
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefdde"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefdde"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i64v9", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";
(function(s, f) {
    if (0, module.exports) module.exports = f(s);
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self) {
    var __lib__bowser = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        var k = k || {};
        k.scope = {};
        k.arrayIteratorImpl = function(f) {
            var m = 0;
            return function() {
                return m < f.length ? {
                    done: !1,
                    value: f[m++]
                } : {
                    done: !0
                };
            };
        };
        k.arrayIterator = function(f) {
            return {
                next: k.arrayIteratorImpl(f)
            };
        };
        k.ASSUME_ES5 = !1;
        k.ASSUME_NO_NATIVE_MAP = !1;
        k.ASSUME_NO_NATIVE_SET = !1;
        k.SIMPLE_FROUND_POLYFILL = !1;
        k.ISOLATE_POLYFILLS = !1;
        k.FORCE_POLYFILL_PROMISE = !1;
        k.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
        k.defineProperty = k.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(f, m, r) {
            if (f == Array.prototype || f == Object.prototype) return f;
            f[m] = r.value;
            return f;
        };
        k.getGlobal = function(f) {
            f = [
                "object" == typeof globalThis && globalThis,
                f,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var m = 0; m < f.length; ++m){
                var r = f[m];
                if (r && r.Math == Math) return r;
            }
            throw Error("Cannot find global object");
        };
        k.global = k.getGlobal(this);
        k.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
        k.TRUST_ES6_POLYFILLS = !k.ISOLATE_POLYFILLS || k.IS_SYMBOL_NATIVE;
        k.polyfills = {};
        k.propertyToPolyfillSymbol = {};
        k.POLYFILL_PREFIX = "$jscp$";
        k.polyfill = function(f, m, r, n) {
            m && (k.ISOLATE_POLYFILLS ? k.polyfillIsolated(f, m, r, n) : k.polyfillUnisolated(f, m, r, n));
        };
        k.polyfillUnisolated = function(f, m) {
            var r = k.global;
            f = f.split(".");
            for(var n = 0; n < f.length - 1; n++){
                var p = f[n];
                if (!(p in r)) return;
                r = r[p];
            }
            f = f[f.length - 1];
            n = r[f];
            m = m(n);
            m != n && null != m && k.defineProperty(r, f, {
                configurable: !0,
                writable: !0,
                value: m
            });
        };
        k.polyfillIsolated = function(f, m, r) {
            var n = f.split(".");
            f = 1 === n.length;
            var p = n[0];
            p = !f && p in k.polyfills ? k.polyfills : k.global;
            for(var e = 0; e < n.length - 1; e++){
                var t = n[e];
                if (!(t in p)) return;
                p = p[t];
            }
            n = n[n.length - 1];
            r = k.IS_SYMBOL_NATIVE && "es6" === r ? p[n] : null;
            m = m(r);
            null != m && (f ? k.defineProperty(k.polyfills, n, {
                configurable: !0,
                writable: !0,
                value: m
            }) : m !== r && (void 0 === k.propertyToPolyfillSymbol[n] && (f = 1E9 * Math.random() >>> 0, k.propertyToPolyfillSymbol[n] = k.IS_SYMBOL_NATIVE ? k.global.Symbol(n) : k.POLYFILL_PREFIX + f + "$" + n), k.defineProperty(p, k.propertyToPolyfillSymbol[n], {
                configurable: !0,
                writable: !0,
                value: m
            })));
        };
        k.initSymbol = function() {};
        k.polyfill("Symbol", function(f) {
            function m(e) {
                if (this instanceof m) throw new TypeError("Symbol is not a constructor");
                return new r(n + (e || "") + "_" + p++, e);
            }
            function r(e, t) {
                this.$jscomp$symbol$id_ = e;
                k.defineProperty(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: t
                });
            }
            if (f) return f;
            r.prototype.toString = function() {
                return this.$jscomp$symbol$id_;
            };
            var n = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", p = 0;
            return m;
        }, "es6", "es3");
        k.polyfill("Symbol.iterator", function(f) {
            if (f) return f;
            f = Symbol("Symbol.iterator");
            for(var m = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), r = 0; r < m.length; r++){
                var n = k.global[m[r]];
                "function" === typeof n && "function" != typeof n.prototype[f] && k.defineProperty(n.prototype, f, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return k.iteratorPrototype(k.arrayIteratorImpl(this));
                    }
                });
            }
            return f;
        }, "es6", "es3");
        k.iteratorPrototype = function(f) {
            f = {
                next: f
            };
            f[Symbol.iterator] = function() {
                return this;
            };
            return f;
        };
        k.iteratorFromArray = function(f, m) {
            f instanceof String && (f += "");
            var r = 0, n = !1, p = {
                next: function() {
                    if (!n && r < f.length) {
                        var e = r++;
                        return {
                            value: m(e, f[e]),
                            done: !1
                        };
                    }
                    n = !0;
                    return {
                        done: !0,
                        value: void 0
                    };
                }
            };
            p[Symbol.iterator] = function() {
                return p;
            };
            return p;
        };
        k.polyfill("Array.prototype.keys", function(f) {
            return f ? f : function() {
                return k.iteratorFromArray(this, function(m) {
                    return m;
                });
            };
        }, "es6", "es3");
        k.findInternal = function(f, m, r) {
            f instanceof String && (f = String(f));
            for(var n = f.length, p = 0; p < n; p++){
                var e = f[p];
                if (m.call(r, e, p, f)) return {
                    i: p,
                    v: e
                };
            }
            return {
                i: -1,
                v: void 0
            };
        };
        k.polyfill("Array.prototype.find", function(f) {
            return f ? f : function(m, r) {
                return k.findInternal(this, m, r).v;
            };
        }, "es6", "es3");
        (function(f) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = f() : "function" === typeof define && define.amd ? define([], f) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = f();
        })(function() {
            return (function() {
                function f(m, r, n) {
                    function p(h, d) {
                        if (!r[h]) {
                            if (!m[h]) {
                                var c = undefined;
                                if (!d && c) return c(h, !0);
                                if (e) return e(h, !0);
                                d = Error("Cannot find module '" + h + "'");
                                throw d.code = "MODULE_NOT_FOUND", d;
                            }
                            d = r[h] = {
                                exports: {}
                            };
                            m[h][0].call(d.exports, function(a) {
                                return p(m[h][1][a] || a);
                            }, d, d.exports, f, m, r, n);
                        }
                        return r[h].exports;
                    }
                    for(var e = undefined, t = 0; t < n.length; t++)p(n[t]);
                    return p;
                }
                return f;
            })()({
                1: [
                    function(f, m, r) {
                        function n(p) {
                            "@babel/helpers - typeof";
                            return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                                return typeof e;
                            } : function(e) {
                                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                            }, n(p);
                        }
                        !function(p, e) {
                            "object" == ("undefined" === typeof r ? "undefined" : n(r)) && "object" == ("undefined" === typeof m ? "undefined" : n(m)) ? m.exports = e() : "object" == ("undefined" === typeof r ? "undefined" : n(r)) ? r.bowser = e() : p.bowser = e();
                        }(void 0, function() {
                            return function(p) {
                                function e(h) {
                                    if (t[h]) return t[h].exports;
                                    var d = t[h] = {
                                        i: h,
                                        l: !1,
                                        exports: {}
                                    };
                                    return p[h].call(d.exports, d, d.exports, e), d.l = !0, d.exports;
                                }
                                var t = {};
                                return e.m = p, e.c = t, e.d = function(h, d, c) {
                                    e.o(h, d) || Object.defineProperty(h, d, {
                                        enumerable: !0,
                                        get: c
                                    });
                                }, e.r = function(h) {
                                    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(h, Symbol.toStringTag, {
                                        value: "Module"
                                    });
                                    Object.defineProperty(h, "__esModule", {
                                        value: !0
                                    });
                                }, e.t = function(h, d) {
                                    if ((1 & d && (h = e(h)), 8 & d) || 4 & d && "object" == n(h) && h && h.__esModule) return h;
                                    var c = Object.create(null);
                                    if (e.r(c), Object.defineProperty(c, "default", {
                                        enumerable: !0,
                                        value: h
                                    }), 2 & d && "string" != typeof h) for(var a in h)e.d(c, a, (function(b) {
                                        return h[b];
                                    }).bind(null, a));
                                    return c;
                                }, e.n = function(h) {
                                    var d = h && h.__esModule ? function() {
                                        return h.default;
                                    } : function() {
                                        return h;
                                    };
                                    return e.d(d, "a", d), d;
                                }, e.o = function(h, d) {
                                    return Object.prototype.hasOwnProperty.call(h, d);
                                }, e.p = "", e(e.s = 90);
                            }({
                                17: function(p, e, t) {
                                    e.__esModule = !0;
                                    e.default = void 0;
                                    var h = t(18);
                                    t = function() {
                                        function d() {}
                                        return d.getFirstMatch = function(c, a) {
                                            return (c = a.match(c)) && 0 < c.length && c[1] || "";
                                        }, d.getSecondMatch = function(c, a) {
                                            return (c = a.match(c)) && 1 < c.length && c[2] || "";
                                        }, d.matchAndReturnConst = function(c, a, b) {
                                            if (c.test(a)) return b;
                                        }, d.getWindowsVersionName = function(c) {
                                            switch(c){
                                                case "NT":
                                                    return "NT";
                                                case "XP":
                                                    return "XP";
                                                case "NT 5.0":
                                                    return "2000";
                                                case "NT 5.1":
                                                    return "XP";
                                                case "NT 5.2":
                                                    return "2003";
                                                case "NT 6.0":
                                                    return "Vista";
                                                case "NT 6.1":
                                                    return "7";
                                                case "NT 6.2":
                                                    return "8";
                                                case "NT 6.3":
                                                    return "8.1";
                                                case "NT 10.0":
                                                    return "10";
                                            }
                                        }, d.getMacOSVersionName = function(c) {
                                            c = c.split(".").splice(0, 2).map(function(a) {
                                                return parseInt(a, 10) || 0;
                                            });
                                            if (c.push(0), 10 === c[0]) switch(c[1]){
                                                case 5:
                                                    return "Leopard";
                                                case 6:
                                                    return "Snow Leopard";
                                                case 7:
                                                    return "Lion";
                                                case 8:
                                                    return "Mountain Lion";
                                                case 9:
                                                    return "Mavericks";
                                                case 10:
                                                    return "Yosemite";
                                                case 11:
                                                    return "El Capitan";
                                                case 12:
                                                    return "Sierra";
                                                case 13:
                                                    return "High Sierra";
                                                case 14:
                                                    return "Mojave";
                                                case 15:
                                                    return "Catalina";
                                            }
                                        }, d.getAndroidVersionName = function(c) {
                                            c = c.split(".").splice(0, 2).map(function(a) {
                                                return parseInt(a, 10) || 0;
                                            });
                                            if (c.push(0), !(1 === c[0] && 5 > c[1])) return 1 === c[0] && 6 > c[1] ? "Cupcake" : 1 === c[0] && 6 <= c[1] ? "Donut" : 2 === c[0] && 2 > c[1] ? "Eclair" : 2 === c[0] && 2 === c[1] ? "Froyo" : 2 === c[0] && 2 < c[1] ? "Gingerbread" : 3 === c[0] ? "Honeycomb" : 4 === c[0] && 1 > c[1] ? "Ice Cream Sandwich" : 4 === c[0] && 4 > c[1] ? "Jelly Bean" : 4 === c[0] && 4 <= c[1] ? "KitKat" : 5 === c[0] ? "Lollipop" : 6 === c[0] ? "Marshmallow" : 7 === c[0] ? "Nougat" : 8 === c[0] ? "Oreo" : 9 === c[0] ? "Pie" : void 0;
                                        }, d.getVersionPrecision = function(c) {
                                            return c.split(".").length;
                                        }, d.compareVersions = function(c, a, b) {
                                            void 0 === b && (b = !1);
                                            var v = d.getVersionPrecision(c), w = d.getVersionPrecision(a), l = Math.max(v, w), g = 0;
                                            c = d.map([
                                                c,
                                                a
                                            ], function(q) {
                                                var u = l - d.getVersionPrecision(q);
                                                q += Array(u + 1).join(".0");
                                                return d.map(q.split("."), function(x) {
                                                    return Array(20 - x.length).join("0") + x;
                                                }).reverse();
                                            });
                                            b && (g = l - Math.min(v, w));
                                            for(--l; l >= g;){
                                                if (c[0][l] > c[1][l]) return 1;
                                                if (c[0][l] === c[1][l]) {
                                                    if (l === g) return 0;
                                                    --l;
                                                } else if (c[0][l] < c[1][l]) return -1;
                                            }
                                        }, d.map = function(c, a) {
                                            var b, v = [];
                                            if (Array.prototype.map) return Array.prototype.map.call(c, a);
                                            for(b = 0; b < c.length; b += 1)v.push(a(c[b]));
                                            return v;
                                        }, d.find = function(c, a) {
                                            var b;
                                            if (Array.prototype.find) return Array.prototype.find.call(c, a);
                                            var v = 0;
                                            for(b = c.length; v < b; v += 1){
                                                var w = c[v];
                                                if (a(w, v)) return w;
                                            }
                                        }, d.assign = function(c) {
                                            function a() {
                                                var g = v[l];
                                                "object" == n(g) && null !== g && Object.keys(g).forEach(function(q) {
                                                    c[q] = g[q];
                                                });
                                            }
                                            var b = arguments.length;
                                            for(var v = Array(1 < b ? b - 1 : 0), w = 1; w < b; w++)v[w - 1] = arguments[w];
                                            if (Object.assign) return Object.assign.apply(Object, [
                                                c
                                            ].concat(v));
                                            var l = 0;
                                            for(b = v.length; l < b; l += 1)a();
                                            return c;
                                        }, d.getBrowserAlias = function(c) {
                                            return h.BROWSER_ALIASES_MAP[c];
                                        }, d.getBrowserTypeByAlias = function(c) {
                                            return h.BROWSER_MAP[c] || "";
                                        }, d;
                                    }();
                                    e.default = t;
                                    p.exports = e.default;
                                },
                                18: function(p, e) {
                                    e.__esModule = !0;
                                    e.BROWSER_ALIASES_MAP = {
                                        "Amazon Silk": "amazon_silk",
                                        "Android Browser": "android",
                                        Bada: "bada",
                                        BlackBerry: "blackberry",
                                        Chrome: "chrome",
                                        Chromium: "chromium",
                                        Electron: "electron",
                                        Epiphany: "epiphany",
                                        Firefox: "firefox",
                                        Focus: "focus",
                                        Generic: "generic",
                                        "Google Search": "google_search",
                                        Googlebot: "googlebot",
                                        "Internet Explorer": "ie",
                                        "K-Meleon": "k_meleon",
                                        Maxthon: "maxthon",
                                        "Microsoft Edge": "edge",
                                        "MZ Browser": "mz",
                                        "NAVER Whale Browser": "naver",
                                        Opera: "opera",
                                        "Opera Coast": "opera_coast",
                                        PhantomJS: "phantomjs",
                                        Puffin: "puffin",
                                        QupZilla: "qupzilla",
                                        QQ: "qq",
                                        QQLite: "qqlite",
                                        Safari: "safari",
                                        Sailfish: "sailfish",
                                        "Samsung Internet for Android": "samsung_internet",
                                        SeaMonkey: "seamonkey",
                                        Sleipnir: "sleipnir",
                                        Swing: "swing",
                                        Tizen: "tizen",
                                        "UC Browser": "uc",
                                        Vivaldi: "vivaldi",
                                        "WebOS Browser": "webos",
                                        WeChat: "wechat",
                                        "Yandex Browser": "yandex",
                                        Roku: "roku"
                                    };
                                    e.BROWSER_MAP = {
                                        amazon_silk: "Amazon Silk",
                                        android: "Android Browser",
                                        bada: "Bada",
                                        blackberry: "BlackBerry",
                                        chrome: "Chrome",
                                        chromium: "Chromium",
                                        electron: "Electron",
                                        epiphany: "Epiphany",
                                        firefox: "Firefox",
                                        focus: "Focus",
                                        generic: "Generic",
                                        googlebot: "Googlebot",
                                        google_search: "Google Search",
                                        ie: "Internet Explorer",
                                        k_meleon: "K-Meleon",
                                        maxthon: "Maxthon",
                                        edge: "Microsoft Edge",
                                        mz: "MZ Browser",
                                        naver: "NAVER Whale Browser",
                                        opera: "Opera",
                                        opera_coast: "Opera Coast",
                                        phantomjs: "PhantomJS",
                                        puffin: "Puffin",
                                        qupzilla: "QupZilla",
                                        qq: "QQ Browser",
                                        qqlite: "QQ Browser Lite",
                                        safari: "Safari",
                                        sailfish: "Sailfish",
                                        samsung_internet: "Samsung Internet for Android",
                                        seamonkey: "SeaMonkey",
                                        sleipnir: "Sleipnir",
                                        swing: "Swing",
                                        tizen: "Tizen",
                                        uc: "UC Browser",
                                        vivaldi: "Vivaldi",
                                        webos: "WebOS Browser",
                                        wechat: "WeChat",
                                        yandex: "Yandex Browser"
                                    };
                                    e.PLATFORMS_MAP = {
                                        tablet: "tablet",
                                        mobile: "mobile",
                                        desktop: "desktop",
                                        tv: "tv"
                                    };
                                    e.OS_MAP = {
                                        WindowsPhone: "Windows Phone",
                                        Windows: "Windows",
                                        MacOS: "macOS",
                                        iOS: "iOS",
                                        Android: "Android",
                                        WebOS: "WebOS",
                                        BlackBerry: "BlackBerry",
                                        Bada: "Bada",
                                        Tizen: "Tizen",
                                        Linux: "Linux",
                                        ChromeOS: "Chrome OS",
                                        PlayStation4: "PlayStation 4",
                                        Roku: "Roku"
                                    };
                                    e.ENGINE_MAP = {
                                        EdgeHTML: "EdgeHTML",
                                        Blink: "Blink",
                                        Trident: "Trident",
                                        Presto: "Presto",
                                        Gecko: "Gecko",
                                        WebKit: "WebKit"
                                    };
                                },
                                90: function(p, e, t) {
                                    function h(b, v) {
                                        for(var w = 0; w < v.length; w++){
                                            var l = v[w];
                                            l.enumerable = l.enumerable || !1;
                                            l.configurable = !0;
                                            "value" in l && (l.writable = !0);
                                            Object.defineProperty(b, l.key, l);
                                        }
                                    }
                                    e.__esModule = !0;
                                    e.default = void 0;
                                    var d, c = (d = t(91)) && d.__esModule ? d : {
                                        default: d
                                    }, a = t(18);
                                    t = function() {
                                        function b() {}
                                        var v;
                                        return b.getParser = function(w, l) {
                                            if (void 0 === l && (l = !1), "string" != typeof w) throw Error("UserAgent should be a string");
                                            return new c.default(w, l);
                                        }, b.parse = function(w) {
                                            return new c.default(w).getResult();
                                        }, v = [
                                            {
                                                key: "BROWSER_MAP",
                                                get: function() {
                                                    return a.BROWSER_MAP;
                                                }
                                            },
                                            {
                                                key: "ENGINE_MAP",
                                                get: function() {
                                                    return a.ENGINE_MAP;
                                                }
                                            },
                                            {
                                                key: "OS_MAP",
                                                get: function() {
                                                    return a.OS_MAP;
                                                }
                                            },
                                            {
                                                key: "PLATFORMS_MAP",
                                                get: function() {
                                                    return a.PLATFORMS_MAP;
                                                }
                                            }
                                        ], v && h(b, v), b;
                                    }();
                                    e.default = t;
                                    p.exports = e.default;
                                },
                                91: function(p, e, t) {
                                    function h(w) {
                                        return w && w.__esModule ? w : {
                                            default: w
                                        };
                                    }
                                    e.__esModule = !0;
                                    e.default = void 0;
                                    var d = h(t(92)), c = h(t(93)), a = h(t(94)), b = h(t(95)), v = h(t(17));
                                    t = function() {
                                        function w(g, q) {
                                            if (void 0 === q && (q = !1), null == g || "" === g) throw Error("UserAgent parameter can't be empty");
                                            this._ua = g;
                                            this.parsedResult = {};
                                            !0 !== q && this.parse();
                                        }
                                        var l = w.prototype;
                                        return l.getUA = function() {
                                            return this._ua;
                                        }, l.test = function(g) {
                                            return g.test(this._ua);
                                        }, l.parseBrowser = function() {
                                            var g = this;
                                            this.parsedResult.browser = {};
                                            var q = v.default.find(d.default, function(u) {
                                                if ("function" == typeof u.test) return u.test(g);
                                                if (u.test instanceof Array) return u.test.some(function(x) {
                                                    return g.test(x);
                                                });
                                                throw Error("Browser's test function is not valid");
                                            });
                                            return q && (this.parsedResult.browser = q.describe(this.getUA())), this.parsedResult.browser;
                                        }, l.getBrowser = function() {
                                            return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                                        }, l.getBrowserName = function(g) {
                                            return g ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                                        }, l.getBrowserVersion = function() {
                                            return this.getBrowser().version;
                                        }, l.getOS = function() {
                                            return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                                        }, l.parseOS = function() {
                                            var g = this;
                                            this.parsedResult.os = {};
                                            var q = v.default.find(c.default, function(u) {
                                                if ("function" == typeof u.test) return u.test(g);
                                                if (u.test instanceof Array) return u.test.some(function(x) {
                                                    return g.test(x);
                                                });
                                                throw Error("Browser's test function is not valid");
                                            });
                                            return q && (this.parsedResult.os = q.describe(this.getUA())), this.parsedResult.os;
                                        }, l.getOSName = function(g) {
                                            var q = this.getOS().name;
                                            return g ? String(q).toLowerCase() || "" : q || "";
                                        }, l.getOSVersion = function() {
                                            return this.getOS().version;
                                        }, l.getPlatform = function() {
                                            return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                                        }, l.getPlatformType = function(g) {
                                            void 0 === g && (g = !1);
                                            var q = this.getPlatform().type;
                                            return g ? String(q).toLowerCase() || "" : q || "";
                                        }, l.parsePlatform = function() {
                                            var g = this;
                                            this.parsedResult.platform = {};
                                            var q = v.default.find(a.default, function(u) {
                                                if ("function" == typeof u.test) return u.test(g);
                                                if (u.test instanceof Array) return u.test.some(function(x) {
                                                    return g.test(x);
                                                });
                                                throw Error("Browser's test function is not valid");
                                            });
                                            return q && (this.parsedResult.platform = q.describe(this.getUA())), this.parsedResult.platform;
                                        }, l.getEngine = function() {
                                            return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                                        }, l.getEngineName = function(g) {
                                            return g ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                                        }, l.parseEngine = function() {
                                            var g = this;
                                            this.parsedResult.engine = {};
                                            var q = v.default.find(b.default, function(u) {
                                                if ("function" == typeof u.test) return u.test(g);
                                                if (u.test instanceof Array) return u.test.some(function(x) {
                                                    return g.test(x);
                                                });
                                                throw Error("Browser's test function is not valid");
                                            });
                                            return q && (this.parsedResult.engine = q.describe(this.getUA())), this.parsedResult.engine;
                                        }, l.parse = function() {
                                            return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                                        }, l.getResult = function() {
                                            return v.default.assign({}, this.parsedResult);
                                        }, l.satisfies = function(g) {
                                            var q = this, u = {}, x = 0, A = {}, D = 0;
                                            if (Object.keys(g).forEach(function(z) {
                                                var C = g[z];
                                                "string" == typeof C ? (A[z] = C, D += 1) : "object" == n(C) && (u[z] = C, x += 1);
                                            }), 0 < x) {
                                                var y = Object.keys(u), B = v.default.find(y, function(z) {
                                                    return q.isOS(z);
                                                });
                                                if (B && (B = this.satisfies(u[B]), void 0 !== B)) return B;
                                                if (y = v.default.find(y, function(z) {
                                                    return q.isPlatform(z);
                                                })) {
                                                    if (y = this.satisfies(u[y]), void 0 !== y) return y;
                                                }
                                            }
                                            if (0 < D && (y = Object.keys(A), y = v.default.find(y, function(z) {
                                                return q.isBrowser(z, !0);
                                            }), void 0 !== y)) return this.compareVersion(A[y]);
                                        }, l.isBrowser = function(g, q) {
                                            void 0 === q && (q = !1);
                                            var u = this.getBrowserName().toLowerCase();
                                            g = g.toLowerCase();
                                            var x = v.default.getBrowserTypeByAlias(g);
                                            return q && x && (g = x.toLowerCase()), g === u;
                                        }, l.compareVersion = function(g) {
                                            var q = [
                                                0
                                            ], u = g, x = !1, A = this.getBrowserVersion();
                                            if ("string" == typeof A) return ">" === g[0] || "<" === g[0] ? (u = g.substr(1), "=" === g[1] ? (x = !0, u = g.substr(2)) : q = [], ">" === g[0] ? q.push(1) : q.push(-1)) : "=" === g[0] ? u = g.substr(1) : "~" === g[0] && (x = !0, u = g.substr(1)), -1 < q.indexOf(v.default.compareVersions(A, u, x));
                                        }, l.isOS = function(g) {
                                            return this.getOSName(!0) === String(g).toLowerCase();
                                        }, l.isPlatform = function(g) {
                                            return this.getPlatformType(!0) === String(g).toLowerCase();
                                        }, l.isEngine = function(g) {
                                            return this.getEngineName(!0) === String(g).toLowerCase();
                                        }, l.is = function(g, q) {
                                            return void 0 === q && (q = !1), this.isBrowser(g, q) || this.isOS(g) || this.isPlatform(g);
                                        }, l.some = function(g) {
                                            var q = this;
                                            return void 0 === g && (g = []), g.some(function(u) {
                                                return q.is(u);
                                            });
                                        }, w;
                                    }();
                                    e.default = t;
                                    p.exports = e.default;
                                },
                                92: function(p, e, t) {
                                    e.__esModule = !0;
                                    e.default = void 0;
                                    var h, d = (h = t(17)) && h.__esModule ? h : {
                                        default: h
                                    }, c = /version\/(\d+(\.?_?\d+)+)/i;
                                    e.default = [
                                        {
                                            test: [
                                                /googlebot/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Googlebot"
                                                };
                                                a = d.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /opera/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Opera"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /opr\/|opios/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Opera"
                                                };
                                                a = d.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /SamsungBrowser/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Samsung Internet for Android"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /Whale/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "NAVER Whale Browser"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /MZBrowser/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "MZ Browser"
                                                };
                                                a = d.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /focus/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Focus"
                                                };
                                                a = d.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /swing/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Swing"
                                                };
                                                a = d.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /coast/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Opera Coast"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /opt\/\d+(?:.?_?\d+)+/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Opera Touch"
                                                };
                                                a = d.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /yabrowser/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Yandex Browser"
                                                };
                                                a = d.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /ucbrowser/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "UC Browser"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /Maxthon|mxios/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Maxthon"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /epiphany/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Epiphany"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /puffin/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Puffin"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /sleipnir/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Sleipnir"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /k-meleon/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "K-Meleon"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /micromessenger/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "WeChat"
                                                };
                                                a = d.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /qqbrowser/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: /qqbrowserlite/i.test(a) ? "QQ Browser Lite" : "QQ Browser"
                                                };
                                                a = d.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /msie|trident/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Internet Explorer"
                                                };
                                                a = d.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /\sedg\//i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Microsoft Edge"
                                                };
                                                a = d.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /edg([ea]|ios)/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Microsoft Edge"
                                                };
                                                a = d.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /vivaldi/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Vivaldi"
                                                };
                                                a = d.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /seamonkey/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "SeaMonkey"
                                                };
                                                a = d.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /sailfish/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Sailfish"
                                                };
                                                a = d.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /silk/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Amazon Silk"
                                                };
                                                a = d.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /phantom/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "PhantomJS"
                                                };
                                                a = d.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /slimerjs/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "SlimerJS"
                                                };
                                                a = d.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /blackberry|\bbb\d+/i,
                                                /rim\stablet/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "BlackBerry"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /(web|hpw)[o0]s/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "WebOS Browser"
                                                };
                                                a = d.default.getFirstMatch(c, a) || d.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /bada/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Bada"
                                                };
                                                a = d.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /tizen/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Tizen"
                                                };
                                                a = d.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /qupzilla/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "QupZilla"
                                                };
                                                a = d.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /firefox|iceweasel|fxios/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Firefox"
                                                };
                                                a = d.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /electron/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Electron"
                                                };
                                                a = d.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /MiuiBrowser/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Miui"
                                                };
                                                a = d.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /chromium/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Chromium"
                                                };
                                                a = d.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, a) || d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /chrome|crios|crmo/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Chrome"
                                                };
                                                a = d.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /GSA/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Google Search"
                                                };
                                                a = d.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                var b = !a.test(/like android/i);
                                                a = a.test(/android/i);
                                                return b && a;
                                            },
                                            describe: function(a) {
                                                var b = {
                                                    name: "Android Browser"
                                                };
                                                a = d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /playstation 4/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "PlayStation 4"
                                                };
                                                a = d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /safari|applewebkit/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: "Safari"
                                                };
                                                a = d.default.getFirstMatch(c, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /.*/i
                                            ],
                                            describe: function(a) {
                                                var b = -1 !== a.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                                                return {
                                                    name: d.default.getFirstMatch(b, a),
                                                    version: d.default.getSecondMatch(b, a)
                                                };
                                            }
                                        }
                                    ];
                                    p.exports = e.default;
                                },
                                93: function(p, e, t) {
                                    e.__esModule = !0;
                                    e.default = void 0;
                                    var h, d = (h = t(17)) && h.__esModule ? h : {
                                        default: h
                                    }, c = t(18);
                                    e.default = [
                                        {
                                            test: [
                                                /Roku\/DVP/
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, a);
                                                return {
                                                    name: c.OS_MAP.Roku,
                                                    version: a
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /windows phone/i
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, a);
                                                return {
                                                    name: c.OS_MAP.WindowsPhone,
                                                    version: a
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /windows /i
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, a);
                                                var b = d.default.getWindowsVersionName(a);
                                                return {
                                                    name: c.OS_MAP.Windows,
                                                    version: a,
                                                    versionName: b
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /Macintosh(.*?) FxiOS(.*?)\//
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: c.OS_MAP.iOS
                                                };
                                                a = d.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /macintosh/i
                                            ],
                                            describe: function(a) {
                                                var b = d.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, a).replace(/[_\s]/g, ".");
                                                a = d.default.getMacOSVersionName(b);
                                                b = {
                                                    name: c.OS_MAP.MacOS,
                                                    version: b
                                                };
                                                return a && (b.versionName = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /(ipod|iphone|ipad)/i
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, a).replace(/[_\s]/g, ".");
                                                return {
                                                    name: c.OS_MAP.iOS,
                                                    version: a
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                var b = !a.test(/like android/i);
                                                a = a.test(/android/i);
                                                return b && a;
                                            },
                                            describe: function(a) {
                                                var b = d.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, a);
                                                a = d.default.getAndroidVersionName(b);
                                                b = {
                                                    name: c.OS_MAP.Android,
                                                    version: b
                                                };
                                                return a && (b.versionName = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /(web|hpw)[o0]s/i
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, a);
                                                var b = {
                                                    name: c.OS_MAP.WebOS
                                                };
                                                return a && a.length && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /blackberry|\bbb\d+/i,
                                                /rim\stablet/i
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, a) || d.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, a) || d.default.getFirstMatch(/\bbb(\d+)/i, a);
                                                return {
                                                    name: c.OS_MAP.BlackBerry,
                                                    version: a
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /bada/i
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, a);
                                                return {
                                                    name: c.OS_MAP.Bada,
                                                    version: a
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /tizen/i
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, a);
                                                return {
                                                    name: c.OS_MAP.Tizen,
                                                    version: a
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /linux/i
                                            ],
                                            describe: function() {
                                                return {
                                                    name: c.OS_MAP.Linux
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /CrOS/
                                            ],
                                            describe: function() {
                                                return {
                                                    name: c.OS_MAP.ChromeOS
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /PlayStation 4/
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, a);
                                                return {
                                                    name: c.OS_MAP.PlayStation4,
                                                    version: a
                                                };
                                            }
                                        }
                                    ];
                                    p.exports = e.default;
                                },
                                94: function(p, e, t) {
                                    e.__esModule = !0;
                                    e.default = void 0;
                                    var h, d = (h = t(17)) && h.__esModule ? h : {
                                        default: h
                                    }, c = t(18);
                                    e.default = [
                                        {
                                            test: [
                                                /googlebot/i
                                            ],
                                            describe: function() {
                                                return {
                                                    type: "bot",
                                                    vendor: "Google"
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /huawei/i
                                            ],
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/(can-l01)/i, a) && "Nova";
                                                var b = {
                                                    type: c.PLATFORMS_MAP.mobile,
                                                    vendor: "Huawei"
                                                };
                                                return a && (b.model = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /nexus\s*(?:7|8|9|10).*/i
                                            ],
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tablet,
                                                    vendor: "Nexus"
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /ipad/i
                                            ],
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tablet,
                                                    vendor: "Apple",
                                                    model: "iPad"
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /Macintosh(.*?) FxiOS(.*?)\//
                                            ],
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tablet,
                                                    vendor: "Apple",
                                                    model: "iPad"
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /kftt build/i
                                            ],
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tablet,
                                                    vendor: "Amazon",
                                                    model: "Kindle Fire HD 7"
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /silk/i
                                            ],
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tablet,
                                                    vendor: "Amazon"
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /tablet(?! pc)/i
                                            ],
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tablet
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                var b = a.test(/ipod|iphone/i);
                                                a = a.test(/like (ipod|iphone)/i);
                                                return b && !a;
                                            },
                                            describe: function(a) {
                                                a = d.default.getFirstMatch(/(ipod|iphone)/i, a);
                                                return {
                                                    type: c.PLATFORMS_MAP.mobile,
                                                    vendor: "Apple",
                                                    model: a
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /nexus\s*[0-6].*/i,
                                                /galaxy nexus/i
                                            ],
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.mobile,
                                                    vendor: "Nexus"
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /[^-]mobi/i
                                            ],
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.mobile
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "blackberry" === a.getBrowserName(!0);
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.mobile,
                                                    vendor: "BlackBerry"
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "bada" === a.getBrowserName(!0);
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.mobile
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "windows phone" === a.getBrowserName();
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.mobile,
                                                    vendor: "Microsoft"
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                var b = Number(String(a.getOSVersion()).split(".")[0]);
                                                return "android" === a.getOSName(!0) && 3 <= b;
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tablet
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "android" === a.getOSName(!0);
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.mobile
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "macos" === a.getOSName(!0);
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.desktop,
                                                    vendor: "Apple"
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "windows" === a.getOSName(!0);
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.desktop
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "linux" === a.getOSName(!0);
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.desktop
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "playstation 4" === a.getOSName(!0);
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tv
                                                };
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return "roku" === a.getOSName(!0);
                                            },
                                            describe: function() {
                                                return {
                                                    type: c.PLATFORMS_MAP.tv
                                                };
                                            }
                                        }
                                    ];
                                    p.exports = e.default;
                                },
                                95: function(p, e, t) {
                                    e.__esModule = !0;
                                    e.default = void 0;
                                    var h, d = (h = t(17)) && h.__esModule ? h : {
                                        default: h
                                    }, c = t(18);
                                    e.default = [
                                        {
                                            test: function(a) {
                                                return "microsoft edge" === a.getBrowserName(!0);
                                            },
                                            describe: function(a) {
                                                if (/\sedg\//i.test(a)) return {
                                                    name: c.ENGINE_MAP.Blink
                                                };
                                                a = d.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, a);
                                                return {
                                                    name: c.ENGINE_MAP.EdgeHTML,
                                                    version: a
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /trident/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: c.ENGINE_MAP.Trident
                                                };
                                                a = d.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                return a.test(/presto/i);
                                            },
                                            describe: function(a) {
                                                var b = {
                                                    name: c.ENGINE_MAP.Presto
                                                };
                                                a = d.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: function(a) {
                                                var b = a.test(/gecko/i);
                                                a = a.test(/like gecko/i);
                                                return b && !a;
                                            },
                                            describe: function(a) {
                                                var b = {
                                                    name: c.ENGINE_MAP.Gecko
                                                };
                                                a = d.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        },
                                        {
                                            test: [
                                                /(apple)?webkit\/537\.36/i
                                            ],
                                            describe: function() {
                                                return {
                                                    name: c.ENGINE_MAP.Blink
                                                };
                                            }
                                        },
                                        {
                                            test: [
                                                /(apple)?webkit/i
                                            ],
                                            describe: function(a) {
                                                var b = {
                                                    name: c.ENGINE_MAP.WebKit
                                                };
                                                a = d.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, a);
                                                return a && (b.version = a), b;
                                            }
                                        }
                                    ];
                                    p.exports = e.default;
                                }
                            });
                        });
                    },
                    {}
                ],
                2: [
                    function(f, m) {
                        m.exports = f("bowser");
                    },
                    {
                        bowser: 1
                    }
                ]
            }, {}, [
                2
            ])(2);
        });
        return module1.exports;
    }();
    var __lib__base64_js = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        (function(d) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = d() : "function" === typeof define && define.amd ? define([], d) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = d();
        })(function() {
            return (function() {
                function d(m, l, p) {
                    function h(a, b) {
                        if (!l[a]) {
                            if (!m[a]) {
                                var c = undefined;
                                if (!b && c) return c(a, !0);
                                if (e) return e(a, !0);
                                b = Error("Cannot find module '" + a + "'");
                                throw b.code = "MODULE_NOT_FOUND", b;
                            }
                            b = l[a] = {
                                exports: {}
                            };
                            m[a][0].call(b.exports, function(f) {
                                return h(m[a][1][f] || f);
                            }, b, b.exports, d, m, l, p);
                        }
                        return l[a].exports;
                    }
                    for(var e = undefined, q = 0; q < p.length; q++)h(p[q]);
                    return h;
                }
                return d;
            })()({
                1: [
                    function(d, m, l) {
                        function p(a) {
                            var b = a.length;
                            if (0 < b % 4) throw Error("Invalid string. Length must be a multiple of 4");
                            a = a.indexOf("=");
                            -1 === a && (a = b);
                            return [
                                a,
                                a === b ? 0 : 4 - a % 4
                            ];
                        }
                        l.byteLength = function(a) {
                            a = p(a);
                            var b = a[1];
                            return 3 * (a[0] + b) / 4 - b;
                        };
                        l.toByteArray = function(a) {
                            var b = p(a);
                            var c = b[0];
                            b = b[1];
                            var f = new q(3 * (c + b) / 4 - b), k = 0, r = 0 < b ? c - 4 : c, g;
                            for(g = 0; g < r; g += 4)c = e[a.charCodeAt(g)] << 18 | e[a.charCodeAt(g + 1)] << 12 | e[a.charCodeAt(g + 2)] << 6 | e[a.charCodeAt(g + 3)], f[k++] = c >> 16 & 255, f[k++] = c >> 8 & 255, f[k++] = c & 255;
                            2 === b && (c = e[a.charCodeAt(g)] << 2 | e[a.charCodeAt(g + 1)] >> 4, f[k++] = c & 255);
                            1 === b && (c = e[a.charCodeAt(g)] << 10 | e[a.charCodeAt(g + 1)] << 4 | e[a.charCodeAt(g + 2)] >> 2, f[k++] = c >> 8 & 255, f[k++] = c & 255);
                            return f;
                        };
                        l.fromByteArray = function(a) {
                            for(var b = a.length, c = b % 3, f = [], k = 0, r = b - c; k < r; k += 16383){
                                for(var g = f, w = g.push, n, u = a, x = k + 16383 > r ? r : k + 16383, v = [], t = k; t < x; t += 3)n = (u[t] << 16 & 16711680) + (u[t + 1] << 8 & 65280) + (u[t + 2] & 255), v.push(h[n >> 18 & 63] + h[n >> 12 & 63] + h[n >> 6 & 63] + h[n & 63]);
                                n = v.join("");
                                w.call(g, n);
                            }
                            1 === c ? (a = a[b - 1], f.push(h[a >> 2] + h[a << 4 & 63] + "==")) : 2 === c && (a = (a[b - 2] << 8) + a[b - 1], f.push(h[a >> 10] + h[a >> 4 & 63] + h[a << 2 & 63] + "="));
                            return f.join("");
                        };
                        var h = [], e = [], q = "undefined" !== typeof Uint8Array ? Uint8Array : Array;
                        for(d = 0; 64 > d; ++d)h[d] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[d], e["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(d)] = d;
                        e[45] = 62;
                        e[95] = 63;
                    },
                    {}
                ],
                2: [
                    function(d, m) {
                        m.exports = d("base64-js");
                    },
                    {
                        "base64-js": 1
                    }
                ]
            }, {}, [
                2
            ])(2);
        });
        return module1.exports;
    }();
    var api = {};
    (function() {
        var e;
        function aa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        function f(a) {
            if (!(a instanceof Array)) {
                var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
                if (b) a = b.call(a);
                else if ("number" == typeof a.length) a = {
                    next: aa(a)
                };
                else throw Error(String(a) + " is not an iterable or ArrayLike");
                for(var c = []; !(b = a.next()).done;)c.push(b.value);
                a = c;
            }
            return a;
        }
        var ba = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, h;
        if ("function" == typeof Object.setPrototypeOf) h = Object.setPrototypeOf;
        else {
            var k;
            a: {
                var ca = {
                    a: !0
                }, l = {};
                try {
                    l.__proto__ = ca;
                    k = l.a;
                    break a;
                } catch (a) {}
                k = !1;
            }
            h = k ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var m = h;
        function p(a, b) {
            a.prototype = ba(b.prototype);
            a.prototype.constructor = a;
            if (m) m(a, b);
            else for(var c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.H = b.prototype;
        }
        function q() {
            for(var a = Number(this), b = [], c = a; c < arguments.length; c++)b[c - a] = arguments[c];
            return b;
        }
        function da() {
            if ("object" === typeof self) return self;
            if ("object" === typeof window) return window;
            if ("object" === typeof $parcel$global) return $parcel$global;
            throw Error("Unable to get global this");
        }
        function r(a) {
            return "undefined" === typeof a;
        }
        var ea = Array.isArray, t = Function.prototype.call.bind(Object.prototype.hasOwnProperty);
        var u = new Uint16Array(1);
        u[0] = 4660;
        new Uint8Array(u.buffer);
        function v(a, b, c) {
            var d = Error.call(this, "[" + a + "] " + b + " :: " + (c || ""));
            this.message = d.message;
            "stack" in d && (this.stack = d.stack);
            this.namespace = a;
            this.errorType = b;
            this.errorMessage = c || "";
        }
        p(v, Error);
        v.isColibrioError = w;
        v.isColibrioAbortedError = fa;
        function w(a) {
            return a instanceof v || a && "string" === typeof a.errorType && "string" === typeof a.namespace;
        }
        function fa(a) {
            return w(a) && "ABORTED" === a.errorType || a instanceof DOMException && (a.code === DOMException.ABORT_ERR || "AbortError" === a.name);
        }
        var x = {
            KEY_LEFT: 37,
            KEY_RIGHT: 39,
            KEY_UP: 38,
            KEY_DOWN: 40,
            KEY_PAGEDOWN: 34,
            KEY_PAGEUP: 33,
            KEY_ESC: 27,
            KEY_ENTER: 13,
            KEY_BACK: 8,
            KEY_DEL: 46,
            KEY_SHIFT: 16,
            KEY_CTRL: 17,
            KEY_ALT: 18,
            KEY_ALTGR: 225,
            KEY_META: 91,
            KEY_CHAR_R: 82,
            KEY_CHAR_S: 83,
            KEY_CHAR_F: 70,
            KEY_CHAR_U: 85,
            KEY_CHAR_Z: 90
        };
        x[x.KEY_LEFT] = "KEY_LEFT";
        x[x.KEY_RIGHT] = "KEY_RIGHT";
        x[x.KEY_UP] = "KEY_UP";
        x[x.KEY_DOWN] = "KEY_DOWN";
        x[x.KEY_PAGEDOWN] = "KEY_PAGEDOWN";
        x[x.KEY_PAGEUP] = "KEY_PAGEUP";
        x[x.KEY_ESC] = "KEY_ESC";
        x[x.KEY_ENTER] = "KEY_ENTER";
        x[x.KEY_BACK] = "KEY_BACK";
        x[x.KEY_DEL] = "KEY_DEL";
        x[x.KEY_SHIFT] = "KEY_SHIFT";
        x[x.KEY_CTRL] = "KEY_CTRL";
        x[x.KEY_ALT] = "KEY_ALT";
        x[x.KEY_ALTGR] = "KEY_ALTGR";
        x[x.KEY_META] = "KEY_META";
        x[x.KEY_CHAR_R] = "KEY_CHAR_R";
        x[x.KEY_CHAR_S] = "KEY_CHAR_S";
        x[x.KEY_CHAR_F] = "KEY_CHAR_F";
        x[x.KEY_CHAR_U] = "KEY_CHAR_U";
        x[x.KEY_CHAR_Z] = "KEY_CHAR_Z";
        var ha = __lib__bowser;
        var y = null, z = null;
        function A() {
            null === y && (y = ha.getParser(navigator.userAgent));
            return y;
        }
        function B() {
            return z || A().getOSVersion() || "";
        }
        function C(a) {
            return A().getOSName() === a;
        }
        var D = null, E = new Map, F = null;
        function G(a, b) {
            return b.startMs === b.endMs ? a === b.startMs : r(b.endMs) ? a >= b.startMs : a >= b.startMs && a < b.endMs;
        }
        function H(a, b) {
            this.m = b;
            this.h = [];
            this.j = [];
            0 < a.length ? (this.h.push(0), this.j.push(a), this.g = a[0]) : this.g = null;
        }
        H.prototype.advanceToNode = function(a) {
            for(; this.g && this.g !== a;)I(this, this.g);
        };
        H.prototype.hasNext = function() {
            return !!this.g;
        };
        H.prototype.next = function() {
            var a = this.g;
            this.g && I(this, this.g);
            if (!a) throw Error("TREE_NODE_WALKER_ALREADY_AT_END");
            return a;
        };
        function I(a, b) {
            b = a.getChildren(b);
            if (0 < b.length) a.h.push(0), a.j.push(b), a.g = b[0];
            else for(b = !1, a.g = null; 0 < a.h.length && !b;){
                var c = a.h.length - 1, d = a.j[c], n = a.h[c] + 1;
                n < d.length ? (a.h[c] = n, a.g = d[n], b = !0) : (a.h.pop(), a.j.pop());
            }
        }
        H.prototype.getChildren = function(a) {
            return this.m ? this.m(a) : a.getChildren();
        };
        function J(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        p(J, Error);
        function K() {
            this.j = 0;
            this.h = L(null, null, null);
            this.g = L(null, this.h, null);
            this.h.i = this.g;
        }
        K.prototype.every = function(a) {
            for(var b = this.h.i, c = !0; b !== this.g && c;){
                var d = b.i;
                c = a(b);
                b = null === b.i ? d : b.i;
            }
            return c;
        };
        K.prototype.find = function(a) {
            for(var b = this.h.i, c = null; b !== this.g && null === c;){
                var d = b.i;
                a(b) && (c = b);
                b = null === b.i ? d : b.i;
            }
            return c;
        };
        K.prototype.forEach = function(a) {
            for(var b = this.h.i; b !== this.g;){
                var c = b.i;
                a(b);
                b = null === b.i ? c : b.i;
            }
        };
        function M(a) {
            return a.j ? a.h.i : null;
        }
        function N(a, b) {
            return (b = b.i) && a.g !== b ? b : null;
        }
        function O(a, b, c) {
            b && b.l ? (c = L(c, b.l, b), b.l.i = c, b.l = c, a.j++) : P(a, c);
        }
        function P(a, b) {
            b = L(b, a.g.l, a.g);
            b.l.i = b;
            a.g.l = b;
            a.j++;
            return b;
        }
        K.prototype.size = function() {
            return this.j;
        };
        function L(a, b, c) {
            return {
                o: a,
                i: c,
                l: b
            };
        }
        function Q(a, b) {
            if (b.l && b.i) {
                var c = b.l, d = b.i;
                c.i = d;
                d.l = c;
                b.i = null;
                b.l = null;
                a.j--;
            }
        }
        function R(a, b) {
            this.G = a;
            this.A = b;
            this.B = null;
            this.j = !1;
            this.F = null;
            this.h = !1;
            this.g = new K;
            this.m = new K;
        }
        e = R.prototype;
        e.destroy = function(a) {
            this.j = !0;
            this.B = a;
            for(var b = M(this.g); b;)b.o.u(a), b = N(this.g, b);
            a = this.g;
            a.h = L(null, null, null);
            a.g = L(null, a.h, null);
            a.h.i = a.g;
            a.j = 0;
        };
        e.getNumberOfRunningTasks = function() {
            return this.m.size();
        };
        e.getNumberOfTasksInQueue = function() {
            return this.g.size();
        };
        e.isDestroyed = function() {
            return this.j;
        };
        e.isPaused = function() {
            return this.h;
        };
        e.pause = function() {
            this.h = !0;
        };
        e.resume = function() {
            this.h && (this.h = !1, S(this));
        };
        e.scheduleDefaultTask = function(a, b) {
            var c = this;
            return this.j ? Promise.reject(this.B) : this.A ? new Promise(function(d, n) {
                for(var g = M(c.g); g && g.o.s < b;)g = N(c.g, g);
                O(c.g, g, {
                    C: a,
                    s: b,
                    u: n,
                    D: d,
                    v: null
                });
                S(c);
            }) : Promise.reject(new J("Cannot call scheduleDefaultTask() because no defaultTask was specified."));
        };
        e.scheduleTask = function(a, b) {
            var c = this;
            return this.j ? Promise.reject(this.B) : new Promise(function(d, n) {
                for(var g = M(c.g); g && g.o.s < b;)g = N(c.g, g);
                O(c.g, g, {
                    C: null,
                    s: b,
                    u: n,
                    D: d,
                    v: a
                });
                S(c);
            });
        };
        e.setOnBeforeExecuteNextTask = function(a) {
            this.F = a;
        };
        function ia(a, b) {
            var c = P(a.m, b);
            Promise.resolve().then(function() {
                if (b.v) return b.v();
                if (a.A) return a.A(b.C);
            }).then(function(d) {
                b.D(d);
            }).catch(function(d) {
                b.u(d);
            }).finally(function() {
                Q(a.m, c);
                S(a);
            }).catch(function(d) {
                console.error(d);
            });
        }
        function S(a) {
            Promise.resolve().then(function() {
                if (a.m.size() < a.G) {
                    var b;
                    null == (b = a.F) || b.call(a);
                    if (!a.h) {
                        b = a.g;
                        if (0 === b.j) b = null;
                        else {
                            var c = b.g.l;
                            Q(b, c);
                            b = c;
                        }
                        b && ia(a, b.o);
                    }
                }
            }).catch(function(b) {
                console.error("Unexpected error in InternalAsyncTaskQueue.maybeExecuteNextTask", b);
            });
        }
        function T(a, b) {
            this.g = new R(a, b);
        }
        e = T.prototype;
        e.destroy = function(a) {
            this.g.destroy(a);
        };
        e.getNumberOfRunningTasks = function() {
            return this.g.getNumberOfRunningTasks();
        };
        e.getNumberOfTasksInQueue = function() {
            return this.g.getNumberOfTasksInQueue();
        };
        e.isDestroyed = function() {
            return this.g.isDestroyed();
        };
        e.isPaused = function() {
            return this.g.isPaused();
        };
        e.pause = function() {
            this.g.pause();
        };
        e.resume = function() {
            this.g.resume();
        };
        e.scheduleDefaultTask = function(a, b) {
            return this.g.scheduleDefaultTask(a, b);
        };
        e.scheduleTask = function(a, b) {
            return this.g.scheduleTask(a, b);
        };
        e.setOnBeforeExecuteNextTask = function(a) {
            this.g.setOnBeforeExecuteNextTask(a);
        };
        var U = __lib__base64_js;
        function V() {}
        V.prototype.logError = function() {
            this.g.apply(this, [
                "error"
            ].concat(f(q.apply(0, arguments))));
        };
        V.prototype.logInfo = function() {
            this.g.apply(this, [
                "info"
            ].concat(f(q.apply(0, arguments))));
        };
        V.prototype.logWarning = function() {
            this.g.apply(this, [
                "warn"
            ].concat(f(q.apply(0, arguments))));
        };
        V.prototype.g = function(a) {
            var b = q.apply(1, arguments);
            "undefined" !== typeof console && console[a] && console[a].apply(console, f(b));
        };
        var W;
        function X() {
            W.logError.apply(W, f(q.apply(0, arguments)));
        }
        function Y(a) {
            if (!ja) {
                ja = !0;
                var b = da();
                b && "function" === typeof b.addEventListener && b.addEventListener("unhandledrejection", function(c) {
                    X("Unhandled Promise rejection", c.reason);
                    c.cancelable && c.preventDefault();
                });
            }
            W = a;
        }
        var ja = !1;
        Y(new V);
        var Z = {
            XML_ELEMENT: 1,
            TEXT: 3
        };
        Z[Z.XML_ELEMENT] = "XML_ELEMENT";
        Z[Z.TEXT] = "TEXT";
        function ka(a) {
            for(var b = [], c = 0; c < a.attributes.length; c++){
                var d = a.attributes[c];
                "src" !== d.localName && (1E4 < d.value.length ? console.warn('Skipped attribute "' + d.name + '" on <' + a.tagName + ">. The value exceeded the maximum length.") : b.push({
                    localName: d.localName,
                    namespaceURI: d.namespaceURI,
                    prefix: d.prefix,
                    value: d.value
                }));
            }
            return b;
        }
        function la(a, b) {
            var c = [];
            if (b) for(var d = a.firstChild; d;)d && 1 === d.nodeType ? c.push(la(d, b)) : d && 3 === d.nodeType && c.push({
                data: d.data,
                nodeType: 3
            }), d = d.nextSibling;
            return {
                attributes: ka(a),
                childNodes: c,
                namespaceURI: a.namespaceURI,
                nodeName: a.localName,
                nodeType: 1,
                prefix: a.prefix
            };
        }
        api = {
            AsyncTaskQueue: T,
            Axis: {
                X: "X",
                Y: "Y"
            },
            Base64: {
                decode: function(a) {
                    return U.toByteArray(a);
                },
                encode: function(a) {
                    return U.fromByteArray(a);
                }
            },
            BrowserDetector: {
                getBrowserVersion: function() {
                    return A().getBrowserVersion() || "";
                },
                getOsName: function() {
                    return A().getOS().name || "";
                },
                getOsVersion: B,
                isBrowser: function(a) {
                    return A().getBrowser().name === a;
                },
                isOS: C,
                isPlatform: function(a) {
                    var b = A().getPlatformType();
                    "desktop" === b && "MacIntel" === navigator.platform && 1 < navigator.maxTouchPoints && (b = "tablet");
                    return b === a;
                },
                isRenderingEngine: function(a) {
                    return A().getEngine().name === a;
                },
                isSupportedBrowser: function(a) {
                    return !!A().satisfies(a);
                },
                overrideOsVersion: function(a) {
                    z = a;
                }
            },
            ColibrioError: v,
            ColibrioErrorType: {
                ABORTED: "ABORTED",
                FOCUS_TARGETS_END_OF_DOCUMENT: "FOCUS_TARGETS_END_OF_DOCUMENT"
            },
            KeyCode: x,
            LengthUnit: {
                CSS_PIXELS: "CSS_PIXELS",
                PERCENT: "PERCENT",
                DEVICE_PIXELS: "DEVICE_PIXELS"
            },
            LengthUtils: {
                getLengthAsCssPixels: function(a, b) {
                    switch(a.unit){
                        case "CSS_PIXELS":
                            return a.value;
                        case "PERCENT":
                            return Math.round(a.value * b / 100);
                        case "DEVICE_PIXELS":
                            return Math.round(a.value) / window.devicePixelRatio;
                    }
                }
            },
            Logger: {
                getInstance: function() {
                    return W;
                },
                logError: X,
                logInfo: function() {
                    W.logInfo.apply(W, f(q.apply(0, arguments)));
                },
                logWarning: function() {
                    W.logWarning.apply(W, f(q.apply(0, arguments)));
                },
                setLogger: Y
            },
            NodeDataUtils: {
                createXmlElementAttributeData: ka,
                createXmlElementNodeData: la,
                isTextNodeData: function(a) {
                    return !!a && 3 === a.nodeType && "string" === typeof a.data && !t(a, "parent");
                },
                isXmlElementNodeData: function(a) {
                    return !!a && 1 === a.nodeType && ea(a.childNodes) && !t(a, "parent");
                }
            },
            NodeType: Z,
            RuntimePlatform: {
                isBlobUrlSupported: function() {
                    if (null === D) {
                        var a = B().split(".");
                        a = parseInt(a[0]);
                        D = "function" === typeof URL.createObjectURL && (isNaN(a) || !C("iOS") || 9 < a);
                    }
                    return D;
                },
                isCssDeclarationSupported: function(a, b) {
                    if ("object" !== typeof document) return !1;
                    var c = a + ":" + b;
                    if (E.has(c)) return E.get(c);
                    F || (F = document.createElement("div"));
                    var d = F.style;
                    d.setProperty(a, b);
                    b = d.getPropertyValue(a) === b;
                    d.removeProperty(a);
                    E.set(c, b);
                    return b;
                }
            },
            TextDirection: {
                LTR: "LTR",
                RTL: "RTL"
            },
            TimeIntervalUtils: {
                isIntersecting: function(a, b) {
                    return a.startMs === a.endMs ? G(a.startMs, b) : b.startMs === b.endMs ? G(b.startMs, a) : r(a.endMs) ? r(b.endMs) ? !0 : a.startMs < b.endMs : r(b.endMs) ? b.startMs < a.endMs : !(a.endMs <= b.startMs || a.startMs >= b.endMs);
                }
            },
            TreeNodeWalker: H,
            XmlNamespace: {
                DC: "http://purl.org/dc/elements/1.1/",
                DCTERMS: "http://purl.org/dc/terms/",
                EPUB: "http://www.idpf.org/2007/ops",
                EPUB_A11Y: "http://www.idpf.org/epub/vocab/package/a11y/#",
                EPUB_OPF_META_VOCABULARY: "http://idpf.org/epub/vocab/package/meta/#",
                EPUB_RENDITION: "http://www.idpf.org/vocab/rendition/#",
                EPUB_ENCRYPTION_COMPRESSION: "http://www.idpf.org/2016/encryption#compression",
                HTML: "http://www.w3.org/1999/xhtml",
                IBOOKS: "http://vocabulary.itunes.apple.com/rdf/ibooks/vocabulary-extensions-1.0/",
                MARC: "http://id.loc.gov/vocabulary/",
                MATHML: "http://www.w3.org/1998/Math/MathML",
                MEDIA_OVERLAYS: "http://www.idpf.org/epub/vocab/overlays/#",
                OPF: "http://www.idpf.org/2007/opf",
                ONIX: "http://www.editeur.org/ONIX/book/codelists/current.html#",
                RDF: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
                RDFS: "http://www.w3.org/2000/01/rdf-schema#",
                SCHEMA_ORG: "http://schema.org/",
                SVG: "http://www.w3.org/2000/svg",
                XLINK: "http://www.w3.org/1999/xlink",
                XML: "http://www.w3.org/XML/1998/namespace",
                XML_ENCRYPTION: "http://www.w3.org/2001/04/xmlenc#",
                XML_SIGNATURES: "http://www.w3.org/2000/09/xmldsig#",
                XMP: "http://ns.adobe.com/xap/1.0/",
                XSD: "http://www.w3.org/2001/XMLSchema#"
            }
        };
        var ma = new ArrayBuffer(8);
        new DataView(ma);
        new Uint8Array(ma);
    }).call(__self);
    return api;
});

});

parcelRegister("loFPd", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";

(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base) {
    var api = {};
    (function() {
        function h(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var k = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function l(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var m = l(this);
        function n(a, b) {
            if (b) a: {
                var c = m;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var e = a[d];
                    if (!(e in c)) break a;
                    c = c[e];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && k(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        n("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, g) {
                this.g = f;
                k(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        });
        n("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = m[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && k(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return p(h(this));
                    }
                });
            }
            return a;
        });
        function p(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        var q = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, r;
        if ("function" == typeof Object.setPrototypeOf) r = Object.setPrototypeOf;
        else {
            var t;
            a: {
                var u = {
                    a: !0
                }, v = {};
                try {
                    v.__proto__ = u;
                    t = v.a;
                    break a;
                } catch (a) {}
                t = !1;
            }
            r = t ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var w = r;
        function x() {
            this.j = !1;
            this.g = null;
            this.m = void 0;
            this.h = 1;
            this.o = 0;
            this.i = null;
        }
        function y(a) {
            if (a.j) throw new TypeError("Generator is already running");
            a.j = !0;
        }
        x.prototype.l = function(a) {
            this.m = a;
        };
        function z(a, b) {
            a.i = {
                s: b,
                u: !0
            };
            a.h = a.o;
        }
        x.prototype.return = function(a) {
            this.i = {
                return: a
            };
            this.h = this.o;
        };
        function A(a, b) {
            a.h = 5;
            return {
                value: b
            };
        }
        function B(a) {
            this.g = new x;
            this.h = a;
        }
        function C(a, b) {
            y(a.g);
            var c = a.g.g;
            if (c) return D(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return E(a);
        }
        function D(a, b, c, d) {
            try {
                var e = b.call(a.g.g, c);
                if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                if (!e.done) return a.g.j = !1, e;
                var f = e.value;
            } catch (g) {
                return a.g.g = null, z(a.g, g), E(a);
            }
            a.g.g = null;
            d.call(a.g, f);
            return E(a);
        }
        function E(a) {
            for(; a.g.h;)try {
                var b = a.h(a.g);
                if (b) return a.g.j = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.m = void 0, z(a.g, c);
            }
            a.g.j = !1;
            if (a.g.i) {
                b = a.g.i;
                a.g.i = null;
                if (b.u) throw b.s;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function F(a) {
            this.next = function(b) {
                y(a.g);
                a.g.g ? b = D(a, a.g.g.next, b, a.g.l) : (a.g.l(b), b = E(a));
                return b;
            };
            this.throw = function(b) {
                y(a.g);
                a.g.g ? b = D(a, a.g.g["throw"], b, a.g.l) : (z(a.g, b), b = E(a));
                return b;
            };
            this.return = function(b) {
                return C(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function G(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function f(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        }
        var H = __dep__colibrio_core_base;
        function I(a) {
            if (0 === a.length) return new Uint8Array(0);
            if (1 === a.length) return a[0];
            for(var b = 0, c = 0; c < a.length; c++)b += a[c].byteLength;
            b = new Uint8Array(b);
            for(var d = c = 0; d < a.length; d++){
                var e = a[d];
                b.set(e, c);
                c += e.byteLength;
            }
            return b;
        }
        var J = new Uint16Array(1);
        J[0] = 4660;
        new Uint8Array(J.buffer);
        function K(a, b) {
            return "data:" + a + ";base64," + b;
        }
        function L() {
            this.g = new Set;
            this.h = null;
        }
        L.prototype.createUrlForBlob = function(a) {
            a = URL.createObjectURL(a);
            this.g.add(a);
            return a;
        };
        L.prototype.createUrl = function(a, b, c) {
            if (H.RuntimePlatform.isBlobUrlSupported() && !c) b = b ? new Blob(a, {
                type: b
            }) : new Blob(a), a = URL.createObjectURL(b), b = {
                blob: b,
                url: a
            }, this.g.add(a);
            else {
                if (a.every(function(Z) {
                    return "string" === typeof Z;
                })) a = "data:" + b + ";charset=UTF-8," + encodeURIComponent(a.join(""));
                else {
                    c = [];
                    for(var d = 0; d < a.length; d++){
                        var e = a[d];
                        if ("string" === typeof e) {
                            var f = c, g = f.push;
                            this.h || (this.h = new TextEncoder);
                            e = this.h.encode(e);
                            g.call(f, e);
                        } else e instanceof ArrayBuffer ? c.push(new Uint8Array(e)) : e instanceof Uint8Array ? c.push(e) : c.push(new Uint8Array(e.buffer, e.byteOffset, e.byteLength));
                    }
                    a = K(b, H.Base64.encode(I(c)));
                }
                b = {
                    blob: null,
                    url: a
                };
            }
            return b;
        };
        L.prototype.revokeAllUrls = function() {
            var a = this;
            this.g.forEach(function(b) {
                return a.revokeUrl(b);
            });
            this.g.clear();
        };
        L.prototype.revokeUrl = function(a) {
            this.g.delete(a) && URL.revokeObjectURL(a);
        };
        function M(a, b) {
            return H.ColibrioError.call(this, "colibrio.core.io", a, b) || this;
        }
        var N = H.ColibrioError;
        M.prototype = q(N.prototype);
        M.prototype.constructor = M;
        if (w) w(M, N);
        else for(var O in N)if ("prototype" != O) {
            if (Object.defineProperties) {
                var P = Object.getOwnPropertyDescriptor(N, O);
                P && Object.defineProperty(M, O, P);
            } else M[O] = N[O];
        }
        function Q(a, b) {
            this.i = a;
            this.h = b;
            this.g = null;
        }
        Q.prototype.abort = function() {};
        Q.prototype.asText = function() {
            return Promise.reject(this.h);
        };
        Q.prototype.asUint8Array = function() {
            return Promise.reject(this.h);
        };
        Q.prototype.getMetadata = function() {
            return this.i;
        };
        Q.prototype.getReadableStream = function() {
            var a = this;
            this.g || (this.g = new ReadableStream({
                start: function(b) {
                    b.error(a.h);
                }
            }));
            return this.g;
        };
        function R() {
            this.h = this.g = void 0;
            this.i = new TextDecoder("utf-8");
        }
        var S;
        function T() {
            S || (S = new R);
            return S;
        }
        R.prototype.decode = function(a) {
            return 2 <= a.length && 254 === a[0] && 255 === a[1] && (void 0 === this.g && (this.g = U("utf-16be")), this.g) ? this.g.decode(a) : 2 <= a.length && 255 === a[0] && 254 === a[1] && (void 0 === this.h && (this.h = U("utf-16le")), this.h) ? this.h.decode(a) : this.i.decode(a);
        };
        function U(a) {
            try {
                return new TextDecoder(a);
            } catch (b) {
                return console.error(b), null;
            }
        }
        function V(a, b, c) {
            this.i = a;
            this.h = b;
            this.j = c;
            this.g = !1;
        }
        V.prototype.getMetadata = function() {
            return this.i;
        };
        V.prototype.abort = function() {
            if (!this.g) {
                this.g = !0;
                var a;
                null == (a = this.j) || a.call(this);
            }
        };
        V.prototype.asText = function() {
            return W(this).then(function(a) {
                return T().decode(a);
            });
        };
        V.prototype.asUint8Array = function() {
            return W(this);
        };
        V.prototype.getReadableStream = function() {
            return this.h;
        };
        function W(a) {
            var b, c, d, e;
            return G(new F(new B(function(f) {
                switch(f.h){
                    case 1:
                        b = a.h.getReader(), c = [], d = !1;
                    case 2:
                        if (d) {
                            f.h = 4;
                            break;
                        }
                        return A(f, b.read());
                    case 5:
                        e = f.m;
                        if (a.g) throw b.cancel().catch(function(g) {
                            H.ColibrioError.isColibrioAbortedError(g) || H.Logger.logWarning(g);
                        }), new M(H.ColibrioErrorType.ABORTED);
                        e.value && c.push(e.value);
                        d = e.done;
                        f.h = 2;
                        break;
                    case 4:
                        return f.return(I(c));
                }
            })));
        }
        function X(a, b) {
            this.i = a;
            this.h = null;
            this.g = b;
        }
        X.prototype.abort = function() {
            this.g && (this.g = null);
        };
        X.prototype.asText = function() {
            if (!this.g) return Promise.reject(new M(H.ColibrioErrorType.ABORTED));
            var a = T().decode(I(this.g));
            return Promise.resolve(a);
        };
        X.prototype.asUint8Array = function() {
            return this.g ? Promise.resolve(I(this.g)) : Promise.reject(new M(H.ColibrioErrorType.ABORTED));
        };
        X.prototype.getMetadata = function() {
            return this.i;
        };
        X.prototype.getReadableStream = function() {
            var a = this;
            if (!this.h) {
                var b = 0;
                this.h = new ReadableStream({
                    cancel: function() {
                        a.g = null;
                    },
                    pull: function(c) {
                        a.g ? (b < a.g.length && c.enqueue(a.g[b++]), b === a.g.length && (a.g = null, c.close())) : c.error(new M(H.ColibrioErrorType.ABORTED));
                    }
                });
            }
            return this.h;
        };
        api = {
            BlobUrlManager: L,
            Endianness: {
                BIG_ENDIAN: "BIG_ENDIAN",
                LITTLE_ENDIAN: "LITTLE_ENDIAN"
            },
            ErrorResourceResponse: Q,
            IoError: M,
            IoErrorType: {
                BYTE_RANGES_NOT_SUPPORTED: "BYTE_RANGES_NOT_SUPPORTED",
                INVALID_BYTE_RANGE: "INVALID_BYTE_RANGE",
                INVALID_DATA_CHUNK: "INVALID_DATA_CHUNK",
                READABLE_STREAM_ALREADY_LOCKED: "READABLE_STREAM_ALREADY_LOCKED",
                RESOURCE_NOT_FOUND: "RESOURCE_NOT_FOUND",
                RESOURCE_ENCRYPTED: "RESOURCE_ENCRYPTED",
                RESOURCE_BODY_LOCKED: "RESOURCE_BODY_LOCKED"
            },
            MediaType: {
                APPLICATION_EPUB_ZIP: "application/epub+zip",
                APPLICATION_HTML: "application/html",
                APPLICATION_LPF_ZIP: "application/lpf+zip",
                APPLICATION_NCX: "application/x-dtbncx+xml",
                APPLICATION_OPF_PACKAGE: "application/oebps-package+xml",
                APPLICATION_PDF: "application/pdf",
                APPLICATION_SMIL: "application/smil+xml",
                APPLICATION_XHTML: "application/xhtml+xml",
                APPLICATION_VND_MS_OPENTYPE: "application/vnd.ms-opentype",
                APPLICATION_XML: "application/xml",
                APPLICATION_ZIP: "application/zip",
                AUDIO_AAC: "audio/aac",
                AUDIO_MPEG: "audio/mpeg",
                AUDIO_MP4: "audio/mp4",
                AUDIO_OGG: "audio/ogg",
                AUDIO_WEBM: "audio/webm",
                AUDIO_WAV: "audio/wav",
                AUDIO_WAVE: "audio/wave",
                FONT_OTF: "font/opentype",
                FONT_TTF: "font/truetype",
                FONT_WOFF: "font/woff",
                FONT_WOFF2: "font/woff2",
                IMAGE_BMP: "image/bmp",
                IMAGE_PNG: "image/png",
                IMAGE_JPEG: "image/jpeg",
                IMAGE_SVG: "image/svg+xml",
                IMAGE_GIF: "image/gif",
                TEXT_CSS: "text/css",
                TEXT_JAVASCRIPT: "text/javascript",
                TEXT_HTML: "text/html",
                VIDEO_MP4: "video/mp4",
                VIDEO_WEBM: "video/webm"
            },
            MediaTypeCategory: {
                FONT: "font/*",
                IMAGE: "image/*",
                VIDEO: "video/*",
                AUDIO: "audio/*"
            },
            ReadableStreamResourceResponse: V,
            Uint8ArrayResourceResponse: X
        };
        var Y = new ArrayBuffer(8);
        new DataView(Y);
        new Uint8Array(Y);
    }).call(__self);
    return api;
});

});

parcelRegister("csyWb", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";




(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("bkFGj")), (parcelRequire("a75zb")), (parcelRequire("loFPd")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_selector_base, __dep__colibrio_core_url, __dep__colibrio_core_io_base) {
    var api = {};
    (function() {
        var d, e = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, g;
        if ("function" == typeof Object.setPrototypeOf) g = Object.setPrototypeOf;
        else {
            var h;
            a: {
                var k = {
                    a: !0
                }, l = {};
                try {
                    l.__proto__ = k;
                    h = l.a;
                    break a;
                } catch (a) {}
                h = !1;
            }
            g = h ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var n = g;
        var p = __dep__colibrio_core_base;
        var q = __dep__colibrio_core_url;
        var u = Array.isArray;
        function v(a) {
            return "string" === typeof a;
        }
        var w = new Uint16Array(1);
        w[0] = 4660;
        new Uint8Array(w.buffer);
        function x(a, b) {
            this.h = a;
            this.g = b;
        }
        d = x.prototype;
        d.getSelectors = function() {
            return this.g;
        };
        d.getSourceUrl = function() {
            return this.h;
        };
        d.toJSON = function() {
            return {
                selectors: this.g.map(function(a) {
                    return a.toString();
                }),
                sourceUrl: this.h
            };
        };
        d.toLegacyAnnotationTarget = function() {
            return 0 < this.g.length ? {
                id: this.h,
                selector: this.g[0].toJSON()
            } : {
                id: this.h
            };
        };
        d.toString = function(a) {
            v(a) || (a = this.h);
            return 0 === this.g.length ? a : a + "#" + this.g[0].toString();
        };
        d.toUrl = function(a) {
            return new URL(this.toString(a));
        };
        d.toWebAnnotationResource = function() {
            var a = this.h;
            return {
                id: 0 === this.g.length ? a : a + "#" + this.g[0].toString()
            };
        };
        d.toWebAnnotationSpecificResource = function() {
            return {
                selector: this.g.map(function(a) {
                    return a.toJSON();
                }),
                source: this.h
            };
        };
        function y(a, b) {
            return p.ColibrioError.call(this, "core.locator", a, b) || this;
        }
        var z = p.ColibrioError;
        y.prototype = e(z.prototype);
        y.prototype.constructor = y;
        if (n) n(y, z);
        else for(var A in z)if ("prototype" != A) {
            if (Object.defineProperties) {
                var E = Object.getOwnPropertyDescriptor(z, A);
                E && Object.defineProperty(y, A, E);
            } else y[A] = z[A];
        }
        function F(a) {
            this.g = a;
        }
        d = F.prototype;
        d.collapseRangeLocatorToEnd = function(a) {
            var b = a.getSelectors().map(function(c) {
                return c.collapseToEnd();
            });
            return new x(a.getSourceUrl(), b);
        };
        d.collapseRangeLocatorToStart = function(a) {
            var b = a.getSelectors().map(function(c) {
                return c.collapseToStart();
            });
            return new x(a.getSourceUrl(), b);
        };
        d.createRangeLocator = function(a, b) {
            return a.getSourceUrl() !== b.getSourceUrl() ? {
                error: new y("INVALID_URL", "startLocator and endLocator have different sourceUrls."),
                locator: null
            } : (b = this.g.createRangeSelectors(a.getSelectors(), b.getSelectors())) && 0 !== b.length ? {
                error: null,
                locator: new x(a.getSourceUrl(), b)
            } : {
                error: new y("UNABLE_TO_CREATE_RANGE_SELECTORS", "Unable to create rangeSelectors"),
                locator: null
            };
        };
        d.getSelectorFactory = function() {
            return this.g;
        };
        d.parse = function(a, b) {
            a = G(this, a, b);
            if (a instanceof x) return {
                error: null,
                locator: a
            };
            p.Logger.logError(a);
            return {
                error: a,
                locator: null
            };
        };
        function H(a, b, c) {
            var f = null, r = !0;
            if (v(b.sourceUrl) && u(b.selectors)) try {
                f = new URL(b.sourceUrl);
                var B = b.selectors;
                var m = [];
                for(c = 0; c < B.length; c++){
                    var C = B[c];
                    if (v(C)) {
                        var D = a.g.createFromFragment(C);
                        D && m.push(D);
                    }
                }
            } catch (t) {
                return new y("INVALID_LOCATOR_DATA", 'Invalid "sourceUrl": ' + b.sourceUrl);
            }
            else if (v(b.source)) try {
                f = new URL(b.source);
            } catch (t) {
                return new y("INVALID_LOCATOR_DATA", 'Invalid "source": ' + b.source);
            }
            else if (v(b.id)) try {
                f = new URL(b.id), r = !f.hash || "#" === f.hash;
            } catch (t) {
                return new y("INVALID_LOCATOR_DATA", 'Invalid "id": ' + b.id);
            }
            else if (c && b.selector) {
                if (c instanceof URL) f = c;
                else try {
                    f = new URL(c);
                } catch (t) {
                    return new y("INVALID_URL", "Invalid baseUrl: " + c);
                }
            } else return new y("INVALID_LOCATOR_DATA", 'Missing "source" or "id"');
            m || (m = r && "undefined" !== typeof b.selector ? a.g.createFromSelectorData(b.selector) : []);
            return I(a, f, m);
        }
        function I(a, b, c) {
            (b.hash || "#" !== b.hash) && (a = a.g.createFromFragment(b.hash, c)) && (c = [
                a
            ]);
            return new x(q.URLUtils.getUrlWithoutHash(b), c);
        }
        function G(a, b, c) {
            if (b instanceof x) return b;
            if (b instanceof URL) return I(a, b, []);
            if (v(b)) try {
                var f = new URL(b, c);
                return I(a, f, []);
            } catch (r) {
                return new y("INVALID_URL", b);
            }
            else return b && !u(b) && "object" === typeof b ? H(a, b, c) : new y("INVALID_LOCATOR_DATA", "Must be an object or string. Got: " + typeof b);
        }
        api = {
            Locator: x,
            LocatorError: y,
            LocatorErrorType: {
                INVALID_URL: "INVALID_URL",
                INVALID_LOCATOR_DATA: "INVALID_LOCATOR_DATA",
                UNABLE_TO_CREATE_RANGE_SELECTORS: "UNABLE_TO_CREATE_RANGE_SELECTORS"
            },
            LocatorFactory: F
        };
        var J = new ArrayBuffer(8);
        new DataView(J);
        new Uint8Array(J);
    }).call(__self);
    return api;
});

});
parcelRegister("bkFGj", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";

(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base) {
    var api = {};
    (function() {
        var f;
        function h(a) {
            var c = 0;
            return function() {
                return c < a.length ? {
                    done: !1,
                    value: a[c++]
                } : {
                    done: !0
                };
            };
        }
        function k(a) {
            if (!(a instanceof Array)) {
                var c = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
                if (c) a = c.call(a);
                else if ("number" == typeof a.length) a = {
                    next: h(a)
                };
                else throw Error(String(a) + " is not an iterable or ArrayLike");
                for(var b = []; !(c = a.next()).done;)b.push(c.value);
                a = b;
            }
            return a;
        }
        var l = "function" == typeof Object.create ? Object.create : function(a) {
            function c() {}
            c.prototype = a;
            return new c;
        }, m;
        if ("function" == typeof Object.setPrototypeOf) m = Object.setPrototypeOf;
        else {
            var p;
            a: {
                var q = {
                    a: !0
                }, r = {};
                try {
                    r.__proto__ = q;
                    p = r.a;
                    break a;
                } catch (a) {}
                p = !1;
            }
            m = p ? function(a, c) {
                a.__proto__ = c;
                if (a.__proto__ !== c) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var t = m;
        function u(a) {
            return "string" === typeof a && /\S/.test(a);
        }
        var v = Array.isArray;
        var x = new Uint16Array(1);
        x[0] = 4660;
        new Uint8Array(x.buffer);
        function y(a) {
            return !!a && "string" === typeof a.type;
        }
        function z(a) {
            for(var c = Object.keys(a), b = [], d = 0; d < c.length; d++){
                var e = c[d], g = a[e];
                e = A(e) + "=";
                y(g) ? b.push(e + z(g)) : v(g) && 0 < g.length ? (g = g[0], y(g) && b.push(e + z(g))) : "string" === typeof g ? b.push(e + A(g)) : ("number" === typeof g && !isNaN(g) || "boolean" === typeof g) && b.push(e + g.toString());
            }
            return "selector(" + b.join(",") + ")";
        }
        function A(a) {
            return a.replace(/[ =,#()]/g, function(c) {
                return "%" + c.charCodeAt(0).toString(16);
            });
        }
        function B() {}
        B.prototype.getType = function() {
            return "FragmentSelector";
        };
        B.prototype.toJSON = function() {
            var a = this.getRefinementSelectors().map(function(b) {
                return b.toJSON();
            }), c;
            1 < a.length ? c = a : 1 === a.length && (c = a[0]);
            return {
                refinedBy: c,
                type: this.getType(),
                value: this.getValue()
            };
        };
        B.prototype.toString = function() {
            return 0 < this.getRefinementSelectors().length ? z(this.toJSON()) : this.getValue();
        };
        function C(a, c, b) {
            this.j = a;
            this.g = c;
            this.h = b;
        }
        C.prototype = l(B.prototype);
        C.prototype.constructor = C;
        if (t) t(C, B);
        else for(var D in B)if ("prototype" != D) {
            if (Object.defineProperties) {
                var E = Object.getOwnPropertyDescriptor(B, D);
                E && Object.defineProperty(C, D, E);
            } else C[D] = B[D];
        }
        f = C.prototype;
        f.collapseToEnd = function() {
            return this;
        };
        f.collapseToStart = function() {
            return this;
        };
        f.createRangeSelectorTo = function() {
            return null;
        };
        f.getFragmentSpecificationIri = function() {
            return this.g;
        };
        f.getRefinementSelectors = function() {
            return this.h;
        };
        f.getValue = function() {
            return this.j;
        };
        f.isRangeSelector = function() {
            return !1;
        };
        function F() {}
        F.prototype.canParseSelectorData = function(a) {
            return "FragmentSelector" === a.type;
        };
        F.prototype.parseSelectorData = function(a, c) {
            if (!u(a.value)) return null;
            var b = null, d = c.createFromSelectorData(a.refinedBy);
            if (u(a.conformsTo)) {
                var e = c.getFragmentSelectorParsers().find(function(g) {
                    return g.getFragmentSpecificationIri() === a.conformsTo && g.canParseFragment(a.value);
                });
                e && (b = e.parseFragment(a.value, c, d));
            }
            b || (b = c.createFromFragment(a.value, d));
            b || (b = new C(a.value, a.conformsTo || "", d));
            return b;
        };
        function G(a, c) {
            this.g = a.collapseToStart();
            this.h = c.collapseToEnd();
        }
        f = G.prototype;
        f.collapseToEnd = function() {
            return this.h;
        };
        f.collapseToStart = function() {
            return this.g;
        };
        f.createRangeSelectorTo = function(a) {
            return new G(this.g, a);
        };
        f.getEndSelector = function() {
            return this.h;
        };
        f.getRefinementSelectors = function() {
            return [];
        };
        f.getStartSelector = function() {
            return this.g;
        };
        f.getType = function() {
            return "RangeSelector";
        };
        f.isRangeSelector = function() {
            return !0;
        };
        f.toJSON = function() {
            return {
                end: this.h.toJSON(),
                start: this.g.toJSON(),
                type: "RangeSelector"
            };
        };
        f.toString = function() {
            return z(this.toJSON());
        };
        function H(a) {
            this.h = a;
            this.g = 0;
            this.m = this.h.length;
        }
        H.prototype.parse = function() {
            return 1 === I(this).i ? J(this) : null;
        };
        function I(a) {
            for(var c = a.g, b = -1, d = ""; a.g < a.m && -1 === b;){
                var e = a.h.charCodeAt(a.g);
                40 === e ? (b = 1, d = a.h.slice(c, a.g++)) : 41 === e ? (b = 4, d = a.h.slice(c, a.g)) : 44 === e ? (b = 4, d = a.h.slice(c, a.g++)) : a.g++;
            }
            return {
                i: b,
                j: d
            };
        }
        function J(a) {
            var c = {};
            do {
                var b = a;
                for(var d = -1, e = ""; b.g < b.m && 44 === b.h.charCodeAt(b.g);)b.g++;
                for(var g = b.g; b.g < b.m && -1 === d;){
                    var n = b.h.charCodeAt(b.g);
                    61 === n ? (d = 3, e = b.h.slice(g, b.g++)) : (41 === n && (d = 2), b.g++);
                }
                b = {
                    i: d,
                    j: e
                };
                3 === b.i && (d = decodeURIComponent(b.j), b = I(a), 4 === b.i ? c[d] = decodeURIComponent(b.j) : 1 === b.i && (c[d] = J(a)));
            }while (-1 !== b.i && 2 !== b.i);
            return c;
        }
        function K() {}
        K.prototype.canParseFragment = function(a) {
            return a.startsWith("selector(") || a.startsWith("state(");
        };
        K.prototype.getFragmentSpecificationIri = function() {
            return "";
        };
        K.prototype.parseFragment = function(a, c) {
            a = new H(a).parse();
            c = c.createFromSelectorData(a);
            return 0 < c.length ? c[0] : null;
        };
        function L(a) {
            this.g = [];
            this.h = [];
            this.h.push(new K);
            for(var c = 0; c < a.length; c++){
                var b = a[c];
                "function" === typeof b.canParseFragment && this.h.push(b);
                "function" === typeof b.canParseSelectorData && this.g.push(b);
            }
            this.g.push(new F);
        }
        f = L.prototype;
        f.createFromFragment = function(a, c) {
            a.startsWith("#") && (a = a.slice(1));
            for(var b = null, d = 0; !b && d < this.h.length; d++){
                var e = this.h[d];
                e.canParseFragment(a) && (b = e.parseFragment(a, this, c || []));
            }
            return b;
        };
        f.createFromSelectorData = function(a) {
            var c = [];
            if (v(a)) {
                for(var b = 0; b < a.length; b++)if (y(a[b])) {
                    var d = M(this, a[b]);
                    d && c.push(d);
                }
            } else y(a) && (a = M(this, a)) && c.push(a);
            return c;
        };
        f.createRangeSelectors = function(a, c) {
            for(var b = [], d = {}, e = 0; e < a.length; d = {
                l: void 0
            }, e++){
                d.l = a[e];
                for(var g = null, n = 0; !g && n < c.length; n++){
                    var w = c[n];
                    (g = d.l.createRangeSelectorTo(w)) || d.l.getType() !== w.getType() || (g = new G(d.l, w));
                }
                g ? b.push(g) : b.push.apply(b, k(c.map(function(P) {
                    return function(Q) {
                        return new G(P.l, Q);
                    };
                }(d))));
            }
            return b;
        };
        f.getFragmentSelectorParsers = function() {
            return this.h;
        };
        f.getSelectorDataParsers = function() {
            return this.g;
        };
        function M(a, c) {
            for(var b = null, d = 0; !b && d < a.g.length; d++){
                var e = a.g[d];
                e.canParseSelectorData(c) && (b = e.parseSelectorData(c, a));
            }
            return b;
        }
        function N() {}
        N.prototype.canParseSelectorData = function(a) {
            return "RangeSelector" === a.type;
        };
        N.prototype.parseSelectorData = function(a, c) {
            if (!y(a.start) || !y(a.end)) return null;
            var b = c.createFromSelectorData(a.start);
            a = c.createFromSelectorData(a.end);
            return 1 !== b.length || 1 !== a.length ? null : new G(b[0], a[0]);
        };
        api = {
            FragmentSelector: B,
            FragmentSpecificationIri: {
                CSV: "http://tools.ietf.org/rfc/rfc7111",
                EPUB3: "http://www.idpf.org/epub/linking/cfi/epub-cfi.html",
                HTML: "http://tools.ietf.org/rfc/rfc3236",
                MEDIA: "http://www.w3.org/TR/media-frags/",
                PDF: "http://tools.ietf.org/rfc/rfc3778",
                PLAIN_TEXT: "http://tools.ietf.org/rfc/rfc5147",
                RDF_XML: "http://tools.ietf.org/rfc/rfc3870",
                SVG: "http://www.w3.org/TR/SVG/",
                XML: "http://tools.ietf.org/rfc/rfc3023"
            },
            RangeSelector: G,
            RangeSelectorDataParser: N,
            SelectorFactory: L,
            SelectorType: {
                CSS_SELECTOR: "CssSelector",
                FRAGMENT_SELECTOR: "FragmentSelector",
                RANGE_SELECTOR: "RangeSelector",
                SVG_SELECTOR: "SvgSelector",
                TEXT_QUOTE_SELECTOR: "TextQuoteSelector",
                TEXT_POSITION_SELECTOR: "TextPositionSelector",
                XPATH_SELECTOR: "XPathSelector"
            },
            UnknownFragmentSelector: C
        };
        var O = new ArrayBuffer(8);
        new DataView(O);
        new Uint8Array(O);
    }).call(__self);
    return api;
});

});

parcelRegister("a75zb", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";

(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base) {
    var api = {};
    (function() {
        var r;
        function aa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function ca(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var t = ca(this);
        function da(a, b) {
            if (b) a: {
                var c = t;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var e = a[d];
                    if (!(e in c)) break a;
                    c = c[e];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && ba(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        da("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, g) {
                this.g = f;
                ba(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        });
        da("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = t[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return ea(aa(this));
                    }
                });
            }
            return a;
        });
        function ea(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        function u(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return {
                next: aa(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        function fa(a) {
            if (!(a instanceof Array)) {
                a = u(a);
                for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                a = c;
            }
            return a;
        }
        var ha = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, ia;
        if ("function" == typeof Object.setPrototypeOf) ia = Object.setPrototypeOf;
        else {
            var ja;
            a: {
                var ka = {
                    a: !0
                }, la = {};
                try {
                    la.__proto__ = ka;
                    ja = la.a;
                    break a;
                } catch (a) {}
                ja = !1;
            }
            ia = ja ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var ma = ia;
        var w = __dep__colibrio_core_base;
        function x(a) {
            return 97 <= a && 122 >= a || 65 <= a && 90 >= a;
        }
        function y(a) {
            return 48 <= a && 57 >= a;
        }
        function na(a) {
            return y(a) || 65 <= a && 70 >= a || 97 <= a && 102 >= a;
        }
        function oa() {
            if ("object" === typeof self) return self;
            if ("object" === typeof window) return window;
            if ("object" === typeof $parcel$global) return $parcel$global;
            throw Error("Unable to get global this");
        }
        var pa = Array.isArray;
        var qa = new Uint16Array(1);
        qa[0] = 4660;
        new Uint8Array(qa.buffer);
        function z(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        var A = Error;
        z.prototype = ha(A.prototype);
        z.prototype.constructor = z;
        if (ma) ma(z, A);
        else for(var B in A)if ("prototype" != B) {
            if (Object.defineProperties) {
                var ra = Object.getOwnPropertyDescriptor(A, B);
                ra && Object.defineProperty(z, B, ra);
            } else z[B] = A[B];
        }
        function sa(a, b) {
            var c = C(a.g, b);
            return ta(a, b, c.M, c.J, c.L, c.K);
        }
        function ta(a, b, c, d, e, f) {
            for(var g = b >> f & 15, h = (c[e] & 15) + 1, m = e + 1, p = 0, n = 0, k = 0, l = 0; n < h;){
                var q = c[m + n], v = q & 15;
                if (g === v) {
                    k = q >> 4;
                    l = 0 === k ? 1 : k;
                    break;
                } else if (g < v) {
                    n--;
                    p -= l;
                    break;
                } else k = q >> 4, l = 0 === k ? 1 : k, p += l;
                n++;
            }
            n === h && (p -= l);
            g = m + h + p;
            l = 1 === l ? c[g] : 2 === l ? D(d, g) : ua(d, g);
            return 0 === k ? l : ta(a, b, c, d, e + l, f - 4);
        }
        function va(a, b) {
            var c = C(a.g, b);
            return wa(a, b, c.M, c.J, c.L, c.K);
        }
        function wa(a, b, c, d, e, f) {
            var g = b >> f & 15, h = c[e], m = (h & 15) + 1, p = h >> 4 & 3, n = e + 1 + (h >> 6 << 1), k = 0, l = 0;
            h = 0;
            var q = -1;
            if (2 === p) g & 1 ? (k = 1, l = c[n] >> 4 & 15, h = c[n + 1] >> 4 & 15) : h = c[n] >> 4 & 15;
            else {
                for(; k < m;){
                    var v = c[n + k], I = v & 15;
                    if (g < I) {
                        k--;
                        l -= h;
                        break;
                    } else if (h = v >> 4 & 15, 15 === h && (q++, h = c[e + 1 + (q << 1)]), g === I) break;
                    else l += h;
                    k++;
                }
                k === m && (k--, l -= h);
            }
            n += m;
            g = n + l;
            1 !== p ? (n += k, g += m) : g++;
            k = c[n];
            m = k & 7;
            p = !!(k & 8);
            if (1 === m || 2 === m || 3 === m) return E(m, p, null);
            k >>= 4;
            15 === k && (k = c[e + 2 + (q << 1)]);
            q = [];
            if (k) for(h /= k, l = 0; l < k; l++){
                switch(h){
                    case 1:
                        n = c[g++];
                        break;
                    case 2:
                        n = D(d, g);
                        g += 2;
                        break;
                    default:
                        n = ua(d, g), g += 3;
                }
                q.push(n);
            }
            if (0 === m) return wa(a, b, c, d, e + q[0], f - 4);
            if (4 === m || 5 === m) return E(m, p, q);
            if (6 === m) return q[0] = b + q[0], E(5, p, q);
            q[0] = b - q[0];
            return E(5, p, q);
        }
        function E(a, b, c) {
            return {
                R: b,
                type: a,
                values: c
            };
        }
        function xa(a, b) {
            var c = C(a.g, b);
            return ya(a, b, c.M, c.J, c.L, c.K);
        }
        function ya(a, b, c, d, e, f) {
            for(var g = b >> f & 15, h = (c[e] & 15) + 1, m = e + 1, p = 0, n = 0, k = 0, l = 0; n < h;){
                var q = c[m + n], v = q & 15;
                if (g === v) {
                    k = q >> 4;
                    l = 6 === k ? 1 : 7 === k ? 2 : 0;
                    break;
                } else if (g < v) {
                    n--;
                    p -= l;
                    break;
                } else k = q >> 4, l = 6 === k ? 1 : 7 === k ? 2 : 0, p += l;
                n++;
            }
            n === h && (p -= l);
            if (!l) return k;
            g = m + h + p;
            return ya(a, b, c, d, e + (1 === l ? c[g] : D(d, g)), f - 4);
        }
        function za(a, b, c, d, e, f) {
            for(var g = b >> f & 15, h = (c[e] & 15) + 1, m = e + 1, p = 0, n = 0, k = 0, l = 0; n < h;){
                var q = c[m + n], v = q & 15;
                if (g === v) {
                    k = q >> 4 & 3;
                    l = q >> 6;
                    break;
                } else if (g < v) {
                    n--;
                    p -= l;
                    break;
                } else k = q >> 4 & 3, l = q >> 6, p += l;
                n++;
            }
            n === h && (p -= l);
            if (0 === k) return !1;
            if (1 === k) return !0;
            g = m + h + p;
            return za(a, b, c, d, e + (1 === l ? c[g] : D(d, g)), f - 4);
        }
        function Aa(a) {
            this.g = a;
        }
        function D(a, b) {
            return a.g[b] + (a.g[b + 1] << 8);
        }
        function ua(a, b) {
            return a.g[b] + (a.g[b + 1] << 8) + (a.g[b + 2] << 16);
        }
        function F(a) {
            this.h = a;
            this.g = new Aa(a);
        }
        function C(a, b) {
            if (255 >= b) {
                b = 0;
                var c = 4;
            } else 65535 >= b ? (b = 1, c = 12) : (b = 2, c = 20);
            return {
                J: a.g,
                K: c,
                L: D(a.g, 2 * b),
                M: a.h
            };
        }
        var G = !1, Ba = new Set, H = [
            32,
            34,
            60,
            62,
            96
        ], Ca = new Set(H);
        H.push(35, 63, 123, 125);
        var Da = new Set(H);
        H.push(47, 58, 59, 61, 64, 91, 92, 93, 94, 124);
        var Ea = new Set(H);
        function Fa(a) {
            return 57 >= a ? a - 48 : 70 >= a ? a - 65 + 10 : a - 97 + 10;
        }
        function J(a) {
            if (2048 > a.length) return String.fromCharCode.apply(null, a);
            for(var b = "", c = 0; c + 2048 < a.length;){
                var d = c + 2048;
                b += String.fromCharCode.apply(null, a.slice(c, d));
                c = d;
            }
            return b + String.fromCharCode.apply(null, a.slice(c));
        }
        function Ga(a) {
            for(var b = [], c = 0; c < a.length; c++){
                var d = a[c];
                65535 >= d ? b.push(d) : (d -= 65536, b.push((d >> 10) + 55296, d % 1024 + 56320));
            }
            return b;
        }
        function Ha(a) {
            return 10 > a ? a + 48 : a + 65 - 10;
        }
        function K(a) {
            for(var b = a.length, c = new Uint8Array(b), d = 0, e = 0; e < b; e++){
                var f = a[e];
                37 !== f ? c[d++] = f : 2 < b - e && na(a[e + 1]) && na(a[e + 2]) ? (f = 16 * Fa(a[e + 1]) + Fa(a[e + 2]), c[d++] = f, e += 2) : c[d++] = f;
            }
            return Ia.decode(d < b ? c.subarray(0, d) : c);
        }
        function L(a, b) {
            a.push(37);
            16 > b ? a.push(48, Ha(b)) : a.push(Ha(b >> 4), Ha(b & 15));
        }
        function Ja(a, b) {
            return 31 >= b || 126 < b || a.has(b);
        }
        function Ka(a) {
            for(var b = [], c = a.length, d = 0; d < c; d++){
                var e = a.charCodeAt(d);
                if (55296 > e || 57343 < e) b.push(e);
                else if (56320 <= e || 1 === c - d) b.push(65533);
                else {
                    var f = a.charCodeAt(d + 1);
                    56320 <= f && 57343 >= f ? (b.push(1024 * (e - 55296) + f - 56320 + 65536), d++) : b.push(65533);
                }
            }
            return b;
        }
        function M(a) {
            a = "" + a;
            var b = N(a);
            return G ? J(b) : a;
        }
        function N(a) {
            var b = a.length, c = Array(b);
            G = !1;
            for(var d = 0; d < b; d++){
                var e = a.charCodeAt(d);
                if (55296 > e || 57343 < e) c[d] = e;
                else if (56320 <= e || 1 === b - d) c[d] = 65533, G = !0;
                else {
                    var f = a.charCodeAt(d + 1);
                    56320 <= f && 57343 >= f ? (c[d] = e, c[++d] = f) : (c[d] = 65533, G = !0);
                }
            }
            return c;
        }
        function O(a) {
            for(var b = [], c, d, e = a.length, f = 0; f < e; f++){
                var g = a[f];
                if (0 <= g && 127 >= g) b.push(g);
                else for(2047 >= g ? (b.push((g >> 6) + 192), d = 1) : (55296 <= g && 56319 >= g && (g = 1024 * (g - 55296) + a[++f] - 56320 + 65536), 65535 >= g ? (d = 2, c = 224) : (d = 3, c = 240), b.push((g >> 6 * d) + c)); 0 < d;)d--, b.push(g >> 6 * d & 63 | 128);
            }
            return b;
        }
        var Ia = new TextDecoder;
        function La(a) {
            var b = 128, c = 0, d = 72, e = [], f = a.lastIndexOf(45);
            if (0 < f) for(var g = 0; g < f; g++){
                var h = a[g];
                if (127 < h) return null;
                e.push(h);
            }
            for(f = f && f + 1; f < a.length;){
                g = c;
                h = 1;
                for(var m = 36;; m += 36){
                    if (f >= a.length) return null;
                    var p = a[f++];
                    p = 65 <= p && 90 >= p ? p - 65 : 97 <= p && 122 >= p ? p - 97 : y(p) ? p - 48 + 26 : -1;
                    if (-1 === p) return null;
                    c += p * h;
                    if (2147483647 < c) return null;
                    var n = m <= d ? 1 : m >= d + 26 ? 26 : m - d;
                    if (p < n) break;
                    h *= 36 - n;
                    if (2147483647 < h) return null;
                }
                d = Ma(c - g, e.length + 1, !g);
                b += Math.trunc(c / (e.length + 1));
                if (2147483647 < b) return null;
                c %= e.length + 1;
                e.splice(c++, 0, b);
            }
            return e;
        }
        function Ma(a, b, c) {
            a = c ? Math.trunc(a / 700) : a >> 1;
            a += Math.trunc(a / b);
            for(b = 0; 455 < a; b += 36)a = Math.trunc(a / 35);
            return b + Math.trunc(36 * a / (a + 38));
        }
        function Na(a, b, c, d, e) {
            this.j = a;
            this.B = b;
            this.v = c;
            this.h = d;
            this.i = e;
            this.g = null;
            String.prototype.normalize || (this.g = new URL("http://a.com"));
        }
        function Oa(a, b) {
            var c = {
                aa: !0,
                ba: !1,
                O: !0,
                S: !1,
                T: !1,
                N: !1
            };
            a = Pa(a, b, c);
            if (!a) return null;
            for(b = 0; b < a.length; b++){
                var d = a[b], e;
                a: {
                    for(e = 0; e < d.length; e++)if (127 < d[e]) {
                        e = !0;
                        break a;
                    }
                    e = !1;
                }
                if (e) {
                    a: {
                        e = [];
                        for(var f = 128, g = 0, h = 72, m = d.length, p = 0, n = 0; n < m; n++){
                            var k = d[n];
                            127 >= k && (e.push(k), p++);
                        }
                        0 < p && e.push(45);
                        for(n = p; n < m;){
                            k = 1114111;
                            for(var l = 0; l < m; l++){
                                var q = d[l];
                                q >= f && q < k && (k = q);
                            }
                            g += (k - f) * (n + 1);
                            if (2147483647 < g) {
                                d = null;
                                break a;
                            }
                            f = k;
                            for(k = 0; k < m; k++){
                                l = d[k];
                                if (l < f && (g++, 2147483647 < g)) {
                                    d = null;
                                    break a;
                                }
                                if (l === f) {
                                    l = g;
                                    for(q = 36;; q += 36){
                                        var v = q <= h ? 1 : q >= h + 26 ? 26 : q - h;
                                        if (l < v) break;
                                        var I = v + (l - v) % (36 - v);
                                        e.push(26 > I ? 97 + I : 22 + I);
                                        l = Math.trunc((l - v) / (36 - v));
                                    }
                                    e.push(26 > l ? 97 + l : 22 + l);
                                    h = Ma(g, n + 1, n === p);
                                    g = 0;
                                    n++;
                                }
                            }
                            g++;
                            f++;
                        }
                        d = e;
                    }
                    if (!d) return null;
                    d.unshift(120, 110, 45, 45);
                    a[b] = d;
                }
            }
            if (c.N) {
                for(b = 0; b < a.length; b++)if (d = a[b].length, 1 > d && b !== a.length - 1 || 63 < d) return null;
            }
            b = [];
            for(d = 0; d < a.length; d++)b.push(J(a[d]));
            a = b.join(".");
            return c.N && !Qa(a) ? null : a;
        }
        Na.prototype.O = function(a) {
            for(var b = 0; b < a.length; b++){
                var c = a[b];
                if (8205 === c) {
                    if (0 === b || !this.h.g.has(a[b - 1])) return !1;
                } else if (8204 === c && !(0 < b && this.h.g.has(a[b - 1]))) {
                    c = !1;
                    for(var d = b - 1; 0 <= d && !c; d--){
                        var e = xa(this.v, a[d]);
                        if (2 === e || 3 === e) c = !0;
                        else if (5 !== e) break;
                    }
                    if (!c) return !1;
                    c = !1;
                    for(b++; b < a.length && !c; b++)if (d = xa(this.v, a[b]), 1 === d || 3 === d) c = !0;
                    else if (5 !== d) break;
                    if (!c) return !1;
                }
            }
            return !0;
        };
        function Ra(a, b, c) {
            var d = b.length;
            if (!d) return c;
            c = Array(d);
            for(var e = 0; e < d; e++)c[e] = sa(a.i, b[e]);
            if (0 === c[0]) a = !1;
            else if (1 === c[0] || 2 === c[0]) a = !0;
            else return !1;
            if (a) {
                for(a = 0; a < d; a++)switch(c[a]){
                    case 1:
                    case 2:
                    case 6:
                    case 3:
                    case 4:
                    case 7:
                    case 5:
                    case 13:
                    case 9:
                    case 8:
                        break;
                    default:
                        return !1;
                }
                a = !1;
                for(b = d - 1; 0 <= b; b--){
                    e = c[b];
                    if (1 === e || 2 === e || 3 === e || 6 === e) {
                        a = !0;
                        break;
                    }
                    if (8 !== e) break;
                }
                if (!a) return !1;
                b = a = !1;
                for(e = 0; e < d; e++){
                    var f = c[e];
                    3 === f ? a = !0 : 6 === f && (b = !0);
                }
                if (a && b) return !1;
            } else {
                for(a = 0; a < d; a++)switch(c[a]){
                    case 0:
                    case 3:
                    case 4:
                    case 7:
                    case 5:
                    case 13:
                    case 9:
                    case 8:
                        break;
                    default:
                        return !1;
                }
                a = !1;
                for(--d; 0 <= d; d--){
                    b = c[d];
                    if (0 === b || 3 === b) {
                        a = !0;
                        break;
                    }
                    if (8 !== b) break;
                }
                if (!a) return !1;
            }
            return !0;
        }
        function Sa(a, b, c, d, e) {
            if (!c.length) return !0;
            if (!(b = b && b.normalize && b.normalize("NFC") !== b || d.ba && (3 < c.length && 45 === c[2] && 45 === c[3] || 45 === c[0] || 45 === c[c.length - 1]) || c.includes(46))) {
                b = a.B;
                var f = c[0], g = C(b.g, f);
                b = za(b, f, g.M, g.J, g.L, g.K);
            }
            if (b) return !1;
            for(b = 0; b < c.length; b++)if (f = va(a.j, c[b]), e && 1 !== f.type || !e && 1 !== f.type && 4 !== f.type || d.T && f.R) return !1;
            return d.O && !a.O(c) ? !1 : !0;
        }
        function Pa(a, b, c) {
            a: {
                for(var d = c.S, e = c.T, f = [], g = 0; g < b.length; g++){
                    var h = b[g], m = va(a.j, h);
                    if (e && m.R) {
                        b = null;
                        break a;
                    }
                    switch(m.type){
                        case 1:
                            f.push(h);
                            break;
                        case 2:
                            b = null;
                            break a;
                        case 4:
                            d ? m.values && 0 < m.values.length && f.push.apply(f, fa(m.values)) : f.push(h);
                            break;
                        case 5:
                            f.push.apply(f, fa(m.values));
                    }
                }
                b = f;
            }
            if (!b) return null;
            b = J(Ga(b));
            if (a.g && "a.a" !== b) {
                if (a.g.hostname = b, b = a.g.hostname, a.g.hostname = "a.a", "a.a" === b) return null;
            } else b = b.normalize("NFC");
            if (c.N && !Qa(b)) return null;
            d = b.split(".");
            g = !1;
            b = [];
            for(e = 0; e < d.length; e++){
                h = d[e];
                if (c.N && (1 > h.length && e !== d.length - 1 || 63 < h.length)) return null;
                if (h.startsWith("xn--")) {
                    f = La(Ka(h.slice(4)));
                    if (!f) return null;
                    h = J(Ga(f));
                    h = Sa(a, h, f, c, !1);
                } else f = Ka(h), h = Sa(a, null, f, c, c.S);
                if (!h) return null;
                if (!g) a: {
                    for(g = 0; g < f.length; g++)if (h = sa(a.i, f[g]), 1 === h || 2 === h || 6 === h) {
                        g = !0;
                        break a;
                    }
                    g = !1;
                }
                b.push(f);
            }
            if (g && c.aa) {
                for(c = 0; c < b.length; c++)if (!Ra(a, b[c], c === b.length - 1)) return null;
            }
            return b;
        }
        function Qa(a) {
            var b = a.length;
            return 1 <= b && (253 >= b || 46 === a.charCodeAt(b - 1) && 254 >= b);
        }
        function Ta(a, b, c, d, e) {
            for(; d < e; d += c)a.g.add(2 === c ? D(b, d) : ua(b, d));
        }
        var Ua = null;
        function Va() {
            if (!Ua) throw new z("Uts46 instance not set.");
            this.ca = Ua;
            this.j = null;
            this.B = !1;
            this.P = new Uint16Array(0);
            this.v = this.h = this.i = this.I = 0;
            this.g = null;
        }
        var Wa;
        function P() {
            Wa || (Wa = new Va);
            return Wa;
        }
        Va.prototype.parse = function(a, b, c, d) {
            if (1E6 < a.length) return null;
            var e = 0, f = a.length;
            if (c) this.g = c;
            else if (this.g = {
                D: !1,
                H: null,
                m: null,
                A: !1,
                s: !1,
                G: "",
                l: [],
                u: -1,
                o: null,
                C: "",
                F: ""
            }, e < f && (Xa(a.charCodeAt(e)) || Xa(a.charCodeAt(f - 1)))) {
                for(; e < f && Xa(a.charCodeAt(e)); e++);
                for(; f > e && Xa(a.charCodeAt(f - 1)); f--);
            }
            c = new Uint16Array(f - e);
            for(var g = 0; e < f; e++){
                var h = a.charCodeAt(e);
                if (55296 > h || 57343 < h) 9 === h || 10 === h || 13 === h || (c[g++] = h);
                else if (56320 <= h || 1 === f - e) c[g++] = 65533;
                else {
                    var m = a.charCodeAt(e + 1);
                    56320 <= m && 57343 >= m ? (c[g++] = h, c[g++] = m, e++) : c[g++] = 65533;
                }
            }
            this.j = b;
            this.B = !1;
            this.P = c;
            this.I = g;
            this.i = -1;
            this.h = d || 1;
            for(this.v = d; this.i < this.I && 0 !== this.h && !this.B;)switch(this.h){
                case 1:
                    x(Q(this, 1)) ? this.h = 2 : this.v ? this.B = !0 : this.h = 3;
                    break;
                case 2:
                    a = [];
                    do if (this.i++, b = Q(this, 0), 65 <= b && 90 >= b) a.push(b + 32);
                    else if (97 <= b && 122 >= b || y(b) || 43 === b || 45 === b || 46 === b) a.push(b);
                    else if (58 === b) {
                        b = J(a);
                        d = Ya.has(b);
                        e = "file" === b;
                        if (f = this.v) (f = this.g.s && !d || !this.g.s && d) || (f = this.g, f = (!!f.F || !!f.G || -1 !== this.g.u) && e), f = f || this.g.A && !this.g.m;
                        if (f) {
                            this.h = 0;
                            break;
                        }
                        this.g.C = b;
                        this.g.s = d;
                        this.g.A = e;
                        if (this.v) {
                            this.g.u === Za(b) && (this.g.u = -1);
                            this.h = 0;
                            break;
                        }
                        e ? this.h = 14 : d ? this.h = this.j && this.j.C === this.g.C ? 4 : 8 : 47 === Q(this, 1) ? (this.h = 5, this.i++) : (this.g.D = !0, this.g.l.push(""), this.h = 19);
                    } else if (this.v) {
                        this.B = !0;
                        break;
                    } else this.h = 3, this.i = -1;
                    while (2 === this.h);
                    break;
                case 3:
                    a = Q(this, 1);
                    !this.j || this.j.D && 35 !== a ? this.B = !0 : this.j.D && 35 === a ? (this.g.C = this.j.C, this.g.A = this.j.A, this.g.s = this.j.s, this.g.l = this.j.l.slice(), this.g.o = this.j.o, this.g.H = "", this.g.D = !0, this.h = 21, this.i++) : this.h = this.j.A ? 14 : 6;
                    break;
                case 4:
                    47 === Q(this, 1) && 47 === Q(this, 2) ? (this.h = 9, this.i += 2) : this.h = 6;
                    break;
                case 5:
                    47 === Q(this, 1) ? (this.h = 10, this.i++) : this.h = 18;
                    break;
                case 6:
                    this.j ? (this.g.C = this.j.C, this.g.A = this.j.A, this.g.s = this.j.s, this.i++, a = Q(this, 0), b = !0, d = !1, -1 === a ? this.g.o = this.j.o : 47 === a || this.g.s && 92 === a ? (b = !1, this.h = 7) : 63 === a ? (this.g.o = "", this.h = 20) : 35 === a ? (this.g.o = this.j.o, this.g.H = "", this.h = 21) : (d = !0, this.h = 18, this.i--), b && (this.g.F = this.j.F, this.g.G = this.j.G, this.g.m = this.j.m, this.g.u = this.j.u, this.g.l = this.j.l.slice(), d && 0 < this.g.l.length && this.g.l.pop())) : this.B = !0;
                    break;
                case 7:
                    this.i++;
                    a = Q(this, 0);
                    !this.g.s || 47 !== a && 92 !== a ? 47 === a ? this.h = 10 : this.j ? (this.g.F = this.j.F, this.g.G = this.j.G, this.g.m = this.j.m, this.g.u = this.j.u, this.h = 18, this.i--) : this.B = !0 : this.h = 9;
                    break;
                case 8:
                    47 === Q(this, 1) && 47 === Q(this, 2) && (this.i += 2);
                    this.h = 9;
                    break;
                case 9:
                    do a = Q(this, 1), 47 === a || 92 === a ? this.i++ : this.h = 10;
                    while (9 === this.h && this.i < this.I);
                    break;
                case 10:
                    b = a = !1;
                    d = [];
                    do if (this.i++, e = Q(this, 0), 64 === e) {
                        a && d.unshift(37, 52, 48);
                        a = !0;
                        e = O(d);
                        d = [];
                        for(f = 0; f < e.length; f++)c = e[f], 58 !== c || b ? Ja(Ea, c) ? L(d, c) : d.push(c) : (this.g.F += J(d), d = [], b = !0);
                        0 < d.length && (b ? this.g.G += J(d) : this.g.F += J(d), d = []);
                    } else if (-1 === e || 47 === e || 63 === e || 35 === e || 92 === e && this.g.s) {
                        if (a && 0 === d.length) {
                            this.B = !0;
                            break;
                        }
                        this.i -= d.length + 1;
                        this.h = 11;
                    } else d.push(e);
                    while (10 === this.h);
                    break;
                case 11:
                case 12:
                    if (this.v && this.g.A) this.h = 16;
                    else {
                        a = [];
                        b = !1;
                        do if (this.i++, d = Q(this, 0), 58 !== d || b) {
                            if (-1 === d || 47 === d || 63 === d || 35 === d || 92 === d && this.g.s) {
                                this.i--;
                                if (0 === a.length && this.g.s) {
                                    this.B = !0;
                                    break;
                                }
                                (d = this.v && 0 === a.length) && !(d = -1 !== this.g.u) && (d = this.g, d = !!d.F || !!d.G);
                                if (d) {
                                    this.h = 0;
                                    break;
                                }
                                d = $a(this, a, !this.g.s);
                                if (null === d) {
                                    this.B = !0;
                                    break;
                                }
                                this.g.m = d;
                                this.h = 17;
                                this.v && (this.h = 0);
                            } else 91 === d ? b = !0 : 93 === d && (b = !1), a.push(d);
                        } else {
                            if (0 === a.length) {
                                this.B = !0;
                                break;
                            }
                            d = $a(this, a, !this.g.s);
                            if (null === d) {
                                this.B = !0;
                                break;
                            }
                            this.g.m = d;
                            this.h = 13;
                            12 === this.v && (this.h = 0);
                        }
                        while (11 === this.h || 12 === this.h);
                    }
                    break;
                case 13:
                    a = [];
                    do if (this.i++, b = Q(this, 0), y(b)) a.push(b);
                    else if (-1 === b || 47 === b || 63 === b || 35 === b || this.v || 92 === b && this.g.s) {
                        if (0 < a.length) {
                            b = parseInt(J(a), 10);
                            if (isNaN(b) || 65535 < b) {
                                this.B = !0;
                                break;
                            }
                            Za(this.g.C) === b ? this.g.u = -1 : this.g.u = b;
                        }
                        this.v ? this.h = 0 : (this.h = 17, this.i--);
                    } else {
                        this.B = !0;
                        break;
                    }
                    while (13 === this.h);
                    break;
                case 14:
                    this.g.C = "file";
                    this.g.A = !0;
                    this.g.s = !0;
                    this.i++;
                    a = Q(this, 0);
                    if (47 === a || 92 === a) this.h = 15;
                    else if (this.j && this.j.A) {
                        b = !0;
                        d = !1;
                        switch(a){
                            case -1:
                                this.g.o = this.j.o;
                                break;
                            case 63:
                                this.g.o = "";
                                this.h = 20;
                                break;
                            case 35:
                                this.g.o = this.j.o;
                                this.g.H = "";
                                this.h = 21;
                                break;
                            default:
                                ab(this) ? b = !1 : d = !0, this.h = 18, this.i--;
                        }
                        b && (this.g.m = this.j.m, this.g.l = this.j.l.slice(), d && bb(this));
                    } else this.h = 18, this.i--;
                    break;
                case 15:
                    this.i++;
                    a = Q(this, 0);
                    47 === a || 92 === a ? this.h = 16 : (this.j && this.j.A && !ab(this) && (a = this.j.l, 0 < a.length && x(a[0].charCodeAt(0)) && 58 === a[0].charCodeAt(1) ? this.g.l.push(a[0]) : this.g.m = this.j.m), this.h = 18, this.i--);
                    break;
                case 16:
                    a = [];
                    do if (this.i++, b = Q(this, 0), -1 === b || 47 === b || 92 === b || 63 === b || 35 === b) {
                        if (this.i--, !this.v && cb(a)) this.h = 18, db(this, a);
                        else {
                            if (0 === a.length) this.g.m = "";
                            else {
                                b = $a(this, a, !this.g.s);
                                if (null === b) {
                                    this.B = !0;
                                    break;
                                }
                                "localhost" === b && (b = "");
                                this.g.m = b;
                            }
                            if (this.v) {
                                this.h = 0;
                                break;
                            }
                            this.h = 17;
                        }
                    } else a.push(b);
                    while (16 === this.h);
                    break;
                case 17:
                    this.i++;
                    a = Q(this, 0);
                    this.g.s ? (this.h = 18, 47 !== a && 92 !== a && this.i--) : this.v || 63 !== a ? this.v || 35 !== a ? -1 !== a && (this.h = 18, 47 !== a && this.i--) : (this.g.H = "", this.h = 21) : (this.g.o = "", this.h = 20);
                    break;
                case 18:
                    db(this, []);
                    break;
                case 19:
                    a = [];
                    do this.i++, b = Q(this, 0), 63 === b ? (this.g.o = "", this.h = 20) : 35 === b ? (this.g.H = "", this.h = 21) : -1 !== b && a.push(b);
                    while (19 === this.h && this.i < this.I);
                    0 < a.length && (a = eb(a, Ba), this.g.l[0] += J(a));
                    break;
                case 20:
                    a = [];
                    do this.i++, b = Q(this, 0), this.v || 35 !== b ? -1 !== b && a.push(b) : (this.g.H = "", this.h = 21);
                    while (20 === this.h && this.i < this.I);
                    if (0 < a.length) {
                        b = O(a);
                        d = this.g.s;
                        a = [];
                        for(e = 0; e < b.length; e++)f = b[e], 33 > f || 126 < f || 34 === f || 35 === f || 60 === f || 62 === f || 39 === f && d ? L(a, f) : a.push(f);
                        this.g.o = J(a);
                    }
                    break;
                case 21:
                    a = [];
                    do this.i++, b = Q(this, 0), 0 < b && a.push(b);
                    while (21 === this.h && this.i < this.I);
                    a = eb(a, Ca);
                    this.g.H = J(a);
            }
            a = this.B ? null : this.g;
            this.P = this.j = this.g = null;
            return a;
        };
        function Q(a, b) {
            b += a.i;
            return a.I > b ? a.P[b] : -1;
        }
        function db(a, b) {
            var c = a.g.s, d = a.g.A, e = a.g.l;
            do {
                a.i++;
                var f = Q(a, 0);
                if (-1 === f || 47 === f || c && 92 === f || !a.v && (63 === f || 35 === f)) {
                    if (b.length && 46 === b[0] ? fb(b, 1, !1) : fb(b, 0, !0) && fb(b, 3, !1)) bb(a), 47 === f || c && 92 === f || e.push("");
                    else {
                        var g = fb(b, 0, !1);
                        !g || 47 === f || c && 92 === f ? g || (d && 0 === e.length && cb(b) && (a.g.m && (a.g.m = ""), b[1] = 58), b = eb(b, Da), e.push(J(b))) : e.push("");
                    }
                    b = [];
                    if (d && (-1 === f || 63 === f || 35 === f)) for(; 1 < e.length && !e[0];)e.shift();
                    63 === f ? (a.g.o = "", a.h = 20) : 35 === f && (a.g.H = "", a.h = 21);
                } else b.push(f);
            }while (18 === a.h && a.i < a.I);
        }
        function $a(a, b, c) {
            if (91 === b[0]) {
                if (93 !== b[b.length - 1]) return null;
                if (a = gb(b)) {
                    b = "[";
                    for(var d = c = -1, e = 1, f = 0; f < a.length; f++)a[f] ? -1 !== d && (f - d > e && (e = f - d, c = d), d = -1) : -1 === d && (d = f);
                    -1 !== d && 8 - d > e && (c = d);
                    d = !1;
                    for(e = 0; 8 > e; e++){
                        if (d) {
                            if (0 === a[e]) continue;
                            d = !1;
                        }
                        c === e ? (b += 0 === e ? "::" : ":", d = !0) : (b += a[e].toString(16), 7 !== e && (b += ":"));
                    }
                    a = b + "]";
                } else a = null;
                return a;
            }
            if (c) {
                a: {
                    a = O(b);
                    b = [];
                    for(c = 0; c < a.length; c++){
                        d = a[c];
                        if (37 !== d && hb.has(d)) {
                            a = null;
                            break a;
                        }
                        Ja(Ba, d) ? L(b, d) : b.push(d);
                    }
                    a = J(b);
                }
                return a;
            }
            b = O(b);
            b = K(b);
            b = Oa(a.ca, Ka(b));
            if (!b) return null;
            for(a = 0; a < b.length; a++)if (hb.has(b.charCodeAt(a))) return null;
            a = ib(b);
            if (-1 === a) a = null;
            else if (-2 === a) a = b;
            else {
                b = [];
                for(c = 24; 0 <= c; c -= 8)b.push(a >>> c & 255);
                a = b.join(".");
            }
            return a;
        }
        function ib(a) {
            var b = a.split(".");
            1 < b.length && !b[b.length - 1] && b.pop();
            a = b.length;
            if (4 < a) return -2;
            for(var c = [], d = 0; d < a; d++){
                var e = b[d];
                if (!e) return -2;
                var f = NaN;
                "0" === e[0] ? e.startsWith("0x") || e.startsWith("0X") ? f = 2 < e.length ? Number(e) : 0 : 2 <= e.length && /^[0-7]*$/.test(e) ? f = parseInt(e, 8) : 1 === e.length && (f = 0) : /^[0-9]*$/.test(e) && (f = Number(e));
                if (isNaN(f)) return -2;
                c.push(f);
            }
            for(b = 0; b < a - 1; b++)if (255 < c[b]) return -1;
            b = c[a - 1];
            if (b >= Math.pow(256, 5 - a)) return -1;
            for(d = 0; d < a - 1; d++)b += c[d] * Math.pow(256, 3 - d);
            return b;
        }
        function gb(a) {
            var b = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], c = 0, d = -1, e = 1, f = a[e];
            if (58 === f) {
                if (a.length > e + 1 && 58 !== a[e + 1]) return null;
                e += 2;
                f = a[e];
                c++;
                d = c;
            }
            for(; 93 !== f;){
                if (8 === c) return null;
                if (58 === f) {
                    if (-1 !== d) return null;
                    f = a[++e];
                    d = c;
                } else {
                    for(var g = 0, h = 0; 4 > h && na(f);)g = 16 * g + Fa(f), f = a[++e], h++;
                    if (46 === f) {
                        if (0 === h) return null;
                        e -= h;
                        f = a[e];
                        if (6 < c) return null;
                        for(g = 0; 93 !== f;){
                            h = null;
                            if (0 < g) {
                                if (46 === f && 4 > g) f = a[++e];
                                else return null;
                            }
                            if (!y(f)) return null;
                            for(; y(f);){
                                f -= 48;
                                if (null === h) h = f;
                                else {
                                    if (0 === h) return null;
                                    h = 10 * h + f;
                                }
                                if (255 < h) return null;
                                f = a[++e];
                            }
                            b[c] = 256 * b[c] + h;
                            g++;
                            2 !== g && 4 !== g || c++;
                        }
                        if (4 !== g) return null;
                        break;
                    }
                    if (58 === f) {
                        if (f = a[++e], 93 === f) return null;
                    } else if (93 !== f) return null;
                    b[c++] = g;
                }
            }
            if (-1 !== d) for(a = c - d, c = 7; 0 !== c && 0 < a;)e = d + a - 1, f = b[c], b[c] = b[e], b[e] = f, c--, a--;
            else if (8 !== c) return null;
            return b;
        }
        function eb(a, b) {
            a = O(a);
            for(var c = [], d = 0; d < a.length; d++){
                var e = a[d];
                Ja(b, e) ? L(c, e) : c.push(e);
            }
            return c;
        }
        function bb(a) {
            var b = a.g.l;
            a.g.A && 1 === b.length && 2 === b[0].length && x(b[0].charCodeAt(0)) && 58 === b[0].charCodeAt(1) || 0 < b.length && b.pop();
        }
        function ab(a) {
            var b = Q(a, 1), c = Q(a, 2);
            return x(Q(a, 0)) && (58 === b || 124 === b) && (-1 === c || 47 === c || 92 === c || 63 === c || 35 === c);
        }
        var Ya = new Map([
            [
                "ftp",
                21
            ],
            [
                "file",
                0
            ],
            [
                "http",
                80
            ],
            [
                "https",
                443
            ],
            [
                "ws",
                80
            ],
            [
                "wss",
                443
            ]
        ]), hb = new Set([
            0,
            9,
            10,
            13,
            32,
            35,
            37,
            47,
            58,
            63,
            64,
            91,
            92,
            93
        ]);
        function Za(a) {
            return "file" !== a && Ya.has(a) ? Ya.get(a) : -1;
        }
        function Xa(a) {
            return 0 <= a && 32 >= a;
        }
        function fb(a, b, c) {
            var d = a.length - b;
            return (c && 0 < d || !c && 1 === d) && 46 === a[b] || (c && 2 < d || !c && 3 === d) && 37 === a[b] && 50 === a[b + 1] && (101 === a[b + 2] || 69 === a[b + 2]);
        }
        function cb(a) {
            return 2 === a.length && x(a[0]) && 58 === a[1] || 124 === a[1];
        }
        var R = Symbol(), S = Symbol(), jb = Symbol(), T = Symbol();
        function kb(a) {
            a = a.split("&");
            for(var b = [], c = 0; c < a.length; c++){
                for(var d = N(a[c]), e = d, f = 0; f < e.length; f++)43 === e[f] && (e[f] = 32);
                f = d.indexOf(61);
                -1 !== f ? (e = O(d.slice(0, f)), d = O(d.slice(f + 1))) : (e = O(d), d = []);
                b.push([
                    K(e),
                    K(d)
                ]);
            }
            return b;
        }
        function lb(a) {
            for(var b = "", c = 0; c < a.length; c++){
                var d = a[c], e = O(N(d[0]));
                e = mb(e);
                d = O(N(d[1]));
                d = mb(d);
                0 !== c && (b += "&");
                b += e + "=" + d;
            }
            return b;
        }
        function mb(a) {
            for(var b = [], c = 0; c < a.length; c++){
                var d = a[c];
                32 === d ? b.push(43) : 42 === d || 45 === d || 46 === d || y(d) || x(d) || 95 === d ? b.push(d) : L(b, d);
            }
            return J(b);
        }
        var U = Symbol();
        function V(a) {
            a = pa(a) ? nb(a) : a && !pa(a) && "object" === typeof a ? "function" === typeof a[Symbol.iterator] ? nb(Array.from(a)) : nb(Object.entries(a)) : "string" === typeof a && 0 < a.length ? kb("?" === a[0] ? a.slice(1) : a) : [];
            Object.defineProperty(this, T, {
                value: a,
                writable: !0
            });
            Object.defineProperty(this, jb, {
                value: null,
                writable: !0
            });
        }
        V.prototype[Symbol.iterator] = function() {
            return this[T][Symbol.iterator]();
        };
        r = V.prototype;
        r.append = function(a, b) {
            this[T].push([
                M(a),
                M(b)
            ]);
            this[U]();
        };
        r.delete = function(a) {
            a = M(a);
            this[T] = this[T].filter(function(b) {
                return b[0] !== a;
            });
            this[U]();
        };
        r.entries = function() {
            return this[T][Symbol.iterator]();
        };
        r.forEach = function(a, b) {
            for(var c = this[T], d = 0; d < c.length; d++){
                var e = c[0];
                a.call(b, e[1], e[0], this);
            }
        };
        r.get = function(a) {
            a = M(a);
            var b = this[T].find(function(c) {
                return c[0] === a;
            });
            return b ? b[1] : null;
        };
        r.getAll = function(a) {
            a = M(a);
            for(var b = [], c = this[T], d = 0; d < c.length; d++){
                var e = c[d];
                e[0] === a && b.push(e[1]);
            }
            return b;
        };
        r.has = function(a) {
            return null !== this.get(a);
        };
        r.keys = function() {
            return this[T].map(function(a) {
                a = u(a);
                var b = a.next().value;
                a.next();
                return b;
            })[Symbol.iterator]();
        };
        r.set = function(a, b) {
            a = M(a);
            b = M(b);
            var c = this[T], d = c.find(function(e) {
                return e[0] === a;
            });
            d ? d[1] = b : c.push([
                a,
                b
            ]);
            this[U]();
        };
        r.sort = function() {
            this[T].sort(function(a, b) {
                return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
            });
            this[U]();
        };
        r.toString = function() {
            return lb(this[T]);
        };
        r.values = function() {
            return this[T].map(function(a) {
                a = u(a);
                a.next();
                return a.next().value;
            })[Symbol.iterator]();
        };
        V.prototype[U] = function() {
            var a = this[jb];
            if (a) {
                var b = lb(this[T]);
                if (a = a[R]) a.o = b || null;
            }
        };
        t.Object.defineProperties(V.prototype, {
            size: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this[T].length;
                }
            }
        });
        function nb(a) {
            var b = [];
            a = u(a);
            for(var c = a.next(); !c.done; c = a.next()){
                c = c.value;
                if (!pa(c) || 2 !== c.length) throw new TypeError("Failed to construct URLSearchParams: Sequence initializer must only contain pair elements");
                b.push([
                    M(c[0]),
                    M(c[1])
                ]);
            }
            return b;
        }
        function W(a, b) {
            if (!(this instanceof W)) throw new TypeError("Failed to construct URL: Please use the new operator");
            var c = null;
            if ("undefined" !== typeof b) {
                if (b instanceof W) c = b[R];
                else if (c = P().parse("" + b, null, null, 0), !c) throw new TypeError("Failed to construct URL: Invalid base URL");
            }
            a = P().parse("" + a, c, null, 0);
            if (!a) throw new TypeError("Failed to construct URL: Invalid URL");
            Object.defineProperty(this, R, {
                value: a,
                writable: !0
            });
            Object.defineProperty(this, S, {
                value: null,
                writable: !0
            });
        }
        W.canParse = function(a, b) {
            try {
                return new W(a, b), !0;
            } catch (c) {
                return !1;
            }
        };
        W.parse = function(a, b) {
            try {
                return new W(a, b);
            } catch (c) {
                return null;
            }
        };
        W.prototype.toJSON = function() {
            return this.href;
        };
        W.prototype.toString = function() {
            return this.href;
        };
        t.Object.defineProperties(W.prototype, {
            hash: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    var a = this[R].H;
                    return a ? "#" + a : "";
                },
                set: function(a) {
                    var b = this[R];
                    a ? ("#" === a[0] && (a = a.slice(1)), P().parse(a, null, b, 21)) : b.H = null;
                }
            },
            host: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    var a = this[R];
                    return null === a.m ? "" : -1 === a.u ? a.m : a.m + ":" + a.u;
                },
                set: function(a) {
                    var b = this[R];
                    b.D || P().parse(a, null, b, 11);
                }
            },
            hostname: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this[R].m || "";
                },
                set: function(a) {
                    var b = this[R];
                    b.D || P().parse(a, null, b, 12);
                }
            },
            href: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return ob(this[R], !1);
                },
                set: function(a) {
                    a = P().parse(a, null, null, 0);
                    if (!a) throw new TypeError("Failed to set URL.href: Invalid URL");
                    this[R] = a;
                    this[S] = null;
                }
            },
            origin: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return pb(this[R]);
                }
            },
            password: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this[R].G;
                },
                set: function(a) {
                    var b = this[R];
                    !b.m || b.D || b.A || (b.G = qb(a));
                }
            },
            pathname: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    var a = this[R];
                    return a.D ? 0 < a.l.length ? a.l[0] : "" : 0 < a.l.length ? "/" + a.l.join("/") : "";
                },
                set: function(a) {
                    var b = this[R];
                    b.D || (b.l = [], P().parse(a, null, b, 17));
                }
            },
            port: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    var a = this[R].u;
                    return -1 === a ? "" : "" + a;
                },
                set: function(a) {
                    var b = this[R];
                    !b.m || b.D || b.A || (a ? P().parse(a, null, b, 13) : b.u = -1);
                }
            },
            protocol: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this[R].C + ":";
                },
                set: function(a) {
                    P().parse(a + ":", null, this[R], 1);
                }
            },
            search: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    var a = this[R].o;
                    return a ? "?" + a : "";
                },
                set: function(a) {
                    var b = this[R];
                    a ? ("?" === a[0] && (a = a.slice(1)), b.o = "", P().parse(a, null, b, 20), (a = this[S]) && (a[T] = kb(b.o))) : (b.o = null, (b = this[S]) && (b[T] = []));
                }
            },
            searchParams: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    if (!this[S]) {
                        var a = this[R].o;
                        a = a ? kb(a) : [];
                        var b = this[S] = new V;
                        b[T] = a;
                        b[jb] = this;
                    }
                    return this[S];
                }
            },
            username: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this[R].F;
                },
                set: function(a) {
                    var b = this[R];
                    !b.m || b.D || b.A || (b.F = qb(a));
                }
            }
        });
        function ob(a, b) {
            var c = rb(a) + sb(a);
            null !== a.o && (c += "?" + a.o);
            b || null === a.H || (c += "#" + a.H);
            return c;
        }
        function rb(a) {
            var b = a.C + ":";
            if (null !== a.m) {
                b += "//";
                if (a.F || a.G) b += a.F, a.G && (b += ":" + a.G), b += "@";
                b += a.m;
                -1 !== a.u && (b += ":" + a.u);
            } else a.A && (b += "//");
            return b;
        }
        function sb(a) {
            if (a.D && 0 < a.l.length) return a.l[0];
            var b = "";
            a = a.l;
            for(var c = 0; c < a.length; c++)b += "/" + a[c];
            return b;
        }
        function pb(a) {
            switch(a.C){
                case "blob":
                    var b = (a = P().parse(a.l[0], null, null, 0)) ? pb(a) : "null";
                    break;
                case "ftp":
                case "http":
                case "https":
                case "ws":
                case "wss":
                    b = a.C + "://" + a.m;
                    -1 !== a.u && (b += ":" + a.u);
                    break;
                default:
                    b = "null";
            }
            return b;
        }
        function qb(a) {
            a = O(N(a));
            for(var b = [], c = 0; c < a.length; c++){
                var d = a[c];
                Ja(Ea, d) ? L(b, d) : b.push(d);
            }
            return J(b);
        }
        var tb;
        function ub(a) {
            a = X(a);
            var b = Object.create(W.prototype);
            b[R] = {
                D: a.D,
                H: a.H,
                m: a.m,
                A: a.A,
                s: a.s,
                G: a.G,
                l: a.l.slice(),
                u: a.u,
                o: a.o,
                C: a.C,
                F: a.F
            };
            b[S] = null;
            return b;
        }
        function vb(a, b) {
            a = X(a);
            var c = X(b);
            if (c.C !== a.C || c.m !== a.m || c.u !== a.u || a.D || c.D) return !1;
            b = a.l;
            a = c.l;
            if (a.length > b.length) return !1;
            for(c = 0; c < a.length - 1; c++)if (b[c] !== a[c]) return !1;
            return !0;
        }
        function wb(a) {
            if (!(a instanceof W)) throw new TypeError("URLUtils error: url not an instance of Colibrio Url");
            a = a[R];
            tb || (tb = new TextEncoder);
            var b = tb;
            a.l = a.l.map(function(c) {
                var d = "";
                c && (c = b.encode(c), c = K(c), d = encodeURIComponent(c));
                return d;
            });
        }
        function X(a) {
            if (a instanceof W) return a[R];
            a = P().parse(a + "", null, null, 0);
            if (!a) throw new TypeError("Failed to parse URL: Invalid URL");
            return a;
        }
        var xb = [
            "http:",
            "https:",
            "mailto:"
        ];
        var Y = {
            U: w.Base64.decode("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"),
            V: w.Base64.decode("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"),
            W: w.Base64.decode("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"),
            Z: w.Base64.decode("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"),
            $: w.Base64.decode("BgAGAEgATQnNCU0KzQpNC80LTQzNDDsNPA1NDcoNOg66DoQPORA6EBQXNBfSF2AaRBuqG6sb8hvzG38tBqjEqFOpwKn2qu2rPwoBRhABfxABuRABMxEBNBEBwBEBNRIB6hIBTRMBQhQBwhQBvxUBPxYBthYBKxcBORgB4BkBNBoBRxoBmRoBPxwBRB0BRR0Blx0B")
        };
        Ua = new Na(new function(a) {
            this.g = a;
        }(new F(Y.V)), new function(a) {
            this.g = a;
        }(new F(Y.Z)), new function(a) {
            this.g = a;
        }(new F(Y.W)), new function(a) {
            this.g = new Set;
            a = a.g;
            var b = D(a, 4);
            Ta(this, a, 2, D(a, 2), b);
            Ta(this, a, 3, b, a.g.length);
        }(new F(Y.$)), new function(a) {
            this.g = a;
        }(new F(Y.U)));
        api = {
            URLUtils: {
                cloneUrl: ub,
                getOrigin: function(a) {
                    a = X(a);
                    return rb(a);
                },
                getOriginAndPath: function(a) {
                    a = X(a);
                    return rb(a) + sb(a);
                },
                getSanitizedRemoteHref: function(a) {
                    return xb.some(function(b) {
                        return a.protocol === b;
                    }) ? a.href : null;
                },
                getSubpath: function(a, b) {
                    if (vb(a, b)) return a = X(a), b = X(b), a.l.slice(b.l.length - 1).join("/");
                },
                getUrlWithoutHash: function(a) {
                    a = X(a);
                    return ob(a, !0);
                },
                isSubpath: vb,
                isValidUrl: function(a) {
                    return null !== P().parse(a.toString(), null, null, 0);
                },
                normalizePathnameEncoding: function(a) {
                    a = ub(a);
                    wb(a);
                    return a;
                }
            }
        };
        var yb = new ArrayBuffer(8);
        new DataView(yb);
        new Uint8Array(yb);
        var Z = null;
        "function" === typeof URL ? Z = URL : "function" === typeof webkitURL && (Z = webkitURL);
        Z && (W.createObjectURL = Z.createObjectURL, W.revokeObjectURL = Z.revokeObjectURL);
        try {
            var zb = oa();
            zb && (zb.URL = W, zb.URLSearchParams = V);
        } catch (a) {
            console.error("Failed to polyfill URL and URLSearchParams"), console.error(a);
        }
    }).call(__self);
    return api;
});

});


parcelRegister("7kECq", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";





(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("csyWb")), (parcelRequire("acQau")), (parcelRequire("bkFGj")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_locator, __dep__colibrio_core_publication_base, __dep__colibrio_core_selector_base) {
    var api = {};
    (function() {
        var c = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        };
        function d(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var e = a[b];
                if (e && e.Math == Math) return e;
            }
            throw Error("Cannot find global object");
        }
        var f = d(this), g;
        if ("function" == typeof Object.setPrototypeOf) g = Object.setPrototypeOf;
        else {
            var h;
            a: {
                var k = {
                    a: !0
                }, l = {};
                try {
                    l.__proto__ = k;
                    h = l.a;
                    break a;
                } catch (a) {}
                h = !1;
            }
            g = h ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var m = g;
        var n = __dep__colibrio_core_base;
        var p = Array.isArray, q = Function.prototype.call.bind(Object.prototype.hasOwnProperty);
        var r = {
            BEFORE_CONTENT_LOCATION: -1,
            INTERSECTS_CONTENT_LOCATION: 0,
            AFTER_CONTENT_LOCATION: 1
        };
        r[r.BEFORE_CONTENT_LOCATION] = "BEFORE_CONTENT_LOCATION";
        r[r.INTERSECTS_CONTENT_LOCATION] = "INTERSECTS_CONTENT_LOCATION";
        r[r.AFTER_CONTENT_LOCATION] = "AFTER_CONTENT_LOCATION";
        function t(a) {
            if (!a || 1 !== a.nodeType) return null;
            var b = null, e = a.parentNode;
            e && 1 === e.nodeType && (b = t(a.parentNode));
            return {
                attributes: n.NodeDataUtils.createXmlElementAttributeData(a),
                namespaceURI: a.namespaceURI,
                nodeName: a.localName,
                nodeType: 1,
                parent: b,
                prefix: a.prefix
            };
        }
        function u(a, b) {
            return n.ColibrioError.call(this, "colibrio.readingsystem.base", a, b) || this;
        }
        var v = n.ColibrioError;
        u.prototype = c(v.prototype);
        u.prototype.constructor = u;
        if (m) m(u, v);
        else for(var w in v)if ("prototype" != w) {
            if (Object.defineProperties) {
                var x = Object.getOwnPropertyDescriptor(v, w);
                x && Object.defineProperty(u, w, x);
            } else u[w] = v[w];
        }
        function y(a) {
            this.g = a;
        }
        y.prototype.toJSON = function() {
            var a;
            return {
                contentBlocks: null == (a = this.contentBlocks) ? void 0 : a.map(function(b) {
                    return b.toSerializableData();
                }),
                locator: this.contentLocation.toJSON(),
                matchingText: this.matchingText,
                readerDocumentIndexInSpine: this.readerDocumentIndexInSpine,
                textAfter: this.textAfter,
                textBefore: this.textBefore
            };
        };
        f.Object.defineProperties(y.prototype, {
            contentBlocks: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g.contentBlocks;
                }
            },
            contentLocation: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g.contentLocation;
                }
            },
            matchingText: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g.matchingText;
                }
            },
            readerDocumentIndexInSpine: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g.readerDocumentIndexInSpine;
                }
            },
            textAfter: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g.textAfter;
                }
            },
            textBefore: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g.textBefore;
                }
            }
        });
        var z = {
            LINE_BOX: 1,
            ELEMENT: 2
        };
        z[z.LINE_BOX] = "LINE_BOX";
        z[z.ELEMENT] = "ELEMENT";
        api = {
            ContainerContentBlockType: {
                ARTICLE: "ARTICLE",
                ASIDE: "ASIDE",
                BLOCK_QUOTE: "BLOCK_QUOTE",
                DESCRIPTION_LIST: "DESCRIPTION_LIST",
                DESCRIPTION_TERM: "DESCRIPTION_TERM",
                DESCRIPTION_DEFINITION: "DESCRIPTION_DEFINITION",
                FIGURE: "FIGURE",
                GENERIC: "GENERIC",
                ORDERED_LIST: "ORDERED_LIST",
                LIST_ITEM: "LIST_ITEM",
                MATHML: "MATHML",
                MATHML_ERROR: "MATHML_ERROR",
                MATHML_FRACTION: "MATHML_FRACTION",
                MATHML_IDENTIFIER: "MATHML_IDENTIFIER",
                MATHML_MULTISCRIPT: "MATHML_MULTISCRIPT",
                MATHML_NUMERIC: "MATHML_NUMERIC",
                MATHML_OPERATOR: "MATHML_OPERATOR",
                MATHML_OVERSCRIPT: "MATHML_OVERSCRIPT",
                MATHML_PADDED: "MATHML_PADDED",
                MATHML_PHANTOM: "MATHML_PHANTOM",
                MATHML_ROOT: "MATHML_ROOT",
                MATHML_ROW: "MATHML_ROW",
                MATHML_STRING: "MATHML_STRING",
                MATHML_SPACE: "MATHML_SPACE",
                MATHML_SQUARE_ROOT: "MATHML_SQUARE_ROOT",
                MATHML_STYLE: "MATHML_STYLE",
                MATHML_SUBSCRIPT: "MATHML_SUBSCRIPT",
                MATHML_SUB_SUPERSCRIPT: "MATHML_SUBSUP_SCRIPT",
                MATHML_SUPERSCRIPT: "MATHML_SUPERSCRIPT",
                MATHML_TABLE: "MATHML_TABLE",
                MATHML_TABLE_CELL: "MATHML_TABLE_CELL",
                MATHML_TABLE_ROW: "MATHML_TABLE_ROW",
                MATHML_TEXT: "MATHML_TEXT",
                MATHML_UNDERSCRIPT: "MATHML_UNDERSCRIPT",
                MATHML_UNDER_OVERSCRIPT: "MATHML_UNDER_OVERSCRIPT",
                MATHML_SEMANTICS: "MATHML_SEMANTICS",
                PREFORMATTED: "PREFORMATTED",
                SECTION: "SECTION",
                TABLE: "TABLE",
                TABLE_BODY: "TABLE_BODY",
                TABLE_CELL: "TABLE_CELL",
                TABLE_FOOTER: "TABLE_FOOTER",
                TABLE_HEADER: "TABLE_HEADER",
                TABLE_ROW: "TABLE_ROW",
                UNORDERED_LIST: "UNORDERED_LIST"
            },
            ContentBlockClass: {
                CONTAINER: "CONTAINER",
                MEDIA: "MEDIA",
                TEXT: "TEXT"
            },
            ContentBlockMarkType: {
                ANCHOR: "ANCHOR",
                EMPHASIS: "EMPHASIS",
                STRONG: "STRONG"
            },
            ContentBlockMicrodataAttribute: {
                ITEMSCOPE: "itemscope",
                ITEMPROP: "itemprop",
                ITEMID: "itemid",
                ITEMTYPE: "itemtype",
                ITEMREF: "itemref"
            },
            ContentBlockRdfAttribute: {
                VOCAB: "vocab",
                TYPEOF: "typeof",
                PROPERTY: "property"
            },
            ContentBlockTargetAnchorPoint: r,
            ContentBlockTargetFetchMode: {
                INTERSECTING_OR_NEAREST_BEFORE: "INTERSECTING_OR_NEAREST_BEFORE",
                INTERSECTING: "INTERSECTING",
                INTERSECTING_OR_NEAREST_AFTER: "INTERSECTING_OR_NEAREST_AFTER"
            },
            ContentDisplayAreaType: {
                ASPECT_RATIO: "ASPECT_RATIO",
                CALCULATED_FROM_PUBLICATION_CONTENT: "CALCULATED_FROM_PUBLICATION_CONTENT",
                FILL: "FILL"
            },
            ContentPositionTimelineUnit: {
                CHARACTERS: "CHARACTERS",
                DOCUMENTS: "DOCUMENTS",
                PAGES: "PAGES",
                WORDS: "WORDS"
            },
            CustomReaderViewContentLayout: {
                FLEX_CENTER: "FLEX_CENTER",
                BLOCK: "BLOCK"
            },
            EngineEventDataObjectType: {
                ACTIVE_GESTURE_TYPE_CHANGED_ENGINE_EVENT: "ACTIVE_GESTURE_TYPE_CHANGED_ENGINE_EVENT",
                CONTENT_POSITION_TIMELINE_CREATE_PROGRESS_ENGINE_EVENT: "CONTENT_POSITION_TIMELINE_CREATE_PROGRESS_ENGINE_EVENT",
                ENGINE_EVENT: "ENGINE_EVENT",
                KEYBOARD_ENGINE_EVENT: "KEYBOARD_ENGINE_EVENT",
                LICENSE_ENGINE_EVENT: "LICENSE_ENGINE_EVENT",
                MOUSE_ENGINE_EVENT: "MOUSE_ENGINE_EVENT",
                NAVIGATION_ENDED_ENGINE_EVENT: "NAVIGATION_ENDED_ENGINE_EVENT",
                NAVIGATION_INTENT_ENGINE_EVENT: "NAVIGATION_INTENT_ENGINE_EVENT",
                NAVIGATION_STARTED_ENGINE_EVENT: "NAVIGATION_STARTED_ENGINE_EVENT",
                PAGE_PROGRESSION_TIMELINE_RECALCULATING_ENGINE_EVENT: "PAGE_PROGRESSION_TIMELINE_RECALCULATING_ENGINE_EVENT",
                PAGE_PROGRESSION_TIMELINE_ENGINE_EVENT: "PAGE_PROGRESSION_TIMELINE_ENGINE_EVENT",
                POINTER_ENGINE_EVENT: "POINTER_ENGINE_EVENT",
                PUBLICATION_MEDIA_ELEMENT_ENGINE_EVENT: "PUBLICATION_MEDIA_ELEMENT_ENGINE_EVENT",
                PUBLICATION_STORAGE_CHANGED_ENGINE_EVENT: "PUBLICATION_STORAGE_CHANGED_ENGINE_EVENT",
                READER_VIEW_ENGINE_EVENT: "READER_VIEW_ENGINE_EVENT",
                READER_VIEW_TRANSFORM_ENGINE_EVENT: "READER_VIEW_TRANSFORM_ENGINE_EVENT",
                RENDERER_SCROLL_ENGINE_EVENT: "RENDERER_SCROLL_ENGINE_EVENT",
                SELECTION_CHANGED_ENGINE_EVENT: "SELECTION_CHANGED_ENGINE_EVENT",
                SWIPE_NAVIGATION_GESTURE_PROGRESS_ENGINE_EVENT: "SWIPE_NAVIGATION_GESTURE_PROGRESS_ENGINE_EVENT",
                SYNC_MEDIA_ERROR_ENGINE_EVENT: "SYNC_MEDIA_ERROR_ENGINE_EVENT",
                SYNC_MEDIA_ENGINE_EVENT: "SYNC_MEDIA_ENGINE_EVENT",
                SYNC_MEDIA_RANGE_ENGINE_EVENT: "SYNC_MEDIA_RANGE_ENGINE_EVENT",
                SYNC_MEDIA_SEGMENT_ACTIVE_ENGINE_EVENT: "SYNC_MEDIA_SEGMENT_ACTIVE_ENGINE_EVENT",
                SYNC_MEDIA_SEGMENT_DURATION_CHANGED_EVENT: "SYNC_MEDIA_SEGMENT_DURATION_CHANGED_EVENT",
                SYNC_MEDIA_TIMELINE_CREATE_PROGRESS_ENGINE_EVENT: "SYNC_MEDIA_TIMELINE_CREATE_PROGRESS_ENGINE_EVENT",
                SYNC_MEDIA_VIEW_SYNCHRONIZATION_STATE_CHANGED_ENGINE_EVENT: "SYNC_MEDIA_VIEW_SYNCHRONIZATION_STATE_CHANGED_ENGINE_EVENT",
                SYNC_MEDIA_WAITING_ENGINE_EVENT: "SYNC_MEDIA_WAITING_ENGINE_EVENT"
            },
            EngineEventTargetFrameworkComponent: {
                APP_WINDOW: "APP_WINDOW",
                READER_DOCUMENT: "READER_DOCUMENT",
                READER_VIEW: "READER_VIEW",
                READER_VIEW_ANNOTATION: "READER_VIEW_ANNOTATION"
            },
            EngineEventTargetNodeUtils: {
                createEventTargetXmlElementNodeData: t,
                isEventTargetXmlElementNodeData: function(a) {
                    return !!a && 1 === a.nodeType && p(a.attributes) && !q(a, "childNodes");
                }
            },
            EngineEventTargetObjectType: {
                ENGINE_EVENT_TARGET: "ENGINE_EVENT_TARGET",
                SYNC_MEDIA_SEGMENT_TARGET: "SYNC_MEDIA_SEGMENT_TARGET"
            },
            FocusOnReadingPositionTarget: {
                NEAREST_ELEMENT: "NEAREST_ELEMENT",
                NEAREST_CHARACTER: "NEAREST_CHARACTER",
                NEAREST_WORD: "NEAREST_WORD",
                NEAREST_SENTENCE: "NEAREST_SENTENCE",
                NONE: "NONE"
            },
            MediaContentBlockType: {
                AUDIO: "AUDIO",
                IMAGE: "IMAGE",
                VIDEO: "VIDEO"
            },
            NavigationAction: {
                NEXT_CONTENT_RANGE: "NEXT_CONTENT_RANGE",
                PREVIOUS_CONTENT_RANGE: "PREVIOUS_CONTENT_RANGE",
                NEXT_RENDERABLE_PAGE: "NEXT_RENDERABLE_PAGE",
                PREVIOUS_RENDERABLE_PAGE: "PREVIOUS_RENDERABLE_PAGE",
                CURRENT: "CURRENT",
                GOTO: "GOTO"
            },
            NavigationCollectionType: {
                TOC: "TOC",
                PAGE_LIST: "PAGE_LIST",
                LANDMARKS: "LANDMARKS",
                CUSTOM: "CUSTOM",
                LIST_OF_AUDIO_CLIPS: "LIST_OF_AUDIO_CLIPS",
                LIST_OF_ILLUSTRATIONS: "LIST_OF_ILLUSTRATIONS",
                LIST_OF_TABLES: "LIST_OF_TABLES",
                LIST_OF_VIDEO_CLIPS: "LIST_OF_VIDEO_CLIPS"
            },
            PageFlowDirection: {
                TB: "TB",
                LR: "LR",
                RL: "RL"
            },
            PageProgressionTimelineType: {
                FIXED_PAGES: "FIXED_PAGES",
                ESTIMATED_PAGES: "ESTIMATED_PAGES",
                RENDERED_PAGES: "RENDERED_PAGES"
            },
            ReaderDocumentEventState: {
                NOT_PROCESSED: "NOT_PROCESSED",
                PROCESSED: "PROCESSED",
                DEFAULT_PREVENTED: "DEFAULT_PREVENTED"
            },
            ReaderPublicationStorageAreaType: {
                LOCAL_STORAGE: "LOCAL_STORAGE",
                SESSION_STORAGE: "SESSION_STORAGE"
            },
            ReaderViewGestureType: {
                PAN_ZOOM: "PAN_ZOOM",
                SWIPE_NAVIGATION: "SWIPE_NAVIGATION"
            },
            ReaderViewPageProgressionDirection: {
                LTR: "LTR",
                RTL: "RTL"
            },
            ReadingSystemError: u,
            ReadingSystemErrorType: {
                CONTENT_BLOCK_WALKER_ALREADY_AT_END: "CONTENT_BLOCK_WALKER_ALREADY_AT_END"
            },
            RenderableState: {
                DESTROYED: "DESTROYED",
                CREATED: "CREATED",
                ATTACHED_TO_DOM: "ATTACHED_TO_DOM",
                VISIBLE: "VISIBLE"
            },
            RendererSpreadMode: {
                SINGLE_PAGE: "SINGLE_PAGE",
                TWO_PAGES: "TWO_PAGES",
                MIXED: "MIXED"
            },
            SearchResultItem: y,
            SyncMediaFormat: {
                CONTENT_BLOCK_TTS: "CONTENT_BLOCK_TTS",
                EPUB_MEDIA_OVERLAY: "EPUB_MEDIA_OVERLAY",
                WP_AUDIOBOOK: "WP_AUDIOBOOK"
            },
            SyncMediaObjectRefType: {
                AUDIO: "AUDIO",
                EPUB_MEDIA_OVERLAY_TEXT: "MO_TEXT",
                TTS_CONTENT_BLOCK: "TTS_CONTENT_BLOCK"
            },
            SyncMediaPlayerErrorType: {
                AUDIO_PLAYER_DESTROYED: "AUDIO_PLAYER_DESTROYED",
                MEDIA_NOT_SUPPORTED: "MEDIA_NOT_SUPPORTED",
                PLAYBACK_NOT_ALLOWED: "PLAYBACK_NOT_ALLOWED",
                MEDIA_LOAD_ERROR: "MEDIA_LOAD_ERROR",
                UNKNOWN_ERROR: "UNKNOWN_ERROR"
            },
            SyncMediaPositionRelativeToVisibleRange: {
                VISIBLE: "VISIBLE",
                NEXT: "NEXT",
                PREVIOUS: "PREVIOUS",
                AFTER_NEXT: "AFTER_NEXT",
                BEFORE_PREVIOUS: "BEFORE_PREVIOUS",
                NO_MATCHING_DOCUMENT: "NO_MATCHING_DOCUMENT"
            },
            SyncMediaRangePlaybackRemoveReason: {
                SEEK: "SEEK",
                RANGE_REPLACED: "RANGE_REPLACED",
                READER_VIEW_SYNC: "READER_VIEW_SYNC",
                APP_GENERATED: "APP_GENERATED",
                END_REACHED: "END_REACHED"
            },
            SyncMediaRangeSeekBehavior: {
                ALWAYS_REMOVE_RANGE: "ALWAYS_REMOVE_RANGE",
                REMOVE_IF_OUTSIDE_RANGE: "REMOVE_IF_OUTSIDE_RANGE",
                CLAMP_TO_RANGE: "CLAMP_TO_RANGE"
            },
            SyncMediaReaderViewSynchronizationMethod: {
                READER_VIEW_GOTO: "READER_VIEW_GOTO",
                READER_VIEW_NEXT: "READER_VIEW_NEXT",
                READER_VIEW_PREVIOUS: "READER_VIEW_PREVIOUS",
                SYNC_MEDIA_SEEK: "SYNC_MEDIA_SEEK"
            },
            SyncMediaReaderViewSynchronizationWaitBehavior: {
                WAIT_OUTSIDE_ADJACENT: "WAIT_OUTSIDE_ADJACENT",
                WAIT_OUTSIDE_VISIBLE: "WAIT_OUTSIDE_VISIBLE",
                DONT_WAIT: "DONT_WAIT"
            },
            SyncMediaSegmentDurationType: {
                FIXED: "FIXED",
                UNKNOWN: "UNKNOWN"
            },
            SyncMediaSyncEventTrigger: {
                READER_VIEW_SCROLL: "READER_VIEW_SCROLL",
                READER_VIEW_NAVIGATION: "READER_VIEW_NAVIGATION",
                SYNC_MEDIA_SEEK: "SYNC_MEDIA_SEEK",
                SYNC_MEDIA_PLAYBACK: "SYNC_MEDIA_PLAYBACK"
            },
            TextAlignment: {
                CENTER: "center",
                JUSTIFY: "justify",
                LEFT: "left",
                RIGHT: "right"
            },
            TextContentBlockType: {
                HEADING1: "HEADING1",
                HEADING2: "HEADING2",
                HEADING3: "HEADING3",
                HEADING4: "HEADING4",
                HEADING5: "HEADING5",
                HEADING6: "HEADING6",
                PARAGRAPH: "PARAGRAPH",
                TEXT: "TEXT"
            },
            TextSearchQueryWhitespaceMode: {
                COLLAPSE: "COLLAPSE",
                IGNORE: "IGNORE"
            },
            TextSearchResultExpandMode: {
                NO_EXPAND: "NO_EXPAND",
                EXPAND_TO_WORD_BOUNDARY: "EXPAND_TO_WORD_BOUNDARY",
                EXPAND_TO_CONTENT_BLOCK_BOUNDARY: "EXPAND_TO_CONTENT_BLOCK_BOUNDARY"
            },
            TransformEasing: {
                EASE: "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
                EASE_IN: "cubic-bezier(0.42, 0.0, 1.0, 1.0)",
                EASE_IN_OUT: "cubic-bezier(0.42, 0.0, 0.58, 1.0)",
                EASE_OUT: "cubic-bezier(0.0, 0.0, 0.58, 1.0)",
                MATERIAL_STANDARD_CURVE: "cubic-bezier(0.4, 0.0, 0.2, 1)",
                MATERIAL_DECELERATION_CURVE: "cubic-bezier(0.0, 0.0, 0.2, 1)",
                MATERIAL_ACCELERATION_CURVE: "cubic-bezier(0.4, 0.0, 1, 1)"
            },
            VisibleContentRectType: z
        };
    }).call(__self);
    return api;
});

});
parcelRegister("acQau", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";


(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base) {
    var api = {};
    (function() {
        api = {
            ContentDocumentFlowMode: {
                PAGINATED: "PAGINATED",
                SCROLLED_CONTINUOUS: "SCROLLED_CONTINUOUS",
                SCROLLED_DOC: "SCROLLED_DOC",
                AUTO: "AUTO"
            },
            ContentDocumentLayout: {
                REFLOWABLE: "REFLOWABLE",
                PRE_PAGINATED: "PRE_PAGINATED"
            },
            PageProgressionDirection: {
                LTR: "LTR",
                RTL: "RTL",
                AUTO: "AUTO"
            },
            PageSpreadSlot: {
                LEFT: "LEFT",
                RIGHT: "RIGHT",
                CENTER: "CENTER",
                AUTO: "AUTO"
            },
            PublicationMetadataType: {
                EPUB_PUBLICATION_METADATA: "EPUB_PUBLICATION_METADATA",
                PUBLICATION_METADATA: "PUBLICATION_METADATA",
                PDF_PUBLICATION_METADATA: "PDF_PUBLICATION_METADATA",
                WP_PUBLICATION_METADATA: "WP_PUBLICATION_METADATA"
            },
            PublicationOrientation: {
                LANDSCAPE: "LANDSCAPE",
                PORTRAIT: "PORTRAIT",
                AUTO: "AUTO"
            },
            PublicationType: {
                EPUB: "EPUB",
                PDF: "PDF",
                WP: "WP"
            },
            SyntheticSpreadBehavior: {
                NONE: "NONE",
                LANDSCAPE: "LANDSCAPE",
                BOTH: "BOTH",
                AUTO: "AUTO"
            }
        };
    }).call(__self);
    return api;
});

});


parcelRegister("9eVOO", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";










(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("cLeaP")), (parcelRequire("loFPd")), (parcelRequire("7uZag")), (parcelRequire("hrxPB")), (parcelRequire("csyWb")), (parcelRequire("acQau")), (parcelRequire("bkFGj")), (parcelRequire("a75zb")), (parcelRequire("7kECq")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_encryption, __dep__colibrio_core_io_base, __dep__colibrio_core_io_mediatypedetector, __dep__colibrio_core_io_resourcecache, __dep__colibrio_core_locator, __dep__colibrio_core_publication_base, __dep__colibrio_core_selector_base, __dep__colibrio_core_url, __dep__colibrio_readingsystem_base) {
    var __lib__bezier_easing = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        (function(g) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = g() : "function" === typeof define && define.amd ? define([], g) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = g();
        })(function() {
            return (function() {
                function g(l, h, r) {
                    function t(a, d) {
                        if (!h[a]) {
                            if (!l[a]) {
                                var m = undefined;
                                if (!d && m) return m(a, !0);
                                if (c) return c(a, !0);
                                d = Error("Cannot find module '" + a + "'");
                                throw d.code = "MODULE_NOT_FOUND", d;
                            }
                            d = h[a] = {
                                exports: {}
                            };
                            l[a][0].call(d.exports, function(p) {
                                return t(l[a][1][p] || p);
                            }, d, d.exports, g, l, h, r);
                        }
                        return h[a].exports;
                    }
                    for(var c = undefined, e = 0; e < r.length; e++)t(r[e]);
                    return t;
                }
                return g;
            })()({
                1: [
                    function(g, l) {
                        function h(c, e, a) {
                            return (((1 - 3 * a + 3 * e) * c + (3 * a - 6 * e)) * c + 3 * e) * c;
                        }
                        function r(c) {
                            return c;
                        }
                        var t = "function" === typeof Float32Array;
                        l.exports = function(c, e, a, d) {
                            if (!(0 <= c && 1 >= c && 0 <= a && 1 >= a)) throw Error("bezier x values must be in [0, 1] range");
                            if (c === e && a === d) return r;
                            for(var m = t ? new Float32Array(11) : Array(11), p = 0; 11 > p; ++p)m[p] = h(.1 * p, c, a);
                            return function(f) {
                                if (0 === f) return 0;
                                if (1 === f) return 1;
                                for(var k = 0, b = 1; 10 !== b && m[b] <= f; ++b)k += .1;
                                --b;
                                b = k + (f - m[b]) / (m[b + 1] - m[b]) * .1;
                                var n = 3 * (1 - 3 * a + 3 * c) * b * b + 2 * (3 * a - 6 * c) * b + 3 * c;
                                if (.001 <= n) {
                                    for(k = 0; 4 > k; ++k){
                                        n = 3 * (1 - 3 * a + 3 * c) * b * b + 2 * (3 * a - 6 * c) * b + 3 * c;
                                        if (0 === n) break;
                                        var q = h(b, c, a) - f;
                                        b -= q / n;
                                    }
                                    f = b;
                                } else if (0 === n) f = b;
                                else {
                                    b = k;
                                    k += .1;
                                    var u = 0;
                                    do q = b + (k - b) / 2, n = h(q, c, a) - f, 0 < n ? k = q : b = q;
                                    while (1E-7 < Math.abs(n) && 10 > ++u);
                                    f = q;
                                }
                                return h(f, e, d);
                            };
                        };
                    },
                    {}
                ],
                2: [
                    function(g, l) {
                        l.exports = g("bezier-easing");
                    },
                    {
                        "bezier-easing": 1
                    }
                ]
            }, {}, [
                2
            ])(2);
        });
        return module1.exports;
    }();
    var __lib__sjcl = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        (function(u) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = u() : "function" === typeof define && define.amd ? define([], u) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = u();
        })(function() {
            return (function() {
                function u(r, h, a) {
                    function b(e, f) {
                        if (!h[e]) {
                            if (!r[e]) {
                                var k = undefined;
                                if (!f && k) return k(e, !0);
                                if (c) return c(e, !0);
                                f = Error("Cannot find module '" + e + "'");
                                throw f.code = "MODULE_NOT_FOUND", f;
                            }
                            f = h[e] = {
                                exports: {}
                            };
                            r[e][0].call(f.exports, function(g) {
                                return b(r[e][1][g] || g);
                            }, f, f.exports, u, r, h, a);
                        }
                        return h[e].exports;
                    }
                    for(var c = undefined, d = 0; d < a.length; d++)b(a[d]);
                    return b;
                }
                return u;
            })()({
                1: [
                    function(u, r) {
                        var h = {
                            cipher: {},
                            hash: {},
                            keyexchange: {},
                            mode: {},
                            misc: {},
                            codec: {},
                            exception: {
                                corrupt: function(a) {
                                    this.toString = function() {
                                        return "CORRUPT: " + this.message;
                                    };
                                    this.message = a;
                                },
                                invalid: function(a) {
                                    this.toString = function() {
                                        return "INVALID: " + this.message;
                                    };
                                    this.message = a;
                                },
                                bug: function(a) {
                                    this.toString = function() {
                                        return "BUG: " + this.message;
                                    };
                                    this.message = a;
                                },
                                notReady: function(a) {
                                    this.toString = function() {
                                        return "NOT READY: " + this.message;
                                    };
                                    this.message = a;
                                }
                            }
                        };
                        h.cipher.aes = function(a) {
                            this._tables[0][0][0] || this._precompute();
                            var b, c, d = this._tables[0][4], e = this._tables[1];
                            var f = a.length;
                            var k = 1;
                            if (4 !== f && 6 !== f && 8 !== f) throw new h.exception.invalid("invalid aes key size");
                            this._key = [
                                b = a.slice(0),
                                c = []
                            ];
                            for(a = f; a < 4 * f + 28; a++){
                                var g = b[a - 1];
                                if (0 === a % f || 8 === f && 4 === a % f) g = d[g >>> 24] << 24 ^ d[g >> 16 & 255] << 16 ^ d[g >> 8 & 255] << 8 ^ d[g & 255], 0 === a % f && (g = g << 8 ^ g >>> 24 ^ k << 24, k = k << 1 ^ 283 * (k >> 7));
                                b[a] = b[a - f] ^ g;
                            }
                            for(f = 0; a; f++, a--)g = b[f & 3 ? a : a - 4], c[f] = 4 >= a || 4 > f ? g : e[0][d[g >>> 24]] ^ e[1][d[g >> 16 & 255]] ^ e[2][d[g >> 8 & 255]] ^ e[3][d[g & 255]];
                        };
                        h.cipher.aes.prototype = {
                            encrypt: function(a) {
                                return this._crypt(a, 0);
                            },
                            decrypt: function(a) {
                                return this._crypt(a, 1);
                            },
                            _tables: [
                                [
                                    [],
                                    [],
                                    [],
                                    [],
                                    []
                                ],
                                [
                                    [],
                                    [],
                                    [],
                                    [],
                                    []
                                ]
                            ],
                            _precompute: function() {
                                var a = this._tables[0], b = this._tables[1], c = a[4], d = b[4], e, f, k, g = [], l = [], n;
                                for(e = 0; 256 > e; e++)l[(g[e] = e << 1 ^ 283 * (e >> 7)) ^ e] = e;
                                for(f = k = 0; !c[f]; f ^= n || 1, k = l[k] || 1){
                                    var m = k ^ k << 1 ^ k << 2 ^ k << 3 ^ k << 4;
                                    m = m >> 8 ^ m & 255 ^ 99;
                                    c[f] = m;
                                    d[m] = f;
                                    var q = g[e = g[n = g[f]]];
                                    var p = 16843009 * q ^ 65537 * e ^ 257 * n ^ 16843008 * f;
                                    q = 257 * g[m] ^ 16843008 * m;
                                    for(e = 0; 4 > e; e++)a[e][f] = q = q << 24 ^ q >>> 8, b[e][m] = p = p << 24 ^ p >>> 8;
                                }
                                for(e = 0; 5 > e; e++)a[e] = a[e].slice(0), b[e] = b[e].slice(0);
                            },
                            _crypt: function(a, b) {
                                if (4 !== a.length) throw new h.exception.invalid("invalid aes block size");
                                var c = this._key[b], d = a[0] ^ c[0], e = a[b ? 3 : 1] ^ c[1], f = a[2] ^ c[2];
                                a = a[b ? 1 : 3] ^ c[3];
                                var k = c.length / 4 - 2, g, l = 4, n = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                var m = this._tables[b];
                                var q = m[0], p = m[1], t = m[2], v = m[3], w = m[4];
                                for(g = 0; g < k; g++){
                                    m = q[d >>> 24] ^ p[e >> 16 & 255] ^ t[f >> 8 & 255] ^ v[a & 255] ^ c[l];
                                    var x = q[e >>> 24] ^ p[f >> 16 & 255] ^ t[a >> 8 & 255] ^ v[d & 255] ^ c[l + 1];
                                    var y = q[f >>> 24] ^ p[a >> 16 & 255] ^ t[d >> 8 & 255] ^ v[e & 255] ^ c[l + 2];
                                    a = q[a >>> 24] ^ p[d >> 16 & 255] ^ t[e >> 8 & 255] ^ v[f & 255] ^ c[l + 3];
                                    l += 4;
                                    d = m;
                                    e = x;
                                    f = y;
                                }
                                for(g = 0; 4 > g; g++)n[b ? 3 & -g : g] = w[d >>> 24] << 24 ^ w[e >> 16 & 255] << 16 ^ w[f >> 8 & 255] << 8 ^ w[a & 255] ^ c[l++], m = d, d = e, e = f, f = a, a = m;
                                return n;
                            }
                        };
                        h.bitArray = {
                            bitSlice: function(a, b, c) {
                                a = h.bitArray._shiftRight(a.slice(b / 32), 32 - (b & 31)).slice(1);
                                return void 0 === c ? a : h.bitArray.clamp(a, c - b);
                            },
                            extract: function(a, b, c) {
                                var d = Math.floor(-b - c & 31);
                                return ((b + c - 1 ^ b) & -32 ? a[b / 32 | 0] << 32 - d ^ a[b / 32 + 1 | 0] >>> d : a[b / 32 | 0] >>> d) & (1 << c) - 1;
                            },
                            concat: function(a, b) {
                                if (0 === a.length || 0 === b.length) return a.concat(b);
                                var c = a[a.length - 1], d = h.bitArray.getPartial(c);
                                return 32 === d ? a.concat(b) : h.bitArray._shiftRight(b, d, c | 0, a.slice(0, a.length - 1));
                            },
                            bitLength: function(a) {
                                var b = a.length;
                                return 0 === b ? 0 : 32 * (b - 1) + h.bitArray.getPartial(a[b - 1]);
                            },
                            clamp: function(a, b) {
                                if (32 * a.length < b) return a;
                                a = a.slice(0, Math.ceil(b / 32));
                                var c = a.length;
                                b &= 31;
                                0 < c && b && (a[c - 1] = h.bitArray.partial(b, a[c - 1] & 2147483648 >> b - 1, 1));
                                return a;
                            },
                            partial: function(a, b, c) {
                                return 32 === a ? b : (c ? b | 0 : b << 32 - a) + 1099511627776 * a;
                            },
                            getPartial: function(a) {
                                return Math.round(a / 1099511627776) || 32;
                            },
                            equal: function(a, b) {
                                if (h.bitArray.bitLength(a) !== h.bitArray.bitLength(b)) return !1;
                                var c = 0, d;
                                for(d = 0; d < a.length; d++)c |= a[d] ^ b[d];
                                return 0 === c;
                            },
                            _shiftRight: function(a, b, c, d) {
                                var e;
                                for(void 0 === d && (d = []); 32 <= b; b -= 32)d.push(c), c = 0;
                                if (0 === b) return d.concat(a);
                                for(e = 0; e < a.length; e++)d.push(c | a[e] >>> b), c = a[e] << 32 - b;
                                a = h.bitArray.getPartial(a.length ? a[a.length - 1] : 0);
                                d.push(h.bitArray.partial(b + a & 31, 32 < b + a ? c : d.pop(), 1));
                                return d;
                            },
                            _xor4: function(a, b) {
                                return [
                                    a[0] ^ b[0],
                                    a[1] ^ b[1],
                                    a[2] ^ b[2],
                                    a[3] ^ b[3]
                                ];
                            },
                            byteswapM: function(a) {
                                var b;
                                for(b = 0; b < a.length; ++b){
                                    var c = a[b];
                                    a[b] = c >>> 24 | c >>> 8 & 65280 | (c & 65280) << 8 | c << 24;
                                }
                                return a;
                            }
                        };
                        h.codec.utf8String = {
                            fromBits: function(a) {
                                var b = "", c = h.bitArray.bitLength(a), d, e;
                                for(d = 0; d < c / 8; d++)0 === (d & 3) && (e = a[d / 4]), b += String.fromCharCode(e >>> 8 >>> 8 >>> 8), e <<= 8;
                                return decodeURIComponent(escape(b));
                            },
                            toBits: function(a) {
                                a = unescape(encodeURIComponent(a));
                                var b = [], c, d = 0;
                                for(c = 0; c < a.length; c++)d = d << 8 | a.charCodeAt(c), 3 === (c & 3) && (b.push(d), d = 0);
                                c & 3 && b.push(h.bitArray.partial(8 * (c & 3), d));
                                return b;
                            }
                        };
                        h.hash.sha256 = function(a) {
                            this._key[0] || this._precompute();
                            a ? (this._h = a._h.slice(0), this._buffer = a._buffer.slice(0), this._length = a._length) : this.reset();
                        };
                        h.hash.sha256.hash = function(a) {
                            return (new h.hash.sha256).update(a).finalize();
                        };
                        h.hash.sha256.prototype = {
                            blockSize: 512,
                            reset: function() {
                                this._h = this._init.slice(0);
                                this._buffer = [];
                                this._length = 0;
                                return this;
                            },
                            update: function(a) {
                                "string" === typeof a && (a = h.codec.utf8String.toBits(a));
                                var b = this._buffer = h.bitArray.concat(this._buffer, a);
                                var c = this._length;
                                a = this._length = c + h.bitArray.bitLength(a);
                                if (9007199254740991 < a) throw new h.exception.invalid("Cannot hash more than 2^53 - 1 bits");
                                if ("undefined" !== typeof Uint32Array) {
                                    var d = new Uint32Array(b), e = 0;
                                    for(c = 512 + c - (512 + c & 511); c <= a; c += 512)this._block(d.subarray(16 * e, 16 * (e + 1))), e += 1;
                                    b.splice(0, 16 * e);
                                } else for(c = 512 + c - (512 + c & 511); c <= a; c += 512)this._block(b.splice(0, 16));
                                return this;
                            },
                            finalize: function() {
                                var a, b = this._buffer, c = this._h;
                                b = h.bitArray.concat(b, [
                                    h.bitArray.partial(1, 1)
                                ]);
                                for(a = b.length + 2; a & 15; a++)b.push(0);
                                b.push(Math.floor(this._length / 4294967296));
                                for(b.push(this._length | 0); b.length;)this._block(b.splice(0, 16));
                                this.reset();
                                return c;
                            },
                            _init: [],
                            _key: [],
                            _precompute: function() {
                                function a(f) {
                                    return 4294967296 * (f - Math.floor(f)) | 0;
                                }
                                for(var b = 0, c = 2, d, e; 64 > b; c++){
                                    e = !0;
                                    for(d = 2; d * d <= c; d++)if (0 === c % d) {
                                        e = !1;
                                        break;
                                    }
                                    e && (8 > b && (this._init[b] = a(Math.pow(c, .5))), this._key[b] = a(Math.pow(c, 1 / 3)), b++);
                                }
                            },
                            _block: function(a) {
                                var b, c = this._h, d = this._key, e = c[0], f = c[1], k = c[2], g = c[3], l = c[4], n = c[5], m = c[6], q = c[7];
                                for(b = 0; 64 > b; b++){
                                    if (16 > b) var p = a[b];
                                    else {
                                        p = a[b + 1 & 15];
                                        var t = a[b + 14 & 15];
                                        p = a[b & 15] = (p >>> 7 ^ p >>> 18 ^ p >>> 3 ^ p << 25 ^ p << 14) + (t >>> 17 ^ t >>> 19 ^ t >>> 10 ^ t << 15 ^ t << 13) + a[b & 15] + a[b + 9 & 15] | 0;
                                    }
                                    p = p + q + (l >>> 6 ^ l >>> 11 ^ l >>> 25 ^ l << 26 ^ l << 21 ^ l << 7) + (m ^ l & (n ^ m)) + d[b];
                                    q = m;
                                    m = n;
                                    n = l;
                                    l = g + p | 0;
                                    g = k;
                                    k = f;
                                    f = e;
                                    e = p + (f & k ^ g & (f ^ k)) + (f >>> 2 ^ f >>> 13 ^ f >>> 22 ^ f << 30 ^ f << 19 ^ f << 10) | 0;
                                }
                                c[0] = c[0] + e | 0;
                                c[1] = c[1] + f | 0;
                                c[2] = c[2] + k | 0;
                                c[3] = c[3] + g | 0;
                                c[4] = c[4] + l | 0;
                                c[5] = c[5] + n | 0;
                                c[6] = c[6] + m | 0;
                                c[7] = c[7] + q | 0;
                            }
                        };
                        h.mode.ccm = {
                            name: "ccm",
                            _progressListeners: [],
                            listenProgress: function(a) {
                                h.mode.ccm._progressListeners.push(a);
                            },
                            unListenProgress: function(a) {
                                a = h.mode.ccm._progressListeners.indexOf(a);
                                -1 < a && h.mode.ccm._progressListeners.splice(a, 1);
                            },
                            _callProgressListener: function(a) {
                                var b = h.mode.ccm._progressListeners.slice(), c;
                                for(c = 0; c < b.length; c += 1)b[c](a);
                            },
                            encrypt: function(a, b, c, d, e) {
                                var f, k = b.slice(0), g = h.bitArray, l = g.bitLength(c) / 8, n = g.bitLength(k) / 8;
                                e = e || 64;
                                d = d || [];
                                if (7 > l) throw new h.exception.invalid("ccm: iv must be at least 7 bytes");
                                for(f = 2; 4 > f && n >>> 8 * f; f++);
                                f < 15 - l && (f = 15 - l);
                                c = g.clamp(c, 8 * (15 - f));
                                b = h.mode.ccm._computeTag(a, b, c, d, e, f);
                                k = h.mode.ccm._ctrMode(a, k, c, b, e, f);
                                return g.concat(k.data, k.tag);
                            },
                            decrypt: function(a, b, c, d, e) {
                                e = e || 64;
                                d = d || [];
                                var f = h.bitArray, k = f.bitLength(c) / 8, g = f.bitLength(b), l = f.clamp(b, g - e), n = f.bitSlice(b, g - e);
                                g = (g - e) / 8;
                                if (7 > k) throw new h.exception.invalid("ccm: iv must be at least 7 bytes");
                                for(b = 2; 4 > b && g >>> 8 * b; b++);
                                b < 15 - k && (b = 15 - k);
                                c = f.clamp(c, 8 * (15 - b));
                                l = h.mode.ccm._ctrMode(a, l, c, n, e, b);
                                a = h.mode.ccm._computeTag(a, l.data, c, d, e, b);
                                if (!f.equal(l.tag, a)) throw new h.exception.corrupt("ccm: tag doesn't match");
                                return l.data;
                            },
                            _macAdditionalData: function(a, b, c, d, e, f) {
                                var k = [], g = h.bitArray, l = g._xor4;
                                d = [
                                    g.partial(8, (b.length ? 64 : 0) | d - 2 << 2 | f - 1)
                                ];
                                d = g.concat(d, c);
                                d[3] |= e;
                                d = a.encrypt(d);
                                if (b.length) for(c = g.bitLength(b) / 8, 65279 >= c ? k = [
                                    g.partial(16, c)
                                ] : 4294967295 >= c && (k = g.concat([
                                    g.partial(16, 65534)
                                ], [
                                    c
                                ])), k = g.concat(k, b), b = 0; b < k.length; b += 4)d = a.encrypt(l(d, k.slice(b, b + 4).concat([
                                    0,
                                    0,
                                    0
                                ])));
                                return d;
                            },
                            _computeTag: function(a, b, c, d, e, f) {
                                var k = h.bitArray, g = k._xor4;
                                e /= 8;
                                if (e % 2 || 4 > e || 16 < e) throw new h.exception.invalid("ccm: invalid tag length");
                                if (4294967295 < d.length || 4294967295 < b.length) throw new h.exception.bug("ccm: can't deal with 4GiB or more data");
                                c = h.mode.ccm._macAdditionalData(a, d, c, e, k.bitLength(b) / 8, f);
                                for(d = 0; d < b.length; d += 4)c = a.encrypt(g(c, b.slice(d, d + 4).concat([
                                    0,
                                    0,
                                    0
                                ])));
                                return k.clamp(c, 8 * e);
                            },
                            _ctrMode: function(a, b, c, d, e, f) {
                                var k = h.bitArray;
                                var g = k._xor4;
                                var l = b.length, n = k.bitLength(b), m = l / 50, q = m;
                                c = k.concat([
                                    k.partial(8, f - 1)
                                ], c).concat([
                                    0,
                                    0,
                                    0
                                ]).slice(0, 4);
                                d = k.bitSlice(g(d, a.encrypt(c)), 0, e);
                                if (!l) return {
                                    tag: d,
                                    data: []
                                };
                                for(g = 0; g < l; g += 4)g > m && (h.mode.ccm._callProgressListener(g / l), m += q), c[3]++, e = a.encrypt(c), b[g] ^= e[0], b[g + 1] ^= e[1], b[g + 2] ^= e[2], b[g + 3] ^= e[3];
                                return {
                                    tag: d,
                                    data: k.clamp(b, n)
                                };
                            }
                        };
                        h.misc.hmac = function(a, b) {
                            this._hash = b = b || h.hash.sha256;
                            var c = [
                                [],
                                []
                            ], d, e = b.prototype.blockSize / 32;
                            this._baseHash = [
                                new b,
                                new b
                            ];
                            a.length > e && (a = b.hash(a));
                            for(d = 0; d < e; d++)c[0][d] = a[d] ^ 909522486, c[1][d] = a[d] ^ 1549556828;
                            this._baseHash[0].update(c[0]);
                            this._baseHash[1].update(c[1]);
                            this._resultHash = new b(this._baseHash[0]);
                        };
                        h.misc.hmac.prototype.encrypt = h.misc.hmac.prototype.mac = function(a) {
                            if (this._updated) throw new h.exception.invalid("encrypt on already updated hmac called!");
                            this.update(a);
                            return this.digest(a);
                        };
                        h.misc.hmac.prototype.reset = function() {
                            this._resultHash = new this._hash(this._baseHash[0]);
                            this._updated = !1;
                        };
                        h.misc.hmac.prototype.update = function(a) {
                            this._updated = !0;
                            this._resultHash.update(a);
                        };
                        h.misc.hmac.prototype.digest = function() {
                            var a = this._resultHash.finalize();
                            a = new this._hash(this._baseHash[1]).update(a).finalize();
                            this.reset();
                            return a;
                        };
                        h.arrayBuffer = h.arrayBuffer || {};
                        "undefined" === typeof ArrayBuffer && function(a) {
                            a.ArrayBuffer = function() {};
                            a.DataView = function() {};
                        }(void 0);
                        h.arrayBuffer.ccm = {
                            mode: "ccm",
                            defaults: {
                                tlen: 128
                            },
                            compat_encrypt: function(a, b, c, d, e) {
                                var f = h.codec.arrayBuffer.fromBits(b, !0, 16);
                                b = h.bitArray.bitLength(b) / 8;
                                d = d || [];
                                a = h.arrayBuffer.ccm.encrypt(a, f, c, d, e || 64, b);
                                c = h.codec.arrayBuffer.toBits(a.ciphertext_buffer);
                                c = h.bitArray.clamp(c, 8 * b);
                                return h.bitArray.concat(c, a.tag);
                            },
                            compat_decrypt: function(a, b, c, d, e) {
                                e = e || 64;
                                d = d || [];
                                var f = h.bitArray, k = f.bitLength(b), g = f.clamp(b, k - e);
                                b = f.bitSlice(b, k - e);
                                g = h.codec.arrayBuffer.fromBits(g, !0, 16);
                                a = h.arrayBuffer.ccm.decrypt(a, g, c, b, d, e, (k - e) / 8);
                                return h.bitArray.clamp(h.codec.arrayBuffer.toBits(a), k - e);
                            },
                            encrypt: function(a, b, c, d, e, f) {
                                var k, g = h.bitArray, l = g.bitLength(c) / 8;
                                d = d || [];
                                e = e || h.arrayBuffer.ccm.defaults.tlen;
                                f = f || b.byteLength;
                                e = Math.ceil(e / 8);
                                for(k = 2; 4 > k && f >>> 8 * k; k++);
                                k < 15 - l && (k = 15 - l);
                                c = g.clamp(c, 8 * (15 - k));
                                d = h.arrayBuffer.ccm._computeTag(a, b, c, d, e, f, k);
                                d = h.arrayBuffer.ccm._ctrMode(a, b, c, d, e, k);
                                return {
                                    ciphertext_buffer: b,
                                    tag: d
                                };
                            },
                            decrypt: function(a, b, c, d, e, f, k) {
                                var g, l = h.bitArray, n = l.bitLength(c) / 8;
                                e = e || [];
                                f = f || h.arrayBuffer.ccm.defaults.tlen;
                                k = k || b.byteLength;
                                f = Math.ceil(f / 8);
                                for(g = 2; 4 > g && k >>> 8 * g; g++);
                                g < 15 - n && (g = 15 - n);
                                c = l.clamp(c, 8 * (15 - g));
                                d = h.arrayBuffer.ccm._ctrMode(a, b, c, d, f, g);
                                a = h.arrayBuffer.ccm._computeTag(a, b, c, e, f, k, g);
                                if (!h.bitArray.equal(d, a)) throw new h.exception.corrupt("ccm: tag doesn't match");
                                return b;
                            },
                            _computeTag: function(a, b, c, d, e, f, k) {
                                c = h.mode.ccm._macAdditionalData(a, d, c, e, f, k);
                                if (0 !== b.byteLength) {
                                    for(d = new DataView(b); f < b.byteLength; f++)d.setUint8(f, 0);
                                    for(f = 0; f < d.byteLength; f += 16)c[0] ^= d.getUint32(f), c[1] ^= d.getUint32(f + 4), c[2] ^= d.getUint32(f + 8), c[3] ^= d.getUint32(f + 12), c = a.encrypt(c);
                                }
                                return h.bitArray.clamp(c, 8 * e);
                            },
                            _ctrMode: function(a, b, c, d, e, f) {
                                var k;
                                var g = h.bitArray;
                                var l = g._xor4;
                                var n = b.byteLength / 50, m = n;
                                new DataView(new ArrayBuffer(16));
                                c = g.concat([
                                    g.partial(8, f - 1)
                                ], c).concat([
                                    0,
                                    0,
                                    0
                                ]).slice(0, 4);
                                d = g.bitSlice(l(d, a.encrypt(c)), 0, 8 * e);
                                c[3]++;
                                0 === c[3] && c[2]++;
                                if (0 !== b.byteLength) for(e = new DataView(b), k = 0; k < e.byteLength; k += 16){
                                    k > n && (h.mode.ccm._callProgressListener(k / b.byteLength), n += m);
                                    var q = a.encrypt(c);
                                    g = e.getUint32(k);
                                    l = e.getUint32(k + 4);
                                    f = e.getUint32(k + 8);
                                    var p = e.getUint32(k + 12);
                                    e.setUint32(k, g ^ q[0]);
                                    e.setUint32(k + 4, l ^ q[1]);
                                    e.setUint32(k + 8, f ^ q[2]);
                                    e.setUint32(k + 12, p ^ q[3]);
                                    c[3]++;
                                    0 === c[3] && c[2]++;
                                }
                                return d;
                            }
                        };
                        "undefined" !== typeof r && r.exports && (r.exports = h);
                    },
                    {}
                ],
                2: [
                    function(u, r) {
                        r.exports = u("sjcl");
                    },
                    {
                        sjcl: 1
                    }
                ]
            }, {}, [
                2
            ])(2);
        });
        return module1.exports;
    }();
    var __lib__timsort = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        (function(u) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = u() : "function" === typeof define && define.amd ? define([], u) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = u();
        })(function() {
            return (function() {
                function u(x, C, z) {
                    function y(r, t) {
                        if (!C[r]) {
                            if (!x[r]) {
                                var D = undefined;
                                if (!t && D) return D(r, !0);
                                if (A) return A(r, !0);
                                t = Error("Cannot find module '" + r + "'");
                                throw t.code = "MODULE_NOT_FOUND", t;
                            }
                            t = C[r] = {
                                exports: {}
                            };
                            x[r][0].call(t.exports, function(F) {
                                return y(x[r][1][F] || F);
                            }, t, t.exports, u, x, C, z);
                        }
                        return C[r].exports;
                    }
                    for(var A = undefined, E = 0; E < z.length; E++)y(z[E]);
                    return y;
                }
                return u;
            })()({
                1: [
                    function(u, x, C) {
                        (function(z, y) {
                            if ("undefined" !== typeof C) y(C);
                            else {
                                var A = {};
                                y(A);
                                z.timsort = A;
                            }
                        })(void 0, function(z) {
                            function y(g) {
                                return 1E5 > g ? 100 > g ? 10 > g ? 0 : 1 : 1E4 > g ? 1E3 > g ? 2 : 3 : 4 : 1E7 > g ? 1E6 > g ? 5 : 6 : 1E9 > g ? 1E8 > g ? 7 : 8 : 9;
                            }
                            function A(g, a) {
                                if (g === a) return 0;
                                if (~~g === g && ~~a === a) {
                                    if (0 === g || 0 === a) return g < a ? -1 : 1;
                                    if (0 > g || 0 > a) {
                                        if (0 <= a) return -1;
                                        if (0 <= g) return 1;
                                        g = -g;
                                        a = -a;
                                    }
                                    var h = y(g), c = y(a), e = 0;
                                    h < c ? (g *= G[c - h - 1], a /= 10, e = -1) : h > c && (a *= G[h - c - 1], g /= 10, e = 1);
                                    return g === a ? e : g < a ? -1 : 1;
                                }
                                g = String(g);
                                a = String(a);
                                return g === a ? 0 : g < a ? -1 : 1;
                            }
                            function E(g, a, h, c) {
                                var e = a + 1;
                                if (e === h) return 1;
                                if (0 > c(g[e++], g[a])) {
                                    for(; e < h && 0 > c(g[e], g[e - 1]);)e++;
                                    h = a;
                                    c = e;
                                    for(c--; h < c;){
                                        var k = g[h];
                                        g[h++] = g[c];
                                        g[c--] = k;
                                    }
                                } else for(; e < h && 0 <= c(g[e], g[e - 1]);)e++;
                                return e - a;
                            }
                            function r(g, a, h, c, e) {
                                for(c === a && c++; c < h; c++){
                                    for(var k = g[c], d = a, b = c; d < b;){
                                        var f = d + b >>> 1;
                                        0 > e(k, g[f]) ? b = f : d = f + 1;
                                    }
                                    b = c - d;
                                    switch(b){
                                        case 3:
                                            g[d + 3] = g[d + 2];
                                        case 2:
                                            g[d + 2] = g[d + 1];
                                        case 1:
                                            g[d + 1] = g[d];
                                            break;
                                        default:
                                            for(; 0 < b;)g[d + b] = g[d + b - 1], b--;
                                    }
                                    g[d] = k;
                                }
                            }
                            function t(g, a, h, c, e, k) {
                                var d = 0, b = 1;
                                if (0 < k(g, a[h + e])) {
                                    for(c -= e; b < c && 0 < k(g, a[h + e + b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    d += e;
                                    b += e;
                                } else {
                                    for(c = e + 1; b < c && 0 >= k(g, a[h + e - b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    c = d;
                                    d = e - b;
                                    b = e - c;
                                }
                                for(d++; d < b;)e = d + (b - d >>> 1), 0 < k(g, a[h + e]) ? d = e + 1 : b = e;
                                return b;
                            }
                            function D(g, a, h, c, e, k) {
                                var d = 0, b = 1;
                                if (0 > k(g, a[h + e])) {
                                    for(c = e + 1; b < c && 0 > k(g, a[h + e - b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    c = d;
                                    d = e - b;
                                    b = e - c;
                                } else {
                                    for(c -= e; b < c && 0 <= k(g, a[h + e + b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    d += e;
                                    b += e;
                                }
                                for(d++; d < b;)e = d + (b - d >>> 1), 0 > k(g, a[h + e]) ? b = e : d = e + 1;
                                return b;
                            }
                            z.__esModule = !0;
                            z.sort = function(g, a, h, c) {
                                if (!Array.isArray(g)) throw new TypeError("Can only sort arrays");
                                a ? "function" !== typeof a && (c = h, h = a, a = A) : a = A;
                                h || (h = 0);
                                c || (c = g.length);
                                var e = c - h;
                                if (!(2 > e)) {
                                    if (e < F) {
                                        var k = E(g, h, c, a);
                                        r(g, h, c, h + k, a);
                                    } else {
                                        var d = new H(g, a), b;
                                        k = e;
                                        for(b = 0; k >= F;)b |= k & 1, k >>= 1;
                                        b = k + b;
                                        do {
                                            k = E(g, h, c, a);
                                            if (k < b) {
                                                var f = e;
                                                f > b && (f = b);
                                                r(g, h, h + f, h + k, a);
                                                k = f;
                                            }
                                            d.pushRun(h, k);
                                            d.mergeRuns();
                                            e -= k;
                                            h += k;
                                        }while (0 !== e);
                                        d.forceMergeRuns();
                                    }
                                }
                            };
                            var F = 32, G = [
                                1,
                                10,
                                100,
                                1E3,
                                1E4,
                                1E5,
                                1E6,
                                1E7,
                                1E8,
                                1E9
                            ], H = function() {
                                function g(a, h) {
                                    if (!(this instanceof g)) throw new TypeError("Cannot call a class as a function");
                                    this.compare = this.array = null;
                                    this.minGallop = 7;
                                    this.length = 0;
                                    this.tmpStorageLength = 256;
                                    this.stackLength = 0;
                                    this.runLength = this.runStart = null;
                                    this.stackSize = 0;
                                    this.array = a;
                                    this.compare = h;
                                    this.length = a.length;
                                    512 > this.length && (this.tmpStorageLength = this.length >>> 1);
                                    this.tmp = Array(this.tmpStorageLength);
                                    this.stackLength = 120 > this.length ? 5 : 1542 > this.length ? 10 : 119151 > this.length ? 19 : 40;
                                    this.runStart = Array(this.stackLength);
                                    this.runLength = Array(this.stackLength);
                                }
                                g.prototype.pushRun = function(a, h) {
                                    this.runStart[this.stackSize] = a;
                                    this.runLength[this.stackSize] = h;
                                    this.stackSize += 1;
                                };
                                g.prototype.mergeRuns = function() {
                                    for(; 1 < this.stackSize;){
                                        var a = this.stackSize - 2;
                                        if (1 <= a && this.runLength[a - 1] <= this.runLength[a] + this.runLength[a + 1] || 2 <= a && this.runLength[a - 2] <= this.runLength[a] + this.runLength[a - 1]) this.runLength[a - 1] < this.runLength[a + 1] && a--;
                                        else if (this.runLength[a] > this.runLength[a + 1]) break;
                                        this.mergeAt(a);
                                    }
                                };
                                g.prototype.forceMergeRuns = function() {
                                    for(; 1 < this.stackSize;){
                                        var a = this.stackSize - 2;
                                        0 < a && this.runLength[a - 1] < this.runLength[a + 1] && a--;
                                        this.mergeAt(a);
                                    }
                                };
                                g.prototype.mergeAt = function(a) {
                                    var h = this.compare, c = this.array, e = this.runStart[a], k = this.runLength[a], d = this.runStart[a + 1], b = this.runLength[a + 1];
                                    this.runLength[a] = k + b;
                                    a === this.stackSize - 3 && (this.runStart[a + 1] = this.runStart[a + 2], this.runLength[a + 1] = this.runLength[a + 2]);
                                    this.stackSize--;
                                    a = D(c[d], c, e, k, 0, h);
                                    e += a;
                                    k -= a;
                                    0 !== k && (b = t(c[e + k - 1], c, d, b, b - 1, h), 0 !== b && (k <= b ? this.mergeLow(e, k, d, b) : this.mergeHigh(e, k, d, b)));
                                };
                                g.prototype.mergeLow = function(a, h, c, e) {
                                    var k = this.compare, d = this.array, b = this.tmp, f;
                                    for(f = 0; f < h; f++)b[f] = d[a + f];
                                    var m = 0;
                                    d[a++] = d[c++];
                                    if (0 === --e) for(f = 0; f < h; f++)d[a + f] = b[m + f];
                                    else if (1 === h) {
                                        for(f = 0; f < e; f++)d[a + f] = d[c + f];
                                        d[a + e] = b[m];
                                    } else {
                                        for(var p = this.minGallop;;){
                                            var l = 0, n = 0, q = !1;
                                            do if (0 > k(d[c], b[m])) {
                                                if (d[a++] = d[c++], n++, l = 0, 0 === --e) {
                                                    q = !0;
                                                    break;
                                                }
                                            } else if (d[a++] = b[m++], l++, n = 0, 1 === --h) {
                                                q = !0;
                                                break;
                                            }
                                            while ((l | n) < p);
                                            if (q) break;
                                            do {
                                                l = D(d[c], b, m, h, 0, k);
                                                if (0 !== l) {
                                                    for(f = 0; f < l; f++)d[a + f] = b[m + f];
                                                    a += l;
                                                    m += l;
                                                    h -= l;
                                                    if (1 >= h) {
                                                        q = !0;
                                                        break;
                                                    }
                                                }
                                                d[a++] = d[c++];
                                                if (0 === --e) {
                                                    q = !0;
                                                    break;
                                                }
                                                n = t(b[m], d, c, e, 0, k);
                                                if (0 !== n) {
                                                    for(f = 0; f < n; f++)d[a + f] = d[c + f];
                                                    a += n;
                                                    c += n;
                                                    e -= n;
                                                    if (0 === e) {
                                                        q = !0;
                                                        break;
                                                    }
                                                }
                                                d[a++] = b[m++];
                                                if (1 === --h) {
                                                    q = !0;
                                                    break;
                                                }
                                                p--;
                                            }while (7 <= l || 7 <= n);
                                            if (q) break;
                                            0 > p && (p = 0);
                                            p += 2;
                                        }
                                        this.minGallop = p;
                                        1 > p && (this.minGallop = 1);
                                        if (1 === h) {
                                            for(f = 0; f < e; f++)d[a + f] = d[c + f];
                                            d[a + e] = b[m];
                                        } else {
                                            if (0 === h) throw Error("mergeLow preconditions were not respected");
                                            for(f = 0; f < h; f++)d[a + f] = b[m + f];
                                        }
                                    }
                                };
                                g.prototype.mergeHigh = function(a, h, c, e) {
                                    var k = this.compare, d = this.array, b = this.tmp, f;
                                    for(f = 0; f < e; f++)b[f] = d[c + f];
                                    var m = a + h - 1, p = e - 1;
                                    c = c + e - 1;
                                    d[c--] = d[m--];
                                    if (0 === --h) {
                                        var l = c - (e - 1);
                                        for(f = 0; f < e; f++)d[l + f] = b[f];
                                    } else if (1 === e) {
                                        c -= h;
                                        var n = c + 1;
                                        l = m - h + 1;
                                        for(f = h - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                        d[c] = b[p];
                                    } else {
                                        for(var q = this.minGallop;;){
                                            var v = 0, w = 0, B = !1;
                                            do if (0 > k(b[p], d[m])) {
                                                if (d[c--] = d[m--], v++, w = 0, 0 === --h) {
                                                    B = !0;
                                                    break;
                                                }
                                            } else if (d[c--] = b[p--], w++, v = 0, 1 === --e) {
                                                B = !0;
                                                break;
                                            }
                                            while ((v | w) < q);
                                            if (B) break;
                                            do {
                                                v = h - D(b[p], d, a, h, h - 1, k);
                                                if (0 !== v) {
                                                    c -= v;
                                                    m -= v;
                                                    h -= v;
                                                    n = c + 1;
                                                    l = m + 1;
                                                    for(f = v - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                                    if (0 === h) {
                                                        B = !0;
                                                        break;
                                                    }
                                                }
                                                d[c--] = b[p--];
                                                if (1 === --e) {
                                                    B = !0;
                                                    break;
                                                }
                                                w = e - t(d[m], b, 0, e, e - 1, k);
                                                if (0 !== w) {
                                                    c -= w;
                                                    p -= w;
                                                    e -= w;
                                                    n = c + 1;
                                                    l = p + 1;
                                                    for(f = 0; f < w; f++)d[n + f] = b[l + f];
                                                    if (1 >= e) {
                                                        B = !0;
                                                        break;
                                                    }
                                                }
                                                d[c--] = d[m--];
                                                if (0 === --h) {
                                                    B = !0;
                                                    break;
                                                }
                                                q--;
                                            }while (7 <= v || 7 <= w);
                                            if (B) break;
                                            0 > q && (q = 0);
                                            q += 2;
                                        }
                                        this.minGallop = q;
                                        1 > q && (this.minGallop = 1);
                                        if (1 === e) {
                                            c -= h;
                                            n = c + 1;
                                            l = m - h + 1;
                                            for(f = h - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                            d[c] = b[p];
                                        } else {
                                            if (0 === e) throw Error("mergeHigh preconditions were not respected");
                                            l = c - (e - 1);
                                            for(f = 0; f < e; f++)d[l + f] = b[f];
                                        }
                                    }
                                };
                                return g;
                            }();
                        });
                    },
                    {}
                ],
                2: [
                    function(u, x) {
                        x.exports = u("./build/timsort.js");
                    },
                    {
                        "./build/timsort.js": 1
                    }
                ],
                3: [
                    function(u, x) {
                        x.exports = u("timsort");
                    },
                    {
                        timsort: 2
                    }
                ]
            }, {}, [
                3
            ])(3);
        });
        return module1.exports;
    }();
    var api = {};
    (function() {
        var k, m = m || {};
        m.scope = {};
        m.td = function(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        };
        m.Pd = function(a) {
            return {
                next: m.td(a)
            };
        };
        m.Jc = !1;
        m.he = !1;
        m.ie = !1;
        m.le = !1;
        m.Mc = !1;
        m.je = !1;
        m.ke = !1;
        m.defineProperty = m.Jc || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        m.Ud = function(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        };
        m.global = m.Ud(this);
        m.$b = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
        m.Nc = !m.Mc || m.$b;
        m.Fc = {};
        m.Gc = {};
        m.Hd = "$jscp$";
        m.Ec = function(a, b, c) {
            b && (m.Mc ? m.ae(a, b, c) : m.be(a, b));
        };
        m.be = function(a, b) {
            var c = m.global;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) return;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && m.defineProperty(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        };
        m.ae = function(a, b, c) {
            var d = a.split(".");
            a = 1 === d.length;
            var e = d[0], f;
            !a && e in m.Fc ? f = m.Fc : f = m.global;
            for(e = 0; e < d.length - 1; e++){
                var g = d[e];
                if (!(g in f)) return;
                f = f[g];
            }
            d = d[d.length - 1];
            c = m.$b && "es6" === c ? f[d] : null;
            b = b(c);
            null != b && (a ? m.defineProperty(m.Fc, d, {
                configurable: !0,
                writable: !0,
                value: b
            }) : b !== c && (void 0 === m.Gc[d] && (a = 1E9 * Math.random() >>> 0, m.Gc[d] = m.$b ? m.global.Symbol(d) : m.Hd + a + "$" + d), m.defineProperty(f, m.Gc[d], {
                configurable: !0,
                writable: !0,
                value: b
            })));
        };
        m.re = function() {};
        m.Ec("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, g) {
                this.g = f;
                m.defineProperty(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        }, "es6");
        m.Ec("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = m.global[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && m.defineProperty(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return m.Wd(m.td(this));
                    }
                });
            }
            return a;
        }, "es6");
        m.Ec("Symbol.asyncIterator", function(a) {
            return a ? a : Symbol("Symbol.asyncIterator");
        }, "es9");
        m.Wd = function(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        };
        m.pe = function(a) {
            return a.raw = a;
        };
        m.qe = function(a, b) {
            a.raw = b;
            return a;
        };
        m.ya = function(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return m.Pd(a);
            throw Error(String(a) + " is not an iterable or ArrayLike");
        };
        m.Od = function(a) {
            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
            return c;
        };
        m.Ua = function(a) {
            return a instanceof Array ? a : m.Od(m.ya(a));
        };
        m.zd = m.Jc || "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        };
        m.Td = function() {
            function a() {
                function c() {}
                new c;
                Reflect.construct(c, [], function() {});
                return new c instanceof c;
            }
            if (m.Nc && "undefined" != typeof Reflect && Reflect.construct) {
                if (a()) return Reflect.construct;
                var b = Reflect.construct;
                return function(c, d, e) {
                    c = b(c, d);
                    e && Reflect.setPrototypeOf(c, e.prototype);
                    return c;
                };
            }
            return function(c, d, e) {
                void 0 === e && (e = c);
                e = m.zd(e.prototype || Object.prototype);
                return Function.prototype.apply.call(c, e, d) || e;
            };
        };
        m.construct = ({
            valueOf: m.Td
        }).valueOf();
        m.ge = function() {
            var a = {
                a: !0
            }, b = {};
            try {
                return b.__proto__ = a, b.a;
            } catch (c) {}
            return !1;
        };
        m.setPrototypeOf = m.Nc && "function" == typeof Object.setPrototypeOf ? Object.setPrototypeOf : m.ge() ? function(a, b) {
            a.__proto__ = b;
            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
            return a;
        } : null;
        m.inherits = function(a, b) {
            a.prototype = m.zd(b.prototype);
            a.prototype.constructor = a;
            if (m.setPrototypeOf) {
                var c = m.setPrototypeOf;
                c(a, b);
            } else for(c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.se = b.prototype;
        };
        m.ta = {};
        m.ta.Sd = function(a) {
            if (!(a instanceof Object)) throw new TypeError("Iterator result " + a + " is not an object");
        };
        m.ta.vb = function() {
            this.s = !1;
            this.o = null;
            this.h = void 0;
            this.g = 1;
            this.l = this.j = 0;
            this.v = this.i = null;
        };
        function aa(a) {
            if (a.s) throw new TypeError("Generator is already running");
            a.s = !0;
        }
        m.ta.vb.prototype.u = function(a) {
            this.h = a;
        };
        function ba(a, b) {
            a.i = {
                vd: b,
                wd: !0
            };
            a.g = a.j || a.l;
        }
        m.ta.vb.prototype.return = function(a) {
            this.i = {
                return: a
            };
            this.g = this.l;
        };
        function n(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        m.ta.vb.prototype.J = function(a) {
            this.g = a;
        };
        function ca(a, b, c) {
            a.j = b;
            void 0 != c && (a.l = c);
        }
        function da(a) {
            a.j = 0;
            var b = a.i.vd;
            a.i = null;
            return b;
        }
        function ea(a, b, c, d) {
            d ? a.v[d] = a.i : a.v = [
                a.i
            ];
            a.j = b || 0;
            a.l = c || 0;
        }
        function fa(a, b, c) {
            c = a.v.splice(c || 0)[0];
            (c = a.i = a.i || c) ? c.wd ? a.g = a.j || a.l : void 0 != c.J && a.l < c.J ? (a.g = c.J, a.i = null) : a.g = a.l : a.g = b;
        }
        m.ta.vb.g = function(a) {
            this.g = [];
            for(var b in a)this.g.push(b);
            this.g.reverse();
        };
        m.ta.Kc = function(a) {
            this.g = new m.ta.vb;
            this.h = a;
        };
        function ha(a, b) {
            aa(a.g);
            var c = a.g.o;
            if (c) return ia(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return ja(a);
        }
        function ia(a, b, c, d) {
            try {
                var e = b.call(a.g.o, c);
                m.ta.Sd(e);
                if (!e.done) return a.g.s = !1, e;
                var f = e.value;
            } catch (g) {
                return a.g.o = null, ba(a.g, g), ja(a);
            }
            a.g.o = null;
            d.call(a.g, f);
            return ja(a);
        }
        function ja(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.s = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.h = void 0, ba(a.g, c);
            }
            a.g.s = !1;
            if (a.g.i) {
                b = a.g.i;
                a.g.i = null;
                if (b.wd) throw b.vd;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        m.ta.Lc = function(a) {
            this.next = function(b) {
                aa(a.g);
                a.g.o ? b = ia(a, a.g.o.next, b, a.g.u) : (a.g.u(b), b = ja(a));
                return b;
            };
            this.throw = function(b) {
                aa(a.g);
                a.g.o ? b = ia(a, a.g.o["throw"], b, a.g.u) : (ba(a.g, b), b = ja(a));
                return b;
            };
            this.return = function(b) {
                return ha(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        };
        m.ta.Sb = function(a, b) {
            b = new m.ta.Lc(new m.ta.Kc(b));
            m.setPrototypeOf && a.prototype && m.setPrototypeOf(b, a.prototype);
            return b;
        };
        m.ud = function(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function f(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        };
        m.oe = function(a) {
            return m.ud(a());
        };
        m.ea = function(a) {
            return m.ud(new m.ta.Lc(new m.ta.Kc(a)));
        };
        m.Dc = function(a) {
            var b = a[Symbol.asyncIterator];
            return void 0 !== b ? b.call(a) : new m.Gd(m.ya(a));
        };
        m.Gd = function(a) {
            this[Symbol.asyncIterator] = function() {
                return this;
            };
            this[Symbol.iterator] = function() {
                return a;
            };
            this.next = function(b) {
                return Promise.resolve(a.next(b));
            };
            void 0 !== a["throw"] && (this["throw"] = function(b) {
                return Promise.resolve(a["throw"](b));
            });
            void 0 !== a["return"] && (this["return"] = function(b) {
                return Promise.resolve(a["return"](b));
            });
        };
        m.Ga = {
            Kb: 0,
            wb: 1,
            Hb: 2
        };
        m.Na = function(a, b) {
            this.g = a;
            this.value = b;
        };
        m.$a = {
            NEXT: "next",
            ac: "throw",
            Id: "return"
        };
        m.Dd = function(a, b, c, d) {
            this.method = a;
            this.g = b;
            this.resolve = c;
            this.h = d;
        };
        m.Ed = function(a) {
            this.g = a;
            this.next = null;
        };
        m.Fd = function() {
            this.h = this.g = null;
        };
        function ka(a) {
            if (a.g) return a.g.g;
            throw Error("no frames in executionQueue");
        }
        function la(a) {
            a.g && (a.g = a.g.next, a.g || (a.h = null));
        }
        m.qb = function(a) {
            this.j = a;
            this.h = null;
            this.g = new m.Fd;
            this[Symbol.asyncIterator] = function() {
                return this;
            };
            var b = this;
            this.o = function(c) {
                var d = ka(b.g);
                !0 === c.done ? (b.h = null, d.method = m.$a.NEXT, d.g = c.value) : (d.resolve({
                    value: c.value,
                    done: !1
                }), la(b.g));
                na(b);
            };
            this.l = function(c) {
                oa(b, c);
            };
            this.i = function(c) {
                pa(b, c);
            };
        };
        function qa(a, b, c) {
            return new Promise(function(d, e) {
                var f = null === a.g.g, g = a.g;
                d = new m.Ed(new m.Dd(b, c, d, e));
                g.h ? g.h.next = d : g.g = d;
                g.h = d;
                f && na(a);
            });
        }
        m.qb.prototype.next = function(a) {
            return qa(this, m.$a.NEXT, a);
        };
        m.qb.prototype.return = function(a) {
            return qa(this, m.$a.Id, new m.Na(m.Ga.Kb, a));
        };
        m.qb.prototype.throw = function(a) {
            return qa(this, m.$a.ac, a);
        };
        function na(a) {
            if (null !== a.g.g) try {
                if (a.h) {
                    if (!a.h) throw Error("no delegate to perform execution");
                    var b = ka(a.g);
                    if (b.method in a.h) try {
                        a.h[b.method](b.g).then(a.o, a.l).catch(a.i);
                    } catch (c) {
                        oa(a, c);
                    }
                    else a.h = null, na(a);
                } else ra(a);
            } catch (c) {
                pa(a, c);
            }
        }
        function ra(a) {
            var b = ka(a.g);
            try {
                var c = a.j[b.method](b.g);
                if (c.value instanceof m.Na) switch(c.value.g){
                    case m.Ga.Kb:
                        Promise.resolve(c.value.value).then(function(d) {
                            b.resolve({
                                value: d,
                                done: c.done
                            });
                            la(a.g);
                            na(a);
                        }, function(d) {
                            b.h(d);
                            la(a.g);
                            na(a);
                        }).catch(a.i);
                        break;
                    case m.Ga.wb:
                        a.h = m.Dc(c.value.value);
                        b.method = m.$a.NEXT;
                        b.g = void 0;
                        na(a);
                        break;
                    case m.Ga.Hb:
                        Promise.resolve(c.value.value).then(function(d) {
                            b.method = m.$a.NEXT;
                            b.g = d;
                            na(a);
                        }, function(d) {
                            b.method = m.$a.ac;
                            b.g = d;
                            na(a);
                        }).catch(a.i);
                        break;
                    default:
                        throw Error("Unrecognized AsyncGeneratorWrapper$ActionEnum");
                }
                else b.resolve(c), la(a.g), na(a);
            } catch (d) {
                b.h(d), la(a.g), na(a);
            }
        }
        function oa(a, b) {
            var c = ka(a.g);
            a.h = null;
            c.method = m.$a.ac;
            c.g = b;
            na(a);
        }
        function pa(a, b) {
            null !== a.g.g && (ka(a.g).h(b), la(a.g));
            a.h && "return" in a.h && (a.h["return"](void 0), a.h = null);
            a.j["return"](void 0);
            na(a);
        }
        m.Vd = function() {
            for(var a = Number(this), b = [], c = a; c < arguments.length; c++)b[c - a] = arguments[c];
            return b;
        };
        function sa() {
            var a = document.createElement("style");
            a.appendChild(document.createTextNode('.colibrio-custom-page-content{height:100%;left:0;overflow:auto;position:absolute;top:0;-ms-touch-action:none;touch-action:none;width:100%}.colibrio-custom-page-content--center{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-box-align:center;-ms-flex-align:center;-webkit-box-pack:center;-ms-flex-pack:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;justify-content:center}\n.colibrio-loader{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;height:42px;justify-items:center;position:relative;width:42px}.colibrio-loader__spinner{-webkit-animation:colibrio-loader__spinner--roll 3s infinite;animation:colibrio-loader__spinner--roll 3s infinite;background-color:transparent;border-radius:50% 50%;border-right:1px solid #61004c;display:inline-block;height:100%;opacity:.7;position:absolute;width:100%}.colibrio-loader__birdie{background-image:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMTAiIGhlaWdodD0iMjk3Ij48cGF0aCBkPSJNNDkuMDE2IDU1Ljk3MmMtOC4xMTIgNi4zOTUtMTkuMDUzIDE4LjY3LTI0LjkzOCAyNy40NTVDMi4zNDMgMTE1Ljg3NC0uNTIgMTY2LjI1OCAyNi4wMzUgMjA0Ljk5YzcuOTMgMTAuODI3IDE3Ljk4IDIwLjE2MiAyNi44OTcgMjcuNTI1IDExLjc4NCAyOS42MTMgMzguMzI4IDUwLjIgNjguNzUzIDQ4LjczN2wuMzUtLjAyMi0yLjQyOC03LjM4NC0uNDEtLjA5M2MtLjAxLS4wMjQtLjAxOC0uMDQ4LS4wMjctLjA3M2wuMDIzLjA3Mi0uMDYzLS4wMTQtMTAuMDA1LTIuNjQ4Yy0uNjM1LTEuMjY3LTIuODI5LTYuNzk1LTMuMjU2LTcuNTY0bC02LjM5NC0yLjU4MS04LjI2NC0xMS4yOTVjLS43NjQtLjE4LTEuNTIyLS4zODEtMi4yODMtLjU3My0xMi4wOTQtMy42NDMtMjUuNDIxLTEwLjAzNS0zNC40ODEtMTYuNTYyIDEyLjY5MyAxLjk5MyAzNy4zNzUtNS4xMjMgNDMuNTYyLTM0LjMxLjcwOC00LjIyMy43NjUtOC40MDkuMjQxLTEyLjQ0OC0yLjAwOC0xMS45OCA4Ljg4My0xNC43NjUgMTEuMDMyLTEzLjM4NSAzLjMwNiAxLjk3NCA4LjczNSA0LjQ0MyAxMi4zNDMgNS4zMjYgMy4yOTEuNzQ0IDcuOTE2LjY2NSAxMS4wNzEtMS4wMyAyLjg3NS0xLjQyNyA1LjI4MS0zLjg4NSA2Ljg5NS02Ljc2MWw1OC43MzUgMTQuOTctLjAyNS0uMDEzLjM3Mi4wOTZjLTI1LjYxNi0xMy4zMDItNTMuMDk4LTIxLjcwOS01Ny4wMTYtMjIuODY3LTEuODkyLTI4LjU0Mi00OC44NjQtMTMuNTMxLTU3Ljc3NC03LjI5Ny0yLjMxNC00LjQxOC02LjkxMS0xNC42MjYtOC41NTUtMjAuNjkzLTUuNDkyLTE4LjY0NS00LjQ1NS00MC40NTItMS40MDQtNTUuNDdDODIuNDAzIDQ3LjYxIDk3Ljg4MSAyMy45MSAxMjguMDIxIDcuMjdjLTEzLjYyOCA2LjE3Ni00NC43MDEgMjcuNTA0LTU2LjE2NCA3My4wNTgtNy43ODQgNi42Mi0xNS40MTQgMTQuMzk2LTIwLjgyMyAyMS43MzYtMi4wNTktOS43NzktNC43NzMtMjUuNzQtMi4wMTgtNDYuMDkyeiIgZmlsbD0iIzYxMDA0YyIvPjwvc3ZnPg==");background-position:50%;background-repeat:no-repeat;background-size:contain;height:70%;left:15%;position:absolute;top:15%;width:70%}@-webkit-keyframes colibrio-loader__spinner--roll{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes colibrio-loader__spinner--roll{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}\n.colibrio-readerview--no-user-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}\n.colibrio-renderer-runtime-container{bottom:0;left:0;position:absolute;right:0;top:0;z-index:1}\n.colibrio-reader-view-annotation-layer{overflow:hidden;pointer-events:none}.colibrio-reader-view-annotation-layer--input-engine-events-enabled>.colibrio-reader-view-annotation>*{pointer-events:auto!important}.colibrio-reader-view-annotation-layer--disable-text-selection{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}'));
            var b = document.head;
            b.insertBefore(a, b.firstChild);
        }
        "object" === typeof document && (document.head ? sa() : document.addEventListener("DOMContentLoaded", sa, !1));
        var p = __dep__colibrio_core_base;
        var ta = __dep__colibrio_core_encryption;
        var ua = __dep__colibrio_core_io_base;
        var va = __dep__colibrio_core_io_mediatypedetector;
        var wa = __dep__colibrio_core_io_resourcecache;
        var xa = __dep__colibrio_core_locator;
        var t = __dep__colibrio_core_publication_base;
        var ya = __dep__colibrio_core_url;
        var x = __dep__colibrio_readingsystem_base;
        function za(a, b) {
            return a === b ? !0 : a.length !== b.length ? !1 : a.every(function(c, d) {
                return c === b[d];
            });
        }
        function Aa(a, b, c, d) {
            var e = 0;
            if (0 >= c) a = -1;
            else {
                c = e + c - 1;
                for(var f = e, g = 1; g && e <= c;)f = e + c >>> 1, g = d(a, f), 0 > g ? c = f - 1 : 0 < g && (e = f + 1);
                0 !== g && 0 === b ? f = -1 : 0 > g && 1 === b ? f-- : 0 < g && 2 === b && f++;
                a = f;
            }
            return a;
        }
        function Ba(a) {
            return 0 < a.length ? a[0] : void 0;
        }
        function Ca(a) {
            return 0 < a.length ? a[a.length - 1] : void 0;
        }
        function Da(a) {
            return 32 === a || 12 === a || 10 === a || 13 === a || 9 === a || 11 === a || 133 === a || 160 === a || 5760 === a || 8192 <= a && 8202 >= a || 8232 === a || 8233 === a || 8239 === a || 8287 === a || 12288 === a || 65279 === a;
        }
        function Ea(a) {
            return a && a && 1 === a.nodeType && "http://www.w3.org/1999/xhtml" === a.namespaceURI;
        }
        function Fa(a) {
            return Ha(a) && /\S/.test(a);
        }
        function Ia(a) {
            return Ha(a) && /^\s*$/.test(a);
        }
        function Ja(a) {
            return "undefined" === typeof a;
        }
        function Ka(a, b, c) {
            return a < b ? b : a > c ? c : a;
        }
        function La(a) {
            return Ma(a, {}, !1);
        }
        function Ma(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), e = 0; e < d.length; e++){
                var f = d[e], g = a[f];
                null !== g && "object" === typeof g ? b[f] = Ma(g, b[f], c) : Ja(g) ? c && delete b[f] : b[f] = g;
            }
            return b;
        }
        function y(a, b, c) {
            return Ma(a, b, c || !1);
        }
        function Na(a, b) {
            var c;
            if (Oa(a)) {
                var d = Object.keys(a);
                var e = 0;
                for(c = d.length; e < c; e++){
                    var f = d[e];
                    b(a[f], f);
                }
            }
        }
        var Pa = Array.isArray;
        function B(a) {
            return "function" === typeof a;
        }
        function C(a) {
            return "number" === typeof a && !isNaN(a);
        }
        function Oa(a) {
            return a && !Pa(a) && "object" === typeof a;
        }
        function Ha(a) {
            return "string" === typeof a;
        }
        function Qa(a, b) {
            var c = [];
            Na(b, function(d) {
                Ra(a, d) || c.push(d);
            });
            return c;
        }
        function Sa(a, b, c, d) {
            return (d - c) / b * a + c;
        }
        var Ra = Function.prototype.call.bind(Object.prototype.hasOwnProperty);
        function Ta(a, b) {
            var c = a.style;
            Na(b, function(d, e) {
                Ha(c[e]) && (c[e] = d);
            });
        }
        function Ua(a, b) {
            a = a.createElement("div");
            for(var c = 0; c < b.length; c++){
                var d = b[c];
                d.Yd ? a.setAttributeNS(d.Yd, d.name, d.value) : a.setAttribute(d.name, d.value);
            }
            return a;
        }
        function Va(a) {
            var b = a.localName, c = [
                {
                    tag: "button"
                },
                {
                    tag: "details"
                },
                {
                    tag: "embed"
                },
                {
                    tag: "label"
                },
                {
                    tag: "select"
                },
                {
                    tag: "textarea"
                },
                {
                    tag: "iframe"
                },
                {
                    Gb: "href",
                    tag: "a"
                },
                {
                    Gb: "controls",
                    tag: "audio"
                },
                {
                    Gb: "usemap",
                    tag: "img"
                },
                {
                    Gb: "usemap",
                    tag: "object"
                },
                {
                    Gb: "controls",
                    tag: "video"
                }
            ], d = "input" === b && "hidden" !== a.getAttribute("type");
            return a.hasAttribute("contenteditable") || d || c.some(function(e) {
                var f = e.tag;
                return (e = e.Gb) ? f === b && a.hasAttribute(e) : f === b;
            });
        }
        function Wa(a) {
            var b = a.parentNode;
            b && b.removeChild(a);
        }
        function Xa(a) {
            return "x" in a ? a : new DOMRect(a.left, a.top, a.width, a.height);
        }
        function Ya(a) {
            a = a.slice(0);
            return new Promise(function(b, c) {
                var d = !1;
                0 === a.length && c([]);
                for(var e = [], f = 0; f < a.length; f++)a[f].then(function(g) {
                    d || (d = !0, b(g));
                }).catch(function(g) {
                    e.push(g);
                    e.length === a.length && c(e);
                });
            });
        }
        var Za = new Uint16Array(1);
        Za[0] = 4660;
        new Uint8Array(Za.buffer);
        function D(a, b) {
            return p.ColibrioError.call(this, "colibrio.readingsystem.engine", a, b) || this;
        }
        m.inherits(D, p.ColibrioError);
        function $a(a) {
            this.g = [];
            this.i = !1;
            this.h = null;
            this.j = !!a;
        }
        $a.prototype.add = function(a) {
            this.g.includes(a) || (this.g = this.g.concat(a), this.j && this.i && a(this.h));
        };
        $a.prototype.clear = function() {
            this.g = [];
            this.h = null;
        };
        function ab(a, b, c) {
            a.i = !0;
            a.j && (a.h = b);
            for(var d = a.g, e = 0; e < d.length; e++){
                var f = d[e];
                if (a.g.includes(f)) try {
                    f(b);
                } catch (g) {
                    c(g);
                }
            }
        }
        $a.prototype.remove = function(a) {
            this.g = this.g.filter(function(b) {
                return b !== a;
            });
        };
        $a.prototype.size = function() {
            return this.g.length;
        };
        function G(a, b) {
            this.da = a;
            this.m = b;
            this.i = this.h = this.j = !1;
        }
        G.prototype.preventDefault = function() {
            this.cancelable && (this.j = !0);
        };
        G.prototype.stopImmediatePropagation = function() {
            this.h = !0;
        };
        G.prototype.stopPropagation = function() {
            this.i = !0;
        };
        G.prototype.toJSON = function() {
            return {
                cancelable: !!this.m.cancelable,
                defaultPrevented: this.j,
                immediatePropagationStopped: this.h,
                isTrusted: !!this.m.isTrusted,
                objectType: x.EngineEventDataObjectType.ENGINE_EVENT,
                propagationStopped: this.i,
                readerViewName: this.m.readerView ? this.m.readerView.getName() : null,
                type: this.da
            };
        };
        m.global.Object.defineProperties(G.prototype, {
            defaultPrevented: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.j;
                }
            },
            immediatePropagationStopped: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.h;
                }
            },
            propagationStopped: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.i;
                }
            },
            cancelable: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return !!this.m.cancelable;
                }
            },
            isTrusted: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return !!this.m.isTrusted;
                }
            },
            type: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.da;
                }
            },
            readerView: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerView;
                }
            }
        });
        function bb(a, b) {
            G.call(this, a, b);
        }
        m.inherits(bb, G);
        bb.prototype.toJSON = function() {
            var a = G.prototype.toJSON.call(this);
            return Object.assign(a, {
                objectType: x.EngineEventDataObjectType.LICENSE_ENGINE_EVENT,
                publicationToken: this.m.publicationToken,
                reason: this.m.reason,
                userToken: this.m.userToken
            });
        };
        m.global.Object.defineProperties(bb.prototype, {
            publicationToken: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.publicationToken;
                }
            },
            reason: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.reason;
                }
            },
            userToken: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.userToken;
                }
            }
        });
        var cb = __lib__sjcl;
        function db() {
            for(var a = eb(), b = 4 - a.length % 4, c = 0; c < b; c++)a += "p";
            a = (new TextEncoder).encode(a);
            return new Int32Array(a);
        }
        function K(a) {
            return gb.apply(null, m.Ua(a));
        }
        function hb(a) {
            var b = Date.now(), c = (new TextEncoder).encode(a);
            a = new Uint8Array(c.length + 1);
            a[0] = b;
            a.set(c, 1);
            b = 203;
            for(c = 1; c < a.length; c++)a[c] = a[c] ^ a[c - 1] ^ b++;
            a = p.Base64.encode(a);
            b = "";
            for(c = 0; c < a.length; c++)b = "+" === a[c] ? b + "-" : "/" === a[c] ? b + "_" : b + a[c];
            return b;
        }
        var ib = [
            67,
            79,
            78,
            84,
            73,
            78,
            85,
            69,
            68,
            95,
            83,
            69,
            83,
            83,
            73,
            79,
            78
        ], jb = [
            73,
            78,
            86,
            65,
            76,
            73,
            68,
            95,
            76,
            73,
            67,
            69,
            78,
            83,
            69,
            95,
            65,
            80,
            73,
            95,
            75,
            69,
            89
        ], kb = [
            73,
            78,
            86,
            65,
            76,
            73,
            68,
            95,
            76,
            73,
            67,
            69,
            78,
            83,
            69,
            95,
            65,
            80,
            73,
            95,
            83,
            69,
            67,
            82,
            69,
            84
        ], lb = [
            74,
            83,
            79,
            78
        ], mb = [
            76,
            73,
            67,
            69,
            78,
            83,
            69,
            95,
            68,
            69,
            65,
            67,
            84,
            73,
            86,
            65,
            84,
            69,
            68
        ], nb = [
            76,
            73,
            67,
            69,
            78,
            83,
            69,
            95,
            86,
            65,
            76,
            73,
            68
        ], ob = [
            78,
            69,
            87,
            95,
            83,
            69,
            83,
            83,
            73,
            79,
            78
        ], pb = [
            79,
            82,
            73,
            71,
            73,
            78,
            95,
            66,
            76,
            79,
            67,
            75,
            69,
            68
        ], qb = [
            80,
            79,
            83,
            84
        ], rb = [
            88,
            77,
            76,
            72,
            116,
            116,
            112,
            82,
            101,
            113,
            117,
            101,
            115,
            116
        ], sb = [
            95,
            95,
            99,
            110,
            108
        ], tb = [
            95,
            95,
            99,
            110,
            108,
            98
        ], ub = [
            95,
            95,
            99,
            110,
            108,
            117
        ], vb = [
            95,
            95,
            99,
            111,
            108,
            105,
            98,
            114,
            105,
            111,
            65,
            110,
            100,
            114,
            111,
            105,
            100
        ], wb = [
            97,
            100,
            100,
            69,
            118,
            101,
            110,
            116,
            76,
            105,
            115,
            116,
            101,
            110,
            101,
            114
        ], xb = [
            104,
            116,
            116,
            112,
            115,
            58,
            97,
            112,
            112,
            105,
            110,
            116,
            101,
            114,
            110,
            97,
            108,
            46,
            99,
            111,
            108,
            105,
            98,
            114,
            105,
            111,
            46,
            99,
            111,
            109
        ], yb = [
            99,
            108,
            105,
            101,
            110,
            116,
            79,
            115
        ], zb = [
            99,
            108,
            105,
            101,
            110,
            116,
            86,
            101,
            114,
            115,
            105,
            111,
            110
        ], Ab = [
            99,
            111,
            108,
            105,
            98,
            114,
            105,
            111
        ], Bb = [
            100,
            101,
            118,
            105,
            99,
            101,
            73,
            100
        ], Cb = [
            101,
            108,
            97,
            112,
            115,
            101,
            100,
            84,
            105,
            109,
            101,
            83
        ], Db = [
            101,
            110,
            100,
            68,
            97,
            116,
            101
        ], Eb = [
            104,
            111,
            115,
            116,
            110,
            97,
            109,
            101
        ], Fb = [
            99,
            111,
            109,
            46,
            99,
            111,
            108,
            105,
            98,
            114,
            105,
            111,
            58,
            97,
            112,
            112,
            105,
            110,
            116,
            101,
            114,
            110,
            97,
            108
        ], Gb = [
            105,
            110,
            99,
            108,
            117,
            100,
            101,
            86,
            97,
            108,
            105,
            100,
            97,
            116,
            105,
            111,
            110,
            68,
            97,
            116,
            97
        ], Hb = [
            106,
            115,
            111,
            110
        ], Ib = [
            108,
            105,
            99,
            101,
            110,
            115,
            101,
            65,
            112,
            105,
            75,
            101,
            121
        ], Jb = [
            108,
            105,
            99,
            101,
            110,
            115,
            101,
            65,
            112,
            105,
            83,
            101,
            99,
            114,
            101,
            116
        ], Kb = [
            108,
            105,
            99,
            101,
            110,
            115,
            101,
            66,
            108,
            111,
            99,
            107,
            101,
            100
        ], Lb = [
            108,
            105,
            99,
            101,
            110,
            115,
            101,
            73,
            100
        ], Mb = [
            104,
            116,
            116,
            112,
            115,
            58,
            47,
            47,
            108,
            105,
            99,
            101,
            110,
            115,
            101,
            46,
            99,
            111,
            108,
            105,
            98,
            114,
            105,
            111,
            46,
            99,
            111,
            109,
            47,
            97,
            112,
            105
        ], Nb = [
            108,
            111,
            97,
            100,
            101,
            110,
            100
        ], Ob = [
            108,
            111,
            99,
            97,
            116,
            105,
            111,
            110
        ], Pb = [
            109,
            97,
            120,
            79,
            102,
            102,
            108,
            105,
            110,
            101,
            68,
            97,
            121,
            115
        ], Qb = [
            109,
            101,
            115,
            115,
            97,
            103,
            101,
            72,
            97,
            110,
            100,
            108,
            101,
            114,
            115
        ], Rb = [
            109,
            105,
            110,
            82,
            101,
            97,
            100,
            68,
            117,
            114,
            97,
            116,
            105,
            111,
            110,
            83
        ], Sb = [
            111,
            112,
            101,
            110
        ], Tb = [
            112,
            114,
            111,
            116,
            111,
            99,
            111,
            108
        ], Ub = [
            112,
            117,
            98,
            108,
            105,
            99,
            97,
            116,
            105,
            111,
            110,
            73,
            100
        ], Vb = [
            112,
            117,
            98,
            108,
            105,
            99,
            97,
            116,
            105,
            111,
            110,
            83,
            105,
            103,
            110,
            97,
            116,
            117,
            114,
            101
        ], Wb = [
            112,
            117,
            98,
            108,
            105,
            99,
            97,
            116,
            105,
            111,
            110,
            84,
            121,
            112,
            101
        ], Xb = [
            63,
            100,
            97,
            116,
            97,
            61
        ], Yb = [
            114,
            101,
            97,
            100,
            101,
            114,
            73,
            100
        ], Zb = [
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            84,
            101,
            120,
            116
        ], $b = [
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            84,
            121,
            112,
            101
        ], ac = [
            114,
            101,
            115,
            112,
            111,
            110,
            115,
            101,
            86,
            97,
            114
        ], bc = [
            115,
            99,
            114,
            105,
            112,
            116
        ], cc = [
            115,
            101,
            110,
            100
        ], dc = [
            115,
            101,
            116,
            84,
            105,
            109,
            101,
            111,
            117,
            116
        ], ec = [
            47,
            108,
            105,
            99,
            101,
            110,
            115,
            101,
            45,
            99,
            104,
            101,
            99,
            107
        ], fc = [
            47,
            111,
            110,
            108,
            105,
            110,
            101,
            45,
            99,
            108,
            105,
            101,
            110,
            116,
            45,
            115,
            101,
            115,
            115,
            105,
            111,
            110
        ], gc = [
            115,
            116,
            97,
            116,
            117,
            115
        ], hc = [
            116,
            121,
            112,
            101
        ], ic = [
            119,
            101,
            98,
            107,
            105,
            116
        ], jc = String.fromCharCode.apply(String, m.Ua([
            102,
            114,
            111,
            109,
            67,
            104,
            97,
            114,
            67,
            111,
            100,
            101
        ])), gb = String[jc];
        function kc(a, b, c) {
            var d = this;
            this.B = a;
            this.l = b;
            this.D = c;
            this.v = !1;
            this.C = 0;
            this.j = 5E3;
            this.h = 0;
            this.g = null;
            this.o = K(Hb);
            this.u = ta.Random.getRandomString(16, !0);
            this.s = Date.now();
            this.i = window;
            this.F = function(e) {
                e = e.target;
                switch(lc(e[K(gc)])){
                    case 1600:
                        try {
                            mc(d, e[K(Zb)]);
                        } catch (f) {}
                        break;
                    default:
                        3 > d.h ? nc(d) : d.o === K(Hb) && (oc(d, K(bc)), pc(d));
                }
            };
            this.l[K(ac)] = this.u;
            oc(this, K(Hb));
        }
        kc.prototype.destroy = function() {
            this.g = null;
        };
        function qc(a) {
            if (a.v) return Promise.reject();
            a.v = !0;
            return new Promise(function(b) {
                a.g = b;
                pc(a);
            });
        }
        function nc(a) {
            var b = Date.now();
            a.s || (a.s = b);
            a.D();
            a.j *= 1.7 + .3 * Math.random();
            a.C = b - a.s + a.j;
            b = a.C - (b - a.s);
            a.i[K(dc)](function() {
                pc(a);
            }, b);
        }
        function mc(a, b) {
            var c = null;
            try {
                var d = a.i[K(lb)], e = d.parse;
                b = b.replace(/-/g, "+");
                b = b.replace(/_/g, "/");
                var f = p.Base64.decode(b);
                b = 203;
                for(var g = new Uint8Array(f.length - 1), h = 0; h < g.length; h++)g[h] = f[h + 1] ^ f[h] ^ b++;
                f = g;
                var l = (new TextDecoder).decode(f);
                c = e.call(d, l);
            } catch (r) {
                if (a.o === K(Hb)) {
                    oc(a, K(bc));
                    pc(a);
                    return;
                }
            }
            a.g && (a.g(c), a.g = null);
        }
        function pc(a) {
            if (3 > a.h && a.g) switch(a.o){
                case K(Hb):
                    a.h++;
                    var b = K(rb);
                    b = new a.i[b];
                    var c = "2:" + hb(JSON.stringify(a.l));
                    b[K(wb)](K(Nb), a.F);
                    b[K(Sb)](K(qb), a.B, !0);
                    b.timeout = 15E3;
                    b[K(cc)](c);
                    break;
                case K(bc):
                    a.h++, rc(a);
            }
            else a.g && (a.g(null), a.g = null);
        }
        function lc(a) {
            return 8 * a;
        }
        function rc(a) {
            function b() {
                c();
                nc(a);
            }
            function c() {
                clearTimeout(e);
                d.onload = null;
                d.onerror = null;
                d.onabort = null;
                document.body.removeChild(d);
            }
            var d = document.createElement(K(bc));
            d.onload = function() {
                c();
                var g = a.i[a.u];
                delete a.i[a.u];
                mc(a, g);
            };
            d.onerror = b;
            d.onabort = b;
            var e = setTimeout(d.onerror, 15E3), f = "2:" + hb(JSON.stringify(a.l));
            d.src = a.B + K(Xb) + f;
            document.body.appendChild(d);
        }
        function oc(a, b) {
            a.o = b;
            a.l[K($b)] = b;
            a.h = 0;
            a.j = 5E3;
        }
        function sc() {
            return [
                "appinternal.colibrio.com",
                "appinternal"
            ];
        }
        var tc = K([
            99,
            111,
            108,
            105,
            98,
            114,
            105,
            111,
            45,
            108,
            105,
            99,
            101,
            110,
            115,
            101,
            45,
            100,
            97,
            116,
            97
        ]);
        function uc(a, b, c, d, e, f) {
            var g = this;
            this.u = a;
            this.o = b;
            this.F = c;
            this.L = d;
            this.C = e;
            this.D = f;
            this.h = [];
            this.v = this.B = this.i = !1;
            this.j = null;
            this.l = 60;
            this.g = null;
            this.s = new $a(!1);
            this.va = 0;
            this.H = function() {
                vc(g, 11, 11);
            };
        }
        function wc(a) {
            return new Date(Date.now() + 864E5 * a);
        }
        function eb() {
            var a = window[K(Ob)][K(Eb)];
            return sc().includes(a) ? "" : a;
        }
        function xc(a) {
            try {
                return window.localStorage ? window.localStorage.getItem(tc + a) : null;
            } catch (b) {
                return null;
            }
        }
        function yc(a, b) {
            try {
                window.localStorage && window.localStorage.setItem(tc + a, b);
            } catch (c) {}
        }
        function zc(a, b) {
            if (null !== b) {
                var c = new ta.Sha256;
                c.append(a + b);
                return c.digestToHex();
            }
            p.Logger.logWarning("Trying to obfuscate without license id");
            return "";
        }
        function Ac(a) {
            try {
                var b = p.Base64.decode(a), c = new DataView(b.buffer), d = c.getUint16(0), e = c.getUint16(2);
                a = 4 + d;
                e = a + e;
                var f = new Int32Array(b.buffer.slice(4, a)), g = new Int32Array(b.buffer.slice(a, e)), h = b.buffer.slice(e), l = db(), r = new cb.misc.hmac(l), q = h.slice(0), v = cb.arrayBuffer.ccm.decrypt(r, q, f, g), u = new DataView(v).getUint32(0), w = v.slice(16, 16 + u);
                var E = (new TextDecoder).decode(w);
                var z = JSON.parse(E);
            } catch (N) {
                return p.Logger.logError(N), null;
            }
            b = z[K(Db)];
            z = z[K(Kb)];
            return Ha(b) && "boolean" === typeof z && (b = new Date(b), C(b.getTime())) ? (f = {}, f[K(Db)] = b, f[K(Kb)] = z, f) : null;
        }
        function Cc(a) {
            if (0 === a.va) {
                a.va = 1;
                var b = new kc(K(Mb) + K(ec), Dc(a), a.H);
                a.h.push(b);
                qc(b).then(function(d) {
                    a.i = null !== d ? d[K(Gb)] : void 0;
                    a.j = null !== d ? d[K(Lb)] : void 0;
                    if (null !== d) {
                        var e = d[K(hc)], f = d[K(Rb)];
                        d = d[K(Pb)];
                        C(d) || (d = 60);
                        e === K(nb) && (C(f) && (a.l = f), Ec(a, wc(d), !1));
                    }
                    a.va = 2;
                }).finally(function() {
                    Fc(a, b);
                }).catch(function(d) {
                    return p.Logger.logError(d || "Invalid call to SR1");
                });
            } else if (2 === a.va && a.g && Date.now() - a.g > 1E3 * a.l) {
                a.va = 3;
                var c = new kc(K(Mb) + K(fc), Gc(a), a.H);
                qc(c).then(function(d) {
                    a.i = null !== d ? d[K(Gb)] : void 0;
                    a.j = null !== d ? d[K(Lb)] : void 0;
                    if (null === d) Hc(a);
                    else {
                        var e = Date.now(), f = d[K(Rb)];
                        C(f) || (f = 60);
                        if (e - a.g < f) a.l = f, a.va = 2;
                        else {
                            e = d[K(hc)];
                            d = d[K(Pb)];
                            C(d) || (d = 60);
                            d = wc(d);
                            switch(e){
                                case K(ob):
                                    e = 8;
                                    break;
                                case K(ib):
                                    e = 1;
                                    break;
                                case K(jb):
                                    e = 2;
                                    break;
                                case K(kb):
                                    e = 3;
                                    break;
                                case K(mb):
                                    e = 4;
                                    break;
                                case K(pb):
                                    e = 10;
                                    break;
                                default:
                                    e = null;
                            }
                            null !== e && ([
                                3,
                                2,
                                4,
                                6,
                                10
                            ].includes(e) ? (Ec(a, wc(30), !0), Hc(a, e)) : (Ec(a, d, !1), vc(a, e, e)));
                        }
                    }
                }).finally(function() {
                    Fc(a, c);
                }).catch(function(d) {
                    return p.Logger.logError(d || "Invalid call to SR2");
                });
            }
            !a.g && a.B && (a.g = Date.now());
            a.B = !0;
        }
        uc.prototype.destroy = function() {
            this.s.clear();
            this.h.forEach(function(a) {
                return a.destroy();
            });
        };
        function Dc(a) {
            var b = {};
            return b[K(Ib)] = a.u, b[K(Jb)] = a.C, b[K(Eb)] = eb(), b[K(zb)] = "4.7.0", b[K(yb)] = p.BrowserDetector.getOsName(), b;
        }
        function Gc(a) {
            var b = Date.now(), c = a.g || b, d = p.BrowserDetector.getOsName(), e = zc(a.F, a.j), f, g = null != (f = a.D) ? f : e;
            e = a.i ? e : void 0;
            a.i ? (f = xc(Bb.join()), null === f && (f = ta.Random.getRandomString(32, !0), yc(Bb.join(), f))) : f = void 0;
            var h = {};
            return h[K(Cb)] = Math.floor((b - c) / 1E3), h[K(Ib)] = a.u, h[K(Jb)] = a.C, h[K(Eb)] = eb(), h[K(Ub)] = g, h[K(Yb)] = a.o, h[K(Vb)] = e, h[K(Wb)] = a.L, h[K(Bb)] = f, h[K(zb)] = "4.7.0", h[K(yb)] = d, h;
        }
        function vc(a, b, c) {
            var d = zc(a.F, a.j), e, f = null != (e = a.D) ? e : d;
            ab(a.s, {
                da: b,
                ce: f,
                ee: a.o,
                Hc: c,
                Ic: a.v
            }, function(g) {
                p.ColibrioError.isColibrioAbortedError(g) || p.Logger.logError(g);
            });
        }
        function Ic(a) {
            a = new Int32Array(cb.hash.sha256.hash(a.o));
            return p.Base64.encode(new Uint8Array(a.buffer));
        }
        function Fc(a, b) {
            var c = a.h.indexOf(b);
            -1 !== c && (b.destroy(), a.h.splice(c, 1));
        }
        function Ec(a, b, c) {
            if (c) {
                var d = xc(Ic(a));
                if (d && (d = Ac(d)) && d[K(Kb)]) return;
            }
            try {
                d = {};
                var e = (d[K(Db)] = b, d[K(Kb)] = c, d), f = JSON.stringify(e), g = db(), h = new Uint8Array(16);
                if (window.crypto) crypto.getRandomValues(h);
                else for(b = 0; b < h.byteLength; b += 1)h[b] = 256 * Math.random() | 0;
                var l = new Int32Array(h.buffer);
                var r = new cb.misc.hmac(g), q = (new TextEncoder).encode(f), v = new Uint8Array(16 + q.byteLength + (16 - q.byteLength % 16));
                new DataView(v.buffer, 0).setUint32(0, q.byteLength);
                v.set(q, 16);
                var u = cb.arrayBuffer.ccm.encrypt(r, v.buffer, l);
                var w = u.ciphertext_buffer;
                var E = u.tag;
                var z = new Uint8Array(w), N = new Int32Array(E), H = new Uint8Array(4 + l.byteLength + N.byteLength + z.byteLength), A = new DataView(H.buffer);
                A.setUint16(0, l.byteLength);
                A.setUint16(2, N.byteLength);
                H.set(new Uint8Array(l.buffer), 4);
                var J = 4 + l.byteLength;
                H.set(new Uint8Array(N.buffer), J);
                H.set(z, J + N.byteLength);
                var L = p.Base64.encode(H);
                yc(Ic(a), L);
            } catch (U) {
                p.Logger.logError(U);
            }
        }
        function Hc(a, b) {
            var c = null, d = xc(Ic(a));
            d && (c = Ac(d));
            d = new Date;
            c ? c[K(Kb)] ? (c[K(Db)] < d && (a.v = !0), vc(a, 6, b)) : c[K(Db)] >= d ? vc(a, 9, b) : (Ec(a, wc(30), !0), vc(a, 6, b)) : (Ec(a, wc(30), !0), vc(a, 6, b));
        }
        function Jc(a, b, c) {
            var d = this;
            this.l = a;
            this.j = b;
            this.s = c;
            this.g = new $a(!0);
            this.h = this.A = !1;
            this.i = new Map;
            this.o = function(e) {
                if (!d.A) {
                    e.Ic !== d.h && (d.h = e.Ic, ab(d.g, d.h, function(l) {
                        p.ColibrioError.isColibrioAbortedError(l) || p.Logger.logError(l);
                    }));
                    var f = [];
                    switch(e.da){
                        case 1:
                            var g = "licenseReadingSessionContinued";
                            break;
                        case 8:
                            g = "licenseReadingSessionStarted";
                            break;
                        case 9:
                            g = "licenseReadingSessionOffline";
                            break;
                        case 11:
                            g = "licenseReadingSessionPending";
                            break;
                        default:
                            g = "licenseReadingSessionBlocked";
                    }
                    switch(e.Hc){
                        case 10:
                            f.push("Origin blocked.");
                            break;
                        case 4:
                            f.push("License deactivated.");
                            break;
                        case 2:
                            f.push("Invalid API key.");
                            break;
                        case 3:
                            f.push("Invalid API secret.");
                            break;
                        case void 0:
                            f.push("Failed to contact license server.");
                    }
                    6 === e.da && f.push("Offline license expired.");
                    e.Ic && f.push("Framework usage blocked.");
                    f = f.join(" ");
                    var h = new bb(g, {
                        cancelable: !1,
                        isTrusted: !1,
                        publicationToken: e.ce,
                        readerView: null,
                        reason: f,
                        userToken: e.ee
                    });
                    d.l.getEventBus().emitAsync(h);
                    ("licenseReadingSessionBlocked" === g || "licenseReadingSessionOffline" === g && e.Hc && [
                        3,
                        2,
                        4,
                        6,
                        10
                    ].includes(e.Hc)) && p.Logger.logError(new D("LICENSE_READING_SESSION_BLOCKED", f));
                }
            };
        }
        function Kc(a) {
            a.A = !0;
            a.g.clear();
        }
        function Lc(a, b) {
            var c = a.i.get(b);
            c && (c.destroy(), a.i.delete(b));
        }
        function Mc(a) {
            var b = window;
            Ja(b[K(tb)]) && (b[K(tb)] = function() {
                a.h = !0;
                ab(a.g, !0, function(c) {
                    p.ColibrioError.isColibrioAbortedError(c) || p.Logger.logError(c);
                });
            }, b[K(ub)] = function() {
                a.h = !1;
                ab(a.g, !1, function(c) {
                    p.ColibrioError.isColibrioAbortedError(c) || p.Logger.logError(c);
                });
            });
        }
        function Nc() {}
        Nc.prototype.handleEngineEvent = function(a) {
            switch(a.type){
                case "navigationIntent":
                    Oc(a);
            }
        };
        function Oc(a) {
            a.internalNavigation && a.readerView.goTo(a.locator).catch(function(b) {
                p.ColibrioError.isColibrioAbortedError(b) || p.Logger.logError(b);
            });
        }
        function Pc(a) {
            this.g = a;
            this.h = new Nc;
        }
        Pc.prototype.emit = function(a) {
            var b = this.g.s.get(a.type);
            Qc(a, b);
            !Rc(a.syncMediaPlayer) || a.immediatePropagationStopped || a.propagationStopped || Qc(a, a.syncMediaPlayer.getEngineEventListeners(a.type));
            !Rc(a.annotationLayer) || a.immediatePropagationStopped || a.propagationStopped || Qc(a, a.annotationLayer.getEngineEventListeners(a.type));
            !Rc(a.readerView) || a.immediatePropagationStopped || a.propagationStopped || Qc(a, a.readerView.getEngineEventListeners(a.type));
            a.immediatePropagationStopped || a.propagationStopped || Qc(a, this.g.getEngineEventListeners(a.type));
            a.immediatePropagationStopped || a.propagationStopped || a.defaultPrevented || this.h.handleEngineEvent(a);
        };
        Pc.prototype.emitAsync = function(a) {
            var b = this;
            Promise.resolve().then(function() {
                return b.emit(a);
            }).catch(function(c) {
                p.ColibrioError.isColibrioAbortedError(c) && p.Logger.logError(c);
            });
        };
        function Qc(a, b) {
            for(var c = 0; c < b.length && !a.immediatePropagationStopped; c++){
                var d = b[c];
                try {
                    B(d) ? d(a) : B(d.handleEngineEvent) && d.handleEngineEvent(a);
                } catch (e) {
                    p.Logger.logError(e);
                }
            }
        }
        function Rc(a) {
            return Oa(a) && B(a.getEngineEventListeners);
        }
        function Sc() {
            this.g = new Map;
        }
        Sc.prototype.add = function(a, b) {
            var c = this.g.get(a);
            c || (c = [], this.g.set(a, c));
            c.push(b);
        };
        Sc.prototype.clear = function() {
            this.g.clear();
        };
        Sc.prototype.get = function(a) {
            return this.g.get(a) || [];
        };
        Sc.prototype.remove = function(a, b) {
            var c = this.g.get(a);
            c && (b = c.indexOf(b), -1 !== b && c.splice(b, 1), 0 === c.length && this.g.delete(a));
        };
        function Tc(a, b) {
            this.$ = a;
            this.i = b;
            this.g = [];
            this.h = null;
        }
        function Uc(a) {
            return new m.qb(function c() {
                var d, e, f, g, h, l, r;
                return m.ta.Sb(c, function(q) {
                    switch(q.g){
                        case 1:
                            return n(q, new m.Na(m.Ga.wb, Vc(a, 0)), 2);
                        case 2:
                            d = q.h, null === a.h && (a.h = a.i.search(a.$)), ca(q, 3, 4), h = m.Dc(a.h);
                        case 6:
                            return n(q, new m.Na(m.Ga.Hb, h.next()), 9);
                        case 9:
                            f = q.h;
                            if (f.done) {
                                q.J(4);
                                break;
                            }
                            l = f.value;
                            a.g.push(l);
                            return n(q, new m.Na(m.Ga.wb, Vc(a, d)), 10);
                        case 10:
                            d = q.h;
                            q.J(6);
                            break;
                        case 4:
                            ea(q);
                            q.j = 0;
                            q.l = 11;
                            if (!f || f.done || !(g = h.return)) {
                                q.J(11);
                                break;
                            }
                            return n(q, new m.Na(m.Ga.Hb, g.call(h)), 11);
                        case 11:
                            ea(q, 0, 0, 1);
                            if (e) throw e.error;
                            fa(q, 12, 1);
                            break;
                        case 12:
                            fa(q, 5);
                            break;
                        case 3:
                            r = da(q);
                            e = {
                                error: r
                            };
                            q.J(4);
                            break;
                        case 5:
                            return n(q, new m.Na(m.Ga.wb, Vc(a, d)), 0);
                    }
                });
            }());
        }
        var Vc = function Wc(a, b) {
            return m.ta.Sb(Wc, function(d) {
                return 1 == d.g ? b < a.g.length ? n(d, a.g[b++], 1) : d.J(4) : d.return(b);
            });
        };
        function Xc(a) {
            this.g = a;
        }
        Xc.prototype[Symbol.asyncIterator] = function() {
            return this.g;
        };
        Xc.prototype.next = function() {
            return this.g.next();
        };
        Xc.prototype.take = function(a) {
            var b = this, c, d;
            return m.ea(function(e) {
                if (1 == e.g) return c = Array.from({
                    length: a
                }, function() {
                    return b.g.next();
                }), n(e, Promise.all(c), 2);
                d = e.h;
                return e.return(d.filter(function(f) {
                    return !f.done;
                }).map(function(f) {
                    return f.value;
                }));
            });
        };
        Xc.prototype.takeRemaining = function() {
            var a = this, b, c, d, e, f, g, h;
            return m.ea(function(l) {
                switch(l.g){
                    case 1:
                        b = [], ca(l, 2, 3), f = m.Dc(a.g);
                    case 5:
                        return n(l, f.next(), 8);
                    case 8:
                        d = l.h;
                        if (d.done) {
                            l.J(3);
                            break;
                        }
                        g = d.value;
                        b.push(g);
                        l.J(5);
                        break;
                    case 3:
                        ea(l);
                        l.j = 0;
                        l.l = 9;
                        if (!d || d.done || !(e = f.return)) {
                            l.J(9);
                            break;
                        }
                        return n(l, e.call(f), 9);
                    case 9:
                        ea(l, 0, 0, 1);
                        if (c) throw c.error;
                        fa(l, 10, 1);
                        break;
                    case 10:
                        fa(l, 4);
                        break;
                    case 2:
                        h = da(l);
                        c = {
                            error: h
                        };
                        l.J(3);
                        break;
                    case 4:
                        return l.return(b);
                }
            });
        };
        function Yc(a) {
            this.h = a;
            this.g = new Map;
        }
        Yc.prototype.execute = function(a) {
            return new Xc(Zc(this, a));
        };
        function Zc(a, b) {
            return new m.qb(function d() {
                var e, f, g, h;
                return m.ta.Sb(d, function(l) {
                    1 == l.g && (e = m.ya(b), f = e.next());
                    if (3 != l.g) {
                        if (f.done) return l.J(0);
                        g = f.value;
                        h = a.g.get(g);
                        h || (h = new Tc(g, a.h), a.g.set(g, h));
                        return n(l, new m.Na(m.Ga.wb, Uc(h)), 3);
                    }
                    f = e.next();
                    return l.J(2);
                });
            }());
        }
        function $c(a, b, c) {
            var d = this;
            this.B = a;
            this.o = b;
            this.i = c;
            this.g = new Map;
            this.j = new Map;
            this.l = new Map;
            this.C = function(e) {
                var f = d.o.createAnnotation(e.contentLocation), g = d.l.get(e);
                g && f.setOptions(g);
                return [
                    f,
                    e
                ];
            };
            this.D = function(e) {
                return e.map(d.C);
            };
            this.F = function() {
                d.h.getReaderDocumentsLoadedForRendering().forEach(function(e) {
                    return ad(d, e);
                });
            };
            this.s = function(e) {
                return d.i.scheduleTask(function() {
                    return ad(d, e.readerDocument);
                }, 1);
            };
            this.u = function(e) {
                return d.i.scheduleTask(function() {
                    d.H(e.readerDocument);
                    return Promise.resolve();
                }, 1);
            };
            this.v = function(e) {
                return null == e ? void 0 : e.forEach(function(f) {
                    return d.o.destroyAnnotation(f);
                });
            };
            this.H = function(e) {
                e = e.getIndexInSpine();
                var f = d.j.get(e);
                bd(d, e);
                d.v(f);
            };
            this.h = b.getReaderView();
            this.h.addEngineEventListener("readerDocumentLoaded", this.s);
            this.h.addEngineEventListener("readerDocumentUnloaded", this.u);
            this.F();
        }
        $c.prototype.clearAllSearchResultItemAnnotationOptions = function() {
            this.l.clear();
        };
        $c.prototype.destroy = function() {
            var a = this;
            this.h.removeEngineEventListener("readerDocumentLoaded", this.s);
            this.h.removeEngineEventListener("readerDocumentUnloaded", this.u);
            this.j.forEach(function(b) {
                return a.v(b);
            });
            this.j.clear();
            this.g.clear();
            this.i.destroy(new D(p.ColibrioErrorType.ABORTED));
        };
        $c.prototype.setSearchResultItemAnnotationOptions = function(a, b) {
            var c = this;
            cd(this, a, b);
            a.forEach(function(d) {
                return c.l.set(d, b);
            });
        };
        function cd(a, b, c) {
            a.g.forEach(function(d, e) {
                -1 < b.indexOf(d) && e.setOptions(c);
            });
        }
        function bd(a, b) {
            a.g.forEach(function(c, d) {
                c.readerDocumentIndexInSpine === b && a.g.delete(d);
            });
        }
        function ad(a, b) {
            function c(d) {
                a.j.set(b.getIndexInSpine(), d.map(function(e) {
                    e = m.ya(e);
                    var f = e.next().value;
                    e.next();
                    return f;
                }));
                d.forEach(function(e) {
                    var f = m.ya(e);
                    e = f.next().value;
                    f = f.next().value;
                    return a.g.set(e, f);
                });
            }
            return a.B.execute([
                b
            ]).takeRemaining().then(function(d) {
                a.i.isDestroyed() || (d = a.D(d), c(d));
            }).catch(function(d) {
                p.ColibrioError.isColibrioAbortedError(d) ? p.Logger.logError("Failed to create search highlights", d) : p.Logger.logError(d);
            });
        }
        function dd(a) {
            this.h = a;
            this.g = void 0;
        }
        dd.prototype.clearAllSearchResultItemAnnotationOptions = function() {
            var a;
            null == (a = this.g) || a.clearAllSearchResultItemAnnotationOptions();
            this.h.getAnnotations().forEach(function(b) {
                return b.setOptions(null);
            });
        };
        dd.prototype.getSearchResultItemByAnnotation = function(a) {
            var b;
            return null == (b = this.g) ? void 0 : b.g.get(a);
        };
        dd.prototype.setSearchQuery = function(a) {
            var b;
            null == (b = this.g) || b.destroy();
            a ? (b = new p.AsyncTaskQueue(1, null), this.g = new $c(a, this.h, b)) : this.g = void 0;
        };
        dd.prototype.setSearchResultItemAnnotationOptions = function(a, b) {
            var c;
            null == (c = this.g) || c.setSearchResultItemAnnotationOptions(a, b);
        };
        function ed(a) {
            return a.normalize("NFKD").replace(/(?:[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B55\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0D81\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF])+/gu, "");
        }
        function fd(a, b) {
            a = a.replace(/\s+/g, "").split("").map(function(c) {
                return c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }).join("\\s*");
            b = gd(b);
            return a ? new RegExp(a, b) : null;
        }
        function gd(a) {
            var b = "gu";
            a.ignoreCase && (b += "i");
            return b;
        }
        function hd(a, b) {
            this.h = a;
            this.g = y(b, {
                ignoreCase: !0,
                ignoreDiacritics: !1,
                searchResultOptions: {
                    expandMode: x.TextSearchResultExpandMode.EXPAND_TO_WORD_BOUNDARY,
                    includeContentBlocks: !1,
                    numberOfCharactersAfter: 40,
                    numberOfCharactersBefore: 40
                },
                whitespaceMode: x.TextSearchQueryWhitespaceMode.COLLAPSE
            });
        }
        hd.prototype.search = function(a) {
            var b = this;
            return new m.qb(function d() {
                var e, f, g, h, l, r, q, v, u, w, E, z, N;
                return m.ta.Sb(d, function(H) {
                    switch(H.g){
                        case 1:
                            a: {
                                var A = b.h;
                                var J = b.g;
                                J.ignoreDiacritics && (A = ed(A));
                                switch(J.whitespaceMode){
                                    case x.TextSearchQueryWhitespaceMode.IGNORE:
                                        J = fd(A, J);
                                        break a;
                                    case x.TextSearchQueryWhitespaceMode.COLLAPSE:
                                        A = A.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/\s+/g, "\\s+");
                                        J = gd(J);
                                        J = A ? new RegExp(A, J) : null;
                                        break a;
                                }
                                J = void 0;
                            }
                            h = J;
                            if (!h) return H.return(new m.Na(m.Ga.Kb));
                            l = null;
                            ca(H, 2);
                            return n(H, new m.Na(m.Ga.Hb, a.fetchContentBlockTree()), 4);
                        case 4:
                            r = H.h;
                            J = [];
                            A = [];
                            for(var L = [], U = 0, F = new p.TreeNodeWalker(r.getContentBlocks()); F.hasNext();){
                                var I = F.next();
                                I.getBlockClass() === x.ContentBlockClass.TEXT && (J.push(I), A.push(U), I = I.getTextContent(), L.push(I), U += I.length + 1);
                            }
                            q = {
                                contentBlocks: J,
                                Rd: A,
                                text: L.join(" ")
                            };
                            v = q.text;
                            b.g.ignoreDiacritics && (v = ed(q.text));
                        case 5:
                            if (!(u = h.exec(v))) {
                                H.g = 0;
                                H.j = 0;
                                break;
                            }
                            w = u.index;
                            E = h.lastIndex;
                            if (!C(w)) {
                                H.J(5);
                                break;
                            }
                            if (b.g.ignoreDiacritics) {
                                J = q.text;
                                L = w;
                                U = E;
                                (F = l) || (F = {
                                    ib: 0,
                                    pb: 0
                                });
                                A = {
                                    ib: F.ib,
                                    pb: F.pb
                                };
                                L -= F.ib - F.pb;
                                U -= F.ib - F.pb;
                                for(F = F.pb; F < J.length; F++)if (I = ed(J[F]), F + I.length > L) {
                                    L = F;
                                    break;
                                } else L -= I.length - 1, U -= I.length - 1, A.ib += I.length, A.pb++;
                                for(F = L; F < J.length; F++)if (I = ed(J[F]), F + I.length + 1 > U) {
                                    U = F + 1;
                                    break;
                                } else U -= I.length - 1, A.ib += I.length, A.pb++;
                                e = A;
                                f = U;
                                g = L;
                                l = e;
                                w = g;
                                E = f;
                            }
                            J = m.Na;
                            A = m.Ga.Kb;
                            F = q;
                            L = w;
                            U = E;
                            var Ga = F.contentBlocks;
                            I = F.Rd;
                            F = F.text;
                            var S = id(I, L);
                            var Y = Ga[S], ma = id(I, U), fb = Ga[ma], ge = L - I[S], Bc = U - I[ma];
                            S === ma ? fb = Y.getContentLocation(ge, Bc - ge) : (Y = Y.getContentLocation(ge, 0), fb = fb.getContentLocation(Bc, 0), fb = Y.createRangeTo(fb));
                            Ga = b.g.searchResultOptions.includeContentBlocks ? Ga.slice(S, ma + 1) : void 0;
                            ma = b.g.searchResultOptions;
                            S = L - ma.numberOfCharactersBefore;
                            Y = U + ma.numberOfCharactersAfter;
                            switch(ma.expandMode){
                                case x.TextSearchResultExpandMode.EXPAND_TO_WORD_BOUNDARY:
                                    I = S;
                                    for(S = Y; 0 <= I; I--)if (Da(F.charCodeAt(I))) {
                                        I++;
                                        break;
                                    }
                                    for(; S < F.length && !Da(F.charCodeAt(S)); S++);
                                    I = m.ya([
                                        I,
                                        S
                                    ]);
                                    S = I.next().value;
                                    Y = I.next().value;
                                    break;
                                case x.TextSearchResultExpandMode.EXPAND_TO_CONTENT_BLOCK_BOUNDARY:
                                    ma = m, Bc = ma.ya, Y = id(I, Y), S = id(I, S), Y = Y < I.length ? I[Y + 1] - 1 : F.length, S = 0 < S ? I[S] : 0, I = Bc.call(ma, [
                                        S,
                                        Y
                                    ]), S = I.next().value, Y = I.next().value;
                            }
                            I = F.substring(U, Y);
                            S = F.substring(S, L);
                            L = new x.SearchResultItem({
                                contentBlocks: Ga,
                                contentLocation: fb,
                                matchingText: F.slice(L, U),
                                readerDocumentIndexInSpine: a.getIndexInSpine(),
                                textAfter: I,
                                textBefore: S
                            });
                            return n(H, new J(A, L), 5);
                        case 2:
                            z = da(H), p.Logger.logError(z), N = "Failed to search in ReaderDocument with indexInSpine=" + a.getIndexInSpine() + ": " + a.getSourceContentDocument().getContentUrl(), p.Logger.logError(new D("READER_DOCUMENT_SEARCH_ERROR", N)), H.g = 0;
                    }
                });
            }());
        };
        function id(a, b) {
            return Aa(a, 1, a.length, function(c, d) {
                return b - c[d];
            });
        }
        function jd() {
            var a = this;
            this.g = [];
            this.h = function() {
                a.g.forEach(a.destroyReaderViewSearchAgent);
            };
            this.destroyReaderViewSearchAgent = function(b) {
                var c = a.g.indexOf(b);
                if (-1 < c) {
                    var d;
                    null == (d = b.g) || d.destroy();
                    a.g.splice(c, 1);
                }
            };
        }
        jd.prototype.createCustomQuery = function(a) {
            return new Yc(a);
        };
        jd.prototype.createReaderViewSearchAgent = function(a) {
            a = new dd(a);
            this.g.push(a);
            return a;
        };
        jd.prototype.createTextQuery = function(a, b) {
            a = new hd(a, b);
            return new Yc(a);
        };
        function kd(a) {
            var b = ld(), c = this;
            this.s = a;
            this.g = [];
            this.A = this.l = !1;
            this.i = p.BrowserDetector.isRenderingEngine("EdgeHTML");
            this.o = !1;
            this.j = 1;
            this.h = function() {
                c.s && md(c, c.j);
                if (!c.o) {
                    c.o = !0;
                    for(var d = m.ya(c.g), e = d.next(); !e.done; e = d.next())e.value.load();
                }
                window.removeEventListener("pointerdown", c.h, !0);
                window.removeEventListener("touchstart", c.h, !0);
            };
            this.i || (this.j = b.audioElementPoolSize, this.s || md(this, this.j), window.addEventListener("pointerdown", this.h, !0), window.addEventListener("touchstart", this.h, !0));
        }
        function nd(a) {
            var b = a.g.pop();
            if (!b || a.i) b = document.createElement("audio");
            return b;
        }
        kd.prototype.destroy = function() {
            this.A || (this.A = !0, window.removeEventListener("pointerdown", this.h, !0), window.removeEventListener("touchstart", this.h, !0), this.g = []);
        };
        function od(a, b) {
            a.i || (b.pause(), b.src = "", b.currentTime = 0, b.playbackRate = 1, b.volume = 1, b.muted = !1, a.A || a.g.includes(b) || a.g.push(b));
        }
        function md(a, b) {
            if (!a.l) {
                a.l = !0;
                for(var c = 0; c < b; c++)a.g.push(document.createElement("audio"));
            }
        }
        function M(a, b, c) {
            this.h = a;
            this.U = b;
            a = a.getSegments().length;
            b >= a ? (this.U = a, this.g = 0) : this.g = 0 > b ? this.U = 0 : Math.round(Math.max(c, 0));
        }
        k = M.prototype;
        k.compareTo = function(a) {
            if (this.h !== a.getTimeline()) throw new D("INVALID_SYNC_MEDIA_TIMELINE_POSITION", "Trying to compare timeline positions from different timelines.");
            return this.U < a.getSegmentIndex() ? -1 : this.U > a.getSegmentIndex() ? 1 : this.g - a.getOffsetWithinSegmentMs();
        };
        k.equals = function(a) {
            return this.h === a.getTimeline() && this.U === a.getSegmentIndex() && this.getOffsetWithinSegmentMs() === a.getOffsetWithinSegmentMs();
        };
        k.getOffsetWithinSegmentMs = function() {
            return this.g;
        };
        k.getSegment = function() {
            var a = this.h.getSegments();
            return this.U < a.length ? a[this.U] : null;
        };
        k.getSegmentIndex = function() {
            return this.U;
        };
        k.getTimeline = function() {
            return this.h;
        };
        k.isAfter = function(a) {
            if (this.h !== a.getTimeline()) throw new D("INVALID_SYNC_MEDIA_TIMELINE_POSITION", "Trying to compare timeline positions from different timelines.");
            return this.U > a.getSegmentIndex() ? !0 : this.U < a.getSegmentIndex() ? !1 : this.g > a.getOffsetWithinSegmentMs();
        };
        k.isBefore = function(a) {
            if (this.h !== a.getTimeline()) throw new D("INVALID_SYNC_MEDIA_TIMELINE_POSITION", "Trying to compare timeline positions from different timelines.");
            return this.U < a.getSegmentIndex() ? !0 : this.U > a.getSegmentIndex() ? !1 : this.g < a.getOffsetWithinSegmentMs();
        };
        k.toJSON = function() {
            return {
                offsetWithinSegmentMs: this.g,
                segmentIndex: this.U
            };
        };
        k.toString = function() {
            return "SyncMediaTimelinePosition - segmentIndex: " + this.U + ", offsetMs: " + this.g;
        };
        M.createFromData = pd;
        function pd(a, b) {
            return new M(b, a.segmentIndex, a.offsetWithinSegmentMs);
        }
        function qd(a, b, c, d) {
            var e = c = Ka(c, 0, a.length - 1), f = c, g = a[c].getApproximateDurationMs() - d, h = d;
            for(d = e - 1; h < b.preloadBehindMs && 0 <= d;){
                var l = a[d];
                e = d;
                h += Math.max(l.getApproximateDurationMs(), rd);
                d--;
            }
            for(d = c + 1; g < b.preloadAheadMs && d < a.length;)c = a[d], f = d, g += Math.max(c.getApproximateDurationMs(), rd), d++;
            return [
                e,
                f + 1
            ];
        }
        var rd = 1E3;
        function sd(a, b, c) {
            var d = [];
            d = void 0 === d ? [] : d;
            this.i = a;
            this.j = b;
            this.l = c;
            this.g = d;
            this.h = "";
        }
        sd.prototype.compareTo = function(a) {
            var b = this.i - a.i;
            if (0 !== b) return b;
            b = this.j - a.j;
            if (0 !== b) return b;
            b = this.l - a.l;
            if (0 !== b) return b;
            b = this.g.length;
            var c = a.g.length;
            if (0 === b && 0 < c) return 1;
            if (0 < b && 0 === c) return -1;
            for(var d = Math.min(b, c), e = 0; e < d; e++){
                var f = this.g[e], g = a.g[e], h = C(f), l = C(g);
                if (h && !l) return -1;
                if (!h && l) return 1;
                if (f < g) return -1;
                if (f > g) return 1;
            }
            return b - c;
        };
        sd.prototype.toString = function() {
            return this.i + "." + this.j + "." + this.l + (0 < this.g.length ? "-" + this.g.join(".") : "") + (this.h ? "+" + this.h : "");
        };
        function td(a, b, c, d) {
            this.h = a;
            this.B = b;
            this.g = c;
            this.C = d;
            this.A = !1;
            this.l = this.j = null;
            this.v = this.o = !1;
            this.i = this.s = null;
            this.u = 0;
            this.g.addEventListener("updateend", this);
            this.h.addEventListener("seeking", this);
            this.h.addEventListener("timeupdate", this);
            "sequence" !== this.g.mode && (this.g.mode = "sequence");
            ud(this);
        }
        td.prototype.destroy = function() {
            this.A || (this.A = !0, this.h.removeEventListener("timeupdate", this), this.h.removeEventListener("seeking", this), this.h.removeEventListener("updateend", this));
        };
        td.prototype.handleEvent = function(a) {
            switch(a.type){
                case "seeking":
                    vd(this);
                    break;
                case "timeupdate":
                    this.h.seeking || wd(this);
                    break;
                case "updateend":
                    xd(this);
            }
        };
        function yd(a) {
            a.i && (a.i.cancel().catch(function(b) {
                p.ColibrioError.isColibrioAbortedError(b) || p.Logger.logWarning(b);
            }), a.i = null, a.v = !1);
        }
        function ud(a) {
            if ("closed" !== a.B.readyState) {
                if (2 === a.u) a.o = !0;
                else {
                    var b = !1, c = !1, d = 1E3 * a.h.currentTime | 0, e = a.g.buffered;
                    if (0 === e.length) b = !0;
                    else if (1 === e.length) {
                        var f = 1E3 * e.start(0) | 0;
                        e = 1E3 * e.end(0) | 0;
                        if (d < f || d > e + 2E4) c = !0;
                    } else c = !0;
                    c ? (a.g.updating && a.g.abort(), yd(a), a.j = null, a.l = null, a.g.remove(0, Number.MAX_SAFE_INTEGER), a.o = !0, a.g.updating ? a.u = 2 : xd(a)) : (b && (a.g.updating && a.g.abort(), yd(a), a.j = null, a.l = null, b = Math.max(0, d - 5E3), a.i = zd(a.C, b).getReader(), a.g.timestampOffset = b / 1E3), a.o = !1, wd(a));
                }
            }
        }
        function vd(a) {
            a.o = !1;
            null !== a.s && clearTimeout(a.s);
            a.s = window.setTimeout(function() {
                a.s = null;
                ud(a);
            }, 200);
        }
        function wd(a) {
            if ("open" === a.B.readyState && 0 === a.u && !a.o && null === a.s) {
                if (a.l) {
                    var b = (1E3 * a.g.timestampOffset | 0) - (1E3 * a.h.currentTime | 0);
                    if (4 > a.h.readyState && 2E4 > b || 5E3 > b) try {
                        a.g.appendBuffer(a.l), a.l = null, a.g.updating ? a.u = 1 : xd(a);
                    } catch (g) {
                        if (g instanceof DOMException && "QuotaExceededError" === g.name) {
                            if (4 === a.h.readyState) return;
                            if (0 === a.g.buffered.length) a.j = "decode", yd(a), a.l = null, p.Logger.logError(new D("MEDIA_STREAM_ERROR", g.toString())), wd(a);
                            else {
                                b = !1;
                                for(var c = a.h.currentTime - 5, d = a.g.buffered, e = 0; e < d.length; e++)d.start(e) < c && (b = !0);
                                b ? b = c : (yd(a), a.l = null, b = Number.MAX_SAFE_INTEGER, a.o = !0);
                                a.g.remove(0, b);
                                a.g.updating ? a.u = 2 : xd(a);
                            }
                        }
                        p.ColibrioError.isColibrioAbortedError(g) || p.Logger.logWarning(g);
                    }
                } else if (!a.v) {
                    if (a.i) {
                        a.v = !0;
                        var f = a.i;
                        f.read().then(function(g) {
                            a.i === f && (g.value && (a.l = g.value), g.done && (a.j = "done", a.i = null), a.v = !1, wd(a));
                        }).catch(function(g) {
                            p.ColibrioError.isColibrioAbortedError(g) || p.Logger.logError(g);
                            a.i === f && (a.j = "network", a.i = null, a.v = !1, wd(a));
                        });
                    } else a.j && a.B.endOfStream("done" !== a.j ? a.j : void 0);
                }
            }
        }
        function xd(a) {
            a.g.updating || (a.u = 0, null === a.s && (a.o ? ud(a) : wd(a)));
        }
        function Ad(a, b, c) {
            this.l = a;
            this.g = b;
            this.j = c;
            this.i = this.h = null;
            this.A = !1;
            this.g.addEventListener("sourceopen", this);
            this.g.addEventListener("sourceclose", this);
        }
        Ad.prototype.destroy = function() {
            this.A || (this.A = !0, this.g.removeEventListener("sourceopen", this), this.g.removeEventListener("sourceclose", this), Bd(this));
        };
        Ad.prototype.handleEvent = function(a) {
            switch(a.type){
                case "sourceopen":
                    this.h || (this.g.duration = this.j.Ub() / 1E3, this.h = this.g.addSourceBuffer(ua.MediaType.AUDIO_MPEG), this.i = new td(this.l, this.g, this.h, this.j));
                    break;
                case "sourceclose":
                    Bd(this);
            }
        };
        function Bd(a) {
            a.i && (a.i.destroy(), a.i = null);
            a.h && (0 < a.g.sourceBuffers.length && a.g.removeSourceBuffer(a.h), a.h = null);
        }
        function Cd(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        m.inherits(Cd, Error);
        var Dd = new ArrayBuffer(8);
        new DataView(Dd);
        new Uint8Array(Dd);
        function Ed(a, b) {
            this.Ld = !0;
            this.Ra = !1;
            this.j = [];
            this.K = this.fa = this.i = 0;
            this.l = [];
            this.g = a || new Uint8Array(0);
            this.h = this.g.length;
            this.Ra = !!b;
        }
        function O(a) {
            return a.h - a.K + a.i;
        }
        Ed.prototype.isAtEnd = function() {
            return this.Ra && 0 === O(this);
        };
        function Fd(a, b, c) {
            if (b) {
                if (a.Ra) throw new Cd("pushData called after final chunk was added.");
                a.j.push(b);
                a.i += b.length;
            }
            a.Ra = a.Ra || c;
        }
        function Gd(a, b) {
            var c = a.h - a.K;
            if (c >= b) {
                var d = a.g.subarray(a.K, a.K + b);
                a.K += b;
            } else for(d = new Uint8Array(b), 0 < c && (d.set(a.g.subarray(a.K, a.h), 0), a.K += c); c < b;){
                Hd(a);
                var e = b - c;
                e < a.h ? (d.set(a.g.subarray(0, e), c), a.K += e, c += e) : (d.set(a.g, c), a.K = a.h, c += a.h);
            }
            a.fa += b;
            return d;
        }
        function Id(a) {
            if (2 > a.h - a.K) return (P(a) << 8) + P(a);
            a.fa += 2;
            return (a.g[a.K++] << 8) + a.g[a.K++];
        }
        function Jd(a) {
            if (3 > a.h - a.K) return (P(a) << 16) + (P(a) << 8) + P(a);
            a.fa += 3;
            return (a.g[a.K++] << 16) + (a.g[a.K++] << 8) + a.g[a.K++];
        }
        function Kd(a) {
            if (4 > a.h - a.K) return (P(a) << 24 >>> 0) + (P(a) << 16) + (P(a) << 8) + P(a);
            a.fa += 4;
            return (a.g[a.K++] << 24 >>> 0) + (a.g[a.K++] << 16) + (a.g[a.K++] << 8) + a.g[a.K++];
        }
        function P(a) {
            0 === a.h - a.K && Hd(a);
            a.fa++;
            return a.g[a.K++];
        }
        function Ld(a, b) {
            if (b > a.fa) throw new Cd("Cannot rewind() ByteReader pass numBytesRead");
            a.fa -= b;
            if (b <= a.K) a.K -= b;
            else for(a.j.unshift(a.g), a.i += a.h, b -= a.K; 0 < b;){
                var c = a.l.pop(), d = c.length;
                b <= d ? (a.g = c, a.h = d, a.K = d - b, b = 0) : (a.j.unshift(c), a.i += d, b -= d);
            }
        }
        Ed.prototype.setPosition = function(a) {
            a > this.fa ? Md(this, a - this.fa) : a < this.fa && Ld(this, this.fa - a);
        };
        function Md(a, b) {
            var c = a.h - a.K;
            if (c >= b) a.K += b;
            else for(a.K = a.h; c < b;){
                Hd(a);
                var d = b - c;
                d < a.h ? (a.K += d, c += d) : (a.K = a.h, c += a.h);
            }
            a.fa += b;
        }
        function Hd(a) {
            if (0 === a.j.length) throw new Cd("BigEndingArrayByteReader: no input arrays available!");
            0 < a.g.length && a.l.push(a.g);
            a.g = a.j.shift();
            a.h = a.g.length;
            a.i -= a.h;
            a.K = 0;
        }
        function Nd(a) {
            return (a >> 24 & 127) << 21 | (a >> 16 & 127) << 14 | (a >> 8 & 127) << 7 | a & 127;
        }
        function Od() {}
        function Pd() {
            this.j = new Uint8Array([]);
            this.l = this.i = this.o = 0;
            this.s = [];
            this.h = this.g = 0;
        }
        function Qd(a, b) {
            for(; 0 < a.h && 24 > a.g;)Rd(a);
            return Sd(a, b);
        }
        function Td(a, b) {
            8 > a.g && Ud(a);
            return Sd(a, b);
        }
        function Vd(a, b) {
            0 !== b.length && (a.s.push(b), a.h += b.length, 0 === a.g && Rd(a));
        }
        function Rd(a) {
            a.l < a.o ? (a.h--, a.i = a.i << 8 | a.j[a.l++], a.g += 8) : 0 < a.s.length ? (a.j = a.s.shift(), a.o = a.j.length, a.h--, a.i = a.i << 8 | a.j[0], a.l = 1, a.g += 8) : a.h = 0;
        }
        function Ud(a) {
            a.l < a.o - 2 ? (a.i = a.i << 24 | a.j[a.l++] << 16 | a.j[a.l++] << 8 | a.j[a.l++], a.g += 24, a.h -= 3) : (Rd(a), Rd(a), Rd(a));
        }
        function Sd(a, b) {
            a.g -= b;
            return (a.i & (1 << b) - 1 << a.g) >>> a.g;
        }
        function Wd() {}
        function Xd(a) {
            this.ua = a;
        }
        function Yd(a) {
            if (3 > O(a)) return null;
            var b = P(a);
            if (0 !== b && 3 !== b) return null;
            b = !1;
            for(var c = ""; !b && 0 < O(a);){
                var d = P(a);
                if (0 === d) b = !0;
                else {
                    if (48 > d || 57 < d) return null;
                    c += String.fromCharCode(d);
                }
            }
            if (!b || 0 === c.length) return null;
            a = Number(c);
            return isNaN(a) ? null : new Xd(a);
        }
        Xd.prototype.Ub = function() {
            return this.ua;
        };
        function Zd() {
            this.g = this.i = this.h = null;
        }
        function $d(a, b, c, d) {
            var e = c & 8, f = c & 4;
            if (O(a) < b) return Md(a, O(a)), null;
            if (f || e) return Md(a, b), null;
            a = Gd(a, b);
            if (d || c & 2) {
                b = new Uint8Array(b);
                d = c = 0;
                for(e = a.length - 1; d < e;)b[c++] = a[d], 255 === a[d] && 0 === a[d + 1] ? d += 2 : d++;
                d < a.length && (b[c++] = a[d]);
                a = b.subarray(0, c);
            }
            return new Ed(a, !0);
        }
        function ae(a, b) {
            this.h = a;
            this.g = b;
        }
        function be(a) {
            if (4801587 !== Jd(a)) return null;
            var b = P(a), c = P(a);
            if (4 < b || 255 === c) return p.Logger.logInfo("Unsupported ID3 tag: ID3v2." + b + "." + c), null;
            b = P(a);
            if (0 !== (b & 15)) return p.Logger.logInfo("Invalid ID3 header flags: 0x" + b.toString(16)), null;
            a = Kd(a);
            return 0 !== (a & 2155905152) ? (p.Logger.logInfo("Invalid ID3 tag size format: 0x" + a.toString(16)), null) : new ae(b, Nd(a) + (b & 16 ? 20 : 10));
        }
        function ce(a, b, c, d, e, f, g) {
            this.s = a;
            this.j = b;
            this.i = c;
            this.g = d;
            this.h = e;
            this.o = f;
            this.l = g;
        }
        function de(a) {
            var b = new Pd, c = Gd(a, 4);
            Vd(b, c);
            if (2047 !== Qd(b, 11)) return null;
            c = Td(b, 2);
            if (1 === c) return null;
            switch(c){
                case 0:
                    c = 3;
                    break;
                case 2:
                    c = 2;
                    break;
                default:
                case 3:
                    c = 1;
            }
            var d = Td(b, 2);
            if (0 === d) return null;
            switch(d){
                default:
                case 1:
                    d = 3;
                    break;
                case 2:
                    d = 2;
                    break;
                case 3:
                    d = 1;
            }
            8 > b.g && Ud(b);
            --b.g;
            var e = Td(b, 4);
            if (15 === e) return null;
            e = 1E3 * (1 === c ? 1 === d ? 32 * e : 2 === d ? ee[e] : fe[e] : 1 === d ? he[e] : ie[e]);
            var f = Td(b, 2);
            if (3 === f) return null;
            f = 0 === f ? 44100 : 1 === f ? 48E3 : 32E3;
            2 === c ? f >>= 1 : 3 === c && (f >>= 2);
            1 > b.g && Ud(b);
            b.g--;
            var g = 1 === (b.i & 1 << b.g) >>> b.g;
            8 > b.g && Ud(b);
            --b.g;
            b = Td(b, 2);
            return new ce(a.fa - 4, c, d, e, f, g, b);
        }
        function je(a) {
            var b = a.o ? 1 : 0;
            1 === a.i ? (a = (12 * a.g / a.h | 0) + b, a *= 4) : a = 2 === a.i ? (144 * a.g / a.h | 0) + b : 1 === a.j ? (144 * a.g / a.h | 0) + b : (144 * a.g / (a.h << 1) | 0) + b;
            return a;
        }
        ce.prototype.getStartOffset = function() {
            return this.s;
        };
        var ee = [
            0,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320,
            384
        ], fe = [
            0,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            256,
            320
        ], he = [
            0,
            32,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160,
            176,
            192,
            224,
            256
        ], ie = [
            0,
            8,
            16,
            24,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            144,
            160
        ];
        function ke(a) {
            this.g = a;
        }
        function le(a) {
            if (1447187017 !== Kd(a)) return null;
            var b = Id(a);
            if (1 !== b) return p.Logger.logInfo("MPEG Audio VBRI Header: Unknown version: " + b), null;
            Md(a, 4);
            Kd(a);
            b = Kd(a);
            Id(a);
            Id(a);
            var c = Id(a);
            if (4 < c) return p.Logger.logInfo("MPEG Audio VBRI Header: Invalid size per toc entry: " + c), null;
            Id(a);
            return new ke(b);
        }
        function me(a, b, c, d) {
            this.j = a;
            this.h = b;
            this.g = c;
            this.i = d;
        }
        function ne(a, b) {
            this.g = a;
            this.j = b;
            this.h = null;
            this.o = 0;
            this.i = -1;
            this.l = this.C = null;
            this.s = -1;
            this.F = this.D = null;
            if (!this.g.Ld) throw new Cd("ByteReader not rewindable.");
            this.v = this.B = this.H = this.u = a = null === b;
            oe(this);
        }
        function oe(a) {
            for(var b = !a.h; b;)if (a.g.fa < a.o) Md(a.g, Math.min(a.o - a.g.fa, O(a.g))), b = 0 < O(a.g);
            else if (a.H) b = a, 10 <= O(b.g) ? (b.l = be(b.g), b.H = !1, b.l || (b.u = !1, b.g.setPosition(0)), b = !0) : b = !1;
            else if (a.u && a.l) {
                b = a;
                var c = a.l;
                if (O(b.g) >= c.g - 10) {
                    var d = b, e = c;
                    var f = b.g;
                    var g = !!(e.h & 64), h = !!(e.h & 128), l = e.h & 16;
                    e = new Ed(Gd(f, e.g - (l ? 20 : 10)), !0);
                    l && Md(f, 10);
                    b: {
                        f = e;
                        if (g) {
                            g = Kd(f);
                            if (0 !== (g & 2155905152)) {
                                f = null;
                                break b;
                            }
                            g = Nd(g);
                            if (O(f) < g - 4) {
                                f = null;
                                break b;
                            }
                            Md(f, g - 4);
                        }
                        g = new Zd;
                        for(l = !1; !l && 10 < O(f);){
                            e = Kd(f);
                            var r = Kd(f);
                            if (0 !== (r & 2155905152)) {
                                f = null;
                                break b;
                            }
                            r = Nd(r);
                            var q = Id(f);
                            switch(e){
                                case 0:
                                    l = !0;
                                    break;
                                case 1095979081:
                                    if (e = $d(f, r, q, h)) {
                                        if (12 > O(e)) e = null;
                                        else {
                                            var v = Kd(e), u = Kd(e);
                                            r = Id(e);
                                            q = P(e);
                                            if (u <= v || 8 !== q && 16 !== q || O(e) < r * (q >> 3)) e = null;
                                            else {
                                                v = [];
                                                if (8 === q) for(q = 0; q < r; q++)v.push(P(e));
                                                else for(q = 0; q < r; q++)v.push(Id(e));
                                                e = new Od;
                                            }
                                        }
                                        g.h = e;
                                    }
                                    break;
                                case 1296845908:
                                    if (e = $d(f, r, q, h)) {
                                        var w = e;
                                        if (10 > O(w)) e = null;
                                        else if (e = Id(w), r = Jd(w), q = Jd(w), v = P(w), u = P(w), 24 < v || 24 < u) e = null;
                                        else {
                                            var E = v + u, z = new Pd;
                                            Vd(z, Gd(w, O(w)));
                                            w = [];
                                            for(var N = 0, H = 0, A = 0; 8 * z.h + z.g >= E;){
                                                N += e;
                                                H += r;
                                                A += q;
                                                var J = Qd(z, v), L = Qd(z, u);
                                                w.push({
                                                    lb: H + J,
                                                    me: N,
                                                    nb: A + L
                                                });
                                            }
                                            e = new Wd;
                                        }
                                        g.i = e;
                                    }
                                    break;
                                case 1414284622:
                                    if (e = $d(f, r, q, h)) g.g = Yd(e);
                                    break;
                                default:
                                    O(f) >= r ? Md(f, r) : l = !0;
                            }
                        }
                        f = g;
                    }
                    d.C = f;
                    b.u = !1;
                    b.o = c.g;
                    b = !0;
                } else b = !1;
            } else if (-1 === a.i) a: {
                for(b = a; 0 < O(b.g);){
                    c = P(b.g);
                    if (255 === b.s && 224 === (c & 224)) {
                        Ld(b.g, 2);
                        b.i = b.g.fa;
                        b.s = 0;
                        oe(b);
                        b = !0;
                        break a;
                    }
                    b.s = c;
                }
                b = !1;
            }
            else a.h ? a.B ? (b = a, c = a.h, c = 4 + (3 === c.l ? 1 === c.j ? 17 : 9 : 1 === c.j ? 32 : 17), O(b.g) < c + 120 ? b = !1 : (Md(b.g, c), c = b, d = b.g, f = Kd(d), 1483304551 !== f && 1231971951 !== f ? d = null : (r = Kd(d), e = r & 2, h = r & 4, g = r & 8, l = -1, r & 1 && (l = Kd(d)), r = -1, e && (r = Kd(d)), e = null, h && (e = Gd(d, 100)), g && Kd(d), d = new me(1483304551 === f, l, r, e)), c.F = d, b.B = !1, b.g.setPosition(b.i), b = !0)) : a.v ? (b = a, 62 > O(b.g) ? b = !1 : (Md(b.g, 36), b.D = le(b.g), b.v = !1, b.g.setPosition(b.i), b = !0)) : b = !1 : (b = a, 4 <= O(b.g) ? (c = de(b.g), d = !1, c && (b.j ? d = b.j.j === c.j && b.j.i === c.i && b.j.h === c.h : (b.j = c, d = !0)), d ? (b.h = c, b.g.setPosition(b.i)) : (b.g.setPosition(b.i + 1), b.i = -1), b = !0) : b = !1);
        }
        function pe(a) {
            return a.j ? 0 === a.j.g ? 0 : 3 : !a.g.Ra && a.g.fa < 1E5 + (a.l ? a.l.g : 0) ? 1 : 0;
        }
        function qe(a) {
            return null === a.h || a.B || a.v;
        }
        function re(a) {
            if (null === a.h || -1 === a.i) throw new D("MP3_PARSE_ERROR", "Cannot find next frame ");
            a.o = a.i + Math.max(je(a.h), 4);
            a.h = null;
            a.i = -1;
            oe(a);
        }
        function se(a, b) {
            this.h = a;
            this.g = b;
        }
        se.prototype.Rb = function() {};
        se.prototype.xc = function(a) {
            return {
                lb: this.h + a * this.g / 8E3 | 0,
                nb: a
            };
        };
        se.prototype.yc = function() {
            return "CBR";
        };
        function te(a) {
            this.g = [];
            this.g.push({
                lb: a,
                nb: 0
            });
        }
        te.prototype.Rb = function(a, b) {
            var c = Ca(this.g);
            c && a > c.lb + 1E5 && this.g.push({
                lb: a,
                nb: b
            });
        };
        te.prototype.xc = function(a) {
            var b = Aa(this.g, 1, this.g.length, function(c, d) {
                return a - c[d].nb;
            });
            0 > b && (b = 0);
            return this.g[b];
        };
        te.prototype.yc = function() {
            return "Frame scan";
        };
        function ue(a, b, c, d) {
            this.h = a;
            this.i = b;
            this.g = c;
            this.ua = d;
        }
        ue.prototype.Rb = function() {};
        ue.prototype.xc = function(a) {
            var b = 100 * Ka(a, 0, this.ua) / this.ua, c = b | 0;
            if (99 < c) return {
                lb: this.g,
                nb: a
            };
            var d = this.h[c];
            return {
                lb: Sa(d + ((99 > c ? this.h[c + 1] : 256) - d) * (b - c), 256, this.i, this.g) | 0,
                nb: a
            };
        };
        ue.prototype.yc = function() {
            return "XING";
        };
        function ve(a, b, c, d, e, f) {
            this.g = a;
            this.u = b;
            this.h = c;
            this.v = d;
            this.i = e;
            this.D = f;
            this.ua = -1;
            this.C = 1;
            this.l = null;
            this.j = !1;
            this.o = "";
            this.B = a;
            this.h && this.h.g > this.i - this.g.getStartOffset() && (p.Logger.logInfo("MPEG Audio XING header seems invalid. File size mismatch. File size: " + this.i + " (" + (this.i - this.g.getStartOffset()) + "), XING header declares: " + this.h.g), this.h = null);
            this.s = (1 === a.i ? 384 : 3 === a.i && 1 !== a.j ? 576 : 1152) / a.h * 1E3;
            var g, h;
            a = -1 !== we(this) || void 0 !== (null == (g = this.u) ? void 0 : null == (h = g.g) ? void 0 : h.Ub());
            this.v || this.h && this.h.j ? (this.j = !0, g = a ? 0 : 3E4) : g = a ? 15E3 : 3E4;
            this.F = g / this.s | 0;
        }
        function we(a) {
            var b = -1;
            a.h ? b = a.h.h : a.v && (b = a.v.g);
            return b;
        }
        function xe(a) {
            if (-1 !== a.ua) return a.ua;
            var b = -1, c = we(a);
            -1 !== c ? (b = c * a.s, a.o = "XING/VBRI") : a.u && (c = a.u.g) && (b = c.Ub(), a.o = "ID3-TLEN");
            -1 === b && (c = a.g.g, b = a.g.getStartOffset(), !a.j && 0 < a.i && 0 < c ? (b = (a.i - b) / a.g.g * 8E3, a.o = "bitrate") : (c = a.B.getStartOffset() + je(a.B) - b, b = ((a.i - b) / c * a.C | 0) * a.s, a.o = "file size"));
            a.ua = b | 0;
            return a.ua;
        }
        function ye(a, b, c) {
            this.g = a;
            this.h = b;
            this.i = c;
        }
        function ze(a, b, c) {
            var d, e, f, g, h, l, r, q, v;
            return m.ea(function(u) {
                switch(u.g){
                    case 1:
                        return n(u, Ae(a, 0), 2);
                    case 2:
                        d = u.h, e = new ne(d, null), f = pe(e);
                    case 3:
                        if (!(qe(e) && 1 <= f)) {
                            u.J(5);
                            break;
                        }
                        return n(u, Be(a, d), 6);
                    case 6:
                        oe(e);
                        f = pe(e);
                        u.J(3);
                        break;
                    case 5:
                        g = null;
                        h = e.h;
                        if (3 !== f || !h) {
                            p.Logger.logInfo("This file does not seem to be an MP3 file");
                            u.J(7);
                            break;
                        }
                        l = new ve(h, e.C, e.F, e.D, b, c);
                        r = !0;
                    case 8:
                        if (!r || l.j || !(l.C < l.F)) {
                            u.J(10);
                            break;
                        }
                        re(e);
                    case 11:
                        if (!qe(e) || d.Ra) {
                            u.J(13);
                            break;
                        }
                        return n(u, Be(a, d), 14);
                    case 14:
                        oe(e);
                        u.J(11);
                        break;
                    case 13:
                        (q = e.h) ? (l.j || q.g === l.g.g || (l.j = !0), l.C++, l.B = q) : r = !1;
                        u.J(8);
                        break;
                    case 10:
                        if (!l.l) {
                            if (l.j) {
                                if (l.h && !l.D) {
                                    var w = l.h.i;
                                    w && (l.l = new ue(w, l.g.getStartOffset(), l.i, xe(l)));
                                }
                            } else l.l = new se(l.g.getStartOffset(), l.g.g);
                        }
                        l.l || (l.l = new te(l.g.getStartOffset()));
                        v = l.l;
                        g = new ye(l, v, a);
                    case 7:
                        return u.return(g);
                }
            });
        }
        function zd(a, b) {
            var c = a.h.xc(b), d = c.lb, e = c.nb, f = !1;
            return new ReadableStream({
                cancel: function() {
                    f = !0;
                },
                pull: function(g) {
                    var h, l, r, q, v, u, w, E, z, N, H;
                    return m.ea(function(A) {
                        switch(A.g){
                            case 1:
                                return n(A, Ae(a.i, d), 2);
                            case 2:
                                h = A.h;
                                if (f) return A.return();
                                l = null;
                                r = !1;
                                q = new ne(h, a.g.g);
                            case 3:
                                if (l || r) {
                                    A.J(5);
                                    break;
                                }
                                if (v = q.h) {
                                    a.h.Rb(d + v.getStartOffset(), e);
                                    e >= b && (l = v);
                                    e += a.g.s;
                                    re(q);
                                    A.J(3);
                                    break;
                                }
                                if (!qe(q) || h.Ra) {
                                    r = !0;
                                    A.J(3);
                                    break;
                                }
                                return n(A, Be(a.i, h), 8);
                            case 8:
                                if (f) return A.return();
                                oe(q);
                                A.J(3);
                                break;
                            case 5:
                                if (!l) return g.close(), A.return();
                                u = l.getStartOffset();
                                if (!qe(q)) {
                                    A.J(9);
                                    break;
                                }
                            case 10:
                                if (!qe(q) || h.Ra) {
                                    A.J(9);
                                    break;
                                }
                                return n(A, Be(a.i, h), 13);
                            case 13:
                                if (f) return A.return();
                                oe(q);
                                A.J(10);
                                break;
                            case 9:
                                for(w = null; !qe(q);)if (E = q.h) a.h.Rb(d + E.getStartOffset(), e), e += a.g.s, w = E, re(q);
                                h.setPosition(u);
                                w ? (z = w.getStartOffset() - u, N = z + je(w), H = O(h) >= N ? N : z, g.enqueue(Gd(h, H))) : je(l) <= O(h) && g.enqueue(Gd(h, je(l)));
                                d += h.fa;
                                h.Ra && g.close();
                                A.g = 0;
                        }
                    });
                }
            });
        }
        ye.prototype.Ub = function() {
            return xe(this.g);
        };
        function Ce() {
            this.Da = 0;
            this.h = De(null, null, null);
            this.g = De(null, this.h, null);
            this.h.aa = this.g;
        }
        k = Ce.prototype;
        k.clear = function() {
            this.h = De(null, null, null);
            this.g = De(null, this.h, null);
            this.h.aa = this.g;
            this.Da = 0;
        };
        k.every = function(a) {
            for(var b = this.h.aa, c = !0; b !== this.g && c;){
                var d = b.aa;
                c = a(b);
                b = null === b.aa ? d : b.aa;
            }
            return c;
        };
        k.find = function(a) {
            for(var b = this.h.aa, c = null; b !== this.g && null === c;){
                var d = b.aa;
                a(b) && (c = b);
                b = null === b.aa ? d : b.aa;
            }
            return c;
        };
        k.forEach = function(a) {
            for(var b = this.h.aa; b !== this.g;){
                var c = b.aa;
                a(b);
                b = null === b.aa ? c : b.aa;
            }
        };
        function Ee(a, b) {
            b = De(b, a.g.Fa, a.g);
            b.Fa.aa = b;
            a.g.Fa = b;
            a.Da++;
            return b;
        }
        k.remove = function(a) {
            for(var b = this.h, c = !1; !c && b !== this.g;)b = b.aa, c = b.m === a;
            c && b !== this.g && Fe(this, b);
        };
        k.shift = function() {
            if (0 === this.Da) var a = null;
            else a = this.h.aa, Fe(this, a);
            return a ? a.m : null;
        };
        k.size = function() {
            return this.Da;
        };
        function De(a, b, c) {
            return {
                m: a,
                aa: c,
                Fa: b
            };
        }
        function Fe(a, b) {
            if (b.Fa && b.aa) {
                var c = b.Fa, d = b.aa;
                c.aa = d;
                d.Fa = c;
                b.aa = null;
                b.Fa = null;
                a.Da--;
            }
        }
        function Ge(a) {
            this.h = a;
            this.g = new Ce;
            this.j = new Map;
            this.i = 0;
        }
        k = Ge.prototype;
        k.clear = function() {
            this.j.clear();
            this.g = new Ce;
            this.i = 0;
        };
        function He(a, b) {
            var c = a.j.get(b);
            c && (a.j.delete(b), Fe(a.g, c), a.i -= c.m.Da);
        }
        k.find = function(a) {
            var b = this.g;
            b = b.Da ? b.g.Fa : null;
            for(var c; b && void 0 === c;)a(b.m.lc, b.m.Ab) ? c = b.m.lc : b = (b = b.Fa) && this.g.h !== b ? b : null;
            b && Ie(this, b);
            return c;
        };
        k.get = function(a) {
            return (a = this.j.get(a)) ? (Ie(this, a), a.m.lc) : null;
        };
        k.has = function(a) {
            return this.j.has(a);
        };
        k.set = function(a, b, c) {
            if (!(c > this.h.Kd || !this.h.Xc && c > this.h.Vc)) {
                var d = this.h.jc;
                b = {
                    Ab: a,
                    La: 0,
                    Da: c,
                    od: d ? Date.now() + d : 0,
                    lc: b
                };
                He(this, a);
                b = Ee(this.g, b);
                this.j.set(a, b);
                this.i += c;
                Je(this);
            }
        };
        function Je(a) {
            var b = a.h.Vc, c = a.h.Xc, d = a.h.jc;
            if (d && a.i > b && a.g.size() > c) {
                d = d ? Date.now() : 0;
                var e = a.g;
                for(e = e.Da ? e.h.aa : null; a.i > b && a.g.size() > c && e && e.m.od <= d;){
                    var f = (f = e.aa) && a.g.g !== f ? f : null;
                    0 >= e.m.La && He(a, e.m.Ab);
                    e = f;
                }
            }
        }
        function Ie(a, b) {
            var c = a.h.jc, d = a.g;
            b.Fa && b.aa && (Fe(d, b), b.Fa = d.g.Fa, b.aa = d.g, b.Fa.aa = b, d.g.Fa = b, d.Da++);
            c && (b.m.od = Date.now() + c);
            c && Je(a);
        }
        function Ke(a, b, c, d) {
            var e = this;
            this.D = a;
            this.u = b;
            this.H = c;
            this.v = d;
            this.B = new WeakMap;
            this.F = !1;
            this.g = 0;
            this.A = !1;
            this.C = new p.AsyncTaskQueue(1, function(f) {
                return e.fetchChunk(f);
            });
            this.i = this.l = this.j = this.s = null;
            this.h = 0;
            this.o = new Ge({
                Kd: d.Oc,
                Vc: d.Oc,
                Xc: 1,
                jc: 0
            });
            this.Da = b.size || null;
        }
        Ke.prototype.destroy = function() {
            this.A || (this.A = !0, this.C.destroy(new D(p.ColibrioErrorType.ABORTED)), this.o.clear(), this.j && (this.j.abort(), this.j = null), this.l && (this.l.abort(), this.l = null));
        };
        function Be(a, b) {
            var c, d, e, f, g;
            return m.ea(function(h) {
                if (1 == h.g) {
                    c = a.B.get(b);
                    if (!C(c)) throw new Cd("Invalid ByteReader instance. It was not created from ResourceByteReaderProvider!");
                    d = b;
                    return (e = a.o.get(c)) ? h.J(2) : n(h, a.C.scheduleDefaultTask(c, 0), 3);
                }
                2 != h.g && (e = h.h);
                e ? (f = c + a.v.Lb, g = C(a.u.size) && f >= a.u.size, Fd(d, e, g), a.B.set(d, f)) : Fd(d, void 0, !0);
                h.g = 0;
            });
        }
        function Ae(a, b) {
            var c, d, e, f, g, h;
            return m.ea(function(l) {
                if (1 == l.g) return c = b % a.v.Lb, d = b - c, e = new Ed, (f = a.o.get(d)) ? l.J(2) : n(l, a.C.scheduleDefaultTask(d, 0), 3);
                2 != l.g && (f = l.h);
                g = d + a.v.Lb;
                f ? (h = C(a.u.size) && g >= a.u.size, Fd(e, 0 === c ? f : f.subarray(c), h)) : Fd(e, void 0, !0);
                a.B.set(e, g);
                return l.return(e);
            });
        }
        Ke.prototype.fetchChunk = function(a) {
            var b = this, c, d, e, f, g, h, l, r, q, v;
            return m.ea(function(u) {
                switch(u.g){
                    case 1:
                        if (c = b.o.get(a)) return u.return(c);
                        b.s && b.g > a && (b.s.cancel().catch(function(w) {
                            p.ColibrioError.isColibrioAbortedError(w) || p.Logger.logWarning(w);
                        }), b.s = null, b.j = null, b.i = null);
                        d = b.v.Lb;
                        if (b.u.acceptsRanges && b.Da) {
                            if (!(a < b.Da)) {
                                u.J(3);
                                break;
                            }
                            return n(u, b.D.fetch(b.H, {
                                range: {
                                    end: Math.min(a + d, b.Da),
                                    start: a
                                }
                            }), 12);
                        }
                        if (b.F) {
                            u.J(3);
                            break;
                        }
                        if (b.s) {
                            u.J(5);
                            break;
                        }
                        return n(u, b.D.fetch(b.H), 6);
                    case 6:
                        b.j = u.h;
                        if (b.A) throw b.j.abort(), b.j = null, new D(p.ColibrioErrorType.ABORTED);
                        b.s = b.j.getReadableStream().getReader();
                        b.g = 0;
                    case 5:
                        b.i || (b.i = new Uint8Array(d), b.h = 0), e = a + d, f = !1;
                    case 7:
                        if (!(b.g < e) || f) {
                            u.J(9);
                            break;
                        }
                        return n(u, b.s.read(), 10);
                    case 10:
                        g = u.h;
                        f = g.done;
                        if (g.value) for(h = 0, l = g.value.length; h < l;)r = l - h, q = void 0, q = r <= b.i.length - b.h ? g.value.subarray(h) : g.value.subarray(h, h + d - b.h), b.i.set(q, b.h), b.h += q.length, h += q.length, b.h === d && (b.o.set(b.g, b.i, d), b.g === a && (c = b.i), b.i = new Uint8Array(d), b.h = 0, b.g += d);
                        u.J(7);
                        break;
                    case 9:
                        f && (b.F = !0, 0 < b.h && (v = b.i.slice(0, b.h), b.o.set(b.g, v, v.length), b.g === a && (c = v), b.i = null, b.s = null, b.j = null, b.g += b.h));
                        u.J(3);
                        break;
                    case 12:
                        b.l = u.h;
                        if (b.A) throw b.l.abort(), b.l = null, new D(p.ColibrioErrorType.ABORTED);
                        return n(u, b.l.asUint8Array(), 13);
                    case 13:
                        c = u.h, b.l = null, b.o.set(a, c, d);
                    case 3:
                        return u.return(c);
                }
            });
        };
        function Le(a, b, c) {
            this.i = a;
            this.l = b;
            this.j = null;
            this.A = !1;
            this.o = 0;
            this.g = new Map;
            this.h = y(c, {
                allowRemoteUrls: !1,
                enableBlobUrls: null,
                enableMediaStreaming: !1,
                highPrecisionSeek: !1,
                minimumSizeForMediaStreaming: 1E6
            });
        }
        Le.prototype.createUrl = function(a, b) {
            var c = this;
            if (this.A) return {
                mediaSourceId: -1,
                urlPromise: Promise.reject(p.ColibrioErrorType.ABORTED)
            };
            var d = ++this.o, e = {
                oc: null,
                pc: null,
                rc: null,
                Wb: null
            };
            this.g.set(d, e);
            Ha(b) && (b = ya.URLUtils.normalizePathnameEncoding(new URL(b, this.i.getBaseUrl() || void 0)));
            if (this.h.allowRemoteUrls && !this.i.acceptsUrl(b) && ("http:" === b.protocol || "https:" === b.protocol)) return Me(d, Promise.resolve(b.toString()));
            var f = "audio" === a.localName ? [
                ua.MediaTypeCategory.AUDIO
            ] : [
                ua.MediaTypeCategory.VIDEO
            ];
            if (this.i.isUrlSupportedByBrowser(b, {
                accept: f
            })) return Me(d, Promise.resolve(b.toString()));
            if (p.BrowserDetector.isOS("macOS") && 1 < navigator.maxTouchPoints || !this.h.enableMediaStreaming || !B(window.MediaSource) || !B(MediaSource.isTypeSupported)) return Me(d, Ne(this, d, b, f));
            var g = b;
            b = this.i.fetchMetadata(b, {
                accept: f
            }).then(function(h) {
                var l, r, q, v, u;
                return m.ea(function(w) {
                    switch(w.g){
                        case 1:
                            if (c.A || !c.g.has(d)) throw new D(p.ColibrioErrorType.ABORTED);
                            l = null;
                            if (!(C(h.size) && h.size >= c.h.minimumSizeForMediaStreaming)) {
                                w.J(2);
                                break;
                            }
                            switch(h.mediaType){
                                case ua.MediaType.AUDIO_MPEG:
                                    return w.J(3);
                            }
                            w.J(2);
                            break;
                        case 3:
                            return r = new Ke(c.i, h, g, {
                                Oc: h.acceptsRanges && C(h.size) ? 16E6 : Number.MAX_SAFE_INTEGER,
                                Lb: 256E3
                            }), e.pc = r, n(w, ze(r, h.size, c.h.highPrecisionSeek || !h.acceptsRanges), 5);
                        case 5:
                            l = w.h;
                            w.J(2);
                            break;
                        case 2:
                            if (c.A || !c.g.has(d)) throw new D(p.ColibrioErrorType.ABORTED);
                            if (l && MediaSource.isTypeSupported(ua.MediaType.AUDIO_MPEG)) {
                                var E = p.Logger, z = E.logInfo, N = "Streaming " + (h.pathRelativeToBaseUrl || h.url) + " - ", H = l, A = H.g.g, J = A.j, L = Math.round(xe(H.g) / 1E3);
                                z.call(E, N + ("Audio - " + [
                                    "MPEG " + (3 === J ? "2.5" : J),
                                    "Layer " + A.i,
                                    A.h + " Hz",
                                    H.g.j ? "VBR" : "CBR",
                                    "Duration: " + (L / 60 | 0) + ":" + (L % 60).toString().padStart(2, "0") + " (from " + H.g.o + ")",
                                    "Seek table: " + H.h.yc()
                                ].join(", ")));
                                q = new MediaSource;
                                v = URL.createObjectURL(q);
                                u = new Ad(a, q, l);
                                e.Wb = {
                                    controller: u,
                                    url: v
                                };
                                return w.return(v);
                            }
                            return w.return(Ne(c, d, g, f));
                    }
                });
            });
            return Me(d, b);
        };
        Le.prototype.destroy = function() {
            var a = this;
            this.A = !0;
            Array.from(this.g.keys()).forEach(function(b) {
                return a.revokeUrl(b);
            });
            this.j = null;
        };
        Le.prototype.revokeUrl = function(a) {
            var b = this.g.get(a);
            if (b) {
                this.g.delete(a);
                b.Wb && (b.Wb.controller.destroy(), URL.revokeObjectURL(b.Wb.url));
                if (b.oc) {
                    var c;
                    null == (c = this.j) || c.revokeUrl(b.oc);
                }
                b.rc && b.rc.destroy();
                b.pc && b.pc.destroy();
            }
        };
        function Ne(a, b, c, d) {
            if (a.l) {
                var e = new wa.ResourceCacheClient(a.l);
                return e.fetchBrowserNativeUrl(c, d, "boolean" === typeof a.h.enableBlobUrls ? !a.h.enableBlobUrls : !1).then(function(f) {
                    var g = a.g.get(b);
                    if (!g || a.A) throw e.destroy(), new D(p.ColibrioErrorType.ABORTED);
                    g.rc = e;
                    return f.data;
                });
            }
            return a.i.fetch(c, {
                accept: d
            }).then(function(f) {
                var g, h, l, r, q, v, u;
                return m.ea(function(w) {
                    switch(w.g){
                        case 1:
                            g = a.g.get(b);
                            if (a.A || !g) throw f.abort(), new D(p.ColibrioErrorType.ABORTED);
                            h = !1;
                            l = [];
                            r = f.getReadableStream().getReader();
                        case 2:
                            if (h) {
                                w.J(4);
                                break;
                            }
                            return n(w, r.read(), 5);
                        case 5:
                            q = w.h;
                            if (a.A || !a.g.has(b)) throw r.cancel().catch(function(E) {
                                p.ColibrioError.isColibrioAbortedError(E) || p.Logger.logWarning(E);
                            }), new D(p.ColibrioErrorType.ABORTED);
                            q.value && l.push(q.value);
                            h = q.done;
                            w.J(2);
                            break;
                        case 4:
                            return a.j || (a.j = new ua.BlobUrlManager), (v = va.MediaTypeDetector.getMediaTypeByExtension(c.pathname)) || (v = f.getMetadata().mediaType || ""), u = a.j.createUrl(l, v, "boolean" === typeof a.h.enableBlobUrls ? !a.h.enableBlobUrls : !1).url, g.oc = u, w.return(u);
                    }
                });
            });
        }
        function Me(a, b) {
            return {
                mediaSourceId: a,
                urlPromise: b
            };
        }
        function Oe(a, b, c) {
            this.l = c;
            this.i = new Map;
            this.g = new Map;
            this.A = !1;
            this.j = new Map;
            this.h = new Le(a, void 0, {
                allowRemoteUrls: !1,
                enableBlobUrls: b.enableBlobUrls,
                enableMediaStreaming: b.enableMediaStreaming,
                highPrecisionSeek: !0
            });
            this.o = !1;
            if (p.BrowserDetector.isOS("iOS")) {
                b = p.BrowserDetector.getOsVersion().trim();
                if (c = /^(\d+)(?:\.(\d+))?(?:\.(\d+))?/.exec(b)) {
                    if (a = c.length, a = new sd(1 < a && c[1] ? Number(c[1]) : 0, 2 < a && c[2] ? Number(c[2]) : 0, 3 < a && c[3] ? Number(c[3]) : 0), b.length > c[0].length) {
                        b: if (b = b.slice(c[0].length), "+" === b[0]) a.h = b.slice(1);
                        else if ("-" === b[0]) for(c = b.indexOf("+"), -1 !== c ? (a.h = b.slice(c + 1), b = b.slice(1, c)) : b = b.slice(1), b = b.split("."), c = 0; c < b.length; c++){
                            var d = b[c];
                            if (/^[0-9]+$/.test(d)) a.g.push(Number(d));
                            else if (/^[0-9A-Za-z]+$/.test(d)) a.g.push(d);
                            else {
                                a.g = [];
                                break b;
                            }
                        }
                    }
                } else a = null;
                b = new sd(17, 4, 0);
                if (null == a ? 0 : 0 <= a.compareTo(b)) this.o = !0;
            }
        }
        Oe.prototype.destroy = function() {
            var a = this;
            this.A = !0;
            this.g.forEach(function(b) {
                a.h.revokeUrl(b.mediaSourceId);
            });
            this.g.clear();
            this.i.forEach(function(b) {
                a.h.revokeUrl(b.mediaSourceId);
            });
            this.i.clear();
            this.h.destroy();
            this.l.destroy();
        };
        function Pe(a, b, c) {
            if (a.A) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            var d = a.i.get(b);
            if (d) return Promise.resolve(d.ja);
            if (d = a.g.get(b)) return d.Qd;
            var e = Qe(a, b), f = nd(a.l);
            d = b.getResourceMetadata();
            var g = a.h.createUrl(f, d.url);
            d = g.urlPromise.then(function(h) {
                return new Promise(function(l, r) {
                    if (a.j.get(b) !== e) r(new D(p.ColibrioErrorType.ABORTED));
                    else {
                        var q = function() {
                            f.removeEventListener("abort", u);
                            f.removeEventListener("error", u);
                            f.removeEventListener("canplaythrough", v);
                        }, v = function() {
                            q();
                            a.A ? r(new D(p.ColibrioErrorType.ABORTED)) : (1 < Math.abs(f.currentTime - c) && (f.currentTime = c / 1E3), l(f));
                        }, u = function() {
                            q();
                            if (a.A) r(new D(p.ColibrioErrorType.ABORTED));
                            else {
                                var w = f.error;
                                r(new D("SYNC_MEDIA_AUDIO_ELEMENT_ERROR", w ? "Code: " + w.code + ", Message: " + w.message : "No error msg available."));
                            }
                        };
                        f.addEventListener("canplaythrough", v);
                        f.addEventListener("abort", u);
                        f.addEventListener("error", u);
                        f.src = h;
                        f.currentTime = c / 1E3;
                        a.o ? (f.muted = !0, f.play().catch(function(w) {
                            "AbortError" !== w.name && r(new D("SYNC_MEDIA_AUDIO_ELEMENT_ERROR", w + ""));
                        }), f.pause(), f.muted = !1) : f.load();
                    }
                });
            }).then(function(h) {
                if (a.g.has(b) && a.j.get(b) === e) return a.i.set(b, {
                    ja: h,
                    mediaSourceId: g.mediaSourceId
                }), a.g.delete(b), h;
                throw new D(p.ColibrioErrorType.ABORTED);
            }).catch(function(h) {
                a.h.revokeUrl(g.mediaSourceId);
                a.j.get(b) === e && a.g.delete(b);
                od(a.l, f);
                return Promise.reject(h);
            });
            a.g.set(b, {
                Qd: d,
                mediaSourceId: g.mediaSourceId
            });
            return d;
        }
        function Qe(a, b) {
            var c = (a.j.get(b) || 0) + 1;
            a.j.set(b, c);
            return c;
        }
        function Re(a, b, c, d) {
            this.G = b;
            this.o = d;
            this.A = !1;
            this.g = new Map;
            this.s = 0;
            this.u = -1;
            this.l = new Set;
            this.h = new Map;
            b = a.getResourceProvider();
            if (!b) throw new D("SYNC_MEDIA_RESOURCE_PROVIDER_MISSING", "SyncMediaAudioRenderer requires a ResourceProvider, but none was found in the SyncMediaTimeline.");
            d = a.getReaderPublication().getReadingSystemEngine();
            if (!d.v) {
                var e, f, g = null != (f = null == (e = d.g.platformWorkaroundOptions) ? void 0 : e.prepareSyncMediaAudioElementsOnFirstUserInteraction) ? f : !1;
                d.v = new kd(g);
            }
            this.j = new Oe(b, c, d.v);
            this.i = a.getSegments();
            this.v = a.getMediaObjects();
        }
        function Se(a, b) {
            var c = b.segmentIndex, d = a.i[c];
            if (b.ja) {
                var e = Math.floor(1E3 * Math.max(b.ja.duration, b.ja.currentTime));
                if (e < b.endMs) {
                    var f = Math.max(0, e - b.startMs);
                    d = d.getApproximateDurationMs();
                    100 < Math.abs(f - d) && (b.endMs = e, a.G.onSegmentDurationChanged(c, f));
                }
            }
        }
        Re.prototype.destroy = function() {
            this.A = !0;
            this.j.destroy();
        };
        function Te(a, b, c) {
            Ue(a, b, c);
            return (c = a.h.get(b)) ? Promise.resolve(c) : (a = a.g.get(b)) ? a : Promise.reject(new D("INVALID_SYNC_MEDIA_SEGMENT_INDEX", "SyncMediaAudioRuntimeSegmentCache - Bad segmentIndex: " + b));
        }
        function Ve(a, b, c) {
            c && Ue(a, b, 0);
            return a.h.get(b) || null;
        }
        function We(a, b) {
            if (!a.h.has(b) && !a.g.has(b)) {
                var c = a.i[b].getMediaObjectRefs().find(Xe);
                if (c) {
                    var d = a.v[c.objectIndex];
                    a.l.add(c.objectIndex);
                    var e = Pe(a.j, d, c.startMs).then(function(f) {
                        var g = Math.floor(1E3 * f.duration);
                        f = {
                            ja: f,
                            endMs: null === c.endMs ? g : c.endMs,
                            segmentIndex: b,
                            Bd: null === c.endMs,
                            startMs: c.startMs
                        };
                        a.g.has(b) && !a.A && (a.g.delete(b), a.h.set(b, f), null === c.endMs && Se(a, f));
                        return f;
                    }).catch(function(f) {
                        a.g.get(b) !== e || a.A || (p.ColibrioError.isColibrioAbortedError(f) || p.Logger.logError(f), a.g.delete(b));
                        return Promise.reject(f);
                    });
                    a.g.set(b, e);
                } else a.h.set(b, {
                    ja: null,
                    endMs: 0,
                    segmentIndex: b,
                    Bd: !1,
                    startMs: 0
                });
            }
        }
        function Ue(a, b, c) {
            if (!a.A) {
                a.u = b;
                a.s = c;
                c = m.ya(qd(a.i, a.o, b, c));
                b = c.next().value;
                c = c.next().value;
                for(var d = b; d < c; d++)We(a, d);
                Ye(a, b, c);
            }
        }
        function Ye(a, b, c) {
            for(var d = new Set, e = b; e < c; e++){
                var f = a.i[e].getMediaObjectRefs().find(Xe);
                f && d.add(f.objectIndex);
            }
            a.h.forEach(function(g, h) {
                (h < b || h >= c) && a.h.delete(h);
            });
            a.g.forEach(function(g, h) {
                (h < b || h >= c) && a.g.delete(h);
            });
            a.l.forEach(function(g) {
                if (!d.has(g)) {
                    var h = a.j;
                    g = a.v[g];
                    Qe(h, g);
                    var l = h.g.get(g);
                    l && (h.h.revokeUrl(l.mediaSourceId), h.g.delete(g));
                    if (l = h.i.get(g)) h.h.revokeUrl(l.mediaSourceId), od(h.l, l.ja), h.i.delete(g);
                }
            });
            a.l = d;
        }
        function Xe(a) {
            return a.type === x.SyncMediaObjectRefType.AUDIO;
        }
        function Ze(a, b, c, d) {
            var e = this;
            this.C = a;
            this.G = b;
            this.ra = c;
            this.l = 0;
            this.h = this.g = null;
            this.A = !1;
            this.o = -1;
            this.D = !1;
            this.M = !0;
            this.F = 1;
            this.i = null;
            this.B = 1;
            this.s = null;
            this.u = !1;
            this.L = 1;
            this.O = function() {
                $e(e);
            };
            this.v = function() {
                if (e.g && 4 <= e.g.readyState) e.G.onRuntimeReady();
            };
            this.W = function() {
                e.g && !e.g.ended && e.g.paused && !e.M && (e.M = !0, e.G.onRuntimePaused());
            };
            this.la = function() {
                e.g && !e.g.paused && e.M && e.pause();
            };
            this.ma = function() {
                af(e);
            };
            this.H = a.getSegments();
            this.j = new Re(a, b, c, d);
        }
        k = Ze.prototype;
        k.clearRangeEndPosition = function() {
            this.i = null;
        };
        k.destroy = function() {
            this.pause();
            this.A = !0;
            this.j.destroy();
        };
        k.getSegmentTargets = function() {
            return [];
        };
        k.pause = function() {
            this.M = !0;
            if (this.g && !this.g.paused) {
                var a = this.g.currentTime;
                this.g.pause();
                var b = this.g.currentTime;
                this.h && .2 < Math.abs(b - a) && (b = new D("SYNC_MEDIA_PAUSE_BUG_MITIGATED", "Audio element pause() bug detected and mitigated! (currentTime before: " + a + " s, after: " + b + " s)"), p.Logger.logWarning(b), a = new M(this.C, this.h.segmentIndex, 1E3 * a - this.h.startMs), this.seekToTimelinePosition(a));
            }
        };
        k.play = function() {
            bf(this);
        };
        k.playUntilRangeEnd = function(a, b) {
            this.i = {
                gb: a.getSegmentIndex(),
                Tb: a.getOffsetWithinSegmentMs(),
                Xb: b
            };
            bf(this);
        };
        k.seekToTimelinePosition = function(a) {
            var b = this;
            if (!this.A) {
                var c = a.getSegmentIndex(), d = a.getOffsetWithinSegmentMs(), e = ++this.B;
                cf(this);
                af(this);
                this.h = this.g = null;
                this.l = c;
                c >= this.H.length ? (this.u = !0, this.G.onRuntimeReady()) : (this.u = !1, Te(this.j, c, d).then(function(f) {
                    e !== b.B || b.A || (b.h = f, b.G.onPlaybackPositionUpdated(c, d), df(b, d));
                }).catch(function(f) {
                    if (e === b.B) b.G.onSegmentError(c, x.SyncMediaPlayerErrorType.MEDIA_LOAD_ERROR, f, !0);
                }));
            }
        };
        k.setActiveSegmentIndex = function(a) {
            this.l = a;
            if (this.h) {
                if (a < this.h.segmentIndex) this.G.onActiveSegmentFinished(a);
                else if (a > this.h.segmentIndex) (this.h = Ve(this.j, a, !0)) ? df(this, 0) : this.seekToTimelinePosition(new M(this.C, a, 0));
                else if (!this.h.ja) this.G.onActiveSegmentFinished(a);
            } else if (this.u) this.G.onActiveSegmentFinished(a);
        };
        k.setMuted = function(a) {
            this.D = a;
            this.g && (this.g.muted = a);
        };
        k.setPlaybackRate = function(a) {
            this.F = a;
            this.g && (this.g.playbackRate = a);
        };
        k.setVolume = function(a) {
            this.L = a;
            this.g && (this.g.volume = a);
        };
        k.willCallPlaybackPositionUpdated = function(a) {
            a = Ve(this.j, a, !1);
            return null !== a && null !== a.ja;
        };
        function ef(a) {
            if (!a.M && !a.s && a.h && a.h.ja) {
                var b = Date.now(), c = 1E3 * a.h.ja.currentTime - a.h.startMs;
                a.i && (a.h.segmentIndex > a.i.gb || a.h.segmentIndex === a.i.gb && c >= a.i.Tb) ? (a.pause(), ff(a, b, a.i.Tb, a.h.segmentIndex, !0), a.G.onRangeEndReached(a.i.Xb), c > a.i.Tb + 64 && a.seekToTimelinePosition(new M(a.C, a.i.gb, a.i.Tb))) : a.h.ja.currentTime >= a.h.endMs / 1E3 && !a.h.Bd ? (ff(a, b, c, a.h.segmentIndex), $e(a)) : ff(a, b, c, a.h.segmentIndex);
                null === a.s && (a.s = window.setTimeout(function() {
                    a.s = null;
                    ef(a);
                }, 32));
            }
        }
        function ff(a, b, c, d, e) {
            var f = b - a.o;
            if ((void 0 === e ? 0 : e) || 200 < f) a.o = b, a.G.onPlaybackPositionUpdated(d, c), a = a.j, a.A || a.u !== d || Math.abs(c - a.s) > .25 * a.o.preloadAheadMs && Ue(a, d, c);
        }
        function $e(a) {
            a.o = Date.now();
            if (a.h) for(var b, c = !0; c && (b = a.h) && !a.M && (b.ja && (b.ja.currentTime >= b.endMs / 1E3 || b.ja.ended) || null === b.ja);){
                c = !1;
                var d = void 0;
                (null == (d = b.ja) ? 0 : d.ended) && Se(a.j, b);
                if (b.segmentIndex === a.l) a.G.onActiveSegmentFinished(a.l);
                d = b.segmentIndex + 1;
                if (d >= a.H.length) cf(a), a.pause(), a.h = null, a.g = null, a.u = !0;
                else if (d = Ve(a.j, d, !0)) a.h = d, null !== b && null !== d && null !== b.ja && null !== d.ja && b.ja === d.ja && Math.abs(b.endMs - d.startMs) <= a.ra.alignedSegmentSeekThresholdMs ? c = !0 : df(a, 0);
            }
            else af(a);
        }
        function bf(a) {
            if (!a.A) {
                if (a.M = !1, a.o = Date.now(), a.g) {
                    a.g.playbackRate = a.F;
                    a.g.volume = a.L;
                    a.g.muted = a.D;
                    if (a.g.paused) {
                        if (a.g.ended) $e(a);
                        else {
                            var b = a.g.play();
                            b && b.catch && b.catch(function(c) {
                                a.A || "AbortError" === c.name || (a.pause(), a.G.onSegmentError(a.h ? a.h.segmentIndex : a.l, "NotAllowedError" === c.name ? x.SyncMediaPlayerErrorType.PLAYBACK_NOT_ALLOWED : "NotSupportedError" === c.name ? x.SyncMediaPlayerErrorType.MEDIA_NOT_SUPPORTED : x.SyncMediaPlayerErrorType.UNKNOWN_ERROR, c, !0));
                            });
                        }
                    }
                    ef(a);
                } else a.G.onActiveSegmentFinished(a.l);
            }
        }
        function cf(a) {
            a.g && (a.g.removeEventListener("canplaythrough", a.v), a.g.removeEventListener("seeked", a.v), a.g.removeEventListener("ended", a.O), a.g.removeEventListener("pause", a.W), a.g.removeEventListener("play", a.la), a.g.removeEventListener("waiting", a.ma));
        }
        function af(a) {
            a.pause();
            a.G.onRuntimeWaiting();
        }
        function df(a, b) {
            cf(a);
            a.g && a.g.pause();
            if (a.h && a.h.ja) {
                a.g = a.h.ja;
                a.g.addEventListener("canplaythrough", a.v);
                a.g.addEventListener("ended", a.O);
                a.g.addEventListener("pause", a.W);
                a.g.addEventListener("play", a.la);
                a.g.addEventListener("seeked", a.v);
                a.g.addEventListener("waiting", a.ma);
                var c = a.g.currentTime;
                var d = (a.h.startMs + b) / 1E3;
                if (c === d) c = !0;
                else {
                    var e = Math.abs(c - d);
                    c = Math.abs(c);
                    d = Math.abs(d);
                    c = e <= (d > c ? d : c) * Number.EPSILON;
                }
                if (!c || p.BrowserDetector.isRenderingEngine("EdgeHTML")) a.g.currentTime = (a.h.startMs + b) / 1E3;
                if (4 <= a.g.readyState && !p.BrowserDetector.isRenderingEngine("EdgeHTML") && !a.g.seeking) a.G.onRuntimeReady();
                else af(a);
            } else a.g = null, a.G.onRuntimeReady();
            a.M || a.play();
        }
        function gf(a) {
            this.g = y(a, ld());
        }
        function ld() {
            return {
                alignedSegmentSeekThresholdMs: 500,
                audioElementPoolSize: 10,
                enableBlobUrls: null,
                enableMediaStreaming: !1
            };
        }
        gf.prototype.createRuntime = function(a, b, c) {
            return new Ze(a, b, this.g, c);
        };
        gf.prototype.destroyRuntime = function(a) {
            a instanceof Ze && a.destroy();
        };
        gf.prototype.getSupportedMediaObjectRefType = function() {
            return x.SyncMediaObjectRefType.AUDIO;
        };
        function hf(a, b, c) {
            var d = this;
            this.g = c;
            this.j = null;
            this.l = Date.now();
            this.h = this.i = this.I = null;
            this.o = function() {
                null !== d.i && (clearTimeout(d.i), d.i = null);
            };
            this.s = function() {
                d.j && jf(d, d.j);
            };
            this.u = function(e) {
                null !== d.i && (clearTimeout(d.i), d.i = null);
                d.j = e.state;
                if (d.h && d.I) {
                    var f = e.state.mediaPlayerPositionRelativeToVisibleRange;
                    if (f === x.SyncMediaPositionRelativeToVisibleRange.VISIBLE) e.state.triggeredBy === x.SyncMediaSyncEventTrigger.READER_VIEW_NAVIGATION && d.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.SYNC_MEDIA_SEEK, e.state.resolvedReaderViewReadingPosition.syncMediaTimelinePosition);
                    else if (e.state.triggeredBy === x.SyncMediaSyncEventTrigger.SYNC_MEDIA_PLAYBACK && d.I.isAtEnd() && !d.h.getReaderView().isAtEnd()) kf(d, d.g.timeToDisplayPagesWithoutSyncMedia);
                    else if (e.state.triggeredBy === x.SyncMediaSyncEventTrigger.READER_VIEW_NAVIGATION || e.state.triggeredBy === x.SyncMediaSyncEventTrigger.READER_VIEW_SCROLL) {
                        var g = f = e.state.resolvedReaderViewReadingPosition.syncMediaTimelinePosition;
                        if (d.g.alwaysSeekToSegmentStart) {
                            if (e.state.triggeredBy === x.SyncMediaSyncEventTrigger.READER_VIEW_SCROLL && d.I.getTimelinePosition().getSegmentIndex() === e.state.visibleTimelineRange.start.getSegmentIndex() && !lf(e.state.visibleTimelineRange)) return;
                            g = new M(g.getTimeline(), g.getSegmentIndex(), 0);
                        }
                        d.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.SYNC_MEDIA_SEEK, g);
                        if (lf(e.state.visibleTimelineRange) || !f.isBefore(e.state.visibleTimelineRange.end)) "visible" === document.visibilityState ? kf(d, d.g.timeToDisplayPagesWithoutSyncMedia) : d.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO, void 0, e.state.resolvedMediaPlayerPosition.contentLocation);
                    } else e.state.triggeredBy === x.SyncMediaSyncEventTrigger.SYNC_MEDIA_SEEK ? f !== x.SyncMediaPositionRelativeToVisibleRange.NO_MATCHING_DOCUMENT && (f === x.SyncMediaPositionRelativeToVisibleRange.NEXT ? d.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_NEXT, void 0, e.state.resolvedMediaPlayerPosition.contentLocation) : f === x.SyncMediaPositionRelativeToVisibleRange.PREVIOUS ? d.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_PREVIOUS, void 0, e.state.resolvedMediaPlayerPosition.contentLocation) : d.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO, void 0, e.state.resolvedMediaPlayerPosition.contentLocation)) : e.state.triggeredBy === x.SyncMediaSyncEventTrigger.SYNC_MEDIA_PLAYBACK && jf(d, e.state);
                }
            };
            this.v = function() {
                d.l = Date.now();
            };
            this.I = a;
            this.h = b;
            a = this.h.getReaderView();
            a.addEngineEventListener("visibleRangeChanged", this.v);
            a.addEngineEventListener("syncMediaReaderViewSynchronizationStateChanged", this.u);
            a.addEngineEventListener("syncMediaPlay", this.s);
            a.addEngineEventListener("syncMediaPaused", this.o);
        }
        hf.prototype.destroy = function() {
            if (this.h) {
                var a = this.h.getReaderView();
                a.removeEngineEventListener("visibleRangeChanged", this.v);
                a.removeEngineEventListener("syncMediaReaderViewSynchronizationStateChanged", this.u);
                a.removeEngineEventListener("syncMediaPlay", this.s);
                a.removeEngineEventListener("syncMediaPaused", this.o);
                this.h = null;
            }
        };
        hf.prototype.setOptions = function(a) {
            this.g = a;
        };
        function jf(a, b) {
            if (a.h && a.I) {
                var c = b.mediaPlayerPositionRelativeToVisibleRange;
                if (c === x.SyncMediaPositionRelativeToVisibleRange.NO_MATCHING_DOCUMENT) b.triggeredBy !== x.SyncMediaSyncEventTrigger.SYNC_MEDIA_PLAYBACK && b.triggeredBy !== x.SyncMediaSyncEventTrigger.READER_VIEW_NAVIGATION || !a.I.isAtEnd() || kf(a, a.g.timeToDisplayPagesWithoutSyncMedia);
                else if (!a.g.alwaysSeekToSegmentStart || a.I.getTimelinePosition().getSegmentIndex() !== b.visibleTimelineRange.start.getSegmentIndex() || lf(b.visibleTimelineRange)) {
                    var d = b.resolvedMediaPlayerPosition.contentLocation;
                    c === x.SyncMediaPositionRelativeToVisibleRange.PREVIOUS ? a.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_PREVIOUS, void 0, d) : c === x.SyncMediaPositionRelativeToVisibleRange.BEFORE_PREVIOUS ? a.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO, void 0, d) : c === x.SyncMediaPositionRelativeToVisibleRange.NEXT || c === x.SyncMediaPositionRelativeToVisibleRange.AFTER_NEXT ? a.g.navigateOnVisibleRangeEndReached && ("visible" === document.visibilityState ? (c = Date.now() - a.l, lf(b.visibleTimelineRange) ? kf(a, a.g.timeToDisplayPagesWithoutSyncMedia) : c < a.g.minimumTimeToDisplayPagesWithSyncMedia ? kf(a, a.g.minimumTimeToDisplayPagesWithSyncMedia - c, d) : a.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_NEXT, void 0, d)) : a.I.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO, void 0, d)) : a.I.isAtEnd() && kf(a, a.g.timeToDisplayPagesWithoutSyncMedia);
                }
            }
        }
        function lf(a) {
            return !!a && a.start.equals(a.end);
        }
        function kf(a, b, c) {
            a.I && !a.I.isPaused() && a.g.navigateOnVisibleRangeEndReached && a.h && !a.h.getReaderView().isAtEnd() && (a.i = window.setTimeout(function() {
                if (a.g.navigateOnVisibleRangeEndReached) {
                    if (a.g.skipPagesWithoutSyncMedia) {
                        var d;
                        null == (d = a.I) || d.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO, void 0, void 0);
                    } else {
                        var e;
                        null == (e = a.I) || e.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_NEXT, void 0, c);
                    }
                }
            }, b));
        }
        function Q(a, b) {
            G.call(this, a, b);
            this.dc = b.I.getApproximateElapsedTimeMs();
            var c;
            this.oa = null != (c = b.Md) ? c : b.I.getTimelinePosition();
        }
        m.inherits(Q, G);
        Q.prototype.toJSON = function() {
            var a = G.prototype.toJSON.call(this), b = {
                approximateElapsedTimeMs: this.dc,
                objectType: x.EngineEventDataObjectType.SYNC_MEDIA_ENGINE_EVENT,
                syncMediaPlayerName: this.m.I.getName(),
                syncMediaTimelinePosition: this.oa.toJSON()
            };
            return Object.assign(a, b);
        };
        m.global.Object.defineProperties(Q.prototype, {
            approximateElapsedTimeMs: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.dc;
                }
            },
            timelinePosition: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.oa;
                }
            },
            syncMediaPlayer: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.I;
                }
            }
        });
        function mf(a, b) {
            Q.call(this, a, b);
        }
        m.inherits(mf, Q);
        mf.prototype.toJSON = function() {
            var a = Q.prototype.toJSON.call(this);
            return Object.assign(a, {
                error: String(this.m.tb),
                errorMessage: this.errorMessage,
                errorType: this.m.Qc,
                objectType: x.EngineEventDataObjectType.SYNC_MEDIA_ERROR_ENGINE_EVENT,
                paused: this.m.M,
                segmentIndex: this.m.U
            });
        };
        m.global.Object.defineProperties(mf.prototype, {
            error: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.tb;
                }
            },
            errorMessage: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.tb instanceof Error ? this.m.tb.message : Ha(this.m.tb) ? this.m.tb : null;
                }
            },
            errorType: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Qc;
                }
            },
            paused: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.M;
                }
            },
            segmentIndex: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.U;
                }
            }
        });
        function nf(a, b) {
            Q.call(this, a, b);
            this.Cb = void 0;
            this.Cb = b.Cb;
            this.g = b.Bb;
        }
        m.inherits(nf, Q);
        nf.prototype.toJSON = function() {
            var a = Q.prototype.toJSON.call(this), b = {
                objectType: x.EngineEventDataObjectType.SYNC_MEDIA_RANGE_ENGINE_EVENT,
                playbackRange: this.g.toJSON(),
                reason: this.Cb
            };
            return Object.assign(a, b);
        };
        m.global.Object.defineProperties(nf.prototype, {
            playbackRange: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g;
                }
            },
            reason: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.Cb;
                }
            }
        });
        function of(a, b) {
            Q.call(this, a, b);
        }
        m.inherits(of, Q);
        of.prototype.toJSON = function() {
            var a = Q.prototype.toJSON.call(this), b = this.m.fd.map(function(c) {
                var d = c.contentLocation;
                return {
                    frameworkComponent: c.frameworkComponent,
                    locator: d ? d.getLocator().toJSON() : null,
                    mediaType: c.mediaType,
                    nodeData: c.nodeData,
                    objectType: x.EngineEventTargetObjectType.SYNC_MEDIA_SEGMENT_TARGET,
                    readerDocumentIndexInSpine: d ? d.getReaderDocuments()[0].getIndexInSpine() : null
                };
            });
            return Object.assign(a, {
                objectType: x.EngineEventDataObjectType.SYNC_MEDIA_SEGMENT_ACTIVE_ENGINE_EVENT,
                segmentIndex: this.m.U,
                targets: b
            });
        };
        m.global.Object.defineProperties(of.prototype, {
            segmentIndex: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.U;
                }
            },
            targets: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.fd;
                }
            }
        });
        function pf(a) {
            Q.call(this, "syncMediaSegmentDurationChanged", a);
        }
        m.inherits(pf, Q);
        pf.prototype.toJSON = function() {
            var a = Q.prototype.toJSON.call(this);
            return Object.assign(a, {
                newDurationMs: this.m.Zc,
                objectType: x.EngineEventDataObjectType.SYNC_MEDIA_SEGMENT_DURATION_CHANGED_EVENT,
                oldDurationMs: this.m.bd,
                segmentIndex: this.m.U
            });
        };
        m.global.Object.defineProperties(pf.prototype, {
            newDurationMs: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Zc;
                }
            },
            oldDurationMs: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.bd;
                }
            },
            segmentIndex: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.U;
                }
            }
        });
        function qf(a) {
            Q.call(this, "syncMediaWaiting", a);
        }
        m.inherits(qf, Q);
        qf.prototype.toJSON = function() {
            var a = Q.prototype.toJSON.call(this);
            return Object.assign(a, {
                objectType: x.EngineEventDataObjectType.SYNC_MEDIA_WAITING_ENGINE_EVENT,
                waitingForMediaObjectRenderers: this.m.rd,
                waitingForReaderViewSynchronization: this.m.sd
            });
        };
        m.global.Object.defineProperties(qf.prototype, {
            waitingForMediaObjectRenderers: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.rd;
                }
            },
            waitingForReaderViewSynchronization: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.sd;
                }
            }
        });
        function rf(a, b, c, d, e) {
            this.ca = d;
            this.s = e;
            this.i = !1;
            this.h = 0;
            this.g = !1;
            this.M = !0;
            this.o = null;
            this.Ma = !1;
            this.l = 0;
            this.j = a;
            this.P = d.createRuntime(b, this, c);
        }
        k = rf.prototype;
        k.bindRenderableDocumentPage = function(a) {
            B(this.P.bindRenderableDocumentPage) && this.P.bindRenderableDocumentPage(a);
        };
        k.clearRangeEndPosition = function() {
            this.g = !1;
            this.o = null;
            this.P.clearRangeEndPosition();
        };
        k.destroy = function() {
            this.j = null;
            this.ca.destroyRuntime(this.P);
        };
        k.isPaused = function() {
            return this.M;
        };
        k.isReady = function() {
            return this.Ma;
        };
        k.onActiveSegmentFinished = function(a) {
            this.M && p.Logger.logWarning("onActiveSegmentFinished called while paused!");
            this.h === a ? this.i = !0 : p.Logger.logError("onActiveSegmentFinished WRONG SEGMENT INDEX, got: " + a + ", expected: " + this.h);
            sf(this, function(b) {
                tf(b, a);
            });
        };
        k.onPlayRequest = function() {
            sf(this, function(a) {
                uf(a, !1);
            });
        };
        k.onPlaybackPositionUpdated = function(a, b) {
            sf(this, function(c, d) {
                c.Uc === d && (d = new M(c.Va, a, b), d.isAfter(c.oa) && (c.V && d.isAfter(c.V.range.end) ? (p.Logger.logError(new Cd("A SyncMediaObjectRendererRuntime reported a timeline position after playback range end.")), vf(c, c.V.range.end)) : vf(c, d)));
            });
        };
        k.onRangeEndReached = function(a) {
            var b = this;
            this.M = !0;
            sf(this, function(c) {
                a === b.o && (b.g = !0, wf(c, a));
            });
        };
        k.onRuntimePaused = function() {
            this.M = !0;
            sf(this, function(a) {
                uf(a, !0);
            });
        };
        k.onRuntimeReady = function() {
            this.Ma = !0;
            sf(this, function(a) {
                xf(a);
            });
        };
        k.onRuntimeWaiting = function() {
            this.Ma = !1;
            this.M = !0;
            sf(this, function(a) {
                xf(a);
            });
        };
        k.onSegmentDurationChanged = function(a, b) {
            sf(this, function(c, d) {
                c._onSegmentDurationChanged(d, a, b);
            });
        };
        k.onSegmentError = function(a, b, c, d) {
            d && (this.M = !0);
            sf(this, function(e) {
                p.Logger.logError(c);
                var f, g = new mf("syncMediaError", {
                    tb: c,
                    Qc: b,
                    M: d,
                    U: a,
                    I: e.fb,
                    readerView: (null == (f = e.pa) ? void 0 : f.getReaderView()) || null
                });
                yf(e, g);
                d && uf(e, !0);
            });
        };
        k.pause = function() {
            this.M || (this.M = !0, this.P.pause());
        };
        k.play = function() {
            this.M && (this.M = !1, this.P.play());
        };
        k.playUntilRangeEnd = function(a, b) {
            this.M && (this.M = !1);
            this.o = b;
            this.P.playUntilRangeEnd(a, b);
        };
        function zf(a, b) {
            a.l++;
            a.M = !0;
            a.Ma = !1;
            a.h = b.getSegmentIndex();
            a.i = !1;
            a.g = !1;
            a.P.seekToTimelinePosition(b);
        }
        k.setActiveSegmentIndex = function(a) {
            this.h = a;
            this.i = !1;
            this.P.setActiveSegmentIndex(a);
        };
        k.setMuted = function(a) {
            this.P.setMuted(a);
        };
        k.setPlaybackRate = function(a) {
            this.P.setPlaybackRate(a);
        };
        k.setVolume = function(a) {
            this.P.setVolume(a);
        };
        k.unbindRenderableDocumentPage = function(a) {
            B(this.P.unbindRenderableDocumentPage) && this.P.unbindRenderableDocumentPage(a);
        };
        function sf(a, b) {
            var c = a.l;
            Promise.resolve().then(function() {
                a.j && c === a.l && b(a.j, a.s);
            }).catch(function(d) {
                p.ColibrioError.isColibrioAbortedError(d) || p.Logger.logError(d);
            });
        }
        function Af(a, b, c) {
            this.Bb = a;
            this.h = b;
            this.g = c;
        }
        Af.prototype.toJSON = function() {
            return {
                id: this.id,
                options: this.options,
                range: {
                    end: this.Bb.end.toJSON(),
                    start: this.Bb.start.toJSON()
                }
            };
        };
        m.global.Object.defineProperties(Af.prototype, {
            id: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g;
                }
            },
            options: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return La(this.h);
                }
            },
            range: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.Bb;
                }
            }
        });
        function Bf(a, b, c, d) {
            var e = this;
            this.fb = a;
            this.Va = b;
            this.v = c;
            this.H = d;
            this.h = 0;
            this.B = !1;
            this.g = [];
            this.o = this.A = !1;
            this.V = null;
            this.C = !1;
            this.Uc = -1;
            this.u = !1;
            this.M = !0;
            this.s = 1;
            this.L = 0;
            this.Ma = !0;
            this.j = !1;
            this.oa = new M(this.Va, 0, 0);
            this.pa = null;
            this.l = !1;
            this.O = function(f) {
                e.B = f;
            };
            this.D = function(f) {
                e.g.forEach(function(g) {
                    return g.bindRenderableDocumentPage(f.g);
                });
            };
            this.F = function(f) {
                e.g.forEach(function(g) {
                    return g.unbindRenderableDocumentPage(f.g);
                });
            };
            this.i = b.getSegments();
            c && c.g.add(this.O);
        }
        function wf(a, b) {
            if (a.V && b === a.V.id) {
                var c = a.V.range.end.getSegmentIndex();
                a.g.every(function(d) {
                    return d.g || !d.P.willCallPlaybackPositionUpdated(c);
                }) && Cf(a);
            }
        }
        k = Bf.prototype;
        k._onSegmentDurationChanged = function(a, b, c) {
            if (!(b >= this.i.length)) {
                a = this.i[b].getApproximateDurationMs();
                this.Va.updateSegmentDuration(b, c);
                var d;
                b = new pf({
                    Zc: c,
                    bd: a,
                    U: b,
                    I: this.fb,
                    readerView: (null == (d = this.pa) ? void 0 : d.getReaderView()) || null
                });
                yf(this, b);
            }
        };
        k.addMediaObjectRenderer = function(a, b) {
            if (!this.A) {
                var c = new rf(this, this.Va, b, a, this.g.length);
                this.g.push(c);
                c.setVolume(1);
                c.setMuted(!1);
                c.setPlaybackRate(this.s);
                if (B(c.P.onSyncMediaPlayerPauseStateChanged)) c.P.onSyncMediaPlayerPauseStateChanged(this.M);
                this.pa && this.pa.Pa.hb().forEach(function(d) {
                    c.bindRenderableDocumentPage(d);
                });
                this.o && (this.oa.getSegmentIndex() > this.h ? zf(c, new M(this.Va, this.h, this.i[this.h].getApproximateDurationMs())) : zf(c, this.oa));
                xf(this);
            }
        };
        k.destroy = function() {
            this.g.forEach(function(a) {
                return a.destroy();
            });
            this.g = [];
            this.Ma = this.M = !0;
            Df(this, null);
            this.A = !0;
        };
        k.getApproximateElapsedTimeMs = function() {
            return this.Va.getApproximateOffsetMs(this.oa);
        };
        k.getMediaObjectRenderers = function() {
            return this.g.map(function(a) {
                return a.ca;
            });
        };
        k.getPlaybackRange = function() {
            return this.V;
        };
        k.getPlaybackRate = function() {
            return this.s;
        };
        k.getTimelinePosition = function() {
            return this.oa;
        };
        k.getVolume = function() {
            return 1;
        };
        k.isAtEnd = function() {
            return this.h === this.i.length;
        };
        k.isMuted = function() {
            return !1;
        };
        k.isPaused = function() {
            return this.M;
        };
        k.isReady = function() {
            return this.Ma;
        };
        k.isSeeking = function() {
            return this.j;
        };
        k.isWaitingForMediaObjectRenderers = function() {
            return !this.u;
        };
        k.isWaitingForReaderViewSynchronization = function() {
            return this.l && !this.isAtEnd();
        };
        k.removeMediaObjectRenderer = function(a) {
            var b = this.g.findIndex(function(c) {
                return c.ca === a;
            });
            if (-1 === b) return !1;
            this.g[b].destroy();
            for(this.g.splice(b, 1); b < this.g.length; b++)this.g[b].s = b;
            xf(this);
            return !0;
        };
        k.removePlaybackRange = function() {
            Ef(this, x.SyncMediaRangePlaybackRemoveReason.APP_GENERATED);
        };
        k.setMuted = function(a) {
            this.g.forEach(function(b) {
                return b.setMuted(a);
            });
        };
        k.setPlaybackRange = function(a, b, c, d) {
            Ef(this, x.SyncMediaRangePlaybackRemoveReason.RANGE_REPLACED);
            d && Ff(this, a, null);
            this.V = new Af({
                end: b,
                start: a
            }, c, ++this.L);
            Gf(this);
            return this.V;
        };
        k.setPlaybackRate = function(a) {
            this.s = a;
            this.g.forEach(function(b) {
                return b.setPlaybackRate(a);
            });
        };
        function Df(a, b) {
            !a.A && a.pa !== b && (a.pa && (R(a.pa, "renderablePageLoaded", a.D), R(a.pa, "renderablePageUnloaded", a.F), a.pa.Pa.hb().forEach(function(c) {
                a.g.forEach(function(d) {
                    return d.unbindRenderableDocumentPage(c);
                });
            })), a.pa = b) && (T(b, "renderablePageLoaded", a.D), T(b, "renderablePageUnloaded", a.F), b.Pa.hb().forEach(function(c) {
                a.g.forEach(function(d) {
                    return d.bindRenderableDocumentPage(c);
                });
            }));
        }
        k.setVolume = function(a) {
            this.g.forEach(function(b) {
                return b.setVolume(a);
            });
        };
        function Hf(a, b) {
            a.l !== b && (a.l = b, xf(a));
        }
        function yf(a, b) {
            a.A || (a.pa ? V(a.pa, b) : a.fb.getReadingSystemEngine().getEventBus().emitAsync(b));
        }
        function If(a, b) {
            var c;
            b = new Q(b, {
                dc: a.getApproximateElapsedTimeMs(),
                I: a.fb,
                oa: a.oa,
                readerView: (null == (c = a.pa) ? void 0 : c.getReaderView()) || null
            });
            yf(a, b);
        }
        function Jf(a, b, c) {
            if (a.V) {
                var d;
                b = new nf(b, {
                    Bb: a.V,
                    Cb: c,
                    I: a.fb,
                    readerView: (null == (d = a.pa) ? void 0 : d.getReaderView()) || null
                });
                yf(a, b);
            }
        }
        function Kf(a) {
            var b = new of("syncMediaSegmentActive", {
                fd: [],
                U: a.h,
                I: a.fb,
                readerView: a.pa ? a.pa.getReaderView() : null
            });
            yf(a, b);
        }
        function Lf(a, b) {
            b = new Q("syncMediaSegmentFinished", {
                I: a.fb,
                Md: b,
                readerView: a.pa ? a.pa.getReaderView() : null
            });
            yf(a, b);
        }
        function Mf(a) {
            var b = new qf({
                I: a.fb,
                rd: a.isWaitingForMediaObjectRenderers(),
                sd: a.l,
                readerView: a.pa ? a.pa.getReaderView() : null
            });
            yf(a, b);
        }
        function tf(a, b) {
            a.h === b && a.g.every(function(c) {
                return c.i && !c.isPaused() && c.isReady();
            }) && (0 <= a.h && a.h < a.i.length && Lf(a, new M(a.Va, a.h, a.i[a.h].getApproximateDurationMs())), a.h++, a.oa.getSegmentIndex() < a.h && vf(a, new M(a.Va, a.h, 0)), Kf(a), a.g.forEach(function(c) {
                return c.setActiveSegmentIndex(a.h);
            }), xf(a));
        }
        function Ef(a, b) {
            if (a.V) {
                Jf(a, "syncMediaRangeRemoved", b);
                a.V.options.pauseOnRangeRemoved && uf(a, !0);
                b = m.ya(a.g);
                for(var c = b.next(); !c.done; c = b.next())c.value.clearRangeEndPosition();
                a.V = null;
            }
        }
        function Ff(a, b, c) {
            a.A || (c && Nf(a, b, c) && Ef(a, c), a.o = !0, a.V && c === x.SyncMediaRangePlaybackRemoveReason.SEEK && a.V.options.seekBehaviour === x.SyncMediaRangeSeekBehavior.CLAMP_TO_RANGE && (b.isBefore(a.V.range.start) ? b = a.V.range.start : b.isAfter(a.V.range.end) && (b = a.V.range.end)), a.h = b.getSegmentIndex(), a.H(b), a.j || (a.j = !0, If(a, "syncMediaSeeking")), a.g.forEach(function(d) {
                return zf(d, b);
            }), xf(a), vf(a, b), a.Ma && (a.j = !1, If(a, "syncMediaSeeked"), Kf(a)));
        }
        function uf(a, b) {
            a.A || a.M === b || (a.M = b, If(a, b ? "syncMediaPaused" : "syncMediaPlay"), a.g.forEach(function(c) {
                if (B(c.P.onSyncMediaPlayerPauseStateChanged)) c.P.onSyncMediaPlayerPauseStateChanged(b);
            }), b || a.o || (a.o = !0, a.g.forEach(function(c) {
                return zf(c, a.oa);
            })), Gf(a));
        }
        function Nf(a, b, c) {
            if (!a.V) return !1;
            b = b.isBefore(a.V.range.start) || b.isAfter(a.V.range.end);
            switch(a.V.options.seekBehaviour){
                case x.SyncMediaRangeSeekBehavior.ALWAYS_REMOVE_RANGE:
                    return !0;
                case x.SyncMediaRangeSeekBehavior.REMOVE_IF_OUTSIDE_RANGE:
                    return b;
                case x.SyncMediaRangeSeekBehavior.CLAMP_TO_RANGE:
                    return b && c === x.SyncMediaRangePlaybackRemoveReason.READER_VIEW_SYNC;
            }
        }
        function Cf(a) {
            a.V && (a.oa.isBefore(a.V.range.end) && vf(a, a.V.range.end), Jf(a, "syncMediaRangeEndReached"), a.V.options.removeRangeOnEndReached && Ef(a, x.SyncMediaRangePlaybackRemoveReason.END_REACHED), uf(a, !0));
        }
        function Gf(a) {
            if (a.isAtEnd() || a.M || a.l || !a.g.every(function(d) {
                return d.isReady();
            }) || a.B) a.g.forEach(function(d) {
                return d.pause();
            });
            else if (a.V) {
                if (a.oa.equals(a.V.range.end)) Cf(a);
                else {
                    for(var b = m.ya(a.g), c = b.next(); !c.done; c = b.next())c = c.value, c.g || c.playUntilRangeEnd(a.V.range.end, a.V.id);
                    tf(a, a.h);
                }
            } else a.g.forEach(function(d) {
                return d.play();
            }), tf(a, a.h);
        }
        function xf(a) {
            var b = 0 < a.g.length && a.g.every(function(f) {
                return f.isReady();
            }), c = a.u !== b, d = a.isWaitingForReaderViewSynchronization(), e = d !== a.C;
            a.C = d;
            c && (a.u = b);
            b = !d && b;
            a.Ma !== b && (a.Ma = b, a.j && b && (a.j = !1, If(a, "syncMediaSeeked"), Kf(a)), b && If(a, "syncMediaReady"), Gf(a));
            b || !c && !e || Mf(a);
            b && (a.Uc = a.g.findIndex(function(f) {
                return f.P.willCallPlaybackPositionUpdated(a.h);
            }));
        }
        function vf(a, b) {
            var c = a.i.length, d = a.oa.getSegmentIndex() === c;
            a.oa = b;
            If(a, "syncMediaTimelinePositionChanged");
            d || b.getSegmentIndex() !== c || (If(a, "syncMediaEndReached"), Gf(a));
            a.v && (b = a.v, a = a.Va.getReaderPublication(), (a = b.i.get(a)) && Cc(a));
        }
        function Of(a, b, c) {
            var d = this;
            this.g = a;
            this.j = b;
            this.h = c;
            this.i = function(e) {
                e = e.state;
                var f = e.mediaPlayerPositionRelativeToVisibleRange;
                if (f === x.SyncMediaPositionRelativeToVisibleRange.NO_MATCHING_DOCUMENT || f === x.SyncMediaPositionRelativeToVisibleRange.VISIBLE) {
                    var g = !1;
                    f === x.SyncMediaPositionRelativeToVisibleRange.NO_MATCHING_DOCUMENT && d.h === x.SyncMediaReaderViewSynchronizationWaitBehavior.WAIT_OUTSIDE_VISIBLE && (f = e.resolvedMediaPlayerPosition.syncMediaTimelinePosition, e.nextTimelineRange && !f.isBefore(e.nextTimelineRange.start) && (g = !0), e.previousTimelineRange && f.isBefore(e.previousTimelineRange.end) && (g = !0));
                    Hf(d.g, g);
                } else d.h === x.SyncMediaReaderViewSynchronizationWaitBehavior.WAIT_OUTSIDE_VISIBLE ? Hf(d.g, !0) : d.h === x.SyncMediaReaderViewSynchronizationWaitBehavior.WAIT_OUTSIDE_ADJACENT && (f === x.SyncMediaPositionRelativeToVisibleRange.AFTER_NEXT || f === x.SyncMediaPositionRelativeToVisibleRange.BEFORE_PREVIOUS ? Hf(d.g, !0) : Hf(d.g, !1));
            };
            T(b, "syncMediaReaderViewSynchronizationStateChanged", this.i);
            Hf(a, this.h !== x.SyncMediaReaderViewSynchronizationWaitBehavior.DONT_WAIT);
        }
        Of.prototype.destroy = function() {
            R(this.j, "syncMediaReaderViewSynchronizationStateChanged", this.i);
            Hf(this.g, !1);
        };
        Of.prototype.setReaderViewSynchronizationWaitBehavior = function(a) {
            this.h = a;
            this.h === x.SyncMediaReaderViewSynchronizationWaitBehavior.DONT_WAIT && Hf(this.g, !1);
        };
        function Pf(a, b) {
            var c = this;
            this.I = a;
            this.u = Date.now();
            this.h = 0;
            this.j = this.i = null;
            this.l = function() {
                var d, e = null == (d = c.g) ? void 0 : d.jb;
                e && Qf(e, function(f) {
                    Rf(c, f);
                });
            };
            this.o = function() {
                c.h++;
            };
            this.v = function() {
                Sf(c, !0);
            };
            this.B = function() {
                Sf(c, !1);
            };
            this.s = a.getTimelinePosition();
            this.g = b;
            T(this.g, "navigationRangeResultChanged", this.l);
            T(this.g, "syncMediaTimelinePositionChanged", this.B);
            T(this.g, "navigationStarted", this.o);
            T(this.g, "syncMediaPaused", this.v);
            this.l();
        }
        Pf.prototype.destroy = function() {
            this.g && (R(this.g, "navigationRangeResultChanged", this.l), R(this.g, "syncMediaTimelinePositionChanged", this.B), R(this.g, "navigationStarted", this.o), R(this.g, "syncMediaPaused", this.v), this.g = null);
        };
        function Sf(a, b) {
            var c = a.I.getTimelinePosition(), d = Date.now(), e = d - a.u, f = a.s.getSegmentIndex() !== c.getSegmentIndex();
            if (a.i && a.g && !a.g.isNavigating() && (200 < e || f || b) && (a.s = c, a.u = d, !c.isBefore(a.i.start) && c.isBefore(a.i.end))) {
                var g = a.h;
                b = [];
                d = a.I.getTimeline();
                b.push(d.fetchContentLocation(c));
                b.push(Tf(a.I));
                Promise.all(b).then(function(h) {
                    var l = h[0];
                    h = h[1];
                    if (a.h === g && a.g) {
                        var r = l;
                        a.j && l.isBefore(a.j.collapseToStart()) && (r = a.j.collapseToStart());
                        l = a.g;
                        l.C && l.C.contains(r) && Uf(l, r, h);
                    }
                }).catch(function(h) {
                    p.ColibrioError.isColibrioAbortedError(h) || p.Logger.logError(h);
                });
            }
        }
        function Rf(a, b) {
            if (a.g) {
                a.i = null;
                a.j = null;
                var c = b.visible;
                if (c) {
                    b = [];
                    var d = a.I.getTimeline();
                    b.push(d.fetchTimelinePosition(c.collapseToStart()));
                    b.push(d.fetchTimelinePosition(c.collapseToEnd()));
                    var e = a.h;
                    Promise.all(b).then(function(f) {
                        a.h === e && (a.i = {
                            end: f[1],
                            start: f[0]
                        }, a.j = c);
                    }).catch(function(f) {
                        p.ColibrioError.isColibrioAbortedError(f) || p.Logger.logError(f);
                    });
                }
            }
        }
        function Vf(a) {
            G.call(this, "syncMediaReaderViewSynchronizationStateChanged", a);
        }
        m.inherits(Vf, G);
        Vf.prototype.toJSON = function() {
            var a = G.prototype.toJSON.call(this), b = {
                objectType: x.EngineEventDataObjectType.SYNC_MEDIA_VIEW_SYNCHRONIZATION_STATE_CHANGED_ENGINE_EVENT,
                state: this.m.va.toJSON(),
                syncMediaPlayerName: this.m.I.getName()
            };
            return Object.assign(a, b);
        };
        m.global.Object.defineProperties(Vf.prototype, {
            readerView: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerView;
                }
            },
            state: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.va;
                }
            },
            syncMediaPlayer: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.I;
                }
            }
        });
        function Wf(a) {
            this.m = a;
        }
        Wf.prototype.toJSON = function() {
            var a = this.m.ia.previous, b = this.m.ia.visible, c = this.m.ia.next;
            return {
                mediaPlayerPositionRelativeToVisibleRange: this.m.Qa,
                nextTimelineRange: c ? Xf(c) : null,
                previousTimelineRange: a ? Xf(a) : null,
                resolvedMediaPlayerPosition: Yf(this.m.jd),
                resolvedReaderViewReadingPosition: Yf(this.m.kd),
                triggeredBy: this.m.Ea,
                visibleTimelineRange: Xf(b)
            };
        };
        function Yf(a) {
            return {
                locator: a.contentLocation.toJSON(),
                readerDocumentIndexInSpine: a.contentLocation.getReaderDocuments()[0].getIndexInSpine(),
                syncMediaTimelinePosition: a.syncMediaTimelinePosition.toJSON()
            };
        }
        function Xf(a) {
            return {
                end: a.end.toJSON(),
                start: a.start.toJSON()
            };
        }
        m.global.Object.defineProperties(Wf.prototype, {
            mediaPlayerPositionRelativeToVisibleRange: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Qa;
                }
            },
            nextTimelineRange: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ia.next;
                }
            },
            previousTimelineRange: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ia.previous;
                }
            },
            resolvedMediaPlayerPosition: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.jd;
                }
            },
            resolvedReaderViewReadingPosition: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.kd;
                }
            },
            triggeredBy: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Ea;
                }
            },
            visibleTimelineRange: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ia.visible;
                }
            }
        });
        function Zf(a, b) {
            var c = this;
            this.I = b;
            this.H = this.F = 0;
            this.v = this.i = -1;
            this.j = this.h = null;
            this.Qa = x.SyncMediaPositionRelativeToVisibleRange.VISIBLE;
            this.O = 0;
            this.l = null;
            this.B = 0;
            this.o = !0;
            this.Ea = this.ia = null;
            this.C = {
                next: null,
                previous: null,
                visible: null
            };
            this.u = this.s = !1;
            this.D = function() {
                2 > c.H && c.H++;
                c.ia = null;
                $f(c, {
                    next: null,
                    previous: null,
                    visible: null
                });
                var d, e = null == (d = c.g) ? void 0 : d.jb;
                e && Qf(e, function(f) {
                    $f(c, f);
                });
            };
            this.L = function(d) {
                c.g && d.dueToRenderingConfigChanged && (c.i = c.g.Oa);
            };
            this.W = function() {
                c.oa = c.I.getTimelinePosition();
                if (!c.u && c.ia) {
                    var d = ag(c, c.oa, c.ia);
                    if (d !== c.Qa || null === c.Ea && c.h === x.SyncMediaSyncEventTrigger.SYNC_MEDIA_SEEK) {
                        if (c.Qa === x.SyncMediaPositionRelativeToVisibleRange.VISIBLE || null === c.Ea) c.Ea = x.SyncMediaSyncEventTrigger.SYNC_MEDIA_PLAYBACK, c.h === x.SyncMediaSyncEventTrigger.SYNC_MEDIA_SEEK && (c.h = null);
                        c.Qa = d;
                        c.o = !0;
                    }
                    bg(c);
                }
            };
            this.g = a;
            this.oa = this.I.getTimelinePosition();
            T(this.g, "navigationStarted", this.L);
            T(this.g, "navigationRangeResultChanged", this.D);
            T(this.g, "syncMediaTimelinePositionChanged", this.W);
            this.D();
        }
        Zf.prototype.destroy = function() {
            this.g && (R(this.g, "navigationStarted", this.L), R(this.g, "navigationRangeResultChanged", this.D), R(this.g, "syncMediaTimelinePositionChanged", this.W), this.g = null);
        };
        function cg(a, b, c) {
            c ? (b.push(a.I.getTimeline().fetchTimelinePosition(c.collapseToStart())), b.push(a.I.getTimeline().fetchTimelinePosition(c.collapseToEnd()))) : (b.push(Promise.resolve(null)), b.push(Promise.resolve(null)));
        }
        function dg(a, b, c) {
            if (a.g) {
                var d = a.B, e = a.I.getTimeline(), f = e.fetchContentLocation(c);
                e = e.fetchTimelinePosition(b);
                var g = ++a.F;
                a.s = !0;
                Promise.all([
                    f,
                    e
                ]).then(function(h) {
                    if (d !== a.B) g === a.F && (a.j = null, a.l = null, a.s = !1);
                    else {
                        a.s = !1;
                        var l = h[1];
                        a.j = {
                            contentLocation: h[0],
                            syncMediaTimelinePosition: c
                        };
                        a.l = {
                            contentLocation: b,
                            syncMediaTimelinePosition: l
                        };
                        bg(a);
                    }
                }).catch(function(h) {
                    p.ColibrioError.isColibrioAbortedError(h) || (p.Logger.logError(h), g === a.F && (a.j = null, a.l = null, a.s = !1));
                });
            }
        }
        function ag(a, b, c) {
            return eg(a, b) ? b.isBefore(c.visible.start) ? c.previous && b.isBefore(c.previous.end) ? b.isBefore(c.previous.start) ? x.SyncMediaPositionRelativeToVisibleRange.BEFORE_PREVIOUS : x.SyncMediaPositionRelativeToVisibleRange.PREVIOUS : x.SyncMediaPositionRelativeToVisibleRange.NO_MATCHING_DOCUMENT : b.isBefore(c.visible.end) ? x.SyncMediaPositionRelativeToVisibleRange.VISIBLE : c.next && !b.isBefore(c.next.start) ? b.isBefore(c.next.end) ? x.SyncMediaPositionRelativeToVisibleRange.NEXT : x.SyncMediaPositionRelativeToVisibleRange.AFTER_NEXT : x.SyncMediaPositionRelativeToVisibleRange.NO_MATCHING_DOCUMENT : x.SyncMediaPositionRelativeToVisibleRange.NO_MATCHING_DOCUMENT;
        }
        function eg(a, b) {
            if (!a.g) return !1;
            b = b.getSegment();
            if (!b && (b = Ca(a.I.getTimeline().getSegments()), !b)) return !1;
            var c = b.getReaderDocumentIndexInSpine();
            a = a.g.getReaderDocuments();
            return -1 !== Aa(a, 0, a.length, function(d, e) {
                return c - d[e].getIndexInSpine();
            });
        }
        function bg(a) {
            if (a.g && !a.u && a.ia && (!a.s || a.Ea !== x.SyncMediaSyncEventTrigger.SYNC_MEDIA_PLAYBACK)) {
                var b = a.g.getReadingPosition();
                if (b && a.Ea) {
                    if (!a.l || !a.j) a.o && dg(a, b, a.oa);
                    else if (!a.s && a.o) {
                        a.o = !1;
                        b = a.ia;
                        var c = a.j, d = a.l, e = a.Ea;
                        a.g && (2 > a.H && e === x.SyncMediaSyncEventTrigger.READER_VIEW_NAVIGATION && a.Qa === x.SyncMediaPositionRelativeToVisibleRange.VISIBLE && (e = x.SyncMediaSyncEventTrigger.SYNC_MEDIA_PLAYBACK), V(a.g, new Vf({
                            va: new Wf({
                                Qa: a.Qa,
                                jd: c,
                                kd: d,
                                ia: b,
                                Ea: e
                            }),
                            I: a.I,
                            readerView: a.g.getReaderView()
                        })));
                        a.l = null;
                        a.j = null;
                    }
                }
            }
        }
        function $f(a, b) {
            if (a.g) {
                a.B++;
                var c = [], d = ++a.O;
                cg(a, c, b.previous);
                cg(a, c, b.visible);
                cg(a, c, b.next);
                var e = null === a.C.next && null === a.C.visible && null === a.C.previous;
                a.C = b;
                a.i !== a.g.Oa && (a.h = x.SyncMediaSyncEventTrigger.READER_VIEW_NAVIGATION);
                e || (a.h = x.SyncMediaSyncEventTrigger.READER_VIEW_SCROLL);
                a.u = !0;
                Promise.all(c).then(function(f) {
                    if (a.O !== d || !a.g) return new D(p.ColibrioErrorType.ABORTED);
                    if (f[2] && f[3]) {
                        a.u = !1;
                        a.j = null;
                        a.l = null;
                        var g = !1, h = {
                            end: f[3],
                            start: f[2]
                        };
                        a.ia ? fg(a.ia.visible, h) || (a.ia.visible = h, g = !0) : (g = !0, a.ia = {
                            next: null,
                            previous: null,
                            visible: h
                        });
                        h = null;
                        f[0] && f[1] && (h = {
                            end: f[1],
                            start: f[0]
                        });
                        fg(a.ia.previous, h) || (a.ia.previous = h, g = !0);
                        h = null;
                        f[4] && f[5] && (h = {
                            end: f[5],
                            start: f[4]
                        });
                        fg(a.ia.next, h) || (a.ia.next = h, g = !0);
                        g && (f = ag(a, a.oa, a.ia), a.o = !0, a.Qa = f, a.Ea = e ? x.SyncMediaSyncEventTrigger.SYNC_MEDIA_PLAYBACK : x.SyncMediaSyncEventTrigger.READER_VIEW_SCROLL, a.v !== a.I.u && a.h === x.SyncMediaSyncEventTrigger.SYNC_MEDIA_SEEK && (a.Ea = x.SyncMediaSyncEventTrigger.SYNC_MEDIA_SEEK), a.i !== a.g.Oa && a.h === x.SyncMediaSyncEventTrigger.READER_VIEW_NAVIGATION && e && (a.Ea = x.SyncMediaSyncEventTrigger.READER_VIEW_NAVIGATION));
                        bg(a);
                    }
                }).catch(function(f) {
                    p.ColibrioError.isColibrioAbortedError(f) || p.Logger.logError(f);
                });
            }
        }
        function fg(a, b) {
            return a && b ? a.start.equals(b.start) && a.end.equals(b.end) : !a && !b;
        }
        var gg = 1;
        function hg(a, b, c, d) {
            var e = this;
            this.Ia = a;
            this.i = b;
            this.F = 0;
            this.s = null;
            this.D = new Sc;
            this.H = null;
            this.o = !1;
            this.la = -1;
            this.l = null;
            this.O = x.SyncMediaReaderViewSynchronizationWaitBehavior.WAIT_OUTSIDE_ADJACENT;
            this.B = null;
            this.u = 0;
            this.ma = {
                selector: []
            };
            this.h = this.j = null;
            this.ra = 0;
            this.C = null;
            this.Ba = function(f) {
                if (e.j) {
                    var g = e.j;
                    g.B++;
                    if (g.v === g.I.u) g.Ea = null;
                    else if (g.h = x.SyncMediaSyncEventTrigger.SYNC_MEDIA_SEEK, !g.u && g.ia && (f = ag(g, f, g.ia), f !== g.Qa || g.Ea !== x.SyncMediaSyncEventTrigger.SYNC_MEDIA_SEEK)) g.Ea = x.SyncMediaSyncEventTrigger.SYNC_MEDIA_SEEK, g.Qa = f, g.o = !0;
                }
            };
            this.W = function() {
                var f = ++e.ra, g = null, h, l = null == (h = e.h) ? void 0 : h.getVisiblePages();
                l && 0 < l.length && (g = l[0].getRangeContentLocation(), 1 !== l.length && (l = Ca(l).getRangeContentLocation(), g = g.createRangeTo(l)));
                e.C = null;
                g && Promise.all([
                    e.i.fetchTimelinePosition(g.collapseToStart()),
                    e.i.fetchTimelinePosition(g.collapseToEnd())
                ]).then(function(r) {
                    e.ra === f && e.h && (e.C = {
                        end: r[1],
                        start: r[0]
                    });
                }).catch(function(r) {
                    p.ColibrioError.isColibrioAbortedError(r) || p.Logger.logError(r);
                });
            };
            this.L = y(d, {
                addDefaultMediaObjectRenderers: !0,
                name: "syncMediaPlayer_" + gg++,
                preloadAheadMs: 2E4,
                preloadBehindMs: 5E3
            });
            this.v = ig();
            this.g = new Bf(this, b, c, this.Ba);
            this.L.addDefaultMediaObjectRenderers && b.createDefaultMediaObjectRenderers().forEach(function(f) {
                e.addMediaObjectRenderer(f);
            });
        }
        k = hg.prototype;
        k.addEngineEventListener = function(a, b) {
            this.o || this.D.add(a, b);
        };
        k.addMediaObjectRenderer = function(a) {
            this.g.addMediaObjectRenderer(a, this.L);
        };
        k.attemptReaderViewSynchronization = function(a, b, c) {
            var d = this;
            if (this.h) {
                var e = ++this.F;
                if (a === x.SyncMediaReaderViewSynchronizationMethod.SYNC_MEDIA_SEEK) {
                    if (b) {
                        var f;
                        null != (f = this.j) && (f.v = this.u + 1);
                        jg(this, b, x.SyncMediaRangePlaybackRemoveReason.READER_VIEW_SYNC);
                    } else (b = this.h.getReadingPosition()) && this.i.fetchTimelinePosition(b).then(function(h) {
                        if (e === d.F) {
                            var l;
                            null != (l = d.j) && (l.v = d.u + 1);
                            jg(d, h, x.SyncMediaRangePlaybackRemoveReason.READER_VIEW_SYNC);
                        }
                    }).catch(function(h) {
                        p.ColibrioError.isColibrioAbortedError(h) || p.Logger.logError(h);
                    });
                } else if (a === x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO) {
                    if (c) kg(this.h, c, void 0, !1).catch(function(h) {
                        p.ColibrioError.isColibrioAbortedError(h) || p.Logger.logError(h);
                    }), null != (b = this.j) && (b.i = this.h.Oa);
                    else {
                        var g = this.h.Oa;
                        this.i.fetchContentLocation(this.getTimelinePosition()).then(function(h) {
                            e === d.F && d.h && g === d.h.Oa && (kg(d.h, h, void 0, !1).catch(function(l) {
                                p.ColibrioError.isColibrioAbortedError(l) || p.Logger.logError(l);
                            }), null != (h = d.j) && (h.i = d.h.Oa));
                        }).catch(function(h) {
                            p.ColibrioError.isColibrioAbortedError(h) || p.Logger.logError(h);
                        });
                    }
                } else (c ? Tf(this) : Promise.resolve(void 0)).then(function(h) {
                    d.h && e === d.F && (a === x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_NEXT ? lg(d.h, x.NavigationAction.NEXT_CONTENT_RANGE) && (d.h.navigate(x.NavigationAction.NEXT_CONTENT_RANGE, c, h).catch(function(l) {
                        p.ColibrioError.isColibrioAbortedError(l) || p.Logger.logError(l);
                    }), null != (h = d.j) && (h.i = d.h.Oa)) : a === x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_PREVIOUS && lg(d.h, x.NavigationAction.PREVIOUS_CONTENT_RANGE) && (d.h.navigate(x.NavigationAction.PREVIOUS_CONTENT_RANGE, c, h).catch(function(l) {
                        p.ColibrioError.isColibrioAbortedError(l) || p.Logger.logError(l);
                    }), null != (h = d.j) && (h.i = d.h.Oa)));
                }).catch(function(h) {
                    p.ColibrioError.isColibrioAbortedError(h) || p.Logger.logError(h);
                });
            }
        };
        k.destroy = function() {
            this.o = !0;
            this.g.destroy();
            this.D.clear();
            this.h && (mg(this), this.h = null);
            this.l && (this.l.destroy(), this.l = null);
            this.j && (this.j.destroy(), this.j = null);
            this.B && (this.B.destroy(), this.B = null);
            this.s && (this.s.destroy(), this.s = null);
        };
        function Tf(a) {
            var b = a.g.getTimelinePosition().getSegmentIndex();
            if (b === a.la && a.H) return a.H;
            a.la = b;
            var c = new M(a.i, b, 0);
            b = new M(a.i, b, Number.MAX_SAFE_INTEGER);
            var d = [];
            d.push(a.i.fetchContentLocation(c));
            d.push(a.i.fetchContentLocation(b));
            a.H = Promise.all(d).then(function(e) {
                return e[0].createRangeTo(e[1]);
            });
            return a.H;
        }
        k.getApproximateElapsedTimeMs = function() {
            return this.g.getApproximateElapsedTimeMs();
        };
        k.getEngineEventListeners = function(a) {
            return this.D.get(a);
        };
        k.getMediaObjectRenderers = function() {
            return this.g.getMediaObjectRenderers();
        };
        k.getName = function() {
            return this.L.name;
        };
        k.getPlaybackRange = function() {
            return this.g.getPlaybackRange();
        };
        k.getPlaybackRate = function() {
            return this.g.getPlaybackRate();
        };
        k.getReaderView = function() {
            var a;
            return (null == (a = this.h) ? void 0 : a.getReaderView()) || null;
        };
        k.getReaderViewSynchronizationWaitBehavior = function() {
            return this.O;
        };
        k.getReadingSystemEngine = function() {
            return this.Ia;
        };
        k.getSkippabilityOptions = function() {
            return this.ma;
        };
        k.getTimeline = function() {
            return this.i;
        };
        k.getTimelinePosition = function() {
            return this.g.getTimelinePosition();
        };
        k.getVolume = function() {
            return this.g.getVolume();
        };
        k.isAtEnd = function() {
            return this.g.isAtEnd();
        };
        k.isAtStart = function() {
            var a = this.g.getTimelinePosition();
            return 0 === a.getSegmentIndex() && 0 === a.getOffsetWithinSegmentMs();
        };
        k.isDestroyed = function() {
            return this.o;
        };
        k.isMuted = function() {
            return this.g.isMuted();
        };
        k.isPaused = function() {
            return this.g.isPaused();
        };
        k.isPlaying = function() {
            return !this.g.isPaused() && this.g.isReady();
        };
        k.isReady = function() {
            return this.g.isReady();
        };
        k.isSeeking = function() {
            return this.g.isSeeking();
        };
        k.isWaitingForMediaObjectRenderers = function() {
            return this.g.isWaitingForMediaObjectRenderers();
        };
        k.isWaitingForReaderViewSynchronization = function() {
            return this.g.isWaitingForReaderViewSynchronization();
        };
        k.pause = function() {
            this.o || uf(this.g, !0);
        };
        k.play = function() {
            this.o || uf(this.g, !1);
        };
        k.removeEngineEventListener = function(a, b) {
            this.o || this.D.remove(a, b);
        };
        k.removeMediaObjectRenderer = function(a) {
            return this.g.removeMediaObjectRenderer(a);
        };
        k.removePlaybackRange = function() {
            this.g.removePlaybackRange();
        };
        k.seekToApproximateTimeMs = function(a) {
            this.u++;
            if (this.o) return !1;
            a = this.i.getTimelinePositionFromApproximateOffsetMs(a);
            Ff(this.g, a, x.SyncMediaRangePlaybackRemoveReason.SEEK);
            return !0;
        };
        k.seekToNextSegment = function(a) {
            this.u++;
            if (this.o) return !1;
            var b = this.g.getTimelinePosition(), c = b.getSegmentIndex() + 1, d = 0, e, f = null == (e = this.C) ? void 0 : e.end;
            a && f && 0 < f.getOffsetWithinSegmentMs() && b.getSegmentIndex() === f.getSegmentIndex() && b.isBefore(f) && (c = f.getSegmentIndex(), d = f.getOffsetWithinSegmentMs());
            a = this.g;
            c = new M(this.i, c, d);
            Ff(a, c, x.SyncMediaRangePlaybackRemoveReason.SEEK);
            return !b.equals(this.g.getTimelinePosition());
        };
        k.seekToPreviousSegment = function(a) {
            this.u++;
            if (this.o) return !1;
            var b = this.g.getTimelinePosition(), c = this.g.h - 1, d = 0, e, f = null == (e = this.C) ? void 0 : e.start;
            a && f && 0 < f.getOffsetWithinSegmentMs() && (f.getSegmentIndex() === c ? d = f.getOffsetWithinSegmentMs() : b.getSegmentIndex() !== f.getSegmentIndex() || b.isBefore(f) || (c++, d = 0));
            a = this.g;
            c = new M(this.i, c, d);
            Ff(a, c, x.SyncMediaRangePlaybackRemoveReason.SEEK);
            return !b.equals(this.g.getTimelinePosition());
        };
        k.seekToTimelinePosition = function(a) {
            return jg(this, a, x.SyncMediaRangePlaybackRemoveReason.SEEK);
        };
        k.setManagedReaderViewSynchronizationOptions = function(a) {
            this.v = y(a, ig());
            this.l ? this.v.enabled ? this.l.setOptions(this.v) : (this.l.destroy(), this.l = null) : this.h && this.v.enabled && (this.l = new hf(this, this.h, this.v));
        };
        k.setMuted = function(a) {
            this.g.setMuted(a);
        };
        k.setPlaybackRange = function(a, b) {
            if (this.o) throw new D(p.ColibrioErrorType.ABORTED, "setPlaybackRange: SyncMediaPlayer is in destroyed state.");
            var c = ng(this, a.start);
            a = ng(this, a.end);
            if (!c || !a) throw new D("INVALID_SYNC_MEDIA_TIMELINE_POSITION", 'setPlaybackRange: The provided range has invalid "start" and/or "end" positions.');
            if (c.getTimeline() !== this.i || a.getTimeline() !== this.i) throw new D("INVALID_SYNC_MEDIA_TIMELINE_POSITION", "setPlaybackRange: The provided range has positions from another timeline.");
            if (c.isAfter(a)) throw new D("INVALID_SYNC_MEDIA_TIMELINE_POSITION", "setPlaybackRange: The start position is after the end position.");
            b = y(b, {
                alwaysInitiallySeekToRangeStart: !0,
                pauseOnRangeRemoved: !1,
                removeRangeOnEndReached: !0,
                seekBehaviour: x.SyncMediaRangeSeekBehavior.ALWAYS_REMOVE_RANGE
            });
            var d = this.getTimelinePosition().isBefore(c) || this.getTimelinePosition().isAfter(a);
            (d = b.alwaysInitiallySeekToRangeStart || d) && this.u++;
            return this.g.setPlaybackRange(c, a, b, d);
        };
        k.setPlaybackRate = function(a) {
            a = Ka(a, .25, 5);
            this.g.setPlaybackRate(a);
        };
        k.setReaderViewSynchronizationWaitBehavior = function(a) {
            this.O = a;
            this.s && this.s.setReaderViewSynchronizationWaitBehavior(a);
        };
        k.setSkippabilityOptions = function(a) {
            this.ma = La(a);
        };
        function og(a, b) {
            b !== a.h && (a.h && mg(a), a.h = b, a.j && (a.j.destroy(), a.j = null), a.l && (a.l.destroy(), a.l = null), a.B && (a.B.destroy(), a.B = null), a.s && (a.s.destroy(), a.s = null), Df(a.g, b), b && (a.h && (T(a.h, "visiblePagesChanged", a.W), a.W()), a.j = new Zf(b, a), a.B = new Pf(a, b), a.v.enabled && (a.l = new hf(a, b, a.v)), a.s = new Of(a.g, b, a.O)));
        }
        k.setVolume = function(a) {
            this.g.setVolume(Ka(a, 0, 1));
        };
        function ng(a, b) {
            if (b instanceof M) return b;
            if (b && C(b.segmentIndex) && C(b.offsetWithinSegmentMs)) try {
                return pd(b, a.i);
            } catch (c) {
                p.Logger.logError(c);
            }
            return null;
        }
        function mg(a) {
            a.h && R(a.h, "visiblePagesChanged", a.W);
            a.C = null;
        }
        function ig() {
            return {
                alwaysSeekToSegmentStart: !1,
                enabled: !0,
                minimumTimeToDisplayPagesWithSyncMedia: 0,
                navigateOnVisibleRangeEndReached: !0,
                skipPagesWithoutSyncMedia: !1,
                timeToDisplayPagesWithoutSyncMedia: 2E3
            };
        }
        function jg(a, b, c) {
            a.u++;
            return a.o ? !1 : (b = ng(a, b)) && b.getTimeline() === a.i ? (Ff(a.g, b, c), !0) : !1;
        }
        function pg(a, b) {
            if (!a.every(function(e) {
                return e.getReaderPublication().getReadingSystemEngine() === b;
            })) throw new D("INVALID_VIEW_OPERATION", "Cannot load readerDocuments from another ReadingSystemEngine instance");
            if (0 < a.length) {
                var c = a[0].getReaderPublication();
                if (!a.every(function(e) {
                    return e.getReaderPublication() === c;
                })) throw new D("READER_DOCUMENT_LOAD_ERROR", "It's currently not possible to load reader documents from multiple publication sources.");
            }
            for(var d = 0; d < a.length - 1; d++)if (a[d].getIndexInSpine() >= a[d + 1].getIndexInSpine()) throw new D("INVALID_READER_DOCUMENT_LIST", "Invalid ReaderDocument order. ReaderDocument list must follow the same order as the publication spine.");
        }
        function qg(a, b) {
            if (0 === a.length) return new D("READER_DOCUMENTS_EMPTY", "Cannot create a timeline from an empty readerDocuments list.");
            if (a.some(function(d) {
                return d.getReaderPublication() !== b;
            })) return new D("INVALID_READER_DOCUMENT_LIST", "ReaderDocument belongs to another ReaderPublication.");
            for(var c = 0; c < a.length - 1; c++)if (a[c].getIndexInSpine() >= a[c + 1].getIndexInSpine()) return new D("INVALID_READER_DOCUMENT_LIST", "Invalid ReaderDocument order. ReaderDocument list must follow the same order as the publication spine.");
            return null;
        }
        function rg(a) {
            return Oa(a) && B(a.getLocator) && B(a.getReaderDocuments) && B(a.fetchNavigationItemReferences) && !B(a.resolve);
        }
        function sg(a) {
            return a.getOptions().platformWorkaroundOptions.useTouchEventsOnIos && (p.BrowserDetector.isOS("iOS") || p.BrowserDetector.isOS("macOS") && 1 < navigator.maxTouchPoints);
        }
        function W(a) {
            return Oa(a) && B(a.getLocator) && B(a.getReaderDocuments) && B(a.fetchNavigationItemReferences) && B(a.resolve);
        }
        function X(a, b) {
            G.call(this, a, b);
        }
        m.inherits(X, G);
        X.prototype.toJSON = function() {
            return {
                cancelable: this.cancelable,
                defaultPrevented: this.defaultPrevented,
                immediatePropagationStopped: this.immediatePropagationStopped,
                isTrusted: this.isTrusted,
                objectType: x.EngineEventDataObjectType.READER_VIEW_ENGINE_EVENT,
                propagationStopped: this.propagationStopped,
                readerViewName: this.m.readerView.getName(),
                type: this.da
            };
        };
        m.global.Object.defineProperties(X.prototype, {
            readerView: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerView;
                }
            }
        });
        function tg(a, b, c) {
            G.call(this, a, b);
            this.g = c;
            (a = b.mediaResource) && (a = a.getResourceUrl()) && /^\s*javascript:/i.test(a) && (b.mediaResource = null);
        }
        m.inherits(tg, X);
        tg.prototype.preventDefault = function() {
            X.prototype.preventDefault.call(this);
            this.g && this.g.cancelable && this.g.preventDefault();
        };
        tg.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this), b = null, c = this.m.target;
            c && (b = c.contentLocation, b = {
                frameworkComponent: c.frameworkComponent,
                locator: b ? b.getLocator().toJSON() : null,
                mediaType: c.mediaType,
                nodeData: c.nodeData,
                objectType: x.EngineEventTargetObjectType.ENGINE_EVENT_TARGET,
                readerDocumentIndexInSpine: b ? b.getReaderDocuments()[0].getIndexInSpine() : null
            });
            c = this.m.mediaResource;
            b = {
                button: this.m.button,
                buttons: this.m.buttons,
                clientX: this.m.clientX,
                clientY: this.m.clientY,
                ctrlKey: this.m.ctrlKey,
                mediaResource: c ? c.toJSON() : null,
                metaKey: this.m.metaKey,
                objectType: x.EngineEventDataObjectType.MOUSE_ENGINE_EVENT,
                pageX: this.m.pageX,
                pageY: this.m.pageY,
                readerDocumentEventState: this.m.readerDocumentEventState,
                relativeClientX: this.m.clientX / window.innerWidth,
                relativeClientY: this.m.clientY / window.innerHeight,
                relativeScreenX: this.m.screenX / screen.width,
                relativeScreenY: this.m.screenY / screen.height,
                screenX: this.m.screenX,
                screenY: this.m.screenY,
                target: b,
                userGenerated: this.m.userGenerated,
                willEmitDomEvent: !!this.g
            };
            return Object.assign(a, b);
        };
        m.global.Object.defineProperties(tg.prototype, {
            button: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.button;
                }
            },
            buttons: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.buttons;
                }
            },
            clientX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.clientX;
                }
            },
            clientY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.clientY;
                }
            },
            ctrlKey: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ctrlKey;
                }
            },
            defaultPrevented: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return X.prototype.defaultPrevented || null !== this.g && this.g.defaultPrevented;
                }
            },
            mediaResource: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.mediaResource;
                }
            },
            metaKey: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.metaKey;
                }
            },
            pageX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pageX;
                }
            },
            pageY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pageY;
                }
            },
            readerDocumentEventState: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerDocumentEventState;
                }
            },
            relativeClientX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.clientX / window.innerWidth;
                }
            },
            relativeClientY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.clientY / window.innerHeight;
                }
            },
            relativeScreenX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.screenX / screen.width;
                }
            },
            relativeScreenY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.screenY / screen.height;
                }
            },
            screenX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.screenX;
                }
            },
            screenY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.screenY;
                }
            },
            target: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.target;
                }
            },
            userGenerated: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.userGenerated;
                }
            },
            willEmitDomEvent: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return !!this.g;
                }
            }
        });
        function ug(a, b, c, d) {
            this.ga = a;
            this.R = b;
            this.cb = c;
            this.Ka = d;
            this.sa = !1;
        }
        ug.prototype.disable = function() {
            this.sa && (this.sa = !1, this.ga.removeEventListener("click", this, !1), this.ga.removeEventListener("dblclick", this, !1));
        };
        ug.prototype.enable = function() {
            this.sa || (this.sa = !0, this.ga.addEventListener("click", this, !1), this.ga.addEventListener("dblclick", this, !1));
        };
        ug.prototype.handleEvent = function(a) {
            if (!a.defaultPrevented) {
                var b = a.type, c = {
                    button: a.button,
                    buttons: a.buttons,
                    cancelable: a.cancelable,
                    clientX: a.clientX,
                    clientY: a.clientY,
                    ctrlKey: a.ctrlKey,
                    isTrusted: a.isTrusted,
                    mediaResource: null,
                    metaKey: a.metaKey,
                    pageX: a.pageX,
                    pageY: a.pageY,
                    readerDocumentEventState: a.defaultPrevented ? x.ReaderDocumentEventState.DEFAULT_PREVENTED : x.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: this.R,
                    screenX: a.screenX,
                    screenY: a.screenY,
                    target: a.target && this.Ka.getEngineEventTargetForTopFrameEvent(a.target),
                    userGenerated: a.isTrusted
                };
                this.cb.emit(new tg(b, c, a));
            }
        };
        function vg(a, b) {
            this.ga = a;
            this.Ka = b;
            this.sa = !1;
        }
        vg.prototype.disable = function() {
            this.sa && (this.sa = !1, this.ga.removeEventListener("keyup", this, !1), this.ga.removeEventListener("keydown", this, !1));
        };
        vg.prototype.enable = function() {
            this.sa || (this.sa = !0, this.ga.addEventListener("keyup", this, !1), this.ga.addEventListener("keydown", this, !1));
        };
        vg.prototype.handleEvent = function(a) {
            var b = a.defaultPrevented ? x.ReaderDocumentEventState.DEFAULT_PREVENTED : x.ReaderDocumentEventState.NOT_PROCESSED, c = a.target && this.Ka.getEngineEventTargetForTopFrameEvent(a.target);
            this.Ka.dispatchKeyboardEvent(a, c, b, a.isTrusted);
        };
        function wg(a, b, c) {
            tg.call(this, a, b, c);
        }
        m.inherits(wg, tg);
        wg.prototype.toJSON = function() {
            var a = tg.prototype.toJSON.call(this);
            return Object.assign(a, {
                isPrimary: this.m.isPrimary,
                objectType: x.EngineEventDataObjectType.POINTER_ENGINE_EVENT,
                pointerId: this.m.pointerId,
                pointerType: this.m.pointerType
            });
        };
        m.global.Object.defineProperties(wg.prototype, {
            isPrimary: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.isPrimary;
                }
            },
            pointerId: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pointerId;
                }
            },
            pointerType: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pointerType;
                }
            }
        });
        function xg(a, b, c, d, e, f, g) {
            this.ga = b;
            this.R = c;
            this.cb = e;
            this.Ka = f;
            this.o = g;
            this.sa = !1;
            this.i = this.l = null;
            this.s = 0;
            this.j = !1;
            this.h = 0;
            this.u = null;
            this.g = a.ownerDocument.defaultView;
            this.v = "ontouchstart" in this.g;
            b = [];
            p.RuntimePlatform.isCssDeclarationSupported("touch-action", "pan-x") ? (d.isNativePanXAllowed() && b.push("pan-x"), d.isNativePanYAllowed() && b.push("pan-y"), 0 === b.length && b.push("none")) : b.push("manipulation");
            0 < b.length && a.style.setProperty("touch-action", b.join(" "));
        }
        xg.prototype.disable = function() {
            this.sa && (this.sa = !1, this.v && (this.ga.removeEventListener("touchstart", this, !1), 0 < this.h && (this.i && yg(this, "pointercancel", this.i, !1, !0), zg(this))), this.o && this.ga.removeEventListener("mousemove", this, !1), this.ga.removeEventListener("mousedown", this, !1), this.g.removeEventListener("dragstart", this, !1), this.j && Ag(this));
        };
        xg.prototype.enable = function() {
            this.sa || (this.sa = !0, this.v && this.ga.addEventListener("touchstart", this, !1), this.o && this.ga.addEventListener("mousemove", this, !1), this.ga.addEventListener("mousedown", this, !1), this.g.addEventListener("dragstart", this, !1));
        };
        xg.prototype.handleEvent = function(a) {
            switch(a.type){
                case "touchstart":
                    0 === this.h && (this.g.addEventListener("touchmove", this, !1), this.g.addEventListener("touchend", this, !1), this.g.addEventListener("touchcancel", this, !1));
                    a.touches.length - a.changedTouches.length !== this.h && this.i && yg(this, "pointercancel", this.i, !1);
                    this.h = a.touches.length;
                    this.i = a;
                    this.s = Date.now();
                    yg(this, "pointerdown", a, !0);
                    this.j && this.l && Bg(this, "pointercancel", this.l, !1, !0);
                    break;
                case "touchmove":
                    0 < this.h && (this.i = a, yg(this, "pointermove", a, !1));
                    this.s = Date.now();
                    break;
                case "touchend":
                case "touchcancel":
                    "touchend" === a.type ? yg(this, "pointerup", a, !0) : yg(this, "pointercancel", a, !1);
                    this.h = Math.max(0, this.h - a.changedTouches.length);
                    this.i = a;
                    this.s = Date.now();
                    0 === this.h && zg(this);
                    break;
                case "mousedown":
                    0 === this.h && 1E3 < Date.now() - this.s && (this.o || this.g.addEventListener("mousemove", this, !1), this.g.addEventListener("mouseup", this, !1), this.j = !0, this.l = a, Bg(this, "pointerdown", a, !0));
                    break;
                case "mousemove":
                    this.j && (this.l = a);
                    (this.j || this.o) && Bg(this, "pointermove", a, !1);
                    break;
                case "mouseup":
                    this.j && (Bg(this, "pointerup", a, !0), Ag(this));
                    break;
                case "dragstart":
                    this.j && this.l && (Bg(this, "pointercancel", this.l, !1, !0), Ag(this));
            }
        };
        function Bg(a, b, c, d, e) {
            d = {
                button: c.button,
                buttons: c.buttons,
                cancelable: e ? !1 : c.cancelable,
                clientX: c.clientX,
                clientY: c.clientY,
                ctrlKey: c.ctrlKey,
                isPrimary: 0 === c.button,
                isTrusted: c.isTrusted,
                mediaResource: null,
                metaKey: c.metaKey,
                pageX: c.pageX,
                pageY: c.pageY,
                pointerId: -1,
                pointerType: "mouse",
                readerDocumentEventState: c.defaultPrevented ? x.ReaderDocumentEventState.DEFAULT_PREVENTED : x.ReaderDocumentEventState.NOT_PROCESSED,
                readerView: a.R,
                screenX: c.screenX,
                screenY: c.screenY,
                target: d && c.target ? a.Ka.getEngineEventTargetForTopFrameEvent(c.target) : null,
                userGenerated: c.isTrusted
            };
            a.cb.emit(new wg(b, d, c));
        }
        function yg(a, b, c, d, e) {
            for(var f = e ? c.targetTouches : c.changedTouches, g = 0; g < f.length; g++){
                var h = f.item(g);
                null === a.u && (a.u = h.identifier);
                h = {
                    button: 0,
                    buttons: 1,
                    cancelable: e ? !1 : c.cancelable,
                    clientX: h.clientX,
                    clientY: h.clientY,
                    ctrlKey: c.ctrlKey,
                    isPrimary: a.u === h.identifier,
                    isTrusted: c.isTrusted,
                    mediaResource: null,
                    metaKey: c.metaKey,
                    pageX: h.pageX,
                    pageY: h.pageY,
                    pointerId: h.identifier,
                    pointerType: "touch",
                    readerDocumentEventState: c.defaultPrevented ? x.ReaderDocumentEventState.DEFAULT_PREVENTED : x.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: a.R,
                    screenX: h.screenX,
                    screenY: h.screenY,
                    target: d && c.target ? a.Ka.getEngineEventTargetForTopFrameEvent(c.target) : null,
                    userGenerated: c.isTrusted
                };
                a.cb.emit(new wg(b, h, c));
            }
        }
        function Ag(a) {
            a.g.removeEventListener("mousemove", a, !1);
            a.g.removeEventListener("mouseup", a, !1);
            a.j = !1;
            a.l = null;
        }
        function zg(a) {
            a.g.removeEventListener("touchmove", a, !1);
            a.g.removeEventListener("touchend", a, !1);
            a.g.removeEventListener("touchcancel", a, !1);
            a.h = 0;
            a.u = null;
            a.i = null;
        }
        function Cg(a, b, c, d, e, f, g) {
            this.ga = b;
            this.R = c;
            this.cb = e;
            this.Ka = f;
            this.i = g;
            this.g = new Map;
            this.j = this.sa = !1;
            b = [];
            p.RuntimePlatform.isCssDeclarationSupported("touch-action", "pan-x") ? (d.isNativePanXAllowed() && b.push("pan-x"), d.isNativePanYAllowed() && b.push("pan-y"), 0 === b.length && b.push("none")) : b.push("manipulation");
            0 < b.length && a.style.setProperty("touch-action", b.join(" "));
            this.h = a.ownerDocument.defaultView;
            this.j = this.R.getOptions().gestureOptions.swipeNavigation.pointerTypes.mouse;
        }
        Cg.prototype.disable = function() {
            var a = this;
            this.sa && (this.sa = !1, this.ga.removeEventListener("pointerdown", this, !1), this.i && this.ga.removeEventListener("pointermove", this, !1), 0 < this.g.size && (this.g.forEach(function(b) {
                Dg(a, "pointercancel", b, !1, !0);
            }), Eg(this), this.g.clear()));
        };
        Cg.prototype.enable = function() {
            this.sa || (this.sa = !0, this.ga.addEventListener("pointerdown", this, !1), this.i && this.ga.addEventListener("pointermove", this, !1));
        };
        Cg.prototype.handleEvent = function(a) {
            var b = 1 === a.buttons, c = "mouse" === a.pointerType && this.j;
            switch(a.type){
                case "pointerdown":
                    0 === this.g.size && (this.i || this.h.addEventListener("pointermove", this, !1), this.h.addEventListener("pointerup", this, !1), this.h.addEventListener("pointercancel", this, !1));
                    var d = document.getSelection();
                    (c && b || "mouse" !== a.pointerType) && (!d || d.isCollapsed) && this.ga.setPointerCapture(a.pointerId);
                    this.g.set(a.pointerId, a);
                    a.cancelable && 2 <= this.g.size && a.preventDefault();
                    Dg(this, a.type, a, !0);
                    break;
                case "pointermove":
                    a.cancelable && 2 <= this.g.size && a.preventDefault();
                    b = this.i;
                    this.g.has(a.pointerId) && (this.g.set(a.pointerId, a), b = !0);
                    b && Dg(this, a.type, a, !1);
                    break;
                case "pointerup":
                case "pointercancel":
                    a.cancelable && 2 <= this.g.size && a.preventDefault();
                    try {
                        ("mouse" !== a.pointerType || c) && this.ga.releasePointerCapture(a.pointerId);
                    } catch (e) {}
                    this.g.delete(a.pointerId) && Dg(this, a.type, a, "pointerup" === a.type);
                    0 === this.g.size && Eg(this);
            }
        };
        function Dg(a, b, c, d, e) {
            d = {
                button: c.button,
                buttons: c.buttons,
                cancelable: e ? !1 : c.cancelable,
                clientX: c.clientX,
                clientY: c.clientY,
                ctrlKey: c.ctrlKey,
                isPrimary: c.isPrimary,
                isTrusted: c.isTrusted,
                mediaResource: null,
                metaKey: c.metaKey,
                pageX: c.pageX,
                pageY: c.pageY,
                pointerId: c.pointerId,
                pointerType: c.pointerType,
                readerDocumentEventState: c.defaultPrevented ? x.ReaderDocumentEventState.DEFAULT_PREVENTED : x.ReaderDocumentEventState.NOT_PROCESSED,
                readerView: a.R,
                screenX: c.screenX,
                screenY: c.screenY,
                target: c.target && d ? a.Ka.getEngineEventTargetForTopFrameEvent(c.target) : null,
                userGenerated: c.isTrusted
            };
            a.cb.emit(new wg(b, d, c));
        }
        function Eg(a) {
            a.i || a.h.removeEventListener("pointermove", a, !1);
            a.h.removeEventListener("pointerup", a, !1);
            a.h.removeEventListener("pointercancel", a, !1);
        }
        function Fg(a, b, c, d, e, f) {
            this.g = [];
            var g = c.getReadingSystemEngine(), h = g.getEventBus(), l;
            !sg(g) && "onpointerdown" in a.ownerDocument.defaultView ? l = new Cg(a, b, c, d, h, e, f) : l = new xg(a, b, c, d, h, e, f);
            this.g.push(l);
            this.g.push(new ug(b, c, h, e));
            this.g.push(new vg(b, e));
        }
        Fg.prototype.disable = function() {
            for(var a = 0; a < this.g.length; a++)this.g[a].disable();
        };
        Fg.prototype.enable = function() {
            for(var a = 0; a < this.g.length; a++)this.g[a].enable();
        };
        function Gg(a, b) {
            G.call(this, a, b);
        }
        m.inherits(Gg, X);
        Gg.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this), b = {
                objectType: x.EngineEventDataObjectType.PAGE_PROGRESSION_TIMELINE_ENGINE_EVENT,
                pageProgressionTimeline: this.m.pageProgressionTimeline.toJSON()
            };
            return Object.assign(a, b);
        };
        m.global.Object.defineProperties(Gg.prototype, {
            pageProgressionTimeline: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pageProgressionTimeline;
                }
            }
        });
        function Hg(a, b) {
            G.call(this, a, b);
        }
        m.inherits(Hg, X);
        Hg.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this);
            return Object.assign(a, {
                objectType: x.EngineEventDataObjectType.PAGE_PROGRESSION_TIMELINE_RECALCULATING_ENGINE_EVENT,
                progress: this.m.progress
            });
        };
        m.global.Object.defineProperties(Hg.prototype, {
            progress: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.progress;
                }
            }
        });
        function Ig(a) {
            return Oa(a) && B(a.getLocator) ? a.getLocator() : Oa(a) && Ra(a, "locator") ? a.locator : a;
        }
        function Jg(a, b) {
            G.call(this, a, b);
        }
        m.inherits(Jg, X);
        m.global.Object.defineProperties(Jg.prototype, {
            annotationLayer: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.annotationLayer;
                }
            }
        });
        function Kg(a, b) {
            G.call(this, a, b);
        }
        m.inherits(Kg, Jg);
        m.global.Object.defineProperties(Kg.prototype, {
            annotation: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.annotation;
                }
            }
        });
        var Lg = 0;
        function Mg(a, b, c, d) {
            this.v = a;
            this.O = c;
            this.g = d;
            this.o = this.u = 0;
            this.C = null;
            this.s = !1;
            this.S = null;
            this.H = this.A = !1;
            this.B = Lg++;
            this.L = !1;
            this.j = new Map;
            this.h = new Map;
            this.i = this.l = this.F = null;
            if (b instanceof xa.Locator) this.D = b.toJSON();
            else if (rg(b) || W(b)) this.D = b.getLocator().toJSON();
            else {
                a = Ig(b);
                if (null === a) throw new D("NAVIGATION_ITEM_MISSING_LOCATOR");
                this.D = a instanceof xa.Locator ? a.toJSON() : a;
            }
        }
        function Ng(a, b, c, d) {
            a.style.left = b.left - c.left + "px";
            a.style.top = b.top - c.top + "px";
            d || (a.style.width = b.width + "px", a.style.height = b.height + "px");
        }
        function Og(a, b) {
            var c = a.j.get(b);
            c && (Wa(c), a.j.delete(b));
            a.h.delete(b);
        }
        function Pg(a, b, c) {
            if (a.S && !a.A) {
                var d = c.ownerDocument, e = d.createElement("div");
                e.classList.add("colibrio-reader-view-annotation");
                e.dataset.id = a.B + "";
                a.j.set(b, e);
                var f = [];
                a.h.set(b, f);
                b.fetchOverlayRectsForContentLocation(a.S).then(function(g) {
                    if (!a.A && a.h.has(b) && 0 !== g.rects.length && f === a.h.get(b)) {
                        var h = g.rects, l = Qg(h);
                        if (a.s = g.collapsed) {
                            if (g.rects[0]) {
                                h = g.rects[0];
                                g = d.createElement("div");
                                if (a.g.positionClassName) {
                                    var r = a.g.positionClassName.trim().split(" ");
                                    g.classList.add.apply(g.classList, m.Ua(r));
                                }
                                g.dataset.id = a.B + "";
                                g.style.position = "absolute";
                                Ng(g, h, l, !0);
                                Ta(g, a.g.positionStyle);
                                f.push(g);
                                e.appendChild(g);
                            }
                        } else for(g = 0; g < h.length; g++){
                            r = d.createElement("div");
                            var q = h[g];
                            r.dataset.id = a.B + "";
                            if (a.g.rangeClassName) {
                                var v = a.g.rangeClassName.trim().split(" ");
                                r.classList.add.apply(r.classList, m.Ua(v));
                            }
                            r.style.position = "absolute";
                            Ng(r, q, l, !1);
                            Ta(r, a.g.rangeStyle);
                            f.push(r);
                            e.appendChild(r);
                        }
                        a.g.containerClassName && (h = a.g.containerClassName.trim().split(" "), e.classList.add.apply(e.classList, m.Ua(h)));
                        e.style.pointerEvents = "none";
                        e.style.position = "absolute";
                        e.style.top = l.top + "px";
                        e.style.left = l.left + "px";
                        e.style.width = l.right - l.left + "px";
                        e.style.height = l.bottom - l.top + "px";
                        a.g.containerStyle && Ta(e, a.g.containerStyle);
                        c.appendChild(e);
                    }
                }).catch(function(g) {
                    p.ColibrioError.isColibrioAbortedError(g) || p.Logger.logError(g);
                });
            }
        }
        function Rg(a, b) {
            a.l = null;
            a.S = b;
        }
        function Sg(a, b, c, d) {
            a.s && b !== a.g.positionClassName && a.h.forEach(function(e) {
                return Tg(e, b, a.g.positionClassName);
            });
            a.s || c === a.g.rangeClassName || a.h.forEach(function(e) {
                return Tg(e, c, a.g.rangeClassName);
            });
            d !== a.g.containerClassName && a.j.forEach(function(e) {
                return Tg([
                    e
                ], d, a.g.containerClassName);
            });
            a.g.containerClassName = d;
            a.g.rangeClassName = c;
            a.g.positionClassName = b;
        }
        function Ug(a, b) {
            if (!a.A && a.L !== b) {
                var c = (a.L = b) ? "annotationIntersectingVisibleRange" : "annotationOutsideVisibleRange";
                b = a.v.getReaderView();
                a = new Kg(c, {
                    annotation: a,
                    annotationLayer: a.v,
                    cancelable: !1,
                    isTrusted: !1,
                    readerView: b
                });
                b.getReadingSystemEngine().getEventBus().emitAsync(a);
            }
        }
        function Vg(a, b, c, d, e, f, g) {
            a.g.containerStyle = f;
            a.g.rangeStyle = b;
            a.g.positionStyle = d;
            if (a.s) {
                var h = d;
                var l = e;
            } else h = b, l = c;
            a.h.forEach(function(r) {
                for(var q = 0; q < r.length; q++){
                    for(var v = r[q], u = 0; u < l.length; u++)v.style.removeProperty(l[u]);
                    Ta(v, h);
                }
            });
            a.j.forEach(function(r) {
                for(var q = 0; q < g.length; q++)r.style.removeProperty(g[q]);
                Ta(r, f);
            });
        }
        function Wg(a) {
            Ug(a, !1);
            a.S = null;
            a.l = null;
        }
        k = Mg.prototype;
        k.getAnnotationLayer = function() {
            return this.v;
        };
        k.getCustomData = function() {
            return this.O;
        };
        k.getId = function() {
            return this.B;
        };
        k.getLocator = function() {
            var a;
            return (null == (a = this.S || this.l) ? void 0 : a.getLocator()) || null;
        };
        k.getOptions = function() {
            return this.g;
        };
        k.hasCustomizedStyleOptions = function() {
            return this.H;
        };
        k.isDestroyed = function() {
            return this.A;
        };
        k.isIntersectingVisibleRange = function() {
            return this.L;
        };
        k.refresh = function(a) {
            var b = this;
            this.S && !this.A && a.fetchOverlayRectsForContentLocation(this.S).then(function(c) {
                if (!b.A && b.h.has(a) && 0 !== c.rects.length) {
                    var d = c.rects, e = Qg(d);
                    b.s = c.collapsed;
                    var f = b.j.get(a), g = b.h.get(a);
                    f && g && g.length === d.length && (c.collapsed ? d[0] && (c = g[0], Ng(c, d[0], e, !0), Ta(c, b.g.positionStyle)) : d.forEach(function(h, l) {
                        l = g[l];
                        Ng(l, h, e, !1);
                        Ta(l, b.g.rangeStyle);
                    }), f.style.top = e.top + "px", f.style.left = e.left + "px", f.style.width = e.right - e.left + "px", f.style.height = e.bottom - e.top + "px", Ta(f, b.g.containerStyle));
                }
            }).catch(function(c) {
                p.ColibrioError.isColibrioAbortedError(c) || p.Logger.logError(c);
            });
        };
        k.setCustomData = function(a) {
            this.O = a;
        };
        k.setOptions = function(a) {
            a ? (this.H = !0, a = y(a, La(this.g), !0), a = y(a, Xg()), Yg(this, a)) : (this.H = !1, Yg(this, this.v.getDefaultAnnotationOptions()));
        };
        function Tg(a, b, c) {
            for(var d = c.trim().split(" "), e = b.trim().split(" "), f = 0; f < a.length; f++)c && a[f].classList.remove.apply(a[f].classList, m.Ua(d)), b && a[f].classList.add.apply(a[f].classList, m.Ua(e));
        }
        function Yg(a, b) {
            var c = a.g;
            Sg(a, b.positionClassName, b.rangeClassName, b.containerClassName);
            a.g = b;
            b = Qa(a.g.containerStyle, c.containerStyle);
            var d = Qa(a.g.rangeStyle, c.rangeStyle);
            c = Qa(a.g.positionStyle, c.positionStyle);
            Vg(a, a.g.rangeStyle, d, a.g.positionStyle, c, a.g.containerStyle, b);
        }
        function Qg(a) {
            var b = {
                bottom: a[0].bottom,
                left: a[0].left,
                right: a[0].right,
                top: a[0].top
            };
            a.forEach(function(c) {
                b.top = b.top < c.top ? b.top : c.top;
                b.left = b.left < c.left ? b.left : c.left;
                b.bottom = b.bottom > c.bottom ? b.bottom : c.bottom;
                b.right = b.right > c.right ? b.right : c.right;
            });
            return b;
        }
        function Xg() {
            return {
                containerClassName: "",
                containerStyle: {},
                positionClassName: "",
                positionStyle: {},
                rangeClassName: "",
                rangeStyle: {}
            };
        }
        function Zg(a, b) {
            var c = this;
            this.i = a;
            this.o = b;
            this.h = null;
            this.Eb = this.Db = 0;
            this.g = null;
            this.s = function() {
                if (c.g) {
                    var d = c.g.target;
                    if (d && 1 === d.nodeType) {
                        var e = new MouseEvent("contextmenu", {
                            bubbles: !0,
                            cancelable: !1,
                            clientX: c.g.clientX,
                            clientY: c.g.clientY,
                            screenX: c.g.screenX,
                            screenY: c.g.screenY,
                            view: window
                        });
                        d.dispatchEvent(e);
                    }
                }
            };
            this.j = function(d) {
                c.g ? $g(c) : ah(c, d);
            };
            this.l = function(d) {
                if (c.g) {
                    var e = 10 <= Math.abs(c.Eb - d.screenY);
                    (10 <= Math.abs(c.Db - d.screenX) || e) && $g(c);
                }
            };
            b ? (this.i.addEventListener("touchstart", this, !0), window.addEventListener("touchmove", this, !0), window.addEventListener("touchend", this, !0), window.addEventListener("touchcancel", this, !0)) : (this.i.addEventListener("pointerdown", this, !0), window.addEventListener("pointermove", this, !0), window.addEventListener("pointerup", this, !0), window.addEventListener("pointercancel", this, !0));
        }
        function bh(a, b) {
            a = a.changedTouches;
            for(var c = 0; c < a.length; c++)b(a[c]);
        }
        Zg.prototype.destroy = function() {
            $g(this);
            this.o ? (this.i.removeEventListener("touchstart", this), window.removeEventListener("touchmove", this), window.removeEventListener("touchend", this), window.removeEventListener("touchcancel", this)) : (this.i.removeEventListener("pointerdown", this), window.removeEventListener("pointermove", this), window.removeEventListener("pointerup", this), window.removeEventListener("pointercancel", this));
        };
        Zg.prototype.handleEvent = function(a) {
            switch(a.type){
                case "pointerdown":
                    this.j(a);
                    break;
                case "pointermove":
                    this.l(a);
                    break;
                case "pointerup":
                case "pointercancel":
                    $g(this);
                    break;
                case "touchstart":
                    bh(a, this.j);
                    break;
                case "touchmove":
                    bh(a, this.l);
                    break;
                case "touchend":
                case "touchcancel":
                    $g(this);
            }
        };
        function $g(a) {
            null !== a.h && (window.clearTimeout(a.h), a.h = null);
            a.g = null;
        }
        function ah(a, b) {
            $g(a);
            a.g = b;
            a.Db = b.screenX;
            a.Eb = b.screenY;
            a.h = window.setTimeout(function() {
                a.h = null;
                a.s();
                a.g = null;
            }, 500);
        }
        function ch(a, b, c) {
            G.call(this, a, b);
            this.g = c;
        }
        m.inherits(ch, Kg);
        ch.prototype.preventDefault = function() {
            Kg.prototype.preventDefault.call(this);
            this.g && this.g.cancelable && this.g.preventDefault();
        };
        ch.prototype.toJSON = function() {
            var a = Kg.prototype.toJSON.call(this);
            return Object.assign(a, {
                button: this.m.button,
                buttons: this.m.buttons,
                clientX: this.m.clientX,
                clientY: this.m.clientY,
                ctrlKey: this.m.ctrlKey,
                mediaResource: null,
                metaKey: this.m.metaKey,
                objectType: x.EngineEventDataObjectType.MOUSE_ENGINE_EVENT,
                pageX: this.m.pageX,
                pageY: this.m.pageY,
                readerDocumentEventState: this.m.readerDocumentEventState,
                relativeClientX: this.m.clientX / window.innerWidth,
                relativeClientY: this.m.clientY / window.innerHeight,
                relativeScreenX: this.m.screenX / screen.width,
                relativeScreenY: this.m.screenY / screen.height,
                screenX: this.m.screenX,
                screenY: this.m.screenY,
                target: null,
                userGenerated: this.m.userGenerated,
                willEmitDomEvent: !!this.g
            });
        };
        m.global.Object.defineProperties(ch.prototype, {
            clientX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.clientX;
                }
            },
            clientY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.clientY;
                }
            },
            ctrlKey: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ctrlKey;
                }
            },
            defaultPrevented: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return Kg.prototype.defaultPrevented || null !== this.g && this.g.defaultPrevented;
                }
            },
            metaKey: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.metaKey;
                }
            },
            pageX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pageX;
                }
            },
            pageY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pageY;
                }
            },
            readerDocumentEventState: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerDocumentEventState;
                }
            },
            relativeClientX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.clientX / window.innerWidth;
                }
            },
            relativeClientY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.clientY / window.innerHeight;
                }
            },
            relativeScreenX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.screenX / screen.width;
                }
            },
            relativeScreenY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.screenY / screen.height;
                }
            },
            screenX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.screenX;
                }
            },
            screenY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.screenY;
                }
            },
            userGenerated: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.userGenerated;
                }
            },
            willEmitDomEvent: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return !!this.g;
                }
            }
        });
        function dh(a, b, c) {
            ch.call(this, a, b, c);
        }
        m.inherits(dh, ch);
        m.global.Object.defineProperties(dh.prototype, {
            isPrimary: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.isPrimary;
                }
            },
            pointerId: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pointerId;
                }
            },
            pointerType: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pointerType;
                }
            }
        });
        function eh(a, b, c, d, e, f) {
            var g = this;
            this.ba = a;
            this.j = c;
            this.u = d;
            this.s = f;
            this.h = [];
            this.v = null;
            this.l = !1;
            this.o = new Map;
            this.refreshAnnotations = function() {
                g.g && g.i && g.h.forEach(function(h) {
                    return h.refresh(g.ba);
                });
            };
            this.B = function(h, l) {
                var r = !0, q = -1, v = "mouse";
                "pointerType" in h && "pointerId" in h && (r = h.isPrimary, q = h.pointerId, v = h.pointerType);
                return {
                    annotation: l,
                    annotationLayer: g.s,
                    button: h.button,
                    buttons: h.buttons,
                    cancelable: h.cancelable,
                    clientX: h.clientX,
                    clientY: h.clientY,
                    ctrlKey: h.ctrlKey,
                    isPrimary: r,
                    isTrusted: h.isTrusted,
                    metaKey: h.metaKey,
                    pageX: h.pageX,
                    pageY: h.pageY,
                    pointerId: q,
                    pointerType: v,
                    readerDocumentEventState: h.defaultPrevented ? x.ReaderDocumentEventState.DEFAULT_PREVENTED : x.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: g.R,
                    screenX: h.screenX,
                    screenY: h.screenY,
                    userGenerated: h.isTrusted
                };
            };
            this.C = function(h) {
                var l = fh(g, h);
                l && (h = new ch("annotationClick", {
                    annotation: l,
                    annotationLayer: g.s,
                    button: h.button,
                    buttons: h.buttons,
                    cancelable: h.cancelable,
                    clientX: h.clientX,
                    clientY: h.clientY,
                    ctrlKey: h.ctrlKey,
                    isTrusted: h.isTrusted,
                    metaKey: h.metaKey,
                    pageX: h.pageX,
                    pageY: h.pageY,
                    readerDocumentEventState: h.defaultPrevented ? x.ReaderDocumentEventState.DEFAULT_PREVENTED : x.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: g.R,
                    screenX: h.screenX,
                    screenY: h.screenY,
                    userGenerated: h.isTrusted
                }, h), g.R.getReadingSystemEngine().getEventBus().emit(h));
            };
            this.D = function(h) {
                h.preventDefault();
                var l = fh(g, h);
                l && (h = new ch("annotationContextMenu", {
                    annotation: l,
                    annotationLayer: g.s,
                    button: h.button,
                    buttons: h.buttons,
                    cancelable: h.cancelable,
                    clientX: h.clientX,
                    clientY: h.clientY,
                    ctrlKey: h.ctrlKey,
                    isTrusted: h.isTrusted,
                    metaKey: h.metaKey,
                    pageX: h.pageX,
                    pageY: h.pageY,
                    readerDocumentEventState: h.defaultPrevented ? x.ReaderDocumentEventState.DEFAULT_PREVENTED : x.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: g.R,
                    screenX: h.screenX,
                    screenY: h.screenY,
                    userGenerated: h.isTrusted
                }, h), g.R.getReadingSystemEngine().getEventBus().emit(h));
            };
            this.F = function(h) {
                if (g.g && g.i !== h.isRenderingCompleted()) {
                    if (g.i = h.isRenderingCompleted(), g.i) for(gh(g), h = 0; h < g.h.length; h++)Pg(g.h[h], g.ba, g.g);
                    else for(h = 0; h < g.h.length; h++)Og(g.h[h], g.ba);
                }
            };
            this.H = function(h) {
                var l = fh(g, h);
                l && (0 === l.o && (h = new dh("annotationPointerEnter", g.B(h, l), h), g.R.getReadingSystemEngine().getEventBus().emit(h)), l.o = 2, l.u++);
            };
            this.L = function(h) {
                var l = fh(g, h);
                l && (l.u = Math.max(l.u - 1, 0), 0 === l.u && 2 === l.o && (l.o = 1, window.setTimeout(function() {
                    if (!l.isDestroyed() && 1 === l.o && 0 === l.u) {
                        l.o = 0;
                        var r = new dh("annotationPointerLeave", g.B(h, l), h);
                        g.R.getReadingSystemEngine().getEventBus().emit(r);
                    }
                }, 17)));
            };
            b = Object.assign({
                "pointer-events": "none",
                "z-index": "" + e
            }, b);
            this.g = this.ba.createOverlayElement(b);
            this.g.dataset.typename = "IReaderViewAnnotationLayer";
            this.g.dataset.instancename = f.getName();
            b = this.g.classList;
            b.add("colibrio-reader-view-annotation-layer");
            a = a.getSpreadSlot();
            a === t.PageSpreadSlot.LEFT ? b.add("colibrio-reader-view-annotation-layer--left-spread") : a === t.PageSpreadSlot.RIGHT ? b.add("colibrio-reader-view-annotation-layer--right-spread") : a === t.PageSpreadSlot.CENTER && b.add("colibrio-reader-view-annotation-layer--center-spread");
            c && b.add(c);
            hh && ih || ("onpointerenter" in this.g ? (hh = "pointerenter", ih = "pointerleave") : (hh = "mouseenter", ih = "mouseleave"));
            this.R = f.getReaderView();
            this.i = this.ba.isRenderingCompleted();
            gh(this);
            this.ba.addStateChangeListener(this.F);
            this.ba.addOverflowingElementScrolledListener(this.refreshAnnotations);
            this.u || (this.g.style.display = "none");
        }
        function jh(a, b) {
            a.g && !a.o.has(b.getId()) && (a.o.set(b.getId(), b), a.h.push(b), a.i && Pg(b, a.ba, a.g));
        }
        function kh(a, b) {
            a.g && (b ? a.g.classList.add("colibrio-reader-view-annotation-layer--input-engine-events-enabled") : a.g.classList.remove("colibrio-reader-view-annotation-layer--input-engine-events-enabled"));
        }
        eh.prototype.setVisible = function(a) {
            this.u !== a && (this.u = a, this.g && (this.g.style.display = a ? "block" : "none"));
        };
        function fh(a, b) {
            b = b.target.dataset.id;
            return b ? (a = a.o.get(parseInt(b))) ? a : null : null;
        }
        function gh(a) {
            if (a.i && !a.l && a.g && hh && ih) {
                a.l = !0;
                if (p.BrowserDetector.isOS("iOS") || p.BrowserDetector.isOS("macOS") && 1 < navigator.maxTouchPoints) {
                    var b = sg(a.R.getReadingSystemEngine());
                    a.v = new Zg(a.g, b);
                    a.g.classList.add("colibrio-reader-view-annotation-layer--disable-text-selection");
                }
                a.g.addEventListener("contextmenu", a.D);
                a.g.addEventListener("click", a.C);
                a.g.addEventListener(hh, a.H, !0);
                a.g.addEventListener(ih, a.L, !0);
            }
        }
        var hh = null, ih = null;
        function lh(a, b) {
            var c = this;
            this.W = a;
            this.i = b;
            this.l = new Ce;
            this.A = !1;
            this.v = new Sc;
            this.o = new Ce;
            this.C = null;
            this.s = new Map;
            this.u = new Map;
            this.j = [];
            this.B = !0;
            this.F = function(d) {
                mh(c, d.g);
            };
            this.H = function(d) {
                nh(c, d.g);
            };
            this.L = function(d) {
                oh(c, d.readerDocument);
            };
            this.O = function() {
                ph(c, c.i.getReaderPublications());
            };
            this.D = function() {
                c.C = c.i.C;
                c.l.forEach(function(d) {
                    qh(c, d.m.S, d.m);
                });
            };
            this.g = Xg();
            this.h = rh();
            T(this.i, "visibleRangeChanged", this.D);
            T(this.i, "renderablePageLoaded", this.F);
            T(this.i, "renderablePageUnloaded", this.H);
            T(this.i, "readerDocumentLoaded", this.L);
            T(this.i, "readerViewDocumentsChanged", this.O);
            a = this.i.Pa;
            Array.from(a.Sa.keys()).forEach(function(d) {
                return oh(c, d);
            });
            a.hb().forEach(function(d) {
                return mh(c, d);
            });
            this.D();
            ph(this, b.getReaderPublications());
        }
        function sh(a) {
            R(a.i, "visibleRangeChanged", a.D);
            R(a.i, "renderablePageLoaded", a.F);
            R(a.i, "renderablePageUnloaded", a.H);
            R(a.i, "readerDocumentLoaded", a.L);
            R(a.i, "readerViewDocumentsChanged", a.O);
            a.s.forEach(function(b, c) {
                nh(a, c);
            });
            a.A = !0;
            a.l.forEach(function(b) {
                a.destroyAnnotation(b.m);
            });
            a.v.clear();
        }
        k = lh.prototype;
        k.addEngineEventListener = function(a, b) {
            this.A || this.v.add(a, b);
        };
        k.createAnnotation = function(a, b) {
            b = new Mg(this, a, Ja(b) ? null : b, th(this.g));
            var c = Ee(this.l, b);
            b.C = c;
            uh(this, b, a);
            return b;
        };
        k.createAnnotations = function(a) {
            for(var b = Array(a.length), c = th(this.g), d = 0; d < a.length; d++){
                var e = a[d], f = new Mg(this, e, null, c);
                b[d] = f;
                var g = Ee(this.l, f);
                f.C = g;
                uh(this, f, e);
            }
            return b;
        };
        k.destroyAllAnnotations = function() {
            var a = this;
            this.l.forEach(function(b) {
                return a.destroyAnnotation(b.m);
            });
        };
        k.destroyAnnotation = function(a) {
            if (a.getAnnotationLayer() !== this) throw new D("INVALID_ANNOTATION_LAYER", "Cannot destroy ReaderViewAnnotation. It belongs to another ReaderViewAnnotationLayer instance.");
            if (!a.isDestroyed()) {
                var b = a.C;
                b && Fe(this.l, b);
                if (b = a.S || a.l) {
                    b = b.getReaderDocuments();
                    for(var c = a.F, d = 0; d < b.length; d++){
                        var e = b[d], f = this.u.get(e);
                        f && c && (Fe(f, c[d]), 0 === f.size() && this.u.delete(e));
                    }
                }
                (b = a.i) && Fe(this.o, b);
                a.A || (Ug(a, !1), a.A = !0, a.C = null, a.S = null, a.F = null, a.l = null, a.i = null, a.h.clear(), a.j.forEach(Wa), a.j.clear());
            }
        };
        k.getAnnotations = function() {
            var a = this.l, b = [];
            b.length = a.Da;
            for(var c = a.h.aa, d = 0; c !== a.g; d++)b[d] = c.m, c = c.aa;
            return b;
        };
        k.getDefaultAnnotationOptions = function() {
            return La(this.g);
        };
        k.getEngineEventListeners = function(a) {
            return this.v.get(a);
        };
        k.getLayerOptions = function() {
            return La(this.h);
        };
        k.getName = function() {
            return this.W;
        };
        k.getReaderView = function() {
            return this.i.getReaderView();
        };
        k.isDestroyed = function() {
            return this.A;
        };
        k.isVisible = function() {
            return this.B;
        };
        k.refreshAnnotations = function() {
            this.s.forEach(function(a) {
                return a.refreshAnnotations();
            });
        };
        k.removeEngineEventListener = function(a, b) {
            this.v.remove(a, b);
        };
        k.setDefaultAnnotationOptions = function(a) {
            var b = this, c = this.g;
            this.g = y(a, La(this.g), !0);
            this.g = y(this.g, Xg());
            var d = Qa(this.g.containerStyle, c.containerStyle), e = Qa(this.g.rangeStyle, c.rangeStyle), f = Qa(this.g.positionStyle, c.positionStyle);
            this.l.forEach(function(g) {
                g.m.hasCustomizedStyleOptions() || (Vg(g.m, b.g.rangeStyle, e, b.g.positionStyle, f, b.g.containerStyle, d), Sg(g.m, b.g.positionClassName, b.g.rangeClassName, b.g.containerClassName));
            });
        };
        k.setLayerOptions = function(a) {
            var b = this, c = this.h;
            this.h = y(a, La(this.h), !0);
            this.h = y(this.h, rh());
            this.h.zIndex = Math.max(0, this.h.zIndex) | 0;
            var d = Qa(this.h.layerStyle, c.layerStyle);
            this.s.forEach(function(e) {
                var f = b.h.layerStyle;
                if (e.g) {
                    for(var g = 0; g < d.length; g++)e.g.style.removeProperty(d[g]);
                    Ta(e.g, f);
                }
                f = b.h.layerClassName;
                e.g && f !== e.j && (f && e.g.classList.add(f), e.j && e.g.classList.remove(e.j), e.j = f);
                kh(e, b.h.annotationInputEngineEventsEnabled);
                e.g && (e.g.style.zIndex = "" + b.h.zIndex);
            });
        };
        k.setVisible = function(a) {
            this.B !== a && (this.B = a, this.s.forEach(function(b) {
                b.setVisible(a);
            }));
        };
        function vh(a, b, c) {
            var d = a.i.Pa;
            c.getReaderDocuments().forEach(function(e) {
                d.isReaderDocumentLoaded(e) && a.s.forEach(function(f, g) {
                    g.getReaderDocument() === e && (g.getPageFragmentationContext() && !g.getRangeContentLocation().intersects(c) || jh(f, b));
                });
            });
        }
        function mh(a, b) {
            var c = new eh(b, a.h.layerStyle, a.h.layerClassName, a.B, a.h.zIndex, a);
            kh(c, a.h.annotationInputEngineEventsEnabled);
            a.s.set(b, c);
            (a = a.u.get(b.getReaderDocument())) && a.forEach(function(d) {
                var e = d.m.S;
                e && (d = d.m, b.getPageFragmentationContext() && !b.getRangeContentLocation().intersects(e) || jh(c, d));
            });
        }
        function nh(a, b) {
            var c = a.s.get(b);
            if (c && (a.s.delete(b), c.g)) {
                c.ba.destroyOverlayElement(c.g);
                c.l && (c.l = !1, c.g.removeEventListener("contextmenu", c.D), c.g.removeEventListener("click", c.C), c.g.removeEventListener(hh, c.H, !0), c.g.removeEventListener(ih, c.L, !0));
                c.v && c.v.destroy();
                if (c.ba.isRenderingCompleted()) for(a = 0; a < c.h.length; a++)Og(c.h[a], c.ba);
                c.ba.removeStateChangeListener(c.F);
                c.ba.removeOverflowingElementScrolledListener(c.refreshAnnotations);
                c.o.clear();
                c.g = null;
            }
        }
        function oh(a, b) {
            (b = a.u.get(b)) && b.forEach(function(c) {
                var d = c.m;
                d = d.S || d.l;
                var e = c.m.S;
                d && !e && wh(a, c.m, d);
            });
        }
        function wh(a, b, c) {
            var d = b.S;
            d ? vh(a, b, d) : rg(c) ? (Rg(b, c), qh(a, c, b), vh(a, b, c)) : c.resolve().then(function(e) {
                b.isDestroyed() || b.S || (Rg(b, e), qh(a, e, b), vh(a, b, e));
            }).catch(function(e) {
                p.ColibrioError.isColibrioAbortedError(e) || p.Logger.logError(e);
            });
        }
        function uh(a, b, c) {
            if (0 < a.j.length) {
                var d = a.j[0];
                if (W(c)) {
                    if (c.getReaderPublication() === d) b.l = c, xh(a, d, b, c);
                    else {
                        var e = Ee(a.o, b);
                        b.i = e;
                    }
                } else rg(c) ? c.getReaderPublication() === d ? (Rg(b, c), qh(a, c, b), xh(a, d, b, c)) : (e = Ee(a.o, b), b.i = e) : d.fetchUnresolvedContentLocation(c).then(function(f) {
                    b.isDestroyed() || (b.l = f, xh(a, d, b, f));
                }).catch(function(f) {
                    b.isDestroyed() || (d === a.j[0] ? (p.ColibrioError.isColibrioAbortedError(f) || p.Logger.logError(f), f = Ee(a.o, b), b.i = f) : uh(a, b, c));
                });
            } else e = Ee(a.o, b), b.i = e;
        }
        function xh(a, b, c, d) {
            if (b === a.j[0]) {
                b = d.getReaderDocuments();
                for(var e = [], f = 0; f < b.length; f++){
                    var g = b[f], h = a.u.get(g);
                    h || (h = new Ce, a.u.set(g, h));
                    g = Ee(h, c);
                    e.push(g);
                }
                c.F = e;
                b.some(function(l) {
                    return a.i.Pa.isReaderDocumentLoaded(l);
                }) && wh(a, c, d);
            } else Wg(c), uh(a, c, c.D);
        }
        function ph(a, b) {
            if (!a.A && (b === a.j ? 0 : a.j.length === b.length ? a.j.some(function(d) {
                return -1 === b.indexOf(d);
            }) : 1)) {
                a.j = b;
                a.u.forEach(function(d, e) {
                    -1 === b.indexOf(e.getReaderPublication()) && (d.forEach(function(f) {
                        if (!f.m.i) {
                            f.m.F = null;
                            Wg(f.m);
                            var g = Ee(a.o, f.m);
                            f.m.i = g;
                        }
                    }), a.u.delete(e));
                });
                var c = a.o;
                a.o = new Ce;
                c.forEach(function(d) {
                    d.m.i = null;
                    uh(a, d.m, d.m.D);
                });
            }
        }
        function qh(a, b, c) {
            Ug(c, !!(a.C && (null == b ? 0 : b.intersects(a.C))));
        }
        function th(a) {
            return {
                containerClassName: a.containerClassName,
                containerStyle: a.containerStyle,
                positionClassName: a.positionClassName,
                positionStyle: a.positionStyle,
                rangeClassName: a.rangeClassName,
                rangeStyle: a.rangeStyle
            };
        }
        function rh() {
            return {
                annotationInputEngineEventsEnabled: !1,
                layerClassName: "",
                layerStyle: {},
                zIndex: 0
            };
        }
        function yh(a) {
            G.call(this, "swipeNavigationGestureProgress", a);
        }
        m.inherits(yh, X);
        yh.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this);
            return Object.assign(a, {
                animationProgress: this.animationProgress,
                deltaX: this.deltaX,
                deltaY: this.deltaY,
                objectType: x.EngineEventDataObjectType.SWIPE_NAVIGATION_GESTURE_PROGRESS_ENGINE_EVENT,
                pendingNavigationAction: this.m.dd,
                relativeDeltaClientX: this.relativeDeltaClientX,
                relativeDeltaClientY: this.relativeDeltaClientY,
                relativeDeltaScreenX: this.relativeDeltaScreenX,
                relativeDeltaScreenY: this.relativeDeltaScreenY
            });
        };
        m.global.Object.defineProperties(yh.prototype, {
            animationProgress: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Jd;
                }
            },
            deltaX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.fc;
                }
            },
            deltaY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.hc;
                }
            },
            pendingNavigationAction: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.dd;
                }
            },
            relativeDeltaClientX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.fc / window.innerWidth;
                }
            },
            relativeDeltaClientY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.hc / window.innerHeight;
                }
            },
            relativeDeltaScreenX: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.fc / screen.width;
                }
            },
            relativeDeltaScreenY: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.hc / screen.height;
                }
            }
        });
        function zh(a) {
            var b = this;
            this.h = a;
            this.B = !1;
            this.i = {
                za: 0,
                Aa: 0
            };
            this.v = 0;
            this.s = !1;
            this.g = new Map;
            this.u = 0;
            this.l = function() {
                b.B = !1;
                b.i = {
                    za: 0,
                    Aa: 0
                };
                b.u = 0;
                b.v = 0;
                b.g.clear();
                b.s = !1;
            };
            this.C = function(c) {
                null !== c.newGestureType && c.oldGestureType !== x.ReaderViewGestureType.PAN_ZOOM || b.l();
            };
            this.D = function() {
                b.o = b.h.getOptions().gestureOptions.panZoom;
                b.l();
            };
            this.j = a.Ha;
            this.o = this.h.getOptions().gestureOptions.panZoom;
            T(this.h, "activeGestureTypeChanged", this.C);
            T(this.h, "navigationStarted", this.l);
            T(this.h, "readerViewOptionsChanged", this.D);
        }
        function Ah(a, b) {
            var c = a.o.pointerTypes;
            if ("mouse" === b.pointerType && c.mouse || "pen" === b.pointerType && c.pen || "touch" === b.pointerType && c.touch) "pointerup" === b.type || "pointercancel" === b.type ? Bh(a, b) : "pointerdown" === b.type ? (a.B = !1, a.g.has(b.pointerId) || b.readerDocumentEventState === x.ReaderDocumentEventState.DEFAULT_PREVENTED || (a.g.set(b.pointerId, {
                Mb: b.clientX,
                Nb: b.clientY,
                Db: b.screenX,
                Eb: b.screenY
            }), Ch(a, !1), Dh(a, !1))) : "pointermove" === b.type && (c = a.g.get(b.pointerId)) && (c.Mb += b.screenX - c.Db, c.Nb += b.screenY - c.Eb, c.Db = b.screenX, c.Eb = b.screenY, (c = Eh(a.h, x.ReaderViewGestureType.PAN_ZOOM) && (2 <= a.g.size || !Fh(a.j.g) && a.o.allowSinglePointerPan)) && !a.h.getActiveGestureType() && Gh(a.h, x.ReaderViewGestureType.PAN_ZOOM), c || b.readerDocumentEventState !== x.ReaderDocumentEventState.DEFAULT_PREVENTED ? (Ch(a, c), Dh(a, !0)) : Bh(a, b));
        }
        function Hh(a) {
            var b = 0;
            a.g.forEach(function(c) {
                var d = c.Mb - a.i.za;
                c = c.Nb - a.i.Aa;
                d = Math.sqrt(d * d + c * c);
                d > b && (b = d);
            });
            return b;
        }
        function Bh(a, b) {
            a.g.delete(b.pointerId);
            0 === a.g.size && (a.h.getActiveGestureType() === x.ReaderViewGestureType.PAN_ZOOM ? (1.05 > a.j.g.g[0] && a.j.removeActiveTransform(void 0, !0).catch(function(c) {
                p.ColibrioError.isColibrioAbortedError(c) || p.Logger.logError(c);
            }), Gh(a.h, null)) : a.l());
            Ch(a, !1);
            Dh(a, !1);
        }
        function Ch(a, b) {
            if (1 <= a.g.size) {
                var c = 0, d = 0;
                a.g.forEach(function(e) {
                    c += e.Mb;
                    d += e.Nb;
                });
                c /= a.g.size;
                d /= a.g.size;
                b && Ih(a.j, c - a.i.za, d - a.i.Aa);
                a.i.za = c;
                a.i.Aa = d;
            }
        }
        function Dh(a, b) {
            if (!(2 > a.g.size)) {
                var c = Hh(a);
                if (0 !== c) {
                    if (b && a.u && (!a.s && Math.abs(c - a.v) > a.o.pinchZoomThresholdPx && (a.s = !0), a.s)) {
                        var d = a.j, e = a.i, f = c / a.u, g, h, l = null == (g = d.l.ka()) ? void 0 : null == (h = g.P) ? void 0 : h.getRendererElement();
                        d.canTransform() && l && !d.j && (h = Xa(l.getBoundingClientRect()), g = (e.za - h.x) / d.g.g[0], e = (e.Aa - h.y) / d.g.g[3], f = Jh(Jh(d.g, g, e).scale(f), -g, -e), f = Kh(d, f), Lh(d, f));
                    }
                    b || (a.v = c);
                    a.u = c;
                }
            }
        }
        function Mh(a, b, c) {
            var d = this;
            this.v = a;
            this.h = b;
            this.B = c;
            this.g = new Set;
            this.j = this.i = null;
            this.l = function() {
                d.i = null;
                d.j = null;
                d.g.clear();
            };
            this.C = function(e) {
                null !== e.newGestureType && e.oldGestureType !== x.ReaderViewGestureType.SWIPE_NAVIGATION || d.l();
            };
            this.D = function() {
                d.s = d.h.ka();
                d.l();
            };
            this.F = function() {
                d.o = d.h.getOptions().gestureOptions.swipeNavigation;
                d.l();
            };
            this.o = b.getOptions().gestureOptions.swipeNavigation;
            T(b, "readerViewOptionsChanged", this.F);
            T(b, "activeRendererRuntimeConfigChanged", this.D);
            T(b, "activeGestureTypeChanged", this.C);
            T(b, "rendererTransitionStarted", this.l);
            this.s = b.ka();
            this.u = new zh(b);
        }
        Mh.prototype.handlePointerEngineEvent = function(a) {
            if (this.s) {
                if (Eh(this.h, x.ReaderViewGestureType.PAN_ZOOM) ? Ah(this.u, a) : this.u.l(), Eh(this.h, x.ReaderViewGestureType.SWIPE_NAVIGATION)) {
                    var b = this.o.pointerTypes, c = "mouse" === a.pointerType && 1 === a.buttons || "mouse" !== a.pointerType && a.isPrimary;
                    if ("mouse" === a.pointerType && b.mouse || "pen" === a.pointerType && b.pen || "touch" === a.pointerType && b.touch) {
                        var d = b = 0;
                        switch(a.type){
                            case "pointerdown":
                                a.readerDocumentEventState !== x.ReaderDocumentEventState.DEFAULT_PREVENTED && (this.g.add(a.pointerId), c && 1 === this.g.size && null === this.i && null === this.j && (this.i = a.screenX, this.j = a.screenY));
                                break;
                            case "pointermove":
                                a.isPrimary && this.g.has(a.pointerId) && (b = null !== this.i ? a.screenX - this.i : 0, d = null !== this.j ? a.screenY - this.j : 0, this.h.getActiveGestureType() || a.readerDocumentEventState !== x.ReaderDocumentEventState.DEFAULT_PREVENTED || (this.j = this.i = null, this.g.delete(a.pointerId)));
                                break;
                            case "pointerup":
                                a.isPrimary && this.g.has(a.pointerId) && (b = null !== this.i ? a.screenX - this.i : 0, d = null !== this.j ? a.screenY - this.j : 0, this.j = this.i = null);
                                this.g.delete(a.pointerId);
                                break;
                            case "pointercancel":
                                a.isPrimary && (this.j = this.i = null), this.g.delete(a.pointerId);
                        }
                        c = this.s.P;
                        this.h.getActiveGestureType() || 1 !== this.g.size || (c.getSwipeNavigationAxis() === p.Axis.X && Math.abs(b) > this.o.pointerDragThresholdPx || c.getSwipeNavigationAxis() === p.Axis.Y && Math.abs(d) > this.o.pointerDragThresholdPx) && Gh(this.h, x.ReaderViewGestureType.SWIPE_NAVIGATION);
                        if (this.h.getActiveGestureType() === x.ReaderViewGestureType.SWIPE_NAVIGATION && a.isPrimary && (c = c.handlePointerEngineEventV2(a, b, d))) {
                            var e = lg(this.h, c.pendingNavigationAction);
                            b = new yh({
                                Jd: e ? c.swipeProgress : 0,
                                fc: b,
                                hc: d,
                                dd: e ? c.pendingNavigationAction : x.NavigationAction.CURRENT,
                                readerView: this.v
                            });
                            this.B.getEventBus().emitAsync(b);
                            "pointerup" !== a.type && "pointercancel" !== a.type || this.h.navigate(c.pendingNavigationAction).catch(function(f) {
                                p.ColibrioError.isColibrioAbortedError(f) && p.Logger.logError(f);
                            });
                        }
                    }
                } else 0 < this.g.size && this.l();
            }
        };
        function Nh(a, b, c, d) {
            this.N = b;
            this.g = d;
            this.h = [];
            this.s = this.g.getReaderPublications();
            this.u = this.g.getReaderDocuments();
            b = this.g.getOptions().pageProgressionTimelineOptions;
            this.i = a.map(function(e) {
                e = Math.ceil(e);
                0 === e && (e = 1);
                return e;
            });
            for(a = this.j = 0; a < this.i.length; a++)this.j += this.i[a];
            this.o = b.forceCompleteRendition ? x.PageProgressionTimelineType.RENDERED_PAGES : x.PageProgressionTimelineType.ESTIMATED_PAGES;
            for(b = a = 0; b < this.i.length; b++)this.h.push(a), a += this.i[b];
            this.l = Oh(this, c);
        }
        k = Nh.prototype;
        k.fetchLocatorFromPageIndex = function(a, b) {
            return this.fetchLocatorFromPosition({
                offset: 0,
                pageIndex: a
            }, b);
        };
        k.fetchLocatorFromPosition = function(a, b) {
            var c = this, d = null != b ? b : !0;
            b = !1;
            a = Ka(Math.round(a.pageIndex), 0, this.j - 1);
            for(var e = this.h.length - 1; 0 <= e && !b;)a >= this.h[e] ? b = !0 : e--;
            b = this.u[e];
            var f = this.h[e], g = a - f, h, l = (null == (h = this.g.getActiveRenderer()) ? void 0 : h.getSpreadMode()) === x.RendererSpreadMode.TWO_PAGES;
            return b.isReflowable() ? this.N.loadPageByReaderDocumentPageIndex(b, g).then(function(r) {
                if (c.o === x.PageProgressionTimelineType.ESTIMATED_PAGES) return Ph(c, r, g, e, f, d).finally(function() {
                    c.N.unloadPage(r);
                });
                if (l && d) return Qh(c, r).finally(function() {
                    c.N.unloadPage(r);
                });
                var q = r.getStartContentLocation().getLocator();
                c.N.unloadPage(r);
                return q;
            }) : l && d ? this.N.loadFirstPageInReaderDocument(b).then(function(r) {
                var q = Qh(c, r);
                c.N.unloadPage(r);
                return q;
            }) : Promise.resolve(b.getLocator());
        };
        k.fetchPositionFromLocator = function(a) {
            var b = this;
            if (W(a)) return Rh(this, a);
            var c = Ig(a);
            if (null === c) return Promise.reject(new D("NAVIGATION_ITEM_MISSING_LOCATOR"));
            var d;
            return (d = 1 < this.s.length ? this.s.find(function(e) {
                return e.isLocatorSourceUrlInPublication(c);
            }) : this.s[0]) ? d.fetchUnresolvedContentLocation(c).then(function(e) {
                return Rh(b, e);
            }) : Promise.reject(new D("NO_MATCHING_PUBLICATION_FOR_LOCATOR", a.toString()));
        };
        k.getTimelineType = function() {
            return this.o;
        };
        k.getTotalNumberOfPages = function() {
            return this.j;
        };
        k.getVisibleTimelineRange = function() {
            var a = this.l.start, b = this.l.end;
            return {
                end: {
                    offset: b.offset,
                    pageIndex: b.pageIndex
                },
                start: {
                    offset: a.offset,
                    pageIndex: a.pageIndex
                }
            };
        };
        k.toJSON = function() {
            return {
                timelineType: this.o,
                totalNumberOfPages: this.j,
                visibleTimelineRange: this.getVisibleTimelineRange()
            };
        };
        function Sh(a, b, c) {
            var d = a.h[c];
            b = b.getPageFragmentationContext();
            if (b) {
                var e = b.getPageFlowDirection() === x.PageFlowDirection.TB ? b.getDocumentHeight() : b.getDocumentWidth();
                a = d + a.i[c];
                if (0 < e) {
                    var f = Sa(b.getStartOffset(), e, d, a);
                    f = Ka(Math.round(f), d, a - 1);
                }
            }
            return f || d;
        }
        function Th(a, b) {
            var c = b.getReaderDocument();
            c = a.u.indexOf(c);
            if (-1 === c) throw new D("RENDERABLE_DOCUMENT_PAGE_NOT_FOUND", "Page not part of timeline");
            var d = b.getPageIndexInSection();
            return a.o === x.PageProgressionTimelineType.ESTIMATED_PAGES ? Sh(a, b, c) : a.h[c] + d;
        }
        function Oh(a, b) {
            if (1 === b.length) {
                var c = Th(a, b[0]);
                c = {
                    end: {
                        offset: 1 - Number.EPSILON,
                        pageIndex: c
                    },
                    start: {
                        offset: 0,
                        pageIndex: c
                    }
                };
            } else if (1 < b.length) c = Th(a, b[0]), a = Th(a, Ca(b)), c = {
                end: {
                    offset: 1 - Number.EPSILON,
                    pageIndex: a
                },
                start: {
                    offset: 0,
                    pageIndex: c
                }
            };
            else throw new D("RENDERABLE_DOCUMENT_PAGE_NOT_FOUND", "ViewPageProgressionTimeline received empty page list");
            return c;
        }
        function Ph(a, b, c, d, e, f) {
            var g, h, l, r, q, v, u, w, E;
            return m.ea(function(z) {
                switch(z.g){
                    case 1:
                        g = b;
                        h = Sh(a, b, d) - e;
                        if (h < c) {
                            z.J(2);
                            break;
                        }
                        r = !1;
                    case 4:
                        if (r || !(0 < b.getPageIndexInSection())) {
                            z.J(3);
                            break;
                        }
                        return n(z, a.N.loadPreviousPage(b), 7);
                    case 7:
                        q = z.h;
                        h = Sh(a, q, d) - e;
                        h < c ? (q !== g && a.N.unloadPage(q), r = !0) : (b !== g && a.N.unloadPage(b), b = q);
                        z.J(4);
                        break;
                    case 2:
                        v = !1;
                    case 8:
                        if (v || a.N.isLastPageOfReaderDocument(b)) {
                            z.J(3);
                            break;
                        }
                        return n(z, a.N.loadNextPage(b), 11);
                    case 11:
                        u = z.h;
                        h = Sh(a, u, d) - e;
                        h >= c && (v = !0);
                        b !== g && a.N.unloadPage(b);
                        b = u;
                        z.J(8);
                        break;
                    case 3:
                        if ((E = (null == (w = a.g.getActiveRenderer()) ? void 0 : w.getSpreadMode()) === x.RendererSpreadMode.TWO_PAGES) && f) return z.return(Qh(a, b).finally(function() {
                            b !== g && a.N.unloadPage(b);
                        }));
                        l = b.getStartContentLocation().getLocator();
                        b !== g && a.N.unloadPage(b);
                        return z.return(l);
                }
            });
        }
        function Qh(a, b) {
            return Uh(a, b) ? Promise.resolve(b.getStartContentLocation().getLocator()) : a.N.loadPreviousPage(b).then(function(c) {
                var d = c.getStartContentLocation().getLocator();
                a.N.unloadPage(c);
                return d;
            });
        }
        function Rh(a, b) {
            return a.N.loadPageByContentLocation(b).then(function(c) {
                try {
                    return {
                        offset: 0,
                        pageIndex: Th(a, c)
                    };
                } finally{
                    a.N.unloadPage(c);
                }
            });
        }
        function Uh(a, b) {
            var c = b.getSpreadSlot(), d = a.g.getPageProgressionDirection() || x.ReaderViewPageProgressionDirection.LTR;
            return c === t.PageSpreadSlot.LEFT && d === x.ReaderViewPageProgressionDirection.LTR || c === t.PageSpreadSlot.RIGHT && d === x.ReaderViewPageProgressionDirection.RTL || a.N.isFirstPage(b);
        }
        function Vh(a) {
            this.g = a;
            this.layout = x.CustomReaderViewContentLayout.FLEX_CENTER;
        }
        Vh.prototype.renderTo = function(a) {
            a.innerHTML = this.g;
        };
        function Wh(a) {
            this.h = new Map;
            Ha(a) ? this.g = new Vh(a) : this.g = a;
        }
        function Xh(a) {
            a.h.forEach(function(b, c) {
                return a.removeFrom(c);
            });
            a.h.clear();
        }
        Wh.prototype.removeFrom = function(a) {
            var b = this.h.get(a);
            if (b && (Wa(b), this.h.delete(a), B(this.g.onRemoved))) this.g.onRemoved(b);
        };
        Wh.prototype.renderTo = function(a) {
            this.removeFrom(a);
            var b = a.ownerDocument.createElement("div");
            b.classList.add("colibrio-custom-page-content");
            switch(this.g.layout){
                case x.CustomReaderViewContentLayout.BLOCK:
                    break;
                default:
                    b.classList.add("colibrio-custom-page-content--center");
            }
            a.appendChild(b);
            this.h.set(a, b);
            this.g.renderTo(b);
        };
        function Yh(a) {
            G.call(this, "activeGestureTypeChanged", a);
        }
        m.inherits(Yh, X);
        Yh.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this);
            return Object.assign(a, {
                newGestureType: this.m.$c,
                objectType: x.EngineEventDataObjectType.ACTIVE_GESTURE_TYPE_CHANGED_ENGINE_EVENT,
                oldGestureType: this.m.cd
            });
        };
        m.global.Object.defineProperties(Yh.prototype, {
            newGestureType: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.$c;
                }
            },
            oldGestureType: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.cd;
                }
            }
        });
        function Zh(a) {
            G.call(this, "activeRendererChanged", a);
        }
        m.inherits(Zh, X);
        m.global.Object.defineProperties(Zh.prototype, {
            newActiveRenderer: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.newActiveRenderer;
                }
            },
            oldActiveRenderer: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.oldActiveRenderer;
                }
            }
        });
        function $h(a, b, c) {
            G.call(this, a, b);
            this.g = c;
        }
        m.inherits($h, X);
        $h.prototype.preventDefault = function() {
            X.prototype.preventDefault.call(this);
            this.g && this.g.cancelable && this.g.preventDefault();
        };
        $h.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this), b = null, c = this.m.Ta;
            c && (b = c.contentLocation, b = {
                frameworkComponent: c.frameworkComponent,
                locator: b ? b.getLocator().toJSON() : null,
                mediaType: c.mediaType,
                nodeData: c.nodeData,
                objectType: x.EngineEventTargetObjectType.ENGINE_EVENT_TARGET,
                readerDocumentIndexInSpine: b ? b.getReaderDocuments()[0].getIndexInSpine() : null
            });
            return Object.assign(a, {
                code: this.m.Pc,
                isComposing: this.m.Rc,
                key: this.m.Ab,
                keyCode: this.m.Sc,
                location: this.m.Tc,
                modifiers: this.m.Yc,
                objectType: x.EngineEventDataObjectType.KEYBOARD_ENGINE_EVENT,
                readerDocumentEventState: this.m.ed,
                repeated: this.m.gd,
                target: b,
                userGenerated: this.m.Fb,
                willEmitDomEvent: this.willEmitDomEvent
            });
        };
        m.global.Object.defineProperties($h.prototype, {
            code: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Pc;
                }
            },
            defaultPrevented: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return X.prototype.defaultPrevented || null !== this.g && this.g.defaultPrevented;
                }
            },
            isComposing: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Rc;
                }
            },
            key: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Ab;
                }
            },
            keyCode: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Sc;
                }
            },
            location: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Tc;
                }
            },
            modifiers: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Yc;
                }
            },
            readerDocumentEventState: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ed;
                }
            },
            repeated: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.gd;
                }
            },
            target: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Ta;
                }
            },
            userGenerated: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Fb;
                }
            },
            willEmitDomEvent: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return !!this.g;
                }
            }
        });
        function ai(a, b) {
            G.call(this, a, b);
        }
        m.inherits(ai, X);
        ai.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this);
            var b = this.m.Ta;
            var c = b.contentLocation;
            b = {
                frameworkComponent: b.frameworkComponent,
                locator: c ? c.getLocator().toJSON() : null,
                mediaType: b.mediaType,
                nodeData: b.nodeData,
                objectType: x.EngineEventTargetObjectType.ENGINE_EVENT_TARGET,
                readerDocumentIndexInSpine: c ? c.getReaderDocuments()[0].getIndexInSpine() : null
            };
            b = {
                currentTimeMs: Number.isFinite(this.m.ec) ? this.m.ec : 0,
                durationMs: Number.isFinite(this.m.ua) ? this.m.ua : 0,
                mediaResource: this.m.Wc.toJSON(),
                objectType: x.EngineEventDataObjectType.PUBLICATION_MEDIA_ELEMENT_ENGINE_EVENT,
                target: b
            };
            return Object.assign(a, b);
        };
        m.global.Object.defineProperties(ai.prototype, {
            currentTimeMs: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ec;
                }
            },
            durationMs: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ua;
                }
            },
            mediaResource: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Wc;
                }
            },
            paused: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.M;
                }
            },
            ready: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Ma;
                }
            },
            target: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Ta;
                }
            }
        });
        function bi(a) {
            var b = document;
            this.g = a;
            this.h = b;
        }
        bi.prototype.dispatchClipboardEvent = function(a) {
            var b, c;
            V(this.g, new X("copy", {
                cancelable: null != (b = null == a ? void 0 : a.cancelable) ? b : !0,
                isTrusted: null != (c = null == a ? void 0 : a.isTrusted) ? c : !1,
                readerView: this.g.getReaderView()
            }));
        };
        bi.prototype.dispatchKeyboardEvent = function(a, b, c, d, e) {
            if ("keyup" === a.type || "keydown" === a.type) {
                var f = a.code, g = a.isComposing, h = a.key, l = a.keyCode, r = a.location;
                e || (e = {
                    alt: a.getModifierState("Alt"),
                    altGraph: a.getModifierState("AltGraph"),
                    capsLock: a.getModifierState("CapsLock"),
                    control: a.getModifierState("Control"),
                    meta: a.getModifierState("Meta"),
                    numLock: a.getModifierState("NumLock"),
                    os: a.getModifierState("OS"),
                    scrollLock: a.getModifierState("ScrollLock"),
                    shift: a.getModifierState("Shift")
                });
                b = {
                    Pc: f,
                    Rc: g,
                    Ab: h,
                    Sc: l,
                    Tc: r,
                    Yc: e,
                    ed: c,
                    gd: a.repeat,
                    Ta: b,
                    Fb: d,
                    cancelable: !0,
                    isTrusted: a.isTrusted,
                    readerView: this.g.getReaderView()
                };
                c = a.target;
                V(this.g, new $h(a.type, b, c === this.h || c === this.h.defaultView || c && C(c.nodeType) && c.ownerDocument === this.h ? a : null));
            }
        };
        bi.prototype.dispatchMediaElementEvent = function(a, b, c, d) {
            V(this.g, new ai(a, {
                ec: Math.round(b.currentTimeMs),
                ua: Math.round(b.durationMs),
                Wc: c,
                M: b.paused,
                Ma: b.ready,
                Ta: d,
                cancelable: !1,
                isTrusted: !1,
                readerView: this.g.getReaderView()
            }));
        };
        bi.prototype.getEngineEventTargetForTopFrameEvent = function(a) {
            var b, c = null == (b = this.g.ka()) ? void 0 : b.P, d = this.g.Z;
            b = null;
            if (a && 1 === a.nodeType && d) {
                if (b = (null == c ? void 0 : c.getRenderablePageByElement(a)) || null) {
                    a: {
                        for(c = !1; a && !c;){
                            c = a === d;
                            if (a && 1 === a.nodeType && a.classList.contains("colibrio-reader-view-annotation-layer")) {
                                d = !0;
                                break a;
                            }
                            a = a.parentNode;
                        }
                        d = !1;
                    }
                    d = d ? x.EngineEventTargetFrameworkComponent.READER_VIEW_ANNOTATION : x.EngineEventTargetFrameworkComponent.READER_DOCUMENT;
                } else {
                    for(c = !1; a && !c;)c = a === d, a = a.parentNode;
                    d = c ? x.EngineEventTargetFrameworkComponent.READER_VIEW : x.EngineEventTargetFrameworkComponent.APP_WINDOW;
                }
            } else d = x.EngineEventTargetFrameworkComponent.APP_WINDOW;
            return {
                contentLocation: b && b.getStartContentLocation(),
                frameworkComponent: d,
                mediaType: "",
                nodeData: null
            };
        };
        function Z(a) {
            this.da = a;
            this.i = this.h = !1;
        }
        Z.prototype.preventDefault = function() {};
        Z.prototype.stopImmediatePropagation = function() {
            this.h = !0;
        };
        Z.prototype.stopPropagation = function() {
            this.i = !0;
        };
        Z.prototype.toJSON = function() {
            throw new Cd("toJSON() not allowed on internal events.");
        };
        m.global.Object.defineProperties(Z.prototype, {
            immediatePropagationStopped: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.h;
                }
            },
            propagationStopped: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.i;
                }
            },
            cancelable: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return !1;
                }
            },
            defaultPrevented: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return !1;
                }
            },
            isTrusted: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return !1;
                }
            },
            readerView: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return null;
                }
            },
            type: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.da;
                }
            }
        });
        function ci(a) {
            G.call(this, "navigationEnded", a);
        }
        m.inherits(ci, X);
        ci.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this);
            return Object.assign(a, {
                navigationAction: this.m.eb,
                objectType: x.EngineEventDataObjectType.NAVIGATION_ENDED_ENGINE_EVENT
            });
        };
        m.global.Object.defineProperties(ci.prototype, {
            navigationAction: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.eb;
                }
            }
        });
        function di(a) {
            G.call(this, "navigationStarted", a);
        }
        m.inherits(di, X);
        di.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this);
            return Object.assign(a, {
                dueToRenderingConfigChanged: this.m.ic,
                navigationAction: this.m.eb,
                objectType: x.EngineEventDataObjectType.NAVIGATION_STARTED_ENGINE_EVENT,
                replacedOngoingNavigation: this.m.hd
            });
        };
        m.global.Object.defineProperties(di.prototype, {
            dueToRenderingConfigChanged: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.ic;
                }
            },
            navigationAction: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.eb;
                }
            },
            replacedOngoingNavigation: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.hd;
                }
            }
        });
        function ei(a) {
            G.call(this, "rendererScrollEnded", a);
        }
        m.inherits(ei, X);
        ei.prototype.toJSON = function() {
            var a = {
                objectType: x.EngineEventDataObjectType.RENDERER_SCROLL_ENGINE_EVENT,
                scrollDistance: this.m.md,
                scrollTop: this.m.nd,
                userGenerated: this.m.Fb
            };
            return Object.assign(X.prototype.toJSON.call(this), a);
        };
        m.global.Object.defineProperties(ei.prototype, {
            scrollDistance: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.md;
                }
            },
            scrollTop: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.nd;
                }
            },
            userGenerated: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.Fb;
                }
            }
        });
        function fi() {}
        fi.prototype.renderTo = function(a) {
            var b = a.ownerDocument, c = Ua(b, [
                {
                    name: "class",
                    value: "colibrio-loader"
                }
            ]), d = Ua(b, [
                {
                    name: "class",
                    value: "colibrio-loader__birdie"
                }
            ]);
            b = Ua(b, [
                {
                    name: "class",
                    value: "colibrio-loader__spinner"
                }
            ]);
            c.appendChild(d);
            c.appendChild(b);
            a.appendChild(c);
        };
        var gi = __lib__timsort;
        function hi(a) {
            this.g = a;
            this.h = 0;
        }
        k = hi.prototype;
        k.destroy = function() {
            for(var a = 0; a < this.g.length; a++)this.g[a].destroy();
            this.g = [];
        };
        k.getEstimatedNumberOfPages = function() {
            return this.g.length;
        };
        k.hasNext = function() {
            return this.h < this.g.length;
        };
        k.next = function() {
            return this.g[this.h++] || null;
        };
        k.skipNext = function() {
            return this.hasNext() ? (this.h++, !0) : !1;
        };
        function ii(a, b) {
            this.j = !0;
            this.h = this.g = a;
            this.i = b || null;
        }
        function ji(a, b) {
            if (null !== a.g) {
                var c = ki(a, b);
                for(a.j = !1; null !== a.g && a.i && !a.i(a.g);)c += ki(a, b);
            }
        }
        ii.prototype.next = function(a) {
            if (this.j && (!this.i || this.i(this.g))) return this.j = !1, this.g;
            ji(this, a);
            return this.g;
        };
        function ki(a, b) {
            var c = a.g, d = 0;
            if (c.firstChild && (B(b) ? b(c) : b)) a.g = c.firstChild, d = 1;
            else if (c !== a.h && c.nextSibling) a.g = c.nextSibling;
            else {
                for(; c !== a.h && !c.nextSibling;)c = c.parentNode, d--;
                c === a.h ? a.g = null : a.g = c.nextSibling;
            }
            return d;
        }
        function li(a, b, c, d, e, f, g, h) {
            var l = this;
            this.u = a;
            this.C = b;
            this.F = c;
            this.l = d;
            this.S = e;
            this.$ = f;
            this.i = g;
            this.D = void 0 === h ? null : h;
            this.j = [];
            this.v = null;
            this.s = 1;
            this.h = !1;
            this.va = x.RenderableState.CREATED;
            this.o = new $a;
            this.g = null;
            this.B = function(r) {
                l.g && (Ta(r, {
                    height: "100%",
                    left: "0",
                    position: "absolute",
                    top: "0",
                    width: "100%"
                }), l.g.appendChild(r));
            };
        }
        k = li.prototype;
        k.addOverflowingElementScrolledListener = function() {};
        k.addStateChangeListener = function(a) {
            this.o.add(a);
        };
        k.createOverlayElement = function(a) {
            var b = document.createElement("div");
            Ta(b, a);
            this.j.push(b);
            this.B(b);
            return b;
        };
        k.destroy = function() {
            this.remove();
            this.va = x.RenderableState.DESTROYED;
            this.o.clear();
        };
        k.destroyOverlayElement = function(a) {
            var b = this.j.indexOf(a);
            -1 !== b && (this.j.splice(b, 1), Wa(a));
        };
        k.fetchContentLocationByTopOffset = function() {
            return Promise.resolve(this.S);
        };
        k.fetchContentRangeByTopOffsets = function() {
            return Promise.resolve(this.S);
        };
        k.fetchContentRangesByTopOffsets = function() {
            return Promise.resolve({
                next: null,
                previous: null,
                visible: this.S
            });
        };
        k.fetchOverlayRectsForContentLocation = function() {
            return Promise.resolve({
                collapsed: !0,
                rects: []
            });
        };
        k.fetchRectsForVisibleContent = function(a) {
            return Promise.resolve({
                boundingClientRect: null,
                contentLocation: a,
                rects: [],
                toJSON: function() {
                    return {
                        boundingClientRect: null,
                        locator: a.toJSON(),
                        rects: []
                    };
                }
            });
        };
        k.focusOnContentLocation = function() {
            if (this.g) {
                var a = new ii(this.g, function(b) {
                    var c;
                    if ((c = Ea(b)) && !(c = Fa(b.textContent))) a: {
                        if (Ea(b)) switch(b.localName){
                            case "img":
                            case "video":
                            case "audio":
                                c = !0;
                                break a;
                        }
                        c = b && b && 1 === b.nodeType && "http://www.w3.org/2000/svg" === b.namespaceURI && "image" === b.localName;
                    }
                    return c;
                });
                a.h = this.g;
                ji(a, !0);
                if (a = a.g) return a.hasAttribute("tabindex") || Va(a) || a.setAttribute("tabindex", "-1"), a.focus({
                    preventScroll: !0
                }), Promise.resolve();
            }
            return Promise.reject(new D("NO_FOCUSABLE_CONTENT_FOUND"));
        };
        k.getPageContentElement = function() {
            return this.g;
        };
        k.getPageDimensions = function() {
            return this.g ? {
                height: this.g.clientHeight,
                width: this.g.clientWidth
            } : {
                height: 0,
                width: 0
            };
        };
        k.getPageFragmentationContext = function() {
            return this.D;
        };
        k.getPageIndexInSection = function() {
            return this.F;
        };
        k.getRangeContentLocation = function() {
            return this.S;
        };
        k.getReaderDocument = function() {
            return this.$;
        };
        k.getSectionIndex = function() {
            return this.C;
        };
        k.getSpreadSlot = function() {
            return this.l;
        };
        k.getStartContentLocation = function() {
            return this.S;
        };
        k.getState = function() {
            return this.va;
        };
        k.isCustomPageContent = function() {
            return !0;
        };
        k.isRenderingCompleted = function() {
            return this.h;
        };
        k.isRenderingPaused = function() {
            return !1;
        };
        k.print = function() {
            throw new D("PRINT_NOT_SUPPORTED");
        };
        k.remove = function() {
            this.va === x.RenderableState.VISIBLE && this.setVisible(!1);
            this.s++;
            this.va === x.RenderableState.ATTACHED_TO_DOM && (this.v && (this.v = null), this.j.forEach(Wa), this.g && this.u.removeFrom(this.g), this.g = null, mi(this, x.RenderableState.CREATED, !1));
        };
        k.removeOverflowingElementScrolledListener = function() {};
        k.removeStateChangeListener = function(a) {
            this.o.remove(a);
        };
        k.renderTo = function(a) {
            var b = this;
            this.remove();
            var c = this.s, d = a.ownerDocument.createElement("div");
            mi(this, x.RenderableState.CREATED, !1);
            return this.$.fetchViewportDimensions().catch(function() {
                return null;
            }).then(function(e) {
                b.s === c && (e = e ? b.i.getConstrainedPageDimensions(e, b.l) : b.i.getUnconstrainedPageDimensions(b.l), b.g = d, d.style.width = e.width + "px", d.style.height = e.height + "px", e = b.i.getConstrainedPageOffsets(e, b.l), b.i.getRenderer().getSupportedFlowModes().includes(t.ContentDocumentFlowMode.PAGINATED) && (d.style.top = e.top + "px", d.style.left = e.left + "px", d.style.position = "absolute"), e = b.i.getReaderViewOptions().publicationStyleOptions.palette, d.style.backgroundColor = e ? e.backgroundLight : "#fff", d.style.color = e ? e.foregroundDark : "#000", a.appendChild(d), b.u.renderTo(d), b.j.forEach(b.B), mi(b, x.RenderableState.ATTACHED_TO_DOM, !0));
            });
        };
        k.setContentSelection = function() {
            p.Logger.logWarning("setContentSelection is not implemented for Custom Content");
            return Promise.resolve();
        };
        k.setRenderingPaused = function() {};
        k.setSpreadSlot = function(a) {
            this.l = a;
        };
        k.setVisible = function(a) {
            a && this.va === x.RenderableState.ATTACHED_TO_DOM ? mi(this, x.RenderableState.VISIBLE, this.h) : a || this.va !== x.RenderableState.VISIBLE || mi(this, x.RenderableState.ATTACHED_TO_DOM, this.h);
        };
        function mi(a, b, c) {
            if (a.va !== b || a.h !== c) a.va = b, a.h = c, ab(a.o, a, function(d) {
                p.ColibrioError.isColibrioAbortedError(d) || p.Logger.logError(d);
            });
        }
        function ni(a, b, c) {
            this.$ = a;
            this.g = b;
            this.h = c;
            this.rangeContentLocation = a.getContentLocation();
        }
        ni.prototype.createPageIterator = function() {
            var a = this, b;
            return m.ea(function(c) {
                if (1 == c.g) return n(c, a.createRenderablePage(), 2);
                b = c.h;
                return c.return(new hi([
                    b
                ]));
            });
        };
        ni.prototype.createRenderablePage = function() {
            return Promise.resolve(new li(this.g, 0, 0, t.PageSpreadSlot.AUTO, this.$.getContentLocation(), this.$, this.h));
        };
        function oi(a, b, c) {
            this.$ = a;
            this.g = b;
            this.h = c;
            this.rangeContentLocation = a.getContentLocation();
            this.sections = [
                new ni(this.$, this.g, this.h)
            ];
        }
        oi.prototype.destroy = function() {};
        function pi(a) {
            this.g = a;
            this.h = 0;
        }
        k = pi.prototype;
        k.destroy = function() {
            for(var a = 0; a < this.g.length; a++)this.g[a].destroy();
            this.g = [];
        };
        k.getEstimatedNumberOfPages = function() {
            return this.g.length;
        };
        k.hasNext = function() {
            return this.h < this.g.length;
        };
        k.next = function() {
            return this.g[this.h++] || null;
        };
        k.skipNext = function() {
            return this.hasNext() ? (this.h++, !0) : !1;
        };
        function qi(a, b, c, d, e, f, g, h, l) {
            this.N = a;
            this.R = b;
            this.l = c;
            this.ca = d;
            this.i = e;
            this.Ka = f;
            this.$ = g;
            this.j = h;
            this.g = l;
            this.h = !1;
        }
        k = qi.prototype;
        k.addReaderViewPropertyChangedListener = function(a, b) {
            var c = this.g, d = c.h.get(a);
            d || (d = new Ce, c.h.set(a, d));
            Ee(d, b);
        };
        k.cancel = function() {
            this.h = !0;
        };
        k.getConstrainedPageDimensions = function(a, b) {
            var c = this.ca.getSupportedFlowModes().includes(t.ContentDocumentFlowMode.PAGINATED) ? 1 : 0;
            b = ri(this, b);
            b = si(this, a, b);
            return {
                height: Math.round(a.height * b) + c,
                width: Math.round(a.width * b) + c
            };
        };
        k.getConstrainedPageOffsets = function(a, b) {
            var c = ri(this, b), d = this.ca.getSupportedFlowModes().includes(t.ContentDocumentFlowMode.SCROLLED_DOC) ? 0 : (c.height - a.height) / 2;
            a = c.width - a.width;
            return {
                left: null === b ? 0 : b === t.PageSpreadSlot.LEFT ? a : b === t.PageSpreadSlot.RIGHT ? 0 : a / 2,
                top: d
            };
        };
        k.getConstrainedPageScaleFactor = function(a, b) {
            b = ri(this, b);
            return si(this, a, b);
        };
        k.getEngineEventDispatcher = function() {
            return this.Ka;
        };
        k.getPageStream = function() {
            return this.N;
        };
        k.getReaderView = function() {
            return this.R;
        };
        k.getReaderViewOptions = function() {
            return this.l;
        };
        k.getReaderViewProperty = function(a) {
            return this.g.g.get(a);
        };
        k.getRenderer = function() {
            return this.ca;
        };
        k.getRendererRuntime = function() {
            return this.i;
        };
        k.getRenderingSessionId = function() {
            return this.j;
        };
        k.getUnconstrainedPageDimensions = function(a) {
            var b = this.ca.getSupportedFlowModes().includes(t.ContentDocumentFlowMode.PAGINATED) ? 1 : 0;
            a = ri(this, a);
            return {
                height: Math.round(a.height) + b,
                width: Math.round(a.width) + b
            };
        };
        k.isCanceled = function() {
            return this.h;
        };
        k.onSelectionChanged = function(a, b) {
            ti(this.g, a, b);
        };
        k.removeReaderViewPropertyChangedListener = function(a, b) {
            var c = this.g, d = c.h.get(a);
            d && (d.remove(b), 0 === d.size() && c.h.delete(a));
        };
        function ri(a, b) {
            var c = a.$.isReflowable();
            return a.i.getContentDisplayAreaDimensions(b === t.PageSpreadSlot.CENTER, c);
        }
        function si(a, b, c) {
            var d = Math.round(c.width) + 1;
            c = Math.round(c.height) + 1;
            var e = d / c, f = b.width / b.height;
            return a.ca.getSupportedFlowModes().includes(t.ContentDocumentFlowMode.SCROLLED_DOC) ? d / b.width : f > e ? d / b.width : c / b.height;
        }
        var ui = 1;
        function vi(a, b, c, d, e, f, g) {
            var h = this;
            this.g = a;
            this.ca = b;
            this.Ka = c;
            this.C = d;
            this.F = e;
            this.v = f;
            this.D = g;
            this.s = this.A = !1;
            this.l = [];
            this.j = [];
            this.u = null;
            this.B = ui++;
            this.i = function() {
                if (wi(h)) {
                    for(var l = 0; l < h.j.length; l++)h.j[l].pause();
                    h.o && h.o.pause();
                } else {
                    for(l = 0; l < h.j.length; l++)h.j[l].resume();
                    h.o && h.o.resume();
                }
            };
            this.h = a.getReaderDocuments().filter(function(l) {
                return l.isRenderable();
            });
            T(this.g, "offscreenContentRendered", this.i);
            T(this.g, "offscreenContentRendering", this.i);
            T(this.g, "rendererTransitionEnded", this.i);
            T(this.g, "rendererTransitionStarted", this.i);
            T(this.g, "visibleContentRendered", this.i);
            T(this.g, "visibleContentRendering", this.i);
            a = 2;
            p.BrowserDetector.isOS("iOS") && "9" === p.BrowserDetector.getOsVersion().split(".")[0] && (a = 1);
            this.o = new p.AsyncTaskQueue(a, function(l) {
                return xi(h, l);
            });
            wi(this) && this.o.pause();
        }
        function yi(a) {
            return {
                Ya: !1,
                bb: null,
                T: [],
                Ob: null,
                kc: a
            };
        }
        function zi(a) {
            var b;
            return m.ea(function(c) {
                if (1 == c.g) return W(a) ? n(c, a.resolve(), 3) : (b = a, c.J(2));
                2 != c.g && (b = c.h);
                return c.return(b.collapseToStart());
            });
        }
        function Ai(a, b) {
            return a.isBefore(b) || b.contains(a);
        }
        function Bi(a) {
            a.o.destroy(new D(p.ColibrioErrorType.ABORTED));
            if (0 < a.j.length) {
                for(var b = 0; b < a.j.length; b++)a.j[b].destroy(new D(p.ColibrioErrorType.ABORTED));
                a.j = [];
            }
        }
        k = vi.prototype;
        k.destroy = function() {
            if (!this.A) {
                this.A = !0;
                R(this.g, "offscreenContentRendered", this.i);
                R(this.g, "offscreenContentRendering", this.i);
                R(this.g, "rendererTransitionEnded", this.i);
                R(this.g, "rendererTransitionStarted", this.i);
                R(this.g, "visibleContentRendered", this.i);
                for(R(this.g, "visibleContentRendering", this.i); 0 < this.l.length;)Ci(this, this.l[0]);
                this.h = [];
                Bi(this);
                this.u = null;
            }
        };
        k.fetchEstimatedHeightPerReaderDocument = function() {
            var a = this;
            if (this.A) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            if (this.h.some(function(c) {
                return c.canHaveMultipleRenderingSections();
            })) return Promise.reject(new D("INTERNAL_PAGE_STREAM_ERROR"));
            var b = this.h.map(function(c) {
                var d = Di(a, c);
                return c.fetchEstimatedHeight(d);
            });
            return Promise.all(b);
        };
        k.fetchNumberOfPagesPerReaderDocument = function(a, b) {
            var c = this;
            if (this.A) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            if (a && Ei(this)) return Promise.reject(new D("INTERNAL_PAGE_STREAM_ERROR"));
            var d = Array(this.h.length), e = -1 !== this.ca.getSupportedFlowModes().indexOf(t.ContentDocumentFlowMode.PAGINATED), f = -1 !== this.ca.getSupportedFlowModes().indexOf(t.ContentDocumentFlowMode.SCROLLED_CONTINUOUS);
            if (e || f) {
                var g = [], h = this.h.length, l = 0;
                this.h.forEach(function(r, q) {
                    if (e && r.isReflowable()) {
                        var v = Di(c, r);
                        r = (a ? r.fetchEstimatedNumberOfPages(v) : c.o.scheduleDefaultTask({
                            G: v,
                            ne: q,
                            $: r
                        }, 0)).then(function(u) {
                            d[q] = u;
                        }).catch(function(u) {
                            p.ColibrioError.isColibrioAbortedError(u) || p.Logger.logWarning(u);
                            d[q] = 1;
                        }).finally(function() {
                            v.cancel();
                            l++;
                            l < h && b(l / h);
                        });
                        g.push(r);
                    } else d[q] = 1;
                });
                f = Promise.all(g).then(function() {
                    return d;
                });
            } else {
                for(f = 0; f < this.h.length; f++)d[f] = 1;
                f = Promise.resolve(d);
            }
            return f;
        };
        k.hb = function() {
            var a = [], b = this.l.slice();
            gi.sort(b, function(l, r) {
                return l.Pb - r.Pb;
            });
            for(var c = 0; c < b.length; c++)for(var d = b[c], e = 0; e < d.ha.length; e++)for(var f = d.ha[e], g = 0; g < f.T.length; g++){
                var h = f.T[g];
                0 < h.La && a.push(h.ba);
            }
            return a;
        };
        function Ei(a) {
            return a.h.some(function(b) {
                return b.canHaveMultipleRenderingSections();
            });
        }
        k.isDestroyed = function() {
            return this.A;
        };
        k.isFirstPage = function(a) {
            return 0 === a.getPageIndexInSection() && 0 === a.getSectionIndex() && a.getReaderDocument() === Ba(this.h);
        };
        k.isLastPage = function(a) {
            return this.isLastPageOfReaderDocument(a) && a.getReaderDocument() === Ca(this.h);
        };
        k.isLastPageOfReaderDocument = function(a) {
            var b = Fi(this, a);
            if (!b) return !1;
            var c = a.getSectionIndex(), d = c === b.ha.length - 1;
            b = b.ha[c];
            return b.Ya && d && a.getPageIndexInSection() === b.T.length - 1;
        };
        k.isReaderDocumentLoaded = function(a) {
            return !!Gi(this, a);
        };
        k.loadFirstPage = function() {
            if (this.A) return Hi();
            var a = Ii(this, 0);
            if (a) return Promise.reject(a);
            a = Ji(this, 0);
            return Ki(this, a, 0, 0);
        };
        k.loadFirstPageInReaderDocument = function(a) {
            if (this.A) return Hi();
            a = this.h.indexOf(a);
            var b = Ii(this, a);
            if (b) return Promise.reject(b);
            a = Ji(this, a);
            return Ki(this, a, 0, 0);
        };
        k.loadNextPage = function(a) {
            if (this.A) return Hi();
            var b = Fi(this, a);
            if (!b) return Promise.reject(new D("RENDERABLE_DOCUMENT_PAGE_NOT_LOADED"));
            if (this.isLastPage(a)) return Promise.reject(new D("RENDERABLE_DOCUMENT_PAGE_NOT_FOUND", "Cannot call loadNextPage() from last page"));
            var c = a.getPageIndexInSection() + 1;
            a = a.getSectionIndex();
            var d = b.ha[a];
            d.Ya && c >= d.T.length ? a === b.ha.length - 1 ? (b = Ji(this, b.Pb + 1), b = Ki(this, b, 0, 0)) : b = Ki(this, b, a + 1, 0) : b = Ki(this, b, a, c);
            return b;
        };
        k.loadPageByContentLocation = function(a) {
            var b = this, c, d, e, f, g, h, l, r, q, v, u;
            return m.ea(function(w) {
                switch(w.g){
                    case 1:
                        return b.A ? w.return(Hi()) : n(w, zi(a), 2);
                    case 2:
                        c = w.h;
                        d = c.getReaderDocuments()[0];
                        e = b.h.indexOf(d);
                        if (f = Ii(b, e)) return w.return(Promise.reject(f));
                        g = Ji(b, e);
                        g.ub++;
                        ca(w, 3);
                        return n(w, g.Qb, 5);
                    case 5:
                        if (g.A) throw new D(p.ColibrioErrorType.ABORTED);
                        h = g.ha.findIndex(function(E) {
                            return Ai(c, E.kc.rangeContentLocation);
                        });
                        l = -1 !== h ? h : g.ha.length - 1;
                        r = g.ha[l];
                        if (!r) throw new Cd("No sections at all in the document");
                        null === r.bb && (q = b.createPageIterator(g, r.kc, l), r.bb = q.then(function(E) {
                            return r.Ob = E;
                        }));
                        return n(w, r.bb, 6);
                    case 6:
                        v = w.h;
                        if (g.A) throw new D(p.ColibrioErrorType.ABORTED);
                        return w.return(Li(r, c, v));
                    case 3:
                        return u = da(w), g.ub--, w.return(Promise.reject(u));
                }
            });
        };
        k.loadPageByReaderDocumentPageIndex = function(a, b) {
            var c = this, d, e, f;
            return m.ea(function(g) {
                if (1 == g.g) {
                    if (c.A) return g.return(Hi());
                    d = c.h.indexOf(a);
                    if (e = Ii(c, d)) return g.return(Promise.reject(e));
                    f = Ji(c, d);
                    return n(g, f.Qb, 2);
                }
                return 1 === f.ha.length ? g.return(Ki(c, f, 0, b)) : g.return(Promise.reject(new D("INTERNAL_PAGE_STREAM_ERROR")));
            });
        };
        k.loadPreviousPage = function(a) {
            if (this.A) return Hi();
            var b = Fi(this, a);
            if (!b) return Promise.reject(new D("RENDERABLE_DOCUMENT_PAGE_NOT_LOADED"));
            if (this.isFirstPage(a)) return Promise.reject(new D("RENDERABLE_DOCUMENT_PAGE_NOT_FOUND", "Cannot call loadPreviousPage() from first page"));
            var c = a.getPageIndexInSection() - 1, d = a.getSectionIndex();
            0 <= c ? a = Ki(this, b, d, c) : 0 < a.getSectionIndex() ? a = Ki(this, b, d - 1, Number.MAX_SAFE_INTEGER) : (a = Ji(this, b.Pb - 1), a = Ki(this, a, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER));
            return a;
        };
        k.unloadPage = function(a) {
            var b = Fi(this, a);
            if (b) {
                var c = b.ha[a.getSectionIndex()].T.find(function(d) {
                    return d.ba === a;
                });
                c && 0 < c.La && (c.La--, b.ub--, 0 === c.La && a.getState() !== x.RenderableState.CREATED && a.remove(), Mi(this));
            }
        };
        function Ni(a, b) {
            var c, d, e, f, g;
            return m.ea(function(h) {
                switch(h.g){
                    case 1:
                        if (a.A) throw b.destroy(), new D(p.ColibrioErrorType.ABORTED);
                        c = 0;
                        d = new p.AsyncTaskQueue(1, function(l) {
                            if (a.A) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
                            try {
                                for(var r = Date.now(); l.hasNext() && Date.now() < r + 50;)l.skipNext(), c++;
                            } catch (q) {
                                return Promise.reject(q);
                            }
                            return Promise.resolve();
                        });
                        wi(a) && d.pause();
                        a.j.push(d);
                        e = b.hasNext();
                    case 2:
                        if (!e) {
                            h.J(4);
                            break;
                        }
                        ca(h, 5);
                        return n(h, new Promise(function(l, r) {
                            window.setTimeout(function() {
                                d.scheduleDefaultTask(b, 0).then(l).catch(r);
                            }, 16);
                        }), 7);
                    case 7:
                        e = b.hasNext();
                        h.g = 2;
                        h.j = 0;
                        break;
                    case 5:
                        f = da(h);
                        p.ColibrioError.isColibrioAbortedError(f) || p.Logger.logError(f);
                        e = !1;
                        h.J(2);
                        break;
                    case 4:
                        return b.destroy(), d.destroy(new D(p.ColibrioErrorType.ABORTED)), g = a.j.indexOf(d), -1 !== g && a.j.splice(g, 1), h.return(c);
                }
            });
        }
        function Di(a, b) {
            if (!a.u) throw new D("INTERNAL_PAGE_STREAM_ERROR", "RendererRuntime required before loading pages.");
            return new qi(a, a.g.getReaderView(), a.g.getOptions(), a.ca, a.u, a.Ka, b, a.B, a.C);
        }
        function Oi(a, b, c) {
            var d = Di(a, b), e = {
                G: d,
                A: !1,
                ha: [],
                $: b,
                Pb: c,
                Qb: b.createRenderableDocument(d).then(function(f) {
                    e.ha = f.sections.map(yi);
                    return f;
                }).catch(function(f) {
                    p.ColibrioError.isColibrioAbortedError(f) || p.Logger.logError(f);
                    f = new oi(b, a.v, d);
                    e.ha = f.sections.map(yi);
                    return Promise.resolve(f);
                }),
                ub: 0
            };
            return e;
        }
        function Pi(a, b, c, d, e) {
            a.s ? (a = new li(a.F, d, 0, t.PageSpreadSlot.AUTO, b.getContentLocation(), b, e), a = Promise.resolve(a)) : a = c.createRenderablePage();
            return a.then(function(f) {
                return new hi([
                    f
                ]);
            });
        }
        k.createPageIterator = function(a, b, c) {
            var d = a.$, e = Di(this, d), f = -1 !== this.ca.getSupportedFlowModes().indexOf(t.ContentDocumentFlowMode.PAGINATED) && (this.s ? !1 : d.isReflowable());
            b = Qi(this, f, b, d, c, e);
            return this.D.Cd(b, d, c, this.h, this.l, e).then(function(g) {
                if (a.A) throw g.destroy(), new D(p.ColibrioErrorType.ABORTED);
                return g;
            });
        };
        function Ii(a, b) {
            return 0 > b || b >= a.h.length ? new D("INTERNAL_PAGE_STREAM_ERROR", "Reader document not part of renderable stream") : null;
        }
        function xi(a, b) {
            var c;
            return m.ea(function(d) {
                if (1 == d.g) return a.A ? d.return(Promise.reject(new D(p.ColibrioErrorType.ABORTED))) : n(d, b.$.createRenderableDocument(b.G).then(function(e) {
                    return e.sections.map(function(f) {
                        return f.createPageIterator().then(function(g) {
                            return Ni(a, g);
                        });
                    });
                }), 2);
                c = d.h;
                return d.return(Promise.all(c).then(function(e) {
                    return e.reduce(function(f, g) {
                        return f + g;
                    }, 0);
                }));
            });
        }
        function Li(a, b, c) {
            var d = a.T.find(function(f) {
                return Ai(b, f.ba.getRangeContentLocation());
            });
            if (d) return d.La++, d.ba;
            for(; c.hasNext();){
                d = c.next();
                var e = {
                    ba: d,
                    La: 0
                };
                a.T.push(e);
                a.Ya = !c.hasNext();
                if (Ai(b, d.getRangeContentLocation())) return e.La++, d;
            }
            if (a = Ca(a.T)) return a.La++, a.ba;
            throw new D("INTERNAL_PAGE_STREAM_ERROR");
        }
        function Qi(a, b, c, d, e, f) {
            return (b ? c.createPageIterator() : Pi(a, d, c, e, f)).catch(function(g) {
                var h = a.v;
                if (p.ColibrioError.isColibrioAbortedError(g)) throw g;
                p.Logger.logError(g);
                g = new li(h, e, 0, t.PageSpreadSlot.AUTO, d.getContentLocation(), d, f);
                return new pi([
                    g
                ]);
            });
        }
        function Fi(a, b) {
            var c = b.getReaderDocument();
            a = Gi(a, c);
            if (!a || b.getState() === x.RenderableState.DESTROYED) return null;
            c = b.getPageIndexInSection();
            return (b = a.ha[b.getSectionIndex()]) && b.T[c] ? a : null;
        }
        function Gi(a, b) {
            return a.l.find(function(c) {
                return c.$ === b;
            }) || null;
        }
        function Ji(a, b) {
            var c = a.h[b], d = Gi(a, c);
            if (d) return d;
            b = Oi(a, c, b);
            a.l.push(b);
            Mi(a);
            if (b.A) throw new Cd("NUM_LOADED_DOCUMENTS_TO_KEEP cannot be 0");
            return b;
        }
        function Ki(a, b, c, d) {
            var e, f, g, h, l, r, q, v, u, w, E;
            return m.ea(function(z) {
                switch(z.g){
                    case 1:
                        return b.ub++, ca(z, 2), n(z, b.Qb, 4);
                    case 4:
                        if (b.A) return z.return(Promise.reject(new D(p.ColibrioErrorType.ABORTED)));
                        f = c < b.ha.length ? c : b.ha.length - 1;
                        g = b.ha[f];
                        if (Ja(g)) return z.return(Promise.reject(new D("INTERNAL_PAGE_STREAM_ERROR")));
                        h = g.T;
                        if (g.Ya || d < g.T.length) {
                            l = h[d] || Ca(h);
                            l.La++;
                            e = Promise.resolve(l.ba);
                            z.J(5);
                            break;
                        }
                        null === g.bb && (r = a.createPageIterator(b, g.kc, f), g.bb = r.then(function(N) {
                            return g.Ob = N;
                        }));
                        return n(z, g.bb, 6);
                    case 6:
                        q = z.h;
                        if (b.A) return z.return(Promise.reject(new D(p.ColibrioErrorType.ABORTED)));
                        if (!g.Ya) {
                            for(; q.hasNext() && d >= g.T.length;)v = q.next(), u = {
                                ba: v,
                                La: 0
                            }, g.T.push(u);
                            g.Ya = !q.hasNext();
                        }
                        w = h[d] || Ca(h);
                        w.La++;
                        e = Promise.resolve(w.ba);
                    case 5:
                        z.g = 3;
                        z.j = 0;
                        break;
                    case 2:
                        return E = da(z), b.ub--, z.return(Promise.reject(E));
                    case 3:
                        return z.return(e);
                }
            });
        }
        function Mi(a) {
            for(var b = 0; b < a.l.length - 2; b++){
                var c = a.l[b];
                0 === c.ub && (Ci(a, c), b--);
            }
        }
        function wi(a) {
            return a.g.isVisibleContentRendering() || a.g.isOffscreenContentRendering() || a.g.Vb();
        }
        function Ci(a, b) {
            var c = a.l.indexOf(b);
            if (-1 !== c) {
                a.l.splice(c, 1);
                b.A = !0;
                b.G.cancel();
                b.Qb.then(function(e) {
                    return e.destroy();
                }).catch(function(e) {
                    e && "ABORTED" !== e.errorType && console.error(e);
                });
                a = b.ha.flatMap(function(e) {
                    return e.T;
                });
                for(c = 0; c < a.length; c++){
                    var d = a[c];
                    d.ba && d.ba.destroy();
                }
                b.ha.forEach(function(e) {
                    e.Ob = null;
                    e.bb && e.bb.then(function(f) {
                        f.destroy();
                    }).catch(function(f) {
                        p.ColibrioError.isColibrioAbortedError(f) || p.Logger.logError(f);
                    });
                });
            }
        }
        function Hi() {
            return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
        }
        function Ri(a, b, c, d, e) {
            this.g = a;
            this.$ = b;
            this.l = c;
            this.s = d;
            this.o = e;
            this.i = this.h = null;
            this.j = 0;
        }
        k = Ri.prototype;
        k.destroy = function() {
            this.h && (this.h.destroy(), this.h = null);
            this.i = null;
            this.g.destroy();
        };
        k.getEstimatedNumberOfPages = function() {
            return this.g.getEstimatedNumberOfPages();
        };
        k.hasNext = function() {
            return null === this.h && (0 === this.j || this.g.hasNext());
        };
        k.next = function() {
            var a = null;
            if (this.hasNext()) {
                try {
                    (a = this.g.next()) ? (a.setSpreadSlot(t.PageSpreadSlot.AUTO), this.i = a) : p.Logger.logError(new D("READER_DOCUMENT_LOAD_ERROR", "RenderableDocumentPageIterator returned null for document: " + this.$.getSourceContentDocument().getContentUrl().toString()));
                } catch (b) {
                    p.Logger.logError(b);
                }
                a || (a = this.h = new li(this.l, this.s, this.j, t.PageSpreadSlot.AUTO, this.i ? this.i.getRangeContentLocation().collapseToEnd() : this.$.getContentLocation(), this.$, this.o));
                this.j++;
            }
            return a;
        };
        k.skipNext = function() {
            if (!this.hasNext()) return !1;
            this.j++;
            return this.g.skipNext();
        };
        function Si(a) {
            this.g = a;
        }
        Si.prototype.Cd = function(a, b, c, d, e, f) {
            var g = this;
            return a.then(function(h) {
                return new Ri(h, b, g.g, c, f);
            });
        };
        function Ti(a, b) {
            var c = null;
            switch(a){
                case t.PageSpreadSlot.LEFT:
                    c = t.PageSpreadSlot.RIGHT;
                    break;
                case t.PageSpreadSlot.RIGHT:
                    c = t.PageSpreadSlot.LEFT;
                    break;
                case t.PageSpreadSlot.CENTER:
                    c = b === x.ReaderViewPageProgressionDirection.LTR ? t.PageSpreadSlot.RIGHT : t.PageSpreadSlot.LEFT;
            }
            return c;
        }
        function Ui(a, b, c, d, e, f, g, h, l) {
            this.i = a;
            this.$ = b;
            this.v = c;
            this.B = d;
            this.C = e;
            this.g = f;
            this.j = g;
            this.qa = h;
            this.u = l;
            this.h = this.s = this.l = null;
            this.o = 0;
        }
        k = Ui.prototype;
        k.destroy = function() {
            this.h = null;
            this.s && (this.s.destroy(), this.s = null);
            this.l && (this.l.destroy(), this.l = null);
            this.i.destroy();
        };
        k.getEstimatedNumberOfPages = function() {
            return this.i.getEstimatedNumberOfPages();
        };
        k.hasNext = function() {
            return 0 === this.o || this.i.hasNext() || this.g === this.j && !this.l && !!this.j;
        };
        k.next = function() {
            var a = null;
            if (0 === this.o || this.i.hasNext()) {
                try {
                    (a = this.i.next()) ? a.setSpreadSlot(this.g) : p.Logger.logError(new D("READER_DOCUMENT_LOAD_ERROR", "RenderableDocumentPageIterator returned null for document: " + this.$.getSourceContentDocument().getContentUrl().toString()));
                } catch (b) {
                    p.Logger.logError(b);
                }
                a || (a = this.h ? this.h.getRangeContentLocation().collapseToEnd() : this.$.getContentLocation(), a = this.s = new li(this.B, this.v, this.o, this.g, a, this.$, this.u));
                this.h = a;
            } else this.h && this.j && this.g === this.j && (a = this.h.getPageFragmentationContext(), a = null === a ? null : new Vi(a.getDocumentWidth(), a.getDocumentHeight(), a.getEndOffset(), a.getPageFlowDirection()), a = this.l = new li(this.C, this.v, this.o, this.j, this.h.getRangeContentLocation().collapseToEnd(), this.h.getReaderDocument(), this.u, a));
            this.g === t.PageSpreadSlot.LEFT ? this.g = t.PageSpreadSlot.RIGHT : this.g === t.PageSpreadSlot.RIGHT ? this.g = t.PageSpreadSlot.LEFT : this.g === t.PageSpreadSlot.CENTER && this.j && !this.i.hasNext() && (this.g = this.qa === x.ReaderViewPageProgressionDirection.LTR ? t.PageSpreadSlot.LEFT : t.PageSpreadSlot.RIGHT);
            this.o++;
            return a;
        };
        k.skipNext = function() {
            var a = this.next();
            a && a.destroy();
            return null !== a;
        };
        function Vi(a, b, c, d) {
            this.i = a;
            this.h = b;
            this.g = c;
            this.j = d;
        }
        k = Vi.prototype;
        k.getDocumentHeight = function() {
            return this.h;
        };
        k.getDocumentWidth = function() {
            return this.i;
        };
        k.getEndOffset = function() {
            return this.g;
        };
        k.getPageFlowDirection = function() {
            return this.j;
        };
        k.getStartOffset = function() {
            return this.g;
        };
        function Wi(a, b, c) {
            this.j = a;
            this.g = b;
            this.l = c;
            this.h = 0;
            this.i = this.l;
        }
        k = Wi.prototype;
        k.destroy = function() {
            this.j.destroy();
            this.g = [];
        };
        k.getEstimatedNumberOfPages = function() {
            return this.g.length;
        };
        k.hasNext = function() {
            return this.h < this.g.length;
        };
        k.next = function() {
            if (!this.hasNext()) return null;
            var a = this.g[this.h++];
            a.setSpreadSlot(this.i);
            Xi(this);
            return a;
        };
        k.skipNext = function() {
            if (!this.hasNext()) return !1;
            this.h++;
            Xi(this);
            return !0;
        };
        function Xi(a) {
            a.i = a.i === t.PageSpreadSlot.LEFT ? t.PageSpreadSlot.RIGHT : t.PageSpreadSlot.LEFT;
        }
        function Yi(a, b, c, d, e) {
            this.g = a;
            this.i = b;
            this.j = c;
            this.qa = d;
            this.h = [];
            a = [];
            b = e.getReaderDocuments();
            var f = b[0].getSourceContentDocument(), g = f, h = g.getPageSpreadSlot();
            if (h === t.PageSpreadSlot.AUTO || !c && h === t.PageSpreadSlot.CENTER) {
                var l = g.getPublication().getSpine(), r = l.indexOf(g);
                var q = e.getPageProgressionDirection() === x.ReaderViewPageProgressionDirection.LTR;
                if (0 === r) e = e.getOptions().defaultStartPageSpreadSlot, h = e !== t.PageSpreadSlot.AUTO ? e : q ? t.PageSpreadSlot.RIGHT : t.PageSpreadSlot.LEFT;
                else {
                    for(var v = !0, u = 0; 0 < r && v;){
                        r--;
                        u++;
                        g = l[r];
                        var w = g.getPageSpreadSlot();
                        0 === r && (w = e.getOptions().defaultStartPageSpreadSlot, w = w !== t.PageSpreadSlot.AUTO ? w : q ? t.PageSpreadSlot.RIGHT : t.PageSpreadSlot.LEFT);
                        if (g.getLayout() === t.ContentDocumentLayout.REFLOWABLE) v = !1, h = q ? t.PageSpreadSlot.LEFT : t.PageSpreadSlot.RIGHT;
                        else if (w !== t.PageSpreadSlot.AUTO && (c || w !== t.PageSpreadSlot.CENTER)) switch(v = !1, g = 0 === u % 2, w){
                            case t.PageSpreadSlot.CENTER:
                                h = q ? g ? t.PageSpreadSlot.RIGHT : t.PageSpreadSlot.LEFT : g ? t.PageSpreadSlot.LEFT : t.PageSpreadSlot.RIGHT;
                                break;
                            case t.PageSpreadSlot.LEFT:
                                h = g ? t.PageSpreadSlot.LEFT : t.PageSpreadSlot.RIGHT;
                                break;
                            case t.PageSpreadSlot.RIGHT:
                                h = g ? t.PageSpreadSlot.RIGHT : t.PageSpreadSlot.LEFT;
                        }
                    }
                    h === t.PageSpreadSlot.AUTO && (h = q ? t.PageSpreadSlot.LEFT : t.PageSpreadSlot.RIGHT);
                }
            }
            q = h;
            e = f.getLayout();
            a.push({
                $: b[0],
                wa: [
                    q
                ]
            });
            f = q;
            for(q = 1; q < b.length; q++){
                h = b[q];
                r = h.getSourceContentDocument();
                l = r.getPageSpreadSlot();
                r = r.getLayout();
                if ((l === t.PageSpreadSlot.AUTO || !c && l === t.PageSpreadSlot.CENTER) && e === t.ContentDocumentLayout.PRE_PAGINATED) switch(f){
                    case t.PageSpreadSlot.LEFT:
                        l = t.PageSpreadSlot.RIGHT;
                        break;
                    case t.PageSpreadSlot.RIGHT:
                        l = t.PageSpreadSlot.LEFT;
                        break;
                    case t.PageSpreadSlot.CENTER:
                        l = d === x.ReaderViewPageProgressionDirection.LTR ? t.PageSpreadSlot.LEFT : t.PageSpreadSlot.RIGHT;
                }
                f = l;
                e = r;
                a.push({
                    $: h,
                    wa: [
                        l
                    ]
                });
            }
            this.h = a;
        }
        Yi.prototype.Cd = function(a, b, c, d, e, f) {
            var g = this;
            return a.then(function(h) {
                var l = g.h.findIndex(function(w) {
                    return w.$ === b;
                }), r = g.h[l], q = Zi(b, e);
                q && r.wa.length < q.ha.length && (q = Array.from({
                    length: q.ha.length - 1
                }, function() {
                    return r.wa[0] === t.PageSpreadSlot.CENTER ? t.PageSpreadSlot.CENTER : t.PageSpreadSlot.AUTO;
                }), r.wa.push.apply(r.wa, m.Ua(q)));
                var v = $i(g, c, r, l), u = !aj(r.wa[c], g.j);
                q = v ? Ti(v, g.qa) : null;
                l = bj(g, c, r, l);
                l = !Ja(l) && !aj(l, g.j);
                v = !Ja(v) && !aj(v, g.j);
                l || u || v ? !l || u || v ? l || u || !v ? l && !u && v ? (u = cj(g, c, b, dj(b, d), e), Ja(u) ? (q = ej(g, h, b, c, q, f), r.wa[c] = q.Yb, h = new Wi(h, q.Ad, q.Yb)) : (r.wa[c] = u, h = new Ui(h, b, c, g.g, g.i, u, q, g.qa, f))) : h = new Ui(h, b, c, g.g, g.i, r.wa[c], q, g.qa, f) : (q = ej(g, h, b, c, q, f), r.wa[c] = q.Yb, h = new Wi(h, q.Ad, q.Yb)) : (u = cj(g, c, b, dj(b, d), e), Ja(u) && (u = fj(g)), r.wa[c] = u, h = new Ui(h, b, c, g.g, g.i, u, q, g.qa, f)) : (u = fj(g), r.wa[c] = u, h = new Ui(h, b, c, g.g, g.i, u, q, g.qa, f));
                return h;
            });
        };
        function gj(a, b, c, d, e, f, g) {
            p.Logger.logError(new D("READER_DOCUMENT_LOAD_ERROR", f));
            c = c ? c.getRangeContentLocation().collapseToEnd() : b.getContentLocation();
            return new li(a.g, d, e.length, t.PageSpreadSlot.AUTO, c, b, g);
        }
        function fj(a) {
            return a.qa === x.ReaderViewPageProgressionDirection.LTR ? t.PageSpreadSlot.LEFT : t.PageSpreadSlot.RIGHT;
        }
        function ej(a, b, c, d, e, f) {
            var g = [], h = !1, l = null;
            try {
                for(; !h && b.hasNext();){
                    var r = b.next();
                    if (r) l = r;
                    else {
                        var q = "RenderableDocumentPageIterator returned null for document: " + c.getSourceContentDocument().getContentUrl().toString();
                        r = gj(a, c, l, d, g, q, f);
                        h = !0;
                    }
                    g.push(r);
                }
            } catch (v) {
                if (p.ColibrioError.isColibrioAbortedError(v)) throw v;
                p.Logger.logError(v);
                b = "RenderableDocumentPageIterator error for document: " + c.getSourceContentDocument().getContentUrl().toString();
                c = gj(a, c, l, d, g, b, f);
                g.push(c);
            }
            a = null !== e ? e : a.qa === x.ReaderViewPageProgressionDirection.LTR ? t.PageSpreadSlot.RIGHT : t.PageSpreadSlot.LEFT;
            return {
                Ad: g,
                Yb: 0 === g.length % 2 ? a === t.PageSpreadSlot.LEFT ? t.PageSpreadSlot.RIGHT : t.PageSpreadSlot.LEFT : a
            };
        }
        function Zi(a, b) {
            return b.find(function(c) {
                return c.$ === a;
            }) || null;
        }
        function hj(a, b) {
            var c;
            if ((c = b) && !(c = b.Ya)) {
                if (c = b.Ob) {
                    for(; c.hasNext();){
                        var d = {
                            ba: c.next(),
                            La: 0
                        };
                        b.T.push(d);
                    }
                    b.Ya = !c.hasNext();
                }
                c = b.Ya;
            }
            if (c) switch(Ca(b.T).ba.getSpreadSlot()){
                case t.PageSpreadSlot.LEFT:
                    return t.PageSpreadSlot.RIGHT;
                case t.PageSpreadSlot.RIGHT:
                    return t.PageSpreadSlot.LEFT;
                case t.PageSpreadSlot.CENTER:
                    return fj(a);
            }
        }
        function $i(a, b, c, d) {
            if (b !== c.wa.length - 1) return c.wa[b + 1];
            if (a = a.h[d + 1]) return a.wa[0];
        }
        function cj(a, b, c, d, e) {
            if (0 === b) {
                if (d && (b = Zi(d, e))) return hj(a, Ca(b.ha));
            } else if (c = Zi(c, e)) return hj(a, c.ha[b - 1]);
        }
        function bj(a, b, c, d) {
            if (0 !== b) return c.wa[b - 1];
            if (a = a.h[d - 1]) return a.wa[0];
        }
        function dj(a, b) {
            a = b.indexOf(a);
            return 0 < a ? b[a - 1] : null;
        }
        function aj(a, b) {
            return a === t.PageSpreadSlot.AUTO || !b && a === t.PageSpreadSlot.CENTER;
        }
        function ij(a, b) {
            var c = new Set;
            jj(a, b, kj, c);
            return c;
        }
        function lj(a, b) {
            Object.values(b).forEach(function(c) {
                Oa(c) ? lj(a, c) : a.add(c);
            });
        }
        function mj(a, b, c, d) {
            if (a.length !== b.length) d.add(c);
            else for(var e = 0; e < a.length; e++){
                var f = a[e], g = b[e];
                f !== g && (Oa(f) && Oa(g) ? jj(f, g, c, d) : Pa(f) && Pa(g) ? mj(f, g, c, d) : d.add(c));
            }
        }
        function jj(a, b, c, d) {
            for(var e = Object.keys(a), f = 0; f < e.length; f++){
                var g = e[f], h = a[g], l = b[g];
                g = Oa(c) ? c[g] : c;
                h !== l && (Oa(h) && Oa(l) ? jj(h, l, g, d) : Pa(h) && Pa(l) ? mj(h, l, g, d) : Oa(g) ? lj(d, g) : d.add(g));
            }
        }
        var kj = {
            constrainEngineEventsToReaderView: 0,
            contentDisplayAreaOptions: {
                aspectRatio: 1,
                fallbackAspectRatio: 1,
                type: 1
            },
            defaultPageProgressionDirection: 1,
            defaultStartPageSpreadSlot: 1,
            emitPointerMoveEventsOnHover: 0,
            forcePageProgressionDirection: 1,
            gestureOptions: {
                panZoom: {
                    allowSinglePointerPan: 0,
                    pinchZoomThresholdPx: 0,
                    pointerTypes: {
                        mouse: 0,
                        pen: 0,
                        touch: 0
                    },
                    removeTransformOnZoomOutGesture: 0
                },
                swipeNavigation: {
                    pointerDragThresholdPx: 0,
                    pointerTypes: {
                        mouse: 0,
                        pen: 0,
                        touch: 0
                    }
                }
            },
            name: 0,
            pageContainerOptions: {
                titleOptions: {
                    scroll: 0,
                    singlePage: 0,
                    spreadCenter: 0,
                    spreadLeft: 0,
                    spreadRight: 0
                }
            },
            pageProgressionTimelineOptions: {
                delayRecalculationUntilPagesVisible: 2,
                enabled: 2,
                forceCompleteRendition: 2
            },
            publicationStyleOptions: {
                defaultFontFamily: 1,
                disableCssAnimations: 0,
                fontSet: {
                    defaults: {
                        cursive: 1,
                        fallback: 1,
                        fantasy: 1,
                        monospace: 1,
                        sansSerif: 1,
                        serif: 1
                    },
                    fontFaces: 1,
                    selectors: 1
                },
                fontSizeScaleFactor: 1,
                letterSpacing: {
                    unit: 1,
                    value: 1
                },
                lineHeightScaleFactor: 1,
                pageMargins: {
                    bottom: {
                        unit: 1,
                        value: 1
                    },
                    left: {
                        unit: 1,
                        value: 1
                    },
                    right: {
                        unit: 1,
                        value: 1
                    },
                    top: {
                        unit: 1,
                        value: 1
                    }
                },
                palette: {
                    accent: 0,
                    backgroundDark: 0,
                    backgroundLight: 0,
                    foregroundDark: 0,
                    foregroundLight: 0
                },
                removePublicationDefinedHorizontalPageMargins: 1,
                textAlignment: {
                    defaultAlignment: 1,
                    preserved: 1
                },
                typographyResetOptions: {
                    removePublicationDefinedFontSizes: 1,
                    removePublicationDefinedLineHeights: 1
                },
                wordSpacing: {
                    unit: 1,
                    value: 1
                }
            },
            refreshDelayMs: 0,
            rendererTransitionAnimationDurationMs: 0,
            rendererTransitionTimeoutMs: 0,
            transformManagerOptions: {
                maxPanOffsetHorizontal: {
                    unit: 0,
                    value: 0
                },
                maxPanOffsetVertical: {
                    unit: 0,
                    value: 0
                },
                maxScaleFactor: 0,
                removeTransformAnimationDurationMs: 0,
                removeTransformOnNavigation: 0
            }
        };
        function nj() {
            this.i = null;
            this.j = new $a(!0);
            this.g = !1;
            this.h = null;
            this.l = new $a(!0);
        }
        function Qf(a, b) {
            a.g || a.j.add(b);
        }
        function oj(a, b) {
            a.g || a.l.add(b);
        }
        nj.prototype.destroy = function() {
            this.g = !0;
            this.h = this.i = null;
            this.l.clear();
            this.j.clear();
        };
        nj.prototype.getVisibleRange = function() {
            return this.h;
        };
        nj.prototype.notifyContentRangesChanged = function(a, b, c) {
            this.i = a;
            this.notifyVisibleRangeChanged(a.visible, b, c);
            ab(this.j, this.i, function(d) {
                p.ColibrioError.isColibrioAbortedError(d) || p.Logger.logError(d);
            });
        };
        nj.prototype.notifyVisibleRangeChanged = function(a, b, c) {
            this.g || (this.h = a, ab(this.l, {
                fe: c || null,
                visiblePages: b,
                visibleRange: a
            }, function(d) {
                p.ColibrioError.isColibrioAbortedError(d) || p.Logger.logError(d);
            }));
        };
        function pj(a, b) {
            var c = this;
            this.h = a;
            this.options = b;
            this.j = this.i = null;
            this.o = !1;
            this.g = function() {
                var d, e, f, g, h;
                return m.ea(function(l) {
                    if (1 == l.g) {
                        if (c.o || c.h.isVisibleContentRendering() || c.h.isNavigating()) return l.J(0);
                        d = c.h.getReadingPosition();
                        e = c.h.getVisiblePages();
                        if (!d || !e) return l.J(0);
                        f = e.find(function(r) {
                            return r.getRangeContentLocation().contains(d);
                        });
                        if (!f || !f.isRenderingCompleted() || f.getState() !== x.RenderableState.VISIBLE) return l.J(0);
                        c.o = !0;
                        g = y(c.options, {
                            focusNearContentLocation: !1,
                            focusOnPageBodyElement: !1,
                            focusOnPageContainer: !1,
                            focusTargetOptions: {
                                target: x.FocusOnReadingPositionTarget.NONE
                            }
                        });
                        ca(l, 5);
                        return n(l, f.focusOnContentLocation(d, g), 7);
                    }
                    5 != l.g ? (qj(c, !0, null), l.g = 0, l.j = 0) : (h = da(l), qj(c, !1, h), l.g = 0);
                });
            };
            this.l = new Promise(function(d, e) {
                c.j = d;
                c.i = e;
            });
            T(a, "visibleContentRendered", this.g);
            T(a, "visiblePagesChanged", this.g);
            T(a, "navigationEnded", this.g);
            T(a, "readingPositionChanged", this.g);
            T(a, "activeNavigationTaskChanged", this.g);
            this.g().catch(function(d) {
                return p.Logger.logError(d);
            });
        }
        pj.prototype.isDestroyed = function() {
            return null === this.j;
        };
        pj.prototype.destroy = function() {
            this.i && (this.i(new D(p.ColibrioErrorType.ABORTED)), rj(this));
        };
        function rj(a) {
            a.i = null;
            a.j = null;
            R(a.h, "visibleContentRendered", a.g);
            R(a.h, "visiblePagesChanged", a.g);
            R(a.h, "navigationEnded", a.g);
            R(a.h, "readingPositionChanged", a.g);
            R(a.h, "activeNavigationTaskChanged", a.g);
        }
        function qj(a, b, c) {
            a.j && a.i && (b ? a.j() : a.i(c), rj(a));
        }
        function sj(a, b) {
            Z.call(this, a);
            this.ba = b;
        }
        m.inherits(sj, Z);
        m.global.Object.defineProperties(sj.prototype, {
            g: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.ba;
                }
            }
        });
        function tj(a, b) {
            G.call(this, a, b);
        }
        m.inherits(tj, X);
        m.global.Object.defineProperties(tj.prototype, {
            readerDocument: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerDocument;
                }
            }
        });
        function uj(a) {
            this.T = new Map;
            this.Sa = new Map;
            this.g = a;
        }
        uj.prototype.destroy = function() {
            this.T.clear();
            this.Sa.clear();
            this.g = null;
        };
        uj.prototype.hb = function() {
            return Array.from(this.T.keys());
        };
        function vj(a, b) {
            if (a.g) {
                var c = a.T.get(b);
                if (C(c)) {
                    if (1 === c) {
                        a.T.delete(b);
                        V(a.g, new sj("renderablePageUnloaded", b));
                        c = a.g;
                        b = b.getReaderDocument();
                        var d = a.Sa.get(b);
                        C(d) && (1 === d ? (a.Sa.delete(b), a = new tj("readerDocumentUnloaded", {
                            readerDocument: b,
                            readerView: c.getReaderView()
                        }), V(c, a)) : a.Sa.set(b, d - 1));
                    } else a.T.set(b, c - 1);
                }
            }
        }
        uj.prototype.isReaderDocumentLoaded = function(a) {
            return this.Sa.has(a);
        };
        function wj(a, b, c, d, e, f, g, h, l, r) {
            var q = this;
            this.W = a;
            this.l = b;
            this.O = c;
            this.ic = d;
            this.ma = e;
            this.ra = f;
            this.H = g;
            this.eb = h;
            this.v = l;
            this.Ba = r;
            this.C = null;
            this.o = 0;
            this.g = null;
            this.D = !1;
            this.S = null;
            this.j = 0;
            this.u = null;
            this.h = !1;
            this.B = this.i = null;
            this.F = !1;
            this.Ia = function() {
                var v = q.g;
                q.W.Z ? null === q.i || 0 === q.i.length ? (v = new D("READER_DOCUMENTS_EMPTY", "Unable to navigate with no reader documents"), xj(q, v, 2)) : v || q.D || (v = new D("INVALID_RENDERER", "No renderer has been set using ReaderView.addRenderer()"), xj(q, v, 2)) : (v = new D("INVALID_VIEW_OPERATION", "ReaderView.renderTo() has not been called with a valid element"), xj(q, v, 2));
            };
            this.s = new Promise(function(v, u) {
                q.la = v;
                q.L = u;
            });
        }
        wj.prototype.cancel = function() {
            0 === this.j && (yj(this, 2), this.l && !this.l.isCanceled() && (this.l.o.catch(function(a) {
                p.ColibrioError.isColibrioAbortedError(a) || p.Logger.logError(a);
            }), this.l.cancel()), this.L(new D(p.ColibrioErrorType.ABORTED)));
            zj(this);
        };
        wj.prototype.ka = function() {
            return this.g;
        };
        wj.prototype.getContentLocation = function() {
            return this.S;
        };
        function Aj(a, b) {
            a.g = b;
            a.o++;
            Bj(a);
        }
        function Cj(a, b) {
            a.D = b;
            Bj(a);
        }
        function Dj(a, b) {
            a.u = b;
            Bj(a);
        }
        function Ej(a, b, c) {
            0 === b.length ? (b = new D("READER_DOCUMENTS_EMPTY", "You must call setReaderDocuments() with a non-empty array for goTo*() to succeed"), xj(a, b, 3)) : a.i ? a.cancel() : (a.i = b, a.B = c, Bj(a));
        }
        wj.prototype.start = function() {
            this.F || (this.F = !0, Bj(this));
        };
        function xj(a, b, c) {
            0 === a.j && (yj(a, c), a.L(b));
            zj(a);
        }
        function zj(a) {
            null !== a.C && window.clearTimeout(a.C);
        }
        function yj(a, b) {
            zj(a);
            a.j = b;
            a.ra(a);
        }
        function Fj(a, b, c) {
            var d = a.eb;
            if (b && d === x.NavigationAction.GOTO) {
                var e;
                if (null == (e = a.v.visible) ? 0 : e.contains(b)) d = x.NavigationAction.CURRENT;
                else {
                    var f;
                    if (null == (f = a.v.next) ? 0 : f.contains(b)) d = x.NavigationAction.NEXT_CONTENT_RANGE;
                    else {
                        var g;
                        if (null == (g = a.v.previous) ? 0 : g.contains(b)) d = x.NavigationAction.PREVIOUS_CONTENT_RANGE;
                    }
                }
            }
            return d === x.NavigationAction.CURRENT && c.G.Ba || d === x.NavigationAction.NEXT_CONTENT_RANGE && c.G.O || d === x.NavigationAction.PREVIOUS_CONTENT_RANGE && c.G.la || d === x.NavigationAction.NEXT_RENDERABLE_PAGE && c.G.W || d === x.NavigationAction.PREVIOUS_RENDERABLE_PAGE && c.G.ma ? d : x.NavigationAction.GOTO;
        }
        function Bj(a) {
            a.F && !a.h && 0 === a.j && (a.h = !0, zj(a), a.u ? Gj(a, a.u) : !a.S && a.l && a.i && a.B ? Hj(a, a.l, a.i, a.B) : a.S && a.g ? Ij(a, a.S, a.g) : !a.S && a.eb !== x.NavigationAction.GOTO && a.g ? Ij(a, null, a.g) : (zj(a), a.D || (a.C = window.setTimeout(a.Ia, 5E3)), a.h = !1));
        }
        function Ij(a, b, c) {
            a.O || a.cancel();
            var d = Fj(a, b, c), e = a.o;
            a.ma(a, b, d);
            c = c.P;
            var f = null;
            d === x.NavigationAction.GOTO && b ? f = c.navigateTo(b, a.H) : d !== x.NavigationAction.GOTO && (f = c.navigate(d, a.H, a.S || void 0, a.Ba));
            f ? f.then(function() {
                e !== a.o ? (a.h = !1, Bj(a)) : 0 === a.j && (yj(a, 1), a.la(), zj(a));
            }).catch(function(g) {
                e !== a.o ? (a.h = !1, Bj(a)) : p.ColibrioError.isColibrioAbortedError(g) ? a.cancel() : xj(a, g, 5);
            }) : xj(a, new D("UNABLE_TO_PERFORM_NAVIGATION", "Navigation task unable to perform navigation."), 5);
        }
        function Hj(a, b, c, d) {
            b.j(c, d);
            b.o.then(function(e) {
                a.S = e.collapseToStart();
                a.h = !1;
                Bj(a);
            }).catch(function(e) {
                b.isCanceled() || p.ColibrioError.isColibrioAbortedError(e) ? a.cancel() : xj(a, e, 4);
            });
        }
        function Gj(a, b) {
            a.u = null;
            b.then(function() {
                a.h = !1;
                Bj(a);
            }).catch(function(c) {
                p.ColibrioError.isColibrioAbortedError(c) ? a.cancel() : xj(a, c, 6);
            });
        }
        function Jj(a) {
            G.call(this, "selectionChanged", a);
        }
        m.inherits(Jj, X);
        Jj.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this), b = this.m.contentLocation, c, d = null != (c = null == b ? void 0 : b.getReaderDocuments()[0].getIndexInSpine()) ? c : null;
            b = {
                isRange: this.m.isRange,
                locator: b ? b.toJSON() : null,
                objectType: x.EngineEventDataObjectType.SELECTION_CHANGED_ENGINE_EVENT,
                readerDocumentIndexInSpine: d,
                selectionText: this.m.selectionText
            };
            return Object.assign(a, b);
        };
        m.global.Object.defineProperties(Jj.prototype, {
            contentLocation: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.contentLocation;
                }
            },
            isRange: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.isRange;
                }
            },
            selectionText: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.selectionText;
                }
            }
        });
        function Kj(a) {
            var b = this;
            this.i = a;
            this.j = null;
            this.h = new Map;
            this.g = new Map;
            this.l = function(c) {
                Lj(b, "activeTransform", c.transform);
            };
            this.o = function() {
                ti(b, null, null);
            };
            this.g.set("contentDocumentEventHandlersEnabled", !0);
            this.g.set("contentSelectionEnabled", !0);
            this.g.set("clearContentSelection", null);
            this.g.set("activeTransform", Mj(this.i.Ha));
            T(a, "visiblePagesChanged", this.o);
            T(a, "activeTransformChanged", this.l);
        }
        function ti(a, b, c) {
            b ? a.j = b : a.j && (b = new Jj({
                contentLocation: null,
                isRange: !1,
                readerView: a.i.getReaderView(),
                selectionText: null
            }), a.j = null);
            b && V(a.i, b);
            (a = a.h.get("clearContentSelection")) && a.forEach(function(d) {
                if (d.m !== c) d.m.onReaderViewPropertyChanged("clearContentSelection", null);
            });
        }
        function Lj(a, b, c) {
            a.g.set(b, c);
            (a = a.h.get(b)) && a.forEach(function(d) {
                try {
                    d.m.onReaderViewPropertyChanged(b, c);
                } catch (e) {
                    p.Logger.logError(e);
                }
            });
        }
        function Nj(a, b) {
            var c = this;
            this.h = a;
            this.g = null;
            this.i = function() {
                if (c.g && Oj(c)) {
                    var d = c.g;
                    c.cancel();
                    d();
                }
            };
            Oj(this) ? b() : (this.g = b, this.h.forEach(function(d) {
                return d.addStateChangeListener(c.i);
            }));
        }
        Nj.prototype.cancel = function() {
            this.g && (this.g = null, Pj(this));
        };
        function Oj(a) {
            return a.h.every(function(b) {
                return b.isRenderingCompleted();
            });
        }
        function Pj(a) {
            a.h.forEach(function(b) {
                return b.removeStateChangeListener(a.i);
            });
        }
        function Qj(a, b, c) {
            var d = this;
            this.N = b;
            this.j = c;
            this.T = new Map;
            this.v = new Set;
            this.l = new Set;
            this.D = this.h = this.C = null;
            this.o = !1;
            this.F = new Set;
            this.ra = !1;
            this.B = !0;
            this.Wa = this.u = this.Ia = this.ma = this.la = this.W = this.O = this.Ba = !1;
            this.H = this.i = null;
            this.s = !1;
            this.Xa = function() {
                d.h = null;
                if (d.g) {
                    var e = d.N.hb().filter(function(f) {
                        return f.getState() === x.RenderableState.ATTACHED_TO_DOM;
                    });
                    d.D = new Nj(e, function() {
                        var f;
                        null == (f = d.g) || Rj(f, !1);
                    });
                }
            };
            this.ab = function() {
                d.i = null;
                if (d.g) {
                    var e = d.N.hb().filter(function(f) {
                        return f.getState() === x.RenderableState.VISIBLE;
                    });
                    d.H = new Nj(e, function() {
                        var f;
                        null == (f = d.g) || Sj(f, !1);
                        d.B = !1;
                        d.g && d.N.hb().forEach(function(g) {
                            g.isRenderingPaused() && g.setRenderingPaused(!1);
                        });
                    });
                }
            };
            this.sb = function() {
                null !== d.i || d.s || (d.i = window.setTimeout(d.ab, 0));
                null !== d.h || d.o || (d.h = window.setTimeout(d.Xa, 0));
            };
            this.L = function(e) {
                if (d.g) {
                    var f = d.F.has(e);
                    f && e.getState() !== x.RenderableState.VISIBLE ? (d.F.delete(e), !d.B || e.isRenderingCompleted() || e.isRenderingPaused() || e.setRenderingPaused(!0), Tj(d), Uj(d), Vj(d)) : f || e.getState() !== x.RenderableState.VISIBLE || (d.g && d.B && e.isRenderingPaused() && e.setRenderingPaused(!1), d.F.add(e), Tj(d), Uj(d), Vj(d));
                    d.g && e.getState() === x.RenderableState.ATTACHED_TO_DOM && !e.isRenderingCompleted() && (Rj(d.g, !0), Uj(d), Wj(d), Vj(d));
                } else e.removeStateChangeListener(d.L);
            };
            this.g = a;
            this.kb = a.getReaderDocuments().slice();
            this.rb = a.getReaderPublications().slice();
        }
        function Xj(a) {
            null !== a.g && (Yj(a), Zj(a), Uj(a), a.T.forEach(function(b, c) {
                c.setRenderingPaused(!0);
                var d;
                null == (d = a.g) || vj(d.Pa, c);
            }), a.T.clear(), a.g = null);
        }
        k = Qj.prototype;
        k.fetchEstimatedHeightPerReaderDocument = function() {
            return this.N.fetchEstimatedHeightPerReaderDocument();
        };
        k.getConfiguredPageAspectRatio = function() {
            return this.j.Ca;
        };
        k.getContentOnLoading = function() {
            return this.j.Nd;
        };
        k.getPageProgressionDirection = function() {
            return this.j.qa;
        };
        k.getPublicationPreferredAspectRatio = function() {
            return this.j.mb;
        };
        k.getReaderDocuments = function() {
            return this.kb;
        };
        k.getReaderPublications = function() {
            return this.rb;
        };
        k.getReaderViewDimensions = function() {
            return this.j.ob;
        };
        k.getReaderViewElement = function() {
            return this.j.Z;
        };
        k.isFirstPage = function(a) {
            return this.N.isFirstPage(a);
        };
        k.isLastPage = function(a) {
            return this.N.isLastPage(a);
        };
        k.isLastPageOfReaderDocument = function(a) {
            return this.N.isLastPageOfReaderDocument(a);
        };
        k.isRendererRuntimeVisible = function() {
            return this.Ia;
        };
        k.isSwipeNavigationGestureAllowed = function() {
            return this.Wa;
        };
        k.loadFirstPage = function(a) {
            if (!this.g) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            var b = this.N.loadFirstPage();
            return ak(this, b, a);
        };
        k.loadFirstPageInReaderDocument = function(a, b) {
            if (!this.g) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            a = this.N.loadFirstPageInReaderDocument(a);
            return ak(this, a, b);
        };
        k.loadNextPage = function(a, b) {
            if (!this.g) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            a = this.N.loadNextPage(a);
            return ak(this, a, b);
        };
        k.loadPageByContentLocation = function(a, b) {
            if (!this.g) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            a = this.N.loadPageByContentLocation(a);
            return ak(this, a, b);
        };
        k.loadPreviousPage = function(a, b) {
            if (!this.g) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            a = this.N.loadPreviousPage(a);
            return ak(this, a, b);
        };
        k.notifyPageLoadingComplete = function() {
            this.o = !0;
            Zj(this);
            Wj(this);
        };
        k.notifyPossibleNavigationActions = function(a) {
            this.g && (this.la = a.previousContentRange, this.O = a.nextContentRange, this.Ba = a.current, this.W = a.nextRenderablePage, this.ma = a.previousRenderablePage, bk(this.g));
        };
        k.notifyScrollEnded = function(a) {
            var b;
            null == (b = this.g) || ck(b, a);
        };
        k.notifyScrollHeightChanged = function() {
            var a;
            null == (a = this.g) || dk(a, !1);
        };
        k.notifyScrollStarted = function() {
            var a;
            null == (a = this.g) || a.zb || (a.zb = !0, V(a, new X("rendererScrollStarted", {
                readerView: a.R
            })));
        };
        k.notifyTransitionFinished = function() {
            this.u = !1;
            this.s && this.notifyVisiblePagesUpdated();
            this.o && this.notifyPageLoadingComplete();
            Vj(this);
            this.g && ek(this.g, !1);
        };
        k.notifyTransitionStarted = function() {
            this.u = !0;
            Uj(this);
            Zj(this);
            Yj(this);
            this.g && ek(this.g, !0);
        };
        k.notifyVisibilityIntentionForLoadingPage = function(a, b) {
            b && this.v.delete(a) ? (fk(this, a, b), Wj(this)) : !b && this.l.delete(a) && (fk(this, a, b), Tj(this));
        };
        k.notifyVisiblePagesUpdated = function() {
            this.s = !0;
            Yj(this);
            Tj(this);
        };
        k.setPanZoomAllowed = function(a) {
            this.ra = a;
        };
        k.setSwipeNavigationGestureAllowed = function(a) {
            this.Wa = a;
        };
        k.unloadPage = function(a) {
            if (this.g) {
                var b = this.T.get(a);
                C(b) && (1 === b ? (this.T.delete(a), this.F.delete(a), a.removeStateChangeListener(this.L), vj(this.g.Pa, a)) : this.T.set(a, b - 1));
            }
            this.N.unloadPage(a);
        };
        function Uj(a) {
            null !== a.C && (clearTimeout(a.C), a.C = null);
        }
        function Zj(a) {
            null !== a.h && (clearTimeout(a.h), a.h = null);
            a.D && (a.D.cancel(), a.D = null);
        }
        function Yj(a) {
            null !== a.i && (clearTimeout(a.i), a.i = null);
            a.H && (a.H.cancel(), a.H = null);
        }
        function ak(a, b, c) {
            function d(f) {
                a.l.delete(f) && Tj(a);
                a.v.delete(f) && Wj(a);
                Vj(a);
            }
            if (!a.g) return b;
            Uj(a);
            a.o = !1;
            var e = b.then(function(f) {
                !a.g || a.B && !a.l.has(e) && f.getState() !== x.RenderableState.VISIBLE ? f.setRenderingPaused(!0) : f.setRenderingPaused(!1);
                if (a.g) {
                    var g = a.T.get(f);
                    if (C(g)) a.T.set(f, g + 1);
                    else {
                        a.T.set(f, 1);
                        g = a.g.Pa;
                        if (g.g) {
                            var h = g.T.get(f);
                            if (C(h)) g.T.set(f, h + 1);
                            else {
                                g.T.set(f, 1);
                                h = g.g;
                                var l = f.getReaderDocument(), r = g.Sa.get(l);
                                C(r) ? g.Sa.set(l, r + 1) : (g.Sa.set(l, 1), l = new tj("readerDocumentLoaded", {
                                    readerDocument: l,
                                    readerView: h.getReaderView()
                                }), V(h, l));
                                V(g.g, new sj("renderablePageLoaded", f));
                            }
                        }
                        f.addStateChangeListener(a.L);
                    }
                }
                d(e);
                return f;
            }).catch(function(f) {
                d(e);
                return Promise.reject(f);
            });
            fk(a, e, c);
            return e;
        }
        function Tj(a) {
            null === a.i && !a.u && 0 === a.l.size && a.s && (Yj(a), a.i = window.setTimeout(a.ab, 0));
        }
        function Vj(a) {
            a.g && !a.u && (0 === a.l.size && !a.s || 0 === a.v.size && !a.o) && (a.C = window.setTimeout(a.sb, 2E3));
        }
        function Wj(a) {
            null === a.h && !a.u && 0 === a.v.size && a.o && (Zj(a), a.h = window.setTimeout(a.Xa, 0));
        }
        function fk(a, b, c) {
            a.g && (c ? (a.s = !1, a.B = !0, Sj(a.g, !0), a.l.add(b), Yj(a)) : (Rj(a.g, !0), a.v.add(b), Zj(a)));
        }
        function gk(a, b) {
            this.g = null;
            this.i = !1;
            null === b ? p.BrowserDetector.isPlatform("tablet") ? this.h = 390 : p.BrowserDetector.isPlatform("mobile") ? this.h = 300 : this.h = 200 : this.h = b;
            this.na = document.createElement("div");
            this.na.classList.add("colibrio-renderer-runtime-container");
            this.na.style.opacity = "0";
            this.na.style.transition = "opacity " + this.h + "ms";
            a.appendChild(this.na);
        }
        gk.prototype.destroy = function() {
            Wa(this.na);
        };
        gk.prototype.isVisible = function() {
            return this.i;
        };
        function hk(a) {
            if (a.i && !a.g) return Promise.resolve();
            a.g || (a.i = !0, a.g = new Promise(function(b) {
                function c() {
                    null !== h && clearTimeout(h);
                    h = window.setTimeout(function() {
                        h = null;
                        d();
                    }, a.h + 500);
                }
                function d() {
                    null !== h && clearTimeout(h);
                    g && f && e && (a.na.removeEventListener(e, d), a.na.removeEventListener(f, d), a.na.removeEventListener(g, d));
                    a.g = null;
                    b();
                }
                var e = null, f = null, g = null, h = null;
                "ontransitionend" in a.na ? (e = "transitionstart", f = "transitionend", g = "transitioncancel") : "onwebkittransitionend" in a.na && (e = "webkittransitionstart", f = "webkittransitionend", g = "webkittransitioncancel");
                g && f && e && (a.na.addEventListener(e, c), a.na.addEventListener(f, d), a.na.addEventListener(g, d));
                c();
                a.na.style.opacity = "1";
            }));
            return a.g;
        }
        function ik(a) {
            Z.call(this, "activeRendererRuntimeConfigChanged");
            this.j = a;
        }
        m.inherits(ik, Z);
        m.global.Object.defineProperties(ik.prototype, {
            g: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.j;
                }
            }
        });
        function jk(a) {
            var b = this;
            this.i = a;
            this.h = null;
            this.g = [];
            this.j = function() {
                b.h && (b.h.G.Ia = !0, hk(b.h.na).finally(function() {
                    kk(b);
                }).catch(function(c) {
                    p.ColibrioError.isColibrioAbortedError(c) || p.Logger.logError(c);
                }));
            };
            T(a, "visibleContentRendered", this.j);
        }
        function lk(a) {
            a.g.forEach(function(b) {
                mk(b);
            });
            a.g = [];
            a.h = null;
            nk(a, new Set([
                1
            ]));
        }
        jk.prototype.ka = function() {
            return this.h;
        };
        function kk(a) {
            var b;
            for(b = a.g.length - 1; 0 <= b && !a.g[b].na.isVisible(); b--);
            for(var c = 0; c < b; c++)mk(a.g[c]);
            0 < b && a.g.splice(0, b);
        }
        function mk(a) {
            Xj(a.G);
            a.ca.destroyRuntime(a.P);
            a.N.destroy();
            a.na.destroy();
        }
        function nk(a, b) {
            V(a.i, new ik(b));
        }
        function ok(a) {
            this.h = this.g = null;
            Ha(a) && (this.h = window.matchMedia(a));
            B(a) && (this.g = a);
        }
        ok.prototype.matches = function() {
            return this.g ? this.g() : this.h ? this.h.matches : !0;
        };
        function pk() {
            var a = this;
            this.l = !1;
            this.h = this.g = null;
            this.i = !1;
            this.o = new Promise(function(b, c) {
                a.h = b;
                a.g = c;
            });
        }
        pk.prototype.cancel = function() {
            this.l = !0;
            qk(this, new D(p.ColibrioErrorType.ABORTED));
        };
        pk.prototype.isCanceled = function() {
            return this.l;
        };
        function qk(a, b) {
            !a.i && a.g && (a.i = !0, a.g(b), a.g = a.h = null);
        }
        pk.prototype.resolve = function(a) {
            !this.i && this.h && (this.i = !0, this.h(a), this.g = this.h = null);
        };
        function rk(a) {
            pk.call(this);
            this.s = a;
        }
        m.inherits(rk, pk);
        rk.prototype.j = function(a, b) {
            var c = this;
            b = b.map(function(d) {
                return d.fetchUnresolvedContentLocation(c.s);
            });
            Ya(b).then(function(d) {
                var e = d.getReaderDocuments()[0];
                c.isCanceled() ? qk(c, new D(p.ColibrioErrorType.ABORTED)) : a.some(function(f) {
                    return f === e;
                }) ? c.resolve(d.resolve()) : qk(c, new D("RENDERABLE_DOCUMENT_PAGE_NOT_FOUND", "LocatorResolver: " + e.getLocator().toString()));
            }, function() {
                qk(c, new D("RENDERABLE_DOCUMENT_PAGE_NOT_FOUND", "LocatorResolver: No ContentLocation matching: " + c.s));
            });
        };
        function sk(a) {
            pk.call(this);
            this.Ta = a;
        }
        m.inherits(sk, pk);
        sk.prototype.j = function(a) {
            var b = this.Ta.getReaderDocuments()[0];
            a.some(function(c) {
                return c === b;
            }) ? (a = rg(this.Ta) ? this.Ta : this.Ta.resolve(), this.resolve(a)) : qk(this, new D("RENDERABLE_DOCUMENT_PAGE_NOT_FOUND", "ReaderPublicationContentLocationResolver: ReaderDocument not part of ReaderView. Locator: " + b.getLocator()));
        };
        function tk() {
            pk.call(this);
        }
        m.inherits(tk, pk);
        tk.prototype.j = function(a) {
            this.resolve(a[0].getContentLocation());
        };
        function uk(a, b) {
            G.call(this, a, b);
        }
        m.inherits(uk, X);
        uk.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this);
            return Object.assign(a, {
                objectType: x.EngineEventDataObjectType.READER_VIEW_TRANSFORM_ENGINE_EVENT,
                transform: this.m.pd
            });
        };
        m.global.Object.defineProperties(uk.prototype, {
            transform: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.pd;
                }
            }
        });
        function vk(a) {
            this.g = a;
        }
        function wk() {
            return new vk([
                1,
                0,
                0,
                1,
                0,
                0
            ]);
        }
        vk.prototype.equals = function(a) {
            return this.g.every(function(b, c) {
                return a.g[c] === b;
            });
        };
        function Fh(a) {
            return 1 === a.g[0] && 0 === a.g[1] && 0 === a.g[2] && 1 === a.g[3] && 0 === a.g[4] && 0 === a.g[5];
        }
        function xk(a) {
            var b = a.g[0], c = a.g[3];
            return 0 < b && 0 < c && Number.isFinite(b) && Number.isFinite(c) && Number.isFinite(a.g[4]) && Number.isFinite(a.g[5]);
        }
        vk.prototype.scale = function(a) {
            return new vk([
                a * this.g[0],
                a * this.g[1],
                a * this.g[2],
                a * this.g[3],
                this.g[4],
                this.g[5]
            ]);
        };
        function yk(a, b) {
            return {
                za: b.za * a.g[0] + b.Aa * a.g[2] + a.g[4],
                Aa: b.za * a.g[1] + b.Aa * a.g[3] + a.g[5]
            };
        }
        function zk(a, b) {
            var c = yk(a, {
                za: b.x,
                Aa: b.y
            });
            a = yk(a, {
                za: b.x + b.width,
                Aa: b.y + b.height
            });
            return {
                height: a.Aa - c.Aa,
                width: a.za - c.za,
                x: c.za,
                y: c.Aa
            };
        }
        function Jh(a, b, c) {
            return new vk([
                a.g[0],
                a.g[1],
                a.g[2],
                a.g[3],
                b * a.g[0] + c * a.g[2] + a.g[4],
                b * a.g[1] + c * a.g[3] + a.g[5]
            ]);
        }
        function Ak(a, b, c, d) {
            this.o = a;
            this.h = b;
            this.B = c;
            this.ua = d;
            this.j = !1;
            this.g = null;
            this.s = -1;
            this.u = this.v = null;
            this.i = 0;
            this.l = !1;
        }
        Ak.prototype.abort = function() {
            if (!this.j) {
                this.j = !0;
                this.l = !1;
                C(this.g) && (cancelAnimationFrame(this.g), this.g = null);
                var a;
                null == (a = this.v) || a.call(this);
            }
        };
        Ak.prototype.isAtEnd = function() {
            return this.i >= this.ua;
        };
        Ak.prototype.play = function() {
            this.l || this.j || (this.l = !0, Bk(this));
        };
        function Ck(a, b) {
            a.v = b;
        }
        function Dk(a, b) {
            a.u = b;
        }
        function Bk(a) {
            a.g = requestAnimationFrame(function(b) {
                a.g = null;
                if (!a.j) {
                    if (-1 !== a.s && (a.i += b - a.s), a.s = b, a.i >= a.ua || 0 >= a.ua) {
                        var c;
                        null == (c = a.u) || c.call(a, a.h, !0);
                        a.l = !1;
                    } else {
                        var d = a.B(Ka(a.i / a.ua, 0, 1));
                        b = Sa(d, 1, a.o.g[4], a.h.g[4]);
                        c = Sa(d, 1, a.o.g[5], a.h.g[5]);
                        var e = Sa(d, 1, a.o.g[0], a.h.g[0]);
                        d = Sa(d, 1, a.o.g[3], a.h.g[3]);
                        var f;
                        null == (f = a.u) || f.call(a, new vk([
                            e,
                            0,
                            0,
                            d,
                            b,
                            c
                        ]), !1);
                        Bk(a);
                    }
                }
            });
        }
        var Ek = __lib__bezier_easing;
        var Fk = [
            .4,
            0,
            .2,
            1
        ];
        function Gk(a) {
            a = a.trim();
            if (a.startsWith("cubic-bezier(") && a.endsWith(")")) {
                var b = a.slice(13, -1).split(",").map(parseFloat);
                4 === b.length && b.every(C) || (p.Logger.logError(new D("TRANSFORM_ERROR", "Invalid transform easing function: " + a)), b = Fk);
            } else p.Logger.logError(new D("TRANSFORM_ERROR", "Invalid transform easing function: " + a)), b = Fk;
            return Ek.apply(null, m.Ua(b));
        }
        function Hk(a, b, c) {
            b = b ? c.removeTransformAnimationDurationMs : 0;
            var d;
            c = {
                durationMs: null != (d = null == a ? void 0 : a.durationMs) ? d : b,
                easing: "cubic-bezier(0.4, 0.0, 0.2, 1)"
            };
            return y(a, c, !1);
        }
        function Ik(a, b) {
            return a && (a = p.LengthUtils.getLengthAsCssPixels(a, b), Number.isFinite(a)) ? a : .5 * b;
        }
        function Jk(a) {
            var b = this;
            this.l = a;
            this.j = null;
            this.C = this.B = 0;
            this.u = 5;
            this.o = null;
            this.F = this.D = this.v = !1;
            this.H = wk();
            this.i = null;
            this.g = wk();
            this.h = this.s = null;
            this.L = function(c) {
                b.v = c.newGestureType === x.ReaderViewGestureType.PAN_ZOOM;
                Kk(b);
            };
            this.O = function() {
                var c = b.l.ka(), d = null == c ? void 0 : c.P;
                c = null == c ? void 0 : c.na.na;
                var e;
                null == (e = b.j) || e.abort();
                b.j = null;
                d && c ? (e = d.getRendererElement(), b.i = {
                    height: e.offsetHeight,
                    width: e.offsetWidth,
                    x: 0,
                    y: 0
                }, b.h = {
                    height: c.offsetHeight,
                    width: c.offsetWidth,
                    x: -e.offsetLeft,
                    y: -e.offsetTop
                }, c = b.l.getVisiblePages(), d = d.getPublicationViewportBoundingRect(c), b.o = {
                    height: d.height,
                    width: d.width,
                    x: d.x - e.offsetLeft,
                    y: d.y - e.offsetTop
                }, d = b.l.getOptions(), b.s = d.transformManagerOptions, b.B = Ik(b.s.maxPanOffsetHorizontal, b.h.width), b.C = Ik(b.s.maxPanOffsetVertical, b.h.height), b.s.maxScaleFactor && (b.u = b.s.maxScaleFactor)) : (b.h = null, b.i = null, b.o = null, b.s = null);
                b.g = wk();
                Kk(b);
            };
            this.W = function() {
                var c, d = null == (c = b.l.ka()) ? void 0 : c.P, e = b.l.getVisiblePages();
                d && (c = d.getRendererElement(), d = d.getPublicationViewportBoundingRect(e), b.o = {
                    height: d.height,
                    width: d.width,
                    x: d.x - c.offsetLeft,
                    y: d.y - c.offsetTop
                });
            };
            T(a, "activeRendererRuntimeConfigChanged", this.O);
            T(a, "activeGestureTypeChanged", this.L);
            T(a, "visiblePagesChanged", this.W);
        }
        function Lk() {
            return new D("TRANSFORM_ERROR", "ReaderView cannot be transformed at this moment.");
        }
        function Mk() {
            return new D("TRANSFORM_ERROR", "The transform is not a valid 2D transform");
        }
        k = Jk.prototype;
        k.canTransform = function() {
            return null !== this.s && null !== this.l.ka() && !this.l.isNavigating() && !this.l.Vb();
        };
        k.destroy = function() {
            var a;
            null == (a = this.j) || a.abort();
            this.s = this.o = this.h = this.i = this.j = null;
        };
        function Mj(a) {
            return !Fh(a.g) || a.j || a.v ? {
                animating: !!a.j,
                scale: a.g.g[0],
                userGestureActive: a.v,
                x: a.g.g[4],
                y: a.g.g[5]
            } : null;
        }
        k.removeActiveTransform = function(a, b) {
            return Fh(this.g) ? Promise.resolve() : b || this.canTransform() ? Nk(this, wk(), a) : Promise.reject(Lk());
        };
        function Ok(a, b, c) {
            b = Kh(a, b ? new vk([
                b.scale,
                0,
                0,
                b.scale,
                b.x,
                b.y
            ]) : wk());
            Nk(a, b, c).catch(function(d) {
                p.ColibrioError.isColibrioAbortedError(d) || p.Logger.logError(d);
            });
        }
        function Ih(a, b, c) {
            a.canTransform() && !a.j && (b = Kh(a, Jh(a.g, b / a.g.g[0], c / a.g.g[3])), Lh(a, b));
        }
        k.zoomToClientPosition = function(a, b, c, d) {
            var e, f, g = null == (e = this.l.ka()) ? void 0 : null == (f = e.P) ? void 0 : f.getRendererElement();
            if (!g || !this.canTransform() || !this.i) return Promise.reject(Lk());
            e = Xa(g.getBoundingClientRect());
            a = (a - e.x) / this.g.g[0];
            b = (b - e.y) / this.g.g[3];
            c = Jh(Jh(wk(), this.i.width / 2, this.i.height / 2).scale(c), -a, -b);
            c = Kh(this, c);
            return Nk(this, c, d);
        };
        k.zoomToClientRect = function(a, b) {
            var c, d;
            if (!(null == (c = this.l.ka()) ? 0 : null == (d = c.P) ? 0 : d.getRendererElement()) || !this.canTransform() || !this.h) return Promise.reject(Lk());
            var e;
            c = Math.max(1, Math.min(this.g.g[0] * this.h.width / Math.abs(a.width), this.g.g[3] * this.h.height / Math.abs(a.height), null != (e = null == b ? void 0 : b.maxScaleFactor) ? e : this.u));
            return this.zoomToClientPosition((a.left + a.right) / 2, (a.top + a.bottom) / 2, c, null == b ? void 0 : b.animationOptions);
        };
        k.zoomToPublicationViewportPosition = function(a, b, c, d) {
            if (!this.canTransform() || !this.o || !this.i) return Promise.reject(Lk());
            a = p.LengthUtils.getLengthAsCssPixels(a, this.o.width) + this.o.x;
            b = p.LengthUtils.getLengthAsCssPixels(b, this.o.height) + this.o.y;
            c = Jh(Jh(wk(), this.i.width / 2, this.i.height / 2).scale(c), -a, -b);
            c = Kh(this, c);
            return Nk(this, c, d);
        };
        k.zoomToPublicationViewportRect = function(a, b, c) {
            var d, e;
            if (!((null == (d = this.l.ka()) ? 0 : null == (e = d.P) ? 0 : e.getRendererElement()) && this.canTransform() && this.h && this.o && this.i)) return Promise.reject(Lk());
            var f = this.o;
            e = (a.top + a.bottom) / 2;
            d = p.LengthUtils.getLengthAsCssPixels({
                unit: b,
                value: (a.left + a.right) / 2
            }, f.width) + f.x;
            e = p.LengthUtils.getLengthAsCssPixels({
                unit: b,
                value: e
            }, f.height) + f.y;
            var g = p.LengthUtils.getLengthAsCssPixels({
                unit: b,
                value: a.width
            }, f.width);
            a = p.LengthUtils.getLengthAsCssPixels({
                unit: b,
                value: a.height
            }, f.height);
            var h;
            a = Math.max(1, Math.min(this.h.width / Math.abs(g), this.h.height / Math.abs(a), null != (h = null == c ? void 0 : c.maxScaleFactor) ? h : this.u));
            h = Jh(Jh(wk(), this.i.width / 2, this.i.height / 2).scale(a), -d, -e);
            h = Kh(this, h);
            return Nk(this, h, null == c ? void 0 : c.animationOptions);
        };
        function Kh(a, b) {
            if (!a.o || !a.i || !a.h) return wk();
            var c = 1;
            b.g[0] > a.u ? c = a.u / b.g[0] - Number.EPSILON : 1 > b.g[0] && (c = 1 / b.g[0] + Number.EPSILON);
            if (1 !== c) {
                var d = 1 / (b.g[0] * b.g[3] - b.g[1] * b.g[2]);
                d = yk(new vk([
                    d * b.g[3],
                    -d * b.g[1],
                    -d * b.g[2],
                    d * b.g[0],
                    d * (b.g[2] * b.g[5] - b.g[3] * b.g[4]),
                    d * (b.g[1] * b.g[4] - b.g[0] * b.g[5])
                ]), {
                    za: a.i.width / 2,
                    Aa: a.i.height / 2
                });
                b = Jh(Jh(b, d.za, d.Aa).scale(c), -d.za, -d.Aa);
            }
            c = zk(b, a.o);
            var e = zk(b, a.i), f = c.height + 2 * a.C, g = c.width + 2 * a.B, h = c.x - a.B, l = c.y - a.C;
            d = c = 0;
            g <= a.h.width ? (g = (a.i.width - e.width) / 2, b = b.g.slice(), b[4] = g, b = new vk(b)) : h > a.h.x ? c = a.h.x - h : h + g < a.h.x + a.h.width && (c = a.h.x + a.h.width - (h + g));
            f <= a.h.height ? (a = (a.i.height - e.height) / 2, b = b.g.slice(), b[5] = a, b = new vk(b)) : l > a.h.y ? d = a.h.y - l : l + f < a.h.y + a.h.height && (d = a.h.y + a.h.height - (l + f));
            if (0 !== c || 0 !== d) b = Jh(b, c / b.g[0], d / b.g[3]);
            return b;
        }
        function Kk(a) {
            var b = !!a.j;
            a.g.equals(a.H) && a.v === a.F && b === a.D || (a.D = b, a.H = a.g, a.F = a.v, b = new uk("activeTransformChanged", {
                pd: Mj(a),
                readerView: a.l.getReaderView()
            }), V(a.l, b));
        }
        function Lh(a, b) {
            xk(b) ? (a.g = b, Kk(a)) : p.Logger.logError(Mk());
        }
        function Nk(a, b, c) {
            if (!xk(b)) return Promise.reject(Mk());
            if (!a.s) return Promise.reject(Lk());
            var d;
            null == (d = a.j) || d.abort();
            a.j = null;
            if (a.g.equals(b)) return Promise.resolve();
            var e = Hk(c, Fh(b), a.s);
            return 0 >= e.durationMs ? (a.g = b, Kk(a), Promise.resolve()) : new Promise(function(f, g) {
                var h = Gk(e.easing);
                a.j = new Ak(a.g, b, h, e.durationMs);
                Dk(a.j, function(l, r) {
                    a.g = l;
                    r && (a.j = null);
                    Kk(a);
                    r && f();
                });
                Ck(a.j, function() {
                    g(new D(p.ColibrioErrorType.ABORTED));
                });
                a.j.play();
            });
        }
        function Pk(a, b) {
            if (!b.contains(a)) {
                var c = a.collapseToStart();
                a = a.collapseToEnd();
                c = c.isBefore(b) ? b : c;
                b = a.isAfter(b) ? b : a;
                a = c.createRangeTo(b);
            }
            return a;
        }
        function Qk(a, b) {
            this.g = a;
            this.h = b;
        }
        k = Qk.prototype;
        k.fetchRectsForVisibleContent = function(a, b) {
            var c = this, d = y(b, {
                includeNodeData: !1
            });
            if (this.g.getState() === x.RenderableState.VISIBLE) {
                b = this.g.getRangeContentLocation();
                if (a) {
                    if (!a.intersects(b)) return Promise.reject(new D("CONTENT_LOCATION_OUTSIDE_VISIBLE_PAGE"));
                    var e = Pk(a, b);
                } else e = b;
                return this.g.isRenderingCompleted() ? this.g.fetchRectsForVisibleContent(e, d) : new Promise(function(f, g) {
                    function h() {
                        c.g.getState() !== x.RenderableState.VISIBLE ? (c.g.removeStateChangeListener(h), g(new D(p.ColibrioErrorType.ABORTED))) : c.g.isRenderingCompleted() && (c.g.removeStateChangeListener(h), f(c.g.fetchRectsForVisibleContent(e, d)));
                    }
                    c.g.addStateChangeListener(h);
                });
            }
            return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
        };
        k.getBoundingClientRect = function() {
            var a = this.g.getPageContentElement();
            return a ? Xa(a.getBoundingClientRect()) : null;
        };
        k.getPageSpreadSlot = function() {
            return this.g.getSpreadSlot();
        };
        k.getRangeContentLocation = function() {
            return this.g.getRangeContentLocation();
        };
        k.getReaderDocument = function() {
            return this.g.getReaderDocument();
        };
        k.getStartContentLocation = function() {
            return this.g.getStartContentLocation();
        };
        k.isCustomPageContent = function() {
            return this.g.isCustomPageContent();
        };
        k.print = function() {
            this.g.print();
        };
        k.setContentSelection = function(a) {
            var b = this, c, d;
            return m.ea(function(e) {
                switch(e.g){
                    case 1:
                        c = b.g.getState();
                        if (c !== x.RenderableState.VISIBLE) throw new D(p.ColibrioErrorType.ABORTED);
                        if (!b.h.isContentSelectionEnabled()) throw new D("CONTENT_SELECTION_DISABLED");
                        if (rg(a) || W(a)) {
                            e.J(2);
                            break;
                        }
                        return n(e, b.g.getReaderDocument().getReaderPublication().fetchUnresolvedContentLocation(a), 3);
                    case 3:
                        a = e.h;
                    case 2:
                        if (!W(a)) {
                            e.J(4);
                            break;
                        }
                        return n(e, a.resolve(), 5);
                    case 5:
                        a = e.h;
                    case 4:
                        if (!a.intersects(b.g.getRangeContentLocation())) throw new D("CONTENT_LOCATION_OUTSIDE_VISIBLE_PAGE");
                        d = Pk(a, b.g.getRangeContentLocation());
                        return e.return(b.g.setContentSelection(d));
                }
            });
        };
        k.toJSON = function() {
            var a = this.getBoundingClientRect();
            return {
                boundingClientRect: a ? a.toJSON() : null,
                pageSpreadSlot: this.getPageSpreadSlot(),
                rangeLocator: this.getRangeContentLocation().getLocator().toJSON(),
                readerDocumentIndexInSpine: this.getReaderDocument().getIndexInSpine(),
                startLocator: this.getStartContentLocation().getLocator().toJSON()
            };
        };
        function Rk(a, b, c, d) {
            var e = this;
            this.Xd = a;
            this.R = b;
            this.Ba = c;
            this.h = d;
            this.o = this.g = this.rb = this.H = null;
            this.sb = [
                x.ReaderViewGestureType.PAN_ZOOM,
                x.ReaderViewGestureType.SWIPE_NAVIGATION
            ];
            this.cc = !0;
            this.sc = this.qc = this.nc = this.mc = this.Zb = !1;
            this.Ca = "unknown";
            this.L = this.ma = this.B = null;
            this.ra = new Wh(new fi);
            this.O = new Wh("Reading session expired. Please check your internet connection.");
            this.jb = new nj;
            this.ab = {
                next: null,
                previous: null,
                visible: null
            };
            this.tc = 0;
            this.A = !1;
            this.xd = new bi(this);
            this.bc = new Sc;
            this.u = null;
            this.Ia = !1;
            this.l = void 0;
            this.zb = this.wc = this.vc = !1;
            this.zc = null;
            this.Ac = this.Oa = 0;
            this.yd = void 0;
            this.Bc = !1;
            this.qa = null;
            this.Ib = new Set;
            this.j = [];
            this.F = [];
            this.s = null;
            this.Jb = void 0;
            this.v = [];
            this.Wa = new jk(this);
            this.kb = !1;
            this.Z = this.ob = this.Xa = this.D = null;
            this.Cc = !1;
            this.la = [];
            this.C = null;
            this.Zd = function() {
                var f = e.Wa.ka();
                f ? (e.Ac = 0, e.wc = !1, e.g ? Aj(e.g, f) : e.s ? kg(e, e.s, void 0, !0).catch(Sk) : 0 < e.la.length && kg(e, e.la[0].getStartContentLocation(), void 0, !0).catch(Sk)) : e.g && Aj(e.g, f);
            };
            this.de = function(f) {
                e.i && (e.i.N.s = f);
            };
            this.$d = function(f) {
                e.i && e.i.P.applyTransform(f.transform);
            };
            this.Ha = new Jk(this);
            T(this, "activeRendererRuntimeConfigChanged", this.Zd);
            T(this, "activeTransformChanged", this.$d);
            this.W = new Kj(this);
            this.Pa = new uj(this);
            c && c.g.add(this.de);
        }
        function V(a, b) {
            a = a.bc.get(b.type);
            Qc(b, a);
        }
        function bk(a) {
            var b = !1, c = !1, d = !1, e = !1, f = !1;
            0 < a.j.length && 0 < a.v.length && null !== a.Z && (f = !0, a.g || null === a.i || (b = a.i.G.O, c = a.i.G.la, d = a.i.G.W, e = a.i.G.ma));
            a.sc !== f && (a.sc = f, V(a, new X("canPerformGoToChanged", {
                readerView: a.R
            })));
            a.Zb !== b && (a.Zb = b);
            a.nc !== c && (a.nc = c);
            a.mc !== d && (a.mc = d, V(a, new X("canPerformNextChanged", {
                readerView: a.R
            })));
            a.qc !== e && (a.qc = e, V(a, new X("canPerformPreviousChanged", {
                readerView: a.R
            })));
        }
        function ck(a, b) {
            a.zb && (a.zb = !1, b ? V(a, new ei({
                md: b.scrollDistance,
                nd: b.scrollTop,
                Fb: b.userGenerated,
                readerView: a.R
            })) : V(a, new X("rendererScrollCanceled", {
                readerView: a.R
            })));
        }
        function dk(a, b) {
            var c = void 0;
            if (!b) {
                var d;
                if ((b = null == (d = a.i) ? void 0 : d.P) && b.getScrollState) {
                    var e;
                    c = null == (e = b.getScrollState()) ? void 0 : e.scrollHeight;
                }
            }
            a.yd !== c && (a.yd = c, V(a, new X("rendererScrollHeightChanged", {
                readerView: a.R
            })));
        }
        function Gh(a, b) {
            if (a.H !== b) {
                var c = new Yh({
                    $c: b,
                    cd: a.H,
                    readerView: a.R
                });
                a.H = b;
                V(a, c);
            }
        }
        function Rj(a, b) {
            a.Bc !== b && (a.Bc = b, V(a, new X(b ? "offscreenContentRendering" : "offscreenContentRendered", {
                readerView: a.R
            })));
        }
        function ek(a, b) {
            a.kb !== b && (a.kb = b, V(a, new X(b ? "rendererTransitionStarted" : "rendererTransitionEnded", {
                readerView: a.R
            })));
        }
        function Sj(a, b) {
            a.Cc !== b && (a.Cc = b, V(a, new X(b ? "visibleContentRendering" : "visibleContentRendered", {
                readerView: a.R
            })));
        }
        function T(a, b, c) {
            a.bc.add(b, c);
        }
        k = Rk.prototype;
        k.addRenderer = function(a, b) {
            var c = this, d;
            b ? B(b.matches) ? d = b : d = new ok(b) : d = null;
            this.v.push({
                ca: a,
                ld: d
            });
            bk(this);
            0 < this.j.length && a.isPublicationPreferredAspectRatioRequired(this.j) && void 0 === this.mb ? Tk(this, function() {
                return Uk(c, !0);
            }) : Uk(this, !1);
        };
        function lg(a, b) {
            switch(b){
                case x.NavigationAction.CURRENT:
                    return !a.kb && null !== a.i;
                case x.NavigationAction.NEXT_CONTENT_RANGE:
                    return a.Zb;
                case x.NavigationAction.PREVIOUS_CONTENT_RANGE:
                    return a.nc;
                case x.NavigationAction.GOTO:
                    return a.sc;
                case x.NavigationAction.NEXT_RENDERABLE_PAGE:
                    return a.mc;
                case x.NavigationAction.PREVIOUS_RENDERABLE_PAGE:
                    return a.qc;
            }
        }
        k.destroy = function() {
            this.A = !0;
            Vk(this);
            this.Pa.destroy();
            this.Ca = "unknown";
            this.l = void 0;
            this.L = this.O = this.ma = this.B = null;
            this.u && (this.u.destroy(), this.u = null);
            this.g && (this.g.cancel(), this.g = null, V(this, new Z("activeNavigationTaskChanged")));
            this.v = [];
            this.j = [];
            this.F = [];
            this.s = null;
            this.Ha.destroy();
            this.la = [];
            this.Z = null;
        };
        k.fetchRectsForVisibleContent = function(a, b, c) {
            return a instanceof Qk ? this.la.includes(a.g) ? a.fetchRectsForVisibleContent(b, c) : Promise.reject(new D("VISIBLE_PAGE_OUTDATED")) : Promise.reject(new Cd("fetchRectsForVisibleContent: visiblePage is not an instance of VisiblePage"));
        };
        k.focusOnReadingPosition = function(a) {
            if (this.u && !this.u.isDestroyed()) return this.u.l;
            this.u = new pj(this, a);
            return this.u.l;
        };
        k.getActiveGestureType = function() {
            return this.H;
        };
        k.getActiveNavigationAction = function() {
            return this.rb;
        };
        k.getActiveRenderer = function() {
            return this.o || this.l || null;
        };
        k.ka = function() {
            return this.i;
        };
        k.getAllowedGestureTypes = function() {
            return this.sb;
        };
        k.getOptions = function() {
            return this.h;
        };
        k.getPageProgressionDirection = function() {
            return this.h.forcePageProgressionDirection ? this.h.forcePageProgressionDirection : this.qa;
        };
        k.getReaderDocuments = function() {
            return this.j;
        };
        k.getReaderPublications = function() {
            return this.F;
        };
        k.getReaderView = function() {
            return this.R;
        };
        k.getReadingPosition = function() {
            return this.s;
        };
        k.getScrollState = function() {
            var a, b = null == (a = this.i) ? void 0 : a.P;
            return b && b.getScrollState ? b.getScrollState() : null;
        };
        k.getVisiblePages = function() {
            return this.la;
        };
        function Eh(a, b) {
            var c = a.Wa.ka();
            if (!c || a.g || a.kb || !a.sb.includes(b)) return !1;
            if (a.H) return a.H === b;
            switch(b){
                case x.ReaderViewGestureType.PAN_ZOOM:
                    var d = c.G.ra;
                    break;
                case x.ReaderViewGestureType.SWIPE_NAVIGATION:
                    d = !!Fh(a.Ha.g) && c.G.isSwipeNavigationGestureAllowed();
            }
            return d;
        }
        k.isNavigating = function() {
            return !!this.g;
        };
        k.isOffscreenContentRendering = function() {
            return this.Bc;
        };
        k.Vb = function() {
            return this.kb;
        };
        k.isScrolling = function() {
            return this.zb;
        };
        k.isVisibleContentRendering = function() {
            return this.Cc;
        };
        k.navigate = function(a, b, c) {
            if (lg(this, a)) {
                this.Oa++;
                var d = null;
                if (b) d = b;
                else {
                    b = this.ab.next;
                    var e = this.ab.previous, f;
                    if (null == (f = this.i) ? 0 : f.ca.getSupportedFlowModes().includes(t.ContentDocumentFlowMode.PAGINATED)) b && a === x.NavigationAction.NEXT_RENDERABLE_PAGE && (d = b.collapseToStart()), e && a === x.NavigationAction.PREVIOUS_RENDERABLE_PAGE && (d = e.collapseToStart());
                    a === x.NavigationAction.NEXT_CONTENT_RANGE && b ? d = b.collapseToStart() : a === x.NavigationAction.PREVIOUS_CONTENT_RANGE && e && (d = e.collapseToStart());
                }
                a = Wk(this, d, void 0, !1, a, c).s;
            } else a = Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            return a;
        };
        k.refresh = function(a) {
            var b = this;
            this.Jb && window.clearTimeout(this.Jb);
            this.Z && (!this.Ia && a && (this.Ia = !0), this.Jb = window.setTimeout(function() {
                b.Jb = void 0;
                if (!b.A && b.Z && (b.Ia || !b.i || !document.g && !document.fullscreenEnabled || !document.fullscreenElement || null === b.i.P.getRenderablePageByElement(document.fullscreenElement))) {
                    var c = Xk(b.Z);
                    if (b.Ia || !b.ob || c.width !== b.ob.width || c.height !== b.ob.height) b.Ia = !1, Uk(b, !0);
                }
            }, this.Ia ? 0 : this.h.refreshDelayMs));
        };
        function R(a, b, c) {
            a.bc.remove(b, c);
        }
        k.removeRenderer = function(a) {
            var b = this.v.findIndex(function(c) {
                return c.ca === a;
            });
            -1 !== b && this.v.splice(b, 1);
            a === this.l && (this.l = null);
            Uk(this, !1);
        };
        k.scrollBy = function(a) {
            var b, c = null == (b = this.i) ? void 0 : b.P;
            return c && c.scrollBy ? c.scrollBy(a) : !1;
        };
        k.setActiveRenderer = function(a) {
            if (a && this.v.every(function(b) {
                return b.ca !== a;
            })) throw new D("INVALID_RENDERER", 'Renderer "' + a.getName() + '" has not been added to the ReaderView "' + this.h.name + '".');
            this.l = a;
            Uk(this, !1);
        };
        k.setAllowedGestureTypes = function(a) {
            this.sb = a;
            this.H && !this.sb.includes(this.H) && Gh(this, null);
        };
        k.setContentOnActiveRendererMissing = function(a) {
            this.B && Xh(this.B);
            null === a ? this.B = null : this.B = new Wh(a);
            Uk(this, !1);
        };
        k.setContentOnEmptyPage = function(a) {
            this.ma && Xh(this.ma);
            this.ma = a ? new Wh(a) : null;
            this.refresh(!0);
        };
        k.setContentOnLicenseGracePeriodExpired = function(a) {
            this.O && Xh(this.O);
            null === a ? this.O = null : this.O = new Wh(a);
            this.refresh(!0);
        };
        k.setContentOnLoadError = function(a) {
            this.L && Xh(this.L);
            null === a ? this.L = null : this.L = new Wh(a);
            this.refresh(!0);
        };
        k.setContentOnLoading = function(a) {
            this.ra = null === a ? new Wh(new fi) : new Wh(a);
            this.refresh(!0);
        };
        k.setOptions = function(a) {
            var b = this;
            ij(this.h, a).forEach(function(d) {
                b.Ib.add(d);
            });
            var c = this.h.contentDisplayAreaOptions;
            this.h = a;
            V(this, new Z("readerViewOptionsChanged"));
            Yk(c, a.contentDisplayAreaOptions) ? Tk(this, function() {
                return b.refresh(!0);
            }) : this.refresh(!0);
        };
        k.setReaderDocuments = function(a) {
            var b = this;
            pg(a, this.Xd);
            var c = "unknown" === this.Ca || 0 === a.length || !this.j.every(function(e) {
                return a.includes(e);
            }) || 0 === this.j.length, d = 0 !== this.j.length;
            this.j = a;
            this.F = 0 === a.length ? [] : [
                a[0].getReaderPublication()
            ];
            c && (this.Ca = "unknown", this.mb = void 0, this.u && (this.u.destroy(), this.u = null), this.g && d && (this.g.cancel(), this.g = null, V(this, new Z("activeNavigationTaskChanged"))), this.vc = !1, this.qa = null, Vk(this), Zk(this), $k(this), al(this, null, [], null), bk(this));
            this.g && (0 === a.length ? (this.g.cancel(), this.g = null, V(this, new Z("activeNavigationTaskChanged"))) : Ej(this.g, this.j, this.F));
            for(c = 0; c < this.F.length; c++)d = this.F[c].getSourcePublication().getPageProgressionDirection(), d !== t.PageProgressionDirection.AUTO && (d = d === t.PageProgressionDirection.LTR ? x.ReaderViewPageProgressionDirection.LTR : x.ReaderViewPageProgressionDirection.RTL, null === this.qa ? this.qa = d : this.qa !== d && (this.qa = this.h.defaultPageProgressionDirection));
            null === this.qa && (this.qa = this.h.defaultPageProgressionDirection);
            V(this, new Z("readerViewDocumentsChanged"));
            this.Ba && (this.vc = !0);
            "unknown" === this.Ca ? Tk(this, function() {
                return Uk(b, !0);
            }) : Uk(this, !0);
        };
        function kg(a, b, c, d) {
            a.Oa++;
            return Wk(a, b, c, d, x.NavigationAction.GOTO).s;
        }
        function bl(a, b, c) {
            var d = a.h.contentDisplayAreaOptions.type === x.ContentDisplayAreaType.CALCULATED_FROM_PUBLICATION_CONTENT ? a.h.contentDisplayAreaOptions.fallbackAspectRatio : .6666;
            a.cc = !1;
            a.Ca = "unknown";
            var e = a.F.map(function(g) {
                return g.fetchPreferredPageAspectRatio().catch(function(h) {
                    p.Logger.logWarning(h);
                    return null;
                });
            }), f;
            null == (f = a.g) || Cj(f, !0);
            return Promise.all(e).then(function(g) {
                if (b !== a.tc) return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
                g = g.filter(function(q) {
                    return null !== q;
                });
                for(var h = 0, l = 0; l < g.length; l++)h += g[l];
                h && (a.mb = h / g.length);
                if (c) {
                    var r;
                    a.Ca = null != (r = a.mb) ? r : d;
                } else a.h.contentDisplayAreaOptions.type === x.ContentDisplayAreaType.ASPECT_RATIO ? a.Ca = a.h.contentDisplayAreaOptions.aspectRatio : a.h.contentDisplayAreaOptions.type === x.ContentDisplayAreaType.FILL && (a.Ca = "fill");
            });
        }
        function $k(a) {
            a.jb.destroy();
            a.jb = new nj;
            a.ab = {
                next: null,
                previous: null,
                visible: null
            };
            oj(a.jb, function(b) {
                var c;
                (null == (c = a.Wa.ka()) ? 0 : c.N) ? al(a, b.visibleRange, b.visiblePages, b.fe) : p.Logger.logWarning(new D("INVALID_RENDERER_BEHAVIOUR", "ReaderViewModel.setNavigationRangeResult visible range changed but there is no PageStream."));
            });
            V(a, new Z("navigationRangeResultChanged"));
            Qf(a.jb, function(b) {
                a.ab = b;
                bk(a);
            });
        }
        function Vk(a) {
            lk(a.Wa);
            a.o = null;
            cl(a);
            a.W.h.clear();
            null !== a.D && (clearTimeout(a.D), a.D = null);
            a.B && Xh(a.B);
            a.ma && Xh(a.ma);
            a.ra && Xh(a.ra);
            a.L && Xh(a.L);
            a.O && Xh(a.O);
            if (a.Z) for(var b = a.Z; b.firstChild;)b.removeChild(b.firstChild);
            bk(a);
        }
        function Wk(a, b, c, d, e, f) {
            var g = null;
            b instanceof pk ? g = b : W(b) || rg(b) ? g = new sk(b) : b && (g = new rk(b));
            a.g && a.g.cancel();
            b = a.ab;
            $k(a);
            a.g = new wj(a, g, a.Ba, d, function(h, l, r) {
                h === a.g && (a.Z && null === a.D && r === x.NavigationAction.GOTO && (a.D = window.setTimeout(function() {
                    a.D = null;
                    a.Z && h === a.g && a.ra.renderTo(a.Z);
                }, 150)), a.Xa = (null == c ? 0 : c.setReadingPositionToVisibleRangeStart) ? {
                    S: null,
                    qd: !0
                } : {
                    S: null !== l ? l.collapseToStart() : null,
                    qd: !1
                }, dl(a, r, d));
            }, function(h) {
                h === a.g && (a.Z && (null !== a.D && (clearTimeout(a.D), a.D = null), a.ra.removeFrom(a.Z)), h = h.j, h !== a.Ac && (5 === h || 4 === h && a.wc) ? (a.s ? Wk(a, a.s.getLocator(), c, d, x.NavigationAction.GOTO).s : Wk(a, new tk, void 0, d, x.NavigationAction.GOTO).s).catch(Sk) : (a.g = null, V(a, new Z("activeNavigationTaskChanged")), dl(a, null, d), bk(a)), 1 === h && (a.wc = !0), a.Ac = h);
            }, a.jb, e, b, f);
            V(a, new Z("activeNavigationTaskChanged"));
            a.cc || Cj(a.g, !0);
            Aj(a.g, a.i);
            0 < a.j.length && Ej(a.g, a.j, a.F);
            Gh(a, null);
            a.h.transformManagerOptions.removeTransformOnNavigation && Dj(a.g, a.Ha.removeActiveTransform(void 0, !0));
            bk(a);
            a.g.start();
            return a.g;
        }
        function el(a, b, c, d) {
            function e(q) {
                for(var v = null, u = -1, w = 0; w < q.length; w++){
                    var E = q[w].ca, z = E.getVisiblePagesArea(Xk(b), c, d, r);
                    z > u && (u = z, v = E);
                }
                return v;
            }
            for(var f = [], g = [], h = 0; h < a.v.length; h++){
                var l = a.v[h];
                l.ld ? l.ld.matches() && f.push(l) : g.push(l);
            }
            var r = a.j.every(function(q) {
                return !q.isReflowable();
            });
            (a = e(f)) || (a = e(g));
            return a;
        }
        function Yk(a, b) {
            return a.type !== b.type ? !0 : a.type === x.ContentDisplayAreaType.ASPECT_RATIO && b.type === x.ContentDisplayAreaType.ASPECT_RATIO ? a.aspectRatio !== b.aspectRatio : a.type === x.ContentDisplayAreaType.CALCULATED_FROM_PUBLICATION_CONTENT && b.type === x.ContentDisplayAreaType.CALCULATED_FROM_PUBLICATION_CONTENT ? a.fallbackAspectRatio !== b.fallbackAspectRatio : !1;
        }
        function Uk(a, b) {
            var c = a.getPageProgressionDirection();
            if (0 === a.j.length || "unknown" === a.Ca || null === a.Z || !c) Zk(a);
            else if ((b || void 0 === a.l || a.l !== a.o) && a.vc) {
                var d = el(a, a.Z, a.Ca, a.mb);
                if (b || void 0 !== a.l || !a.o || a.o !== d) {
                    var e;
                    null == (e = a.B) || e.removeFrom(a.Z);
                    a.o = void 0 !== a.l ? a.l : d;
                    cl(a);
                    if (a.o) {
                        b = a.o;
                        d = a.xd;
                        e = a.W;
                        var f = a.L || new Wh(""), g = a.ma || new Wh(""), h = a.O || new Wh("");
                        switch(b.getSpreadMode()){
                            case x.RendererSpreadMode.SINGLE_PAGE:
                                g = new Si(f);
                                break;
                            case x.RendererSpreadMode.TWO_PAGES:
                                g = new Yi(f, g, !1, c, a);
                                break;
                            default:
                                g = new Yi(f, g, !0, c, a);
                        }
                        d = new vi(a, b, d, e, h, f, g);
                        a.Ba && (d.s = a.Ba.h);
                        a.ob = Xk(a.Z);
                        b = new gk(a.Z, a.h.rendererTransitionAnimationDurationMs);
                        c = new Qj(a, d, {
                            Ca: a.Ca,
                            qa: c,
                            mb: a.mb,
                            Nd: a.ra,
                            ob: a.ob,
                            Z: b.na
                        });
                        d = a.Ib;
                        a.Ib = new Set;
                        e = a.Wa;
                        f = a.o;
                        kk(e);
                        var l = Ca(e.g);
                        h = f.createRuntime(c);
                        g = c.N;
                        var r = e.i.getOptions().rendererTransitionTimeoutMs, q = h.getContentDisplayAreaDimensions(!1, !0), v, u = null == (v = e.h) ? void 0 : v.P.getContentDisplayAreaDimensions(!1, !0);
                        v = !u || q.width !== u.width || q.height !== u.height;
                        var w;
                        q = (null == (w = e.h) ? void 0 : w.ca) !== f;
                        (v || q) && d.add(1);
                        g.u = h;
                        w = 0 === r || !l || q || v ? 0 : 1;
                        if (e.g.length > w) {
                            for(v = w; v < e.g.length; v++)mk(e.g[v]);
                            e.g = e.g.slice(0, w);
                        }
                        e.h && (Xj(e.h.G), Bi(e.h.N));
                        dk(e.i, !0);
                        e.h = {
                            na: b,
                            G: c,
                            N: g,
                            ca: f,
                            P: h
                        };
                        e.g.push(e.h);
                        nk(e, d);
                        window.setTimeout(e.j, r);
                    } else a.B ? (Vk(a), a.B.renderTo(a.Z)) : Vk(a);
                    Zk(a);
                }
            }
        }
        function Zk(a) {
            if (a.zc !== a.getActiveRenderer()) {
                var b = new Zh({
                    newActiveRenderer: a.o,
                    oldActiveRenderer: a.zc,
                    readerView: a.R
                });
                a.zc = a.o;
                V(a, b);
            }
        }
        function cl(a) {
            ck(a, null);
            Rj(a, !1);
            Sj(a, !1);
            ek(a, !1);
        }
        function dl(a, b, c) {
            var d = a.rb;
            b && b !== d ? (a.rb = b, V(a, new di({
                ic: c,
                eb: b,
                hd: !!d,
                readerView: a.R
            }))) : d && !b && (a.rb = null, V(a, new ci({
                eb: d,
                readerView: a.R
            })));
        }
        function Uf(a, b, c) {
            if (!a.s !== !b || a.s && b && !a.s.equals(b)) {
                a.s = null !== b ? b.collapseToStart() : null;
                if (b) {
                    if (a.Ba) {
                        var d = a.Ba, e = b.getReaderPublication();
                        (d = d.i.get(e)) && Cc(d);
                    }
                    var f, g, h;
                    null == (f = a.i) || null == (g = f.P) || null == (h = g.onReadingPositionChanged) || h.call(g, b, c);
                }
                V(a, new X("readingPositionChanged", {
                    readerView: a.R
                }));
            }
        }
        function al(a, b, c, d) {
            if (!a.C !== !b || a.C && b && !a.C.equals(b)) a.C = b, V(a, new X("visibleRangeChanged", {
                readerView: a.R
            }));
            za(a.la, c) || (a.la = c, bk(a), V(a, new X("visiblePagesChanged", {
                readerView: a.R
            })));
            if (b) {
                var e;
                c = null == (e = a.Xa) ? void 0 : e.qd;
                var f;
                !c && (null == (f = a.Xa) ? 0 : f.S) && b.contains(a.Xa.S) ? Uf(a, a.Xa.S) : !c && a.s && b.contains(a.s) || (d && b.contains(d) ? Uf(a, d) : Uf(a, b.collapseToStart()));
                a.Xa = null;
            } else Uf(a, null);
        }
        function Tk(a, b) {
            var c = Promise.resolve(), d = ++a.tc, e = a.v.some(function(g) {
                return g.ca.isPublicationPreferredAspectRatioRequired(a.j);
            }), f = a.h.contentDisplayAreaOptions.type === x.ContentDisplayAreaType.CALCULATED_FROM_PUBLICATION_CONTENT;
            e || f ? c = bl(a, d, f) : a.h.contentDisplayAreaOptions.type === x.ContentDisplayAreaType.ASPECT_RATIO ? a.Ca = a.h.contentDisplayAreaOptions.aspectRatio : a.h.contentDisplayAreaOptions.type === x.ContentDisplayAreaType.FILL && (a.Ca = "fill");
            c.then(function() {
                if (d === a.tc) {
                    a.cc = !0;
                    var g;
                    null == (g = a.g) || Cj(g, !1);
                    b();
                } else return Promise.reject(new D(p.ColibrioErrorType.ABORTED));
            }).catch(Sk);
        }
        m.global.Object.defineProperties(Rk.prototype, {
            i: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.Wa.ka();
                }
            }
        });
        function Sk(a) {
            p.ColibrioError.isColibrioAbortedError(a) || p.Logger.logError(a);
        }
        function Xk(a) {
            return {
                height: a.offsetHeight,
                width: a.offsetWidth
            };
        }
        function fl(a) {
            this.g = a;
        }
        k = fl.prototype;
        k.applyTransform = function(a, b) {
            if (!this.canTransform()) throw new D("TRANSFORM_ERROR", "ReaderView cannot be transformed at this moment.");
            Ok(this.g.Ha, a, b);
        };
        k.canTransform = function() {
            return this.g.Ha.canTransform();
        };
        k.getActiveTransform = function() {
            return Mj(this.g.Ha);
        };
        k.removeActiveTransform = function(a) {
            return this.g.Ha.removeActiveTransform(a, !1);
        };
        k.zoomToClientPosition = function(a, b, c, d) {
            return this.g.Ha.zoomToClientPosition(a, b, c, d);
        };
        k.zoomToClientRect = function(a, b) {
            return this.g.Ha.zoomToClientRect(a, b);
        };
        k.zoomToPublicationViewportPosition = function(a, b, c, d) {
            return this.g.Ha.zoomToPublicationViewportPosition(a, b, c, d);
        };
        k.zoomToPublicationViewportRect = function(a, b, c) {
            return this.g.Ha.zoomToPublicationViewportRect(a, b, c);
        };
        function gl(a, b, c) {
            var d = this;
            this.i = a;
            this.j = [];
            this.B = this.v = this.u = null;
            this.H = this.A = !1;
            this.l = null;
            this.o = new Sc;
            this.L = this.s = null;
            this.O = !1;
            this.h = this.I = null;
            this.F = [];
            this.W = function(e) {
                d.i.getEventBus().emitAsync(e);
            };
            this.D = function(e) {
                d.W(e);
                hl(d);
            };
            this.ra = function(e) {
                d.i.getEventBus().emit(e);
            };
            this.handlePointerEngineEvent = function(e) {
                var f;
                null == (f = d.L) || f.handlePointerEngineEvent(e);
            };
            this.la = function(e) {
                var f = d.g.ka();
                e.g.has(2) || e.g.has(1) || null === d.h || !f ? (d.s = null, d.O = !1, d.h = null) : d.h && f && (d.h.N = f.N);
                d.l && (d.l.disable(), d.l = null);
                e = d.g.getOptions();
                if (f) {
                    var g = f.G.getReaderViewElement(), h;
                    e.constrainEngineEventsToReaderView || !g.ownerDocument ? h = g : h = g.ownerDocument.documentElement;
                    d.l = new Fg(g, h, d, f.P, d.g.xd, e.emitPointerMoveEventsOnHover);
                    d.l.enable();
                }
                e.pageProgressionTimelineOptions.delayRecalculationUntilPagesVisible || il(d);
            };
            this.Ba = function() {
                d.g.getOptions().pageProgressionTimelineOptions.delayRecalculationUntilPagesVisible && il(d);
            };
            this.ma = function() {
                var e = d.g.getVisiblePages();
                if (d.h) {
                    if (0 < e.length) {
                        var f = d.h;
                        e = Oh(f, e);
                        var g = 0, h = f.l;
                        if (e.start.pageIndex !== h.start.pageIndex || e.start.offset !== h.start.offset || e.end.pageIndex !== h.end.pageIndex || e.end.offset !== h.end.offset) f.l = e, g |= 1;
                        f = g;
                        f & 2 && jl(d, "pageProgressionTimelineRecalculated", d.h);
                        f & 1 && jl(d, "pageProgressionTimelineVisibleRangeChanged", d.h);
                    }
                } else d.s && 0 < e.length && (f = d.g.ka()) && kl(d, f, e, d.s);
            };
            c = y(c, ll());
            this.g = new Rk(a, this, b, c);
            this.L = new Mh(this, this.g, a);
            this.C = new fl(this.g);
            T(this.g, "activeTransformChanged", function(e) {
                var f = d.g.Z;
                if (f) {
                    e = null !== e.transform;
                    var g = f.classList.contains("colibrio-readerview--transform-manager-active");
                    e && !g ? f.classList.add("colibrio-readerview--transform-manager-active") : !e && g && f.classList.remove("colibrio-readerview--transform-manager-active");
                }
            });
            T(this.g, "readingPositionChanged", function(e) {
                d.u = null;
                d.D(e);
            });
            T(this.g, "visibleRangeChanged", function(e) {
                d.B = null;
                d.D(e);
            });
            T(this.g, "visiblePagesChanged", function(e) {
                d.v = null;
                d.F = d.g.getVisiblePages().map(function(f) {
                    return new Qk(f, d);
                });
                d.D(e);
            });
            "activeGestureTypeChanged activeRendererChanged activeTransformChanged canPerformGoToChanged canPerformNextChanged canPerformPreviousChanged navigationStarted navigationEnded offscreenContentRendered offscreenContentRendering rendererScrollCanceled rendererScrollEnded rendererScrollHeightChanged rendererScrollStarted rendererTransitionEnded rendererTransitionStarted visibleContentRendering visibleContentRendered".split(" ").forEach(function(e) {
                T(d.g, e, d.D);
            });
            "mediaElementCurrentTimeChanged mediaElementInsideVisiblePages mediaElementOutsideVisiblePages mediaElementPaused mediaElementPlay mediaElementReady mediaElementSeeked mediaElementWaiting readerDocumentLoaded readerDocumentUnloaded selectionChanged syncMediaEndReached syncMediaError syncMediaPlay syncMediaPaused syncMediaSeeking syncMediaSeeked syncMediaRangeEndReached syncMediaRangeRemoved syncMediaReaderViewSynchronizationStateChanged syncMediaTimelinePositionChanged syncMediaSegmentActive syncMediaSegmentDurationChanged syncMediaSegmentFinished syncMediaWaiting syncMediaReady".split(" ").forEach(function(e) {
                T(d.g, e, d.W);
            });
            [
                "keydown",
                "keyup",
                "copy"
            ].forEach(function(e) {
                T(d.g, e, d.ra);
            });
            T(this.g, "activeRendererRuntimeConfigChanged", this.la);
            T(this.g, "visibleContentRendered", this.Ba);
            T(this.g, "visiblePagesChanged", this.ma);
            this.addEngineEventListener("pointerdown", this.handlePointerEngineEvent);
            this.addEngineEventListener("pointermove", this.handlePointerEngineEvent);
            this.addEngineEventListener("pointerup", this.handlePointerEngineEvent);
            this.addEngineEventListener("pointercancel", this.handlePointerEngineEvent);
        }
        k = gl.prototype;
        k.abortActiveGesture = function() {
            Gh(this.g, null);
            var a;
            null == (a = this.L) || a.l();
        };
        k.addEngineEventListener = function(a, b) {
            this.o.add(a, b);
        };
        k.addRenderer = function(a, b) {
            this.g.addRenderer(a, b);
        };
        k.canPerformGoTo = function() {
            return lg(this.g, x.NavigationAction.GOTO);
        };
        k.canPerformNext = function() {
            return lg(this.g, x.NavigationAction.NEXT_RENDERABLE_PAGE);
        };
        k.canPerformPrevious = function() {
            return lg(this.g, x.NavigationAction.PREVIOUS_RENDERABLE_PAGE);
        };
        k.clearContentSelection = function() {
            ti(this.g.W, null, null);
        };
        k.createAnnotationLayer = function(a) {
            a = new lh(a, this.g);
            this.j.push(a);
            return a;
        };
        k.destroy = function() {
            this.A = !0;
            this.o.clear();
            var a;
            null == (a = this.g.Z) || a.classList.remove("colibrio-readerview--no-user-select", "colibrio-readerview--transform-manager-active");
            this.g.destroy();
            this.F = [];
            this.I && (og(this.I, null), this.I = null);
            hl(this);
        };
        k.destroyAnnotationLayer = function(a) {
            if (a.getReaderView() !== this || !(a instanceof lh)) throw new D("INVALID_ANNOTATION_LAYER", "Cannot destroy ReaderViewAnnotationLayer. It belongs to another ReaderView instance.");
            a.isDestroyed() || (sh(a), a = this.j.indexOf(a), -1 !== a && this.j.splice(a, 1));
        };
        k.fetchRectsForVisibleContent = function(a, b, c) {
            return this.g.fetchRectsForVisibleContent(a, b, c);
        };
        k.focusOnReadingPosition = function(a) {
            return this.g.focusOnReadingPosition(a);
        };
        k.getActiveGestureType = function() {
            return this.g.getActiveGestureType();
        };
        k.getActiveNavigationAction = function() {
            return this.g.getActiveNavigationAction();
        };
        k.getActiveRenderer = function() {
            return this.g.getActiveRenderer();
        };
        k.getAllowedGestureTypes = function() {
            return this.g.getAllowedGestureTypes();
        };
        k.getAnnotationLayerByName = function(a) {
            return this.j.find(function(b) {
                return b.getName() === a;
            }) || null;
        };
        k.getAnnotationLayers = function() {
            return this.j.slice();
        };
        k.getElement = function() {
            return this.g.Z;
        };
        k.getEngineEventListeners = function(a) {
            return this.o.get(a);
        };
        k.getName = function() {
            return this.g.getOptions().name;
        };
        k.getOptions = function() {
            return La(this.g.getOptions());
        };
        k.getPageProgressionDirection = function() {
            return this.g.getPageProgressionDirection();
        };
        k.getPageProgressionTimeline = function() {
            return this.h;
        };
        k.getReaderDocuments = function() {
            return this.g.getReaderDocuments().slice();
        };
        k.getReaderDocumentsLoadedForRendering = function() {
            return Array.from(this.g.Pa.Sa.keys());
        };
        k.getReaderPublications = function() {
            return this.g.getReaderPublications().slice();
        };
        k.getReadingPosition = function() {
            return this.g.getReadingPosition();
        };
        k.getReadingSystemEngine = function() {
            return this.i;
        };
        k.getRendererByName = function(a) {
            var b = this.g.v.find(function(c) {
                return c.ca.getName() === a;
            });
            return b ? b.ca : null;
        };
        k.getRenderers = function() {
            return this.g.v.map(function(a) {
                return a.ca;
            });
        };
        k.getScrollState = function() {
            return this.g.getScrollState();
        };
        k.getSyncMediaPlayer = function() {
            return this.I;
        };
        k.getTransformManager = function() {
            return this.C;
        };
        k.getVisiblePages = function() {
            return this.F.slice();
        };
        k.getVisibleRange = function() {
            return this.g.C;
        };
        k.getVisibleReaderDocuments = function() {
            var a = [];
            this.g.getVisiblePages().forEach(function(b) {
                b = b.getReaderDocument();
                a.includes(b) || a.push(b);
            });
            return a;
        };
        k.goTo = function(a, b) {
            return W(a) || rg(a) || (a = Ig(a), null !== a) ? kg(this.g, a, b, !1) : Promise.reject(new D("NAVIGATION_ITEM_MISSING_LOCATOR"));
        };
        k.goToStart = function() {
            return kg(this.g, new tk, void 0, !1);
        };
        k.hasActiveTransform = function() {
            return null !== this.C.getActiveTransform();
        };
        k.isAtEnd = function() {
            var a = !1, b, c = null == (b = this.g.ka()) ? void 0 : b.G;
            b = this.g.getVisiblePages();
            c && 0 < b.length && (a = c.isLastPage(b[b.length - 1]));
            return a;
        };
        k.isAtStart = function() {
            var a = !1, b, c = null == (b = this.g.ka()) ? void 0 : b.G;
            b = this.g.getVisiblePages();
            c && 0 < b.length && (a = c.isFirstPage(b[0]));
            return a;
        };
        k.isContentSelectionEnabled = function() {
            return this.g.W.g.get("contentSelectionEnabled");
        };
        k.isDestroyed = function() {
            return this.A;
        };
        k.isNavigating = function() {
            return this.g.isNavigating();
        };
        k.isOffscreenContentRendering = function() {
            return this.g.isOffscreenContentRendering();
        };
        k.Vb = function() {
            return this.g.Vb();
        };
        k.isResponsiveRendererSelectionEnabled = function() {
            return void 0 === this.g.l;
        };
        k.isScriptedContentDocumentEventHandlersEnabled = function() {
            return this.g.W.g.get("contentDocumentEventHandlersEnabled");
        };
        k.isScrolling = function() {
            return this.g.isScrolling();
        };
        k.isVisibleContentRendering = function() {
            return this.g.isVisibleContentRendering();
        };
        k.next = function() {
            return this.g.navigate(x.NavigationAction.NEXT_RENDERABLE_PAGE);
        };
        k.previous = function() {
            return this.g.navigate(x.NavigationAction.PREVIOUS_RENDERABLE_PAGE);
        };
        k.refresh = function(a) {
            a && this.g.Ib.add(1);
            this.g.refresh(a);
        };
        k.removeEngineEventListener = function(a, b) {
            this.o.remove(a, b);
        };
        k.removeRenderer = function(a) {
            this.g.removeRenderer(a);
        };
        k.renderTo = function(a) {
            var b;
            null == (b = this.g.Z) || b.classList.remove("colibrio-readerview--no-user-select", "colibrio-readerview--transform-manager-active");
            b = this.g;
            Vk(b);
            if (a) {
                var c = a.clientHeight, d = a.clientWidth;
                if (!c || !d) throw new D("INVALID_VIEW_OPERATION", "ReaderView.renderTo() called with non-displayed element or it has no dimensions. (width: " + d + "px, height: " + c + "px");
                "static" === window.getComputedStyle(a).position && (a.style.position = "relative");
            }
            b.Z = a;
            Uk(b, !1);
            !b.o && b.Z && b.ra.renderTo(b.Z);
            this.g.W.g.get("contentSelectionEnabled") ? a.classList.remove("colibrio-readerview--no-user-select") : a.classList.add("colibrio-readerview--no-user-select");
            this.hasActiveTransform() ? a.classList.add("colibrio-readerview--transform-manager-active") : a.classList.remove("colibrio-readerview--transform-manager-active");
            bk(this.g);
        };
        k.scrollBy = function(a) {
            return this.g.scrollBy(a);
        };
        k.setActiveRenderer = function(a) {
            this.g.setActiveRenderer(a);
        };
        k.setAllowedGestureTypes = function(a) {
            this.g.setAllowedGestureTypes(a.slice());
            hl(this);
        };
        k.setContentOnActiveRendererMissing = function(a) {
            this.g.setContentOnActiveRendererMissing(a);
        };
        k.setContentOnEmptyPage = function(a) {
            this.g.setContentOnEmptyPage(a);
        };
        k.setContentOnLicenseGracePeriodExpired = function(a) {
            this.g.setContentOnLicenseGracePeriodExpired(a);
        };
        k.setContentOnLoadError = function(a) {
            this.g.setContentOnLoadError(a);
        };
        k.setContentOnLoading = function(a) {
            this.g.setContentOnLoading(a);
        };
        k.setContentSelectionEnabled = function(a) {
            this.g.getOptions().gestureOptions.swipeNavigation.pointerTypes.mouse && p.Logger.logWarning("Enabling content selection while allowing mouse swipe navigation might give unwanted behaviour");
            Lj(this.g.W, "contentSelectionEnabled", a);
            if (a) {
                var b;
                null == (b = this.g.Z) || b.classList.add("colibrio-readerview--no-user-select");
            } else {
                var c;
                null == (c = this.g.Z) || c.classList.remove("colibrio-readerview--no-user-select");
            }
        };
        k.setOptions = function(a) {
            a = y(a, La(this.g.getOptions()), !0);
            a = y(a, ll());
            this.g.setOptions(a);
        };
        k.setReaderDocuments = function(a) {
            a = a.filter(function(b) {
                if (b.isRenderable()) return !0;
                p.Logger.logError(new D("READER_DOCUMENT_NOT_RENDERABLE"), "ReaderDocument not added to ReaderView because the document is not renderable. Index in spine:" + b.getIndexInSpine());
                return !1;
            });
            this.g.setReaderDocuments(a);
        };
        k.setResponsiveRendererSelectionEnabled = function(a) {
            if (a) a = this.g, a.l = void 0, Uk(a, !1);
            else {
                a = this.g;
                var b = this.g.getActiveRenderer();
                a.l = b;
                Uk(a, !1);
            }
        };
        k.setScriptedContentDocumentEventHandlersEnabled = function(a) {
            Lj(this.g.W, "contentDocumentEventHandlersEnabled", a);
        };
        k.setSyncMediaPlayer = function(a, b) {
            if (a && !(a instanceof hg)) throw new D("INVALID_SYNC_MEDIA_PLAYER", "Use ReadingSystemEngine to create the Synchronized Media Player");
            this.I && og(this.I, null);
            if (this.I = a) {
                if (og(this.I, this.g), b === x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_NEXT || b === x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_PREVIOUS) {
                    p.Logger.logWarning("Incompatible initialSyncMethod. Defaulting to READER_VIEW_GOTO");
                    var c;
                    null == (c = this.I) || c.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO, this.I.getTimelinePosition());
                } else if (b === x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO) {
                    var d;
                    null == (d = this.I) || d.attemptReaderViewSynchronization(x.SyncMediaReaderViewSynchronizationMethod.READER_VIEW_GOTO, this.I.getTimelinePosition());
                }
            }
        };
        k.toJSON = function() {
            if (!this.u) {
                var a;
                this.u = (null == (a = this.g.getReadingPosition()) ? void 0 : a.toJSON()) || null;
            }
            if (!this.B) {
                var b;
                this.B = (null == (b = this.g.C) ? void 0 : b.toJSON()) || null;
            }
            this.v || (this.v = this.getVisiblePages().map(function(d) {
                return d.toJSON();
            }));
            var c;
            return {
                activeGestureType: this.g.getActiveGestureType(),
                activeNavigationAction: this.g.getActiveNavigationAction(),
                activeRendererName: (null == (c = this.g.getActiveRenderer()) ? void 0 : c.getName()) || null,
                activeTransform: this.C.getActiveTransform(),
                allowedGestureTypes: this.g.getAllowedGestureTypes().slice(),
                atEnd: this.isAtEnd(),
                atStart: this.isAtStart(),
                canPerformGoTo: this.canPerformGoTo(),
                canPerformNext: this.canPerformNext(),
                canPerformPrevious: this.canPerformPrevious(),
                canTransform: this.C.canTransform(),
                contentSelectionEnabled: this.isContentSelectionEnabled(),
                destroyed: this.isDestroyed(),
                name: this.getName(),
                offscreenContentRendering: this.g.isOffscreenContentRendering(),
                pageProgressionDirection: this.g.getPageProgressionDirection(),
                readingPosition: this.u,
                responsiveRendererSelectionEnabled: this.isResponsiveRendererSelectionEnabled(),
                scriptedContentDocumentEventHandlersEnabled: this.isScriptedContentDocumentEventHandlersEnabled(),
                scrollState: this.g.getScrollState(),
                visibleContentRendering: this.g.isVisibleContentRendering(),
                visiblePages: this.v,
                visibleRange: this.B
            };
        };
        function kl(a, b, c, d) {
            ml(a, 1);
            a.h = new Nh(d, b.N, c, a.g);
            jl(a, "pageProgressionTimelineRecalculated", a.h);
            jl(a, "pageProgressionTimelineVisibleRangeChanged", a.h);
        }
        function jl(a, b, c) {
            a.i.getEventBus().emitAsync(new Gg(b, {
                pageProgressionTimeline: c,
                readerView: a
            }));
        }
        function ml(a, b) {
            a.i.getEventBus().emitAsync(new Hg("pageProgressionTimelineRecalculating", {
                progress: b,
                readerView: a
            }));
        }
        function hl(a) {
            a.H || (a.H = !0, Promise.resolve().then(function() {
                a.H = !1;
                a.i.getEventBus().emit(new X("readerViewStateDataChanged", {
                    readerView: a
                }));
            }).catch(function(b) {
                p.ColibrioError.isColibrioAbortedError(b) || p.Logger.logError(b);
            }));
        }
        function il(a) {
            var b = a.g.getOptions().pageProgressionTimelineOptions, c = a.g.ka();
            if (c) {
                var d = c.N;
                c = !b.forceCompleteRendition && Ei(d);
                !b.enabled || c || a.O || (a.O = !0, c = function(e) {
                    var f = a.g.ka();
                    f && f.N === d && ml(a, e);
                }, c(0), d.fetchNumberOfPagesPerReaderDocument(!b.forceCompleteRendition, c).then(function(e) {
                    var f = a.g.ka();
                    if (f && f.N === d) {
                        a.s = e;
                        var g = a.g.getVisiblePages();
                        0 < g.length && kl(a, f, g, e);
                    }
                }).catch(nl));
            }
        }
        var ol = 1;
        function ll() {
            return {
                constrainEngineEventsToReaderView: !0,
                contentDisplayAreaOptions: {
                    fallbackAspectRatio: .66666666666,
                    type: x.ContentDisplayAreaType.CALCULATED_FROM_PUBLICATION_CONTENT
                },
                defaultPageProgressionDirection: x.ReaderViewPageProgressionDirection.LTR,
                defaultStartPageSpreadSlot: t.PageSpreadSlot.AUTO,
                emitPointerMoveEventsOnHover: !1,
                forcePageProgressionDirection: null,
                gestureOptions: {
                    panZoom: {
                        allowSinglePointerPan: !0,
                        pinchZoomThresholdPx: 32,
                        pointerTypes: {
                            mouse: !1,
                            pen: !1,
                            touch: !0
                        },
                        removeTransformOnZoomOutGesture: !0
                    },
                    swipeNavigation: {
                        pointerDragThresholdPx: 32,
                        pointerTypes: {
                            mouse: !1,
                            pen: !1,
                            touch: !0
                        }
                    }
                },
                name: "view_" + ol++,
                pageContainerOptions: {
                    titleOptions: {
                        scroll: null,
                        singlePage: null,
                        spreadCenter: null,
                        spreadLeft: null,
                        spreadRight: null
                    }
                },
                pageProgressionTimelineOptions: {
                    delayRecalculationUntilPagesVisible: !0,
                    enabled: !0,
                    forceCompleteRendition: !1
                },
                publicationStyleOptions: {
                    defaultFontFamily: "serif",
                    disableCssAnimations: !1,
                    fontSet: null,
                    fontSizeScaleFactor: 1,
                    letterSpacing: null,
                    lineHeightScaleFactor: 1,
                    pageMargins: {
                        bottom: {
                            unit: p.LengthUnit.PERCENT,
                            value: 6
                        },
                        left: {
                            unit: p.LengthUnit.PERCENT,
                            value: 6
                        },
                        right: {
                            unit: p.LengthUnit.PERCENT,
                            value: 6
                        },
                        top: {
                            unit: p.LengthUnit.PERCENT,
                            value: 6
                        }
                    },
                    palette: null,
                    removePublicationDefinedHorizontalPageMargins: !1,
                    textAlignment: null,
                    typographyResetOptions: {
                        removePublicationDefinedFontSizes: !1,
                        removePublicationDefinedLineHeights: !1
                    },
                    wordSpacing: null
                },
                refreshDelayMs: 150,
                rendererTransitionAnimationDurationMs: null,
                rendererTransitionTimeoutMs: 500,
                transformManagerOptions: {
                    maxPanOffsetHorizontal: null,
                    maxPanOffsetVertical: null,
                    maxScaleFactor: null,
                    removeTransformAnimationDurationMs: 300,
                    removeTransformOnNavigation: !0
                }
            };
        }
        function nl(a) {
            p.ColibrioError.isColibrioAbortedError(a) || p.Logger.logError(a);
        }
        function pl(a) {
            this.h = null;
            this.A = !1;
            this.o = new Sc;
            this.cb = new Pc(this);
            this.u = [];
            this.s = new Sc;
            this.B = new jd;
            this.j = [];
            this.l = [];
            this.i = [];
            this.g = y(a, ql());
            if (!Ha(this.g.licenseApiKey) || !this.g.licenseApiKey || 64 < this.g.licenseApiKey.length) throw new D("INVALID_CLOUD_LICENSE_OPTIONS", "Missing or invalid licenseApiKey");
            if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(this.g.licenseApiKey)) throw new D("INVALID_CLOUD_LICENSE_OPTIONS", "LicenseApiKey should be a v4 UUID");
            var b;
            if (null == (b = this.g.platformWorkaroundOptions) ? 0 : b.prepareSyncMediaAudioElementsOnFirstUserInteraction) this.v = new kd(!0);
            a = window.location.hostname;
            if (!(a && !sc().includes(a) || Ha(this.g.licenseApiNativeAppSecret) && this.g.licenseApiNativeAppSecret)) throw new D("INVALID_CLOUD_LICENSE_OPTIONS", "Missing or invalid licenseApiNativeAppSecret");
            this.h = new Jc(this, this.g.licenseApiKey, this.g.licenseApiNativeAppSecret);
        }
        k = pl.prototype;
        k.getFrameworkVersion = function() {
            return rl();
        };
        k.addEngineEventListener = function(a, b) {
            if (this.A) throw new D("READING_SYSTEM_ENGINE_IN_DESTROYED_STATE");
            this.o.add(a, b);
        };
        k.addFormatAdapter = function(a) {
            if (this.A) throw new D("READING_SYSTEM_ENGINE_IN_DESTROYED_STATE");
            this.u.push(a);
        };
        k.createReaderView = function(a) {
            if (this.A) throw new D("READING_SYSTEM_ENGINE_IN_DESTROYED_STATE");
            a = new gl(this, this.h, a);
            this.l.push(a);
            return a;
        };
        k.createSyncMediaPlayer = function(a, b) {
            if (this.A) throw new D("READING_SYSTEM_ENGINE_IN_DESTROYED_STATE");
            a = new hg(this, a, this.h, b);
            this.i.push(a);
            return a;
        };
        k.destroy = function() {
            var a = this;
            this.A || (this.A = !0, this.i.forEach(function(b) {
                return b.destroy();
            }), this.i = [], this.l.forEach(function(b) {
                return b.destroy();
            }), this.l = [], this.j.forEach(function(b) {
                a.unloadPublication(b);
            }), this.getReaderPublications().forEach(function(b) {
                b.destroy();
                a.h && Lc(a.h, b);
            }), this.B.h(), this.h && Kc(this.h), this.u = [], this.o.clear(), this.s.clear());
        };
        k.destroyReaderView = function(a) {
            if (a.getReadingSystemEngine() !== this || !(a instanceof gl)) throw new D("INVALID_READER_VIEW", "ReaderView was not created with this ReadingSystemEngine");
            this.l = this.l.filter(function(b) {
                return b !== a;
            });
            a.destroy();
        };
        k.destroySyncMediaPlayer = function(a) {
            if (a.getReadingSystemEngine() !== this || !(a instanceof hg)) throw new D("INVALID_SYNC_MEDIA_PLAYER", "SyncMediaPlayer was not created with this ReadingSystemEngine");
            this.i = this.i.filter(function(b) {
                return b !== a;
            });
            a.destroy();
        };
        k.getEngineEventListeners = function(a) {
            return this.o.get(a);
        };
        k.getEventBus = function() {
            return this.cb;
        };
        k.getOptions = function() {
            return La(this.g);
        };
        k.getReaderDocumentSearch = function() {
            return this.B;
        };
        k.getReaderPublications = function() {
            return this.j.slice();
        };
        k.getReaderViewByName = function(a) {
            return this.getReaderViews().find(function(b) {
                return b.getName() === a;
            }) || null;
        };
        k.getReaderViews = function() {
            return this.l.slice();
        };
        k.getSyncMediaPlayerByName = function(a) {
            return this.i.find(function(b) {
                return b.getName() === a;
            }) || null;
        };
        k.getSyncMediaPlayers = function() {
            return this.i.slice();
        };
        k.isDestroyed = function() {
            return this.A;
        };
        k.loadPublication = function(a, b, c) {
            var d = this;
            if (this.A) throw new D("READING_SYSTEM_ENGINE_IN_DESTROYED_STATE");
            if (a.isDestroyed()) throw new D("PUBLICATION_IN_DESTROYED_STATE");
            var e = this.u.find(function(f) {
                return f.isPublicationSupported(a, d);
            });
            if (!e) return Promise.reject(new D("FORMAT_ADAPTER_MISSING", 'format="' + a.getType() + '"'));
            if (!Oa(c)) throw new D("INVALID_CLOUD_LICENSE_OPTIONS", "Missing licenseOptions in loadPublication()");
            if (!Ha(c.userToken) || !c.userToken || 128 < c.userToken.length) throw new D("INVALID_CLOUD_LICENSE_OPTIONS", "Missing or too long licenseOptions.userToken");
            if (c.publicationToken && (!Ha(c.publicationToken) || 128 < c.publicationToken.length)) throw new D("INVALID_CLOUD_LICENSE_OPTIONS", "Missing or too long licenseOptions.publicationToken");
            c = La(c);
            return e.createReaderPublication(a, this, b, c).then(function(f) {
                if (d.A) throw f.destroy(), new D("READING_SYSTEM_ENGINE_IN_DESTROYED_STATE");
                if (sl(d, a, f)) return f.destroy(), Promise.reject(new D("PUBLICATION_ALREADY_LOADED"));
                d.j.push(f);
                if (d.h && c) {
                    var g = d.h, h = a.getHashSignature(), l = a.getType(), r = c.userToken, q = c.publicationToken, v = window, u = v[K(Ob)], w = u[K(Tb)];
                    u = u[K(Eb)];
                    w += u;
                    w = w === K(xb) || w === K(Fb);
                    u = !!v[K(vb)];
                    var E, z, N = !!(null == (E = v[K(ic)]) ? 0 : null == (z = E[K(Qb)]) ? 0 : z[K(Ab)]);
                    v = !0 === v[K(sb)];
                    w && (u || N) && v ? Mc(g) : (h = new uc(g.j, r, h, l, g.s, q), h.s.add(g.o), g.i.set(f, h));
                }
                return f;
            });
        };
        k.removeEngineEventListener = function(a, b) {
            this.o.remove(a, b);
        };
        k.setOptions = function(a) {
            var b = this.g.licenseApiKey, c = this.g.licenseApiNativeAppSecret;
            a = y(a, this.g, !0);
            this.g = y(a, ql());
            if (this.g.licenseApiKey !== b || this.g.licenseApiNativeAppSecret !== c) throw this.g.licenseApiKey = b, this.g.licenseApiNativeAppSecret = c, new D("INVALID_CLOUD_LICENSE_OPTIONS", "licenceApiKey and licenseApiNativeAppSecret can not be changed with ReadingSystemEngine.setOptions()");
        };
        k.unloadPublication = function(a) {
            if (a.getReadingSystemEngine() !== this) throw new D("INVALID_READER_PUBLICATION", "ReaderPublication was not created with this ReadingSystemEngine");
            this.l.some(function(b) {
                return b.getReaderPublications().includes(a);
            }) && p.Logger.logError(new D("READER_PUBLICATION_IN_USE", "ReaderPublication is still in use by a ReaderView"));
            this.i.some(function(b) {
                return b.getTimeline().getReaderPublication() === a;
            }) && p.Logger.logError(new D("READER_PUBLICATION_IN_USE", "ReaderPublication is still in use by a SyncMediaPlayer"));
            this.j.includes(a) && (this.j = this.j.filter(function(b) {
                return b !== a;
            }), this.h && Lc(this.h, a), a.isDestroyed() || a.destroy());
        };
        function sl(a, b, c) {
            return a.j.some(function(d) {
                var e = d.getSourcePublication();
                return b === e || b.getHashSignature() === e.getHashSignature() || c.getDefaultLocatorUrl() === d.getDefaultLocatorUrl();
            });
        }
        function rl() {
            return "4.7.0";
        }
        pl.getFrameworkVersion = rl;
        function ql() {
            return {
                licenseApiKey: "",
                licenseApiNativeAppSecret: "",
                platformWorkaroundOptions: {
                    escapeXmlInTtsUtterancesOnSafari26: !0,
                    firefoxCspConnectDomains: [],
                    prepareSyncMediaAudioElementsOnFirstUserInteraction: !1,
                    useTouchEventsOnIos: !1
                }
            };
        }
        function tl(a, b) {
            var c = this;
            this.g = function() {
                var d = c.j.getReaderViews().some(function(e) {
                    return c.i.pauseOnOffscreenContentRendering && e.isOffscreenContentRendering() || c.i.pauseOnReaderViewGesture && null !== e.getActiveGestureType() || c.i.pauseOnReaderViewNavigation && e.isNavigating() || c.i.pauseOnVisibleContentRendering && e.isVisibleContentRendering() ? !0 : !1;
                });
                d && !c.h.isPaused() ? c.h.pause() : !d && c.h.isPaused() && c.h.resume();
            };
            this.j = a;
            this.i = La(b);
            this.h = new p.AsyncTaskQueue(b.concurrency, null);
            this.h.setOnBeforeExecuteNextTask(this.g);
            a = this.j.s;
            b.pauseOnOffscreenContentRendering && (a.add("offscreenContentRendering", this.g), a.add("offscreenContentRendered", this.g));
            b.pauseOnReaderViewGesture && a.add("activeGestureTypeChanged", this.g);
            b.pauseOnReaderViewNavigation && (a.add("navigationStarted", this.g), a.add("navigationEnded", this.g));
            b.pauseOnVisibleContentRendering && (a.add("visibleContentRendering", this.g), a.add("visibleContentRendered", this.g));
            this.g();
        }
        tl.prototype.destroy = function() {
            var a = this.j.s;
            this.i.pauseOnOffscreenContentRendering && (a.remove("offscreenContentRendering", this.g), a.remove("offscreenContentRendered", this.g));
            this.i.pauseOnReaderViewGesture && a.remove("activeGestureTypeChanged", this.g);
            this.i.pauseOnReaderViewNavigation && (a.remove("navigationStarted", this.g), a.remove("navigationEnded", this.g));
            this.i.pauseOnVisibleContentRendering && (a.remove("visibleContentRendering", this.g), a.remove("visibleContentRendered", this.g));
            this.h.destroy(new D(p.ColibrioErrorType.ABORTED));
        };
        tl.prototype.isDestroyed = function() {
            return this.h.isDestroyed();
        };
        tl.prototype.isPaused = function() {
            return this.h.isPaused();
        };
        tl.prototype.scheduleTask = function(a, b) {
            return this.h.scheduleTask(a, b);
        };
        function ul(a) {
            G.call(this, "contentPositionTimelineCreateProgress", a);
        }
        m.inherits(ul, G);
        ul.prototype.toJSON = function() {
            var a = {
                done: this.m.done,
                objectType: x.EngineEventDataObjectType.CONTENT_POSITION_TIMELINE_CREATE_PROGRESS_ENGINE_EVENT,
                progress: this.m.progress,
                timelineName: this.m.timelineName
            };
            return Object.assign(G.prototype.toJSON.call(this), a);
        };
        m.global.Object.defineProperties(ul.prototype, {
            done: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.done;
                }
            },
            progress: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.progress;
                }
            },
            timelineName: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.timelineName;
                }
            }
        });
        function vl(a) {
            a || (a = "ContentPositionTimeline_" + wl, wl++);
            return a;
        }
        function xl(a, b, c, d) {
            try {
                null == c || c(d);
            } catch (e) {
                p.Logger.logError(e);
            }
            b = new ul({
                done: 1 === d,
                progress: d,
                readerView: null,
                timelineName: b
            });
            a.getReadingSystemEngine().getEventBus().emitAsync(b);
        }
        function yl(a, b) {
            if ("1" === a) {
                b = m.ya(b.split(":"));
                var c = b.next().value;
                a = b.next().value;
                b = b.next().value;
                c = c.split(",").map(function(d) {
                    return parseInt(d);
                });
                a = a.split(",").map(function(d) {
                    return parseInt(d);
                });
                return c.every(function(d) {
                    return C(d);
                }) && a.every(function(d) {
                    return C(d);
                }) ? [
                    c,
                    a,
                    b
                ] : null;
            }
            return null;
        }
        function zl(a) {
            var b = new ta.Sha1;
            b.append(a);
            return b.digestToHex();
        }
        var wl = 1;
        function Al(a, b) {
            this.j = a;
            this.g = b;
            this.h = null;
            this.i = b[0].getReaderPublication();
        }
        k = Al.prototype;
        k.fetchContentLocation = function(a) {
            a = Ka(a, 0, this.g.length);
            return a === this.g.length ? Bl(this) : Promise.resolve(this.g[a].getContentLocation());
        };
        k.fetchContentLocationAsRange = function(a, b) {
            var c = this, d, e, f, g, h, l, r;
            return m.ea(function(q) {
                if (1 == q.g) {
                    a = Ka(a, 0, c.g.length);
                    C(b) || (b = a + 1);
                    b = Ka(b, a, c.g.length);
                    if (a === c.g.length) return q.return(Bl(c));
                    if (a === b) return q.return(c.g[a].getContentLocation());
                    if (1 === b - a) return q.return(c.g[a].fetchContentLocationForEntireDocument());
                    d = m;
                    e = d.ya;
                    return n(q, Promise.all([
                        c.g[a].getContentLocation(),
                        b < c.g.length ? c.g[b].fetchContentLocationForEntireDocument() : Bl(c)
                    ]), 2);
                }
                f = e.call(d, q.h);
                g = f.next().value;
                h = f.next().value;
                l = g;
                r = h;
                return q.return(l.createRangeTo(r));
            });
        };
        k.fetchTimelinePosition = function(a) {
            var b = this, c, d;
            return m.ea(function(e) {
                if (1 == e.g) return rg(a) || W(a) ? e.J(2) : n(e, b.i.fetchUnresolvedContentLocation(a), 3);
                2 != e.g && (a = e.h);
                c = a.getReaderDocuments()[0];
                d = c.getIndexInSpine();
                return e.return(Cl(b, d));
            });
        };
        k.fetchTimelinePositions = function(a) {
            var b = this, c, d, e;
            return m.ea(function(f) {
                if (1 == f.g) return c = a.map(function(g) {
                    var h;
                    return m.ea(function(l) {
                        if (1 == l.g) return rg(g) || W(g) ? l.J(2) : n(l, b.i.fetchUnresolvedContentLocation(g), 3);
                        2 != l.g && (g = l.h);
                        return (h = g.getReaderDocuments()[0]) ? l.return(h) : l.return(Promise.reject());
                    });
                }), n(f, Promise.allSettled(c), 2);
                d = f.h;
                e = {};
                return f.return(d.map(function(g) {
                    if ("fulfilled" === g.status) {
                        g = g.value.getIndexInSpine();
                        if (e[g]) return e[g];
                        var h = {
                            status: "fulfilled",
                            value: Cl(b, g)
                        };
                        return e[g] = h;
                    }
                    return g;
                }));
            });
        };
        k.fetchTimelineRange = function(a) {
            var b = this, c, d, e, f, g;
            return m.ea(function(h) {
                switch(h.g){
                    case 1:
                        if (rg(a) || W(a)) {
                            h.J(2);
                            break;
                        }
                        return n(h, b.i.fetchUnresolvedContentLocation(a), 3);
                    case 3:
                        a = h.h;
                    case 2:
                        if (Ca(a.getReaderDocuments()).getIndexInSpine() < b.g[0].getIndexInSpine()) return h.return({
                            end: 0,
                            start: 0
                        });
                        if (a.isRange()) {
                            if (!W(a)) {
                                h.J(7);
                                break;
                            }
                            return n(h, a.resolve(), 8);
                        }
                        return n(h, b.fetchTimelinePosition(a), 6);
                    case 6:
                        c = d = h.h;
                        h.J(5);
                        break;
                    case 8:
                        a = h.h;
                    case 7:
                        return e = m, f = e.ya, n(h, Promise.all([
                            b.fetchTimelinePosition(a.collapseToStart()),
                            b.fetchTimelinePosition(a.collapseToEnd())
                        ]), 9);
                    case 9:
                        g = f.call(e, h.h), c = g.next().value, d = g.next().value;
                    case 5:
                        return h.return({
                            end: Ka(d + 1, c, b.g.length),
                            start: c
                        });
                }
            });
        };
        k.getLength = function() {
            return this.g.length;
        };
        k.getReaderDocuments = function() {
            return this.g.slice();
        };
        k.getUnit = function() {
            return this.j;
        };
        k.intersectsContentLocation = function(a) {
            var b = this;
            return a.getReaderDocuments().some(function(c) {
                return b.g.includes(c);
            });
        };
        k.toSerializedData = function() {
            return "";
        };
        function Bl(a) {
            a.h || (a.h = Ca(a.g).fetchContentLocationForEntireDocument().then(function(b) {
                return b.collapseToEnd();
            }).catch(function(b) {
                a.h = null;
                throw b;
            }));
            return a.h;
        }
        function Cl(a, b) {
            return Aa(a.g, 2, a.g.length, function(c, d) {
                return b - c[d].getIndexInSpine();
            });
        }
        function Dl(a) {
            G.call(this, "navigationIntent", a);
            this.g = null;
        }
        m.inherits(Dl, X);
        Dl.prototype.toJSON = function() {
            var a = X.prototype.toJSON.call(this), b = this.readerDocument;
            b = {
                internalNavigation: this.internalNavigation,
                locator: this.locator.toJSON(),
                objectType: x.EngineEventDataObjectType.NAVIGATION_INTENT_ENGINE_EVENT,
                readerDocumentIndexInSpine: b && b.getIndexInSpine(),
                relatedEvent: this.relatedEvent && this.relatedEvent.toJSON(),
                sourceReaderDocumentIndexInSpine: this.sourceReaderDocument && this.sourceReaderDocument.getIndexInSpine()
            };
            return Object.assign(a, b);
        };
        m.global.Object.defineProperties(Dl.prototype, {
            internalNavigation: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    if (null === this.g) {
                        var a = this.readerDocument;
                        this.g = null !== a && this.readerView.getReaderDocuments().includes(a);
                    }
                    return this.g;
                }
            },
            locator: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.locator;
                }
            },
            readerDocument: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerDocument;
                }
            },
            relatedEvent: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.relatedEvent;
                }
            },
            sourceReaderDocument: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.sourceReaderDocument;
                }
            }
        });
        function El(a) {
            G.call(this, "publicationStorageChanged", a);
        }
        m.inherits(El, G);
        El.prototype.toJSON = function() {
            var a = {
                key: this.m.key,
                newValue: this.m.newValue,
                objectType: x.EngineEventDataObjectType.PUBLICATION_STORAGE_CHANGED_ENGINE_EVENT,
                oldValue: this.m.oldValue,
                readerDocumentIndexInSpine: this.m.readerDocumentIndexInSpine,
                readerPublicationDefaultLocatorUrl: this.m.readerPublication.getDefaultLocatorUrl(),
                storageAreaType: this.m.storageAreaType
            };
            return Object.assign(G.prototype.toJSON.call(this), a);
        };
        m.global.Object.defineProperties(El.prototype, {
            key: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.key;
                }
            },
            newValue: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.newValue;
                }
            },
            oldValue: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.oldValue;
                }
            },
            readerDocumentIndexInSpine: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerDocumentIndexInSpine;
                }
            },
            readerPublication: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.readerPublication;
                }
            },
            storageAreaType: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.storageAreaType;
                }
            }
        });
        function Fl(a) {
            G.call(this, "syncMediaTimelineCreateProgress", a);
        }
        m.inherits(Fl, G);
        Fl.prototype.toJSON = function() {
            var a = {
                done: this.m.done,
                objectType: x.EngineEventDataObjectType.SYNC_MEDIA_TIMELINE_CREATE_PROGRESS_ENGINE_EVENT,
                progress: this.m.progress,
                timelineName: this.m.timelineName
            };
            return Object.assign(G.prototype.toJSON.call(this), a);
        };
        m.global.Object.defineProperties(Fl.prototype, {
            done: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.done;
                }
            },
            progress: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.progress;
                }
            },
            timelineName: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.m.timelineName;
                }
            }
        });
        function Gl(a) {
            this.g = a;
        }
        function Hl(a) {
            var b = [];
            a.split(",").forEach(function(c) {
                if (!(4 > c.length)) {
                    var d = c[0];
                    switch(d){
                        case "A":
                        case "D":
                            var e = 2;
                            break;
                        case "R":
                            e = 3;
                            break;
                        default:
                            return;
                    }
                    c = c.slice(1).split(":").map(function(f) {
                        return f ? Number(f) : NaN;
                    });
                    c.length === e && c.every(function(f) {
                        return C(f) && 0 <= f;
                    }) && ("R" === d ? b.push({
                        xb: c[2] | 0,
                        yb: c[1] | 0,
                        K: c[0] | 0,
                        da: "R"
                    }) : b.push({
                        Ja: c[1] | 0,
                        K: c[0] | 0,
                        da: d
                    }));
                }
            });
            return new Gl(b);
        }
        function Il(a, b) {
            for(var c = a.g.length - 1; 0 <= c; c--){
                var d = a.g[c], e = d.K;
                "A" === d.da ? b > e + d.Ja ? b -= d.Ja : b > e && (b = e) : "D" === d.da ? b >= e && (b += d.Ja) : "R" === d.da && (b >= e + d.xb ? b += d.yb - d.xb : b > e && (b = e));
            }
            return b;
        }
        function Jl(a, b) {
            this.g = a;
            this.j = b;
            this.u = this.i = this.l = this.s = this.h = this.o = this.Za = null;
        }
        Jl.prototype.destroy = function() {
            this.u = this.s = null;
            Kl(this);
            Ll(this);
            this.g = null;
        };
        function Ml(a, b, c) {
            a.o && a.Za && a.l && (b = Il(a.o, b), a.u = a.Za.getContentLocation(b + a.l.startOffset, Il(a.o, c) - b), Ll(a));
        }
        function Nl(a, b) {
            a.Za = null;
            a.o = null;
            a.l = null;
            a.u = null;
            a.s = null;
            var c;
            b.Za && (null == (c = b.xa) ? 0 : c.sources) && (c = Ba(b.xa.sources)) && (a.l = c, a.o = Hl(c.srcMap), a.Za = b.Za, a.s = a.Za.getContentLocation(a.l.startOffset, a.l.endOffset - a.l.startOffset));
            Kl(a);
            Ll(a);
        }
        Jl.prototype.setOptions = function(a) {
            !a.wordHighlightEnabled && this.g && this.i && (this.g.destroyAnnotation(this.i), this.i = null);
            !a.segmentHighlightEnabled && this.g && this.h && (this.g.destroyAnnotation(this.h), this.h = null);
            this.j = a;
            this.i && a.wordHighlightAnnotationOptions && this.i.setOptions(a.wordHighlightAnnotationOptions);
            this.h && a.segmentHighlightAnnotationOptions && this.h.setOptions(a.segmentHighlightAnnotationOptions);
        };
        function Kl(a) {
            a.g && (a.h && (a.g.destroyAnnotation(a.h), a.h = null), !a.g.isDestroyed() && a.s && a.j.segmentHighlightEnabled && (a.h = a.g.createAnnotation(a.s), a.j.segmentHighlightAnnotationOptions && a.h.setOptions(a.j.segmentHighlightAnnotationOptions)));
        }
        function Ll(a) {
            a.g && (a.i && (a.g.destroyAnnotation(a.i), a.i = null), !a.g.isDestroyed() && a.u && a.j.wordHighlightEnabled && (a.i = a.g.createAnnotation(a.u), a.j.wordHighlightAnnotationOptions && a.i.setOptions(a.j.wordHighlightAnnotationOptions)));
        }
        function Ol(a, b) {
            this.l = b;
            this.i = new Map;
            this.A = !1;
            this.g = new Map;
            this.h = new Map;
            this.j = a.getSegments();
            this.o = a.getReaderPublication().getSpine();
        }
        Ol.prototype.destroy = function() {
            this.A || (this.A = !0, this.i.clear(), this.g.clear(), this.h.clear());
        };
        function Pl(a, b, c) {
            return (c = Ql(a, b, c, !0)) ? Promise.resolve(c) : a.g.get(b) || Promise.reject(new D("INVALID_SYNC_MEDIA_SEGMENT_INDEX", "SyncMediaTtsRuntimeSegmentCache - Bad segmentIndex: " + b));
        }
        function Ql(a, b, c, d) {
            if (d && !a.A) {
                d = m.ya(qd(a.j, a.l, b, c));
                c = d.next().value;
                d = d.next().value;
                for(var e = c; e < d; e++)Rl(a, e);
                Sl(a, c, d);
            }
            return a.h.get(b) || null;
        }
        function Rl(a, b) {
            if (!a.h.has(b) && !a.g.has(b)) {
                var c = a.j[b], d = c.getMediaObjectRefs().find(Tl);
                if (d) {
                    c = c.getReaderDocumentIndexInSpine();
                    var e = a.i.get(c);
                    e || (e = a.o[c].fetchContentBlockTree(), a.i.set(c, e));
                    var f = e.then(function(g) {
                        var h = Ba(d.sources);
                        g = h ? g.getContentBlockById(h.contentBlockId) : null;
                        h = h && g ? g.getCommonAncestorContainer(h.startOffset, h.endOffset - h.startOffset) : null;
                        h = x.EngineEventTargetNodeUtils.createEventTargetXmlElementNodeData(h);
                        g = {
                            Za: g,
                            ad: h,
                            U: b,
                            xa: d
                        };
                        a.g.has(b) && !a.A && (a.g.delete(b), a.h.set(b, g));
                        return g;
                    }).catch(function(g) {
                        p.ColibrioError.isColibrioAbortedError(g) || p.Logger.logError(g);
                        a.g.get(b) !== f || a.A || a.g.delete(b);
                        return Promise.reject(g);
                    });
                    a.g.set(b, f);
                } else a.h.set(b, {
                    Za: null,
                    ad: null,
                    U: b,
                    xa: null
                });
            }
        }
        function Sl(a, b, c) {
            a.h.forEach(function(d, e) {
                (e < b || e >= c) && a.h.delete(e);
            });
            a.g.forEach(function(d, e) {
                (e < b || e >= c) && a.g.delete(e);
            });
        }
        function Tl(a) {
            return a.type === x.SyncMediaObjectRefType.TTS_CONTENT_BLOCK;
        }
        function Ul(a, b, c, d, e, f) {
            this.F = a;
            this.G = b;
            this.h = c;
            this.D = f;
            this.j = this.s = 0;
            this.A = !1;
            this.H = -1;
            this.M = !0;
            this.B = 0;
            this.g = null;
            this.C = new Map;
            this.v = null;
            this.i = !0;
            this.L = !1;
            this.u = new Map;
            this.O = !1;
            this.o = new Ol(a, e);
            this.l = new Jl(d, f);
            this.h.init(this);
        }
        function Vl(a, b) {
            var c = 0;
            if (0 < a) for(c = Math.min(Math.round(a / 82.53094910591471), b.length); 0 < c;){
                if (/\s/.test(b[c])) {
                    c++;
                    break;
                }
                c--;
            }
            return c;
        }
        function Wl(a, b) {
            for(; a < b.length && !/\s/.test(b[a]);)a++;
            return a;
        }
        k = Ul.prototype;
        k.clearRangeEndPosition = function() {
            var a = this;
            this.g = null;
            Xl(this);
            Yl(this, !0);
            var b = ++this.B;
            Pl(this.o, this.j, this.s).then(function(c) {
                b !== a.B || a.A || (Nl(a.l, c), Zl(a, c, a.s), Yl(a, !1));
            }).catch(function(c) {
                a.G.onSegmentError(a.j, x.SyncMediaPlayerErrorType.MEDIA_LOAD_ERROR, c, !0);
            });
        };
        k.destroy = function() {
            this.pause();
            this.h.destroy();
            this.u.clear();
            this.C.clear();
            this.A = !0;
            this.o.destroy();
            this.l.destroy();
        };
        k.getSegmentTargets = function() {
            return [];
        };
        function $l(a) {
            if (a.L || a.O) a.G.onRuntimeWaiting();
            else a.G.onRuntimeReady();
        }
        k.onTtsSynthesizerReady = function() {
            this.L = !1;
            $l(this);
        };
        k.onTtsSynthesizerWaiting = function() {
            this.L = !0;
            $l(this);
        };
        k.onUtteranceBoundary = function(a, b, c) {
            a = this.u.get(a);
            if (!this.A && this.j === a) {
                var d = 82.53094910591471 * b;
                this.G.onPlaybackPositionUpdated(a, d);
                if (this.l && this.v && this.v.xa && this.D.wordHighlightEnabled) {
                    if (null === c) {
                        var e = this.v.xa.text.value, f;
                        c = (null == (f = this.g) ? void 0 : f.gb) == a ? Math.min(Wl(b, e), this.g.uc) : Wl(b, e);
                    } else c = b + c;
                    this.s = 82.53094910591471 * c;
                    Ml(this.l, b, c);
                }
                Ql(this.o, a, d, !0);
                am(this, a);
            }
        };
        k.onUtteranceEnd = function(a) {
            var b = this.u.get(a);
            if (!this.A && C(b)) {
                this.u.delete(a);
                this.C.delete(b);
                this.H = b;
                var c;
                if ((null == (c = this.g) ? void 0 : c.gb) === b) this.pause(), this.G.onRangeEndReached(this.g.Xb);
                else if (this.j === b) this.G.onActiveSegmentFinished(b);
            }
        };
        k.onUtteranceError = function(a, b) {
            var c = this.u.get(a);
            !this.A && C(c) && (this.u.delete(a), this.C.delete(c), this.pause(), this.G.onSegmentError(c, x.SyncMediaPlayerErrorType.UNKNOWN_ERROR, b, !0));
        };
        k.onUtterancePaused = function(a) {
            a = this.u.get(a);
            !this.A && C(a) && (this.i = this.M = !0, this.G.onRuntimePaused());
        };
        k.pause = function() {
            this.M = !0;
            this.i || (this.i = !0, this.h.pause());
        };
        k.play = function() {
            this.M = !1;
            if (!this.A) {
                if (this.v) this.i && (this.i = !1, this.h.play());
                else this.G.onActiveSegmentFinished(this.j);
            }
        };
        k.playUntilRangeEnd = function(a, b) {
            var c = this;
            if (this.g && this.g.Xb === b && this.v && this.i) this.i = !1, this.h.play();
            else {
                this.g = {
                    uc: Math.round(a.getOffsetWithinSegmentMs() / 82.53094910591471),
                    gb: a.getSegmentIndex(),
                    Xb: b
                };
                Xl(this);
                var d = ++this.B;
                this.M = !1;
                Pl(this.o, this.j, this.s).then(function(e) {
                    d !== c.B || c.A || (Nl(c.l, e), Zl(c, e, c.s, !1), Yl(c, !1));
                }).catch(function(e) {
                    c.G.onSegmentError(c.j, x.SyncMediaPlayerErrorType.MEDIA_LOAD_ERROR, e, !0);
                });
            }
        };
        k.seekToTimelinePosition = function(a) {
            var b = this;
            Xl(this);
            Yl(this, !0);
            var c = this.j = a.getSegmentIndex(), d = this.s = a.getOffsetWithinSegmentMs(), e = ++this.B;
            c >= this.F.getSegments().length ? Yl(this, !1) : Pl(this.o, c, d).then(function(f) {
                e !== b.B || b.A || (bm(b, f, d), Zl(b, f, d), Yl(b, !1));
            }).catch(function(f) {
                b.G.onSegmentError(c, x.SyncMediaPlayerErrorType.MEDIA_LOAD_ERROR, f, !0);
            });
        };
        k.setActiveSegmentIndex = function(a) {
            var b = Ql(this.o, a, 0, !0);
            b && bm(this, b);
            this.j = a;
            this.s = 0;
            if (this.H >= a) this.G.onActiveSegmentFinished(a);
            else b ? Zl(this, b, this.s) : this.seekToTimelinePosition(new M(this.F, a, this.s));
        };
        k.setMuted = function(a) {
            this.h.setMuted(a);
        };
        k.setOptions = function(a) {
            this.D = a;
            this.l.setOptions(a);
        };
        k.setPlaybackRate = function(a) {
            this.h.setPlaybackRate(a);
        };
        k.setTtsHighlightLayer = function(a) {
            var b = this.l;
            b.g && !b.g.isDestroyed() && (b.h && b.g.destroyAnnotation(b.h), b.i && b.g.destroyAnnotation(b.i));
            b.i = null;
            b.h = null;
            b.g = a;
            Kl(b);
            Ll(b);
            (a = Ql(this.o, this.j, 0, !1)) && bm(this, a);
        };
        k.setVolume = function(a) {
            this.h.setVolume(a);
        };
        k.willCallPlaybackPositionUpdated = function(a) {
            a = Ql(this.o, a, 0, !1);
            return null !== a && null !== a.xa;
        };
        function am(a, b) {
            for(var c = a.F.getSegments().length; b < c; b++){
                var d = Ql(a.o, b, 0, !1);
                if (d && d.xa) cm(a, d, d.xa.text, 0);
                else break;
            }
        }
        function Zl(a, b, c, d) {
            d = void 0 === d ? !0 : d;
            var e = b.U;
            if (b.xa) {
                var f = b.xa.text.value;
                cm(a, b, b.xa.text, d ? Vl(c, f) : Math.round(c / 82.53094910591471));
                a.v = b;
                !a.M && a.i && (a.i = !1, a.h.play());
            } else if (a.v = null, a.i || (a.i = !0, a.h.pause()), !a.M) a.G.onActiveSegmentFinished(b.U);
            am(a, e + 1);
        }
        function cm(a, b, c, d) {
            if (!a.C.has(b.U)) {
                var e = c, f;
                (null == (f = a.g) ? void 0 : f.gb) === b.U && (e = {
                    dir: c.dir,
                    lang: c.lang,
                    value: c.value.substring(0, a.g.uc)
                });
                var g;
                c = {
                    charOffset: (null == (g = a.g) ? void 0 : g.gb) === b.U ? Math.min(d, a.g.uc) : d,
                    id: dm++,
                    nodeData: b.ad,
                    segmentIndex: b.U,
                    text: e
                };
                a.C.set(b.U, b);
                a.u.set(c.id, b.U);
                a.h.addUtterance(c);
            }
        }
        function Xl(a) {
            a.M = !0;
            a.i = !0;
            a.h.clearAndPause();
            a.C.clear();
            a.u.clear();
            a.v = null;
            a.H = -1;
        }
        function bm(a, b, c) {
            Nl(a.l, b);
            var d;
            b = null == (d = b.xa) ? void 0 : d.text.value;
            a.D.highlightFirstWordOnSegmentActive && b && (c = Vl(null != c ? c : 0, b), Ml(a.l, c, Wl(c, b)));
        }
        function Yl(a, b) {
            a.O = b;
            $l(a);
        }
        var dm = 1;
        function em(a, b, c) {
            this.j = a;
            this.i = b;
            this.h = [];
            this.g = y(c, fm());
        }
        function fm() {
            return {
                highlightFirstWordOnSegmentActive: !1,
                segmentHighlightAnnotationOptions: null,
                segmentHighlightEnabled: !0,
                wordHighlightAnnotationOptions: null,
                wordHighlightEnabled: !1
            };
        }
        k = em.prototype;
        k.createRuntime = function(a, b, c) {
            a = new Ul(a, b, this.j, this.i, c, this.g);
            this.h.push(a);
            return a;
        };
        k.destroyRuntime = function(a) {
            var b = this.h.indexOf(a);
            -1 !== b && (a.destroy(), this.h.splice(b, 1));
        };
        k.getOptions = function() {
            return La(this.g);
        };
        k.getSupportedMediaObjectRefType = function() {
            return x.SyncMediaObjectRefType.TTS_CONTENT_BLOCK;
        };
        k.getTtsHighlightLayer = function() {
            return this.i;
        };
        k.setOptions = function(a) {
            var b = this;
            a = y(a, this.g, !0);
            this.g = y(a, fm());
            this.h.forEach(function(c) {
                return c.setOptions(b.g);
            });
        };
        k.setTtsHighlightLayer = function(a) {
            this.i = a;
            this.h.forEach(function(b) {
                return b.setTtsHighlightLayer(a);
            });
        };
        function gm(a) {
            var b = this;
            this.i = a;
            this.g = [];
            this.h = a.getSegments();
            var c = 0;
            this.h.forEach(function(d, e) {
                0 === e % 16 && b.g.push(c);
                c += d.getApproximateDurationMs();
            });
        }
        gm.prototype._onSegmentDurationChanged = function(a) {
            var b = a.segmentIndex;
            if (!(b >= this.h.length)) for(a = a.newDurationMs - a.oldDurationMs, b = (b / 16 | 0) + 1; b < this.g.length; b++)this.g[b] += a;
        };
        gm.prototype.getApproximateElapsedTimeMsForTimelinePosition = function(a) {
            if (a.getTimeline() !== this.i) throw new D("INVALID_SYNC_MEDIA_TIMELINE_POSITION", "Position is from a different timeline");
            if (0 === this.h.length) return 0;
            var b = a.getSegmentIndex();
            if (b === this.h.length) {
                var c = this.g.length - 1;
                var d = 16 * c;
                c = this.g[c];
            } else c = this.g[b / 16 | 0], d = b - b % 16;
            for(; d < b; d++)c += this.h[d].getApproximateDurationMs();
            return c += a.getOffsetWithinSegmentMs();
        };
        gm.prototype.getTimelinePositionForApproximateTimeMs = function(a) {
            a |= 0;
            var b = Aa(this.g, 1, this.g.length, function(f, g) {
                return a < f[g] ? -1 : 1;
            });
            if (-1 === b) return new M(this.i, 0, 0);
            var c = 16 * b;
            b = a - this.g[b];
            for(var d = !1; c < this.h.length && !d;){
                var e = this.h[c].getApproximateDurationMs();
                e = b - e;
                0 <= e ? (b = e, c++) : d = !0;
            }
            c === this.h.length && (b = 0);
            return new M(this.i, c, b);
        };
        function hm(a) {
            a || (a = "SyncMediaTimeline_" + im, im++);
            return a;
        }
        function jm(a, b, c, d) {
            try {
                null == c || c(d);
            } catch (e) {
                p.Logger.logError(e);
            }
            b = new Fl({
                done: 1 === d,
                progress: d,
                readerView: null,
                timelineName: b
            });
            a.getReadingSystemEngine().getEventBus().emitAsync(b);
        }
        var im = 1;
        function km(a) {
            this.h = [];
            this.g = a;
        }
        km.prototype.append = function(a) {
            this.h.push({
                Ja: a.length,
                K: this.g.length,
                da: "A"
            });
            this.g += a;
        };
        function lm(a) {
            return a.h.map(function(b) {
                return "R" === b.da ? "R" + b.K + ":" + b.yb + ":" + b.xb : b.da + b.K + ":" + b.Ja;
            }).join(",");
        }
        function mm(a, b, c) {
            var d = 0;
            a.g = a.g.replace(b, function(e) {
                var f = m.Vd.apply(1, arguments), g = f.find(function(h) {
                    return C(h);
                });
                if (void 0 === g) return "";
                f = Ha(c) ? c : c.apply(null, [
                    e
                ].concat(m.Ua(f)));
                f.length !== e.length && (f ? a.h.push({
                    xb: f.length,
                    yb: e.length,
                    K: g + d,
                    da: "R"
                }) : e && a.h.push({
                    Ja: e.length,
                    K: g + d,
                    da: "D"
                }), d += f.length - e.length);
                return f;
            });
        }
        km.prototype.slice = function(a, b) {
            var c = this.g.length;
            a = Math.max(0, a);
            b = Math.min(b, c);
            0 < a && this.h.push({
                Ja: a,
                K: 0,
                da: "D"
            });
            b < c && this.h.push({
                Ja: c - b,
                K: b - a,
                da: "D"
            });
            this.g = this.g.slice(a, b);
        };
        km.prototype.toString = function() {
            return this.g;
        };
        km.prototype.trim = function() {
            var a = this.g.length;
            this.g = this.g.trimLeft();
            a -= this.g.length;
            0 < a && this.h.push({
                Ja: a,
                K: 0,
                da: "D"
            });
            var b = this.g.length;
            this.g = this.g.trimRight();
            a = this.g.length;
            b -= a;
            0 < b && this.h.push({
                Ja: b,
                K: a,
                da: "D"
            });
        };
        m.global.Object.defineProperties(km.prototype, {
            length: {
                configurable: !0,
                enumerable: !0,
                get: function() {
                    return this.g.length;
                }
            }
        });
        function nm(a, b, c) {
            this.g = a;
            this.xa = b;
            this.h = c;
        }
        k = nm.prototype;
        k.getApproximateDurationMs = function() {
            return this.g;
        };
        k.getDurationType = function() {
            return x.SyncMediaSegmentDurationType.FIXED;
        };
        k.getReaderDocumentIndexInSpine = function() {
            return this.h;
        };
        k.getMediaObjectRefs = function() {
            return [
                this.xa
            ];
        };
        k.toJSON = function() {
            return {
                approximateDurationMs: this.g,
                durationType: x.SyncMediaSegmentDurationType.FIXED,
                readerDocumentIndexInSpine: this.h,
                refs: [
                    this.xa
                ]
            };
        };
        function om(a) {
            var b = this;
            this.H = a;
            this.G = this.j = this.i = this.g = null;
            this.C = new Map;
            this.l = !0;
            this.D = !1;
            this.M = !0;
            this.F = 1;
            this.o = 0;
            this.v = [];
            this.s = [];
            this.h = new Map;
            this.u = [];
            this.B = 1;
            this.L = function() {
                b.i = null;
                !b.M && b.g && (b.o = 0, speechSynthesis.speak(b.g), pm(b), (speechSynthesis.paused || !p.BrowserDetector.isOS("iOS") && !p.BrowserDetector.isBrowser("Safari")) && speechSynthesis.resume());
            };
        }
        function qm(a) {
            var b, c = null == (b = Ba(a.split("-"))) ? void 0 : b.trim().toLowerCase().substr(0, 2);
            return c ? c : a;
        }
        function rm(a) {
            return a.utterance ? a.utterance : a.target instanceof SpeechSynthesisUtterance ? a.target : null;
        }
        k = om.prototype;
        k.addUtterance = function(a) {
            this.l ? sm(this, a, !1) : this.v.push(a);
        };
        k.clearAndPause = function() {
            var a = this;
            this.h.forEach(function(b, c) {
                tm(a, c);
            });
            this.v = [];
            this.h.clear();
            this.s = [];
            this.g = null;
            this.M = !0;
            this.o = 0;
            um(this);
        };
        k.destroy = function() {
            this.G = null;
            window.removeEventListener("unload", this);
            B(speechSynthesis.removeEventListener) && speechSynthesis.removeEventListener("voiceschanged", this);
            this.clearAndPause();
        };
        k.handleEvent = function(a) {
            switch(a.type){
                case "unload":
                    speechSynthesis.cancel();
                    break;
                case "end":
                    this.onUtteranceEnd(a);
                    break;
                case "boundary":
                    this.onUtteranceBoundary(a);
                    break;
                case "error":
                    this.onUtteranceError(a);
                    break;
                case "voiceschanged":
                    vm(this);
            }
        };
        k.init = function(a) {
            var b = this;
            if (this.G) throw new D("TTS_SYNTHESIZER_ALREADY_IN_USE");
            this.G = a;
            window.addEventListener("unload", this);
            wm(this, !1);
            xm(this);
            B(speechSynthesis.addEventListener) && speechSynthesis.addEventListener("voiceschanged", this);
            setTimeout(function() {
                b.G && !b.l && vm(b);
            }, 1E3);
            0 < this.u.length && vm(this);
            this.pause();
        };
        k.pause = function() {
            if (!this.M && (this.M = !0, um(this), this.g)) {
                tm(this, this.g);
                var a = this.h.get(this.g);
                this.g = null;
                a && (a = La(a), a.charOffset = Math.max(a.charOffset, this.o), sm(this, a, !0));
            }
        };
        k.play = function() {
            this.M && (this.M = !1, ym(this));
        };
        k.setMuted = function(a) {
            this.D = a;
        };
        k.setPlaybackRate = function(a) {
            this.F = a;
            this.h.forEach(function(b, c) {
                c.rate = a;
            });
        };
        k.setVolume = function(a) {
            var b = this;
            this.B = Ka(a, 1E-6, 1);
            this.h.forEach(function(c, d) {
                d.volume = b.B;
            });
        };
        function um(a) {
            zm(a);
            null !== a.i && window.clearTimeout(a.i);
            a.G && (a.i = window.setTimeout(a.L, 200));
            speechSynthesis.cancel();
        }
        function zm(a) {
            null !== a.j && (clearTimeout(a.j), a.j = null);
        }
        function sm(a, b, c) {
            var d = b.text.value;
            b.charOffset && (d = d.slice(b.charOffset));
            d = new SpeechSynthesisUtterance(d);
            var e = b.text.lang;
            if (e) {
                d.lang = e;
                var f;
                xm(a);
                e && (e = qm(e)) && (f = a.C.get(e));
                f && (d.voice = f);
            }
            d.rate = a.F;
            d.volume = a.D ? 1E-6 : Math.max(1E-6, a.B);
            d.addEventListener("boundary", a);
            d.addEventListener("end", a);
            d.addEventListener("error", a);
            a.H && a.H(d, b);
            a.h.set(d, b);
            c ? a.s.unshift(d) : a.s.push(d);
            ym(a);
        }
        function ym(a) {
            !a.M && !a.g && 0 < a.s.length && (a.g = a.s.shift(), null === a.i && um(a));
        }
        function vm(a) {
            xm(a);
            for(var b = a.v.shift(); b;)sm(a, b, !1), b = a.v.shift();
            wm(a, !0);
        }
        k.onUtteranceBoundary = function(a) {
            var b = rm(a);
            if (b) {
                var c = this.h.get(b);
                if (b === this.g && c) {
                    var d = c.text.value;
                    this.o = a = a.charIndex + c.charOffset;
                    b = b.text;
                    if (d.slice(c.charOffset) !== b && 0 < b.length) {
                        a *= d.length / b.length;
                        a = Ka(a, 0, d.length);
                        for(b = a = Math.floor(a); 0 < b && !Ia(d[b - 1]);)b--;
                        a = b;
                    }
                    var e;
                    null == (e = this.G) || e.onUtteranceBoundary(c.id, a, null);
                }
            }
        };
        k.onUtteranceEnd = function(a) {
            if (a = rm(a)) {
                tm(this, a);
                var b = this.h.get(a);
                if (b && a === this.g) {
                    this.o = 0;
                    this.g = null;
                    this.h.delete(a);
                    var c;
                    null == (c = this.G) || c.onUtteranceEnd(b.id);
                    ym(this);
                }
            }
        };
        k.onUtteranceError = function(a) {
            if ("canceled" !== a.error || null === this.i) {
                var b = rm(a);
                if (b) {
                    tm(this, b);
                    var c = this.h.get(b);
                    if (c) {
                        this.g = null;
                        this.h.delete(b);
                        var d;
                        null == (d = this.G) || d.onUtteranceError(c.id, a.error);
                    }
                }
            }
        };
        function tm(a, b) {
            b.removeEventListener("boundary", a);
            b.removeEventListener("end", a);
            b.removeEventListener("error", a);
        }
        function wm(a, b) {
            if (b !== a.l && (a.l = b, a.G)) {
                if (a.l) a.G.onTtsSynthesizerReady();
                else a.G.onTtsSynthesizerWaiting();
            }
        }
        function Am(a) {
            a.u.sort(function(b, c) {
                var d = qm(b.lang), e = qm(c.lang);
                return d === e ? b.default ? -1 : c.default ? 1 : 0 : d < e ? -1 : d === e ? 0 : 1;
            });
        }
        function pm(a) {
            zm(a);
            !a.M && a.g && p.BrowserDetector.isBrowser("Chrome") && p.BrowserDetector.isOS("Windows") && (a.j = window.setTimeout(function() {
                a.j = null;
                speechSynthesis.pause();
                speechSynthesis.resume();
                pm(a);
            }, 1E4));
        }
        function xm(a) {
            var b = speechSynthesis.getVoices();
            b.length !== a.u.length && (a.u = b.slice(), Am(a), a.u.forEach(function(c) {
                var d = qm(c.lang);
                d && (a.C.get(d) || a.C.set(d, c));
            }));
        }
        function Bm(a, b, c, d) {
            this.h = a;
            this.j = b;
            this.g = c;
            this.i = d;
            this.l = b.getSpine();
        }
        function Cm(a, b) {
            var c = b.getSegmentIndex();
            if (c < a.g.length) var d = a.g[c];
            else c = a.g.length - 1, d = a.g[c], b = new M(a.h, c, d.getApproximateDurationMs());
            var e = d.xa;
            a = a.l[d.getReaderDocumentIndexInSpine()];
            var f = Ba(e.sources);
            return f ? a.fetchContentBlockTree().then(function(g) {
                if (g = g.getContentBlockById(f.contentBlockId)) {
                    var h = b.getOffsetWithinSegmentMs();
                    h = Math.min(e.text.value.length, Math.round(h / 82.53094910591471));
                    h = Il(Hl(f.srcMap), h) + f.startOffset;
                    return g.getContentLocation(h, 0).collapseToStart();
                }
                throw new D("INVALID_CONTENT_BLOCK_ID", "id: " + f.contentBlockId);
            }) : Promise.resolve(a.getContentLocation());
        }
        function Dm(a, b) {
            if (rg(b)) return Em(a, b);
            if (W(b)) b = b.resolve();
            else {
                b = Ig(b);
                if (null === b) return Promise.reject(new D("NAVIGATION_ITEM_MISSING_LOCATOR"));
                b = a.j.fetchUnresolvedContentLocation(b).then(function(c) {
                    return c.resolve();
                });
            }
            return b.then(function(c) {
                return Em(a, c);
            });
        }
        function Fm(a, b) {
            var c;
            rg(b) ? c = Promise.resolve(b) : c = W(b) ? b.resolve() : a.j.fetchContentLocation(b);
            return c.then(function(d) {
                var e = d.collapseToStart(), f = d.collapseToEnd();
                return d.isRange() ? Promise.all([
                    Em(a, e),
                    Em(a, f)
                ]).then(function(g) {
                    return {
                        end: g[1],
                        start: g[0]
                    };
                }) : Em(a, e).then(function(g) {
                    return {
                        end: g,
                        start: g
                    };
                });
            });
        }
        function Em(a, b) {
            var c = b.getReaderDocuments()[0];
            if (c.getReaderPublication() !== a.j) return Promise.reject(new D("INVALID_SYNC_MEDIA_TIMELINE_POSITION", "The location does not target this publication"));
            for(var d = c.getIndexInSpine(), e = a.i.length, f = a.i.length - 1; 0 <= f; f--){
                var g = a.i[f];
                if (g < a.g.length) {
                    if (g = a.g[g].getReaderDocumentIndexInSpine(), d > g) break;
                    else if (e = f, d === g) break;
                }
            }
            if (e >= a.i.length) return Promise.resolve(new M(a.h, a.g.length, 0));
            var h = a.i[e];
            if (h >= a.g.length) return Promise.resolve(new M(a.h, a.g.length, 0));
            if (a.g[h].getReaderDocumentIndexInSpine() > d) return Promise.resolve(new M(a.h, h, 0));
            var l = e + 1 < a.i.length ? a.i[e + 1] : a.g.length, r;
            b = b.isRange() ? b.collapseToStart() : b;
            return b.fetchContentBlockTargets(x.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_AFTER).then(function(q) {
                return 0 === q.length ? new M(a.h, l, 0) : c.fetchContentBlockTree().then(function(v) {
                    for(var u = q[0], w = u.getContentBlock(), E = h; E < l && !r; E++){
                        var z = Ba(a.g[E].xa.sources);
                        if (z) {
                            var N = v.getContentBlockById(z.contentBlockId);
                            if (N) {
                                if (w.isBefore(N)) r = new M(a.h, E, 0);
                                else if (w.equals(N)) {
                                    if (u.getCharOffset() <= z.startOffset) r = new M(a.h, E, 0);
                                    else if (u.getCharOffset() < z.endOffset) {
                                        var H = u.getCharOffset() - z.startOffset;
                                        N = Hl(z.srcMap);
                                        for(var A = 0; A < N.g.length; A++){
                                            var J = N.g[A], L = J.K;
                                            "A" === J.da ? H >= L && (H += J.Ja) : "D" === J.da ? H > L + J.Ja ? H -= J.Ja : H > L && (H = L) : "R" === J.da && (H >= L + J.yb ? H += J.xb - J.yb : H > L && (H = L));
                                        }
                                        r = new M(a.h, E, 82.53094910591471 * (H + z.ttsOffset));
                                    }
                                }
                            }
                        }
                    }
                    r || (r = new M(a.h, l, 0));
                    return r;
                });
            });
        }
        function Gm(a, b, c, d, e, f) {
            this.i = a;
            this.s = b;
            this.g = c;
            this.o = e;
            this.l = f;
            if (0 === this.g.length) throw new D("INVALID_SYNC_MEDIA_TIMELINE", "The resulting SyncMediaTimeline have no segments.");
            this.h = new Bm(this, a, c, d);
            this.j = new gm(this);
        }
        k = Gm.prototype;
        k.createDefaultMediaObjectRenderers = function() {
            var a, b = (null == (a = this.l) ? void 0 : a.defaultTtsSynthesizer) || new om, c;
            a = (null == (c = this.l) ? void 0 : c.defaultTtsHighlightLayer) || null;
            var d;
            c = (null == (d = this.l) ? void 0 : d.defaultTtsRendererOptions) || null;
            return [
                new em(b, a, c)
            ];
        };
        k.fetchContentLocation = function(a) {
            return Cm(this.h, a);
        };
        k.fetchTimelinePosition = function(a) {
            return Dm(this.h, a);
        };
        k.fetchTimelineRange = function(a) {
            return Fm(this.h, a);
        };
        k.getApproximateDurationMs = function() {
            return this.o;
        };
        k.getApproximateOffsetMs = function(a) {
            return this.j.getApproximateElapsedTimeMsForTimelinePosition(a);
        };
        k.getMediaObjectRefTypes = function() {
            return [
                x.SyncMediaObjectRefType.TTS_CONTENT_BLOCK
            ];
        };
        k.getMediaObjects = function() {
            return [];
        };
        k.getReaderDocuments = function() {
            return this.s;
        };
        k.getReaderPublication = function() {
            return this.i;
        };
        k.getResourceProvider = function() {
            return null;
        };
        k.getSegments = function() {
            return this.g;
        };
        k.getSyncMediaFormat = function() {
            return x.SyncMediaFormat.CONTENT_BLOCK_TTS;
        };
        k.getTimelinePositionFromApproximateOffsetMs = function(a) {
            return this.j.getTimelinePositionForApproximateTimeMs(a);
        };
        k.toJSON = function() {
            return {
                approximateDurationMs: this.o,
                mediaObjectRefTypes: [
                    x.SyncMediaObjectRefType.TTS_CONTENT_BLOCK
                ],
                mediaObjects: [],
                publicationHashSignature: this.i.getSourcePublication().getHashSignature(),
                readerDocumentIndexes: this.s.map(function(a) {
                    return a.getIndexInSpine();
                }),
                readerPublicationDefaultLocatorUrl: this.i.getDefaultLocatorUrl(),
                segments: this.g.map(function(a) {
                    return a.toJSON();
                }),
                syncMediaFormat: x.SyncMediaFormat.CONTENT_BLOCK_TTS
            };
        };
        k.updateSegmentDuration = function(a, b) {
            if (a < this.g.length) {
                var c = this.g[a], d = c.getApproximateDurationMs();
                this.j._onSegmentDurationChanged({
                    newDurationMs: b,
                    oldDurationMs: d,
                    segmentIndex: a
                });
                c.g = b;
            }
        };
        function Hm(a, b) {
            b.add(a);
            a.getChildren().forEach(function(c) {
                return Hm(c, b);
            });
        }
        function Im(a, b, c, d, e) {
            e && mm(a, /[<>&]/g, function(f) {
                switch(f){
                    case "<":
                        return "&lt;";
                    case ">":
                        return "&gt;";
                    default:
                        return "&amp;";
                }
            });
            return {
                sources: [
                    {
                        contentBlockId: b.getId(),
                        endOffset: d,
                        srcMap: lm(a),
                        startOffset: c,
                        ttsOffset: 0
                    }
                ],
                text: {
                    dir: p.TextDirection.LTR,
                    lang: b.getLanguage(),
                    value: a.toString()
                },
                type: x.SyncMediaObjectRefType.TTS_CONTENT_BLOCK
            };
        }
        function Jm(a, b, c, d) {
            if (b.has(a)) return [];
            var e = a.getAttributes(), f = e.find(function(q) {
                return "role" === q.localName;
            }), g = e.find(function(q) {
                return "aria-hidden" === q.localName;
            }), h = e.find(function(q) {
                return "alttext" === q.localName;
            }), l = a.getBlockClass(), r = a.getBlockType();
            if (f && ("presentation" === f.value || "none" === f.value) || g && "true" === g.value) return Hm(a, b), [];
            f = [];
            if (l === x.ContentBlockClass.MEDIA) {
                h = new km("");
                (l = e.find(function(q) {
                    return "alt" === q.localName;
                })) && Fa(l.value) && r === x.MediaContentBlockType.IMAGE && (c.imageAltTextPrefix ? h.append(c.imageAltTextPrefix + " " + l.value) : h.append("" + l.value));
                if (e = e.find(function(q) {
                    return "aria-describedby" === q.localName;
                })) {
                    if (e = Km(a.getContentBlockTree(), e.value)) Hm(e, b), (b = Lm(e)) && h.append(b);
                }
                Mm(h, c);
                0 < h.length && f.push(Im(h, a, 0, 0, d));
            } else if (r === x.ContainerContentBlockType.MATHML && h && Fa(h.value)) b = new km(""), b.append(h.value), Mm(b, c), 0 < b.length && f.push(Im(b, a, 0, 0, d));
            else if (l === x.ContentBlockClass.TEXT && (b = a.getTextContent())) for(e = /[\s\S]+?(?:[.:?!]+\s|$)/g, h = e.exec(b); null !== h;)r = h.index, h = h.index + h[0].length, l = a.getTextContent().slice(r, h), l = new km(l), Mm(l, c), 0 < l.length && f.push(Im(l, a, r, h, d)), h = e.exec(b);
            return f;
        }
        function Km(a, b) {
            for(a = new p.TreeNodeWalker(a.getContentBlocks()); a.hasNext();){
                var c = a.next();
                if (c.getAttributes().some(function(d) {
                    return "id" === d.localName && d.value === b;
                })) return c;
            }
            return null;
        }
        function Lm(a) {
            a = new p.TreeNodeWalker([
                a
            ]);
            for(var b = []; a.hasNext();){
                var c = a.next().getTextContent();
                c && b.push(c);
            }
            return b.join(" ").trim();
        }
        function Mm(a, b) {
            a.trim();
            mm(a, /\s+/g, " ");
            b.normalizeQuotationMarks && (mm(a, Nm, '"'), mm(a, Om, "'"));
        }
        var Nm = RegExp("[\\u00AB\\u00BB\\u201C-\\u201F\\u2E42]", "g"), Om = RegExp("[\\u2018-\\u201B\\u2039\\u203A]", "g");
        function Pm(a) {
            this.$ = a;
        }
        Pm.prototype.getContentBlockById = function() {
            return null;
        };
        Pm.prototype.getContentBlocks = function() {
            return [];
        };
        Pm.prototype.getReaderDocument = function() {
            return this.$;
        };
        Pm.prototype.toSerializableData = function() {
            return [];
        };
        function Qm() {
            this.g = 0;
        }
        k = Qm.prototype;
        k.getStorageArea = function() {
            throw new D("PUBLICATION_STORAGE_AREA_NOT_SUPPORTED");
        };
        k.getStorageSizeLimit = function() {
            return this.g;
        };
        k.getStorageState = function() {
            return {};
        };
        k.setStorageSizeLimit = function(a) {
            this.g = a;
        };
        k.setStorageState = function() {};
        api = {
            ContentLocationUtils: {
                clampContentLocationToRange: Pk
            },
            ContentPositionTimelineUtils: {
                deserialize: function(a) {
                    try {
                        var b = (new TextDecoder).decode(p.Base64.decode(a)), c = m.ya(b.split("|")), d = c.next().value, e = c.next().value, f = c.next().value, g = c.next().value;
                        if (zl(f) === g) {
                            var h = yl(d, f);
                            if (h) {
                                var l = m.ya(h), r = l.next().value, q = l.next().value, v = l.next().value;
                                return {
                                    documentsLength: r,
                                    indexesInSpine: q,
                                    optionsHash: v,
                                    signature: e
                                };
                            }
                        }
                        return null;
                    } catch (u) {
                        return null;
                    }
                },
                getOrGenerateTimelineName: vl,
                sendProgressEvent: xl,
                serialize: function(a) {
                    var b = [
                        a.documentsLength.join(","),
                        a.indexesInSpine.join(","),
                        a.optionsHash
                    ].join(":"), c = zl(b);
                    a = [
                        "1",
                        a.signature,
                        b,
                        c
                    ].join("|");
                    a = (new TextEncoder).encode(a);
                    return p.Base64.encode(a);
                }
            },
            EmptyContentBlockTree: Pm,
            EmptyPublicationStorage: Qm,
            EngineError: D,
            EngineErrorType: {
                CONTENT_LOCATION_OUTSIDE_VISIBLE_PAGE: "CONTENT_LOCATION_OUTSIDE_VISIBLE_PAGE",
                CONTENT_SELECTION_DISABLED: "CONTENT_SELECTION_DISABLED",
                FORMAT_ADAPTER_MISSING: "FORMAT_ADAPTER_MISSING",
                INCOMPATIBLE_CONTENT_POSITION_TIMELINE_UNIT: "INCOMPATIBLE_CONTENT_POSITION_TIMELINE_UNIT",
                INVALID_ANNOTATION_LAYER: "INVALID_ANNOTATION_LAYER",
                INVALID_RENDERER: "INVALID_RENDERER",
                INTERNAL_PAGE_STREAM_ERROR: "INTERNAL_PAGE_STREAM_ERROR",
                INVALID_CONTENT_BLOCK_ID: "INVALID_CONTENT_BLOCK_ID",
                INVALID_CLOUD_LICENSE_OPTIONS: "INVALID_CLOUD_LICENSE_OPTIONS",
                INVALID_READER_DOCUMENT_LIST: "INVALID_READER_DOCUMENT_LIST",
                INVALID_READER_PUBLICATION: "INVALID_READER_PUBLICATION",
                INVALID_READER_VIEW: "INVALID_READER_VIEW",
                INVALID_RENDERER_BEHAVIOUR: "INVALID_RENDERER_BEHAVIOUR",
                INVALID_SYNC_MEDIA_SEGMENT_INDEX: "INVALID_SYNC_MEDIA_SEGMENT_INDEX",
                INVALID_SYNC_MEDIA_TIMELINE: "INVALID_SYNC_MEDIA_TIMELINE",
                INVALID_SYNC_MEDIA_TIMELINE_POSITION: "INVALID_SYNC_MEDIA_TIMELINE_POSITION",
                INVALID_SYNC_MEDIA_PLAYER: "INVALID_SYNC_MEDIA_PLAYER",
                INVALID_VIEW_OPERATION: "INVALID_VIEW_OPERATION",
                LICENSE_READING_SESSION_BLOCKED: "LICENSE_READING_SESSION_BLOCKED",
                MEDIA_STREAM_ERROR: "MEDIA_STREAM_ERROR",
                MP3_PARSE_ERROR: "MP3_PARSE_ERROR",
                MP4_PARSE_ERROR: "MP4_PARSE_ERROR",
                MULTIPLE_PUBLICATION_SOURCES_NOT_SUPPORTED: "MULTIPLE_PUBLICATION_SOURCES_NOT_SUPPORTED",
                NAVIGATION_ITEM_MISSING_LOCATOR: "NAVIGATION_ITEM_MISSING_LOCATOR",
                NO_FOCUSABLE_CONTENT_FOUND: "NO_FOCUSABLE_CONTENT_FOUND",
                NO_MATCHING_PUBLICATION_FOR_LOCATOR: "NO_MATCHING_PUBLICATION_FOR_LOCATOR",
                PUBLICATION_IN_DESTROYED_STATE: "PUBLICATION_IN_DESTROYED_STATE",
                PUBLICATION_ALREADY_LOADED: "PUBLICATION_ALREADY_LOADED",
                READING_SYSTEM_ENGINE_IN_DESTROYED_STATE: "READING_SYSTEM_ENGINE_IN_DESTROYED_STATE",
                READER_DOCUMENT_LOAD_ERROR: "READER_DOCUMENT_LOAD_ERROR",
                READER_DOCUMENT_NOT_RENDERABLE: "READER_DOCUMENT_NOT_RENDERABLE",
                READER_DOCUMENT_SEARCH_ERROR: "READER_DOCUMENT_SEARCH_ERROR",
                READER_DOCUMENTS_EMPTY: "READER_DOCUMENTS_EMPTY",
                READER_PUBLICATION_IN_USE: "READER_PUBLICATION_IN_USE",
                RENDERABLE_DOCUMENT_PAGE_NOT_FOUND: "RENDERABLE_DOCUMENT_PAGE_NOT_FOUND",
                RENDERABLE_DOCUMENT_PAGE_NOT_LOADED: "RENDERABLE_DOCUMENT_PAGE_NOT_LOADED",
                SYNC_MEDIA_AUDIO_ELEMENT_ERROR: "SYNC_MEDIA_AUDIO_ELEMENT_ERROR",
                SYNC_MEDIA_PAUSE_BUG_MITIGATED: "SYNC_MEDIA_PAUSE_BUG_MITIGATED",
                SYNC_MEDIA_RESOURCE_PROVIDER_MISSING: "SYNC_MEDIA_RESOURCE_PROVIDER_MISSING",
                TRANSFORM_ERROR: "TRANSFORM_ERROR",
                TTS_SYNTHESIZER_ALREADY_IN_USE: "TTS_SYNTHESIZER_ALREADY_IN_USE",
                UNABLE_TO_PERFORM_NAVIGATION: "UNABLE_TO_PERFORM_NAVIGATION",
                VISIBLE_PAGE_OUTDATED: "VISIBLE_PAGE_OUTDATED",
                RENDERER_ADDED_AFTER_SETTING_DOCUMENTS: "RENDERER_ADDED_AFTER_SETTING_DOCUMENTS",
                PRINT_NOT_SUPPORTED: "PRINT_NOT_SUPPORTED",
                PUBLICATION_STORAGE_AREA_NOT_SUPPORTED: "PUBLICATION_STORAGE_AREA_NOT_SUPPORTED"
            },
            event: {
                ContentPositionTimelineCreateProgressEngineEvent: ul,
                EngineEvent: G,
                MouseEngineEvent: tg,
                NavigationIntentEngineEvent: Dl,
                PointerEngineEvent: wg,
                PublicationStorageChangedEngineEvent: El,
                SelectionChangedEngineEvent: Jj,
                SyncMediaTimelineCreateProgressEngineEvent: Fl
            },
            LocatorUtils: {
                getLocator: Ig,
                isLocatorSourceUrlInPublication: function(a, b, c, d) {
                    return (a = b.parse(a, c).locator) ? (a = a.getSourceUrl(), a === c || (null == d ? void 0 : d.includes(a))) : !1;
                }
            },
            MediaSourceFactory: Le,
            ReaderDocumentContentPositionTimelineBuilder: {
                createTimeline: function(a, b, c, d, e) {
                    var f = qg(b, c);
                    if (f) return Promise.reject(f);
                    d = vl(d);
                    xl(c, d, e, 0);
                    if (a === x.ContentPositionTimelineUnit.PAGES && !b.every(function(g) {
                        return g.getSourceContentDocument().getLayout() === t.ContentDocumentLayout.PRE_PAGINATED;
                    })) return Promise.reject(new D("INCOMPATIBLE_CONTENT_POSITION_TIMELINE_UNIT", "Cannot use unit PAGES, some ReaderDocuments are not pre-paginated."));
                    xl(c, d, e, 1);
                    return Promise.resolve(new Al(a, b));
                }
            },
            ReadingSystemAsyncTaskScheduler: tl,
            ReadingSystemEngine: pl,
            ReadingSystemUtils: {
                fetchAverageAspectRatioFromReaderDocuments: function(a) {
                    var b = [];
                    a = a.map(function(c) {
                        return c.fetchViewportDimensions().catch(function(d) {
                            p.Logger.logWarning(d);
                            return null;
                        });
                    });
                    return Promise.all(a).then(function(c) {
                        for(var d = 0; d < c.length; d++){
                            var e = c[d];
                            e && b.push(e);
                        }
                        if (0 < b.length) {
                            c = b.map(function(f) {
                                return f.width / f.height;
                            });
                            for(e = d = 0; e < c.length; e++)d += c[e];
                            return d / c.length;
                        }
                        return null;
                    });
                },
                getPageContainerIframeTitle: function(a, b, c) {
                    a = a.pageContainerOptions.titleOptions;
                    if (!c.getSupportedFlowModes().includes(t.ContentDocumentFlowMode.PAGINATED)) return a.scroll;
                    if (c.getSpreadMode() === x.RendererSpreadMode.SINGLE_PAGE) return a.singlePage;
                    switch(b){
                        case t.PageSpreadSlot.LEFT:
                            return a.spreadLeft;
                        case t.PageSpreadSlot.RIGHT:
                            return a.spreadRight;
                        default:
                            return a.spreadCenter;
                    }
                },
                getReaderDocumentListErrorForTimelineCreation: qg,
                isContentLocation: rg,
                isTouchEventsForced: sg,
                isUnresolvedContentLocation: W
            },
            ResponsiveViewRule: ok,
            SyncMediaAudioRenderer: gf,
            SyncMediaObjectRendererRuntimeHelper: {
                getSegmentPreloadRange: qd
            },
            SyncMediaTimelinePosition: M,
            SyncMediaTimelineTimeMapper: gm,
            SyncMediaTimelineUtils: {
                getOrGenerateTimelineName: hm,
                sendProgressEvent: jm
            },
            SyncMediaTtsContentBlockRenderer: em,
            TtsSyncMediaTimelineBuilder: {
                createTimeline: function(a, b, c) {
                    var d = y(null == b ? void 0 : b.contentTransformationOptions, {
                        imageAltTextPrefix: "",
                        normalizeQuotationMarks: !0
                    }), e = a[0].getReaderPublication();
                    if (e.getReadingSystemEngine().getOptions().platformWorkaroundOptions.escapeXmlInTtsUtterancesOnSafari26) {
                        var f = p.BrowserDetector.isOS("iOS") || p.BrowserDetector.isOS("macOS") && 1 < navigator.maxTouchPoints, g = p.BrowserDetector.getOsVersion(), h = p.BrowserDetector.isBrowser("Safari"), l = p.BrowserDetector.getBrowserVersion();
                        var r = f && g.startsWith("26") || h && l.startsWith("26");
                    } else r = !1;
                    if (f = qg(a, e)) return Promise.reject(f);
                    var q = [], v = [], u = 0, w = hm(null == b ? void 0 : b.name);
                    jm(e, w, c, 0);
                    var E = new tl(e.getReadingSystemEngine(), {
                        concurrency: 1,
                        pauseOnOffscreenContentRendering: !0,
                        pauseOnReaderViewGesture: !0,
                        pauseOnReaderViewNavigation: !0,
                        pauseOnVisibleContentRendering: !0
                    });
                    f = a.map(function(z, N) {
                        return E.scheduleTask(function() {
                            var H, A, J, L, U;
                            return m.ea(function(F) {
                                if (1 == F.g) return v.push(q.length), ca(F, 2), n(F, z.fetchContentBlockTree(), 4);
                                if (2 != F.g) {
                                    H = F.h;
                                    A = new Set;
                                    for(J = new p.TreeNodeWalker(H.getContentBlocks()); J.hasNext();)L = J.next(), Jm(L, A, d, r).forEach(function(I) {
                                        var Ga = 82.53094910591471 * I.text.value.length | 0;
                                        u += Ga;
                                        I = new nm(Ga, I, z.getIndexInSpine());
                                        q.push(I);
                                    });
                                    jm(e, w, c, (N + 1) / a.length);
                                    F.g = 0;
                                    F.j = 0;
                                } else U = da(F), p.ColibrioError.isColibrioAbortedError(U) || p.Logger.logError(U), F.g = 0;
                            });
                        }, 0);
                    });
                    return Promise.all(f).then(function() {
                        return new Gm(e, a, q, v, u, b);
                    }).finally(function() {
                        E.destroy();
                    });
                }
            },
            WebSpeechTtsSynthesizer: om
        };
    }).call(__self);
    return api;
});

});
parcelRegister("cLeaP", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";
(function(s, f) {
    if (0, module.exports) module.exports = f(s);
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self) {
    var api = {};
    (function() {
        var l = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, m;
        if ("function" == typeof Object.setPrototypeOf) m = Object.setPrototypeOf;
        else {
            var n;
            a: {
                var p = {
                    a: !0
                }, q = {};
                try {
                    q.__proto__ = p;
                    n = q.a;
                    break a;
                } catch (a) {}
                n = !1;
            }
            m = n ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var t = m;
        function u(a, b) {
            a.prototype = l(b.prototype);
            a.prototype.constructor = a;
            if (t) t(a, b);
            else for(var d in b)if ("prototype" != d) {
                if (Object.defineProperties) {
                    var c = Object.getOwnPropertyDescriptor(b, d);
                    c && Object.defineProperty(a, d, c);
                } else a[d] = b[d];
            }
            a.u = b.prototype;
        }
        var v = new Uint16Array(1);
        v[0] = 4660;
        new Uint8Array(v.buffer);
        function w(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        u(w, Error);
        var x = new ArrayBuffer(8);
        new DataView(x);
        new Uint8Array(x);
        function y(a) {
            var b = new Uint8Array(a);
            if ("undefined" !== typeof crypto && crypto.getRandomValues) crypto.getRandomValues(b);
            else for(var d = 0; d < a; d++)b[d] = 256 * Math.random() | 0;
            return b;
        }
        function z(a, b) {
            this.l = !1;
            this.m = new Uint8Array(64);
            this.i = this.h = 0;
            this.o = new Int32Array(a);
            this.g = new Int32Array(b);
            this.s(this.g);
        }
        z.prototype.append = function(a) {
            if (this.l) throw new w("Illegal Sha.append(). Already finalized.");
            var b = 0;
            a instanceof ArrayBuffer ? a = new Uint8Array(a) : a instanceof Uint8Array || ("string" === typeof a ? (B || (B = new TextEncoder), a = B.encode(a)) : a = new Uint8Array(a.buffer, a.byteOffset, a.byteLength));
            if (a.length > Number.MAX_SAFE_INTEGER) throw new w("Data passed to Sha.append() is too large");
            var d = a.length;
            if (0 < this.h) {
                b = Math.min(64 - this.h, d);
                for(var c = 0; c < b; c++)this.m[this.h++] = a[c];
                64 === this.h && (this.j(this.m, 0, this.o, this.g), this.h = 0);
            }
            this.i += d;
            if (!(b >= d)) {
                c = d - (d - b) % 64;
                if (b < c) {
                    for(; b < c; b += 64)this.j(a, b, this.o, this.g);
                    b > c && (b -= 64);
                }
                if (b < d) for(; b < d;)this.m[this.h++] = a[b++];
            }
        };
        z.prototype.digestToHex = function() {
            C(this);
            for(var a = Array(2 * this.g.byteLength), b = 0, d = 0; d < this.g.length; d++)for(var c = this.g[d], e = 7; 0 <= e; e--){
                var f = c >> (e << 2) & 15;
                a[b++] = (10 > f ? 48 : 87) + f;
            }
            return String.fromCharCode.apply(null, a);
        };
        z.prototype.digestToUint32Array = function() {
            C(this);
            return new Uint32Array(this.g);
        };
        z.prototype.digestToUint8Array = function() {
            C(this);
            for(var a = new Uint8Array(this.g.byteLength), b = 0, d = 0; d < this.g.length; d++){
                var c = this.g[d];
                a[b++] = c >>> 24;
                a[b++] = c >>> 16;
                a[b++] = c >>> 8;
                a[b++] = c;
            }
            return a;
        };
        z.prototype.reset = function() {
            this.s(this.g);
            this.l = !1;
            this.i = this.h = 0;
        };
        function C(a) {
            if (!a.l) {
                a.l = !0;
                var b = a.h, d = a.m;
                d[b++] = 128;
                if (56 < b) {
                    for(; 64 > b;)d[b++] = 0;
                    a.j(d, 0, a.o, a.g);
                    b = 0;
                }
                for(; 56 > b;)d[b++] = 0;
                if (a.i > Math.pow(2, 29) - 1) {
                    var c = Math.trunc(a.i / Math.pow(2, 29)) | 0;
                    d[b++] = c >>> 24;
                    d[b++] = c >>> 16;
                    d[b++] = c >>> 8;
                    d[b++] = c;
                } else for(; 60 > b;)d[b++] = 0;
                c = a.i << 3 | 0;
                d[b++] = c >>> 24;
                d[b++] = c >>> 16;
                d[b++] = c >>> 8;
                d[b++] = c;
                a.j(d, 0, a.o, a.g);
            }
        }
        var B = null;
        function D() {
            z.call(this, 80, 5);
        }
        u(D, z);
        D.prototype.j = function(a, b, d, c) {
            for(var e = 0; 16 > e; e++)d[e] = a[b++] << 24 | a[b++] << 16 | a[b++] << 8 | a[b++];
            for(a = 16; 80 > a; a++)d[a] = E(d[a - 3] ^ d[a - 8] ^ d[a - 14] ^ d[a - 16], 1);
            a = c[0];
            b = c[1];
            e = c[2];
            for(var f = c[3], h = c[4], g = 0; 20 > g; g++){
                var k = E(a, 5) + (b & e | ~b & f) + h + d[g] + 1518500249 | 0;
                h = f;
                f = e;
                e = E(b, 30);
                b = a;
                a = k;
            }
            for(g = 20; 40 > g; g++)k = E(a, 5) + (b ^ e ^ f) + h + d[g] + 1859775393 | 0, h = f, f = e, e = E(b, 30), b = a, a = k;
            for(g = 40; 60 > g; g++)k = E(a, 5) + (b & e | b & f | e & f) + h + d[g] + 2400959708 | 0, h = f, f = e, e = E(b, 30), b = a, a = k;
            for(g = 60; 80 > g; g++)k = E(a, 5) + (b ^ e ^ f) + h + d[g] + 3395469782 | 0, h = f, f = e, e = E(b, 30), b = a, a = k;
            c[0] += a;
            c[1] += b;
            c[2] += e;
            c[3] += f;
            c[4] += h;
        };
        D.prototype.s = function(a) {
            a[0] = 1732584193;
            a[1] = 4023233417;
            a[2] = 2562383102;
            a[3] = 271733878;
            a[4] = 3285377520;
        };
        function E(a, b) {
            return a << b | a >>> 32 - b;
        }
        function G() {
            z.call(this, 64, 8);
        }
        u(G, z);
        G.prototype.j = function(a, b, d, c) {
            for(var e = 0; 16 > e; e++)d[e] = a[b++] << 24 | a[b++] << 16 | a[b++] << 8 | a[b++];
            for(a = 16; 64 > a; a++)b = d[a - 15], e = d[a - 2], d[a] = (H(e, 17) ^ H(e, 19) ^ e >>> 10) + d[a - 7] + (H(b, 7) ^ H(b, 18) ^ b >>> 3) + d[a - 16];
            a = c[0];
            b = c[1];
            e = c[2];
            for(var f = c[3], h = c[4], g = c[5], k = c[6], A = c[7], r = 0; 64 > r; r++){
                var F = A + (H(h, 6) ^ H(h, 11) ^ H(h, 25)) + (h & g ^ ~h & k) + I[r] + d[r] | 0, J = (H(a, 2) ^ H(a, 13) ^ H(a, 22)) + (a & b ^ a & e ^ b & e) | 0;
                A = k;
                k = g;
                g = h;
                h = f + F | 0;
                f = e;
                e = b;
                b = a;
                a = F + J | 0;
            }
            c[0] += a;
            c[1] += b;
            c[2] += e;
            c[3] += f;
            c[4] += h;
            c[5] += g;
            c[6] += k;
            c[7] += A;
        };
        G.prototype.s = function(a) {
            a[0] = 1779033703;
            a[1] = 3144134277;
            a[2] = 1013904242;
            a[3] = 2773480762;
            a[4] = 1359893119;
            a[5] = 2600822924;
            a[6] = 528734635;
            a[7] = 1541459225;
        };
        var I = [
            1116352408,
            1899447441,
            3049323471,
            3921009573,
            961987163,
            1508970993,
            2453635748,
            2870763221,
            3624381080,
            310598401,
            607225278,
            1426881987,
            1925078388,
            2162078206,
            2614888103,
            3248222580,
            3835390401,
            4022224774,
            264347078,
            604807628,
            770255983,
            1249150122,
            1555081692,
            1996064986,
            2554220882,
            2821834349,
            2952996808,
            3210313671,
            3336571891,
            3584528711,
            113926993,
            338241895,
            666307205,
            773529912,
            1294757372,
            1396182291,
            1695183700,
            1986661051,
            2177026350,
            2456956037,
            2730485921,
            2820302411,
            3259730800,
            3345764771,
            3516065817,
            3600352804,
            4094571909,
            275423344,
            430227734,
            506948616,
            659060556,
            883997877,
            958139571,
            1322822218,
            1537002063,
            1747873779,
            1955562222,
            2024104815,
            2227730452,
            2361852424,
            2428436474,
            2756734187,
            3204031479,
            3329325298
        ];
        function H(a, b) {
            return a >>> b | a << 32 - b;
        }
        api = {
            Random: {
                getRandomBytes: y,
                getRandomHexString: function(a) {
                    a = y(a);
                    for(var b = [], d = 0; d < a.length; d++)16 > a[d] && b.push("0"), b.push(a[d].toString(16));
                    return b.join("");
                },
                getRandomString: function(a, b) {
                    for(var d = y(a), c = "", e = 0; e < a; e++)c += String.fromCharCode(d[e]);
                    a = btoa(c);
                    b && (a = a.replace(/[.+\/]/g, function(f) {
                        return "." === f ? "a" : "+" === f ? "A" : "0";
                    }));
                    return a;
                }
            },
            Sha1: D,
            Sha256: G
        };
    }).call(__self);
    return api;
});

});

parcelRegister("7uZag", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";


(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base) {
    var __lib__file_type = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        var c = c || {};
        c.scope = {};
        c.ASSUME_ES5 = !1;
        c.ASSUME_NO_NATIVE_MAP = !1;
        c.ASSUME_NO_NATIVE_SET = !1;
        c.SIMPLE_FROUND_POLYFILL = !1;
        c.ISOLATE_POLYFILLS = !1;
        c.FORCE_POLYFILL_PROMISE = !1;
        c.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
        c.defineProperty = c.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(b, g, d) {
            if (b == Array.prototype || b == Object.prototype) return b;
            b[g] = d.value;
            return b;
        };
        c.getGlobal = function(b) {
            b = [
                "object" == typeof globalThis && globalThis,
                b,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var g = 0; g < b.length; ++g){
                var d = b[g];
                if (d && d.Math == Math) return d;
            }
            throw Error("Cannot find global object");
        };
        c.global = c.getGlobal(this);
        c.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
        c.TRUST_ES6_POLYFILLS = !c.ISOLATE_POLYFILLS || c.IS_SYMBOL_NATIVE;
        c.polyfills = {};
        c.propertyToPolyfillSymbol = {};
        c.POLYFILL_PREFIX = "$jscp$";
        c.polyfill = function(b, g, d, f) {
            g && (c.ISOLATE_POLYFILLS ? c.polyfillIsolated(b, g, d, f) : c.polyfillUnisolated(b, g, d, f));
        };
        c.polyfillUnisolated = function(b, g) {
            var d = c.global;
            b = b.split(".");
            for(var f = 0; f < b.length - 1; f++){
                var h = b[f];
                if (!(h in d)) return;
                d = d[h];
            }
            b = b[b.length - 1];
            f = d[b];
            g = g(f);
            g != f && null != g && c.defineProperty(d, b, {
                configurable: !0,
                writable: !0,
                value: g
            });
        };
        c.polyfillIsolated = function(b, g, d) {
            var f = b.split(".");
            b = 1 === f.length;
            var h = f[0];
            h = !b && h in c.polyfills ? c.polyfills : c.global;
            for(var l = 0; l < f.length - 1; l++){
                var e = f[l];
                if (!(e in h)) return;
                h = h[e];
            }
            f = f[f.length - 1];
            d = c.IS_SYMBOL_NATIVE && "es6" === d ? h[f] : null;
            g = g(d);
            null != g && (b ? c.defineProperty(c.polyfills, f, {
                configurable: !0,
                writable: !0,
                value: g
            }) : g !== d && (void 0 === c.propertyToPolyfillSymbol[f] && (b = 1E9 * Math.random() >>> 0, c.propertyToPolyfillSymbol[f] = c.IS_SYMBOL_NATIVE ? c.global.Symbol(f) : c.POLYFILL_PREFIX + b + "$" + f), c.defineProperty(h, c.propertyToPolyfillSymbol[f], {
                configurable: !0,
                writable: !0,
                value: g
            })));
        };
        c.polyfill("Array.from", function(b) {
            return b ? b : function(g, d, f) {
                d = null != d ? d : function(k) {
                    return k;
                };
                var h = [], l = "undefined" != typeof Symbol && Symbol.iterator && g[Symbol.iterator];
                if ("function" == typeof l) {
                    g = l.call(g);
                    for(var e = 0; !(l = g.next()).done;)h.push(d.call(f, l.value, e++));
                } else for(l = g.length, e = 0; e < l; e++)h.push(d.call(f, g[e], e));
                return h;
            };
        }, "es6", "es3");
        c.owns = function(b, g) {
            return Object.prototype.hasOwnProperty.call(b, g);
        };
        c.assign = c.TRUST_ES6_POLYFILLS && "function" == typeof Object.assign ? Object.assign : function(b, g) {
            for(var d = 1; d < arguments.length; d++){
                var f = arguments[d];
                if (f) for(var h in f)c.owns(f, h) && (b[h] = f[h]);
            }
            return b;
        };
        c.polyfill("Object.assign", function(b) {
            return b || c.assign;
        }, "es6", "es3");
        c.findInternal = function(b, g, d) {
            b instanceof String && (b = String(b));
            for(var f = b.length, h = 0; h < f; h++){
                var l = b[h];
                if (g.call(d, l, h, b)) return {
                    i: h,
                    v: l
                };
            }
            return {
                i: -1,
                v: void 0
            };
        };
        c.polyfill("Array.prototype.findIndex", function(b) {
            return b ? b : function(g, d) {
                return c.findInternal(this, g, d).i;
            };
        }, "es6", "es3");
        (function(b) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = b() : "function" === typeof define && define.amd ? define([], b) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = b();
        })(function() {
            return (function() {
                function b(g, d, f) {
                    function h(k, a) {
                        if (!d[k]) {
                            if (!g[k]) {
                                var m = undefined;
                                if (!a && m) return m(k, !0);
                                if (l) return l(k, !0);
                                a = Error("Cannot find module '" + k + "'");
                                throw a.code = "MODULE_NOT_FOUND", a;
                            }
                            a = d[k] = {
                                exports: {}
                            };
                            g[k][0].call(a.exports, function(r) {
                                return h(g[k][1][r] || r);
                            }, a, a.exports, b, g, d, f);
                        }
                        return d[k].exports;
                    }
                    for(var l = undefined, e = 0; e < f.length; e++)h(f[e]);
                    return h;
                }
                return b;
            })()({
                1: [
                    function(b, g) {
                        function d(e) {
                            return Array.from(e).map(function(k) {
                                return k.charCodeAt(0);
                            });
                        }
                        var f = d("META-INF/mozilla.rsa"), h = d("[Content_Types].xml"), l = d("_rels/.rels");
                        g.exports = function(e) {
                            function k(q, p) {
                                return a(d(q), p);
                            }
                            function a(q, p) {
                                p = Object.assign({
                                    offset: 0
                                }, p);
                                for(var n = 0; n < q.length; n++)if (p.mask) {
                                    if (q[n] !== (p.mask[n] & m[n + p.offset])) return !1;
                                } else if (q[n] !== m[n + p.offset]) return !1;
                                return !0;
                            }
                            var m = e instanceof Uint8Array ? e : new Uint8Array(e);
                            if (!(m && 1 < m.length)) return null;
                            if (a([
                                255,
                                216,
                                255
                            ])) return {
                                ext: "jpg",
                                mime: "image/jpeg"
                            };
                            if (a([
                                137,
                                80,
                                78,
                                71,
                                13,
                                10,
                                26,
                                10
                            ])) return {
                                ext: "png",
                                mime: "image/png"
                            };
                            if (a([
                                71,
                                73,
                                70
                            ])) return {
                                ext: "gif",
                                mime: "image/gif"
                            };
                            if (a([
                                87,
                                69,
                                66,
                                80
                            ], {
                                offset: 8
                            })) return {
                                ext: "webp",
                                mime: "image/webp"
                            };
                            if (a([
                                70,
                                76,
                                73,
                                70
                            ])) return {
                                ext: "flif",
                                mime: "image/flif"
                            };
                            if ((a([
                                73,
                                73,
                                42,
                                0
                            ]) || a([
                                77,
                                77,
                                0,
                                42
                            ])) && a([
                                67,
                                82
                            ], {
                                offset: 8
                            })) return {
                                ext: "cr2",
                                mime: "image/x-canon-cr2"
                            };
                            if (a([
                                73,
                                73,
                                42,
                                0
                            ]) || a([
                                77,
                                77,
                                0,
                                42
                            ])) return {
                                ext: "tif",
                                mime: "image/tiff"
                            };
                            if (a([
                                66,
                                77
                            ])) return {
                                ext: "bmp",
                                mime: "image/bmp"
                            };
                            if (a([
                                73,
                                73,
                                188
                            ])) return {
                                ext: "jxr",
                                mime: "image/vnd.ms-photo"
                            };
                            if (a([
                                56,
                                66,
                                80,
                                83
                            ])) return {
                                ext: "psd",
                                mime: "image/vnd.adobe.photoshop"
                            };
                            if (a([
                                80,
                                75,
                                3,
                                4
                            ])) {
                                if (a([
                                    109,
                                    105,
                                    109,
                                    101,
                                    116,
                                    121,
                                    112,
                                    101,
                                    97,
                                    112,
                                    112,
                                    108,
                                    105,
                                    99,
                                    97,
                                    116,
                                    105,
                                    111,
                                    110,
                                    47,
                                    101,
                                    112,
                                    117,
                                    98,
                                    43,
                                    122,
                                    105,
                                    112
                                ], {
                                    offset: 30
                                })) return {
                                    ext: "epub",
                                    mime: "application/epub+zip"
                                };
                                if (a(f, {
                                    offset: 30
                                })) return {
                                    ext: "xpi",
                                    mime: "application/x-xpinstall"
                                };
                                if (k("mimetypeapplication/vnd.oasis.opendocument.text", {
                                    offset: 30
                                })) return {
                                    ext: "odt",
                                    mime: "application/vnd.oasis.opendocument.text"
                                };
                                if (k("mimetypeapplication/vnd.oasis.opendocument.spreadsheet", {
                                    offset: 30
                                })) return {
                                    ext: "ods",
                                    mime: "application/vnd.oasis.opendocument.spreadsheet"
                                };
                                if (k("mimetypeapplication/vnd.oasis.opendocument.presentation", {
                                    offset: 30
                                })) return {
                                    ext: "odp",
                                    mime: "application/vnd.oasis.opendocument.presentation"
                                };
                                if (a(h, {
                                    offset: 30
                                }) || a(l, {
                                    offset: 30
                                })) {
                                    var r = m.subarray(4, 2004);
                                    e = function(q) {
                                        return q.findIndex(function(p, n, t) {
                                            return 80 === t[n] && 75 === t[n + 1] && 3 === t[n + 2] && 4 === t[n + 3];
                                        });
                                    };
                                    r = e(r);
                                    if (-1 !== r) {
                                        var v = m.subarray(r + 8, r + 8 + 1E3);
                                        e = e(v);
                                        if (-1 !== e) {
                                            e = 8 + r + e + 30;
                                            if (k("word/", {
                                                offset: e
                                            })) return {
                                                ext: "docx",
                                                mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            };
                                            if (k("ppt/", {
                                                offset: e
                                            })) return {
                                                ext: "pptx",
                                                mime: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                            };
                                            if (k("xl/", {
                                                offset: e
                                            })) return {
                                                ext: "xlsx",
                                                mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                            };
                                        }
                                    }
                                }
                            }
                            if (a([
                                80,
                                75
                            ]) && (3 === m[2] || 5 === m[2] || 7 === m[2]) && (4 === m[3] || 6 === m[3] || 8 === m[3])) return {
                                ext: "zip",
                                mime: "application/zip"
                            };
                            if (a([
                                117,
                                115,
                                116,
                                97,
                                114
                            ], {
                                offset: 257
                            })) return {
                                ext: "tar",
                                mime: "application/x-tar"
                            };
                            if (a([
                                82,
                                97,
                                114,
                                33,
                                26,
                                7
                            ]) && (0 === m[6] || 1 === m[6])) return {
                                ext: "rar",
                                mime: "application/x-rar-compressed"
                            };
                            if (a([
                                31,
                                139,
                                8
                            ])) return {
                                ext: "gz",
                                mime: "application/gzip"
                            };
                            if (a([
                                66,
                                90,
                                104
                            ])) return {
                                ext: "bz2",
                                mime: "application/x-bzip2"
                            };
                            if (a([
                                55,
                                122,
                                188,
                                175,
                                39,
                                28
                            ])) return {
                                ext: "7z",
                                mime: "application/x-7z-compressed"
                            };
                            if (a([
                                120,
                                1
                            ])) return {
                                ext: "dmg",
                                mime: "application/x-apple-diskimage"
                            };
                            if (a([
                                51,
                                103,
                                112,
                                53
                            ]) || a([
                                0,
                                0,
                                0
                            ]) && a([
                                102,
                                116,
                                121,
                                112
                            ], {
                                offset: 4
                            }) && (a([
                                109,
                                112,
                                52,
                                49
                            ], {
                                offset: 8
                            }) || a([
                                109,
                                112,
                                52,
                                50
                            ], {
                                offset: 8
                            }) || a([
                                105,
                                115,
                                111,
                                109
                            ], {
                                offset: 8
                            }) || a([
                                105,
                                115,
                                111,
                                50
                            ], {
                                offset: 8
                            }) || a([
                                109,
                                109,
                                112,
                                52
                            ], {
                                offset: 8
                            }) || a([
                                77,
                                52,
                                86
                            ], {
                                offset: 8
                            }) || a([
                                100,
                                97,
                                115,
                                104
                            ], {
                                offset: 8
                            }))) return {
                                ext: "mp4",
                                mime: "video/mp4"
                            };
                            if (a([
                                77,
                                84,
                                104,
                                100
                            ])) return {
                                ext: "mid",
                                mime: "audio/midi"
                            };
                            if (a([
                                26,
                                69,
                                223,
                                163
                            ])) {
                                var u = m.subarray(4, 4100);
                                e = u.findIndex(function(q, p, n) {
                                    return 66 === n[p] && 130 === n[p + 1];
                                });
                                if (-1 !== e) {
                                    var w = e + 3;
                                    e = function(q) {
                                        return Array.from(q).every(function(p, n) {
                                            return u[w + n] === p.charCodeAt(0);
                                        });
                                    };
                                    if (e("matroska")) return {
                                        ext: "mkv",
                                        mime: "video/x-matroska"
                                    };
                                    if (e("webm")) return {
                                        ext: "webm",
                                        mime: "video/webm"
                                    };
                                }
                            }
                            if (a([
                                0,
                                0,
                                0,
                                20,
                                102,
                                116,
                                121,
                                112,
                                113,
                                116,
                                32,
                                32
                            ]) || a([
                                102,
                                114,
                                101,
                                101
                            ], {
                                offset: 4
                            }) || a([
                                102,
                                116,
                                121,
                                112,
                                113,
                                116,
                                32,
                                32
                            ], {
                                offset: 4
                            }) || a([
                                109,
                                100,
                                97,
                                116
                            ], {
                                offset: 4
                            }) || a([
                                119,
                                105,
                                100,
                                101
                            ], {
                                offset: 4
                            })) return {
                                ext: "mov",
                                mime: "video/quicktime"
                            };
                            if (a([
                                82,
                                73,
                                70,
                                70
                            ]) && a([
                                65,
                                86,
                                73
                            ], {
                                offset: 8
                            })) return {
                                ext: "avi",
                                mime: "video/x-msvideo"
                            };
                            if (a([
                                48,
                                38,
                                178,
                                117,
                                142,
                                102,
                                207,
                                17,
                                166,
                                217
                            ])) return {
                                ext: "wmv",
                                mime: "video/x-ms-wmv"
                            };
                            if (a([
                                0,
                                0,
                                1,
                                186
                            ]) || a([
                                0,
                                0,
                                1,
                                179
                            ])) return {
                                ext: "mpg",
                                mime: "video/mpeg"
                            };
                            if (a([
                                102,
                                116,
                                121,
                                112,
                                51,
                                103
                            ], {
                                offset: 4
                            })) return {
                                ext: "3gp",
                                mime: "video/3gpp"
                            };
                            for(e = 0; 2 > e && e < m.length - 16; e++){
                                if (a([
                                    73,
                                    68,
                                    51
                                ], {
                                    offset: e
                                }) || a([
                                    255,
                                    226
                                ], {
                                    offset: e,
                                    mask: [
                                        255,
                                        226
                                    ]
                                })) return {
                                    ext: "mp3",
                                    mime: "audio/mpeg"
                                };
                                if (a([
                                    255,
                                    228
                                ], {
                                    offset: e,
                                    mask: [
                                        255,
                                        228
                                    ]
                                })) return {
                                    ext: "mp2",
                                    mime: "audio/mpeg"
                                };
                            }
                            if (a([
                                102,
                                116,
                                121,
                                112,
                                77,
                                52,
                                65
                            ], {
                                offset: 4
                            }) || a([
                                77,
                                52,
                                65,
                                32
                            ])) return {
                                ext: "m4a",
                                mime: "audio/m4a"
                            };
                            if (a([
                                79,
                                112,
                                117,
                                115,
                                72,
                                101,
                                97,
                                100
                            ], {
                                offset: 28
                            })) return {
                                ext: "opus",
                                mime: "audio/opus"
                            };
                            if (a([
                                79,
                                103,
                                103,
                                83
                            ])) return a([
                                128,
                                116,
                                104,
                                101,
                                111,
                                114,
                                97
                            ], {
                                offset: 28
                            }) ? {
                                ext: "ogv",
                                mime: "video/ogg"
                            } : a([
                                1,
                                118,
                                105,
                                100,
                                101,
                                111,
                                0
                            ], {
                                offset: 28
                            }) ? {
                                ext: "ogm",
                                mime: "video/ogg"
                            } : a([
                                127,
                                70,
                                76,
                                65,
                                67
                            ], {
                                offset: 28
                            }) ? {
                                ext: "oga",
                                mime: "audio/ogg"
                            } : a([
                                83,
                                112,
                                101,
                                101,
                                120,
                                32,
                                32
                            ], {
                                offset: 28
                            }) ? {
                                ext: "spx",
                                mime: "audio/ogg"
                            } : a([
                                1,
                                118,
                                111,
                                114,
                                98,
                                105,
                                115
                            ], {
                                offset: 28
                            }) ? {
                                ext: "ogg",
                                mime: "audio/ogg"
                            } : {
                                ext: "ogx",
                                mime: "application/ogg"
                            };
                            if (a([
                                102,
                                76,
                                97,
                                67
                            ])) return {
                                ext: "flac",
                                mime: "audio/x-flac"
                            };
                            if (a([
                                82,
                                73,
                                70,
                                70
                            ]) && a([
                                87,
                                65,
                                86,
                                69
                            ], {
                                offset: 8
                            })) return {
                                ext: "wav",
                                mime: "audio/x-wav"
                            };
                            if (a([
                                35,
                                33,
                                65,
                                77,
                                82,
                                10
                            ])) return {
                                ext: "amr",
                                mime: "audio/amr"
                            };
                            if (a([
                                37,
                                80,
                                68,
                                70
                            ])) return {
                                ext: "pdf",
                                mime: "application/pdf"
                            };
                            if (a([
                                77,
                                90
                            ])) return {
                                ext: "exe",
                                mime: "application/x-msdownload"
                            };
                            if ((67 === m[0] || 70 === m[0]) && a([
                                87,
                                83
                            ], {
                                offset: 1
                            })) return {
                                ext: "swf",
                                mime: "application/x-shockwave-flash"
                            };
                            if (a([
                                123,
                                92,
                                114,
                                116,
                                102
                            ])) return {
                                ext: "rtf",
                                mime: "application/rtf"
                            };
                            if (a([
                                0,
                                97,
                                115,
                                109
                            ])) return {
                                ext: "wasm",
                                mime: "application/wasm"
                            };
                            if (a([
                                119,
                                79,
                                70,
                                70
                            ]) && (a([
                                0,
                                1,
                                0,
                                0
                            ], {
                                offset: 4
                            }) || a([
                                79,
                                84,
                                84,
                                79
                            ], {
                                offset: 4
                            }))) return {
                                ext: "woff",
                                mime: "font/woff"
                            };
                            if (a([
                                119,
                                79,
                                70,
                                50
                            ]) && (a([
                                0,
                                1,
                                0,
                                0
                            ], {
                                offset: 4
                            }) || a([
                                79,
                                84,
                                84,
                                79
                            ], {
                                offset: 4
                            }))) return {
                                ext: "woff2",
                                mime: "font/woff2"
                            };
                            if (a([
                                76,
                                80
                            ], {
                                offset: 34
                            }) && (a([
                                0,
                                0,
                                1
                            ], {
                                offset: 8
                            }) || a([
                                1,
                                0,
                                2
                            ], {
                                offset: 8
                            }) || a([
                                2,
                                0,
                                2
                            ], {
                                offset: 8
                            }))) return {
                                ext: "eot",
                                mime: "application/octet-stream"
                            };
                            if (a([
                                0,
                                1,
                                0,
                                0,
                                0
                            ])) return {
                                ext: "ttf",
                                mime: "font/ttf"
                            };
                            if (a([
                                79,
                                84,
                                84,
                                79,
                                0
                            ])) return {
                                ext: "otf",
                                mime: "font/otf"
                            };
                            if (a([
                                0,
                                0,
                                1,
                                0
                            ])) return {
                                ext: "ico",
                                mime: "image/x-icon"
                            };
                            if (a([
                                0,
                                0,
                                2,
                                0
                            ])) return {
                                ext: "cur",
                                mime: "image/x-icon"
                            };
                            if (a([
                                70,
                                76,
                                86,
                                1
                            ])) return {
                                ext: "flv",
                                mime: "video/x-flv"
                            };
                            if (a([
                                37,
                                33
                            ])) return {
                                ext: "ps",
                                mime: "application/postscript"
                            };
                            if (a([
                                253,
                                55,
                                122,
                                88,
                                90,
                                0
                            ])) return {
                                ext: "xz",
                                mime: "application/x-xz"
                            };
                            if (a([
                                83,
                                81,
                                76,
                                105
                            ])) return {
                                ext: "sqlite",
                                mime: "application/x-sqlite3"
                            };
                            if (a([
                                78,
                                69,
                                83,
                                26
                            ])) return {
                                ext: "nes",
                                mime: "application/x-nintendo-nes-rom"
                            };
                            if (a([
                                67,
                                114,
                                50,
                                52
                            ])) return {
                                ext: "crx",
                                mime: "application/x-google-chrome-extension"
                            };
                            if (a([
                                77,
                                83,
                                67,
                                70
                            ]) || a([
                                73,
                                83,
                                99,
                                40
                            ])) return {
                                ext: "cab",
                                mime: "application/vnd.ms-cab-compressed"
                            };
                            if (a([
                                33,
                                60,
                                97,
                                114,
                                99,
                                104,
                                62,
                                10,
                                100,
                                101,
                                98,
                                105,
                                97,
                                110,
                                45,
                                98,
                                105,
                                110,
                                97,
                                114,
                                121
                            ])) return {
                                ext: "deb",
                                mime: "application/x-deb"
                            };
                            if (a([
                                33,
                                60,
                                97,
                                114,
                                99,
                                104,
                                62
                            ])) return {
                                ext: "ar",
                                mime: "application/x-unix-archive"
                            };
                            if (a([
                                237,
                                171,
                                238,
                                219
                            ])) return {
                                ext: "rpm",
                                mime: "application/x-rpm"
                            };
                            if (a([
                                31,
                                160
                            ]) || a([
                                31,
                                157
                            ])) return {
                                ext: "Z",
                                mime: "application/x-compress"
                            };
                            if (a([
                                76,
                                90,
                                73,
                                80
                            ])) return {
                                ext: "lz",
                                mime: "application/x-lzip"
                            };
                            if (a([
                                208,
                                207,
                                17,
                                224,
                                161,
                                177,
                                26,
                                225
                            ])) return {
                                ext: "msi",
                                mime: "application/x-msi"
                            };
                            if (a([
                                6,
                                14,
                                43,
                                52,
                                2,
                                5,
                                1,
                                1,
                                13,
                                1,
                                2,
                                1,
                                1,
                                2
                            ])) return {
                                ext: "mxf",
                                mime: "application/mxf"
                            };
                            if (a([
                                71
                            ], {
                                offset: 4
                            }) && (a([
                                71
                            ], {
                                offset: 192
                            }) || a([
                                71
                            ], {
                                offset: 196
                            }))) return {
                                ext: "mts",
                                mime: "video/mp2t"
                            };
                            if (a([
                                66,
                                76,
                                69,
                                78,
                                68,
                                69,
                                82
                            ])) return {
                                ext: "blend",
                                mime: "application/x-blender"
                            };
                            if (a([
                                66,
                                80,
                                71,
                                251
                            ])) return {
                                ext: "bpg",
                                mime: "image/bpg"
                            };
                            if (a([
                                0,
                                0,
                                0,
                                12,
                                106,
                                80,
                                32,
                                32,
                                13,
                                10,
                                135,
                                10
                            ])) {
                                if (a([
                                    106,
                                    112,
                                    50,
                                    32
                                ], {
                                    offset: 20
                                })) return {
                                    ext: "jp2",
                                    mime: "image/jp2"
                                };
                                if (a([
                                    106,
                                    112,
                                    120,
                                    32
                                ], {
                                    offset: 20
                                })) return {
                                    ext: "jpx",
                                    mime: "image/jpx"
                                };
                                if (a([
                                    106,
                                    112,
                                    109,
                                    32
                                ], {
                                    offset: 20
                                })) return {
                                    ext: "jpm",
                                    mime: "image/jpm"
                                };
                                if (a([
                                    109,
                                    106,
                                    112,
                                    50
                                ], {
                                    offset: 20
                                })) return {
                                    ext: "mj2",
                                    mime: "image/mj2"
                                };
                            }
                            if (a([
                                70,
                                79,
                                82,
                                77,
                                0
                            ])) return {
                                ext: "aif",
                                mime: "audio/aiff"
                            };
                            if (k("<?xml ")) return {
                                ext: "xml",
                                mime: "application/xml"
                            };
                            if (a([
                                66,
                                79,
                                79,
                                75,
                                77,
                                79,
                                66,
                                73
                            ], {
                                offset: 60
                            })) return {
                                ext: "mobi",
                                mime: "application/x-mobipocket-ebook"
                            };
                            if (a([
                                102,
                                116,
                                121,
                                112
                            ], {
                                offset: 4
                            })) {
                                if (a([
                                    109,
                                    105,
                                    102,
                                    49
                                ], {
                                    offset: 8
                                })) return {
                                    ext: "heic",
                                    mime: "image/heif"
                                };
                                if (a([
                                    109,
                                    115,
                                    102,
                                    49
                                ], {
                                    offset: 8
                                })) return {
                                    ext: "heic",
                                    mime: "image/heif-sequence"
                                };
                                if (a([
                                    104,
                                    101,
                                    105,
                                    99
                                ], {
                                    offset: 8
                                }) || a([
                                    104,
                                    101,
                                    105,
                                    120
                                ], {
                                    offset: 8
                                })) return {
                                    ext: "heic",
                                    mime: "image/heic"
                                };
                                if (a([
                                    104,
                                    101,
                                    118,
                                    99
                                ], {
                                    offset: 8
                                }) || a([
                                    104,
                                    101,
                                    118,
                                    120
                                ], {
                                    offset: 8
                                })) return {
                                    ext: "heic",
                                    mime: "image/heic-sequence"
                                };
                            }
                            return null;
                        };
                    },
                    {}
                ],
                2: [
                    function(b, g) {
                        Array.from || Object.defineProperty(Array, "from", {
                            configurable: !0,
                            writable: !0,
                            value: function(d, f, h) {
                                f = null != f ? f : function(a) {
                                    return a;
                                };
                                var l = [], e = "undefined" != typeof Symbol && Symbol.iterator && d[Symbol.iterator];
                                if ("function" == typeof e) {
                                    d = e.call(d);
                                    for(var k = 0; !(e = d.next()).done;)l.push(f.call(h, e.value, k++));
                                } else for(e = d.length, k = 0; k < e; k++)l.push(f.call(h, d[k], k));
                                return l;
                            }
                        });
                        g.exports = b("file-type");
                    },
                    {
                        "file-type": 1
                    }
                ]
            }, {}, [
                2
            ])(2);
        });
        return module1.exports;
    }();
    var api = {};
    (function() {
        var a = "function" == typeof Object.create ? Object.create : function(b) {
            function c() {}
            c.prototype = b;
            return new c;
        }, e;
        if ("function" == typeof Object.setPrototypeOf) e = Object.setPrototypeOf;
        else {
            var f;
            a: {
                var g = {
                    a: !0
                }, h = {};
                try {
                    h.__proto__ = g;
                    f = h.a;
                    break a;
                } catch (b) {}
                f = !1;
            }
            e = f ? function(b, c) {
                b.__proto__ = c;
                if (b.__proto__ !== c) throw new TypeError(b + " is not extensible");
                return b;
            } : null;
        }
        var k = e;
        var l = __dep__colibrio_core_base;
        var m = __dep__colibrio_core_io_base;
        var n = new Uint16Array(1);
        n[0] = 4660;
        new Uint8Array(n.buffer);
        function p(b) {
            !isNaN(0) && (b = b.slice(0, 16E3));
            return new Promise(function(c, x) {
                var d = new FileReader;
                d.onload = function() {
                    d.onabort = null;
                    d.onload = null;
                    d.onerror = null;
                    c(d.result);
                };
                d.onabort = d.onerror = function() {
                    d.onabort = null;
                    d.onload = null;
                    d.onerror = null;
                    x(d.error);
                };
                d.readAsArrayBuffer(b);
            });
        }
        var q = __lib__file_type;
        function r(b) {
            return (b = q(b)) ? b.mime : null;
        }
        function t(b, c) {
            return l.ColibrioError.call(this, "colibrio.core.io.mediatypedetector", b, c) || this;
        }
        var u = l.ColibrioError;
        t.prototype = a(u.prototype);
        t.prototype.constructor = t;
        if (k) k(t, u);
        else for(var v in u)if ("prototype" != v) {
            if (Object.defineProperties) {
                var w = Object.getOwnPropertyDescriptor(u, v);
                w && Object.defineProperty(t, v, w);
            } else t[v] = u[v];
        }
        api = {
            MediaTypeDetector: {
                detectFromBlob: function(b) {
                    return p(b).then(function(c) {
                        c = new Uint8Array(c);
                        return r(c);
                    });
                },
                detectFromUint8Array: r,
                getMediaTypeByExtension: function(b) {
                    var c = b.lastIndexOf(".");
                    -1 !== c && (b = b.slice(c + 1));
                    switch(b.toLowerCase()){
                        case "aac":
                            return m.MediaType.AUDIO_AAC;
                        case "css":
                            return m.MediaType.TEXT_CSS;
                        case "html":
                            return m.MediaType.TEXT_HTML;
                        case "jpg":
                            return m.MediaType.IMAGE_JPEG;
                        case "js":
                            return m.MediaType.TEXT_JAVASCRIPT;
                        case "mp3":
                            return m.MediaType.AUDIO_MPEG;
                        case "mp4":
                            return m.MediaType.VIDEO_MP4;
                        case "m4a":
                            return m.MediaType.AUDIO_MP4;
                        case "m4v":
                            return m.MediaType.VIDEO_MP4;
                        case "ogg":
                            return m.MediaType.AUDIO_OGG;
                        case "otf":
                            return m.MediaType.FONT_OTF;
                        case "png":
                            return m.MediaType.IMAGE_PNG;
                        case "ttc":
                        case "ttf":
                            return m.MediaType.FONT_TTF;
                        case "svg":
                            return m.MediaType.IMAGE_SVG;
                        case "wav":
                            return m.MediaType.AUDIO_WAV;
                        case "webm":
                            return m.MediaType.VIDEO_WEBM;
                        case "woff":
                            return m.MediaType.FONT_WOFF;
                        case "woff2":
                            return m.MediaType.FONT_WOFF2;
                        case "xhtml":
                            return m.MediaType.APPLICATION_XHTML;
                    }
                    return null;
                },
                getMediaTypesFromCategory: function(b) {
                    switch(b){
                        case m.MediaTypeCategory.FONT:
                            return [
                                m.MediaType.FONT_OTF,
                                m.MediaType.FONT_TTF,
                                m.MediaType.FONT_WOFF,
                                m.MediaType.FONT_WOFF2
                            ];
                        case m.MediaTypeCategory.IMAGE:
                            return [
                                m.MediaType.IMAGE_PNG,
                                m.MediaType.IMAGE_JPEG,
                                m.MediaType.IMAGE_SVG,
                                m.MediaType.IMAGE_GIF,
                                m.MediaType.IMAGE_BMP
                            ];
                        case m.MediaTypeCategory.VIDEO:
                            return [
                                m.MediaType.VIDEO_MP4,
                                m.MediaType.VIDEO_WEBM
                            ];
                        case m.MediaTypeCategory.AUDIO:
                            return [
                                m.MediaType.AUDIO_AAC,
                                m.MediaType.AUDIO_MPEG,
                                m.MediaType.AUDIO_MP4,
                                m.MediaType.AUDIO_OGG,
                                m.MediaType.AUDIO_WEBM,
                                m.MediaType.AUDIO_WAV,
                                m.MediaType.AUDIO_WAVE
                            ];
                    }
                    return [];
                }
            },
            MediaTypeDetectorError: t,
            MediaTypeDetectorErrorType: {
                INVALID_MEDIA_TYPE_CATEGORY: "INVALID_MEDIA_TYPE_CATEGORY"
            }
        };
        var y = new ArrayBuffer(8);
        new DataView(y);
        new Uint8Array(y);
    }).call(__self);
    return api;
});

});

parcelRegister("hrxPB", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";




(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("7uZag")), (parcelRequire("a75zb")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_io_mediatypedetector, __dep__colibrio_core_url) {
    var api = {};
    (function() {
        var h;
        function k(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var l = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, e) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = e.value;
            return a;
        };
        function m(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var e = a[b];
                if (e && e.Math == Math) return e;
            }
            throw Error("Cannot find global object");
        }
        var n = m(this);
        function q(a, b) {
            if (b) a: {
                var e = n;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var f = a[d];
                    if (!(f in e)) break a;
                    e = e[f];
                }
                a = a[a.length - 1];
                d = e[a];
                b = b(d);
                b != d && null != b && l(e, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        q("Symbol", function(a) {
            function b(c) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new e(d + (c || "") + "_" + f++, c);
            }
            function e(c, g) {
                this.g = c;
                l(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            e.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", f = 0;
            return b;
        });
        q("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), e = 0; e < b.length; e++){
                var d = n[b[e]];
                "function" === typeof d && "function" != typeof d.prototype[a] && l(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return r(k(this));
                    }
                });
            }
            return a;
        });
        function r(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        var aa = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, t;
        if ("function" == typeof Object.setPrototypeOf) t = Object.setPrototypeOf;
        else {
            var u;
            a: {
                var ba = {
                    a: !0
                }, v = {};
                try {
                    v.__proto__ = ba;
                    u = v.a;
                    break a;
                } catch (a) {}
                u = !1;
            }
            t = u ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var w = t;
        function x() {
            this.i = !1;
            this.g = null;
            this.I = void 0;
            this.j = 1;
            this.K = 0;
            this.h = null;
        }
        function y(a) {
            if (a.i) throw new TypeError("Generator is already running");
            a.i = !0;
        }
        x.prototype.H = function(a) {
            this.I = a;
        };
        function z(a, b) {
            a.h = {
                M: b,
                N: !0
            };
            a.j = a.K;
        }
        x.prototype.return = function(a) {
            this.h = {
                return: a
            };
            this.j = this.K;
        };
        function ca(a, b) {
            a.j = 2;
            return {
                value: b
            };
        }
        function da(a) {
            this.g = new x;
            this.h = a;
        }
        function ea(a, b) {
            y(a.g);
            var e = a.g.g;
            if (e) return A(a, "return" in e ? e["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return B(a);
        }
        function A(a, b, e, d) {
            try {
                var f = b.call(a.g.g, e);
                if (!(f instanceof Object)) throw new TypeError("Iterator result " + f + " is not an object");
                if (!f.done) return a.g.i = !1, f;
                var c = f.value;
            } catch (g) {
                return a.g.g = null, z(a.g, g), B(a);
            }
            a.g.g = null;
            d.call(a.g, c);
            return B(a);
        }
        function B(a) {
            for(; a.g.j;)try {
                var b = a.h(a.g);
                if (b) return a.g.i = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (e) {
                a.g.I = void 0, z(a.g, e);
            }
            a.g.i = !1;
            if (a.g.h) {
                b = a.g.h;
                a.g.h = null;
                if (b.N) throw b.M;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function fa(a) {
            this.next = function(b) {
                y(a.g);
                a.g.g ? b = A(a, a.g.g.next, b, a.g.H) : (a.g.H(b), b = B(a));
                return b;
            };
            this.throw = function(b) {
                y(a.g);
                a.g.g ? b = A(a, a.g.g["throw"], b, a.g.H) : (z(a.g, b), b = B(a));
                return b;
            };
            this.return = function(b) {
                return ea(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function ha(a) {
            function b(d) {
                return a.next(d);
            }
            function e(d) {
                return a.throw(d);
            }
            return new Promise(function(d, f) {
                function c(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, e).then(c, f);
                }
                c(a.next());
            });
        }
        var C = __dep__colibrio_core_base;
        var ia = __dep__colibrio_core_io_base;
        var D = __dep__colibrio_core_url;
        var E = new Uint16Array(1);
        E[0] = 4660;
        new Uint8Array(E.buffer);
        function F(a, b) {
            return C.ColibrioError.call(this, "colibrio.core.io.resourcecache", a, b) || this;
        }
        var G = C.ColibrioError;
        F.prototype = aa(G.prototype);
        F.prototype.constructor = F;
        if (w) w(F, G);
        else for(var H in G)if ("prototype" != H) {
            if (Object.defineProperties) {
                var I = Object.getOwnPropertyDescriptor(G, H);
                I && Object.defineProperty(F, H, I);
            } else F[H] = G[H];
        }
        function J(a) {
            this.h = a;
            this.j = [];
            this.g = !1;
            this.i = a.I++;
        }
        h = J.prototype;
        h.createUrlForContent = function(a, b, e) {
            a = this.h.h.createUrl(a, b, e).url;
            this.j.push(a);
            return a;
        };
        h.destroy = function() {
            var a = this;
            this.g || (this.g = !0, this.j.forEach(function(b) {
                a.h.h.revokeUrl(b);
            }), this.j = [], ja(this.h, this.i));
        };
        h.fetchBlob = function(a, b) {
            return this.g ? K() : ka(this.h, a, b, this.i);
        };
        h.fetchBrowserNativeUrl = function(a, b, e) {
            return this.g ? K() : la(this.h, a, b, e, this.i);
        };
        h.fetchText = function(a, b) {
            return this.g ? K() : ma(this.h, a, b, this.i);
        };
        h.fetchUint8Array = function(a, b) {
            return this.g ? K() : na(this.h, a, b, this.i);
        };
        h.isDestroyed = function() {
            return this.g;
        };
        function K() {
            return Promise.reject(new F(C.ColibrioErrorType.ABORTED));
        }
        function oa(a) {
            return new Promise(function(b, e) {
                var d = new FileReader;
                d.onload = function() {
                    d.onabort = null;
                    d.onload = null;
                    d.onerror = null;
                    b(d.result);
                };
                d.onabort = d.onerror = function() {
                    d.onabort = null;
                    d.onload = null;
                    d.onerror = null;
                    e(d.error);
                };
                d.readAsArrayBuffer(a);
            });
        }
        function L() {
            this.h = this.g = void 0;
            this.i = new TextDecoder("utf-8");
        }
        var M;
        L.prototype.decode = function(a) {
            return 2 <= a.length && 254 === a[0] && 255 === a[1] && (void 0 === this.g && (this.g = N("utf-16be")), this.g) ? this.g.decode(a) : 2 <= a.length && 255 === a[0] && 254 === a[1] && (void 0 === this.h && (this.h = N("utf-16le")), this.h) ? this.h.decode(a) : this.i.decode(a);
        };
        function N(a) {
            try {
                return new TextDecoder(a);
            } catch (b) {
                return console.error(b), null;
            }
        }
        function O(a) {
            this.H = a;
            this.h = new ia.BlobUrlManager;
            this.g = new Map;
            this.j = new Map;
            this.i = !1;
            this.I = 1;
            this.K = new TextEncoder;
        }
        function ka(a, b, e, d) {
            if (a.i) return P();
            b = Q(a, b);
            var f = R(a, b, e);
            d = S(a, d, f);
            f.B++;
            d.B++;
            if (f.l) return f.l;
            f.l = T(a, b, e, f).then(function(c) {
                U(a, f, f.l);
                return {
                    data: V(c),
                    metadata: c.metadata
                };
            }).catch(function(c) {
                W(a, f, f.l) && (C.Logger.logWarning("Unexpected ResourceCache error"), X(a, f));
                throw c;
            });
            return f.l;
        }
        function la(a, b, e, d, f) {
            if (a.i) return P();
            b = Q(a, b);
            var c = R(a, b, e);
            d = !C.RuntimePlatform.isBlobUrlSupported() || d;
            f = S(a, f, c);
            if (d) {
                if (c.F++, f.F++, c.v) return c.v;
            } else if (c.D++, f.D++, c.u) return c.u;
            !d && C.RuntimePlatform.isBlobUrlSupported() ? (c.l || (c.l = T(a, b, e, c).then(function(g) {
                U(a, c, c.u);
                return {
                    data: V(g),
                    metadata: g.metadata
                };
            }).catch(function(g) {
                W(a, c, c.u) && (C.Logger.logWarning("Unexpected ResourceCache error"), X(a, c));
                throw g;
            })), b = c.l.then(function(g) {
                U(a, c, c.u);
                c.C = a.h.createUrlForBlob(g.data);
                return {
                    data: c.C,
                    metadata: g.metadata
                };
            }).catch(function(g) {
                W(a, c, c.u) && (C.Logger.logWarning("Unexpected ResourceCache error"), X(a, c));
                throw g;
            })) : b = T(a, b, e, c).then(function(g) {
                U(a, c, c.v);
                return {
                    data: a.h.createUrl([
                        g.data
                    ], g.metadata.mediaType || "", !0).url,
                    metadata: g.metadata
                };
            }).catch(function(g) {
                W(a, c, c.v) && (C.Logger.logWarning("Unexpected ResourceCache error"), X(a, c));
                throw g;
            });
            d ? c.v = b : c.u = b;
            return b;
        }
        function ma(a, b, e, d) {
            if (a.i) return P();
            b = Q(a, b);
            var f = R(a, b, e);
            d = S(a, d, f);
            f.G++;
            d.G++;
            if (f.s) return f.s;
            f.s = T(a, b, e, f).then(function(c) {
                U(a, f, f.s);
                var g = c.data;
                "string" !== typeof g && (M || (M = new L), g = M.decode(g));
                return {
                    data: g,
                    metadata: c.metadata
                };
            }).catch(function(c) {
                W(a, f, f.s) && (C.Logger.logWarning("Unexpected ResourceCache error"), X(a, f));
                throw c;
            });
            return f.s;
        }
        function na(a, b, e, d) {
            if (a.i) return P();
            b = Q(a, b);
            var f = R(a, b, e);
            d = S(a, d, f);
            f.A++;
            d.A++;
            if (f.o) return f.o;
            f.o = T(a, b, e, f).then(function(c) {
                U(a, f, f.o);
                var g = c.data;
                return {
                    data: "string" === typeof g ? a.K.encode(g) : g,
                    metadata: c.metadata
                };
            }).catch(function(c) {
                W(a, f, f.o) && (C.Logger.logWarning("Unexpected ResourceCache error"), X(a, f));
                throw c;
            });
            return f.o;
        }
        function ja(a, b) {
            var e = a.j.get(b);
            a.j.delete(b);
            e && e.forEach(function(d, f) {
                var c = a.g.get(f);
                c && (c.A -= d.A, c.B -= d.B, c.D -= d.D, c.F -= d.F, c.G -= d.G, d = 0, 0 === c.A && (d++, c.o = null), 0 === c.D && (d++, c.C && (a.h.revokeUrl(c.C), c.C = null, c.u = null), 0 === c.B && (d++, c.l = null)), 0 === c.F && (d++, c.v = null), 0 === c.G && (d++, c.s = null), 5 === d && (c.m && (c.m.abort(), c.m = null), a.g.delete(f)));
            });
        }
        O.prototype.destroy = function() {
            this.i || (this.i = !0, this.g.forEach(function(a) {
                a.m && (a.m.abort(), a.m = null);
            }), this.g.clear(), this.j.clear(), this.h.revokeAllUrls());
        };
        O.prototype.getBackingResourceProvider = function() {
            return this.H;
        };
        function V(a) {
            var b = a.metadata.mediaType;
            return b ? new Blob([
                a.data
            ], {
                type: b
            }) : new Blob([
                a.data
            ]);
        }
        function X(a, b) {
            var e = b.J;
            b.m && (b.m.abort(), b.m = null);
            a.g.get(e) === b && (a.g.delete(e), b.C && a.h.revokeUrl(b.C), a.j.forEach(function(d) {
                d.delete(e);
            }));
        }
        function T(a, b, e, d) {
            return d.o ? d.o : d.s ? d.s : d.l && d.L ? d.l.then(function(f) {
                return oa(f.data).then(function(c) {
                    return {
                        data: new Uint8Array(c),
                        metadata: f.metadata
                    };
                });
            }) : d.v ? d.v.then(function(f) {
                U(a, d);
                var c = f.data, g = c.indexOf(","), p = null;
                if (-1 !== g) {
                    var pa = c.slice(0, g);
                    p = decodeURIComponent(c.slice(g + 1));
                    pa.endsWith("base64") && (p = C.Base64.decode(p));
                }
                return null === p ? Y(a, b, e, d) : {
                    data: p,
                    metadata: f.metadata
                };
            }) : Y(a, b, e, d);
        }
        function Y(a, b, e, d) {
            var f, c;
            return ha(new fa(new da(function(g) {
                if (1 == g.j) return ca(g, a.H.fetch(b, {
                    accept: e
                }));
                f = g.I;
                if (!W(a, d)) throw f.abort(), new F(C.ColibrioErrorType.ABORTED);
                c = f.getMetadata();
                d.m = f;
                d.L = c;
                return g.return(f.asUint8Array().then(function(p) {
                    return {
                        data: p,
                        metadata: c
                    };
                }).finally(function() {
                    d.m = null;
                }));
            })));
        }
        function S(a, b, e) {
            var d = a.j.get(b);
            d || (d = new Map, a.j.set(b, d));
            a = d.get(e.J);
            a || (a = {
                A: 0,
                B: 0,
                D: 0,
                F: 0,
                G: 0
            }, d.set(e.J, a));
            return a;
        }
        function P() {
            return Promise.reject(new F("RESOURCE_CACHE_HOST_DESTROYED"));
        }
        function R(a, b, e) {
            b = D.URLUtils.getUrlWithoutHash(b);
            e && 0 < e.length && (b += "#" + e.join("&"));
            e = b;
            b = a.g.get(e);
            b || (b = {
                A: 0,
                o: null,
                m: null,
                B: 0,
                l: null,
                C: null,
                D: 0,
                u: null,
                J: e,
                F: 0,
                v: null,
                L: null,
                G: 0,
                s: null
            }, a.g.set(e, b));
            return b;
        }
        function W(a, b, e) {
            return a.g.get(b.J) === b && null !== e;
        }
        function Q(a, b) {
            return "string" === typeof b ? D.URLUtils.normalizePathnameEncoding(new URL(b, a.H.getBaseUrl() || void 0)) : b;
        }
        function U(a, b, e) {
            if (!W(a, b, e)) throw new F(C.ColibrioErrorType.ABORTED);
        }
        api = {
            ResourceCacheClient: J,
            ResourceCacheError: F,
            ResourceCacheErrorType: {
                RESOURCE_CACHE_HOST_DESTROYED: "RESOURCE_CACHE_HOST_DESTROYED"
            },
            ResourceCacheHost: O
        };
        var Z = new ArrayBuffer(8);
        new DataView(Z);
        new Uint8Array(Z);
    }).call(__self);
    return api;
});

});


parcelRegister("fQRpb", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";


(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("bkFGj")), (parcelRequire("i64v9")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_selector_base, __dep__colibrio_core_base) {
    var api = {};
    (function() {
        var c;
        function e(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        function f(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return {
                next: e(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        var g = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, h;
        if ("function" == typeof Object.setPrototypeOf) h = Object.setPrototypeOf;
        else {
            var l;
            a: {
                var m = {
                    a: !0
                }, n = {};
                try {
                    n.__proto__ = m;
                    l = n.a;
                    break a;
                } catch (a) {}
                l = !1;
            }
            h = l ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var p = h;
        var q = __dep__colibrio_core_base;
        var r = __dep__colibrio_core_selector_base;
        function t(a) {
            return "number" === typeof a && !isNaN(a);
        }
        var u = new Uint16Array(1);
        u[0] = 4660;
        new Uint8Array(u.buffer);
        function w(a, b) {
            var d = r.FragmentSelector.call(this) || this;
            d.g = a;
            d.i = b;
            d.h = "";
            return d;
        }
        var x = r.FragmentSelector;
        w.prototype = g(x.prototype);
        w.prototype.constructor = w;
        if (p) p(w, x);
        else for(var y in x)if ("prototype" != y) {
            if (Object.defineProperties) {
                var z = Object.getOwnPropertyDescriptor(x, y);
                z && Object.defineProperty(w, y, z);
            } else w[y] = x[y];
        }
        c = w.prototype;
        c.collapseToEnd = function() {
            var a = this.g.timeInterval, b = this.i.map(function(d) {
                return d.collapseToEnd();
            });
            return a && a.endMs ? (a = a.endMs, new w({
                timeInterval: {
                    endMs: a,
                    startMs: a
                }
            }, b)) : new w(this.g, b);
        };
        c.collapseToStart = function() {
            var a = this.g.timeInterval, b = this.i.map(function(d) {
                return d.collapseToStart();
            });
            return a ? (a = a.startMs, new w({
                timeInterval: {
                    endMs: a,
                    startMs: a
                }
            }, b)) : new w(this.g, b);
        };
        c.createRangeSelectorTo = function(a) {
            if (a instanceof w && a.g.timeInterval && this.g.timeInterval) {
                var b = a.g.timeInterval;
                a = b.startMs;
                b = b.endMs;
                return new w({
                    timeInterval: {
                        endMs: t(b) ? b : a,
                        startMs: this.g.timeInterval.startMs
                    }
                }, []);
            }
            return null;
        };
        c.getFragmentSpecificationIri = function() {
            return r.FragmentSpecificationIri.MEDIA;
        };
        c.getRefinementSelectors = function() {
            return this.i;
        };
        c.getTimeInterval = function() {
            return this.g.timeInterval || null;
        };
        c.getValue = function() {
            if (!this.h && this.g.timeInterval) {
                var a = this.g.timeInterval, b = a.endMs;
                this.h = "t=" + a.startMs / 1E3 + (t(b) ? "," + b / 1E3 : "");
            }
            return this.h;
        };
        c.isRangeSelector = function() {
            var a = this.g.timeInterval;
            return a && a.endMs ? a.endMs > a.startMs : !1;
        };
        function A(a) {
            var b = f(a.split(",").map(function(k) {
                return k ? parseFloat(k) : void 0;
            }));
            a = b.next().value;
            var d = b.next().value;
            b = void 0 !== d ? isNaN(d) ? null : Math.round(1E3 * d) : void 0;
            a = t(a) ? Math.round(1E3 * a) : d ? 0 : void 0;
            if (void 0 !== a && null !== b) return {
                endMs: b,
                startMs: a
            };
        }
        var B = q.Logger.logError;
        function C() {}
        C.prototype.canParseFragment = function(a) {
            try {
                return new URLSearchParams(a.startsWith("#") ? a.slice(1) : a).has("t");
            } catch (b) {
                return B("Failed to decode fragment: ", a), !1;
            }
        };
        C.prototype.getFragmentSpecificationIri = function() {
            return r.FragmentSpecificationIri.MEDIA;
        };
        C.prototype.parseFragment = function(a, b, d) {
            return (a = new URLSearchParams(a.startsWith("#") ? a.slice(1) : a).getAll("t").reduce(function(k, E) {
                var v;
                return null != (v = A(E)) ? v : k;
            }, void 0)) ? new w({
                timeInterval: a
            }, d) : null;
        };
        api = {
            MediaFragmentSelector: w,
            MediaFragmentSelectorParser: C
        };
        var D = new ArrayBuffer(8);
        new DataView(D);
        new Uint8Array(D);
    }).call(__self);
    return api;
});

});

parcelRegister("kj8wo", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";



(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("a75zb")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_url) {
    var __lib__timsort = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        (function(u) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = u() : "function" === typeof define && define.amd ? define([], u) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = u();
        })(function() {
            return (function() {
                function u(x, C, z) {
                    function y(r, t) {
                        if (!C[r]) {
                            if (!x[r]) {
                                var D = undefined;
                                if (!t && D) return D(r, !0);
                                if (A) return A(r, !0);
                                t = Error("Cannot find module '" + r + "'");
                                throw t.code = "MODULE_NOT_FOUND", t;
                            }
                            t = C[r] = {
                                exports: {}
                            };
                            x[r][0].call(t.exports, function(F) {
                                return y(x[r][1][F] || F);
                            }, t, t.exports, u, x, C, z);
                        }
                        return C[r].exports;
                    }
                    for(var A = undefined, E = 0; E < z.length; E++)y(z[E]);
                    return y;
                }
                return u;
            })()({
                1: [
                    function(u, x, C) {
                        (function(z, y) {
                            if ("undefined" !== typeof C) y(C);
                            else {
                                var A = {};
                                y(A);
                                z.timsort = A;
                            }
                        })(void 0, function(z) {
                            function y(g) {
                                return 1E5 > g ? 100 > g ? 10 > g ? 0 : 1 : 1E4 > g ? 1E3 > g ? 2 : 3 : 4 : 1E7 > g ? 1E6 > g ? 5 : 6 : 1E9 > g ? 1E8 > g ? 7 : 8 : 9;
                            }
                            function A(g, a) {
                                if (g === a) return 0;
                                if (~~g === g && ~~a === a) {
                                    if (0 === g || 0 === a) return g < a ? -1 : 1;
                                    if (0 > g || 0 > a) {
                                        if (0 <= a) return -1;
                                        if (0 <= g) return 1;
                                        g = -g;
                                        a = -a;
                                    }
                                    var h = y(g), c = y(a), e = 0;
                                    h < c ? (g *= G[c - h - 1], a /= 10, e = -1) : h > c && (a *= G[h - c - 1], g /= 10, e = 1);
                                    return g === a ? e : g < a ? -1 : 1;
                                }
                                g = String(g);
                                a = String(a);
                                return g === a ? 0 : g < a ? -1 : 1;
                            }
                            function E(g, a, h, c) {
                                var e = a + 1;
                                if (e === h) return 1;
                                if (0 > c(g[e++], g[a])) {
                                    for(; e < h && 0 > c(g[e], g[e - 1]);)e++;
                                    h = a;
                                    c = e;
                                    for(c--; h < c;){
                                        var k = g[h];
                                        g[h++] = g[c];
                                        g[c--] = k;
                                    }
                                } else for(; e < h && 0 <= c(g[e], g[e - 1]);)e++;
                                return e - a;
                            }
                            function r(g, a, h, c, e) {
                                for(c === a && c++; c < h; c++){
                                    for(var k = g[c], d = a, b = c; d < b;){
                                        var f = d + b >>> 1;
                                        0 > e(k, g[f]) ? b = f : d = f + 1;
                                    }
                                    b = c - d;
                                    switch(b){
                                        case 3:
                                            g[d + 3] = g[d + 2];
                                        case 2:
                                            g[d + 2] = g[d + 1];
                                        case 1:
                                            g[d + 1] = g[d];
                                            break;
                                        default:
                                            for(; 0 < b;)g[d + b] = g[d + b - 1], b--;
                                    }
                                    g[d] = k;
                                }
                            }
                            function t(g, a, h, c, e, k) {
                                var d = 0, b = 1;
                                if (0 < k(g, a[h + e])) {
                                    for(c -= e; b < c && 0 < k(g, a[h + e + b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    d += e;
                                    b += e;
                                } else {
                                    for(c = e + 1; b < c && 0 >= k(g, a[h + e - b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    c = d;
                                    d = e - b;
                                    b = e - c;
                                }
                                for(d++; d < b;)e = d + (b - d >>> 1), 0 < k(g, a[h + e]) ? d = e + 1 : b = e;
                                return b;
                            }
                            function D(g, a, h, c, e, k) {
                                var d = 0, b = 1;
                                if (0 > k(g, a[h + e])) {
                                    for(c = e + 1; b < c && 0 > k(g, a[h + e - b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    c = d;
                                    d = e - b;
                                    b = e - c;
                                } else {
                                    for(c -= e; b < c && 0 <= k(g, a[h + e + b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    d += e;
                                    b += e;
                                }
                                for(d++; d < b;)e = d + (b - d >>> 1), 0 > k(g, a[h + e]) ? b = e : d = e + 1;
                                return b;
                            }
                            z.__esModule = !0;
                            z.sort = function(g, a, h, c) {
                                if (!Array.isArray(g)) throw new TypeError("Can only sort arrays");
                                a ? "function" !== typeof a && (c = h, h = a, a = A) : a = A;
                                h || (h = 0);
                                c || (c = g.length);
                                var e = c - h;
                                if (!(2 > e)) {
                                    if (e < F) {
                                        var k = E(g, h, c, a);
                                        r(g, h, c, h + k, a);
                                    } else {
                                        var d = new H(g, a), b;
                                        k = e;
                                        for(b = 0; k >= F;)b |= k & 1, k >>= 1;
                                        b = k + b;
                                        do {
                                            k = E(g, h, c, a);
                                            if (k < b) {
                                                var f = e;
                                                f > b && (f = b);
                                                r(g, h, h + f, h + k, a);
                                                k = f;
                                            }
                                            d.pushRun(h, k);
                                            d.mergeRuns();
                                            e -= k;
                                            h += k;
                                        }while (0 !== e);
                                        d.forceMergeRuns();
                                    }
                                }
                            };
                            var F = 32, G = [
                                1,
                                10,
                                100,
                                1E3,
                                1E4,
                                1E5,
                                1E6,
                                1E7,
                                1E8,
                                1E9
                            ], H = function() {
                                function g(a, h) {
                                    if (!(this instanceof g)) throw new TypeError("Cannot call a class as a function");
                                    this.compare = this.array = null;
                                    this.minGallop = 7;
                                    this.length = 0;
                                    this.tmpStorageLength = 256;
                                    this.stackLength = 0;
                                    this.runLength = this.runStart = null;
                                    this.stackSize = 0;
                                    this.array = a;
                                    this.compare = h;
                                    this.length = a.length;
                                    512 > this.length && (this.tmpStorageLength = this.length >>> 1);
                                    this.tmp = Array(this.tmpStorageLength);
                                    this.stackLength = 120 > this.length ? 5 : 1542 > this.length ? 10 : 119151 > this.length ? 19 : 40;
                                    this.runStart = Array(this.stackLength);
                                    this.runLength = Array(this.stackLength);
                                }
                                g.prototype.pushRun = function(a, h) {
                                    this.runStart[this.stackSize] = a;
                                    this.runLength[this.stackSize] = h;
                                    this.stackSize += 1;
                                };
                                g.prototype.mergeRuns = function() {
                                    for(; 1 < this.stackSize;){
                                        var a = this.stackSize - 2;
                                        if (1 <= a && this.runLength[a - 1] <= this.runLength[a] + this.runLength[a + 1] || 2 <= a && this.runLength[a - 2] <= this.runLength[a] + this.runLength[a - 1]) this.runLength[a - 1] < this.runLength[a + 1] && a--;
                                        else if (this.runLength[a] > this.runLength[a + 1]) break;
                                        this.mergeAt(a);
                                    }
                                };
                                g.prototype.forceMergeRuns = function() {
                                    for(; 1 < this.stackSize;){
                                        var a = this.stackSize - 2;
                                        0 < a && this.runLength[a - 1] < this.runLength[a + 1] && a--;
                                        this.mergeAt(a);
                                    }
                                };
                                g.prototype.mergeAt = function(a) {
                                    var h = this.compare, c = this.array, e = this.runStart[a], k = this.runLength[a], d = this.runStart[a + 1], b = this.runLength[a + 1];
                                    this.runLength[a] = k + b;
                                    a === this.stackSize - 3 && (this.runStart[a + 1] = this.runStart[a + 2], this.runLength[a + 1] = this.runLength[a + 2]);
                                    this.stackSize--;
                                    a = D(c[d], c, e, k, 0, h);
                                    e += a;
                                    k -= a;
                                    0 !== k && (b = t(c[e + k - 1], c, d, b, b - 1, h), 0 !== b && (k <= b ? this.mergeLow(e, k, d, b) : this.mergeHigh(e, k, d, b)));
                                };
                                g.prototype.mergeLow = function(a, h, c, e) {
                                    var k = this.compare, d = this.array, b = this.tmp, f;
                                    for(f = 0; f < h; f++)b[f] = d[a + f];
                                    var m = 0;
                                    d[a++] = d[c++];
                                    if (0 === --e) for(f = 0; f < h; f++)d[a + f] = b[m + f];
                                    else if (1 === h) {
                                        for(f = 0; f < e; f++)d[a + f] = d[c + f];
                                        d[a + e] = b[m];
                                    } else {
                                        for(var p = this.minGallop;;){
                                            var l = 0, n = 0, q = !1;
                                            do if (0 > k(d[c], b[m])) {
                                                if (d[a++] = d[c++], n++, l = 0, 0 === --e) {
                                                    q = !0;
                                                    break;
                                                }
                                            } else if (d[a++] = b[m++], l++, n = 0, 1 === --h) {
                                                q = !0;
                                                break;
                                            }
                                            while ((l | n) < p);
                                            if (q) break;
                                            do {
                                                l = D(d[c], b, m, h, 0, k);
                                                if (0 !== l) {
                                                    for(f = 0; f < l; f++)d[a + f] = b[m + f];
                                                    a += l;
                                                    m += l;
                                                    h -= l;
                                                    if (1 >= h) {
                                                        q = !0;
                                                        break;
                                                    }
                                                }
                                                d[a++] = d[c++];
                                                if (0 === --e) {
                                                    q = !0;
                                                    break;
                                                }
                                                n = t(b[m], d, c, e, 0, k);
                                                if (0 !== n) {
                                                    for(f = 0; f < n; f++)d[a + f] = d[c + f];
                                                    a += n;
                                                    c += n;
                                                    e -= n;
                                                    if (0 === e) {
                                                        q = !0;
                                                        break;
                                                    }
                                                }
                                                d[a++] = b[m++];
                                                if (1 === --h) {
                                                    q = !0;
                                                    break;
                                                }
                                                p--;
                                            }while (7 <= l || 7 <= n);
                                            if (q) break;
                                            0 > p && (p = 0);
                                            p += 2;
                                        }
                                        this.minGallop = p;
                                        1 > p && (this.minGallop = 1);
                                        if (1 === h) {
                                            for(f = 0; f < e; f++)d[a + f] = d[c + f];
                                            d[a + e] = b[m];
                                        } else {
                                            if (0 === h) throw Error("mergeLow preconditions were not respected");
                                            for(f = 0; f < h; f++)d[a + f] = b[m + f];
                                        }
                                    }
                                };
                                g.prototype.mergeHigh = function(a, h, c, e) {
                                    var k = this.compare, d = this.array, b = this.tmp, f;
                                    for(f = 0; f < e; f++)b[f] = d[c + f];
                                    var m = a + h - 1, p = e - 1;
                                    c = c + e - 1;
                                    d[c--] = d[m--];
                                    if (0 === --h) {
                                        var l = c - (e - 1);
                                        for(f = 0; f < e; f++)d[l + f] = b[f];
                                    } else if (1 === e) {
                                        c -= h;
                                        var n = c + 1;
                                        l = m - h + 1;
                                        for(f = h - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                        d[c] = b[p];
                                    } else {
                                        for(var q = this.minGallop;;){
                                            var v = 0, w = 0, B = !1;
                                            do if (0 > k(b[p], d[m])) {
                                                if (d[c--] = d[m--], v++, w = 0, 0 === --h) {
                                                    B = !0;
                                                    break;
                                                }
                                            } else if (d[c--] = b[p--], w++, v = 0, 1 === --e) {
                                                B = !0;
                                                break;
                                            }
                                            while ((v | w) < q);
                                            if (B) break;
                                            do {
                                                v = h - D(b[p], d, a, h, h - 1, k);
                                                if (0 !== v) {
                                                    c -= v;
                                                    m -= v;
                                                    h -= v;
                                                    n = c + 1;
                                                    l = m + 1;
                                                    for(f = v - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                                    if (0 === h) {
                                                        B = !0;
                                                        break;
                                                    }
                                                }
                                                d[c--] = b[p--];
                                                if (1 === --e) {
                                                    B = !0;
                                                    break;
                                                }
                                                w = e - t(d[m], b, 0, e, e - 1, k);
                                                if (0 !== w) {
                                                    c -= w;
                                                    p -= w;
                                                    e -= w;
                                                    n = c + 1;
                                                    l = p + 1;
                                                    for(f = 0; f < w; f++)d[n + f] = b[l + f];
                                                    if (1 >= e) {
                                                        B = !0;
                                                        break;
                                                    }
                                                }
                                                d[c--] = d[m--];
                                                if (0 === --h) {
                                                    B = !0;
                                                    break;
                                                }
                                                q--;
                                            }while (7 <= v || 7 <= w);
                                            if (B) break;
                                            0 > q && (q = 0);
                                            q += 2;
                                        }
                                        this.minGallop = q;
                                        1 > q && (this.minGallop = 1);
                                        if (1 === e) {
                                            c -= h;
                                            n = c + 1;
                                            l = m - h + 1;
                                            for(f = h - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                            d[c] = b[p];
                                        } else {
                                            if (0 === e) throw Error("mergeHigh preconditions were not respected");
                                            l = c - (e - 1);
                                            for(f = 0; f < e; f++)d[l + f] = b[f];
                                        }
                                    }
                                };
                                return g;
                            }();
                        });
                    },
                    {}
                ],
                2: [
                    function(u, x) {
                        x.exports = u("./build/timsort.js");
                    },
                    {
                        "./build/timsort.js": 1
                    }
                ],
                3: [
                    function(u, x) {
                        x.exports = u("timsort");
                    },
                    {
                        timsort: 2
                    }
                ]
            }, {}, [
                3
            ])(3);
        });
        return module1.exports;
    }();
    var __worker__colibrio_core_io_resourceprovider_zip_webworker = '\'use strict\'; (function (__self) { var __lib__timsort = (function () { var exports = {}; var module = { exports: exports }; var define = void 0; (function(u){"object"===typeof exports&&"undefined"!==typeof module?module.exports=u():"function"===typeof define&&define.amd?define([],u):("undefined"!==typeof window?window:"undefined"!==typeof global?global:"undefined"!==typeof self?self:this).lib=u()})(function(){return function(){function u(x,C,z){function y(r,t){if(!C[r]){if(!x[r]){var D="function"==typeof require&&require;if(!t&&D)return D(r,!0);if(A)return A(r,!0);t=Error("Cannot find module \'"+r+"\'");throw t.code="MODULE_NOT_FOUND",t;}t=\nC[r]={exports:{}};x[r][0].call(t.exports,function(F){return y(x[r][1][F]||F)},t,t.exports,u,x,C,z)}return C[r].exports}for(var A="function"==typeof require&&require,E=0;E<z.length;E++)y(z[E]);return y}return u}()({1:[function(u,x,C){(function(z,y){if("undefined"!==typeof C)y(C);else{var A={};y(A);z.timsort=A}})(void 0,function(z){function y(g){return 1E5>g?100>g?10>g?0:1:1E4>g?1E3>g?2:3:4:1E7>g?1E6>g?5:6:1E9>g?1E8>g?7:8:9}function A(g,a){if(g===a)return 0;if(~~g===g&&~~a===a){if(0===g||0===a)return g<\na?-1:1;if(0>g||0>a){if(0<=a)return-1;if(0<=g)return 1;g=-g;a=-a}var h=y(g),c=y(a),e=0;h<c?(g*=G[c-h-1],a/=10,e=-1):h>c&&(a*=G[h-c-1],g/=10,e=1);return g===a?e:g<a?-1:1}g=String(g);a=String(a);return g===a?0:g<a?-1:1}function E(g,a,h,c){var e=a+1;if(e===h)return 1;if(0>c(g[e++],g[a])){for(;e<h&&0>c(g[e],g[e-1]);)e++;h=a;c=e;for(c--;h<c;){var k=g[h];g[h++]=g[c];g[c--]=k}}else for(;e<h&&0<=c(g[e],g[e-1]);)e++;return e-a}function r(g,a,h,c,e){for(c===a&&c++;c<h;c++){for(var k=g[c],d=a,b=c;d<b;){var f=\nd+b>>>1;0>e(k,g[f])?b=f:d=f+1}b=c-d;switch(b){case 3:g[d+3]=g[d+2];case 2:g[d+2]=g[d+1];case 1:g[d+1]=g[d];break;default:for(;0<b;)g[d+b]=g[d+b-1],b--}g[d]=k}}function t(g,a,h,c,e,k){var d=0,b=1;if(0<k(g,a[h+e])){for(c-=e;b<c&&0<k(g,a[h+e+b]);)d=b,b=(b<<1)+1,0>=b&&(b=c);b>c&&(b=c);d+=e;b+=e}else{for(c=e+1;b<c&&0>=k(g,a[h+e-b]);)d=b,b=(b<<1)+1,0>=b&&(b=c);b>c&&(b=c);c=d;d=e-b;b=e-c}for(d++;d<b;)e=d+(b-d>>>1),0<k(g,a[h+e])?d=e+1:b=e;return b}function D(g,a,h,c,e,k){var d=0,b=1;if(0>k(g,a[h+e])){for(c=\ne+1;b<c&&0>k(g,a[h+e-b]);)d=b,b=(b<<1)+1,0>=b&&(b=c);b>c&&(b=c);c=d;d=e-b;b=e-c}else{for(c-=e;b<c&&0<=k(g,a[h+e+b]);)d=b,b=(b<<1)+1,0>=b&&(b=c);b>c&&(b=c);d+=e;b+=e}for(d++;d<b;)e=d+(b-d>>>1),0>k(g,a[h+e])?b=e:d=e+1;return b}z.__esModule=!0;z.sort=function(g,a,h,c){if(!Array.isArray(g))throw new TypeError("Can only sort arrays");a?"function"!==typeof a&&(c=h,h=a,a=A):a=A;h||(h=0);c||(c=g.length);var e=c-h;if(!(2>e))if(e<F){var k=E(g,h,c,a);r(g,h,c,h+k,a)}else{var d=new H(g,a),b;k=e;for(b=0;k>=F;)b|=\nk&1,k>>=1;b=k+b;do{k=E(g,h,c,a);if(k<b){var f=e;f>b&&(f=b);r(g,h,h+f,h+k,a);k=f}d.pushRun(h,k);d.mergeRuns();e-=k;h+=k}while(0!==e);d.forceMergeRuns()}};var F=32,G=[1,10,100,1E3,1E4,1E5,1E6,1E7,1E8,1E9],H=function(){function g(a,h){if(!(this instanceof g))throw new TypeError("Cannot call a class as a function");this.compare=this.array=null;this.minGallop=7;this.length=0;this.tmpStorageLength=256;this.stackLength=0;this.runLength=this.runStart=null;this.stackSize=0;this.array=a;this.compare=h;this.length=\na.length;512>this.length&&(this.tmpStorageLength=this.length>>>1);this.tmp=Array(this.tmpStorageLength);this.stackLength=120>this.length?5:1542>this.length?10:119151>this.length?19:40;this.runStart=Array(this.stackLength);this.runLength=Array(this.stackLength)}g.prototype.pushRun=function(a,h){this.runStart[this.stackSize]=a;this.runLength[this.stackSize]=h;this.stackSize+=1};g.prototype.mergeRuns=function(){for(;1<this.stackSize;){var a=this.stackSize-2;if(1<=a&&this.runLength[a-1]<=this.runLength[a]+\nthis.runLength[a+1]||2<=a&&this.runLength[a-2]<=this.runLength[a]+this.runLength[a-1])this.runLength[a-1]<this.runLength[a+1]&&a--;else if(this.runLength[a]>this.runLength[a+1])break;this.mergeAt(a)}};g.prototype.forceMergeRuns=function(){for(;1<this.stackSize;){var a=this.stackSize-2;0<a&&this.runLength[a-1]<this.runLength[a+1]&&a--;this.mergeAt(a)}};g.prototype.mergeAt=function(a){var h=this.compare,c=this.array,e=this.runStart[a],k=this.runLength[a],d=this.runStart[a+1],b=this.runLength[a+1];this.runLength[a]=\nk+b;a===this.stackSize-3&&(this.runStart[a+1]=this.runStart[a+2],this.runLength[a+1]=this.runLength[a+2]);this.stackSize--;a=D(c[d],c,e,k,0,h);e+=a;k-=a;0!==k&&(b=t(c[e+k-1],c,d,b,b-1,h),0!==b&&(k<=b?this.mergeLow(e,k,d,b):this.mergeHigh(e,k,d,b)))};g.prototype.mergeLow=function(a,h,c,e){var k=this.compare,d=this.array,b=this.tmp,f;for(f=0;f<h;f++)b[f]=d[a+f];var m=0;d[a++]=d[c++];if(0===--e)for(f=0;f<h;f++)d[a+f]=b[m+f];else if(1===h){for(f=0;f<e;f++)d[a+f]=d[c+f];d[a+e]=b[m]}else{for(var p=this.minGallop;;){var l=\n0,n=0,q=!1;do if(0>k(d[c],b[m])){if(d[a++]=d[c++],n++,l=0,0===--e){q=!0;break}}else if(d[a++]=b[m++],l++,n=0,1===--h){q=!0;break}while((l|n)<p);if(q)break;do{l=D(d[c],b,m,h,0,k);if(0!==l){for(f=0;f<l;f++)d[a+f]=b[m+f];a+=l;m+=l;h-=l;if(1>=h){q=!0;break}}d[a++]=d[c++];if(0===--e){q=!0;break}n=t(b[m],d,c,e,0,k);if(0!==n){for(f=0;f<n;f++)d[a+f]=d[c+f];a+=n;c+=n;e-=n;if(0===e){q=!0;break}}d[a++]=b[m++];if(1===--h){q=!0;break}p--}while(7<=l||7<=n);if(q)break;0>p&&(p=0);p+=2}this.minGallop=p;1>p&&(this.minGallop=\n1);if(1===h){for(f=0;f<e;f++)d[a+f]=d[c+f];d[a+e]=b[m]}else{if(0===h)throw Error("mergeLow preconditions were not respected");for(f=0;f<h;f++)d[a+f]=b[m+f]}}};g.prototype.mergeHigh=function(a,h,c,e){var k=this.compare,d=this.array,b=this.tmp,f;for(f=0;f<e;f++)b[f]=d[c+f];var m=a+h-1,p=e-1;c=c+e-1;d[c--]=d[m--];if(0===--h){var l=c-(e-1);for(f=0;f<e;f++)d[l+f]=b[f]}else if(1===e){c-=h;var n=c+1;l=m-h+1;for(f=h-1;0<=f;f--)d[n+f]=d[l+f];d[c]=b[p]}else{for(var q=this.minGallop;;){var v=0,w=0,B=!1;do if(0>\nk(b[p],d[m])){if(d[c--]=d[m--],v++,w=0,0===--h){B=!0;break}}else if(d[c--]=b[p--],w++,v=0,1===--e){B=!0;break}while((v|w)<q);if(B)break;do{v=h-D(b[p],d,a,h,h-1,k);if(0!==v){c-=v;m-=v;h-=v;n=c+1;l=m+1;for(f=v-1;0<=f;f--)d[n+f]=d[l+f];if(0===h){B=!0;break}}d[c--]=b[p--];if(1===--e){B=!0;break}w=e-t(d[m],b,0,e,e-1,k);if(0!==w){c-=w;p-=w;e-=w;n=c+1;l=p+1;for(f=0;f<w;f++)d[n+f]=b[l+f];if(1>=e){B=!0;break}}d[c--]=d[m--];if(0===--h){B=!0;break}q--}while(7<=v||7<=w);if(B)break;0>q&&(q=0);q+=2}this.minGallop=\nq;1>q&&(this.minGallop=1);if(1===e){c-=h;n=c+1;l=m-h+1;for(f=h-1;0<=f;f--)d[n+f]=d[l+f];d[c]=b[p]}else{if(0===e)throw Error("mergeHigh preconditions were not respected");l=c-(e-1);for(f=0;f<e;f++)d[l+f]=b[f]}}};return g}()})},{}],2:[function(u,x){x.exports=u("./build/timsort.js")},{"./build/timsort.js":1}],3:[function(u,x){x.exports=u("timsort")},{timsort:2}]},{},[3])(3)});\n return module.exports; })(); (function () { var p;function aa(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var ba="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};\nfunction ca(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var q=ca(this);function t(a,b){if(b)a:{var c=q;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))break a;c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&ba(c,a,{configurable:!0,writable:!0,value:b})}}\nt("Symbol",function(a){function b(h){if(this instanceof b)throw new TypeError("Symbol is not a constructor");return new c(d+(h||"")+"_"+e++,h)}function c(h,f){this.g=h;ba(this,"description",{configurable:!0,writable:!0,value:f})}if(a)return a;c.prototype.toString=function(){return this.g};var d="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",e=0;return b});\nt("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=q[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&ba(d.prototype,a,{configurable:!0,writable:!0,value:function(){return da(aa(this))}})}return a});function da(a){a={next:a};a[Symbol.iterator]=function(){return this};return a}\nfunction u(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];if(b)return b.call(a);if("number"==typeof a.length)return{next:aa(a)};throw Error(String(a)+" is not an iterable or ArrayLike");}function w(a){if(!(a instanceof Array)){a=u(a);for(var b,c=[];!(b=a.next()).done;)c.push(b.value);a=c}return a}var ea="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},fa;\nif("function"==typeof Object.setPrototypeOf)fa=Object.setPrototypeOf;else{var ha;a:{var ia={a:!0},ja={};try{ja.__proto__=ia;ha=ja.a;break a}catch(a){}ha=!1}fa=ha?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var ka=fa;\nfunction x(a,b){a.prototype=ea(b.prototype);a.prototype.constructor=a;if(ka)ka(a,b);else for(var c in b)if("prototype"!=c)if(Object.defineProperties){var d=Object.getOwnPropertyDescriptor(b,c);d&&Object.defineProperty(a,c,d)}else a[c]=b[c];a.Ca=b.prototype}function la(){this.l=!1;this.i=null;this.h=void 0;this.g=1;this.A=this.o=0;this.j=null}function ma(a){if(a.l)throw new TypeError("Generator is already running");a.l=!0}la.prototype.u=function(a){this.h=a};\nfunction na(a,b){a.j={ha:b,za:!0};a.g=a.o||a.A}la.prototype.return=function(a){this.j={return:a};this.g=this.A};function y(a,b,c){a.g=c;return{value:b}}function oa(a){a.o=0;var b=a.j.ha;a.j=null;return b}function pa(a){this.g=new la;this.h=a}function qa(a,b){ma(a.g);var c=a.g.i;if(c)return ra(a,"return"in c?c["return"]:function(d){return{value:d,done:!0}},b,a.g.return);a.g.return(b);return z(a)}\nfunction ra(a,b,c,d){try{var e=b.call(a.g.i,c);if(!(e instanceof Object))throw new TypeError("Iterator result "+e+" is not an object");if(!e.done)return a.g.l=!1,e;var h=e.value}catch(f){return a.g.i=null,na(a.g,f),z(a)}a.g.i=null;d.call(a.g,h);return z(a)}function z(a){for(;a.g.g;)try{var b=a.h(a.g);if(b)return a.g.l=!1,{value:b.value,done:!1}}catch(c){a.g.h=void 0,na(a.g,c)}a.g.l=!1;if(a.g.j){b=a.g.j;a.g.j=null;if(b.za)throw b.ha;return{value:b.return,done:!0}}return{value:void 0,done:!0}}\nfunction sa(a){this.next=function(b){ma(a.g);a.g.i?b=ra(a,a.g.i.next,b,a.g.u):(a.g.u(b),b=z(a));return b};this.throw=function(b){ma(a.g);a.g.i?b=ra(a,a.g.i["throw"],b,a.g.u):(na(a.g,b),b=z(a));return b};this.return=function(b){return qa(a,b)};this[Symbol.iterator]=function(){return this}}function ta(a){function b(d){return a.next(d)}function c(d){return a.throw(d)}return new Promise(function(d,e){function h(f){f.done?d(f.value):Promise.resolve(f.value).then(b,c).then(h,e)}h(a.next())})}\nfunction A(a){return ta(new sa(new pa(a)))}function B(){for(var a=Number(this),b=[],c=a;c<arguments.length;c++)b[c-a]=arguments[c];return b}\nt("Promise",function(a){function b(f){this.h=0;this.i=void 0;this.g=[];this.u=!1;var g=this.j();try{f(g.resolve,g.reject)}catch(k){g.reject(k)}}function c(){this.g=null}function d(f){return f instanceof b?f:new b(function(g){g(f)})}if(a)return a;c.prototype.h=function(f){if(null==this.g){this.g=[];var g=this;this.i(function(){g.l()})}this.g.push(f)};var e=q.setTimeout;c.prototype.i=function(f){e(f,0)};c.prototype.l=function(){for(;this.g&&this.g.length;){var f=this.g;this.g=[];for(var g=0;g<f.length;++g){var k=\nf[g];f[g]=null;try{k()}catch(l){this.j(l)}}}this.g=null};c.prototype.j=function(f){this.i(function(){throw f;})};b.prototype.j=function(){function f(l){return function(m){k||(k=!0,l.call(g,m))}}var g=this,k=!1;return{resolve:f(this.pa),reject:f(this.l)}};b.prototype.pa=function(f){if(f===this)this.l(new TypeError("A Promise cannot resolve to itself"));else if(f instanceof b)this.ra(f);else{a:switch(typeof f){case "object":var g=null!=f;break a;case "function":g=!0;break a;default:g=!1}g?this.N(f):\nthis.o(f)}};b.prototype.N=function(f){var g=void 0;try{g=f.then}catch(k){this.l(k);return}"function"==typeof g?this.sa(g,f):this.o(f)};b.prototype.l=function(f){this.A(2,f)};b.prototype.o=function(f){this.A(1,f)};b.prototype.A=function(f,g){if(0!=this.h)throw Error("Cannot settle("+f+", "+g+"): Promise already settled in state"+this.h);this.h=f;this.i=g;2===this.h&&this.qa();this.C()};b.prototype.qa=function(){var f=this;e(function(){if(f.G()){var g=q.console;"undefined"!==typeof g&&g.error(f.i)}},\n1)};b.prototype.G=function(){if(this.u)return!1;var f=q.CustomEvent,g=q.Event,k=q.dispatchEvent;if("undefined"===typeof k)return!0;"function"===typeof f?f=new f("unhandledrejection",{cancelable:!0}):"function"===typeof g?f=new g("unhandledrejection",{cancelable:!0}):(f=q.document.createEvent("CustomEvent"),f.initCustomEvent("unhandledrejection",!1,!0,f));f.promise=this;f.reason=this.i;return k(f)};b.prototype.C=function(){if(null!=this.g){for(var f=0;f<this.g.length;++f)h.h(this.g[f]);this.g=null}};\nvar h=new c;b.prototype.ra=function(f){var g=this.j();f.T(g.resolve,g.reject)};b.prototype.sa=function(f,g){var k=this.j();try{f.call(g,k.resolve,k.reject)}catch(l){k.reject(l)}};b.prototype.then=function(f,g){function k(r,v){return"function"==typeof r?function(K){try{l(r(K))}catch(L){m(L)}}:v}var l,m,n=new b(function(r,v){l=r;m=v});this.T(k(f,l),k(g,m));return n};b.prototype.catch=function(f){return this.then(void 0,f)};b.prototype.T=function(f,g){function k(){switch(l.h){case 1:f(l.i);break;case 2:g(l.i);\nbreak;default:throw Error("Unexpected state: "+l.h);}}var l=this;null==this.g?h.h(k):this.g.push(k);this.u=!0};b.resolve=d;b.reject=function(f){return new b(function(g,k){k(f)})};b.race=function(f){return new b(function(g,k){for(var l=u(f),m=l.next();!m.done;m=l.next())d(m.value).T(g,k)})};b.all=function(f){var g=u(f),k=g.next();return k.done?d([]):new b(function(l,m){function n(K){return function(L){r[K]=L;v--;0==v&&l(r)}}var r=[],v=0;do r.push(void 0),v++,d(k.value).T(n(r.length-1),m),k=g.next();\nwhile(!k.done)})};return b});t("Number.MAX_SAFE_INTEGER",function(){return 9007199254740991});function ua(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var h=a[e];if(b.call(c,h,e,a))return{la:e,oa:h}}return{la:-1,oa:void 0}}t("Array.prototype.find",function(a){return a?a:function(b,c){return ua(this,b,c).oa}});function C(a,b){return Object.prototype.hasOwnProperty.call(a,b)}\nt("WeakMap",function(a){function b(k){this.g=(g+=Math.random()+1).toString();if(k){k=u(k);for(var l;!(l=k.next()).done;)l=l.value,this.set(l[0],l[1])}}function c(){}function d(k){var l=typeof k;return"object"===l&&null!==k||"function"===l}function e(k){if(!C(k,f)){var l=new c;ba(k,f,{value:l})}}function h(k){var l=Object[k];l&&(Object[k]=function(m){if(m instanceof c)return m;Object.isExtensible(m)&&e(m);return l(m)})}if(function(){if(!a||!Object.seal)return!1;try{var k=Object.seal({}),l=Object.seal({}),\nm=new a([[k,2],[l,3]]);if(2!=m.get(k)||3!=m.get(l))return!1;m.delete(k);m.set(l,4);return!m.has(k)&&4==m.get(l)}catch(n){return!1}}())return a;var f="$jscomp_hidden_"+Math.random();h("freeze");h("preventExtensions");h("seal");var g=0;b.prototype.set=function(k,l){if(!d(k))throw Error("Invalid WeakMap key");e(k);if(!C(k,f))throw Error("WeakMap key fail: "+k);k[f][this.g]=l;return this};b.prototype.get=function(k){return d(k)&&C(k,f)?k[f][this.g]:void 0};b.prototype.has=function(k){return d(k)&&C(k,\nf)&&C(k[f],this.g)};b.prototype.delete=function(k){return d(k)&&C(k,f)&&C(k[f],this.g)?delete k[f][this.g]:!1};return b});\nt("Map",function(a){function b(){var g={};return g.I=g.next=g.head=g}function c(g,k){var l=g[1];return da(function(){if(l){for(;l.head!=g[1];)l=l.I;for(;l.next!=l.head;)return l=l.next,{done:!1,value:k(l)};l=null}return{done:!0,value:void 0}})}function d(g,k){var l=k&&typeof k;"object"==l||"function"==l?h.has(k)?l=h.get(k):(l=""+ ++f,h.set(k,l)):l="p_"+k;var m=g[0][l];if(m&&C(g[0],l))for(g=0;g<m.length;g++){var n=m[g];if(k!==k&&n.key!==n.key||k===n.key)return{id:l,list:m,index:g,D:n}}return{id:l,\nlist:m,index:-1,D:void 0}}function e(g){this[0]={};this[1]=b();this.size=0;if(g){g=u(g);for(var k;!(k=g.next()).done;)k=k.value,this.set(k[0],k[1])}}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return!1;try{var g=Object.seal({x:4}),k=new a(u([[g,"s"]]));if("s"!=k.get(g)||1!=k.size||k.get({x:4})||k.set({x:4},"t")!=k||2!=k.size)return!1;var l=k.entries(),m=l.next();if(m.done||m.value[0]!=g||"s"!=m.value[1])return!1;m=l.next();return m.done||4!=m.value[0].x||\n"t"!=m.value[1]||!l.next().done?!1:!0}catch(n){return!1}}())return a;var h=new WeakMap;e.prototype.set=function(g,k){g=0===g?0:g;var l=d(this,g);l.list||(l.list=this[0][l.id]=[]);l.D?l.D.value=k:(l.D={next:this[1],I:this[1].I,head:this[1],key:g,value:k},l.list.push(l.D),this[1].I.next=l.D,this[1].I=l.D,this.size++);return this};e.prototype.delete=function(g){g=d(this,g);return g.D&&g.list?(g.list.splice(g.index,1),g.list.length||delete this[0][g.id],g.D.I.next=g.D.next,g.D.next.I=g.D.I,g.D.head=null,\nthis.size--,!0):!1};e.prototype.clear=function(){this[0]={};this[1]=this[1].I=b();this.size=0};e.prototype.has=function(g){return!!d(this,g).D};e.prototype.get=function(g){return(g=d(this,g).D)&&g.value};e.prototype.entries=function(){return c(this,function(g){return[g.key,g.value]})};e.prototype.keys=function(){return c(this,function(g){return g.key})};e.prototype.values=function(){return c(this,function(g){return g.value})};e.prototype.forEach=function(g,k){for(var l=this.entries(),m;!(m=l.next()).done;)m=\nm.value,g.call(k,m[1],m[0],this)};e.prototype[Symbol.iterator]=e.prototype.entries;var f=0;return e});t("Math.trunc",function(a){return a?a:function(b){b=Number(b);if(isNaN(b)||Infinity===b||-Infinity===b||0===b)return b;var c=Math.floor(Math.abs(b));return 0>b?-c:c}});t("Array.prototype.findIndex",function(a){return a?a:function(b,c){return ua(this,b,c).la}});\nt("Promise.prototype.finally",function(a){return a?a:function(b){return this.then(function(c){return Promise.resolve(b()).then(function(){return c})},function(c){return Promise.resolve(b()).then(function(){throw c;})})}});function va(){if("object"===typeof self)return self;if("object"===typeof window)return window;if("object"===typeof global)return global;throw Error("Unable to get global this");}function E(a){return"number"===typeof a&&!isNaN(a)}function F(a){return"string"===typeof a};var wa=new Uint16Array(1);wa[0]=4660;new Uint8Array(wa.buffer);function xa(a){var b,c,d,e;return A(function(h){switch(h.g){case 1:b=a.getReader(),c=[],d=!1;case 2:if(d){h.g=4;break}return y(h,b.read(),5);case 5:e=h.h;e.value&&c.push(e.value);d=e.done;h.g=2;break;case 4:return h.return(c)}})};function G(a,b,c){var d=Error.call(this,"["+a+"] "+b+" :: "+(c||""));this.message=d.message;"stack"in d&&(this.stack=d.stack);this.namespace=a;this.errorType=b;this.errorMessage=c||""}x(G,Error);G.isColibrioError=ya;G.isColibrioAbortedError=H;function ya(a){return a instanceof G||a&&F(a.errorType)&&F(a.namespace)}function H(a){return ya(a)&&"ABORTED"===a.errorType||a instanceof DOMException&&(a.code===DOMException.ABORT_ERR||"AbortError"===a.name)};function za(a,b){E(0)&&(a=a.slice(0,b));return new Promise(function(c,d){var e=new FileReader;e.onload=function(){e.onabort=null;e.onload=null;e.onerror=null;c(e.result)};e.onabort=e.onerror=function(){e.onabort=null;e.onload=null;e.onerror=null;d(e.error)};e.readAsArrayBuffer(a)})};function I(){}I.prototype.logError=function(){this.g.apply(this,["error"].concat(w(B.apply(0,arguments))))};I.prototype.logInfo=function(){this.g.apply(this,["info"].concat(w(B.apply(0,arguments))))};I.prototype.logWarning=function(){this.g.apply(this,["warn"].concat(w(B.apply(0,arguments))))};I.prototype.g=function(a){var b=B.apply(1,arguments);"undefined"!==typeof console&&console[a]&&console[a].apply(console,w(b))};var J;function Aa(){J.logError.apply(J,w(B.apply(0,arguments)))}function Ba(){J.logWarning.apply(J,w(B.apply(0,arguments)))}var Ca=!1;(function(a){if(!Ca){Ca=!0;var b=va();b&&"function"===typeof b.addEventListener&&b.addEventListener("unhandledrejection",function(c){Aa("Unhandled Promise rejection",c.reason);c.cancelable&&c.preventDefault()})}J=a})(new I);function M(a,b){G.call(this,"colibrio.core.io.resourceprovider.zip.webworker",a,b)}x(M,G);function Da(){this.s=0;this.h=Ea(null,null,null);this.g=Ea(null,this.h,null);this.h.v=this.g}p=Da.prototype;p.every=function(a){for(var b=this.h.v,c=!0;b!==this.g&&c;){var d=b.v;c=a(b);b=null===b.v?d:b.v}return c};p.find=function(a){for(var b=this.h.v,c=null;b!==this.g&&null===c;){var d=b.v;a(b)&&(c=b);b=null===b.v?d:b.v}return c};p.forEach=function(a){for(var b=this.h.v;b!==this.g;){var c=b.v;a(b);b=null===b.v?c:b.v}};function Fa(a){return a.s?a.h.v:null}\nfunction Ga(a,b){return(b=b.v)&&a.g!==b?b:null}p.push=function(a){a=Ea(a,this.g.B,this.g);a.B.v=a;this.g.B=a;this.s++;return a};p.size=function(){return this.s};function Ea(a,b,c){return{F:a,v:c,B:b}}function Ha(a,b){if(b.B&&b.v){var c=b.B,d=b.v;c.v=d;d.B=c;b.v=null;b.B=null;a.s--}};function N(a){this.h=a;this.g=new Da;this.j=new Map;this.i=0;this.l=null}function Ia(a,b){var c=a.j.get(b);c&&(a.j.delete(b),Ha(a.g,c),a.i-=c.F.s,a.l&&a.l(c.F.S,b))}N.prototype.find=function(a){var b=this.g;b=b.s?b.g.B:null;for(var c;b&&void 0===c;)a(b.F.S,b.F.$)?c=b.F.S:b=(b=b.B)&&this.g.h!==b?b:null;b&&Ja(this,b);return c};N.prototype.get=function(a){return(a=this.j.get(a))?(Ja(this,a),a.F.S):null};N.prototype.has=function(a){return this.j.has(a)};\nN.prototype.set=function(a,b,c){if(!(c>this.h.va||!this.h.ba&&c>this.h.aa)){var d=this.h.U;b={$:a,xa:0,s:c,fa:d?Date.now()+d:0,S:b};Ia(this,a);b=this.g.push(b);this.j.set(a,b);this.i+=c;Ka(this)}};function La(a,b){a.l=b}function Ka(a){var b=a.h.aa,c=a.h.ba,d=a.h.U;if(d&&a.i>b&&a.g.size()>c){d=d?Date.now():0;for(var e=Fa(a.g);a.i>b&&a.g.size()>c&&e&&e.F.fa<=d;){var h=Ga(a.g,e);0>=e.F.xa&&Ia(a,e.F.$);e=h}}}\nfunction Ja(a,b){var c=a.h.U,d=a.g;b.B&&b.v&&(Ha(d,b),b.B=d.g.B,b.v=d.g,b.B.v=b,d.g.B=b,d.s++);c&&(b.F.fa=Date.now()+c);c&&Ka(a)};function Ma(a){this.g=a;this.i=!1;this.h=null}function Na(a,b,c){return c.fetchChunk(a,b).then(function(d){if(d instanceof ArrayBuffer)d=new Uint8Array(d);else if(!(d instanceof Uint8Array||d instanceof ReadableStream))throw new M("INVALID_RANDOM_ACCESS_DATA_CHUNK","Expected an ArrayBuffer, Uint8Array or ReadableStream. Got: "+(null==d?void 0:d.constructor.name));return new Ma(d)})}\nfunction Oa(a,b,c){if(a.g instanceof Uint8Array)return new ReadableStream({start:function(f){var g=a.g;if(0<b||c!==g.length)g=g.subarray(b,b+c);f.enqueue(g);f.close()}});if(a.i){var d=u(a.g.tee()),e=d.next().value;d=d.next().value;a.g=e;var h=d.getReader()}else h=a.g.getReader();return new ReadableStream({cancel:function(){h.cancel().catch(function(f){H(f)||console.warn(f)})},pull:function(f){var g,k,l,m,n,r,v,K,L;return A(function(D){switch(D.g){case 1:D.o=2,g=!1;case 4:if(g){D.g=0;D.o=0;break}return y(D,\nh.read(),7);case 7:k=D.h;if(l=k.value)b>=l.length?b-=l.length:(m=void 0,l.length>=b+c?m=l.subarray(b,b+c):0<b?(m=l.subarray(b),b=0):m=l,c-=m.length,f.enqueue(m),g=!0);0===c?(f.close(),h.cancel().catch(function(V){H(V)||console.warn(V)}),g=!0):k.done&&(g=!0,r=n=void 0,null==(r=(n=a).h)||r.call(n),f.error(new M("UNEXPECTED_END_OF_STREAM","Stream returned by fetchChunk() ended too early.")),h.cancel().catch(function(V){H(V)||console.warn(V)}));D.g=4;break;case 2:throw v=oa(D),null==(L=(K=a).h)||L.call(K),\nv;}})}})}function Pa(a,b){a.i&&!b&&a.g instanceof ReadableStream&&(a.g.locked||a.g.cancel().catch(function(c){H(c)||console.warn(c)}));a.i=b}function Qa(a,b){a.h=b};function Ra(a,b){this.i=a;this.h=b;this.j=new Map;a=Math.max(this.h.maxChunkSize,this.h.chunkCacheSize);this.g=new N({va:a,aa:a,ba:0,U:0});La(this.g,function(c){c.ca.then(function(d){d.h=null;Pa(d,!1)}).catch()})}\nfunction Sa(a,b,c){var d=a.i.getSize();if(b>=c||c>d)return Promise.reject(new M("INVALID_START_END_OFFSETS","start: "+b+", end: "+c+", sizeOfDisk: "+d));var e=Ta(a,b,c);if(e)d=e.ca.then(function(f){return Oa(f,b-e.da,c-b)});else{d<1.5*a.h.preferredChunkSize&&d<a.h.maxChunkSize&&(b=0,c=d);d=Na(b,c,a.i);var h=b+":"+c;a.h.deterministicChunkRequests&&a.j.set(h,{end:c,start:b});a.g.set(h,{ua:c,ca:d,da:b},c-b);d=d.then(function(f){a.g.has(h)&&(Pa(f,!0),Qa(f,function(){Ia(a.g,h)}));return Oa(f,0,c-b)}).catch(function(f){Ia(a.g,\nh);return Promise.reject(f)})}return d}function O(a,b,c){return Sa(a,b,c).then(function(d){return xa(d)}).then(function(d){if(0===d.length)d=new Uint8Array(0);else if(1===d.length)d=d[0];else{for(var e=0,h=0;h<d.length;h++)e+=d[h].byteLength;e=new Uint8Array(e);for(var f=h=0;f<d.length;f++){var g=d[f];e.set(g,h);h+=g.byteLength}d=e}return d})}function Ua(a){var b=[];a.j.forEach(function(c){b.push(c)});return b}function Ta(a,b,c){return a.g.find(function(d){return d.da<=b&&d.ua>=c})};function Va(a){var b=Error.call(this,"[colibrio.internal] "+(a||""));this.message=b.message;"stack"in b&&(this.stack=b.stack);this.errorMessage=a}x(Va,Error);var Wa=__lib__timsort;function Xa(a,b){this.j=!1;this.l=new Uint8Array(64);this.i=this.h=0;this.o=new Int32Array(a);this.g=new Int32Array(b);Ya(this.g)}p=Xa.prototype;\np.append=function(a){if(this.j)throw new Va("Illegal Sha.append(). Already finalized.");var b=0;a instanceof ArrayBuffer?a=new Uint8Array(a):a instanceof Uint8Array||(F(a)?(Za||(Za=new TextEncoder),a=Za.encode(a)):a=new Uint8Array(a.buffer,a.byteOffset,a.byteLength));if(a.length>Number.MAX_SAFE_INTEGER)throw new Va("Data passed to Sha.append() is too large");var c=a.length;if(0<this.h){b=Math.min(64-this.h,c);for(var d=0;d<b;d++)this.l[this.h++]=a[d];64===this.h&&($a(this.l,0,this.o,this.g),this.h=\n0)}this.i+=c;if(!(b>=c)){d=c-(c-b)%64;if(b<d){for(;b<d;b+=64)$a(a,b,this.o,this.g);b>d&&(b-=64)}if(b<c)for(;b<c;)this.l[this.h++]=a[b++]}};p.digestToHex=function(){ab(this);for(var a=Array(2*this.g.byteLength),b=0,c=0;c<this.g.length;c++)for(var d=this.g[c],e=7;0<=e;e--){var h=d>>(e<<2)&15;a[b++]=(10>h?48:87)+h}return String.fromCharCode.apply(null,a)};p.digestToUint32Array=function(){ab(this);return new Uint32Array(this.g)};\np.digestToUint8Array=function(){ab(this);for(var a=new Uint8Array(this.g.byteLength),b=0,c=0;c<this.g.length;c++){var d=this.g[c];a[b++]=d>>>24;a[b++]=d>>>16;a[b++]=d>>>8;a[b++]=d}return a};p.reset=function(){Ya(this.g);this.j=!1;this.i=this.h=0};\nfunction ab(a){if(!a.j){a.j=!0;var b=a.h,c=a.l;c[b++]=128;if(56<b){for(;64>b;)c[b++]=0;$a(c,0,a.o,a.g);b=0}for(;56>b;)c[b++]=0;if(a.i>Math.pow(2,29)-1){var d=Math.trunc(a.i/Math.pow(2,29))|0;c[b++]=d>>>24;c[b++]=d>>>16;c[b++]=d>>>8;c[b++]=d}else for(;60>b;)c[b++]=0;d=a.i<<3|0;c[b++]=d>>>24;c[b++]=d>>>16;c[b++]=d>>>8;c[b++]=d;$a(c,0,a.o,a.g)}}var Za=null;function bb(){Xa.call(this,80,5)}x(bb,Xa);\nfunction $a(a,b,c,d){for(var e=0;16>e;e++)c[e]=a[b++]<<24|a[b++]<<16|a[b++]<<8|a[b++];for(a=16;80>a;a++)c[a]=P(c[a-3]^c[a-8]^c[a-14]^c[a-16],1);a=d[0];b=d[1];e=d[2];for(var h=d[3],f=d[4],g=0;20>g;g++){var k=P(a,5)+(b&e|~b&h)+f+c[g]+1518500249|0;f=h;h=e;e=P(b,30);b=a;a=k}for(g=20;40>g;g++)k=P(a,5)+(b^e^h)+f+c[g]+1859775393|0,f=h,h=e,e=P(b,30),b=a,a=k;for(g=40;60>g;g++)k=P(a,5)+(b&e|b&h|e&h)+f+c[g]+2400959708|0,f=h,h=e,e=P(b,30),b=a,a=k;for(g=60;80>g;g++)k=P(a,5)+(b^e^h)+f+c[g]+3395469782|0,f=h,h=e,\ne=P(b,30),b=a,a=k;d[0]+=a;d[1]+=b;d[2]+=e;d[3]+=h;d[4]+=f}function Ya(a){a[0]=1732584193;a[1]=4023233417;a[2]=2562383102;a[3]=271733878;a[4]=3285377520}function P(a,b){return a<<b|a>>>32-b};function Q(a){this.g=a}function R(a,b){return a.g[b]+(a.g[b+1]<<8)}function S(a,b){return a.g[b]+(a.g[b+1]<<8)+(a.g[b+2]<<16)+(a.g[b+3]<<24>>>0)}function T(a,b){var c=a.g[b]+(a.g[b+1]<<8)+(a.g[b+2]<<16)+(a.g[b+3]<<24>>>0);a=a.g[b+4]+(a.g[b+5]<<8)+(a.g[b+6]<<16)+(a.g[b+7]<<24>>>0);return 2097151<a?-1:c+4294967296*a};function cb(){this.h=this.g=void 0;this.i=new TextDecoder("utf-8")}var db;function eb(a){try{return new TextDecoder(a)}catch(b){return console.error(b),null}};var fb=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,199,252,233,226,228,224,229,231,234,235,232,239,238,236,196,197,201,230,198,244,246,242,251,\n249,255,214,220,162,163,165,8359,402,225,237,243,250,241,209,170,186,191,8976,172,189,188,161,171,187,9617,9618,9619,9474,9508,9569,9570,9558,9557,9571,9553,9559,9565,9564,9563,9488,9492,9524,9516,9500,9472,9532,9566,9567,9562,9556,9577,9574,9568,9552,9580,9575,9576,9572,9573,9561,9560,9554,9555,9579,9578,9496,9484,9608,9604,9612,9616,9600,945,223,915,960,931,963,181,964,934,920,937,948,8734,966,949,8745,8801,177,8805,8804,8992,8993,247,8776,176,8729,183,8730,8319,178,9632,160];function gb(a,b){this.h=-1;this.j=0;this.i=-1;this.A=0;this.G=null;var c=new Q(new Uint8Array(a,b));if(33639248!==S(c,0))throw new M("INVALID_CENTRAL_DIRECTORY_FILE_HEADER_SIGNATURE");var d=R(c,8)&2048;this.o=R(c,10);this.l=S(c,20);this.C=S(c,24);var e=R(c,28),h=46+e,f=R(c,30);this.N=h+f+R(c,32);this.g=S(c,42);c=new Uint8Array(a,b+46,e);if(d)a:{if(db||(db=new cb),d=db,2<=c.length&&254===c[0]&&255===c[1]&&(void 0===d.g&&(d.g=eb("utf-16be")),d.g)){c=d.g.decode(c);break a}if(2<=c.length&&255===c[0]&&\n254===c[1]&&(void 0===d.h&&(d.h=eb("utf-16le")),d.h)){c=d.h.decode(c);break a}c=d.i.decode(c)}else{d=Array(c.length);for(e=0;e<c.length;e++)d[e]=fb[c[e]];c=String.fromCharCode.apply(null,d)}this.u=c;if(0<f)for(a=new Q(new Uint8Array(a,b+h,f)),b=0;b<f;){h=R(a,b+2);if(1===R(a,b)){c=b+4;4294967295===this.C&&(d=T(a,c),0<=d&&(this.C=d),c+=8);if(4294967295===this.l){d=T(a,c);if(-1===d)throw new M("ZIP64_FIELD_LARGER_THAN_52BITS","Compressed size");this.l=d;c+=8}if(4294967295===this.g){c=T(a,c);if(-1===\nc)throw new M("ZIP64_FIELD_LARGER_THAN_52BITS","Offset to local header");this.g=c}}b+=h+4}};function hb(a,b){this.g=new Q(new Uint8Array(a,b));if(101075792!==S(this.g,0))throw new M("INVALID_ZIP64_END_OF_CENTRAL_DIRECTORY_SIGNATURE");}function ib(a,b){return O(a,b,b+56).then(function(c){return new hb(c.buffer,c.byteOffset)})}hb.prototype.X=function(){var a=T(this.g,48);if(-1===a)throw new M("ZIP64_FIELD_LARGER_THAN_52BITS","OFFSET_TO_CENTRAL_DIRECTORY_FROM_STARTING_DISC");return a};\nhb.prototype.h=function(){var a=T(this.g,40);if(-1===a)throw new M("ZIP64_FIELD_LARGER_THAN_52BITS","SIZE_OF_CENTRAL_DIRECTORY");return a};hb.prototype.ka=function(){var a=T(this.g,32);if(-1===a)throw new M("ZIP64_FIELD_LARGER_THAN_52BITS","TOTAL_NUM_ENTRIES_IN_CENTRAL_DIRECTORY");return a};function jb(a,b){this.g=new Q(new Uint8Array(a,b))}function kb(a,b){a=T(a.g,8);if(-1===a)throw new M("ZIP64_FIELD_LARGER_THAN_52BITS","Archive not supported");return ib(b,a)};function lb(a,b,c){this.i=c;this.g=new Q(new Uint8Array(a,b))}function mb(a){var b=a.i.getSize();return O(a,Math.max(0,b-65578),b).then(function(c){for(var d=-1,e=c.length-22;0<e&&-1===d;e--)80===c[e]&&75===c[e+1]&&5===c[e+2]&&6===c[e+3]&&(d=e);if(-1===d)throw new M("END_OF_CENTRAL_DIRECTORY_SIGNATURE_NOT_FOUND");e=d+c.byteOffset;var h=null,f;if(f=20<d)d-=20,f=80===c[d]&&75===c[d+1]&&6===c[d+2]&&7===c[d+3];f&&(h=new jb(c.buffer,e-20));return new lb(c.buffer,e,h)})}\nlb.prototype.X=function(){return S(this.g,16)};lb.prototype.h=function(){return S(this.g,12)};lb.prototype.ka=function(){return R(this.g,10)};function nb(a,b,c,d){this.i=a;this.A=c;this.h=[];this.g=[];this.j=!1;this.l=new Map;this.J=0;this.C=c.ka();this.o=b.byteOffset;this.u=b.buffer;a=new bb;a.append(b);this.G=a.digestToHex();ob(this,d);if(!this.j)for(b=Ua(d),Wa.sort(b,function(e,h){return e.start-h.start}),d=0;d<b.length;d++)a=b[d],this.g.push({P:this.J++,m:a.start,s:a.end-a.start})}\nfunction pb(a,b){return mb(a).then(function(c){var d=c.i;if(d){if(1<S(d.g,16))throw new M("MULTI_VOLUME_ZIP_UNSUPPORTED");return kb(d,a).catch(function(e){console.error(e);return c})}if(1<R(c.g,4))throw new M("MULTI_VOLUME_ZIP_UNSUPPORTED");return c}).then(function(c){var d=c.X(),e=c.h();return O(a,d,d+e).then(function(h){return new nb(b,h,c,a)})})}function qb(a){return a.h.map(function(b){return rb(b)})}function sb(a){return a.g.map(function(b){return{end:b.m+b.s,start:b.m}})}\nfunction tb(a,b,c,d){var e=b.A;if(d&&b.g>=d.start)a.j?c=a.g[a.g.length-1]:(a.j=!0,c={P:a.J++,m:d.start,s:d.end-d.start},a.g.push(c)),b.h=c.P,b.i=b.g-c.m,b.j=1;else if(c&&c.s+e<a.i.preferredChunkSize)b.h=c.P,b.i=c.s,b.j=1,c.s+=e;else for(d=b.g,b.h=a.J,b.i=0;0<e;){var h=Math.min(e,a.i.maxChunkSize);c={P:a.J++,m:d,s:h};a.g.push(c);b.j++;e-=h;d+=h}return c&&c.s<a.i.preferredChunkSize?c:null}\nfunction rb(a){return{compressedSize:a.l,compressionMethod:a.o,entrySize:a.A,numChunks:a.j,path:a.u,startChunkIndex:a.h,startOffsetInChunk:a.i,uncompressedSize:a.C}}function ob(a,b){for(var c=0;c<a.C;c++){var d=new gb(a.u,a.o);a.h.push(d);a.l.set(d.u,d);a.o+=d.N}Wa.sort(a.h,function(k,l){return k.g-l.g});c=null;b=Ua(b);b=1===b.length?b[0]:null;d=0;for(var e=a.h.length;d<e;d++){var h=a.h[d],f=a.h[d+1],g=void 0;g=f?f.g:a.A.X();h.A=g-h.g;c=tb(a,h,c,b)}};function ub(a,b){0!==b&&(a=new Uint8Array(a.buffer,a.byteOffset+b));b=new Q(a);if(67324752!==S(b,0))throw new M("INVALID_LOCAL_HEADEAR_SIGNATURE");this.g=30+R(b,26)+R(b,28)};function vb(){this.l=new Uint8Array([]);this.j=this.h=this.o=0;this.u=[];this.i=this.g=0}function wb(a){return a.i+(a.g>>>3)}function xb(a){1>a.g&&yb(a);var b=a.h&1;a.h>>>=1;--a.g;return b}function zb(a,b){for(;0<a.i&&16>a.g;)U(a);var c=a.h&(1<<b)-1;a.h>>>=b;a.g-=b;return c}function W(a,b){8>a.g&&yb(a);var c=a.h&(1<<b)-1;a.h>>>=b;a.g-=b;return c}vb.prototype.push=function(a){0!==a.length&&(this.u.push(a),this.i+=a.length,0===this.g&&U(this))};function Ab(a,b){8>a.g&&yb(a);a.h>>>=b;a.g-=b}\nfunction Bb(a){var b=a.g%8;b&&(a.h>>>=b,a.g-=b)}function U(a){a.j<a.o?(a.i--,a.h|=a.l[a.j++]<<a.g,a.g+=8):0<a.u.length?(a.l=a.u.shift(),a.o=a.l.length,a.i--,a.h|=a.l[0]<<a.g,a.j=1,a.g+=8):a.i=0}function yb(a){a.j<a.o-1?(a.h|=(a.l[a.j++]|a.l[a.j++]<<8)<<a.g,a.g+=16,a.i-=2):(U(a),U(a))};function X(a){this.l=this.g=0;for(var b=new Uint16Array(16),c=0;c<a.length;c++)b[a[c]]++;var d=b[0]=0;c=new Uint16Array(16);this.h=new Uint16Array(35);for(var e=new Uint16Array(7),h=0,f=1;16>f;f++){c[f]=d;var g=b[f];if(g&&(this.g=f,8<f)){var k=5*this.l++;this.h[k]=f;this.h[k+1]=d+g-1;this.h[k+2]=d;this.h[k+3]=h;this.h[k+4]=g;e[f-9]=h;h+=g}d=d+g<<1}this.j=new Uint16Array(h);this.g=8>this.g?this.g:8;this.i=new Uint16Array(1<<this.g);for(b=0;b<a.length;b++)if(d=a[b],0!==d)if(h=c[d]++,d<=this.g)for(h=\n65793*(2050*h&139536|32800*h&558144)>>>24-d&255>>>8-d,f=b|1024|d<<12,g=0,k=1<<this.g-d;g<k;g++)this.i[h|g<<d]=f;else f=h>>>=d-this.g,g=this.g,f=65793*(2050*f&139536|32800*f&558144)>>>24-g&255>>>8-g,this.i[f]||(this.i[f]=h|2048),d-=9,h=e[d],this.j[h++]=b,e[d]=h}\nfunction Cb(a,b){var c=a.i,d=a.g;8>b.g&&yb(b);c=c[b.h&(1<<d)-1];d=-1;if(c&1024)Ab(b,c>>>12),d=c&511;else if(c&2048){Ab(b,8);var e=0,h=8,f=c&511;d=a.h;do{c=5*e;var g=d[c];var k=d[c+1];for(h=g-h;0<h;h--)f=f<<1|xb(b);h=g}while(f>k&&++e<a.l);b=f-d[c+2];e=d[c+3];d=b<d[c+4]?a.j[e+b]:-1}return d};function Db(a){this.h=a;this.m=0;this.g=new Uint8Array(65536)}Db.prototype.close=function(){0<this.m&&this.flush()};\nfunction Eb(a,b,c){if(65536<a.m+c){var d=65536-a.m;Eb(a,b,d);c-=d}for(;0<c;){d=b;var e=c;Bb(d);var h=d.g>>>3;if(d.o){var f=d.j-h,g=d.o-f;g=g<e?g:e;if(0<=f)e=d.l.subarray(f,f+g),d.h=0;else{for(e=new Uint8Array(g);0>f;)e[f+h]=d.h&255,f++,d.h>>>=8;e.set(d.l,h)}h=g-h;d.j+=h;d.i-=h;d.g=0;d.j>=d.o&&U(d)}else{e=new Uint8Array(e);for(f=0;0<h--;)e[f++]=d.h&255,d.h>>>=8;d.g=0}d=e;h=d.length;a.g.set(d,a.m);a.m+=h;c-=h}65536===a.m&&a.flush()}\nfunction Fb(a,b,c){var d=a.m-b;if(0>d)c>-d?(Y(a,a.m,d+65536,-d),Y(a,a.m-d,0,c+d)):Y(a,a.m,d+65536,c),a.m+=c;else if(65536<a.m+c){var e=65536-a.m;Y(a,a.m,d,e);a.m=65536;a.flush();Fb(a,b,c-e)}else Y(a,a.m,d,c),a.m+=c,65536===a.m&&a.flush()}function Y(a,b,c,d){a=a.g;for(d=b+d;b<d;)a[b++]=a[c++]}Db.prototype.flush=function(){var a=65536===this.m?this.g.slice():this.g.slice(0,this.m);this.m=0;this.h(a)};function Gb(a){this.g=new vb;this.u=Hb;this.i=0;this.j=this.A=!1;this.C=Ib;this.h=this.l=0;this.o=new Db(a.Ba);this.G=a.Aa}p=Gb.prototype;p._getDistanceFromCode=function(a,b){if(29<a)return this.i=3,this.h=5,0;var c=Jb[a];a=Kb[a];0<a&&(c+=zb(b,a));return c};p._getLengthFromCode=function(a,b){if(28<a)return this.i=7,this.h=5,0;var c=Lb[a];a=Mb[a];0<a&&(c+=W(b,a));return c};\np._handleDecompress=function(){var a=this.g,b=this.j,c=this.o;if(!(6<a.i||b&&(0<a.g||0<a.i)))return!1;for(;4===this.h&&(6<a.i||b&&(0<a.g||0<a.i));){var d=Cb(this.C,a);if(-1===d)this.i=1,this.h=5;else if(256>d){var e=c;e.g[e.m++]=d;65536===e.m&&e.flush()}else 256<d?(e=this._getLengthFromCode(d-257,a),d=Cb(this.u,a),d=this._getDistanceFromCode(d,a),Fb(c,d,e)):this.h=5}return!0};\np._handleDynamicHuffman=function(){if(!this.j&&300>wb(this.g))return!1;for(var a=W(this.g,5)+257,b=W(this.g,5)+1,c=W(this.g,4)+4,d=new Uint8Array(19),e=0;e<c;)d[Nb[e++]]=W(this.g,3);c=new X(d);d=0;b=a+b;e=new Uint8Array(b);for(var h=0;d<b;){var f=Cb(c,this.g);if(-1===f)return this.i=5,!1;if(16>f)e[d++]=h=f;else if(16===f){f=W(this.g,2)+3;for(var g=0;g<f;g++)e[d++]=h}else if(17===f)for(f=W(this.g,3)+3,g=0;g<f;g++)e[d++]=0;else if(18===f)for(f=W(this.g,7)+11,g=0;g<f;g++)e[d++]=0}this.C=new X(e.subarray(0,\na));this.u=new X(e.subarray(a,b));this.h=4;return!0};p._handleNonCompressedData=function(){if(wb(this.g)<this.l)return!1;Eb(this.o,this.g,this.l);this.l=0;this.h=5;return!0};p._handleNonCompressedHeader=function(){Bb(this.g);if(4>wb(this.g))return!1;var a=zb(this.g,16),b=zb(this.g,16);a!==(~b&65535)?this.i=6:a?(this.l=a,this.h=2):this.h=5;return!0};\np._handleStartOfBlock=function(){var a=this.g;if(3>8*a.i+a.g)return!1;xb(this.g)&&(this.A=!0);switch(W(this.g,2)){case 0:this.h=1;break;case 1:this.C=Ib;this.u=Hb;this.h=4;break;case 2:this.h=3;break;default:return this.i=4,!1}return!0};\np.push=function(a,b){if(!this.j){this.j=b;this.g.push(a);for(a=!0;a&&!this.i;)switch(this.h){case 0:a=this._handleStartOfBlock();break;case 1:a=this._handleNonCompressedHeader();break;case 2:a=this._handleNonCompressedData();break;case 3:a=this._handleDynamicHuffman();break;case 4:a=this._handleDecompress();break;case 5:this.A?(a=!1,this.o.close()):(this.h=0,a=!0)}!b||this.i||this.A&&5===this.h||(this.i=2);this.i&&(this.G(this.i),this.j=!0,this.o.close())}};\nfor(var Nb=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],Lb=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258],Mb=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],Jb=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577],Kb=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],Ob=new Uint8Array(288),Pb=0;144>Pb;Pb++)Ob[Pb]=8;for(var Qb=144;256>Qb;Qb++)Ob[Qb]=9;\nfor(var Rb=256;280>Rb;Rb++)Ob[Rb]=7;for(var Sb=280;288>Sb;Sb++)Ob[Sb]=8;for(var Ib=new X(Ob),Tb=new Uint8Array(30),Ub=0;30>Ub;Ub++)Tb[Ub]=5;var Hb=new X(Tb);function Vb(a){var b=this;this.j=a;this.i=0;this.g=null;this.h=new Gb({Aa:function(c){b.i=c},Ba:function(c){b.g&&b.g(c)}})}Vb.prototype.ga=function(a,b,c){if(!this.h)throw new M("INFLATE_ERROR","Inflate error: Final chunk already pushed: "+this.j);this.g=c;this.h.push(a,b);this.g=null;if(this.i)throw new M("INFLATE_ERROR","Inflate error code: "+this.i+", file: "+this.j);b&&(this.h=null)};function Wb(){}Wb.prototype.ga=function(a,b,c){c(a.slice())};function Xb(a,b,c,d,e,h){this.ya=a;this.H=b;this.L=c;this.M=d;this.Z=e;this.K=h;this.J=0;this.O=null}\nXb.prototype.pull=function(a){var b=this,c,d,e,h;return A(function(f){switch(f.g){case 1:c=!1;case 2:if(c){f.g=0;break}if(b.O){f.g=5;break}if(b.J>=b.H.length||0>=b.M)var g=Promise.resolve(null);else g=b.H[b.J++],g=Sa(b.K,g.m,g.m+g.s);return y(f,g,6);case 6:d=f.h;if(!d)return a.close(),f.return();b.O=d.getReader();case 5:return y(f,b.O.read(),7);case 7:e=f.h;if(h=e.value)b.L>=h.length?b.L-=h.length:(c=Yb(b,a,h,b.L),b.L=0);0>=b.M?(a.close(),b.O.cancel().catch(),b.O=null,c=!0):e.done&&(b.O=null);f.g=\n2}})};Xb.prototype.start=function(a){this.Z&&(Yb(this,a,this.Z,this.L),this.L=0,this.J++)};function Yb(a,b,c,d){var e=c.length-d;e=a.M<e?a.M:e;a.M-=e;if(0!==d||e!==c.length)c=c.subarray(d,d+e);var h=!1;a.ya.ga(c,0>=a.M,function(f){b.enqueue(f);h=!0});return h};function Zb(a,b,c,d){this.H=a;this.g=b;this.K=c;this.h=d}Zb.prototype.createStream=function(a){var b=this,c;return A(function(d){if(1==d.g)return y(d,$b(b,a),2);c=d.h;return d.return(new ReadableStream(new Xb(c.na,c.ia,c.ma,c.compressedSize,c.ja,b.K)))})};Zb.prototype.isByteRangeSupported=function(){return 0===this.g.o};\nfunction $b(a,b){var c,d,e,h,f,g,k,l,m;return A(function(n){switch(n.g){case 1:switch(a.g.o){case 0:c=new Wb;break;case 8:if(b)throw new M("RANGE_REQUEST_NOT_SUPPORTED");c=new Vb(a.g.u);break;default:throw new M("COMPRESSION_METHOD_UNSUPPORTED",a.g.o+"");}d=a.g.G;e=null;if(d){n.g=2;break}h=a.H[0];return a.h?y(n,O(a.K,h.m,h.m+h.s),6):y(n,O(a.K,h.m,8),5);case 5:e=n.h;n.g=4;break;case 6:e=n.h;case 4:d=new ub(e,a.g.i),a.g.G=d;case 2:f=a.g.i+d.g;g=a.g.l;b&&(f+=b.start,g=b.end-b.start);if(a.h){k=0;for(l=\na.H[0];l&&f>=l.s;)f-=l.s,k++,l=k<a.H.length?a.H[k]:null;m=0<k?a.H.slice(k):a.H;return n.return({compressedSize:g,ia:m,ja:0===k?e:null,ma:f,na:c})}return n.return({compressedSize:g,ia:[{P:-1,m:f+a.H[0].m,s:g}],ja:null,ma:0,na:c})}})};function ac(a,b,c){this.K=a;this.g=b;this.h=c}function bc(a,b){var c=new Ra(a,b);return pb(c,b).then(function(d){return new ac(c,d,b)})}ac.prototype.getZipEntries=function(){return qb(this.g)};ac.prototype.getZipEntry=function(a){return(a=this.g.l.get(a))?rb(a):null};ac.prototype.getResource=function(a){return(a=this.g.l.get(a))?new Zb(this.g.g.slice(a.h,a.h+a.j),a,this.K,this.h.deterministicChunkRequests):null};function cc(a){this.g=a}cc.prototype.fetchChunk=function(a,b){return Promise.resolve(this.g.slice(a,b))};cc.prototype.getSize=function(){return this.g.byteLength};function dc(a){this.g=a}dc.prototype.fetchChunk=function(a,b){var c=this;return new Promise(function(d,e){var h=c.g.slice(a,b),f=new FileReader;f.onload=function(){f.onload=null;f.onerror=null;d(f.result)};f.onerror=function(){f.onload=null;f.onerror=null;e(f.error)};f.readAsArrayBuffer(h)})};dc.prototype.getSize=function(){return this.g.size};function ec(a){this.h=a;this.j=null;this.g=new Da;this.i=new Da}function fc(a,b){return a.h?new Promise(function(c,d){for(var e=Fa(a.g);e&&0>e.F.wa;)e=Ga(a.g,e);var h=a.g;c={ta:b,wa:0,V:d,W:c,ea:null};e&&e.B?(c=Ea(c,e.B,e),e.B.v=c,e.B=c,h.s++):h.push(c);gc(a)}):Promise.reject(new Va("Cannot call scheduleDefaultTask() because no defaultTask was specified."))}\nfunction hc(a,b){var c=a.i.push(b);Promise.resolve().then(function(){if(b.ea)return b.ea();if(a.h)return a.h(b.ta)}).then(function(d){b.W(d)}).catch(function(d){b.V(d)}).finally(function(){Ha(a.i,c);gc(a)}).catch(function(d){console.error(d)})}\nfunction gc(a){Promise.resolve().then(function(){if(4>a.i.size()){var b;null==(b=a.j)||b.call(a);b=a.g;if(0===b.s)b=null;else{var c=b.g.B;Ha(b,c);b=c}b&&hc(a,b.F)}}).catch(function(b){console.error("Unexpected error in InternalAsyncTaskQueue.maybeExecuteNextTask",b)})};function ic(a,b){var c=this;this.g=a;this.s=b;this.h=new ec(function(d){var e=c.g;if(!e.u)throw new Z(e.l,"NOT_CONNECTED");d={msg:d,msgId:e.A++,type:3};var h=jc(e,d);try{kc(e,d)}catch(f){e.A--,d.msg=f.toString(),lc(e,d)}return h})}ic.prototype.fetchChunk=function(a,b){var c=this;return fc(this.h,{end:b,start:a,type:8}).then(function(d){return E(d.bufferOrStream)?mc(c,d.bufferOrStream):d.bufferOrStream})};ic.prototype.getSize=function(){return this.s};\nfunction mc(a,b){return new ReadableStream({cancel:function(){var c=a.g;var d={msg:{streamId:b,type:7},msgId:c.A++,type:4};try{kc(c,d)}catch(e){throw c.A--,e;}},pull:function(c){return fc(a.h,{streamId:b,type:5}).then(function(d){d.data&&c.enqueue(new Uint8Array(d.data));d.done&&c.close()}).catch(function(d){c.error(d)})}})};var nc=1;function oc(){this.g=new Map;this.h=!1;this.i=null}function pc(a,b){switch(b.type){case 7:b=b.streamId;var c=a.g.get(b);c&&c.cancel().catch(function(d){Ba(d)});a.g.delete(b)}}function qc(a,b,c){switch(b.type){case 1:return rc(a,b,c);case 3:return sc(a,b);case 5:return tc(a,b);case 10:return uc(a,b);default:return Promise.reject(new M("UNKNOWN_MESSAGE_FROM_HOST",\'messageType="\'+b.type+\'"\'))}}\nfunction sc(a,b){var c,d,e,h,f;return A(function(g){if(1==g.g)return(c=a.getResource(b.path))?y(g,c.createStream(b.range),2):g.return(Promise.reject(new M("ZIP_RESOURCE_NOT_FOUND",\'path="\'+b.path+\'"\')));d=g.h;a.h?e={message:{streamOrId:d,type:4},Y:[d]}:(h=d.getReader(),f=nc++,a.g.set(f,h),e={streamOrId:f,type:4});return g.return(e)})}oc.prototype.getResource=function(a){"/"===a[0]&&(a=a.slice(1));return this.i.getResource(a)};\nfunction rc(a,b,c){var d={chunkCacheSize:b.chunkCacheSize,deterministicChunkRequests:!0,maxChunkSize:b.maxChunkSize,preferredChunkSize:b.preferredChunkSize};return(b.blob?b.convertBlob?za(b.blob,b.blob.size).then(function(e){return bc(new cc(e),d)}):bc(new dc(b.blob),d):b.arrayBuffer?bc(new cc(b.arrayBuffer),d):E(b.dataSourceSize)?bc(new ic(c,b.dataSourceSize),d):Promise.reject(new M("ZIP_FILE_LOAD_ERROR","Unsupported data format"))).then(function(e){a.i=e;e=e.g;var h=qb(e);return{chunkDescriptors:sb(e),\nsha1Signature:e.G,type:2,zipEntries:h}})}function tc(a,b){var c,d;return A(function(e){if(c=a.g.get(b.streamId))return e.return(c.read().then(function(h){h.done&&a.g.delete(b.streamId);var f,g=null==(f=h.value)?void 0:f.buffer;h={data:g||null,done:h.done,type:6};return g?{message:h,Y:[g]}:h}).catch(function(h){a.g.delete(b.streamId);return Promise.reject(h)}));d={data:null,done:!0,type:6};return e.return(Promise.resolve(d))})}\nfunction uc(a,b){return b.stream.getReader().read().then(function(c){a.h=c.value instanceof Uint8Array&&3===c.value[0];return{ok:a.h,type:10}}).finally(function(){b.stream.cancel().catch(function(c){H(c)&&Ba(c)})})};function Z(a,b,c){var d=Error.call(this,"["+a+"] "+b+" :: "+(c||""));this.message=d.message;"stack"in d&&(this.stack=d.stack);this.namespace=a;this.errorType=b;this.errorMessage=c||""}x(Z,Error);function vc(a,b,c){this.l=a;this.G=b;this.N=c;this.u=!1;this.C=null;this.h=new Map;this.A=this.i=1;this.g=[];this.o=-1}function lc(a,b){var c=a.h.get(b.msgId);c&&(a.h.delete(b.msgId),-1!==c.R&&clearTimeout(c.R),a=(b=b.msg)&&b.errorMessage&&b.errorType?new Z(a.l,"ABORTED"===b.errorType?"ABORTED":"REMOTE_ERROR",b.errorType+" :: "+b.errorMessage+" :: "+b.stack):new Z(a.l,"ABORTED"===(null==b?void 0:b.errorType)?"ABORTED":"REMOTE_ERROR",F(b)?b:JSON.stringify(b)),c.V(a))}\nfunction wc(a,b){var c=a.h.get(b.msgId);c&&(a.h.delete(b.msgId),-1!==c.R&&clearTimeout(c.R),c.W(b.msg))}function xc(a){a.C||(a.C=function(b){if(yc(b))switch(b=b.data,b.type){case 2:a.u=!0;wc(a,b);break;case 3:case 4:a.i===b.msgId?(a.i++,zc(a,b),0<a.g.length&&Ac(a,!1)):Bc(a,b);break;case 5:wc(a,b);break;case 6:lc(a,b)}});return a.C}\nfunction Bc(a,b){console.log("Incoming out of order message: ",b.msgId,", expected: ",a.i);var c=a.g.findIndex(function(d){return d.msgId>b.msgId});0<=c?a.g.splice(c,0,b):a.g.push(b);-1===a.o&&(a.o=setTimeout(function(){a.o=-1;Ac(a,!0)},2E3))}\nfunction zc(a,b){switch(b.type){case 3:try{qc(a.N,b.msg,a).then(function(c){if(c&&c.Y&&c.message){var d=c.Y;c=c.message}a.u&&kc(a,{msg:c,msgId:b.msgId,type:5},d)}).catch(function(c){c&&"ABORTED"!==c.errorType&&console.error(c);Cc(a,b,c)})}catch(c){c&&"ABORTED"!==c.errorType&&console.error(c),Cc(a,b,c)}break;case 4:pc(a.N,b.msg)}}function Ac(a,b){for(;0<a.g.length&&(b||a.g[0].msgId===a.i);){var c=a.g.shift();a.i=c.msgId+1;zc(a,c)}0===a.g.length&&-1!==a.o&&clearTimeout(a.o)}\nfunction Cc(a,b,c){var d;c&&F(c.errorType)&&F(c.errorMessage)?d={errorMessage:c.errorMessage,errorType:c.errorType,stack:F(c.stack)?c.stack:""}:c&&(c.message?d={errorMessage:c.message,errorType:c.constructor?c.constructor.name:""+c,stack:F(c.stack)?c.stack:""}:d=F(c.stack)?c.stack:""+c);kc(a,{msg:d,msgId:b.msgId,type:6})}\nfunction jc(a,b){return new Promise(function(c,d){c={V:d,W:c,R:-1};a.h.set(b.msgId,c);c.R=setTimeout(function(){a.h.has(b.msgId)&&(a.h.delete(b.msgId),d(new Z(a.l,"TIMEOUT")))},a.G)})};function Dc(a,b,c,d){vc.call(this,b,c,d);this.j=a}x(Dc,vc);function yc(a){a=a.data;return E(a.type)&&E(a.msgId)}function kc(a,b,c){c?a.j.postMessage(b,c):a.j.postMessage(b)};(function(){var a=new Dc(self,"colibrio.core.io.resourceprovider.zip.webworker",6E4,new oc);return new Promise(function(b,c){function d(h){if(yc(h))if(h=h.data,a.j.removeEventListener("message",d,!1),1===h.type){a.u=!0;a.i=h.msgId+1;var f=xc(a);a.j.addEventListener("message",f,!1);kc(a,{msg:null,msgId:h.msgId,type:2});clearTimeout(e);b()}else c("Received invalid connect message")}var e=setTimeout(function(){a.j.removeEventListener("message",d,!1);c(new Z(a.l,"TIMEOUT"))},a.G);a.j.addEventListener("message",\nd,!1)})})().catch(function(a){console.error(a)});var Ec=[Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array];function Fc(a,b){var c=this.length;"number"!==typeof a&&(a=0);"number"!==typeof b&&(b=c);0>a&&(a=c+a);0>b&&(b=c+b);c=this.constructor;a=a*c.BYTES_PER_ELEMENT+this.byteOffset;b=b*c.BYTES_PER_ELEMENT+this.byteOffset;return new c(this.buffer.slice(a,b))}\nif(!("slice"in Ec[0].prototype))for(var Gc=0;Gc<Ec.length;Gc++)Object.defineProperty(Ec[Gc].prototype,"slice",{configurable:!0,value:Fc,writable:!0});var Hc=new ArrayBuffer(8);new DataView(Hc);new Uint8Array(Hc); }).call(__self); })(typeof self !== \'undefined\' && self ? self : typeof window !== \'undefined\' && window ? window : typeof global !== \'undefined\' && global ? global : this)\n';
    var api = {};
    (function() {
        var k;
        function aa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function ca(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var da = ca(this);
        function ea(a, b) {
            if (b) a: {
                var c = da;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var e = a[d];
                    if (!(e in c)) break a;
                    c = c[e];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && ba(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        ea("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, g) {
                this.g = f;
                ba(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        });
        ea("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = da[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return fa(aa(this));
                    }
                });
            }
            return a;
        });
        function fa(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        function ha(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return {
                next: aa(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        var ia = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, ja;
        if ("function" == typeof Object.setPrototypeOf) ja = Object.setPrototypeOf;
        else {
            var ka;
            a: {
                var la = {
                    a: !0
                }, ma = {};
                try {
                    ma.__proto__ = la;
                    ka = ma.a;
                    break a;
                } catch (a) {}
                ka = !1;
            }
            ja = ka ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var na = ja;
        function p(a, b) {
            a.prototype = ia(b.prototype);
            a.prototype.constructor = a;
            if (na) na(a, b);
            else for(var c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.ja = b.prototype;
        }
        function oa() {
            this.m = !1;
            this.h = null;
            this.j = void 0;
            this.g = 1;
            this.B = this.l = 0;
            this.i = null;
        }
        function pa(a) {
            if (a.m) throw new TypeError("Generator is already running");
            a.m = !0;
        }
        oa.prototype.s = function(a) {
            this.j = a;
        };
        function qa(a, b) {
            a.i = {
                da: b,
                ia: !0
            };
            a.g = a.l || a.B;
        }
        oa.prototype.return = function(a) {
            this.i = {
                return: a
            };
            this.g = this.B;
        };
        function q(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        function ra(a) {
            a.l = 0;
            var b = a.i.da;
            a.i = null;
            return b;
        }
        function sa(a) {
            this.g = new oa;
            this.h = a;
        }
        function ta(a, b) {
            pa(a.g);
            var c = a.g.h;
            if (c) return ua(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return u(a);
        }
        function ua(a, b, c, d) {
            try {
                var e = b.call(a.g.h, c);
                if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                if (!e.done) return a.g.m = !1, e;
                var f = e.value;
            } catch (g) {
                return a.g.h = null, qa(a.g, g), u(a);
            }
            a.g.h = null;
            d.call(a.g, f);
            return u(a);
        }
        function u(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.m = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.j = void 0, qa(a.g, c);
            }
            a.g.m = !1;
            if (a.g.i) {
                b = a.g.i;
                a.g.i = null;
                if (b.ia) throw b.da;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function va(a) {
            this.next = function(b) {
                pa(a.g);
                a.g.h ? b = ua(a, a.g.h.next, b, a.g.s) : (a.g.s(b), b = u(a));
                return b;
            };
            this.throw = function(b) {
                pa(a.g);
                a.g.h ? b = ua(a, a.g.h["throw"], b, a.g.s) : (qa(a.g, b), b = u(a));
                return b;
            };
            this.return = function(b) {
                return ta(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function wa(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function f(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        }
        function v(a) {
            return wa(new va(new sa(a)));
        }
        var y = __dep__colibrio_core_base;
        var z = __dep__colibrio_core_io_base;
        var A = __dep__colibrio_core_url;
        function xa(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), e = 0; e < d.length; e++){
                var f = d[e], g = a[f];
                null !== g && "object" === typeof g ? b[f] = xa(g, b[f], c) : "undefined" === typeof g ? c && delete b[f] : b[f] = g;
            }
            return b;
        }
        function ya(a) {
            return xa(a, {
                chunkCacheSize: 16E6,
                maxChunkSize: 4E5,
                preferredChunkSize: 1E5,
                transferBuffers: !1
            }, !1);
        }
        function za(a) {
            return "number" === typeof a && !isNaN(a);
        }
        function B(a) {
            return "string" === typeof a;
        }
        var Aa = new Uint16Array(1);
        Aa[0] = 4660;
        new Uint8Array(Aa.buffer);
        function Ba(a) {
            var b, c, d, e;
            return v(function(f) {
                switch(f.g){
                    case 1:
                        b = a.getReader(), c = [], d = !1;
                    case 2:
                        if (d) {
                            f.g = 4;
                            break;
                        }
                        return q(f, b.read(), 5);
                    case 5:
                        e = f.j;
                        e.value && c.push(e.value);
                        d = e.done;
                        f.g = 2;
                        break;
                    case 4:
                        return f.return(c);
                }
            });
        }
        function C(a, b, c) {
            var d = Error.call(this, "[" + a + "] " + b + " :: " + (c || ""));
            this.message = d.message;
            "stack" in d && (this.stack = d.stack);
            this.namespace = a;
            this.errorType = b;
            this.errorMessage = c || "";
        }
        p(C, Error);
        C.isColibrioError = Ca;
        C.isColibrioAbortedError = D;
        function Ca(a) {
            return a instanceof C || a && B(a.errorType) && B(a.namespace);
        }
        function D(a) {
            return Ca(a) && "ABORTED" === a.errorType || a instanceof DOMException && (a.code === DOMException.ABORT_ERR || "AbortError" === a.name);
        }
        function E(a, b) {
            return y.ColibrioError.call(this, "colibrio.core.io.resourceprovider.zip", a, b) || this;
        }
        p(E, y.ColibrioError);
        function Da(a, b) {
            this.i = a;
            this.h = b;
            this.l = 1;
            this.g = new Map;
            this.j = !1;
        }
        function Ea(a, b) {
            switch(b.type){
                case 7:
                    b = b.streamId;
                    var c = a.g.get(b);
                    c && c.cancel().catch(function(d) {
                        y.Logger.logWarning(d);
                    });
                    a.g.delete(b);
            }
        }
        function Fa(a, b) {
            switch(b.type){
                case 8:
                    return Ga(a, b);
                case 5:
                    return Ha(a, b);
            }
            return Promise.reject("Unknown ZipWorkerMessage");
        }
        function Ga(a, b) {
            return a.i ? a.i.fetchChunk(b.start, b.end).then(function(c) {
                var d, e = null, f = !1, g = b.end - b.start;
                c instanceof Uint8Array ? (c.length !== g && y.Logger.logError(new z.IoError(z.IoErrorType.INVALID_DATA_CHUNK, "Expected RandomAccessDataSource.fetchChunk(" + b.start + ", " + b.end + ") to return " + g + " bytes of data. Actually got " + c.length + " bytes.")), 0 < c.byteOffset || c.byteLength !== c.buffer.byteLength ? (e = c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength), f = !0) : (e = c.buffer, f = a.h)) : c instanceof ArrayBuffer ? (c.byteLength !== g && y.Logger.logError(new z.IoError(z.IoErrorType.INVALID_DATA_CHUNK, "Expected RandomAccessDataSource.fetchChunk(" + b.start + ", " + b.end + ") to return " + g + " bytes of data. Actually got " + c.byteLength + " bytes.")), e = c, f = a.h) : c instanceof ReadableStream && (a.j ? (e = c, f = !0) : (g = c.getReader(), e = a.l++, a.g.set(e, g)));
                if (e) f ? d = {
                    message: {
                        bufferOrStream: e,
                        type: 9
                    },
                    U: [
                        e
                    ]
                } : d = {
                    bufferOrStream: e,
                    type: 9
                };
                else throw c = new E("INVALID_RANDOM_ACCESS_DATA_SOURCE_RESPONSE", "Unsupported data type. Got: " + (null == c ? void 0 : c.constructor.name)), y.Logger.logError(c), c;
                return d;
            }) : Promise.reject("RandomAccessDataSource not available");
        }
        function Ha(a, b) {
            var c = a.g.get(b.streamId);
            return c ? c.read().then(function(d) {
                d.done && a.g.delete(b.streamId);
                var e = d.value;
                e ? (d = {
                    data: e.buffer,
                    done: d.done,
                    type: 6
                }, a.h && (d = {
                    message: d,
                    U: [
                        e.buffer
                    ]
                })) : d = {
                    data: null,
                    done: d.done,
                    type: 6
                };
                return d;
            }).catch(function(d) {
                a.g.delete(b.streamId);
                return Promise.reject(d);
            }) : Promise.resolve({
                data: null,
                done: !0,
                type: 6
            });
        }
        function F(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        p(F, Error);
        function G() {
            this.u = 0;
            this.h = H(null, null, null);
            this.g = H(null, this.h, null);
            this.h.o = this.g;
        }
        G.prototype.every = function(a) {
            for(var b = this.h.o, c = !0; b !== this.g && c;){
                var d = b.o;
                c = a(b);
                b = null === b.o ? d : b.o;
            }
            return c;
        };
        G.prototype.find = function(a) {
            for(var b = this.h.o, c = null; b !== this.g && null === c;){
                var d = b.o;
                a(b) && (c = b);
                b = null === b.o ? d : b.o;
            }
            return c;
        };
        G.prototype.forEach = function(a) {
            for(var b = this.h.o; b !== this.g;){
                var c = b.o;
                a(b);
                b = null === b.o ? c : b.o;
            }
        };
        function I(a) {
            return a.u ? a.h.o : null;
        }
        function L(a, b) {
            return (b = b.o) && a.g !== b ? b : null;
        }
        function Ia(a, b, c) {
            b && b.v ? (c = H(c, b.v, b), b.v.o = c, b.v = c, a.u++) : Ja(a, c);
        }
        function Ja(a, b) {
            b = H(b, a.g.v, a.g);
            b.v.o = b;
            a.g.v = b;
            a.u++;
            return b;
        }
        G.prototype.size = function() {
            return this.u;
        };
        function H(a, b, c) {
            return {
                A: a,
                o: c,
                v: b
            };
        }
        function M(a, b) {
            if (b.v && b.o) {
                var c = b.v, d = b.o;
                c.o = d;
                d.v = c;
                b.o = null;
                b.v = null;
                a.u--;
            }
        }
        function Ka(a) {
            this.l = a;
            this.m = null;
            this.i = !1;
            this.s = null;
            this.h = !1;
            this.g = new G;
            this.j = new G;
        }
        k = Ka.prototype;
        k.destroy = function(a) {
            this.i = !0;
            this.m = a;
            for(var b = I(this.g); b;)b.A.I(a), b = L(this.g, b);
            a = this.g;
            a.h = H(null, null, null);
            a.g = H(null, a.h, null);
            a.h.o = a.g;
            a.u = 0;
        };
        k.getNumberOfRunningTasks = function() {
            return this.j.size();
        };
        k.getNumberOfTasksInQueue = function() {
            return this.g.size();
        };
        k.isDestroyed = function() {
            return this.i;
        };
        k.isPaused = function() {
            return this.h;
        };
        k.pause = function() {
            this.h = !0;
        };
        k.resume = function() {
            this.h && (this.h = !1, N(this));
        };
        k.scheduleDefaultTask = function(a, b) {
            var c = this;
            return this.i ? Promise.reject(this.m) : this.l ? new Promise(function(d, e) {
                for(var f = I(c.g); f && f.A.R < b;)f = L(c.g, f);
                Ia(c.g, f, {
                    V: a,
                    R: b,
                    I: e,
                    L: d,
                    S: null
                });
                N(c);
            }) : Promise.reject(new F("Cannot call scheduleDefaultTask() because no defaultTask was specified."));
        };
        k.scheduleTask = function(a, b) {
            var c = this;
            return this.i ? Promise.reject(this.m) : new Promise(function(d, e) {
                for(var f = I(c.g); f && f.A.R < b;)f = L(c.g, f);
                Ia(c.g, f, {
                    V: null,
                    R: b,
                    I: e,
                    L: d,
                    S: a
                });
                N(c);
            });
        };
        k.setOnBeforeExecuteNextTask = function(a) {
            this.s = a;
        };
        function La(a, b) {
            var c = Ja(a.j, b);
            Promise.resolve().then(function() {
                if (b.S) return b.S();
                if (a.l) return a.l(b.V);
            }).then(function(d) {
                b.L(d);
            }).catch(function(d) {
                b.I(d);
            }).finally(function() {
                M(a.j, c);
                N(a);
            }).catch(function(d) {
                console.error(d);
            });
        }
        function N(a) {
            Promise.resolve().then(function() {
                if (4 > a.j.size()) {
                    var b;
                    null == (b = a.s) || b.call(a);
                    if (!a.h) {
                        b = a.g;
                        if (0 === b.u) b = null;
                        else {
                            var c = b.g.v;
                            M(b, c);
                            b = c;
                        }
                        b && La(a, b.A);
                    }
                }
            }).catch(function(b) {
                console.error("Unexpected error in InternalAsyncTaskQueue.maybeExecuteNextTask", b);
            });
        }
        function Ma(a) {
            za() && (a = a.slice(void 0, void 0));
            return new Promise(function(b, c) {
                var d = new FileReader;
                d.onload = function() {
                    d.onabort = null;
                    d.onload = null;
                    d.onerror = null;
                    b(d.result);
                };
                d.onabort = d.onerror = function() {
                    d.onabort = null;
                    d.onload = null;
                    d.onerror = null;
                    c(d.error);
                };
                d.readAsArrayBuffer(a);
            });
        }
        function O(a, b, c) {
            var d = Error.call(this, "[" + a + "] " + b + " :: " + (c || ""));
            this.message = d.message;
            "stack" in d && (this.stack = d.stack);
            this.namespace = a;
            this.errorType = b;
            this.errorMessage = c || "";
        }
        p(O, Error);
        function Na(a, b, c) {
            this.j = a;
            this.O = b;
            this.F = c;
            this.B = !1;
            this.l = null;
            this.g = new Map;
            this.C = this.m = 1;
            this.h = [];
            this.i = -1;
        }
        function Oa(a) {
            var b = Pa(a, 1, {}), c = Qa(a, b);
            Ra(a, Sa(a));
            P(a, b);
            return c.then(function() {
                return a;
            });
        }
        Na.prototype.destroy = function() {
            var a = this;
            this.g.forEach(function(b) {
                -1 !== b.G && clearTimeout(b.G);
                b.I(new O(a.j, "ABORTED"));
            });
            this.g.clear();
            this.B = !1;
            this.l && this.s.removeEventListener("message", this.l, !1);
            -1 !== this.i && (clearTimeout(this.i), this.i = -1);
            this.h = [];
        };
        function Ta(a, b, c) {
            if (!a.B) throw new O(a.j, "NOT_CONNECTED");
            b = Pa(a, 3, b);
            var d = Qa(a, b);
            try {
                P(a, b, c);
            } catch (e) {
                a.C--, b.msg = e.toString(), Ua(a, b);
            }
            return d;
        }
        function Pa(a, b, c) {
            return {
                msg: c,
                msgId: a.C++,
                type: b
            };
        }
        function Ua(a, b) {
            var c = a.g.get(b.msgId);
            c && (a.g.delete(b.msgId), -1 !== c.G && clearTimeout(c.G), a = (b = b.msg) && b.errorMessage && b.errorType ? new O(a.j, "ABORTED" === b.errorType ? "ABORTED" : "REMOTE_ERROR", b.errorType + " :: " + b.errorMessage + " :: " + b.stack) : new O(a.j, "ABORTED" === (null == b ? void 0 : b.errorType) ? "ABORTED" : "REMOTE_ERROR", B(b) ? b : JSON.stringify(b)), c.I(a));
        }
        function Va(a, b) {
            var c = a.g.get(b.msgId);
            c && (a.g.delete(b.msgId), -1 !== c.G && clearTimeout(c.G), c.L(b.msg));
        }
        function Sa(a) {
            a.l || (a.l = function(b) {
                var c = b.data;
                if (za(c.type) && za(c.msgId)) switch(b = b.data, b.type){
                    case 2:
                        a.B = !0;
                        Va(a, b);
                        break;
                    case 3:
                    case 4:
                        a.m === b.msgId ? (a.m++, Wa(a, b), 0 < a.h.length && Xa(a, !1)) : Ya(a, b);
                        break;
                    case 5:
                        Va(a, b);
                        break;
                    case 6:
                        Ua(a, b);
                }
            });
            return a.l;
        }
        function Ya(a, b) {
            console.log("Incoming out of order message: ", b.msgId, ", expected: ", a.m);
            var c = a.h.findIndex(function(d) {
                return d.msgId > b.msgId;
            });
            0 <= c ? a.h.splice(c, 0, b) : a.h.push(b);
            -1 === a.i && (a.i = setTimeout(function() {
                a.i = -1;
                Xa(a, !0);
            }, 2E3));
        }
        function Wa(a, b) {
            switch(b.type){
                case 3:
                    try {
                        Fa(a.F, b.msg).then(function(c) {
                            if (c && c.U && c.message) {
                                var d = c.U;
                                c = c.message;
                            }
                            a.B && P(a, {
                                msg: c,
                                msgId: b.msgId,
                                type: 5
                            }, d);
                        }).catch(function(c) {
                            c && "ABORTED" !== c.errorType && console.error(c);
                            Za(a, b, c);
                        });
                    } catch (c) {
                        c && "ABORTED" !== c.errorType && console.error(c), Za(a, b, c);
                    }
                    break;
                case 4:
                    Ea(a.F, b.msg);
            }
        }
        function Xa(a, b) {
            for(; 0 < a.h.length && (b || a.h[0].msgId === a.m);){
                var c = a.h.shift();
                a.m = c.msgId + 1;
                Wa(a, c);
            }
            0 === a.h.length && -1 !== a.i && clearTimeout(a.i);
        }
        function Za(a, b, c) {
            var d;
            c && B(c.errorType) && B(c.errorMessage) ? d = {
                errorMessage: c.errorMessage,
                errorType: c.errorType,
                stack: B(c.stack) ? c.stack : ""
            } : c && (c.message ? d = {
                errorMessage: c.message,
                errorType: c.constructor ? c.constructor.name : "" + c,
                stack: B(c.stack) ? c.stack : ""
            } : d = B(c.stack) ? c.stack : "" + c);
            P(a, {
                msg: d,
                msgId: b.msgId,
                type: 6
            });
        }
        function Qa(a, b) {
            return new Promise(function(c, d) {
                c = {
                    I: d,
                    L: c,
                    G: -1
                };
                a.g.set(b.msgId, c);
                c.G = setTimeout(function() {
                    a.g.has(b.msgId) && (a.g.delete(b.msgId), d(new O(a.j, "TIMEOUT")));
                }, a.O);
            });
        }
        function $a(a, b, c, d) {
            Na.call(this, b, c, d);
            this.s = a;
        }
        p($a, Na);
        function Ra(a, b) {
            a.s.addEventListener("message", b, !1);
        }
        function P(a, b, c) {
            c ? a.s.postMessage(b, c) : a.s.postMessage(b);
        }
        function ab(a) {
            var b = __worker__colibrio_core_io_resourceprovider_zip_webworker;
            this.g = null;
            var c = new Blob([
                b
            ]);
            try {
                this.g = URL.createObjectURL(c), this.h = new Worker(this.g);
            } catch (d) {
                this.g && URL.revokeObjectURL(this.g), a = a((new TextEncoder).encode(b)), this.h = new Worker(new URL("data:text/javascript;base64," + a));
            }
        }
        ab.prototype.terminate = function() {
            this.h.terminate();
            this.g && URL.revokeObjectURL(this.g);
        };
        function Q(a) {
            this.h = a;
            this.g = new G;
            this.j = new Map;
            this.i = 0;
            this.l = null;
        }
        function R(a, b) {
            var c = a.j.get(b);
            c && (a.j.delete(b), M(a.g, c), a.i -= c.A.u, a.l && a.l(c.A.M, b));
        }
        Q.prototype.find = function(a) {
            var b = this.g;
            b = b.u ? b.g.v : null;
            for(var c; b && void 0 === c;)a(b.A.M, b.A.W) ? c = b.A.M : b = (b = b.v) && this.g.h !== b ? b : null;
            b && bb(this, b);
            return c;
        };
        Q.prototype.get = function(a) {
            return (a = this.j.get(a)) ? (bb(this, a), a.A.M) : null;
        };
        Q.prototype.has = function(a) {
            return this.j.has(a);
        };
        Q.prototype.set = function(a, b, c) {
            if (!(c > this.h.ga || !this.h.$ && c > this.h.Z)) {
                var d = this.h.P;
                b = {
                    W: a,
                    ha: 0,
                    u: c,
                    ca: d ? Date.now() + d : 0,
                    M: b
                };
                R(this, a);
                b = Ja(this.g, b);
                this.j.set(a, b);
                this.i += c;
                cb(this);
            }
        };
        function db(a, b) {
            a.l = b;
        }
        function cb(a) {
            var b = a.h.Z, c = a.h.$, d = a.h.P;
            if (d && a.i > b && a.g.size() > c) {
                d = d ? Date.now() : 0;
                for(var e = I(a.g); a.i > b && a.g.size() > c && e && e.A.ca <= d;){
                    var f = L(a.g, e);
                    0 >= e.A.ha && R(a, e.A.W);
                    e = f;
                }
            }
        }
        function bb(a, b) {
            var c = a.h.P, d = a.g;
            b.v && b.o && (M(d, b), b.v = d.g.v, b.o = d.g, b.v.o = b, d.g.v = b, d.u++);
            c && (b.A.ca = Date.now() + c);
            c && cb(a);
        }
        function T(a, b) {
            C.call(this, "colibrio.core.io.resourceprovider.zip.webworker", a, b);
        }
        p(T, C);
        function eb(a) {
            this.g = a;
            this.i = !1;
            this.h = null;
        }
        function fb(a, b, c) {
            return c.fetchChunk(a, b).then(function(d) {
                if (d instanceof ArrayBuffer) d = new Uint8Array(d);
                else if (!(d instanceof Uint8Array || d instanceof ReadableStream)) throw new T("INVALID_RANDOM_ACCESS_DATA_CHUNK", "Expected an ArrayBuffer, Uint8Array or ReadableStream. Got: " + (null == d ? void 0 : d.constructor.name));
                return new eb(d);
            });
        }
        function gb(a, b, c) {
            if (a.g instanceof Uint8Array) return new ReadableStream({
                start: function(g) {
                    var h = a.g;
                    if (0 < b || c !== h.length) h = h.subarray(b, b + c);
                    g.enqueue(h);
                    g.close();
                }
            });
            if (a.i) {
                var d = ha(a.g.tee()), e = d.next().value;
                d = d.next().value;
                a.g = e;
                var f = d.getReader();
            } else f = a.g.getReader();
            return new ReadableStream({
                cancel: function() {
                    f.cancel().catch(function(g) {
                        D(g) || console.warn(g);
                    });
                },
                pull: function(g) {
                    var h, l, r, m, n, J, w, K, S;
                    return v(function(t) {
                        switch(t.g){
                            case 1:
                                t.l = 2, h = !1;
                            case 4:
                                if (h) {
                                    t.g = 0;
                                    t.l = 0;
                                    break;
                                }
                                return q(t, f.read(), 7);
                            case 7:
                                l = t.j;
                                if (r = l.value) b >= r.length ? b -= r.length : (m = void 0, r.length >= b + c ? m = r.subarray(b, b + c) : 0 < b ? (m = r.subarray(b), b = 0) : m = r, c -= m.length, g.enqueue(m), h = !0);
                                0 === c ? (g.close(), f.cancel().catch(function(x) {
                                    D(x) || console.warn(x);
                                }), h = !0) : l.done && (h = !0, J = n = void 0, null == (J = (n = a).h) || J.call(n), g.error(new T("UNEXPECTED_END_OF_STREAM", "Stream returned by fetchChunk() ended too early.")), f.cancel().catch(function(x) {
                                    D(x) || console.warn(x);
                                }));
                                t.g = 4;
                                break;
                            case 2:
                                throw w = ra(t), null == (S = (K = a).h) || S.call(K), w;
                        }
                    });
                }
            });
        }
        function hb(a, b) {
            a.i && !b && a.g instanceof ReadableStream && (a.g.locked || a.g.cancel().catch(function(c) {
                D(c) || console.warn(c);
            }));
            a.i = b;
        }
        function ib(a, b) {
            a.h = b;
        }
        function jb(a, b) {
            this.i = a;
            this.h = b;
            this.j = new Map;
            a = Math.max(this.h.maxChunkSize, this.h.chunkCacheSize);
            this.g = new Q({
                ga: a,
                Z: a,
                $: 0,
                P: 0
            });
            db(this.g, function(c) {
                c.aa.then(function(d) {
                    d.h = null;
                    hb(d, !1);
                }).catch();
            });
        }
        function kb(a, b, c) {
            var d = a.i.getSize();
            if (b >= c || c > d) return Promise.reject(new T("INVALID_START_END_OFFSETS", "start: " + b + ", end: " + c + ", sizeOfDisk: " + d));
            var e = lb(a, b, c);
            if (e) d = e.aa.then(function(g) {
                return gb(g, b - e.ba, c - b);
            });
            else {
                d < 1.5 * a.h.preferredChunkSize && d < a.h.maxChunkSize && (b = 0, c = d);
                d = fb(b, c, a.i);
                var f = b + ":" + c;
                a.h.deterministicChunkRequests && a.j.set(f, {
                    end: c,
                    start: b
                });
                a.g.set(f, {
                    fa: c,
                    aa: d,
                    ba: b
                }, c - b);
                d = d.then(function(g) {
                    a.g.has(f) && (hb(g, !0), ib(g, function() {
                        R(a.g, f);
                    }));
                    return gb(g, 0, c - b);
                }).catch(function(g) {
                    R(a.g, f);
                    return Promise.reject(g);
                });
            }
            return d;
        }
        function mb(a, b, c) {
            return kb(a, b, c).then(function(d) {
                return Ba(d);
            }).then(function(d) {
                if (0 === d.length) d = new Uint8Array(0);
                else if (1 === d.length) d = d[0];
                else {
                    for(var e = 0, f = 0; f < d.length; f++)e += d[f].byteLength;
                    e = new Uint8Array(e);
                    for(var g = f = 0; g < d.length; g++){
                        var h = d[g];
                        e.set(h, f);
                        f += h.byteLength;
                    }
                    d = e;
                }
                return d;
            });
        }
        function nb(a) {
            var b = [];
            a.j.forEach(function(c) {
                b.push(c);
            });
            return b;
        }
        function lb(a, b, c) {
            return a.g.find(function(d) {
                return d.ba <= b && d.fa >= c;
            });
        }
        var ob = __lib__timsort;
        function pb(a, b) {
            this.j = !1;
            this.l = new Uint8Array(64);
            this.i = this.h = 0;
            this.m = new Int32Array(a);
            this.g = new Int32Array(b);
            qb(this.g);
        }
        k = pb.prototype;
        k.append = function(a) {
            if (this.j) throw new F("Illegal Sha.append(). Already finalized.");
            var b = 0;
            a instanceof ArrayBuffer ? a = new Uint8Array(a) : a instanceof Uint8Array || (B(a) ? (rb || (rb = new TextEncoder), a = rb.encode(a)) : a = new Uint8Array(a.buffer, a.byteOffset, a.byteLength));
            if (a.length > Number.MAX_SAFE_INTEGER) throw new F("Data passed to Sha.append() is too large");
            var c = a.length;
            if (0 < this.h) {
                b = Math.min(64 - this.h, c);
                for(var d = 0; d < b; d++)this.l[this.h++] = a[d];
                64 === this.h && (U(this.l, 0, this.m, this.g), this.h = 0);
            }
            this.i += c;
            if (!(b >= c)) {
                d = c - (c - b) % 64;
                if (b < d) {
                    for(; b < d; b += 64)U(a, b, this.m, this.g);
                    b > d && (b -= 64);
                }
                if (b < c) for(; b < c;)this.l[this.h++] = a[b++];
            }
        };
        k.digestToHex = function() {
            sb(this);
            for(var a = Array(2 * this.g.byteLength), b = 0, c = 0; c < this.g.length; c++)for(var d = this.g[c], e = 7; 0 <= e; e--){
                var f = d >> (e << 2) & 15;
                a[b++] = (10 > f ? 48 : 87) + f;
            }
            return String.fromCharCode.apply(null, a);
        };
        k.digestToUint32Array = function() {
            sb(this);
            return new Uint32Array(this.g);
        };
        k.digestToUint8Array = function() {
            sb(this);
            for(var a = new Uint8Array(this.g.byteLength), b = 0, c = 0; c < this.g.length; c++){
                var d = this.g[c];
                a[b++] = d >>> 24;
                a[b++] = d >>> 16;
                a[b++] = d >>> 8;
                a[b++] = d;
            }
            return a;
        };
        k.reset = function() {
            qb(this.g);
            this.j = !1;
            this.i = this.h = 0;
        };
        function sb(a) {
            if (!a.j) {
                a.j = !0;
                var b = a.h, c = a.l;
                c[b++] = 128;
                if (56 < b) {
                    for(; 64 > b;)c[b++] = 0;
                    U(c, 0, a.m, a.g);
                    b = 0;
                }
                for(; 56 > b;)c[b++] = 0;
                if (a.i > Math.pow(2, 29) - 1) {
                    var d = Math.trunc(a.i / Math.pow(2, 29)) | 0;
                    c[b++] = d >>> 24;
                    c[b++] = d >>> 16;
                    c[b++] = d >>> 8;
                    c[b++] = d;
                } else for(; 60 > b;)c[b++] = 0;
                d = a.i << 3 | 0;
                c[b++] = d >>> 24;
                c[b++] = d >>> 16;
                c[b++] = d >>> 8;
                c[b++] = d;
                U(c, 0, a.m, a.g);
            }
        }
        var rb = null;
        function tb() {
            pb.call(this, 80, 5);
        }
        p(tb, pb);
        function U(a, b, c, d) {
            for(var e = 0; 16 > e; e++)c[e] = a[b++] << 24 | a[b++] << 16 | a[b++] << 8 | a[b++];
            for(a = 16; 80 > a; a++)c[a] = V(c[a - 3] ^ c[a - 8] ^ c[a - 14] ^ c[a - 16], 1);
            a = d[0];
            b = d[1];
            e = d[2];
            for(var f = d[3], g = d[4], h = 0; 20 > h; h++){
                var l = V(a, 5) + (b & e | ~b & f) + g + c[h] + 1518500249 | 0;
                g = f;
                f = e;
                e = V(b, 30);
                b = a;
                a = l;
            }
            for(h = 20; 40 > h; h++)l = V(a, 5) + (b ^ e ^ f) + g + c[h] + 1859775393 | 0, g = f, f = e, e = V(b, 30), b = a, a = l;
            for(h = 40; 60 > h; h++)l = V(a, 5) + (b & e | b & f | e & f) + g + c[h] + 2400959708 | 0, g = f, f = e, e = V(b, 30), b = a, a = l;
            for(h = 60; 80 > h; h++)l = V(a, 5) + (b ^ e ^ f) + g + c[h] + 3395469782 | 0, g = f, f = e, e = V(b, 30), b = a, a = l;
            d[0] += a;
            d[1] += b;
            d[2] += e;
            d[3] += f;
            d[4] += g;
        }
        function qb(a) {
            a[0] = 1732584193;
            a[1] = 4023233417;
            a[2] = 2562383102;
            a[3] = 271733878;
            a[4] = 3285377520;
        }
        function V(a, b) {
            return a << b | a >>> 32 - b;
        }
        function W(a) {
            this.g = a;
        }
        function X(a, b) {
            return a.g[b] + (a.g[b + 1] << 8);
        }
        function Y(a, b) {
            return a.g[b] + (a.g[b + 1] << 8) + (a.g[b + 2] << 16) + (a.g[b + 3] << 24 >>> 0);
        }
        function Z(a, b) {
            var c = a.g[b] + (a.g[b + 1] << 8) + (a.g[b + 2] << 16) + (a.g[b + 3] << 24 >>> 0);
            a = a.g[b + 4] + (a.g[b + 5] << 8) + (a.g[b + 6] << 16) + (a.g[b + 7] << 24 >>> 0);
            return 2097151 < a ? -1 : c + 4294967296 * a;
        }
        function ub() {
            this.h = this.g = void 0;
            this.i = new TextDecoder("utf-8");
        }
        var vb;
        ub.prototype.decode = function(a) {
            return 2 <= a.length && 254 === a[0] && 255 === a[1] && (void 0 === this.g && (this.g = wb("utf-16be")), this.g) ? this.g.decode(a) : 2 <= a.length && 255 === a[0] && 254 === a[1] && (void 0 === this.h && (this.h = wb("utf-16le")), this.h) ? this.h.decode(a) : this.i.decode(a);
        };
        function wb(a) {
            try {
                return new TextDecoder(a);
            } catch (b) {
                return console.error(b), null;
            }
        }
        var xb = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            91,
            92,
            93,
            94,
            95,
            96,
            97,
            98,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            107,
            108,
            109,
            110,
            111,
            112,
            113,
            114,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            123,
            124,
            125,
            126,
            127,
            199,
            252,
            233,
            226,
            228,
            224,
            229,
            231,
            234,
            235,
            232,
            239,
            238,
            236,
            196,
            197,
            201,
            230,
            198,
            244,
            246,
            242,
            251,
            249,
            255,
            214,
            220,
            162,
            163,
            165,
            8359,
            402,
            225,
            237,
            243,
            250,
            241,
            209,
            170,
            186,
            191,
            8976,
            172,
            189,
            188,
            161,
            171,
            187,
            9617,
            9618,
            9619,
            9474,
            9508,
            9569,
            9570,
            9558,
            9557,
            9571,
            9553,
            9559,
            9565,
            9564,
            9563,
            9488,
            9492,
            9524,
            9516,
            9500,
            9472,
            9532,
            9566,
            9567,
            9562,
            9556,
            9577,
            9574,
            9568,
            9552,
            9580,
            9575,
            9576,
            9572,
            9573,
            9561,
            9560,
            9554,
            9555,
            9579,
            9578,
            9496,
            9484,
            9608,
            9604,
            9612,
            9616,
            9600,
            945,
            223,
            915,
            960,
            931,
            963,
            181,
            964,
            934,
            920,
            937,
            948,
            8734,
            966,
            949,
            8745,
            8801,
            177,
            8805,
            8804,
            8992,
            8993,
            247,
            8776,
            176,
            8729,
            183,
            8730,
            8319,
            178,
            9632,
            160
        ];
        function yb(a, b) {
            this.h = -1;
            this.i = 0;
            this.j = -1;
            this.m = 0;
            var c = new W(new Uint8Array(a, b));
            if (33639248 !== Y(c, 0)) throw new T("INVALID_CENTRAL_DIRECTORY_FILE_HEADER_SIGNATURE");
            var d = X(c, 8) & 2048;
            this.C = X(c, 10);
            this.l = Y(c, 20);
            this.s = Y(c, 24);
            var e = X(c, 28), f = 46 + e, g = X(c, 30);
            this.F = f + g + X(c, 32);
            this.g = Y(c, 42);
            c = new Uint8Array(a, b + 46, e);
            if (d) vb || (vb = new ub), d = vb.decode(c);
            else {
                d = Array(c.length);
                for(e = 0; e < c.length; e++)d[e] = xb[c[e]];
                d = String.fromCharCode.apply(null, d);
            }
            this.B = d;
            if (0 < g) for(a = new W(new Uint8Array(a, b + f, g)), b = 0; b < g;){
                f = X(a, b + 2);
                if (1 === X(a, b)) {
                    d = b + 4;
                    4294967295 === this.s && (c = Z(a, d), 0 <= c && (this.s = c), d += 8);
                    if (4294967295 === this.l) {
                        c = Z(a, d);
                        if (-1 === c) throw new T("ZIP64_FIELD_LARGER_THAN_52BITS", "Compressed size");
                        this.l = c;
                        d += 8;
                    }
                    if (4294967295 === this.g) {
                        d = Z(a, d);
                        if (-1 === d) throw new T("ZIP64_FIELD_LARGER_THAN_52BITS", "Offset to local header");
                        this.g = d;
                    }
                }
                b += f + 4;
            }
        }
        function zb(a, b) {
            this.g = new W(new Uint8Array(a, b));
            if (101075792 !== Y(this.g, 0)) throw new T("INVALID_ZIP64_END_OF_CENTRAL_DIRECTORY_SIGNATURE");
        }
        function Ab(a, b) {
            return mb(a, b, b + 56).then(function(c) {
                return new zb(c.buffer, c.byteOffset);
            });
        }
        zb.prototype.N = function() {
            var a = Z(this.g, 48);
            if (-1 === a) throw new T("ZIP64_FIELD_LARGER_THAN_52BITS", "OFFSET_TO_CENTRAL_DIRECTORY_FROM_STARTING_DISC");
            return a;
        };
        zb.prototype.T = function() {
            var a = Z(this.g, 40);
            if (-1 === a) throw new T("ZIP64_FIELD_LARGER_THAN_52BITS", "SIZE_OF_CENTRAL_DIRECTORY");
            return a;
        };
        zb.prototype.ea = function() {
            var a = Z(this.g, 32);
            if (-1 === a) throw new T("ZIP64_FIELD_LARGER_THAN_52BITS", "TOTAL_NUM_ENTRIES_IN_CENTRAL_DIRECTORY");
            return a;
        };
        function Bb(a, b) {
            this.g = new W(new Uint8Array(a, b));
        }
        function Cb(a, b) {
            a = Z(a.g, 8);
            if (-1 === a) throw new T("ZIP64_FIELD_LARGER_THAN_52BITS", "Archive not supported");
            return Ab(b, a);
        }
        function Db(a, b, c) {
            this.h = c;
            this.g = new W(new Uint8Array(a, b));
        }
        function Eb(a) {
            var b = a.i.getSize();
            return mb(a, Math.max(0, b - 65578), b).then(function(c) {
                for(var d = -1, e = c.length - 22; 0 < e && -1 === d; e--)80 === c[e] && 75 === c[e + 1] && 5 === c[e + 2] && 6 === c[e + 3] && (d = e);
                if (-1 === d) throw new T("END_OF_CENTRAL_DIRECTORY_SIGNATURE_NOT_FOUND");
                e = d + c.byteOffset;
                var f = null, g;
                if (g = 20 < d) d -= 20, g = 80 === c[d] && 75 === c[d + 1] && 6 === c[d + 2] && 7 === c[d + 3];
                g && (f = new Bb(c.buffer, e - 20));
                return new Db(c.buffer, e, f);
            });
        }
        Db.prototype.N = function() {
            return Y(this.g, 16);
        };
        Db.prototype.T = function() {
            return Y(this.g, 12);
        };
        Db.prototype.ea = function() {
            return X(this.g, 10);
        };
        function Fb(a, b, c, d) {
            this.j = a;
            this.m = c;
            this.h = [];
            this.g = [];
            this.l = !1;
            this.F = new Map;
            this.i = 0;
            this.O = c.ea();
            this.s = b.byteOffset;
            this.C = b.buffer;
            a = new tb;
            a.append(b);
            this.B = a.digestToHex();
            Gb(this, d);
            if (!this.l) for(b = nb(d), ob.sort(b, function(e, f) {
                return e.start - f.start;
            }), d = 0; d < b.length; d++)a = b[d], this.g.push({
                K: this.i++,
                D: a.start,
                u: a.end - a.start
            });
        }
        function Hb(a, b) {
            return Eb(a).then(function(c) {
                var d = c.h;
                if (d) {
                    if (1 < Y(d.g, 16)) throw new T("MULTI_VOLUME_ZIP_UNSUPPORTED");
                    return Cb(d, a).catch(function(e) {
                        console.error(e);
                        return c;
                    });
                }
                if (1 < X(c.g, 4)) throw new T("MULTI_VOLUME_ZIP_UNSUPPORTED");
                return c;
            }).then(function(c) {
                var d = c.N(), e = c.T();
                return mb(a, d, d + e).then(function(f) {
                    return new Fb(b, f, c, a);
                });
            });
        }
        function Ib(a) {
            return a.h.map(function(b) {
                return {
                    compressedSize: b.l,
                    compressionMethod: b.C,
                    entrySize: b.m,
                    numChunks: b.i,
                    path: b.B,
                    startChunkIndex: b.h,
                    startOffsetInChunk: b.j,
                    uncompressedSize: b.s
                };
            });
        }
        Fb.prototype.getDataChunkDescriptors = function() {
            return this.g.map(function(a) {
                return {
                    end: a.D + a.u,
                    start: a.D
                };
            });
        };
        function Jb(a) {
            var b = a.m.N(), c = b + a.m.T(), d = a.g.findIndex(function(f) {
                var g = f.D;
                f = g + f.u;
                return b >= g && c <= f;
            });
            if (-1 === d) throw new F("The chunk used for ZIP archive signature calculation not found");
            var e = a.g[d];
            return {
                dataChunkIndex: d,
                rangeWithinDataChunk: {
                    end: c - e.D,
                    start: b - e.D
                },
                sha1Hash: a.B
            };
        }
        function Kb(a, b, c, d) {
            var e = b.m;
            if (d && b.g >= d.start) a.l ? c = a.g[a.g.length - 1] : (a.l = !0, c = {
                K: a.i++,
                D: d.start,
                u: d.end - d.start
            }, a.g.push(c)), b.h = c.K, b.j = b.g - c.D, b.i = 1;
            else if (c && c.u + e < a.j.preferredChunkSize) b.h = c.K, b.j = c.u, b.i = 1, c.u += e;
            else for(d = b.g, b.h = a.i, b.j = 0; 0 < e;){
                var f = Math.min(e, a.j.maxChunkSize);
                c = {
                    K: a.i++,
                    D: d,
                    u: f
                };
                a.g.push(c);
                b.i++;
                e -= f;
                d += f;
            }
            return c && c.u < a.j.preferredChunkSize ? c : null;
        }
        function Gb(a, b) {
            for(var c = 0; c < a.O; c++){
                var d = new yb(a.C, a.s);
                a.h.push(d);
                a.F.set(d.B, d);
                a.s += d.F;
            }
            ob.sort(a.h, function(l, r) {
                return l.g - r.g;
            });
            c = null;
            b = nb(b);
            b = 1 === b.length ? b[0] : null;
            d = 0;
            for(var e = a.h.length; d < e; d++){
                var f = a.h[d], g = a.h[d + 1], h = void 0;
                h = g ? g.g : a.m.N();
                f.m = h - f.g;
                c = Kb(a, f, c, b);
            }
        }
        function Lb(a, b, c, d, e) {
            var f = this;
            this.C = a;
            this.i = b;
            this.B = c;
            this.F = e;
            this.g = !1;
            this.l = new Map;
            this.s = new Map;
            this.j = new Ka(function(g) {
                return f.g ? Promise.reject(new E("ZIP_RESOURCE_PROVIDER_DESTROYED")) : Ta(f.i, g);
            });
            this.h = Mb(c);
            this.m = d.map(function(g) {
                var h = A.URLUtils.cloneUrl(f.h);
                h.pathname = g.path;
                h = A.URLUtils.normalizePathnameEncoding(h);
                var l = h.pathname;
                g = {
                    H: {
                        acceptsRanges: 0 === g.compressionMethod,
                        pathRelativeToBaseUrl: l.slice(1),
                        size: g.uncompressedSize,
                        url: h.toString()
                    },
                    J: g
                };
                f.s.set(l, g);
                f.l.set(l.toLowerCase(), g);
                return g;
            });
        }
        function Mb(a) {
            return new URL("com.colibrio.zipstream://" + a + "/");
        }
        function Nb(a, b) {
            return Ob({
                arrayBuffer: a,
                chunkCacheSize: 0,
                maxChunkSize: 1E6,
                preferredChunkSize: 1E5,
                type: 1
            }, b, null);
        }
        function Ob(a, b, c) {
            var d = new ab(function(g) {
                return y.Base64.encode(g);
            }), e = new Da(c, b), f = new $a(d.h, "colibrio.core.io.resourceprovider.zip", 6E4, e);
            return Oa(f).then(function() {
                var g, h, l, r;
                return v(function(m) {
                    switch(m.g){
                        case 1:
                            b && a.arrayBuffer && (g = [
                                a.arrayBuffer
                            ]);
                            if (!c) {
                                m.g = 2;
                                break;
                            }
                            h = new ReadableStream({
                                start: function(n) {
                                    n.enqueue(new Uint8Array([
                                        3
                                    ]));
                                    n.close();
                                }
                            });
                            l = {
                                stream: h,
                                type: 10
                            };
                            m.l = 3;
                            return q(m, Ta(f, l, [
                                h
                            ]), 5);
                        case 5:
                            r = m.j;
                            r.ok && (y.Logger.logInfo("ZipResourceProvider: Transferable streams enabled: true"), e.j = !0);
                            m.g = 2;
                            m.l = 0;
                            break;
                        case 3:
                            ra(m);
                        case 2:
                            return m.return(Ta(f, a, g).then(function(n) {
                                return new Lb(d, f, n.sha1Signature, n.zipEntries, n.chunkDescriptors);
                            }));
                    }
                });
            }).catch(function(g) {
                f.destroy();
                d.terminate();
                return Promise.reject(g);
            });
        }
        k = Lb.prototype;
        k.acceptsUrl = function(a) {
            try {
                return a = Pb(this, a), A.URLUtils.isSubpath(a, this.h);
            } catch (b) {
                return !1;
            }
        };
        k.destroy = function() {
            this.g || (this.g = !0, this.j.destroy(new E(y.ColibrioErrorType.ABORTED)), this.i.destroy(), this.C.terminate());
        };
        k.fetch = function(a, b) {
            var c = this, d, e, f, g, h, l, r, m, n, J;
            return v(function(w) {
                if (1 == w.g) {
                    if (c.g) return w.return(Promise.reject(new E("ZIP_RESOURCE_PROVIDER_DESTROYED")));
                    d = Qb(c, a);
                    if (!d) return w.return(Promise.reject(new E(z.IoErrorType.RESOURCE_NOT_FOUND, a.toString())));
                    f = null == (e = b) ? void 0 : e.range;
                    g = null;
                    if (f) {
                        g = {
                            end: "undefined" === typeof (null == (h = f) ? void 0 : h.end) ? d.J.uncompressedSize : f.end,
                            start: f.start
                        };
                        if (g.end > d.J.uncompressedSize || 0 > g.start || g.end < g.start) throw new E(z.IoErrorType.INVALID_BYTE_RANGE, "Range: " + g.start + "-" + g.end);
                        if (!d.H.acceptsRanges) throw new E(z.IoErrorType.BYTE_RANGES_NOT_SUPPORTED, d.J.path + ": Byte range requests not supported for deflated resources.");
                        if (g.end === g.start) return w.return(new z.Uint8ArrayResourceResponse(d.H, [
                            new Uint8Array(0)
                        ]));
                    }
                    l = !1;
                    r = {
                        path: d.J.path,
                        range: g,
                        type: 3
                    };
                    return q(w, c.j.scheduleDefaultTask(r, 0), 2);
                }
                m = w.j;
                if (m.streamOrId instanceof ReadableStream) return w.return(new z.ReadableStreamResourceResponse(d.H, m.streamOrId));
                n = m.streamOrId;
                J = new ReadableStream({
                    cancel: function() {
                        Rb(c, n);
                    },
                    pull: function(K) {
                        var S, t;
                        return v(function(x) {
                            if (1 == x.g) {
                                if (l || -1 === n) {
                                    K.error(new E(y.ColibrioErrorType.ABORTED));
                                    x.g = 0;
                                    return;
                                }
                                S = {
                                    streamId: n,
                                    type: 5
                                };
                                return q(x, c.j.scheduleDefaultTask(S, 0), 3);
                            }
                            t = x.j;
                            t.data && K.enqueue(new Uint8Array(t.data));
                            t.done && K.close();
                            x.g = 0;
                        });
                    }
                });
                return w.return(new z.ReadableStreamResourceResponse(d.H, J, function() {
                    l = !0;
                    Rb(c, n);
                }));
            });
        };
        k.fetchMetadata = function(a) {
            if (this.g) return Promise.reject(new E("ZIP_RESOURCE_PROVIDER_DESTROYED"));
            var b = Qb(this, a);
            return b ? Promise.resolve(b.H) : Promise.reject(new E(z.IoErrorType.RESOURCE_NOT_FOUND, a.toString()));
        };
        k.getBaseUrl = function() {
            return A.URLUtils.cloneUrl(this.h);
        };
        k.getCentralDirectorySha1Signature = function() {
            return this.B;
        };
        k.getDataChunkDescriptors = function() {
            return this.F;
        };
        k.getResourceManifest = function() {
            return this.m.map(function(a) {
                return a.H;
            });
        };
        k.getZipEntries = function() {
            return this.m.map(function(a) {
                return a.J;
            });
        };
        k.isDestroyed = function() {
            return this.g;
        };
        k.isUrlSupportedByBrowser = function() {
            return !1;
        };
        function Rb(a, b) {
            if (!a.g && -1 !== b) {
                a = a.i;
                b = Pa(a, 4, {
                    streamId: b,
                    type: 7
                });
                try {
                    P(a, b);
                } catch (c) {
                    throw a.C--, c;
                }
            }
        }
        function Qb(a, b) {
            b = Pb(a, b);
            if (!A.URLUtils.isSubpath(b, a.h)) return null;
            b = b.pathname;
            var c = a.s.get(b);
            c || (c = a.l.get(b.toLowerCase()));
            return c || null;
        }
        function Pb(a, b) {
            return B(b) ? A.URLUtils.normalizePathnameEncoding(new URL(b, a.h)) : b;
        }
        api = {
            ZipResourceProvider: {
                createBaseUrl: Mb,
                createFromArrayBuffer: Nb,
                createFromBase64: function(a) {
                    a = y.Base64.decode(a);
                    return Nb(a.buffer, !0);
                },
                createFromBlob: function(a) {
                    return y.BrowserDetector.isBrowser("Safari") || y.BrowserDetector.isBrowser("Firefox") && y.BrowserDetector.isPlatform("mobile") || y.BrowserDetector.isOS("iOS") ? Ma(a).then(function(b) {
                        return Nb(b, !0);
                    }) : Ob({
                        blob: a,
                        chunkCacheSize: 16E3,
                        convertBlob: !1,
                        maxChunkSize: 1E6,
                        preferredChunkSize: 1E5,
                        type: 1
                    }, !1, null);
                },
                createFromRandomAccessDataSource: function(a, b) {
                    b = ya(b);
                    return Ob({
                        chunkCacheSize: b.chunkCacheSize,
                        dataSourceSize: a.getSize(),
                        maxChunkSize: b.maxChunkSize,
                        preferredChunkSize: b.preferredChunkSize,
                        type: 1
                    }, b.transferBuffers, a);
                },
                fetchZipArchiveInformation: function(a, b) {
                    b = ya(b);
                    b = {
                        chunkCacheSize: b.chunkCacheSize,
                        deterministicChunkRequests: !0,
                        maxChunkSize: b.maxChunkSize,
                        preferredChunkSize: b.preferredChunkSize
                    };
                    a = new jb(a, b);
                    return Hb(a, b).then(function(c) {
                        return {
                            dataChunkDescriptors: c.getDataChunkDescriptors(),
                            signature: Jb(c),
                            zipEntries: Ib(c)
                        };
                    });
                }
            },
            ZipResourceProviderError: E,
            ZipResourceProviderErrorType: {
                ZIP_RESOURCE_PROVIDER_DESTROYED: "ZIP_RESOURCE_PROVIDER_DESTROYED",
                INVALID_RANDOM_ACCESS_DATA_SOURCE_RESPONSE: "INVALID_RANDOM_ACCESS_DATA_SOURCE_RESPONSE"
            }
        };
        var Sb = new ArrayBuffer(8);
        new DataView(Sb);
        new Uint8Array(Sb);
    }).call(__self);
    return api;
});

});

parcelRegister("lrB5E", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";









(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("7uZag")), (parcelRequire("kj8wo")), (parcelRequire("acQau")), (parcelRequire("k5V4T")), (parcelRequire("cLeaP")), (parcelRequire("a75zb")), (parcelRequire("gWxKE")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_io_mediatypedetector, __dep__colibrio_core_io_resourceprovider_zip, __dep__colibrio_core_publication_base, __dep__colibrio_core_drm, __dep__colibrio_core_encryption, __dep__colibrio_core_url, __dep__colibrio_core_xml) {
    var api = {};
    (function() {
        var f, g = g || {};
        g.scope = {};
        g.O = function(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        };
        g.$ = function(a) {
            return {
                next: g.O(a)
            };
        };
        g.J = !1;
        g.ja = !1;
        g.ka = !1;
        g.na = !1;
        g.M = !1;
        g.la = !1;
        g.ma = !1;
        g.defineProperty = g.J || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        g.ca = function(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        };
        g.global = g.ca(this);
        g.F = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
        g.N = !g.M || g.F;
        g.H = {};
        g.I = {};
        g.V = "$jscp$";
        g.T = function(a, b, c) {
            b && (g.M ? g.fa(a, b, c) : g.ga(a, b));
        };
        g.ga = function(a, b) {
            var c = g.global;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) return;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && g.defineProperty(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        };
        g.fa = function(a, b, c) {
            var d = a.split(".");
            a = 1 === d.length;
            var e = d[0], h;
            !a && e in g.H ? h = g.H : h = g.global;
            for(e = 0; e < d.length - 1; e++){
                var k = d[e];
                if (!(k in h)) return;
                h = h[k];
            }
            d = d[d.length - 1];
            c = g.F && "es6" === c ? h[d] : null;
            b = b(c);
            null != b && (a ? g.defineProperty(g.H, d, {
                configurable: !0,
                writable: !0,
                value: b
            }) : b !== c && (void 0 === g.I[d] && (a = 1E9 * Math.random() >>> 0, g.I[d] = g.F ? g.global.Symbol(d) : g.V + a + "$" + d), g.defineProperty(h, g.I[d], {
                configurable: !0,
                writable: !0,
                value: b
            })));
        };
        g.ta = function() {};
        g.T("Symbol", function(a) {
            function b(h) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (h || "") + "_" + e++, h);
            }
            function c(h, k) {
                this.g = h;
                g.defineProperty(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: k
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        }, "es6");
        g.T("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = g.global[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && g.defineProperty(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return g.ea(g.O(this));
                    }
                });
            }
            return a;
        }, "es6");
        g.ea = function(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        };
        g.qa = function(a) {
            return a.raw = a;
        };
        g.ra = function(a, b) {
            a.raw = b;
            return a;
        };
        g.D = function(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return g.$(a);
            throw Error(String(a) + " is not an iterable or ArrayLike");
        };
        g.Z = function(a) {
            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
            return c;
        };
        g.W = function(a) {
            return a instanceof Array ? a : g.Z(g.D(a));
        };
        g.S = g.J || "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        };
        g.ba = function() {
            function a() {
                function c() {}
                new c;
                Reflect.construct(c, [], function() {});
                return new c instanceof c;
            }
            if (g.N && "undefined" != typeof Reflect && Reflect.construct) {
                if (a()) return Reflect.construct;
                var b = Reflect.construct;
                return function(c, d, e) {
                    c = b(c, d);
                    e && Reflect.setPrototypeOf(c, e.prototype);
                    return c;
                };
            }
            return function(c, d, e) {
                void 0 === e && (e = c);
                e = g.S(e.prototype || Object.prototype);
                return Function.prototype.apply.call(c, e, d) || e;
            };
        };
        g.construct = ({
            valueOf: g.ba
        }).valueOf();
        g.ha = function() {
            var a = {
                a: !0
            }, b = {};
            try {
                return b.__proto__ = a, b.a;
            } catch (c) {}
            return !1;
        };
        g.setPrototypeOf = g.N && "function" == typeof Object.setPrototypeOf ? Object.setPrototypeOf : g.ha() ? function(a, b) {
            a.__proto__ = b;
            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
            return a;
        } : null;
        g.inherits = function(a, b) {
            a.prototype = g.S(b.prototype);
            a.prototype.constructor = a;
            if (g.setPrototypeOf) {
                var c = g.setPrototypeOf;
                c(a, b);
            } else for(c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.ua = b.prototype;
        };
        g.s = {};
        g.s.aa = function(a) {
            if (!(a instanceof Object)) throw new TypeError("Iterator result " + a + " is not an object");
        };
        g.s.C = function() {
            this.m = !1;
            this.j = null;
            this.h = void 0;
            this.g = 1;
            this.A = this.i = 0;
            this.l = null;
        };
        function aa(a) {
            if (a.m) throw new TypeError("Generator is already running");
            a.m = !0;
        }
        g.s.C.prototype.u = function(a) {
            this.h = a;
        };
        function ba(a, b) {
            a.l = {
                R: b,
                da: !0
            };
            a.g = a.i || a.A;
        }
        g.s.C.prototype.return = function(a) {
            this.l = {
                return: a
            };
            this.g = this.A;
        };
        function l(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        function n(a) {
            a.i = 0;
            var b = a.l.R;
            a.l = null;
            return b;
        }
        g.s.C.g = function(a) {
            this.g = [];
            for(var b in a)this.g.push(b);
            this.g.reverse();
        };
        g.s.K = function(a) {
            this.g = new g.s.C;
            this.h = a;
        };
        function ca(a, b) {
            aa(a.g);
            var c = a.g.j;
            if (c) return da(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return r(a);
        }
        function da(a, b, c, d) {
            try {
                var e = b.call(a.g.j, c);
                g.s.aa(e);
                if (!e.done) return a.g.m = !1, e;
                var h = e.value;
            } catch (k) {
                return a.g.j = null, ba(a.g, k), r(a);
            }
            a.g.j = null;
            d.call(a.g, h);
            return r(a);
        }
        function r(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.m = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.h = void 0, ba(a.g, c);
            }
            a.g.m = !1;
            if (a.g.l) {
                b = a.g.l;
                a.g.l = null;
                if (b.da) throw b.R;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        g.s.L = function(a) {
            this.next = function(b) {
                aa(a.g);
                a.g.j ? b = da(a, a.g.j.next, b, a.g.u) : (a.g.u(b), b = r(a));
                return b;
            };
            this.throw = function(b) {
                aa(a.g);
                a.g.j ? b = da(a, a.g.j["throw"], b, a.g.u) : (ba(a.g, b), b = r(a));
                return b;
            };
            this.return = function(b) {
                return ca(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        };
        g.s.pa = function(a, b) {
            b = new g.s.L(new g.s.K(b));
            g.setPrototypeOf && a.prototype && g.setPrototypeOf(b, a.prototype);
            return b;
        };
        g.P = function(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function h(k) {
                    k.done ? d(k.value) : Promise.resolve(k.value).then(b, c).then(h, e);
                }
                h(a.next());
            });
        };
        g.oa = function(a) {
            return g.P(a());
        };
        g.B = function(a) {
            return g.P(new g.s.L(new g.s.K(a)));
        };
        g.sa = function() {
            for(var a = Number(this), b = [], c = a; c < arguments.length; c++)b[c - a] = arguments[c];
            return b;
        };
        var z = __dep__colibrio_core_base;
        var ea = __dep__colibrio_core_drm;
        var fa = __dep__colibrio_core_encryption;
        var E = __dep__colibrio_core_io_base;
        var ha = __dep__colibrio_core_io_mediatypedetector;
        var F = __dep__colibrio_core_io_resourceprovider_zip;
        var G = __dep__colibrio_core_publication_base;
        var H = __dep__colibrio_core_url;
        var I = __dep__colibrio_core_xml;
        function K(a) {
            return "string" === typeof a && /\S/.test(a);
        }
        function L(a, b, c) {
            return a && ia(c, a) ? c[a] : b;
        }
        var ia = Function.prototype.call.bind(Object.prototype.hasOwnProperty);
        var ja = new Uint16Array(1);
        ja[0] = 4660;
        new Uint8Array(ja.buffer);
        function ka(a, b, c, d, e) {
            this.i = a;
            this.l = b;
            this.h = c;
            this.g = d;
            this.j = e;
            this.m = d ? d.i : null;
        }
        f = ka.prototype;
        f.getContentUrl = function() {
            return this.h.getContentUrl();
        };
        f.getIndexInSpine = function() {
            return this.j;
        };
        f.getLayout = function() {
            var a;
            this.g && (a = la(this.g, {
                "rendition:layout-pre-paginated": G.ContentDocumentLayout.PRE_PAGINATED,
                "rendition:layout-reflowable": G.ContentDocumentLayout.REFLOWABLE
            }));
            return a ? a : this.i.getDefaultLayout();
        };
        f.getMediaOverlayUrl = function() {
            var a = null, b = this.h.m;
            b && (b = M(N(this.l), b)) && b.g === E.MediaType.APPLICATION_SMIL && (a = b.getContentUrl());
            return a;
        };
        f.getMediaType = function() {
            return this.h.g;
        };
        f.getOpfManifestItemElement = function() {
            return this.h.i;
        };
        f.getOpfSpineItemElement = function() {
            return this.m;
        };
        f.getPageSpreadSlot = function() {
            var a;
            this.g && (a = la(this.g, {
                "page-spread-left": G.PageSpreadSlot.LEFT,
                "page-spread-right": G.PageSpreadSlot.RIGHT,
                "rendition:page-spread-center": G.PageSpreadSlot.CENTER,
                "rendition:page-spread-left": G.PageSpreadSlot.LEFT,
                "rendition:page-spread-right": G.PageSpreadSlot.RIGHT
            }));
            return a ? a : G.PageSpreadSlot.AUTO;
        };
        f.getPublication = function() {
            return this.i;
        };
        f.getSyntheticSpreadBehavior = function() {
            var a;
            this.g && (a = la(this.g, {
                "rendition:spread-auto": G.SyntheticSpreadBehavior.AUTO,
                "rendition:spread-both": G.SyntheticSpreadBehavior.BOTH,
                "rendition:spread-landscape": G.SyntheticSpreadBehavior.LANDSCAPE,
                "rendition:spread-none": G.SyntheticSpreadBehavior.NONE,
                "rendition:spread-portrait": G.SyntheticSpreadBehavior.BOTH
            }));
            return a ? a : this.i.getPreferredSyntheticSpreadBehavior();
        };
        f.hasRemoteResources = function() {
            return -1 !== this.h.h.indexOf("remote-resources");
        };
        f.isInLinearContent = function() {
            return this.g ? this.g.j : !1;
        };
        f.isScripted = function() {
            return -1 !== this.h.h.indexOf("scripted");
        };
        f.toJSON = function() {
            return {
                contentUrl: this.getContentUrl().toString(),
                hasRemoteResources: this.hasRemoteResources(),
                indexInSpine: this.j,
                inLinearContent: this.isInLinearContent(),
                layout: this.getLayout(),
                mediaType: this.getMediaType(),
                pageSpreadSlot: this.getPageSpreadSlot(),
                scripted: this.isScripted(),
                syntheticSpreadBehavior: this.getSyntheticSpreadBehavior()
            };
        };
        function la(a, b) {
            return (a = a.g.find(function(c) {
                return ia(b, c);
            })) ? b[a] : void 0;
        }
        function O(a, b, c) {
            this.h = a;
            this.g = b;
            this.i = c;
        }
        O.prototype.getDocument = function() {
            return this.h;
        };
        O.prototype.getType = function() {
            return this.g;
        };
        O.prototype.getUrl = function() {
            return this.i;
        };
        function P(a, b) {
            return z.ColibrioError.call(this, "core.publication.epub", a, b) || this;
        }
        g.inherits(P, z.ColibrioError);
        function ma(a, b) {
            this.g = a;
            this.h = null;
            a = this.g.getMetadata();
            !a.mediaType && b && (this.h = Object.assign({}, a), this.h.mediaType = b);
        }
        f = ma.prototype;
        f.abort = function() {
            this.g.abort();
        };
        f.asText = function() {
            return this.g.asText();
        };
        f.asUint8Array = function() {
            return this.g.asUint8Array();
        };
        f.getMetadata = function() {
            return this.h || this.g.getMetadata();
        };
        f.getReadableStream = function() {
            return this.g.getReadableStream();
        };
        function na(a, b) {
            this.g = a;
            this.j = b;
            this.i = null;
            a = this.g.getBaseUrl();
            if (!a) throw new P("BASE_URL_MISSING", "BaseURL required for EpubResourceProvider");
            this.h = a;
        }
        f = na.prototype;
        f.acceptsUrl = function(a) {
            return this.g.acceptsUrl(a);
        };
        f.fetch = function(a, b) {
            a = g.D(oa(this, a, b));
            var c = a.next().value, d = a.next().value;
            return this.g.fetch(c, b).then(function(e) {
                return new ma(e, d);
            });
        };
        f.fetchMetadata = function(a, b) {
            a = g.D(oa(this, a, b));
            var c = a.next().value, d = a.next().value;
            return this.g.fetchMetadata(c, b).then(function(e) {
                !e.mediaType && d && (e = Object.assign({}, e), e.mediaType = d);
                return e;
            });
        };
        f.getBaseUrl = function() {
            return null !== this.h ? H.URLUtils.cloneUrl(this.h) : null;
        };
        f.getResourceManifest = function() {
            var a = this;
            null === this.i && (this.i = this.j.g.map(function(b) {
                return {
                    mediaType: a.getMediaType(b.getContentUrl(), b),
                    pathRelativeToBaseUrl: H.URLUtils.getSubpath(b.getContentUrl(), a.h),
                    url: b.getContentUrl().toString()
                };
            }));
            return this.i;
        };
        f.isUrlSupportedByBrowser = function(a, b) {
            return this.g.isUrlSupportedByBrowser(a, b);
        };
        f.getMediaType = function(a, b) {
            if (b) {
                if (b = b.g, b.startsWith("audio") || b.startsWith("video")) b = ha.MediaTypeDetector.getMediaTypeByExtension(a.pathname) || b;
            } else b = ha.MediaTypeDetector.getMediaTypeByExtension(a.pathname) || void 0;
            if (b) switch(b.toLowerCase()){
                case "audio/m4a":
                    b = E.MediaType.AUDIO_MP4;
            }
            return b;
        };
        function oa(a, b, c) {
            "string" === typeof b && (b = H.URLUtils.normalizePathnameEncoding(new URL(b, a.h)));
            (c = pa(a.j, b, null == c ? void 0 : c.accept)) && (b = c.getContentUrl());
            a = a.getMediaType(b, c);
            return [
                b,
                a
            ];
        }
        function qa(a) {
            this.g = a;
        }
        qa.prototype.getAppleBooksOptions = function() {
            return this.g;
        };
        function ra(a) {
            a = a.trim();
            var b = 0, c = 0, d = 0, e = 0, h = /^[0-9]+(\.[0-9]+)?(h|min|s|ms)?$/;
            if (/^([0-9]+:)?[0-9][0-9]:[0-9][0-9](\.[0-9]+)?$/.test(a)) a = a.split(":"), d = parseFloat(a.pop()), 0 < a.length && (c = parseFloat(a.pop()), 0 < a.length && (b = parseFloat(a.pop())));
            else if (h.test(a)) -1 != a.indexOf("h") ? b = parseFloat(a) : -1 != a.indexOf("min") ? c = parseFloat(a) : -1 != a.indexOf("ms") ? e = parseFloat(a) : d = parseFloat(a);
            else return null;
            return 1E3 * (3600 * b + 60 * c + d) + e;
        }
        function sa(a, b) {
            this.h = a;
            this.g = b;
        }
        function ta(a, b) {
            var c = [];
            for(b = b.firstElementChild; b;){
                switch(b.localName){
                    case "par":
                        var d = a;
                        for(var e = b, h = null, k = null, m = e.firstElementChild; m;){
                            switch(m.localName){
                                case "text":
                                    h = m;
                                    var p = h.getAttribute("src");
                                    h = p ? {
                                        attributes: z.NodeDataUtils.createXmlElementAttributeData(h),
                                        childNodes: [],
                                        namespaceURI: h.namespaceURI,
                                        nodeName: h.localName,
                                        nodeType: z.NodeType.XML_ELEMENT,
                                        prefix: h.prefix,
                                        src: p
                                    } : null;
                                    break;
                                case "audio":
                                    k = d;
                                    p = m;
                                    var B = p.getAttribute("src"), w = p.getAttribute("clipBegin"), x = null;
                                    w && (x = ra(w), null === x && z.Logger.logWarning(new P("INVALID_MEDIA_OVERLAY", k.g.pathname + ": invalid SMIL clock value: " + w)));
                                    w = p.getAttribute("clipEnd");
                                    var A = null;
                                    w && (A = ra(w), null === A && z.Logger.logWarning(new P("INVALID_MEDIA_OVERLAY", k.g.pathname + ": invalid SMIL clock value: " + w)));
                                    k = B ? {
                                        attributes: z.NodeDataUtils.createXmlElementAttributeData(p),
                                        childNodes: [],
                                        clipBeginMs: x || 0,
                                        clipEndMs: A,
                                        namespaceURI: p.namespaceURI,
                                        nodeName: p.localName,
                                        nodeType: z.NodeType.XML_ELEMENT,
                                        prefix: p.prefix,
                                        src: B
                                    } : null;
                            }
                            m = m.nextElementSibling;
                        }
                        h ? d = {
                            attributes: z.NodeDataUtils.createXmlElementAttributeData(e),
                            audio: k,
                            childNodes: k ? [
                                h,
                                k
                            ] : [
                                h
                            ],
                            namespaceURI: e.namespaceURI,
                            nodeName: e.localName,
                            nodeType: z.NodeType.XML_ELEMENT,
                            prefix: e.prefix,
                            text: h
                        } : (z.Logger.logError(new P("INVALID_MEDIA_OVERLAY", d.g.pathname + ": par element missing valid text child")), d = null);
                        d && c.push(d);
                        break;
                    case "seq":
                        d = a, e = b, e.hasAttributeNS(z.XmlNamespace.EPUB, "textref") || z.Logger.logWarning(new P("INVALID_MEDIA_OVERLAY", d.g.pathname + " seq element missing textref attribute")), m = ta(d, e), 1 > m.length ? (z.Logger.logWarning(new P("INVALID_MEDIA_OVERLAY", d.g.pathname + ": seq element doesn't have any valid seq or par children")), d = null) : d = ua(e, m), d && c.push(d);
                }
                b = b.nextElementSibling;
            }
            return c;
        }
        function ua(a, b) {
            return {
                attributes: z.NodeDataUtils.createXmlElementAttributeData(a),
                childNodes: b,
                children: b,
                namespaceURI: a.namespaceURI,
                nodeName: a.localName,
                nodeType: z.NodeType.XML_ELEMENT,
                prefix: a.prefix,
                textRef: a.getAttributeNS(z.XmlNamespace.EPUB, "textref")
            };
        }
        function Q(a) {
            this.g = a;
        }
        Q.prototype.getActiveClassName = function() {
            return R(this, "active-class");
        };
        Q.prototype.getDurationMs = function() {
            var a = R(this, "duration");
            return a ? ra(a) : null;
        };
        Q.prototype.getNarrator = function() {
            return R(this, "narrator");
        };
        Q.prototype.getPlaybackActiveClassName = function() {
            return R(this, "playback-active-class");
        };
        function R(a, b) {
            return (a = va(a.g, z.XmlNamespace.MEDIA_OVERLAYS, b)) ? a.content.value : null;
        }
        function wa(a) {
            this.g = a.getMetadata();
            this.h = new Q(this.g);
        }
        f = wa.prototype;
        f.getAll = function() {
            return this.g.getAll().slice();
        };
        f.getIdentifiers = function() {
            return xa(this, this.g.i);
        };
        f.getLanguages = function() {
            return xa(this, this.g.j);
        };
        f.getMediaOverlayMetadata = function() {
            return this.h;
        };
        f.getTitles = function() {
            return xa(this, this.g.l);
        };
        f.getUniqueIdentifier = function() {
            return this.g.getUniqueIdentifier();
        };
        f.toJSON = function() {
            return {
                all: this.getAll(),
                identifierIndexes: this.g.i.slice(),
                languageIndexes: this.g.j.slice(),
                titleIndexes: this.g.l.slice(),
                type: G.PublicationMetadataType.EPUB_PUBLICATION_METADATA,
                uniqueIdentifier: this.g.getUniqueIdentifier()
            };
        };
        function xa(a, b) {
            var c = a.g.getAll();
            return b.map(function(d) {
                return c[d];
            });
        }
        function ya(a, b, c, d) {
            this.U = b;
            this.g = c;
            this.h = this.i = null;
            this.l = !1;
            this.m = new Map;
            this.u = new Map;
            this.A = new wa(c);
            this.j = new na(a, N(c));
            d && (this.i = d.getOptionsForPlatform("ALL"));
            this.ia = new qa(d);
        }
        f = ya.prototype;
        f.destroy = function() {
            this.l || (this.l = !0, this.h = [], this.m.clear());
        };
        f.fetchMediaOverlay = function(a) {
            var b = this, c = a.href, d = this.u.get(c);
            d || (d = this.j.fetch(a, {
                accept: [
                    E.MediaType.APPLICATION_SMIL
                ]
            }).then(function(e) {
                return e.asText().then(function(h) {
                    var k = new I.DomParser, m = e.getMetadata(), p;
                    h = k.parseXmlString(h, null != (p = m.pathRelativeToBaseUrl) ? p : m.url);
                    h = new sa(h, a);
                    p = h.h.documentElement;
                    if (!p) throw new P("INVALID_MEDIA_OVERLAY", h.g.pathname + ": document element not found");
                    for(k = p.firstElementChild; k && "body" !== k.localName;)k = k.nextElementSibling;
                    if (!k) throw new P("INVALID_MEDIA_OVERLAY", h.g.pathname + ": body element not found");
                    var B = ta(h, k);
                    if (1 > B.length) throw new P("INVALID_MEDIA_OVERLAY", h.g.pathname + ": smil body missing valid seq and par children");
                    h = ua(k, B);
                    return {
                        mediaOverlay: {
                            attributes: z.NodeDataUtils.createXmlElementAttributeData(p),
                            body: h,
                            childNodes: [
                                h
                            ],
                            namespaceURI: p.namespaceURI,
                            nodeName: p.localName,
                            nodeType: z.NodeType.XML_ELEMENT,
                            prefix: p.prefix
                        },
                        metadata: m
                    };
                });
            }).catch(function(e) {
                b.u.delete(c);
                return Promise.reject(e);
            }), this.u.set(c, d));
            return d;
        };
        f.fetchNavigationDocument = function() {
            var a = this, b, c, d, e, h, k, m, p, B, w, x, A, t, v, u, q, C, D, J, Aa, Ba;
            return g.B(function(y) {
                switch(y.g){
                    case 1:
                        b = a.g;
                        c = N(b);
                        d = c.j;
                        if (!d) {
                            y.g = 2;
                            break;
                        }
                        h = d.g;
                        if (h !== E.MediaType.TEXT_HTML && h !== E.MediaType.APPLICATION_XHTML && h !== E.MediaType.APPLICATION_HTML) {
                            y.g = 2;
                            break;
                        }
                        y.i = 4;
                        k = d.getContentUrl();
                        return l(y, a.j.fetch(k), 6);
                    case 6:
                        return m = y.h, l(y, m.asText(), 7);
                    case 7:
                        p = y.h;
                        B = new I.XhtmlParser(p, k.pathname, h === E.MediaType.TEXT_HTML || h === E.MediaType.APPLICATION_HTML);
                        w = B.getDocument();
                        if (!w) throw new P("INVALID_NAV_DOCUMENT", 'path="' + k.pathname + '"');
                        e = new O(w, "nav", k);
                        y.g = 2;
                        y.i = 0;
                        break;
                    case 4:
                        x = n(y), z.Logger.logWarning(x);
                    case 2:
                        if (e) {
                            y.g = 8;
                            break;
                        }
                        A = b.getSpine().h.getAttribute("toc");
                        if (!A) {
                            y.g = 8;
                            break;
                        }
                        t = M(c, A);
                        if (!t) {
                            y.g = 8;
                            break;
                        }
                        y.i = 11;
                        v = t.getContentUrl();
                        return l(y, a.j.fetch(v), 13);
                    case 13:
                        return u = y.h, l(y, u.asText(), 14);
                    case 14:
                        q = y.h;
                        C = new I.DomParser;
                        D = u.getMetadata();
                        Aa = C.parseXmlString(q, null != (J = D.pathRelativeToBaseUrl) ? J : D.url);
                        e = new O(Aa, "ncx", v);
                        y.g = 8;
                        y.i = 0;
                        break;
                    case 11:
                        Ba = n(y), z.Logger.logWarning(Ba);
                    case 8:
                        if (!e) throw new P("INVALID_OR_MISSING_NAV_OR_NCX_DOCUMENT");
                        return y.return(e);
                }
            });
        };
        f.getContentDocumentByUrl = function(a) {
            "string" === typeof a && (a = H.URLUtils.normalizePathnameEncoding(new URL(a, this.getEpubResourceProvider().getBaseUrl() || void 0)));
            var b = pa(N(this.g), a, [
                E.MediaType.APPLICATION_XHTML,
                E.MediaType.IMAGE_SVG,
                E.MediaType.TEXT_HTML,
                E.MediaType.APPLICATION_HTML
            ]);
            a = null;
            if (b && (a = this.getSpine().find(function(d) {
                return d.getOpfManifestItemElement() === b.i;
            }) || null, !a)) {
                var c = H.URLUtils.getOriginAndPath(b.getContentUrl());
                a = this.m.get(c);
                a || (a = new ka(this, this.g, b, null, -1), this.m.set(c, a));
            }
            return a;
        };
        f.getCoverImageResourceUrl = function() {
            var a = N(this.g).h;
            if (!a) {
                var b = va(this.g.getMetadata(), null, "cover");
                b && (a = M(N(this.g), b.content.value));
            }
            return a ? a.getContentUrl() : null;
        };
        f.getDefaultLayout = function() {
            var a = S(this, "layout"), b = this.i && this.i.isFixedLayout() ? G.ContentDocumentLayout.PRE_PAGINATED : G.ContentDocumentLayout.REFLOWABLE;
            return L(a, b, {
                "pre-paginated": G.ContentDocumentLayout.PRE_PAGINATED
            });
        };
        f.getEpubResourceProvider = function() {
            return this.j;
        };
        f.getFormatExtensions = function() {
            return this.ia;
        };
        f.getHashSignature = function() {
            return this.U;
        };
        f.getMetadata = function() {
            return this.A;
        };
        f.getOpfDocument = function() {
            return this.g.getOpfDocument();
        };
        f.getOpfDocumentUrl = function() {
            return this.g.i;
        };
        f.getPageProgressionDirection = function() {
            var a = this.g.getSpine().getPageProgressionDirection();
            return L(a, G.PageProgressionDirection.AUTO, {
                ltr: G.PageProgressionDirection.LTR,
                rtl: G.PageProgressionDirection.RTL
            });
        };
        f.getPreferredFlowMode = function() {
            var a = S(this, "flow");
            return L(a, G.ContentDocumentFlowMode.AUTO, {
                paginated: G.ContentDocumentFlowMode.PAGINATED,
                "scrolled-continuous": G.ContentDocumentFlowMode.SCROLLED_CONTINUOUS,
                "scrolled-doc": G.ContentDocumentFlowMode.SCROLLED_DOC
            });
        };
        f.getPreferredOrientation = function() {
            var a = S(this, "orientation"), b = this.i && this.i.getOrientationLock() || G.PublicationOrientation.AUTO;
            return L(a, b, {
                landscape: G.PublicationOrientation.LANDSCAPE,
                portrait: G.PublicationOrientation.PORTRAIT
            });
        };
        f.getPreferredSyntheticSpreadBehavior = function() {
            var a = S(this, "spread");
            return L(a, G.SyntheticSpreadBehavior.AUTO, {
                both: G.SyntheticSpreadBehavior.BOTH,
                landscape: G.SyntheticSpreadBehavior.LANDSCAPE,
                none: G.SyntheticSpreadBehavior.NONE,
                portrait: G.SyntheticSpreadBehavior.BOTH
            });
        };
        f.getSpine = function() {
            if (!this.h) {
                this.h = [];
                for(var a = N(this.g), b = this.g.getSpine().g, c = 0; c < b.length; c++){
                    var d = b[c];
                    try {
                        var e = M(a, d.h, [
                            E.MediaType.APPLICATION_XHTML,
                            E.MediaType.IMAGE_SVG,
                            E.MediaType.TEXT_HTML,
                            E.MediaType.APPLICATION_HTML
                        ]);
                        e && this.h.push(new ka(this, this.g, e, d, this.h.length));
                    } catch (h) {
                        z.Logger.logError(h);
                    }
                }
            }
            return this.h.slice();
        };
        f.getType = function() {
            return G.PublicationType.EPUB;
        };
        f.isDestroyed = function() {
            return this.l;
        };
        f.toJSON = function() {
            var a;
            return {
                coverImageUrl: (null == (a = this.getCoverImageResourceUrl()) ? void 0 : a.toString()) || null,
                defaultLayout: this.getDefaultLayout(),
                hashSignature: this.U,
                metadata: this.A.toJSON(),
                pageProgressionDirection: this.getPageProgressionDirection(),
                preferredFlowMode: this.getPreferredFlowMode(),
                preferredOrientation: this.getPreferredOrientation(),
                preferredSyntheticSpreadBehavior: this.getPreferredSyntheticSpreadBehavior(),
                spine: this.getSpine().map(function(b) {
                    return b.toJSON();
                }),
                type: G.PublicationType.EPUB
            };
        };
        function S(a, b) {
            return (a = va(a.g.getMetadata(), z.XmlNamespace.EPUB_RENDITION, b)) ? a.content.value : null;
        }
        function T(a) {
            this.h = a;
            this.g = null;
        }
        T.prototype.decrypt = function(a) {
            if (!this.g) {
                var b = this.h.getDefaultPublication();
                if (!b) throw new P("IDPF_OBFUSCATION_DECRYPTION_FAILED", "No default publication found");
                b = b.getMetadata().getUniqueIdentifier();
                if (!b) throw new P("IDPF_OBFUSCATION_DECRYPTION_FAILED", "Unique identifier missing");
                var c = new fa.Sha1;
                c.append(b.content.value.replace(/[\x20\x09\x0d\x0a]/g, ""));
                this.g = c.digestToUint8Array();
            }
            b = this.g;
            c = new Uint8Array(a.length);
            for(var d = 0, e = 0; 1040 > e && e < a.length;)20 === d && (d = 0), c[e] = a[e] ^ b[d], e++, d++;
            e < a.length && c.set(a.subarray(1040), 1040);
            return Promise.resolve(c);
        };
        T.prototype.getName = function() {
            return "http://www.idpf.org/2008/embedding";
        };
        function za(a, b, c, d) {
            this.j = a;
            this.l = c;
            this.i = d;
            this.h = (a = d.getAttribute("properties")) ? a.split(/\s+/) : [];
            this.m = d.getAttribute("media-overlay");
            this.g = b.toLowerCase();
        }
        za.prototype.getContentUrl = function() {
            return this.l;
        };
        function Ca(a, b) {
            this.h = null;
            this.i = new Map;
            this.g = [];
            this.j = null;
            this.l = new Map;
            this.m = new Map;
            a = a.children;
            for(var c = 0, d = a.length; c < d; c++){
                var e = a[c];
                if (e && e.namespaceURI === z.XmlNamespace.OPF && "item" === e.localName) {
                    var h = e.getAttribute("id"), k = e.getAttribute("href"), m = e.getAttribute("media-type");
                    if (K(h)) {
                        if (K(k)) {
                            if (K(m)) {
                                var p = void 0;
                                try {
                                    p = H.URLUtils.normalizePathnameEncoding(new URL(k, b));
                                } catch (B) {
                                    z.Logger.logError(new P("INVALID_MANIFEST_ITEM_URL", k + ": " + String(B)));
                                    continue;
                                }
                                e = new za(h, m, p, e);
                                -1 !== e.h.indexOf("nav") && (this.j = e);
                                -1 !== e.h.indexOf("cover-image") && (this.h = e);
                                this.g.push(e);
                                this.i.set(h, e);
                                h = H.URLUtils.getOriginAndPath(p);
                                this.l.set(h, e);
                                this.m.set(h.toLowerCase(), e);
                            } else z.Logger.logError(Da("media-type", c));
                        } else z.Logger.logError(Da("href", c));
                    } else z.Logger.logError(Da("id", c));
                }
            }
        }
        function Ea(a, b) {
            b = M(a, b);
            var c = null;
            if (b && b.i.getAttribute("fallback")) for(var d = []; b;){
                d.push(b.j);
                var e = b.i.getAttribute("fallback");
                e && -1 === d.indexOf(e) ? b = M(a, e) : b = null;
                b && (c || (c = []), c.push(b));
            }
            return c;
        }
        function M(a, b, c) {
            return (b = a.i.get(b) || null) && c ? Fa(a, b, c) : b;
        }
        function pa(a, b, c) {
            b = H.URLUtils.getOriginAndPath(b);
            return (b = a.l.get(b) || a.m.get(b.toLowerCase()) || null) && c ? Fa(a, b, c) : b;
        }
        function Fa(a, b, c) {
            var d = [];
            c.forEach(function(e) {
                e.endsWith("/*") ? d.push.apply(d, g.W(ha.MediaTypeDetector.getMediaTypesFromCategory(e))) : d.push(e);
            });
            c = null;
            -1 !== d.indexOf(b.g) ? c = b : (a = Ea(a, b.j)) && (c = a.find(function(e) {
                return -1 !== d.indexOf(e.g);
            }) || c);
            return c || b;
        }
        function Da(a, b) {
            return new P("OPF_MANIFEST_ITEM_ATTRIBUTE_NOT_FOUND", 'attrName="' + a + '" in /manifest/item[' + b + "]");
        }
        function Ga() {
            this.i = 0;
            this.h = {
                G: null,
                o: null,
                v: null
            };
            this.g = {
                G: null,
                o: null,
                v: this.h
            };
            this.h.o = this.g;
        }
        f = Ga.prototype;
        f.every = function(a) {
            for(var b = this.h.o, c = !0; b !== this.g && c;){
                var d = b.o;
                c = a(b);
                b = null === b.o ? d : b.o;
            }
            return c;
        };
        f.find = function(a) {
            for(var b = this.h.o, c = null; b !== this.g && null === c;){
                var d = b.o;
                a(b) && (c = b);
                b = null === b.o ? d : b.o;
            }
            return c;
        };
        f.forEach = function(a) {
            for(var b = this.h.o; b !== this.g;){
                var c = b.o;
                a(b);
                b = null === b.o ? c : b.o;
            }
        };
        f.push = function(a) {
            a = {
                G: a,
                o: this.g,
                v: this.g.v
            };
            a.v.o = a;
            this.g.v = a;
            this.i++;
            return a;
        };
        f.size = function() {
            return this.i;
        };
        function Ha(a, b) {
            if (b.v && b.o) {
                var c = b.v, d = b.o;
                c.o = d;
                d.v = c;
                b.o = null;
                b.v = null;
                a.i--;
            }
        }
        function Ia(a, b) {
            this.j = !0;
            this.i = this.g = a;
            this.h = b || null;
        }
        function Ja(a, b) {
            if (null !== a.g) {
                var c = Ka(a, b);
                for(a.j = !1; null !== a.g && a.h && !a.h(a.g);)c += Ka(a, b);
            }
        }
        Ia.prototype.next = function(a) {
            if (this.j && (!this.h || this.h(this.g))) return this.j = !1, this.g;
            Ja(this, a);
            return this.g;
        };
        function Ka(a, b) {
            var c = a.g, d = 0;
            if (c.firstChild && ("function" === typeof b ? b(c) : b)) a.g = c.firstChild, d = 1;
            else if (c !== a.i && c.nextSibling) a.g = c.nextSibling;
            else {
                for(; c !== a.i && !c.nextSibling;)c = c.parentNode, d--;
                c === a.i ? a.g = null : a.g = c.nextSibling;
            }
            return d;
        }
        function La(a, b, c, d) {
            var e = this;
            this.u = c;
            this.m = d;
            this.g = [];
            this.h = new Map;
            this.i = [];
            this.j = [];
            this.l = [];
            a = new Ia(a, function(w) {
                return 1 === w.nodeType;
            });
            Ja(a, !0);
            for(var h = new Ga; a.g;){
                c = a.g;
                if (c.namespaceURI === z.XmlNamespace.OPF) {
                    if ("meta" === c.localName) {
                        var k = c.getAttribute("name"), m = c.getAttribute("content"), p = c.getAttribute("refines");
                        d = c.getAttribute("property");
                        k && m ? (c = U(this, {
                            name: k,
                            namespace: null
                        }, null, m, c), this.g.push(c)) : p ? h.push(c) : d ? (k = c.getAttribute("scheme"), d = V(this, d, c, null, null), k = k ? V(this, k, c, null, null) : null, (m = (c.textContent || "").trim()) ? (c = U(this, d, k, m, c), this.g.push(c)) : z.Logger.logWarning(new P("INVALID_OPF_METADATA", "Expected meta element to contain text content."))) : z.Logger.logWarning(new P("INVALID_OPF_METADATA", "Invalid metadata element"));
                    }
                } else if (c.namespaceURI === z.XmlNamespace.DC) {
                    if (d = (c.textContent || "").trim()) {
                        d = U(this, {
                            name: c.localName,
                            namespace: z.XmlNamespace.DC
                        }, null, d, c);
                        k = this.g.length;
                        this.g.push(d);
                        switch(c.localName){
                            case "language":
                                this.j.push(k);
                                break;
                            case "title":
                                this.l.push(k);
                                break;
                            case "identifier":
                                this.i.push(k);
                        }
                        if (2 === b) for(c = c.attributes, k = 0; k < c.length; k++)m = c[k], m.namespaceURI === z.XmlNamespace.OPF && K(m.value) && (m = U(this, {
                            name: m.localName,
                            namespace: z.XmlNamespace.OPF
                        }, null, m.value.trim(), null), d.refinedBy.push(m));
                    } else z.Logger.logWarning(new P("INVALID_OPF_METADATA", "Found empty dc:" + c.localName));
                }
                Ja(a, !0);
            }
            for(var B = !0; 0 < h.size() && B;)B = !1, h.forEach(function(w) {
                var x = w.G, A = x.getAttribute("refines"), t = x.getAttribute("property"), v = (x.textContent || "").trim();
                if (t && A && v && "#" === A[0]) {
                    if (A = e.h.get(A.slice(1))) {
                        t = V(e, t, x, z.XmlNamespace.EPUB_OPF_META_VOCABULARY, Ma);
                        var u = x.getAttribute("scheme");
                        u = u ? V(e, u, x, null, null) : null;
                        x = U(e, t, u, v, x);
                        A.refinedBy.push(x);
                        B = !0;
                        Ha(h, w);
                    }
                } else z.Logger.logWarning(new P("INVALID_OPF_METADATA", "Invalid EPUB 3 subexpression meta element")), Ha(h, w);
            });
        }
        La.prototype.getAll = function() {
            return this.g;
        };
        function va(a, b, c) {
            return a.g.find(function(d) {
                return d.property.namespace === b && d.property.name === c;
            }) || null;
        }
        La.prototype.getUniqueIdentifier = function() {
            return this.h.get(this.u) || null;
        };
        function U(a, b, c, d, e) {
            var h = null, k = null;
            e && (k = e.getAttribute("dir"), "ltr" === k ? h = z.TextDirection.LTR : "rtl" === k && (h = z.TextDirection.RTL), k = e.getAttributeNS(z.XmlNamespace.XML, "lang"));
            b = {
                content: {
                    dir: h,
                    lang: k,
                    value: d
                },
                contentScheme: c,
                property: b,
                refinedBy: []
            };
            e && e.id && a.h.set(e.id, b);
            return b;
        }
        function V(a, b, c, d, e) {
            var h = b.split(":", 2);
            2 !== h.length ? (c = null, d && e ? e.has(b) ? c = d : z.Logger.logWarning(new P("INVALID_OPF_METADATA", 'Found unknown property "' + b + '". It is not defined by ' + d)) : z.Logger.logWarning(new P("INVALID_OPF_METADATA", 'Found unknown property "' + b + ". Expected a namespace prefix.")), b = {
                name: b,
                namespace: c
            }) : (d = h[0], (a = c.lookupNamespaceURI(d) || a.m.get(d) || Na.get(d) || null) ? b = {
                name: h[1],
                namespace: a
            } : (z.Logger.logWarning(new P("INVALID_OPF_METADATA", 'Found unknown property "' + b + '" in element <' + c.localName + ">")), b = {
                name: b,
                namespace: null
            }));
            return b;
        }
        var Na = new Map([
            [
                "a11y",
                z.XmlNamespace.EPUB_A11Y
            ],
            [
                "dcterms",
                z.XmlNamespace.DCTERMS
            ],
            [
                "marc",
                z.XmlNamespace.MARC
            ],
            [
                "media",
                z.XmlNamespace.MEDIA_OVERLAYS
            ],
            [
                "opf",
                z.XmlNamespace.OPF
            ],
            [
                "onix",
                z.XmlNamespace.ONIX
            ],
            [
                "rendition",
                z.XmlNamespace.EPUB_RENDITION
            ],
            [
                "schema",
                z.XmlNamespace.SCHEMA_ORG
            ],
            [
                "xsd",
                z.XmlNamespace.XSD
            ]
        ]), Ma = new Set("alternate-script authority belongs-to-collection collection-type display-seq file-as group-position identifier-type meta-auth role source-of term title-type".split(" "));
        function Oa(a, b) {
            this.h = a;
            this.i = b;
            this.j = "no" !== b.getAttribute("linear");
            this.g = (a = b.getAttribute("properties")) ? a.split(/\s+/) : [];
        }
        function Pa(a) {
            this.h = a;
            this.g = [];
            a = a.children;
            for(var b = 0, c = a.length; b < c; b++){
                var d = a[b];
                if (d && d.namespaceURI === z.XmlNamespace.OPF && "itemref" === d.localName) {
                    var e = d.getAttribute("idref");
                    if (K(e)) this.g.push(new Oa(e, d));
                    else {
                        d = z.Logger;
                        e = d.logError;
                        var h = new P("OPF_SPINE_ITEMREF_ATTRIBUTE_NOT_FOUND", 'attrName="idref" in /spine/itemref[' + b + "]");
                        e.call(d, h);
                    }
                }
            }
        }
        Pa.prototype.getPageProgressionDirection = function() {
            return this.h.getAttribute("page-progression-direction") || "default";
        };
        function W(a, b) {
            this.g = a;
            this.i = b;
            this.spine = this.metadata = this.h = null;
        }
        function N(a) {
            if (!a.h) {
                var b = a.g.querySelector("package > manifest");
                if (!b) throw new P("OPF_ELEMENT_NOT_FOUND", "<manifest>");
                a.h = new Ca(b, a.i);
            }
            return a.h;
        }
        W.prototype.getMetadata = function() {
            if (!this.metadata) {
                var a = this.g.querySelector("package > metadata"), b = this.g.documentElement.getAttribute("unique-identifier"), c = this.g.documentElement.getAttribute("version") || "2";
                c = parseInt(c) || 2;
                if (!a) throw new P("OPF_ELEMENT_NOT_FOUND", "<metadata>");
                if (!b) throw new P("OPF_ATTRIBUTE_UNIQUE_IDENTIFIER_NOT_FOUND");
                var d = this.g.documentElement.getAttribute("prefix"), e = new Map;
                if (d) {
                    for(var h = /(\S+):\s+(\S+)/g, k; null !== (k = h.exec(d));)if (3 === k.length) {
                        var m = k[1];
                        k = k[2];
                        m && k && (H.URLUtils.isValidUrl(k) ? e.set(m, k) : z.Logger.logWarning(new P("INVALID_OPF_METADATA", 'Package attribute "prefix" contains invalid namespace URI: ' + k)));
                    }
                }
                this.metadata = new La(a, c, b, e);
            }
            return this.metadata;
        };
        W.prototype.getOpfDocument = function() {
            return this.g;
        };
        W.prototype.getSpine = function() {
            if (!this.spine) {
                var a = this.g.querySelector("package > spine");
                if (!a) throw new P("OPF_ELEMENT_NOT_FOUND", "<spine>");
                this.spine = new Pa(a);
            }
            return this.spine;
        };
        function Qa(a) {
            this.m = this.h = this.l = this.j = this.i = null;
            switch(a.getAttribute("name")){
                case "iphone":
                    this.g = "IPHONE";
                    break;
                case "ipad":
                    this.g = "IPAD";
                    break;
                default:
                    this.g = "ALL";
            }
            for(a = a.firstElementChild; a;){
                if ("option" === a.localName) switch(a.getAttribute("name")){
                    case "interactive":
                        this.j = "true" === X(a);
                        break;
                    case "fixed-layout":
                        this.i = "true" === X(a);
                        break;
                    case "open-to-spread":
                        this.l = "true" === X(a);
                        break;
                    case "orientation-lock":
                        var b = X(a);
                        "landscape-only" === b ? this.h = G.PublicationOrientation.LANDSCAPE : "portrait-only" === b && (this.h = G.PublicationOrientation.PORTRAIT);
                        break;
                    case "specified-fonts":
                        this.m = "true" === X(a);
                }
                a = a.nextElementSibling;
            }
        }
        f = Qa.prototype;
        f.getOrientationLock = function() {
            return this.h;
        };
        f.getPlatformType = function() {
            return this.g;
        };
        f.hasCustomFonts = function() {
            return this.m;
        };
        f.isFixedLayout = function() {
            return this.i;
        };
        f.isInteractive = function() {
            return this.j;
        };
        f.shouldOpenToSpread = function() {
            return this.l;
        };
        function X(a) {
            return (a = a.firstChild) && 3 === a.nodeType ? a.data.trim() : "";
        }
        function Ra(a) {
            this.g = [];
            a = a.documentElement;
            if ("display_options" === a.localName) for(a = a.firstElementChild; a;)"platform" === a.localName && this.g.push(new Qa(a)), a = a.nextElementSibling;
        }
        Ra.prototype.getOptionsForPlatform = function(a) {
            return this.g.find(function(b) {
                return b.getPlatformType() === a;
            }) || null;
        };
        function Y(a, b, c, d, e) {
            this.g = a;
            this.m = b;
            this.i = c;
            this.A = d;
            this.u = e;
            this.l = this.j = !1;
            this.h = [];
            this.enableBuiltInEncryptionMethods();
        }
        f = Y.prototype;
        f.acceptsUrl = function(a) {
            return this.g.acceptsUrl(a);
        };
        f.destroy = function() {
            if (!this.l) {
                this.l = !0;
                for(var a = 0; a < this.h.length; a++)this.h[a].destroy();
                this.h = [];
                this.u && this.u();
            }
        };
        f.disableBuiltInEncryptionMethods = function() {
            this.j && (this.i.removeEncryptionMethod("http://www.idpf.org/2008/embedding"), this.j = !1);
        };
        f.enableBuiltInEncryptionMethods = function() {
            this.j || (this.i.addEncryptionMethod(new T(this)), this.j = !0);
        };
        f.fetch = function(a, b) {
            var c = this;
            return this.g.fetch(a, b).then(function(d) {
                return c.i.getDecryptedResourceResponse(d);
            });
        };
        f.fetchMetadata = function(a, b) {
            var c = this;
            return this.g.fetchMetadata(a, b).then(function(d) {
                return c.i.getDecryptedResourceMetadata(d);
            });
        };
        f.getBaseUrl = function() {
            var a = this.g.getBaseUrl();
            return null !== a ? H.URLUtils.cloneUrl(a) : null;
        };
        f.getDefaultPublication = function() {
            return this.h[0] || null;
        };
        f.getDrmManager = function() {
            return this.i;
        };
        f.getMimeType = function() {
            return this.m;
        };
        f.getPublications = function() {
            return this.h;
        };
        f.getResourceManifest = function() {
            return this.g.getResourceManifest();
        };
        f.isDestroyed = function() {
            return this.l;
        };
        f.isUrlSupportedByBrowser = function(a, b) {
            return this.g.isUrlSupportedByBrowser(a, b);
        };
        f.load = function() {
            var a = this, b, c, d, e, h, k, m, p, B, w, x;
            return g.B(function(A) {
                if (1 == A.g) return a.m !== E.MediaType.APPLICATION_EPUB_ZIP && z.Logger.logWarning("Invalid EPUB container mimetype: " + a.m), b = a.fetch("META-INF/container.xml").then(function(t) {
                    var v, u, q, C;
                    return g.B(function(D) {
                        if (1 == D.g) return l(D, t.asText(), 2);
                        v = D.h;
                        u = new I.DomParser;
                        q = t.getMetadata();
                        return D.return(u.parseXmlString(v, null != (C = q.pathRelativeToBaseUrl) ? C : q.url));
                    });
                }), c = a.fetch("META-INF/com.apple.ibooks.display-options.xml").then(function(t) {
                    var v, u, q, C, D;
                    return g.B(function(J) {
                        if (1 == J.g) return l(J, t.asText(), 2);
                        v = J.h;
                        u = new I.DomParser;
                        q = t.getMetadata();
                        D = u.parseXmlString(v, null != (C = q.pathRelativeToBaseUrl) ? C : q.url);
                        return J.return(new Ra(D));
                    });
                }).catch(function(t) {
                    z.ColibrioError.isColibrioError(t) && t.errorType === E.IoErrorType.RESOURCE_NOT_FOUND || z.Logger.logWarning(t);
                    return null;
                }), d = g, e = d.D, l(A, Promise.all([
                    b,
                    c
                ]), 2);
                h = e.call(d, A.h);
                k = h.next().value;
                m = h.next().value;
                p = k;
                B = m;
                w = Sa(p);
                x = w.map(function(t) {
                    return a.fetch(t).then(function(v) {
                        return v.asText().then(function(u) {
                            var q = v.getMetadata(), C;
                            u = (new I.DomParser).parseXmlString(u, null != (C = q.pathRelativeToBaseUrl) ? C : q.url);
                            q = new W(u, new URL(v.getMetadata().url));
                            C = new fa.Sha1;
                            u = F.ZipResourceProvider.createBaseUrl(a.A);
                            C.append(u.toString());
                            u = new URL(t, u);
                            C.append(u.toString());
                            C = C.digestToHex();
                            return new ya(a, C, q, B);
                        });
                    }).catch(function(v) {
                        z.ColibrioError.isColibrioAbortedError(v) || z.Logger.logError(v);
                        return null;
                    });
                });
                return A.return(Promise.all(x).then(function(t) {
                    a.h = t.filter(function(v) {
                        return null !== v;
                    });
                }));
            });
        };
        function Sa(a) {
            a = a.querySelectorAll("rootfile");
            for(var b = [], c = 0; c < a.length; c++){
                var d = a[c], e = d.getAttribute("full-path");
                d = d.getAttribute("media-type");
                e && d === E.MediaType.APPLICATION_OPF_PACKAGE && b.push(e);
            }
            return b;
        }
        Y.createFromArrayBuffer = Ta;
        Y.createFromBackingResourceProvider = Ua;
        Y.createFromBase64 = Va;
        Y.createFromBlob = Wa;
        Y.createFromRandomAccessDataSource = Xa;
        function Ta(a, b, c) {
            return F.ZipResourceProvider.createFromArrayBuffer(a, b).then(function(d) {
                return Z(d, c);
            });
        }
        function Va(a, b) {
            return F.ZipResourceProvider.createFromBase64(a).then(function(c) {
                return Z(c, b);
            });
        }
        function Wa(a, b) {
            return F.ZipResourceProvider.createFromBlob(a).then(function(c) {
                return Z(c, b);
            });
        }
        function Xa(a, b, c) {
            return F.ZipResourceProvider.createFromRandomAccessDataSource(a, c).then(function(d) {
                return Z(d, b);
            });
        }
        function Ua(a, b, c, d) {
            var e, h, k, m, p, B, w, x, A, t, v, u;
            return g.B(function(q) {
                switch(q.g){
                    case 1:
                        e = a.getBaseUrl();
                        if (!e) throw new P("BASE_URL_MISSING");
                        q.i = 2;
                        return l(q, a.fetch("mimetype").then(function(C) {
                            return C.asText();
                        }), 4);
                    case 4:
                        h = q.h;
                        q.g = 3;
                        q.i = 0;
                        break;
                    case 2:
                        k = n(q), z.Logger.logWarning(k), h = E.MediaType.APPLICATION_EPUB_ZIP;
                    case 3:
                        return m = null, q.i = 5, l(q, a.fetch("META-INF/encryption.xml"), 7);
                    case 7:
                        return p = q.h, l(q, p.asText(), 8);
                    case 8:
                        B = q.h;
                        w = new I.DomParser;
                        x = p.getMetadata();
                        m = w.parseXmlString(B, null != (A = x.pathRelativeToBaseUrl) ? A : x.url);
                        q.g = 6;
                        q.i = 0;
                        break;
                    case 5:
                        t = n(q), z.ColibrioError.isColibrioError(t) && t.errorType === E.IoErrorType.RESOURCE_NOT_FOUND || z.Logger.logWarning(t);
                    case 6:
                        return c || (c = new ea.DrmManager(null)), m && (v = new ea.XmlEncryptionInfo(m, e), c.setXmlEncryptionInfo(v)), u = new Y(a, h, c, b, d || null), q.return(u.load().then(function() {
                            return u;
                        }));
                }
            });
        }
        function Z(a, b) {
            return Ua(a, a.getCentralDirectorySha1Signature(), b, function() {
                a.destroy();
            });
        }
        api = {
            drm: {
                IdpfObfuscationEncryptionMethod: T
            },
            EpubAppleBooksOptionsPlatformType: {
                ALL: "ALL",
                IPHONE: "IPHONE",
                IPAD: "IPAD"
            },
            EpubOcfResourceProvider: Y,
            EpubPublicationError: P,
            EpubPublicationErrorType: {
                BASE_URL_MISSING: "BASE_URL_MISSING",
                IDPF_OBFUSCATION_DECRYPTION_FAILED: "IDPF_OBFUSCATION_DECRYPTION_FAILED",
                INVALID_OR_MISSING_NAV_OR_NCX_DOCUMENT: "INVALID_OR_MISSING_NAV_OR_NCX_DOCUMENT",
                INVALID_NAV_DOCUMENT: "INVALID_NAV_DOCUMENT",
                INVALID_MANIFEST_ITEM_URL: "INVALID_MANIFEST_ITEM_URL",
                INVALID_MEDIA_OVERLAY: "INVALID_MEDIA_OVERLAY",
                INVALID_OPF_METADATA: "INVALID_OPF_METADATA",
                OPF_ELEMENT_NOT_FOUND: "OPF_ELEMENT_NOT_FOUND",
                OPF_MANIFEST_ITEM_ATTRIBUTE_NOT_FOUND: "OPF_MANIFEST_ITEM_ATTRIBUTE_NOT_FOUND",
                OPF_SPINE_ITEMREF_ATTRIBUTE_NOT_FOUND: "OPF_SPINE_ITEMREF_ATTRIBUTE_NOT_FOUND",
                OPF_ATTRIBUTE_UNIQUE_IDENTIFIER_NOT_FOUND: "OPF_ATTRIBUTE_UNIQUE_IDENTIFIER_NOT_FOUND"
            }
        };
        var Ya = new ArrayBuffer(8);
        new DataView(Ya);
        new Uint8Array(Ya);
    }).call(__self);
    return api;
});

});
parcelRegister("k5V4T", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";



(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("a75zb")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_url) {
    var api = {};
    (function() {
        var g;
        function k(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var l = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function n(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var p = n(this);
        function q(a, b) {
            if (b) a: {
                var c = p;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var f = a[d];
                    if (!(f in c)) break a;
                    c = c[f];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && l(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        q("Symbol", function(a) {
            function b(e) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (e || "") + "_" + f++, e);
            }
            function c(e, h) {
                this.g = e;
                l(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: h
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", f = 0;
            return b;
        });
        q("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = p[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && l(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return r(k(this));
                    }
                });
            }
            return a;
        });
        function r(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        var t = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, u;
        if ("function" == typeof Object.setPrototypeOf) u = Object.setPrototypeOf;
        else {
            var v;
            a: {
                var w = {
                    a: !0
                }, x = {};
                try {
                    x.__proto__ = w;
                    v = x.a;
                    break a;
                } catch (a) {}
                v = !1;
            }
            u = v ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var y = u;
        function z() {
            this.j = !1;
            this.h = null;
            this.l = void 0;
            this.g = 1;
            this.o = 0;
            this.i = null;
        }
        function A(a) {
            if (a.j) throw new TypeError("Generator is already running");
            a.j = !0;
        }
        z.prototype.m = function(a) {
            this.l = a;
        };
        function B(a, b) {
            a.i = {
                s: b,
                u: !0
            };
            a.g = a.o;
        }
        z.prototype.return = function(a) {
            this.i = {
                return: a
            };
            this.g = this.o;
        };
        function D(a) {
            this.g = new z;
            this.h = a;
        }
        function E(a, b) {
            A(a.g);
            var c = a.g.h;
            if (c) return F(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return G(a);
        }
        function F(a, b, c, d) {
            try {
                var f = b.call(a.g.h, c);
                if (!(f instanceof Object)) throw new TypeError("Iterator result " + f + " is not an object");
                if (!f.done) return a.g.j = !1, f;
                var e = f.value;
            } catch (h) {
                return a.g.h = null, B(a.g, h), G(a);
            }
            a.g.h = null;
            d.call(a.g, e);
            return G(a);
        }
        function G(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.j = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.l = void 0, B(a.g, c);
            }
            a.g.j = !1;
            if (a.g.i) {
                b = a.g.i;
                a.g.i = null;
                if (b.u) throw b.s;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function H(a) {
            this.next = function(b) {
                A(a.g);
                a.g.h ? b = F(a, a.g.h.next, b, a.g.m) : (a.g.m(b), b = G(a));
                return b;
            };
            this.throw = function(b) {
                A(a.g);
                a.g.h ? b = F(a, a.g.h["throw"], b, a.g.m) : (B(a.g, b), b = G(a));
                return b;
            };
            this.return = function(b) {
                return E(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function I(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, f) {
                function e(h) {
                    h.done ? d(h.value) : Promise.resolve(h.value).then(b, c).then(e, f);
                }
                e(a.next());
            });
        }
        var J = __dep__colibrio_core_base;
        var aa = __dep__colibrio_core_io_base;
        var ba = __dep__colibrio_core_url;
        function K(a, b) {
            a: {
                a = a.attributes;
                for(var c = 0; c < a.length; c++){
                    var d = a.item(c);
                    if (d && d.name === b) {
                        b = d.value;
                        break a;
                    }
                }
                b = void 0;
            }
            if (!b) return null;
            b = parseInt(b);
            return "number" !== typeof b || isNaN(b) ? null : b;
        }
        var L = new Uint16Array(1);
        L[0] = 4660;
        new Uint8Array(L.buffer);
        function M(a, b) {
            return J.ColibrioError.call(this, "colibrio.core.drm", a, b) || this;
        }
        var N = J.ColibrioError;
        M.prototype = t(N.prototype);
        M.prototype.constructor = M;
        if (y) y(M, N);
        else for(var O in N)if ("prototype" != O) {
            if (Object.defineProperties) {
                var P = Object.getOwnPropertyDescriptor(N, O);
                P && Object.defineProperty(M, O, P);
            } else M[O] = N[O];
        }
        function Q() {
            this.h = this.g = void 0;
            this.i = new TextDecoder("utf-8");
        }
        var R;
        Q.prototype.decode = function(a) {
            return 2 <= a.length && 254 === a[0] && 255 === a[1] && (void 0 === this.g && (this.g = T("utf-16be")), this.g) ? this.g.decode(a) : 2 <= a.length && 255 === a[0] && 254 === a[1] && (void 0 === this.h && (this.h = T("utf-16le")), this.h) ? this.h.decode(a) : this.i.decode(a);
        };
        function T(a) {
            try {
                return new TextDecoder(a);
            } catch (b) {
                return console.error(b), null;
            }
        }
        function U(a, b, c, d) {
            this.l = a;
            this.g = b;
            this.j = c;
            this.m = d;
            this.i = !1;
            this.h = null;
        }
        g = U.prototype;
        g.abort = function() {
            this.i = !0;
            this.g.abort();
        };
        g.asText = function() {
            return V(this).then(function(a) {
                R || (R = new Q);
                return R.decode(a);
            });
        };
        g.asUint8Array = function() {
            return V(this);
        };
        g.getMetadata = function() {
            return this.l;
        };
        g.getReadableStream = function() {
            var a = this;
            this.h || (this.h = new ReadableStream({
                cancel: function() {
                    a.g.abort();
                },
                start: function(b) {
                    var c;
                    return I(new H(new D(function(d) {
                        if (1 == d.g) {
                            if (a.i) {
                                b.error(new M(J.ColibrioErrorType.ABORTED));
                                d.g = 0;
                                return;
                            }
                            var f = V(a);
                            d.g = 3;
                            return {
                                value: f
                            };
                        }
                        c = d.l;
                        b.enqueue(c);
                        b.close();
                        d.g = 0;
                    })));
                }
            }));
            return this.h;
        };
        function V(a) {
            var b;
            return I(new H(new D(function(c) {
                if (1 == c.g) {
                    var d = a.g.asUint8Array();
                    c.g = 2;
                    return {
                        value: d
                    };
                }
                b = c.l;
                return c.return(a.j.decrypt(b, a.g.getMetadata(), a.m));
            })));
        }
        function W(a) {
            this.i = a;
            this.h = new Map;
            this.g = null;
        }
        g = W.prototype;
        g.addEncryptionMethod = function(a) {
            this.h.set(a.getName(), a);
        };
        g.getDecryptedResourceMetadata = function(a) {
            return this.g ? this.g.getEncryptedDataEntryByUri(a.url) ? X(a) : a : a;
        };
        g.getDecryptedResourceResponse = function(a) {
            if (!this.g) return a;
            var b = this.g.getEncryptedDataEntryByUri(a.getMetadata().url);
            if (b && b.algorithmName) {
                var c = this.h.get(b.algorithmName);
                if (c) {
                    var d = X(a.getMetadata());
                    a = new U(d, a, c, b);
                } else a = this.i ? this.i(a, b) : new aa.ErrorResourceResponse(a.getMetadata(), new M("ENCRYPTION_ALGORITHM_NOT_SUPPORTED", "Algorithm: " + b.algorithmName));
            }
            return a;
        };
        g.getEncryptionMethod = function(a) {
            return this.h.get(a);
        };
        g.getEncryptionMethods = function() {
            return Array.from(this.h.values());
        };
        g.getXmlEncryptionInfo = function() {
            return this.g;
        };
        g.isEncrypted = function(a) {
            var b;
            this.g && (b = this.g.getEncryptedDataEntryByUri(a.toString()));
            return void 0 != b;
        };
        g.removeEncryptionMethod = function(a) {
            this.h.delete(a);
        };
        g.setXmlEncryptionInfo = function(a) {
            this.g = a;
        };
        function X(a) {
            a = Object.assign({}, a);
            a.acceptsRanges = !1;
            return a;
        }
        function Y(a, b) {
            this.i = b;
            this.g = new Map;
            this.h = [];
            for(a = a.documentElement.firstChild; a;){
                if (a && 1 === a.nodeType && a.namespaceURI === J.XmlNamespace.XML_ENCRYPTION && "EncryptedData" === a.localName) {
                    b = a;
                    for(var c = b.firstChild, d = null, f = null, e = null, h = null; c;){
                        if (c && 1 === c.nodeType) {
                            if (c.namespaceURI === J.XmlNamespace.XML_ENCRYPTION) {
                                if ("EncryptionMethod" === c.localName) d = c.getAttribute("Algorithm");
                                else if ("CipherData" === c.localName) {
                                    var m = c.firstElementChild;
                                    m && "CipherReference" === m.localName && (f = m.getAttribute("URI"));
                                } else if ("EncryptionProperties" === c.localName) b: {
                                    for(e = c.firstChild; e;){
                                        if (e && 1 === e.nodeType && e.namespaceURI === J.XmlNamespace.XML_ENCRYPTION && "EncryptionProperty" === e.localName && (m = e.getElementsByTagNameNS(J.XmlNamespace.EPUB_ENCRYPTION_COMPRESSION, "Compression"), 0 < m.length)) {
                                            e = m[0];
                                            e = {
                                                compressionMethod: K(e, "Method"),
                                                originalLength: K(e, "OriginalLength")
                                            };
                                            break b;
                                        }
                                        e = e.nextSibling;
                                    }
                                    e = null;
                                }
                            } else if (c.namespaceURI === J.XmlNamespace.XML_SIGNATURES && "KeyInfo" === c.localName) {
                                if (h = c.getElementsByTagNameNS(J.XmlNamespace.XML_SIGNATURES, "RetrievalMethod"), 0 < h.length) {
                                    m = [];
                                    for(var C = 0; C < h.length; C++){
                                        var S = h[C];
                                        m.push({
                                            type: S.getAttribute("Type"),
                                            uri: S.getAttribute("URI")
                                        });
                                    }
                                    h = {
                                        retrievalMethods: m
                                    };
                                } else h = null;
                            }
                        }
                        c = c.nextSibling;
                    }
                    f && d ? (c = ba.URLUtils.normalizePathnameEncoding(new URL(f, this.i)), b = {
                        algorithmName: d,
                        cipherRefUrl: c.toString(),
                        cipherRefUrlRaw: f,
                        encryptionProperties: e,
                        keyInfo: h,
                        nodeTree: J.NodeDataUtils.createXmlElementNodeData(b, !0)
                    }) : b = null;
                    b && (this.h.push(b), this.g.set(b.cipherRefUrl, b));
                }
                a = a.nextSibling;
            }
        }
        Y.prototype.getEncryptedDataEntries = function() {
            return this.h.slice();
        };
        Y.prototype.getEncryptedDataEntryByUri = function(a) {
            return this.g.get(a);
        };
        api = {
            DrmError: M,
            DrmErrorType: {
                ENCRYPTION_ALGORITHM_NOT_SUPPORTED: "ENCRYPTION_ALGORITHM_NOT_SUPPORTED"
            },
            DrmManager: W,
            XmlEncryptionInfo: Y
        };
        var Z = new ArrayBuffer(8);
        new DataView(Z);
        new Uint8Array(Z);
    }).call(__self);
    return api;
});

});

parcelRegister("gWxKE", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";


(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base) {
    var api = {};
    (function() {
        var l = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, m;
        if ("function" == typeof Object.setPrototypeOf) m = Object.setPrototypeOf;
        else {
            var p;
            a: {
                var q = {
                    a: !0
                }, r = {};
                try {
                    r.__proto__ = q;
                    p = r.a;
                    break a;
                } catch (a) {}
                p = !1;
            }
            m = p ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var t = m;
        var w = __dep__colibrio_core_base;
        var x = __dep__colibrio_core_io_base;
        var y = new Uint16Array(1);
        y[0] = 4660;
        new Uint8Array(y.buffer);
        function z(a, b, d) {
            a = w.ColibrioError.call(this, "colibrio.core.xml", a, d) || this;
            a.parserErrorDocument = b;
            return a;
        }
        var A = w.ColibrioError;
        z.prototype = l(A.prototype);
        z.prototype.constructor = z;
        if (t) t(z, A);
        else for(var B in A)if ("prototype" != B) {
            if (Object.defineProperties) {
                var C = Object.getOwnPropertyDescriptor(A, B);
                C && Object.defineProperty(z, B, C);
            } else z[B] = A[B];
        }
        function D() {}
        D.prototype.parseHtmlString = function(a, b) {
            a = E().parseFromString(a, x.MediaType.TEXT_HTML);
            G(a, b);
            return a;
        };
        D.prototype.parseXhtmlString = function(a, b) {
            a = E().parseFromString(a, x.MediaType.APPLICATION_XHTML);
            G(a, b);
            return a;
        };
        D.prototype.parseXmlString = function(a, b) {
            a = E().parseFromString(a, x.MediaType.APPLICATION_XML);
            G(a, b);
            return a;
        };
        function G(a, b) {
            H(a.documentElement, b);
            H(a.documentElement.firstElementChild, b);
            a.body && H(a.body.firstElementChild, b);
        }
        function H(a, b) {
            if (a && "parsererror" === a.localName) throw new z("DOM_PARSE_ERROR", a.ownerDocument, '"' + b + '": ' + (a.textContent || ""));
        }
        var I;
        function E() {
            I || (I = new DOMParser);
            return I;
        }
        function J(a) {
            this.h = a;
            this.j = "";
            this.i = this.g = 0;
            this.l = a.length;
        }
        function K(a) {
            for(; 62 !== a.h.charCodeAt(a.g++););
        }
        function L(a, b) {
            var d = a.g;
            for(var e; (e = a.h.charCodeAt(++a.g)) && 9 !== e && 10 !== e && 12 !== e && 32 !== e && 47 !== e && 62 !== e;);
            d = b ? a.h.slice(d, a.g) : "";
            e = !0;
            for(var c = !1; e;){
                var h = a.h.charCodeAt(a.g++);
                if (34 === h || 39 === h) for(var g = a, f = g.h.charCodeAt(g.g++); f !== h;)f = g.h.charCodeAt(g.g++);
                else 47 === h ? (h = a.h.charCodeAt(a.g), 62 === h && (c = !0, e = !1, a.g++)) : 62 === h ? e = !1 : h || (e = !1);
            }
            b && c && !M.has(d.toLowerCase()) && (a.j += a.h.slice(a.i, a.g - 2) + "></" + d + ">", a.i = a.g);
        }
        var M = new Set("area base br col embed hr img input link meta param source track wbr".split(" "));
        function P(a, b, d) {
            this.h = this.g = this.i = null;
            this.j = "";
            var e = new D, c = !1;
            if (!d) {
                if ((d = /^([\s\S]+?)<html/i.exec(a)) && d[1]) {
                    d = d[1];
                    var h = /^<\?xml[\s\S]+?\?>/.exec(d);
                    h && h[0] && (this.j = h[0]);
                    /<!DOCTYPE\s+html\s*[>\[]/i.test(d) || (a = a.replace(/^[\s\S]+?<html/i, this.j + "<!DOCTYPE html>\n<html"));
                }
                try {
                    var g = e.parseXhtmlString(a, b);
                    "html" === g.documentElement.localName && g.documentElement.style ? this.h = g : w.Logger.logWarning(new z("INVALID_XHTML_DOCUMENT", null, 'path="' + b + '" rootTagName="' + g.documentElement.localName + '"'));
                } catch (u) {
                    w.Logger.logWarning(u), w.Logger.logWarning(new z("INVALID_XHTML_DOCUMENT", null, 'path="' + b + '"')), this.g = u.parserErrorDocument || null, c = !0;
                }
            }
            if (!this.h) try {
                if (c) {
                    w.Logger.logInfo("Falling back to HTML parser for: " + b);
                    for(var f = new J(a); f.g < f.l;)if (60 === f.h.charCodeAt(f.g++)) {
                        var n = f.h.charCodeAt(f.g);
                        if (65 <= n && 90 >= n || 97 <= n && 122 >= n) L(f, !0);
                        else if (47 === n) {
                            f.g++;
                            c = f;
                            var v = c.h.charCodeAt(c.g);
                            65 <= v && 90 >= v || 97 <= v && 122 >= v ? L(c, !1) : 62 === v ? c.g++ : K(c);
                        } else if (63 === n) K(f);
                        else if (33 === n) {
                            f.g++;
                            c = f;
                            var N = c.h.charCodeAt(c.g);
                            if (45 === N && 45 === c.h.charCodeAt(c.g + 1)) for(c.g += 2, g = !0, d = 1; g;){
                                var k = c.h.charCodeAt(c.g++);
                                switch(d){
                                    case 1:
                                        45 === k ? d = 2 : 62 === k ? g = !1 : (c.g--, d = 3);
                                        break;
                                    case 2:
                                        45 === k ? d = 8 : 62 === k ? g = !1 : (c.g--, d = 3);
                                        break;
                                    case 3:
                                        60 === k ? d = 4 : 45 === k ? d = 7 : "undefined" === typeof k && (g = !1);
                                        break;
                                    case 4:
                                        33 === k ? d = 5 : 60 !== k && (c.g--, d = 3);
                                        break;
                                    case 5:
                                        45 === k ? d = 6 : (c.g--, d = 3);
                                        break;
                                    case 6:
                                        45 === k ? d = 8 : (c.g--, d = 7);
                                        break;
                                    case 7:
                                        45 === k ? d = 8 : (c.g--, d = 3);
                                        break;
                                    case 8:
                                        62 === k ? g = !1 : 33 === k ? d = 9 : 45 !== k && (c.g--, d = 3);
                                        break;
                                    case 9:
                                        45 === k ? d = 7 : 62 === k ? g = !1 : (c.g--, d = 3);
                                }
                            }
                            else if (91 === N && "[CDATA[" === c.h.slice(c.g, c.g + 7)) for(c.g += 7, g = !0; g;){
                                var O = c.h.charCodeAt(c.g++);
                                93 === O && 93 === c.h.charCodeAt(c.g) && 62 === c.h.charCodeAt(c.g + 1) ? (c.g += 2, g = !1) : "undefined" === typeof O && (g = !1);
                            }
                            else K(c);
                        } else f.g++;
                    }
                    a = 0 === f.i ? f.h : f.j + f.h.slice(f.i);
                }
                var F = e.parseHtmlString(a, b);
                "html" === F.documentElement.localName && F.documentElement.style && (this.i = F);
            } catch (u) {
                w.Logger.logError(u), w.Logger.logError(new z("INVALID_HTML_DOCUMENT", null, 'path="' + b + '"')), this.g || (this.g = u.parserErrorDocument || null);
            }
        }
        P.prototype.getDocument = function() {
            return this.h || this.i;
        };
        P.prototype.getParserError = function() {
            return this.g;
        };
        P.prototype.getXmlHeader = function() {
            return this.j;
        };
        P.prototype.isHtmlDocument = function() {
            return null !== this.i;
        };
        P.prototype.isXhtmlDocument = function() {
            return null !== this.h;
        };
        function Q(a) {
            return a.replace(/["&'<>]/g, function(b) {
                switch(b){
                    case '"':
                        return "&quot;";
                    case "&":
                        return "&amp;";
                    case "'":
                        return "&apos;";
                    case "<":
                        return "&lt;";
                    case ">":
                        return "&gt;";
                }
                return "";
            });
        }
        function R(a, b) {
            switch(a.nodeType){
                case 1:
                    b.push("<", a.tagName);
                    var d = a.attributes;
                    if (0 < d.length) for(var e = 0; e < d.length; e++){
                        var c = d[e];
                        b.push(" ", Q(c.name), '="', Q(c.value), '"');
                    }
                    a: {
                        if (a.namespaceURI === w.XmlNamespace.HTML) switch(a.localName){
                            case "area":
                            case "base":
                            case "br":
                            case "col":
                            case "command":
                            case "embed":
                            case "hr":
                            case "img":
                            case "input":
                            case "keygen":
                            case "link":
                            case "menuitem":
                            case "meta":
                            case "param":
                            case "source":
                            case "track":
                            case "wbr":
                                d = !0;
                                break a;
                        }
                        d = !1;
                    }
                    if (d) b.push(" />");
                    else {
                        b.push(">");
                        d = "script" === a.localName;
                        e = a.childNodes;
                        for(c = 0; c < e.length; c++){
                            var h = e[c];
                            !d || 3 !== h.nodeType && 4 !== h.nodeType ? R(h, b) : b.push(h.data.replace(/<\/script>/g, "&lt;/script>"));
                        }
                        b.push("</" + a.tagName + ">");
                    }
                    break;
                case 3:
                    b.push(Q(a.data));
                    break;
                case 4:
                    b.push(Q(a.data));
                    break;
                case 8:
                    b.push("<!--", Q(a.data.replace(/--/g, "- ")) || " ", "-->");
                    break;
                case 9:
                    a = a.childNodes;
                    for(d = 0; d < a.length; d++)R(a[d], b);
                    break;
                case 10:
                    a.name && (b.push("<!DOCTYPE ", a.name), a.publicId && b.push(' PUBLIC "', a.publicId, '"'), a.systemId && b.push(' "', a.systemId, '"'), b.push(">"));
                    break;
                default:
                    throw new z("UNSUPPORTED_NODE_TYPE", null, "" + a.nodeType);
            }
        }
        function S() {}
        S.prototype.serializeXml = function(a) {
            var b = !0;
            a && 9 === a.nodeType && "HTML" === a.documentElement.tagName ? b = !1 : a && 1 === a.nodeType && a.namespaceURI === w.XmlNamespace.HTML && a.tagName !== a.tagName.toLowerCase() && (b = !1);
            b ? (null === T && (T = new XMLSerializer), a = T.serializeToString(a)) : (b = [], R(a, b), a = b.join(""));
            return a;
        };
        var T = null;
        api = {
            CoreXmlError: z,
            CoreXmlErrorType: {
                DOM_PARSE_ERROR: "DOM_PARSE_ERROR",
                INVALID_HTML_DOCUMENT: "INVALID_HTML_DOCUMENT",
                INVALID_XHTML_DOCUMENT: "INVALID_XHTML_DOCUMENT",
                UNSUPPORTED_NODE_TYPE: "UNSUPPORTED_NODE_TYPE"
            },
            DomParser: D,
            XhtmlParser: P,
            XmlSerializer: S
        };
        var U = new ArrayBuffer(8);
        new DataView(U);
        new Uint8Array(U);
    }).call(__self);
    return api;
});

});


parcelRegister("8v4lP", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";



(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("acQau")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_publication_base) {
    var __lib__pdfjs = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        var p = p || {};
        p.scope = {};
        p.arrayIteratorImpl = function(y) {
            var A = 0;
            return function() {
                return A < y.length ? {
                    done: !1,
                    value: y[A++]
                } : {
                    done: !0
                };
            };
        };
        p.arrayIterator = function(y) {
            return {
                next: p.arrayIteratorImpl(y)
            };
        };
        p.ASSUME_ES5 = !1;
        p.ASSUME_NO_NATIVE_MAP = !1;
        p.ASSUME_NO_NATIVE_SET = !1;
        p.SIMPLE_FROUND_POLYFILL = !1;
        p.ISOLATE_POLYFILLS = !1;
        p.FORCE_POLYFILL_PROMISE = !1;
        p.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
        p.defineProperty = p.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(y, A, G) {
            if (y == Array.prototype || y == Object.prototype) return y;
            y[A] = G.value;
            return y;
        };
        p.getGlobal = function(y) {
            y = [
                "object" == typeof globalThis && globalThis,
                y,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var A = 0; A < y.length; ++A){
                var G = y[A];
                if (G && G.Math == Math) return G;
            }
            throw Error("Cannot find global object");
        };
        p.global = p.getGlobal(this);
        p.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
        p.TRUST_ES6_POLYFILLS = !p.ISOLATE_POLYFILLS || p.IS_SYMBOL_NATIVE;
        p.polyfills = {};
        p.propertyToPolyfillSymbol = {};
        p.POLYFILL_PREFIX = "$jscp$";
        p.polyfill = function(y, A, G, E) {
            A && (p.ISOLATE_POLYFILLS ? p.polyfillIsolated(y, A, G, E) : p.polyfillUnisolated(y, A, G, E));
        };
        p.polyfillUnisolated = function(y, A) {
            var G = p.global;
            y = y.split(".");
            for(var E = 0; E < y.length - 1; E++){
                var F = y[E];
                if (!(F in G)) return;
                G = G[F];
            }
            y = y[y.length - 1];
            E = G[y];
            A = A(E);
            A != E && null != A && p.defineProperty(G, y, {
                configurable: !0,
                writable: !0,
                value: A
            });
        };
        p.polyfillIsolated = function(y, A, G) {
            var E = y.split(".");
            y = 1 === E.length;
            var F = E[0];
            F = !y && F in p.polyfills ? p.polyfills : p.global;
            for(var ha = 0; ha < E.length - 1; ha++){
                var Q = E[ha];
                if (!(Q in F)) return;
                F = F[Q];
            }
            E = E[E.length - 1];
            G = p.IS_SYMBOL_NATIVE && "es6" === G ? F[E] : null;
            A = A(G);
            null != A && (y ? p.defineProperty(p.polyfills, E, {
                configurable: !0,
                writable: !0,
                value: A
            }) : A !== G && (void 0 === p.propertyToPolyfillSymbol[E] && (y = 1E9 * Math.random() >>> 0, p.propertyToPolyfillSymbol[E] = p.IS_SYMBOL_NATIVE ? p.global.Symbol(E) : p.POLYFILL_PREFIX + y + "$" + E), p.defineProperty(F, p.propertyToPolyfillSymbol[E], {
                configurable: !0,
                writable: !0,
                value: A
            })));
        };
        p.initSymbol = function() {};
        p.polyfill("Symbol", function(y) {
            function A(ha) {
                if (this instanceof A) throw new TypeError("Symbol is not a constructor");
                return new G(E + (ha || "") + "_" + F++, ha);
            }
            function G(ha, Q) {
                this.$jscomp$symbol$id_ = ha;
                p.defineProperty(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: Q
                });
            }
            if (y) return y;
            G.prototype.toString = function() {
                return this.$jscomp$symbol$id_;
            };
            var E = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", F = 0;
            return A;
        }, "es6", "es3");
        p.polyfill("Symbol.iterator", function(y) {
            if (y) return y;
            y = Symbol("Symbol.iterator");
            for(var A = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), G = 0; G < A.length; G++){
                var E = p.global[A[G]];
                "function" === typeof E && "function" != typeof E.prototype[y] && p.defineProperty(E.prototype, y, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return p.iteratorPrototype(p.arrayIteratorImpl(this));
                    }
                });
            }
            return y;
        }, "es6", "es3");
        p.iteratorPrototype = function(y) {
            y = {
                next: y
            };
            y[Symbol.iterator] = function() {
                return this;
            };
            return y;
        };
        p.makeIterator = function(y) {
            var A = "undefined" != typeof Symbol && Symbol.iterator && y[Symbol.iterator];
            if (A) return A.call(y);
            if ("number" == typeof y.length) return p.arrayIterator(y);
            throw Error(String(y) + " is not an iterable or ArrayLike");
        };
        p.arrayFromIterator = function(y) {
            for(var A, G = []; !(A = y.next()).done;)G.push(A.value);
            return G;
        };
        p.arrayFromIterable = function(y) {
            return y instanceof Array ? y : p.arrayFromIterator(p.makeIterator(y));
        };
        p.underscoreProtoCanBeSet = function() {
            var y = {
                a: !0
            }, A = {};
            try {
                return A.__proto__ = y, A.a;
            } catch (G) {}
            return !1;
        };
        p.setPrototypeOf = p.TRUST_ES6_POLYFILLS && "function" == typeof Object.setPrototypeOf ? Object.setPrototypeOf : p.underscoreProtoCanBeSet() ? function(y, A) {
            y.__proto__ = A;
            if (y.__proto__ !== A) throw new TypeError(y + " is not extensible");
            return y;
        } : null;
        p.generator = {};
        p.generator.ensureIteratorResultIsObject_ = function(y) {
            if (!(y instanceof Object)) throw new TypeError("Iterator result " + y + " is not an object");
        };
        p.generator.Context = function() {
            this.isRunning_ = !1;
            this.yieldAllIterator_ = null;
            this.yieldResult = void 0;
            this.nextAddress = 1;
            this.finallyAddress_ = this.catchAddress_ = 0;
            this.finallyContexts_ = this.abruptCompletion_ = null;
        };
        p.generator.Context.prototype.start_ = function() {
            if (this.isRunning_) throw new TypeError("Generator is already running");
            this.isRunning_ = !0;
        };
        p.generator.Context.prototype.stop_ = function() {
            this.isRunning_ = !1;
        };
        p.generator.Context.prototype.jumpToErrorHandler_ = function() {
            this.nextAddress = this.catchAddress_ || this.finallyAddress_;
        };
        p.generator.Context.prototype.next_ = function(y) {
            this.yieldResult = y;
        };
        p.generator.Context.prototype.throw_ = function(y) {
            this.abruptCompletion_ = {
                exception: y,
                isException: !0
            };
            this.jumpToErrorHandler_();
        };
        p.generator.Context.prototype.return = function(y) {
            this.abruptCompletion_ = {
                return: y
            };
            this.nextAddress = this.finallyAddress_;
        };
        p.generator.Context.prototype.jumpThroughFinallyBlocks = function(y) {
            this.abruptCompletion_ = {
                jumpTo: y
            };
            this.nextAddress = this.finallyAddress_;
        };
        p.generator.Context.prototype.yield = function(y, A) {
            this.nextAddress = A;
            return {
                value: y
            };
        };
        p.generator.Context.prototype.yieldAll = function(y, A) {
            y = p.makeIterator(y);
            var G = y.next();
            p.generator.ensureIteratorResultIsObject_(G);
            if (G.done) this.yieldResult = G.value, this.nextAddress = A;
            else return this.yieldAllIterator_ = y, this.yield(G.value, A);
        };
        p.generator.Context.prototype.jumpTo = function(y) {
            this.nextAddress = y;
        };
        p.generator.Context.prototype.jumpToEnd = function() {
            this.nextAddress = 0;
        };
        p.generator.Context.prototype.setCatchFinallyBlocks = function(y, A) {
            this.catchAddress_ = y;
            void 0 != A && (this.finallyAddress_ = A);
        };
        p.generator.Context.prototype.setFinallyBlock = function(y) {
            this.catchAddress_ = 0;
            this.finallyAddress_ = y || 0;
        };
        p.generator.Context.prototype.leaveTryBlock = function(y, A) {
            this.nextAddress = y;
            this.catchAddress_ = A || 0;
        };
        p.generator.Context.prototype.enterCatchBlock = function(y) {
            this.catchAddress_ = y || 0;
            y = this.abruptCompletion_.exception;
            this.abruptCompletion_ = null;
            return y;
        };
        p.generator.Context.prototype.enterFinallyBlock = function(y, A, G) {
            G ? this.finallyContexts_[G] = this.abruptCompletion_ : this.finallyContexts_ = [
                this.abruptCompletion_
            ];
            this.catchAddress_ = y || 0;
            this.finallyAddress_ = A || 0;
        };
        p.generator.Context.prototype.leaveFinallyBlock = function(y, A) {
            A = this.finallyContexts_.splice(A || 0)[0];
            if (A = this.abruptCompletion_ = this.abruptCompletion_ || A) {
                if (A.isException) return this.jumpToErrorHandler_();
                void 0 != A.jumpTo && this.finallyAddress_ < A.jumpTo ? (this.nextAddress = A.jumpTo, this.abruptCompletion_ = null) : this.nextAddress = this.finallyAddress_;
            } else this.nextAddress = y;
        };
        p.generator.Context.prototype.forIn = function(y) {
            return new p.generator.Context.PropertyIterator(y);
        };
        p.generator.Context.PropertyIterator = function(y) {
            this.object_ = y;
            this.properties_ = [];
            for(var A in y)this.properties_.push(A);
            this.properties_.reverse();
        };
        p.generator.Context.PropertyIterator.prototype.getNext = function() {
            for(; 0 < this.properties_.length;){
                var y = this.properties_.pop();
                if (y in this.object_) return y;
            }
            return null;
        };
        p.generator.Engine_ = function(y) {
            this.context_ = new p.generator.Context;
            this.program_ = y;
        };
        p.generator.Engine_.prototype.next_ = function(y) {
            this.context_.start_();
            if (this.context_.yieldAllIterator_) return this.yieldAllStep_(this.context_.yieldAllIterator_.next, y, this.context_.next_);
            this.context_.next_(y);
            return this.nextStep_();
        };
        p.generator.Engine_.prototype.return_ = function(y) {
            this.context_.start_();
            var A = this.context_.yieldAllIterator_;
            if (A) return this.yieldAllStep_("return" in A ? A["return"] : function(G) {
                return {
                    value: G,
                    done: !0
                };
            }, y, this.context_.return);
            this.context_.return(y);
            return this.nextStep_();
        };
        p.generator.Engine_.prototype.throw_ = function(y) {
            this.context_.start_();
            if (this.context_.yieldAllIterator_) return this.yieldAllStep_(this.context_.yieldAllIterator_["throw"], y, this.context_.next_);
            this.context_.throw_(y);
            return this.nextStep_();
        };
        p.generator.Engine_.prototype.yieldAllStep_ = function(y, A, G) {
            try {
                var E = y.call(this.context_.yieldAllIterator_, A);
                p.generator.ensureIteratorResultIsObject_(E);
                if (!E.done) return this.context_.stop_(), E;
                var F = E.value;
            } catch (ha) {
                return this.context_.yieldAllIterator_ = null, this.context_.throw_(ha), this.nextStep_();
            }
            this.context_.yieldAllIterator_ = null;
            G.call(this.context_, F);
            return this.nextStep_();
        };
        p.generator.Engine_.prototype.nextStep_ = function() {
            for(; this.context_.nextAddress;)try {
                var y = this.program_(this.context_);
                if (y) return this.context_.stop_(), {
                    value: y.value,
                    done: !1
                };
            } catch (A) {
                this.context_.yieldResult = void 0, this.context_.throw_(A);
            }
            this.context_.stop_();
            if (this.context_.abruptCompletion_) {
                y = this.context_.abruptCompletion_;
                this.context_.abruptCompletion_ = null;
                if (y.isException) throw y.exception;
                return {
                    value: y.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        };
        p.generator.Generator_ = function(y) {
            this.next = function(A) {
                return y.next_(A);
            };
            this.throw = function(A) {
                return y.throw_(A);
            };
            this.return = function(A) {
                return y.return_(A);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        };
        p.generator.createGenerator = function(y, A) {
            A = new p.generator.Generator_(new p.generator.Engine_(A));
            p.setPrototypeOf && y.prototype && p.setPrototypeOf(A, y.prototype);
            return A;
        };
        p.polyfill("Array.from", function(y) {
            return y ? y : function(A, G, E) {
                G = null != G ? G : function(ca) {
                    return ca;
                };
                var F = [], ha = "undefined" != typeof Symbol && Symbol.iterator && A[Symbol.iterator];
                if ("function" == typeof ha) {
                    A = ha.call(A);
                    for(var Q = 0; !(ha = A.next()).done;)F.push(G.call(E, ha.value, Q++));
                } else for(ha = A.length, Q = 0; Q < ha; Q++)F.push(G.call(E, A[Q], Q));
                return F;
            };
        }, "es6", "es3");
        p.polyfill("Reflect.apply", function(y) {
            if (y) return y;
            var A = Function.prototype.apply;
            return function(G, E, F) {
                return A.call(G, E, F);
            };
        }, "es6", "es3");
        p.iteratorFromArray = function(y, A) {
            y instanceof String && (y += "");
            var G = 0, E = !1, F = {
                next: function() {
                    if (!E && G < y.length) {
                        var ha = G++;
                        return {
                            value: A(ha, y[ha]),
                            done: !1
                        };
                    }
                    E = !0;
                    return {
                        done: !0,
                        value: void 0
                    };
                }
            };
            F[Symbol.iterator] = function() {
                return F;
            };
            return F;
        };
        p.polyfill("Array.prototype.keys", function(y) {
            return y ? y : function() {
                return p.iteratorFromArray(this, function(A) {
                    return A;
                });
            };
        }, "es6", "es3");
        p.polyfill("Object.hasOwn", function(y) {
            return y ? y : function(A, G) {
                return Object.prototype.hasOwnProperty.call(A, G);
            };
        }, "es_next", "es3");
        p.checkEs6ConformanceViaProxy = function() {
            try {
                var y = {}, A = Object.create(new p.global.Proxy(y, {
                    get: function(G, E, F) {
                        return G == y && "q" == E && F == A;
                    }
                }));
                return !0 === A.q;
            } catch (G) {
                return !1;
            }
        };
        p.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS = !1;
        p.ES6_CONFORMANCE = p.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS && p.checkEs6ConformanceViaProxy();
        p.owns = function(y, A) {
            return Object.prototype.hasOwnProperty.call(y, A);
        };
        p.polyfill("WeakMap", function(y) {
            function A(W) {
                this.id_ = (S += Math.random() + 1).toString();
                if (W) {
                    W = p.makeIterator(W);
                    for(var R; !(R = W.next()).done;)R = R.value, this.set(R[0], R[1]);
                }
            }
            function G() {
                if (!y || !Object.seal) return !1;
                try {
                    var W = Object.seal({}), R = Object.seal({}), da = new y([
                        [
                            W,
                            2
                        ],
                        [
                            R,
                            3
                        ]
                    ]);
                    if (2 != da.get(W) || 3 != da.get(R)) return !1;
                    da.delete(W);
                    da.set(R, 4);
                    return !da.has(W) && 4 == da.get(R);
                } catch (Fa) {
                    return !1;
                }
            }
            function E() {}
            function F(W) {
                var R = typeof W;
                return "object" === R && null !== W || "function" === R;
            }
            function ha(W) {
                if (!p.owns(W, ca)) {
                    var R = new E;
                    p.defineProperty(W, ca, {
                        value: R
                    });
                }
            }
            function Q(W) {
                if (!p.ISOLATE_POLYFILLS) {
                    var R = Object[W];
                    R && (Object[W] = function(da) {
                        if (da instanceof E) return da;
                        Object.isExtensible(da) && ha(da);
                        return R(da);
                    });
                }
            }
            if (p.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
                if (y && p.ES6_CONFORMANCE) return y;
            } else if (G()) return y;
            var ca = "$jscomp_hidden_" + Math.random();
            Q("freeze");
            Q("preventExtensions");
            Q("seal");
            var S = 0;
            A.prototype.set = function(W, R) {
                if (!F(W)) throw Error("Invalid WeakMap key");
                ha(W);
                if (!p.owns(W, ca)) throw Error("WeakMap key fail: " + W);
                W[ca][this.id_] = R;
                return this;
            };
            A.prototype.get = function(W) {
                return F(W) && p.owns(W, ca) ? W[ca][this.id_] : void 0;
            };
            A.prototype.has = function(W) {
                return F(W) && p.owns(W, ca) && p.owns(W[ca], this.id_);
            };
            A.prototype.delete = function(W) {
                return F(W) && p.owns(W, ca) && p.owns(W[ca], this.id_) ? delete W[ca][this.id_] : !1;
            };
            return A;
        }, "es6", "es3");
        p.polyfill("Number.isFinite", function(y) {
            return y ? y : function(A) {
                return "number" !== typeof A ? !1 : !isNaN(A) && Infinity !== A && -Infinity !== A;
            };
        }, "es6", "es3");
        p.polyfill("Number.isInteger", function(y) {
            return y ? y : function(A) {
                return Number.isFinite(A) ? A === Math.floor(A) : !1;
            };
        }, "es6", "es3");
        p.polyfill("Array.prototype.entries", function(y) {
            return y ? y : function() {
                return p.iteratorFromArray(this, function(A, G) {
                    return [
                        A,
                        G
                    ];
                });
            };
        }, "es6", "es3");
        p.polyfill("Math.fround", function(y) {
            if (y) return y;
            if (p.SIMPLE_FROUND_POLYFILL || "function" !== typeof Float32Array) return function(G) {
                return G;
            };
            var A = new Float32Array(1);
            return function(G) {
                A[0] = G;
                return A[0];
            };
        }, "es6", "es3");
        p.polyfill("Math.sign", function(y) {
            return y ? y : function(A) {
                A = Number(A);
                return 0 === A || isNaN(A) ? A : 0 < A ? 1 : -1;
            };
        }, "es6", "es3");
        p.polyfill("Math.trunc", function(y) {
            return y ? y : function(A) {
                A = Number(A);
                if (isNaN(A) || Infinity === A || -Infinity === A || 0 === A) return A;
                var G = Math.floor(Math.abs(A));
                return 0 > A ? -G : G;
            };
        }, "es6", "es3");
        p.polyfill("Promise", function(y) {
            function A(Q) {
                this.state_ = 0;
                this.result_ = void 0;
                this.onSettledCallbacks_ = [];
                this.isRejectionHandled_ = !1;
                var ca = this.createResolveAndReject_();
                try {
                    Q(ca.resolve, ca.reject);
                } catch (S) {
                    ca.reject(S);
                }
            }
            function G() {
                this.batch_ = null;
            }
            function E(Q) {
                return Q instanceof A ? Q : new A(function(ca) {
                    ca(Q);
                });
            }
            if (y && (!(p.FORCE_POLYFILL_PROMISE || p.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION && "undefined" === typeof p.global.PromiseRejectionEvent) || !p.global.Promise || -1 === p.global.Promise.toString().indexOf("[native code]"))) return y;
            G.prototype.asyncExecute = function(Q) {
                if (null == this.batch_) {
                    this.batch_ = [];
                    var ca = this;
                    this.asyncExecuteFunction(function() {
                        ca.executeBatch_();
                    });
                }
                this.batch_.push(Q);
            };
            var F = p.global.setTimeout;
            G.prototype.asyncExecuteFunction = function(Q) {
                F(Q, 0);
            };
            G.prototype.executeBatch_ = function() {
                for(; this.batch_ && this.batch_.length;){
                    var Q = this.batch_;
                    this.batch_ = [];
                    for(var ca = 0; ca < Q.length; ++ca){
                        var S = Q[ca];
                        Q[ca] = null;
                        try {
                            S();
                        } catch (W) {
                            this.asyncThrow_(W);
                        }
                    }
                }
                this.batch_ = null;
            };
            G.prototype.asyncThrow_ = function(Q) {
                this.asyncExecuteFunction(function() {
                    throw Q;
                });
            };
            A.prototype.createResolveAndReject_ = function() {
                function Q(W) {
                    return function(R) {
                        S || (S = !0, W.call(ca, R));
                    };
                }
                var ca = this, S = !1;
                return {
                    resolve: Q(this.resolveTo_),
                    reject: Q(this.reject_)
                };
            };
            A.prototype.resolveTo_ = function(Q) {
                if (Q === this) this.reject_(new TypeError("A Promise cannot resolve to itself"));
                else if (Q instanceof A) this.settleSameAsPromise_(Q);
                else {
                    a: switch(typeof Q){
                        case "object":
                            var ca = null != Q;
                            break a;
                        case "function":
                            ca = !0;
                            break a;
                        default:
                            ca = !1;
                    }
                    ca ? this.resolveToNonPromiseObj_(Q) : this.fulfill_(Q);
                }
            };
            A.prototype.resolveToNonPromiseObj_ = function(Q) {
                var ca = void 0;
                try {
                    ca = Q.then;
                } catch (S) {
                    this.reject_(S);
                    return;
                }
                "function" == typeof ca ? this.settleSameAsThenable_(ca, Q) : this.fulfill_(Q);
            };
            A.prototype.reject_ = function(Q) {
                this.settle_(2, Q);
            };
            A.prototype.fulfill_ = function(Q) {
                this.settle_(1, Q);
            };
            A.prototype.settle_ = function(Q, ca) {
                if (0 != this.state_) throw Error("Cannot settle(" + Q + ", " + ca + "): Promise already settled in state" + this.state_);
                this.state_ = Q;
                this.result_ = ca;
                2 === this.state_ && this.scheduleUnhandledRejectionCheck_();
                this.executeOnSettledCallbacks_();
            };
            A.prototype.scheduleUnhandledRejectionCheck_ = function() {
                var Q = this;
                F(function() {
                    if (Q.notifyUnhandledRejection_()) {
                        var ca = p.global.console;
                        "undefined" !== typeof ca && ca.error(Q.result_);
                    }
                }, 1);
            };
            A.prototype.notifyUnhandledRejection_ = function() {
                if (this.isRejectionHandled_) return !1;
                var Q = p.global.CustomEvent, ca = p.global.Event, S = p.global.dispatchEvent;
                if ("undefined" === typeof S) return !0;
                "function" === typeof Q ? Q = new Q("unhandledrejection", {
                    cancelable: !0
                }) : "function" === typeof ca ? Q = new ca("unhandledrejection", {
                    cancelable: !0
                }) : (Q = p.global.document.createEvent("CustomEvent"), Q.initCustomEvent("unhandledrejection", !1, !0, Q));
                Q.promise = this;
                Q.reason = this.result_;
                return S(Q);
            };
            A.prototype.executeOnSettledCallbacks_ = function() {
                if (null != this.onSettledCallbacks_) {
                    for(var Q = 0; Q < this.onSettledCallbacks_.length; ++Q)ha.asyncExecute(this.onSettledCallbacks_[Q]);
                    this.onSettledCallbacks_ = null;
                }
            };
            var ha = new G;
            A.prototype.settleSameAsPromise_ = function(Q) {
                var ca = this.createResolveAndReject_();
                Q.callWhenSettled_(ca.resolve, ca.reject);
            };
            A.prototype.settleSameAsThenable_ = function(Q, ca) {
                var S = this.createResolveAndReject_();
                try {
                    Q.call(ca, S.resolve, S.reject);
                } catch (W) {
                    S.reject(W);
                }
            };
            A.prototype.then = function(Q, ca) {
                function S(Fa, qa) {
                    return "function" == typeof Fa ? function(lb) {
                        try {
                            W(Fa(lb));
                        } catch (Va) {
                            R(Va);
                        }
                    } : qa;
                }
                var W, R, da = new A(function(Fa, qa) {
                    W = Fa;
                    R = qa;
                });
                this.callWhenSettled_(S(Q, W), S(ca, R));
                return da;
            };
            A.prototype.catch = function(Q) {
                return this.then(void 0, Q);
            };
            A.prototype.callWhenSettled_ = function(Q, ca) {
                function S() {
                    switch(W.state_){
                        case 1:
                            Q(W.result_);
                            break;
                        case 2:
                            ca(W.result_);
                            break;
                        default:
                            throw Error("Unexpected state: " + W.state_);
                    }
                }
                var W = this;
                null == this.onSettledCallbacks_ ? ha.asyncExecute(S) : this.onSettledCallbacks_.push(S);
                this.isRejectionHandled_ = !0;
            };
            A.resolve = E;
            A.reject = function(Q) {
                return new A(function(ca, S) {
                    S(Q);
                });
            };
            A.race = function(Q) {
                return new A(function(ca, S) {
                    for(var W = p.makeIterator(Q), R = W.next(); !R.done; R = W.next())E(R.value).callWhenSettled_(ca, S);
                });
            };
            A.all = function(Q) {
                var ca = p.makeIterator(Q), S = ca.next();
                return S.done ? E([]) : new A(function(W, R) {
                    function da(lb) {
                        return function(Va) {
                            Fa[lb] = Va;
                            qa--;
                            0 == qa && W(Fa);
                        };
                    }
                    var Fa = [], qa = 0;
                    do Fa.push(void 0), qa++, E(S.value).callWhenSettled_(da(Fa.length - 1), R), S = ca.next();
                    while (!S.done);
                });
            };
            return A;
        }, "es6", "es3");
        p.polyfill("Object.getOwnPropertySymbols", function(y) {
            return y ? y : function() {
                return [];
            };
        }, "es6", "es5");
        p.polyfill("Object.setPrototypeOf", function(y) {
            return y || p.setPrototypeOf;
        }, "es6", "es5");
        p.polyfill("Object.is", function(y) {
            return y ? y : function(A, G) {
                return A === G ? 0 !== A || 1 / A === 1 / G : A !== A && G !== G;
            };
        }, "es6", "es3");
        p.polyfill("Array.prototype.includes", function(y) {
            return y ? y : function(A, G) {
                var E = this;
                E instanceof String && (E = String(E));
                var F = E.length;
                G = G || 0;
                for(0 > G && (G = Math.max(G + F, 0)); G < F; G++){
                    var ha = E[G];
                    if (ha === A || Object.is(ha, A)) return !0;
                }
                return !1;
            };
        }, "es7", "es3");
        p.checkStringArgs = function(y, A, G) {
            if (null == y) throw new TypeError("The 'this' value for String.prototype." + G + " must not be null or undefined");
            if (A instanceof RegExp) throw new TypeError("First argument to String.prototype." + G + " must not be a regular expression");
            return y + "";
        };
        p.polyfill("String.prototype.includes", function(y) {
            return y ? y : function(A, G) {
                return -1 !== p.checkStringArgs(this, A, "includes").indexOf(A, G || 0);
            };
        }, "es6", "es3");
        p.MapEntry = function() {};
        p.polyfill("Map", function(y) {
            function A() {
                var S = {};
                return S.previous = S.next = S.head = S;
            }
            function G(S, W) {
                var R = S[1];
                return p.iteratorPrototype(function() {
                    if (R) {
                        for(; R.head != S[1];)R = R.previous;
                        for(; R.next != R.head;)return R = R.next, {
                            done: !1,
                            value: W(R)
                        };
                        R = null;
                    }
                    return {
                        done: !0,
                        value: void 0
                    };
                });
            }
            function E(S, W) {
                var R = W && typeof W;
                "object" == R || "function" == R ? Q.has(W) ? R = Q.get(W) : (R = "" + ++ca, Q.set(W, R)) : R = "p_" + W;
                var da = S[0][R];
                if (da && p.owns(S[0], R)) for(S = 0; S < da.length; S++){
                    var Fa = da[S];
                    if (W !== W && Fa.key !== Fa.key || W === Fa.key) return {
                        id: R,
                        list: da,
                        index: S,
                        entry: Fa
                    };
                }
                return {
                    id: R,
                    list: da,
                    index: -1,
                    entry: void 0
                };
            }
            function F(S) {
                this[0] = {};
                this[1] = A();
                this.size = 0;
                if (S) {
                    S = p.makeIterator(S);
                    for(var W; !(W = S.next()).done;)W = W.value, this.set(W[0], W[1]);
                }
            }
            function ha() {
                if (p.ASSUME_NO_NATIVE_MAP || !y || "function" != typeof y || !y.prototype.entries || "function" != typeof Object.seal) return !1;
                try {
                    var S = Object.seal({
                        x: 4
                    }), W = new y(p.makeIterator([
                        [
                            S,
                            "s"
                        ]
                    ]));
                    if ("s" != W.get(S) || 1 != W.size || W.get({
                        x: 4
                    }) || W.set({
                        x: 4
                    }, "t") != W || 2 != W.size) return !1;
                    var R = W.entries(), da = R.next();
                    if (da.done || da.value[0] != S || "s" != da.value[1]) return !1;
                    da = R.next();
                    return da.done || 4 != da.value[0].x || "t" != da.value[1] || !R.next().done ? !1 : !0;
                } catch (Fa) {
                    return !1;
                }
            }
            if (p.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
                if (y && p.ES6_CONFORMANCE) return y;
            } else if (ha()) return y;
            var Q = new WeakMap;
            F.prototype.set = function(S, W) {
                S = 0 === S ? 0 : S;
                var R = E(this, S);
                R.list || (R.list = this[0][R.id] = []);
                R.entry ? R.entry.value = W : (R.entry = {
                    next: this[1],
                    previous: this[1].previous,
                    head: this[1],
                    key: S,
                    value: W
                }, R.list.push(R.entry), this[1].previous.next = R.entry, this[1].previous = R.entry, this.size++);
                return this;
            };
            F.prototype.delete = function(S) {
                S = E(this, S);
                return S.entry && S.list ? (S.list.splice(S.index, 1), S.list.length || delete this[0][S.id], S.entry.previous.next = S.entry.next, S.entry.next.previous = S.entry.previous, S.entry.head = null, this.size--, !0) : !1;
            };
            F.prototype.clear = function() {
                this[0] = {};
                this[1] = this[1].previous = A();
                this.size = 0;
            };
            F.prototype.has = function(S) {
                return !!E(this, S).entry;
            };
            F.prototype.get = function(S) {
                return (S = E(this, S).entry) && S.value;
            };
            F.prototype.entries = function() {
                return G(this, function(S) {
                    return [
                        S.key,
                        S.value
                    ];
                });
            };
            F.prototype.keys = function() {
                return G(this, function(S) {
                    return S.key;
                });
            };
            F.prototype.values = function() {
                return G(this, function(S) {
                    return S.value;
                });
            };
            F.prototype.forEach = function(S, W) {
                for(var R = this.entries(), da; !(da = R.next()).done;)da = da.value, S.call(W, da[1], da[0], this);
            };
            F.prototype[Symbol.iterator] = F.prototype.entries;
            var ca = 0;
            return F;
        }, "es6", "es3");
        p.polyfill("Set", function(y) {
            function A(E) {
                this.map_ = new Map;
                if (E) {
                    E = p.makeIterator(E);
                    for(var F; !(F = E.next()).done;)this.add(F.value);
                }
                this.size = this.map_.size;
            }
            function G() {
                if (p.ASSUME_NO_NATIVE_SET || !y || "function" != typeof y || !y.prototype.entries || "function" != typeof Object.seal) return !1;
                try {
                    var E = Object.seal({
                        x: 4
                    }), F = new y(p.makeIterator([
                        E
                    ]));
                    if (!F.has(E) || 1 != F.size || F.add(E) != F || 1 != F.size || F.add({
                        x: 4
                    }) != F || 2 != F.size) return !1;
                    var ha = F.entries(), Q = ha.next();
                    if (Q.done || Q.value[0] != E || Q.value[1] != E) return !1;
                    Q = ha.next();
                    return Q.done || Q.value[0] == E || 4 != Q.value[0].x || Q.value[1] != Q.value[0] ? !1 : ha.next().done;
                } catch (ca) {
                    return !1;
                }
            }
            if (p.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
                if (y && p.ES6_CONFORMANCE) return y;
            } else if (G()) return y;
            A.prototype.add = function(E) {
                E = 0 === E ? 0 : E;
                this.map_.set(E, E);
                this.size = this.map_.size;
                return this;
            };
            A.prototype.delete = function(E) {
                E = this.map_.delete(E);
                this.size = this.map_.size;
                return E;
            };
            A.prototype.clear = function() {
                this.map_.clear();
                this.size = 0;
            };
            A.prototype.has = function(E) {
                return this.map_.has(E);
            };
            A.prototype.entries = function() {
                return this.map_.entries();
            };
            A.prototype.values = function() {
                return this.map_.values();
            };
            A.prototype.keys = A.prototype.values;
            A.prototype[Symbol.iterator] = A.prototype.values;
            A.prototype.forEach = function(E, F) {
                var ha = this;
                this.map_.forEach(function(Q) {
                    return E.call(F, Q, Q, ha);
                });
            };
            return A;
        }, "es6", "es3");
        p.polyfill("String.prototype.trimRight", function(y) {
            function A() {
                return this.replace(/[\s\xa0]+$/, "");
            }
            return y || A;
        }, "es_2019", "es3");
        p.polyfill("String.prototype.trimEnd", function(y) {
            return y || String.prototype.trimRight;
        }, "es_2019", "es3");
        p.polyfill("Math.hypot", function(y) {
            return y ? y : function(A) {
                if (2 > arguments.length) return arguments.length ? Math.abs(arguments[0]) : 0;
                var G, E, F;
                for(G = F = 0; G < arguments.length; G++)F = Math.max(F, Math.abs(arguments[G]));
                if (1E100 < F || 1E-100 > F) {
                    if (!F) return F;
                    for(G = E = 0; G < arguments.length; G++){
                        var ha = Number(arguments[G]) / F;
                        E += ha * ha;
                    }
                    return Math.sqrt(E) * F;
                }
                for(G = E = 0; G < arguments.length; G++)ha = Number(arguments[G]), E += ha * ha;
                return Math.sqrt(E);
            };
        }, "es6", "es3");
        p.polyfill("Array.prototype.values", function(y) {
            return y ? y : function() {
                return p.iteratorFromArray(this, function(A, G) {
                    return G;
                });
            };
        }, "es8", "es3");
        p.atMethod = function(y) {
            y = Math.trunc(y) || 0;
            0 > y && (y += this.length);
            if (!(0 > y || y >= this.length)) return this[y];
        };
        p.polyfill("Array.prototype.at", function(y) {
            return y ? y : p.atMethod;
        }, "es_next", "es5");
        p.typedArrayAt = function(y) {
            return y ? y : p.atMethod;
        };
        p.polyfill("Int8Array.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("Uint8Array.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("Uint8ClampedArray.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("Int16Array.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("Uint16Array.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("Int32Array.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("Uint32Array.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("Float32Array.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("Float64Array.prototype.at", p.typedArrayAt, "es_next", "es5");
        p.polyfill("String.prototype.at", function(y) {
            return y ? y : p.atMethod;
        }, "es_next", "es5");
        p.polyfill("Array.prototype.fill", function(y) {
            return y ? y : function(A, G, E) {
                var F = this.length || 0;
                0 > G && (G = Math.max(0, F + G));
                if (null == E || E > F) E = F;
                E = Number(E);
                0 > E && (E = Math.max(0, F + E));
                for(G = Number(G || 0); G < E; G++)this[G] = A;
                return this;
            };
        }, "es6", "es3");
        p.typedArrayFill = function(y) {
            return y ? y : Array.prototype.fill;
        };
        p.polyfill("Int8Array.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.polyfill("Uint8Array.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.polyfill("Uint8ClampedArray.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.polyfill("Int16Array.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.polyfill("Uint16Array.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.polyfill("Int32Array.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.polyfill("Uint32Array.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.polyfill("Float32Array.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.polyfill("Float64Array.prototype.fill", p.typedArrayFill, "es6", "es5");
        p.findLastInternal = function(y, A, G) {
            y instanceof String && (y = String(y));
            for(var E = y.length - 1; 0 <= E; E--){
                var F = y[E];
                if (A.call(G, F, E, y)) return {
                    i: E,
                    v: F
                };
            }
            return {
                i: -1,
                v: void 0
            };
        };
        p.polyfill("Array.prototype.findLastIndex", function(y) {
            return y ? y : function(A, G) {
                return p.findLastInternal(this, A, G).i;
            };
        }, "es_next", "es3");
        p.typedArrayFindLastIndex = function(y) {
            return y ? y : function(A, G) {
                return p.findLastInternal(this, A, G).i;
            };
        };
        p.polyfill("Int8Array.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Uint8Array.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Uint8ClampedArray.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Int16Array.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Uint16Array.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Int32Array.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Uint32Array.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Float32Array.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Float64Array.prototype.findLastIndex", p.typedArrayFindLastIndex, "es_next", "es5");
        p.polyfill("Array.prototype.findLast", function(y) {
            return y ? y : function(A, G) {
                return p.findLastInternal(this, A, G).v;
            };
        }, "es_next", "es3");
        p.typedArrayFindLast = function(y) {
            return y ? y : function(A, G) {
                return p.findLastInternal(this, A, G).v;
            };
        };
        p.polyfill("Int8Array.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("Uint8Array.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("Uint8ClampedArray.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("Int16Array.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("Uint16Array.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("Int32Array.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("Uint32Array.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("Float32Array.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("Float64Array.prototype.findLast", p.typedArrayFindLast, "es_next", "es5");
        p.polyfill("globalThis", function(y) {
            return y || p.global;
        }, "es_2020", "es3");
        p.polyfill("String.prototype.startsWith", function(y) {
            return y ? y : function(A, G) {
                var E = p.checkStringArgs(this, A, "startsWith");
                A += "";
                var F = E.length, ha = A.length;
                G = Math.max(0, Math.min(G | 0, E.length));
                for(var Q = 0; Q < ha && G < F;)if (E[G++] != A[Q++]) return !1;
                return Q >= ha;
            };
        }, "es6", "es3");
        p.polyfill("String.prototype.repeat", function(y) {
            return y ? y : function(A) {
                var G = p.checkStringArgs(this, null, "repeat");
                if (0 > A || 1342177279 < A) throw new RangeError("Invalid count value");
                A |= 0;
                for(var E = ""; A;)if (A & 1 && (E += G), A >>>= 1) G += G;
                return E;
            };
        }, "es6", "es3");
        p.stringPadding = function(y, A) {
            y = void 0 !== y ? String(y) : " ";
            return 0 < A && y ? y.repeat(Math.ceil(A / y.length)).substring(0, A) : "";
        };
        p.polyfill("String.prototype.padStart", function(y) {
            return y ? y : function(A, G) {
                var E = p.checkStringArgs(this, null, "padStart");
                return p.stringPadding(G, A - E.length) + E;
            };
        }, "es8", "es3");
        p.polyfill("String.prototype.replaceAll", function(y) {
            return y ? y : function(A, G) {
                if (A instanceof RegExp && !A.global) throw new TypeError("String.prototype.replaceAll called with a non-global RegExp argument.");
                return A instanceof RegExp ? this.replace(A, G) : this.replace(new RegExp(String(A).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08"), "g"), G);
            };
        }, "es_2021", "es3");
        p.polyfill("String.prototype.padEnd", function(y) {
            return y ? y : function(A, G) {
                var E = p.checkStringArgs(this, null, "padStart");
                return E + p.stringPadding(G, A - E.length);
            };
        }, "es8", "es3");
        p.polyfill("Object.entries", function(y) {
            return y ? y : function(A) {
                var G = [], E;
                for(E in A)p.owns(A, E) && G.push([
                    E,
                    A[E]
                ]);
                return G;
            };
        }, "es8", "es3");
        p.assign = p.TRUST_ES6_POLYFILLS && "function" == typeof Object.assign ? Object.assign : function(y, A) {
            for(var G = 1; G < arguments.length; G++){
                var E = arguments[G];
                if (E) for(var F in E)p.owns(E, F) && (y[F] = E[F]);
            }
            return y;
        };
        p.polyfill("Object.assign", function(y) {
            return y || p.assign;
        }, "es6", "es3");
        p.polyfill("String.prototype.endsWith", function(y) {
            return y ? y : function(A, G) {
                var E = p.checkStringArgs(this, A, "endsWith");
                A += "";
                void 0 === G && (G = E.length);
                G = Math.max(0, Math.min(G | 0, E.length));
                for(var F = A.length; 0 < F && 0 < G;)if (E[--G] != A[--F]) return !1;
                return 0 >= F;
            };
        }, "es6", "es3");
        p.polyfill("Promise.allSettled", function(y) {
            function A(E) {
                return {
                    status: "fulfilled",
                    value: E
                };
            }
            function G(E) {
                return {
                    status: "rejected",
                    reason: E
                };
            }
            return y ? y : function(E) {
                var F = this;
                E = Array.from(E, function(ha) {
                    return F.resolve(ha).then(A, G);
                });
                return F.all(E);
            };
        }, "es_2020", "es3");
        p.polyfill("Object.fromEntries", function(y) {
            return y ? y : function(A) {
                var G = {};
                if (!(Symbol.iterator in A)) throw new TypeError("" + A + " is not iterable");
                A = A[Symbol.iterator].call(A);
                for(var E = A.next(); !E.done; E = A.next()){
                    E = E.value;
                    if (Object(E) !== E) throw new TypeError("iterable for fromEntries should yield objects");
                    G[E[0]] = E[1];
                }
                return G;
            };
        }, "es_2019", "es3");
        p.polyfill("Promise.prototype.finally", function(y) {
            return y ? y : function(A) {
                return this.then(function(G) {
                    return Promise.resolve(A()).then(function() {
                        return G;
                    });
                }, function(G) {
                    return Promise.resolve(A()).then(function() {
                        throw G;
                    });
                });
            };
        }, "es9", "es3");
        p.polyfill("WeakSet", function(y) {
            function A(E) {
                this.map_ = new WeakMap;
                if (E) {
                    E = p.makeIterator(E);
                    for(var F; !(F = E.next()).done;)this.add(F.value);
                }
            }
            function G() {
                if (!y || !Object.seal) return !1;
                try {
                    var E = Object.seal({}), F = Object.seal({}), ha = new y([
                        E
                    ]);
                    if (!ha.has(E) || ha.has(F)) return !1;
                    ha.delete(E);
                    ha.add(F);
                    return !ha.has(E) && ha.has(F);
                } catch (Q) {
                    return !1;
                }
            }
            if (p.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS) {
                if (y && p.ES6_CONFORMANCE) return y;
            } else if (G()) return y;
            A.prototype.add = function(E) {
                this.map_.set(E, !0);
                return this;
            };
            A.prototype.has = function(E) {
                return this.map_.has(E);
            };
            A.prototype.delete = function(E) {
                return this.map_.delete(E);
            };
            return A;
        }, "es6", "es3");
        p.polyfill("Object.values", function(y) {
            return y ? y : function(A) {
                var G = [], E;
                for(E in A)p.owns(A, E) && G.push(A[E]);
                return G;
            };
        }, "es8", "es3");
        p.findInternal = function(y, A, G) {
            y instanceof String && (y = String(y));
            for(var E = y.length, F = 0; F < E; F++){
                var ha = y[F];
                if (A.call(G, ha, F, y)) return {
                    i: F,
                    v: ha
                };
            }
            return {
                i: -1,
                v: void 0
            };
        };
        p.polyfill("Array.prototype.findIndex", function(y) {
            return y ? y : function(A, G) {
                return p.findInternal(this, A, G).i;
            };
        }, "es6", "es3");
        p.polyfill("Array.prototype.flatMap", function(y) {
            return y ? y : function(A, G) {
                var E = [];
                Array.prototype.forEach.call(this, function(F, ha) {
                    F = A.call(G, F, ha, this);
                    Array.isArray(F) ? E.push.apply(E, F) : E.push(F);
                });
                return E;
            };
        }, "es9", "es5");
        (function(y) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = y() : "function" === typeof define && define.amd ? define([], y) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = y();
        })(function() {
            return (function() {
                function y(A, G, E) {
                    function F(ca, S) {
                        if (!G[ca]) {
                            if (!A[ca]) {
                                var W = undefined;
                                if (!S && W) return W(ca, !0);
                                if (ha) return ha(ca, !0);
                                S = Error("Cannot find module '" + ca + "'");
                                throw S.code = "MODULE_NOT_FOUND", S;
                            }
                            S = G[ca] = {
                                exports: {}
                            };
                            A[ca][0].call(S.exports, function(R) {
                                return F(A[ca][1][R] || R);
                            }, S, S.exports, y, A, G, E);
                        }
                        return G[ca].exports;
                    }
                    for(var ha = undefined, Q = 0; Q < E.length; Q++)F(E[Q]);
                    return F;
                }
                return y;
            })()({
                1: [
                    function(y, A, G) {
                        (function() {
                            function E() {}
                            function F(g) {
                                var f = Zc[g];
                                if (void 0 !== f) return f.exports;
                                f = Zc[g] = {
                                    exports: {}
                                };
                                ef[g].call(f.exports, f, f.exports, F);
                                return f.exports;
                            }
                            function ha(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Q(g, f, a) {
                                return f && ha(g.prototype, f), a && ha(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function ca(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                S(g, f);
                            }
                            function S(g, f) {
                                return S = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, S(g, f);
                            }
                            function W(g) {
                                vb >= wb.INFOS && console.log("Info: " + g);
                            }
                            function R(g) {
                                vb >= wb.WARNINGS && console.log("Warning: " + g);
                            }
                            function da(g) {
                                throw Error(g);
                            }
                            function Fa(g, f, a) {
                                void 0 === f && (f = null);
                                void 0 === a && (a = null);
                                if (!g) return null;
                                try {
                                    if (a && "string" === typeof g) {
                                        if (a.addDefaultProtocol && g.startsWith("www.")) {
                                            var b = g.match(/\./g);
                                            2 <= (null == b ? void 0 : b.length) && (g = "http://" + g);
                                        }
                                        if (a.tryConvertEncoding) try {
                                            g = decodeURIComponent(escape(g));
                                        } catch (e) {}
                                    }
                                    var c = f ? new URL(g, f) : new URL(g);
                                    a: switch(null == c ? void 0 : c.protocol){
                                        case "http:":
                                        case "https:":
                                        case "ftp:":
                                        case "mailto:":
                                        case "tel:":
                                            var d = !0;
                                            break a;
                                        default:
                                            d = !1;
                                    }
                                    if (d) return c;
                                } catch (e) {}
                                return null;
                            }
                            function qa(g, f, a, b) {
                                void 0 === b && (b = !1);
                                Object.defineProperty(g, f, {
                                    value: a,
                                    enumerable: !b,
                                    configurable: !0,
                                    writable: !1
                                });
                                return a;
                            }
                            function lb(g) {
                                "object" === typeof g && void 0 !== (null == g ? void 0 : g.length) || da("Invalid argument for bytesToString");
                                var f = g.length;
                                if (8192 > f) return String.fromCharCode.apply(null, g);
                                for(var a = [], b = 0; b < f; b += 8192){
                                    var c = g.subarray(b, Math.min(b + 8192, f));
                                    a.push(String.fromCharCode.apply(null, c));
                                }
                                return a.join("");
                            }
                            function Va(g) {
                                "string" !== typeof g && da("Invalid argument for stringToBytes");
                                for(var f = g.length, a = new Uint8Array(f), b = 0; b < f; ++b)a[b] = g.charCodeAt(b) & 255;
                                return a;
                            }
                            function Rb(g) {
                                var f = Object.create(null);
                                g = p.makeIterator(g);
                                for(var a = g.next(); !a.done; a = g.next()){
                                    var b = p.makeIterator(a.value);
                                    a = b.next().value;
                                    b = b.next().value;
                                    f[a] = b;
                                }
                                return f;
                            }
                            function ff(g) {
                                Sb || (Sb = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, $c = new Map([
                                    [
                                        "\uFB05",
                                        "\u017Ft"
                                    ]
                                ]));
                                return g.replaceAll(Sb, function(f, a, b) {
                                    return a ? a.normalize("NFKC") : $c.get(b);
                                });
                            }
                            function gf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                Tb(g, f);
                            }
                            function Tb(g, f) {
                                return Tb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, Tb(g, f);
                            }
                            function ad(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function bd(g, f, a) {
                                return f && ad(g.prototype, f), a && ad(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function cd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function hf(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            cd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            cd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function xb(g, f) {
                                return Ub.apply(this, arguments);
                            }
                            function Ub() {
                                Ub = hf(function b(f, a) {
                                    var c;
                                    return p.generator.createGenerator(b, function(d) {
                                        if (1 == d.nextAddress) return void 0 === a && (a = "text"), yb(f, document.baseURI) ? d.yield(fetch(f), 3) : d.jumpTo(2);
                                        if (2 != d.nextAddress) {
                                            c = d.yieldResult;
                                            if (!c.ok) throw Error(c.statusText);
                                            switch(a){
                                                case "arraybuffer":
                                                    return d.return(c.arrayBuffer());
                                                case "blob":
                                                    return d.return(c.blob());
                                                case "json":
                                                    return d.return(c.json());
                                            }
                                            return d.return(c.text());
                                        }
                                        return d.return(new Promise(function(e, h) {
                                            var k = new XMLHttpRequest;
                                            k.open("GET", f, !0);
                                            k.responseType = a;
                                            k.onreadystatechange = function() {
                                                if (k.readyState === XMLHttpRequest.DONE) {
                                                    if (200 === k.status || 0 === k.status) {
                                                        switch(a){
                                                            case "arraybuffer":
                                                            case "blob":
                                                            case "json":
                                                                e(k.response);
                                                                return;
                                                        }
                                                        e(k.responseText);
                                                    } else h(Error(k.statusText));
                                                }
                                            };
                                            k.send(null);
                                        }));
                                    });
                                });
                                return Ub.apply(this, arguments);
                            }
                            function zb(g) {
                                for(var f = g.length, a = 0; a < f && "" === g[a].trim();)a++;
                                return "data:" === g.substring(a, a + 5).toLowerCase();
                            }
                            function Vb(g) {
                                return "string" === typeof g && /\.pdf$/i.test(g);
                            }
                            function jf(g) {
                                g = p.makeIterator(g.split(/[#?]/, 1)).next().value;
                                return g.substring(g.lastIndexOf("/") + 1);
                            }
                            function kf(g, f) {
                                void 0 === f && (f = "document.pdf");
                                if ("string" !== typeof g) return f;
                                if (zb(g)) return R('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), f;
                                var a = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                                g = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/.exec(g);
                                if (g = a.exec(g[1]) || a.exec(g[2]) || a.exec(g[3])) {
                                    if (g = g[0], g.includes("%")) try {
                                        g = a.exec(decodeURIComponent(g))[0];
                                    } catch (b) {}
                                }
                                return g || f;
                            }
                            function yb(g, f) {
                                try {
                                    var a = (f ? new URL(g, f) : new URL(g)).protocol;
                                    return "http:" === a || "https:" === a;
                                } catch (b) {
                                    return !1;
                                }
                            }
                            function Ma(g) {
                                g.preventDefault();
                            }
                            function dd(g) {
                                console.log("Deprecated API usage: " + g);
                            }
                            function lf(g, f) {
                                var a = void 0 === f.scale ? 1 : f.scale;
                                f = void 0 === f.rotation ? 0 : f.rotation;
                                g = g.attributes.style;
                                var b = g.height;
                                g = [
                                    0,
                                    0,
                                    parseInt(g.width),
                                    parseInt(b)
                                ];
                                return new Wb({
                                    viewBox: g,
                                    scale: a,
                                    rotation: f
                                });
                            }
                            function Xb(g) {
                                if (g.startsWith("#")) return g = parseInt(g.slice(1), 16), [
                                    (g & 16711680) >> 16,
                                    (g & 65280) >> 8,
                                    g & 255
                                ];
                                if (g.startsWith("rgb(")) return g.slice(4, -1).split(",").map(function(f) {
                                    return parseInt(f);
                                });
                                if (g.startsWith("rgba(")) return g.slice(5, -1).split(",").map(function(f) {
                                    return parseInt(f);
                                }).slice(0, 3);
                                R('Not a valid color format: "' + g + '"');
                                return [
                                    0,
                                    0,
                                    0
                                ];
                            }
                            function Ba(g) {
                                g = g.getTransform();
                                return [
                                    g.a,
                                    g.b,
                                    g.c,
                                    g.d,
                                    g.e,
                                    g.f
                                ];
                            }
                            function Sa(g) {
                                g = g.getTransform().invertSelf();
                                return [
                                    g.a,
                                    g.b,
                                    g.c,
                                    g.d,
                                    g.e,
                                    g.f
                                ];
                            }
                            function ab(g, f, a, b) {
                                void 0 === a && (a = !1);
                                void 0 === b && (b = !0);
                                if (f instanceof Wb) {
                                    var c = f.rawDims, d = g.style, e = Ka.isCSSRoundSupported, h = "var(--scale-factor) * " + c.pageWidth + "px";
                                    c = "var(--scale-factor) * " + c.pageHeight + "px";
                                    h = e ? "round(down, " + h + ", var(--scale-round-x, 1px))" : "calc(" + h + ")";
                                    e = e ? "round(down, " + c + ", var(--scale-round-y, 1px))" : "calc(" + c + ")";
                                    a && 0 !== f.rotation % 180 ? (d.width = e, d.height = h) : (d.width = h, d.height = e);
                                }
                                b && g.setAttribute("data-main-rotation", f.rotation);
                            }
                            function ed(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function mf(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            ed(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            ed(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function fd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function nf(g, f, a) {
                                return f && fd(g.prototype, f), a && fd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function gd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Ta(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            gd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            gd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function hd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Ab(g, f, a) {
                                return f && hd(g.prototype, f), a && hd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Bb(g, f, a) {
                                a = p.makeIterator(a);
                                for(var b = a.next(); !b.done; b = a.next())b = b.value, f.addEventListener(b, g[b].bind(g));
                            }
                            function id(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Yb(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            id(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            id(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function jd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function of(g, f, a) {
                                return f && jd(g.prototype, f), a && jd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function pf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                Zb(g, f);
                            }
                            function Zb(g, f) {
                                return Zb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, Zb(g, f);
                            }
                            function kd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Cb(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            kd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            kd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function ld(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function qf(g, f, a) {
                                return f && ld(g.prototype, f), a && ld(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function rf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                $b(g, f);
                            }
                            function $b(g, f) {
                                return $b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, $b(g, f);
                            }
                            function md(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function nd(g, f, a) {
                                return f && md(g.prototype, f), a && md(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function od(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function pd(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            od(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            od(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function qd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function sf(g, f, a) {
                                return f && qd(g.prototype, f), a && qd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function tf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                ac(g, f);
                            }
                            function ac(g, f) {
                                return ac = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, ac(g, f);
                            }
                            function uf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                bc(g, f);
                            }
                            function bc(g, f) {
                                return bc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, bc(g, f);
                            }
                            function rd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function cc(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            rd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            rd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function sd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function vf(g, f, a) {
                                return f && sd(g.prototype, f), a && sd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function wf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                dc(g, f);
                            }
                            function dc(g, f) {
                                return dc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, dc(g, f);
                            }
                            function xf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                ec(g, f);
                            }
                            function ec(g, f) {
                                return ec = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, ec(g, f);
                            }
                            function td(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function fc(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            td(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            td(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function Db(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                gc(g, f);
                            }
                            function gc(g, f) {
                                return gc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, gc(g, f);
                            }
                            function ud(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function yf(g, f, a) {
                                return f && ud(g.prototype, f), a && ud(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function vd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function hc(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            vd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            vd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function wd(g) {
                                return ic.apply(this, arguments);
                            }
                            function ic() {
                                ic = hc(function a(f) {
                                    var b, c;
                                    return p.generator.createGenerator(a, function(d) {
                                        if (1 == d.nextAddress) return b = bb.get("fs"), d.yield(b.promises.readFile(f), 2);
                                        c = d.yieldResult;
                                        return d.return(new Uint8Array(c));
                                    });
                                });
                                return ic.apply(this, arguments);
                            }
                            function jc(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                kc(g, f);
                            }
                            function kc(g, f) {
                                return kc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, kc(g, f);
                            }
                            function lc(g, f) {
                                if (f) {
                                    var a = f[2] - f[0], b = f[3] - f[1], c = new Path2D;
                                    c.rect(f[0], f[1], a, b);
                                    g.clip(c);
                                }
                            }
                            function mc(g, f, a, b, c, d, e, h) {
                                var k = f.coords, l = f.colors, m = g.data;
                                g = 4 * g.width;
                                if (k[a + 1] > k[b + 1]) {
                                    var n = a;
                                    a = b;
                                    b = n;
                                    n = d;
                                    d = e;
                                    e = n;
                                }
                                k[b + 1] > k[c + 1] && (n = b, b = c, c = n, n = e, e = h, h = n);
                                k[a + 1] > k[b + 1] && (n = a, a = b, b = n, n = d, d = e, e = n);
                                n = (k[a] + f.offsetX) * f.scaleX;
                                a = (k[a + 1] + f.offsetY) * f.scaleY;
                                var q = (k[b] + f.offsetX) * f.scaleX;
                                b = (k[b + 1] + f.offsetY) * f.scaleY;
                                var r = (k[c] + f.offsetX) * f.scaleX;
                                f = (k[c + 1] + f.offsetY) * f.scaleY;
                                if (!(a >= f)) {
                                    c = l[d];
                                    k = l[d + 1];
                                    d = l[d + 2];
                                    var t = l[e], u = l[e + 1];
                                    e = l[e + 2];
                                    var v = l[h], w = l[h + 1];
                                    h = l[h + 2];
                                    l = Math.round(f);
                                    for(var x, B, z, C, D, H, J, M, I = Math.round(a); I <= l; I++){
                                        I < b ? (C = I < a ? 0 : (a - I) / (a - b), x = n - (n - q) * C, B = c - (c - t) * C, z = k - (k - u) * C, C = d - (d - e) * C) : (C = I > f ? 1 : b === f ? 0 : (b - I) / (b - f), x = q - (q - r) * C, B = t - (t - v) * C, z = u - (u - w) * C, C = e - (e - h) * C);
                                        var P = I < a ? 0 : I > f ? 1 : (a - I) / (a - f);
                                        D = n - (n - r) * P;
                                        H = c - (c - v) * P;
                                        J = k - (k - w) * P;
                                        M = d - (d - h) * P;
                                        P = Math.round(Math.min(x, D));
                                        for(var L = Math.round(Math.max(x, D)), T = g * I + 4 * P, aa = P; aa <= L; aa++)P = (x - aa) / (x - D), 0 > P ? P = 0 : 1 < P && (P = 1), m[T++] = B - (B - H) * P | 0, m[T++] = z - (z - J) * P | 0, m[T++] = C - (C - M) * P | 0, m[T++] = 255;
                                    }
                                }
                            }
                            function xd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function zf(g, f, a) {
                                return f && xd(g.prototype, f), a && xd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Af(g, f) {
                                if (g._removeMirroring) throw Error("Context is already forwarding operations.");
                                g.__originalSave = g.save;
                                g.__originalRestore = g.restore;
                                g.__originalRotate = g.rotate;
                                g.__originalScale = g.scale;
                                g.__originalTranslate = g.translate;
                                g.__originalTransform = g.transform;
                                g.__originalSetTransform = g.setTransform;
                                g.__originalResetTransform = g.resetTransform;
                                g.__originalClip = g.clip;
                                g.__originalMoveTo = g.moveTo;
                                g.__originalLineTo = g.lineTo;
                                g.__originalBezierCurveTo = g.bezierCurveTo;
                                g.__originalRect = g.rect;
                                g.__originalClosePath = g.closePath;
                                g.__originalBeginPath = g.beginPath;
                                g._removeMirroring = function() {
                                    g.save = g.__originalSave;
                                    g.restore = g.__originalRestore;
                                    g.rotate = g.__originalRotate;
                                    g.scale = g.__originalScale;
                                    g.translate = g.__originalTranslate;
                                    g.transform = g.__originalTransform;
                                    g.setTransform = g.__originalSetTransform;
                                    g.resetTransform = g.__originalResetTransform;
                                    g.clip = g.__originalClip;
                                    g.moveTo = g.__originalMoveTo;
                                    g.lineTo = g.__originalLineTo;
                                    g.bezierCurveTo = g.__originalBezierCurveTo;
                                    g.rect = g.__originalRect;
                                    g.closePath = g.__originalClosePath;
                                    g.beginPath = g.__originalBeginPath;
                                    delete g._removeMirroring;
                                };
                                g.save = function() {
                                    f.save();
                                    this.__originalSave();
                                };
                                g.restore = function() {
                                    f.restore();
                                    this.__originalRestore();
                                };
                                g.translate = function(a, b) {
                                    f.translate(a, b);
                                    this.__originalTranslate(a, b);
                                };
                                g.scale = function(a, b) {
                                    f.scale(a, b);
                                    this.__originalScale(a, b);
                                };
                                g.transform = function(a, b, c, d, e, h) {
                                    f.transform(a, b, c, d, e, h);
                                    this.__originalTransform(a, b, c, d, e, h);
                                };
                                g.setTransform = function(a, b, c, d, e, h) {
                                    f.setTransform(a, b, c, d, e, h);
                                    this.__originalSetTransform(a, b, c, d, e, h);
                                };
                                g.resetTransform = function() {
                                    f.resetTransform();
                                    this.__originalResetTransform();
                                };
                                g.rotate = function(a) {
                                    f.rotate(a);
                                    this.__originalRotate(a);
                                };
                                g.clip = function(a) {
                                    f.clip(a);
                                    this.__originalClip(a);
                                };
                                g.moveTo = function(a, b) {
                                    f.moveTo(a, b);
                                    this.__originalMoveTo(a, b);
                                };
                                g.lineTo = function(a, b) {
                                    f.lineTo(a, b);
                                    this.__originalLineTo(a, b);
                                };
                                g.bezierCurveTo = function(a, b, c, d, e, h) {
                                    f.bezierCurveTo(a, b, c, d, e, h);
                                    this.__originalBezierCurveTo(a, b, c, d, e, h);
                                };
                                g.rect = function(a, b, c, d) {
                                    f.rect(a, b, c, d);
                                    this.__originalRect(a, b, c, d);
                                };
                                g.closePath = function() {
                                    f.closePath();
                                    this.__originalClosePath();
                                };
                                g.beginPath = function() {
                                    f.beginPath();
                                    this.__originalBeginPath();
                                };
                            }
                            function Eb(g, f, a, b, c, d, e, h, k, l) {
                                var m = p.makeIterator(Ba(g)), n = m.next().value, q = m.next().value, r = m.next().value, t = m.next().value, u = m.next().value;
                                m = m.next().value;
                                if (0 === q && 0 === r) {
                                    var v = Math.round(e * n + u), w = Math.round(h * t + m);
                                    e = Math.abs(Math.round((e + k) * n + u) - v) || 1;
                                    h = Math.abs(Math.round((h + l) * t + m) - w) || 1;
                                    g.setTransform(Math.sign(n), 0, 0, Math.sign(t), v, w);
                                    g.drawImage(f, a, b, c, d, 0, 0, e, h);
                                    g.setTransform(n, q, r, t, u, m);
                                    return [
                                        e,
                                        h
                                    ];
                                }
                                if (0 === n && 0 === t) return v = Math.round(h * r + u), w = Math.round(e * q + m), h = Math.abs(Math.round((h + l) * r + u) - v) || 1, e = Math.abs(Math.round((e + k) * q + m) - w) || 1, g.setTransform(0, Math.sign(q), Math.sign(r), 0, v, w), g.drawImage(f, a, b, c, d, 0, 0, e, h), g.setTransform(n, q, r, t, u, m), [
                                    e,
                                    h
                                ];
                                g.drawImage(f, a, b, c, d, e, h, k, l);
                                return [
                                    Math.hypot(n, q) * k,
                                    Math.hypot(r, t) * l
                                ];
                            }
                            function Bf(g) {
                                var f = g.width, a = g.height;
                                if (1E3 < f || 1E3 < a) return null;
                                var b = new Uint8Array([
                                    0,
                                    2,
                                    4,
                                    0,
                                    1,
                                    0,
                                    5,
                                    4,
                                    8,
                                    10,
                                    0,
                                    8,
                                    0,
                                    2,
                                    1,
                                    0
                                ]), c = f + 1, d = new Uint8Array(c * (a + 1)), e, h = f + 7 & -8, k = new Uint8Array(h * a), l = 0;
                                g = p.makeIterator(g.data);
                                for(var m = g.next(); !m.done; m = g.next())for(m = m.value, e = 128; 0 < e;)k[l++] = m & e ? 0 : 255, e >>= 1;
                                l = m = 0;
                                0 !== k[l] && (d[0] = 1, ++m);
                                for(e = 1; e < f; e++)k[l] !== k[l + 1] && (d[e] = k[l] ? 2 : 1, ++m), l++;
                                0 !== k[l] && (d[e] = 2, ++m);
                                for(g = 1; g < a; g++){
                                    l = g * h;
                                    var n = g * c;
                                    k[l - h] !== k[l] && (d[n] = k[l] ? 1 : 8, ++m);
                                    var q = (k[l] ? 4 : 0) + (k[l - h] ? 8 : 0);
                                    for(e = 1; e < f; e++)q = (q >> 2) + (k[l + 1] ? 4 : 0) + (k[l - h + 1] ? 8 : 0), b[q] && (d[n + e] = b[q], ++m), l++;
                                    k[l - h] !== k[l] && (d[n + e] = k[l] ? 2 : 4, ++m);
                                    if (1E3 < m) return null;
                                }
                                l = h * (a - 1);
                                n = g * c;
                                0 !== k[l] && (d[n] = 8, ++m);
                                for(e = 1; e < f; e++)k[l] !== k[l + 1] && (d[n + e] = k[l] ? 4 : 8, ++m), l++;
                                0 !== k[l] && (d[n + e] = 4, ++m);
                                if (1E3 < m) return null;
                                b = new Int32Array([
                                    0,
                                    c,
                                    -1,
                                    0,
                                    -c,
                                    0,
                                    0,
                                    0,
                                    1
                                ]);
                                var r = new Path2D;
                                for(g = 0; m && g <= a; g++){
                                    h = g * c;
                                    for(k = h + f; h < k && !d[h];)h++;
                                    if (h !== k) {
                                        r.moveTo(h % c, g);
                                        k = h;
                                        l = d[h];
                                        do {
                                            e = b[l];
                                            do h += e;
                                            while (!d[h]);
                                            e = d[h];
                                            5 !== e && 10 !== e ? (l = e, d[h] = 0) : (l = e & 51 * l >> 4, d[h] &= l >> 2 | l << 2);
                                            r.lineTo(h % c, h / c | 0);
                                            d[h] || --m;
                                        }while (k !== h);
                                        --g;
                                    }
                                }
                                d = k = null;
                                return function(t) {
                                    t.save();
                                    t.scale(1 / f, -1 / a);
                                    t.translate(0, -a);
                                    t.fill(r);
                                    t.beginPath();
                                    t.restore();
                                };
                            }
                            function yd(g, f) {
                                if ("undefined" !== typeof ImageData && f instanceof ImageData) g.putImageData(f, 0, 0);
                                else {
                                    var a = f.height, b = f.width, c = a % 16;
                                    a = (a - c) / 16;
                                    var d = 0 === c ? a : a + 1, e = g.createImageData(b, 16), h = 0, k = f.data, l = e.data, m, n;
                                    if (f.kind === Fb.GRAYSCALE_1BPP) {
                                        var q = k.byteLength;
                                        l = new Uint32Array(l.buffer, 0, l.byteLength >> 2);
                                        var r = l.length, t = b + 7 >> 3, u = Ka.isLittleEndian ? 4278190080 : 255;
                                        for(m = 0; m < d; m++){
                                            var v = m < a ? 16 : c;
                                            for(n = f = 0; n < v; n++){
                                                var w = q - h, x = 0;
                                                w = w > t ? b : 8 * w - 7;
                                                for(var B = w & -8, z = 0, C = 0; x < B; x += 8)C = k[h++], l[f++] = C & 128 ? 4294967295 : u, l[f++] = C & 64 ? 4294967295 : u, l[f++] = C & 32 ? 4294967295 : u, l[f++] = C & 16 ? 4294967295 : u, l[f++] = C & 8 ? 4294967295 : u, l[f++] = C & 4 ? 4294967295 : u, l[f++] = C & 2 ? 4294967295 : u, l[f++] = C & 1 ? 4294967295 : u;
                                                for(; x < w; x++)0 === z && (C = k[h++], z = 128), l[f++] = C & z ? 4294967295 : u, z >>= 1;
                                            }
                                            for(; f < r;)l[f++] = 0;
                                            g.putImageData(e, 0, 16 * m);
                                        }
                                    } else if (f.kind === Fb.RGBA_32BPP) {
                                        n = 0;
                                        v = 64 * b;
                                        for(m = 0; m < a; m++)l.set(k.subarray(h, h + v)), h += v, g.putImageData(e, 0, n), n += 16;
                                        m < d && (l.set(k.subarray(h, h + b * c * 4)), g.putImageData(e, 0, n));
                                    } else if (f.kind === Fb.RGB_24BPP) for(v = 16 * b, m = 0; m < d; m++){
                                        m >= a && (v = c, v *= b);
                                        f = 0;
                                        for(n = v; n--;)l[f++] = k[h++], l[f++] = k[h++], l[f++] = k[h++], l[f++] = 255;
                                        g.putImageData(e, 0, 16 * m);
                                    }
                                    else throw Error("bad image kind: " + f.kind);
                                }
                            }
                            function zd(g, f) {
                                if (f.bitmap) g.drawImage(f.bitmap, 0, 0);
                                else {
                                    var a = f.height, b = f.width, c = a % 16;
                                    a = (a - c) / 16;
                                    var d = 0 === c ? a : a + 1, e = g.createImageData(b, 16);
                                    var h = 0;
                                    f = f.data;
                                    for(var k = e.data, l = 0; l < d; l++){
                                        var m = {
                                            src: f,
                                            srcPos: h,
                                            dest: k,
                                            width: b,
                                            height: l < a ? 16 : c,
                                            nonBlackColor: 0
                                        };
                                        h = m.src;
                                        var n = void 0 === m.srcPos ? 0 : m.srcPos, q = m.dest, r = m.width, t = m.height, u = void 0 === m.nonBlackColor ? 4294967295 : m.nonBlackColor, v = Ka.isLittleEndian ? 4278190080 : 255;
                                        u = p.makeIterator((void 0 === m.inverseDecode ? 0 : m.inverseDecode) ? [
                                            u,
                                            v
                                        ] : [
                                            v,
                                            u
                                        ]);
                                        m = u.next().value;
                                        u = u.next().value;
                                        v = r >> 3;
                                        r &= 7;
                                        var w = h.length;
                                        q = new Uint32Array(q.buffer);
                                        for(var x = 0, B = 0; B < t; B++){
                                            for(var z = n + v; n < z; n++){
                                                var C = n < w ? h[n] : 255;
                                                q[x++] = C & 128 ? u : m;
                                                q[x++] = C & 64 ? u : m;
                                                q[x++] = C & 32 ? u : m;
                                                q[x++] = C & 16 ? u : m;
                                                q[x++] = C & 8 ? u : m;
                                                q[x++] = C & 4 ? u : m;
                                                q[x++] = C & 2 ? u : m;
                                                q[x++] = C & 1 ? u : m;
                                            }
                                            if (0 !== r) for(z = n < w ? h[n++] : 255, C = 0; C < r; C++)q[x++] = z & 1 << 7 - C ? u : m;
                                        }
                                        h = n;
                                        g.putImageData(e, 0, 16 * l);
                                    }
                                }
                            }
                            function qb(g, f) {
                                for(var a = p.makeIterator("strokeStyle fillStyle fillRule globalAlpha lineWidth lineCap lineJoin miterLimit globalCompositeOperation font filter".split(" ")), b = a.next(); !b.done; b = a.next())b = b.value, void 0 !== g[b] && (f[b] = g[b]);
                                void 0 !== g.setLineDash && (f.setLineDash(g.getLineDash()), f.lineDashOffset = g.lineDashOffset);
                            }
                            function Gb(g) {
                                g.strokeStyle = g.fillStyle = "#000000";
                                g.fillRule = "nonzero";
                                g.globalAlpha = 1;
                                g.lineWidth = 1;
                                g.lineCap = "butt";
                                g.lineJoin = "miter";
                                g.miterLimit = 10;
                                g.globalCompositeOperation = "source-over";
                                g.font = "10px sans-serif";
                                void 0 !== g.setLineDash && (g.setLineDash([]), g.lineDashOffset = 0);
                                var f = g.filter;
                                "none" !== f && "" !== f && (g.filter = "none");
                            }
                            function Ad(g, f) {
                                if (f) return !0;
                                g = fa.singularValueDecompose2dScale(g);
                                g[0] = Math.fround(g[0]);
                                g[1] = Math.fround(g[1]);
                                f = Math.fround((globalThis.devicePixelRatio || 1) * E.PDF_TO_CSS_UNITS);
                                return g[0] <= f && g[1] <= f;
                            }
                            function Bd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Cf(g, f, a) {
                                return f && Bd(g.prototype, f), a && Bd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Cd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Df(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            Cd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            Cd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function La(g) {
                                g instanceof Error || "object" === typeof g && null !== g || da('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                                switch(g.name){
                                    case "AbortException":
                                        return new cb(g.message);
                                    case "MissingPDFException":
                                        return new db(g.message);
                                    case "PasswordException":
                                        return new nc(g.message, g.code);
                                    case "UnexpectedResponseException":
                                        return new Hb(g.message, g.status);
                                    case "UnknownErrorException":
                                        return new oc(g.message, g.details);
                                    default:
                                        return new oc(g.message, g.toString());
                                }
                            }
                            function Dd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Ed(g, f, a) {
                                return f && Dd(g.prototype, f), a && Dd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Fd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Gd(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            Fd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            Fd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function Hd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function pc(g, f, a) {
                                return f && Hd(g.prototype, f), a && Hd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Ef(g) {
                                function f(l, m) {
                                    return new RegExp("(?:^|;)\\s*" + l + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', m);
                                }
                                function a(l, m) {
                                    if (l) {
                                        if (!/^[\x00-\xFF]+$/.test(m)) return m;
                                        try {
                                            var n = new TextDecoder(l, {
                                                fatal: !0
                                            }), q = Va(m);
                                            m = n.decode(q);
                                            h = !1;
                                        } catch (r) {}
                                    }
                                    return m;
                                }
                                function b(l) {
                                    h && /[\x80-\xff]/.test(l) && (l = a("utf-8", l), h && (l = a("iso-8859-1", l)));
                                    return l;
                                }
                                function c(l) {
                                    if (l.startsWith('"')) {
                                        l = l.slice(1).split('\\"');
                                        for(var m = 0; m < l.length; ++m){
                                            var n = l[m].indexOf('"');
                                            -1 !== n && (l[m] = l[m].slice(0, n), l.length = m + 1);
                                            l[m] = l[m].replaceAll(/\\(.)/g, "$1");
                                        }
                                        l = l.join('"');
                                    }
                                    return l;
                                }
                                function d(l) {
                                    var m = l.indexOf("'");
                                    if (-1 === m) return l;
                                    var n = l.slice(0, m);
                                    l = l.slice(m + 1).replace(/^[^']*'/, "");
                                    return a(n, l);
                                }
                                function e(l) {
                                    return !l.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(l) ? l : l.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(m, n, q, r) {
                                        if ("q" === q || "Q" === q) return r = r.replaceAll("_", " "), r = r.replaceAll(/=([0-9a-fA-F]{2})/g, function(t, u) {
                                            return String.fromCharCode(parseInt(u, 16));
                                        }), a(n, r);
                                        try {
                                            r = atob(r);
                                        } catch (t) {}
                                        return a(n, r);
                                    });
                                }
                                var h = !0, k = f("filename\\*", "i").exec(g);
                                return k ? (k = k[1], g = c(k), g = unescape(g), g = d(g), g = e(g), b(g)) : (k = function(l) {
                                    for(var m = [], n, q = f("filename\\*((?!0\\d)\\d+)(\\*?)", "ig"); null !== (n = q.exec(l));){
                                        var r = p.makeIterator(n);
                                        r.next();
                                        n = r.next().value;
                                        var t = r.next().value;
                                        r = r.next().value;
                                        n = parseInt(n, 10);
                                        if (n in m) {
                                            if (0 === n) break;
                                        } else m[n] = [
                                            t,
                                            r
                                        ];
                                    }
                                    l = [];
                                    for(q = 0; q < m.length && (q in m); ++q)t = p.makeIterator(m[q]), n = t.next().value, t = t.next().value, t = c(t), n && (t = unescape(t), 0 === q && (t = d(t))), l.push(t);
                                    return l.join("");
                                }(g)) ? (g = e(k), b(g)) : (k = f("filename", "i").exec(g)) ? (k = k[1], g = c(k), g = e(g), b(g)) : "";
                            }
                            function qc(g, f) {
                                var a = new Headers;
                                if (!g || !f || "object" !== typeof f) return a;
                                for(var b in f)g = f[b], void 0 !== g && a.append(b, g);
                                return a;
                            }
                            function rc(g) {
                                var f = g.responseHeaders, a = g.isHttp, b = g.rangeChunkSize;
                                g = g.disableRange;
                                var c = {
                                    allowRangeRequests: !1,
                                    suggestedLength: void 0
                                }, d = parseInt(f.get("Content-Length"), 10);
                                if (!Number.isInteger(d)) return c;
                                c.suggestedLength = d;
                                if (d <= 2 * b || g || !a || "bytes" !== f.get("Accept-Ranges") || "identity" !== (f.get("Content-Encoding") || "identity")) return c;
                                c.allowRangeRequests = !0;
                                return c;
                            }
                            function sc(g) {
                                if (g = g.get("Content-Disposition")) {
                                    g = Ef(g);
                                    if (g.includes("%")) try {
                                        g = decodeURIComponent(g);
                                    } catch (f) {}
                                    if (Vb(g)) return g;
                                }
                                return null;
                            }
                            function Ib(g, f) {
                                return 404 === g || 0 === g && f.startsWith("file:") ? new db('Missing PDF "' + f + '".') : new Hb("Unexpected server response (" + g + ') while retrieving PDF "' + f + '".', g);
                            }
                            function Id(g) {
                                return 200 === g || 206 === g;
                            }
                            function Jd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Kd(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            Jd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            Jd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function Ld(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function tc(g, f, a) {
                                return f && Ld(g.prototype, f), a && Ld(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Md(g, f, a) {
                                return {
                                    method: "GET",
                                    headers: g,
                                    signal: a.signal,
                                    mode: "cors",
                                    credentials: f ? "include" : "same-origin",
                                    redirect: "follow"
                                };
                            }
                            function Nd(g) {
                                if (g instanceof Uint8Array) return g.buffer;
                                if (g instanceof ArrayBuffer) return g;
                                R("getArrayBuffer - unexpected data format: " + g);
                                return new Uint8Array(g).buffer;
                            }
                            function Od(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Pd(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            Od(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            Od(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function Qd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Rd(g, f, a) {
                                return f && Qd(g.prototype, f), a && Qd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Jb(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                uc(g, f);
                            }
                            function uc(g, f) {
                                return uc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, uc(g, f);
                            }
                            function Sd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Td(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            Sd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            Sd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function Ud(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function vc(g, f, a) {
                                return f && Ud(g.prototype, f), a && Ud(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Vd(g, f, a) {
                                return "http:" === g.protocol ? bb.get("http").request(g, {
                                    headers: f
                                }, a) : bb.get("https").request(g, {
                                    headers: f
                                }, a);
                            }
                            function Wd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Ff(g, f, a) {
                                return f && Wd(g.prototype, f), a && Wd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Xd(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function eb(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            Xd(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            Xd(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function Yd(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function fb(g, f, a) {
                                return f && Yd(g.prototype, f), a && Yd(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Gf(g) {
                                var f, a, b;
                                void 0 === g && (g = {});
                                if ("string" === typeof g || g instanceof URL) g = {
                                    url: g
                                };
                                else if (g instanceof ArrayBuffer || ArrayBuffer.isView(g)) g = {
                                    data: g
                                };
                                var c = new Zd, d = c.docId, e = g.url ? Hf(g.url) : null, h = g.data ? If(g.data) : null, k = g.httpHeaders || null, l = !0 === g.withCredentials, m = null != (f = g.password) ? f : null, n = g.range instanceof $d ? g.range : null, q = Number.isInteger(g.rangeChunkSize) && 0 < g.rangeChunkSize ? g.rangeChunkSize : 65536, r = g.worker instanceof Wa ? g.worker : null, t = g.verbosity;
                                f = "string" !== typeof g.docBaseUrl || zb(g.docBaseUrl) ? null : g.docBaseUrl;
                                var u = "string" === typeof g.cMapUrl ? g.cMapUrl : null, v = !1 !== g.cMapPacked, w = g.CMapReaderFactory || Jf, x = "string" === typeof g.standardFontDataUrl ? g.standardFontDataUrl : null, B = g.StandardFontDataFactory || Kf, z = !0 !== g.stopAtErrors, C = Number.isInteger(g.maxImageSize) && -1 < g.maxImageSize ? g.maxImageSize : -1, D = !1 !== g.isEvalSupported, H = "boolean" === typeof g.isOffscreenCanvasSupported ? g.isOffscreenCanvasSupported : !0, J = "boolean" === typeof g.isChrome ? g.isChrome : !Ka.platform.isFirefox && "undefined" !== typeof window && !(null == (a = window) || !a.chrome);
                                a = Number.isInteger(g.canvasMaxAreaInBytes) ? g.canvasMaxAreaInBytes : -1;
                                var M = "boolean" === typeof g.disableFontFace ? g.disableFontFace : !1, I = !0 === g.fontExtraProperties, P = !0 === g.enableXfa, L = g.ownerDocument || globalThis.document, T = !0 === g.disableRange, aa = !0 === g.disableStream, ba = !0 === g.disableAutoFetch, ra = !0 === g.pdfBug, X = g.CanvasFactory || Lf, ma = g.FilterFactory || Mf, U = !0 === g.enableHWA, K = n ? n.length : null != (b = g.length) ? b : NaN;
                                b = "boolean" === typeof g.useSystemFonts ? g.useSystemFonts : !M;
                                var N = "boolean" === typeof g.useWorkerFetch ? g.useWorkerFetch : w === ae && B === be && u && x && yb(u, document.baseURI) && yb(x, document.baseURI);
                                g.canvasFactory && dd("`canvasFactory`-instance option, please use `CanvasFactory` instead.");
                                g.filterFactory && dd("`filterFactory`-instance option, please use `FilterFactory` instead.");
                                Number.isInteger(t) && (vb = t);
                                var V = {
                                    canvasFactory: new X({
                                        ownerDocument: L,
                                        enableHWA: U
                                    }),
                                    filterFactory: new ma({
                                        docId: d,
                                        ownerDocument: L
                                    }),
                                    cMapReaderFactory: N ? null : new w({
                                        baseUrl: u,
                                        isCompressed: v
                                    }),
                                    standardFontDataFactory: N ? null : new B({
                                        baseUrl: x
                                    })
                                };
                                r || (g = {
                                    verbosity: t,
                                    port: mb.workerPort
                                }, r = g.port ? Wa.fromPort(g) : new Wa(g), c._worker = r);
                                var ea = {
                                    docId: d,
                                    apiVersion: "4.8.73",
                                    data: h,
                                    password: m,
                                    disableAutoFetch: ba,
                                    rangeChunkSize: q,
                                    length: K,
                                    docBaseUrl: f,
                                    enableXfa: P,
                                    evaluatorOptions: {
                                        maxImageSize: C,
                                        disableFontFace: M,
                                        ignoreErrors: z,
                                        isEvalSupported: D,
                                        isOffscreenCanvasSupported: H,
                                        isChrome: J,
                                        canvasMaxAreaInBytes: a,
                                        fontExtraProperties: I,
                                        useSystemFonts: b,
                                        cMapUrl: N ? u : null,
                                        standardFontDataUrl: N ? x : null
                                    }
                                }, ia = {
                                    disableFontFace: M,
                                    fontExtraProperties: I,
                                    ownerDocument: L,
                                    pdfBug: ra,
                                    styleElement: null,
                                    loadingParams: {
                                        disableAutoFetch: ba,
                                        enableXfa: P
                                    }
                                };
                                r.promise.then(function() {
                                    if (c.destroyed) throw Error("Loading aborted");
                                    if (r.destroyed) throw Error("Worker was destroyed");
                                    var na = r.messageHandler.sendWithPromise("GetDocRequest", ea, h ? [
                                        h.buffer
                                    ] : null);
                                    if (n) var ua = new Nf(n, {
                                        disableRange: T,
                                        disableStream: aa
                                    });
                                    else if (!h) {
                                        if (!e) throw Error("getDocument - no `url` parameter provided.");
                                        ua = new (yb(e) ? Of : Pf)({
                                            url: e,
                                            length: K,
                                            httpHeaders: k,
                                            withCredentials: l,
                                            rangeChunkSize: q,
                                            disableRange: T,
                                            disableStream: aa
                                        });
                                    }
                                    return na.then(function(va) {
                                        if (c.destroyed) throw Error("Loading aborted");
                                        if (r.destroyed) throw Error("Worker was destroyed");
                                        va = new rb(d, va, r.port);
                                        var za = new Qf(va, c, ua, ia, V);
                                        c._transport = za;
                                        va.send("Ready", null);
                                    });
                                }).catch(c._capability.reject);
                                return c;
                            }
                            function Hf(g) {
                                if (g instanceof URL) return g.href;
                                try {
                                    return new URL(g, window.location).href;
                                } catch (f) {}
                                throw Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                            }
                            function If(g) {
                                if (g instanceof Uint8Array && g.byteLength === g.buffer.byteLength) return g;
                                if ("string" === typeof g) return Va(g);
                                if (g instanceof ArrayBuffer || ArrayBuffer.isView(g) || "object" === typeof g && !isNaN(null == g ? void 0 : g.length)) return new Uint8Array(g);
                                throw Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                            }
                            function ce(g) {
                                return "object" === typeof g && Number.isInteger(null == g ? void 0 : g.num) && 0 <= g.num && Number.isInteger(null == g ? void 0 : g.gen) && 0 <= g.gen;
                            }
                            function de(g) {
                                return Math.floor(255 * Math.max(0, Math.min(1, g))).toString(16).padStart(2, "0");
                            }
                            function sb(g) {
                                return Math.max(0, Math.min(255, 255 * g));
                            }
                            function Rf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                wc(g, f);
                            }
                            function wc(g, f) {
                                return wc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, wc(g, f);
                            }
                            function ee(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function fe(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            ee(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            ee(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function Aa(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                xc(g, f);
                            }
                            function xc(g, f) {
                                return xc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, xc(g, f);
                            }
                            function ge(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function he(g, f, a) {
                                return f && ge(g.prototype, f), a && ge(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Ua(g) {
                                return {
                                    width: g[2] - g[0],
                                    height: g[3] - g[1]
                                };
                            }
                            function ie(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Sf(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            ie(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            ie(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function je(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Tf(g, f, a) {
                                return f && je(g.prototype, f), a && je(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Uf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                yc(g, f);
                            }
                            function yc(g, f) {
                                return yc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, yc(g, f);
                            }
                            function ke(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Vf(g, f, a) {
                                return f && ke(g.prototype, f), a && ke(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function le(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Wf(g, f, a) {
                                return f && le(g.prototype, f), a && le(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Xf(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                zc(g, f);
                            }
                            function zc(g, f) {
                                return zc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, zc(g, f);
                            }
                            function me(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Ac(g, f, a) {
                                return f && me(g.prototype, f), a && me(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function Bc(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                Cc(g, f);
                            }
                            function Cc(g, f) {
                                return Cc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, Cc(g, f);
                            }
                            function ne(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Yf(g, f, a) {
                                return f && ne(g.prototype, f), a && ne(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function oe(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function pe(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            oe(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            oe(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function qe(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function Zf(g, f, a) {
                                return f && qe(g.prototype, f), a && qe(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function $f(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                Dc(g, f);
                            }
                            function Dc(g, f) {
                                return Dc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, Dc(g, f);
                            }
                            function re(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function ag(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            re(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            re(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function se(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function bg(g, f, a) {
                                return f && se(g.prototype, f), a && se(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function cg(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                Ec(g, f);
                            }
                            function Ec(g, f) {
                                return Ec = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, Ec(g, f);
                            }
                            function te(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function Fc(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            te(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            te(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function ue(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function dg(g, f, a) {
                                return f && ue(g.prototype, f), a && ue(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function eg(g, f) {
                                g.prototype = Object.create(f.prototype);
                                g.prototype.constructor = g;
                                Gc(g, f);
                            }
                            function Gc(g, f) {
                                return Gc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, b) {
                                    return a.__proto__ = b, a;
                                }, Gc(g, f);
                            }
                            function ve(g, f, a, b, c, d, e) {
                                try {
                                    var h = g[d](e), k = h.value;
                                } catch (l) {
                                    return void a(l);
                                }
                                h.done ? f(k) : Promise.resolve(k).then(b, c);
                            }
                            function we(g) {
                                return function() {
                                    var f = this, a = arguments;
                                    return new Promise(function(b, c) {
                                        function d(k) {
                                            ve(h, b, c, d, e, "next", k);
                                        }
                                        function e(k) {
                                            ve(h, b, c, d, e, "throw", k);
                                        }
                                        var h = g.apply(f, a);
                                        d(void 0);
                                    });
                                };
                            }
                            function xe(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function fg(g, f, a) {
                                return f && xe(g.prototype, f), a && xe(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            function ye(g, f) {
                                for(var a = 0; a < f.length; a++){
                                    var b = f[a];
                                    b.enumerable = b.enumerable || !1;
                                    b.configurable = !0;
                                    "value" in b && (b.writable = !0);
                                    var c = Object, d = c.defineProperty;
                                    a: {
                                        var e = b.key;
                                        if ("object" == typeof e && e) {
                                            var h = e[Symbol.toPrimitive];
                                            if (void 0 !== h) {
                                                e = h.call(e, "string");
                                                if ("object" != typeof e) break a;
                                                throw new TypeError("@@toPrimitive must return a primitive value.");
                                            }
                                            e = String(e);
                                        }
                                    }
                                    d.call(c, g, "symbol" == typeof e ? e : e + "", b);
                                }
                            }
                            function gg(g, f, a) {
                                return f && ye(g.prototype, f), a && ye(g, a), Object.defineProperty(g, "prototype", {
                                    writable: !1
                                }), g;
                            }
                            var ef = {
                                9306: function(g, f, a) {
                                    var b = a(4901), c = a(6823), d = TypeError;
                                    g.exports = function(e) {
                                        if (b(e)) return e;
                                        throw new d(c(e) + " is not a function");
                                    };
                                },
                                5548: function(g, f, a) {
                                    var b = a(3517), c = a(6823), d = TypeError;
                                    g.exports = function(e) {
                                        if (b(e)) return e;
                                        throw new d(c(e) + " is not a constructor");
                                    };
                                },
                                3506: function(g, f, a) {
                                    var b = a(3925), c = String, d = TypeError;
                                    g.exports = function(e) {
                                        if (b(e)) return e;
                                        throw new d("Can't set " + c(e) + " as a prototype");
                                    };
                                },
                                7080: function(g, f, a) {
                                    var b = a(4402).has;
                                    g.exports = function(c) {
                                        b(c);
                                        return c;
                                    };
                                },
                                6469: function(g, f, a) {
                                    f = a(8227);
                                    var b = a(2360);
                                    a = a(4913).f;
                                    var c = f("unscopables"), d = Array.prototype;
                                    void 0 === d[c] && a(d, c, {
                                        configurable: !0,
                                        value: b(null)
                                    });
                                    g.exports = function(e) {
                                        d[c][e] = !0;
                                    };
                                },
                                7829: function(g, f, a) {
                                    var b = a(8183).charAt;
                                    g.exports = function(c, d, e) {
                                        return d + (e ? b(c, d).length : 1);
                                    };
                                },
                                679: function(g, f, a) {
                                    var b = a(1625), c = TypeError;
                                    g.exports = function(d, e) {
                                        if (b(e, d)) return d;
                                        throw new c("Incorrect invocation");
                                    };
                                },
                                8551: function(g, f, a) {
                                    var b = a(34), c = String, d = TypeError;
                                    g.exports = function(e) {
                                        if (b(e)) return e;
                                        throw new d(c(e) + " is not an object");
                                    };
                                },
                                7811: function(g) {
                                    g.exports = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
                                },
                                7394: function(g, f, a) {
                                    f = a(4576);
                                    var b = a(6706), c = a(2195);
                                    a = f.ArrayBuffer;
                                    var d = f.TypeError;
                                    g.exports = a && b(a.prototype, "byteLength", "get") || function(e) {
                                        if ("ArrayBuffer" !== c(e)) throw new d("ArrayBuffer expected");
                                        return e.byteLength;
                                    };
                                },
                                3238: function(g, f, a) {
                                    var b = a(4576);
                                    f = a(7476);
                                    var c = a(7394), d = (a = (a = b.ArrayBuffer) && a.prototype) && f(a.slice);
                                    g.exports = function(e) {
                                        if (0 !== c(e) || !d) return !1;
                                        try {
                                            return d(e, 0, 0), !1;
                                        } catch (h) {
                                            return !0;
                                        }
                                    };
                                },
                                5169: function(g, f, a) {
                                    var b = a(3238), c = TypeError;
                                    g.exports = function(d) {
                                        if (b(d)) throw new c("ArrayBuffer is detached");
                                        return d;
                                    };
                                },
                                5636: function(g, f, a) {
                                    var b = a(4576);
                                    f = a(9504);
                                    var c = a(6706), d = a(7696), e = a(5169), h = a(7394), k = a(4483), l = a(1548), m = b.structuredClone, n = b.ArrayBuffer, q = b.DataView, r = Math.min;
                                    a = n.prototype;
                                    b = q.prototype;
                                    var t = f(a.slice), u = c(a, "resizable", "get"), v = c(a, "maxByteLength", "get"), w = f(b.getInt8), x = f(b.setInt8);
                                    g.exports = (l || k) && function(B, z, C) {
                                        var D = h(B);
                                        z = void 0 === z ? D : d(z);
                                        var H = !u || !u(B);
                                        e(B);
                                        if (l && (B = m(B, {
                                            transfer: [
                                                B
                                            ]
                                        }), D === z && (C || H))) return B;
                                        if (D >= z && (!C || H)) C = t(B, 0, z);
                                        else {
                                            C = C && !H && v ? {
                                                maxByteLength: v(B)
                                            } : void 0;
                                            C = new n(z, C);
                                            H = new q(B);
                                            var J = new q(C);
                                            D = r(z, D);
                                            for(z = 0; z < D; z++)x(J, z, w(H, z));
                                        }
                                        l || k(B);
                                        return C;
                                    };
                                },
                                4644: function(g, f, a) {
                                    function b(X) {
                                        if (!l(X)) return !1;
                                        X = n(X);
                                        return m(ba, X) || m(ra, X);
                                    }
                                    function c(X) {
                                        X = v(X);
                                        if (l(X)) {
                                            var ma = C(X);
                                            return ma && m(ma, "TypedArrayConstructor") ? ma.TypedArrayConstructor : c(X);
                                        }
                                    }
                                    var d = a(7811), e = a(3724), h = a(4576), k = a(4901), l = a(34), m = a(9297), n = a(6955), q = a(6823);
                                    f = a(6699);
                                    var r = a(6840), t = a(2106), u = a(1625), v = a(2787), w = a(2967), x = a(8227), B = a(3392), z = a(1181);
                                    a = z.enforce;
                                    var C = z.get, D = h.Int8Array, H = D && D.prototype;
                                    z = (z = h.Uint8ClampedArray) && z.prototype;
                                    var J = D && v(D), M = H && v(H);
                                    D = Object.prototype;
                                    var I = h.TypeError;
                                    x = x("toStringTag");
                                    var P = B("TYPED_ARRAY_TAG"), L = d && !!w && "Opera" !== n(h.opera);
                                    d = !1;
                                    var T, aa, ba = {
                                        Int8Array: 1,
                                        Uint8Array: 1,
                                        Uint8ClampedArray: 1,
                                        Int16Array: 2,
                                        Uint16Array: 2,
                                        Int32Array: 4,
                                        Uint32Array: 4,
                                        Float32Array: 4,
                                        Float64Array: 8
                                    }, ra = {
                                        BigInt64Array: 8,
                                        BigUint64Array: 8
                                    };
                                    for(T in ba)(aa = (B = h[T]) && B.prototype) ? a(aa).TypedArrayConstructor = B : L = !1;
                                    for(T in ra)(aa = (B = h[T]) && B.prototype) && (a(aa).TypedArrayConstructor = B);
                                    if (!L || !k(J) || J === Function.prototype) {
                                        if (J = function() {
                                            throw new I("Incorrect invocation");
                                        }, L) for(T in ba)h[T] && w(h[T], J);
                                    }
                                    if (!L || !M || M === D) {
                                        if (M = J.prototype, L) for(T in ba)h[T] && w(h[T].prototype, M);
                                    }
                                    L && v(z) !== M && w(z, M);
                                    if (e && !m(M, x)) for(T in d = !0, t(M, x, {
                                        configurable: !0,
                                        get: function() {
                                            return l(this) ? this[P] : void 0;
                                        }
                                    }), ba)h[T] && f(h[T], P, T);
                                    g.exports = {
                                        NATIVE_ARRAY_BUFFER_VIEWS: L,
                                        TYPED_ARRAY_TAG: d && P,
                                        aTypedArray: function(X) {
                                            if (b(X)) return X;
                                            throw new I("Target is not a typed array");
                                        },
                                        aTypedArrayConstructor: function(X) {
                                            if (k(X) && (!w || u(J, X))) return X;
                                            throw new I(q(X) + " is not a typed array constructor");
                                        },
                                        exportTypedArrayMethod: function(X, ma, U, K) {
                                            if (e) {
                                                if (U) for(var N in ba){
                                                    var V = h[N];
                                                    if (V && m(V.prototype, X)) try {
                                                        delete V.prototype[X];
                                                    } catch (ea) {
                                                        try {
                                                            V.prototype[X] = ma;
                                                        } catch (ia) {}
                                                    }
                                                }
                                                M[X] && !U || r(M, X, U ? ma : L && H[X] || ma, K);
                                            }
                                        },
                                        exportTypedArrayStaticMethod: function(X, ma, U) {
                                            var K, N;
                                            if (e) {
                                                if (w) {
                                                    if (U) {
                                                        for(K in ba)if ((N = h[K]) && m(N, X)) try {
                                                            delete N[X];
                                                        } catch (V) {}
                                                    }
                                                    if (!J[X] || U) try {
                                                        return r(J, X, U ? ma : L && J[X] || ma);
                                                    } catch (V) {}
                                                    else return;
                                                }
                                                for(K in ba)N = h[K], !N || N[X] && !U || r(N, X, ma);
                                            }
                                        },
                                        getTypedArrayConstructor: c,
                                        isView: function(X) {
                                            if (!l(X)) return !1;
                                            X = n(X);
                                            return "DataView" === X || m(ba, X) || m(ra, X);
                                        },
                                        isTypedArray: b,
                                        TypedArray: J,
                                        TypedArrayPrototype: M
                                    };
                                },
                                6346: function(g, f, a) {
                                    function b(O, Y, oa, xa, la, ta) {
                                        O = K(O);
                                        oa = H(oa);
                                        xa = xa(+la);
                                        ta = !!ta;
                                        if (oa + Y > O.byteLength) throw new va("Wrong index");
                                        la = O.bytes;
                                        O = oa + O.byteOffset;
                                        for(oa = 0; oa < Y; oa++)la[O + oa] = xa[ta ? oa : Y - oa - 1];
                                    }
                                    function c(O, Y, oa, xa) {
                                        O = K(O);
                                        oa = H(oa);
                                        xa = !!xa;
                                        if (oa + Y > O.byteLength) throw new va("Wrong index");
                                        oa += O.byteOffset;
                                        Y = T(O.bytes, oa, oa + Y);
                                        return xa ? Y : Ha(Y);
                                    }
                                    function d(O, Y, oa) {
                                        w(O.prototype, Y, {
                                            configurable: !0,
                                            get: function() {
                                                return oa(this)[Y];
                                            }
                                        });
                                    }
                                    function e(O) {
                                        return Ia(O, 52, 8);
                                    }
                                    function h(O) {
                                        return Ia(J(O), 23, 4);
                                    }
                                    function k(O) {
                                        return O[3] << 24 | O[2] << 16 | O[1] << 8 | O[0];
                                    }
                                    function l(O) {
                                        return [
                                            O & 255,
                                            O >> 8 & 255,
                                            O >> 16 & 255,
                                            O >> 24 & 255
                                        ];
                                    }
                                    function m(O) {
                                        return [
                                            O & 255,
                                            O >> 8 & 255
                                        ];
                                    }
                                    function n(O) {
                                        return [
                                            O & 255
                                        ];
                                    }
                                    var q = a(4576);
                                    f = a(9504);
                                    var r = a(3724), t = a(7811), u = a(350), v = a(6699), w = a(2106), x = a(6279), B = a(9039), z = a(679), C = a(1291), D = a(8014), H = a(7696), J = a(5617), M = a(8490), I = a(2787), P = a(2967), L = a(4373), T = a(7680), aa = a(3167), ba = a(7740), ra = a(687), X = a(1181);
                                    a = u.PROPER;
                                    var ma = u.CONFIGURABLE, U = X.getterFor("ArrayBuffer"), K = X.getterFor("DataView"), N = X.set, V = q.ArrayBuffer, ea = V, ia = ea && ea.prototype, na = (u = q.DataView) && u.prototype;
                                    X = Object.prototype;
                                    var ua = q.Array, va = q.RangeError, za = f(L), Ha = f([].reverse), Ia = M.pack, Z = M.unpack;
                                    if (t) {
                                        var ja = a && "ArrayBuffer" !== V.name;
                                        B(function() {
                                            V(1);
                                        }) && B(function() {
                                            new V(-1);
                                        }) && !B(function() {
                                            new V;
                                            new V(1.5);
                                            new V(NaN);
                                            return 1 !== V.length || ja && !ma;
                                        }) ? ja && ma && v(V, "name", "ArrayBuffer") : (ea = function(O) {
                                            z(this, ia);
                                            return aa(new V(H(O)), this, ea);
                                        }, ea.prototype = ia, ia.constructor = ea, ba(ea, V));
                                        P && I(na) !== X && P(na, X);
                                        q = new u(new ea(2));
                                        var ka = f(na.setInt8);
                                        q.setInt8(0, 2147483648);
                                        q.setInt8(1, 2147483649);
                                        !q.getInt8(0) && q.getInt8(1) || x(na, {
                                            setInt8: function(O, Y) {
                                                ka(this, O, Y << 24 >> 24);
                                            },
                                            setUint8: function(O, Y) {
                                                ka(this, O, Y << 24 >> 24);
                                            }
                                        }, {
                                            unsafe: !0
                                        });
                                    } else ea = function(O) {
                                        z(this, ia);
                                        O = H(O);
                                        N(this, {
                                            type: "ArrayBuffer",
                                            bytes: za(ua(O), 0),
                                            byteLength: O
                                        });
                                        r || (this.byteLength = O, this.detached = !1);
                                    }, ia = ea.prototype, u = function(O, Y, oa) {
                                        z(this, na);
                                        z(O, ia);
                                        var xa = U(O), la = xa.byteLength;
                                        Y = C(Y);
                                        if (0 > Y || Y > la) throw new va("Wrong offset");
                                        oa = void 0 === oa ? la - Y : D(oa);
                                        if (Y + oa > la) throw new va("Wrong length");
                                        N(this, {
                                            type: "DataView",
                                            buffer: O,
                                            byteLength: oa,
                                            byteOffset: Y,
                                            bytes: xa.bytes
                                        });
                                        r || (this.buffer = O, this.byteLength = oa, this.byteOffset = Y);
                                    }, na = u.prototype, r && (d(ea, "byteLength", U), d(u, "buffer", K), d(u, "byteLength", K), d(u, "byteOffset", K)), x(na, {
                                        getInt8: function(O) {
                                            return c(this, 1, O)[0] << 24 >> 24;
                                        },
                                        getUint8: function(O) {
                                            return c(this, 1, O)[0];
                                        },
                                        getInt16: function(O) {
                                            var Y = c(this, 2, O, 1 < arguments.length ? arguments[1] : !1);
                                            return (Y[1] << 8 | Y[0]) << 16 >> 16;
                                        },
                                        getUint16: function(O) {
                                            var Y = c(this, 2, O, 1 < arguments.length ? arguments[1] : !1);
                                            return Y[1] << 8 | Y[0];
                                        },
                                        getInt32: function(O) {
                                            return k(c(this, 4, O, 1 < arguments.length ? arguments[1] : !1));
                                        },
                                        getUint32: function(O) {
                                            return k(c(this, 4, O, 1 < arguments.length ? arguments[1] : !1)) >>> 0;
                                        },
                                        getFloat32: function(O) {
                                            return Z(c(this, 4, O, 1 < arguments.length ? arguments[1] : !1), 23);
                                        },
                                        getFloat64: function(O) {
                                            return Z(c(this, 8, O, 1 < arguments.length ? arguments[1] : !1), 52);
                                        },
                                        setInt8: function(O, Y) {
                                            b(this, 1, O, n, Y);
                                        },
                                        setUint8: function(O, Y) {
                                            b(this, 1, O, n, Y);
                                        },
                                        setInt16: function(O, Y) {
                                            b(this, 2, O, m, Y, 2 < arguments.length ? arguments[2] : !1);
                                        },
                                        setUint16: function(O, Y) {
                                            b(this, 2, O, m, Y, 2 < arguments.length ? arguments[2] : !1);
                                        },
                                        setInt32: function(O, Y) {
                                            b(this, 4, O, l, Y, 2 < arguments.length ? arguments[2] : !1);
                                        },
                                        setUint32: function(O, Y) {
                                            b(this, 4, O, l, Y, 2 < arguments.length ? arguments[2] : !1);
                                        },
                                        setFloat32: function(O, Y) {
                                            b(this, 4, O, h, Y, 2 < arguments.length ? arguments[2] : !1);
                                        },
                                        setFloat64: function(O, Y) {
                                            b(this, 8, O, e, Y, 2 < arguments.length ? arguments[2] : !1);
                                        }
                                    });
                                    ra(ea, "ArrayBuffer");
                                    ra(u, "DataView");
                                    g.exports = {
                                        ArrayBuffer: ea,
                                        DataView: u
                                    };
                                },
                                4373: function(g, f, a) {
                                    var b = a(8981), c = a(5610), d = a(6198);
                                    g.exports = function(e) {
                                        var h = b(this), k = d(h), l = arguments.length, m = c(1 < l ? arguments[1] : void 0, k);
                                        l = 2 < l ? arguments[2] : void 0;
                                        for(k = void 0 === l ? k : c(l, k); k > m;)h[m++] = e;
                                        return h;
                                    };
                                },
                                5370: function(g, f, a) {
                                    var b = a(6198);
                                    g.exports = function(c, d, e) {
                                        for(var h = 0, k = 2 < arguments.length ? e : b(d), l = new c(k); k > h;)l[h] = d[h++];
                                        return l;
                                    };
                                },
                                9617: function(g, f, a) {
                                    function b(h) {
                                        return function(k, l, m) {
                                            k = c(k);
                                            var n = e(k);
                                            if (0 === n) return !h && -1;
                                            m = d(m, n);
                                            if (h && l !== l) for(; n > m;){
                                                if (l = k[m++], l !== l) return !0;
                                            }
                                            else for(; n > m; m++)if ((h || m in k) && k[m] === l) return h || m || 0;
                                            return !h && -1;
                                        };
                                    }
                                    var c = a(5397), d = a(5610), e = a(6198);
                                    g.exports = {
                                        includes: b(!0),
                                        indexOf: b(!1)
                                    };
                                },
                                3839: function(g, f, a) {
                                    function b(k) {
                                        var l = 1 === k;
                                        return function(m, n, q) {
                                            m = e(m);
                                            var r = d(m), t = h(r);
                                            n = c(n, q);
                                            for(var u; 0 < t--;)if (q = r[t], u = n(q, t, m)) switch(k){
                                                case 0:
                                                    return q;
                                                case 1:
                                                    return t;
                                            }
                                            return l ? -1 : void 0;
                                        };
                                    }
                                    var c = a(6080), d = a(7055), e = a(8981), h = a(6198);
                                    g.exports = {
                                        findLast: b(0),
                                        findLastIndex: b(1)
                                    };
                                },
                                9213: function(g, f, a) {
                                    function b(m) {
                                        var n = 1 === m, q = 2 === m, r = 3 === m, t = 4 === m, u = 6 === m, v = 7 === m, w = 5 === m || u;
                                        return function(x, B, z, C) {
                                            var D = e(x), H = d(D), J = h(H);
                                            B = c(B, z);
                                            z = 0;
                                            C = C || k;
                                            x = n ? C(x, J) : q || v ? C(x, 0) : void 0;
                                            for(var M; J > z; z++)if (w || z in H) {
                                                if (C = H[z], M = B(C, z, D), m) {
                                                    if (n) x[z] = M;
                                                    else if (M) switch(m){
                                                        case 3:
                                                            return !0;
                                                        case 5:
                                                            return C;
                                                        case 6:
                                                            return z;
                                                        case 2:
                                                            l(x, C);
                                                    }
                                                    else switch(m){
                                                        case 4:
                                                            return !1;
                                                        case 7:
                                                            l(x, C);
                                                    }
                                                }
                                            }
                                            return u ? -1 : r || t ? t : x;
                                        };
                                    }
                                    var c = a(6080);
                                    f = a(9504);
                                    var d = a(7055), e = a(8981), h = a(6198), k = a(1469), l = f([].push);
                                    g.exports = {
                                        forEach: b(0),
                                        map: b(1),
                                        filter: b(2),
                                        some: b(3),
                                        every: b(4),
                                        find: b(5),
                                        findIndex: b(6),
                                        filterReject: b(7)
                                    };
                                },
                                4598: function(g, f, a) {
                                    var b = a(9039);
                                    g.exports = function(c, d) {
                                        var e = [][c];
                                        return !!e && b(function() {
                                            e.call(null, d || function() {
                                                return 1;
                                            }, 1);
                                        });
                                    };
                                },
                                926: function(g, f, a) {
                                    function b(l) {
                                        return function(m, n, q, r) {
                                            m = d(m);
                                            var t = e(m), u = h(m);
                                            c(n);
                                            if (0 === u && 2 > q) throw new k("Reduce of empty array with no initial value");
                                            var v = l ? u - 1 : 0, w = l ? -1 : 1;
                                            if (2 > q) for(;;){
                                                if (v in t) {
                                                    r = t[v];
                                                    v += w;
                                                    break;
                                                }
                                                v += w;
                                                if (l ? 0 > v : u <= v) throw new k("Reduce of empty array with no initial value");
                                            }
                                            for(; l ? 0 <= v : u > v; v += w)v in t && (r = n(r, t[v], v, m));
                                            return r;
                                        };
                                    }
                                    var c = a(9306), d = a(8981), e = a(7055), h = a(6198), k = TypeError;
                                    g.exports = {
                                        left: b(!1),
                                        right: b(!0)
                                    };
                                },
                                4527: function(g, f, a) {
                                    f = a(3724);
                                    var b = a(4376), c = TypeError, d = Object.getOwnPropertyDescriptor;
                                    a = f && !function() {
                                        if (void 0 !== this) return !0;
                                        try {
                                            Object.defineProperty([], "length", {
                                                writable: !1
                                            }).length = 1;
                                        } catch (e) {
                                            return e instanceof TypeError;
                                        }
                                    }();
                                    g.exports = a ? function(e, h) {
                                        if (b(e) && !d(e, "length").writable) throw new c("Cannot set read only .length");
                                        return e.length = h;
                                    } : function(e, h) {
                                        return e.length = h;
                                    };
                                },
                                7680: function(g, f, a) {
                                    f = a(9504);
                                    g.exports = f([].slice);
                                },
                                4488: function(g, f, a) {
                                    function b(e, h) {
                                        var k = e.length;
                                        if (8 > k) for(var l = 1, m, n; l < k;){
                                            n = l;
                                            for(m = e[l]; n && 0 < h(e[n - 1], m);)e[n] = e[--n];
                                            n !== l++ && (e[n] = m);
                                        }
                                        else {
                                            l = d(k / 2);
                                            k = b(c(e, 0, l), h);
                                            l = b(c(e, l), h);
                                            m = k.length;
                                            n = l.length;
                                            for(var q = 0, r = 0; q < m || r < n;)e[q + r] = q < m && r < n ? 0 >= h(k[q], l[r]) ? k[q++] : l[r++] : q < m ? k[q++] : l[r++];
                                        }
                                        return e;
                                    }
                                    var c = a(7680), d = Math.floor;
                                    g.exports = b;
                                },
                                7433: function(g, f, a) {
                                    var b = a(4376), c = a(3517), d = a(34), e = a(8227)("species"), h = Array;
                                    g.exports = function(k) {
                                        if (b(k)) {
                                            var l = k.constructor;
                                            c(l) && (l === h || b(l.prototype)) ? l = void 0 : d(l) && (l = l[e], null === l && (l = void 0));
                                        }
                                        return void 0 === l ? h : l;
                                    };
                                },
                                1469: function(g, f, a) {
                                    var b = a(7433);
                                    g.exports = function(c, d) {
                                        return new (b(c))(0 === d ? 0 : d);
                                    };
                                },
                                7628: function(g, f, a) {
                                    var b = a(6198);
                                    g.exports = function(c, d) {
                                        var e = b(c);
                                        d = new d(e);
                                        for(var h = 0; h < e; h++)d[h] = c[e - h - 1];
                                        return d;
                                    };
                                },
                                9928: function(g, f, a) {
                                    var b = a(6198), c = a(1291), d = RangeError;
                                    g.exports = function(e, h, k, l) {
                                        var m = b(e);
                                        k = c(k);
                                        k = 0 > k ? m + k : k;
                                        if (k >= m || 0 > k) throw new d("Incorrect index");
                                        h = new h(m);
                                        for(var n = 0; n < m; n++)h[n] = n === k ? l : e[n];
                                        return h;
                                    };
                                },
                                6319: function(g, f, a) {
                                    var b = a(8551), c = a(9539);
                                    g.exports = function(d, e, h, k) {
                                        try {
                                            return k ? e(b(h)[0], h[1]) : e(h);
                                        } catch (l) {
                                            c(d, "throw", l);
                                        }
                                    };
                                },
                                4428: function(g, f, a) {
                                    var b = a(8227)("iterator"), c = !1;
                                    try {
                                        var d = 0;
                                        f = {
                                            next: function() {
                                                return {
                                                    done: !!d++
                                                };
                                            },
                                            "return": function() {
                                                c = !0;
                                            }
                                        };
                                        f[b] = function() {
                                            return this;
                                        };
                                        Array.from(f, function() {
                                            throw 2;
                                        });
                                    } catch (e) {}
                                    g.exports = function(e, h) {
                                        if (!h && !c) return !1;
                                        var k = !1;
                                        try {
                                            h = {}, h[b] = function() {
                                                return {
                                                    next: function() {
                                                        return {
                                                            done: k = !0
                                                        };
                                                    }
                                                };
                                            }, e(h);
                                        } catch (l) {}
                                        return k;
                                    };
                                },
                                2195: function(g, f, a) {
                                    f = a(9504);
                                    var b = f({}.toString), c = f("".slice);
                                    g.exports = function(d) {
                                        return c(b(d), 8, -1);
                                    };
                                },
                                6955: function(g, f, a) {
                                    f = a(2140);
                                    var b = a(4901), c = a(2195), d = a(8227)("toStringTag"), e = Object, h = "Arguments" === c(function() {
                                        return arguments;
                                    }());
                                    g.exports = f ? c : function(k) {
                                        var l;
                                        if (void 0 === k) var m = "Undefined";
                                        else {
                                            if (null === k) var n = "Null";
                                            else {
                                                a: {
                                                    var q = k = e(k);
                                                    try {
                                                        n = q[d];
                                                        break a;
                                                    } catch (r) {}
                                                    n = void 0;
                                                }
                                                n = "string" == typeof (m = n) ? m : h ? c(k) : "Object" === (l = c(k)) && b(k.callee) ? "Arguments" : l;
                                            }
                                            m = n;
                                        }
                                        return m;
                                    };
                                },
                                7740: function(g, f, a) {
                                    var b = a(9297), c = a(5031), d = a(7347), e = a(4913);
                                    g.exports = function(h, k, l) {
                                        for(var m = c(k), n = e.f, q = d.f, r = 0; r < m.length; r++){
                                            var t = m[r];
                                            b(h, t) || l && b(l, t) || n(h, t, q(k, t));
                                        }
                                    };
                                },
                                2211: function(g, f, a) {
                                    f = a(9039);
                                    g.exports = !f(function() {
                                        function b() {}
                                        b.prototype.constructor = null;
                                        return Object.getPrototypeOf(new b) !== b.prototype;
                                    });
                                },
                                2529: function(g) {
                                    g.exports = function(f, a) {
                                        return {
                                            value: f,
                                            done: a
                                        };
                                    };
                                },
                                6699: function(g, f, a) {
                                    f = a(3724);
                                    var b = a(4913), c = a(6980);
                                    g.exports = f ? function(d, e, h) {
                                        return b.f(d, e, c(1, h));
                                    } : function(d, e, h) {
                                        d[e] = h;
                                        return d;
                                    };
                                },
                                6980: function(g) {
                                    g.exports = function(f, a) {
                                        return {
                                            enumerable: !(f & 1),
                                            configurable: !(f & 2),
                                            writable: !(f & 4),
                                            value: a
                                        };
                                    };
                                },
                                2278: function(g, f, a) {
                                    var b = a(3724), c = a(4913), d = a(6980);
                                    g.exports = function(e, h, k) {
                                        b ? c.f(e, h, d(0, k)) : e[h] = k;
                                    };
                                },
                                2106: function(g, f, a) {
                                    var b = a(283), c = a(4913);
                                    g.exports = function(d, e, h) {
                                        h.get && b(h.get, e, {
                                            getter: !0
                                        });
                                        h.set && b(h.set, e, {
                                            setter: !0
                                        });
                                        return c.f(d, e, h);
                                    };
                                },
                                6840: function(g, f, a) {
                                    var b = a(4901), c = a(4913), d = a(283), e = a(9433);
                                    g.exports = function(h, k, l, m) {
                                        m || (m = {});
                                        var n = m.enumerable, q = void 0 !== m.name ? m.name : k;
                                        b(l) && d(l, q, m);
                                        if (m.global) n ? h[k] = l : e(k, l);
                                        else {
                                            try {
                                                m.unsafe ? h[k] && (n = !0) : delete h[k];
                                            } catch (r) {}
                                            n ? h[k] = l : c.f(h, k, {
                                                value: l,
                                                enumerable: !1,
                                                configurable: !m.nonConfigurable,
                                                writable: !m.nonWritable
                                            });
                                        }
                                        return h;
                                    };
                                },
                                6279: function(g, f, a) {
                                    var b = a(6840);
                                    g.exports = function(c, d, e) {
                                        for(var h in d)b(c, h, d[h], e);
                                        return c;
                                    };
                                },
                                9433: function(g, f, a) {
                                    var b = a(4576), c = Object.defineProperty;
                                    g.exports = function(d, e) {
                                        try {
                                            c(b, d, {
                                                value: e,
                                                configurable: !0,
                                                writable: !0
                                            });
                                        } catch (h) {
                                            b[d] = e;
                                        }
                                        return e;
                                    };
                                },
                                4606: function(g, f, a) {
                                    var b = a(6823), c = TypeError;
                                    g.exports = function(d, e) {
                                        if (!delete d[e]) throw new c("Cannot delete property " + b(e) + " of " + b(d));
                                    };
                                },
                                3724: function(g, f, a) {
                                    f = a(9039);
                                    g.exports = !f(function() {
                                        return 7 !== Object.defineProperty({}, 1, {
                                            get: function() {
                                                return 7;
                                            }
                                        })[1];
                                    });
                                },
                                4483: function(g, f, a) {
                                    var b = a(4576);
                                    f = a(9429);
                                    a = a(1548);
                                    var c = b.structuredClone, d = b.ArrayBuffer;
                                    b = b.MessageChannel;
                                    var e = !1, h;
                                    if (a) e = function(n) {
                                        c(n, {
                                            transfer: [
                                                n
                                            ]
                                        });
                                    };
                                    else if (d) try {
                                        if (!b && (h = f("worker_threads")) && (b = h.MessageChannel), b) {
                                            var k = new b;
                                            var l = new d(2);
                                            var m = function(n) {
                                                k.port1.postMessage(null, [
                                                    n
                                                ]);
                                            };
                                            2 === l.byteLength && (m(l), 0 === l.byteLength && (e = m));
                                        }
                                    } catch (n) {}
                                    g.exports = e;
                                },
                                4055: function(g, f, a) {
                                    f = a(4576);
                                    a = a(34);
                                    var b = f.document, c = a(b) && a(b.createElement);
                                    g.exports = function(d) {
                                        return c ? b.createElement(d) : {};
                                    };
                                },
                                6837: function(g) {
                                    var f = TypeError;
                                    g.exports = function(a) {
                                        if (9007199254740991 < a) throw f("Maximum allowed index exceeded");
                                        return a;
                                    };
                                },
                                5002: function(g) {
                                    g.exports = {
                                        IndexSizeError: {
                                            s: "INDEX_SIZE_ERR",
                                            c: 1,
                                            m: 1
                                        },
                                        DOMStringSizeError: {
                                            s: "DOMSTRING_SIZE_ERR",
                                            c: 2,
                                            m: 0
                                        },
                                        HierarchyRequestError: {
                                            s: "HIERARCHY_REQUEST_ERR",
                                            c: 3,
                                            m: 1
                                        },
                                        WrongDocumentError: {
                                            s: "WRONG_DOCUMENT_ERR",
                                            c: 4,
                                            m: 1
                                        },
                                        InvalidCharacterError: {
                                            s: "INVALID_CHARACTER_ERR",
                                            c: 5,
                                            m: 1
                                        },
                                        NoDataAllowedError: {
                                            s: "NO_DATA_ALLOWED_ERR",
                                            c: 6,
                                            m: 0
                                        },
                                        NoModificationAllowedError: {
                                            s: "NO_MODIFICATION_ALLOWED_ERR",
                                            c: 7,
                                            m: 1
                                        },
                                        NotFoundError: {
                                            s: "NOT_FOUND_ERR",
                                            c: 8,
                                            m: 1
                                        },
                                        NotSupportedError: {
                                            s: "NOT_SUPPORTED_ERR",
                                            c: 9,
                                            m: 1
                                        },
                                        InUseAttributeError: {
                                            s: "INUSE_ATTRIBUTE_ERR",
                                            c: 10,
                                            m: 1
                                        },
                                        InvalidStateError: {
                                            s: "INVALID_STATE_ERR",
                                            c: 11,
                                            m: 1
                                        },
                                        SyntaxError: {
                                            s: "SYNTAX_ERR",
                                            c: 12,
                                            m: 1
                                        },
                                        InvalidModificationError: {
                                            s: "INVALID_MODIFICATION_ERR",
                                            c: 13,
                                            m: 1
                                        },
                                        NamespaceError: {
                                            s: "NAMESPACE_ERR",
                                            c: 14,
                                            m: 1
                                        },
                                        InvalidAccessError: {
                                            s: "INVALID_ACCESS_ERR",
                                            c: 15,
                                            m: 1
                                        },
                                        ValidationError: {
                                            s: "VALIDATION_ERR",
                                            c: 16,
                                            m: 0
                                        },
                                        TypeMismatchError: {
                                            s: "TYPE_MISMATCH_ERR",
                                            c: 17,
                                            m: 1
                                        },
                                        SecurityError: {
                                            s: "SECURITY_ERR",
                                            c: 18,
                                            m: 1
                                        },
                                        NetworkError: {
                                            s: "NETWORK_ERR",
                                            c: 19,
                                            m: 1
                                        },
                                        AbortError: {
                                            s: "ABORT_ERR",
                                            c: 20,
                                            m: 1
                                        },
                                        URLMismatchError: {
                                            s: "URL_MISMATCH_ERR",
                                            c: 21,
                                            m: 1
                                        },
                                        QuotaExceededError: {
                                            s: "QUOTA_EXCEEDED_ERR",
                                            c: 22,
                                            m: 1
                                        },
                                        TimeoutError: {
                                            s: "TIMEOUT_ERR",
                                            c: 23,
                                            m: 1
                                        },
                                        InvalidNodeTypeError: {
                                            s: "INVALID_NODE_TYPE_ERR",
                                            c: 24,
                                            m: 1
                                        },
                                        DataCloneError: {
                                            s: "DATA_CLONE_ERR",
                                            c: 25,
                                            m: 1
                                        }
                                    };
                                },
                                7400: function(g) {
                                    g.exports = {
                                        CSSRuleList: 0,
                                        CSSStyleDeclaration: 0,
                                        CSSValueList: 0,
                                        ClientRectList: 0,
                                        DOMRectList: 0,
                                        DOMStringList: 0,
                                        DOMTokenList: 1,
                                        DataTransferItemList: 0,
                                        FileList: 0,
                                        HTMLAllCollection: 0,
                                        HTMLCollection: 0,
                                        HTMLFormElement: 0,
                                        HTMLSelectElement: 0,
                                        MediaList: 0,
                                        MimeTypeArray: 0,
                                        NamedNodeMap: 0,
                                        NodeList: 1,
                                        PaintRequestList: 0,
                                        Plugin: 0,
                                        PluginArray: 0,
                                        SVGLengthList: 0,
                                        SVGNumberList: 0,
                                        SVGPathSegList: 0,
                                        SVGPointList: 0,
                                        SVGStringList: 0,
                                        SVGTransformList: 0,
                                        SourceBufferList: 0,
                                        StyleSheetList: 0,
                                        TextTrackCueList: 0,
                                        TextTrackList: 0,
                                        TouchList: 0
                                    };
                                },
                                9296: function(g, f, a) {
                                    f = (f = a(4055)("span").classList) && f.constructor && f.constructor.prototype;
                                    g.exports = f === Object.prototype ? void 0 : f;
                                },
                                8727: function(g) {
                                    g.exports = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
                                },
                                3709: function(g, f, a) {
                                    f = a(2839).match(/firefox\/(\d+)/i);
                                    g.exports = !!f && +f[1];
                                },
                                3763: function(g, f, a) {
                                    f = a(2839);
                                    g.exports = /MSIE|Trident/.test(f);
                                },
                                4265: function(g, f, a) {
                                    f = a(2839);
                                    g.exports = /ipad|iphone|ipod/i.test(f) && "undefined" != typeof Pebble;
                                },
                                9544: function(g, f, a) {
                                    f = a(2839);
                                    g.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(f);
                                },
                                8574: function(g, f, a) {
                                    f = a(4215);
                                    g.exports = "NODE" === f;
                                },
                                7860: function(g, f, a) {
                                    f = a(2839);
                                    g.exports = /web0s(?!.*chrome)/i.test(f);
                                },
                                2839: function(g, f, a) {
                                    f = (f = a(4576).navigator) && f.userAgent;
                                    g.exports = f ? String(f) : "";
                                },
                                9519: function(g, f, a) {
                                    f = a(4576);
                                    a = a(2839);
                                    var b = f.process;
                                    f = f.Deno;
                                    f = (f = b && b.versions || f && f.version) && f.v8;
                                    if (f) {
                                        f = f.split(".");
                                        var c = 0 < f[0] && 4 > f[0] ? 1 : +(f[0] + f[1]);
                                    }
                                    !c && a && (f = a.match(/Edge\/(\d+)/), (!f || 74 <= f[1]) && (f = a.match(/Chrome\/(\d+)/)) && (c = +f[1]));
                                    g.exports = c;
                                },
                                3607: function(g, f, a) {
                                    f = a(2839).match(/AppleWebKit\/(\d+)\./);
                                    g.exports = !!f && +f[1];
                                },
                                4215: function(g, f, a) {
                                    function b(d) {
                                        return c.slice(0, d.length) === d;
                                    }
                                    f = a(4576);
                                    var c = a(2839);
                                    a = a(2195);
                                    g.exports = b("Bun/") ? "BUN" : b("Cloudflare-Workers") ? "CLOUDFLARE" : b("Deno/") ? "DENO" : b("Node.js/") ? "NODE" : f.Bun && "string" == typeof Bun.version ? "BUN" : f.Deno && "object" == typeof Deno.version ? "DENO" : "process" === a(f.process) ? "NODE" : f.window && f.document ? "BROWSER" : "REST";
                                },
                                6193: function(g, f, a) {
                                    f = a(9504);
                                    var b = Error, c = f("".replace);
                                    f = String(new b("zxcasd").stack);
                                    var d = /\n\s*at [^:]*:[^\n]*/, e = d.test(f);
                                    g.exports = function(h, k) {
                                        if (e && "string" == typeof h && !b.prepareStackTrace) for(; k--;)h = c(h, d, "");
                                        return h;
                                    };
                                },
                                747: function(g, f, a) {
                                    var b = a(6699), c = a(6193), d = a(4659), e = Error.captureStackTrace;
                                    g.exports = function(h, k, l, m) {
                                        d && (e ? e(h, k) : b(h, "stack", c(l, m)));
                                    };
                                },
                                4659: function(g, f, a) {
                                    f = a(9039);
                                    var b = a(6980);
                                    g.exports = !f(function() {
                                        var c = Error("a");
                                        if (!("stack" in c)) return !0;
                                        Object.defineProperty(c, "stack", b(1, 7));
                                        return 7 !== c.stack;
                                    });
                                },
                                6518: function(g, f, a) {
                                    var b = a(4576), c = a(7347).f, d = a(6699), e = a(6840), h = a(9433), k = a(7740), l = a(2796);
                                    g.exports = function(m, n) {
                                        var q = m.target, r = m.global, t = m.stat, u, v, w;
                                        if (v = r ? b : t ? b[q] || h(q, {}) : b[q] && b[q].prototype) for(w in n){
                                            var x = n[w];
                                            var B = m.dontCallGetSet ? (u = c(v, w)) && u.value : v[w];
                                            u = l(r ? w : q + (t ? "." : "#") + w, m.forced);
                                            if (!u && void 0 !== B) {
                                                if (typeof x == typeof B) continue;
                                                k(x, B);
                                            }
                                            (m.sham || B && B.sham) && d(x, "sham", !0);
                                            e(v, w, x, m);
                                        }
                                    };
                                },
                                9039: function(g) {
                                    g.exports = function(f) {
                                        try {
                                            return !!f();
                                        } catch (a) {
                                            return !0;
                                        }
                                    };
                                },
                                9228: function(g, f, a) {
                                    a(7495);
                                    var b = a(9565), c = a(6840), d = a(7323), e = a(9039), h = a(8227), k = a(6699), l = h("species"), m = RegExp.prototype;
                                    g.exports = function(n, q, r, t) {
                                        var u = h(n), v = !e(function() {
                                            var B = {};
                                            B[u] = function() {
                                                return 7;
                                            };
                                            return 7 !== ""[n](B);
                                        }), w = v && !e(function() {
                                            var B = !1, z = /a/;
                                            "split" === n && (z = {
                                                constructor: {}
                                            }, z.constructor[l] = function() {
                                                return z;
                                            }, z.flags = "", z[u] = /./[u]);
                                            z.exec = function() {
                                                B = !0;
                                                return null;
                                            };
                                            z[u]("");
                                            return !B;
                                        });
                                        if (!v || !w || r) {
                                            var x = /./[u];
                                            q = q(u, ""[n], function(B, z, C, D, H) {
                                                var J = z.exec;
                                                return J === d || J === m.exec ? v && !H ? {
                                                    done: !0,
                                                    value: b(x, z, C, D)
                                                } : {
                                                    done: !0,
                                                    value: b(B, C, z, D)
                                                } : {
                                                    done: !1
                                                };
                                            });
                                            c(String.prototype, n, q[0]);
                                            c(m, u, q[1]);
                                        }
                                        t && k(m[u], "sham", !0);
                                    };
                                },
                                259: function(g, f, a) {
                                    function b(k, l, m, n, q, r, t, u) {
                                        var v = 0;
                                        t = t ? h(t, u) : !1;
                                        for(var w; v < n;)v in m && (u = t ? t(m[v], v, l) : m[v], 0 < r && c(u) ? (w = d(u), q = b(k, l, u, w, q, r - 1) - 1) : (e(q + 1), k[q] = u), q++), v++;
                                        return q;
                                    }
                                    var c = a(4376), d = a(6198), e = a(6837), h = a(6080);
                                    g.exports = b;
                                },
                                8745: function(g, f, a) {
                                    f = a(616);
                                    a = Function.prototype;
                                    var b = a.apply, c = a.call;
                                    g.exports = "object" == typeof Reflect && Reflect.apply || (f ? c.bind(b) : function() {
                                        return c.apply(b, arguments);
                                    });
                                },
                                6080: function(g, f, a) {
                                    f = a(7476);
                                    var b = a(9306), c = a(616), d = f(f.bind);
                                    g.exports = function(e, h) {
                                        b(e);
                                        return void 0 === h ? e : c ? d(e, h) : function() {
                                            return e.apply(h, arguments);
                                        };
                                    };
                                },
                                616: function(g, f, a) {
                                    f = a(9039);
                                    g.exports = !f(function() {
                                        var b = (function() {}).bind();
                                        return "function" != typeof b || b.hasOwnProperty("prototype");
                                    });
                                },
                                9565: function(g, f, a) {
                                    f = a(616);
                                    var b = Function.prototype.call;
                                    g.exports = f ? b.bind(b) : function() {
                                        return b.apply(b, arguments);
                                    };
                                },
                                350: function(g, f, a) {
                                    f = a(3724);
                                    var b = a(9297);
                                    a = Function.prototype;
                                    var c = f && Object.getOwnPropertyDescriptor, d = (b = b(a, "name")) && "something" === (function() {}).name;
                                    f = b && (!f || f && c(a, "name").configurable);
                                    g.exports = {
                                        EXISTS: b,
                                        PROPER: d,
                                        CONFIGURABLE: f
                                    };
                                },
                                6706: function(g, f, a) {
                                    var b = a(9504), c = a(9306);
                                    g.exports = function(d, e, h) {
                                        try {
                                            return b(c(Object.getOwnPropertyDescriptor(d, e)[h]));
                                        } catch (k) {}
                                    };
                                },
                                7476: function(g, f, a) {
                                    var b = a(2195), c = a(9504);
                                    g.exports = function(d) {
                                        if ("Function" === b(d)) return c(d);
                                    };
                                },
                                9504: function(g, f, a) {
                                    f = a(616);
                                    a = Function.prototype;
                                    var b = a.call;
                                    a = f && a.bind.bind(b, b);
                                    g.exports = f ? a : function(c) {
                                        return function() {
                                            return b.apply(c, arguments);
                                        };
                                    };
                                },
                                9429: function(g, f, a) {
                                    var b = a(4576), c = a(8574);
                                    g.exports = function(d) {
                                        if (c) {
                                            try {
                                                return b.process.getBuiltinModule(d);
                                            } catch (e) {}
                                            try {
                                                return Function('return require("' + d + '")')();
                                            } catch (e) {}
                                        }
                                    };
                                },
                                7751: function(g, f, a) {
                                    var b = a(4576), c = a(4901);
                                    g.exports = function(d, e) {
                                        if (2 > arguments.length) {
                                            var h = b[d];
                                            h = c(h) ? h : void 0;
                                        } else h = b[d] && b[d][e];
                                        return h;
                                    };
                                },
                                1767: function(g) {
                                    g.exports = function(f) {
                                        return {
                                            iterator: f,
                                            next: f.next,
                                            done: !1
                                        };
                                    };
                                },
                                8646: function(g, f, a) {
                                    var b = a(9565), c = a(8551), d = a(1767), e = a(851);
                                    g.exports = function(h, k) {
                                        k && "string" === typeof h || c(h);
                                        k = e(h);
                                        return d(c(void 0 !== k ? b(k, h) : h));
                                    };
                                },
                                851: function(g, f, a) {
                                    var b = a(6955), c = a(5966), d = a(4117), e = a(6269), h = a(8227)("iterator");
                                    g.exports = function(k) {
                                        if (!d(k)) return c(k, h) || c(k, "@@iterator") || e[b(k)];
                                    };
                                },
                                81: function(g, f, a) {
                                    var b = a(9565), c = a(9306), d = a(8551), e = a(6823), h = a(851), k = TypeError;
                                    g.exports = function(l, m) {
                                        var n = 2 > arguments.length ? h(l) : m;
                                        if (c(n)) return d(b(n, l));
                                        throw new k(e(l) + " is not iterable");
                                    };
                                },
                                6933: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(4376), c = a(4901), d = a(2195), e = a(655), h = f([].push);
                                    g.exports = function(k) {
                                        if (c(k)) return k;
                                        if (b(k)) {
                                            for(var l = k.length, m = [], n = 0; n < l; n++){
                                                var q = k[n];
                                                "string" == typeof q ? h(m, q) : ("number" == typeof q || "Number" === d(q) || "String" === d(q)) && h(m, e(q));
                                            }
                                            var r = m.length, t = !0;
                                            return function(u, v) {
                                                if (t) return t = !1, v;
                                                if (b(this)) return v;
                                                for(var w = 0; w < r; w++)if (m[w] === u) return v;
                                            };
                                        }
                                    };
                                },
                                5966: function(g, f, a) {
                                    var b = a(9306), c = a(4117);
                                    g.exports = function(d, e) {
                                        d = d[e];
                                        return c(d) ? void 0 : b(d);
                                    };
                                },
                                3789: function(g, f, a) {
                                    function b(q, r) {
                                        this.set = q;
                                        this.size = n(r, 0);
                                        this.has = c(q.has);
                                        this.keys = c(q.keys);
                                    }
                                    var c = a(9306), d = a(8551), e = a(9565), h = a(1291), k = a(1767), l = RangeError, m = TypeError, n = Math.max;
                                    b.prototype = {
                                        getIterator: function() {
                                            return k(d(e(this.keys, this.set)));
                                        },
                                        includes: function(q) {
                                            return e(this.has, this.set, q);
                                        }
                                    };
                                    g.exports = function(q) {
                                        d(q);
                                        var r = +q.size;
                                        if (r !== r) throw new m("Invalid size");
                                        r = h(r);
                                        if (0 > r) throw new l("Invalid size");
                                        return new b(q, r);
                                    };
                                },
                                2478: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(8981), c = Math.floor, d = f("".charAt), e = f("".replace), h = f("".slice), k = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
                                    g.exports = function(m, n, q, r, t, u) {
                                        var v = q + m.length, w = r.length, x = l;
                                        void 0 !== t && (t = b(t), x = k);
                                        return e(u, x, function(B, z) {
                                            switch(d(z, 0)){
                                                case "$":
                                                    return "$";
                                                case "&":
                                                    return m;
                                                case "`":
                                                    return h(n, 0, q);
                                                case "'":
                                                    return h(n, v);
                                                case "<":
                                                    B = t[h(z, 1, -1)];
                                                    break;
                                                default:
                                                    var C = +z;
                                                    if (0 === C) return B;
                                                    if (C > w) return C = c(C / 10), 0 === C ? B : C <= w ? void 0 === r[C - 1] ? d(z, 1) : r[C - 1] + d(z, 1) : B;
                                                    B = r[C - 1];
                                            }
                                            return void 0 === B ? "" : B;
                                        });
                                    };
                                },
                                4576: function(g) {
                                    function f(a) {
                                        return a && a.Math === Math && a;
                                    }
                                    g.exports = f("object" == typeof globalThis && globalThis) || f("object" == typeof window && window) || f("object" == typeof self && self) || f("object" == typeof $parcel$global && $parcel$global) || f("object" == typeof this && this) || function() {
                                        return this;
                                    }() || Function("return this")();
                                },
                                9297: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(8981), c = f({}.hasOwnProperty);
                                    g.exports = Object.hasOwn || function(d, e) {
                                        return c(b(d), e);
                                    };
                                },
                                421: function(g) {
                                    g.exports = {};
                                },
                                3138: function(g) {
                                    g.exports = function(f, a) {
                                        try {
                                            1 === arguments.length ? console.error(f) : console.error(f, a);
                                        } catch (b) {}
                                    };
                                },
                                397: function(g, f, a) {
                                    f = a(7751);
                                    g.exports = f("document", "documentElement");
                                },
                                5917: function(g, f, a) {
                                    f = a(3724);
                                    var b = a(9039), c = a(4055);
                                    g.exports = !f && !b(function() {
                                        return 7 !== Object.defineProperty(c("div"), "a", {
                                            get: function() {
                                                return 7;
                                            }
                                        }).a;
                                    });
                                },
                                8490: function(g) {
                                    var f = Array, a = Math.abs, b = Math.pow, c = Math.floor, d = Math.log, e = Math.LN2;
                                    g.exports = {
                                        pack: function(h, k, l) {
                                            var m = f(l);
                                            l = 8 * l - k - 1;
                                            var n = (1 << l) - 1, q = n >> 1, r = 23 === k ? b(2, -24) - b(2, -77) : 0, t = 0 > h || 0 === h && 0 > 1 / h ? 1 : 0, u = 0;
                                            h = a(h);
                                            if (h !== h || Infinity === h) {
                                                h = h !== h ? 1 : 0;
                                                var v = n;
                                            } else {
                                                v = c(d(h) / e);
                                                var w = b(2, -v);
                                                1 > h * w && (v--, w *= 2);
                                                h = 1 <= v + q ? h + r / w : h + r * b(2, 1 - q);
                                                2 <= h * w && (v++, w /= 2);
                                                v + q >= n ? (h = 0, v = n) : 1 <= v + q ? (h = (h * w - 1) * b(2, k), v += q) : (h = h * b(2, q - 1) * b(2, k), v = 0);
                                            }
                                            for(; 8 <= k;)m[u++] = h & 255, h /= 256, k -= 8;
                                            v = v << k | h;
                                            for(l += k; 0 < l;)m[u++] = v & 255, v /= 256, l -= 8;
                                            m[u - 1] |= 128 * t;
                                            return m;
                                        },
                                        unpack: function(h, k) {
                                            var l = h.length, m = 8 * l - k - 1, n = (1 << m) - 1, q = n >> 1;
                                            m -= 7;
                                            --l;
                                            var r = h[l--], t = r & 127;
                                            for(r >>= 7; 0 < m;)t = 256 * t + h[l--], m -= 8;
                                            var u = t & (1 << -m) - 1;
                                            t >>= -m;
                                            for(m += k; 0 < m;)u = 256 * u + h[l--], m -= 8;
                                            if (0 === t) t = 1 - q;
                                            else {
                                                if (t === n) return u ? NaN : r ? -Infinity : Infinity;
                                                u += b(2, k);
                                                t -= q;
                                            }
                                            return (r ? -1 : 1) * u * b(2, t - k);
                                        }
                                    };
                                },
                                7055: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(9039), c = a(2195), d = Object, e = f("".split);
                                    g.exports = b(function() {
                                        return !d("z").propertyIsEnumerable(0);
                                    }) ? function(h) {
                                        return "String" === c(h) ? e(h, "") : d(h);
                                    } : d;
                                },
                                3167: function(g, f, a) {
                                    var b = a(4901), c = a(34), d = a(2967);
                                    g.exports = function(e, h, k) {
                                        var l, m;
                                        d && b(l = h.constructor) && l !== k && c(m = l.prototype) && m !== k.prototype && d(e, m);
                                        return e;
                                    };
                                },
                                3706: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(4901);
                                    a = a(7629);
                                    var c = f(Function.toString);
                                    b(a.inspectSource) || (a.inspectSource = function(d) {
                                        return c(d);
                                    });
                                    g.exports = a.inspectSource;
                                },
                                7584: function(g, f, a) {
                                    var b = a(34), c = a(6699);
                                    g.exports = function(d, e) {
                                        b(e) && "cause" in e && c(d, "cause", e.cause);
                                    };
                                },
                                1181: function(g, f, a) {
                                    f = a(8622);
                                    var b = a(4576), c = a(34), d = a(6699), e = a(9297), h = a(7629), k = a(6119);
                                    a = a(421);
                                    var l = b.TypeError;
                                    b = b.WeakMap;
                                    if (f || h.state) {
                                        var m = h.state || (h.state = new b);
                                        m.get = m.get;
                                        m.has = m.has;
                                        m.set = m.set;
                                        var n = function(u, v) {
                                            if (m.has(u)) throw new l("Object already initialized");
                                            v.facade = u;
                                            m.set(u, v);
                                            return v;
                                        };
                                        var q = function(u) {
                                            return m.get(u) || {};
                                        };
                                        var r = function(u) {
                                            return m.has(u);
                                        };
                                    } else {
                                        var t = k("state");
                                        a[t] = !0;
                                        n = function(u, v) {
                                            if (e(u, t)) throw new l("Object already initialized");
                                            v.facade = u;
                                            d(u, t, v);
                                            return v;
                                        };
                                        q = function(u) {
                                            return e(u, t) ? u[t] : {};
                                        };
                                        r = function(u) {
                                            return e(u, t);
                                        };
                                    }
                                    g.exports = {
                                        set: n,
                                        get: q,
                                        has: r,
                                        enforce: function(u) {
                                            return r(u) ? q(u) : n(u, {});
                                        },
                                        getterFor: function(u) {
                                            return function(v) {
                                                var w;
                                                if (!c(v) || (w = q(v)).type !== u) throw new l("Incompatible receiver, " + u + " required");
                                                return w;
                                            };
                                        }
                                    };
                                },
                                4209: function(g, f, a) {
                                    f = a(8227);
                                    var b = a(6269), c = f("iterator"), d = Array.prototype;
                                    g.exports = function(e) {
                                        return void 0 !== e && (b.Array === e || d[c] === e);
                                    };
                                },
                                4376: function(g, f, a) {
                                    var b = a(2195);
                                    g.exports = Array.isArray || function(c) {
                                        return "Array" === b(c);
                                    };
                                },
                                1108: function(g, f, a) {
                                    var b = a(6955);
                                    g.exports = function(c) {
                                        c = b(c);
                                        return "BigInt64Array" === c || "BigUint64Array" === c;
                                    };
                                },
                                4901: function(g) {
                                    var f = "object" == typeof document && document.all;
                                    g.exports = "undefined" == typeof f && void 0 !== f ? function(a) {
                                        return "function" == typeof a || a === f;
                                    } : function(a) {
                                        return "function" == typeof a;
                                    };
                                },
                                3517: function(g, f, a) {
                                    function b(u) {
                                        if (!h(u)) return !1;
                                        switch(k(u)){
                                            case "AsyncFunction":
                                            case "GeneratorFunction":
                                            case "AsyncGeneratorFunction":
                                                return !1;
                                        }
                                        try {
                                            return t || !!r(q, m(u));
                                        } catch (v) {
                                            return !0;
                                        }
                                    }
                                    function c(u) {
                                        if (!h(u)) return !1;
                                        try {
                                            return n(d, [], u), !0;
                                        } catch (v) {
                                            return !1;
                                        }
                                    }
                                    function d() {}
                                    f = a(9504);
                                    var e = a(9039), h = a(4901), k = a(6955), l = a(7751), m = a(3706), n = l("Reflect", "construct"), q = /^\s*(?:class|function)\b/, r = f(q.exec), t = !q.test(d);
                                    b.sham = !0;
                                    g.exports = !n || e(function() {
                                        var u;
                                        return c(c.call) || !c(Object) || !c(function() {
                                            u = !0;
                                        }) || u;
                                    }) ? b : c;
                                },
                                2796: function(g, f, a) {
                                    function b(n, q) {
                                        n = k[h(n)];
                                        return n === m ? !0 : n === l ? !1 : d(q) ? c(q) : !!q;
                                    }
                                    var c = a(9039), d = a(4901), e = /#|\.prototype\./, h = b.normalize = function(n) {
                                        return String(n).replace(e, ".").toLowerCase();
                                    }, k = b.data = {}, l = b.NATIVE = "N", m = b.POLYFILL = "P";
                                    g.exports = b;
                                },
                                2087: function(g, f, a) {
                                    var b = a(34), c = Math.floor;
                                    g.exports = Number.isInteger || function(d) {
                                        return !b(d) && isFinite(d) && c(d) === d;
                                    };
                                },
                                4117: function(g) {
                                    g.exports = function(f) {
                                        return null === f || void 0 === f;
                                    };
                                },
                                34: function(g, f, a) {
                                    var b = a(4901);
                                    g.exports = function(c) {
                                        return "object" == typeof c ? null !== c : b(c);
                                    };
                                },
                                3925: function(g, f, a) {
                                    var b = a(34);
                                    g.exports = function(c) {
                                        return b(c) || null === c;
                                    };
                                },
                                6395: function(g) {
                                    g.exports = !1;
                                },
                                788: function(g, f, a) {
                                    var b = a(34), c = a(2195), d = a(8227)("match");
                                    g.exports = function(e) {
                                        var h;
                                        return b(e) && (void 0 !== (h = e[d]) ? !!h : "RegExp" === c(e));
                                    };
                                },
                                757: function(g, f, a) {
                                    var b = a(7751), c = a(4901), d = a(1625);
                                    f = a(7040);
                                    var e = Object;
                                    g.exports = f ? function(h) {
                                        return "symbol" == typeof h;
                                    } : function(h) {
                                        var k = b("Symbol");
                                        return c(k) && d(k.prototype, e(h));
                                    };
                                },
                                507: function(g, f, a) {
                                    var b = a(9565);
                                    g.exports = function(c, d, e) {
                                        e = e ? c : c.iterator;
                                        c = c.next;
                                        for(var h; !(h = b(c, e)).done;)if (h = d(h.value), void 0 !== h) return h;
                                    };
                                },
                                2652: function(g, f, a) {
                                    function b(v, w) {
                                        this.stopped = v;
                                        this.result = w;
                                    }
                                    var c = a(6080), d = a(9565), e = a(8551), h = a(6823), k = a(4209), l = a(6198), m = a(1625), n = a(81), q = a(851), r = a(9539), t = TypeError, u = b.prototype;
                                    g.exports = function(v, w, x) {
                                        function B(L) {
                                            return C ? (e(L), J ? M(L[0], L[1], z) : M(L[0], L[1])) : J ? M(L, z) : M(L);
                                        }
                                        function z(L) {
                                            P && r(P, "normal", L);
                                            return new b(!0, L);
                                        }
                                        var C = !(!x || !x.AS_ENTRIES), D = !(!x || !x.IS_RECORD), H = !(!x || !x.IS_ITERATOR), J = !(!x || !x.INTERRUPTED), M = c(w, x && x.that), I;
                                        if (D) var P = v.iterator;
                                        else if (H) P = v;
                                        else {
                                            w = q(v);
                                            if (!w) throw new t(h(v) + " is not iterable");
                                            if (k(w)) {
                                                D = 0;
                                                for(w = l(v); w > D; D++)if ((I = B(v[D])) && m(u, I)) return I;
                                                return new b(!1);
                                            }
                                            P = n(v, w);
                                        }
                                        for(v = D ? v.next : P.next; !(D = d(v, P)).done;){
                                            try {
                                                I = B(D.value);
                                            } catch (L) {
                                                r(P, "throw", L);
                                            }
                                            if ("object" == typeof I && I && m(u, I)) return I;
                                        }
                                        return new b(!1);
                                    };
                                },
                                9539: function(g, f, a) {
                                    var b = a(9565), c = a(8551), d = a(5966);
                                    g.exports = function(e, h, k) {
                                        c(e);
                                        try {
                                            var l = d(e, "return");
                                            if (!l) {
                                                if ("throw" === h) throw k;
                                                return k;
                                            }
                                            l = b(l, e);
                                        } catch (n) {
                                            var m = !0;
                                            l = n;
                                        }
                                        if ("throw" === h) throw k;
                                        if (m) throw l;
                                        c(l);
                                        return k;
                                    };
                                },
                                3994: function(g, f, a) {
                                    function b() {
                                        return this;
                                    }
                                    var c = a(7657).IteratorPrototype, d = a(2360), e = a(6980), h = a(687), k = a(6269);
                                    g.exports = function(l, m, n, q) {
                                        m += " Iterator";
                                        l.prototype = d(c, {
                                            next: e(+!q, n)
                                        });
                                        h(l, m, !1, !0);
                                        k[m] = b;
                                        return l;
                                    };
                                },
                                9462: function(g, f, a) {
                                    function b(v) {
                                        var w = k.getterFor(v ? "WrapForValidIterator" : "IteratorHelper");
                                        return e(d(m), {
                                            next: function() {
                                                var x = w(this);
                                                if (v) return x.nextHandler();
                                                try {
                                                    var B = x.done ? void 0 : x.nextHandler();
                                                    return n(B, x.done);
                                                } catch (z) {
                                                    throw x.done = !0, z;
                                                }
                                            },
                                            "return": function() {
                                                var x = w(this), B = x.iterator;
                                                x.done = !0;
                                                if (v) return (x = l(B, "return")) ? c(x, B) : n(void 0, !0);
                                                if (x.inner) try {
                                                    q(x.inner.iterator, "normal");
                                                } catch (z) {
                                                    return q(B, "throw", z);
                                                }
                                                q(B, "normal");
                                                return n(void 0, !0);
                                            }
                                        });
                                    }
                                    var c = a(9565), d = a(2360);
                                    f = a(6699);
                                    var e = a(6279), h = a(8227), k = a(1181), l = a(5966), m = a(7657).IteratorPrototype, n = a(2529), q = a(9539);
                                    a = h("toStringTag");
                                    var r = k.set, t = b(!0), u = b(!1);
                                    f(u, a, "Iterator Helper");
                                    g.exports = function(v, w) {
                                        function x(B, z) {
                                            z ? (z.iterator = B.iterator, z.next = B.next) : z = B;
                                            z.type = w ? "WrapForValidIterator" : "IteratorHelper";
                                            z.nextHandler = v;
                                            z.counter = 0;
                                            z.done = !1;
                                            r(this, z);
                                        }
                                        x.prototype = w ? t : u;
                                        return x;
                                    };
                                },
                                1088: function(g, f, a) {
                                    function b() {
                                        return this;
                                    }
                                    var c = a(6518), d = a(9565), e = a(6395);
                                    f = a(350);
                                    var h = a(4901), k = a(3994), l = a(2787), m = a(2967), n = a(687), q = a(6699), r = a(6840), t = a(8227), u = a(6269);
                                    a = a(7657);
                                    var v = f.PROPER, w = f.CONFIGURABLE, x = a.IteratorPrototype, B = a.BUGGY_SAFARI_ITERATORS, z = t("iterator");
                                    g.exports = function(C, D, H, J, M, I, P) {
                                        function L(K) {
                                            if (K === M && ra) return ra;
                                            if (!B && K && K in aa) return aa[K];
                                            switch(K){
                                                case "keys":
                                                    return function() {
                                                        return new H(this, K);
                                                    };
                                                case "values":
                                                    return function() {
                                                        return new H(this, K);
                                                    };
                                                case "entries":
                                                    return function() {
                                                        return new H(this, K);
                                                    };
                                            }
                                            return function() {
                                                return new H(this);
                                            };
                                        }
                                        k(H, D, J);
                                        J = D + " Iterator";
                                        var T = !1, aa = C.prototype, ba = aa[z] || aa["@@iterator"] || M && aa[M], ra = !B && ba || L(M), X = "Array" === D ? aa.entries || ba : ba, ma;
                                        X && (C = l(X.call(new C)), C !== Object.prototype && C.next && (e || l(C) === x || (m ? m(C, x) : h(C[z]) || r(C, z, b)), n(C, J, !0, !0), e && (u[J] = b)));
                                        v && "values" === M && ba && "values" !== ba.name && (!e && w ? q(aa, "name", "values") : (T = !0, ra = function() {
                                            return d(ba, this);
                                        }));
                                        if (M) {
                                            var U = {
                                                values: L("values"),
                                                keys: I ? ra : L("keys"),
                                                entries: L("entries")
                                            };
                                            if (P) for(ma in U)!B && !T && ma in aa || r(aa, ma, U[ma]);
                                            else c({
                                                target: D,
                                                proto: !0,
                                                forced: B || T
                                            }, U);
                                        }
                                        e && !P || aa[z] === ra || r(aa, z, ra, {
                                            name: M
                                        });
                                        u[D] = ra;
                                        return U;
                                    };
                                },
                                713: function(g, f, a) {
                                    var b = a(9565), c = a(9306), d = a(8551), e = a(1767);
                                    f = a(9462);
                                    var h = a(6319), k = f(function() {
                                        var l = this.iterator, m = d(b(this.next, l));
                                        if (!(this.done = !!m.done)) return h(l, this.mapper, [
                                            m.value,
                                            this.counter++
                                        ], !0);
                                    });
                                    g.exports = function(l) {
                                        d(this);
                                        c(l);
                                        return new k(e(this), {
                                            mapper: l
                                        });
                                    };
                                },
                                7657: function(g, f, a) {
                                    f = a(9039);
                                    var b = a(4901), c = a(34), d = a(2360), e = a(2787), h = a(6840), k = a(8227);
                                    a = a(6395);
                                    var l = k("iterator");
                                    k = !1;
                                    var m;
                                    if ([].keys) {
                                        var n = [].keys();
                                        "next" in n ? (e = e(e(n)), e !== Object.prototype && (m = e)) : k = !0;
                                    }
                                    !c(m) || f(function() {
                                        var q = {};
                                        return m[l].call(q) !== q;
                                    }) ? m = {} : a && (m = d(m));
                                    b(m[l]) || h(m, l, function() {
                                        return this;
                                    });
                                    g.exports = {
                                        IteratorPrototype: m,
                                        BUGGY_SAFARI_ITERATORS: k
                                    };
                                },
                                6269: function(g) {
                                    g.exports = {};
                                },
                                6198: function(g, f, a) {
                                    var b = a(8014);
                                    g.exports = function(c) {
                                        return b(c.length);
                                    };
                                },
                                283: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(9039), c = a(4901), d = a(9297), e = a(3724), h = a(350).CONFIGURABLE, k = a(3706);
                                    a = a(1181);
                                    var l = a.enforce, m = a.get, n = String, q = Object.defineProperty, r = f("".slice), t = f("".replace), u = f([].join), v = e && !b(function() {
                                        return 8 !== q(function() {}, "length", {
                                            value: 8
                                        }).length;
                                    }), w = String(String).split("String");
                                    g = g.exports = function(x, B, z) {
                                        "Symbol(" === r(n(B), 0, 7) && (B = "[" + t(n(B), /^Symbol\(([^)]*)\).*$/, "$1") + "]");
                                        z && z.getter && (B = "get " + B);
                                        z && z.setter && (B = "set " + B);
                                        if (!d(x, "name") || h && x.name !== B) e ? q(x, "name", {
                                            value: B,
                                            configurable: !0
                                        }) : x.name = B;
                                        v && z && d(z, "arity") && x.length !== z.arity && q(x, "length", {
                                            value: z.arity
                                        });
                                        try {
                                            z && d(z, "constructor") && z.constructor ? e && q(x, "prototype", {
                                                writable: !1
                                            }) : x.prototype && (x.prototype = void 0);
                                        } catch (C) {}
                                        z = l(x);
                                        d(z, "source") || (z.source = u(w, "string" == typeof B ? B : ""));
                                        return x;
                                    };
                                    Function.prototype.toString = g(function() {
                                        return c(this) && m(this).source || k(this);
                                    }, "toString");
                                },
                                3164: function(g, f, a) {
                                    var b = a(7782), c = Math.abs;
                                    g.exports = function(d, e, h, k) {
                                        var l = +d;
                                        d = c(l);
                                        l = b(l);
                                        if (d < k) return l * (d / k / e + 4503599627370496 - 4503599627370496) * k * e;
                                        e = (1 + e / 2.220446049250313E-16) * d;
                                        e -= e - d;
                                        return e > h || e !== e ? Infinity * l : l * e;
                                    };
                                },
                                5617: function(g, f, a) {
                                    var b = a(3164);
                                    g.exports = Math.fround || function(c) {
                                        return b(c, 1.1920928955078125E-7, 3.4028234663852886E38, 1.1754943508222875E-38);
                                    };
                                },
                                7782: function(g) {
                                    g.exports = Math.sign || function(f) {
                                        f = +f;
                                        return 0 === f || f !== f ? f : 0 > f ? -1 : 1;
                                    };
                                },
                                741: function(g) {
                                    var f = Math.ceil, a = Math.floor;
                                    g.exports = Math.trunc || function(b) {
                                        b = +b;
                                        return (0 < b ? a : f)(b);
                                    };
                                },
                                1955: function(g, f, a) {
                                    var b = a(4576), c = a(3389);
                                    f = a(6080);
                                    var d = a(9225).set, e = a(8265), h = a(9544), k = a(4265), l = a(7860), m = a(8574), n = b.MutationObserver || b.WebKitMutationObserver, q = b.document, r = b.process;
                                    a = b.Promise;
                                    c = c("queueMicrotask");
                                    if (!c) {
                                        var t = new e, u = function() {
                                            var z, C;
                                            for(m && (z = r.domain) && z.exit(); C = t.get();)try {
                                                C();
                                            } catch (D) {
                                                throw t.head && w(), D;
                                            }
                                            z && z.enter();
                                        };
                                        if (h || m || l || !n || !q) {
                                            if (!k && a && a.resolve) {
                                                b = a.resolve(void 0);
                                                b.constructor = a;
                                                var v = f(b.then, b);
                                                var w = function() {
                                                    v(u);
                                                };
                                            } else m ? w = function() {
                                                r.nextTick(u);
                                            } : (d = f(d, b), w = function() {
                                                d(u);
                                            });
                                        } else {
                                            var x = !0;
                                            var B = q.createTextNode("");
                                            new n(u).observe(B, {
                                                characterData: !0
                                            });
                                            w = function() {
                                                B.data = x = !x;
                                            };
                                        }
                                        c = function(z) {
                                            t.head || w();
                                            t.add(z);
                                        };
                                    }
                                    g.exports = c;
                                },
                                6043: function(g, f, a) {
                                    function b(e) {
                                        var h, k;
                                        this.promise = new e(function(l, m) {
                                            if (void 0 !== h || void 0 !== k) throw new d("Bad Promise constructor");
                                            h = l;
                                            k = m;
                                        });
                                        this.resolve = c(h);
                                        this.reject = c(k);
                                    }
                                    var c = a(9306), d = TypeError;
                                    g.exports.f = function(e) {
                                        return new b(e);
                                    };
                                },
                                2603: function(g, f, a) {
                                    var b = a(655);
                                    g.exports = function(c, d) {
                                        return void 0 === c ? 2 > arguments.length ? "" : d : b(c);
                                    };
                                },
                                4149: function(g) {
                                    var f = RangeError;
                                    g.exports = function(a) {
                                        if (a === a) return a;
                                        throw new f("NaN is not allowed");
                                    };
                                },
                                2360: function(g, f, a) {
                                    function b() {
                                        try {
                                            q = new ActiveXObject("htmlfile");
                                        } catch (t) {}
                                        if ("undefined" != typeof document) {
                                            if (document.domain && q) var r = c(q);
                                            else r = m("iframe"), r.style.display = "none", l.appendChild(r), r.src = "javascript:", r = r.contentWindow.document, r.open(), r.write("<script>document.F=Object</script>"), r.close(), r = r.F;
                                        } else r = c(q);
                                        b = r;
                                        for(r = k.length; r--;)delete b.prototype[k[r]];
                                        return b();
                                    }
                                    function c(r) {
                                        r.write("<script></script>");
                                        r.close();
                                        return r.parentWindow.Object;
                                    }
                                    function d() {}
                                    var e = a(8551), h = a(6801), k = a(8727);
                                    f = a(421);
                                    var l = a(397), m = a(4055), n = a(6119)("IE_PROTO"), q;
                                    f[n] = !0;
                                    g.exports = Object.create || function(r, t) {
                                        if (null !== r) {
                                            d.prototype = e(r);
                                            var u = new d;
                                            d.prototype = null;
                                            u[n] = r;
                                        } else u = b();
                                        return void 0 === t ? u : h.f(u, t);
                                    };
                                },
                                6801: function(g, f, a) {
                                    g = a(3724);
                                    var b = a(8686), c = a(4913), d = a(8551), e = a(5397), h = a(1072);
                                    f.f = g && !b ? Object.defineProperties : function(k, l) {
                                        d(k);
                                        var m = e(l);
                                        l = h(l);
                                        for(var n = l.length, q = 0, r; n > q;)c.f(k, r = l[q++], m[r]);
                                        return k;
                                    };
                                },
                                4913: function(g, f, a) {
                                    g = a(3724);
                                    var b = a(5917), c = a(8686), d = a(8551), e = a(6969), h = TypeError, k = Object.defineProperty, l = Object.getOwnPropertyDescriptor;
                                    f.f = g ? c ? function(m, n, q) {
                                        d(m);
                                        n = e(n);
                                        d(q);
                                        if ("function" === typeof m && "prototype" === n && "value" in q && "writable" in q && !q.writable) {
                                            var r = l(m, n);
                                            r && r.writable && (m[n] = q.value, q = {
                                                configurable: "configurable" in q ? q.configurable : r.configurable,
                                                enumerable: "enumerable" in q ? q.enumerable : r.enumerable,
                                                writable: !1
                                            });
                                        }
                                        return k(m, n, q);
                                    } : k : function(m, n, q) {
                                        d(m);
                                        n = e(n);
                                        d(q);
                                        if (b) try {
                                            return k(m, n, q);
                                        } catch (r) {}
                                        if ("get" in q || "set" in q) throw new h("Accessors not supported");
                                        "value" in q && (m[n] = q.value);
                                        return m;
                                    };
                                },
                                7347: function(g, f, a) {
                                    g = a(3724);
                                    var b = a(9565), c = a(8773), d = a(6980), e = a(5397), h = a(6969), k = a(9297), l = a(5917), m = Object.getOwnPropertyDescriptor;
                                    f.f = g ? m : function(n, q) {
                                        n = e(n);
                                        q = h(q);
                                        if (l) try {
                                            return m(n, q);
                                        } catch (r) {}
                                        if (k(n, q)) return d(!b(c.f, n, q), n[q]);
                                    };
                                },
                                8480: function(g, f, a) {
                                    var b = a(1828), c = a(8727).concat("length", "prototype");
                                    f.f = Object.getOwnPropertyNames || function(d) {
                                        return b(d, c);
                                    };
                                },
                                3717: function(g, f) {
                                    f.f = Object.getOwnPropertySymbols;
                                },
                                2787: function(g, f, a) {
                                    var b = a(9297), c = a(4901), d = a(8981);
                                    f = a(6119);
                                    a = a(2211);
                                    var e = f("IE_PROTO"), h = Object, k = h.prototype;
                                    g.exports = a ? h.getPrototypeOf : function(l) {
                                        l = d(l);
                                        if (b(l, e)) return l[e];
                                        var m = l.constructor;
                                        return c(m) && l instanceof m ? m.prototype : l instanceof h ? k : null;
                                    };
                                },
                                1625: function(g, f, a) {
                                    f = a(9504);
                                    g.exports = f({}.isPrototypeOf);
                                },
                                1828: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(9297), c = a(5397), d = a(9617).indexOf, e = a(421), h = f([].push);
                                    g.exports = function(k, l) {
                                        k = c(k);
                                        var m = 0, n = [], q;
                                        for(q in k)!b(e, q) && b(k, q) && h(n, q);
                                        for(; l.length > m;)b(k, q = l[m++]) && (~d(n, q) || h(n, q));
                                        return n;
                                    };
                                },
                                1072: function(g, f, a) {
                                    var b = a(1828), c = a(8727);
                                    g.exports = Object.keys || function(d) {
                                        return b(d, c);
                                    };
                                },
                                8773: function(g, f) {
                                    g = ({}).propertyIsEnumerable;
                                    var a = Object.getOwnPropertyDescriptor, b = a && !g.call({
                                        1: 2
                                    }, 1);
                                    f.f = b ? function(c) {
                                        c = a(this, c);
                                        return !!c && c.enumerable;
                                    } : g;
                                },
                                2967: function(g, f, a) {
                                    var b = a(6706), c = a(34), d = a(7750), e = a(3506);
                                    g.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                                        var h = !1, k = {};
                                        try {
                                            var l = b(Object.prototype, "__proto__", "set");
                                            l(k, []);
                                            h = k instanceof Array;
                                        } catch (m) {}
                                        return function(m, n) {
                                            d(m);
                                            e(n);
                                            if (!c(m)) return m;
                                            h ? l(m, n) : m.__proto__ = n;
                                            return m;
                                        };
                                    }() : void 0);
                                },
                                2357: function(g, f, a) {
                                    function b(q) {
                                        return function(r) {
                                            r = k(r);
                                            for(var t = h(r), u = n && null === e(r), v = t.length, w = 0, x = [], B; v > w;)B = t[w++], (!c || (u ? B in r : l(r, B))) && m(x, q ? [
                                                B,
                                                r[B]
                                            ] : r[B]);
                                            return x;
                                        };
                                    }
                                    var c = a(3724);
                                    f = a(9039);
                                    var d = a(9504), e = a(2787), h = a(1072), k = a(5397);
                                    a = a(8773).f;
                                    var l = d(a), m = d([].push), n = c && f(function() {
                                        var q = Object.create(null);
                                        q[2] = 2;
                                        return !l(q, 2);
                                    });
                                    g.exports = {
                                        entries: b(!0),
                                        values: b(!1)
                                    };
                                },
                                4270: function(g, f, a) {
                                    var b = a(9565), c = a(4901), d = a(34), e = TypeError;
                                    g.exports = function(h, k) {
                                        var l, m;
                                        if ("string" === k && c(l = h.toString) && !d(m = b(l, h)) || c(l = h.valueOf) && !d(m = b(l, h)) || "string" !== k && c(l = h.toString) && !d(m = b(l, h))) return m;
                                        throw new e("Can't convert object to primitive value");
                                    };
                                },
                                5031: function(g, f, a) {
                                    f = a(7751);
                                    var b = a(9504), c = a(8480), d = a(3717), e = a(8551), h = b([].concat);
                                    g.exports = f("Reflect", "ownKeys") || function(k) {
                                        var l = c.f(e(k)), m = d.f;
                                        return m ? h(l, m(k)) : l;
                                    };
                                },
                                8235: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(9297), c = SyntaxError, d = parseInt, e = String.fromCharCode, h = f("".charAt), k = f("".slice), l = f(/./.exec), m = {
                                        '\\"': '"',
                                        "\\\\": "\\",
                                        "\\/": "/",
                                        "\\b": "\b",
                                        "\\f": "\f",
                                        "\\n": "\n",
                                        "\\r": "\r",
                                        "\\t": "	"
                                    }, n = /^[\da-f]{4}$/i, q = /^[\u0000-\u001F]$/;
                                    g.exports = function(r, t) {
                                        for(var u = !0, v = ""; t < r.length;){
                                            var w = h(r, t);
                                            if ("\\" === w) {
                                                if (w = k(r, t, t + 2), b(m, w)) v += m[w], t += 2;
                                                else if ("\\u" === w) {
                                                    t += 2;
                                                    w = k(r, t, t + 4);
                                                    if (!l(n, w)) throw new c("Bad Unicode escape at: " + t);
                                                    v += e(d(w, 16));
                                                    t += 4;
                                                } else throw new c('Unknown escape sequence: "' + w + '"');
                                            } else if ('"' === w) {
                                                u = !1;
                                                t++;
                                                break;
                                            } else {
                                                if (l(q, w)) throw new c("Bad control character in string literal at: " + t);
                                                v += w;
                                                t++;
                                            }
                                        }
                                        if (u) throw new c("Unterminated string at: " + t);
                                        return {
                                            value: v,
                                            end: t
                                        };
                                    };
                                },
                                1103: function(g) {
                                    g.exports = function(f) {
                                        try {
                                            return {
                                                error: !1,
                                                value: f()
                                            };
                                        } catch (a) {
                                            return {
                                                error: !0,
                                                value: a
                                            };
                                        }
                                    };
                                },
                                916: function(g, f, a) {
                                    f = a(4576);
                                    var b = a(550), c = a(4901), d = a(2796), e = a(3706), h = a(8227), k = a(4215), l = a(6395), m = a(9519), n = b && b.prototype, q = h("species"), r = !1, t = c(f.PromiseRejectionEvent);
                                    a = d("Promise", function() {
                                        var u = e(b), v = u !== String(b);
                                        if (!v && 66 === m || l && (!n["catch"] || !n["finally"])) return !0;
                                        if (!m || 51 > m || !/native code/.test(u)) {
                                            u = new b(function(x) {
                                                x(1);
                                            });
                                            var w = function(x) {
                                                x(function() {}, function() {});
                                            };
                                            (u.constructor = {})[q] = w;
                                            r = u.then(function() {}) instanceof w;
                                            if (!r) return !0;
                                        }
                                        return !v && ("BROWSER" === k || "DENO" === k) && !t;
                                    });
                                    g.exports = {
                                        CONSTRUCTOR: a,
                                        REJECTION_EVENT: t,
                                        SUBCLASSING: r
                                    };
                                },
                                550: function(g, f, a) {
                                    f = a(4576);
                                    g.exports = f.Promise;
                                },
                                3438: function(g, f, a) {
                                    var b = a(8551), c = a(34), d = a(6043);
                                    g.exports = function(e, h) {
                                        b(e);
                                        if (c(h) && h.constructor === e) return h;
                                        e = d.f(e);
                                        var k = e.resolve;
                                        k(h);
                                        return e.promise;
                                    };
                                },
                                537: function(g, f, a) {
                                    var b = a(550);
                                    f = a(4428);
                                    a = a(916).CONSTRUCTOR;
                                    g.exports = a || !f(function(c) {
                                        b.all(c).then(void 0, function() {});
                                    });
                                },
                                1056: function(g, f, a) {
                                    var b = a(4913).f;
                                    g.exports = function(c, d, e) {
                                        e in c || b(c, e, {
                                            configurable: !0,
                                            get: function() {
                                                return d[e];
                                            },
                                            set: function(h) {
                                                d[e] = h;
                                            }
                                        });
                                    };
                                },
                                8265: function(g) {
                                    function f() {
                                        this.tail = this.head = null;
                                    }
                                    f.prototype = {
                                        add: function(a) {
                                            a = {
                                                item: a,
                                                next: null
                                            };
                                            var b = this.tail;
                                            b ? b.next = a : this.head = a;
                                            this.tail = a;
                                        },
                                        get: function() {
                                            var a = this.head;
                                            if (a) return null === (this.head = a.next) && (this.tail = null), a.item;
                                        }
                                    };
                                    g.exports = f;
                                },
                                6682: function(g, f, a) {
                                    var b = a(9565), c = a(8551), d = a(4901), e = a(2195), h = a(7323), k = TypeError;
                                    g.exports = function(l, m) {
                                        var n = l.exec;
                                        if (d(n)) return l = b(n, l, m), null !== l && c(l), l;
                                        if ("RegExp" === e(l)) return b(h, l, m);
                                        throw new k("RegExp#exec called on incompatible receiver");
                                    };
                                },
                                7323: function(g, f, a) {
                                    var b = a(9565);
                                    f = a(9504);
                                    var c = a(655), d = a(7979), e = a(8429), h = a(5745), k = a(2360), l = a(1181).get, m = a(3635);
                                    a = a(8814);
                                    var n = h("native-string-replace", String.prototype.replace), q = RegExp.prototype.exec, r = q, t = f("".charAt), u = f("".indexOf), v = f("".replace), w = f("".slice), x = function() {
                                        var C = /a/, D = /b*/g;
                                        b(q, C, "a");
                                        b(q, D, "a");
                                        return 0 !== C.lastIndex || 0 !== D.lastIndex;
                                    }(), B = e.BROKEN_CARET, z = void 0 !== /()??/.exec("")[1];
                                    if (x || z || B || m || a) r = function(C) {
                                        var D = l(this);
                                        C = c(C);
                                        var H = D.raw, J;
                                        if (H) {
                                            H.lastIndex = this.lastIndex;
                                            var M = b(r, H, C);
                                            this.lastIndex = H.lastIndex;
                                            return M;
                                        }
                                        D = D.groups;
                                        H = B && this.sticky;
                                        var I = b(d, this), P = this.source, L = 0, T = C;
                                        H && (I = v(I, "y", ""), -1 === u(I, "g") && (I += "g"), T = w(C, this.lastIndex), 0 < this.lastIndex && (!this.multiline || this.multiline && "\n" !== t(C, this.lastIndex - 1)) && (P = "(?: " + P + ")", T = " " + T, L++), M = new RegExp("^(?:" + P + ")", I));
                                        z && (M = new RegExp("^" + P + "$(?!\\s)", I));
                                        if (x) var aa = this.lastIndex;
                                        var ba = b(q, H ? M : this, T);
                                        H ? ba ? (ba.input = w(ba.input, L), ba[0] = w(ba[0], L), ba.index = this.lastIndex, this.lastIndex += ba[0].length) : this.lastIndex = 0 : x && ba && (this.lastIndex = this.global ? ba.index + ba[0].length : aa);
                                        z && ba && 1 < ba.length && b(n, ba[0], M, function() {
                                            for(J = 1; J < arguments.length - 2; J++)void 0 === arguments[J] && (ba[J] = void 0);
                                        });
                                        if (ba && D) for(ba.groups = M = k(null), J = 0; J < D.length; J++)aa = D[J], M[aa[0]] = ba[aa[1]];
                                        return ba;
                                    };
                                    g.exports = r;
                                },
                                7979: function(g, f, a) {
                                    var b = a(8551);
                                    g.exports = function() {
                                        var c = b(this), d = "";
                                        c.hasIndices && (d += "d");
                                        c.global && (d += "g");
                                        c.ignoreCase && (d += "i");
                                        c.multiline && (d += "m");
                                        c.dotAll && (d += "s");
                                        c.unicode && (d += "u");
                                        c.unicodeSets && (d += "v");
                                        c.sticky && (d += "y");
                                        return d;
                                    };
                                },
                                1034: function(g, f, a) {
                                    var b = a(9565), c = a(9297), d = a(1625), e = a(7979), h = RegExp.prototype;
                                    g.exports = function(k) {
                                        var l = k.flags;
                                        return void 0 !== l || "flags" in h || c(k, "flags") || !d(h, k) ? l : b(e, k);
                                    };
                                },
                                8429: function(g, f, a) {
                                    f = a(9039);
                                    var b = a(4576).RegExp, c = (a = f(function() {
                                        var d = b("a", "y");
                                        d.lastIndex = 2;
                                        return null !== d.exec("abcd");
                                    })) || f(function() {
                                        return !b("a", "y").sticky;
                                    });
                                    f = a || f(function() {
                                        var d = b("^r", "gy");
                                        d.lastIndex = 2;
                                        return null !== d.exec("str");
                                    });
                                    g.exports = {
                                        BROKEN_CARET: f,
                                        MISSED_STICKY: c,
                                        UNSUPPORTED_Y: a
                                    };
                                },
                                3635: function(g, f, a) {
                                    f = a(9039);
                                    var b = a(4576).RegExp;
                                    g.exports = f(function() {
                                        var c = b(".", "s");
                                        return !(c.dotAll && c.test("\n") && "s" === c.flags);
                                    });
                                },
                                8814: function(g, f, a) {
                                    f = a(9039);
                                    var b = a(4576).RegExp;
                                    g.exports = f(function() {
                                        var c = b("(?<a>b)", "g");
                                        return "b" !== c.exec("b").groups.a || "bc" !== "b".replace(c, "$<a>c");
                                    });
                                },
                                7750: function(g, f, a) {
                                    var b = a(4117), c = TypeError;
                                    g.exports = function(d) {
                                        if (b(d)) throw new c("Can't call method on " + d);
                                        return d;
                                    };
                                },
                                3389: function(g, f, a) {
                                    var b = a(4576), c = a(3724), d = Object.getOwnPropertyDescriptor;
                                    g.exports = function(e) {
                                        return c ? (e = d(b, e)) && e.value : b[e];
                                    };
                                },
                                9286: function(g, f, a) {
                                    f = a(4402);
                                    var b = a(8469), c = f.Set, d = f.add;
                                    g.exports = function(e) {
                                        var h = new c;
                                        b(e, function(k) {
                                            d(h, k);
                                        });
                                        return h;
                                    };
                                },
                                3440: function(g, f, a) {
                                    var b = a(7080);
                                    f = a(4402);
                                    var c = a(9286), d = a(5170), e = a(3789), h = a(8469), k = a(507), l = f.has, m = f.remove;
                                    g.exports = function(n) {
                                        var q = b(this), r = e(n), t = c(q);
                                        d(q) <= r.size ? h(q, function(u) {
                                            r.includes(u) && m(t, u);
                                        }) : k(r.getIterator(), function(u) {
                                            l(q, u) && m(t, u);
                                        });
                                        return t;
                                    };
                                },
                                4402: function(g, f, a) {
                                    f = a(9504);
                                    a = Set.prototype;
                                    g.exports = {
                                        Set: Set,
                                        add: f(a.add),
                                        has: f(a.has),
                                        remove: f(a["delete"]),
                                        proto: a
                                    };
                                },
                                8750: function(g, f, a) {
                                    var b = a(7080);
                                    f = a(4402);
                                    var c = a(5170), d = a(3789), e = a(8469), h = a(507), k = f.Set, l = f.add, m = f.has;
                                    g.exports = function(n) {
                                        var q = b(this), r = d(n), t = new k;
                                        c(q) > r.size ? h(r.getIterator(), function(u) {
                                            m(q, u) && l(t, u);
                                        }) : e(q, function(u) {
                                            r.includes(u) && l(t, u);
                                        });
                                        return t;
                                    };
                                },
                                4449: function(g, f, a) {
                                    var b = a(7080), c = a(4402).has, d = a(5170), e = a(3789), h = a(8469), k = a(507), l = a(9539);
                                    g.exports = function(m) {
                                        var n = b(this), q = e(m);
                                        if (d(n) <= q.size) return !1 !== h(n, function(t) {
                                            if (q.includes(t)) return !1;
                                        }, !0);
                                        var r = q.getIterator();
                                        return !1 !== k(r, function(t) {
                                            if (c(n, t)) return l(r, "normal", !1);
                                        });
                                    };
                                },
                                3838: function(g, f, a) {
                                    var b = a(7080), c = a(5170), d = a(8469), e = a(3789);
                                    g.exports = function(h) {
                                        var k = b(this), l = e(h);
                                        return c(k) > l.size ? !1 : !1 !== d(k, function(m) {
                                            if (!l.includes(m)) return !1;
                                        }, !0);
                                    };
                                },
                                8527: function(g, f, a) {
                                    var b = a(7080), c = a(4402).has, d = a(5170), e = a(3789), h = a(507), k = a(9539);
                                    g.exports = function(l) {
                                        var m = b(this);
                                        l = e(l);
                                        if (d(m) < l.size) return !1;
                                        var n = l.getIterator();
                                        return !1 !== h(n, function(q) {
                                            if (!c(m, q)) return k(n, "normal", !1);
                                        });
                                    };
                                },
                                8469: function(g, f, a) {
                                    f = a(9504);
                                    var b = a(507), c = a(4402);
                                    a = c.Set;
                                    c = c.proto;
                                    var d = f(c.forEach), e = f(c.keys), h = e(new a).next;
                                    g.exports = function(k, l, m) {
                                        return m ? b({
                                            iterator: e(k),
                                            next: h
                                        }, l) : d(k, l);
                                    };
                                },
                                4916: function(g, f, a) {
                                    function b(d) {
                                        return {
                                            size: d,
                                            has: function() {
                                                return !1;
                                            },
                                            keys: function() {
                                                return {
                                                    next: function() {
                                                        return {
                                                            done: !0
                                                        };
                                                    }
                                                };
                                            }
                                        };
                                    }
                                    var c = a(7751);
                                    g.exports = function(d) {
                                        var e = c("Set");
                                        try {
                                            (new e)[d](b(0));
                                            try {
                                                return (new e)[d](b(-1)), !1;
                                            } catch (h) {
                                                return !0;
                                            }
                                        } catch (h) {
                                            return !1;
                                        }
                                    };
                                },
                                5170: function(g, f, a) {
                                    f = a(6706);
                                    a = a(4402);
                                    g.exports = f(a.proto, "size", "get") || function(b) {
                                        return b.size;
                                    };
                                },
                                7633: function(g, f, a) {
                                    var b = a(7751), c = a(2106);
                                    f = a(8227);
                                    var d = a(3724), e = f("species");
                                    g.exports = function(h) {
                                        h = b(h);
                                        d && h && !h[e] && c(h, e, {
                                            configurable: !0,
                                            get: function() {
                                                return this;
                                            }
                                        });
                                    };
                                },
                                3650: function(g, f, a) {
                                    var b = a(7080);
                                    f = a(4402);
                                    var c = a(9286), d = a(3789), e = a(507), h = f.add, k = f.has, l = f.remove;
                                    g.exports = function(m) {
                                        var n = b(this);
                                        m = d(m).getIterator();
                                        var q = c(n);
                                        e(m, function(r) {
                                            k(n, r) ? l(q, r) : h(q, r);
                                        });
                                        return q;
                                    };
                                },
                                687: function(g, f, a) {
                                    var b = a(4913).f, c = a(9297), d = a(8227)("toStringTag");
                                    g.exports = function(e, h, k) {
                                        e && !k && (e = e.prototype);
                                        e && !c(e, d) && b(e, d, {
                                            configurable: !0,
                                            value: h
                                        });
                                    };
                                },
                                4204: function(g, f, a) {
                                    var b = a(7080), c = a(4402).add, d = a(9286), e = a(3789), h = a(507);
                                    g.exports = function(k) {
                                        var l = b(this);
                                        k = e(k).getIterator();
                                        var m = d(l);
                                        h(k, function(n) {
                                            c(m, n);
                                        });
                                        return m;
                                    };
                                },
                                6119: function(g, f, a) {
                                    f = a(5745);
                                    var b = a(3392), c = f("keys");
                                    g.exports = function(d) {
                                        return c[d] || (c[d] = b(d));
                                    };
                                },
                                7629: function(g, f, a) {
                                    f = a(6395);
                                    var b = a(4576);
                                    a = a(9433);
                                    g = g.exports = b["__core-js_shared__"] || a("__core-js_shared__", {});
                                    (g.versions || (g.versions = [])).push({
                                        version: "3.38.1",
                                        mode: f ? "pure" : "global",
                                        copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
                                        license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
                                        source: "https://github.com/zloirock/core-js"
                                    });
                                },
                                5745: function(g, f, a) {
                                    var b = a(7629);
                                    g.exports = function(c, d) {
                                        return b[c] || (b[c] = d || {});
                                    };
                                },
                                2293: function(g, f, a) {
                                    var b = a(8551), c = a(5548), d = a(4117), e = a(8227)("species");
                                    g.exports = function(h, k) {
                                        h = b(h).constructor;
                                        var l;
                                        return void 0 === h || d(l = b(h)[e]) ? k : c(l);
                                    };
                                },
                                8183: function(g, f, a) {
                                    function b(m) {
                                        return function(n, q) {
                                            n = d(e(n));
                                            q = c(q);
                                            var r = n.length, t;
                                            if (0 > q || q >= r) return m ? "" : void 0;
                                            var u = k(n, q);
                                            return 55296 > u || 56319 < u || q + 1 === r || 56320 > (t = k(n, q + 1)) || 57343 < t ? m ? h(n, q) : u : m ? l(n, q, q + 2) : (u - 55296 << 10) + (t - 56320) + 65536;
                                        };
                                    }
                                    f = a(9504);
                                    var c = a(1291), d = a(655), e = a(7750), h = f("".charAt), k = f("".charCodeAt), l = f("".slice);
                                    g.exports = {
                                        codeAt: b(!1),
                                        charAt: b(!0)
                                    };
                                },
                                3063: function(g, f, a) {
                                    f = a(2839);
                                    g.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(f);
                                },
                                533: function(g, f, a) {
                                    function b(n) {
                                        return function(q, r, t) {
                                            q = d(h(q));
                                            r = c(r);
                                            var u = q.length;
                                            t = void 0 === t ? " " : d(t);
                                            if (r <= u || "" === t) return q;
                                            r -= u;
                                            t = k(t, m(r / t.length));
                                            t.length > r && (t = l(t, 0, r));
                                            return n ? q + t : t + q;
                                        };
                                    }
                                    f = a(9504);
                                    var c = a(8014), d = a(655), e = a(2333), h = a(7750), k = f(e), l = f("".slice), m = Math.ceil;
                                    g.exports = {
                                        start: b(!1),
                                        end: b(!0)
                                    };
                                },
                                2333: function(g, f, a) {
                                    var b = a(1291), c = a(655), d = a(7750), e = RangeError;
                                    g.exports = function(h) {
                                        var k = c(d(this)), l = "";
                                        h = b(h);
                                        if (0 > h || Infinity === h) throw new e("Wrong number of repetitions");
                                        for(; 0 < h; (h >>>= 1) && (k += k))h & 1 && (l += k);
                                        return l;
                                    };
                                },
                                8866: function(g, f, a) {
                                    var b = a(3802).end;
                                    f = a(706);
                                    g.exports = f("trimEnd") ? function() {
                                        return b(this);
                                    } : "".trimEnd;
                                },
                                706: function(g, f, a) {
                                    var b = a(350).PROPER, c = a(9039), d = a(7452);
                                    g.exports = function(e) {
                                        return c(function() {
                                            return !!d[e]() || "\u200B\x85\u180E" !== "\u200B\x85\u180E"[e]() || b && d[e].name !== e;
                                        });
                                    };
                                },
                                3802: function(g, f, a) {
                                    function b(l) {
                                        return function(m) {
                                            m = d(c(m));
                                            l & 1 && (m = e(m, h, ""));
                                            l & 2 && (m = e(m, k, "$1"));
                                            return m;
                                        };
                                    }
                                    f = a(9504);
                                    var c = a(7750), d = a(655);
                                    a = a(7452);
                                    var e = f("".replace), h = RegExp("^[" + a + "]+"), k = RegExp("(^|[^" + a + "])[" + a + "]+$");
                                    g.exports = {
                                        start: b(1),
                                        end: b(2),
                                        trim: b(3)
                                    };
                                },
                                1548: function(g, f, a) {
                                    f = a(4576);
                                    var b = a(9039), c = a(9519), d = a(4215), e = f.structuredClone;
                                    g.exports = !!e && !b(function() {
                                        if ("DENO" === d && 92 < c || "NODE" === d && 94 < c || "BROWSER" === d && 97 < c) return !1;
                                        var h = new ArrayBuffer(8), k = e(h, {
                                            transfer: [
                                                h
                                            ]
                                        });
                                        return 0 !== h.byteLength || 8 !== k.byteLength;
                                    });
                                },
                                4495: function(g, f, a) {
                                    var b = a(9519);
                                    f = a(9039);
                                    var c = a(4576).String;
                                    g.exports = !!Object.getOwnPropertySymbols && !f(function() {
                                        var d = Symbol("symbol detection");
                                        return !c(d) || !(Object(d) instanceof Symbol) || !Symbol.sham && b && 41 > b;
                                    });
                                },
                                9225: function(g, f, a) {
                                    function b(L) {
                                        h.postMessage(H(L), I.protocol + "//" + I.host);
                                    }
                                    function c(L) {
                                        e(L.data);
                                    }
                                    function d(L) {
                                        return function() {
                                            e(L);
                                        };
                                    }
                                    function e(L) {
                                        if (m(M, L)) {
                                            var T = M[L];
                                            delete M[L];
                                            T();
                                        }
                                    }
                                    var h = a(4576), k = a(8745);
                                    f = a(6080);
                                    var l = a(4901), m = a(9297), n = a(9039), q = a(397), r = a(7680), t = a(4055), u = a(2812), v = a(9544), w = a(8574);
                                    a = h.setImmediate;
                                    var x = h.clearImmediate, B = h.process, z = h.Dispatch, C = h.Function, D = h.MessageChannel, H = h.String, J = 0, M = {}, I;
                                    n(function() {
                                        I = h.location;
                                    });
                                    if (!a || !x) {
                                        if (a = function(L) {
                                            u(arguments.length, 1);
                                            var T = l(L) ? L : C(L), aa = r(arguments, 1);
                                            M[++J] = function() {
                                                k(T, void 0, aa);
                                            };
                                            P(J);
                                            return J;
                                        }, x = function(L) {
                                            delete M[L];
                                        }, w) var P = function(L) {
                                            B.nextTick(d(L));
                                        };
                                        else z && z.now ? P = function(L) {
                                            z.now(d(L));
                                        } : D && !v ? (n = new D, v = n.port2, n.port1.onmessage = c, P = f(v.postMessage, v)) : h.addEventListener && l(h.postMessage) && !h.importScripts && I && "file:" !== I.protocol && !n(b) ? (P = b, h.addEventListener("message", c, !1)) : P = "onreadystatechange" in t("script") ? function(L) {
                                            q.appendChild(t("script")).onreadystatechange = function() {
                                                q.removeChild(this);
                                                e(L);
                                            };
                                        } : function(L) {
                                            setTimeout(d(L), 0);
                                        };
                                    }
                                    g.exports = {
                                        set: a,
                                        clear: x
                                    };
                                },
                                5610: function(g, f, a) {
                                    var b = a(1291), c = Math.max, d = Math.min;
                                    g.exports = function(e, h) {
                                        e = b(e);
                                        return 0 > e ? c(e + h, 0) : d(e, h);
                                    };
                                },
                                5854: function(g, f, a) {
                                    var b = a(2777), c = TypeError;
                                    g.exports = function(d) {
                                        d = b(d, "number");
                                        if ("number" == typeof d) throw new c("Can't convert number to bigint");
                                        return BigInt(d);
                                    };
                                },
                                7696: function(g, f, a) {
                                    var b = a(1291), c = a(8014), d = RangeError;
                                    g.exports = function(e) {
                                        if (void 0 === e) return 0;
                                        e = b(e);
                                        var h = c(e);
                                        if (e !== h) throw new d("Wrong length or index");
                                        return h;
                                    };
                                },
                                5397: function(g, f, a) {
                                    var b = a(7055), c = a(7750);
                                    g.exports = function(d) {
                                        return b(c(d));
                                    };
                                },
                                1291: function(g, f, a) {
                                    var b = a(741);
                                    g.exports = function(c) {
                                        c = +c;
                                        return c !== c || 0 === c ? 0 : b(c);
                                    };
                                },
                                8014: function(g, f, a) {
                                    var b = a(1291), c = Math.min;
                                    g.exports = function(d) {
                                        d = b(d);
                                        return 0 < d ? c(d, 9007199254740991) : 0;
                                    };
                                },
                                8981: function(g, f, a) {
                                    var b = a(7750), c = Object;
                                    g.exports = function(d) {
                                        return c(b(d));
                                    };
                                },
                                8229: function(g, f, a) {
                                    var b = a(9590), c = RangeError;
                                    g.exports = function(d, e) {
                                        d = b(d);
                                        if (d % e) throw new c("Wrong offset");
                                        return d;
                                    };
                                },
                                9590: function(g, f, a) {
                                    var b = a(1291), c = RangeError;
                                    g.exports = function(d) {
                                        d = b(d);
                                        if (0 > d) throw new c("The argument can't be less than 0");
                                        return d;
                                    };
                                },
                                2777: function(g, f, a) {
                                    var b = a(9565), c = a(34), d = a(757), e = a(5966), h = a(4270);
                                    f = a(8227);
                                    var k = TypeError, l = f("toPrimitive");
                                    g.exports = function(m, n) {
                                        if (!c(m) || d(m)) return m;
                                        var q = e(m, l);
                                        if (q) {
                                            void 0 === n && (n = "default");
                                            m = b(q, m, n);
                                            if (!c(m) || d(m)) return m;
                                            throw new k("Can't convert object to primitive value");
                                        }
                                        void 0 === n && (n = "number");
                                        return h(m, n);
                                    };
                                },
                                6969: function(g, f, a) {
                                    var b = a(2777), c = a(757);
                                    g.exports = function(d) {
                                        d = b(d, "string");
                                        return c(d) ? d : d + "";
                                    };
                                },
                                2140: function(g, f, a) {
                                    f = a(8227)("toStringTag");
                                    a = {};
                                    a[f] = "z";
                                    g.exports = "[object z]" === String(a);
                                },
                                655: function(g, f, a) {
                                    var b = a(6955), c = String;
                                    g.exports = function(d) {
                                        if ("Symbol" === b(d)) throw new TypeError("Cannot convert a Symbol value to a string");
                                        return c(d);
                                    };
                                },
                                8319: function(g) {
                                    var f = Math.round;
                                    g.exports = function(a) {
                                        a = f(a);
                                        return 0 > a ? 0 : 255 < a ? 255 : a & 255;
                                    };
                                },
                                6823: function(g) {
                                    var f = String;
                                    g.exports = function(a) {
                                        try {
                                            return f(a);
                                        } catch (b) {
                                            return "Object";
                                        }
                                    };
                                },
                                5823: function(g, f, a) {
                                    function b(la, ta, Ca) {
                                        ta = D(ta);
                                        return !(d(la, ta) && M(Ca) && H(Ca, "value")) || H(Ca, "get") || H(Ca, "set") || Ca.configurable || H(Ca, "writable") && !Ca.writable || H(Ca, "enumerable") && !Ca.enumerable ? va(la, ta, Ca) : (la[ta] = Ca.value, la);
                                    }
                                    function c(la, ta) {
                                        ta = D(ta);
                                        return d(la, ta) ? u(2, la[ta]) : za(la, ta);
                                    }
                                    function d(la, ta) {
                                        return xa(la) && !I(ta) && ta in la && w(+ta) && 0 <= ta;
                                    }
                                    function e(la) {
                                        var ta;
                                        return L(Z, la) || "ArrayBuffer" === (ta = J(la)) || "SharedArrayBuffer" === ta;
                                    }
                                    function h(la, ta) {
                                        ma(la, ta, {
                                            configurable: !0,
                                            get: function() {
                                                return ia(this)[ta];
                                            }
                                        });
                                    }
                                    var k = a(6518), l = a(4576), m = a(9565);
                                    f = a(3724);
                                    var n = a(2805), q = a(4644), r = a(6346), t = a(679), u = a(6980), v = a(6699), w = a(2087), x = a(8014), B = a(7696), z = a(8229), C = a(8319), D = a(6969), H = a(9297), J = a(6955), M = a(34), I = a(757), P = a(2360), L = a(1625), T = a(2967), aa = a(8480).f, ba = a(3251), ra = a(9213).forEach, X = a(7633), ma = a(2106), U = a(4913), K = a(7347), N = a(5370), V = a(1181), ea = a(3167), ia = V.get, na = V.set, ua = V.enforce, va = U.f, za = K.f, Ha = l.RangeError, Ia = r.ArrayBuffer, Z = Ia.prototype, ja = r.DataView, ka = q.NATIVE_ARRAY_BUFFER_VIEWS, O = q.TYPED_ARRAY_TAG, Y = q.TypedArray, oa = q.TypedArrayPrototype, xa = q.isTypedArray;
                                    f ? (ka || (K.f = c, U.f = b, h(oa, "buffer"), h(oa, "byteOffset"), h(oa, "byteLength"), h(oa, "length")), k({
                                        target: "Object",
                                        stat: !0,
                                        forced: !ka
                                    }, {
                                        getOwnPropertyDescriptor: c,
                                        defineProperty: b
                                    }), g.exports = function(la, ta, Ca) {
                                        function nb(Na, ya) {
                                            va(Na, ya, {
                                                get: function() {
                                                    var Oa = ia(this);
                                                    return Oa.view[hg](ya * Ga + Oa.byteOffset, !0);
                                                },
                                                set: function(Oa) {
                                                    var Ja = ia(this);
                                                    Ja.view[ig](ya * Ga + Ja.byteOffset, Ca ? C(Oa) : Oa, !0);
                                                },
                                                enumerable: !0
                                            });
                                        }
                                        var Ga = la.match(/\d+/)[0] / 8, Kb = la + (Ca ? "Clamped" : "") + "Array", hg = "get" + la, ig = "set" + la, Xa = l[Kb], Da = Xa, Qa = Da && Da.prototype;
                                        la = {};
                                        ka ? n && (Da = ta(function(Na, ya, Oa, Ja) {
                                            t(Na, Qa);
                                            return ea(M(ya) ? e(ya) ? void 0 !== Ja ? new Xa(ya, z(Oa, Ga), Ja) : void 0 !== Oa ? new Xa(ya, z(Oa, Ga)) : new Xa(ya) : xa(ya) ? N(Da, ya) : m(ba, Da, ya) : new Xa(B(ya)), Na, Da);
                                        }), T && T(Da, Y), ra(aa(Xa), function(Na) {
                                            Na in Da || v(Da, Na, Xa[Na]);
                                        }), Da.prototype = Qa) : (Da = ta(function(Na, ya, Oa, Ja) {
                                            t(Na, Qa);
                                            var ze = 0, Lb = 0;
                                            if (M(ya)) {
                                                if (e(ya)) {
                                                    var Hc = ya;
                                                    Lb = z(Oa, Ga);
                                                    ya = ya.byteLength;
                                                    if (void 0 === Ja) {
                                                        if (ya % Ga) throw new Ha("Wrong length");
                                                        Ja = ya - Lb;
                                                        if (0 > Ja) throw new Ha("Wrong length");
                                                    } else if (Ja = x(Ja) * Ga, Ja + Lb > ya) throw new Ha("Wrong length");
                                                    ya = Ja / Ga;
                                                } else return xa(ya) ? N(Da, ya) : m(ba, Da, ya);
                                            } else ya = B(ya), Ja = ya * Ga, Hc = new Ia(Ja);
                                            for(na(Na, {
                                                buffer: Hc,
                                                byteOffset: Lb,
                                                byteLength: Ja,
                                                length: ya,
                                                view: new ja(Hc)
                                            }); ze < ya;)nb(Na, ze++);
                                        }), T && T(Da, Y), Qa = Da.prototype = P(oa));
                                        Qa.constructor !== Da && v(Qa, "constructor", Da);
                                        ua(Qa).TypedArrayConstructor = Da;
                                        O && v(Qa, O, Kb);
                                        la[Kb] = Da;
                                        k({
                                            global: !0,
                                            constructor: !0,
                                            forced: Da !== Xa,
                                            sham: !ka
                                        }, la);
                                        "BYTES_PER_ELEMENT" in Da || v(Da, "BYTES_PER_ELEMENT", Ga);
                                        "BYTES_PER_ELEMENT" in Qa || v(Qa, "BYTES_PER_ELEMENT", Ga);
                                        X(Kb);
                                    }) : g.exports = function() {};
                                },
                                2805: function(g, f, a) {
                                    f = a(4576);
                                    var b = a(9039), c = a(4428);
                                    a = a(4644).NATIVE_ARRAY_BUFFER_VIEWS;
                                    var d = f.ArrayBuffer, e = f.Int8Array;
                                    g.exports = !a || !b(function() {
                                        e(1);
                                    }) || !b(function() {
                                        new e(-1);
                                    }) || !c(function(h) {
                                        new e;
                                        new e(null);
                                        new e(1.5);
                                        new e(h);
                                    }, !0) || b(function() {
                                        return 1 !== new e(new d(2), 1, void 0).length;
                                    });
                                },
                                3251: function(g, f, a) {
                                    var b = a(6080), c = a(9565), d = a(5548), e = a(8981), h = a(6198), k = a(81), l = a(851), m = a(4209), n = a(1108), q = a(4644).aTypedArrayConstructor, r = a(5854);
                                    g.exports = function(t) {
                                        var u = d(this), v = e(t), w = arguments.length, x = 1 < w ? arguments[1] : void 0, B = void 0 !== x, z = l(v);
                                        if (z && !m(z)) {
                                            var C = k(v, z);
                                            var D = C.next;
                                            for(v = []; !(z = c(D, C)).done;)v.push(z.value);
                                        }
                                        B && 2 < w && (x = b(x, arguments[2]));
                                        w = h(v);
                                        z = new (q(u))(w);
                                        C = n(z);
                                        for(u = 0; w > u; u++)D = B ? x(v[u], u) : v[u], z[u] = C ? r(D) : +D;
                                        return z;
                                    };
                                },
                                3392: function(g, f, a) {
                                    f = a(9504);
                                    var b = 0, c = Math.random(), d = f(1..toString);
                                    g.exports = function(e) {
                                        return "Symbol(" + (void 0 === e ? "" : e) + ")_" + d(++b + c, 36);
                                    };
                                },
                                7040: function(g, f, a) {
                                    f = a(4495);
                                    g.exports = f && !Symbol.sham && "symbol" == typeof Symbol.iterator;
                                },
                                8686: function(g, f, a) {
                                    f = a(3724);
                                    a = a(9039);
                                    g.exports = f && a(function() {
                                        return 42 !== Object.defineProperty(function() {}, "prototype", {
                                            value: 42,
                                            writable: !1
                                        }).prototype;
                                    });
                                },
                                2812: function(g) {
                                    var f = TypeError;
                                    g.exports = function(a, b) {
                                        if (a < b) throw new f("Not enough arguments");
                                        return a;
                                    };
                                },
                                8622: function(g, f, a) {
                                    f = a(4576);
                                    a = a(4901);
                                    f = f.WeakMap;
                                    g.exports = a(f) && /native code/.test(String(f));
                                },
                                8227: function(g, f, a) {
                                    f = a(4576);
                                    var b = a(5745), c = a(9297), d = a(3392), e = a(4495);
                                    a = a(7040);
                                    var h = f.Symbol, k = b("wks"), l = a ? h["for"] || h : h && h.withoutSetter || d;
                                    g.exports = function(m) {
                                        c(k, m) || (k[m] = e && c(h, m) ? h[m] : l("Symbol." + m));
                                        return k[m];
                                    };
                                },
                                7452: function(g) {
                                    g.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
                                },
                                4601: function(g, f, a) {
                                    var b = a(7751), c = a(9297), d = a(6699), e = a(1625), h = a(2967), k = a(7740), l = a(1056), m = a(3167), n = a(2603), q = a(7584), r = a(747), t = a(3724), u = a(6395);
                                    g.exports = function(v, w, x, B) {
                                        var z = B ? 2 : 1, C = v.split(".");
                                        v = C[C.length - 1];
                                        var D = b.apply(null, C);
                                        if (D) {
                                            var H = D.prototype;
                                            !u && c(H, "cause") && delete H.cause;
                                            if (!x) return D;
                                            x = b("Error");
                                            var J = w(function(M, I) {
                                                var P = n(B ? I : M, void 0), L = B ? new D(M) : new D;
                                                void 0 !== P && d(L, "message", P);
                                                r(L, J, L.stack, 2);
                                                this && e(H, this) && m(L, this, J);
                                                arguments.length > z && q(L, arguments[z]);
                                                return L;
                                            });
                                            J.prototype = H;
                                            "Error" !== v ? h ? h(J, x) : k(J, x, {
                                                name: !0
                                            }) : t && "stackTraceLimit" in D && (l(J, D, "stackTraceLimit"), l(J, D, "prepareStackTrace"));
                                            k(J, D);
                                            if (!u) try {
                                                H.name !== v && d(H, "name", v), H.constructor = J;
                                            } catch (M) {}
                                            return J;
                                        }
                                    };
                                },
                                6573: function(g, f, a) {
                                    g = a(3724);
                                    f = a(2106);
                                    var b = a(3238);
                                    a = ArrayBuffer.prototype;
                                    !g || "detached" in a || f(a, "detached", {
                                        configurable: !0,
                                        get: function() {
                                            return b(this);
                                        }
                                    });
                                },
                                1745: function(g, f, a) {
                                    g = a(6518);
                                    f = a(7476);
                                    var b = a(9039), c = a(6346), d = a(8551), e = a(5610), h = a(8014), k = a(2293), l = c.ArrayBuffer, m = c.DataView;
                                    a = m.prototype;
                                    var n = f(l.prototype.slice), q = f(a.getUint8), r = f(a.setUint8);
                                    a = b(function() {
                                        return !new l(2).slice(1, void 0).byteLength;
                                    });
                                    g({
                                        target: "ArrayBuffer",
                                        proto: !0,
                                        unsafe: !0,
                                        forced: a
                                    }, {
                                        slice: function(t, u) {
                                            if (n && void 0 === u) return n(d(this), t);
                                            var v = d(this).byteLength;
                                            t = e(t, v);
                                            u = e(void 0 === u ? v : u, v);
                                            v = new (k(this, l))(h(u - t));
                                            for(var w = new m(this), x = new m(v), B = 0; t < u;)r(x, B++, q(w, t++));
                                            return v;
                                        }
                                    });
                                },
                                7936: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(5636);
                                    b && g({
                                        target: "ArrayBuffer",
                                        proto: !0
                                    }, {
                                        transferToFixedLength: function() {
                                            return b(this, arguments.length ? arguments[0] : void 0, !1);
                                        }
                                    });
                                },
                                8100: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(5636);
                                    b && g({
                                        target: "ArrayBuffer",
                                        proto: !0
                                    }, {
                                        transfer: function() {
                                            return b(this, arguments.length ? arguments[0] : void 0, !0);
                                        }
                                    });
                                },
                                8107: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(8981), c = a(6198), d = a(1291);
                                    a = a(6469);
                                    g({
                                        target: "Array",
                                        proto: !0
                                    }, {
                                        at: function(e) {
                                            var h = b(this), k = c(h);
                                            e = d(e);
                                            e = 0 <= e ? e : k + e;
                                            return 0 > e || e >= k ? void 0 : h[e];
                                        }
                                    });
                                    a("at");
                                },
                                8350: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(259), c = a(9306), d = a(8981), e = a(6198), h = a(1469);
                                    g({
                                        target: "Array",
                                        proto: !0
                                    }, {
                                        flatMap: function(k) {
                                            var l = d(this), m = e(l);
                                            c(k);
                                            var n = h(l, 0);
                                            n.length = b(n, l, l, m, 0, 1, k, 1 < arguments.length ? arguments[1] : void 0);
                                            return n;
                                        }
                                    });
                                },
                                4423: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9617).includes;
                                    f = a(9039);
                                    a = a(6469);
                                    f = f(function() {
                                        return !Array(1).includes();
                                    });
                                    g({
                                        target: "Array",
                                        proto: !0,
                                        forced: f
                                    }, {
                                        includes: function(c) {
                                            return b(this, c, 1 < arguments.length ? arguments[1] : void 0);
                                        }
                                    });
                                    a("includes");
                                },
                                3792: function(g, f, a) {
                                    var b = a(5397);
                                    f = a(6469);
                                    var c = a(6269), d = a(1181), e = a(4913).f, h = a(1088), k = a(2529), l = a(6395);
                                    a = a(3724);
                                    var m = d.set, n = d.getterFor("Array Iterator");
                                    g.exports = h(Array, "Array", function(q, r) {
                                        m(this, {
                                            type: "Array Iterator",
                                            target: b(q),
                                            index: 0,
                                            kind: r
                                        });
                                    }, function() {
                                        var q = n(this), r = q.target, t = q.index++;
                                        if (!r || t >= r.length) return q.target = null, k(void 0, !0);
                                        switch(q.kind){
                                            case "keys":
                                                return k(t, !1);
                                            case "values":
                                                return k(r[t], !1);
                                        }
                                        return k([
                                            t,
                                            r[t]
                                        ], !1);
                                    }, "values");
                                    g = c.Arguments = c.Array;
                                    f("keys");
                                    f("values");
                                    f("entries");
                                    if (!l && a && "values" !== g.name) try {
                                        e(g, "name", {
                                            value: "values"
                                        });
                                    } catch (q) {}
                                },
                                4114: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(8981), c = a(6198), d = a(4527), e = a(6837);
                                    if (!(a = a(9039)(function() {
                                        return 4294967297 !== [].push.call({
                                            length: 4294967296
                                        }, 1);
                                    }))) {
                                        a: {
                                            try {
                                                Object.defineProperty([], "length", {
                                                    writable: !1
                                                }).push();
                                            } catch (h) {
                                                a = h instanceof TypeError;
                                                break a;
                                            }
                                            a = void 0;
                                        }
                                        a = !a;
                                    }
                                    g({
                                        target: "Array",
                                        proto: !0,
                                        arity: 1,
                                        forced: a
                                    }, {
                                        push: function(h) {
                                            var k = b(this), l = c(k), m = arguments.length;
                                            e(l + m);
                                            for(var n = 0; n < m; n++)k[l] = arguments[n], l++;
                                            d(k, l);
                                            return l;
                                        }
                                    });
                                },
                                2712: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(926).left;
                                    f = a(4598);
                                    var c = a(9519);
                                    a = !a(8574) && 79 < c && 83 > c || !f("reduce");
                                    g({
                                        target: "Array",
                                        proto: !0,
                                        forced: a
                                    }, {
                                        reduce: function(d) {
                                            var e = arguments.length;
                                            return b(this, d, e, 1 < e ? arguments[1] : void 0);
                                        }
                                    });
                                },
                                4490: function(g, f, a) {
                                    g = a(6518);
                                    f = a(9504);
                                    var b = a(4376), c = f([].reverse);
                                    a = [
                                        1,
                                        2
                                    ];
                                    g({
                                        target: "Array",
                                        proto: !0,
                                        forced: String(a) === String(a.reverse())
                                    }, {
                                        reverse: function() {
                                            b(this) && (this.length = this.length);
                                            return c(this);
                                        }
                                    });
                                },
                                6910: function(g, f, a) {
                                    function b(z) {
                                        return function(C, D) {
                                            return void 0 === D ? -1 : void 0 === C ? 1 : void 0 !== z ? +z(C, D) || 0 : l(C) > l(D) ? 1 : -1;
                                        };
                                    }
                                    g = a(6518);
                                    var c = a(9504), d = a(9306), e = a(8981), h = a(6198), k = a(4606), l = a(655);
                                    f = a(9039);
                                    var m = a(4488), n = a(4598), q = a(3709), r = a(3763), t = a(9519), u = a(3607), v = [], w = c(v.sort), x = c(v.push);
                                    a = f(function() {
                                        v.sort(void 0);
                                    });
                                    c = f(function() {
                                        v.sort(null);
                                    });
                                    n = n("sort");
                                    var B = !f(function() {
                                        if (t) return 70 > t;
                                        if (!(q && 3 < q)) {
                                            if (r) return !0;
                                            if (u) return 603 > u;
                                            var z = "", C, D;
                                            for(C = 65; 76 > C; C++){
                                                var H = String.fromCharCode(C);
                                                switch(C){
                                                    case 66:
                                                    case 69:
                                                    case 70:
                                                    case 72:
                                                        var J = 3;
                                                        break;
                                                    case 68:
                                                    case 71:
                                                        J = 4;
                                                        break;
                                                    default:
                                                        J = 2;
                                                }
                                                for(D = 0; 47 > D; D++)v.push({
                                                    k: H + D,
                                                    v: J
                                                });
                                            }
                                            v.sort(function(M, I) {
                                                return I.v - M.v;
                                            });
                                            for(D = 0; D < v.length; D++)H = v[D].k.charAt(0), z.charAt(z.length - 1) !== H && (z += H);
                                            return "DGBEFHACIJK" !== z;
                                        }
                                    });
                                    g({
                                        target: "Array",
                                        proto: !0,
                                        forced: a || !c || !n || !B
                                    }, {
                                        sort: function(z) {
                                            void 0 !== z && d(z);
                                            var C = e(this);
                                            if (B) return void 0 === z ? w(C) : w(C, z);
                                            var D = [], H = h(C), J;
                                            for(J = 0; J < H; J++)J in C && x(D, C[J]);
                                            m(D, b(z));
                                            z = h(D);
                                            for(J = 0; J < z;)C[J] = D[J++];
                                            for(; J < H;)k(C, J++);
                                            return C;
                                        }
                                    });
                                },
                                237: function(g, f, a) {
                                    a(6469)("flatMap");
                                },
                                6280: function(g, f, a) {
                                    function b(m, n) {
                                        if (k && k[m]) {
                                            var q = {};
                                            q[m] = h("WebAssembly." + m, n, l);
                                            d({
                                                target: "WebAssembly",
                                                stat: !0,
                                                constructor: !0,
                                                arity: 1,
                                                forced: l
                                            }, q);
                                        }
                                    }
                                    function c(m, n) {
                                        var q = {};
                                        q[m] = h(m, n, l);
                                        d({
                                            global: !0,
                                            constructor: !0,
                                            arity: 1,
                                            forced: l
                                        }, q);
                                    }
                                    var d = a(6518);
                                    g = a(4576);
                                    var e = a(8745), h = a(4601), k = g.WebAssembly, l = 7 !== Error("e", {
                                        cause: 7
                                    }).cause;
                                    c("Error", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    c("EvalError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    c("RangeError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    c("ReferenceError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    c("SyntaxError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    c("TypeError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    c("URIError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    b("CompileError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    b("LinkError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                    b("RuntimeError", function(m) {
                                        return function(n) {
                                            return e(m, this, arguments);
                                        };
                                    });
                                },
                                5081: function(g, f, a) {
                                    g = a(6518);
                                    a = a(4576);
                                    g({
                                        global: !0,
                                        forced: a.globalThis !== a
                                    }, {
                                        globalThis: a
                                    });
                                },
                                3110: function(g, f, a) {
                                    function b(M, I, P) {
                                        var L = v(P, I - 1);
                                        I = v(P, I + 1);
                                        return u(C, M) && !u(D, I) || u(D, M) && !u(C, L) ? "\\u" + B(w(M, 0), 16) : M;
                                    }
                                    function c(M, I) {
                                        var P = n(arguments), L = q(I);
                                        if (l(L) || void 0 !== M && !m(M)) return P[1] = function(T, aa) {
                                            l(L) && (aa = h(L, this, r(T), aa));
                                            if (!m(aa)) return aa;
                                        }, e(t, null, P);
                                    }
                                    g = a(6518);
                                    var d = a(7751), e = a(8745), h = a(9565);
                                    f = a(9504);
                                    var k = a(9039), l = a(4901), m = a(757), n = a(7680), q = a(6933);
                                    a = a(4495);
                                    var r = String, t = d("JSON", "stringify"), u = f(/./.exec), v = f("".charAt), w = f("".charCodeAt), x = f("".replace), B = f(1..toString), z = /[\uD800-\uDFFF]/g, C = /^[\uD800-\uDBFF]$/, D = /^[\uDC00-\uDFFF]$/, H = !a || k(function() {
                                        var M = d("Symbol")("stringify detection");
                                        return "[null]" !== t([
                                            M
                                        ]) || "{}" !== t({
                                            a: M
                                        }) || "{}" !== t(Object(M));
                                    }), J = k(function() {
                                        return '"\udf06\ud834"' !== t("\udf06\ud834") || '"\udead"' !== t("\udead");
                                    });
                                    t && g({
                                        target: "JSON",
                                        stat: !0,
                                        arity: 3,
                                        forced: H || J
                                    }, {
                                        stringify: function(M, I, P) {
                                            var L = n(arguments);
                                            L = e(H ? c : t, null, L);
                                            return J && "string" == typeof L ? x(L, z, b) : L;
                                        }
                                    });
                                },
                                9469: function(g, f, a) {
                                    g = a(6518);
                                    f = Math.hypot;
                                    var b = Math.abs, c = Math.sqrt;
                                    f = !!f && Infinity !== f(Infinity, NaN);
                                    g({
                                        target: "Math",
                                        stat: !0,
                                        arity: 2,
                                        forced: f
                                    }, {
                                        hypot: function(d, e) {
                                            for(var h = 0, k = 0, l = arguments.length, m = 0, n, q; k < l;)n = b(arguments[k++]), m < n ? (q = m / n, h = h * q * q + 1, m = n) : 0 < n ? (q = n / m, h += q * q) : h += n;
                                            return Infinity === m ? Infinity : m * c(h);
                                        }
                                    });
                                },
                                5506: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(2357).entries;
                                    g({
                                        target: "Object",
                                        stat: !0
                                    }, {
                                        entries: function(c) {
                                            return b(c);
                                        }
                                    });
                                },
                                3921: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(2652), c = a(2278);
                                    g({
                                        target: "Object",
                                        stat: !0
                                    }, {
                                        fromEntries: function(d) {
                                            var e = {};
                                            b(d, function(h, k) {
                                                c(e, h, k);
                                            }, {
                                                AS_ENTRIES: !0
                                            });
                                            return e;
                                        }
                                    });
                                },
                                6034: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(2357).values;
                                    g({
                                        target: "Object",
                                        stat: !0
                                    }, {
                                        values: function(c) {
                                            return b(c);
                                        }
                                    });
                                },
                                6167: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9565), c = a(9306), d = a(6043), e = a(1103), h = a(2652);
                                    a = a(537);
                                    g({
                                        target: "Promise",
                                        stat: !0,
                                        forced: a
                                    }, {
                                        allSettled: function(k) {
                                            var l = this, m = d.f(l), n = m.resolve, q = m.reject, r = e(function() {
                                                var t = c(l.resolve), u = [], v = 0, w = 1;
                                                h(k, function(x) {
                                                    var B = v++, z = !1;
                                                    w++;
                                                    b(t, l, x).then(function(C) {
                                                        z || (z = !0, u[B] = {
                                                            status: "fulfilled",
                                                            value: C
                                                        }, --w || n(u));
                                                    }, function(C) {
                                                        z || (z = !0, u[B] = {
                                                            status: "rejected",
                                                            reason: C
                                                        }, --w || n(u));
                                                    });
                                                });
                                                --w || n(u);
                                            });
                                            r.error && q(r.value);
                                            return m.promise;
                                        }
                                    });
                                },
                                6499: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9565), c = a(9306), d = a(6043), e = a(1103), h = a(2652);
                                    a = a(537);
                                    g({
                                        target: "Promise",
                                        stat: !0,
                                        forced: a
                                    }, {
                                        all: function(k) {
                                            var l = this, m = d.f(l), n = m.resolve, q = m.reject, r = e(function() {
                                                var t = c(l.resolve), u = [], v = 0, w = 1;
                                                h(k, function(x) {
                                                    var B = v++, z = !1;
                                                    w++;
                                                    b(t, l, x).then(function(C) {
                                                        z || (z = !0, u[B] = C, --w || n(u));
                                                    }, q);
                                                });
                                                --w || n(u);
                                            });
                                            r.error && q(r.value);
                                            return m.promise;
                                        }
                                    });
                                },
                                2003: function(g, f, a) {
                                    g = a(6518);
                                    f = a(6395);
                                    var b = a(916).CONSTRUCTOR, c = a(550), d = a(7751), e = a(4901);
                                    a = a(6840);
                                    var h = c && c.prototype;
                                    g({
                                        target: "Promise",
                                        proto: !0,
                                        forced: b,
                                        real: !0
                                    }, {
                                        "catch": function(k) {
                                            return this.then(void 0, k);
                                        }
                                    });
                                    !f && e(c) && (g = d("Promise").prototype["catch"], h["catch"] !== g && a(h, "catch", g, {
                                        unsafe: !0
                                    }));
                                },
                                436: function(g, f, a) {
                                    function b(Z, ja, ka) {
                                        if (!Z.done) {
                                            Z.done = !0;
                                            ka && (Z = ka);
                                            try {
                                                if (Z.facade === ja) throw new V("Promise can't be resolved itself");
                                                var O = n(ja);
                                                O ? M(function() {
                                                    var Y = {
                                                        done: !1
                                                    };
                                                    try {
                                                        t(O, ja, d(b, Y, Z), d(c, Y, Z));
                                                    } catch (oa) {
                                                        c(Y, oa, Z);
                                                    }
                                                }) : (Z.value = ja, Z.state = 1, l(Z, !1));
                                            } catch (Y) {
                                                c({
                                                    done: !1
                                                }, Y, Z);
                                            }
                                        }
                                    }
                                    function c(Z, ja, ka) {
                                        Z.done || (Z.done = !0, ka && (Z = ka), Z.value = ja, Z.state = 2, l(Z, !0));
                                    }
                                    function d(Z, ja, ka) {
                                        return function(O) {
                                            Z(ja, O, ka);
                                        };
                                    }
                                    function e(Z) {
                                        t(J, r, function() {
                                            var ja = Z.facade;
                                            q ? ia.emit("rejectionHandled", ja) : k("rejectionhandled", ja, Z.value);
                                        });
                                    }
                                    function h(Z) {
                                        t(J, r, function() {
                                            var ja = Z.facade, ka = Z.value;
                                            if (1 !== Z.rejection && !Z.parent) {
                                                var O = P(function() {
                                                    q ? ia.emit("unhandledRejection", ka, ja) : k("unhandledrejection", ja, ka);
                                                });
                                                Z.rejection = q || 1 !== Z.rejection && !Z.parent ? 2 : 1;
                                                if (O.error) throw O.value;
                                            }
                                        });
                                    }
                                    function k(Z, ja, ka) {
                                        var O;
                                        if (va) {
                                            var Y = ea.createEvent("Event");
                                            Y.promise = ja;
                                            Y.reason = ka;
                                            Y.initEvent(Z, !1, !0);
                                            r.dispatchEvent(Y);
                                        } else Y = {
                                            promise: ja,
                                            reason: ka
                                        };
                                        !X && (O = r["on" + Z]) ? O(Y) : "unhandledrejection" === Z && I("Unhandled promise rejection", ka);
                                    }
                                    function l(Z, ja) {
                                        Z.notified || (Z.notified = !0, M(function() {
                                            for(var ka = Z.reactions, O; O = ka.get();)m(O, Z);
                                            Z.notified = !1;
                                            ja && !Z.rejection && h(Z);
                                        }));
                                    }
                                    function m(Z, ja) {
                                        var ka = ja.value, O = 1 === ja.state, Y = O ? Z.ok : Z.fail, oa = Z.resolve, xa = Z.reject, la = Z.domain, ta;
                                        try {
                                            if (Y) {
                                                O || (2 === ja.rejection && e(ja), ja.rejection = 1);
                                                if (!0 === Y) var Ca = ka;
                                                else if (la && la.enter(), Ca = Y(ka), la) {
                                                    la.exit();
                                                    var nb = !0;
                                                }
                                                Ca === Z.promise ? xa(new V("Promise-chain cycle")) : (ta = n(Ca)) ? t(ta, Ca, oa, xa) : oa(Ca);
                                            } else xa(ka);
                                        } catch (Ga) {
                                            la && !nb && la.exit(), xa(Ga);
                                        }
                                    }
                                    function n(Z) {
                                        var ja;
                                        return C(Z) && z(ja = Z.then) ? ja : !1;
                                    }
                                    g = a(6518);
                                    f = a(6395);
                                    var q = a(8574), r = a(4576), t = a(9565), u = a(6840), v = a(2967), w = a(687), x = a(7633), B = a(9306), z = a(4901), C = a(34), D = a(679), H = a(2293), J = a(9225).set, M = a(1955), I = a(3138), P = a(1103), L = a(8265), T = a(1181), aa = a(550), ba = a(916);
                                    a = a(6043);
                                    var ra = ba.CONSTRUCTOR, X = ba.REJECTION_EVENT;
                                    ba = ba.SUBCLASSING;
                                    var ma = T.getterFor("Promise"), U = T.set;
                                    T = aa && aa.prototype;
                                    var K = aa, N = T, V = r.TypeError, ea = r.document, ia = r.process, na = a.f, ua = na, va = !!(ea && ea.createEvent && r.dispatchEvent);
                                    if (ra) {
                                        K = function(Z) {
                                            D(this, N);
                                            B(Z);
                                            t(za, this);
                                            var ja = ma(this);
                                            try {
                                                Z(d(b, ja), d(c, ja));
                                            } catch (ka) {
                                                c(ja, ka);
                                            }
                                        };
                                        N = K.prototype;
                                        var za = function() {
                                            U(this, {
                                                type: "Promise",
                                                done: !1,
                                                notified: !1,
                                                parent: !1,
                                                reactions: new L,
                                                rejection: !1,
                                                state: 0,
                                                value: null
                                            });
                                        };
                                        za.prototype = u(N, "then", function(Z, ja) {
                                            var ka = ma(this), O = na(H(this, K));
                                            ka.parent = !0;
                                            O.ok = z(Z) ? Z : !0;
                                            O.fail = z(ja) && ja;
                                            O.domain = q ? ia.domain : void 0;
                                            0 === ka.state ? ka.reactions.add(O) : M(function() {
                                                m(O, ka);
                                            });
                                            return O.promise;
                                        });
                                        var Ha = function() {
                                            var Z = new za, ja = ma(Z);
                                            this.promise = Z;
                                            this.resolve = d(b, ja);
                                            this.reject = d(c, ja);
                                        };
                                        a.f = na = function(Z) {
                                            return Z === K || void 0 === Z ? new Ha(Z) : ua(Z);
                                        };
                                        if (!f && z(aa) && T !== Object.prototype) {
                                            var Ia = T.then;
                                            ba || u(T, "then", function(Z, ja) {
                                                var ka = this;
                                                return new K(function(O, Y) {
                                                    t(Ia, ka, O, Y);
                                                }).then(Z, ja);
                                            }, {
                                                unsafe: !0
                                            });
                                            try {
                                                delete T.constructor;
                                            } catch (Z) {}
                                            v && v(T, N);
                                        }
                                    }
                                    g({
                                        global: !0,
                                        constructor: !0,
                                        wrap: !0,
                                        forced: ra
                                    }, {
                                        Promise: K
                                    });
                                    w(K, "Promise", !1, !0);
                                    x("Promise");
                                },
                                9391: function(g, f, a) {
                                    g = a(6518);
                                    f = a(6395);
                                    var b = a(550), c = a(9039), d = a(7751), e = a(4901), h = a(2293), k = a(3438);
                                    a = a(6840);
                                    var l = b && b.prototype;
                                    c = !!b && c(function() {
                                        l["finally"].call({
                                            then: function() {}
                                        }, function() {});
                                    });
                                    g({
                                        target: "Promise",
                                        proto: !0,
                                        real: !0,
                                        forced: c
                                    }, {
                                        "finally": function(m) {
                                            var n = h(this, d("Promise")), q = e(m);
                                            return this.then(q ? function(r) {
                                                return k(n, m()).then(function() {
                                                    return r;
                                                });
                                            } : m, q ? function(r) {
                                                return k(n, m()).then(function() {
                                                    throw r;
                                                });
                                            } : m);
                                        }
                                    });
                                    !f && e(b) && (g = d("Promise").prototype["finally"], l["finally"] !== g && a(l, "finally", g, {
                                        unsafe: !0
                                    }));
                                },
                                3362: function(g, f, a) {
                                    a(436);
                                    a(6499);
                                    a(2003);
                                    a(7743);
                                    a(1481);
                                    a(280);
                                },
                                7743: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9565), c = a(9306), d = a(6043), e = a(1103), h = a(2652);
                                    a = a(537);
                                    g({
                                        target: "Promise",
                                        stat: !0,
                                        forced: a
                                    }, {
                                        race: function(k) {
                                            var l = this, m = d.f(l), n = m.reject, q = e(function() {
                                                var r = c(l.resolve);
                                                h(k, function(t) {
                                                    b(r, l, t).then(m.resolve, n);
                                                });
                                            });
                                            q.error && n(q.value);
                                            return m.promise;
                                        }
                                    });
                                },
                                1481: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(6043);
                                    a = a(916).CONSTRUCTOR;
                                    g({
                                        target: "Promise",
                                        stat: !0,
                                        forced: a
                                    }, {
                                        reject: function(c) {
                                            var d = b.f(this), e = d.reject;
                                            e(c);
                                            return d.promise;
                                        }
                                    });
                                },
                                280: function(g, f, a) {
                                    g = a(6518);
                                    f = a(7751);
                                    var b = a(6395), c = a(550), d = a(916).CONSTRUCTOR, e = a(3438), h = f("Promise"), k = b && !d;
                                    g({
                                        target: "Promise",
                                        stat: !0,
                                        forced: b || d
                                    }, {
                                        resolve: function(l) {
                                            return e(k && this === h ? c : this, l);
                                        }
                                    });
                                },
                                4628: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(6043);
                                    g({
                                        target: "Promise",
                                        stat: !0
                                    }, {
                                        withResolvers: function() {
                                            var c = b.f(this);
                                            return {
                                                promise: c.promise,
                                                resolve: c.resolve,
                                                reject: c.reject
                                            };
                                        }
                                    });
                                },
                                4864: function(g, f, a) {
                                    var b = a(3724);
                                    g = a(4576);
                                    var c = a(9504), d = a(2796), e = a(3167), h = a(6699), k = a(2360), l = a(8480).f, m = a(1625), n = a(788), q = a(655), r = a(1034), t = a(8429);
                                    f = a(1056);
                                    var u = a(6840), v = a(9039), w = a(9297), x = a(1181).enforce, B = a(7633), z = a(8227), C = a(3635), D = a(8814), H = z("match"), J = g.RegExp, M = J.prototype, I = g.SyntaxError, P = c(M.exec), L = c("".charAt), T = c("".replace), aa = c("".indexOf), ba = c("".slice), ra = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/, X = /a/g, ma = /a/g;
                                    a = new J(X) !== X;
                                    var U = t.MISSED_STICKY, K = t.UNSUPPORTED_Y;
                                    a = b && (!a || U || C || D || v(function() {
                                        ma[H] = !1;
                                        return J(X) !== X || J(ma) === ma || "/a/i" !== String(J(X, "i"));
                                    }));
                                    if (d("RegExp", a)) {
                                        var N = function(V, ea) {
                                            var ia = m(M, this), na = n(V), ua = void 0 === ea, va = [], za = V, Ha, Ia;
                                            if (!ia && na && ua && V.constructor === N) return V;
                                            if (na || m(M, V)) V = V.source, ua && (ea = r(za));
                                            V = void 0 === V ? "" : q(V);
                                            ea = void 0 === ea ? "" : q(ea);
                                            za = V;
                                            C && "dotAll" in X && (Ha = !!ea && -1 < aa(ea, "s")) && (ea = T(ea, /s/g, ""));
                                            na = ea;
                                            U && "sticky" in X && (Ia = !!ea && -1 < aa(ea, "y")) && K && (ea = T(ea, /y/g, ""));
                                            if (D) {
                                                va = V.length;
                                                ua = 0;
                                                for(var Z = "", ja = [], ka = k(null), O = !1, Y = !1, oa = 0, xa = "", la; ua <= va; ua++){
                                                    la = L(V, ua);
                                                    if ("\\" === la) la += L(V, ++ua);
                                                    else if ("]" === la) O = !1;
                                                    else if (!O) switch(!0){
                                                        case "[" === la:
                                                            O = !0;
                                                            break;
                                                        case "(" === la:
                                                            Z += la;
                                                            if ("?:" === ba(V, ua + 1, ua + 3)) continue;
                                                            P(ra, ba(V, ua + 1)) && (ua += 2, Y = !0);
                                                            oa++;
                                                            continue;
                                                        case ">" === la && Y:
                                                            if ("" === xa || w(ka, xa)) throw new I("Invalid capture group name");
                                                            ka[xa] = !0;
                                                            ja[ja.length] = [
                                                                xa,
                                                                oa
                                                            ];
                                                            Y = !1;
                                                            xa = "";
                                                            continue;
                                                    }
                                                    Y ? xa += la : Z += la;
                                                }
                                                va = [
                                                    Z,
                                                    ja
                                                ];
                                                V = va[0];
                                                va = va[1];
                                            }
                                            ea = e(J(V, ea), ia ? this : M, N);
                                            if (Ha || Ia || va.length) {
                                                ia = x(ea);
                                                if (Ha) {
                                                    ia.dotAll = !0;
                                                    Ha = N;
                                                    ua = V;
                                                    Z = ua.length;
                                                    ja = 0;
                                                    ka = "";
                                                    for(O = !1; ja <= Z; ja++)Y = L(ua, ja), "\\" === Y ? ka += Y + L(ua, ++ja) : O || "." !== Y ? ("[" === Y ? O = !0 : "]" === Y && (O = !1), ka += Y) : ka += "[\\s\\S]";
                                                    ia.raw = Ha(ka, na);
                                                }
                                                Ia && (ia.sticky = !0);
                                                va.length && (ia.groups = va);
                                            }
                                            if (V !== za) try {
                                                h(ea, "source", "" === za ? "(?:)" : za);
                                            } catch (ta) {}
                                            return ea;
                                        };
                                        a = l(J);
                                        for(d = 0; a.length > d;)f(N, J, a[d++]);
                                        M.constructor = N;
                                        N.prototype = M;
                                        u(g, "RegExp", N, {
                                            constructor: !0
                                        });
                                    }
                                    B("RegExp");
                                },
                                7465: function(g, f, a) {
                                    g = a(3724);
                                    f = a(3635);
                                    var b = a(2195), c = a(2106), d = a(1181).get, e = RegExp.prototype, h = TypeError;
                                    g && f && c(e, "dotAll", {
                                        configurable: !0,
                                        get: function() {
                                            if (this !== e) {
                                                if ("RegExp" === b(this)) return !!d(this).dotAll;
                                                throw new h("Incompatible receiver, RegExp required");
                                            }
                                        }
                                    });
                                },
                                7495: function(g, f, a) {
                                    g = a(6518);
                                    a = a(7323);
                                    g({
                                        target: "RegExp",
                                        proto: !0,
                                        forced: /./.exec !== a
                                    }, {
                                        exec: a
                                    });
                                },
                                7642: function(g, f, a) {
                                    g = a(6518);
                                    f = a(3440);
                                    a = a(4916);
                                    g({
                                        target: "Set",
                                        proto: !0,
                                        real: !0,
                                        forced: !a("difference")
                                    }, {
                                        difference: f
                                    });
                                },
                                8004: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9039);
                                    f = a(8750);
                                    a = !a(4916)("intersection") || b(function() {
                                        return "3,2" !== String(Array.from(new Set([
                                            1,
                                            2,
                                            3
                                        ]).intersection(new Set([
                                            3,
                                            2
                                        ]))));
                                    });
                                    g({
                                        target: "Set",
                                        proto: !0,
                                        real: !0,
                                        forced: a
                                    }, {
                                        intersection: f
                                    });
                                },
                                3853: function(g, f, a) {
                                    g = a(6518);
                                    f = a(4449);
                                    a = a(4916);
                                    g({
                                        target: "Set",
                                        proto: !0,
                                        real: !0,
                                        forced: !a("isDisjointFrom")
                                    }, {
                                        isDisjointFrom: f
                                    });
                                },
                                5876: function(g, f, a) {
                                    g = a(6518);
                                    f = a(3838);
                                    a = a(4916);
                                    g({
                                        target: "Set",
                                        proto: !0,
                                        real: !0,
                                        forced: !a("isSubsetOf")
                                    }, {
                                        isSubsetOf: f
                                    });
                                },
                                2475: function(g, f, a) {
                                    g = a(6518);
                                    f = a(8527);
                                    a = a(4916);
                                    g({
                                        target: "Set",
                                        proto: !0,
                                        real: !0,
                                        forced: !a("isSupersetOf")
                                    }, {
                                        isSupersetOf: f
                                    });
                                },
                                5024: function(g, f, a) {
                                    g = a(6518);
                                    f = a(3650);
                                    a = a(4916);
                                    g({
                                        target: "Set",
                                        proto: !0,
                                        real: !0,
                                        forced: !a("symmetricDifference")
                                    }, {
                                        symmetricDifference: f
                                    });
                                },
                                1698: function(g, f, a) {
                                    g = a(6518);
                                    f = a(4204);
                                    a = a(4916);
                                    g({
                                        target: "Set",
                                        proto: !0,
                                        real: !0,
                                        forced: !a("union")
                                    }, {
                                        union: f
                                    });
                                },
                                7357: function(g, f, a) {
                                    g = a(6518);
                                    f = a(9504);
                                    var b = a(7750), c = a(1291), d = a(655);
                                    a = a(9039);
                                    var e = f("".charAt);
                                    a = a(function() {
                                        return "\ud842" !== "\ud842\udfb7".at(-2);
                                    });
                                    g({
                                        target: "String",
                                        proto: !0,
                                        forced: a
                                    }, {
                                        at: function(h) {
                                            var k = d(b(this)), l = k.length;
                                            h = c(h);
                                            h = 0 <= h ? h : l + h;
                                            return 0 > h || h >= l ? void 0 : e(k, h);
                                        }
                                    });
                                },
                                5701: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(533).end;
                                    a = a(3063);
                                    g({
                                        target: "String",
                                        proto: !0,
                                        forced: a
                                    }, {
                                        padEnd: function(c) {
                                            return b(this, c, 1 < arguments.length ? arguments[1] : void 0);
                                        }
                                    });
                                },
                                8156: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(533).start;
                                    a = a(3063);
                                    g({
                                        target: "String",
                                        proto: !0,
                                        forced: a
                                    }, {
                                        padStart: function(c) {
                                            return b(this, c, 1 < arguments.length ? arguments[1] : void 0);
                                        }
                                    });
                                },
                                9978: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9565);
                                    f = a(9504);
                                    var c = a(7750), d = a(4901), e = a(4117), h = a(788), k = a(655), l = a(5966), m = a(1034), n = a(2478), q = a(8227), r = a(6395), t = q("replace"), u = TypeError, v = f("".indexOf), w = f("".replace), x = f("".slice), B = Math.max;
                                    g({
                                        target: "String",
                                        proto: !0
                                    }, {
                                        replaceAll: function(z, C) {
                                            var D = c(this), H, J, M = 0, I = "";
                                            if (!e(z)) {
                                                if (H = h(z)) {
                                                    var P = k(c(m(z)));
                                                    if (!~v(P, "g")) throw new u("`.replaceAll` does not allow non-global regexes");
                                                }
                                                if (P = l(z, t)) return b(P, z, D, C);
                                                if (r && H) return w(k(D), z, C);
                                            }
                                            D = k(D);
                                            z = k(z);
                                            (H = d(C)) || (C = k(C));
                                            P = z.length;
                                            var L = B(1, P);
                                            for(J = v(D, z); -1 !== J;){
                                                var T = H ? k(C(z, J, D)) : n(z, D, J, [], void 0, C);
                                                I += x(D, M, J) + T;
                                                M = J + P;
                                                J = J + L > D.length ? -1 : v(D, z, J + L);
                                            }
                                            M < D.length && (I += x(D, M));
                                            return I;
                                        }
                                    });
                                },
                                5440: function(g, f, a) {
                                    var b = a(8745), c = a(9565), d = a(9504);
                                    g = a(9228);
                                    f = a(9039);
                                    var e = a(8551), h = a(4901), k = a(4117), l = a(1291), m = a(8014), n = a(655), q = a(7750), r = a(7829), t = a(5966), u = a(2478), v = a(6682), w = a(8227)("replace"), x = Math.max, B = Math.min, z = d([].concat), C = d([].push), D = d("".indexOf), H = d("".slice);
                                    a = "$0" === "a".replace(/./, "$0");
                                    var J = /./[w] ? "" === /./[w]("a", "$0") : !1;
                                    f = !f(function() {
                                        var M = /./;
                                        M.exec = function() {
                                            var I = [];
                                            I.groups = {
                                                a: "7"
                                            };
                                            return I;
                                        };
                                        return "7" !== "".replace(M, "$<a>");
                                    });
                                    g("replace", function(M, I, P) {
                                        var L = J ? "$" : "$0";
                                        return [
                                            function(T, aa) {
                                                var ba = q(this), ra = k(T) ? void 0 : t(T, w);
                                                return ra ? c(ra, T, ba, aa) : c(I, n(ba), T, aa);
                                            },
                                            function(T, aa) {
                                                var ba = e(this);
                                                T = n(T);
                                                if ("string" == typeof aa && -1 === D(aa, L) && -1 === D(aa, "$<")) {
                                                    var ra = P(I, ba, T, aa);
                                                    if (ra.done) return ra.value;
                                                }
                                                (ra = h(aa)) || (aa = n(aa));
                                                var X = ba.global;
                                                if (X) {
                                                    var ma = ba.unicode;
                                                    ba.lastIndex = 0;
                                                }
                                                for(var U = [], K;;){
                                                    K = v(ba, T);
                                                    if (null === K) break;
                                                    C(U, K);
                                                    if (!X) break;
                                                    "" === n(K[0]) && (ba.lastIndex = r(T, m(ba.lastIndex), ma));
                                                }
                                                ba = "";
                                                for(X = ma = 0; X < U.length; X++){
                                                    K = U[X];
                                                    for(var N = n(K[0]), V = x(B(l(K.index), T.length), 0), ea = [], ia = 1; ia < K.length; ia++){
                                                        var na = K[ia];
                                                        C(ea, void 0 === na ? na : String(na));
                                                    }
                                                    K = K.groups;
                                                    ra ? (ea = z([
                                                        N
                                                    ], ea, V, T), void 0 !== K && C(ea, K), K = n(b(aa, void 0, ea))) : K = u(N, T, V, ea, K, aa);
                                                    V >= ma && (ba += H(T, ma, V) + K, ma = V + N.length);
                                                }
                                                return ba + H(T, ma);
                                            }
                                        ];
                                    }, !f || !a || J);
                                },
                                744: function(g, f, a) {
                                    var b = a(9565);
                                    f = a(9504);
                                    g = a(9228);
                                    var c = a(8551), d = a(4117), e = a(7750), h = a(2293), k = a(7829), l = a(8014), m = a(655), n = a(5966), q = a(6682), r = a(8429);
                                    a = a(9039);
                                    var t = r.UNSUPPORTED_Y, u = Math.min, v = f([].push), w = f("".slice);
                                    a = !a(function() {
                                        var B = /(?:)/, z = B.exec;
                                        B.exec = function() {
                                            return z.apply(this, arguments);
                                        };
                                        B = "ab".split(B);
                                        return 2 !== B.length || "a" !== B[0] || "b" !== B[1];
                                    });
                                    var x = "c" === "abbc".split(/(b)*/)[1] || 4 !== "test".split(/(?:)/, -1).length || 2 !== "ab".split(/(?:ab)*/).length || 4 !== ".".split(/(.?)(.?)/).length || 1 < ".".split(/()()/).length || "".split(/.?/).length;
                                    g("split", function(B, z, C) {
                                        var D = "0".split(void 0, 0).length ? function(H, J) {
                                            return void 0 === H && 0 === J ? [] : b(z, this, H, J);
                                        } : z;
                                        return [
                                            function(H, J) {
                                                var M = e(this), I = d(H) ? void 0 : n(H, B);
                                                return I ? b(I, H, M, J) : b(D, m(M), H, J);
                                            },
                                            function(H, J) {
                                                var M = c(this);
                                                H = m(H);
                                                if (!x) {
                                                    var I = C(D, M, H, J, D !== z);
                                                    if (I.done) return I.value;
                                                }
                                                var P = h(M, RegExp);
                                                I = M.unicode;
                                                M = new P(t ? "^(?:" + M.source + ")" : M, (M.ignoreCase ? "i" : "") + (M.multiline ? "m" : "") + (M.unicode ? "u" : "") + (t ? "g" : "y"));
                                                J = void 0 === J ? 4294967295 : J >>> 0;
                                                if (0 === J) return [];
                                                if (0 === H.length) return null === q(M, H) ? [
                                                    H
                                                ] : [];
                                                var L = 0, T = 0;
                                                for(P = []; T < H.length;){
                                                    M.lastIndex = t ? 0 : T;
                                                    var aa = q(M, t ? w(H, T) : H), ba;
                                                    if (null === aa || (ba = u(l(M.lastIndex + (t ? T : 0)), H.length)) === L) T = k(H, T, I);
                                                    else {
                                                        v(P, w(H, L, T));
                                                        if (P.length === J) return P;
                                                        for(L = 1; L <= aa.length - 1; L++)if (v(P, aa[L]), P.length === J) return P;
                                                        T = L = ba;
                                                    }
                                                }
                                                v(P, w(H, L));
                                                return P;
                                            }
                                        ];
                                    }, x || !a, t);
                                },
                                9202: function(g, f, a) {
                                    a(3313);
                                    g = a(6518);
                                    a = a(8866);
                                    g({
                                        target: "String",
                                        proto: !0,
                                        name: "trimEnd",
                                        forced: "".trimEnd !== a
                                    }, {
                                        trimEnd: a
                                    });
                                },
                                3313: function(g, f, a) {
                                    g = a(6518);
                                    a = a(8866);
                                    g({
                                        target: "String",
                                        proto: !0,
                                        name: "trimEnd",
                                        forced: "".trimRight !== a
                                    }, {
                                        trimRight: a
                                    });
                                },
                                2762: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(3802).trim;
                                    a = a(706);
                                    g({
                                        target: "String",
                                        proto: !0,
                                        forced: a("trim")
                                    }, {
                                        trim: function() {
                                            return b(this);
                                        }
                                    });
                                },
                                9463: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(3724), c = a(4576);
                                    f = a(9504);
                                    var d = a(9297), e = a(4901), h = a(1625), k = a(655), l = a(2106);
                                    a = a(7740);
                                    var m = c.Symbol, n = m && m.prototype;
                                    if (b && e(m) && (!("description" in n) || void 0 !== m().description)) {
                                        var q = {};
                                        b = function() {
                                            var B = 1 > arguments.length || void 0 === arguments[0] ? void 0 : k(arguments[0]), z = h(n, this) ? new m(B) : void 0 === B ? m() : m(B);
                                            "" === B && (q[z] = !0);
                                            return z;
                                        };
                                        a(b, m);
                                        b.prototype = n;
                                        n.constructor = b;
                                        var r = "Symbol(description detection)" === String(m("description detection")), t = f(n.valueOf), u = f(n.toString), v = /^Symbol\((.*)\)[^)]+$/, w = f("".replace), x = f("".slice);
                                        l(n, "description", {
                                            configurable: !0,
                                            get: function() {
                                                var B = t(this);
                                                if (d(q, B)) return "";
                                                B = u(B);
                                                B = r ? x(B, 7, -1) : w(B, v, "$1");
                                                return "" === B ? void 0 : B;
                                            }
                                        });
                                        g({
                                            global: !0,
                                            constructor: !0,
                                            forced: !0
                                        }, {
                                            Symbol: b
                                        });
                                    }
                                },
                                8140: function(g, f, a) {
                                    g = a(4644);
                                    var b = a(6198), c = a(1291), d = g.aTypedArray;
                                    a = g.exportTypedArrayMethod;
                                    a("at", function(e) {
                                        var h = d(this), k = b(h);
                                        e = c(e);
                                        e = 0 <= e ? e : k + e;
                                        return 0 > e || e >= k ? void 0 : h[e];
                                    });
                                },
                                5044: function(g, f, a) {
                                    f = a(4644);
                                    var b = a(4373), c = a(5854), d = a(6955), e = a(9565);
                                    g = a(9504);
                                    a = a(9039);
                                    var h = f.aTypedArray;
                                    f = f.exportTypedArrayMethod;
                                    var k = g("".slice);
                                    a = a(function() {
                                        var l = 0;
                                        new Int8Array(2).fill({
                                            valueOf: function() {
                                                return l++;
                                            }
                                        });
                                        return 1 !== l;
                                    });
                                    f("fill", function(l) {
                                        var m = arguments.length;
                                        h(this);
                                        var n = "Big" === k(d(this), 0, 3) ? c(l) : +l;
                                        return e(b, this, n, 1 < m ? arguments[1] : void 0, 2 < m ? arguments[2] : void 0);
                                    }, a);
                                },
                                1134: function(g, f, a) {
                                    g = a(4644);
                                    var b = a(3839).findLastIndex, c = g.aTypedArray;
                                    a = g.exportTypedArrayMethod;
                                    a("findLastIndex", function(d) {
                                        return b(c(this), d, 1 < arguments.length ? arguments[1] : void 0);
                                    });
                                },
                                1903: function(g, f, a) {
                                    g = a(4644);
                                    var b = a(3839).findLast, c = g.aTypedArray;
                                    a = g.exportTypedArrayMethod;
                                    a("findLast", function(d) {
                                        return b(c(this), d, 1 < arguments.length ? arguments[1] : void 0);
                                    });
                                },
                                4594: function(g, f, a) {
                                    a(5823)("Float32", function(b) {
                                        return function(c, d, e) {
                                            return b(this, c, d, e);
                                        };
                                    });
                                },
                                9833: function(g, f, a) {
                                    a(5823)("Float64", function(b) {
                                        return function(c, d, e) {
                                            return b(this, c, d, e);
                                        };
                                    });
                                },
                                5477: function(g, f, a) {
                                    a(5823)("Int32", function(b) {
                                        return function(c, d, e) {
                                            return b(this, c, d, e);
                                        };
                                    });
                                },
                                8845: function(g, f, a) {
                                    f = a(4576);
                                    var b = a(9565);
                                    g = a(4644);
                                    var c = a(6198), d = a(8229), e = a(8981);
                                    a = a(9039);
                                    var h = f.RangeError, k = f.Int8Array, l = (f = k && k.prototype) && f.set, m = g.aTypedArray;
                                    f = g.exportTypedArrayMethod;
                                    var n = !a(function() {
                                        var q = new Uint8ClampedArray(2);
                                        b(l, q, {
                                            length: 1,
                                            0: 3
                                        }, 1);
                                        return 3 !== q[1];
                                    });
                                    g = n && g.NATIVE_ARRAY_BUFFER_VIEWS && a(function() {
                                        var q = new k(2);
                                        q.set(1);
                                        q.set("2", 1);
                                        return 0 !== q[0] || 2 !== q[1];
                                    });
                                    f("set", function(q) {
                                        m(this);
                                        var r = d(1 < arguments.length ? arguments[1] : void 0, 1), t = e(q);
                                        if (n) return b(l, this, t, r);
                                        var u = this.length, v = c(t), w = 0;
                                        if (v + r > u) throw new h("Wrong length");
                                        for(; w < v;)this[r + w] = t[w++];
                                    }, !n || g);
                                },
                                373: function(g, f, a) {
                                    function b(v) {
                                        return function(w, x) {
                                            return void 0 !== v ? +v(w, x) || 0 : x !== x ? -1 : w !== w ? 1 : 0 === w && 0 === x ? 0 < 1 / w && 0 > 1 / x ? 1 : -1 : w > x;
                                        };
                                    }
                                    f = a(4576);
                                    var c = a(7476);
                                    g = a(9039);
                                    var d = a(9306), e = a(4488), h = a(4644), k = a(3709), l = a(3763), m = a(9519), n = a(3607), q = h.aTypedArray;
                                    a = h.exportTypedArrayMethod;
                                    var r = f.Uint16Array, t = r && c(r.prototype.sort);
                                    f = !!t && !(g(function() {
                                        t(new r(2), null);
                                    }) && g(function() {
                                        t(new r(2), {});
                                    }));
                                    var u = !!t && !g(function() {
                                        if (m) return 74 > m;
                                        if (k) return 67 > k;
                                        if (l) return !0;
                                        if (n) return 602 > n;
                                        var v = new r(516), w = Array(516), x;
                                        for(x = 0; 516 > x; x++){
                                            var B = x % 4;
                                            v[x] = 515 - x;
                                            w[x] = x - 2 * B + 3;
                                        }
                                        t(v, function(z, C) {
                                            return (z / 4 | 0) - (C / 4 | 0);
                                        });
                                        for(x = 0; 516 > x; x++)if (v[x] !== w[x]) return !0;
                                    });
                                    a("sort", function(v) {
                                        void 0 !== v && d(v);
                                        return u ? t(this, v) : e(q(this), b(v));
                                    }, !u || f);
                                },
                                7467: function(g, f, a) {
                                    var b = a(7628);
                                    g = a(4644);
                                    var c = g.aTypedArray;
                                    f = g.exportTypedArrayMethod;
                                    var d = g.getTypedArrayConstructor;
                                    f("toReversed", function() {
                                        return b(c(this), d(this));
                                    });
                                },
                                4732: function(g, f, a) {
                                    g = a(4644);
                                    f = a(9504);
                                    var b = a(9306), c = a(5370), d = g.aTypedArray, e = g.getTypedArrayConstructor;
                                    a = g.exportTypedArrayMethod;
                                    var h = f(g.TypedArrayPrototype.sort);
                                    a("toSorted", function(k) {
                                        void 0 !== k && b(k);
                                        var l = d(this);
                                        l = c(e(l), l);
                                        return h(l, k);
                                    });
                                },
                                1740: function(g, f, a) {
                                    a(5823)("Uint32", function(b) {
                                        return function(c, d, e) {
                                            return b(this, c, d, e);
                                        };
                                    });
                                },
                                1489: function(g, f, a) {
                                    a(5823)("Uint8", function(b) {
                                        return function(c, d, e) {
                                            return b(this, c, d, e);
                                        };
                                    });
                                },
                                9577: function(g, f, a) {
                                    var b = a(9928);
                                    g = a(4644);
                                    var c = a(1108), d = a(1291), e = a(5854), h = g.aTypedArray, k = g.getTypedArrayConstructor;
                                    a = g.exportTypedArrayMethod;
                                    g = !!function() {
                                        try {
                                            new Int8Array(1)["with"](2, {
                                                valueOf: function() {
                                                    throw 8;
                                                }
                                            });
                                        } catch (l) {
                                            return 8 === l;
                                        }
                                    }();
                                    a("with", function(l, m) {
                                        var n = h(this);
                                        l = d(l);
                                        m = c(n) ? e(m) : +m;
                                        return b(n, k(n), l, m);
                                    }, !g);
                                },
                                8992: function(g, f, a) {
                                    function b(x, B) {
                                        u ? l(t, x, {
                                            configurable: !0,
                                            get: function() {
                                                return B;
                                            },
                                            set: function(z) {
                                                e(this);
                                                if (this === t) throw new v("You can't redefine this property");
                                                q(this, x) ? this[x] = z : m(this, x, z);
                                            }
                                        }) : t[x] = B;
                                    }
                                    function c() {
                                        d(this, t);
                                        if (k(this) === t) throw new v("Abstract class Iterator not directly constructable");
                                    }
                                    g = a(6518);
                                    f = a(4576);
                                    var d = a(679), e = a(8551), h = a(4901), k = a(2787), l = a(2106), m = a(2278), n = a(9039), q = a(9297), r = a(8227), t = a(7657).IteratorPrototype, u = a(3724);
                                    a = a(6395);
                                    r = r("toStringTag");
                                    var v = TypeError, w = f.Iterator;
                                    a = a || !h(w) || w.prototype !== t || !n(function() {
                                        w({});
                                    });
                                    q(t, r) || b(r, "Iterator");
                                    !a && q(t, "constructor") && t.constructor !== Object || b("constructor", c);
                                    c.prototype = t;
                                    g({
                                        global: !0,
                                        constructor: !0,
                                        forced: a
                                    }, {
                                        Iterator: c
                                    });
                                },
                                4743: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9565), c = a(8551), d = a(1767), e = a(4149), h = a(9590);
                                    f = a(9462);
                                    a = a(6395);
                                    var k = f(function() {
                                        for(var l = this.iterator, m = this.next, n, q; this.remaining;)if (this.remaining--, n = c(b(m, l)), q = this.done = !!n.done) return;
                                        n = c(b(m, l));
                                        q = this.done = !!n.done;
                                        if (!q) return n.value;
                                    });
                                    g({
                                        target: "Iterator",
                                        proto: !0,
                                        real: !0,
                                        forced: a
                                    }, {
                                        drop: function(l) {
                                            c(this);
                                            l = h(e(+l));
                                            return new k(d(this), {
                                                remaining: l
                                            });
                                        }
                                    });
                                },
                                3215: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(2652), c = a(9306), d = a(8551), e = a(1767);
                                    g({
                                        target: "Iterator",
                                        proto: !0,
                                        real: !0
                                    }, {
                                        every: function(h) {
                                            d(this);
                                            c(h);
                                            var k = e(this), l = 0;
                                            return !b(k, function(m, n) {
                                                if (!h(m, l++)) return n();
                                            }, {
                                                IS_RECORD: !0,
                                                INTERRUPTED: !0
                                            }).stopped;
                                        }
                                    });
                                },
                                4520: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9565), c = a(9306), d = a(8551), e = a(1767);
                                    f = a(9462);
                                    var h = a(6319);
                                    a = a(6395);
                                    var k = f(function() {
                                        for(var l = this.iterator, m = this.predicate, n = this.next, q, r;;){
                                            q = d(b(n, l));
                                            if (r = this.done = !!q.done) break;
                                            q = q.value;
                                            if (h(l, m, [
                                                q,
                                                this.counter++
                                            ], !0)) return q;
                                        }
                                    });
                                    g({
                                        target: "Iterator",
                                        proto: !0,
                                        real: !0,
                                        forced: a
                                    }, {
                                        filter: function(l) {
                                            d(this);
                                            c(l);
                                            return new k(e(this), {
                                                predicate: l
                                            });
                                        }
                                    });
                                },
                                670: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(9565), c = a(9306), d = a(8551), e = a(1767), h = a(8646);
                                    f = a(9462);
                                    var k = a(9539);
                                    a = a(6395);
                                    var l = f(function() {
                                        for(var m = this.iterator, n = this.mapper, q, r;;){
                                            if (r = this.inner) try {
                                                q = d(b(r.next, r.iterator));
                                                if (!q.done) return q.value;
                                                this.inner = null;
                                            } catch (t) {
                                                k(m, "throw", t);
                                            }
                                            q = d(b(this.next, m));
                                            if (this.done = !!q.done) break;
                                            try {
                                                this.inner = h(n(q.value, this.counter++), !1);
                                            } catch (t) {
                                                k(m, "throw", t);
                                            }
                                        }
                                    });
                                    g({
                                        target: "Iterator",
                                        proto: !0,
                                        real: !0,
                                        forced: a
                                    }, {
                                        flatMap: function(m) {
                                            d(this);
                                            c(m);
                                            return new l(e(this), {
                                                mapper: m,
                                                inner: null
                                            });
                                        }
                                    });
                                },
                                1454: function(g, f, a) {
                                    g = a(6518);
                                    f = a(713);
                                    a = a(6395);
                                    g({
                                        target: "Iterator",
                                        proto: !0,
                                        real: !0,
                                        forced: a
                                    }, {
                                        map: f
                                    });
                                },
                                7550: function(g, f, a) {
                                    g = a(6518);
                                    var b = a(2652), c = a(9306), d = a(8551), e = a(1767);
                                    g({
                                        target: "Iterator",
                                        proto: !0,
                                        real: !0
                                    }, {
                                        some: function(h) {
                                            d(this);
                                            c(h);
                                            var k = e(this), l = 0;
                                            return b(k, function(m, n) {
                                                if (h(m, l++)) return n();
                                            }, {
                                                IS_RECORD: !0,
                                                INTERRUPTED: !0
                                            }).stopped;
                                        }
                                    });
                                },
                                8335: function(g, f, a) {
                                    function b(U, K) {
                                        this.source = U;
                                        this.index = K;
                                    }
                                    function c(U, K, N, V) {
                                        this.value = U;
                                        this.end = K;
                                        this.source = N;
                                        this.nodes = V;
                                    }
                                    function d(U, K, N) {
                                        if (h) {
                                            var V = M(U, K);
                                            if (V && !V.configurable) return;
                                        }
                                        void 0 === N ? delete U[K] : x(U, K, N);
                                    }
                                    function e(U, K, N, V) {
                                        var ea = U[K], ia = V && ea === V.value, na = ia && "string" == typeof V.source ? {
                                            source: V.source
                                        } : {};
                                        if (r(ea)) {
                                            var ua = t(ea);
                                            V = ia ? V.nodes : ua ? [] : {};
                                            if (ua) {
                                                var va = V.length;
                                                ua = w(ea);
                                                for(ia = 0; ia < ua; ia++)d(ea, ia, e(ea, "" + ia, N, ia < va ? V[ia] : void 0));
                                            } else for(va = J(ea), ua = w(va), ia = 0; ia < ua; ia++){
                                                var za = va[ia];
                                                d(ea, za, e(ea, za, N, u(V, za) ? V[za] : void 0));
                                            }
                                        }
                                        return n(N, U, K, ea, na);
                                    }
                                    g = a(6518);
                                    var h = a(3724), k = a(4576), l = a(7751), m = a(9504), n = a(9565), q = a(4901), r = a(34), t = a(4376), u = a(9297), v = a(655), w = a(6198), x = a(2278);
                                    f = a(9039);
                                    var B = a(8235);
                                    a = a(4495);
                                    var z = k.JSON, C = k.Number, D = k.SyntaxError, H = z && z.parse, J = l("Object", "keys"), M = Object.getOwnPropertyDescriptor, I = m("".charAt), P = m("".slice), L = m(/./.exec), T = m([].push), aa = /^\d$/, ba = /^[1-9]$/, ra = /^[\d-]$/, X = /^[\t\n\r ]$/;
                                    b.prototype = {
                                        fork: function(U) {
                                            return new b(this.source, U);
                                        },
                                        parse: function() {
                                            var U = this.source, K = this.skip(X, this.index), N = this.fork(K);
                                            U = I(U, K);
                                            if (L(ra, U)) return N.number();
                                            switch(U){
                                                case "{":
                                                    return N.object();
                                                case "[":
                                                    return N.array();
                                                case '"':
                                                    return N.string();
                                                case "t":
                                                    return N.keyword(!0);
                                                case "f":
                                                    return N.keyword(!1);
                                                case "n":
                                                    return N.keyword(null);
                                            }
                                            throw new D('Unexpected character: "' + U + '" at: ' + K);
                                        },
                                        node: function(U, K, N, V, ea) {
                                            return new c(K, V, U ? null : P(this.source, N, V), ea);
                                        },
                                        object: function() {
                                            for(var U = this.source, K = this.index + 1, N = !1, V = {}, ea = {}; K < U.length;){
                                                K = this.until([
                                                    '"',
                                                    "}"
                                                ], K);
                                                if ("}" === I(U, K) && !N) {
                                                    K++;
                                                    break;
                                                }
                                                K = this.fork(K).string();
                                                var ia = K.value;
                                                K = K.end;
                                                K = this.until([
                                                    ":"
                                                ], K) + 1;
                                                K = this.skip(X, K);
                                                K = this.fork(K).parse();
                                                x(ea, ia, K);
                                                x(V, ia, K.value);
                                                K = this.until([
                                                    ",",
                                                    "}"
                                                ], K.end);
                                                ia = I(U, K);
                                                if ("," === ia) N = !0, K++;
                                                else if ("}" === ia) {
                                                    K++;
                                                    break;
                                                }
                                            }
                                            return this.node(1, V, this.index, K, ea);
                                        },
                                        array: function() {
                                            for(var U = this.source, K = this.index + 1, N = !1, V = [], ea = []; K < U.length;){
                                                K = this.skip(X, K);
                                                if ("]" === I(U, K) && !N) {
                                                    K++;
                                                    break;
                                                }
                                                K = this.fork(K).parse();
                                                T(ea, K);
                                                T(V, K.value);
                                                K = this.until([
                                                    ",",
                                                    "]"
                                                ], K.end);
                                                if ("," === I(U, K)) N = !0, K++;
                                                else if ("]" === I(U, K)) {
                                                    K++;
                                                    break;
                                                }
                                            }
                                            return this.node(1, V, this.index, K, ea);
                                        },
                                        string: function() {
                                            var U = this.index, K = B(this.source, this.index + 1);
                                            return this.node(0, K.value, U, K.end);
                                        },
                                        number: function() {
                                            var U = this.source, K = this.index, N = K;
                                            "-" === I(U, N) && N++;
                                            if ("0" === I(U, N)) N++;
                                            else if (L(ba, I(U, N))) N = this.skip(aa, N + 1);
                                            else throw new D("Failed to parse number at: " + N);
                                            "." === I(U, N) && (N = this.skip(aa, N + 1));
                                            if ("e" === I(U, N) || "E" === I(U, N)) {
                                                N++;
                                                "+" !== I(U, N) && "-" !== I(U, N) || N++;
                                                var V = N;
                                                N = this.skip(aa, N);
                                                if (V === N) throw new D("Failed to parse number's exponent value at: " + N);
                                            }
                                            return this.node(0, C(P(U, K, N)), K, N);
                                        },
                                        keyword: function(U) {
                                            var K = "" + U, N = this.index, V = N + K.length;
                                            if (P(this.source, N, V) !== K) throw new D("Failed to parse value at: " + N);
                                            return this.node(0, U, N, V);
                                        },
                                        skip: function(U, K) {
                                            for(var N = this.source; K < N.length && L(U, I(N, K)); K++);
                                            return K;
                                        },
                                        until: function(U, K) {
                                            K = this.skip(X, K);
                                            for(var N = I(this.source, K), V = 0; V < U.length; V++)if (U[V] === N) return K;
                                            throw new D('Unexpected character: "' + N + '" at: ' + K);
                                        }
                                    };
                                    k = f(function() {
                                        var U;
                                        H("9007199254740993", function(K, N, V) {
                                            U = V.source;
                                        });
                                        return "9007199254740993" !== U;
                                    });
                                    var ma = a && !f(function() {
                                        return -Infinity !== 1 / H("-0 	");
                                    });
                                    g({
                                        target: "JSON",
                                        stat: !0,
                                        forced: k
                                    }, {
                                        parse: function(U, K) {
                                            if (ma && !q(K)) K = H(U);
                                            else {
                                                U = v(U);
                                                var N = new b(U, 0, ""), V = N.parse(), ea = V.value;
                                                N = N.skip(X, V.end);
                                                if (N < U.length) throw new D('Unexpected extra character: "' + I(U, N) + '" after the parsed data at: ' + N);
                                                K = q(K) ? e({
                                                    "": ea
                                                }, "", K, V) : ea;
                                            }
                                            return K;
                                        }
                                    });
                                },
                                2953: function(g, f, a) {
                                    function b(n, q) {
                                        if (n) {
                                            if (n[k] !== l) try {
                                                e(n, k, l);
                                            } catch (t) {
                                                n[k] = l;
                                            }
                                            h(n, q, !0);
                                            if (c[q]) {
                                                for(var r in d)if (n[r] !== d[r]) try {
                                                    e(n, r, d[r]);
                                                } catch (t) {
                                                    n[r] = d[r];
                                                }
                                            }
                                        }
                                    }
                                    g = a(4576);
                                    var c = a(7400);
                                    f = a(9296);
                                    var d = a(3792), e = a(6699), h = a(687), k = a(8227)("iterator"), l = d.values, m;
                                    for(m in c)b(g[m] && g[m].prototype, m);
                                    b(f, "DOMTokenList");
                                },
                                4979: function(g, f, a) {
                                    function b() {
                                        l(this, v);
                                        var z = arguments.length, C = n(1 > z ? void 0 : arguments[0]);
                                        z = n(2 > z ? void 0 : arguments[1], "Error");
                                        z = new u(C, z);
                                        C = new t(C);
                                        C.name = "DOMException";
                                        k(z, "stack", h(1, q(C.stack, 1)));
                                        m(z, this, b);
                                        return z;
                                    }
                                    var c = a(6518), d = a(4576), e = a(7751), h = a(6980), k = a(4913).f;
                                    g = a(9297);
                                    var l = a(679), m = a(3167), n = a(2603);
                                    f = a(5002);
                                    var q = a(6193), r = a(3724);
                                    a = a(6395);
                                    var t = e("Error"), u = e("DOMException"), v = b.prototype = u.prototype, w = "stack" in new t("DOMException"), x = "stack" in new u(1, 2);
                                    d = u && r && Object.getOwnPropertyDescriptor(d, "DOMException");
                                    d = !!d && !(d.writable && d.configurable);
                                    w = w && !d && !x;
                                    c({
                                        global: !0,
                                        constructor: !0,
                                        forced: a || w
                                    }, {
                                        DOMException: w ? b : u
                                    });
                                    c = e("DOMException");
                                    e = c.prototype;
                                    if (e.constructor !== c) {
                                        a || k(e, "constructor", h(1, c));
                                        for(var B in f)g(f, B) && (a = f[B], e = a.s, g(c, e) || k(c, e, h(6, a.c)));
                                    }
                                }
                            }, Zc = {};
                            (function() {
                                F.d = function(g, f) {
                                    for(var a in f)F.o(f, a) && !F.o(g, a) && Object.defineProperty(g, a, {
                                        enumerable: !0,
                                        get: f[a]
                                    });
                                };
                            })();
                            (function() {
                                F.o = function(g, f) {
                                    return Object.prototype.hasOwnProperty.call(g, f);
                                };
                            })();
                            (function() {
                                F.r = function(g) {
                                    "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(g, Symbol.toStringTag, {
                                        value: "Module"
                                    });
                                    Object.defineProperty(g, "__esModule", {
                                        value: !0
                                    });
                                };
                            })();
                            var tb = globalThis.pdfjsLib = {};
                            F.r(tb);
                            F.d(tb, {
                                AbortException: function() {
                                    return cb;
                                },
                                AnnotationEditorLayer: function() {
                                    return Ic;
                                },
                                AnnotationEditorParamsType: function() {
                                    return pa;
                                },
                                AnnotationEditorType: function() {
                                    return sa;
                                },
                                AnnotationEditorUIManager: function() {
                                    return gb;
                                },
                                AnnotationElement: function() {
                                    return Ea;
                                },
                                AnnotationLayer: function() {
                                    return jg;
                                },
                                AnnotationMode: function() {
                                    return Ya;
                                },
                                ColorPicker: function() {
                                    return Jc;
                                },
                                DOMSVGFactory: function() {
                                    return Kc;
                                },
                                DrawLayer: function() {
                                    return kg;
                                },
                                FeatureTest: function() {
                                    return Ka;
                                },
                                GlobalWorkerOptions: function() {
                                    return mb;
                                },
                                ImageKind: function() {
                                    return Fb;
                                },
                                InvalidPDFException: function() {
                                    return Ae;
                                },
                                MissingPDFException: function() {
                                    return db;
                                },
                                OPS: function() {
                                    return Pa;
                                },
                                OutputScale: function() {
                                    return Lc;
                                },
                                PDFDataRangeTransport: function() {
                                    return $d;
                                },
                                PDFDateString: function() {
                                    return Mc;
                                },
                                PDFWorker: function() {
                                    return Wa;
                                },
                                PasswordResponses: function() {
                                    return lg;
                                },
                                PermissionFlag: function() {
                                    return mg;
                                },
                                PixelsPerInch: function() {
                                    return E;
                                },
                                RenderingCancelledException: function() {
                                    return Nc;
                                },
                                TextLayer: function() {
                                    return Za;
                                },
                                UnexpectedResponseException: function() {
                                    return Hb;
                                },
                                Util: function() {
                                    return fa;
                                },
                                VerbosityLevel: function() {
                                    return wb;
                                },
                                XfaLayer: function() {
                                    return Be;
                                },
                                build: function() {
                                    return "da10fb6b5";
                                },
                                createValidAbsoluteUrl: function() {
                                    return Fa;
                                },
                                fetchData: function() {
                                    return xb;
                                },
                                getDocument: function() {
                                    return Gf;
                                },
                                getFilenameFromUrl: function() {
                                    return jf;
                                },
                                getPdfFilenameFromUrl: function() {
                                    return kf;
                                },
                                getXfaPageViewport: function() {
                                    return lf;
                                },
                                isDataScheme: function() {
                                    return zb;
                                },
                                isPdfFile: function() {
                                    return Vb;
                                },
                                noContextMenu: function() {
                                    return Ma;
                                },
                                normalizeUnicode: function() {
                                    return ff;
                                },
                                setLayerDimensions: function() {
                                    return ab;
                                },
                                shadow: function() {
                                    return qa;
                                },
                                version: function() {
                                    return "4.8.73";
                                }
                            });
                            F(5081);
                            F(6280);
                            F(4423);
                            F(3792);
                            F(4114);
                            F(1745);
                            F(6573);
                            F(8100);
                            F(7936);
                            F(7495);
                            F(8156);
                            F(5440);
                            F(9978);
                            F(1489);
                            F(1740);
                            F(8140);
                            F(5044);
                            F(1903);
                            F(1134);
                            F(8845);
                            F(373);
                            F(7467);
                            F(4732);
                            F(9577);
                            F(2953);
                            F(4979);
                            var Ce = [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ], Oc = [
                                .001,
                                0,
                                0,
                                .001,
                                0,
                                0
                            ], Ya = {
                                DISABLE: 0,
                                ENABLE: 1,
                                ENABLE_FORMS: 2,
                                ENABLE_STORAGE: 3
                            }, sa = {
                                DISABLE: -1,
                                NONE: 0,
                                FREETEXT: 3,
                                HIGHLIGHT: 9,
                                STAMP: 13,
                                INK: 15
                            }, pa = {
                                RESIZE: 1,
                                CREATE: 2,
                                FREETEXT_SIZE: 11,
                                FREETEXT_COLOR: 12,
                                FREETEXT_OPACITY: 13,
                                INK_COLOR: 21,
                                INK_THICKNESS: 22,
                                INK_OPACITY: 23,
                                HIGHLIGHT_COLOR: 31,
                                HIGHLIGHT_DEFAULT_COLOR: 32,
                                HIGHLIGHT_THICKNESS: 33,
                                HIGHLIGHT_FREE: 34,
                                HIGHLIGHT_SHOW_ALL: 35
                            }, mg = {
                                PRINT: 4,
                                MODIFY_CONTENTS: 8,
                                COPY: 16,
                                MODIFY_ANNOTATIONS: 32,
                                FILL_INTERACTIVE_FORMS: 256,
                                COPY_FOR_ACCESSIBILITY: 512,
                                ASSEMBLE: 1024,
                                PRINT_HIGH_QUALITY: 2048
                            }, Fb = {
                                GRAYSCALE_1BPP: 1,
                                RGB_24BPP: 2,
                                RGBA_32BPP: 3
                            }, wb = {
                                ERRORS: 0,
                                WARNINGS: 1,
                                INFOS: 5
                            }, Pa = {
                                dependency: 1,
                                setLineWidth: 2,
                                setLineCap: 3,
                                setLineJoin: 4,
                                setMiterLimit: 5,
                                setDash: 6,
                                setRenderingIntent: 7,
                                setFlatness: 8,
                                setGState: 9,
                                save: 10,
                                restore: 11,
                                transform: 12,
                                moveTo: 13,
                                lineTo: 14,
                                curveTo: 15,
                                curveTo2: 16,
                                curveTo3: 17,
                                closePath: 18,
                                rectangle: 19,
                                stroke: 20,
                                closeStroke: 21,
                                fill: 22,
                                eoFill: 23,
                                fillStroke: 24,
                                eoFillStroke: 25,
                                closeFillStroke: 26,
                                closeEOFillStroke: 27,
                                endPath: 28,
                                clip: 29,
                                eoClip: 30,
                                beginText: 31,
                                endText: 32,
                                setCharSpacing: 33,
                                setWordSpacing: 34,
                                setHScale: 35,
                                setLeading: 36,
                                setFont: 37,
                                setTextRenderingMode: 38,
                                setTextRise: 39,
                                moveText: 40,
                                setLeadingMoveText: 41,
                                setTextMatrix: 42,
                                nextLine: 43,
                                showText: 44,
                                showSpacedText: 45,
                                nextLineShowText: 46,
                                nextLineSetSpacingShowText: 47,
                                setCharWidth: 48,
                                setCharWidthAndBounds: 49,
                                setStrokeColorSpace: 50,
                                setFillColorSpace: 51,
                                setStrokeColor: 52,
                                setStrokeColorN: 53,
                                setFillColor: 54,
                                setFillColorN: 55,
                                setStrokeGray: 56,
                                setFillGray: 57,
                                setStrokeRGBColor: 58,
                                setFillRGBColor: 59,
                                setStrokeCMYKColor: 60,
                                setFillCMYKColor: 61,
                                shadingFill: 62,
                                beginInlineImage: 63,
                                beginImageData: 64,
                                endInlineImage: 65,
                                paintXObject: 66,
                                markPoint: 67,
                                markPointProps: 68,
                                beginMarkedContent: 69,
                                beginMarkedContentProps: 70,
                                endMarkedContent: 71,
                                beginCompat: 72,
                                endCompat: 73,
                                paintFormXObjectBegin: 74,
                                paintFormXObjectEnd: 75,
                                beginGroup: 76,
                                endGroup: 77,
                                beginAnnotation: 80,
                                endAnnotation: 81,
                                paintImageMaskXObject: 83,
                                paintImageMaskXObjectGroup: 84,
                                paintImageXObject: 85,
                                paintInlineImageXObject: 86,
                                paintInlineImageXObjectGroup: 87,
                                paintImageXObjectRepeat: 88,
                                paintImageMaskXObjectRepeat: 89,
                                paintSolidColorImageMask: 90,
                                constructPath: 91,
                                setStrokeTransparent: 92,
                                setFillTransparent: 93
                            }, lg = {
                                NEED_PASSWORD: 1,
                                INCORRECT_PASSWORD: 2
                            }, vb = wb.WARNINGS, $a = function() {
                                function g(f, a) {
                                    this.message = f;
                                    this.name = a;
                                }
                                g.prototype = Error();
                                return g.constructor = g;
                            }(), nc = function(g) {
                                function f(a, b) {
                                    a = g.call(this, a, "PasswordException") || this;
                                    a.code = b;
                                    return a;
                                }
                                ca(f, g);
                                return f;
                            }($a), oc = function(g) {
                                function f(a, b) {
                                    a = g.call(this, a, "UnknownErrorException") || this;
                                    a.details = b;
                                    return a;
                                }
                                ca(f, g);
                                return f;
                            }($a), Ae = function(g) {
                                function f(a) {
                                    return g.call(this, a, "InvalidPDFException") || this;
                                }
                                ca(f, g);
                                return f;
                            }($a), db = function(g) {
                                function f(a) {
                                    return g.call(this, a, "MissingPDFException") || this;
                                }
                                ca(f, g);
                                return f;
                            }($a), Hb = function(g) {
                                function f(a, b) {
                                    a = g.call(this, a, "UnexpectedResponseException") || this;
                                    a.status = b;
                                    return a;
                                }
                                ca(f, g);
                                return f;
                            }($a), ng = function(g) {
                                function f(a) {
                                    return g.call(this, a, "FormatError") || this;
                                }
                                ca(f, g);
                                return f;
                            }($a), cb = function(g) {
                                function f(a) {
                                    return g.call(this, a, "AbortException") || this;
                                }
                                ca(f, g);
                                return f;
                            }($a), Ka = function() {
                                return Q(function() {}, null, [
                                    {
                                        key: "isLittleEndian",
                                        get: function() {
                                            var g = new Uint8Array(4);
                                            g[0] = 1;
                                            g = 1 === new Uint32Array(g.buffer, 0, 1)[0];
                                            return qa(this, "isLittleEndian", g);
                                        }
                                    },
                                    {
                                        key: "isEvalSupported",
                                        get: function() {
                                            try {
                                                new Function("");
                                                var g = !0;
                                            } catch (f) {
                                                g = !1;
                                            }
                                            return qa(this, "isEvalSupported", g);
                                        }
                                    },
                                    {
                                        key: "isOffscreenCanvasSupported",
                                        get: function() {
                                            return qa(this, "isOffscreenCanvasSupported", "undefined" !== typeof OffscreenCanvas);
                                        }
                                    },
                                    {
                                        key: "platform",
                                        get: function() {
                                            var g;
                                            if ("undefined" !== typeof navigator && "string" === typeof (null == (g = navigator) ? void 0 : g.platform)) {
                                                var f;
                                                return qa(this, "platform", {
                                                    isMac: navigator.platform.includes("Mac"),
                                                    isWindows: navigator.platform.includes("Win"),
                                                    isFirefox: "string" === typeof (null == (f = navigator) ? void 0 : f.userAgent) && navigator.userAgent.includes("Firefox")
                                                });
                                            }
                                            return qa(this, "platform", {
                                                isMac: !1,
                                                isWindows: !1,
                                                isFirefox: !1
                                            });
                                        }
                                    },
                                    {
                                        key: "isCSSRoundSupported",
                                        get: function() {
                                            var g;
                                            return qa(this, "isCSSRoundSupported", null == (g = globalThis.CSS) || null == g.supports ? void 0 : g.supports("width: round(1.5px, 1px)"));
                                        }
                                    }
                                ]);
                            }(), Pc = Array.from(Array(256).keys(), function(g) {
                                return g.toString(16).padStart(2, "0");
                            }), fa = function() {
                                function g() {}
                                g.makeHexColor = function(f, a, b) {
                                    return "#" + Pc[f] + Pc[a] + Pc[b];
                                };
                                g.scaleMinMax = function(f, a) {
                                    if (f[0]) {
                                        if (0 > f[0]) {
                                            var b = a[0];
                                            a[0] = a[2];
                                            a[2] = b;
                                        }
                                        a[0] *= f[0];
                                        a[2] *= f[0];
                                        0 > f[3] && (b = a[1], a[1] = a[3], a[3] = b);
                                        a[1] *= f[3];
                                        a[3] *= f[3];
                                    } else b = a[0], a[0] = a[1], a[1] = b, b = a[2], a[2] = a[3], a[3] = b, 0 > f[1] && (b = a[1], a[1] = a[3], a[3] = b), a[1] *= f[1], a[3] *= f[1], 0 > f[2] && (b = a[0], a[0] = a[2], a[2] = b), a[0] *= f[2], a[2] *= f[2];
                                    a[0] += f[4];
                                    a[1] += f[5];
                                    a[2] += f[4];
                                    a[3] += f[5];
                                };
                                g.transform = function(f, a) {
                                    return [
                                        f[0] * a[0] + f[2] * a[1],
                                        f[1] * a[0] + f[3] * a[1],
                                        f[0] * a[2] + f[2] * a[3],
                                        f[1] * a[2] + f[3] * a[3],
                                        f[0] * a[4] + f[2] * a[5] + f[4],
                                        f[1] * a[4] + f[3] * a[5] + f[5]
                                    ];
                                };
                                g.applyTransform = function(f, a) {
                                    return [
                                        f[0] * a[0] + f[1] * a[2] + a[4],
                                        f[0] * a[1] + f[1] * a[3] + a[5]
                                    ];
                                };
                                g.applyInverseTransform = function(f, a) {
                                    var b = a[0] * a[3] - a[1] * a[2];
                                    return [
                                        (f[0] * a[3] - f[1] * a[2] + a[2] * a[5] - a[4] * a[3]) / b,
                                        (-f[0] * a[1] + f[1] * a[0] + a[4] * a[1] - a[5] * a[0]) / b
                                    ];
                                };
                                g.getAxialAlignedBoundingBox = function(f, a) {
                                    var b = this.applyTransform(f, a), c = this.applyTransform(f.slice(2, 4), a), d = this.applyTransform([
                                        f[0],
                                        f[3]
                                    ], a);
                                    f = this.applyTransform([
                                        f[2],
                                        f[1]
                                    ], a);
                                    return [
                                        Math.min(b[0], c[0], d[0], f[0]),
                                        Math.min(b[1], c[1], d[1], f[1]),
                                        Math.max(b[0], c[0], d[0], f[0]),
                                        Math.max(b[1], c[1], d[1], f[1])
                                    ];
                                };
                                g.inverseTransform = function(f) {
                                    var a = f[0] * f[3] - f[1] * f[2];
                                    return [
                                        f[3] / a,
                                        -f[1] / a,
                                        -f[2] / a,
                                        f[0] / a,
                                        (f[2] * f[5] - f[4] * f[3]) / a,
                                        (f[4] * f[1] - f[5] * f[0]) / a
                                    ];
                                };
                                g.singularValueDecompose2dScale = function(f) {
                                    var a = [
                                        f[0],
                                        f[2],
                                        f[1],
                                        f[3]
                                    ], b = f[0] * a[0] + f[1] * a[2], c = f[2] * a[1] + f[3] * a[3], d = (b + c) / 2;
                                    f = Math.sqrt(Math.pow(b + c, 2) - 4 * (b * c - (f[2] * a[0] + f[3] * a[2]) * (f[0] * a[1] + f[1] * a[3]))) / 2;
                                    return [
                                        Math.sqrt(d + f || 1),
                                        Math.sqrt(d - f || 1)
                                    ];
                                };
                                g.normalizeRect = function(f) {
                                    var a = f.slice(0);
                                    f[0] > f[2] && (a[0] = f[2], a[2] = f[0]);
                                    f[1] > f[3] && (a[1] = f[3], a[3] = f[1]);
                                    return a;
                                };
                                g.intersect = function(f, a) {
                                    var b = Math.max(Math.min(f[0], f[2]), Math.min(a[0], a[2])), c = Math.min(Math.max(f[0], f[2]), Math.max(a[0], a[2]));
                                    if (b > c) return null;
                                    var d = Math.max(Math.min(f[1], f[3]), Math.min(a[1], a[3]));
                                    f = Math.min(Math.max(f[1], f[3]), Math.max(a[1], a[3]));
                                    return d > f ? null : [
                                        b,
                                        d,
                                        c,
                                        f
                                    ];
                                };
                                g.__getExtremumOnCurve = function(f, a, b, c, d, e, h, k, l, m) {
                                    if (!(0 >= l || 1 <= l)) {
                                        var n = 1 - l, q = l * l, r = q * l;
                                        f = n * (n * (n * f + 3 * l * a) + 3 * q * b) + r * c;
                                        d = n * (n * (n * d + 3 * l * e) + 3 * q * h) + r * k;
                                        m[0] = Math.min(m[0], f);
                                        m[1] = Math.min(m[1], d);
                                        m[2] = Math.max(m[2], f);
                                        m[3] = Math.max(m[3], d);
                                    }
                                };
                                g.__getExtremum = function(f, a, b, c, d, e, h, k, l, m, n, q) {
                                    1E-12 > Math.abs(l) ? 1E-12 <= Math.abs(m) && this.__getExtremumOnCurve(f, a, b, c, d, e, h, k, -n / m, q) : (n = Math.pow(m, 2) - 4 * n * l, 0 > n || (n = Math.sqrt(n), l *= 2, this.__getExtremumOnCurve(f, a, b, c, d, e, h, k, (-m + n) / l, q), this.__getExtremumOnCurve(f, a, b, c, d, e, h, k, (-m - n) / l, q)));
                                };
                                g.bezierBoundingBox = function(f, a, b, c, d, e, h, k, l) {
                                    l ? (l[0] = Math.min(l[0], f, h), l[1] = Math.min(l[1], a, k), l[2] = Math.max(l[2], f, h), l[3] = Math.max(l[3], a, k)) : l = [
                                        Math.min(f, h),
                                        Math.min(a, k),
                                        Math.max(f, h),
                                        Math.max(a, k)
                                    ];
                                    this.__getExtremum(f, b, d, h, a, c, e, k, 3 * (-f + 3 * (b - d) + h), 6 * (f - 2 * b + d), 3 * (b - f), l);
                                    this.__getExtremum(f, b, d, h, a, c, e, k, 3 * (-a + 3 * (c - e) + k), 6 * (a - 2 * c + e), 3 * (c - a), l);
                                    return l;
                                };
                                return g;
                            }(), Sb = null, $c = null;
                            F(9463);
                            F(3362);
                            F(9391);
                            F(4628);
                            F(7642);
                            F(8004);
                            F(3853);
                            F(5876);
                            F(2475);
                            F(5024);
                            F(1698);
                            F(1454);
                            F(3110);
                            F(5506);
                            F(9469);
                            F(8107);
                            F(4490);
                            F(7357);
                            F(2762);
                            F(8992);
                            F(4743);
                            F(3215);
                            F(7550);
                            F(8335);
                            F(4864);
                            F(7465);
                            F(5701);
                            F(744);
                            var De = E;
                            E.CSS = 96;
                            E.PDF = 72;
                            E.PDF_TO_CSS_UNITS = De.CSS / De.PDF;
                            var Wb = function() {
                                function g(a) {
                                    var b = a.viewBox, c = a.scale, d = a.rotation, e = void 0 === a.offsetX ? 0 : a.offsetX, h = void 0 === a.offsetY ? 0 : a.offsetY, k = void 0 === a.dontFlip ? !1 : a.dontFlip;
                                    this.viewBox = b;
                                    this.scale = c;
                                    this.rotation = d;
                                    this.offsetX = e;
                                    this.offsetY = h;
                                    a = (b[2] + b[0]) / 2;
                                    var l = (b[3] + b[1]) / 2, m;
                                    d %= 360;
                                    0 > d && (d += 360);
                                    switch(d){
                                        case 180:
                                            d = -1;
                                            var n = m = 0;
                                            var q = 1;
                                            break;
                                        case 90:
                                            d = 0;
                                            n = m = 1;
                                            q = 0;
                                            break;
                                        case 270:
                                            d = 0;
                                            n = m = -1;
                                            q = 0;
                                            break;
                                        case 0:
                                            d = 1;
                                            n = m = 0;
                                            q = -1;
                                            break;
                                        default:
                                            throw Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                                    }
                                    k && (n = -n, q = -q);
                                    0 === d ? (e = Math.abs(l - b[1]) * c + e, h = Math.abs(a - b[0]) * c + h, k = (b[3] - b[1]) * c, b = (b[2] - b[0]) * c) : (e = Math.abs(a - b[0]) * c + e, h = Math.abs(l - b[1]) * c + h, k = (b[2] - b[0]) * c, b = (b[3] - b[1]) * c);
                                    this.transform = [
                                        d * c,
                                        m * c,
                                        n * c,
                                        q * c,
                                        e - d * c * a - n * c * l,
                                        h - m * c * a - q * c * l
                                    ];
                                    this.width = k;
                                    this.height = b;
                                }
                                var f = g.prototype;
                                f.clone = function(a) {
                                    var b = void 0 === a ? {} : a;
                                    a = void 0 === b.scale ? this.scale : b.scale;
                                    var c = void 0 === b.rotation ? this.rotation : b.rotation, d = void 0 === b.offsetX ? this.offsetX : b.offsetX, e = void 0 === b.offsetY ? this.offsetY : b.offsetY;
                                    b = void 0 === b.dontFlip ? !1 : b.dontFlip;
                                    return new g({
                                        viewBox: this.viewBox.slice(),
                                        scale: a,
                                        rotation: c,
                                        offsetX: d,
                                        offsetY: e,
                                        dontFlip: b
                                    });
                                };
                                f.convertToViewportPoint = function(a, b) {
                                    return fa.applyTransform([
                                        a,
                                        b
                                    ], this.transform);
                                };
                                f.convertToViewportRectangle = function(a) {
                                    var b = fa.applyTransform([
                                        a[0],
                                        a[1]
                                    ], this.transform);
                                    a = fa.applyTransform([
                                        a[2],
                                        a[3]
                                    ], this.transform);
                                    return [
                                        b[0],
                                        b[1],
                                        a[0],
                                        a[1]
                                    ];
                                };
                                f.convertToPdfPoint = function(a, b) {
                                    return fa.applyInverseTransform([
                                        a,
                                        b
                                    ], this.transform);
                                };
                                return bd(g, [
                                    {
                                        key: "rawDims",
                                        get: function() {
                                            var a = this.viewBox;
                                            return qa(this, "rawDims", {
                                                pageWidth: a[2] - a[0],
                                                pageHeight: a[3] - a[1],
                                                pageX: a[0],
                                                pageY: a[1]
                                            });
                                        }
                                    }
                                ]);
                            }(), Nc = function(g) {
                                function f(a, b) {
                                    void 0 === b && (b = 0);
                                    a = g.call(this, a, "RenderingCancelledException") || this;
                                    a.extraDelay = b;
                                    return a;
                                }
                                gf(f, g);
                                return f;
                            }($a), Ee = function() {
                                function g() {
                                    this.started = Object.create(null);
                                    this.times = [];
                                }
                                var f = g.prototype;
                                f.time = function(a) {
                                    a in this.started && R("Timer is already running for " + a);
                                    this.started[a] = Date.now();
                                };
                                f.timeEnd = function(a) {
                                    a in this.started || R("Timer has not been started for " + a);
                                    this.times.push({
                                        name: a,
                                        start: this.started[a],
                                        end: Date.now()
                                    });
                                    delete this.started[a];
                                };
                                f.toString = function() {
                                    for(var a = [], b = 0, c = p.makeIterator(this.times), d = c.next(); !d.done; d = c.next())b = Math.max(d.value.name.length, b);
                                    c = p.makeIterator(this.times);
                                    for(d = c.next(); !d.done; d = c.next()){
                                        d = d.value;
                                        var e = d.start, h = d.end;
                                        a.push(d.name.padEnd(b) + " " + (h - e) + "ms\n");
                                    }
                                    return a.join("");
                                };
                                return g;
                            }(), Mc = function() {
                                function g() {}
                                g.toDateObject = function(f) {
                                    if (!f || "string" !== typeof f) return null;
                                    this.__regex || (this.__regex = RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
                                    var a = this.__regex.exec(f);
                                    if (!a) return null;
                                    f = parseInt(a[1], 10);
                                    var b = parseInt(a[2], 10);
                                    b = 1 <= b && 12 >= b ? b - 1 : 0;
                                    var c = parseInt(a[3], 10);
                                    c = 1 <= c && 31 >= c ? c : 1;
                                    var d = parseInt(a[4], 10);
                                    d = 0 <= d && 23 >= d ? d : 0;
                                    var e = parseInt(a[5], 10);
                                    e = 0 <= e && 59 >= e ? e : 0;
                                    var h = parseInt(a[6], 10);
                                    h = 0 <= h && 59 >= h ? h : 0;
                                    var k = a[7] || "Z", l = parseInt(a[8], 10);
                                    l = 0 <= l && 23 >= l ? l : 0;
                                    a = parseInt(a[9], 10) || 0;
                                    a = 0 <= a && 59 >= a ? a : 0;
                                    "-" === k ? (d += l, e += a) : "+" === k && (d -= l, e -= a);
                                    return new Date(Date.UTC(f, b, c, d, e, h));
                                };
                                return g;
                            }();
                            Mc.__regex = void 0;
                            var Lc = function() {
                                return bd(function() {
                                    var g = window.devicePixelRatio || 1;
                                    this.sy = this.sx = g;
                                }, [
                                    {
                                        key: "scaled",
                                        get: function() {
                                            return 1 !== this.sx || 1 !== this.sy;
                                        }
                                    },
                                    {
                                        key: "symmetric",
                                        get: function() {
                                            return this.sx === this.sy;
                                        }
                                    }
                                ]);
                            }(), Fe = function() {
                                function g(a) {
                                    this.__altText = this.__buttons = this.__colorPicker = this.__toolbar = null;
                                    this.__editor = a;
                                    g.__l10nRemove || (g.__l10nRemove = Object.freeze({
                                        freetext: "pdfjs-editor-remove-freetext-button",
                                        highlight: "pdfjs-editor-remove-highlight-button",
                                        ink: "pdfjs-editor-remove-ink-button",
                                        stamp: "pdfjs-editor-remove-stamp-button"
                                    }));
                                }
                                var f = g.prototype;
                                f.render = function() {
                                    var a = this.__toolbar = document.createElement("div");
                                    a.classList.add("editToolbar", "hidden");
                                    a.setAttribute("role", "toolbar");
                                    var b = this.__editor._uiManager._signal;
                                    a.addEventListener("contextmenu", Ma, {
                                        signal: b
                                    });
                                    a.addEventListener("pointerdown", g.__pointerDown, {
                                        signal: b
                                    });
                                    b = this.__buttons = document.createElement("div");
                                    b.className = "buttons";
                                    a.append(b);
                                    if (b = this.__editor.toolbarPosition) {
                                        var c = a.style;
                                        c.insetInlineEnd = 100 * ("ltr" === this.__editor._uiManager.direction ? 1 - b[0] : b[0]) + "%";
                                        c.top = "calc(" + 100 * b[1] + "% + var(--editor-toolbar-vert-offset))";
                                    }
                                    this.__addDeleteButton();
                                    return a;
                                };
                                g.__pointerDown = function(a) {
                                    a.stopPropagation();
                                };
                                f.__focusIn = function(a) {
                                    this.__editor._focusEventsAllowed = !1;
                                    a.preventDefault();
                                    a.stopPropagation();
                                };
                                f.__focusOut = function(a) {
                                    this.__editor._focusEventsAllowed = !0;
                                    a.preventDefault();
                                    a.stopPropagation();
                                };
                                f.__addListenersToElement = function(a) {
                                    var b = this.__editor._uiManager._signal;
                                    a.addEventListener("focusin", this.__focusIn.bind(this), {
                                        capture: !0,
                                        signal: b
                                    });
                                    a.addEventListener("focusout", this.__focusOut.bind(this), {
                                        capture: !0,
                                        signal: b
                                    });
                                    a.addEventListener("contextmenu", Ma, {
                                        signal: b
                                    });
                                };
                                f.hide = function() {
                                    var a;
                                    this.__toolbar.classList.add("hidden");
                                    null == (a = this.__colorPicker) || a.hideDropdown();
                                };
                                f.show = function() {
                                    var a;
                                    this.__toolbar.classList.remove("hidden");
                                    null == (a = this.__altText) || a.shown();
                                };
                                f.__addDeleteButton = function() {
                                    var a = this.__editor, b = a.editorType, c = a._uiManager;
                                    a = document.createElement("button");
                                    a.className = "delete";
                                    a.tabIndex = 0;
                                    a.setAttribute("data-l10n-id", g.__l10nRemove[b]);
                                    this.__addListenersToElement(a);
                                    a.addEventListener("click", function() {
                                        c.delete();
                                    }, {
                                        signal: c._signal
                                    });
                                    this.__buttons.append(a);
                                };
                                f.addAltText = function() {
                                    var a = mf(function d(c) {
                                        var e, h = this;
                                        return p.generator.createGenerator(d, function(k) {
                                            if (1 == k.nextAddress) return k.yield(c.render(), 2);
                                            e = k.yieldResult;
                                            h.__addListenersToElement(e);
                                            h.__buttons.prepend(e, h.__divider);
                                            h.__altText = c;
                                            k.jumpToEnd();
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.addColorPicker = function(a) {
                                    this.__colorPicker = a;
                                    a = a.renderButton();
                                    this.__addListenersToElement(a);
                                    this.__buttons.prepend(a, this.__divider);
                                };
                                f.remove = function() {
                                    var a;
                                    this.__toolbar.remove();
                                    null == (a = this.__colorPicker) || a.destroy();
                                    this.__colorPicker = null;
                                };
                                return nf(g, [
                                    {
                                        key: "div",
                                        get: function() {
                                            return this.__toolbar;
                                        }
                                    },
                                    {
                                        key: "__divider",
                                        get: function() {
                                            var a = document.createElement("div");
                                            a.className = "divider";
                                            return a;
                                        }
                                    }
                                ]);
                            }();
                            Fe.__l10nRemove = null;
                            var og = function() {
                                function g(a) {
                                    this.__toolbar = this.__buttons = null;
                                    this.__uiManager = a;
                                }
                                var f = g.prototype;
                                f.__render = function() {
                                    var a = this.__toolbar = document.createElement("div");
                                    a.className = "editToolbar";
                                    a.setAttribute("role", "toolbar");
                                    a.addEventListener("contextmenu", Ma, {
                                        signal: this.__uiManager._signal
                                    });
                                    var b = this.__buttons = document.createElement("div");
                                    b.className = "buttons";
                                    a.append(b);
                                    this.__addHighlightButton();
                                    return a;
                                };
                                f.__getLastPoint = function(a, b) {
                                    var c = 0, d = 0;
                                    a = p.makeIterator(a);
                                    for(var e = a.next(); !e.done; e = a.next()){
                                        var h = e.value;
                                        e = h.y + h.height;
                                        e < c || (h = h.x + (b ? h.width : 0), e > c ? (d = h, c = e) : b ? h > d && (d = h) : h < d && (d = h));
                                    }
                                    return [
                                        b ? 1 - d : d,
                                        c
                                    ];
                                };
                                f.show = function(a, b, c) {
                                    c = p.makeIterator(this.__getLastPoint(b, c));
                                    b = c.next().value;
                                    c = c.next().value;
                                    var d = (this.__toolbar || (this.__toolbar = this.__render())).style;
                                    a.append(this.__toolbar);
                                    d.insetInlineEnd = 100 * b + "%";
                                    d.top = "calc(" + 100 * c + "% + var(--editor-toolbar-vert-offset))";
                                };
                                f.hide = function() {
                                    this.__toolbar.remove();
                                };
                                f.__addHighlightButton = function() {
                                    var a = this, b = document.createElement("button");
                                    b.className = "highlightButton";
                                    b.tabIndex = 0;
                                    b.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button1");
                                    var c = document.createElement("span");
                                    b.append(c);
                                    c.className = "visuallyHidden";
                                    c.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button-label");
                                    c = this.__uiManager._signal;
                                    b.addEventListener("contextmenu", Ma, {
                                        signal: c
                                    });
                                    b.addEventListener("click", function() {
                                        a.__uiManager.highlightSelection("floating_button");
                                    }, {
                                        signal: c
                                    });
                                    this.__buttons.append(b);
                                };
                                return g;
                            }(), pg = function() {
                                return Ab(function() {
                                    this.__id = 0;
                                }, [
                                    {
                                        key: "id",
                                        get: function() {
                                            return "pdfjs_internal_editor_" + this.__id++;
                                        }
                                    }
                                ]);
                            }(), qg = function() {
                                function g() {
                                    var a;
                                    if ("undefined" !== typeof crypto && "function" === typeof (null == (a = crypto) ? void 0 : a.randomUUID)) var b = crypto.randomUUID();
                                    else {
                                        a = new Uint8Array(32);
                                        if ("undefined" !== typeof crypto && "function" === typeof (null == (b = crypto) ? void 0 : b.getRandomValues)) crypto.getRandomValues(a);
                                        else for(b = 0; 32 > b; b++)a[b] = Math.floor(255 * Math.random());
                                        b = lb(a);
                                    }
                                    this.__baseId = b;
                                    this.__id = 0;
                                    this.__cache = null;
                                }
                                var f = g.prototype;
                                f.__get = function() {
                                    var a = Ta(function e(c, d) {
                                        var h, k = this, l, m, n, q, r, t, u, v;
                                        return p.generator.createGenerator(e, function(w) {
                                            switch(w.nextAddress){
                                                case 1:
                                                    k.__cache || (k.__cache = new Map);
                                                    l = k.__cache.get(c);
                                                    if (null === l) return w.return(null);
                                                    if (null != (h = l) && h.bitmap) return l.refCounter += 1, w.return(l);
                                                    w.setCatchFinallyBlocks(2);
                                                    l || (l = {
                                                        bitmap: null,
                                                        id: "image_" + k.__baseId + "_" + k.__id++,
                                                        refCounter: 0,
                                                        isSvg: !1
                                                    });
                                                    if ("string" !== typeof d) {
                                                        d instanceof File ? m = l.file = d : d instanceof Blob && (m = d);
                                                        w.jumpTo(4);
                                                        break;
                                                    }
                                                    l.url = d;
                                                    return w.yield(xb(d, "blob"), 5);
                                                case 5:
                                                    m = w.yieldResult;
                                                case 4:
                                                    if ("image/svg+xml" === m.type) return q = g._isSVGFittingCanvas, r = new FileReader, t = new Image, u = new Promise(function(x, B) {
                                                        t.onload = function() {
                                                            l.bitmap = t;
                                                            l.isSvg = !0;
                                                            x();
                                                        };
                                                        r.onload = Ta(function C() {
                                                            var D;
                                                            return p.generator.createGenerator(C, function(H) {
                                                                if (1 == H.nextAddress) return D = l.svgUrl = r.result, H.yield(q, 2);
                                                                t.src = H.yieldResult ? D + "#svgView(preserveAspectRatio(none))" : D;
                                                                H.jumpToEnd();
                                                            });
                                                        });
                                                        t.onerror = r.onerror = B;
                                                    }), r.readAsDataURL(m), w.yield(u, 7);
                                                    n = l;
                                                    return w.yield(createImageBitmap(m), 8);
                                                case 8:
                                                    n.bitmap = w.yieldResult;
                                                    w.jumpTo(7);
                                                    break;
                                                case 7:
                                                    l.refCounter = 1;
                                                    w.leaveTryBlock(3);
                                                    break;
                                                case 2:
                                                    v = w.enterCatchBlock(), console.error(v), l = null;
                                                case 3:
                                                    return k.__cache.set(c, l), l && k.__cache.set(l.id, l), w.return(l);
                                            }
                                        });
                                    });
                                    return function(c, d) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.getFromFile = function() {
                                    var a = Ta(function d(c) {
                                        var e, h, k, l, m, n = this;
                                        return p.generator.createGenerator(d, function(q) {
                                            e = c;
                                            h = e.lastModified;
                                            k = e.name;
                                            l = e.size;
                                            m = e.type;
                                            return q.return(n.__get(h + "_" + k + "_" + l + "_" + m, c));
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.getFromUrl = function() {
                                    var a = Ta(function d(c) {
                                        var e = this;
                                        return p.generator.createGenerator(d, function(h) {
                                            return h.return(e.__get(c, c));
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.getFromBlob = function() {
                                    var a = Ta(function e(c, d) {
                                        var h, k = this;
                                        return p.generator.createGenerator(e, function(l) {
                                            if (1 == l.nextAddress) return l.yield(d, 2);
                                            h = l.yieldResult;
                                            return l.return(k.__get(c, h));
                                        });
                                    });
                                    return function(c, d) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.getFromId = function() {
                                    var a = Ta(function d(c) {
                                        var e = this, h, k, l;
                                        return p.generator.createGenerator(d, function(m) {
                                            e.__cache || (e.__cache = new Map);
                                            h = e.__cache.get(c);
                                            return h ? h.bitmap ? (h.refCounter += 1, m.return(h)) : h.file ? m.return(e.getFromFile(h.file)) : h.blobPromise ? (k = h, l = k.blobPromise, delete h.blobPromise, m.return(e.getFromBlob(h.id, l))) : m.return(e.getFromUrl(h.url)) : m.return(null);
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.getFromCanvas = function(a, b) {
                                    var c;
                                    this.__cache || (this.__cache = new Map);
                                    var d = this.__cache.get(a);
                                    if (null != (c = d) && c.bitmap) return d.refCounter += 1, d;
                                    c = new OffscreenCanvas(b.width, b.height);
                                    c.getContext("2d").drawImage(b, 0, 0);
                                    d = {
                                        bitmap: c.transferToImageBitmap(),
                                        id: "image_" + this.__baseId + "_" + this.__id++,
                                        refCounter: 1,
                                        isSvg: !1
                                    };
                                    this.__cache.set(a, d);
                                    this.__cache.set(d.id, d);
                                    return d;
                                };
                                f.getSvgUrl = function(a) {
                                    a = this.__cache.get(a);
                                    return null != a && a.isSvg ? a.svgUrl : null;
                                };
                                f.deleteId = function(a) {
                                    this.__cache || (this.__cache = new Map);
                                    if (a = this.__cache.get(a)) {
                                        if (--a.refCounter, 0 === a.refCounter) {
                                            var b = a.bitmap;
                                            if (!a.url && !a.file) {
                                                var c = new OffscreenCanvas(b.width, b.height);
                                                c.getContext("bitmaprenderer").transferFromImageBitmap(b);
                                                a.blobPromise = c.convertToBlob();
                                            }
                                            null == b.close || b.close();
                                            a.bitmap = null;
                                        }
                                    }
                                };
                                f.isValidId = function(a) {
                                    return a.startsWith("image_" + this.__baseId + "_");
                                };
                                return Ab(g, null, [
                                    {
                                        key: "_isSVGFittingCanvas",
                                        get: function() {
                                            var a = new OffscreenCanvas(1, 3).getContext("2d", {
                                                willReadFrequently: !0
                                            }), b = new Image;
                                            b.src = 'data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>';
                                            var c = b.decode().then(function() {
                                                a.drawImage(b, 0, 0, 1, 1, 0, 0, 1, 3);
                                                return 0 === new Uint32Array(a.getImageData(0, 0, 1, 1).data.buffer)[0];
                                            });
                                            return qa(this, "_isSVGFittingCanvas", c);
                                        }
                                    }
                                ]);
                            }(), rg = function() {
                                function g(a) {
                                    void 0 === a && (a = 128);
                                    this.__commands = [];
                                    this.__locked = !1;
                                    this.__position = -1;
                                    this.__maxSize = a;
                                }
                                var f = g.prototype;
                                f.add = function(a) {
                                    var b = a.cmd, c = a.undo, d = a.post, e = void 0 === a.type ? NaN : a.type, h = void 0 === a.overwriteIfSameType ? !1 : a.overwriteIfSameType, k = void 0 === a.keepUndo ? !1 : a.keepUndo;
                                    a.mustExec && b();
                                    this.__locked || (a = {
                                        cmd: b,
                                        undo: c,
                                        post: d,
                                        type: e
                                    }, -1 === this.__position ? (0 < this.__commands.length && (this.__commands.length = 0), this.__position = 0, this.__commands.push(a)) : h && this.__commands[this.__position].type === e ? (k && (a.undo = this.__commands[this.__position].undo), this.__commands[this.__position] = a) : (e = this.__position + 1, e === this.__maxSize ? this.__commands.splice(0, 1) : (this.__position = e, e < this.__commands.length && this.__commands.splice(e)), this.__commands.push(a)));
                                };
                                f.undo = function() {
                                    if (-1 !== this.__position) {
                                        this.__locked = !0;
                                        var a = this.__commands[this.__position], b = a.undo;
                                        a = a.post;
                                        b();
                                        null == a || a();
                                        this.__locked = !1;
                                        --this.__position;
                                    }
                                };
                                f.redo = function() {
                                    if (this.__position < this.__commands.length - 1) {
                                        this.__position += 1;
                                        this.__locked = !0;
                                        var a = this.__commands[this.__position], b = a.cmd;
                                        a = a.post;
                                        b();
                                        null == a || a();
                                        this.__locked = !1;
                                    }
                                };
                                f.hasSomethingToUndo = function() {
                                    return -1 !== this.__position;
                                };
                                f.hasSomethingToRedo = function() {
                                    return this.__position < this.__commands.length - 1;
                                };
                                f.destroy = function() {
                                    this.__commands = null;
                                };
                                return g;
                            }(), ub = function() {
                                function g(a) {
                                    this.buffer = [];
                                    this.callbacks = new Map;
                                    this.allKeys = new Set;
                                    var b = Ka.platform.isMac;
                                    a = p.makeIterator(a);
                                    for(var c = a.next(); !c.done; c = a.next()){
                                        var d = p.makeIterator(c.value), e = d.next().value;
                                        c = d.next().value;
                                        d = d.next().value;
                                        d = void 0 === d ? {} : d;
                                        e = p.makeIterator(e);
                                        for(var h = e.next(); !h.done; h = e.next()){
                                            h = h.value;
                                            var k = h.startsWith("mac+");
                                            b && k ? (this.callbacks.set(h.slice(4), {
                                                callback: c,
                                                options: d
                                            }), this.allKeys.add(h.split("+").at(-1))) : b || k || (this.callbacks.set(h, {
                                                callback: c,
                                                options: d
                                            }), this.allKeys.add(h.split("+").at(-1)));
                                        }
                                    }
                                }
                                var f = g.prototype;
                                f.__serialize = function(a) {
                                    a.altKey && this.buffer.push("alt");
                                    a.ctrlKey && this.buffer.push("ctrl");
                                    a.metaKey && this.buffer.push("meta");
                                    a.shiftKey && this.buffer.push("shift");
                                    this.buffer.push(a.key);
                                    a = this.buffer.join("+");
                                    this.buffer.length = 0;
                                    return a;
                                };
                                f.exec = function(a, b) {
                                    if (this.allKeys.has(b.key)) {
                                        var c = this.callbacks.get(this.__serialize(b));
                                        if (c) {
                                            var d = c.callback, e = c.options;
                                            c = void 0 === e.bubbles ? !1 : e.bubbles;
                                            var h = void 0 === e.args ? [] : e.args;
                                            e = void 0 === e.checker ? null : e.checker;
                                            if (!e || e(a, b)) d.bind.apply(d, [
                                                a
                                            ].concat(p.arrayFromIterable(h), [
                                                b
                                            ]))(), c || (b.stopPropagation(), b.preventDefault());
                                        }
                                    }
                                };
                                return g;
                            }(), Ge = function() {
                                function g() {}
                                var f = g.prototype;
                                f.convert = function(a) {
                                    var b = Xb(a);
                                    if (!window.matchMedia("(forced-colors: active)").matches) return b;
                                    a = p.makeIterator(this._colors);
                                    for(var c = a.next(); !c.done; c = a.next()){
                                        c = p.makeIterator(c.value);
                                        var d = c.next().value;
                                        if (c.next().value.every(function(e, h) {
                                            return e === b[h];
                                        })) return g._colorsMapping.get(d);
                                    }
                                    return b;
                                };
                                f.getHexCode = function(a) {
                                    var b = this._colors.get(a);
                                    return b ? fa.makeHexColor.apply(fa, p.arrayFromIterable(b)) : a;
                                };
                                return Ab(g, [
                                    {
                                        key: "_colors",
                                        get: function() {
                                            var a = new Map([
                                                [
                                                    "CanvasText",
                                                    null
                                                ],
                                                [
                                                    "Canvas",
                                                    null
                                                ]
                                            ]), b = document.createElement("span");
                                            b.style.visibility = "hidden";
                                            document.body.append(b);
                                            for(var c = p.makeIterator(a.keys()), d = c.next(); !d.done; d = c.next()){
                                                d = d.value;
                                                b.style.color = d;
                                                var e = window.getComputedStyle(b).color;
                                                a.set(d, Xb(e));
                                            }
                                            b.remove();
                                            return qa(this, "_colors", a);
                                        }
                                    }
                                ]);
                            }();
                            Ge._colorsMapping = new Map([
                                [
                                    "CanvasText",
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ],
                                [
                                    "Canvas",
                                    [
                                        255,
                                        255,
                                        255
                                    ]
                                ]
                            ]);
                            var gb = function() {
                                function g(a, b, c, d, e, h, k, l, m, n, q) {
                                    var r = this;
                                    this.__abortController = new AbortController;
                                    this.__activeEditor = null;
                                    this.__allEditors = new Map;
                                    this.__allLayers = new Map;
                                    this.__changedExistingAnnotations = this.__annotationStorage = this.__altTextManager = null;
                                    this.__commandManager = new rg;
                                    this.__copyPasteAC = null;
                                    this.__currentPageIndex = 0;
                                    this.__deletedAnnotationsElementIds = new Set;
                                    this.__editorTypes = this.__draggingEditors = null;
                                    this.__editorsToRescale = new Set;
                                    this.__enableNewAltTextWhenAddingImage = this.__enableUpdatedAddImage = this.__enableHighlightFloatingButton = !1;
                                    this.__highlightColors = this.__focusManagerAC = this.__focusMainContainerTimeoutId = this.__filterFactory = null;
                                    this.__highlightWhenShiftUp = !1;
                                    this.__highlightToolbar = null;
                                    this.__idManager = new pg;
                                    this.__isWaiting = this.__isEnabled = !1;
                                    this.__mlManager = this.__mainHighlightColorPicker = this.__lastActiveElement = this.__keyboardManagerAC = null;
                                    this.__mode = sa.NONE;
                                    this.__selectedEditors = new Set;
                                    this.__showAllStates = this.__pageColors = this.__selectedTextNode = null;
                                    this.__previousStates = {
                                        isEditing: !1,
                                        isEmpty: !0,
                                        hasSomethingToUndo: !1,
                                        hasSomethingToRedo: !1,
                                        hasSelectedEditor: !1,
                                        hasSelectedText: !1
                                    };
                                    this.__translation = [
                                        0,
                                        0
                                    ];
                                    this.__updateModeCapability = this.__viewer = this.__container = this.__translationTimeoutId = null;
                                    var t = this._signal = this.__abortController.signal;
                                    this.__container = a;
                                    this.__viewer = b;
                                    this.__altTextManager = c;
                                    this._eventBus = d;
                                    d._on("editingaction", this.onEditingAction.bind(this), {
                                        signal: t
                                    });
                                    d._on("pagechanging", this.onPageChanging.bind(this), {
                                        signal: t
                                    });
                                    d._on("scalechanging", this.onScaleChanging.bind(this), {
                                        signal: t
                                    });
                                    d._on("rotationchanging", this.onRotationChanging.bind(this), {
                                        signal: t
                                    });
                                    d._on("setpreference", this.onSetPreference.bind(this), {
                                        signal: t
                                    });
                                    d._on("switchannotationeditorparams", function(u) {
                                        return r.updateParams(u.type, u.value);
                                    }, {
                                        signal: t
                                    });
                                    this.__addSelectionListener();
                                    this.__addDragAndDropListeners();
                                    this.__addKeyboardManager();
                                    this.__annotationStorage = e.annotationStorage;
                                    this.__filterFactory = e.filterFactory;
                                    this.__pageColors = h;
                                    this.__highlightColors = k || null;
                                    this.__enableHighlightFloatingButton = l;
                                    this.__enableUpdatedAddImage = m;
                                    this.__enableNewAltTextWhenAddingImage = n;
                                    this.__mlManager = q || null;
                                    this.viewParameters = {
                                        realScale: E.PDF_TO_CSS_UNITS,
                                        rotation: 0
                                    };
                                    this.isShiftKeyDown = !1;
                                }
                                var f = g.prototype;
                                f.destroy = function() {
                                    var a, b, c, d;
                                    null == (a = this.__updateModeCapability) || a.resolve();
                                    this.__updateModeCapability = null;
                                    null == (b = this.__abortController) || b.abort();
                                    this._signal = this.__abortController = null;
                                    a = p.makeIterator(this.__allLayers.values());
                                    for(b = a.next(); !b.done; b = a.next())b.value.destroy();
                                    this.__allLayers.clear();
                                    this.__allEditors.clear();
                                    this.__editorsToRescale.clear();
                                    this.__activeEditor = null;
                                    this.__selectedEditors.clear();
                                    this.__commandManager.destroy();
                                    null == (c = this.__altTextManager) || c.destroy();
                                    null == (d = this.__highlightToolbar) || d.hide();
                                    this.__highlightToolbar = null;
                                    this.__focusMainContainerTimeoutId && (clearTimeout(this.__focusMainContainerTimeoutId), this.__focusMainContainerTimeoutId = null);
                                    this.__translationTimeoutId && (clearTimeout(this.__translationTimeoutId), this.__translationTimeoutId = null);
                                };
                                f.combinedSignal = function(a) {
                                    return AbortSignal.any([
                                        this._signal,
                                        a.signal
                                    ]);
                                };
                                f.setMainHighlightColorPicker = function(a) {
                                    this.__mainHighlightColorPicker = a;
                                };
                                f.editAltText = function(a, b) {
                                    var c;
                                    void 0 === b && (b = !1);
                                    null == (c = this.__altTextManager) || c.editAltText(this, a, b);
                                };
                                f.switchToMode = function(a, b) {
                                    this._eventBus.on("annotationeditormodechanged", b, {
                                        once: !0,
                                        signal: this._signal
                                    });
                                    this._eventBus.dispatch("showannotationeditorui", {
                                        source: this,
                                        mode: a
                                    });
                                };
                                f.setPreference = function(a, b) {
                                    this._eventBus.dispatch("setpreference", {
                                        source: this,
                                        name: a,
                                        value: b
                                    });
                                };
                                f.onSetPreference = function(a) {
                                    var b = a.value;
                                    switch(a.name){
                                        case "enableNewAltTextWhenAddingImage":
                                            this.__enableNewAltTextWhenAddingImage = b;
                                    }
                                };
                                f.onPageChanging = function(a) {
                                    this.__currentPageIndex = a.pageNumber - 1;
                                };
                                f.focusMainContainer = function() {
                                    this.__container.focus();
                                };
                                f.findParent = function(a, b) {
                                    for(var c = p.makeIterator(this.__allLayers.values()), d = c.next(); !d.done; d = c.next()){
                                        d = d.value;
                                        var e = d.div.getBoundingClientRect(), h = e.x, k = e.y, l = e.width;
                                        e = e.height;
                                        if (a >= h && a <= h + l && b >= k && b <= k + e) return d;
                                    }
                                    return null;
                                };
                                f.disableUserSelect = function(a) {
                                    void 0 === a && (a = !1);
                                    this.__viewer.classList.toggle("noUserSelect", a);
                                };
                                f.addShouldRescale = function(a) {
                                    this.__editorsToRescale.add(a);
                                };
                                f.removeShouldRescale = function(a) {
                                    this.__editorsToRescale.delete(a);
                                };
                                f.onScaleChanging = function(a) {
                                    a = a.scale;
                                    this.commitOrRemove();
                                    this.viewParameters.realScale = a * E.PDF_TO_CSS_UNITS;
                                    a = p.makeIterator(this.__editorsToRescale);
                                    for(var b = a.next(); !b.done; b = a.next())b.value.onScaleChanging();
                                };
                                f.onRotationChanging = function(a) {
                                    a = a.pagesRotation;
                                    this.commitOrRemove();
                                    this.viewParameters.rotation = a;
                                };
                                f.__getAnchorElementForSelection = function(a) {
                                    a = a.anchorNode;
                                    return a.nodeType === Node.TEXT_NODE ? a.parentElement : a;
                                };
                                f.__getLayerForTextLayer = function(a) {
                                    var b = this.currentLayer;
                                    if (b.hasTextLayer(a)) return b;
                                    b = p.makeIterator(this.__allLayers.values());
                                    for(var c = b.next(); !c.done; c = b.next())if (c = c.value, c.hasTextLayer(a)) return c;
                                    return null;
                                };
                                f.highlightSelection = function(a) {
                                    var b = this;
                                    void 0 === a && (a = "");
                                    var c = document.getSelection();
                                    if (c && !c.isCollapsed) {
                                        var d = c.anchorNode, e = c.anchorOffset, h = c.focusNode, k = c.focusOffset, l = c.toString(), m = this.__getAnchorElementForSelection(c).closest(".textLayer"), n = this.getSelectionBoxes(m);
                                        if (n) {
                                            c.empty();
                                            var q = this.__getLayerForTextLayer(m), r = this.__mode === sa.NONE;
                                            c = function() {
                                                null == q || q.createAndAddNewEditor({
                                                    x: 0,
                                                    y: 0
                                                }, !1, {
                                                    methodOfCreation: a,
                                                    boxes: n,
                                                    anchorNode: d,
                                                    anchorOffset: e,
                                                    focusNode: h,
                                                    focusOffset: k,
                                                    text: l
                                                });
                                                r && b.showAllEditors("highlight", !0, !0);
                                            };
                                            r ? this.switchToMode(sa.HIGHLIGHT, c) : c();
                                        }
                                    }
                                };
                                f.__displayHighlightToolbar = function() {
                                    var a = document.getSelection();
                                    if (a && !a.isCollapsed) {
                                        a = this.__getAnchorElementForSelection(a).closest(".textLayer");
                                        var b = this.getSelectionBoxes(a);
                                        b && (this.__highlightToolbar || (this.__highlightToolbar = new og(this)), this.__highlightToolbar.show(a, b, "ltr" === this.direction));
                                    }
                                };
                                f.addToAnnotationStorage = function(a) {
                                    a.isEmpty() || !this.__annotationStorage || this.__annotationStorage.has(a.id) || this.__annotationStorage.setValue(a.id, a);
                                };
                                f.__selectionChange = function() {
                                    var a = this, b, c = document.getSelection();
                                    if (!c || c.isCollapsed) {
                                        if (this.__selectedTextNode) {
                                            var d;
                                            null == (d = this.__highlightToolbar) || d.hide();
                                            this.__selectedTextNode = null;
                                            this.__dispatchUpdateStates({
                                                hasSelectedText: !1
                                            });
                                        }
                                    } else if (d = c.anchorNode, d !== this.__selectedTextNode) {
                                        if (c = this.__getAnchorElementForSelection(c).closest(".textLayer")) {
                                            if (null == (b = this.__highlightToolbar) || b.hide(), this.__selectedTextNode = d, this.__dispatchUpdateStates({
                                                hasSelectedText: !0
                                            }), this.__mode === sa.HIGHLIGHT || this.__mode === sa.NONE) {
                                                if (this.__mode === sa.HIGHLIGHT && this.showAllEditors("highlight", !0, !0), this.__highlightWhenShiftUp = this.isShiftKeyDown, !this.isShiftKeyDown) {
                                                    var e = this.__mode === sa.HIGHLIGHT ? this.__getLayerForTextLayer(c) : null;
                                                    null == e || e.toggleDrawing();
                                                    var h = new AbortController;
                                                    b = this.combinedSignal(h);
                                                    var k = function(l) {
                                                        if ("pointerup" !== l.type || 0 === l.button) h.abort(), null == e || e.toggleDrawing(!0), "pointerup" === l.type && a.__onSelectEnd("main_toolbar");
                                                    };
                                                    window.addEventListener("pointerup", k, {
                                                        signal: b
                                                    });
                                                    window.addEventListener("blur", k, {
                                                        signal: b
                                                    });
                                                }
                                            }
                                        } else this.__selectedTextNode && (null == (k = this.__highlightToolbar) || k.hide(), this.__selectedTextNode = null, this.__dispatchUpdateStates({
                                            hasSelectedText: !1
                                        }));
                                    }
                                };
                                f.__onSelectEnd = function(a) {
                                    void 0 === a && (a = "");
                                    this.__mode === sa.HIGHLIGHT ? this.highlightSelection(a) : this.__enableHighlightFloatingButton && this.__displayHighlightToolbar();
                                };
                                f.__addSelectionListener = function() {
                                    document.addEventListener("selectionchange", this.__selectionChange.bind(this), {
                                        signal: this._signal
                                    });
                                };
                                f.__addFocusManager = function() {
                                    if (!this.__focusManagerAC) {
                                        this.__focusManagerAC = new AbortController;
                                        var a = this.combinedSignal(this.__focusManagerAC);
                                        window.addEventListener("focus", this.focus.bind(this), {
                                            signal: a
                                        });
                                        window.addEventListener("blur", this.blur.bind(this), {
                                            signal: a
                                        });
                                    }
                                };
                                f.__removeFocusManager = function() {
                                    var a;
                                    null == (a = this.__focusManagerAC) || a.abort();
                                    this.__focusManagerAC = null;
                                };
                                f.blur = function() {
                                    this.isShiftKeyDown = !1;
                                    this.__highlightWhenShiftUp && (this.__highlightWhenShiftUp = !1, this.__onSelectEnd("main_toolbar"));
                                    if (this.hasSelection) {
                                        for(var a = document.activeElement, b = p.makeIterator(this.__selectedEditors), c = b.next(); !c.done; c = b.next())if (c = c.value, c.div.contains(a)) {
                                            this.__lastActiveElement = [
                                                c,
                                                a
                                            ];
                                            c._focusEventsAllowed = !1;
                                            break;
                                        }
                                    }
                                };
                                f.focus = function() {
                                    if (this.__lastActiveElement) {
                                        var a = p.makeIterator(this.__lastActiveElement), b = a.next().value;
                                        a = a.next().value;
                                        this.__lastActiveElement = null;
                                        a.addEventListener("focusin", function() {
                                            b._focusEventsAllowed = !0;
                                        }, {
                                            once: !0,
                                            signal: this._signal
                                        });
                                        a.focus();
                                    }
                                };
                                f.__addKeyboardManager = function() {
                                    if (!this.__keyboardManagerAC) {
                                        this.__keyboardManagerAC = new AbortController;
                                        var a = this.combinedSignal(this.__keyboardManagerAC);
                                        window.addEventListener("keydown", this.keydown.bind(this), {
                                            signal: a
                                        });
                                        window.addEventListener("keyup", this.keyup.bind(this), {
                                            signal: a
                                        });
                                    }
                                };
                                f.__removeKeyboardManager = function() {
                                    var a;
                                    null == (a = this.__keyboardManagerAC) || a.abort();
                                    this.__keyboardManagerAC = null;
                                };
                                f.__addCopyPasteListeners = function() {
                                    if (!this.__copyPasteAC) {
                                        this.__copyPasteAC = new AbortController;
                                        var a = this.combinedSignal(this.__copyPasteAC);
                                        document.addEventListener("copy", this.copy.bind(this), {
                                            signal: a
                                        });
                                        document.addEventListener("cut", this.cut.bind(this), {
                                            signal: a
                                        });
                                        document.addEventListener("paste", this.paste.bind(this), {
                                            signal: a
                                        });
                                    }
                                };
                                f.__removeCopyPasteListeners = function() {
                                    var a;
                                    null == (a = this.__copyPasteAC) || a.abort();
                                    this.__copyPasteAC = null;
                                };
                                f.__addDragAndDropListeners = function() {
                                    var a = this._signal;
                                    document.addEventListener("dragover", this.dragOver.bind(this), {
                                        signal: a
                                    });
                                    document.addEventListener("drop", this.drop.bind(this), {
                                        signal: a
                                    });
                                };
                                f.addEditListeners = function() {
                                    this.__addKeyboardManager();
                                    this.__addCopyPasteListeners();
                                };
                                f.removeEditListeners = function() {
                                    this.__removeKeyboardManager();
                                    this.__removeCopyPasteListeners();
                                };
                                f.dragOver = function(a) {
                                    for(var b = p.makeIterator(a.dataTransfer.items), c = b.next(); !c.done; c = b.next()){
                                        c = c.value.type;
                                        for(var d = p.makeIterator(this.__editorTypes), e = d.next(); !e.done; e = d.next())if (e.value.isHandlingMimeForPasting(c)) {
                                            a.dataTransfer.dropEffect = "copy";
                                            a.preventDefault();
                                            return;
                                        }
                                    }
                                };
                                f.drop = function(a) {
                                    for(var b = p.makeIterator(a.dataTransfer.items), c = b.next(); !c.done; c = b.next()){
                                        c = c.value;
                                        for(var d = p.makeIterator(this.__editorTypes), e = d.next(); !e.done; e = d.next())if (e = e.value, e.isHandlingMimeForPasting(c.type)) {
                                            e.paste(c, this.currentLayer);
                                            a.preventDefault();
                                            return;
                                        }
                                    }
                                };
                                f.copy = function(a) {
                                    var b;
                                    a.preventDefault();
                                    null == (b = this.__activeEditor) || b.commitOrRemove();
                                    if (this.hasSelection) {
                                        b = [];
                                        for(var c = p.makeIterator(this.__selectedEditors), d = c.next(); !d.done; d = c.next())(d = d.value.serialize(!0)) && b.push(d);
                                        0 !== b.length && a.clipboardData.setData("application/pdfjs", JSON.stringify(b));
                                    }
                                };
                                f.cut = function(a) {
                                    this.copy(a);
                                    this.delete();
                                };
                                f.paste = function() {
                                    var a = Ta(function d(c) {
                                        var e = this, h, k, l, m, n, q, r, t, u, v, w, x, B, z, C, D, H, J, M;
                                        return p.generator.createGenerator(d, function(I) {
                                            switch(I.nextAddress){
                                                case 1:
                                                    h = e;
                                                    c.preventDefault();
                                                    k = c;
                                                    l = k.clipboardData;
                                                    m = p.makeIterator(l.items);
                                                    for(n = m.next(); !n.done; n = m.next())for(q = n.value, r = p.makeIterator(e.__editorTypes), t = r.next(); !t.done; t = r.next())if (u = t.value, u.isHandlingMimeForPasting(q.type)) return u.paste(q, e.currentLayer), I.return();
                                                    v = l.getData("application/pdfjs");
                                                    if (!v) return I.return();
                                                    try {
                                                        v = JSON.parse(v);
                                                    } catch (P) {
                                                        return R('paste: "' + P.message + '".'), I.return();
                                                    }
                                                    if (!Array.isArray(v)) return I.return();
                                                    e.unselectAll();
                                                    w = e.currentLayer;
                                                    I.setCatchFinallyBlocks(2);
                                                    x = [];
                                                    B = p.makeIterator(v);
                                                    z = B.next();
                                                case 4:
                                                    if (z.done) {
                                                        H = function() {
                                                            for(var P = p.makeIterator(x), L = P.next(); !L.done; L = P.next())h.__addEditorToLayer(L.value);
                                                            h.__selectEditors(x);
                                                        };
                                                        J = function() {
                                                            for(var P = p.makeIterator(x), L = P.next(); !L.done; L = P.next())L.value.remove();
                                                        };
                                                        e.addCommands({
                                                            cmd: H,
                                                            undo: J,
                                                            mustExec: !0
                                                        });
                                                        I.leaveTryBlock(0);
                                                        break;
                                                    }
                                                    C = z.value;
                                                    return I.yield(w.deserialize(C), 7);
                                                case 7:
                                                    D = I.yieldResult;
                                                    if (!D) return I.return();
                                                    x.push(D);
                                                    z = B.next();
                                                    I.jumpTo(4);
                                                    break;
                                                case 2:
                                                    M = I.enterCatchBlock(), R('paste: "' + M.message + '".'), I.jumpToEnd();
                                            }
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.keydown = function(a) {
                                    this.isShiftKeyDown || "Shift" !== a.key || (this.isShiftKeyDown = !0);
                                    this.__mode === sa.NONE || this.isEditorHandlingKeyboard || g._keyboardManager.exec(this, a);
                                };
                                f.keyup = function(a) {
                                    this.isShiftKeyDown && "Shift" === a.key && (this.isShiftKeyDown = !1, this.__highlightWhenShiftUp && (this.__highlightWhenShiftUp = !1, this.__onSelectEnd("main_toolbar")));
                                };
                                f.onEditingAction = function(a) {
                                    a = a.name;
                                    switch(a){
                                        case "undo":
                                        case "redo":
                                        case "delete":
                                        case "selectAll":
                                            this[a]();
                                            break;
                                        case "highlightSelection":
                                            this.highlightSelection("context_menu");
                                    }
                                };
                                f.__dispatchUpdateStates = function(a) {
                                    var b = this;
                                    Object.entries(a).some(function(c) {
                                        var d = p.makeIterator(c);
                                        c = d.next().value;
                                        d = d.next().value;
                                        return b.__previousStates[c] !== d;
                                    }) && (this._eventBus.dispatch("annotationeditorstateschanged", {
                                        source: this,
                                        details: Object.assign(this.__previousStates, a)
                                    }), this.__mode === sa.HIGHLIGHT && !1 === a.hasSelectedEditor && this.__dispatchUpdateUI([
                                        [
                                            pa.HIGHLIGHT_FREE,
                                            !0
                                        ]
                                    ]));
                                };
                                f.__dispatchUpdateUI = function(a) {
                                    this._eventBus.dispatch("annotationeditorparamschanged", {
                                        source: this,
                                        details: a
                                    });
                                };
                                f.setEditingState = function(a) {
                                    a ? (this.__addFocusManager(), this.__addCopyPasteListeners(), this.__dispatchUpdateStates({
                                        isEditing: this.__mode !== sa.NONE,
                                        isEmpty: this.__isEmpty(),
                                        hasSomethingToUndo: this.__commandManager.hasSomethingToUndo(),
                                        hasSomethingToRedo: this.__commandManager.hasSomethingToRedo(),
                                        hasSelectedEditor: !1
                                    })) : (this.__removeFocusManager(), this.__removeCopyPasteListeners(), this.__dispatchUpdateStates({
                                        isEditing: !1
                                    }), this.disableUserSelect(!1));
                                };
                                f.registerEditorTypes = function(a) {
                                    if (!this.__editorTypes) {
                                        this.__editorTypes = a;
                                        a = p.makeIterator(this.__editorTypes);
                                        for(var b = a.next(); !b.done; b = a.next())this.__dispatchUpdateUI(b.value.defaultPropertiesToUpdate);
                                    }
                                };
                                f.getId = function() {
                                    return this.__idManager.id;
                                };
                                f.getLayer = function(a) {
                                    return this.__allLayers.get(a);
                                };
                                f.addLayer = function(a) {
                                    this.__allLayers.set(a.pageIndex, a);
                                    this.__isEnabled ? a.enable() : a.disable();
                                };
                                f.removeLayer = function(a) {
                                    this.__allLayers.delete(a.pageIndex);
                                };
                                f.updateMode = function() {
                                    var a = Ta(function h(c, d, e) {
                                        var k = this, l, m, n, q, r, t;
                                        return p.generator.createGenerator(h, function(u) {
                                            switch(u.nextAddress){
                                                case 1:
                                                    void 0 === d && (d = null);
                                                    void 0 === e && (e = !1);
                                                    if (k.__mode === c) return u.return();
                                                    if (!k.__updateModeCapability) {
                                                        u.jumpTo(2);
                                                        break;
                                                    }
                                                    return u.yield(k.__updateModeCapability.promise, 3);
                                                case 3:
                                                    if (!k.__updateModeCapability) return u.return();
                                                case 2:
                                                    k.__updateModeCapability = Promise.withResolvers();
                                                    k.__mode = c;
                                                    if (c === sa.NONE) return k.setEditingState(!1), k.__disableAll(), k.__updateModeCapability.resolve(), u.return();
                                                    k.setEditingState(!0);
                                                    return u.yield(k.__enableAll(), 4);
                                                case 4:
                                                    k.unselectAll();
                                                    l = p.makeIterator(k.__allLayers.values());
                                                    for(m = l.next(); !m.done; m = l.next())n = m.value, n.updateMode(c);
                                                    if (!d) return e && k.addNewEditorFromKeyboard(), k.__updateModeCapability.resolve(), u.return();
                                                    q = p.makeIterator(k.__allEditors.values());
                                                    for(r = q.next(); !r.done; r = q.next())t = r.value, t.annotationElementId === d ? (k.setSelected(t), t.enterInEditMode()) : t.unselect();
                                                    k.__updateModeCapability.resolve();
                                                    u.jumpToEnd();
                                            }
                                        });
                                    });
                                    return function(c, d, e) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.addNewEditorFromKeyboard = function() {
                                    this.currentLayer.canCreateNewEmptyEditor() && this.currentLayer.addNewEditor();
                                };
                                f.updateToolbar = function(a) {
                                    a !== this.__mode && this._eventBus.dispatch("switchannotationeditormode", {
                                        source: this,
                                        mode: a
                                    });
                                };
                                f.updateParams = function(a, b) {
                                    var c;
                                    if (this.__editorTypes) {
                                        switch(a){
                                            case pa.CREATE:
                                                this.currentLayer.addNewEditor();
                                                return;
                                            case pa.HIGHLIGHT_DEFAULT_COLOR:
                                                null == (c = this.__mainHighlightColorPicker) || c.updateColor(b);
                                                break;
                                            case pa.HIGHLIGHT_SHOW_ALL:
                                                this._eventBus.dispatch("reporttelemetry", {
                                                    source: this,
                                                    details: {
                                                        type: "editing",
                                                        data: {
                                                            type: "highlight",
                                                            action: "toggle_visibility"
                                                        }
                                                    }
                                                }), (this.__showAllStates || (this.__showAllStates = new Map)).set(a, b), this.showAllEditors("highlight", b);
                                        }
                                        c = p.makeIterator(this.__selectedEditors);
                                        for(var d = c.next(); !d.done; d = c.next())d.value.updateParams(a, b);
                                        c = p.makeIterator(this.__editorTypes);
                                        for(d = c.next(); !d.done; d = c.next())d.value.updateDefaultParams(a, b);
                                    }
                                };
                                f.showAllEditors = function(a, b) {
                                    for(var c, d, e = p.makeIterator(this.__allEditors.values()), h = e.next(); !h.done; h = e.next())h = h.value, h.editorType === a && h.show(b);
                                    (null != (c = null == (d = this.__showAllStates) ? void 0 : d.get(pa.HIGHLIGHT_SHOW_ALL)) ? c : !0) !== b && this.__dispatchUpdateUI([
                                        [
                                            pa.HIGHLIGHT_SHOW_ALL,
                                            b
                                        ]
                                    ]);
                                };
                                f.enableWaiting = function(a) {
                                    void 0 === a && (a = !1);
                                    if (this.__isWaiting !== a) {
                                        this.__isWaiting = a;
                                        for(var b = p.makeIterator(this.__allLayers.values()), c = b.next(); !c.done; c = b.next())c = c.value, a ? c.disableClick() : c.enableClick(), c.div.classList.toggle("waiting", a);
                                    }
                                };
                                f.__enableAll = function() {
                                    var a = Ta(function c() {
                                        var d = this, e, h, k, l, m, n, q;
                                        return p.generator.createGenerator(c, function(r) {
                                            if (1 == r.nextAddress) {
                                                if (d.__isEnabled) return r.jumpTo(0);
                                                d.__isEnabled = !0;
                                                e = [];
                                                h = p.makeIterator(d.__allLayers.values());
                                                for(k = h.next(); !k.done; k = h.next())l = k.value, e.push(l.enable());
                                                return r.yield(Promise.all(e), 3);
                                            }
                                            m = p.makeIterator(d.__allEditors.values());
                                            for(n = m.next(); !n.done; n = m.next())q = n.value, q.enable();
                                            r.jumpToEnd();
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.__disableAll = function() {
                                    this.unselectAll();
                                    if (this.__isEnabled) {
                                        this.__isEnabled = !1;
                                        for(var a = p.makeIterator(this.__allLayers.values()), b = a.next(); !b.done; b = a.next())b.value.disable();
                                        a = p.makeIterator(this.__allEditors.values());
                                        for(b = a.next(); !b.done; b = a.next())b.value.disable();
                                    }
                                };
                                f.getEditors = function(a) {
                                    for(var b = [], c = p.makeIterator(this.__allEditors.values()), d = c.next(); !d.done; d = c.next())d = d.value, d.pageIndex === a && b.push(d);
                                    return b;
                                };
                                f.getEditor = function(a) {
                                    return this.__allEditors.get(a);
                                };
                                f.addEditor = function(a) {
                                    this.__allEditors.set(a.id, a);
                                };
                                f.removeEditor = function(a) {
                                    var b = this;
                                    a.div.contains(document.activeElement) && (this.__focusMainContainerTimeoutId && clearTimeout(this.__focusMainContainerTimeoutId), this.__focusMainContainerTimeoutId = setTimeout(function() {
                                        b.focusMainContainer();
                                        b.__focusMainContainerTimeoutId = null;
                                    }, 0));
                                    this.__allEditors.delete(a.id);
                                    this.unselect(a);
                                    if (!a.annotationElementId || !this.__deletedAnnotationsElementIds.has(a.annotationElementId)) {
                                        var c;
                                        null == (c = this.__annotationStorage) || c.remove(a.id);
                                    }
                                };
                                f.addDeletedAnnotationElement = function(a) {
                                    this.__deletedAnnotationsElementIds.add(a.annotationElementId);
                                    this.addChangedExistingAnnotation(a);
                                    a.deleted = !0;
                                };
                                f.isDeletedAnnotationElement = function(a) {
                                    return this.__deletedAnnotationsElementIds.has(a);
                                };
                                f.removeDeletedAnnotationElement = function(a) {
                                    this.__deletedAnnotationsElementIds.delete(a.annotationElementId);
                                    this.removeChangedExistingAnnotation(a);
                                    a.deleted = !1;
                                };
                                f.__addEditorToLayer = function(a) {
                                    var b = this.__allLayers.get(a.pageIndex);
                                    b ? b.addOrRebuild(a) : (this.addEditor(a), this.addToAnnotationStorage(a));
                                };
                                f.setActiveEditor = function(a) {
                                    this.__activeEditor !== a && (this.__activeEditor = a) && this.__dispatchUpdateUI(a.propertiesToUpdate);
                                };
                                f.updateUI = function(a) {
                                    this.__lastSelectedEditor === a && this.__dispatchUpdateUI(a.propertiesToUpdate);
                                };
                                f.toggleSelected = function(a) {
                                    this.__selectedEditors.has(a) ? (this.__selectedEditors.delete(a), a.unselect(), this.__dispatchUpdateStates({
                                        hasSelectedEditor: this.hasSelection
                                    })) : (this.__selectedEditors.add(a), a.select(), this.__dispatchUpdateUI(a.propertiesToUpdate), this.__dispatchUpdateStates({
                                        hasSelectedEditor: !0
                                    }));
                                };
                                f.setSelected = function(a) {
                                    for(var b = p.makeIterator(this.__selectedEditors), c = b.next(); !c.done; c = b.next())c = c.value, c !== a && c.unselect();
                                    this.__selectedEditors.clear();
                                    this.__selectedEditors.add(a);
                                    a.select();
                                    this.__dispatchUpdateUI(a.propertiesToUpdate);
                                    this.__dispatchUpdateStates({
                                        hasSelectedEditor: !0
                                    });
                                };
                                f.isSelected = function(a) {
                                    return this.__selectedEditors.has(a);
                                };
                                f.unselect = function(a) {
                                    a.unselect();
                                    this.__selectedEditors.delete(a);
                                    this.__dispatchUpdateStates({
                                        hasSelectedEditor: this.hasSelection
                                    });
                                };
                                f.undo = function() {
                                    this.__commandManager.undo();
                                    this.__dispatchUpdateStates({
                                        hasSomethingToUndo: this.__commandManager.hasSomethingToUndo(),
                                        hasSomethingToRedo: !0,
                                        isEmpty: this.__isEmpty()
                                    });
                                };
                                f.redo = function() {
                                    this.__commandManager.redo();
                                    this.__dispatchUpdateStates({
                                        hasSomethingToUndo: !0,
                                        hasSomethingToRedo: this.__commandManager.hasSomethingToRedo(),
                                        isEmpty: this.__isEmpty()
                                    });
                                };
                                f.addCommands = function(a) {
                                    this.__commandManager.add(a);
                                    this.__dispatchUpdateStates({
                                        hasSomethingToUndo: !0,
                                        hasSomethingToRedo: !1,
                                        isEmpty: this.__isEmpty()
                                    });
                                };
                                f.__isEmpty = function() {
                                    if (0 === this.__allEditors.size) return !0;
                                    if (1 === this.__allEditors.size) for(var a = p.makeIterator(this.__allEditors.values()).next(); !a.done;)return a.value.isEmpty();
                                    return !1;
                                };
                                f.delete = function() {
                                    var a = this;
                                    this.commitOrRemove();
                                    if (this.hasSelection) {
                                        var b = [].concat(p.arrayFromIterable(this.__selectedEditors));
                                        this.addCommands({
                                            cmd: function() {
                                                for(var c = p.makeIterator(b), d = c.next(); !d.done; d = c.next())d.value.remove();
                                            },
                                            undo: function() {
                                                for(var c = p.makeIterator(b), d = c.next(); !d.done; d = c.next())a.__addEditorToLayer(d.value);
                                            },
                                            mustExec: !0
                                        });
                                    }
                                };
                                f.commitOrRemove = function() {
                                    var a;
                                    null == (a = this.__activeEditor) || a.commitOrRemove();
                                };
                                f.hasSomethingToControl = function() {
                                    return this.__activeEditor || this.hasSelection;
                                };
                                f.__selectEditors = function(a) {
                                    for(var b = p.makeIterator(this.__selectedEditors), c = b.next(); !c.done; c = b.next())c.value.unselect();
                                    this.__selectedEditors.clear();
                                    a = p.makeIterator(a);
                                    for(b = a.next(); !b.done; b = a.next())b = b.value, b.isEmpty() || (this.__selectedEditors.add(b), b.select());
                                    this.__dispatchUpdateStates({
                                        hasSelectedEditor: this.hasSelection
                                    });
                                };
                                f.selectAll = function() {
                                    for(var a = p.makeIterator(this.__selectedEditors), b = a.next(); !b.done; b = a.next())b.value.commit();
                                    this.__selectEditors(this.__allEditors.values());
                                };
                                f.unselectAll = function() {
                                    if (this.__activeEditor && (this.__activeEditor.commitOrRemove(), this.__mode !== sa.NONE)) return;
                                    if (this.hasSelection) {
                                        for(var a = p.makeIterator(this.__selectedEditors), b = a.next(); !b.done; b = a.next())b.value.unselect();
                                        this.__selectedEditors.clear();
                                        this.__dispatchUpdateStates({
                                            hasSelectedEditor: !1
                                        });
                                    }
                                };
                                f.translateSelectedEditors = function(a, b, c) {
                                    var d = this;
                                    void 0 === c && (c = !1);
                                    c || this.commitOrRemove();
                                    if (this.hasSelection) {
                                        this.__translation[0] += a;
                                        this.__translation[1] += b;
                                        c = p.makeIterator(this.__translation);
                                        var e = c.next().value, h = c.next().value, k = [].concat(p.arrayFromIterable(this.__selectedEditors));
                                        this.__translationTimeoutId && clearTimeout(this.__translationTimeoutId);
                                        this.__translationTimeoutId = setTimeout(function() {
                                            d.__translationTimeoutId = null;
                                            d.__translation[0] = d.__translation[1] = 0;
                                            d.addCommands({
                                                cmd: function() {
                                                    for(var m = p.makeIterator(k), n = m.next(); !n.done; n = m.next())n = n.value, d.__allEditors.has(n.id) && n.translateInPage(e, h);
                                                },
                                                undo: function() {
                                                    for(var m = p.makeIterator(k), n = m.next(); !n.done; n = m.next())n = n.value, d.__allEditors.has(n.id) && n.translateInPage(-e, -h);
                                                },
                                                mustExec: !1
                                            });
                                        }, 1E3);
                                        c = p.makeIterator(k);
                                        for(var l = c.next(); !l.done; l = c.next())l.value.translateInPage(a, b);
                                    }
                                };
                                f.setUpDragSession = function() {
                                    if (this.hasSelection) {
                                        this.disableUserSelect(!0);
                                        this.__draggingEditors = new Map;
                                        for(var a = p.makeIterator(this.__selectedEditors), b = a.next(); !b.done; b = a.next())b = b.value, this.__draggingEditors.set(b, {
                                            savedX: b.x,
                                            savedY: b.y,
                                            savedPageIndex: b.pageIndex,
                                            newX: 0,
                                            newY: 0,
                                            newPageIndex: -1
                                        });
                                    }
                                };
                                f.endDragSession = function() {
                                    function a(n, q, r, t) {
                                        if (b.__allEditors.has(n.id)) {
                                            var u = b.__allLayers.get(t);
                                            u ? n._setParentAndPosition(u, q, r) : (n.pageIndex = t, n.x = q, n.y = r);
                                        }
                                    }
                                    var b = this;
                                    if (!this.__draggingEditors) return !1;
                                    this.disableUserSelect(!1);
                                    var c = this.__draggingEditors;
                                    this.__draggingEditors = null;
                                    for(var d = !1, e = p.makeIterator(c), h = e.next(); !h.done; h = e.next()){
                                        var k = p.makeIterator(h.value), l = k.next().value;
                                        h = l.x;
                                        var m = l.y;
                                        l = l.pageIndex;
                                        k = k.next().value;
                                        k.newX = h;
                                        k.newY = m;
                                        k.newPageIndex = l;
                                        d || (d = h !== k.savedX || m !== k.savedY || l !== k.savedPageIndex);
                                    }
                                    if (!d) return !1;
                                    this.addCommands({
                                        cmd: function() {
                                            for(var n = p.makeIterator(c), q = n.next(); !q.done; q = n.next()){
                                                var r = p.makeIterator(q.value);
                                                q = r.next().value;
                                                r = r.next().value;
                                                a(q, r.newX, r.newY, r.newPageIndex);
                                            }
                                        },
                                        undo: function() {
                                            for(var n = p.makeIterator(c), q = n.next(); !q.done; q = n.next()){
                                                var r = p.makeIterator(q.value);
                                                q = r.next().value;
                                                r = r.next().value;
                                                a(q, r.savedX, r.savedY, r.savedPageIndex);
                                            }
                                        },
                                        mustExec: !0
                                    });
                                    return !0;
                                };
                                f.dragSelectedEditors = function(a, b) {
                                    if (this.__draggingEditors) for(var c = p.makeIterator(this.__draggingEditors.keys()), d = c.next(); !d.done; d = c.next())d.value.drag(a, b);
                                };
                                f.rebuild = function(a) {
                                    if (null === a.parent) {
                                        var b = this.getLayer(a.pageIndex);
                                        b ? (b.changeParent(a), b.addOrRebuild(a)) : (this.addEditor(a), this.addToAnnotationStorage(a), a.rebuild());
                                    } else a.parent.addOrRebuild(a);
                                };
                                f.isActive = function(a) {
                                    return this.__activeEditor === a;
                                };
                                f.getActive = function() {
                                    return this.__activeEditor;
                                };
                                f.getMode = function() {
                                    return this.__mode;
                                };
                                f.getSelectionBoxes = function(a) {
                                    if (!a) return null;
                                    for(var b = document.getSelection(), c = 0, d = b.rangeCount; c < d; c++)if (!a.contains(b.getRangeAt(c).commonAncestorContainer)) return null;
                                    c = a.getBoundingClientRect();
                                    var e = c.x, h = c.y, k = c.width, l = c.height;
                                    switch(a.getAttribute("data-main-rotation")){
                                        case "90":
                                            a = function(u, v, w, x) {
                                                return {
                                                    x: (v - h) / l,
                                                    y: 1 - (u + w - e) / k,
                                                    width: x / l,
                                                    height: w / k
                                                };
                                            };
                                            break;
                                        case "180":
                                            a = function(u, v, w, x) {
                                                return {
                                                    x: 1 - (u + w - e) / k,
                                                    y: 1 - (v + x - h) / l,
                                                    width: w / k,
                                                    height: x / l
                                                };
                                            };
                                            break;
                                        case "270":
                                            a = function(u, v, w, x) {
                                                return {
                                                    x: 1 - (v + x - h) / l,
                                                    y: (u - e) / k,
                                                    width: x / l,
                                                    height: w / k
                                                };
                                            };
                                            break;
                                        default:
                                            a = function(u, v, w, x) {
                                                return {
                                                    x: (u - e) / k,
                                                    y: (v - h) / l,
                                                    width: w / k,
                                                    height: x / l
                                                };
                                            };
                                    }
                                    c = [];
                                    d = 0;
                                    for(var m = b.rangeCount; d < m; d++){
                                        var n = b.getRangeAt(d);
                                        if (!n.collapsed) {
                                            n = p.makeIterator(n.getClientRects());
                                            for(var q = n.next(); !q.done; q = n.next()){
                                                q = q.value;
                                                var r = q.width, t = q.height;
                                                0 !== r && 0 !== t && c.push(a(q.x, q.y, r, t));
                                            }
                                        }
                                    }
                                    return 0 === c.length ? null : c;
                                };
                                f.addChangedExistingAnnotation = function(a) {
                                    var b = a.annotationElementId;
                                    a = a.id;
                                    (this.__changedExistingAnnotations || (this.__changedExistingAnnotations = new Map)).set(b, a);
                                };
                                f.removeChangedExistingAnnotation = function(a) {
                                    var b;
                                    a = a.annotationElementId;
                                    null == (b = this.__changedExistingAnnotations) || b.delete(a);
                                };
                                f.renderAnnotationElement = function(a) {
                                    var b, c = null == (b = this.__changedExistingAnnotations) ? void 0 : b.get(a.data.id);
                                    c && (b = this.__annotationStorage.getRawValue(c)) && (this.__mode !== sa.NONE || b.hasBeenModified) && b.renderAnnotationElement(a);
                                };
                                return Ab(g, [
                                    {
                                        key: "mlManager",
                                        get: function() {
                                            return this.__mlManager;
                                        }
                                    },
                                    {
                                        key: "useNewAltTextFlow",
                                        get: function() {
                                            return this.__enableUpdatedAddImage;
                                        }
                                    },
                                    {
                                        key: "useNewAltTextWhenAddingImage",
                                        get: function() {
                                            return this.__enableNewAltTextWhenAddingImage;
                                        }
                                    },
                                    {
                                        key: "hcmFilter",
                                        get: function() {
                                            return qa(this, "hcmFilter", this.__pageColors ? this.__filterFactory.addHCMFilter(this.__pageColors.foreground, this.__pageColors.background) : "none");
                                        }
                                    },
                                    {
                                        key: "direction",
                                        get: function() {
                                            return qa(this, "direction", getComputedStyle(this.__container).direction);
                                        }
                                    },
                                    {
                                        key: "highlightColors",
                                        get: function() {
                                            return qa(this, "highlightColors", this.__highlightColors ? new Map(this.__highlightColors.split(",").map(function(a) {
                                                return a.split("=").map(function(b) {
                                                    return b.trim();
                                                });
                                            })) : null);
                                        }
                                    },
                                    {
                                        key: "highlightColorNames",
                                        get: function() {
                                            return qa(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, function(a) {
                                                return a.reverse();
                                            })) : null);
                                        }
                                    },
                                    {
                                        key: "currentLayer",
                                        get: function() {
                                            return this.__allLayers.get(this.__currentPageIndex);
                                        }
                                    },
                                    {
                                        key: "currentPageIndex",
                                        get: function() {
                                            return this.__currentPageIndex;
                                        }
                                    },
                                    {
                                        key: "__lastSelectedEditor",
                                        get: function() {
                                            for(var a = null, b = p.makeIterator(this.__selectedEditors), c = b.next(); !c.done; c = b.next())a = c.value;
                                            return a;
                                        }
                                    },
                                    {
                                        key: "firstSelectedEditor",
                                        get: function() {
                                            return this.__selectedEditors.values().next().value;
                                        }
                                    },
                                    {
                                        key: "hasSelection",
                                        get: function() {
                                            return 0 !== this.__selectedEditors.size;
                                        }
                                    },
                                    {
                                        key: "isEnterHandled",
                                        get: function() {
                                            return 1 === this.__selectedEditors.size && this.firstSelectedEditor.isEnterHandled;
                                        }
                                    },
                                    {
                                        key: "isEditorHandlingKeyboard",
                                        get: function() {
                                            var a;
                                            return (null == (a = this.getActive()) ? void 0 : a.shouldGetKeyboardEvents()) || 1 === this.__selectedEditors.size && this.firstSelectedEditor.shouldGetKeyboardEvents();
                                        }
                                    },
                                    {
                                        key: "imageManager",
                                        get: function() {
                                            return qa(this, "imageManager", new qg);
                                        }
                                    }
                                ], [
                                    {
                                        key: "_keyboardManager",
                                        get: function() {
                                            function a(h, k) {
                                                h = k.target;
                                                return h instanceof HTMLInputElement ? (h = h.type, "text" !== h && "number" !== h) : !0;
                                            }
                                            function b(h) {
                                                return h.__container.contains(document.activeElement) && "BUTTON" !== document.activeElement.tagName && h.hasSomethingToControl();
                                            }
                                            var c = g.prototype, d = this.TRANSLATE_SMALL, e = this.TRANSLATE_BIG;
                                            return qa(this, "_keyboardManager", new ub([
                                                [
                                                    [
                                                        "ctrl+a",
                                                        "mac+meta+a"
                                                    ],
                                                    c.selectAll,
                                                    {
                                                        checker: a
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+z",
                                                        "mac+meta+z"
                                                    ],
                                                    c.undo,
                                                    {
                                                        checker: a
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+y",
                                                        "ctrl+shift+z",
                                                        "mac+meta+shift+z",
                                                        "ctrl+shift+Z",
                                                        "mac+meta+shift+Z"
                                                    ],
                                                    c.redo,
                                                    {
                                                        checker: a
                                                    }
                                                ],
                                                [
                                                    "Backspace alt+Backspace ctrl+Backspace shift+Backspace mac+Backspace mac+alt+Backspace mac+ctrl+Backspace Delete ctrl+Delete shift+Delete mac+Delete".split(" "),
                                                    c.delete,
                                                    {
                                                        checker: a
                                                    }
                                                ],
                                                [
                                                    [
                                                        "Enter",
                                                        "mac+Enter"
                                                    ],
                                                    c.addNewEditorFromKeyboard,
                                                    {
                                                        checker: function(h, k) {
                                                            k = k.target;
                                                            return !(k instanceof HTMLButtonElement) && h.__container.contains(k) && !h.isEnterHandled;
                                                        }
                                                    }
                                                ],
                                                [
                                                    [
                                                        " ",
                                                        "mac+ "
                                                    ],
                                                    c.addNewEditorFromKeyboard,
                                                    {
                                                        checker: function(h, k) {
                                                            return !(k.target instanceof HTMLButtonElement) && h.__container.contains(document.activeElement);
                                                        }
                                                    }
                                                ],
                                                [
                                                    [
                                                        "Escape",
                                                        "mac+Escape"
                                                    ],
                                                    c.unselectAll
                                                ],
                                                [
                                                    [
                                                        "ArrowLeft",
                                                        "mac+ArrowLeft"
                                                    ],
                                                    c.translateSelectedEditors,
                                                    {
                                                        args: [
                                                            -d,
                                                            0
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowLeft",
                                                        "mac+shift+ArrowLeft"
                                                    ],
                                                    c.translateSelectedEditors,
                                                    {
                                                        args: [
                                                            -e,
                                                            0
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowRight",
                                                        "mac+ArrowRight"
                                                    ],
                                                    c.translateSelectedEditors,
                                                    {
                                                        args: [
                                                            d,
                                                            0
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowRight",
                                                        "mac+shift+ArrowRight"
                                                    ],
                                                    c.translateSelectedEditors,
                                                    {
                                                        args: [
                                                            e,
                                                            0
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowUp",
                                                        "mac+ArrowUp"
                                                    ],
                                                    c.translateSelectedEditors,
                                                    {
                                                        args: [
                                                            0,
                                                            -d
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowUp",
                                                        "mac+shift+ArrowUp"
                                                    ],
                                                    c.translateSelectedEditors,
                                                    {
                                                        args: [
                                                            0,
                                                            -e
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowDown",
                                                        "mac+ArrowDown"
                                                    ],
                                                    c.translateSelectedEditors,
                                                    {
                                                        args: [
                                                            0,
                                                            d
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowDown",
                                                        "mac+shift+ArrowDown"
                                                    ],
                                                    c.translateSelectedEditors,
                                                    {
                                                        args: [
                                                            0,
                                                            e
                                                        ],
                                                        checker: b
                                                    }
                                                ]
                                            ]));
                                        }
                                    }
                                ]);
                            }();
                            gb.TRANSLATE_SMALL = 1;
                            gb.TRANSLATE_BIG = 10;
                            var Mb = function() {
                                function g(a) {
                                    this.__altText = null;
                                    this.__altTextDecorative = !1;
                                    this.__altTextTooltipTimeout = this.__altTextTooltip = this.__altTextButtonLabel = this.__altTextButton = null;
                                    this.__altTextWasFromKeyBoard = !1;
                                    this.__textWithDisclaimer = this.__guessedText = this.__badge = null;
                                    this.__editor = a;
                                    this.__useNewAltTextFlow = a._uiManager.useNewAltTextFlow;
                                    g.__l10nNewButton || (g.__l10nNewButton = Object.freeze({
                                        added: "pdfjs-editor-new-alt-text-added-button",
                                        "added-label": "pdfjs-editor-new-alt-text-added-button-label",
                                        missing: "pdfjs-editor-new-alt-text-missing-button",
                                        "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
                                        review: "pdfjs-editor-new-alt-text-to-review-button",
                                        "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
                                    }));
                                }
                                g.initialize = function(a) {
                                    var b;
                                    null != (b = g._l10n) ? b : g._l10n = a;
                                };
                                var f = g.prototype;
                                f.render = function() {
                                    var a = Yb(function c() {
                                        var d = this, e, h, k, l, m;
                                        return p.generator.createGenerator(c, function(n) {
                                            return 1 == n.nextAddress ? (e = d, h = d.__altTextButton = document.createElement("button"), h.className = "altText", h.tabIndex = "0", k = d.__altTextButtonLabel = document.createElement("span"), h.append(k), d.__useNewAltTextFlow ? (h.classList.add("new"), h.setAttribute("data-l10n-id", g.__l10nNewButton.missing), k.setAttribute("data-l10n-id", g.__l10nNewButton["missing-label"])) : (h.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button"), k.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label")), l = d.__editor._uiManager._signal, h.addEventListener("contextmenu", Ma, {
                                                signal: l
                                            }), h.addEventListener("pointerdown", function(q) {
                                                return q.stopPropagation();
                                            }, {
                                                signal: l
                                            }), m = function(q) {
                                                q.preventDefault();
                                                e.__editor._uiManager.editAltText(e.__editor);
                                                e.__useNewAltTextFlow && e.__editor._reportTelemetry({
                                                    action: "pdfjs.image.alt_text.image_status_label_clicked",
                                                    data: {
                                                        label: e.__label
                                                    }
                                                });
                                            }, h.addEventListener("click", m, {
                                                capture: !0,
                                                signal: l
                                            }), h.addEventListener("keydown", function(q) {
                                                q.target === h && "Enter" === q.key && (e.__altTextWasFromKeyBoard = !0, m(q));
                                            }, {
                                                signal: l
                                            }), n.yield(d.__setState(), 2)) : n.return(h);
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.finish = function() {
                                    this.__altTextButton && (this.__altTextButton.focus({
                                        focusVisible: this.__altTextWasFromKeyBoard
                                    }), this.__altTextWasFromKeyBoard = !1);
                                };
                                f.isEmpty = function() {
                                    return this.__useNewAltTextFlow ? null === this.__altText : !this.__altText && !this.__altTextDecorative;
                                };
                                f.hasData = function() {
                                    return this.__useNewAltTextFlow ? null !== this.__altText || !!this.__guessedText : this.isEmpty();
                                };
                                f.setGuessedText = function() {
                                    var a = Yb(function d(c) {
                                        var e = this;
                                        return p.generator.createGenerator(d, function(h) {
                                            if (1 == h.nextAddress) {
                                                if (null !== e.__altText) return h.return();
                                                e.__guessedText = c;
                                                return h.yield(g._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
                                                    generatedAltText: c
                                                }), 2);
                                            }
                                            e.__textWithDisclaimer = h.yieldResult;
                                            e.__setState();
                                            h.jumpToEnd();
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.toggleAltTextBadge = function(a) {
                                    void 0 === a && (a = !1);
                                    if (!this.__useNewAltTextFlow || this.__altText) {
                                        var b;
                                        null == (b = this.__badge) || b.remove();
                                        this.__badge = null;
                                    } else this.__badge || (b = this.__badge = document.createElement("div"), b.className = "noAltTextBadge", this.__editor.div.append(b)), this.__badge.classList.toggle("hidden", !a);
                                };
                                f.serialize = function(a) {
                                    var b = this.__altText;
                                    a || this.__guessedText !== b || (b = this.__textWithDisclaimer);
                                    return {
                                        altText: b,
                                        decorative: this.__altTextDecorative,
                                        guessedText: this.__guessedText,
                                        textWithDisclaimer: this.__textWithDisclaimer
                                    };
                                };
                                f.toggle = function(a) {
                                    void 0 === a && (a = !1);
                                    this.__altTextButton && (!a && this.__altTextTooltipTimeout && (clearTimeout(this.__altTextTooltipTimeout), this.__altTextTooltipTimeout = null), this.__altTextButton.disabled = !a);
                                };
                                f.shown = function() {
                                    this.__editor._reportTelemetry({
                                        action: "pdfjs.image.alt_text.image_status_label_displayed",
                                        data: {
                                            label: this.__label
                                        }
                                    });
                                };
                                f.destroy = function() {
                                    var a, b;
                                    null == (a = this.__altTextButton) || a.remove();
                                    this.__altTextTooltip = this.__altTextButtonLabel = this.__altTextButton = null;
                                    null == (b = this.__badge) || b.remove();
                                    this.__badge = null;
                                };
                                f.__setState = function() {
                                    var a = Yb(function c() {
                                        var d = this, e, h, k, l, m, n, q, r;
                                        return p.generator.createGenerator(c, function(t) {
                                            e = d;
                                            h = d.__altTextButton;
                                            if (!h) return t.return();
                                            if (d.__useNewAltTextFlow) {
                                                if (h.classList.toggle("done", !!d.__altText), h.setAttribute("data-l10n-id", g.__l10nNewButton[d.__label]), null == (k = d.__altTextButtonLabel) || k.setAttribute("data-l10n-id", g.__l10nNewButton[d.__label + "-label"]), !d.__altText) return null == (l = d.__altTextTooltip) || l.remove(), t.return();
                                            } else {
                                                if (!d.__altText && !d.__altTextDecorative) return h.classList.remove("done"), null == (m = d.__altTextTooltip) || m.remove(), t.return();
                                                h.classList.add("done");
                                                h.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
                                            }
                                            n = d.__altTextTooltip;
                                            n || (d.__altTextTooltip = n = document.createElement("span"), n.className = "tooltip", n.setAttribute("role", "tooltip"), n.id = "alt-text-tooltip-" + d.__editor.id, q = d.__editor._uiManager._signal, q.addEventListener("abort", function() {
                                                clearTimeout(e.__altTextTooltipTimeout);
                                                e.__altTextTooltipTimeout = null;
                                            }, {
                                                once: !0
                                            }), h.addEventListener("mouseenter", function() {
                                                e.__altTextTooltipTimeout = setTimeout(function() {
                                                    e.__altTextTooltipTimeout = null;
                                                    e.__altTextTooltip.classList.add("show");
                                                    e.__editor._reportTelemetry({
                                                        action: "alt_text_tooltip"
                                                    });
                                                }, 100);
                                            }, {
                                                signal: q
                                            }), h.addEventListener("mouseleave", function() {
                                                var u;
                                                e.__altTextTooltipTimeout && (clearTimeout(e.__altTextTooltipTimeout), e.__altTextTooltipTimeout = null);
                                                null == (u = e.__altTextTooltip) || u.classList.remove("show");
                                            }, {
                                                signal: q
                                            }));
                                            d.__altTextDecorative ? n.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip") : (n.removeAttribute("data-l10n-id"), n.textContent = d.__altText);
                                            n.parentNode || h.append(n);
                                            r = d.__editor.getImageForAltText();
                                            null == r || r.setAttribute("aria-describedby", n.id);
                                            t.jumpToEnd();
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                return of(g, [
                                    {
                                        key: "__label",
                                        get: function() {
                                            return this.__altText && "added" || null === this.__altText && this.guessedText && "review" || "missing";
                                        }
                                    },
                                    {
                                        key: "guessedText",
                                        get: function() {
                                            return this.__guessedText;
                                        }
                                    },
                                    {
                                        key: "data",
                                        get: function() {
                                            return {
                                                altText: this.__altText,
                                                decorative: this.__altTextDecorative
                                            };
                                        },
                                        set: function(a) {
                                            var b = a.altText, c = a.decorative, d = a.guessedText, e = a.textWithDisclaimer;
                                            a = void 0 === a.cancel ? !1 : a.cancel;
                                            d && (this.__guessedText = d, this.__textWithDisclaimer = e);
                                            if (this.__altText !== b || this.__altTextDecorative !== c) a || (this.__altText = b, this.__altTextDecorative = c), this.__setState();
                                        }
                                    }
                                ]);
                            }();
                            Mb.__l10nNewButton = null;
                            Mb._l10n = null;
                            var wa = function() {
                                function g(a) {
                                    this.__altText = this.__allResizerDivs = this.__accessibilityData = null;
                                    this.__keepAspectRatio = this.__disabled = !1;
                                    this.__focusAC = this.__savedDimensions = this.__resizersDiv = null;
                                    this.__focusedResizerName = "";
                                    this.__hasBeenClicked = !1;
                                    this.__initialPosition = null;
                                    this.__isResizerEnabledForKeyboard = this.__isInEditMode = this.__isEditing = !1;
                                    this.__moveInDOMTimeout = null;
                                    this.__prevDragY = this.__prevDragX = 0;
                                    this._editToolbar = this.__telemetryTimeouts = null;
                                    this._initialOptions = Object.create(null);
                                    this._initialData = null;
                                    this._isVisible = !0;
                                    this._uiManager = null;
                                    this._focusEventsAllowed = !0;
                                    this.__isDraggable = !1;
                                    this.__zIndex = g._zIndex++;
                                    this.parent = a.parent;
                                    this.id = a.id;
                                    this.width = this.height = null;
                                    this.pageIndex = a.parent.pageIndex;
                                    this.name = a.name;
                                    this.div = null;
                                    this._uiManager = a.uiManager;
                                    this.annotationElementId = null;
                                    this._willKeepAspectRatio = !1;
                                    this._initialOptions.isCentered = a.isCentered;
                                    this._structTreeParentId = null;
                                    var b = this.parent.viewport, c = b.rotation, d = b.rawDims;
                                    b = d.pageWidth;
                                    var e = d.pageHeight, h = d.pageX;
                                    d = d.pageY;
                                    this.rotation = c;
                                    this.pageRotation = (360 + c - this._uiManager.viewParameters.rotation) % 360;
                                    this.pageDimensions = [
                                        b,
                                        e
                                    ];
                                    this.pageTranslation = [
                                        h,
                                        d
                                    ];
                                    b = p.makeIterator(this.parentDimensions);
                                    c = b.next().value;
                                    b = b.next().value;
                                    this.x = a.x / c;
                                    this.y = a.y / b;
                                    this.deleted = this.isAttachedToDOM = !1;
                                }
                                g.deleteAnnotationElement = function(a) {
                                    var b = new sg({
                                        id: a.parent.getNextId(),
                                        parent: a.parent,
                                        uiManager: a._uiManager
                                    });
                                    b.annotationElementId = a.annotationElementId;
                                    b.deleted = !0;
                                    b._uiManager.addToAnnotationStorage(b);
                                };
                                g.initialize = function(a) {
                                    var b;
                                    null != (b = g._l10n) ? b : g._l10n = a;
                                    g._l10nResizer || (g._l10nResizer = Object.freeze({
                                        topLeft: "pdfjs-editor-resizer-top-left",
                                        topMiddle: "pdfjs-editor-resizer-top-middle",
                                        topRight: "pdfjs-editor-resizer-top-right",
                                        middleRight: "pdfjs-editor-resizer-middle-right",
                                        bottomRight: "pdfjs-editor-resizer-bottom-right",
                                        bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
                                        bottomLeft: "pdfjs-editor-resizer-bottom-left",
                                        middleLeft: "pdfjs-editor-resizer-middle-left"
                                    }));
                                    -1 === g._borderLineWidth && (a = getComputedStyle(document.documentElement), g._borderLineWidth = parseFloat(a.getPropertyValue("--outline-width")) || 0);
                                };
                                g.updateDefaultParams = function() {};
                                g.isHandlingMimeForPasting = function() {
                                    return !1;
                                };
                                g.paste = function() {
                                    da("Not implemented");
                                };
                                var f = g.prototype;
                                f.center = function() {
                                    var a = p.makeIterator(this.pageDimensions), b = a.next().value;
                                    a = a.next().value;
                                    switch(this.parentRotation){
                                        case 90:
                                            this.x -= this.height * a / (2 * b);
                                            this.y += this.width * b / (2 * a);
                                            break;
                                        case 180:
                                            this.x += this.width / 2;
                                            this.y += this.height / 2;
                                            break;
                                        case 270:
                                            this.x += this.height * a / (2 * b);
                                            this.y -= this.width * b / (2 * a);
                                            break;
                                        default:
                                            this.x -= this.width / 2, this.y -= this.height / 2;
                                    }
                                    this.fixAndSetPosition();
                                };
                                f.addCommands = function(a) {
                                    this._uiManager.addCommands(a);
                                };
                                f.setInBackground = function() {
                                    this.div.style.zIndex = 0;
                                };
                                f.setInForeground = function() {
                                    this.div.style.zIndex = this.__zIndex;
                                };
                                f.setParent = function(a) {
                                    null !== a ? (this.pageIndex = a.pageIndex, this.pageDimensions = a.pageDimensions) : this.__stopResizing();
                                    this.parent = a;
                                };
                                f.focusin = function() {
                                    this._focusEventsAllowed && (this.__hasBeenClicked ? this.__hasBeenClicked = !1 : this.parent.setSelected(this));
                                };
                                f.focusout = function(a) {
                                    var b;
                                    if (this._focusEventsAllowed && this.isAttachedToDOM) {
                                        var c = a.relatedTarget;
                                        null != c && c.closest("#" + this.id) || (a.preventDefault(), null != (b = this.parent) && b.isMultipleSelection || this.commitOrRemove());
                                    }
                                };
                                f.commitOrRemove = function() {
                                    this.isEmpty() ? this.remove() : this.commit();
                                };
                                f.commit = function() {
                                    this.addToAnnotationStorage();
                                };
                                f.addToAnnotationStorage = function() {
                                    this._uiManager.addToAnnotationStorage(this);
                                };
                                f.setAt = function(a, b, c, d) {
                                    var e = p.makeIterator(this.parentDimensions), h = e.next().value;
                                    e = e.next().value;
                                    d = p.makeIterator(this.screenToPageTranslation(c, d));
                                    c = d.next().value;
                                    d = d.next().value;
                                    this.x = (a + c) / h;
                                    this.y = (b + d) / e;
                                    this.fixAndSetPosition();
                                };
                                f.__translate = function(a, b, c) {
                                    var d = p.makeIterator(a);
                                    a = d.next().value;
                                    d = d.next().value;
                                    c = p.makeIterator(this.screenToPageTranslation(b, c));
                                    b = c.next().value;
                                    c = c.next().value;
                                    this.x += b / a;
                                    this.y += c / d;
                                    this.fixAndSetPosition();
                                };
                                f.translate = function(a, b) {
                                    this.__translate(this.parentDimensions, a, b);
                                };
                                f.translateInPage = function(a, b) {
                                    this.__initialPosition || (this.__initialPosition = [
                                        this.x,
                                        this.y
                                    ]);
                                    this.__translate(this.pageDimensions, a, b);
                                    this.div.scrollIntoView({
                                        block: "nearest"
                                    });
                                };
                                f.drag = function(a, b) {
                                    this.__initialPosition || (this.__initialPosition = [
                                        this.x,
                                        this.y
                                    ]);
                                    var c = p.makeIterator(this.parentDimensions), d = c.next().value;
                                    c = c.next().value;
                                    this.x += a / d;
                                    this.y += b / c;
                                    this.parent && (0 > this.x || 1 < this.x || 0 > this.y || 1 < this.y) && (a = this.div.getBoundingClientRect(), this.parent.findNewParent(this, a.x, a.y) && (this.x -= Math.floor(this.x), this.y -= Math.floor(this.y)));
                                    a = this.x;
                                    b = this.y;
                                    c = p.makeIterator(this.getBaseTranslation());
                                    d = c.next().value;
                                    c = c.next().value;
                                    b += c;
                                    this.div.style.left = (100 * (a + d)).toFixed(2) + "%";
                                    this.div.style.top = (100 * b).toFixed(2) + "%";
                                    this.div.scrollIntoView({
                                        block: "nearest"
                                    });
                                };
                                f.getBaseTranslation = function() {
                                    var a = p.makeIterator(this.parentDimensions), b = a.next().value;
                                    a = a.next().value;
                                    var c = g._borderLineWidth;
                                    b = c / b;
                                    a = c / a;
                                    switch(this.rotation){
                                        case 90:
                                            return [
                                                -b,
                                                a
                                            ];
                                        case 180:
                                            return [
                                                b,
                                                a
                                            ];
                                        case 270:
                                            return [
                                                b,
                                                -a
                                            ];
                                        default:
                                            return [
                                                -b,
                                                -a
                                            ];
                                    }
                                };
                                f.fixAndSetPosition = function(a) {
                                    void 0 === a && (a = this.rotation);
                                    var b = p.makeIterator(this.pageDimensions), c = b.next().value, d = b.next().value;
                                    b = this.x;
                                    var e = this.y, h = this.width, k = this.height;
                                    h *= c;
                                    k *= d;
                                    b *= c;
                                    e *= d;
                                    if (this._mustFixPosition) switch(a){
                                        case 0:
                                            b = Math.max(0, Math.min(c - h, b));
                                            e = Math.max(0, Math.min(d - k, e));
                                            break;
                                        case 90:
                                            b = Math.max(0, Math.min(c - k, b));
                                            e = Math.min(d, Math.max(h, e));
                                            break;
                                        case 180:
                                            b = Math.min(c, Math.max(h, b));
                                            e = Math.min(d, Math.max(k, e));
                                            break;
                                        case 270:
                                            b = Math.min(c, Math.max(k, b)), e = Math.max(0, Math.min(d - h, e));
                                    }
                                    this.x = b /= c;
                                    this.y = e /= d;
                                    c = p.makeIterator(this.getBaseTranslation());
                                    a = c.next().value;
                                    c = c.next().value;
                                    e += c;
                                    c = this.div.style;
                                    c.left = (100 * (b + a)).toFixed(2) + "%";
                                    c.top = (100 * e).toFixed(2) + "%";
                                    this.moveInDOM();
                                };
                                g.__rotatePoint = function(a, b, c) {
                                    switch(c){
                                        case 90:
                                            return [
                                                b,
                                                -a
                                            ];
                                        case 180:
                                            return [
                                                -a,
                                                -b
                                            ];
                                        case 270:
                                            return [
                                                -b,
                                                a
                                            ];
                                        default:
                                            return [
                                                a,
                                                b
                                            ];
                                    }
                                };
                                f.screenToPageTranslation = function(a, b) {
                                    return g.__rotatePoint(a, b, this.parentRotation);
                                };
                                f.pageTranslationToScreen = function(a, b) {
                                    return g.__rotatePoint(a, b, 360 - this.parentRotation);
                                };
                                f.__getRotationMatrix = function(a) {
                                    switch(a){
                                        case 90:
                                            var b = p.makeIterator(this.pageDimensions);
                                            a = b.next().value;
                                            b = b.next().value;
                                            return [
                                                0,
                                                -a / b,
                                                b / a,
                                                0
                                            ];
                                        case 180:
                                            return [
                                                -1,
                                                0,
                                                0,
                                                -1
                                            ];
                                        case 270:
                                            return b = p.makeIterator(this.pageDimensions), a = b.next().value, b = b.next().value, [
                                                0,
                                                a / b,
                                                -b / a,
                                                0
                                            ];
                                        default:
                                            return [
                                                1,
                                                0,
                                                0,
                                                1
                                            ];
                                    }
                                };
                                f.setDims = function(a, b) {
                                    var c = p.makeIterator(this.parentDimensions), d = c.next().value;
                                    c = c.next().value;
                                    this.div.style.width = (100 * a / d).toFixed(2) + "%";
                                    this.__keepAspectRatio || (this.div.style.height = (100 * b / c).toFixed(2) + "%");
                                };
                                f.fixDims = function() {
                                    var a = this.div.style, b = a.height, c = a.width, d = c.endsWith("%"), e = !this.__keepAspectRatio && b.endsWith("%");
                                    if (!d || !e) {
                                        var h = p.makeIterator(this.parentDimensions), k = h.next().value;
                                        h = h.next().value;
                                        d || (a.width = (100 * parseFloat(c) / k).toFixed(2) + "%");
                                        this.__keepAspectRatio || e || (a.height = (100 * parseFloat(b) / h).toFixed(2) + "%");
                                    }
                                };
                                f.getInitialTranslation = function() {
                                    return [
                                        0,
                                        0
                                    ];
                                };
                                f.__createResizers = function() {
                                    if (!this.__resizersDiv) {
                                        this.__resizersDiv = document.createElement("div");
                                        this.__resizersDiv.classList.add("resizers");
                                        for(var a = this._uiManager._signal, b = p.makeIterator(this._willKeepAspectRatio ? [
                                            "topLeft",
                                            "topRight",
                                            "bottomRight",
                                            "bottomLeft"
                                        ] : "topLeft topMiddle topRight middleRight bottomRight bottomMiddle bottomLeft middleLeft".split(" ")), c = b.next(); !c.done; c = b.next()){
                                            c = c.value;
                                            var d = document.createElement("div");
                                            this.__resizersDiv.append(d);
                                            d.classList.add("resizer", c);
                                            d.setAttribute("data-resizer-name", c);
                                            d.addEventListener("pointerdown", this.__resizerPointerdown.bind(this, c), {
                                                signal: a
                                            });
                                            d.addEventListener("contextmenu", Ma, {
                                                signal: a
                                            });
                                            d.tabIndex = -1;
                                        }
                                        this.div.prepend(this.__resizersDiv);
                                    }
                                };
                                f.__resizerPointerdown = function(a, b) {
                                    var c = this, d;
                                    b.preventDefault();
                                    var e = Ka.platform.isMac;
                                    if (!(0 !== b.button || b.ctrlKey && e)) {
                                        null == (d = this.__altText) || d.toggle(!1);
                                        var h = this._isDraggable;
                                        this._isDraggable = !1;
                                        var k = new AbortController;
                                        d = this._uiManager.combinedSignal(k);
                                        this.parent.togglePointerEvents(!1);
                                        window.addEventListener("pointermove", this.__resizerPointermove.bind(this, a), {
                                            passive: !0,
                                            capture: !0,
                                            signal: d
                                        });
                                        window.addEventListener("contextmenu", Ma, {
                                            signal: d
                                        });
                                        var l = this.x, m = this.y, n = this.width, q = this.height, r = this.parent.div.style.cursor, t = this.div.style.cursor;
                                        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(b.target).cursor;
                                        a = function() {
                                            var u;
                                            k.abort();
                                            c.parent.togglePointerEvents(!0);
                                            null == (u = c.__altText) || u.toggle(!0);
                                            c._isDraggable = h;
                                            c.parent.div.style.cursor = r;
                                            c.div.style.cursor = t;
                                            c.__addResizeToUndoStack(l, m, n, q);
                                        };
                                        window.addEventListener("pointerup", a, {
                                            signal: d
                                        });
                                        window.addEventListener("blur", a, {
                                            signal: d
                                        });
                                    }
                                };
                                f.__addResizeToUndoStack = function(a, b, c, d) {
                                    var e = this, h = this.x, k = this.y, l = this.width, m = this.height;
                                    h === a && k === b && l === c && m === d || this.addCommands({
                                        cmd: function() {
                                            e.width = l;
                                            e.height = m;
                                            e.x = h;
                                            e.y = k;
                                            var n = p.makeIterator(e.parentDimensions), q = n.next().value;
                                            n = n.next().value;
                                            e.setDims(q * l, n * m);
                                            e.fixAndSetPosition();
                                        },
                                        undo: function() {
                                            e.width = c;
                                            e.height = d;
                                            e.x = a;
                                            e.y = b;
                                            var n = p.makeIterator(e.parentDimensions), q = n.next().value;
                                            n = n.next().value;
                                            e.setDims(q * c, n * d);
                                            e.fixAndSetPosition();
                                        },
                                        mustExec: !0
                                    });
                                };
                                f.__resizerPointermove = function(a, b) {
                                    function c(D, H) {
                                        return [
                                            r[0] * D + r[2] * H,
                                            r[1] * D + r[3] * H
                                        ];
                                    }
                                    var d = p.makeIterator(this.parentDimensions), e = d.next().value;
                                    d = d.next().value;
                                    var h = this.x, k = this.y, l = this.width, m = this.height, n = g.MIN_SIZE / e, q = g.MIN_SIZE / d, r = this.__getRotationMatrix(this.rotation), t = this.__getRotationMatrix(360 - this.rotation), u = !1, v = !1;
                                    switch(a){
                                        case "topLeft":
                                            u = !0;
                                            var w = function() {
                                                return [
                                                    0,
                                                    0
                                                ];
                                            };
                                            var x = function(D, H) {
                                                return [
                                                    D,
                                                    H
                                                ];
                                            };
                                            break;
                                        case "topMiddle":
                                            w = function(D) {
                                                return [
                                                    D / 2,
                                                    0
                                                ];
                                            };
                                            x = function(D, H) {
                                                return [
                                                    D / 2,
                                                    H
                                                ];
                                            };
                                            break;
                                        case "topRight":
                                            u = !0;
                                            w = function(D) {
                                                return [
                                                    D,
                                                    0
                                                ];
                                            };
                                            x = function(D, H) {
                                                return [
                                                    0,
                                                    H
                                                ];
                                            };
                                            break;
                                        case "middleRight":
                                            v = !0;
                                            w = function(D, H) {
                                                return [
                                                    D,
                                                    H / 2
                                                ];
                                            };
                                            x = function(D, H) {
                                                return [
                                                    0,
                                                    H / 2
                                                ];
                                            };
                                            break;
                                        case "bottomRight":
                                            u = !0;
                                            w = function(D, H) {
                                                return [
                                                    D,
                                                    H
                                                ];
                                            };
                                            x = function() {
                                                return [
                                                    0,
                                                    0
                                                ];
                                            };
                                            break;
                                        case "bottomMiddle":
                                            w = function(D, H) {
                                                return [
                                                    D / 2,
                                                    H
                                                ];
                                            };
                                            x = function(D) {
                                                return [
                                                    D / 2,
                                                    0
                                                ];
                                            };
                                            break;
                                        case "bottomLeft":
                                            u = !0;
                                            w = function(D, H) {
                                                return [
                                                    0,
                                                    H
                                                ];
                                            };
                                            x = function(D) {
                                                return [
                                                    D,
                                                    0
                                                ];
                                            };
                                            break;
                                        case "middleLeft":
                                            v = !0, w = function(D, H) {
                                                return [
                                                    0,
                                                    H / 2
                                                ];
                                            }, x = function(D, H) {
                                                return [
                                                    D,
                                                    H / 2
                                                ];
                                            };
                                    }
                                    a = w(l, m);
                                    w = x(l, m);
                                    var B = c.apply(null, p.arrayFromIterable(w));
                                    h = Math.round(1E4 * (h + B[0])) / 1E4;
                                    k = Math.round(1E4 * (k + B[1])) / 1E4;
                                    var z = 1;
                                    B = 1;
                                    var C = p.makeIterator(this.screenToPageTranslation(b.movementX, b.movementY));
                                    b = C.next().value;
                                    C = C.next().value;
                                    C = p.makeIterator(function(D, H) {
                                        return [
                                            t[0] * D + t[2] * H,
                                            t[1] * D + t[3] * H
                                        ];
                                    }(b / e, C / d));
                                    b = C.next().value;
                                    C = C.next().value;
                                    u ? z = B = Math.max(Math.min(Math.hypot(w[0] - a[0] - b, w[1] - a[1] - C) / Math.hypot(l, m), 1 / l, 1 / m), n / l, q / m) : v ? z = Math.max(n, Math.min(1, Math.abs(w[0] - a[0] - b))) / l : B = Math.max(q, Math.min(1, Math.abs(w[1] - a[1] - C))) / m;
                                    l = Math.round(l * z * 1E4) / 1E4;
                                    m = Math.round(m * B * 1E4) / 1E4;
                                    B = c.apply(null, p.arrayFromIterable(x(l, m)));
                                    x = h - B[0];
                                    n = k - B[1];
                                    this.width = l;
                                    this.height = m;
                                    this.x = x;
                                    this.y = n;
                                    this.setDims(e * l, d * m);
                                    this.fixAndSetPosition();
                                };
                                f.altTextFinish = function() {
                                    var a;
                                    null == (a = this.__altText) || a.finish();
                                };
                                f.addEditToolbar = function() {
                                    var a = Cb(function c() {
                                        var d = this;
                                        return p.generator.createGenerator(c, function(e) {
                                            if (1 == e.nextAddress) {
                                                if (d._editToolbar || d.__isInEditMode) return e.return(d._editToolbar);
                                                d._editToolbar = new Fe(d);
                                                d.div.append(d._editToolbar.render());
                                                return d.__altText ? e.yield(d._editToolbar.addAltText(d.__altText), 2) : e.jumpTo(2);
                                            }
                                            return e.return(d._editToolbar);
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.removeEditToolbar = function() {
                                    var a;
                                    this._editToolbar && (this._editToolbar.remove(), this._editToolbar = null, null == (a = this.__altText) || a.destroy());
                                };
                                f.addContainer = function(a) {
                                    var b, c = null == (b = this._editToolbar) ? void 0 : b.div;
                                    c ? c.before(a) : this.div.append(a);
                                };
                                f.getClientDimensions = function() {
                                    return this.div.getBoundingClientRect();
                                };
                                f.addAltTextButton = function() {
                                    var a = Cb(function c() {
                                        var d = this;
                                        return p.generator.createGenerator(c, function(e) {
                                            if (d.__altText) return e.return();
                                            Mb.initialize(g._l10n);
                                            d.__altText = new Mb(d);
                                            d.__accessibilityData && (d.__altText.data = d.__accessibilityData, d.__accessibilityData = null);
                                            return e.yield(d.addEditToolbar(), 0);
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.setGuessedAltText = function() {
                                    var a = Cb(function d(c) {
                                        var e, h = this;
                                        return p.generator.createGenerator(d, function(k) {
                                            return k.yield(null == (e = h.__altText) ? void 0 : e.setGuessedText(c), 0);
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.serializeAltText = function(a) {
                                    var b;
                                    return null == (b = this.__altText) ? void 0 : b.serialize(a);
                                };
                                f.hasAltText = function() {
                                    return !!this.__altText && !this.__altText.isEmpty();
                                };
                                f.hasAltTextData = function() {
                                    var a, b;
                                    return null != (a = null == (b = this.__altText) ? void 0 : b.hasData()) ? a : !1;
                                };
                                f.render = function() {
                                    this.div = document.createElement("div");
                                    this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                                    this.div.className = this.name;
                                    this.div.setAttribute("id", this.id);
                                    this.div.tabIndex = this.__disabled ? -1 : 0;
                                    this._isVisible || this.div.classList.add("hidden");
                                    this.setInForeground();
                                    this.__addFocusListeners();
                                    var a = p.makeIterator(this.parentDimensions), b = a.next().value;
                                    a = a.next().value;
                                    0 !== this.parentRotation % 180 && (this.div.style.maxWidth = (100 * a / b).toFixed(2) + "%", this.div.style.maxHeight = (100 * b / a).toFixed(2) + "%");
                                    a = p.makeIterator(this.getInitialTranslation());
                                    b = a.next().value;
                                    a = a.next().value;
                                    this.translate(b, a);
                                    Bb(this, this.div, [
                                        "pointerdown"
                                    ]);
                                    return this.div;
                                };
                                f.pointerdown = function(a) {
                                    var b = Ka.platform.isMac;
                                    0 !== a.button || a.ctrlKey && b ? a.preventDefault() : (this.__hasBeenClicked = !0, this._isDraggable ? this.__setUpDragSession(a) : this.__selectOnPointerEvent(a));
                                };
                                f.__selectOnPointerEvent = function(a) {
                                    var b = Ka.platform.isMac;
                                    a.ctrlKey && !b || a.shiftKey || a.metaKey && b ? this.parent.toggleSelected(this) : this.parent.setSelected(this);
                                };
                                f.__setUpDragSession = function(a) {
                                    function b() {
                                        e.abort();
                                        d && c.div.classList.remove("moving");
                                        c.__hasBeenClicked = !1;
                                        c._uiManager.endDragSession() || c.__selectOnPointerEvent(a);
                                    }
                                    var c = this, d = this.isSelected;
                                    this._uiManager.setUpDragSession();
                                    var e = new AbortController, h = this._uiManager.combinedSignal(e);
                                    d && (this.div.classList.add("moving"), this.__prevDragX = a.clientX, this.__prevDragY = a.clientY, window.addEventListener("pointermove", function(k) {
                                        var l = k.clientX;
                                        k = k.clientY;
                                        var m = p.makeIterator(c.screenToPageTranslation(l - c.__prevDragX, k - c.__prevDragY)), n = m.next().value;
                                        m = m.next().value;
                                        c.__prevDragX = l;
                                        c.__prevDragY = k;
                                        c._uiManager.dragSelectedEditors(n, m);
                                    }, {
                                        passive: !0,
                                        capture: !0,
                                        signal: h
                                    }));
                                    window.addEventListener("pointerup", b, {
                                        signal: h
                                    });
                                    window.addEventListener("blur", b, {
                                        signal: h
                                    });
                                };
                                f.moveInDOM = function() {
                                    var a = this;
                                    this.__moveInDOMTimeout && clearTimeout(this.__moveInDOMTimeout);
                                    this.__moveInDOMTimeout = setTimeout(function() {
                                        var b;
                                        a.__moveInDOMTimeout = null;
                                        null == (b = a.parent) || b.moveEditorInDOM(a);
                                    }, 0);
                                };
                                f._setParentAndPosition = function(a, b, c) {
                                    a.changeParent(this);
                                    this.x = b;
                                    this.y = c;
                                    this.fixAndSetPosition();
                                };
                                f.getRect = function(a, b, c) {
                                    void 0 === c && (c = this.rotation);
                                    var d = this.parentScale, e = p.makeIterator(this.pageDimensions), h = e.next().value;
                                    e = e.next().value;
                                    var k = p.makeIterator(this.pageTranslation), l = k.next().value;
                                    k = k.next().value;
                                    a /= d;
                                    b /= d;
                                    d = this.x * h;
                                    var m = this.y * e;
                                    h *= this.width;
                                    var n = this.height * e;
                                    switch(c){
                                        case 0:
                                            return [
                                                d + a + l,
                                                e - m - b - n + k,
                                                d + a + h + l,
                                                e - m - b + k
                                            ];
                                        case 90:
                                            return [
                                                d + b + l,
                                                e - m + a + k,
                                                d + b + n + l,
                                                e - m + a + h + k
                                            ];
                                        case 180:
                                            return [
                                                d - a - h + l,
                                                e - m + b + k,
                                                d - a + l,
                                                e - m + b + n + k
                                            ];
                                        case 270:
                                            return [
                                                d - b - n + l,
                                                e - m - a - h + k,
                                                d - b + l,
                                                e - m - a + k
                                            ];
                                        default:
                                            throw Error("Invalid rotation");
                                    }
                                };
                                f.getRectInCurrentCoords = function(a, b) {
                                    var c = p.makeIterator(a);
                                    a = c.next().value;
                                    var d = c.next().value, e = c.next().value;
                                    c = c.next().value;
                                    var h = e - a, k = c - d;
                                    switch(this.rotation){
                                        case 0:
                                            return [
                                                a,
                                                b - c,
                                                h,
                                                k
                                            ];
                                        case 90:
                                            return [
                                                a,
                                                b - d,
                                                k,
                                                h
                                            ];
                                        case 180:
                                            return [
                                                e,
                                                b - d,
                                                h,
                                                k
                                            ];
                                        case 270:
                                            return [
                                                e,
                                                b - c,
                                                k,
                                                h
                                            ];
                                        default:
                                            throw Error("Invalid rotation");
                                    }
                                };
                                f.onceAdded = function() {};
                                f.isEmpty = function() {
                                    return !1;
                                };
                                f.enableEditMode = function() {
                                    this.__isInEditMode = !0;
                                };
                                f.disableEditMode = function() {
                                    this.__isInEditMode = !1;
                                };
                                f.isInEditMode = function() {
                                    return this.__isInEditMode;
                                };
                                f.shouldGetKeyboardEvents = function() {
                                    return this.__isResizerEnabledForKeyboard;
                                };
                                f.needsToBeRebuilt = function() {
                                    return this.div && !this.isAttachedToDOM;
                                };
                                f.__addFocusListeners = function() {
                                    if (!this.__focusAC && this.div) {
                                        this.__focusAC = new AbortController;
                                        var a = this._uiManager.combinedSignal(this.__focusAC);
                                        this.div.addEventListener("focusin", this.focusin.bind(this), {
                                            signal: a
                                        });
                                        this.div.addEventListener("focusout", this.focusout.bind(this), {
                                            signal: a
                                        });
                                    }
                                };
                                f.rebuild = function() {
                                    this.__addFocusListeners();
                                };
                                f.rotate = function() {};
                                f.serializeDeleted = function() {
                                    var a;
                                    return {
                                        id: this.annotationElementId,
                                        deleted: !0,
                                        pageIndex: this.pageIndex,
                                        popupRef: (null == (a = this._initialData) ? void 0 : a.popupRef) || ""
                                    };
                                };
                                f.serialize = function() {
                                    da("An editor must be serializable");
                                };
                                g.deserialize = function() {
                                    var a = Cb(function h(c, d, e) {
                                        var k = this, l, m, n, q, r, t, u, v, w;
                                        return p.generator.createGenerator(h, function(x) {
                                            l = new k.prototype.constructor({
                                                parent: d,
                                                id: d.getNextId(),
                                                uiManager: e
                                            });
                                            l.rotation = c.rotation;
                                            l.__accessibilityData = c.accessibilityData;
                                            m = p.makeIterator(l.pageDimensions);
                                            n = m.next().value;
                                            q = m.next().value;
                                            r = p.makeIterator(l.getRectInCurrentCoords(c.rect, q));
                                            t = r.next().value;
                                            u = r.next().value;
                                            v = r.next().value;
                                            w = r.next().value;
                                            l.x = t / n;
                                            l.y = u / q;
                                            l.width = v / n;
                                            l.height = w / q;
                                            return x.return(l);
                                        });
                                    });
                                    return function(c, d, e) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.remove = function() {
                                    var a;
                                    null == (a = this.__focusAC) || a.abort();
                                    this.__focusAC = null;
                                    this.isEmpty() || this.commit();
                                    this.parent ? this.parent.remove(this) : this._uiManager.removeEditor(this);
                                    this.__moveInDOMTimeout && (clearTimeout(this.__moveInDOMTimeout), this.__moveInDOMTimeout = null);
                                    this.__stopResizing();
                                    this.removeEditToolbar();
                                    if (this.__telemetryTimeouts) {
                                        a = p.makeIterator(this.__telemetryTimeouts.values());
                                        for(var b = a.next(); !b.done; b = a.next())clearTimeout(b.value);
                                        this.__telemetryTimeouts = null;
                                    }
                                    this.parent = null;
                                };
                                f.makeResizable = function() {
                                    this.isResizable && (this.__createResizers(), this.__resizersDiv.classList.remove("hidden"), Bb(this, this.div, [
                                        "keydown"
                                    ]));
                                };
                                f.keydown = function(a) {
                                    if (this.isResizable && a.target === this.div && "Enter" === a.key) {
                                        this._uiManager.setSelected(this);
                                        this.__savedDimensions = {
                                            savedX: this.x,
                                            savedY: this.y,
                                            savedWidth: this.width,
                                            savedHeight: this.height
                                        };
                                        var b = this.__resizersDiv.children;
                                        if (!this.__allResizerDivs) {
                                            this.__allResizerDivs = Array.from(b);
                                            for(var c = this.__resizerKeydown.bind(this), d = this.__resizerBlur.bind(this), e = this._uiManager._signal, h = p.makeIterator(this.__allResizerDivs), k = h.next(); !k.done; k = h.next()){
                                                k = k.value;
                                                var l = k.getAttribute("data-resizer-name");
                                                k.setAttribute("role", "spinbutton");
                                                k.addEventListener("keydown", c, {
                                                    signal: e
                                                });
                                                k.addEventListener("blur", d, {
                                                    signal: e
                                                });
                                                k.addEventListener("focus", this.__resizerFocus.bind(this, l), {
                                                    signal: e
                                                });
                                                k.setAttribute("data-l10n-id", g._l10nResizer[l]);
                                            }
                                        }
                                        d = this.__allResizerDivs[0];
                                        c = 0;
                                        e = p.makeIterator(b);
                                        for(h = e.next(); !h.done && h.value !== d; h = e.next())c++;
                                        d = (360 - this.rotation + this.parentRotation) % 360 / 90 * (this.__allResizerDivs.length / 4);
                                        if (d !== c) {
                                            if (d < c) for(e = 0; e < c - d; e++)this.__resizersDiv.append(this.__resizersDiv.firstChild);
                                            else if (d > c) for(e = 0; e < d - c; e++)this.__resizersDiv.firstChild.before(this.__resizersDiv.lastChild);
                                            c = 0;
                                            b = p.makeIterator(b);
                                            for(d = b.next(); !d.done; d = b.next())d = d.value, e = this.__allResizerDivs[c++].getAttribute("data-resizer-name"), d.setAttribute("data-l10n-id", g._l10nResizer[e]);
                                        }
                                        this.__setResizerTabIndex(0);
                                        this.__isResizerEnabledForKeyboard = !0;
                                        this.__resizersDiv.firstChild.focus({
                                            focusVisible: !0
                                        });
                                        a.preventDefault();
                                        a.stopImmediatePropagation();
                                    }
                                };
                                f.__resizerKeydown = function(a) {
                                    g._resizerKeyboardManager.exec(this, a);
                                };
                                f.__resizerBlur = function(a) {
                                    var b;
                                    this.__isResizerEnabledForKeyboard && (null == (b = a.relatedTarget) ? void 0 : b.parentNode) !== this.__resizersDiv && this.__stopResizing();
                                };
                                f.__resizerFocus = function(a) {
                                    this.__focusedResizerName = this.__isResizerEnabledForKeyboard ? a : "";
                                };
                                f.__setResizerTabIndex = function(a) {
                                    if (this.__allResizerDivs) for(var b = p.makeIterator(this.__allResizerDivs), c = b.next(); !c.done; c = b.next())c.value.tabIndex = a;
                                };
                                f._resizeWithKeyboard = function(a, b) {
                                    this.__isResizerEnabledForKeyboard && this.__resizerPointermove(this.__focusedResizerName, {
                                        movementX: a,
                                        movementY: b
                                    });
                                };
                                f.__stopResizing = function() {
                                    this.__isResizerEnabledForKeyboard = !1;
                                    this.__setResizerTabIndex(-1);
                                    if (this.__savedDimensions) {
                                        var a = this.__savedDimensions;
                                        this.__addResizeToUndoStack(a.savedX, a.savedY, a.savedWidth, a.savedHeight);
                                        this.__savedDimensions = null;
                                    }
                                };
                                f._stopResizingWithKeyboard = function() {
                                    this.__stopResizing();
                                    this.div.focus();
                                };
                                f.select = function() {
                                    var a = this, b, c, d;
                                    this.makeResizable();
                                    null == (b = this.div) || b.classList.add("selectedEditor");
                                    this._editToolbar ? (null == (c = this._editToolbar) || c.show(), null == (d = this.__altText) || d.toggleAltTextBadge(!1)) : this.addEditToolbar().then(function() {
                                        var e;
                                        if (null != (e = a.div) && e.classList.contains("selectedEditor")) {
                                            var h;
                                            null == (h = a._editToolbar) || h.show();
                                        }
                                    });
                                };
                                f.unselect = function() {
                                    var a, b, c, d, e;
                                    null == (a = this.__resizersDiv) || a.classList.add("hidden");
                                    null == (b = this.div) || b.classList.remove("selectedEditor");
                                    null != (c = this.div) && c.contains(document.activeElement) && this._uiManager.currentLayer.div.focus({
                                        preventScroll: !0
                                    });
                                    null == (d = this._editToolbar) || d.hide();
                                    null == (e = this.__altText) || e.toggleAltTextBadge(!0);
                                };
                                f.updateParams = function() {};
                                f.disableEditing = function() {};
                                f.enableEditing = function() {};
                                f.enterInEditMode = function() {};
                                f.getImageForAltText = function() {
                                    return null;
                                };
                                f.setAspectRatio = function(a, b) {
                                    this.__keepAspectRatio = !0;
                                    var c = this.div.style;
                                    c.aspectRatio = a / b;
                                    c.height = "auto";
                                };
                                g.canCreateNewEmptyEditor = function() {
                                    return !0;
                                };
                                f._reportTelemetry = function(a, b) {
                                    var c = this;
                                    void 0 === b && (b = !1);
                                    if (b) {
                                        this.__telemetryTimeouts || (this.__telemetryTimeouts = new Map);
                                        var d = a.action;
                                        (b = this.__telemetryTimeouts.get(d)) && clearTimeout(b);
                                        b = setTimeout(function() {
                                            c._reportTelemetry(a);
                                            c.__telemetryTimeouts.delete(d);
                                            0 === c.__telemetryTimeouts.size && (c.__telemetryTimeouts = null);
                                        }, g._telemetryTimeout);
                                        this.__telemetryTimeouts.set(d, b);
                                    } else a.type || (a.type = this.editorType), this._uiManager._eventBus.dispatch("reporttelemetry", {
                                        source: this,
                                        details: {
                                            type: "editing",
                                            data: a
                                        }
                                    });
                                };
                                f.show = function(a) {
                                    void 0 === a && (a = this._isVisible);
                                    this.div.classList.toggle("hidden", !a);
                                    this._isVisible = a;
                                };
                                f.enable = function() {
                                    this.div && (this.div.tabIndex = 0);
                                    this.__disabled = !1;
                                };
                                f.disable = function() {
                                    this.div && (this.div.tabIndex = -1);
                                    this.__disabled = !0;
                                };
                                f.renderAnnotationElement = function(a) {
                                    var b = a.container.querySelector(".annotationContent");
                                    b ? "CANVAS" === b.nodeName && (a = b, b = document.createElement("div"), b.classList.add("annotationContent", this.editorType), a.before(b)) : (b = document.createElement("div"), b.classList.add("annotationContent", this.editorType), a.container.prepend(b));
                                    return b;
                                };
                                f.resetAnnotationElement = function(a) {
                                    a = a.container.firstChild;
                                    "DIV" === (null == a ? void 0 : a.nodeName) && a.classList.contains("annotationContent") && a.remove();
                                };
                                return qf(g, [
                                    {
                                        key: "editorType",
                                        get: function() {
                                            return Object.getPrototypeOf(this).constructor._type;
                                        }
                                    },
                                    {
                                        key: "propertiesToUpdate",
                                        get: function() {
                                            return [];
                                        }
                                    },
                                    {
                                        key: "_isDraggable",
                                        get: function() {
                                            return this.__isDraggable;
                                        },
                                        set: function(a) {
                                            var b;
                                            this.__isDraggable = a;
                                            null == (b = this.div) || b.classList.toggle("draggable", a);
                                        }
                                    },
                                    {
                                        key: "isEnterHandled",
                                        get: function() {
                                            return !0;
                                        }
                                    },
                                    {
                                        key: "currentLayer",
                                        get: function() {
                                            return this._uiManager.currentLayer;
                                        }
                                    },
                                    {
                                        key: "_hasBeenMoved",
                                        get: function() {
                                            return !!this.__initialPosition && (this.__initialPosition[0] !== this.x || this.__initialPosition[1] !== this.y);
                                        }
                                    },
                                    {
                                        key: "_mustFixPosition",
                                        get: function() {
                                            return !0;
                                        }
                                    },
                                    {
                                        key: "parentScale",
                                        get: function() {
                                            return this._uiManager.viewParameters.realScale;
                                        }
                                    },
                                    {
                                        key: "parentRotation",
                                        get: function() {
                                            return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                                        }
                                    },
                                    {
                                        key: "parentDimensions",
                                        get: function() {
                                            var a = this.parentScale, b = p.makeIterator(this.pageDimensions), c = b.next().value;
                                            b = b.next().value;
                                            return [
                                                c * a,
                                                b * a
                                            ];
                                        }
                                    },
                                    {
                                        key: "altTextData",
                                        get: function() {
                                            var a;
                                            return null == (a = this.__altText) ? void 0 : a.data;
                                        },
                                        set: function(a) {
                                            this.__altText && (this.__altText.data = a);
                                        }
                                    },
                                    {
                                        key: "guessedAltText",
                                        get: function() {
                                            var a;
                                            return null == (a = this.__altText) ? void 0 : a.guessedText;
                                        }
                                    },
                                    {
                                        key: "isSelected",
                                        get: function() {
                                            return this._uiManager.isSelected(this);
                                        }
                                    },
                                    {
                                        key: "hasBeenModified",
                                        get: function() {
                                            return !!this.annotationElementId && (this.deleted || null !== this.serialize());
                                        }
                                    },
                                    {
                                        key: "isResizable",
                                        get: function() {
                                            return !1;
                                        }
                                    },
                                    {
                                        key: "toolbarPosition",
                                        get: function() {
                                            return null;
                                        }
                                    },
                                    {
                                        key: "contentDiv",
                                        get: function() {
                                            return this.div;
                                        }
                                    },
                                    {
                                        key: "isEditing",
                                        get: function() {
                                            return this.__isEditing;
                                        },
                                        set: function(a) {
                                            this.__isEditing = a;
                                            this.parent && (a ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null));
                                        }
                                    },
                                    {
                                        key: "telemetryInitialData",
                                        get: function() {
                                            return {
                                                action: "added"
                                            };
                                        }
                                    },
                                    {
                                        key: "telemetryFinalData",
                                        get: function() {
                                            return null;
                                        }
                                    }
                                ], [
                                    {
                                        key: "_resizerKeyboardManager",
                                        get: function() {
                                            var a = g.prototype._resizeWithKeyboard, b = gb.TRANSLATE_SMALL, c = gb.TRANSLATE_BIG;
                                            return qa(this, "_resizerKeyboardManager", new ub([
                                                [
                                                    [
                                                        "ArrowLeft",
                                                        "mac+ArrowLeft"
                                                    ],
                                                    a,
                                                    {
                                                        args: [
                                                            -b,
                                                            0
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowLeft",
                                                        "mac+shift+ArrowLeft"
                                                    ],
                                                    a,
                                                    {
                                                        args: [
                                                            -c,
                                                            0
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowRight",
                                                        "mac+ArrowRight"
                                                    ],
                                                    a,
                                                    {
                                                        args: [
                                                            b,
                                                            0
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowRight",
                                                        "mac+shift+ArrowRight"
                                                    ],
                                                    a,
                                                    {
                                                        args: [
                                                            c,
                                                            0
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowUp",
                                                        "mac+ArrowUp"
                                                    ],
                                                    a,
                                                    {
                                                        args: [
                                                            0,
                                                            -b
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowUp",
                                                        "mac+shift+ArrowUp"
                                                    ],
                                                    a,
                                                    {
                                                        args: [
                                                            0,
                                                            -c
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowDown",
                                                        "mac+ArrowDown"
                                                    ],
                                                    a,
                                                    {
                                                        args: [
                                                            0,
                                                            b
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowDown",
                                                        "mac+shift+ArrowDown"
                                                    ],
                                                    a,
                                                    {
                                                        args: [
                                                            0,
                                                            c
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "Escape",
                                                        "mac+Escape"
                                                    ],
                                                    g.prototype._stopResizingWithKeyboard
                                                ]
                                            ]));
                                        }
                                    },
                                    {
                                        key: "_defaultLineColor",
                                        get: function() {
                                            return qa(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                                        }
                                    },
                                    {
                                        key: "defaultPropertiesToUpdate",
                                        get: function() {
                                            return [];
                                        }
                                    },
                                    {
                                        key: "MIN_SIZE",
                                        get: function() {
                                            return 16;
                                        }
                                    }
                                ]);
                            }();
                            wa._l10n = null;
                            wa._l10nResizer = null;
                            wa._borderLineWidth = -1;
                            wa._colorManager = new Ge;
                            wa._zIndex = 1;
                            wa._telemetryTimeout = 1E3;
                            var sg = function(g) {
                                function f(a) {
                                    var b = g.call(this, a) || this;
                                    b.annotationElementId = a.annotationElementId;
                                    b.deleted = !0;
                                    return b;
                                }
                                pf(f, g);
                                f.prototype.serialize = function() {
                                    return this.serializeDeleted();
                                };
                                return f;
                            }(wa), He = function() {
                                function g(a) {
                                    this.h1 = a ? a & 4294967295 : 3285377520;
                                    this.h2 = a ? a & 4294967295 : 3285377520;
                                }
                                var f = g.prototype;
                                f.update = function(a) {
                                    var b;
                                    if ("string" === typeof a) {
                                        var c = new Uint8Array(2 * a.length);
                                        for(var d = b = 0, e = a.length; d < e; d++){
                                            var h = a.charCodeAt(d);
                                            255 >= h ? c[b++] = h : (c[b++] = h >>> 8, c[b++] = h & 255);
                                        }
                                    } else if (ArrayBuffer.isView(a)) c = a.slice(), b = c.byteLength;
                                    else throw Error("Invalid data format, must be a string or TypedArray.");
                                    a = b >> 2;
                                    b -= 4 * a;
                                    d = new Uint32Array(c.buffer, 0, a);
                                    e = this.h1;
                                    h = this.h2;
                                    for(var k = 0; k < a; k++)if (k & 1) {
                                        var l = d[k];
                                        l = 3432918353 * l & 4294901760 | 11601 * l & 65535;
                                        l = l << 15 | l >>> 17;
                                        l = 461845907 * l & 4294901760 | 13715 * l & 65535;
                                        e ^= l;
                                        e = e << 13 | e >>> 19;
                                        e = 5 * e + 3864292196;
                                    } else l = d[k], l = 3432918353 * l & 4294901760 | 11601 * l & 65535, l = l << 15 | l >>> 17, l = 461845907 * l & 4294901760 | 13715 * l & 65535, h ^= l, h = h << 13 | h >>> 19, h = 5 * h + 3864292196;
                                    l = 0;
                                    switch(b){
                                        case 3:
                                            l ^= c[4 * a + 2] << 16;
                                        case 2:
                                            l ^= c[4 * a + 1] << 8;
                                        case 1:
                                            l ^= c[4 * a], l = 3432918353 * l & 4294901760 | 11601 * l & 65535, l = l << 15 | l >>> 17, l = 461845907 * l & 4294901760 | 13715 * l & 65535, a & 1 ? e ^= l : h ^= l;
                                    }
                                    this.h1 = e;
                                    this.h2 = h;
                                };
                                f.hexdigest = function() {
                                    var a = this.h1, b = this.h2;
                                    a ^= b >>> 1;
                                    a = 3981806797 * a & 4294901760 | 36045 * a & 65535;
                                    b = 4283543511 * b & 4294901760 | (2950163797 * (b << 16 | a >>> 16) & 4294901760) >>> 16;
                                    a ^= b >>> 1;
                                    a = 444984403 * a & 4294901760 | 60499 * a & 65535;
                                    b = 3301882366 * b & 4294901760 | (3120437893 * (b << 16 | a >>> 16) & 4294901760) >>> 16;
                                    return ((a ^ b >>> 1) >>> 0).toString(16).padStart(8, "0") + (b >>> 0).toString(16).padStart(8, "0");
                                };
                                return g;
                            }(), Qc = Object.freeze({
                                map: null,
                                hash: "",
                                transfer: void 0
                            }), Rc = function() {
                                function g() {
                                    this.__modified = !1;
                                    this.__modifiedIds = null;
                                    this.__storage = new Map;
                                    this.onAnnotationEditor = this.onResetModified = this.onSetModified = null;
                                }
                                var f = g.prototype;
                                f.getValue = function(a, b) {
                                    a = this.__storage.get(a);
                                    return void 0 === a ? b : Object.assign(b, a);
                                };
                                f.getRawValue = function(a) {
                                    return this.__storage.get(a);
                                };
                                f.remove = function(a) {
                                    this.__storage.delete(a);
                                    0 === this.__storage.size && this.resetModified();
                                    if ("function" === typeof this.onAnnotationEditor) {
                                        a = p.makeIterator(this.__storage.values());
                                        for(var b = a.next(); !b.done; b = a.next())if (b.value instanceof wa) return;
                                        this.onAnnotationEditor(null);
                                    }
                                };
                                f.setValue = function(a, b) {
                                    var c = this.__storage.get(a), d = !1;
                                    if (void 0 !== c) {
                                        a = p.makeIterator(Object.entries(b));
                                        for(var e = a.next(); !e.done; e = a.next()){
                                            var h = p.makeIterator(e.value);
                                            e = h.next().value;
                                            h = h.next().value;
                                            c[e] !== h && (d = !0, c[e] = h);
                                        }
                                    } else d = !0, this.__storage.set(a, b);
                                    d && this.__setModified();
                                    if (b instanceof wa && "function" === typeof this.onAnnotationEditor) this.onAnnotationEditor(b.constructor._type);
                                };
                                f.has = function(a) {
                                    return this.__storage.has(a);
                                };
                                f.getAll = function() {
                                    return 0 < this.__storage.size ? Rb(this.__storage) : null;
                                };
                                f.setAll = function(a) {
                                    a = p.makeIterator(Object.entries(a));
                                    for(var b = a.next(); !b.done; b = a.next()){
                                        var c = p.makeIterator(b.value);
                                        b = c.next().value;
                                        c = c.next().value;
                                        this.setValue(b, c);
                                    }
                                };
                                f.__setModified = function() {
                                    if (!this.__modified && (this.__modified = !0, "function" === typeof this.onSetModified)) this.onSetModified();
                                };
                                f.resetModified = function() {
                                    if (this.__modified && (this.__modified = !1, "function" === typeof this.onResetModified)) this.onResetModified();
                                };
                                f.resetModifiedIds = function() {
                                    this.__modifiedIds = null;
                                };
                                return nd(g, [
                                    {
                                        key: "size",
                                        get: function() {
                                            return this.__storage.size;
                                        }
                                    },
                                    {
                                        key: "print",
                                        get: function() {
                                            return new Ie(this);
                                        }
                                    },
                                    {
                                        key: "serializable",
                                        get: function() {
                                            if (0 === this.__storage.size) return Qc;
                                            for(var a = new Map, b = new He, c = [], d = Object.create(null), e = !1, h = p.makeIterator(this.__storage), k = h.next(); !k.done; k = h.next()){
                                                var l = p.makeIterator(k.value);
                                                k = l.next().value;
                                                l = l.next().value;
                                                if (l = l instanceof wa ? l.serialize(!1, d) : l) a.set(k, l), b.update(k + ":" + JSON.stringify(l)), e || (e = !!l.bitmap);
                                            }
                                            if (e) for(d = p.makeIterator(a.values()), e = d.next(); !e.done; e = d.next())e = e.value, e.bitmap && c.push(e.bitmap);
                                            return 0 < a.size ? {
                                                map: a,
                                                hash: b.hexdigest(),
                                                transfer: c
                                            } : Qc;
                                        }
                                    },
                                    {
                                        key: "editorStats",
                                        get: function() {
                                            for(var a = null, b = new Map, c = p.makeIterator(this.__storage.values()), d = c.next(); !d.done; d = c.next()){
                                                d = d.value;
                                                var e;
                                                if (d instanceof wa) {
                                                    var h = d.telemetryFinalData;
                                                    if (h) {
                                                        var k = h.type;
                                                        b.has(k) || b.set(k, Object.getPrototypeOf(d).constructor);
                                                        a || (a = Object.create(null));
                                                        d = (e = a)[k] || (e[k] = new Map);
                                                        h = p.makeIterator(Object.entries(h));
                                                        for(k = h.next(); !k.done; k = h.next()){
                                                            var l = p.makeIterator(k.value);
                                                            k = l.next().value;
                                                            l = l.next().value;
                                                            var m;
                                                            if ("type" !== k) {
                                                                var n = d.get(k);
                                                                n || (n = new Map, d.set(k, n));
                                                                k = null != (m = n.get(l)) ? m : 0;
                                                                n.set(l, k + 1);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            b = p.makeIterator(b);
                                            for(c = b.next(); !c.done; c = b.next())e = p.makeIterator(c.value), c = e.next().value, e = e.next().value, a[c] = e.computeTelemetryFinalData(a[c]);
                                            return a;
                                        }
                                    },
                                    {
                                        key: "modifiedIds",
                                        get: function() {
                                            if (this.__modifiedIds) return this.__modifiedIds;
                                            for(var a = [], b = p.makeIterator(this.__storage.values()), c = b.next(); !c.done; c = b.next())c = c.value, c instanceof wa && c.annotationElementId && c.serialize() && a.push(c.annotationElementId);
                                            return this.__modifiedIds = {
                                                ids: new Set(a),
                                                hash: a.join(",")
                                            };
                                        }
                                    }
                                ]);
                            }(), Ie = function(g) {
                                function f(a) {
                                    var b = g.call(this) || this;
                                    b.__serializable = void 0;
                                    var c = a.serializable;
                                    a = c.hash;
                                    var d = c.transfer;
                                    c = structuredClone(c.map, d ? {
                                        transfer: d
                                    } : null);
                                    b.__serializable = {
                                        map: c,
                                        hash: a,
                                        transfer: d
                                    };
                                    return b;
                                }
                                rf(f, g);
                                return nd(f, [
                                    {
                                        key: "print",
                                        get: function() {
                                            da("Should not call PrintAnnotationStorage.print");
                                        }
                                    },
                                    {
                                        key: "serializable",
                                        get: function() {
                                            return this.__serializable;
                                        }
                                    },
                                    {
                                        key: "modifiedIds",
                                        get: function() {
                                            return qa(this, "modifiedIds", {
                                                ids: new Set,
                                                hash: ""
                                            });
                                        }
                                    }
                                ]);
                            }(Rc), tg = function() {
                                function g(a) {
                                    a = void 0 === a.ownerDocument ? globalThis.document : a.ownerDocument;
                                    this.__systemFonts = new Set;
                                    this._document = a;
                                    this.nativeFontFaces = new Set;
                                    this.styleElement = null;
                                    this.loadingRequests = [];
                                    this.loadTestFontId = 0;
                                }
                                var f = g.prototype;
                                f.addNativeFontFace = function(a) {
                                    this.nativeFontFaces.add(a);
                                    this._document.fonts.add(a);
                                };
                                f.removeNativeFontFace = function(a) {
                                    this.nativeFontFaces.delete(a);
                                    this._document.fonts.delete(a);
                                };
                                f.insertRule = function(a) {
                                    this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
                                    var b = this.styleElement.sheet;
                                    b.insertRule(a, b.cssRules.length);
                                };
                                f.clear = function() {
                                    for(var a = p.makeIterator(this.nativeFontFaces), b = a.next(); !b.done; b = a.next())this._document.fonts.delete(b.value);
                                    this.nativeFontFaces.clear();
                                    this.__systemFonts.clear();
                                    this.styleElement && (this.styleElement.remove(), this.styleElement = null);
                                };
                                f.loadSystemFont = function() {
                                    var a = pd(function d(c) {
                                        var e, h, k, l = this, m, n, q, r, t;
                                        return p.generator.createGenerator(d, function(u) {
                                            switch(u.nextAddress){
                                                case 1:
                                                    e = c;
                                                    h = e.systemFontInfo;
                                                    k = e._inspectFont;
                                                    if (!h || l.__systemFonts.has(h.loadedName)) return u.return();
                                                    !l.disableFontFace || da("loadSystemFont shouldn't be called when `disableFontFace` is set.");
                                                    if (!l.isFontLoadingAPISupported) {
                                                        u.jumpTo(2);
                                                        break;
                                                    }
                                                    m = h;
                                                    n = m.loadedName;
                                                    q = m.src;
                                                    r = m.style;
                                                    t = new FontFace(n, q, r);
                                                    l.addNativeFontFace(t);
                                                    u.setCatchFinallyBlocks(3);
                                                    return u.yield(t.load(), 5);
                                                case 5:
                                                    l.__systemFonts.add(n);
                                                    null == k || k(h);
                                                    u.leaveTryBlock(4);
                                                    break;
                                                case 3:
                                                    u.enterCatchBlock(), R("Cannot load system font: " + h.baseFontName + ", installing it could help to improve PDF rendering."), l.removeNativeFontFace(t);
                                                case 4:
                                                    return u.return();
                                                case 2:
                                                    da("Not implemented: loadSystemFont without the Font Loading API."), u.jumpToEnd();
                                            }
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.bind = function() {
                                    var a = pd(function d(c) {
                                        var e = this, h, k, l, m;
                                        return p.generator.createGenerator(d, function(n) {
                                            switch(n.nextAddress){
                                                case 1:
                                                    h = e;
                                                    if (c.attached || c.missingFile && !c.systemFontInfo) return n.return();
                                                    c.attached = !0;
                                                    if (!c.systemFontInfo) {
                                                        n.jumpTo(2);
                                                        break;
                                                    }
                                                    return n.yield(e.loadSystemFont(c), 3);
                                                case 3:
                                                    return n.return();
                                                case 2:
                                                    if (!e.isFontLoadingAPISupported) {
                                                        n.jumpTo(4);
                                                        break;
                                                    }
                                                    k = c.createNativeFontFace();
                                                    if (!k) {
                                                        n.jumpTo(5);
                                                        break;
                                                    }
                                                    e.addNativeFontFace(k);
                                                    n.setCatchFinallyBlocks(6);
                                                    return n.yield(k.loaded, 8);
                                                case 8:
                                                    n.leaveTryBlock(5);
                                                    break;
                                                case 6:
                                                    throw l = n.enterCatchBlock(), R("Failed to load font '" + k.family + "': '" + l + "'."), c.disableFontFace = !0, l;
                                                case 5:
                                                    return n.return();
                                                case 4:
                                                    if (m = c.createFontFaceRule()) return e.insertRule(m), e.isSyncFontLoadingSupported ? n.return() : n.yield(new Promise(function(q) {
                                                        q = h._queueLoadingCallback(q);
                                                        h._prepareFontLoadEvent(c, q);
                                                    }), 0);
                                                    n.jumpTo(0);
                                            }
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f._queueLoadingCallback = function(a) {
                                    var b = this.loadingRequests, c = {
                                        done: !1,
                                        complete: function() {
                                            !c.done || da("completeRequest() cannot be called twice.");
                                            for(c.done = !0; 0 < b.length && b[0].done;){
                                                var d = b.shift();
                                                setTimeout(d.callback, 0);
                                            }
                                        },
                                        callback: a
                                    };
                                    b.push(c);
                                    return c;
                                };
                                f._prepareFontLoadEvent = function(a, b) {
                                    function c(u, v) {
                                        return u.charCodeAt(v) << 24 | u.charCodeAt(v + 1) << 16 | u.charCodeAt(v + 2) << 8 | u.charCodeAt(v + 3) & 255;
                                    }
                                    function d(u, v, w, x) {
                                        var B = u.substring(0, v);
                                        u = u.substring(v + w);
                                        return B + x + u;
                                    }
                                    function e(u, v) {
                                        30 < ++m ? (R("Load test font never loaded."), v()) : (l.font = "30px " + u, l.fillText(".", 0, 20), 0 < l.getImageData(0, 0, 1, 1).data[3] ? v() : setTimeout(e.bind(null, u, v)));
                                    }
                                    var h, k = this._document.createElement("canvas");
                                    k.width = 1;
                                    k.height = 1;
                                    var l = k.getContext("2d"), m = 0;
                                    k = "lt" + Date.now() + this.loadTestFontId++;
                                    var n = this._loadTestFont;
                                    n = d(n, 976, k.length, k);
                                    var q = c(n, 16);
                                    var r = 0;
                                    for(h = k.length - 3; r < h; r += 4)q = q - 1482184792 + c(k, r) | 0;
                                    r < k.length && (q = q - 1482184792 + c(k + "XXX", r) | 0);
                                    n = d(n, 16, 4, String.fromCharCode(q >> 24 & 255, q >> 16 & 255, q >> 8 & 255, q & 255));
                                    r = "url(data:font/opentype;base64," + btoa(n) + ");";
                                    this.insertRule('@font-face {font-family:"' + k + '";src:' + r + "}");
                                    var t = this._document.createElement("div");
                                    t.style.visibility = "hidden";
                                    t.style.width = t.style.height = "10px";
                                    t.style.position = "absolute";
                                    t.style.top = t.style.left = "0px";
                                    a = p.makeIterator([
                                        a.loadedName,
                                        k
                                    ]);
                                    for(r = a.next(); !r.done; r = a.next())r = r.value, h = this._document.createElement("span"), h.textContent = "Hi", h.style.fontFamily = r, t.append(h);
                                    this._document.body.append(t);
                                    e(k, function() {
                                        t.remove();
                                        b.complete();
                                    });
                                };
                                return sf(g, [
                                    {
                                        key: "isFontLoadingAPISupported",
                                        get: function() {
                                            var a, b = !(null == (a = this._document) || !a.fonts);
                                            return qa(this, "isFontLoadingAPISupported", b);
                                        }
                                    },
                                    {
                                        key: "isSyncFontLoadingSupported",
                                        get: function() {
                                            var a, b = !1;
                                            "undefined" !== typeof navigator && "string" === typeof (null == (a = navigator) ? void 0 : a.userAgent) && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent) && (b = !0);
                                            return qa(this, "isSyncFontLoadingSupported", b);
                                        }
                                    },
                                    {
                                        key: "_loadTestFont",
                                        get: function() {
                                            var a = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                                            return qa(this, "_loadTestFont", a);
                                        }
                                    }
                                ]);
                            }(), ug = function() {
                                function g(a, b) {
                                    var c = void 0 === b.disableFontFace ? !1 : b.disableFontFace;
                                    b = void 0 === b.inspectFont ? null : b.inspectFont;
                                    this.compiledGlyphs = Object.create(null);
                                    for(var d in a)this[d] = a[d];
                                    this.disableFontFace = !0 === c;
                                    this._inspectFont = b;
                                }
                                var f = g.prototype;
                                f.createNativeFontFace = function() {
                                    var a;
                                    if (!this.data || this.disableFontFace) return null;
                                    if (this.cssFontInfo) {
                                        var b = {
                                            weight: this.cssFontInfo.fontWeight
                                        };
                                        this.cssFontInfo.italicAngle && (b.style = "oblique " + this.cssFontInfo.italicAngle + "deg");
                                        b = new FontFace(this.cssFontInfo.fontFamily, this.data, b);
                                    } else b = new FontFace(this.loadedName, this.data, {});
                                    null == (a = this._inspectFont) || a.call(this, this);
                                    return b;
                                };
                                f.createFontFaceRule = function() {
                                    var a;
                                    if (!this.data || this.disableFontFace) return null;
                                    var b = "url(data:" + this.mimetype + ";base64,";
                                    var c = this.data;
                                    c = Uint8Array.prototype.toBase64 ? c.toBase64() : btoa(lb(c));
                                    b = b + c + ");";
                                    this.cssFontInfo ? (c = "font-weight: " + this.cssFontInfo.fontWeight + ";", this.cssFontInfo.italicAngle && (c += "font-style: oblique " + this.cssFontInfo.italicAngle + "deg;"), c = '@font-face {font-family:"' + this.cssFontInfo.fontFamily + '";' + c + "src:" + b + "}") : c = '@font-face {font-family:"' + this.loadedName + '";src:' + b + "}";
                                    null == (a = this._inspectFont) || a.call(this, this, b);
                                    return c;
                                };
                                f.getPathGenerator = function(a, b) {
                                    if (void 0 !== this.compiledGlyphs[b]) return this.compiledGlyphs[b];
                                    try {
                                        var c = a.get(this.loadedName + "_path_" + b);
                                    } catch (l) {
                                        R('getPathGenerator - ignoring character: "' + l + '".');
                                    }
                                    if (!Array.isArray(c) || 0 === c.length) return this.compiledGlyphs[b] = function() {};
                                    var d = [];
                                    a = {};
                                    for(var e = 0, h = c.length; e < h; a = {
                                        a$jscomp$24: void 0,
                                        b$jscomp$11: void 0,
                                        c$jscomp$13: void 0,
                                        d$jscomp$5: void 0,
                                        e$jscomp$79: void 0,
                                        f$jscomp$9: void 0,
                                        a$jscomp$25: void 0,
                                        b$jscomp$12: void 0,
                                        a$jscomp$26: void 0,
                                        b$jscomp$13: void 0,
                                        a$jscomp$27: void 0,
                                        b$jscomp$14: void 0,
                                        c$jscomp$14: void 0,
                                        d$jscomp$6: void 0,
                                        a$jscomp$28: void 0,
                                        b$jscomp$15: void 0,
                                        c$jscomp$15: void 0,
                                        d$jscomp$7: void 0,
                                        e$jscomp$80: void 0,
                                        f$jscomp$10: void 0,
                                        a$jscomp$29: void 0,
                                        b$jscomp$16: void 0
                                    })switch(c[e++]){
                                        case 0:
                                            var k = p.makeIterator(c.slice(e, e + 6));
                                            a.a$jscomp$24 = k.next().value;
                                            a.b$jscomp$11 = k.next().value;
                                            a.c$jscomp$13 = k.next().value;
                                            a.d$jscomp$5 = k.next().value;
                                            a.e$jscomp$79 = k.next().value;
                                            a.f$jscomp$9 = k.next().value;
                                            d.push(function(l) {
                                                return function(m) {
                                                    return m.bezierCurveTo(l.a$jscomp$24, l.b$jscomp$11, l.c$jscomp$13, l.d$jscomp$5, l.e$jscomp$79, l.f$jscomp$9);
                                                };
                                            }(a));
                                            e += 6;
                                            break;
                                        case 1:
                                            k = p.makeIterator(c.slice(e, e + 2));
                                            a.a$jscomp$25 = k.next().value;
                                            a.b$jscomp$12 = k.next().value;
                                            d.push(function(l) {
                                                return function(m) {
                                                    return m.moveTo(l.a$jscomp$25, l.b$jscomp$12);
                                                };
                                            }(a));
                                            e += 2;
                                            break;
                                        case 2:
                                            k = p.makeIterator(c.slice(e, e + 2));
                                            a.a$jscomp$26 = k.next().value;
                                            a.b$jscomp$13 = k.next().value;
                                            d.push(function(l) {
                                                return function(m) {
                                                    return m.lineTo(l.a$jscomp$26, l.b$jscomp$13);
                                                };
                                            }(a));
                                            e += 2;
                                            break;
                                        case 3:
                                            k = p.makeIterator(c.slice(e, e + 4));
                                            a.a$jscomp$27 = k.next().value;
                                            a.b$jscomp$14 = k.next().value;
                                            a.c$jscomp$14 = k.next().value;
                                            a.d$jscomp$6 = k.next().value;
                                            d.push(function(l) {
                                                return function(m) {
                                                    return m.quadraticCurveTo(l.a$jscomp$27, l.b$jscomp$14, l.c$jscomp$14, l.d$jscomp$6);
                                                };
                                            }(a));
                                            e += 4;
                                            break;
                                        case 4:
                                            d.push(function(l) {
                                                return l.restore();
                                            });
                                            break;
                                        case 5:
                                            d.push(function(l) {
                                                return l.save();
                                            });
                                            break;
                                        case 6:
                                            2 === d.length || da("Scale command is only valid at the third position.");
                                            break;
                                        case 7:
                                            k = p.makeIterator(c.slice(e, e + 6));
                                            a.a$jscomp$28 = k.next().value;
                                            a.b$jscomp$15 = k.next().value;
                                            a.c$jscomp$15 = k.next().value;
                                            a.d$jscomp$7 = k.next().value;
                                            a.e$jscomp$80 = k.next().value;
                                            a.f$jscomp$10 = k.next().value;
                                            d.push(function(l) {
                                                return function(m) {
                                                    return m.transform(l.a$jscomp$28, l.b$jscomp$15, l.c$jscomp$15, l.d$jscomp$7, l.e$jscomp$80, l.f$jscomp$10);
                                                };
                                            }(a));
                                            e += 6;
                                            break;
                                        case 8:
                                            k = p.makeIterator(c.slice(e, e + 2)), a.a$jscomp$29 = k.next().value, a.b$jscomp$16 = k.next().value, d.push(function(l) {
                                                return function(m) {
                                                    return m.translate(l.a$jscomp$29, l.b$jscomp$16);
                                                };
                                            }(a)), e += 2;
                                    }
                                    return this.compiledGlyphs[b] = function(l, m) {
                                        d[0](l);
                                        d[1](l);
                                        l.scale(m, -m);
                                        m = 2;
                                        for(var n = d.length; m < n; m++)d[m](l);
                                    };
                                };
                                return g;
                            }(), Je = function() {
                                function g(a) {
                                    this.__enableHWA = void 0 === a.enableHWA ? !1 : a.enableHWA;
                                }
                                var f = g.prototype;
                                f.create = function(a, b) {
                                    if (0 >= a || 0 >= b) throw Error("Invalid canvas size");
                                    a = this._createCanvas(a, b);
                                    return {
                                        canvas: a,
                                        context: a.getContext("2d", {
                                            willReadFrequently: !this.__enableHWA
                                        })
                                    };
                                };
                                f.reset = function(a, b, c) {
                                    if (!a.canvas) throw Error("Canvas is not specified");
                                    if (0 >= b || 0 >= c) throw Error("Invalid canvas size");
                                    a.canvas.width = b;
                                    a.canvas.height = c;
                                };
                                f.destroy = function(a) {
                                    if (!a.canvas) throw Error("Canvas is not specified");
                                    a.canvas.width = 0;
                                    a.canvas.height = 0;
                                    a.canvas = null;
                                    a.context = null;
                                };
                                f._createCanvas = function() {
                                    da("Abstract method `_createCanvas` called.");
                                };
                                return g;
                            }(), vg = function(g) {
                                function f(a) {
                                    var b = void 0 === a.ownerDocument ? globalThis.document : a.ownerDocument;
                                    a = g.call(this, {
                                        enableHWA: void 0 === a.enableHWA ? !1 : a.enableHWA
                                    }) || this;
                                    a._document = b;
                                    return a;
                                }
                                tf(f, g);
                                f.prototype._createCanvas = function(a, b) {
                                    var c = this._document.createElement("canvas");
                                    c.width = a;
                                    c.height = b;
                                    return c;
                                };
                                return f;
                            }(Je), Ke = function() {
                                function g(a) {
                                    var b = void 0 === a.isCompressed ? !0 : a.isCompressed;
                                    this.baseUrl = void 0 === a.baseUrl ? null : a.baseUrl;
                                    this.isCompressed = b;
                                }
                                var f = g.prototype;
                                f.fetch = function() {
                                    var a = cc(function d(c) {
                                        var e = this, h, k, l, m;
                                        return p.generator.createGenerator(d, function(n) {
                                            h = e;
                                            k = c;
                                            l = k.name;
                                            if (!e.baseUrl) throw Error("Ensure that the `cMapUrl` and `cMapPacked` API parameters are provided.");
                                            if (!l) throw Error("CMap name must be specified.");
                                            m = e.baseUrl + l + (e.isCompressed ? ".bcmap" : "");
                                            return n.return(e._fetch(m).then(function(q) {
                                                return {
                                                    cMapData: q,
                                                    isCompressed: h.isCompressed
                                                };
                                            }).catch(function() {
                                                throw Error("Unable to load " + (h.isCompressed ? "binary " : "") + "CMap at: " + m);
                                            }));
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f._fetch = function() {
                                    var a = cc(function c() {
                                        return p.generator.createGenerator(c, function(d) {
                                            da("Abstract method `_fetch` called.");
                                            d.jumpToEnd();
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                return g;
                            }(), ae = function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                uf(f, g);
                                f.prototype._fetch = function() {
                                    var a = cc(function d(c) {
                                        var e = this, h;
                                        return p.generator.createGenerator(d, function(k) {
                                            if (1 == k.nextAddress) return k.yield(xb(c, e.isCompressed ? "arraybuffer" : "text"), 2);
                                            h = k.yieldResult;
                                            return k.return(h instanceof ArrayBuffer ? new Uint8Array(h) : Va(h));
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                return f;
                            }(Ke);
                            F(4520);
                            var Le = function() {
                                function g() {}
                                var f = g.prototype;
                                f.addFilter = function() {
                                    return "none";
                                };
                                f.addHCMFilter = function() {
                                    return "none";
                                };
                                f.addAlphaFilter = function() {
                                    return "none";
                                };
                                f.addLuminosityFilter = function() {
                                    return "none";
                                };
                                f.addHighlightHCMFilter = function() {
                                    return "none";
                                };
                                f.destroy = function() {};
                                return g;
                            }(), wg = function(g) {
                                function f(b) {
                                    var c = b.docId, d = void 0 === b.ownerDocument ? globalThis.document : b.ownerDocument;
                                    b = g.call(this) || this;
                                    b.__baseUrl = void 0;
                                    b.___cache = void 0;
                                    b.___defs = void 0;
                                    b.___hcmCache = void 0;
                                    b.__id = 0;
                                    b.__docId = c;
                                    b.__document = d;
                                    return b;
                                }
                                wf(f, g);
                                var a = f.prototype;
                                a.__createTables = function(b) {
                                    if (1 === b.length) {
                                        b = b[0];
                                        for(var c = Array(256), d = 0; 256 > d; d++)c[d] = b[d] / 255;
                                        b = c.join(",");
                                        return [
                                            b,
                                            b,
                                            b
                                        ];
                                    }
                                    d = p.makeIterator(b);
                                    b = d.next().value;
                                    c = d.next().value;
                                    d = d.next().value;
                                    for(var e = Array(256), h = Array(256), k = Array(256), l = 0; 256 > l; l++)e[l] = b[l] / 255, h[l] = c[l] / 255, k[l] = d[l] / 255;
                                    return [
                                        e.join(","),
                                        h.join(","),
                                        k.join(",")
                                    ];
                                };
                                a.__createUrl = function(b) {
                                    if (void 0 === this.__baseUrl) {
                                        this.__baseUrl = "";
                                        var c = this.__document.URL;
                                        c !== this.__document.baseURI && (zb(c) ? R('#createUrl: ignore "data:"-URL for performance reasons.') : this.__baseUrl = c.split("#", 1)[0]);
                                    }
                                    return "url(" + this.__baseUrl + "#" + b + ")";
                                };
                                a.addFilter = function(b) {
                                    if (!b) return "none";
                                    var c = this.__cache.get(b);
                                    if (c) return c;
                                    var d = p.makeIterator(this.__createTables(b)), e = d.next().value, h = d.next().value;
                                    d = d.next().value;
                                    var k = 1 === b.length ? e : "" + e + h + d;
                                    if (c = this.__cache.get(k)) return this.__cache.set(b, c), c;
                                    var l = "g_" + this.__docId + "_transfer_map_" + this.__id++;
                                    c = this.__createUrl(l);
                                    this.__cache.set(b, c);
                                    this.__cache.set(k, c);
                                    b = this.__createFilter(l);
                                    this.__addTransferMapConversion(e, h, d, b);
                                    return c;
                                };
                                a.addHCMFilter = function(b, c) {
                                    function d(q, r) {
                                        var t = m[q] / 255;
                                        q = n[q] / 255;
                                        for(var u = Array(r + 1), v = 0; v <= r; v++)u[v] = t + v / r * (q - t);
                                        return u.join(",");
                                    }
                                    var e, h = b + "-" + c, k = this.__hcmCache.get("base");
                                    if ((null == (e = k) ? void 0 : e.key) === h) return k.url;
                                    if (k) {
                                        var l;
                                        null == (l = k.filter) || l.remove();
                                        k.key = h;
                                        k.url = "none";
                                        k.filter = null;
                                    } else k = {
                                        key: h,
                                        url: "none",
                                        filter: null
                                    }, this.__hcmCache.set("base", k);
                                    if (!b || !c) return k.url;
                                    var m = this.__getRGB(b);
                                    b = fa.makeHexColor.apply(fa, p.arrayFromIterable(m));
                                    var n = this.__getRGB(c);
                                    c = fa.makeHexColor.apply(fa, p.arrayFromIterable(n));
                                    this.__defs.style.color = "";
                                    if ("#000000" === b && "#ffffff" === c || b === c) return k.url;
                                    b = Array(256);
                                    for(c = 0; 255 >= c; c++)e = c / 255, b[c] = .03928 >= e ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
                                    b = b.join(",");
                                    c = "g_" + this.__docId + "_hcm_filter";
                                    e = k.filter = this.__createFilter(c);
                                    this.__addTransferMapConversion(b, b, b, e);
                                    this.__addGrayConversion(e);
                                    this.__addTransferMapConversion(d(0, 5), d(1, 5), d(2, 5), e);
                                    k.url = this.__createUrl(c);
                                    return k.url;
                                };
                                a.addAlphaFilter = function(b) {
                                    var c = this.__cache.get(b);
                                    if (c) return c;
                                    var d = p.makeIterator(this.__createTables([
                                        b
                                    ])).next().value, e = "alpha_" + d;
                                    if (c = this.__cache.get(e)) return this.__cache.set(b, c), c;
                                    var h = "g_" + this.__docId + "_alpha_map_" + this.__id++;
                                    c = this.__createUrl(h);
                                    this.__cache.set(b, c);
                                    this.__cache.set(e, c);
                                    b = this.__createFilter(h);
                                    this.__addTransferMapAlphaConversion(d, b);
                                    return c;
                                };
                                a.addLuminosityFilter = function(b) {
                                    var c = this.__cache.get(b || "luminosity");
                                    if (c) return c;
                                    if (b) {
                                        var d = p.makeIterator(this.__createTables([
                                            b
                                        ])).next().value;
                                        var e = "luminosity_" + d;
                                    } else e = "luminosity";
                                    if (c = this.__cache.get(e)) return this.__cache.set(b, c), c;
                                    var h = "g_" + this.__docId + "_luminosity_map_" + this.__id++;
                                    c = this.__createUrl(h);
                                    this.__cache.set(b, c);
                                    this.__cache.set(e, c);
                                    e = this.__createFilter(h);
                                    this.__addLuminosityConversion(e);
                                    b && this.__addTransferMapAlphaConversion(d, e);
                                    return c;
                                };
                                a.addHighlightHCMFilter = function(b, c, d, e, h) {
                                    function k(u, v, w) {
                                        var x = Array(256), B = (t - r) / w, z = u / 255;
                                        u = (v - u) / (255 * w);
                                        for(var C = v = 0; C <= w; C++){
                                            for(var D = Math.round(r + C * B), H = z + C * u; v <= D; v++)x[v] = H;
                                            v = D + 1;
                                        }
                                        for(w = v; 256 > w; w++)x[w] = x[v - 1];
                                        return x.join(",");
                                    }
                                    var l, m = c + "-" + d + "-" + e + "-" + h, n = this.__hcmCache.get(b);
                                    if ((null == (l = n) ? void 0 : l.key) === m) return n.url;
                                    if (n) {
                                        var q;
                                        null == (q = n.filter) || q.remove();
                                        n.key = m;
                                        n.url = "none";
                                        n.filter = null;
                                    } else n = {
                                        key: m,
                                        url: "none",
                                        filter: null
                                    }, this.__hcmCache.set(b, n);
                                    if (!c || !d) return n.url;
                                    d = p.makeIterator([
                                        c,
                                        d
                                    ].map(this.__getRGB.bind(this)));
                                    c = d.next().value;
                                    d = d.next().value;
                                    var r = Math.round(.2126 * c[0] + .7152 * c[1] + .0722 * c[2]), t = Math.round(.2126 * d[0] + .7152 * d[1] + .0722 * d[2]);
                                    h = p.makeIterator([
                                        e,
                                        h
                                    ].map(this.__getRGB.bind(this)));
                                    e = h.next().value;
                                    h = h.next().value;
                                    t < r && (h = p.makeIterator([
                                        t,
                                        r,
                                        h,
                                        e
                                    ]), r = h.next().value, t = h.next().value, e = h.next().value, h = h.next().value);
                                    this.__defs.style.color = "";
                                    b = "g_" + this.__docId + "_hcm_" + b + "_filter";
                                    c = n.filter = this.__createFilter(b);
                                    this.__addGrayConversion(c);
                                    this.__addTransferMapConversion(k(e[0], h[0], 5), k(e[1], h[1], 5), k(e[2], h[2], 5), c);
                                    n.url = this.__createUrl(b);
                                    return n.url;
                                };
                                a.destroy = function(b) {
                                    void 0 === b && (b = !1);
                                    b && 0 !== this.__hcmCache.size || (this.___defs && (this.___defs.parentNode.parentNode.remove(), this.___defs = null), this.___cache && (this.___cache.clear(), this.___cache = null), this.__id = 0);
                                };
                                a.__addLuminosityConversion = function(b) {
                                    var c = this.__document.createElementNS("http://www.w3.org/2000/svg", "feColorMatrix");
                                    c.setAttribute("type", "matrix");
                                    c.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
                                    b.append(c);
                                };
                                a.__addGrayConversion = function(b) {
                                    var c = this.__document.createElementNS("http://www.w3.org/2000/svg", "feColorMatrix");
                                    c.setAttribute("type", "matrix");
                                    c.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                                    b.append(c);
                                };
                                a.__createFilter = function(b) {
                                    var c = this.__document.createElementNS("http://www.w3.org/2000/svg", "filter");
                                    c.setAttribute("color-interpolation-filters", "sRGB");
                                    c.setAttribute("id", b);
                                    this.__defs.append(c);
                                    return c;
                                };
                                a.__appendFeFunc = function(b, c, d) {
                                    c = this.__document.createElementNS("http://www.w3.org/2000/svg", c);
                                    c.setAttribute("type", "discrete");
                                    c.setAttribute("tableValues", d);
                                    b.append(c);
                                };
                                a.__addTransferMapConversion = function(b, c, d, e) {
                                    var h = this.__document.createElementNS("http://www.w3.org/2000/svg", "feComponentTransfer");
                                    e.append(h);
                                    this.__appendFeFunc(h, "feFuncR", b);
                                    this.__appendFeFunc(h, "feFuncG", c);
                                    this.__appendFeFunc(h, "feFuncB", d);
                                };
                                a.__addTransferMapAlphaConversion = function(b, c) {
                                    var d = this.__document.createElementNS("http://www.w3.org/2000/svg", "feComponentTransfer");
                                    c.append(d);
                                    this.__appendFeFunc(d, "feFuncA", b);
                                };
                                a.__getRGB = function(b) {
                                    this.__defs.style.color = b;
                                    return Xb(getComputedStyle(this.__defs).getPropertyValue("color"));
                                };
                                return vf(f, [
                                    {
                                        key: "__cache",
                                        get: function() {
                                            return this.___cache || (this.___cache = new Map);
                                        }
                                    },
                                    {
                                        key: "__hcmCache",
                                        get: function() {
                                            return this.___hcmCache || (this.___hcmCache = new Map);
                                        }
                                    },
                                    {
                                        key: "__defs",
                                        get: function() {
                                            if (!this.___defs) {
                                                var b = this.__document.createElement("div"), c = b.style;
                                                c.visibility = "hidden";
                                                c.contain = "strict";
                                                c.width = c.height = 0;
                                                c.position = "absolute";
                                                c.top = c.left = 0;
                                                c.zIndex = -1;
                                                c = this.__document.createElementNS("http://www.w3.org/2000/svg", "svg");
                                                c.setAttribute("width", 0);
                                                c.setAttribute("height", 0);
                                                this.___defs = this.__document.createElementNS("http://www.w3.org/2000/svg", "defs");
                                                b.append(c);
                                                c.append(this.___defs);
                                                this.__document.body.append(b);
                                            }
                                            return this.___defs;
                                        }
                                    }
                                ]);
                            }(Le), Me = function() {
                                function g(a) {
                                    this.baseUrl = void 0 === a.baseUrl ? null : a.baseUrl;
                                }
                                var f = g.prototype;
                                f.fetch = function() {
                                    var a = fc(function d(c) {
                                        var e, h, k = this, l;
                                        return p.generator.createGenerator(d, function(m) {
                                            e = c;
                                            h = e.filename;
                                            if (!k.baseUrl) throw Error("Ensure that the `standardFontDataUrl` API parameter is provided.");
                                            if (!h) throw Error("Font filename must be specified.");
                                            l = "" + k.baseUrl + h;
                                            return m.return(k._fetch(l).catch(function() {
                                                throw Error("Unable to load font data at: " + l);
                                            }));
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f._fetch = function() {
                                    var a = fc(function c() {
                                        return p.generator.createGenerator(c, function(d) {
                                            da("Abstract method `_fetch` called.");
                                            d.jumpToEnd();
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                return g;
                            }(), be = function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                xf(f, g);
                                f.prototype._fetch = function() {
                                    var a = fc(function d(c) {
                                        var e;
                                        return p.generator.createGenerator(d, function(h) {
                                            if (1 == h.nextAddress) return h.yield(xb(c, "arraybuffer"), 2);
                                            e = h.yieldResult;
                                            return h.return(new Uint8Array(e));
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                return f;
                            }(Me), bb = function() {
                                function g() {}
                                g.get = function() {};
                                return yf(g, null, [
                                    {
                                        key: "promise",
                                        get: function() {
                                            return (void 0).promise;
                                        }
                                    }
                                ]);
                            }();
                            (function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                Db(f, g);
                                return f;
                            })(Le);
                            (function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                Db(f, g);
                                f.prototype._createCanvas = function(a, b) {
                                    return bb.get("canvas").createCanvas(a, b);
                                };
                                return f;
                            })(Je);
                            (function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                Db(f, g);
                                f.prototype._fetch = function() {
                                    var a = hc(function d(c) {
                                        return p.generator.createGenerator(d, function(e) {
                                            return e.return(wd(c));
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                return f;
                            })(Ke);
                            (function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                Db(f, g);
                                f.prototype._fetch = function() {
                                    var a = hc(function d(c) {
                                        return p.generator.createGenerator(d, function(e) {
                                            return e.return(wd(c));
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                return f;
                            })(Me);
                            F(5477);
                            var Sc = function() {
                                function g() {}
                                g.prototype.getPattern = function() {
                                    da("Abstract method `getPattern` called.");
                                };
                                return g;
                            }(), xg = function(g) {
                                function f(b) {
                                    var c = g.call(this) || this;
                                    c._type = b[1];
                                    c._bbox = b[2];
                                    c._colorStops = b[3];
                                    c._p0 = b[4];
                                    c._p1 = b[5];
                                    c._r0 = b[6];
                                    c._r1 = b[7];
                                    c.matrix = null;
                                    return c;
                                }
                                jc(f, g);
                                var a = f.prototype;
                                a._createGradient = function(b) {
                                    var c;
                                    "axial" === this._type ? c = b.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : "radial" === this._type && (c = b.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
                                    b = p.makeIterator(this._colorStops);
                                    for(var d = b.next(); !d.done; d = b.next())d = d.value, c.addColorStop(d[0], d[1]);
                                    return c;
                                };
                                a.getPattern = function(b, c, d, e) {
                                    if ("Stroke" === e || "Fill" === e) {
                                        e = c.current.getClippedPathBoundingBox(e, Ba(b)) || [
                                            0,
                                            0,
                                            0,
                                            0
                                        ];
                                        var h = c.cachedCanvases.getCanvas("pattern", Math.ceil(e[2] - e[0]) || 1, Math.ceil(e[3] - e[1]) || 1), k = h.context;
                                        k.clearRect(0, 0, k.canvas.width, k.canvas.height);
                                        k.beginPath();
                                        k.rect(0, 0, k.canvas.width, k.canvas.height);
                                        k.translate(-e[0], -e[1]);
                                        d = fa.transform(d, [
                                            1,
                                            0,
                                            0,
                                            1,
                                            e[0],
                                            e[1]
                                        ]);
                                        k.transform.apply(k, p.arrayFromIterable(c.baseTransform));
                                        this.matrix && k.transform.apply(k, p.arrayFromIterable(this.matrix));
                                        lc(k, this._bbox);
                                        k.fillStyle = this._createGradient(k);
                                        k.fill();
                                        b = b.createPattern(h.canvas, "no-repeat");
                                        d = new DOMMatrix(d);
                                        b.setTransform(d);
                                    } else lc(b, this._bbox), b = this._createGradient(b);
                                    return b;
                                };
                                return f;
                            }(Sc), yg = function(g) {
                                function f(b) {
                                    var c = g.call(this) || this;
                                    c._coords = b[2];
                                    c._colors = b[3];
                                    c._figures = b[4];
                                    c._bounds = b[5];
                                    c._bbox = b[7];
                                    c._background = b[8];
                                    c.matrix = null;
                                    return c;
                                }
                                jc(f, g);
                                var a = f.prototype;
                                a._createMeshCanvas = function(b, c, d) {
                                    var e = Math.floor(this._bounds[0]), h = Math.floor(this._bounds[1]), k = Math.ceil(this._bounds[2]) - e, l = Math.ceil(this._bounds[3]) - h, m = Math.min(Math.ceil(Math.abs(k * b[0] * 1.1)), 3E3), n = Math.min(Math.ceil(Math.abs(l * b[1] * 1.1)), 3E3);
                                    k /= m;
                                    l /= n;
                                    b = {
                                        coords: this._coords,
                                        colors: this._colors,
                                        offsetX: -e,
                                        offsetY: -h,
                                        scaleX: 1 / k,
                                        scaleY: 1 / l
                                    };
                                    d = d.getCanvas("mesh", m + 4, n + 4);
                                    var q = d.context;
                                    m = q.createImageData(m, n);
                                    if (c) {
                                        n = m.data;
                                        for(var r = 0, t = n.length; r < t; r += 4)n[r] = c[0], n[r + 1] = c[1], n[r + 2] = c[2], n[r + 3] = 255;
                                    }
                                    c = p.makeIterator(this._figures);
                                    for(n = c.next(); !n.done; n = c.next())switch(t = n.value, n = t.coords, r = t.colors, t.type){
                                        case "lattice":
                                            var u = t.verticesPerRow;
                                            var v = Math.floor(n.length / u) - 1, w = u - 1;
                                            for(t = 0; t < v; t++)for(var x = t * u, B = 0; B < w; B++, x++)mc(m, b, n[x], n[x + 1], n[x + u], r[x], r[x + 1], r[x + u]), mc(m, b, n[x + u + 1], n[x + 1], n[x + u], r[x + u + 1], r[x + 1], r[x + u]);
                                            break;
                                        case "triangles":
                                            t = 0;
                                            for(u = n.length; t < u; t += 3)mc(m, b, n[t], n[t + 1], n[t + 2], r[t], r[t + 1], r[t + 2]);
                                            break;
                                        default:
                                            throw Error("illegal figure");
                                    }
                                    q.putImageData(m, 2, 2);
                                    return {
                                        canvas: d.canvas,
                                        offsetX: e - 2 * k,
                                        offsetY: h - 2 * l,
                                        scaleX: k,
                                        scaleY: l
                                    };
                                };
                                a.getPattern = function(b, c, d, e) {
                                    lc(b, this._bbox);
                                    if ("Shading" === e) d = fa.singularValueDecompose2dScale(Ba(b));
                                    else if (d = fa.singularValueDecompose2dScale(c.baseTransform), this.matrix) {
                                        var h = fa.singularValueDecompose2dScale(this.matrix);
                                        d = [
                                            d[0] * h[0],
                                            d[1] * h[1]
                                        ];
                                    }
                                    d = this._createMeshCanvas(d, "Shading" === e ? null : this._background, c.cachedCanvases);
                                    "Shading" !== e && (b.setTransform.apply(b, p.arrayFromIterable(c.baseTransform)), this.matrix && b.transform.apply(b, p.arrayFromIterable(this.matrix)));
                                    b.translate(d.offsetX, d.offsetY);
                                    b.scale(d.scaleX, d.scaleY);
                                    return b.createPattern(d.canvas, "no-repeat");
                                };
                                return f;
                            }(Sc), zg = function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                jc(f, g);
                                f.prototype.getPattern = function() {
                                    return "hotpink";
                                };
                                return f;
                            }(Sc), Ne = function() {
                                function g(a, b, c, d, e) {
                                    this.operatorList = a[2];
                                    this.matrix = a[3];
                                    this.bbox = a[4];
                                    this.xstep = a[5];
                                    this.ystep = a[6];
                                    this.paintType = a[7];
                                    this.tilingType = a[8];
                                    this.color = b;
                                    this.ctx = c;
                                    this.canvasGraphicsFactory = d;
                                    this.baseTransform = e;
                                }
                                var f = g.prototype;
                                f.createPatternCanvas = function(a) {
                                    var b = this.bbox, c = this.operatorList, d = this.paintType, e = this.tilingType, h = this.color, k = this.canvasGraphicsFactory, l = this.xstep, m = this.ystep;
                                    l = Math.abs(l);
                                    m = Math.abs(m);
                                    W("TilingType: " + e);
                                    e = b[0];
                                    var n = b[1], q = b[2], r = b[3], t = q - e;
                                    b = r - n;
                                    var u = fa.singularValueDecompose2dScale(this.matrix), v = fa.singularValueDecompose2dScale(this.baseTransform), w = u[0] * v[0], x = u[1] * v[1], B = t, z = b;
                                    u = v = !1;
                                    var C = Math.ceil(m * x), D = Math.ceil(b * x);
                                    Math.ceil(l * w) >= Math.ceil(t * w) ? B = l : v = !0;
                                    C >= D ? z = m : u = !0;
                                    C = this.getSizeAndScale(B, this.ctx.canvas.width, w);
                                    D = this.getSizeAndScale(z, this.ctx.canvas.height, x);
                                    var H = a.cachedCanvases.getCanvas("pattern", C.size, D.size), J = H.context;
                                    k = k.createCanvasGraphics(J);
                                    k.groupLevel = a.groupLevel;
                                    this.setFillAndStrokeStyleToContext(k, d, h);
                                    J.translate(-C.scale * e, -D.scale * n);
                                    k.transform(C.scale, 0, 0, D.scale, 0, 0);
                                    J.save();
                                    this.clipBbox(k, e, n, q, r);
                                    k.baseTransform = Ba(k.ctx);
                                    k.executeOperatorList(c);
                                    k.endDrawing();
                                    J.restore();
                                    if (v || u) {
                                        c = H.canvas;
                                        v && (B = l);
                                        u && (z = m);
                                        d = this.getSizeAndScale(B, this.ctx.canvas.width, w);
                                        h = this.getSizeAndScale(z, this.ctx.canvas.height, x);
                                        k = d.size;
                                        q = h.size;
                                        a = a.cachedCanvases.getCanvas("pattern-workaround", k, q);
                                        w = a.context;
                                        l = v ? Math.floor(t / l) : 0;
                                        m = u ? Math.floor(b / m) : 0;
                                        for(b = 0; b <= l; b++)for(t = 0; t <= m; t++)w.drawImage(c, k * b, q * t, k, q, 0, 0, k, q);
                                        return {
                                            canvas: a.canvas,
                                            scaleX: d.scale,
                                            scaleY: h.scale,
                                            offsetX: e,
                                            offsetY: n
                                        };
                                    }
                                    return {
                                        canvas: H.canvas,
                                        scaleX: C.scale,
                                        scaleY: D.scale,
                                        offsetX: e,
                                        offsetY: n
                                    };
                                };
                                f.getSizeAndScale = function(a, b, c) {
                                    b = Math.max(g.MAX_PATTERN_SIZE, b);
                                    var d = Math.ceil(a * c);
                                    d >= b ? d = b : c = d / a;
                                    return {
                                        scale: c,
                                        size: d
                                    };
                                };
                                f.clipBbox = function(a, b, c, d, e) {
                                    a.ctx.rect(b, c, d - b, e - c);
                                    a.current.updateRectMinMax(Ba(a.ctx), [
                                        b,
                                        c,
                                        d,
                                        e
                                    ]);
                                    a.clip();
                                    a.endPath();
                                };
                                f.setFillAndStrokeStyleToContext = function(a, b, c) {
                                    var d = a.ctx;
                                    a = a.current;
                                    switch(b){
                                        case 1:
                                            b = this.ctx;
                                            d.fillStyle = b.fillStyle;
                                            d.strokeStyle = b.strokeStyle;
                                            a.fillColor = b.fillStyle;
                                            a.strokeColor = b.strokeStyle;
                                            break;
                                        case 2:
                                            b = fa.makeHexColor(c[0], c[1], c[2]);
                                            d.fillStyle = b;
                                            d.strokeStyle = b;
                                            a.fillColor = b;
                                            a.strokeColor = b;
                                            break;
                                        default:
                                            throw new ng("Unsupported paint type: " + b);
                                    }
                                };
                                f.getPattern = function(a, b, c, d) {
                                    "Shading" !== d && (c = fa.transform(c, b.baseTransform), this.matrix && (c = fa.transform(c, this.matrix)));
                                    b = this.createPatternCanvas(b);
                                    d = new DOMMatrix(c);
                                    d = d.translate(b.offsetX, b.offsetY);
                                    d = d.scale(1 / b.scaleX, 1 / b.scaleY);
                                    a = a.createPattern(b.canvas, "repeat");
                                    a.setTransform(d);
                                    return a;
                                };
                                return g;
                            }();
                            Ne.MAX_PATTERN_SIZE = 3E3;
                            var Ag = function() {
                                function g(a) {
                                    this.canvasFactory = a;
                                    this.cache = Object.create(null);
                                }
                                var f = g.prototype;
                                f.getCanvas = function(a, b, c) {
                                    if (void 0 !== this.cache[a]) {
                                        var d = this.cache[a];
                                        this.canvasFactory.reset(d, b, c);
                                    } else d = this.canvasFactory.create(b, c), this.cache[a] = d;
                                    return d;
                                };
                                f.delete = function(a) {
                                    delete this.cache[a];
                                };
                                f.clear = function() {
                                    for(var a in this.cache)this.canvasFactory.destroy(this.cache[a]), delete this.cache[a];
                                };
                                return g;
                            }(), Oe = function() {
                                function g(a, b) {
                                    this.alphaIsShape = !1;
                                    this.fontSize = 0;
                                    this.fontSizeScale = 1;
                                    this.textMatrix = Ce;
                                    this.textMatrixScale = 1;
                                    this.fontMatrix = Oc;
                                    this.wordSpacing = this.charSpacing = this.lineY = this.lineX = this.y = this.x = this.leading = 0;
                                    this.textHScale = 1;
                                    this.textRise = this.textRenderingMode = 0;
                                    this.strokeColor = this.fillColor = "#000000";
                                    this.patternFill = !1;
                                    this.lineWidth = this.strokeAlpha = this.fillAlpha = 1;
                                    this.activeSMask = null;
                                    this.transferMaps = "none";
                                    this.startNewPathAndClipBox([
                                        0,
                                        0,
                                        a,
                                        b
                                    ]);
                                }
                                var f = g.prototype;
                                f.clone = function() {
                                    var a = Object.create(this);
                                    a.clipBox = this.clipBox.slice();
                                    return a;
                                };
                                f.setCurrentPoint = function(a, b) {
                                    this.x = a;
                                    this.y = b;
                                };
                                f.updatePathMinMax = function(a, b, c) {
                                    a = p.makeIterator(fa.applyTransform([
                                        b,
                                        c
                                    ], a));
                                    b = a.next().value;
                                    c = a.next().value;
                                    this.minX = Math.min(this.minX, b);
                                    this.minY = Math.min(this.minY, c);
                                    this.maxX = Math.max(this.maxX, b);
                                    this.maxY = Math.max(this.maxY, c);
                                };
                                f.updateRectMinMax = function(a, b) {
                                    var c = fa.applyTransform(b, a), d = fa.applyTransform(b.slice(2), a), e = fa.applyTransform([
                                        b[0],
                                        b[3]
                                    ], a);
                                    a = fa.applyTransform([
                                        b[2],
                                        b[1]
                                    ], a);
                                    this.minX = Math.min(this.minX, c[0], d[0], e[0], a[0]);
                                    this.minY = Math.min(this.minY, c[1], d[1], e[1], a[1]);
                                    this.maxX = Math.max(this.maxX, c[0], d[0], e[0], a[0]);
                                    this.maxY = Math.max(this.maxY, c[1], d[1], e[1], a[1]);
                                };
                                f.updateScalingPathMinMax = function(a, b) {
                                    fa.scaleMinMax(a, b);
                                    this.minX = Math.min(this.minX, b[0]);
                                    this.minY = Math.min(this.minY, b[1]);
                                    this.maxX = Math.max(this.maxX, b[2]);
                                    this.maxY = Math.max(this.maxY, b[3]);
                                };
                                f.updateCurvePathMinMax = function(a, b, c, d, e, h, k, l, m, n) {
                                    b = fa.bezierBoundingBox(b, c, d, e, h, k, l, m, n);
                                    n || this.updateRectMinMax(a, b);
                                };
                                f.getPathBoundingBox = function(a, b) {
                                    void 0 === a && (a = "Fill");
                                    void 0 === b && (b = null);
                                    var c = [
                                        this.minX,
                                        this.minY,
                                        this.maxX,
                                        this.maxY
                                    ];
                                    "Stroke" === a && (b || da("Stroke bounding box must include transform."), b = fa.singularValueDecompose2dScale(b), a = b[0] * this.lineWidth / 2, b = b[1] * this.lineWidth / 2, c[0] -= a, c[1] -= b, c[2] += a, c[3] += b);
                                    return c;
                                };
                                f.updateClipFromPath = function() {
                                    var a = fa.intersect(this.clipBox, this.getPathBoundingBox());
                                    this.startNewPathAndClipBox(a || [
                                        0,
                                        0,
                                        0,
                                        0
                                    ]);
                                };
                                f.isEmptyClip = function() {
                                    return Infinity === this.minX;
                                };
                                f.startNewPathAndClipBox = function(a) {
                                    this.clipBox = a;
                                    this.minY = this.minX = Infinity;
                                    this.maxY = this.maxX = 0;
                                };
                                f.getClippedPathBoundingBox = function(a, b) {
                                    void 0 === a && (a = "Fill");
                                    void 0 === b && (b = null);
                                    return fa.intersect(this.clipBox, this.getPathBoundingBox(a, b));
                                };
                                return g;
                            }(), Bg = [
                                "butt",
                                "round",
                                "square"
                            ], Cg = [
                                "miter",
                                "round",
                                "bevel"
                            ], Dg = {}, Pe = {}, Nb = function() {
                                function g(a, b, c, d, e, h, k, l) {
                                    var m = h.optionalContentConfig;
                                    h = void 0 === h.markedContentStack ? null : h.markedContentStack;
                                    this.ctx = a;
                                    this.current = new Oe(this.ctx.canvas.width, this.ctx.canvas.height);
                                    this.stateStack = [];
                                    this.pendingClip = null;
                                    this.pendingEOFill = !1;
                                    this.xobjs = this.res = null;
                                    this.commonObjs = b;
                                    this.objs = c;
                                    this.canvasFactory = d;
                                    this.filterFactory = e;
                                    this.groupStack = [];
                                    this.baseTransform = this.processingType3 = null;
                                    this.baseTransformStack = [];
                                    this.groupLevel = 0;
                                    this.smaskStack = [];
                                    this.smaskCounter = 0;
                                    this.suspendedCtx = this.tempSMask = null;
                                    this.contentVisible = !0;
                                    this.markedContentStack = h || [];
                                    this.optionalContentConfig = m;
                                    this.cachedCanvases = new Ag(this.canvasFactory);
                                    this.cachedPatterns = new Map;
                                    this.annotationCanvasMap = k;
                                    this.outputScaleY = this.outputScaleX = this.viewportScale = 1;
                                    this.pageColors = l;
                                    this._cachedScaleForStroking = [
                                        -1,
                                        0
                                    ];
                                    this._cachedGetSinglePixelWidth = null;
                                    this._cachedBitmapsMap = new Map;
                                }
                                var f = g.prototype;
                                f.getObject = function(a, b) {
                                    void 0 === b && (b = null);
                                    return "string" === typeof a ? a.startsWith("g_") ? this.commonObjs.get(a) : this.objs.get(a) : b;
                                };
                                f.beginDrawing = function(a) {
                                    var b = a.transform, c = a.viewport, d = void 0 === a.transparency ? !1 : a.transparency, e = this.ctx.canvas.width, h = this.ctx.canvas.height, k = this.ctx.fillStyle;
                                    this.ctx.fillStyle = (void 0 === a.background ? null : a.background) || "#ffffff";
                                    this.ctx.fillRect(0, 0, e, h);
                                    this.ctx.fillStyle = k;
                                    d && (a = this.cachedCanvases.getCanvas("transparent", e, h), this.compositeCtx = this.ctx, this.transparentCanvas = a.canvas, this.ctx = a.context, this.ctx.save(), this.ctx.transform.apply(this.ctx, p.arrayFromIterable(Ba(this.compositeCtx))));
                                    this.ctx.save();
                                    Gb(this.ctx);
                                    b && (this.ctx.transform.apply(this.ctx, p.arrayFromIterable(b)), this.outputScaleX = b[0], this.outputScaleY = b[0]);
                                    this.ctx.transform.apply(this.ctx, p.arrayFromIterable(c.transform));
                                    this.viewportScale = c.scale;
                                    this.baseTransform = Ba(this.ctx);
                                };
                                f.executeOperatorList = function(a, b, c, d) {
                                    var e = a.argsArray;
                                    a = a.fnArray;
                                    b = b || 0;
                                    var h = e.length;
                                    if (h === b) return b;
                                    for(var k = 10 < h - b && "function" === typeof c, l = k ? Date.now() + 15 : 0, m = 0, n = this.commonObjs, q = this.objs, r;;){
                                        if (void 0 !== d && b === d.nextBreakPoint) return d.breakIt(b, c), b;
                                        r = a[b];
                                        if (r !== Pa.dependency) this[r].apply(this, e[b]);
                                        else {
                                            r = p.makeIterator(e[b]);
                                            for(var t = r.next(); !t.done; t = r.next()){
                                                t = t.value;
                                                var u = t.startsWith("g_") ? n : q;
                                                if (!u.has(t)) return u.get(t, c), b;
                                            }
                                        }
                                        b++;
                                        if (b === h) return b;
                                        if (k && 10 < ++m) {
                                            if (Date.now() > l) return c(), b;
                                            m = 0;
                                        }
                                    }
                                };
                                f.__restoreInitialState = function() {
                                    for(; this.stateStack.length || this.inSMaskMode;)this.restore();
                                    this.current.activeSMask = null;
                                    this.ctx.restore();
                                    this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
                                };
                                f.endDrawing = function() {
                                    this.__restoreInitialState();
                                    this.cachedCanvases.clear();
                                    this.cachedPatterns.clear();
                                    for(var a = p.makeIterator(this._cachedBitmapsMap.values()), b = a.next(); !b.done; b = a.next()){
                                        b = b.value;
                                        for(var c = p.makeIterator(b.values()), d = c.next(); !d.done; d = c.next())d = d.value, "undefined" !== typeof HTMLCanvasElement && d instanceof HTMLCanvasElement && (d.width = d.height = 0);
                                        b.clear();
                                    }
                                    this._cachedBitmapsMap.clear();
                                    this.__drawFilter();
                                };
                                f.__drawFilter = function() {
                                    if (this.pageColors) {
                                        var a = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                                        if ("none" !== a) {
                                            var b = this.ctx.filter;
                                            this.ctx.filter = a;
                                            this.ctx.drawImage(this.ctx.canvas, 0, 0);
                                            this.ctx.filter = b;
                                        }
                                    }
                                };
                                f._scaleImage = function(a, b) {
                                    var c, d, e = null != (c = a.width) ? c : a.displayWidth;
                                    c = null != (d = a.height) ? d : a.displayHeight;
                                    d = Math.max(Math.hypot(b[0], b[1]), 1);
                                    b = Math.max(Math.hypot(b[2], b[3]), 1);
                                    for(var h = "prescale1", k, l; 2 < d && 1 < e || 2 < b && 1 < c;){
                                        var m = e, n = c;
                                        2 < d && 1 < e && (m = 16384 <= e ? Math.floor(e / 2) - 1 || 1 : Math.ceil(e / 2), d /= e / m);
                                        2 < b && 1 < c && (n = 16384 <= c ? Math.floor(c / 2) - 1 || 1 : Math.ceil(c) / 2, b /= c / n);
                                        k = this.cachedCanvases.getCanvas(h, m, n);
                                        l = k.context;
                                        l.clearRect(0, 0, m, n);
                                        l.drawImage(a, 0, 0, e, c, 0, 0, m, n);
                                        a = k.canvas;
                                        e = m;
                                        c = n;
                                        h = "prescale1" === h ? "prescale2" : "prescale1";
                                    }
                                    return {
                                        img: a,
                                        paintWidth: e,
                                        paintHeight: c
                                    };
                                };
                                f._createMaskCanvas = function(a) {
                                    var b = this.ctx, c = a.width, d = a.height, e = this.current.fillColor, h = this.current.patternFill, k = Ba(b);
                                    if ((a.bitmap || a.data) && 1 < a.count) {
                                        var l = a.bitmap || a.data.buffer;
                                        var m = JSON.stringify(h ? k : [
                                            k.slice(0, 4),
                                            e
                                        ]);
                                        var n = this._cachedBitmapsMap.get(l);
                                        n || (n = new Map, this._cachedBitmapsMap.set(l, n));
                                        if ((l = n.get(m)) && !h) return {
                                            canvas: l,
                                            offsetX: Math.round(Math.min(k[0], k[2]) + k[4]),
                                            offsetY: Math.round(Math.min(k[1], k[3]) + k[5])
                                        };
                                    }
                                    if (!l) {
                                        var q = this.cachedCanvases.getCanvas("maskCanvas", c, d);
                                        zd(q.context, a);
                                    }
                                    var r = fa.transform(k, [
                                        1 / c,
                                        0,
                                        0,
                                        -1 / d,
                                        0,
                                        0
                                    ]);
                                    r = fa.transform(r, [
                                        1,
                                        0,
                                        0,
                                        1,
                                        0,
                                        -d
                                    ]);
                                    var t = p.makeIterator(fa.getAxialAlignedBoundingBox([
                                        0,
                                        0,
                                        c,
                                        d
                                    ], r));
                                    k = t.next().value;
                                    var u = t.next().value, v = t.next().value;
                                    t = t.next().value;
                                    v = this.cachedCanvases.getCanvas("fillCanvas", Math.round(v - k) || 1, Math.round(t - u) || 1);
                                    t = v.context;
                                    t.translate(-k, -u);
                                    t.transform.apply(t, p.arrayFromIterable(r));
                                    l || (l = this._scaleImage(q.canvas, Sa(t)), l = l.img, n && h && n.set(m, l));
                                    t.imageSmoothingEnabled = Ad(Ba(t), a.interpolate);
                                    Eb(t, l, 0, 0, l.width, l.height, 0, 0, c, d);
                                    t.globalCompositeOperation = "source-in";
                                    a = fa.transform(Sa(t), [
                                        1,
                                        0,
                                        0,
                                        1,
                                        -k,
                                        -u
                                    ]);
                                    t.fillStyle = h ? e.getPattern(b, this, a, "Fill") : e;
                                    t.fillRect(0, 0, c, d);
                                    n && !h && (this.cachedCanvases.delete("fillCanvas"), n.set(m, v.canvas));
                                    return {
                                        canvas: v.canvas,
                                        offsetX: Math.round(k),
                                        offsetY: Math.round(u)
                                    };
                                };
                                f.setLineWidth = function(a) {
                                    a !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1);
                                    this.current.lineWidth = a;
                                    this.ctx.lineWidth = a;
                                };
                                f.setLineCap = function(a) {
                                    this.ctx.lineCap = Bg[a];
                                };
                                f.setLineJoin = function(a) {
                                    this.ctx.lineJoin = Cg[a];
                                };
                                f.setMiterLimit = function(a) {
                                    this.ctx.miterLimit = a;
                                };
                                f.setDash = function(a, b) {
                                    var c = this.ctx;
                                    void 0 !== c.setLineDash && (c.setLineDash(a), c.lineDashOffset = b);
                                };
                                f.setRenderingIntent = function() {};
                                f.setFlatness = function() {};
                                f.setGState = function(a) {
                                    a = p.makeIterator(a);
                                    for(var b = a.next(); !b.done; b = a.next()){
                                        var c = p.makeIterator(b.value);
                                        b = c.next().value;
                                        c = c.next().value;
                                        switch(b){
                                            case "LW":
                                                this.setLineWidth(c);
                                                break;
                                            case "LC":
                                                this.setLineCap(c);
                                                break;
                                            case "LJ":
                                                this.setLineJoin(c);
                                                break;
                                            case "ML":
                                                this.setMiterLimit(c);
                                                break;
                                            case "D":
                                                this.setDash(c[0], c[1]);
                                                break;
                                            case "RI":
                                                this.setRenderingIntent(c);
                                                break;
                                            case "FL":
                                                this.setFlatness(c);
                                                break;
                                            case "Font":
                                                this.setFont(c[0], c[1]);
                                                break;
                                            case "CA":
                                                this.current.strokeAlpha = c;
                                                break;
                                            case "ca":
                                                this.current.fillAlpha = c;
                                                this.ctx.globalAlpha = c;
                                                break;
                                            case "BM":
                                                this.ctx.globalCompositeOperation = c;
                                                break;
                                            case "SMask":
                                                this.current.activeSMask = c ? this.tempSMask : null;
                                                this.tempSMask = null;
                                                this.checkSMaskState();
                                                break;
                                            case "TR":
                                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(c);
                                        }
                                    }
                                };
                                f.checkSMaskState = function() {
                                    var a = this.inSMaskMode;
                                    this.current.activeSMask && !a ? this.beginSMaskMode() : !this.current.activeSMask && a && this.endSMaskMode();
                                };
                                f.beginSMaskMode = function() {
                                    if (this.inSMaskMode) throw Error("beginSMaskMode called while already in smask mode");
                                    var a = this.cachedCanvases.getCanvas("smaskGroupAt" + this.groupLevel, this.ctx.canvas.width, this.ctx.canvas.height);
                                    this.suspendedCtx = this.ctx;
                                    a = this.ctx = a.context;
                                    a.setTransform.apply(a, p.arrayFromIterable(Ba(this.suspendedCtx)));
                                    qb(this.suspendedCtx, a);
                                    Af(a, this.suspendedCtx);
                                    this.setGState([
                                        [
                                            "BM",
                                            "source-over"
                                        ],
                                        [
                                            "ca",
                                            1
                                        ],
                                        [
                                            "CA",
                                            1
                                        ]
                                    ]);
                                };
                                f.endSMaskMode = function() {
                                    if (!this.inSMaskMode) throw Error("endSMaskMode called while not in smask mode");
                                    this.ctx._removeMirroring();
                                    qb(this.ctx, this.suspendedCtx);
                                    this.ctx = this.suspendedCtx;
                                    this.suspendedCtx = null;
                                };
                                f.compose = function(a) {
                                    this.current.activeSMask && (a ? (a[0] = Math.floor(a[0]), a[1] = Math.floor(a[1]), a[2] = Math.ceil(a[2]), a[3] = Math.ceil(a[3])) : a = [
                                        0,
                                        0,
                                        this.ctx.canvas.width,
                                        this.ctx.canvas.height
                                    ], this.composeSMask(this.suspendedCtx, this.current.activeSMask, this.ctx, a), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore());
                                };
                                f.composeSMask = function(a, b, c, d) {
                                    var e = d[0], h = d[1], k = d[2] - e;
                                    d = d[3] - h;
                                    0 !== k && 0 !== d && (this.genericComposeSMask(b.context, c, k, d, b.subtype, b.backdrop, b.transferMap, e, h, b.offsetX, b.offsetY), a.save(), a.globalAlpha = 1, a.globalCompositeOperation = "source-over", a.setTransform(1, 0, 0, 1, 0, 0), a.drawImage(c.canvas, 0, 0), a.restore());
                                };
                                f.genericComposeSMask = function(a, b, c, d, e, h, k, l, m, n, q) {
                                    var r = a.canvas;
                                    n = l - n;
                                    q = m - q;
                                    if (h) {
                                        if (h = fa.makeHexColor.apply(fa, p.arrayFromIterable(h)), 0 > n || 0 > q || n + c > r.width || q + d > r.height) {
                                            a = this.cachedCanvases.getCanvas("maskExtension", c, d);
                                            var t = a.context;
                                            t.drawImage(r, -n, -q);
                                            t.globalCompositeOperation = "destination-atop";
                                            t.fillStyle = h;
                                            t.fillRect(0, 0, c, d);
                                            t.globalCompositeOperation = "source-over";
                                            r = a.canvas;
                                            n = q = 0;
                                        } else a.save(), a.globalAlpha = 1, a.setTransform(1, 0, 0, 1, 0, 0), t = new Path2D, t.rect(n, q, c, d), a.clip(t), a.globalCompositeOperation = "destination-atop", a.fillStyle = h, a.fillRect(n, q, c, d), a.restore();
                                    }
                                    b.save();
                                    b.globalAlpha = 1;
                                    b.setTransform(1, 0, 0, 1, 0, 0);
                                    "Alpha" === e && k ? b.filter = this.filterFactory.addAlphaFilter(k) : "Luminosity" === e && (b.filter = this.filterFactory.addLuminosityFilter(k));
                                    e = new Path2D;
                                    e.rect(l, m, c, d);
                                    b.clip(e);
                                    b.globalCompositeOperation = "destination-in";
                                    b.drawImage(r, n, q, c, d, l, m, c, d);
                                    b.restore();
                                };
                                f.save = function() {
                                    this.inSMaskMode ? (qb(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
                                    var a = this.current;
                                    this.stateStack.push(a);
                                    this.current = a.clone();
                                };
                                f.restore = function() {
                                    0 === this.stateStack.length && this.inSMaskMode && this.endSMaskMode();
                                    0 !== this.stateStack.length && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), qb(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null);
                                };
                                f.transform = function(a, b, c, d, e, h) {
                                    this.ctx.transform(a, b, c, d, e, h);
                                    this._cachedScaleForStroking[0] = -1;
                                    this._cachedGetSinglePixelWidth = null;
                                };
                                f.constructPath = function(a, b, c) {
                                    var d = this.ctx, e = this.current, h = e.x, k = e.y, l = Ba(d), m = 0 === l[0] && 0 === l[3] || 0 === l[1] && 0 === l[2];
                                    c = m ? c.slice(0) : null;
                                    for(var n = 0, q = 0, r = a.length; n < r; n++)switch(a[n] | 0){
                                        case Pa.rectangle:
                                            h = b[q++];
                                            k = b[q++];
                                            var t = b[q++];
                                            var u = b[q++];
                                            var v = h + t, w = k + u;
                                            d.moveTo(h, k);
                                            0 === t || 0 === u ? d.lineTo(v, w) : (d.lineTo(v, k), d.lineTo(v, w), d.lineTo(h, w));
                                            m || e.updateRectMinMax(l, [
                                                h,
                                                k,
                                                v,
                                                w
                                            ]);
                                            d.closePath();
                                            break;
                                        case Pa.moveTo:
                                            h = b[q++];
                                            k = b[q++];
                                            d.moveTo(h, k);
                                            m || e.updatePathMinMax(l, h, k);
                                            break;
                                        case Pa.lineTo:
                                            h = b[q++];
                                            k = b[q++];
                                            d.lineTo(h, k);
                                            m || e.updatePathMinMax(l, h, k);
                                            break;
                                        case Pa.curveTo:
                                            t = h;
                                            u = k;
                                            h = b[q + 4];
                                            k = b[q + 5];
                                            d.bezierCurveTo(b[q], b[q + 1], b[q + 2], b[q + 3], h, k);
                                            e.updateCurvePathMinMax(l, t, u, b[q], b[q + 1], b[q + 2], b[q + 3], h, k, c);
                                            q += 6;
                                            break;
                                        case Pa.curveTo2:
                                            t = h;
                                            u = k;
                                            d.bezierCurveTo(h, k, b[q], b[q + 1], b[q + 2], b[q + 3]);
                                            e.updateCurvePathMinMax(l, t, u, h, k, b[q], b[q + 1], b[q + 2], b[q + 3], c);
                                            h = b[q + 2];
                                            k = b[q + 3];
                                            q += 4;
                                            break;
                                        case Pa.curveTo3:
                                            t = h;
                                            u = k;
                                            h = b[q + 2];
                                            k = b[q + 3];
                                            d.bezierCurveTo(b[q], b[q + 1], h, k, h, k);
                                            e.updateCurvePathMinMax(l, t, u, b[q], b[q + 1], h, k, h, k, c);
                                            q += 4;
                                            break;
                                        case Pa.closePath:
                                            d.closePath();
                                    }
                                    m && e.updateScalingPathMinMax(l, c);
                                    e.setCurrentPoint(h, k);
                                };
                                f.closePath = function() {
                                    this.ctx.closePath();
                                };
                                f.stroke = function(a) {
                                    void 0 === a && (a = !0);
                                    var b = this.ctx, c = this.current.strokeColor;
                                    b.globalAlpha = this.current.strokeAlpha;
                                    this.contentVisible && ("object" === typeof c && null != c && c.getPattern ? (b.save(), b.strokeStyle = c.getPattern(b, this, Sa(b), "Stroke"), this.rescaleAndStroke(!1), b.restore()) : this.rescaleAndStroke(!0));
                                    a && this.consumePath(this.current.getClippedPathBoundingBox());
                                    b.globalAlpha = this.current.fillAlpha;
                                };
                                f.closeStroke = function() {
                                    this.closePath();
                                    this.stroke();
                                };
                                f.fill = function(a) {
                                    void 0 === a && (a = !0);
                                    var b = this.ctx, c = this.current.fillColor, d = !1;
                                    this.current.patternFill && (b.save(), b.fillStyle = c.getPattern(b, this, Sa(b), "Fill"), d = !0);
                                    c = this.current.getClippedPathBoundingBox();
                                    this.contentVisible && null !== c && (this.pendingEOFill ? (b.fill("evenodd"), this.pendingEOFill = !1) : b.fill());
                                    d && b.restore();
                                    a && this.consumePath(c);
                                };
                                f.eoFill = function() {
                                    this.pendingEOFill = !0;
                                    this.fill();
                                };
                                f.fillStroke = function() {
                                    this.fill(!1);
                                    this.stroke(!1);
                                    this.consumePath();
                                };
                                f.eoFillStroke = function() {
                                    this.pendingEOFill = !0;
                                    this.fillStroke();
                                };
                                f.closeFillStroke = function() {
                                    this.closePath();
                                    this.fillStroke();
                                };
                                f.closeEOFillStroke = function() {
                                    this.pendingEOFill = !0;
                                    this.closePath();
                                    this.fillStroke();
                                };
                                f.endPath = function() {
                                    this.consumePath();
                                };
                                f.clip = function() {
                                    this.pendingClip = Dg;
                                };
                                f.eoClip = function() {
                                    this.pendingClip = Pe;
                                };
                                f.beginText = function() {
                                    this.current.textMatrix = Ce;
                                    this.current.textMatrixScale = 1;
                                    this.current.x = this.current.lineX = 0;
                                    this.current.y = this.current.lineY = 0;
                                };
                                f.endText = function() {
                                    var a = this.pendingTextPaths, b = this.ctx;
                                    if (void 0 === a) b.beginPath();
                                    else {
                                        b.save();
                                        b.beginPath();
                                        a = p.makeIterator(a);
                                        for(var c = a.next(); !c.done; c = a.next())c = c.value, b.setTransform.apply(b, p.arrayFromIterable(c.transform)), b.translate(c.x, c.y), c.addToPath(b, c.fontSize);
                                        b.restore();
                                        b.clip();
                                        b.beginPath();
                                        delete this.pendingTextPaths;
                                    }
                                };
                                f.setCharSpacing = function(a) {
                                    this.current.charSpacing = a;
                                };
                                f.setWordSpacing = function(a) {
                                    this.current.wordSpacing = a;
                                };
                                f.setHScale = function(a) {
                                    this.current.textHScale = a / 100;
                                };
                                f.setLeading = function(a) {
                                    this.current.leading = -a;
                                };
                                f.setFont = function(a, b) {
                                    var c, d = this.commonObjs.get(a), e = this.current;
                                    if (!d) throw Error("Can't find font for " + a);
                                    e.fontMatrix = d.fontMatrix || Oc;
                                    0 !== e.fontMatrix[0] && 0 !== e.fontMatrix[3] || R("Invalid font matrix for font " + a);
                                    0 > b ? (b = -b, e.fontDirection = -1) : e.fontDirection = 1;
                                    this.current.font = d;
                                    this.current.fontSize = b;
                                    d.isType3Font || (e = d.loadedName || "sans-serif", a = (null == (c = d.systemFontInfo) ? void 0 : c.css) || '"' + e + '", ' + d.fallbackName, c = "normal", d.black ? c = "900" : d.bold && (c = "bold"), d = d.italic ? "italic" : "normal", e = b, 16 > b ? e = 16 : 100 < b && (e = 100), this.current.fontSizeScale = b / e, this.ctx.font = d + " " + c + " " + e + "px " + a);
                                };
                                f.setTextRenderingMode = function(a) {
                                    this.current.textRenderingMode = a;
                                };
                                f.setTextRise = function(a) {
                                    this.current.textRise = a;
                                };
                                f.moveText = function(a, b) {
                                    this.current.x = this.current.lineX += a;
                                    this.current.y = this.current.lineY += b;
                                };
                                f.setLeadingMoveText = function(a, b) {
                                    this.setLeading(-b);
                                    this.moveText(a, b);
                                };
                                f.setTextMatrix = function(a, b, c, d, e, h) {
                                    this.current.textMatrix = [
                                        a,
                                        b,
                                        c,
                                        d,
                                        e,
                                        h
                                    ];
                                    this.current.textMatrixScale = Math.hypot(a, b);
                                    this.current.x = this.current.lineX = 0;
                                    this.current.y = this.current.lineY = 0;
                                };
                                f.nextLine = function() {
                                    this.moveText(0, this.current.leading);
                                };
                                f.paintChar = function(a, b, c, d) {
                                    var e = this.ctx, h = this.current, k = h.font, l = h.textRenderingMode, m = h.fontSize / h.fontSizeScale, n = l & 3;
                                    l = !!(l & 4);
                                    h = h.patternFill && !k.missingFile;
                                    if (k.disableFontFace || l || h) var q = k.getPathGenerator(this.commonObjs, a);
                                    k.disableFontFace || h ? (e.save(), e.translate(b, c), e.beginPath(), q(e, m), d && e.setTransform.apply(e, p.arrayFromIterable(d)), 0 !== n && 2 !== n || e.fill(), 1 !== n && 2 !== n || e.stroke(), e.restore()) : (0 !== n && 2 !== n || e.fillText(a, b, c), 1 !== n && 2 !== n || e.strokeText(a, b, c));
                                    l && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                                        transform: Ba(e),
                                        x: b,
                                        y: c,
                                        fontSize: m,
                                        addToPath: q
                                    });
                                };
                                f.showText = function(a) {
                                    var b = this.current, c = b.font;
                                    if (c.isType3Font) return this.showType3Text(a);
                                    var d = b.fontSize;
                                    if (0 !== d) {
                                        var e = this.ctx, h = b.fontSizeScale, k = b.charSpacing, l = b.wordSpacing, m = b.fontDirection, n = b.textHScale * m, q = a.length, r = c.vertical, t = r ? 1 : -1, u = c.defaultVMetrics, v = d * b.fontMatrix[0], w = 0 === b.textRenderingMode && !c.disableFontFace && !b.patternFill;
                                        e.save();
                                        e.transform.apply(e, p.arrayFromIterable(b.textMatrix));
                                        e.translate(b.x, b.y + b.textRise);
                                        0 < m ? e.scale(n, -1) : e.scale(n, 1);
                                        if (b.patternFill) {
                                            e.save();
                                            var x = b.fillColor.getPattern(e, this, Sa(e), "Fill");
                                            var B = Ba(e);
                                            e.restore();
                                            e.fillStyle = x;
                                        }
                                        x = b.lineWidth;
                                        var z = b.textMatrixScale;
                                        if (0 === z || 0 === x) {
                                            if (z = b.textRenderingMode & 3, 1 === z || 2 === z) x = this.getSinglePixelWidth();
                                        } else x /= z;
                                        1 !== h && (e.scale(h, h), x /= h);
                                        e.lineWidth = x;
                                        if (c.isInvalidPDFjsFont) {
                                            c = [];
                                            d = 0;
                                            a = p.makeIterator(a);
                                            for(h = a.next(); !h.done; h = a.next())h = h.value, c.push(h.unicode), d += h.width;
                                            e.fillText(c.join(""), 0, 0);
                                            b.x += d * v * n;
                                        } else {
                                            for(z = x = 0; z < q; ++z){
                                                var C = a[z];
                                                if ("number" === typeof C) x += t * C * d / 1E3;
                                                else {
                                                    var D = !1, H = (C.isSpace ? l : 0) + k, J = C.fontChar, M = C.accent, I = C.width;
                                                    if (r) {
                                                        var P = C.vmetric || u;
                                                        var L = -(C.vmetric ? P[1] : .5 * I) * v;
                                                        var T = P[2] * v;
                                                        I = P ? -P[0] : I;
                                                        P = L / h;
                                                        T = (x + T) / h;
                                                    } else P = x / h, T = 0;
                                                    c.remeasure && 0 < I && (L = 1E3 * e.measureText(J).width / d * h, I < L && this.isFontSubpixelAAEnabled ? (L = I / L, D = !0, e.save(), e.scale(L, 1), P /= L) : I !== L && (P += (I - L) / 2E3 * d / h));
                                                    this.contentVisible && (C.isInFont || c.missingFile) && (w && !M ? e.fillText(J, P, T) : (this.paintChar(J, P, T, B), M && this.paintChar(M.fontChar, P + d * M.offset.x / h, T - d * M.offset.y / h, B)));
                                                    x += r ? I * v - H * m : I * v + H * m;
                                                    D && e.restore();
                                                }
                                            }
                                            r ? b.y -= x : b.x += x * n;
                                        }
                                        e.restore();
                                        this.compose();
                                    }
                                };
                                f.showType3Text = function(a) {
                                    var b = this.ctx, c = this.current, d = c.font, e = c.fontSize, h = c.fontDirection, k = d.vertical ? 1 : -1, l = c.charSpacing, m = c.wordSpacing, n = c.textHScale * h, q = c.fontMatrix || Oc, r = a.length;
                                    if (3 !== c.textRenderingMode && 0 !== e) {
                                        this._cachedScaleForStroking[0] = -1;
                                        this._cachedGetSinglePixelWidth = null;
                                        b.save();
                                        b.transform.apply(b, p.arrayFromIterable(c.textMatrix));
                                        b.translate(c.x, c.y);
                                        b.scale(n, h);
                                        for(h = 0; h < r; ++h){
                                            var t = a[h];
                                            if ("number" === typeof t) t = k * t * e / 1E3, this.ctx.translate(t, 0), c.x += t * n;
                                            else {
                                                var u = (t.isSpace ? m : 0) + l, v = d.charProcOperatorList[t.operatorListId];
                                                v ? (this.contentVisible && (this.processingType3 = t, this.save(), b.scale(e, e), b.transform.apply(b, p.arrayFromIterable(q)), this.executeOperatorList(v), this.restore()), t = fa.applyTransform([
                                                    t.width,
                                                    0
                                                ], q)[0] * e + u, b.translate(t, 0), c.x += t * n) : R('Type3 character "' + t.operatorListId + '" is not available.');
                                            }
                                        }
                                        b.restore();
                                        this.processingType3 = null;
                                    }
                                };
                                f.setCharWidth = function() {};
                                f.setCharWidthAndBounds = function(a, b, c, d, e, h) {
                                    this.ctx.rect(c, d, e - c, h - d);
                                    this.ctx.clip();
                                    this.endPath();
                                };
                                f.getColorN_Pattern = function(a) {
                                    var b = this;
                                    if ("TilingPattern" === a[0]) {
                                        var c = a[1], d = this.baseTransform || Ba(this.ctx);
                                        a = new Ne(a, c, this.ctx, {
                                            createCanvasGraphics: function(e) {
                                                return new g(e, b.commonObjs, b.objs, b.canvasFactory, b.filterFactory, {
                                                    optionalContentConfig: b.optionalContentConfig,
                                                    markedContentStack: b.markedContentStack
                                                });
                                            }
                                        }, d);
                                    } else a = this._getPattern(a[1], a[2]);
                                    return a;
                                };
                                f.setStrokeColorN = function() {
                                    this.current.strokeColor = this.getColorN_Pattern(arguments);
                                };
                                f.setFillColorN = function() {
                                    this.current.fillColor = this.getColorN_Pattern(arguments);
                                    this.current.patternFill = !0;
                                };
                                f.setStrokeRGBColor = function(a, b, c) {
                                    this.ctx.strokeStyle = this.current.strokeColor = fa.makeHexColor(a, b, c);
                                };
                                f.setStrokeTransparent = function() {
                                    this.ctx.strokeStyle = this.current.strokeColor = "transparent";
                                };
                                f.setFillRGBColor = function(a, b, c) {
                                    this.ctx.fillStyle = this.current.fillColor = fa.makeHexColor(a, b, c);
                                    this.current.patternFill = !1;
                                };
                                f.setFillTransparent = function() {
                                    this.ctx.fillStyle = this.current.fillColor = "transparent";
                                    this.current.patternFill = !1;
                                };
                                f._getPattern = function(a, b) {
                                    void 0 === b && (b = null);
                                    if (this.cachedPatterns.has(a)) var c = this.cachedPatterns.get(a);
                                    else {
                                        a: {
                                            c = this.getObject(a);
                                            switch(c[0]){
                                                case "RadialAxial":
                                                    c = new xg(c);
                                                    break a;
                                                case "Mesh":
                                                    c = new yg(c);
                                                    break a;
                                                case "Dummy":
                                                    c = new zg;
                                                    break a;
                                            }
                                            throw Error("Unknown IR type: " + c[0]);
                                        }
                                        this.cachedPatterns.set(a, c);
                                    }
                                    b && (c.matrix = b);
                                    return c;
                                };
                                f.shadingFill = function(a) {
                                    if (this.contentVisible) {
                                        var b = this.ctx;
                                        this.save();
                                        a = this._getPattern(a);
                                        b.fillStyle = a.getPattern(b, this, Sa(b), "Shading");
                                        if (a = Sa(b)) {
                                            b = b.canvas;
                                            var c = p.makeIterator(fa.getAxialAlignedBoundingBox([
                                                0,
                                                0,
                                                b.width,
                                                b.height
                                            ], a));
                                            b = c.next().value;
                                            a = c.next().value;
                                            var d = c.next().value;
                                            c = c.next().value;
                                            this.ctx.fillRect(b, a, d - b, c - a);
                                        } else this.ctx.fillRect(-10000000000, -10000000000, 2E10, 2E10);
                                        this.compose(this.current.getClippedPathBoundingBox());
                                        this.restore();
                                    }
                                };
                                f.beginInlineImage = function() {
                                    da("Should not call beginInlineImage");
                                };
                                f.beginImageData = function() {
                                    da("Should not call beginImageData");
                                };
                                f.paintFormXObjectBegin = function(a, b) {
                                    this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), a && this.transform.apply(this, p.arrayFromIterable(a)), this.baseTransform = Ba(this.ctx), b && (this.ctx.rect(b[0], b[1], b[2] - b[0], b[3] - b[1]), this.current.updateRectMinMax(Ba(this.ctx), b), this.clip(), this.endPath()));
                                };
                                f.paintFormXObjectEnd = function() {
                                    this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
                                };
                                f.beginGroup = function(a) {
                                    if (this.contentVisible) {
                                        this.save();
                                        this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
                                        var b = this.ctx;
                                        a.isolated || W("TODO: Support non-isolated groups.");
                                        a.knockout && R("Knockout groups not supported.");
                                        var c = Ba(b);
                                        a.matrix && b.transform.apply(b, p.arrayFromIterable(a.matrix));
                                        if (!a.bbox) throw Error("Bounding box is required.");
                                        var d = fa.getAxialAlignedBoundingBox(a.bbox, Ba(b));
                                        d = fa.intersect(d, [
                                            0,
                                            0,
                                            b.canvas.width,
                                            b.canvas.height
                                        ]) || [
                                            0,
                                            0,
                                            0,
                                            0
                                        ];
                                        var e = Math.floor(d[0]), h = Math.floor(d[1]), k = Math.max(Math.ceil(d[2]) - e, 1);
                                        d = Math.max(Math.ceil(d[3]) - h, 1);
                                        this.current.startNewPathAndClipBox([
                                            0,
                                            0,
                                            k,
                                            d
                                        ]);
                                        var l = "groupAt" + this.groupLevel;
                                        a.smask && (l += "_smask_" + this.smaskCounter++ % 2);
                                        k = this.cachedCanvases.getCanvas(l, k, d);
                                        d = k.context;
                                        d.translate(-e, -h);
                                        d.transform.apply(d, p.arrayFromIterable(c));
                                        a.smask ? this.smaskStack.push({
                                            canvas: k.canvas,
                                            context: d,
                                            offsetX: e,
                                            offsetY: h,
                                            subtype: a.smask.subtype,
                                            backdrop: a.smask.backdrop,
                                            transferMap: a.smask.transferMap || null,
                                            startTransformInverse: null
                                        }) : (b.setTransform(1, 0, 0, 1, 0, 0), b.translate(e, h), b.save());
                                        qb(b, d);
                                        this.ctx = d;
                                        this.setGState([
                                            [
                                                "BM",
                                                "source-over"
                                            ],
                                            [
                                                "ca",
                                                1
                                            ],
                                            [
                                                "CA",
                                                1
                                            ]
                                        ]);
                                        this.groupStack.push(b);
                                        this.groupLevel++;
                                    }
                                };
                                f.endGroup = function(a) {
                                    if (this.contentVisible) {
                                        this.groupLevel--;
                                        var b = this.ctx;
                                        this.ctx = this.groupStack.pop();
                                        this.ctx.imageSmoothingEnabled = !1;
                                        a.smask ? (this.tempSMask = this.smaskStack.pop(), this.restore()) : (this.ctx.restore(), a = Ba(this.ctx), this.restore(), this.ctx.save(), this.ctx.setTransform.apply(this.ctx, p.arrayFromIterable(a)), a = fa.getAxialAlignedBoundingBox([
                                            0,
                                            0,
                                            b.canvas.width,
                                            b.canvas.height
                                        ], a), this.ctx.drawImage(b.canvas, 0, 0), this.ctx.restore(), this.compose(a));
                                    }
                                };
                                f.beginAnnotation = function(a, b, c, d, e) {
                                    this.__restoreInitialState();
                                    Gb(this.ctx);
                                    this.ctx.save();
                                    this.save();
                                    this.baseTransform && this.ctx.setTransform.apply(this.ctx, p.arrayFromIterable(this.baseTransform));
                                    if (b) {
                                        var h = b[2] - b[0], k = b[3] - b[1];
                                        if (e && this.annotationCanvasMap) {
                                            c = c.slice();
                                            c[4] -= b[0];
                                            c[5] -= b[1];
                                            b = b.slice();
                                            b[0] = b[1] = 0;
                                            b[2] = h;
                                            b[3] = k;
                                            e = p.makeIterator(fa.singularValueDecompose2dScale(Ba(this.ctx)));
                                            b = e.next().value;
                                            e = e.next().value;
                                            var l = this.viewportScale;
                                            h = this.annotationCanvas = this.canvasFactory.create(Math.ceil(h * this.outputScaleX * l), Math.ceil(k * this.outputScaleY * l));
                                            l = h.context;
                                            this.annotationCanvasMap.set(a, h.canvas);
                                            this.annotationCanvas.savedCtx = this.ctx;
                                            this.ctx = l;
                                            this.ctx.save();
                                            this.ctx.setTransform(b, 0, 0, -e, 0, k * e);
                                            Gb(this.ctx);
                                        } else Gb(this.ctx), this.endPath(), this.ctx.rect(b[0], b[1], h, k), this.ctx.clip(), this.ctx.beginPath();
                                    }
                                    this.current = new Oe(this.ctx.canvas.width, this.ctx.canvas.height);
                                    this.transform.apply(this, p.arrayFromIterable(c));
                                    this.transform.apply(this, p.arrayFromIterable(d));
                                };
                                f.endAnnotation = function() {
                                    this.annotationCanvas && (this.ctx.restore(), this.__drawFilter(), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
                                };
                                f.paintImageMaskXObject = function(a) {
                                    if (this.contentVisible) {
                                        var b = a.count;
                                        a = this.getObject(a.data, a);
                                        a.count = b;
                                        b = this.ctx;
                                        var c = this.processingType3;
                                        if (c && (void 0 === c.compiled && (c.compiled = Bf(a)), c.compiled)) {
                                            c.compiled(b);
                                            return;
                                        }
                                        a = this._createMaskCanvas(a);
                                        c = a.canvas;
                                        b.save();
                                        b.setTransform(1, 0, 0, 1, 0, 0);
                                        b.drawImage(c, a.offsetX, a.offsetY);
                                        b.restore();
                                        this.compose();
                                    }
                                };
                                f.paintImageMaskXObjectRepeat = function(a, b, c, d, e, h) {
                                    void 0 === c && (c = 0);
                                    void 0 === d && (d = 0);
                                    if (this.contentVisible) {
                                        a = this.getObject(a.data, a);
                                        var k = this.ctx;
                                        k.save();
                                        var l = Ba(k);
                                        k.transform(b, c, d, e, 0, 0);
                                        a = this._createMaskCanvas(a);
                                        k.setTransform(1, 0, 0, 1, a.offsetX - l[4], a.offsetY - l[5]);
                                        for(var m = 0, n = h.length; m < n; m += 2){
                                            var q = fa.transform(l, [
                                                b,
                                                c,
                                                d,
                                                e,
                                                h[m],
                                                h[m + 1]
                                            ]), r = p.makeIterator(fa.applyTransform([
                                                0,
                                                0
                                            ], q));
                                            q = r.next().value;
                                            r = r.next().value;
                                            k.drawImage(a.canvas, q, r);
                                        }
                                        k.restore();
                                        this.compose();
                                    }
                                };
                                f.paintImageMaskXObjectGroup = function(a) {
                                    if (this.contentVisible) {
                                        var b = this.ctx, c = this.current.fillColor, d = this.current.patternFill;
                                        a = p.makeIterator(a);
                                        for(var e = a.next(); !e.done; e = a.next()){
                                            var h = e.value, k = h, l = k.data;
                                            e = k.width;
                                            var m = k.height;
                                            k = k.transform;
                                            var n = this.cachedCanvases.getCanvas("maskCanvas", e, m), q = n.context;
                                            q.save();
                                            h = this.getObject(l, h);
                                            zd(q, h);
                                            q.globalCompositeOperation = "source-in";
                                            q.fillStyle = d ? c.getPattern(q, this, Sa(b), "Fill") : c;
                                            q.fillRect(0, 0, e, m);
                                            q.restore();
                                            b.save();
                                            b.transform.apply(b, p.arrayFromIterable(k));
                                            b.scale(1, -1);
                                            Eb(b, n.canvas, 0, 0, e, m, 0, -1, 1, 1);
                                            b.restore();
                                        }
                                        this.compose();
                                    }
                                };
                                f.paintImageXObject = function(a) {
                                    this.contentVisible && ((a = this.getObject(a)) ? this.paintInlineImageXObject(a) : R("Dependent image isn't ready yet"));
                                };
                                f.paintImageXObjectRepeat = function(a, b, c, d) {
                                    if (this.contentVisible) {
                                        if (a = this.getObject(a)) {
                                            for(var e = a.width, h = a.height, k = [], l = 0, m = d.length; l < m; l += 2)k.push({
                                                transform: [
                                                    b,
                                                    0,
                                                    0,
                                                    c,
                                                    d[l],
                                                    d[l + 1]
                                                ],
                                                x: 0,
                                                y: 0,
                                                w: e,
                                                h: h
                                            });
                                            this.paintInlineImageXObjectGroup(a, k);
                                        } else R("Dependent image isn't ready yet");
                                    }
                                };
                                f.applyTransferMapsToCanvas = function(a) {
                                    "none" !== this.current.transferMaps && (a.filter = this.current.transferMaps, a.drawImage(a.canvas, 0, 0), a.filter = "none");
                                    return a.canvas;
                                };
                                f.applyTransferMapsToBitmap = function(a) {
                                    if ("none" === this.current.transferMaps) return a.bitmap;
                                    var b = a.bitmap;
                                    a = this.cachedCanvases.getCanvas("inlineImage", a.width, a.height);
                                    var c = a.context;
                                    c.filter = this.current.transferMaps;
                                    c.drawImage(b, 0, 0);
                                    c.filter = "none";
                                    return a.canvas;
                                };
                                f.paintInlineImageXObject = function(a) {
                                    if (this.contentVisible) {
                                        var b = a.width, c = a.height, d = this.ctx;
                                        this.save();
                                        var e = d.filter;
                                        "none" !== e && "" !== e && (d.filter = "none");
                                        d.scale(1 / b, -1 / c);
                                        a.bitmap ? e = this.applyTransferMapsToBitmap(a) : "function" === typeof HTMLElement && a instanceof HTMLElement || !a.data ? e = a : (e = this.cachedCanvases.getCanvas("inlineImage", b, c).context, yd(e, a), e = this.applyTransferMapsToCanvas(e));
                                        e = this._scaleImage(e, Sa(d));
                                        d.imageSmoothingEnabled = Ad(Ba(d), a.interpolate);
                                        Eb(d, e.img, 0, 0, e.paintWidth, e.paintHeight, 0, -c, b, c);
                                        this.compose();
                                        this.restore();
                                    }
                                };
                                f.paintInlineImageXObjectGroup = function(a, b) {
                                    if (this.contentVisible) {
                                        var c = this.ctx;
                                        if (a.bitmap) a = a.bitmap;
                                        else {
                                            var d = this.cachedCanvases.getCanvas("inlineImage", a.width, a.height).context;
                                            yd(d, a);
                                            a = this.applyTransferMapsToCanvas(d);
                                        }
                                        b = p.makeIterator(b);
                                        for(d = b.next(); !d.done; d = b.next())d = d.value, c.save(), c.transform.apply(c, p.arrayFromIterable(d.transform)), c.scale(1, -1), Eb(c, a, d.x, d.y, d.w, d.h, 0, -1, 1, 1), c.restore();
                                        this.compose();
                                    }
                                };
                                f.paintSolidColorImageMask = function() {
                                    this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
                                };
                                f.markPoint = function() {};
                                f.markPointProps = function() {};
                                f.beginMarkedContent = function() {
                                    this.markedContentStack.push({
                                        visible: !0
                                    });
                                };
                                f.beginMarkedContentProps = function(a, b) {
                                    "OC" === a ? this.markedContentStack.push({
                                        visible: this.optionalContentConfig.isVisible(b)
                                    }) : this.markedContentStack.push({
                                        visible: !0
                                    });
                                    this.contentVisible = this.isContentVisible();
                                };
                                f.endMarkedContent = function() {
                                    this.markedContentStack.pop();
                                    this.contentVisible = this.isContentVisible();
                                };
                                f.beginCompat = function() {};
                                f.endCompat = function() {};
                                f.consumePath = function(a) {
                                    var b = this.current.isEmptyClip();
                                    this.pendingClip && this.current.updateClipFromPath();
                                    this.pendingClip || this.compose(a);
                                    a = this.ctx;
                                    this.pendingClip && (b || (this.pendingClip === Pe ? a.clip("evenodd") : a.clip()), this.pendingClip = null);
                                    this.current.startNewPathAndClipBox(this.current.clipBox);
                                    a.beginPath();
                                };
                                f.getSinglePixelWidth = function() {
                                    if (!this._cachedGetSinglePixelWidth) {
                                        var a = Ba(this.ctx);
                                        this._cachedGetSinglePixelWidth = 0 === a[1] && 0 === a[2] ? 1 / Math.min(Math.abs(a[0]), Math.abs(a[3])) : Math.max(Math.hypot(a[0], a[2]), Math.hypot(a[1], a[3])) / Math.abs(a[0] * a[3] - a[2] * a[1]);
                                    }
                                    return this._cachedGetSinglePixelWidth;
                                };
                                f.getScaleForStroking = function() {
                                    if (-1 === this._cachedScaleForStroking[0]) {
                                        var a = this.current.lineWidth, b = this.ctx.getTransform(), c = b.a, d = b.b, e = b.c, h = b.d;
                                        0 === d && 0 === e ? (e = Math.abs(c), b = Math.abs(h), e === b ? 0 === a ? a = b = 1 / e : (a *= e, a = b = 1 > a ? 1 / a : 1) : 0 === a ? (a = 1 / e, b = 1 / b) : (e *= a, b *= a, a = 1 > e ? 1 / e : 1, b = 1 > b ? 1 / b : 1)) : (b = Math.abs(c * h - d * e), c = Math.hypot(c, d), e = Math.hypot(e, h), 0 === a ? (a = e / b, b = c / b) : (b *= a, a = e > b ? e / b : 1, b = c > b ? c / b : 1));
                                        this._cachedScaleForStroking[0] = a;
                                        this._cachedScaleForStroking[1] = b;
                                    }
                                    return this._cachedScaleForStroking;
                                };
                                f.rescaleAndStroke = function(a) {
                                    var b = this.ctx, c = this.current.lineWidth, d = p.makeIterator(this.getScaleForStroking()), e = d.next().value;
                                    d = d.next().value;
                                    b.lineWidth = c || 1;
                                    if (1 === e && 1 === d) b.stroke();
                                    else {
                                        c = b.getLineDash();
                                        a && b.save();
                                        b.scale(e, d);
                                        if (0 < c.length) {
                                            var h = Math.max(e, d);
                                            b.setLineDash(c.map(function(k) {
                                                return k / h;
                                            }));
                                            b.lineDashOffset /= h;
                                        }
                                        b.stroke();
                                        a && b.restore();
                                    }
                                };
                                f.isContentVisible = function() {
                                    for(var a = this.markedContentStack.length - 1; 0 <= a; a--)if (!this.markedContentStack[a].visible) return !1;
                                    return !0;
                                };
                                return zf(g, [
                                    {
                                        key: "inSMaskMode",
                                        get: function() {
                                            return !!this.suspendedCtx;
                                        }
                                    },
                                    {
                                        key: "isFontSubpixelAAEnabled",
                                        get: function() {
                                            var a = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10).context;
                                            a.scale(1.5, 1);
                                            a.fillText("I", 0, 10);
                                            a = a.getImageData(0, 0, 10, 10).data;
                                            for(var b = !1, c = 3; c < a.length; c += 4)if (0 < a[c] && 255 > a[c]) {
                                                b = !0;
                                                break;
                                            }
                                            return qa(this, "isFontSubpixelAAEnabled", b);
                                        }
                                    }
                                ]);
                            }(), Ob;
                            for(Ob in Pa)void 0 !== Nb.prototype[Ob] && (Nb.prototype[Pa[Ob]] = Nb.prototype[Ob]);
                            var mb = function() {
                                return Cf(function() {}, null, [
                                    {
                                        key: "workerPort",
                                        get: function() {
                                            return this.__port;
                                        },
                                        set: function(g) {
                                            if (!("undefined" !== typeof Worker && g instanceof Worker) && null !== g) throw Error("Invalid `workerPort` type.");
                                            this.__port = g;
                                        }
                                    },
                                    {
                                        key: "workerSrc",
                                        get: function() {
                                            return this.__src;
                                        },
                                        set: function(g) {
                                            if ("string" !== typeof g) throw Error("Invalid `workerSrc` type.");
                                            this.__src = g;
                                        }
                                    }
                                ]);
                            }();
                            mb.__port = null;
                            mb.__src = "";
                            F(6167);
                            var rb = function() {
                                function g(a, b, c) {
                                    this.__messageAC = new AbortController;
                                    this.sourceName = a;
                                    this.targetName = b;
                                    this.comObj = c;
                                    this.streamId = this.callbackId = 1;
                                    this.streamSinks = Object.create(null);
                                    this.streamControllers = Object.create(null);
                                    this.callbackCapabilities = Object.create(null);
                                    this.actionHandler = Object.create(null);
                                    c.addEventListener("message", this.__onMessage.bind(this), {
                                        signal: this.__messageAC.signal
                                    });
                                }
                                var f = g.prototype;
                                f.__onMessage = function(a) {
                                    var b = a.data;
                                    if (b.targetName === this.sourceName) {
                                        if (b.stream) this.__processStreamMessage(b);
                                        else if (b.callback) {
                                            a = b.callbackId;
                                            var c = this.callbackCapabilities[a];
                                            if (!c) throw Error("Cannot resolve callback " + a);
                                            delete this.callbackCapabilities[a];
                                            if (1 === b.callback) c.resolve(b.data);
                                            else if (2 === b.callback) c.reject(La(b.reason));
                                            else throw Error("Unexpected callback case");
                                        } else {
                                            var d = this.actionHandler[b.action];
                                            if (!d) throw Error("Unknown action from worker: " + b.action);
                                            if (b.callbackId) {
                                                var e = this.sourceName, h = b.sourceName, k = this.comObj;
                                                new Promise(function(l) {
                                                    l(d(b.data));
                                                }).then(function(l) {
                                                    k.postMessage({
                                                        sourceName: e,
                                                        targetName: h,
                                                        callback: 1,
                                                        callbackId: b.callbackId,
                                                        data: l
                                                    });
                                                }, function(l) {
                                                    k.postMessage({
                                                        sourceName: e,
                                                        targetName: h,
                                                        callback: 2,
                                                        callbackId: b.callbackId,
                                                        reason: La(l)
                                                    });
                                                });
                                            } else b.streamId ? this.__createStreamSink(b) : d(b.data);
                                        }
                                    }
                                };
                                f.on = function(a, b) {
                                    var c = this.actionHandler;
                                    if (c[a]) throw Error('There is already an actionName called "' + a + '"');
                                    c[a] = b;
                                };
                                f.send = function(a, b, c) {
                                    this.comObj.postMessage({
                                        sourceName: this.sourceName,
                                        targetName: this.targetName,
                                        action: a,
                                        data: b
                                    }, c);
                                };
                                f.sendWithPromise = function(a, b, c) {
                                    var d = this.callbackId++, e = Promise.withResolvers();
                                    this.callbackCapabilities[d] = e;
                                    try {
                                        this.comObj.postMessage({
                                            sourceName: this.sourceName,
                                            targetName: this.targetName,
                                            action: a,
                                            callbackId: d,
                                            data: b
                                        }, c);
                                    } catch (h) {
                                        e.reject(h);
                                    }
                                    return e.promise;
                                };
                                f.sendWithStream = function(a, b, c, d) {
                                    var e = this, h = this.streamId++, k = this.sourceName, l = this.targetName, m = this.comObj;
                                    return new ReadableStream({
                                        start: function(n) {
                                            var q = Promise.withResolvers();
                                            e.streamControllers[h] = {
                                                controller: n,
                                                startCall: q,
                                                pullCall: null,
                                                cancelCall: null,
                                                isClosed: !1
                                            };
                                            m.postMessage({
                                                sourceName: k,
                                                targetName: l,
                                                action: a,
                                                streamId: h,
                                                data: b,
                                                desiredSize: n.desiredSize
                                            }, d);
                                            return q.promise;
                                        },
                                        pull: function(n) {
                                            var q = Promise.withResolvers();
                                            e.streamControllers[h].pullCall = q;
                                            m.postMessage({
                                                sourceName: k,
                                                targetName: l,
                                                stream: 6,
                                                streamId: h,
                                                desiredSize: n.desiredSize
                                            });
                                            return q.promise;
                                        },
                                        cancel: function(n) {
                                            n instanceof Error || da("cancel must have a valid reason");
                                            var q = Promise.withResolvers();
                                            e.streamControllers[h].cancelCall = q;
                                            e.streamControllers[h].isClosed = !0;
                                            m.postMessage({
                                                sourceName: k,
                                                targetName: l,
                                                stream: 1,
                                                streamId: h,
                                                reason: La(n)
                                            });
                                            return q.promise;
                                        }
                                    }, c);
                                };
                                f.__createStreamSink = function(a) {
                                    var b = a.streamId, c = this.sourceName, d = a.sourceName, e = this.comObj, h = this, k = this.actionHandler[a.action], l = {
                                        enqueue: function(m, n, q) {
                                            void 0 === n && (n = 1);
                                            if (!this.isCancelled) {
                                                var r = this.desiredSize;
                                                this.desiredSize -= n;
                                                0 < r && 0 >= this.desiredSize && (this.sinkCapability = Promise.withResolvers(), this.ready = this.sinkCapability.promise);
                                                e.postMessage({
                                                    sourceName: c,
                                                    targetName: d,
                                                    stream: 4,
                                                    streamId: b,
                                                    chunk: m
                                                }, q);
                                            }
                                        },
                                        close: function() {
                                            this.isCancelled || (this.isCancelled = !0, e.postMessage({
                                                sourceName: c,
                                                targetName: d,
                                                stream: 3,
                                                streamId: b
                                            }), delete h.streamSinks[b]);
                                        },
                                        error: function(m) {
                                            m instanceof Error || da("error must have a valid reason");
                                            this.isCancelled || (this.isCancelled = !0, e.postMessage({
                                                sourceName: c,
                                                targetName: d,
                                                stream: 5,
                                                streamId: b,
                                                reason: La(m)
                                            }));
                                        },
                                        sinkCapability: Promise.withResolvers(),
                                        onPull: null,
                                        onCancel: null,
                                        isCancelled: !1,
                                        desiredSize: a.desiredSize,
                                        ready: null
                                    };
                                    l.sinkCapability.resolve();
                                    l.ready = l.sinkCapability.promise;
                                    this.streamSinks[b] = l;
                                    new Promise(function(m) {
                                        m(k(a.data, l));
                                    }).then(function() {
                                        e.postMessage({
                                            sourceName: c,
                                            targetName: d,
                                            stream: 8,
                                            streamId: b,
                                            success: !0
                                        });
                                    }, function(m) {
                                        e.postMessage({
                                            sourceName: c,
                                            targetName: d,
                                            stream: 8,
                                            streamId: b,
                                            reason: La(m)
                                        });
                                    });
                                };
                                f.__processStreamMessage = function(a) {
                                    var b = a.streamId, c = this.sourceName, d = a.sourceName, e = this.comObj, h = this.streamControllers[b], k = this.streamSinks[b];
                                    switch(a.stream){
                                        case 8:
                                            a.success ? h.startCall.resolve() : h.startCall.reject(La(a.reason));
                                            break;
                                        case 7:
                                            a.success ? h.pullCall.resolve() : h.pullCall.reject(La(a.reason));
                                            break;
                                        case 6:
                                            if (!k) {
                                                e.postMessage({
                                                    sourceName: c,
                                                    targetName: d,
                                                    stream: 7,
                                                    streamId: b,
                                                    success: !0
                                                });
                                                break;
                                            }
                                            0 >= k.desiredSize && 0 < a.desiredSize && k.sinkCapability.resolve();
                                            k.desiredSize = a.desiredSize;
                                            new Promise(function(l) {
                                                l(null == k.onPull ? void 0 : k.onPull());
                                            }).then(function() {
                                                e.postMessage({
                                                    sourceName: c,
                                                    targetName: d,
                                                    stream: 7,
                                                    streamId: b,
                                                    success: !0
                                                });
                                            }, function(l) {
                                                e.postMessage({
                                                    sourceName: c,
                                                    targetName: d,
                                                    stream: 7,
                                                    streamId: b,
                                                    reason: La(l)
                                                });
                                            });
                                            break;
                                        case 4:
                                            h || da("enqueue should have stream controller");
                                            if (h.isClosed) break;
                                            h.controller.enqueue(a.chunk);
                                            break;
                                        case 3:
                                            h || da("close should have stream controller");
                                            if (h.isClosed) break;
                                            h.isClosed = !0;
                                            h.controller.close();
                                            this.__deleteStreamController(h, b);
                                            break;
                                        case 5:
                                            h || da("error should have stream controller");
                                            h.controller.error(La(a.reason));
                                            this.__deleteStreamController(h, b);
                                            break;
                                        case 2:
                                            a.success ? h.cancelCall.resolve() : h.cancelCall.reject(La(a.reason));
                                            this.__deleteStreamController(h, b);
                                            break;
                                        case 1:
                                            if (!k) break;
                                            new Promise(function(l) {
                                                l(null == k.onCancel ? void 0 : k.onCancel(La(a.reason)));
                                            }).then(function() {
                                                e.postMessage({
                                                    sourceName: c,
                                                    targetName: d,
                                                    stream: 2,
                                                    streamId: b,
                                                    success: !0
                                                });
                                            }, function(l) {
                                                e.postMessage({
                                                    sourceName: c,
                                                    targetName: d,
                                                    stream: 2,
                                                    streamId: b,
                                                    reason: La(l)
                                                });
                                            });
                                            k.sinkCapability.reject(La(a.reason));
                                            k.isCancelled = !0;
                                            delete this.streamSinks[b];
                                            break;
                                        default:
                                            throw Error("Unexpected stream case");
                                    }
                                };
                                f.__deleteStreamController = function() {
                                    var a = Df(function e(c, d) {
                                        var h, k, l, m = this;
                                        return p.generator.createGenerator(e, function(n) {
                                            if (1 == n.nextAddress) return n.yield(Promise.allSettled([
                                                null == (h = c.startCall) ? void 0 : h.promise,
                                                null == (k = c.pullCall) ? void 0 : k.promise,
                                                null == (l = c.cancelCall) ? void 0 : l.promise
                                            ]), 2);
                                            delete m.streamControllers[d];
                                            n.jumpToEnd();
                                        });
                                    });
                                    return function(c, d) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.destroy = function() {
                                    var a;
                                    null == (a = this.__messageAC) || a.abort();
                                    this.__messageAC = null;
                                };
                                return g;
                            }(), Eg = function() {
                                function g(a) {
                                    var b = a.rawData;
                                    this.__metadataMap = a.parsedData;
                                    this.__data = b;
                                }
                                var f = g.prototype;
                                f.getRaw = function() {
                                    return this.__data;
                                };
                                f.get = function(a) {
                                    var b;
                                    return null != (b = this.__metadataMap.get(a)) ? b : null;
                                };
                                f.getAll = function() {
                                    return Rb(this.__metadataMap);
                                };
                                f.has = function(a) {
                                    return this.__metadataMap.has(a);
                                };
                                return g;
                            }(), ob = Symbol("INTERNAL"), Fg = function() {
                                function g(f, a) {
                                    var b = a.name, c = a.intent, d = a.usage;
                                    a = a.rbGroups;
                                    this.__userSet = !1;
                                    this.__visible = !0;
                                    this.__isDisplay = !!(f & 2);
                                    this.__isPrint = !!(f & 4);
                                    this.name = b;
                                    this.intent = c;
                                    this.usage = d;
                                    this.rbGroups = a;
                                }
                                g.prototype._setVisible = function(f, a, b) {
                                    void 0 === b && (b = !1);
                                    f !== ob && da("Internal method `_setVisible` called.");
                                    this.__userSet = b;
                                    this.__visible = a;
                                };
                                return Ed(g, [
                                    {
                                        key: "visible",
                                        get: function() {
                                            if (this.__userSet) return this.__visible;
                                            if (!this.__visible) return !1;
                                            var f = this.usage, a = f.print;
                                            f = f.view;
                                            return this.__isDisplay ? "OFF" !== (null == f ? void 0 : f.viewState) : this.__isPrint ? "OFF" !== (null == a ? void 0 : a.printState) : !0;
                                        }
                                    }
                                ]);
                            }(), Gg = function() {
                                function g(a, b) {
                                    void 0 === b && (b = 2);
                                    this.__cachedGetHash = null;
                                    this.__groups = new Map;
                                    this.__order = this.__initialHash = null;
                                    this.renderingIntent = b;
                                    this.creator = this.name = null;
                                    if (null !== a) {
                                        this.name = a.name;
                                        this.creator = a.creator;
                                        this.__order = a.order;
                                        for(var c = p.makeIterator(a.groups), d = c.next(); !d.done; d = c.next())d = d.value, this.__groups.set(d.id, new Fg(b, d));
                                        if ("OFF" === a.baseState) for(b = p.makeIterator(this.__groups.values()), c = b.next(); !c.done; c = b.next())c.value._setVisible(ob, !1);
                                        b = p.makeIterator(a.on);
                                        for(c = b.next(); !c.done; c = b.next())this.__groups.get(c.value)._setVisible(ob, !0);
                                        a = p.makeIterator(a.off);
                                        for(b = a.next(); !b.done; b = a.next())this.__groups.get(b.value)._setVisible(ob, !1);
                                        this.__initialHash = this.getHash();
                                    }
                                }
                                var f = g.prototype;
                                f.__evaluateVisibilityExpression = function(a) {
                                    var b = a.length;
                                    if (2 > b) return !0;
                                    for(var c = a[0], d = 1; d < b; d++){
                                        var e = a[d];
                                        if (Array.isArray(e)) e = this.__evaluateVisibilityExpression(e);
                                        else if (this.__groups.has(e)) e = this.__groups.get(e).visible;
                                        else return R("Optional content group not found: " + e), !0;
                                        switch(c){
                                            case "And":
                                                if (!e) return !1;
                                                break;
                                            case "Or":
                                                if (e) return !0;
                                                break;
                                            case "Not":
                                                return !e;
                                            default:
                                                return !0;
                                        }
                                    }
                                    return "And" === c;
                                };
                                f.isVisible = function(a) {
                                    if (0 === this.__groups.size) return !0;
                                    if (!a) return W("Optional content group not defined."), !0;
                                    if ("OCG" === a.type) return this.__groups.has(a.id) ? this.__groups.get(a.id).visible : (R("Optional content group not found: " + a.id), !0);
                                    if ("OCMD" === a.type) {
                                        if (a.expression) return this.__evaluateVisibilityExpression(a.expression);
                                        if (a.policy && "AnyOn" !== a.policy) {
                                            if ("AllOn" === a.policy) {
                                                a = p.makeIterator(a.ids);
                                                for(var b = a.next(); !b.done; b = a.next()){
                                                    b = b.value;
                                                    if (!this.__groups.has(b)) {
                                                        R("Optional content group not found: " + b);
                                                        break;
                                                    }
                                                    if (!this.__groups.get(b).visible) return !1;
                                                }
                                                return !0;
                                            }
                                            if ("AnyOff" === a.policy) {
                                                a = p.makeIterator(a.ids);
                                                for(b = a.next(); !b.done; b = a.next()){
                                                    b = b.value;
                                                    if (!this.__groups.has(b)) return R("Optional content group not found: " + b), !0;
                                                    if (!this.__groups.get(b).visible) return !0;
                                                }
                                                return !1;
                                            }
                                            if ("AllOff" === a.policy) {
                                                a = p.makeIterator(a.ids);
                                                for(b = a.next(); !b.done; b = a.next()){
                                                    b = b.value;
                                                    if (!this.__groups.has(b)) {
                                                        R("Optional content group not found: " + b);
                                                        break;
                                                    }
                                                    if (this.__groups.get(b).visible) return !1;
                                                }
                                                return !0;
                                            }
                                        } else {
                                            a = p.makeIterator(a.ids);
                                            for(b = a.next(); !b.done; b = a.next()){
                                                b = b.value;
                                                if (!this.__groups.has(b)) return R("Optional content group not found: " + b), !0;
                                                if (this.__groups.get(b).visible) return !0;
                                            }
                                            return !1;
                                        }
                                        R("Unknown optional content policy " + a.policy + ".");
                                        return !0;
                                    }
                                    R("Unknown group type " + a.type + ".");
                                    return !0;
                                };
                                f.setVisibility = function(a, b, c) {
                                    void 0 === b && (b = !0);
                                    void 0 === c && (c = !0);
                                    var d = this.__groups.get(a);
                                    if (d) {
                                        if (c && b && d.rbGroups.length) {
                                            c = p.makeIterator(d.rbGroups);
                                            for(var e = c.next(); !e.done; e = c.next()){
                                                e = p.makeIterator(e.value);
                                                for(var h = e.next(); !h.done; h = e.next())if (h = h.value, h !== a) {
                                                    var k;
                                                    null == (k = this.__groups.get(h)) || k._setVisible(ob, !1, !0);
                                                }
                                            }
                                        }
                                        d._setVisible(ob, !!b, !0);
                                        this.__cachedGetHash = null;
                                    } else R("Optional content group not found: " + a);
                                };
                                f.setOCGState = function(a) {
                                    var b = a.preserveRB;
                                    a = p.makeIterator(a.state);
                                    for(var c = a.next(); !c.done; c = a.next()){
                                        c = c.value;
                                        switch(c){
                                            case "ON":
                                            case "OFF":
                                            case "Toggle":
                                                var d = c;
                                                continue;
                                        }
                                        var e = this.__groups.get(c);
                                        if (e) switch(d){
                                            case "ON":
                                                this.setVisibility(c, !0, b);
                                                break;
                                            case "OFF":
                                                this.setVisibility(c, !1, b);
                                                break;
                                            case "Toggle":
                                                this.setVisibility(c, !e.visible, b);
                                        }
                                    }
                                    this.__cachedGetHash = null;
                                };
                                f.getOrder = function() {
                                    return this.__groups.size ? this.__order ? this.__order.slice() : [].concat(p.arrayFromIterable(this.__groups.keys())) : null;
                                };
                                f.getGroups = function() {
                                    return 0 < this.__groups.size ? Rb(this.__groups) : null;
                                };
                                f.getGroup = function(a) {
                                    return this.__groups.get(a) || null;
                                };
                                f.getHash = function() {
                                    if (null !== this.__cachedGetHash) return this.__cachedGetHash;
                                    for(var a = new He, b = p.makeIterator(this.__groups), c = b.next(); !c.done; c = b.next()){
                                        var d = p.makeIterator(c.value);
                                        c = d.next().value;
                                        d = d.next().value;
                                        a.update(c + ":" + d.visible);
                                    }
                                    return this.__cachedGetHash = a.hexdigest();
                                };
                                return Ed(g, [
                                    {
                                        key: "hasInitialVisibility",
                                        get: function() {
                                            return null === this.__initialHash || this.getHash() === this.__initialHash;
                                        }
                                    }
                                ]);
                            }(), Nf = function() {
                                function g(a, b) {
                                    var c = this, d = void 0 === b.disableRange ? !1 : b.disableRange;
                                    b = void 0 === b.disableStream ? !1 : b.disableStream;
                                    a || da('PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                                    var e = a.length, h = a.initialData, k = a.progressiveDone, l = a.contentDispositionFilename;
                                    this._queuedChunks = [];
                                    this._progressiveDone = k;
                                    this._contentDispositionFilename = l;
                                    0 < (null == h ? void 0 : h.length) && (h = h instanceof Uint8Array && h.byteLength === h.buffer.byteLength ? h.buffer : new Uint8Array(h).buffer, this._queuedChunks.push(h));
                                    this._pdfDataRangeTransport = a;
                                    this._isStreamingSupported = !b;
                                    this._isRangeSupported = !d;
                                    this._contentLength = e;
                                    this._fullRequestReader = null;
                                    this._rangeReaders = [];
                                    a.addRangeListener(function(m, n) {
                                        c._onReceiveData({
                                            begin: m,
                                            chunk: n
                                        });
                                    });
                                    a.addProgressListener(function(m, n) {
                                        c._onProgress({
                                            loaded: m,
                                            total: n
                                        });
                                    });
                                    a.addProgressiveReadListener(function(m) {
                                        c._onReceiveData({
                                            chunk: m
                                        });
                                    });
                                    a.addProgressiveDoneListener(function() {
                                        c._onProgressiveDone();
                                    });
                                    a.transportReady();
                                }
                                var f = g.prototype;
                                f._onReceiveData = function(a) {
                                    var b = a.begin;
                                    a = a.chunk;
                                    var c = a instanceof Uint8Array && a.byteLength === a.buffer.byteLength ? a.buffer : new Uint8Array(a).buffer;
                                    void 0 === b ? this._fullRequestReader ? this._fullRequestReader._enqueue(c) : this._queuedChunks.push(c) : this._rangeReaders.some(function(d) {
                                        if (d._begin !== b) return !1;
                                        d._enqueue(c);
                                        return !0;
                                    }) || da("_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                                };
                                f._onProgress = function(a) {
                                    if (void 0 === a.total) {
                                        var b;
                                        null == (b = this._rangeReaders[0]) || null == b.onProgress || b.onProgress({
                                            loaded: a.loaded
                                        });
                                    } else {
                                        var c;
                                        null == (c = this._fullRequestReader) || null == c.onProgress || c.onProgress({
                                            loaded: a.loaded,
                                            total: a.total
                                        });
                                    }
                                };
                                f._onProgressiveDone = function() {
                                    var a;
                                    null == (a = this._fullRequestReader) || a.progressiveDone();
                                    this._progressiveDone = !0;
                                };
                                f._removeRangeReader = function(a) {
                                    a = this._rangeReaders.indexOf(a);
                                    0 <= a && this._rangeReaders.splice(a, 1);
                                };
                                f.getFullReader = function() {
                                    !this._fullRequestReader || da("PDFDataTransportStream.getFullReader can only be called once.");
                                    var a = this._queuedChunks;
                                    this._queuedChunks = null;
                                    return new Hg(this, a, this._progressiveDone, this._contentDispositionFilename);
                                };
                                f.getRangeReader = function(a, b) {
                                    if (b <= this._progressiveDataLength) return null;
                                    var c = new Ig(this, a, b);
                                    this._pdfDataRangeTransport.requestDataRange(a, b);
                                    this._rangeReaders.push(c);
                                    return c;
                                };
                                f.cancelAllRequests = function(a) {
                                    var b;
                                    null == (b = this._fullRequestReader) || b.cancel(a);
                                    b = p.makeIterator(this._rangeReaders.slice(0));
                                    for(var c = b.next(); !c.done; c = b.next())c.value.cancel(a);
                                    this._pdfDataRangeTransport.abort();
                                };
                                return pc(g, [
                                    {
                                        key: "_progressiveDataLength",
                                        get: function() {
                                            var a, b;
                                            return null != (a = null == (b = this._fullRequestReader) ? void 0 : b._loaded) ? a : 0;
                                        }
                                    }
                                ]);
                            }(), Hg = function() {
                                function g(a, b, c, d) {
                                    void 0 === c && (c = !1);
                                    void 0 === d && (d = null);
                                    this._stream = a;
                                    this._done = c || !1;
                                    this._filename = Vb(d) ? d : null;
                                    this._queuedChunks = b || [];
                                    this._loaded = 0;
                                    b = p.makeIterator(this._queuedChunks);
                                    for(c = b.next(); !c.done; c = b.next())this._loaded += c.value.byteLength;
                                    this._requests = [];
                                    this._headersReady = Promise.resolve();
                                    a._fullRequestReader = this;
                                    this.onProgress = null;
                                }
                                var f = g.prototype;
                                f._enqueue = function(a) {
                                    this._done || (0 < this._requests.length ? this._requests.shift().resolve({
                                        value: a,
                                        done: !1
                                    }) : this._queuedChunks.push(a), this._loaded += a.byteLength);
                                };
                                f.read = function() {
                                    var a = Gd(function c() {
                                        var d = this, e, h;
                                        return p.generator.createGenerator(c, function(k) {
                                            if (0 < d._queuedChunks.length) return e = d._queuedChunks.shift(), k.return({
                                                value: e,
                                                done: !1
                                            });
                                            if (d._done) return k.return({
                                                value: void 0,
                                                done: !0
                                            });
                                            h = Promise.withResolvers();
                                            d._requests.push(h);
                                            return k.return(h.promise);
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cancel = function() {
                                    this._done = !0;
                                    for(var a = p.makeIterator(this._requests), b = a.next(); !b.done; b = a.next())b.value.resolve({
                                        value: void 0,
                                        done: !0
                                    });
                                    this._requests.length = 0;
                                };
                                f.progressiveDone = function() {
                                    this._done || (this._done = !0);
                                };
                                return pc(g, [
                                    {
                                        key: "headersReady",
                                        get: function() {
                                            return this._headersReady;
                                        }
                                    },
                                    {
                                        key: "filename",
                                        get: function() {
                                            return this._filename;
                                        }
                                    },
                                    {
                                        key: "isRangeSupported",
                                        get: function() {
                                            return this._stream._isRangeSupported;
                                        }
                                    },
                                    {
                                        key: "isStreamingSupported",
                                        get: function() {
                                            return this._stream._isStreamingSupported;
                                        }
                                    },
                                    {
                                        key: "contentLength",
                                        get: function() {
                                            return this._stream._contentLength;
                                        }
                                    }
                                ]);
                            }(), Ig = function() {
                                function g(a, b, c) {
                                    this._stream = a;
                                    this._begin = b;
                                    this._end = c;
                                    this._queuedChunk = null;
                                    this._requests = [];
                                    this._done = !1;
                                    this.onProgress = null;
                                }
                                var f = g.prototype;
                                f._enqueue = function(a) {
                                    if (!this._done) {
                                        if (0 === this._requests.length) this._queuedChunk = a;
                                        else {
                                            this._requests.shift().resolve({
                                                value: a,
                                                done: !1
                                            });
                                            a = p.makeIterator(this._requests);
                                            for(var b = a.next(); !b.done; b = a.next())b.value.resolve({
                                                value: void 0,
                                                done: !0
                                            });
                                            this._requests.length = 0;
                                        }
                                        this._done = !0;
                                        this._stream._removeRangeReader(this);
                                    }
                                };
                                f.read = function() {
                                    var a = Gd(function c() {
                                        var d = this, e, h;
                                        return p.generator.createGenerator(c, function(k) {
                                            if (d._queuedChunk) return e = d._queuedChunk, d._queuedChunk = null, k.return({
                                                value: e,
                                                done: !1
                                            });
                                            if (d._done) return k.return({
                                                value: void 0,
                                                done: !0
                                            });
                                            h = Promise.withResolvers();
                                            d._requests.push(h);
                                            return k.return(h.promise);
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cancel = function() {
                                    this._done = !0;
                                    for(var a = p.makeIterator(this._requests), b = a.next(); !b.done; b = a.next())b.value.resolve({
                                        value: void 0,
                                        done: !0
                                    });
                                    this._requests.length = 0;
                                    this._stream._removeRangeReader(this);
                                };
                                return pc(g, [
                                    {
                                        key: "isStreamingSupported",
                                        get: function() {
                                            return !1;
                                        }
                                    }
                                ]);
                            }(), Of = function() {
                                function g(a) {
                                    this.source = a;
                                    this.isHttp = /^https?:/i.test(a.url);
                                    this.headers = qc(this.isHttp, a.httpHeaders);
                                    this._fullRequestReader = null;
                                    this._rangeRequestReaders = [];
                                }
                                var f = g.prototype;
                                f.getFullReader = function() {
                                    !this._fullRequestReader || da("PDFFetchStream.getFullReader can only be called once.");
                                    return this._fullRequestReader = new Jg(this);
                                };
                                f.getRangeReader = function(a, b) {
                                    if (b <= this._progressiveDataLength) return null;
                                    a = new Kg(this, a, b);
                                    this._rangeRequestReaders.push(a);
                                    return a;
                                };
                                f.cancelAllRequests = function(a) {
                                    var b;
                                    null == (b = this._fullRequestReader) || b.cancel(a);
                                    b = p.makeIterator(this._rangeRequestReaders.slice(0));
                                    for(var c = b.next(); !c.done; c = b.next())c.value.cancel(a);
                                };
                                return tc(g, [
                                    {
                                        key: "_progressiveDataLength",
                                        get: function() {
                                            var a, b;
                                            return null != (a = null == (b = this._fullRequestReader) ? void 0 : b._loaded) ? a : 0;
                                        }
                                    }
                                ]);
                            }(), Jg = function() {
                                function g(a) {
                                    var b = this;
                                    this._stream = a;
                                    this._reader = null;
                                    this._loaded = 0;
                                    this._filename = null;
                                    var c = a.source;
                                    this._withCredentials = c.withCredentials || !1;
                                    this._contentLength = c.length;
                                    this._headersCapability = Promise.withResolvers();
                                    this._disableRange = c.disableRange || !1;
                                    this._rangeChunkSize = c.rangeChunkSize;
                                    this._rangeChunkSize || this._disableRange || (this._disableRange = !0);
                                    this._abortController = new AbortController;
                                    this._isStreamingSupported = !c.disableStream;
                                    this._isRangeSupported = !c.disableRange;
                                    var d = new Headers(a.headers), e = c.url;
                                    fetch(e, Md(d, this._withCredentials, this._abortController)).then(function(h) {
                                        if (!Id(h.status)) throw Ib(h.status, e);
                                        b._reader = h.body.getReader();
                                        b._headersCapability.resolve();
                                        h = h.headers;
                                        var k = rc({
                                            responseHeaders: h,
                                            isHttp: a.isHttp,
                                            rangeChunkSize: b._rangeChunkSize,
                                            disableRange: b._disableRange
                                        }), l = k.suggestedLength;
                                        b._isRangeSupported = k.allowRangeRequests;
                                        b._contentLength = l || b._contentLength;
                                        b._filename = sc(h);
                                        !b._isStreamingSupported && b._isRangeSupported && b.cancel(new cb("Streaming is disabled."));
                                    }).catch(this._headersCapability.reject);
                                    this.onProgress = null;
                                }
                                var f = g.prototype;
                                f.read = function() {
                                    var a = Kd(function c() {
                                        var d, e = this, h, k, l;
                                        return p.generator.createGenerator(c, function(m) {
                                            if (1 == m.nextAddress) return m.yield(e._headersCapability.promise, 2);
                                            if (3 != m.nextAddress) return m.yield(e._reader.read(), 3);
                                            h = m.yieldResult;
                                            k = h.value;
                                            if (l = h.done) return m.return({
                                                value: k,
                                                done: l
                                            });
                                            e._loaded += k.byteLength;
                                            null == (d = e.onProgress) || d.call(e, {
                                                loaded: e._loaded,
                                                total: e._contentLength
                                            });
                                            return m.return({
                                                value: Nd(k),
                                                done: !1
                                            });
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cancel = function(a) {
                                    var b;
                                    null == (b = this._reader) || b.cancel(a);
                                    this._abortController.abort();
                                };
                                return tc(g, [
                                    {
                                        key: "headersReady",
                                        get: function() {
                                            return this._headersCapability.promise;
                                        }
                                    },
                                    {
                                        key: "filename",
                                        get: function() {
                                            return this._filename;
                                        }
                                    },
                                    {
                                        key: "contentLength",
                                        get: function() {
                                            return this._contentLength;
                                        }
                                    },
                                    {
                                        key: "isRangeSupported",
                                        get: function() {
                                            return this._isRangeSupported;
                                        }
                                    },
                                    {
                                        key: "isStreamingSupported",
                                        get: function() {
                                            return this._isStreamingSupported;
                                        }
                                    }
                                ]);
                            }(), Kg = function() {
                                function g(a, b, c) {
                                    var d = this;
                                    this._stream = a;
                                    this._reader = null;
                                    this._loaded = 0;
                                    var e = a.source;
                                    this._withCredentials = e.withCredentials || !1;
                                    this._readCapability = Promise.withResolvers();
                                    this._isStreamingSupported = !e.disableStream;
                                    this._abortController = new AbortController;
                                    a = new Headers(a.headers);
                                    a.append("Range", "bytes=" + b + "-" + (c - 1));
                                    var h = e.url;
                                    fetch(h, Md(a, this._withCredentials, this._abortController)).then(function(k) {
                                        if (!Id(k.status)) throw Ib(k.status, h);
                                        d._readCapability.resolve();
                                        d._reader = k.body.getReader();
                                    }).catch(this._readCapability.reject);
                                    this.onProgress = null;
                                }
                                var f = g.prototype;
                                f.read = function() {
                                    var a = Kd(function c() {
                                        var d, e = this, h, k, l;
                                        return p.generator.createGenerator(c, function(m) {
                                            if (1 == m.nextAddress) return m.yield(e._readCapability.promise, 2);
                                            if (3 != m.nextAddress) return m.yield(e._reader.read(), 3);
                                            h = m.yieldResult;
                                            k = h.value;
                                            if (l = h.done) return m.return({
                                                value: k,
                                                done: l
                                            });
                                            e._loaded += k.byteLength;
                                            null == (d = e.onProgress) || d.call(e, {
                                                loaded: e._loaded
                                            });
                                            return m.return({
                                                value: Nd(k),
                                                done: !1
                                            });
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cancel = function(a) {
                                    var b;
                                    null == (b = this._reader) || b.cancel(a);
                                    this._abortController.abort();
                                };
                                return tc(g, [
                                    {
                                        key: "isStreamingSupported",
                                        get: function() {
                                            return this._isStreamingSupported;
                                        }
                                    }
                                ]);
                            }(), Lg = function() {
                                function g(a) {
                                    var b = a.url, c = a.httpHeaders;
                                    a = a.withCredentials;
                                    this.url = b;
                                    this.isHttp = /^https?:/i.test(b);
                                    this.headers = qc(this.isHttp, c);
                                    this.withCredentials = a || !1;
                                    this.currXhrId = 0;
                                    this.pendingRequests = Object.create(null);
                                }
                                var f = g.prototype;
                                f.requestRange = function(a, b, c) {
                                    a = {
                                        begin: a,
                                        end: b
                                    };
                                    for(var d in c)a[d] = c[d];
                                    return this.request(a);
                                };
                                f.requestFull = function(a) {
                                    return this.request(a);
                                };
                                f.request = function(a) {
                                    var b = new XMLHttpRequest, c = this.currXhrId++, d = this.pendingRequests[c] = {
                                        xhr: b
                                    };
                                    b.open("GET", this.url);
                                    b.withCredentials = this.withCredentials;
                                    for(var e = p.makeIterator(this.headers), h = e.next(); !h.done; h = e.next()){
                                        var k = p.makeIterator(h.value);
                                        h = k.next().value;
                                        k = k.next().value;
                                        b.setRequestHeader(h, k);
                                    }
                                    this.isHttp && "begin" in a && "end" in a ? (b.setRequestHeader("Range", "bytes=" + a.begin + "-" + (a.end - 1)), d.expectedStatus = 206) : d.expectedStatus = 200;
                                    b.responseType = "arraybuffer";
                                    a.onError && (b.onerror = function() {
                                        a.onError(b.status);
                                    });
                                    b.onreadystatechange = this.onStateChange.bind(this, c);
                                    b.onprogress = this.onProgress.bind(this, c);
                                    d.onHeadersReceived = a.onHeadersReceived;
                                    d.onDone = a.onDone;
                                    d.onError = a.onError;
                                    d.onProgress = a.onProgress;
                                    b.send(null);
                                    return c;
                                };
                                f.onProgress = function(a, b) {
                                    (a = this.pendingRequests[a]) && (null == a.onProgress || a.onProgress(b));
                                };
                                f.onStateChange = function(a) {
                                    var b = this.pendingRequests[a];
                                    if (b) {
                                        var c = b.xhr;
                                        2 <= c.readyState && b.onHeadersReceived && (b.onHeadersReceived(), delete b.onHeadersReceived);
                                        if (4 === c.readyState && a in this.pendingRequests) {
                                            if (delete this.pendingRequests[a], 0 === c.status && this.isHttp) null == b.onError || b.onError(c.status);
                                            else {
                                                var d = c.status || 200;
                                                if (200 === d && 206 === b.expectedStatus || d === b.expectedStatus) {
                                                    if (a = c.response, a = "string" !== typeof a ? a : Va(a).buffer, 206 === d) c = c.getResponseHeader("Content-Range"), c = /bytes (\d+)-(\d+)\/(\d+)/.exec(c), b.onDone({
                                                        begin: parseInt(c[1], 10),
                                                        chunk: a
                                                    });
                                                    else if (a) b.onDone({
                                                        begin: 0,
                                                        chunk: a
                                                    });
                                                    else null == b.onError || b.onError(c.status);
                                                } else null == b.onError || b.onError(c.status);
                                            }
                                        }
                                    }
                                };
                                f.getRequestXhr = function(a) {
                                    return this.pendingRequests[a].xhr;
                                };
                                f.isPendingRequest = function(a) {
                                    return a in this.pendingRequests;
                                };
                                f.abortRequest = function(a) {
                                    var b = this.pendingRequests[a].xhr;
                                    delete this.pendingRequests[a];
                                    b.abort();
                                };
                                return g;
                            }(), Pf = function() {
                                function g(a) {
                                    this._source = a;
                                    this._manager = new Lg(a);
                                    this._rangeChunkSize = a.rangeChunkSize;
                                    this._fullRequestReader = null;
                                    this._rangeRequestReaders = [];
                                }
                                var f = g.prototype;
                                f._onRangeRequestReaderClosed = function(a) {
                                    a = this._rangeRequestReaders.indexOf(a);
                                    0 <= a && this._rangeRequestReaders.splice(a, 1);
                                };
                                f.getFullReader = function() {
                                    !this._fullRequestReader || da("PDFNetworkStream.getFullReader can only be called once.");
                                    return this._fullRequestReader = new Mg(this._manager, this._source);
                                };
                                f.getRangeReader = function(a, b) {
                                    a = new Ng(this._manager, a, b);
                                    a.onClosed = this._onRangeRequestReaderClosed.bind(this);
                                    this._rangeRequestReaders.push(a);
                                    return a;
                                };
                                f.cancelAllRequests = function(a) {
                                    var b;
                                    null == (b = this._fullRequestReader) || b.cancel(a);
                                    b = p.makeIterator(this._rangeRequestReaders.slice(0));
                                    for(var c = b.next(); !c.done; c = b.next())c.value.cancel(a);
                                };
                                return g;
                            }(), Mg = function() {
                                function g(a, b) {
                                    this._manager = a;
                                    var c = {
                                        onHeadersReceived: this._onHeadersReceived.bind(this),
                                        onDone: this._onDone.bind(this),
                                        onError: this._onError.bind(this),
                                        onProgress: this._onProgress.bind(this)
                                    };
                                    this._url = b.url;
                                    this._fullRequestId = a.requestFull(c);
                                    this._headersCapability = Promise.withResolvers();
                                    this._disableRange = b.disableRange || !1;
                                    this._contentLength = b.length;
                                    this._rangeChunkSize = b.rangeChunkSize;
                                    this._rangeChunkSize || this._disableRange || (this._disableRange = !0);
                                    this._isRangeSupported = this._isStreamingSupported = !1;
                                    this._cachedChunks = [];
                                    this._requests = [];
                                    this._done = !1;
                                    this._storedError = void 0;
                                    this.onProgress = this._filename = null;
                                }
                                var f = g.prototype;
                                f._onHeadersReceived = function() {
                                    var a = this._fullRequestId, b = this._manager.getRequestXhr(a);
                                    b = new Headers(b.getAllResponseHeaders().trim().split(/[\r\n]+/).map(function(e) {
                                        var h = p.makeIterator(e.split(": "));
                                        e = h.next().value;
                                        h = p.arrayFromIterator(h);
                                        return [
                                            e,
                                            h.join(": ")
                                        ];
                                    }));
                                    var c = rc({
                                        responseHeaders: b,
                                        isHttp: this._manager.isHttp,
                                        rangeChunkSize: this._rangeChunkSize,
                                        disableRange: this._disableRange
                                    }), d = c.suggestedLength;
                                    c.allowRangeRequests && (this._isRangeSupported = !0);
                                    this._contentLength = d || this._contentLength;
                                    this._filename = sc(b);
                                    this._isRangeSupported && this._manager.abortRequest(a);
                                    this._headersCapability.resolve();
                                };
                                f._onDone = function(a) {
                                    a && (0 < this._requests.length ? this._requests.shift().resolve({
                                        value: a.chunk,
                                        done: !1
                                    }) : this._cachedChunks.push(a.chunk));
                                    this._done = !0;
                                    if (!(0 < this._cachedChunks.length)) {
                                        a = p.makeIterator(this._requests);
                                        for(var b = a.next(); !b.done; b = a.next())b.value.resolve({
                                            value: void 0,
                                            done: !0
                                        });
                                        this._requests.length = 0;
                                    }
                                };
                                f._onError = function(a) {
                                    this._storedError = Ib(a, this._url);
                                    this._headersCapability.reject(this._storedError);
                                    a = p.makeIterator(this._requests);
                                    for(var b = a.next(); !b.done; b = a.next())b.value.reject(this._storedError);
                                    this._requests.length = 0;
                                    this._cachedChunks.length = 0;
                                };
                                f._onProgress = function(a) {
                                    var b;
                                    null == (b = this.onProgress) || b.call(this, {
                                        loaded: a.loaded,
                                        total: a.lengthComputable ? a.total : this._contentLength
                                    });
                                };
                                f.read = function() {
                                    var a = Pd(function c() {
                                        var d = this, e, h;
                                        return p.generator.createGenerator(c, function(k) {
                                            if (d._storedError) throw d._storedError;
                                            if (0 < d._cachedChunks.length) return e = d._cachedChunks.shift(), k.return({
                                                value: e,
                                                done: !1
                                            });
                                            if (d._done) return k.return({
                                                value: void 0,
                                                done: !0
                                            });
                                            h = Promise.withResolvers();
                                            d._requests.push(h);
                                            return k.return(h.promise);
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cancel = function(a) {
                                    this._done = !0;
                                    this._headersCapability.reject(a);
                                    a = p.makeIterator(this._requests);
                                    for(var b = a.next(); !b.done; b = a.next())b.value.resolve({
                                        value: void 0,
                                        done: !0
                                    });
                                    this._requests.length = 0;
                                    this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId);
                                    this._fullRequestReader = null;
                                };
                                return Rd(g, [
                                    {
                                        key: "filename",
                                        get: function() {
                                            return this._filename;
                                        }
                                    },
                                    {
                                        key: "isRangeSupported",
                                        get: function() {
                                            return this._isRangeSupported;
                                        }
                                    },
                                    {
                                        key: "isStreamingSupported",
                                        get: function() {
                                            return this._isStreamingSupported;
                                        }
                                    },
                                    {
                                        key: "contentLength",
                                        get: function() {
                                            return this._contentLength;
                                        }
                                    },
                                    {
                                        key: "headersReady",
                                        get: function() {
                                            return this._headersCapability.promise;
                                        }
                                    }
                                ]);
                            }(), Ng = function() {
                                function g(a, b, c) {
                                    this._manager = a;
                                    var d = {
                                        onDone: this._onDone.bind(this),
                                        onError: this._onError.bind(this),
                                        onProgress: this._onProgress.bind(this)
                                    };
                                    this._url = a.url;
                                    this._requestId = a.requestRange(b, c, d);
                                    this._requests = [];
                                    this._queuedChunk = null;
                                    this._done = !1;
                                    this._storedError = void 0;
                                    this.onClosed = this.onProgress = null;
                                }
                                var f = g.prototype;
                                f._close = function() {
                                    var a;
                                    null == (a = this.onClosed) || a.call(this, this);
                                };
                                f._onDone = function(a) {
                                    a = a.chunk;
                                    0 < this._requests.length ? this._requests.shift().resolve({
                                        value: a,
                                        done: !1
                                    }) : this._queuedChunk = a;
                                    this._done = !0;
                                    a = p.makeIterator(this._requests);
                                    for(var b = a.next(); !b.done; b = a.next())b.value.resolve({
                                        value: void 0,
                                        done: !0
                                    });
                                    this._requests.length = 0;
                                    this._close();
                                };
                                f._onError = function(a) {
                                    this._storedError = Ib(a, this._url);
                                    a = p.makeIterator(this._requests);
                                    for(var b = a.next(); !b.done; b = a.next())b.value.reject(this._storedError);
                                    this._requests.length = 0;
                                    this._queuedChunk = null;
                                };
                                f._onProgress = function(a) {
                                    if (!this.isStreamingSupported) {
                                        var b;
                                        null == (b = this.onProgress) || b.call(this, {
                                            loaded: a.loaded
                                        });
                                    }
                                };
                                f.read = function() {
                                    var a = Pd(function c() {
                                        var d = this, e, h;
                                        return p.generator.createGenerator(c, function(k) {
                                            if (d._storedError) throw d._storedError;
                                            if (null !== d._queuedChunk) return e = d._queuedChunk, d._queuedChunk = null, k.return({
                                                value: e,
                                                done: !1
                                            });
                                            if (d._done) return k.return({
                                                value: void 0,
                                                done: !0
                                            });
                                            h = Promise.withResolvers();
                                            d._requests.push(h);
                                            return k.return(h.promise);
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cancel = function() {
                                    this._done = !0;
                                    for(var a = p.makeIterator(this._requests), b = a.next(); !b.done; b = a.next())b.value.resolve({
                                        value: void 0,
                                        done: !0
                                    });
                                    this._requests.length = 0;
                                    this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId);
                                    this._close();
                                };
                                return Rd(g, [
                                    {
                                        key: "isStreamingSupported",
                                        get: function() {
                                            return !1;
                                        }
                                    }
                                ]);
                            }();
                            F(3921);
                            var Og = /^[a-z][a-z0-9\-+.]+:/i;
                            (function() {
                                function g(a) {
                                    this.source = a;
                                    var b = a.url;
                                    if (Og.test(b)) b = new URL(b);
                                    else {
                                        var c = bb.get("url");
                                        b = new URL(c.pathToFileURL(b));
                                    }
                                    this.url = b;
                                    this.isHttp = "http:" === this.url.protocol || "https:" === this.url.protocol;
                                    this.isFsUrl = "file:" === this.url.protocol;
                                    this.headers = qc(this.isHttp, a.httpHeaders);
                                    this._fullRequestReader = null;
                                    this._rangeRequestReaders = [];
                                }
                                var f = g.prototype;
                                f.getFullReader = function() {
                                    !this._fullRequestReader || da("PDFNodeStream.getFullReader can only be called once.");
                                    return this._fullRequestReader = this.isFsUrl ? new Pg(this) : new Qg(this);
                                };
                                f.getRangeReader = function(a, b) {
                                    if (b <= this._progressiveDataLength) return null;
                                    a = this.isFsUrl ? new Rg(this, a, b) : new Sg(this, a, b);
                                    this._rangeRequestReaders.push(a);
                                    return a;
                                };
                                f.cancelAllRequests = function(a) {
                                    var b;
                                    null == (b = this._fullRequestReader) || b.cancel(a);
                                    b = p.makeIterator(this._rangeRequestReaders.slice(0));
                                    for(var c = b.next(); !c.done; c = b.next())c.value.cancel(a);
                                };
                                return vc(g, [
                                    {
                                        key: "_progressiveDataLength",
                                        get: function() {
                                            var a, b;
                                            return null != (a = null == (b = this._fullRequestReader) ? void 0 : b._loaded) ? a : 0;
                                        }
                                    }
                                ]);
                            })();
                            var Qe = function() {
                                function g(a) {
                                    this._url = a.url;
                                    this._done = !1;
                                    this.onProgress = this._storedError = null;
                                    a = a.source;
                                    this._contentLength = a.length;
                                    this._loaded = 0;
                                    this._filename = null;
                                    this._disableRange = a.disableRange || !1;
                                    this._rangeChunkSize = a.rangeChunkSize;
                                    this._rangeChunkSize || this._disableRange || (this._disableRange = !0);
                                    this._isStreamingSupported = !a.disableStream;
                                    this._isRangeSupported = !a.disableRange;
                                    this._readableStream = null;
                                    this._readCapability = Promise.withResolvers();
                                    this._headersCapability = Promise.withResolvers();
                                }
                                var f = g.prototype;
                                f.read = function() {
                                    var a = Td(function c() {
                                        var d, e = this, h, k;
                                        return p.generator.createGenerator(c, function(l) {
                                            if (1 == l.nextAddress) return l.yield(e._readCapability.promise, 2);
                                            if (e._done) return l.return({
                                                value: void 0,
                                                done: !0
                                            });
                                            if (e._storedError) throw e._storedError;
                                            h = e._readableStream.read();
                                            if (null === h) return e._readCapability = Promise.withResolvers(), l.return(e.read());
                                            e._loaded += h.length;
                                            null == (d = e.onProgress) || d.call(e, {
                                                loaded: e._loaded,
                                                total: e._contentLength
                                            });
                                            k = new Uint8Array(h).buffer;
                                            return l.return({
                                                value: k,
                                                done: !1
                                            });
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cancel = function(a) {
                                    this._readableStream ? this._readableStream.destroy(a) : this._error(a);
                                };
                                f._error = function(a) {
                                    this._storedError = a;
                                    this._readCapability.resolve();
                                };
                                f._setReadableStream = function(a) {
                                    var b = this;
                                    this._readableStream = a;
                                    a.on("readable", function() {
                                        b._readCapability.resolve();
                                    });
                                    a.on("end", function() {
                                        a.destroy();
                                        b._done = !0;
                                        b._readCapability.resolve();
                                    });
                                    a.on("error", function(c) {
                                        b._error(c);
                                    });
                                    !this._isStreamingSupported && this._isRangeSupported && this._error(new cb("streaming is disabled"));
                                    this._storedError && this._readableStream.destroy(this._storedError);
                                };
                                return vc(g, [
                                    {
                                        key: "headersReady",
                                        get: function() {
                                            return this._headersCapability.promise;
                                        }
                                    },
                                    {
                                        key: "filename",
                                        get: function() {
                                            return this._filename;
                                        }
                                    },
                                    {
                                        key: "contentLength",
                                        get: function() {
                                            return this._contentLength;
                                        }
                                    },
                                    {
                                        key: "isRangeSupported",
                                        get: function() {
                                            return this._isRangeSupported;
                                        }
                                    },
                                    {
                                        key: "isStreamingSupported",
                                        get: function() {
                                            return this._isStreamingSupported;
                                        }
                                    }
                                ]);
                            }(), Re = function() {
                                function g(a) {
                                    this._url = a.url;
                                    this._done = !1;
                                    this.onProgress = this._storedError = null;
                                    this._loaded = 0;
                                    this._readableStream = null;
                                    this._readCapability = Promise.withResolvers();
                                    this._isStreamingSupported = !a.source.disableStream;
                                }
                                var f = g.prototype;
                                f.read = function() {
                                    var a = Td(function c() {
                                        var d, e = this, h, k;
                                        return p.generator.createGenerator(c, function(l) {
                                            if (1 == l.nextAddress) return l.yield(e._readCapability.promise, 2);
                                            if (e._done) return l.return({
                                                value: void 0,
                                                done: !0
                                            });
                                            if (e._storedError) throw e._storedError;
                                            h = e._readableStream.read();
                                            if (null === h) return e._readCapability = Promise.withResolvers(), l.return(e.read());
                                            e._loaded += h.length;
                                            null == (d = e.onProgress) || d.call(e, {
                                                loaded: e._loaded
                                            });
                                            k = new Uint8Array(h).buffer;
                                            return l.return({
                                                value: k,
                                                done: !1
                                            });
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cancel = function(a) {
                                    this._readableStream ? this._readableStream.destroy(a) : this._error(a);
                                };
                                f._error = function(a) {
                                    this._storedError = a;
                                    this._readCapability.resolve();
                                };
                                f._setReadableStream = function(a) {
                                    var b = this;
                                    this._readableStream = a;
                                    a.on("readable", function() {
                                        b._readCapability.resolve();
                                    });
                                    a.on("end", function() {
                                        a.destroy();
                                        b._done = !0;
                                        b._readCapability.resolve();
                                    });
                                    a.on("error", function(c) {
                                        b._error(c);
                                    });
                                    this._storedError && this._readableStream.destroy(this._storedError);
                                };
                                return vc(g, [
                                    {
                                        key: "isStreamingSupported",
                                        get: function() {
                                            return this._isStreamingSupported;
                                        }
                                    }
                                ]);
                            }(), Qg = function(g) {
                                function f(a) {
                                    var b = g.call(this, a) || this;
                                    var c = Object.fromEntries(a.headers);
                                    b._request = Vd(b._url, c, function(d) {
                                        if (404 === d.statusCode) d = new db('Missing PDF "' + b._url + '".'), b._storedError = d, b._headersCapability.reject(d);
                                        else {
                                            b._headersCapability.resolve();
                                            b._setReadableStream(d);
                                            d = new Headers(b._readableStream.headers);
                                            var e = rc({
                                                responseHeaders: d,
                                                isHttp: a.isHttp,
                                                rangeChunkSize: b._rangeChunkSize,
                                                disableRange: b._disableRange
                                            }), h = e.suggestedLength;
                                            b._isRangeSupported = e.allowRangeRequests;
                                            b._contentLength = h || b._contentLength;
                                            b._filename = sc(d);
                                        }
                                    });
                                    b._request.on("error", function(d) {
                                        b._storedError = d;
                                        b._headersCapability.reject(d);
                                    });
                                    b._request.end();
                                    return b;
                                }
                                Jb(f, g);
                                return f;
                            }(Qe), Sg = function(g) {
                                function f(a, b, c) {
                                    var d = g.call(this, a) || this;
                                    a = Object.fromEntries(a.headers);
                                    a.Range = "bytes=" + b + "-" + (c - 1);
                                    d._request = Vd(d._url, a, function(e) {
                                        404 === e.statusCode ? (e = new db('Missing PDF "' + d._url + '".'), d._storedError = e) : d._setReadableStream(e);
                                    });
                                    d._request.on("error", function(e) {
                                        d._storedError = e;
                                    });
                                    d._request.end();
                                    return d;
                                }
                                Jb(f, g);
                                return f;
                            }(Re), Pg = function(g) {
                                function f(a) {
                                    var b = g.call(this, a) || this;
                                    var c = bb.get("fs");
                                    c.promises.lstat(b._url).then(function(d) {
                                        b._contentLength = d.size;
                                        b._setReadableStream(c.createReadStream(b._url));
                                        b._headersCapability.resolve();
                                    }, function(d) {
                                        "ENOENT" === d.code && (d = new db('Missing PDF "' + b._url + '".'));
                                        b._storedError = d;
                                        b._headersCapability.reject(d);
                                    });
                                    return b;
                                }
                                Jb(f, g);
                                return f;
                            }(Qe), Rg = function(g) {
                                function f(a, b, c) {
                                    a = g.call(this, a) || this;
                                    var d = bb.get("fs");
                                    a._setReadableStream(d.createReadStream(a._url, {
                                        start: b,
                                        end: c - 1
                                    }));
                                    return a;
                                }
                                Jb(f, g);
                                return f;
                            }(Re), Za = function() {
                                function g(a) {
                                    var b = this, c, d = a.textContentSource, e = a.container;
                                    a = a.viewport;
                                    this.__capability = Promise.withResolvers();
                                    this.__container = null;
                                    this.__disableProcessItems = !1;
                                    this.__fontInspectorEnabled = !(null == (c = globalThis.FontInspector) || !c.enabled);
                                    this.__layoutTextParams = this.__lang = null;
                                    this.__pageWidth = this.__pageHeight = 0;
                                    this.__rootContainer = this.__reader = null;
                                    this.__scale = this.__rotation = 0;
                                    this.__styleCache = Object.create(null);
                                    this.__textContentItemsStr = [];
                                    this.__textContentSource = null;
                                    this.__textDivs = [];
                                    this.__textDivProperties = new WeakMap;
                                    this.__transform = null;
                                    if (d instanceof ReadableStream) this.__textContentSource = d;
                                    else if ("object" === typeof d) this.__textContentSource = new ReadableStream({
                                        start: function(l) {
                                            l.enqueue(d);
                                            l.close();
                                        }
                                    });
                                    else throw Error('No "textContentSource" parameter specified.');
                                    this.__container = this.__rootContainer = e;
                                    this.__scale = a.scale * (globalThis.devicePixelRatio || 1);
                                    this.__rotation = a.rotation;
                                    this.__layoutTextParams = {
                                        div: null,
                                        properties: null,
                                        ctx: null
                                    };
                                    c = a.rawDims;
                                    var h = c.pageWidth, k = c.pageHeight;
                                    this.__transform = [
                                        1,
                                        0,
                                        0,
                                        -1,
                                        -c.pageX,
                                        c.pageY + k
                                    ];
                                    this.__pageWidth = h;
                                    this.__pageHeight = k;
                                    g.__ensureMinFontSizeComputed();
                                    ab(e, a);
                                    this.__capability.promise.finally(function() {
                                        g.__pendingTextLayers.delete(b);
                                        b.__layoutTextParams = null;
                                        b.__styleCache = null;
                                    }).catch(function() {});
                                }
                                var f = g.prototype;
                                f.render = function() {
                                    function a() {
                                        b.__reader.read().then(function(c) {
                                            var d, e = c.value;
                                            c.done ? b.__capability.resolve() : (null != (d = b.__lang) ? d : b.__lang = e.lang, Object.assign(b.__styleCache, e.styles), b.__processItems(e.items), a());
                                        }, b.__capability.reject);
                                    }
                                    var b = this;
                                    this.__reader = this.__textContentSource.getReader();
                                    g.__pendingTextLayers.add(this);
                                    a();
                                    return this.__capability.promise;
                                };
                                f.update = function(a) {
                                    var b = a.viewport;
                                    a = void 0 === a.onBefore ? null : a.onBefore;
                                    var c = b.scale * (globalThis.devicePixelRatio || 1);
                                    b = b.rotation;
                                    b !== this.__rotation && (null == a || a(), this.__rotation = b, ab(this.__rootContainer, {
                                        rotation: b
                                    }));
                                    if (c !== this.__scale) for(null == a || a(), this.__scale = c, b = {
                                        div: null,
                                        properties: null,
                                        ctx: g.__getCtx(this.__lang)
                                    }, a = p.makeIterator(this.__textDivs), c = a.next(); !c.done; c = a.next())c = c.value, b.properties = this.__textDivProperties.get(c), b.div = c, this.__layout(b);
                                };
                                f.cancel = function() {
                                    var a, b = new cb("TextLayer task cancelled.");
                                    null == (a = this.__reader) || a.cancel(b).catch(function() {});
                                    this.__reader = null;
                                    this.__capability.reject(b);
                                };
                                f.__processItems = function(a) {
                                    var b, c;
                                    if (!this.__disableProcessItems) {
                                        null != (c = (b = this.__layoutTextParams).ctx) ? c : b.ctx = g.__getCtx(this.__lang);
                                        b = this.__textDivs;
                                        c = this.__textContentItemsStr;
                                        a = p.makeIterator(a);
                                        for(var d = a.next(); !d.done; d = a.next()){
                                            d = d.value;
                                            if (1E5 < b.length) {
                                                R("Ignoring additional textDivs for performance reasons.");
                                                this.__disableProcessItems = !0;
                                                break;
                                            }
                                            if (void 0 === d.str) {
                                                if ("beginMarkedContentProps" === d.type || "beginMarkedContent" === d.type) {
                                                    var e = this.__container;
                                                    this.__container = document.createElement("span");
                                                    this.__container.classList.add("markedContent");
                                                    null !== d.id && this.__container.setAttribute("id", "" + d.id);
                                                    e.append(this.__container);
                                                } else "endMarkedContent" === d.type && (this.__container = this.__container.parentNode);
                                            } else c.push(d.str), this.__appendText(d);
                                        }
                                    }
                                };
                                f.__appendText = function(a) {
                                    var b = document.createElement("span"), c = {
                                        angle: 0,
                                        canvasWidth: 0,
                                        hasText: "" !== a.str,
                                        hasEOL: a.hasEOL,
                                        fontSize: 0
                                    };
                                    this.__textDivs.push(b);
                                    var d = fa.transform(this.__transform, a.transform), e = Math.atan2(d[1], d[0]), h = this.__styleCache[a.fontName];
                                    h.vertical && (e += Math.PI / 2);
                                    var k = this.__fontInspectorEnabled && h.fontSubstitution || h.fontFamily;
                                    k = g.fontFamilyMap.get(k) || k;
                                    var l = Math.hypot(d[2], d[3]), m = l * g.__getAscent(k, this.__lang);
                                    if (0 === e) {
                                        var n = d[4];
                                        d = d[5] - m;
                                    } else n = d[4] + m * Math.sin(e), d = d[5] - m * Math.cos(e);
                                    m = b.style;
                                    this.__container === this.__rootContainer ? (m.left = (100 * n / this.__pageWidth).toFixed(2) + "%", m.top = (100 * d / this.__pageHeight).toFixed(2) + "%") : (m.left = "calc(var(--scale-factor)*" + n.toFixed(2) + "px)", m.top = "calc(var(--scale-factor)*" + d.toFixed(2) + "px)");
                                    m.fontSize = "calc(var(--scale-factor)*" + (g.__minFontSize * l).toFixed(2) + "px)";
                                    m.fontFamily = k;
                                    c.fontSize = l;
                                    b.setAttribute("role", "presentation");
                                    b.textContent = a.str;
                                    b.dir = a.dir;
                                    this.__fontInspectorEnabled && (b.dataset.fontName = h.fontSubstitutionLoadedName || a.fontName);
                                    0 !== e && (c.angle = 180 / Math.PI * e);
                                    e = !1;
                                    1 < a.str.length ? e = !0 : " " !== a.str && a.transform[0] !== a.transform[3] && (k = Math.abs(a.transform[0]), l = Math.abs(a.transform[3]), k !== l && 1.5 < Math.max(k, l) / Math.min(k, l) && (e = !0));
                                    e && (c.canvasWidth = h.vertical ? a.height : a.width);
                                    this.__textDivProperties.set(b, c);
                                    this.__layoutTextParams.div = b;
                                    this.__layoutTextParams.properties = c;
                                    this.__layout(this.__layoutTextParams);
                                    c.hasText && this.__container.append(b);
                                    c.hasEOL && (a = document.createElement("br"), a.setAttribute("role", "presentation"), this.__container.append(a));
                                };
                                f.__layout = function(a) {
                                    var b = a.div, c = a.properties, d = a.ctx;
                                    a = b.style;
                                    var e = "";
                                    1 < g.__minFontSize && (e = "scale(" + 1 / g.__minFontSize + ")");
                                    if (0 !== c.canvasWidth && c.hasText) {
                                        var h = c.canvasWidth;
                                        g.__ensureCtxFont(d, c.fontSize * this.__scale, a.fontFamily);
                                        b = d.measureText(b.textContent).width;
                                        0 < b && (e = "scaleX(" + h * this.__scale / b + ") " + e);
                                    }
                                    0 !== c.angle && (e = "rotate(" + c.angle + "deg) " + e);
                                    0 < e.length && (a.transform = e);
                                };
                                g.cleanup = function() {
                                    if (!(0 < this.__pendingTextLayers.size)) {
                                        this.__ascentCache.clear();
                                        for(var a = p.makeIterator(this.__canvasContexts.values()), b = a.next(); !b.done; b = a.next())b.value.canvas.remove();
                                        this.__canvasContexts.clear();
                                    }
                                };
                                g.__getCtx = function(a) {
                                    void 0 === a && (a = null);
                                    var b = this.__canvasContexts.get(a || (a = ""));
                                    b || (b = document.createElement("canvas"), b.className = "hiddenCanvasElement", b.lang = a, document.body.append(b), b = b.getContext("2d", {
                                        alpha: !1,
                                        willReadFrequently: !0
                                    }), this.__canvasContexts.set(a, b), this.__canvasCtxFonts.set(b, {
                                        size: 0,
                                        family: ""
                                    }));
                                    return b;
                                };
                                g.__ensureCtxFont = function(a, b, c) {
                                    var d = this.__canvasCtxFonts.get(a);
                                    if (b !== d.size || c !== d.family) a.font = b + "px " + c, d.size = b, d.family = c;
                                };
                                g.__ensureMinFontSizeComputed = function() {
                                    if (null === this.__minFontSize) {
                                        var a = document.createElement("div");
                                        a.style.opacity = 0;
                                        a.style.lineHeight = 1;
                                        a.style.fontSize = "1px";
                                        a.style.position = "absolute";
                                        a.textContent = "X";
                                        document.body.append(a);
                                        this.__minFontSize = a.getBoundingClientRect().height;
                                        a.remove();
                                    }
                                };
                                g.__getAscent = function(a, b) {
                                    var c = this.__ascentCache.get(a);
                                    if (c) return c;
                                    b = this.__getCtx(b);
                                    b.canvas.width = b.canvas.height = 30;
                                    this.__ensureCtxFont(b, 30, a);
                                    var d = b.measureText("");
                                    c = d.fontBoundingBoxAscent;
                                    d = Math.abs(d.fontBoundingBoxDescent);
                                    if (c) return c /= c + d, this.__ascentCache.set(a, c), b.canvas.width = b.canvas.height = 0, c;
                                    b.strokeStyle = "red";
                                    b.clearRect(0, 0, 30, 30);
                                    b.strokeText("g", 0, 0);
                                    var e = b.getImageData(0, 0, 30, 30).data;
                                    d = 0;
                                    for(c = e.length - 1 - 3; 0 <= c; c -= 4)if (0 < e[c]) {
                                        d = Math.ceil(c / 4 / 30);
                                        break;
                                    }
                                    b.clearRect(0, 0, 30, 30);
                                    b.strokeText("A", 0, 30);
                                    e = b.getImageData(0, 0, 30, 30).data;
                                    for(var h = c = 0, k = e.length; h < k; h += 4)if (0 < e[h]) {
                                        c = 30 - Math.floor(h / 4 / 30);
                                        break;
                                    }
                                    b.canvas.width = b.canvas.height = 0;
                                    b = c ? c / (c + d) : .8;
                                    this.__ascentCache.set(a, b);
                                    return b;
                                };
                                return Ff(g, [
                                    {
                                        key: "textDivs",
                                        get: function() {
                                            return this.__textDivs;
                                        }
                                    },
                                    {
                                        key: "textContentItemsStr",
                                        get: function() {
                                            return this.__textContentItemsStr;
                                        }
                                    }
                                ], [
                                    {
                                        key: "fontFamilyMap",
                                        get: function() {
                                            var a = Ka.platform, b = a.isWindows;
                                            a = a.isFirefox;
                                            return qa(this, "fontFamilyMap", new Map([
                                                [
                                                    "sans-serif",
                                                    (b && a ? "Calibri, " : "") + "sans-serif"
                                                ],
                                                [
                                                    "monospace",
                                                    (b && a ? "Lucida Console, " : "") + "monospace"
                                                ]
                                            ]));
                                        }
                                    }
                                ]);
                            }();
                            Za.__ascentCache = new Map;
                            Za.__canvasContexts = new Map;
                            Za.__canvasCtxFonts = new WeakMap;
                            Za.__minFontSize = null;
                            Za.__pendingTextLayers = new Set;
                            var Tc = function() {
                                function g() {}
                                g.textContent = function(f) {
                                    function a(d) {
                                        var e;
                                        if (d) {
                                            var h = null, k = d.name;
                                            if ("#text" === k) h = d.value;
                                            else {
                                                if (!g.shouldBuildText(k)) return;
                                                null != d && null != (e = d.attributes) && e.textContent ? h = d.attributes.textContent : d.value && (h = d.value);
                                            }
                                            null !== h && b.push({
                                                str: h
                                            });
                                            if (d.children) for(d = p.makeIterator(d.children), e = d.next(); !e.done; e = d.next())a(e.value);
                                        }
                                    }
                                    var b = [], c = {
                                        items: b,
                                        styles: Object.create(null)
                                    };
                                    a(f);
                                    return c;
                                };
                                g.shouldBuildText = function(f) {
                                    return !("textarea" === f || "input" === f || "option" === f || "select" === f);
                                };
                                return g;
                            }(), Lf = vg, Jf = ae, Mf = wg, Kf = be, Zd = function() {
                                function g() {
                                    this._capability = Promise.withResolvers();
                                    this._worker = this._transport = null;
                                    this.docId = "d" + g.__docId++;
                                    this.destroyed = !1;
                                    this.onProgress = this.onPassword = null;
                                }
                                g.prototype.destroy = function() {
                                    var f = eb(function b() {
                                        var c = this, d, e, h, k;
                                        return p.generator.createGenerator(b, function(l) {
                                            switch(l.nextAddress){
                                                case 1:
                                                    return c.destroyed = !0, l.setCatchFinallyBlocks(2), null != (d = c._worker) && d.port && (c._worker._pendingDestroy = !0), l.yield(null == (e = c._transport) ? void 0 : e.destroy(), 4);
                                                case 4:
                                                    l.leaveTryBlock(3);
                                                    break;
                                                case 2:
                                                    throw h = l.enterCatchBlock(), null != (k = c._worker) && k.port && delete c._worker._pendingDestroy, h;
                                                case 3:
                                                    c._transport = null, c._worker && (c._worker.destroy(), c._worker = null), l.jumpToEnd();
                                            }
                                        });
                                    });
                                    return function() {
                                        return f.apply(this, arguments);
                                    };
                                }();
                                return fb(g, [
                                    {
                                        key: "promise",
                                        get: function() {
                                            return this._capability.promise;
                                        }
                                    }
                                ]);
                            }();
                            Zd.__docId = 0;
                            var $d = function() {
                                function g(a, b, c, d) {
                                    void 0 === c && (c = !1);
                                    void 0 === d && (d = null);
                                    this.length = a;
                                    this.initialData = b;
                                    this.progressiveDone = c;
                                    this.contentDispositionFilename = d;
                                    this._rangeListeners = [];
                                    this._progressListeners = [];
                                    this._progressiveReadListeners = [];
                                    this._progressiveDoneListeners = [];
                                    this._readyCapability = Promise.withResolvers();
                                }
                                var f = g.prototype;
                                f.addRangeListener = function(a) {
                                    this._rangeListeners.push(a);
                                };
                                f.addProgressListener = function(a) {
                                    this._progressListeners.push(a);
                                };
                                f.addProgressiveReadListener = function(a) {
                                    this._progressiveReadListeners.push(a);
                                };
                                f.addProgressiveDoneListener = function(a) {
                                    this._progressiveDoneListeners.push(a);
                                };
                                f.onDataRange = function(a, b) {
                                    for(var c = p.makeIterator(this._rangeListeners), d = c.next(); !d.done; d = c.next())d = d.value, d(a, b);
                                };
                                f.onDataProgress = function(a, b) {
                                    var c = this;
                                    this._readyCapability.promise.then(function() {
                                        for(var d = p.makeIterator(c._progressListeners), e = d.next(); !e.done; e = d.next())e = e.value, e(a, b);
                                    });
                                };
                                f.onDataProgressiveRead = function(a) {
                                    var b = this;
                                    this._readyCapability.promise.then(function() {
                                        for(var c = p.makeIterator(b._progressiveReadListeners), d = c.next(); !d.done; d = c.next())d = d.value, d(a);
                                    });
                                };
                                f.onDataProgressiveDone = function() {
                                    var a = this;
                                    this._readyCapability.promise.then(function() {
                                        for(var b = p.makeIterator(a._progressiveDoneListeners), c = b.next(); !c.done; c = b.next())c = c.value, c();
                                    });
                                };
                                f.transportReady = function() {
                                    this._readyCapability.resolve();
                                };
                                f.requestDataRange = function() {
                                    da("Abstract method PDFDataRangeTransport.requestDataRange");
                                };
                                f.abort = function() {};
                                return g;
                            }(), Tg = function() {
                                function g(a, b) {
                                    this._pdfInfo = a;
                                    this._transport = b;
                                }
                                var f = g.prototype;
                                f.getPage = function(a) {
                                    return this._transport.getPage(a);
                                };
                                f.getPageIndex = function(a) {
                                    return this._transport.getPageIndex(a);
                                };
                                f.getDestinations = function() {
                                    return this._transport.getDestinations();
                                };
                                f.getDestination = function(a) {
                                    return this._transport.getDestination(a);
                                };
                                f.getPageLabels = function() {
                                    return this._transport.getPageLabels();
                                };
                                f.getPageLayout = function() {
                                    return this._transport.getPageLayout();
                                };
                                f.getPageMode = function() {
                                    return this._transport.getPageMode();
                                };
                                f.getViewerPreferences = function() {
                                    return this._transport.getViewerPreferences();
                                };
                                f.getOpenAction = function() {
                                    return this._transport.getOpenAction();
                                };
                                f.getAttachments = function() {
                                    return this._transport.getAttachments();
                                };
                                f.getJSActions = function() {
                                    return this._transport.getDocJSActions();
                                };
                                f.getOutline = function() {
                                    return this._transport.getOutline();
                                };
                                f.getOptionalContentConfig = function(a) {
                                    a = void 0 === a ? {} : a;
                                    a = this._transport.getRenderingIntent(void 0 === a.intent ? "display" : a.intent).renderingIntent;
                                    return this._transport.getOptionalContentConfig(a);
                                };
                                f.getPermissions = function() {
                                    return this._transport.getPermissions();
                                };
                                f.getMetadata = function() {
                                    return this._transport.getMetadata();
                                };
                                f.getMarkInfo = function() {
                                    return this._transport.getMarkInfo();
                                };
                                f.getData = function() {
                                    return this._transport.getData();
                                };
                                f.saveDocument = function() {
                                    return this._transport.saveDocument();
                                };
                                f.getDownloadInfo = function() {
                                    return this._transport.downloadInfoCapability.promise;
                                };
                                f.cleanup = function(a) {
                                    void 0 === a && (a = !1);
                                    return this._transport.startCleanup(a || this.isPureXfa);
                                };
                                f.destroy = function() {
                                    return this.loadingTask.destroy();
                                };
                                f.cachedPageNumber = function(a) {
                                    return this._transport.cachedPageNumber(a);
                                };
                                f.getFieldObjects = function() {
                                    return this._transport.getFieldObjects();
                                };
                                f.hasJSActions = function() {
                                    return this._transport.hasJSActions();
                                };
                                f.getCalculationOrderIds = function() {
                                    return this._transport.getCalculationOrderIds();
                                };
                                return fb(g, [
                                    {
                                        key: "annotationStorage",
                                        get: function() {
                                            return this._transport.annotationStorage;
                                        }
                                    },
                                    {
                                        key: "canvasFactory",
                                        get: function() {
                                            return this._transport.canvasFactory;
                                        }
                                    },
                                    {
                                        key: "filterFactory",
                                        get: function() {
                                            return this._transport.filterFactory;
                                        }
                                    },
                                    {
                                        key: "numPages",
                                        get: function() {
                                            return this._pdfInfo.numPages;
                                        }
                                    },
                                    {
                                        key: "fingerprints",
                                        get: function() {
                                            return this._pdfInfo.fingerprints;
                                        }
                                    },
                                    {
                                        key: "isPureXfa",
                                        get: function() {
                                            return qa(this, "isPureXfa", !!this._transport._htmlForXfa);
                                        }
                                    },
                                    {
                                        key: "allXfaHtml",
                                        get: function() {
                                            return this._transport._htmlForXfa;
                                        }
                                    },
                                    {
                                        key: "loadingParams",
                                        get: function() {
                                            return this._transport.loadingParams;
                                        }
                                    },
                                    {
                                        key: "loadingTask",
                                        get: function() {
                                            return this._transport.loadingTask;
                                        }
                                    }
                                ]);
                            }(), Ug = function() {
                                function g(a, b, c, d) {
                                    void 0 === d && (d = !1);
                                    this.__delayedCleanupTimeout = null;
                                    this.__pendingCleanup = !1;
                                    this._pageIndex = a;
                                    this._pageInfo = b;
                                    this._transport = c;
                                    this._stats = d ? new Ee : null;
                                    this._pdfBug = d;
                                    this.commonObjs = c.commonObjs;
                                    this.objs = new Se;
                                    this._maybeCleanupAfterRender = !1;
                                    this._intentStates = new Map;
                                    this.destroyed = !1;
                                }
                                var f = g.prototype;
                                f.getViewport = function(a) {
                                    a = void 0 === a ? {} : a;
                                    return new Wb({
                                        viewBox: this.view,
                                        scale: a.scale,
                                        rotation: void 0 === a.rotation ? this.rotate : a.rotation,
                                        offsetX: void 0 === a.offsetX ? 0 : a.offsetX,
                                        offsetY: void 0 === a.offsetY ? 0 : a.offsetY,
                                        dontFlip: void 0 === a.dontFlip ? !1 : a.dontFlip
                                    });
                                };
                                f.getAnnotations = function(a) {
                                    a = void 0 === a ? {} : a;
                                    a = this._transport.getRenderingIntent(void 0 === a.intent ? "display" : a.intent).renderingIntent;
                                    return this._transport.getAnnotations(this._pageIndex, a);
                                };
                                f.getJSActions = function() {
                                    return this._transport.getPageJSActions(this._pageIndex);
                                };
                                f.getXfa = function() {
                                    var a = eb(function c() {
                                        var d, e = this;
                                        return p.generator.createGenerator(c, function(h) {
                                            return h.return((null == (d = e._transport._htmlForXfa) ? void 0 : d.children[e._pageIndex]) || null);
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.render = function(a) {
                                    function b(D) {
                                        x.renderTasks.delete(C);
                                        if (c._maybeCleanupAfterRender || B) c.__pendingCleanup = !0;
                                        c.__tryCleanup(!B);
                                        D ? (C.capability.reject(D), c._abortOperatorList({
                                            intentState: x,
                                            reason: D instanceof Error ? D : Error(D)
                                        })) : C.capability.resolve();
                                        if (c._stats) {
                                            var H;
                                            c._stats.timeEnd("Rendering");
                                            c._stats.timeEnd("Overall");
                                            null != (H = globalThis.Stats) && H.enabled && globalThis.Stats.add(c.pageNumber, c._stats);
                                        }
                                    }
                                    var c = this, d, e, h = a.canvasContext, k = a.viewport, l = void 0 === a.intent ? "display" : a.intent, m = void 0 === a.annotationMode ? Ya.ENABLE : a.annotationMode, n = void 0 === a.transform ? null : a.transform, q = void 0 === a.background ? null : a.background, r = void 0 === a.optionalContentConfigPromise ? null : a.optionalContentConfigPromise, t = void 0 === a.annotationCanvasMap ? null : a.annotationCanvasMap, u = void 0 === a.pageColors ? null : a.pageColors, v = void 0 === a.printAnnotationStorage ? null : a.printAnnotationStorage;
                                    a = void 0 === a.isEditing ? !1 : a.isEditing;
                                    null == (d = this._stats) || d.time("Overall");
                                    d = this._transport.getRenderingIntent(l, m, v, a);
                                    var w = d.renderingIntent;
                                    l = d.cacheKey;
                                    this.__pendingCleanup = !1;
                                    this.__abortDelayedCleanup();
                                    r || (r = this._transport.getOptionalContentConfig(w));
                                    var x = this._intentStates.get(l);
                                    x || (x = Object.create(null), this._intentStates.set(l, x));
                                    x.streamReaderCancelTimeout && (clearTimeout(x.streamReaderCancelTimeout), x.streamReaderCancelTimeout = null);
                                    var B = !!(w & 4);
                                    if (!x.displayReadyCapability) {
                                        var z;
                                        x.displayReadyCapability = Promise.withResolvers();
                                        x.operatorList = {
                                            fnArray: [],
                                            argsArray: [],
                                            lastChunk: !1,
                                            separateAnnots: null
                                        };
                                        null == (z = this._stats) || z.time("Page Request");
                                        this._pumpOperatorList(d);
                                    }
                                    var C = new Te({
                                        callback: b,
                                        params: {
                                            canvasContext: h,
                                            viewport: k,
                                            transform: n,
                                            background: q
                                        },
                                        objs: this.objs,
                                        commonObjs: this.commonObjs,
                                        annotationCanvasMap: t,
                                        operatorList: x.operatorList,
                                        pageIndex: this._pageIndex,
                                        canvasFactory: this._transport.canvasFactory,
                                        filterFactory: this._transport.filterFactory,
                                        useRequestAnimationFrame: !B,
                                        pdfBug: this._pdfBug,
                                        pageColors: u
                                    });
                                    ((e = x).renderTasks || (e.renderTasks = new Set)).add(C);
                                    e = C.task;
                                    Promise.all([
                                        x.displayReadyCapability.promise,
                                        r
                                    ]).then(function(D) {
                                        var H, J = p.makeIterator(D);
                                        D = J.next().value;
                                        J = J.next().value;
                                        if (c.destroyed) b();
                                        else {
                                            null == (H = c._stats) || H.time("Rendering");
                                            if (!(J.renderingIntent & w)) throw Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
                                            C.initializeGraphics({
                                                transparency: D,
                                                optionalContentConfig: J
                                            });
                                            C.operatorListChanged();
                                        }
                                    }).catch(b);
                                    return e;
                                };
                                f.getOperatorList = function(a) {
                                    function b() {
                                        c.operatorList.lastChunk && (c.opListReadCapability.resolve(c.operatorList), c.renderTasks.delete(h));
                                    }
                                    a = void 0 === a ? {} : a;
                                    a = this._transport.getRenderingIntent(void 0 === a.intent ? "display" : a.intent, void 0 === a.annotationMode ? Ya.ENABLE : a.annotationMode, void 0 === a.printAnnotationStorage ? null : a.printAnnotationStorage, void 0 === a.isEditing ? !1 : a.isEditing, !0);
                                    var c = this._intentStates.get(a.cacheKey);
                                    c || (c = Object.create(null), this._intentStates.set(a.cacheKey, c));
                                    if (!c.opListReadCapability) {
                                        var d, e;
                                        var h = Object.create(null);
                                        h.operatorListChanged = b;
                                        c.opListReadCapability = Promise.withResolvers();
                                        ((d = c).renderTasks || (d.renderTasks = new Set)).add(h);
                                        c.operatorList = {
                                            fnArray: [],
                                            argsArray: [],
                                            lastChunk: !1,
                                            separateAnnots: null
                                        };
                                        null == (e = this._stats) || e.time("Page Request");
                                        this._pumpOperatorList(a);
                                    }
                                    return c.opListReadCapability.promise;
                                };
                                f.streamTextContent = function(a) {
                                    a = void 0 === a ? {} : a;
                                    return this._transport.messageHandler.sendWithStream("GetTextContent", {
                                        pageIndex: this._pageIndex,
                                        includeMarkedContent: !0 === (void 0 === a.includeMarkedContent ? !1 : a.includeMarkedContent),
                                        disableNormalization: !0 === (void 0 === a.disableNormalization ? !1 : a.disableNormalization)
                                    }, {
                                        highWaterMark: 100,
                                        size: function(b) {
                                            return b.items.length;
                                        }
                                    });
                                };
                                f.getTextContent = function(a) {
                                    void 0 === a && (a = {});
                                    if (this._transport._htmlForXfa) return this.getXfa().then(function(c) {
                                        return Tc.textContent(c);
                                    });
                                    var b = this.streamTextContent(a);
                                    return new Promise(function(c, d) {
                                        function e() {
                                            h.read().then(function(l) {
                                                var m, n = l.value;
                                                l.done ? c(k) : (null != (m = k.lang) ? m : k.lang = n.lang, Object.assign(k.styles, n.styles), k.items.push.apply(k.items, p.arrayFromIterable(n.items)), e());
                                            }, d);
                                        }
                                        var h = b.getReader(), k = {
                                            items: [],
                                            styles: Object.create(null),
                                            lang: null
                                        };
                                        e();
                                    });
                                };
                                f.getStructTree = function() {
                                    return this._transport.getStructTree(this._pageIndex);
                                };
                                f._destroy = function() {
                                    this.destroyed = !0;
                                    for(var a = [], b = p.makeIterator(this._intentStates.values()), c = b.next(); !c.done; c = b.next())if (c = c.value, this._abortOperatorList({
                                        intentState: c,
                                        reason: Error("Page was destroyed."),
                                        force: !0
                                    }), !c.opListReadCapability) {
                                        c = p.makeIterator(c.renderTasks);
                                        for(var d = c.next(); !d.done; d = c.next())d = d.value, a.push(d.completed), d.cancel();
                                    }
                                    this.objs.clear();
                                    this.__pendingCleanup = !1;
                                    this.__abortDelayedCleanup();
                                    return Promise.all(a);
                                };
                                f.cleanup = function(a) {
                                    void 0 === a && (a = !1);
                                    this.__pendingCleanup = !0;
                                    var b = this.__tryCleanup(!1);
                                    a && b && this._stats && (this._stats = new Ee);
                                    return b;
                                };
                                f.__tryCleanup = function(a) {
                                    var b = this;
                                    void 0 === a && (a = !1);
                                    this.__abortDelayedCleanup();
                                    if (!this.__pendingCleanup || this.destroyed) return !1;
                                    if (a) return this.__delayedCleanupTimeout = setTimeout(function() {
                                        b.__delayedCleanupTimeout = null;
                                        b.__tryCleanup(!1);
                                    }, 5E3), !1;
                                    a = p.makeIterator(this._intentStates.values());
                                    for(var c = a.next(); !c.done; c = a.next()){
                                        c = c.value;
                                        var d = c.operatorList;
                                        if (0 < c.renderTasks.size || !d.lastChunk) return !1;
                                    }
                                    this._intentStates.clear();
                                    this.objs.clear();
                                    this.__pendingCleanup = !1;
                                    return !0;
                                };
                                f.__abortDelayedCleanup = function() {
                                    this.__delayedCleanupTimeout && (clearTimeout(this.__delayedCleanupTimeout), this.__delayedCleanupTimeout = null);
                                };
                                f._startRenderPage = function(a, b) {
                                    var c, d;
                                    if (b = this._intentStates.get(b)) null == (c = this._stats) || c.timeEnd("Page Request"), null == (d = b.displayReadyCapability) || d.resolve(a);
                                };
                                f._renderPageChunk = function(a, b) {
                                    for(var c = 0, d = a.length; c < d; c++)b.operatorList.fnArray.push(a.fnArray[c]), b.operatorList.argsArray.push(a.argsArray[c]);
                                    b.operatorList.lastChunk = a.lastChunk;
                                    b.operatorList.separateAnnots = a.separateAnnots;
                                    b = p.makeIterator(b.renderTasks);
                                    for(c = b.next(); !c.done; c = b.next())c.value.operatorListChanged();
                                    a.lastChunk && this.__tryCleanup(!0);
                                };
                                f._pumpOperatorList = function(a) {
                                    function b() {
                                        h.read().then(function(l) {
                                            var m = l.value;
                                            l.done ? k.streamReader = null : c._transport.destroyed || (c._renderPageChunk(m, k), b());
                                        }, function(l) {
                                            k.streamReader = null;
                                            if (!c._transport.destroyed) {
                                                if (k.operatorList) {
                                                    k.operatorList.lastChunk = !0;
                                                    for(var m = p.makeIterator(k.renderTasks), n = m.next(); !n.done; n = m.next())n.value.operatorListChanged();
                                                    c.__tryCleanup(!0);
                                                }
                                                if (k.displayReadyCapability) k.displayReadyCapability.reject(l);
                                                else if (k.opListReadCapability) k.opListReadCapability.reject(l);
                                                else throw l;
                                            }
                                        });
                                    }
                                    var c = this, d = a.cacheKey, e = a.annotationStorageSerializable, h = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                                        pageIndex: this._pageIndex,
                                        intent: a.renderingIntent,
                                        cacheKey: d,
                                        annotationStorage: e.map,
                                        modifiedIds: a.modifiedIds
                                    }, e.transfer).getReader(), k = this._intentStates.get(d);
                                    k.streamReader = h;
                                    b();
                                };
                                f._abortOperatorList = function(a) {
                                    var b = this, c = a.intentState, d = a.reason;
                                    a = void 0 === a.force ? !1 : a.force;
                                    if (c.streamReader) {
                                        c.streamReaderCancelTimeout && (clearTimeout(c.streamReaderCancelTimeout), c.streamReaderCancelTimeout = null);
                                        if (!a) {
                                            if (0 < c.renderTasks.size) return;
                                            if (d instanceof Nc) {
                                                a = 100;
                                                0 < d.extraDelay && 1E3 > d.extraDelay && (a += d.extraDelay);
                                                c.streamReaderCancelTimeout = setTimeout(function() {
                                                    c.streamReaderCancelTimeout = null;
                                                    b._abortOperatorList({
                                                        intentState: c,
                                                        reason: d,
                                                        force: !0
                                                    });
                                                }, a);
                                                return;
                                            }
                                        }
                                        c.streamReader.cancel(new cb(d.message)).catch(function() {});
                                        c.streamReader = null;
                                        if (!this._transport.destroyed) {
                                            a = p.makeIterator(this._intentStates);
                                            for(var e = a.next(); !e.done; e = a.next()){
                                                e = p.makeIterator(e.value);
                                                var h = e.next().value;
                                                if (e.next().value === c) {
                                                    this._intentStates.delete(h);
                                                    break;
                                                }
                                            }
                                            this.cleanup();
                                        }
                                    }
                                };
                                return fb(g, [
                                    {
                                        key: "pageNumber",
                                        get: function() {
                                            return this._pageIndex + 1;
                                        }
                                    },
                                    {
                                        key: "rotate",
                                        get: function() {
                                            return this._pageInfo.rotate;
                                        }
                                    },
                                    {
                                        key: "ref",
                                        get: function() {
                                            return this._pageInfo.ref;
                                        }
                                    },
                                    {
                                        key: "userUnit",
                                        get: function() {
                                            return this._pageInfo.userUnit;
                                        }
                                    },
                                    {
                                        key: "view",
                                        get: function() {
                                            return this._pageInfo.view;
                                        }
                                    },
                                    {
                                        key: "filterFactory",
                                        get: function() {
                                            return this._transport.filterFactory;
                                        }
                                    },
                                    {
                                        key: "isPureXfa",
                                        get: function() {
                                            return qa(this, "isPureXfa", !!this._transport._htmlForXfa);
                                        }
                                    },
                                    {
                                        key: "stats",
                                        get: function() {
                                            return this._stats;
                                        }
                                    }
                                ]);
                            }(), Vg = function() {
                                function g() {
                                    this.__listeners = new Map;
                                    this.__deferred = Promise.resolve();
                                }
                                var f = g.prototype;
                                f.postMessage = function(a, b) {
                                    var c = this, d = {
                                        data: structuredClone(a, b ? {
                                            transfer: b
                                        } : null)
                                    };
                                    this.__deferred.then(function() {
                                        for(var e = p.makeIterator(c.__listeners), h = e.next(); !h.done; h = e.next())p.makeIterator(h.value).next().value.call(c, d);
                                    });
                                };
                                f.addEventListener = function(a, b, c) {
                                    var d = this, e;
                                    void 0 === c && (c = null);
                                    var h = null;
                                    if ((null == (e = c) ? void 0 : e.signal) instanceof AbortSignal) {
                                        var k = c.signal;
                                        if (k.aborted) {
                                            R("LoopbackPort - cannot use an `aborted` signal.");
                                            return;
                                        }
                                        var l = function() {
                                            return d.removeEventListener(a, b);
                                        };
                                        h = function() {
                                            return k.removeEventListener("abort", l);
                                        };
                                        k.addEventListener("abort", l);
                                    }
                                    this.__listeners.set(b, h);
                                };
                                f.removeEventListener = function(a, b) {
                                    a = this.__listeners.get(b);
                                    null == a || a();
                                    this.__listeners.delete(b);
                                };
                                f.terminate = function() {
                                    for(var a = p.makeIterator(this.__listeners), b = a.next(); !b.done; b = a.next())b = p.makeIterator(b.value), b.next(), b = b.next().value, null == b || b();
                                    this.__listeners.clear();
                                };
                                return g;
                            }(), Wa = function() {
                                function g(a) {
                                    a = void 0 === a ? {} : a;
                                    var b = void 0 === a.port ? null : a.port, c = void 0 === a.verbosity ? vb : a.verbosity;
                                    this.name = void 0 === a.name ? null : a.name;
                                    this.destroyed = !1;
                                    this.verbosity = c;
                                    this._readyCapability = Promise.withResolvers();
                                    this._messageHandler = this._webWorker = this._port = null;
                                    if (b) {
                                        var d;
                                        if (null != (d = g.__workerPorts) && d.has(b)) throw Error("Cannot use more than one PDFWorker per port.");
                                        (g.__workerPorts || (g.__workerPorts = new WeakMap)).set(b, this);
                                        this._initializeFromPort(b);
                                    } else this._initialize();
                                }
                                var f = g.prototype;
                                f.__resolve = function() {
                                    this._readyCapability.resolve();
                                    this._messageHandler.send("configure", {
                                        verbosity: this.verbosity
                                    });
                                };
                                f._initializeFromPort = function(a) {
                                    this._port = a;
                                    this._messageHandler = new rb("main", "worker", a);
                                    this._messageHandler.on("ready", function() {});
                                    this.__resolve();
                                };
                                f._initialize = function() {
                                    var a = this;
                                    if (!g.__isWorkerDisabled && !g.__mainThreadWorkerMessageHandler) {
                                        var b = g.workerSrc;
                                        try {
                                            g._isSameOrigin(window.location.href, b) || (b = g._createCDNWrapper(new URL(b, window.location).href));
                                            var c = new Worker(b, {
                                                type: "module"
                                            }), d = new rb("main", "worker", c), e = function() {
                                                h.abort();
                                                d.destroy();
                                                c.terminate();
                                                a.destroyed ? a._readyCapability.reject(Error("Worker was destroyed")) : a._setupFakeWorker();
                                            }, h = new AbortController;
                                            c.addEventListener("error", function() {
                                                a._webWorker || e();
                                            }, {
                                                signal: h.signal
                                            });
                                            d.on("test", function(l) {
                                                h.abort();
                                                a.destroyed || !l ? e() : (a._messageHandler = d, a._port = c, a._webWorker = c, a.__resolve());
                                            });
                                            d.on("ready", function() {
                                                h.abort();
                                                if (a.destroyed) e();
                                                else try {
                                                    k();
                                                } catch (l) {
                                                    a._setupFakeWorker();
                                                }
                                            });
                                            var k = function() {
                                                var l = new Uint8Array;
                                                d.send("test", l, [
                                                    l.buffer
                                                ]);
                                            };
                                            k();
                                            return;
                                        } catch (l) {
                                            W("The worker has been disabled.");
                                        }
                                    }
                                    this._setupFakeWorker();
                                };
                                f._setupFakeWorker = function() {
                                    var a = this;
                                    g.__isWorkerDisabled || (R("Setting up fake worker."), g.__isWorkerDisabled = !0);
                                    g._setupFakeWorkerGlobal.then(function(b) {
                                        if (a.destroyed) a._readyCapability.reject(Error("Worker was destroyed"));
                                        else {
                                            var c = new Vg;
                                            a._port = c;
                                            var d = "fake" + g.__fakeWorkerId++, e = new rb(d + "_worker", d, c);
                                            b.setup(e, c);
                                            a._messageHandler = new rb(d, d + "_worker", c);
                                            a.__resolve();
                                        }
                                    }).catch(function(b) {
                                        a._readyCapability.reject(Error('Setting up fake worker failed: "' + b.message + '".'));
                                    });
                                };
                                f.destroy = function() {
                                    var a;
                                    this.destroyed = !0;
                                    this._webWorker && (this._webWorker.terminate(), this._webWorker = null);
                                    null == (a = g.__workerPorts) || a.delete(this._port);
                                    this._port = null;
                                    this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
                                };
                                g.fromPort = function(a) {
                                    var b;
                                    if (null == a || !a.port) throw Error("PDFWorker.fromPort - invalid method signature.");
                                    var c = null == (b = this.__workerPorts) ? void 0 : b.get(a.port);
                                    if (c) {
                                        if (c._pendingDestroy) throw Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                                        return c;
                                    }
                                    return new g(a);
                                };
                                return fb(g, [
                                    {
                                        key: "promise",
                                        get: function() {
                                            return this._readyCapability.promise;
                                        }
                                    },
                                    {
                                        key: "port",
                                        get: function() {
                                            return this._port;
                                        }
                                    },
                                    {
                                        key: "messageHandler",
                                        get: function() {
                                            return this._messageHandler;
                                        }
                                    }
                                ], [
                                    {
                                        key: "workerSrc",
                                        get: function() {
                                            if (mb.workerSrc) return mb.workerSrc;
                                            throw Error('No "GlobalWorkerOptions.workerSrc" specified.');
                                        }
                                    },
                                    {
                                        key: "__mainThreadWorkerMessageHandler",
                                        get: function() {
                                            try {
                                                var a;
                                                return (null == (a = globalThis.pdfjsWorker) ? void 0 : a.WorkerMessageHandler) || null;
                                            } catch (b) {
                                                return null;
                                            }
                                        }
                                    },
                                    {
                                        key: "_setupFakeWorkerGlobal",
                                        get: function() {
                                            return Promise.reject("Fake worker not supported");
                                        }
                                    }
                                ]);
                            }();
                            var Ue = Wa;
                            Wa.__fakeWorkerId = 0;
                            Wa.__isWorkerDisabled = !1;
                            Wa.__workerPorts = void 0;
                            (function() {
                                Ue._isSameOrigin = function(g, f) {
                                    try {
                                        var a = new URL(g);
                                        if (!a.origin || "null" === a.origin) return !1;
                                    } catch (b) {
                                        return !1;
                                    }
                                    g = new URL(f, a);
                                    return a.origin === g.origin;
                                };
                                Ue._createCDNWrapper = function(g) {
                                    return URL.createObjectURL(new Blob([
                                        'await import("' + g + '");'
                                    ], {
                                        type: "text/javascript"
                                    }));
                                };
                            })();
                            var Qf = function() {
                                function g(a, b, c, d, e) {
                                    this.__methodPromises = new Map;
                                    this.__pageCache = new Map;
                                    this.__pagePromises = new Map;
                                    this.__pageRefCache = new Map;
                                    this.__passwordCapability = null;
                                    this.messageHandler = a;
                                    this.loadingTask = b;
                                    this.commonObjs = new Se;
                                    this.fontLoader = new tg({
                                        ownerDocument: d.ownerDocument,
                                        styleElement: d.styleElement
                                    });
                                    this.loadingParams = d.loadingParams;
                                    this._params = d;
                                    this.canvasFactory = e.canvasFactory;
                                    this.filterFactory = e.filterFactory;
                                    this.cMapReaderFactory = e.cMapReaderFactory;
                                    this.standardFontDataFactory = e.standardFontDataFactory;
                                    this.destroyed = !1;
                                    this.destroyCapability = null;
                                    this._networkStream = c;
                                    this._lastProgress = this._fullReader = null;
                                    this.downloadInfoCapability = Promise.withResolvers();
                                    this.setupMessageHandler();
                                }
                                var f = g.prototype;
                                f.__cacheSimpleMethod = function(a, b) {
                                    void 0 === b && (b = null);
                                    var c = this.__methodPromises.get(a);
                                    if (c) return c;
                                    b = this.messageHandler.sendWithPromise(a, b);
                                    this.__methodPromises.set(a, b);
                                    return b;
                                };
                                f.getRenderingIntent = function(a, b, c, d, e) {
                                    void 0 === b && (b = Ya.ENABLE);
                                    void 0 === c && (c = null);
                                    void 0 === d && (d = !1);
                                    void 0 === e && (e = !1);
                                    var h = 2, k = Qc;
                                    switch(a){
                                        case "any":
                                            h = 1;
                                            break;
                                        case "display":
                                            break;
                                        case "print":
                                            h = 4;
                                            break;
                                        default:
                                            R("getRenderingIntent - invalid intent: " + a);
                                    }
                                    a = h & 4 && c instanceof Ie ? c : this.annotationStorage;
                                    switch(b){
                                        case Ya.DISABLE:
                                            h += 64;
                                            break;
                                        case Ya.ENABLE:
                                            break;
                                        case Ya.ENABLE_FORMS:
                                            h += 16;
                                            break;
                                        case Ya.ENABLE_STORAGE:
                                            h += 32;
                                            k = a.serializable;
                                            break;
                                        default:
                                            R("getRenderingIntent - invalid annotationMode: " + b);
                                    }
                                    d && (h += 128);
                                    e && (h += 256);
                                    b = a.modifiedIds;
                                    d = b.ids;
                                    return {
                                        renderingIntent: h,
                                        cacheKey: [
                                            h,
                                            k.hash,
                                            b.hash
                                        ].join("_"),
                                        annotationStorageSerializable: k,
                                        modifiedIds: d
                                    };
                                };
                                f.destroy = function() {
                                    var a = this, b;
                                    if (this.destroyCapability) return this.destroyCapability.promise;
                                    this.destroyed = !0;
                                    this.destroyCapability = Promise.withResolvers();
                                    null == (b = this.__passwordCapability) || b.reject(Error("Worker was destroyed during onPassword callback"));
                                    b = [];
                                    for(var c = p.makeIterator(this.__pageCache.values()), d = c.next(); !d.done; d = c.next())b.push(d.value._destroy());
                                    this.__pageCache.clear();
                                    this.__pagePromises.clear();
                                    this.__pageRefCache.clear();
                                    this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
                                    c = this.messageHandler.sendWithPromise("Terminate", null);
                                    b.push(c);
                                    Promise.all(b).then(function() {
                                        var e;
                                        a.commonObjs.clear();
                                        a.fontLoader.clear();
                                        a.__methodPromises.clear();
                                        a.filterFactory.destroy();
                                        Za.cleanup();
                                        null == (e = a._networkStream) || e.cancelAllRequests(new cb("Worker was terminated."));
                                        a.messageHandler && (a.messageHandler.destroy(), a.messageHandler = null);
                                        a.destroyCapability.resolve();
                                    }, this.destroyCapability.reject);
                                    return this.destroyCapability.promise;
                                };
                                f.setupMessageHandler = function() {
                                    var a = this, b = this, c = this.messageHandler, d = this.loadingTask;
                                    c.on("GetReader", function(e, h) {
                                        a._networkStream || da("GetReader - no `IPDFStream` instance available.");
                                        a._fullReader = a._networkStream.getFullReader();
                                        a._fullReader.onProgress = function(k) {
                                            a._lastProgress = {
                                                loaded: k.loaded,
                                                total: k.total
                                            };
                                        };
                                        h.onPull = function() {
                                            a._fullReader.read().then(function(k) {
                                                var l = k.value;
                                                k.done ? h.close() : (l instanceof ArrayBuffer || da("GetReader - expected an ArrayBuffer."), h.enqueue(new Uint8Array(l), 1, [
                                                    l
                                                ]));
                                            }).catch(function(k) {
                                                h.error(k);
                                            });
                                        };
                                        h.onCancel = function(k) {
                                            a._fullReader.cancel(k);
                                            h.ready.catch(function(l) {
                                                if (!a.destroyed) throw l;
                                            });
                                        };
                                    });
                                    c.on("ReaderHeadersReady", function() {
                                        var e = eb(function k() {
                                            var l, m, n, q;
                                            return p.generator.createGenerator(k, function(r) {
                                                if (1 == r.nextAddress) return r.yield(b._fullReader.headersReady, 2);
                                                l = b._fullReader;
                                                m = l.isStreamingSupported;
                                                n = l.isRangeSupported;
                                                q = l.contentLength;
                                                m && n || (b._lastProgress && (null == d.onProgress || d.onProgress(b._lastProgress)), b._fullReader.onProgress = function(t) {
                                                    null == d.onProgress || d.onProgress({
                                                        loaded: t.loaded,
                                                        total: t.total
                                                    });
                                                });
                                                return r.return({
                                                    isStreamingSupported: m,
                                                    isRangeSupported: n,
                                                    contentLength: q
                                                });
                                            });
                                        });
                                        return function(k) {
                                            return e.apply(this, arguments);
                                        };
                                    }());
                                    c.on("GetRangeReader", function(e, h) {
                                        a._networkStream || da("GetRangeReader - no `IPDFStream` instance available.");
                                        var k = a._networkStream.getRangeReader(e.begin, e.end);
                                        k ? (h.onPull = function() {
                                            k.read().then(function(l) {
                                                var m = l.value;
                                                l.done ? h.close() : (m instanceof ArrayBuffer || da("GetRangeReader - expected an ArrayBuffer."), h.enqueue(new Uint8Array(m), 1, [
                                                    m
                                                ]));
                                            }).catch(function(l) {
                                                h.error(l);
                                            });
                                        }, h.onCancel = function(l) {
                                            k.cancel(l);
                                            h.ready.catch(function(m) {
                                                if (!a.destroyed) throw m;
                                            });
                                        }) : h.close();
                                    });
                                    c.on("GetDoc", function(e) {
                                        e = e.pdfInfo;
                                        a._numPages = e.numPages;
                                        a._htmlForXfa = e.htmlForXfa;
                                        delete e.htmlForXfa;
                                        d._capability.resolve(new Tg(e, a));
                                    });
                                    c.on("DocException", function(e) {
                                        switch(e.name){
                                            case "PasswordException":
                                                var h = new nc(e.message, e.code);
                                                break;
                                            case "InvalidPDFException":
                                                h = new Ae(e.message);
                                                break;
                                            case "MissingPDFException":
                                                h = new db(e.message);
                                                break;
                                            case "UnexpectedResponseException":
                                                h = new Hb(e.message, e.status);
                                                break;
                                            case "UnknownErrorException":
                                                h = new oc(e.message, e.details);
                                                break;
                                            default:
                                                da("DocException - expected a valid Error.");
                                        }
                                        d._capability.reject(h);
                                    });
                                    c.on("PasswordRequest", function(e) {
                                        a.__passwordCapability = Promise.withResolvers();
                                        if (d.onPassword) {
                                            var h = function(k) {
                                                k instanceof Error ? a.__passwordCapability.reject(k) : a.__passwordCapability.resolve({
                                                    password: k
                                                });
                                            };
                                            try {
                                                d.onPassword(h, e.code);
                                            } catch (k) {
                                                a.__passwordCapability.reject(k);
                                            }
                                        } else a.__passwordCapability.reject(new nc(e.message, e.code));
                                        return a.__passwordCapability.promise;
                                    });
                                    c.on("DataLoaded", function(e) {
                                        null == d.onProgress || d.onProgress({
                                            loaded: e.length,
                                            total: e.length
                                        });
                                        a.downloadInfoCapability.resolve(e);
                                    });
                                    c.on("StartRenderPage", function(e) {
                                        a.destroyed || a.__pageCache.get(e.pageIndex)._startRenderPage(e.transparency, e.cacheKey);
                                    });
                                    c.on("commonobj", function(e) {
                                        e = p.makeIterator(e);
                                        var h = e.next().value, k = e.next().value;
                                        e = e.next().value;
                                        if (a.destroyed || a.commonObjs.has(h)) return null;
                                        switch(k){
                                            case "Font":
                                                var l = a._params;
                                                k = l.disableFontFace;
                                                var m = l.fontExtraProperties;
                                                l = l.pdfBug;
                                                if ("error" in e) {
                                                    var n = e.error;
                                                    R("Error during font loading: " + n);
                                                    a.commonObjs.resolve(h, n);
                                                    break;
                                                }
                                                l = l && null != (n = globalThis.FontInspector) && n.enabled ? function(r, t) {
                                                    return globalThis.FontInspector.fontAdded(r, t);
                                                } : null;
                                                var q = new ug(e, {
                                                    disableFontFace: k,
                                                    inspectFont: l
                                                });
                                                a.fontLoader.bind(q).catch(function() {
                                                    return c.sendWithPromise("FontFallback", {
                                                        id: h
                                                    });
                                                }).finally(function() {
                                                    !m && q.data && (q.data = null);
                                                    a.commonObjs.resolve(h, q);
                                                });
                                                break;
                                            case "CopyLocalImage":
                                                (n = e.imageRef) || da("The imageRef must be defined.");
                                                e = p.makeIterator(a.__pageCache.values());
                                                for(k = e.next(); !k.done; k = e.next())for(k = p.makeIterator(k.value.objs), l = k.next(); !l.done; l = k.next())if (l = p.makeIterator(l.value), l.next(), l = l.next().value, (null == l ? void 0 : l.ref) === n) {
                                                    if (!l.dataLen) return null;
                                                    a.commonObjs.resolve(h, structuredClone(l));
                                                    return l.dataLen;
                                                }
                                                break;
                                            case "FontPath":
                                            case "Image":
                                            case "Pattern":
                                                a.commonObjs.resolve(h, e);
                                                break;
                                            default:
                                                throw Error("Got unknown common object type " + k);
                                        }
                                        return null;
                                    });
                                    c.on("obj", function(e) {
                                        var h = p.makeIterator(e);
                                        e = h.next().value;
                                        var k = h.next().value, l = h.next().value;
                                        h = h.next().value;
                                        if (!a.destroyed && (k = a.__pageCache.get(k), !k.objs.has(e))) {
                                            if (0 === k._intentStates.size) {
                                                var m;
                                                null == h || null == (m = h.bitmap) || m.close();
                                            } else switch(l){
                                                case "Image":
                                                    k.objs.resolve(e, h);
                                                    1E7 < (null == h ? void 0 : h.dataLen) && (k._maybeCleanupAfterRender = !0);
                                                    break;
                                                case "Pattern":
                                                    k.objs.resolve(e, h);
                                                    break;
                                                default:
                                                    throw Error("Got unknown object type " + l);
                                            }
                                        }
                                    });
                                    c.on("DocProgress", function(e) {
                                        a.destroyed || null == d.onProgress || d.onProgress({
                                            loaded: e.loaded,
                                            total: e.total
                                        });
                                    });
                                    c.on("FetchBuiltInCMap", function() {
                                        var e = eb(function l(k) {
                                            return p.generator.createGenerator(l, function(m) {
                                                if (b.destroyed) throw Error("Worker was destroyed.");
                                                if (!b.cMapReaderFactory) throw Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter.");
                                                return m.return(b.cMapReaderFactory.fetch(k));
                                            });
                                        });
                                        return function(k) {
                                            return e.apply(this, arguments);
                                        };
                                    }());
                                    c.on("FetchStandardFontData", function() {
                                        var e = eb(function l(k) {
                                            return p.generator.createGenerator(l, function(m) {
                                                if (b.destroyed) throw Error("Worker was destroyed.");
                                                if (!b.standardFontDataFactory) throw Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.");
                                                return m.return(b.standardFontDataFactory.fetch(k));
                                            });
                                        });
                                        return function(k) {
                                            return e.apply(this, arguments);
                                        };
                                    }());
                                };
                                f.getData = function() {
                                    return this.messageHandler.sendWithPromise("GetData", null);
                                };
                                f.saveDocument = function() {
                                    var a = this, b, c;
                                    0 >= this.annotationStorage.size && R("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                                    var d = this.annotationStorage.serializable, e = d.transfer;
                                    return this.messageHandler.sendWithPromise("SaveDocument", {
                                        isPureXfa: !!this._htmlForXfa,
                                        numPages: this._numPages,
                                        annotationStorage: d.map,
                                        filename: null != (b = null == (c = this._fullReader) ? void 0 : c.filename) ? b : null
                                    }, e).finally(function() {
                                        a.annotationStorage.resetModified();
                                    });
                                };
                                f.getPage = function(a) {
                                    var b = this;
                                    if (!Number.isInteger(a) || 0 >= a || a > this._numPages) return Promise.reject(Error("Invalid page request."));
                                    var c = a - 1, d = this.__pagePromises.get(c);
                                    if (d) return d;
                                    d = this.messageHandler.sendWithPromise("GetPage", {
                                        pageIndex: c
                                    }).then(function(e) {
                                        if (b.destroyed) throw Error("Transport destroyed");
                                        e.refStr && b.__pageRefCache.set(e.refStr, a);
                                        e = new Ug(c, e, b, b._params.pdfBug);
                                        b.__pageCache.set(c, e);
                                        return e;
                                    });
                                    this.__pagePromises.set(c, d);
                                    return d;
                                };
                                f.getPageIndex = function(a) {
                                    return ce(a) ? this.messageHandler.sendWithPromise("GetPageIndex", {
                                        num: a.num,
                                        gen: a.gen
                                    }) : Promise.reject(Error("Invalid pageIndex request."));
                                };
                                f.getAnnotations = function(a, b) {
                                    return this.messageHandler.sendWithPromise("GetAnnotations", {
                                        pageIndex: a,
                                        intent: b
                                    });
                                };
                                f.getFieldObjects = function() {
                                    return this.__cacheSimpleMethod("GetFieldObjects");
                                };
                                f.hasJSActions = function() {
                                    return this.__cacheSimpleMethod("HasJSActions");
                                };
                                f.getCalculationOrderIds = function() {
                                    return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                                };
                                f.getDestinations = function() {
                                    return this.messageHandler.sendWithPromise("GetDestinations", null);
                                };
                                f.getDestination = function(a) {
                                    return "string" !== typeof a ? Promise.reject(Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                                        id: a
                                    });
                                };
                                f.getPageLabels = function() {
                                    return this.messageHandler.sendWithPromise("GetPageLabels", null);
                                };
                                f.getPageLayout = function() {
                                    return this.messageHandler.sendWithPromise("GetPageLayout", null);
                                };
                                f.getPageMode = function() {
                                    return this.messageHandler.sendWithPromise("GetPageMode", null);
                                };
                                f.getViewerPreferences = function() {
                                    return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                                };
                                f.getOpenAction = function() {
                                    return this.messageHandler.sendWithPromise("GetOpenAction", null);
                                };
                                f.getAttachments = function() {
                                    return this.messageHandler.sendWithPromise("GetAttachments", null);
                                };
                                f.getDocJSActions = function() {
                                    return this.__cacheSimpleMethod("GetDocJSActions");
                                };
                                f.getPageJSActions = function(a) {
                                    return this.messageHandler.sendWithPromise("GetPageJSActions", {
                                        pageIndex: a
                                    });
                                };
                                f.getStructTree = function(a) {
                                    return this.messageHandler.sendWithPromise("GetStructTree", {
                                        pageIndex: a
                                    });
                                };
                                f.getOutline = function() {
                                    return this.messageHandler.sendWithPromise("GetOutline", null);
                                };
                                f.getOptionalContentConfig = function(a) {
                                    return this.__cacheSimpleMethod("GetOptionalContentConfig").then(function(b) {
                                        return new Gg(b, a);
                                    });
                                };
                                f.getPermissions = function() {
                                    return this.messageHandler.sendWithPromise("GetPermissions", null);
                                };
                                f.getMetadata = function() {
                                    var a = this, b = this.__methodPromises.get("GetMetadata");
                                    if (b) return b;
                                    b = this.messageHandler.sendWithPromise("GetMetadata", null).then(function(c) {
                                        var d, e, h, k;
                                        return {
                                            info: c[0],
                                            metadata: c[1] ? new Eg(c[1]) : null,
                                            contentDispositionFilename: null != (d = null == (e = a._fullReader) ? void 0 : e.filename) ? d : null,
                                            contentLength: null != (h = null == (k = a._fullReader) ? void 0 : k.contentLength) ? h : null
                                        };
                                    });
                                    this.__methodPromises.set("GetMetadata", b);
                                    return b;
                                };
                                f.getMarkInfo = function() {
                                    return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                                };
                                f.startCleanup = function() {
                                    var a = eb(function d(c) {
                                        var e = this, h, k, l, m;
                                        return p.generator.createGenerator(d, function(n) {
                                            if (1 == n.nextAddress) return void 0 === c && (c = !1), e.destroyed ? n.return() : n.yield(e.messageHandler.sendWithPromise("Cleanup", null), 2);
                                            h = p.makeIterator(e.__pageCache.values());
                                            for(k = h.next(); !k.done; k = h.next())if (l = k.value, m = l.cleanup(), !m) throw Error("startCleanup: Page " + l.pageNumber + " is currently rendering.");
                                            e.commonObjs.clear();
                                            c || e.fontLoader.clear();
                                            e.__methodPromises.clear();
                                            e.filterFactory.destroy(!0);
                                            Za.cleanup();
                                            n.jumpToEnd();
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.cachedPageNumber = function(a) {
                                    var b;
                                    return ce(a) ? null != (b = this.__pageRefCache.get(0 === a.gen ? a.num + "R" : a.num + "R" + a.gen)) ? b : null : null;
                                };
                                return fb(g, [
                                    {
                                        key: "annotationStorage",
                                        get: function() {
                                            return qa(this, "annotationStorage", new Rc);
                                        }
                                    }
                                ]);
                            }(), Pb = Symbol("INITIAL_DATA"), Se = function() {
                                function g() {
                                    this.__objs = Object.create(null);
                                }
                                var f = g.prototype;
                                f.__ensureObj = function(a) {
                                    var b;
                                    return (b = this.__objs)[a] || (b[a] = Object.assign({}, Promise.withResolvers(), {
                                        data: Pb
                                    }));
                                };
                                f.get = function(a, b) {
                                    void 0 === b && (b = null);
                                    if (b) {
                                        var c = this.__ensureObj(a);
                                        c.promise.then(function() {
                                            return b(c.data);
                                        });
                                        return null;
                                    }
                                    var d = this.__objs[a];
                                    if (!d || d.data === Pb) throw Error("Requesting object that isn't resolved yet " + a + ".");
                                    return d.data;
                                };
                                f.has = function(a) {
                                    a = this.__objs[a];
                                    return !!a && a.data !== Pb;
                                };
                                f.resolve = function(a, b) {
                                    void 0 === b && (b = null);
                                    a = this.__ensureObj(a);
                                    a.data = b;
                                    a.resolve();
                                };
                                f.clear = function() {
                                    for(var a in this.__objs){
                                        var b, c = this.__objs[a].data;
                                        null == c || null == (b = c.bitmap) || b.close();
                                    }
                                    this.__objs = Object.create(null);
                                };
                                f[Symbol.iterator] = function b() {
                                    var c, d = this, e, h, k;
                                    return p.generator.createGenerator(b, function(l) {
                                        1 == l.nextAddress && (e = l.forIn(d.__objs));
                                        if (null == (c = e.getNext())) return l.jumpTo(0);
                                        h = d.__objs[c];
                                        k = h.data;
                                        return k === Pb ? l.jumpTo(2) : l.yield([
                                            c,
                                            k
                                        ], 2);
                                    });
                                };
                                return g;
                            }(), Wg = function() {
                                function g(f) {
                                    this.__internalRenderTask = f;
                                    this.onContinue = null;
                                }
                                g.prototype.cancel = function(f) {
                                    void 0 === f && (f = 0);
                                    this.__internalRenderTask.cancel(null, f);
                                };
                                return fb(g, [
                                    {
                                        key: "promise",
                                        get: function() {
                                            return this.__internalRenderTask.capability.promise;
                                        }
                                    },
                                    {
                                        key: "separateAnnots",
                                        get: function() {
                                            var f = this.__internalRenderTask.operatorList.separateAnnots;
                                            if (!f) return !1;
                                            var a = this.__internalRenderTask.annotationCanvasMap;
                                            return f.form || f.canvas && 0 < (null == a ? void 0 : a.size);
                                        }
                                    }
                                ]);
                            }(), Te = function() {
                                function g(a) {
                                    var b = a.callback, c = a.params, d = a.objs, e = a.commonObjs, h = a.annotationCanvasMap, k = a.operatorList, l = a.pageIndex, m = a.canvasFactory, n = a.filterFactory, q = void 0 === a.useRequestAnimationFrame ? !1 : a.useRequestAnimationFrame, r = void 0 === a.pdfBug ? !1 : a.pdfBug;
                                    a = void 0 === a.pageColors ? null : a.pageColors;
                                    this.__rAF = null;
                                    this.callback = b;
                                    this.params = c;
                                    this.objs = d;
                                    this.commonObjs = e;
                                    this.annotationCanvasMap = h;
                                    this.operatorListIdx = null;
                                    this.operatorList = k;
                                    this._pageIndex = l;
                                    this.canvasFactory = m;
                                    this.filterFactory = n;
                                    this._pdfBug = r;
                                    this.pageColors = a;
                                    this.running = !1;
                                    this.graphicsReadyCallback = null;
                                    this.graphicsReady = !1;
                                    this._useRequestAnimationFrame = !0 === q && "undefined" !== typeof window;
                                    this.cancelled = !1;
                                    this.capability = Promise.withResolvers();
                                    this.task = new Wg(this);
                                    this._cancelBound = this.cancel.bind(this);
                                    this._continueBound = this._continue.bind(this);
                                    this._scheduleNextBound = this._scheduleNext.bind(this);
                                    this._nextBound = this._next.bind(this);
                                    this._canvas = c.canvasContext.canvas;
                                }
                                var f = g.prototype;
                                f.initializeGraphics = function(a) {
                                    var b, c, d = void 0 === a.transparency ? !1 : a.transparency;
                                    a = a.optionalContentConfig;
                                    if (!this.cancelled) {
                                        if (this._canvas) {
                                            if (g.__canvasInUse.has(this._canvas)) throw Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                                            g.__canvasInUse.add(this._canvas);
                                        }
                                        this._pdfBug && null != (b = globalThis.StepperManager) && b.enabled && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
                                        b = this.params;
                                        var e = b.viewport, h = b.transform, k = b.background;
                                        this.gfx = new Nb(b.canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                            optionalContentConfig: a
                                        }, this.annotationCanvasMap, this.pageColors);
                                        this.gfx.beginDrawing({
                                            transform: h,
                                            viewport: e,
                                            transparency: d,
                                            background: k
                                        });
                                        this.operatorListIdx = 0;
                                        this.graphicsReady = !0;
                                        null == (c = this.graphicsReadyCallback) || c.call(this);
                                    }
                                };
                                f.cancel = function(a, b) {
                                    var c;
                                    void 0 === a && (a = null);
                                    void 0 === b && (b = 0);
                                    this.running = !1;
                                    this.cancelled = !0;
                                    null == (c = this.gfx) || c.endDrawing();
                                    this.__rAF && (window.cancelAnimationFrame(this.__rAF), this.__rAF = null);
                                    g.__canvasInUse.delete(this._canvas);
                                    this.callback(a || new Nc("Rendering cancelled, page " + (this._pageIndex + 1), b));
                                };
                                f.operatorListChanged = function() {
                                    var a;
                                    this.graphicsReady ? (null == (a = this.stepper) || a.updateOperatorList(this.operatorList), this.running || this._continue()) : this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                                };
                                f._continue = function() {
                                    this.running = !0;
                                    if (!this.cancelled) {
                                        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                                        else this._scheduleNext();
                                    }
                                };
                                f._scheduleNext = function() {
                                    var a = this;
                                    this._useRequestAnimationFrame ? this.__rAF = window.requestAnimationFrame(function() {
                                        a.__rAF = null;
                                        a._nextBound().catch(a._cancelBound);
                                    }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                                };
                                f._next = function() {
                                    var a = eb(function c() {
                                        var d = this;
                                        return p.generator.createGenerator(c, function(e) {
                                            if (d.cancelled) return e.return();
                                            d.operatorListIdx = d.gfx.executeOperatorList(d.operatorList, d.operatorListIdx, d._continueBound, d.stepper);
                                            d.operatorListIdx === d.operatorList.argsArray.length && (d.running = !1, d.operatorList.lastChunk && (d.gfx.endDrawing(), g.__canvasInUse.delete(d._canvas), d.callback()));
                                            e.jumpToEnd();
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                return fb(g, [
                                    {
                                        key: "completed",
                                        get: function() {
                                            return this.capability.promise.catch(function() {});
                                        }
                                    }
                                ]);
                            }();
                            Te.__canvasInUse = new WeakSet;
                            F(2712);
                            F(9202);
                            F(8350);
                            F(237);
                            F(6034);
                            F(670);
                            var Ve = function() {
                                function g() {}
                                g.CMYK_G = function(f) {
                                    var a = p.makeIterator(f);
                                    f = a.next().value;
                                    var b = a.next().value, c = a.next().value;
                                    a = a.next().value;
                                    return [
                                        "G",
                                        1 - Math.min(1, .3 * f + .59 * c + .11 * b + a)
                                    ];
                                };
                                g.G_CMYK = function(f) {
                                    return [
                                        "CMYK",
                                        0,
                                        0,
                                        0,
                                        1 - p.makeIterator(f).next().value
                                    ];
                                };
                                g.G_RGB = function(f) {
                                    f = p.makeIterator(f).next().value;
                                    return [
                                        "RGB",
                                        f,
                                        f,
                                        f
                                    ];
                                };
                                g.G_rgb = function(f) {
                                    f = p.makeIterator(f).next().value;
                                    f = sb(f);
                                    return [
                                        f,
                                        f,
                                        f
                                    ];
                                };
                                g.G_HTML = function(f) {
                                    f = p.makeIterator(f).next().value;
                                    f = de(f);
                                    return "#" + f + f + f;
                                };
                                g.RGB_G = function(f) {
                                    var a = p.makeIterator(f);
                                    f = a.next().value;
                                    var b = a.next().value;
                                    a = a.next().value;
                                    return [
                                        "G",
                                        .3 * f + .59 * b + .11 * a
                                    ];
                                };
                                g.RGB_rgb = function(f) {
                                    return f.map(sb);
                                };
                                g.RGB_HTML = function(f) {
                                    return "#" + f.map(de).join("");
                                };
                                g.T_HTML = function() {
                                    return "#00000000";
                                };
                                g.T_rgb = function() {
                                    return [
                                        null
                                    ];
                                };
                                g.CMYK_RGB = function(f) {
                                    var a = p.makeIterator(f);
                                    f = a.next().value;
                                    var b = a.next().value, c = a.next().value;
                                    a = a.next().value;
                                    return [
                                        "RGB",
                                        1 - Math.min(1, f + a),
                                        1 - Math.min(1, c + a),
                                        1 - Math.min(1, b + a)
                                    ];
                                };
                                g.CMYK_rgb = function(f) {
                                    var a = p.makeIterator(f);
                                    f = a.next().value;
                                    var b = a.next().value, c = a.next().value;
                                    a = a.next().value;
                                    return [
                                        sb(1 - Math.min(1, f + a)),
                                        sb(1 - Math.min(1, c + a)),
                                        sb(1 - Math.min(1, b + a))
                                    ];
                                };
                                g.CMYK_HTML = function(f) {
                                    f = this.CMYK_RGB(f).slice(1);
                                    return this.RGB_HTML(f);
                                };
                                g.RGB_CMYK = function(f) {
                                    var a = p.makeIterator(f), b = a.next().value;
                                    f = a.next().value;
                                    a = a.next().value;
                                    b = 1 - b;
                                    f = 1 - f;
                                    a = 1 - a;
                                    return [
                                        "CMYK",
                                        b,
                                        f,
                                        a,
                                        Math.min(b, f, a)
                                    ];
                                };
                                return g;
                            }(), Kc = function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                Rf(f, g);
                                f.prototype._createSVG = function(a) {
                                    return document.createElementNS("http://www.w3.org/2000/svg", a);
                                };
                                return f;
                            }(function() {
                                function g() {}
                                var f = g.prototype;
                                f.create = function(a, b, c) {
                                    void 0 === c && (c = !1);
                                    if (0 >= a || 0 >= b) throw Error("Invalid SVG dimensions");
                                    var d = this._createSVG("svg:svg");
                                    d.setAttribute("version", "1.1");
                                    c || (d.setAttribute("width", a + "px"), d.setAttribute("height", b + "px"));
                                    d.setAttribute("preserveAspectRatio", "none");
                                    d.setAttribute("viewBox", "0 0 " + a + " " + b);
                                    return d;
                                };
                                f.createElement = function(a) {
                                    if ("string" !== typeof a) throw Error("Invalid SVG element type");
                                    return this._createSVG(a);
                                };
                                f._createSVG = function() {
                                    da("Abstract method `_createSVG` called.");
                                };
                                return g;
                            }()), Be = function() {
                                function g() {}
                                g.setupStorage = function(f, a, b, c, d) {
                                    var e = c.getValue(a, {
                                        value: null
                                    });
                                    switch(b.name){
                                        case "textarea":
                                            null !== e.value && (f.textContent = e.value);
                                            if ("print" === d) break;
                                            f.addEventListener("input", function(h) {
                                                c.setValue(a, {
                                                    value: h.target.value
                                                });
                                            });
                                            break;
                                        case "input":
                                            "radio" === b.attributes.type || "checkbox" === b.attributes.type ? (e.value === b.attributes.xfaOn ? f.setAttribute("checked", !0) : e.value === b.attributes.xfaOff && f.removeAttribute("checked"), "print" !== d && f.addEventListener("change", function(h) {
                                                c.setValue(a, {
                                                    value: h.target.checked ? h.target.getAttribute("xfaOn") : h.target.getAttribute("xfaOff")
                                                });
                                            })) : (null !== e.value && f.setAttribute("value", e.value), "print" !== d && f.addEventListener("input", function(h) {
                                                c.setValue(a, {
                                                    value: h.target.value
                                                });
                                            }));
                                            break;
                                        case "select":
                                            if (null !== e.value) for(f.setAttribute("value", e.value), b = p.makeIterator(b.children), d = b.next(); !d.done; d = b.next())d = d.value, d.attributes.value === e.value ? d.attributes.selected = !0 : d.attributes.hasOwnProperty("selected") && delete d.attributes.selected;
                                            f.addEventListener("input", function(h) {
                                                h = h.target.options;
                                                c.setValue(a, {
                                                    value: -1 === h.selectedIndex ? "" : h[h.selectedIndex].value
                                                });
                                            });
                                    }
                                };
                                g.setAttributes = function(f) {
                                    var a = f.html, b = f.element, c = void 0 === f.storage ? null : f.storage, d = f.intent;
                                    f = f.linkService;
                                    var e = b.attributes, h = a instanceof HTMLAnchorElement;
                                    "radio" === e.type && (e.name = e.name + "-" + d);
                                    d = p.makeIterator(Object.entries(e));
                                    for(var k = d.next(); !k.done; k = d.next()){
                                        var l = p.makeIterator(k.value);
                                        k = l.next().value;
                                        l = l.next().value;
                                        if (null !== l && void 0 !== l) switch(k){
                                            case "class":
                                                l.length && a.setAttribute(k, l.join(" "));
                                                break;
                                            case "dataId":
                                                break;
                                            case "id":
                                                a.setAttribute("data-element-id", l);
                                                break;
                                            case "style":
                                                Object.assign(a.style, l);
                                                break;
                                            case "textContent":
                                                a.textContent = l;
                                                break;
                                            default:
                                                (!h || "href" !== k && "newWindow" !== k) && a.setAttribute(k, l);
                                        }
                                    }
                                    h && f.addLinkAttributes(a, e.href, e.newWindow);
                                    c && e.dataId && this.setupStorage(a, e.dataId, b, c);
                                };
                                g.render = function(f) {
                                    var a = f.annotationStorage, b = f.linkService, c = f.xfaHtml, d = f.intent || "display", e = document.createElement(c.name);
                                    c.attributes && this.setAttributes({
                                        html: e,
                                        element: c,
                                        intent: d,
                                        linkService: b
                                    });
                                    var h = "richText" !== d, k = f.div;
                                    k.append(e);
                                    f.viewport && (f = "matrix(" + f.viewport.transform.join(",") + ")", k.style.transform = f);
                                    h && k.setAttribute("class", "xfaLayer xfaFont");
                                    f = [];
                                    if (0 === c.children.length) return c.value && (a = document.createTextNode(c.value), e.append(a), h && Tc.shouldBuildText(c.name) && f.push(a)), {
                                        textDivs: f
                                    };
                                    for(c = [
                                        [
                                            c,
                                            -1,
                                            e
                                        ]
                                    ]; 0 < c.length;){
                                        var l, m;
                                        e = p.makeIterator(c.at(-1));
                                        var n = e.next().value, q = e.next().value;
                                        e = e.next().value;
                                        if (q + 1 === n.children.length) c.pop();
                                        else {
                                            var r = n.children[++c.at(-1)[1]];
                                            null !== r && (n = r.name, "#text" === n ? (n = document.createTextNode(r.value), f.push(n), e.append(n)) : (q = null != r && null != (l = r.attributes) && l.xmlns ? document.createElementNS(r.attributes.xmlns, n) : document.createElement(n), e.append(q), r.attributes && this.setAttributes({
                                                html: q,
                                                element: r,
                                                storage: a,
                                                intent: d,
                                                linkService: b
                                            }), 0 < (null == (m = r.children) ? void 0 : m.length) ? c.push([
                                                r,
                                                -1,
                                                q
                                            ]) : r.value && (e = document.createTextNode(r.value), h && Tc.shouldBuildText(n) && f.push(e), q.append(e))));
                                        }
                                    }
                                    h = p.makeIterator(k.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"));
                                    for(a = h.next(); !a.done; a = h.next())a.value.setAttribute("readOnly", !0);
                                    return {
                                        textDivs: f
                                    };
                                };
                                g.update = function(f) {
                                    var a = "matrix(" + f.viewport.transform.join(",") + ")";
                                    f.div.style.transform = a;
                                    f.div.hidden = !1;
                                };
                                return g;
                            }(), hb = new WeakSet, lh = function() {
                                function g() {}
                                g.create = function(f) {
                                    switch(f.data.annotationType){
                                        case 2:
                                            return new We(f);
                                        case 1:
                                            return new Xg(f);
                                        case 20:
                                            switch(f.data.fieldType){
                                                case "Tx":
                                                    return new Yg(f);
                                                case "Btn":
                                                    return f.data.radioButton ? new Xe(f) : f.data.checkBox ? new Zg(f) : new $g(f);
                                                case "Ch":
                                                    return new ah(f);
                                                case "Sig":
                                                    return new bh(f);
                                            }
                                            return new ib(f);
                                        case 16:
                                            return new Uc(f);
                                        case 3:
                                            return new Ye(f);
                                        case 4:
                                            return new ch(f);
                                        case 5:
                                            return new dh(f);
                                        case 6:
                                            return new eh(f);
                                        case 8:
                                            return new Ze(f);
                                        case 14:
                                            return new fh(f);
                                        case 15:
                                            return new Vc(f);
                                        case 7:
                                            return new gh(f);
                                        case 9:
                                            return new $e(f);
                                        case 10:
                                            return new hh(f);
                                        case 11:
                                            return new ih(f);
                                        case 12:
                                            return new jh(f);
                                        case 13:
                                            return new af(f);
                                        case 17:
                                            return new kh(f);
                                        default:
                                            return new Ea(f);
                                    }
                                };
                                return g;
                            }(), Ea = function() {
                                function g(a, b) {
                                    var c = void 0 === b ? {} : b;
                                    b = void 0 === c.isRenderable ? !1 : c.isRenderable;
                                    var d = void 0 === c.ignoreBorder ? !1 : c.ignoreBorder;
                                    c = void 0 === c.createQuadrilaterals ? !1 : c.createQuadrilaterals;
                                    this.__updates = null;
                                    this.__hasBorder = !1;
                                    this.__popupElement = null;
                                    this.isRenderable = b;
                                    this.data = a.data;
                                    this.layer = a.layer;
                                    this.linkService = a.linkService;
                                    this.downloadManager = a.downloadManager;
                                    this.imageResourcesPath = a.imageResourcesPath;
                                    this.renderForms = a.renderForms;
                                    this.svgFactory = a.svgFactory;
                                    this.annotationStorage = a.annotationStorage;
                                    this.enableScripting = a.enableScripting;
                                    this.hasJSActions = a.hasJSActions;
                                    this._fieldObjects = a.fieldObjects;
                                    this.parent = a.parent;
                                    b && (this.container = this._createContainer(d));
                                    c && this._createQuadrilaterals();
                                }
                                g._hasPopupData = function(a) {
                                    var b = a.titleObj, c = a.contentsObj;
                                    a = a.richText;
                                    return !!(null != b && b.str || null != c && c.str || null != a && a.str);
                                };
                                var f = g.prototype;
                                f.updateEdited = function(a) {
                                    var b;
                                    if (this.container) {
                                        this.__updates || (this.__updates = {
                                            rect: this.data.rect.slice(0)
                                        });
                                        var c = a.rect;
                                        c && this.__setRectEdited(c);
                                        null == (b = this.__popupElement) || b.popup.updateEdited(a);
                                    }
                                };
                                f.resetEdited = function() {
                                    var a;
                                    this.__updates && (this.__setRectEdited(this.__updates.rect), null == (a = this.__popupElement) || a.popup.resetEdited(), this.__updates = null);
                                };
                                f.__setRectEdited = function(a) {
                                    var b = this.container.style, c = this.data, d = c.rect;
                                    c = c.rotation;
                                    var e = this.parent.viewport.rawDims, h = e.pageWidth, k = e.pageHeight, l = e.pageX;
                                    e = e.pageY;
                                    null == d || d.splice.apply(d, [
                                        0,
                                        4
                                    ].concat(p.arrayFromIterable(a)));
                                    var m = Ua(a);
                                    d = m.width;
                                    m = m.height;
                                    b.left = 100 * (a[0] - l) / h + "%";
                                    b.top = 100 * (k - a[3] + e) / k + "%";
                                    0 === c ? (b.width = 100 * d / h + "%", b.height = 100 * m / k + "%") : this.setRotation(c);
                                };
                                f._createContainer = function(a) {
                                    var b = this.data, c = this.parent, d = c.page, e = c.viewport;
                                    c = document.createElement("section");
                                    c.setAttribute("data-annotation-id", b.id);
                                    this instanceof ib || (c.tabIndex = 1E3);
                                    var h = c.style;
                                    h.zIndex = this.parent.zIndex++;
                                    b.alternativeText && (c.title = b.alternativeText);
                                    b.noRotate && c.classList.add("norotate");
                                    if (!b.rect || this instanceof Uc) return h = b.rotation, b.hasOwnCanvas || 0 === h || this.setRotation(h, c), c;
                                    var k = Ua(b.rect), l = k.width;
                                    k = k.height;
                                    if (!a && 0 < b.borderStyle.width) {
                                        h.borderWidth = b.borderStyle.width + "px";
                                        a = b.borderStyle.horizontalCornerRadius;
                                        var m = b.borderStyle.verticalCornerRadius;
                                        0 < a || 0 < m ? h.borderRadius = "calc(" + a + "px * var(--scale-factor)) / calc(" + m + "px * var(--scale-factor))" : this instanceof Xe && (h.borderRadius = "calc(" + l + "px * var(--scale-factor)) / calc(" + k + "px * var(--scale-factor))");
                                        switch(b.borderStyle.style){
                                            case 1:
                                                h.borderStyle = "solid";
                                                break;
                                            case 2:
                                                h.borderStyle = "dashed";
                                                break;
                                            case 3:
                                                R("Unimplemented border style: beveled");
                                                break;
                                            case 4:
                                                R("Unimplemented border style: inset");
                                                break;
                                            case 5:
                                                h.borderBottomStyle = "solid";
                                        }
                                        (a = b.borderColor || null) ? (this.__hasBorder = !0, h.borderColor = fa.makeHexColor(a[0] | 0, a[1] | 0, a[2] | 0)) : h.borderWidth = 0;
                                    }
                                    d = fa.normalizeRect([
                                        b.rect[0],
                                        d.view[3] - b.rect[1] + d.view[1],
                                        b.rect[2],
                                        d.view[3] - b.rect[3] + d.view[1]
                                    ]);
                                    m = e.rawDims;
                                    e = m.pageWidth;
                                    a = m.pageHeight;
                                    var n = m.pageY;
                                    h.left = 100 * (d[0] - m.pageX) / e + "%";
                                    h.top = 100 * (d[1] - n) / a + "%";
                                    d = b.rotation;
                                    b.hasOwnCanvas || 0 === d ? (h.width = 100 * l / e + "%", h.height = 100 * k / a + "%") : this.setRotation(d, c);
                                    return c;
                                };
                                f.setRotation = function(a, b) {
                                    void 0 === b && (b = this.container);
                                    if (this.data.rect) {
                                        var c = this.parent.viewport.rawDims, d = c.pageWidth;
                                        c = c.pageHeight;
                                        var e = Ua(this.data.rect), h = e.width;
                                        e = e.height;
                                        0 === a % 180 ? (d = 100 * h / d, c = 100 * e / c) : (d = 100 * e / d, c = 100 * h / c);
                                        b.style.width = d + "%";
                                        b.style.height = c + "%";
                                        b.setAttribute("data-main-rotation", (360 - a) % 360);
                                    }
                                };
                                f._dispatchEventFromSandbox = function(a, b) {
                                    for(var c = this._commonActions, d = p.makeIterator(Object.keys(b.detail)), e = d.next(); !e.done; e = d.next())e = e.value, e = a[e] || c[e], null == e || e(b);
                                };
                                f._setDefaultPropertiesFromJS = function(a) {
                                    if (this.enableScripting) {
                                        var b = this.annotationStorage.getRawValue(this.data.id);
                                        if (b) for(var c = this._commonActions, d = p.makeIterator(Object.entries(b)), e = d.next(); !e.done; e = d.next()){
                                            var h = p.makeIterator(e.value);
                                            e = h.next().value;
                                            var k = h.next().value;
                                            if (h = c[e]) {
                                                var l = {};
                                                k = {
                                                    detail: (l[e] = k, l),
                                                    target: a
                                                };
                                                h(k);
                                                delete b[e];
                                            }
                                        }
                                    }
                                };
                                f._createQuadrilaterals = function() {
                                    if (this.container) {
                                        var a = this.data.quadPoints;
                                        if (a) {
                                            var b = p.makeIterator(this.data.rect.map(function(H) {
                                                return Math.fround(H);
                                            })), c = b.next().value, d = b.next().value, e = b.next().value;
                                            b = b.next().value;
                                            if (8 === a.length) {
                                                var h = p.makeIterator(a.subarray(2, 6)), k = h.next().value, l = h.next().value, m = h.next().value;
                                                h = h.next().value;
                                                if (e === k && b === l && c === m && d === h) return;
                                            }
                                            k = this.container.style;
                                            if (this.__hasBorder) {
                                                var n = k.borderColor;
                                                l = k.borderWidth;
                                                k.borderWidth = 0;
                                                n = [
                                                    "url('data:image/svg+xml;utf8,",
                                                    '<svg xmlns="http://www.w3.org/2000/svg"',
                                                    ' preserveAspectRatio="none" viewBox="0 0 1 1">',
                                                    '<g fill="transparent" stroke="' + n + '" stroke-width="' + l + '">'
                                                ];
                                                this.container.classList.add("hasBorder");
                                            }
                                            e -= c;
                                            d = b - d;
                                            l = this.svgFactory;
                                            m = l.createElement("svg");
                                            m.classList.add("quadrilateralsContainer");
                                            m.setAttribute("width", 0);
                                            m.setAttribute("height", 0);
                                            var q = l.createElement("defs");
                                            m.append(q);
                                            h = l.createElement("clipPath");
                                            var r = "clippath_" + this.data.id;
                                            h.setAttribute("id", r);
                                            h.setAttribute("clipPathUnits", "objectBoundingBox");
                                            q.append(h);
                                            q = 2;
                                            for(var t = a.length; q < t; q += 8){
                                                var u, v = a[q], w = a[q + 1], x = a[q + 2], B = a[q + 3], z = l.createElement("rect"), C = (x - c) / e, D = (b - w) / d;
                                                v = (v - x) / e;
                                                w = (w - B) / d;
                                                z.setAttribute("x", C);
                                                z.setAttribute("y", D);
                                                z.setAttribute("width", v);
                                                z.setAttribute("height", w);
                                                h.append(z);
                                                null == (u = n) || u.push('<rect vector-effect="non-scaling-stroke" x="' + C + '" y="' + D + '" width="' + v + '" height="' + w + '"/>');
                                            }
                                            this.__hasBorder && (n.push("</g></svg>')"), k.backgroundImage = n.join(""));
                                            this.container.append(m);
                                            this.container.style.clipPath = "url(#" + r + ")";
                                        }
                                    }
                                };
                                f._createPopup = function() {
                                    var a = this.data;
                                    a = this.__popupElement = new Uc({
                                        data: {
                                            color: a.color,
                                            titleObj: a.titleObj,
                                            modificationDate: a.modificationDate,
                                            contentsObj: a.contentsObj,
                                            richText: a.richText,
                                            parentRect: a.rect,
                                            borderStyle: 0,
                                            id: "popup_" + a.id,
                                            rotation: a.rotation
                                        },
                                        parent: this.parent,
                                        elements: [
                                            this
                                        ]
                                    });
                                    this.parent.div.append(a.render());
                                };
                                f.render = function() {
                                    da("Abstract method `AnnotationElement.render` called");
                                };
                                f._getElementsByName = function(a, b) {
                                    void 0 === b && (b = null);
                                    var c = [];
                                    if (this._fieldObjects) {
                                        if (a = this._fieldObjects[a]) {
                                            a = p.makeIterator(a);
                                            for(var d = a.next(); !d.done; d = a.next()){
                                                var e = d.value;
                                                d = e.id;
                                                var h = e.exportValues;
                                                -1 !== e.page && d !== b && (e = "string" === typeof h ? h : null, (h = document.querySelector('[data-element-id="' + d + '"]')) && !hb.has(h) ? R("_getElementsByName - element not allowed: " + d) : c.push({
                                                    id: d,
                                                    exportValue: e,
                                                    domElement: h
                                                }));
                                            }
                                        }
                                        return c;
                                    }
                                    a = p.makeIterator(document.getElementsByName(a));
                                    for(d = a.next(); !d.done; d = a.next())d = d.value, e = d.exportValue, h = d.getAttribute("data-element-id"), h !== b && hb.has(d) && c.push({
                                        id: h,
                                        exportValue: e,
                                        domElement: d
                                    });
                                    return c;
                                };
                                f.show = function() {
                                    var a;
                                    this.container && (this.container.hidden = !1);
                                    null == (a = this.popup) || a.maybeShow();
                                };
                                f.hide = function() {
                                    var a;
                                    this.container && (this.container.hidden = !0);
                                    null == (a = this.popup) || a.forceHide();
                                };
                                f.getElementsToTriggerPopup = function() {
                                    return this.container;
                                };
                                f.addHighlightArea = function() {
                                    var a = this.getElementsToTriggerPopup();
                                    if (Array.isArray(a)) {
                                        a = p.makeIterator(a);
                                        for(var b = a.next(); !b.done; b = a.next())b.value.classList.add("highlightArea");
                                    } else a.classList.add("highlightArea");
                                };
                                f._editOnDoubleClick = function() {
                                    var a = this;
                                    if (this._isEditable) {
                                        var b = this.annotationEditorType, c = this.data.id;
                                        this.container.addEventListener("dblclick", function() {
                                            var d;
                                            null == (d = a.linkService.eventBus) || d.dispatch("switchannotationeditormode", {
                                                source: a,
                                                mode: b,
                                                editId: c
                                            });
                                        });
                                    }
                                };
                                return he(g, [
                                    {
                                        key: "_isEditable",
                                        get: function() {
                                            return this.data.isEditable;
                                        }
                                    },
                                    {
                                        key: "hasPopupData",
                                        get: function() {
                                            return g._hasPopupData(this.data);
                                        }
                                    },
                                    {
                                        key: "_commonActions",
                                        get: function() {
                                            function a(c, d, e) {
                                                var h = e.detail[c];
                                                c = h[0];
                                                h = h.slice(1);
                                                e.target.style[d] = Ve[c + "_HTML"](h);
                                                e = {};
                                                b.annotationStorage.setValue(b.data.id, (e[d] = Ve[c + "_rgb"](h), e));
                                            }
                                            var b = this;
                                            return qa(this, "_commonActions", {
                                                display: function(c) {
                                                    c = c.detail.display;
                                                    var d = 1 === c % 2;
                                                    b.container.style.visibility = d ? "hidden" : "visible";
                                                    b.annotationStorage.setValue(b.data.id, {
                                                        noView: d,
                                                        noPrint: 1 === c || 2 === c
                                                    });
                                                },
                                                print: function(c) {
                                                    b.annotationStorage.setValue(b.data.id, {
                                                        noPrint: !c.detail.print
                                                    });
                                                },
                                                hidden: function(c) {
                                                    c = c.detail.hidden;
                                                    b.container.style.visibility = c ? "hidden" : "visible";
                                                    b.annotationStorage.setValue(b.data.id, {
                                                        noPrint: c,
                                                        noView: c
                                                    });
                                                },
                                                focus: function(c) {
                                                    setTimeout(function() {
                                                        return c.target.focus({
                                                            preventScroll: !1
                                                        });
                                                    }, 0);
                                                },
                                                userName: function(c) {
                                                    c.target.title = c.detail.userName;
                                                },
                                                readonly: function(c) {
                                                    c.target.disabled = c.detail.readonly;
                                                },
                                                required: function(c) {
                                                    b._setRequired(c.target, c.detail.required);
                                                },
                                                bgColor: function(c) {
                                                    a("bgColor", "backgroundColor", c);
                                                },
                                                fillColor: function(c) {
                                                    a("fillColor", "backgroundColor", c);
                                                },
                                                fgColor: function(c) {
                                                    a("fgColor", "color", c);
                                                },
                                                textColor: function(c) {
                                                    a("textColor", "color", c);
                                                },
                                                borderColor: function(c) {
                                                    a("borderColor", "borderColor", c);
                                                },
                                                strokeColor: function(c) {
                                                    a("strokeColor", "borderColor", c);
                                                },
                                                rotation: function(c) {
                                                    c = c.detail.rotation;
                                                    b.setRotation(c);
                                                    b.annotationStorage.setValue(b.data.id, {
                                                        rotation: c
                                                    });
                                                }
                                            });
                                        }
                                    }
                                ]);
                            }(), We = function(g) {
                                function f(b, c) {
                                    var d;
                                    void 0 === c && (c = null);
                                    c = g.call(this, b, {
                                        isRenderable: !0,
                                        ignoreBorder: !(null == (d = c) || !d.ignoreBorder),
                                        createQuadrilaterals: !0
                                    }) || this;
                                    c.isTooltipOnly = b.data.isTooltipOnly;
                                    return c;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.render = function() {
                                    var b = this.data, c = this.linkService, d = document.createElement("a");
                                    d.setAttribute("data-element-id", b.id);
                                    var e = !1;
                                    b.url ? (c.addLinkAttributes(d, b.url, b.newWindow), e = !0) : b.action ? (this._bindNamedAction(d, b.action), e = !0) : b.attachment ? (this.__bindAttachment(d, b.attachment, b.attachmentDest), e = !0) : b.setOCGState ? (this.__bindSetOCGState(d, b.setOCGState), e = !0) : b.dest ? (this._bindLink(d, b.dest), e = !0) : (b.actions && (b.actions.Action || b.actions["Mouse Up"] || b.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(d, b), e = !0), b.resetForm ? (this._bindResetFormAction(d, b.resetForm), e = !0) : this.isTooltipOnly && !e && (this._bindLink(d, ""), e = !0));
                                    this.container.classList.add("linkAnnotation");
                                    e && this.container.append(d);
                                    return this.container;
                                };
                                a.__setInternalLink = function() {
                                    this.container.setAttribute("data-internal-link", "");
                                };
                                a._bindLink = function(b, c) {
                                    var d = this;
                                    b.href = this.linkService.getDestinationHash(c);
                                    b.onclick = function() {
                                        c && d.linkService.goToDestination(c);
                                        return !1;
                                    };
                                    (c || "" === c) && this.__setInternalLink();
                                };
                                a._bindNamedAction = function(b, c) {
                                    var d = this;
                                    b.href = this.linkService.getAnchorUrl("");
                                    b.onclick = function() {
                                        d.linkService.executeNamedAction(c);
                                        return !1;
                                    };
                                    this.__setInternalLink();
                                };
                                a.__bindAttachment = function(b, c, d) {
                                    var e = this;
                                    void 0 === d && (d = null);
                                    b.href = this.linkService.getAnchorUrl("");
                                    c.description && (b.title = c.description);
                                    b.onclick = function() {
                                        var h;
                                        null == (h = e.downloadManager) || h.openOrDownloadData(c.content, c.filename, d);
                                        return !1;
                                    };
                                    this.__setInternalLink();
                                };
                                a.__bindSetOCGState = function(b, c) {
                                    var d = this;
                                    b.href = this.linkService.getAnchorUrl("");
                                    b.onclick = function() {
                                        d.linkService.executeSetOCGState(c);
                                        return !1;
                                    };
                                    this.__setInternalLink();
                                };
                                a._bindJSAction = function(b, c) {
                                    var d = this;
                                    b.href = this.linkService.getAnchorUrl("");
                                    for(var e = new Map([
                                        [
                                            "Action",
                                            "onclick"
                                        ],
                                        [
                                            "Mouse Up",
                                            "onmouseup"
                                        ],
                                        [
                                            "Mouse Down",
                                            "onmousedown"
                                        ]
                                    ]), h = p.makeIterator(Object.keys(c.actions)), k = h.next(), l = {}; !k.done; l = {
                                        name$jscomp$122: void 0
                                    }, k = h.next())l.name$jscomp$122 = k.value, (k = e.get(l.name$jscomp$122)) && (b[k] = function(m) {
                                        return function() {
                                            var n;
                                            null == (n = d.linkService.eventBus) || n.dispatch("dispatcheventinsandbox", {
                                                source: d,
                                                detail: {
                                                    id: c.id,
                                                    name: m.name$jscomp$122
                                                }
                                            });
                                            return !1;
                                        };
                                    }(l));
                                    b.onclick || (b.onclick = function() {
                                        return !1;
                                    });
                                    this.__setInternalLink();
                                };
                                a._bindResetFormAction = function(b, c) {
                                    var d = this, e = b.onclick;
                                    e || (b.href = this.linkService.getAnchorUrl(""));
                                    this.__setInternalLink();
                                    this._fieldObjects ? b.onclick = function() {
                                        null == e || e();
                                        var h = c.fields, k = c.refs, l = c.include, m = [];
                                        if (0 !== h.length || 0 !== k.length) {
                                            k = new Set(k);
                                            h = p.makeIterator(h);
                                            for(var n = h.next(); !n.done; n = h.next()){
                                                n = p.makeIterator(d._fieldObjects[n.value] || []);
                                                for(var q = n.next(); !q.done; q = n.next())k.add(q.value.id);
                                            }
                                            h = p.makeIterator(Object.values(d._fieldObjects));
                                            for(n = h.next(); !n.done; n = h.next())for(n = p.makeIterator(n.value), q = n.next(); !q.done; q = n.next())q = q.value, k.has(q.id) === l && m.push(q);
                                        } else for(l = p.makeIterator(Object.values(d._fieldObjects)), k = l.next(); !k.done; k = l.next())m.push.apply(m, p.arrayFromIterable(k.value));
                                        l = d.annotationStorage;
                                        k = [];
                                        m = p.makeIterator(m);
                                        for(h = m.next(); !h.done; h = m.next()){
                                            n = h.value;
                                            h = n.id;
                                            k.push(h);
                                            switch(n.type){
                                                case "text":
                                                    l.setValue(h, {
                                                        value: n.defaultValue || ""
                                                    });
                                                    break;
                                                case "checkbox":
                                                case "radiobutton":
                                                    l.setValue(h, {
                                                        value: n.defaultValue === n.exportValues
                                                    });
                                                    break;
                                                case "combobox":
                                                case "listbox":
                                                    l.setValue(h, {
                                                        value: n.defaultValue || ""
                                                    });
                                                    break;
                                                default:
                                                    continue;
                                            }
                                            (n = document.querySelector('[data-element-id="' + h + '"]')) && (hb.has(n) ? n.dispatchEvent(new Event("resetform")) : R("_bindResetFormAction - element not allowed: " + h));
                                        }
                                        if (d.enableScripting) {
                                            var r;
                                            null == (r = d.linkService.eventBus) || r.dispatch("dispatcheventinsandbox", {
                                                source: d,
                                                detail: {
                                                    id: "app",
                                                    ids: k,
                                                    name: "ResetForm"
                                                }
                                            });
                                        }
                                        return !1;
                                    } : (R('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), e || (b.onclick = function() {
                                        return !1;
                                    }));
                                };
                                return f;
                            }(Ea), Xg = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: !0
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    this.container.classList.add("textAnnotation");
                                    var a = document.createElement("img");
                                    a.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                                    a.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
                                    a.setAttribute("data-l10n-args", JSON.stringify({
                                        type: this.data.name
                                    }));
                                    !this.data.popupRef && this.hasPopupData && this._createPopup();
                                    this.container.append(a);
                                    return this.container;
                                };
                                return f;
                            }(Ea), ib = function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.render = function() {
                                    return this.container;
                                };
                                a.showElementAndHideCanvas = function(b) {
                                    if (this.data.hasOwnCanvas) {
                                        var c;
                                        "CANVAS" === (null == (c = b.previousSibling) ? void 0 : c.nodeName) && (b.previousSibling.hidden = !0);
                                        b.hidden = !1;
                                    }
                                };
                                a._getKeyModifier = function(b) {
                                    return Ka.platform.isMac ? b.metaKey : b.ctrlKey;
                                };
                                a._setEventListener = function(b, c, d, e, h) {
                                    var k = this;
                                    d.includes("mouse") ? b.addEventListener(d, function(l) {
                                        var m;
                                        null == (m = k.linkService.eventBus) || m.dispatch("dispatcheventinsandbox", {
                                            source: k,
                                            detail: {
                                                id: k.data.id,
                                                name: e,
                                                value: h(l),
                                                shift: l.shiftKey,
                                                modifier: k._getKeyModifier(l)
                                            }
                                        });
                                    }) : b.addEventListener(d, function(l) {
                                        var m;
                                        if ("blur" === d) {
                                            if (!c.focused || !l.relatedTarget) return;
                                            c.focused = !1;
                                        } else if ("focus" === d) {
                                            if (c.focused) return;
                                            c.focused = !0;
                                        }
                                        h && (null == (m = k.linkService.eventBus) || m.dispatch("dispatcheventinsandbox", {
                                            source: k,
                                            detail: {
                                                id: k.data.id,
                                                name: e,
                                                value: h(l)
                                            }
                                        }));
                                    });
                                };
                                a._setEventListeners = function(b, c, d, e) {
                                    d = p.makeIterator(d);
                                    for(var h = d.next(); !h.done; h = d.next()){
                                        var k = p.makeIterator(h.value);
                                        h = k.next().value;
                                        k = k.next().value;
                                        var l;
                                        if ("Action" === k || null != (l = this.data.actions) && l[k]) {
                                            var m, n;
                                            if ("Focus" === k || "Blur" === k) c || (c = {
                                                focused: !1
                                            });
                                            this._setEventListener(b, c, h, k, e);
                                            "Focus" !== k || null != (m = this.data.actions) && m.Blur ? "Blur" !== k || null != (n = this.data.actions) && n.Focus || this._setEventListener(b, c, "focus", "Focus", null) : this._setEventListener(b, c, "blur", "Blur", null);
                                        }
                                    }
                                };
                                a._setBackgroundColor = function(b) {
                                    var c = this.data.backgroundColor || null;
                                    b.style.backgroundColor = null === c ? "transparent" : fa.makeHexColor(c[0], c[1], c[2]);
                                };
                                a._setTextStyle = function(b) {
                                    var c = [
                                        "left",
                                        "center",
                                        "right"
                                    ], d = this.data.defaultAppearanceData.fontColor, e = this.data.defaultAppearanceData.fontSize || 9;
                                    b = b.style;
                                    if (this.data.multiLine) {
                                        var h = Math.abs(this.data.rect[3] - this.data.rect[1] - 2);
                                        e = Math.min(e, Math.round(h / (Math.round(h / (1.35 * e)) || 1) / 1.35 * 10) / 10);
                                    } else e = Math.min(e, Math.round(Math.abs(this.data.rect[3] - this.data.rect[1] - 2) / 1.35 * 10) / 10);
                                    b.fontSize = "calc(" + e + "px * var(--scale-factor))";
                                    b.color = fa.makeHexColor(d[0], d[1], d[2]);
                                    null !== this.data.textAlignment && (b.textAlign = c[this.data.textAlignment]);
                                };
                                a._setRequired = function(b, c) {
                                    c ? b.setAttribute("required", !0) : b.removeAttribute("required");
                                    b.setAttribute("aria-required", c);
                                };
                                return f;
                            }(Ea), Yg = function(g) {
                                function f(b) {
                                    return g.call(this, b, {
                                        isRenderable: b.renderForms || b.data.hasOwnCanvas || !b.data.hasAppearance && !!b.data.fieldValue
                                    }) || this;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.setPropertyOnSiblings = function(b, c, d, e) {
                                    var h = this.annotationStorage;
                                    b = p.makeIterator(this._getElementsByName(b.name, b.id));
                                    for(var k = b.next(); !k.done; k = b.next()){
                                        k = k.value;
                                        k.domElement && (k.domElement[c] = d);
                                        var l = {};
                                        h.setValue(k.id, (l[e] = d, l));
                                    }
                                };
                                a.render = function() {
                                    var b = this, c = this.annotationStorage, d = this.data.id;
                                    this.container.classList.add("textWidgetAnnotation");
                                    var e = null;
                                    if (this.renderForms) {
                                        var h, k = c.getValue(d, {
                                            value: this.data.fieldValue
                                        }), l = k.value || "", m = c.getValue(d, {
                                            charLimit: this.data.maxLen
                                        }).charLimit;
                                        m && l.length > m && (l = l.slice(0, m));
                                        (k = k.formattedValue || (null == (h = this.data.textContent) ? void 0 : h.join("\n")) || null) && this.data.comb && (k = k.replaceAll(/\s+/g, ""));
                                        var n = {
                                            userValue: l,
                                            formattedValue: k,
                                            lastCommittedValue: null,
                                            commitKey: 1,
                                            focused: !1
                                        };
                                        if (this.data.multiLine) {
                                            var q;
                                            e = document.createElement("textarea");
                                            e.textContent = null != (q = k) ? q : l;
                                            this.data.doNotScroll && (e.style.overflowY = "hidden");
                                        } else {
                                            var r;
                                            e = document.createElement("input");
                                            e.type = "text";
                                            e.setAttribute("value", null != (r = k) ? r : l);
                                            this.data.doNotScroll && (e.style.overflowX = "hidden");
                                        }
                                        this.data.hasOwnCanvas && (e.hidden = !0);
                                        hb.add(e);
                                        e.setAttribute("data-element-id", d);
                                        e.disabled = this.data.readOnly;
                                        e.name = this.data.fieldName;
                                        e.tabIndex = 1E3;
                                        this._setRequired(e, this.data.required);
                                        m && (e.maxLength = m);
                                        e.addEventListener("input", function(v) {
                                            c.setValue(d, {
                                                value: v.target.value
                                            });
                                            b.setPropertyOnSiblings(e, "value", v.target.value, "value");
                                            n.formattedValue = null;
                                        });
                                        e.addEventListener("resetform", function() {
                                            var v, w = null != (v = b.data.defaultFieldValue) ? v : "";
                                            e.value = n.userValue = w;
                                            n.formattedValue = null;
                                        });
                                        h = function(v) {
                                            var w = n.formattedValue;
                                            null !== w && void 0 !== w && (v.target.value = w);
                                            v.target.scrollLeft = 0;
                                        };
                                        if (this.enableScripting && this.hasJSActions) {
                                            var t;
                                            e.addEventListener("focus", function(v) {
                                                var w;
                                                n.focused || (v = v.target, n.userValue && (v.value = n.userValue), n.lastCommittedValue = v.value, n.commitKey = 1, null != (w = b.data.actions) && w.Focus || (n.focused = !0));
                                            });
                                            e.addEventListener("updatefromsandbox", function(v) {
                                                b.showElementAndHideCanvas(v.target);
                                                b._dispatchEventFromSandbox({
                                                    value: function(w) {
                                                        var x;
                                                        n.userValue = null != (x = w.detail.value) ? x : "";
                                                        c.setValue(d, {
                                                            value: n.userValue.toString()
                                                        });
                                                        w.target.value = n.userValue;
                                                    },
                                                    formattedValue: function(w) {
                                                        var x = w.detail.formattedValue;
                                                        n.formattedValue = x;
                                                        null !== x && void 0 !== x && w.target !== document.activeElement && (w.target.value = x);
                                                        c.setValue(d, {
                                                            formattedValue: x
                                                        });
                                                    },
                                                    selRange: function(w) {
                                                        w.target.setSelectionRange.apply(w.target, p.arrayFromIterable(w.detail.selRange));
                                                    },
                                                    charLimit: function(w) {
                                                        var x, B = w.detail.charLimit;
                                                        w = w.target;
                                                        if (0 === B) w.removeAttribute("maxLength");
                                                        else {
                                                            w.setAttribute("maxLength", B);
                                                            var z = n.userValue;
                                                            !z || z.length <= B || (z = z.slice(0, B), w.value = n.userValue = z, c.setValue(d, {
                                                                value: z
                                                            }), null == (x = b.linkService.eventBus) || x.dispatch("dispatcheventinsandbox", {
                                                                source: b,
                                                                detail: {
                                                                    id: d,
                                                                    name: "Keystroke",
                                                                    value: z,
                                                                    willCommit: !0,
                                                                    commitKey: 1,
                                                                    selStart: w.selectionStart,
                                                                    selEnd: w.selectionEnd
                                                                }
                                                            }));
                                                        }
                                                    }
                                                }, v);
                                            });
                                            e.addEventListener("keydown", function(v) {
                                                var w;
                                                n.commitKey = 1;
                                                var x = -1;
                                                "Escape" === v.key ? x = 0 : "Enter" !== v.key || b.data.multiLine ? "Tab" === v.key && (n.commitKey = 3) : x = 2;
                                                if (-1 !== x) {
                                                    var B = v.target.value;
                                                    n.lastCommittedValue !== B && (n.lastCommittedValue = B, n.userValue = B, null == (w = b.linkService.eventBus) || w.dispatch("dispatcheventinsandbox", {
                                                        source: b,
                                                        detail: {
                                                            id: d,
                                                            name: "Keystroke",
                                                            value: B,
                                                            willCommit: !0,
                                                            commitKey: x,
                                                            selStart: v.target.selectionStart,
                                                            selEnd: v.target.selectionEnd
                                                        }
                                                    }));
                                                }
                                            });
                                            var u = h;
                                            h = null;
                                            e.addEventListener("blur", function(v) {
                                                var w;
                                                if (n.focused && v.relatedTarget) {
                                                    null != (w = b.data.actions) && w.Blur || (n.focused = !1);
                                                    w = v.target.value;
                                                    n.userValue = w;
                                                    if (n.lastCommittedValue !== w) {
                                                        var x;
                                                        null == (x = b.linkService.eventBus) || x.dispatch("dispatcheventinsandbox", {
                                                            source: b,
                                                            detail: {
                                                                id: d,
                                                                name: "Keystroke",
                                                                value: w,
                                                                willCommit: !0,
                                                                commitKey: n.commitKey,
                                                                selStart: v.target.selectionStart,
                                                                selEnd: v.target.selectionEnd
                                                            }
                                                        });
                                                    }
                                                    u(v);
                                                }
                                            });
                                            null != (t = this.data.actions) && t.Keystroke && e.addEventListener("beforeinput", function(v) {
                                                var w;
                                                n.lastCommittedValue = null;
                                                var x = v.data, B = v.target, z = B.value, C = B.selectionStart, D = B.selectionEnd;
                                                B = C;
                                                var H = D;
                                                switch(v.inputType){
                                                    case "deleteWordBackward":
                                                        (C = z.substring(0, C).match(/\w*[^\w]*$/)) && (B -= C[0].length);
                                                        break;
                                                    case "deleteWordForward":
                                                        (C = z.substring(C).match(/^[^\w]*\w*/)) && (H += C[0].length);
                                                        break;
                                                    case "deleteContentBackward":
                                                        C === D && --B;
                                                        break;
                                                    case "deleteContentForward":
                                                        C === D && (H += 1);
                                                }
                                                v.preventDefault();
                                                null == (w = b.linkService.eventBus) || w.dispatch("dispatcheventinsandbox", {
                                                    source: b,
                                                    detail: {
                                                        id: d,
                                                        name: "Keystroke",
                                                        value: z,
                                                        change: x || "",
                                                        willCommit: !1,
                                                        selStart: B,
                                                        selEnd: H
                                                    }
                                                });
                                            });
                                            this._setEventListeners(e, n, [
                                                [
                                                    "focus",
                                                    "Focus"
                                                ],
                                                [
                                                    "blur",
                                                    "Blur"
                                                ],
                                                [
                                                    "mousedown",
                                                    "Mouse Down"
                                                ],
                                                [
                                                    "mouseenter",
                                                    "Mouse Enter"
                                                ],
                                                [
                                                    "mouseleave",
                                                    "Mouse Exit"
                                                ],
                                                [
                                                    "mouseup",
                                                    "Mouse Up"
                                                ]
                                            ], function(v) {
                                                return v.target.value;
                                            });
                                        }
                                        h && e.addEventListener("blur", h);
                                        this.data.comb && (m = (this.data.rect[2] - this.data.rect[0]) / m, e.classList.add("comb"), e.style.letterSpacing = "calc(" + m + "px * var(--scale-factor) - 1ch)");
                                    } else e = document.createElement("div"), e.textContent = this.data.fieldValue, e.style.verticalAlign = "middle", e.style.display = "table-cell", this.data.hasOwnCanvas && (e.hidden = !0);
                                    this._setTextStyle(e);
                                    this._setBackgroundColor(e);
                                    this._setDefaultPropertiesFromJS(e);
                                    this.container.append(e);
                                    return this.container;
                                };
                                return f;
                            }(ib), bh = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: !!a.data.hasOwnCanvas
                                    }) || this;
                                }
                                Aa(f, g);
                                return f;
                            }(ib), Zg = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: a.renderForms
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    var a = this, b = this.annotationStorage, c = this.data, d = c.id, e = b.getValue(d, {
                                        value: c.exportValue === c.fieldValue
                                    }).value;
                                    "string" === typeof e && (e = "Off" !== e, b.setValue(d, {
                                        value: e
                                    }));
                                    this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                                    var h = document.createElement("input");
                                    hb.add(h);
                                    h.setAttribute("data-element-id", d);
                                    h.disabled = c.readOnly;
                                    this._setRequired(h, this.data.required);
                                    h.type = "checkbox";
                                    h.name = c.fieldName;
                                    e && h.setAttribute("checked", !0);
                                    h.setAttribute("exportValue", c.exportValue);
                                    h.tabIndex = 1E3;
                                    h.addEventListener("change", function(k) {
                                        var l = k.target;
                                        k = l.checked;
                                        l = p.makeIterator(a._getElementsByName(l.name, d));
                                        for(var m = l.next(); !m.done; m = l.next()){
                                            m = m.value;
                                            var n = k && m.exportValue === c.exportValue;
                                            m.domElement && (m.domElement.checked = n);
                                            b.setValue(m.id, {
                                                value: n
                                            });
                                        }
                                        b.setValue(d, {
                                            value: k
                                        });
                                    });
                                    h.addEventListener("resetform", function(k) {
                                        k.target.checked = (c.defaultFieldValue || "Off") === c.exportValue;
                                    });
                                    this.enableScripting && this.hasJSActions && (h.addEventListener("updatefromsandbox", function(k) {
                                        a._dispatchEventFromSandbox({
                                            value: function(l) {
                                                l.target.checked = "Off" !== l.detail.value;
                                                b.setValue(d, {
                                                    value: l.target.checked
                                                });
                                            }
                                        }, k);
                                    }), this._setEventListeners(h, null, [
                                        [
                                            "change",
                                            "Validate"
                                        ],
                                        [
                                            "change",
                                            "Action"
                                        ],
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ]
                                    ], function(k) {
                                        return k.target.checked;
                                    }));
                                    this._setBackgroundColor(h);
                                    this._setDefaultPropertiesFromJS(h);
                                    this.container.append(h);
                                    return this.container;
                                };
                                return f;
                            }(ib), Xe = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: a.renderForms
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    var a = this;
                                    this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                                    var b = this.annotationStorage, c = this.data, d = c.id, e = b.getValue(d, {
                                        value: c.fieldValue === c.buttonValue
                                    }).value;
                                    "string" === typeof e && (e = e !== c.buttonValue, b.setValue(d, {
                                        value: e
                                    }));
                                    if (e) for(var h = p.makeIterator(this._getElementsByName(c.fieldName, d)), k = h.next(); !k.done; k = h.next())b.setValue(k.value.id, {
                                        value: !1
                                    });
                                    h = document.createElement("input");
                                    hb.add(h);
                                    h.setAttribute("data-element-id", d);
                                    h.disabled = c.readOnly;
                                    this._setRequired(h, this.data.required);
                                    h.type = "radio";
                                    h.name = c.fieldName;
                                    e && h.setAttribute("checked", !0);
                                    h.tabIndex = 1E3;
                                    h.addEventListener("change", function(m) {
                                        var n = m.target;
                                        m = n.checked;
                                        n = p.makeIterator(a._getElementsByName(n.name, d));
                                        for(var q = n.next(); !q.done; q = n.next())b.setValue(q.value.id, {
                                            value: !1
                                        });
                                        b.setValue(d, {
                                            value: m
                                        });
                                    });
                                    h.addEventListener("resetform", function(m) {
                                        var n = c.defaultFieldValue;
                                        m.target.checked = null !== n && void 0 !== n && n === c.buttonValue;
                                    });
                                    if (this.enableScripting && this.hasJSActions) {
                                        var l = c.buttonValue;
                                        h.addEventListener("updatefromsandbox", function(m) {
                                            a._dispatchEventFromSandbox({
                                                value: function(n) {
                                                    var q = l === n.detail.value;
                                                    n = p.makeIterator(a._getElementsByName(n.target.name));
                                                    for(var r = n.next(); !r.done; r = n.next()){
                                                        r = r.value;
                                                        var t = q && r.id === d;
                                                        r.domElement && (r.domElement.checked = t);
                                                        b.setValue(r.id, {
                                                            value: t
                                                        });
                                                    }
                                                }
                                            }, m);
                                        });
                                        this._setEventListeners(h, null, [
                                            [
                                                "change",
                                                "Validate"
                                            ],
                                            [
                                                "change",
                                                "Action"
                                            ],
                                            [
                                                "focus",
                                                "Focus"
                                            ],
                                            [
                                                "blur",
                                                "Blur"
                                            ],
                                            [
                                                "mousedown",
                                                "Mouse Down"
                                            ],
                                            [
                                                "mouseenter",
                                                "Mouse Enter"
                                            ],
                                            [
                                                "mouseleave",
                                                "Mouse Exit"
                                            ],
                                            [
                                                "mouseup",
                                                "Mouse Up"
                                            ]
                                        ], function(m) {
                                            return m.target.checked;
                                        });
                                    }
                                    this._setBackgroundColor(h);
                                    this._setDefaultPropertiesFromJS(h);
                                    this.container.append(h);
                                    return this.container;
                                };
                                return f;
                            }(ib), $g = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        ignoreBorder: a.data.hasAppearance
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    var a = this, b = g.prototype.render.call(this);
                                    b.classList.add("buttonWidgetAnnotation", "pushButton");
                                    var c = b.lastChild;
                                    this.enableScripting && this.hasJSActions && c && (this._setDefaultPropertiesFromJS(c), c.addEventListener("updatefromsandbox", function(d) {
                                        a._dispatchEventFromSandbox({}, d);
                                    }));
                                    return b;
                                };
                                return f;
                            }(We), ah = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: a.renderForms
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    function a(v) {
                                        return Array.prototype.map.call(v.target.options, function(w) {
                                            return {
                                                displayValue: w.textContent,
                                                exportValue: w.value
                                            };
                                        });
                                    }
                                    function b(v) {
                                        var w = v ? "value" : "textContent";
                                        v = k.options;
                                        return k.multiple ? Array.prototype.filter.call(v, function(x) {
                                            return x.selected;
                                        }).map(function(x) {
                                            return x[w];
                                        }) : -1 === v.selectedIndex ? null : v[v.selectedIndex][w];
                                    }
                                    var c = this;
                                    this.container.classList.add("choiceWidgetAnnotation");
                                    var d = this.annotationStorage, e = this.data.id, h = d.getValue(e, {
                                        value: this.data.fieldValue
                                    }), k = document.createElement("select");
                                    hb.add(k);
                                    k.setAttribute("data-element-id", e);
                                    k.disabled = this.data.readOnly;
                                    this._setRequired(k, this.data.required);
                                    k.name = this.data.fieldName;
                                    k.tabIndex = 1E3;
                                    var l = this.data.combo && 0 < this.data.options.length;
                                    this.data.combo || (k.size = this.data.options.length, this.data.multiSelect && (k.multiple = !0));
                                    k.addEventListener("resetform", function() {
                                        for(var v = c.data.defaultFieldValue, w = p.makeIterator(k.options), x = w.next(); !x.done; x = w.next())x = x.value, x.selected = x.value === v;
                                    });
                                    for(var m = p.makeIterator(this.data.options), n = m.next(); !n.done; n = m.next()){
                                        n = n.value;
                                        var q = document.createElement("option");
                                        q.textContent = n.displayValue;
                                        q.value = n.exportValue;
                                        h.value.includes(n.exportValue) && (q.setAttribute("selected", !0), l = !1);
                                        k.append(q);
                                    }
                                    var r = null;
                                    if (l) {
                                        var t = document.createElement("option");
                                        t.value = " ";
                                        t.setAttribute("hidden", !0);
                                        t.setAttribute("selected", !0);
                                        k.prepend(t);
                                        r = function() {
                                            t.remove();
                                            k.removeEventListener("input", r);
                                            r = null;
                                        };
                                        k.addEventListener("input", r);
                                    }
                                    var u = b(!1);
                                    this.enableScripting && this.hasJSActions ? (k.addEventListener("updatefromsandbox", function(v) {
                                        c._dispatchEventFromSandbox({
                                            value: function(w) {
                                                null == r || r();
                                                w = w.detail.value;
                                                w = new Set(Array.isArray(w) ? w : [
                                                    w
                                                ]);
                                                for(var x = p.makeIterator(k.options), B = x.next(); !B.done; B = x.next())B = B.value, B.selected = w.has(B.value);
                                                d.setValue(e, {
                                                    value: b(!0)
                                                });
                                                u = b(!1);
                                            },
                                            multipleSelection: function() {
                                                k.multiple = !0;
                                            },
                                            remove: function(w) {
                                                var x = k.options, B = w.detail.remove;
                                                x[B].selected = !1;
                                                k.remove(B);
                                                0 < x.length && -1 === Array.prototype.findIndex.call(x, function(z) {
                                                    return z.selected;
                                                }) && (x[0].selected = !0);
                                                d.setValue(e, {
                                                    value: b(!0),
                                                    items: a(w)
                                                });
                                                u = b(!1);
                                            },
                                            clear: function() {
                                                for(; 0 !== k.length;)k.remove(0);
                                                d.setValue(e, {
                                                    value: null,
                                                    items: []
                                                });
                                                u = b(!1);
                                            },
                                            insert: function(w) {
                                                var x = w.detail.insert, B = x.displayValue, z = x.exportValue;
                                                x = k.children[x.index];
                                                var C = document.createElement("option");
                                                C.textContent = B;
                                                C.value = z;
                                                x ? x.before(C) : k.append(C);
                                                d.setValue(e, {
                                                    value: b(!0),
                                                    items: a(w)
                                                });
                                                u = b(!1);
                                            },
                                            items: function(w) {
                                                for(var x = w.detail.items; 0 !== k.length;)k.remove(0);
                                                x = p.makeIterator(x);
                                                for(var B = x.next(); !B.done; B = x.next()){
                                                    var z = B.value;
                                                    B = z.displayValue;
                                                    z = z.exportValue;
                                                    var C = document.createElement("option");
                                                    C.textContent = B;
                                                    C.value = z;
                                                    k.append(C);
                                                }
                                                0 < k.options.length && (k.options[0].selected = !0);
                                                d.setValue(e, {
                                                    value: b(!0),
                                                    items: a(w)
                                                });
                                                u = b(!1);
                                            },
                                            indices: function(w) {
                                                var x = new Set(w.detail.indices);
                                                w = p.makeIterator(w.target.options);
                                                for(var B = w.next(); !B.done; B = w.next())B = B.value, B.selected = x.has(B.index);
                                                d.setValue(e, {
                                                    value: b(!0)
                                                });
                                                u = b(!1);
                                            },
                                            editable: function(w) {
                                                w.target.disabled = !w.detail.editable;
                                            }
                                        }, v);
                                    }), k.addEventListener("input", function(v) {
                                        var w, x = b(!0), B = b(!1);
                                        d.setValue(e, {
                                            value: x
                                        });
                                        v.preventDefault();
                                        null == (w = c.linkService.eventBus) || w.dispatch("dispatcheventinsandbox", {
                                            source: c,
                                            detail: {
                                                id: e,
                                                name: "Keystroke",
                                                value: u,
                                                change: B,
                                                changeEx: x,
                                                willCommit: !1,
                                                commitKey: 1,
                                                keyDown: !1
                                            }
                                        });
                                    }), this._setEventListeners(k, null, [
                                        [
                                            "focus",
                                            "Focus"
                                        ],
                                        [
                                            "blur",
                                            "Blur"
                                        ],
                                        [
                                            "mousedown",
                                            "Mouse Down"
                                        ],
                                        [
                                            "mouseenter",
                                            "Mouse Enter"
                                        ],
                                        [
                                            "mouseleave",
                                            "Mouse Exit"
                                        ],
                                        [
                                            "mouseup",
                                            "Mouse Up"
                                        ],
                                        [
                                            "input",
                                            "Action"
                                        ],
                                        [
                                            "input",
                                            "Validate"
                                        ]
                                    ], function(v) {
                                        return v.target.value;
                                    })) : k.addEventListener("input", function() {
                                        d.setValue(e, {
                                            value: b(!0)
                                        });
                                    });
                                    this.data.combo && this._setTextStyle(k);
                                    this._setBackgroundColor(k);
                                    this._setDefaultPropertiesFromJS(k);
                                    this.container.append(k);
                                    return this.container;
                                };
                                return f;
                            }(ib), Uc = function(g) {
                                function f(a) {
                                    var b = a.elements;
                                    a = g.call(this, a, {
                                        isRenderable: Ea._hasPopupData(a.data)
                                    }) || this;
                                    a.elements = b;
                                    a.popup = null;
                                    return a;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    this.container.classList.add("popupAnnotation");
                                    for(var a = this.popup = new mh({
                                        container: this.container,
                                        color: this.data.color,
                                        titleObj: this.data.titleObj,
                                        modificationDate: this.data.modificationDate,
                                        contentsObj: this.data.contentsObj,
                                        richText: this.data.richText,
                                        rect: this.data.rect,
                                        parentRect: this.data.parentRect || null,
                                        parent: this.parent,
                                        elements: this.elements,
                                        open: this.data.open
                                    }), b = [], c = p.makeIterator(this.elements), d = c.next(); !d.done; d = c.next())d = d.value, d.popup = a, d.container.ariaHasPopup = "dialog", b.push(d.data.id), d.addHighlightArea();
                                    this.container.setAttribute("aria-controls", b.map(function(e) {
                                        return "pdfjs_internal_id_" + e;
                                    }).join(","));
                                    return this.container;
                                };
                                return f;
                            }(Ea), mh = function() {
                                function g(a) {
                                    var b = a.container, c = a.color, d = a.elements, e = a.titleObj, h = a.modificationDate, k = a.contentsObj, l = a.richText, m = a.parent, n = a.rect, q = a.parentRect;
                                    a = a.open;
                                    this.__boundKeyDown = this.__keyDown.bind(this);
                                    this.__boundHide = this.__hide.bind(this);
                                    this.__boundShow = this.__show.bind(this);
                                    this.__boundToggle = this.__toggle.bind(this);
                                    this.__parentRect = this.__parent = this.__elements = this.__dateObj = this.__contentsObj = this.__container = this.__color = null;
                                    this.__pinned = !1;
                                    this.__updates = this.__titleObj = this.__richText = this.__rect = this.__position = this.__popup = null;
                                    this.__wasVisible = !1;
                                    this.__container = b;
                                    this.__titleObj = e;
                                    this.__contentsObj = k;
                                    this.__richText = l;
                                    this.__parent = m;
                                    this.__color = c;
                                    this.__rect = n;
                                    this.__parentRect = q;
                                    this.__elements = d;
                                    this.__dateObj = Mc.toDateObject(h);
                                    this.trigger = d.flatMap(function(t) {
                                        return t.getElementsToTriggerPopup();
                                    });
                                    b = p.makeIterator(this.trigger);
                                    for(c = b.next(); !c.done; c = b.next())c = c.value, c.addEventListener("click", this.__boundToggle), c.addEventListener("mouseenter", this.__boundShow), c.addEventListener("mouseleave", this.__boundHide), c.classList.add("popupTriggerArea");
                                    d = p.makeIterator(d);
                                    for(b = d.next(); !b.done; b = d.next()){
                                        var r;
                                        null == (r = b.value.container) || r.addEventListener("keydown", this.__boundKeyDown);
                                    }
                                    this.__container.hidden = !0;
                                    a && this.__toggle();
                                }
                                var f = g.prototype;
                                f.render = function() {
                                    if (!this.__popup) {
                                        var a = this.__popup = document.createElement("div");
                                        a.className = "popup";
                                        if (this.__color) {
                                            var b = a.style.outlineColor = fa.makeHexColor.apply(fa, p.arrayFromIterable(this.__color));
                                            CSS.supports("background-color", "color-mix(in srgb, red 30%, white)") ? a.style.backgroundColor = "color-mix(in srgb, " + b + " 30%, white)" : a.style.backgroundColor = fa.makeHexColor.apply(fa, p.arrayFromIterable(this.__color.map(function(e) {
                                                return Math.floor(.7 * (255 - e) + e);
                                            })));
                                        }
                                        b = document.createElement("span");
                                        b.className = "header";
                                        var c = document.createElement("h1");
                                        b.append(c);
                                        var d = this.__titleObj;
                                        c.dir = d.dir;
                                        c.textContent = d.str;
                                        a.append(b);
                                        this.__dateObj && (c = document.createElement("span"), c.classList.add("popupDate"), c.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string"), c.setAttribute("data-l10n-args", JSON.stringify({
                                            dateObj: this.__dateObj.valueOf()
                                        })), b.append(c));
                                        (b = this.__html) ? (Be.render({
                                            xfaHtml: b,
                                            intent: "richText",
                                            div: a
                                        }), a.lastChild.classList.add("richText", "popupContent")) : (b = this._formatContents(this.__contentsObj), a.append(b));
                                        this.__container.append(a);
                                    }
                                };
                                f.__makePopupContent = function(a) {
                                    var b = [], c = {
                                        str: a,
                                        html: {
                                            name: "div",
                                            attributes: {
                                                dir: "auto"
                                            },
                                            children: [
                                                {
                                                    name: "p",
                                                    children: b
                                                }
                                            ]
                                        }
                                    }, d = {
                                        style: {
                                            color: this.__fontColor,
                                            fontSize: this.__fontSize ? "calc(" + this.__fontSize + "px * var(--scale-factor))" : ""
                                        }
                                    };
                                    a = p.makeIterator(a.split("\n"));
                                    for(var e = a.next(); !e.done; e = a.next())b.push({
                                        name: "span",
                                        value: e.value,
                                        attributes: d
                                    });
                                    return c;
                                };
                                f._formatContents = function(a) {
                                    var b = a.str, c = a.dir;
                                    a = document.createElement("p");
                                    a.classList.add("popupContent");
                                    a.dir = c;
                                    b = b.split(/(?:\r\n?|\n)/);
                                    c = 0;
                                    for(var d = b.length; c < d; ++c)a.append(document.createTextNode(b[c])), c < d - 1 && a.append(document.createElement("br"));
                                    return a;
                                };
                                f.__keyDown = function(a) {
                                    a.altKey || a.shiftKey || a.ctrlKey || a.metaKey || ("Enter" === a.key || "Escape" === a.key && this.__pinned) && this.__toggle();
                                };
                                f.updateEdited = function(a) {
                                    var b, c = a.rect;
                                    a = a.popupContent;
                                    this.__updates || (this.__updates = {
                                        contentsObj: this.__contentsObj,
                                        richText: this.__richText
                                    });
                                    c && (this.__position = null);
                                    a && (this.__richText = this.__makePopupContent(a), this.__contentsObj = null);
                                    null == (b = this.__popup) || b.remove();
                                    this.__popup = null;
                                };
                                f.resetEdited = function() {
                                    var a;
                                    if (this.__updates) {
                                        var b = this.__updates;
                                        this.__contentsObj = b.contentsObj;
                                        this.__richText = b.richText;
                                        this.__updates = null;
                                        null == (a = this.__popup) || a.remove();
                                        this.__position = this.__popup = null;
                                    }
                                };
                                f.__setPosition = function() {
                                    if (null === this.__position) {
                                        var a = this.__parent, b = a.page.view, c = a.viewport.rawDims;
                                        a = c.pageWidth;
                                        var d = c.pageHeight, e = c.pageX;
                                        c = c.pageY;
                                        for(var h = !!this.__parentRect, k = h ? this.__parentRect : this.__rect, l = p.makeIterator(this.__elements), m = l.next(); !m.done; m = l.next())if (m = m.value, !k || null !== fa.intersect(m.data.rect, k)) {
                                            k = m.data.rect;
                                            h = !0;
                                            break;
                                        }
                                        b = fa.normalizeRect([
                                            k[0],
                                            b[3] - k[1] + b[1],
                                            k[2],
                                            b[3] - k[3] + b[1]
                                        ]);
                                        this.__position = [
                                            100 * (b[0] + (h ? k[2] - k[0] + 5 : 0) - e) / a,
                                            100 * (b[1] - c) / d
                                        ];
                                        b = this.__container.style;
                                        b.left = this.__position[0] + "%";
                                        b.top = this.__position[1] + "%";
                                    }
                                };
                                f.__toggle = function() {
                                    (this.__pinned = !this.__pinned) ? (this.__show(), this.__container.addEventListener("click", this.__boundToggle), this.__container.addEventListener("keydown", this.__boundKeyDown)) : (this.__hide(), this.__container.removeEventListener("click", this.__boundToggle), this.__container.removeEventListener("keydown", this.__boundKeyDown));
                                };
                                f.__show = function() {
                                    this.__popup || this.render();
                                    this.isVisible ? this.__pinned && this.__container.classList.add("focused") : (this.__setPosition(), this.__container.hidden = !1, this.__container.style.zIndex = parseInt(this.__container.style.zIndex) + 1E3);
                                };
                                f.__hide = function() {
                                    this.__container.classList.remove("focused");
                                    !this.__pinned && this.isVisible && (this.__container.hidden = !0, this.__container.style.zIndex = parseInt(this.__container.style.zIndex) - 1E3);
                                };
                                f.forceHide = function() {
                                    if (this.__wasVisible = this.isVisible) this.__container.hidden = !0;
                                };
                                f.maybeShow = function() {
                                    this.__wasVisible && (this.__popup || this.__show(), this.__wasVisible = !1, this.__container.hidden = !1);
                                };
                                return he(g, [
                                    {
                                        key: "__html",
                                        get: function() {
                                            var a = this.__richText, b = this.__contentsObj;
                                            return null == a || !a.str || null != b && b.str && b.str !== a.str ? null : this.__richText.html || null;
                                        }
                                    },
                                    {
                                        key: "__fontSize",
                                        get: function() {
                                            var a;
                                            return (null == (a = this.__html) || null == (a = a.attributes) || null == (a = a.style) ? void 0 : a.fontSize) || 0;
                                        }
                                    },
                                    {
                                        key: "__fontColor",
                                        get: function() {
                                            var a;
                                            return (null == (a = this.__html) || null == (a = a.attributes) || null == (a = a.style) ? void 0 : a.color) || null;
                                        }
                                    },
                                    {
                                        key: "isVisible",
                                        get: function() {
                                            return !1 === this.__container.hidden;
                                        }
                                    }
                                ]);
                            }(), Ye = function(g) {
                                function f(a) {
                                    var b = g.call(this, a, {
                                        isRenderable: !0,
                                        ignoreBorder: !0
                                    }) || this;
                                    b.textContent = a.data.textContent;
                                    b.textPosition = a.data.textPosition;
                                    b.annotationEditorType = sa.FREETEXT;
                                    return b;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    this.container.classList.add("freeTextAnnotation");
                                    if (this.textContent) {
                                        var a = document.createElement("div");
                                        a.classList.add("annotationTextContent");
                                        a.setAttribute("role", "comment");
                                        for(var b = p.makeIterator(this.textContent), c = b.next(); !c.done; c = b.next()){
                                            c = c.value;
                                            var d = document.createElement("span");
                                            d.textContent = c;
                                            a.append(d);
                                        }
                                        this.container.append(a);
                                    }
                                    !this.data.popupRef && this.hasPopupData && this._createPopup();
                                    this._editOnDoubleClick();
                                    return this.container;
                                };
                                return f;
                            }(Ea), ch = function(g) {
                                function f(b) {
                                    b = g.call(this, b, {
                                        isRenderable: !0,
                                        ignoreBorder: !0
                                    }) || this;
                                    b.__line = null;
                                    return b;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.render = function() {
                                    this.container.classList.add("lineAnnotation");
                                    var b = this.data, c = Ua(b.rect);
                                    c = this.svgFactory.create(c.width, c.height, !0);
                                    var d = this.__line = this.svgFactory.createElement("svg:line");
                                    d.setAttribute("x1", b.rect[2] - b.lineCoordinates[0]);
                                    d.setAttribute("y1", b.rect[3] - b.lineCoordinates[1]);
                                    d.setAttribute("x2", b.rect[2] - b.lineCoordinates[2]);
                                    d.setAttribute("y2", b.rect[3] - b.lineCoordinates[3]);
                                    d.setAttribute("stroke-width", b.borderStyle.width || 1);
                                    d.setAttribute("stroke", "transparent");
                                    d.setAttribute("fill", "transparent");
                                    c.append(d);
                                    this.container.append(c);
                                    !b.popupRef && this.hasPopupData && this._createPopup();
                                    return this.container;
                                };
                                a.getElementsToTriggerPopup = function() {
                                    return this.__line;
                                };
                                a.addHighlightArea = function() {
                                    this.container.classList.add("highlightArea");
                                };
                                return f;
                            }(Ea), dh = function(g) {
                                function f(b) {
                                    b = g.call(this, b, {
                                        isRenderable: !0,
                                        ignoreBorder: !0
                                    }) || this;
                                    b.__square = null;
                                    return b;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.render = function() {
                                    this.container.classList.add("squareAnnotation");
                                    var b = this.data, c = Ua(b.rect), d = c.width;
                                    c = c.height;
                                    var e = this.svgFactory.create(d, c, !0), h = b.borderStyle.width, k = this.__square = this.svgFactory.createElement("svg:rect");
                                    k.setAttribute("x", h / 2);
                                    k.setAttribute("y", h / 2);
                                    k.setAttribute("width", d - h);
                                    k.setAttribute("height", c - h);
                                    k.setAttribute("stroke-width", h || 1);
                                    k.setAttribute("stroke", "transparent");
                                    k.setAttribute("fill", "transparent");
                                    e.append(k);
                                    this.container.append(e);
                                    !b.popupRef && this.hasPopupData && this._createPopup();
                                    return this.container;
                                };
                                a.getElementsToTriggerPopup = function() {
                                    return this.__square;
                                };
                                a.addHighlightArea = function() {
                                    this.container.classList.add("highlightArea");
                                };
                                return f;
                            }(Ea), eh = function(g) {
                                function f(b) {
                                    b = g.call(this, b, {
                                        isRenderable: !0,
                                        ignoreBorder: !0
                                    }) || this;
                                    b.__circle = null;
                                    return b;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.render = function() {
                                    this.container.classList.add("circleAnnotation");
                                    var b = this.data, c = Ua(b.rect), d = c.width;
                                    c = c.height;
                                    var e = this.svgFactory.create(d, c, !0), h = b.borderStyle.width, k = this.__circle = this.svgFactory.createElement("svg:ellipse");
                                    k.setAttribute("cx", d / 2);
                                    k.setAttribute("cy", c / 2);
                                    k.setAttribute("rx", d / 2 - h / 2);
                                    k.setAttribute("ry", c / 2 - h / 2);
                                    k.setAttribute("stroke-width", h || 1);
                                    k.setAttribute("stroke", "transparent");
                                    k.setAttribute("fill", "transparent");
                                    e.append(k);
                                    this.container.append(e);
                                    !b.popupRef && this.hasPopupData && this._createPopup();
                                    return this.container;
                                };
                                a.getElementsToTriggerPopup = function() {
                                    return this.__circle;
                                };
                                a.addHighlightArea = function() {
                                    this.container.classList.add("highlightArea");
                                };
                                return f;
                            }(Ea), Ze = function(g) {
                                function f(b) {
                                    b = g.call(this, b, {
                                        isRenderable: !0,
                                        ignoreBorder: !0
                                    }) || this;
                                    b.__polyline = null;
                                    b.containerClassName = "polylineAnnotation";
                                    b.svgElementName = "svg:polyline";
                                    return b;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.render = function() {
                                    this.container.classList.add(this.containerClassName);
                                    var b = this.data, c = b.rect, d = b.vertices, e = b.borderStyle;
                                    b = b.popupRef;
                                    if (!d) return this.container;
                                    var h = Ua(c);
                                    h = this.svgFactory.create(h.width, h.height, !0);
                                    for(var k = [], l = 0, m = d.length; l < m; l += 2)k.push(d[l] - c[0] + "," + (c[3] - d[l + 1]));
                                    k = k.join(" ");
                                    c = this.__polyline = this.svgFactory.createElement(this.svgElementName);
                                    c.setAttribute("points", k);
                                    c.setAttribute("stroke-width", e.width || 1);
                                    c.setAttribute("stroke", "transparent");
                                    c.setAttribute("fill", "transparent");
                                    h.append(c);
                                    this.container.append(h);
                                    !b && this.hasPopupData && this._createPopup();
                                    return this.container;
                                };
                                a.getElementsToTriggerPopup = function() {
                                    return this.__polyline;
                                };
                                a.addHighlightArea = function() {
                                    this.container.classList.add("highlightArea");
                                };
                                return f;
                            }(Ea), gh = function(g) {
                                function f(a) {
                                    a = g.call(this, a) || this;
                                    a.containerClassName = "polygonAnnotation";
                                    a.svgElementName = "svg:polygon";
                                    return a;
                                }
                                Aa(f, g);
                                return f;
                            }(Ze), fh = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: !0,
                                        ignoreBorder: !0
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    this.container.classList.add("caretAnnotation");
                                    !this.data.popupRef && this.hasPopupData && this._createPopup();
                                    return this.container;
                                };
                                return f;
                            }(Ea), Vc = function(g) {
                                function f(b) {
                                    b = g.call(this, b, {
                                        isRenderable: !0,
                                        ignoreBorder: !0
                                    }) || this;
                                    b.__polylines = [];
                                    b.containerClassName = "inkAnnotation";
                                    b.svgElementName = "svg:polyline";
                                    b.annotationEditorType = "InkHighlight" === b.data.it ? sa.HIGHLIGHT : sa.INK;
                                    return b;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.render = function() {
                                    this.container.classList.add(this.containerClassName);
                                    var b = this.data, c = b.rect, d = b.inkLists, e = b.borderStyle;
                                    b = b.popupRef;
                                    var h = Ua(c);
                                    h = this.svgFactory.create(h.width, h.height, !0);
                                    d = p.makeIterator(d);
                                    for(var k = d.next(); !k.done; k = d.next()){
                                        var l = k.value;
                                        k = [];
                                        for(var m = 0, n = l.length; m < n; m += 2)k.push(l[m] - c[0] + "," + (c[3] - l[m + 1]));
                                        k = k.join(" ");
                                        l = this.svgFactory.createElement(this.svgElementName);
                                        this.__polylines.push(l);
                                        l.setAttribute("points", k);
                                        l.setAttribute("stroke-width", e.width || 1);
                                        l.setAttribute("stroke", "transparent");
                                        l.setAttribute("fill", "transparent");
                                        h.append(l);
                                    }
                                    !b && this.hasPopupData && this._createPopup();
                                    this.container.append(h);
                                    this._editOnDoubleClick();
                                    return this.container;
                                };
                                a.getElementsToTriggerPopup = function() {
                                    return this.__polylines;
                                };
                                a.addHighlightArea = function() {
                                    this.container.classList.add("highlightArea");
                                };
                                return f;
                            }(Ea), $e = function(g) {
                                function f(a) {
                                    a = g.call(this, a, {
                                        isRenderable: !0,
                                        ignoreBorder: !0,
                                        createQuadrilaterals: !0
                                    }) || this;
                                    a.annotationEditorType = sa.HIGHLIGHT;
                                    return a;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    !this.data.popupRef && this.hasPopupData && this._createPopup();
                                    this.container.classList.add("highlightAnnotation");
                                    this._editOnDoubleClick();
                                    return this.container;
                                };
                                return f;
                            }(Ea), hh = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: !0,
                                        ignoreBorder: !0,
                                        createQuadrilaterals: !0
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    !this.data.popupRef && this.hasPopupData && this._createPopup();
                                    this.container.classList.add("underlineAnnotation");
                                    return this.container;
                                };
                                return f;
                            }(Ea), ih = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: !0,
                                        ignoreBorder: !0,
                                        createQuadrilaterals: !0
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    !this.data.popupRef && this.hasPopupData && this._createPopup();
                                    this.container.classList.add("squigglyAnnotation");
                                    return this.container;
                                };
                                return f;
                            }(Ea), jh = function(g) {
                                function f(a) {
                                    return g.call(this, a, {
                                        isRenderable: !0,
                                        ignoreBorder: !0,
                                        createQuadrilaterals: !0
                                    }) || this;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    !this.data.popupRef && this.hasPopupData && this._createPopup();
                                    this.container.classList.add("strikeoutAnnotation");
                                    return this.container;
                                };
                                return f;
                            }(Ea), af = function(g) {
                                function f(a) {
                                    a = g.call(this, a, {
                                        isRenderable: !0,
                                        ignoreBorder: !0
                                    }) || this;
                                    a.annotationEditorType = sa.STAMP;
                                    return a;
                                }
                                Aa(f, g);
                                f.prototype.render = function() {
                                    this.container.classList.add("stampAnnotation");
                                    this.container.setAttribute("role", "img");
                                    !this.data.popupRef && this.hasPopupData && this._createPopup();
                                    this._editOnDoubleClick();
                                    return this.container;
                                };
                                return f;
                            }(Ea), kh = function(g) {
                                function f(b) {
                                    var c;
                                    b = g.call(this, b, {
                                        isRenderable: !0
                                    }) || this;
                                    b.__trigger = null;
                                    var d = b.data.file;
                                    b.filename = d.filename;
                                    b.content = d.content;
                                    null == (c = b.linkService.eventBus) || c.dispatch("fileattachmentannotation", Object.assign({
                                        source: b
                                    }, d));
                                    return b;
                                }
                                Aa(f, g);
                                var a = f.prototype;
                                a.render = function() {
                                    var b = this;
                                    this.container.classList.add("fileAttachmentAnnotation");
                                    var c = this.container, d = this.data;
                                    if (d.hasAppearance || 0 === d.fillAlpha) var e = document.createElement("div");
                                    else e = document.createElement("img"), e.src = this.imageResourcesPath + "annotation-" + (/paperclip/i.test(d.name) ? "paperclip" : "pushpin") + ".svg", d.fillAlpha && 1 > d.fillAlpha && (e.style = "filter: opacity(" + Math.round(100 * d.fillAlpha) + "%);");
                                    e.addEventListener("dblclick", this.__download.bind(this));
                                    this.__trigger = e;
                                    var h = Ka.platform.isMac;
                                    c.addEventListener("keydown", function(k) {
                                        "Enter" === k.key && (h ? k.metaKey : k.ctrlKey) && b.__download();
                                    });
                                    !d.popupRef && this.hasPopupData ? this._createPopup() : e.classList.add("popupTriggerArea");
                                    c.append(e);
                                    return c;
                                };
                                a.getElementsToTriggerPopup = function() {
                                    return this.__trigger;
                                };
                                a.addHighlightArea = function() {
                                    this.container.classList.add("highlightArea");
                                };
                                a.__download = function() {
                                    var b;
                                    null == (b = this.downloadManager) || b.openOrDownloadData(this.content, this.filename);
                                };
                                return f;
                            }(Ea), jg = function() {
                                function g(a) {
                                    var b = a.div, c = a.accessibilityManager, d = a.annotationCanvasMap, e = a.annotationEditorUIManager, h = a.page, k = a.viewport;
                                    a = a.structTreeLayer;
                                    this.__annotationCanvasMap = this.__accessibilityManager = null;
                                    this.__editableAnnotations = new Map;
                                    this.__structTreeLayer = null;
                                    this.div = b;
                                    this.__accessibilityManager = c;
                                    this.__annotationCanvasMap = d;
                                    this.__structTreeLayer = a || null;
                                    this.page = h;
                                    this.viewport = k;
                                    this.zIndex = 0;
                                    this._annotationEditorUIManager = e;
                                }
                                var f = g.prototype;
                                f.hasEditableAnnotations = function() {
                                    return 0 < this.__editableAnnotations.size;
                                };
                                f.__appendElement = function() {
                                    var a = fe(function e(c, d) {
                                        var h, k, l, m, n = this, q, r, t, u, v, w, x;
                                        return p.generator.createGenerator(e, function(B) {
                                            if (1 == B.nextAddress) return l = c.firstChild || c, m = l.id = "pdfjs_internal_id_" + d, B.yield(null == (h = n.__structTreeLayer) ? void 0 : h.getAriaAttributes(m), 2);
                                            if (q = B.yieldResult) for(r = p.makeIterator(q), t = r.next(); !t.done; t = r.next())u = t.value, v = p.makeIterator(u), w = v.next().value, x = v.next().value, l.setAttribute(w, x);
                                            n.div.append(c);
                                            null == (k = n.__accessibilityManager) || k.moveElementInDOM(n.div, c, l, !1);
                                            B.jumpToEnd();
                                        });
                                    });
                                    return function(c, d) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.render = function() {
                                    var a = fe(function d(c) {
                                        var e, h, k = this, l, m, n, q, r, t, u, v, w, x, B, z, C, D, H;
                                        return p.generator.createGenerator(d, function(J) {
                                            switch(J.nextAddress){
                                                case 1:
                                                    e = c, h = e.annotations, l = k.div, ab(l, k.viewport), m = new Map, n = {
                                                        data: null,
                                                        layer: l,
                                                        linkService: c.linkService,
                                                        downloadManager: c.downloadManager,
                                                        imageResourcesPath: c.imageResourcesPath || "",
                                                        renderForms: !1 !== c.renderForms,
                                                        svgFactory: new Kc,
                                                        annotationStorage: c.annotationStorage || new Rc,
                                                        enableScripting: !0 === c.enableScripting,
                                                        hasJSActions: c.hasJSActions,
                                                        fieldObjects: c.fieldObjects,
                                                        parent: k,
                                                        elements: null
                                                    }, q = p.makeIterator(h), r = q.next();
                                                case 2:
                                                    if (r.done) {
                                                        J.jumpTo(4);
                                                        break;
                                                    }
                                                    t = r.value;
                                                    if (t.noHTML) {
                                                        J.jumpTo(3);
                                                        break;
                                                    }
                                                    if (u = 16 === t.annotationType) {
                                                        B = m.get(t.id);
                                                        if (!B) {
                                                            J.jumpTo(3);
                                                            break;
                                                        }
                                                        n.elements = B;
                                                    } else if (v = Ua(t.rect), w = v.width, x = v.height, 0 >= w || 0 >= x) {
                                                        J.jumpTo(3);
                                                        break;
                                                    }
                                                    n.data = t;
                                                    z = lh.create(n);
                                                    if (!z.isRenderable) {
                                                        J.jumpTo(3);
                                                        break;
                                                    }
                                                    !u && t.popupRef && ((C = m.get(t.popupRef)) ? C.push(z) : m.set(t.popupRef, [
                                                        z
                                                    ]));
                                                    D = z.render();
                                                    t.hidden && (D.style.visibility = "hidden");
                                                    return J.yield(k.__appendElement(D, t.id), 5);
                                                case 5:
                                                    z._isEditable && (k.__editableAnnotations.set(z.data.id, z), null == (H = k._annotationEditorUIManager) || H.renderAnnotationElement(z));
                                                case 3:
                                                    r = q.next();
                                                    J.jumpTo(2);
                                                    break;
                                                case 4:
                                                    k.__setAnnotationCanvasMap(), J.jumpToEnd();
                                            }
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.update = function(a) {
                                    a = a.viewport;
                                    var b = this.div;
                                    this.viewport = a;
                                    ab(b, {
                                        rotation: a.rotation
                                    });
                                    this.__setAnnotationCanvasMap();
                                    b.hidden = !1;
                                };
                                f.__setAnnotationCanvasMap = function() {
                                    if (this.__annotationCanvasMap) {
                                        for(var a = this.div, b = p.makeIterator(this.__annotationCanvasMap), c = b.next(); !c.done; c = b.next()){
                                            c = p.makeIterator(c.value);
                                            var d = c.next().value;
                                            c = c.next().value;
                                            if (d = a.querySelector('[data-annotation-id="' + d + '"]')) {
                                                c.className = "annotationContent";
                                                var e = d.firstChild;
                                                e ? "CANVAS" === e.nodeName ? e.replaceWith(c) : e.classList.contains("annotationContent") ? e.after(c) : e.before(c) : d.append(c);
                                            }
                                        }
                                        this.__annotationCanvasMap.clear();
                                    }
                                };
                                f.getEditableAnnotations = function() {
                                    return Array.from(this.__editableAnnotations.values());
                                };
                                f.getEditableAnnotation = function(a) {
                                    return this.__editableAnnotations.get(a);
                                };
                                return g;
                            }(), Qb = /\r\n?|\n/g, jb = function(g) {
                                function f(b) {
                                    var c = g.call(this, Object.assign({}, b, {
                                        name: "freeTextEditor"
                                    })) || this;
                                    c.__color = void 0;
                                    c.__content = "";
                                    c.__editorDivId = c.id + "-editor";
                                    c.__editModeAC = null;
                                    c.__fontSize = void 0;
                                    c.__color = b.color || f._defaultColor || wa._defaultLineColor;
                                    c.__fontSize = b.fontSize || f._defaultFontSize;
                                    return c;
                                }
                                Uf(f, g);
                                f.initialize = function(b, c) {
                                    wa.initialize(b, c);
                                    b = getComputedStyle(document.documentElement);
                                    this._internalPadding = parseFloat(b.getPropertyValue("--freetext-padding"));
                                };
                                f.updateDefaultParams = function(b, c) {
                                    switch(b){
                                        case pa.FREETEXT_SIZE:
                                            f._defaultFontSize = c;
                                            break;
                                        case pa.FREETEXT_COLOR:
                                            f._defaultColor = c;
                                    }
                                };
                                var a = f.prototype;
                                a.updateParams = function(b, c) {
                                    switch(b){
                                        case pa.FREETEXT_SIZE:
                                            this.__updateFontSize(c);
                                            break;
                                        case pa.FREETEXT_COLOR:
                                            this.__updateColor(c);
                                    }
                                };
                                a.__updateFontSize = function(b) {
                                    function c(h) {
                                        d.editorDiv.style.fontSize = "calc(" + h + "px * var(--scale-factor))";
                                        d.translate(0, -(h - d.__fontSize) * d.parentScale);
                                        d.__fontSize = h;
                                        d.__setEditorDimensions();
                                    }
                                    var d = this, e = this.__fontSize;
                                    this.addCommands({
                                        cmd: c.bind(this, b),
                                        undo: c.bind(this, e),
                                        post: this._uiManager.updateUI.bind(this._uiManager, this),
                                        mustExec: !0,
                                        type: pa.FREETEXT_SIZE,
                                        overwriteIfSameType: !0,
                                        keepUndo: !0
                                    });
                                };
                                a.__updateColor = function(b) {
                                    function c(h) {
                                        d.__color = d.editorDiv.style.color = h;
                                    }
                                    var d = this, e = this.__color;
                                    this.addCommands({
                                        cmd: c.bind(this, b),
                                        undo: c.bind(this, e),
                                        post: this._uiManager.updateUI.bind(this._uiManager, this),
                                        mustExec: !0,
                                        type: pa.FREETEXT_COLOR,
                                        overwriteIfSameType: !0,
                                        keepUndo: !0
                                    });
                                };
                                a._translateEmpty = function(b, c) {
                                    this._uiManager.translateSelectedEditors(b, c, !0);
                                };
                                a.getInitialTranslation = function() {
                                    var b = this.parentScale;
                                    return [
                                        -f._internalPadding * b,
                                        -(f._internalPadding + this.__fontSize) * b
                                    ];
                                };
                                a.rebuild = function() {
                                    this.parent && (g.prototype.rebuild.call(this), null !== this.div && (this.isAttachedToDOM || this.parent.add(this)));
                                };
                                a.enableEditMode = function() {
                                    if (!this.isInEditMode()) {
                                        this.parent.setEditingState(!1);
                                        this.parent.updateToolbar(sa.FREETEXT);
                                        g.prototype.enableEditMode.call(this);
                                        this.overlayDiv.classList.remove("enabled");
                                        this.editorDiv.contentEditable = !0;
                                        this._isDraggable = !1;
                                        this.div.removeAttribute("aria-activedescendant");
                                        this.__editModeAC = new AbortController;
                                        var b = this._uiManager.combinedSignal(this.__editModeAC);
                                        this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
                                            signal: b
                                        });
                                        this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
                                            signal: b
                                        });
                                        this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
                                            signal: b
                                        });
                                        this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
                                            signal: b
                                        });
                                        this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
                                            signal: b
                                        });
                                    }
                                };
                                a.disableEditMode = function() {
                                    var b;
                                    this.isInEditMode() && (this.parent.setEditingState(!0), g.prototype.disableEditMode.call(this), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", this.__editorDivId), this._isDraggable = !0, null == (b = this.__editModeAC) || b.abort(), this.__editModeAC = null, this.div.focus({
                                        preventScroll: !0
                                    }), this.isEditing = !1, this.parent.div.classList.add("freetextEditing"));
                                };
                                a.focusin = function(b) {
                                    this._focusEventsAllowed && (g.prototype.focusin.call(this, b), b.target !== this.editorDiv && this.editorDiv.focus());
                                };
                                a.onceAdded = function() {
                                    var b;
                                    this.width || (this.enableEditMode(), this.editorDiv.focus(), null != (b = this._initialOptions) && b.isCentered && this.center(), this._initialOptions = null);
                                };
                                a.isEmpty = function() {
                                    return !this.editorDiv || "" === this.editorDiv.innerText.trim();
                                };
                                a.remove = function() {
                                    this.isEditing = !1;
                                    this.parent && (this.parent.setEditingState(!0), this.parent.div.classList.add("freetextEditing"));
                                    g.prototype.remove.call(this);
                                };
                                a.__extractText = function() {
                                    var b = [];
                                    this.editorDiv.normalize();
                                    for(var c = null, d = p.makeIterator(this.editorDiv.childNodes), e = d.next(); !e.done; e = d.next()){
                                        e = e.value;
                                        var h;
                                        if ((null == (h = c) ? void 0 : h.nodeType) !== Node.TEXT_NODE || "BR" !== e.nodeName) b.push(f.__getNodeContent(e)), c = e;
                                    }
                                    return b.join("\n");
                                };
                                a.__setEditorDimensions = function() {
                                    var b = p.makeIterator(this.parentDimensions), c = b.next().value;
                                    b = b.next().value;
                                    if (this.isAttachedToDOM) var d = this.div.getBoundingClientRect();
                                    else {
                                        d = this.currentLayer;
                                        var e = this.div, h = e.style.display, k = e.classList.contains("hidden");
                                        e.classList.remove("hidden");
                                        e.style.display = "hidden";
                                        d.div.append(this.div);
                                        d = e.getBoundingClientRect();
                                        e.remove();
                                        e.style.display = h;
                                        e.classList.toggle("hidden", k);
                                    }
                                    this.rotation % 180 === this.parentRotation % 180 ? (this.width = d.width / c, this.height = d.height / b) : (this.width = d.height / c, this.height = d.width / b);
                                    this.fixAndSetPosition();
                                };
                                a.commit = function() {
                                    var b = this;
                                    if (this.isInEditMode()) {
                                        g.prototype.commit.call(this);
                                        this.disableEditMode();
                                        var c = this.__content, d = this.__content = this.__extractText().trimEnd();
                                        if (c !== d) {
                                            var e = function(h) {
                                                (b.__content = h) ? (b.__setContent(), b._uiManager.rebuild(b), b.__setEditorDimensions()) : b.remove();
                                            };
                                            this.addCommands({
                                                cmd: function() {
                                                    e(d);
                                                },
                                                undo: function() {
                                                    e(c);
                                                },
                                                mustExec: !1
                                            });
                                            this.__setEditorDimensions();
                                        }
                                    }
                                };
                                a.shouldGetKeyboardEvents = function() {
                                    return this.isInEditMode();
                                };
                                a.enterInEditMode = function() {
                                    this.enableEditMode();
                                    this.editorDiv.focus();
                                };
                                a.dblclick = function() {
                                    this.enterInEditMode();
                                };
                                a.keydown = function(b) {
                                    b.target === this.div && "Enter" === b.key && (this.enterInEditMode(), b.preventDefault());
                                };
                                a.editorDivKeydown = function(b) {
                                    f._keyboardManager.exec(this, b);
                                };
                                a.editorDivFocus = function() {
                                    this.isEditing = !0;
                                };
                                a.editorDivBlur = function() {
                                    this.isEditing = !1;
                                };
                                a.editorDivInput = function() {
                                    this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
                                };
                                a.disableEditing = function() {
                                    this.editorDiv.setAttribute("role", "comment");
                                    this.editorDiv.removeAttribute("aria-multiline");
                                };
                                a.enableEditing = function() {
                                    this.editorDiv.setAttribute("role", "textbox");
                                    this.editorDiv.setAttribute("aria-multiline", !0);
                                };
                                a.render = function() {
                                    if (this.div) return this.div;
                                    if (this.width) {
                                        var b = this.x;
                                        var c = this.y;
                                    }
                                    g.prototype.render.call(this);
                                    this.editorDiv = document.createElement("div");
                                    this.editorDiv.className = "internal";
                                    this.editorDiv.setAttribute("id", this.__editorDivId);
                                    this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2");
                                    this.editorDiv.setAttribute("data-l10n-attrs", "default-content");
                                    this.enableEditing();
                                    this.editorDiv.contentEditable = !0;
                                    var d = this.editorDiv.style;
                                    d.fontSize = "calc(" + this.__fontSize + "px * var(--scale-factor))";
                                    d.color = this.__color;
                                    this.div.append(this.editorDiv);
                                    this.overlayDiv = document.createElement("div");
                                    this.overlayDiv.classList.add("overlay", "enabled");
                                    this.div.append(this.overlayDiv);
                                    Bb(this, this.div, [
                                        "dblclick",
                                        "keydown"
                                    ]);
                                    if (this.width) {
                                        var e = p.makeIterator(this.parentDimensions);
                                        d = e.next().value;
                                        e = e.next().value;
                                        if (this.annotationElementId) {
                                            var h = this._initialData.position, k = p.makeIterator(this.getInitialTranslation()), l = k.next().value;
                                            k = k.next().value;
                                            k = p.makeIterator(this.pageTranslationToScreen(l, k));
                                            l = k.next().value;
                                            k = k.next().value;
                                            var m = p.makeIterator(this.pageDimensions), n = m.next().value;
                                            m = m.next().value;
                                            var q = p.makeIterator(this.pageTranslation), r = q.next().value;
                                            q = q.next().value;
                                            switch(this.rotation){
                                                case 0:
                                                    var t = b + (h[0] - r) / n;
                                                    var u = c + this.height - (h[1] - q) / m;
                                                    break;
                                                case 90:
                                                    t = b + (h[0] - r) / n;
                                                    u = c - (h[1] - q) / m;
                                                    b = p.makeIterator([
                                                        k,
                                                        -l
                                                    ]);
                                                    l = b.next().value;
                                                    k = b.next().value;
                                                    break;
                                                case 180:
                                                    t = b - this.width + (h[0] - r) / n;
                                                    u = c - (h[1] - q) / m;
                                                    b = p.makeIterator([
                                                        -l,
                                                        -k
                                                    ]);
                                                    l = b.next().value;
                                                    k = b.next().value;
                                                    break;
                                                case 270:
                                                    t = b + (h[0] - r - this.height * m) / n, u = c + (h[1] - q - this.width * n) / m, b = p.makeIterator([
                                                        -k,
                                                        l
                                                    ]), l = b.next().value, k = b.next().value;
                                            }
                                            this.setAt(t * d, u * e, l, k);
                                        } else this.setAt(b * d, c * e, this.width * d, this.height * e);
                                        this.__setContent();
                                        this._isDraggable = !0;
                                        this.editorDiv.contentEditable = !1;
                                    } else this._isDraggable = !1, this.editorDiv.contentEditable = !0;
                                    return this.div;
                                };
                                f.__getNodeContent = function(b) {
                                    return (b.nodeType === Node.TEXT_NODE ? b.nodeValue : b.innerText).replaceAll(Qb, "");
                                };
                                a.editorDivPaste = function(b) {
                                    var c = b.clipboardData || window.clipboardData, d = c.types;
                                    if (1 !== d.length || "text/plain" !== d[0]) {
                                        if (b.preventDefault(), c = f.__deserializeContent(c.getData("text") || "").replaceAll(Qb, "\n")) {
                                            if (b = window.getSelection(), b.rangeCount) {
                                                if (this.editorDiv.normalize(), b.deleteFromDocument(), d = b.getRangeAt(0), c.includes("\n")) {
                                                    var e = d.startContainer, h = d.startOffset;
                                                    d = [];
                                                    var k = [];
                                                    if (e.nodeType === Node.TEXT_NODE) {
                                                        var l = e.parentElement;
                                                        k.push(e.nodeValue.slice(h).replaceAll(Qb, ""));
                                                        if (l !== this.editorDiv) for(var m = d, n = p.makeIterator(this.editorDiv.childNodes), q = n.next(); !q.done; q = n.next())q = q.value, q === l ? m = k : m.push(f.__getNodeContent(q));
                                                        d.push(e.nodeValue.slice(0, h).replaceAll(Qb, ""));
                                                    } else if (e === this.editorDiv) for(e = d, l = 0, m = p.makeIterator(this.editorDiv.childNodes), n = m.next(); !n.done; n = m.next())n = n.value, l++ === h && (e = k), e.push(f.__getNodeContent(n));
                                                    this.__content = "" + d.join("\n") + c + k.join("\n");
                                                    this.__setContent();
                                                    c = new Range;
                                                    d = d.reduce(function(r, t) {
                                                        return r + t.length;
                                                    }, 0);
                                                    h = p.makeIterator(this.editorDiv.childNodes);
                                                    for(k = h.next(); !k.done; k = h.next())if (k = k.value.firstChild, k.nodeType === Node.TEXT_NODE) {
                                                        e = k.nodeValue.length;
                                                        if (d <= e) {
                                                            c.setStart(k, d);
                                                            c.setEnd(k, d);
                                                            break;
                                                        }
                                                        d -= e;
                                                    }
                                                    b.removeAllRanges();
                                                    b.addRange(c);
                                                } else d.insertNode(document.createTextNode(c)), this.editorDiv.normalize(), b.collapseToStart();
                                            }
                                        }
                                    }
                                };
                                a.__setContent = function() {
                                    this.editorDiv.replaceChildren();
                                    if (this.__content) for(var b = p.makeIterator(this.__content.split("\n")), c = b.next(); !c.done; c = b.next()){
                                        c = c.value;
                                        var d = document.createElement("div");
                                        d.append(c ? document.createTextNode(c) : document.createElement("br"));
                                        this.editorDiv.append(d);
                                    }
                                };
                                a.__serializeContent = function() {
                                    return this.__content.replaceAll("\xa0", " ");
                                };
                                f.__deserializeContent = function(b) {
                                    return b.replaceAll(" ", "\xa0");
                                };
                                f.deserialize = function() {
                                    var b = Sf(function k(d, e, h) {
                                        var l, m, n, q, r, t, u, v, w, x, B, z, C, D, H, J = this, M;
                                        return p.generator.createGenerator(k, function(I) {
                                            if (1 == I.nextAddress) {
                                                l = null;
                                                if (d instanceof Ye) {
                                                    m = d;
                                                    n = m.data;
                                                    q = n.defaultAppearanceData;
                                                    r = q.fontSize;
                                                    t = q.fontColor;
                                                    u = n.rect;
                                                    v = n.rotation;
                                                    w = n.id;
                                                    x = n.popupRef;
                                                    B = m.textContent;
                                                    z = m.textPosition;
                                                    C = m.parent;
                                                    D = C.page;
                                                    H = D.pageNumber;
                                                    if (!B || 0 === B.length) return I.return(null);
                                                    l = d = {
                                                        annotationType: sa.FREETEXT,
                                                        color: Array.from(t),
                                                        fontSize: r,
                                                        value: B.join("\n"),
                                                        position: z,
                                                        pageIndex: H - 1,
                                                        rect: u.slice(0),
                                                        rotation: v,
                                                        id: w,
                                                        deleted: !1,
                                                        popupRef: x
                                                    };
                                                }
                                                return I.yield(g.deserialize.call(J, d, e, h), 2);
                                            }
                                            M = I.yieldResult;
                                            M.__fontSize = d.fontSize;
                                            M.__color = fa.makeHexColor.apply(fa, p.arrayFromIterable(d.color));
                                            M.__content = f.__deserializeContent(d.value);
                                            M.annotationElementId = d.id || null;
                                            M._initialData = l;
                                            return I.return(M);
                                        });
                                    });
                                    return function(d, e, h) {
                                        return b.apply(this, arguments);
                                    };
                                }();
                                a.serialize = function(b) {
                                    void 0 === b && (b = !1);
                                    if (this.isEmpty()) return null;
                                    if (this.deleted) return this.serializeDeleted();
                                    var c = f._internalPadding * this.parentScale;
                                    c = this.getRect(c, c);
                                    var d = wa._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.__color);
                                    c = {
                                        annotationType: sa.FREETEXT,
                                        color: d,
                                        fontSize: this.__fontSize,
                                        value: this.__serializeContent(),
                                        pageIndex: this.pageIndex,
                                        rect: c,
                                        rotation: this.rotation,
                                        structTreeParentId: this._structTreeParentId
                                    };
                                    if (b) return c;
                                    if (this.annotationElementId && !this.__hasElementChanged(c)) return null;
                                    c.id = this.annotationElementId;
                                    return c;
                                };
                                a.__hasElementChanged = function(b) {
                                    var c = this._initialData, d = c.value, e = c.fontSize, h = c.color;
                                    c = c.pageIndex;
                                    return this._hasBeenMoved || b.value !== d || b.fontSize !== e || b.color.some(function(k, l) {
                                        return k !== h[l];
                                    }) || b.pageIndex !== c;
                                };
                                a.renderAnnotationElement = function(b) {
                                    var c = g.prototype.renderAnnotationElement.call(this, b);
                                    if (this.deleted) return c;
                                    var d = c.style;
                                    d.fontSize = "calc(" + this.__fontSize + "px * var(--scale-factor))";
                                    d.color = this.__color;
                                    c.replaceChildren();
                                    d = p.makeIterator(this.__content.split("\n"));
                                    for(var e = d.next(); !e.done; e = d.next()){
                                        e = e.value;
                                        var h = document.createElement("div");
                                        h.append(e ? document.createTextNode(e) : document.createElement("br"));
                                        c.append(h);
                                    }
                                    d = f._internalPadding * this.parentScale;
                                    b.updateEdited({
                                        rect: this.getRect(d, d),
                                        popupContent: this.__content
                                    });
                                    return c;
                                };
                                a.resetAnnotationElement = function(b) {
                                    g.prototype.resetAnnotationElement.call(this, b);
                                    b.resetEdited();
                                };
                                return Tf(f, [
                                    {
                                        key: "propertiesToUpdate",
                                        get: function() {
                                            return [
                                                [
                                                    pa.FREETEXT_SIZE,
                                                    this.__fontSize
                                                ],
                                                [
                                                    pa.FREETEXT_COLOR,
                                                    this.__color
                                                ]
                                            ];
                                        }
                                    },
                                    {
                                        key: "contentDiv",
                                        get: function() {
                                            return this.editorDiv;
                                        }
                                    }
                                ], [
                                    {
                                        key: "_keyboardManager",
                                        get: function() {
                                            function b(h) {
                                                return h.isEmpty();
                                            }
                                            var c = f.prototype, d = gb.TRANSLATE_SMALL, e = gb.TRANSLATE_BIG;
                                            return qa(this, "_keyboardManager", new ub([
                                                [
                                                    [
                                                        "ctrl+s",
                                                        "mac+meta+s",
                                                        "ctrl+p",
                                                        "mac+meta+p"
                                                    ],
                                                    c.commitOrRemove,
                                                    {
                                                        bubbles: !0
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+Enter",
                                                        "mac+meta+Enter",
                                                        "Escape",
                                                        "mac+Escape"
                                                    ],
                                                    c.commitOrRemove
                                                ],
                                                [
                                                    [
                                                        "ArrowLeft",
                                                        "mac+ArrowLeft"
                                                    ],
                                                    c._translateEmpty,
                                                    {
                                                        args: [
                                                            -d,
                                                            0
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowLeft",
                                                        "mac+shift+ArrowLeft"
                                                    ],
                                                    c._translateEmpty,
                                                    {
                                                        args: [
                                                            -e,
                                                            0
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowRight",
                                                        "mac+ArrowRight"
                                                    ],
                                                    c._translateEmpty,
                                                    {
                                                        args: [
                                                            d,
                                                            0
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowRight",
                                                        "mac+shift+ArrowRight"
                                                    ],
                                                    c._translateEmpty,
                                                    {
                                                        args: [
                                                            e,
                                                            0
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowUp",
                                                        "mac+ArrowUp"
                                                    ],
                                                    c._translateEmpty,
                                                    {
                                                        args: [
                                                            0,
                                                            -d
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowUp",
                                                        "mac+shift+ArrowUp"
                                                    ],
                                                    c._translateEmpty,
                                                    {
                                                        args: [
                                                            0,
                                                            -e
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowDown",
                                                        "mac+ArrowDown"
                                                    ],
                                                    c._translateEmpty,
                                                    {
                                                        args: [
                                                            0,
                                                            d
                                                        ],
                                                        checker: b
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ctrl+ArrowDown",
                                                        "mac+shift+ArrowDown"
                                                    ],
                                                    c._translateEmpty,
                                                    {
                                                        args: [
                                                            0,
                                                            e
                                                        ],
                                                        checker: b
                                                    }
                                                ]
                                            ]));
                                        }
                                    },
                                    {
                                        key: "defaultPropertiesToUpdate",
                                        get: function() {
                                            return [
                                                [
                                                    pa.FREETEXT_SIZE,
                                                    f._defaultFontSize
                                                ],
                                                [
                                                    pa.FREETEXT_COLOR,
                                                    f._defaultColor || wa._defaultLineColor
                                                ]
                                            ];
                                        }
                                    }
                                ]);
                            }(wa);
                            jb._freeTextDefaultContent = "";
                            jb._internalPadding = 0;
                            jb._defaultColor = null;
                            jb._defaultFontSize = 10;
                            jb._type = "freetext";
                            jb._editorType = sa.FREETEXT;
                            F(4594);
                            F(6910);
                            F(9833);
                            var bf = function() {
                                function g() {}
                                var f = g.prototype;
                                f.toSVGPath = function() {
                                    da("Abstract method `toSVGPath` must be implemented.");
                                };
                                f.serialize = function() {
                                    da("Abstract method `serialize` must be implemented.");
                                };
                                return Vf(g, [
                                    {
                                        key: "box",
                                        get: function() {
                                            da("Abstract getter `box` must be implemented.");
                                        }
                                    },
                                    {
                                        key: "classNamesForDrawing",
                                        get: function() {
                                            da("Abstract getter `classNamesForDrawing` must be implemented.");
                                        }
                                    },
                                    {
                                        key: "classNamesForOutlining",
                                        get: function() {
                                            da("Abstract getter `classNamesForOutlining` must be implemented.");
                                        }
                                    },
                                    {
                                        key: "mustRemoveSelfIntersections",
                                        get: function() {
                                            return !1;
                                        }
                                    }
                                ]);
                            }(), kb = function() {
                                function g(a, b, c, d, e, h) {
                                    var k = a.x;
                                    a = a.y;
                                    void 0 === h && (h = 0);
                                    this.__box = void 0;
                                    this.__bottom = [];
                                    this.__isLTR = this.__innerMargin = void 0;
                                    this.__top = [];
                                    this.__last = new Float64Array(18);
                                    this.__scaleFactor = this.__min_dist = this.__min = this.__lastY = this.__lastX = void 0;
                                    this.__points = [];
                                    this.__box = b;
                                    this.__thickness = d * c;
                                    this.__isLTR = e;
                                    this.__last.set([
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        k,
                                        a
                                    ], 6);
                                    this.__innerMargin = h;
                                    this.__min_dist = g.__MIN_DIST * c;
                                    this.__min = g.__MIN * c;
                                    this.__scaleFactor = c;
                                    this.__points.push(k, a);
                                }
                                var f = g.prototype;
                                f.isEmpty = function() {
                                    return isNaN(this.__last[8]);
                                };
                                f.__getLastCoords = function() {
                                    var a = this.__last.subarray(4, 6), b = this.__last.subarray(16, 18), c = p.makeIterator(this.__box), d = c.next().value, e = c.next().value, h = c.next().value;
                                    c = c.next().value;
                                    return [
                                        (this.__lastX + (a[0] - b[0]) / 2 - d) / h,
                                        (this.__lastY + (a[1] - b[1]) / 2 - e) / c,
                                        (this.__lastX + (b[0] - a[0]) / 2 - d) / h,
                                        (this.__lastY + (b[1] - a[1]) / 2 - e) / c
                                    ];
                                };
                                f.add = function(a) {
                                    var b, c = a.x, d = a.y;
                                    this.__lastX = c;
                                    this.__lastY = d;
                                    var e = p.makeIterator(this.__box);
                                    a = e.next().value;
                                    var h = e.next().value, k = e.next().value;
                                    e = e.next().value;
                                    var l = p.makeIterator(this.__last.subarray(8, 12)), m = l.next().value, n = l.next().value, q = l.next().value;
                                    l = l.next().value;
                                    var r = c - q, t = d - l, u = Math.hypot(r, t);
                                    if (u < this.__min) return !1;
                                    var v = u - this.__min_dist;
                                    u = v / u;
                                    r *= u;
                                    var w = u * t;
                                    t = m;
                                    u = n;
                                    m = q;
                                    n = l;
                                    q += r;
                                    l += w;
                                    null == (b = this.__points) || b.push(c, d);
                                    b = -w / v * this.__thickness;
                                    c = r / v * this.__thickness;
                                    this.__last.set(this.__last.subarray(2, 8), 0);
                                    this.__last.set([
                                        q + b,
                                        l + c
                                    ], 4);
                                    this.__last.set(this.__last.subarray(14, 18), 12);
                                    this.__last.set([
                                        q - b,
                                        l - c
                                    ], 16);
                                    if (isNaN(this.__last[6])) return 0 === this.__top.length && (this.__last.set([
                                        m + b,
                                        n + c
                                    ], 2), this.__top.push(NaN, NaN, NaN, NaN, (m + b - a) / k, (n + c - h) / e), this.__last.set([
                                        m - b,
                                        n - c
                                    ], 14), this.__bottom.push(NaN, NaN, NaN, NaN, (m - b - a) / k, (n - c - h) / e)), this.__last.set([
                                        t,
                                        u,
                                        m,
                                        n,
                                        q,
                                        l
                                    ], 6), !this.isEmpty();
                                    this.__last.set([
                                        t,
                                        u,
                                        m,
                                        n,
                                        q,
                                        l
                                    ], 6);
                                    if (Math.abs(Math.atan2(u - n, t - m) - Math.atan2(w, r)) < Math.PI / 2) return b = p.makeIterator(this.__last.subarray(2, 6)), m = b.next().value, n = b.next().value, q = b.next().value, l = b.next().value, this.__top.push(NaN, NaN, NaN, NaN, ((m + q) / 2 - a) / k, ((n + l) / 2 - h) / e), q = p.makeIterator(this.__last.subarray(14, 18)), m = q.next().value, n = q.next().value, t = q.next().value, u = q.next().value, this.__bottom.push(NaN, NaN, NaN, NaN, ((t + m) / 2 - a) / k, ((u + n) / 2 - h) / e), !0;
                                    b = p.makeIterator(this.__last.subarray(0, 6));
                                    t = b.next().value;
                                    u = b.next().value;
                                    m = b.next().value;
                                    n = b.next().value;
                                    q = b.next().value;
                                    l = b.next().value;
                                    this.__top.push(((t + 5 * m) / 6 - a) / k, ((u + 5 * n) / 6 - h) / e, ((5 * m + q) / 6 - a) / k, ((5 * n + l) / 6 - h) / e, ((m + q) / 2 - a) / k, ((n + l) / 2 - h) / e);
                                    b = p.makeIterator(this.__last.subarray(12, 18));
                                    q = b.next().value;
                                    l = b.next().value;
                                    m = b.next().value;
                                    n = b.next().value;
                                    t = b.next().value;
                                    u = b.next().value;
                                    this.__bottom.push(((t + 5 * m) / 6 - a) / k, ((u + 5 * n) / 6 - h) / e, ((5 * m + q) / 6 - a) / k, ((5 * n + l) / 6 - h) / e, ((m + q) / 2 - a) / k, ((n + l) / 2 - h) / e);
                                    return !0;
                                };
                                f.toSVGPath = function() {
                                    if (this.isEmpty()) return "";
                                    var a = this.__top, b = this.__bottom;
                                    if (isNaN(this.__last[6]) && !this.isEmpty()) return this.__toSVGPathTwoPoints();
                                    var c = [];
                                    c.push("M" + a[4] + " " + a[5]);
                                    for(var d = 6; d < a.length; d += 6)isNaN(a[d]) ? c.push("L" + a[d + 4] + " " + a[d + 5]) : c.push("C" + a[d] + " " + a[d + 1] + " " + a[d + 2] + " " + a[d + 3] + " " + a[d + 4] + " " + a[d + 5]);
                                    this.__toSVGPathEnd(c);
                                    for(a = b.length - 6; 6 <= a; a -= 6)isNaN(b[a]) ? c.push("L" + b[a + 4] + " " + b[a + 5]) : c.push("C" + b[a] + " " + b[a + 1] + " " + b[a + 2] + " " + b[a + 3] + " " + b[a + 4] + " " + b[a + 5]);
                                    this.__toSVGPathStart(c);
                                    return c.join(" ");
                                };
                                f.__toSVGPathTwoPoints = function() {
                                    var a = p.makeIterator(this.__box), b = a.next().value, c = a.next().value, d = a.next().value;
                                    a = a.next().value;
                                    var e = p.makeIterator(this.__getLastCoords()), h = e.next().value, k = e.next().value, l = e.next().value;
                                    e = e.next().value;
                                    return "M" + (this.__last[2] - b) / d + " " + (this.__last[3] - c) / a + " L" + (this.__last[4] - b) / d + " " + (this.__last[5] - c) / a + " L" + h + " " + k + " L" + l + " " + e + " L" + (this.__last[16] - b) / d + " " + (this.__last[17] - c) / a + " L" + (this.__last[14] - b) / d + " " + (this.__last[15] - c) / a + " Z";
                                };
                                f.__toSVGPathStart = function(a) {
                                    var b = this.__bottom;
                                    a.push("L" + b[4] + " " + b[5] + " Z");
                                };
                                f.__toSVGPathEnd = function(a) {
                                    var b = p.makeIterator(this.__box), c = b.next().value, d = b.next().value, e = b.next().value;
                                    b = b.next().value;
                                    var h = this.__last.subarray(4, 6), k = this.__last.subarray(16, 18), l = p.makeIterator(this.__getLastCoords()), m = l.next().value, n = l.next().value, q = l.next().value;
                                    l = l.next().value;
                                    a.push("L" + (h[0] - c) / e + " " + (h[1] - d) / b + " L" + m + " " + n + " L" + q + " " + l + " L" + (k[0] - c) / e + " " + (k[1] - d) / b);
                                };
                                f.newFreeDrawOutline = function(a, b, c, d, e, h) {
                                    return new cf(a, b, c, d, e, h);
                                };
                                f.getOutlines = function() {
                                    var a, b, c = this.__top, d = this.__bottom, e = this.__last, h = p.makeIterator(this.__box), k = h.next().value, l = h.next().value, m = h.next().value, n = h.next().value;
                                    h = new Float64Array((null != (a = null == (b = this.__points) ? void 0 : b.length) ? a : 0) + 2);
                                    a = 0;
                                    for(b = h.length - 2; a < b; a += 2)h[a] = (this.__points[a] - k) / m, h[a + 1] = (this.__points[a + 1] - l) / n;
                                    h[h.length - 2] = (this.__lastX - k) / m;
                                    h[h.length - 1] = (this.__lastY - l) / n;
                                    if (isNaN(e[6]) && !this.isEmpty()) return this.__getOutlineTwoPoints(h);
                                    e = new Float64Array(this.__top.length + 24 + this.__bottom.length);
                                    k = c.length;
                                    for(l = 0; l < k; l += 2)isNaN(c[l]) ? e[l] = e[l + 1] = NaN : (e[l] = c[l], e[l + 1] = c[l + 1]);
                                    k = this.__getOutlineEnd(e, k);
                                    for(c = d.length - 6; 6 <= c; c -= 6)for(l = 0; 6 > l; l += 2)isNaN(d[c + l]) ? e[k] = e[k + 1] = NaN : (e[k] = d[c + l], e[k + 1] = d[c + l + 1]), k += 2;
                                    this.__getOutlineStart(e, k);
                                    return this.newFreeDrawOutline(e, h, this.__box, this.__scaleFactor, this.__innerMargin, this.__isLTR);
                                };
                                f.__getOutlineTwoPoints = function(a) {
                                    var b = this.__last, c = p.makeIterator(this.__box), d = c.next().value, e = c.next().value, h = c.next().value;
                                    c = c.next().value;
                                    var k = p.makeIterator(this.__getLastCoords()), l = k.next().value, m = k.next().value, n = k.next().value;
                                    k = k.next().value;
                                    var q = new Float64Array(36);
                                    q.set([
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        (b[2] - d) / h,
                                        (b[3] - e) / c,
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        (b[4] - d) / h,
                                        (b[5] - e) / c,
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        l,
                                        m,
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        n,
                                        k,
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        (b[16] - d) / h,
                                        (b[17] - e) / c,
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        (b[14] - d) / h,
                                        (b[15] - e) / c
                                    ], 0);
                                    return this.newFreeDrawOutline(q, a, this.__box, this.__scaleFactor, this.__innerMargin, this.__isLTR);
                                };
                                f.__getOutlineStart = function(a, b) {
                                    var c = this.__bottom;
                                    a.set([
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        c[4],
                                        c[5]
                                    ], b);
                                    return b + 6;
                                };
                                f.__getOutlineEnd = function(a, b) {
                                    var c = this.__last.subarray(4, 6), d = this.__last.subarray(16, 18), e = p.makeIterator(this.__box), h = e.next().value, k = e.next().value, l = e.next().value;
                                    e = e.next().value;
                                    var m = p.makeIterator(this.__getLastCoords()), n = m.next().value, q = m.next().value, r = m.next().value;
                                    m = m.next().value;
                                    a.set([
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        (c[0] - h) / l,
                                        (c[1] - k) / e,
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        n,
                                        q,
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        r,
                                        m,
                                        NaN,
                                        NaN,
                                        NaN,
                                        NaN,
                                        (d[0] - h) / l,
                                        (d[1] - k) / e
                                    ], b);
                                    return b + 24;
                                };
                                return g;
                            }();
                            kb.__MIN_DIST = 8;
                            kb.__MIN_DIFF = 2;
                            kb.__MIN = kb.__MIN_DIST + kb.__MIN_DIFF;
                            var cf = function(g) {
                                function f(b, c, d, e, h, k) {
                                    var l = g.call(this) || this;
                                    l.__bbox = null;
                                    l.__outline = b;
                                    l.__points = c;
                                    l.__box = d;
                                    l.__scaleFactor = e;
                                    l.__innerMargin = h;
                                    l.__isLTR = k;
                                    l.__computeMinMax(k);
                                    k = l.__bbox;
                                    d = k.x;
                                    e = k.y;
                                    h = k.width;
                                    k = k.height;
                                    for(var m = 0, n = b.length; m < n; m += 2)b[m] = (b[m] - d) / h, b[m + 1] = (b[m + 1] - e) / k;
                                    b = 0;
                                    for(m = c.length; b < m; b += 2)c[b] = (c[b] - d) / h, c[b + 1] = (c[b + 1] - e) / k;
                                    return l;
                                }
                                Xf(f, g);
                                var a = f.prototype;
                                a.toSVGPath = function() {
                                    for(var b = [
                                        "M" + this.__outline[4] + " " + this.__outline[5]
                                    ], c = 6, d = this.__outline.length; c < d; c += 6)isNaN(this.__outline[c]) ? b.push("L" + this.__outline[c + 4] + " " + this.__outline[c + 5]) : b.push("C" + this.__outline[c] + " " + this.__outline[c + 1] + " " + this.__outline[c + 2] + " " + this.__outline[c + 3] + " " + this.__outline[c + 4] + " " + this.__outline[c + 5]);
                                    b.push("Z");
                                    return b.join(" ");
                                };
                                a.serialize = function(b, c) {
                                    var d = p.makeIterator(b);
                                    b = d.next().value;
                                    var e = d.next().value, h = d.next().value;
                                    d = d.next().value;
                                    var k = h - b, l = d - e;
                                    switch(c){
                                        case 0:
                                            var m = this.__rescale(this.__outline, b, d, k, -l);
                                            var n = this.__rescale(this.__points, b, d, k, -l);
                                            break;
                                        case 90:
                                            m = this.__rescaleAndSwap(this.__outline, b, e, k, l);
                                            n = this.__rescaleAndSwap(this.__points, b, e, k, l);
                                            break;
                                        case 180:
                                            m = this.__rescale(this.__outline, h, e, -k, l);
                                            n = this.__rescale(this.__points, h, e, -k, l);
                                            break;
                                        case 270:
                                            m = this.__rescaleAndSwap(this.__outline, h, d, -k, -l), n = this.__rescaleAndSwap(this.__points, h, d, -k, -l);
                                    }
                                    return {
                                        outline: Array.from(m),
                                        points: [
                                            Array.from(n)
                                        ]
                                    };
                                };
                                a.__rescale = function(b, c, d, e, h) {
                                    for(var k = new Float64Array(b.length), l = 0, m = b.length; l < m; l += 2)k[l] = c + b[l] * e, k[l + 1] = d + b[l + 1] * h;
                                    return k;
                                };
                                a.__rescaleAndSwap = function(b, c, d, e, h) {
                                    for(var k = new Float64Array(b.length), l = 0, m = b.length; l < m; l += 2)k[l] = c + b[l + 1] * e, k[l + 1] = d + b[l] * h;
                                    return k;
                                };
                                a.__computeMinMax = function(b) {
                                    var c = this.__outline, d = c[4], e = c[5], h = d, k = e, l = d, m = e, n = d, q = e;
                                    b = b ? Math.max : Math.min;
                                    for(var r = 6, t = c.length; r < t; r += 6)isNaN(c[r]) ? (h = Math.min(h, c[r + 4]), k = Math.min(k, c[r + 5]), l = Math.max(l, c[r + 4]), m = Math.max(m, c[r + 5]), q < c[r + 5] ? (n = c[r + 4], q = c[r + 5]) : q === c[r + 5] && (n = b(n, c[r + 4]))) : (d = fa.bezierBoundingBox.apply(fa, [
                                        d,
                                        e
                                    ].concat(p.arrayFromIterable(c.slice(r, r + 6)))), h = Math.min(h, d[0]), k = Math.min(k, d[1]), l = Math.max(l, d[2]), m = Math.max(m, d[3]), q < d[3] ? (n = d[2], q = d[3]) : q === d[3] && (n = b(n, d[2]))), d = c[r + 4], e = c[r + 5];
                                    this.__bbox = {
                                        x: h - this.__innerMargin,
                                        y: k - this.__innerMargin,
                                        width: l - h + 2 * this.__innerMargin,
                                        height: m - k + 2 * this.__innerMargin,
                                        lastPoint: [
                                            n,
                                            q
                                        ]
                                    };
                                };
                                a.newOutliner = function(b, c, d, e, h, k) {
                                    void 0 === k && (k = 0);
                                    return new kb(b, c, d, e, h, k);
                                };
                                a.getNewOutline = function(b, c) {
                                    var d = this.__bbox, e = d.x, h = d.y, k = d.width, l = d.height, m = p.makeIterator(this.__box), n = m.next().value;
                                    d = m.next().value;
                                    var q = m.next().value;
                                    m = m.next().value;
                                    k *= q;
                                    l *= m;
                                    e = e * q + n;
                                    h = h * m + d;
                                    b = this.newOutliner({
                                        x: this.__points[0] * k + e,
                                        y: this.__points[1] * l + h
                                    }, this.__box, this.__scaleFactor, b, this.__isLTR, null != c ? c : this.__innerMargin);
                                    for(c = 2; c < this.__points.length; c += 2)b.add({
                                        x: this.__points[c] * k + e,
                                        y: this.__points[c + 1] * l + h
                                    });
                                    return b.getOutlines();
                                };
                                return Wf(f, [
                                    {
                                        key: "box",
                                        get: function() {
                                            return this.__bbox;
                                        }
                                    },
                                    {
                                        key: "mustRemoveSelfIntersections",
                                        get: function() {
                                            return !0;
                                        }
                                    }
                                ]);
                            }(bf), df = function() {
                                function g(a, b, c, d) {
                                    void 0 === b && (b = 0);
                                    void 0 === c && (c = 0);
                                    void 0 === d && (d = !0);
                                    this.__box = void 0;
                                    this.__verticalEdges = [];
                                    this.__intervals = [];
                                    var e = Infinity, h = -Infinity, k = Infinity, l = -Infinity, m = Math.pow(10, -4);
                                    a = p.makeIterator(a);
                                    for(var n = a.next(); !n.done; n = a.next()){
                                        var q = n.value, r = q.x, t = q.y;
                                        n = Math.floor((r - b) / m) * m;
                                        r = Math.ceil((r + q.width + b) / m) * m;
                                        var u = Math.floor((t - b) / m) * m;
                                        q = Math.ceil((t + q.height + b) / m) * m;
                                        this.__verticalEdges.push([
                                            n,
                                            u,
                                            q,
                                            !0
                                        ], [
                                            r,
                                            u,
                                            q,
                                            !1
                                        ]);
                                        e = Math.min(e, n);
                                        h = Math.max(h, r);
                                        k = Math.min(k, u);
                                        l = Math.max(l, q);
                                    }
                                    b = h - e + 2 * c;
                                    l = l - k + 2 * c;
                                    e -= c;
                                    c = k - c;
                                    d = this.__verticalEdges.at(d ? -1 : -2);
                                    d = [
                                        d[0],
                                        d[2]
                                    ];
                                    k = p.makeIterator(this.__verticalEdges);
                                    for(h = k.next(); !h.done; h = k.next())h = h.value, n = p.makeIterator(h), m = n.next().value, a = n.next().value, n = n.next().value, h[0] = (m - e) / b, h[1] = (a - c) / l, h[2] = (n - c) / l;
                                    this.__box = {
                                        x: e,
                                        y: c,
                                        width: b,
                                        height: l,
                                        lastPoint: d
                                    };
                                }
                                var f = g.prototype;
                                f.getOutlines = function() {
                                    this.__verticalEdges.sort(function(d, e) {
                                        return d[0] - e[0] || d[1] - e[1] || d[2] - e[2];
                                    });
                                    for(var a = [], b = p.makeIterator(this.__verticalEdges), c = b.next(); !c.done; c = b.next())c = c.value, c[3] ? (a.push.apply(a, p.arrayFromIterable(this.__breakEdge(c))), this.__insert(c)) : (this.__remove(c), a.push.apply(a, p.arrayFromIterable(this.__breakEdge(c))));
                                    return this.__getOutlines(a);
                                };
                                f.__getOutlines = function(a) {
                                    var b = [], c = new Set;
                                    a = p.makeIterator(a);
                                    for(var d = a.next(); !d.done; d = a.next()){
                                        d = d.value;
                                        var e = p.makeIterator(d), h = e.next().value, k = e.next().value;
                                        e = e.next().value;
                                        b.push([
                                            h,
                                            k,
                                            d
                                        ], [
                                            h,
                                            e,
                                            d
                                        ]);
                                    }
                                    b.sort(function(q, r) {
                                        return q[1] - r[1] || q[0] - r[0];
                                    });
                                    a = 0;
                                    for(d = b.length; a < d; a += 2)h = b[a][2], k = b[a + 1][2], h.push(k), k.push(h), c.add(h), c.add(k);
                                    for(b = []; 0 < c.size;){
                                        e = c.values().next().value;
                                        var l = p.makeIterator(e);
                                        d = l.next().value;
                                        h = l.next().value;
                                        k = l.next().value;
                                        a = l.next().value;
                                        l = l.next().value;
                                        c.delete(e);
                                        var m = d, n = h;
                                        e = [
                                            d,
                                            k
                                        ];
                                        for(b.push(e);;){
                                            d = void 0;
                                            if (c.has(a)) d = a;
                                            else if (c.has(l)) d = l;
                                            else break;
                                            c.delete(d);
                                            l = p.makeIterator(d);
                                            d = l.next().value;
                                            h = l.next().value;
                                            k = l.next().value;
                                            a = l.next().value;
                                            l = l.next().value;
                                            m !== d && (e.push(m, n, d, n === h ? h : k), m = d);
                                            n = n === h ? k : h;
                                        }
                                        e.push(m, n);
                                    }
                                    return new nh(b, this.__box);
                                };
                                f.__binarySearch = function(a) {
                                    for(var b = this.__intervals, c = 0, d = b.length - 1; c <= d;){
                                        var e = c + d >> 1, h = b[e][0];
                                        if (h === a) return e;
                                        h < a ? c = e + 1 : d = e - 1;
                                    }
                                    return d + 1;
                                };
                                f.__insert = function(a) {
                                    var b = p.makeIterator(a);
                                    b.next();
                                    a = b.next().value;
                                    b = b.next().value;
                                    var c = this.__binarySearch(a);
                                    this.__intervals.splice(c, 0, [
                                        a,
                                        b
                                    ]);
                                };
                                f.__remove = function(a) {
                                    var b = p.makeIterator(a);
                                    b.next();
                                    a = b.next().value;
                                    b = b.next().value;
                                    for(var c = this.__binarySearch(a), d = c; d < this.__intervals.length; d++){
                                        var e = p.makeIterator(this.__intervals[d]), h = e.next().value;
                                        e = e.next().value;
                                        if (h !== a) break;
                                        if (h === a && e === b) {
                                            this.__intervals.splice(d, 1);
                                            return;
                                        }
                                    }
                                    for(--c; 0 <= c; c--){
                                        h = p.makeIterator(this.__intervals[c]);
                                        d = h.next().value;
                                        h = h.next().value;
                                        if (d !== a) break;
                                        if (d === a && h === b) {
                                            this.__intervals.splice(c, 1);
                                            break;
                                        }
                                    }
                                };
                                f.__breakEdge = function(a) {
                                    var b = p.makeIterator(a);
                                    a = b.next().value;
                                    var c = b.next().value;
                                    b = b.next().value;
                                    c = [
                                        [
                                            a,
                                            c,
                                            b
                                        ]
                                    ];
                                    b = this.__binarySearch(b);
                                    for(var d = 0; d < b; d++){
                                        var e = p.makeIterator(this.__intervals[d]), h = e.next().value;
                                        e = e.next().value;
                                        for(var k = 0, l = c.length; k < l; k++){
                                            var m = p.makeIterator(c[k]);
                                            m.next();
                                            var n = m.next().value;
                                            m = m.next().value;
                                            if (!(e <= n || m <= h)) {
                                                if (n >= h) {
                                                    if (m > e) c[k][1] = e;
                                                    else {
                                                        if (1 === l) return [];
                                                        c.splice(k, 1);
                                                        k--;
                                                        l--;
                                                    }
                                                } else c[k][2] = h, m > e && c.push([
                                                    a,
                                                    e,
                                                    m
                                                ]);
                                            }
                                        }
                                    }
                                    return c;
                                };
                                return g;
                            }(), nh = function(g) {
                                function f(b, c) {
                                    var d = g.call(this) || this;
                                    d.__outlines = b;
                                    d.__box = c;
                                    return d;
                                }
                                Bc(f, g);
                                var a = f.prototype;
                                a.toSVGPath = function() {
                                    for(var b = [], c = p.makeIterator(this.__outlines), d = c.next(); !d.done; d = c.next()){
                                        d = d.value;
                                        var e = p.makeIterator(d), h = e.next().value;
                                        e = e.next().value;
                                        b.push("M" + h + " " + e);
                                        for(var k = 2; k < d.length; k += 2){
                                            var l = d[k], m = d[k + 1];
                                            l === h ? (b.push("V" + m), e = m) : m === e && (b.push("H" + l), h = l);
                                        }
                                        b.push("Z");
                                    }
                                    return b.join(" ");
                                };
                                a.serialize = function(b) {
                                    var c = p.makeIterator(b);
                                    b = c.next().value;
                                    var d = c.next().value, e = c.next().value;
                                    c = c.next().value;
                                    var h = [];
                                    e -= b;
                                    d = c - d;
                                    for(var k = p.makeIterator(this.__outlines), l = k.next(); !l.done; l = k.next()){
                                        l = l.value;
                                        for(var m = Array(l.length), n = 0; n < l.length; n += 2)m[n] = b + l[n] * e, m[n + 1] = c - l[n + 1] * d;
                                        h.push(m);
                                    }
                                    return h;
                                };
                                return Ac(f, [
                                    {
                                        key: "box",
                                        get: function() {
                                            return this.__box;
                                        }
                                    },
                                    {
                                        key: "classNamesForDrawing",
                                        get: function() {
                                            return [
                                                "highlight"
                                            ];
                                        }
                                    },
                                    {
                                        key: "classNamesForOutlining",
                                        get: function() {
                                            return [
                                                "highlightOutline"
                                            ];
                                        }
                                    }
                                ]);
                            }(bf), Wc = function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                Bc(f, g);
                                f.prototype.newFreeDrawOutline = function(a, b, c, d, e, h) {
                                    return new oh(a, b, c, d, e, h);
                                };
                                return Ac(f, [
                                    {
                                        key: "classNamesForDrawing",
                                        get: function() {
                                            return [
                                                "highlight",
                                                "free"
                                            ];
                                        }
                                    }
                                ]);
                            }(kb), oh = function(g) {
                                function f() {
                                    return g.apply(this, arguments) || this;
                                }
                                Bc(f, g);
                                f.prototype.newOutliner = function(a, b, c, d, e, h) {
                                    void 0 === h && (h = 0);
                                    return new Wc(a, b, c, d, e, h);
                                };
                                return Ac(f, [
                                    {
                                        key: "classNamesForDrawing",
                                        get: function() {
                                            return [
                                                "highlight",
                                                "free"
                                            ];
                                        }
                                    },
                                    {
                                        key: "classNamesForOutlining",
                                        get: function() {
                                            return [
                                                "highlightOutline",
                                                "free"
                                            ];
                                        }
                                    }
                                ]);
                            }(cf), Jc = function() {
                                function g(a) {
                                    var b, c = void 0 === a.editor ? null : a.editor;
                                    a = void 0 === a.uiManager ? null : a.uiManager;
                                    this.__buttonSwatch = this.__button = null;
                                    this.__defaultColor = void 0;
                                    this.__dropdown = null;
                                    this.__isMainColorPicker = this.__dropdownWasFromKeyboard = !1;
                                    this.__editor = null;
                                    this.__eventBus = void 0;
                                    this.__uiManager = this.__openDropdownAC = null;
                                    this.__type = void 0;
                                    c ? (this.__isMainColorPicker = !1, this.__type = pa.HIGHLIGHT_COLOR, this.__editor = c) : (this.__isMainColorPicker = !0, this.__type = pa.HIGHLIGHT_DEFAULT_COLOR);
                                    this.__uiManager = (null == c ? void 0 : c._uiManager) || a;
                                    this.__eventBus = this.__uiManager._eventBus;
                                    this.__defaultColor = (null == c ? void 0 : c.color) || (null == (b = this.__uiManager) ? void 0 : b.highlightColors.values().next().value) || "#FFFF98";
                                    g.__l10nColor || (g.__l10nColor = Object.freeze({
                                        blue: "pdfjs-editor-colorpicker-blue",
                                        green: "pdfjs-editor-colorpicker-green",
                                        pink: "pdfjs-editor-colorpicker-pink",
                                        red: "pdfjs-editor-colorpicker-red",
                                        yellow: "pdfjs-editor-colorpicker-yellow"
                                    }));
                                }
                                var f = g.prototype;
                                f.renderButton = function() {
                                    var a = this.__button = document.createElement("button");
                                    a.className = "colorPicker";
                                    a.tabIndex = "0";
                                    a.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
                                    a.setAttribute("aria-haspopup", !0);
                                    var b = this.__uiManager._signal;
                                    a.addEventListener("click", this.__openDropdown.bind(this), {
                                        signal: b
                                    });
                                    a.addEventListener("keydown", this.__keyDown.bind(this), {
                                        signal: b
                                    });
                                    b = this.__buttonSwatch = document.createElement("span");
                                    b.className = "swatch";
                                    b.setAttribute("aria-hidden", !0);
                                    b.style.backgroundColor = this.__defaultColor;
                                    a.append(b);
                                    return a;
                                };
                                f.renderMainDropdown = function() {
                                    var a = this.__dropdown = this.__getDropdownRoot();
                                    a.setAttribute("aria-orientation", "horizontal");
                                    a.setAttribute("aria-labelledby", "highlightColorPickerLabel");
                                    return a;
                                };
                                f.__getDropdownRoot = function() {
                                    var a = document.createElement("div"), b = this.__uiManager._signal;
                                    a.addEventListener("contextmenu", Ma, {
                                        signal: b
                                    });
                                    a.className = "dropdown";
                                    a.role = "listbox";
                                    a.setAttribute("aria-multiselectable", !1);
                                    a.setAttribute("aria-orientation", "vertical");
                                    a.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
                                    for(var c = p.makeIterator(this.__uiManager.highlightColors), d = c.next(); !d.done; d = c.next()){
                                        var e = p.makeIterator(d.value);
                                        d = e.next().value;
                                        e = e.next().value;
                                        var h = document.createElement("button");
                                        h.tabIndex = "0";
                                        h.role = "option";
                                        h.setAttribute("data-color", e);
                                        h.title = d;
                                        h.setAttribute("data-l10n-id", g.__l10nColor[d]);
                                        d = document.createElement("span");
                                        h.append(d);
                                        d.className = "swatch";
                                        d.style.backgroundColor = e;
                                        h.setAttribute("aria-selected", e === this.__defaultColor);
                                        h.addEventListener("click", this.__colorSelect.bind(this, e), {
                                            signal: b
                                        });
                                        a.append(h);
                                    }
                                    a.addEventListener("keydown", this.__keyDown.bind(this), {
                                        signal: b
                                    });
                                    return a;
                                };
                                f.__colorSelect = function(a, b) {
                                    b.stopPropagation();
                                    this.__eventBus.dispatch("switchannotationeditorparams", {
                                        source: this,
                                        type: this.__type,
                                        value: a
                                    });
                                };
                                f._colorSelectFromKeyboard = function(a) {
                                    if (a.target === this.__button) this.__openDropdown(a);
                                    else {
                                        var b = a.target.getAttribute("data-color");
                                        b && this.__colorSelect(b, a);
                                    }
                                };
                                f._moveToNext = function(a) {
                                    var b;
                                    if (this.__isDropdownVisible) {
                                        if (a.target === this.__button) {
                                            var c;
                                            null == (c = this.__dropdown.firstChild) || c.focus();
                                        } else null == (b = a.target.nextSibling) || b.focus();
                                    } else this.__openDropdown(a);
                                };
                                f._moveToPrevious = function(a) {
                                    var b, c;
                                    a.target === (null == (b = this.__dropdown) ? void 0 : b.firstChild) || a.target === this.__button ? this.__isDropdownVisible && this._hideDropdownFromKeyboard() : (this.__isDropdownVisible || this.__openDropdown(a), null == (c = a.target.previousSibling) || c.focus());
                                };
                                f._moveToBeginning = function(a) {
                                    var b;
                                    this.__isDropdownVisible ? null == (b = this.__dropdown.firstChild) || b.focus() : this.__openDropdown(a);
                                };
                                f._moveToEnd = function(a) {
                                    var b;
                                    this.__isDropdownVisible ? null == (b = this.__dropdown.lastChild) || b.focus() : this.__openDropdown(a);
                                };
                                f.__keyDown = function(a) {
                                    g._keyboardManager.exec(this, a);
                                };
                                f.__openDropdown = function(a) {
                                    this.__isDropdownVisible ? this.hideDropdown() : (this.__dropdownWasFromKeyboard = 0 === a.detail, this.__openDropdownAC || (this.__openDropdownAC = new AbortController, window.addEventListener("pointerdown", this.__pointerDown.bind(this), {
                                        signal: this.__uiManager.combinedSignal(this.__openDropdownAC)
                                    })), this.__dropdown ? this.__dropdown.classList.remove("hidden") : (a = this.__dropdown = this.__getDropdownRoot(), this.__button.append(a)));
                                };
                                f.__pointerDown = function(a) {
                                    var b;
                                    null != (b = this.__dropdown) && b.contains(a.target) || this.hideDropdown();
                                };
                                f.hideDropdown = function() {
                                    var a, b;
                                    null == (a = this.__dropdown) || a.classList.add("hidden");
                                    null == (b = this.__openDropdownAC) || b.abort();
                                    this.__openDropdownAC = null;
                                };
                                f._hideDropdownFromKeyboard = function() {
                                    if (!this.__isMainColorPicker) {
                                        if (this.__isDropdownVisible) this.hideDropdown(), this.__button.focus({
                                            preventScroll: !0,
                                            focusVisible: this.__dropdownWasFromKeyboard
                                        });
                                        else {
                                            var a;
                                            null == (a = this.__editor) || a.unselect();
                                        }
                                    }
                                };
                                f.updateColor = function(a) {
                                    this.__buttonSwatch && (this.__buttonSwatch.style.backgroundColor = a);
                                    if (this.__dropdown) for(var b = this.__uiManager.highlightColors.values(), c = p.makeIterator(this.__dropdown.children), d = c.next(); !d.done; d = c.next())d.value.setAttribute("aria-selected", b.next().value === a);
                                };
                                f.destroy = function() {
                                    var a, b;
                                    null == (a = this.__button) || a.remove();
                                    this.__buttonSwatch = this.__button = null;
                                    null == (b = this.__dropdown) || b.remove();
                                    this.__dropdown = null;
                                };
                                return Yf(g, [
                                    {
                                        key: "__isDropdownVisible",
                                        get: function() {
                                            return this.__dropdown && !this.__dropdown.classList.contains("hidden");
                                        }
                                    }
                                ], [
                                    {
                                        key: "_keyboardManager",
                                        get: function() {
                                            return qa(this, "_keyboardManager", new ub([
                                                [
                                                    [
                                                        "Escape",
                                                        "mac+Escape"
                                                    ],
                                                    g.prototype._hideDropdownFromKeyboard
                                                ],
                                                [
                                                    [
                                                        " ",
                                                        "mac+ "
                                                    ],
                                                    g.prototype._colorSelectFromKeyboard
                                                ],
                                                [
                                                    [
                                                        "ArrowDown",
                                                        "ArrowRight",
                                                        "mac+ArrowDown",
                                                        "mac+ArrowRight"
                                                    ],
                                                    g.prototype._moveToNext
                                                ],
                                                [
                                                    [
                                                        "ArrowUp",
                                                        "ArrowLeft",
                                                        "mac+ArrowUp",
                                                        "mac+ArrowLeft"
                                                    ],
                                                    g.prototype._moveToPrevious
                                                ],
                                                [
                                                    [
                                                        "Home",
                                                        "mac+Home"
                                                    ],
                                                    g.prototype._moveToBeginning
                                                ],
                                                [
                                                    [
                                                        "End",
                                                        "mac+End"
                                                    ],
                                                    g.prototype._moveToEnd
                                                ]
                                            ]));
                                        }
                                    }
                                ]);
                            }();
                            Jc.__l10nColor = null;
                            var Ra = function(g) {
                                function f(b) {
                                    var c = g.call(this, Object.assign({}, b, {
                                        name: "highlightEditor"
                                    })) || this;
                                    c.__anchorNode = null;
                                    c.__anchorOffset = 0;
                                    c.__boxes = void 0;
                                    c.__clipPathId = null;
                                    c.__colorPicker = null;
                                    c.__focusOutlines = null;
                                    c.__focusNode = null;
                                    c.__focusOffset = 0;
                                    c.__highlightDiv = null;
                                    c.__highlightOutlines = null;
                                    c.__id = null;
                                    c.__isFreeHighlight = !1;
                                    c.__lastPoint = null;
                                    c.__opacity = void 0;
                                    c.__outlineId = null;
                                    c.__text = "";
                                    c.__thickness = void 0;
                                    c.__methodOfCreation = "";
                                    c.color = b.color || f._defaultColor;
                                    c.__thickness = b.thickness || f._defaultThickness;
                                    c.__opacity = b.opacity || f._defaultOpacity;
                                    c.__boxes = b.boxes || null;
                                    c.__methodOfCreation = b.methodOfCreation || "";
                                    c.__text = b.text || "";
                                    c._isDraggable = !1;
                                    -1 < b.highlightId ? (c.__isFreeHighlight = !0, c.__createFreeOutlines(b), c.__addToDrawLayer()) : c.__boxes && (c.__anchorNode = b.anchorNode, c.__anchorOffset = b.anchorOffset, c.__focusNode = b.focusNode, c.__focusOffset = b.focusOffset, c.__createOutlines(), c.__addToDrawLayer(), c.rotate(c.rotation));
                                    return c;
                                }
                                $f(f, g);
                                f.computeTelemetryFinalData = function(b) {
                                    return {
                                        numberOfColors: b.get("color").size
                                    };
                                };
                                var a = f.prototype;
                                a.__createOutlines = function() {
                                    this.__highlightOutlines = new df(this.__boxes, .001).getOutlines();
                                    var b = this.__highlightOutlines.box;
                                    this.x = b.x;
                                    this.y = b.y;
                                    this.width = b.width;
                                    this.height = b.height;
                                    this.__focusOutlines = new df(this.__boxes, .0025, .001, "ltr" === this._uiManager.direction).getOutlines();
                                    b = this.__focusOutlines.box.lastPoint;
                                    this.__lastPoint = [
                                        (b[0] - this.x) / this.width,
                                        (b[1] - this.y) / this.height
                                    ];
                                };
                                a.__createFreeOutlines = function(b) {
                                    var c = b.highlightOutlines, d = b.highlightId;
                                    b = b.clipPathId;
                                    this.__highlightOutlines = c;
                                    this.__focusOutlines = c.getNewOutline(this.__thickness / 2 + 1.5, .0025);
                                    0 <= d ? (this.__id = d, this.__clipPathId = b, this.parent.drawLayer.finalizeLine(d, c), this.__outlineId = this.parent.drawLayer.drawOutline(this.__focusOutlines)) : this.parent && (d = this.parent.viewport.rotation, this.parent.drawLayer.updateLine(this.__id, c), this.parent.drawLayer.updateBox(this.__id, f.__rotateBbox(this.__highlightOutlines.box, (d - this.rotation + 360) % 360)), this.parent.drawLayer.updateLine(this.__outlineId, this.__focusOutlines), this.parent.drawLayer.updateBox(this.__outlineId, f.__rotateBbox(this.__focusOutlines.box, d)));
                                    var e = c.box;
                                    c = e.x;
                                    d = e.y;
                                    b = e.width;
                                    e = e.height;
                                    switch(this.rotation){
                                        case 0:
                                            this.x = c;
                                            this.y = d;
                                            this.width = b;
                                            this.height = e;
                                            break;
                                        case 90:
                                            var h = p.makeIterator(this.parentDimensions), k = h.next().value;
                                            h = h.next().value;
                                            this.x = d;
                                            this.y = 1 - c;
                                            this.width = b * h / k;
                                            this.height = e * k / h;
                                            break;
                                        case 180:
                                            this.x = 1 - c;
                                            this.y = 1 - d;
                                            this.width = b;
                                            this.height = e;
                                            break;
                                        case 270:
                                            h = p.makeIterator(this.parentDimensions), k = h.next().value, h = h.next().value, this.x = 1 - d, this.y = c, this.width = b * h / k, this.height = e * k / h;
                                    }
                                    k = this.__focusOutlines.box.lastPoint;
                                    this.__lastPoint = [
                                        (k[0] - c) / b,
                                        (k[1] - d) / e
                                    ];
                                };
                                f.initialize = function(b, c) {
                                    var d;
                                    wa.initialize(b, c);
                                    f._defaultColor || (f._defaultColor = (null == (d = c.highlightColors) ? void 0 : d.values().next().value) || "#fff066");
                                };
                                f.updateDefaultParams = function(b, c) {
                                    switch(b){
                                        case pa.HIGHLIGHT_DEFAULT_COLOR:
                                            f._defaultColor = c;
                                            break;
                                        case pa.HIGHLIGHT_THICKNESS:
                                            f._defaultThickness = c;
                                    }
                                };
                                a.translateInPage = function() {};
                                a.updateParams = function(b, c) {
                                    switch(b){
                                        case pa.HIGHLIGHT_COLOR:
                                            this.__updateColor(c);
                                            break;
                                        case pa.HIGHLIGHT_THICKNESS:
                                            this.__updateThickness(c);
                                    }
                                };
                                a.__updateColor = function(b) {
                                    function c(k, l) {
                                        var m, n, q;
                                        d.color = k;
                                        null == (m = d.parent) || m.drawLayer.changeColor(d.__id, k);
                                        null == (n = d.__colorPicker) || n.updateColor(k);
                                        d.__opacity = l;
                                        null == (q = d.parent) || q.drawLayer.changeOpacity(d.__id, l);
                                    }
                                    var d = this, e = this.color, h = this.__opacity;
                                    this.addCommands({
                                        cmd: c.bind(this, b, f._defaultOpacity),
                                        undo: c.bind(this, e, h),
                                        post: this._uiManager.updateUI.bind(this._uiManager, this),
                                        mustExec: !0,
                                        type: pa.HIGHLIGHT_COLOR,
                                        overwriteIfSameType: !0,
                                        keepUndo: !0
                                    });
                                    this._reportTelemetry({
                                        action: "color_changed",
                                        color: this._uiManager.highlightColorNames.get(b)
                                    }, !0);
                                };
                                a.__updateThickness = function(b) {
                                    function c(h) {
                                        d.__thickness = h;
                                        d.__changeThickness(h);
                                    }
                                    var d = this, e = this.__thickness;
                                    this.addCommands({
                                        cmd: c.bind(this, b),
                                        undo: c.bind(this, e),
                                        post: this._uiManager.updateUI.bind(this._uiManager, this),
                                        mustExec: !0,
                                        type: pa.INK_THICKNESS,
                                        overwriteIfSameType: !0,
                                        keepUndo: !0
                                    });
                                    this._reportTelemetry({
                                        action: "thickness_changed",
                                        thickness: b
                                    }, !0);
                                };
                                a.addEditToolbar = function() {
                                    var b = pe(function d() {
                                        var e = this, h;
                                        return p.generator.createGenerator(d, function(k) {
                                            if (1 == k.nextAddress) return k.yield(g.prototype.addEditToolbar.call(e), 2);
                                            h = k.yieldResult;
                                            if (!h) return k.return(null);
                                            e._uiManager.highlightColors && (e.__colorPicker = new Jc({
                                                editor: e
                                            }), h.addColorPicker(e.__colorPicker));
                                            return k.return(h);
                                        });
                                    });
                                    return function() {
                                        return b.apply(this, arguments);
                                    };
                                }();
                                a.disableEditing = function() {
                                    g.prototype.disableEditing.call(this);
                                    this.div.classList.toggle("disabled", !0);
                                };
                                a.enableEditing = function() {
                                    g.prototype.enableEditing.call(this);
                                    this.div.classList.toggle("disabled", !1);
                                };
                                a.fixAndSetPosition = function() {
                                    return g.prototype.fixAndSetPosition.call(this, this.__getRotation());
                                };
                                a.getBaseTranslation = function() {
                                    return [
                                        0,
                                        0
                                    ];
                                };
                                a.getRect = function(b, c) {
                                    return g.prototype.getRect.call(this, b, c, this.__getRotation());
                                };
                                a.onceAdded = function() {
                                    this.annotationElementId || this.parent.addUndoableEditor(this);
                                    this.div.focus();
                                };
                                a.remove = function() {
                                    this.__cleanDrawLayer();
                                    this._reportTelemetry({
                                        action: "deleted"
                                    });
                                    g.prototype.remove.call(this);
                                };
                                a.rebuild = function() {
                                    this.parent && (g.prototype.rebuild.call(this), null !== this.div && (this.__addToDrawLayer(), this.isAttachedToDOM || this.parent.add(this)));
                                };
                                a.setParent = function(b) {
                                    var c = !1;
                                    if (this.parent && !b) this.__cleanDrawLayer();
                                    else if (b) {
                                        var d;
                                        this.__addToDrawLayer(b);
                                        c = !this.parent && (null == (d = this.div) ? void 0 : d.classList.contains("selectedEditor"));
                                    }
                                    g.prototype.setParent.call(this, b);
                                    this.show(this._isVisible);
                                    c && this.select();
                                };
                                a.__changeThickness = function(b) {
                                    if (this.__isFreeHighlight) {
                                        this.__createFreeOutlines({
                                            highlightOutlines: this.__highlightOutlines.getNewOutline(b / 2)
                                        });
                                        this.fixAndSetPosition();
                                        var c = p.makeIterator(this.parentDimensions);
                                        b = c.next().value;
                                        c = c.next().value;
                                        this.setDims(this.width * b, this.height * c);
                                    }
                                };
                                a.__cleanDrawLayer = function() {
                                    null !== this.__id && this.parent && (this.parent.drawLayer.remove(this.__id), this.__id = null, this.parent.drawLayer.remove(this.__outlineId), this.__outlineId = null);
                                };
                                a.__addToDrawLayer = function(b) {
                                    void 0 === b && (b = this.parent);
                                    if (null === this.__id) {
                                        var c = b.drawLayer.draw(this.__highlightOutlines, this.color, this.__opacity);
                                        this.__id = c.id;
                                        this.__clipPathId = c.clipPathId;
                                        this.__outlineId = b.drawLayer.drawOutline(this.__focusOutlines);
                                        this.__highlightDiv && (this.__highlightDiv.style.clipPath = this.__clipPathId);
                                    }
                                };
                                f.__rotateBbox = function(b, c) {
                                    var d = b.x, e = b.y, h = b.width;
                                    b = b.height;
                                    switch(c){
                                        case 90:
                                            return {
                                                x: 1 - e - b,
                                                y: d,
                                                width: b,
                                                height: h
                                            };
                                        case 180:
                                            return {
                                                x: 1 - d - h,
                                                y: 1 - e - b,
                                                width: h,
                                                height: b
                                            };
                                        case 270:
                                            return {
                                                x: e,
                                                y: 1 - d - h,
                                                width: b,
                                                height: h
                                            };
                                    }
                                    return {
                                        x: d,
                                        y: e,
                                        width: h,
                                        height: b
                                    };
                                };
                                a.rotate = function(b) {
                                    var c = this.parent.drawLayer;
                                    if (this.__isFreeHighlight) {
                                        b = (b - this.rotation + 360) % 360;
                                        var d = f.__rotateBbox(this.__highlightOutlines.box, b);
                                    } else d = f.__rotateBbox(this, b);
                                    c.rotate(this.__id, b);
                                    c.rotate(this.__outlineId, b);
                                    c.updateBox(this.__id, d);
                                    c.updateBox(this.__outlineId, f.__rotateBbox(this.__focusOutlines.box, b));
                                };
                                a.render = function() {
                                    if (this.div) return this.div;
                                    var b = g.prototype.render.call(this);
                                    this.__text && (b.setAttribute("aria-label", this.__text), b.setAttribute("role", "mark"));
                                    this.__isFreeHighlight ? b.classList.add("free") : this.div.addEventListener("keydown", this.__keydown.bind(this), {
                                        signal: this._uiManager._signal
                                    });
                                    var c = this.__highlightDiv = document.createElement("div");
                                    b.append(c);
                                    c.setAttribute("aria-hidden", "true");
                                    c.className = "internal";
                                    c.style.clipPath = this.__clipPathId;
                                    var d = p.makeIterator(this.parentDimensions);
                                    c = d.next().value;
                                    d = d.next().value;
                                    this.setDims(this.width * c, this.height * d);
                                    Bb(this, this.__highlightDiv, [
                                        "pointerover",
                                        "pointerleave"
                                    ]);
                                    this.enableEditing();
                                    return b;
                                };
                                a.pointerover = function() {
                                    this.isSelected || this.parent.drawLayer.addClass(this.__outlineId, "hovered");
                                };
                                a.pointerleave = function() {
                                    this.isSelected || this.parent.drawLayer.removeClass(this.__outlineId, "hovered");
                                };
                                a.__keydown = function(b) {
                                    f._keyboardManager.exec(this, b);
                                };
                                a._moveCaret = function(b) {
                                    this.parent.unselect(this);
                                    switch(b){
                                        case 0:
                                        case 2:
                                            this.__setCaret(!0);
                                            break;
                                        case 1:
                                        case 3:
                                            this.__setCaret(!1);
                                    }
                                };
                                a.__setCaret = function(b) {
                                    if (this.__anchorNode) {
                                        var c = window.getSelection();
                                        b ? c.setPosition(this.__anchorNode, this.__anchorOffset) : c.setPosition(this.__focusNode, this.__focusOffset);
                                    }
                                };
                                a.select = function() {
                                    var b, c;
                                    g.prototype.select.call(this);
                                    this.__outlineId && (null == (b = this.parent) || b.drawLayer.removeClass(this.__outlineId, "hovered"), null == (c = this.parent) || c.drawLayer.addClass(this.__outlineId, "selected"));
                                };
                                a.unselect = function() {
                                    var b;
                                    g.prototype.unselect.call(this);
                                    this.__outlineId && (null == (b = this.parent) || b.drawLayer.removeClass(this.__outlineId, "selected"), this.__isFreeHighlight || this.__setCaret(!1));
                                };
                                a.show = function(b) {
                                    void 0 === b && (b = this._isVisible);
                                    g.prototype.show.call(this, b);
                                    this.parent && (this.parent.drawLayer.show(this.__id, b), this.parent.drawLayer.show(this.__outlineId, b));
                                };
                                a.__getRotation = function() {
                                    return this.__isFreeHighlight ? this.rotation : 0;
                                };
                                a.__serializeBoxes = function() {
                                    if (this.__isFreeHighlight) return null;
                                    var b = p.makeIterator(this.pageDimensions), c = b.next().value;
                                    b = b.next().value;
                                    var d = p.makeIterator(this.pageTranslation), e = d.next().value;
                                    d = d.next().value;
                                    var h = this.__boxes, k = new Float32Array(8 * h.length), l = 0;
                                    h = p.makeIterator(h);
                                    for(var m = h.next(); !m.done; m = h.next()){
                                        var n = m.value;
                                        m = n.width;
                                        var q = n.height, r = n.x * c + e;
                                        n = (1 - n.y - q) * b + d;
                                        k[l] = k[l + 4] = r;
                                        k[l + 1] = k[l + 3] = n;
                                        k[l + 2] = k[l + 6] = r + m * c;
                                        k[l + 5] = k[l + 7] = n + q * b;
                                        l += 8;
                                    }
                                    return k;
                                };
                                a.__serializeOutlines = function(b) {
                                    return this.__highlightOutlines.serialize(b, this.__getRotation());
                                };
                                f.startHighlighting = function(b, c, d) {
                                    function e(v) {
                                        t.abort();
                                        h.__endHighlight(b, v);
                                    }
                                    var h = this, k = d.target, l = d.x;
                                    d = d.y;
                                    var m = k.getBoundingClientRect(), n = m.x, q = m.y, r = m.width;
                                    m = m.height;
                                    var t = new AbortController, u = b.combinedSignal(t);
                                    window.addEventListener("blur", e, {
                                        signal: u
                                    });
                                    window.addEventListener("pointerup", e, {
                                        signal: u
                                    });
                                    window.addEventListener("pointerdown", function(v) {
                                        v.preventDefault();
                                        v.stopPropagation();
                                    }, {
                                        capture: !0,
                                        passive: !1,
                                        signal: u
                                    });
                                    window.addEventListener("contextmenu", Ma, {
                                        signal: u
                                    });
                                    k.addEventListener("pointermove", this.__highlightMove.bind(this, b), {
                                        signal: u
                                    });
                                    this._freeHighlight = new Wc({
                                        x: l,
                                        y: d
                                    }, [
                                        n,
                                        q,
                                        r,
                                        m
                                    ], b.scale, this._defaultThickness / 2, c, .001);
                                    c = b.drawLayer.draw(this._freeHighlight, this._defaultColor, this._defaultOpacity, !0);
                                    this._freeHighlightId = c.id;
                                    this._freeHighlightClipId = c.clipPathId;
                                };
                                f.__highlightMove = function(b, c) {
                                    this._freeHighlight.add(c) && b.drawLayer.updatePath(this._freeHighlightId, this._freeHighlight);
                                };
                                f.__endHighlight = function(b, c) {
                                    this._freeHighlight.isEmpty() ? b.drawLayer.remove(this._freeHighlightId) : b.createAndAddNewEditor(c, !1, {
                                        highlightId: this._freeHighlightId,
                                        highlightOutlines: this._freeHighlight.getOutlines(),
                                        clipPathId: this._freeHighlightClipId,
                                        methodOfCreation: "main_toolbar"
                                    });
                                    this._freeHighlightId = -1;
                                    this._freeHighlight = null;
                                    this._freeHighlightClipId = "";
                                };
                                f.deserialize = function() {
                                    var b = pe(function k(d, e, h) {
                                        var l, m, n, q, r, t, u, v, w, x, B, z, C, D, H, J, M, I, P, L, T, aa, ba, ra, X, ma, U, K, N, V, ea, ia = this, na, ua, va, za, Ha, Ia, Z, ja, ka, O, Y, oa, xa, la, ta, Ca, nb;
                                        return p.generator.createGenerator(k, function(Ga) {
                                            if (1 == Ga.nextAddress) return l = null, d instanceof $e ? (m = d, n = m.data, q = n.quadPoints, r = n.rect, t = n.rotation, u = n.id, v = n.color, w = n.opacity, x = n.popupRef, B = m.parent, z = B.page, C = z.pageNumber, l = d = {
                                                annotationType: sa.HIGHLIGHT,
                                                color: Array.from(v),
                                                opacity: w,
                                                quadPoints: q,
                                                boxes: null,
                                                pageIndex: C - 1,
                                                rect: r.slice(0),
                                                rotation: t,
                                                id: u,
                                                deleted: !1,
                                                popupRef: x
                                            }) : d instanceof Vc && (D = d, H = D.data, J = H.inkLists, M = H.rect, I = H.rotation, P = H.id, L = H.color, T = H.borderStyle, aa = T.rawWidth, ba = H.popupRef, ra = D.parent, X = ra.page, ma = X.pageNumber, l = d = {
                                                annotationType: sa.HIGHLIGHT,
                                                color: Array.from(L),
                                                thickness: aa,
                                                inkLists: J,
                                                boxes: null,
                                                pageIndex: ma - 1,
                                                rect: M.slice(0),
                                                rotation: I,
                                                id: P,
                                                deleted: !1,
                                                popupRef: ba
                                            }), U = d, K = U.color, N = U.quadPoints, V = U.inkLists, ea = U.opacity, Ga.yield(g.deserialize.call(ia, d, e, h), 2);
                                            na = Ga.yieldResult;
                                            na.color = fa.makeHexColor.apply(fa, p.arrayFromIterable(K));
                                            na.__opacity = ea || 1;
                                            V && (na.__thickness = d.thickness);
                                            na.annotationElementId = d.id || null;
                                            na._initialData = l;
                                            ua = p.makeIterator(na.pageDimensions);
                                            va = ua.next().value;
                                            za = ua.next().value;
                                            Ha = p.makeIterator(na.pageTranslation);
                                            Ia = Ha.next().value;
                                            Z = Ha.next().value;
                                            if (N) {
                                                ja = na.__boxes = [];
                                                for(ka = 0; ka < N.length; ka += 8)ja.push({
                                                    x: (N[ka] - Ia) / va,
                                                    y: 1 - (N[ka + 1] - Z) / za,
                                                    width: (N[ka + 2] - N[ka]) / va,
                                                    height: (N[ka + 1] - N[ka + 5]) / za
                                                });
                                                na.__createOutlines();
                                                na.__addToDrawLayer();
                                                na.rotate(na.rotation);
                                            } else if (V) {
                                                na.__isFreeHighlight = !0;
                                                O = V[0];
                                                Y = {
                                                    x: O[0] - Ia,
                                                    y: za - (O[1] - Z)
                                                };
                                                oa = new Wc(Y, [
                                                    0,
                                                    0,
                                                    va,
                                                    za
                                                ], 1, na.__thickness / 2, !0, .001);
                                                xa = 0;
                                                for(la = O.length; xa < la; xa += 2)Y.x = O[xa] - Ia, Y.y = za - (O[xa + 1] - Z), oa.add(Y);
                                                ta = e.drawLayer.draw(oa, na.color, na._defaultOpacity, !0);
                                                Ca = ta.id;
                                                nb = ta.clipPathId;
                                                na.__createFreeOutlines({
                                                    highlightOutlines: oa.getOutlines(),
                                                    highlightId: Ca,
                                                    clipPathId: nb
                                                });
                                                na.__addToDrawLayer();
                                            }
                                            return Ga.return(na);
                                        });
                                    });
                                    return function(d, e, h) {
                                        return b.apply(this, arguments);
                                    };
                                }();
                                a.serialize = function(b) {
                                    void 0 === b && (b = !1);
                                    if (this.isEmpty() || b) return null;
                                    if (this.deleted) return this.serializeDeleted();
                                    b = this.getRect(0, 0);
                                    var c = wa._colorManager.convert(this.color);
                                    b = {
                                        annotationType: sa.HIGHLIGHT,
                                        color: c,
                                        opacity: this.__opacity,
                                        thickness: this.__thickness,
                                        quadPoints: this.__serializeBoxes(),
                                        outlines: this.__serializeOutlines(b),
                                        pageIndex: this.pageIndex,
                                        rect: b,
                                        rotation: this.__getRotation(),
                                        structTreeParentId: this._structTreeParentId
                                    };
                                    if (this.annotationElementId && !this.__hasElementChanged(b)) return null;
                                    b.id = this.annotationElementId;
                                    return b;
                                };
                                a.__hasElementChanged = function(b) {
                                    var c = this._initialData.color;
                                    return b.color.some(function(d, e) {
                                        return d !== c[e];
                                    });
                                };
                                a.renderAnnotationElement = function(b) {
                                    b.updateEdited({
                                        rect: this.getRect(0, 0)
                                    });
                                    return null;
                                };
                                f.canCreateNewEmptyEditor = function() {
                                    return !1;
                                };
                                return Zf(f, [
                                    {
                                        key: "telemetryInitialData",
                                        get: function() {
                                            return {
                                                action: "added",
                                                type: this.__isFreeHighlight ? "free_highlight" : "highlight",
                                                color: this._uiManager.highlightColorNames.get(this.color),
                                                thickness: this.__thickness,
                                                methodOfCreation: this.__methodOfCreation
                                            };
                                        }
                                    },
                                    {
                                        key: "telemetryFinalData",
                                        get: function() {
                                            return {
                                                type: "highlight",
                                                color: this._uiManager.highlightColorNames.get(this.color)
                                            };
                                        }
                                    },
                                    {
                                        key: "toolbarPosition",
                                        get: function() {
                                            return this.__lastPoint;
                                        }
                                    },
                                    {
                                        key: "propertiesToUpdate",
                                        get: function() {
                                            return [
                                                [
                                                    pa.HIGHLIGHT_COLOR,
                                                    this.color || f._defaultColor
                                                ],
                                                [
                                                    pa.HIGHLIGHT_THICKNESS,
                                                    this.__thickness || f._defaultThickness
                                                ],
                                                [
                                                    pa.HIGHLIGHT_FREE,
                                                    this.__isFreeHighlight
                                                ]
                                            ];
                                        }
                                    },
                                    {
                                        key: "_mustFixPosition",
                                        get: function() {
                                            return !this.__isFreeHighlight;
                                        }
                                    }
                                ], [
                                    {
                                        key: "_keyboardManager",
                                        get: function() {
                                            var b = f.prototype;
                                            return qa(this, "_keyboardManager", new ub([
                                                [
                                                    [
                                                        "ArrowLeft",
                                                        "mac+ArrowLeft"
                                                    ],
                                                    b._moveCaret,
                                                    {
                                                        args: [
                                                            0
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowRight",
                                                        "mac+ArrowRight"
                                                    ],
                                                    b._moveCaret,
                                                    {
                                                        args: [
                                                            1
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowUp",
                                                        "mac+ArrowUp"
                                                    ],
                                                    b._moveCaret,
                                                    {
                                                        args: [
                                                            2
                                                        ]
                                                    }
                                                ],
                                                [
                                                    [
                                                        "ArrowDown",
                                                        "mac+ArrowDown"
                                                    ],
                                                    b._moveCaret,
                                                    {
                                                        args: [
                                                            3
                                                        ]
                                                    }
                                                ]
                                            ]));
                                        }
                                    },
                                    {
                                        key: "defaultPropertiesToUpdate",
                                        get: function() {
                                            return [
                                                [
                                                    pa.HIGHLIGHT_DEFAULT_COLOR,
                                                    f._defaultColor
                                                ],
                                                [
                                                    pa.HIGHLIGHT_THICKNESS,
                                                    f._defaultThickness
                                                ]
                                            ];
                                        }
                                    }
                                ]);
                            }(wa);
                            Ra._defaultColor = null;
                            Ra._defaultOpacity = 1;
                            Ra._defaultThickness = 12;
                            Ra._type = "highlight";
                            Ra._editorType = sa.HIGHLIGHT;
                            Ra._freeHighlightId = -1;
                            Ra._freeHighlight = null;
                            Ra._freeHighlightClipId = "";
                            var pb = function(g) {
                                function f(b) {
                                    var c = g.call(this, Object.assign({}, b, {
                                        name: "inkEditor"
                                    })) || this;
                                    c.__baseHeight = 0;
                                    c.__baseWidth = 0;
                                    c.__canvasContextMenuTimeoutId = null;
                                    c.__currentPath2D = new Path2D;
                                    c.__disableEditing = !1;
                                    c.__drawingAC = null;
                                    c.__hasSomethingToDraw = !1;
                                    c.__isCanvasInitialized = !1;
                                    c.__observer = null;
                                    c.__pointerdownAC = null;
                                    c.__realWidth = 0;
                                    c.__realHeight = 0;
                                    c.__requestFrameCallback = null;
                                    c.color = b.color || null;
                                    c.thickness = b.thickness || null;
                                    c.opacity = b.opacity || null;
                                    c.paths = [];
                                    c.bezierPath2D = [];
                                    c.allRawPaths = [];
                                    c.currentPath = [];
                                    c.scaleFactor = 1;
                                    c.translationX = c.translationY = 0;
                                    c.x = 0;
                                    c.y = 0;
                                    c._willKeepAspectRatio = !0;
                                    return c;
                                }
                                cg(f, g);
                                f.initialize = function(b, c) {
                                    wa.initialize(b, c);
                                };
                                f.updateDefaultParams = function(b, c) {
                                    switch(b){
                                        case pa.INK_THICKNESS:
                                            f._defaultThickness = c;
                                            break;
                                        case pa.INK_COLOR:
                                            f._defaultColor = c;
                                            break;
                                        case pa.INK_OPACITY:
                                            f._defaultOpacity = c / 100;
                                    }
                                };
                                var a = f.prototype;
                                a.updateParams = function(b, c) {
                                    switch(b){
                                        case pa.INK_THICKNESS:
                                            this.__updateThickness(c);
                                            break;
                                        case pa.INK_COLOR:
                                            this.__updateColor(c);
                                            break;
                                        case pa.INK_OPACITY:
                                            this.__updateOpacity(c);
                                    }
                                };
                                a.__updateThickness = function(b) {
                                    function c(h) {
                                        d.thickness = h;
                                        d.__fitToContent();
                                    }
                                    var d = this, e = this.thickness;
                                    this.addCommands({
                                        cmd: c.bind(this, b),
                                        undo: c.bind(this, e),
                                        post: this._uiManager.updateUI.bind(this._uiManager, this),
                                        mustExec: !0,
                                        type: pa.INK_THICKNESS,
                                        overwriteIfSameType: !0,
                                        keepUndo: !0
                                    });
                                };
                                a.__updateColor = function(b) {
                                    function c(h) {
                                        d.color = h;
                                        d.__redraw();
                                    }
                                    var d = this, e = this.color;
                                    this.addCommands({
                                        cmd: c.bind(this, b),
                                        undo: c.bind(this, e),
                                        post: this._uiManager.updateUI.bind(this._uiManager, this),
                                        mustExec: !0,
                                        type: pa.INK_COLOR,
                                        overwriteIfSameType: !0,
                                        keepUndo: !0
                                    });
                                };
                                a.__updateOpacity = function(b) {
                                    function c(h) {
                                        d.opacity = h;
                                        d.__redraw();
                                    }
                                    var d = this, e = this.opacity;
                                    this.addCommands({
                                        cmd: c.bind(this, b / 100),
                                        undo: c.bind(this, e),
                                        post: this._uiManager.updateUI.bind(this._uiManager, this),
                                        mustExec: !0,
                                        type: pa.INK_OPACITY,
                                        overwriteIfSameType: !0,
                                        keepUndo: !0
                                    });
                                };
                                a.rebuild = function() {
                                    this.parent && (g.prototype.rebuild.call(this), null !== this.div && (this.canvas || (this.__createCanvas(), this.__createObserver()), this.isAttachedToDOM || (this.parent.add(this), this.__setCanvasDims()), this.__fitToContent()));
                                };
                                a.remove = function() {
                                    var b;
                                    null !== this.canvas && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, this.__canvasContextMenuTimeoutId && (clearTimeout(this.__canvasContextMenuTimeoutId), this.__canvasContextMenuTimeoutId = null), null == (b = this.__observer) || b.disconnect(), this.__observer = null, g.prototype.remove.call(this));
                                };
                                a.setParent = function(b) {
                                    !this.parent && b ? this._uiManager.removeShouldRescale(this) : this.parent && null === b && this._uiManager.addShouldRescale(this);
                                    g.prototype.setParent.call(this, b);
                                };
                                a.onScaleChanging = function() {
                                    var b = p.makeIterator(this.parentDimensions), c = b.next().value;
                                    b = b.next().value;
                                    this.setDimensions(this.width * c, this.height * b);
                                };
                                a.enableEditMode = function() {
                                    this.__disableEditing || null === this.canvas || (g.prototype.enableEditMode.call(this), this._isDraggable = !1, this.__addPointerdownListener());
                                };
                                a.disableEditMode = function() {
                                    this.isInEditMode() && null !== this.canvas && (g.prototype.disableEditMode.call(this), this._isDraggable = !this.isEmpty(), this.div.classList.remove("editing"), this.__removePointerdownListener());
                                };
                                a.onceAdded = function() {
                                    this._isDraggable = !this.isEmpty();
                                };
                                a.isEmpty = function() {
                                    return 0 === this.paths.length || 1 === this.paths.length && 0 === this.paths[0].length;
                                };
                                a.__getInitialBBox = function() {
                                    var b = this.parentRotation, c = p.makeIterator(this.parentDimensions), d = c.next().value;
                                    c = c.next().value;
                                    switch(b){
                                        case 90:
                                            return [
                                                0,
                                                c,
                                                c,
                                                d
                                            ];
                                        case 180:
                                            return [
                                                d,
                                                c,
                                                d,
                                                c
                                            ];
                                        case 270:
                                            return [
                                                d,
                                                0,
                                                c,
                                                d
                                            ];
                                        default:
                                            return [
                                                0,
                                                0,
                                                d,
                                                c
                                            ];
                                    }
                                };
                                a.__setStroke = function() {
                                    var b = this.ctx, c = this.color, d = this.opacity;
                                    b.lineWidth = this.thickness * this.parentScale / this.scaleFactor;
                                    b.lineCap = "round";
                                    b.lineJoin = "round";
                                    b.miterLimit = 10;
                                    b.strokeStyle = "" + c + Math.round(Math.min(255, Math.max(1, 255 * d))).toString(16).padStart(2, "0");
                                };
                                a.__startDrawing = function(b, c) {
                                    var d = this;
                                    this.canvas.addEventListener("contextmenu", Ma, {
                                        signal: this._uiManager._signal
                                    });
                                    this.__removePointerdownListener();
                                    this.__drawingAC = new AbortController;
                                    var e = this._uiManager.combinedSignal(this.__drawingAC);
                                    this.canvas.addEventListener("pointerleave", this.canvasPointerleave.bind(this), {
                                        signal: e
                                    });
                                    this.canvas.addEventListener("pointermove", this.canvasPointermove.bind(this), {
                                        signal: e
                                    });
                                    this.canvas.addEventListener("pointerup", this.canvasPointerup.bind(this), {
                                        signal: e
                                    });
                                    this.isEditing = !0;
                                    if (!this.__isCanvasInitialized) {
                                        var h;
                                        this.__isCanvasInitialized = !0;
                                        this.__setCanvasDims();
                                        this.thickness || (this.thickness = f._defaultThickness);
                                        this.color || (this.color = f._defaultColor || wa._defaultLineColor);
                                        null != (h = this.opacity) ? h : this.opacity = f._defaultOpacity;
                                    }
                                    this.currentPath.push([
                                        b,
                                        c
                                    ]);
                                    this.__hasSomethingToDraw = !1;
                                    this.__setStroke();
                                    this.__requestFrameCallback = function() {
                                        d.__drawPoints();
                                        d.__requestFrameCallback && window.requestAnimationFrame(d.__requestFrameCallback);
                                    };
                                    window.requestAnimationFrame(this.__requestFrameCallback);
                                };
                                a.__draw = function(b, c) {
                                    var d = p.makeIterator(this.currentPath.at(-1)), e = d.next().value;
                                    d = d.next().value;
                                    1 < this.currentPath.length && b === e && c === d || (e = this.currentPath, d = this.__currentPath2D, e.push([
                                        b,
                                        c
                                    ]), this.__hasSomethingToDraw = !0, 2 >= e.length ? (d.moveTo.apply(d, p.arrayFromIterable(e[0])), d.lineTo(b, c)) : (3 === e.length && (this.__currentPath2D = d = new Path2D, d.moveTo.apply(d, p.arrayFromIterable(e[0]))), this.__makeBezierCurve.apply(this, [
                                        d
                                    ].concat(p.arrayFromIterable(e.at(-3)), p.arrayFromIterable(e.at(-2)), [
                                        b,
                                        c
                                    ]))));
                                };
                                a.__endPath = function() {
                                    if (0 !== this.currentPath.length) {
                                        var b = this.currentPath.at(-1);
                                        this.__currentPath2D.lineTo.apply(this.__currentPath2D, p.arrayFromIterable(b));
                                    }
                                };
                                a.__stopDrawing = function(b, c) {
                                    var d = this;
                                    this.__requestFrameCallback = null;
                                    b = Math.min(Math.max(b, 0), this.canvas.width);
                                    c = Math.min(Math.max(c, 0), this.canvas.height);
                                    this.__draw(b, c);
                                    this.__endPath();
                                    if (1 !== this.currentPath.length) var e = this.__generateBezierPoints();
                                    else b = [
                                        b,
                                        c
                                    ], e = [
                                        [
                                            b,
                                            b.slice(),
                                            b.slice(),
                                            b
                                        ]
                                    ];
                                    var h = this.__currentPath2D, k = this.currentPath;
                                    this.currentPath = [];
                                    this.__currentPath2D = new Path2D;
                                    this.addCommands({
                                        cmd: function() {
                                            d.allRawPaths.push(k);
                                            d.paths.push(e);
                                            d.bezierPath2D.push(h);
                                            d._uiManager.rebuild(d);
                                        },
                                        undo: function() {
                                            d.allRawPaths.pop();
                                            d.paths.pop();
                                            d.bezierPath2D.pop();
                                            0 === d.paths.length ? d.remove() : (d.canvas || (d.__createCanvas(), d.__createObserver()), d.__fitToContent());
                                        },
                                        mustExec: !0
                                    });
                                };
                                a.__drawPoints = function() {
                                    if (this.__hasSomethingToDraw) {
                                        this.__hasSomethingToDraw = !1;
                                        var b = this.currentPath.slice(-3), c = b.map(function(e) {
                                            return e[0];
                                        });
                                        b = b.map(function(e) {
                                            return e[1];
                                        });
                                        Math.min.apply(Math, p.arrayFromIterable(c));
                                        Math.max.apply(Math, p.arrayFromIterable(c));
                                        Math.min.apply(Math, p.arrayFromIterable(b));
                                        Math.max.apply(Math, p.arrayFromIterable(b));
                                        c = this.ctx;
                                        c.save();
                                        c.clearRect(0, 0, this.canvas.width, this.canvas.height);
                                        b = p.makeIterator(this.bezierPath2D);
                                        for(var d = b.next(); !d.done; d = b.next())c.stroke(d.value);
                                        c.stroke(this.__currentPath2D);
                                        c.restore();
                                    }
                                };
                                a.__makeBezierCurve = function(b, c, d, e, h, k, l) {
                                    c = (c + e) / 2;
                                    d = (d + h) / 2;
                                    k = (e + k) / 2;
                                    l = (h + l) / 2;
                                    b.bezierCurveTo(c + 2 * (e - c) / 3, d + 2 * (h - d) / 3, k + 2 * (e - k) / 3, l + 2 * (h - l) / 3, k, l);
                                };
                                a.__generateBezierPoints = function() {
                                    var b = this.currentPath;
                                    if (2 >= b.length) return [
                                        [
                                            b[0],
                                            b[0],
                                            b.at(-1),
                                            b.at(-1)
                                        ]
                                    ];
                                    var c = [], d, e = p.makeIterator(b[0]), h = e.next().value;
                                    e = e.next().value;
                                    for(d = 1; d < b.length - 2; d++){
                                        var k = p.makeIterator(b[d]), l = k.next().value;
                                        k = k.next().value;
                                        var m = p.makeIterator(b[d + 1]), n = m.next().value;
                                        m = m.next().value;
                                        n = (l + n) / 2;
                                        m = (k + m) / 2;
                                        c.push([
                                            [
                                                h,
                                                e
                                            ],
                                            [
                                                h + 2 * (l - h) / 3,
                                                e + 2 * (k - e) / 3
                                            ],
                                            [
                                                n + 2 * (l - n) / 3,
                                                m + 2 * (k - m) / 3
                                            ],
                                            [
                                                n,
                                                m
                                            ]
                                        ]);
                                        e = p.makeIterator([
                                            n,
                                            m
                                        ]);
                                        h = e.next().value;
                                        e = e.next().value;
                                    }
                                    k = p.makeIterator(b[d]);
                                    l = k.next().value;
                                    k = k.next().value;
                                    d = p.makeIterator(b[d + 1]);
                                    b = d.next().value;
                                    d = d.next().value;
                                    c.push([
                                        [
                                            h,
                                            e
                                        ],
                                        [
                                            h + 2 * (l - h) / 3,
                                            e + 2 * (k - e) / 3
                                        ],
                                        [
                                            b + 2 * (l - b) / 3,
                                            d + 2 * (k - d) / 3
                                        ],
                                        [
                                            b,
                                            d
                                        ]
                                    ]);
                                    return c;
                                };
                                a.__redraw = function() {
                                    if (this.isEmpty()) this.__updateTransform();
                                    else {
                                        this.__setStroke();
                                        var b = this.canvas, c = this.ctx;
                                        c.setTransform(1, 0, 0, 1, 0, 0);
                                        c.clearRect(0, 0, b.width, b.height);
                                        this.__updateTransform();
                                        b = p.makeIterator(this.bezierPath2D);
                                        for(var d = b.next(); !d.done; d = b.next())c.stroke(d.value);
                                    }
                                };
                                a.commit = function() {
                                    this.__disableEditing || (g.prototype.commit.call(this), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), this.__disableEditing = !0, this.div.classList.add("disabled"), this.__fitToContent(!0), this.select(), this.parent.addInkEditorIfNeeded(!0), this.moveInDOM(), this.div.focus({
                                        preventScroll: !0
                                    }));
                                };
                                a.focusin = function(b) {
                                    this._focusEventsAllowed && (g.prototype.focusin.call(this, b), this.enableEditMode());
                                };
                                a.__addPointerdownListener = function() {
                                    if (!this.__pointerdownAC) {
                                        this.__pointerdownAC = new AbortController;
                                        var b = this._uiManager.combinedSignal(this.__pointerdownAC);
                                        this.canvas.addEventListener("pointerdown", this.canvasPointerdown.bind(this), {
                                            signal: b
                                        });
                                    }
                                };
                                a.__removePointerdownListener = function() {
                                    var b;
                                    null == (b = this.pointerdownAC) || b.abort();
                                    this.pointerdownAC = null;
                                };
                                a.canvasPointerdown = function(b) {
                                    0 === b.button && this.isInEditMode() && !this.__disableEditing && (this.setInForeground(), b.preventDefault(), this.div.contains(document.activeElement) || this.div.focus({
                                        preventScroll: !0
                                    }), this.__startDrawing(b.offsetX, b.offsetY));
                                };
                                a.canvasPointermove = function(b) {
                                    b.preventDefault();
                                    this.__draw(b.offsetX, b.offsetY);
                                };
                                a.canvasPointerup = function(b) {
                                    b.preventDefault();
                                    this.__endDrawing(b);
                                };
                                a.canvasPointerleave = function(b) {
                                    this.__endDrawing(b);
                                };
                                a.__endDrawing = function(b) {
                                    var c = this, d;
                                    null == (d = this.__drawingAC) || d.abort();
                                    this.__drawingAC = null;
                                    this.__addPointerdownListener();
                                    this.__canvasContextMenuTimeoutId && clearTimeout(this.__canvasContextMenuTimeoutId);
                                    this.__canvasContextMenuTimeoutId = setTimeout(function() {
                                        c.__canvasContextMenuTimeoutId = null;
                                        c.canvas.removeEventListener("contextmenu", Ma);
                                    }, 10);
                                    this.__stopDrawing(b.offsetX, b.offsetY);
                                    this.addToAnnotationStorage();
                                    this.setInBackground();
                                };
                                a.__createCanvas = function() {
                                    this.canvas = document.createElement("canvas");
                                    this.canvas.width = this.canvas.height = 0;
                                    this.canvas.className = "inkEditorCanvas";
                                    this.canvas.setAttribute("data-l10n-id", "pdfjs-ink-canvas");
                                    this.div.append(this.canvas);
                                    this.ctx = this.canvas.getContext("2d");
                                };
                                a.__createObserver = function() {
                                    var b = this;
                                    this.__observer = new ResizeObserver(function(c) {
                                        c = c[0].contentRect;
                                        c.width && c.height && b.setDimensions(c.width, c.height);
                                    });
                                    this.__observer.observe(this.div);
                                    this._uiManager._signal.addEventListener("abort", function() {
                                        var c;
                                        null == (c = b.__observer) || c.disconnect();
                                        b.__observer = null;
                                    }, {
                                        once: !0
                                    });
                                };
                                a.render = function() {
                                    if (this.div) return this.div;
                                    if (this.width) {
                                        var b = this.x;
                                        var c = this.y;
                                    }
                                    g.prototype.render.call(this);
                                    this.div.setAttribute("data-l10n-id", "pdfjs-ink");
                                    var d = p.makeIterator(this.__getInitialBBox()), e = d.next().value, h = d.next().value, k = d.next().value;
                                    d = d.next().value;
                                    this.setAt(e, h, 0, 0);
                                    this.setDims(k, d);
                                    this.__createCanvas();
                                    this.width ? (h = p.makeIterator(this.parentDimensions), e = h.next().value, h = h.next().value, this.setAspectRatio(this.width * e, this.height * h), this.setAt(b * e, c * h, this.width * e, this.height * h), this.__isCanvasInitialized = !0, this.__setCanvasDims(), this.setDims(this.width * e, this.height * h), this.__redraw(), this.div.classList.add("disabled")) : (this.div.classList.add("editing"), this.enableEditMode());
                                    this.__createObserver();
                                    return this.div;
                                };
                                a.__setCanvasDims = function() {
                                    if (this.__isCanvasInitialized) {
                                        var b = p.makeIterator(this.parentDimensions), c = b.next().value;
                                        b = b.next().value;
                                        this.canvas.width = Math.ceil(this.width * c);
                                        this.canvas.height = Math.ceil(this.height * b);
                                        this.__updateTransform();
                                    }
                                };
                                a.setDimensions = function(b, c) {
                                    var d = Math.round(b), e = Math.round(c);
                                    if (this.__realWidth !== d || this.__realHeight !== e) this.__realWidth = d, this.__realHeight = e, this.canvas.style.visibility = "hidden", e = p.makeIterator(this.parentDimensions), d = e.next().value, e = e.next().value, this.width = b / d, this.height = c / e, this.fixAndSetPosition(), this.__disableEditing && this.__setScaleFactor(b, c), this.__setCanvasDims(), this.__redraw(), this.canvas.style.visibility = "visible", this.fixDims();
                                };
                                a.__setScaleFactor = function(b, c) {
                                    var d = this.__getPadding();
                                    this.scaleFactor = Math.min((b - d) / this.__baseWidth, (c - d) / this.__baseHeight);
                                };
                                a.__updateTransform = function() {
                                    var b = this.__getPadding() / 2;
                                    this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + b, this.translationY * this.scaleFactor + b);
                                };
                                f.__buildPath2D = function(b) {
                                    for(var c = new Path2D, d = 0, e = b.length; d < e; d++){
                                        var h = p.makeIterator(b[d]), k = h.next().value, l = h.next().value, m = h.next().value;
                                        h = h.next().value;
                                        0 === d && c.moveTo.apply(c, p.arrayFromIterable(k));
                                        c.bezierCurveTo(l[0], l[1], m[0], m[1], h[0], h[1]);
                                    }
                                    return c;
                                };
                                f.__toPDFCoordinates = function(b, c, d) {
                                    var e = p.makeIterator(c);
                                    c = e.next().value;
                                    var h = e.next().value, k = e.next().value;
                                    e = e.next().value;
                                    switch(d){
                                        case 0:
                                            h = 0;
                                            for(k = b.length; h < k; h += 2)b[h] += c, b[h + 1] = e - b[h + 1];
                                            break;
                                        case 90:
                                            k = 0;
                                            for(e = b.length; k < e; k += 2)d = b[k], b[k] = b[k + 1] + c, b[k + 1] = d + h;
                                            break;
                                        case 180:
                                            c = 0;
                                            for(e = b.length; c < e; c += 2)b[c] = k - b[c], b[c + 1] += h;
                                            break;
                                        case 270:
                                            c = 0;
                                            for(h = b.length; c < h; c += 2)d = b[c], b[c] = k - b[c + 1], b[c + 1] = e - d;
                                            break;
                                        default:
                                            throw Error("Invalid rotation");
                                    }
                                    return b;
                                };
                                f.__fromPDFCoordinates = function(b, c, d) {
                                    var e = p.makeIterator(c);
                                    c = e.next().value;
                                    var h = e.next().value, k = e.next().value;
                                    e = e.next().value;
                                    switch(d){
                                        case 0:
                                            h = 0;
                                            for(k = b.length; h < k; h += 2)b[h] -= c, b[h + 1] = e - b[h + 1];
                                            break;
                                        case 90:
                                            k = 0;
                                            for(e = b.length; k < e; k += 2)d = b[k], b[k] = b[k + 1] - h, b[k + 1] = d - c;
                                            break;
                                        case 180:
                                            c = 0;
                                            for(e = b.length; c < e; c += 2)b[c] = k - b[c], b[c + 1] -= h;
                                            break;
                                        case 270:
                                            c = 0;
                                            for(h = b.length; c < h; c += 2)d = b[c], b[c] = e - b[c + 1], b[c + 1] = k - d;
                                            break;
                                        default:
                                            throw Error("Invalid rotation");
                                    }
                                    return b;
                                };
                                a.__serializePaths = function(b, c, d, e) {
                                    var h = [], k = this.thickness / 2;
                                    c = b * c + k;
                                    d = b * d + k;
                                    k = p.makeIterator(this.paths);
                                    for(var l = k.next(); !l.done; l = k.next()){
                                        var m = l.value;
                                        l = [];
                                        for(var n = [], q = 0, r = m.length; q < r; q++){
                                            var t = p.makeIterator(m[q]), u = t.next().value, v = t.next().value, w = t.next().value, x = t.next().value;
                                            if (u[0] === x[0] && u[1] === x[1] && 1 === r) {
                                                m = b * u[0] + c;
                                                q = b * u[1] + d;
                                                l.push(m, q);
                                                n.push(m, q);
                                                break;
                                            }
                                            t = b * u[0] + c;
                                            u = b * u[1] + d;
                                            var B = b * v[0] + c;
                                            v = b * v[1] + d;
                                            var z = b * w[0] + c;
                                            w = b * w[1] + d;
                                            var C = b * x[0] + c;
                                            x = b * x[1] + d;
                                            0 === q && (l.push(t, u), n.push(t, u));
                                            l.push(B, v, z, w, C, x);
                                            n.push(B, v);
                                            q === r - 1 && n.push(C, x);
                                        }
                                        h.push({
                                            bezier: f.__toPDFCoordinates(l, e, this.rotation),
                                            points: f.__toPDFCoordinates(n, e, this.rotation)
                                        });
                                    }
                                    return h;
                                };
                                a.__getBbox = function() {
                                    for(var b = Infinity, c = -Infinity, d = Infinity, e = -Infinity, h = p.makeIterator(this.paths), k = h.next(); !k.done; k = h.next()){
                                        k = p.makeIterator(k.value);
                                        for(var l = k.next(); !l.done; l = k.next()){
                                            var m = p.makeIterator(l.value);
                                            l = m.next().value;
                                            var n = m.next().value, q = m.next().value;
                                            m = m.next().value;
                                            l = fa.bezierBoundingBox.apply(fa, [].concat(p.arrayFromIterable(l), p.arrayFromIterable(n), p.arrayFromIterable(q), p.arrayFromIterable(m)));
                                            b = Math.min(b, l[0]);
                                            d = Math.min(d, l[1]);
                                            c = Math.max(c, l[2]);
                                            e = Math.max(e, l[3]);
                                        }
                                    }
                                    return [
                                        b,
                                        d,
                                        c,
                                        e
                                    ];
                                };
                                a.__getPadding = function() {
                                    return this.__disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
                                };
                                a.__fitToContent = function(b) {
                                    void 0 === b && (b = !1);
                                    if (!this.isEmpty()) {
                                        if (this.__disableEditing) {
                                            var c = this.__getBbox(), d = this.__getPadding();
                                            this.__baseWidth = Math.max(wa.MIN_SIZE, c[2] - c[0]);
                                            this.__baseHeight = Math.max(wa.MIN_SIZE, c[3] - c[1]);
                                            var e = Math.ceil(d + this.__baseWidth * this.scaleFactor), h = Math.ceil(d + this.__baseHeight * this.scaleFactor), k = p.makeIterator(this.parentDimensions), l = k.next().value;
                                            k = k.next().value;
                                            this.width = e / l;
                                            this.height = h / k;
                                            this.setAspectRatio(e, h);
                                            l = this.translationX;
                                            k = this.translationY;
                                            this.translationX = -c[0];
                                            this.translationY = -c[1];
                                            this.__setCanvasDims();
                                            this.__redraw();
                                            this.__realWidth = e;
                                            this.__realHeight = h;
                                            this.setDims(e, h);
                                            b = b ? d / this.scaleFactor / 2 : 0;
                                            this.translate(l - this.translationX - b, k - this.translationY - b);
                                        } else this.__redraw();
                                    }
                                };
                                f.deserialize = function() {
                                    var b = ag(function k(d, e, h) {
                                        var l = this, m, n, q, r, t, u, v, w, x, B, z, C, D, H, J, M, I, P, L, T, aa, ba, ra, X, ma, U, K, N, V, ea;
                                        return p.generator.createGenerator(k, function(ia) {
                                            if (1 == ia.nextAddress) return d instanceof Vc ? ia.return(null) : ia.yield(g.deserialize.call(l, d, e, h), 2);
                                            m = ia.yieldResult;
                                            m.thickness = d.thickness;
                                            m.color = fa.makeHexColor.apply(fa, p.arrayFromIterable(d.color));
                                            m.opacity = d.opacity;
                                            n = p.makeIterator(m.pageDimensions);
                                            q = n.next().value;
                                            r = n.next().value;
                                            t = m.width * q;
                                            u = m.height * r;
                                            v = m.parentScale;
                                            w = d.thickness / 2;
                                            m.__disableEditing = !0;
                                            m.__realWidth = Math.round(t);
                                            m.__realHeight = Math.round(u);
                                            x = d;
                                            B = x.paths;
                                            z = x.rect;
                                            C = x.rotation;
                                            D = p.makeIterator(B);
                                            for(H = D.next(); !H.done; H = D.next()){
                                                M = J = H.value;
                                                I = M.bezier;
                                                I = f.__fromPDFCoordinates(I, z, C);
                                                P = [];
                                                m.paths.push(P);
                                                L = v * (I[0] - w);
                                                T = v * (I[1] - w);
                                                aa = 2;
                                                for(ba = I.length; aa < ba; aa += 6)ra = v * (I[aa] - w), X = v * (I[aa + 1] - w), ma = v * (I[aa + 2] - w), U = v * (I[aa + 3] - w), K = v * (I[aa + 4] - w), N = v * (I[aa + 5] - w), P.push([
                                                    [
                                                        L,
                                                        T
                                                    ],
                                                    [
                                                        ra,
                                                        X
                                                    ],
                                                    [
                                                        ma,
                                                        U
                                                    ],
                                                    [
                                                        K,
                                                        N
                                                    ]
                                                ]), L = K, T = N;
                                                V = l.__buildPath2D(P);
                                                m.bezierPath2D.push(V);
                                            }
                                            ea = m.__getBbox();
                                            m.__baseWidth = Math.max(wa.MIN_SIZE, ea[2] - ea[0]);
                                            m.__baseHeight = Math.max(wa.MIN_SIZE, ea[3] - ea[1]);
                                            m.__setScaleFactor(t, u);
                                            return ia.return(m);
                                        });
                                    });
                                    return function(d, e, h) {
                                        return b.apply(this, arguments);
                                    };
                                }();
                                a.serialize = function() {
                                    if (this.isEmpty()) return null;
                                    var b = this.getRect(0, 0), c = wa._colorManager.convert(this.ctx.strokeStyle);
                                    return {
                                        annotationType: sa.INK,
                                        color: c,
                                        thickness: this.thickness,
                                        opacity: this.opacity,
                                        paths: this.__serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, b),
                                        pageIndex: this.pageIndex,
                                        rect: b,
                                        rotation: this.rotation,
                                        structTreeParentId: this._structTreeParentId
                                    };
                                };
                                return bg(f, [
                                    {
                                        key: "propertiesToUpdate",
                                        get: function() {
                                            var b;
                                            return [
                                                [
                                                    pa.INK_THICKNESS,
                                                    this.thickness || f._defaultThickness
                                                ],
                                                [
                                                    pa.INK_COLOR,
                                                    this.color || f._defaultColor || wa._defaultLineColor
                                                ],
                                                [
                                                    pa.INK_OPACITY,
                                                    Math.round(100 * (null != (b = this.opacity) ? b : f._defaultOpacity))
                                                ]
                                            ];
                                        }
                                    },
                                    {
                                        key: "isResizable",
                                        get: function() {
                                            return !this.isEmpty() && this.__disableEditing;
                                        }
                                    }
                                ], [
                                    {
                                        key: "defaultPropertiesToUpdate",
                                        get: function() {
                                            return [
                                                [
                                                    pa.INK_THICKNESS,
                                                    f._defaultThickness
                                                ],
                                                [
                                                    pa.INK_COLOR,
                                                    f._defaultColor || wa._defaultLineColor
                                                ],
                                                [
                                                    pa.INK_OPACITY,
                                                    Math.round(100 * f._defaultOpacity)
                                                ]
                                            ];
                                        }
                                    }
                                ]);
                            }(wa);
                            pb._defaultColor = null;
                            pb._defaultOpacity = 1;
                            pb._defaultThickness = 1;
                            pb._type = "ink";
                            pb._editorType = sa.INK;
                            var Xc = function(g) {
                                function f(b) {
                                    var c = g.call(this, Object.assign({}, b, {
                                        name: "stampEditor"
                                    })) || this;
                                    c.__bitmap = null;
                                    c.__bitmapId = null;
                                    c.__bitmapPromise = null;
                                    c.__bitmapFileName = "";
                                    c.__canvas = null;
                                    c.__observer = null;
                                    c.__resizeTimeoutId = null;
                                    c.__isSvg = !1;
                                    c.__hasBeenAddedInUndoStack = !1;
                                    c.__bitmapUrl = b.bitmapUrl;
                                    c.__bitmapFile = b.bitmapFile;
                                    return c;
                                }
                                eg(f, g);
                                f.initialize = function(b, c) {
                                    wa.initialize(b, c);
                                };
                                f.isHandlingMimeForPasting = function(b) {
                                    return this.supportedTypes.includes(b);
                                };
                                f.paste = function(b, c) {
                                    c.pasteEditor(sa.STAMP, {
                                        bitmapFile: b.getAsFile()
                                    });
                                };
                                var a = f.prototype;
                                a.altTextFinish = function() {
                                    this._uiManager.useNewAltTextFlow && (this.div.hidden = !1);
                                    g.prototype.altTextFinish.call(this);
                                };
                                f.computeTelemetryFinalData = function(b) {
                                    var c, d;
                                    b = b.get("hasAltText");
                                    return {
                                        hasAltText: null != (c = b.get(!0)) ? c : 0,
                                        hasNoAltText: null != (d = b.get(!1)) ? d : 0
                                    };
                                };
                                a.__getBitmapFetched = function(b, c) {
                                    void 0 === c && (c = !1);
                                    b ? (this.__bitmap = b.bitmap, c || (this.__bitmapId = b.id, this.__isSvg = b.isSvg), b.file && (this.__bitmapFileName = b.file.name), this.__createCanvas()) : this.remove();
                                };
                                a.__getBitmapDone = function() {
                                    this.__bitmapPromise = null;
                                    this._uiManager.enableWaiting(!1);
                                    if (this.__canvas) {
                                        if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.__bitmap) this._editToolbar.hide(), this._uiManager.editAltText(this, !0);
                                        else {
                                            if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.__bitmap) {
                                                this._reportTelemetry({
                                                    action: "pdfjs.image.image_added",
                                                    data: {
                                                        alt_text_modal: !1,
                                                        alt_text_type: "empty"
                                                    }
                                                });
                                                try {
                                                    this.mlGuessAltText();
                                                } catch (b) {}
                                            }
                                            this.div.focus();
                                        }
                                    }
                                };
                                a.mlGuessAltText = function() {
                                    var b = Fc(function h(d, e) {
                                        var k = this, l, m, n, q, r, t, u, v;
                                        return p.generator.createGenerator(h, function(w) {
                                            switch(w.nextAddress){
                                                case 1:
                                                    void 0 === d && (d = null);
                                                    void 0 === e && (e = !0);
                                                    if (k.hasAltTextData()) return w.return(null);
                                                    l = k._uiManager;
                                                    m = l.mlManager;
                                                    if (!m) throw Error("No ML.");
                                                    return w.yield(m.isEnabledFor("altText"), 2);
                                                case 2:
                                                    if (!w.yieldResult) throw Error("ML isn't enabled for alt text.");
                                                    n = d || k.copyCanvas(null, null, !0).imageData;
                                                    q = n.data;
                                                    r = n.width;
                                                    t = n.height;
                                                    return w.yield(m.guess({
                                                        name: "altText",
                                                        request: {
                                                            data: q,
                                                            width: r,
                                                            height: t,
                                                            channels: q.length / (r * t)
                                                        }
                                                    }), 3);
                                                case 3:
                                                    u = w.yieldResult;
                                                    if (!u) throw Error("No response from the AI service.");
                                                    if (u.error) throw Error("Error from the AI service.");
                                                    if (u.cancel) return w.return(null);
                                                    if (!u.output) throw Error("No valid response from the AI service.");
                                                    v = u.output;
                                                    return w.yield(k.setGuessedAltText(v), 4);
                                                case 4:
                                                    return e && !k.hasAltTextData() && (k.altTextData = {
                                                        alt: v,
                                                        decorative: !1
                                                    }), w.return(v);
                                            }
                                        });
                                    });
                                    return function(d, e) {
                                        return b.apply(this, arguments);
                                    };
                                }();
                                a.__getBitmap = function() {
                                    var b = this, c = this;
                                    if (this.__bitmapId) this._uiManager.enableWaiting(!0), this._uiManager.imageManager.getFromId(this.__bitmapId).then(function(k) {
                                        return b.__getBitmapFetched(k, !0);
                                    }).finally(function() {
                                        return b.__getBitmapDone();
                                    });
                                    else if (this.__bitmapUrl) {
                                        var d = this.__bitmapUrl;
                                        this.__bitmapUrl = null;
                                        this._uiManager.enableWaiting(!0);
                                        this.__bitmapPromise = this._uiManager.imageManager.getFromUrl(d).then(function(k) {
                                            return b.__getBitmapFetched(k);
                                        }).finally(function() {
                                            return b.__getBitmapDone();
                                        });
                                    } else if (this.__bitmapFile) d = this.__bitmapFile, this.__bitmapFile = null, this._uiManager.enableWaiting(!0), this.__bitmapPromise = this._uiManager.imageManager.getFromFile(d).then(function(k) {
                                        return b.__getBitmapFetched(k);
                                    }).finally(function() {
                                        return b.__getBitmapDone();
                                    });
                                    else {
                                        var e = document.createElement("input");
                                        e.type = "file";
                                        e.accept = f.supportedTypesStr;
                                        var h = this._uiManager._signal;
                                        this.__bitmapPromise = new Promise(function(k) {
                                            e.addEventListener("change", Fc(function m() {
                                                var n;
                                                return p.generator.createGenerator(m, function(q) {
                                                    if (1 == q.nextAddress) {
                                                        if (!e.files || 0 === e.files.length) return c.remove(), q.jumpTo(2);
                                                        c._uiManager.enableWaiting(!0);
                                                        return q.yield(c._uiManager.imageManager.getFromFile(e.files[0]), 3);
                                                    }
                                                    2 != q.nextAddress && (n = q.yieldResult, c._reportTelemetry({
                                                        action: "pdfjs.image.image_selected",
                                                        data: {
                                                            alt_text_modal: c._uiManager.useNewAltTextFlow
                                                        }
                                                    }), c.__getBitmapFetched(n));
                                                    k();
                                                    q.jumpToEnd();
                                                });
                                            }), {
                                                signal: h
                                            });
                                            e.addEventListener("cancel", function() {
                                                b.remove();
                                                k();
                                            }, {
                                                signal: h
                                            });
                                        }).finally(function() {
                                            return b.__getBitmapDone();
                                        });
                                        e.click();
                                    }
                                };
                                a.remove = function() {
                                    if (this.__bitmapId) {
                                        var b, c;
                                        this.__bitmap = null;
                                        this._uiManager.imageManager.deleteId(this.__bitmapId);
                                        null == (b = this.__canvas) || b.remove();
                                        this.__canvas = null;
                                        null == (c = this.__observer) || c.disconnect();
                                        this.__observer = null;
                                        this.__resizeTimeoutId && (clearTimeout(this.__resizeTimeoutId), this.__resizeTimeoutId = null);
                                    }
                                    g.prototype.remove.call(this);
                                };
                                a.rebuild = function() {
                                    this.parent ? (g.prototype.rebuild.call(this), null !== this.div && (this.__bitmapId && null === this.__canvas && this.__getBitmap(), this.isAttachedToDOM || this.parent.add(this))) : this.__bitmapId && this.__getBitmap();
                                };
                                a.onceAdded = function() {
                                    this._isDraggable = !0;
                                    this.div.focus();
                                };
                                a.isEmpty = function() {
                                    return !(this.__bitmapPromise || this.__bitmap || this.__bitmapUrl || this.__bitmapFile || this.__bitmapId);
                                };
                                a.render = function() {
                                    if (this.div) return this.div;
                                    if (this.width) {
                                        var b = this.x;
                                        var c = this.y;
                                    }
                                    g.prototype.render.call(this);
                                    this.div.hidden = !0;
                                    this.div.setAttribute("role", "figure");
                                    this.addAltTextButton();
                                    this.__bitmap ? this.__createCanvas() : this.__getBitmap();
                                    if (this.width && !this.annotationElementId) {
                                        var d = p.makeIterator(this.parentDimensions), e = d.next().value;
                                        d = d.next().value;
                                        this.setAt(b * e, c * d, this.width * e, this.height * d);
                                    }
                                    return this.div;
                                };
                                a.__createCanvas = function() {
                                    var b = this.div, c = this.__bitmap, d = c.width;
                                    c = c.height;
                                    var e = p.makeIterator(this.pageDimensions), h = e.next().value;
                                    e = e.next().value;
                                    if (this.width) d = this.width * h, c = this.height * e;
                                    else if (d > .75 * h || c > .75 * e) {
                                        var k = Math.min(.75 * h / d, .75 * e / c);
                                        d *= k;
                                        c *= k;
                                    }
                                    var l = p.makeIterator(this.parentDimensions);
                                    k = l.next().value;
                                    l = l.next().value;
                                    this.setDims(d * k / h, c * l / e);
                                    this._uiManager.enableWaiting(!1);
                                    h = this.__canvas = document.createElement("canvas");
                                    h.setAttribute("role", "img");
                                    this.addContainer(h);
                                    this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && !this.annotationElementId || (b.hidden = !1);
                                    this.__drawBitmap(d, c);
                                    this.__createObserver();
                                    this.__hasBeenAddedInUndoStack || (this.parent.addUndoableEditor(this), this.__hasBeenAddedInUndoStack = !0);
                                    this._reportTelemetry({
                                        action: "inserted_image"
                                    });
                                    this.__bitmapFileName && h.setAttribute("aria-label", this.__bitmapFileName);
                                };
                                a.copyCanvas = function(b, c, d) {
                                    void 0 === d && (d = !1);
                                    b || (b = 224);
                                    var e = this.__bitmap, h = e.width, k = e.height, l = new Lc;
                                    e = this.__bitmap;
                                    var m = h, n = k, q = null;
                                    if (c) {
                                        if (h > c || k > c) n = Math.min(c / h, c / k), m = Math.floor(h * n), n = Math.floor(k * n);
                                        q = document.createElement("canvas");
                                        c = q.width = Math.ceil(m * l.sx);
                                        var r = q.height = Math.ceil(n * l.sy);
                                        this.__isSvg || (e = this.__scaleBitmap(c, r));
                                        var t = q.getContext("2d");
                                        t.filter = this._uiManager.hcmFilter;
                                        var u = "white", v = "#cfcfd8";
                                        "none" !== this._uiManager.hcmFilter ? v = "black" : null != window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches && (u = "#8f8f9d", v = "#42414d");
                                        var w = 15 * l.sx, x = 15 * l.sy, B = new OffscreenCanvas(2 * w, 2 * x), z = B.getContext("2d");
                                        z.fillStyle = u;
                                        z.fillRect(0, 0, 2 * w, 2 * x);
                                        z.fillStyle = v;
                                        z.fillRect(0, 0, w, x);
                                        z.fillRect(w, x, w, x);
                                        t.fillStyle = t.createPattern(B, "repeat");
                                        t.fillRect(0, 0, c, r);
                                        t.drawImage(e, 0, 0, e.width, e.height, 0, 0, c, r);
                                    }
                                    c = null;
                                    if (d) {
                                        if (l.symmetric && e.width < b && e.height < b) {
                                            var C = e.width;
                                            var D = e.height;
                                        } else if (e = this.__bitmap, h > b || k > b) D = Math.min(b / h, b / k), C = Math.floor(h * D), D = Math.floor(k * D), this.__isSvg || (e = this.__scaleBitmap(C, D));
                                        h = new OffscreenCanvas(C, D).getContext("2d", {
                                            willReadFrequently: !0
                                        });
                                        h.drawImage(e, 0, 0, e.width, e.height, 0, 0, C, D);
                                        c = {
                                            width: C,
                                            height: D,
                                            data: h.getImageData(0, 0, C, D).data
                                        };
                                    }
                                    return {
                                        canvas: q,
                                        width: m,
                                        height: n,
                                        imageData: c
                                    };
                                };
                                a.__setDimensions = function(b, c) {
                                    var d = this, e, h = p.makeIterator(this.parentDimensions), k = h.next().value;
                                    h = h.next().value;
                                    this.width = b / k;
                                    this.height = c / h;
                                    null != (e = this._initialOptions) && e.isCentered ? this.center() : this.fixAndSetPosition();
                                    this._initialOptions = null;
                                    null !== this.__resizeTimeoutId && clearTimeout(this.__resizeTimeoutId);
                                    this.__resizeTimeoutId = setTimeout(function() {
                                        d.__resizeTimeoutId = null;
                                        d.__drawBitmap(b, c);
                                    }, 200);
                                };
                                a.__scaleBitmap = function(b, c) {
                                    var d = this.__bitmap, e = d.width;
                                    d = d.height;
                                    for(var h = this.__bitmap; e > 2 * b || d > 2 * c;){
                                        var k = e, l = d;
                                        e > 2 * b && (e = 16384 <= e ? Math.floor(e / 2) - 1 : Math.ceil(e / 2));
                                        d > 2 * c && (d = 16384 <= d ? Math.floor(d / 2) - 1 : Math.ceil(d / 2));
                                        var m = new OffscreenCanvas(e, d);
                                        m.getContext("2d").drawImage(h, 0, 0, k, l, 0, 0, e, d);
                                        h = m.transferToImageBitmap();
                                    }
                                    return h;
                                };
                                a.__drawBitmap = function(b, c) {
                                    var d = new Lc;
                                    b = Math.ceil(b * d.sx);
                                    c = Math.ceil(c * d.sy);
                                    var e = this.__canvas;
                                    !e || e.width === b && e.height === c || (e.width = b, e.height = c, d = this.__isSvg ? this.__bitmap : this.__scaleBitmap(b, c), e = e.getContext("2d"), e.filter = this._uiManager.hcmFilter, e.drawImage(d, 0, 0, d.width, d.height, 0, 0, b, c));
                                };
                                a.getImageForAltText = function() {
                                    return this.__canvas;
                                };
                                a.__serializeBitmap = function(b) {
                                    if (b) {
                                        if (this.__isSvg && (b = this._uiManager.imageManager.getSvgUrl(this.__bitmapId))) return b;
                                        b = document.createElement("canvas");
                                        var c = this.__bitmap;
                                        b.width = c.width;
                                        b.height = c.height;
                                        b.getContext("2d").drawImage(this.__bitmap, 0, 0);
                                        return b.toDataURL();
                                    }
                                    if (this.__isSvg) {
                                        c = p.makeIterator(this.pageDimensions);
                                        b = c.next().value;
                                        c = c.next().value;
                                        b = Math.round(this.width * b * E.PDF_TO_CSS_UNITS);
                                        c = Math.round(this.height * c * E.PDF_TO_CSS_UNITS);
                                        var d = new OffscreenCanvas(b, c);
                                        d.getContext("2d").drawImage(this.__bitmap, 0, 0, this.__bitmap.width, this.__bitmap.height, 0, 0, b, c);
                                        return d.transferToImageBitmap();
                                    }
                                    return structuredClone(this.__bitmap);
                                };
                                a.__createObserver = function() {
                                    var b = this;
                                    this._uiManager._signal && (this.__observer = new ResizeObserver(function(c) {
                                        c = c[0].contentRect;
                                        c.width && c.height && b.__setDimensions(c.width, c.height);
                                    }), this.__observer.observe(this.div), this._uiManager._signal.addEventListener("abort", function() {
                                        var c;
                                        null == (c = b.__observer) || c.disconnect();
                                        b.__observer = null;
                                    }, {
                                        once: !0
                                    }));
                                };
                                f.deserialize = function() {
                                    var b = Fc(function k(d, e, h) {
                                        var l, m, n, q, r, t, u, v, w, x, B, z, C, D, H, J, M = this, I, P, L, T, aa, ba, ra, X, ma, U, K;
                                        return p.generator.createGenerator(k, function(N) {
                                            switch(N.nextAddress){
                                                case 1:
                                                    l = null;
                                                    if (!(d instanceof af)) {
                                                        N.jumpTo(2);
                                                        break;
                                                    }
                                                    n = d;
                                                    q = n.data;
                                                    r = q.rect;
                                                    t = q.rotation;
                                                    u = q.id;
                                                    v = q.structParent;
                                                    w = q.popupRef;
                                                    x = n.container;
                                                    B = n.parent;
                                                    z = B.page;
                                                    C = z.pageNumber;
                                                    D = x.querySelector("canvas");
                                                    H = h.imageManager.getFromCanvas(x.id, D);
                                                    D.remove();
                                                    return N.yield(e._structTree.getAriaAttributes("pdfjs_internal_id_" + u), 3);
                                                case 3:
                                                    J = (null == (m = N.yieldResult) ? void 0 : m.get("aria-label")) || "", l = d = {
                                                        annotationType: sa.STAMP,
                                                        bitmapId: H.id,
                                                        bitmap: H.bitmap,
                                                        pageIndex: C - 1,
                                                        rect: r.slice(0),
                                                        rotation: t,
                                                        id: u,
                                                        deleted: !1,
                                                        accessibilityData: {
                                                            decorative: !1,
                                                            altText: J
                                                        },
                                                        isSvg: !1,
                                                        structParent: v,
                                                        popupRef: w
                                                    };
                                                case 2:
                                                    return N.yield(g.deserialize.call(M, d, e, h), 4);
                                                case 4:
                                                    return I = N.yieldResult, P = d, L = P.rect, T = P.bitmap, aa = P.bitmapUrl, ba = P.bitmapId, ra = P.isSvg, X = P.accessibilityData, ba && h.imageManager.isValidId(ba) ? (I.__bitmapId = ba, T && (I.__bitmap = T)) : I.__bitmapUrl = aa, I.__isSvg = ra, ma = p.makeIterator(I.pageDimensions), U = ma.next().value, K = ma.next().value, I.width = (L[2] - L[0]) / U, I.height = (L[3] - L[1]) / K, I.annotationElementId = d.id || null, X && (I.altTextData = X), I._initialData = l, I.__hasBeenAddedInUndoStack = !!l, N.return(I);
                                            }
                                        });
                                    });
                                    return function(d, e, h) {
                                        return b.apply(this, arguments);
                                    };
                                }();
                                a.serialize = function(b, c) {
                                    var d;
                                    void 0 === b && (b = !1);
                                    void 0 === c && (c = null);
                                    if (this.isEmpty()) return null;
                                    if (this.deleted) return this.serializeDeleted();
                                    var e = {
                                        annotationType: sa.STAMP,
                                        bitmapId: this.__bitmapId,
                                        pageIndex: this.pageIndex,
                                        rect: this.getRect(0, 0),
                                        rotation: this.rotation,
                                        isSvg: this.__isSvg,
                                        structTreeParentId: this._structTreeParentId
                                    };
                                    if (b) return e.bitmapUrl = this.__serializeBitmap(!0), e.accessibilityData = this.serializeAltText(!0), e;
                                    b = this.serializeAltText(!1);
                                    var h = b.altText;
                                    !b.decorative && h && (e.accessibilityData = {
                                        type: "Figure",
                                        alt: h
                                    });
                                    if (this.annotationElementId) {
                                        b = this.__hasElementChanged(e);
                                        if (b.isSame) return null;
                                        if (b.isSameAltText) delete e.accessibilityData;
                                        else {
                                            var k;
                                            e.accessibilityData.structParent = null != (k = this._initialData.structParent) ? k : -1;
                                        }
                                    }
                                    e.id = this.annotationElementId;
                                    if (null === c) return e;
                                    (d = c).stamps || (d.stamps = new Map);
                                    d = this.__isSvg ? (e.rect[2] - e.rect[0]) * (e.rect[3] - e.rect[1]) : null;
                                    c.stamps.has(this.__bitmapId) ? this.__isSvg && (c = c.stamps.get(this.__bitmapId), d > c.area && (c.area = d, c.serialized.bitmap.close(), c.serialized.bitmap = this.__serializeBitmap(!1))) : (c.stamps.set(this.__bitmapId, {
                                        area: d,
                                        serialized: e
                                    }), e.bitmap = this.__serializeBitmap(!1));
                                    return e;
                                };
                                a.__hasElementChanged = function(b) {
                                    var c, d = this._initialData, e = d.rect, h = d.pageIndex;
                                    d = d.accessibilityData.altText;
                                    var k = b.rect.every(function(l, m) {
                                        return 1 > Math.abs(l - e[m]);
                                    });
                                    h = b.pageIndex === h;
                                    b = ((null == (c = b.accessibilityData) ? void 0 : c.alt) || "") === d;
                                    return {
                                        isSame: k && h && b,
                                        isSameAltText: b
                                    };
                                };
                                a.renderAnnotationElement = function(b) {
                                    b.updateEdited({
                                        rect: this.getRect(0, 0)
                                    });
                                    return null;
                                };
                                return dg(f, [
                                    {
                                        key: "telemetryFinalData",
                                        get: function() {
                                            var b;
                                            return {
                                                type: "stamp",
                                                hasAltText: !(null == (b = this.altTextData) || !b.altText)
                                            };
                                        }
                                    },
                                    {
                                        key: "isResizable",
                                        get: function() {
                                            return !0;
                                        }
                                    }
                                ], [
                                    {
                                        key: "supportedTypes",
                                        get: function() {
                                            return qa(this, "supportedTypes", "apng avif bmp gif jpeg png svg+xml webp x-icon".split(" ").map(function(b) {
                                                return "image/" + b;
                                            }));
                                        }
                                    },
                                    {
                                        key: "supportedTypesStr",
                                        get: function() {
                                            return qa(this, "supportedTypesStr", this.supportedTypes.join(","));
                                        }
                                    }
                                ]);
                            }(wa);
                            Xc._type = "stamp";
                            Xc._editorType = sa.STAMP;
                            var Ic = function() {
                                function g(a) {
                                    var b = a.uiManager, c = a.pageIndex, d = a.div, e = a.structTreeLayer, h = a.accessibilityManager, k = a.annotationLayer, l = a.drawLayer, m = a.textLayer, n = a.viewport;
                                    a = a.l10n;
                                    this.__accessibilityManager = void 0;
                                    this.__allowClick = !1;
                                    this.__editorFocusTimeoutId = this.__clickAC = this.__annotationLayer = null;
                                    this.__editors = new Map;
                                    this.__isDisabling = this.__isCleaningUp = this.__hadPointerDown = !1;
                                    this.__textSelectionAC = this.__textLayer = null;
                                    this.__uiManager = void 0;
                                    var q = [].concat(p.arrayFromIterable(g.__editorTypes.values()));
                                    if (!g._initialized) {
                                        g._initialized = !0;
                                        for(var r = p.makeIterator(q), t = r.next(); !t.done; t = r.next())t.value.initialize(a, b);
                                    }
                                    b.registerEditorTypes(q);
                                    this.__uiManager = b;
                                    this.pageIndex = c;
                                    this.div = d;
                                    this.__accessibilityManager = h;
                                    this.__annotationLayer = k;
                                    this.viewport = n;
                                    this.__textLayer = m;
                                    this.drawLayer = l;
                                    this._structTree = e;
                                    this.__uiManager.addLayer(this);
                                }
                                var f = g.prototype;
                                f.updateToolbar = function(a) {
                                    this.__uiManager.updateToolbar(a);
                                };
                                f.updateMode = function(a) {
                                    void 0 === a && (a = this.__uiManager.getMode());
                                    this.__cleanup();
                                    switch(a){
                                        case sa.NONE:
                                            this.disableTextSelection();
                                            this.togglePointerEvents(!1);
                                            this.toggleAnnotationLayerPointerEvents(!0);
                                            this.disableClick();
                                            return;
                                        case sa.INK:
                                            this.addInkEditorIfNeeded(!1);
                                            this.disableTextSelection();
                                            this.togglePointerEvents(!0);
                                            this.disableClick();
                                            break;
                                        case sa.HIGHLIGHT:
                                            this.enableTextSelection();
                                            this.togglePointerEvents(!1);
                                            this.disableClick();
                                            break;
                                        default:
                                            this.disableTextSelection(), this.togglePointerEvents(!0), this.enableClick();
                                    }
                                    this.toggleAnnotationLayerPointerEvents(!1);
                                    for(var b = this.div.classList, c = p.makeIterator(g.__editorTypes.values()), d = c.next(); !d.done; d = c.next())d = d.value, b.toggle(d._type + "Editing", a === d._editorType);
                                    this.div.hidden = !1;
                                };
                                f.hasTextLayer = function(a) {
                                    var b;
                                    return a === (null == (b = this.__textLayer) ? void 0 : b.div);
                                };
                                f.addInkEditorIfNeeded = function(a) {
                                    if (this.__uiManager.getMode() === sa.INK) {
                                        if (!a) {
                                            a = p.makeIterator(this.__editors.values());
                                            for(var b = a.next(); !b.done; b = a.next())if (b = b.value, b.isEmpty()) {
                                                b.setInBackground();
                                                return;
                                            }
                                        }
                                        this.createAndAddNewEditor({
                                            offsetX: 0,
                                            offsetY: 0
                                        }, !1).setInBackground();
                                    }
                                };
                                f.setEditingState = function(a) {
                                    this.__uiManager.setEditingState(a);
                                };
                                f.addCommands = function(a) {
                                    this.__uiManager.addCommands(a);
                                };
                                f.toggleDrawing = function(a) {
                                    void 0 === a && (a = !1);
                                    this.div.classList.toggle("drawing", !a);
                                };
                                f.togglePointerEvents = function(a) {
                                    void 0 === a && (a = !1);
                                    this.div.classList.toggle("disabled", !a);
                                };
                                f.toggleAnnotationLayerPointerEvents = function(a) {
                                    var b;
                                    void 0 === a && (a = !1);
                                    null == (b = this.__annotationLayer) || b.div.classList.toggle("disabled", !a);
                                };
                                f.enable = function() {
                                    var a = we(function c() {
                                        var d = this, e, h, k, l, m, n, q, r, t;
                                        return p.generator.createGenerator(c, function(u) {
                                            switch(u.nextAddress){
                                                case 1:
                                                    d.div.tabIndex = 0;
                                                    d.togglePointerEvents(!0);
                                                    e = new Set;
                                                    h = p.makeIterator(d.__editors.values());
                                                    for(k = h.next(); !k.done; k = h.next())l = k.value, l.enableEditing(), l.show(!0), l.annotationElementId && (d.__uiManager.removeChangedExistingAnnotation(l), e.add(l.annotationElementId));
                                                    if (!d.__annotationLayer) return u.return();
                                                    m = d.__annotationLayer.getEditableAnnotations();
                                                    n = p.makeIterator(m);
                                                    q = n.next();
                                                case 2:
                                                    if (q.done) {
                                                        u.jumpTo(0);
                                                        break;
                                                    }
                                                    r = q.value;
                                                    r.hide();
                                                    if (d.__uiManager.isDeletedAnnotationElement(r.data.id)) {
                                                        u.jumpTo(3);
                                                        break;
                                                    }
                                                    if (e.has(r.data.id)) {
                                                        u.jumpTo(3);
                                                        break;
                                                    }
                                                    return u.yield(d.deserialize(r), 5);
                                                case 5:
                                                    t = u.yieldResult;
                                                    if (!t) {
                                                        u.jumpTo(3);
                                                        break;
                                                    }
                                                    d.addOrRebuild(t);
                                                    t.enableEditing();
                                                case 3:
                                                    q = n.next(), u.jumpTo(2);
                                            }
                                        });
                                    });
                                    return function() {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.disable = function() {
                                    this.__isDisabling = !0;
                                    this.div.tabIndex = -1;
                                    this.togglePointerEvents(!1);
                                    for(var a = new Map, b = new Map, c = p.makeIterator(this.__editors.values()), d = c.next(); !d.done; d = c.next()){
                                        d = d.value;
                                        var e;
                                        d.disableEditing();
                                        d.annotationElementId && (null !== d.serialize() ? a.set(d.annotationElementId, d) : (b.set(d.annotationElementId, d), null == (e = this.getEditableAnnotation(d.annotationElementId)) || e.show(), d.remove()));
                                    }
                                    if (this.__annotationLayer) {
                                        for(c = this.__annotationLayer.getEditableAnnotations(), c = p.makeIterator(c), e = c.next(); !e.done; e = c.next())if (e = e.value, d = e.data.id, !this.__uiManager.isDeletedAnnotationElement(d)) {
                                            var h = b.get(d);
                                            if (h) h.resetAnnotationElement(e), h.show(!1);
                                            else if (h = a.get(d)) this.__uiManager.addChangedExistingAnnotation(h), h.renderAnnotationElement(e) && h.show(!1);
                                            e.show();
                                        }
                                    }
                                    this.__cleanup();
                                    this.isEmpty && (this.div.hidden = !0);
                                    a = this.div.classList;
                                    b = p.makeIterator(g.__editorTypes.values());
                                    for(c = b.next(); !c.done; c = b.next())a.remove(c.value._type + "Editing");
                                    this.disableTextSelection();
                                    this.toggleAnnotationLayerPointerEvents(!0);
                                    this.__isDisabling = !1;
                                };
                                f.getEditableAnnotation = function(a) {
                                    var b;
                                    return (null == (b = this.__annotationLayer) ? void 0 : b.getEditableAnnotation(a)) || null;
                                };
                                f.setActiveEditor = function(a) {
                                    this.__uiManager.getActive() !== a && this.__uiManager.setActiveEditor(a);
                                };
                                f.enableTextSelection = function() {
                                    var a;
                                    this.div.tabIndex = -1;
                                    null != (a = this.__textLayer) && a.div && !this.__textSelectionAC && (this.__textSelectionAC = new AbortController, a = this.__uiManager.combinedSignal(this.__textSelectionAC), this.__textLayer.div.addEventListener("pointerdown", this.__textLayerPointerDown.bind(this), {
                                        signal: a
                                    }), this.__textLayer.div.classList.add("highlighting"));
                                };
                                f.disableTextSelection = function() {
                                    var a;
                                    this.div.tabIndex = 0;
                                    null != (a = this.__textLayer) && a.div && this.__textSelectionAC && (this.__textSelectionAC.abort(), this.__textSelectionAC = null, this.__textLayer.div.classList.remove("highlighting"));
                                };
                                f.__textLayerPointerDown = function(a) {
                                    var b = this;
                                    this.__uiManager.unselectAll();
                                    var c = a.target;
                                    if (c === this.__textLayer.div || ("img" === c.getAttribute("role") || c.classList.contains("endOfContent")) && this.__textLayer.div.contains(c)) c = Ka.platform.isMac, 0 !== a.button || a.ctrlKey && c || (this.__uiManager.showAllEditors("highlight", !0, !0), this.__textLayer.div.classList.add("free"), this.toggleDrawing(), Ra.startHighlighting(this, "ltr" === this.__uiManager.direction, {
                                        target: this.__textLayer.div,
                                        x: a.x,
                                        y: a.y
                                    }), this.__textLayer.div.addEventListener("pointerup", function() {
                                        b.__textLayer.div.classList.remove("free");
                                        b.toggleDrawing(!0);
                                    }, {
                                        once: !0,
                                        signal: this.__uiManager._signal
                                    }), a.preventDefault());
                                };
                                f.enableClick = function() {
                                    if (!this.__clickAC) {
                                        this.__clickAC = new AbortController;
                                        var a = this.__uiManager.combinedSignal(this.__clickAC);
                                        this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
                                            signal: a
                                        });
                                        this.div.addEventListener("pointerup", this.pointerup.bind(this), {
                                            signal: a
                                        });
                                    }
                                };
                                f.disableClick = function() {
                                    var a;
                                    null == (a = this.__clickAC) || a.abort();
                                    this.__clickAC = null;
                                };
                                f.attach = function(a) {
                                    this.__editors.set(a.id, a);
                                    var b = a.annotationElementId;
                                    b && this.__uiManager.isDeletedAnnotationElement(b) && this.__uiManager.removeDeletedAnnotationElement(a);
                                };
                                f.detach = function(a) {
                                    var b;
                                    this.__editors.delete(a.id);
                                    null == (b = this.__accessibilityManager) || b.removePointerInTextLayer(a.contentDiv);
                                    !this.__isDisabling && a.annotationElementId && this.__uiManager.addDeletedAnnotationElement(a);
                                };
                                f.remove = function(a) {
                                    this.detach(a);
                                    this.__uiManager.removeEditor(a);
                                    a.div.remove();
                                    a.isAttachedToDOM = !1;
                                    this.__isCleaningUp || this.addInkEditorIfNeeded(!1);
                                };
                                f.changeParent = function(a) {
                                    var b;
                                    a.parent !== this && (a.parent && a.annotationElementId && (this.__uiManager.addDeletedAnnotationElement(a.annotationElementId), wa.deleteAnnotationElement(a), a.annotationElementId = null), this.attach(a), null == (b = a.parent) || b.detach(a), a.setParent(this), a.div && a.isAttachedToDOM && (a.div.remove(), this.div.append(a.div)));
                                };
                                f.add = function(a) {
                                    if (a.parent !== this || !a.isAttachedToDOM) {
                                        this.changeParent(a);
                                        this.__uiManager.addEditor(a);
                                        this.attach(a);
                                        if (!a.isAttachedToDOM) {
                                            var b = a.render();
                                            this.div.append(b);
                                            a.isAttachedToDOM = !0;
                                        }
                                        a.fixAndSetPosition();
                                        a.onceAdded();
                                        this.__uiManager.addToAnnotationStorage(a);
                                        a._reportTelemetry(a.telemetryInitialData);
                                    }
                                };
                                f.moveEditorInDOM = function(a) {
                                    var b = this, c;
                                    if (a.isAttachedToDOM) {
                                        var d = document.activeElement;
                                        a.div.contains(d) && !this.__editorFocusTimeoutId && (a._focusEventsAllowed = !1, this.__editorFocusTimeoutId = setTimeout(function() {
                                            b.__editorFocusTimeoutId = null;
                                            a.div.contains(document.activeElement) ? a._focusEventsAllowed = !0 : (a.div.addEventListener("focusin", function() {
                                                a._focusEventsAllowed = !0;
                                            }, {
                                                once: !0,
                                                signal: b.__uiManager._signal
                                            }), d.focus());
                                        }, 0));
                                        a._structTreeParentId = null == (c = this.__accessibilityManager) ? void 0 : c.moveElementInDOM(this.div, a.div, a.contentDiv, !0);
                                    }
                                };
                                f.addOrRebuild = function(a) {
                                    a.needsToBeRebuilt() ? (a.parent || (a.parent = this), a.rebuild(), a.show()) : this.add(a);
                                };
                                f.addUndoableEditor = function(a) {
                                    this.addCommands({
                                        cmd: function() {
                                            return a._uiManager.rebuild(a);
                                        },
                                        undo: function() {
                                            a.remove();
                                        },
                                        mustExec: !1
                                    });
                                };
                                f.getNextId = function() {
                                    return this.__uiManager.getId();
                                };
                                f.combinedSignal = function(a) {
                                    return this.__uiManager.combinedSignal(a);
                                };
                                f.__createNewEditor = function(a) {
                                    var b = this.__currentEditorType;
                                    return b ? new b.prototype.constructor(a) : null;
                                };
                                f.canCreateNewEmptyEditor = function() {
                                    var a;
                                    return null == (a = this.__currentEditorType) ? void 0 : a.canCreateNewEmptyEditor();
                                };
                                f.pasteEditor = function(a, b) {
                                    this.__uiManager.updateToolbar(a);
                                    this.__uiManager.updateMode(a);
                                    var c = this.__getCenterPoint();
                                    a = c.offsetX;
                                    c = c.offsetY;
                                    var d = this.getNextId();
                                    (b = this.__createNewEditor(Object.assign({
                                        parent: this,
                                        id: d,
                                        x: a,
                                        y: c,
                                        uiManager: this.__uiManager,
                                        isCentered: !0
                                    }, b))) && this.add(b);
                                };
                                f.deserialize = function() {
                                    var a = we(function d(c) {
                                        var e, h, k = this;
                                        return p.generator.createGenerator(d, function(l) {
                                            return 1 == l.nextAddress ? l.yield(null == (e = g.__editorTypes.get(null != (h = c.annotationType) ? h : c.annotationEditorType)) ? void 0 : e.deserialize(c, k, k.__uiManager), 2) : l.return(l.yieldResult || null);
                                        });
                                    });
                                    return function(c) {
                                        return a.apply(this, arguments);
                                    };
                                }();
                                f.createAndAddNewEditor = function(a, b, c) {
                                    void 0 === c && (c = {});
                                    var d = this.getNextId();
                                    (a = this.__createNewEditor(Object.assign({
                                        parent: this,
                                        id: d,
                                        x: a.offsetX,
                                        y: a.offsetY,
                                        uiManager: this.__uiManager,
                                        isCentered: b
                                    }, c))) && this.add(a);
                                    return a;
                                };
                                f.__getCenterPoint = function() {
                                    var a = this.div.getBoundingClientRect(), b = a.x, c = a.y;
                                    b = (Math.max(0, b) + Math.min(window.innerWidth, b + a.width)) / 2 - b;
                                    a = (Math.max(0, c) + Math.min(window.innerHeight, c + a.height)) / 2 - c;
                                    c = p.makeIterator(0 === this.viewport.rotation % 180 ? [
                                        b,
                                        a
                                    ] : [
                                        a,
                                        b
                                    ]);
                                    a = c.next().value;
                                    c = c.next().value;
                                    return {
                                        offsetX: a,
                                        offsetY: c
                                    };
                                };
                                f.addNewEditor = function() {
                                    this.createAndAddNewEditor(this.__getCenterPoint(), !0);
                                };
                                f.setSelected = function(a) {
                                    this.__uiManager.setSelected(a);
                                };
                                f.toggleSelected = function(a) {
                                    this.__uiManager.toggleSelected(a);
                                };
                                f.unselect = function(a) {
                                    this.__uiManager.unselect(a);
                                };
                                f.pointerup = function(a) {
                                    var b = Ka.platform.isMac;
                                    0 !== a.button || a.ctrlKey && b || a.target !== this.div || !this.__hadPointerDown || (this.__hadPointerDown = !1, this.__allowClick ? this.__uiManager.getMode() === sa.STAMP ? this.__uiManager.unselectAll() : this.createAndAddNewEditor(a, !1) : this.__allowClick = !0);
                                };
                                f.pointerdown = function(a) {
                                    this.__uiManager.getMode() === sa.HIGHLIGHT && this.enableTextSelection();
                                    if (this.__hadPointerDown) this.__hadPointerDown = !1;
                                    else {
                                        var b = Ka.platform.isMac;
                                        0 !== a.button || a.ctrlKey && b || a.target !== this.div || (this.__hadPointerDown = !0, a = this.__uiManager.getActive(), this.__allowClick = !a || a.isEmpty());
                                    }
                                };
                                f.findNewParent = function(a, b, c) {
                                    b = this.__uiManager.findParent(b, c);
                                    if (null === b || b === this) return !1;
                                    b.changeParent(a);
                                    return !0;
                                };
                                f.destroy = function() {
                                    var a;
                                    (null == (a = this.__uiManager.getActive()) ? void 0 : a.parent) === this && (this.__uiManager.commitOrRemove(), this.__uiManager.setActiveEditor(null));
                                    this.__editorFocusTimeoutId && (clearTimeout(this.__editorFocusTimeoutId), this.__editorFocusTimeoutId = null);
                                    a = p.makeIterator(this.__editors.values());
                                    for(var b = a.next(); !b.done; b = a.next()){
                                        b = b.value;
                                        var c;
                                        null == (c = this.__accessibilityManager) || c.removePointerInTextLayer(b.contentDiv);
                                        b.setParent(null);
                                        b.isAttachedToDOM = !1;
                                        b.div.remove();
                                    }
                                    this.div = null;
                                    this.__editors.clear();
                                    this.__uiManager.removeLayer(this);
                                };
                                f.__cleanup = function() {
                                    this.__isCleaningUp = !0;
                                    for(var a = p.makeIterator(this.__editors.values()), b = a.next(); !b.done; b = a.next())b = b.value, b.isEmpty() && b.remove();
                                    this.__isCleaningUp = !1;
                                };
                                f.render = function(a) {
                                    this.viewport = a = a.viewport;
                                    ab(this.div, a);
                                    a = p.makeIterator(this.__uiManager.getEditors(this.pageIndex));
                                    for(var b = a.next(); !b.done; b = a.next())b = b.value, this.add(b), b.rebuild();
                                    this.updateMode();
                                };
                                f.update = function(a) {
                                    var b = a.viewport;
                                    this.__uiManager.commitOrRemove();
                                    this.__cleanup();
                                    var c = this.viewport.rotation;
                                    a = b.rotation;
                                    this.viewport = b;
                                    ab(this.div, {
                                        rotation: a
                                    });
                                    if (c !== a) for(b = p.makeIterator(this.__editors.values()), c = b.next(); !c.done; c = b.next())c.value.rotate(a);
                                    this.addInkEditorIfNeeded(!1);
                                };
                                return fg(g, [
                                    {
                                        key: "isEmpty",
                                        get: function() {
                                            return 0 === this.__editors.size;
                                        }
                                    },
                                    {
                                        key: "isInvisible",
                                        get: function() {
                                            return this.isEmpty && this.__uiManager.getMode() === sa.NONE;
                                        }
                                    },
                                    {
                                        key: "__currentEditorType",
                                        get: function() {
                                            return g.__editorTypes.get(this.__uiManager.getMode());
                                        }
                                    },
                                    {
                                        key: "pageDimensions",
                                        get: function() {
                                            var a = this.viewport.rawDims;
                                            return [
                                                a.pageWidth,
                                                a.pageHeight
                                            ];
                                        }
                                    },
                                    {
                                        key: "scale",
                                        get: function() {
                                            return this.__uiManager.viewParameters.realScale;
                                        }
                                    }
                                ]);
                            }();
                            Ic._initialized = !1;
                            Ic.__editorTypes = new Map([
                                jb,
                                pb,
                                Xc,
                                Ra
                            ].map(function(g) {
                                return [
                                    g._editorType,
                                    g
                                ];
                            }));
                            var kg = function() {
                                function g(a) {
                                    a = a.pageIndex;
                                    this.__parent = null;
                                    this.__id = 0;
                                    this.__mapping = new Map;
                                    this.__toUpdate = new Map;
                                    this.pageIndex = a;
                                }
                                var f = g.prototype;
                                f.setParent = function(a) {
                                    if (!this.__parent) this.__parent = a;
                                    else if (this.__parent !== a) {
                                        if (0 < this.__mapping.size) for(var b = p.makeIterator(this.__mapping.values()), c = b.next(); !c.done; c = b.next())c = c.value, c.remove(), a.append(c);
                                        this.__parent = a;
                                    }
                                };
                                g.__setBox = function(a, b) {
                                    b = void 0 === b ? {} : b;
                                    var c = void 0 === b.x ? 0 : b.x, d = void 0 === b.width ? 1 : b.width, e = void 0 === b.height ? 1 : b.height;
                                    a = a.style;
                                    a.top = 100 * (void 0 === b.y ? 0 : b.y) + "%";
                                    a.left = 100 * c + "%";
                                    a.width = 100 * d + "%";
                                    a.height = 100 * e + "%";
                                };
                                f.__createSVG = function(a) {
                                    var b = g._svgFactory.create(1, 1, !0);
                                    this.__parent.append(b);
                                    b.setAttribute("aria-hidden", !0);
                                    g.__setBox(b, a);
                                    return b;
                                };
                                f.__createClipPath = function(a, b) {
                                    var c = g._svgFactory.createElement("clipPath");
                                    a.append(c);
                                    a = "clip_" + b;
                                    c.setAttribute("id", a);
                                    c.setAttribute("clipPathUnits", "objectBoundingBox");
                                    var d = g._svgFactory.createElement("use");
                                    c.append(d);
                                    d.setAttribute("href", "#" + b);
                                    d.classList.add("clip");
                                    return a;
                                };
                                f.draw = function(a, b, c, d) {
                                    void 0 === d && (d = !1);
                                    var e = this.__id++, h = this.__createSVG(a.box);
                                    h.classList.add.apply(h.classList, p.arrayFromIterable(a.classNamesForDrawing));
                                    var k = g._svgFactory.createElement("defs");
                                    h.append(k);
                                    var l = g._svgFactory.createElement("path");
                                    k.append(l);
                                    var m = "path_p" + this.pageIndex + "_" + e;
                                    l.setAttribute("id", m);
                                    l.setAttribute("d", a.toSVGPath());
                                    d && this.__toUpdate.set(e, l);
                                    a = this.__createClipPath(k, m);
                                    d = g._svgFactory.createElement("use");
                                    h.append(d);
                                    h.setAttribute("fill", b);
                                    h.setAttribute("fill-opacity", c);
                                    d.setAttribute("href", "#" + m);
                                    this.__mapping.set(e, h);
                                    return {
                                        id: e,
                                        clipPathId: "url(#" + a + ")"
                                    };
                                };
                                f.drawOutline = function(a) {
                                    var b = this.__id++, c = this.__createSVG(a.box);
                                    c.classList.add.apply(c.classList, p.arrayFromIterable(a.classNamesForOutlining));
                                    var d = g._svgFactory.createElement("defs");
                                    c.append(d);
                                    var e = g._svgFactory.createElement("path");
                                    d.append(e);
                                    var h = "path_p" + this.pageIndex + "_" + b;
                                    e.setAttribute("id", h);
                                    e.setAttribute("d", a.toSVGPath());
                                    e.setAttribute("vector-effect", "non-scaling-stroke");
                                    if (a.mustRemoveSelfIntersections) {
                                        a = g._svgFactory.createElement("mask");
                                        d.append(a);
                                        var k = "mask_p" + this.pageIndex + "_" + b;
                                        a.setAttribute("id", k);
                                        a.setAttribute("maskUnits", "objectBoundingBox");
                                        d = g._svgFactory.createElement("rect");
                                        a.append(d);
                                        d.setAttribute("width", "1");
                                        d.setAttribute("height", "1");
                                        d.setAttribute("fill", "white");
                                        d = g._svgFactory.createElement("use");
                                        a.append(d);
                                        d.setAttribute("href", "#" + h);
                                        d.setAttribute("stroke", "none");
                                        d.setAttribute("fill", "black");
                                        d.setAttribute("fill-rule", "nonzero");
                                        d.classList.add("mask");
                                    }
                                    d = g._svgFactory.createElement("use");
                                    c.append(d);
                                    d.setAttribute("href", "#" + h);
                                    k && d.setAttribute("mask", "url(#" + k + ")");
                                    h = d.cloneNode();
                                    c.append(h);
                                    d.classList.add("mainOutline");
                                    h.classList.add("secondaryOutline");
                                    this.__mapping.set(b, c);
                                    return b;
                                };
                                f.finalizeLine = function(a, b) {
                                    var c = this.__toUpdate.get(a);
                                    this.__toUpdate.delete(a);
                                    this.updateBox(a, b.box);
                                    c.setAttribute("d", b.toSVGPath());
                                };
                                f.updateLine = function(a, b) {
                                    this.__mapping.get(a).firstChild.firstChild.setAttribute("d", b.toSVGPath());
                                };
                                f.updatePath = function(a, b) {
                                    this.__toUpdate.get(a).setAttribute("d", b.toSVGPath());
                                };
                                f.updateBox = function(a, b) {
                                    g.__setBox(this.__mapping.get(a), b);
                                };
                                f.show = function(a, b) {
                                    this.__mapping.get(a).classList.toggle("hidden", !b);
                                };
                                f.rotate = function(a, b) {
                                    this.__mapping.get(a).setAttribute("data-main-rotation", b);
                                };
                                f.changeColor = function(a, b) {
                                    this.__mapping.get(a).setAttribute("fill", b);
                                };
                                f.changeOpacity = function(a, b) {
                                    this.__mapping.get(a).setAttribute("fill-opacity", b);
                                };
                                f.addClass = function(a, b) {
                                    this.__mapping.get(a).classList.add(b);
                                };
                                f.removeClass = function(a, b) {
                                    this.__mapping.get(a).classList.remove(b);
                                };
                                f.getSVGRoot = function(a) {
                                    return this.__mapping.get(a);
                                };
                                f.remove = function(a) {
                                    this.__toUpdate.delete(a);
                                    null !== this.__parent && (this.__mapping.get(a).remove(), this.__mapping.delete(a));
                                };
                                f.destroy = function() {
                                    this.__parent = null;
                                    for(var a = p.makeIterator(this.__mapping.values()), b = a.next(); !b.done; b = a.next())b.value.remove();
                                    this.__mapping.clear();
                                    this.__toUpdate.clear();
                                };
                                return gg(g, null, [
                                    {
                                        key: "_svgFactory",
                                        get: function() {
                                            return qa(this, "_svgFactory", new Kc);
                                        }
                                    }
                                ]);
                            }(), Yc;
                            for(Yc in tb)G[Yc] = tb[Yc];
                            tb.__esModule && Object.defineProperty(G, "__esModule", {
                                value: !0
                            });
                        })();
                    },
                    {}
                ],
                2: [
                    function(y, A) {
                        A.exports = y("colibrio-pdf-js-dist/legacy/build/pdf");
                    },
                    {
                        "colibrio-pdf-js-dist/legacy/build/pdf": 1
                    }
                ]
            }, {}, [
                2
            ])(2);
        });
        return module1.exports;
    }();
    var __worker__colibrio_core_publication_pdf_webworker = '\'use strict\'; (function (__self) { var u=u||{};u.scope={};u.arrayIteratorImpl=function(I){var K=0;return function(){return K<I.length?{done:!1,value:I[K++]}:{done:!0}}};u.arrayIterator=function(I){return{next:u.arrayIteratorImpl(I)}};u.ASSUME_ES5=!1;u.ASSUME_NO_NATIVE_MAP=!1;u.ASSUME_NO_NATIVE_SET=!1;u.SIMPLE_FROUND_POLYFILL=!1;u.ISOLATE_POLYFILLS=!1;u.FORCE_POLYFILL_PROMISE=!1;u.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION=!1;\nu.defineProperty=u.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(I,K,Z){if(I==Array.prototype||I==Object.prototype)return I;I[K]=Z.value;return I};u.getGlobal=function(I){I=["object"==typeof globalThis&&globalThis,I,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var K=0;K<I.length;++K){var Z=I[K];if(Z&&Z.Math==Math)return Z}throw Error("Cannot find global object");};u.global=u.getGlobal(this);\nu.IS_SYMBOL_NATIVE="function"===typeof Symbol&&"symbol"===typeof Symbol("x");u.TRUST_ES6_POLYFILLS=!u.ISOLATE_POLYFILLS||u.IS_SYMBOL_NATIVE;u.polyfills={};u.propertyToPolyfillSymbol={};u.POLYFILL_PREFIX="$jscp$";u.polyfill=function(I,K,Z,ia){K&&(u.ISOLATE_POLYFILLS?u.polyfillIsolated(I,K,Z,ia):u.polyfillUnisolated(I,K,Z,ia))};\nu.polyfillUnisolated=function(I,K){var Z=u.global;I=I.split(".");for(var ia=0;ia<I.length-1;ia++){var sa=I[ia];if(!(sa in Z))return;Z=Z[sa]}I=I[I.length-1];ia=Z[I];K=K(ia);K!=ia&&null!=K&&u.defineProperty(Z,I,{configurable:!0,writable:!0,value:K})};\nu.polyfillIsolated=function(I,K,Z){var ia=I.split(".");I=1===ia.length;var sa=ia[0];sa=!I&&sa in u.polyfills?u.polyfills:u.global;for(var Qa=0;Qa<ia.length-1;Qa++){var Ba=ia[Qa];if(!(Ba in sa))return;sa=sa[Ba]}ia=ia[ia.length-1];Z=u.IS_SYMBOL_NATIVE&&"es6"===Z?sa[ia]:null;K=K(Z);null!=K&&(I?u.defineProperty(u.polyfills,ia,{configurable:!0,writable:!0,value:K}):K!==Z&&(void 0===u.propertyToPolyfillSymbol[ia]&&(I=1E9*Math.random()>>>0,u.propertyToPolyfillSymbol[ia]=u.IS_SYMBOL_NATIVE?u.global.Symbol(ia):\nu.POLYFILL_PREFIX+I+"$"+ia),u.defineProperty(sa,u.propertyToPolyfillSymbol[ia],{configurable:!0,writable:!0,value:K})))};u.initSymbol=function(){};\nu.polyfill("Symbol",function(I){function K(Qa){if(this instanceof K)throw new TypeError("Symbol is not a constructor");return new Z(ia+(Qa||"")+"_"+sa++,Qa)}function Z(Qa,Ba){this.$jscomp$symbol$id_=Qa;u.defineProperty(this,"description",{configurable:!0,writable:!0,value:Ba})}if(I)return I;Z.prototype.toString=function(){return this.$jscomp$symbol$id_};var ia="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",sa=0;return K},"es6","es3");\nu.polyfill("Symbol.iterator",function(I){if(I)return I;I=Symbol("Symbol.iterator");for(var K="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),Z=0;Z<K.length;Z++){var ia=u.global[K[Z]];"function"===typeof ia&&"function"!=typeof ia.prototype[I]&&u.defineProperty(ia.prototype,I,{configurable:!0,writable:!0,value:function(){return u.iteratorPrototype(u.arrayIteratorImpl(this))}})}return I},"es6","es3");\nu.polyfill("Symbol.asyncIterator",function(I){return I?I:Symbol("Symbol.asyncIterator")},"es9","es3");u.iteratorPrototype=function(I){I={next:I};I[Symbol.iterator]=function(){return this};return I};u.makeIterator=function(I){var K="undefined"!=typeof Symbol&&Symbol.iterator&&I[Symbol.iterator];if(K)return K.call(I);if("number"==typeof I.length)return u.arrayIterator(I);throw Error(String(I)+" is not an iterable or ArrayLike");};\nu.arrayFromIterator=function(I){for(var K,Z=[];!(K=I.next()).done;)Z.push(K.value);return Z};u.arrayFromIterable=function(I){return I instanceof Array?I:u.arrayFromIterator(u.makeIterator(I))};u.underscoreProtoCanBeSet=function(){var I={a:!0},K={};try{return K.__proto__=I,K.a}catch(Z){}return!1};\nu.setPrototypeOf=u.TRUST_ES6_POLYFILLS&&"function"==typeof Object.setPrototypeOf?Object.setPrototypeOf:u.underscoreProtoCanBeSet()?function(I,K){I.__proto__=K;if(I.__proto__!==K)throw new TypeError(I+" is not extensible");return I}:null;u.generator={};u.generator.ensureIteratorResultIsObject_=function(I){if(!(I instanceof Object))throw new TypeError("Iterator result "+I+" is not an object");};\nu.generator.Context=function(){this.isRunning_=!1;this.yieldAllIterator_=null;this.yieldResult=void 0;this.nextAddress=1;this.finallyAddress_=this.catchAddress_=0;this.finallyContexts_=this.abruptCompletion_=null};u.generator.Context.prototype.start_=function(){if(this.isRunning_)throw new TypeError("Generator is already running");this.isRunning_=!0};u.generator.Context.prototype.stop_=function(){this.isRunning_=!1};\nu.generator.Context.prototype.jumpToErrorHandler_=function(){this.nextAddress=this.catchAddress_||this.finallyAddress_};u.generator.Context.prototype.next_=function(I){this.yieldResult=I};u.generator.Context.prototype.throw_=function(I){this.abruptCompletion_={exception:I,isException:!0};this.jumpToErrorHandler_()};u.generator.Context.prototype.return=function(I){this.abruptCompletion_={return:I};this.nextAddress=this.finallyAddress_};\nu.generator.Context.prototype.jumpThroughFinallyBlocks=function(I){this.abruptCompletion_={jumpTo:I};this.nextAddress=this.finallyAddress_};u.generator.Context.prototype.yield=function(I,K){this.nextAddress=K;return{value:I}};u.generator.Context.prototype.yieldAll=function(I,K){I=u.makeIterator(I);var Z=I.next();u.generator.ensureIteratorResultIsObject_(Z);if(Z.done)this.yieldResult=Z.value,this.nextAddress=K;else return this.yieldAllIterator_=I,this.yield(Z.value,K)};\nu.generator.Context.prototype.jumpTo=function(I){this.nextAddress=I};u.generator.Context.prototype.jumpToEnd=function(){this.nextAddress=0};u.generator.Context.prototype.setCatchFinallyBlocks=function(I,K){this.catchAddress_=I;void 0!=K&&(this.finallyAddress_=K)};u.generator.Context.prototype.setFinallyBlock=function(I){this.catchAddress_=0;this.finallyAddress_=I||0};u.generator.Context.prototype.leaveTryBlock=function(I,K){this.nextAddress=I;this.catchAddress_=K||0};\nu.generator.Context.prototype.enterCatchBlock=function(I){this.catchAddress_=I||0;I=this.abruptCompletion_.exception;this.abruptCompletion_=null;return I};u.generator.Context.prototype.enterFinallyBlock=function(I,K,Z){Z?this.finallyContexts_[Z]=this.abruptCompletion_:this.finallyContexts_=[this.abruptCompletion_];this.catchAddress_=I||0;this.finallyAddress_=K||0};\nu.generator.Context.prototype.leaveFinallyBlock=function(I,K){K=this.finallyContexts_.splice(K||0)[0];if(K=this.abruptCompletion_=this.abruptCompletion_||K){if(K.isException)return this.jumpToErrorHandler_();void 0!=K.jumpTo&&this.finallyAddress_<K.jumpTo?(this.nextAddress=K.jumpTo,this.abruptCompletion_=null):this.nextAddress=this.finallyAddress_}else this.nextAddress=I};u.generator.Context.prototype.forIn=function(I){return new u.generator.Context.PropertyIterator(I)};\nu.generator.Context.PropertyIterator=function(I){this.object_=I;this.properties_=[];for(var K in I)this.properties_.push(K);this.properties_.reverse()};u.generator.Context.PropertyIterator.prototype.getNext=function(){for(;0<this.properties_.length;){var I=this.properties_.pop();if(I in this.object_)return I}return null};u.generator.Engine_=function(I){this.context_=new u.generator.Context;this.program_=I};\nu.generator.Engine_.prototype.next_=function(I){this.context_.start_();if(this.context_.yieldAllIterator_)return this.yieldAllStep_(this.context_.yieldAllIterator_.next,I,this.context_.next_);this.context_.next_(I);return this.nextStep_()};u.generator.Engine_.prototype.return_=function(I){this.context_.start_();var K=this.context_.yieldAllIterator_;if(K)return this.yieldAllStep_("return"in K?K["return"]:function(Z){return{value:Z,done:!0}},I,this.context_.return);this.context_.return(I);return this.nextStep_()};\nu.generator.Engine_.prototype.throw_=function(I){this.context_.start_();if(this.context_.yieldAllIterator_)return this.yieldAllStep_(this.context_.yieldAllIterator_["throw"],I,this.context_.next_);this.context_.throw_(I);return this.nextStep_()};\nu.generator.Engine_.prototype.yieldAllStep_=function(I,K,Z){try{var ia=I.call(this.context_.yieldAllIterator_,K);u.generator.ensureIteratorResultIsObject_(ia);if(!ia.done)return this.context_.stop_(),ia;var sa=ia.value}catch(Qa){return this.context_.yieldAllIterator_=null,this.context_.throw_(Qa),this.nextStep_()}this.context_.yieldAllIterator_=null;Z.call(this.context_,sa);return this.nextStep_()};\nu.generator.Engine_.prototype.nextStep_=function(){for(;this.context_.nextAddress;)try{var I=this.program_(this.context_);if(I)return this.context_.stop_(),{value:I.value,done:!1}}catch(K){this.context_.yieldResult=void 0,this.context_.throw_(K)}this.context_.stop_();if(this.context_.abruptCompletion_){I=this.context_.abruptCompletion_;this.context_.abruptCompletion_=null;if(I.isException)throw I.exception;return{value:I.return,done:!0}}return{value:void 0,done:!0}};\nu.generator.Generator_=function(I){this.next=function(K){return I.next_(K)};this.throw=function(K){return I.throw_(K)};this.return=function(K){return I.return_(K)};this[Symbol.iterator]=function(){return this}};u.generator.createGenerator=function(I,K){K=new u.generator.Generator_(new u.generator.Engine_(K));u.setPrototypeOf&&I.prototype&&u.setPrototypeOf(K,I.prototype);return K};\nu.polyfill("Array.from",function(I){return I?I:function(K,Z,ia){Z=null!=Z?Z:function(Oa){return Oa};var sa=[],Qa="undefined"!=typeof Symbol&&Symbol.iterator&&K[Symbol.iterator];if("function"==typeof Qa){K=Qa.call(K);for(var Ba=0;!(Qa=K.next()).done;)sa.push(Z.call(ia,Qa.value,Ba++))}else for(Qa=K.length,Ba=0;Ba<Qa;Ba++)sa.push(Z.call(ia,K[Ba],Ba));return sa}},"es6","es3");u.polyfill("Reflect",function(I){return I?I:{}},"es6","es3");\nu.polyfill("Reflect.apply",function(I){if(I)return I;var K=Function.prototype.apply;return function(Z,ia,sa){return K.call(Z,ia,sa)}},"es6","es3");u.iteratorFromArray=function(I,K){I instanceof String&&(I+="");var Z=0,ia=!1,sa={next:function(){if(!ia&&Z<I.length){var Qa=Z++;return{value:K(Qa,I[Qa]),done:!1}}ia=!0;return{done:!0,value:void 0}}};sa[Symbol.iterator]=function(){return sa};return sa};\nu.polyfill("Array.prototype.keys",function(I){return I?I:function(){return u.iteratorFromArray(this,function(K){return K})}},"es6","es3");u.polyfill("Object.hasOwn",function(I){return I?I:function(K,Z){return Object.prototype.hasOwnProperty.call(K,Z)}},"es_next","es3");u.checkEs6ConformanceViaProxy=function(){try{var I={},K=Object.create(new u.global.Proxy(I,{get:function(Z,ia,sa){return Z==I&&"q"==ia&&sa==K}}));return!0===K.q}catch(Z){return!1}};u.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS=!1;\nu.ES6_CONFORMANCE=u.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS&&u.checkEs6ConformanceViaProxy();u.owns=function(I,K){return Object.prototype.hasOwnProperty.call(I,K)};\nu.polyfill("WeakMap",function(I){function K(Ka){this.id_=(Ea+=Math.random()+1).toString();if(Ka){Ka=u.makeIterator(Ka);for(var pa;!(pa=Ka.next()).done;)pa=pa.value,this.set(pa[0],pa[1])}}function Z(){if(!I||!Object.seal)return!1;try{var Ka=Object.seal({}),pa=Object.seal({}),fb=new I([[Ka,2],[pa,3]]);if(2!=fb.get(Ka)||3!=fb.get(pa))return!1;fb.delete(Ka);fb.set(pa,4);return!fb.has(Ka)&&4==fb.get(pa)}catch(Yb){return!1}}function ia(){}function sa(Ka){var pa=typeof Ka;return"object"===pa&&null!==Ka||\n"function"===pa}function Qa(Ka){if(!u.owns(Ka,Oa)){var pa=new ia;u.defineProperty(Ka,Oa,{value:pa})}}function Ba(Ka){if(!u.ISOLATE_POLYFILLS){var pa=Object[Ka];pa&&(Object[Ka]=function(fb){if(fb instanceof ia)return fb;Object.isExtensible(fb)&&Qa(fb);return pa(fb)})}}if(u.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS){if(I&&u.ES6_CONFORMANCE)return I}else if(Z())return I;var Oa="$jscomp_hidden_"+Math.random();Ba("freeze");Ba("preventExtensions");Ba("seal");var Ea=0;K.prototype.set=function(Ka,pa){if(!sa(Ka))throw Error("Invalid WeakMap key");\nQa(Ka);if(!u.owns(Ka,Oa))throw Error("WeakMap key fail: "+Ka);Ka[Oa][this.id_]=pa;return this};K.prototype.get=function(Ka){return sa(Ka)&&u.owns(Ka,Oa)?Ka[Oa][this.id_]:void 0};K.prototype.has=function(Ka){return sa(Ka)&&u.owns(Ka,Oa)&&u.owns(Ka[Oa],this.id_)};K.prototype.delete=function(Ka){return sa(Ka)&&u.owns(Ka,Oa)&&u.owns(Ka[Oa],this.id_)?delete Ka[Oa][this.id_]:!1};return K},"es6","es3");\nu.polyfill("Number.isFinite",function(I){return I?I:function(K){return"number"!==typeof K?!1:!isNaN(K)&&Infinity!==K&&-Infinity!==K}},"es6","es3");u.polyfill("Number.isInteger",function(I){return I?I:function(K){return Number.isFinite(K)?K===Math.floor(K):!1}},"es6","es3");u.polyfill("Array.prototype.entries",function(I){return I?I:function(){return u.iteratorFromArray(this,function(K,Z){return[K,Z]})}},"es6","es3");\nu.polyfill("Math.fround",function(I){if(I)return I;if(u.SIMPLE_FROUND_POLYFILL||"function"!==typeof Float32Array)return function(Z){return Z};var K=new Float32Array(1);return function(Z){K[0]=Z;return K[0]}},"es6","es3");u.polyfill("Math.sign",function(I){return I?I:function(K){K=Number(K);return 0===K||isNaN(K)?K:0<K?1:-1}},"es6","es3");\nu.polyfill("Math.trunc",function(I){return I?I:function(K){K=Number(K);if(isNaN(K)||Infinity===K||-Infinity===K||0===K)return K;var Z=Math.floor(Math.abs(K));return 0>K?-Z:Z}},"es6","es3");\nu.polyfill("Promise",function(I){function K(Ba){this.state_=0;this.result_=void 0;this.onSettledCallbacks_=[];this.isRejectionHandled_=!1;var Oa=this.createResolveAndReject_();try{Ba(Oa.resolve,Oa.reject)}catch(Ea){Oa.reject(Ea)}}function Z(){this.batch_=null}function ia(Ba){return Ba instanceof K?Ba:new K(function(Oa){Oa(Ba)})}if(I&&(!(u.FORCE_POLYFILL_PROMISE||u.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION&&"undefined"===typeof u.global.PromiseRejectionEvent)||!u.global.Promise||-1===u.global.Promise.toString().indexOf("[native code]")))return I;\nZ.prototype.asyncExecute=function(Ba){if(null==this.batch_){this.batch_=[];var Oa=this;this.asyncExecuteFunction(function(){Oa.executeBatch_()})}this.batch_.push(Ba)};var sa=u.global.setTimeout;Z.prototype.asyncExecuteFunction=function(Ba){sa(Ba,0)};Z.prototype.executeBatch_=function(){for(;this.batch_&&this.batch_.length;){var Ba=this.batch_;this.batch_=[];for(var Oa=0;Oa<Ba.length;++Oa){var Ea=Ba[Oa];Ba[Oa]=null;try{Ea()}catch(Ka){this.asyncThrow_(Ka)}}}this.batch_=null};Z.prototype.asyncThrow_=\nfunction(Ba){this.asyncExecuteFunction(function(){throw Ba;})};K.prototype.createResolveAndReject_=function(){function Ba(Ka){return function(pa){Ea||(Ea=!0,Ka.call(Oa,pa))}}var Oa=this,Ea=!1;return{resolve:Ba(this.resolveTo_),reject:Ba(this.reject_)}};K.prototype.resolveTo_=function(Ba){if(Ba===this)this.reject_(new TypeError("A Promise cannot resolve to itself"));else if(Ba instanceof K)this.settleSameAsPromise_(Ba);else{a:switch(typeof Ba){case "object":var Oa=null!=Ba;break a;case "function":Oa=\n!0;break a;default:Oa=!1}Oa?this.resolveToNonPromiseObj_(Ba):this.fulfill_(Ba)}};K.prototype.resolveToNonPromiseObj_=function(Ba){var Oa=void 0;try{Oa=Ba.then}catch(Ea){this.reject_(Ea);return}"function"==typeof Oa?this.settleSameAsThenable_(Oa,Ba):this.fulfill_(Ba)};K.prototype.reject_=function(Ba){this.settle_(2,Ba)};K.prototype.fulfill_=function(Ba){this.settle_(1,Ba)};K.prototype.settle_=function(Ba,Oa){if(0!=this.state_)throw Error("Cannot settle("+Ba+", "+Oa+"): Promise already settled in state"+\nthis.state_);this.state_=Ba;this.result_=Oa;2===this.state_&&this.scheduleUnhandledRejectionCheck_();this.executeOnSettledCallbacks_()};K.prototype.scheduleUnhandledRejectionCheck_=function(){var Ba=this;sa(function(){if(Ba.notifyUnhandledRejection_()){var Oa=u.global.console;"undefined"!==typeof Oa&&Oa.error(Ba.result_)}},1)};K.prototype.notifyUnhandledRejection_=function(){if(this.isRejectionHandled_)return!1;var Ba=u.global.CustomEvent,Oa=u.global.Event,Ea=u.global.dispatchEvent;if("undefined"===\ntypeof Ea)return!0;"function"===typeof Ba?Ba=new Ba("unhandledrejection",{cancelable:!0}):"function"===typeof Oa?Ba=new Oa("unhandledrejection",{cancelable:!0}):(Ba=u.global.document.createEvent("CustomEvent"),Ba.initCustomEvent("unhandledrejection",!1,!0,Ba));Ba.promise=this;Ba.reason=this.result_;return Ea(Ba)};K.prototype.executeOnSettledCallbacks_=function(){if(null!=this.onSettledCallbacks_){for(var Ba=0;Ba<this.onSettledCallbacks_.length;++Ba)Qa.asyncExecute(this.onSettledCallbacks_[Ba]);this.onSettledCallbacks_=\nnull}};var Qa=new Z;K.prototype.settleSameAsPromise_=function(Ba){var Oa=this.createResolveAndReject_();Ba.callWhenSettled_(Oa.resolve,Oa.reject)};K.prototype.settleSameAsThenable_=function(Ba,Oa){var Ea=this.createResolveAndReject_();try{Ba.call(Oa,Ea.resolve,Ea.reject)}catch(Ka){Ea.reject(Ka)}};K.prototype.then=function(Ba,Oa){function Ea(Yb,wc){return"function"==typeof Yb?function(de){try{Ka(Yb(de))}catch(Ya){pa(Ya)}}:wc}var Ka,pa,fb=new K(function(Yb,wc){Ka=Yb;pa=wc});this.callWhenSettled_(Ea(Ba,\nKa),Ea(Oa,pa));return fb};K.prototype.catch=function(Ba){return this.then(void 0,Ba)};K.prototype.callWhenSettled_=function(Ba,Oa){function Ea(){switch(Ka.state_){case 1:Ba(Ka.result_);break;case 2:Oa(Ka.result_);break;default:throw Error("Unexpected state: "+Ka.state_);}}var Ka=this;null==this.onSettledCallbacks_?Qa.asyncExecute(Ea):this.onSettledCallbacks_.push(Ea);this.isRejectionHandled_=!0};K.resolve=ia;K.reject=function(Ba){return new K(function(Oa,Ea){Ea(Ba)})};K.race=function(Ba){return new K(function(Oa,\nEa){for(var Ka=u.makeIterator(Ba),pa=Ka.next();!pa.done;pa=Ka.next())ia(pa.value).callWhenSettled_(Oa,Ea)})};K.all=function(Ba){var Oa=u.makeIterator(Ba),Ea=Oa.next();return Ea.done?ia([]):new K(function(Ka,pa){function fb(de){return function(Ya){Yb[de]=Ya;wc--;0==wc&&Ka(Yb)}}var Yb=[],wc=0;do Yb.push(void 0),wc++,ia(Ea.value).callWhenSettled_(fb(Yb.length-1),pa),Ea=Oa.next();while(!Ea.done)})};return K},"es6","es3");\nu.polyfill("Object.getOwnPropertySymbols",function(I){return I?I:function(){return[]}},"es6","es5");u.polyfill("Object.setPrototypeOf",function(I){return I||u.setPrototypeOf},"es6","es5");u.polyfill("Object.is",function(I){return I?I:function(K,Z){return K===Z?0!==K||1/K===1/Z:K!==K&&Z!==Z}},"es6","es3");\nu.polyfill("Array.prototype.includes",function(I){return I?I:function(K,Z){var ia=this;ia instanceof String&&(ia=String(ia));var sa=ia.length;Z=Z||0;for(0>Z&&(Z=Math.max(Z+sa,0));Z<sa;Z++){var Qa=ia[Z];if(Qa===K||Object.is(Qa,K))return!0}return!1}},"es7","es3");\nu.checkStringArgs=function(I,K,Z){if(null==I)throw new TypeError("The \'this\' value for String.prototype."+Z+" must not be null or undefined");if(K instanceof RegExp)throw new TypeError("First argument to String.prototype."+Z+" must not be a regular expression");return I+""};u.polyfill("String.prototype.includes",function(I){return I?I:function(K,Z){return-1!==u.checkStringArgs(this,K,"includes").indexOf(K,Z||0)}},"es6","es3");u.MapEntry=function(){};\nu.polyfill("Map",function(I){function K(){var Ea={};return Ea.previous=Ea.next=Ea.head=Ea}function Z(Ea,Ka){var pa=Ea[1];return u.iteratorPrototype(function(){if(pa){for(;pa.head!=Ea[1];)pa=pa.previous;for(;pa.next!=pa.head;)return pa=pa.next,{done:!1,value:Ka(pa)};pa=null}return{done:!0,value:void 0}})}function ia(Ea,Ka){var pa=Ka&&typeof Ka;"object"==pa||"function"==pa?Ba.has(Ka)?pa=Ba.get(Ka):(pa=""+ ++Oa,Ba.set(Ka,pa)):pa="p_"+Ka;var fb=Ea[0][pa];if(fb&&u.owns(Ea[0],pa))for(Ea=0;Ea<fb.length;Ea++){var Yb=\nfb[Ea];if(Ka!==Ka&&Yb.key!==Yb.key||Ka===Yb.key)return{id:pa,list:fb,index:Ea,entry:Yb}}return{id:pa,list:fb,index:-1,entry:void 0}}function sa(Ea){this[0]={};this[1]=K();this.size=0;if(Ea){Ea=u.makeIterator(Ea);for(var Ka;!(Ka=Ea.next()).done;)Ka=Ka.value,this.set(Ka[0],Ka[1])}}function Qa(){if(u.ASSUME_NO_NATIVE_MAP||!I||"function"!=typeof I||!I.prototype.entries||"function"!=typeof Object.seal)return!1;try{var Ea=Object.seal({x:4}),Ka=new I(u.makeIterator([[Ea,"s"]]));if("s"!=Ka.get(Ea)||1!=Ka.size||\nKa.get({x:4})||Ka.set({x:4},"t")!=Ka||2!=Ka.size)return!1;var pa=Ka.entries(),fb=pa.next();if(fb.done||fb.value[0]!=Ea||"s"!=fb.value[1])return!1;fb=pa.next();return fb.done||4!=fb.value[0].x||"t"!=fb.value[1]||!pa.next().done?!1:!0}catch(Yb){return!1}}if(u.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS){if(I&&u.ES6_CONFORMANCE)return I}else if(Qa())return I;var Ba=new WeakMap;sa.prototype.set=function(Ea,Ka){Ea=0===Ea?0:Ea;var pa=ia(this,Ea);pa.list||(pa.list=this[0][pa.id]=[]);pa.entry?pa.entry.value=Ka:\n(pa.entry={next:this[1],previous:this[1].previous,head:this[1],key:Ea,value:Ka},pa.list.push(pa.entry),this[1].previous.next=pa.entry,this[1].previous=pa.entry,this.size++);return this};sa.prototype.delete=function(Ea){Ea=ia(this,Ea);return Ea.entry&&Ea.list?(Ea.list.splice(Ea.index,1),Ea.list.length||delete this[0][Ea.id],Ea.entry.previous.next=Ea.entry.next,Ea.entry.next.previous=Ea.entry.previous,Ea.entry.head=null,this.size--,!0):!1};sa.prototype.clear=function(){this[0]={};this[1]=this[1].previous=\nK();this.size=0};sa.prototype.has=function(Ea){return!!ia(this,Ea).entry};sa.prototype.get=function(Ea){return(Ea=ia(this,Ea).entry)&&Ea.value};sa.prototype.entries=function(){return Z(this,function(Ea){return[Ea.key,Ea.value]})};sa.prototype.keys=function(){return Z(this,function(Ea){return Ea.key})};sa.prototype.values=function(){return Z(this,function(Ea){return Ea.value})};sa.prototype.forEach=function(Ea,Ka){for(var pa=this.entries(),fb;!(fb=pa.next()).done;)fb=fb.value,Ea.call(Ka,fb[1],fb[0],\nthis)};sa.prototype[Symbol.iterator]=sa.prototype.entries;var Oa=0;return sa},"es6","es3");\nu.polyfill("Set",function(I){function K(ia){this.map_=new Map;if(ia){ia=u.makeIterator(ia);for(var sa;!(sa=ia.next()).done;)this.add(sa.value)}this.size=this.map_.size}function Z(){if(u.ASSUME_NO_NATIVE_SET||!I||"function"!=typeof I||!I.prototype.entries||"function"!=typeof Object.seal)return!1;try{var ia=Object.seal({x:4}),sa=new I(u.makeIterator([ia]));if(!sa.has(ia)||1!=sa.size||sa.add(ia)!=sa||1!=sa.size||sa.add({x:4})!=sa||2!=sa.size)return!1;var Qa=sa.entries(),Ba=Qa.next();if(Ba.done||Ba.value[0]!=\nia||Ba.value[1]!=ia)return!1;Ba=Qa.next();return Ba.done||Ba.value[0]==ia||4!=Ba.value[0].x||Ba.value[1]!=Ba.value[0]?!1:Qa.next().done}catch(Oa){return!1}}if(u.USE_PROXY_FOR_ES6_CONFORMANCE_CHECKS){if(I&&u.ES6_CONFORMANCE)return I}else if(Z())return I;K.prototype.add=function(ia){ia=0===ia?0:ia;this.map_.set(ia,ia);this.size=this.map_.size;return this};K.prototype.delete=function(ia){ia=this.map_.delete(ia);this.size=this.map_.size;return ia};K.prototype.clear=function(){this.map_.clear();this.size=\n0};K.prototype.has=function(ia){return this.map_.has(ia)};K.prototype.entries=function(){return this.map_.entries()};K.prototype.values=function(){return this.map_.values()};K.prototype.keys=K.prototype.values;K.prototype[Symbol.iterator]=K.prototype.values;K.prototype.forEach=function(ia,sa){var Qa=this;this.map_.forEach(function(Ba){return ia.call(sa,Ba,Ba,Qa)})};return K},"es6","es3");\nu.polyfill("String.prototype.trimRight",function(I){function K(){return this.replace(/[\\s\\xa0]+$/,"")}return I||K},"es_2019","es3");u.polyfill("String.prototype.trimEnd",function(I){return I||String.prototype.trimRight},"es_2019","es3");\nu.polyfill("Math.hypot",function(I){return I?I:function(K){if(2>arguments.length)return arguments.length?Math.abs(arguments[0]):0;var Z,ia,sa;for(Z=sa=0;Z<arguments.length;Z++)sa=Math.max(sa,Math.abs(arguments[Z]));if(1E100<sa||1E-100>sa){if(!sa)return sa;for(Z=ia=0;Z<arguments.length;Z++){var Qa=Number(arguments[Z])/sa;ia+=Qa*Qa}return Math.sqrt(ia)*sa}for(Z=ia=0;Z<arguments.length;Z++)Qa=Number(arguments[Z]),ia+=Qa*Qa;return Math.sqrt(ia)}},"es6","es3");\nu.polyfill("Array.prototype.values",function(I){return I?I:function(){return u.iteratorFromArray(this,function(K,Z){return Z})}},"es8","es3");u.atMethod=function(I){I=Math.trunc(I)||0;0>I&&(I+=this.length);if(!(0>I||I>=this.length))return this[I]};u.polyfill("Array.prototype.at",function(I){return I?I:u.atMethod},"es_next","es5");u.typedArrayAt=function(I){return I?I:u.atMethod};u.polyfill("Int8Array.prototype.at",u.typedArrayAt,"es_next","es5");\nu.polyfill("Uint8Array.prototype.at",u.typedArrayAt,"es_next","es5");u.polyfill("Uint8ClampedArray.prototype.at",u.typedArrayAt,"es_next","es5");u.polyfill("Int16Array.prototype.at",u.typedArrayAt,"es_next","es5");u.polyfill("Uint16Array.prototype.at",u.typedArrayAt,"es_next","es5");u.polyfill("Int32Array.prototype.at",u.typedArrayAt,"es_next","es5");u.polyfill("Uint32Array.prototype.at",u.typedArrayAt,"es_next","es5");u.polyfill("Float32Array.prototype.at",u.typedArrayAt,"es_next","es5");\nu.polyfill("Float64Array.prototype.at",u.typedArrayAt,"es_next","es5");u.polyfill("String.prototype.at",function(I){return I?I:u.atMethod},"es_next","es5");u.polyfill("Array.prototype.fill",function(I){return I?I:function(K,Z,ia){var sa=this.length||0;0>Z&&(Z=Math.max(0,sa+Z));if(null==ia||ia>sa)ia=sa;ia=Number(ia);0>ia&&(ia=Math.max(0,sa+ia));for(Z=Number(Z||0);Z<ia;Z++)this[Z]=K;return this}},"es6","es3");u.typedArrayFill=function(I){return I?I:Array.prototype.fill};\nu.polyfill("Int8Array.prototype.fill",u.typedArrayFill,"es6","es5");u.polyfill("Uint8Array.prototype.fill",u.typedArrayFill,"es6","es5");u.polyfill("Uint8ClampedArray.prototype.fill",u.typedArrayFill,"es6","es5");u.polyfill("Int16Array.prototype.fill",u.typedArrayFill,"es6","es5");u.polyfill("Uint16Array.prototype.fill",u.typedArrayFill,"es6","es5");u.polyfill("Int32Array.prototype.fill",u.typedArrayFill,"es6","es5");u.polyfill("Uint32Array.prototype.fill",u.typedArrayFill,"es6","es5");\nu.polyfill("Float32Array.prototype.fill",u.typedArrayFill,"es6","es5");u.polyfill("Float64Array.prototype.fill",u.typedArrayFill,"es6","es5");u.findLastInternal=function(I,K,Z){I instanceof String&&(I=String(I));for(var ia=I.length-1;0<=ia;ia--){var sa=I[ia];if(K.call(Z,sa,ia,I))return{i:ia,v:sa}}return{i:-1,v:void 0}};u.polyfill("Array.prototype.findLastIndex",function(I){return I?I:function(K,Z){return u.findLastInternal(this,K,Z).i}},"es_next","es3");\nu.typedArrayFindLastIndex=function(I){return I?I:function(K,Z){return u.findLastInternal(this,K,Z).i}};u.polyfill("Int8Array.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");u.polyfill("Uint8Array.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");u.polyfill("Uint8ClampedArray.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");u.polyfill("Int16Array.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");\nu.polyfill("Uint16Array.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");u.polyfill("Int32Array.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");u.polyfill("Uint32Array.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");u.polyfill("Float32Array.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");u.polyfill("Float64Array.prototype.findLastIndex",u.typedArrayFindLastIndex,"es_next","es5");\nu.polyfill("Array.prototype.findLast",function(I){return I?I:function(K,Z){return u.findLastInternal(this,K,Z).v}},"es_next","es3");u.typedArrayFindLast=function(I){return I?I:function(K,Z){return u.findLastInternal(this,K,Z).v}};u.polyfill("Int8Array.prototype.findLast",u.typedArrayFindLast,"es_next","es5");u.polyfill("Uint8Array.prototype.findLast",u.typedArrayFindLast,"es_next","es5");u.polyfill("Uint8ClampedArray.prototype.findLast",u.typedArrayFindLast,"es_next","es5");\nu.polyfill("Int16Array.prototype.findLast",u.typedArrayFindLast,"es_next","es5");u.polyfill("Uint16Array.prototype.findLast",u.typedArrayFindLast,"es_next","es5");u.polyfill("Int32Array.prototype.findLast",u.typedArrayFindLast,"es_next","es5");u.polyfill("Uint32Array.prototype.findLast",u.typedArrayFindLast,"es_next","es5");u.polyfill("Float32Array.prototype.findLast",u.typedArrayFindLast,"es_next","es5");u.polyfill("Float64Array.prototype.findLast",u.typedArrayFindLast,"es_next","es5");\nu.polyfill("globalThis",function(I){return I||u.global},"es_2020","es3");u.polyfill("String.prototype.startsWith",function(I){return I?I:function(K,Z){var ia=u.checkStringArgs(this,K,"startsWith");K+="";var sa=ia.length,Qa=K.length;Z=Math.max(0,Math.min(Z|0,ia.length));for(var Ba=0;Ba<Qa&&Z<sa;)if(ia[Z++]!=K[Ba++])return!1;return Ba>=Qa}},"es6","es3");\nu.polyfill("String.prototype.repeat",function(I){return I?I:function(K){var Z=u.checkStringArgs(this,null,"repeat");if(0>K||1342177279<K)throw new RangeError("Invalid count value");K|=0;for(var ia="";K;)if(K&1&&(ia+=Z),K>>>=1)Z+=Z;return ia}},"es6","es3");u.stringPadding=function(I,K){I=void 0!==I?String(I):" ";return 0<K&&I?I.repeat(Math.ceil(K/I.length)).substring(0,K):""};\nu.polyfill("String.prototype.padStart",function(I){return I?I:function(K,Z){var ia=u.checkStringArgs(this,null,"padStart");return u.stringPadding(Z,K-ia.length)+ia}},"es8","es3");\nu.polyfill("String.prototype.replaceAll",function(I){return I?I:function(K,Z){if(K instanceof RegExp&&!K.global)throw new TypeError("String.prototype.replaceAll called with a non-global RegExp argument.");return K instanceof RegExp?this.replace(K,Z):this.replace(new RegExp(String(K).replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g,"\\\\$1").replace(/\\x08/g,"\\\\x08"),"g"),Z)}},"es_2021","es3");\nu.polyfill("Object.values",function(I){return I?I:function(K){var Z=[],ia;for(ia in K)u.owns(K,ia)&&Z.push(K[ia]);return Z}},"es8","es3");u.polyfill("Object.entries",function(I){return I?I:function(K){var Z=[],ia;for(ia in K)u.owns(K,ia)&&Z.push([ia,K[ia]]);return Z}},"es8","es3");u.polyfill("Math.log2",function(I){return I?I:function(K){return Math.log(K)/Math.LN2}},"es6","es3");\nu.polyfill("String.prototype.codePointAt",function(I){return I?I:function(K){var Z=u.checkStringArgs(this,null,"codePointAt"),ia=Z.length;K=Number(K)||0;if(0<=K&&K<ia){K|=0;var sa=Z.charCodeAt(K);if(55296>sa||56319<sa||K+1===ia)return sa;K=Z.charCodeAt(K+1);return 56320>K||57343<K?sa:1024*(sa-55296)+K+9216}}},"es6","es3");\nu.assign=u.TRUST_ES6_POLYFILLS&&"function"==typeof Object.assign?Object.assign:function(I,K){for(var Z=1;Z<arguments.length;Z++){var ia=arguments[Z];if(ia)for(var sa in ia)u.owns(ia,sa)&&(I[sa]=ia[sa])}return I};u.polyfill("Object.assign",function(I){return I||u.assign},"es6","es3");\nu.polyfill("Array.prototype.copyWithin",function(I){function K(Z){Z=Number(Z);return Infinity===Z||-Infinity===Z?Z:Z|0}return I?I:function(Z,ia,sa){var Qa=this.length;Z=K(Z);ia=K(ia);sa=void 0===sa?Qa:K(sa);Z=0>Z?Math.max(Qa+Z,0):Math.min(Z,Qa);ia=0>ia?Math.max(Qa+ia,0):Math.min(ia,Qa);sa=0>sa?Math.max(Qa+sa,0):Math.min(sa,Qa);if(Z<ia)for(;ia<sa;)ia in this?this[Z++]=this[ia++]:(delete this[Z++],ia++);else for(sa=Math.min(sa,Qa+ia-Z),Z+=sa-ia;sa>ia;)--sa in this?this[--Z]=this[sa]:delete this[--Z];\nreturn this}},"es6","es3");u.typedArrayCopyWithin=function(I){return I?I:Array.prototype.copyWithin};u.polyfill("Int8Array.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");u.polyfill("Uint8Array.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");u.polyfill("Uint8ClampedArray.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");u.polyfill("Int16Array.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");\nu.polyfill("Uint16Array.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");u.polyfill("Int32Array.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");u.polyfill("Uint32Array.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");u.polyfill("Float32Array.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");u.polyfill("Float64Array.prototype.copyWithin",u.typedArrayCopyWithin,"es6","es5");\nu.polyfill("String.fromCodePoint",function(I){return I?I:function(K){for(var Z="",ia=0;ia<arguments.length;ia++){var sa=Number(arguments[ia]);if(0>sa||1114111<sa||sa!==Math.floor(sa))throw new RangeError("invalid_code_point "+sa);65535>=sa?Z+=String.fromCharCode(sa):(sa-=65536,Z+=String.fromCharCode(sa>>>10&1023|55296),Z+=String.fromCharCode(sa&1023|56320))}return Z}},"es6","es3");u.polyfill("Math.log10",function(I){return I?I:function(K){return Math.log(K)/Math.LN10}},"es6","es3");\nu.polyfill("Promise.prototype.finally",function(I){return I?I:function(K){return this.then(function(Z){return Promise.resolve(K()).then(function(){return Z})},function(Z){return Promise.resolve(K()).then(function(){throw Z;})})}},"es9","es3");u.polyfill("Number.isNaN",function(I){return I?I:function(K){return"number"===typeof K&&isNaN(K)}},"es6","es3");\nu.polyfill("String.prototype.endsWith",function(I){return I?I:function(K,Z){var ia=u.checkStringArgs(this,K,"endsWith");K+="";void 0===Z&&(Z=ia.length);Z=Math.max(0,Math.min(Z|0,ia.length));for(var sa=K.length;0<sa&&0<Z;)if(ia[--Z]!=K[--sa])return!1;return 0>=sa}},"es6","es3");u.findInternal=function(I,K,Z){I instanceof String&&(I=String(I));for(var ia=I.length,sa=0;sa<ia;sa++){var Qa=I[sa];if(K.call(Z,Qa,sa,I))return{i:sa,v:Qa}}return{i:-1,v:void 0}};\nu.polyfill("Array.prototype.find",function(I){return I?I:function(K,Z){return u.findInternal(this,K,Z).v}},"es6","es3");u.polyfill("Array.prototype.flat",function(I){return I?I:function(K){K=void 0===K?1:K;var Z=[];Array.prototype.forEach.call(this,function(ia){Array.isArray(ia)&&0<K?(ia=Array.prototype.flat.call(ia,K-1),Z.push.apply(Z,ia)):Z.push(ia)});return Z}},"es9","es5");u.objectCreate=u.ASSUME_ES5||"function"==typeof Object.create?Object.create:function(I){function K(){}K.prototype=I;return new K};\nu.getConstructImplementation=function(){function I(){function Z(){}new Z;Reflect.construct(Z,[],function(){});return new Z instanceof Z}if(u.TRUST_ES6_POLYFILLS&&"undefined"!=typeof Reflect&&Reflect.construct){if(I())return Reflect.construct;var K=Reflect.construct;return function(Z,ia,sa){Z=K(Z,ia);sa&&Reflect.setPrototypeOf(Z,sa.prototype);return Z}}return function(Z,ia,sa){void 0===sa&&(sa=Z);sa=u.objectCreate(sa.prototype||Object.prototype);return Function.prototype.apply.call(Z,sa,ia)||sa}};\nu.construct={valueOf:u.getConstructImplementation}.valueOf();u.polyfill("Reflect.construct",function(){return u.construct},"es6","es3");u.polyfill("Array.prototype.findIndex",function(I){return I?I:function(K,Z){return u.findInternal(this,K,Z).i}},"es6","es3");\nu.polyfill("Promise.allSettled",function(I){function K(ia){return{status:"fulfilled",value:ia}}function Z(ia){return{status:"rejected",reason:ia}}return I?I:function(ia){var sa=this;ia=Array.from(ia,function(Qa){return sa.resolve(Qa).then(K,Z)});return sa.all(ia)}},"es_2020","es3");\n(function(){function I(K,Z,ia){function sa(Oa,Ea){if(!Z[Oa]){if(!K[Oa]){var Ka="function"==typeof require&&require;if(!Ea&&Ka)return Ka(Oa,!0);if(Qa)return Qa(Oa,!0);Ea=Error("Cannot find module \'"+Oa+"\'");throw Ea.code="MODULE_NOT_FOUND",Ea;}Ea=Z[Oa]={exports:{}};K[Oa][0].call(Ea.exports,function(pa){return sa(K[Oa][1][pa]||pa)},Ea,Ea.exports,I,K,Z,ia)}return Z[Oa].exports}for(var Qa="function"==typeof require&&require,Ba=0;Ba<ia.length;Ba++)sa(ia[Ba]);return sa}return I})()({1:[function(I,K,Z){(function(){function ia(a){var c=\nvoid 0===a.dict?null:a.dict,b=void 0===a.mcid?null:a.mcid,d=void 0===a.pageObjId?null:a.pageObjId,e=void 0===a.refObjId?null:a.refObjId;this.type=a.type;this.dict=c;this.mcid=b;this.pageObjId=d;this.refObjId=e;this.parentNode=null}function sa(a){var c=a.flags,b=a.yCoordinates;this.xCoordinates=a.xCoordinates;this.yCoordinates=b;this.flags=c}function Qa(a,c,b,d){this.predefined=a;this.format=c;this.encoding=b;this.raw=d}function Ba(a,c,b,d){this.predefined=a;this.format=c;this.charset=b;this.raw=d}\nfunction Oa(a,c,b,d){this.major=a;this.minor=c;this.hdrSize=b;this.offSize=d}function Ea(a){2===a.length?(this.isOOB=!0,this.rangeLow=0,this.prefixLength=a[0],this.rangeLength=0,this.prefixCode=a[1],this.isLowerRange=!1):(this.isOOB=!1,this.rangeLow=a[0],this.prefixLength=a[1],this.rangeLength=a[2],this.prefixCode=a[3],this.isLowerRange="lower"===a[4])}function Ka(){return Ka}function pa(a){var c=ck[a];if(void 0!==c)return c.exports;c=ck[a]={exports:{}};ep[a].call(c.exports,c,c.exports,pa);return c.exports}\nfunction fb(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Yb(a,c,b){return c&&fb(a.prototype,c),b&&fb(a,b),Object.defineProperty(a,\n"prototype",{writable:!1}),a}function wc(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;de(a,c)}function de(a,c){return de=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},de(a,c)}function Ya(a){Wf>=ef.INFOS&&console.log("Info: "+a)}function T(a){Wf>=ef.WARNINGS&&console.log("Warning: "+a)}function db(a){throw Error(a);}function xc(a,c){a||db(c)}function Xf(a,c,b){void 0===c&&(c=null);void 0===b&&(b=null);if(!a)return null;try{if(b&&"string"===\ntypeof a){if(b.addDefaultProtocol&&a.startsWith("www.")){var d=a.match(/\\./g);2<=(null==d?void 0:d.length)&&(a="http://"+a)}if(b.tryConvertEncoding)try{a=decodeURIComponent(escape(a))}catch(f){}}var e=c?new URL(a,c):new URL(a);a:switch(null==e?void 0:e.protocol){case "http:":case "https:":case "ftp:":case "mailto:":case "tel:":var g=!0;break a;default:g=!1}if(g)return e}catch(f){}return null}function Fa(a,c,b,d){void 0===d&&(d=!1);Object.defineProperty(a,c,{value:b,enumerable:!d,configurable:!0,writable:!1});\nreturn b}function Ec(a){"object"===typeof a&&void 0!==(null==a?void 0:a.length)||db("Invalid argument for bytesToString");var c=a.length;if(8192>c)return String.fromCharCode.apply(null,a);for(var b=[],d=0;d<c;d+=8192){var e=a.subarray(d,Math.min(d+8192,c));b.push(String.fromCharCode.apply(null,e))}return b.join("")}function jc(a){"string"!==typeof a&&db("Invalid argument for stringToBytes");for(var c=a.length,b=new Uint8Array(c),d=0;d<c;++d)b[d]=a.charCodeAt(d)&255;return b}function kc(a){return String.fromCharCode(a>>\n24&255,a>>16&255,a>>8&255,a&255)}function ib(a){if("\\u00ef"<=a[0]){if("\\u00fe"===a[0]&&"\\u00ff"===a[1]){var c="utf-16be";1===a.length%2&&(a=a.slice(0,-1))}else"\\u00ff"===a[0]&&"\\u00fe"===a[1]?(c="utf-16le",1===a.length%2&&(a=a.slice(0,-1))):"\\u00ef"===a[0]&&"\\u00bb"===a[1]&&"\\u00bf"===a[2]&&(c="utf-8");if(c)try{var b=new TextDecoder(c,{fatal:!0}),d=jc(a),e=b.decode(d);return e.includes("\\u001b")?e.replaceAll(/\\x1b[^\\x1b]*(?:\\x1b|$)/g,""):e}catch(g){T(\'stringToPDFString: "\'+g+\'".\')}}c=[];b=0;for(d=\na.length;b<d;b++)if(e=a.charCodeAt(b),27===e)for(;++b<d&&27!==a.charCodeAt(b););else e=fp[e],c.push(e?String.fromCharCode(e):a.charAt(b));return c.join("")}function ee(a,c){if(a.length!==c.length)return!1;for(var b=0,d=a.length;b<d;b++)if(a[b]!==c[b])return!1;return!0}function rd(a){void 0===a&&(a=new Date);return[a.getUTCFullYear().toString(),(a.getUTCMonth()+1).toString().padStart(2,"0"),a.getUTCDate().toString().padStart(2,"0"),a.getUTCHours().toString().padStart(2,"0"),a.getUTCMinutes().toString().padStart(2,\n"0"),a.getUTCSeconds().toString().padStart(2,"0")].join("")}function gp(a){bh||(bh=/([\\u00a0\\u00b5\\u037e\\u0eb3\\u2000-\\u200a\\u202f\\u2126\\ufb00-\\ufb04\\ufb06\\ufb20-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40-\\ufb41\\ufb43-\\ufb44\\ufb46-\\ufba1\\ufba4-\\ufba9\\ufbae-\\ufbb1\\ufbd3-\\ufbdc\\ufbde-\\ufbe7\\ufbea-\\ufbf8\\ufbfc-\\ufbfd\\ufc00-\\ufc5d\\ufc64-\\ufcf1\\ufcf5-\\ufd3d\\ufd88\\ufdf4\\ufdfa-\\ufdfb\\ufe71\\ufe77\\ufe79\\ufe7b\\ufe7d]+)|(\\ufb05+)/gu,dk=new Map([["\\ufb05","\\u017ft"]]));return a.replaceAll(bh,function(c,b,d){return b?b.normalize("NFKC"):\ndk.get(d)})}function ek(a){return Uint8Array.prototype.toHex?a.toHex():Array.from(a,function(c){return Be[c]}).join("")}function hp(a){return Uint8Array.fromBase64?Uint8Array.fromBase64(a):jc(atob(a))}function fk(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function ip(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){fk(h,d,e,g,f,"next",k)}function f(k){fk(h,d,e,g,f,"throw",k)}var h=a.apply(c,\nb);g(void 0)})}}function gk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function hk(a,c,b){return c&&gk(a.prototype,c),b&&gk(a,b),Object.defineProperty(a,\n"prototype",{writable:!1}),a}function Lb(a,c){return a instanceof ka&&(void 0===c||a.name===c)}function Ub(a,c){return a instanceof Vb&&(void 0===c||a.cmd===c)}function ik(a,c){return a instanceof ca&&(void 0===c||Lb(a.get("Type"),c))}function Yf(a,c){return a.num===c.num&&a.gen===c.gen}function jk(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function ch(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){jk(h,\nd,e,g,f,"next",k)}function f(k){jk(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function kk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:\nf+"",d)}}function jp(a,c,b){return c&&kk(a.prototype,c),b&&kk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Zf(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;dh(a,c)}function dh(a,c){return dh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},dh(a,c)}function xb(a){var c;return function(){a&&(c=Object.create(null),a(c),a=null);return c}}function lk(a){var c=a.length;if(0===c)return new Uint8Array(0);if(1===c)return new Uint8Array(a[0]);\nfor(var b=0,d=0;d<c;d++)b+=a[d].byteLength;b=new Uint8Array(b);for(var e=d=0;e<c;e++){var g=new Uint8Array(a[e]);b.set(g,d);d+=g.byteLength}return b}function Yc(a){var c=a.dict,b=a.key,d=void 0===a.getArray?!1:a.getArray;a=void 0===a.stopWhenFound?!0:a.stopWhenFound;for(var e,g=new Zb;c instanceof ca&&(!c.objId||!g.has(c.objId));){c.objId&&g.put(c.objId);var f=d?c.getArray(b):c.get(b);if(void 0!==f){if(a)return f;(e||(e=[])).push(f)}c=c.get("Parent")}return e}function eh(a){return 0>=a?0:Math.ceil(Math.log2(a))}\nfunction yb(a,c){return a[c]<<8|a[c+1]}function zb(a,c){return(a[c]<<24|a[c+1]<<16|a[c+2]<<8|a[c+3])>>>0}function Lc(a){return 32===a||9===a||13===a||10===a}function kp(a,c){return Array.isArray(a)&&(null===c||a.length===c)&&a.every(function(b){return"boolean"===typeof b})}function yc(a,c){return Array.isArray(a)?(null===c||a.length===c)&&a.every(function(b){return"number"===typeof b}):ArrayBuffer.isView(a)&&(0===a.length||"number"===typeof a[0])&&(null===c||a.length===c)}function Md(a,c){return yc(a,\n6)?a:c}function fh(a,c){return yc(a,4)?a:c}function sd(a,c){return yc(a,4)?Rb.normalizeRect(a):c}function mk(a){var c=/(.+)\\[(\\d+)\\]$/;return a.split(".").map(function(b){var d=b.match(c);return d?{name:d[1],pos:parseInt(d[2],10)}:{name:b,pos:0}})}function gh(a){for(var c=[],b=0,d=0,e=a.length;d<e;d++){var g=a.charCodeAt(d);if(33>g||126<g||35===g||40===g||41===g||60===g||62===g||91===g||93===g||123===g||125===g||47===g||37===g)b<d&&c.push(a.substring(b,d)),c.push("#"+g.toString(16)),b=d+1}if(0===\nc.length)return a;b<a.length&&c.push(a.substring(b,a.length));return c.join("")}function Ce(a){return a.replaceAll(/([()\\\\\\n\\r])/g,function(c){return"\\n"===c?"\\\\n":"\\r"===c?"\\\\r":"\\\\"+c})}function $f(a,c,b,d){if(a){var e=null;if(a instanceof Ha){if(d.has(a))return;e=a;d.put(e);a=c.fetch(a)}if(Array.isArray(a)){a=u.makeIterator(a);for(var g=a.next();!g.done;g=a.next())$f(g.value,c,b,d)}else if(a instanceof ca){if(Lb(a.get("S"),"JavaScript")){g=a.get("JS");var f;g instanceof $a?f=g.getString():"string"===\ntypeof g&&(f=g);f&&(f=ib(f).replaceAll("\\x00",""));f&&b.push(f)}$f(a.getRaw("Next"),c,b,d)}e&&d.remove(e)}}function ag(a,c,b){var d=Object.create(null),e=Yc({dict:c,key:"AA",stopWhenFound:!1});if(e)for(var g=e.length-1;0<=g;g--){var f=e[g];if(f instanceof ca)for(var h=u.makeIterator(f.getKeys()),k=h.next();!k.done;k=h.next()){var l=k.value;if(k=b[l]){l=f.getRaw(l);var m=new Zb,n=[];$f(l,a,n,m);0<n.length&&(d[k]=n)}}}c.has("A")&&(c=c.get("A"),b=new Zb,e=[],$f(c,a,e,b),0<e.length&&(d.Action=e));return 0<\nObject.keys(d).length?d:null}function nk(a){var c,b,d;return u.generator.createGenerator(nk,function(e){1==e.nextAddress&&(c=0,b=a.length);if(3!=e.nextAddress){if(!(c<b))return e.jumpTo(0);d=a.codePointAt(c);55295<d&&(57344>d||65533<d)&&c++;return e.yield(d,3)}c++;return e.jumpTo(2)})}function De(a){for(var c=[],b=0,d=0,e=a.length;d<e;d++){var g=a.codePointAt(d);if(32<=g&&126>=g){if(g=lp[g])b<d&&c.push(a.substring(b,d)),c.push(g),b=d+1}else b<d&&c.push(a.substring(b,d)),c.push("&#x"+g.toString(16).toUpperCase()+\n";"),55295<g&&(57344>g||65533<g)&&d++,b=d+1}if(0===c.length)return a;b<a.length&&c.push(a.substring(b,a.length));return c.join("")}function hh(a,c){void 0===c&&(c=!1);var b=/^("|\').*("|\')$/.exec(a);if(b&&b[1]===b[2]){if((new RegExp("[^\\\\\\\\]"+b[1])).test(a.slice(1,-1)))return c&&T("FontFamily contains unescaped "+b[1]+": "+a+"."),!1}else{b=u.makeIterator(a.split(/[ \\t]+/));for(var d=b.next();!d.done;d=b.next())if(d=d.value,/^(\\d|(-(\\d|-)))/.test(d)||!/^[\\w-\\\\]+$/.test(d))return c&&T("FontFamily contains invalid <custom-ident>: "+\na+"."),!1}return!0}function mp(a){var c=new Set("100 200 300 400 500 600 700 800 900 1000 normal bold bolder lighter".split(" ")),b=a.fontWeight,d=a.italicAngle;if(!hh(a.fontFamily,!0))return!1;b=b?b.toString():"";a.fontWeight=c.has(b)?b:"400";c=parseFloat(d);a.italicAngle=isNaN(c)||-90>c||90<c?"14":d.toString();return!0}function ok(a){a=RegExp("^\\\\s*(app\\\\.launchURL|window\\\\.open|xfa\\\\.host\\\\.gotoURL)\\\\((?:\'|\\")([^\'\\"]*)(?:\'|\\")(?:,\\\\s*(\\\\w+)\\\\)|\\\\))","i").exec(a);if(null!=a&&a[2]){var c=a[2],b=\n!1;"true"===a[3]&&"app.launchURL"===a[1]&&(b=!0);return{url:c,newWindow:b}}return null}function ob(a){if(Number.isInteger(a))return a.toString();var c=Math.round(100*a);return 0===c%100?(c/100).toString():0===c%10?a.toFixed(1):a.toFixed(2)}function pk(a){if(!a)return null;var c=new Map;a=u.makeIterator(a);for(var b=a.next();!b.done;b=a.next()){var d=u.makeIterator(b.value);b=d.next().value;d=d.next().value;b.startsWith("pdfjs_internal_editor_")&&(b=c.get(d.pageIndex),b||(b=[],c.set(d.pageIndex,b)),\nb.push(d))}return 0<c.size?c:null}function hd(a){return/^[\\x00-\\x7F]*$/.test(a)?a:qk(a,!0)}function qk(a,c){void 0===c&&(c=!1);var b=[];c&&b.push("\\u00fe\\u00ff");c=0;for(var d=a.length;c<d;c++){var e=a.charCodeAt(c);b.push(String.fromCharCode(e>>8&255),String.fromCharCode(e&255))}return b.join("")}function bg(a,c,b){switch(a){case 90:return[0,1,-1,0,c,0];case 180:return[-1,0,0,-1,c,b];case 270:return[0,-1,1,0,0,b];default:throw Error("Invalid rotation");}}function rk(a,c){for(var b=0;b<c.length;b++){var d=\nc[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function np(a,c,b){return c&&rk(a.prototype,c),b&&rk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function ih(a,c){a.prototype=\nObject.create(c.prototype);a.prototype.constructor=a;jh(a,c)}function jh(a,c){return jh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},jh(a,c)}function sk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function op(a,c,b){return c&&sk(a.prototype,c),b&&sk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function pp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;kh(a,c)}function kh(a,c){return kh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},kh(a,c)}function td(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;lh(a,c)}function lh(a,c){return lh=Object.setPrototypeOf?\nObject.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},lh(a,c)}function tk(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function qp(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){tk(h,d,e,g,f,"next",k)}function f(k){tk(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function uk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in\nd&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function vk(a,c,b){return c&&uk(a.prototype,c),b&&uk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function wk(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?\nc(k):Promise.resolve(k).then(d,e)}function rp(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){wk(h,d,e,g,f,"next",k)}function f(k){wk(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function nc(a,c){for(var b=0,d=0;d<=c;d++)b=b<<8|a[d];return b>>>0}function cg(a,c){return 1===c?String.fromCharCode(a[0],a[1]):3===c?String.fromCharCode(a[0],a[1],a[2],a[3]):String.fromCharCode.apply(String,u.arrayFromIterable(a.subarray(0,c+1)))}function zc(a,c,b){for(var d=\n0;0<=b;b--)d+=a[b]+c[b],a[b]=d&255,d>>=8}function fe(a,c){for(var b=1;0<=c&&0<b;c--)b+=a[c],a[c]=b&255,b>>=8}function xk(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function sp(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){xk(h,d,e,g,f,"next",k)}function f(k){xk(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function yk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||\n!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function tp(a,c,b){return c&&yk(a.prototype,c),b&&yk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function zk(a,c){a.prototype=Object.create(c.prototype);\na.prototype.constructor=a;mh(a,c)}function mh(a,c){return mh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},mh(a,c)}function up(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;nh(a,c)}function nh(a,c){return nh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},nh(a,c)}function vp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;oh(a,c)}function oh(a,c){return oh=Object.setPrototypeOf?\nObject.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},oh(a,c)}function wp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;ph(a,c)}function ph(a,c){return ph=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},ph(a,c)}function Ak(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function qh(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){Ak(h,\nd,e,g,f,"next",k)}function f(k){Ak(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Bk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:\nf+"",d)}}function xp(a,c,b){return c&&Bk(a.prototype,c),b&&Bk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function yp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;rh(a,c)}function rh(a,c){return rh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},rh(a,c)}function zp(a){var c,b,d,e=2;for("undefined"!=typeof Symbol&&(b=Symbol.asyncIterator,d=Symbol.iterator);e--;){if(b&&null!=(c=a[b]))return c.call(a);if(d&&null!=(c=a[d]))return new dg(c.call(a));\nb="@@asyncIterator";d="@@iterator"}throw new TypeError("Object is not async iterable");}function dg(a){function c(b){if(Object(b)!==b)return Promise.reject(new TypeError(b+" is not an object."));var d=b.done;return Promise.resolve(b.value).then(function(e){return{value:e,done:d}})}return dg=function(b){this.s=b;this.n=b.next},dg.prototype={s:null,n:null,next:function(){return c(this.n.apply(this.s,arguments))},return:function(b){var d=this.s.return;return void 0===d?Promise.resolve({value:b,done:!0}):\nc(d.apply(this.s,arguments))},throw:function(b){var d=this.s.return;return void 0===d?Promise.reject(b):c(d.apply(this.s,arguments))}},new dg(a)}function Ck(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Ap(a,c,b){return c&&Ck(a.prototype,c),b&&Ck(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Bp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;sh(a,c)}function sh(a,c){return sh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},sh(a,c)}function oc(a,c,b){function d(h){for(var k=0,l=0;l<h;l++){var m=b.readBit(e,g);g=256>g?g<<1|m:(g<<1|m)&511|256;k=k<<1|m}return k>>>\n0}var e=a.getContexts(c),g=1;a=d(1);c=d(1)?d(1)?d(1)?d(1)?d(1)?d(32)+4436:d(12)+340:d(8)+84:d(6)+20:d(4)+4:d(2);var f;0===a?f=c:0<c&&(f=-c);return f>=Cp&&f<=Dp?f:null}function Dk(a,c,b){a=a.getContexts("IAID");for(var d=1,e=0;e<b;e++){var g=c.readBit(a,d);d=d<<1|g}return 31>b?d&(1<<b)-1:d&2147483647}function Ep(a,c,b){var d=b.decoder;b=b.contextCache.getContexts("GB");var e=[],g,f,h;for(g=0;g<c;g++){var k=e[g]=new Uint8Array(a);var l=1>g?k:e[g-1];var m=2>g?k:e[g-2];var n=m[0]<<13|m[1]<<12|m[2]<<11|\nl[0]<<7|l[1]<<6|l[2]<<5|l[3]<<4;for(f=0;f<a;f++)k[f]=h=d.readBit(b,n),n=(n&31735)<<1|(f+3<a?m[f+3]<<11:0)|(f+4<a?l[f+4]<<4:0)|h}return e}function eg(a,c,b,d,e,g,f,h){if(a)return e=new ff(h.data,h.start,h.end),th(e,c,b,!1);if(0===d&&!g&&!e&&4===f.length&&3===f[0].x&&-1===f[0].y&&-3===f[1].x&&-1===f[1].y&&2===f[2].x&&-2===f[2].y&&-2===f[3].x&&-2===f[3].y)return Ep(c,b,h);a=!!g;var k=Fp[d].concat(f);k.sort(function(L,M){return L.y-M.y||L.x-M.x});f=k.length;var l=new Int8Array(f),m=new Int8Array(f),n=\n[],p=0,q=0,r=0,t=0,v,w;for(w=0;w<f;w++)l[w]=k[w].x,m[w]=k[w].y,q=Math.min(q,k[w].x),r=Math.max(r,k[w].x),t=Math.min(t,k[w].y),w<f-1&&k[w].y===k[w+1].y&&k[w].x===k[w+1].x-1?p|=1<<f-1-w:n.push(w);var y=n.length,x=new Int8Array(y),z=new Int8Array(y),A=new Uint16Array(y);for(v=0;v<y;v++)w=n[v],x[v]=k[w].x,z[v]=k[w].y,A[v]=1<<f-1-w;k=-q;t=-t;r=c-r;d=Gp[d];n=new Uint8Array(c);q=[];v=h.decoder;h=h.contextCache.getContexts("GB");for(var B=0,C,D,E,G=0,J,F=0;F<b;F++){if(e&&(w=v.readBit(h,d),B^=w)){q.push(n);\ncontinue}n=new Uint8Array(n);q.push(n);for(C=0;C<c;C++)if(a&&g[F][C])n[C]=0;else{if(C>=k&&C<r&&F>=t)for(G=G<<1&p,w=0;w<y;w++){if(D=F+z[w],E=C+x[w],D=q[D][E])D=A[w],G|=D}else for(G=0,J=f-1,w=0;w<f;w++,J--)E=C+l[w],0<=E&&E<c&&(D=F+m[w],0<=D&&(D=q[D][E])&&(G|=D<<J));w=v.readBit(h,G);n[C]=w}}return q}function Ek(a,c,b,d,e,g,f,h,k){var l=Fk[b].coding;0===b&&(l=l.concat([h[0]]));var m=l.length,n=new Int32Array(m),p=new Int32Array(m),q;for(q=0;q<m;q++)n[q]=l[q].x,p[q]=l[q].y;var r=Fk[b].reference;0===b&&\n(r=r.concat([h[1]]));h=r.length;l=new Int32Array(h);var t=new Int32Array(h);for(q=0;q<h;q++)l[q]=r[q].x,t[q]=r[q].y;r=d[0].length;var v=d.length;b=Hp[b];var w=[],y=k.decoder;k=k.contextCache.getContexts("GR");for(var x=0,z=0;z<c;z++){if(f&&(q=y.readBit(k,b),x^=q))throw new Ab("prediction is not supported");var A=new Uint8Array(a);w.push(A);for(var B=0;B<a;B++){var C=0;for(q=0;q<m;q++){var D=z+p[q];var E=B+n[q];C=0>D||0>E||E>=a?C<<1:C<<1|w[D][E]}for(q=0;q<h;q++)D=z+t[q]-g,E=B+l[q]-e,C=0>D||D>=v||0>\nE||E>=r?C<<1:C<<1|d[D][E];q=y.readBit(k,C);A[B]=q}}return w}function Gk(a,c,b,d,e,g,f,h,k,l,m,n,p,q,r,t,v,w,y){if(a&&c)throw new Ab("refinement with Huffman is not supported");var x=[],z;for(z=0;z<d;z++){var A=new Uint8Array(b);if(e)for(var B=0;B<b;B++)A[B]=e;x.push(A)}d=v.decoder;e=v.contextCache;B=a?-q.tableDeltaT.decode(y):-oc(e,"IADT",d);var C=0;for(z=0;z<g;){var D=a?q.tableDeltaT.decode(y):oc(e,"IADT",d);B+=D;D=a?q.tableFirstS.decode(y):oc(e,"IAFS",d);D=C+=D;do{var E=0;1<f&&(E=a?y.readBits(w):\noc(e,"IAIT",d));A=f*B+E;E=a?q.symbolIDTable.decode(y):Dk(e,d,k);var G=c&&(a?y.readBit():oc(e,"IARI",d));E=h[E];var J=E[0].length,F=E.length;if(G){G=oc(e,"IARDW",d);var L=oc(e,"IARDH",d),M=oc(e,"IARDX",d),W=oc(e,"IARDY",d);J+=G;F+=L;E=Ek(J,F,r,E,(G>>1)+M,(L>>1)+W,!1,t,v)}G=0;l?n&1?G=F-1:D+=F-1:1<n?D+=J-1:G=J-1;L=A-(n&1?0:F-1);M=D-(n&2?J-1:0);var Q;if(l)for(W=0;W<F;W++){if(A=x[M+W]){var la=E[W];var ta=Math.min(b-L,J);switch(p){case 0:for(Q=0;Q<ta;Q++)A[L+Q]|=la[Q];break;case 2:for(Q=0;Q<ta;Q++)A[L+\nQ]^=la[Q];break;default:throw new Ab("operator "+p+" is not supported");}}}else for(Q=0;Q<F;Q++)if(A=x[L+Q])switch(la=E[Q],p){case 0:for(W=0;W<J;W++)A[M+W]|=la[W];break;case 2:for(W=0;W<J;W++)A[M+W]^=la[W];break;default:throw new Ab("operator "+p+" is not supported");}z++;E=a?q.tableDeltaS.decode(y):oc(e,"IADS",d);if(null===E)break;D+=G+E+m}while(1)}return x}function fg(a,c){return{width:zb(a,c),height:zb(a,c+4),x:zb(a,c+8),y:zb(a,c+12),combinationOperator:a[c+16]&7}}function Nd(a){var c=Hk[a];if(c)return c;\nswitch(a){case 1:c=[[0,1,4,0],[16,2,8,2],[272,3,16,6],[65808,3,32,7]];break;case 2:c=[[0,1,0,0],[1,2,0,2],[2,3,0,6],[3,4,3,14],[11,5,6,30],[75,6,32,62],[6,63]];break;case 3:c=[[-256,8,8,254],[0,1,0,0],[1,2,0,2],[2,3,0,6],[3,4,3,14],[11,5,6,30],[-257,8,32,255,"lower"],[75,7,32,126],[6,62]];break;case 4:c=[[1,1,0,0],[2,2,0,2],[3,3,0,6],[4,4,3,14],[12,5,6,30],[76,5,32,31]];break;case 5:c=[[-255,7,8,126],[1,1,0,0],[2,2,0,2],[3,3,0,6],[4,4,3,14],[12,5,6,30],[-256,7,32,127,"lower"],[76,6,32,62]];break;\ncase 6:c=[[-2048,5,10,28],[-1024,4,9,8],[-512,4,8,9],[-256,4,7,10],[-128,5,6,29],[-64,5,5,30],[-32,4,5,11],[0,2,7,0],[128,3,7,2],[256,3,8,3],[512,4,9,12],[1024,4,10,13],[-2049,6,32,62,"lower"],[2048,6,32,63]];break;case 7:c=[[-1024,4,9,8],[-512,3,8,0],[-256,4,7,9],[-128,5,6,26],[-64,5,5,27],[-32,4,5,10],[0,4,5,11],[32,5,5,28],[64,5,6,29],[128,4,7,12],[256,3,8,1],[512,3,9,2],[1024,3,10,3],[-1025,5,32,30,"lower"],[2048,5,32,31]];break;case 8:c=[[-15,8,3,252],[-7,9,1,508],[-5,8,1,253],[-3,9,0,509],[-2,\n7,0,124],[-1,4,0,10],[0,2,1,0],[2,5,0,26],[3,6,0,58],[4,3,4,4],[20,6,1,59],[22,4,4,11],[38,4,5,12],[70,5,6,27],[134,5,7,28],[262,6,7,60],[390,7,8,125],[646,6,10,61],[-16,9,32,510,"lower"],[1670,9,32,511],[2,1]];break;case 9:c=[[-31,8,4,252],[-15,9,2,508],[-11,8,2,253],[-7,9,1,509],[-5,7,1,124],[-3,4,1,10],[-1,3,1,2],[1,3,1,3],[3,5,1,26],[5,6,1,58],[7,3,5,4],[39,6,2,59],[43,4,5,11],[75,4,6,12],[139,5,7,27],[267,5,8,28],[523,6,8,60],[779,7,9,125],[1291,6,11,61],[-32,9,32,510,"lower"],[3339,9,32,511],\n[2,0]];break;case 10:c=[[-21,7,4,122],[-5,8,0,252],[-4,7,0,123],[-3,5,0,24],[-2,2,2,0],[2,5,0,25],[3,6,0,54],[4,7,0,124],[5,8,0,253],[6,2,6,1],[70,5,5,26],[102,6,5,55],[134,6,6,56],[198,6,7,57],[326,6,8,58],[582,6,9,59],[1094,6,10,60],[2118,7,11,125],[-22,8,32,254,"lower"],[4166,8,32,255],[2,2]];break;case 11:c=[[1,1,0,0],[2,2,1,2],[4,4,0,12],[5,4,1,13],[7,5,1,28],[9,5,2,29],[13,6,2,60],[17,7,2,122],[21,7,3,123],[29,7,4,124],[45,7,5,125],[77,7,6,126],[141,7,32,127]];break;case 12:c=[[1,1,0,0],[2,\n2,0,2],[3,3,1,6],[5,5,0,28],[6,5,1,29],[8,6,1,60],[10,7,0,122],[11,7,1,123],[13,7,2,124],[17,7,3,125],[25,7,4,126],[41,8,5,254],[73,8,32,255]];break;case 13:c=[[1,1,0,0],[2,3,0,4],[3,4,0,12],[4,5,0,28],[5,4,1,13],[7,3,3,5],[15,6,1,58],[17,6,2,59],[21,6,3,60],[29,6,4,61],[45,6,5,62],[77,7,6,126],[141,7,32,127]];break;case 14:c=[[-2,3,0,4],[-1,3,0,5],[0,1,0,0],[1,3,0,6],[2,3,0,7]];break;case 15:c=[[-24,7,4,124],[-8,6,2,60],[-4,5,1,28],[-2,4,0,12],[-1,3,0,4],[0,1,0,0],[1,3,0,5],[2,4,0,13],[3,5,1,29],\n[5,6,2,61],[9,7,4,125],[-25,7,32,126,"lower"],[25,7,32,127]];break;default:throw new Ab("standard table B."+a+" does not exist");}for(var b=0,d=c.length;b<d;b++)c[b]=new Ea(c[b]);c=new gg(c,!0);return Hk[a]=c}function ge(a,c,b){for(var d=0,e=0,g=c.length;e<g;e++){var f=b[c[e]];if(f){if(a===d)return f;d++}}throw new Ab("can\'t find custom Huffman table");}function th(a,c,b,d){a=new Ik(a,{K:-1,Columns:c,Rows:b,BlackIs1:!0,EndOfBlock:d});for(var e=[],g,f=!1,h=0;h<b;h++){var k=new Uint8Array(c);e.push(k);\nfor(var l=-1,m=0;m<c;m++)0>l&&(g=a.readNextChar(),-1===g&&(g=0,f=!0),l=7),k[m]=g>>l&1,l--}if(d&&!f)for(c=0;5>c&&-1!==a.readNextChar();c++);return e}function Jk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Ip(a,c,b){return c&&Jk(a.prototype,c),b&&Jk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Jp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;uh(a,c)}function uh(a,c){return uh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},uh(a,c)}function vh(a){var c=a.src,b=void 0===a.srcPos?0:a.srcPos,d=a.dest,e=a.width,g=a.height,f=void 0===a.nonBlackColor?4294967295:\na.nonBlackColor,h=id.isLittleEndian?4278190080:255;f=u.makeIterator((void 0===a.inverseDecode?0:a.inverseDecode)?[f,h]:[h,f]);a=f.next().value;f=f.next().value;h=e>>3;e&=7;var k=c.length;d=new Uint32Array(d.buffer);for(var l=0,m=0;m<g;m++){for(var n=b+h;b<n;b++){var p=b<k?c[b]:255;d[l++]=p&128?f:a;d[l++]=p&64?f:a;d[l++]=p&32?f:a;d[l++]=p&16?f:a;d[l++]=p&8?f:a;d[l++]=p&4?f:a;d[l++]=p&2?f:a;d[l++]=p&1?f:a}if(0!==e)for(n=b<k?c[b++]:255,p=0;p<e;p++)d[l++]=n&1<<7-p?f:a}return{srcPos:b,destPos:l}}function Kk(a,\nc){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Kp(a,c,b){return c&&Kk(a.prototype,c),b&&Kk(a,b),Object.defineProperty(a,"prototype",\n{writable:!1}),a}function wh(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;xh(a,c)}function xh(a,c){return xh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},xh(a,c)}function Lp(a,c,b,d,e,g,f,h,k,l){function m(){if(0<D)return D--,C>>D&1;C=a[c++];if(255===C){var Y=a[c++];if(Y){if(220===Y&&l){c+=2;var fa=yb(a,c);c+=2;if(0<fa&&fa!==b.scanLines)throw new yh("Found DNL marker (0xFFDC) while parsing scan data",fa);}else if(217===Y){if(l&&\n(Y=F*(8===b.precision?8:0),0<Y&&5<=Math.round(b.scanLines/Y)))throw new yh("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter",Y);throw new Lk("Found EOI marker (0xFFD9) while parsing scan data");}throw new jd("unexpected marker "+(C<<8|Y).toString(16));}}D=7;return C>>>7}function n(Y){for(;;){Y=Y[m()];switch(typeof Y){case "number":return Y;case "object":continue}throw new jd("invalid huffman sequence");}}function p(Y){for(var fa=0;0<Y;)fa=fa<<\n1|m(),Y--;return fa}function q(Y){if(1===Y)return 1===m()?1:-1;var fa=p(Y);return fa>=1<<Y-1?fa:fa+(-1<<Y)+1}function r(Y,fa){var H=n(Y.huffmanTableDC);H=0===H?0:q(H);Y.blockData[fa]=Y.pred+=H;for(H=1;64>H;){var U=n(Y.huffmanTableAC),N=U&15;U>>=4;if(0===N){if(15>U)break;H+=16}else H+=U,Y.blockData[fa+gf[H]]=q(N),H++}}function t(Y,fa){var H=n(Y.huffmanTableDC);H=0===H?0:q(H)<<k;Y.blockData[fa]=Y.pred+=H}function v(Y,fa){Y.blockData[fa]|=m()<<k}function w(Y,fa){if(0<E)E--;else for(var H=g;H<=f;){var U=\nn(Y.huffmanTableAC),N=U&15;U>>=4;if(0===N){if(15>U){E=p(U)+(1<<U)-1;break}H+=16}else H+=U,Y.blockData[fa+gf[H]]=q(N)*(1<<k),H++}}function y(Y,fa){for(var H=g,U=0,N;H<=f;){N=fa+gf[H];var ba=0>Y.blockData[N]?-1:1;switch(G){case 0:U=n(Y.huffmanTableAC);N=U&15;U>>=4;if(0===N)15>U?(E=p(U)+(1<<U),G=4):(U=16,G=1);else{if(1!==N)throw new jd("invalid ACn encoding");J=q(N);G=U?2:3}continue;case 1:case 2:Y.blockData[N]?Y.blockData[N]+=ba*(m()<<k):(U--,0===U&&(G=2===G?3:0));break;case 3:Y.blockData[N]?Y.blockData[N]+=\nba*(m()<<k):(Y.blockData[N]=J<<k,G=0);break;case 4:Y.blockData[N]&&(Y.blockData[N]+=ba*(m()<<k))}H++}4===G&&(E--,0===E&&(G=0))}function x(Y,fa,H,U,N){var ba=H%A;F=(H/A|0)*Y.v+U;fa(Y,64*((Y.blocksPerLine+1)*F+(ba*Y.h+N)))}function z(Y,fa,H){F=H/Y.blocksPerLine|0;fa(Y,64*((Y.blocksPerLine+1)*F+H%Y.blocksPerLine))}void 0===l&&(l=!1);var A=b.mcusPerLine,B=c,C=0,D=0,E=0,G=0,J,F=0,L=d.length,M,W,Q,la;h=b.progressive?0===g?0===h?t:v:0===h?w:y:r;for(var ta=0,qa=1===L?d[0].blocksPerLine*d[0].blocksPerColumn:\nA*b.mcusPerColumn,va,S;ta<=qa;){var da=e?Math.min(qa-ta,e):qa;if(0<da){for(M=0;M<L;M++)d[M].pred=0;E=0;if(1===L){var R=d[0];for(la=0;la<da;la++)z(R,h,ta),ta++}else for(la=0;la<da;la++){for(M=0;M<L;M++)for(R=d[M],va=R.h,S=R.v,W=0;W<S;W++)for(Q=0;Q<va;Q++)x(R,h,ta,W,Q);ta++}}D=0;R=hg(a,c);if(!R)break;R.invalid&&(T("decodeScan - "+(0<da?"unexpected":"excessive")+" MCU data, current marker is: "+R.invalid),c=R.offset);if(65488<=R.marker&&65495>=R.marker)c+=2;else break}return c-B}function hg(a,c,b){void 0===\nb&&(b=c);var d=a.length-1;b=b<c?b:c;if(c>=d)return null;var e=yb(a,c);if(65472<=e&&65534>=e)return{invalid:null,marker:e,offset:c};for(c=yb(a,b);!(65472<=c&&65534>=c);){if(++b>=d)return null;c=yb(a,b)}return{invalid:e.toString(16),marker:c,offset:b}}function Mk(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function Mp(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){Mk(h,d,e,g,f,"next",k)}function f(k){Mk(h,\nd,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Nk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Np(a,c,b){return c&&\nNk(a.prototype,c),b&&Nk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Op(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;zh(a,c)}function zh(a,c){return zh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},zh(a,c)}function Pp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Ah(a,c)}function Ah(a,c){return Ah=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},\nAh(a,c)}function Ok(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Qp(a,c,b){return c&&Ok(a.prototype,c),b&&Ok(a,b),Object.defineProperty(a,\n"prototype",{writable:!1}),a}function Rp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Bh(a,c)}function Bh(a,c){return Bh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Bh(a,c)}function Sp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Ch(a,c)}function Ch(a,c){return Ch=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Ch(a,c)}function Dh(a){if(void 0===a)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");\nreturn a}function Tp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Eh(a,c)}function Eh(a,c){return Eh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Eh(a,c)}function Up(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Fh(a,c)}function Fh(a,c){return Fh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Fh(a,c)}function Gh(a){return 48<=a&&57>=a?a&15:65<=a&&70>=a||97<=a&&102>=\na?(a&15)+9:-1}function Pk(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function ig(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){Pk(h,d,e,g,f,"next",k)}function f(k){Pk(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Vp(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Hh(a,c)}function Hh(a,c){return Hh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,\nd){return b.__proto__=d,b},Hh(a,c)}function Qk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Rk(a,c,b){return c&&Qk(a.prototype,\nc),b&&Qk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Od(a){for(var c=0,b=0;b<a.length;b++)c=c<<8|a.charCodeAt(b);return c>>>0}function he(a){if("string"!==typeof a)throw new oa("Malformed CMap: expected string.");}function Sk(a){if(!Number.isInteger(a))throw new oa("Malformed CMap: expected int.");}function Tk(a,c,b,d){return Ih.apply(this,arguments)}function Ih(){Ih=ig(function g(c,b,d,e){var f,h,k;return u.generator.createGenerator(g,function(l){a:for(;;)try{if(k=b.getObj(),\nk===$b)break;else if(k instanceof ka){if("WMode"===k.name){var m=c,n=b.getObj();Number.isInteger(n)&&(m.vertical=!!n)}else if("CMapName"===k.name){m=c;var p=b.getObj();p instanceof ka&&(m.name=p.name)}f=k}else if(k instanceof Vb)switch(k.cmd){case "endcmap":break a;case "usecmap":f instanceof ka&&(h=f.name);break;case "begincodespacerange":b:{m=c;for(var q=b;;){var r=q.getObj();if(r===$b)break;if(Ub(r,"endcodespacerange"))break b;if("string"!==typeof r)break;var t=Od(r);r=q.getObj();if("string"!==\ntypeof r)break;var v=Od(r);m.addCodespaceRange(r.length,t,v)}throw new oa("Invalid codespace range.");}break;case "beginbfchar":b:for(m=c,q=b;;){var w=q.getObj();if(w===$b)break;if(Ub(w,"endbfchar"))break b;he(w);var y=Od(w);w=q.getObj();he(w);m.mapOne(y,w)}break;case "begincidchar":b:for(m=c,q=b;;){var x=q.getObj();if(x===$b)break;if(Ub(x,"endcidchar"))break b;he(x);var z=Od(x);x=q.getObj();Sk(x);m.mapOne(z,x)}break;case "beginbfrange":b:{m=c;for(q=b;;){var A=q.getObj();if(A===$b)break;if(Ub(A,"endbfrange"))break b;\nhe(A);var B=Od(A);A=q.getObj();he(A);var C=Od(A);A=q.getObj();if(Number.isInteger(A)||"string"===typeof A){var D=Number.isInteger(A)?String.fromCharCode(A):A;m.mapBfRange(B,C,D)}else if(Ub(A,"[")){A=q.getObj();for(var E=[];!Ub(A,"]")&&A!==$b;)E.push(A),A=q.getObj();m.mapBfRangeToArray(B,C,E)}else break}throw new oa("Invalid bf range.");}break;case "begincidrange":b:for(m=c,q=b;;){var G=q.getObj();if(G===$b)break;if(Ub(G,"endcidrange"))break b;he(G);var J=Od(G);G=q.getObj();he(G);var F=Od(G);G=q.getObj();\nSk(G);m.mapCidRange(J,F,G)}}}catch(L){if(L instanceof ub)throw L;T("Invalid cMap data: "+L)}!e&&h&&(e=h);return e?l.return(Uk(c,d,e)):l.return(c)})});return Ih.apply(this,arguments)}function Uk(a,c,b){return Jh.apply(this,arguments)}function Jh(){Jh=ig(function e(c,b,d){var g,f,h;return u.generator.createGenerator(e,function(k){if(1==k.nextAddress)return g=c,k.yield(Kh(d,b),2);g.useCMap=k.yieldResult;if(0===c.numCodespaceRanges){f=c.useCMap.codespaceRanges;for(h=0;h<f.length;h++)c.codespaceRanges[h]=\nf[h].slice();c.numCodespaceRanges=c.useCMap.numCodespaceRanges}c.useCMap.forEach(function(l){c.contains(l)||c.mapOne(l,c.useCMap.lookup(l))});return k.return(c)})});return Jh.apply(this,arguments)}function Kh(a,c){return Lh.apply(this,arguments)}function Lh(){Lh=ig(function d(c,b){var e,g,f,h,k;return u.generator.createGenerator(d,function(l){if(1==l.nextAddress){if("Identity-H"===c)return l.return(new Ee(!1,2));if("Identity-V"===c)return l.return(new Ee(!0,2));if(!Wp.includes(c))throw Error("Unknown CMap name: "+\nc);if(!b)throw Error("Built-in CMap parameters are not provided.");return l.yield(b(c),2)}e=l.yieldResult;g=e.cMapData;f=e.isCompressed;h=new Mh(!0);if(f)return l.return((new Xp).process(g,h,function(m){return Uk(h,b,m)}));k=new kd(new Mb(g));return l.return(Tk(h,k,b,null))})});return Lh.apply(this,arguments)}function hf(a){switch(a){case "WinAnsiEncoding":return jf;case "StandardEncoding":return Bd;case "MacRomanEncoding":return Nh;case "SymbolSetEncoding":return Oh;case "ZapfDingbatsEncoding":return Ph;\ncase "ExpertEncoding":return Vk;case "MacExpertEncoding":return Yp;default:return null}}function Wk(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Qh(a,c)}function Qh(a,c){return Qh=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Qh(a,c)}function Xk(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&\nf){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function kf(a,c,b){return c&&Xk(a.prototype,c),b&&Xk(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Fe(a,c){c=c[a];if(void 0!==c)return c;if(!a)return-1;if("u"===a[0]){c=a.length;if(7===c&&"n"===a[1]&&"i"===a[2])a=a.substring(3);else if(5<=c&&7>=c)a=a.substring(1);\nelse return-1;if(a===a.toUpperCase()&&(c=parseInt(a,16),0<=c))return c}return-1}function Yk(a,c){if(void 0!==c[a])return a;var b=Fe(a,c);if(-1!==b)for(var d in c)if(c[d]===b)return d;Ya("Unable to recover a standard glyph name for: "+a);return a}function Zk(a,c,b){var d=Object.create(null),e;var g=!!(a.flags&Zc.Symbolic);if(a.isInternalFont)for(g=c,e=0;e<g.length;e++)c=b.indexOf(g[e]),d[e]=0<=c?c:0;else if(a.baseEncodingName)for(g=hf(a.baseEncodingName),e=0;e<g.length;e++)c=b.indexOf(g[e]),d[e]=0<=\nc?c:0;else if(g)for(e in c)d[e]=c[e];else for(g=Bd,e=0;e<g.length;e++)c=b.indexOf(g[e]),d[e]=0<=c?c:0;a=a.differences;var f;if(a)for(e in a){g=a[e];c=b.indexOf(g);if(-1===c){f||(f=ud());var h=Yk(g,f);h!==g&&(c=b.indexOf(h))}d[e]=0<=c?c:0}return d}function lf(a){return a.replaceAll(/[,_]/g,"-").replaceAll(/\\s/g,"")}function $k(a){a=lf(a);return jg()[a]}function al(a){a=lf(a);return!!(jg()[a]||bl()[a]||Rh()[a]||Sh()[a])}function cl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||\n!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function dl(a,c,b){return c&&cl(a.prototype,c),b&&cl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function el(a,c){for(var b=0;b<c.length;b++){var d=\nc[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Zp(a,c,b){return c&&el(a.prototype,c),b&&el(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function fl(a,c){a.prototype=\nObject.create(c.prototype);a.prototype.constructor=a;Th(a,c)}function Th(a,c){return Th=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Th(a,c)}function Cd(a,c){return(a[c]<<24|a[c+1]<<16|a[c+2]<<8|a[c+3])>>>0}function Wb(a,c){return a[c]<<8|a[c+1]}function $c(a,c){return(a[c]<<24|a[c+1]<<16)>>16}function Uh(a){a=a.length;var c=32768;1240>a?c=107:33900>a&&(c=1131);return c}function $p(a,c,b){if(b){b=4;var d=Cd}else b=2,d=function(k,l){return 2*Wb(k,l)};for(var e=\n[],g=d(c,0),f=b;f<c.length;f+=b){var h=d(c,f);e.push(a.subarray(g,h));g=h}return e}function kg(a,c){c=c.codePointAt(0);for(var b=0,d=0,e=a.length-1;d<e;){var g=d+e+1>>1;c<a[g].start?e=g-1:d=g}a[d].start<=c&&c<=a[d].end&&(b=a[d].idDelta+(a[d].ids?a[d].ids[c-a[d].start]:c)&65535);return{charCode:c,glyphId:b}}function gl(a,c,b){var d=0,e=$c(a,d),g=0,f=0;d+=10;if(0>e){do{var h=Wb(a,d);e=Wb(a,d+2);d+=4;if(h&1)h&2?(g=$c(a,d),f=$c(a,d+2)):(g=Wb(a,d),f=Wb(a,d+2)),d+=4;else if(h&2){g=a;f=d++;g=g[f]<<24>>24;\nf=a;var k=d++;f=f[k]<<24>>24}else g=a[d++],f=a[d++];h&2||(f=g=0);var l=k=1,m=0,n=0;h&8?(k=l=$c(a,d)/16384,d+=2):h&64?(k=$c(a,d)/16384,l=$c(a,d+2)/16384,d+=4):h&128&&(k=$c(a,d)/16384,m=$c(a,d+2)/16384,n=$c(a,d+4)/16384,l=$c(a,d+6)/16384,d+=8);if(e=b.glyphs[e])c.add(Xb.SAVE),c.add(Xb.TRANSFORM,[k,m,n,l,g,f]),gl(e,c,b),c.add(Xb.RESTORE)}while(h&32)}else{b=[];for(h=0;h<e;h++)b.push(Wb(a,d)),d+=2;h=Wb(a,d);d+=2+h;l=b.at(-1)+1;for(k=[];k.length<l;)for(h=a[d++],m=1,h&8&&(m+=a[d++]);0<m--;)k.push({flags:h});\nfor(h=0;h<l;h++){switch(k[h].flags&18){case 0:g+=$c(a,d);d+=2;break;case 2:g-=a[d++];break;case 18:g+=a[d++]}k[h].x=g}for(h=0;h<l;h++){switch(k[h].flags&36){case 0:f+=$c(a,d);d+=2;break;case 4:f-=a[d++];break;case 36:f+=a[d++]}k[h].y=f}for(d=h=0;d<e;d++){a=b[d];g=k.slice(h,a+1);g[0].flags&1?g.push(g[0]):g.at(-1).flags&1?g.unshift(g.at(-1)):(h={flags:1,x:(g[0].x+g.at(-1).x)/2,y:(g[0].y+g.at(-1).y)/2},g.unshift(h),g.push(h));c.add(Xb.MOVE_TO,[g[0].x,g[0].y]);h=1;for(f=g.length;h<f;h++)g[h].flags&1?\nc.add(Xb.LINE_TO,[g[h].x,g[h].y]):g[h+1].flags&1?(c.add(Xb.QUADRATIC_CURVE_TO,[g[h].x,g[h].y,g[h+1].x,g[h+1].y]),h++):c.add(Xb.QUADRATIC_CURVE_TO,[g[h].x,g[h].y,(g[h].x+g[h+1].x)/2,(g[h].y+g[h+1].y)/2]);h=a+1}}}function Vh(a,c,b,d){function e(n,p){c.add(Xb.LINE_TO,[n,p])}function g(n,p,q,r,t,v){c.add(Xb.BEZIER_CURVE_TO,[n,p,q,r,t,v])}function f(n){for(var p=0;p<n.length;){var q=!1,r=n[p++];switch(r){case 1:m+=h.length>>1;q=!0;break;case 3:m+=h.length>>1;q=!0;break;case 4:l+=h.pop();c.add(Xb.MOVE_TO,\n[k,l]);q=!0;break;case 5:for(;0<h.length;)k+=h.shift(),l+=h.shift(),e(k,l);break;case 6:for(;0<h.length;){k+=h.shift();e(k,l);if(0===h.length)break;l+=h.shift();e(k,l)}break;case 7:for(;0<h.length;){l+=h.shift();e(k,l);if(0===h.length)break;k+=h.shift();e(k,l)}break;case 8:for(;0<h.length;){r=k+h.shift();var t=l+h.shift();var v=r+h.shift();var w=t+h.shift();k=v+h.shift();l=w+h.shift();g(r,t,v,w,k,l)}break;case 10:r=h.pop();v=null;if(b.isCFFCIDFont)if(t=b.fdSelect.getFDIndex(d),0<=t&&t<b.fdArray.length){var y;\nt=b.fdArray[t];w=void 0;null!=(y=t.privateDict)&&y.subrsIndex&&(w=t.privateDict.subrsIndex.objects);w&&(r+=Uh(w),v=w[r])}else T("Invalid fd index for glyph index.");else v=b.subrs[r+b.subrsBias];v&&f(v);break;case 11:return;case 12:r=n[p++];switch(r){case 34:r=k+h.shift();v=r+h.shift();w=l+h.shift();k=v+h.shift();g(r,l,v,w,k,w);r=k+h.shift();v=r+h.shift();k=v+h.shift();g(r,w,v,l,k,l);break;case 35:r=k+h.shift();t=l+h.shift();v=r+h.shift();w=t+h.shift();k=v+h.shift();l=w+h.shift();g(r,t,v,w,k,l);r=\nk+h.shift();t=l+h.shift();v=r+h.shift();w=t+h.shift();k=v+h.shift();l=w+h.shift();g(r,t,v,w,k,l);h.pop();break;case 36:r=k+h.shift();w=l+h.shift();v=r+h.shift();t=w+h.shift();k=v+h.shift();g(r,w,v,t,k,t);r=k+h.shift();v=r+h.shift();w=t+h.shift();k=v+h.shift();g(r,t,v,w,k,l);break;case 37:var x=k,z=l;r=k+h.shift();t=l+h.shift();v=r+h.shift();w=t+h.shift();k=v+h.shift();l=w+h.shift();g(r,t,v,w,k,l);r=k+h.shift();t=l+h.shift();v=r+h.shift();w=t+h.shift();k=v;l=w;Math.abs(k-x)>Math.abs(l-z)?k+=h.shift():\nl+=h.shift();g(r,t,v,w,k,l);break;default:throw new oa("unknown operator: 12 "+r);}break;case 14:4<=h.length&&(p=h.pop(),n=h.pop(),l=h.pop(),k=h.pop(),c.add(Xb.SAVE),c.add(Xb.TRANSLATE,[k,l]),p=kg(b.cmap,String.fromCharCode(b.glyphNameMap[Bd[p]])),Vh(b.glyphs[p.glyphId],c,b,p.glyphId),c.add(Xb.RESTORE),p=kg(b.cmap,String.fromCharCode(b.glyphNameMap[Bd[n]])),Vh(b.glyphs[p.glyphId],c,b,p.glyphId));return;case 18:m+=h.length>>1;q=!0;break;case 19:m+=h.length>>1;p+=m+7>>3;q=!0;break;case 20:m+=h.length>>\n1;p+=m+7>>3;q=!0;break;case 21:l+=h.pop();k+=h.pop();c.add(Xb.MOVE_TO,[k,l]);q=!0;break;case 22:k+=h.pop();c.add(Xb.MOVE_TO,[k,l]);q=!0;break;case 23:m+=h.length>>1;q=!0;break;case 24:for(;2<h.length;)r=k+h.shift(),t=l+h.shift(),v=r+h.shift(),w=t+h.shift(),k=v+h.shift(),l=w+h.shift(),g(r,t,v,w,k,l);k+=h.shift();l+=h.shift();e(k,l);break;case 25:for(;6<h.length;)k+=h.shift(),l+=h.shift(),e(k,l);r=k+h.shift();t=l+h.shift();v=r+h.shift();w=t+h.shift();k=v+h.shift();l=w+h.shift();g(r,t,v,w,k,l);break;\ncase 26:for(h.length%2&&(k+=h.shift());0<h.length;)r=k,t=l+h.shift(),v=r+h.shift(),w=t+h.shift(),k=v,l=w+h.shift(),g(r,t,v,w,k,l);break;case 27:for(h.length%2&&(l+=h.shift());0<h.length;)r=k+h.shift(),t=l,v=r+h.shift(),w=t+h.shift(),k=v+h.shift(),l=w,g(r,t,v,w,k,l);break;case 28:h.push((n[p]<<24|n[p+1]<<16)>>16);p+=2;break;case 29:r=h.pop()+b.gsubrsBias;(v=b.gsubrs[r])&&f(v);break;case 30:for(;0<h.length;){r=k;t=l+h.shift();v=r+h.shift();w=t+h.shift();k=v+h.shift();l=w+(1===h.length?h.shift():0);\ng(r,t,v,w,k,l);if(0===h.length)break;r=k+h.shift();t=l;v=r+h.shift();w=t+h.shift();l=w+h.shift();k=v+(1===h.length?h.shift():0);g(r,t,v,w,k,l)}break;case 31:for(;0<h.length;){r=k+h.shift();t=l;v=r+h.shift();w=t+h.shift();l=w+h.shift();k=v+(1===h.length?h.shift():0);g(r,t,v,w,k,l);if(0===h.length)break;r=k;t=l+h.shift();v=r+h.shift();w=t+h.shift();k=v+h.shift();l=w+(1===h.length?h.shift():0);g(r,t,v,w,k,l)}break;default:if(32>r)throw new oa("unknown operator: "+r);247>r?h.push(r-139):251>r?h.push(256*\n(r-247)+n[p++]+108):255>r?h.push(256*-(r-251)-n[p++]-108):(h.push((n[p]<<24|n[p+1]<<16|n[p+2]<<8|n[p+3])/65536),p+=4)}q&&(h.length=0)}}var h=[],k=0,l=0,m=0;f(a)}function lg(a,c,b){a[c]=b>>8&255;a[c+1]=b&255}function Wh(a,c,b){a[c]=b>>24&255;a[c+1]=b>>16&255;a[c+2]=b>>8&255;a[c+3]=b&255}function vd(a){return 48<=a&&57>=a||65<=a&&70>=a||97<=a&&102>=a}function hl(a,c,b){if(b>=a.length)return new Uint8Array(0);c|=0;var d;for(d=0;d<b;d++)c=52845*(a[d]+c)+22719&65535;var e=a.length-b,g=new Uint8Array(e);\nd=b;for(b=0;b<e;d++,b++){var f=a[d];g[b]=f^c>>8;c=52845*(f+c)+22719&65535}return g}function il(a){return 47===a||91===a||93===a||123===a||125===a||40===a||41===a}function jl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function aq(a,c,b){return c&&jl(a.prototype,c),b&&jl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function kl(a,c,b){for(var d=a.length,e=c.length,g=d-e,f=!1;b<g;){for(var h=0;h<e&&a[b+h]===c[h];)h++;if(h>=e){for(b+=h;b<d&&Lc(a[b]);)b++;f=!0;break}b++}return{found:f,length:b}}function ll(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;\na:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function ml(a,c,b){return c&&ll(a.prototype,c),b&&ll(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Xh(a){if(a.fontMatrix&&a.fontMatrix[0]!==ie[0]){var c=.001/a.fontMatrix[0],b=a.widths,d;for(d in b)b[d]*=c;a.defaultWidth*=\nc}}function bq(a,c,b){if(!(a.isInternalFont||a.hasIncludedToUnicodeMap||a.hasEncoding||a.toUnicode instanceof ad)&&c&&0!==b.length&&a.defaultEncoding!==jf){c=u.makeIterator(b);for(b=c.next();!b.done;b=c.next())if(b=b.value,3!==b.platform||1!==b.encoding||1033!==b.language)return;c=jf;b=[];var d=ud(),e;for(e in c){var g=c[e];""!==g&&(g=d[g],void 0!==g&&(b[e]=String.fromCharCode(g)))}0<b.length&&a.toUnicode.amend(b)}}function cq(a,c){if(!(a.isInternalFont||a.hasIncludedToUnicodeMap||c===a.defaultEncoding||\na.toUnicode instanceof ad)){var b=[],d=ud(),e;for(e in c)if(!a.hasEncoding||!a.baseEncodingName&&void 0===a.differences[e]){var g=Fe(c[e],d);-1!==g&&(b[e]=String.fromCharCode(g))}0<b.length&&a.toUnicode.amend(b)}}function nl(a){if(a.fallbackToUnicode&&!(a.toUnicode instanceof ad)){var c=[],b;for(b in a.fallbackToUnicode)a.toUnicode.has(b)||(c[b]=a.fallbackToUnicode[b]);0<c.length&&a.toUnicode.amend(c)}}function mf(a,c,b){a[c+1]=b;a[c]=b>>>8}function Mc(a,c){a=(a<<8)+c;return a&32768?a-65536:a}function dq(a,\nc,b){a[c+3]=b&255;a[c+2]=b>>>8;a[c+1]=b>>>16;a[c]=b>>>24}function lb(a){return String.fromCharCode(a>>8&255,a&255)}function je(a){32767<a?a=32767:-32768>a&&(a=-32768);return String.fromCharCode(a>>8&255,a&255)}function ol(a){a=a.peekBytes(4);return"ttcf"===Ec(a)}function mg(a,c){for(var b in c)a[+b]=c[b]}function Yh(a,c,b){for(var d=[],e,g=0,f=a.length;g<f;g++)e=Fe(a[g],c),-1!==e&&(d[g]=e);for(var h in b)e=Fe(b[h],c),-1!==e&&(d[+h]=e);return d}function Zh(a,c,b){void 0===b&&(b=!1);switch(c.length){case 1:return c.charCodeAt(0);\ncase 2:return c.charCodeAt(0)<<8|c.charCodeAt(1)}a="Unsupported CID string (charCode "+a+\'): "\'+c+\'".\';if(b)throw new oa(a);T(a);return c}function pl(a,c,b,d){var e=Object.create(null),g=new Map,f=[],h=new Set,k=0,l=Dd[k][0],m=Dd[k][1],n;for(n in a){var p=a[n];if(c(p)){if(l>m){k++;if(k>=Dd.length){T("Ran out of space in font private use area.");break}l=Dd[k][0];m=Dd[k][1]}var q=l++;0===p&&(p=b);var r=d.get(n);"string"===typeof r&&(r=r.codePointAt(0));!r||Dd[0][0]<=r&&r<=Dd[0][1]||Dd[1][0]<=r&&r<=\nDd[1][1]||h.has(p)||(g.set(r,p),h.add(p));e[q]=p;f[n]=q}}return{toFontChar:f,charCodeToGlyphId:e,toUnicodeExtraMap:g,nextAvailableFontCharCode:l}}function eq(a,c,b){var d=[];for(e in a)a[e]>=b||d.push({fontCharCode:e|0,glyphId:a[e]});if(c)for(a=u.makeIterator(c),c=a.next();!c.done;c=a.next()){var e=u.makeIterator(c.value);c=e.next().value;e=e.next().value;e>=b||d.push({fontCharCode:c,glyphId:e})}0===d.length&&d.push({fontCharCode:0,glyphId:0});d.sort(function(h,k){return h.fontCharCode-k.fontCharCode});\nb=[];a=d.length;for(c=0;c<a;){e=d[c].fontCharCode;var g=[d[c].glyphId];++c;for(var f=e;c<a&&f+1===d[c].fontCharCode&&(g.push(d[c].glyphId),++f,++c,65535!==f););b.push([e,f,g])}return b}function ql(a,c,b){a=eq(a,c,b);b=65535<a.at(-1)[1]?2:1;c="\\x00\\x00"+lb(b)+"\\x00\\u0003\\x00\\u0001"+kc(4+8*b);var d,e;for(d=a.length-1;0<=d&&!(65535>=a[d][0]);--d);var g=d+1;65535>a[d][0]&&65535===a[d][1]&&(a[d][1]=65534);var f=65535>a[d][1]?1:0,h=g+f,k=$h.getSearchParams(h,2),l="",m="",n="",p="",q="",r=0;for(d=0;d<g;d++){var t=\na[d];var v=t[0];var w=t[1];l+=lb(v);m+=lb(w);var y=t[2];t=!0;var x=1;for(e=y.length;x<e;++x)if(y[x]!==y[x-1]+1){t=!1;break}if(t)n+=lb(y[0]-v&65535),p+=lb(0);else for(x=2*(h-d)+2*r,r+=w-v+1,n+=lb(0),p+=lb(x),x=0,e=y.length;x<e;++x)q+=lb(y[x])}0<f&&(m+="\\u00ff\\u00ff",l+="\\u00ff\\u00ff",n+="\\x00\\u0001",p+="\\x00\\x00");f="\\x00\\x00"+lb(2*h)+lb(k.range)+lb(k.entry)+lb(k.rangeShift)+m+"\\x00\\x00"+l+n+p+q;d=h="";if(1<b){c+="\\x00\\u0003\\x00\\n"+kc(8*b+8+f.length);h="";d=0;for(g=a.length;d<g;d++){t=a[d];v=t[0];\ny=t[2];b=y[0];x=1;for(e=y.length;x<e;++x)y[x]!==y[x-1]+1&&(w=t[0]+x-1,h+=kc(v)+kc(w)+kc(b),v=w+1,b=y[x]);h+=kc(v)+kc(t[1])+kc(b)}d="\\x00\\f\\x00\\x00"+kc(h.length+16)+"\\x00\\x00\\x00\\x00"+kc(h.length/12)}return c+"\\x00\\u0004"+lb(f.length+4)+f+d+h}function fq(a,c){c.pos=(c.start||0)+a.offset;var b=c.getUint16();c.skip(60);var d=c.getUint16();if(4>b&&d&768)return!1;b=c.getUint16();d=c.getUint16();if(b>d)return!1;c.skip(6);if(0===c.getUint16())return!1;a.data[8]=a.data[9]=0;return!0}function rl(a,c,b){b||\n(b={unitsPerEm:0,yMax:0,yMin:0,ascent:0,descent:0});var d=0,e=0,g=0,f=0,h=null,k=0,l=-1;if(c){for(var m in c){m|=0;if(h>m||!h)h=m;k<m&&(k=m);a:{c=m;void 0===l&&(l=-1);if(-1!==l)for(var n=ai[l],p=0,q=n.length;p<q;p+=2)if(c>=n[p]&&c<=n[p+1])break a;l=0;for(n=ai.length;l<n;l++){p=ai[l];q=0;for(var r=p.length;q<r;q+=2)if(c>=p[q]&&c<=p[q+1])break a}l=-1}if(32>l)d|=1<<l;else if(64>l)e|=1<<l-32;else if(96>l)g|=1<<l-64;else if(123>l)f|=1<<l-96;else throw new oa("Unicode ranges Bits > 123 are reserved for internal usage");\n}65535<k&&(k=65535)}else h=0,k=255;c=a.bbox||[0,0,0,0];m=b.unitsPerEm||(a.fontMatrix?1/Math.max.apply(Math,u.arrayFromIterable(a.fontMatrix.slice(0,4).map(Math.abs))):1E3);l=a.ascentScaled?1:m/1E3;m=b.ascent||Math.round(l*(a.ascent||c[3]));l=b.descent||Math.round(l*(a.descent||c[1]));0<l&&0<a.descent&&0>c[1]&&(l=-l);c=b.yMax||m;b=-b.yMin||-l;return"\\x00\\u0003\\u0002$\\u0001\\u00f4\\x00\\u0005\\x00\\x00\\u0002\\u008a\\u0002\\u00bb\\x00\\x00\\x00\\u008c\\u0002\\u008a\\u0002\\u00bb\\x00\\x00\\u0001\\u00df\\x001\\u0001\\u0002\\x00\\x00\\x00\\x00\\u0006"+\nString.fromCharCode(a.fixedPitch?9:0)+"\\x00\\x00\\x00\\x00\\x00\\x00"+kc(d)+kc(e)+kc(g)+kc(f)+"*21*"+lb(a.italicAngle?1:0)+lb(h||a.firstChar)+lb(k||a.lastChar)+lb(m)+lb(l)+"\\x00d"+lb(c)+lb(b)+"\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00"+lb(a.xHeight)+lb(a.capHeight)+lb(0)+lb(h||a.firstChar)+"\\x00\\u0003"}function sl(a){return"\\x00\\u0003\\x00\\x00"+kc(Math.floor(a.italicAngle*Math.pow(2,16)))+"\\x00\\x00\\x00\\x00"+kc(a.fixedPitch?1:0)+"\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00"}function bi(a,c){c||\n(c=[[],[]]);a=[c[0][0]||"Original licence",c[0][1]||a,c[0][2]||"Unknown",c[0][3]||"uniqueID",c[0][4]||a,c[0][5]||"Version 0.11",c[0][6]||a.replaceAll(/[^\\x21-\\x7E]|[[\\](){}<>/%]/g,"").slice(0,63),c[0][7]||"Unknown",c[0][8]||"Unknown",c[0][9]||"Unknown"];var b=[],d,e;var g=0;for(d=a.length;g<d;g++){var f=c[1][g]||a[g];var h=[];var k=0;for(e=f.length;k<e;k++)h.push(lb(f.charCodeAt(k)));b.push(h.join(""))}c=[a,b];h=["\\x00\\u0001","\\x00\\u0003"];var l=["\\x00\\x00","\\x00\\u0001"],m=["\\x00\\x00","\\u0004\\t"];\ng=a.length*h.length;var n="\\x00\\x00"+lb(g)+lb(12*g+6),p=0;g=0;for(d=h.length;g<d;g++){var q=c[g];k=0;for(e=q.length;k<e;k++){f=q[k];var r=h[g]+l[g]+m[g]+lb(k)+lb(f.length)+lb(p);n+=r;p+=f.length}}return n+=a.join("")+b.join("")}function tl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=\ntypeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function gq(a,c,b){return c&&tl(a.prototype,c),b&&tl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function ci(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;di(a,c)}function di(a,c){return di=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},di(a,c)}function ul(a){var c,b;if(!(b=(c=vl)[a])){b=\n[];for(var d=0;d<=a;d++){var e=d/a,g=1-e;b.push(new Float32Array([Math.pow(g,3),3*e*Math.pow(g,2),3*Math.pow(e,2)*g,Math.pow(e,3)]))}b=c[a]=b}return b}function wl(a,c,b){var d=Md(c.getArray("Matrix"),ld),e=sd(c.getArray("BBox"),null);if(!e||0===e[2]-e[0]||0===e[3]-e[1])throw new oa("Invalid getTilingPatternIR /BBox array.");var g=c.get("XStep");if("number"!==typeof g)throw new oa("Invalid getTilingPatternIR /XStep value.");var f=c.get("YStep");if("number"!==typeof f)throw new oa("Invalid getTilingPatternIR /YStep value.");\nvar h=c.get("PaintType");if(!Number.isInteger(h))throw new oa("Invalid getTilingPatternIR /PaintType value.");c=c.get("TilingType");if(!Number.isInteger(c))throw new oa("Invalid getTilingPatternIR /TilingType value.");return["TilingPattern",b,a,d,e,g,f,h,c]}function ei(a){a=lf(a);return hq()[a]}function iq(a){a=ei(a);if(!a)return null;var c=a.baseWidths,b=a.baseMapping,d=a.factors;a=d?c.map(function(k,l){return k*d[l]}):c;c=-2;var e=[];b=u.makeIterator(b.map(function(k,l){return[k,l]}).sort(function(k,\nl){k=u.makeIterator(k).next().value;l=u.makeIterator(l).next().value;return k-l}));for(var g=b.next();!g.done;g=b.next()){var f=u.makeIterator(g.value);g=f.next().value;f=f.next().value;if(-1!==g)if(g===c+1)h.push(a[f]),c+=1;else{c=g;var h=[a[f]];e.push(g,h)}}return e}function xl(a){var c=iq(a),b=new ca(null);b.set("BaseFont",ka.get(a));b.set("Type",ka.get("Font"));b.set("Subtype",ka.get("CIDFontType2"));b.set("Encoding",ka.get("Identity-H"));b.set("CIDToGIDMap",ka.get("Identity"));b.set("W",c);b.set("FirstChar",\nc[0]);b.set("LastChar",c.at(-2)+c.at(-1).length-1);a=new ca(null);b.set("FontDescriptor",a);a=new ca(null);a.set("Ordering","Identity");a.set("Registry","Adobe");a.set("Supplement",0);b.set("CIDSystemInfo",a);return b}function yl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=\ntypeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function jq(a,c,b){return c&&yl(a.prototype,c),b&&yl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function zl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=\nh.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function kq(a,c,b){return c&&zl(a.prototype,c),b&&zl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Ge(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;fi(a,c)}function fi(a,c){return fi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},fi(a,c)}function He(a,\nc){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;gi(a,c)}function gi(a,c){return gi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},gi(a,c)}function Al(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function lq(a,c,b){return c&&Al(a.prototype,c),b&&Al(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function bd(a){return Array.isArray(a)?yc(a,null)?a:a.map(function(c){return+c}):null}function hi(a){if(!(a instanceof ca))if(a instanceof $a)a=a.dict;else return!1;return a.has("FunctionType")}function mq(a,c){if("literal"===c.type){if(0===c.number)return new ke(0);if(1===c.number)return a;if("literal"===a.type)return new ke(a.number*\nc.number)}if("literal"===a.type){if(0===a.number)return new ke(0);if(1===a.number)return c}return new ii("*",a,c,Math.min(a.min*c.min,a.min*c.max,a.max*c.min,a.max*c.max),Math.max(a.min*c.min,a.min*c.max,a.max*c.min,a.max*c.max))}function Bl(a,c,b){for(--b;c<b;++c,--b){var d=a[c];a[c]=a[b];a[b]=d}}function ji(a,c,b){void 0===b&&(b=!1);var d="ltr";b?d="ttb":c||(d="rtl");return{str:a,dir:d}}function Cl(a,c,b){void 0===c&&(c=-1);void 0===b&&(b=!1);var d=!0,e=a.length;if(0===e||b)return ji(a,d,b);Pd.length=\ne;jb.length=e;var g=0;for(b=0;b<e;++b){Pd[b]=a.charAt(b);var f=a.charCodeAt(b),h="L";if(255>=f)h=nq[f];else if(1424<=f&&1524>=f)h="R";else if(1536<=f&&1791>=f)(h=oq[f&255])||T("Bidi: invalid Unicode character "+f.toString(16));else if(1792<=f&&2220>=f||64336<=f&&65023>=f||65136<=f&&65279>=f)h="AL";"R"!==h&&"AL"!==h&&"AN"!==h||g++;jb[b]=h}if(0===g)return ji(a,!0);-1===c&&(.3>g/e&&4<e?(d=!0,c=0):(d=!1,c=1));a=[];for(b=0;b<e;++b)a[b]=c;g=c=0!==(c&1)?"R":"L";for(b=0;b<e;++b)"NSM"===jb[b]?jb[b]=g:g=jb[b];\ng=c;for(b=0;b<e;++b)if(f=jb[b],"EN"===f)jb[b]="AL"===g?"AN":"EN";else if("R"===f||"L"===f||"AL"===f)g=f;for(b=0;b<e;++b)f=jb[b],"AL"===f&&(jb[b]="R");for(b=1;b<e-1;++b)"ES"===jb[b]&&"EN"===jb[b-1]&&"EN"===jb[b+1]&&(jb[b]="EN"),"CS"!==jb[b]||"EN"!==jb[b-1]&&"AN"!==jb[b-1]||jb[b+1]!==jb[b-1]||(jb[b]=jb[b-1]);for(b=0;b<e;++b)if("EN"===jb[b]){for(g=b-1;0<=g&&"ET"===jb[g];--g)jb[g]="EN";for(g=b+1;g<e&&"ET"===jb[g];++g)jb[g]="EN"}for(b=0;b<e;++b)if(f=jb[b],"WS"===f||"ES"===f||"ET"===f||"CS"===f)jb[b]="ON";\ng=c;for(b=0;b<e;++b)if(f=jb[b],"EN"===f)jb[b]="L"===g?"L":"EN";else if("R"===f||"L"===f)g=f;for(b=0;b<e;++b)if("ON"===jb[b]){a:{f=b+1;for(g=jb.length;f<g;++f)if("ON"!==jb[f]){g=f;break a}g=f}var k=c;0<b&&(k=jb[b-1]);f=c;g+1<e&&(f=jb[g+1]);"L"!==k&&(k="R");"L"!==f&&(f="R");if(k===f)for(f=jb,h=g;b<h;++b)f[b]=k;b=g-1}for(b=0;b<e;++b)"ON"===jb[b]&&(jb[b]=c);for(b=0;b<e;++b)if(f=jb[b],0===(a[b]&1))if("R"===f)a[b]+=1;else{if("AN"===f||"EN"===f)a[b]+=2}else if("L"===f||"AN"===f||"EN"===f)a[b]+=1;f=-1;c=\n99;b=0;for(e=a.length;b<e;++b)g=a[b],f<g&&(f=g),c>g&&0!==(g&1)&&(c=g);for(g=f;g>=c;--g){f=-1;b=0;for(e=a.length;b<e;++b)a[b]<g?0<=f&&(Bl(Pd,f,b),f=-1):0>f&&(f=b);0<=f&&Bl(Pd,f,a.length)}b=0;for(e=Pd.length;b<e;++b)if(a=Pd[b],"<"===a||">"===a)Pd[b]="";return ji(Pd.join(""),d)}function pq(a){switch(a){case le:return"Bold";case me:return"Italic";case ne:return"Bold Italic";default:if("bold"===(null==a?void 0:a.weight))return"Bold";if("italic"===(null==a?void 0:a.style))return"Italic"}return""}function Dl(a){var c=\nnew Set("thin extralight ultralight demilight semilight light book regular normal medium demibold semibold bold extrabold ultrabold black heavy extrablack ultrablack roman italic oblique ultracondensed extracondensed condensed semicondensed normal semiexpanded expanded extraexpanded ultraexpanded bolditalic".split(" "));return a.split(/[- ,+]+/g).filter(function(b){return!c.has(b.toLowerCase())}).join(" ")}function ki(a,c,b,d,e,g){var f=a.alias,h=a.local,k=a.path,l=a.fallback,m=a.style,n=a.ultimate;\nvoid 0===d&&(d=!0);void 0===e&&(e=!0);void 0===g&&(g="");a={style:null,ultimate:null};if(h){var p=g?" "+g:"";h=u.makeIterator(h);for(var q=h.next();!q.done;q=h.next())c.push("local("+q.value+p+")")}f&&(f=nf.get(f),p=g||pq(m),Object.assign(a,ki(f,c,b,d&&!l,e&&!k,p)));m&&(a.style=m);n&&(a.ultimate=n);d&&l&&(l=nf.get(l),d=ki(l,c,b,d,e&&!k,g).ultimate,a.ultimate||(a.ultimate=d));e&&k&&b&&c.push("url("+b+k+")");return a}function El(a,c,b,d,e,g){if(d.startsWith("InvalidPDFjsFont_"))return null;"TrueType"!==\ng&&"Type1"!==g||!/^[A-Z]{6}\\+/.test(d)||(d=d.slice(7));g=d=lf(d);var f=a.get(g);if(f)return f;f=nf.get(d);if(!f)for(var h=u.makeIterator(qq),k=h.next();!k.done;k=h.next()){var l=u.makeIterator(k.value);k=l.next().value;l=l.next().value;if(d.startsWith(k)){d=""+l+d.substring(k.length);f=nf.get(d);break}}h=!1;f||(f=nf.get(e),h=!0);c=c.getDocId()+"_s"+c.createFontId();if(!f){if(!hh(d))return T("Cannot substitute the font because of its name: "+d),a.set(g,null),null;b=/bold/gi.test(d);e=/oblique|italic/gi.test(d);\nb=b&&e&&ne||b&&le||e&&me||oe;f={css:\'"\'+Dl(d)+\'",\'+c,guessFallback:!0,loadedName:c,baseFontName:d,src:"local("+d+")",style:b};a.set(g,f);return f}e=[];h&&hh(d)&&e.push("local("+d+")");f=ki(f,e,b);b=f.style;h=f.ultimate;h=(f=null===h)?"":","+h;f={css:\'"\'+Dl(d)+\'",\'+c+h,guessFallback:f,loadedName:c,baseFontName:d,src:e.join(","),style:b};a.set(g,f);return f}function Fl(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function Gl(a){return function(){var c=\nthis,b=arguments;return new Promise(function(d,e){function g(k){Fl(h,d,e,g,f,"next",k)}function f(k){Fl(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Hl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function rq(a,c,b){return c&&Hl(a.prototype,c),b&&Hl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Il(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Jl(a,c,b){return c&&Il(a.prototype,c),b&&Il(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function sq(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;li(a,c)}function li(a,c){return li=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},li(a,c)}function ng(a,c,b,d,e){for(var g=0,f=c.length-1;g<f;g++){var h,k=c[g];a=(h=a)[k]||(h[k]=[])}a[c.at(-1)]={checkFn:b,iterateFn:d,\nprocessFn:e}}function Kl(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function pe(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){Kl(h,d,e,g,f,"next",k)}function f(k){Kl(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Ll(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=\nd.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function tq(a,c,b){return c&&Ll(a.prototype,c),b&&Ll(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Ml(a,c,b,d,e,g){var f=e*g;c=8>=c?new Uint8Array(f):16>=c?new Uint16Array(f):new Uint32Array(f);var h=b/e;d/=g;var k=0,l=new Uint16Array(e);\nfor(f=0;f<e;f++)l[f]=Math.floor(f*h);for(f=0;f<g;f++){var m=Math.floor(f*d)*b;for(h=0;h<e;h++){var n=m+l[h];c[k++]=a[n]}}return c}function Nl(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function Fc(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){Nl(h,d,e,g,f,"next",k)}function f(k){Nl(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Ol(a,c){for(var b=0;b<c.length;b++){var d=c[b];\nd.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function mi(a,c,b){return c&&Ol(a.prototype,c),b&&Ol(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Pl(a,c){void 0===\nc&&(c=!1);if(Array.isArray(a)){c=u.makeIterator(a);for(var b=c.next();!b.done;b=c.next())if(b=Pl(b.value,!0))return b;T("Unsupported blend mode Array: "+a);return"source-over"}if(!(a instanceof ka))return c?null:"source-over";switch(a.name){case "Normal":case "Compatible":return"source-over";case "Multiply":return"multiply";case "Screen":return"screen";case "Overlay":return"overlay";case "Darken":return"darken";case "Lighten":return"lighten";case "ColorDodge":return"color-dodge";case "ColorBurn":return"color-burn";\ncase "HardLight":return"hard-light";case "SoftLight":return"soft-light";case "Difference":return"difference";case "Exclusion":return"exclusion";case "Hue":return"hue";case "Saturation":return"saturation";case "Color":return"color";case "Luminosity":return"luminosity"}if(c)return null;T("Unsupported blend mode: "+a.name);return"source-over"}function ni(a,c){var b;c.objId&&a.addDependency(c.objId);a.addImageOps(c.fn,c.args,c.optionalContent);c.fn===O.paintImageMaskXObject&&0<(null==(b=c.args[0])?void 0:\nb.count)&&c.args[0].count++}function Ql(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Rl(a,c,b){return c&&Ql(a.prototype,c),b&&\nQl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Sl(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;oi(a,c)}function oi(a,c){return oi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},oi(a,c)}function Ed(a,c){return a[0]===a[1]&&a[1]===a[2]?ob(a[0]/255)+" "+(c?"g":"G"):Array.from(a,function(b){return ob(b/255)}).join(" ")+(" "+(c?"rg":"RG"))}function Tl(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=\na;pi(a,c)}function pi(a,c){return pi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},pi(a,c)}function qi(){vl=Object.create(null);Ul=Object.create(null);Vl=Object.create(null);og=Object.create(null);ri.clear();pg.cleanup()}function Wl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==\nh){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function uq(a,c,b){return c&&Wl(a.prototype,c),b&&Wl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Xl(a){return a instanceof ca?a.has("UF")?a.get("UF"):a.has("F")?a.get("F"):a.has("Unix")?a.get("Unix"):a.has("Mac")?a.get("Mac"):a.has("DOS")?a.get("DOS"):null:null}function vq(a,c){a.prototype=Object.create(c.prototype);\na.prototype.constructor=a;si(a,c)}function si(a,c){return si=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},si(a,c)}function Yl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function wq(a,c,b){return c&&Yl(a.prototype,c),b&&Yl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Ie(a,c){a=a[c];return" "===a||"\\n"===a||"\\r"===a||"\\t"===a}function Zl(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");\nif("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function xq(a,c,b){return c&&Zl(a.prototype,c),b&&Zl(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function yq(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;ti(a,c)}function ti(a,c){return ti=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},ti(a,c)}function $l(a,c){a.prototype=\nObject.create(c.prototype);a.prototype.constructor=a;ui(a,c)}function ui(a,c){return ui=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},ui(a,c)}function am(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function wd(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){am(h,d,e,g,f,"next",k)}function f(k){am(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}\nfunction pc(a,c,b,d){return vi.apply(this,arguments)}function vi(){vi=wd(function g(c,b,d,e){var f,h,k;return u.generator.createGenerator(g,function(l){if(1==l.nextAddress)return f=e,h=void 0===f.encrypt?null:f.encrypt,k=null==h?void 0:h.createCipherTransform(c.num,c.gen),d.push(c.num+" "+c.gen+" obj\\n"),b instanceof ca?l.yield(qg(b,d,k),3):b instanceof $a?l.yield(bm(b,d,k),3):Array.isArray(b)||ArrayBuffer.isView(b)?l.yield(cm(b,d,k),3):l.jumpTo(3);d.push("\\nendobj\\n");l.jumpToEnd()})});return vi.apply(this,\narguments)}function qg(a,c,b){return wi.apply(this,arguments)}function wi(){wi=wd(function e(c,b,d){var g,f,h;return u.generator.createGenerator(e,function(k){switch(k.nextAddress){case 1:b.push("<<"),g=u.makeIterator(c.getKeys()),f=g.next();case 2:if(f.done){k.jumpTo(4);break}h=f.value;b.push(" /"+gh(h)+" ");return k.yield(dm(c.getRaw(h),b,d),3);case 3:f=g.next();k.jumpTo(2);break;case 4:b.push(">>"),k.jumpToEnd()}})});return wi.apply(this,arguments)}function bm(a,c,b){return xi.apply(this,arguments)}\nfunction xi(){xi=wd(function e(c,b,d){var g,f,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B;return u.generator.createGenerator(e,function(C){switch(C.nextAddress){case 1:return g=c.getBytes(),f=c,h=f.dict,k=u,l=k.makeIterator,C.yield(Promise.all([h.getAsync("Filter"),h.getAsync("DecodeParms")]),2);case 2:m=l.call(k,C.yieldResult);n=m.next().value;p=m.next().value;if(!Array.isArray(n)){q=n;C.jumpTo(3);break}return C.yield(h.xref.fetchIfRefAsync(n[0]),4);case 4:q=C.yieldResult;case 3:r=q;t=Lb(r,"FlateDecode");if(!(256<=\ng.length||t)){C.jumpTo(5);break}C.setCatchFinallyBlocks(6);v=new CompressionStream("deflate");w=v.writable.getWriter();return C.yield(w.ready,8);case 8:return w.write(g).then(wd(function E(){return u.generator.createGenerator(E,function(G){return 1==G.nextAddress?G.yield(w.ready,2):G.yield(w.close(),0)})})).catch(function(){}),C.yield((new Response(v.readable)).arrayBuffer(),9);case 9:y=C.yieldResult;g=new Uint8Array(y);n?t||(x=Array.isArray(n)?[ka.get("FlateDecode")].concat(u.arrayFromIterable(n)):\n[ka.get("FlateDecode"),n],p&&(z=Array.isArray(p)?[null].concat(u.arrayFromIterable(p)):[null,p])):x=ka.get("FlateDecode");x&&h.set("Filter",x);z&&h.set("DecodeParms",z);C.leaveTryBlock(5);break;case 6:A=C.enterCatchBlock(),Ya(\'writeStream - cannot compress data: "\'+A+\'".\');case 5:return B=Ec(g),d&&(B=d.encryptString(B)),h.set("Length",B.length),C.yield(qg(h,b,d),10);case 10:b.push(" stream\\n",B,"\\nendstream"),C.jumpToEnd()}})});return xi.apply(this,arguments)}function cm(a,c,b){return yi.apply(this,\narguments)}function yi(){yi=wd(function e(c,b,d){var g,f,h,k;return u.generator.createGenerator(e,function(l){switch(l.nextAddress){case 1:b.push("["),g=!0,f=u.makeIterator(c),h=f.next();case 2:if(h.done){l.jumpTo(4);break}k=h.value;g?g=!1:b.push(" ");return l.yield(dm(k,b,d),3);case 3:h=f.next();l.jumpTo(2);break;case 4:b.push("]"),l.jumpToEnd()}})});return yi.apply(this,arguments)}function dm(a,c,b){return zi.apply(this,arguments)}function zi(){zi=wd(function e(c,b,d){return u.generator.createGenerator(e,\nfunction(g){return c instanceof ka?(b.push("/"+gh(c.name)),g.jumpTo(0)):c instanceof Ha?(b.push(c.num+" "+c.gen+" R"),g.jumpTo(0)):Array.isArray(c)||ArrayBuffer.isView(c)?g.yield(cm(c,b,d),0):"string"===typeof c?(d&&(c=d.encryptString(c)),b.push("("+Ce(c)+")"),g.jumpTo(0)):"number"===typeof c?(b.push(ob(c)),g.jumpTo(0)):"boolean"===typeof c?(b.push(c.toString()),g.jumpTo(0)):c instanceof ca?g.yield(qg(c,b,d),0):c instanceof $a?g.yield(bm(c,b,d),0):(null===c?b.push("null"):T("Unhandled value in writer: "+\ntypeof c+", please file a bug."),g.jumpTo(0))})});return zi.apply(this,arguments)}function Ai(a,c,b,d){for(var e=c+b-1;e>b-1;e--)d[e]=a&255,a>>=8;return b+c}function em(a,c,b){for(var d=0,e=a.length;d<e;d++)b[c+d]=a.charCodeAt(d)&255}function zq(a,c){a=[Math.floor(Date.now()/1E3).toString(),c.filename||"",a.toString()];var b=a.reduce(function(e,g){return e+g.length},0);c=u.makeIterator(Object.values(c.info));for(var d=c.next();!d.done;d=c.next())d=d.value,a.push(d),b+=d.length;b=new Uint8Array(b);\nc=0;a=u.makeIterator(a);for(d=a.next();!d.done;d=a.next())d=d.value,em(d,c,b),c+=d.length;return Ec(Qd(b))}function Aq(a,c){a=(new rg({hasAttributes:!0})).parseFromString(a);c=u.makeIterator(c);for(var b=c.next();!b.done;b=c.next())if(b=b.value.xfa){var d=b;b=d.path;d=d.value;if(b){var e=mk(b),g=a.documentElement.searchNode(e,0);!g&&1<e.length&&(g=a.documentElement.searchNode([e.at(-1)],0));g?g.childNodes=Array.isArray(d)?d.map(function(f){return new of("value",f)}):[new of("#text",d)]:T("Node not found for path: "+\nb)}}c=[];a.documentElement.dump(c);return c.join("")}function Bq(a){return Bi.apply(this,arguments)}function Bi(){Bi=wd(function b(c){var d,e,g,f,h,k,l,m,n,p,q,r;return u.generator.createGenerator(b,function(t){if(1==t.nextAddress){d=c;e=d.xref;g=d.acroForm;f=d.acroFormRef;h=d.hasXfa;k=d.hasXfaDatasetsEntry;l=d.xfaDatasetsRef;m=d.needAppearances;n=d.newRefs;!h||k||l||T("XFA - Cannot save it");if(!(m||h&&l&&!k))return t.return();p=g.clone();h&&!k&&(q=g.get("XFA").slice(),q.splice(2,0,"datasets"),q.splice(3,\n0,l),p.set("XFA",q));m&&p.set("NeedAppearances",!0);r=[];return t.yield(pc(f,p,r,e),2)}n.push({ref:f,data:r.join("")});t.jumpToEnd()})});return Bi.apply(this,arguments)}function Cq(a){var c=a.xfaData,b=a.xfaDatasetsRef,d=a.newRefs;a=a.xref;null===c&&(c=a.fetchIfRef(b),c=Aq(c.getString(),d));(a=a.encrypt)&&(c=a.createCipherTransform(b.num,b.gen).encryptString(c));d.push({ref:b,data:b.num+" "+b.gen+" obj\\n<< /Type /EmbeddedFile /Length "+(c.length+">>\\nstream\\n")+c+"\\nendstream\\nendobj\\n"})}function Dq(a,\nc,b,d,e){return Ci.apply(this,arguments)}function Ci(){Ci=wd(function f(c,b,d,e,g){var h,k,l,m,n,p,q,r;return u.generator.createGenerator(f,function(t){if(1==t.nextAddress){g.push("xref\\n");h=fm(d);k=0;l=u.makeIterator(d);for(m=l.next();!m.done;m=l.next())p=n=m.value,q=p.ref,r=p.data,q.num===h[k]&&(g.push(h[k]+" "+h[k+1]+"\\n"),k+=2),null!==r?(g.push(b.toString().padStart(10,"0")+" "+Math.min(q.gen,65535).toString().padStart(5,"0")+" n\\r\\n"),b+=r.length):g.push("0000000000 "+Math.min(q.gen+1,65535).toString().padStart(5,\n"0")+" f\\r\\n");gm(b,c,e);g.push("trailer\\n");return t.yield(qg(e,g),2)}g.push("\\nstartxref\\n",b.toString(),"\\n%%EOF\\n");t.jumpToEnd()})});return Ci.apply(this,arguments)}function fm(a){var c=[];a=u.makeIterator(a);for(var b=a.next();!b.done;b=a.next())b=b.value.ref,b.num===c.at(-2)+c.at(-1)?c[c.length-1]+=1:c.push(b.num,1);return c}function Eq(a,c,b,d,e){return Di.apply(this,arguments)}function Di(){Di=wd(function f(c,b,d,e,g){var h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M;return u.generator.createGenerator(f,\nfunction(W){if(1==W.nextAddress){h=[];l=k=0;m=u.makeIterator(d);for(n=m.next();!n.done;n=m.next())q=p=n.value,r=q.ref,t=q.data,v=void 0,k=Math.max(k,b),null!==t?(v=Math.min(r.gen,65535),h.push([1,b,v]),b+=t.length):(v=Math.min(r.gen+1,65535),h.push([0,0,v])),l=Math.max(l,v);e.set("Index",fm(d));w=Math.ceil(Math.ceil(Math.log2(1+k))/8);y=Math.ceil(Math.ceil(Math.log2(1+l))/8);x=[1,w,y];e.set("W",x);gm(b,c,e);z=x.reduce(function(Q,la){return Q+la},0);A=new Uint8Array(z*h.length);B=new Mb(A);B.dict=\ne;C=0;D=u.makeIterator(h);for(E=D.next();!E.done;E=D.next())G=E.value,J=u.makeIterator(G),F=J.next().value,L=J.next().value,M=J.next().value,C=Ai(F,x[0],C,A),C=Ai(L,x[1],C,A),C=Ai(M,x[2],C,A);return W.yield(pc(c.newRef,B,g,{}),2)}g.push("startxref\\n",b.toString(),"\\n%%EOF\\n");W.jumpToEnd()})});return Di.apply(this,arguments)}function gm(a,c,b){Array.isArray(c.fileIds)&&0<c.fileIds.length&&(a=zq(a,c),b.set("ID",[c.fileIds[0],a]))}function Fq(a,c,b){var d=new ca(null);d.set("Prev",a.startXRef);var e=\na.newRef;b?(c.push({ref:e,data:""}),d.set("Size",e.num+1),d.set("Type",ka.get("XRef"))):d.set("Size",e.num);null!==a.rootRef&&d.set("Root",a.rootRef);null!==a.infoRef&&d.set("Info",a.infoRef);null!==a.encryptRef&&d.set("Encrypt",a.encryptRef);return d}function Gq(a){return Ei.apply(this,arguments)}function Ei(){Ei=wd(function b(c){var d,e,g,f,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M;return u.generator.createGenerator(b,function(W){if(1==W.nextAddress)return d=c,e=d.originalData,g=d.xrefInfo,\nf=d.newRefs,h=void 0===d.xref?null:d.xref,k=void 0===d.hasXfa?!1:d.hasXfa,l=void 0===d.xfaDatasetsRef?null:d.xfaDatasetsRef,m=void 0===d.hasXfaDatasetsEntry?!1:d.hasXfaDatasetsEntry,n=d.needAppearances,p=void 0===d.acroFormRef?null:d.acroFormRef,q=void 0===d.acroForm?null:d.acroForm,r=void 0===d.xfaData?null:d.xfaData,t=void 0===d.useXrefStream?!1:d.useXrefStream,W.yield(Bq({xref:h,acroForm:q,acroFormRef:p,hasXfa:k,hasXfaDatasetsEntry:m,xfaDatasetsRef:l,needAppearances:n,newRefs:f}),2);if(3!=W.nextAddress){k&&\nCq({xfaData:r,xfaDatasetsRef:l,newRefs:f,xref:h});v=[];w=e.length;y=e.at(-1);10!==y&&13!==y&&(v.push("\\n"),w+=1);x=Fq(g,f,t);f=f.sort(function(Q,la){return Q.ref.num-la.ref.num});z=u.makeIterator(f);for(A=z.next();!A.done;A=z.next())C=B=A.value,D=C.data,null!==D&&v.push(D);return W.yield(t?Eq(g,w,f,x,v):Dq(g,w,f,x,v),3)}E=v.reduce(function(Q,la){return Q+la.length},e.length);G=new Uint8Array(E);G.set(e);J=e.length;F=u.makeIterator(v);for(L=F.next();!L.done;L=F.next())M=L.value,em(M,J,G),J+=M.length;\nreturn W.return(G)})});return Ei.apply(this,arguments)}function hm(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function im(a,c,b){return c&&\nhm(a.prototype,c),b&&hm(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function jm(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function Je(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){jm(h,d,e,g,f,"next",k)}function f(k){jm(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function km(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,\ne)}function sg(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){km(h,d,e,g,f,"next",k)}function f(k){km(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function lm(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Hq(a,c,b){return c&&lm(a.prototype,c),b&&lm(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Fi(a){if(!Array.isArray(a)||2>a.length)return!1;var c=u.makeIterator(a);a=c.next().value;var b=c.next().value;c=u.arrayFromIterator(c);if(!((a instanceof Ha||Number.isInteger(a))&&b instanceof ka))return!1;var d=c.length;a=!0;switch(b.name){case "XYZ":if(2>d||3<d)return!1;break;case "Fit":case "FitB":return 0===d;case "FitH":case "FitBH":case "FitV":case "FitBV":if(1<\nd)return!1;break;case "FitR":if(4!==d)return!1;a=!1;break;default:return!1}b=u.makeIterator(c);for(c=b.next();!c.done;c=b.next())if(c=c.value,!("number"===typeof c||a&&null===c))return!1;return!0}function tg(a){a instanceof ca&&(a=a.get("D"));return Fi(a)?a:null}function mm(a){if(a=a.get("D")){a instanceof ka&&(a=a.name);if("string"===typeof a)return ib(a);if(Fi(a))return JSON.stringify(a)}return null}function nm(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,\ne)}function om(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){nm(h,d,e,g,f,"next",k)}function f(k){nm(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function pm(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Iq(a,c,b){return c&&pm(a.prototype,c),b&&pm(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function ug(a){return a.startsWith("\'")||a.startsWith(\'"\')?a.slice(1,-1):a}function Ta(a){var c=a.data,b=a.defaultValue;a=a.validate;if(!c)return b;c=c.trim();c=parseInt(c,10);return!isNaN(c)&&a(c)?c:b}function vg(a){var c=a.data,b=a.defaultValue;a=a.validate;if(!c)return b;c=c.trim();c=parseFloat(c);return!isNaN(c)&&a(c)?c:b}function wg(a){var c=\na.data,b=a.defaultValue;a=a.validate;if(!c)return b;c=c.trim();return a(c)?c:b}function ua(a,c){return wg({data:a,defaultValue:c[0],validate:function(b){return c.includes(b)}})}function Ma(a,c){void 0===c&&(c="0");c||(c="0");if(!a)return Ma(c);a=a.trim().match(Jq);if(!a)return Ma(c);var b=u.makeIterator(a);b.next();a=b.next().value;b=b.next().value;a=parseFloat(a);return isNaN(a)?Ma(c):0===a?0:(c=Kq[b])?c(a):a}function qm(a){if(!a)return{num:1,den:1};a=a.trim().split(/\\s*:\\s*/).map(function(b){return parseFloat(b)}).filter(function(b){return!isNaN(b)});\n1===a.length&&a.push(1);if(0===a.length)return{num:1,den:1};var c=u.makeIterator(a);a=c.next().value;c=c.next().value;return{num:a,den:c}}function md(a){return a?a.trim().split(/\\s+/).map(function(c){return{excluded:"-"===c[0],viewname:c.substring(1)}}):[]}function Lq(a,c){void 0===c&&(c=[0,0,0]);var b=u.makeIterator(c);c=b.next().value;var d=b.next().value;b=b.next().value;if(!a)return{r:c,g:d,b:b};a=a.trim().split(/\\s*,\\s*/).map(function(e){return Math.min(Math.max(0,parseInt(e.trim(),10)),255)}).map(function(e){return isNaN(e)?\n0:e});if(3>a.length)return{r:c,g:d,b:b};a=u.makeIterator(a);c=a.next().value;d=a.next().value;b=a.next().value;return{r:c,g:d,b:b}}function Mq(a){if(!a)return{x:-1,y:-1,width:-1,height:-1};a=a.trim().split(/\\s*,\\s*/).map(function(e){return Ma(e,"-1")});if(4>a.length||0>a[2]||0>a[3])return{x:-1,y:-1,width:-1,height:-1};var c=u.makeIterator(a);a=c.next().value;var b=c.next().value,d=c.next().value;c=c.next().value;return{x:a,y:b,width:d,height:c}}function Gi(a,c){return"italic"===a.posture?"bold"===\na.weight?c.bolditalic:c.italic:"bold"===a.weight?c.bold:c.regular}function rm(a,c,b){void 0===b&&(b=!0);var d=a.match(sm);if(!d)return null;d=u.makeIterator(d).next().value;for(var e=[{name:d,cacheName:"."+d,index:0,js:null,formCalc:null,operator:Nc.dot}],g=d.length;g<a.length;){var f=g;if("["===a.charAt(g++)){d=a.slice(g).match(Nq);if(!d)return T("XFA - Invalid index in SOM expression"),null;f=e.at(-1);var h=d[0];h=h.trim();h="*"===h?Infinity:parseInt(h,10)||0;f.index=h;g+=d[0].length+1}else{switch(a.charAt(g)){case ".":if(!c)return null;\ng++;h=Nc.dotDot;break;case "#":g++;h=Nc.dotHash;break;case "[":if(b)return T("XFA - SOM expression contains a FormCalc subexpression which is not supported for now."),null;h=Nc.dotBracket;break;case "(":if(b)return T("XFA - SOM expression contains a JavaScript subexpression which is not supported for now."),null;h=Nc.dotParen;break;default:h=Nc.dot}d=a.slice(g).match(sm);if(!d)break;d=u.makeIterator(d).next().value;g+=d.length;e.push({name:d,cacheName:a.slice(f,g),operator:h,index:0,js:null,formCalc:null})}}return e}\nfunction Rd(a,c,b,d,e){void 0===d&&(d=!0);void 0===e&&(e=!0);b=rm(b,d);if(!b)return null;var g=tm.get(b[0].name);d=0;if(g){var f=!0;a=[g(a,c)];d=1}else f=null===c,a=[c||a];g={};for(var h=b.length;d<h;g={index$jscomp$177:void 0},d++){var k=b[d],l=k.name,m=k.cacheName,n=k.operator;g.index$jscomp$177=k.index;k=[];a=u.makeIterator(a);for(var p=a.next();!p.done;p=a.next())if(p=p.value,p.isXFAObject){var q=void 0,r=void 0;e&&(r=um.get(p),r||(r=new Map,um.set(p,r)),q=r.get(m));if(!q){switch(n){case Nc.dot:q=\np[pf](l,!1);break;case Nc.dotDot:q=p[pf](l,!0);break;case Nc.dotHash:q=p[xg](l),q=q.isXFAObjectArray?q.children:[q]}e&&r.set(m,q)}0<q.length&&k.push(q)}if(0!==k.length||f||0!==d)a=isFinite(g.index$jscomp$177)?k.filter(function(t){return function(v){return t.index$jscomp$177<v.length}}(g)).map(function(t){return function(v){return v[t.index$jscomp$177]}}(g)):k.flat();else{c=c[Va]();if(!c)return null;d=-1;a=[c]}}return 0===a.length?null:a}function Oq(a,c,b){b=rm(b);if(!b||b.some(function(k){return k.operator===\nNc.dotDot}))return null;var d=tm.get(b[0].name),e=0;d?(a=d(a,c),e=1):a=c||a;for(c=b.length;e<c;e++){var g=b[e];d=g.name;var f=g.operator;g=g.index;if(!isFinite(g))return b[e].index=0,a.createNodes(b.slice(e));var h=void 0;switch(f){case Nc.dot:h=a[pf](d,!1);break;case Nc.dotDot:h=a[pf](d,!0);break;case Nc.dotHash:h=a[xg](d),h=h.isXFAObjectArray?h.children:[h]}if(0===h.length)return a.createNodes(b.slice(e));if(g<h.length){if(a=h[g],!a.isXFAObject){T("XFA - Cannot create a node.");break}}else return b[e].index=\ng-h.length,a.createNodes(b.slice(e))}return null}function qe(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Hi(a,c)}function Hi(a,c){return Hi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Hi(a,c)}function vm(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==\nh){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function wm(a,c,b){return c&&vm(a.prototype,c),b&&vm(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Ua(a){return"string"===typeof a?"0px":Number.isInteger(a)?a+"px":a.toFixed(2)+"px"}function xm(a,c){"position"===a[Nb]().layout&&(0<a.minW&&(c.minWidth=Ua(a.minW)),0<a.maxW&&(c.maxWidth=Ua(a.maxW)),0<a.minH&&\n(c.minHeight=Ua(a.minH)),0<a.maxH&&(c.maxHeight=Ua(a.maxH)))}function ym(a,c,b,d,e,g){c=new Pq(c,b,d,e);if("string"===typeof a)c.addString(a);else a[xd](c);return c.compute(g)}function Ii(a,c){var b=null,d=null,e=!1;if((!a.w||!a.h)&&a.value){var g=0,f=0;a.margin&&(g=a.margin.leftInset+a.margin.rightInset,f=a.margin.topInset+a.margin.bottomInset);var h=null,k=null;a.para&&(k=Object.create(null),h=""===a.para.lineHeight?null:a.para.lineHeight,k.top=""===a.para.spaceAbove?0:a.para.spaceAbove,k.bottom=\n""===a.para.spaceBelow?0:a.para.spaceBelow,k.left=""===a.para.marginLeft?0:a.para.marginLeft,k.right=""===a.para.marginRight?0:a.para.marginRight);var l=a.font;if(!l)for(var m=a[Ob](),n=a[Va]();n&&n!==m;){if(n.font){l=n.font;break}n=n[Va]()}c=(a.w||c.width)-g;m=a[rb].fontFinder;if(a.value.exData&&a.value.exData[ra]&&"text/html"===a.value.exData.contentType)e=ym(a.value.exData[ra],l,k,h,m,c),d=e.width,b=e.height,e=e.isBroken;else if(n=a.value[Sb]())e=ym(n,l,k,h,m,c),d=e.width,b=e.height,e=e.isBroken;\nnull===d||a.w||(d+=g);null===b||a.h||(b+=f)}return{w:d,h:b,isBroken:e}}function zm(a,c,b){if(""!==a.w&&""!==a.h)a=[a.x,a.y,a.w,a.h];else{if(!b)return null;var d=a.w;""===d&&(0===a.maxW?(d=a[Nb](),d="position"===d.layout&&""!==d.w?0:a.minW):d=Math.min(a.maxW,b.width),c.attributes.style.width=Ua(d));var e=a.h;""===e&&(0===a.maxH?(b=a[Nb](),e="position"===b.layout&&""!==b.h?0:a.minH):e=Math.min(a.maxH,b.height),c.attributes.style.height=Ua(e));a=[a.x,a.y,d,e]}return a}function yg(a){var c,b=a[Nb]();\nif(null!=(c=b.layout)&&c.includes("row")){c=b[ja];var d=a.colSpan;c=-1===d?c.columnWidths.slice(c.currentColumn).reduce(function(e,g){return e+g},0):c.columnWidths.slice(c.currentColumn,c.currentColumn+d).reduce(function(e,g){return e+g},0);isNaN(c)||(a.w=c)}b.layout&&"position"!==b.layout&&(a.x=a.y=0);"table"===a.layout&&""===a.w&&Array.isArray(a.columnWidths)&&(a.w=a.columnWidths.reduce(function(e,g){return e+g},0))}function Am(a){switch(a.layout){case "position":return"xfaPosition";case "lr-tb":return"xfaLrTb";\ncase "rl-row":return"xfaRlRow";case "rl-tb":return"xfaRlTb";case "row":return"xfaRow";case "table":return"xfaTable";case "tb":return"xfaTb";default:return"xfaPosition"}}function Ac(a){for(var c=Object.create(null),b=arguments.length,d=Array(1<b?b-1:0),e=1;e<b;e++)d[e-1]=arguments[e];b=u.makeIterator(d);for(d=b.next();!d.done;d=b.next())if(d=d.value,e=a[d],null!==e)if(Bm.hasOwnProperty(d))Bm[d](a,c);else e instanceof na&&((e=e[gb]())?Object.assign(c,e):T("(DEBUG) - XFA - style for "+d+" not implemented yet"));\nreturn c}function re(a,c){var b=c.attributes,d=b.style,e={name:"div",attributes:{class:["xfaWrapper"],style:Object.create(null)},children:[]};b.class.push("xfaWrapped");if(a.border){var g=a.border[ja];b=g.widths;var f=g.insets;g=f[0];var h=f[3],k=f[0]+f[2];f=f[1]+f[3];switch(a.border.hand){case "even":g-=b[0]/2;h-=b[3]/2;var l="calc(100% + "+((b[1]+b[3])/2-f)+"px)";var m="calc(100% + "+((b[0]+b[2])/2-k)+"px)";break;case "left":g-=b[0];h-=b[3];l="calc(100% + "+(b[1]+b[3]-f)+"px)";m="calc(100% + "+\n(b[0]+b[2]-k)+"px)";break;case "right":l=f?"calc(100% - "+f+"px)":"100%",m=k?"calc(100% - "+k+"px)":"100%"}b=["xfaBorder"];Ke(a.border)&&b.push("xfaPrintOnly");a={name:"div",attributes:{class:b,style:{top:g+"px",left:h+"px",width:l,height:m}},children:[]};l=u.makeIterator(["border","borderWidth","borderColor","borderRadius","borderStyle"]);for(m=l.next();!m.done;m=l.next())m=m.value,void 0!==d[m]&&(a.attributes.style[m]=d[m],delete d[m]);e.children.push(a,c)}else e.children.push(c);c=u.makeIterator("background backgroundClip top left width height minWidth minHeight maxWidth maxHeight transform transformOrigin visibility".split(" "));\nfor(a=c.next();!a.done;a=c.next())a=a.value,void 0!==d[a]&&(e.attributes.style[a]=d[a],delete d[a]);e.attributes.style.position="absolute"===d.position?"absolute":"relative";delete d.position;d.alignSelf&&(e.attributes.style.alignSelf=d.alignSelf,delete d.alignSelf);return e}function Cm(a){var c=Ma(a.textIndent,"0px");if(!(0<=c)){var b="padding"+("left"===("right"===a.textAlign?"right":"left")?"Left":"Right"),d=Ma(a[b],"0px");a[b]=d-c+"px"}}function Ji(a,c){switch(a.access){case "nonInteractive":c.push("xfaNonInteractive");\nbreak;case "readOnly":c.push("xfaReadOnly");break;case "protected":c.push("xfaDisabled")}}function Ke(a){return 0<a.relevant.length&&!a.relevant[0].excluded&&"print"===a.relevant[0].viewname}function Dm(a){a=a[Ob]()[ja].paraStack;return a.length?a.at(-1):null}function Em(a,c,b){var d;if(null!=(d=b.attributes.class)&&d.includes("xfaRich")&&(c&&(""===a.h&&(c.height="auto"),""===a.w&&(c.width="auto")),a=Dm(a))){b=b.attributes.style;b.display="flex";b.flexDirection="column";switch(a.vAlign){case "top":b.justifyContent=\n"start";break;case "bottom":b.justifyContent="end";break;case "middle":b.justifyContent="center"}a=a[gb]();a=u.makeIterator(Object.entries(a));for(c=a.next();!c.done;c=a.next())d=u.makeIterator(c.value),c=d.next().value,d=d.next().value,c in b||(b[c]=d)}}function Fm(a,c,b,d){if(b){var e=ug(a.typeface);d.fontFamily=\'"\'+e+\'"\';if(b=b.find(e)){var g=b.regular.cssFontInfo.fontFamily;g!==e&&(d.fontFamily=\'"\'+g+\'"\');c=Dm(c);c&&""!==c.lineHeight||d.lineHeight||!(a=Gi(a,b))||(d.lineHeight=Math.max(1.2,a.lineHeight))}}else delete d.fontFamily}\nfunction Gm(a){return(a=Xf(a,null,{addDefaultProtocol:!0,tryConvertEncoding:!0}))?a.href:null}function Hm(a,c){return{name:"div",attributes:{class:["lr-tb"===a.layout?"xfaLr":"xfaRl"]},children:c}}function Im(a){if(!a[ja])return null;var c={name:"div",attributes:a[ja].attributes,children:a[ja].children};if(a[ja].failingNode){var b=a[ja].failingNode[qf]();b&&(a.layout.endsWith("-tb")?c.children.push(Hm(a,[b])):c.children.push(b))}return 0===c.children.length?null:c}function Jm(a,c,b){var d=a[ja],e=\nd.availableSpace,g=u.makeIterator(b);b=g.next().value;var f=g.next().value,h=g.next().value;g=g.next().value;switch(a.layout){case "position":d.width=Math.max(d.width,b+h);d.height=Math.max(d.height,f+g);d.children.push(c);break;case "lr-tb":case "rl-tb":d.line&&1!==d.attempt||(d.line=Hm(a,[]),d.children.push(d.line),d.numberInLine=0);d.numberInLine+=1;d.line.children.push(c);0===d.attempt?(d.currentWidth+=h,d.height=Math.max(d.height,d.prevHeight+g)):(d.currentWidth=h,d.prevHeight=d.height,d.height+=\ng,d.attempt=0);d.width=Math.max(d.width,d.currentWidth);break;case "rl-row":case "row":d.children.push(c);d.width+=h;d.height=Math.max(d.height,g);a=Ua(d.height);d=u.makeIterator(d.children);for(c=d.next();!c.done;c=d.next())c.value.attributes.style.height=a;break;case "table":d.width=Math.min(e.width,Math.max(d.width,h));d.height+=g;d.children.push(c);break;case "tb":d.width=Math.min(e.width,Math.max(d.width,h)),d.height+=g,d.children.push(c)}}function Km(a){var c=a[ja].availableSpace,b=a.margin?\na.margin.topInset+a.margin.bottomInset:0,d=a.margin?a.margin.leftInset+a.margin.rightInset:0;switch(a.layout){case "lr-tb":case "rl-tb":return 0===a[ja].attempt?{width:c.width-d-a[ja].currentWidth,height:c.height-b-a[ja].prevHeight}:{width:c.width-d,height:c.height-b-a[ja].height};case "rl-row":case "row":return{width:a[ja].columnWidths.slice(a[ja].currentColumn).reduce(function(e,g){return e+g}),height:c.height-d};case "table":case "tb":return{width:c.width-d,height:c.height-b-a[ja].height};default:return c}}\nfunction zg(a,c){var b;if(null===a[Ob]()[ja].firstUnsplittable||0===a.w||0===a.h)return!0;var d=a[Nb](),e=(null==(b=d[ja])?void 0:b.attempt)||0;b=u;var g=b.makeIterator,f=""===a.w?NaN:a.w,h=""===a.h?NaN:a.h,k=u.makeIterator([0,0]),l=k.next().value;k=k.next().value;switch(a.anchorType||""){case "bottomCenter":k=u.makeIterator([f/2,h]);l=k.next().value;k=k.next().value;break;case "bottomLeft":k=u.makeIterator([0,h]);l=k.next().value;k=k.next().value;break;case "bottomRight":k=u.makeIterator([f,h]);\nl=k.next().value;k=k.next().value;break;case "middleCenter":k=u.makeIterator([f/2,h/2]);l=k.next().value;k=k.next().value;break;case "middleLeft":k=u.makeIterator([0,h/2]);l=k.next().value;k=k.next().value;break;case "middleRight":k=u.makeIterator([f,h/2]);l=k.next().value;k=k.next().value;break;case "topCenter":k=u.makeIterator([f/2,0]);l=k.next().value;k=k.next().value;break;case "topRight":k=u.makeIterator([f,0]),l=k.next().value,k=k.next().value}switch(a.rotate||0){case 0:var m=u.makeIterator([-l,\n-k]);var n=m.next().value;m=m.next().value;break;case 90:m=u.makeIterator([-k,l]);n=m.next().value;m=m.next().value;h=u.makeIterator([h,-f]);f=h.next().value;h=h.next().value;break;case 180:m=u.makeIterator([l,k]);n=m.next().value;m=m.next().value;h=u.makeIterator([-f,-h]);f=h.next().value;h=h.next().value;break;case 270:m=u.makeIterator([k,-l]),n=m.next().value,m=m.next().value,h=u.makeIterator([-h,f]),f=h.next().value,h=h.next().value}g=g.call(b,[a.x+n+Math.min(0,f),a.y+m+Math.min(0,h),Math.abs(f),\nMath.abs(h)]);g.next();n=g.next().value;b=g.next().value;g=g.next().value;switch(d.layout){case "lr-tb":case "rl-tb":return 0===e?a[Ob]()[ja].noLayoutFailure?""!==a.w?2>=Math.round(b-c.width):2<c.width:""!==a.h&&2<Math.round(g-c.height)?!1:""!==a.w?2>=Math.round(b-c.width)?!0:0===d[ja].numberInLine?2<c.height:!1:2<c.width:a[Ob]()[ja].noLayoutFailure?!0:""!==a.h&&2<Math.round(g-c.height)?!1:""===a.w||2>=Math.round(b-c.width)?2<c.height:d[Fd]()?!1:2<c.height;case "table":case "tb":return a[Ob]()[ja].noLayoutFailure?\n!0:""===a.h||a[Gd]()?""===a.w||2>=Math.round(b-c.width)?2<c.height:d[Fd]()?!1:2<c.height:2>=Math.round(g-c.height);case "position":if(a[Ob]()[ja].noLayoutFailure||""===a.h||2>=Math.round(g+n-c.height))return!0;a=a[Ob]()[ja].currentContentArea;return g+n>a.h;case "rl-row":case "row":return a[Ob]()[ja].noLayoutFailure?!0:""!==a.h?2>=Math.round(g-c.height):!0;default:return!0}}function Lm(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=\n!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Qq(a,c,b){return c&&Lm(a.prototype,c),b&&Lm(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Ca(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Ki(a,c)}function Ki(a,\nc){return Ki=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Ki(a,c)}function Mm(a){return a&&a.border?(a=a.border[lc]())?{w:a.widths[0]+a.widths[2]+a.insets[0]+a.insets[2],h:a.widths[1]+a.widths[3]+a.insets[1]+a.insets[3]}:{w:0,h:0}:{w:0,h:0}}function Li(a){return a.margin&&(a.margin.topInset||a.margin.rightInset||a.margin.bottomInset||a.margin.leftInset)}function Mi(a,c){if(!a.value){var b=new Ni({});a[Cb](b);a.value=b}a.value[Gc](c)}function Ag(a){var c,\nb,d;return u.generator.createGenerator(Ag,function(e){switch(e.nextAddress){case 1:c=u.makeIterator(a[ac]()),b=c.next();case 2:if(b.done){e.jumpTo(0);break}d=b.value;if(!(d instanceof Oi)){e.jumpTo(5);break}return e.yieldAll(d[Le](),6);case 6:e.jumpTo(3);break;case 5:return e.yield(d,3);case 3:b=c.next(),e.jumpTo(2)}})}function rf(a){var c;return"error"===(null==(c=a.validate)?void 0:c.nullTest)}function Bg(a){for(;a;){if(!a.traversal){a[nd]=a[Va]()[nd];break}if(a[nd])break;for(var c=null,b=u.makeIterator(a.traversal[ac]()),\nd=b.next();!d.done;d=b.next())if(d=d.value,"next"===d.operation){c=d;break}if(!c||!c.ref){a[nd]=a[Va]()[nd];break}b=a[Ob]();a[nd]=++b[nd];a=b[Hd](c.ref,a);if(!a)break;a=a[0]}}function Cg(a,c){var b=a.assist;if(b){var d=b[Ra]();d&&(c.title=d);if(b=b.role.match(Rq))b=b[1],c.role="heading",c["aria-level"]=b}if("table"===a.layout)c.role="table";else if("row"===a.layout)c.role="row";else if(a=a[Va](),"row"===a.layout){var e;c.role="TH"===(null==(e=a.assist)?void 0:e.role)?"columnheader":"cell"}}function se(a){if(!a.assist)return null;\na=a.assist;return a.speak&&""!==a.speak[ra]?a.speak[ra]:a.toolTip?a.toolTip[ra]:null}function Sd(a){return Pa.success({name:"div",attributes:{class:["xfaRich"],style:Object.create(null)},children:[{name:"span",attributes:{style:Object.create(null)},value:a}]})}function Dg(a){var c=a[Ob]();null===c[ja].firstUnsplittable&&(c[ja].firstUnsplittable=a,c[ja].noLayoutFailure=!0)}function Eg(a){var c=a[Ob]();c[ja].firstUnsplittable===a&&(c[ja].noLayoutFailure=!1)}function Nm(a){if(a[ja])return!1;a[ja]=Object.create(null);\nif("auto"===a.targetType)return!1;var c=a[Ob](),b=null;if(a.target){b=c[Hd](a.target,a[Va]());if(!b)return!1;b=b[0]}c=c[ja];var d=c.currentPageArea,e=c.currentContentArea;if("pageArea"===a.targetType)return b instanceof Me||(b=null),a.startNew?(a[ja].target=b||d,!0):b&&b!==d?(a[ja].target=b,!0):!1;b instanceof Pi||(b=null);var g=b&&b[Va]();c=g;if(a.startNew)b?(d=g.contentArea.children,e=d.indexOf(e),b=d.indexOf(b),-1!==e&&e<b&&(c=null),--b):b=d.contentArea.children.indexOf(e);else if(b&&b!==e)b=g.contentArea.children.indexOf(b)-\n1,c=g===d?null:g;else return!1;a[ja].target=c;a[ja].index=b;return!0}function Om(a,c,b){var d=a[Ob](),e=d[ja].noLayoutFailure,g=c[Nb];c[Nb]=function(){return a};d[ja].noLayoutFailure=!0;b=c[Ra](b);a[te](b.html,b.bbox);d[ja].noLayoutFailure=e;c[Nb]=g}function Fg(a){var c=new Pm({});c[ra]=a;return c}function Qm(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&\nf){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Sq(a,c,b){return c&&Qm(a.prototype,c),b&&Qm(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function xa(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Qi(a,c)}function Qi(a,c){return Qi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,\nd){return b.__proto__=d,b},Qi(a,c)}function cd(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Ri(a,c)}function Ri(a,c){return Ri=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Ri(a,c)}function Rm(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Si(a,c)}function Si(a,c){return Si=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Si(a,c)}function Db(a,c){a.prototype=Object.create(c.prototype);\na.prototype.constructor=a;Ti(a,c)}function Ti(a,c){return Ti=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Ti(a,c)}function Tq(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Ui(a,c)}function Ui(a,c){return Ui=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Ui(a,c)}function Uq(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Vi(a,c)}function Vi(a,c){return Vi=Object.setPrototypeOf?\nObject.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Vi(a,c)}function Vq(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Wi(a,c)}function Wi(a,c){return Wi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Wi(a,c)}function Hc(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Xi(a,c)}function Xi(a,c){return Xi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Xi(a,c)}\nfunction Wq(a,c,b){var d=Object.create(null);if(!a)return d;var e=Object.create(null);a=u.makeIterator(a.split(";").map(function(l){return l.split(":",2)}));for(var g=a.next();!g.done;g=a.next()){var f=u.makeIterator(g.value);g=f.next().value;f=f.next().value;var h=Xq.get(g);if(""!==h){var k=f;h&&(k="string"===typeof h?h:h(f,e));g.endsWith("scale")?d.transform=d.transform?d[g]+" "+k:k:d[g.replaceAll(/-([a-zA-Z])/g,function(l,m){return m.toUpperCase()})]=k}}d.fontFamily&&Fm({typeface:d.fontFamily,\nweight:d.fontWeight||"normal",posture:d.fontStyle||"normal",size:e.fontSize||0},c,c[rb].fontFinder,d);b&&d.verticalAlign&&"0px"!==d.verticalAlign&&d.fontSize&&(c=Ma(d.fontSize),d.fontSize=Ua(.583*c),d.verticalAlign=Ua(Math.sign(Ma(d.verticalAlign))*c*.333));b&&d.fontSize&&(d.fontSize="calc("+d.fontSize+" * var(--scale-factor))");Cm(d);return d}function Yq(a){return a.style?a.style.trim().split(/\\s*;\\s*/).filter(function(c){return!!c}).map(function(c){return c.split(/\\s*:\\s*/,2)}).filter(function(c){var b=\nu.makeIterator(c);c=b.next().value;b=b.next().value;"font-family"===c&&a[rb].usedTypefaces.add(b);return Zq.has(c)}).map(function(c){return c.join(":")}).join(";"):""}function Sm(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Yi(a,c)}function Yi(a,c){return Yi=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Yi(a,c)}function $q(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;Zi(a,c)}function Zi(a,c){return Zi=Object.setPrototypeOf?\nObject.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},Zi(a,c)}function Tm(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function $i(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){Tm(h,d,e,g,f,"next",k)}function f(k){Tm(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function sf(a){if(void 0===a)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");\nreturn a}function Jb(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;aj(a,c)}function aj(a,c){return aj=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},aj(a,c)}function Um(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=\ntypeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function Gg(a,c,b){return c&&Um(a.prototype,c),b&&Um(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function Vm(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function Bb(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){Vm(h,d,e,g,f,"next",k)}function f(k){Vm(h,\nd,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Ne(a,c){void 0===c&&(c=new Uint8ClampedArray(3));if(!Array.isArray(a))return c;var b=c||new Uint8ClampedArray(3);switch(a.length){case 0:return null;case 1:return ab.singletons.gray.getRgbItem(a,0,b,0),b;case 3:return ab.singletons.rgb.getRgbItem(a,0,b,0),b;case 4:return ab.singletons.cmyk.getRgbItem(a,0,b,0),b;default:return c}}function Ic(a){return Array.from(a,function(c){return c/255})}function tf(a,c){a=a.getArray("QuadPoints");if(!yc(a,\nnull)||0===a.length||0<a.length%8)return null;for(var b=new Float32Array(a.length),d=0,e=a.length;d<e;d+=8){var g=u.makeIterator(a.slice(d,d+8)),f=g.next().value,h=g.next().value,k=g.next().value,l=g.next().value,m=g.next().value,n=g.next().value,p=g.next().value,q=g.next().value;g=Math.min(f,k,m,p);f=Math.max(f,k,m,p);k=Math.min(h,l,n,q);h=Math.max(h,l,n,q);if(null!==c&&(g<c[0]||f>c[2]||k<c[1]||h>c[3]))return null;b.set([g,h,f,h,g,k,f,k],d)}return b}function bj(a,c,b){var d=u.makeIterator(Rb.getAxialAlignedBoundingBox(c,\nb));c=d.next().value;b=d.next().value;var e=d.next().value;d=d.next().value;if(c===e||b===d)return[1,0,0,1,a[0],a[1]];e=(a[2]-a[0])/(e-c);d=(a[3]-a[1])/(d-b);return[e,0,0,d,a[0]-c*e,a[1]-b*d]}function ar(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;cj(a,c)}function cj(a,c){return cj=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},cj(a,c)}function Wm(a){try{return decodeURIComponent(escape(a))}catch(c){return T(\'UTF-8 decoding failed: "\'+\nc+\'".\'),a}}function Xm(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function Ym(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){Xm(h,d,e,g,f,"next",k)}function f(k){Xm(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Zm(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=\nd.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function br(a,c,b){return c&&Zm(a.prototype,c),b&&Zm(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function $m(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function qc(a){return function(){var c=\nthis,b=arguments;return new Promise(function(d,e){function g(k){$m(h,d,e,g,f,"next",k)}function f(k){$m(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function cr(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;dj(a,c)}function dj(a,c){return dj=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},dj(a,c)}function an(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);\nvar e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function bn(a,c,b){return c&&an(a.prototype,c),b&&an(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function ej(a,c,b,d){void 0===b&&(b=1024);void 0===d&&(d=!1);var e=c.length;b=a.peekBytes(b);var g=b.length-\ne;if(0>=g)return!1;if(d)for(g=e-1,d=b.length-1;d>=g;){for(var f=0;f<e&&b[d-f]===c[g-f];)f++;if(f>=e)return a.pos+=d-g,!0;d--}else for(d=0;d<=g;){for(f=0;f<e&&b[d+f]===c[f];)f++;if(f>=e)return a.pos+=d,!0;d++}return!1}function cn(a,c){a.prototype=Object.create(c.prototype);a.prototype.constructor=a;fj(a,c)}function fj(a,c){return fj=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(b,d){return b.__proto__=d,b},fj(a,c)}function dn(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?\nc(k):Promise.resolve(k).then(d,e)}function gj(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){dn(h,d,e,g,f,"next",k)}function f(k){dn(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function en(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=\ntypeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function dr(a,c,b){return c&&en(a.prototype,c),b&&en(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function fn(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function er(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){fn(h,d,e,g,f,"next",k)}function f(k){fn(h,\nd,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function Oc(a){a instanceof Error||"object"===typeof a&&null!==a||db(\'wrapReason: Expected "reason" to be a (possibly cloned) Error.\');switch(a.name){case "AbortException":return new rc(a.message);case "MissingPDFException":return new gn(a.message);case "PasswordException":return new Hg(a.message,a.code);case "UnexpectedResponseException":return new hn(a.message,a.status);case "UnknownErrorException":return new Ig(a.message,a.details);default:return new Ig(a.message,\na.toString())}}function jn(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function kn(a){return function(){var c=this,b=arguments;return new Promise(function(d,e){function g(k){jn(h,d,e,g,f,"next",k)}function f(k){jn(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function ln(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=\nd.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function mn(a,c,b){return c&&ln(a.prototype,c),b&&ln(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}function nn(a,c,b,d,e,g,f){try{var h=a[g](f),k=h.value}catch(l){return void b(l)}h.done?c(k):Promise.resolve(k).then(d,e)}function Jg(a){return function(){var c=\nthis,b=arguments;return new Promise(function(d,e){function g(k){nn(h,d,e,g,f,"next",k)}function f(k){nn(h,d,e,g,f,"throw",k)}var h=a.apply(c,b);g(void 0)})}}function on(a,c){for(var b=0;b<c.length;b++){var d=c[b];d.enumerable=d.enumerable||!1;d.configurable=!0;"value"in d&&(d.writable=!0);var e=Object,g=e.defineProperty;a:{var f=d.key;if("object"==typeof f&&f){var h=f[Symbol.toPrimitive];if(void 0!==h){f=h.call(f,"string");if("object"!=typeof f)break a;throw new TypeError("@@toPrimitive must return a primitive value.");\n}f=String(f)}}g.call(e,a,"symbol"==typeof f?f:f+"",d)}}function fr(a,c,b){return c&&on(a.prototype,c),b&&on(a,b),Object.defineProperty(a,"prototype",{writable:!1}),a}var ep={9306:function(a,c,b){var d=b(4901),e=b(6823),g=TypeError;a.exports=function(f){if(d(f))return f;throw new g(e(f)+" is not a function");}},5548:function(a,c,b){var d=b(3517),e=b(6823),g=TypeError;a.exports=function(f){if(d(f))return f;throw new g(e(f)+" is not a constructor");}},3506:function(a,c,b){var d=b(3925),e=String,g=TypeError;\na.exports=function(f){if(d(f))return f;throw new g("Can\'t set "+e(f)+" as a prototype");}},7080:function(a,c,b){var d=b(4402).has;a.exports=function(e){d(e);return e}},6469:function(a,c,b){c=b(8227);var d=b(2360);b=b(4913).f;var e=c("unscopables"),g=Array.prototype;void 0===g[e]&&b(g,e,{configurable:!0,value:d(null)});a.exports=function(f){g[e][f]=!0}},7829:function(a,c,b){var d=b(8183).charAt;a.exports=function(e,g,f){return g+(f?d(e,g).length:1)}},679:function(a,c,b){var d=b(1625),e=TypeError;a.exports=\nfunction(g,f){if(d(f,g))return g;throw new e("Incorrect invocation");}},8551:function(a,c,b){var d=b(34),e=String,g=TypeError;a.exports=function(f){if(d(f))return f;throw new g(e(f)+" is not an object");}},7811:function(a){a.exports="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof DataView},7394:function(a,c,b){c=b(4576);var d=b(6706),e=b(2195);b=c.ArrayBuffer;var g=c.TypeError;a.exports=b&&d(b.prototype,"byteLength","get")||function(f){if("ArrayBuffer"!==e(f))throw new g("ArrayBuffer expected");\nreturn f.byteLength}},3238:function(a,c,b){var d=b(4576);c=b(7476);var e=b(7394),g=(b=(b=d.ArrayBuffer)&&b.prototype)&&c(b.slice);a.exports=function(f){if(0!==e(f)||!g)return!1;try{return g(f,0,0),!1}catch(h){return!0}}},5169:function(a,c,b){var d=b(3238),e=TypeError;a.exports=function(g){if(d(g))throw new e("ArrayBuffer is detached");return g}},5636:function(a,c,b){var d=b(4576);c=b(9504);var e=b(6706),g=b(7696),f=b(5169),h=b(7394),k=b(4483),l=b(1548),m=d.structuredClone,n=d.ArrayBuffer,p=d.DataView,\nq=Math.min;b=n.prototype;d=p.prototype;var r=c(b.slice),t=e(b,"resizable","get"),v=e(b,"maxByteLength","get"),w=c(d.getInt8),y=c(d.setInt8);a.exports=(l||k)&&function(x,z,A){var B=h(x);z=void 0===z?B:g(z);var C=!t||!t(x);f(x);if(l&&(x=m(x,{transfer:[x]}),B===z&&(A||C)))return x;if(B>=z&&(!A||C))A=r(x,0,z);else{A=A&&!C&&v?{maxByteLength:v(x)}:void 0;A=new n(z,A);C=new p(x);var D=new p(A);B=q(z,B);for(z=0;z<B;z++)y(D,z,w(C,z))}l||k(x);return A}},4644:function(a,c,b){function d(la){if(!l(la))return!1;\nla=n(la);return m(W,la)||m(Q,la)}function e(la){la=v(la);if(l(la)){var ta=A(la);return ta&&m(ta,"TypedArrayConstructor")?ta.TypedArrayConstructor:e(la)}}var g=b(7811),f=b(3724),h=b(4576),k=b(4901),l=b(34),m=b(9297),n=b(6955),p=b(6823);c=b(6699);var q=b(6840),r=b(2106),t=b(1625),v=b(2787),w=b(2967),y=b(8227),x=b(3392),z=b(1181);b=z.enforce;var A=z.get,B=h.Int8Array,C=B&&B.prototype;z=(z=h.Uint8ClampedArray)&&z.prototype;var D=B&&v(B),E=C&&v(C);B=Object.prototype;var G=h.TypeError;y=y("toStringTag");\nvar J=x("TYPED_ARRAY_TAG"),F=g&&!!w&&"Opera"!==n(h.opera);g=!1;var L,M,W={Int8Array:1,Uint8Array:1,Uint8ClampedArray:1,Int16Array:2,Uint16Array:2,Int32Array:4,Uint32Array:4,Float32Array:4,Float64Array:8},Q={BigInt64Array:8,BigUint64Array:8};for(L in W)(M=(x=h[L])&&x.prototype)?b(M).TypedArrayConstructor=x:F=!1;for(L in Q)(M=(x=h[L])&&x.prototype)&&(b(M).TypedArrayConstructor=x);if(!F||!k(D)||D===Function.prototype)if(D=function(){throw new G("Incorrect invocation");},F)for(L in W)h[L]&&w(h[L],D);\nif(!F||!E||E===B)if(E=D.prototype,F)for(L in W)h[L]&&w(h[L].prototype,E);F&&v(z)!==E&&w(z,E);if(f&&!m(E,y))for(L in g=!0,r(E,y,{configurable:!0,get:function(){return l(this)?this[J]:void 0}}),W)h[L]&&c(h[L],J,L);a.exports={NATIVE_ARRAY_BUFFER_VIEWS:F,TYPED_ARRAY_TAG:g&&J,aTypedArray:function(la){if(d(la))return la;throw new G("Target is not a typed array");},aTypedArrayConstructor:function(la){if(k(la)&&(!w||t(D,la)))return la;throw new G(p(la)+" is not a typed array constructor");},exportTypedArrayMethod:function(la,\nta,qa,va){if(f){if(qa)for(var S in W){var da=h[S];if(da&&m(da.prototype,la))try{delete da.prototype[la]}catch(R){try{da.prototype[la]=ta}catch(Y){}}}E[la]&&!qa||q(E,la,qa?ta:F&&C[la]||ta,va)}},exportTypedArrayStaticMethod:function(la,ta,qa){var va,S;if(f){if(w){if(qa)for(va in W)if((S=h[va])&&m(S,la))try{delete S[la]}catch(da){}if(!D[la]||qa)try{return q(D,la,qa?ta:F&&D[la]||ta)}catch(da){}else return}for(va in W)S=h[va],!S||S[la]&&!qa||q(S,la,ta)}},getTypedArrayConstructor:e,isView:function(la){if(!l(la))return!1;\nla=n(la);return"DataView"===la||m(W,la)||m(Q,la)},isTypedArray:d,TypedArray:D,TypedArrayPrototype:E}},6346:function(a,c,b){function d(V,ea,za,Ia,wa,Aa){V=va(V);za=C(za);Ia=Ia(+wa);Aa=!!Aa;if(za+ea>V.byteLength)throw new U("Wrong index");wa=V.bytes;V=za+V.byteOffset;for(za=0;za<ea;za++)wa[V+za]=Ia[Aa?za:ea-za-1]}function e(V,ea,za,Ia){V=va(V);za=C(za);Ia=!!Ia;if(za+ea>V.byteLength)throw new U("Wrong index");za+=V.byteOffset;ea=L(V.bytes,za,za+ea);return Ia?ea:ba(ea)}function g(V,ea,za){w(V.prototype,\nea,{configurable:!0,get:function(){return za(this)[ea]}})}function f(V){return aa(V,52,8)}function h(V){return aa(D(V),23,4)}function k(V){return V[3]<<24|V[2]<<16|V[1]<<8|V[0]}function l(V){return[V&255,V>>8&255,V>>16&255,V>>24&255]}function m(V){return[V&255,V>>8&255]}function n(V){return[V&255]}var p=b(4576);c=b(9504);var q=b(3724),r=b(7811),t=b(350),v=b(6699),w=b(2106),y=b(6279),x=b(9039),z=b(679),A=b(1291),B=b(8014),C=b(7696),D=b(5617),E=b(8490),G=b(2787),J=b(2967),F=b(4373),L=b(7680),M=b(3167),\nW=b(7740),Q=b(687),la=b(1181);b=t.PROPER;var ta=t.CONFIGURABLE,qa=la.getterFor("ArrayBuffer"),va=la.getterFor("DataView"),S=la.set,da=p.ArrayBuffer,R=da,Y=R&&R.prototype,fa=(t=p.DataView)&&t.prototype;la=Object.prototype;var H=p.Array,U=p.RangeError,N=c(F),ba=c([].reverse),aa=E.pack,X=E.unpack;if(r){var ha=b&&"ArrayBuffer"!==da.name;x(function(){da(1)})&&x(function(){new da(-1)})&&!x(function(){new da;new da(1.5);new da(NaN);return 1!==da.length||ha&&!ta})?ha&&ta&&v(da,"name","ArrayBuffer"):(R=function(V){z(this,\nY);return M(new da(C(V)),this,R)},R.prototype=Y,Y.constructor=R,W(R,da));J&&G(fa)!==la&&J(fa,la);p=new t(new R(2));var ma=c(fa.setInt8);p.setInt8(0,2147483648);p.setInt8(1,2147483649);!p.getInt8(0)&&p.getInt8(1)||y(fa,{setInt8:function(V,ea){ma(this,V,ea<<24>>24)},setUint8:function(V,ea){ma(this,V,ea<<24>>24)}},{unsafe:!0})}else R=function(V){z(this,Y);V=C(V);S(this,{type:"ArrayBuffer",bytes:N(H(V),0),byteLength:V});q||(this.byteLength=V,this.detached=!1)},Y=R.prototype,t=function(V,ea,za){z(this,\nfa);z(V,Y);var Ia=qa(V),wa=Ia.byteLength;ea=A(ea);if(0>ea||ea>wa)throw new U("Wrong offset");za=void 0===za?wa-ea:B(za);if(ea+za>wa)throw new U("Wrong length");S(this,{type:"DataView",buffer:V,byteLength:za,byteOffset:ea,bytes:Ia.bytes});q||(this.buffer=V,this.byteLength=za,this.byteOffset=ea)},fa=t.prototype,q&&(g(R,"byteLength",qa),g(t,"buffer",va),g(t,"byteLength",va),g(t,"byteOffset",va)),y(fa,{getInt8:function(V){return e(this,1,V)[0]<<24>>24},getUint8:function(V){return e(this,1,V)[0]},getInt16:function(V){var ea=\ne(this,2,V,1<arguments.length?arguments[1]:!1);return(ea[1]<<8|ea[0])<<16>>16},getUint16:function(V){var ea=e(this,2,V,1<arguments.length?arguments[1]:!1);return ea[1]<<8|ea[0]},getInt32:function(V){return k(e(this,4,V,1<arguments.length?arguments[1]:!1))},getUint32:function(V){return k(e(this,4,V,1<arguments.length?arguments[1]:!1))>>>0},getFloat32:function(V){return X(e(this,4,V,1<arguments.length?arguments[1]:!1),23)},getFloat64:function(V){return X(e(this,8,V,1<arguments.length?arguments[1]:!1),\n52)},setInt8:function(V,ea){d(this,1,V,n,ea)},setUint8:function(V,ea){d(this,1,V,n,ea)},setInt16:function(V,ea){d(this,2,V,m,ea,2<arguments.length?arguments[2]:!1)},setUint16:function(V,ea){d(this,2,V,m,ea,2<arguments.length?arguments[2]:!1)},setInt32:function(V,ea){d(this,4,V,l,ea,2<arguments.length?arguments[2]:!1)},setUint32:function(V,ea){d(this,4,V,l,ea,2<arguments.length?arguments[2]:!1)},setFloat32:function(V,ea){d(this,4,V,h,ea,2<arguments.length?arguments[2]:!1)},setFloat64:function(V,ea){d(this,\n8,V,f,ea,2<arguments.length?arguments[2]:!1)}});Q(R,"ArrayBuffer");Q(t,"DataView");a.exports={ArrayBuffer:R,DataView:t}},4373:function(a,c,b){var d=b(8981),e=b(5610),g=b(6198);a.exports=function(f){var h=d(this),k=g(h),l=arguments.length,m=e(1<l?arguments[1]:void 0,k);l=2<l?arguments[2]:void 0;for(k=void 0===l?k:e(l,k);k>m;)h[m++]=f;return h}},235:function(a,c,b){var d=b(9213).forEach;c=b(4598)("forEach");a.exports=c?[].forEach:function(e){return d(this,e,1<arguments.length?arguments[1]:void 0)}},\n5370:function(a,c,b){var d=b(6198);a.exports=function(e,g,f){for(var h=0,k=2<arguments.length?f:d(g),l=new e(k);k>h;)l[h]=g[h++];return l}},9617:function(a,c,b){function d(h){return function(k,l,m){k=e(k);var n=f(k);if(0===n)return!h&&-1;m=g(m,n);if(h&&l!==l)for(;n>m;){if(l=k[m++],l!==l)return!0}else for(;n>m;m++)if((h||m in k)&&k[m]===l)return h||m||0;return!h&&-1}}var e=b(5397),g=b(5610),f=b(6198);a.exports={includes:d(!0),indexOf:d(!1)}},3839:function(a,c,b){function d(k){var l=1===k;return function(m,\nn,p){m=f(m);var q=g(m),r=h(q);n=e(n,p);for(var t;0<r--;)if(p=q[r],t=n(p,r,m))switch(k){case 0:return p;case 1:return r}return l?-1:void 0}}var e=b(6080),g=b(7055),f=b(8981),h=b(6198);a.exports={findLast:d(0),findLastIndex:d(1)}},9213:function(a,c,b){function d(m){var n=1===m,p=2===m,q=3===m,r=4===m,t=6===m,v=7===m,w=5===m||t;return function(y,x,z,A){var B=f(y),C=g(B),D=h(C);x=e(x,z);z=0;A=A||k;y=n?A(y,D):p||v?A(y,0):void 0;for(var E;D>z;z++)if(w||z in C)if(A=C[z],E=x(A,z,B),m)if(n)y[z]=E;else if(E)switch(m){case 3:return!0;\ncase 5:return A;case 6:return z;case 2:l(y,A)}else switch(m){case 4:return!1;case 7:l(y,A)}return t?-1:q||r?r:y}}var e=b(6080);c=b(9504);var g=b(7055),f=b(8981),h=b(6198),k=b(1469),l=c([].push);a.exports={forEach:d(0),map:d(1),filter:d(2),some:d(3),every:d(4),find:d(5),findIndex:d(6),filterReject:d(7)}},4598:function(a,c,b){var d=b(9039);a.exports=function(e,g){var f=[][e];return!!f&&d(function(){f.call(null,g||function(){return 1},1)})}},926:function(a,c,b){function d(l){return function(m,n,p,q){m=\ng(m);var r=f(m),t=h(m);e(n);if(0===t&&2>p)throw new k("Reduce of empty array with no initial value");var v=l?t-1:0,w=l?-1:1;if(2>p)for(;;){if(v in r){q=r[v];v+=w;break}v+=w;if(l?0>v:t<=v)throw new k("Reduce of empty array with no initial value");}for(;l?0<=v:t>v;v+=w)v in r&&(q=n(q,r[v],v,m));return q}}var e=b(9306),g=b(8981),f=b(7055),h=b(6198),k=TypeError;a.exports={left:d(!1),right:d(!0)}},4527:function(a,c,b){c=b(3724);var d=b(4376),e=TypeError,g=Object.getOwnPropertyDescriptor;b=c&&!function(){if(void 0!==\nthis)return!0;try{Object.defineProperty([],"length",{writable:!1}).length=1}catch(f){return f instanceof TypeError}}();a.exports=b?function(f,h){if(d(f)&&!g(f,"length").writable)throw new e("Cannot set read only .length");return f.length=h}:function(f,h){return f.length=h}},7680:function(a,c,b){c=b(9504);a.exports=c([].slice)},4488:function(a,c,b){function d(f,h){var k=f.length;if(8>k)for(var l=1,m,n;l<k;){n=l;for(m=f[l];n&&0<h(f[n-1],m);)f[n]=f[--n];n!==l++&&(f[n]=m)}else{l=g(k/2);k=d(e(f,0,l),h);\nl=d(e(f,l),h);m=k.length;n=l.length;for(var p=0,q=0;p<m||q<n;)f[p+q]=p<m&&q<n?0>=h(k[p],l[q])?k[p++]:l[q++]:p<m?k[p++]:l[q++]}return f}var e=b(7680),g=Math.floor;a.exports=d},7433:function(a,c,b){var d=b(4376),e=b(3517),g=b(34),f=b(8227)("species"),h=Array;a.exports=function(k){if(d(k)){var l=k.constructor;e(l)&&(l===h||d(l.prototype))?l=void 0:g(l)&&(l=l[f],null===l&&(l=void 0))}return void 0===l?h:l}},1469:function(a,c,b){var d=b(7433);a.exports=function(e,g){return new (d(e))(0===g?0:g)}},7628:function(a,\nc,b){var d=b(6198);a.exports=function(e,g){var f=d(e);g=new g(f);for(var h=0;h<f;h++)g[h]=e[f-h-1];return g}},9928:function(a,c,b){var d=b(6198),e=b(1291),g=RangeError;a.exports=function(f,h,k,l){var m=d(f);k=e(k);k=0>k?m+k:k;if(k>=m||0>k)throw new g("Incorrect index");h=new h(m);for(var n=0;n<m;n++)h[n]=n===k?l:f[n];return h}},6319:function(a,c,b){var d=b(8551),e=b(9539);a.exports=function(g,f,h,k){try{return k?f(d(h)[0],h[1]):f(h)}catch(l){e(g,"throw",l)}}},4428:function(a,c,b){var d=b(8227)("iterator"),\ne=!1;try{var g=0;c={next:function(){return{done:!!g++}},"return":function(){e=!0}};c[d]=function(){return this};Array.from(c,function(){throw 2;})}catch(f){}a.exports=function(f,h){if(!h&&!e)return!1;var k=!1;try{h={},h[d]=function(){return{next:function(){return{done:k=!0}}}},f(h)}catch(l){}return k}},2195:function(a,c,b){c=b(9504);var d=c({}.toString),e=c("".slice);a.exports=function(g){return e(d(g),8,-1)}},6955:function(a,c,b){c=b(2140);var d=b(4901),e=b(2195),g=b(8227)("toStringTag"),f=Object,\nh="Arguments"===e(function(){return arguments}());a.exports=c?e:function(k){var l;if(void 0===k)var m="Undefined";else{if(null===k)var n="Null";else{a:{var p=k=f(k);try{n=p[g];break a}catch(q){}n=void 0}n="string"==typeof(m=n)?m:h?e(k):"Object"===(l=e(k))&&d(k.callee)?"Arguments":l}m=n}return m}},7740:function(a,c,b){var d=b(9297),e=b(5031),g=b(7347),f=b(4913);a.exports=function(h,k,l){for(var m=e(k),n=f.f,p=g.f,q=0;q<m.length;q++){var r=m[q];d(h,r)||l&&d(l,r)||n(h,r,p(k,r))}}},2211:function(a,c,\nb){c=b(9039);a.exports=!c(function(){function d(){}d.prototype.constructor=null;return Object.getPrototypeOf(new d)!==d.prototype})},2529:function(a){a.exports=function(c,b){return{value:c,done:b}}},6699:function(a,c,b){c=b(3724);var d=b(4913),e=b(6980);a.exports=c?function(g,f,h){return d.f(g,f,e(1,h))}:function(g,f,h){g[f]=h;return g}},6980:function(a){a.exports=function(c,b){return{enumerable:!(c&1),configurable:!(c&2),writable:!(c&4),value:b}}},2278:function(a,c,b){var d=b(3724),e=b(4913),g=b(6980);\na.exports=function(f,h,k){d?e.f(f,h,g(0,k)):f[h]=k}},2106:function(a,c,b){var d=b(283),e=b(4913);a.exports=function(g,f,h){h.get&&d(h.get,f,{getter:!0});h.set&&d(h.set,f,{setter:!0});return e.f(g,f,h)}},6840:function(a,c,b){var d=b(4901),e=b(4913),g=b(283),f=b(9433);a.exports=function(h,k,l,m){m||(m={});var n=m.enumerable,p=void 0!==m.name?m.name:k;d(l)&&g(l,p,m);if(m.global)n?h[k]=l:f(k,l);else{try{m.unsafe?h[k]&&(n=!0):delete h[k]}catch(q){}n?h[k]=l:e.f(h,k,{value:l,enumerable:!1,configurable:!m.nonConfigurable,\nwritable:!m.nonWritable})}return h}},6279:function(a,c,b){var d=b(6840);a.exports=function(e,g,f){for(var h in g)d(e,h,g[h],f);return e}},9433:function(a,c,b){var d=b(4576),e=Object.defineProperty;a.exports=function(g,f){try{e(d,g,{value:f,configurable:!0,writable:!0})}catch(h){d[g]=f}return f}},4606:function(a,c,b){var d=b(6823),e=TypeError;a.exports=function(g,f){if(!delete g[f])throw new e("Cannot delete property "+d(f)+" of "+d(g));}},3724:function(a,c,b){c=b(9039);a.exports=!c(function(){return 7!==\nObject.defineProperty({},1,{get:function(){return 7}})[1]})},4483:function(a,c,b){var d=b(4576);c=b(9429);b=b(1548);var e=d.structuredClone,g=d.ArrayBuffer;d=d.MessageChannel;var f=!1,h;if(b)f=function(n){e(n,{transfer:[n]})};else if(g)try{if(!d&&(h=c("worker_threads"))&&(d=h.MessageChannel),d){var k=new d;var l=new g(2);var m=function(n){k.port1.postMessage(null,[n])};2===l.byteLength&&(m(l),0===l.byteLength&&(f=m))}}catch(n){}a.exports=f},4055:function(a,c,b){c=b(4576);b=b(34);var d=c.document,\ne=b(d)&&b(d.createElement);a.exports=function(g){return e?d.createElement(g):{}}},6837:function(a){var c=TypeError;a.exports=function(b){if(9007199254740991<b)throw c("Maximum allowed index exceeded");return b}},5002:function(a){a.exports={IndexSizeError:{s:"INDEX_SIZE_ERR",c:1,m:1},DOMStringSizeError:{s:"DOMSTRING_SIZE_ERR",c:2,m:0},HierarchyRequestError:{s:"HIERARCHY_REQUEST_ERR",c:3,m:1},WrongDocumentError:{s:"WRONG_DOCUMENT_ERR",c:4,m:1},InvalidCharacterError:{s:"INVALID_CHARACTER_ERR",c:5,m:1},\nNoDataAllowedError:{s:"NO_DATA_ALLOWED_ERR",c:6,m:0},NoModificationAllowedError:{s:"NO_MODIFICATION_ALLOWED_ERR",c:7,m:1},NotFoundError:{s:"NOT_FOUND_ERR",c:8,m:1},NotSupportedError:{s:"NOT_SUPPORTED_ERR",c:9,m:1},InUseAttributeError:{s:"INUSE_ATTRIBUTE_ERR",c:10,m:1},InvalidStateError:{s:"INVALID_STATE_ERR",c:11,m:1},SyntaxError:{s:"SYNTAX_ERR",c:12,m:1},InvalidModificationError:{s:"INVALID_MODIFICATION_ERR",c:13,m:1},NamespaceError:{s:"NAMESPACE_ERR",c:14,m:1},InvalidAccessError:{s:"INVALID_ACCESS_ERR",\nc:15,m:1},ValidationError:{s:"VALIDATION_ERR",c:16,m:0},TypeMismatchError:{s:"TYPE_MISMATCH_ERR",c:17,m:1},SecurityError:{s:"SECURITY_ERR",c:18,m:1},NetworkError:{s:"NETWORK_ERR",c:19,m:1},AbortError:{s:"ABORT_ERR",c:20,m:1},URLMismatchError:{s:"URL_MISMATCH_ERR",c:21,m:1},QuotaExceededError:{s:"QUOTA_EXCEEDED_ERR",c:22,m:1},TimeoutError:{s:"TIMEOUT_ERR",c:23,m:1},InvalidNodeTypeError:{s:"INVALID_NODE_TYPE_ERR",c:24,m:1},DataCloneError:{s:"DATA_CLONE_ERR",c:25,m:1}}},7400:function(a){a.exports={CSSRuleList:0,\nCSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0}},9296:function(a,\nc,b){c=(c=b(4055)("span").classList)&&c.constructor&&c.constructor.prototype;a.exports=c===Object.prototype?void 0:c},8727:function(a){a.exports="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ")},3709:function(a,c,b){c=b(2839).match(/firefox\\/(\\d+)/i);a.exports=!!c&&+c[1]},3763:function(a,c,b){c=b(2839);a.exports=/MSIE|Trident/.test(c)},4265:function(a,c,b){c=b(2839);a.exports=/ipad|iphone|ipod/i.test(c)&&"undefined"!=typeof Pebble},9544:function(a,\nc,b){c=b(2839);a.exports=/(?:ipad|iphone|ipod).*applewebkit/i.test(c)},8574:function(a,c,b){c=b(4215);a.exports="NODE"===c},7860:function(a,c,b){c=b(2839);a.exports=/web0s(?!.*chrome)/i.test(c)},2839:function(a,c,b){c=(c=b(4576).navigator)&&c.userAgent;a.exports=c?String(c):""},9519:function(a,c,b){c=b(4576);b=b(2839);var d=c.process;c=c.Deno;c=(c=d&&d.versions||c&&c.version)&&c.v8;if(c){c=c.split(".");var e=0<c[0]&&4>c[0]?1:+(c[0]+c[1])}!e&&b&&(c=b.match(/Edge\\/(\\d+)/),(!c||74<=c[1])&&(c=b.match(/Chrome\\/(\\d+)/))&&\n(e=+c[1]));a.exports=e},3607:function(a,c,b){c=b(2839).match(/AppleWebKit\\/(\\d+)\\./);a.exports=!!c&&+c[1]},4215:function(a,c,b){function d(g){return e.slice(0,g.length)===g}c=b(4576);var e=b(2839);b=b(2195);a.exports=d("Bun/")?"BUN":d("Cloudflare-Workers")?"CLOUDFLARE":d("Deno/")?"DENO":d("Node.js/")?"NODE":c.Bun&&"string"==typeof Bun.version?"BUN":c.Deno&&"object"==typeof Deno.version?"DENO":"process"===b(c.process)?"NODE":c.window&&c.document?"BROWSER":"REST"},6193:function(a,c,b){c=b(9504);var d=\nError,e=c("".replace);c=String((new d("zxcasd")).stack);var g=/\\n\\s*at [^:]*:[^\\n]*/,f=g.test(c);a.exports=function(h,k){if(f&&"string"==typeof h&&!d.prepareStackTrace)for(;k--;)h=e(h,g,"");return h}},747:function(a,c,b){var d=b(6699),e=b(6193),g=b(4659),f=Error.captureStackTrace;a.exports=function(h,k,l,m){g&&(f?f(h,k):d(h,"stack",e(l,m)))}},4659:function(a,c,b){c=b(9039);var d=b(6980);a.exports=!c(function(){var e=Error("a");if(!("stack"in e))return!0;Object.defineProperty(e,"stack",d(1,7));return 7!==\ne.stack})},6518:function(a,c,b){var d=b(4576),e=b(7347).f,g=b(6699),f=b(6840),h=b(9433),k=b(7740),l=b(2796);a.exports=function(m,n){var p=m.target,q=m.global,r=m.stat,t,v,w;if(v=q?d:r?d[p]||h(p,{}):d[p]&&d[p].prototype)for(w in n){var y=n[w];var x=m.dontCallGetSet?(t=e(v,w))&&t.value:v[w];t=l(q?w:p+(r?".":"#")+w,m.forced);if(!t&&void 0!==x){if(typeof y==typeof x)continue;k(y,x)}(m.sham||x&&x.sham)&&g(y,"sham",!0);f(v,w,y,m)}}},9039:function(a){a.exports=function(c){try{return!!c()}catch(b){return!0}}},\n9228:function(a,c,b){b(7495);var d=b(9565),e=b(6840),g=b(7323),f=b(9039),h=b(8227),k=b(6699),l=h("species"),m=RegExp.prototype;a.exports=function(n,p,q,r){var t=h(n),v=!f(function(){var x={};x[t]=function(){return 7};return 7!==""[n](x)}),w=v&&!f(function(){var x=!1,z=/a/;"split"===n&&(z={constructor:{}},z.constructor[l]=function(){return z},z.flags="",z[t]=/./[t]);z.exec=function(){x=!0;return null};z[t]("");return!x});if(!v||!w||q){var y=/./[t];p=p(t,""[n],function(x,z,A,B,C){var D=z.exec;return D===\ng||D===m.exec?v&&!C?{done:!0,value:d(y,z,A,B)}:{done:!0,value:d(x,A,z,B)}:{done:!1}});e(String.prototype,n,p[0]);e(m,t,p[1])}r&&k(m[t],"sham",!0)}},259:function(a,c,b){function d(k,l,m,n,p,q,r,t){var v=0;r=r?h(r,t):!1;for(var w;v<n;)v in m&&(t=r?r(m[v],v,l):m[v],0<q&&e(t)?(w=g(t),p=d(k,l,t,w,p,q-1)-1):(f(p+1),k[p]=t),p++),v++;return p}var e=b(4376),g=b(6198),f=b(6837),h=b(6080);a.exports=d},8745:function(a,c,b){c=b(616);b=Function.prototype;var d=b.apply,e=b.call;a.exports="object"==typeof Reflect&&\nReflect.apply||(c?e.bind(d):function(){return e.apply(d,arguments)})},6080:function(a,c,b){c=b(7476);var d=b(9306),e=b(616),g=c(c.bind);a.exports=function(f,h){d(f);return void 0===h?f:e?g(f,h):function(){return f.apply(h,arguments)}}},616:function(a,c,b){c=b(9039);a.exports=!c(function(){var d=function(){}.bind();return"function"!=typeof d||d.hasOwnProperty("prototype")})},9565:function(a,c,b){c=b(616);var d=Function.prototype.call;a.exports=c?d.bind(d):function(){return d.apply(d,arguments)}},350:function(a,\nc,b){c=b(3724);var d=b(9297);b=Function.prototype;var e=c&&Object.getOwnPropertyDescriptor,g=(d=d(b,"name"))&&"something"===function(){}.name;c=d&&(!c||c&&e(b,"name").configurable);a.exports={EXISTS:d,PROPER:g,CONFIGURABLE:c}},6706:function(a,c,b){var d=b(9504),e=b(9306);a.exports=function(g,f,h){try{return d(e(Object.getOwnPropertyDescriptor(g,f)[h]))}catch(k){}}},7476:function(a,c,b){var d=b(2195),e=b(9504);a.exports=function(g){if("Function"===d(g))return e(g)}},9504:function(a,c,b){c=b(616);b=\nFunction.prototype;var d=b.call;b=c&&b.bind.bind(d,d);a.exports=c?b:function(e){return function(){return d.apply(e,arguments)}}},9429:function(a,c,b){var d=b(4576),e=b(8574);a.exports=function(g){if(e){try{return d.process.getBuiltinModule(g)}catch(f){}try{return Function(\'return require("\'+g+\'")\')()}catch(f){}}}},7751:function(a,c,b){var d=b(4576),e=b(4901);a.exports=function(g,f){if(2>arguments.length){var h=d[g];h=e(h)?h:void 0}else h=d[g]&&d[g][f];return h}},1767:function(a){a.exports=function(c){return{iterator:c,\nnext:c.next,done:!1}}},851:function(a,c,b){var d=b(6955),e=b(5966),g=b(4117),f=b(6269),h=b(8227)("iterator");a.exports=function(k){if(!g(k))return e(k,h)||e(k,"@@iterator")||f[d(k)]}},81:function(a,c,b){var d=b(9565),e=b(9306),g=b(8551),f=b(6823),h=b(851),k=TypeError;a.exports=function(l,m){var n=2>arguments.length?h(l):m;if(e(n))return g(d(n,l));throw new k(f(l)+" is not iterable");}},6933:function(a,c,b){c=b(9504);var d=b(4376),e=b(4901),g=b(2195),f=b(655),h=c([].push);a.exports=function(k){if(e(k))return k;\nif(d(k)){for(var l=k.length,m=[],n=0;n<l;n++){var p=k[n];"string"==typeof p?h(m,p):("number"==typeof p||"Number"===g(p)||"String"===g(p))&&h(m,f(p))}var q=m.length,r=!0;return function(t,v){if(r)return r=!1,v;if(d(this))return v;for(var w=0;w<q;w++)if(m[w]===t)return v}}}},5966:function(a,c,b){var d=b(9306),e=b(4117);a.exports=function(g,f){g=g[f];return e(g)?void 0:d(g)}},3789:function(a,c,b){function d(p,q){this.set=p;this.size=n(q,0);this.has=e(p.has);this.keys=e(p.keys)}var e=b(9306),g=b(8551),\nf=b(9565),h=b(1291),k=b(1767),l=RangeError,m=TypeError,n=Math.max;d.prototype={getIterator:function(){return k(g(f(this.keys,this.set)))},includes:function(p){return f(this.has,this.set,p)}};a.exports=function(p){g(p);var q=+p.size;if(q!==q)throw new m("Invalid size");q=h(q);if(0>q)throw new l("Invalid size");return new d(p,q)}},2478:function(a,c,b){c=b(9504);var d=b(8981),e=Math.floor,g=c("".charAt),f=c("".replace),h=c("".slice),k=/\\$([$&\'`]|\\d{1,2}|<[^>]*>)/g,l=/\\$([$&\'`]|\\d{1,2})/g;a.exports=function(m,\nn,p,q,r,t){var v=p+m.length,w=q.length,y=l;void 0!==r&&(r=d(r),y=k);return f(t,y,function(x,z){switch(g(z,0)){case "$":return"$";case "&":return m;case "`":return h(n,0,p);case "\'":return h(n,v);case "<":x=r[h(z,1,-1)];break;default:var A=+z;if(0===A)return x;if(A>w)return A=e(A/10),0===A?x:A<=w?void 0===q[A-1]?g(z,1):q[A-1]+g(z,1):x;x=q[A-1]}return void 0===x?"":x})}},4576:function(a){function c(b){return b&&b.Math===Math&&b}a.exports=c("object"==typeof globalThis&&globalThis)||c("object"==typeof window&&\nwindow)||c("object"==typeof self&&self)||c("object"==typeof global&&global)||c("object"==typeof this&&this)||function(){return this}()||Function("return this")()},9297:function(a,c,b){c=b(9504);var d=b(8981),e=c({}.hasOwnProperty);a.exports=Object.hasOwn||function(g,f){return e(d(g),f)}},421:function(a){a.exports={}},3138:function(a){a.exports=function(c,b){try{1===arguments.length?console.error(c):console.error(c,b)}catch(d){}}},397:function(a,c,b){c=b(7751);a.exports=c("document","documentElement")},\n5917:function(a,c,b){c=b(3724);var d=b(9039),e=b(4055);a.exports=!c&&!d(function(){return 7!==Object.defineProperty(e("div"),"a",{get:function(){return 7}}).a})},8490:function(a){var c=Array,b=Math.abs,d=Math.pow,e=Math.floor,g=Math.log,f=Math.LN2;a.exports={pack:function(h,k,l){var m=c(l);l=8*l-k-1;var n=(1<<l)-1,p=n>>1,q=23===k?d(2,-24)-d(2,-77):0,r=0>h||0===h&&0>1/h?1:0,t=0;h=b(h);if(h!==h||Infinity===h){h=h!==h?1:0;var v=n}else{v=e(g(h)/f);var w=d(2,-v);1>h*w&&(v--,w*=2);h=1<=v+p?h+q/w:h+q*d(2,\n1-p);2<=h*w&&(v++,w/=2);v+p>=n?(h=0,v=n):1<=v+p?(h=(h*w-1)*d(2,k),v+=p):(h=h*d(2,p-1)*d(2,k),v=0)}for(;8<=k;)m[t++]=h&255,h/=256,k-=8;v=v<<k|h;for(l+=k;0<l;)m[t++]=v&255,v/=256,l-=8;m[t-1]|=128*r;return m},unpack:function(h,k){var l=h.length,m=8*l-k-1,n=(1<<m)-1,p=n>>1;m-=7;--l;var q=h[l--],r=q&127;for(q>>=7;0<m;)r=256*r+h[l--],m-=8;var t=r&(1<<-m)-1;r>>=-m;for(m+=k;0<m;)t=256*t+h[l--],m-=8;if(0===r)r=1-p;else{if(r===n)return t?NaN:q?-Infinity:Infinity;t+=d(2,k);r-=p}return(q?-1:1)*t*d(2,r-k)}}},\n7055:function(a,c,b){c=b(9504);var d=b(9039),e=b(2195),g=Object,f=c("".split);a.exports=d(function(){return!g("z").propertyIsEnumerable(0)})?function(h){return"String"===e(h)?f(h,""):g(h)}:g},3167:function(a,c,b){var d=b(4901),e=b(34),g=b(2967);a.exports=function(f,h,k){var l,m;g&&d(l=h.constructor)&&l!==k&&e(m=l.prototype)&&m!==k.prototype&&g(f,m);return f}},3706:function(a,c,b){c=b(9504);var d=b(4901);b=b(7629);var e=c(Function.toString);d(b.inspectSource)||(b.inspectSource=function(g){return e(g)});\na.exports=b.inspectSource},7584:function(a,c,b){var d=b(34),e=b(6699);a.exports=function(g,f){d(f)&&"cause"in f&&e(g,"cause",f.cause)}},1181:function(a,c,b){c=b(8622);var d=b(4576),e=b(34),g=b(6699),f=b(9297),h=b(7629),k=b(6119);b=b(421);var l=d.TypeError;d=d.WeakMap;if(c||h.state){var m=h.state||(h.state=new d);m.get=m.get;m.has=m.has;m.set=m.set;var n=function(t,v){if(m.has(t))throw new l("Object already initialized");v.facade=t;m.set(t,v);return v};var p=function(t){return m.get(t)||{}};var q=\nfunction(t){return m.has(t)}}else{var r=k("state");b[r]=!0;n=function(t,v){if(f(t,r))throw new l("Object already initialized");v.facade=t;g(t,r,v);return v};p=function(t){return f(t,r)?t[r]:{}};q=function(t){return f(t,r)}}a.exports={set:n,get:p,has:q,enforce:function(t){return q(t)?p(t):n(t,{})},getterFor:function(t){return function(v){var w;if(!e(v)||(w=p(v)).type!==t)throw new l("Incompatible receiver, "+t+" required");return w}}}},4209:function(a,c,b){c=b(8227);var d=b(6269),e=c("iterator"),g=\nArray.prototype;a.exports=function(f){return void 0!==f&&(d.Array===f||g[e]===f)}},4376:function(a,c,b){var d=b(2195);a.exports=Array.isArray||function(e){return"Array"===d(e)}},1108:function(a,c,b){var d=b(6955);a.exports=function(e){e=d(e);return"BigInt64Array"===e||"BigUint64Array"===e}},4901:function(a){var c="object"==typeof document&&document.all;a.exports="undefined"==typeof c&&void 0!==c?function(b){return"function"==typeof b||b===c}:function(b){return"function"==typeof b}},3517:function(a,\nc,b){function d(t){if(!h(t))return!1;switch(k(t)){case "AsyncFunction":case "GeneratorFunction":case "AsyncGeneratorFunction":return!1}try{return r||!!q(p,m(t))}catch(v){return!0}}function e(t){if(!h(t))return!1;try{return n(g,[],t),!0}catch(v){return!1}}function g(){}c=b(9504);var f=b(9039),h=b(4901),k=b(6955),l=b(7751),m=b(3706),n=l("Reflect","construct"),p=/^\\s*(?:class|function)\\b/,q=c(p.exec),r=!p.test(g);d.sham=!0;a.exports=!n||f(function(){var t;return e(e.call)||!e(Object)||!e(function(){t=\n!0})||t})?d:e},2796:function(a,c,b){function d(n,p){n=k[h(n)];return n===m?!0:n===l?!1:g(p)?e(p):!!p}var e=b(9039),g=b(4901),f=/#|\\.prototype\\./,h=d.normalize=function(n){return String(n).replace(f,".").toLowerCase()},k=d.data={},l=d.NATIVE="N",m=d.POLYFILL="P";a.exports=d},2087:function(a,c,b){var d=b(34),e=Math.floor;a.exports=Number.isInteger||function(g){return!d(g)&&isFinite(g)&&e(g)===g}},4117:function(a){a.exports=function(c){return null===c||void 0===c}},34:function(a,c,b){var d=b(4901);a.exports=\nfunction(e){return"object"==typeof e?null!==e:d(e)}},3925:function(a,c,b){var d=b(34);a.exports=function(e){return d(e)||null===e}},6395:function(a){a.exports=!1},788:function(a,c,b){var d=b(34),e=b(2195),g=b(8227)("match");a.exports=function(f){var h;return d(f)&&(void 0!==(h=f[g])?!!h:"RegExp"===e(f))}},757:function(a,c,b){var d=b(7751),e=b(4901),g=b(1625);c=b(7040);var f=Object;a.exports=c?function(h){return"symbol"==typeof h}:function(h){var k=d("Symbol");return e(k)&&g(k.prototype,f(h))}},507:function(a,\nc,b){var d=b(9565);a.exports=function(e,g,f){f=f?e:e.iterator;e=e.next;for(var h;!(h=d(e,f)).done;)if(h=g(h.value),void 0!==h)return h}},2652:function(a,c,b){function d(v,w){this.stopped=v;this.result=w}var e=b(6080),g=b(9565),f=b(8551),h=b(6823),k=b(4209),l=b(6198),m=b(1625),n=b(81),p=b(851),q=b(9539),r=TypeError,t=d.prototype;a.exports=function(v,w,y){function x(F){return A?(f(F),D?E(F[0],F[1],z):E(F[0],F[1])):D?E(F,z):E(F)}function z(F){J&&q(J,"normal",F);return new d(!0,F)}var A=!(!y||!y.AS_ENTRIES),\nB=!(!y||!y.IS_RECORD),C=!(!y||!y.IS_ITERATOR),D=!(!y||!y.INTERRUPTED),E=e(w,y&&y.that),G;if(B)var J=v.iterator;else if(C)J=v;else{w=p(v);if(!w)throw new r(h(v)+" is not iterable");if(k(w)){B=0;for(w=l(v);w>B;B++)if((G=x(v[B]))&&m(t,G))return G;return new d(!1)}J=n(v,w)}for(v=B?v.next:J.next;!(B=g(v,J)).done;){try{G=x(B.value)}catch(F){q(J,"throw",F)}if("object"==typeof G&&G&&m(t,G))return G}return new d(!1)}},9539:function(a,c,b){var d=b(9565),e=b(8551),g=b(5966);a.exports=function(f,h,k){e(f);try{var l=\ng(f,"return");if(!l){if("throw"===h)throw k;return k}l=d(l,f)}catch(n){var m=!0;l=n}if("throw"===h)throw k;if(m)throw l;e(l);return k}},3994:function(a,c,b){function d(){return this}var e=b(7657).IteratorPrototype,g=b(2360),f=b(6980),h=b(687),k=b(6269);a.exports=function(l,m,n,p){m+=" Iterator";l.prototype=g(e,{next:f(+!p,n)});h(l,m,!1,!0);k[m]=d;return l}},9462:function(a,c,b){function d(v){var w=k.getterFor(v?"WrapForValidIterator":"IteratorHelper");return f(g(m),{next:function(){var y=w(this);\nif(v)return y.nextHandler();try{var x=y.done?void 0:y.nextHandler();return n(x,y.done)}catch(z){throw y.done=!0,z;}},"return":function(){var y=w(this),x=y.iterator;y.done=!0;if(v)return(y=l(x,"return"))?e(y,x):n(void 0,!0);if(y.inner)try{p(y.inner.iterator,"normal")}catch(z){return p(x,"throw",z)}p(x,"normal");return n(void 0,!0)}})}var e=b(9565),g=b(2360);c=b(6699);var f=b(6279),h=b(8227),k=b(1181),l=b(5966),m=b(7657).IteratorPrototype,n=b(2529),p=b(9539);b=h("toStringTag");var q=k.set,r=d(!0),t=\nd(!1);c(t,b,"Iterator Helper");a.exports=function(v,w){function y(x,z){z?(z.iterator=x.iterator,z.next=x.next):z=x;z.type=w?"WrapForValidIterator":"IteratorHelper";z.nextHandler=v;z.counter=0;z.done=!1;q(this,z)}y.prototype=w?r:t;return y}},1088:function(a,c,b){function d(){return this}var e=b(6518),g=b(9565),f=b(6395);c=b(350);var h=b(4901),k=b(3994),l=b(2787),m=b(2967),n=b(687),p=b(6699),q=b(6840),r=b(8227),t=b(6269);b=b(7657);var v=c.PROPER,w=c.CONFIGURABLE,y=b.IteratorPrototype,x=b.BUGGY_SAFARI_ITERATORS,\nz=r("iterator");a.exports=function(A,B,C,D,E,G,J){function F(va){if(va===E&&Q)return Q;if(!x&&va&&va in M)return M[va];switch(va){case "keys":return function(){return new C(this,va)};case "values":return function(){return new C(this,va)};case "entries":return function(){return new C(this,va)}}return function(){return new C(this)}}k(C,B,D);D=B+" Iterator";var L=!1,M=A.prototype,W=M[z]||M["@@iterator"]||E&&M[E],Q=!x&&W||F(E),la="Array"===B?M.entries||W:W,ta;la&&(A=l(la.call(new A)),A!==Object.prototype&&\nA.next&&(f||l(A)===y||(m?m(A,y):h(A[z])||q(A,z,d)),n(A,D,!0,!0),f&&(t[D]=d)));v&&"values"===E&&W&&"values"!==W.name&&(!f&&w?p(M,"name","values"):(L=!0,Q=function(){return g(W,this)}));if(E){var qa={values:F("values"),keys:G?Q:F("keys"),entries:F("entries")};if(J)for(ta in qa)!x&&!L&&ta in M||q(M,ta,qa[ta]);else e({target:B,proto:!0,forced:x||L},qa)}f&&!J||M[z]===Q||q(M,z,Q,{name:E});t[B]=Q;return qa}},713:function(a,c,b){var d=b(9565),e=b(9306),g=b(8551),f=b(1767);c=b(9462);var h=b(6319),k=c(function(){var l=\nthis.iterator,m=g(d(this.next,l));if(!(this.done=!!m.done))return h(l,this.mapper,[m.value,this.counter++],!0)});a.exports=function(l){g(this);e(l);return new k(f(this),{mapper:l})}},7657:function(a,c,b){c=b(9039);var d=b(4901),e=b(34),g=b(2360),f=b(2787),h=b(6840),k=b(8227);b=b(6395);var l=k("iterator");k=!1;var m;if([].keys){var n=[].keys();"next"in n?(f=f(f(n)),f!==Object.prototype&&(m=f)):k=!0}!e(m)||c(function(){var p={};return m[l].call(p)!==p})?m={}:b&&(m=g(m));d(m[l])||h(m,l,function(){return this});\na.exports={IteratorPrototype:m,BUGGY_SAFARI_ITERATORS:k}},6269:function(a){a.exports={}},6198:function(a,c,b){var d=b(8014);a.exports=function(e){return d(e.length)}},283:function(a,c,b){c=b(9504);var d=b(9039),e=b(4901),g=b(9297),f=b(3724),h=b(350).CONFIGURABLE,k=b(3706);b=b(1181);var l=b.enforce,m=b.get,n=String,p=Object.defineProperty,q=c("".slice),r=c("".replace),t=c([].join),v=f&&!d(function(){return 8!==p(function(){},"length",{value:8}).length}),w=String(String).split("String");a=a.exports=\nfunction(y,x,z){"Symbol("===q(n(x),0,7)&&(x="["+r(n(x),/^Symbol\\(([^)]*)\\).*$/,"$1")+"]");z&&z.getter&&(x="get "+x);z&&z.setter&&(x="set "+x);if(!g(y,"name")||h&&y.name!==x)f?p(y,"name",{value:x,configurable:!0}):y.name=x;v&&z&&g(z,"arity")&&y.length!==z.arity&&p(y,"length",{value:z.arity});try{z&&g(z,"constructor")&&z.constructor?f&&p(y,"prototype",{writable:!1}):y.prototype&&(y.prototype=void 0)}catch(A){}z=l(y);g(z,"source")||(z.source=t(w,"string"==typeof x?x:""));return y};Function.prototype.toString=\na(function(){return e(this)&&m(this).source||k(this)},"toString")},3164:function(a,c,b){var d=b(7782),e=Math.abs;a.exports=function(g,f,h,k){var l=+g;g=e(l);l=d(l);if(g<k)return l*(g/k/f+4503599627370496-4503599627370496)*k*f;f=(1+f/2.220446049250313E-16)*g;f-=f-g;return f>h||f!==f?Infinity*l:l*f}},5617:function(a,c,b){var d=b(3164);a.exports=Math.fround||function(e){return d(e,1.1920928955078125E-7,3.4028234663852886E38,1.1754943508222875E-38)}},7782:function(a){a.exports=Math.sign||function(c){c=\n+c;return 0===c||c!==c?c:0>c?-1:1}},741:function(a){var c=Math.ceil,b=Math.floor;a.exports=Math.trunc||function(d){d=+d;return(0<d?b:c)(d)}},1955:function(a,c,b){var d=b(4576),e=b(3389);c=b(6080);var g=b(9225).set,f=b(8265),h=b(9544),k=b(4265),l=b(7860),m=b(8574),n=d.MutationObserver||d.WebKitMutationObserver,p=d.document,q=d.process;b=d.Promise;e=e("queueMicrotask");if(!e){var r=new f,t=function(){var z,A;for(m&&(z=q.domain)&&z.exit();A=r.get();)try{A()}catch(B){throw r.head&&w(),B;}z&&z.enter()};\nif(h||m||l||!n||!p)if(!k&&b&&b.resolve){d=b.resolve(void 0);d.constructor=b;var v=c(d.then,d);var w=function(){v(t)}}else m?w=function(){q.nextTick(t)}:(g=c(g,d),w=function(){g(t)});else{var y=!0;var x=p.createTextNode("");(new n(t)).observe(x,{characterData:!0});w=function(){x.data=y=!y}}e=function(z){r.head||w();r.add(z)}}a.exports=e},6043:function(a,c,b){function d(f){var h,k;this.promise=new f(function(l,m){if(void 0!==h||void 0!==k)throw new g("Bad Promise constructor");h=l;k=m});this.resolve=\ne(h);this.reject=e(k)}var e=b(9306),g=TypeError;a.exports.f=function(f){return new d(f)}},2603:function(a,c,b){var d=b(655);a.exports=function(e,g){return void 0===e?2>arguments.length?"":g:d(e)}},2360:function(a,c,b){function d(){try{p=new ActiveXObject("htmlfile")}catch(r){}if("undefined"!=typeof document)if(document.domain&&p)var q=e(p);else q=m("iframe"),q.style.display="none",l.appendChild(q),q.src="javascript:",q=q.contentWindow.document,q.open(),q.write("<script>document.F=Object\\x3c/script>"),\nq.close(),q=q.F;else q=e(p);d=q;for(q=k.length;q--;)delete d.prototype[k[q]];return d()}function e(q){q.write("<script>\\x3c/script>");q.close();return q.parentWindow.Object}function g(){}var f=b(8551),h=b(6801),k=b(8727);c=b(421);var l=b(397),m=b(4055),n=b(6119)("IE_PROTO"),p;c[n]=!0;a.exports=Object.create||function(q,r){if(null!==q){g.prototype=f(q);var t=new g;g.prototype=null;t[n]=q}else t=d();return void 0===r?t:h.f(t,r)}},6801:function(a,c,b){a=b(3724);var d=b(8686),e=b(4913),g=b(8551),f=b(5397),\nh=b(1072);c.f=a&&!d?Object.defineProperties:function(k,l){g(k);var m=f(l);l=h(l);for(var n=l.length,p=0,q;n>p;)e.f(k,q=l[p++],m[q]);return k}},4913:function(a,c,b){a=b(3724);var d=b(5917),e=b(8686),g=b(8551),f=b(6969),h=TypeError,k=Object.defineProperty,l=Object.getOwnPropertyDescriptor;c.f=a?e?function(m,n,p){g(m);n=f(n);g(p);if("function"===typeof m&&"prototype"===n&&"value"in p&&"writable"in p&&!p.writable){var q=l(m,n);q&&q.writable&&(m[n]=p.value,p={configurable:"configurable"in p?p.configurable:\nq.configurable,enumerable:"enumerable"in p?p.enumerable:q.enumerable,writable:!1})}return k(m,n,p)}:k:function(m,n,p){g(m);n=f(n);g(p);if(d)try{return k(m,n,p)}catch(q){}if("get"in p||"set"in p)throw new h("Accessors not supported");"value"in p&&(m[n]=p.value);return m}},7347:function(a,c,b){a=b(3724);var d=b(9565),e=b(8773),g=b(6980),f=b(5397),h=b(6969),k=b(9297),l=b(5917),m=Object.getOwnPropertyDescriptor;c.f=a?m:function(n,p){n=f(n);p=h(p);if(l)try{return m(n,p)}catch(q){}if(k(n,p))return g(!d(e.f,\nn,p),n[p])}},8480:function(a,c,b){var d=b(1828),e=b(8727).concat("length","prototype");c.f=Object.getOwnPropertyNames||function(g){return d(g,e)}},3717:function(a,c){c.f=Object.getOwnPropertySymbols},2787:function(a,c,b){var d=b(9297),e=b(4901),g=b(8981);c=b(6119);b=b(2211);var f=c("IE_PROTO"),h=Object,k=h.prototype;a.exports=b?h.getPrototypeOf:function(l){l=g(l);if(d(l,f))return l[f];var m=l.constructor;return e(m)&&l instanceof m?m.prototype:l instanceof h?k:null}},1625:function(a,c,b){c=b(9504);\na.exports=c({}.isPrototypeOf)},1828:function(a,c,b){c=b(9504);var d=b(9297),e=b(5397),g=b(9617).indexOf,f=b(421),h=c([].push);a.exports=function(k,l){k=e(k);var m=0,n=[],p;for(p in k)!d(f,p)&&d(k,p)&&h(n,p);for(;l.length>m;)d(k,p=l[m++])&&(~g(n,p)||h(n,p));return n}},1072:function(a,c,b){var d=b(1828),e=b(8727);a.exports=Object.keys||function(g){return d(g,e)}},8773:function(a,c){a={}.propertyIsEnumerable;var b=Object.getOwnPropertyDescriptor,d=b&&!a.call({1:2},1);c.f=d?function(e){e=b(this,e);return!!e&&\ne.enumerable}:a},2967:function(a,c,b){var d=b(6706),e=b(34),g=b(7750),f=b(3506);a.exports=Object.setPrototypeOf||("__proto__"in{}?function(){var h=!1,k={};try{var l=d(Object.prototype,"__proto__","set");l(k,[]);h=k instanceof Array}catch(m){}return function(m,n){g(m);f(n);if(!e(m))return m;h?l(m,n):m.__proto__=n;return m}}():void 0)},2357:function(a,c,b){function d(p){return function(q){q=k(q);for(var r=h(q),t=n&&null===f(q),v=r.length,w=0,y=[],x;v>w;)x=r[w++],(!e||(t?x in q:l(q,x)))&&m(y,p?[x,q[x]]:\nq[x]);return y}}var e=b(3724);c=b(9039);var g=b(9504),f=b(2787),h=b(1072),k=b(5397);b=b(8773).f;var l=g(b),m=g([].push),n=e&&c(function(){var p=Object.create(null);p[2]=2;return!l(p,2)});a.exports={entries:d(!0),values:d(!1)}},4270:function(a,c,b){var d=b(9565),e=b(4901),g=b(34),f=TypeError;a.exports=function(h,k){var l,m;if("string"===k&&e(l=h.toString)&&!g(m=d(l,h))||e(l=h.valueOf)&&!g(m=d(l,h))||"string"!==k&&e(l=h.toString)&&!g(m=d(l,h)))return m;throw new f("Can\'t convert object to primitive value");\n}},5031:function(a,c,b){c=b(7751);var d=b(9504),e=b(8480),g=b(3717),f=b(8551),h=d([].concat);a.exports=c("Reflect","ownKeys")||function(k){var l=e.f(f(k)),m=g.f;return m?h(l,m(k)):l}},9167:function(a,c,b){c=b(4576);a.exports=c},1103:function(a){a.exports=function(c){try{return{error:!1,value:c()}}catch(b){return{error:!0,value:b}}}},916:function(a,c,b){c=b(4576);var d=b(550),e=b(4901),g=b(2796),f=b(3706),h=b(8227),k=b(4215),l=b(6395),m=b(9519),n=d&&d.prototype,p=h("species"),q=!1,r=e(c.PromiseRejectionEvent);\nb=g("Promise",function(){var t=f(d),v=t!==String(d);if(!v&&66===m||l&&(!n["catch"]||!n["finally"]))return!0;if(!m||51>m||!/native code/.test(t)){t=new d(function(y){y(1)});var w=function(y){y(function(){},function(){})};(t.constructor={})[p]=w;q=t.then(function(){})instanceof w;if(!q)return!0}return!v&&("BROWSER"===k||"DENO"===k)&&!r});a.exports={CONSTRUCTOR:b,REJECTION_EVENT:r,SUBCLASSING:q}},550:function(a,c,b){c=b(4576);a.exports=c.Promise},3438:function(a,c,b){var d=b(8551),e=b(34),g=b(6043);\na.exports=function(f,h){d(f);if(e(h)&&h.constructor===f)return h;f=g.f(f);var k=f.resolve;k(h);return f.promise}},537:function(a,c,b){var d=b(550);c=b(4428);b=b(916).CONSTRUCTOR;a.exports=b||!c(function(e){d.all(e).then(void 0,function(){})})},1056:function(a,c,b){var d=b(4913).f;a.exports=function(e,g,f){f in e||d(e,f,{configurable:!0,get:function(){return g[f]},set:function(h){g[f]=h}})}},8265:function(a){function c(){this.tail=this.head=null}c.prototype={add:function(b){b={item:b,next:null};var d=\nthis.tail;d?d.next=b:this.head=b;this.tail=b},get:function(){var b=this.head;if(b)return null===(this.head=b.next)&&(this.tail=null),b.item}};a.exports=c},6682:function(a,c,b){var d=b(9565),e=b(8551),g=b(4901),f=b(2195),h=b(7323),k=TypeError;a.exports=function(l,m){var n=l.exec;if(g(n))return l=d(n,l,m),null!==l&&e(l),l;if("RegExp"===f(l))return d(h,l,m);throw new k("RegExp#exec called on incompatible receiver");}},7323:function(a,c,b){var d=b(9565);c=b(9504);var e=b(655),g=b(7979),f=b(8429),h=b(5745),\nk=b(2360),l=b(1181).get,m=b(3635);b=b(8814);var n=h("native-string-replace",String.prototype.replace),p=RegExp.prototype.exec,q=p,r=c("".charAt),t=c("".indexOf),v=c("".replace),w=c("".slice),y=function(){var A=/a/,B=/b*/g;d(p,A,"a");d(p,B,"a");return 0!==A.lastIndex||0!==B.lastIndex}(),x=f.BROKEN_CARET,z=void 0!==/()??/.exec("")[1];if(y||z||x||m||b)q=function(A){var B=l(this);A=e(A);var C=B.raw,D;if(C){C.lastIndex=this.lastIndex;var E=d(q,C,A);this.lastIndex=C.lastIndex;return E}B=B.groups;C=x&&this.sticky;\nvar G=d(g,this),J=this.source,F=0,L=A;C&&(G=v(G,"y",""),-1===t(G,"g")&&(G+="g"),L=w(A,this.lastIndex),0<this.lastIndex&&(!this.multiline||this.multiline&&"\\n"!==r(A,this.lastIndex-1))&&(J="(?: "+J+")",L=" "+L,F++),E=new RegExp("^(?:"+J+")",G));z&&(E=new RegExp("^"+J+"$(?!\\\\s)",G));if(y)var M=this.lastIndex;var W=d(p,C?E:this,L);C?W?(W.input=w(W.input,F),W[0]=w(W[0],F),W.index=this.lastIndex,this.lastIndex+=W[0].length):this.lastIndex=0:y&&W&&(this.lastIndex=this.global?W.index+W[0].length:M);z&&W&&\n1<W.length&&d(n,W[0],E,function(){for(D=1;D<arguments.length-2;D++)void 0===arguments[D]&&(W[D]=void 0)});if(W&&B)for(W.groups=E=k(null),D=0;D<B.length;D++)M=B[D],E[M[0]]=W[M[1]];return W};a.exports=q},7979:function(a,c,b){var d=b(8551);a.exports=function(){var e=d(this),g="";e.hasIndices&&(g+="d");e.global&&(g+="g");e.ignoreCase&&(g+="i");e.multiline&&(g+="m");e.dotAll&&(g+="s");e.unicode&&(g+="u");e.unicodeSets&&(g+="v");e.sticky&&(g+="y");return g}},1034:function(a,c,b){var d=b(9565),e=b(9297),\ng=b(1625),f=b(7979),h=RegExp.prototype;a.exports=function(k){var l=k.flags;return void 0!==l||"flags"in h||e(k,"flags")||!g(h,k)?l:d(f,k)}},8429:function(a,c,b){c=b(9039);var d=b(4576).RegExp,e=(b=c(function(){var g=d("a","y");g.lastIndex=2;return null!==g.exec("abcd")}))||c(function(){return!d("a","y").sticky});c=b||c(function(){var g=d("^r","gy");g.lastIndex=2;return null!==g.exec("str")});a.exports={BROKEN_CARET:c,MISSED_STICKY:e,UNSUPPORTED_Y:b}},3635:function(a,c,b){c=b(9039);var d=b(4576).RegExp;\na.exports=c(function(){var e=d(".","s");return!(e.dotAll&&e.test("\\n")&&"s"===e.flags)})},8814:function(a,c,b){c=b(9039);var d=b(4576).RegExp;a.exports=c(function(){var e=d("(?<a>b)","g");return"b"!==e.exec("b").groups.a||"bc"!=="b".replace(e,"$<a>c")})},7750:function(a,c,b){var d=b(4117),e=TypeError;a.exports=function(g){if(d(g))throw new e("Can\'t call method on "+g);return g}},3389:function(a,c,b){var d=b(4576),e=b(3724),g=Object.getOwnPropertyDescriptor;a.exports=function(f){return e?(f=g(d,f))&&\nf.value:d[f]}},9286:function(a,c,b){c=b(4402);var d=b(8469),e=c.Set,g=c.add;a.exports=function(f){var h=new e;d(f,function(k){g(h,k)});return h}},3440:function(a,c,b){var d=b(7080);c=b(4402);var e=b(9286),g=b(5170),f=b(3789),h=b(8469),k=b(507),l=c.has,m=c.remove;a.exports=function(n){var p=d(this),q=f(n),r=e(p);g(p)<=q.size?h(p,function(t){q.includes(t)&&m(r,t)}):k(q.getIterator(),function(t){l(p,t)&&m(r,t)});return r}},4402:function(a,c,b){c=b(9504);b=Set.prototype;a.exports={Set:Set,add:c(b.add),\nhas:c(b.has),remove:c(b["delete"]),proto:b}},8750:function(a,c,b){var d=b(7080);c=b(4402);var e=b(5170),g=b(3789),f=b(8469),h=b(507),k=c.Set,l=c.add,m=c.has;a.exports=function(n){var p=d(this),q=g(n),r=new k;e(p)>q.size?h(q.getIterator(),function(t){m(p,t)&&l(r,t)}):f(p,function(t){q.includes(t)&&l(r,t)});return r}},4449:function(a,c,b){var d=b(7080),e=b(4402).has,g=b(5170),f=b(3789),h=b(8469),k=b(507),l=b(9539);a.exports=function(m){var n=d(this),p=f(m);if(g(n)<=p.size)return!1!==h(n,function(r){if(p.includes(r))return!1},\n!0);var q=p.getIterator();return!1!==k(q,function(r){if(e(n,r))return l(q,"normal",!1)})}},3838:function(a,c,b){var d=b(7080),e=b(5170),g=b(8469),f=b(3789);a.exports=function(h){var k=d(this),l=f(h);return e(k)>l.size?!1:!1!==g(k,function(m){if(!l.includes(m))return!1},!0)}},8527:function(a,c,b){var d=b(7080),e=b(4402).has,g=b(5170),f=b(3789),h=b(507),k=b(9539);a.exports=function(l){var m=d(this);l=f(l);if(g(m)<l.size)return!1;var n=l.getIterator();return!1!==h(n,function(p){if(!e(m,p))return k(n,\n"normal",!1)})}},8469:function(a,c,b){c=b(9504);var d=b(507),e=b(4402);b=e.Set;e=e.proto;var g=c(e.forEach),f=c(e.keys),h=f(new b).next;a.exports=function(k,l,m){return m?d({iterator:f(k),next:h},l):g(k,l)}},4916:function(a,c,b){function d(g){return{size:g,has:function(){return!1},keys:function(){return{next:function(){return{done:!0}}}}}}var e=b(7751);a.exports=function(g){var f=e("Set");try{(new f)[g](d(0));try{return(new f)[g](d(-1)),!1}catch(h){return!0}}catch(h){return!1}}},5170:function(a,c,\nb){c=b(6706);b=b(4402);a.exports=c(b.proto,"size","get")||function(d){return d.size}},7633:function(a,c,b){var d=b(7751),e=b(2106);c=b(8227);var g=b(3724),f=c("species");a.exports=function(h){h=d(h);g&&h&&!h[f]&&e(h,f,{configurable:!0,get:function(){return this}})}},3650:function(a,c,b){var d=b(7080);c=b(4402);var e=b(9286),g=b(3789),f=b(507),h=c.add,k=c.has,l=c.remove;a.exports=function(m){var n=d(this);m=g(m).getIterator();var p=e(n);f(m,function(q){k(n,q)?l(p,q):h(p,q)});return p}},687:function(a,\nc,b){var d=b(4913).f,e=b(9297),g=b(8227)("toStringTag");a.exports=function(f,h,k){f&&!k&&(f=f.prototype);f&&!e(f,g)&&d(f,g,{configurable:!0,value:h})}},4204:function(a,c,b){var d=b(7080),e=b(4402).add,g=b(9286),f=b(3789),h=b(507);a.exports=function(k){var l=d(this);k=f(k).getIterator();var m=g(l);h(k,function(n){e(m,n)});return m}},6119:function(a,c,b){c=b(5745);var d=b(3392),e=c("keys");a.exports=function(g){return e[g]||(e[g]=d(g))}},7629:function(a,c,b){c=b(6395);var d=b(4576);b=b(9433);a=a.exports=\nd["__core-js_shared__"]||b("__core-js_shared__",{});(a.versions||(a.versions=[])).push({version:"3.38.1",mode:c?"pure":"global",copyright:"\\u00a9 2014-2024 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",source:"https://github.com/zloirock/core-js"})},5745:function(a,c,b){var d=b(7629);a.exports=function(e,g){return d[e]||(d[e]=g||{})}},2293:function(a,c,b){var d=b(8551),e=b(5548),g=b(4117),f=b(8227)("species");a.exports=function(h,k){h=d(h).constructor;\nvar l;return void 0===h||g(l=d(h)[f])?k:e(l)}},8183:function(a,c,b){function d(m){return function(n,p){n=g(f(n));p=e(p);var q=n.length,r;if(0>p||p>=q)return m?"":void 0;var t=k(n,p);return 55296>t||56319<t||p+1===q||56320>(r=k(n,p+1))||57343<r?m?h(n,p):t:m?l(n,p,p+2):(t-55296<<10)+(r-56320)+65536}}c=b(9504);var e=b(1291),g=b(655),f=b(7750),h=c("".charAt),k=c("".charCodeAt),l=c("".slice);a.exports={codeAt:d(!1),charAt:d(!0)}},3063:function(a,c,b){c=b(2839);a.exports=/Version\\/10(?:\\.\\d+){1,2}(?: [\\w./]+)?(?: Mobile\\/\\w+)? Safari\\//.test(c)},\n533:function(a,c,b){function d(n){return function(p,q,r){p=g(h(p));q=e(q);var t=p.length;r=void 0===r?" ":g(r);if(q<=t||""===r)return p;q-=t;r=k(r,m(q/r.length));r.length>q&&(r=l(r,0,q));return n?p+r:r+p}}c=b(9504);var e=b(8014),g=b(655),f=b(2333),h=b(7750),k=c(f),l=c("".slice),m=Math.ceil;a.exports={start:d(!1),end:d(!0)}},2333:function(a,c,b){var d=b(1291),e=b(655),g=b(7750),f=RangeError;a.exports=function(h){var k=e(g(this)),l="";h=d(h);if(0>h||Infinity===h)throw new f("Wrong number of repetitions");\nfor(;0<h;(h>>>=1)&&(k+=k))h&1&&(l+=k);return l}},8866:function(a,c,b){var d=b(3802).end;c=b(706);a.exports=c("trimEnd")?function(){return d(this)}:"".trimEnd},706:function(a,c,b){var d=b(350).PROPER,e=b(9039),g=b(7452);a.exports=function(f){return e(function(){return!!g[f]()||"\\u200b\\u0085\\u180e"!=="\\u200b\\u0085\\u180e"[f]()||d&&g[f].name!==f})}},3802:function(a,c,b){function d(l){return function(m){m=g(e(m));l&1&&(m=f(m,h,""));l&2&&(m=f(m,k,"$1"));return m}}c=b(9504);var e=b(7750),g=b(655);b=b(7452);\nvar f=c("".replace),h=RegExp("^["+b+"]+"),k=RegExp("(^|[^"+b+"])["+b+"]+$");a.exports={start:d(1),end:d(2),trim:d(3)}},1548:function(a,c,b){c=b(4576);var d=b(9039),e=b(9519),g=b(4215),f=c.structuredClone;a.exports=!!f&&!d(function(){if("DENO"===g&&92<e||"NODE"===g&&94<e||"BROWSER"===g&&97<e)return!1;var h=new ArrayBuffer(8),k=f(h,{transfer:[h]});return 0!==h.byteLength||8!==k.byteLength})},4495:function(a,c,b){var d=b(9519);c=b(9039);var e=b(4576).String;a.exports=!!Object.getOwnPropertySymbols&&\n!c(function(){var g=Symbol("symbol detection");return!e(g)||!(Object(g)instanceof Symbol)||!Symbol.sham&&d&&41>d})},9225:function(a,c,b){function d(F){h.postMessage(C(F),G.protocol+"//"+G.host)}function e(F){f(F.data)}function g(F){return function(){f(F)}}function f(F){if(m(E,F)){var L=E[F];delete E[F];L()}}var h=b(4576),k=b(8745);c=b(6080);var l=b(4901),m=b(9297),n=b(9039),p=b(397),q=b(7680),r=b(4055),t=b(2812),v=b(9544),w=b(8574);b=h.setImmediate;var y=h.clearImmediate,x=h.process,z=h.Dispatch,\nA=h.Function,B=h.MessageChannel,C=h.String,D=0,E={},G;n(function(){G=h.location});if(!b||!y)if(b=function(F){t(arguments.length,1);var L=l(F)?F:A(F),M=q(arguments,1);E[++D]=function(){k(L,void 0,M)};J(D);return D},y=function(F){delete E[F]},w)var J=function(F){x.nextTick(g(F))};else z&&z.now?J=function(F){z.now(g(F))}:B&&!v?(n=new B,v=n.port2,n.port1.onmessage=e,J=c(v.postMessage,v)):h.addEventListener&&l(h.postMessage)&&!h.importScripts&&G&&"file:"!==G.protocol&&!n(d)?(J=d,h.addEventListener("message",\ne,!1)):J="onreadystatechange"in r("script")?function(F){p.appendChild(r("script")).onreadystatechange=function(){p.removeChild(this);f(F)}}:function(F){setTimeout(g(F),0)};a.exports={set:b,clear:y}},5610:function(a,c,b){var d=b(1291),e=Math.max,g=Math.min;a.exports=function(f,h){f=d(f);return 0>f?e(f+h,0):g(f,h)}},5854:function(a,c,b){var d=b(2777),e=TypeError;a.exports=function(g){g=d(g,"number");if("number"==typeof g)throw new e("Can\'t convert number to bigint");return BigInt(g)}},7696:function(a,\nc,b){var d=b(1291),e=b(8014),g=RangeError;a.exports=function(f){if(void 0===f)return 0;f=d(f);var h=e(f);if(f!==h)throw new g("Wrong length or index");return h}},5397:function(a,c,b){var d=b(7055),e=b(7750);a.exports=function(g){return d(e(g))}},1291:function(a,c,b){var d=b(741);a.exports=function(e){e=+e;return e!==e||0===e?0:d(e)}},8014:function(a,c,b){var d=b(1291),e=Math.min;a.exports=function(g){g=d(g);return 0<g?e(g,9007199254740991):0}},8981:function(a,c,b){var d=b(7750),e=Object;a.exports=\nfunction(g){return e(d(g))}},8229:function(a,c,b){var d=b(9590),e=RangeError;a.exports=function(g,f){g=d(g);if(g%f)throw new e("Wrong offset");return g}},9590:function(a,c,b){var d=b(1291),e=RangeError;a.exports=function(g){g=d(g);if(0>g)throw new e("The argument can\'t be less than 0");return g}},2777:function(a,c,b){var d=b(9565),e=b(34),g=b(757),f=b(5966),h=b(4270);c=b(8227);var k=TypeError,l=c("toPrimitive");a.exports=function(m,n){if(!e(m)||g(m))return m;var p=f(m,l);if(p){void 0===n&&(n="default");\nm=d(p,m,n);if(!e(m)||g(m))return m;throw new k("Can\'t convert object to primitive value");}void 0===n&&(n="number");return h(m,n)}},6969:function(a,c,b){var d=b(2777),e=b(757);a.exports=function(g){g=d(g,"string");return e(g)?g:g+""}},2140:function(a,c,b){c=b(8227)("toStringTag");b={};b[c]="z";a.exports="[object z]"===String(b)},655:function(a,c,b){var d=b(6955),e=String;a.exports=function(g){if("Symbol"===d(g))throw new TypeError("Cannot convert a Symbol value to a string");return e(g)}},8319:function(a){var c=\nMath.round;a.exports=function(b){b=c(b);return 0>b?0:255<b?255:b&255}},6823:function(a){var c=String;a.exports=function(b){try{return c(b)}catch(d){return"Object"}}},5823:function(a,c,b){function d(wa,Aa,Ja){Aa=B(Aa);return!(g(wa,Aa)&&E(Ja)&&C(Ja,"value"))||C(Ja,"get")||C(Ja,"set")||Ja.configurable||C(Ja,"writable")&&!Ja.writable||C(Ja,"enumerable")&&!Ja.enumerable?U(wa,Aa,Ja):(wa[Aa]=Ja.value,wa)}function e(wa,Aa){Aa=B(Aa);return g(wa,Aa)?t(2,wa[Aa]):N(wa,Aa)}function g(wa,Aa){return Ia(wa)&&!G(Aa)&&\nAa in wa&&w(+Aa)&&0<=Aa}function f(wa){var Aa;return F(X,wa)||"ArrayBuffer"===(Aa=D(wa))||"SharedArrayBuffer"===Aa}function h(wa,Aa){ta(wa,Aa,{configurable:!0,get:function(){return Y(this)[Aa]}})}var k=b(6518),l=b(4576),m=b(9565);c=b(3724);var n=b(2805),p=b(4644),q=b(6346),r=b(679),t=b(6980),v=b(6699),w=b(2087),y=b(8014),x=b(7696),z=b(8229),A=b(8319),B=b(6969),C=b(9297),D=b(6955),E=b(34),G=b(757),J=b(2360),F=b(1625),L=b(2967),M=b(8480).f,W=b(3251),Q=b(9213).forEach,la=b(7633),ta=b(2106),qa=b(4913),\nva=b(7347),S=b(5370),da=b(1181),R=b(3167),Y=da.get,fa=da.set,H=da.enforce,U=qa.f,N=va.f,ba=l.RangeError,aa=q.ArrayBuffer,X=aa.prototype,ha=q.DataView,ma=p.NATIVE_ARRAY_BUFFER_VIEWS,V=p.TYPED_ARRAY_TAG,ea=p.TypedArray,za=p.TypedArrayPrototype,Ia=p.isTypedArray;c?(ma||(va.f=e,qa.f=d,h(za,"buffer"),h(za,"byteOffset"),h(za,"byteLength"),h(za,"length")),k({target:"Object",stat:!0,forced:!ma},{getOwnPropertyDescriptor:e,defineProperty:d}),a.exports=function(wa,Aa,Ja){function Sa(Kb,Za){U(Kb,Za,{get:function(){var mc=\nY(this);return mc.view[vb](Za*Wa+mc.byteOffset,!0)},set:function(mc){var tb=Y(this);tb.view[eb](Za*Wa+tb.byteOffset,Ja?A(mc):mc,!0)},enumerable:!0})}var Wa=wa.match(/\\d+/)[0]/8,La=wa+(Ja?"Clamped":"")+"Array",vb="get"+wa,eb="set"+wa,Xa=l[La],Na=Xa,hb=Na&&Na.prototype;wa={};ma?n&&(Na=Aa(function(Kb,Za,mc,tb){r(Kb,hb);return R(E(Za)?f(Za)?void 0!==tb?new Xa(Za,z(mc,Wa),tb):void 0!==mc?new Xa(Za,z(mc,Wa)):new Xa(Za):Ia(Za)?S(Na,Za):m(W,Na,Za):new Xa(x(Za)),Kb,Na)}),L&&L(Na,ea),Q(M(Xa),function(Kb){Kb in\nNa||v(Na,Kb,Xa[Kb])}),Na.prototype=hb):(Na=Aa(function(Kb,Za,mc,tb){r(Kb,hb);var uf=0,Td=0;if(E(Za))if(f(Za)){var sc=Za;Td=z(mc,Wa);Za=Za.byteLength;if(void 0===tb){if(Za%Wa)throw new ba("Wrong length");tb=Za-Td;if(0>tb)throw new ba("Wrong length");}else if(tb=y(tb)*Wa,tb+Td>Za)throw new ba("Wrong length");Za=tb/Wa}else return Ia(Za)?S(Na,Za):m(W,Na,Za);else Za=x(Za),tb=Za*Wa,sc=new aa(tb);for(fa(Kb,{buffer:sc,byteOffset:Td,byteLength:tb,length:Za,view:new ha(sc)});uf<Za;)Sa(Kb,uf++)}),L&&L(Na,ea),\nhb=Na.prototype=J(za));hb.constructor!==Na&&v(hb,"constructor",Na);H(hb).TypedArrayConstructor=Na;V&&v(hb,V,La);wa[La]=Na;k({global:!0,constructor:!0,forced:Na!==Xa,sham:!ma},wa);"BYTES_PER_ELEMENT"in Na||v(Na,"BYTES_PER_ELEMENT",Wa);"BYTES_PER_ELEMENT"in hb||v(hb,"BYTES_PER_ELEMENT",Wa);la(La)}):a.exports=function(){}},2805:function(a,c,b){c=b(4576);var d=b(9039),e=b(4428);b=b(4644).NATIVE_ARRAY_BUFFER_VIEWS;var g=c.ArrayBuffer,f=c.Int8Array;a.exports=!b||!d(function(){f(1)})||!d(function(){new f(-1)})||\n!e(function(h){new f;new f(null);new f(1.5);new f(h)},!0)||d(function(){return 1!==(new f(new g(2),1,void 0)).length})},3251:function(a,c,b){var d=b(6080),e=b(9565),g=b(5548),f=b(8981),h=b(6198),k=b(81),l=b(851),m=b(4209),n=b(1108),p=b(4644).aTypedArrayConstructor,q=b(5854);a.exports=function(r){var t=g(this),v=f(r),w=arguments.length,y=1<w?arguments[1]:void 0,x=void 0!==y,z=l(v);if(z&&!m(z)){var A=k(v,z);var B=A.next;for(v=[];!(z=e(B,A)).done;)v.push(z.value)}x&&2<w&&(y=d(y,arguments[2]));w=h(v);\nz=new (p(t))(w);A=n(z);for(t=0;w>t;t++)B=x?y(v[t],t):v[t],z[t]=A?q(B):+B;return z}},3392:function(a,c,b){c=b(9504);var d=0,e=Math.random(),g=c((1).toString);a.exports=function(f){return"Symbol("+(void 0===f?"":f)+")_"+g(++d+e,36)}},7040:function(a,c,b){c=b(4495);a.exports=c&&!Symbol.sham&&"symbol"==typeof Symbol.iterator},8686:function(a,c,b){c=b(3724);b=b(9039);a.exports=c&&b(function(){return 42!==Object.defineProperty(function(){},"prototype",{value:42,writable:!1}).prototype})},2812:function(a){var c=\nTypeError;a.exports=function(b,d){if(b<d)throw new c("Not enough arguments");return b}},8622:function(a,c,b){c=b(4576);b=b(4901);c=c.WeakMap;a.exports=b(c)&&/native code/.test(String(c))},511:function(a,c,b){var d=b(9167),e=b(9297),g=b(1951),f=b(4913).f;a.exports=function(h){var k=d.Symbol||(d.Symbol={});e(k,h)||f(k,h,{value:g.f(h)})}},1951:function(a,c,b){a=b(8227);c.f=a},8227:function(a,c,b){c=b(4576);var d=b(5745),e=b(9297),g=b(3392),f=b(4495);b=b(7040);var h=c.Symbol,k=d("wks"),l=b?h["for"]||\nh:h&&h.withoutSetter||g;a.exports=function(m){e(k,m)||(k[m]=f&&e(h,m)?h[m]:l("Symbol."+m));return k[m]}},7452:function(a){a.exports="\\t\\n\\v\\f\\r \\u00a0\\u1680\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\u2028\\u2029\\ufeff"},4601:function(a,c,b){var d=b(7751),e=b(9297),g=b(6699),f=b(1625),h=b(2967),k=b(7740),l=b(1056),m=b(3167),n=b(2603),p=b(7584),q=b(747),r=b(3724),t=b(6395);a.exports=function(v,w,y,x){var z=x?2:1,A=v.split(".");v=A[A.length-1];var B=d.apply(null,\nA);if(B){var C=B.prototype;!t&&e(C,"cause")&&delete C.cause;if(!y)return B;y=d("Error");var D=w(function(E,G){var J=n(x?G:E,void 0),F=x?new B(E):new B;void 0!==J&&g(F,"message",J);q(F,D,F.stack,2);this&&f(C,this)&&m(F,this,D);arguments.length>z&&p(F,arguments[z]);return F});D.prototype=C;"Error"!==v?h?h(D,y):k(D,y,{name:!0}):r&&"stackTraceLimit"in B&&(l(D,B,"stackTraceLimit"),l(D,B,"prepareStackTrace"));k(D,B);if(!t)try{C.name!==v&&g(C,"name",v),C.constructor=D}catch(E){}return D}}},6573:function(a,\nc,b){a=b(3724);c=b(2106);var d=b(3238);b=ArrayBuffer.prototype;!a||"detached"in b||c(b,"detached",{configurable:!0,get:function(){return d(this)}})},1745:function(a,c,b){a=b(6518);c=b(7476);var d=b(9039),e=b(6346),g=b(8551),f=b(5610),h=b(8014),k=b(2293),l=e.ArrayBuffer,m=e.DataView;b=m.prototype;var n=c(l.prototype.slice),p=c(b.getUint8),q=c(b.setUint8);b=d(function(){return!(new l(2)).slice(1,void 0).byteLength});a({target:"ArrayBuffer",proto:!0,unsafe:!0,forced:b},{slice:function(r,t){if(n&&void 0===\nt)return n(g(this),r);var v=g(this).byteLength;r=f(r,v);t=f(void 0===t?v:t,v);v=new (k(this,l))(h(t-r));for(var w=new m(this),y=new m(v),x=0;r<t;)q(y,x++,p(w,r++));return v}})},7936:function(a,c,b){a=b(6518);var d=b(5636);d&&a({target:"ArrayBuffer",proto:!0},{transferToFixedLength:function(){return d(this,arguments.length?arguments[0]:void 0,!1)}})},8100:function(a,c,b){a=b(6518);var d=b(5636);d&&a({target:"ArrayBuffer",proto:!0},{transfer:function(){return d(this,arguments.length?arguments[0]:void 0,\n!0)}})},8107:function(a,c,b){a=b(6518);var d=b(8981),e=b(6198),g=b(1291);b=b(6469);a({target:"Array",proto:!0},{at:function(f){var h=d(this),k=e(h);f=g(f);f=0<=f?f:k+f;return 0>f||f>=k?void 0:h[f]}});b("at")},6449:function(a,c,b){a=b(6518);var d=b(259),e=b(8981),g=b(6198),f=b(1291),h=b(1469);a({target:"Array",proto:!0},{flat:function(){var k=arguments.length?arguments[0]:void 0,l=e(this),m=g(l),n=h(l,0);n.length=d(n,l,l,m,0,void 0===k?1:f(k));return n}})},4423:function(a,c,b){a=b(6518);var d=b(9617).includes;\nc=b(9039);b=b(6469);c=c(function(){return!Array(1).includes()});a({target:"Array",proto:!0,forced:c},{includes:function(e){return d(this,e,1<arguments.length?arguments[1]:void 0)}});b("includes")},3792:function(a,c,b){var d=b(5397);c=b(6469);var e=b(6269),g=b(1181),f=b(4913).f,h=b(1088),k=b(2529),l=b(6395);b=b(3724);var m=g.set,n=g.getterFor("Array Iterator");a.exports=h(Array,"Array",function(p,q){m(this,{type:"Array Iterator",target:d(p),index:0,kind:q})},function(){var p=n(this),q=p.target,r=p.index++;\nif(!q||r>=q.length)return p.target=null,k(void 0,!0);switch(p.kind){case "keys":return k(r,!1);case "values":return k(q[r],!1)}return k([r,q[r]],!1)},"values");a=e.Arguments=e.Array;c("keys");c("values");c("entries");if(!l&&b&&"values"!==a.name)try{f(a,"name",{value:"values"})}catch(p){}},4114:function(a,c,b){a=b(6518);var d=b(8981),e=b(6198),g=b(4527),f=b(6837);if(!(b=b(9039)(function(){return 4294967297!==[].push.call({length:4294967296},1)}))){a:{try{Object.defineProperty([],"length",{writable:!1}).push()}catch(h){b=\nh instanceof TypeError;break a}b=void 0}b=!b}a({target:"Array",proto:!0,arity:1,forced:b},{push:function(h){var k=d(this),l=e(k),m=arguments.length;f(l+m);for(var n=0;n<m;n++)k[l]=arguments[n],l++;g(k,l);return l}})},2712:function(a,c,b){a=b(6518);var d=b(926).left;c=b(4598);var e=b(9519);b=!b(8574)&&79<e&&83>e||!c("reduce");a({target:"Array",proto:!0,forced:b},{reduce:function(g){var f=arguments.length;return d(this,g,f,1<f?arguments[1]:void 0)}})},6910:function(a,c,b){function d(z){return function(A,\nB){return void 0===B?-1:void 0===A?1:void 0!==z?+z(A,B)||0:l(A)>l(B)?1:-1}}a=b(6518);var e=b(9504),g=b(9306),f=b(8981),h=b(6198),k=b(4606),l=b(655);c=b(9039);var m=b(4488),n=b(4598),p=b(3709),q=b(3763),r=b(9519),t=b(3607),v=[],w=e(v.sort),y=e(v.push);b=c(function(){v.sort(void 0)});e=c(function(){v.sort(null)});n=n("sort");var x=!c(function(){if(r)return 70>r;if(!(p&&3<p)){if(q)return!0;if(t)return 603>t;var z="",A,B;for(A=65;76>A;A++){var C=String.fromCharCode(A);switch(A){case 66:case 69:case 70:case 72:var D=\n3;break;case 68:case 71:D=4;break;default:D=2}for(B=0;47>B;B++)v.push({k:C+B,v:D})}v.sort(function(E,G){return G.v-E.v});for(B=0;B<v.length;B++)C=v[B].k.charAt(0),z.charAt(z.length-1)!==C&&(z+=C);return"DGBEFHACIJK"!==z}});a({target:"Array",proto:!0,forced:b||!e||!n||!x},{sort:function(z){void 0!==z&&g(z);var A=f(this);if(x)return void 0===z?w(A):w(A,z);var B=[],C=h(A),D;for(D=0;D<C;D++)D in A&&y(B,A[D]);m(B,d(z));z=h(B);for(D=0;D<z;)A[D]=B[D++];for(;D<C;)k(A,D++);return A}})},3514:function(a,c,b){b(6469)("flat")},\n3609:function(a,c,b){a=b(6518);var d=b(8981),e=b(6198),g=b(4527),f=b(4606),h=b(6837);if(!(b=1!==[].unshift(0))){a:{try{Object.defineProperty([],"length",{writable:!1}).unshift()}catch(k){b=k instanceof TypeError;break a}b=void 0}b=!b}a({target:"Array",proto:!0,arity:1,forced:b},{unshift:function(k){var l=d(this),m=e(l),n=arguments.length;if(n){h(m+n);for(var p=m;p--;){var q=p+n;p in l?l[q]=l[p]:f(l,q)}for(p=0;p<n;p++)l[p]=arguments[p]}return g(l,m+n)}})},6280:function(a,c,b){function d(m,n){if(k&&\nk[m]){var p={};p[m]=h("WebAssembly."+m,n,l);g({target:"WebAssembly",stat:!0,constructor:!0,arity:1,forced:l},p)}}function e(m,n){var p={};p[m]=h(m,n,l);g({global:!0,constructor:!0,arity:1,forced:l},p)}var g=b(6518);a=b(4576);var f=b(8745),h=b(4601),k=a.WebAssembly,l=7!==Error("e",{cause:7}).cause;e("Error",function(m){return function(n){return f(m,this,arguments)}});e("EvalError",function(m){return function(n){return f(m,this,arguments)}});e("RangeError",function(m){return function(n){return f(m,\nthis,arguments)}});e("ReferenceError",function(m){return function(n){return f(m,this,arguments)}});e("SyntaxError",function(m){return function(n){return f(m,this,arguments)}});e("TypeError",function(m){return function(n){return f(m,this,arguments)}});e("URIError",function(m){return function(n){return f(m,this,arguments)}});d("CompileError",function(m){return function(n){return f(m,this,arguments)}});d("LinkError",function(m){return function(n){return f(m,this,arguments)}});d("RuntimeError",function(m){return function(n){return f(m,\nthis,arguments)}})},5081:function(a,c,b){a=b(6518);b=b(4576);a({global:!0,forced:b.globalThis!==b},{globalThis:b})},3110:function(a,c,b){function d(E,G,J){var F=v(J,G-1);G=v(J,G+1);return t(A,E)&&!t(B,G)||t(B,E)&&!t(A,F)?"\\\\u"+x(w(E,0),16):E}function e(E,G){var J=n(arguments),F=p(G);if(l(F)||void 0!==E&&!m(E))return J[1]=function(L,M){l(F)&&(M=h(F,this,q(L),M));if(!m(M))return M},f(r,null,J)}a=b(6518);var g=b(7751),f=b(8745),h=b(9565);c=b(9504);var k=b(9039),l=b(4901),m=b(757),n=b(7680),p=b(6933);\nb=b(4495);var q=String,r=g("JSON","stringify"),t=c(/./.exec),v=c("".charAt),w=c("".charCodeAt),y=c("".replace),x=c((1).toString),z=/[\uD800-\uDFFF]/g,A=/^[\uD800-\uDBFF]$/,B=/^[\uDC00-\uDFFF]$/,C=!b||k(function(){var E=g("Symbol")("stringify detection");return"[null]"!==r([E])||"{}"!==r({a:E})||"{}"!==r(Object(E))}),D=k(function(){return\'"\\\udf06\\\ud834"\'!==r("\udf06\ud834")||\'"\\\udead"\'!==r("\udead")});r&&a({target:"JSON",stat:!0,arity:3,forced:C||D},{stringify:function(E,G,J){var F=n(arguments);\nF=f(C?e:r,null,F);return D&&"string"==typeof F?y(F,z,d):F}})},9469:function(a,c,b){a=b(6518);c=Math.hypot;var d=Math.abs,e=Math.sqrt;c=!!c&&Infinity!==c(Infinity,NaN);a({target:"Math",stat:!0,arity:2,forced:c},{hypot:function(g,f){for(var h=0,k=0,l=arguments.length,m=0,n,p;k<l;)n=d(arguments[k++]),m<n?(p=m/n,h=h*p*p+1,m=n):0<n?(p=n/m,h+=p*p):h+=n;return Infinity===m?Infinity:m*e(h)}})},5506:function(a,c,b){a=b(6518);var d=b(2357).entries;a({target:"Object",stat:!0},{entries:function(e){return d(e)}})},\n6034:function(a,c,b){a=b(6518);var d=b(2357).values;a({target:"Object",stat:!0},{values:function(e){return d(e)}})},6167:function(a,c,b){a=b(6518);var d=b(9565),e=b(9306),g=b(6043),f=b(1103),h=b(2652);b=b(537);a({target:"Promise",stat:!0,forced:b},{allSettled:function(k){var l=this,m=g.f(l),n=m.resolve,p=m.reject,q=f(function(){var r=e(l.resolve),t=[],v=0,w=1;h(k,function(y){var x=v++,z=!1;w++;d(r,l,y).then(function(A){z||(z=!0,t[x]={status:"fulfilled",value:A},--w||n(t))},function(A){z||(z=!0,t[x]=\n{status:"rejected",reason:A},--w||n(t))})});--w||n(t)});q.error&&p(q.value);return m.promise}})},6499:function(a,c,b){a=b(6518);var d=b(9565),e=b(9306),g=b(6043),f=b(1103),h=b(2652);b=b(537);a({target:"Promise",stat:!0,forced:b},{all:function(k){var l=this,m=g.f(l),n=m.resolve,p=m.reject,q=f(function(){var r=e(l.resolve),t=[],v=0,w=1;h(k,function(y){var x=v++,z=!1;w++;d(r,l,y).then(function(A){z||(z=!0,t[x]=A,--w||n(t))},p)});--w||n(t)});q.error&&p(q.value);return m.promise}})},2003:function(a,c,\nb){a=b(6518);c=b(6395);var d=b(916).CONSTRUCTOR,e=b(550),g=b(7751),f=b(4901);b=b(6840);var h=e&&e.prototype;a({target:"Promise",proto:!0,forced:d,real:!0},{"catch":function(k){return this.then(void 0,k)}});!c&&f(e)&&(a=g("Promise").prototype["catch"],h["catch"]!==a&&b(h,"catch",a,{unsafe:!0}))},436:function(a,c,b){function d(X,ha,ma){if(!X.done){X.done=!0;ma&&(X=ma);try{if(X.facade===ha)throw new da("Promise can\'t be resolved itself");var V=n(ha);V?E(function(){var ea={done:!1};try{r(V,ha,g(d,ea,\nX),g(e,ea,X))}catch(za){e(ea,za,X)}}):(X.value=ha,X.state=1,l(X,!1))}catch(ea){e({done:!1},ea,X)}}}function e(X,ha,ma){X.done||(X.done=!0,ma&&(X=ma),X.value=ha,X.state=2,l(X,!0))}function g(X,ha,ma){return function(V){X(ha,V,ma)}}function f(X){r(D,q,function(){var ha=X.facade;p?Y.emit("rejectionHandled",ha):k("rejectionhandled",ha,X.value)})}function h(X){r(D,q,function(){var ha=X.facade,ma=X.value;if(1!==X.rejection&&!X.parent){var V=J(function(){p?Y.emit("unhandledRejection",ma,ha):k("unhandledrejection",\nha,ma)});X.rejection=p||1!==X.rejection&&!X.parent?2:1;if(V.error)throw V.value;}})}function k(X,ha,ma){var V;if(U){var ea=R.createEvent("Event");ea.promise=ha;ea.reason=ma;ea.initEvent(X,!1,!0);q.dispatchEvent(ea)}else ea={promise:ha,reason:ma};!la&&(V=q["on"+X])?V(ea):"unhandledrejection"===X&&G("Unhandled promise rejection",ma)}function l(X,ha){X.notified||(X.notified=!0,E(function(){for(var ma=X.reactions,V;V=ma.get();)m(V,X);X.notified=!1;ha&&!X.rejection&&h(X)}))}function m(X,ha){var ma=ha.value,\nV=1===ha.state,ea=V?X.ok:X.fail,za=X.resolve,Ia=X.reject,wa=X.domain,Aa;try{if(ea){V||(2===ha.rejection&&f(ha),ha.rejection=1);if(!0===ea)var Ja=ma;else if(wa&&wa.enter(),Ja=ea(ma),wa){wa.exit();var Sa=!0}Ja===X.promise?Ia(new da("Promise-chain cycle")):(Aa=n(Ja))?r(Aa,Ja,za,Ia):za(Ja)}else Ia(ma)}catch(Wa){wa&&!Sa&&wa.exit(),Ia(Wa)}}function n(X){var ha;return A(X)&&z(ha=X.then)?ha:!1}a=b(6518);c=b(6395);var p=b(8574),q=b(4576),r=b(9565),t=b(6840),v=b(2967),w=b(687),y=b(7633),x=b(9306),z=b(4901),\nA=b(34),B=b(679),C=b(2293),D=b(9225).set,E=b(1955),G=b(3138),J=b(1103),F=b(8265),L=b(1181),M=b(550),W=b(916);b=b(6043);var Q=W.CONSTRUCTOR,la=W.REJECTION_EVENT;W=W.SUBCLASSING;var ta=L.getterFor("Promise"),qa=L.set;L=M&&M.prototype;var va=M,S=L,da=q.TypeError,R=q.document,Y=q.process,fa=b.f,H=fa,U=!!(R&&R.createEvent&&q.dispatchEvent);if(Q){va=function(X){B(this,S);x(X);r(N,this);var ha=ta(this);try{X(g(d,ha),g(e,ha))}catch(ma){e(ha,ma)}};S=va.prototype;var N=function(){qa(this,{type:"Promise",done:!1,\nnotified:!1,parent:!1,reactions:new F,rejection:!1,state:0,value:null})};N.prototype=t(S,"then",function(X,ha){var ma=ta(this),V=fa(C(this,va));ma.parent=!0;V.ok=z(X)?X:!0;V.fail=z(ha)&&ha;V.domain=p?Y.domain:void 0;0===ma.state?ma.reactions.add(V):E(function(){m(V,ma)});return V.promise});var ba=function(){var X=new N,ha=ta(X);this.promise=X;this.resolve=g(d,ha);this.reject=g(e,ha)};b.f=fa=function(X){return X===va||void 0===X?new ba(X):H(X)};if(!c&&z(M)&&L!==Object.prototype){var aa=L.then;W||t(L,\n"then",function(X,ha){var ma=this;return(new va(function(V,ea){r(aa,ma,V,ea)})).then(X,ha)},{unsafe:!0});try{delete L.constructor}catch(X){}v&&v(L,S)}}a({global:!0,constructor:!0,wrap:!0,forced:Q},{Promise:va});w(va,"Promise",!1,!0);y("Promise")},9391:function(a,c,b){a=b(6518);c=b(6395);var d=b(550),e=b(9039),g=b(7751),f=b(4901),h=b(2293),k=b(3438);b=b(6840);var l=d&&d.prototype;e=!!d&&e(function(){l["finally"].call({then:function(){}},function(){})});a({target:"Promise",proto:!0,real:!0,forced:e},\n{"finally":function(m){var n=h(this,g("Promise")),p=f(m);return this.then(p?function(q){return k(n,m()).then(function(){return q})}:m,p?function(q){return k(n,m()).then(function(){throw q;})}:m)}});!c&&f(d)&&(a=g("Promise").prototype["finally"],l["finally"]!==a&&b(l,"finally",a,{unsafe:!0}))},3362:function(a,c,b){b(436);b(6499);b(2003);b(7743);b(1481);b(280)},7743:function(a,c,b){a=b(6518);var d=b(9565),e=b(9306),g=b(6043),f=b(1103),h=b(2652);b=b(537);a({target:"Promise",stat:!0,forced:b},{race:function(k){var l=\nthis,m=g.f(l),n=m.reject,p=f(function(){var q=e(l.resolve);h(k,function(r){d(q,l,r).then(m.resolve,n)})});p.error&&n(p.value);return m.promise}})},1481:function(a,c,b){a=b(6518);var d=b(6043);b=b(916).CONSTRUCTOR;a({target:"Promise",stat:!0,forced:b},{reject:function(e){var g=d.f(this),f=g.reject;f(e);return g.promise}})},280:function(a,c,b){a=b(6518);c=b(7751);var d=b(6395),e=b(550),g=b(916).CONSTRUCTOR,f=b(3438),h=c("Promise"),k=d&&!g;a({target:"Promise",stat:!0,forced:d||g},{resolve:function(l){return f(k&&\nthis===h?e:this,l)}})},4628:function(a,c,b){a=b(6518);var d=b(6043);a({target:"Promise",stat:!0},{withResolvers:function(){var e=d.f(this);return{promise:e.promise,resolve:e.resolve,reject:e.reject}}})},4864:function(a,c,b){var d=b(3724);a=b(4576);var e=b(9504),g=b(2796),f=b(3167),h=b(6699),k=b(2360),l=b(8480).f,m=b(1625),n=b(788),p=b(655),q=b(1034),r=b(8429);c=b(1056);var t=b(6840),v=b(9039),w=b(9297),y=b(1181).enforce,x=b(7633),z=b(8227),A=b(3635),B=b(8814),C=z("match"),D=a.RegExp,E=D.prototype,\nG=a.SyntaxError,J=e(E.exec),F=e("".charAt),L=e("".replace),M=e("".indexOf),W=e("".slice),Q=/^\\?<[^\\s\\d!#%&*+<=>@^][^\\s!#%&*+<=>@^]*>/,la=/a/g,ta=/a/g;b=new D(la)!==la;var qa=r.MISSED_STICKY,va=r.UNSUPPORTED_Y;b=d&&(!b||qa||A||B||v(function(){ta[C]=!1;return D(la)!==la||D(ta)===ta||"/a/i"!==String(D(la,"i"))}));if(g("RegExp",b)){var S=function(da,R){var Y=m(E,this),fa=n(da),H=void 0===R,U=[],N=da,ba,aa;if(!Y&&fa&&H&&da.constructor===S)return da;if(fa||m(E,da))da=da.source,H&&(R=q(N));da=void 0===da?\n"":p(da);R=void 0===R?"":p(R);N=da;A&&"dotAll"in la&&(ba=!!R&&-1<M(R,"s"))&&(R=L(R,/s/g,""));fa=R;qa&&"sticky"in la&&(aa=!!R&&-1<M(R,"y"))&&va&&(R=L(R,/y/g,""));if(B){U=da.length;H=0;for(var X="",ha=[],ma=k(null),V=!1,ea=!1,za=0,Ia="",wa;H<=U;H++){wa=F(da,H);if("\\\\"===wa)wa+=F(da,++H);else if("]"===wa)V=!1;else if(!V)switch(!0){case "["===wa:V=!0;break;case "("===wa:X+=wa;if("?:"===W(da,H+1,H+3))continue;J(Q,W(da,H+1))&&(H+=2,ea=!0);za++;continue;case ">"===wa&&ea:if(""===Ia||w(ma,Ia))throw new G("Invalid capture group name");\nma[Ia]=!0;ha[ha.length]=[Ia,za];ea=!1;Ia="";continue}ea?Ia+=wa:X+=wa}U=[X,ha];da=U[0];U=U[1]}R=f(D(da,R),Y?this:E,S);if(ba||aa||U.length){Y=y(R);if(ba){Y.dotAll=!0;ba=S;H=da;X=H.length;ha=0;ma="";for(V=!1;ha<=X;ha++)ea=F(H,ha),"\\\\"===ea?ma+=ea+F(H,++ha):V||"."!==ea?("["===ea?V=!0:"]"===ea&&(V=!1),ma+=ea):ma+="[\\\\s\\\\S]";Y.raw=ba(ma,fa)}aa&&(Y.sticky=!0);U.length&&(Y.groups=U)}if(da!==N)try{h(R,"source",""===N?"(?:)":N)}catch(Aa){}return R};b=l(D);for(g=0;b.length>g;)c(S,D,b[g++]);E.constructor=S;S.prototype=\nE;t(a,"RegExp",S,{constructor:!0})}x("RegExp")},7465:function(a,c,b){a=b(3724);c=b(3635);var d=b(2195),e=b(2106),g=b(1181).get,f=RegExp.prototype,h=TypeError;a&&c&&e(f,"dotAll",{configurable:!0,get:function(){if(this!==f){if("RegExp"===d(this))return!!g(this).dotAll;throw new h("Incompatible receiver, RegExp required");}}})},7495:function(a,c,b){a=b(6518);b=b(7323);a({target:"RegExp",proto:!0,forced:/./.exec!==b},{exec:b})},9479:function(a,c,b){a=b(4576);c=b(3724);var d=b(2106),e=b(7979);b=b(9039);\nvar g=a.RegExp,f=g.prototype;c&&b(function(){function h(r,t){Object.defineProperty(l,r,{get:function(){m+=t;return!0}})}var k=!0;try{g(".","d")}catch(r){k=!1}var l={},m="",n=k?"dgimsy":"gimsy",p={dotAll:"s",global:"g",ignoreCase:"i",multiline:"m",sticky:"y"};k&&(p.hasIndices="d");for(var q in p)h(q,p[q]);return Object.getOwnPropertyDescriptor(f,"flags").get.call(l)!==n||m!==n})&&d(f,"flags",{configurable:!0,get:e})},7642:function(a,c,b){a=b(6518);c=b(3440);b=b(4916);a({target:"Set",proto:!0,real:!0,\nforced:!b("difference")},{difference:c})},8004:function(a,c,b){a=b(6518);var d=b(9039);c=b(8750);b=!b(4916)("intersection")||d(function(){return"3,2"!==String(Array.from((new Set([1,2,3])).intersection(new Set([3,2]))))});a({target:"Set",proto:!0,real:!0,forced:b},{intersection:c})},3853:function(a,c,b){a=b(6518);c=b(4449);b=b(4916);a({target:"Set",proto:!0,real:!0,forced:!b("isDisjointFrom")},{isDisjointFrom:c})},5876:function(a,c,b){a=b(6518);c=b(3838);b=b(4916);a({target:"Set",proto:!0,real:!0,\nforced:!b("isSubsetOf")},{isSubsetOf:c})},2475:function(a,c,b){a=b(6518);c=b(8527);b=b(4916);a({target:"Set",proto:!0,real:!0,forced:!b("isSupersetOf")},{isSupersetOf:c})},5024:function(a,c,b){a=b(6518);c=b(3650);b=b(4916);a({target:"Set",proto:!0,real:!0,forced:!b("symmetricDifference")},{symmetricDifference:c})},1698:function(a,c,b){a=b(6518);c=b(4204);b=b(4916);a({target:"Set",proto:!0,real:!0,forced:!b("union")},{union:c})},7357:function(a,c,b){a=b(6518);c=b(9504);var d=b(7750),e=b(1291),g=b(655);\nb=b(9039);var f=c("".charAt);b=b(function(){return"\ud842"!=="\ud842\udfb7".at(-2)});a({target:"String",proto:!0,forced:b},{at:function(h){var k=g(d(this)),l=k.length;h=e(h);h=0<=h?h:l+h;return 0>h||h>=l?void 0:f(k,h)}})},8156:function(a,c,b){a=b(6518);var d=b(533).start;b=b(3063);a({target:"String",proto:!0,forced:b},{padStart:function(e){return d(this,e,1<arguments.length?arguments[1]:void 0)}})},9978:function(a,c,b){a=b(6518);var d=b(9565);c=b(9504);var e=b(7750),g=b(4901),f=b(4117),h=b(788),k=\nb(655),l=b(5966),m=b(1034),n=b(2478),p=b(8227),q=b(6395),r=p("replace"),t=TypeError,v=c("".indexOf),w=c("".replace),y=c("".slice),x=Math.max;a({target:"String",proto:!0},{replaceAll:function(z,A){var B=e(this),C,D,E=0,G="";if(!f(z)){if(C=h(z)){var J=k(e(m(z)));if(!~v(J,"g"))throw new t("`.replaceAll` does not allow non-global regexes");}if(J=l(z,r))return d(J,z,B,A);if(q&&C)return w(k(B),z,A)}B=k(B);z=k(z);(C=g(A))||(A=k(A));J=z.length;var F=x(1,J);for(D=v(B,z);-1!==D;){var L=C?k(A(z,D,B)):n(z,B,\nD,[],void 0,A);G+=y(B,E,D)+L;E=D+J;D=D+F>B.length?-1:v(B,z,D+F)}E<B.length&&(G+=y(B,E));return G}})},5440:function(a,c,b){var d=b(8745),e=b(9565),g=b(9504);a=b(9228);c=b(9039);var f=b(8551),h=b(4901),k=b(4117),l=b(1291),m=b(8014),n=b(655),p=b(7750),q=b(7829),r=b(5966),t=b(2478),v=b(6682),w=b(8227)("replace"),y=Math.max,x=Math.min,z=g([].concat),A=g([].push),B=g("".indexOf),C=g("".slice);b="$0"==="a".replace(/./,"$0");var D=/./[w]?""===/./[w]("a","$0"):!1;c=!c(function(){var E=/./;E.exec=function(){var G=\n[];G.groups={a:"7"};return G};return"7"!=="".replace(E,"$<a>")});a("replace",function(E,G,J){var F=D?"$":"$0";return[function(L,M){var W=p(this),Q=k(L)?void 0:r(L,w);return Q?e(Q,L,W,M):e(G,n(W),L,M)},function(L,M){var W=f(this);L=n(L);if("string"==typeof M&&-1===B(M,F)&&-1===B(M,"$<")){var Q=J(G,W,L,M);if(Q.done)return Q.value}(Q=h(M))||(M=n(M));var la=W.global;if(la){var ta=W.unicode;W.lastIndex=0}for(var qa=[],va;;){va=v(W,L);if(null===va)break;A(qa,va);if(!la)break;""===n(va[0])&&(W.lastIndex=\nq(L,m(W.lastIndex),ta))}W="";for(la=ta=0;la<qa.length;la++){va=qa[la];for(var S=n(va[0]),da=y(x(l(va.index),L.length),0),R=[],Y=1;Y<va.length;Y++){var fa=va[Y];A(R,void 0===fa?fa:String(fa))}va=va.groups;Q?(R=z([S],R,da,L),void 0!==va&&A(R,va),va=n(d(M,void 0,R))):va=t(S,L,da,R,va,M);da>=ta&&(W+=C(L,ta,da)+va,ta=da+S.length)}return W+C(L,ta)}]},!c||!b||D)},744:function(a,c,b){var d=b(9565);c=b(9504);a=b(9228);var e=b(8551),g=b(4117),f=b(7750),h=b(2293),k=b(7829),l=b(8014),m=b(655),n=b(5966),p=b(6682),\nq=b(8429);b=b(9039);var r=q.UNSUPPORTED_Y,t=Math.min,v=c([].push),w=c("".slice);b=!b(function(){var x=/(?:)/,z=x.exec;x.exec=function(){return z.apply(this,arguments)};x="ab".split(x);return 2!==x.length||"a"!==x[0]||"b"!==x[1]});var y="c"==="abbc".split(/(b)*/)[1]||4!=="test".split(/(?:)/,-1).length||2!=="ab".split(/(?:ab)*/).length||4!==".".split(/(.?)(.?)/).length||1<".".split(/()()/).length||"".split(/.?/).length;a("split",function(x,z,A){var B="0".split(void 0,0).length?function(C,D){return void 0===\nC&&0===D?[]:d(z,this,C,D)}:z;return[function(C,D){var E=f(this),G=g(C)?void 0:n(C,x);return G?d(G,C,E,D):d(B,m(E),C,D)},function(C,D){var E=e(this);C=m(C);if(!y){var G=A(B,E,C,D,B!==z);if(G.done)return G.value}var J=h(E,RegExp);G=E.unicode;E=new J(r?"^(?:"+E.source+")":E,(E.ignoreCase?"i":"")+(E.multiline?"m":"")+(E.unicode?"u":"")+(r?"g":"y"));D=void 0===D?4294967295:D>>>0;if(0===D)return[];if(0===C.length)return null===p(E,C)?[C]:[];var F=0,L=0;for(J=[];L<C.length;){E.lastIndex=r?0:L;var M=p(E,\nr?w(C,L):C),W;if(null===M||(W=t(l(E.lastIndex+(r?L:0)),C.length))===F)L=k(C,L,G);else{v(J,w(C,F,L));if(J.length===D)return J;for(F=1;F<=M.length-1;F++)if(v(J,M[F]),J.length===D)return J;L=F=W}}v(J,w(C,F));return J}]},y||!b,r)},9202:function(a,c,b){b(3313);a=b(6518);b=b(8866);a({target:"String",proto:!0,name:"trimEnd",forced:"".trimEnd!==b},{trimEnd:b})},3313:function(a,c,b){a=b(6518);b=b(8866);a({target:"String",proto:!0,name:"trimEnd",forced:"".trimRight!==b},{trimRight:b})},2762:function(a,c,b){a=\nb(6518);var d=b(3802).trim;b=b(706);a({target:"String",proto:!0,forced:b("trim")},{trim:function(){return d(this)}})},6412:function(a,c,b){b(511)("asyncIterator")},9463:function(a,c,b){a=b(6518);var d=b(3724),e=b(4576);c=b(9504);var g=b(9297),f=b(4901),h=b(1625),k=b(655),l=b(2106);b=b(7740);var m=e.Symbol,n=m&&m.prototype;if(d&&f(m)&&(!("description"in n)||void 0!==m().description)){var p={};d=function(){var x=1>arguments.length||void 0===arguments[0]?void 0:k(arguments[0]),z=h(n,this)?new m(x):void 0===\nx?m():m(x);""===x&&(p[z]=!0);return z};b(d,m);d.prototype=n;n.constructor=d;var q="Symbol(description detection)"===String(m("description detection")),r=c(n.valueOf),t=c(n.toString),v=/^Symbol\\((.*)\\)[^)]+$/,w=c("".replace),y=c("".slice);l(n,"description",{configurable:!0,get:function(){var x=r(this);if(g(p,x))return"";x=t(x);x=q?y(x,7,-1):w(x,v,"$1");return""===x?void 0:x}});a({global:!0,constructor:!0,forced:!0},{Symbol:d})}},8140:function(a,c,b){a=b(4644);var d=b(6198),e=b(1291),g=a.aTypedArray;\nb=a.exportTypedArrayMethod;b("at",function(f){var h=g(this),k=d(h);f=e(f);f=0<=f?f:k+f;return 0>f||f>=k?void 0:h[f]})},5044:function(a,c,b){c=b(4644);var d=b(4373),e=b(5854),g=b(6955),f=b(9565);a=b(9504);b=b(9039);var h=c.aTypedArray;c=c.exportTypedArrayMethod;var k=a("".slice);b=b(function(){var l=0;(new Int8Array(2)).fill({valueOf:function(){return l++}});return 1!==l});c("fill",function(l){var m=arguments.length;h(this);var n="Big"===k(g(this),0,3)?e(l):+l;return f(d,this,n,1<m?arguments[1]:void 0,\n2<m?arguments[2]:void 0)},b)},1134:function(a,c,b){a=b(4644);var d=b(3839).findLastIndex,e=a.aTypedArray;b=a.exportTypedArrayMethod;b("findLastIndex",function(g){return d(e(this),g,1<arguments.length?arguments[1]:void 0)})},1903:function(a,c,b){a=b(4644);var d=b(3839).findLast,e=a.aTypedArray;b=a.exportTypedArrayMethod;b("findLast",function(g){return d(e(this),g,1<arguments.length?arguments[1]:void 0)})},4594:function(a,c,b){b(5823)("Float32",function(d){return function(e,g,f){return d(this,e,g,f)}})},\n9833:function(a,c,b){b(5823)("Float64",function(d){return function(e,g,f){return d(this,e,g,f)}})},8345:function(a,c,b){a=b(2805);c=b(4644).exportTypedArrayStaticMethod;b=b(3251);c("from",b,a)},2107:function(a,c,b){b(5823)("Int16",function(d){return function(e,g,f){return d(this,e,g,f)}})},5477:function(a,c,b){b(5823)("Int32",function(d){return function(e,g,f){return d(this,e,g,f)}})},6594:function(a,c,b){b(5823)("Int8",function(d){return function(e,g,f){return d(this,e,g,f)}})},8845:function(a,c,\nb){c=b(4576);var d=b(9565);a=b(4644);var e=b(6198),g=b(8229),f=b(8981);b=b(9039);var h=c.RangeError,k=c.Int8Array,l=(c=k&&k.prototype)&&c.set,m=a.aTypedArray;c=a.exportTypedArrayMethod;var n=!b(function(){var p=new Uint8ClampedArray(2);d(l,p,{length:1,0:3},1);return 3!==p[1]});a=n&&a.NATIVE_ARRAY_BUFFER_VIEWS&&b(function(){var p=new k(2);p.set(1);p.set("2",1);return 0!==p[0]||2!==p[1]});c("set",function(p){m(this);var q=g(1<arguments.length?arguments[1]:void 0,1),r=f(p);if(n)return d(l,this,r,q);\nvar t=this.length,v=e(r),w=0;if(v+q>t)throw new h("Wrong length");for(;w<v;)this[q+w]=r[w++]},!n||a)},373:function(a,c,b){function d(v){return function(w,y){return void 0!==v?+v(w,y)||0:y!==y?-1:w!==w?1:0===w&&0===y?0<1/w&&0>1/y?1:-1:w>y}}c=b(4576);var e=b(7476);a=b(9039);var g=b(9306),f=b(4488),h=b(4644),k=b(3709),l=b(3763),m=b(9519),n=b(3607),p=h.aTypedArray;b=h.exportTypedArrayMethod;var q=c.Uint16Array,r=q&&e(q.prototype.sort);c=!!r&&!(a(function(){r(new q(2),null)})&&a(function(){r(new q(2),\n{})}));var t=!!r&&!a(function(){if(m)return 74>m;if(k)return 67>k;if(l)return!0;if(n)return 602>n;var v=new q(516),w=Array(516),y;for(y=0;516>y;y++){var x=y%4;v[y]=515-y;w[y]=y-2*x+3}r(v,function(z,A){return(z/4|0)-(A/4|0)});for(y=0;516>y;y++)if(v[y]!==w[y])return!0});b("sort",function(v){void 0!==v&&g(v);return t?r(this,v):f(p(this),d(v))},!t||c)},7467:function(a,c,b){var d=b(7628);a=b(4644);var e=a.aTypedArray;c=a.exportTypedArrayMethod;var g=a.getTypedArrayConstructor;c("toReversed",function(){return d(e(this),\ng(this))})},4732:function(a,c,b){a=b(4644);c=b(9504);var d=b(9306),e=b(5370),g=a.aTypedArray,f=a.getTypedArrayConstructor;b=a.exportTypedArrayMethod;var h=c(a.TypedArrayPrototype.sort);b("toSorted",function(k){void 0!==k&&d(k);var l=g(this);l=e(f(l),l);return h(l,k)})},3690:function(a,c,b){b(5823)("Uint16",function(d){return function(e,g,f){return d(this,e,g,f)}})},1740:function(a,c,b){b(5823)("Uint32",function(d){return function(e,g,f){return d(this,e,g,f)}})},1489:function(a,c,b){b(5823)("Uint8",\nfunction(d){return function(e,g,f){return d(this,e,g,f)}})},2134:function(a,c,b){b(5823)("Uint8",function(d){return function(e,g,f){return d(this,e,g,f)}},!0)},9577:function(a,c,b){var d=b(9928);a=b(4644);var e=b(1108),g=b(1291),f=b(5854),h=a.aTypedArray,k=a.getTypedArrayConstructor;b=a.exportTypedArrayMethod;a=!!function(){try{(new Int8Array(1))["with"](2,{valueOf:function(){throw 8;}})}catch(l){return 8===l}}();b("with",function(l,m){var n=h(this);l=g(l);m=e(n)?f(m):+m;return d(n,k(n),l,m)},!a)},\n8992:function(a,c,b){function d(y,x){t?l(r,y,{configurable:!0,get:function(){return x},set:function(z){f(this);if(this===r)throw new v("You can\'t redefine this property");p(this,y)?this[y]=z:m(this,y,z)}}):r[y]=x}function e(){g(this,r);if(k(this)===r)throw new v("Abstract class Iterator not directly constructable");}a=b(6518);c=b(4576);var g=b(679),f=b(8551),h=b(4901),k=b(2787),l=b(2106),m=b(2278),n=b(9039),p=b(9297),q=b(8227),r=b(7657).IteratorPrototype,t=b(3724);b=b(6395);q=q("toStringTag");var v=\nTypeError,w=c.Iterator;b=b||!h(w)||w.prototype!==r||!n(function(){w({})});p(r,q)||d(q,"Iterator");!b&&p(r,"constructor")&&r.constructor!==Object||d("constructor",e);e.prototype=r;a({global:!0,constructor:!0,forced:b},{Iterator:e})},3215:function(a,c,b){a=b(6518);var d=b(2652),e=b(9306),g=b(8551),f=b(1767);a({target:"Iterator",proto:!0,real:!0},{every:function(h){g(this);e(h);var k=f(this),l=0;return!d(k,function(m,n){if(!h(m,l++))return n()},{IS_RECORD:!0,INTERRUPTED:!0}).stopped}})},4520:function(a,\nc,b){a=b(6518);var d=b(9565),e=b(9306),g=b(8551),f=b(1767);c=b(9462);var h=b(6319);b=b(6395);var k=c(function(){for(var l=this.iterator,m=this.predicate,n=this.next,p,q;;){p=g(d(n,l));if(q=this.done=!!p.done)break;p=p.value;if(h(l,m,[p,this.counter++],!0))return p}});a({target:"Iterator",proto:!0,real:!0,forced:b},{filter:function(l){g(this);e(l);return new k(f(this),{predicate:l})}})},2577:function(a,c,b){a=b(6518);var d=b(2652),e=b(9306),g=b(8551),f=b(1767);a({target:"Iterator",proto:!0,real:!0},\n{find:function(h){g(this);e(h);var k=f(this),l=0;return d(k,function(m,n){if(h(m,l++))return n(m)},{IS_RECORD:!0,INTERRUPTED:!0}).result}})},3949:function(a,c,b){a=b(6518);var d=b(2652),e=b(9306),g=b(8551),f=b(1767);a({target:"Iterator",proto:!0,real:!0},{forEach:function(h){g(this);e(h);var k=f(this),l=0;d(k,function(m){h(m,l++)},{IS_RECORD:!0})}})},1454:function(a,c,b){a=b(6518);c=b(713);b=b(6395);a({target:"Iterator",proto:!0,real:!0,forced:b},{map:c})},8872:function(a,c,b){a=b(6518);var d=b(2652),\ne=b(9306),g=b(8551),f=b(1767),h=TypeError;a({target:"Iterator",proto:!0,real:!0},{reduce:function(k){g(this);e(k);var l=f(this),m=2>arguments.length,n=m?void 0:arguments[1],p=0;d(l,function(q){m?(m=!1,n=q):n=k(n,q,p);p++},{IS_RECORD:!0});if(m)throw new h("Reduce of empty iterator with no initial value");return n}})},7550:function(a,c,b){a=b(6518);var d=b(2652),e=b(9306),g=b(8551),f=b(1767);a({target:"Iterator",proto:!0,real:!0},{some:function(h){g(this);e(h);var k=f(this),l=0;return d(k,function(m,\nn){if(h(m,l++))return n()},{IS_RECORD:!0,INTERRUPTED:!0}).stopped}})},1795:function(a,c,b){a=b(6518);var d=b(8551),e=b(2652),g=b(1767),f=[].push;a({target:"Iterator",proto:!0,real:!0},{toArray:function(){var h=[];e(g(d(this)),f,{that:h,IS_RECORD:!0});return h}})},3500:function(a,c,b){function d(k){if(k&&k.forEach!==g)try{f(k,"forEach",g)}catch(l){k.forEach=g}}a=b(4576);c=b(7400);var e=b(9296),g=b(235),f=b(6699),h;for(h in c)c[h]&&d(a[h]&&a[h].prototype);d(e)},2953:function(a,c,b){function d(n,p){if(n){if(n[k]!==\nl)try{f(n,k,l)}catch(r){n[k]=l}h(n,p,!0);if(e[p])for(var q in g)if(n[q]!==g[q])try{f(n,q,g[q])}catch(r){n[q]=g[q]}}}a=b(4576);var e=b(7400);c=b(9296);var g=b(3792),f=b(6699),h=b(687),k=b(8227)("iterator"),l=g.values,m;for(m in e)d(a[m]&&a[m].prototype,m);d(c,"DOMTokenList")},4979:function(a,c,b){function d(){l(this,v);var z=arguments.length,A=n(1>z?void 0:arguments[0]);z=n(2>z?void 0:arguments[1],"Error");z=new t(A,z);A=new r(A);A.name="DOMException";k(z,"stack",h(1,p(A.stack,1)));m(z,this,d);return z}\nvar e=b(6518),g=b(4576),f=b(7751),h=b(6980),k=b(4913).f;a=b(9297);var l=b(679),m=b(3167),n=b(2603);c=b(5002);var p=b(6193),q=b(3724);b=b(6395);var r=f("Error"),t=f("DOMException"),v=d.prototype=t.prototype,w="stack"in new r("DOMException"),y="stack"in new t(1,2);g=t&&q&&Object.getOwnPropertyDescriptor(g,"DOMException");g=!!g&&!(g.writable&&g.configurable);w=w&&!g&&!y;e({global:!0,constructor:!0,forced:b||w},{DOMException:w?d:t});e=f("DOMException");f=e.prototype;if(f.constructor!==e){b||k(f,"constructor",\nh(1,e));for(var x in c)a(c,x)&&(b=c[x],f=b.s,a(e,f)||k(e,f,h(6,b.c)))}},3611:function(a,c,b){a=b(6518);var d=b(4576);c=b(2106);b=b(3724);var e=TypeError,g=Object.defineProperty,f=d.self!==d;try{if(b){var h=Object.getOwnPropertyDescriptor(d,"self");!f&&h&&h.get&&h.enumerable||c(d,"self",{get:function(){return d},set:function(k){if(this!==d)throw new e("Illegal invocation");g(d,"self",{value:k,writable:!0,configurable:!0,enumerable:!0})},configurable:!0,enumerable:!0})}else a({global:!0,simple:!0,forced:f},\n{self:d})}catch(k){}}},ck={};(function(){pa.d=function(a,c){for(var b in c)pa.o(c,b)&&!pa.o(a,b)&&Object.defineProperty(a,b,{enumerable:!0,get:c[b]})}})();(function(){pa.o=function(a,c){return Object.prototype.hasOwnProperty.call(a,c)}})();(function(){pa.r=function(a){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(a,Symbol.toStringTag,{value:"Module"});Object.defineProperty(a,"__esModule",{value:!0})}})();var vf=globalThis.pdfjsWorker={};pa.r(vf);pa.d(vf,{WorkerMessageHandler:function(){return pn}});\npa(6280);pa(6449);pa(3792);pa(4114);pa(3514);pa(1745);pa(6573);pa(8100);pa(7936);pa(3362);pa(9391);pa(4628);pa(7642);pa(8004);pa(3853);pa(5876);pa(2475);pa(5024);pa(1698);pa(1489);pa(8140);pa(5044);pa(1903);pa(1134);pa(8845);pa(373);pa(7467);pa(4732);pa(9577);pa(8992);pa(3949);pa(1454);pa(7550);pa(3500);pa(2953);pa(3611);pa(4423);pa(5081);pa(7495);pa(8156);pa(5440);pa(9978);pa(1740);pa(4979);var ld=[1,0,0,1,0,0],ie=[.001,0,0,.001,0,0],qn=.35/1.35,rn={PRINT:4,MODIFY_CONTENTS:8,COPY:16,MODIFY_ANNOTATIONS:32,\nFILL_INTERACTIVE_FORMS:256,COPY_FOR_ACCESSIBILITY:512,ASSEMBLE:1024,PRINT_HIGH_QUALITY:2048},sn={E:"Mouse Enter",X:"Mouse Exit",D:"Mouse Down",U:"Mouse Up",Fo:"Focus",Bl:"Blur",PO:"PageOpen",PC:"PageClose",PV:"PageVisible",PI:"PageInvisible",K:"Keystroke",F:"Format",V:"Validate",C:"Calculate"},gr={WC:"WillClose",WS:"WillSave",DS:"DidSave",WP:"WillPrint",DP:"DidPrint"},hr={O:"PageOpen",C:"PageClose"},ef={ERRORS:0,WARNINGS:1,INFOS:5},O={dependency:1,setLineWidth:2,setLineCap:3,setLineJoin:4,setMiterLimit:5,\nsetDash:6,setRenderingIntent:7,setFlatness:8,setGState:9,save:10,restore:11,transform:12,moveTo:13,lineTo:14,curveTo:15,curveTo2:16,curveTo3:17,closePath:18,rectangle:19,stroke:20,closeStroke:21,fill:22,eoFill:23,fillStroke:24,eoFillStroke:25,closeFillStroke:26,closeEOFillStroke:27,endPath:28,clip:29,eoClip:30,beginText:31,endText:32,setCharSpacing:33,setWordSpacing:34,setHScale:35,setLeading:36,setFont:37,setTextRenderingMode:38,setTextRise:39,moveText:40,setLeadingMoveText:41,setTextMatrix:42,nextLine:43,\nshowText:44,showSpacedText:45,nextLineShowText:46,nextLineSetSpacingShowText:47,setCharWidth:48,setCharWidthAndBounds:49,setStrokeColorSpace:50,setFillColorSpace:51,setStrokeColor:52,setStrokeColorN:53,setFillColor:54,setFillColorN:55,setStrokeGray:56,setFillGray:57,setStrokeRGBColor:58,setFillRGBColor:59,setStrokeCMYKColor:60,setFillCMYKColor:61,shadingFill:62,beginInlineImage:63,beginImageData:64,endInlineImage:65,paintXObject:66,markPoint:67,markPointProps:68,beginMarkedContent:69,beginMarkedContentProps:70,\nendMarkedContent:71,beginCompat:72,endCompat:73,paintFormXObjectBegin:74,paintFormXObjectEnd:75,beginGroup:76,endGroup:77,beginAnnotation:80,endAnnotation:81,paintImageMaskXObject:83,paintImageMaskXObjectGroup:84,paintImageXObject:85,paintInlineImageXObject:86,paintInlineImageXObjectGroup:87,paintImageXObjectRepeat:88,paintImageMaskXObjectRepeat:89,paintSolidColorImageMask:90,constructPath:91,setStrokeTransparent:92,setFillTransparent:93},Wf=ef.WARNINGS,tc=function(){function a(c,b){this.message=\nc;this.name=b}a.prototype=Error();return a.constructor=a}(),Hg=function(a){function c(b,d){b=a.call(this,b,"PasswordException")||this;b.code=d;return b}wc(c,a);return c}(tc),Ig=function(a){function c(b,d){b=a.call(this,b,"UnknownErrorException")||this;b.details=d;return b}wc(c,a);return c}(tc),Kg=function(a){function c(b){return a.call(this,b,"InvalidPDFException")||this}wc(c,a);return c}(tc),gn=function(a){function c(b){return a.call(this,b,"MissingPDFException")||this}wc(c,a);return c}(tc),hn=function(a){function c(b,\nd){b=a.call(this,b,"UnexpectedResponseException")||this;b.status=d;return b}wc(c,a);return c}(tc),oa=function(a){function c(b){return a.call(this,b,"FormatError")||this}wc(c,a);return c}(tc),rc=function(a){function c(b){return a.call(this,b,"AbortException")||this}wc(c,a);return c}(tc),id=function(){return Yb(function(){},null,[{key:"isLittleEndian",get:function(){var a=new Uint8Array(4);a[0]=1;a=1===(new Uint32Array(a.buffer,0,1))[0];return Fa(this,"isLittleEndian",a)}},{key:"isEvalSupported",get:function(){try{new Function("");\nvar a=!0}catch(c){a=!1}return Fa(this,"isEvalSupported",a)}},{key:"isOffscreenCanvasSupported",get:function(){return Fa(this,"isOffscreenCanvasSupported","undefined"!==typeof OffscreenCanvas)}},{key:"platform",get:function(){var a;if("undefined"!==typeof navigator&&"string"===typeof(null==(a=navigator)?void 0:a.platform)){var c;return Fa(this,"platform",{isMac:navigator.platform.includes("Mac"),isWindows:navigator.platform.includes("Win"),isFirefox:"string"===typeof(null==(c=navigator)?void 0:c.userAgent)&&\nnavigator.userAgent.includes("Firefox")})}return Fa(this,"platform",{isMac:!1,isWindows:!1,isFirefox:!1})}},{key:"isCSSRoundSupported",get:function(){var a;return Fa(this,"isCSSRoundSupported",null==(a=globalThis.CSS)||null==a.supports?void 0:a.supports("width: round(1.5px, 1px)"))}}])}(),Be=Array.from(Array(256).keys(),function(a){return a.toString(16).padStart(2,"0")}),Rb=function(){function a(){}a.makeHexColor=function(c,b,d){return"#"+Be[c]+Be[b]+Be[d]};a.scaleMinMax=function(c,b){if(c[0]){if(0>\nc[0]){var d=b[0];b[0]=b[2];b[2]=d}b[0]*=c[0];b[2]*=c[0];0>c[3]&&(d=b[1],b[1]=b[3],b[3]=d);b[1]*=c[3];b[3]*=c[3]}else d=b[0],b[0]=b[1],b[1]=d,d=b[2],b[2]=b[3],b[3]=d,0>c[1]&&(d=b[1],b[1]=b[3],b[3]=d),b[1]*=c[1],b[3]*=c[1],0>c[2]&&(d=b[0],b[0]=b[2],b[2]=d),b[0]*=c[2],b[2]*=c[2];b[0]+=c[4];b[1]+=c[5];b[2]+=c[4];b[3]+=c[5]};a.transform=function(c,b){return[c[0]*b[0]+c[2]*b[1],c[1]*b[0]+c[3]*b[1],c[0]*b[2]+c[2]*b[3],c[1]*b[2]+c[3]*b[3],c[0]*b[4]+c[2]*b[5]+c[4],c[1]*b[4]+c[3]*b[5]+c[5]]};a.applyTransform=\nfunction(c,b){return[c[0]*b[0]+c[1]*b[2]+b[4],c[0]*b[1]+c[1]*b[3]+b[5]]};a.applyInverseTransform=function(c,b){var d=b[0]*b[3]-b[1]*b[2];return[(c[0]*b[3]-c[1]*b[2]+b[2]*b[5]-b[4]*b[3])/d,(-c[0]*b[1]+c[1]*b[0]+b[4]*b[1]-b[5]*b[0])/d]};a.getAxialAlignedBoundingBox=function(c,b){var d=this.applyTransform(c,b),e=this.applyTransform(c.slice(2,4),b),g=this.applyTransform([c[0],c[3]],b);c=this.applyTransform([c[2],c[1]],b);return[Math.min(d[0],e[0],g[0],c[0]),Math.min(d[1],e[1],g[1],c[1]),Math.max(d[0],\ne[0],g[0],c[0]),Math.max(d[1],e[1],g[1],c[1])]};a.inverseTransform=function(c){var b=c[0]*c[3]-c[1]*c[2];return[c[3]/b,-c[1]/b,-c[2]/b,c[0]/b,(c[2]*c[5]-c[4]*c[3])/b,(c[4]*c[1]-c[5]*c[0])/b]};a.singularValueDecompose2dScale=function(c){var b=[c[0],c[2],c[1],c[3]],d=c[0]*b[0]+c[1]*b[2],e=c[2]*b[1]+c[3]*b[3],g=(d+e)/2;c=Math.sqrt(Math.pow(d+e,2)-4*(d*e-(c[2]*b[0]+c[3]*b[2])*(c[0]*b[1]+c[1]*b[3])))/2;return[Math.sqrt(g+c||1),Math.sqrt(g-c||1)]};a.normalizeRect=function(c){var b=c.slice(0);c[0]>c[2]&&\n(b[0]=c[2],b[2]=c[0]);c[1]>c[3]&&(b[1]=c[3],b[3]=c[1]);return b};a.intersect=function(c,b){var d=Math.max(Math.min(c[0],c[2]),Math.min(b[0],b[2])),e=Math.min(Math.max(c[0],c[2]),Math.max(b[0],b[2]));if(d>e)return null;var g=Math.max(Math.min(c[1],c[3]),Math.min(b[1],b[3]));c=Math.min(Math.max(c[1],c[3]),Math.max(b[1],b[3]));return g>c?null:[d,g,e,c]};a.__getExtremumOnCurve=function(c,b,d,e,g,f,h,k,l,m){if(!(0>=l||1<=l)){var n=1-l,p=l*l,q=p*l;c=n*(n*(n*c+3*l*b)+3*p*d)+q*e;g=n*(n*(n*g+3*l*f)+3*p*h)+\nq*k;m[0]=Math.min(m[0],c);m[1]=Math.min(m[1],g);m[2]=Math.max(m[2],c);m[3]=Math.max(m[3],g)}};a.__getExtremum=function(c,b,d,e,g,f,h,k,l,m,n,p){1E-12>Math.abs(l)?1E-12<=Math.abs(m)&&this.__getExtremumOnCurve(c,b,d,e,g,f,h,k,-n/m,p):(n=Math.pow(m,2)-4*n*l,0>n||(n=Math.sqrt(n),l*=2,this.__getExtremumOnCurve(c,b,d,e,g,f,h,k,(-m+n)/l,p),this.__getExtremumOnCurve(c,b,d,e,g,f,h,k,(-m-n)/l,p)))};a.bezierBoundingBox=function(c,b,d,e,g,f,h,k,l){l?(l[0]=Math.min(l[0],c,h),l[1]=Math.min(l[1],b,k),l[2]=Math.max(l[2],\nc,h),l[3]=Math.max(l[3],b,k)):l=[Math.min(c,h),Math.min(b,k),Math.max(c,h),Math.max(b,k)];this.__getExtremum(c,d,g,h,b,e,f,k,3*(-c+3*(d-g)+h),6*(c-2*d+g),3*(d-c),l);this.__getExtremum(c,d,g,h,b,e,f,k,3*(-b+3*(e-f)+k),6*(b-2*e+f),3*(e-b),l);return l};return a}(),fp=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,728,711,710,729,733,731,730,732,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,\n0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,8226,8224,8225,8230,8212,8211,402,8260,8249,8250,8722,8240,8222,8220,8221,8216,8217,8218,8482,64257,64258,321,338,352,376,381,305,322,339,353,382,0,8364],bh=null,dk=null,Xb={BEZIER_CURVE_TO:0,MOVE_TO:1,LINE_TO:2,QUADRATIC_CURVE_TO:3,RESTORE:4,SAVE:5,SCALE:6,TRANSFORM:7,TRANSLATE:8};pa(4864);pa(7465);pa(744);pa(3215);pa(9463);pa(5506);pa(6034);var ir=Symbol("CIRCULAR_REF"),$b=Symbol("EOF"),Ul=Object.create(null),Vl=Object.create(null),og=Object.create(null),ka=function(){function a(c){this.name=\nc}a.get=function(c){var b;return(b=Vl)[c]||(b[c]=new a(c))};return a}(),Vb=function(){function a(c){this.cmd=c}a.get=function(c){var b;return(b=Ul)[c]||(b[c]=new a(c))};return a}(),ca=function(){function a(b){void 0===b&&(b=null);this._map=Object.create(null);this.xref=b;this.objId=null;this.suppressEncryption=!1;this.__nonSerializable__=Ka}var c=a.prototype;c.assignXref=function(b){this.xref=b};c.get=function(b,d,e){b=this._map[b];void 0===b&&void 0!==d&&(b=this._map[d],void 0===b&&void 0!==e&&(b=\nthis._map[e]));return b instanceof Ha&&this.xref?this.xref.fetch(b,this.suppressEncryption):b};c.getAsync=function(){var b=ip(function h(e,g,f){var k=this,l;return u.generator.createGenerator(h,function(m){l=k._map[e];void 0===l&&void 0!==g&&(l=k._map[g],void 0===l&&void 0!==f&&(l=k._map[f]));return l instanceof Ha&&k.xref?m.return(k.xref.fetchAsync(l,k.suppressEncryption)):m.return(l)})});return function(e,g,f){return b.apply(this,arguments)}}();c.getArray=function(b,d,e){b=this._map[b];void 0===\nb&&void 0!==d&&(b=this._map[d],void 0===b&&void 0!==e&&(b=this._map[e]));b instanceof Ha&&this.xref&&(b=this.xref.fetch(b,this.suppressEncryption));if(Array.isArray(b))for(b=b.slice(),d=0,e=b.length;d<e;d++)b[d]instanceof Ha&&this.xref&&(b[d]=this.xref.fetch(b[d],this.suppressEncryption));return b};c.getRaw=function(b){return this._map[b]};c.getKeys=function(){return Object.keys(this._map)};c.getRawValues=function(){return Object.values(this._map)};c.set=function(b,d){this._map[b]=d};c.has=function(b){return void 0!==\nthis._map[b]};c.forEach=function(b){for(var d in this._map)b(d,this.get(d))};a.merge=function(b){var d=b.xref,e=b.dictArray,g=void 0===b.mergeSubDicts?!1:b.mergeSubDicts;b=new a(d);var f=new Map;e=u.makeIterator(e);for(var h=e.next();!h.done;h=e.next())if(h=h.value,h instanceof a){h=u.makeIterator(Object.entries(h._map));for(var k=h.next();!k.done;k=h.next()){var l=u.makeIterator(k.value);k=l.next().value;l=l.next().value;var m=f.get(k);if(void 0===m)m=[],f.set(k,m);else if(!(g&&l instanceof a))continue;\nm.push(l)}}g=u.makeIterator(f);for(e=g.next();!e.done;e=g.next())if(h=u.makeIterator(e.value),e=h.next().value,k=h.next().value,1!==k.length&&k[0]instanceof a){h=new a(d);k=u.makeIterator(k);for(l=k.next();!l.done;l=k.next())for(l=u.makeIterator(Object.entries(l.value._map)),m=l.next();!m.done;m=l.next()){var n=u.makeIterator(m.value);m=n.next().value;n=n.next().value;void 0===h._map[m]&&(h._map[m]=n)}0<h.size&&(b._map[e]=h)}else b._map[e]=k[0];f.clear();return 0<b.size?b:a.empty};c.clone=function(){for(var b=\nnew a(this.xref),d=u.makeIterator(this.getKeys()),e=d.next();!e.done;e=d.next())e=e.value,b.set(e,this.getRaw(e));return b};c.delete=function(b){delete this._map[b]};return hk(a,[{key:"size",get:function(){return Object.keys(this._map).length}}],[{key:"empty",get:function(){var b=new a(null);b.set=function(){db("Should not call `set` on the empty dictionary.")};return Fa(this,"empty",b)}}])}(),Ha=function(){function a(c,b){this.num=c;this.gen=b}a.prototype.toString=function(){return 0===this.gen?\nthis.num+"R":this.num+"R"+this.gen};a.fromString=function(c){var b=og[c];return b?b:(b=/^(\\d+)R(\\d*)$/.exec(c))&&"0"!==b[1]?og[c]=new a(parseInt(b[1]),b[2]?parseInt(b[2]):0):null};a.get=function(c,b){var d,e=0===b?c+"R":c+"R"+b;return(d=og)[e]||(d[e]=new a(c,b))};return a}(),Zb=function(){function a(b){var d;void 0===b&&(b=null);this._set=new Set(null==(d=b)?void 0:d._set)}var c=a.prototype;c.has=function(b){return this._set.has(b.toString())};c.put=function(b){this._set.add(b.toString())};c.remove=\nfunction(b){this._set.delete(b.toString())};c[Symbol.iterator]=function(){return this._set.values()};c.clear=function(){this._set.clear()};return a}(),Pc=function(){function a(){this._map=new Map}var c=a.prototype;c.get=function(b){return this._map.get(b.toString())};c.has=function(b){return this._map.has(b.toString())};c.put=function(b,d){this._map.set(b.toString(),d)};c.putAlias=function(b,d){this._map.set(b.toString(),this.get(d))};c[Symbol.iterator]=function(){return this._map.values()};c.clear=\nfunction(){this._map.clear()};c.items=function d(){var e=this,g,f,h,k,l,m;return u.generator.createGenerator(d,function(n){1==n.nextAddress&&(g=u.makeIterator(e._map),f=g.next());if(3!=n.nextAddress){if(f.done)return n.jumpTo(0);h=f.value;k=u.makeIterator(h);l=k.next().value;m=k.next().value;return n.yield([Ha.fromString(l),m],3)}f=g.next();return n.jumpTo(2)})};return hk(a,[{key:"size",get:function(){return this._map.size}}])}(),$a=function(){function a(){}var c=a.prototype;c.getByte=function(){db("Abstract method `getByte` called")};\nc.getBytes=function(){db("Abstract method `getBytes` called")};c.getImageData=function(){var b=ch(function f(e,g){var h=this;return u.generator.createGenerator(f,function(k){return k.return(h.getBytes(e,g))})});return function(e,g){return b.apply(this,arguments)}}();c.asyncGetBytes=function(){var b=ch(function e(){return u.generator.createGenerator(e,function(g){db("Abstract method `asyncGetBytes` called");g.jumpToEnd()})});return function(){return b.apply(this,arguments)}}();c.getTransferableImage=\nfunction(){var b=ch(function e(){return u.generator.createGenerator(e,function(g){return g.return(null)})});return function(){return b.apply(this,arguments)}}();c.peekByte=function(){var b=this.getByte();-1!==b&&this.pos--;return b};c.peekBytes=function(b){b=this.getBytes(b);this.pos-=b.length;return b};c.getUint16=function(){var b=this.getByte(),d=this.getByte();return-1===b||-1===d?-1:(b<<8)+d};c.getInt32=function(){var b=this.getByte(),d=this.getByte(),e=this.getByte(),g=this.getByte();return(b<<\n24)+(d<<16)+(e<<8)+g};c.getByteRange=function(){db("Abstract method `getByteRange` called")};c.getString=function(b){return Ec(this.getBytes(b))};c.skip=function(b){this.pos+=b||1};c.reset=function(){db("Abstract method `reset` called")};c.moveStart=function(){db("Abstract method `moveStart` called")};c.makeSubStream=function(){db("Abstract method `makeSubStream` called")};c.getBaseStreams=function(){return null};return jp(a,[{key:"length",get:function(){db("Abstract getter `length` accessed")}},\n{key:"isEmpty",get:function(){db("Abstract getter `isEmpty` accessed")}},{key:"isDataLoaded",get:function(){return Fa(this,"isDataLoaded",!0)}},{key:"isAsync",get:function(){return!1}},{key:"canAsyncDecodeImageFromBuffer",get:function(){return!1}}])}(),tn=/^[1-9]\\.\\d$/,ub=function(a){function c(b,d){var e=a.call(this,"Missing data ["+b+", "+d+")","MissingDataException")||this;e.begin=b;e.end=d;return e}Zf(c,a);return c}(tc),hj=function(a){function c(b){return a.call(this,b,"ParserEOFException")||\nthis}Zf(c,a);return c}(tc),Ud=function(a){function c(b){return a.call(this,b,"XRefEntryException")||this}Zf(c,a);return c}(tc),Oe=function(a){function c(b){return a.call(this,b,"XRefParseException")||this}Zf(c,a);return c}(tc),ij=" C CC CCC CD D DC DCC DCCC CM  X XX XXX XL L LX LXX LXXX XC  I II III IV V VI VII VIII IX".split(" "),lp={60:"&lt;",62:"&gt;",38:"&amp;",34:"&quot;",39:"&apos;"};pa(6910);var Mb=function(a){function c(d,e,g,f){var h=a.call(this)||this;h.bytes=d instanceof Uint8Array?d:new Uint8Array(d);\nh.start=e||0;h.pos=h.start;h.end=e+g||h.bytes.length;h.dict=f;return h}ih(c,a);var b=c.prototype;b.getByte=function(){return this.pos>=this.end?-1:this.bytes[this.pos++]};b.getBytes=function(d){var e=this.bytes,g=this.pos,f=this.end;if(!d)return e.subarray(g,f);d=g+d;d>f&&(d=f);this.pos=d;return e.subarray(g,d)};b.getByteRange=function(d,e){0>d&&(d=0);e>this.end&&(e=this.end);return this.bytes.subarray(d,e)};b.reset=function(){this.pos=this.start};b.moveStart=function(){this.start=this.pos};b.makeSubStream=\nfunction(d,e,g){void 0===g&&(g=null);return new c(this.bytes.buffer,d,e,g)};return np(c,[{key:"length",get:function(){return this.end-this.start}},{key:"isEmpty",get:function(){return 0===this.length}}])}($a),Qc=function(a){function c(b){return a.call(this,jc(b))||this}ih(c,a);return c}(Mb),jj=function(a){function c(){return a.call(this,new Uint8Array(0))||this}ih(c,a);return c}(Mb),jr=function(a){function c(d,e,g){var f=a.call(this,new Uint8Array(d),0,d,null)||this;f.chunkSize=e;f._loadedChunks=\nnew Set;f.numChunks=Math.ceil(d/e);f.manager=g;f.progressiveDataLength=0;f.lastSuccessfulEnsureByteChunk=-1;return f}pp(c,a);var b=c.prototype;b.getMissingChunks=function(){for(var d=[],e=0,g=this.numChunks;e<g;++e)this._loadedChunks.has(e)||d.push(e);return d};b.onReceiveData=function(d,e){var g=this.chunkSize;if(0!==d%g)throw Error("Bad begin offset: "+d);var f=d+e.byteLength;if(0!==f%g&&f!==this.bytes.length)throw Error("Bad end offset: "+f);this.bytes.set(new Uint8Array(e),d);e=Math.floor((f-\n1)/g)+1;for(d=Math.floor(d/g);d<e;++d)this._loadedChunks.add(d)};b.onReceiveProgressiveData=function(d){var e=this.progressiveDataLength,g=Math.floor(e/this.chunkSize);this.bytes.set(new Uint8Array(d),e);this.progressiveDataLength=e+=d.byteLength;for(d=e>=this.end?this.numChunks:Math.floor(e/this.chunkSize);g<d;++g)this._loadedChunks.add(g)};b.ensureByte=function(d){if(!(d<this.progressiveDataLength)){var e=Math.floor(d/this.chunkSize);if(!(e>this.numChunks)&&e!==this.lastSuccessfulEnsureByteChunk){if(!this._loadedChunks.has(e))throw new ub(d,\nd+1);this.lastSuccessfulEnsureByteChunk=e}}};b.ensureRange=function(d,e){if(!(d>=e||e<=this.progressiveDataLength)){var g=Math.floor(d/this.chunkSize);if(!(g>this.numChunks))for(var f=Math.min(Math.floor((e-1)/this.chunkSize)+1,this.numChunks);g<f;++g)if(!this._loadedChunks.has(g))throw new ub(d,e);}};b.nextEmptyChunk=function(d){for(var e=this.numChunks,g=0;g<e;++g){var f=(d+g)%e;if(!this._loadedChunks.has(f))return f}return null};b.hasChunk=function(d){return this._loadedChunks.has(d)};b.getByte=\nfunction(){var d=this.pos;if(d>=this.end)return-1;d>=this.progressiveDataLength&&this.ensureByte(d);return this.bytes[this.pos++]};b.getBytes=function(d){var e=this.bytes,g=this.pos,f=this.end;if(!d)return f>this.progressiveDataLength&&this.ensureRange(g,f),e.subarray(g,f);d=g+d;d>f&&(d=f);d>this.progressiveDataLength&&this.ensureRange(g,d);this.pos=d;return e.subarray(g,d)};b.getByteRange=function(d,e){0>d&&(d=0);e>this.end&&(e=this.end);e>this.progressiveDataLength&&this.ensureRange(d,e);return this.bytes.subarray(d,\ne)};b.makeSubStream=function(d,e,g){function f(){}void 0===g&&(g=null);e?d+e>this.progressiveDataLength&&this.ensureRange(d,d+e):d>=this.progressiveDataLength&&this.ensureByte(d);f.prototype=Object.create(this);f.prototype.getMissingChunks=function(){var k=this.chunkSize,l=Math.floor((this.end-1)/k)+1,m=[];for(k=Math.floor(this.start/k);k<l;++k)this._loadedChunks.has(k)||m.push(k);return m};Object.defineProperty(f.prototype,"isDataLoaded",{get:function(){return this.numChunksLoaded===this.numChunks?\n!0:0===this.getMissingChunks().length},configurable:!0});var h=new f;h.pos=h.start=d;h.end=d+e||this.end;h.dict=g;return h};b.getBaseStreams=function(){return[this]};return op(c,[{key:"numChunksLoaded",get:function(){return this._loadedChunks.size}},{key:"isDataLoaded",get:function(){return this.numChunksLoaded===this.numChunks}}])}(Mb),kr=function(){function a(b,d){this.length=d.length;this.chunkSize=d.rangeChunkSize;this.stream=new jr(this.length,this.chunkSize,this);this.pdfNetworkStream=b;this.disableAutoFetch=\nd.disableAutoFetch;this.msgHandler=d.msgHandler;this.currRequestId=0;this._chunksNeededByRequest=new Map;this._requestsByChunk=new Map;this._promisesByRequest=new Map;this.progressiveDataLength=0;this.aborted=!1;this._loadedStreamCapability=Promise.withResolvers()}var c=a.prototype;c.sendRequest=function(b,d){var e=this,g=this.pdfNetworkStream.getRangeReader(b,d);g.isStreamingSupported||(g.onProgress=this.onProgress.bind(this));var f=[],h=0;return(new Promise(function(k,l){function m(n){var p=n.value;\nn=n.done;try{if(n){var q=lk(f);f=null;k(q)}else{h+=p.byteLength;if(g.isStreamingSupported)e.onProgress({loaded:h});f.push(p);g.read().then(m,l)}}catch(r){l(r)}}g.read().then(m,l)})).then(function(k){if(!e.aborted)e.onReceiveData({chunk:k,begin:b})})};c.requestAllChunks=function(b){void 0===b&&(b=!1);b||(b=this.stream.getMissingChunks(),this._requestChunks(b));return this._loadedStreamCapability.promise};c._requestChunks=function(b){var d=this,e=this.currRequestId++,g=new Set;this._chunksNeededByRequest.set(e,\ng);b=u.makeIterator(b);for(var f=b.next();!f.done;f=b.next())f=f.value,this.stream.hasChunk(f)||g.add(f);if(0===g.size)return Promise.resolve();b=Promise.withResolvers();this._promisesByRequest.set(e,b);f=[];g=u.makeIterator(g);for(var h=g.next();!h.done;h=g.next()){h=h.value;var k=this._requestsByChunk.get(h);k||(k=[],this._requestsByChunk.set(h,k),f.push(h));k.push(e)}if(0<f.length)for(e=this.groupChunks(f),e=u.makeIterator(e),g=e.next();!g.done;g=e.next())g=g.value,this.sendRequest(g.beginChunk*\nthis.chunkSize,Math.min(g.endChunk*this.chunkSize,this.length)).catch(b.reject);return b.promise.catch(function(l){if(!d.aborted)throw l;})};c.getStream=function(){return this.stream};c.requestRange=function(b,d){d=Math.min(d,this.length);b=this.getBeginChunk(b);d=this.getEndChunk(d);for(var e=[];b<d;++b)e.push(b);return this._requestChunks(e)};c.requestRanges=function(b){void 0===b&&(b=[]);var d=[];b=u.makeIterator(b);for(var e=b.next();!e.done;e=b.next()){var g=e.value;e=this.getBeginChunk(g.begin);\nfor(g=this.getEndChunk(g.end);e<g;++e)d.includes(e)||d.push(e)}d.sort(function(f,h){return f-h});return this._requestChunks(d)};c.groupChunks=function(b){for(var d=[],e=-1,g=-1,f=0,h=b.length;f<h;++f){var k=b[f];0>e&&(e=k);0<=g&&g+1!==k&&(d.push({beginChunk:e,endChunk:g+1}),e=k);f+1===b.length&&d.push({beginChunk:e,endChunk:k+1});g=k}return d};c.onProgress=function(b){this.msgHandler.send("DocProgress",{loaded:this.stream.numChunksLoaded*this.chunkSize+b.loaded,total:this.length})};c.onReceiveData=\nfunction(b){var d=b.chunk,e=void 0===b.begin,g=e?this.progressiveDataLength:b.begin,f=g+d.byteLength,h=Math.floor(g/this.chunkSize);b=f<this.length?Math.floor(f/this.chunkSize):Math.ceil(f/this.chunkSize);if(e)this.stream.onReceiveProgressiveData(d),this.progressiveDataLength=f;else this.stream.onReceiveData(g,d);this.stream.isDataLoaded&&this._loadedStreamCapability.resolve(this.stream);d=[];for(e=h;e<b;++e)if(h=this._requestsByChunk.get(e))for(this._requestsByChunk.delete(e),h=u.makeIterator(h),\ng=h.next();!g.done;g=h.next())g=g.value,f=this._chunksNeededByRequest.get(g),f.has(e)&&f.delete(e),0<f.size||d.push(g);if(!this.disableAutoFetch&&0===this._requestsByChunk.size){var k;1===this.stream.numChunksLoaded?(b=this.stream.numChunks-1,this.stream.hasChunk(b)||(k=b)):k=this.stream.nextEmptyChunk(b);Number.isInteger(k)&&this._requestChunks([k])}k=u.makeIterator(d);for(b=k.next();!b.done;b=k.next())b=b.value,d=this._promisesByRequest.get(b),this._promisesByRequest.delete(b),d.resolve();this.msgHandler.send("DocProgress",\n{loaded:this.stream.numChunksLoaded*this.chunkSize,total:this.length})};c.onError=function(b){this._loadedStreamCapability.reject(b)};c.getBeginChunk=function(b){return Math.floor(b/this.chunkSize)};c.getEndChunk=function(b){return Math.floor((b-1)/this.chunkSize)+1};c.abort=function(b){var d;this.aborted=!0;null==(d=this.pdfNetworkStream)||d.cancelAllRequests(b);d=u.makeIterator(this._promisesByRequest.values());for(var e=d.next();!e.done;e=d.next())e.value.reject(b)};return a}();pa(8107);pa(4520);\npa(2712);pa(3609);pa(9479);pa(9202);pa(4594);pa(2134);pa(8345);pa(2577);pa(8872);pa(9469);pa(3690);var ab=function(){function a(b,d){this.name=b;this.numComps=d}var c=a.prototype;c.getRgb=function(b,d){var e=new Uint8ClampedArray(3);this.getRgbItem(b,d,e,0);return e};c.getRgbItem=function(){db("Should not call ColorSpace.getRgbItem")};c.getRgbBuffer=function(){db("Should not call ColorSpace.getRgbBuffer")};c.getOutputLength=function(){db("Should not call ColorSpace.getOutputLength")};c.isPassthrough=\nfunction(){return!1};c.isDefaultDecode=function(b){return a.isDefaultDecode(b,this.numComps)};c.fillRgb=function(b,d,e,g,f,h,k,l,m){var n=d*e,p=null,q=1<<k,r=e!==f||d!==g;if(this.isPassthrough(k))p=l;else if(1===this.numComps&&n>q&&"DeviceGray"!==this.name&&"DeviceRGB"!==this.name){for(var t=8>=k?new Uint8Array(q):new Uint16Array(q),v=0;v<q;v++)t[v]=v;v=new Uint8ClampedArray(3*q);this.getRgbBuffer(t,0,q,v,0,k,0);if(r)for(p=new Uint8Array(3*n),q=k=0;q<n;++q)t=3*l[q],p[k++]=v[t],p[k++]=v[t+1],p[k++]=\nv[t+2];else for(q=k=0;q<n;++q)t=3*l[q],b[k++]=v[t],b[k++]=v[t+1],b[k++]=v[t+2],k+=m}else r?(p=new Uint8ClampedArray(3*n),this.getRgbBuffer(l,0,n,p,0,k,0)):this.getRgbBuffer(l,0,g*h,b,0,k,m);if(p)if(r){m=1!==m?0:m;n=d/g;e/=f;h=0;l=new Uint16Array(g);d*=3;for(r=0;r<g;r++)l[r]=3*Math.floor(r*n);for(r=0;r<f;r++)for(v=Math.floor(r*e)*d,k=0;k<g;k++)n=v+l[k],b[h++]=p[n++],b[h++]=p[n++],b[h++]=p[n++],h+=m}else for(e=d=f=0,g*=h;e<g;e++)b[f++]=p[d++],b[f++]=p[d++],b[f++]=p[d++],f+=m};a._cache=function(b,d,\ne,g){if(!e)throw Error(\'ColorSpace._cache - expected "localColorSpaceCache" argument.\');if(!g)throw Error(\'ColorSpace._cache - expected "parsedColorSpace" argument.\');if(b instanceof Ha){var f=b;b=d.fetch(b)}if(b instanceof ka)var h=b.name;(h||f)&&e.set(h,f,g)};a.getCached=function(b,d,e){if(!e)throw Error(\'ColorSpace.getCached - expected "localColorSpaceCache" argument.\');if(b instanceof Ha){var g=e.getByRef(b);if(g)return g;try{b=d.fetch(b)}catch(f){if(f instanceof ub)throw f;}}return b instanceof\nka&&(b=e.getByName(b.name))?b:null};a.parseAsync=function(){var b=qp(function g(e){var f,h,k,l,m,n,p=this,q;return u.generator.createGenerator(g,function(r){f=e;h=f.cs;k=f.xref;l=void 0===f.resources?null:f.resources;m=f.pdfFunctionFactory;n=f.localColorSpaceCache;q=p._parse(h,k,l,m);p._cache(h,k,n,q);return r.return(q)})});return function(e){return b.apply(this,arguments)}}();a.parse=function(b){var d=b.cs,e=b.xref,g=void 0===b.resources?null:b.resources,f=b.pdfFunctionFactory;b=b.localColorSpaceCache;\nvar h=this.getCached(d,e,b);if(h)return h;g=this._parse(d,e,g,f);this._cache(d,e,b,g);return g};a._parse=function(b,d,e,g){void 0===e&&(e=null);b=d.fetchIfRef(b);if(b instanceof ka)switch(b.name){case "G":case "DeviceGray":return this.singletons.gray;case "RGB":case "DeviceRGB":return this.singletons.rgb;case "DeviceRGBA":return this.singletons.rgba;case "CMYK":case "DeviceCMYK":return this.singletons.cmyk;case "Pattern":return new un(null);default:if(e instanceof ca){var f=e.get("ColorSpace");if(f instanceof\nca&&(f=f.get(b.name))){if(f instanceof ka)return this._parse(f,d,e,g);b=f;break}}T("Unrecognized ColorSpace: "+b.name);return this.singletons.gray}if(Array.isArray(b))switch(f=d.fetchIfRef(b[0]).name,f){case "G":case "DeviceGray":return this.singletons.gray;case "RGB":case "DeviceRGB":return this.singletons.rgb;case "CMYK":case "DeviceCMYK":return this.singletons.cmyk;case "CalGray":return g=d.fetchIfRef(b[1]),b=g.getArray("WhitePoint"),d=g.getArray("BlackPoint"),e=g.get("Gamma"),new lr(b,d,e);case "CalRGB":return g=\nd.fetchIfRef(b[1]),b=g.getArray("WhitePoint"),d=g.getArray("BlackPoint"),e=g.getArray("Gamma"),g=g.getArray("Matrix"),new Id(b,d,e,g);case "ICCBased":var h=d.fetchIfRef(b[1]).dict;f=h.get("N");if(h=h.get("Alternate")){d=this._parse(h,d,e,g);if(d.numComps===f)return d;T("ICCBased color space: Ignoring incorrect /Alternate entry.")}if(1===f)return this.singletons.gray;if(3===f)return this.singletons.rgb;if(4===f)return this.singletons.cmyk;break;case "Pattern":return(h=b[1]||null)&&(h=this._parse(h,\nd,e,g)),new un(h);case "I":case "Indexed":return h=this._parse(b[1],d,e,g),e=Math.max(0,Math.min(d.fetchIfRef(b[2]),255)),b=d.fetchIfRef(b[3]),new mr(h,e,b);case "Separation":case "DeviceN":return f=d.fetchIfRef(b[1]),f=Array.isArray(f)?f.length:1,h=this._parse(b[2],d,e,g),b=g.create(b[3]),new nr(f,h,b);case "Lab":return g=d.fetchIfRef(b[1]),b=g.getArray("WhitePoint"),d=g.getArray("BlackPoint"),e=g.getArray("Range"),new or(b,d,e);default:return T("Unimplemented ColorSpace object: "+f),this.singletons.gray}T("Unrecognized ColorSpace object: "+\nb);return this.singletons.gray};a.isDefaultDecode=function(b,d){if(!Array.isArray(b))return!0;if(2*d!==b.length)return T("The decode map is not the correct length"),!0;d=0;for(var e=b.length;d<e;d+=2)if(0!==b[d]||1!==b[d+1])return!1;return!0};return vk(a,[{key:"usesZeroToOneRange",get:function(){return Fa(this,"usesZeroToOneRange",!0)}}],[{key:"singletons",get:function(){return Fa(this,"singletons",{get gray(){return Fa(this,"gray",new pr)},get rgb(){return Fa(this,"rgb",new qr)},get rgba(){return Fa(this,\n"rgba",new rr)},get cmyk(){return Fa(this,"cmyk",new sr)}})}}])}(),nr=function(a){function c(d,e,g){d=a.call(this,"Alternate",d)||this;d.base=e;d.tintFn=g;d.tmpBuf=new Float32Array(e.numComps);return d}td(c,a);var b=c.prototype;b.getRgbItem=function(d,e,g,f){var h=this.tmpBuf;this.tintFn(d,e,h,0);this.base.getRgbItem(h,0,g,f)};b.getRgbBuffer=function(d,e,g,f,h,k,l){var m=this.tintFn,n=this.base;k=1/((1<<k)-1);var p=n.numComps,q=n.usesZeroToOneRange,r=(n.isPassthrough(8)||!q)&&0===l,t=r?h:0,v=r?f:\nnew Uint8ClampedArray(p*g),w=this.numComps,y=new Float32Array(w),x=new Float32Array(p),z,A;for(z=0;z<g;z++){for(A=0;A<w;A++)y[A]=d[e++]*k;m(y,0,x,0);if(q)for(A=0;A<p;A++)v[t++]=255*x[A];else n.getRgbItem(x,0,v,t),t+=p}r||n.getRgbBuffer(v,0,g,f,h,8,l)};b.getOutputLength=function(d,e){return this.base.getOutputLength(d*this.base.numComps/this.numComps,e)};return c}(ab),un=function(a){function c(b){var d=a.call(this,"Pattern",null)||this;d.base=b;return d}td(c,a);c.prototype.isDefaultDecode=function(){db("Should not call PatternCS.isDefaultDecode")};\nreturn c}(ab),mr=function(a){function c(d,e,g){var f=a.call(this,"Indexed",1)||this;f.base=d;d=d.numComps*(e+1);f.lookup=new Uint8Array(d);if(g instanceof $a)g=g.getBytes(d),f.lookup.set(g);else if("string"===typeof g)for(e=0;e<d;++e)f.lookup[e]=g.charCodeAt(e)&255;else throw new oa("IndexedCS - unrecognized lookup table: "+g);return f}td(c,a);var b=c.prototype;b.getRgbItem=function(d,e,g,f){this.base.getRgbBuffer(this.lookup,d[e]*this.base.numComps,1,g,f,8,0)};b.getRgbBuffer=function(d,e,g,f,h,k,\nl){k=this.base;for(var m=k.numComps,n=k.getOutputLength(m,l),p=this.lookup,q=0;q<g;++q){var r=d[e++]*m;k.getRgbBuffer(p,r,1,f,h,8,l);h+=n}};b.getOutputLength=function(d,e){return this.base.getOutputLength(d*this.base.numComps,e)};b.isDefaultDecode=function(d,e){return Array.isArray(d)?2!==d.length?(T("Decode map length is not correct"),!0):!Number.isInteger(e)||1>e?(T("Bits per component is not correct"),!0):0===d[0]&&d[1]===(1<<e)-1:!0};return c}(ab),pr=function(a){function c(){return a.call(this,\n"DeviceGray",1)||this}td(c,a);var b=c.prototype;b.getRgbItem=function(d,e,g,f){g[f]=g[f+1]=g[f+2]=255*d[e]};b.getRgbBuffer=function(d,e,g,f,h,k,l){k=255/((1<<k)-1);for(var m=0;m<g;++m){var n=k*d[e++];f[h++]=n;f[h++]=n;f[h++]=n;h+=l}};b.getOutputLength=function(d,e){return d*(3+e)};return c}(ab),qr=function(a){function c(){return a.call(this,"DeviceRGB",3)||this}td(c,a);var b=c.prototype;b.getRgbItem=function(d,e,g,f){g[f]=255*d[e];g[f+1]=255*d[e+1];g[f+2]=255*d[e+2]};b.getRgbBuffer=function(d,e,g,\nf,h,k,l){if(8===k&&0===l)f.set(d.subarray(e,e+3*g),h);else{k=255/((1<<k)-1);for(var m=0;m<g;++m)f[h++]=k*d[e++],f[h++]=k*d[e++],f[h++]=k*d[e++],h+=l}};b.getOutputLength=function(d,e){return d*(3+e)/3|0};b.isPassthrough=function(d){return 8===d};return c}(ab),rr=function(a){function c(){return a.call(this,"DeviceRGBA",4)||this}td(c,a);var b=c.prototype;b.getOutputLength=function(d){return 4*d};b.isPassthrough=function(d){return 8===d};b.fillRgb=function(d,e,g,f,h,k,l,m,n){if(g!==h||e!==f){var p=e/\nf;g/=h;k=0;l=new Uint16Array(f);if(1===n){for(n=0;n<f;n++)l[n]=Math.floor(n*p);m=new Uint32Array(m.buffer);d=new Uint32Array(d.buffer);p=id.isLittleEndian?16777215:4294967040;for(n=0;n<h;n++)for(var q=m.subarray(Math.floor(n*g)*e),r=0;r<f;r++)d[k++]|=q[l[r]]&p}else{e*=4;for(n=0;n<f;n++)l[n]=4*Math.floor(n*p);for(p=0;p<h;p++)for(n=m.subarray(Math.floor(p*g)*e),q=0;q<f;q++)r=l[q],d[k++]=n[r],d[k++]=n[r+1],d[k++]=n[r+2]}}else if(1===n)for(f=new Uint32Array(m.buffer),h=new Uint32Array(d.buffer),d=id.isLittleEndian?\n16777215:4294967040,m=0,g=f.length;m<g;m++)h[m]|=f[m]&d;else for(h=f=0,g=m.length;h<g;h+=4)d[f++]=m[h],d[f++]=m[h+1],d[f++]=m[h+2]};return c}(ab),sr=function(a){function c(){return a.call(this,"DeviceCMYK",4)||this}td(c,a);var b=c.prototype;b.__toRgb=function(d,e,g,f,h){var k=d[e]*g,l=d[e+1]*g,m=d[e+2]*g;d=d[e+3]*g;f[h]=255+k*(-4.387332384609988*k+54.48615194189176*l+18.82290502165302*m+212.25662451639585*d+-285.2331026137004)+l*(1.7149763477362134*l-5.6096736904047315*m+-17.873870861415444*d-5.497006427196366)+\nm*(-2.5217340131683033*m-21.248923337353073*d+17.5119270841813)+d*(-21.86122147463605*d-189.48180835922747);f[h+1]=255+k*(8.841041422036149*k+60.118027045597366*l+6.871425592049007*m+31.159100130055922*d+-79.2970844816548)+l*(-15.310361306967817*l+17.575251261109482*m+131.35250912493976*d-190.9453302588951)+m*(4.444339102852739*m+9.8632861493405*d-24.86741582555878)+d*(-20.737325471181034*d-187.80453709719578);f[h+2]=255+k*(.8842522430003296*k+8.078677503112928*l+30.89978309703729*m-.23883238689178934*\nd+-14.183576799673286)+l*(10.49593273432072*l+63.02378494754052*m+50.606957656360734*d-112.23884253719248)+m*(.03296041114873217*m+115.60384449646641*d+-193.58209356861505)+d*(-22.33816807309886*d-180.12613974708367)};b.getRgbItem=function(d,e,g,f){this.__toRgb(d,e,1,g,f)};b.getRgbBuffer=function(d,e,g,f,h,k,l){k=1/((1<<k)-1);for(var m=0;m<g;m++)this.__toRgb(d,e,k,f,h),e+=4,h+=3+l};b.getOutputLength=function(d,e){return d/4*(3+e)|0};return c}(ab),lr=function(a){function c(d,e,g){var f=a.call(this,\n"CalGray",1)||this;if(!d)throw new oa("WhitePoint missing - required for color space CalGray");d=u.makeIterator(d);f.XW=d.next().value;f.YW=d.next().value;f.ZW=d.next().value;e=u.makeIterator(e||[0,0,0]);f.XB=e.next().value;f.YB=e.next().value;f.ZB=e.next().value;f.G=g||1;if(0>f.XW||0>f.ZW||1!==f.YW)throw new oa("Invalid WhitePoint components for "+f.name+", no fallback available");if(0>f.XB||0>f.YB||0>f.ZB)Ya("Invalid BlackPoint for "+f.name+", falling back to default."),f.XB=f.YB=f.ZB=0;0===f.XB&&\n0===f.YB&&0===f.ZB||T(f.name+", BlackPoint: XB: "+f.XB+", YB: "+f.YB+", ZB: "+(f.ZB+", only default values are supported."));1>f.G&&(Ya("Invalid Gamma: "+f.G+" for "+f.name+", falling back to default."),f.G=1);return f}td(c,a);var b=c.prototype;b.__toRgb=function(d,e,g,f,h){d=Math.max(295.8*Math.pow(this.YW*Math.pow(d[e]*h,this.G),.3333333333333333)-40.8,0);g[f]=d;g[f+1]=d;g[f+2]=d};b.getRgbItem=function(d,e,g,f){this.__toRgb(d,e,g,f,1)};b.getRgbBuffer=function(d,e,g,f,h,k,l){k=1/((1<<k)-1);for(var m=\n0;m<g;++m)this.__toRgb(d,e,f,h,k),e+=1,h+=3+l};b.getOutputLength=function(d,e){return d*(3+e)};return c}(ab),Id=function(a){function c(d,e,g,f){var h=a.call(this,"CalRGB",3)||this;if(!d)throw new oa("WhitePoint missing - required for color space CalRGB");var k=u.makeIterator(h.whitePoint=d);d=k.next().value;var l=k.next().value;k=k.next().value;var m=u.makeIterator(h.blackPoint=e||new Float32Array(3));e=m.next().value;var n=m.next().value;m=m.next().value;g=u.makeIterator(g||new Float32Array([1,1,\n1]));h.GR=g.next().value;h.GG=g.next().value;h.GB=g.next().value;f=u.makeIterator(f||new Float32Array([1,0,0,0,1,0,0,0,1]));h.MXA=f.next().value;h.MYA=f.next().value;h.MZA=f.next().value;h.MXB=f.next().value;h.MYB=f.next().value;h.MZB=f.next().value;h.MXC=f.next().value;h.MYC=f.next().value;h.MZC=f.next().value;if(0>d||0>k||1!==l)throw new oa("Invalid WhitePoint components for "+h.name+", no fallback available");if(0>e||0>n||0>m)Ya("Invalid BlackPoint for "+h.name+" ["+e+", "+n+", "+m+"], falling back to default."),\nh.blackPoint=new Float32Array(3);if(0>h.GR||0>h.GG||0>h.GB)Ya("Invalid Gamma ["+h.GR+", "+h.GG+", "+h.GB+"] for "+(h.name+", falling back to default.")),h.GR=h.GG=h.GB=1;return h}td(c,a);var b=c.prototype;b.__matrixProduct=function(d,e,g){g[0]=d[0]*e[0]+d[1]*e[1]+d[2]*e[2];g[1]=d[3]*e[0]+d[4]*e[1]+d[5]*e[2];g[2]=d[6]*e[0]+d[7]*e[1]+d[8]*e[2]};b.__toFlat=function(d,e,g){g[0]=1*e[0]/d[0];g[1]=1*e[1]/d[1];g[2]=1*e[2]/d[2]};b.__toD65=function(d,e,g){g[0]=.95047*e[0]/d[0];g[1]=1*e[1]/d[1];g[2]=1.08883*\ne[2]/d[2]};b.__sRGBTransferFunction=function(d){return.0031308>=d?this.__adjustToRange(0,1,12.92*d):.99554525<=d?1:this.__adjustToRange(0,1,1.055*Math.pow(d,1/2.4)-.055)};b.__adjustToRange=function(d,e,g){return Math.max(d,Math.min(e,g))};b.__decodeL=function(d){return 0>d?-this.__decodeL(-d):8<d?Math.pow((d+16)/116,3):d*c.__DECODE_L_CONSTANT};b.__compensateBlackPoint=function(d,e,g){if(0===d[0]&&0===d[1]&&0===d[2])g[0]=e[0],g[1]=e[1],g[2]=e[2];else{var f=this.__decodeL(0),h=this.__decodeL(d[0]),\nk=this.__decodeL(d[1]);d=this.__decodeL(d[2]);h=(1-f)/(1-h);k=(1-f)/(1-k);f=(1-f)/(1-d);g[0]=e[0]*h+(1-h);g[1]=e[1]*k+(1-k);g[2]=e[2]*f+(1-f)}};b.__normalizeWhitePointToFlat=function(d,e,g){1===d[0]&&1===d[2]?(g[0]=e[0],g[1]=e[1],g[2]=e[2]):(this.__matrixProduct(c.__BRADFORD_SCALE_MATRIX,e,g),e=c.__tempNormalizeMatrix,this.__toFlat(d,g,e),this.__matrixProduct(c.__BRADFORD_SCALE_INVERSE_MATRIX,e,g))};b.__normalizeWhitePointToD65=function(d,e,g){this.__matrixProduct(c.__BRADFORD_SCALE_MATRIX,e,g);e=\nc.__tempNormalizeMatrix;this.__toD65(d,g,e);this.__matrixProduct(c.__BRADFORD_SCALE_INVERSE_MATRIX,e,g)};b.__toRgb=function(d,e,g,f,h){var k=this.__adjustToRange(0,1,d[e]*h),l=this.__adjustToRange(0,1,d[e+1]*h);d=this.__adjustToRange(0,1,d[e+2]*h);k=1===k?1:Math.pow(k,this.GR);l=1===l?1:Math.pow(l,this.GG);e=1===d?1:Math.pow(d,this.GB);h=this.MYA*k+this.MYB*l+this.MYC*e;var m=this.MZA*k+this.MZB*l+this.MZC*e;d=c.__tempConvertMatrix1;d[0]=this.MXA*k+this.MXB*l+this.MXC*e;d[1]=h;d[2]=m;k=c.__tempConvertMatrix2;\nthis.__normalizeWhitePointToFlat(this.whitePoint,d,k);l=c.__tempConvertMatrix1;this.__compensateBlackPoint(this.blackPoint,k,l);k=c.__tempConvertMatrix2;this.__normalizeWhitePointToD65(c.__FLAT_WHITEPOINT_MATRIX,l,k);l=c.__tempConvertMatrix1;this.__matrixProduct(c.__SRGB_D65_XYZ_TO_RGB_MATRIX,k,l);g[f]=255*this.__sRGBTransferFunction(l[0]);g[f+1]=255*this.__sRGBTransferFunction(l[1]);g[f+2]=255*this.__sRGBTransferFunction(l[2])};b.getRgbItem=function(d,e,g,f){this.__toRgb(d,e,g,f,1)};b.getRgbBuffer=\nfunction(d,e,g,f,h,k,l){k=1/((1<<k)-1);for(var m=0;m<g;++m)this.__toRgb(d,e,f,h,k),e+=3,h+=3+l};b.getOutputLength=function(d,e){return d*(3+e)/3|0};return c}(ab);Id.__BRADFORD_SCALE_MATRIX=new Float32Array([.8951,.2664,-.1614,-.7502,1.7135,.0367,.0389,-.0685,1.0296]);Id.__BRADFORD_SCALE_INVERSE_MATRIX=new Float32Array([.9869929,-.1470543,.1599627,.4323053,.5183603,.0492912,-.0085287,.0400428,.9684867]);Id.__SRGB_D65_XYZ_TO_RGB_MATRIX=new Float32Array([3.2404542,-1.5371385,-.4985314,-.969266,1.8760108,\n.041556,.0556434,-.2040259,1.0572252]);Id.__FLAT_WHITEPOINT_MATRIX=new Float32Array([1,1,1]);Id.__tempNormalizeMatrix=new Float32Array(3);Id.__tempConvertMatrix1=new Float32Array(3);Id.__tempConvertMatrix2=new Float32Array(3);Id.__DECODE_L_CONSTANT=Math.pow(24/116,3)/8;var or=function(a){function c(d,e,g){var f=a.call(this,"Lab",3)||this;if(!d)throw new oa("WhitePoint missing - required for color space Lab");d=u.makeIterator(d);f.XW=d.next().value;f.YW=d.next().value;f.ZW=d.next().value;g=u.makeIterator(g||\n[-100,100,-100,100]);f.amin=g.next().value;f.amax=g.next().value;f.bmin=g.next().value;f.bmax=g.next().value;e=u.makeIterator(e||[0,0,0]);f.XB=e.next().value;f.YB=e.next().value;f.ZB=e.next().value;if(0>f.XW||0>f.ZW||1!==f.YW)throw new oa("Invalid WhitePoint components, no fallback available");if(0>f.XB||0>f.YB||0>f.ZB)Ya("Invalid BlackPoint, falling back to default"),f.XB=f.YB=f.ZB=0;if(f.amin>f.amax||f.bmin>f.bmax)Ya("Invalid Range, falling back to defaults"),f.amin=-100,f.amax=100,f.bmin=-100,\nf.bmax=100;return f}td(c,a);var b=c.prototype;b.__fn_g=function(d){return d>=6/29?Math.pow(d,3):108/841*(d-4/29)};b.__decode=function(d,e,g,f){return g+d*(f-g)/e};b.__toRgb=function(d,e,g,f,h){var k=d[e],l=d[e+1];d=d[e+2];!1!==g&&(k=this.__decode(k,g,0,100),l=this.__decode(l,g,this.amin,this.amax),d=this.__decode(d,g,this.bmin,this.bmax));l>this.amax?l=this.amax:l<this.amin&&(l=this.amin);d>this.bmax?d=this.bmax:d<this.bmin&&(d=this.bmin);g=(k+16)/116;k=g-d/200;l=this.XW*this.__fn_g(g+l/500);g=this.YW*\nthis.__fn_g(g);e=this.ZW*this.__fn_g(k);1>this.ZW?(k=3.1339*l+-1.617*g+-.4906*e,d=-.9785*l+1.916*g+.0333*e,l=.072*l+-.229*g+1.4057*e):(k=3.2406*l+-1.5372*g+-.4986*e,d=-.9689*l+1.8758*g+.0415*e,l=.0557*l+-.204*g+1.057*e);f[h]=255*Math.sqrt(k);f[h+1]=255*Math.sqrt(d);f[h+2]=255*Math.sqrt(l)};b.getRgbItem=function(d,e,g,f){this.__toRgb(d,e,!1,g,f)};b.getRgbBuffer=function(d,e,g,f,h,k,l){k=(1<<k)-1;for(var m=0;m<g;m++)this.__toRgb(d,e,k,f,h),e+=3,h+=3+l};b.getOutputLength=function(d,e){return d*(3+e)/\n3|0};b.isDefaultDecode=function(){return!0};return vk(c,[{key:"usesZeroToOneRange",get:function(){return Fa(this,"usesZeroToOneRange",!1)}}])}(ab),tr=function(){function a(b){this.buffer=b;this.pos=0;this.end=b.length;this.tmpBuf=new Uint8Array(19)}var c=a.prototype;c.readByte=function(){return this.pos>=this.end?-1:this.buffer[this.pos++]};c.readNumber=function(){var b=0;do{var d=this.readByte();if(0>d)throw new oa("unexpected EOF in bcmap");var e=!(d&128);b=b<<7|d&127}while(!e);return b};c.readSigned=\nfunction(){var b=this.readNumber();return b&1?~(b>>>1):b>>>1};c.readHex=function(b,d){b.set(this.buffer.subarray(this.pos,this.pos+d+1));this.pos+=d+1};c.readHexNumber=function(b,d){var e=this.tmpBuf,g=0;do{var f=this.readByte();if(0>f)throw new oa("unexpected EOF in bcmap");var h=!(f&128);e[g++]=f&127}while(!h);for(f=h=0;0<=d;){for(;8>f&&0<e.length;)h|=e[--g]<<f,f+=7;b[d]=h&255;d--;h>>=8;f-=8}};c.readHexSigned=function(b,d){this.readHexNumber(b,d);for(var e=b[d]&1?255:0,g=0,f=0;f<=d;f++)g=(g&1)<<\n8|b[f],b[f]=g>>1^e};c.readString=function(){for(var b=this.readNumber(),d=Array(b),e=0;e<b;e++)d[e]=this.readNumber();return String.fromCharCode.apply(String,u.arrayFromIterable(d))};return a}(),Xp=function(){function a(){}a.prototype.process=function(){var c=rp(function f(d,e,g){var h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G;return u.generator.createGenerator(f,function(J){h=new tr(d);k=h.readByte();e.vertical=!!(k&1);l=null;m=new Uint8Array(16);n=new Uint8Array(16);p=new Uint8Array(16);q=new Uint8Array(16);\nfor(r=new Uint8Array(16);0<=(v=h.readByte());)if(w=v>>5,7===w)switch(v&31){case 0:h.readString();break;case 1:l=h.readString()}else{y=!!(v&16);x=v&15;if(16<x+1)throw Error("BinaryCMapReader.process: Invalid dataSize.");z=h.readNumber();switch(w){case 0:h.readHex(m,x);h.readHexNumber(n,x);zc(n,m,x);e.addCodespaceRange(x+1,nc(m,x),nc(n,x));for(A=1;A<z;A++)fe(n,x),h.readHexNumber(m,x),zc(m,n,x),h.readHexNumber(n,x),zc(n,m,x),e.addCodespaceRange(x+1,nc(m,x),nc(n,x));break;case 1:h.readHex(m,x);h.readHexNumber(n,\nx);zc(n,m,x);h.readNumber();for(B=1;B<z;B++)fe(n,x),h.readHexNumber(m,x),zc(m,n,x),h.readHexNumber(n,x),zc(n,m,x),h.readNumber();break;case 2:h.readHex(p,x);t=h.readNumber();e.mapOne(nc(p,x),t);for(C=1;C<z;C++)fe(p,x),y||(h.readHexNumber(r,x),zc(p,r,x)),t=h.readSigned()+(t+1),e.mapOne(nc(p,x),t);break;case 3:h.readHex(m,x);h.readHexNumber(n,x);zc(n,m,x);t=h.readNumber();e.mapCidRange(nc(m,x),nc(n,x),t);for(D=1;D<z;D++)fe(n,x),y?m.set(n):(h.readHexNumber(m,x),zc(m,n,x)),h.readHexNumber(n,x),zc(n,m,\nx),t=h.readNumber(),e.mapCidRange(nc(m,x),nc(n,x),t);break;case 4:h.readHex(p,1);h.readHex(q,x);e.mapOne(nc(p,1),cg(q,x));for(E=1;E<z;E++)fe(p,1),y||(h.readHexNumber(r,1),zc(p,r,1)),fe(q,x),h.readHexSigned(r,x),zc(q,r,x),e.mapOne(nc(p,1),cg(q,x));break;case 5:h.readHex(m,1);h.readHexNumber(n,1);zc(n,m,1);h.readHex(q,x);e.mapBfRange(nc(m,1),nc(n,1),cg(q,x));for(G=1;G<z;G++)fe(n,1),y?m.set(n):(h.readHexNumber(m,1),zc(m,n,1)),h.readHexNumber(n,1),zc(n,m,1),h.readHex(q,x),e.mapBfRange(nc(m,1),nc(n,1),\ncg(q,x));break;default:throw Error("BinaryCMapReader.process - unknown type: "+w);}}return l?J.return(g(l)):J.return(e)})});return function(d,e,g){return c.apply(this,arguments)}}();return a}(),ur=new Uint8Array(0),uc=function(a){function c(d){var e=a.call(this)||this;e._rawMinBufferLength=d||0;e.pos=0;e.bufferLength=0;e.eof=!1;e.buffer=ur;e.minBufferLength=512;if(d)for(;e.minBufferLength<d;)e.minBufferLength*=2;return e}zk(c,a);var b=c.prototype;b.ensureBuffer=function(d){var e=this.buffer;if(d<=\ne.byteLength)return e;for(var g=this.minBufferLength;g<d;)g*=2;d=new Uint8Array(g);d.set(e);return this.buffer=d};b.getByte=function(){for(var d=this.pos;this.bufferLength<=d;){if(this.eof)return-1;this.readBlock()}return this.buffer[this.pos++]};b.getBytes=function(d,e){void 0===e&&(e=null);var g=this.pos;if(d){this.ensureBuffer(g+d);for(d=g+d;!this.eof&&this.bufferLength<d;)this.readBlock(e);e=this.bufferLength;d>e&&(d=e)}else{for(;!this.eof;)this.readBlock(e);d=this.bufferLength}this.pos=d;return this.buffer.subarray(g,\nd)};b.getImageData=function(){var d=sp(function h(g,f){var k=this,l;return u.generator.createGenerator(h,function(m){if(1==m.nextAddress)return void 0===f&&(f=null),k.canAsyncDecodeImageFromBuffer?m.yield(k.stream.asyncGetBytes(),2):m.return(k.getBytes(g,f));l=m.yieldResult;return m.return(k.decodeImage(l,f))})});return function(g,f){return d.apply(this,arguments)}}();b.reset=function(){this.pos=0};b.makeSubStream=function(d,e,g){void 0===g&&(g=null);if(void 0===e)for(;!this.eof;)this.readBlock();\nelse for(var f=d+e;this.bufferLength<=f&&!this.eof;)this.readBlock();return new Mb(this.buffer,d,e,g)};b.getBaseStreams=function(){return this.str?this.str.getBaseStreams():null};return tp(c,[{key:"isEmpty",get:function(){for(;!this.eof&&0===this.bufferLength;)this.readBlock();return 0===this.bufferLength}}])}($a),vr=function(a){function c(d,e){void 0===e&&(e=null);d=d.filter(function(k){return k instanceof $a});var g=0;for(var f=u.makeIterator(d),h=f.next();!h.done;h=f.next())h=h.value,g+=h instanceof\nuc?h._rawMinBufferLength:h.length;g=a.call(this,g)||this;g.streams=d;g._onError=e;return g}zk(c,a);var b=c.prototype;b.readBlock=function(){var d=this.streams;if(0===d.length)this.eof=!0;else{d=d.shift();try{var e=d.getBytes()}catch(f){if(this._onError){var g;this._onError(f,null==(g=d.dict)?void 0:g.objId);return}throw f;}g=this.bufferLength;d=g+e.length;this.ensureBuffer(d).set(e,g);this.bufferLength=d}};b.getBaseStreams=function(){for(var d=[],e=u.makeIterator(this.streams),g=e.next();!g.done;g=\ne.next())(g=g.value.getBaseStreams())&&d.push.apply(d,u.arrayFromIterable(g));return 0<d.length?d:null};return c}(uc),wr=function(a){function c(b,d){d&&(d*=.8);d=a.call(this,d)||this;d.str=b;d.dict=b.dict;d.input=new Uint8Array(5);return d}up(c,a);c.prototype.readBlock=function(){for(var b=this.str,d=b.getByte();Lc(d);)d=b.getByte();if(-1===d||126===d)this.eof=!0;else{var e=this.bufferLength,g;if(122===d){b=this.ensureBuffer(e+4);for(g=0;4>g;++g)b[e+g]=0;this.bufferLength+=4}else{var f=this.input;\nf[0]=d;for(g=1;5>g;++g){for(d=b.getByte();Lc(d);)d=b.getByte();f[g]=d;if(-1===d||126===d)break}b=this.ensureBuffer(e+g-1);this.bufferLength+=g-1;if(5>g){for(;5>g;++g)f[g]=117;this.eof=!0}for(g=d=0;5>g;++g)d=85*d+(f[g]-33);for(g=3;0<=g;--g)b[e+g]=d&255,d>>=8}}};return c}(uc),xr=function(a){function c(b,d){d&&(d*=.5);d=a.call(this,d)||this;d.str=b;d.dict=b.dict;d.firstDigit=-1;return d}vp(c,a);c.prototype.readBlock=function(){var b=this.str.getBytes(8E3);if(b.length){var d=this.ensureBuffer(this.bufferLength+\n(b.length+1>>1)),e=this.bufferLength,g=this.firstDigit;b=u.makeIterator(b);for(var f=b.next();!f.done;f=b.next()){f=f.value;if(48<=f&&57>=f)f&=15;else if(65<=f&&70>=f||97<=f&&102>=f)f=(f&15)+9;else if(62===f){this.eof=!0;break}else continue;0>g?g=f:(d[e++]=g<<4|f,g=-1)}0<=g&&this.eof&&(d[e++]=g<<4,g=-1);this.firstDigit=g;this.bufferLength=e}else this.eof=!0};return c}(uc),vn=[[-1,-1],[-1,-1],[7,8],[7,7],[6,6],[6,6],[6,5],[6,5],[4,0],[4,0],[4,0],[4,0],[4,0],[4,0],[4,0],[4,0],[3,1],[3,1],[3,1],[3,1],\n[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[3,3],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,\n2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2],[1,2]],wn=[[-1,-1],[12,-2],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[11,1792],[11,1792],[12,1984],[12,2048],[12,2112],[12,2176],[12,2240],[12,2304],[11,1856],[11,1856],[11,1920],[11,1920],[12,2368],[12,2432],[12,2496],[12,2560]],xn=[[-1,-1],[-1,-1],[-1,-1],[-1,-1],[8,29],[8,29],[8,30],[8,\n30],[8,45],[8,45],[8,46],[8,46],[7,22],[7,22],[7,22],[7,22],[7,23],[7,23],[7,23],[7,23],[8,47],[8,47],[8,48],[8,48],[6,13],[6,13],[6,13],[6,13],[6,13],[6,13],[6,13],[6,13],[7,20],[7,20],[7,20],[7,20],[8,33],[8,33],[8,34],[8,34],[8,35],[8,35],[8,36],[8,36],[8,37],[8,37],[8,38],[8,38],[7,19],[7,19],[7,19],[7,19],[8,31],[8,31],[8,32],[8,32],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[6,12],[6,12],[6,12],[6,12],[6,12],[6,12],[6,12],[6,12],[8,53],[8,53],[8,54],[8,54],[7,26],[7,26],[7,26],[7,26],[8,\n39],[8,39],[8,40],[8,40],[8,41],[8,41],[8,42],[8,42],[8,43],[8,43],[8,44],[8,44],[7,21],[7,21],[7,21],[7,21],[7,28],[7,28],[7,28],[7,28],[8,61],[8,61],[8,62],[8,62],[8,63],[8,63],[8,0],[8,0],[8,320],[8,320],[8,384],[8,384],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,10],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[5,11],[7,27],[7,27],[7,27],[7,27],[8,59],[8,59],[8,60],[8,60],\n[9,1472],[9,1536],[9,1600],[9,1728],[7,18],[7,18],[7,18],[7,18],[7,24],[7,24],[7,24],[7,24],[8,49],[8,49],[8,50],[8,50],[8,51],[8,51],[8,52],[8,52],[7,25],[7,25],[7,25],[7,25],[8,55],[8,55],[8,56],[8,56],[8,57],[8,57],[8,58],[8,58],[6,192],[6,192],[6,192],[6,192],[6,192],[6,192],[6,192],[6,192],[6,1664],[6,1664],[6,1664],[6,1664],[6,1664],[6,1664],[6,1664],[6,1664],[8,448],[8,448],[8,512],[8,512],[9,704],[9,768],[8,640],[8,640],[8,576],[8,576],[9,832],[9,896],[9,960],[9,1024],[9,1088],[9,1152],[9,\n1216],[9,1280],[9,1344],[9,1408],[7,256],[7,256],[7,256],[7,256],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[5,128],[5,128],[5,128],[5,128],[5,128],[5,128],[5,128],\n[5,128],[5,128],[5,128],[5,128],[5,128],[5,128],[5,128],[5,128],[5,128],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,8],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[5,9],[6,16],[6,16],[6,16],[6,16],[6,16],[6,16],[6,16],[6,16],[6,17],[6,17],[6,17],[6,17],[6,17],[6,17],[6,17],[6,17],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],\n[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,4],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[4,5],[6,14],[6,14],[6,14],[6,14],[6,14],[6,14],[6,14],[6,14],[6,15],[6,15],[6,15],[6,15],[6,15],[6,15],[6,15],[6,15],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[5,64],[4,6],[4,6],[4,6],[4,\n6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,6],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7],[4,7]],yn=[[-1,-1],[-1,-1],[12,-2],[12,-2],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],\n[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[-1,-1],[11,1792],[11,1792],[11,1792],[11,1792],[12,1984],[12,1984],[12,2048],[12,2048],[12,2112],[12,2112],[12,2176],[12,2176],[12,2240],[12,2240],[12,2304],[12,2304],[11,1856],[11,1856],[11,1856],[11,1856],[11,1920],[11,1920],[11,1920],[11,1920],[12,2368],[12,2368],[12,2432],[12,2432],[12,2496],[12,2496],[12,2560],[12,2560],[10,18],[10,18],[10,18],[10,18],[10,18],[10,18],[10,18],[10,18],\n[12,52],[12,52],[13,640],[13,704],[13,768],[13,832],[12,55],[12,55],[12,56],[12,56],[13,1280],[13,1344],[13,1408],[13,1472],[12,59],[12,59],[12,60],[12,60],[13,1536],[13,1600],[11,24],[11,24],[11,24],[11,24],[11,25],[11,25],[11,25],[11,25],[13,1664],[13,1728],[12,320],[12,320],[12,384],[12,384],[12,448],[12,448],[13,512],[13,576],[12,53],[12,53],[12,54],[12,54],[13,896],[13,960],[13,1024],[13,1088],[13,1152],[13,1216],[10,64],[10,64],[10,64],[10,64],[10,64],[10,64],[10,64],[10,64]],zn=[[8,13],[8,\n13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[8,13],[11,23],[11,23],[12,50],[12,51],[12,44],[12,45],[12,46],[12,47],[12,57],[12,58],[12,61],[12,256],[10,16],[10,16],[10,16],[10,16],[10,17],[10,17],[10,17],[10,17],[12,48],[12,49],[12,62],[12,63],[12,30],[12,31],[12,32],[12,33],[12,40],[12,41],[11,22],[11,22],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[8,14],[7,10],[7,10],[7,10],[7,10],[7,\n10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,10],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[7,11],[9,15],[9,15],[9,15],[9,15],[9,15],[9,15],[9,15],[9,15],[12,128],[12,192],[12,26],[12,\n27],[12,28],[12,29],[11,19],[11,19],[11,20],[11,20],[12,34],[12,35],[12,36],[12,37],[12,38],[12,39],[11,21],[11,21],[12,42],[12,43],[10,0],[10,0],[10,0],[10,0],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12],[7,12]],An=[[-1,-1],[-1,-1],[-1,-1],[-1,-1],[6,9],[6,8],[5,7],[5,7],[4,6],[4,6],[4,6],[4,6],[4,5],[4,5],[4,5],[4,5],[3,1],[3,\n1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,1],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[3,4],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,3],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2],[2,2]],Ik=function(){function a(b,d){var e;void 0===d&&(d={});if(!b||"function"!==typeof b.next)throw Error(\'CCITTFaxDecoder - invalid "source" parameter.\');this.source=b;this.eof=!1;this.encoding=d.K||0;this.eoline=d.EndOfLine||\n!1;this.byteAlign=d.EncodedByteAlign||!1;this.columns=d.Columns||1728;this.rows=d.Rows||0;this.eoblock=null!=(e=d.EndOfBlock)?e:!0;this.black=d.BlackIs1||!1;this.codingLine=new Uint32Array(this.columns+1);this.refLine=new Uint32Array(this.columns+2);this.codingLine[0]=this.columns;this.row=this.codingPos=0;this.nextLine2D=0>this.encoding;this.outputBits=this.inputBuf=this.inputBits=0;for(this.rowsDone=!1;0===(b=this._lookBits(12));)this._eatBits(1);1===b&&this._eatBits(12);0<this.encoding&&(this.nextLine2D=\n!this._lookBits(1),this._eatBits(1))}var c=a.prototype;c.readNextChar=function(){if(this.eof)return-1;var b=this.refLine,d=this.codingLine,e=this.columns,g,f;if(0===this.outputBits){this.rowsDone&&(this.eof=!0);if(this.eof)return-1;this.err=!1;var h,k;if(this.nextLine2D){for(g=0;d[g]<e;++g)b[g]=d[g];b[g++]=e;b[g]=e;for(f=g=this.codingPos=d[0]=0;d[this.codingPos]<e;){var l=this._getTwoDimCode();switch(l){case 0:this._addPixels(b[g+1],f);b[g+1]<e&&(g+=2);break;case 1:l=h=0;if(f){do l+=k=this._getBlackCode();\nwhile(64<=k);do h+=k=this._getWhiteCode();while(64<=k)}else{do l+=k=this._getWhiteCode();while(64<=k);do h+=k=this._getBlackCode();while(64<=k)}this._addPixels(d[this.codingPos]+l,f);for(d[this.codingPos]<e&&this._addPixels(d[this.codingPos]+h,f^1);b[g]<=d[this.codingPos]&&b[g]<e;)g+=2;break;case 7:this._addPixels(b[g]+3,f);f^=1;if(d[this.codingPos]<e)for(++g;b[g]<=d[this.codingPos]&&b[g]<e;)g+=2;break;case 5:this._addPixels(b[g]+2,f);f^=1;if(d[this.codingPos]<e)for(++g;b[g]<=d[this.codingPos]&&b[g]<\ne;)g+=2;break;case 3:this._addPixels(b[g]+1,f);f^=1;if(d[this.codingPos]<e)for(++g;b[g]<=d[this.codingPos]&&b[g]<e;)g+=2;break;case 2:this._addPixels(b[g],f);f^=1;if(d[this.codingPos]<e)for(++g;b[g]<=d[this.codingPos]&&b[g]<e;)g+=2;break;case 8:this._addPixelsNeg(b[g]-3,f);f^=1;if(d[this.codingPos]<e)for(0<g?--g:++g;b[g]<=d[this.codingPos]&&b[g]<e;)g+=2;break;case 6:this._addPixelsNeg(b[g]-2,f);f^=1;if(d[this.codingPos]<e)for(0<g?--g:++g;b[g]<=d[this.codingPos]&&b[g]<e;)g+=2;break;case 4:this._addPixelsNeg(b[g]-\n1,f);f^=1;if(d[this.codingPos]<e)for(0<g?--g:++g;b[g]<=d[this.codingPos]&&b[g]<e;)g+=2;break;case -1:this._addPixels(e,0);this.eof=!0;break;default:Ya("bad 2d code"),this._addPixels(e,0),this.err=!0}}}else for(f=this.codingPos=d[0]=0;d[this.codingPos]<e;){l=0;if(f){do l+=k=this._getBlackCode();while(64<=k)}else{do l+=k=this._getWhiteCode();while(64<=k)}this._addPixels(d[this.codingPos]+l,f);f^=1}b=!1;this.byteAlign&&(this.inputBits&=-8);if(this.eoblock||this.row!==this.rows-1){l=this._lookBits(12);\nif(this.eoline)for(;-1!==l&&1!==l;)this._eatBits(1),l=this._lookBits(12);else for(;0===l;)this._eatBits(1),l=this._lookBits(12);1===l?(this._eatBits(12),b=!0):-1===l&&(this.eof=!0)}else this.rowsDone=!0;!this.eof&&0<this.encoding&&!this.rowsDone&&(this.nextLine2D=!this._lookBits(1),this._eatBits(1));if(this.eoblock&&b&&this.byteAlign){if(l=this._lookBits(12),1===l){this._eatBits(12);0<this.encoding&&(this._lookBits(1),this._eatBits(1));if(0<=this.encoding)for(g=0;4>g;++g)l=this._lookBits(12),1!==\nl&&Ya("bad rtc code: "+l),this._eatBits(12),0<this.encoding&&(this._lookBits(1),this._eatBits(1));this.eof=!0}}else if(this.err&&this.eoline){for(;;){l=this._lookBits(13);if(-1===l)return this.eof=!0,-1;if(1===l>>1)break;this._eatBits(1)}this._eatBits(12);0<this.encoding&&(this._eatBits(1),this.nextLine2D=!(l&1))}this.outputBits=0<d[0]?d[this.codingPos=0]:d[this.codingPos=1];this.row++}if(8<=this.outputBits)b=this.codingPos&1?0:255,this.outputBits-=8,0===this.outputBits&&d[this.codingPos]<e&&(this.codingPos++,\nthis.outputBits=d[this.codingPos]-d[this.codingPos-1]);else{l=8;b=0;do{if("number"!==typeof this.outputBits)throw new oa(\'Invalid /CCITTFaxDecode data, "outputBits" must be a number.\');this.outputBits>l?(b<<=l,this.codingPos&1||(b|=255>>8-l),this.outputBits-=l,l=0):(b<<=this.outputBits,this.codingPos&1||(b|=255>>8-this.outputBits),l-=this.outputBits,this.outputBits=0,d[this.codingPos]<e?(this.codingPos++,this.outputBits=d[this.codingPos]-d[this.codingPos-1]):0<l&&(b<<=l,l=0))}while(l)}this.black&&\n(b^=255);return b};c._addPixels=function(b,d){var e=this.codingLine,g=this.codingPos;b>e[g]&&(b>this.columns&&(Ya("row is wrong length"),this.err=!0,b=this.columns),g&1^d&&++g,e[g]=b);this.codingPos=g};c._addPixelsNeg=function(b,d){var e=this.codingLine,g=this.codingPos;if(b>e[g])b>this.columns&&(Ya("row is wrong length"),this.err=!0,b=this.columns),g&1^d&&++g,e[g]=b;else if(b<e[g]){0>b&&(Ya("invalid code"),this.err=!0,b=0);for(;0<g&&b<e[g-1];)--g;e[g]=b}this.codingPos=g};c._findTableCode=function(b,\nd,e,g){for(g=g||0;b<=d;++b){var f=this._lookBits(b);if(-1===f)return[!0,1,!1];b<d&&(f<<=d-b);if(!g||f>=g)if(f=e[f-g],f[0]===b)return this._eatBits(b),[!0,f[1],!0]}return[!1,0,!1]};c._getTwoDimCode=function(){if(this.eoblock){var b=this._lookBits(7);b=vn[b];if(0<(null==b?void 0:b[0]))return this._eatBits(b[0]),b[1]}else if(b=this._findTableCode(1,7,vn),b[0]&&b[2])return b[1];Ya("Bad two dim code");return-1};c._getWhiteCode=function(){if(this.eoblock){var b=this._lookBits(12);if(-1===b)return 1;b=0===\nb>>5?wn[b]:xn[b>>3];if(0<b[0])return this._eatBits(b[0]),b[1]}else{b=this._findTableCode(1,9,xn);if(b[0])return b[1];b=this._findTableCode(11,12,wn);if(b[0])return b[1]}Ya("bad white code");this._eatBits(1);return 1};c._getBlackCode=function(){if(this.eoblock){var b=this._lookBits(13);if(-1===b)return 1;b=0===b>>7?yn[b]:0===b>>9&&0!==b>>7?zn[(b>>1)-64]:An[b>>7];if(0<b[0])return this._eatBits(b[0]),b[1]}else{b=this._findTableCode(2,6,An);if(b[0])return b[1];b=this._findTableCode(7,12,zn,64);if(b[0])return b[1];\nb=this._findTableCode(10,13,yn);if(b[0])return b[1]}Ya("bad black code");this._eatBits(1);return 1};c._lookBits=function(b){for(var d;this.inputBits<b;){if(-1===(d=this.source.next()))return 0===this.inputBits?-1:this.inputBuf<<b-this.inputBits&65535>>16-b;this.inputBuf=this.inputBuf<<8|d;this.inputBits+=8}return this.inputBuf>>this.inputBits-b&65535>>16-b};c._eatBits=function(b){0>(this.inputBits-=b)&&(this.inputBits=0)};return a}(),yr=function(a){function c(b,d,e){d=a.call(this,d)||this;d.str=b;\nd.dict=b.dict;e instanceof ca||(e=ca.empty);d.ccittFaxDecoder=new Ik({next:function(){return b.getByte()}},{K:e.get("K"),EndOfLine:e.get("EndOfLine"),EncodedByteAlign:e.get("EncodedByteAlign"),Columns:e.get("Columns"),Rows:e.get("Rows"),EndOfBlock:e.get("EndOfBlock"),BlackIs1:e.get("BlackIs1")});return d}wp(c,a);c.prototype.readBlock=function(){for(;!this.eof;){var b=this.ccittFaxDecoder.readNextChar();if(-1===b){this.eof=!0;break}this.ensureBuffer(this.bufferLength+1);this.buffer[this.bufferLength++]=\nb}};return c}(uc);pa(6412);pa(5477);var Bn=new Int32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),zr=new Int32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),Ar=new Int32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),\nBr=[new Int32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59E4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,\n524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,\n524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,\n524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,\n524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,\n524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,\n524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,\n524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],Cr=[new Int32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5],Cn=function(a){function c(d,e){e=a.call(this,e)||this;e.str=d;e.dict=d.dict;var g=d.getByte();d=d.getByte();if(-1===g||-1===d)throw new oa("Invalid header in flate stream: "+g+", "+\nd);if(8!==(g&15))throw new oa("Unknown compression method in flate stream: "+g+", "+d);if(0!==((g<<8)+d)%31)throw new oa("Bad FCHECK in flate stream: "+g+", "+d);if(d&32)throw new oa("FDICT bit set in flate stream: "+g+", "+d);e.codeSize=0;e.codeBuf=0;return e}yp(c,a);var b=c.prototype;b.getImageData=function(){var d=qh(function f(g){var h=this,k;return u.generator.createGenerator(f,function(l){if(1==l.nextAddress)return l.yield(h.asyncGetBytes(),2);k=l.yieldResult;return l.return((null==k?void 0:\nk.subarray(0,g))||h.getBytes(g))})});return function(g,f){return d.apply(this,arguments)}}();b.asyncGetBytes=function(){var d=qh(function g(){var f=this,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E;return u.generator.createGenerator(g,function(G){switch(G.nextAddress){case 1:return f.str.reset(),h=f.str.getBytes(),G.setCatchFinallyBlocks(2),k=new DecompressionStream("deflate"),l=k.readable,m=k.writable,n=m.getWriter(),G.yield(n.ready,4);case 4:n.write(h).then(qh(function F(){return u.generator.createGenerator(F,\nfunction(L){return 1==L.nextAddress?L.yield(n.ready,2):L.yield(n.close(),0)})})).catch(function(){}),p=[],q=0,t=r=!1,G.setCatchFinallyBlocks(5,6),w=zp(l);case 8:return G.yield(w.next(),11);case 11:if(!(r=!(y=G.yieldResult).done)){G.jumpTo(6);break}x=y.value;p.push(x);q+=x.byteLength;r=!1;G.jumpTo(8);break;case 6:G.enterFinallyBlock(2);G.setFinallyBlock(12);if(!r||null==w.return){G.jumpTo(12);break}return G.yield(w.return(),12);case 12:G.enterFinallyBlock(2,0,1);if(t)throw v;G.leaveFinallyBlock(13,\n1);break;case 13:G.leaveFinallyBlock(7);break;case 5:z=G.enterCatchBlock();t=!0;v=z;G.jumpTo(6);break;case 7:A=new Uint8Array(q);B=0;C=u.makeIterator(p);for(D=C.next();!D.done;D=C.next())E=D.value,A.set(E,B),B+=E.byteLength;return G.return(A);case 2:return G.enterCatchBlock(),f.str=new Mb(h,2,h.length,f.str.dict),f.reset(),G.return(null)}})});return function(){return d.apply(this,arguments)}}();b.getBits=function(d){for(var e=this.str,g=this.codeSize,f=this.codeBuf,h;g<d;){if(-1===(h=e.getByte()))throw new oa("Bad encoding in flate stream");\nf|=h<<g;g+=8}this.codeBuf=f>>d;this.codeSize=g-d;return f&(1<<d)-1};b.getCode=function(d){var e=this.str,g=d[0],f=d[1];d=this.codeSize;for(var h=this.codeBuf,k;d<f&&-1!==(k=e.getByte());)h|=k<<d,d+=8;g=g[h&(1<<f)-1];e=g>>16;g&=65535;if(1>e||d<e)throw new oa("Bad encoding in flate stream");this.codeBuf=h>>e;this.codeSize=d-e;return g};b.generateHuffmanTable=function(d){var e=d.length,g=0,f;for(f=0;f<e;++f)d[f]>g&&(g=d[f]);for(var h=1<<g,k=new Int32Array(h),l=1,m=0,n=2;l<=g;++l,m<<=1,n<<=1)for(var p=\n0;p<e;++p)if(d[p]===l){var q=0,r=m;for(f=0;f<l;++f)q=q<<1|r&1,r>>=1;for(f=q;f<h;f+=n)k[f]=l<<16|p;++m}return[k,g]};b.__endsStreamOnError=function(d){Ya(d);this.eof=!0};b.readBlock=function(){var d=this.str;try{var e=this.getBits(3)}catch(p){this.__endsStreamOnError(p.message);return}e&1&&(this.eof=!0);e>>=1;if(0===e)if(-1===(e=d.getByte()))this.__endsStreamOnError("Bad block header in flate stream");else{var g=e;if(-1===(e=d.getByte()))this.__endsStreamOnError("Bad block header in flate stream");\nelse if(g|=e<<8,-1===(e=d.getByte()))this.__endsStreamOnError("Bad block header in flate stream");else{var f=e;if(-1===(e=d.getByte()))this.__endsStreamOnError("Bad block header in flate stream");else{f|=e<<8;if(f!==(~g&65535)&&(0!==g||0!==f))throw new oa("Bad uncompressed block length in flate stream");this.codeSize=this.codeBuf=0;f=this.bufferLength;var h=f+g;e=this.ensureBuffer(h);this.bufferLength=h;0===g?-1===d.peekByte()&&(this.eof=!0):(d=d.getBytes(g),e.set(d,f),d.length<g&&(this.eof=!0))}}}else{if(1===\ne)g=Br,f=Cr;else if(2===e){e=this.getBits(5)+257;h=this.getBits(5)+1;d=this.getBits(4)+4;f=new Uint8Array(Bn.length);for(g=0;g<d;++g)f[Bn[g]]=this.getBits(3);f=this.generateHuffmanTable(f);g=d=0;h=e+h;for(var k=new Uint8Array(h),l,m,n;g<h;){n=this.getCode(f);if(16===n)l=2,m=3,n=d;else if(17===n)m=l=3,n=d=0;else if(18===n)l=7,m=11,n=d=0;else{k[g++]=d=n;continue}for(l=this.getBits(l)+m;0<l--;)k[g++]=n}g=this.generateHuffmanTable(k.subarray(0,e));f=this.generateHuffmanTable(k.subarray(e,h))}else throw new oa("Unknown block type in flate stream");\nh=(e=this.buffer)?e.length:0;for(k=this.bufferLength;;)if(n=this.getCode(g),256>n)k+1>=h&&(e=this.ensureBuffer(k+1),h=e.length),e[k++]=n;else{if(256===n){this.bufferLength=k;break}n-=257;n=zr[n];l=n>>16;0<l&&(l=this.getBits(l));d=(n&65535)+l;n=this.getCode(f);n=Ar[n];l=n>>16;0<l&&(l=this.getBits(l));n=(n&65535)+l;k+d>=h&&(e=this.ensureBuffer(k+d),h=e.length);for(l=0;l<d;++l,++k)e[k]=e[k-n]}}};return xp(c,[{key:"isAsync",get:function(){return!0}}])}(uc);pa(7357);pa(6594);var Dr=[{qe:22017,nmps:1,nlps:1,\nswitchFlag:1},{qe:13313,nmps:2,nlps:6,switchFlag:0},{qe:6145,nmps:3,nlps:9,switchFlag:0},{qe:2753,nmps:4,nlps:12,switchFlag:0},{qe:1313,nmps:5,nlps:29,switchFlag:0},{qe:545,nmps:38,nlps:33,switchFlag:0},{qe:22017,nmps:7,nlps:6,switchFlag:1},{qe:21505,nmps:8,nlps:14,switchFlag:0},{qe:18433,nmps:9,nlps:14,switchFlag:0},{qe:14337,nmps:10,nlps:14,switchFlag:0},{qe:12289,nmps:11,nlps:17,switchFlag:0},{qe:9217,nmps:12,nlps:18,switchFlag:0},{qe:7169,nmps:13,nlps:20,switchFlag:0},{qe:5633,nmps:29,nlps:21,\nswitchFlag:0},{qe:22017,nmps:15,nlps:14,switchFlag:1},{qe:21505,nmps:16,nlps:14,switchFlag:0},{qe:20737,nmps:17,nlps:15,switchFlag:0},{qe:18433,nmps:18,nlps:16,switchFlag:0},{qe:14337,nmps:19,nlps:17,switchFlag:0},{qe:13313,nmps:20,nlps:18,switchFlag:0},{qe:12289,nmps:21,nlps:19,switchFlag:0},{qe:10241,nmps:22,nlps:19,switchFlag:0},{qe:9217,nmps:23,nlps:20,switchFlag:0},{qe:8705,nmps:24,nlps:21,switchFlag:0},{qe:7169,nmps:25,nlps:22,switchFlag:0},{qe:6145,nmps:26,nlps:23,switchFlag:0},{qe:5633,nmps:27,\nnlps:24,switchFlag:0},{qe:5121,nmps:28,nlps:25,switchFlag:0},{qe:4609,nmps:29,nlps:26,switchFlag:0},{qe:4353,nmps:30,nlps:27,switchFlag:0},{qe:2753,nmps:31,nlps:28,switchFlag:0},{qe:2497,nmps:32,nlps:29,switchFlag:0},{qe:2209,nmps:33,nlps:30,switchFlag:0},{qe:1313,nmps:34,nlps:31,switchFlag:0},{qe:1089,nmps:35,nlps:32,switchFlag:0},{qe:673,nmps:36,nlps:33,switchFlag:0},{qe:545,nmps:37,nlps:34,switchFlag:0},{qe:321,nmps:38,nlps:35,switchFlag:0},{qe:273,nmps:39,nlps:36,switchFlag:0},{qe:133,nmps:40,\nnlps:37,switchFlag:0},{qe:73,nmps:41,nlps:38,switchFlag:0},{qe:37,nmps:42,nlps:39,switchFlag:0},{qe:21,nmps:43,nlps:40,switchFlag:0},{qe:9,nmps:44,nlps:41,switchFlag:0},{qe:5,nmps:45,nlps:42,switchFlag:0},{qe:1,nmps:45,nlps:43,switchFlag:0},{qe:22017,nmps:46,nlps:46,switchFlag:0}],Er=function(){function a(b,d,e){this.data=b;this.bp=d;this.dataEnd=e;this.chigh=b[d];this.clow=0;this.byteIn();this.chigh=this.chigh<<7&65535|this.clow>>9&127;this.clow=this.clow<<7&65535;this.ct-=7;this.a=32768}var c=a.prototype;\nc.byteIn=function(){var b=this.data,d=this.bp;255===b[d]?143<b[d+1]?(this.clow+=65280,this.ct=8):(d++,this.clow+=b[d]<<9,this.ct=7,this.bp=d):(d++,this.clow+=d<this.dataEnd?b[d]<<8:65280,this.ct=8,this.bp=d);65535<this.clow&&(this.chigh+=this.clow>>16,this.clow&=65535)};c.readBit=function(b,d){var e=b[d]>>1,g=b[d]&1;e=Dr[e];var f=e.qe,h=this.a-f;if(this.chigh<f)h<f?(h=f,f=g,e=e.nmps):(h=f,f=1^g,1===e.switchFlag&&(g=f),e=e.nlps);else{this.chigh-=f;if(0!==(h&32768))return this.a=h,g;h<f?(f=1^g,1===\ne.switchFlag&&(g=f),e=e.nlps):(f=g,e=e.nmps)}do 0===this.ct&&this.byteIn(),h<<=1,this.chigh=this.chigh<<1&65535|this.clow>>15&1,this.clow=this.clow<<1&65535,this.ct--;while(0===(h&32768));this.a=h;b[d]=e<<1|g;return f};return a}(),Ab=function(a){function c(b){return a.call(this,b,"Jbig2Error")||this}Bp(c,a);return c}(tc),Fr=function(){function a(){}a.prototype.getContexts=function(c){return c in this?this[c]:this[c]=new Int8Array(65536)};return a}(),wf=function(){return Ap(function(a,c,b){this.data=\na;this.start=c;this.end=b},[{key:"decoder",get:function(){var a=new Er(this.data,this.start,this.end);return Fa(this,"decoder",a)}},{key:"contextCache",get:function(){var a=new Fr;return Fa(this,"contextCache",a)}}])}(),Dp=Math.pow(2,31)-1,Cp=-Math.pow(2,31),Dn=["SymbolDictionary",null,null,null,"IntermediateTextRegion",null,"ImmediateTextRegion","ImmediateLosslessTextRegion",null,null,null,null,null,null,null,null,"PatternDictionary",null,null,null,"IntermediateHalftoneRegion",null,"ImmediateHalftoneRegion",\n"ImmediateLosslessHalftoneRegion",null,null,null,null,null,null,null,null,null,null,null,null,"IntermediateGenericRegion",null,"ImmediateGenericRegion","ImmediateLosslessGenericRegion","IntermediateGenericRefinementRegion",null,"ImmediateGenericRefinementRegion","ImmediateLosslessGenericRefinementRegion",null,null,null,null,"PageInformation","EndOfPage","EndOfStripe","EndOfFile","Profiles","Tables",null,null,null,null,null,null,null,null,"Extension"],Fp=[[{x:-1,y:-2},{x:0,y:-2},{x:1,y:-2},{x:-2,y:-1},\n{x:-1,y:-1},{x:0,y:-1},{x:1,y:-1},{x:2,y:-1},{x:-4,y:0},{x:-3,y:0},{x:-2,y:0},{x:-1,y:0}],[{x:-1,y:-2},{x:0,y:-2},{x:1,y:-2},{x:2,y:-2},{x:-2,y:-1},{x:-1,y:-1},{x:0,y:-1},{x:1,y:-1},{x:2,y:-1},{x:-3,y:0},{x:-2,y:0},{x:-1,y:0}],[{x:-1,y:-2},{x:0,y:-2},{x:1,y:-2},{x:-2,y:-1},{x:-1,y:-1},{x:0,y:-1},{x:1,y:-1},{x:-2,y:0},{x:-1,y:0}],[{x:-3,y:-1},{x:-2,y:-1},{x:-1,y:-1},{x:0,y:-1},{x:1,y:-1},{x:-4,y:0},{x:-3,y:0},{x:-2,y:0},{x:-1,y:0}]],Fk=[{coding:[{x:0,y:-1},{x:1,y:-1},{x:-1,y:0}],reference:[{x:0,y:-1},\n{x:1,y:-1},{x:-1,y:0},{x:0,y:0},{x:1,y:0},{x:-1,y:1},{x:0,y:1},{x:1,y:1}]},{coding:[{x:-1,y:-1},{x:0,y:-1},{x:1,y:-1},{x:-1,y:0}],reference:[{x:0,y:-1},{x:-1,y:0},{x:0,y:0},{x:1,y:0},{x:0,y:1},{x:1,y:1}]}],Gp=[39717,1941,229,405],Hp=[32,8],Gr=function(){function a(){}var c=a.prototype;c.onPageInformation=function(b){this.currentPageInfo=b;var d=new Uint8ClampedArray((b.width+7>>3)*b.height);b.defaultPixelValue&&d.fill(255);this.buffer=d};c.drawBitmap=function(b,d){var e=this.currentPageInfo,g=b.width,\nf=b.height,h=e.width+7>>3,k=e.combinationOperatorOverride?b.combinationOperator:e.combinationOperator;e=this.buffer;var l=128>>(b.x&7);b=b.y*h+(b.x>>3);var m;switch(k){case 0:for(k=0;k<f;k++){var n=l;var p=b;for(m=0;m<g;m++)d[k][m]&&(e[p]|=n),n>>=1,n||(n=128,p++);b+=h}break;case 2:for(k=0;k<f;k++){n=l;p=b;for(m=0;m<g;m++)d[k][m]&&(e[p]^=n),n>>=1,n||(n=128,p++);b+=h}break;default:throw new Ab("operator "+k+" is not supported");}};c.onImmediateGenericRegion=function(b,d,e,g){var f=b.info;d=new wf(d,\ne,g);b=eg(b.mmr,f.width,f.height,b.template,b.prediction,null,b.at,d);this.drawBitmap(f,b)};c.onImmediateLosslessGenericRegion=function(){this.onImmediateGenericRegion.apply(this,arguments)};c.onSymbolDictionary=function(b,d,e,g,f,h){if(b.huffman){var k=this.customTables,l=0;switch(b.huffmanDHSelector){case 0:case 1:var m=Nd(b.huffmanDHSelector+4);break;case 3:m=ge(l,e,k);l++;break;default:throw new Ab("invalid Huffman DH selector");}switch(b.huffmanDWSelector){case 0:case 1:var n=Nd(b.huffmanDWSelector+\n2);break;case 3:n=ge(l,e,k);l++;break;default:throw new Ab("invalid Huffman DW selector");}if(b.bitmapSizeSelector){var p=ge(l,e,k);l++}else p=Nd(1);k=b.aggregationInstancesSelector?ge(l,e,k):Nd(1);p={tableDeltaHeight:m,tableDeltaWidth:n,tableBitmapSize:p,tableAggregateInstances:k};n=new ff(g,f,h)}l=this.symbols;l||(this.symbols=l={});m=[];e=u.makeIterator(e);for(k=e.next();!k.done;k=e.next())(k=l[k.value])&&m.push.apply(m,u.arrayFromIterable(k));k=new wf(g,f,h);g=l;h=b.huffman;l=b.refinement;f=b.numberOfNewSymbols;\nvar q=p,r=b.template,t=b.at,v=b.refinementTemplate,w=b.refinementAt;if(h&&l)throw new Ab("symbol refinement with Huffman is not supported");b=[];var y=0,x=eh(m.length+f);p=k.decoder;e=k.contextCache;if(h){var z=Nd(1);var A=[];x=Math.max(x,1)}for(;b.length<f;){var B=h?q.tableDeltaHeight.decode(n):oc(e,"IADH",p);y+=B;var C=0,D=0;for(B=h?A.length:0;;){var E=h?q.tableDeltaWidth.decode(n):oc(e,"IADW",p);if(null===E)break;C+=E;D+=C;if(l){E=oc(e,"IAAI",p);if(1<E)E=Gk(h,l,C,y,0,E,1,m.concat(b),x,0,0,1,0,\nq,v,w,k,0,n);else{E=Dk(e,p,x);var G=oc(e,"IARDX",p),J=oc(e,"IARDY",p);E=Ek(C,y,v,E<m.length?m[E]:b[E-m.length],G,J,!1,w,k)}b.push(E)}else h?A.push(C):(E=eg(!1,C,y,r,!1,null,t,k),b.push(E))}if(h&&!l){E=q.tableBitmapSize.decode(n);n.byteAlign();if(0===E){C=n;E=y;G=[];for(J=0;J<E;J++){var F=new Uint8Array(D);G.push(F);for(var L=0;L<D;L++)F[L]=C.readBit();C.byteAlign()}D=G}else C=n.end,E=n.position+E,n.end=E,D=th(n,D,y,!1),n.end=C,n.position=E;C=A.length;if(B===C-1)b.push(D);else for(E=0;B<C;B++){G=A[B];\nJ=E+G;F=[];for(G=0;G<y;G++)F.push(D[G].subarray(E,J));b.push(F);E=J}}}A=[];k=[];l=!1;for(q=m.length+f;k.length<q;){for(r=h?z.decode(n):oc(e,"IAEX",p);r--;)k.push(l);l=!l}z=0;for(h=m.length;z<h;z++)k[z]&&A.push(m[z]);for(m=0;m<f;z++,m++)k[z]&&A.push(b[m]);g[d]=A};c.onImmediateTextRegion=function(b,d,e,g,f){for(var h=b.info,k,l,m=this.symbols,n=[],p=u.makeIterator(d),q=p.next();!q.done;q=p.next())(q=m[q.value])&&n.push.apply(n,u.arrayFromIterable(q));m=eh(n.length);if(b.huffman){l=new ff(e,g,f);k=this.customTables;\np=n.length;q=l;for(var r=[],t=0;34>=t;t++){var v=q.readBits(4);r.push(new Ea([t,v,0,0]))}t=new gg(r,!1);for(v=r.length=0;v<p;){var w=t.decode(q);if(32<=w){var y;switch(w){case 32:if(0===v)throw new Ab("no previous value in symbol ID table");var x=q.readBits(2)+3;w=r[v-1].prefixLength;break;case 33:x=q.readBits(3)+3;w=0;break;case 34:x=q.readBits(7)+11;w=0;break;default:throw new Ab("invalid code length in symbol ID table");}for(y=0;y<x;y++)r.push(new Ea([v,w,0,0])),v++}else r.push(new Ea([v,w,0,0])),\nv++}q.byteAlign();p=new gg(r,!1);t=0;switch(b.huffmanFS){case 0:case 1:q=Nd(b.huffmanFS+6);break;case 3:q=ge(t,d,k);t++;break;default:throw new Ab("invalid Huffman FS selector");}switch(b.huffmanDS){case 0:case 1:case 2:r=Nd(b.huffmanDS+8);break;case 3:r=ge(t,d,k);t++;break;default:throw new Ab("invalid Huffman DS selector");}switch(b.huffmanDT){case 0:case 1:case 2:d=Nd(b.huffmanDT+11);break;case 3:d=ge(t,d,k);break;default:throw new Ab("invalid Huffman DT selector");}if(b.refinement)throw new Ab("refinement with Huffman is not supported");\nk={symbolIDTable:p,tableFirstS:q,tableDeltaS:r,tableDeltaT:d}}e=new wf(e,g,f);b=Gk(b.huffman,b.refinement,h.width,h.height,b.defaultPixelValue,b.numberOfSymbolInstances,b.stripSize,n,m,b.transposed,b.dsOffset,b.referenceCorner,b.combinationOperator,k,b.refinementTemplate,b.refinementAt,e,b.logStripSize,l);this.drawBitmap(h,b)};c.onImmediateLosslessTextRegion=function(){this.onImmediateTextRegion.apply(this,arguments)};c.onPatternDictionary=function(b,d,e,g,f){var h=this.patterns;h||(this.patterns=\nh={});var k=new wf(e,g,f),l=b.mmr;e=b.patternWidth;g=b.patternHeight;f=b.maxPatternIndex;b=b.template;var m=[];l||(m.push({x:-e,y:0}),0===b&&m.push({x:-3,y:-1},{x:2,y:-2},{x:-2,y:-2}));b=eg(l,(f+1)*e,g,b,!1,null,m,k);k=[];for(l=0;l<=f;l++){m=[];for(var n=e*l,p=n+e,q=0;q<g;q++)m.push(b[q].subarray(n,p));k.push(m)}h[d]=k};c.onImmediateHalftoneRegion=function(b,d,e,g,f){d=this.patterns[d[0]];var h=b.info,k=new wf(e,g,f),l=b.mmr,m=b.template;e=h.width;g=h.height;var n=b.defaultPixelValue,p=b.combinationOperator;\nf=b.gridWidth;var q=b.gridHeight,r=b.gridOffsetX,t=b.gridOffsetY,v=b.gridVectorX,w=b.gridVectorY;if(b.enableSkip)throw new Ab("skip is not supported");if(0!==p)throw new Ab(\'operator "\'+p+\'" is not supported in halftone region\');b=[];var y;for(p=0;p<g;p++){var x=new Uint8Array(e);if(n)for(y=0;y<e;y++)x[y]=n;b.push(x)}p=d[0];n=p[0].length;x=p.length;var z=eh(d.length);y=[];l||(y.push({x:1>=m?3:2,y:-1}),0===m&&y.push({x:-3,y:-1},{x:2,y:-2},{x:-2,y:-2}));var A=[],B;l&&(B=new ff(k.data,k.start,k.end));\nfor(p=z-1;0<=p;p--){var C=l?th(B,f,q,!0):eg(!1,f,q,m,!1,null,y,k);A[p]=C}for(B=0;B<q;B++)for(k=0;k<f;k++){l=p=0;for(y=z-1;0<=y;y--)p^=A[y][B][k],l|=p<<y;l=d[l];m=r+B*w+k*v>>8;C=t+B*v-k*w>>8;if(0<=m&&m+n<=e&&0<=C&&C+x<=g)for(p=0;p<x;p++){var D=b[C+p];var E=l[p];for(y=0;y<n;y++)D[m+y]|=E[y]}else for(p=0;p<x;p++)if(y=C+p,!(0>y||y>=g))for(D=b[y],E=l[p],y=0;y<n;y++){var G=m+y;0<=G&&G<e&&(D[G]|=E[y])}}this.drawBitmap(h,b)};c.onImmediateLosslessHalftoneRegion=function(){this.onImmediateHalftoneRegion.apply(this,\narguments)};c.onTables=function(b,d,e,g){var f=this.customTables;f||(this.customTables=f={});var h=d[e];var k=zb(d,e+1)&4294967295,l=zb(d,e+5)&4294967295;d=new ff(d,e+9,g);e=(h>>1&7)+1;g=(h>>4&7)+1;var m=[],n=k;do{var p=d.readBits(e);var q=d.readBits(g);m.push(new Ea([n,p,q,0]));n+=1<<q}while(n<l);p=d.readBits(e);m.push(new Ea([k-1,p,32,0,"lower"]));p=d.readBits(e);m.push(new Ea([l,p,32,0]));h&1&&(p=d.readBits(e),m.push(new Ea([p,0])));h=new gg(m,!1);f[b]=h};return a}(),Hr=function(){function a(b){this.children=\n[];b?(this.isLeaf=!0,this.rangeLength=b.rangeLength,this.rangeLow=b.rangeLow,this.isLowerRange=b.isLowerRange,this.isOOB=b.isOOB):this.isLeaf=!1}var c=a.prototype;c.buildTree=function(b,d){var e=b.prefixCode>>d&1;if(0>=d)this.children[e]=new a(b);else{var g=this.children[e];g||(this.children[e]=g=new a(null));g.buildTree(b,d-1)}};c.decodeNode=function(b){if(this.isLeaf){if(this.isOOB)return null;b=b.readBits(this.rangeLength);return this.rangeLow+(this.isLowerRange?-b:b)}var d=this.children[b.readBit()];\nif(!d)throw new Ab("invalid Huffman data");return d.decodeNode(b)};return a}(),gg=function(){function a(b,d){d||this.assignPrefixCodes(b);this.rootNode=new Hr(null);d=0;for(var e=b.length;d<e;d++){var g=b[d];0<g.prefixLength&&this.rootNode.buildTree(g,g.prefixLength-1)}}var c=a.prototype;c.decode=function(b){return this.rootNode.decodeNode(b)};c.assignPrefixCodes=function(b){for(var d=b.length,e=0,g=0;g<d;g++)e=Math.max(e,b[g].prefixLength);g=new Uint32Array(e+1);for(var f=0;f<d;f++)g[b[f].prefixLength]++;\nf=1;var h=0,k;for(g[0]=0;f<=e;){var l=h=h+g[f-1]<<1;for(k=0;k<d;){var m=b[k];m.prefixLength===f&&(m.prefixCode=l,l++);k++}f++}};return a}(),Hk={},ff=function(){function a(b,d,e){this.data=b;this.start=d;this.end=e;this.position=d;this.shift=-1;this.currentByte=0}var c=a.prototype;c.readBit=function(){if(0>this.shift){if(this.position>=this.end)throw new Ab("end of data while reading bit");this.currentByte=this.data[this.position++];this.shift=7}var b=this.currentByte>>this.shift&1;this.shift--;return b};\nc.readBits=function(b){var d=0;for(--b;0<=b;b--)d|=this.readBit()<<b;return d};c.byteAlign=function(){this.shift=-1};c.next=function(){return this.position>=this.end?-1:this.data[this.position++]};return a}(),Ir=function(){function a(){}var c=a.prototype;c.parseChunks=function(b){for(var d=new Gr,e=0,g=b.length;e<g;e++){for(var f=b[e],h={},k=f.data,l=f.end,m=[],n=f.start;n<l;){f=k;var p=n;n={};n.number=zb(f,p);var q=f[p+4];var r=q&63;if(!Dn[r])throw new Ab("invalid segment type: "+r);n.type=r;n.typeName=\nDn[r];n.deferredNonRetain=!!(q&128);q=!!(q&64);var t=f[p+5],v=t>>5&7;var w=[t&31];p+=6;if(7===t)for(v=zb(f,p-1)&536870911,p+=3,t=v+7>>3,w[0]=f[p++];0<--t;)w.push(f[p++]);else if(5===t||6===t)throw new Ab("invalid referred-to flags");n.retainBits=w;t=4;256>=n.number?t=1:65536>=n.number&&(t=2);var y=[];for(w=0;w<v;w++){var x=1===t?f[p]:2===t?yb(f,p):zb(f,p);y.push(x);p+=t}n.referredTo=y;q?(n.pageAssociation=zb(f,p),p+=4):n.pageAssociation=f[p++];n.length=zb(f,p);p+=4;if(4294967295===n.length)if(38===\nr){q=fg(f,p);v=!!(f[p+17]&1);r=new Uint8Array(6);v||(r[0]=255,r[1]=172);r[2]=q.height>>>24&255;r[3]=q.height>>16&255;r[4]=q.height>>8&255;r[5]=q.height&255;w=p;for(q=f.length;w<q;w++){for(v=0;6>v&&r[v]===f[w+v];)v++;if(6===v){n.length=w+6;break}}if(4294967295===n.length)throw new Ab("segment end was not found");}else throw new Ab("invalid unknown segment length");n.headerEnd=p;f=n;n=f.headerEnd;p={header:f,data:k};h.randomAccess||(p.start=n,n+=f.length,p.end=n);m.push(p);if(51===f.type)break}if(h.randomAccess)for(h=\n0,k=m.length;h<k;h++)m[h].start=n,n+=m[h].header.length,m[h].end=n;h=0;for(k=m.length;h<k;h++){r=void 0;n=m[h];l=n.header;f=n.data;p=n.end;n=n.start;switch(l.type){case 0:w={};r=yb(f,n);w.huffman=!!(r&1);w.refinement=!!(r&2);w.huffmanDHSelector=r>>2&3;w.huffmanDWSelector=r>>4&3;w.bitmapSizeSelector=r>>6&1;w.aggregationInstancesSelector=r>>7&1;w.bitmapCodingContextUsed=!!(r&256);w.bitmapCodingContextRetained=!!(r&512);w.template=r>>10&3;w.refinementTemplate=r>>12&1;n+=2;if(!w.huffman){v=0===w.template?\n4:1;q=[];for(r=0;r<v;r++)q.push({x:f[n]<<24>>24,y:f[n+1]<<24>>24}),n+=2;w.at=q}if(w.refinement&&!w.refinementTemplate){q=[];for(r=0;2>r;r++)q.push({x:f[n]<<24>>24,y:f[n+1]<<24>>24}),n+=2;w.refinementAt=q}w.numberOfExportedSymbols=zb(f,n);n+=4;w.numberOfNewSymbols=zb(f,n);r=[w,l.number,l.referredTo,f,n+4,p];break;case 6:case 7:v={};v.info=fg(f,n);n+=17;r=yb(f,n);n+=2;v.huffman=!!(r&1);v.refinement=!!(r&2);v.logStripSize=r>>2&3;v.stripSize=1<<v.logStripSize;v.referenceCorner=r>>4&3;v.transposed=!!(r&\n64);v.combinationOperator=r>>7&3;v.defaultPixelValue=r>>9&1;v.dsOffset=r<<17>>27;v.refinementTemplate=r>>15&1;v.huffman&&(r=yb(f,n),n+=2,v.huffmanFS=r&3,v.huffmanDS=r>>2&3,v.huffmanDT=r>>4&3,v.huffmanRefinementDW=r>>6&3,v.huffmanRefinementDH=r>>8&3,v.huffmanRefinementDX=r>>10&3,v.huffmanRefinementDY=r>>12&3,v.huffmanRefinementSizeSelector=!!(r&16384));if(v.refinement&&!v.refinementTemplate){q=[];for(r=0;2>r;r++)q.push({x:f[n]<<24>>24,y:f[n+1]<<24>>24}),n+=2;v.refinementAt=q}v.numberOfSymbolInstances=\nzb(f,n);r=[v,l.referredTo,f,n+4,p];break;case 16:r={};q=f[n++];r.mmr=!!(q&1);r.template=q>>1&3;r.patternWidth=f[n++];r.patternHeight=f[n++];r.maxPatternIndex=zb(f,n);r=[r,l.number,f,n+4,p];break;case 22:case 23:r={};r.info=fg(f,n);n+=17;q=f[n++];r.mmr=!!(q&1);r.template=q>>1&3;r.enableSkip=!!(q&8);r.combinationOperator=q>>4&7;r.defaultPixelValue=q>>7&1;r.gridWidth=zb(f,n);n+=4;r.gridHeight=zb(f,n);n+=4;r.gridOffsetX=zb(f,n)&4294967295;n+=4;r.gridOffsetY=zb(f,n)&4294967295;n+=4;r.gridVectorX=yb(f,\nn);n+=2;r.gridVectorY=yb(f,n);r=[r,l.referredTo,f,n+2,p];break;case 38:case 39:w={};w.info=fg(f,n);n+=17;r=f[n++];w.mmr=!!(r&1);w.template=r>>1&3;w.prediction=!!(r&8);if(!w.mmr){v=0===w.template?4:1;q=[];for(r=0;r<v;r++)q.push({x:f[n]<<24>>24,y:f[n+1]<<24>>24}),n+=2;w.at=q}r=[w,f,n,p];break;case 48:p={width:zb(f,n),height:zb(f,n+4),resolutionX:zb(f,n+8),resolutionY:zb(f,n+12)};4294967295===p.height&&delete p.height;r=f[n+16];yb(f,n+17);p.lossless=!!(r&1);p.refinement=!!(r&2);p.defaultPixelValue=r>>\n2&1;p.combinationOperator=r>>3&3;p.requiresBuffer=!!(r&32);p.combinationOperatorOverride=!!(r&64);r=[p];break;case 49:break;case 50:break;case 51:break;case 53:r=[l.number,f,n,p];break;case 62:break;default:throw new Ab("segment type "+l.typeName+"("+l.type+") is not implemented");}l="on"+l.typeName;l in d&&d[l].apply(d,r)}}return d.buffer};c.parse=function(){throw Error("Not implemented: Jbig2Image.parse");};return a}(),Jr=function(a){function c(d,e,g){var f=a.call(this,e)||this;f.stream=d;f.dict=\nd.dict;f.maybeLength=e;f.params=g;return f}Jp(c,a);var b=c.prototype;b.ensureBuffer=function(){};b.readBlock=function(){this.decodeImage()};b.decodeImage=function(d){if(this.eof)return this.buffer;d||(d=this.bytes);var e=new Ir,g=[];if(this.params instanceof ca){var f=this.params.get("JBIG2Globals");f instanceof $a&&(f=f.getBytes(),g.push({data:f,start:0,end:f.length}))}g.push({data:d,start:0,end:d.length});d=e.parseChunks(g);e=d.length;for(g=0;g<e;g++)d[g]^=255;this.buffer=d;this.bufferLength=e;\nthis.eof=!0;return this.buffer};return Ip(c,[{key:"bytes",get:function(){return Fa(this,"bytes",this.stream.getBytes(this.maybeLength))}},{key:"canAsyncDecodeImageFromBuffer",get:function(){return this.stream.isAsync}}])}(uc);pa(2107);var jd=function(a){function c(b){return a.call(this,b,"JpegError")||this}wh(c,a);return c}(tc),yh=function(a){function c(b,d){b=a.call(this,b,"DNLMarkerError")||this;b.scanLines=d;return b}wh(c,a);return c}(tc),Lk=function(a){function c(b){return a.call(this,b,"EOIMarkerError")||\nthis}wh(c,a);return c}(tc),gf=new Uint8Array([0,1,8,16,9,2,3,10,17,24,32,25,18,11,4,5,12,19,26,33,40,48,41,34,27,20,13,6,7,14,21,28,35,42,49,56,57,50,43,36,29,22,15,23,30,37,44,51,58,59,52,45,38,31,39,46,53,60,61,54,47,55,62,63]),Hn=function(){function a(b){b=void 0===b?{}:b;var d=void 0===b.colorTransform?-1:b.colorTransform;this._decodeTransform=void 0===b.decodeTransform?null:b.decodeTransform;this._colorTransform=d}a.canUseImageDecoder=function(b,d){void 0===d&&(d=-1);var e=0,g=null,f=yb(b,e);\ne+=2;if(65496!==f)throw new jd("SOI not found");f=yb(b,e);e+=2;a:for(;65497!==f;){switch(f){case 65472:case 65473:case 65474:g=b[e+7];break a;case 65535:255!==b[e]&&e--}f=b;var h=yb(f,e);e+=2;h=e+h-2;f=hg(f,h,e);e=null!=f&&f.invalid?f.offset:h;f=yb(b,e);e+=2}return 4===g||3===g&&0===d?!1:!0};var c=a.prototype;c.parse=function(b,d){var e=void 0===d?{}:d,g=void 0===e.dnlScanLines?null:e.dnlScanLines,f=0,h=null,k=null,l=0,m=[],n=[],p=[],q=yb(b,f);f+=2;if(65496!==q)throw new jd("SOI not found");q=yb(b,\nf);f+=2;a:for(;65497!==q;){var r,t;switch(q){case 65504:case 65505:case 65506:case 65507:case 65508:case 65509:case 65510:case 65511:case 65512:case 65513:case 65514:case 65515:case 65516:case 65517:case 65518:case 65519:case 65534:var v=b,w=f,y=yb(v,w);w+=2;var x=w+y-2,z=hg(v,x,w);null!=z&&z.invalid&&(T("readDataBlock - incorrect length, current marker is: "+z.invalid),x=z.offset);var A=v.subarray(w,x);w+=A.length;var B=A;f=w;65504===q&&74===B[0]&&70===B[1]&&73===B[2]&&70===B[3]&&0===B[4]&&(h={version:{major:B[5],\nminor:B[6]},densityUnits:B[7],xDensity:B[8]<<8|B[9],yDensity:B[10]<<8|B[11],thumbWidth:B[12],thumbHeight:B[13],thumbData:B.subarray(14,14+3*B[12]*B[13])});65518===q&&65===B[0]&&100===B[1]&&111===B[2]&&98===B[3]&&101===B[4]&&(k={version:B[5]<<8|B[6],flags0:B[7]<<8|B[8],flags1:B[9]<<8|B[10],transformCode:B[11]});break;case 65499:var C=yb(b,f);f+=2;for(var D=C+f-2,E;f<D;){var G=b[f++],J=new Uint16Array(64);if(0===G>>4)for(t=0;64>t;t++)E=gf[t],J[E]=b[f++];else if(1===G>>4)for(t=0;64>t;t++)E=gf[t],J[E]=\nyb(b,f),f+=2;else throw new jd("DQT - invalid table spec");m[G&15]=J}break;case 65472:case 65473:case 65474:if(F)throw new jd("Only single frame JPEGs supported");f+=2;var F={};F.extended=65473===q;F.progressive=65474===q;F.precision=b[f++];var L=yb(b,f);f+=2;F.scanLines=g||L;F.samplesPerLine=yb(b,f);f+=2;F.components=[];F.componentIds={};var M=b[f++],W=0,Q=0;for(r=0;r<M;r++){var la=b[f],ta=b[f+1]>>4,qa=b[f+1]&15;W<ta&&(W=ta);Q<qa&&(Q=qa);var va=F.components.push({h:ta,v:qa,quantizationId:b[f+2],\nquantizationTable:null});F.componentIds[la]=va-1;f+=3}F.maxH=W;F.maxV=Q;for(var S=F,da=Math.ceil(S.samplesPerLine/8/S.maxH),R=Math.ceil(S.scanLines/8/S.maxV),Y=u.makeIterator(S.components),fa=Y.next();!fa.done;fa=Y.next()){var H=fa.value,U=Math.ceil(Math.ceil(S.samplesPerLine/8)*H.h/S.maxH),N=Math.ceil(Math.ceil(S.scanLines/8)*H.v/S.maxV);H.blockData=new Int16Array(64*R*H.v*(da*H.h+1));H.blocksPerLine=U;H.blocksPerColumn=N}S.mcusPerLine=da;S.mcusPerColumn=R;break;case 65476:var ba=yb(b,f);f+=2;for(r=\n2;r<ba;){var aa=b[f++],X=new Uint8Array(16),ha=0;for(t=0;16>t;t++,f++)ha+=X[t]=b[f];var ma=new Uint8Array(ha);for(t=0;t<ha;t++,f++)ma[t]=b[f];r+=17+ha;for(var V,ea,za,Ia=0,wa=16;0<wa&&!X[wa-1];)wa--;var Aa=[{children:[],index:0}],Ja=Aa[0];for(za=0;za<wa;za++){for(ea=0;ea<X[za];ea++){Ja=Aa.pop();for(Ja.children[Ja.index]=ma[Ia];0<Ja.index;)Ja=Aa.pop();Ja.index++;for(Aa.push(Ja);Aa.length<=za;)Aa.push(V={children:[],index:0}),Ja.children[Ja.index]=V.children,Ja=V;Ia++}za+1<wa&&(Aa.push(V={children:[],\nindex:0}),Ja.children[Ja.index]=V.children,Ja=V)}(0===aa>>4?p:n)[aa&15]=Aa[0].children}break;case 65501:f+=2;var Sa=yb(b,f);f+=2;break;case 65498:var Wa=1===++l&&!g;f+=2;var La=b[f++],vb=[];for(r=0;r<La;r++){var eb=b[f++],Xa=F.components[F.componentIds[eb]];Xa.index=eb;var Na=b[f++];Xa.huffmanTableDC=p[Na>>4];Xa.huffmanTableAC=n[Na&15];vb.push(Xa)}var hb=b[f++],Kb=b[f++],Za=b[f++];try{var mc=Lp(b,f,F,vb,Sa,hb,Kb,Za>>4,Za&15,Wa);f+=mc}catch(Pe){if(Pe instanceof yh)return T(Pe.message+" -- attempting to re-parse the JPEG image."),\nthis.parse(b,{dnlScanLines:Pe.scanLines});if(Pe instanceof Lk){T(Pe.message+" -- ignoring the rest of the image data.");break a}throw Pe;}break;case 65500:f+=4;break;case 65535:255!==b[f]&&f--;break;default:var tb=hg(b,f-2,f-3);if(null!=tb&&tb.invalid)T("JpegImage.parse - unexpected data, current marker is: "+tb.invalid),f=tb.offset;else{if(!tb||f>=b.length-1){T("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");break a}throw new jd("JpegImage.parse - unknown marker: "+\nq.toString(16));}}q=yb(b,f);f+=2}if(!F)throw new jd("JpegImage.parse - no frame data found.");this.width=F.samplesPerLine;this.height=F.scanLines;this.jfif=h;this.adobe=k;this.components=[];for(var uf=u.makeIterator(F.components),Td=uf.next();!Td.done;Td=uf.next()){var sc=Td.value,En=m[sc.quantizationId];En&&(sc.quantizationTable=En);for(var Fn=this.components,Kr=Fn.push,Lr=sc.index,Mr=sc.blocksPerLine,Nr=sc.blocksPerColumn,Or=new Int16Array(64),kj=0;kj<Nr;kj++)for(var lj=0;lj<Mr;lj++){var pb=void 0,\nBc=void 0,Rc=void 0,Sc=void 0,Tc=void 0,Uc=void 0,Vc=void 0,Cc=void 0,Wc=void 0,bc=void 0,cc=void 0,dc=void 0,ec=void 0,fc=void 0,gc=void 0,hc=void 0,ic=void 0,Gn=sc,Eb=64*((sc.blocksPerLine+1)*kj+lj),Fb=Or,Jd=Gn.quantizationTable,Gb=Gn.blockData;if(!Jd)throw new jd("missing required Quantization Table.");for(var qb=0;64>qb;qb+=8)Wc=Gb[Eb+qb],Cc=Gb[Eb+qb+1],Vc=Gb[Eb+qb+2],Uc=Gb[Eb+qb+3],Tc=Gb[Eb+qb+4],Sc=Gb[Eb+qb+5],Rc=Gb[Eb+qb+6],Bc=Gb[Eb+qb+7],Wc*=Jd[qb],0===(Cc|Vc|Uc|Tc|Sc|Rc|Bc)?(pb=5793*Wc+512>>\n10,Fb[qb]=pb,Fb[qb+1]=pb,Fb[qb+2]=pb,Fb[qb+3]=pb,Fb[qb+4]=pb,Fb[qb+5]=pb,Fb[qb+6]=pb,Fb[qb+7]=pb):(Cc*=Jd[qb+1],Vc*=Jd[qb+2],Uc*=Jd[qb+3],Tc*=Jd[qb+4],Sc*=Jd[qb+5],Rc*=Jd[qb+6],Bc*=Jd[qb+7],ic=5793*Wc+128>>8,hc=5793*Tc+128>>8,gc=Vc,fc=Rc,ec=2896*(Cc-Bc)+128>>8,bc=2896*(Cc+Bc)+128>>8,dc=Uc<<4,cc=Sc<<4,ic=ic+hc+1>>1,hc=ic-hc,pb=3784*gc+1567*fc+128>>8,gc=1567*gc-3784*fc+128>>8,fc=pb,ec=ec+cc+1>>1,cc=ec-cc,bc=bc+dc+1>>1,dc=bc-dc,ic=ic+fc+1>>1,fc=ic-fc,hc=hc+gc+1>>1,gc=hc-gc,pb=2276*ec+3406*bc+2048>>12,\nec=3406*ec-2276*bc+2048>>12,bc=pb,pb=799*dc+4017*cc+2048>>12,dc=4017*dc-799*cc+2048>>12,cc=pb,Fb[qb]=ic+bc,Fb[qb+7]=ic-bc,Fb[qb+1]=hc+cc,Fb[qb+6]=hc-cc,Fb[qb+2]=gc+dc,Fb[qb+5]=gc-dc,Fb[qb+3]=fc+ec,Fb[qb+4]=fc-ec);for(var wb=0;8>wb;++wb)Wc=Fb[wb],Cc=Fb[wb+8],Vc=Fb[wb+16],Uc=Fb[wb+24],Tc=Fb[wb+32],Sc=Fb[wb+40],Rc=Fb[wb+48],Bc=Fb[wb+56],0===(Cc|Vc|Uc|Tc|Sc|Rc|Bc)?(pb=5793*Wc+8192>>14,pb=-2040>pb?0:2024<=pb?255:pb+2056>>4,Gb[Eb+wb]=pb,Gb[Eb+wb+8]=pb,Gb[Eb+wb+16]=pb,Gb[Eb+wb+24]=pb,Gb[Eb+wb+32]=pb,Gb[Eb+\nwb+40]=pb,Gb[Eb+wb+48]=pb,Gb[Eb+wb+56]=pb):(ic=5793*Wc+2048>>12,hc=5793*Tc+2048>>12,gc=Vc,fc=Rc,ec=2896*(Cc-Bc)+2048>>12,bc=2896*(Cc+Bc)+2048>>12,dc=Uc,cc=Sc,ic=(ic+hc+1>>1)+4112,hc=ic-hc,pb=3784*gc+1567*fc+2048>>12,gc=1567*gc-3784*fc+2048>>12,fc=pb,ec=ec+cc+1>>1,cc=ec-cc,bc=bc+dc+1>>1,dc=bc-dc,ic=ic+fc+1>>1,fc=ic-fc,hc=hc+gc+1>>1,gc=hc-gc,pb=2276*ec+3406*bc+2048>>12,ec=3406*ec-2276*bc+2048>>12,bc=pb,pb=799*dc+4017*cc+2048>>12,dc=4017*dc-799*cc+2048>>12,cc=pb,Wc=ic+bc,Bc=ic-bc,Cc=hc+cc,Rc=hc-cc,Vc=\ngc+dc,Sc=gc-dc,Uc=fc+ec,Tc=fc-ec,Wc=16>Wc?0:4080<=Wc?255:Wc>>4,Cc=16>Cc?0:4080<=Cc?255:Cc>>4,Vc=16>Vc?0:4080<=Vc?255:Vc>>4,Uc=16>Uc?0:4080<=Uc?255:Uc>>4,Tc=16>Tc?0:4080<=Tc?255:Tc>>4,Sc=16>Sc?0:4080<=Sc?255:Sc>>4,Rc=16>Rc?0:4080<=Rc?255:Rc>>4,Bc=16>Bc?0:4080<=Bc?255:Bc>>4,Gb[Eb+wb]=Wc,Gb[Eb+wb+8]=Cc,Gb[Eb+wb+16]=Vc,Gb[Eb+wb+24]=Uc,Gb[Eb+wb+32]=Tc,Gb[Eb+wb+40]=Sc,Gb[Eb+wb+48]=Rc,Gb[Eb+wb+56]=Bc)}Kr.call(Fn,{index:Lr,output:sc.blockData,scaleX:sc.h/F.maxH,scaleY:sc.v/F.maxV,blocksPerLine:sc.blocksPerLine,\nblocksPerColumn:sc.blocksPerColumn})}this.numComponents=this.components.length};c._getLinearizedBlockData=function(b,d,e){void 0===e&&(e=!1);var g=this.width/b,f=this.height/d,h,k,l=this.components.length,m=b*d*l,n=new Uint8ClampedArray(m),p=new Uint32Array(b);for(k=0;k<l;k++){var q=this.components[k];var r=q.scaleX*g;var t=q.scaleY*f;var v=k;var w=q.output;var y=q.blocksPerLine+1<<3;if(r!==x){for(h=0;h<b;h++)q=0|h*r,p[h]=(q&4294967288)<<3|q&7;var x=r}for(r=0;r<d;r++)for(q=0|r*t,q=y*(q&4294967288)|\n(q&7)<<3,h=0;h<b;h++)n[v]=w[q+p[h]],v+=l}b=this._decodeTransform;e||4!==l||b||(b=new Int32Array([-256,255,-256,255,-256,255,-256,255]));if(b)for(k=0;k<m;)for(e=q=0;q<l;q++,k++,e+=2)n[k]=(n[k]*b[e]>>8)+b[e+1];return n};c._convertYccToRgb=function(b){for(var d,e,g,f=0,h=b.length;f<h;f+=3)d=b[f],e=b[f+1],g=b[f+2],b[f]=d-179.456+1.402*g,b[f+1]=d+135.459-.344*e-.714*g,b[f+2]=d-226.816+1.772*e;return b};c._convertYccToRgba=function(b,d){for(var e=0,g=0,f=b.length;e<f;e+=3,g+=4){var h=b[e],k=b[e+1],l=b[e+\n2];d[g]=h-179.456+1.402*l;d[g+1]=h+135.459-.344*k-.714*l;d[g+2]=h-226.816+1.772*k;d[g+3]=255}return d};c._convertYcckToRgb=function(b){for(var d,e,g,f,h=0,k=0,l=b.length;k<l;k+=4)d=b[k],e=b[k+1],g=b[k+2],f=b[k+3],b[h++]=-122.67195406894+e*(-6.60635669420364E-5*e+4.37130475926232E-4*g-5.4080610064599E-5*d+4.8449797120281E-4*f-.154362151871126)+g*(-9.57964378445773E-4*g+8.17076911346625E-4*d-.00477271405408747*f+1.53380253221734)+d*(9.61250184130688E-4*d-.00266257332283933*f+.48357088451265)+f*(-3.36197177618394E-4*\nf+.484791561490776),b[h++]=107.268039397724+e*(2.19927104525741E-5*e-6.40992018297945E-4*g+6.59397001245577E-4*d+4.26105652938837E-4*f-.176491792462875)+g*(-7.78269941513683E-4*g+.00130872261408275*d+7.70482631801132E-4*f-.151051492775562)+d*(.00126935368114843*d-.00265090189010898*f+.25802910206845)+f*(-3.18913117588328E-4*f-.213742400323665),b[h++]=-20.810012546947+e*(-5.70115196973677E-4*e-2.63409051004589E-5*g+.0020741088115012*d-.00288260236853442*f+.814272968359295)+g*(-1.53496057440975E-5*\ng-1.32689043961446E-4*d+5.60833691242812E-4*f-.195152027534049)+d*(.00174418132927582*d-.00255243321439347*f+.116935020465145)+f*(-3.43531996510555E-4*f+.24165260232407);return b.subarray(0,h)};c._convertYcckToRgba=function(b){for(var d=0,e=b.length;d<e;d+=4){var g=b[d],f=b[d+1],h=b[d+2],k=b[d+3];b[d]=-122.67195406894+f*(-6.60635669420364E-5*f+4.37130475926232E-4*h-5.4080610064599E-5*g+4.8449797120281E-4*k-.154362151871126)+h*(-9.57964378445773E-4*h+8.17076911346625E-4*g-.00477271405408747*k+1.53380253221734)+\ng*(9.61250184130688E-4*g-.00266257332283933*k+.48357088451265)+k*(-3.36197177618394E-4*k+.484791561490776);b[d+1]=107.268039397724+f*(2.19927104525741E-5*f-6.40992018297945E-4*h+6.59397001245577E-4*g+4.26105652938837E-4*k-.176491792462875)+h*(-7.78269941513683E-4*h+.00130872261408275*g+7.70482631801132E-4*k-.151051492775562)+g*(.00126935368114843*g-.00265090189010898*k+.25802910206845)+k*(-3.18913117588328E-4*k-.213742400323665);b[d+2]=-20.810012546947+f*(-5.70115196973677E-4*f-2.63409051004589E-5*\nh+.0020741088115012*g-.00288260236853442*k+.814272968359295)+h*(-1.53496057440975E-5*h-1.32689043961446E-4*g+5.60833691242812E-4*k-.195152027534049)+g*(.00174418132927582*g-.00255243321439347*k+.116935020465145)+k*(-3.43531996510555E-4*k+.24165260232407);b[d+3]=255}return b};c._convertYcckToCmyk=function(b){for(var d,e,g,f=0,h=b.length;f<h;f+=4)d=b[f],e=b[f+1],g=b[f+2],b[f]=434.456-d-1.402*g,b[f+1]=119.541-d+.344*e+.714*g,b[f+2]=481.816-d-1.772*e;return b};c._convertCmykToRgb=function(b){for(var d,\ne,g,f,h=0,k=0,l=b.length;k<l;k+=4)d=b[k],e=b[k+1],g=b[k+2],f=b[k+3],b[h++]=255+d*(-6.747147073602441E-5*d+8.379262121013727E-4*e+2.894718188643294E-4*g+.003264231057537806*f-1.1185611867203937)+e*(2.6374107616089405E-5*e-8.626949158638572E-5*g-2.748769067499491E-4*f-.02155688794978967)+g*(-3.878099212869363E-5*g-3.267808279485286E-4*f+.0686742238595345)-f*(3.361971776183937E-4*f+.7430659151342254),b[h++]=255+d*(1.3596372813588848E-4*d+9.24537132573585E-4*e+1.0567359618683593E-4*g+4.791864687436512E-4*\nf-.3109689587515875)+e*(-2.3545346108370344E-4*e+2.702845253534714E-4*g+.0020200308977307156*f-.7488052167015494)+g*(6.834815998235662E-5*g+1.5168452363460973E-4*f-.09751927774728933)-f*(3.189131175883281E-4*f+.7364883807733168),b[h++]=255+d*(1.3598650411385307E-5*d+1.2423956175490851E-4*e+4.751985097583589E-4*g-3.6729317476630422E-6*f-.05562186980264034)+e*(1.6141380598724676E-4*e+9.692239130725186E-4*g+7.782692450036253E-4*f-.44015232367526463)+g*(5.068882914068769E-7*g+.0017778369011375071*f-.7591454649749609)-\nf*(3.435319965105553E-4*f+.7063770186160144);return b.subarray(0,h)};c._convertCmykToRgba=function(b){for(var d=0,e=b.length;d<e;d+=4){var g=b[d],f=b[d+1],h=b[d+2],k=b[d+3];b[d]=255+g*(-6.747147073602441E-5*g+8.379262121013727E-4*f+2.894718188643294E-4*h+.003264231057537806*k-1.1185611867203937)+f*(2.6374107616089405E-5*f-8.626949158638572E-5*h-2.748769067499491E-4*k-.02155688794978967)+h*(-3.878099212869363E-5*h-3.267808279485286E-4*k+.0686742238595345)-k*(3.361971776183937E-4*k+.7430659151342254);\nb[d+1]=255+g*(1.3596372813588848E-4*g+9.24537132573585E-4*f+1.0567359618683593E-4*h+4.791864687436512E-4*k-.3109689587515875)+f*(-2.3545346108370344E-4*f+2.702845253534714E-4*h+.0020200308977307156*k-.7488052167015494)+h*(6.834815998235662E-5*h+1.5168452363460973E-4*k-.09751927774728933)-k*(3.189131175883281E-4*k+.7364883807733168);b[d+2]=255+g*(1.3598650411385307E-5*g+1.2423956175490851E-4*f+4.751985097583589E-4*h-3.6729317476630422E-6*k-.05562186980264034)+f*(1.6141380598724676E-4*f+9.692239130725186E-4*\nh+7.782692450036253E-4*k-.44015232367526463)+h*(5.068882914068769E-7*h+.0017778369011375071*k-.7591454649749609)-k*(3.435319965105553E-4*k+.7063770186160144);b[d+3]=255}return b};c.getData=function(b){var d=b.width,e=b.height,g=void 0===b.forceRGBA?!1:b.forceRGBA,f=void 0===b.forceRGB?!1:b.forceRGB;b=void 0===b.isSourcePDF?!1:b.isSourcePDF;if(4<this.numComponents)throw new jd("Unsupported color mode");d=this._getLinearizedBlockData(d,e,b);if(1===this.numComponents&&(g||f)){f=new Uint8ClampedArray(d.length*\n(g?4:3));e=0;if(g)if(g=new Uint32Array(f.buffer),id.isLittleEndian)for(e=0,b=d.length;e<b;e++)g[e]=65793*d[e]|4278190080;else for(e=0,b=d.length;e<b;e++)g[e]=16843008*d[e]|255;else for(d=u.makeIterator(d),g=d.next();!g.done;g=d.next())g=g.value,f[e++]=g,f[e++]=g,f[e++]=g;return f}if(3===this.numComponents&&this._isColorConversionNeeded)return g?(f=new Uint8ClampedArray(d.length/3*4),this._convertYccToRgba(d,f)):this._convertYccToRgb(d);if(4===this.numComponents){if(this._isColorConversionNeeded)return g?\nthis._convertYcckToRgba(d):f?this._convertYcckToRgb(d):this._convertYcckToCmyk(d);if(g)return this._convertCmykToRgba(d);if(f)return this._convertCmykToRgb(d)}return d};return Kp(a,[{key:"_isColorConversionNeeded",get:function(){return this.adobe?!!this.adobe.transformCode:3===this.numComponents?0===this._colorTransform||82===this.components[0].index&&71===this.components[1].index&&66===this.components[2].index?!1:!0:1===this._colorTransform?!0:!1}}])}(),mj=function(a){function c(d,e,g){var f=a.call(this,\ne)||this;f.stream=d;f.dict=d.dict;f.maybeLength=e;f.params=g;return f}Op(c,a);var b=c.prototype;b.ensureBuffer=function(){};b.readBlock=function(){this.decodeImage()};b.__skipUselessBytes=function(d){for(var e=0,g=d.length-1;e<g;e++)if(255===d[e]&&216===d[e+1]){0<e&&(d=d.subarray(e));break}return d};b.decodeImage=function(d){if(this.eof)return this.buffer;d=this.__skipUselessBytes(d||this.bytes);var e=new Hn(this.jpegOptions);e.parse(d);this.buffer=d=e.getData({width:this.drawWidth,height:this.drawHeight,\nforceRGBA:this.forceRGBA,forceRGB:this.forceRGB,isSourcePDF:!0});this.bufferLength=d.length;this.eof=!0;return this.buffer};b.getTransferableImage=function(){var d=Mp(function g(){var f=this,h,k,l,m,n,p,q;return u.generator.createGenerator(g,function(r){switch(r.nextAddress){case 1:return r.yield(c.canUseImageDecoder,2);case 2:if(!r.yieldResult)return r.return(null);h=f.jpegOptions;if(h.decodeTransform)return r.return(null);r.setCatchFinallyBlocks(3,4);if(!(l=f.canAsyncDecodeImageFromBuffer)){r.jumpTo(6);\nbreak}return r.yield(f.stream.asyncGetBytes(),7);case 7:l=r.yieldResult;case 6:m=l||f.bytes;if(!m)return r.return(null);n=f.__skipUselessBytes(m);if(!Hn.canUseImageDecoder(n,h.colorTransform))return r.return(null);k=new ImageDecoder({data:n,type:"image/jpeg",preferAnimation:!1});return r.yield(k.decode(),8);case 8:return r.return(r.yieldResult.image);case 4:r.enterFinallyBlock();null==(p=k)||p.close();r.leaveFinallyBlock(0);break;case 3:return q=r.enterCatchBlock(),T(\'getTransferableImage - failed: "\'+\nq+\'".\'),r.return(null)}})});return function(){return d.apply(this,arguments)}}();return Np(c,[{key:"bytes",get:function(){return Fa(this,"bytes",this.stream.getBytes(this.maybeLength))}},{key:"jpegOptions",get:function(){var d={decodeTransform:void 0,colorTransform:void 0},e=this.dict.getArray("D","Decode");if((this.forceRGBA||this.forceRGB)&&Array.isArray(e)){var g=this.dict.get("BPC","BitsPerComponent")||8,f=e.length,h=new Int32Array(f),k=!1;g=(1<<g)-1;for(var l=0;l<f;l+=2)if(h[l]=256*(e[l+1]-e[l])|\n0,h[l+1]=e[l]*g|0,256!==h[l]||0!==h[l+1])k=!0;k&&(d.decodeTransform=h)}this.params instanceof ca&&(e=this.params.get("ColorTransform"),Number.isInteger(e)&&(d.colorTransform=e));return Fa(this,"jpegOptions",d)}},{key:"canAsyncDecodeImageFromBuffer",get:function(){return this.stream.isAsync}}],[{key:"canUseImageDecoder",get:function(){return Fa(this,"canUseImageDecoder","undefined"===typeof ImageDecoder?Promise.resolve(!1):ImageDecoder.isTypeSupported("image/jpeg"))}}])}(uc);pa(9833);var Pr=function(a){var c=\n"undefined"!=typeof document?null==(a=document.currentScript)?void 0:a.src:void 0;return function(b){function d(S,da,R){var Y=da+R;for(R=da;S[R]&&!(R>=Y);)++R;if(16<R-da&&S.buffer&&la)return la.decode(S.subarray(da,R));for(Y="";da<R;){var fa=S[da++];if(fa&128){var H=S[da++]&63;if(192==(fa&224))Y+=String.fromCharCode((fa&31)<<6|H);else{var U=S[da++]&63;fa=224==(fa&240)?(fa&15)<<12|H<<6|U:(fa&7)<<18|H<<12|U<<6|S[da++]&63;65536>fa?Y+=String.fromCharCode(fa):(fa-=65536,Y+=String.fromCharCode(55296|fa>>\n10,56320|fa&1023))}}else Y+=String.fromCharCode(fa)}return Y}function e(){if(!e.strings){var S={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:("object"==typeof navigator&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",_:q||"./this.program"},da;for(da in W)void 0===W[da]?delete S[da]:S[da]=W[da];var R=[];for(da in S)R.push(da+"="+S[da]);e.strings=R}return e.strings}function g(S){for(;0<S.length;)S.shift()(m)}function f(){var S=x.buffer;\nm.HEAP8=z=new Int8Array(S);m.HEAP16=new Int16Array(S);m.HEAPU8=A=new Uint8Array(S);m.HEAPU16=new Uint16Array(S);m.HEAP32=new Int32Array(S);m.HEAPU32=B=new Uint32Array(S);m.HEAPF32=new Float32Array(S);m.HEAPF64=new Float64Array(S)}function h(){var S;G++;null==(S=m.monitorRunDependencies)||S.call(m,G)}function k(S,da){if(S==M&&y)S=new Uint8Array(y);else{if(S.startsWith(L)){var R=S.slice(L.length);R=atob(R);for(var Y=new Uint8Array(R.length),fa=0;fa<R.length;++fa)Y[fa]=R.charCodeAt(fa);R=Y}else R=void 0;\nif(R)S=R;else if(t)S=t(S);else throw\'sync fetching of the wasm failed: you can preload it to Module["wasmBinary"] manually, or emcc.py will do that for you when generating HTML (but not JS)\';}S=new WebAssembly.Module(S);return[new WebAssembly.Instance(S,da),S]}function l(){function S(){if(!va){va=!0;m.calledRun=!0;g(D);n(m);if(m.onRuntimeInitialized)m.onRuntimeInitialized();if(m.postRun)for("function"==typeof m.postRun&&(m.postRun=[m.postRun]);m.postRun.length;)E.unshift(m.postRun.shift());g(E)}}\nif(!(0<G)){if(m.preRun)for("function"==typeof m.preRun&&(m.preRun=[m.preRun]);m.preRun.length;)C.unshift(m.preRun.shift());g(C);0<G||(m.setStatus?(m.setStatus("Running..."),setTimeout(function(){setTimeout(function(){m.setStatus("")},1);S()},1)):S())}}void 0===b&&(b={});var m=b,n,p;new Promise(function(S,da){n=S;p=da});m.decode=function(S,da){var R=void 0===da.numComponents?4:da.numComponents,Y=void 0===da.isIndexedColormap?!1:da.isIndexedColormap,fa=void 0===da.smaskInData?!1:da.smaskInData,H=S.length;\nda=m._malloc(H);m.HEAPU8.set(S,da);S=m._jp2_decode(da,H,0<R?R:0,!!Y,!!fa);m._free(da);if(S)return(S=m.errorMessages)?(delete m.errorMessages,S):"Unknown error";S=m.imageData;m.imageData=null;return S};b=Object.assign({},m);var q="./this.program",r="",t;"undefined"!=typeof document&&document.currentScript&&(r=document.currentScript.src);c&&(r=c);r=r.startsWith("blob:")?"":r.substr(0,r.replace(/[?#].*/,"").lastIndexOf("/")+1);var v=m.print||console.log.bind(console),w=m.printErr||console.error.bind(console);\nObject.assign(m,b);b=null;m.thisProgram&&(q=m.thisProgram);var y;m.wasmBinary&&(y=m.wasmBinary);var x,z,A,B,C=[],D=[],E=[],G=0,J=null,F=null,L="data:application/octet-stream;base64,",M,W={},Q=[null,[],[]],la="undefined"!=typeof TextDecoder?new TextDecoder("utf8"):void 0,ta={c:function(S,da,R){return A.copyWithin(S,da,da+R)},g:function(S,da){S>>=2;var R=m.imageData=new Uint8ClampedArray(da);S=m.HEAP32.subarray(S,S+da);R.set(S)},f:function(S,da,R,Y){S>>=2;da>>=2;R>>=2;var fa=m.imageData=new Uint8ClampedArray(3*\nY);S=m.HEAP32.subarray(S,S+Y);da=m.HEAP32.subarray(da,da+Y);R=m.HEAP32.subarray(R,R+Y);for(var H=0;H<Y;H++)fa[3*H]=S[H],fa[3*H+1]=da[H],fa[3*H+2]=R[H]},e:function(S,da,R,Y,fa){S>>=2;da>>=2;R>>=2;Y>>=2;var H=m.imageData=new Uint8ClampedArray(4*fa);S=m.HEAP32.subarray(S,S+fa);da=m.HEAP32.subarray(da,da+fa);R=m.HEAP32.subarray(R,R+fa);Y=m.HEAP32.subarray(Y,Y+fa);for(var U=0;U<fa;U++)H[4*U]=S[U],H[4*U+1]=da[U],H[4*U+2]=R[U],H[4*U+3]=Y[U]},k:function(S){var da=A.length;S>>>=0;if(2147483648<S)return!1;\nfor(var R=1;4>=R;R*=2){var Y=da*(1+.2/R);Y=Math.min(Y,S+100663296);var fa=Math;Y=Math.max(S,Y);a:{fa=(fa.min.call(fa,2147483648,Y+(65536-Y%65536)%65536)-x.buffer.byteLength+65535)/65536;try{x.grow(fa);f();var H=1;break a}catch(U){}H=void 0}if(H)return!0}return!1},l:function(S,da){var R=0;e().forEach(function(Y,fa){var H=da+R;fa=B[S+4*fa>>2]=H;for(H=0;H<Y.length;++H)z[fa++]=Y.charCodeAt(H);z[fa]=0;R+=Y.length+1});return 0},m:function(S,da){var R=e();B[S>>2]=R.length;var Y=0;R.forEach(function(fa){return Y+=\nfa.length+1});B[da>>2]=Y;return 0},n:function(){return 52},j:function(){return 70},b:function(S,da,R,Y){for(var fa=0,H=0;H<R;H++){var U=B[da>>2],N=B[da+4>>2];da+=8;for(var ba=0;ba<N;ba++){var aa=S,X=A[U+ba],ha=Q[aa];0===X||10===X?((1===aa?v:w)(d(ha,0)),ha.length=0):ha.push(X)}fa+=N}B[Y>>2]=fa;return 0},o:function(S,da){S>>=2;var R=m.imageData=new Uint8ClampedArray(4*da);S=m.HEAP32.subarray(S,S+da);for(var Y=0;Y<da;Y++)R[4*Y]=R[4*Y+1]=R[4*Y+2]=S[Y],R[4*Y+3]=255},i:function(S,da,R){S>>=2;da>>=2;var Y=\nm.imageData=new Uint8ClampedArray(4*R);S=m.HEAP32.subarray(S,S+R);da=m.HEAP32.subarray(da,da+R);for(var fa=0;fa<R;fa++)Y[4*fa]=Y[4*fa+1]=Y[4*fa+2]=S[fa],Y[4*fa+3]=da[fa]},d:function(S){S=S?d(A,S,void 0):"";(m.warn||console.warn)("OpenJPEG: "+S)},h:function(S,da,R,Y){S>>=2;da>>=2;R>>=2;var fa=m.imageData=new Uint8ClampedArray(4*Y);S=m.HEAP32.subarray(S,S+Y);da=m.HEAP32.subarray(da,da+Y);R=m.HEAP32.subarray(R,R+Y);for(var H=0;H<Y;H++)fa[4*H]=S[H],fa[4*H+1]=da[H],fa[4*H+2]=R[H],fa[4*H+3]=255},a:function(S){S=\nS?d(A,S,void 0):"";m.errorMessages=m.errorMessages?m.errorMessages+("\\n"+S):S}},qa=function(){function S(R){qa=R.exports;x=qa.p;f();D.unshift(qa.q);var Y;G--;null==(Y=m.monitorRunDependencies)||Y.call(m,G);0==G&&(null!==J&&(clearInterval(J),J=null),F&&(R=F,F=null,R()));return qa}var da={a:ta};h("wasm-instantiate");if(m.instantiateWasm)try{return m.instantiateWasm(da,S)}catch(R){w("Module.instantiateWasm callback failed with error: "+R),p(R)}M||(M="data:application/octet-stream;base64,AGFzbQEAAAABzgEaYAN/f38Bf2AEf39/fwF/YAF/AGACf38AYAF/AX9gA39/fwBgAn9/AX9gBH9/f38AYAN/fn8BfmAFf39/f38Bf2ACfn8Bf2ACfn8BfmAFf39/f38AYAN/fn8Bf2AAAX9gB39/f39/f38Bf2AJf39/f39/f39/AX9gC39/f39/f39/f39/AX9gBn9/f39/fwF/YAZ/fH9/f38Bf2AIf39/f39/f38AYAh/f39/f39/fwF/YAAAYAZ/f39/f38AYAd/f39/f39/AGACfH8BfAJbDwFhAWEAAgFhAWIAAQFhAWMABQFhAWQAAgFhAWUADAFhAWYABwFhAWcAAwFhAWgABwFhAWkABQFhAWoACQFhAWsABAFhAWwABgFhAW0ABgFhAW4ABAFhAW8AAwPAAb4BBwIFAAYEAAUGBAUBBAwFFAYCAgICAAYQEQQCChICBQIEBwQCDgICDQYCFQMHAAAEAwEWCQkDAAkGAQQEBQUODwEBAwADBgIQBBcYAgcGAwcHAQECAAQZBAYHBA8MAAQCAgIABgAGAQEBAQEBAQEAAAAAAAYDAgICAwMDAwMAAxMIBA4EAAgDAwkECAoLCAAAAQEBAQEBAQENAQAEBAUJDwESEQEAAAYDAwEFBQUFBQUFBQELAQEBAQEBAQEBCgQFAXABbm4FBwEBggKAgAIGCAF/AUGQ2QULBxsGAXACAAFxAEEBcgCYAQFzABABdAEAAXUAlwEJvQEBAEEBC21RzAHCAXNzNqcBnAGZAYsBigGJAYgBhwGGAYUBhAFSgQGAAX9+fXx7enl4d3Z1ywHKAckByAHHAcYBQMUBxAFAQMMBwQHAAb8BvgG9AbwBuwG6AbkBswGoAaYBpQGkAaMBogGhAaABnwGeAZ0BmwGaAUlKTFJIgwFTOFCCAU9FRk4rJ6sBqgGsAbQBuAG1Aa8BqQGtAa4BtgG3AXCwAbEBsgFRlgGVAYwBjgGNAZIBkwGUAZABjwEKkZoOvgGCAgEDfyMAQZAEayIEJAACQCAARQ0AAkACQAJAAkAgAUEBaw4EAAEEAgQLIABBDGohAQwCCyAAQRBqIQEgAEEEaiEADAELIABBFGohASAAQQhqIQALIAEoAgAiBUUNACACRQ0AIAAoAgAhBiAEQQBBgAQQFSIBIAM2AowEIwBBoAFrIgAkACAAIAE2ApQBIABB/wM2ApgBIABBAEGQARAVIgBBfzYCTCAAQeYANgIkIABBfzYCUCAAIABBnwFqNgIsIAAgAEGUAWo2AlQgAUEAOgAAIAAgAiADQecAQegAEGsgAEGgAWokACABQQA6AP8DIAEgBiAFEQMACyAEQZAEaiQAC9ACAQV/IAAEQCAAQQRrIgMoAgAiBCEBIAMhAiAAQQhrKAIAIgAgAEF+cSIARwRAIAIgAGsiAigCBCIBIAIoAggiBTYCCCAFIAE2AgQgACAEaiEBCyADIARqIgAoAgAiAyAAIANqQQRrKAIARwRAIAAoAgQiBCAAKAIIIgA2AgggACAENgIEIAEgA2ohAQsgAiABNgIAIAIgAUF8cWpBBGsgAUEBcjYCACACAn8gAigCAEEIayIAQf8ATQRAIABBA3ZBAWsMAQsgAGchAyAAQR0gA2t2QQRzIANBAnRrQe4AaiAAQf8fTQ0AGkE/IABBHiADa3ZBAnMgA0EBdGtBxwBqIgAgAEE/TxsLIgFBBHQiAEGgxwFqNgIEIAIgAEGoxwFqIgAoAgA2AgggACACNgIAIAIoAgggAjYCBEGozwFBqM8BKQMAQgEgAa2GhDcDAAsLyQIBBH8gAUEANgIAAkAgAkUNACABIAJqIQMCQCACQRBJBEAgACEBDAELAkAgACACaiABTQ0AIAAgA08NACAAIQEMAQsgA0EQayEGIAAgAkFwcSIFaiEBIAMgBWshAwNAIAYgBGsgACAEav0AAAD9DAAAAAAAAAAAAAAAAAAAAAD9DQ8ODQwLCgkIBwYFBAMCAQD9CwAAIARBEGoiBCAFRw0ACyACIAVGDQELAkAgAkEDcSIGRQRAIAUhBAwBC0EAIQAgBSEEA0AgA0EBayIDIAEtAAA6AAAgBEEBaiEEIAFBAWohASAAQQFqIgAgBkcNAAsLIAUgAmtBfEsNAANAIANBAWsgAS0AADoAACADQQJrIAEtAAE6AAAgA0EDayABLQACOgAAIANBBGsiAyABLQADOgAAIAFBBGohASAEQQRqIgQgAkcNAAsLC4AEAQN/IAJBgARPBEAgACABIAIQAiAADwsgACACaiEDAkAgACABc0EDcUUEQAJAIABBA3FFBEAgACECDAELIAJFBEAgACECDAELIAAhAgNAIAIgAS0AADoAACABQQFqIQEgAkEBaiICQQNxRQ0BIAIgA0kNAAsLAkAgA0F8cSIEQcAASQ0AIAIgBEFAaiIFSw0AA0AgAiABKAIANgIAIAIgASgCBDYCBCACIAEoAgg2AgggAiABKAIMNgIMIAIgASgCEDYCECACIAEoAhQ2AhQgAiABKAIYNgIYIAIgASgCHDYCHCACIAEoAiA2AiAgAiABKAIkNgIkIAIgASgCKDYCKCACIAEoAiw2AiwgAiABKAIwNgIwIAIgASgCNDYCNCACIAEoAjg2AjggAiABKAI8NgI8IAFBQGshASACQUBrIgIgBU0NAAsLIAIgBE8NAQNAIAIgASgCADYCACABQQRqIQEgAkEEaiICIARJDQALDAELIANBBEkEQCAAIQIMAQsgACADQQRrIgRLBEAgACECDAELIAAhAgNAIAIgAS0AADoAACACIAEtAAE6AAEgAiABLQACOgACIAIgAS0AAzoAAyABQQRqIQEgAkEEaiICIARNDQALCyACIANJBEADQCACIAEtAAA6AAAgAUEBaiEBIAJBAWoiAiADRw0ACwsgAAswAQF/AkAgAEUNACABRQ0AQQggACABbCIBECUiAARAIABBACABEBUaCyAAIQILIAILEQAgAEUEQEEADwtBCCAAECUL8gICAn8BfgJAIAJFDQAgACABOgAAIAAgAmoiA0EBayABOgAAIAJBA0kNACAAIAE6AAIgACABOgABIANBA2sgAToAACADQQJrIAE6AAAgAkEHSQ0AIAAgAToAAyADQQRrIAE6AAAgAkEJSQ0AIABBACAAa0EDcSIEaiIDIAFB/wFxQYGChAhsIgE2AgAgAyACIARrQXxxIgRqIgJBBGsgATYCACAEQQlJDQAgAyABNgIIIAMgATYCBCACQQhrIAE2AgAgAkEMayABNgIAIARBGUkNACADIAE2AhggAyABNgIUIAMgATYCECADIAE2AgwgAkEQayABNgIAIAJBFGsgATYCACACQRhrIAE2AgAgAkEcayABNgIAIAQgA0EEcUEYciIEayICQSBJDQAgAa1CgYCAgBB+IQUgAyAEaiEBA0AgASAFNwMYIAEgBTcDECABIAU3AwggASAFNwMAIAFBIGohASACQSBrIgJBH0sNAAsLIAALJwEBfyMAQRBrIgMkACADIAI2AgwgACABIAJBAEEAEGsgA0EQaiQAC+gFAQl/IAFFBEBBAA8LAn8gAEUEQEEIIAEQJQwBCyABRQRAIAAQEEEADAELAkAgAUFHSw0AIAACf0EIIAFBA2pBfHEgAUEITRsiB0EIaiEBAkACfwJAIABBBGsiCiIEKAIAIgUgBGoiAigCACIJIAIgCWoiCEEEaygCAEcEQCAIIAEgBGoiA0EQak8EQCACKAIEIgUgAigCCCICNgIIIAIgBTYCBCADIAggA2siAjYCACADIAJBfHFqQQRrIAJBAXI2AgAgAwJ/IAMoAgBBCGsiAkH/AE0EQCACQQN2QQFrDAELIAJBHSACZyIFa3ZBBHMgBUECdGtB7gBqIAJB/x9NDQAaQT8gAkEeIAVrdkECcyAFQQF0a0HHAGoiAiACQT9PGwsiAkEEdCIFQaDHAWo2AgQgAyAFQajHAWoiBSgCADYCCCAFIAM2AgAgAygCCCADNgIEQajPAUGozwEpAwBCASACrYaENwMAIAQgATYCAAwECyADIAhLDQEgAigCBCIBIAIoAggiAzYCCCADIAE2AgQgBCAFIAlqIgE2AgAMAwsgBSABQRBqTwRAIAQgATYCACAEIAFBfHFqQQRrIAE2AgAgASAEaiIDIAUgAWsiATYCACADIAFBfHFqQQRrIAFBAXI2AgAgAwJ/IAMoAgBBCGsiAUH/AE0EQCABQQN2QQFrDAELIAFBHSABZyIEa3ZBBHMgBEECdGtB7gBqIAFB/x9NDQAaQT8gAUEeIARrdkECcyAEQQF0a0HHAGoiASABQT9PGwsiAUEEdCIEQaDHAWo2AgQgAyAEQajHAWoiBCgCADYCCCAEIAM2AgAgAygCCCADNgIEQajPAUGozwEpAwBCASABrYaENwMAQQEMBAtBASABIAVNDQEaC0EACwwBCyAEIAFBfHFqQQRrIAE2AgBBAQsNARpBCCAHECUiAUUNACABIAAgByAKKAIAQQhrIgYgBiAHSxsQEhogABAQIAEhBgsgBgsLNwECfyMAQRBrIgEkACAABH8gAUEMakEQIAAQbCEAQQAgASgCDCAAGwVBAAshAiABQRBqJAAgAgsXACAALQAAQSBxRQRAIAEgAiAAED0aCwu8BAEFfyACIAAoAjAiBU0EQCABIAAoAiQgAhASGiAAIAAoAiQgAmo2AiQgACAAKAIwIAJrNgIwIAAgACkDOCACrXw3AzggAg8LIAAtAERBBHEEQCABIAAoAiQgBRASGiAAKAIwIQEgAEEANgIwIAAgASAAKAIkajYCJCAAIAApAzggAa18NwM4IAVBfyAFGw8LAkAgBQRAIAEgACgCJCAFEBIhBCAAIAAoAiAiBzYCJCAAKAIwIQEgAEEANgIwIAAgACkDOCABrXw3AzggAiABayECIAEgBGohAQwBCyAAIAAoAiAiBzYCJAsCQAJAA0ACQCAAKAIAIQQgACgCECEGAkAgACgCQCIIIAJLBEAgACAHIAggBCAGEQAAIgY2AjAgBkF/RgRADAYLIAIgBk0NAiABIAAoAiQgBhASGiAAIAAoAiAiBzYCJCAAKAIwIQQMAQsgACABIAIgBCAGEQAAIgQ2AjAgBEF/RgRADAULIAIgBE0NAyAAIAAoAiAiBzYCJCAEIQYLIABBADYCMCAAIAApAzggBK18NwM4IAEgBGohASACIARrIQIgBSAGaiEFDAELCyABIAAoAiQgAhASGiAAIAAoAiQgAmo2AiQgACAAKAIwIAJrNgIwIAAgACkDOCACrXw3AzggAiAFag8LIABBADYCMCAAIAAoAiA2AiQgACAAKQM4IAStfDcDOCAEIAVqDwsgA0EEQZv1AEEAEA8gAEEANgIwIAAgACgCREEEcjYCRCAFQX8gBRsLiwcCDX8BfiAAKAIQIgdBIE8EQCAAKQMIpw8LAkAgACgCGCICQQROBEAgACgCACIBKAIAIQQgACACQQRrIgU2AhggACABQQRqNgIADAELQX9BACAAKAIcGyEEIAJBAEwEQCACIQUMAQsgAkEBcSEMIAAoAgAhAQJAIAJBAUYEQCABIQYMAQsgAkH+////B3EhCgNAIAAgAUEBajYCACABLQAAIQkgACABQQJqIgY2AgAgACACQQFrNgIYIAEtAAEhASAAIAJBAmsiAjYCGCAEQf8BIAN0QX9zcSAJIAN0ckGA/gMgA3RBf3NxIAEgA0EIcnRyIQQgA0EQaiEDIAYhASAFQQJqIgUgCkcNAAsLQQAhBSAMRQ0AIAAgBkEBajYCACAGLQAAIQEgACACQQFrNgIYIARB/wEgA3RBf3NxIAEgA3RyIQQLIAAoAhQhASAAIARBGHYiCkH/AUY2AhQgAEEHQQggARsiAUEHQQggBEH/AXEiBkH/AUYbaiICQQdBCCAEQQh2Qf8BcSIDQf8BRhtqIglBB0EIIARBEHZB/wFxIgRB/wFGGyAHamoiCDYCECAAIAApAwggAyABdCAEIAJ0ciAKIAl0ciAGcq0gB62GhCIONwMIIAhBH00EQAJAIAVBBE4EQCAAKAIAIgEoAgAhAiAAIAVBBGs2AhggACABQQRqNgIADAELQQAhA0F/QQAgACgCHBshAiAFQQBMDQAgBUEBcSENIAAoAgAhAQJAIAVBAUYEQCABIQQMAQsgBUH+////B3EhCUEAIQYDQCAAIAFBAWo2AgAgAS0AACELIAAgAUECaiIENgIAIAAgBUEBazYCGCABLQABIQEgACAFQQJrIgU2AhggAkH/ASADdEF/c3EgCyADdHJBgP4DIAN0QX9zcSABIANBCHJ0ciECIANBEGohAyAEIQEgBkECaiIGIAlHDQALCyANRQ0AIAAgBEEBajYCACAELQAAIQEgACAFQQFrNgIYIAJB/wEgA3RBf3NxIAEgA3RyIQILIAAgAkEYdiIBQf8BRjYCFCAAQQdBCCAKQf8BRhsiBEEHQQggAkH/AXEiBkH/AUYbaiIFQQdBCCACQQh2Qf8BcSIDQf8BRhtqIgdBB0EIIAJBEHZB/wFxIgJB/wFGGyAIamo2AhAgACADIAR0IAIgBXRyIAEgB3RyIAZyrSAIrYYgDoQiDjcDCAsgDqcLawEBfyMAQYACayIFJAACQCACIANMDQAgBEGAwARxDQAgBSABIAIgA2siA0GAAiADQYACSSIBGxAVGiABRQRAA0AgACAFQYACEBkgA0GAAmsiA0H/AUsNAAsLIAAgBSADEBkLIAVBgAJqJAALMQAgAQJ/IAIoAkxBAEgEQCAAIAEgAhA9DAELIAAgASACED0LIgBGBEAPCyAAIAFuGgsXACAAIAEgAiADIAQgBSAGIAdBARAmGguhAQEEfyABQQBMBEBBAA8LIAAoAgwhAiAAKAIQIQMDQCABIQUCQCADDQAgACACQQh0QYD+A3EiAjYCDCAAQQdBCCACQYD+A0YbIgM2AhAgACgCCCIBIAAoAgRPDQAgACABQQFqNgIIIAAgAiABLQAAciICNgIMCyAAIANBAWsiAzYCECACIAN2QQFxIAVBAWsiAXQgBHIhBCAFQQFLDQALIAQLHgAgACgCDARAIABBADYCKANAIAAoAhhBAEoNAAsLC2oBA38gAARAIAAoAhgiAQRAIAAoAhAiAgR/QQAhAQNAIAAoAhggAUE0bGooAiwiAwRAIAMQECAAKAIQIQILIAFBAWoiASACSQ0ACyAAKAIYBSABCxAQCyAAKAIcIgEEQCABEBALIAAQEAsLkhUBD38CQAJAIAAoAgxFBEBBASEPIAAoAgRBAEoNASAAKAIIQQFKDQEMAgtBASENIAAoAghBAEoNACAAKAIEQQJIDQELIAAoAgAiCCANQQV0aiEEAkAgACgCECIHIAAoAhQiCk8NACAEIAdBBnRqIQECQCAKIAdrQQNxIgZFBEAgByECDAELIAchAgNAIAEgAf0ABAD9DFh2nT9Ydp0/WHadP1h2nT/95gH9CwQAIAEgAf0ABBD9DFh2nT9Ydp0/WHadP1h2nT/95gH9CwQQIAFBQGshASACQQFqIQIgA0EBaiIDIAZHDQALCyAHIAprQXxLDQADQCABIAH9AAQA/QxYdp0/WHadP1h2nT9Ydp0//eYB/QsEACABIAH9AAQQ/QxYdp0/WHadP1h2nT9Ydp0//eYB/QsEECABIAH9AARA/QxYdp0/WHadP1h2nT9Ydp0//eYB/QsEQCABIAH9AARQ/QxYdp0/WHadP1h2nT9Ydp0//eYB/QsEUCABIAH9AASAAf0MWHadP1h2nT9Ydp0/WHadP/3mAf0LBIABIAEgAf0ABJAB/QxYdp0/WHadP1h2nT9Ydp0//eYB/QsEkAEgASAB/QAEwAH9DFh2nT9Ydp0/WHadP1h2nT/95gH9CwTAASABIAH9AATQAf0MWHadP1h2nT9Ydp0/WHadP/3mAf0LBNABIAFBgAJqIQEgAkEEaiICIApHDQALCyAIIA9BBXRqIQUCQCAAKAIYIgYgACgCHCILTw0AIAUgBkEGdGohAQJAIAsgBmtBA3EiCEUEQCAGIQIMAQtBACEDIAYhAgNAIAEgAf0ABAD9DAAY0D8AGNA/ABjQPwAY0D/95gH9CwQAIAEgAf0ABBD9DAAY0D8AGNA/ABjQPwAY0D/95gH9CwQQIAFBQGshASACQQFqIQIgA0EBaiIDIAhHDQALCyAGIAtrQXxLDQADQCABIAH9AAQA/QwAGNA/ABjQPwAY0D8AGNA//eYB/QsEACABIAH9AAQQ/QwAGNA/ABjQPwAY0D8AGNA//eYB/QsEECABIAH9AARA/QwAGNA/ABjQPwAY0D8AGNA//eYB/QsEQCABIAH9AARQ/QwAGNA/ABjQPwAY0D8AGNA//eYB/QsEUCABIAH9AASAAf0MABjQPwAY0D8AGNA/ABjQP/3mAf0LBIABIAEgAf0ABJAB/QwAGNA/ABjQPwAY0D8AGNA//eYB/QsEkAEgASAB/QAEwAH9DAAY0D8AGNA/ABjQPwAY0D/95gH9CwTAASABIAH9AATQAf0MABjQPwAY0D8AGNA/ABjQP/3mAf0LBNABIAFBgAJqIQEgAkEEaiICIAtHDQALCyAKIAAoAggiCSAAKAIEIg4gDWsiACAAIAlKGyIIIAggCksbIQwgBEEgaiEBAn8gB0UEQCAMRQRAQQAhAyABDAILIAQgBP0ABAAgBf0ABAAgBP0ABCD95AH9DFUT4z5VE+M+VRPjPlUT4z795gH95QH9CwQAIAQgBP0ABBAgBf0ABBAgBP0ABDD95AH9DFUT4z5VE+M+VRPjPlUT4z795gH95QH9CwQQQQEhAyAEQeAAagwBCyABIAciA0EGdGoLIQIgAyAMSQRAA0AgAkEgayIAIAD9AAQAIAJBQGr9AAQAIAL9AAQA/eQB/QxVE+M+VRPjPlUT4z5VE+M+/eYB/eUB/QsEACACQRBrIgAgAP0ABAAgAkEwa/0ABAAgAv0ABBD95AH9DFUT4z5VE+M+VRPjPlUT4z795gH95QH9CwQAIAJBQGshAiADQQFqIgMgDEcNAAsLIAggCk8iDUUEQCACQSBrIgAgAP0ABAAgAkFAav0ABAD9DFUTYz9VE2M/VRNjP1UTYz/95gH95QH9CwQAIAJBEGsiACAA/QAEACACQTBr/QAEAP0MVRNjP1UTYz9VE2M/VRNjP/3mAf3lAf0LBAALIAsgDiAJIA9rIgAgACAOShsiDiALIA5JGyEJIAVBIGohAiAJAn8gBkUEQCAJRQRAIAIhA0EADAILIAUgBf0ABAAgBP0ABAAgBf0ABCD95AH9DHYGYj92BmI/dgZiP3YGYj/95gH95QH9CwQAIAUgBf0ABBAgBP0ABBAgBf0ABDD95AH9DHYGYj92BmI/dgZiP3YGYj/95gH95QH9CwQQIAVB4ABqIQNBAQwBCyACIAZBBnRqIQMgBgsiAEsEQANAIANBIGsiCCAI/QAEACADQUBq/QAEACAD/QAEAP3kAf0MdgZiP3YGYj92BmI/dgZiP/3mAf3lAf0LBAAgA0EQayIIIAj9AAQAIANBMGv9AAQAIAP9AAQQ/eQB/Qx2BmI/dgZiP3YGYj92BmI//eYB/eUB/QsEACADQUBrIQMgAEEBaiIAIAlHDQALCyALIA5NIghFBEAgA0EgayIAIAD9AAQAIANBQGr9AAQA/Qx2BuI/dgbiP3YG4j92BuI//eYB/eUB/QsEACADQRBrIgAgAP0ABAAgA0Ewa/0ABAD9DHYG4j92BuI/dgbiP3YG4j/95gH95QH9CwQACwJAIAdFBEAgDEUEQEEAIQcMAgsgBCAE/QAEACAF/QAEACAE/QAEIP3kAf0MrgFZPa4BWT2uAVk9rgFZPf3mAf3kAf0LBAAgBCAE/QAEECAF/QAEECAE/QAEMP3kAf0MrgFZPa4BWT2uAVk9rgFZPf3mAf3kAf0LBBAgBEHgAGohAUEBIQcMAQsgASAHQQZ0aiEBCyAHIAxJBEADQCABQSBrIgAgAP0ABAAgAUFAav0ABAAgAf0ABAD95AH9DK4BWT2uAVk9rgFZPa4BWT395gH95AH9CwQAIAFBEGsiACAA/QAEACABQTBr/QAEACAB/QAEEP3kAf0MrgFZPa4BWT2uAVk9rgFZPf3mAf3kAf0LBAAgAUFAayEBIAdBAWoiByAMRw0ACwsgDUUEQCABQSBrIgAgAP0ABAAgAUFAav0ABAD9DK4B2T2uAdk9rgHZPa4B2T395gH95AH9CwQAIAFBEGsiACAA/QAEACABQTBr/QAEAP0MrgHZPa4B2T2uAdk9rgHZPf3mAf3kAf0LBAALAkAgBkUEQCAJRQRAQQAhBgwCCyAFIAX9AAQAIAT9AAQAIAX9AAQg/eQB/QxzBss/cwbLP3MGyz9zBss//eYB/eQB/QsEACAFIAX9AAQQIAT9AAQQIAX9AAQw/eQB/QxzBss/cwbLP3MGyz9zBss//eYB/eQB/QsEECAFQeAAaiECQQEhBgwBCyACIAZBBnRqIQILIAYgCUkEQANAIAJBIGsiACAA/QAEACACQUBq/QAEACAC/QAEAP3kAf0McwbLP3MGyz9zBss/cwbLP/3mAf3kAf0LBAAgAkEQayIAIAD9AAQAIAJBMGv9AAQAIAL9AAQQ/eQB/QxzBss/cwbLP3MGyz9zBss//eYB/eQB/QsEACACQUBrIQIgBkEBaiIGIAlHDQALCyAIDQAgAkEgayIAIAD9AAQAIAJBQGr9AAQA/QxzBktAcwZLQHMGS0BzBktA/eYB/eQB/QsEACACQRBrIgAgAP0ABAAgAkEwa/0ABAD9DHMGS0BzBktAcwZLQHMGS0D95gH95AH9CwQACwtdAQR/IAAEQCAAKAIUIgEgACgCECICbARAA0AgACgCGCADQQJ0aigCACIEBEAgBBAQIAAoAhAhAiAAKAIUIQELIANBAWoiAyABIAJsSQ0ACwsgACgCGBAQIAAQEAsLhQEBAn8CQAJAIAAoAgQiAyAAKAIAIgRHBEAgACgCCCEDDAELIAAgA0EKaiIENgIEIAAoAgggBEECdBAXIgNFDQEgACADNgIIIAAoAgAhBAsgAyAEQQJ0aiABNgIAIAAgBEEBajYCAEEBDwsgACgCCBAQIABCADcCACACQQFB0i5BABAPQQALkwQCBn8CfgJAAkADQCAAIABBAWtxDQEgAUFHSw0BIABBCCAAQQhLIgcbIQBBqM8BKQMAIggCf0EIIAFBA2pBfHEgAUEITRsiAUH/AE0EQCABQQN2QQFrDAELIAFnIQMgAUEdIANrdkEEcyADQQJ0a0HuAGogAUH/H00NABpBPyABQR4gA2t2QQJzIANBAXRrQccAaiIDIANBP08bCyIDrYgiCUIAUgRAA0AgCSAJeiIIiCEJAn4gAyAIp2oiA0EEdCIEQajHAWooAgAiAiAEQaDHAWoiBUcEQCACIAAgARA8IgQNBiACKAIEIgQgAigCCCIGNgIIIAYgBDYCBCACIAU2AgggAiAFKAIENgIEIAUgAjYCBCACKAIEIAI2AgggA0EBaiEDIAlCAYgMAQtBqM8BQajPASkDAEJ+IAOtiYM3AwAgCUIBhQsiCUIAUg0AC0GozwEpAwAhCAtBPyAIeadrIQUCQCAIUARAQQAhAgwBCyAFQQR0IgRBqMcBaigCACECIAhCgICAgARUDQBB4wAhAyACIARBoMcBaiIGRg0AA0AgA0UNASACIAAgARA8IgQNBCADQQFrIQMgAigCCCICIAZHDQALCyABIABBMGpBMCAHG2oQbQ0ACyACRQ0AIAIgBUEEdEGgxwFqIgNGDQADQCACIAAgARA8IgQNAiACKAIIIgIgA0cNAAsLQQAhBAsgBAvaIwIrfwN7AkAgACgCACIJIANJDQAgASADTw0AIAEgCU8NACAAKAIEIgkgBEkNACACIARPDQAgAiAJTw0AIAVBHGshJyAAKAIIIhlBAnQhESAHQQJ0IQ8gBkECdCEfIAVBBGshKCACIAAoAgxuIR4gGSAZIAEgGW4iKWwgAWtqISogBkEIRyEjIAIhHQNAIAAoAgwiCSEKIAIgHUYEQCAJIAIgCXBrIQoLIAogBCAdayIMIAogDEkbIhNBfHEhGyATQQNxIRYgE0F4cSErIBNBB3EhJCATQQFrIRogGSAJQQJ0IApBAnRrQQRqbCEgIAZBAkYgE0EBRnEhLCAJIAprIBlsISUgJyAPIB0gAmsiDGwiCWohJiAJIChqIS0gBSAJaiEuIAUgByAMbEECdGohHCApISEgASEYA0AgKiAZIAEgGEYbIgwgAyAYayIJIAkgDEsbIRAgGSAMayEJICFBAnQiDSAAKAIYIAAoAhAgHmxBAnRqaigCACESAkACQCAIBEACQAJAAkACQAJAIBIEQCASICVBAnRqIAlBAnRqIQogGCABayENIAZBAUYNBCAcIAYgDWxBAnRqIQsgEEEBRg0DICwNAiAjDQEgEEEHTQ0BIBNFDQggJiANIB9saiAQQQV0aiEVIBIgICAQQQJ0aiAMQQJ0a2ohIiAQQXxxIQ1BACESDAULIAZBAUcEQCATRQ0IIBBBfHEhDSAQQQNxIQwgHCAYIAFrIAZsQQJ0aiELQQAhEiAQQQFrQQNJIRQDQAJAIBBFDQBBACEJQQAhCkEAIQ4gFEUEQANAIAsgBiAKbEECdGpBADYCACALIApBAXIgBmxBAnRqQQA2AgAgCyAKQQJyIAZsQQJ0akEANgIAIAsgCkEDciAGbEECdGpBADYCACAKQQRqIQogDkEEaiIOIA1HDQALCyAMRQ0AA0AgCyAGIApsQQJ0akEANgIAIApBAWohCiAJQQFqIgkgDEcNAAsLIAsgD2ohCyATIBJBAWoiEkcNAAsMCAsgE0UNByAQQQJ0IQwgHCAYIAFrQQJ0aiELQQAhCSAaQQdPBEADQCALQQAgDBAVIA9qQQAgDBAVIA9qQQAgDBAVIA9qQQAgDBAVIA9qQQAgDBAVIA9qQQAgDBAVIA9qQQAgDBAVIA9qQQAgDBAVIA9qIQsgCUEIaiIJICtHDQALC0EAIQkgJEUNBwNAIAtBACAMEBUgD2ohCyAJQQFqIgkgJEcNAAsMBwsgE0UNBiAQQXxxIRQgEEEDcSESQQAhDSAQQQFrQQNJIRcMBQtBACEJIBBBfHEiDgRAA0AgCyAJQQN0aiAKIAlBAnRqKAIANgIAIAsgCUEBciIUQQN0aiAKIBRBAnRqKAIANgIAIAsgCUECciIUQQN0aiAKIBRBAnRqKAIANgIAIAsgCUEDciIUQQN0aiAKIBRBAnRqKAIANgIAIAlBBGoiCSAOSQ0ACwsgCSAQTw0FAkAgECAJayIUQRBJDQAgLiANIB9sIg1qIAlBA3RqIBIgIGoiDiAQIAxrQQJ0akkEQCAOIAkgDGtBAnRqIA0gLWogEEEDdGpJDQELIAogCUECdGohDSAJ/RH9DAAAAAABAAAAAgAAAAMAAAD9rgEhNCAJIBRBfHEiDGohCUEAIQ4DQCALIDRBAf2rASI1/RsAQQJ0aiANIA5BAnRq/QACACI2/VoCAAAgCyA1/RsBQQJ0aiA2/VoCAAEgCyA1/RsCQQJ0aiA2/VoCAAIgCyA1/RsDQQJ0aiA2/VoCAAMgNP0MBAAAAAQAAAAEAAAABAAAAP2uASE0IA5BBGoiDiAMRw0ACyAMIBRGDQYLQQAhDCAJIQ4gECAJa0EDcSINBEADQCALIA5BA3RqIAogDkECdGooAgA2AgAgDkEBaiEOIAxBAWoiDCANRw0ACwsgCSAQa0F8Sw0FA0AgCyAOQQN0aiAKIA5BAnRqKAIANgIAIAsgDkEBaiIJQQN0aiAKIAlBAnRqKAIANgIAIAsgDkECaiIJQQN0aiAKIAlBAnRqKAIANgIAIAsgDkEDaiIJQQN0aiAKIAlBAnRqKAIANgIAIA5BBGoiDiAQRw0ACwwFCyATRQ0EQQAhCSAaQQNPBEADQCALIAooAgA2AgAgCyAPaiIMIAogEWoiDSgCADYCACAMIA9qIgwgDSARaiINKAIANgIAIAwgD2oiDCANIBFqIg0oAgA2AgAgDSARaiEKIAwgD2ohCyAJQQRqIgkgG0cNAAsLQQAhCSAWRQ0EA0AgCyAKKAIANgIAIAogEWohCiALIA9qIQsgCUEBaiIJIBZHDQALDAQLIBwgDUECdGohCyAQQQRHBEAgE0UNBCAQQQJ0IQlBACEOIBpBA08EQANAIAsgCiAJEBIhMCAKIBFqIg0gEWoiCyARaiISIBFqIQogMCAPaiANIAkQEiAPaiALIAkQEiAPaiASIAkQEiAPaiELIA5BBGoiDiAbRw0ACwtBACEOIBZFDQQDQCALIAogCRASITEgCiARaiEKIDEgD2ohCyAOQQFqIg4gFkcNAAsMBAsgE0UNA0EAIQkgGkEDTwRAA0AgCyAK/QACAP0LAgAgCyAPaiIMIAogEWoiDf0AAgD9CwIAIAwgD2oiDCANIBFqIg39AAIA/QsCACAMIA9qIgwgDSARaiIN/QACAP0LAgAgDSARaiEKIAwgD2ohCyAJQQRqIgkgG0cNAAsLQQAhCSAWRQ0DA0AgCyAK/QACAP0LAgAgCiARaiEKIAsgD2ohCyAJQQFqIgkgFkcNAAsMAwsDQEEAIQkgDQRAA0AgCyAJQQV0aiAKIAlBAnRqKAIANgIAIAsgCUEBciIMQQV0aiAKIAxBAnRqKAIANgIAIAsgCUECciIMQQV0aiAKIAxBAnRqKAIANgIAIAsgCUEDciIMQQV0aiAKIAxBAnRqKAIANgIAIAlBBGoiCSANSQ0ACwsCQCAJIBBPDQACQCAQIAlrIhRBCE8EQAJAIAsgCUEFdGogIiARIBJsak8NACAKIAlBAnRqIBUgDyASbGpPDQAgCSEMDAILIAn9Ef0MAAAAAAEAAAACAAAAAwAAAP2uASE0IAkgFEF8cSIXaiEMQQAhDgNAIAsgNEED/asBIjX9GwBBAnRqIAogCSAOakECdGr9AAIAIjb9WgIAACALIDX9GwFBAnRqIDb9WgIAASALIDX9GwJBAnRqIDb9WgIAAiALIDX9GwNBAnRqIDb9WgIAAyA0/QwEAAAABAAAAAQAAAAEAAAA/a4BITQgDkEEaiIOIBdHDQALIBQgF0YNAgwBCyAJIQwLQQAhDiAQIAwiCWtBA3EiFARAA0AgCyAJQQV0aiAKIAlBAnRqKAIANgIAIAlBAWohCSAOQQFqIg4gFEcNAAsLIAwgEGtBfEsNAANAIAsgCUEFdGogCiAJQQJ0aigCADYCACALIAlBAWoiDEEFdGogCiAMQQJ0aigCADYCACALIAlBAmoiDEEFdGogCiAMQQJ0aigCADYCACALIAlBA2oiDEEFdGogCiAMQQJ0aigCADYCACAJQQRqIgkgEEcNAAsLIAogEWohCiALIA9qIQsgEyASQQFqIhJHDQALDAILIBJFBEBBASAAKAIIIAAoAgxsQQJ0EBMiEkUEQEEADwsgACgCGCAAKAIQIB5sQQJ0aiANaiASNgIACyASICVBAnRqIAlBAnRqIQsgGCABayEJAkACQAJAAkAgBkEBRwRAIBwgBiAJbEECdGohCiAQQQFGDQEgIw0CIBBBB00NAiATRQ0GICYgCSAfbGogEEEFdGohIiAgIBBBAnRqIAxBAnRrIS8gEEF8cSEUQQAhDANAQQAhCSAUBEADQCALIAlBAnRqIAogCUEFdGooAgA2AgAgCyAJQQFyIg1BAnRqIAogDUEFdGooAgA2AgAgCyAJQQJyIg1BAnRqIAogDUEFdGooAgA2AgAgCyAJQQNyIg1BAnRqIAogDUEFdGooAgA2AgAgCUEEaiIJIBRJDQALCwJAIAkgEE8NAAJAIBAgCWsiF0EITwRAAkAgCyAJQQJ0aiAiIAwgD2xqTw0AIAogCUEFdGogEiAvIAwgEWxqak8NACAJIQ0MAgsgCf0R/QwAAAAAAQAAAAIAAAADAAAA/a4BITQgCSAXQXxxIhVqIQ1BACEOA0AgCyAJIA5qQQJ0aiAKIDRBA/2rASI1/RsDQQJ0aiAKIDX9GwJBAnRqIAogNf0bAUECdGogCiA1/RsAQQJ0av0JAgD9VgIAAf1WAgAC/VYCAAP9CwIAIDT9DAQAAAAEAAAABAAAAAQAAAD9rgEhNCAOQQRqIg4gFUcNAAsgFSAXRg0CDAELIAkhDQtBACEOIBAgDSIJa0EDcSIXBEADQCALIAlBAnRqIAogCUEFdGooAgA2AgAgCUEBaiEJIA5BAWoiDiAXRw0ACwsgDSAQa0F8Sw0AA0AgCyAJQQJ0aiAKIAlBBXRqKAIANgIAIAsgCUEBaiINQQJ0aiAKIA1BBXRqKAIANgIAIAsgCUECaiINQQJ0aiAKIA1BBXRqKAIANgIAIAsgCUEDaiINQQJ0aiAKIA1BBXRqKAIANgIAIAlBBGoiCSAQRw0ACwsgCyARaiELIAogD2ohCiATIAxBAWoiDEcNAAsMBgsgHCAJQQJ0aiEKIBBBBEYNAiATRQ0FIBBBAnQhCUEAIQ4gGkEDTwRAA0AgCyAKIAkQEiEyIAogD2oiDSAPaiILIA9qIhIgD2ohCiAyIBFqIA0gCRASIBFqIAsgCRASIBFqIBIgCRASIBFqIQsgDkEEaiIOIBtHDQALC0EAIQ4gFkUNBQNAIAsgCiAJEBIhMyAKIA9qIQogMyARaiELIA5BAWoiDiAWRw0ACwwFCyATRQ0EQQAhCSAaQQNPBEADQCALIAooAgA2AgAgCyARaiIMIAogD2oiDSgCADYCACAMIBFqIgwgDSAPaiINKAIANgIAIAwgEWoiDCANIA9qIg0oAgA2AgAgDCARaiELIA0gD2ohCiAJQQRqIgkgG0cNAAsLQQAhCSAWRQ0EA0AgCyAKKAIANgIAIAsgEWohCyAKIA9qIQogCUEBaiIJIBZHDQALDAQLIBNFDQMgEEF8cSEUIBBBA3EhEkEAIQ0gEEEBa0EDSSEXDAELIBNFDQJBACEJIBpBA08EQANAIAsgCv0AAgD9CwIAIAsgEWoiDCAKIA9qIg39AAIA/QsCACAMIBFqIgwgDSAPaiIN/QACAP0LAgAgDCARaiIMIA0gD2oiDf0AAgD9CwIAIA0gD2ohCiAMIBFqIQsgCUEEaiIJIBtHDQALC0EAIQkgFkUNAgNAIAsgCv0AAgD9CwIAIAogD2ohCiALIBFqIQsgCUEBaiIJIBZHDQALDAILA0ACQCAQRQ0AQQAhDkEAIQlBACEMIBdFBEADQCALIAlBAnRqIAogBiAJbEECdGooAgA2AgAgCyAJQQFyIhVBAnRqIAogBiAVbEECdGooAgA2AgAgCyAJQQJyIhVBAnRqIAogBiAVbEECdGooAgA2AgAgCyAJQQNyIhVBAnRqIAogBiAVbEECdGooAgA2AgAgCUEEaiEJIAxBBGoiDCAURw0ACwsgEkUNAANAIAsgCUECdGogCiAGIAlsQQJ0aigCADYCACAJQQFqIQkgDkEBaiIOIBJHDQALCyALIBFqIQsgCiAPaiEKIBMgDUEBaiINRw0ACwwBCwNAAkAgEEUNAEEAIQ5BACEJQQAhDCAXRQRAA0AgCyAGIAlsQQJ0aiAKIAlBAnRqKAIANgIAIAsgCUEBciIVIAZsQQJ0aiAKIBVBAnRqKAIANgIAIAsgCUECciIVIAZsQQJ0aiAKIBVBAnRqKAIANgIAIAsgCUEDciIVIAZsQQJ0aiAKIBVBAnRqKAIANgIAIAlBBGohCSAMQQRqIgwgFEcNAAsLIBJFDQADQCALIAYgCWxBAnRqIAogCUECdGooAgA2AgAgCUEBaiEJIA5BAWoiDiASRw0ACwsgCiARaiEKIAsgD2ohCyANQQFqIg0gE0cNAAsLICFBAWohISAQIBhqIhggA0kNAAsgHkEBaiEeIBMgHWoiHSAESQ0ACwtBAQvDMwUmfw9+AXsBfQF8IwBB0ABrIg4kACAOQZD/AzYCKCAAKAJsIAAoAmhsIRcCfwJAAkACQCAAKAIIIgtBCEcEQEEAIAtBgAJHDQQaIA5B2f8DNgIoDAELIAAtAERBAXENACAXQQFxISIgF0F8cSEPIBdBAWutQowsfiIxQiCIp0EARyEjIDGnISQgDkHNAGohJSAOQcwAaiEoIA5ByABqISkgF0EkSSEqQZD/AyELAkACQAJAA0ACQCALQZP/A0YNAAJAA0AgCSkDCCIxUAR+QgAFIDEgCSkDOH0LUARAIABBwAA2AggMAwsgCSAAKAIQQQIgChAaQQJHBEAgCkEBQZYSQQAQD0EADAsLIAAoAhAgDkEkakECEBEgDigCJCILQQFNBEAgCkEBQYcuQQAQD0EADAsLAkAgDigCKEGAgQJGBEAgCSkDCCIxUAR+QgAFIDEgCSkDOH0LUA0BIA4oAiQhCwsgACgCCCIUQRBxBEAgACAAKAIYIAtrQQJrNgIYCyAOIAtBAmsiEjYCJEHgvQEhDCAOKAIoIQ0DQCAMIgsoAgAiGARAIAtBDGohDCANIBhHDQELCyALKAIEIBRxRQRAIApBAUH8KEEAEA9BAAwMCwJAIAAoAhQgEk8EQCAAKAIQIQwMAQsgCSkDCCIxUAR+QgAFIDEgCSkDOH0LIBKtUwRAIApBAUGMLEEAEA9BAAwNCyAAKAIQIA4oAiQQFyIMRQRAIAAoAhAQECAAQgA3AxAgCkEBQdQlQQAQD0EADA0LIAAgDDYCECAAIA4oAiQiEjYCFAsgCSAMIBIgChAaIgwgDigCJEcEQCAKQQFBlhJBABAPQQAMDAsgCygCCCILRQRAIApBAUHa1gBBABAPQQAMDAsgACAAKAIQIAwgCiALEQEARQRAIA4gDigCKDYCICAKQQFBlOgAIA5BIGoQD0EADAwLIAkpAzghMSAOKAIkIREgACgCyAEiFCgCKCISIAAoAswBIgxBKGwiDWoiFigCFCIcQQFqIh0gFigCHCILSwRAIBYCfyALs0MAAMhCkiJBQwAAgE9dIEFDAAAAAGBxBEAgQakMAQtBAAsiCzYCHCAWKAIYIAtBGGwQFyELIBQoAigiEiANaiEWIAtFDQMgFiALNgIYIBYoAhQiHEEBaiEdCyANIBJqIg0oAhggHEEYbGoiCyARQQRqNgIQIAsgMacgEWtBBGsiDKw3AwggCyAYOwEAIA0gHTYCFAJAIBhBkP8DRw0AIA0oAhAiCwRAIAsgDSgCDEEYbGogDK03AwALIAkpAzinIA4oAiRrQQRrrSIxIAApAzBXDQAgACAxNwMwCyAALQBEQQRxBEAgCSAANQIYIAogCSgCKBEIACAANQIYUgRAIApBAUGWEkEAEA9BAAwNCyAOQZP/AzYCKAwECyAJIAAoAhBBAiAKEBpBAkcEQCAKQQFBlhJBABAPQQAMDAsgACgCECAOQShqQQIQESAOKAIoQZP/A0cNAQwDCwsgAEHAADYCCAwBCyAWKAIYEBAgFCgCKCAMQShsaiIAQQA2AhwgAEIANwIUIApBAUGFHUEAEA9BAAwICwJAIAkpAwgiMVAEfkIABSAxIAkpAzh9C1AEQCAAKAIIQcAARg0BCwJAAkAgAC0ARCILQQRxRQRAIAAoAswBQYwsbCEMIAAoApwBIS4CQAJAIAAoAjgEQCAJKQMIIjFQBH5CAAUgMSAJKQM4fQunIRMMAQsgACgCGCITQQJJDQELIAAgE0ECayITNgIYCyAuIAxqIRggE0UNASAJKQMIIjFQBH5CAAUgMSAJKQM4fQsgE61TBEAgACgCuAEEQCAKQQFBuSxBABAPQQAMDQsgCkECQbksQQAQDwsgACgCGCINQX5PBEAgCkEBQf4KQQAQD0EADAwLAkAgGCgC3CsiDARAIBgoAuArIgtBfSANa0sEQCAKQQFBlglBABAPQQAMDgsgDCALIA1qQQJqEBciCwRAIBggCzYC3CsMBAsgGCgC3CsQECAYQQA2AtwrDAELIBggDUECahAUIgs2AtwrIAsNAgsgCkEBQYcvQQAQD0EADAsLIABBCDYCCCAAIAtB+gFxOgBEDAELIAAoAsgBIhYEQCAWKAIoIhIgACgCzAEiFEEobCIRaiIMKAIQIAwoAgxBGGxqIgsgCSkDOCIyQgJ9IjE3AwggCyAyIAA1Ahh8NwMQIAAoAhghDQJAIAwoAhQiHEEBaiIdIAwoAhwiC00EQCAMKAIYIQwMAQsgDAJ/IAuzQwAAyEKSIkFDAACAT10gQUMAAAAAYHEEQCBBqQwBC0EACyILNgIcIAwoAhggC0EYbBAXIQwgFigCKCISIBFqIQsgDEUNBiALIAw2AhggCygCFCIcQQFqIR0LIAwgHEEYbGoiCyANQQJqNgIQIAsgMcQ3AwggC0GT/wM7AQAgESASaiAdNgIUCyAAKAIYIQwCQCATRQRAQQAhEwwBCyAJIBgoAtwrIBgoAuAraiAMIAoQGiETIAAoAhghDAsgAEEIQcAAIAwgE0YbNgIIIBggGCgC4CsgE2o2AuArIAAtAEQiC0EJcUEBRw0AIAAgC0EIcjoARCAAKALMASENIAkoAhxBAkYNACAJKQM4IjFCf1ENAAJAA0BBACEMIAkgDkHGAGoiC0ECIAoQGkECRw0BIAsgDkFAa0ECEBEgDigCQEGQ/wNHDQFBlhIhEiAJIAtBAiAKEBpBAkcNCSALIA5BPGpBAhARIA4oAjxBCkcEQEGHLiESDAoLIA5BCDYCPCAJIA5BxgBqQQggChAaIgsgDigCPEcNCSALQQhHBEBBvR4hEgwKCyAOQcYAaiAOQThqQQIQESApIA5BNGpBBBARICggDkEwakEBEBEgJSAOQSxqQQEQESANIA4oAjhHBEAgDigCNCILQQ5JDQIgDiALQQxrIgs2AjQgCSALrSAKIAkoAigRCAAgDjUCNFENAQwCCwsgDigCMCAOKAIsRiEMCyAJIDEgCiAJKAIsEQ0ARQ0IIAxFDQAgACAALQBEQe4BcUEQcjoARAJAIBdFDQAgACgCnAEhE0EAIQsCQCAqDQAgE0HYK2oiDCAkaiAMSSAjcg0AA0AgEyALQYwsbGoiHCgC2CsiHf0RIBMgC0EBckGMLGxqIhgoAtgrIhb9HAEgEyALQQJyQYwsbGoiESgC2CsiFP0cAiATIAtBA3JBjCxsaiINKALYKyIM/RwD/QwAAAAAAAAAAAAAAAAAAAAA/TgiQP0bAEEBcQRAIBxB2CtqIB1BAWo2AgALIED9GwFBAXEEQCAYQdgraiAWQQFqNgIACyBA/RsCQQFxBEAgEUHYK2ogFEEBajYCAAsgQP0bA0EBcQRAIA1B2CtqIAxBAWo2AgALIAtBBGoiCyAPRw0ACyAXIA8iC0YNAQsgC0EBciEMICIEQCATIAtBjCxsaiINKALYKyILBEAgDUHYK2ogC0EBajYCAAsgDCELCyAMIBdGDQADQCATIAtBjCxsaiINKALYKyIMBEAgDUHYK2ogDEEBajYCAAsgDUHk1wBqIg0oAgAiDARAIA0gDEEBajYCAAsgC0ECaiILIBdHDQALCyAKQQJBlMQAQQAQDwsgAC0AREEBcQ0AIAkgACgCEEECIAoQGkECRwRAAkAgACgCzAFBAWogF0cNACAXRQ0AIAAoApwBIQxBACELA0AgDCALQYwsbGoiCSgC1CtFBEAgCSgC2CtFDQgLIAtBAWoiCyAXRw0ACwsgCkEBQZYSQQAQD0EADAkLIAAoAhAgDkEoakECEBEgDigCKCELIAAtAERBAXENAiALQdn/A0cNAQwCCwsgDigCKCELCyALQdn/A0cNAiAAKAIIQYACRg0CIABBgAI2AgggAEEANgLMAQwCCyALKAIYEBAgFigCKCAUQShsaiIAQQA2AhwgAEIANwIUIApBAUGFHUEAEA9BAAwECyAOIAs2AhAgCkEEQefRACAOQRBqEA8gACALNgLMASAOQdn/AzYCKCAAQYACNgIICyAAKALMASELIAAoApwBIQkCQAJAIAAtAERBAXENAAJAAkAgCyAXTw0AIAkgC0GMLGxqIRMDQCATKALcKw0BIAAgC0EBaiILNgLMASATQYwsaiETIAsgF0cNAAsMAQsgCyAXRw0BCyAIQQA2AgAMAQsCQAJAIApBASAJIAtBjCxsaiIRKAK0KAR/QZw0BSARLQCILEECcUUNAgJAIBEoAqgoIg9FBEBBACEMDAELIBEoAqwoIQlBACEMQQAhCyAPQQRPBEAgD0F8cSEL/QwAAAAAAAAAAAAAAAAAAAAAIUBBACESA0AgCSASQQN0aiIMQRxqIAxBFGogDEEMaiAM/QkCBP1WAgAB/VYCAAL9VgIAAyBA/a4BIUAgEkEEaiISIAtHDQALIEAgQCBA/Q0ICQoLDA0ODwABAgMAAQID/a4BIkAgQCBA/Q0EBQYHAAECAwABAgMAAQID/a4B/RsAIQwgCyAPRg0BCwNAIAkgC0EDdGooAgQgDGohDCALQQFqIgsgD0cNAAsLIBEgDBAUIgk2ArQoIAkNAUGXHgtBABAPIApBAUH1PEEAEA9BAAwFCyARIAw2ArwoIBEoAqwoIQkgESgCqCgiDARAQQAhEkEAIQsDQCAJIAtBA3QiFGoiDSgCACIPBEAgESgCtCggEmogDyANKAIEEBIaIBEoAqwoIBRqIgkoAgQhLyAJKAIAEBAgESgCrCgiCSAUakIANwIAIC8gEmohEiARKAKoKCEMCyALQQFqIgsgDEkNAAsLIBFBADYCqCggCRAQIBFBADYCrCggESARKAK0KDYCsCggESARKAK8KDYCuCgLAn9BACEoIAAoAtABIgsoAhwiJigCTCAAKALMASIJQYwsbGooAtArIRsgCygCGCIUKAIYIScgCygCFCgCACIeICYoAgQgJigCDCILIAkgCSAmKAIYIgluIgwgCWxrbGoiDSAUKAIAIgkgCSANSRsiDzYCACAeQX8gCyANaiIJIAkgDUkbIgsgFCgCCCIJIAkgC0sbIgk2AggCQCAJIA9KIA9BAE5xRQRAIApBAUGBM0EAEA8MAQsgHigCFCEQIB4gJigCCCAMICYoAhAiC2xqIg8gFCgCBCIJIAkgD0kbIgw2AgQgHkF/IAsgD2oiCSAJIA9JGyILIBQoAgwiCSAJIAtLGyIJNgIMIAkgDEogDEEATnFFBEAgCkEBQdsyQQAQDwwBCwJAIBsoAgQEQCAeKAIQDQFBAQwDCyAKQQFB1ShBABAPDAELAkACQANAICdBADYCJCAQICc0AgAiNUIBfSIxIB40AgB8IDV/PgIAIBAgJzQCBCI0QgF9IjIgHjQCBHwgNH8+AgQgECAxIB40Agh8IDV/PgIIIB40AgwhMSAQICg2AhAgECAxIDJ8IDR/PgIMIBAgGygCBCILNgIUIBBBASALICYoAlAiCWsgCSALSxs2AhggECgCNBAQIBBBADYCRCAQ/QwAAAAAAAAAAAAAAAAAAAAA/QsCNCALQZgBbCEMAkAgECgCHCIJRQRAIBAgDBAUIgk2AhwgCUUNBSAQIAw2AiAgCUEAIAwQFRoMAQsgDCAQKAIgTQ0AIAkgDBAXIgtFBEAgCkEBQYAXQQAQDyAQKAIcEBAgEEIANwIcDAULIBAgCzYCHCALIBAoAiAiCWpBACAMIAlrEBUaIBAgDDYCIAsgECgCFCILBEAgG0GwB2ohHSAbQawGaiEYIBtBHGohFyAQKAIcIRpBACErA0AgGkJ/IAtBAWsiCa0iM4ZCf4UiMiAQNAIAfCAzh6ciFjYCACAaIDIgEDQCBHwgM4enIhE2AgQgGiAyIBA0Agh8IDOHIjGnIhQ2AgggGiAyIBA0Agx8IDOHIjSnIg02AgwgMcRCASAYICtBAnQiDGooAgAiH60iMYZ8QgF9IDGHpyAfdCIPQQBIDQQgNMRCfyAMIB1qKAIAIiCtIjGGQn+FfCAxh6cgIHQiDEEASA0EIBogDEF/ICB0IBFxIhNrICB1QQAgDSARRxsiDDYCFCAaIA9BfyAfdCAWcSIiayAfdUEAIBQgFkcbIg82AhACQCAPRQ0AIA+tIAytfkIgiFANAAwECyAMIA9sIiNB58yZM08NAyAjQShsISEgGiArBH8gIEEBayEgIB9BAWshHyATrEIBfEIBiKchEyAirEIBfEIBiKchIkEDBUEBCzYCGCAaQRxqIRVCASALrSI2hiE3Qn8gGygCDCILICAgCyAgSRsiLK0iPIZCf4UhPUJ/IBsoAggiCyAfIAsgH0kbIi2tIj6GQn+FIT9BACEpA0ACfiArRQRAIDIgEDQCBHwgM4chOCAyIBA0AgB8IDOHITlBACELIDIiMSE6IDMMAQsgNyApQQFqIgtBAXatIDOGQn+FfCI6IBA0AgR8IDaHITggNyALQQFxrSAzhkJ/hXwiMSAQNAIAfCA2hyE5IDYLITsgEDQCCCE1IBA0AgwhNCAVIDg+AgQgFSA5PgIAIBUgCzYCECAVIDQgOnwgO4c+AgwgFSAxIDV8IDuHPgIIQQAhDAJAIBsoAhRFDQAgC0UNAEECQQEgC0EDRhshDAtEAAAAAAAA8D8hQgJAICcoAhggDGogFygCACIMayILQYAITgRARAAAAAAAAOB/IUIgC0H/D0kEQCALQf8HayELDAILRAAAAAAAAPB/IUJB/RcgCyALQf0XTxtB/g9rIQsMAQsgC0GBeEoNAEQAAAAAAABgAyFCIAtBuHBLBEAgC0HJB2ohCwwBC0QAAAAAAAAAACFCQfBoIAsgC0HwaE0bQZIPaiELCyAVIBcoAgS3RAAAAAAAAEA/okQAAAAAAADwP6AgQiALQf8Haq1CNIa/oqK2OAIgIBUgDCAbKAKkBmpBAWs2AhwgFSgCFCELAkACQAJAICNFDQAgCw0AIBUgIRAUIgs2AhQgC0UEQCAKQQFBlBVBABAPDAoLIAtBACAhEBUaIBUgITYCGAwBCyAhIBUoAhhLBEAgCyAhEBciDEUEQCAKQQFBlBVBABAPIBUoAhQQECAVQgA3AhQMCgsgFSAMNgIUIAwgFSgCGCILakEAICEgC2sQFRogFSAhNgIYCyAjRQ0BCyAVKAIUIQtBACEkA0AgCyAkICQgGigCECIMbiIWIAxsayINIB90ICJqIg8gFSgCACIMIAwgD0gbIhE2AgAgCyAWICB0IBNqIg8gFSgCBCIMIAwgD0gbIhQ2AgQgCyANQQFqIB90ICJqIg8gFSgCCCIMIAwgD0obIg02AgggCyAWQQFqICB0IBNqIg8gFSgCDCIMIAwgD0obIgw2AgwgCyA/IA2sfCA+h6cgESAtdSIWayAtdCAtdSIPNgIQIAsgPSAMrHwgPIenIBQgLHUiEWsgLHQgLHUiDDYCFCAMIA9sIiWtQgaGQiCIQgBSBEAgCkEBQeUVQQAQDwwJCyAlQQZ0IQ0CQAJ/AkAgCygCGCIMDQAgJUUNACALIA0QFCIMNgIYIAxFDQsgDEEAIA0QFRogC0EcagwBCyANIAsoAhxNDQEgDCANEBciD0UEQCALKAIYEBAgC0IANwIYIApBAUHjEkEAEA8MCwsgCyAPNgIYIA8gCygCHCIMakEAIA0gDGsQFRogC0EcagsgDTYCAAsgCygCFCENIAsoAhAhDyALAn8gCygCICIMRQRAIA8gDSAKEGMMAQsgDCAPIA0gChBhCzYCICALKAIUIQ0gCygCECEPIAsCfyALKAIkIgxFBEAgDyANIAoQYwwBCyAMIA8gDSAKEGELNgIkICUEQEEAIRIDQCASIAsoAhAiDW4hHAJAIAsoAhggEkEGdGoiGSgCACIUBEAgGSgCOCEPIBkoAgQhDCAZKAIwISogGSgCPBAQIBn9DAAAAAAAAAAAAAAAAAAAAAD9CwIoIBlCADcCOCAZ/QwAAAAAAAAAAAAAAAAAAAAA/QsCGCAZ/QwAAAAAAAAAAAAAAAAAAAAA/QsCCCAZIBQ2AgAgGSAqNgIwICoEQCAUQQAgKkEYbBAVGgsgGSAPNgI4IBkgDDYCBAwBCyAZQQpBGBATIgw2AgAgDEUNCyAZQQo2AjALIBkgEiANIBxsayAWaiIUIC10Ig8gCygCACIMIAwgD0gbNgIIIBkgESAcaiINICx0Ig8gCygCBCIMIAwgD0gbNgIMIBkgFEEBaiAtdCIPIAsoAggiDCAMIA9KGzYCECAZIA1BAWogLHQiDyALKAIMIgwgDCAPShs2AhQgEkEBaiISICVHDQALCyALQShqIQsgJEEBaiIkICNHDQALCyAXQQhqIRcgFUEkaiEVIClBAWoiKSAaKAIYSQ0ACyAaQZgBaiEaIAkhCyArQQFqIisgECgCFEkNAAsLICdBNGohJyAQQcwAaiEQIBtBuAhqIRsgKEEBaiIoIB4oAhBJDQALQQEMAwsgCkEBQZQWQQAQDwwBCyAKQQFBsxFBABAPC0EAC0UEQCAKQQFBwhtBABAPQQAMBAsgACgCzAEhCSAOIAAoAmggACgCbGw2AgQgDiAJQQFqNgIAIApBBEG+1wAgDhAPIAEgACgCzAE2AgAgCEEBNgIAIAIEQCACIAAoAtABQQAQVCIBNgIAQQAgAUF/Rg0EGgsgAyAAKALQASgCFCgCACIBKAIANgIAIAQgASgCBDYCACAFIAEoAgg2AgAgBiABKAIMNgIAIAcgASgCEDYCACAAIAAoAghBgAFyNgIIC0EBDAILIApBASASQQAQDwsgCkEBQeQbQQAQD0EACyEwIA5B0ABqJAAgMAveEAINfwJ+AkAgACgCICIFDQACQCAAKAIQIglBBUoEQCAJIQMMAQsCQAJAIAAoAhQiAkEFTgRAIAAoAgAiASgCACEFIAAgAUEEajYCACACQQRrIQcMAQsgAkEATARAQX8hBQwCCyAAKAIAIQECfyACQQFGBEBBfyEGQQAMAQtBfyEGIAJBAWsiA0EBcSENAkAgAkECRgRAQQAhBSACIQQMAQsgA0F+cSELQQAhBSABIQMgAiEEA0AgACADQQFqNgIAIAMtAAAhDCAAIANBAmoiATYCACAAIARBAWs2AhQgAy0AASEDIAAgBEECayIENgIUIAZB/wEgBXRBf3NxIAwgBXRyQYD+AyAFdEF/c3EgAyAFQQhydHIhBiAFQRBqIQUgASEDIAhBAmoiCCALRw0ACwsgDQRAIAAgAUEBaiIDNgIAIAEtAAAhASAAIARBAWs2AhQgBkH/ASAFdEF/c3EgASAFdHIhBiADIQELIAJBA3RBCGsLIQUgACABQQFqNgIAIAZB/wEgBXRBf3NxIAEtAABBD3IgBXRyIQULIAAgBzYCFAsgACgCGCEBIAAgBUEYdiIHQf8BRjYCGCAAIAkgBUEQdkH/AXEiCEH/AUYiCiAFQQh2Qf8BcSILQf8BRiIMIAEgBUH/AXEiBEH/AUYiAmpqaiIBa0EgaiIDNgIQIAAgACkDCCAEQQdBCCACG3QgC3JBB0EIIAwbdCAIckEHQQggCht0IAdyrSABIAlrQSBqrYaENwMIQQAhBSADQQZIDQELIAAoAhwiAUECdEGgnQFqKAIAIQICfiAAKQMIIg5CAFMEQEEMIAFBAWogAUELThshBCADQQFrIQNBfyACdEF/c0EBdCEBQgEMAQsgAUEBa0EAIAFBAUobIQQgDkE/IAJrrYinQX8gAnRBf3NxQQF0QQFyIQEgAyACQQFqIgJrIQMgAq0LIQ8gACADNgIQIAAgBDYCHCAAIA4gD4Y3AwggACABrCAAKQMoQkCDhDcDKEEBIQUgA0EGSA0AIAAoAhwiAUECdEGgnQFqKAIAIQICfiAAKQMIIg5CAFMEQEEMIAFBAWogAUELThshBCADQQFrIQNBfyACdEF/c0EBdCEBQgEMAQsgAUEBa0EAIAFBAUobIQQgDkE/IAJrrYinQX8gAnRBf3NxQQF0QQFyIQEgAyACQQFqIgJrIQMgAq0LIQ8gACADNgIQIAAgBDYCHCAAIA4gD4Y3AwggACAAKQMoQv9AgyABrEIHhoQ3AyhBAiEFIANBBkgNACAAKAIcIgFBAnRBoJ0BaigCACECAn4gACkDCCIOQgBTBEBBDCABQQFqIAFBC04bIQQgA0EBayEDQX8gAnRBf3NBAXQhAUIBDAELIAFBAWtBACABQQFKGyEEIA5BPyACa62Ip0F/IAJ0QX9zcUEBdEEBciEBIAMgAkEBaiICayEDIAKtCyEPIAAgAzYCECAAIAQ2AhwgACAOIA+GNwMIIAAgACkDKEL//0CDIAGsQg6GhDcDKEEDIQUgA0EGSA0AIAAoAhwiAUECdEGgnQFqKAIAIQICfiAAKQMIIg5CAFMEQEEMIAFBAWogAUELThshBCADQQFrIQNBfyACdEF/c0EBdCEBQgEMAQsgAUEBa0EAIAFBAUobIQQgDkE/IAJrrYinQX8gAnRBf3NxQQF0QQFyIQEgAyACQQFqIgJrIQMgAq0LIQ8gACADNgIQIAAgBDYCHCAAIA4gD4Y3AwggACAAKQMoQv///0CDIAGsQhWGhDcDKEEEIQUgA0EGSA0AIAAoAhwiAUECdEGgnQFqKAIAIQICfiAAKQMIIg5CAFMEQEEMIAFBAWogAUELThshBCADQQFrIQNBfyACdEF/c0EBdCEBQgEMAQsgAUEBa0EAIAFBAUobIQQgDkE/IAJrrYinQX8gAnRBf3NxQQF0QQFyIQEgAyACQQFqIgJrIQMgAq0LIQ8gACADNgIQIAAgBDYCHCAAIA4gD4Y3AwggACAAKQMoQv////9AgyABrEIchoQ3AyhBBSEFIANBBkgNACAAKAIcIgFBAnRBoJ0BaigCACECAn4gACkDCCIOQgBTBEBBDCABQQFqIAFBC04bIQQgA0EBayEDQX8gAnRBf3NBAXQhAUIBDAELIAFBAWtBACABQQFKGyEEIA5BPyACa62Ip0F/IAJ0QX9zcUEBdEEBciEBIAMgAkEBaiICayEDIAKtCyEPIAAgAzYCECAAIAQ2AhwgACAOIA+GNwMIIAAgACkDKEL//////0CDIAGtQiOGhDcDKEEGIQUgA0EGSA0AIAAoAhwiAUECdEGgnQFqKAIAIQICfiAAKQMIIg5CAFMEQEEMIAFBAWogAUELThshBCADQQFrIQNBfyACdEF/c0EBdCEBQgEMAQsgAUEBa0EAIAFBAUobIQQgDkE/IAJrrYinQX8gAnRBf3NxQQF0QQFyIQEgAyACQQFqIgJrIQMgAq0LIQ8gACADNgIQIAAgBDYCHCAAIA4gD4Y3AwggACAAKQMoQv///////0CDIAGtQiqGhDcDKEEHIQUgA0EGSA0AIAAoAhwiAUECdEGgnQFqKAIAIQICfiAAKQMIIg5CAFMEQEEMIAFBAWogAUELThshBCADQQFrIQNBfyACdEF/c0EBdCEBQgEMAQsgAUEBa0EAIAFBAUobIQQgDkE/IAJrrYinQX8gAnRBf3NxQQF0QQFyIQEgAyACQQFqIgJrIQMgAq0LIQ8gACADNgIQIAAgBDYCHCAAIA4gD4Y3AwggACAAKQMoQv////////9AgyABrUIxhoQ3AyhBCCEFCyAAIAVBAWs2AiAgACAAKQMoIg5CB4g3AyggDqdB/wBxCyIBAX8gAARAIAAoAgwiAQRAIAEQECAAQQA2AgwLIAAQEAsLigECAX4FfwJAIABCgICAgBBUBEAgACECDAELA0AgAUEBayIBIABCCoAiAkL2AX4gAHynQTByOgAAIABC/////58BViEGIAIhACAGDQALCyACQgBSBEAgAqchAwNAIAFBAWsiASADQQpuIgRB9gFsIANqQTByOgAAIANBCUshByAEIQMgBw0ACwsgAQv54gEEen8Gewh+AX0jAEEQayJOJAACQCAALQAIQYABcUUNACAAKALMASABRw0AIAAoApwBIAFBjCxsaiJPKALcKyIVRQRAIE8QLgwBCyAAKALIARogACgC0AEhGSAAKAJMIgdFBEAgACgCSCEHCyAHKAIAIQYgBygCBCELIAcoAgghCSAHKAIMIQ0gACgCPCEHIAAoAkAhCCBPKALgKyEKIwBBEGsiQCQAIBkgATYCJCAZKAIcKAJMIQwgGUEBNgJAIBkgDTYCPCAZIAk2AjggGSALNgI0IBkgBjYCMCAZIAwgAUGMLGxqNgIgIBkoAkQQEEEAIQsgGUEANgJEAkAgBwRAQQQgGSgCGCgCEBATIgtFBEAMAgtBACENQQAhCSAHQQRPBEAgB0F8cSEMQQAhAQNAIAsgCCAJQQJ0aiIGKAIAQQJ0akEBNgIAIAsgBigCBEECdGpBATYCACALIAYoAghBAnRqQQE2AgAgCyAGKAIMQQJ0akEBNgIAIAlBBGohCSABQQRqIgEgDEcNAAsLIAdBA3EiAQRAA0AgCyAIIAlBAnRqKAIAQQJ0akEBNgIAIAlBAWohCSANQQFqIg0gAUcNAAsLIBkgCzYCRAsCQAJAIBkoAhgiBigCECINRQ0AQQAhCQJAA0ACQCALBEAgCyAJQQJ0aigCAEUNAQsgBigCGCAJQTRsaiIBNQIEIoYBQgF9IooBIBk1Ajx8IIYBgCGLASABNQIAIocBQgF9IogBIBk1Ajh8IIcBgCGMASCKASAZNQI0fCCGAYAhhgEgGSgCFCgCACgCFCAJQcwAbGoiASgCFCABKAIYayIHQR9LDQACQCCIASAZNQIwfCCHAYCnIgggASgCAGsiDEEAIAggDE8bIAd2DQAghgGnIgggASgCBGsiDEEAIAggDE8bIAd2DQAgASgCCCIIIIwBp2siDEEAIAggDE8bIAd2DQAgASgCDCIBIIsBp2siCEEAIAEgCE8bIAd2RQ0BCyAZQQA2AkAMAgsgCUEBaiIJIA1HDQALIBkoAkBFDQAgDUUNAUEAIQ0DQCAZKAIUKAIAKAIUIA1BzABsaiIBKAIcIAEoAhhBmAFsaiIHQZQBaygCACEGIAdBjAFrKAIAIQsgB0GYAWsoAgAhCSAHQZABaygCACEIAkAgGSgCRCIHBEAgByANQQJ0aigCAEUNAQsgCyAGayEHIAggCWshCQJAIAYgC0YNACAHrSAJrX5CIIhQDQAgBUEBQZQWQQAQDwwGCyAHIAlsIgdBgICAgARPBEAgBUEBQZQWQQAQDwwGCyABIAdBAnQiBzYCLAJ/AkACQAJAIAEoAiQiBgRAIAcgASgCME0NBSABKAIoDQELIAEgBxAYIgc2AiQgB0EBIAEoAiwiBxtFDQEgASAHNgIwIAFBKGoMAwsgBhAQIAEgASgCLBAYIgc2AiQgBw0BIAFBADYCMCABQgA3AigLIAVBAUGUFkEAEA8MBwsgASABKAIsNgIwIAFBKGoLQQE2AgALIA1BAWoiDSAZKAIYIgYoAhBJDQALDAELIA1FDQAgBigCGCEPIBkoAhQoAgAoAhQhFkEAIQEDQAJAIAsEQCALIAFBAnRqKAIARQ0BCyAWIAFBzABsaiIHIAcoAgAiCSAPIAFBNGxqIgg1AgAihgFCAX0iigEgGTUCMHwghgGApyIMIAkgDEsbIgk2AjggByAHKAIEIgwgCDUCBCKHAUIBfSKLASAZNQI0fCCHAYCnIgggCCAMSRsiCDYCPCAHIAcoAggiDCCKASAZNQI4fCCGAYCnIhcgDCAXSRsiDDYCQCAHIAcoAgwiFyCLASAZNQI8fCCHAYCnIg4gDiAXSxsiFzYCRCAJIAxLDQMgCCAXSw0DIAcoAhQiDkUNACAOrSGLASAXrSGIASAMrSGMASAIrSGNASAJrSGJASAHKAIcIQlCACGHAQNAIAkghwGnIghBmAFsaiIHQn8gDiAIQX9zaq0ihgGGQn+FIooBIIgBfCCGAYg+ApQBIAcgigEgjAF8IIYBiD4CkAEgByCKASCNAXwghgGIPgKMASAHIIkBIIoBfCCGAYg+AogBIIcBQgF8IocBIIsBUg0ACwsgAUEBaiIBIA1HDQALCyBAQQA2AgggGSgCHCEBQQFBCBATIhsEQCAbIAE2AgQgGyAGNgIACyAbRQ0BIBkoAiQhESAZKAIUKAIAISAjAEHwAGsiEyQAIBFBjCxsIgEgGygCBCIIKAJMaiIcKAKkAyEoAn8gGygCACIeIRcgBSEzQQAhDSMAQSBrIg8kACABIAgoAkxqIh0oAqQDIRgCQCAXKAIQIhZBkARsEBQiDEUNAAJAIBZBAnQQFCILRQRAIAwhCwwBCwJ/IAgoAkwgEUGMLGxqIgkoAqQDIhpBAWoiAUHwARATIgcEQAJAIAEEQCAXKAIQIQ4gByEBA0AgASAzNgLsASABIA5BEBATIgY2AsgBIAZFDQIgASAXKAIQIh82AsQBQQAhBkEAIQ4gHwRAA0AgASgCyAEgBkEEdGoiDiAJKALQKyAGQbgIbGoiHygCBEEQEBMiITYCDCAhRQ0EIA4gHygCBDYCCCAGQQFqIgYgFygCECIOSQ0ACwsgAUHwAWohASASIBpGIXMgEkEBaiESIHNFDQALCyAHDAILIAcoAgQiAQRAIAEQECAHQQA2AgQLIAchAUEAIQkDQCABKALIASIGBEBBACEOIAEoAsQBIhIEfwNAIAYoAgwiHwRAIB8QECAGQQA2AgwgASgCxAEhEgsgBkEQaiEGIA5BAWoiDiASSQ0ACyABKALIAQUgBgsQECABQQA2AsgBCyABQfABaiEBIAkgGkYhdCAJQQFqIQkgdEUNAAsgBxAQC0EACyIHBEACQCAWRQ0AQQAhCSAMIQYgFkEETwRAIAYgFkF8cSIJQZAEbGohBiAMIQEDQCALIBBBAnRqIAH9Ef0MAAAAABACAAAgBAAAMAYAAP2uAf0LAgAgAUHAEGohASAQQQRqIhAgCUcNAAsgCSAWRg0BCwNAIAsgCUECdGogBjYCACAGQZAEaiEGIAlBAWoiCSAWRw0ACwsgCyEOQQAhEiAIKAJMIBFBjCxsaigC0CshASAXKAIYIQkgDyAIKAIEIAgoAgwgESARIAgoAhgiBm4iCyAGbGtsaiIGIBcoAgAiECAGIBBLGzYCFCAPQX8gBiAIKAIMaiIQIAYgEEsbIgYgFygCCCIQIAYgEEkbNgIQIA8gCCgCCCAIKAIQIAtsaiIGIBcoAgQiCyAGIAtLGzYCDCAPQX8gBiAIKAIQaiILIAYgC0sbIgYgFygCDCILIAYgC0kbNgIIIA9BADYCGCAPQQA2AhwgD0H/////BzYCBCAPQf////8HNgIAIBcoAhAEQANAIA4EfyAOIBJBAnRqKAIABUEACyELIAk1AgQihgFCAX0iigEgDzUCCHwghgGAIYsBIAk1AgAihwFCAX0iiAEgDzUCEHwghwGAIYwBIIoBIA81Agx8IIYBgCGGASCIASAPNQIUfCCHAYAhhwEgASgCBCIIIA8oAhxLBEAgDyAINgIcIAEoAgQhCAsgCARAIIsBQv////8PgyGKASCMAUL/////D4MhiwEghgFC/////w+DIYgBIIcBQv////8PgyGMASABQbAHaiEfIAFBrAZqISFBACEaA0AgHyAaQQJ0IhBqKAIAIQYgECAhaigCACERQQAhECALBEAgCyAGNgIEIAsgETYCACALQQhqIRALAkAgESAIQQFrIghqIgtBH0sNACAJKAIAIiJBfyALdksNACAPIA8oAgQiJyAiIAt0IgsgCyAnSxs2AgQLAkAgBiAIaiILQR9LDQAgCSgCBCIiQX8gC3ZLDQAgDyAPKAIAIicgIiALdCILIAsgJ0sbNgIAC0EAIQsgigFCfyAIrSKGAYZCf4UihwF8IIYBiCKNAUL/////D4NCASAGrSKJAYZ8QgF9IIkBiKcghwEgiAF8IIYBiKciIiAGdmtBfyAGdnFBACAiII0Bp0cbIQYghwEgiwF8IIYBiCKNAUL/////D4NCASARrSKJAYZ8QgF9IIkBiKcghwEgjAF8IIYBiKciIiARdmtBfyARdnFBACAiII0Bp0cbIREgEARAIBAgBjYCBCAQIBE2AgAgEEEIaiELCyAGIBFsIgYgDygCGEsEQCAPIAY2AhgLIBpBAWoiGiABKAIESQ0ACwsgCUE0aiEJIAFBuAhqIQEgEkEBaiISIBcoAhBJDQALCyAYQQFqISEgDygCHCERIA8oAhghEiAHQQA2AgQCQCAdKAIIQQFqIgGtIBEgEiAWbCIibCIarX5CIIhQBEAgByABIBpsIgE2AgggByABQQIQEyIBNgIEIAENAQsgDBAQIA4QECAHKAIEIgEEQCABEBAgB0EANgIECyAhRQRAIAchCwwDC0EAIQsgByEBA0AgASgCyAEiCQRAQQAhBiABKALEASIQBH8DQCAJKAIMIggEQCAIEBAgCUEANgIMIAEoAsQBIRALIAlBEGohCSAGQQFqIgYgEEkNAAsgASgCyAEFIAkLEBAgAUEANgLIAQsgAUHwAWohASALIBhGIXUgC0EBaiELIHVFDQALIAchCwwCCyAXKAIYIRcgByAPKAIUIic2AswBIAcgDygCDCIwNgLQASAHIA8oAhAiLTYC1AEgByAPKAIIIis2AtgBIAcgGjYCDCAHICI2AhAgByASNgIUQQEhHyAHQQE2AhggFgRAIAcoAsgBIQFBACEIIBchCwNAIA4gCEECdGooAgAhCSABIAsoAgA2AgAgASALKAIENgIEAkAgASgCCCINRQ0AIAEoAgwhBiANQQFHBEAgDUF+cSEvQQAhEANAIAYgCSgCADYCACAGIAkoAgQ2AgQgBiAJKAIINgIIIAYgCSgCDDYCDCAGIAkoAhA2AhAgBiAJKAIUNgIUIAYgCSgCGDYCGCAGIAkoAhw2AhwgBkEgaiEGIAlBIGohCSAQQQJqIhAgL0cNAAsLIA1BAXFFDQAgBiAJKAIANgIAIAYgCSgCBDYCBCAGIAkoAgg2AgggBiAJKAIMNgIMCyALQTRqIQsgAUEQaiEBIAhBAWoiCCAWRw0ACwsgIUEBSwRAIAchDQNAIA0gKzYCyAMgDSAtNgLEAyANIDA2AsADIA0gJzYCvAMgDUEBNgKIAiANIBI2AoQCIA0gIjYCgAIgDSAaNgL8ASAWBEAgDSgCuAMhAUEAIQggFyELA0AgDiAIQQJ0aigCACEJIAEgCygCADYCACABIAsoAgQ2AgQCQCABKAIIIiFFDQAgASgCDCEGICFBAUcEQCAhQX5xIS9BACEQA0AgBiAJKAIANgIAIAYgCSgCBDYCBCAGIAkoAgg2AgggBiAJKAIMNgIMIAYgCSgCEDYCECAGIAkoAhQ2AhQgBiAJKAIYNgIYIAYgCSgCHDYCHCAGQSBqIQYgCUEgaiEJIBBBAmoiECAvRw0ACwsgIUEBcUUNACAGIAkoAgA2AgAgBiAJKAIENgIEIAYgCSgCCDYCCCAGIAkoAgw2AgwLIAtBNGohCyABQRBqIQEgCEEBaiIIIBZHDQALCyANIA0pAgQ3AvQBIBggH0chdiANQfABaiENIB9BAWohHyB2DQALCyAMEBAgDhAQIB0oAqQDIQsCQCAdLQCILEEEcQRAIAtBf0YNASAdQagDaiEGIB0oAgghAUEAIRAgByEJA0AgBigCJCENIAlBATYCLCAJIA02AlQgCSAGKAIANgIwIAYoAgQhDSAJQgA3AkQgCSANNgI0IAkgBigCDDYCPCAJIAYoAhA2AkAgBigCCCENIAkgEjYCTCAJIA0gASABIA1LGzYCOCAGQZQBaiEGIAlB8AFqIQkgCyAQRiF3IBBBAWohECB3RQ0ACwwBCyALQX9GDQAgHSgCCCEGIB0oAgQhDSAHIQkgCwRAIAtBAWpBfnEhCEEAIQEDQCAJQgA3AkQgCUEANgI0IAlCATcCLCAJIA02AlQgCSARNgI8IAkgDTYCxAIgCSASNgJMIAkgBjYCOCAJQgA3ArQCIAlBADYCpAIgCUIBNwKcAiAJIBE2AqwCIAkgBjYCqAIgCSASNgK8AiAJIAkoAsQBNgJAIAkgCSgCtAM2ArACIAlB4ANqIQkgAUECaiIBIAhHDQALCyALQQFxDQAgCUIANwJEIAlBADYCNCAJQgE3AiwgCSANNgJUIAkgETYCPCAJIBI2AkwgCSAGNgI4IAkgCSgCxAE2AkALIAchDQwCCyAMEBALIAsQEAsgD0EgaiQAQQAgDSIHRQ0AGiAoQQFqIQ4gFSEdIAchCwJAAkADQCALKAJUQX9GDQIgHigCEEECdBAUIgFFDQIgAUEBIB4oAhBBAnQQFSEJIAsQVwRAA0AgICgCFCEIAkACQCALKAIoIBwoAgxPDQAgCygCICIBIAggCygCHEHMAGxqIgYoAhhPDQAgBigCHCABQZgBbGoiDSgCGEUNACANQRxqIQhBACEBAkADQCAZIAsoAhwgCygCICAIIAFBJGxqIgYoAhAgBigCFCALKAIkQShsaiIGKAIAIAYoAgQgBigCCCAGKAIMEDlFBEAgAUEBaiIBIA0oAhhJDQEMAgsLIAkgCygCHEECdGpBADYCACATQQA2AmggGygCBCAgKAIUIBwgCyATQewAaiAdIBNB6ABqIAogMxBWRQ0GIAsoAiAhCCALKAIcIRYgEygCaCEaIBMoAmwEQCATQQA2AmggICgCFCAWQcwAbGooAhwgCEGYAWxqIh8oAhgiAQR/IAogGmshGCAKIB1qISEgH0EcaiEMQQAhEUEAIQ8gGiAdaiIiIRIDQAJAIAwoAgggDCgCAEYNACAMKAIMIAwoAgRGDQAgDCgCFCALKAIkQShsaiIGKAIUIAYoAhBsIihFDQAgBigCGCEBQQAhFgNAIA8EQCABQQA2AjQLIAEoAiQiFwRAIAEoAgAhCAJAIAEgASgCKCIGBH8gCCAGQRhsaiIIQRRrKAIAIAhBDGsoAgBHBEAgCEEYayEIDAILIAZBAWoFQQELNgIoCwJAA0ACQAJAAkAgCCgCFCINIBJBf3NLDQAgDw0AIA0gEmogIU0NAQsgCygCHCEGIAsoAiAhFyALKAIkIQ8gGygCBCgCaARAIBMgBjYCWCATIBc2AlQgEyARNgJQIBMgDzYCTCATIBY2AkggEyAYNgJEIBMgDTYCQCAzQQFB8u0AIBNBQGsQDwwRCyATIAY2AjggEyAXNgI0IBMgETYCMCATIA82AiwgEyAWNgIoIBMgGDYCJCATIA02AiAgM0ECQfLtACATQSBqEA8gAUEANgI0IAggCCgCECIGIAgoAgRqNgIEIAEgASgCJCINIAZrIhc2AiRBASEPIAYgDUYNASABIAEoAihBAWoiCDYCKAwDCyABKAIEIRAgASgCNCIPIAEoAjhHBH8gFwUgECAPQQF0QQFyIgZBA3QQFyIQRQRAIDNBAUGACEEAEA8MEQsgASAGNgI4IAEgEDYCBCABKAI0IQ8gCCgCFCENIAEoAiQLIQYgECAPQQN0aiIXIA02AgQgFyASNgIAIAEgD0EBajYCNCAIIAgoAgAgDWo2AgAgCCAIKAIQIhAgCCgCBGoiDzYCBCABIAYgEGsiFzYCJCAIIA82AgggDSASaiESQQAhDyAGIBBGDQAgASABKAIoQQFqNgIoIAhBGGohCAsgFw0ACyABKAIoIQgLIAEgCDYCLAsgAUFAayEBIBZBAWoiFiAoRw0ACyAfKAIYIQELIAxBJGohDCARQQFqIhEgAUkNAAsgCygCHCEWIAsoAiAhCCAYIBIgImsgDxsFQQALIBpqIRoLIB4oAhggFkE0bGoiASAIIAEoAiQiASABIAhJGzYCJAwCCyAgKAIUIQgLIBNBADYCaCAbKAIEIAggHCALIBNB7ABqIB0gE0HoAGogCiAzEFZFDQQgCygCHCEWIBMoAmghGiATKAJsRQ0AAkAgICgCFCAWQcwAbGooAhwgCygCICIiQZgBbGoiASgCGCIoRQRAQQAhFwwBCyAKIBprIRAgAUEcaiEMIAsoAiQhIUEAIRdBACEYA0ACQCAMKAIIIAwoAgBGDQAgDCgCDCAMKAIERg0AIAwoAhQgIUEobGoiASgCFCABKAIQbCInRQ0AIAEoAhghEUEAIR8DQCARKAIkIgEEQCARKAIAIQgCQCARIBEoAigiEgR/IAggEkEYbGoiCEEUaygCACAIQQxrKAIARwRAIAhBGGshCAwCCyASQQFqBUEBCyISNgIoCwJAAkAgCCgCFCIPIBdqIg0gD0kNACANIBBLDQADQCANIRcgCCAIKAIQIg0gCCgCBGo2AgQgASANayEGIAEgDUYNAiARIBJBAWoiEjYCKCAIKAIsIg8gF2oiDSAPTwRAIAhBGGohCCAGIQEgDSAQTQ0BCwsgESAGNgIkCyAbKAIEKAJoIQEgEyAWNgIYIBMgIjYCFCATIBg2AhAgEyAhNgIMIBMgHzYCCCATIBA2AgQgEyAPNgIAIDNBAUECIAEbQZ3tACATEA8gAQ0KIAsoAhwhFgwFCyARIAY2AiQLIBFBQGshESAfQQFqIh8gJ0cNAAsLIAxBJGohDCAYQQFqIhggKEcNAAsLIBcgGmohGgsCQCAJIBZBAnRqKAIARQ0AIB4oAhggFkE0bGoiASgCJA0AIAEgICgCFCAWQcwAbGooAhhBAWs2AiQLIAogGmshCiAaIB1qIR0gCxBXDQALCyAJEBAgC0HwAWohCyAjQQFqIiMgHCgCpANNDQALIAcgDhA6IEAgHSAVazYCCEEBDAILIAcgDhA6IAkQEEEADAELIAcgDhA6QQALIXggE0HwAGokACAbECwgeEUNASAZKAIgKALQKyEJIBkoAhQoAgAiFigCFCEdIEBBATYCDEEAIQ1BACEVIBkoAiAiASgCDCABKAIIRgRAIAkoAhBBBHZBAXEhFQsCQCAWKAIQIjFFDQADQAJAIBkoAkQiAQRAIAEgDUECdGooAgBFDQELIEBBDGohE0EAITECQCAdKAIYIgFFDQAgGSgCLCEQA0AgHSgCHCAxQZgBbGoiDCgCGCILBEAgDEEcaiESIAwoAhQhASAMKAIQIRdBACEOA0AgASAXbARAIBIgDkEkbGohD0EAIQgDQCAZIB0oAhAgMSAPKAIQIA8oAhQgCEEobGoiBygCACAHKAIEIAcoAgggBygCDBA5IQYgBygCFCILIAcoAhAiCmwhAQJAIAYEQCABRQ0BQQAhCgNAAkAgGSAdKAIQIDEgDygCECAHKAIYIApBBnRqIgYoAgggBigCDCAGKAIQIAYoAhQQOUUEQCAGKAI8IgFFDQEgARAQIAZBADYCPAwBCyAZKAJARQRAIAYoAjwNASAGKAIQIAYoAghGDQEgBigCFCAGKAIMRg0BC0EBQSwQEyIBRQRAIEBBADYCDAwKCyAZKAJAIQsgAUEANgIkIAEgEzYCHCABIAk2AhQgASAdNgIQIAEgDzYCDCABIAY2AgggASAxNgIEIAEgCzYCACABIBU2AiggASAzNgIgIAEgECgCBEEBSjYCGCAQQQ4gARAtIEAoAgxFDQkLIApBAWoiCiAHKAIUIAcoAhBsSQ0ACwwBCyABRQ0AQQAhFwNAIAcoAhggF0EGdGoiASgCPCIGBEAgBhAQIAFBADYCPCAHKAIQIQogBygCFCELCyAXQQFqIhcgCiALbEkNAAsLIAhBAWoiCCAMKAIUIgEgDCgCECIXbEkNAAsgDCgCGCELCyAOQQFqIg4gC0kNAAsgHSgCGCEBCyAxQQFqIjEgAUkNAAsLIEAoAgxFDQIgFigCECExCyAJQbgIaiEJIB1BzABqIR0gDUEBaiINIDFJDQALC0EAITEgGSgCLBAgIEAoAgxFDQECQCAZKAJADQAgGSgCGCIdKAIQRQ0AQQAhCQNAIBkoAhQoAgAoAhQgCUHMAGxqIgEoAhwgHSgCGCAJQTRsaigCJEGYAWxqIgcoAogBIQYgBygCkAEhCyAHKAKMASEKIAcoApQBIQcgASgCNBAQIAFBADYCNAJAIBkoAkQiDQRAIA0gCUECdGooAgBFDQELIAYgC0YNACAHIApGDQAgByAKayIHrSALIAZrIgatfkIgiEIAUgRAIDNBAUGUFkEAEA8MBQsgBiAHbCIHQYCAgIAETwRAIDNBAUGUFkEAEA8MBQsgASAHQQJ0EBgiATYCNCABDQAgM0EBQZQWQQAQDwwECyAJQQFqIgkgGSgCGCIdKAIQSQ0ACwsgGSgCICEdIBkoAhQoAgAiFygCEARAIBcoAhQhCSAdKALQKyEdIBkoAhgoAhghDUEAIQsDQAJAIBkoAkQiAQRAIAEgC0ECdGooAgBFDQELIA0oAiRBAWohASAdKAIUQQFGBEAgASEeQQAhBkEAIQz9DAAAAAAAAAAAAAAAAAAAAAAhgAEjAEEgayIlJAACQAJAIBkoAkAEQEEBIQcgAUEBRg0CIAkoAhwiDCAJKAIYQZgBbGoiAUGQAWsoAgAiECABQZgBaygCACITRg0CIAwoAgQhESAMKAIMIRggDCgCACEaIAwoAgghGyAZKAIsIg4oAgQhFiAeQQFrIgohFSAMIQcCQCAKQQRPBEAgCkEDcSEVIAcgCkF8cSIIQZgBbGohB0EAIQEDQCCAASAMIAFBmAFsaiIGQegEaiAGQdADaiAGQbgCaiAG/QkCoAH9VgIAAf1WAgAC/VYCAAMgBkHgBGogBkHIA2ogBkGwAmogBv0JApgB/VYCAAH9VgIAAv1WAgAD/bEB/bkBIAZB7ARqIAZB1ANqIAZBvAJqIAb9CQKkAf1WAgAB/VYCAAL9VgIAAyAGQeQEaiAGQcwDaiAGQbQCaiAG/QkCnAH9VgIAAf1WAgAC/VYCAAP9sQH9uQEhgAEgAUEEaiIBIAhHDQALIIABIIABIIAB/Q0ICQoLDA0ODwABAgMAAQID/bkBIoABIIABIIAB/Q0EBQYHAAECAwABAgMAAQID/bkB/RsAIQYgCCAKRg0BCwNAIAYgBygCoAEgBygCmAFrIgEgASAGSRsiASAHKAKkASAHKAKcAWsiBiABIAZLGyEGIAdBmAFqIQcgFUEBayIVDQALC0EAIQcgBkH///8/Sw0CICUgBkEFdCISEDEiDzYCECAPRQ0CICUgDzYCACAKBEAgECATayEQIBggEWshCCAbIBprIQEDQCAJKAIkIRMgJSAIIhU2AgggJSABIgc2AhggDCgCnAEhBiAMKAKkASEIIAwoAqABIQEgJSAMKAKYASIRQQJvNgIcICUgASARayIBIAdrNgIUAkAgFkECSCIaRSAIIAZrIghBAUtxRQRAQQAhBiAIRQ0BA0AgJUEQaiATIAYgEGxBAnRqEF0gBkEBaiIGIAhHDQALDAELIAggFiAIIBZJGyIRQQFrIRsgCCARbiEYQQAhBwNAQSQQFCIGRQ0FICX9AAIQIYABIAYgEzYCGCAGIBA2AhQgBiABNgIQIAYggAH9CwIAIAYgByAYbDYCHCAHIBtGIR8gBiAIIAdBAWoiByAYbCAfGzYCICAGIBIQMSIfNgIAIB9FBEBBACEHIA4QICAGEBAgDxAQDAcLIA5BCiAGEC0gByARRw0ACyAOECALICUgCCAVazYCBCAlIAwoApwBQQJvNgIMAkAgGkUgAUEBS3FFBEBBCCEHQQAhBiABQQhPBEADQCAlIBMgBkECdGogEEEIEDAgByIGQQhqIgcgAU0NAAsLIAEgBk0NASAlIBMgBkECdGogECABIAZrEDAMAQsgASAWIAEgFkkbIhVBAWshGCABIBVuIRFBACEHA0BBJBAUIgZFDQUgJf0AAgAhgAEgBiATNgIYIAYgEDYCFCAGIAg2AhAgBiCAAf0LAgAgBiAHIBFsNgIcIAcgGEYhGiAGIAEgB0EBaiIHIBFsIBobNgIgIAYgEhAxIho2AgAgGkUEQEEAIQcgDhAgIAYQECAPEBAMBwsgDkELIAYQLSAHIBVHDQALIA4QIAsgDEGYAWohDCAKQQFrIgoNAAsLQQEhByAPEBAMAgtBASEHIAkoAhwiCCAeQZgBbGoiNUGYAWsiXygCACA1QZABaygCAEYNASA1QZQBayJgKAIAIDVBjAFrKAIARg0BIAgoAgQhDiAIKAIMIQ8gCCgCACEWIAgoAgghECAJKAJEISEgCSgCQCEiIAkoAjwhKCAJKAI4ITAgCSAeEFwiOUUEQEEAIQcMAgsCQAJAIB5BAUcEQAJAAkAgHkEBayIKQQRJBEAgCiEBIAghBwwBCyAKQQNxIQEgCCAKQXxxIhVBmAFsaiEHA0AggAEgCCAMQZgBbGoiBkHoBGogBkHQA2ogBkG4AmogBv0JAqAB/VYCAAH9VgIAAv1WAgADIAZB4ARqIAZByANqIAZBsAJqIAb9CQKYAf1WAgAB/VYCAAL9VgIAA/2xAf25ASAGQewEaiAGQdQDaiAGQbwCaiAG/QkCpAH9VgIAAf1WAgAC/VYCAAMgBkHkBGogBkHMA2ogBkG0AmogBv0JApwB/VYCAAH9VgIAAv1WAgAD/bEB/bkBIYABIAxBBGoiDCAVRw0ACyCAASCAASCAAf0NCAkKCwwNDg8AAQIDAAECA/25ASKAASCAASCAAf0NBAUGBwABAgMAAQIDAAECA/25Af0bACEGIAogFUYNAQsDQCAGIAcoAqABIAcoApgBayIKIAYgCksbIgYgBygCpAEgBygCnAFrIgogBiAKSxshBiAHQZgBaiEHIAFBAWsiAQ0ACwsgBkGAgICAAU8NAiAGQQR0EDEiFEUNAgJAIB5FDQAgDyAOayESIBAgFmshGiAUQQRrITsgFEEEaiEkIBRBDGohKSAUQRxqIUMgFEEYaiEfIBRBFGohICAUQQxrIUQgFEEIaiEqIBRBEGohNiAUQRBrITcgFEEIayFBICGtIYYBICKtIYcBICitIYoBIDCtIYsBQQEhRgNAIAgoApwBIgFBAm8hRyAIKAKYASIHQQJvITwgCCgCpAEgAWsiJyASayEsIAgoAqABIAdrIi0gGmshLiAwIgwhByAoIgYhCiAiIgEhOiAhIg8hEQJAIAkoAhQiFSBGRg0AIBUgRmshFUEAIQpBACEHIAwEQEJ/IBWtIogBhkJ/hSCLAXwgiAGIpyEHCyAoBEBCfyAVrSKIAYZCf4UgigF8IIgBiKchCgtBACEPQQAhASAiBEBCfyAVrSKIAYZCf4UghwF8IIgBiKchAQsgIQRAQn8gFa0iiAGGQn+FIIYBfCCIAYinIQ8LQQAhOkEAIQxBASAVQQFrdCIOIDBJBEAgMCAOa61CfyAVrSKIAYZCf4V8IIgBiKchDAsgDiAiSQRAICIgDmutQn8gFa0iiAGGQn+FfCCIAYinIToLQQAhEUEAIQYgDiAoSQRAICggDmutQn8gFa0iiAGGQn+FfCCIAYinIQYLIA4gIU8NACAhIA5rrUJ/IBWtIogBhkJ/hXwgiAGIpyERC0F/IDogCCgCtAEiFWsiDkEAIA4gOk0bIg5BAmoiFiAOIBZLGyIOIC4gDiAuSRsiNEF/IAEgCCgC2AEiE2siDkEAIAEgDk8bIgFBAmoiDiABIA5LGyIBIBogASAaSRsiJiA8G0EBdCIBICYgNCA8G0EBdEEBciIOIAEgDksbIkggLUkhGCAMIBVrIgFBACABIAxNGyIBQQJrIgxBACABIAxPGyIQIAcgE2siAUEAIAEgB00bIgFBAmsiDEEAIAEgDE8bIhYgPBtBAXQiDCAWIBAgPBtBAXRBAXIiK0khLyAKIAgoArgBIhtrIhVBACAKIBVPGyIKQQJrIhVBACAKIBVPGyIVISMgBiAIKALcASIKayIOQQAgBiAOTxsiBkECayIOQQAgBiAOTxsiDiE9QX8gDyAbayIGQQAgBiAPTRsiBkECaiIPIAYgD0sbIgYgEiAGIBJJGyIbIT5BfyARIAprIgZBACAGIBFNGyIGQQJqIgogBiAKSxsiBiAsIAYgLEkbIhwhPyBHBEAgFSE9IBwhPiAbIT8gDiEjCyBIIC0gGBshSSAMICsgLxshGCASIBxqIVAgDiASaiFRICcEQCAUIBZBA3QiBmoiRUEEaiA7IC5BA3QiCmoiUiAWIC5IIgwbIVMgBiAkaiIGICYgLiAmIC5IGyIPIAcgEyAHIBNJG0ECIAEgAUECTxtqIgFqIhMgB2tBAmsiEUEDdCIraiAGSSApIAcgAWtBA3RqIgEgK2ogAUlyIBFB/////wFLciFUIDQgGkEBayAaIDRKGyEvQQAhESAaQQFKIC5BAEpyIVUgJCA8QQJ0IgFrIBBBA3RqIVYgASBFaiFXIBYgB0F/cyATaiJKQXxxIjJqITggFkEBaiITIDJqIUIgGiA0aiFYIBAgGmohWSAW/RH9DAAAAAABAAAAAgAAAAMAAAD9rgEhgwEgFCAYQQJ0aiFaIEEgGkEDdCIBaiFLIAEgO2ohTCAKIEFqIU0gGkUgLkEBRnEhWyAUIElBAnQiAWohXCABIDtqIV0gE/0R/QwAAAAAAQAAAAIAAAADAAAA/a4BIYQBIDsgFiAuIAwbQQN0aiFeA0ACQAJAIBEgG0kgESAVT3ENACARIFBJIBEgUU9xDQAgEUEBaiErDAELIC0gSEsEQCBdQQA2AgAgXEEANgIACyA5IBYgESAmIBFBAWoiKyBXQQJBABAeIDkgWSARIFggKyBWQQJBABAeAkACQAJAIDxFBEAgVUUNAyAWICZODQICQAJAIBZBAEoEQCBeKAIAIQcMAQsgJCgCACIHIQEgFkEASA0BCyAHIQEgUygCACEHCyBFIEUoAgAgASAHakECakECdWs2AgAgEyIHIA9ODQFBACEHIIQBIYABIIMBIYIBIBMhASAWIQogSkEUSSBUckUEQANAIBQggAFBAf2rASKBAf0bAEECdGoiASAUIIEB/RsDQQJ0aiIGIBQggQH9GwJBAnRqIgogFCCBAf0bAUECdGoiDCAB/QkCAP1WAgAB/VYCAAL9VgIAAyAUIIIBQQH9qwH9DAEAAAABAAAAAQAAAAEAAAD9UCKFAf0bA0ECdGogFCCFAf0bAkECdGogFCCFAf0bAUECdGogFCCFAf0bAEECdGr9CQIA/VYCAAH9VgIAAv1WAgADIBQggQH9DAEAAAABAAAAAQAAAAEAAAD9UCKBAf0bA0ECdGogFCCBAf0bAkECdGogFCCBAf0bAUECdGogFCCBAf0bAEECdGr9CQIA/VYCAAH9VgIAAv1WAgAD/a4B/QwCAAAAAgAAAAIAAAACAAAA/a4BQQL9rAH9sQEigQH9WgIAACAMIIEB/VoCAAEgCiCBAf1aAgACIAYggQH9WgIAAyCCAf0MBAAAAAQAAAAEAAAABAAAAP2uASGCASCAAf0MBAAAAAQAAAAEAAAABAAAAP2uASGAASAHQQRqIgcgMkcNAAsgQiEBIDghCiAPIQcgMiBKRg0CCwNAIBQgAUEDdGoiByAHKAIAIBQgCkEDdGooAgQgBygCBGpBAmpBAnVrNgIAIAEiCkEBaiIBIA9HDQALIA8hBwwBCwJAIFtFBEAgFiIHICZODQEDQCAUIAdBA3RqIgEoAgQhBiABIAYCfwJAIAdBAE4EQCABIE0gByAuSBsoAgAhOiAHQQFqIQEMAQsgFCgCACE6QQAhASAUIAdBAWoiBw0BGgsgASAuTgRAIAEhByBNDAELIBQgASIHQQN0agsoAgAgOmpBAmpBAnVrNgIEIAcgJkgNAAsMAQsgFCAUKAIAQQJtNgIADAMLIBAiByA0Tg0CA0AgFCAHQQN0aiIBKAIAIQoCfyAHQQBIBEAgJCgCACEGICQMAQsgFCAHQQN0akEEaiBMIAcgGkgbKAIAIQYgJCAHRQ0AGiBMIAFBBGsgByAaShsLIQwgASAMKAIAIAZqQQF1IApqNgIAIAdBAWoiByA0Rw0ACwwCCyAHICZODQADQCAUIAdBA3RqIgEgASgCAAJ/AkAgB0EASgRAIDsgByAuIAcgLkgbQQN0aigCACEKDAELICQoAgAhCiAkIAdBAEgNARoLIFIgByAuTg0AGiAUIAdBA3RqQQRqCygCACAKakECakECdWs2AgAgB0EBaiIHICZHDQALCyAQIDRODQAgLyAQIgEiB0oEQANAIBQgB0EDdGoiASABKAIEIBQgB0EBaiIHQQN0aigCACABKAIAakEBdWo2AgQgByAvRw0ACyAvIQELIAEgNE4NAANAAn8CQCABIgdBAE4EQCAUIAFBA3RqIEsgASAaSBsoAgAhDCABQQFqIQoMAQsgFCgCACEMQQAhCiAUIAdBAWoiAQ0BGgsgCiAaTgRAIAohASBLDAELIBQgCiIBQQN0agshBiAUIAdBA3RqIgcgBygCBCAGKAIAIAxqQQF1ajYCBCABIDRIDQALCyA5IBggESBJICsgWkEBQQBBABAmRQ0GCyArIhEgJ0cNAAsLIAhBmAFqIQggPkEBdCIBID9BAXRBAXIiByABIAdLGyIBICcgASAnSRshSCBDIBVBBXQiAWogOyAsQQV0IgdqIBUgLEgiBhshSiABIB9qIAcgQWogBhshSyABICBqIAcgRGogBhshTCABIDZqIAcgN2ogBhshTSAcIBJBAWsgEiAcShshDCAsQQBKIg8gEkEBSnIhUiABIBRqIisgR0EEdGohUyApIBJBA3QiGkEIayI+QQAgEkEATBtBAnQiCmohVCAKICpqIVUgCiAkaiFWIAogFGohVyApQQAgLEEDdCIKQQhrIj8gDxtBAnQiD2ohWCAPICpqIVkgDyAkaiFaIA8gFGohWyAUQQQgR0ECdGtBAnRqIA5BBXRqIVwgGyAsIBsgLEgbIQ8gFUEBaiEQIBQgI0EBdCIWID1BAXRBAXIiEyATIBZLGyJdQQR0aiFeIAEgKWohPSABICpqISMgASAkaiEvIBpBAWshOCAaQQJrIUIgGkEDayEuIBQgEkEFdGohYSAaQQRrITQgCkEFayFiIApBBmshYyAKQQdrIWQgEkUgLEEBRnEhZSApIAdBEGsiAWohJiABICpqITogASAkaiE8IAEgFGohRSApID5BAnQiAWohaCABICpqIWkgASAkaiFqIAEgFGohayA7IBUgLCAGG0EFdCIBaiFsIAEgQWohEyABIERqIREgASA3aiFtICkgP0ECdCIBaiFuIAEgKmohbyABICRqIXAgASAUaiFxA0ACQAJAAn8CQCAYIhYgSUkEQCA5IBYgFUEEIEkgFmsiASABQQRPGyAWaiIYIBsgU0EBQQgQHiA5IBYgUSAYIFAgXEEBQQgQHiBHRQRAIFJFDQUgFSAbTg0EAn8gFUEASgRAIG0oAgAhByATIQYgESEKIGwMAQsgNigCACEHIBVBAEgNAyAfIQYgICEKIEMLIXkgKyArKAIAIAcgTSgCAGpBAmpBAnVrNgIAIC8gLygCACAKKAIAIEwoAgBqQQJqQQJ1azYCACAjICMoAgAgBigCACBLKAIAakECakECdWs2AgAgSigCACEHIHkoAgAMAwsgZQRAIBQgFCgCAEECbTYCACAkICQoAgBBAm02AgAgKiAqKAIAQQJtNgIAICkgKSgCAEECbTYCAAwFCyAbIBUiB0oEQANAIAdBA3QhAQJ/AkAgB0EASARAIAdBf0YNASAUIAFBAnRqIgEgASgCECAUKAIAQQF0QQJqQQJ1azYCECABIAEoAhQgJCgCAEEBdEECakECdWs2AhQgASABKAIYICooAgBBAXRBAmpBAnVrNgIYICkoAgBBAXRBAmohBiABQRxqDAILICwgB0EBaiIGTARAIBQgAUECdGoiCiAKKAIQIBQgASA/IAcgLEgiBhtBAnRqKAIAIHEoAgBqQQJqQQJ1azYCECAKIAooAhQgFCABQQFyIGQgBhtBAnRqKAIAIHAoAgBqQQJqQQJ1azYCFCAKIAooAhggFCABQQJyIGMgBhtBAnRqKAIAIG8oAgBqQQJqQQJ1azYCGCAUIAFBA3IgYiAGG0ECdGooAgAgbigCAGpBAmohBiAKQRxqDAILIBQgAUECdGoiASABKAIQIAEoAgAgFCAGQQV0aiIGKAIAakECakECdWs2AhAgASABKAIUIAEoAgQgBigCBGpBAmpBAnVrNgIUIAEgASgCGCABKAIIIAYoAghqQQJqQQJ1azYCGCABKAIMIAYoAgxqQQJqIQYgAUEcagwBCyA3IDcoAgAgFCgCACBbKAIAakECakECdWs2AgAgRCBEKAIAICQoAgAgWigCAGpBAmpBAnVrNgIAIEEgQSgCACAqKAIAIFkoAgBqQQJqQQJ1azYCACApKAIAIFgoAgBqQQJqIQYgOwsiASABKAIAIAZBAnVrNgIAIAdBAWoiByAbRw0ACwsgHCAOIgdMDQQDQCAHQQN0IQECfyAHQQBIBEAgFCABQQJ0aiIBIAEoAgAgNigCAEEBdEEBdWo2AgAgASABKAIEIBQoAhRBAXRBAXVqNgIEIAEgASgCCCAUKAIYQQF0QQF1ajYCCCAUKAIcQQF0IQogAUEMagwBCyAHBEAgFCABQQJ0aiIGIAYoAgAgYSAGIAcgEkoiMhtBEGsoAgAgFCABQQRyIDQgByASSCIKG0ECdGooAgBqQQF1ajYCACAGIAYoAgQgRCAaIAEgMhtBAnQiMmooAgAgFCABQQVyIC4gChtBAnRqKAIAakEBdWo2AgQgBiAGKAIIIDIgQWooAgAgFCABQQZyIEIgChtBAnRqKAIAakEBdWo2AgggMiA7aigCACAUIAFBB3IgOCAKG0ECdGooAgBqIQogBkEMagwBCyAUIBQoAgAgNigCACAUQQQgNCAHIBJIIgEbQQJ0aigCAGpBAXVqNgIAICQgJCgCACAUKAIUIBRBBSAuIAEbQQJ0aigCAGpBAXVqNgIAICogKigCACAUKAIYIBRBBiBCIAEbQQJ0aigCAGpBAXVqNgIAIBQoAhwgFEEHIDggARtBAnRqKAIAaiEKICkLIgEgASgCACAKQQF1ajYCACAHQQFqIgcgHEcNAAsMBAsgLSEaICchEiBGQQFqIkYgHkcNBQwGCyArICsoAgAgB0EBdEECakECdWs2AgAgLyAvKAIAICAoAgBBAXRBAmpBAnVrNgIAICMgIygCACAfKAIAQQF0QQJqQQJ1azYCACBDKAIAIgcLIQEgPSA9KAIAIAEgB2pBAmpBAnVrNgIAIBUhBiAQIgEiByAPSARAA0AgFCABQQV0aiIHIAf9AAIAIDYgBkEFdGr9AAIAIAf9AAIQ/a4B/QwCAAAAAgAAAAIAAAACAAAA/a4BQQL9rAH9sQH9CwIAIAEiBkEBaiIBIA9HDQALIA8hBwsgByAbTg0AA0AgB0EDdCEBIAcgLEghBgJAIAdBAEwEQCA2KAIAIQogB0EATgRAIBQgAUECdCIBaiIyIDIoAgAgCiABIDZqIEUgBhsoAgBqQQJqQQJ1azYCACABICRqIgogCigCACAgKAIAIAEgIGogPCAGGygCAGpBAmpBAnVrNgIAIAEgKmoiCiAKKAIAIB8oAgAgASAfaiA6IAYbKAIAakECakECdWs2AgAgQygCACABIENqICYgBhsoAgBqQQJqIQYgASApaiEBDAILIBQgAUECdCIBaiIGIAYoAgAgCkEBdEECakECdWs2AgAgASAkaiIGIAYoAgAgFCgCFEEBdEECakECdWs2AgAgASAqaiIGIAYoAgAgFCgCGEEBdEECakECdWs2AgAgASApaiEBIBQoAhxBAXRBAmohBgwBCyAUIAcgLCAGG0EDdEEEa0ECdCIKaigCACEyIAZFBEAgFCABQQJ0IgFqIgYgBigCACAyIEUoAgBqQQJqQQJ1azYCACABICRqIgYgBigCACAKICRqKAIAIDwoAgBqQQJqQQJ1azYCACABICpqIgYgBigCACAKICpqKAIAIDooAgBqQQJqQQJ1azYCACABIClqIQEgCiApaigCACAmKAIAakECaiEGDAELIBQgAUECdCIBaiIGIAYoAgAgMiAGKAIQakECakECdWs2AgAgASAkaiIGIAYoAgAgCiAkaigCACAGKAIQakECakECdWs2AgAgASAqaiIGIAYoAgAgCiAqaigCACAGKAIQakECakECdWs2AgAgCiApaigCACABIClqIgEoAhBqQQJqIQYLIAEgASgCACAGQQJ1azYCACAHQQFqIgcgG0cNAAsLIA4gHE4NACAMIA4iASIHSgRAA0AgFCABQQV0aiIHIAf9AAIgIAf9AAIA/a4BQQH9rAEgB/0AAhD9rgH9CwIQIAFBAWoiASAMRw0ACyAMIQcLIAcgHE4NAANAIEMgB0EDdCIBQQJ0aiIyAn8gB0EASARAIBQoAgAhBiAHQX9HBEAgNiABQQJ0IgFqIgogCigCACAGajYCACABICBqIgYgBigCACAkKAIAajYCACABIB9qIgEgASgCACAqKAIAajYCACApKAIADAILIDYgAUECdCIBaiIKIAooAgAgVygCACAGakEBdWo2AgAgASAgaiIGIAYoAgAgVigCACAkKAIAakEBdWo2AgAgASAfaiIBIAEoAgAgVSgCACAqKAIAakEBdWo2AgAgVCgCACApKAIAakEBdQwBCyABID4gByASSBshBiASIAdBAWoiZkwEQCA2IAFBAnQiCmoiASABKAIAIGsoAgAgFCAGQQJ0aiIBKAIAakEBdWo2AgAgCiAgaiIGIAYoAgAgaigCACABKAIEakEBdWo2AgAgCiAfaiIGIAYoAgAgaSgCACABKAIIakEBdWo2AgAgaCgCACABKAIMakEBdQwBCyA2IAFBAnQiCmoiASABKAIAIBQgZkEFdGoiASgCACAUIAZBAnRqIgYoAgBqQQF1ajYCACAKICBqImYgZigCACABKAIEIAYoAgRqQQF1ajYCACAKIB9qIgogCigCACABKAIIIAYoAghqQQF1ajYCACABKAIMIAYoAgxqQQF1CyAyKAIAajYCACAHQQFqIgcgHEcNAAsLIDkgFiBdIBggSCBeQQFBBEEAECYNAAsLDAILIBQQEEEBIQcLIDkgNUEQaygCACIBIF8oAgAiBmsgNUEMaygCACBgKAIAIgprIDVBCGsoAgAiCCAGayA1QQRrKAIAIAprIAkoAjRBASAIIAFrEB4gORAjDAMLIDkQIyAUEBBBACEHDAILIDkQI0EAIQcMAQtBACEHIA4QICAPEBALICVBIGokACAHDQEMBQsgASEIQQAhDv0MAAAAAAAAAAAAAAAAAAAAACGAASMAQUBqIhwkAAJAAn8CQCAZKAJABEAgCSgCHCIVIAkoAhhBmAFsaiIBQZgBaygCACEaIAFBkAFrKAIAIRsgFSgCBCEMIBUoAgwheiAVKAIAIRAgFSgCCCETQQEhByAZKAIsIh8oAgQhKyAIQQFGDQNBACEGIAhBAWsiFiEIIBUhAQJAIBZBBE8EQCAWQQNxIQggASAWQXxxIgpBmAFsaiEBQQAhBwNAIIABIBUgB0GYAWxqIgZB6ARqIAZB0ANqIAZBuAJqIAb9CQKgAf1WAgAB/VYCAAL9VgIAAyAGQeAEaiAGQcgDaiAGQbACaiAG/QkCmAH9VgIAAf1WAgAC/VYCAAP9sQH9uQEgBkHsBGogBkHUA2ogBkG8AmogBv0JAqQB/VYCAAH9VgIAAv1WAgADIAZB5ARqIAZBzANqIAZBtAJqIAb9CQKcAf1WAgAB/VYCAAL9VgIAA/2xAf25ASGAASAHQQRqIgcgCkcNAAsggAEggAEggAH9DQgJCgsMDQ4PAAECAwABAgP9uQEigAEggAEggAH9DQQFBgcAAQIDAAECAwABAgP9uQH9GwAhBiAKIBZGDQELA0AgBiABKAKgASABKAKYAWsiByAGIAdLGyIHIAEoAqQBIAEoApwBayIGIAYgB0kbIQYgAUGYAWohASAIQQFrIggNAAsLQQAhByAGQf///z9LDQMgHCAGQQV0IkYQGCIBNgIgIAFFDQMgHCABNgIAIBZFBEBBASEHIAEQEAwECyB6IAxrIQ8gEyAQayEOQQIgK0EBdiIBIAFBAk0bIUcgCSgCJCIKIBtBHGwiTSAaQRxsIl9raiEvIAogG0EYbCJgIBpBGGwiUmtqIT0gCiAbQRRsIlMgGkEUbCJUa2ohPiAKIBtBBHQiVSAaQQR0IlZraiE/IAogG0EMbCJXIBpBDGwiWGtqITggGyAaayIQQQdsIUkgEEEGbCFFIBBBBWwhMiAQQQNsIUggEEEBdCFQIAogEEEDdCJRaiFCIAogEEECdCJBaiEUIBBBBXQhWSAQ/REhhAEDQCAcIA82AgggHCAOIgE2AiggFSgCnAEhJCAVKAKkASEpIBUoAqABIR4gFSgCmAEhICAcQQA2AjggHCABNgI0IBxBADYCMCAcICBBAm8iGDYCLCAcIB4gIGsiDiABayITNgI8IBwgEzYCJAJAICtBAkgiWkUgKSAkayIPQQ9LcUUEQEEAIQcgCiEGIA9BCEkNASA/IAYgUyAeQQJ0IgFqIFQgIEECdCIIamtqIjpJID4gBiABIFVqIAggVmpraiJDSXEgPSBDSSA/IAYgASBgaiAIIFJqa2oiPElxciAvIENJID8gBiABIE1qIAggX2praiJESXFyIVsgPSBESSAvIDxJcSFcID4gREkgLyA6SXEhXSA8ID5LIDogPUtxIV4gQiAGIAEgV2ogCCBYamtqIkpJIDggBiABIFFqIAhraiJLSXEhYSAUIEpJIDggBiAbIB5qIBogIGprQQJ0aiJMSXEhYiAUIEtJIEIgTElxIWMgBiABIAhraiEqIA5BfHEhCCAcKAIgIhMgDkEFdGoiEUEQayElIBFBFGshLCARQRhrIS4gEUEcayE2IBFBBGshOSARQQhrITsgEUEMayE0QQAhGCATQQxqIiMgHiAgQX9zaiIMQQV0IgFqICNJIAxB////P0siDCATQQRqIiEgAWogIUkgASATaiATSXJyIBNBCGoiIiABaiAiSXJyIA5ByAJJciFkIBNBFGoiKCABaiAoSSATQRBqIicgAWogJ0lyIAxyIBNBGGoiMCABaiAwSXIgE0EcaiItIAFqIC1JciAOQdQASXIhZQNAIAchDCAcQSBqIgEgBiAQQQgQOyABECICQCAORQ0AIBggWWwhB0EAIQECQAJAIGQNACBhIAYgNkkgEyAHICpqIjdJcSAGIAcgSmoiEkkgKiA4S3EgFCAqSSAGIAcgTGoiJklxIAYgByBLaiI1SSAqIEJLcXJyciAGIC5JICEgN0lxciAGICxJICIgN0lxciAGICVJICMgN0lxciBjciBiciATICZJIAcgFGoiNyA2SXFyICEgJkkgLiA3S3FyICIgJkkgLCA3S3FyICMgJkkgJSA3S3Fycg0AIBMgNUkgByBCaiImIDZJcQ0AICEgNUkgJiAuSXENACAiIDVJICYgLElxDQAgIyA1SSAlICZLcQ0AIAcgOGoiJiA2SSASIBNLcQ0AICYgLkkgEiAhS3ENACAmICxJIBIgIktxDQAgEiAjSyAlICZLcQ0AA0AgBiABQQJ0aiATIAFBBXRqIhL9CQIAIBIqAiD9IAEgEkFAayoCAP0gAiASKgJg/SAD/QsCACAGIAEgEGpBAnRqIBL9CQIEIBIqAiT9IAEgEioCRP0gAiASKgJk/SAD/QsCACAGIAEgUGpBAnRqIBL9CQIIIBIqAij9IAEgEioCSP0gAiASKgJo/SAD/QsCACAGIAEgSGpBAnRqIBL9CQIMIBIqAiz9IAEgEioCTP0gAiASKgJs/SAD/QsCACABQQRqIgEgCEcNAAsgCCIBIA5GDQELA0AgBiABQQJ0aiATIAFBBXRqIhIqAgA4AgAgBiABIBBqQQJ0aiASKgIEOAIAIAYgASBQakECdGogEioCCDgCACAGIAEgSGpBAnRqIBIqAgw4AgAgAUEBaiIBIA5HDQALC0EAIQECQCBlDQAgXCAHID5qIhIgNEkgJyAHIDpqIiZJcSBbIAcgP2oiNSA0SSAnIAcgQ2oiN0lxciAoIDdJIDUgO0lxciAwIDdJIDUgOUlxciAtIDdJIBEgNUtxciBeciBdcnIgEiA7SSAmIChLcXIgEiA5SSAmIDBLcXIgJiAtSyARIBJLcXJyDQAgByA9aiISIDRJICcgByA8aiImSXENACASIDtJICYgKEtxDQAgEiA5SSAmIDBLcQ0AICYgLUsgESASS3ENACAHIC9qIhIgNEkgJyAHIERqIgdJcQ0AIBIgO0kgByAoS3ENACASIDlJIAcgMEtxDQAgByAtSyARIBJLcQ0AA0AgBiABIEFqQQJ0aiATIAFBBXRqIgf9CQIQIAcqAjD9IAEgByoCUP0gAiAHKgJw/SAD/QsCACAGIAEgMmpBAnRqIAf9CQIUIAcqAjT9IAEgByoCVP0gAiAHKgJ0/SAD/QsCACAGIAEgRWpBAnRqIAf9CQIYIAcqAjj9IAEgByoCWP0gAiAHKgJ4/SAD/QsCACAGIAEgSWpBAnRqIAf9CQIcIAcqAjz9IAEgByoCXP0gAiAHKgJ8/SAD/QsCACABQQRqIgEgCEcNAAsgCCIBIA5GDQELA0AgBiABIEFqQQJ0aiATIAFBBXRqIgcqAhA4AgAgBiABIDJqQQJ0aiAHKgIUOAIAIAYgASBFakECdGogByoCGDgCACAGIAEgSWpBAnRqIAcqAhw4AgAgAUEBaiIBIA5HDQALCyAYQQFqIRggDEEIaiEHIAYgUUECdGohBiAMQQ9qIA9JDQALDAELIA8gD0EDdiIHICsgByArSRsiEm5BeHEhESAPQXhxIQdBACEIIAohBgNAQTAQFCIMRQ0EIAwgRhAYIiM2AgAgI0UEQCAfECAgDBAQQQAMBgsgDCAGNgIoIAwgEDYCJCAMIA42AiAgDCATNgIcIAxBADYCGCAMIAE2AhQgDEEANgIQIAwgGDYCDCAMIAE2AgggDCATNgIEIAwgByAIIBFsayARIAhBAWoiCCASRhsiIzYCLCAfQQwgDBAtIAYgECAjbEECdGohBiAIIBJHDQALIB8QIAsCQCAHIA9PDQAgHEEgaiIBIAYgECAPIAdrIhgQOyABECIgDkUNACAcKAIgIiMgHkEFdEEBIBggGEEBTRsiEkECdGogIEEFdGtqQSBrIR4gEkEDcSEgIBJBfHEhDCBBIBJBAWtsISFBACEIA0AgIyAIQQV0aiETQQAhBwJAAkAgGEEESQ0AIB4gBiAIQQJ0IhFqIgEgBiARICFqaiIRIAEgEUkbSwRAICMgASARIAEgEUsbQQRqSQ0BCyAI/REhgQH9DAAAAAABAAAAAgAAAAMAAAAhgAFBACEBA0AgBiCAASCEAf21ASCBAf2uASKCAf0bAEECdGogEyABQQJ0av0AAgAigwH9HwA4AgAgBiCCAf0bAUECdGoggwH9HwE4AgAgBiCCAf0bAkECdGoggwH9HwI4AgAgBiCCAf0bA0ECdGoggwH9HwM4AgAggAH9DAQAAAAEAAAABAAAAAQAAAD9rgEhgAEgAUEEaiIBIAxHDQALIAwiByASRg0BC0EAIREgByEBICAEQANAIAYgASAQbCAIakECdGogEyABQQJ0aioCADgCACABQQFqIQEgEUEBaiIRICBHDQALCyAHIBJrQXxLDQADQCAGIAEgEGwgCGpBAnRqIBMgAUECdGoqAgA4AgAgBiABQQFqIgcgEGwgCGpBAnRqIBMgB0ECdGoqAgA4AgAgBiABQQJqIgcgEGwgCGpBAnRqIBMgB0ECdGoqAgA4AgAgBiABQQNqIgcgEGwgCGpBAnRqIBMgB0ECdGoqAgA4AgAgGCABQQRqIgFHDQALCyAIQQFqIgggDkcNAAsLIBwgDyAcKAIIIgxrIhM2AgQgFSgCnAEhASAcQQA2AhAgHCAMNgIUIBxBADYCGCAcIBM2AhwgHCABQQJvIhg2AgwCQCBaRSAOQQ9LcUUEQCAKIQEgDkEISQ0BIA9BfnEhISAPQQFxISIgE0F+cSEoIBNBAXEhJyAMQX5xITAgDEEBcSEtICkgJEF/c2ohIyAcKAIAIhIgGEEFdCIHaiEgIBIgB2tBIGohHiAMIBBsQQJ0ISogDiEIA0BBACEGQQAhBwJAAkACQCAMDgICAQALA0AgICAGQQZ0aiIRIAEgBiAQbEECdGoiJf0AAgD9CwIAIBEgJf0AAhD9CwIQICAgBkEBciIRQQZ0aiIlIAEgECARbEECdGoiEf0AAhD9CwIQICUgEf0AAgD9CwIAIAZBAmohBiAHQQJqIgcgMEcNAAsLIC1FDQAgICAGQQZ0aiIHIAEgBiAQbEECdGoiBv0AAgD9CwIAIAcgBv0AAhD9CwIQCwJAIAwgD0YNACABICpqIQdBACEGQQAhESAMICNHBEADQCAeIAZBBnRqIiUgByAGIBBsQQJ0aiIs/QACAP0LAgAgJSAs/QACEP0LAhAgHiAGQQFyIiVBBnRqIiwgByAQICVsQQJ0aiIl/QACEP0LAhAgLCAl/QACAP0LAgAgBkECaiEGIBFBAmoiESAoRw0ACwsgJ0UNACAeIAZBBnRqIhEgByAGIBBsQQJ0aiIH/QACAP0LAgAgESAH/QACEP0LAhALIBwQIgJAIA9FDQBBACEGQQAhByAjBEADQCABIAYgEGxBAnRqIhEgEiAGQQV0aiIl/QACAP0LAgAgESAl/QACEP0LAhAgASAGQQFyIhEgEGxBAnRqIiUgEiARQQV0aiIR/QACEP0LAhAgJSAR/QACAP0LAgAgBkECaiEGIAdBAmoiByAhRw0ACwsgIkUNACABIAYgEGxBAnRqIgcgEiAGQQV0aiIG/QACAP0LAgAgByAG/QACEP0LAhALIAFBIGohASAIQQhrIghBB0sNAAsMAQtBASAOQQN2IgEgRyABIEdJGyIIIAhBAU0bIREgDiAIbkF4cSESIA5BeHEhIEEAIQcgCiEBA0BBMBAUIgZFDQQgBiBGEBgiHjYCACAeRQRAIB8QICAGEBBBAAwGCyAGIAE2AiggBiAQNgIkIAYgDzYCICAGIBM2AhwgBkEANgIYIAYgDDYCFCAGQQA2AhAgBiAYNgIMIAYgDDYCCCAGIBM2AgQgBiAgIAcgEmxrIBIgB0EBaiIHIAhGGyIeNgIsIB9BDSAGEC0gASAeQQJ0aiEBIAcgEUcNAAsgHxAgCwJAIA5BB3EiEkUNACAYQQV0ISAgHCgCACEIAkAgDEUNACAIICBqIREgEkECdCEYQQAhBiAMQQFHBEAgDEF+cSEeQQAhBwNAIBEgBkEGdGogASAGIBBsQQJ0aiAYEBIaIBEgBkEBciIjQQZ0aiABIBAgI2xBAnRqIBgQEhogBkECaiEGIAdBAmoiByAeRw0ACwsgDEEBcUUNACARIAZBBnRqIAEgBiAQbEECdGogGBASGgsCQCAMIA9GDQAgCCAga0EgaiEHIAEgDCAQbEECdGohESASQQJ0IRhBACEGIAwgKSAkQX9zakcEQCATQX5xISBBACEMA0AgByAGQQZ0aiARIAYgEGxBAnRqIBgQEhogByAGQQFyIh5BBnRqIBEgECAebEECdGogGBASGiAGQQJqIQYgDEECaiIMICBHDQALCyATQQFxRQ0AIAcgBkEGdGogESAGIBBsQQJ0aiAYEBIaCyAcECIgD0UNACASQQJ0IQdBACEGICRBAWogKUcEQCAPQX5xIQxBACERA0AgASAGIBBsQQJ0aiAIIAZBBXRqIAcQEhogASAGQQFyIhMgEGxBAnRqIAggE0EFdGogBxASGiAGQQJqIQYgEUECaiIRIAxHDQALCyAPQQFxRQ0AIAEgBiAQbEECdGogCCAGQQV0aiAHEBIaCyAVQZgBaiEVIBZBAWsiFg0AC0EBDAILQQEhByAJKAIcIgwgCEGYAWxqIiNBmAFrIi8oAgAgI0GQAWsoAgBGDQIgI0GUAWsiPSgCACAjQYwBaygCAEYNAiAMKAIEIQ8gDCgCDCEWIAwoAgAhECAMKAIIIRMgCSgCRCESIAkoAkAhESAJKAI8IRogCSgCOCEfIAkgCBBcIh5FBEBBACEHDAMLIAhBAUYEQCAeICNBEGsoAgAiASAvKAIAIgZrICNBDGsoAgAgPSgCACIKayAjQQhrKAIAIgggBmsgI0EEaygCACAKayAJKAI0QQEgCCABaxAeIB4QIwwDC0EAIQYCQAJAIAhBAWsiCkEESQRAIAohByAMIQEMAQsgCkEDcSEHIAwgCkF8cSIVQZgBbGohAQNAIIABIAwgDkGYAWxqIgZB6ARqIAZB0ANqIAZBuAJqIAb9CQKgAf1WAgAB/VYCAAL9VgIAAyAGQeAEaiAGQcgDaiAGQbACaiAG/QkCmAH9VgIAAf1WAgAC/VYCAAP9sQH9uQEgBkHsBGogBkHUA2ogBkG8AmogBv0JAqQB/VYCAAH9VgIAAv1WAgADIAZB5ARqIAZBzANqIAZBtAJqIAb9CQKcAf1WAgAB/VYCAAL9VgIAA/2xAf25ASGAASAOQQRqIg4gFUcNAAsggAEggAEggAH9DQgJCgsMDQ4PAAECAwABAgP9uQEigAEggAEggAH9DQQFBgcAAQIDAAECAwABAgP9uQH9GwAhBiAKIBVGDQELA0AgBiABKAKgASABKAKYAWsiCiAGIApLGyIGIAEoAqQBIAEoApwBayIKIAYgCksbIQYgAUGYAWohASAHQQFrIgcNAAsLAkAgBkGAgIDAAE8NACAcIAZBBXQQGCIhNgIgICFFDQAgHCAhNgIAAkAgCARAIBYgD2shCiATIBBrIQYgIUEgaiE+IAitIYcBIBKtIYoBIBGtIYsBIBqtIYgBIB+tIYwBIAkoAhQiQq0hjQFCASGGAQNAIBwgCjYCCCAcIAY2AiggDCgCpAEhByAMKAKgASEIIAwoApwBIQEgHCAMKAKYASIVQQJvIiI2AiwgHCABQQJvIj82AgwgHCAIIBVrIiAgBmsiKDYCJCAcIAcgAWsiEyAKayI4NgIEIB8iFiEIIBoiASEOIBEiByEYIBIiFSEPAkAghgEgjQFRDQAgQiCGAadrIRBBACEOQQAhCCAWBEBCfyAQrSKJAYZCf4UgjAF8IIkBiKchCAsgGgRAQn8gEK0iiQGGQn+FIIgBfCCJAYinIQ4LQQAhFUEAIQcgEQRAQn8gEK0iiQGGQn+FIIsBfCCJAYinIQcLIBIEQEJ/IBCtIokBhkJ/hSCKAXwgiQGIpyEVC0EAIRhBACEWQQEgEEEBa3QiGyAfSQRAIB8gG2utQn8gEK0iiQGGQn+FfCCJAYinIRYLIBEgG0sEQCARIBtrrUJ/IBCtIokBhkJ/hXwgiQGIpyEYC0EAIQ9BACEBIBogG0sEQCAaIBtrrUJ/IBCtIokBhkJ/hXwgiQGIpyEBCyASIBtNDQAgEiAba61CfyAQrSKJAYZCf4V8IIkBiKchDwtBfyAYIAwoArQBIhBrIhtBACAYIBtPGyIYQQRqIhsgGCAbSxsiGCAoIBggKEkbIi1BfyAHIAwoAtgBIhhrIhtBACAHIBtPGyIHQQRqIhsgByAbSxsiByAGIAYgB0sbIisgIhtBAXQiByArIC0gIhtBAXRBAXIiGyAHIBtLGyIoICBJIRQgFiAQayIHQQAgByAWTRsiB0EEayIWQQAgByAWTxsiJyAIIBhrIgdBACAHIAhNGyIHQQRrIghBACAHIAhPGyIwICIbQQF0IhggMCAnICIbQQF0QQFyIiRJISkgDiAMKAK4ASIWayIHQQAgByAOTRsiB0EEayIIQQAgByAITxsiCCEQIAEgDCgC3AEiDmsiB0EAIAEgB08bIgFBBGsiB0EAIAEgB08bIgEhB0F/IBUgFmsiFkEAIBUgFk8bIhVBBGoiFiAVIBZLGyIVIAogCiAVSxsiFiEVQX8gDyAOayIOQQAgDiAPTRsiDkEEaiIPIA4gD0sbIg4gOCAOIDhJGyIbIQ8gPwRAIAEhECAWIQ8gGyEVIAghBwsgKCAgIBQbISggGCAkICkbIRggHCAtNgI8IBwgJzYCOCAcICs2AjQgHCAwNgIwAkAgE0EISQRAQQchBkEAIQ4MAQsgPiAiQQV0Ig5rICdBBnRqITggDiAhaiAwQQZ0aiEUIAYgLWohLSAGICdqIScgCiAbaiEkIAEgCmohKSAhIBhBBXRqISpBACEOA0ACQAJAIA4gFkkgDkEHciIGIAhPcQ0AIA4gJEkgBiApT3ENACAOQQhqIQ4MAQtBCCATIA5rIgYgBkEITxshJUEAIQYDQCAeIDAgBiAOaiIiICsgIkEBaiIsIBQgBkECdCIuakEQQQAQHiAeICcgIiAtICwgLiA4akEQQQAQHiAGQQFqIgYgJUcNAAsgHEEgahAiIB4gGCAOICggDkEIaiIOICpBCEEBQQAQJkUNBQsgDkEHciIGIBNJDQALCwJAIA4gE08NACAOIBZJIAYgCE9xRQRAIA4gCiAbak8NASAGIAEgCmpJDQELIBxBIGohBkEAISIgEyAOayIwBEADQCAeIAYoAhAiLSAOICJqIicgBigCFCAnQQFqIisgIkECdCI4IAYoAgAgBigCDEEFdGogLUEGdGpqQRBBABAeIB4gBigCGCItIAYoAggiFGogJyAGKAIcIBRqICsgBigCACAGKAIMQQV0ayAtQQZ0aiA4akEgakEQQQAQHiAiQQFqIiIgMEcNAAsLIAYQIiAeIBggDiAoIBMgISAYQQV0akEIQQFBABAmRQ0DCyAcIBs2AhwgHCABNgIYIBwgFjYCFCAcIAg2AhAgGCAoSQRAIBVBAXQiBiAPQQF0QQFyIhUgBiAVSxsiBiATIAYgE0kbIQYgPiA/QQV0IhVrIAFBBnRqIQ4gFSAhaiAIQQZ0aiEVIAogG2ohDyABIApqIQogISAQQQF0IgEgB0EBdEEBciIHIAEgB0kbIgdBBXRqIRADQCAeIBggCEEIICggGGsiASABQQhPGyAYaiIBIBYgFUEBQRAQHiAeIBggCiABIA8gDkEBQRAQHiAcECIgHiAYIAcgASAGIBBBAUEIQQAQJkUNBCAYQQhqIhggKEkNAAsLIAxBmAFqIQwgICEGIBMhCiCGAUIBfCKGASCHAVINAAsLQQEhByAeICNBEGsoAgAiASAvKAIAIgZrICNBDGsoAgAgPSgCACIKayAjQQhrKAIAIgggBmsgI0EEaygCACAKayAJKAI0QQEgCCABaxAeIB4QIyAhEBAMBAsgHhAjICEQEEEAIQcMAwsgHhAjQQAhBwwCCyAfECBBAAshByAcKAIgEBALIBxBQGskACAHDQAMBAsgHUG4CGohHSANQTRqIQ0gCUHMAGohCSALQQFqIgsgFygCEEkNAAsgGSgCICEdIBkoAhQoAgAhFwsCQCAdKAIQIglFDQAgGSgCRA0AIBcoAhQiDSgCHCEBAkACQAJAIBkoAkAiBgRAIBcoAhAiC0EDSQ0CAkAgDSgCGCIHIA0oAmRGBEAgByANKAKwAUYNAQsgM0EBQdTKAEEAEA8MBwsCQCAZKAIYKAIYIgooAiQiCCAKKAJYRw0AIAggCigCjAFHDQAgASAHQZgBbCIKaiIBQYwBaygCACABQZQBaygCAGsgAUGQAWsoAgAgAUGYAWsoAgBrbCIBIA0oAmggCmoiB0GMAWsoAgAgB0GUAWsoAgBrIAdBkAFrKAIAIAdBmAFrKAIAa2xHDQAgDSgCtAEgCmoiB0GMAWsoAgAgB0GUAWsoAgBrIAdBkAFrKAIAIAdBmAFrKAIAa2wgAUYNAgsgM0EBQdTKAEEAEA8MBgsgFygCECILQQNJDQECQCAZKAIYKAIYIgcoAiQiCiAHKAJYRw0AIAogBygCjAEiCEcNACABIApBmAFsIgdqIgEoApQBIAEoAowBayABKAKQASABKAKIAWtsIgEgByANKAJoaiIHKAKUASAHKAKMAWsgBygCkAEgBygCiAFrbEcNACANKAK0ASAIQZgBbGoiBygClAEgBygCjAFrIAcoApABIAcoAogBa2wgAUYNAQsgM0EBQdTKAEEAEA8MBQsgCUECRgRAIB0oAugrRQ0DIAtBAnQQFCILRQ0FIBcoAhAiCEUNAiAZKAJABEBBACEXAkAgCEEMSQRAQQAhBgwBCyANQSRqIQoCQCALIA0gCEHMAGxqQSRrTw0AIAogCyAIQQJ0ak8NAEEAIQYMAQsgDUGIAmohDCANQbwBaiEVIA1B8ABqIQ4gDSAIQXxxIgZBzABsaiENQQAhCQNAIAsgCUECdGogDCAJQcwAbCIHaiAHIBVqIAcgDmogByAKav0JAgD9VgIAAf1WAgAC/VYCAAP9CwIAIAlBBGoiCSAGRw0ACyAGIAhGDQQLAkAgCEEDcSIHRQRAIAYhCQwBCyAGIQkDQCALIAlBAnRqIA0oAiQ2AgAgCUEBaiEJIA1BzABqIQ0gF0EBaiIXIAdHDQALCyAGIAhrQXxLDQMgC0EMaiEGIAtBCGohCiALQQRqIQwDQCALIAlBAnQiB2ogDSgCJDYCACAHIAxqIA0oAnA2AgAgByAKaiANKAK8ATYCACAGIAdqIA0oAogCNgIAIA1BsAJqIQ0gCUEEaiIJIAhHDQALDAMLQQAhFwJAIAhBDEkEQEEAIQYMAQsgDUE0aiEKAkAgCyANIAhBzABsakEUa08NACAKIAsgCEECdGpPDQBBACEGDAELIA1BmAJqIQwgDUHMAWohFSANQYABaiEOIA0gCEF8cSIGQcwAbGohDUEAIQkDQCALIAlBAnRqIAwgCUHMAGwiB2ogByAVaiAHIA5qIAcgCmr9CQIA/VYCAAH9VgIAAv1WAgAD/QsCACAJQQRqIgkgBkcNAAsgBiAIRg0DCwJAIAhBA3EiB0UEQCAGIQkMAQsgBiEJA0AgCyAJQQJ0aiANKAI0NgIAIAlBAWohCSANQcwAaiENIBdBAWoiFyAHRw0ACwsgBiAIa0F8Sw0CIAtBDGohBiALQQhqIQogC0EEaiEMA0AgCyAJQQJ0IgdqIA0oAjQ2AgAgByAMaiANKAKAATYCACAHIApqIA0oAswBNgIAIAYgB2ogDSgCmAI2AgAgDUGwAmohDSAJQQRqIgkgCEcNAAsMAgsgHSgC0CsoAhRBAUYEQCAGBEAgDSgCJCANKAJwIA0oArwBIAEQXwwECyANKAI0IA0oAoABIA0oAswBIAEQXwwDCyAGBEAgDSgCJCANKAJwIA0oArwBIAEQXgwDCyANKAI0IA0oAoABIA0oAswBIAEQXgwCCyBAIAs2AgAgM0EBQZHLACBAEA8MAQsgGSgCGCgCGCgCIBoCfyAdKALoKyEHQQAhDkEAIAhBA3QQFCINRQ0AGgJAIAFFDQAgCEUNACANIAhBAnRqIRMgCEF8cSEPIAhBA3EhDCAIQQFrIRADQEEAIRdBACEJIBBBA08EQANAIA0gF0ECdCIGaiAGIAtqKAIAKgIAOAIAIA0gBkEEciIKaiAKIAtqKAIAKgIAOAIAIA0gBkEIciIKaiAKIAtqKAIAKgIAOAIAIA0gBkEMciIGaiAGIAtqKAIAKgIAOAIAIBdBBGohFyAJQQRqIgkgD0cNAAsLQQAhCiAMBEADQCANIBdBAnQiBmogBiALaigCACoCADgCACAXQQFqIRcgCkEBaiIKIAxHDQALC0EAIQYgByEXA0AgEyAGQQJ0IhJqIglBADYCAEMAAAAAIY4BQQAhCkEAIRYgEEECSwRAA0AgCSAXKgIAIA0gCkECdGoiFSoCAJQgjgGSIo4BOAIAIAkgFyoCBCAVKgIElCCOAZIijgE4AgAgCSAXKgIIIBUqAgiUII4BkiKOATgCACAJIBcqAgwgFSoCDJQgjgGSIo4BOAIAIApBBGohCiAXQRBqIRcgFkEEaiIWIA9HDQALC0EAIRUgDARAA0AgCSAXKgIAIA0gCkECdGoqAgCUII4BkiKOATgCACAKQQFqIQogF0EEaiEXIBVBAWoiFSAMRw0ACwsgCyASaiIKIAooAgAiCkEEajYCACAKII4BOAIAIAZBAWoiBiAIRw0ACyAOQQFqIg4gAUcNAAsLIA0QEEEBCyF7IAsQECB7RQ0CCyAZKAIUKAIAIhYoAhBFBEBBASExDAILIBkoAiAoAtArIhdBuAhqIRMgF0G0CGohEiAZKAJEIRAgFigCFCEHIBkoAhgoAhghCkEAIQgDQAJAIBAEQCAQIAhBAnRqKAIARQ0BCyAHKAIcIgEgCigCJEGYAWxqIQsCfyAZKAJARQRAIAsoApQBIAsoAowBayEGIAsoApABIAsoAogBayEBQQAhDEE0DAELIAEgBygCGEGYAWxqIgZBkAFrKAIAIAsoAgggCygCAGsiASAGQZgBaygCAGprIQwgCygCDCALKAIEayEGQSQLIQkgCigCGCELAn8gCigCIARAQQEgC0EBa3QiC0EBayEdQQAgC2sMAQtBfyALdEF/cyEdQQALIQ8gAUUNACAGRQ0AIAcgCWooAgAhCSAXKAIUQQFGBEAgEyAIQbgIbCILaiERIAsgEmohGCABQQFxIRogAUECdCEzIAFBfHEiDkECdCEbIB39ESGCASAP/REhgAFBACEVIAFBBEkhHwNAAkACQAJAIB8NACAJIBFJIBggCSAzaklxDQAgCSAbaiENIBf9CQK0CCGDAUEAIQsDQCAJIAtBAnRqIiAggAEggwEgIP0AAgD9rgEihAEgggH9tgEghAEggAH9Of1S/QsCACALQQRqIgsgDkcNAAsgDiILIAFGDQIMAQsgCSENQQAhCwsgC0EBciEJIBoEQCANIA8gFygCtAggDSgCAGoiCyAdIAsgHUgbIAsgD0gbNgIAIA1BBGohDSAJIQsLIAEgCUYNAANAIA0gDyAXKAK0CCANKAIAaiIJIB0gCSAdSBsgCSAPSBs2AgAgDSAPIBcoArQIIA0oAgRqIgkgHSAJIB1IGyAJIA9IGzYCBCANQQhqIQ0gC0ECaiILIAFHDQALCyANIAxBAnRqIQkgFUEBaiIVIAZHDQALDAELIB2sIYYBIA+sIYcBQQAhFQNAQQAhCwNAIAkCfyAdIAkqAgAijgFDAAAAT14NABogDyCOAUMAAADPXQ0AGiCHASAXNAK0CAJ/II4BkCKOAYtDAAAAT10EQCCOAagMAQtBgICAgHgLrHwiigEghgEghgEgigFVGyCHASCKAVUbpws2AgAgCUEEaiEJIAtBAWoiCyABRw0ACyAJIAxBAnRqIQkgFUEBaiIVIAZHDQALCyAHQcwAaiEHIBdBuAhqIRcgCkE0aiEKQQEhMSAIQQFqIgggFigCEEkNAAsMAQsgBUEBQZoZQQAQDwsgQEEQaiQAIDFFBEAgTxAuIAAgACgCCEGAgAJyNgIIIAVBAUHw1ABBABAPDAELAkAgAkUNAAJ/IAIhB0EAIQYCQCAAKALQASIVQQEQVCIBQX9GDQAgASADSw0AQQEgFSgCGCIBKAIQRQ0BGiABKAIYIQggFSgCFCgCACgCFCEXA0AgCCgCGCIBQQdxIQIgAUEDdiEDIBcoAhwiBiAIKAIkQZgBbGohAQJ/IBUoAkAEQCAGIBcoAhhBmAFsaiIGQZABaygCACABKAIIIAEoAgBrIgsgBkGYAWsoAgBqayEMIAEoAgwgASgCBGshCUEkDAELIAEoApQBIAEoAowBayEJIAEoApABIAEoAogBayELQQAhDEE0CyAXaigCACEBAkACQAJAAkACQEEEIAMgAkEAR2oiAiACQQNGG0EBaw4EAQIEAAQLIAlFDQMgCyAMaiEGIAtBAnQhAiAJQQRPBEAgCUF8cSEKQQAhCwNAIAcgASACEBIhByABIAZBAnQiA2oiDSADaiIMIANqIg4gA2ohASACIAdqIA0gAhASIAJqIAwgAhASIAJqIA4gAhASIAJqIQcgC0EEaiILIApHDQALC0EAIQsgCUEDcSIDRQ0DA0AgByABIAIQEiEHIAEgBkECdGohASACIAdqIQcgC0EBaiILIANHDQALDAMLIAlFIAtFciECIAgoAiBFDQEgAg0CIAtBAnQhDiALQXxxIgNBAnQhD0EAIQ0DQAJAAkACQCALQQRJDQAgASAHIAtqSSABIA5qIAdLcQ0AIAMgB2ohfCABIA9qIQZBACEKA0AgByAKaiABIApBAnRq/QACAP0MAAAAAAAAAAAAAAAAAAAAAP0NAAQIDAAAAAAAAAAAAAAAAP1aAAAAIApBBGoiCiADRw0ACyB8IQcgAyICIAtGDQIMAQsgASEGQQAhAgtBACEKIAsgAiIBa0EHcSIWBEADQCAHIAYoAgA6AAAgAUEBaiEBIAdBAWohByAGQQRqIQYgCkEBaiIKIBZHDQALCyACIAtrQXhLDQADQCAHIAYoAgA6AAAgByAGKAIEOgABIAcgBigCCDoAAiAHIAYoAgw6AAMgByAGKAIQOgAEIAcgBigCFDoABSAHIAYoAhg6AAYgByAGKAIcOgAHIAdBCGohByAGQSBqIQYgAUEIaiIBIAtHDQALCyAGIAxBAnRqIQEgDUEBaiINIAlHDQALDAILIAlFIAtFciECIAgoAiAEQCACDQIgC0ECdCEOIAtBAXQhDyALQXxxIgNBAnQhFiADQQF0IRBBACENA0ACQAJAAkAgC0EESQ0AIAEgByAPakkgASAOaiAHS3ENACABIBZqIQYgByAQaiF9QQAhCgNAIAcgCkEBdGogASAKQQJ0av0AAgD9DAAAAAAAAAAAAAAAAAAAAAD9DQABBAUICQwNAAEAAQABAAH9WwEAACAKQQRqIgogA0cNAAsgfSEHIAMiAiALRg0CDAELIAEhBkEAIQILQQAhCiALIAIiAWtBB3EiEwRAA0AgByAGKAIAOwEAIAFBAWohASAHQQJqIQcgBkEEaiEGIApBAWoiCiATRw0ACwsgAiALa0F4Sw0AA0AgByAGKAIAOwEAIAcgBigCBDsBAiAHIAYoAgg7AQQgByAGKAIMOwEGIAcgBigCEDsBCCAHIAYoAhQ7AQogByAGKAIYOwEMIAcgBigCHDsBDiAHQRBqIQcgBkEgaiEGIAFBCGoiASALRw0ACwsgBiAMQQJ0aiEBIA1BAWoiDSAJRw0ACwwCCyACDQEgC0ECdCEOIAtBAXQhDyALQXxxIgNBAnQhFiADQQF0IRBBACENA0ACQAJAAkAgC0EESQ0AIAEgByAPakkgASAOaiAHS3ENACABIBZqIQYgByAQaiF+QQAhCgNAIAcgCkEBdGogASAKQQJ0av0AAgD9DAAAAAAAAAAAAAAAAAAAAAD9DQABBAUICQwNAAEAAQABAAH9WwEAACAKQQRqIgogA0cNAAsgfiEHIAMiAiALRg0CDAELIAEhBkEAIQILQQAhCiALIAIiAWtBB3EiEwRAA0AgByAGKAIAOwEAIAFBAWohASAHQQJqIQcgBkEEaiEGIApBAWoiCiATRw0ACwsgAiALa0F4Sw0AA0AgByAGKAIAOwEAIAcgBigCBDsBAiAHIAYoAgg7AQQgByAGKAIMOwEGIAcgBigCEDsBCCAHIAYoAhQ7AQogByAGKAIYOwEMIAcgBigCHDsBDiAHQRBqIQcgBkEgaiEGIAFBCGoiASALRw0ACwsgBiAMQQJ0aiEBIA1BAWoiDSAJRw0ACwwBCyACDQAgC0ECdCEOIAtBfHEiA0ECdCEPQQAhDQNAAkACQAJAIAtBBEkNACABIAcgC2pJIAEgDmogB0txDQAgAyAHaiF/IAEgD2ohBkEAIQoDQCAHIApqIAEgCkECdGr9AAIA/QwAAAAAAAAAAAAAAAAAAAAA/Q0ABAgMAAAAAAAAAAAAAAAA/VoAAAAgCkEEaiIKIANHDQALIH8hByADIgIgC0YNAgwBCyABIQZBACECC0EAIQogCyACIgFrQQdxIhYEQANAIAcgBigCADoAACABQQFqIQEgB0EBaiEHIAZBBGohBiAKQQFqIgogFkcNAAsLIAIgC2tBeEsNAANAIAcgBigCADoAACAHIAYoAgQ6AAEgByAGKAIIOgACIAcgBigCDDoAAyAHIAYoAhA6AAQgByAGKAIUOgAFIAcgBigCGDoABiAHIAYoAhw6AAcgB0EIaiEHIAZBIGohBiABQQhqIgEgC0cNAAsLIAYgDEECdGohASANQQFqIg0gCUcNAAsLIBdBzABqIRcgCEE0aiEIQQEhBiByQQFqInIgFSgCGCgCEEkNAAsLIAYLRQ0BIE8oAtwrIgFFDQAgARAQIE9CADcC3CsLIAAgAC0AREH+AXE6AEQgACAAKAIIQf9+cTYCCEEBIWcgBCkDCCKGAVAEfkIABSCGASAEKQM4fQtQIAAoAggiAUHAAEZxDQAgAUGAAkYNACAEIE5BCmpBAiAFEBpBAkcEQCAFQQFBAiAAKAK4ARtBlhJBABAPIAAoArgBRSFnDAELIE5BCmogTkEMakECEBEgTigCDCIBQZD/A0YNACABQdn/A0YEQCAAQYACNgIIIABBADYCzAEMAQsgBCkDCCKGAVAEfkIABSCGASAEKQM4fQtQBEAgAEHAADYCCCAFQQJBrD9BABAPDAELQQAhZyAFQQFB7D5BABAPCyBOQRBqJAAgZwsLACAABEAgABAQCwu0AQEBfyAAKAIMRQRAIAIgACgCJCABEQMADwsCQEEIEBQiA0UNACADIAI2AgQgAyABNgIAQQgQFCIBRQRAIAMQEA8LIAEgAzYCACAAIAAoAgRB5ABsIgI2AigDQCAAKAIYIAJKDQALIAEgACgCFDYCBCAAIAE2AhQgACAAKAIYQQFqNgIYIAAoAhwiAUUNACABKAIAQQA2AgggACABKAIENgIcIAAgACgCIEEBazYCICABEBALC/oCAQR/AkAgAEUNACAAKAKsKCIBBEAgACgCqCgiAgRAQQAhAQNAIAAoAqwoIAFBA3RqKAIAIgMEQCADEBAgACgCqCghAgsgAUEBaiIBIAJJDQALIAAoAqwoIQELIABBADYCqCggARAQIABBADYCrCgLIAAoArQoIgEEQCABEBAgAEEANgK0KAsgACgC0CsiAQRAIAEQECAAQQA2AtArCyAAKALsKyIBBEAgARAQIABBADYC7CsLIAAoAugrIgEEQCABEBAgAEEANgLoKwsgACgC/CsiAQRAIAEQECAAQQA2AoQsIABCADcC/CsLIAAoAvArIgEEQCAAKAL0KyIDBH9BACECA0AgASgCDCIEBEAgBBAQIAFBADYCDCAAKAL0KyEDCyABQRRqIQEgAkEBaiICIANJDQALIAAoAvArBSABCxAQIABBADYC8CsLIAAoAuQrIgEEQCABEBAgAEEANgLkKwsgACgC3CsiAUUNACABEBAgAEIANwLcKwsLyAcCEX8BfiAAKAIQIghBIE8EQCAAKQMIpw8LAkAgACgCFCIDQQROBEAgACgCACICQQNrKAIAIQEgACADQQRrIgM2AhQgACACQQRrNgIADAELIANBAEwEQAwBCyADQQFxIQ0gACgCACECAkAgA0EBRgRAQRghBAwBCyADQf7///8HcSEJQRghBANAIAAgAkEBayIGNgIAIAItAAAhDCAAIAJBAmsiAjYCACAAIANBAWs2AhQgBi0AACEGIAAgA0ECayIDNgIUIAwgBHQgAXIgBiAEQQhrdHIhASAEQRBrIQQgBUECaiIFIAlHDQALCyANBEAgACACQQFrNgIAIAItAAAhDiAAIANBAWs2AhQgDiAEdCABciEBC0EAIQMLIAAoAhghAiAAIAFB/wFxIglBjwFLNgIYIABBB0EIIAFBgICA+AdxQYCAgPgHRhtBCCACGyICQQhBB0EIIAFBgID8A3FBgID8A0YbIAFB/////3hNG2oiBEEIQQdBCCABQYD+AXFBgP4BRhsgAUEQdkH/AXEiBUGPAU0baiIGQQhBB0EIIAFB/wBxQf8ARhsgAUEIdkH/AXEiB0GPAU0bIAhqaiIKNgIQIAAgACkDCCAFIAJ0IAFBGHZyIAcgBHRyIAkgBnRyrSAIrYaEIhI3AwggCkEfTQRAAkAgA0EETgRAIAAoAgAiAkEDaygCACEBIAAgA0EEazYCFCAAIAJBBGs2AgAMAQsgA0EATARAQQAhAQwBCyADQQFxIRAgACgCACECAkAgA0EBRgRAQRghBEEAIQEMAQsgA0H+////B3EhBkEYIQRBACEBQQAhBQNAIAAgAkEBayIHNgIAIAItAAAhDyAAIAJBAmsiAjYCACAAIANBAWs2AhQgBy0AACEHIAAgA0ECayIDNgIUIA8gBHQgAXIgByAEQQhrdHIhASAEQRBrIQQgBUECaiIFIAZHDQALCyAQRQ0AIAAgAkEBazYCACACLQAAIREgACADQQFrNgIUIBEgBHQgAXIhAQsgACABQf8BcSICQY8BSzYCGCAAQQhBB0EIIAFBgICA+AdxQYCAgPgHRhsgCUGPAU0bIgNBCEEHQQggAUGAgPwDcUGAgPwDRhsgAUH/////eE0baiIEQQhBB0EIIAFBgP4BcUGA/gFGGyABQRB2Qf8BcSIFQY8BTRtqIghBCEEHQQggAUH/AHFB/wBGGyABQQh2Qf8BcSIJQY8BTRsgCmpqNgIQIAAgBSADdCABQRh2ciAJIAR0ciACIAh0cq0gCq2GIBKEIhI3AwgLIBKnC8kUAh1/BnsgACgCCCIKIAAoAgRqIQgCQCAAKAIMRQRAIAhBAkgNASADQQBMDQEgACgCACIFIAhBBGsiBkEBdiIMQQJ0IgkgASAKQQJ0aiIHIANBAnQiBGpqQQRqSSAFIAxBA3RqQQhqIgAgB0EEaktxIAUgASAEaiAJakEEakkgAUEEaiAASXFyIRIgCEEESSIUIAJBAUdyIRUgAkEBRiAGQQVLcSEWIAhB/P///wdxIRMgCEEBcSEXIApBAWohDyAIQQNxIREgASAFayEYIAUgCEECdGohGSAFIAhBAWsiAEECdGohGiAMQQFqIhtBfHEiEEEBdCELIAIgCmxBAnQhHCAAQQF2IAJsQQJ0IR0DQCABKAIAIAEgHGooAgAiCUEBakEBdWshBwJAIBQEQCAJIQRBACEGDAELQQAhBgJAAn9BACAWRQ0AGkEAIBINABogCf0RISIgB/0RISH9DAAAAAACAAAABAAAAAYAAAAhJUEAIQADQCABIABBAnRq/QACBCEkIAEgACAPakECdGr9AAIAISMgBSAAQQN0aiIEICH9WgIAAyAEQQhqICQgIyAiICP9DQwNDg8QERITFBUWFxgZGhsiJP2uAf0MAgAAAAIAAAACAAAAAgAAAP2uAUEC/awB/bEBIiL9WgIAACAEQRBqICL9WgIAASAEQRhqICL9WgIAAiAFICX9DAEAAAABAAAAAQAAAAEAAAD9UCIm/RsAQQJ0aiAiICEgIv0NDA0ODxAREhMUFRYXGBkaG/2uAUEB/awBICT9rgEiIf1aAgAAIAUgJv0bAUECdGogIf1aAgABIAUgJv0bAkECdGogIf1aAgACIAUgJv0bA0ECdGogIf1aAgADICX9DAgAAAAIAAAACAAAAAgAAAD9rgEhJSAiISEgIyEiIABBBGoiACAQRw0ACyAi/RsDIQQgIf0bAyEHIBAgG0YNASALIQYgBCEJIBALIQADQCABIABBAWoiCiACbEECdGooAgAhHiABIAAgD2ogAmxBAnRqKAIAIQQgBSAGQQJ0aiIOIAc2AgAgDiAHIB4gBCAJakECakECdWsiB2pBAXUgCWo2AgQgBkECaiEGIAAgDEchHyAEIQkgCiEAIB8NAAsMAQsgCyEGCyAFIAZBAnRqIAc2AgBBfCEAIBcEfyAaIAEgHWooAgAgBEEBakEBdWsiADYCACAAIAdqQQF1IQdBeAVBfAsgGWogBCAHajYCAEEAIQZBACEAQQAhBAJAIBUgGCANQQJ0akEQSXJFBEADQCABIABBAnQiBGogBCAFav0AAgD9CwIAIABBBGoiACATRw0ACyATIgQgCEYNAQsgBCEAIBEEQANAIAEgACACbEECdGogBSAAQQJ0aigCADYCACAAQQFqIQAgBkEBaiIGIBFHDQALCyAEIAhrQXxLDQADQCABIAAgAmxBAnRqIAUgAEECdGooAgA2AgAgASAAQQFqIgQgAmxBAnRqIAUgBEECdGooAgA2AgAgASAAQQJqIgQgAmxBAnRqIAUgBEECdGooAgA2AgAgASAAQQNqIgQgAmxBAnRqIAUgBEECdGooAgA2AgAgAEEEaiIAIAhHDQALCyABQQRqIQEgDUEBaiINIANHDQALDAELAkACQAJAIAhBAWsOAgABAgsgA0EATA0CQQAhAgJAIANBBEkEQCABIQAMAQsgASADQfz///8HcSICQQJ0aiEAA0AgASAGQQJ0aiIEIAT9AAIAIiH9GwBBAm39ESAh/RsBQQJt/RwBICH9GwJBAm39HAIgIf0bA0ECbf0cA/0LAgAgBkEEaiIGIAJHDQALIAIgA0YNAwsDQCAAIAAoAgBBAm02AgAgAEEEaiEAIAJBAWoiAiADRw0ACwwCCyADQQBMDQEgACgCACEJIAIgCmxBAnQhBwNAIAkgASgCACABIAdqIgQoAgBBAWpBAXVrIgA2AgQgCSAAIAQoAgBqIgA2AgAgASAANgIAIAEgAkECdGogCSgCBDYCACABQQRqIQEgBkEBaiIGIANHDQALDAELIAhBA0gNACADQQBMDQAgACgCACIFIAggCEEBcSIURSIGa0EEayIJQQF2IgtBAnQiByABIANBAnQiAGpqSSAFIAtBA3RqQQxqIgQgAUEEaktxIAVBBGogACABIApBAnRqIgBqIAdqQQhqSSAAQQhqIARJcXIhFSACQQFHIAhBBElyIRYgAkEBRiAJQQVLcSEXIAhB/P///wdxIRAgCEEDcSERIAEgBWshGCAFIAhBAnRqQQRrIRkgBSAIQQJrIgBBAnRqIRogC0EBaiISQXxxIgxBAXIhEyAMQQF0QQFyIQsgAiAKbEECdCEbIAAgBmtBAkkhHCAIQQF2QQFrIAJsQQJ0IR0DQCAFIAEoAgAgASAbaiIPIAJBAnRqKAIAIgkgDygCACIAakECakECdWsiByAAajYCAEEBIQQCQCAcBEAgCSEGDAELAkACf0EBIBdFDQAaQQEgFQ0AGiAJ/REhISAH/REhIkEAIQADQCAFIABBA3RqIgcgASAAQQJ0IgRq/QACBCAhIAQgD2r9AAIIIiH9DQwNDg8QERITFBUWFxgZGhsiJCAh/a4B/QwCAAAAAgAAAAIAAAACAAAA/a4BQQL9rAH9sQEiIyAjICIgI/0NDA0ODxAREhMUFRYXGBkaG/2uAUEB/awBICT9rgEiJP0NBAUGBxgZGhsICQoLHB0eH/0LAhQgByAiICT9DQwNDg8QERITAAECAxQVFhcgI/0NAAECAwQFBgcQERITDA0OD/0LAgQgIyEiIABBBGoiACAMRw0ACyAh/RsDIQYgIv0bAyEHIAwgEkYNASALIQQgBiEJIBMLIQADQCABIAAgAmxBAnRqKAIAIR4gDyAAQQFqIgogAmxBAnRqKAIAIQYgBSAEQQJ0aiIOIAc2AgAgDiAHIB4gBiAJakECakECdWsiB2pBAXUgCWo2AgQgBEECaiEEIAAgEkchICAKIQAgBiEJICANAAsMAQsgCyEECyAYIA1BAnRqIQkgBSAEQQJ0aiAHNgIAAkAgFEUEQCAaIAEgHWooAgAgBkEBakEBdWsiACAHakEBdSAGajYCAAwBCyAGIAdqIQALIBkgADYCAEEAIQZBACEAQQAhBAJAIBYgCUEQSXJFBEADQCABIABBAnQiBGogBCAFav0AAgD9CwIAIABBBGoiACAQRw0ACyAQIgQgCEYNAQsgBCEAIBEEQANAIAEgACACbEECdGogBSAAQQJ0aigCADYCACAAQQFqIQAgBkEBaiIGIBFHDQALCyAEIAhrQXxLDQADQCABIAAgAmxBAnRqIAUgAEECdGooAgA2AgAgASAAQQFqIgQgAmxBAnRqIAUgBEECdGooAgA2AgAgASAAQQJqIgQgAmxBAnRqIAUgBEECdGooAgA2AgAgASAAQQNqIgQgAmxBAnRqIAUgBEECdGooAgA2AgAgAEEEaiIAIAhHDQALCyABQQRqIQEgDUEBaiINIANHDQALCws3AQJ/IwBBEGsiASQAIAAEfyABQQxqQSAgABBsIQBBACABKAIMIAAbBUEACyECIAFBEGokACACCxsBAX8gAARAIAAoAggiAQRAIAEQEAsgABAQCwsxAQJ/QQFBDBATIgAEQCAAQQo2AgQgAEEKQQQQEyIBNgIIIAEEQCAADwsgABAQC0EACy8BAX8gAARAIAAoAgQiAQRAIAAoAgAgARECAAsgACgCIBAQIABBADYCICAAEBALCyoAIAAEQCAAKAIwIABBFEEQIAAoAkwbaigCABECACAAQQA2AjAgABAQCwtTAQJ/IABBADYCMCAAIAAoAiA2AiQgASAAKAIAIAAoAhwRCgAhBCAAKAJEIQIgBEUEQCAAIAJBBHI2AkRBAA8LIAAgATcDOCAAIAJBe3E2AkRBAQuGAwIFfwp+IwBBIGsiAyQAAkAgACgCECIFRQRAQQEhAgwBCwJAIAA0AgAiB0IAUw0AIAA0AgQiCEIAUw0AIAA0AggiCUIAUw0AIAA0AgwiCkIAUw0AIAAoAhghACAHQgF9IQwgCEIBfSENIAlCAX0hCSAKQgF9IQoDQCAAIAwgACgCACICrSIHfCAHgCILPgIQIAAgDSAAKAIEIgatIgd8IAeAIg4+AhRCASAANQIoIgeGIg9CAX0iCCAJIAKsIhB8IBB/xHwgB4enIAggC8R8IAeHp2siAkEASARAIAMgAjYCBCADIAQ2AgAgAUEBQdPkACADEA9BACECDAMLIAAgAjYCCCAIIAogBqwiC3wgC3/EfCAHh6cgDsQgD3xCAX0gB4enayICQQBIBEAgAyACNgIUIAMgBDYCECABQQFBmOUAIANBEGoQD0EAIQIMAwsgACACNgIMIABBNGohAEEBIQIgBEEBaiIEIAVHDQALDAELIAFBAUGnM0EAEA8LIANBIGokACACC9cGAQZ/IAAEQAJAIAAoAgAEQCAAKAIMIgEEQCABEC4gACgCDBAQIABBADYCDAsgACgCECIBBEAgARAQIABCADcDEAsgACgCQBAQIABCADcCPAwBCyAAKAIsIgEEQCABEBAgAEEANgIsCyAAKAIgIgEEQCABEBAgAEIANwMgCyAAKAI0IgFFDQAgARAQIABCADcCNAsgACgC0AEQVSAAKAKcASIBBEAgACgCaCAAKAJsbCIDBH8DQCABEC4gAUGMLGohASACQQFqIgIgA0cNAAsgACgCnAEFIAELEBAgAEEANgKcAQsgACgCdCIBBEAgACgCcCICBEBBACEBA0AgACgCdCABQQN0aigCACIDBEAgAxAQIAAoAnAhAgsgAUEBaiIBIAJJDQALIAAoAnQhAQsgAEEANgJwIAEQECAAQQA2AnQLIAAoAogBEBAgAEEANgJ4IABBADYCiAEgACgCZBAQIABBADYCZCAALQC8AUECcUUEQCAAKAKoARAQCyAAQdAAakEAQfAAEBUaIAAoAsABEDIgAEEANgLAASAAKALEARAyIABBADYCwAEgACgCyAEiAQRAIAEoAhwiAgRAIAIQECABQQA2AhwLIAEoAigiAgRAIAEoAiQEQANAIAIgBUEobCIDaigCJCIEBEAgBBAQIAEoAigiAiADakEANgIkCyACIANqKAIQIgQEQCAEEBAgASgCKCICIANqQQA2AhALIAIgA2ooAhgiBARAIAQQECABKAIoIgIgA2pBADYCGAsgBUEBaiIFIAEoAiRJDQALCyACEBAgAUEANgIoCyABEBALIABBADYCyAEgACgCSBAhIABBADYCSCAAKAJMECEgAEEANgJMIAAoAtQBIgMEQAJAIAMoAghFDQAgAygCDARAIANBADYCKANAIAMoAhhBAEoNAAsLIANBATYCECADKAIAEBAgAygCHCICRQ0AA0AgAigCBCEBIAIQECADIAE2AhwgASICDQALCyADKAIkIgIEQCACKAIEIgVBAEoEQEEAIQEDQCACKAIAIAFBDGxqIgQoAggiBgRAIAQoAgQgBhECACACKAIEIQULIAFBAWoiASAFSA0ACwsgAigCABAQIAIQEAsgAxAQCyAAQQA2AtQBIAAQEAsL5gMCCH8EfiAAKAIUKAIAKAIUIAFBzABsaiIJKAIMIgggACgCGCgCGCABQTRsaiIKNQIEIhBCAX0iEiAANQI8fCAQgKciCyAIIAtJGyEMIAkoAggiCCAKNQIAIhFCAX0iEyAANQI4fCARgKciCiAIIApJGyEKIAkoAgQiCCASIAA1AjR8IBCApyILIAggC0sbIQsgCSgCACIIIBMgADUCMHwgEYCnIg0gCCANSxshDUEAIQggACgCICgC0CsgAUG4CGxqKAIUIQ4CQCAJKAIUQQAgAmtBfyACG2oiAkUEQCAKIQAgDSEIIAshAQwBCyADQQFxIAJBAWsiD3QiCSANSQRAIA0gCWutQn8gAq0iEIZCf4V8IBCIpyEIC0EAIQBBACEBIANBAXYgD3QiAyALSQRAIAsgA2utQn8gAq0iEIZCf4V8IBCIpyEBCyAJIApJBEAgCiAJa61CfyACrSIQhkJ/hXwgEIinIQALIAMgDE8EQEEAIQwMAQsgDCADa61CfyACrSIQhkJ/hXwgEIinIQwLQX8gAEECQQMgDkEBRhsiAmoiAyAAIANLGyAES0F/IAIgDGoiACAAIAxJGyAFS3EgCCACayIAQQAgACAITRsgBklxIAEgAmsiAEEAIAAgAU0bIAdJcQuiAQEGfyAABEAgACgCBCICBEAgAhAQIABBADYCBAsgAQRAIAAhAgNAIAIoAsgBIgMEQEEAIQUgAigCxAEiBAR/A0AgAygCDCIGBEAgBhAQIANBADYCDCACKALEASEECyADQRBqIQMgBUEBaiIFIARJDQALIAIoAsgBBSADCxAQIAJBADYCyAELIAJB8AFqIQIgB0EBaiIHIAFHDQALCyAAEBALC9UZAhN/A3sgACgCACIKIAAoAgwiDUEFdCIFaiEGIAogBWshFiAAKAIQIQUgACgCHCELIAAoAhQhCSAAKAIIIQ4CQAJAAkACQCADQQhJDQAgAUEPcQ0AIAZBD3FFDQELIAUgCU8NAgJAAkAgA0EBaw4CAAEDCwJAIAkgBWsiCEEYSQ0AIAEgBUECdGohByANQQV0IgQgCiAFQQZ0amogASAJQQJ0akkEQCAHIAogCUEGdGogBGpBPGtJDQELIAX9Ef0MAAAAAAEAAAACAAAAAwAAAP2uASEYIAUgCEF8cSIPaiEFQQAhBANAIAYgGEEE/asBIhf9GwBBAnRqIAcgBEECdGr9AAIAIhn9HwA4AgAgBiAX/RsBQQJ0aiAZ/R8BOAIAIAYgF/0bAkECdGogGf0fAjgCACAGIBf9GwNBAnRqIBn9HwM4AgAgGP0MBAAAAAQAAAAEAAAABAAAAP2uASEYIARBBGoiBCAPRw0ACyAIIA9GDQQLIAUhBCAJIAVrQQNxIgcEQEEAIQgDQCAGIARBBnRqIAEgBEECdGoqAgA4AgAgBEEBaiEEIAhBAWoiCCAHRw0ACwsgBSAJa0F8Sw0DA0AgBiAEQQZ0aiABIARBAnRqKgIAOAIAIAYgBEEBaiIFQQZ0aiABIAVBAnRqKgIAOAIAIAYgBEECaiIFQQZ0aiABIAVBAnRqKgIAOAIAIAYgBEEDaiIFQQZ0aiABIAVBAnRqKgIAOAIAIARBBGoiBCAJRw0ACwwDCyABIAJBAnRqIQgCQCAJIAVrIg9BPEkEQCAFIQQMAQsgCiAFQQZ0IA1BBXRqaiIEIAkgBUF/c2oiB0EGdCIQaiAESQRAIAUhBAwBCyAEQQRqIgQgEGogBEkEQCAFIQQMAQsgB0H///8fSwRAIAUhBAwBCyANQQV0IgQgCiAFQQZ0amoiByABIAIgCWpBAnRqSSAKIAlBBnRqIARqQThrIgQgASACIAVqQQJ0aktxBEAgBSEEDAELIAcgASAJQQJ0akkgASAFQQJ0aiAESXEEQCAFIQQMAQsgBf0R/QwAAAAAAQAAAAIAAAADAAAA/a4BIRggBSAPQXxxIhBqIQRBACEHA0AgBiAYQQT9qwEiF/0bAEECdGoiESABIAUgB2pBAnQiDGr9AAIAIhn9HwA4AgAgBiAX/RsBQQJ0aiITIBn9HwE4AgAgBiAX/RsCQQJ0aiIUIBn9HwI4AgAgBiAX/RsDQQJ0aiIVIBn9HwM4AgAgESAIIAxq/QACACIX/R8AOAIEIBMgF/0fATgCBCAUIBf9HwI4AgQgFSAX/R8DOAIEIBj9DAQAAAAEAAAABAAAAAQAAAD9rgEhGCAHQQRqIgcgEEcNAAsgDyAQRg0DCyAEQQFqIQUgCSAEa0EBcQRAIAYgBEEGdGoiByABIARBAnQiBGoqAgA4AgAgByAEIAhqKgIAOAIEIAUhBAsgBSAJRg0CA0AgBiAEQQZ0aiIFIAEgBEECdCIHaioCADgCACAFIAcgCGoqAgA4AgQgBiAEQQFqIgVBBnRqIgcgASAFQQJ0IgVqKgIAOAIAIAcgBSAIaioCADgCBCAEQQJqIgQgCUcNAAsMAgsgBSAJTw0BIAEgAkECdGohCANAIAYgBUEGdGoiBCABIAVBAnRqKgIAOAIAIAQgASACIAVqIgdBAnRqKgIAOAIEIAQgASACIAdqIgdBAnRqKgIAOAIIIAQgASACIAdqIgdBAnRqKgIAOAIMIAQgASACIAdqIgdBAnRqKgIAOAIQIAQgASACIAdqIgdBAnRqKgIAOAIUIAQgASACIAdqQQJ0IgdqKgIAOAIYIAQgByAIaioCADgCHCAFQQFqIgUgCUcNAAsMAQsgASACQQJ0aiEIIANBA0YhByADQQRGIQ8gA0EFRiEQIANBB0YhEQNAIAYgBUEGdGoiBCABIAVBAnRqKgIAOAIAIAQgASACIAVqIgxBAnRqKgIAOAIEIAQgASACIAxqIgxBAnRqKgIAOAIIAkAgBw0AIAQgASACIAxqIgxBAnRqKgIAOAIMIA8NACAEIAEgAiAMaiIMQQJ0aioCADgCECAQDQAgBCABIAIgDGoiDEECdGoqAgA4AhQgA0EGRg0AIAQgASACIAxqQQJ0IgxqKgIAOAIYIBENACAEIAggDGoqAgA4AhwLIAVBAWoiBSAJRw0ACwsgFkEgaiEGIAEgDkECdGohBCAAKAIYIQUCQAJAAkAgA0EISQ0AIARBD3ENACAGQQ9xRQ0BCyAFIAtPDQECQAJAAkAgA0EBaw4CAAECCwJAIAsgBWsiAEEcSQ0AIAogBUEGdEEgciANQQV0IgJraiABIAsgDmpBAnRqSQRAIAEgBSAOakECdGogC0EGdCACayAKakEca0kNAQsgBCAFQQJ0aiEDIAX9Ef0MAAAAAAEAAAACAAAAAwAAAP2uASEYIAUgAEF8cSIBaiEFQQAhAgNAIAYgGEEE/asBIhf9GwBBAnRqIAMgAkECdGr9AAIAIhn9HwA4AgAgBiAX/RsBQQJ0aiAZ/R8BOAIAIAYgF/0bAkECdGogGf0fAjgCACAGIBf9GwNBAnRqIBn9HwM4AgAgGP0MBAAAAAQAAAAEAAAABAAAAP2uASEYIAJBBGoiAiABRw0ACyAAIAFGDQQLIAUhAiALIAVrQQNxIgAEQEEAIQEDQCAGIAJBBnRqIAQgAkECdGoqAgA4AgAgAkEBaiECIAFBAWoiASAARw0ACwsgBSALa0F8Sw0DA0AgBiACQQZ0aiAEIAJBAnRqKgIAOAIAIAYgAkEBaiIAQQZ0aiAEIABBAnRqKgIAOAIAIAYgAkECaiIAQQZ0aiAEIABBAnRqKgIAOAIAIAYgAkEDaiIAQQZ0aiAEIABBAnRqKgIAOAIAIAJBBGoiAiALRw0ACwwDCyAEIAJBAnRqIQMCQCALIAVrIgBBxABJBEAgBSECDAELIAogBUEGdCIJQSByIA1BBXQiCGtqIgcgCyAFQX9zaiIPQQZ0IhBqIAdJBEAgBSECDAELIAogCUEkciAIa2oiCSAQaiAJSQRAIAUhAgwBCyAPQf///x9LBEAgBSECDAELIAogBUEGdEEgciANQQV0IglraiINIAEgCyAOaiIIIAJqQQJ0akkgC0EGdCAJayAKakEYayIJIAEgDkECdGogBUECdGoiCiACQQJ0aktxBEAgBSECDAELIA0gASAIQQJ0akkgCSAKS3EEQCAFIQIMAQsgBf0R/QwAAAAAAQAAAAIAAAADAAAA/a4BIRggBSAAQXxxIglqIQJBACEBA0AgBiAYQQT9qwEiF/0bAEECdGoiCiAEIAEgBWpBAnQiDWr9AAIAIhn9HwA4AgAgBiAX/RsBQQJ0aiIOIBn9HwE4AgAgBiAX/RsCQQJ0aiIIIBn9HwI4AgAgBiAX/RsDQQJ0aiIHIBn9HwM4AgAgCiADIA1q/QACACIX/R8AOAIEIA4gF/0fATgCBCAIIBf9HwI4AgQgByAX/R8DOAIEIBj9DAQAAAAEAAAABAAAAAQAAAD9rgEhGCABQQRqIgEgCUcNAAsgACAJRg0DCyACQQFqIQAgCyACa0EBcQRAIAYgAkEGdGoiASAEIAJBAnQiAmoqAgA4AgAgASACIANqKgIAOAIEIAAhAgsgACALRg0CA0AgBiACQQZ0aiIAIAQgAkECdCIBaioCADgCACAAIAEgA2oqAgA4AgQgBiACQQFqIgBBBnRqIgEgBCAAQQJ0IgBqKgIAOAIAIAEgACADaioCADgCBCACQQJqIgIgC0cNAAsMAgsgBCACQQJ0aiEBIANBA0YhCSADQQRGIQogA0EFRiENIANBB0YhDgNAIAYgBUEGdGoiACAEIAVBAnRqKgIAOAIAIAAgBCACIAVqIghBAnRqKgIAOAIEIAAgBCACIAhqIghBAnRqKgIAOAIIAkAgCQ0AIAAgBCACIAhqIghBAnRqKgIAOAIMIAoNACAAIAQgAiAIaiIIQQJ0aioCADgCECANDQAgACAEIAIgCGoiCEECdGoqAgA4AhQgA0EGRg0AIAAgBCACIAhqQQJ0IghqKgIAOAIYIA4NACAAIAEgCGoqAgA4AhwLIAVBAWoiBSALRw0ACwwBCyAFIAtPDQAgBCACQQJ0aiEBA0AgBiAFQQZ0aiIAIAQgBUECdGoqAgA4AgAgACAEIAIgBWoiA0ECdGoqAgA4AgQgACAEIAIgA2oiA0ECdGoqAgA4AgggACAEIAIgA2oiA0ECdGoqAgA4AgwgACAEIAIgA2oiA0ECdGoqAgA4AhAgACAEIAIgA2oiA0ECdGoqAgA4AhQgACAEIAIgA2pBAnQiA2oqAgA4AhggACABIANqKgIAOAIcIAVBAWoiBSALRw0ACwsLmwMBBH8gASAAQQRqIgRqQQFrQQAgAWtxIgUgAmogACAAKAIAIgFqQQRrTQR/IAAoAgQiAyAAKAIIIgY2AgggBiADNgIEIAQgBUcEQCAAIABBBGsoAgBBfnFrIgMgBSAEayIEIAMoAgBqIgU2AgAgAyAFQXxxakEEayAFNgIAIAAgBGoiACABIARrIgE2AgALAn8gASACQRhqTwRAIAAgAmpBCGoiAyABIAJrQQhrIgE2AgAgAyABQXxxakEEayABQQFyNgIAIAMCfyADKAIAQQhrIgFB/wBNBEAgAUEDdkEBawwBCyABZyEEIAFBHSAEa3ZBBHMgBEECdGtB7gBqIAFB/x9NDQAaQT8gAUEeIARrdkECcyAEQQF0a0HHAGoiASABQT9PGwsiAUEEdCIEQaDHAWo2AgQgAyAEQajHAWoiBCgCADYCCCAEIAM2AgAgAygCCCADNgIEQajPAUGozwEpAwBCASABrYaENwMAIAAgAkEIaiIBNgIAIAAgAUF8cWoMAQsgACABagtBBGsgATYCACAAQQRqBUEACwvCAQEDfwJAIAEgAigCECIDBH8gAwUgAhA+DQEgAigCEAsgAigCFCIEa0sEQCACIAAgASACKAIkEQAADwsCQAJAIAIoAlBBAEgNACABRQ0AIAEhAwNAIAAgA2oiBUEBay0AAEEKRwRAIANBAWsiAw0BDAILCyACIAAgAyACKAIkEQAAIgQgA0kNAiABIANrIQEgAigCFCEEDAELIAAhBUEAIQMLIAQgBSABEBIaIAIgAigCFCABajYCFCABIANqIQQLIAQLWQEBfyAAIAAoAkgiAUEBayABcjYCSCAAKAIAIgFBCHEEQCAAIAFBIHI2AgBBfw8LIABCADcCBCAAIAAoAiwiATYCHCAAIAE2AhQgACABIAAoAjBqNgIQQQALzAIBBH8gASAA/QACAP0LAgAgASgCGCICBEAgASgCECIDBH9BACECA0AgASgCGCACQTRsaigCLCIEBEAgBBAQIAEoAhAhAwsgAkEBaiICIANJDQALIAEoAhgFIAILEBAgAUEANgIYCyABIAAoAhAiAjYCECABIAJBNGwQFCICNgIYIAIEQCABKAIQBEBBACEDA0AgAiADQTRsIgVqIgIgACgCGCAFaiIE/QACAP0LAgAgAiAEKAIwNgIwIAIgBP0AAiD9CwIgIAIgBP0AAhD9CwIQIAEoAhgiAiAFakEANgIsIANBAWoiAyABKAIQSQ0ACwsgASAAKAIUNgIUIAEgACgCICICNgIgIAIEQCABIAIQFCICNgIcIAJFBEAgAUIANwIcDwsgAiAAKAIcIAAoAiAQEhoPCyABQQA2AhwPCyABQQA2AhAgAUEANgIYCwQAQQELxgEBA38DQCAAQQR0IgFBpMcBaiABQaDHAWoiAjYCACABQajHAWogAjYCACAAQQFqIgBBwABHDQALQTAQbRojAEEQayIAJAACQCAAQQxqIABBCGoQDA0AQbDPAUEIIAAoAgxBAnRBBGoQJSIBNgIAIAFFDQBBCCAAKAIIECUiAQRAQbDPASgCACICIAAoAgxBAnRqQQA2AgAgAiABEAtFDQELQbDPAUEANgIACyAAQRBqJABBzM8BQSo2AgBBlNABQdjQATYCAAuQBgIFfwN7IwBBEGsiBiQAAn8gACgCCEEQRgRAIAAoApwBIAAoAswBQYwsbGoMAQsgACgCDAshAAJAIAMoAgAiBUUEQEEAIQIgBEEBQcATQQAQDwwBCyAAKALQKyEJIAMgBUEBazYCACACIAZBDGpBARARIAkgAUG4CGxqIgcgBigCDCIAQQV2NgKkBiAHIABBH3EiATYCGCACQQFqIQAgAwJ/An8CQAJ/AkACQCABDgIAAwELIAMoAgAMAQsgAygCAEEBdgsiBUHiAE8EfyAGQuGAgICQDDcCBCAGIAU2AgAgBEECQcX4ACAGEA8gBygCGAUgAQsEQCAFIgENAUEADAILIAUEQCAHQRxqIQFBACECA0AgACAGQQxqQQEQESACQeAATQRAIAYoAgwhBCABIAJBA3RqIghBADYCBCAIIARBA3Y2AgALIABBAWohACACQQFqIgIgBUcNAAsLQQAhAiADKAIAIgAgBUkNAyAAIAVrDAILIAdBHGohBEEAIQIDQCAAIAZBDGpBAhARIAJB4ABNBEAgBCACQQN0aiIFIAYoAgwiCEH/D3E2AgQgBSAIQQt2NgIACyAAQQJqIQAgAkEBaiICIAFHDQALIAFBAXQLIQBBACECIAMoAgAiASAASQ0BIAEgAGsLNgIAQQEhAiAHKAIYQQFHDQAgB0EcaiEEIAf9CQIcIQwgBygCICED/QwBAAAAAgAAAAMAAAAEAAAAIQtBACEBA0AgBCABQQN0aiIAQRhqIAwgC/0M//////////////////////2uASIK/RsAQQNu/REgCv0bAUEDbv0cASAK/RsCQQNu/RwCIAr9GwNBA279HAP9sQH9DAAAAAAAAAAAAAAAAAAAAAD9uAEiCv1aAgACIABBEGogCv1aAgABIABBCGogCv1aAgAAIAQgAUEEaiIBQQN0aiIFIAr9WgIAAyAAIAM2AhwgACADNgIUIAAgAzYCDCAFIAM2AgQgC/0MBAAAAAQAAAAEAAAABAAAAP2uASELIAFB4ABHDQALCyAGQRBqJAAgAgufBgEGfyMAQSBrIgYkAAJ/IAAoAghBEEYEQCAAKAKcASAAKALMAUGMLGxqDAELIAAoAgwLIQUCQCADKAIAQQRNBEBBACEAIARBAUGdE0EAEA8MAQsgAiAFKALQKyABQbgIbGoiBSIJQQRqQQEQESAFIAUoAgRBAWoiBzYCBCAHQSJPBEAgBkEhNgIEIAYgBzYCACAEQQFB+TkgBhAPQQAhAAwBCyAHIAAoAqABIghNBEAgBiAHNgIYIAYgCDYCFCAGIAE2AhAgBEEBQbT7ACAGQRBqEA8gACAAKAIIQYCAAnI2AghBACEADAELIAJBAWogBUEIakEBEBEgBSAFKAIIQQJqNgIIIAJBAmogBUEMakEBEBEgBSAFKAIMQQJqIgA2AgwCQAJAIAUoAggiAUEKSw0AIABBCksNACAAIAFqQQ1JDQELQQAhACAEQQFBwylBABAPDAELIAJBA2ogBUEQakEBEBEgBS0AEEGAAXEEQEEAIQAgBEEBQYsyQQAQDwwBCyACQQRqIAVBFGpBARARIAUoAhRBAk8EQEEAIQAgBEEBQcoxQQAQDwwBCyADIAMoAgBBBWsiBzYCAEEBIQAgBSgCBCEBIAUtAABBAXFFBEAgAUUNASAFQbAHaiEBIAVBrAZqIQJBACEFA0AgAiAFQQJ0IgBqQQ82AgAgACABakEPNgIAQQEhACAFQQFqIgUgCSgCBEkNAAsMAQsgASAHTQRAAkAgAUUEQEEAIQEMAQsgAkEFaiAGQRxqQQEQESAFIAYoAhwiAEEEdjYCsAcgBSAAQQ9xNgKsBiAFKAIEIgFBAk8EQCAFQbAHaiEHIAVBrAZqIQggAkEGaiEAQQEhBQNAIAAgBkEcakEBEBECQCAGKAIcIgFBEE8EQCABQQ9xIgINAQtBACEAIARBAUHwLUEAEA8MBQsgCCAFQQJ0IgpqIAI2AgAgByAKaiABQQR2NgIAIABBAWohACAFQQFqIgUgCSgCBCIBSQ0ACwsgAygCACEHCyADIAcgAWs2AgBBASEADAELQQAhACAEQQFBnRNBABAPCyAGQSBqJAAgAAtSACABIAAtAAA6AAcgASAALQABOgAGIAEgAC0AAjoABSABIAAtAAM6AAQgASAALQAEOgADIAEgAC0ABToAAiABIAAtAAY6AAEgASAALQAHOgAAC5IBAQR/IAAgATYCoAECQCAAKAJIIgNFDQAgAygCGCIGRQ0AIAAoAgwiBEUNACAEKALQK0UNACADKAIQIgRFBEBBAQ8LQQAhAwNAIAEgACgCDCgC0CsgA0G4CGxqKAIETwRAIAJBAUGixQBBABAPQQAPCyAGIANBNGxqIAE2AihBASEFIANBAWoiAyAERw0ACwsgBQusBwIJfwh+IwBBEGsiCiQAAkAgAkUEQCADQQFB+tUAQQAQDwwBCyACKAIQIgsgACgCSCIGKAIQSQRAIANBAUG1zgBBABAPDAELIAQgACgCaCIFIAAoAmxsIgdPBEAgCiAENgIAIAogB0EBazYCBCADQQFB9/oAIAoQD0EAIQUMAQsgAiAAKAJUIAQgBSAEIAVuIgdsayIIIAAoAlxsaiIFNgIAIAIgBSAGKAIAIgYgBSAGSxsiBjYCACACIAAoAlQgACgCXCAIQQFqbGoiBTYCCCACIAUgACgCSCgCCCIIIAUgCEkbIgg2AgggAiAAKAJYIAAoAmAgB2xqIgU2AgQgAiAFIAAoAkgoAgQiCSAFIAlLGyIJNgIEIAIgACgCWCAAKAJgIAdBAWpsaiIFNgIMIAIgBSAAKAJIKAIMIgcgBSAHSRsiBTYCDCAAKAJIIgwoAhAiBwRAIAWsQgF9IREgCKxCAX0hEiAJrUIBfSETIAatQgF9IRQgDCgCGCEIIAIoAhghBUEAIQYDQCAFIAggBkE0bGooAigiCTYCKCAFIBQgBSgCACIMrSIOfCAOgCIVPgIQIAUgEyAFKAIEIg2tIg58IA6AIhA+AhQgBUJ/IAmtIg6GIg8gEMR9IA6HpyAPIBEgDawiEHwgEH/EfSAOh6drNgIMIAUgDyAVxH0gDoenIA8gEiAMrCIPfCAPf8R9IA6Hp2s2AgggBUE0aiEFIAZBAWoiBiAHRw0ACwsgByALSQRAIAIoAhghBQNAIAUgB0E0bCIGaigCLBAQIAIoAhgiBSAGakEANgIsIAdBAWoiByACKAIQSQ0ACyACIAAoAkgoAhA2AhALIAAoAkwiBQRAIAUQIQsgAEEBQSQQEyIHNgJMQQAhBSAHRQ0AIAIgBxA/IAAgBDYCLCAAKALAAUEXIAMQJEUNACAAKALAASIEKAIAIQYgBCgCCCEHAkAgBgRAQQEhBSAGQQFxIQsgBkEBRgR/QQAFIAZBfnEhCEEAIQYDQAJ/QQAgBUUNABpBACAAIAEgAyAHKAIAEQAARQ0AGiAAIAEgAyAHKAIEEQAAQQBHCyEFIAdBCGohByAGQQJqIgYgCEcNAAsgBUEBcwshBgJAAkAgCwRAIAYNASAAIAEgAyAHKAIAEQAAQQBHIQULIARBADYCACAFQQFxRQ0BDAMLIARBADYCAAsgACgCSBAhQQAhBSAAQQA2AkgMAgsgBEEANgIACyAAIAIQRyEFCyAKQRBqJAAgBQvyAwEFfwJAAkAgACgCPCICRQRAIAEoAhANAUEBDwsgAkE0bBAUIgVFDQEgASgCEARAIAEoAhghAgNAIAIgA0E0bCIEaigCLBAQIAEoAhgiAiAEakEANgIsIANBAWoiAyABKAIQIgRJDQALCyABIAAoAjwEfyAAKAJMKAIYIQNBACECA0AgBSACQTRsaiIEIAMgACgCQCACQQJ0aigCAEE0bCIGaiID/QACAP0LAgAgBCADKAIwNgIwIAQgA/0AAiD9CwIgIAQgA/0AAhD9CwIQIAQgACgCTCgCGCIDIAZqIgYoAiQ2AiQgBCAGKAIsNgIsIAZBADYCLCACQQFqIgIgACgCPCIGSQ0ACyABKAIQBSAECwR/IAAoAkwoAhghAkEAIQMDQCACIANBNGwiBGooAiwQECAAKAJMKAIYIgIgBGpBADYCLCADQQFqIgMgASgCEEkNAAsgACgCPAUgBgs2AhAgASgCGBAQIAEgBTYCGEEBDwsgASgCGCEEIAAoAkwoAhghA0EAIQIDQCAEIAJBNGwiBWoiBCADIAVqKAIkNgIkIAQoAiwQECABKAIYIgQgBWogACgCTCgCGCIDIAVqIgUoAiw2AiwgBUEANgIsIAJBAWoiAiABKAIQSQ0AC0EBDwsgACgCSBAhIABBADYCSEEAC84EAQh/AkAgAkUNAAJAIAAoAqABIgVFDQAgACgCSCIERQ0AIAQoAhBFDQAgBCgCGCgCKCAFRw0AIAIoAhAiCEUNACACKAIYIgYoAigNACAGKAIsDQBBACEEIAhBCE8EQCAIQXhxIQkDQCAGIARBNGxqIAU2AiggBiAEQQFyQTRsaiAFNgIoIAYgBEECckE0bGogBTYCKCAGIARBA3JBNGxqIAU2AiggBiAEQQRyQTRsaiAFNgIoIAYgBEEFckE0bGogBTYCKCAGIARBBnJBNGxqIAU2AiggBiAEQQdyQTRsaiAFNgIoIARBCGohBCAKQQhqIgogCUcNAAsLIAhBB3EiCARAA0AgBiAEQTRsaiAFNgIoIARBAWohBCALQQFqIgsgCEcNAAsLIAIgAxA3DQBBAA8LIAAoAkwiBUUEQCAAQQFBJBATIgU2AkwgBUUNAQsgAiAFED8gACgCwAFBFiADECRFDQAgACgCwAEiBigCACEEIAYoAgghBQJAIAQEQEEBIQcgBEEBcSEIIARBAUYEf0EABSAEQX5xIQlBACEEA0ACf0EAIAdFDQAaQQAgACABIAMgBSgCABEAAEUNABogACABIAMgBSgCBBEAAEEARwshByAFQQhqIQUgBEECaiIEIAlHDQALIAdBAXMLIQQCQAJAIAgEQCAEDQEgACABIAMgBSgCABEAAEEARyEHCyAGQQA2AgAgB0EBcUUNAQwDCyAGQQA2AgALIAAoAkgQISAAQQA2AkhBAA8LIAZBADYCAAsgACACEEchBwsgBwv4BAEGfwJAQQFBMBATIgIEfyACIAAoAsgBIgH9AAMA/QsDACACIAEpAxA3AxAgAiABKAIYIgE2AhggAiABQRhsEBQiATYCHCABRQRAIAIQEEEADwsCQCAAKALIASgCHCIDBEAgASADIAIoAhhBGGwQEhoMAQsgARAQIAJBADYCHAsgAiAAKALIASgCJCIBNgIkIAIgAUEoEBMiATYCKCABRQRAIAIoAhwQECACEBBBAA8LAkAgACgCyAEoAigEQCACKAIkRQ0BA0AgASAFQShsIgNqIAAoAsgBKAIoIANqKAIUIgE2AhQgAUEYbBAUIQEgAigCKCIEIANqIgYgATYCGCABRQRAIAUEf0EAIQEDQCACKAIoIAFBKGxqKAIYEBAgAUEBaiIBIAVHDQALIAIoAigFIAQLEBAMBQsCQCAAKALIASgCKCADaigCGCIEBEAgASAEIAYoAhRBGGwQEhogAigCKCEBDAELIAEQECACKAIoIgEgA2pBADYCGAsgASADaiAAKALIASgCKCADaigCBCIBNgIEIAFBGGwQFCEBIAIoAigiBCADaiIGIAE2AhAgAUUEQCAFBH9BACEBA0AgAUEobCIAIAIoAihqKAIYEBAgAigCKCAAaigCEBAQIAFBAWoiASAFRw0ACyACKAIoBSAECxAQDAULAkAgACgCyAEoAiggA2ooAhAiBARAIAEgBCAGKAIEQRhsEBIaIAIoAighAQwBCyABEBAgAigCKCIBIANqQQA2AhALIAEgA2pCADcCICAFQQFqIgUgAigCJEkNAAsMAQsgARAQIAJBADYCKAsgAgVBAAsPCyACKAIcEBAgAhAQQQALoAYCDn8BeyMAQRBrIggkACAAKAJIKAIQIQ0gCEEBQTgQEyIBNgIMAkAgAUUNACABIAAoAkgoAhAiCTYCGCABIAD9AAJU/QsCACABIAAoAmg2AhAgACgCbCECIAFBADYCNCABIAI2AhQgASAAKAIMIgwoAgA2AiAgASAMKAIENgIkIAEgDCgCCDYCKCABIAwoAhA2AiwgASAJQbgIEBMiADYCMCAABEAgDQRAA0AgDkG4CGwiACABKAIwaiIFIAwoAtArIABqIgT9AAIAIg/9CwIEIAUgBCgCEDYCFCAFIAQoAhQ2AhggD/0bASIAQSBNBEAgBUG0B2ogBEGwB2ogABASGiAFQbAGaiAEQawGaiAEKAIEEBIaCyAFIAQoAhgiADYCHCAFIAQoAqQGNgKoBkEBIQYCQCAAQQFHBEAgBCgCBEEDbCIAQQNrQd8ASw0BIABBAmshBgsgBUGkA2ohCSAFQSBqIQogBEEcaiELQQAhAAJAIAZBCEkNACAEIAZBA3RqQRxqIApLBEAgCyAFIAZBAnRqQaQDakkNAQsgBkF8cSEAQQAhAgNAIAogAkECdCIDaiALIAJBA3RqIgdBHGogB0EUaiAHQQxqIAf9CQIE/VYCAAH9VgIAAv1WAgAD/QsCACADIAlqIAdBGGogB0EQaiAHQQhqIAf9CQIA/VYCAAH9VgIAAv1WAgAD/QsCACACQQRqIgIgAEcNAAsgACAGRg0BCyAAQQFyIQMgBkEBcQRAIAogAEECdCICaiALIABBA3RqIgAoAgQ2AgAgAiAJaiAAKAIANgIAIAMhAAsgAyAGRg0AA0AgCiAAQQJ0IgJqIAsgAEEDdGoiAygCBDYCACACIAlqIAMoAgA2AgAgCiAAQQFqIgNBAnQiAmogCyADQQN0aiIDKAIENgIAIAIgCWogAygCADYCACAAQQJqIgAgBkcNAAsLIAUgBCgCqAY2AqwGIA5BAWoiDiANRw0ACwsgASEDDAELIAhBDGoEQCAIKAIMIgEoAjAiAAR/IAAQECAIKAIMBSABCxAQIAhBADYCDAsLIAhBEGokACADC/kEAQh/IwBBgAJrIgMkACAABEBB/AxBESACEB0gAyAAKAIANgLwASACQZoRIANB8AFqEBYgAyAAKAIENgLgASACQacRIANB4AFqEBYgAyAAKAIINgLQASACQYI3IANB0AFqEBYgAyAAKAIQNgLAASACQf0QIANBwAFqEBYgAUEASgRAA0AgACgC0CshBCADIAc2ArABIAJBog0gA0GwAWoQFiADIAQgB0G4CGxqIgQoAgA2AqABIAJBmREgA0GgAWoQFiADIAQoAgQ2ApABIAJB9DcgA0GQAWoQFiADIAQoAgg2AoABIAJBoDYgA0GAAWoQFiADIAQoAgw2AnAgAkGwNiADQfAAahAWIAMgBCgCEDYCYCACQYgRIANB4ABqEBYgAyAEKAIUNgJQIAJBtjggA0HQAGoQFkHVC0EXIAIQHSAEKAIEBEAgBEGwB2ohBiAEQawGaiEIQQAhBQNAIAggBUECdCIJaigCACEKIAMgBiAJaigCADYCRCADIAo2AkAgAkGLDCADQUBrEBYgBUEBaiIFIAQoAgRJDQALCyACEG4gAyAEKAIYNgIwIAJBwDYgA0EwahAWIAMgBCgCpAY2AiAgAkHxNiADQSBqEBZBASEGQe0LQRQgAhAdAkAgBCgCGEEBRwRAIAQoAgQiBUEATA0BIAVBA2xBAmshBgsgBEEcaiEIQQAhBQNAIAMgCCAFQQN0aikCAEIgiTcDECACQYsMIANBEGoQFiAFQQFqIgUgBkcNAAsLIAIQbiADIAQoAqgGNgIAIAJB4DYgAxAWQZkMQQUgAhAdIAdBAWoiByABRw0ACwtBmgxBBCACEB0LIANBgAJqJAAL5goDCX8BewF+IwBBsAFrIgUkAAJAIAFBgANxBEBBni1BCyACEB0MAQsCQCABQQFxRQ0AIAAoAkgiBkUNACMAQdAAayIDJABB7gxBDSACEB0gA0EAOgBPIANBCToATiADIAYpAgA3AkQgAyADQc4AaiIENgJAIAJBhjkgA0FAaxAWIAMgBikCCDcCNCADIAQ2AjAgAkH1OCADQTBqEBYgAyAGKAIQNgIkIAMgBDYCICACQZM3IANBIGoQFgJAIAYoAhhFDQAgBigCEEUNAANAIAMgA0HOAGoiCjYCECADIAc2AhQgAkGODSADQRBqEBYgBigCGCAHQTRsaiEIIwBBMGsiBCQAIARBCTsALiAEQQk6AC0gBCAIKQIANwIkIAQgBEEtaiIJNgIgIAJBzzYgBEEgahAWIAQgCCgCGDYCFCAEIAk2AhAgAkHFOCAEQRBqEBYgBCAIKAIgNgIEIAQgCTYCACACQao4IAQQFiAEQTBqJAAgAyAKNgIAIAJBlAwgAxAWIAdBAWoiByAGKAIQSQ0ACwtBnAxBAiACEB0gA0HQAGokAAsCQCABQQJxRQ0AIAAoAkhFDQBB+Q1BJCACEB0gBSAAKQJUNwOgASACQecRIAVBoAFqEBYgBSAAKQJcNwOQASACQcURIAVBkAFqEBYgBSAAKQNoNwOAASACQdcRIAVBgAFqEBYgACgCDCAAKAJIKAIQIAIQS0GcDEECIAIQHQsCQCABQQhxRQ0AIAAoAkhFDQAgACgCaCAAKAJsbCIERQ0AIAAoApwBIQMDQCADIAAoAkgoAhAgAhBLIANBjCxqIQMgC0EBaiILIARHDQALCyABQRBxRQ0AIAAoAsgBIQFB0w1BJSACEB0gBSAB/QADAP0LBHAgAkHJKyAFQfAAahAWQcENQREgAhAdAkAgASgCHEUNACABKAIYRQ0AQQAhAwNAIAEoAhwgA0EYbGoiAC8BACEEIAApAwghDSAFIAAoAhA2AmAgBSANNwNYIAUgBDYCUCACQYs4IAVB0ABqEBYgA0EBaiIDIAEoAhhJDQALC0GaDEEEIAIQHQJAIAEoAigiBEUNACABKAIkIgdFDQBBACEDQQAhAAJAIAdBBE8EQCAHQXxxIQADQCAEIANBA3JBKGxqQQRqIAQgA0ECckEobGpBBGogBCADQQFyQShsakEEaiAEIANBKGxq/QkCBP1WAgAB/VYCAAL9VgIAAyAM/a4BIQwgA0EEaiIDIABHDQALIAwgDCAM/Q0ICQoLDA0ODwABAgMAAQID/a4BIgwgDCAM/Q0EBQYHAAECAwABAgMAAQID/a4B/RsAIQMgACAHRg0BCwNAIAQgAEEobGooAgQgA2ohAyAAQQFqIgAgB0cNAAsLIANFDQBBsA1BECACEB0gASgCJARAIAEoAighAEEAIQcDQCAFIAAgB0EobCIEaigCBCIGNgJEIAUgBzYCQCACQdE4IAVBQGsQFiABKAIoIQACQCAGRQ0AQQAhAyAAIARqKAIQRQ0AA0AgASgCKCAEaigCECADQRhsaiIA/QADACEMIAUgACkDEDcDOCAFIAz9CwMoIAUgAzYCICACQaXRACAFQSBqEBYgA0EBaiIDIAZHDQALIAEoAighAAsCQCAAIARqIgYoAhhFDQBBACEDIAYoAhRFDQADQCAAIARqKAIYIANBGGxqIgAvAQAhBiAAKQMIIQ0gBSAAKAIQNgIQIAUgDTcDCCAFIAY2AgAgAkGLOCAFEBYgA0EBaiIDIAEoAigiACAEaigCFEkNAAsLIAdBAWoiByABKAIkSQ0ACwtBmgxBBCACEB0LQZwMQQIgAhAdCyAFQbABaiQAC48CAQN/AkBBAUHoARATIgEEfyABQQE2AgAgAUEBNgK4ASABIAEtALwBQQZyOgC8ASABQQFBjCwQEyIANgIMIABFDQEgAUEBQegHEBMiADYCECAARQ0BIAFCADcDMCABQX82AiwgAUHoBzYCFAJAQQFBMBATIgAEQCAAQQA2AhggAEHkADYCICAAQeQAQRgQEyICNgIcIAINASAAEBALIAFBADYCyAEMAgsgAEEANgIoIAEgADYCyAEgARAzIgA2AsQBIABFDQEgARAzIgA2AsABIABFDQECQBCRAUUNAAsgAUEAEGYiADYC1AEgAEUEQCABQQAQZiIANgLUASAARQ0CCyABBUEACw8LIAEQOEEAC40JAgl/AX4jAEHQAWsiByQAIAAoAkghCQJAAkACQCAAKAJoQQFHDQAgACgCbEEBRw0AIAAoApwBKALcKw0BCyAAKAIIQQhGDQAgBkEBQeHOAEEAEA8MAQsCQCABKAIQIgxFDQAgACgCoAEhCiABKAIYIQsgDEEITwRAIAxBeHEhDwNAIAsgCEE0bGogCjYCKCALIAhBAXJBNGxqIAo2AiggCyAIQQJyQTRsaiAKNgIoIAsgCEEDckE0bGogCjYCKCALIAhBBHJBNGxqIAo2AiggCyAIQQVyQTRsaiAKNgIoIAsgCEEGckE0bGogCjYCKCALIAhBB3JBNGxqIAo2AiggCEEIaiEIIA5BCGoiDiAPRw0ACwsgDEEHcSIMRQ0AA0AgCyAIQTRsaiAKNgIoIAhBAWohCCANQQFqIg0gDEcNAAsLIAIgA3IgBHIgBXJFBEAgBkEEQa8wQQAQDyAAQgA3AhwgACAAKQJoNwIkIAEgCf0AAgD9CwIAIAEgBhA3IQgMAQsgAkEASARAIAcgAjYCACAGQQFBx90AIAcQD0EAIQgMAQsgAiAJKAIIIghLBEAgByAINgIUIAcgAjYCECAGQQFBm+EAIAdBEGoQD0EAIQgMAQsCQCACIAkoAgAiCEkEQCAHIAg2AsQBIAcgAjYCwAEgBkECQfvjACAHQcABahAPIABBADYCHCAJKAIAIQIMAQsgACACIAAoAlRrIAAoAlxuNgIcCyABIAI2AgAgA0EASARAIAcgAzYCICAGQQFBh90AIAdBIGoQD0EAIQgMAQsgAyAJKAIMIgJLBEAgByACNgI0IAcgAzYCMCAGQQFB7t8AIAdBMGoQD0EAIQgMAQsCQCADIAkoAgQiAkkEQCAHIAI2ArQBIAcgAzYCsAEgBkECQcziACAHQbABahAPIABBADYCICAJKAIEIQMMAQsgACADIAAoAlhrIAAoAmBuNgIgCyABIAM2AgRBACEIIARBAEwEQCAHIAQ2AkAgBkEBQcXcACAHQUBrEA8MAQsgBCAJKAIAIgJJBEAgByACNgJUIAcgBDYCUCAGQQFBouMAIAdB0ABqEA8MAQsCQCAEIAkoAggiAksEQCAHIAI2AqQBIAcgBDYCoAEgBkECQcPgACAHQaABahAPIAAgACgCaDYCJCAJKAIIIQQMAQsgACAANQJcIhAgBCAAKAJUa618QgF9IBCAPgIkCyABIAQ2AgggBUEATARAIAcgBTYCYCAGQQFBgtwAIAdB4ABqEA8MAQsgBSAJKAIEIgJJBEAgByACNgJ0IAcgBTYCcCAGQQFB8uEAIAdB8ABqEA8MAQsCQCAFIAkoAgwiAksEQCAHIAI2ApQBIAcgBTYCkAEgBkECQZXfACAHQZABahAPIAAgACgCbDYCKCAJKAIMIQUMAQsgACAANQJgIhAgBSAAKAJYa618QgF9IBCAPgIoCyABIAU2AgwgACAALQBEQQJyOgBEIAEgBhA3IghFBEBBACEIDAELIAcgAf0AAgD9CwSAASAGQQRBtDkgB0GAAWoQDwsgB0HQAWokACAIC5UCAQd/IwBBIGsiBSQAAn8gACgCSCIERQRAIANBAUHF5gBBABAPQQAMAQtBAEEEIAQoAhAQEyIERQ0AGiABBEAgACgCSCEIA0ACQAJAIAIgBkECdGooAgAiByAIKAIQTwRAIAUgBzYCECADQQFB+REgBUEQahAPDAELIAQgB0ECdGoiCSgCAEUNASAFIAc2AgAgA0EBQY0aIAUQDwsgBBAQQQAMAwsgCUEBNgIAIAZBAWoiBiABRw0ACwsgBBAQIAAoAkAQEAJAIAEEQCAAIAFBAnQiBBAUIgM2AkAgA0UEQCAAQQA2AjxBAAwDCyADIAIgBBASGgwBCyAAQQA2AkALIAAgATYCPEEBCyEKIAVBIGokACAKC7wFAQd/IAFBAUEkEBMiBDYCSAJAAkAgBEUNAAJAIAEoAsQBQRIgAxAkBEAgASgCxAFBEyADECQNAQsMAgsgASgCxAEiBygCACEGIAcoAgghBAJAIAYEQEEBIQUgBkEBRwRAIAZBfnEhCQNAAn9BACAFRQ0AGkEAIAEgACADIAQoAgARAABFDQAaIAEgACADIAQoAgQRAABBAEcLIQUgBEEIaiEEIAhBAmoiCCAJRw0ACwsCQAJAIAZBAXEEQCAFRQ0BIAEgACADIAQoAgARAABBAEchBQsgB0EANgIAIAVFDQEMAwsgB0EANgIACwwDCyAHQQA2AgALAkAgASgCwAFBFCADECQEQCABKALAAUEVIAMQJA0BCwwCCyABKALAASIHKAIAIQYgBygCCCEEAkAgBgRAQQEhBSAGQQFxIQkgBkEBRgR/QQAFIAZBfnEhBkEAIQgDQAJ/QQAgBUUNABpBACABIAAgAyAEKAIAEQAARQ0AGiABIAAgAyAEKAIEEQAAQQBHCyEFIARBCGohBCAIQQJqIgggBkcNAAsgBUULIQYCQAJAIAkEQCAGDQEgASAAIAMgBCgCABEAAEEARyEFCyAHQQA2AgAgBUUNAQwDCyAHQQA2AgALDAMLIAdBADYCAAsgAkEBQSQQEyIANgIAIABFDQAgASgCSCAAED8gASgCyAEgASgCbCABKAJobCIANgIkIABBKBATIQMgASgCyAEiACADNgIoAkAgA0UNACAAKAIkRQRAQQEPC0EAIQQDQCADIARBKGwiBWoiAEEANgIUIABB5AA2AhxB5ABBGBATIQAgBSABKALIASIHKAIoIgNqIAA2AhggAEUNAUEBIQogBEEBaiIEIAcoAiRJDQALDAELIAIoAgAQIUEAIQogAkEANgIACyAKDwsgASgCSBAhIAFBADYCSEEACwIACwQAQQELNAACQCAARQ0AIAFFDQAgACABKAIENgKkASAAIAEoAgA2AqABIAAgASgCuEBBAnE2AuABCwu0BQEIfyAAKAIYIgQoAhAiCUUEQEEADwsgBCgCGCEFIAAoAhQoAgAoAhQhBAJAAkAgAUUEQEEAIQEDQCAFKAIYIQIgBCgCHCAEKAIYQZgBbGoiAEGMAWsoAgAiByAAQZQBaygCACIIayEDIABBkAFrKAIAIABBmAFrKAIAayEAAkAgByAIRg0AIACtIAOtfkIgiFANAAwECyAAIANsIQMCQEEEIAJBA3YgAkEHcUEAR2oiACAAQQNGGyICRQ0AIAKtIAOtfkIgiFANAAwEC0F/IQAgAiADbCICIAFBf3NLDQIgBEHMAGohBCAFQTRqIQUgASACaiIBIQAgBkEBaiIGIAlHDQALDAELQQAhASAAKAJARQRAA0AgBSgCGCECIAQoAhwgBCgCGEGYAWxqIgBBBGsoAgAiByAAQQxrKAIAIghrIQMgAEEIaygCACAAQRBrKAIAayEAAkAgByAIRg0AIACtIAOtfkIgiFANAAwECyAAIANsIQMCQEEEIAJBA3YgAkEHcUEAR2oiACAAQQNGGyICRQ0AIAKtIAOtfkIgiFANAAwEC0F/IQAgAiADbCICIAFBf3NLDQIgBEHMAGohBCAFQTRqIQUgASACaiIBIQAgBkEBaiIGIAlHDQALDAELA0AgBSgCGCECIAQoAhwgBCgCGEGYAWxqIgBBjAFrKAIAIgcgAEGUAWsoAgAiCGshAyAAQZABaygCACAAQZgBaygCAGshAAJAIAcgCEYNACAArSADrX5CIIhQDQAMAwsgACADbCEDAkBBBCACQQN2IAJBB3FBAEdqIgAgAEEDRhsiAkUNACACrSADrX5CIIhQDQAMAwtBfyEAIAIgA2wiAiABQX9zSw0BIARBzABqIQQgBUE0aiEFIAEgAmoiASEAIAZBAWoiBiAJRw0ACwsgAA8LQX8L2gQBC38gAARAIAAoAhQiAQRAIAEoAgAiBQRAIAUoAhQhAyAFKAIQBH9BEEERIAAtAChBAXEbIQgDQCADKAIcIgIEQCADKAIgIgFBmAFuIQpBACEJIAFBmAFPBH8DQCACKAIwIgEEQCACKAI0IgZBKG4hB0EAIQQgBkEoTwR/A0AgASgCIBApIAFBADYCICABKAIkECkgAUEANgIkIAEgCBECACABQShqIQEgBEEBaiIEIAdHDQALIAIoAjAFIAELEBAgAkEANgIwCyACKAJUIgEEQCACKAJYIgZBKG4hB0EAIQQgBkEoTwR/A0AgASgCIBApIAFBADYCICABKAIkECkgAUEANgIkIAEgCBECACABQShqIQEgBEEBaiIEIAdHDQALIAIoAlQFIAELEBAgAkEANgJUCyACKAJ4IgEEQCACKAJ8IgZBKG4hB0EAIQQgBkEoTwR/A0AgASgCIBApIAFBADYCICABKAIkECkgAUEANgIkIAEgCBECACABQShqIQEgBEEBaiIEIAdHDQALIAIoAngFIAELEBAgAkEANgJ4CyACQZgBaiECIAlBAWoiCSAKRw0ACyADKAIcBSACCxAQIANBADYCHAsCQCADKAIoRQ0AIAMoAiQiAUUNACABEBAgA/0MAAAAAAAAAAAAAAAAAAAAAP0LAiQLIAMoAjQQECADQcwAaiEDIAtBAWoiCyAFKAIQSQ0ACyAFKAIUBSADCxAQIAVBADYCFCAAKAIUKAIAEBAgACgCFCIBQQA2AgALIAEQECAAQQA2AhQLIAAoAkQQECAAEBALC8sTARV/IwBBIGsiDyQAIA8gBTYCGCABIAMoAhxBzABsaigCHCADKAIgQZgBbGohEQJAAkAgAygCKA0AIBEoAhhFDQAgEUEcaiEJA0ACQCAJKAIIIAkoAgBHBH8gCSgCDCAJKAIERgVBAQsNACADKAIkIgEgCSgCGEEobk8EQCAIQQFBghVBABAPDAQLIAkoAhQgAUEobGoiASgCIBBiIAEoAiQQYiABKAIUIAEoAhBsIg1FDQAgASgCGCEBIA1BCE8EQCANQXhxIQtBACEKA0AgAUIANwLoAyABQgA3AqgDIAFCADcC6AIgAUIANwKoAiABQgA3AugBIAFCADcCqAEgAUIANwJoIAFCADcCKCABQYAEaiEBIApBCGoiCiALRw0ACwtBACEKIA1BB3EiDUUNAANAIAFCADcCKCABQUBrIQEgCkEBaiIKIA1HDQALCyAJQSRqIQkgDEEBaiIMIBEoAhhJDQALCyAFIQ0CQCACLQAAQQJxRQ0AIAdBBU0EQCAIQQJBsR9BABAPDAELAkAgBS0AAEH/AUYEQCAFLQABQZEBRg0BCyAIQQJB2x9BABAPDAELIA8gBUEGaiINNgIYC0EUEBQiC0UNAAJ/IAAtAGxBAXEEQCAAQShqIQcgACgCKCENIABBLGoMAQsgAi0AiCxBAnEEQCACQbAoaiEHIAIoArAoIQ0gAkG8KGoMAQsgDyAFIAdqIA1rNgIcIA9BGGohByAPQRxqCyISKAIAIQAgC0IANwIMIAsgDTYCCCALIA02AgAgCyAAIA1qNgIEIAtBARAfRQRAIAsQZBogCygCCCALKAIAayEaIAsQLCAaIA1qIQECQCACLQAAQQRxRQ0AIAcoAgAgEigCACABa2pBAU0EQCAIQQJBmCFBABAPDAELAkAgAS0AAEH/AUYEQCABLQABQZIBRg0BCyAIQQJBwiFBABAPDAELIAFBAmohAQsgEiASKAIAIAcoAgAgAWtqNgIAIAcgATYCACAEQQA2AgAgBiAPKAIYIAVrNgIAQQEhFwwBCyARKAIYBEAgEUEcaiEQA0AgAygCJCEAIBAoAhQhAQJAIBAoAgggECgCAEcEfyAQKAIMIBAoAgRGBUEBCw0AIAEgAEEobGoiFCgCFCAUKAIQbCIYRQ0AIBQoAhghCUEAIRUDQAJAAn8gCSgCKEUEQCALIBQoAiAgFSADKAIoQQFqEGAMAQsgC0EBEB8LRQRAIAlBADYCJAwBCyAJKAIoRQRAQQAhAQNAIAEiAEEBaiEBIAsgFCgCJCAVIAAQYEUNAAsgECgCHCEBIAlBAzYCICAJIAE2AhggCSABIABrQQFqNgIcCyAJAn9BASALQQEQH0UNABpBAiALQQEQH0UNABogC0ECEB8iAEEDRwRAIABBA2oMAQsgC0EFEB8iAEEfRwRAIABBBmoMAQsgC0EHEB9BJWoLNgIkQQAhAQNAIAEiAEEBaiEBIAtBARAfDQALIAkgCSgCICAAajYCIAJAAkACfyAJKAIoIgBFBEAgAigC0CsgAygCHEG4CGxqKAIQIQAgCSgCMEUEQCAJKAIAQfABEBciAUUNBCAJIAE2AgAgASAJKAIwQRhsakEAQfABEBUaIAlBCjYCMAsgCSgCACIB/QwAAAAAAAAAAAAAAAAAAAAA/QsCACABQgA3AhBBAUEKQe0AIABBAXEbIABBBHEbIQpBAAwBCyAJKAIAIgEgAEEBayIMQRhsaiIKKAIEIAooAgxHDQEgAigC0CsgAygCHEG4CGxqKAIQIQogCSgCMCIMIABBAWpJBH8gASAMQQpqIgxBGGwQFyIBRQ0DIAkgATYCACABIAkoAjBBGGxqQQBB8AEQFRogCSAMNgIwIAkoAgAFIAELIABBGGxqIgH9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAFCADcCEAJ/QQEgCkEEcQ0AGkHtACAKQQFxRQ0AGkECQQJBASABQQxrKAIAIgpBCkYbIApBAUYbCyEKIAALIQwgASAKNgIMCyAJKAIkIQAgAigC0CsgAygCHEG4CGxqLQAQQcAAcQRAA0AgDEEYbCIOIAkoAgBqIABBASAMGyITNgIQIAkoAiAhFkEAIQogACEBIBNBAk8EQANAIApBAWohCiABQQNLIRsgAUEBdiEBIBsNAAsLIAogFmoiAUEhTwRAIA8gATYCECAIQQFBvPQAIA9BEGoQDwwDCyALIAEQHyEKIAkoAgAiASAOaiIOIAo2AhQgACAOKAIQayIAQQBMDQMgAigC0CsgAygCHEG4CGxqKAIQIQogCSgCMCIOIAxBAmpJBEAgASAOQQpqIg5BGGwQFyIBRQ0DIAkgATYCACABIAkoAjBBGGxqQQBB8AEQFRogCSAONgIwIAkoAgAhAQsgASAMQQFqIgxBGGxqIgH9DAAAAAAAAAAAAAAAAAAAAAD9CwIAIAFCADcCECABAn9BASAKQQRxDQAaQe0AIApBAXFFDQAaQQJBAkEBIAFBDGsoAgAiAUEKRhsgAUEBRhsLNgIMDAALAAsDQCAMQRhsIg4gCSgCAGoiASABKAIMIAEoAgRrIgEgACAAIAFKGyIBNgIQIAkoAiAhE0EAIQogAUECTwRAA0AgCkEBaiEKIAFBA0shHCABQQF2IQEgHA0ACwsgCiATaiIBQSFPBEAgDyABNgIAIAhBAUG89AAgDxAPDAILIAsgARAfIQogCSgCACIBIA5qIg4gCjYCFCAAIA4oAhBrIgBBAEwNAiACKALQKyADKAIcQbgIbGooAhAhCiAJKAIwIg4gDEECakkEQCABIA5BCmoiDkEYbBAXIgFFDQIgCSABNgIAIAEgCSgCMEEYbGpBAEHwARAVGiAJIA42AjAgCSgCACEBCyABIAxBAWoiDEEYbGoiAf0MAAAAAAAAAAAAAAAAAAAAAP0LAgAgAUIANwIQIAECf0EBIApBBHENABpB7QAgCkEBcUUNABpBAkECQQEgAUEMaygCACIBQQpGGyABQQFGGws2AgwMAAsACyALECwMBQsgCUFAayEJIBVBAWoiFSAYRw0ACwsgEEEkaiEQIBlBAWoiGSARKAIYSQ0ACwsgCxBkRQRAIAsQLAwBCyALKAIIIAsoAgBrIR0gCxAsIB0gDWohAQJAIAItAABBBHFFDQAgBygCACASKAIAIAFrakEBTQRAIAhBAkGYIUEAEA8MAQsCQCABLQAAQf8BRgRAIAEtAAFBkgFGDQELIAhBAkHCIUEAEA8MAQsgAUECaiEBCyASIBIoAgAgBygCACABa2o2AgAgByABNgIAQQEhFyAEQQE2AgAgBiAPKAIYIAVrNgIACyAPQSBqJAAgFwuWJAIUfw5+AkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQCAAKAJUDgUAAQIDBAoLAkAgACgCNCIGIAAoAsQBIgFJBEAgACgCQCIHIAFBAWpJDQELIAAoAuwBQQFB9D9BABAPDAwLIAAoAixFBEAgACgCJCECQQAhAQwFCyAAQQA2AiwgACgCRCEDQQEhAQwECwJAIAAoAjQiBiAAKALEASIBSQRAIAAoAkAiByABQQFqSQ0BCyAAKALsAUEBQaHAAEEAEA8MCwsgACgCLEUEQCAAKAIkIQRBACEBDAgLIABBADYCLCAAKAIwIQNBASEBDAcLAkAgACgCNCIEIAAoAsQBIgpJBEAgACgCQCIOIApBAWpJDQELIAAoAuwBQQFBqMEAQQAQDwwKCyAAKAIsRQRAIAAoAighCwwGCyAAQgA3AuQBIABBADYCLCAAKALIASEMA0AgDCAHQQR0aiIFKAIIIg8EQCAFKAIMIRJBACEBA0ACQCAPIAFBf3NqIhAgEiABQQR0aiIRKAIAaiIJQR9LDQAgBSgCACITQX8gCXZLDQAgACACIBMgCXQiCSACIAlJGyAJIAIbIgI2AuQBCwJAIBEoAgQgEGoiCUEfSw0AIAUoAgQiEEF/IAl2Sw0AIAAgAyAQIAl0IgkgAyAJSRsgCSADGyIDNgLoAQsgAUEBaiIBIA9HDQALCyAHQQFqIgcgCkcNAAsgAkUNByADRQ0HIAAtAABFBEAgACAAKALQATYCbCAAIAAoAswBNgJkIAAgACgC2AE2AnAgACAAKALUATYCaAsgACgCMCEFQQEhAQwFCwJAIAAoAjQiBSAAKALEASIJSQRAIAAoAkAiEiAJQQFqSQ0BCyAAKALsAUEBQfvAAEEAEA8MCQsgACgCLEUEQCAAKALIASINIAAoAhwiBEEEdGohCyAAKAIoIQgMBAsgAEIANwLkASAAQQA2AiwgACgCyAEhDQNAIA0gBkEEdGoiCigCCCIOBEAgCigCDCEQQQAhAQNAAkAgDiABQX9zaiIRIBAgAUEEdGoiEygCAGoiDEEfSw0AIAooAgAiFEF/IAx2Sw0AIAAgAiAUIAx0IgwgAiAMSRsgDCACGyICNgLkAQsCQCATKAIEIBFqIgxBH0sNACAKKAIEIhFBfyAMdksNACAAIAMgESAMdCIMIAMgDEkbIAwgAxsiAzYC6AELIAFBAWoiASAORw0ACwsgBkEBaiIGIAlHDQALIAJFDQYgA0UNBgJAIAAtAAAEQCAAKAJsIQYMAQsgACAAKALQASIGNgJsIAAgACgCzAE2AmQgACAAKALYATYCcCAAIAAoAtQBNgJoC0EBIQEMAwsCQCAAKAI0IgYgACgCxAEiAUkEQCAAKAJAIg8gAUEBakkNAQsgACgC7AFBAUHOwABBABAPDAYLIAAoAixFBEAgACgCyAEgACgCHCIGQQR0aiEFIAAoAighB0EAIQEMAgsgACAGNgIcIABBADYCLEEBIQEMAQsDQAJ/AkAgAUUEQCACQQFqIQIMAQsgACADNgIoIAAoAjggA00NCSAAKAIwIQRBAAwBC0EBCyEBA0ACQAJAAkACQCABRQRAIAAgBDYCICAEIAAoAjxPDQEgACAGNgIcIAYhAUEAIQUMBAsgACACNgIkIAAoAkwgAk0EQCAAKAIcIQFBASEFDAQLIAAoAhAgACgCIGwgACgCDCAAKAIobGogACgCFCAAKAIcbGogACgCGCACbGoiASAAKAIITwRADAwLIAAoAgQgAUEBdGoiAS8BAA0BDA0LIAAoAihBAWohAwwBC0EAIQEMAwtBASEBDAILA0ACQAJAAkAgBUUEQCABIAdPDQEgACgCICIFIAAoAsgBIAFBBHRqIg0oAghPDQMgAC0AAEUEQCAAIA0oAgwgBUEEdGoiASgCDCABKAIIbDYCTAsgACgCSCECQQEhAQwFCyAAIAFBAWoiATYCHAwBCyAAKAIgQQFqIQRBACEBDAMLQQAhBQwBC0EBIQUMAAsACwALAAsDQAJ/AkAgAUUEQCAAIAdBAWoiBzYCKAwBCyAGIA9PDQggAEIANwLkASAAKALIASAGQQR0aiIFKAIIIgtFDQggBSgCDCEKQQAhAkEAIQRBACEBA0ACQCALIAFBf3NqIgkgCiABQQR0aiIOKAIAaiIIQR9LDQAgBSgCACIMQX8gCHZLDQAgACAEIAwgCHQiCCAEIAhJGyAIIAQbIgQ2AuQBCwJAIA4oAgQgCWoiCEEfSw0AIAUoAgQiCUF/IAh2Sw0AIAAgAiAJIAh0IgggAiAISRsgCCACGyICNgLoAQsgAUEBaiIBIAtHDQALIARFDQYgAkUNBgJAIAAtAAAEQCAAKAJsIQIMAQsgACAAKALQASICNgJsIAAgACgCzAE2AmQgACAAKALYATYCcCAAIAAoAtQBNgJoC0EADAELQQELIQEDQAJAAkACQAJAIAFFBEAgACACNgLgASACIAAoAnBPDQEgACgCZCENQQAhAQwECyAAKAI4IAdNBEAgACgCICEDQQEhAQwECyAAKAIQIAAoAiBsIAAoAgwgB2xqIAAoAhQgBmxqIAAoAhggACgCJGxqIgEgACgCCE8EQAwLCyAAKAIEIAFBAXRqIgEvAQANAQwMCyAAIAZBAWoiBjYCHAwBC0EAIQEMAwtBASEBDAILA0ACQAJAAkAgAAJ/IAFFBEAgACANNgLcASANIAAoAmhPDQIgACgCMAwBCyADQQFqCyIDNgIgIAAoAjwiASAFKAIIIgQgASAESRsgA0sEQCAFKAIAIgEgAa0iHiAEIANBf3NqIgitIhaGIhcgFoinRw0DIAUoAgQiBEJ/IBaIp3EgBEcNAyAErSIVIBaGIhhCAX0iGSAANQLYAXwgGIAhHyAZIAAoAtABIgmtfCAYgCEaIBdCAX0iGyAANQLUAXwgF4AhICAbIAAoAswBIg6tfCAXgCEcIAFCfyAFKAIMIANBBHRqIgsoAgAiCiAIaq0iHYincSABRw0DIAQgFSALKAIEIgEgCGqtIhWGIiEgFYinRw0DIAAoAuABIgStIiIgIYJCAFIEQCAEIAlHDQRCfyAVhkJ/hSAaQv////8PgyAWhoNQDQQLIAAoAtwBIgStIhUgHiAdhoJCAFIEQCAEIA5HDQRCfyAdhkJ/hSAcQv////8PgyAWhoNQDQQLIAsoAggiBEUNAyALKAIMRQ0DIBynIgsgIKdGDQMgGqciCCAfp0YNAyAAIAAoAkQiBzYCKCAAIBUgG3wgF4CnIAp2IAsgCnZrIBkgInwgGICnIAF2IAggAXZrIARsajYCJEEBIQEMBQsgACgC3AEiASAAKALkASIEaiABIARwayENDAELIAAoAuABIgEgACgC6AEiBGogASAEcGshAkEAIQEMAwtBACEBDAELQQEhAQwACwALAAsACwNAAn8CQCABRQRAIAAgCEEBaiIINgIoDAELIAAgBjYC4AEgACgCcCAGTQ0HIAAoAmQhD0EADAELQQELIQEDQAJAAkACQAJAIAFFBEAgACAPNgLcASAPIAAoAmhPDQEgACAFNgIcIAUhBEEAIQEMBAsgACgCOCAITQRAIAAoAiAhB0EBIQEMBAsgACgCECAAKAIgbCAAKAIMIAhsaiAAKAIUIARsaiAAKAIYIAAoAiRsaiIBIAAoAghPBEAMCgsgACgCBCABQQF0aiIBLwEADQEMCwsgACgC4AEiASAAKALoASIGaiABIAZwayEGDAELQQAhAQwDC0EBIQEMAgsDQAJAAkACQAJAIAFFBEAgBCASTw0CIAAgACgCMCIHNgIgIA0gBEEEdGohCwwBCyAAIAdBAWoiBzYCIAsgACgCPCIBIAsoAggiAiABIAJJGyAHSwRAIAsoAgAiASABrSIeIAIgB0F/c2oiCq0iFoYiFyAWiKdHDQMgCygCBCICQn8gFoincSACRw0DIAKtIhUgFoYiGEIBfSIZIAA1AtgBfCAYgCEfIBkgACgC0AEiDq18IBiAIRogF0IBfSIbIAA1AtQBfCAXgCEgIBsgACgCzAEiDK18IBeAIRwgAUJ/IAsoAgwgB0EEdGoiAygCACIJIApqrSIdiKdxIAFHDQMgAiAVIAMoAgQiASAKaq0iFYYiISAViKdHDQMgACgC4AEiAq0iIiAhgkIAUgRAIAIgDkcNBEJ/IBWGQn+FIBpC/////w+DIBaGg1ANBAsgACgC3AEiAq0iFSAeIB2GgkIAUgRAIAIgDEcNBEJ/IB2GQn+FIBxC/////w+DIBaGg1ANBAsgAygCCCICRQ0DIAMoAgxFDQMgHKciAyAgp0YNAyAapyIKIB+nRg0DIAAgACgCRCIINgIoIAAgFSAbfCAXgKcgCXYgAyAJdmsgGSAifCAYgKcgAXYgCiABdmsgAmxqNgIkQQEhAQwFCyAAIARBAWoiBDYCHAwBCyAAKALcASIBIAAoAuQBIgJqIAEgAnBrIQ9BACEBDAMLQQAhAQwBC0EBIQEMAAsACwALAAsDQAJ/AkAgAUUEQCAAIAtBAWoiCzYCKAwBCyAAIAU2AiAgACgCPCAFTQ0GIAAoAmwhCEEADAELQQELIQEDQAJAAkACQAJAIAFFBEAgACAINgLgASAIIAAoAnBPDQEgACgCZCENQQAhAQwECyAAKAI4IAtNBEAgACgCHCEGQQEhAQwECyAAKAIQIAAoAiBsIAAoAgwgC2xqIAAoAhQgACgCHGxqIAAoAhggACgCJGxqIgEgACgCCE8EQAwJCyAAKAIEIAFBAXRqIgEvAQANAQwKCyAAKAIgQQFqIQUMAQtBACEBDAMLQQEhAQwCCwNAAkACQAJAAkAgAUUEQCAAIA02AtwBIA0gACgCaE8NAiAAIAQ2AhwgBCEGDAELIAAgBkEBaiIGNgIcCyAGIA5JBEAgACgCICIHIAAoAsgBIAZBBHRqIgEoAggiA08NAyABKAIAIgIgAq0iHiADIAdBf3NqIgqtIhaGIhcgFoinRw0DIAEoAgQiA0J/IBaIp3EgA0cNAyADrSIVIBaGIhhCAX0iGSAANQLYAXwgGIAhHyAZIAAoAtABIg+tfCAYgCEaIBdCAX0iGyAANQLUAXwgF4AhICAbIAAoAswBIgmtfCAXgCEcIAJCfyABKAIMIAdBBHRqIgEoAgAiByAKaq0iHYincSACRw0DIAMgFSABKAIEIgIgCmqtIhWGIiEgFYinRw0DIAAoAuABIgOtIiIgIYJCAFIEQCADIA9HDQRCfyAVhkJ/hSAaQv////8PgyAWhoNQDQQLIAAoAtwBIgOtIhUgHiAdhoJCAFIEQCADIAlHDQRCfyAdhkJ/hSAcQv////8PgyAWhoNQDQQLIAEoAggiA0UNAyABKAIMRQ0DIBynIgEgIKdGDQMgGqciCiAfp0YNAyAAIAAoAkQiCzYCKCAAIBUgG3wgF4CnIAd2IAEgB3ZrIBkgInwgGICnIAJ2IAogAnZrIANsajYCJEEBIQEMBQsgACgC3AEiASAAKALkASICaiABIAJwayENDAELIAAoAuABIgEgACgC6AEiAmogASACcGshCEEAIQEMAwtBACEBDAELQQEhAQwACwALAAsACwNAAn8CQCABRQRAIARBAWohBAwBCyAAIAM2AiAgACgCPCADTQ0FIAAoAkQhAkEADAELQQELIQEDQAJAAkACQAJAIAFFBEAgACACNgIoIAIgACgCOE8NASAAIAY2AhwgBiEBQQAhBQwECyAAIAQ2AiQgACgCTCAETQRAIAAoAhwhAUEBIQUMBAsgACgCECAAKAIgbCAAKAIMIAAoAihsaiAAKAIUIAAoAhxsaiAAKAIYIARsaiIBIAAoAghPBEAMCAsgACgCBCABQQF0aiIBLwEADQEMCQsgACgCIEEBaiEDDAELQQAhAQwDC0EBIQEMAgsDQAJAAkACQCAFRQRAIAEgB08NASAAKAIgIgUgACgCyAEgAUEEdGoiDSgCCE8NAyAALQAARQRAIAAgDSgCDCAFQQR0aiIBKAIMIAEoAghsNgJMCyAAKAJIIQRBASEBDAULIAAgAUEBaiIBNgIcDAELIAAoAihBAWohAkEAIQEMAwtBACEFDAELQQEhBQwACwALAAsAC0EADwsgACgC7AFBAUGaCkEAEA8LQQAPCyABQQE7AQBBAQuRCwEKfwJAIAEoAgAgBEEDbCIMdiIGQZCAgAFxDQAgACAAQRxqIg4gACgCbCAGQe8DcWotAABBAnRqIgo2AmggACAAKAIEIAooAgAiCSgCACIIayIGNgIEAkAgCCAAKAIAIgdBEHZLBEAgCSgCBCELIAAgCDYCBCAKIAlBCEEMIAYgCEkiBhtqKAIANgIAIAsgC0UgBhshCSAAKAIIIQYDQAJAIAYNACAAKAIQIgZBAWohCyAGLQABIQogBi0AAEH/AUYEQCAKQZABTwRAIAAgACgCDEEBajYCDCAHQYD+A2ohB0EIIQYMAgsgACALNgIQIAcgCkEJdGohB0EHIQYMAQsgACALNgIQQQghBiAHIApBCHRqIQcLIAAgBkEBayIGNgIIIAAgB0EBdCIHNgIAIAAgCEEBdCIINgIEIAhBgIACSQ0ACyAIIQYMAQsgACAHIAhBEHRrIgc2AgAgBkGAgAJxRQRAIAkoAgQhCyAKIAlBDEEIIAYgCEkiCBtqKAIANgIAIAtFIAsgCBshCSAAKAIIIQgDQAJAIAgNACAAKAIQIghBAWohCyAILQABIQogCC0AAEH/AUYEQCAKQZABTwRAIAAgACgCDEEBajYCDCAHQYD+A2ohB0EIIQgMAgsgACALNgIQIAcgCkEJdGohB0EHIQgMAQsgACALNgIQQQghCCAHIApBCHRqIQcLIAAgCEEBayIINgIIIAAgB0EBdCIHNgIAIAAgBkEBdCIGNgIEIAZBgIACSQ0ACwwBCyAJKAIEIQkLIAlFDQAgACAOIAEoAgQgDEERanZBBHEgAUEEayINKAIAIAxBE2p2QQFxIAEoAgAiCCAMQRBqdkHAAHEgCCAMdkGqAXFyIAggDEEMakEOIAQbdkEQcXJyciIPQdC5AWotAABBAnRqIgs2AmggACAGIAsoAgAiCigCACIIayIGNgIEAkAgCCAHQRB2SwRAIAooAgQhCSAAIAg2AgQgCyAKQQhBDCAGIAhJIgYbaigCADYCACAJIAlFIAYbIQogACgCCCEGA0ACQCAGDQAgACgCECIGQQFqIQsgBi0AASEJIAYtAABB/wFGBEAgCUGQAU8EQCAAIAAoAgxBAWo2AgwgB0GA/gNqIQdBCCEGDAILIAAgCzYCECAHIAlBCXRqIQdBByEGDAELIAAgCzYCEEEIIQYgByAJQQh0aiEHCyAAIAZBAWsiBjYCCCAAIAdBAXQiBzYCACAAIAhBAXQiCDYCBCAIQYCAAkkNAAsMAQsgACAHIAhBEHRrIgk2AgAgBkGAgAJxRQRAIAooAgQhByALIApBDEEIIAYgCEkiCBtqKAIANgIAIAdFIAcgCBshCiAAKAIIIQcDQAJAIAcNACAAKAIQIgdBAWohCyAHLQABIQggBy0AAEH/AUYEQCAIQZABTwRAIAAgACgCDEEBajYCDCAJQYD+A2ohCUEIIQcMAgsgACALNgIQIAkgCEEJdGohCUEHIQcMAQsgACALNgIQQQghByAJIAhBCHRqIQkLIAAgB0EBayIHNgIIIAAgCUEBdCIJNgIAIAAgBkEBdCIGNgIEIAZBgIACSQ0ACwwBCyAKKAIEIQoLIAJBACADayADIAogD0HQuwFqLQAAcyIDGzYCACANIA0oAgBBICAMdHI2AgAgASABKAIAIANBE3RBEHIgDHRyNgIAIAEgASgCBEEIIAx0cjYCBCAEIAVyRQRAIAFBfiAAKAJ8a0ECdGoiAiACKAIEQYCAAnI2AgQgAiACKAIAIANBH3RyQYCABHI2AgAgAkEEayICIAIoAgBBgIAIcjYCAAsgBEEDRw0AIAEgACgCfEECdGoiAEEEaiAAKAIEQQRyNgIAIAAgACgCDEEBcjYCDCAAIAAoAgggA0ESdHJBAnI2AggLC6sLAQl/AkAgASgCACAEQQNsIg12IgdBkICAAXENACAHQe8DcSIHRQ0AIAAgAEEcaiIOIAAoAmwgB2otAABBAnRqIgs2AmggACAAKAIEIAsoAgAiCigCACIJayIHNgIEAkAgCSAAKAIAIghBEHZLBEAgCigCBCEMIAAgCTYCBCALIApBCEEMIAcgCUkiBxtqKAIANgIAIAwgDEUgBxshCiAAKAIIIQcDQAJAIAcNACAAKAIQIgdBAWohDCAHLQABIQsgBy0AAEH/AUYEQCALQZABTwRAIAAgACgCDEEBajYCDCAIQYD+A2ohCEEIIQcMAgsgACAMNgIQIAggC0EJdGohCEEHIQcMAQsgACAMNgIQQQghByAIIAtBCHRqIQgLIAAgB0EBayIHNgIIIAAgCEEBdCIINgIAIAAgCUEBdCIJNgIEIAlBgIACSQ0ACyAJIQcMAQsgACAIIAlBEHRrIgg2AgAgB0GAgAJxRQRAIAooAgQhDCALIApBDEEIIAcgCUkiCRtqKAIANgIAIAxFIAwgCRshCiAAKAIIIQkDQAJAIAkNACAAKAIQIglBAWohDCAJLQABIQsgCS0AAEH/AUYEQCALQZABTwRAIAAgACgCDEEBajYCDCAIQYD+A2ohCEEIIQkMAgsgACAMNgIQIAggC0EJdGohCEEHIQkMAQsgACAMNgIQQQghCSAIIAtBCHRqIQgLIAAgCUEBayIJNgIIIAAgCEEBdCIINgIAIAAgB0EBdCIHNgIEIAdBgIACSQ0ACwwBCyAKKAIEIQoLAkAgCkUNACAAIA4gASgCBCANQRFqdkEEcSABQQRrIg8oAgAgDUETanZBAXEgASgCACIJIA1BEGp2QcAAcSAJIA12QaoBcXIgCSANQQxqQQ4gBBt2QRBxcnJyIgpB0LkBai0AAEECdGoiDDYCaCAAIAcgDCgCACILKAIAIglrIgc2AgQgCkHQuwFqLQAAIQ4CQCAJIAhBEHZLBEAgCygCBCEKIAAgCTYCBCAMIAtBCEEMIAcgCUkiBxtqKAIANgIAIAogCkUgBxshCyAAKAIIIQcDQAJAIAcNACAAKAIQIgdBAWohDCAHLQABIQogBy0AAEH/AUYEQCAKQZABTwRAIAAgACgCDEEBajYCDCAIQYD+A2ohCEEIIQcMAgsgACAMNgIQIAggCkEJdGohCEEHIQcMAQsgACAMNgIQQQghByAIIApBCHRqIQgLIAAgB0EBayIHNgIIIAAgCEEBdCIINgIAIAAgCUEBdCIJNgIEIAlBgIACSQ0ACwwBCyAAIAggCUEQdGsiCjYCACAHQYCAAnFFBEAgCygCBCEIIAwgC0EMQQggByAJSSIJG2ooAgA2AgAgCEUgCCAJGyELIAAoAgghCANAAkAgCA0AIAAoAhAiCEEBaiEMIAgtAAEhCSAILQAAQf8BRgRAIAlBkAFPBEAgACAAKAIMQQFqNgIMIApBgP4DaiEKQQghCAwCCyAAIAw2AhAgCiAJQQl0aiEKQQchCAwBCyAAIAw2AhBBCCEIIAogCUEIdGohCgsgACAIQQFrIgg2AgggACAKQQF0Igo2AgAgACAHQQF0Igc2AgQgB0GAgAJJDQALDAELIAsoAgQhCwsgAkEAIANrIAMgCyAOcyICGzYCACAPIA8oAgBBICANdHI2AgAgASABKAIAIAJBE3RBEHIgDXRyNgIAIAEgASgCBEEIIA10cjYCBCAEIAZyRQRAIAEgBUECdGsiACAAKAIEQYCAAnI2AgQgACAAKAIAIAJBH3RyQYCABHI2AgAgAEEEayIAIAAoAgBBgIAIcjYCAAsgBEEDRw0AIAEgBUECdGoiACAAKAIEQQFyNgIEIAAgACgCACACQRJ0ckECcjYCACAAQQRrIgAgACgCAEEEcjYCAAsgASABKAIAQYCAgAEgDXRyNgIACwutAQAgAEHwnQE2AmQgAEHwnQE2AmAgAEHwnQE2AlwgAEHwnQE2AlggAEHwnQE2AlQgAEHwnQE2AlAgAEHwnQE2AkwgAEHwnQE2AkggAEHwnQE2AkQgAEHwnQE2AkAgAEHwnQE2AjwgAEHwnQE2AjggAEHwnQE2AjQgAEHwnQE2AjAgAEHwnQE2AiwgAEHwnQE2AiggAEHwnQE2AiQgAEHwnQE2AiAgAEHwnQE2AhwLkgYCCX8EfiAAIAE2AgAgAP0MAAAAAAAAAAAAAAAAAAAAAP0LAwggACADNgIcIAAgAkEBayIFNgIYIAFBA3EhCgJ/IAJBAEwEQCABIQQgAwwBCyAAIAFBAWoiBDYCACABLQAACyEBQQghByAAQQg2AhAgACABrSINNwMIIAAgDUL/AYMiDkL/AVEiCTYCFAJAIApBA0YNACAAIAJBAmsiCDYCGAJ/IAJBAkgEQCAEIQEgAwwBCyAAIARBAWoiATYCACAELQAACyEEIABBD0EQIA5C/wFRGyIHNgIQIAAgBK0iDkL/AYMiD0L/AVEiCTYCFCAAIA5CCIYgDYQiDTcDCCAKQQJGBEAgASEEIAUhAiAIIQUMAQsgACACQQNrIgs2AhggAAJ/IAJBA0gEQCABIQYgAwwBCyAAIAFBAWoiBjYCACABLQAAC60iDkL/AYMiEEL/AVEiCTYCFCAAQQdBCCAPQv8BURsgB2oiATYCECAAIA4gB62GIA2EIg03AwggCkEBRgRAIAYhBCABIQcgCCECIAshBQwBCyAAIAJBBGsiBTYCGCAAAn8gAkEESARAIAYhBCADDAELIAAgBkEBaiIENgIAIAYtAAALrSIOQv8Bg0L/AVEiCTYCFCAAQQdBCCAQQv8BURsgAWoiBzYCECAAIA4gAa2GIA2EIg03AwggCyECCwJAIAJBBU4EQCAEKAIAIQMgACACQQVrNgIYIAAgBEEEajYCAAwBC0EAIQFBf0EAIAMbIQMgAkECSA0AA0AgACAEQQFqIgI2AgAgBC0AACEEIAAgBUEBayIGNgIYIANB/wEgAXRBf3NxIAQgAXRyIQMgAUEIaiEBIAVBAUshDCACIQQgBiEFIAwNAAsLIAAgA0EYdiIBQf8BRjYCFCAAQQdBCCAJGyICQQdBCCADQf8BcSIEQf8BRhtqIgVBB0EIIANBCHZB/wFxIgZB/wFGG2oiCEEHQQggA0EQdkH/AXEiA0H/AUYbIAdqajYCECAAIAYgAnQgAyAFdHIgASAIdHIgBHKtIAethiANhDcDCAu2BQISfwJ+An8gACgCHCABQZgBbGoiAkGQAWsoAgAgAkGYAWsoAgBrIgMhBSACQYwBaygCACACQZQBaygCAGsiAiEGQcAAIAMgA0HAAE8bIQNBwAAgAiACQcAATxshBAJAIAVFDQAgBkUNACADRQ0AIARFDQBBfyAEbkECdiADSQ0AQQFBHBATIgIgBDYCDCACIAM2AgggAiAGNgIEIAIgBTYCACACIAStIhQgBq18QgF9IBSAIhSnIgQ2AhQgAiADrSIVIAWtfEIBfSAVgCIVpyIDNgIQAkAgFEL/////D4MgFUL/////D4N+QiCIpw0AIAJBBCADIARsEBMiAzYCGCADRQ0AIAIMAgsgAhAQC0EACyIJRQRAQQAPCwJAIAEEQANAIA5BmAFsIg8gACgCHGoiBSgCGCICBEAgBUEcaiEQIAUoAhQhAyAFKAIQIQRBACEKA0AgAyAEbARAIBAgCkEkbGohBkEAIQsDQCAGKAIUIAtBKGxqIggoAhQiAiAIKAIQIgdsBEBBACEEA0AgCCgCGCAEQQZ0aiIDKAI8IhEEQCADKAIMIQcgAygCFCESIAMoAhAhDCADKAIIIhMgBigCAGshAyAGKAIQIg1BAXEEQCAAKAIcIA9qIgJBkAFrKAIAIANqIAJBmAFrKAIAayEDCyAHIAYoAgRrIQIgDUECcQRAIAIgACgCHCAPaiINQYwBaygCAGogDUGUAWsoAgBrIQILIAkgAyACIAMgDCATayIMaiASIAdrIAJqIBFBASAMQQAQJkUNCSAIKAIQIQcgCCgCFCECCyAEQQFqIgQgAiAHbEkNAAsgBSgCECEEIAUoAhQhAwsgC0EBaiILIAMgBGxJDQALIAUoAhghAgsgCkEBaiIKIAJJDQALCyAOQQFqIg4gAUcNAAsLIAkPCyAJECNBAAvQDAIQfwZ7IAAoAggiCyAAKAIEaiEHAkAgACgCDEUEQCAHQQJIDQEgASgCACABIAtBAnRqIg0oAgAiBEEBakEBdWshAyAAKAIAIQYCQCAHQQRJBEAgBCECDAELIAdBBGsiAEEBdiIJQQFqIQwCQCAAQRZJBEBBASEADAELIAYgASALQQJ0aiIFIAlBAnQiAmpBCGpJIAYgCUEDdGpBCGoiACAFQQRqS3EEQEEBIQAMAQsgBiABIAJqQQhqSSABQQRqIABJcQRAQQEhAAwBCyAMQfz///8HcSIFQQFyIQAgBUEBdCEIIAT9ESESIAP9ESET/QwAAAAAAgAAAAQAAAAGAAAAIRZBACECA0AgASACQQJ0QQRyIgNq/QACACEVIAMgDWr9AAIAIRQgBiACQQN0aiIDIBP9WgIAAyADQQhqIBUgFCASIBT9DQwNDg8QERITFBUWFxgZGhsiFf2uAf0MAgAAAAIAAAACAAAAAgAAAP2uAUEC/awB/bEBIhL9WgIAACADQRBqIBL9WgIAASADQRhqIBL9WgIAAiAGIBb9DAEAAAABAAAAAQAAAAEAAAD9UCIX/RsAQQJ0aiASIBMgEv0NDA0ODxAREhMUFRYXGBkaG/2uAUEB/awBIBX9rgEiE/1aAgAAIAYgF/0bAUECdGogE/1aAgABIAYgF/0bAkECdGogE/1aAgACIAYgF/0bA0ECdGogE/1aAgADIBb9DAgAAAAIAAAACAAAAAgAAAD9rgEhFiASIRMgFCESIAJBBGoiAiAFRw0ACyAS/RsDIQIgE/0bAyEDIAUgDEYNASACIQQLA0AgASAAQQJ0IgJqKAIAIQkgAiANaigCACECIAYgCEECdGoiBSADNgIAIAUgAyAJIAIgBGpBAmpBAnVrIgNqQQF1IARqNgIEIAhBAmohCCAAIAxHIRAgAiEEIABBAWohACAQDQALCyAGIAhBAnRqIAM2AgBBfCEAIAdBAXEEfyAGIAdBAWsiAEECdGogASAAQQF0aigCACACQQFqQQF1ayIANgIAIAAgA2pBAXUhA0F4BUF8CyAGIAdBAnQiAGpqIAIgA2o2AgAgASAGIAAQEhoPCwJAAkACQCAHQQFrDgIAAQILIAEgASgCAEECbTYCAA8LIAAoAgAiBCABKAIAIAEgC0ECdGoiAygCAEEBakEBdWsiADYCBCAEIAAgAygCAGo2AgAgASAEKQIANwIADwsgB0EDSA0AIAAoAgAiCiABKAIAIAEgC0ECdGoiDigCBCIEIA4oAgAiAGpBAmpBAnVrIgMgAGo2AgBBASEIAkAgB0ECayIGIAdBAXEiDEUiAGtBAkkEQCAEIQIMAQsgByAAa0EEayIAQQF2IgJBAWohDwJAAkAgAEEWSQ0AIApBBGoiBSABIAJBAnQiAGpBCGpJIAogAkEDdGpBDGoiAiABQQRqS3ENACAFIAAgASALQQJ0aiIAakEMakkgAEEIaiACSXENACAPQXxxIgVBAXIhACAFQQF0QQFyIQggBP0RIRMgA/0RIRJBACECA0AgCiACQQN0aiIEIAEgAkECdCIDav0AAgQgEyADIA5q/QACCCIT/Q0MDQ4PEBESExQVFhcYGRobIhUgE/2uAf0MAgAAAAIAAAACAAAAAgAAAP2uAUEC/awB/bEBIhQgFCASIBT9DQwNDg8QERITFBUWFxgZGhv9rgFBAf2sASAV/a4BIhX9DQQFBgcYGRobCAkKCxwdHh/9CwIUIAQgEiAV/Q0MDQ4PEBESEwABAgMUFRYXIBT9DQABAgMEBQYHEBESEwwNDg/9CwIEIBQhEiACQQRqIgIgBUcNAAsgE/0bAyECIBL9GwMhAyAFIA9GDQIgAiEEDAELQQEhAAsDQCABIABBAnRqKAIAIQ0gDiAAQQFqIgVBAnRqKAIAIQIgCiAIQQJ0aiIJIAM2AgAgCSADIA0gAiAEakECakECdWsiA2pBAXUgBGo2AgQgCEECaiEIIAAgD0chESACIQQgBSEAIBENAAsLIAogCEECdGogAzYCAAJAIAxFBEAgCiAGQQJ0aiABIAdBAXRqQQRrKAIAIAJBAWpBAXVrIgAgA2pBAXUgAmo2AgAMAQsgAiADaiEACyAKIAdBAnQiA2pBBGsgADYCACABIAogAxASGgsLoAcDA30DewJ/IANBCE8EQCADQQN2IQsDQCAB/QAEACEHIAAgAP0ABAAiCCAC/QAEACIJ/Qy8dLM/vHSzP7x0sz+8dLM//eYB/eQB/QsEACABIAggB/0MzzGwPs8xsD7PMbA+zzGwPv3mAf3lASAJ/Qzh0TY/4dE2P+HRNj/h0TY//eYB/eUB/QsEACACIAggB/0M5dDiP+XQ4j/l0OI/5dDiP/3mAf3kAf0LBAAgAf0ABBAhByAAIAD9AAQQIgggAv0ABBAiCf0MvHSzP7x0sz+8dLM/vHSzP/3mAf3kAf0LBBAgASAIIAf9DM8xsD7PMbA+zzGwPs8xsD795gH95QEgCf0M4dE2P+HRNj/h0TY/4dE2P/3mAf3lAf0LBBAgAiAIIAf9DOXQ4j/l0OI/5dDiP+XQ4j/95gH95AH9CwQQIAJBIGohAiABQSBqIQEgAEEgaiEAIApBAWoiCiALRw0ACwsCQCADQQdxIgNFDQAgASoCACEEIAAgAioCACIGQ7x0sz+UIAAqAgAiBZI4AgAgASAFIARDzzGwvpSSIAZD4dE2v5SSOAIAIAIgBSAEQ+XQ4j+UkjgCACADQQFGDQAgASoCBCEEIAAgAioCBCIGQ7x0sz+UIAAqAgQiBZI4AgQgASAFIARDzzGwvpSSIAZD4dE2v5SSOAIEIAIgBSAEQ+XQ4j+UkjgCBCADQQJGDQAgASoCCCEEIAAgAioCCCIGQ7x0sz+UIAAqAggiBZI4AgggASAFIARDzzGwvpSSIAZD4dE2v5SSOAIIIAIgBSAEQ+XQ4j+UkjgCCCADQQNGDQAgASoCDCEEIAAgAioCDCIGQ7x0sz+UIAAqAgwiBZI4AgwgASAFIARDzzGwvpSSIAZD4dE2v5SSOAIMIAIgBSAEQ+XQ4j+UkjgCDCADQQRGDQAgASoCECEEIAAgAioCECIGQ7x0sz+UIAAqAhAiBZI4AhAgASAFIARDzzGwvpSSIAZD4dE2v5SSOAIQIAIgBSAEQ+XQ4j+UkjgCECADQQVGDQAgASoCFCEEIAAgAioCFCIGQ7x0sz+UIAAqAhQiBZI4AhQgASAFIARDzzGwvpSSIAZD4dE2v5SSOAIUIAIgBSAEQ+XQ4j+UkjgCFCADQQZGDQAgASoCGCEEIAAgAioCGCIGQ7x0sz+UIAAqAhgiBZI4AhggASAFIARDzzGwvpSSIAZD4dE2v5SSOAIYIAIgBSAEQ+XQ4j+UkjgCGAsL4AECBn8DewJAIANFDQAgA0EETwRAIANBfHEhBgNAIAAgBEECdCIFaiIHIAf9AAIAIAIgBWoiB/0AAgAiCyABIAVqIgX9AAIAIgz9rgFBAv2sAf2xASIKIAv9rgH9CwIAIAUgCv0LAgAgByAKIAz9rgH9CwIAIARBBGoiBCAGRw0ACyADIAZGDQELA0AgACAGQQJ0IgRqIgUgBSgCACACIARqIgUoAgAiByABIARqIggoAgAiCWpBAnVrIgQgB2o2AgAgCCAENgIAIAUgBCAJajYCACAGQQFqIgYgA0cNAAsLC90BAQR/IwBBgAFrIgYkACAGIQUCQCABKAIMIAJBBHRqIgIoAgAiBEUEQCACIQEMAQsDQCAFIAI2AgAgBUEEaiEFIAQiASICKAIAIgQNAAsLQQAhBANAIAEoAggiAiAESARAIAEgBDYCCCAEIQILAkAgAiADTg0AA0AgAiABKAIETg0BAkAgAEEBEB8EQCABIAI2AgQMAQsgAkEBaiECCyACIANIDQALCyABIAI2AgggBSAGRwRAIAVBBGsiBSgCACEBIAIhBAwBCwsgASgCBCEHIAZBgAFqJAAgByADSAv9BgELfyMAQYACayIKJAACQCAARQRAQQAhAAwBCwJAIAEgACgCAEYEQCAAKAIEIAJGDQELIAAgAjYCBCAAIAE2AgAgCiACNgIAIAogATYCgAEgAiEEIAEhBQNAIAogByIMQQFqIgdBAnQiCGogBEEBakECbSIJNgIAIApBgAFqIAhqIAVBAWpBAm0iCDYCACAGIAQgBWwiC2ohBiAJIQQgCCEFIAtBAUsNAAsgACAGNgIIAkACQAJAAkAgBkUEQCAAKAIMIgRFDQIgAEEMaiEFDAELIAZBBHQiBCAAKAIQTQ0DIAAoAgwgBBAXIgENAiADQQFBmjFBABAPIABBDGoiBSgCACIERQ0BCyAEEBAgBUEANgIACyAAEBBBACEADAMLIAAgATYCDCABIAAoAhAiAmpBACAEIAJrEBUaIAAgBDYCECAAKAIEIQIgACgCACEBCyAAKAIMIQUgDARAQQAhAyAFIAEgAmxBBHRqIgQhBgNAAkAgCiADQQJ0IgFqKAIAIghBAEwNACAIQQFrIQtBACEJAkACQCAKQYABaiABaigCACICQQBMBEAgCEEBcSENQQAhByAIQQFHDQEgBiEBDAILA0AgBiEBIAIhBgNAAkAgBSAENgIAIAZBAUYEQCAFQRBqIQUgBEEQaiEEDAELIAUgBDYCECAEQRBqIQQgBUEgaiEFIAZBAkohDiAGQQJrIQYgDg0BCwsgBCABIAJBBHRqIAkgCSALRnJBAXEiBxshBiAEIAEgBxshBCAJQQFqIgkgCEcNAAsMAgsgCEH+////B3EhCANAIAcgC0YhASAHQQJqIQcgBCAGIAEbIgQhBiAEIQEgCUECaiIJIAhHDQALCyANRQRAIAQhBgwBCyAEIAEgAkEEdGogByAHIAtGckEBcSICGyEGIAQgASACGyEECyADQQFqIgMgDEcNAAsLIAVBADYCAAsgACgCCCIBRQ0AIAAoAgwhBCABQQRPBEAgAUF8cSECQQAhBQNAIARBADYCPCAEQucHNwI0IARBADYCLCAEQucHNwIkIARBADYCHCAEQucHNwIUIARBADYCDCAEQucHNwIEIARBQGshBCAFQQRqIgUgAkcNAAsLIAFBA3EiAUUNAEEAIQUDQCAEQQA2AgwgBELnBzcCBCAEQRBqIQQgBUEBaiIFIAFHDQALCyAKQYACaiQAIAALsQEBA38CQCAARQ0AIAAoAggiAUUNACAAKAIMIQAgAUEETwRAIAFBfHEhAwNAIABBADYCPCAAQucHNwI0IABBADYCLCAAQucHNwIkIABBADYCHCAAQucHNwIUIABBADYCDCAAQucHNwIEIABBQGshACACQQRqIgIgA0cNAAsLIAFBA3EiAUUNAEEAIQIDQCAAQQA2AgwgAELnBzcCBCAAQRBqIQAgAkEBaiICIAFHDQALCwv7BQEQfyMAQYACayIIJAACf0EBQRQQEyIGRQRAIAJBAUH0MEEAEA9BAAwBCyAGIAE2AgQgBiAANgIAIAggATYCACAIIAA2AoABA0AgCCAFIg1BAWoiBUECdCIHaiABQQFqQQJtIgM2AgAgCEGAAWogB2ogAEEBakECbSIHNgIAIAQgACABbCIJaiEEIAMhASAHIQAgCUEBSw0ACyAGIAQ2AgggBEUEQCAGEBBBAAwBCyAGIARBEBATIgM2AgwgA0UEQCACQQFB2hpBABAPIAYQEEEADAELIAYgBigCCCILQQR0NgIQIAMhACANBEAgAyAGKAIEIAYoAgBsQQR0aiIEIQEDQAJAIAggDkECdCICaigCACIJQQBMDQAgCUEBayEMQQAhBwJAIAhBgAFqIAJqKAIAIgJBAEwEQEEAIQUgCUEBRwRAIAlB/v///wdxIQoDQCAFIAxGIQ8gBUECaiEFIAEgBCAPGyIEIQEgB0ECaiIHIApHDQALCyAJQQFxDQEgBCEBDAILA0AgBCEFIAIhBANAAkAgACABNgIAIARBAUYEQCAAQRBqIQAgAUEQaiEBDAELIAAgATYCECABQRBqIQEgAEEgaiEAIARBAkohECAEQQJrIQQgEA0BCwsgASAFIAJBBHRqIAcgByAMRnJBAXEiChshBCABIAUgChshASAHQQFqIgcgCUcNAAsMAQsgASAEIAJBBHRqIAUgBSAMRnJBAXEiBRshESABIAQgBRshASARIQQLIA5BAWoiDiANRw0ACwsgAEEANgIAAkAgC0UNACALQQRPBEAgC0F8cSEAQQAhAQNAIANBADYCPCADQucHNwI0IANBADYCLCADQucHNwIkIANBADYCHCADQucHNwIUIANBADYCDCADQucHNwIEIANBQGshAyABQQRqIgEgAEcNAAsLIAtBA3EiAEUNAEEAIQEDQCADQQA2AgwgA0LnBzcCBCADQRBqIQMgAUEBaiIBIABHDQALCyAGCyESIAhBgAJqJAAgEgtTAQF/An8gAC0ADEH/AUYEQCAAQoD+g4DwADcCDEEAIAAoAggiASAAKAIETw0BGiAAIAFBAWo2AgggACABLQAAQYD+A3I2AgwLIABBADYCEEEBCwt+AgF/AX4gAL0iA0I0iKdB/w9xIgJB/w9HBHwgAkUEQCABIABEAAAAAAAAAABhBH9BAAUgAEQAAAAAAADwQ6IgARBlIQAgASgCAEFAags2AgAgAA8LIAEgAkH+B2s2AgAgA0L/////////h4B/g0KAgICAgICA8D+EvwUgAAsLSQEBfwJAQQFBLBATIgEEQCABQQA2AhACQCAAQQBMBEAgAUEBQQgQEyIANgIkIABFDQEMAwsgAUEANgIMCyABEBALQQAhAQsgAQuRAgAgAEUEQEEADwsCfwJAIAFB/wBNDQACQEGU0AEoAgAoAgBFBEAgAUGAf3FBgL8DRg0CDAELIAFB/w9NBEAgACABQT9xQYABcjoAASAAIAFBBnZBwAFyOgAAQQIMAwsgAUGAQHFBgMADRyABQYCwA09xRQRAIAAgAUE/cUGAAXI6AAIgACABQQx2QeABcjoAACAAIAFBBnZBP3FBgAFyOgABQQMMAwsgAUGAgARrQf//P00EQCAAIAFBP3FBgAFyOgADIAAgAUESdkHwAXI6AAAgACABQQZ2QT9xQYABcjoAAiAAIAFBDHZBP3FBgAFyOgABQQQMAwsLQZTHAUEZNgIAQX8MAQsgACABOgAAQQELC7wCAAJAAkACQAJAAkACQAJAAkACQAJAAkAgAUEJaw4SAAgJCggJAQIDBAoJCgoICQUGBwsgAiACKAIAIgFBBGo2AgAgACABKAIANgIADwsgAiACKAIAIgFBBGo2AgAgACABMgEANwMADwsgAiACKAIAIgFBBGo2AgAgACABMwEANwMADwsgAiACKAIAIgFBBGo2AgAgACABMAAANwMADwsgAiACKAIAIgFBBGo2AgAgACABMQAANwMADwsgAiACKAIAQQdqQXhxIgFBCGo2AgAgACABKwMAOQMADwsgACACIAMRAwALDwsgAiACKAIAIgFBBGo2AgAgACABNAIANwMADwsgAiACKAIAIgFBBGo2AgAgACABNQIANwMADwsgAiACKAIAQQdqQXhxIgFBCGo2AgAgACABKQMANwMAC3MBBn8gACgCACIDLAAAQTBrIgFBCUsEQEEADwsDQEF/IQQgAkHMmbPmAE0EQEF/IAEgAkEKbCIFaiABIAVB/////wdzSxshBAsgACADQQFqIgU2AgAgAywAASEGIAQhAiAFIQMgBkEwayIBQQpJDQALIAILtBQCFX8BfiMAQUBqIggkACAIIAE2AjwgCEEnaiEWIAhBKGohEQJAAkACQAJAA0BBACEHA0AgASENIAcgDkH/////B3NKDQIgByAOaiEOAkACQAJAAkAgASIHLQAAIgsEQANAAkACQCALQf8BcSIBRQRAIAchAQwBCyABQSVHDQEgByELA0AgCy0AAUElRwRAIAshAQwCCyAHQQFqIQcgCy0AAiEZIAtBAmoiASELIBlBJUYNAAsLIAcgDWsiByAOQf////8HcyIXSg0JIAAEQCAAIA0gBxAZCyAHDQcgCCABNgI8IAFBAWohB0F/IRACQCABLAABQTBrIglBCUsNACABLQACQSRHDQAgAUEDaiEHQQEhEiAJIRALIAggBzYCPEEAIQwCQCAHLAAAIgtBIGsiAUEfSwRAIAchCQwBCyAHIQlBASABdCIBQYnRBHFFDQADQCAIIAdBAWoiCTYCPCABIAxyIQwgBywAASILQSBrIgFBIE8NASAJIQdBASABdCIBQYnRBHENAAsLAkAgC0EqRgRAAn8CQCAJLAABQTBrIgFBCUsNACAJLQACQSRHDQACfyAARQRAIAQgAUECdGpBCjYCAEEADAELIAMgAUEDdGooAgALIQ8gCUEDaiEBQQEMAQsgEg0GIAlBAWohASAARQRAIAggATYCPEEAIRJBACEPDAMLIAIgAigCACIHQQRqNgIAIAcoAgAhD0EACyESIAggATYCPCAPQQBODQFBACAPayEPIAxBgMAAciEMDAELIAhBPGoQaSIPQQBIDQogCCgCPCEBC0EAIQdBfyEKAn9BACABLQAAQS5HDQAaIAEtAAFBKkYEQAJ/AkAgASwAAkEwayIJQQlLDQAgAS0AA0EkRw0AIAFBBGohAQJ/IABFBEAgBCAJQQJ0akEKNgIAQQAMAQsgAyAJQQN0aigCAAsMAQsgEg0GIAFBAmohAUEAIABFDQAaIAIgAigCACIJQQRqNgIAIAkoAgALIQogCCABNgI8IApBAE4MAQsgCCABQQFqNgI8IAhBPGoQaSEKIAgoAjwhAUEBCyETA0AgByEUQRwhCSABIhgsAAAiB0H7AGtBRkkNCyABQQFqIQEgByAUQTpsakG/wAFqLQAAIgdBAWtBCEkNAAsgCCABNgI8AkAgB0EbRwRAIAdFDQwgEEEATgRAIABFBEAgBCAQQQJ0aiAHNgIADAwLIAggAyAQQQN0aikDADcDMAwCCyAARQ0IIAhBMGogByACIAYQaAwBCyAQQQBODQtBACEHIABFDQgLIAAtAABBIHENCyAMQf//e3EiCyAMIAxBgMAAcRshDEEAIRBBsAghFSARIQkCQAJAAn8CQAJAAkACQAJAAkACfwJAAkACQAJAAkACQAJAIBgsAAAiB0FTcSAHIAdBD3FBA0YbIAcgFBsiB0HYAGsOIQQWFhYWFhYWFhAWCQYQEBAWBhYWFhYCBQMWFgoWARYWBAALAkAgB0HBAGsOBxAWCxYQEBAACyAHQdMARg0LDBULIAgpAzAhHEGwCAwFC0EAIQcCQAJAAkACQAJAAkACQCAUQf8BcQ4IAAECAwQcBQYcCyAIKAIwIA42AgAMGwsgCCgCMCAONgIADBoLIAgoAjAgDqw3AwAMGQsgCCgCMCAOOwEADBgLIAgoAjAgDjoAAAwXCyAIKAIwIA42AgAMFgsgCCgCMCAOrDcDAAwVC0EIIAogCkEITRshCiAMQQhyIQxB+AAhBwsgESEBIAgpAzAiHEIAUgRAIAdBIHEhDQNAIAFBAWsiASAcp0EPcUHQxAFqLQAAIA1yOgAAIBxCD1YhGiAcQgSIIRwgGg0ACwsgASENIAgpAzBQDQMgDEEIcUUNAyAHQQR2QbAIaiEVQQIhEAwDCyARIQEgCCkDMCIcQgBSBEADQCABQQFrIgEgHKdBB3FBMHI6AAAgHEIHViEbIBxCA4ghHCAbDQALCyABIQ0gDEEIcUUNAiAKIBEgAWsiAUEBaiABIApIGyEKDAILIAgpAzAiHEIAUwRAIAhCACAcfSIcNwMwQQEhEEGwCAwBCyAMQYAQcQRAQQEhEEGxCAwBC0GyCEGwCCAMQQFxIhAbCyEVIBwgERAqIQ0LIBMgCkEASHENESAMQf//e3EgDCATGyEMAkAgCCkDMCIcQgBSDQAgCg0AIBEhDUEAIQoMDgsgCiAcUCARIA1raiIBIAEgCkgbIQoMDQsgCCkDMCEcDAsLAn9B/////wcgCiAKQf////8HTxsiDCIHQQBHIQkCQAJAAkAgCCgCMCIBQYQMIAEbIg0iAUEDcUUNACAHRQ0AA0AgAS0AAEUNAiAHQQFrIgdBAEchCSABQQFqIgFBA3FFDQEgBw0ACwsgCUUNAQJAIAEtAABFDQAgB0EESQ0AA0BBgIKECCABKAIAIglrIAlyQYCBgoR4cUGAgYKEeEcNAiABQQRqIQEgB0EEayIHQQNLDQALCyAHRQ0BCwNAIAEgAS0AAEUNAhogAUEBaiEBIAdBAWsiBw0ACwtBAAsiASANayAMIAEbIgEgDWohCSAKQQBOBEAgCyEMIAEhCgwMCyALIQwgASEKIAktAAANDwwLCyAIKQMwIhxCAFINAUIAIRwMCQsgCgRAIAgoAjAMAgtBACEHIABBICAPQQAgDBAcDAILIAhBADYCDCAIIBw+AgggCCAIQQhqIgc2AjBBfyEKIAcLIQtBACEHA0ACQCALKAIAIg1FDQAgCEEEaiANEGciDUEASA0PIA0gCiAHa0sNACALQQRqIQsgByANaiIHIApJDQELC0E9IQkgB0EASA0MIABBICAPIAcgDBAcIAdFBEBBACEHDAELQQAhCSAIKAIwIQsDQCALKAIAIg1FDQEgCEEEaiIKIA0QZyINIAlqIgkgB0sNASAAIAogDRAZIAtBBGohCyAHIAlLDQALCyAAQSAgDyAHIAxBgMAAcxAcIA8gByAHIA9IGyEHDAgLIBMgCkEASHENCUE9IQkgACAIKwMwIA8gCiAMIAcgBRETACIHQQBODQcMCgsgBy0AASELIAdBAWohBwwACwALIAANCSASRQ0DQQEhBwNAIAQgB0ECdGooAgAiAARAIAMgB0EDdGogACACIAYQaEEBIQ4gB0EBaiIHQQpHDQEMCwsLQQEhDiAHQQpPDQkDQCAEIAdBAnRqKAIADQEgB0EBaiIHQQpHDQALDAkLQRwhCQwGCyAIIBw8ACdBASEKIBYhDSALIQwLIAogCSANayILIAogC0obIgogEEH/////B3NKDQNBPSEJIA8gCiAQaiIBIAEgD0gbIgcgF0oNBCAAQSAgByABIAwQHCAAIBUgEBAZIABBMCAHIAEgDEGAgARzEBwgAEEwIAogC0EAEBwgACANIAsQGSAAQSAgByABIAxBgMAAcxAcIAgoAjwhAQwBCwsLQQAhDgwDC0E9IQkLQZTHASAJNgIAC0F/IQ4LIAhBQGskACAOC6gCAQR/IwBB0AFrIgUkACAFIAI2AswBIAVBoAFqIgJBAEEoEBUaIAUgBSgCzAE2AsgBAkBBACABIAVByAFqIAVB0ABqIAIgAyAEEGpBAEgNACAAKAJMQQBIIQggACAAKAIAIgdBX3E2AgACfwJAAkAgACgCMEUEQCAAQdAANgIwIABBADYCHCAAQgA3AxAgACgCLCEGIAAgBTYCLAwBCyAAKAIQDQELQX8gABA+DQEaCyAAIAEgBUHIAWogBUHQAGogBUGgAWogAyAEEGoLIQEgBgR/IABBAEEAIAAoAiQRAAAaIABBADYCMCAAIAY2AiwgAEEANgIcIAAoAhQaIABCADcDEEEABSABCxogACAAKAIAIAdBIHFyNgIAIAgNAAsgBUHQAWokAAsnAQF/QRwhAyABQQNxBH9BHAUgACABIAIQJSIANgIAQQBBMCAAGwsL/QMBBX8Cf0HgxAEoAgAiAiAAQQdqQXhxIgFBB2pBeHEiA2ohAAJAIANBACAAIAJNG0UEQCAAPwBBEHRNDQEgABAKDQELQZTHAUEwNgIAQX8MAQtB4MQBIAA2AgAgAgsiAkF/RwRAIAEgAmoiAEEEa0EQNgIAIABBEGsiA0EQNgIAAkACf0GgzwEoAgAiAQR/IAEoAggFQQALIAJGBEAgAiACQQRrKAIAQX5xayIEQQRrKAIAIQUgASAANgIIIAQgBUF+cWsiACAAKAIAakEEay0AAEEBcQRAIAAoAgQiASAAKAIIIgQ2AgggBCABNgIEIAAgAyAAayIBNgIADAMLIAJBEGsMAQsgAkEQNgIAIAIgADYCCCACIAE2AgQgAkEQNgIMQaDPASACNgIAIAJBEGoLIgAgAyAAayIBNgIACyAAIAFBfHFqQQRrIAFBAXI2AgAgAAJ/IAAoAgBBCGsiAUH/AE0EQCABQQN2QQFrDAELIAFBHSABZyIDa3ZBBHMgA0ECdGtB7gBqIAFB/x9NDQAaQT8gAUEeIANrdkECcyADQQF0a0HHAGoiASABQT9PGwsiAUEEdCIDQaDHAWo2AgQgACADQajHAWoiAygCADYCCCADIAA2AgAgACgCCCAANgIEQajPAUGozwEpAwBCASABrYaENwMACyACQX9HC70BAQJ/AkAgACgCTCIBQQBOBEAgAUUNAUHMzwEoAgAgAUH/////A3FHDQELAkAgACgCUEEKRg0AIAAoAhQiASAAKAIQRg0AIAAgAUEBajYCFCABQQo6AAAPCyAAEG8PCyAAQcwAaiIBIAEoAgAiAkH/////AyACGzYCAAJAAkAgACgCUEEKRg0AIAAoAhQiAiAAKAIQRg0AIAAgAkEBajYCFCACQQo6AAAMAQsgABBvCyABKAIAGiABQQA2AgALfAECfyMAQRBrIgEkACABQQo6AA8CQAJAIAAoAhAiAgR/IAIFIAAQPg0CIAAoAhALIAAoAhQiAkYNACAAKAJQQQpGDQAgACACQQFqNgIUIAJBCjoAAAwBCyAAIAFBD2pBASAAKAIkEQAAQQFHDQAgAS0ADxoLIAFBEGokAAuwAgECfyAABEAgACgCABA4IABBADYCACAAKAJIIgEEQCABEBAgAEEANgJICyAAKAJEIgEEQCABEBAgAEEANgJECyAAKAJsIgEEQCABEBAgAEEANgJsCyAAKAJ0IgEEQCABKAIAIgIEQCACEBAgACgCdCIBQQA2AgALIAEQECAAQQA2AnQLIAAoAngiAQRAIAEoAgwiAgRAIAIQECAAKAJ4IgFBADYCDAsgASgCBCICBEAgAhAQIAAoAngiAUEANgIECyABKAIIIgIEQCACEBAgACgCeCIBQQA2AggLIAEoAgAiAgRAIAIQECAAKAJ4IgFBADYCAAsgARAQIABBADYCeAsgACgCBCIBBEAgARAyIABBADYCBAsgACgCCCIBBEAgARAyIABBADYCCAsgABAQCwuLGwIefwV7IwBB8AFrIgkkAEEBIQ4CQCAAKAIAKAI8DQAgACgCgAENAAJAAkAgACgCdCIIRQRAIAAoAnghBAwBCyABKAIQIQMgCC8BBCEGAkAgACgCeCIERQ0AIAQoAgxFDQAgBC0AEiEDCwJAIAYEQCAIKAIAIQgDQCAIIAVBBmxqIgovAQAiByADTwRAIAkgAzYCtAEgCSAHNgKwASACQQFBoOYAIAlBsAFqEA9BACEODAYLAkAgCi8BBCIKRQ0AIApB//8DRg0AIApBAWsiCiADSQ0AIAkgAzYCpAEgCSAKNgKgASACQQFBoOYAIAlBoAFqEA9BACEODAYLIAVBAWoiBSAGRw0ACwwBCyADDQIMAQsDQCADQQFrIQNBACEFA0AgCCAFQQZsai8BACADRwRAIAVBAWoiBSAGRw0BDAQLCyADDQALCwJAIARFDQAgBCgCDCIKRQ0AAkACQCAELQASIggEQEEAIQVBASEHA0AgASgCECIDIAogBUECdGovAQAiBE0EQCAJIAM2ApQBIAkgBDYCkAEgAkEBQaDmACAJQZABahAPQQAhBwsgBUEBaiIFIAhHDQALIAhBBBATIgNFDQFBACEFA0ACQCAKIAVBAnRqIgQtAAIiBkECTwRAIAkgBjYCRCAJIAU2AkAgAkEBQcvZACAJQUBrEA9BACEHDAELIAggBC0AAyIETQRAIAkgBDYCgAEgAkEBQZPZACAJQYABahAPQQAhBwwBCyADIARBAnRqIQsCQCAGQQFHIgwNACALKAIARQ0AIAkgBDYCUCACQQFBvNUAIAlB0ABqEA9BACEHDAELAkAgBg0AIARFDQAgCSAENgJkIAkgBTYCYCACQQFBitgAIAlB4ABqEA9BACEHDAELAkAgDA0AIAQgBUYNACAJIAQ2AnggCSAFNgJ0IAkgBTYCcCACQQFBrtgAIAlB8ABqEA9BACEHDAELIAtBATYCAAsgBUEBaiIFIAhHDQALQQAhBQNAAkACQCADIAVBAnQiBGooAgBFBEAgBCAKai0AAg0BCyAFQQFqIgUgCEcNAiAHRQ0BIAEoAhBBAUcNBUEAIQUDQCADIAVBAnRqKAIABEAgCCAFQQFqIgVHDQEMBwsLQQAhByACQQJB7sUAQQAQDyAIQRBPBEAgCEHwAXEhB0EAIQQDQCAKIARBAnRqIgZBAToAAiAGIAQ6AAMgBkEBOgA+IAZBAToAOiAGQQE6ADYgBkEBOgAyIAZBAToALiAGQQE6ACogBkEBOgAmIAZBAToAIiAGQQE6AB4gBkEBOgAaIAZBAToAFiAGQQE6ABIgBkEBOgAOIAZBAToACiAGQQE6AAYgBiAEQQFyOgAHIAYgBEEPcjoAPyAGIARBDnI6ADsgBiAEQQ1yOgA3IAYgBEEMcjoAMyAGIARBC3I6AC8gBiAEQQpyOgArIAYgBEEJcjoAJyAGIARBCHI6ACMgBiAEQQdyOgAfIAYgBEEGcjoAGyAGIARBBXI6ABcgBiAEQQRyOgATIAYgBEEDcjoADyAGIARBAnI6AAsgBEEQaiIEIAdHDQALIAcgCEYNBgsDQCAKIAdBAnRqIgQgBzoAAyAEQQE6AAIgB0EBaiIHIAhHDQALDAULIAkgBTYCMCACQQFByNIAIAlBMGoQD0EAIQcgBUEBaiIFIAhHDQELCyADEBBBACEODAULIAhBBBATIgMNAQtBACEOIAJBAUGK2wBBABAPDAMLIAMQEAsCQCAAKAJ4IgNFDQAgAygCDCIPRQRAIAMoAgQQECAAKAJ4KAIIEBAgACgCeCgCABAQIAAoAngiAygCDCIEBH8gBBAQIAAoAngFIAMLEBAgAEEANgJ4DAELIAEoAhghDQJAAkAgAy0AEiIKBEAgAygCACEUIAMoAgQhBiADKAIIIQhBACEFAkADQCANIA8gBUECdGovAQBBNGxqKAIsBEAgCiAFQQFqIgVHDQEMAgsLIAkgBTYCICACQQFBwucAIAlBIGoQD0EAIQ4MBgsgCkE0bBAUIgtFDQFBACEFA0AgDyAFQQJ0aiIDLwEAIQcgCyADLQACBH8gAy0AAwUgBQtBNGxqIgQgDSAHQTRsaiID/QACAP0LAgAgBCADKAIwNgIwIAQgA/0AAiD9CwIgIAQgA/0AAhD9CwIQIAsgBUE0bGoiBCADKAIIIAMoAgxsQQJ0EBgiAzYCLCADRQRAIAUEQCAFQf//A3EhAANAIABBNGwgC2pBCGsoAgAQECAAQQFrIgANAAsLIAsQEEEAIQ4gAkEBQY7nAEEAEA8MBwsgBCAFIAhqLQAANgIYIAQgBSAGai0AADYCICAFQQFqIgUgCkcNAAsgACgCeC8BECIQQQFrIRIDQCALIBNBNGxqIgMoAgwgAygCCGwhBiANIA8gE0ECdGoiBC8BAEE0bGooAiwhCAJAIAQtAAJFBEAgBkUNASADKAIsIQVBACEHQQAhBAJAIAZBBEkNACAFIAhrQRBJDQAgBkF8cSEEQQAhAwNAIAUgA0ECdCIMaiAIIAxq/QACAP0LAgAgA0EEaiIDIARHDQALIAQgBkYNAgsgBCEDIAZBA3EiDARAA0AgBSADQQJ0IhFqIAggEWooAgA2AgAgA0EBaiEDIAdBAWoiByAMRw0ACwsgBCAGa0F8Sw0BA0AgBSADQQJ0IgRqIAQgCGooAgA2AgAgBSAEQQRqIgdqIAcgCGooAgA2AgAgBSAEQQhqIgdqIAcgCGooAgA2AgAgBSAEQQxqIgRqIAQgCGooAgA2AgAgA0EEaiIDIAZHDQALDAELIAZFDQAgFCAELQADIgNBAnRqIQQgCyADQTRsaigCLCEFQQAhAyAGQQFHBEAgBkF+cSEVQQAhDANAIAUgA0ECdCIHaiAEIAcgCGooAgAiESASIBAgEUobQQAgEUEAThsgCmxBAnRqKAIANgIAIAUgB0EEciIHaiAEIAcgCGooAgAiByASIAcgEEgbQQAgB0EAThsgCmxBAnRqKAIANgIAIANBAmohAyAMQQJqIgwgFUcNAAsLIAZBAXFFDQAgBSADQQJ0IgNqIAQgAyAIaigCACIDIBIgAyAQSBtBACADQQBOGyAKbEECdGooAgA2AgALIBNBAWoiEyAKRw0ACwwCCyAKQTRsEBQiCw0BC0EAIQ4gAkEBQY7nAEEAEA8MAwsgASgCECIDBEBBACEFA0AgDSAFQTRsaigCLCIEBEAgBBAQCyAFQQFqIgUgA0cNAAsLIA0QECABIAo2AhAgASALNgIYCyAAKAJ0IgVFDQEgBSgCACEHIAUvAQQiCwRAIAdBKmohEiAHQSRqIRMgB0EeaiERIAdBGGohFCAHQRJqIRUgB0EMaiEWIAdBBmohFyALQQJrIRhBACEFQQEhBANAAkAgASgCECIDIAcgBUEGbGoiDS8BACIGTQRAIAkgAzYCFCAJIAY2AhAgAkECQcw3IAlBEGoQDwwBCyANLwEEIghBAWpB//8DcUEBTQRAIAEoAhggBkE0bGogDS8BAjsBMAwBCyAIQQFrIgpB//8DcSIPIANPBEAgCSADNgIEIAkgDzYCACACQQJBozcgCRAPDAELAkAgBiAPRg0AIA0vAQINACAJIAEoAhgiCCAGQTRsaiIDKAIwNgLoASAJIAP9AAIg/QsD2AEgCSAD/QACEP0LA8gBIAkgA/0AAgD9CwO4ASADIAggD0E0bCIMaiIIKQIINwIIIAMgCCkCEDcCECADIAgpAhg3AhggAyAIKQIgNwIgIAMgCCkCKDcCKCADIAgoAjA2AjAgAyAIKQIANwIAIAEoAhggDGoiAyAJ/QADuAH9CwIAIAMgCf0AA9gB/QsCICADIAn9AAPIAf0LAhAgAyAJKALoATYCMCAFQQFqIAtPDQAgBCEIIBggBWtB//8DcSIDQQdPBEAgBCADQQFqIhlB+P8HcSIQaiEIIAr9ECEkIAb9ECEjQQAhDANAICMgJCASIAQgDGpBBmwiA2oiGiADIBNqIhsgAyARaiIcIAMgFGoiHSADIBVqIh4gAyAWaiIfIAMgF2oiICADIAdqIgP9CAEA/VUBAAH9VQEAAv1VAQAD/VUBAAT9VQEABf1VAQAG/VUBAAciISAj/S4gISAk/S0iJf1O/VIhIiAhICP9LSAl/VAiIf0ZAEEBcQRAIAMgIv1ZAQAACyAh/RkBQQFxBEAgICAi/VkBAAELICH9GQJBAXEEQCAfICL9WQEAAgsgIf0ZA0EBcQRAIB4gIv1ZAQADCyAh/RkEQQFxBEAgHSAi/VkBAAQLICH9GQVBAXEEQCAcICL9WQEABQsgIf0ZBkEBcQRAIBsgIv1ZAQAGCyAh/RkHQQFxBEAgGiAi/VkBAAcLIAxBCGoiDCAQRw0ACyAQIBlGDQELA0AgCiEDAkAgBiAHIAhBBmxqIgwvAQAiEEcEQCAGIQMgDyAQRw0BCyAMIAM7AQALIAsgCEEBaiIIQf//A3FHDQALCyABKAIYIAZBNGxqIA0vAQI7ATALIARBAWohBCAFQQFqIgUgC0cNAAsgACgCdCIFKAIAIQcLIAcEfyAHEBAgACgCdAUgBQsQECAAQQA2AnQMAQtBACEOIAJBAUGhxgBBABAPCyAJQfABaiQAIA4L6QEBBn8jAEEgayIEJAACfwJAIAAoAjwiAwRAQQEhBQNAIAAoAkwoAhggACgCQCACQQJ0aigCACIGQTRsaigCLEUEQCAEIAY2AhAgAUECQdo5IARBEGoQD0EAIQUgACgCPCEDCyACQQFqIgIgA0kNAAsMAQtBASEFQQEgACgCTCIDKAIQRQ0BGgNAIAMoAhggAkE0bGooAixFBEAgBCACNgIAIAFBAkHaOSAEEA9BACEFIAAoAkwhAwsgAkEBaiICIAMoAhBJDQALC0EBIAUNABogAUEBQb8VQQAQD0EACyEHIARBIGokACAHCwQAQX8LhgcCFn8CfiAAKAIYIhAoAhBFBEBBAQ8LIBAoAhghDSAAKAIUKAIAKAIUIQsDQCABIA0oAiQiAjYCJCALKAIcIgYgAkGYAWxqIQMCQAJAAn8gACgCQCIRBEAgBiALKAIYQZgBbGoiAkGQAWsoAgAgAkGYAWsoAgBrIQwgA0EMaiEGIANBBGohBCADKAIIIQIgAygCACEFQSQMAQsgA0GUAWohBiADQYwBaiEEIAMoApABIgIgAygCiAEiBWshDEE0CyALaigCACISRQ0AIAQoAgAhByAGKAIAIQkgAiAFayEGIAEoAggiA0J/IAE1AigiGIZCf4UiGSABNQIQfCAYiKciCGohBAJ/IAUgCEsEQCAFIAhrIQ5BACEIQQAgAiAETQ0BGiAGIAQgBWsiBmsMAQsgCCAFayEIIAIgBE0EQCAGIAhrIQZBACEOQQAMAQtBACEOIAMhBiACIARrCyEVIAkgB2shAiABKAIMIgQgGSABNQIUfCAYiKciCmohBQJ/IAcgCksEQCAHIAprIQ9BACEKQQAgBSAJTw0BGiACIAUgB2siAmsMAQsgCiAHayEKIAUgCU8EQCACIAprIQJBACEPQQAMAQtBACEPIAQhAiAJIAVrCyEHQQAhBSAIQQBIDQEgCkEASA0BIBVBAEgNASAHQQBIDQEgBkEASA0BIAJBAEgNASADIA9sIA5qIQcgCiAMbCAIaiEJAkACQAJAIAEoAiwiCA0AIAkNACAHDQAgAyAMRw0AIAMgBkcNACACIARHDQEgASALQSRBNCARG2oiAigCADYCLCACQQA2AgAMAwsgCA0BCyAERQ0CIAStIAOtfkIgiKcNAiADIARsIgNB/////wNLDQIgASADQQJ0EBgiAzYCLCADRQ0CIAYgASgCCCIERiABKAIMIgUgAkZxDQAgA0EAIAQgBWxBAnQQFRoLIAJFDQAgAkEBcSEXIAZBAnQhBiABKAIsIAdBAnRqIQQgEiAJQQJ0aiEFIAJBAUcEQCACQf7///8HcSEHQQAhAgNAIAQgBSAGEBIhFiAFIAxBAnQiCWoiCCAJaiEFIBYgASgCCEECdGogCCAGEBIgASgCCEECdGohBCACQQJqIgIgB0cNAAsLIBdFDQAgBCAFIAYQEhoLIAtBzABqIQsgDUE0aiENIAFBNGohAUEBIQUgFEEBaiIUIBAoAhBJDQELCyAFC9USAgl/DH4jAEGgAWsiBSQAAkAgAkEjTQRAQQAhAiADQQFBti5BABAPDAELIAJBJGsiAiACQQNuIglBA2xHBEBBACECIANBAUG2LkEAEA8MAQsgACgCSCEGIAEgBUGcAWoiAkECEBEgACAFKAKcATsBUCABQQJqIAZBCGpBBBARIAFBBmogBkEMakEEEBEgAUEKaiAGQQQQESABQQ5qIAZBBGpBBBARIAFBEmogAEHcAGpBBBARIAFBFmogAEHgAGpBBBARIAFBGmogAEHUAGpBBBARIAFBHmogAEHYAGpBBBARIAFBImogAkECEBECQAJAAkAgBSgCnAEiAkGAgAFNBEAgBiACNgIQIAIgCUcEQCAFIAk2AoQBIAUgAjYCgAEgA0EBQZHwACAFQYABahAPQQAhAgwFCyAGKAIEIgIgBigCDCIISSAGKAIIIgsgBigCACIES3FFBEAgBSAIrSACrX03A3ggBSALrSAErX03A3AgA0EBQdvsACAFQfAAahAPQQAhAgwFCyAAKAJcIgdBACAAKAJgIgobRQRAIAUgCjYCBCAFIAc2AgAgA0EBQYPxACAFEA9BACECDAULAkACQCAAKAJUIgwgBEsNAEF/IAcgDGoiByAHIAxJGyAETQ0AIAAoAlgiByACSw0AQX8gByAKaiIKIAcgCksbIAJLDQELQQAhAiADQQFB1hRBABAPDAULAkAgACgC4AENACAAKALYASIHRQ0AIAAoAtwBIgpFDQAgCyAEayIEIAdGIAggAmsiAiAKRnENACAFIAI2AmwgBSAENgJoIAUgCjYCZCAFIAc2AmAgA0EBQcPoACAFQeAAahAPQQAhAgwFCyAGIAlBNBATIgQ2AhggBEUNAQJAIAYoAhBFDQAgAUEkaiAFQZgBaiICQQEQESAEIAUoApgBIglBB3YiCjYCICAEIAlB/wBxQQFqIgw2AhggACgC4AEhCyABQSVqIAJBARARIAQgBSgCmAE2AgAgAUEmaiACQQEQESAEIAUoApgBIgg2AgRBACECIAQoAgAiB0GAAmtBgX5JBEBBACEJDAULQQAhCSAIQYACa0GBfkkNBCAEKAIYIghBH0sNAyAEQQA2AiQgBCAAKAKgATYCKEEBIQkgBigCEEEBTQ0AQQAgCiALGyEKQQAgDCALGyELIAFBJ2ohAQNAIAEgBUGYAWpBARARIAQgBSgCmAEiB0EHdiIINgJUIAQgB0H/AHFBAWoiBzYCTAJAIAAoAuABDQAgAC0AvAFBBHENACAHIAtGIAggCkZxDQAgBSAINgJUIAUgBzYCUCAFIAk2AkwgBSAKNgJIIAUgCzYCRCAFIAk2AkAgA0ECQcfuACAFQUBrEA8LIAFBAWogBUGYAWoiCEEBEBEgBCAFKAKYATYCNCABQQJqIAhBARARIAQgBSgCmAEiCDYCOCAEKAI0IgdBgAJrQYF+SQ0FIAhBgAJrQYB+TQ0FIAQoAkwiCEEgTw0EIAFBA2ohASAEQQA2AlggBCAAKAKgATYCXCAEQTRqIQQgCUEBaiIJIAYoAhBJDQALC0EAIQIgACgCXCIIRQ0EIAAoAmAiC0UNBCAAIAitIg1CAX0iDyAGKAIIIAAoAlQiB2utfCANgKciATYCaCAAIAutIg5CAX0iECAGKAIMIAAoAlgiCmutfCAOgKciBDYCbAJAAkAgAUUNACAERQ0AQf//AyAEbiABTw0BCyAFIAQ2AhQgBSABNgIQIANBAUG16QAgBUEQahAPDAULIAEgBGwhCQJAIAAtAERBAnEEQCAAIAAoAhwgB2sgCG42AhwgACAAKAIgIAprIAtuNgIgIAAgDyAAKAIkIAdrrXwgDYA+AiQgACAQIAAoAiggCmutfCAOgD4CKAwBCyAAIAQ2AiggACABNgIkIABCADcCHAsgACAJQYwsEBMiATYCnAEgAUUEQCADQQFBzR1BABAPDAULIAYoAhBBuAgQEyEBIAAoAgwgATYC0CsgACgCDCgC0CtFBEAgA0EBQc0dQQAQDwwFC0EKQRQQEyEBIAAoAgwgATYC8CsgACgCDCIBKALwK0UEQCADQQFBzR1BABAPDAULIAFBCjYC+CtBCkEUEBMhASAAKAIMIAE2AvwrIAAoAgwiASgC/CtFBEAgA0EBQc0dQQAQDwwFCyABQQo2AoQsAkAgBigCECIERQ0AIAYoAhghCEEAIQEgBEEBRwRAIARBfnEhCwNAIAggAUE0bGoiBygCIEUEQCAAKAIMKALQKyABQbgIbGpBASAHKAIYQQFrdDYCtAgLIAggAUEBciIHQTRsaiIKKAIgRQRAIAAoAgwoAtArIAdBuAhsakEBIAooAhhBAWt0NgK0CAsgAUECaiEBIAJBAmoiAiALRw0ACwsgBEEBcUUNACAIIAFBNGxqIgIoAiANACAAKAIMKALQKyABQbgIbGpBASACKAIYQQFrdDYCtAgLIAkEQCAAKAKcASEBQQAhAgNAIAEgBigCEEG4CBATIgQ2AtArIARFBEBBACECIANBAUHNHUEAEA8MBwsgAUGMLGohASACQQFqIgIgCUkNAAsLIABBBDYCCCAGKAIQIgMEQEF/IAAoAlgiASAAKAJgIgIgACgCbEEBa2xqIgQgAmoiAiACIARJGyICIAYoAgwiBCACIARJG60hEEF/IAAoAlQiAiAAKAJcIgQgACgCaEEBa2xqIgAgBGoiBCAAIARLGyIAIAYoAggiBCAAIARJG60hESABIAYoAgQiACAAIAFJG60hEiACIAYoAgAiACAAIAJJG60hEyAGKAIYIQBBACEBA0AgACAANQIEIg1CAX0iFCASfCANgCIVPgIUIAAgADUCACIOQgF9IhYgE3wgDoAiFz4CECAAQn8gADUCKCIPhkJ/hSIYIBAgFHwgDYAgFX1C/////w+DfCAPiD4CDCAAIBEgFnwgDoAgF31C/////w+DIBh8IA+IPgIIIABBNGohACABQQFqIgEgA0cNAAsLQQEhAgwECyAFIAI2ApABIANBAUH2OyAFQZABahAPQQAhAgwDC0EAIQIgBkEANgIQIANBAUHNHUEAEA8MAgsgBSAINgI0IAUgCTYCMCADQQFBt/MAIAVBMGoQDwwBCyAFIAg2AiggBSAHNgIkIAUgCTYCICADQQFBkesAIAVBIGoQDwsgBUGgAWokACACC54DAQd/IwBBEGsiBiQAAn8gAiACQQFBAiAAKAJIKAIQIghBgQJJGyIHQQF0QQVqIgRuIgUgBGxGIAIgBE9xRQRAIANBAUGKI0EAEA9BAAwBCwJ/IAAoAghBEEYEQCAAKAKcASAAKALMAUGMLGxqDAELIAAoAgwLIQRBACEAIAQtAIgsIgJBBHEEQCAEKAKkA0EBaiEACyAAIAVqIgVBIE8EQCAGIAU2AgAgA0EBQYs7IAYQD0EADAELIAQgAkEEcjoAiCwgACAFSQRAIAQgAEGUAWxqQagDaiECA0AgASACQQEQESABQQFqIgEgAkEEaiAHEBEgASAHaiIBIAJBCGpBAhARIAIgAigCCCIDIAQoAggiCSADIAlJGzYCCCABQQJqIAJBDGpBARARIAFBA2oiASACQRBqIAcQESABIAdqIgEgBkEMakEBEBEgAiAGKAIMNgIkIAIgAigCECIDIAggAyAISRs2AhAgAkGUAWohAiABQQFqIQEgAEEBaiIAIAVHDQALCyAEIAVBAWs2AqQDQQELIQogBkEQaiQAIAoL7AEBBH8jAEEQayIEJAACfwJAIAEgBEEIagJ/IAAoAkgoAhBBgAJNBEAgAgRAQX8hBUEBDAILIANBAUG+I0EAEA9BAAwDCyACQQFNDQFBfiEFQQILIgYQESAEIAIgBWo2AgwgBCgCCCICIAAoAkgoAhAiBU8EQCAEIAU2AgQgBCACNgIAIANBAUHGOiAEEA9BAAwCCyAAIAIgASAGaiAEQQxqIAMQQkUEQCADQQFBviNBABAPQQAMAgtBASAEKAIMRQ0BGiADQQFBviNBABAPQQAMAQsgA0EBQb4jQQAQD0EACyEHIARBEGokACAHC9kBAQR/IwBBEGsiBCQAIAQgAjYCDAJAAkAgAEEAIAEgBEEMaiADEEJFDQAgBCgCDA0AAn8gACgCCEEQRgRAIAAoApwBIAAoAswBQYwsbGoMAQsgACgCDAshB0EBIQUgACgCSCgCEEECSQ0BIAcoAtArIgJBHGohBkEBIQEgAiEDA0AgAyACKAIYNgLQCCADIAIoAqQGNgLcDiADQdQIaiAGQYgGEBIaIANBuAhqIQMgAUEBaiIBIAAoAkgoAhBJDQALDAELIANBAUHWIkEAEA8LIARBEGokACAFC9YBAQN/IwBBEGsiBCQAAkAgAkEBQQIgACgCSCgCECIGQYECSRsiBUECakcEQEEAIQAgA0EBQYogQQAQDwwBCwJ/IAAoAghBEEYEQCAAKAKcASAAKALMAUGMLGxqDAELIAAoAgwLIQIgASAEQQxqIAUQEUEBIQAgASAFaiIFIARBCGpBARARIAYgBCgCDCIBTQRAIAQgBjYCBCAEIAE2AgAgA0EBQdjvACAEEA9BACEADAELIAVBAWogAigC0CsgAUG4CGxqQagGakEBEBELIARBEGokACAAC4QCAQV/IwBBEGsiBCQAAn8gACgCCEEQRgRAIAAoApwBIAAoAswBQYwsbGoMAQsgACgCDAshBgJAIAJBAUECIAAoAkgiBygCEEGBAkkbIgVNBEBBACECIANBAUGkI0EAEA8MAQsgBCAFQX9zIAJqNgIMIAEgBEEIaiAFEBEgBCgCCCIIIAcoAhBPBEBBACECIANBAUGA6QBBABAPDAELQQEhAiABIAVqIgEgBigC0CsgCEG4CGxqQQEQESAAIAQoAgggAUEBaiAEQQxqIAMQQ0UEQEEAIQIgA0EBQaQjQQAQDwwBCyAEKAIMRQ0AQQAhAiADQQFBpCNBABAPCyAEQRBqJAAgAgusBgEHfyMAQRBrIgYkACAGIAI2AgwgACgCSCEJAn8gACgCCEEQRgRAIAAoApwBIAAoAswBQYwsbGoMAQsgACgCDAsiBCAELQCILEEBcjoAiCwCQCACQQRNBEAgA0EBQbwiQQAQDwwBCyABIARBARARIAQoAgBBCE8EQCADQQFBmiJBABAPDAELIAFBAWogBkEIakEBEBEgBCAGKAIIIgI2AgQgAkEFTgRAIANBAUHxIUEAEA8gBEF/NgIECyABQQJqIARBCGpBAhARIAQoAggiB0GAgARrQYCAfE0EQCAGIAc2AgAgA0EBQak9IAYQDwwBCyAEIAAoAqQBIgIgByACGzYCDCABQQRqIARBEGpBARARIAQoAhBBAk8EQCADQQFBhypBABAPDAELIAFBBWohAiAGIAYoAgxBBWs2AgwCQCAJKAIQIgdFDQAgBCgCAEEBcSEIIAQoAtArIQRBACEJIAdBCE8EQCAHQXhxIQEDQCAEIAVBuAhsaiAINgIAIAQgBUEBckG4CGxqIAg2AgAgBCAFQQJyQbgIbGogCDYCACAEIAVBA3JBuAhsaiAINgIAIAQgBUEEckG4CGxqIAg2AgAgBCAFQQVyQbgIbGogCDYCACAEIAVBBnJBuAhsaiAINgIAIAQgBUEHckG4CGxqIAg2AgAgBUEIaiEFIApBCGoiCiABRw0ACwsgB0EHcSIBRQ0AA0AgBCAFQbgIbGogCDYCACAFQQFqIQUgCUEBaiIJIAFHDQALC0EAIQUgAEEAIAIgBkEMaiADEENFBEAgA0EBQbwiQQAQDwwBCyAGKAIMBEAgA0EBQbwiQQAQDwwBCwJ/IAAoAghBEEYEQCAAKAKcASAAKALMAUGMLGxqDAELIAAoAgwLIQEgACgCSCgCEEECTwRAIAEoAtArIgEoAgRBAnQhByABQbAHaiEKIAFBrAZqIQNBASEJIAEhAgNAIAIgAf0AAgT9CwK8CCACIAEoAhQ2AswIIAJB5A5qIAMgBxASGiACQegPaiAKIAcQEhogAkG4CGohAiAJQQFqIgkgACgCSCgCEEkNAAsLQQEhBQsgBkEQaiQAIAUL7AkBBn8jAEHwAGsiBCQAIARBADYCaAJAIAJBCEcEQCADQQFBvR5BABAPIANBAUG9HkEAEA8MAQsgASAAQcwBakECEBEgAUECaiAEQewAakEEEBEgAUEGaiAEQeQAakEBEBEgAUEHaiAEQegAakEBEBEgACgCzAEiAiAAKAJoIgggACgCbGxPBEAgBCACNgJgIANBAUGdOyAEQeAAahAPDAELIAAoApwBIAJBjCxsaiEFIAIgCG4hByAEKAJkIQECQCAAKAIsIgZBAE4gAiAGR3ENACAFKALUK0EBaiIGIAFGDQAgBCAGNgJYIAQgATYCVCAEIAI2AlAgA0EBQbU7IARB0ABqEA9BACEFDAELIAUgATYC1CsCQAJAIAQoAmwiAUEBa0EMTQR/IAFBDEcNASAEQQw2AjAgA0ECQeXXACAEQTBqEA8gBCgCbAUgAQtFBEAgA0EEQbLPAEEAEA8gAEEBNgI4CwJAAkACQAJAIAUoAtgrIgEEQCAEKAJkIgYgAUkNASAEIAE2AiQgBCAGNgIgIANBAUGFJyAEQSBqEA8gAEEBNgI4QQAhBQwHCyAEKAJoIgYNAQwDCyAEKAJoIgZFDQELIAQgBiAALQBEQQR2QQFxaiIBNgJoIAQoAmQiBiAFKALYKyIJQQFrSwRAIAQgCTYCBCAEIAY2AgAgA0EBQaImIAQQDyAAQQE2AjhBACEFDAULIAEgBk0EQCAEIAE2AhQgBCAGNgIQIANBAUHpJyAEQRBqEA8gAEEBNgI4QQAhBQwFCyAFIAE2AtgrCyABIAQoAmRBAWpHDQAgACAALQBEQQFyOgBECyAEKAJsIQEgAEEQNgIIIABBACABQQxrIAAoAjgbNgIYAkAgACgCLCIBQX9GBEBBBCEFIAIgByAIbGsiASAAKAIcSQ0BIAEgACgCJE8NASAHIAAoAiBJDQEgByAAKAIoT0ECdCEFDAELIAAoAswBIAFHQQJ0IQULIAAgAC0AREH7AXEgBXI6AERBASEFIAAoAsgBIgFFDQIgASgCKCIGIAAoAswBIgJBKGxqIgcgAjYCACAHIAQoAmQiCDYCDCAEKAJoIgEEQCAHIAE2AgQgByAEKAJoIgE2AgggBygCECICRQRAIAFBGBATIQEgACgCyAEoAiggACgCzAFBKGxqIAE2AhAgAQ0EQQAhBSADQQFByTRBABAPDAQLIAIgAUEYbBAXIQEgACgCyAEoAiggACgCzAFBKGxqIQIgAUUEQCACKAIQEBBBACEFIAAoAsgBKAIoIAAoAswBQShsakEANgIQIANBAUHJNEEAEA8MBAsgAiABNgIQDAMLIAcoAhAiAUUEQCAHQQo2AghBCkEYEBMhASAAKALIASgCKCIGIAAoAswBIgJBKGxqIgcgATYCECABRQ0CIAQoAmQhCAsgCCAGIAJBKGxqIgIoAghJDQIgAiAIQQFqIgI2AgggASACQRhsEBchASAAKALIASgCKCAAKALMAUEobGohAiABRQRAIAIoAhAQEEEAIQUgACgCyAEoAiggACgCzAFBKGxqIgBBADYCCCAAQQA2AhAgA0EBQck0QQAQDwwDCyACIAE2AhAMAgsgBCABNgJAIANBAUHy2QAgBEFAaxAPQQAhBQwBC0EAIQUgB0EANgIIIANBAUHJNEEAEA8LIARB8ABqJAAgBQurBwEIfyMAQdAAayIEJAAgBEEBNgJMAkACQCAAKALIASIFKAIoIgMNACAFIAAoAmwgACgCaGwiAzYCJCADQSgQEyEDIAAoAsgBIgUgAzYCKCADRQRAQQAhBQwCCyAFKAIkRQ0AA0BBACEFIAMgBkEobCIHaiIDQQA2AhQgA0HkADYCHEHkAEEYEBMhCSAHIAAoAsgBIggoAigiA2ogCTYCGCAJRQ0CIAZBAWoiBiAIKAIkSQ0ACwsgACgCLCEJAkAgAygCEEUNAAJAIAMgCUEobGoiAygCBEUEQCABIAApAzBCAnwgAhA2DQFBACEFIAJBAUGnKUEAEA8MAwsgASADKAIQKQMAQgJ8IAIQNg0AQQAhBSACQQFBpylBABAPDAILIAAoAghBgAJHDQAgAEEINgIICwJAIAAoAmwgACgCaGwiB0UNACAAKAKcASEFQQAhAyAHQQhPBEAgB0F4cSEIQQAhBgNAIAUgA0GMLGxqQX82AtQrIAUgA0EBckGMLGxqQX82AtQrIAUgA0ECckGMLGxqQX82AtQrIAUgA0EDckGMLGxqQX82AtQrIAUgA0EEckGMLGxqQX82AtQrIAUgA0EFckGMLGxqQX82AtQrIAUgA0EGckGMLGxqQX82AtQrIAUgA0EHckGMLGxqQX82AtQrIANBCGohAyAGQQhqIgYgCEcNAAsLIAdBB3EiBkUNAANAIAUgA0GMLGxqQX82AtQrIANBAWohAyAKQQFqIgogBkcNAAsLQQAhBSAAIARByABqQQAgBEHEAGogBEFAayAEQTxqIARBOGogBEE0aiAEQcwAaiABIAIQJ0UNACAJQQFqIQcDQAJAIAQoAkxFDQAgACAEKAJIIgNBAEEAIAEgAhArRQ0CIAAoAmghCCAAKAJsIQogBCADQQFqIgY2AiAgBCAIIApsNgIkIAJBBEGg1wAgBEEgahAPIAAoAtABIAAoAkwoAhgQdEUNAiAAKAKcASADQYwsbGoiBSgC3CsiCARAIAgQECAFQgA3AtwrCyAEIAY2AhAgAkEEQeb8ACAEQRBqEA8gAyAJRgRAIAEgACgCyAEpAwhCAnwgAhA2DQFBACEFIAJBAUGnKUEAEA8MAwsgBCAHNgIEIAQgBjYCACACQQJB3eUAIAQQD0EAIQUgACAEQcgAakEAIARBxABqIARBQGsgBEE8aiAEQThqIARBNGogBEHMAGogASACECcNAQwCCwsgACACEHIhBQsgBEHQAGokACAFC8gGAgd/AX4jAEHQAGsiAyQAIANBATYCTAJAAkAgACgCaCIEQQFHDQAgACgCbEEBRw0AIAAoAlQNACAAKAJYDQAgACgCTCIFKAIADQAgBSgCBA0AIAUoAgggACgCXEcNACAFKAIMIAAoAmBHDQBBACEEIAAgA0HIAGpBACADQcQAaiADQUBrIANBPGogA0E4aiADQTRqIANBzABqIAEgAhAnRQ0BAkAgACADKAJIQQBBACABIAIQKwRAIAAoAkwiASgCEA0BQQEhBAwDCyACQQFBkcIAQQAQDwwCCyABKAIYIQFBACECA0AgASACQTRsIgRqKAIsEBAgACgCTCIFKAIYIgEgBGoiBiAAKALQASIHKAIUKAIAKAIUIAJBzABsaiIIKAIkNgIsIAYgBygCGCgCGCAEaigCJDYCJCAIQQA2AiRBASEEIAJBAWoiAiAFKAIQSQ0ACwwBCwNAAkACfwJAIARBAUcNACAAKAJsQQFHDQAgACgCnAEoAtwrRQ0AIANBADYCSCAAQQA2AswBIAAgACgCCEGAAXI2AghBAAwBC0EAIQQgACADQcgAakEAIANBxABqIANBQGsgA0E8aiADQThqIANBNGogA0HMAGogASACECdFDQMgAygCTEUNASADKAJICyIHQQFqIQQgACAHQQBBACABIAIQKyEJIAAoAmggACgCbGwhBSAJRQRAIAMgBTYCBCADIAQ2AgAgAkEBQZc5IAMQD0EAIQQMAwsgAyAFNgIkIAMgBDYCICACQQRBoNcAIANBIGoQDyAAKALQASAAKAJMKAIYEHRFBEBBACEEDAMLAkACQCAAKAJoQQFHDQAgACgCbEEBRw0AIAAoAkwiBSgCACAAKAJIIgYoAgBHDQEgBSgCBCAGKAIERw0BIAUoAgggBigCCEcNASAFKAIMIAYoAgxHDQELIAAoApwBIAdBjCxsaiIFKALcKyIGRQ0AIAYQECAFQgA3AtwrCyADIAQ2AhAgAkEEQeb8ACADQRBqEA8gASkDCCIKUAR+QgAFIAogASkDOH0LUARAIAAoAghBwABGDQELIAhBAWoiCCAAKAJoIgQgACgCbGxHDQELCyAAIAIQciEECyADQdAAaiQAIAQLtQYBDH8gACgCSCEJAkAgACgCaCAAKAJsbCIMBEAgCSgCECIBQbgIbCENIAEgAWxBAnQhCiAAKAIMIQQgACgCnAEhAwNAIAMoAtArIQsgAyAEQYwsEBIiAUEANgLoKyABQX82AtQrIAFBADYCsCggAUEANgKELCABQQA2AvArIAFCADcC+CsgASALNgLQKyABIAEtAIgsQfwBcToAiCwgBCgC6CsEQCABIAoQFCIDNgLoKyADRQRAQQAPCyADIAQoAugrIAoQEhoLIAEgBCgC+CtBFGwiBRAUIgM2AvArQQAhCCADRQ0CIAMgBCgC8CsgBRASGiAEKAL0KyIGBEAgBCgC8CshAyABKALwKyEFQQAhBwNAIAMoAgwEQCAFIAMoAhAQFCIGNgIMIAZFBEBBAA8LIAYgAygCDCADKAIQEBIaIAQoAvQrIQYLIAEgASgC+CtBAWo2AvgrIAVBFGohBSADQRRqIQMgB0EBaiIHIAZJDQALCyABIAQoAoQsQRRsIgUQFCIDNgL8KyADRQ0CIAMgBCgC/CsgBRASGiABIAQoAoQsIgg2AoQsIAgEQCAEKAL8KyEDIAEoAvwrIQVBACEHA0AgAygCCCIGBEAgBSABKALwKyAGIAQoAvAra2o2AggLIAMoAgwiBgRAIAUgASgC8CsgBiAEKALwK2tqNgIMCyAFQRRqIQUgA0EUaiEDIAdBAWoiByAIRw0ACwsgCyAEKALQKyANEBIaIAFBjCxqIQMgDkEBaiIOIAxHDQALC0EBIQggAAJ/QQBBAUHIABATIgFFDQAaIAEgAS0AKEH+AXFBAXI6ACggAUEBQQQQEyIENgIUIAEgBA0AGiABEBBBAAsiATYC0AEgAUUEQEEADwsgACgC1AEhBUEAIQQgASAAQdAAajYCHCABIAk2AhhBAUHQBhATIQMgASgCFCADNgIAAkAgA0UNACAJKAIQQcwAEBMhAyABKAIUKAIAIgcgAzYCFCADRQ0AIAcgCSgCEDYCECAAKAKkASEEIAEgBTYCLCABIAQ2AgBBASEECyAEDQAgACgC0AEQVUEAIQggAEEANgLQASACQQFBwhtBABAPCyAIC9USAwx/AX0BfiMAQTBrIggkACAAQQE2AggCfwJAAkAgASAIQShqIgVBAiACEBpBAkcNACAFIAhBLGpBAhARIAgoAixBz/4DRw0AIABBAjYCCCAAKALIASABKQM4QgJ9IhA3AwAgCCAQNwMQIAJBBEHu3gAgCEEQahAPIAAoAsgBIgMpAwAhECADKAIYIgdBAWoiBSADKAIgIgRNBEAgAygCHCEEDAILIAMCfyAEs0MAAMhCkiIPQwAAgE9dIA9DAAAAAGBxBEAgD6kMAQtBAAsiBTYCICADKAIcIAVBGGwQFyIEBEAgAyAENgIcIAMoAhgiB0EBaiEFDAILIAMoAhwQECADQQA2AiAgA0IANwMYIAJBAUGpHUEAEA8LIAJBAUG19QBBABAPQQAMAQsgBCAHQRhsaiIEQQI2AhAgBCAQxDcDCCAEQc/+AzsBACADIAU2AhggASAAKAIQQQIgAhAaQQJHBEAgAkEBQZYSQQAQD0EADAELIAAoAhAgCEEoakECEBECQAJAIAgoAigiBEGQ/wNHBEADQEHgvQEhByAEQf/9A00EQCAIIAQ2AgAgAkEBQcoQIAgQD0EADAULA0AgByIFKAIAIgMEQCAFQQxqIQcgAyAERw0BCwsCQAJAIAMNAEECIQYgAkECQfUcQQAQD0GWEiEHAkACQCABIAAoAhBBAiACEBpBAkcNAANAIAAoAhAgCEEsakECEBFB4L0BIQMgCCgCLCIEQYD+A08EQANAIAMiBSgCACIMBEAgA0EMaiEDIAQgDEcNAQsLIAUoAgQgACgCCHFFBEBB/CghBwwDCyAMBEAgDEGQ/wNGBEAgCEGQ/wM2AigMBwsgASkDOCEQIAAoAsgBIgMoAhgiBUEBaiIEIAMoAiAiB00EQCADKAIcIQcMBQsgAwJ/IAezQwAAyEKSIg9DAACAT10gD0MAAAAAYHEEQCAPqQwBC0EACyIFNgIgIAMoAhwgBUEYbBAXIgcEQCADIAc2AhwgAygCGCIFQQFqIQQMBQsgAygCHBAQIANBADYCICADQgA3AxhBqR0hBwwDCyAGQQJqIQYLIAEgACgCEEECIAIQGkECRg0ACwsgAkEBIAdBABAPIAJBAUH9yABBABAPQQAMBwsgByAFQRhsaiIFIAY2AhAgBSAQpyAGa6w3AwggBUEAOwEAIAMgBDYCGCAIIAw2AihB4L0BIQQDQCAEIgUoAgAiA0UNASAEQQxqIQQgAyAMRw0ACwsgBSgCBCAAKAIIcUUEQCACQQFB/ChBABAPQQAMBgsgASAAKAIQQQIgAhAaQQJHBEAgAkEBQZYSQQAQD0EADAYLIAAoAhAgCEEkakECEBEgCCgCJCIEQQFNBEAgAkEBQaEuQQAQD0EADAYLIAggBEECayIHNgIkIAAoAhAhBCAAKAIUIAdJBEAgBCAHEBciBEUEQCAAKAIQEBAgAEIANwMQIAJBAUHUJUEAEA9BAAwHCyAAIAQ2AhAgACAIKAIkIgc2AhQLIAEgBCAHIAIQGiIEIAgoAiRHBEAgAkEBQZYSQQAQD0EADAYLIAAgACgCECAEIAIgBSgCCBEBAEUEQCACQQFBqBJBABAPQQAMBgsgASkDOCEQIAgoAiQhDAJAIAAoAsgBIgUoAhgiBkEBaiIHIAUoAiAiBE0EQCAFKAIcIQQMAQsgBQJ/IASzQwAAyEKSIg9DAACAT10gD0MAAAAAYHEEQCAPqQwBC0EACyIENgIgIAUoAhwgBEEYbBAXIgRFDQUgBSAENgIcIAUoAhgiBkEBaiEHCyAEIAZBGGxqIgQgDEEEajYCECAEIBCnIAxrQQRrrDcDCCAEIAM7AQAgBSAHNgIYIAEgACgCEEECIAIQGkECRwRAIAJBAUGWEkEAEA9BAAwGC0EBIAogA0Hc/gNGGyEKQQEgCyADQdL+A0YbIQtBASANIANB0f4DRhshDSAAKAIQIAhBKGpBAhARIAgoAigiBEGQ/wNHDQELCyANDQELIAJBAUGYJEEAEA9BAAwCCyALRQRAIAJBAUHGJEEAEA9BAAwCCyAKRQRAIAJBAUH0JEEAEA9BAAwCC0EAIQNBACENIwBBEGsiBCQAQQEhBwJAIAAtALwBQQFxRQ0AAkAgACgCcCILRQ0AAkADQCAAKAJ0IA1BA3RqIgUoAgAiCgRAIAMgBSgCBCIGayIFQQAgAyAFTxshBSADIAZJBEAgBiADayELIAMgCmohCgNAIAtBBEkEQEGOKyEDDAULIAogBEEMakEEEBEgBCgCDCIDQX9zIAlJBEBB9CohAwwFCyADIAtBBGsiBmsgBSADIAZLIgwbIQUgAyAJaiEJIAYgA2shCyAKQQAgAyAMG2pBBGohCiADIAZJDQALIAAoAnAhCwsgBSEDCyANQQFqIg0gC0kNAAsgA0UNAUEAIQcgAkEBQekWQQAQDwwCC0EAIQcgAkEBIANBABAPDAELIAAgCRAUIgM2AogBIANFBEBBACEHIAJBAUG+IEEAEA8MAQsgACAJNgJ8IAAoAnQhBgJAIAAoAnAiCgRAQQAhCUEAIQNBACEFA0AgBiAFQQN0Ig1qIgwoAgAiCwRAIAAoAogBIANqIQoCfyAMKAIEIgYgCU0EQCAKIAsgBhASGiADIAZqIQMgCSAGawwBCyAKIAsgCRASGiADIAlqIQMgBiAJayIGBEAgCSALaiEJA0AgBkEESQ0GIAkgBEEIakEEEBEgCUEEaiEJIAAoAogBIANqIQogBkEEayIGIAQoAggiC0kEQCAKIAkgBhASGiADIAZqIQMgBCgCCCAGawwDCyAKIAkgCxASGiAEKAIIIgogA2ohAyAJIApqIQkgBiAKayIGDQALC0EACyEJIAAoAnQgDWooAgAQECAAKAJ0IgYgDWpCADcCACAAKAJwIQoLIAVBAWoiBSAKSQ0ACyAAKAJ8IQkgACgCiAEhAwsgACAJNgKQASAAIAM2AnggAEEANgJwIAYQECAAQQA2AnQMAQtBACEHIAJBAUGOK0EAEA8LIARBEGokACAHRQRAIAJBAUGPPUEAEA9BAAwCCyACQQRB99YAQQAQDyAAKALIASABKQM4Qv7///8PfEL/////D4M3AwggAEEINgIIQQEMAQsgBSgCHBAQIAVBADYCICAFQgA3AxggAkEBQakdQQAQD0EACyEOIAhBMGokACAOCxwAIAAoAghFIAAoAsABQQBHIAAoAsQBQQBHcXELBABBAAsPACAABEAgACABNgK4AQsLjwEBBH8gACgCGCIBBEAgACgCHCIDQTRuIQQgA0E0TwR/QQAhAwNAIAEoAgAiAgRAIAJBAWsQECABQQA2AgALIAEoAgQiAgRAIAIQECABQQA2AgQLIAEoAggiAgRAIAIQECABQQA2AggLIAFBNGohASADQQFqIgMgBEcNAAsgACgCGAUgAQsQECAAQQA2AhgLC4YBAQR/IAAoAhgiAQRAIAAoAhwiAkHAAE8EfyACQQZ2IQRBACECA0AgASgCACIDBEAgAxAQIAFBADYCAAsgASgCBCIDBEAgAxAQIAFBADYCBAsgASgCPBAQIAFBADYCPCABQUBrIQEgAkEBaiICIARHDQALIAAoAhgFIAELEBAgAEEANgIYCws/AQF/IAAEQCAAKAJ0IgEEQCABEBAgAEEANgJ0CyAAKAJ4IgEEQCABEBAgAEEANgJ4CyAAKAKUARAQIAAQEAsLwaYFBFx/AnsGfgF9IwBB4ABrIiMkACAAKAIIIRoCQAJAAkACQCAAKAIARQRAIBogGigCECAaKAIIayAaKAIUIBooAgxrbEECdCIGEBgiAzYCPCADRQRAIAAoAiQaIAAoAiBBAUHRPEEAEA8gACgCJBogAEEcaiEQDAMLIANBACAGEBUaDAELIBooAjwiA0UNACADEBAgGkEANgI8CyAAKAIQIjIoAhwgMigCGEGYAWxqIgNBmAFrKAIAITUgA0GQAWsoAgAhNiAAKAIUIS8gACgCDCEwIAAoAgQhNyAAKAIcKAIARQ0CIABBHGohEAJAAn9BACABKAIEIgNBAEwNABogASgCACEGAkADQCAGIAdBDGxqIgQoAgBFDQEgB0EBaiIHIANHDQALQQAMAQsgBCgCBAsiBA0AQQFBnAEQEyIERQRAIAAoAiBBAUGQMEEAEA8MAgsgBEEANgKMASABKAIEIgNB/////wdHBH8CfyABKAIAIQYgA0EASgRAA0AgBiAJQQxsaiIHKAIARQRAIAcoAggiAwR/IAcoAgQgAxECACABKAIABSAGCyAJQQxsaiIBQQ82AgggASAENgIEQQEMAwsgCUEBaiIJIANHDQALC0EAIAYgA0EMbEEMahAXIgNFDQAaIAEgAzYCACADIAEoAgQiBkEMbGoiA0EPNgIIIAMgBDYCBCADQQA2AgAgASAGQQFqNgIEQQELBUEACw0AIAAoAiBBAUGMP0EAEA8gBCgCdCIBBEAgARAQIARBADYCdAsgBCgCeCIBBEAgARAQIARBADYCeAsgBCgClAEQECAEEBAMAQsgBCAAKAIYNgKQASAAKAIoISsgACgCJCEhIAAoAiAhHSAvKAKoBiERIDAoAhAhAQJAAkAgLygCECIWQcAAcQRAIBYhCiMAQbACayIPJAACQCARBEAgIQRAQQAhByAdQQFBgRhBABAPDAILQQAhByAdQQFBgRhBABAPDAELIAQoAnQhBwJAAkAgGigCFCAaKAIMayIDIBooAhAgGigCCGsiBmwiASAEKAKEAUsEQCAHEBAgBCABQQJ0IhEQGCIHNgJ0IAdFBEBBACEHDAQLIAQgATYChAEMAQsgB0UNASABQQJ0IRELIAdBACAREBUaCyAEKAJ4IQcCQCAEKAKIAUHPFEsNACAHEBAgBEHA0gAQGCIHNgJ4IAcNAEEAIQcMAQsgBEHQFDYCiAEgB0EAQcDSABAVGiAEIAM2AoABIAQgBjYCfCAaKAIYIgJFBEBBASEHDAELIBooAhwhDUEBIQcCQAJAAkACQAJAIBooAjQiAwRAIBooAgQhCUEAIQdBACEBAkAgA0EETwRAIANBfHEhAQNAIAkgCEEDdGoiBkEcaiAGQRRqIAZBDGogBv0JAgT9VgIAAf1WAgAC/VYCAAMgXv2uASFeIAhBBGoiCCABRw0ACyBeIF4gXv0NCAkKCwwNDg8AAQIDAAECA/2uASJeIF4gXv0NBAUGBwABAgMAAQIDAAECA/2uAf0bACEHIAEgA0YNAQsDQCAJIAFBA3RqKAIEIAdqIQcgAUEBaiIBIANHDQALCyADQQFGBEAgBCgCkAFFDQULIAcgBCgCmAFNDQEgBCgClAEgBxAXIhENAkEAIQcMBgsgBCgCkAFFDQULIAQoApQBIhENAUEAIQcMBAsgBCAHNgKYASAEIBE2ApQBCyAaKAI0RQRAQQAhBwwCCyAaKAIEIQhBACEHQQAhAQNAIAcgEWogCCABQQN0IgNqIgYoAgAgBigCBBASGiAaKAIEIgggA2ooAgQgB2ohByABQQFqIgEgGigCNEkNAAsMAQsgGigCBCgCACERC0EAIQFBACEIAn9BACAaKAIoIgNFDQAaIBooAgAiBigCCCEIQQAgA0EBRg0AGiAGKAIgCyEDIAIgDWshRQJAIAMgCGoiCEUEQEEAIQkMAQtBASEBIBooAgAiAygCACEFQQAhCSAIQQFGBEBBACEBDAELIAMoAhghCQsgRUEBaiEWIAQoAnQhDiAEKAJ4IRQgGigCDCESIBooAhQhGCAaKAIIISQgGigCECErAkACQAJAAkACQAJAAkACQAJAIAFFDQAgCQ0AICFFDQEgHUECQaHQAEEAEA9BASEIDAILIAhBBEkNASAhBEAgDyAINgJwIB1BAUH8xgAgD0HwAGoQDwwICyAPIAg2AmAgHUEBQfzGACAPQeAAahAPQQAhBwwICyAdQQJBodAAQQAQDyAaKAIYIgFBHksNAUEBIQwgASAWTw0DDAULIBooAhgiAUEeTQ0BICFFDQAgDyABNgIgIB1BAUGb2wAgD0EgahAPDAULIA8gATYCACAdQQFBm9sAIA8QD0EAIQcMBQsgASAWSQ0BIAhBAkkEQCAIIQwMAQsgASAWRwRAIAghDAwBC0EBIQxBkMcBLQAADQAgIUUEQEGQxwFBAToAACAPIAg2AkAgHUECQabMACAPQUBrEA8MAQtBkMcBLQAARQRAQZDHAUEBOgAAIA8gCDYCUCAdQQJBpswAIA9B0ABqEA8LCwJAAkAgBUECSQ0AIAUgB0sNACAFIAlqIAdNDQELICEEQEEAIQcgHUEBQcLGAEEAEA8MBQtBACEHIB1BAUHCxgBBABAPDAQLAkACQCAFIBFqIhNBAWstAABBBHQgE0ECay0AAEEPcXIiBkECSQ0AIAUgBkgNACAGQfAfSQ0BCyAhBEBBACEHIB1BAUHW8gBBABAPDAULQQAhByAdQQFB1vIAQQAQDwwECyAaKAIcISYgD0EANgKQAiAPQQA2ApgCIA9CADcDiAIgD0IANwOoAiAPQgA3ApwCIA8gBkEBayIHNgKUAiAPIAUgEWogBmsiATYCgAJC/wEhYCAGQQJPBEAgATEAACFgC0EIIQMgD0EINgKQAiAPIAZBAmsiCDYClAIgDyBgQg+EIGAgB0EBRhsiYDcDiAIgDyABIAZBAUpqIgc2AoACIA8gYEL/AVEiDTYCmAICfwJAIAFBA3EiAkEDRg0AQv8BIWEgDQRAQQAgBy0AAEGPAUsNAhoLIAZBA04EQCAHMQAAIWELIA8gBkEDayINNgKUAiAPQQ9BECBgQv8BUSILGyIDNgKQAiAPIAcgBkECSmoiATYCgAIgDyBhQg+EIGEgCEEBRhsiYUL/AVE2ApgCIA8gYEIHQgggCxuGIGGEImA3A4gCIAJBAkYNACBhQv8BUQRAQQAgAS0AAEGPAUsNAhoLQv8BIWIgBkEETgRAIAExAAAhYgsgDyAGQQRrIgc2ApQCIA8gASAGQQNKaiIBNgKAAiAPIGJCD4QgYiANQQFGGyJiQv8BUTYCmAIgDyADQQdBCCBhQv8BUSIIG2oiAzYCkAIgDyBgQgdCCCAIG4YgYoQiYDcDiAIgAkEBRg0AQv8BIWEgYkL/AVEEQEEAIAEtAABBjwFLDQIaCyAGQQVOBEAgATEAACFhCyAPIAZBBWs2ApQCIA8gASAGQQRKajYCgAIgDyBhQg+EIGEgB0EBRhsiYUL/AVE2ApgCIA8gA0EHQQggYkL/AVEiARtqIgM2ApACIA8gYEIHQgggARuGIGGEImA3A4gCCyAPIGBBwAAgA2uthjcDiAJBAQtFBEAgIQRAQQAhByAdQQFBg9UAQQAQDwwFC0EAIQcgHUEBQYPVAEEAEA8MBAsgKyAkayEVIA8gBkECayILNgL0ASAPIAUgEWoiAkEDayIDNgLgASAPIAJBAmstAAAiGUGPAUsiDTYC+AEgDyAZQQR2rSJgNwPoASAPQQNBBCBgQgeDQgdRGyIBNgLwASADQQNxQQFqIgcgCyAHIAtIGyEIAkACQCAGQQJMBEAgDyALIAhrIgI2AvQBDAELIA8gAkEEayIHNgLgASAPIAMtAAAiF0GPAUsiDTYC+AEgDyAXrSJhIAGthiBghCJgNwPoASAPQQhBB0EIIGFC/wCDQv8AURsgGUGPAU0bIAFqIgE2AvABAkAgCEEBRgRAIAchAwwBCyAPIAJBBWsiAzYC4AEgDyAHLQAAIhlBjwFLIg02AvgBIA8gGa0iYSABrYYgYIQiYDcD6AEgD0EIQQdBCCBhQv8Ag0L/AFEbIBdBjwFNGyABaiIBNgLwASAIQQJGDQAgDyACQQZrIgc2AuABIA8gAy0AACIXQY8BSyINNgL4ASAPIBetImEgAa2GIGCEImA3A+gBIA9BCEEHQQggYUL/AINC/wBRGyAZQY8BTRsgAWoiATYC8AEgCEEDRgRAIAchAwwBCyAPIAJBB2siAzYC4AEgDyAHMQAAImFCjwFWIg02AvgBIA8gYSABrYYgYIQiYDcD6AEgD0EIQQdBCCBhQv8Ag0L/AFEbIBdBjwFNGyABaiIBNgLwAQsgDyALIAhrIgI2AvQBIAFBIEsNAQsCQCACQQROBEAgA0EDaygCACEHIA8gAkEEazYC9AEgDyADQQRrNgLgAQwBCyACQQBMBEBBACEHDAELIAJBAXEhRwJAIAJBAUYEQEEYIQhBACEHDAELIAJB/v///wdxIRdBGCEIQQAhB0EAIQsDQCAPIANBAWsiHzYC4AEgAy0AACFGIA8gA0ECayIDNgLgASAPIAJBAWs2AvQBIB8tAAAhHyAPIAJBAmsiAjYC9AEgRiAIdCAHciAfIAhBCGt0ciEHIAhBEGshCCALQQJqIgsgF0cNAAsLIEdFDQAgDyADQQFrNgLgASADLQAAIUggDyACQQFrNgL0ASBIIAh0IAdyIQcLIA8gB0H/AXEiA0GPAUs2AvgBIA9BB0EIIAdBgICA+AdxQYCAgPgHRhtBCCANGyICQQhBB0EIIAdBgID8A3FBgID8A0YbIAdB/////3hNG2oiCEEIQQdBCCAHQYD+AXFBgP4BRhsgB0EQdkH/AXEiDUGPAU0baiILQQhBB0EIIAdB/wBxQf8ARhsgB0EIdkH/AXEiGUGPAU0bIAFqajYC8AEgDyANIAJ0IAdBGHZyIBkgCHRyIAMgC3RyrSABrYYgYIQ3A+gBCyAPQcABaiARIAUgBmtB/wEQWwJ/QQAgDEECSQ0AGiAPQaABaiATIAlBABBbQQAgDEECRg0AGkIAIWBCACFiIA9BATYCmAEgD0EANgKQASAPQgA3A4gBIA8gCUEBayIGNgKUASAPIAUgEWogCWoiA0EBayIBNgKAASABQQNxIQUCQCAJQQBMBEAgASEDDAELIA8gA0ECayIDNgKAASABMQAAIWALIA8gYDcDiAEgDyBgQo8BViIRNgKYASAPQQdBCCBgQv8Ag0L/AFEbIg02ApABAkAgBUUNACAPIAlBAmsiAjYClAECQCAJQQJIBEAgAyEHDAELIA8gA0EBayIHNgKAASADMQAAIWILIA8gYkKPAVYiETYCmAEgDyBiIA2thiBghCJhNwOIASAPQQhBB0EIIGJC/wCDQv8AURsgYEKPAVgbIA1qIg02ApABIAVBAUYEQCAHIQMgYSFgIAYhCSACIQYMAQsgDyAJQQNrIgg2ApQBAkAgCUEDSARAIAchAQwBCyAPIAdBAWsiATYCgAEgBzEAACFjCyAPIGNCjwFWIhE2ApgBIA8gYyANrYYgYYQiYDcDiAEgD0EIQQdBCCBjQv8Ag0L/AFEbIGJCjwFYGyANaiINNgKQASAFQQJGBEAgASEDIAIhCSAIIQYMAQsgDyAJQQRrIgY2ApQBQgAhYgJAIAlBBEgEQCABIQMMAQsgDyABQQFrIgM2AoABIAExAAAhYgsgDyBiQo8BViIRNgKYASAPIGIgDa2GIGCEImA3A4gBIA9BCEEHQQggYkL/AINC/wBRGyBjQo8BWBsgDWoiDTYCkAEgCCEJCyANQSBNBEACQCAJQQVOBEAgA0EDaygCACEHIA8gCUEFazYClAEgDyADQQRrNgKAAQwBC0EAIQcgCUECSA0AQRghCQNAIA8gA0EBayIBNgKAASADLQAAIUkgDyAGQQFrIgI2ApQBIEkgCXQgB3IhByAGQQFLIUogASEDIAlBCGshCSACIQYgSg0ACwsgDyAHQf8BcSIBQY8BSzYCmAEgD0EHQQggB0GAgID4B3FBgICA+AdGG0EIIBEbIgNBCEEHQQggB0GAgPwDcUGAgPwDRhsgB0H/////eE0baiIGQQhBB0EIIAdBgP4BcUGA/gFGGyAHQRB2Qf8BcSIJQY8BTRtqIgJBCEEHQQggB0H/AHFB/wBGGyAHQQh2Qf8BcSIIQY8BTRsgDWpqNgKQASAPIAkgA3QgB0EYdnIgCCAGdHIgASACdHKtIA2thiBghDcDiAELQQELITEgGCASayEfIBZBAWohLCAUQQA6AMAQIBRBwBBqIQsgD0GAAmoQKCECIBVBAEoEQCAmQQFrIRMgFCEDIAshCEEAIREgDiEGQQAhDQNAIA0hBSARQQh0IA9B4AFqEC9B/wBxQQF0ckGg/QBqLwEAIQECQCARDQAgAUEAIAJBAmsiB0F/RhshASACQQFKBEAgByECDAELIA9BgAJqECghAgsgDykD6AEhZCAPKALwASFLIAMgAygCACABQQR2IhhBA3EgAUECdkEwcXIgInRyIhY2AgAgAUEFdkEHcSABQRBxIh5BBHZyIREgSyABQQdxIgdrIQ0gZCAHrYgiYKchCUEAIQcgFSAFQQJySgRAIBFBCHQgCUH/AHFBAXRyQaD9AGovAQAhBwJAIBENACAHQQAgAkECayIJQX9GGyEHIAJBAUoEQCAJIQIMAQsgD0GAAmoQKCECCyAHQQR2QQFxIAdBBXZBB3FyIREgDSAHQQdxIglrIQ0gYCAJrYgiYKchCQsgAyAHQQJ0QYAGcSAHQTBxciAiQQRqdCAWcjYCAAJAIAdBAnZBAnEgAUEDdkEBcXIiF0EDRw0AQQRBAyACQQJrIhZBf0YbIRcgAkEBSgRAIBYhAgwBCyAPQYACahAoIQILAn8gF0UEQCAPQoGAgIAQNwJ4QQAMAQsgF0ECTQRAIA9BASAJQQdxQdSdAWotAAAiFkEFdkF/IBZBAnZBB3EiGXRBf3MgCSAWQQNxIgl2cWpBAWoiFiAXQQFGIhcbNgJ8IA8gFkEBIBcbNgJ4IAkgGWoMAQsgCSAJQQdxQdSdAWotAAAiFkEDcSIZdiEJIBdBA0YEQCAWQQV2QQFqIRcgGUEDRgRAIA8gCUEBcUECcjYCfCAPIBdBfyAWQQJ2QQdxIhZ0QX9zIAlBAXZxajYCeCAWQQRqDAILIA8gFyAJIAlBB3FB1J0Bai0AACIJQQNxIhJ2IiBBfyAWQQJ2QQdxIhZ0QX9zcWo2AnggD0F/IAlBAnZBB3EiF3RBf3MgICAWdnEgCUEFdmpBAWo2AnwgFiAZaiASaiAXagwBCyAPIAkgCUEHcUHUnQFqLQAAIglBA3EiEnYiIEF/IBZBAnZBB3EiF3RBf3NxIBZBBXZqQQNqNgJ4IA9BfyAJQQJ2QQdxIhZ0QX9zICAgF3ZxIAlBBXZqQQNqNgJ8IBIgGWogF2ogFmoLIQkCQCAsIA8oAngiGU8EQCAPKAJ8IhIgLE0NAQsgIQRAQQAhByAdQQFBmfYAQQAQDwwHC0EAIQcgHUEBQZn2AEEAEA8MBgsgDyANIAlrNgLwASAPIGAgCa2INwPoASAHQfABcSAYQQ9xckH/AUH/ASAFQQRqIg0gFWtBAXR2IA0gFUwbIgkgCUHVAHEgH0EBShsiCUF/c3EEQCAhBEBBACEHIB1BAUGv2gBBABAPDAcLQQAhByAdQQFBr9oAQQAQDwwGCwJAAkAgHgRAIA9BwAFqEBshFyAPIA8oAtABIBkgAUETdEEfdWoiFms2AtABIA8gDykDyAEgFq2INwPIASAXQX8gFnRBf3NxIAFBCHZBAXEgFnRyQQFyQQJqIBN0IBdBH3RyIRYMAQtBACEWIAlBAXFFDQELIAYgFjYCAAsCQCABQSBxBEAgD0HAAWoQGyEXIA8gDygC0AEgGSABQRJ0QR91aiIWazYC0AEgDyAPKQPIASAWrYg3A8gBIAYgFUECdGogF0F/IBZ0QX9zcSABQQl2QQFxIBZ0ckEBciIWQQJqIBN0IBdBH3RyNgIAIAhBICAWZ2siFiAILQAAQf8AcSIXIBYgF0sbQYABcjoAAAwBCyAJQQJxRQ0AIAYgFUECdGpBADYCAAsgBkEEaiEXAkACQCABQcAAcQRAIA9BwAFqEBshGCAPIA8oAtABIBkgAUERdEEfdWoiFms2AtABIA8gDykDyAEgFq2INwPIASAYQX8gFnRBf3NxIAFBCnZBAXEgFnRyQQFyQQJqIBN0IBhBH3RyIRYMAQtBACEWIAlBBHFFDQELIBcgFjYCAAsgCEEAOgABAkAgAUGAAXEEQCAPQcABahAbIRggDyAPKALQASAZIAFBEHRBH3VqIhZrNgLQASAPIA8pA8gBIBatiDcDyAEgFyAVQQJ0aiAYQX8gFnRBf3NxIAFBC3ZBAXEgFnRyQQFyIgFBAmogE3QgGEEfdHI2AgAgCEGgfyABZ2s6AAEMAQsgCUEIcUUNACAXIBVBAnRqQQA2AgALIAZBCGohAQJAAkAgB0EQcQRAIA9BwAFqEBshGSAPIA8oAtABIBIgB0ETdEEfdWoiFms2AtABIA8gDykDyAEgFq2INwPIASAZQX8gFnRBf3NxIAdBCHZBAXEgFnRyQQFyQQJqIBN0IBlBH3RyIRcMAQtBACEXIAlBEHFFDQELIAEgFzYCAAsCQCAHQSBxBEAgD0HAAWoQGyEZIA8gDygC0AEgEiAHQRJ0QR91aiIWazYC0AEgDyAPKQPIASAWrYg3A8gBIAEgFUECdGogGUF/IBZ0QX9zcSAHQQl2QQFxIBZ0ckEBciIBQQJqIBN0IBlBH3RyNgIAIAhBICABZ2siASAILQABQf8AcSIWIAEgFksbQYABcjoAAQwBCyAJQSBxRQ0AIAEgFUECdGpBADYCAAsgBkEMaiEBAkACQCAHQcAAcQRAIA9BwAFqEBshGSAPIA8oAtABIBIgB0ERdEEfdWoiFms2AtABIA8gDykDyAEgFq2INwPIASAZQX8gFnRBf3NxIAdBCnZBAXEgFnRyQQFyQQJqIBN0IBlBH3RyIRcMAQtBACEXIAlBwABxRQ0BCyABIBc2AgALIAhBAmoiCEEAOgAAAkAgB0GAAXEEQCAPQcABahAbIRYgDyAPKALQASASIAdBEHRBH3VqIglrNgLQASAPIA8pA8gBIAmtiDcDyAEgASAVQQJ0aiAWQX8gCXRBf3NxIAdBC3ZBAXEgCXRyQQFyIgFBAmogE3QgFkEfdHI2AgAgCEGgfyABZ2s6AAAMAQsgCUGAAUkNACABIBVBAnRqQQA2AgALICJBEHMhIiADIAVBBHFqIQMgBkEQaiEGIA0gFUgNAAsLIApBCHEhOCAUQbAMaiEoIBRBoAhqISkgFEGQBGohJSAfQQNOBEAgFUEDbCE5IBVBAXQhOiAmQQFrISBBAyAmQQJrIgF0IS1BASABdCEuIBVBB2pBAXZB/P///wdxQQRqIT0gKyAkQX9zaiIBQQN2IgNBAnQiPkEEaiE7IANBAWoiP0H8////A3EiHEECdCE8IBxBA3QhEiABQRhJIUBBAiEZA0AgGSETIAstAAAhFiALQQA6AAAgIkFvcUECcyEiAkAgFUEATARAIBNBAmohGQwBCyAlIBQgE0EEcRshESATQQJqIRkgDiATIBVsQQJ0aiEIQQAhCiALIQZBACENA0AgDSEFIAYtAAFBBXZBBHEgCiAWQQd2cnIiA0EIdCAPQeABahAvQf8AcUEBdHJBoI0Bai8BACEBAkAgAw0AIAFBACACQQJrIgNBf0YbIQEgAkEBSgRAIAMhAgwBCyAPQYACahAoIQILIA8pA+gBIWUgDygC8AEhTCARIBEoAgAgAUEEdkEDcSABQQJ2QTBxciAidHIiCTYCACABQcAAcSIqQQV2IAFBgAFxIidBBnZyIQogTCABQQdxIgNrIRcgZSADrYgiYKchDUEAIRgCQCAVIAVBAnJMBEBBACEHDAELIAogBi0AAkEFdkEEcSAGLQABQQd2cnIiA0EIdCANQf8AcUEBdHJBoI0Bai8BACEHAkAgAw0AIAdBACACQQJrIgNBf0YbIQcgAkEBSgRAIAMhAgwBCyAPQYACahAoIQILIAdBBXYgB0EGdnJBAnEhCiAXIAdBB3EiA2shFyBgIAOtiCJgpyENCyARIAdBAnRBgAZxIAdBMHFyICJBBGp0IAlyNgIAQQEhCUEBIQMCQCAHQQJ2QQJxIAFBA3ZBAXFyIh5FDQAgDSANQQdxQdSdAWotAAAiA0EDcSINdiEJIB5BA0cEQEEBIAlBfyADQQJ2QQdxIhh0QX9zcSADQQV2akEBaiIDIB5BAUYiHhshCSADQQEgHhshAyANIBhqIRgMAQsgCUEHcUHUnQFqLQAAIh5BA3EiMyANIANBAnZBB3EiG2pqIB5BAnZBB3EiDWohGCAJIDN2IglBfyAbdEF/c3EgA0EFdmpBAWohA0F/IA10QX9zIAkgG3ZxIB5BBXZqQQFqIQkLIA8gFyAYazYC8AEgDyBgIBitiDcD6AEgAUHwAXEiDSANQQFrcQRAIAMgFkH/AHEiFiAGLQABQf8AcSIXIBYgF0sbIhZBAmsiF0EAIBYgF08baiEDCyAHQfABcSIXIBdBAWtxBEAgCSAGLQABQf8AcSIWIAYtAAJB/wBxIhggFiAYSxsiFkECa0EAIBZBAksbaiEJCyADICxNIAkgLE1xRQRAICEEQEEAIQcgHUEBQf32AEEAEA8MCQtBACEHIB1BAUH99gBBABAPDAgLIAYtAAIhFiAGQQA7AAEgFyANQQR2ckH/AUH/ASAFQQRqIg0gFWtBAXR2IA0gFUwbIhdB1QBxIBcgGSAfShsiGEF/c3EEQCAhBEBBACEHIB1BAUGv2gBBABAPDAkLQQAhByAdQQFBr9oAQQAQDwwICwJAAkAgAUEQcQRAIA9BwAFqEBshHiAPIA8oAtABIAMgAUETdEEfdWoiF2s2AtABIA8gDykDyAEgF62INwPIASAeQX8gF3RBf3NxIAFBCHZBAXEgF3RyQQFyQQJqICB0IB5BH3RyIRcMAQtBACEXIBhBAXFFDQELIAggFzYCAAsCQCABQSBxBEAgD0HAAWoQGyEeIA8gDygC0AEgAyABQRJ0QR91aiIXazYC0AEgDyAPKQPIASAXrYg3A8gBIAggFUECdGogHkF/IBd0QX9zcSABQQl2QQFxIBd0ckEBciIXQQJqICB0IB5BH3RyNgIAIAZBICAXZ2siFyAGLQAAQf8AcSIeIBcgHksbQYABcjoAAAwBCyAYQQJxRQ0AIAggFUECdGpBADYCAAsgCEEEaiEeAkACQCAqBEAgD0HAAWoQGyEbIA8gDygC0AEgAyABQRF0QR91aiIXazYC0AEgDyAPKQPIASAXrYg3A8gBIBtBfyAXdEF/c3EgAUEKdkEBcSAXdHJBAXJBAmogIHQgG0EfdHIhFwwBC0EAIRcgGEEEcUUNAQsgHiAXNgIACwJAICcEQCAPQcABahAbIRcgDyAPKALQASADIAFBEHRBH3VqIgNrNgLQASAPIA8pA8gBIAOtiDcDyAEgHiAVQQJ0aiAXQX8gA3RBf3NxIAFBC3ZBAXEgA3RyQQFyIgFBAmogIHQgF0EfdHI2AgAgBkGgfyABZ2s6AAEMAQsgGEEIcUUNACAeIBVBAnRqQQA2AgALIAhBCGohAQJAAkAgB0EQcQRAIA9BwAFqEBshFyAPIA8oAtABIAkgB0ETdEEfdWoiA2s2AtABIA8gDykDyAEgA62INwPIASAXQX8gA3RBf3NxIAdBCHZBAXEgA3RyQQFyQQJqICB0IBdBH3RyIQMMAQtBACEDIBhBEHFFDQELIAEgAzYCAAsCQCAHQSBxBEAgD0HAAWoQGyEXIA8gDygC0AEgCSAHQRJ0QR91aiIDazYC0AEgDyAPKQPIASADrYg3A8gBIAEgFUECdGogF0F/IAN0QX9zcSAHQQl2QQFxIAN0ckEBciIBQQJqICB0IBdBH3RyNgIAIAZBICABZ2siASAGLQABQf8AcSIDIAEgA0sbQYABcjoAAQwBCyAYQSBxRQ0AIAEgFUECdGpBADYCAAsgCEEMaiEBAkACQCAHQcAAcQRAIA9BwAFqEBshFyAPIA8oAtABIAkgB0ERdEEfdWoiA2s2AtABIA8gDykDyAEgA62INwPIASAXQX8gA3RBf3NxIAdBCnZBAXEgA3RyQQFyQQJqICB0IBdBH3RyIQMMAQtBACEDIBhBwABxRQ0BCyABIAM2AgALIAZBAmohBgJAIAdBgAFxBEAgD0HAAWoQGyEXIA8gDygC0AEgCSAHQRB0QR91aiIDazYC0AEgDyAPKQPIASADrYg3A8gBIAEgFUECdGogF0F/IAN0QX9zcSAHQQt2QQFxIAN0ckEBciIBQQJqICB0IBdBH3RyNgIAIAZBoH8gAWdrOgAADAELIBhBgAFJDQAgASAVQQJ0akEANgIACyAiQRBzISIgESAFQQRxaiERIAhBEGohCCANIBVIDQALCwJAIAxBAkkNACATQQJxRQ0AIBlBBHEhAwJAAn8CQAJAIDEEQCAUICUgAxshFkEAIRggFUEATA0BIA4gE0ECayAVbEECdGohEQNAIA9BgAFqEC8hB0EAIQEgFigCACIIBEAgESAYQQJ0aiEBQQAhCUEPIQYDQAJAIAYgCHFFDQAgBkGRosSIAXEiDSAIcQRAIAEgASgCACAHQX9zQQFxICB0cyAucjYCACAHQQF2IQcLIA1BAXQgCHEEQCABIBVBAnRqIgUgBSgCACAHQX9zQQFxICB0cyAucjYCACAHQQF2IQcLIA1BAnQgCHEEQCABIDpBAnRqIgUgBSgCACAHQX9zQQFxICB0cyAucjYCACAHQQF2IQcLIA1BA3QgCHFFDQAgASA5QQJ0aiINIA0oAgAgB0F/c0EBcSAgdHMgLnI2AgAgB0EBdiEHCyABQQRqIQEgBkEEdCEGIAlBAWoiCUEIRw0ACyAIaSEBCyAWQQRqIRYgDyAPKAKQASABazYCkAEgDyAPKQOIASABrYg3A4gBIBhBCGoiGCAVSA0ACwsgKSAoIAMbIQUgFCAlIAMbIRYgA0UhGCAVQQBMDQNBACEDIEANASAFIBYgO2pJIBYgBSA7aiIHSXENAUEAIAUiASAWIgYgPmpBCGpJIAZBBGogB0lxDQIaIAYgPGohBiABIDxqIQH9DAAAAAAAAAAAAAAAAAAAAAAhXkEAIQcDQCAFIAdBAnQiA2oiCSADIBZqIgP9AAIAIl9BBP2tASBfQQT9qwEgXiBf/Q0MDQ4PEBESExQVFhcYGRobQRz9rQH9UP1QIF/9UCJe/QsCACAJIF4gA/0AAgRBHP2rAf1QIl5BAf2tAf0Md3d3d3d3d3d3d3d3d3d3d/1OIF5BAf2rAf0M7u7u7u7u7u7u7u7u7u7u7v1O/VAgXv1QIF/9T/0LAgAgXyFeIAdBBGoiByAcRw0ACyAcID9GDQMgEiEDIF79GwMMAgsgA0UhGCApICggAxshBQwCCyAFIQEgFiEGQQALIQcDQCAHQRx2IQkgASAGKAIAIgdBBHYgCSAHQQR0cnIgB3IiCTYCACABIAkgBigCBEEcdHIiCUEBdkH37t27B3EgCUEBdEHu3bv3fnFyIAlyIAdBf3NxNgIAIAFBBGohASAGQQRqIQYgA0EIaiIDIBVIDQALCyATQQZJDQBBACEJQQAhESAWIQEgKSAoIBgbIhshByAUICUgGBsiFyEGAkAgFUEATCINDQADQCABQQRqIQMgBygCACEIIAEoAgAhASAHIDgEfyAIBSABQQR0IBFBHHZyIAFBBHZyIAMoAgBBHHRyIAFyQQN0QYiRosR4cSAIcgsgBigCAEF/c3E2AgAgBkEEaiEGIAdBBGohByABIREgAyEBIAlBCGoiCSAVSA0ACyANDQAgDiATQQZrIBVsQQJ0aiFBQQAhHiAXIREDQEEAIQMgGygCACIBBEAgFSAeayFCQQAhB0EAIQoDQCAHIU0gD0GgAWoQGyEHAkAgCiAKQQRqIgYgQiAGIB5qIBVIGyIzTiJDBEBBACEGDAELIBEoAgBBf3MhKiBBIAogHnJBAnRqIRhBACEGQQ8gCiIJQQJ0IkR0Ig0hCANAAkAgASAIcUUNACAIQZGixIgBcSInIAFxBEAgB0EBcQRAIAMgJ3IhA0EyIAlBAnR0ICpxIAFyIQELIAdBAXYhByAGQQFqIQYLIAEgJ0EBdCI0cQRAIAdBAXEEQCADIDRyIQMgAUH0ACAJQQJ0dCAqcXIhAQsgB0EBdiEHIAZBAWohBgsgASAnQQJ0IjRxBEAgB0EBcQRAIAMgNHIhAyABQegBIAlBAnR0ICpxciEBCyAHQQF2IQcgBkEBaiEGCyABICdBA3QiJ3FFDQAgB0EBcQRAIAMgJ3IhAyABQcABIAlBAnR0ICpxciEBCyAGQQFqIQYgB0EBdiEHCyAIQQR0IQggCUEBaiIJIDNIDQALIAMgRHZB//8DcUUNACBDDQADQAJAIAMgDXFFDQAgDUGRosSIAXEiCSADcQRAIBggGCgCACAHQR90ciAtcjYCACAHQQF2IQcgBkEBaiEGCyAJQQF0IANxBEAgGCAVQQJ0aiIIIAgoAgAgB0EfdHIgLXI2AgAgB0EBdiEHIAZBAWohBgsgCUECdCADcQRAIBggOkECdGoiCCAIKAIAIAdBH3RyIC1yNgIAIAdBAXYhByAGQQFqIQYLIAlBA3QgA3FFDQAgGCA5QQJ0aiIJIAkoAgAgB0EfdHIgLXI2AgAgBkEBaiEGIAdBAXYhBwsgDUEEdCENIBhBBGohGCAKQQFqIgogM0gNAAsLIA8gDygCsAEgBms2ArABIA8gDykDqAEgBq2INwOoAUEBIQdBBCEKIE1BAXFFDQALIBsgGygCBCADQRt2QQ5xIANBHXZyIANBHHZyIBEoAgRBf3NxcjYCBAsgESgCACADciIDQQN2QZGixIgBcSIBQQR2IAFBBHRyIAFyIQYgHgRAIAVBBGsiByAHKAIAIBZBBGsoAgBBf3MgAUEcdHFyNgIACyAFIAUoAgAgBiAWKAIAQX9zcXI2AgAgBSAFKAIEIBYoAgRBf3MgA0EfdnFyNgIEIBtBBGohGyARQQRqIREgBUEEaiEFIBZBBGohFiAeQQhqIh4gFUgNAAsLIBdBACA9EBUaCyAZIB9IDQALCwJAIAxBAkkNAAJAIB9BA3FBAWsiFkECSSAxcQRAIBVBAEwNAUEBICZBAmt0IQIgDiAfQfz//wdxIBVsQQJ0aiERICUgFCAfQQRxGyEFICZBAWshCEEAIQogFUEMbCEMIBVBA3QhCwNAIA9BgAFqEC8hB0EAIQEgBSgCACIDBEAgESAKQQJ0aiEBQQ8hBkEAIQkDQAJAIAMgBnFFDQAgBkGRosSIAXEiDSADcQRAIAEgASgCACAHQX9zQQFxIAh0cyACcjYCACAHQQF2IQcLIA1BAXQgA3EEQCABIBVBAnRqIh0gHSgCACAHQX9zQQFxIAh0cyACcjYCACAHQQF2IQcLIA1BAnQgA3EEQCABIAtqIh0gHSgCACAHQX9zQQFxIAh0cyACcjYCACAHQQF2IQcLIA1BA3QgA3FFDQAgASAMaiINIA0oAgAgB0F/c0EBcSAIdHMgAnI2AgAgB0EBdiEHCyABQQRqIQEgBkEEdCEGIAlBAWoiCUEIRw0ACyADaSEBCyAFQQRqIQUgDyAPKAKQASABazYCkAEgDyAPKQOIASABrYg3A4gBIApBCGoiCiAVSA0ACwsgFkEBSw0AIBVBAEwNACAlIBQgH0EEcSIBGyEJICggKSABGyECQQAhAwJ/AkAgKyAkQX9zaiIBQThJDQAgAiAJIAFBAXZB/P///wdxIgZBBGoiB2pJIAkgAiAHaiIHSXENACACIAYgCWpBCGpJIAlBBGogB0lxDQAgAUEDdkEBaiINQfz///8DcSIIQQN0IQMgCSAIQQJ0IgFqIQYgASACaiEB/QwAAAAAAAAAAAAAAAAAAAAAIV5BACEHA0AgAiAHQQJ0IhZqIhEgCSAWaiIW/QACACJfQQT9rQEgX0EE/asBIF4gX/0NDA0ODxAREhMUFRYXGBkaG0Ec/a0B/VD9UCBf/VAiXv0LAgAgESBeIBb9AAIEQRz9qwH9UCJeQQH9rQH9DHd3d3d3d3d3d3d3d3d3d3f9TiBeQQH9qwH9DO7u7u7u7u7u7u7u7u7u7u79Tv1QIF79UCBf/U/9CwIAIF8hXiAHQQRqIgcgCEcNAAsgCCANRg0CIF79GwMMAQsgAiEBIAkhBkEACyEHA0AgB0EcdiEJIAEgBigCACIHQQR2IAkgB0EEdHJyIAdyIgk2AgAgASAJIAYoAgRBHHRyIglBAXZB9+7duwdxIAlBAXRB7t27935xciAJciAHQX9zcTYCACABQQRqIQEgBkEEaiEGIANBCGoiAyAVSA0ACwsgHyAfQQFqQQNxa0EDa0EAIB9BBkobIhEgH04NAEEDICZBAmt0IRkgKyAkQX9zaiIBQQN2IgNBAnQiK0EEaiEdIANBAWoiA0H8////A3EiEkECdCEhIBJBA3QhFiAVQQxsISwgFUEDdCEtIAFBGEkhJiADIBJGIRsDQAJAAkACQAJAAn8CQCAfIBFrIgFBAWsiA0EDTwRAQX8hFyABQQVIDQUgFUEATA0GICUgFCARQQRxIgEbIQIgKCApIAEbIQkgOARAQQAhBiAmDQQgAiAJIB1qSSACIB1qIAlLcQ0EIAIgIWohASAJICFqIQcDQCAJIAZBAnQiA2oiCCAI/QACACACIANq/QACAP1P/QsCACAGQQRqIgYgEkcNAAsgFiEGIBsNBgwFCyAUICUgARshDUEAIQMgJg0BIAkgDSAdakkgDSAJIB1qIgFJcQ0BIAkgDSArakEIakkgDUEEaiABSXENASAJIAIgHWpJIAEgAktxDQEgAiAhaiEIIAkgIWohASANICFqIQf9DAAAAAAAAAAAAAAAAAAAAAAhXkEAIQYDQCAJIAZBAnQiA2oiBSADIA1qIgz9AAIAIl9BBP2tASBfQQT9qwEgXiBf/Q0MDQ4PEBESExQVFhcYGRobQRz9rQH9UP1QIAz9AAIEQRz9qwH9UCBf/VBBA/2rAf0MiIiIiIiIiIiIiIiIiIiIiP1OIAX9AAIA/VAgAiADav0AAgD9T/0LAgAgXyFeIAZBBGoiBiASRw0ACyAbDQUgFiEDIF79GwMMAgsgA0ECdEHcnQFqKAIAIRcMBAsgDSEHIAkhASACIQhBAAshBgNAIAZBHHYhCSABIAEoAgAgBygCACIGQQR2IAkgBkEEdHJyIAcoAgRBHHRyIAZyQQN0QYiRosR4cXIgCCgCAEF/c3E2AgAgCEEEaiEIIAFBBGohASAHQQRqIQcgA0EIaiIDIBVIDQALDAILIAkhByACIQELA0AgByAHKAIAIAEoAgBBf3NxNgIAIAFBBGohASAHQQRqIQcgBkEIaiIGIBVIDQALCyAVQQBMDQAgJSAUIBFBBHEiARshCiAoICkgARshAiAUICUgARshEyApICggARshHiAOIBEgFWxBAnRqIS5BACEFA0BBACEDIAIoAgAgF3EiAQRAIBUgBWshKkEAIQdBACENA0AgByFOIA9BoAFqEBshBwJAIA0gDUEEaiIGICogBSAGaiAVSBsiJE4iJwRAQQAhBgwBCyAXIAooAgBBf3NxIRggLiAFIA1yQQJ0aiELQQAhBkEPIA0iCUECdCIcdCIgIQgDQAJAIAEgCHFFDQAgCEGRosSIAXEiIiABcQRAIAdBAXEEQCADICJyIQNBMiAJQQJ0dCAYcSABciEBCyAHQQF2IQcgBkEBaiEGCyABICJBAXQiMXEEQCAHQQFxBEAgAyAxciEDIAFB9AAgCUECdHQgGHFyIQELIAdBAXYhByAGQQFqIQYLIAEgIkECdCIxcQRAIAdBAXEEQCADIDFyIQMgAUHoASAJQQJ0dCAYcXIhAQsgB0EBdiEHIAZBAWohBgsgASAiQQN0IiJxRQ0AIAdBAXEEQCADICJyIQMgAUHAASAJQQJ0dCAYcXIhAQsgBkEBaiEGIAdBAXYhBwsgCEEEdCEIIAlBAWoiCSAkSA0ACyADIBx2Qf//A3FFDQAgJw0AA0ACQCADICBxRQ0AICBBkaLEiAFxIgkgA3EEQCALIAsoAgAgB0EfdHIgGXI2AgAgB0EBdiEHIAZBAWohBgsgCUEBdCADcQRAIAsgFUECdGoiCCAIKAIAIAdBH3RyIBlyNgIAIAdBAXYhByAGQQFqIQYLIAlBAnQgA3EEQCALIC1qIgggCCgCACAHQR90ciAZcjYCACAHQQF2IQcgBkEBaiEGCyAJQQN0IANxRQ0AIAsgLGoiCSAJKAIAIAdBH3RyIBlyNgIAIAZBAWohBiAHQQF2IQcLICBBBHQhICALQQRqIQsgDUEBaiINICRIDQALCyAPIA8oArABIAZrNgKwASAPIA8pA6gBIAatiDcDqAFBASEHQQQhDSBOQQFxRQ0ACyACIAIoAgQgA0EbdkEOcSADQR12ciADQRx2ciAKKAIEQX9zcXI2AgQLIAooAgAgA3IiA0EDdkGRosSIAXEiAUEEdiABQQR0ciABciEGIAUEQCAeQQRrIgcgBygCACATQQRrKAIAQX9zIAFBHHRxcjYCAAsgHiAeKAIAIAYgEygCAEF/c3FyNgIAIB4gHigCBCATKAIEQX9zIANBH3ZxcjYCBCACQQRqIQIgCkEEaiEKIB5BBGohHiATQQRqIRMgBUEIaiIFIBVIDQALCyARQQRqIhEgH0gNAAsLQQEhByAfQQBMDQMgFUEATA0DIBVB/P///wdxIgZBAnQhAiAVQQRJIQhBACEJA0AgDiAJIBVsQQJ0aiEDAkACQCAIBEAgAyEHQQAhAQwBCyACIANqIQdBACEBA0AgAyABQQJ0aiINIA39AAIAIl79DP///3////9/////f////3/9TiJf/aEBIF8gXv0MAAAAAAAAAAAAAAAAAAAAAP05/VL9CwIAIAFBBGoiASAGRw0ACyAGIgEgFUYNAQsDQCAHQQAgBygCACIDQf////8HcSINayANIANBAEgbNgIAIAdBBGohByABQQFqIgEgFUcNAAsLQQEhByAJQQFqIgkgH0cNAAsMAwsgIUUNACAPIBooAhg2AjQgDyAWNgIwIB1BAUHcxwAgD0EwahAPDAELIA8gATYCFCAPIBY2AhAgHUEBQdzHACAPQRBqEA9BACEHDAELQQAhBwsgD0GwAmokACAHDQEMAwsgBCABQQl0QdCpAWo2AmwCfyAEKAJ0IQECQAJAIBooAhAgGigCCGsiBSAaKAIUIBooAgxrIglsIgMgBCgChAFLBEAgARAQIAQgA0ECdBAYIgE2AnRBACABRQ0DGiAEIAM2AoQBDAELIAFFDQELIAFBACADQQJ0EBUaCyAEKAJ4IQECQCAFQQJqIgYgCUEDakECdiIMQQJqbCIDIAQoAogBTQRAIANBAnQhCAwBCyABEBAgBCADQQJ0IggQGCIBNgJ4IAENAEEADAELIAQgAzYCiAEgAUEAIAgQFRoCQCAGRQ0AIAQoAngiByEBAkAgBkEETwRAIAcgBkF8cSINQQJ0aiEBQQAhCANAIAcgCEECdGr9DAAAIEkAACBJAAAgSQAAIEn9CwIAIAhBBGoiCCANRw0ACyAGIA1GDQELA0AgAUGAgIDJBDYCACABQQRqIQEgDUEBaiINIAZHDQALCyAHIAxBAWogBmxBAnRqIQNBACENAkACQCAGQQRJBEAgAyEBDAELIAMgBkF8cSINQQJ0aiEBQQAhCANAIAMgCEECdGr9DAAAIEkAACBJAAAgSQAAIEn9CwIAIAhBBGoiCCANRw0ACyAGIA1GDQELA0AgAUGAgIDJBDYCACABQQRqIQEgDUEBaiINIAZHDQALCyAJQQNxIgFFDQAgBkUNAEGAgIDIBEGAgIDABEGAgICABCABQQJGGyABQQFGGyELIAcgBiAMbEECdGohA0EAIQ0CQCAGQQRJBEAgAyEBDAELIAMgBkF8cSINQQJ0aiEBIAv9ESFfQQAhCANAIAMgCEECdGogX/0LAgAgCEEEaiIIIA1HDQALIAYgDUYNAQsDQCABIAs2AgAgAUEEaiEBIA1BAWoiDSAGRw0ACwsgBCAJNgKAASAEIAU2AnxBAQtFDQIgGigCHCARaiIZQR9OBEAgIUUNAiAjIBk2AhAgHUECQdXBACAjQRBqEA8MAwsgBBBaQQAhASAEQbCpATYCZCAEQdCeATYCYCAEQfCeATYCHAJAAkACQAJAIBooAjQiB0EBSw0AIAQoApABRQ0CIAcNAAwBCyAaKAIEIQMgB0EETwRAIAdBfHEhAkEAIQYDQCADIAZBA3RqIgFBHGogAUEUaiABQQxqIAH9CQIE/VYCAAH9VgIAAv1WAgADIF79rgEhXiAGQQRqIgYgAkcNAAsgXiBeIF79DQgJCgsMDQ4PAAECAwABAgP9rgEiXiBeIF79DQQFBgcAAQIDAAECAwABAgP9rgH9GwAhASACIAdGDQELA0AgAyACQQN0aigCBCABaiEBIAJBAWoiAiAHRw0ACwsgAUECaiIDIAQoApgBSwRAIAQoApQBIAMQFyIGRQ0FIAQgBjYClAEgASAGakEAOwAAIAQgAzYCmAEgGigCNCEHCyAEKAKUASEeIAdFDQEgGigCBCEGQQAhAkEAIQEDQCACIB5qIAYgAUEDdCIDaiIGKAIAIAYoAgQQEhogGigCBCIGIANqKAIEIAJqIQIgAUEBaiIBIBooAjRJDQALDAELIAdBAUcNASAaKAIEKAIAIR4LIBooAjwiAQRAIAQoAnQhLCAEIAE2AnQLIBooAiwEQCAWQQhxISUgBEEcaiEPIBZBAXEhLSAWQQJxRSEuQQIhHwNAIB4gKGohASAaKAIAIClBGGxqIiAoAgAhAwJAIC0gH0ECSSAZIBooAhxBBGtMcXEiIgRAIAQgATYCFCAEIAEgA2oiAzYCGCAEIAMvAAA7AXAgA0H/AToAACAEKAIYQf8BOgABIARBADYCCCAEQQA2AgAgBCABNgIQDAELIAQgATYCFCAEIAEgA2oiBjYCGCAEIAYvAAA7AXAgBkH/AToAACAEKAIYQf8BOgABIAQgBEEcajYCaCAEIAE2AhAgBEEANgIMIAQgAwR/IAEtAABBEHQFQYCA/AcLIgM2AgBBASEGIAFBAWohCSABLQABIQcCfyABLQAAQf8BRgRAIAdBkAFPBEAgBEEBNgIMIANBgP4DcgwCCyAEIAk2AhBBACEGIAdBCXQgA2oMAQsgBCAJNgIQIAdBCHQgA3ILIQEgBCAGNgIIIARBgIACNgIEIAQgAUEHdDYCAAsgICgCACEqAkAgGUEATA0AICAoAghFDQAgIiAuciEnQQAhJgNAAkACQAJAAkACQCAfQQFrDgIBAgALICIEQEEBIBl0IgFBAXYgAXIhESAEKAJ8IgVBAnQiDSAEKAJ4akEMaiEBIAQoAnQhBkEAIQggBCgCgAEiA0EETwRAIAVFDQUgBUEDbCECIAVBAXQhDEEAIBFrIQkDQCAMQQJ0IQtBACEDA0ACQCABIgcoAgAiAUUNAAJAIAFBkICAAXENACABQe8DcUUNACAEKAIAIQECQCAEKAIIIhANACABQf8BRiEKIAQoAhAiEC0AACEBAkAgCkUEQCAEIAE2AgAgBCAQQQFqNgIQDAELIAFBjwFNBEAgBCABNgIAIAQgEEEBajYCEEEHIRAMAgtB/wEhASAEQf8BNgIAC0EIIRALIAQgEEEBayIQNgIIAkAgASAQdkEBcUUNAAJAIBANACABQf8BRiEKIAQoAhAiEC0AACEBAkAgCkUEQCAEIAE2AgAgBCAQQQFqNgIQDAELIAFBjwFNBEAgBCABNgIAIAQgEEEBajYCEEEHIRAMAgtB/wEhASAEQf8BNgIAC0EIIRALIAQgEEEBayIQNgIIIAYgCSARIAEgEHZBAXEiEBs2AgAgBCgCfCEBIAdBBGsiCiAKKAIAQSByNgIAIAcgBygCBEEIcjYCBCAHIAcoAgAgEEETdHJBEHI2AgAgJQ0AIAdBfiABa0ECdGoiASABKAIEQYCAAnI2AgQgASABKAIAIBBBH3RyQYCABHI2AgAgAUEEayIBIAEoAgBBgIAIcjYCAAsgByAHKAIAQYCAgAFyIgE2AgALAkAgAUGAgYAIcQ0AIAFB+B5xRQ0AIAQoAgAhAQJAIAQoAggiEA0AIAFB/wFGIQogBCgCECIQLQAAIQECQCAKRQRAIAQgATYCACAEIBBBAWo2AhAMAQsgAUGPAU0EQCAEIAE2AgAgBCAQQQFqNgIQQQchEAwCC0H/ASEBIARB/wE2AgALQQghEAsgBCAQQQFrIhA2AgggBwJ/IAEgEHZBAXFFBEAgBygCAAwBCwJAIBANACABQf8BRiEKIAQoAhAiEC0AACEBAkAgCkUEQCAEIAE2AgAgBCAQQQFqNgIQDAELIAFBjwFNBEAgBCABNgIAIAQgEEEBajYCEEEHIRAMAgtB/wEhASAEQf8BNgIAC0EIIRALIAQgEEEBayIQNgIIIAYgDWogCSARIAEgEHZBAXEiARs2AgAgB0EEayIQIBAoAgBBgAJyNgIAIAcgBygCBEHAAHI2AgQgBygCACABQRZ0ckGAAXILQYCAgAhyIgE2AgALAkAgAUGAiIDAAHENACABQcD3AXFFDQAgBCgCACEBAkAgBCgCCCIQDQAgAUH/AUYhCiAEKAIQIhAtAAAhAQJAIApFBEAgBCABNgIAIAQgEEEBajYCEAwBCyABQY8BTQRAIAQgATYCACAEIBBBAWo2AhBBByEQDAILQf8BIQEgBEH/ATYCAAtBCCEQCyAEIBBBAWsiEDYCCCAHAn8gASAQdkEBcUUEQCAHKAIADAELAkAgEA0AIAFB/wFGIQogBCgCECIQLQAAIQECQCAKRQRAIAQgATYCACAEIBBBAWo2AhAMAQsgAUGPAU0EQCAEIAE2AgAgBCAQQQFqNgIQQQchEAwCC0H/ASEBIARB/wE2AgALQQghEAsgBCAQQQFrIhA2AgggBiALaiAJIBEgASAQdkEBcSIBGzYCACAHQQRrIhAgECgCAEGAEHI2AgAgByAHKAIEQYAEcjYCBCAHKAIAIAFBGXRyQYAIcgtBgICAwAByIgE2AgALIAFBgMCAgARxDQAgAUGAvA9xRQ0AIAQoAgAhAQJAIAQoAggiEA0AIAFB/wFGIQogBCgCECIQLQAAIQECQCAKRQRAIAQgATYCACAEIBBBAWo2AhAMAQsgAUGPAU0EQCAEIAE2AgAgBCAQQQFqNgIQQQchEAwCC0H/ASEBIARB/wE2AgALQQghEAsgBCAQQQFrIhA2AgggASAQdkEBcQRAIAYgAkECdGohTwJAIBANACABQf8BRiEUIAQoAhAiEC0AACEBAkAgFEUEQCAEIAE2AgAgBCAQQQFqNgIQDAELIAFBjwFNBEAgBCABNgIAIAQgEEEBajYCEEEHIRAMAgtB/wEhASAEQf8BNgIAC0EIIRALIAQgEEEBayIQNgIIIE8gCSARIAEgEHZBAXEiEBs2AgAgBCgCfCEBIAdBBGsiCiAKKAIAQYCAAXI2AgAgByAHKAIEQYAgcjYCBCAHIAcoAgAgEEEcdHJBgMAAcjYCACAHIAFBAnRqIgEgASgCBEEEcjYCBCABIAEoAgxBAXI2AgwgASABKAIIIBBBEnRyQQJyNgIICyAHIAcoAgBBgICAgARyNgIACyAGQQRqIQYgB0EEaiEBIANBAWoiAyAFRw0ACyAHQQxqIQEgBiACQQJ0aiEGIAhBBGoiCCAEKAKAASIDQXxxSQ0ACwsgAyAITQ0DIAVFDQNBACETQQAgEWshCyADIRADQAJAIAggEEYEQCAIIRAMAQsgAUEEayEMIAEoAgAhDUEAIQIDQAJAIA0gAkEDbCIHdiIJQZCAgAFxDQAgCUHvA3FFDQAgBCgCACEDAkAgBCgCCCIJDQAgA0H/AUchECAEKAIQIgktAAAhAwJAIBBFBEAgA0GQAU8EQEH/ASEDIARB/wE2AgAMAgsgBCADNgIAIAQgCUEBajYCEEEHIQkMAgsgBCADNgIAIAQgCUEBajYCEAtBCCEJCyAEIAlBAWsiCTYCCAJAIAMgCXZBAXFFDQAgBiACIAVsQQJ0aiFQAkAgCQ0AIANB/wFHIQ0gBCgCECIJLQAAIQMCQCANRQRAIANBkAFPBEBB/wEhAyAEQf8BNgIADAILIAQgAzYCACAEIAlBAWo2AhBBByEJDAILIAQgAzYCACAEIAlBAWo2AhALQQghCQsgBCAJQQFrIgk2AgggUCALIBEgAyAJdkEBcSIJGzYCACAEKAJ8IRAgDCAMKAIAQSAgB3RyNgIAIAEgASgCACAJQRN0QRByIAd0cjYCACABIAEoAgRBCCAHdHI2AgQgAiAlckUEQCABQX4gEGtBAnRqIgMgAygCBEGAgAJyNgIEIAMgAygCACAJQR90ckGAgARyNgIAIANBBGsiAyADKAIAQYCACHI2AgALIAJBA0cNACABIBBBAnRqIgMgAygCBEEEcjYCBCADIAMoAgxBAXI2AgwgAyADKAIIIAlBEnRyQQJyNgIICyABIAEoAgBBgICAASAHdHIiDTYCACAEKAKAASEDCyADIRAgAkEBaiICIAMgCGtJDQALCyAGQQRqIQYgAUEEaiEBIBNBAWoiEyAFRw0ACwwDC0EAIQdBACENQQAhFwJAAkACQAJAIAQoAnwiEEHAAEcNACAEKAKAAUHAAEcNAEEAQQEgGXQiAUEBdiABciIRayEFIARBHGohECAEKAJ4QYwCaiEGIAQoAgghCCAEKAIEIQMgBCgCACECIAQoAmghDCAEKAJ0IQEgFkEIcQ0BA0BBACEXA0AgASEJIAYiBygCACIGBEACQCAGQZCAgAFxDQAgBkHvA3EiAUUNACADIBAgBCgCbCABai0AAEECdGoiDCgCACILKAIAIgFrIQMCfyABIAJBEHZLBEAgCygCBCEKIAwgC0EIQQwgASADSyIUG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQMgCC0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIANBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCADQQh0IAJqIQILIAhBAWshCCACQQF0IQIgAUEBdCIBQYCAAkkNAAsgASEDIAogCkUgFBsMAQsgAiABQRB0ayECIANBgIACcUUEQCALKAIEIQogDCALQQxBCCABIANLIhQbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiELIAgtAAEhASAILQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAwCCyAEIAs2AhAgAUEJdCACaiECQQchCAwBCyAEIAs2AhBBCCEIIAFBCHQgAmohAgsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyAKRSAKIBQbDAELIAsoAgQLBH8gAyAQIAcoAgRBEXZBBHEgB0EEayIKKAIAQRN2QQFxIAZBDnZBEHEgBkEQdkHAAHEgBkGqAXFycnJyIhRB0LkBai0AAEECdGoiDCgCACILKAIAIgFrIQMgFEHQuwFqLQAAIRMgCSAFIBECfyABIAJBEHZLBEAgCygCBCEUIAwgC0EIQQwgASADSyIOG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQMgCC0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIANBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCADQQh0IAJqIQILIAhBAWshCCACQQF0IQIgAUEBdCIBQYCAAkkNAAsgASEDIBQgFEUgDhsMAQsgAiABQRB0ayECIANBgIACcUUEQCALKAIEIRQgDCALQQxBCCABIANLIg4baigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiELIAgtAAEhASAILQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAwCCyAEIAs2AhAgAUEJdCACaiECQQchCAwBCyAEIAs2AhBBCCEIIAFBCHQgAmohAgsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyAURSAUIA4bDAELIAsoAgQLIBNzIgEbNgIAIAogCigCAEEgcjYCACAHIAcoAgRBCHI2AgQgB0GMAmsiCyALKAIAQYCACHI2AgAgB0GEAmsiCyALKAIAQYCAAnI2AgAgB0GIAmsiCyALKAIAIAFBH3RyQYCABHI2AgAgBiABQRN0ckEQcgUgBgtBgICAAXIhBgsCQCAGQYCBgAhxDQAgBkH4HnFFDQAgAyAQIAQoAmwgBkEDdiIUQe8DcWotAABBAnRqIgwoAgAiCygCACIBayEDAn8gASACQRB2SwRAIAsoAgQhCiAMIAtBCEEMIAEgA0siExtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEDIAgtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECADQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggA0EIdCACaiECCyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyAKIApFIBMbDAELIAIgAUEQdGshAiADQYCAAnFFBEAgCygCBCEKIAwgC0EMQQggASADSyITG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQEgCC0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIAFBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCABQQh0IAJqIQILIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgCkUgCiATGwwBCyALKAIECwR/IAMgECAHKAIEQRR2QQRxIAdBBGsiCigCAEEWdkEBcSAGQQ92QRBxIAZBE3ZBwABxIBRBqgFxcnJyciIUQdC5AWotAABBAnRqIgwoAgAiCygCACIBayEDIBRB0LsBai0AACETIAkgBSARAn8gASACQRB2SwRAIAsoAgQhFCAMIAtBCEEMIAEgA0siDhtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEDIAgtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECADQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggA0EIdCACaiECCyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyAUIBRFIA4bDAELIAIgAUEQdGshAiADQYCAAnFFBEAgCygCBCEUIAwgC0EMQQggASADSyIOG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQEgCC0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIAFBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCABQQh0IAJqIQILIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgFEUgFCAOGwwBCyALKAIECyATcyIBGzYCgAIgCiAKKAIAQYACcjYCACAHIAcoAgRBwAByNgIEIAYgAUEWdHJBgAFyBSAGC0GAgIAIciEGCwJAIAZBgIiAwABxDQAgBkHA9wFxRQ0AIAMgECAEKAJsIAZBBnYiFEHvA3FqLQAAQQJ0aiIMKAIAIgsoAgAiAWshAwJ/IAEgAkEQdksEQCALKAIEIQogDCALQQhBDCABIANLIhMbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiELIAgtAAEhAyAILQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAwCCyAEIAs2AhAgA0EJdCACaiECQQchCAwBCyAEIAs2AhBBCCEIIANBCHQgAmohAgsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgCiAKRSATGwwBCyACIAFBEHRrIQIgA0GAgAJxRQRAIAsoAgQhCiAMIAtBDEEIIAEgA0siExtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEBIAgtAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECABQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggAUEIdCACaiECCyAIQQFrIQggAkEBdCECIANBAXQiA0GAgAJJDQALIApFIAogExsMAQsgCygCBAsEfyADIBAgBygCBEEXdkEEcSAHQQRrIgooAgBBGXZBAXEgBkESdkEQcSAGQRZ2QcAAcSAUQaoBcXJycnIiFEHQuQFqLQAAQQJ0aiIMKAIAIgsoAgAiAWshAyAUQdC7AWotAAAhEyAJIAUgEQJ/IAEgAkEQdksEQCALKAIEIRQgDCALQQhBDCABIANLIg4baigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiELIAgtAAEhAyAILQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAwCCyAEIAs2AhAgA0EJdCACaiECQQchCAwBCyAEIAs2AhBBCCEIIANBCHQgAmohAgsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgFCAURSAOGwwBCyACIAFBEHRrIQIgA0GAgAJxRQRAIAsoAgQhFCAMIAtBDEEIIAEgA0siDhtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEBIAgtAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECABQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggAUEIdCACaiECCyAIQQFrIQggAkEBdCECIANBAXQiA0GAgAJJDQALIBRFIBQgDhsMAQsgCygCBAsgE3MiARs2AoAEIAogCigCAEGAEHI2AgAgByAHKAIEQYAEcjYCBCAGIAFBGXRyQYAIcgUgBgtBgICAwAByIQYLAkAgBkGAwICABHENACAGQYC8D3FFDQAgAyAQIAQoAmwgBkEJdiIUQe8DcWotAABBAnRqIgwoAgAiCygCACIBayEDAn8gASACQRB2SwRAIAsoAgQhCiAMIAtBCEEMIAEgA0siExtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEDIAgtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECADQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggA0EIdCACaiECCyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyAKIApFIBMbDAELIAIgAUEQdGshAiADQYCAAnFFBEAgCygCBCEKIAwgC0EMQQggASADSyITG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQEgCC0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIAFBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCABQQh0IAJqIQILIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgCkUgCiATGwwBCyALKAIECwR/IAMgECAHKAIEQRp2QQRxIAdBBGsiCigCAEEcdkEBcSAGQRV2QRBxIAZBGXZBwABxIBRBqgFxcnJyciIUQdC5AWotAABBAnRqIgwoAgAiCygCACIBayEDIBRB0LsBai0AACETIAkgBSARAn8gASACQRB2SwRAIAsoAgQhFCAMIAtBCEEMIAEgA0siDhtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEDIAgtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECADQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggA0EIdCACaiECCyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyAUIBRFIA4bDAELIAIgAUEQdGshAiADQYCAAnFFBEAgCygCBCEUIAwgC0EMQQggASADSyIOG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQEgCC0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIAFBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCABQQh0IAJqIQILIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgFEUgFCAOGwwBCyALKAIECyATcyIBGzYCgAYgCiAKKAIAQYCAAXI2AgAgByAHKAIEQYAgcjYCBCAHIAcoAoQCQQRyNgKEAiAHIAcoAowCQQFyNgKMAiAHIAcoAogCIAFBEnRyQQJyNgKIAiAGIAFBHHRyQYDAAHIFIAYLQYCAgIAEciEGCyAHIAY2AgALIAdBBGohBiAJQQRqIQEgF0EBaiIXQcAARw0ACyAHQQxqIQYgCUGEBmohASANQTxJIVEgDUEEaiENIFENAAsMAgtBASAZdCIBQQF2IAFyIQ0gBCgCeCIJIBBBAnRqQQxqIQYgBCgCgAEhASAEKAIIIQggBCgCBCEDIAQoAgAhAiAEKAJoIQwgBCgCdCERAkAgFkEIcQRAAkAgAUEESQ0AIBAEQEEAIA1rIRQgBEEcaiEFIBBBDGwhEyAQQQN0IRUDQEEAIQsDQCAGIgkoAgAiBgRAAkAgBkGQgIABcQ0AIAZB7wNxIgFFDQAgAyAFIAQoAmwgAWotAABBAnRqIgwoAgAiCigCACIBayEDAn8gASACQRB2TQRAIAIgAUEQdGshAiADQYCAAnEEQCAKKAIEDAILIAooAgQhDiAMIApBDEEIIAEgA0siEhtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQogCC0AASEBIAgtAABB/wFHBEAgBCAKNgIQQQghCCABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAo2AhAgAUEJdCACaiECQQchCAwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEICyAIQQFrIQggAkEBdCECIANBAXQiA0GAgAJJDQALIA5FIA4gEhsMAQsgCigCBCEOIAwgCkEIQQwgASADSyISG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQMgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIANBCHQgAmohAgwBCyADQY8BTQRAIAQgCjYCECADQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgAUEBdCIBQYCAAkkNAAsgASEDIA4gDkUgEhsLBH8gAyAFIAkoAgRBEXZBBHEgCUEEayIOKAIAQRN2QQFxIAZBDnZBEHEgBkEQdkHAAHEgBkGqAXFycnJyIhJB0LkBai0AAEECdGoiDCgCACIKKAIAIgFrIQMgEkHQuwFqLQAAIRggESAUIA0CfyABIAJBEHZNBEAgAiABQRB0ayECIANBgIACcQRAIAooAgQMAgsgCigCBCESIAwgCkEMQQggASADSyIbG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQEgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgEkUgEiAbGwwBCyAKKAIEIRIgDCAKQQhBDCABIANLIhsbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhAyAILQAAQf8BRwRAIAQgCjYCEEEIIQggA0EIdCACaiECDAELIANBjwFNBEAgBCAKNgIQIANBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgEiASRSAbGwsgGHMiARs2AgAgDiAOKAIAQSByNgIAIAkgCSgCBEEIcjYCBCAGIAFBE3RyQRByBSAGC0GAgIABciEGCwJAIAZBgIGACHENACAGQfgecUUNACADIAUgBCgCbCAGQQN2IhJB7wNxai0AAEECdGoiDCgCACIKKAIAIgFrIQMCfyABIAJBEHZNBEAgAiABQRB0ayECIANBgIACcQRAIAooAgQMAgsgCigCBCEOIAwgCkEMQQggASADSyIYG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQEgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgDkUgDiAYGwwBCyAKKAIEIQ4gDCAKQQhBDCABIANLIhgbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhAyAILQAAQf8BRwRAIAQgCjYCEEEIIQggA0EIdCACaiECDAELIANBjwFNBEAgBCAKNgIQIANBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgDiAORSAYGwsEfyADIAUgCSgCBEEUdkEEcSAJQQRrIg4oAgBBFnZBAXEgBkEPdkEQcSAGQRN2QcAAcSASQaoBcXJycnIiEkHQuQFqLQAAQQJ0aiIMKAIAIgooAgAiAWshAyASQdC7AWotAAAhGCARIBBBAnRqIBQgDQJ/IAEgAkEQdk0EQCACIAFBEHRrIQIgA0GAgAJxBEAgCigCBAwCCyAKKAIEIRIgDCAKQQxBCCABIANLIhsbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhASAILQAAQf8BRwRAIAQgCjYCEEEIIQggAUEIdCACaiECDAELIAFBjwFNBEAgBCAKNgIQIAFBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyASRSASIBsbDAELIAooAgQhEiAMIApBCEEMIAEgA0siGxtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQogCC0AASEDIAgtAABB/wFHBEAgBCAKNgIQQQghCCADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAo2AhAgA0EJdCACaiECQQchCAwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEICyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyASIBJFIBsbCyAYcyIBGzYCACAOIA4oAgBBgAJyNgIAIAkgCSgCBEHAAHI2AgQgBiABQRZ0ckGAAXIFIAYLQYCAgAhyIQYLAkAgBkGAiIDAAHENACAGQcD3AXFFDQAgAyAFIAQoAmwgBkEGdiISQe8DcWotAABBAnRqIgwoAgAiCigCACIBayEDAn8gASACQRB2TQRAIAIgAUEQdGshAiADQYCAAnEEQCAKKAIEDAILIAooAgQhDiAMIApBDEEIIAEgA0siGBtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQogCC0AASEBIAgtAABB/wFHBEAgBCAKNgIQQQghCCABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAo2AhAgAUEJdCACaiECQQchCAwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEICyAIQQFrIQggAkEBdCECIANBAXQiA0GAgAJJDQALIA5FIA4gGBsMAQsgCigCBCEOIAwgCkEIQQwgASADSyIYG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQMgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIANBCHQgAmohAgwBCyADQY8BTQRAIAQgCjYCECADQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgAUEBdCIBQYCAAkkNAAsgASEDIA4gDkUgGBsLBH8gAyAFIAkoAgRBF3ZBBHEgCUEEayIOKAIAQRl2QQFxIAZBEnZBEHEgBkEWdkHAAHEgEkGqAXFycnJyIhJB0LkBai0AAEECdGoiDCgCACIKKAIAIgFrIQMgEkHQuwFqLQAAIRggESAVaiAUIA0CfyABIAJBEHZNBEAgAiABQRB0ayECIANBgIACcQRAIAooAgQMAgsgCigCBCESIAwgCkEMQQggASADSyIbG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQEgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgEkUgEiAbGwwBCyAKKAIEIRIgDCAKQQhBDCABIANLIhsbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhAyAILQAAQf8BRwRAIAQgCjYCEEEIIQggA0EIdCACaiECDAELIANBjwFNBEAgBCAKNgIQIANBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgEiASRSAbGwsgGHMiARs2AgAgDiAOKAIAQYAQcjYCACAJIAkoAgRBgARyNgIEIAYgAUEZdHJBgAhyBSAGC0GAgIDAAHIhBgsCQCAGQYDAgIAEcQ0AIAZBgLwPcUUNACADIAUgBCgCbCAGQQl2IhJB7wNxai0AAEECdGoiDCgCACIKKAIAIgFrIQMCfyABIAJBEHZNBEAgAiABQRB0ayECIANBgIACcQRAIAooAgQMAgsgCigCBCEOIAwgCkEMQQggASADSyIYG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQEgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgDkUgDiAYGwwBCyAKKAIEIQ4gDCAKQQhBDCABIANLIhgbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhAyAILQAAQf8BRwRAIAQgCjYCEEEIIQggA0EIdCACaiECDAELIANBjwFNBEAgBCAKNgIQIANBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgDiAORSAYGwsEfyADIAUgCSgCBEEadkEEcSAJQQRrIg4oAgBBHHZBAXEgBkEVdkEQcSAGQRl2QcAAcSASQaoBcXJycnIiEkHQuQFqLQAAQQJ0aiIMKAIAIgooAgAiAWshAyASQdC7AWotAAAhGCARIBNqIBQgDQJ/IAEgAkEQdk0EQCACIAFBEHRrIQIgA0GAgAJxBEAgCigCBAwCCyAKKAIEIRIgDCAKQQxBCCABIANLIhsbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhASAILQAAQf8BRwRAIAQgCjYCEEEIIQggAUEIdCACaiECDAELIAFBjwFNBEAgBCAKNgIQIAFBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyASRSASIBsbDAELIAooAgQhEiAMIApBCEEMIAEgA0siGxtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQogCC0AASEDIAgtAABB/wFHBEAgBCAKNgIQQQghCCADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAo2AhAgA0EJdCACaiECQQchCAwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEICyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyASIBJFIBsbCyAYcyIKGzYCACAOIA4oAgBBgIABcjYCACAJIAkoAgRBgCByNgIEIAQoAnxBAnQgCWoiASABKAIEQQRyNgIEIAEgASgCDEEBcjYCDCABIAEoAgggCkESdHJBAnI2AgggBiAKQRx0ckGAwAByBSAGC0GAgICABHIhBgsgCSAGNgIACyAJQQRqIQYgEUEEaiERIAtBAWoiCyAQRw0ACyAJQQxqIQYgESATaiERIAdBBGoiByAEKAKAASIBQXxxSQ0ACwwBC0EEIAFBfHEiBiAGQQRNG0EBayIGQXxxQQRqIQcgCSAGQQF0QXhxakEUaiEGCyAEIAg2AgggBCADNgIEIAQgAjYCACAEIAw2AmggEEUNASABIAdNDQEDQCABIAdGIVJBACEIIAchASBSRQRAA0AgBCAGIBEgCCAQbEECdGogDSAIIAQoAnxBAmpBARBZIAhBAWoiCCAEKAKAASIBIAdrSQ0ACwsgBkEEaiEGIBFBBGohESAXQQFqIhcgEEcNAAsMAQsCQCABQQRJDQAgEARAQQAgDWshFCAEQRxqIQUgEEEMbCETIBBBA3QhFQNAQQAhCwNAIAYiCSgCACIGBEACQCAGQZCAgAFxDQAgBkHvA3EiAUUNACADIAUgBCgCbCABai0AAEECdGoiDCgCACIKKAIAIgFrIQMCfyABIAJBEHZNBEAgAiABQRB0ayECIANBgIACcQRAIAooAgQMAgsgCigCBCEOIAwgCkEMQQggASADSyISG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQEgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgDkUgDiASGwwBCyAKKAIEIQ4gDCAKQQhBDCABIANLIhIbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhAyAILQAAQf8BRwRAIAQgCjYCEEEIIQggA0EIdCACaiECDAELIANBjwFNBEAgBCAKNgIQIANBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgDiAORSASGwsEfyADIAUgCSgCBEERdkEEcSAJQQRrIg4oAgBBE3ZBAXEgBkEOdkEQcSAGQRB2QcAAcSAGQaoBcXJycnIiEkHQuQFqLQAAQQJ0aiIMKAIAIgooAgAiAWshAyASQdC7AWotAAAhGCARIBQgDQJ/IAEgAkEQdk0EQCACIAFBEHRrIQIgA0GAgAJxBEAgCigCBAwCCyAKKAIEIRIgDCAKQQxBCCABIANLIhsbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhASAILQAAQf8BRwRAIAQgCjYCEEEIIQggAUEIdCACaiECDAELIAFBjwFNBEAgBCAKNgIQIAFBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyASRSASIBsbDAELIAooAgQhEiAMIApBCEEMIAEgA0siGxtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQogCC0AASEDIAgtAABB/wFHBEAgBCAKNgIQQQghCCADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAo2AhAgA0EJdCACaiECQQchCAwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEICyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyASIBJFIBsbCyAYcyIKGzYCACAOIA4oAgBBIHI2AgAgCSAJKAIEQQhyNgIEIAlBfiAEKAJ8a0ECdGoiASABKAIEQYCAAnI2AgQgASABKAIAIApBH3RyQYCABHI2AgAgAUEEayIBIAEoAgBBgIAIcjYCACAGIApBE3RyQRByBSAGC0GAgIABciEGCwJAIAZBgIGACHENACAGQfgecUUNACADIAUgBCgCbCAGQQN2IhJB7wNxai0AAEECdGoiDCgCACIKKAIAIgFrIQMCfyABIAJBEHZNBEAgAiABQRB0ayECIANBgIACcQRAIAooAgQMAgsgCigCBCEOIAwgCkEMQQggASADSyIYG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQEgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgDkUgDiAYGwwBCyAKKAIEIQ4gDCAKQQhBDCABIANLIhgbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhAyAILQAAQf8BRwRAIAQgCjYCEEEIIQggA0EIdCACaiECDAELIANBjwFNBEAgBCAKNgIQIANBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgDiAORSAYGwsEfyADIAUgCSgCBEEUdkEEcSAJQQRrIg4oAgBBFnZBAXEgBkEPdkEQcSAGQRN2QcAAcSASQaoBcXJycnIiEkHQuQFqLQAAQQJ0aiIMKAIAIgooAgAiAWshAyASQdC7AWotAAAhGCARIBBBAnRqIBQgDQJ/IAEgAkEQdk0EQCACIAFBEHRrIQIgA0GAgAJxBEAgCigCBAwCCyAKKAIEIRIgDCAKQQxBCCABIANLIhsbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhASAILQAAQf8BRwRAIAQgCjYCEEEIIQggAUEIdCACaiECDAELIAFBjwFNBEAgBCAKNgIQIAFBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyASRSASIBsbDAELIAooAgQhEiAMIApBCEEMIAEgA0siGxtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQogCC0AASEDIAgtAABB/wFHBEAgBCAKNgIQQQghCCADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAo2AhAgA0EJdCACaiECQQchCAwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEICyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyASIBJFIBsbCyAYcyIBGzYCACAOIA4oAgBBgAJyNgIAIAkgCSgCBEHAAHI2AgQgBiABQRZ0ckGAAXIFIAYLQYCAgAhyIQYLAkAgBkGAiIDAAHENACAGQcD3AXFFDQAgAyAFIAQoAmwgBkEGdiISQe8DcWotAABBAnRqIgwoAgAiCigCACIBayEDAn8gASACQRB2TQRAIAIgAUEQdGshAiADQYCAAnEEQCAKKAIEDAILIAooAgQhDiAMIApBDEEIIAEgA0siGBtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQogCC0AASEBIAgtAABB/wFHBEAgBCAKNgIQQQghCCABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAo2AhAgAUEJdCACaiECQQchCAwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEICyAIQQFrIQggAkEBdCECIANBAXQiA0GAgAJJDQALIA5FIA4gGBsMAQsgCigCBCEOIAwgCkEIQQwgASADSyIYG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQMgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIANBCHQgAmohAgwBCyADQY8BTQRAIAQgCjYCECADQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgAUEBdCIBQYCAAkkNAAsgASEDIA4gDkUgGBsLBH8gAyAFIAkoAgRBF3ZBBHEgCUEEayIOKAIAQRl2QQFxIAZBEnZBEHEgBkEWdkHAAHEgEkGqAXFycnJyIhJB0LkBai0AAEECdGoiDCgCACIKKAIAIgFrIQMgEkHQuwFqLQAAIRggESAVaiAUIA0CfyABIAJBEHZNBEAgAiABQRB0ayECIANBgIACcQRAIAooAgQMAgsgCigCBCESIAwgCkEMQQggASADSyIbG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQEgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgEkUgEiAbGwwBCyAKKAIEIRIgDCAKQQhBDCABIANLIhsbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhAyAILQAAQf8BRwRAIAQgCjYCEEEIIQggA0EIdCACaiECDAELIANBjwFNBEAgBCAKNgIQIANBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgEiASRSAbGwsgGHMiARs2AgAgDiAOKAIAQYAQcjYCACAJIAkoAgRBgARyNgIEIAYgAUEZdHJBgAhyBSAGC0GAgIDAAHIhBgsCQCAGQYDAgIAEcQ0AIAZBgLwPcUUNACADIAUgBCgCbCAGQQl2IhJB7wNxai0AAEECdGoiDCgCACIKKAIAIgFrIQMCfyABIAJBEHZNBEAgAiABQRB0ayECIANBgIACcQRAIAooAgQMAgsgCigCBCEOIAwgCkEMQQggASADSyIYG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCiAILQABIQEgCC0AAEH/AUcEQCAEIAo2AhBBCCEIIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEIDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgLIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgDkUgDiAYGwwBCyAKKAIEIQ4gDCAKQQhBDCABIANLIhgbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhAyAILQAAQf8BRwRAIAQgCjYCEEEIIQggA0EIdCACaiECDAELIANBjwFNBEAgBCAKNgIQIANBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgDiAORSAYGwsEfyADIAUgCSgCBEEadkEEcSAJQQRrIg4oAgBBHHZBAXEgBkEVdkEQcSAGQRl2QcAAcSASQaoBcXJycnIiEkHQuQFqLQAAQQJ0aiIMKAIAIgooAgAiAWshAyASQdC7AWotAAAhGCARIBNqIBQgDQJ/IAEgAkEQdk0EQCACIAFBEHRrIQIgA0GAgAJxBEAgCigCBAwCCyAKKAIEIRIgDCAKQQxBCCABIANLIhsbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiEKIAgtAAEhASAILQAAQf8BRwRAIAQgCjYCEEEIIQggAUEIdCACaiECDAELIAFBjwFNBEAgBCAKNgIQIAFBCXQgAmohAkEHIQgMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyASRSASIBsbDAELIAooAgQhEiAMIApBCEEMIAEgA0siGxtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQogCC0AASEDIAgtAABB/wFHBEAgBCAKNgIQQQghCCADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAo2AhAgA0EJdCACaiECQQchCAwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEICyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyASIBJFIBsbCyAYcyIKGzYCACAOIA4oAgBBgIABcjYCACAJIAkoAgRBgCByNgIEIAQoAnxBAnQgCWoiASABKAIEQQRyNgIEIAEgASgCDEEBcjYCDCABIAEoAgggCkESdHJBAnI2AgggBiAKQRx0ckGAwAByBSAGC0GAgICABHIhBgsgCSAGNgIACyAJQQRqIQYgEUEEaiERIAtBAWoiCyAQRw0ACyAJQQxqIQYgESATaiERIAdBBGoiByAEKAKAASIBQXxxSQ0ACwwBC0EEIAFBfHEiBiAGQQRNG0EBayIGQXxxQQRqIQcgCSAGQQF0QXhxakEUaiEGCyAEIAg2AgggBCADNgIEIAQgAjYCACAEIAw2AmggEEUNACABIAdNDQADQCABIAdGIVNBACEIIAchASBTRQRAA0AgBCAGIBEgCCAQbEECdGogDSAIIAQoAnxBAmpBABBZIAhBAWoiCCAEKAKAASIBIAdrSQ0ACwsgBkEEaiEGIBFBBGohESAXQQFqIhcgEEcNAAsLDAILA0BBACEXA0AgASEJIAYiBygCACIGBEACQCAGQZCAgAFxDQAgBkHvA3EiAUUNACADIBAgBCgCbCABai0AAEECdGoiDCgCACILKAIAIgFrIQMCfyABIAJBEHZLBEAgCygCBCEKIAwgC0EIQQwgASADSyIUG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQMgCC0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIANBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCADQQh0IAJqIQILIAhBAWshCCACQQF0IQIgAUEBdCIBQYCAAkkNAAsgASEDIAogCkUgFBsMAQsgAiABQRB0ayECIANBgIACcUUEQCALKAIEIQogDCALQQxBCCABIANLIhQbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiELIAgtAAEhASAILQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAwCCyAEIAs2AhAgAUEJdCACaiECQQchCAwBCyAEIAs2AhBBCCEIIAFBCHQgAmohAgsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyAKRSAKIBQbDAELIAsoAgQLBH8gAyAQIAcoAgRBEXZBBHEgB0EEayIKKAIAQRN2QQFxIAZBDnZBEHEgBkEQdkHAAHEgBkGqAXFycnJyIhRB0LkBai0AAEECdGoiDCgCACILKAIAIgFrIQMgFEHQuwFqLQAAIRMgCSAFIBECfyABIAJBEHZLBEAgCygCBCEUIAwgC0EIQQwgASADSyIOG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQMgCC0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIANBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCADQQh0IAJqIQILIAhBAWshCCACQQF0IQIgAUEBdCIBQYCAAkkNAAsgASEDIBQgFEUgDhsMAQsgAiABQRB0ayECIANBgIACcUUEQCALKAIEIRQgDCALQQxBCCABIANLIg4baigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiELIAgtAAEhASAILQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAwCCyAEIAs2AhAgAUEJdCACaiECQQchCAwBCyAEIAs2AhBBCCEIIAFBCHQgAmohAgsgCEEBayEIIAJBAXQhAiADQQF0IgNBgIACSQ0ACyAURSAUIA4bDAELIAsoAgQLIBNzIgEbNgIAIAogCigCAEEgcjYCACAHIAcoAgRBCHI2AgQgBiABQRN0ckEQcgUgBgtBgICAAXIhBgsCQCAGQYCBgAhxDQAgBkH4HnFFDQAgAyAQIAQoAmwgBkEDdiIUQe8DcWotAABBAnRqIgwoAgAiCygCACIBayEDAn8gASACQRB2SwRAIAsoAgQhCiAMIAtBCEEMIAEgA0siExtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEDIAgtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECADQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggA0EIdCACaiECCyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyAKIApFIBMbDAELIAIgAUEQdGshAiADQYCAAnFFBEAgCygCBCEKIAwgC0EMQQggASADSyITG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQEgCC0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIAFBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCABQQh0IAJqIQILIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgCkUgCiATGwwBCyALKAIECwR/IAMgECAHKAIEQRR2QQRxIAdBBGsiCigCAEEWdkEBcSAGQQ92QRBxIAZBE3ZBwABxIBRBqgFxcnJyciIUQdC5AWotAABBAnRqIgwoAgAiCygCACIBayEDIBRB0LsBai0AACETIAkgBSARAn8gASACQRB2SwRAIAsoAgQhFCAMIAtBCEEMIAEgA0siDhtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEDIAgtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECADQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggA0EIdCACaiECCyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyAUIBRFIA4bDAELIAIgAUEQdGshAiADQYCAAnFFBEAgCygCBCEUIAwgC0EMQQggASADSyIOG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQEgCC0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIAFBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCABQQh0IAJqIQILIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgFEUgFCAOGwwBCyALKAIECyATcyIBGzYCgAIgCiAKKAIAQYACcjYCACAHIAcoAgRBwAByNgIEIAYgAUEWdHJBgAFyBSAGC0GAgIAIciEGCwJAIAZBgIiAwABxDQAgBkHA9wFxRQ0AIAMgECAEKAJsIAZBBnYiFEHvA3FqLQAAQQJ0aiIMKAIAIgsoAgAiAWshAwJ/IAEgAkEQdksEQCALKAIEIQogDCALQQhBDCABIANLIhMbaigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiELIAgtAAEhAyAILQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAwCCyAEIAs2AhAgA0EJdCACaiECQQchCAwBCyAEIAs2AhBBCCEIIANBCHQgAmohAgsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgCiAKRSATGwwBCyACIAFBEHRrIQIgA0GAgAJxRQRAIAsoAgQhCiAMIAtBDEEIIAEgA0siExtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEBIAgtAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECABQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggAUEIdCACaiECCyAIQQFrIQggAkEBdCECIANBAXQiA0GAgAJJDQALIApFIAogExsMAQsgCygCBAsEfyADIBAgBygCBEEXdkEEcSAHQQRrIgooAgBBGXZBAXEgBkESdkEQcSAGQRZ2QcAAcSAUQaoBcXJycnIiFEHQuQFqLQAAQQJ0aiIMKAIAIgsoAgAiAWshAyAUQdC7AWotAAAhEyAJIAUgEQJ/IAEgAkEQdksEQCALKAIEIRQgDCALQQhBDCABIANLIg4baigCADYCAANAAkAgCA0AIAQoAhAiCEEBaiELIAgtAAEhAyAILQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghCAwCCyAEIAs2AhAgA0EJdCACaiECQQchCAwBCyAEIAs2AhBBCCEIIANBCHQgAmohAgsgCEEBayEIIAJBAXQhAiABQQF0IgFBgIACSQ0ACyABIQMgFCAURSAOGwwBCyACIAFBEHRrIQIgA0GAgAJxRQRAIAsoAgQhFCAMIAtBDEEIIAEgA0siDhtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEBIAgtAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECABQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggAUEIdCACaiECCyAIQQFrIQggAkEBdCECIANBAXQiA0GAgAJJDQALIBRFIBQgDhsMAQsgCygCBAsgE3MiARs2AoAEIAogCigCAEGAEHI2AgAgByAHKAIEQYAEcjYCBCAGIAFBGXRyQYAIcgUgBgtBgICAwAByIQYLAkAgBkGAwICABHENACAGQYC8D3FFDQAgAyAQIAQoAmwgBkEJdiIUQe8DcWotAABBAnRqIgwoAgAiCygCACIBayEDAn8gASACQRB2SwRAIAsoAgQhCiAMIAtBCEEMIAEgA0siExtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEDIAgtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECADQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggA0EIdCACaiECCyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyAKIApFIBMbDAELIAIgAUEQdGshAiADQYCAAnFFBEAgCygCBCEKIAwgC0EMQQggASADSyITG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQEgCC0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIAFBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCABQQh0IAJqIQILIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgCkUgCiATGwwBCyALKAIECwR/IAMgECAHKAIEQRp2QQRxIAdBBGsiCigCAEEcdkEBcSAGQRV2QRBxIAZBGXZBwABxIBRBqgFxcnJyciIUQdC5AWotAABBAnRqIgwoAgAiCygCACIBayEDIBRB0LsBai0AACETIAkgBSARAn8gASACQRB2SwRAIAsoAgQhFCAMIAtBCEEMIAEgA0siDhtqKAIANgIAA0ACQCAIDQAgBCgCECIIQQFqIQsgCC0AASEDIAgtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEIDAILIAQgCzYCECADQQl0IAJqIQJBByEIDAELIAQgCzYCEEEIIQggA0EIdCACaiECCyAIQQFrIQggAkEBdCECIAFBAXQiAUGAgAJJDQALIAEhAyAUIBRFIA4bDAELIAIgAUEQdGshAiADQYCAAnFFBEAgCygCBCEUIAwgC0EMQQggASADSyIOG2ooAgA2AgADQAJAIAgNACAEKAIQIghBAWohCyAILQABIQEgCC0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQgMAgsgBCALNgIQIAFBCXQgAmohAkEHIQgMAQsgBCALNgIQQQghCCABQQh0IAJqIQILIAhBAWshCCACQQF0IQIgA0EBdCIDQYCAAkkNAAsgFEUgFCAOGwwBCyALKAIECyATcyIBGzYCgAYgCiAKKAIAQYCAAXI2AgAgByAHKAIEQYAgcjYCBCAHIAcoAoQCQQRyNgKEAiAHIAcoAowCQQFyNgKMAiAHIAcoAogCIAFBEnRyQQJyNgKIAiAGIAFBHHRyQYDAAHIFIAYLQYCAgIAEciEGCyAHIAY2AgALIAdBBGohBiAJQQRqIQEgF0EBaiIXQcAARw0ACyAHQQxqIQYgCUGEBmohASANQTxJIVQgDUEEaiENIFQNAAsLIAQgCDYCCCAEIAM2AgQgBCACNgIAIAQgDDYCaAsMAgsgIgRAQQEgGXRBAXYhCSAEKAJ8IhFBAnQiDCAEKAJ4akEMaiEBIAQoAnQhBkEAIQ0gBCgCgAEiA0EETwRAIBFFDQQgEUEDbCEFIBFBAXQhC0EAIAlrIQIDQCALQQJ0IQpBACEDA0ACQCABIgcoAgAiAUUNACABQZCAgAFxQRBGBEAgBCgCACEBAkAgBCgCCCIQDQAgAUH/AUYhECAEKAIQIggtAAAhAQJAIBBFBEAgBCABNgIAIAQgCEEBajYCEAwBCyABQY8BTQRAIAQgATYCACAEIAhBAWo2AhBBByEQDAILQf8BIQEgBEH/ATYCAAtBCCEQCyAEIBBBAWsiCDYCCCAGIAIgCSABIAh2QQFxIAYoAgAiAUEfdkYbIAFqNgIAIAcgBygCAEGAgMAAciIBNgIACyABQYCBgAhxQYABRgRAIAQoAgAhAQJAIAQoAggiEA0AIAFB/wFGIRAgBCgCECIILQAAIQECQCAQRQRAIAQgATYCACAEIAhBAWo2AhAMAQsgAUGPAU0EQCAEIAE2AgAgBCAIQQFqNgIQQQchEAwCC0H/ASEBIARB/wE2AgALQQghEAsgBCAQQQFrIgg2AgggBiAMaiIQIAIgCSABIAh2QQFxIBAoAgAiAUEfdkYbIAFqNgIAIAcgBygCAEGAgIAEciIBNgIACyABQYCIgMAAcUGACEYEQCAEKAIAIQECQCAEKAIIIhANACABQf8BRiEQIAQoAhAiCC0AACEBAkAgEEUEQCAEIAE2AgAgBCAIQQFqNgIQDAELIAFBjwFNBEAgBCABNgIAIAQgCEEBajYCEEEHIRAMAgtB/wEhASAEQf8BNgIAC0EIIRALIAQgEEEBayIINgIIIAYgCmoiECACIAkgASAIdkEBcSAQKAIAIgFBH3ZGGyABajYCACAHIAcoAgBBgICAIHIiATYCAAsgAUGAwICABHFBgMAARw0AIAYgBUECdGohECAEKAIAIQECQCAEKAIIIggNACABQf8BRiEUIAQoAhAiCC0AACEBAkAgFEUEQCAEIAE2AgAgBCAIQQFqNgIQDAELIAFBjwFNBEAgBCABNgIAIAQgCEEBajYCEEEHIQgMAgtB/wEhASAEQf8BNgIAC0EIIQgLIAQgCEEBayIINgIIIBAgAiAJIAEgCHZBAXEgECgCACIBQR92RhsgAWo2AgAgByAHKAIAQYCAgIACcjYCAAsgBkEEaiEGIAdBBGohASADQQFqIgMgEUcNAAsgB0EMaiEBIAYgBUECdGohBiANQQRqIg0gBCgCgAEiA0F8cUkNAAsLIAMgDU0NAiARRQ0CQQAhE0EAIAlrIQUgAyEHA0ACQCAHIA1GBEAgDSEHDAELIAEoAgAhEEEAIQIDQEGQgIABIAJBA2wiB3QgEHFBECAHdEYEQCAGIAIgEWxBAnRqIRAgBCgCACEDAkAgBCgCCCIIDQAgA0H/AUchDCAEKAIQIggtAAAhAwJAIAxFBEAgA0GQAU8EQEH/ASEDIARB/wE2AgAMAgsgBCADNgIAIAQgCEEBajYCEEEHIQgMAgsgBCADNgIAIAQgCEEBajYCEAtBCCEICyAEIAhBAWsiCDYCCCAQIAUgCSADIAh2QQFxIBAoAgAiA0EfdkYbIANqNgIAIAEgASgCAEGAgMAAIAd0ciIQNgIAIAQoAoABIQMLIAMhByACQQFqIgIgAyANa0kNAAsLIAZBBGohBiABQQRqIQEgE0EBaiITIBFHDQALDAILIAQoAnghCCAEKAJ0IQcgBCgCgAEhAwJAIAQoAnwiDEHAAEcNACADQcAARw0AIAhBjAJqIQNBACETQQBBASAZdEEBdiIFayEMIAQoAgghAiAEKAIEIQYgBCgCACEBIAQoAmghDQNAQQAhCANAIAchCSADIhAoAgAiBwRAIAMhVSAHQZCAgAFxQRBGBEAgBiAPQRBBD0EOIAdB7wNxGyAHQYCAwABxG0ECdGoiDSgCACIRKAIAIgNrIQYCfyADIAFBEHZLBEAgESgCBCELIA0gEUEIQQwgAyAGSyIKG2ooAgA2AgADQAJAIAINACAEKAIQIgJBAWohESACLQABIQYgAi0AAEH/AUYEQCAGQZABTwRAIAQgBCgCDEEBajYCDCABQYD+A2ohAUEIIQIMAgsgBCARNgIQIAZBCXQgAWohAUEHIQIMAQsgBCARNgIQQQghAiAGQQh0IAFqIQELIAJBAWshAiABQQF0IQEgA0EBdCIDQYCAAkkNAAsgAyEGIAsgC0UgChsMAQsgASADQRB0ayEBIAZBgIACcUUEQCARKAIEIQsgDSARQQxBCCADIAZLIgobaigCADYCAANAAkAgAg0AIAQoAhAiAkEBaiERIAItAAEhAyACLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAFBgP4DaiEBQQghAgwCCyAEIBE2AhAgA0EJdCABaiEBQQchAgwBCyAEIBE2AhBBCCECIANBCHQgAWohAQsgAkEBayECIAFBAXQhASAGQQF0IgZBgIACSQ0ACyALRSALIAobDAELIBEoAgQLIQMgCSAMIAUgAyAJKAIAIhFBH3ZGGyARajYCACAHQYCAwAByIQcLIAdBgIGACHFBgAFGBEAgBiAPQRBBD0EOIAdB+B5xGyAHQYCAgARxG0ECdGoiDSgCACIRKAIAIgNrIQYCfyADIAFBEHZLBEAgESgCBCELIA0gEUEIQQwgAyAGSyIKG2ooAgA2AgADQAJAIAINACAEKAIQIgJBAWohESACLQABIQYgAi0AAEH/AUYEQCAGQZABTwRAIAQgBCgCDEEBajYCDCABQYD+A2ohAUEIIQIMAgsgBCARNgIQIAZBCXQgAWohAUEHIQIMAQsgBCARNgIQQQghAiAGQQh0IAFqIQELIAJBAWshAiABQQF0IQEgA0EBdCIDQYCAAkkNAAsgAyEGIAsgC0UgChsMAQsgASADQRB0ayEBIAZBgIACcUUEQCARKAIEIQsgDSARQQxBCCADIAZLIgobaigCADYCAANAAkAgAg0AIAQoAhAiAkEBaiERIAItAAEhAyACLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAFBgP4DaiEBQQghAgwCCyAEIBE2AhAgA0EJdCABaiEBQQchAgwBCyAEIBE2AhBBCCECIANBCHQgAWohAQsgAkEBayECIAFBAXQhASAGQQF0IgZBgIACSQ0ACyALRSALIAobDAELIBEoAgQLIQMgCSAMIAUgAyAJKAKAAiIRQR92RhsgEWo2AoACIAdBgICABHIhBwsgB0GAiIDAAHFBgAhGBEAgBiAPQRBBD0EOIAdBwPcBcRsgB0GAgIAgcRtBAnRqIg0oAgAiESgCACIDayEGAn8gAyABQRB2SwRAIBEoAgQhCyANIBFBCEEMIAMgBksiChtqKAIANgIAA0ACQCACDQAgBCgCECICQQFqIREgAi0AASEGIAItAABB/wFGBEAgBkGQAU8EQCAEIAQoAgxBAWo2AgwgAUGA/gNqIQFBCCECDAILIAQgETYCECAGQQl0IAFqIQFBByECDAELIAQgETYCEEEIIQIgBkEIdCABaiEBCyACQQFrIQIgAUEBdCEBIANBAXQiA0GAgAJJDQALIAMhBiALIAtFIAobDAELIAEgA0EQdGshASAGQYCAAnFFBEAgESgCBCELIA0gEUEMQQggAyAGSyIKG2ooAgA2AgADQAJAIAINACAEKAIQIgJBAWohESACLQABIQMgAi0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCABQYD+A2ohAUEIIQIMAgsgBCARNgIQIANBCXQgAWohAUEHIQIMAQsgBCARNgIQQQghAiADQQh0IAFqIQELIAJBAWshAiABQQF0IQEgBkEBdCIGQYCAAkkNAAsgC0UgCyAKGwwBCyARKAIECyEDIAkgDCAFIAMgCSgCgAQiEUEfdkYbIBFqNgKABCAHQYCAgCByIQcLIFUgB0GAwICABHFBgMAARgR/IAYgD0EQQQ9BDiAHQYC8D3EbIAdBgICAgAJxG0ECdGoiDSgCACIRKAIAIgNrIQYCfyADIAFBEHZLBEAgESgCBCELIA0gEUEIQQwgAyAGSyIKG2ooAgA2AgADQAJAIAINACAEKAIQIgJBAWohESACLQABIQYgAi0AAEH/AUYEQCAGQZABTwRAIAQgBCgCDEEBajYCDCABQYD+A2ohAUEIIQIMAgsgBCARNgIQIAZBCXQgAWohAUEHIQIMAQsgBCARNgIQQQghAiAGQQh0IAFqIQELIAJBAWshAiABQQF0IQEgA0EBdCIDQYCAAkkNAAsgAyEGIAsgC0UgChsMAQsgASADQRB0ayEBIAZBgIACcUUEQCARKAIEIQsgDSARQQxBCCADIAZLIgobaigCADYCAANAAkAgAg0AIAQoAhAiAkEBaiERIAItAAEhAyACLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAFBgP4DaiEBQQghAgwCCyAEIBE2AhAgA0EJdCABaiEBQQchAgwBCyAEIBE2AhBBCCECIANBCHQgAWohAQsgAkEBayECIAFBAXQhASAGQQF0IgZBgIACSQ0ACyALRSALIAobDAELIBEoAgQLIQMgCSAMIAUgAyAJKAKABiIRQR92RhsgEWo2AoAGIAdBgICAgAJyBSAHCzYCAAsgEEEEaiEDIAlBBGohByAIQQFqIghBwABHDQALIBBBDGohAyAJQYQGaiEHIBNBPEkhViATQQRqIRMgVg0ACyAEIAI2AgggBCAGNgIEIAQgATYCACAEIA02AmgMAgtBASAZdEEBdiELIAggDEECdCIOakEMaiEJIAQoAgghAiAEKAIEIQYgBCgCACEBIAQoAmghDUEAIRECQCADQQRJDQAgDARAIAxBA2whFCAMQQF0IRdBACALayEKA0AgF0ECdCESQQAhCANAIAkiBSgCACIQBEAgEEGQgIABcUEQRgRAIAYgD0EQQQ9BDiAQQe8DcRsgEEGAgMAAcRtBAnRqIg0oAgAiCSgCACIDayEGAn8gAyABQRB2TQRAIAEgA0EQdGshASAGQYCAAnEEQCAJKAIEDAILIAkoAgQhEyANIAlBDEEIIAMgBksiFRtqKAIANgIAA0ACQCACDQAgBCgCECIJQQFqIQIgCS0AASEDIAktAABB/wFHBEAgBCACNgIQQQghAiADQQh0IAFqIQEMAQsgA0GPAU0EQCAEIAI2AhAgA0EJdCABaiEBQQchAgwBCyAEIAQoAgxBAWo2AgwgAUGA/gNqIQFBCCECCyACQQFrIQIgAUEBdCEBIAZBAXQiBkGAgAJJDQALIBNFIBMgFRsMAQsgCSgCBCETIA0gCUEIQQwgAyAGSyIVG2ooAgA2AgADQAJAIAINACAEKAIQIglBAWohAiAJLQABIQYgCS0AAEH/AUcEQCAEIAI2AhBBCCECIAZBCHQgAWohAQwBCyAGQY8BTQRAIAQgAjYCECAGQQl0IAFqIQFBByECDAELIAQgBCgCDEEBajYCDCABQYD+A2ohAUEIIQILIAJBAWshAiABQQF0IQEgA0EBdCIDQYCAAkkNAAsgAyEGIBMgE0UgFRsLIQMgByAKIAsgAyAHKAIAIglBH3ZGGyAJajYCACAQQYCAwAByIRALIBBBgIGACHFBgAFGBEAgBiAPQRBBD0EOIBBB+B5xGyAQQYCAgARxG0ECdGoiDSgCACIJKAIAIgNrIQYCfyADIAFBEHZNBEAgASADQRB0ayEBIAZBgIACcQRAIAkoAgQMAgsgCSgCBCETIA0gCUEMQQggAyAGSyIVG2ooAgA2AgADQAJAIAINACAEKAIQIglBAWohAiAJLQABIQMgCS0AAEH/AUcEQCAEIAI2AhBBCCECIANBCHQgAWohAQwBCyADQY8BTQRAIAQgAjYCECADQQl0IAFqIQFBByECDAELIAQgBCgCDEEBajYCDCABQYD+A2ohAUEIIQILIAJBAWshAiABQQF0IQEgBkEBdCIGQYCAAkkNAAsgE0UgEyAVGwwBCyAJKAIEIRMgDSAJQQhBDCADIAZLIhUbaigCADYCAANAAkAgAg0AIAQoAhAiCUEBaiECIAktAAEhBiAJLQAAQf8BRwRAIAQgAjYCEEEIIQIgBkEIdCABaiEBDAELIAZBjwFNBEAgBCACNgIQIAZBCXQgAWohAUEHIQIMAQsgBCAEKAIMQQFqNgIMIAFBgP4DaiEBQQghAgsgAkEBayECIAFBAXQhASADQQF0IgNBgIACSQ0ACyADIQYgEyATRSAVGwshAyAHIA5qIgkgCiALIAMgCSgCACIJQR92RhsgCWo2AgAgEEGAgIAEciEQCyAQQYCIgMAAcUGACEYEQCAGIA9BEEEPQQ4gEEHA9wFxGyAQQYCAgCBxG0ECdGoiDSgCACIJKAIAIgNrIQYCfyADIAFBEHZNBEAgASADQRB0ayEBIAZBgIACcQRAIAkoAgQMAgsgCSgCBCETIA0gCUEMQQggAyAGSyIVG2ooAgA2AgADQAJAIAINACAEKAIQIglBAWohAiAJLQABIQMgCS0AAEH/AUcEQCAEIAI2AhBBCCECIANBCHQgAWohAQwBCyADQY8BTQRAIAQgAjYCECADQQl0IAFqIQFBByECDAELIAQgBCgCDEEBajYCDCABQYD+A2ohAUEIIQILIAJBAWshAiABQQF0IQEgBkEBdCIGQYCAAkkNAAsgE0UgEyAVGwwBCyAJKAIEIRMgDSAJQQhBDCADIAZLIhUbaigCADYCAANAAkAgAg0AIAQoAhAiCUEBaiECIAktAAEhBiAJLQAAQf8BRwRAIAQgAjYCEEEIIQIgBkEIdCABaiEBDAELIAZBjwFNBEAgBCACNgIQIAZBCXQgAWohAUEHIQIMAQsgBCAEKAIMQQFqNgIMIAFBgP4DaiEBQQghAgsgAkEBayECIAFBAXQhASADQQF0IgNBgIACSQ0ACyADIQYgEyATRSAVGwshAyAHIBJqIgkgCiALIAMgCSgCACIJQR92RhsgCWo2AgAgEEGAgIAgciEQCyAFIBBBgMCAgARxQYDAAEYEfyAGIA9BEEEPQQ4gEEGAvA9xGyAQQYCAgIACcRtBAnRqIg0oAgAiCSgCACIDayEGAn8gAyABQRB2TQRAIAEgA0EQdGshASAGQYCAAnEEQCAJKAIEDAILIAkoAgQhEyANIAlBDEEIIAMgBksiFRtqKAIANgIAA0ACQCACDQAgBCgCECIJQQFqIQIgCS0AASEDIAktAABB/wFHBEAgBCACNgIQQQghAiADQQh0IAFqIQEMAQsgA0GPAU0EQCAEIAI2AhAgA0EJdCABaiEBQQchAgwBCyAEIAQoAgxBAWo2AgwgAUGA/gNqIQFBCCECCyACQQFrIQIgAUEBdCEBIAZBAXQiBkGAgAJJDQALIBNFIBMgFRsMAQsgCSgCBCETIA0gCUEIQQwgAyAGSyIVG2ooAgA2AgADQAJAIAINACAEKAIQIglBAWohAiAJLQABIQYgCS0AAEH/AUcEQCAEIAI2AhBBCCECIAZBCHQgAWohAQwBCyAGQY8BTQRAIAQgAjYCECAGQQl0IAFqIQFBByECDAELIAQgBCgCDEEBajYCDCABQYD+A2ohAUEIIQILIAJBAWshAiABQQF0IQEgA0EBdCIDQYCAAkkNAAsgAyEGIBMgE0UgFRsLIQMgByAUQQJ0aiIJIAogCyADIAkoAgAiCUEfdkYbIAlqNgIAIBBBgICAgAJyBSAQCzYCAAsgBUEEaiEJIAdBBGohByAIQQFqIgggDEcNAAsgBUEMaiEJIAcgFEECdGohByARQQRqIhEgBCgCgAEiA0F8cUkNAAsMAQtBBCADQXxxIgkgCUEETRtBAWsiCUF8cUEEaiERIAggCUEBdEF4cWpBFGohCQsgBCACNgIIIAQgBjYCBCAEIAE2AgAgBCANNgJoIAxFDQEgAyARTQ0BQQAhE0EAIAtrIRQgAyEBA0ACQCABIBFGBEAgESEBDAELIAkoAgAhAkEAIRADQEGQgIABIBBBA2wiCHQgAnFBECAIdEYEQCAHIAwgEGxBAnRqIQUgBCAPQRBBD0EOIAIgCHYiAUHvA3EbIAFBgIDAAHEbQQJ0aiINNgJoIAQgBCgCBCANKAIAIgIoAgAiAWsiAzYCBAJ/IAEgBCgCACIGQRB2SwRAIAIoAgQhCiAEIAE2AgQgDSACQQhBDCABIANLIg4baigCADYCACAEKAIIIQIDQAJAIAINACAEKAIQIgJBAWohDSACLQABIQMgAi0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCAGQYD+A2ohBkEIIQIMAgsgBCANNgIQIANBCXQgBmohBkEHIQIMAQsgBCANNgIQQQghAiADQQh0IAZqIQYLIAQgAkEBayICNgIIIAQgBkEBdCIGNgIAIAQgAUEBdCIBNgIEIAFBgIACSQ0ACyAKIApFIA4bDAELIAQgBiABQRB0ayIGNgIAIANBgIACcUUEQCACKAIEIQogDSACQQxBCCABIANLIg4baigCADYCACAEKAIIIQIDQAJAIAINACAEKAIQIgJBAWohDSACLQABIQEgAi0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCAGQYD+A2ohBkEIIQIMAgsgBCANNgIQIAFBCXQgBmohBkEHIQIMAQsgBCANNgIQQQghAiABQQh0IAZqIQYLIAQgAkEBayICNgIIIAQgBkEBdCIGNgIAIAQgA0EBdCIDNgIEIANBgIACSQ0ACyAKRSAKIA4bDAELIAIoAgQLIQEgBSAUIAsgASAFKAIAIgNBH3ZGGyADajYCACAJIAkoAgBBgIDAACAIdHIiAjYCACAEKAKAASEDCyAQQQFqIhAgAyIBIBFrSQ0ACwsgCUEEaiEJIAdBBGohByATQQFqIhMgDEcNAAsMAQtBACERQQAhFwJAAkACQAJAIAQoAnwiFEHAAEcNACAEKAKAAUHAAEcNAEEAQQEgGXQiAUEBdiABciIUayETIARB5ABqIQggBEHgAGohECAEQRxqIQsgBCgCeEGMAmohBiAEKAIIIQUgBCgCBCEBIAQoAgAhAiAEKAJoIQkgBCgCdCEDIBZBCHENAQNAQQAhDANAIAMhEQJAAkACfwJAAkAgBiINKAIAIgZFBEAgASAQKAIAIgMoAgAiBmshAQJ/IAYgAkEQdksEQCADKAIEIQcgECADQQhBDCABIAZJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiA0EBaiEJIAMtAAEhASADLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAk2AhAgAUEJdCACaiECQQchBQwBCyAEIAk2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiAGQQF0IgZBgIACSQ0ACyAGIQEgByAHRSAKGwwBCyACIAZBEHRrIQIgAUGAgAJxRQRAIAMoAgQhByAQIANBDEEIIAEgBkkiChtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgCTYCECADQQl0IAJqIQJBByEFDAELIAQgCTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAdFIAcgChsMAQsgAygCBAtFBEAgECEJDAYLIAEgCCgCACIDKAIAIgZrIQECfyAGIAJBEHZLBEAgAygCBCEHIAggA0EIQQwgASAGSSIKG2ooAgAiAzYCAANAAkAgBQ0AIAQoAhAiCUEBaiEFIAktAAEhASAJLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiAGQQF0IgZBgIACSQ0ACyAGIQEgByAHRSAKGwwBCyACIAZBEHRrIQIgAUGAgAJxRQRAIAMoAgQhByAIIANBDEEIIAEgBkkiChtqKAIAIgM2AgADQAJAIAUNACAEKAIQIglBAWohBSAJLQABIQYgCS0AAEH/AUYEQCAGQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAZBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSAGQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgB0UgByAKGwwBCyADKAIECyEKIAEgAygCACIGayEBAn8gBiACQRB2SwRAIAMoAgQhByAIIANBCEEMIAEgBkkiDhtqKAIANgIAA0ACQCAFDQAgBCgCECIDQQFqIQkgAy0AASEBIAMtAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgCTYCECABQQl0IAJqIQJBByEFDAELIAQgCTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhASAHIAdFIA4bDAELIAIgBkEQdGshAiABQYCAAnFFBEAgAygCBCEHIAggA0EMQQggASAGSSIOG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohCSAGLQABIQMgBi0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAJNgIQIANBCXQgAmohAkEHIQUMAQsgBCAJNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgB0UgByAOGwwBCyADKAIECyEDQQAhBiAIIQkCQAJAAkACfwJAAkAgAyAKQQF0cg4EAAEDBQoLIAEgCyANKAIEQRF2QQRxIA1BBGsiBygCAEETdkEBcXIiDkHQuQFqLQAAQQJ0aiIJKAIAIgMoAgAiBmshAQJ/IAYgAkEQdksEQCADKAIEIQogCSADQQhBDCABIAZJIhIbaigCADYCAANAAkAgBQ0AIAQoAhAiA0EBaiEJIAMtAAEhASADLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAk2AhAgAUEJdCACaiECQQchBQwBCyAEIAk2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiAGQQF0IgZBgIACSQ0ACyAGIQEgCiAKRSASGwwBCyACIAZBEHRrIQIgAUGAgAJxRQRAIAMoAgQhCiAJIANBDEEIIAEgBkkiEhtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgCTYCECADQQl0IAJqIQJBByEFDAELIAQgCTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogEhsMAQsgAygCBAshAyARIBMgFCADIA5B0LsBai0AAHMiAxs2AgAgByAHKAIAQSByNgIAIA0gDSgCBEEIcjYCBCANQYwCayIGIAYoAgBBgIAIcjYCACANQYQCayIGIAYoAgBBgIACcjYCACANQYgCayIGIAYoAgAgA0EfdHJBgIAEcjYCACADQRN0IVcgASALIAQoAmwtAAJBAnRqIgcoAgAiAygCACIGayEBAn8gBiACQRB2SwRAIAMoAgQhCSAHIANBCEEMIAEgBkkiDhtqKAIANgIAA0ACQCAFDQAgBCgCECIDQQFqIQcgAy0AASEBIAMtAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBzYCECABQQl0IAJqIQJBByEFDAELIAQgBzYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhASAJIAlFIA4bDAELIAIgBkEQdGshAiABQYCAAnFFBEAgAygCBCEJIAcgA0EMQQggASAGSSIOG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohByAGLQABIQMgBi0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAHNgIQIANBCXQgAmohAkEHIQUMAQsgBCAHNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgCUUgCSAOGwwBCyADKAIECyEDIFdBEHIiBiADRQ0BGgsgASALIA0oAgRBFHZBBHEgDUEEayIJKAIAQRZ2QQFxIAZBD3ZBEHEgBkETdkHAAHEgBkEDdkGqAXFycnJyIhJB0LkBai0AAEECdGoiCigCACIHKAIAIgNrIQECfyADIAJBEHZLBEAgBygCBCEOIAogB0EIQQwgASADSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIA4gDkUgChsMAQsgAiADQRB0ayECIAFBgIACcUUEQCAHKAIEIQ4gCiAHQQxBCCABIANJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgA0EJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAORSAOIAobDAELIAcoAgQLIQMgESATIBQgAyASQdC7AWotAABzIgMbNgKAAiAJIAkoAgBBgAJyNgIAIA0gDSgCBEHAAHI2AgQgBiADQRZ0ckGAAXILIQYgASALIAQoAmwgBkEGdkHvA3FqLQAAQQJ0aiIJKAIAIgcoAgAiA2shAQJ/IAMgAkEQdksEQCAHKAIEIQogCSAHQQhBDCABIANJIg4baigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEJIActAAEhASAHLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAk2AhAgAUEJdCACaiECQQchBQwBCyAEIAk2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiADQQF0IgNBgIACSQ0ACyADIQEgCiAKRSAOGwwBCyACIANBEHRrIQIgAUGAgAJxRQRAIAcoAgQhCiAJIAdBDEEIIAEgA0kiDhtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQkgBy0AASEDIActAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgCTYCECADQQl0IAJqIQJBByEFDAELIAQgCTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogDhsMAQsgBygCBAtFDQELIAEgCyANKAIEQRd2QQRxIA1BBGsiCSgCAEEZdkEBcSAGQRJ2QRBxIAZBFnZBwABxIAZBBnZBqgFxcnJyciISQdC5AWotAABBAnRqIgooAgAiBygCACIDayEBAn8gAyACQRB2SwRAIAcoAgQhDiAKIAdBCEEMIAEgA0kiChtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAOIA5FIAobDAELIAIgA0EQdGshAiABQYCAAnFFBEAgBygCBCEOIAogB0EMQQggASADSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIANBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgDkUgDiAKGwwBCyAHKAIECyEDIBEgEyAUIAMgEkHQuwFqLQAAcyIDGzYCgAQgCSAJKAIAQYAQcjYCACANIA0oAgRBgARyNgIEIAYgA0EZdHJBgAhyIQYLIAEgCyAEKAJsIAZBCXZB7wNxai0AAEECdGoiCSgCACIHKAIAIgNrIQECfyADIAJBEHZLBEAgBygCBCEKIAkgB0EIQQwgASADSSIOG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAogCkUgDhsMAQsgAiADQRB0ayECIAFBgIACcUUEQCAHKAIEIQogCSAHQQxBCCABIANJIg4baigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgA0EJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAKRSAKIA4bDAELIAcoAgQLRQ0FCyABIAsgDSgCBEEadkEEcSANQQRrIg4oAgBBHHZBAXEgBkEVdkEQcSAGQRl2QcAAcSAGQQl2QaoBcXJycnIiCkHQuQFqLQAAQQJ0aiIJKAIAIgcoAgAiA2shASADIAJBEHZLBEAgBygCBCESIAkgB0EIQQwgASADSSIVG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIBIgEkUgFRsMBAsgAiADQRB0ayECIAFBgIACcQ0BIAcoAgQhEiAJIAdBDEEIIAEgA0kiFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEDIActAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECADQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIBJFIBIgFRsMAwsCQCAGQZCAgAFxDQAgASALIAQoAmwgBkHvA3FqLQAAQQJ0aiIJKAIAIgcoAgAiA2shAQJ/IAMgAkEQdksEQCAHKAIEIQogCSAHQQhBDCABIANJIg4baigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhASAHLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiADQQF0IgNBgIACSQ0ACyADIQEgCiAKRSAOGwwBCyACIANBEHRrIQIgAUGAgAJxRQRAIAcoAgQhCiAJIAdBDEEIIAEgA0kiDhtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEDIActAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECADQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogDhsMAQsgBygCBAtFDQAgASALIA0oAgRBEXZBBHEgDUEEayIKKAIAQRN2QQFxIAZBDnZBEHEgBkEQdkHAAHEgBkGqAXFycnJyIhJB0LkBai0AAEECdGoiCSgCACIHKAIAIgNrIQECfyADIAJBEHZLBEAgBygCBCEOIAkgB0EIQQwgASADSSIVG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIA4gDkUgFRsMAQsgAiADQRB0ayECIAFBgIACcUUEQCAHKAIEIQ4gCSAHQQxBCCABIANJIhUbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgA0EJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAORSAOIBUbDAELIAcoAgQLIQMgESATIBQgAyASQdC7AWotAABzIgMbNgIAIAogCigCAEEgcjYCACANIA0oAgRBCHI2AgQgDUGMAmsiByAHKAIAQYCACHI2AgAgDUGEAmsiByAHKAIAQYCAAnI2AgAgDUGIAmsiByAHKAIAIANBH3RyQYCABHI2AgAgBiADQRN0ckEQciEGCwJAIAZBgIGACHENACABIAsgBCgCbCAGQQN2Ig5B7wNxai0AAEECdGoiCSgCACIHKAIAIgNrIQECfyADIAJBEHZLBEAgBygCBCEKIAkgB0EIQQwgASADSSISG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAogCkUgEhsMAQsgAiADQRB0ayECIAFBgIACcUUEQCAHKAIEIQogCSAHQQxBCCABIANJIhIbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgA0EJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAKRSAKIBIbDAELIAcoAgQLRQ0AIAEgCyANKAIEQRR2QQRxIA1BBGsiCigCAEEWdkEBcSAGQQ92QRBxIAZBE3ZBwABxIA5BqgFxcnJyciISQdC5AWotAABBAnRqIgkoAgAiBygCACIDayEBAn8gAyACQRB2SwRAIAcoAgQhDiAJIAdBCEEMIAEgA0kiFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAOIA5FIBUbDAELIAIgA0EQdGshAiABQYCAAnFFBEAgBygCBCEOIAkgB0EMQQggASADSSIVG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIANBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgDkUgDiAVGwwBCyAHKAIECyEDIBEgEyAUIAMgEkHQuwFqLQAAcyIDGzYCgAIgCiAKKAIAQYACcjYCACANIA0oAgRBwAByNgIEIAYgA0EWdHJBgAFyIQYLAkAgBkGAiIDAAHENACABIAsgBCgCbCAGQQZ2Ig5B7wNxai0AAEECdGoiCSgCACIHKAIAIgNrIQECfyADIAJBEHZLBEAgBygCBCEKIAkgB0EIQQwgASADSSISG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAogCkUgEhsMAQsgAiADQRB0ayECIAFBgIACcUUEQCAHKAIEIQogCSAHQQxBCCABIANJIhIbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgA0EJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAKRSAKIBIbDAELIAcoAgQLRQ0AIAEgCyANKAIEQRd2QQRxIA1BBGsiCigCAEEZdkEBcSAGQRJ2QRBxIAZBFnZBwABxIA5BqgFxcnJyciISQdC5AWotAABBAnRqIgkoAgAiBygCACIDayEBAn8gAyACQRB2SwRAIAcoAgQhDiAJIAdBCEEMIAEgA0kiFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAOIA5FIBUbDAELIAIgA0EQdGshAiABQYCAAnFFBEAgBygCBCEOIAkgB0EMQQggASADSSIVG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIANBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgDkUgDiAVGwwBCyAHKAIECyEDIBEgEyAUIAMgEkHQuwFqLQAAcyIDGzYCgAQgCiAKKAIAQYAQcjYCACANIA0oAgRBgARyNgIEIAYgA0EZdHJBgAhyIQYLIAZBgMCAgARxDQMgASALIAQoAmwgBkEJdiISQe8DcWotAABBAnRqIgkoAgAiASgCACIDayEHAn8gAyACQRB2SwRAIAEoAgQhCiAJIAFBCEEMIAMgB0siDhtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhByAKIApFIA4bDAELIAIgA0EQdGshAiAHQYCAAnFFBEAgASgCBCEKIAkgAUEMQQggAyAHSyIOG2ooAgA2AgADQAJAIAUNACAEKAIQIgNBAWohBSADLQABIQEgAy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgB0EBdCIHQYCAAkkNAAsgCkUgCiAOGwwBCyABKAIEC0UEQCAHIQEMBAsgByALIA0oAgRBGnZBBHEgDUEEayIOKAIAQRx2QQFxIAZBFXZBEHEgBkEZdkHAAHEgEkGqAXFycnJyIgpB0LkBai0AAEECdGoiCSgCACIHKAIAIgFrIQMgASACQRB2SwRAIAcoAgQhEiAJIAdBCEEMIAEgA0siFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEDIActAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECADQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIBIgEkUgFRsMAwsgAiABQRB0ayECIANBgIACcUUNASADIQELIAcoAgQMAQsgBygCBCESIAkgB0EMQQggASADSyIVG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIBJFIBIgFRsLIQMgESATIBQgAyAKQdC7AWotAABzIgMbNgKABiAOIA4oAgBBgIABcjYCACANIA0oAgRBgCByNgIEIA0gDSgChAJBBHI2AoQCIA0gDSgCjAJBAXI2AowCIA0gDSgCiAIgA0ESdHJBAnI2AogCIAYgA0EcdHJBgMAAciEGCyANIAZB////tntxNgIACyANQQRqIQYgEUEEaiEDIAxBAWoiDEHAAEcNAAsgDUEMaiEGIBFBhAZqIQMgF0E8SSFYIBdBBGohFyBYDQALDAILQQEgGXQiAUEBdiABciEOIAQoAngiByAUQQJ0akEMaiEDIAQoAoABIQYgBCgCCCEFIAQoAgQhASAEKAIAIQIgBCgCaCEJIAQoAnQhCwJAAkAgFkEIcQRAIAZBBEkNAiAURQ0BIARB5ABqIRAgBEHgAGohDSAUQQNsIRsgFEEBdCEkQQAgDmshFSAEQRxqIRIDQEEAIRgDQAJAAkACfwJAIAMiCCgCACIDBEACQCADQZCAgAFxDQAgASASIAQoAmwgA0HvA3FqLQAAQQJ0aiIJKAIAIgcoAgAiBmshAQJ/IAYgAkEQdk0EQCACIAZBEHRrIQIgAUGAgAJxBEAgBygCBAwCCyAHKAIEIQwgCSAHQQxBCCABIAZJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhBiAHLQAAQf8BRwRAIAQgBTYCEEEIIQUgBkEIdCACaiECDAELIAZBjwFNBEAgBCAFNgIQIAZBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAMRSAMIAobDAELIAcoAgQhDCAJIAdBCEEMIAEgBkkiChtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFHBEAgBCAFNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhASAMIAxFIAobC0UNACABIBIgCCgCBEERdkEEcSAIQQRrIgwoAgBBE3ZBAXEgA0EOdkEQcSADQRB2QcAAcSADQaoBcXJycnIiE0HQuQFqLQAAQQJ0aiIJKAIAIgcoAgAiBmshAQJ/IAYgAkEQdk0EQCACIAZBEHRrIQIgAUGAgAJxBEAgBygCBAwCCyAHKAIEIQogCSAHQQxBCCABIAZJIhwbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhBiAHLQAAQf8BRwRAIAQgBTYCEEEIIQUgBkEIdCACaiECDAELIAZBjwFNBEAgBCAFNgIQIAZBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAKRSAKIBwbDAELIAcoAgQhCiAJIAdBCEEMIAEgBkkiHBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFHBEAgBCAFNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhASAKIApFIBwbCyEGIAsgFSAOIAYgE0HQuwFqLQAAcyIGGzYCACAMIAwoAgBBIHI2AgAgCCAIKAIEQQhyNgIEIAMgBkETdHJBEHIhAwsCQCADQYCBgAhxDQAgASASIAQoAmwgA0EDdiIKQe8DcWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhDCAJIAdBDEEIIAEgBkkiExtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgExsMAQsgBygCBCEMIAkgB0EIQQwgASAGSSITG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAwgDEUgExsLRQ0AIAEgEiAIKAIEQRR2QQRxIAhBBGsiDCgCAEEWdkEBcSADQQ92QRBxIANBE3ZBwABxIApBqgFxcnJyciITQdC5AWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhCiAJIAdBDEEIIAEgBkkiHBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogHBsMAQsgBygCBCEKIAkgB0EIQQwgASAGSSIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAogCkUgHBsLIQYgCyAUQQJ0aiAVIA4gBiATQdC7AWotAABzIgYbNgIAIAwgDCgCAEGAAnI2AgAgCCAIKAIEQcAAcjYCBCADIAZBFnRyQYABciEDCwJAIANBgIiAwABxDQAgASASIAQoAmwgA0EGdiIKQe8DcWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhDCAJIAdBDEEIIAEgBkkiExtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgExsMAQsgBygCBCEMIAkgB0EIQQwgASAGSSITG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAwgDEUgExsLRQ0AIAEgEiAIKAIEQRd2QQRxIAhBBGsiDCgCAEEZdkEBcSADQRJ2QRBxIANBFnZBwABxIApBqgFxcnJyciITQdC5AWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhCiAJIAdBDEEIIAEgBkkiHBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogHBsMAQsgBygCBCEKIAkgB0EIQQwgASAGSSIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAogCkUgHBsLIQYgCyAkQQJ0aiAVIA4gBiATQdC7AWotAABzIgYbNgIAIAwgDCgCAEGAEHI2AgAgCCAIKAIEQYAEcjYCBCADIAZBGXRyQYAIciEDCyADQYDAgIAEcQ0DIAEgEiAEKAJsIANBCXYiCkHvA3FqLQAAQQJ0aiIJKAIAIgEoAgAiBmshBwJ/IAYgAkEQdk0EQCACIAZBEHRrIQIgB0GAgAJxBEAgASgCBAwCCyABKAIEIQwgCSABQQxBCCAGIAdLIhMbaigCADYCAANAAkAgBQ0AIAQoAhAiBkEBaiEFIAYtAAEhASAGLQAAQf8BRwRAIAQgBTYCEEEIIQUgAUEIdCACaiECDAELIAFBjwFNBEAgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiAHQQF0IgdBgIACSQ0ACyAMRSAMIBMbDAELIAEoAgQhDCAJIAFBCEEMIAYgB0siExtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFHBEAgBCAFNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhByAMIAxFIBMbC0UEQCAHIQEMBAsgByASIAgoAgRBGnZBBHEgCEEEayIMKAIAQRx2QQFxIANBFXZBEHEgA0EZdkHAAHEgCkGqAXFycnJyIhNB0LkBai0AAEECdGoiCSgCACIKKAIAIgFrIQYgASACQRB2TQRAIAIgAUEQdGshAiAGQYCAAnEEQCAGIQEMAwsgCigCBCEHIAkgCkEMQQggASAGSyIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgVBAWohCiAFLQABIQEgBS0AAEH/AUcEQCAEIAo2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAdFIAcgHBsMAwsgCigCBCEHIAkgCkEIQQwgASAGSyIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgVBAWohCiAFLQABIQYgBS0AAEH/AUcEQCAEIAo2AhBBCCEFIAZBCHQgAmohAgwBCyAGQY8BTQRAIAQgCjYCECAGQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgByAHRSAcGwwCCyABIA0oAgAiBigCACIDayEBAn8gAyACQRB2TQRAIAIgA0EQdGshAiABQYCAAnEEQCAGKAIEDAILIAYoAgQhByANIAZBDEEIIAEgA0kiDBtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFHBEAgBCAJNgIQQQghBSADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAdFIAcgDBsMAQsgBigCBCEHIA0gBkEIQQwgASADSSIMG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohCSAGLQABIQEgBi0AAEH/AUcEQCAEIAk2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAcgB0UgDBsLRQRAIA0hCQwECyABIBAoAgAiBigCACIDayEBAn8gAyACQRB2TQRAIAIgA0EQdGshAiABQYCAAnEEQCAGKAIEDAILIAYoAgQhByAQIAZBDEEIIAEgA0kiDBtqKAIAIgY2AgADQAJAIAUNACAEKAIQIglBAWohBSAJLQABIQMgCS0AAEH/AUcEQCAEIAU2AhBBCCEFIANBCHQgAmohAgwBCyADQY8BTQRAIAQgBTYCECADQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgB0UgByAMGwwBCyAGKAIEIQcgECAGQQhBDCABIANJIgwbaigCACIGNgIAA0ACQCAFDQAgBCgCECIJQQFqIQUgCS0AASEBIAktAABB/wFHBEAgBCAFNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAHIAdFIAwbCyEMIAEgBigCACIDayEBAn8gAyACQRB2TQRAIAIgA0EQdGshAiABQYCAAnEEQCAGKAIEDAILIAYoAgQhByAQIAZBDEEIIAEgA0kiChtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFHBEAgBCAJNgIQQQghBSADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAdFIAcgChsMAQsgBigCBCEHIBAgBkEIQQwgASADSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohCSAGLQABIQEgBi0AAEH/AUcEQCAEIAk2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAcgB0UgChsLIQZBACEDIBAhCQJAAkACQAJ/AkACQCAGIAxBAXRyDgQAAQMFCAsgASASIAgoAgRBEXZBBHEgCEEEayIHKAIAQRN2QQFxciIKQdC5AWotAABBAnRqIgkoAgAiBigCACIDayEBAn8gAyACQRB2TQRAIAIgA0EQdGshAiABQYCAAnEEQCAGKAIEDAILIAYoAgQhDCAJIAZBDEEIIAEgA0kiExtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFHBEAgBCAJNgIQQQghBSADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgExsMAQsgBigCBCEMIAkgBkEIQQwgASADSSITG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohCSAGLQABIQEgBi0AAEH/AUcEQCAEIAk2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAwgDEUgExsLIQMgCyAVIA4gAyAKQdC7AWotAABzIgMbNgIAIAcgBygCAEEgcjYCACAIIAgoAgRBCHI2AgQgA0ETdCFZIAEgEiAEKAJsLQACQQJ0aiIHKAIAIgYoAgAiA2shAQJ/IAMgAkEQdk0EQCACIANBEHRrIQIgAUGAgAJxBEAgBigCBAwCCyAGKAIEIQkgByAGQQxBCCABIANJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiBkEBaiEHIAYtAAEhAyAGLQAAQf8BRwRAIAQgBzYCEEEIIQUgA0EIdCACaiECDAELIANBjwFNBEAgBCAHNgIQIANBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAJRSAJIAobDAELIAYoAgQhCSAHIAZBCEEMIAEgA0kiChtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQcgBi0AASEBIAYtAABB/wFHBEAgBCAHNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAc2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAJIAlFIAobCyEGIFlBEHIiAyAGRQ0BGgsgASASIAgoAgRBFHZBBHEgCEEEayIJKAIAQRZ2QQFxIANBD3ZBEHEgA0ETdkHAAHEgA0EDdkGqAXFycnJyIhNB0LkBai0AAEECdGoiDCgCACIHKAIAIgZrIQECfyAGIAJBEHZNBEAgAiAGQRB0ayECIAFBgIACcQRAIAcoAgQMAgsgBygCBCEKIAwgB0EMQQggASAGSSIMG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQYgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAZBCHQgAmohAgwBCyAGQY8BTQRAIAQgBTYCECAGQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgCkUgCiAMGwwBCyAHKAIEIQogDCAHQQhBDCABIAZJIgwbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhASAHLQAAQf8BRwRAIAQgBTYCEEEIIQUgAUEIdCACaiECDAELIAFBjwFNBEAgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiAGQQF0IgZBgIACSQ0ACyAGIQEgCiAKRSAMGwshBiALIBRBAnRqIBUgDiAGIBNB0LsBai0AAHMiBhs2AgAgCSAJKAIAQYACcjYCACAIIAgoAgRBwAByNgIEIAMgBkEWdHJBgAFyCyEDIAEgEiAEKAJsIANBBnZB7wNxai0AAEECdGoiCSgCACIHKAIAIgZrIQECfyAGIAJBEHZNBEAgAiAGQRB0ayECIAFBgIACcQRAIAcoAgQMAgsgBygCBCEMIAkgB0EMQQggASAGSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohCSAHLQABIQYgBy0AAEH/AUcEQCAEIAk2AhBBCCEFIAZBCHQgAmohAgwBCyAGQY8BTQRAIAQgCTYCECAGQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgDEUgDCAKGwwBCyAHKAIEIQwgCSAHQQhBDCABIAZJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEJIActAAEhASAHLQAAQf8BRwRAIAQgCTYCEEEIIQUgAUEIdCACaiECDAELIAFBjwFNBEAgBCAJNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiAGQQF0IgZBgIACSQ0ACyAGIQEgDCAMRSAKGwtFDQELIAEgEiAIKAIEQRd2QQRxIAhBBGsiCSgCAEEZdkEBcSADQRJ2QRBxIANBFnZBwABxIANBBnZBqgFxcnJyciITQdC5AWotAABBAnRqIgwoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhCiAMIAdBDEEIIAEgBkkiDBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogDBsMAQsgBygCBCEKIAwgB0EIQQwgASAGSSIMG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAogCkUgDBsLIQYgCyAkQQJ0aiAVIA4gBiATQdC7AWotAABzIgYbNgIAIAkgCSgCAEGAEHI2AgAgCCAIKAIEQYAEcjYCBCADIAZBGXRyQYAIciEDCyABIBIgBCgCbCADQQl2Qe8DcWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhDCAJIAdBDEEIIAEgBkkiChtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgChsMAQsgBygCBCEMIAkgB0EIQQwgASAGSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAwgDEUgChsLRQ0DCyABIBIgCCgCBEEadkEEcSAIQQRrIgwoAgBBHHZBAXEgA0EVdkEQcSADQRl2QcAAcSADQQl2QaoBcXJycnIiE0HQuQFqLQAAQQJ0aiIJKAIAIgooAgAiBmshASAGIAJBEHZNBEAgAiAGQRB0ayECIAFBgIACcQ0BIAooAgQhByAJIApBDEEIIAEgBkkiHBtqKAIANgIAA0ACQCAFDQAgBCgCECIFQQFqIQogBS0AASEGIAUtAABB/wFHBEAgBCAKNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAo2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAdFIAcgHBsMAgsgCigCBCEHIAkgCkEIQQwgASAGSSIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgVBAWohCiAFLQABIQEgBS0AAEH/AUcEQCAEIAo2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAcgB0UgHBsMAQsgCigCBAshBiALIBtBAnRqIBUgDiAGIBNB0LsBai0AAHMiBxs2AgAgDCAMKAIAQYCAAXI2AgAgCCAIKAIEQYAgcjYCBCAEKAJ8QQJ0IAhqIgYgBigCBEEEcjYCBCAGIAYoAgxBAXI2AgwgBiAGKAIIIAdBEnRyQQJyNgIIIAMgB0EcdHJBgMAAciEDCyAIIANB////tntxNgIACyAIQQRqIQMgC0EEaiELIBhBAWoiGCAURw0ACyAIQQxqIQMgCyAbQQJ0aiELIBFBBGoiESAEKAKAASIGQXxxSQ0ACwwCCwJAIAZBBEkNACAUBEAgBEHkAGohECAEQeAAaiENIBRBA2whGyAUQQF0ISRBACAOayEVIARBHGohEgNAQQAhGANAAkACQAJ/AkAgAyIIKAIAIgMEQAJAIANBkICAAXENACABIBIgBCgCbCADQe8DcWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhDCAJIAdBDEEIIAEgBkkiChtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgChsMAQsgBygCBCEMIAkgB0EIQQwgASAGSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAwgDEUgChsLRQ0AIAEgEiAIKAIEQRF2QQRxIAhBBGsiDCgCAEETdkEBcSADQQ52QRBxIANBEHZBwABxIANBqgFxcnJyciITQdC5AWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhCiAJIAdBDEEIIAEgBkkiHBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogHBsMAQsgBygCBCEKIAkgB0EIQQwgASAGSSIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAogCkUgHBsLIQYgCyAVIA4gBiATQdC7AWotAABzIgcbNgIAIAwgDCgCAEEgcjYCACAIIAgoAgRBCHI2AgQgCEF+IAQoAnxrQQJ0aiIGIAYoAgRBgIACcjYCBCAGIAYoAgAgB0EfdHJBgIAEcjYCACAGQQRrIgYgBigCAEGAgAhyNgIAIAMgB0ETdHJBEHIhAwsCQCADQYCBgAhxDQAgASASIAQoAmwgA0EDdiIKQe8DcWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhDCAJIAdBDEEIIAEgBkkiExtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgExsMAQsgBygCBCEMIAkgB0EIQQwgASAGSSITG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAwgDEUgExsLRQ0AIAEgEiAIKAIEQRR2QQRxIAhBBGsiDCgCAEEWdkEBcSADQQ92QRBxIANBE3ZBwABxIApBqgFxcnJyciITQdC5AWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhCiAJIAdBDEEIIAEgBkkiHBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogHBsMAQsgBygCBCEKIAkgB0EIQQwgASAGSSIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAogCkUgHBsLIQYgCyAUQQJ0aiAVIA4gBiATQdC7AWotAABzIgYbNgIAIAwgDCgCAEGAAnI2AgAgCCAIKAIEQcAAcjYCBCADIAZBFnRyQYABciEDCwJAIANBgIiAwABxDQAgASASIAQoAmwgA0EGdiIKQe8DcWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhDCAJIAdBDEEIIAEgBkkiExtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgExsMAQsgBygCBCEMIAkgB0EIQQwgASAGSSITG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAwgDEUgExsLRQ0AIAEgEiAIKAIEQRd2QQRxIAhBBGsiDCgCAEEZdkEBcSADQRJ2QRBxIANBFnZBwABxIApBqgFxcnJyciITQdC5AWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhCiAJIAdBDEEIIAEgBkkiHBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogHBsMAQsgBygCBCEKIAkgB0EIQQwgASAGSSIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAogCkUgHBsLIQYgCyAkQQJ0aiAVIA4gBiATQdC7AWotAABzIgYbNgIAIAwgDCgCAEGAEHI2AgAgCCAIKAIEQYAEcjYCBCADIAZBGXRyQYAIciEDCyADQYDAgIAEcQ0DIAEgEiAEKAJsIANBCXYiCkHvA3FqLQAAQQJ0aiIJKAIAIgEoAgAiBmshBwJ/IAYgAkEQdk0EQCACIAZBEHRrIQIgB0GAgAJxBEAgASgCBAwCCyABKAIEIQwgCSABQQxBCCAGIAdLIhMbaigCADYCAANAAkAgBQ0AIAQoAhAiBkEBaiEFIAYtAAEhASAGLQAAQf8BRwRAIAQgBTYCEEEIIQUgAUEIdCACaiECDAELIAFBjwFNBEAgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiAHQQF0IgdBgIACSQ0ACyAMRSAMIBMbDAELIAEoAgQhDCAJIAFBCEEMIAYgB0siExtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFHBEAgBCAFNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhByAMIAxFIBMbC0UEQCAHIQEMBAsgByASIAgoAgRBGnZBBHEgCEEEayIMKAIAQRx2QQFxIANBFXZBEHEgA0EZdkHAAHEgCkGqAXFycnJyIhNB0LkBai0AAEECdGoiCSgCACIKKAIAIgFrIQYgASACQRB2TQRAIAIgAUEQdGshAiAGQYCAAnEEQCAGIQEMAwsgCigCBCEHIAkgCkEMQQggASAGSyIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgVBAWohCiAFLQABIQEgBS0AAEH/AUcEQCAEIAo2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCjYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAdFIAcgHBsMAwsgCigCBCEHIAkgCkEIQQwgASAGSyIcG2ooAgA2AgADQAJAIAUNACAEKAIQIgVBAWohCiAFLQABIQYgBS0AAEH/AUcEQCAEIAo2AhBBCCEFIAZBCHQgAmohAgwBCyAGQY8BTQRAIAQgCjYCECAGQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgByAHRSAcGwwCCyABIA0oAgAiBigCACIDayEBAn8gAyACQRB2TQRAIAIgA0EQdGshAiABQYCAAnEEQCAGKAIEDAILIAYoAgQhByANIAZBDEEIIAEgA0kiDBtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFHBEAgBCAJNgIQQQghBSADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAdFIAcgDBsMAQsgBigCBCEHIA0gBkEIQQwgASADSSIMG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohCSAGLQABIQEgBi0AAEH/AUcEQCAEIAk2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAcgB0UgDBsLRQRAIA0hCQwECyABIBAoAgAiBigCACIDayEBAn8gAyACQRB2TQRAIAIgA0EQdGshAiABQYCAAnEEQCAGKAIEDAILIAYoAgQhByAQIAZBDEEIIAEgA0kiDBtqKAIAIgY2AgADQAJAIAUNACAEKAIQIglBAWohBSAJLQABIQMgCS0AAEH/AUcEQCAEIAU2AhBBCCEFIANBCHQgAmohAgwBCyADQY8BTQRAIAQgBTYCECADQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgB0UgByAMGwwBCyAGKAIEIQcgECAGQQhBDCABIANJIgwbaigCACIGNgIAA0ACQCAFDQAgBCgCECIJQQFqIQUgCS0AASEBIAktAABB/wFHBEAgBCAFNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAHIAdFIAwbCyEMIAEgBigCACIDayEBAn8gAyACQRB2TQRAIAIgA0EQdGshAiABQYCAAnEEQCAGKAIEDAILIAYoAgQhByAQIAZBDEEIIAEgA0kiChtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFHBEAgBCAJNgIQQQghBSADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAdFIAcgChsMAQsgBigCBCEHIBAgBkEIQQwgASADSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohCSAGLQABIQEgBi0AAEH/AUcEQCAEIAk2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAcgB0UgChsLIQZBACEDIBAhCQJAAkACQAJ/AkACQCAGIAxBAXRyDgQAAQMFCAsgASASIAgoAgRBEXZBBHEgCEEEayIHKAIAQRN2QQFxciIKQdC5AWotAABBAnRqIgkoAgAiBigCACIDayEBAn8gAyACQRB2TQRAIAIgA0EQdGshAiABQYCAAnEEQCAGKAIEDAILIAYoAgQhDCAJIAZBDEEIIAEgA0kiExtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFHBEAgBCAJNgIQQQghBSADQQh0IAJqIQIMAQsgA0GPAU0EQCAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgExsMAQsgBigCBCEMIAkgBkEIQQwgASADSSITG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohCSAGLQABIQEgBi0AAEH/AUcEQCAEIAk2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAwgDEUgExsLIQMgCyAVIA4gAyAKQdC7AWotAABzIgYbNgIAIAcgBygCAEEgcjYCACAIIAgoAgRBCHI2AgQgCEF+IAQoAnxrQQJ0aiIDIAMoAgRBgIACcjYCBCADIAMoAgAgBkEfdHJBgIAEcjYCACADQQRrIgMgAygCAEGAgAhyNgIAIAZBE3QhWiABIBIgBCgCbC0AAkECdGoiBygCACIGKAIAIgNrIQECfyADIAJBEHZNBEAgAiADQRB0ayECIAFBgIACcQRAIAYoAgQMAgsgBigCBCEJIAcgBkEMQQggASADSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgZBAWohByAGLQABIQMgBi0AAEH/AUcEQCAEIAc2AhBBCCEFIANBCHQgAmohAgwBCyADQY8BTQRAIAQgBzYCECADQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgCUUgCSAKGwwBCyAGKAIEIQkgByAGQQhBDCABIANJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiBkEBaiEHIAYtAAEhASAGLQAAQf8BRwRAIAQgBzYCEEEIIQUgAUEIdCACaiECDAELIAFBjwFNBEAgBCAHNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiADQQF0IgNBgIACSQ0ACyADIQEgCSAJRSAKGwshBiBaQRByIgMgBkUNARoLIAEgEiAIKAIEQRR2QQRxIAhBBGsiCSgCAEEWdkEBcSADQQ92QRBxIANBE3ZBwABxIANBA3ZBqgFxcnJyciITQdC5AWotAABBAnRqIgwoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhCiAMIAdBDEEIIAEgBkkiDBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEGIActAABB/wFHBEAgBCAFNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAU2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIApFIAogDBsMAQsgBygCBCEKIAwgB0EIQQwgASAGSSIMG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUcEQCAEIAU2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAogCkUgDBsLIQYgCyAUQQJ0aiAVIA4gBiATQdC7AWotAABzIgYbNgIAIAkgCSgCAEGAAnI2AgAgCCAIKAIEQcAAcjYCBCADIAZBFnRyQYABcgshAyABIBIgBCgCbCADQQZ2Qe8DcWotAABBAnRqIgkoAgAiBygCACIGayEBAn8gBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnEEQCAHKAIEDAILIAcoAgQhDCAJIAdBDEEIIAEgBkkiChtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQkgBy0AASEGIActAABB/wFHBEAgBCAJNgIQQQghBSAGQQh0IAJqIQIMAQsgBkGPAU0EQCAEIAk2AhAgBkEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAxFIAwgChsMAQsgBygCBCEMIAkgB0EIQQwgASAGSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohCSAHLQABIQEgBy0AAEH/AUcEQCAEIAk2AhBBCCEFIAFBCHQgAmohAgwBCyABQY8BTQRAIAQgCTYCECABQQl0IAJqIQJBByEFDAELIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQULIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAwgDEUgChsLRQ0BCyABIBIgCCgCBEEXdkEEcSAIQQRrIgkoAgBBGXZBAXEgA0ESdkEQcSADQRZ2QcAAcSADQQZ2QaoBcXJycnIiE0HQuQFqLQAAQQJ0aiIMKAIAIgcoAgAiBmshAQJ/IAYgAkEQdk0EQCACIAZBEHRrIQIgAUGAgAJxBEAgBygCBAwCCyAHKAIEIQogDCAHQQxBCCABIAZJIgwbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhBiAHLQAAQf8BRwRAIAQgBTYCEEEIIQUgBkEIdCACaiECDAELIAZBjwFNBEAgBCAFNgIQIAZBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAKRSAKIAwbDAELIAcoAgQhCiAMIAdBCEEMIAEgBkkiDBtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFHBEAgBCAFNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhASAKIApFIAwbCyEGIAsgJEECdGogFSAOIAYgE0HQuwFqLQAAcyIGGzYCACAJIAkoAgBBgBByNgIAIAggCCgCBEGABHI2AgQgAyAGQRl0ckGACHIhAwsgASASIAQoAmwgA0EJdkHvA3FqLQAAQQJ0aiIJKAIAIgcoAgAiBmshAQJ/IAYgAkEQdk0EQCACIAZBEHRrIQIgAUGAgAJxBEAgBygCBAwCCyAHKAIEIQwgCSAHQQxBCCABIAZJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhBiAHLQAAQf8BRwRAIAQgBTYCEEEIIQUgBkEIdCACaiECDAELIAZBjwFNBEAgBCAFNgIQIAZBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAMRSAMIAobDAELIAcoAgQhDCAJIAdBCEEMIAEgBkkiChtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFHBEAgBCAFNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhASAMIAxFIAobC0UNAwsgASASIAgoAgRBGnZBBHEgCEEEayIMKAIAQRx2QQFxIANBFXZBEHEgA0EZdkHAAHEgA0EJdkGqAXFycnJyIhNB0LkBai0AAEECdGoiCSgCACIKKAIAIgZrIQEgBiACQRB2TQRAIAIgBkEQdGshAiABQYCAAnENASAKKAIEIQcgCSAKQQxBCCABIAZJIhwbaigCADYCAANAAkAgBQ0AIAQoAhAiBUEBaiEKIAUtAAEhBiAFLQAAQf8BRwRAIAQgCjYCEEEIIQUgBkEIdCACaiECDAELIAZBjwFNBEAgBCAKNgIQIAZBCXQgAmohAkEHIQUMAQsgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAHRSAHIBwbDAILIAooAgQhByAJIApBCEEMIAEgBkkiHBtqKAIANgIAA0ACQCAFDQAgBCgCECIFQQFqIQogBS0AASEBIAUtAABB/wFHBEAgBCAKNgIQQQghBSABQQh0IAJqIQIMAQsgAUGPAU0EQCAEIAo2AhAgAUEJdCACaiECQQchBQwBCyAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFCyAFQQFrIQUgAkEBdCECIAZBAXQiBkGAgAJJDQALIAYhASAHIAdFIBwbDAELIAooAgQLIQYgCyAbQQJ0aiAVIA4gBiATQdC7AWotAABzIgcbNgIAIAwgDCgCAEGAgAFyNgIAIAggCCgCBEGAIHI2AgQgBCgCfEECdCAIaiIGIAYoAgRBBHI2AgQgBiAGKAIMQQFyNgIMIAYgBigCCCAHQRJ0ckECcjYCCCADIAdBHHRyQYDAAHIhAwsgCCADQf///7Z7cTYCAAsgCEEEaiEDIAtBBGohCyAYQQFqIhggFEcNAAsgCEEMaiEDIAsgG0ECdGohCyARQQRqIhEgBCgCgAEiBkF8cUkNAAsMAQtBBCAGQXxxIgMgA0EETRtBAWsiA0F8cUEEaiERIAcgA0EBdEF4cWpBFGohAwsgBCAFNgIIIAQgATYCBCAEIAI2AgAgBCAJNgJoIBRFDQQgBiARTQ0EA0BBACEFIBEgBCgCgAFHBEADQCAEIAMgCyAFIBRsQQJ0aiAOIAVBABBYIAVBAWoiBSAEKAKAASARa0kNAAsLIAMgAygCAEH///+2e3E2AgAgC0EEaiELIANBBGohAyAXQQFqIhcgFEcNAAsMBAtBBCAGQXxxIgMgA0EETRtBAWsiA0F8cUEEaiERIAcgA0EBdEF4cWpBFGohAwsgBCAFNgIIIAQgATYCBCAEIAI2AgAgBCAJNgJoIBRFDQIgBiARTQ0CA0BBACEFIBEgBCgCgAFHBEADQCAEIAMgCyAFIBRsQQJ0aiAOIAVBARBYIAVBAWoiBSAEKAKAASARa0kNAAsLIAMgAygCAEH///+2e3E2AgAgC0EEaiELIANBBGohAyAXQQFqIhcgFEcNAAsMAgsDQEEAIQwDQCADIRECQAJAAn8CQAJAIAYiDSgCACIGRQRAIAEgECgCACIDKAIAIgZrIQECfyAGIAJBEHZLBEAgAygCBCEHIBAgA0EIQQwgASAGSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgNBAWohCSADLQABIQEgAy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAJNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAJNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAcgB0UgChsMAQsgAiAGQRB0ayECIAFBgIACcUUEQCADKAIEIQcgECADQQxBCCABIAZJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiBkEBaiEJIAYtAAEhAyAGLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAk2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAHRSAHIAobDAELIAMoAgQLRQRAIBAhCQwGCyABIAgoAgAiAygCACIGayEBAn8gBiACQRB2SwRAIAMoAgQhByAIIANBCEEMIAEgBkkiChtqKAIAIgM2AgADQAJAIAUNACAEKAIQIglBAWohBSAJLQABIQEgCS0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAcgB0UgChsMAQsgAiAGQRB0ayECIAFBgIACcUUEQCADKAIEIQcgCCADQQxBCCABIAZJIgobaigCACIDNgIAA0ACQCAFDQAgBCgCECIJQQFqIQUgCS0AASEGIAktAABB/wFGBEAgBkGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECAGQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgBkEIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAdFIAcgChsMAQsgAygCBAshCiABIAMoAgAiBmshAQJ/IAYgAkEQdksEQCADKAIEIQcgCCADQQhBDCABIAZJIg4baigCADYCAANAAkAgBQ0AIAQoAhAiA0EBaiEJIAMtAAEhASADLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAk2AhAgAUEJdCACaiECQQchBQwBCyAEIAk2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiAGQQF0IgZBgIACSQ0ACyAGIQEgByAHRSAOGwwBCyACIAZBEHRrIQIgAUGAgAJxRQRAIAMoAgQhByAIIANBDEEIIAEgBkkiDhtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQkgBi0AASEDIAYtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgCTYCECADQQl0IAJqIQJBByEFDAELIAQgCTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAdFIAcgDhsMAQsgAygCBAshA0EAIQYgCCEJAkACQAJAAn8CQAJAIAMgCkEBdHIOBAABAwUKCyABIAsgDSgCBEERdkEEcSANQQRrIgcoAgBBE3ZBAXFyIg5B0LkBai0AAEECdGoiCSgCACIDKAIAIgZrIQECfyAGIAJBEHZLBEAgAygCBCEKIAkgA0EIQQwgASAGSSISG2ooAgA2AgADQAJAIAUNACAEKAIQIgNBAWohCSADLQABIQEgAy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAJNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAJNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgBkEBdCIGQYCAAkkNAAsgBiEBIAogCkUgEhsMAQsgAiAGQRB0ayECIAFBgIACcUUEQCADKAIEIQogCSADQQxBCCABIAZJIhIbaigCADYCAANAAkAgBQ0AIAQoAhAiBkEBaiEJIAYtAAEhAyAGLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAk2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAKRSAKIBIbDAELIAMoAgQLIQMgESATIBQgAyAOQdC7AWotAABzIgMbNgIAIAcgBygCAEEgcjYCACANIA0oAgRBCHI2AgQgA0ETdCFbIAEgCyAEKAJsLQACQQJ0aiIHKAIAIgMoAgAiBmshAQJ/IAYgAkEQdksEQCADKAIEIQkgByADQQhBDCABIAZJIg4baigCADYCAANAAkAgBQ0AIAQoAhAiA0EBaiEHIAMtAAEhASADLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAc2AhAgAUEJdCACaiECQQchBQwBCyAEIAc2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiAGQQF0IgZBgIACSQ0ACyAGIQEgCSAJRSAOGwwBCyACIAZBEHRrIQIgAUGAgAJxRQRAIAMoAgQhCSAHIANBDEEIIAEgBkkiDhtqKAIANgIAA0ACQCAFDQAgBCgCECIGQQFqIQcgBi0AASEDIAYtAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBzYCECADQQl0IAJqIQJBByEFDAELIAQgBzYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIAlFIAkgDhsMAQsgAygCBAshAyBbQRByIgYgA0UNARoLIAEgCyANKAIEQRR2QQRxIA1BBGsiCSgCAEEWdkEBcSAGQQ92QRBxIAZBE3ZBwABxIAZBA3ZBqgFxcnJyciISQdC5AWotAABBAnRqIgooAgAiBygCACIDayEBAn8gAyACQRB2SwRAIAcoAgQhDiAKIAdBCEEMIAEgA0kiChtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAOIA5FIAobDAELIAIgA0EQdGshAiABQYCAAnFFBEAgBygCBCEOIAogB0EMQQggASADSSIKG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIANBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgDkUgDiAKGwwBCyAHKAIECyEDIBEgEyAUIAMgEkHQuwFqLQAAcyIDGzYCgAIgCSAJKAIAQYACcjYCACANIA0oAgRBwAByNgIEIAYgA0EWdHJBgAFyCyEGIAEgCyAEKAJsIAZBBnZB7wNxai0AAEECdGoiCSgCACIHKAIAIgNrIQECfyADIAJBEHZLBEAgBygCBCEKIAkgB0EIQQwgASADSSIOG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohCSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAJNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAJNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAogCkUgDhsMAQsgAiADQRB0ayECIAFBgIACcUUEQCAHKAIEIQogCSAHQQxBCCABIANJIg4baigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEJIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAk2AhAgA0EJdCACaiECQQchBQwBCyAEIAk2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAKRSAKIA4bDAELIAcoAgQLRQ0BCyABIAsgDSgCBEEXdkEEcSANQQRrIgkoAgBBGXZBAXEgBkESdkEQcSAGQRZ2QcAAcSAGQQZ2QaoBcXJycnIiEkHQuQFqLQAAQQJ0aiIKKAIAIgcoAgAiA2shAQJ/IAMgAkEQdksEQCAHKAIEIQ4gCiAHQQhBDCABIANJIgobaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhASAHLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiADQQF0IgNBgIACSQ0ACyADIQEgDiAORSAKGwwBCyACIANBEHRrIQIgAUGAgAJxRQRAIAcoAgQhDiAKIAdBDEEIIAEgA0kiChtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEDIActAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECADQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIA5FIA4gChsMAQsgBygCBAshAyARIBMgFCADIBJB0LsBai0AAHMiAxs2AoAEIAkgCSgCAEGAEHI2AgAgDSANKAIEQYAEcjYCBCAGIANBGXRyQYAIciEGCyABIAsgBCgCbCAGQQl2Qe8DcWotAABBAnRqIgkoAgAiBygCACIDayEBAn8gAyACQRB2SwRAIAcoAgQhCiAJIAdBCEEMIAEgA0kiDhtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAKIApFIA4bDAELIAIgA0EQdGshAiABQYCAAnFFBEAgBygCBCEKIAkgB0EMQQggASADSSIOG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIANBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgCkUgCiAOGwwBCyAHKAIEC0UNBQsgASALIA0oAgRBGnZBBHEgDUEEayIOKAIAQRx2QQFxIAZBFXZBEHEgBkEZdkHAAHEgBkEJdkGqAXFycnJyIgpB0LkBai0AAEECdGoiCSgCACIHKAIAIgNrIQEgAyACQRB2SwRAIAcoAgQhEiAJIAdBCEEMIAEgA0kiFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASASIBJFIBUbDAQLIAIgA0EQdGshAiABQYCAAnENASAHKAIEIRIgCSAHQQxBCCABIANJIhUbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgA0EJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyASRSASIBUbDAMLAkAgBkGQgIABcQ0AIAEgCyAEKAJsIAZB7wNxai0AAEECdGoiCSgCACIHKAIAIgNrIQECfyADIAJBEHZLBEAgBygCBCEKIAkgB0EIQQwgASADSSIOG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQEgBy0AAEH/AUYEQCABQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIAFBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSABQQh0IAJqIQILIAVBAWshBSACQQF0IQIgA0EBdCIDQYCAAkkNAAsgAyEBIAogCkUgDhsMAQsgAiADQRB0ayECIAFBgIACcUUEQCAHKAIEIQogCSAHQQxBCCABIANJIg4baigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgA0EJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyAKRSAKIA4bDAELIAcoAgQLRQ0AIAEgCyANKAIEQRF2QQRxIA1BBGsiCigCAEETdkEBcSAGQQ52QRBxIAZBEHZBwABxIAZBqgFxcnJyciISQdC5AWotAABBAnRqIgkoAgAiBygCACIDayEBAn8gAyACQRB2SwRAIAcoAgQhDiAJIAdBCEEMIAEgA0kiFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAOIA5FIBUbDAELIAIgA0EQdGshAiABQYCAAnFFBEAgBygCBCEOIAkgB0EMQQggASADSSIVG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIANBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgDkUgDiAVGwwBCyAHKAIECyEDIBEgEyAUIAMgEkHQuwFqLQAAcyIDGzYCACAKIAooAgBBIHI2AgAgDSANKAIEQQhyNgIEIAYgA0ETdHJBEHIhBgsCQCAGQYCBgAhxDQAgASALIAQoAmwgBkEDdiIOQe8DcWotAABBAnRqIgkoAgAiBygCACIDayEBAn8gAyACQRB2SwRAIAcoAgQhCiAJIAdBCEEMIAEgA0kiEhtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAKIApFIBIbDAELIAIgA0EQdGshAiABQYCAAnFFBEAgBygCBCEKIAkgB0EMQQggASADSSISG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIANBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgCkUgCiASGwwBCyAHKAIEC0UNACABIAsgDSgCBEEUdkEEcSANQQRrIgooAgBBFnZBAXEgBkEPdkEQcSAGQRN2QcAAcSAOQaoBcXJycnIiEkHQuQFqLQAAQQJ0aiIJKAIAIgcoAgAiA2shAQJ/IAMgAkEQdksEQCAHKAIEIQ4gCSAHQQhBDCABIANJIhUbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhASAHLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiADQQF0IgNBgIACSQ0ACyADIQEgDiAORSAVGwwBCyACIANBEHRrIQIgAUGAgAJxRQRAIAcoAgQhDiAJIAdBDEEIIAEgA0kiFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEDIActAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECADQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIA5FIA4gFRsMAQsgBygCBAshAyARIBMgFCADIBJB0LsBai0AAHMiAxs2AoACIAogCigCAEGAAnI2AgAgDSANKAIEQcAAcjYCBCAGIANBFnRyQYABciEGCwJAIAZBgIiAwABxDQAgASALIAQoAmwgBkEGdiIOQe8DcWotAABBAnRqIgkoAgAiBygCACIDayEBAn8gAyACQRB2SwRAIAcoAgQhCiAJIAdBCEEMIAEgA0kiEhtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASAKIApFIBIbDAELIAIgA0EQdGshAiABQYCAAnFFBEAgBygCBCEKIAkgB0EMQQggASADSSISG2ooAgA2AgADQAJAIAUNACAEKAIQIgdBAWohBSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCACQYD+A2ohAkEIIQUMAgsgBCAFNgIQIANBCXQgAmohAkEHIQUMAQsgBCAFNgIQQQghBSADQQh0IAJqIQILIAVBAWshBSACQQF0IQIgAUEBdCIBQYCAAkkNAAsgCkUgCiASGwwBCyAHKAIEC0UNACABIAsgDSgCBEEXdkEEcSANQQRrIgooAgBBGXZBAXEgBkESdkEQcSAGQRZ2QcAAcSAOQaoBcXJycnIiEkHQuQFqLQAAQQJ0aiIJKAIAIgcoAgAiA2shAQJ/IAMgAkEQdksEQCAHKAIEIQ4gCSAHQQhBDCABIANJIhUbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhASAHLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiADQQF0IgNBgIACSQ0ACyADIQEgDiAORSAVGwwBCyACIANBEHRrIQIgAUGAgAJxRQRAIAcoAgQhDiAJIAdBDEEIIAEgA0kiFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEDIActAABB/wFGBEAgA0GQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECADQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgA0EIdCACaiECCyAFQQFrIQUgAkEBdCECIAFBAXQiAUGAgAJJDQALIA5FIA4gFRsMAQsgBygCBAshAyARIBMgFCADIBJB0LsBai0AAHMiAxs2AoAEIAogCigCAEGAEHI2AgAgDSANKAIEQYAEcjYCBCAGIANBGXRyQYAIciEGCyAGQYDAgIAEcQ0DIAEgCyAEKAJsIAZBCXYiEkHvA3FqLQAAQQJ0aiIJKAIAIgEoAgAiA2shBwJ/IAMgAkEQdksEQCABKAIEIQogCSABQQhBDCADIAdLIg4baigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhASAHLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgAUEJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIAFBCHQgAmohAgsgBUEBayEFIAJBAXQhAiADQQF0IgNBgIACSQ0ACyADIQcgCiAKRSAOGwwBCyACIANBEHRrIQIgB0GAgAJxRQRAIAEoAgQhCiAJIAFBDEEIIAMgB0siDhtqKAIANgIAA0ACQCAFDQAgBCgCECIDQQFqIQUgAy0AASEBIAMtAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIAdBAXQiB0GAgAJJDQALIApFIAogDhsMAQsgASgCBAtFBEAgByEBDAQLIAcgCyANKAIEQRp2QQRxIA1BBGsiDigCAEEcdkEBcSAGQRV2QRBxIAZBGXZBwABxIBJBqgFxcnJyciIKQdC5AWotAABBAnRqIgkoAgAiBygCACIBayEDIAEgAkEQdksEQCAHKAIEIRIgCSAHQQhBDCABIANLIhUbaigCADYCAANAAkAgBQ0AIAQoAhAiB0EBaiEFIActAAEhAyAHLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAJBgP4DaiECQQghBQwCCyAEIAU2AhAgA0EJdCACaiECQQchBQwBCyAEIAU2AhBBCCEFIANBCHQgAmohAgsgBUEBayEFIAJBAXQhAiABQQF0IgFBgIACSQ0ACyASIBJFIBUbDAMLIAIgAUEQdGshAiADQYCAAnFFDQEgAyEBCyAHKAIEDAELIAcoAgQhEiAJIAdBDEEIIAEgA0siFRtqKAIANgIAA0ACQCAFDQAgBCgCECIHQQFqIQUgBy0AASEBIActAABB/wFGBEAgAUGQAU8EQCAEIAQoAgxBAWo2AgwgAkGA/gNqIQJBCCEFDAILIAQgBTYCECABQQl0IAJqIQJBByEFDAELIAQgBTYCEEEIIQUgAUEIdCACaiECCyAFQQFrIQUgAkEBdCECIANBAXQiA0GAgAJJDQALIAMhASASRSASIBUbCyEDIBEgEyAUIAMgCkHQuwFqLQAAcyIDGzYCgAYgDiAOKAIAQYCAAXI2AgAgDSANKAIEQYAgcjYCBCANIA0oAoQCQQRyNgKEAiANIA0oAowCQQFyNgKMAiANIA0oAogCIANBEnRyQQJyNgKIAiAGIANBHHRyQYDAAHIhBgsgDSAGQf///7Z7cTYCAAsgDUEEaiEGIBFBBGohAyAMQQFqIgxBwABHDQALIA1BDGohBiARQYQGaiEDIBdBPEkhXCAXQQRqIRcgXA0ACwsgBCAFNgIIIAQgATYCBCAEIAI2AgAgBCAJNgJoCwJAIBZBIHFFDQAgBCAEQeQAajYCaCAEIAQoAgQgBCgCZCIGKAIAIgFrIgI2AgQCQCABIAQoAgAiBUEQdksEQCAEIAE2AgQgBCAGQQhBDCABIAJLG2ooAgAiBjYCZCAEKAIIIQIDQAJAIAINACAEKAIQIgdBAWohCSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCAFQYD+A2ohBUEIIQIMAgsgBCAJNgIQIANBCXQgBWohBUEHIQIMAQsgBCAJNgIQQQghAiADQQh0IAVqIQULIAQgAkEBayICNgIIIAQgBUEBdCIFNgIAIAQgAUEBdCIBNgIEIAFBgIACSQ0ACyABIQIMAQsgBCAFIAFBEHRrIgU2AgAgAkGAgAJxDQAgBCAGQQxBCCABIAJLG2ooAgAiBjYCZCAEKAIIIQEDQAJAIAENACAEKAIQIgFBAWohByABLQABIQMgAS0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCAFQYD+A2ohBUEIIQEMAgsgBCAHNgIQIANBCXQgBWohBUEHIQEMAQsgBCAHNgIQQQghASADQQh0IAVqIQULIAQgAUEBayIBNgIIIAQgBUEBdCIFNgIAIAQgAkEBdCICNgIEIAJBgIACSQ0ACwsgBCACIAYoAgAiAWsiAjYCBAJAIAEgBUEQdksEQCAEIAE2AgQgBCAGQQhBDCABIAJLG2ooAgAiBjYCZCAEKAIIIQIDQAJAIAINACAEKAIQIgdBAWohCSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCAFQYD+A2ohBUEIIQIMAgsgBCAJNgIQIANBCXQgBWohBUEHIQIMAQsgBCAJNgIQQQghAiADQQh0IAVqIQULIAQgAkEBayICNgIIIAQgBUEBdCIFNgIAIAQgAUEBdCIBNgIEIAFBgIACSQ0ACyABIQIMAQsgBCAFIAFBEHRrIgU2AgAgAkGAgAJxDQAgBCAGQQxBCCABIAJLG2ooAgAiBjYCZCAEKAIIIQEDQAJAIAENACAEKAIQIgFBAWohByABLQABIQMgAS0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCAFQYD+A2ohBUEIIQEMAgsgBCAHNgIQIANBCXQgBWohBUEHIQEMAQsgBCAHNgIQQQghASADQQh0IAVqIQULIAQgAUEBayIBNgIIIAQgBUEBdCIFNgIAIAQgAkEBdCICNgIEIAJBgIACSQ0ACwsgBCACIAYoAgAiAWsiAjYCBAJAIAEgBUEQdksEQCAEIAE2AgQgBCAGQQhBDCABIAJLG2ooAgAiBjYCZCAEKAIIIQIDQAJAIAINACAEKAIQIgdBAWohCSAHLQABIQMgBy0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCAFQYD+A2ohBUEIIQIMAgsgBCAJNgIQIANBCXQgBWohBUEHIQIMAQsgBCAJNgIQQQghAiADQQh0IAVqIQULIAQgAkEBayICNgIIIAQgBUEBdCIFNgIAIAQgAUEBdCIBNgIEIAFBgIACSQ0ACyABIQIMAQsgBCAFIAFBEHRrIgU2AgAgAkGAgAJxDQAgBCAGQQxBCCABIAJLG2ooAgAiBjYCZCAEKAIIIQEDQAJAIAENACAEKAIQIgFBAWohByABLQABIQMgAS0AAEH/AUYEQCADQZABTwRAIAQgBCgCDEEBajYCDCAFQYD+A2ohBUEIIQEMAgsgBCAHNgIQIANBCXQgBWohBUEHIQEMAQsgBCAHNgIQQQghASADQQh0IAVqIQULIAQgAUEBayIBNgIIIAQgBUEBdCIFNgIAIAQgAkEBdCICNgIEIAJBgIACSQ0ACwsgBCACIAYoAgAiAWsiAjYCBCABIAVBEHZLBEAgBCABNgIEIAQgBkEIQQwgASACSxtqKAIANgJkIAQoAgghAgNAAkAgAg0AIAQoAhAiBkEBaiEHIAYtAAEhAyAGLQAAQf8BRgRAIANBkAFPBEAgBCAEKAIMQQFqNgIMIAVBgP4DaiEFQQghAgwCCyAEIAc2AhAgA0EJdCAFaiEFQQchAgwBCyAEIAc2AhBBCCECIANBCHQgBWohBQsgBCACQQFrIgI2AgggBCAFQQF0IgU2AgAgBCABQQF0IgE2AgQgAUGAgAJJDQALDAELIAQgBSABQRB0ayIHNgIAIAJBgIACcQ0AIAQgBkEMQQggASACSxtqKAIANgJkIAQoAgghBQNAAkAgBQ0AIAQoAhAiA0EBaiEGIAMtAAEhASADLQAAQf8BRgRAIAFBkAFPBEAgBCAEKAIMQQFqNgIMIAdBgP4DaiEHQQghBQwCCyAEIAY2AhAgAUEJdCAHaiEHQQchBQwBCyAEIAY2AhBBCCEFIAFBCHQgB2ohBwsgBCAFQQFrIgU2AgggBCAHQQF0Igc2AgAgBCACQQF0IgI2AgQgAkGAgAJJDQALCwsgJw0AIAQQWiAEQbCpATYCZCAEQdCeATYCYCAEQfCeATYCHAtBACAfQQFqIgEgAUEDRiIBGyEfIBkgAWshGSAmQQFqIiYgICgCCE8NASAZQQBKDQALCyAoICpqISggBCgCGCAELwFwOwAAIClBAWoiKSAaKAIsSQ0ACwsCQCArRQ0AAkAgBCgCGCIBIAQoAhAiA0ECaksEQCAhRQ0BICMgASAEKAIUIgZrNgI4ICMgAyAGazYCNCAjIAEgA2tBAms2AjAgHUECQZDyACAjQTBqEA8MAgsgBCgCDCIBQQNJDQEgIQRAICMgATYCUCAdQQJB6TUgI0HQAGoQDwwCCyAjIAE2AkAgHUECQek1ICNBQGsQDwwBCyAjIAEgBCgCFCIGazYCKCAjIAMgBms2AiQgIyABIANrQQJrNgIgIB1BAkGQ8gAgI0EgahAPCyAaKAI8RQ0AIAQgLDYCdAsgMCgCBCEBIBooAgwhXSAaKAIIIDAoAgBrIQggMCgCECIGQQFxBEAgMigCHCA3QZgBbGoiB0GQAWsoAgAgCGogB0GYAWsoAgBrIQgLIF0gAWshAyAGQQJxBEAgMigCHCA3QZgBbGoiAUGMAWsoAgAgA2ogAUGUAWsoAgBrIQMLIBooAjwiBiECIAZFBEAgBCgCdCECCyAEKAKAASEWIAQoAnwhDQJAIC8oAqgGIgdFDQAgFkUgDUVyIQEgB0EeTARAIAENAUEAIRADQCANIBBsIQRBACEBA0AgAiABIARqQQJ0aiIRKAIAIgkgCUEfdSIFcyAFayIFIAd2BEAgEUEAIAUgLygCqAZ2IhFrIBEgCUEASBs2AgALIAFBAWoiASANRw0ACyAQQQFqIhAgFkcNAAsMAQsgAQ0AIAJBACANIBZsQQJ0EBUaCyAGBEAgDSAWbCEGIC8oAhRBAUYEQCAGRQ0FQQAhASAGQQRPBEAgBkF8cSEBQQAhBANAIAIgBEECdGoiAyAD/QACACJe/RsAQQJt/REgXv0bAUECbf0cASBe/RsCQQJt/RwCIF79GwNBAm39HAP9CwIAIARBBGoiBCABRw0ACyABIAZGDQYLA0AgAiABQQJ0aiIDIAMoAgBBAm02AgAgAUEBaiIBIAZHDQALDAULIAZFDQQgMCoCIEMAAAA/lCFmQQAhBAJAIAZBBEkEQCACIQEMAQsgAiAGQXxxIgRBAnRqIQEgZv0TIV5BACEDA0AgAiADQQJ0aiIHIF4gB/0AAgD9+gH95gH9CwIAIANBBGoiAyAERw0ACyAEIAZGDQULA0AgASBmIAEoAgCylDgCACABQQRqIQEgBEEBaiIEIAZHDQALDAQLIDYgNWshESAvKAIUQQFHDQIgFkUNAyAyKAIkIgYgAyARbCIDQQJ0aiAIQQJ0aiEJIA1BfHEiDEEBayIBQQRxIQsgNiANIDVqa0ECdCEaIAFBAnZBAWpB/v///wdxIR0gAyAIakECdCAGaiACayEKQQAhCCABQQNHIRQDQEEAIQECQCAMRQ0AIAggDWwhAyAJIAggEWxBAnRqIQZBACEHIBQEQANAIAYgAUECdGogAiABIANqQQJ0av0AAgAiXv0bAEECbf0RIF79GwFBAm39HAEgXv0bAkECbf0cAiBe/RsDQQJt/RwD/QsCACAGIAFBBHIiBEECdGogAiADIARqQQJ0av0AAgAiXv0bAEECbf0RIF79GwFBAm39HAEgXv0bAkECbf0cAiBe/RsDQQJt/RwD/QsCACABQQhqIQEgB0ECaiIHIB1HDQALCyALDQAgBiABQQJ0aiACIAEgA2pBAnRq/QACACJe/RsAQQJt/REgXv0bAUECbf0cASBe/RsCQQJt/RwCIF79GwNBAm39HAP9CwIAIAFBBGohAQsCQCABIA1PDQAgCCANbCEDIAkgCCARbEECdGohBwJAIA0gAWsiEEEESQRAIAEhBAwBCyAKIAggGmxqQRBJBEAgASEEDAELIAEgEEF8cSIFaiEEQQAhBgNAIAcgASAGaiIhQQJ0aiACIAMgIWpBAnRq/QACACJe/RsAQQJt/REgXv0bAUECbf0cASBe/RsCQQJt/RwCIF79GwNBAm39HAP9CwIAIAZBBGoiBiAFRw0ACyAFIBBGDQELIARBAWohASANIARrQQFxBEAgByAEQQJ0aiACIAMgBGpBAnRqKAIAQQJtNgIAIAEhBAsgASANRg0AA0AgByAEQQJ0aiACIAMgBGpBAnRqKAIAQQJtNgIAIAcgBEEBaiIBQQJ0aiACIAEgA2pBAnRqKAIAQQJtNgIAIARBAmoiBCANRw0ACwsgCEEBaiIIIBZHDQALDAMLICMgGTYCACAdQQJB1cEAICMQDwsgECgCAEEANgIADAELIBZFDQAgDUUNACAyKAIkIAMgEWxBAnRqIAhBAnRqIQcgDUF8cSIDQQJ0IQYgMCoCIEMAAAA/lCJm/RMhXkEAIRAgDUEESSEIA0ACQAJAIAgEQCACIQkgByEBQQAhBAwBCyAGIAdqIQEgAiAGaiEJQQAhBANAIAcgBEECdCIFaiBeIAIgBWr9AAIA/foB/eYB/QsCACAEQQRqIgQgA0cNAAsgCSECIAMiBCANRg0BCyAJIQIDQCABIGYgAigCALKUOAIAIAFBBGohASACQQRqIQIgBEEBaiIEIA1HDQALCyAHIBFBAnRqIQcgEEEBaiIQIBZHDQALCyAAEBAgI0HgAGokAAvWBAEJfyAAKAIsQQhPBEAgACgCKCEFQQghCgNAIAAoAgxBBXQhCCAAKAIAIQQgACgCJCEDAkAgACgCFCIGIAAoAhAiAU0NACAEIAhqIQcgAUEBaiECIAYgAWtBAXEEQCAHIAFBBnRqIgkgBSABIANsQQJ0aiIB/QACAP0LAgAgCSAB/QACEP0LAhAgAiEBCyACIAZGDQADQCAHIAFBBnRqIgIgBSABIANsQQJ0aiIJ/QACAP0LAgAgAiAJ/QACEP0LAhAgByABQQFqIgJBBnRqIgkgBSACIANsQQJ0aiIC/QACEP0LAhAgCSAC/QACAP0LAgAgAUECaiIBIAZHDQALCwJAIAAoAhwiBiAAKAIYIgFNDQAgBCAIa0EgaiEHIAUgACgCCCADbEECdGohCCABQQFqIQIgBiABa0EBcQRAIAcgAUEGdGoiBCAIIAEgA2xBAnRqIgH9AAIA/QsCACAEIAH9AAIQ/QsCECACIQELIAIgBkYNAANAIAcgAUEGdGoiAiAIIAEgA2xBAnRqIgT9AAIA/QsCACACIAT9AAIQ/QsCECAHIAFBAWoiAkEGdGoiBCAIIAIgA2xBAnRqIgL9AAIQ/QsCECAEIAL9AAIA/QsCACABQQJqIgEgBkcNAAsLIAAQIkEAIQEgACgCIARAA0AgBSAAKAIkIAFsQQJ0aiICIAAoAgAgAUEFdGoiA/0AAgD9CwIAIAIgA/0AAhD9CwIQIAFBAWoiASAAKAIgSQ0ACwsgBUEgaiEFIApBCGoiCiAAKAIsTQ0ACwsgACgCABAQIAAQEAv3DQElfyAAKAIsQQhPBEAgACgCJCIKQQV0IR4gCkEHbCEWIApBBmwhFyAKQQVsIRggCkEDbCEZIApBAXQhGiAAKAIoIgEgCkEcbGohHyABIApBGGxqISAgASAKQRRsaiEhIAEgCkEEdGohIiABIApBDGxqISMgASAKQQN0IiRqISUgASAKQQJ0IhtqISZBCCEcA0AgACABIAAoAiRBCBA7IAAQIgJAIAAoAiAiC0UNACAdIB5sIQggACgCACEGQQAhBAJAAkAgC0HoAkkNACAGQQxqIg4gC0EBayICQQV0IgNqIA5JDQAgBkEIaiIPIANqIA9JDQAgAyAGaiAGSQ0AIAZBBGoiECADaiAQSQ0AIAJB////P0sNACABIAggJmoiAyALQQJ0IgVqIgxJIAMgASAFaiIHSXENACABIAggJWoiAiAFaiINSSACIAdJcQ0AIAEgBSAIICNqIglqIgVJIAcgCUtxDQAgBiAHSSABIAYgC0EFdGoiEUEcayISSXENACABIBFBGGsiE0kgByAQS3ENACABIBFBFGsiFEkgByAPS3ENACAHIA5LIAEgEUEQayIHSXENACADIA1JIAIgDElxDQAgAyAFSSAJIAxJcQ0AIAMgEkkgBiAMSXENACADIBNJIAwgEEtxDQAgAyAUSSAMIA9LcQ0AIAMgB0kgDCAOS3ENACACIAVJIAkgDUlxDQAgAiASSSAGIA1JcQ0AIAIgE0kgDSAQS3ENACACIBRJIA0gD0txDQAgAiAHSSANIA5LcQ0AIAkgEkkgBSAGS3ENACAJIBNJIAUgEEtxDQAgCSAUSSAFIA9LcQ0AIAcgCUsgBSAOS3ENACALQfz///8AcSEEQQAhAwNAIAEgA0ECdGogBiADQQV0aiIC/QkCACACKgIg/SABIAJBQGsqAgD9IAIgAioCYP0gA/0LAgAgASADIApqQQJ0aiAC/QkCBCACKgIk/SABIAIqAkT9IAIgAioCZP0gA/0LAgAgASADIBpqQQJ0aiAC/QkCCCACKgIo/SABIAIqAkj9IAIgAioCaP0gA/0LAgAgASADIBlqQQJ0aiAC/QkCDCACKgIs/SABIAIqAkz9IAIgAioCbP0gA/0LAgAgA0EEaiIDIARHDQALIAQgC0YNAQsDQCABIARBAnRqIAYgBEEFdGoiAyoCADgCACABIAQgCmpBAnRqIAMqAgQ4AgAgASAEIBpqQQJ0aiADKgIIOAIAIAEgBCAZakECdGogAyoCDDgCACAEQQFqIgQgC0cNAAsLIAAoAgAhBkEAIQQCQCALQdwASQ0AIAZBHGoiDyALQQFrIgJBBXQiA2ogD0kNACAGQRhqIhAgA2ogEEkNACAGQRBqIhEgA2ogEUkNACAGQRRqIhIgA2ogEkkNACACQf///z9LDQAgCCAiaiIDIAggIWoiAiALQQJ0IgVqIgxJIAIgAyAFaiIHSXENACADIAggIGoiCSAFaiINSSAHIAlLcQ0AIAMgCCAfaiIIIAVqIgVJIAcgCEtxDQAgAyAGIAtBBXRqIg5BDGsiE0kgByARS3ENACADIA5BCGsiFEkgByASS3ENACADIA5BBGsiFUkgByAQS3ENACADIA5JIAcgD0txDQAgAiANSSAJIAxJcQ0AIAIgBUkgCCAMSXENACACIBNJIAwgEUtxDQAgAiAUSSAMIBJLcQ0AIAIgFUkgDCAQS3ENACACIA5JIAwgD0txDQAgCCANSSAFIAlLcQ0AIAkgE0kgDSARS3ENACAJIBRJIA0gEktxDQAgCSAVSSANIBBLcQ0AIAkgDkkgDSAPS3ENACAIIBNJIAUgEUtxDQAgCCAUSSAFIBJLcQ0AIAggFUkgBSAQS3ENACAIIA5JIAUgD0txDQAgC0H8////AHEhBEEAIQMDQCABIAMgG2pBAnRqIAYgA0EFdGoiAv0JAhAgAioCMP0gASACKgJQ/SACIAIqAnD9IAP9CwIAIAEgAyAYakECdGogAv0JAhQgAioCNP0gASACKgJU/SACIAIqAnT9IAP9CwIAIAEgAyAXakECdGogAv0JAhggAioCOP0gASACKgJY/SACIAIqAnj9IAP9CwIAIAEgAyAWakECdGogAv0JAhwgAioCPP0gASACKgJc/SACIAIqAnz9IAP9CwIAIANBBGoiAyAERw0ACyAEIAtGDQELA0AgASAEIBtqQQJ0aiAGIARBBXRqIgMqAhA4AgAgASAEIBhqQQJ0aiADKgIUOAIAIAEgBCAXakECdGogAyoCGDgCACABIAQgFmpBAnRqIAMqAhw4AgAgBEEBaiIEIAtHDQALCyAdQQFqIR0gASAkQQJ0aiEBIBxBCGoiHCAAKAIsTQ0ACwsgACgCABAQIAAQEAtzAQJ/IAAoAhwiAUEIaiIDIAAoAiAiAk0EQANAIAAgACgCGCABQQJ0aiAAKAIUQQgQMCADIgFBCGoiAyAAKAIgIgJNDQALCyABIAJJBEAgACAAKAIYIAFBAnRqIAAoAhQgAiABaxAwCyAAKAIAEBAgABAQC0QAIAAoAhwiASAAKAIgSQRAA0AgACAAKAIYIAAoAhQgAWxBAnRqEF0gAUEBaiIBIAAoAiBJDQALCyAAKAIAEBAgABAQC6gBAQV/IAAoAlQiAygCACEFIAMoAgQiBCAAKAIUIAAoAhwiB2siBiAEIAZJGyIGBEAgBSAHIAYQEhogAyADKAIAIAZqIgU2AgAgAyADKAIEIAZrIgQ2AgQLIAQgAiACIARLGyIEBEAgBSABIAQQEhogAyADKAIAIARqIgU2AgAgAyADKAIEIARrNgIECyAFQQA6AAAgACAAKAIsIgE2AhwgACABNgIUIAILngUCBn4EfyABIAEoAgBBB2pBeHEiAUEQajYCACAAIQsgASkDACEDIAEpAwghByMAQSBrIggkACAHQv///////z+DIQQCfiAHQjCIQv//AYMiBaciCkGB+ABrQf0PTQRAIARCBIYgA0I8iIQhAiAKQYD4AGutIQUCQCADQv//////////D4MiA0KBgICAgICAgAhaBEAgAkIBfCECDAELIANCgICAgICAgIAIUg0AIAJCAYMgAnwhAgtCACACIAJC/////////wdWIgAbIQIgAK0gBXwMAQsCQCADIASEUA0AIAVC//8BUg0AIARCBIYgA0I8iIRCgICAgICAgASEIQJC/w8MAQtC/w8gCkH+hwFLDQAaQgBBgPgAQYH4ACAFUCIBGyIAIAprIglB8ABKDQAaIAMhAiAEIARCgICAgICAwACEIAEbIgYhBAJAQYABIAlrIgFBwABxBEAgAyABQUBqrYYhBEIAIQIMAQsgAUUNACAEIAGtIgWGIAJBwAAgAWutiIQhBCACIAWGIQILIAggAjcDECAIIAQ3AxgCQCAJQcAAcQRAIAYgCUFAaq2IIQNCACEGDAELIAlFDQAgBkHAACAJa62GIAMgCa0iAoiEIQMgBiACiCEGCyAIIAM3AwAgCCAGNwMIIAgpAwhCBIYgCCkDACICQjyIhCEDAkAgACAKRyAIKQMQIAgpAxiEQgBSca0gAkL//////////w+DhCICQoGAgICAgICACFoEQCADQgF8IQMMAQsgAkKAgICAgICAgAhSDQAgA0IBgyADfCEDCyADQoCAgICAgIAIhSADIANC/////////wdWIgAbIQIgAK0LIQMgCEEgaiQAIAsgB0KAgICAgICAgIB/gyADQjSGhCAChL85AwALhhgDE38BfAN+IwBBsARrIgwkACAMQQA2AiwCQCABvSIaQgBTBEBBASERQboIIRMgAZoiAb0hGgwBCyAEQYAQcQRAQQEhEUG9CCETDAELQcAIQbsIIARBAXEiERshEyARRSEVCwJAIBpCgICAgICAgPj/AINCgICAgICAgPj/AFEEQCAAQSAgAiARQQNqIgMgBEH//3txEBwgACATIBEQGSAAQZIJQfYKIAVBIHEiBRtB+wlB+gogBRsgASABYhtBAxAZIABBICACIAMgBEGAwABzEBwgAyACIAIgA0gbIQoMAQsgDEEQaiESAkACfwJAIAEgDEEsahBlIgEgAaAiAUQAAAAAAAAAAGIEQCAMIAwoAiwiBkEBazYCLCAFQSByIg5B4QBHDQEMAwsgBUEgciIOQeEARg0CIAwoAiwhCUEGIAMgA0EASBsMAQsgDCAGQR1rIgk2AiwgAUQAAAAAAACwQaIhAUEGIAMgA0EASBsLIQsgDEEwakGgAkEAIAlBAE4baiINIQcDQCAHAn8gAUQAAAAAAADwQWMgAUQAAAAAAAAAAGZxBEAgAasMAQtBAAsiAzYCACAHQQRqIQcgASADuKFEAAAAAGXNzUGiIgFEAAAAAAAAAABiDQALAkAgCUEATARAIAkhAyAHIQYgDSEIDAELIA0hCCAJIQMDQEEdIAMgA0EdTxshAwJAIAdBBGsiBiAISQ0AIAOtIRxCACEaA0AgBiAaQv////8PgyAGNQIAIByGfCIbQoCU69wDgCIaQoDslKMMfiAbfD4CACAGQQRrIgYgCE8NAAsgG0KAlOvcA1QNACAIQQRrIgggGj4CAAsDQCAIIAciBkkEQCAGQQRrIgcoAgBFDQELCyAMIAwoAiwgA2siAzYCLCAGIQcgA0EASg0ACwsgA0EASARAIAtBGWpBCW5BAWohDyAOQeYARiEQA0BBCUEAIANrIgMgA0EJTxshCgJAIAYgCE0EQCAIKAIARUECdCEHDAELQYCU69wDIAp2IRRBfyAKdEF/cyEWQQAhAyAIIQcDQCAHIAMgBygCACIXIAp2ajYCACAWIBdxIBRsIQMgB0EEaiIHIAZJDQALIAgoAgBFQQJ0IQcgA0UNACAGIAM2AgAgBkEEaiEGCyAMIAwoAiwgCmoiAzYCLCANIAcgCGoiCCAQGyIHIA9BAnRqIAYgBiAHa0ECdSAPShshBiADQQBIDQALC0EAIQMCQCAGIAhNDQAgDSAIa0ECdUEJbCEDQQohByAIKAIAIgpBCkkNAANAIANBAWohAyAKIAdBCmwiB08NAAsLIAsgA0EAIA5B5gBHG2sgDkHnAEYgC0EAR3FrIgcgBiANa0ECdUEJbEEJa0gEQCAMQTBqQYRgQaRiIAlBAEgbaiAHQYDIAGoiCkEJbSIPQQJ0aiEJQQohByAPQXdsIApqIgpBB0wEQANAIAdBCmwhByAKQQFqIgpBCEcNAAsLAkAgCSgCACIQIBAgB24iDyAHbCIKRiAJQQRqIhQgBkZxDQAgECAKayEQAkAgD0EBcUUEQEQAAAAAAABAQyEBIAdBgJTr3ANHDQEgCCAJTw0BIAlBBGstAABBAXFFDQELRAEAAAAAAEBDIQELRAAAAAAAAOA/RAAAAAAAAPA/RAAAAAAAAPg/IAYgFEYbRAAAAAAAAPg/IBAgB0EBdiIURhsgECAUSRshGQJAIBUNACATLQAAQS1HDQAgGZohGSABmiEBCyAJIAo2AgAgASAZoCABYQ0AIAkgByAKaiIDNgIAIANBgJTr3ANPBEADQCAJQQA2AgAgCCAJQQRrIglLBEAgCEEEayIIQQA2AgALIAkgCSgCAEEBaiIDNgIAIANB/5Pr3ANLDQALCyANIAhrQQJ1QQlsIQNBCiEHIAgoAgAiCkEKSQ0AA0AgA0EBaiEDIAogB0EKbCIHTw0ACwsgCUEEaiIHIAYgBiAHSxshBgsDQCAGIgcgCE0iCkUEQCAGQQRrIgYoAgBFDQELCwJAIA5B5wBHBEAgBEEIcSEJDAELIANBf3NBfyALQQEgCxsiBiADSiADQXtKcSIJGyAGaiELQX9BfiAJGyAFaiEFIARBCHEiCQ0AQXchBgJAIAoNACAHQQRrKAIAIg5FDQBBCiEKQQAhBiAOQQpwDQADQCAGIglBAWohBiAOIApBCmwiCnBFDQALIAlBf3MhBgsgByANa0ECdUEJbCEKIAVBX3FBxgBGBEBBACEJIAsgBiAKakEJayIGQQAgBkEAShsiBiAGIAtKGyELDAELQQAhCSALIAMgCmogBmpBCWsiBkEAIAZBAEobIgYgBiALShshCwtBfyEKIAtB/f///wdB/v///wcgCSALciIQG0oNASALIBBBAEdqQQFqIQ4CQCAFQV9xIhVBxgBGBEAgAyAOQf////8Hc0oNAyADQQAgA0EAShshBgwBCyASIAMgA0EfdSIGcyAGa60gEhAqIgZrQQFMBEADQCAGQQFrIgZBMDoAACASIAZrQQJIDQALCyAGQQJrIg8gBToAACAGQQFrQS1BKyADQQBIGzoAACASIA9rIgYgDkH/////B3NKDQILIAYgDmoiAyARQf////8Hc0oNASAAQSAgAiADIBFqIgMgBBAcIAAgEyAREBkgAEEwIAIgAyAEQYCABHMQHAJAAkACQCAVQcYARgRAIAxBEGpBCXIhBSANIAggCCANSxsiCSEIA0AgCDUCACAFECohBgJAIAggCUcEQCAGIAxBEGpNDQEDQCAGQQFrIgZBMDoAACAGIAxBEGpLDQALDAELIAUgBkcNACAGQQFrIgZBMDoAAAsgACAGIAUgBmsQGSAIQQRqIgggDU0NAAsgEARAIABBggxBARAZCyAHIAhNDQEgC0EATA0BA0AgCDUCACAFECoiBiAMQRBqSwRAA0AgBkEBayIGQTA6AAAgBiAMQRBqSw0ACwsgACAGQQkgCyALQQlOGxAZIAtBCWshBiAIQQRqIgggB08NAyALQQlKIRggBiELIBgNAAsMAgsCQCALQQBIDQAgByAIQQRqIAcgCEsbIQ0gDEEQakEJciEFIAghBwNAIAUgBzUCACAFECoiBkYEQCAGQQFrIgZBMDoAAAsCQCAHIAhHBEAgBiAMQRBqTQ0BA0AgBkEBayIGQTA6AAAgBiAMQRBqSw0ACwwBCyAAIAZBARAZIAZBAWohBiAJIAtyRQ0AIABBggxBARAZCyAAIAYgBSAGayIGIAsgBiALSBsQGSALIAZrIQsgB0EEaiIHIA1PDQEgC0EATg0ACwsgAEEwIAtBEmpBEkEAEBwgACAPIBIgD2sQGQwCCyALIQYLIABBMCAGQQlqQQlBABAcCyAAQSAgAiADIARBgMAAcxAcIAMgAiACIANIGyEKDAELIBMgBUEadEEfdUEJcWohCAJAIANBC0sNAEEMIANrIQZEAAAAAAAAMEAhGQNAIBlEAAAAAAAAMECiIRkgBkEBayIGDQALIAgtAABBLUYEQCAZIAGaIBmhoJohAQwBCyABIBmgIBmhIQELIBIgDCgCLCIHIAdBH3UiBnMgBmutIBIQKiIGRgRAIAZBAWsiBkEwOgAACyARQQJyIQsgBUEgcSENIAZBAmsiCSAFQQ9qOgAAIAZBAWtBLUErIAdBAEgbOgAAIARBCHEhBiAMQRBqIQcDQCAHIgUCfyABmUQAAAAAAADgQWMEQCABqgwBC0GAgICAeAsiB0HQxAFqLQAAIA1yOgAAIAEgB7ehRAAAAAAAADBAoiEBAkAgBUEBaiIHIAxBEGprQQFHDQACQCAGDQAgA0EASg0AIAFEAAAAAAAAAABhDQELIAVBLjoAASAFQQJqIQcLIAFEAAAAAAAAAABiDQALQX8hCkH9////ByALIBIgCWsiBmoiDWsgA0gNACAAQSAgAiANIANBAmogByAMQRBqIgdrIgUgBUECayADSBsgBSADGyIKaiIDIAQQHCAAIAggCxAZIABBMCACIAMgBEGAgARzEBwgACAHIAUQGSAAQTAgCiAFa0EAQQAQHCAAIAkgBhAZIABBICACIAMgBEGAwABzEBwgAyACIAIgA0gbIQoLIAxBsARqJAAgCgsEAEIACwQAQQALnwMBCX9B5gohAAJAA0AgAC0AACIBRQ0BIAFBPUYNASAAQQFqIgBBA3ENAAsCQAJAQYCChAggACgCACICayACckGAgYKEeHFBgIGChHhHDQADQEGAgoQIIAJBvfr06QNzIgFrIAFyQYCBgoR4cUGAgYKEeEcNASAAKAIEIQIgAEEEaiIBIQAgAkGAgoQIIAJrckGAgYKEeHFBgIGChHhGDQALDAELIAAhAQsDQCABIgAtAAAiAkUNASAAQQFqIQEgAkE9Rw0ACwsgACIBQeYKRgRAQQAPCwJAIAFB5gprIgBB5gpqLQAADQBBsM8BKAIAIgRFDQAgBCgCACIFRQ0AA0ACQAJ/IAUhAkHmCiEGQQAgACIBRQ0AGkHmCi0AACIDBH8CQANAIAMgAi0AACIHRw0BIAdFDQEgAUEBayIBRQ0BIAJBAWohAiAGLQABIQMgBkEBaiEGIAMNAAtBACEDCyADBUEACyACLQAAawtFBEAgACAFaiIBLQAAQT1GDQELIAQoAgQhBSAEQQRqIQQgBQ0BDAILCyABQQFqIQgLIAgLCQAgACgCPBANC84CAQh/IwBBIGsiAyQAIAMgACgCHCIENgIQIAAoAhQhBSADIAI2AhwgAyABNgIYIAMgBSAEayIBNgIUIAEgAmohBUECIQYgA0EQaiEBAn8DQAJAAkACQCAAKAI8IAEgBiADQQxqEAEiBAR/QZTHASAENgIAQX8FQQALRQRAIAUgAygCDCIHRg0BIAdBAE4NAgwDCyAFQX9HDQILIAAgACgCLCIBNgIcIAAgATYCFCAAIAEgACgCMGo2AhAgAgwDCyABIAcgASgCBCIISyIJQQN0aiIEIAcgCEEAIAkbayIIIAQoAgBqNgIAIAFBDEEEIAkbaiIBIAEoAgAgCGs2AgAgBSAHayEFIAYgCWshBiAEIQEMAQsLIABBADYCHCAAQgA3AxAgACAAKAIAQSByNgIAQQAgBkECRg0AGiACIAEoAgRrCyEKIANBIGokACAKC1YBAn8gACgCPCEEIwBBEGsiACQAIAQgAacgAUIgiKcgAkH/AXEgAEEIahAJIgIEf0GUxwEgAjYCAEF/BUEACyECIAApAwghASAAQRBqJABCfyABIAIbCwYAIAAQAAsGACAAEAML8n4FAnw2fwh7A34GfSMAQeDAAGsiGCQAIBhBADYCIEECIQwCQAJAIAAoAgAiB0GNlJzUAEYNACAHQf+f/Y8FRwRAAkAgB0GAgIDgAEcNACAAKAIEQeqggYECRw0AIAAoAghBjZSc1ABGDQILQc0IEABBASEMDAILQQAhDAsCf0EAQQFB4AAQEyIHRQ0AGiAHQQE2AkwCQAJAAkACQCAMDgMAAwEDCyAHQcMANgJYIAdBxAA2AlQgB0HFADYCUCAHQcYANgIQIAdBxwA2AgQgB0HIADYCHCAHQckANgIYIAdBygA2AhQgB0HLADYCACAHQcwANgJcIAdBzQA2AiwgB0HOADYCKCAHQc8ANgIkIAdB0AA2AiAgB0HRADYCDCAHQdIANgIIIAcQTSIINgIwIAgNAQwCCyAHQdMANgJYIAdB1AA2AlQgB0HVADYCUCAHQdYANgIQIAdB1wA2AgQgB0HYADYCXCAHQdkANgIsIAdB2gA2AiggB0HbADYCJCAHQdwANgIgIAdB3QA2AhwgB0HeADYCGCAHQd8ANgIUIAdB4AA2AgwgB0HhADYCCCAHQeIANgIAIAcCf0EBQYgBEBMiCARAIAgQTSIONgIAAkAgDkUNACAI/QwAAAAAAAAAAAAAAAAAAAAA/QsCbCAIQQA6AHwgCBAzIg42AgQgDkUNACAIEDMiDjYCCCAORQ0AIAgMAgsgCBBwC0EACyIINgIwIAhFDQELIAdBATYCSCAHQQE2AkAgB0EANgI8IAdCADcCNCAHQQE2AkQgBwwBCyAHEBBBAAsiCARAIAhBADYCPCAIQeMANgJICyAIBEAgCEEANgI4IAhB5AA2AkQLIAgEQCAIQQA2AjQgCEHlADYCQAsgGEEkaiIHBEAgB0EAQbjAABAVIgdBADYCuEAgB0J/NwKIQAsgAwRAIBggGCgC3EBBAXI2AtxACyAYIAE2AhwgGCAANgIYIBggADYCFEEBIQxBACEBAkAgGEEUaiIHRQ0AQQFByAAQEyIABH8CfyAAQYCAwAA2AkAgAEGAgMAAEBQiDjYCICAORQRAIAAQEEEADAELIAAgDjYCJCAAQQI2AhwgAEEDNgIYIABBBDYCFCAAQQU2AhAgAEEGNgIsIABBCDYCKCAAIAAoAkRBAnI2AkQgAAsFQQALIgBFDQAgAARAIABBADYCBCAAIAc2AgALIAc1AgghRSAABEAgACBFNwMICwJAIABFDQAgAC0AREECcUUNACAAQT82AhALIAAEQCAAQcEANgIYCyAABEAgAEHCADYCHAsgACEBCyABIQACfyAYQSRqIQECQCAIRQ0AIAFFDQAgCCgCTEUEQCAIQTRqQQFBtMkAQQAQD0EADAILIAgoAjAgASAIKAIYEQMAQQEhCwsgCwtFBEBB3AgQACAAEDQgCBA1DAELAn8gGEEgaiEBQQAhBwJAIABFDQAgCEUNACAIKAJMRQRAIAhBNGpBAUGFygBBABAPQQAMAgsgACAIKAIwIAEgCEE0aiAIKAIAEQEAIQcLIAcLRQRAQfgIEAAgABA0IAgQNSAYKAIgECEMAQsgGCgCICEBQQAhBwJAIAhFDQAgAEUNACAIKAJMRQ0AIAgoAjAgACABIAhBNGogCCgCBBEBACEHCwJAIAcEQEEAIQcCQCAIRQ0AIABFDQAgCCgCTEUNACAIKAIwIAAgCEE0aiAIKAIQEQAAIQcLIAcNAQtB/wkQACAIEDUgABA0IBgoAiAQIQwBCyAAEDQgCBA1IBgoAiAiDSgCHCIABEAgABAQIBgoAiAiDUIANwIcCyANKAIQISECQAJAIAJFBEACQCAERQ0AICFBBEcNAEEBIRlBBCEhDAMLAkACQCANKAIUIgFBA0YNACAhQQNHDQAgDSgCGCIAKAIAIAAoAgRHDQEgACgCNEEBRg0BIA1BAzYCFAwDCyAhQQJLDQAgDUECNgIUDAMLAkACQCABQQNrDgMDAQAECyMAQRBrIg4kAAJAAkACQCANKAIQQQRJDQAgDSgCGCIAKAIAIgEgACgCNEcNACABIAAoAmhHDQAgASAAKAKcAUcNACAAKAIEIgEgACgCOEcNACABIAAoAmxHDQAgASAAKAKgAUYNAQsgDkGHCDYCBCAOQbgKNgIAQejEAUHtPSAOEBYMAQsCQCAAKAIMIAAoAghsIghFBEAgACgCyAEhAQwBC0MAAIA/QX8gACgCtAF0QX9zs5UhSEMAAIA/QX8gACgCgAF0QX9zs5UhSkMAAIA/QX8gACgCTHRBf3OzlSFLQwAAgD9BfyAAKAIYdEF/c7OVIUkgACgCyAEhASAAKAKUASECIAAoAmAhCiAAKAIsIQdBACEAAkAgCEEISQ0AIAcgCiAIQQJ0IgtqIg9JIAogByALaiIXSXENACACIBdJIAcgAiALaiIJSXENACABIBdJIAcgASALaiILSXENACACIA9JIAkgCktxDQAgASAPSSAKIAtJcQ0AIAEgCUkgAiALSXENACAIQXxxIQAgSP0TIT0gSv0TIT4gS/0TIUMgSf0TIUBBACELA0AgAiALQQJ0Ig9qIhf9AAIAIUEgCiAPaiIJ/QACACFCIAcgD2oiEP0MAACAPwAAgD8AAIA/AACAPyBAIBD9AAIA/foB/eYB/eUB/QwAAH9DAAB/QwAAf0MAAH9D/eYB/QwAAIA/AACAPwAAgD8AAIA/ID0gASAPav0AAgD9+gH95gH95QEiP/3mAf34Af0LAgAgCf0MAACAPwAAgD8AAIA/AACAPyBDIEL9+gH95gH95QH9DAAAf0MAAH9DAAB/QwAAf0P95gEgP/3mAf34Af0LAgAgF/0MAACAPwAAgD8AAIA/AACAPyA+IEH9+gH95gH95QH9DAAAf0MAAH9DAAB/QwAAf0P95gEgP/3mAf34Af0LAgAgC0EEaiILIABHDQALIAAgCEYNAQsDQAJ/QwAAgD8gSSAHIABBAnQiC2oiDygCALKUk0MAAH9DlEMAAIA/IEggASALaigCALKUkyJMlCJNi0MAAABPXQRAIE2oDAELQYCAgIB4CyEXIAIgC2oiCSgCACEQIAogC2oiCygCACEMIA8gFzYCACALAn9DAACAPyBLIAyylJNDAAB/Q5QgTJQiTYtDAAAAT10EQCBNqAwBC0GAgICAeAs2AgAgCQJ/QwAAgD8gSiAQspSTQwAAf0OUIEyUIkyLQwAAAE9dBEAgTKgMAQtBgICAgHgLNgIAIABBAWoiACAIRw0ACwsgARAQIA0oAhgiAEEINgKAASAAQQg2AkwgAEEINgIYIABBADYCyAEgDUEBNgIUIA0gDSgCEEEBayIANgIQIABBBEkNAEEDIQADQCANKAIYIABBNGxqIgEgASgCZDYCMCABIAH9AAJU/QsCICABIAH9AAJE/QsCECABIAH9AAI0/QsCACAAQQFqIgAgDSgCEEkNAAsLIA5BEGokAAwDCyMAQRBrIgskAAJAAkACQCANKAIQQQNJDQAgDSgCGCIAKAIAIgEgACgCNEcNACABIAAoAmhHDQAgACgCBCIBIAAoAjhHDQAgASAAKAJsRg0BCyALQcUINgIEIAtBuAo2AgBB6MQBQZc+IAsQFgwBCwJAIAAoAgwgACgCCGwiAkUNAEF/IAAoAhgiCnRBf3MhAUEAQQEgCkEBa3QiCiAAKAKIARshD0EAIAogACgCVBshFyAAKAKUASEKIAAoAmAhByAAKAIsIQ5BACEAAkAgAkEESQ0AIA4gByACQQJ0IghqIglJIAcgCCAOaiIQSXENACAKIBBJIA4gCCAKaiIISXENACAHIAhJIAkgCktxDQAgAkF8cSEAIAH9ESE/IA/9ESFAIBf9ESFBQQAhCANAIA4gCEECdCIJaiIQID8gCSAKaiIM/QACACBA/bEB/foBIj39DGl0sz9pdLM/aXSzP2l0sz/95gEgByAJaiIJ/QACACBB/bEB/foBIj79DLNZGrizWRq4s1kauLNZGrj95gEgEP0AAgD9+gEiQ/3kAf3kAf0MAAAAPwAAAD8AAAA/AAAAP/3kAf34ASJC/QwAAAAAAAAAAAAAAAAAAAAA/bgBID8gQv05/VL9CwIAIAkgPyA9/QwZ0Da/GdA2vxnQNr8Z0Da//eYBIEP9DNUJgD/VCYA/1QmAP9UJgD/95gEgPv0MJzGwvicxsL4nMbC+JzGwvv3mAf3kAf3kAf0MAAAAPwAAAD8AAAA/AAAAP/3kAf34ASJC/QwAAAAAAAAAAAAAAAAAAAAA/bgBID8gQv05/VL9CwIAIAwgPyA9/Qy9Nwa3vTcGt703Bre9Nwa3/eYBIEP9DGb0fz9m9H8/ZvR/P2b0fz/95gEgPv0MNdLiPzXS4j810uI/NdLiP/3mAf3kAf3kAf0MAAAAPwAAAD8AAAA/AAAAP/3kAf34ASI9/QwAAAAAAAAAAAAAAAAAAAAA/bgBID8gPf05/VL9CwIAIAhBBGoiCCAARw0ACyAAIAJGDQELA0ACfyAKIABBAnQiCGoiCSgCACAPa7IiSENpdLM/lCAHIAhqIhAoAgAgF2uyIkpDs1kauJQgCCAOaiIMKAIAsiJLkpJDAAAAP5IiSYtDAAAAT10EQCBJqAwBC0GAgICAeAshCCAMIAEgCEEAIAhBAEobIAEgCEgbNgIAIBAgAQJ/IEhDGdA2v5QgS0PVCYA/lCBKQycxsL6UkpJDAAAAP5IiSYtDAAAAT10EQCBJqAwBC0GAgICAeAsiCEEAIAhBAEobIAEgCEgbNgIAIAkgAQJ/IEhDvTcGt5QgS0Nm9H8/lCBKQzXS4j+UkpJDAAAAP5IiSItDAAAAT10EQCBIqAwBC0GAgICAeAsiCEEAIAhBAEobIAEgCEgbNgIAIABBAWoiACACRw0ACwsgDUEBNgIUCyALQRBqJAAMAgsgISACIAIgIUsbISFBASEZDAELAkACQAJ/AkACQCANKAIYIgEoAgBBAUcNAAJAAkAgASgCNEEBaw4CAQACCyABKAJoQQJHDQECQCABKAIEQQFHDQAgASgCOEECRw0AIAEoAmxBAkcNAEEAIQsgDSIXKAIYIgAoAhghASAAKAKUASERIAAoAmAhCiAAKAIsIRAgACgCCCINIAAoAgwiAmxBAnQiABAYIQcgABAYIQggABAYIQ4CQAJAAkACQAJAAkAgB0UNACAIRQ0AIA5FDQBBfyABdEF/cyEJQQEgAUEBa3QhDCACIBcoAgRBAXEiAGshHiAXKAIAQQFxIRsgAEUNAyANRQ0DAn9BACAMa7K7IgVEarx0kxgE1j+iIAVEDAIrhxbZ5j+ioCIGmUQAAAAAAADgQWMEQCAGqgwBC0GAgICAeAshFAJ/IAVEJzEIrBxa/D+iIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyEaIA1BCEkhOAJ/IAVEO99PjZdu9j+iIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyEdIDgNASAIIAdrQRBJDQEgDiAHa0EQSQ0BIAcgEGtBEEkNASAOIAhrQRBJDQEgCCAQa0EQSQ0BIA4gEGtBEEkNASAOIA1BfHEiC0ECdCICaiEBIAIgB2ohACAa/REhPiAU/REhQyAJ/REhPyAd/REhQANAIAcgD0ECdCITav0MAAAAAAAAAAAAAAAAAAAAACAQIBNq/QACACI9IED9rgEiQSA//bYBIEH9DAAAAAAAAAAAAAAAAAAAAAD9Of1S/QsCACAIIBNq/QwAAAAAAAAAAAAAAAAAAAAAID0gQ/2xASJBID/9tgEgQf0MAAAAAAAAAAAAAAAAAAAAAP05/VL9CwIAIA4gE2r9DAAAAAAAAAAAAAAAAAAAAAAgPSA+/a4BIj0gP/22ASA9/QwAAAAAAAAAAAAAAAAAAAAA/Tn9Uv0LAgAgD0EEaiIPIAtHDQALIAIgEGohECACIAhqIQIgCyANRg0EDAILIAcQECAIEBAgDhAQDAQLIAchACAIIQIgDiEBCwNAIAAgECgCACIPIB1qIhMgCSAJIBNKG0EAIBNBAE4bNgIAIAIgDyAUayITIAkgCSATShtBACATQQBOGzYCACABIA8gGmoiDyAJIAkgD0obQQAgD0EAThs2AgAgAUEEaiEBIAJBBGohAiAAQQRqIQAgEEEEaiEQIAtBAWoiCyANRw0ACwwBCyAOIQEgCCECIAchAAsgDSAbayEaAkAgHkF+cSIdBH8Cf0EAIAxrsrsiBURqvHSTGATWP6IgBUQMAiuHFtnmP6KgIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyEiIBpBfnEiHEEBayE5An8gBUQnMQisHFr8P6IiBplEAAAAAAAA4EFjBEAgBqoMAQtBgICAgHgLISMgOUF+cSE6An8gBUQ730+Nl272P6IiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLISQgHUEBayElIDpBAmohJiANQQJ0IQ0DQCABIA1qIQ8gAiANaiETIAAgDWohCyANIBBqIRQgGwRAIAAgECgCACIVICRqIhIgCSAJIBJKG0EAIBJBAE4bNgIAIAIgFSAiayISIAkgCSASShtBACASQQBOGzYCACABIBUgI2oiFSAJIAkgFUobQQAgFUEAThs2AgAgCigCACEWIAsCfyARKAIAIAxrsrsiBUQ730+Nl272P6IiBplEAAAAAAAA4EFjBEAgBqoMAQtBgICAgHgLIBQoAgAiFWoiEiAJIAkgEkobQQAgEkEAThs2AgAgEyAVAn8gFiAMa7K7IgZEarx0kxgE1j+iIAVEDAIrhxbZ5j+ioCIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAtrIhIgCSAJIBJKG0EAIBJBAE4bNgIAIA8CfyAGRCcxCKwcWvw/oiIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAsgFWoiFSAJIAkgFUobQQAgFUEAThs2AgAgD0EEaiEPIBNBBGohEyALQQRqIQsgFEEEaiEUIAJBBGohAiAQQQRqIRAgAUEEaiEBIABBBGohAAtBACEVIBwEfwNAIAooAgAhHyAAAn8gESgCACAMa7K7IgVEO99PjZdu9j+iIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyAQKAIAIhJqIhYgCSAJIBZKG0EAIBZBAE4bNgIAIAIgEgJ/IB8gDGuyuyIGRGq8dJMYBNY/oiAFRAwCK4cW2eY/oqAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLayIWIAkgCSAWShtBACAWQQBOGzYCACABAn8gBkQnMQisHFr8P6IiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLIBJqIhIgCSAJIBJKG0EAIBJBAE4bNgIAIAooAgAhHyAAAn8gESgCACAMa7K7IgVEO99PjZdu9j+iIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyAQKAIEIhJqIhYgCSAJIBZKG0EAIBZBAE4bNgIEIAIgEgJ/IB8gDGuyuyIGRGq8dJMYBNY/oiAFRAwCK4cW2eY/oqAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLayIWIAkgCSAWShtBACAWQQBOGzYCBCABAn8gBkQnMQisHFr8P6IiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLIBJqIhIgCSAJIBJKG0EAIBJBAE4bNgIEIAooAgAhHyALAn8gESgCACAMa7K7IgVEO99PjZdu9j+iIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyAUKAIAIhJqIhYgCSAJIBZKG0EAIBZBAE4bNgIAIBMgEgJ/IB8gDGuyuyIGRGq8dJMYBNY/oiAFRAwCK4cW2eY/oqAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLayIWIAkgCSAWShtBACAWQQBOGzYCACAPAn8gBkQnMQisHFr8P6IiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLIBJqIhIgCSAJIBJKG0EAIBJBAE4bNgIAIAooAgAhHyALAn8gESgCACAMa7K7IgVEO99PjZdu9j+iIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyAUKAIEIhJqIhYgCSAJIBZKG0EAIBZBAE4bNgIEIBMgEgJ/IB8gDGuyuyIGRGq8dJMYBNY/oiAFRAwCK4cW2eY/oqAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLayIWIAkgCSAWShtBACAWQQBOGzYCBCAPAn8gBkQnMQisHFr8P6IiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLIBJqIhIgCSAJIBJKG0EAIBJBAE4bNgIEIBFBBGohESAKQQRqIQogD0EIaiEPIBNBCGohEyALQQhqIQsgFEEIaiEUIAFBCGohASACQQhqIQIgAEEIaiEAIBBBCGohECAVQQJqIhUgHEkNAAsgJgVBAAsgGkkEfyAKKAIAIRYgAAJ/IBEoAgAgDGuyuyIFRDvfT42XbvY/oiIGmUQAAAAAAADgQWMEQCAGqgwBC0GAgICAeAsgECgCACIVaiISIAkgCSASShtBACASQQBOGzYCACACIBUCfyAWIAxrsrsiBkRqvHSTGATWP6IgBUQMAiuHFtnmP6KgIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C2siEiAJIAkgEkobQQAgEkEAThs2AgAgAQJ/IAZEJzEIrBxa/D+iIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyAVaiIVIAkgCSAVShtBACAVQQBOGzYCACAKKAIAIRUgCwJ/IBEoAgAgDGuyuyIFRDvfT42XbvY/oiIGmUQAAAAAAADgQWMEQCAGqgwBC0GAgICAeAsgFCgCACILaiIUIAkgCSAUShtBACAUQQBOGzYCACATIAsCfyAVIAxrsrsiBkRqvHSTGATWP6IgBUQMAiuHFtnmP6KgIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C2siEyAJIAkgE0obQQAgE0EAThs2AgAgDwJ/IAZEJzEIrBxa/D+iIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyALaiILIAkgCSALShtBACALQQBOGzYCACARQQRqIREgCkEEaiEKIAJBBGohAiAQQQRqIRAgAEEEaiEAIAFBBGoFIAELIA1qIQEgAiANaiECIAAgDWohACANIBBqIRAgIEECaiIgIB1JDQALICVBfnFBAmoFQQALIB5PDQAgGwRAIAACf0EAIAxrsrsiBUQ730+Nl272P6IiBplEAAAAAAAA4EFjBEAgBqoMAQtBgICAgHgLIBAoAgAiC2oiDSAJIAkgDUobQQAgDUEAThs2AgAgAiALAn8gBURqvHSTGATWP6IgBUQMAiuHFtnmP6KgIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4C2siDSAJIAkgDUobQQAgDUEAThs2AgAgAQJ/IAVEJzEIrBxa/D+iIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyALaiILIAkgCSALShtBACALQQBOGzYCACACQQRqIQIgEEEEaiEQIAFBBGohASAAQQRqIQALIBpBfnEiIAR/ICBBAWsiC0F+cSE7AkACf0EAICBBD0kNABpBACAAIAIgC0EBdiIUQQN0QQhqIhNqIgtJIAIgACATaiINSXENABpBACABIA1JIAAgASATaiIPSXENABpBACAAIBAgE2oiE0kgDSAQS3ENABpBACAKIA1JIAAgCiAUQQJ0QQRqIh5qIhtJcQ0AGkEAIA0gEUsgACARIB5qIg1JcQ0AGkEAIAIgD0kgASALSXENABpBACACIBNJIAsgEEtxDQAaQQAgCiALSSACIBtJcQ0AGkEAIAIgDUkgCyARS3ENABpBACABIBNJIA8gEEtxDQAaQQAgCiAPSSABIBtJcQ0AGkEAIAEgDUkgDyARS3ENABogCiAUQQFqIhZB/P///wdxIhtBAnQiImohCyABIBtBA3QiHmohDSAAIB5qIQ8gCf0RIT8gDP0RIUNBACETA0AgECATQQN0IhRBGHIiHWoiIyAQIBRBEHIiHGoiJCAQIBRBCHIiFWoiJSAQIBRqIib9CQIA/VYCAAH9VgIAAv1WAgADIT0CfyARIBNBAnQiH2r9AAIAIEP9sQH9+gEiPv1fIkD9DDvfT42XbvY/O99PjZdu9j/98gEiQf0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAshJyAKIB9q/QACACFCIAAgFGoiH/0MAAAAAAAAAAAAAAAAAAAAACA9An8gQf0hACIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9ESAn/RwBAn8gPiA+/Q0ICQoLDA0ODwABAgMAAQID/V8iQf0MO99PjZdu9j8730+Nl272P/3yASI+/SEAIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0cAgJ/ID79IQEiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/RwDIkT9rgEiPiA//bYBID79DAAAAAAAAAAAAAAAAAAAAAD9Of1SIj79WgIAACAAIBVqIicgPv1aAgABIAAgHGoiKSA+/VoCAAIgACAdaiIqID79WgIAAwJ/IEIgQ/2xAf36ASI+/V8iQv0Marx0kxgE1j9qvHSTGATWP/3yASBA/QwMAiuHFtnmPwwCK4cW2eY//fIB/fABIkD9IQEiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLISggAiAUaiIr/QwAAAAAAAAAAAAAAAAAAAAAID0CfyBA/SEAIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0RICj9HAECfyA+/QwAAAAAAAAAAAAAAAAAAAAA/Q0ICQoLDA0ODwABAgMAAQID/V8iQP0Marx0kxgE1j9qvHSTGATWP/3yASBB/QwMAiuHFtnmPwwCK4cW2eY//fIB/fABIj79IQAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/RwCAn8gPv0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9HAMiQf2xASI+ID/9tgEgPv0MAAAAAAAAAAAAAAAAAAAAAP05/VIiPv1aAgAAIAIgFWoiKCA+/VoCAAEgAiAcaiIsID79WgIAAiACIB1qIi0gPv1aAgADAn8gQv0MJzEIrBxa/D8nMQisHFr8P/3yASI+/SEBIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyEuIAEgFGoiFP0MAAAAAAAAAAAAAAAAAAAAACA9An8gPv0hACIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9ESAu/RwBAn8gQP0MJzEIrBxa/D8nMQisHFr8P/3yASI9/SEAIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0cAgJ/ID39IQEiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/RwDIkD9rgEiPSA//bYBID39DAAAAAAAAAAAAAAAAAAAAAD9Of1SIj39WgIAACABIBVqIhUgPf1aAgABIAEgHGoiHCA9/VoCAAIgASAdaiIdID39WgIAAyAf/QwAAAAAAAAAAAAAAAAAAAAAICNBBGogJEEEaiAlQQRqICb9CQIE/VYCAAH9VgIAAv1WAgADIj4gRP2uASI9ID/9tgEgPf0MAAAAAAAAAAAAAAAAAAAAAP05/VIiPf1aAgQAICcgPf1aAgQBICkgPf1aAgQCICogPf1aAgQDICv9DAAAAAAAAAAAAAAAAAAAAAAgPiBB/bEBIj0gP/22ASA9/QwAAAAAAAAAAAAAAAAAAAAA/Tn9UiI9/VoCBAAgKCA9/VoCBAEgLCA9/VoCBAIgLSA9/VoCBAMgFP0MAAAAAAAAAAAAAAAAAAAAACA+IED9rgEiPSA//bYBID39DAAAAAAAAAAAAAAAAAAAAAD9Of1SIj39WgIEACAVID39WgIEASAcID39WgIEAiAdID39WgIEAyATQQRqIhMgG0cNAAsgESAiaiERIBAgHmohECACIB5qIQIgFiAbRgRAIA8hACANIQEgCyEKDAILIA8hACANIQEgCyEKIBtBAXQLIQsDQCAKKAIAIRMgAAJ/IBEoAgAgDGuyuyIFRDvfT42XbvY/oiIGmUQAAAAAAADgQWMEQCAGqgwBC0GAgICAeAsgECgCACINaiIPIAkgCSAPShtBACAPQQBOGzYCACACIA0CfyATIAxrsrsiBkRqvHSTGATWP6IgBUQMAiuHFtnmP6KgIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C2siDyAJIAkgD0obQQAgD0EAThs2AgAgAQJ/IAZEJzEIrBxa/D+iIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyANaiINIAkgCSANShtBACANQQBOGzYCACAKKAIAIRMgAAJ/IBEoAgAgDGuyuyIFRDvfT42XbvY/oiIGmUQAAAAAAADgQWMEQCAGqgwBC0GAgICAeAsgECgCBCINaiIPIAkgCSAPShtBACAPQQBOGzYCBCACIA0CfyATIAxrsrsiBkRqvHSTGATWP6IgBUQMAiuHFtnmP6KgIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C2siDyAJIAkgD0obQQAgD0EAThs2AgQgAQJ/IAZEJzEIrBxa/D+iIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyANaiINIAkgCSANShtBACANQQBOGzYCBCARQQRqIREgCkEEaiEKIAFBCGohASACQQhqIQIgAEEIaiEAIBBBCGohECALQQJqIgsgIEkNAAsLIDtBAmoFQQALIBpPDQAgCigCACELIAACfyARKAIAIAxrsrsiBUQ730+Nl272P6IiBplEAAAAAAAA4EFjBEAgBqoMAQtBgICAgHgLIBAoAgAiAGoiCiAJIAkgCkobQQAgCkEAThs2AgAgAiAAAn8gCyAMa7K7IgZEarx0kxgE1j+iIAVEDAIrhxbZ5j+ioCIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAtrIgIgCSACIAlIG0EAIAJBAE4bNgIAIAECfyAGRCcxCKwcWvw/oiIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAsgAGoiACAJIAAgCUgbQQAgAEEAThs2AgALIBcoAhgoAiwQECAXKAIYIgAgBzYCLCAAKAJgEBAgFygCGCIAIAg2AmAgACgClAEQECAXKAIYIgAgDjYClAEgACAA/QACACI//QsCaCAAID/9CwI0IBdBATYCFAsMBwsgASgCBEEBRw0BIAEoAjhBAUcNASABKAJsQQFHDQEgASgCGCEAIAEoApQBIQIgASgCYCEHIAEoAiwhDCABKAIIIgogASgCDCIWbEECdCIBEBghDyABEBghFyABEBghCSAPRQ0FIBdFDQUgCUUNBSAWBEAgCiANKAIAQQFxIh9rISICf0EAQQEgAEEBa3QiFGuyuyIFRGq8dJMYBNY/oiAFRAwCK4cW2eY/oqAiBplEAAAAAAAA4EFjBEAgBqoMAQtBgICAgHgLISdBfyAAdCE8ICJBfnEiHUEBayIKQQF2IgBBAWohIwJ/IAVEJzEIrBxa/D+iIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyEpIApBfnEhCiAAQQJ0IQggAEEDdCEAICNBfHEhGyA8QX9zIRECfyAFRDvfT42XbvY/oiIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAshKiAKQQJqISQgCEEEaiElIABBCGohICAbQQJ0ISYgG0EDdCEeIBtBAXQhECAR/REhPyAU/REhQyAdQQdJISggDyEKIBchACAJIQ4DQCAfBEAgCiAMKAIAIgEgKmoiCCARIAggEUgbQQAgCEEAThs2AgAgACABICdrIgggESAIIBFIG0EAIAhBAE4bNgIAIA4gASApaiIBIBEgASARSBtBACABQQBOGzYCACAOQQRqIQ4gCkEEaiEKIAxBBGohDCAAQQRqIQALAn8CfyAdRQRAIAchASAOIQsgCiEIQQAMAQtBACEZAkACQCAoDQAgCiAAICBqIgFJIAAgCiAgaiIISXENACAKIA4gIGoiC0kgCCAOS3ENACAKIAwgIGoiGkkgCCAMS3ENACAHIAhJIAogByAlaiIcSXENACACIAhJIAogAiAlaiIISXENACAAIAtJIAEgDktxDQAgACAaSSABIAxLcQ0AIAAgHEkgASAHS3ENACAAIAhJIAEgAktxDQAgDiAaSSALIAxLcQ0AIA4gHEkgByALSXENACACIAtJIAggDktxDQAgByAmaiEBIA4gHmohCyAKIB5qIQgDQCAMIBlBA3QiGkEYciIcaiIrIAwgGkEQciIVaiIsIAwgGkEIciISaiItIAwgGmoiLv0JAgD9VgIAAf1WAgAC/VYCAAMhPQJ/IAIgGUECdCIvav0AAgAgQ/2xAf36ASI+/V8iQP0MO99PjZdu9j8730+Nl272P/3yASJB/SEBIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyEwIAcgL2r9AAIAIUIgCiAaaiIv/QwAAAAAAAAAAAAAAAAAAAAAID0CfyBB/SEAIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0RIDD9HAECfyA+ID79DQgJCgsMDQ4PAAECAwABAgP9XyJB/Qw730+Nl272PzvfT42XbvY//fIBIj79IQAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/RwCAn8gPv0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9HAMiRP2uASI+ID/9tgEgPv0MAAAAAAAAAAAAAAAAAAAAAP05/VIiPv1aAgAAIAogEmoiMCA+/VoCAAEgCiAVaiIyID79WgIAAiAKIBxqIjMgPv1aAgADAn8gQiBD/bEB/foBIj79XyJC/QxqvHSTGATWP2q8dJMYBNY//fIBIED9DAwCK4cW2eY/DAIrhxbZ5j/98gH98AEiQP0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAshMSAAIBpqIjT9DAAAAAAAAAAAAAAAAAAAAAAgPQJ/IED9IQAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/REgMf0cAQJ/ID79DAAAAAAAAAAAAAAAAAAAAAD9DQgJCgsMDQ4PAAECAwABAgP9XyJA/QxqvHSTGATWP2q8dJMYBNY//fIBIEH9DAwCK4cW2eY/DAIrhxbZ5j/98gH98AEiPv0hACIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9HAICfyA+/SEBIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0cAyJB/bEBIj4gP/22ASA+/QwAAAAAAAAAAAAAAAAAAAAA/Tn9UiI+/VoCAAAgACASaiIxID79WgIAASAAIBVqIjUgPv1aAgACIAAgHGoiNiA+/VoCAAMCfyBC/QwnMQisHFr8PycxCKwcWvw//fIBIj79IQEiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLITcgDiAaaiIa/QwAAAAAAAAAAAAAAAAAAAAAID0CfyA+/SEAIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0RIDf9HAECfyBA/QwnMQisHFr8PycxCKwcWvw//fIBIj39IQAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/RwCAn8gPf0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9HAMiQP2uASI9ID/9tgEgPf0MAAAAAAAAAAAAAAAAAAAAAP05/VIiPf1aAgAAIA4gEmoiEiA9/VoCAAEgDiAVaiIVID39WgIAAiAOIBxqIhwgPf1aAgADIC/9DAAAAAAAAAAAAAAAAAAAAAAgK0EEaiAsQQRqIC1BBGogLv0JAgT9VgIAAf1WAgAC/VYCAAMiPiBE/a4BIj0gP/22ASA9/QwAAAAAAAAAAAAAAAAAAAAA/Tn9UiI9/VoCBAAgMCA9/VoCBAEgMiA9/VoCBAIgMyA9/VoCBAMgNP0MAAAAAAAAAAAAAAAAAAAAACA+IEH9sQEiPSA//bYBID39DAAAAAAAAAAAAAAAAAAAAAD9Of1SIj39WgIEACAxID39WgIEASA1ID39WgIEAiA2ID39WgIEAyAa/QwAAAAAAAAAAAAAAAAAAAAAID4gQP2uASI9ID/9tgEgPf0MAAAAAAAAAAAAAAAAAAAAAP05/VIiPf1aAgQAIBIgPf1aAgQBIBUgPf1aAgQCIBwgPf1aAgQDIBlBBGoiGSAbRw0ACyACICZqIQIgDCAeaiEMIAAgHmohACAQIRkgJCAbICNGDQIaDAELIAohCCAOIQsgByEBCwNAIAEoAgAhDiAIAn8gAigCACAUa7K7IgVEO99PjZdu9j+iIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyAMKAIAIgpqIgcgESAHIBFIG0EAIAdBAE4bNgIAIAAgCgJ/IA4gFGuyuyIGRGq8dJMYBNY/oiAFRAwCK4cW2eY/oqAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLayIHIBEgByARSBtBACAHQQBOGzYCACALAn8gBkQnMQisHFr8P6IiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLIApqIgogESAKIBFIG0EAIApBAE4bNgIAIAEoAgAhDiAIAn8gAigCACAUa7K7IgVEO99PjZdu9j+iIgaZRAAAAAAAAOBBYwRAIAaqDAELQYCAgIB4CyAMKAIEIgpqIgcgESAHIBFIG0EAIAdBAE4bNgIEIAAgCgJ/IA4gFGuyuyIGRGq8dJMYBNY/oiAFRAwCK4cW2eY/oqAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLayIHIBEgByARSBtBACAHQQBOGzYCBCALAn8gBkQnMQisHFr8P6IiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgLIApqIgogESAKIBFIG0EAIApBAE4bNgIEIAJBBGohAiABQQRqIQEgC0EIaiELIABBCGohACAIQQhqIQggDEEIaiEMIBlBAmoiGSAdSQ0ACyAkCyAiTwRAIAEhByAIIQogCwwBCyABKAIAIQ4gCAJ/IAIoAgAgFGuyuyIFRDvfT42XbvY/oiIGmUQAAAAAAADgQWMEQCAGqgwBC0GAgICAeAsgDCgCACIKaiIHIBEgByARSBtBACAHQQBOGzYCACAAIAoCfyAOIBRrsrsiBkRqvHSTGATWP6IgBUQMAiuHFtnmP6KgIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C2siByARIAcgEUgbQQAgB0EAThs2AgAgCwJ/IAZEJzEIrBxa/D+iIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4CyAKaiIKIBEgCiARSBtBACAKQQBOGzYCACACQQRqIQIgAUEEaiEHIABBBGohACAIQQRqIQogDEEEaiEMIAtBBGoLIQ4gE0EBaiITIBZHDQALCyANKAIYKAIsEBAgDSgCGCIAIA82AiwgACgCYBAQIA0oAhgiACAXNgJgIAAoApQBEBAgDSgCGCIAIAk2ApQBIAAgAP0AAgAiP/0LAmggACA//QsCNCANQQE2AhRBACEZDAYLIAEoAmhBAUcNACABKAIEQQFHDQAgASgCOEEBRw0AIAEoAmxBAUcNACABKAIYIQIgASgClAEhCCABKAJgIQwgASgCLCEAIAEoAgwgASgCCGwiF0ECdCIBEBghByABEBghDyABEBghDgJAIAdFDQAgD0UNACAORQ0AIBdFDQRBfyACdEF/cyEZQQEgAkEBa3QhESAXQQhJDQIgDyAHa0EQSQ0CIA4gB2tBEEkNAiAHIABrQRBJDQIgByAMa0EQSQ0CIAcgCGtBEEkNAiAOIA9rQRBJDQIgDyAAa0EQSQ0CIA8gDGtBEEkNAiAPIAhrQRBJDQIgDiAAa0EQSQ0CIA4gDGtBEEkNAiAOIAhrQRBJDQIgCCAXQXxxIgpBAnQiCWohCyAJIA5qIQEgByAJaiECIBn9ESE/IBH9ESE9A0ACfyAIIBNBAnQiEGr9AAIAID39sQH9+gEiPv1fIkD9DDvfT42XbvY/O99PjZdu9j/98gEiQf0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAshFCAMIBBq/QACACFCIAcgEGr9DAAAAAAAAAAAAAAAAAAAAAAgACAQav0AAgAiQwJ/IEH9IQAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/REgFP0cAQJ/ID4gPv0NCAkKCwwNDg8AAQIDAAECA/1fIj79DDvfT42XbvY/O99PjZdu9j/98gEiQf0hACIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9HAICfyBB/SEBIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0cA/2uASJBID/9tgEgQf0MAAAAAAAAAAAAAAAAAAAAAP05/VL9CwIAAn8gQiA9/bEB/foBIkH9XyJC/QxqvHSTGATWP2q8dJMYBNY//fIBIED9DAwCK4cW2eY/DAIrhxbZ5j/98gH98AEiQP0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAshFCAPIBBq/QwAAAAAAAAAAAAAAAAAAAAAIEMCfyBA/SEAIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0RIBT9HAECfyBB/QwAAAAAAAAAAAAAAAAAAAAA/Q0ICQoLDA0ODwABAgMAAQID/V8iQP0Marx0kxgE1j9qvHSTGATWP/3yASA+/QwMAiuHFtnmPwwCK4cW2eY//fIB/fABIj79IQAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/RwCAn8gPv0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9HAP9sQEiPiA//bYBID79DAAAAAAAAAAAAAAAAAAAAAD9Of1S/QsCAAJ/IEL9DCcxCKwcWvw/JzEIrBxa/D/98gEiPv0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAshFCAOIBBq/QwAAAAAAAAAAAAAAAAAAAAAIEMCfyA+/SEAIgWZRAAAAAAAAOBBYwRAIAWqDAELQYCAgIB4C/0RIBT9HAECfyBA/QwnMQisHFr8PycxCKwcWvw//fIBIj79IQAiBZlEAAAAAAAA4EFjBEAgBaoMAQtBgICAgHgL/RwCAn8gPv0hASIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAv9HAP9rgEiPiA//bYBID79DAAAAAAAAAAAAAAAAAAAAAD9Of1S/QsCACATQQRqIhMgCkcNAAsgCiAXRg0EIAkgDGohDCAAIAlqIQAgCSAPagwDCyAHEBAgDxAQIA4QEAwFCyAYQbkDNgIEIBhBuAo2AgBB6MQBQcI+IBgQFgwECyAHIQIgDiEBIAghCyAPCyEIA0AgDCgCACETIAICfyALKAIAIBFrsrsiBUQ730+Nl272P6IiBplEAAAAAAAA4EFjBEAgBqoMAQtBgICAgHgLIAAoAgAiCWoiECAZIBAgGUgbQQAgEEEAThs2AgAgCCAJAn8gEyARa7K7IgZEarx0kxgE1j+iIAVEDAIrhxbZ5j+ioCIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAtrIhAgGSAQIBlIG0EAIBBBAE4bNgIAIAECfyAGRCcxCKwcWvw/oiIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAsgCWoiCSAZIAkgGUgbQQAgCUEAThs2AgAgAUEEaiEBIAhBBGohCCACQQRqIQIgC0EEaiELIAxBBGohDCAAQQRqIQAgCkEBaiIKIBdHDQALCyANKAIYKAIsEBAgDSgCGCIAIAc2AiwgACgCYBAQIA0oAhgiACAPNgJgIAAoApQBEBAgDSgCGCAONgKUASANQQE2AhRBACEZDAELIA8QECAXEBAgCRAQCyAYKAIgIQACQCADDQAgIUUNACAAKAIYIQ5BACETA0AgDiATQTRsaiIDKAIYIgJBCEcEQAJAIAJBB00EQCADKAIMIAMoAghsIQEgAygCLCEKIAMoAiAEQCABRQ0CQQEgAkEBa3StIUVBACEHIAFBBE8EQCABQXxxIQcgRf0SIT9BACEMA0AgCiAMQQJ0aiICIAL9AAIAIj39xwFBB/3LASI+/R0AID/9HQAiRn/9EiA+/R0BID/9HQEiR3/9HgEgPSA//Q0ICQoLDA0ODwABAgMAAQID/ccBQQf9ywEiPf0dACBGf/0SID39HQEgR3/9HgH9DQABAgMICQoLEBESExgZGhv9CwIAIAxBBGoiDCAHRw0ACyABIAdGDQMLA0AgCiAHQQJ0aiICIAI0AgBCB4YgRX8+AgAgB0EBaiIHIAFHDQALDAILIAFFDQFBfyACdEF/c60hRUEAIQcgAUEETwRAIAFBfHEhByBF/RIhP0EAIQwDQCAKIAxBAnRqIgIgAv0AAgAiPf3JAf0M/wAAAAAAAAD/AAAAAAAAAP3VASI+/R0AID/9HQAiRoD9EiA+/R0BID/9HQEiR4D9HgEgPSA//Q0ICQoLDA0ODwABAgMAAQID/ckB/Qz/AAAAAAAAAP8AAAAAAAAA/dUBIj39HQAgRoD9EiA9/R0BIEeA/R4B/Q0AAQIDCAkKCxAREhMYGRob/QsCACAMQQRqIgwgB0cNAAsgASAHRg0CCwNAIAogB0ECdGoiAiACNQIAQv8BfiBFgD4CACAHQQFqIgcgAUcNAAsMAQsgAkEIayEKIAMoAgwgAygCCGwhASADKAIsIQggAygCIARAIAFFDQFBACEHIAFBBE8EQCABQXxxIQdBACECA0AgCCACQQJ0aiILIAv9AAIAIAr9rAH9CwIAIAJBBGoiAiAHRw0ACyABIAdGDQILA0AgCCAHQQJ0aiICIAIoAgAgCnU2AgAgB0EBaiIHIAFHDQALDAELIAFFDQBBACEHIAFBBE8EQCABQXxxIQdBACECA0AgCCACQQJ0aiILIAv9AAIAIAr9rQH9CwIAIAJBBGoiAiAHRw0ACyABIAdGDQELA0AgCCAHQQJ0aiICIAIoAgAgCnY2AgAgB0EBaiIHIAFHDQALCyADQQg2AhgLIBNBAWoiEyAhRw0ACwsgACgCDCAAKAIIbCEBAkAgGUUEQCAAKAIUQQJGBEAgACgCEEEBRgRAIAAoAhgoAiwgARAODAMLIARFDQIgACgCGCIAKAIsIAAoAmAgARAIDAILIAAoAhgiACgCLCAAKAJgIAAoApQBIAEQBwwBCwJAAkACQCAhQQFrDgQAAwECAwsgACgCGCgCLCABEAYMAgsgACgCGCIAKAIsIAAoAmAgACgClAEgARAFDAELIAAoAhgiACgCLCAAKAJgIAAoApQBIAAoAsgBIAEQBAsgGCgCIBAhQQAhDAsgGEHgwABqJAAgDAsIAEEIIAAQJQurAgICfgJ/Qn8hAyAALQBEQQhxRQRAIAAgACgCICIGNgIkAkACQAJAIAAgACgCMCIFBH8DQCAGIAUgACgCACAAKAIUEQAAIgVBf0YNAiAAIAAoAiQgBWoiBjYCJCAAIAAoAjAgBWsiBTYCMCAFDQALIAAoAiAFIAYLNgIkIAFCAFUNAUIAIQMMAgsgACAAKAJEQQhyNgJEIAJBBEGB9QBBABAPIABBADYCMCAAIAAoAkRBCHI2AkRCfw8LQgAhAwNAIAEgACgCACAAKAIYEQsAIgRCf1EEQCACQQRB8vQAQQAQDyAAIAAoAkRBCHI2AkQgACAAKQM4IAN8NwM4Qn8gAyADUBsPCyADIAR8IQMgASAEfSIBQgBVDQALCyAAIAApAzggA3w3AzgLIAMLIwEBfyABIAEoAgAgASgCCCIBIACnIgIgASACSRtqNgIEQQELPAICfwF+IAEoAgAgASgCCGoiAyABKAIEIgJGBEBCfw8LIAEgAiAAp2o2AgQgAyACa6wiBCAAIAAgBFUbC5gDAgJ+An8gACgCMCIFIAGnIgZPBEAgACAFIAZrNgIwIAAgACgCJCAGajYCJCAAIAApAzggAXw3AzggAQ8LIAAtAERBBHEEQCAAQQA2AjAgACAAKAIkIAVqNgIkIAAgBa0iASAAKQM4fDcDOCABQn8gBRsPCwJAIAVFBEAMAQsgAEEANgIwIAAgACgCIDYCJCABIAWtIgN9IQELIAFCAFUEQANAIAApAwggACkDOCABIAN8fFQEQCACQQRBm/UAQQAQDyAAQQA2AjAgACAAKAIgNgIkIAAgACkDOCADfCIDNwM4IAApAwgiASADfSEEIAEgACgCACAAKAIcEQoAIQUgACgCRCECIAAgBQR/IAAgATcDOCACQXtxBSACC0EEcjYCREJ/IAQgASADURsPCyABIAAoAgAgACgCGBELACIEQn9RBEAgAkEEQZv1AEEAEA8gACAAKAJEQQRyNgJEIAAgACkDOCADfDcDOEJ/IAMgA1AbDwsgAyAEfCEDIAEgBH0iAUIAVQ0ACwsgACAAKQM4IAN8NwM4IAMLmwEBBX9BASACKAIIIgcgB0EBTRshBCACKAIEIgMgAigCAGshBgNAIAQiBUEBdCEEIAUgBmsgAUkNAAsgBSAHRwRAIAUQFCIDRQRAQX8PCyACKAIAIgQEQCADIAQgBhASGiACKAIAEBALIAIgBTYCCCACIAM2AgAgAiADIAZqIgM2AgQLIAMgACABEBIaIAIgAigCBCABajYCBCABC0YBAn8gAigCACACKAIIaiIEIAIoAgQiA0YEQEF/DwsgACADIAQgA2siACABIAAgAUkbIgAQEhogAiACKAIEIABqNgIEIAALqgIBBH8jAEEQayIEJAACQCAAKAJ0DQAgAkEBTQRAIANBAUH7wgBBABAPDAELIAEgBEEMakECEBEgBCgCDCIGQf//A3EiB0UEQCADQQFBnMMAQQAQDwwBCyACIAdBBmxBAmpJBEAgA0EBQfvCAEEAEA8MAQsgBkEGbBAUIgNFDQAgAEEIEBQiAjYCdCACRQRAIAMQEAwBCyACIAM2AgAgAiAELwEMIgI7AQQgAkUEQEEBIQUMAQtBACECA0AgAUECaiAEQQxqIgVBAhARIAMgAkEGbGoiBiAEKAIMOwEAIAFBBGogBUECEBEgBiAEKAIMOwECIAFBBmoiASAFQQIQESAGIAQoAgw7AQRBASEFIAJBAWoiAiAAKAJ0LwEESQ0ACwsgBEEQaiQAIAUL8AEBBX8jAEEQayIEJAACfyAAKAJ4IgVFBEAgA0EBQc3CAEEAEA9BAAwBCyAFKAIMBEAgA0EBQdvVAEEAEA9BAAwBCyACIAUtABIiBUECdCIGSQRAIANBAUGswgBBABAPQQAMAQtBACAGEBQiAkUNABogBQRAQQAhAwNAIAEgBEEMaiIHQQIQESACIANBAnRqIgYgBCgCDDsBACABQQJqIAdBARARIAYgBCgCDDoAAiABQQNqIAdBARARIAYgBCgCDDoAAyABQQRqIQEgA0EBaiIDIAVHDQALCyAAKAJ4IAI2AgxBAQshCCAEQRBqJAAgCAvwAwEJfyMAQRBrIgUkAAJAIAJBA0kNACAAKAJ4DQAgASAFQQxqQQIQESAFLwEMIglBgQhrQf93TQRAIAUgCTYCACADQQFBtBogBRAPDAELIAFBAmogBUEMakEBEBEgBS8BDCIIRQRAIANBAUHUF0EAEA8MAQsgCEEDaiACSw0AIAggCWxBAnQQFCIHRQ0AIAgQFCIKRQRAIAcQEAwBCyAIEBQiC0UEQCAHEBAgChAQDAELQRQQFCIGRQRAIAcQECAKEBAgCxAQDAELIAFBA2ohAyAGIAo2AgggBiALNgIEIAYgCTsBECAGIAc2AgAgBSgCDCEMIAZBADYCDCAGIAw6ABIgACAGNgJ4A0AgAyAFQQxqQQEQESAEIApqIAUtAAxB/wBxQQFqOgAAIAQgC2ogBSgCDEGAAXFBB3Y6AAAgA0EBaiEDIARBAWoiBCAIRw0ACyAJRQRAQQEhBAwBC0EAIQYDQEEAIQRBACEAA0AgAkEEIAQgCmotAABBB2pBA3YiBCAEQQRPGyIEIAMgAWtqSARAQQAhBAwDCyADIAVBDGogBBARIAcgBSgCDDYCACAHQQRqIQcgAyAEaiEDIABBAWoiAEH//wNxIgQgCEkNAAtBASEEIAZBAWoiBkH//wNxIAlJDQALCyAFQRBqJAAgBAuYAQECfyMAQRBrIgUkACAAKAIYIgRB/wFHBEAgBSAENgIAIANBAkHkEyAFEA8LAkACQCACIAAoAhRGBEAgAg0BQQEhBAwCC0EAIQQgA0EBQbvsAEEAEA8MAQtBACECA0BBASEEIAEgACgCSCACQQxsakEIakEBEBEgAUEBaiEBIAJBAWoiAiAAKAIUSQ0ACwsgBUEQaiQAIAQLjgYBBn8jAEHQAGsiBCQAAkAgAkECTQRAIANBAUGb7ABBABAPDAELIAAtAHwEQCADQQRB7tIAQQAQD0EBIQYMAQtBASEGIAEgAEEoakEBEBEgAUEBaiAAQTRqQQEQESABQQJqIABBLGpBARARIAFBA2ohBQJAAkACQAJAAkAgACgCKCIHQQFrDgIAAQILIAJBBk0EQCAEIAI2AhAgA0EBQcDxACAEQRBqEA9BACEGDAULAkAgAkEHRg0AIAAoAjBBDkYNACAEIAI2AjAgA0ECQcDxACAEQTBqEA8LIAUgAEEwakEEEBEgACgCMEEORw0DQSQQFCIFRQRAQQAhBiADQQFBszxBABAPDAULIAVBDjYCACAEQQA2AkAgBEEANgI4IARBADYCSCAEQQA2AjwgBEEANgJEIARBADYCTEGw6pACIQYgBEGw6pACNgI0IAVBgIyVogQ2AgQCfyACQQdHBEAgAkEjRgRAIAFBB2ogBEHMAGpBBBARIAFBC2ogBEHIAGpBBBARIAFBD2ogBEHEAGpBBBARIAFBE2ogBEFAa0EEEBEgAUEXaiAEQTxqQQQQESABQRtqIARBOGpBBBARIAFBH2ogBEE0akEEEBEgBUEANgIEIAQoAjQhBiAEKAI4IQIgBCgCQCEDIAQoAjwhByAEKAJEIQggBCgCTCEJIAQoAkgMAgsgBCACNgIgIANBAkHk8QAgBEEgahAPC0EAIQJBACEDQQAhB0EACyEBIAUgBzYCGCAFIAg2AhAgBSAJNgIIIAUgBjYCICAFIAI2AhwgBSADNgIUIAUgATYCDCAAQQA2AnAgACAFNgJsDAMLIAAgAkEDayIBNgJwIABBASABEBMiAzYCbCADRQ0BIAJBA0wNAkEAIQIDQCAFIARBzABqQQEQESAAKAJsIAJqIAQoAkw6AAAgBUEBaiEFIAJBAWoiAiABRw0ACwwCCyAHQQNJDQIgBCAHNgIAIANBBEHb9wAgBBAPDAILQQAhBiAAQQA2AnAMAQtBASEGIABBAToAfAsgBEHQAGokACAGC7QDAQN/IwBBIGsiBCQAAkAgACgCSARAIANBAkGNNUEAEA9BASECDAELIAJBDkcEQEEAIQIgA0EBQfrrAEEAEA8MAQsgASAAQRBqQQQQESABQQRqIABBDGpBBBARIAFBCGogAEEUakECEBEgACgCDCEFAkAgBAJ/IAAoAhAiBkUEQCAAKAIUDAELIAAoAhQiAiAFRQ0AGiACDQFBAAs2AgggBCAGNgIEIAQgBTYCACADQQFB3uoAIAQQD0EAIQIMAQsgAkGBgAFrQf//fk0EQEEAIQIgA0EBQYjqAEEAEA8MAQsgACACQQwQEyICNgJIIAJFBEBBACECIANBAUGt6gBBABAPDAELQQEhAiABQQpqIABBGGpBARARIAFBC2ogAEEcakEBEBEgACgCHCIFQQdHBEAgBCAFNgIQIANBBEGd+gAgBEEQahAPCyABQQxqIABBIGpBARARIAFBDWogAEEkakEBEBEgACgCACIBIAEtALwBQfsBcSAAKAIYQf8BRkECdHI6ALwBIAAoAgAiASAAKAIMNgLYASABIAAoAhA2AtwBIABBAToAhQELIARBIGokACACC7oEAQZ/IwBBEGsiBiQAAn8gAC0AZEECcUUEQCADQQFBkdQAQQAQD0EADAELIABBADYCaAJAAkACQCACBEADQCACQQdNBEAgA0EBQbkZQQAQDwwFCyABIAZBDGoiBUEEEBEgBigCDCEEIAFBBGogBUEEEBFBCCEHIAYoAgwhBQJAAkACQAJAIAQOAgEAAwsgAkEQSQRAQeEZIQQMBwsgAUEIaiAGQQhqQQQQESAGKAIIBEBByj8hBAwHCyABQQxqIAZBDGpBBBARIAYoAgwiBA0BQbIYIQQMBgsgA0EBQbIYQQAQDwwGC0EQIQcLIAQgB0kEQCADQQFBhcUAQQAQDwwFCyACIARJBEAgA0EBQb3EAEEAEA9BAAwGCwJAAkAgACABIAdqIAQgB2sgAwJ/AkACQAJAIAVB8di9mwZMBEAgBUHjxsGTBkYNASAFQebKkZsGRg0DIAVB8MK1mwZHDQVB4MABDAQLIAVB8tiNgwdGDQFBwMABIAVB8sihywZGDQMaIAVB8ti9mwZHDQRByMABDAMLQdDAAQwCC0HYwAEMAQtB6MABCygCBBEBAA0BQQAMBwsgACAAKAJoQf////8HcjYCaAtBASAIIAVB8sihywZGGyEIIAEgBGohASACIARrIgINAAsgCA0BCyADQQFB2cMAQQAQD0EADAMLIABBAToAhAEgACAAKAJkQQRyNgJkQQEMAgsgA0EBIARBABAPCyADQQFBng5BABAPQQALIQkgBkEQaiQAIAkL4gEBAX8gACgCZEEBRwRAIANBAUG+1ABBABAPQQAPCwJAIAJBB00EQAwBCyABIABBOGpBBBARIAFBBGogAEE8akEEEBEgAkEDcQRADAELIAAgAkEIayICQQJ2IgQ2AkACQCACRQ0AIAAgBEEEEBMiAjYCRCACRQRAIANBAUGpEEEAEA9BAA8LIAAoAkBFDQAgAUEIaiEDQQAhAgNAIAMgACgCRCACQQJ0akEEEBEgA0EEaiEDIAJBAWoiAiAAKAJASQ0ACwsgACAAKAJkQQJyNgJkQQEPCyADQQFBqi1BABAPQQALxAEBAn8gACAAKAIgIgQ2AiQCQCAAKAIwIgMEQANAIAQgAyAAKAIAIAAoAhQRAAAiA0F/Rg0CIAAgACgCJCADaiIENgIkIAAgACgCMCADayIDNgIwIAMNAAsgACgCICEECyAAQQA2AjAgACAENgIkIAEgACgCACAAKAIcEQoARQRAIAAgACgCREEIcjYCREEADwsgACABNwM4QQEPCyAAIAAoAkRBCHI2AkQgAkEEQYH1AEEAEA8gACAAKAJEQQhyNgJEQQALggEBAn8jAEEQayIEJAACfyAAKAJkBEAgA0EBQdvTAEEAEA9BAAwBCyACQQRHBEAgA0EBQc4tQQAQD0EADAELIAEgBEEMakEEEBEgBCgCDEGKjqroAEcEQCADQQFB9iVBABAPQQAMAQsgACAAKAJkQQFyNgJkQQELIQUgBEEQaiQAIAULDQAgACgCACABIAIQRQsJACAAKAIAEEoLCQAgACgCABBJCw0AIAAoAgAgASACEEwLQQEBfyACBH8gA0ECQdvLAEEAEA8gACgCACABIAIgAyAEEEZFBEAgA0EBQakvQQAQD0EADwsgACACIAMQcQVBAAsLFQAgACgCACABIAIgAyAEIAUgBhBOCw8AIAAoAgAgASACIAMQTwsTACAAKAIAIAEgAiADIAQgBRArCx0AIAAoAgAgASACIAMgBCAFIAYgByAIIAkgChAnC+oEAQd/AkAgASgCCEE1IAMQJEUNACABKAIEIgcoAgAhBSAHKAIIIQQCQCAFBEBBASEGIAVBAUcEQCAFQX5xIQoDQAJ/QQAgBkUNABpBACABIAAgAyAEKAIAEQAARQ0AGiABIAAgAyAEKAIEEQAAQQBHCyEGIARBCGohBCAJQQJqIgkgCkcNAAsLAkAgBUEBcQRAIAZFDQEgASAAIAMgBCgCABEAAEEARyEGCyAHQQA2AgAgBkUNAwwCCyAHQQA2AgBBAA8LIAdBADYCAAsgASgCCCIHKAIAIQUgBygCCCEEAkACQAJ/AkAgBQRAQQEhBiAFQQFxIQggBUEBRw0BQQAMAgsgB0EANgIADAILIAVBfnEhBUEAIQkDQAJ/QQAgBkUNABpBACABIAAgAyAEKAIAEQAARQ0AGiABIAAgAyAEKAIEEQAAQQBHCyEGIARBCGohBCAJQQJqIgkgBUcNAAsgBkULIQUgCARAIAUNAiABIAAgAyAEKAIAEQAAQQBHIQYLIAdBADYCAEEAIQggBkUNAgsgAS0AhAFFBEAgA0EBQb3WAEEAEA9BAA8LIAEtAIUBRQRAIANBAUGg1gBBABAPQQAPCyAAIAEoAgAgAiADEFAhCCACRQ0BIAIoAgAiAEUNAUEBIQQCQAJAAkACQAJAAkAgASgCMEEMaw4NAwQEBAUAAQQEBAQEAgQLQQIhBAwEC0EDIQQMAwtBBCEEDAILQQUhBAwBC0F/IQQLIAAgBDYCFCABKAJsIgNFDQEgACADNgIcIAIoAgAgASgCcDYCICABQQA2AmwgCA8LIAdBADYCAEEAIQgLIAgL5AkCCn8BfiMAQfAAayIDJABBgAghCAJ/AkBBAUGACBATIgYEQCADQdwAaiELIANB7ABqIQkDQAJAAkACQCABIANB6ABqIgRBCCACEBpBCEcNACAEIANB2ABqQQQQESAJIAtBBBARQQghBQJAAkACQAJAAkAgAygCWA4CAAEECyABKQMIIg1QBH5CAAUgDSABKQM4fQsiDUL4////D1MNASACQQFByj9BABAPDAQLIAEgA0HoAGoiBEEIIAIQGkEIRw0DIAQgA0HkAGpBBBARIAMoAmRFDQEgAkEBQco/QQAQDwwDCyADIA2nQQhqNgJYDAELIAkgA0HYAGpBBBARQRAhBQsgAygCXCIEQePkwNMGRgRAIAAoAmQiAUEEcQRAIAAgAUEIcjYCZAwCCyACQQFBrStBABAPIAYQEEEADAcLIAMoAlgiB0UEQCACQQFBshhBABAPIAYQEEEADAcLIAUgB0sEQCADIAQ2AgQgAyAHNgIAIAJBAUH65wAgAxAPDAYLAkACfwJ/AkACfwJAAkACQAJAAkAgBEHx2L2bBkwEQCAEQePGwZMGRg0CIARB5sqRmwZGDQQgBEHwwrWbBkcNAUHgwAEMBgsgBEGfwMDSBkwEQCAEQfLYvZsGRg0FQcDAASAEQfLIocsGRg0GGiAEQfDy0bMGRw0BQajAAQwICyAEQfLYjYMHRg0CIARBoMDA0gZGDQZBsMABIARB6OTA0wZGDQcaCyAAKAJkIgRBAXENCCACQQFB/A5BABAPIAYQEEEADA8LQdDAAQwDC0HYwAEMAgtB6MABDAELQcjAAQshCiADIARB/wFxNgJMIAMgBEEYdjYCQCADIARBCHZB/wFxNgJIIAMgBEEQdkH/AXE2AkQgAkECQckOIANBQGsQDyAHIAVrIgUgAC0AZEEEcQ0CGiADIAMoAlwiBEEYdjYCMCADIARB/wFxNgI8IAMgBEEQdkH/AXE2AjQgAyAEQQh2Qf8BcTYCOCACQQJB2jMgA0EwahAPIAAgACgCZEH/////B3I2AmQgASAFrSINIAIgASgCKBEIACANUQ0HIAJBAUGSHEEAEA8gBhAQQQAMCgtBoMABCyEKIAcgBWsLIQUgASkDCCINUAR+QgAFIA0gASkDOH0LIAWtUwRAIAMoAlghBCADKAJcIQAgAyABKQMIIg1QBH5CAAUgDSABKQM4fQs+AiggAyAFNgIkIAMgAEH/AXE2AiAgAyAAQRh2NgIUIAMgBDYCECADIABBCHZB/wFxNgIcIAMgAEEQdkH/AXE2AhggAkEBQc31ACADQRBqEA8MBwsgBSAITQRAIAYhBAwECyAFIQggBiAFEBciBA0DIAYQECACQQFB/w9BABAPQQAMBwsgBEECcUUEQCACQQFBwg9BABAPIAYQEEEADAcLIAAgBEH/////B3I2AmQgASAHIAVrrSINIAIgASgCKBEIACANUQ0DIAAtAGRBCHFFDQEgAkECQZIcQQAQDwsgBhAQQQEMBQsgAkEBQZIcQQAQDyAGEBBBAAwECyABIAQgBSACEBogBUcEQCACQQFBxBxBABAPIAQQEEEADAQLIAAgBCIGIAUgAiAKKAIEEQEADQALIAQQEEEADAILIAJBAUGiJUEAEA9BAAwBCyAGEBBBAAshDCADQfAAaiQAIAwL5gEBBn8gACgCCEE1IAIQJARAAkAgACgCCCIGKAIAIQMgBigCCCEFAkACQAJ/AkAgAwRAQQEhBCADQQFxIQcgA0EBRw0BQQAMAgsgBkEANgIADAILIANBfnEhAwNAAn9BACAERQ0AGkEAIAAgASACIAUoAgARAABFDQAaIAAgASACIAUoAgQRAABBAEcLIQQgBUEIaiEFIAhBAmoiCCADRw0ACyAERQshAyAHBEAgAw0CIAAgASACIAUoAgARAABBAEchBAsgBkEANgIAIARFDQILIAAoAgAaQQEPCyAGQQA2AgALC0EACwoAIAAoAgAaQQALFAAgACgCACIABEAgACABNgK4AQsLIQAgACgCACABEFMgAEEAOgB8IAAgASgCuEBBAXE2AoABCzIAIAJFBEBBAA8LIAAoAgAgASACIAMQSEUEQCADQQFBqS9BABAPQQAPCyAAIAIgAxBxC2kCAn8BfCMAQRBrIgMkACACBEADQCAAIANBCGoQRCABAn8gAysDCCIFmUQAAAAAAADgQWMEQCAFqgwBC0GAgICAeAs2AgAgAUEEaiEBIABBCGohACAEQQFqIgQgAkcNAAsLIANBEGokAAuEAQICfwF9IwBBEGsiAyQAIAIEQANAIAMgAC0AADoADyADIAAtAAE6AA4gAyAALQACOgANIAMgAC0AAzoADCABAn8gAyoCDCIFi0MAAABPXQRAIAWoDAELQYCAgIB4CzYCACABQQRqIQEgAEEEaiEAIARBAWoiBCACRw0ACwsgA0EQaiQAC0sBAn8jAEEQayIDJAAgAgRAA0AgACADQQxqQQQQESABIAMoAgw2AgAgAUEEaiEBIABBBGohACAEQQFqIgQgAkcNAAsLIANBEGokAAtLAQJ/IwBBEGsiAyQAIAIEQANAIAAgA0EMakECEBEgASADKAIMNgIAIAFBBGohASAAQQJqIQAgBEEBaiIEIAJHDQALCyADQRBqJAALSgECfyMAQRBrIgMkACACBEADQCAAIANBCGoQRCABIAMrAwi2OAIAIAFBBGohASAAQQhqIQAgBEEBaiIEIAJHDQALCyADQRBqJAALaAECfyMAQRBrIgMkACACBEADQCADIAAtAAA6AA8gAyAALQABOgAOIAMgAC0AAjoADSADIAAtAAM6AAwgASADKgIMOAIAIAFBBGohASAAQQRqIQAgBEEBaiIEIAJHDQALCyADQRBqJAALTAECfyMAQRBrIgMkACACBEADQCAAIANBDGpBBBARIAEgAygCDLM4AgAgAUEEaiEBIABBBGohACAEQQFqIgQgAkcNAAsLIANBEGokAAtMAQJ/IwBBEGsiAyQAIAIEQANAIAAgA0EMakECEBEgASADKAIMszgCACABQQRqIQEgAEECaiEAIARBAWoiBCACRw0ACwsgA0EQaiQAC6oIAg1/AXsjAEEQayIIJAACfyAAKAIIQRBGBEAgACgCnAEgACgCzAFBjCxsagwBCyAAKAIMCyEJAkAgAkUEQCADQQFB8B9BABAPDAELIAAoAkghBkEBIQQgASAIQQhqQQEQESAIKAIIIgVBAk8EQCADQQJBxsgAQQAQDwwBCyACIAVBAWpHBEBBACEEIANBAkHwH0EAEA8MAQsCQCAGKAIQIgNFDQAgCSgC0CshBCADQQhPBEAgA0F4cSEGQQAhAgNAIARBADYCvEMgBEEANgKEOyAEQQA2AswyIARBADYClCogBEEANgLcISAEQQA2AqQZIARBADYC7BAgBEEANgK0CCAEQcDDAGohBCACQQhqIgIgBkcNAAsLIANBB3EiA0UNAEEAIQIDQCAEQQA2ArQIIARBuAhqIQQgAkEBaiICIANHDQALCyAJKALoKyICBH8gAhAQIAlBADYC6CsgCCgCCAUgBQtFBEBBASEEDAELA0AgAUEBaiIBIAhBDGpBARARAkAgCSgCgCxFDQAgCSgC/CsiAygCACAIKAIMRw0AIAMoAgQiBSAAKAJIIgYoAhBHDQAgAygCCCICBEBBACEEIAIoAhAgBSAFbCIFIAIoAgBBAnRB0L0BaigCAGxHDQMgCSAFQQJ0EBQiBzYC6CsgB0UNAyACKAIMIAcgBSACKAIAQQJ0QYDAAWooAgARBQALIAMoAgwiAkUNAEEAIQQgAigCECAGKAIQIgMgAigCAEECdEHQvQFqKAIAbEcNAiADQQJ0EBQiBUUNAiACKAIMIAUgAyACKAIAQQJ0QZDAAWooAgARBQACQCAGKAIQIgdFDQAgCSgC0CshBEEAIQsCQAJAIAdBBEkNACAEQbQIaiIMIAUgB0ECdGpJBEAgBSAEIAdBuAhsakkNAQsgBEHcIWohDSAEQaQZaiEOIARB7BBqIQ8gBSAHQXxxIgZBAnRqIQIgBCAGQbgIbGohBEEAIQMDQCAMIANBuAhsIgpqIAUgA0ECdGr9AAIAIhH9WgIAACAKIA9qIBH9WgIAASAKIA5qIBH9WgIAAiAKIA1qIBH9WgIAAyADQQRqIgMgBkcNAAsgBiAHRg0CDAELIAUhAkEAIQYLIAcgBiIDa0EHcSIKBEADQCAEIAIoAgA2ArQIIANBAWohAyAEQbgIaiEEIAJBBGohAiALQQFqIgsgCkcNAAsLIAYgB2tBeEsNAANAIAQgAigCADYCtAggBCACKAIENgLsECAEIAIoAgg2AqQZIAQgAigCDDYC3CEgBCACKAIQNgKUKiAEIAIoAhQ2AswyIAQgAigCGDYChDsgBCACKAIcNgK8QyAEQcDDAGohBCACQSBqIQIgA0EIaiIDIAdHDQALCyAFEBALQQEhBCAQQQFqIhAgCCgCCEkNAAsLIAhBEGokACAECwQAQn8LvwkBC38jAEEQayIFJAACfyAAKAIIQRBGBEAgACgCnAEgACgCzAFBjCxsagwBCyAAKAIMCyEHAn8gAkEBTQRAIANBAUHYI0EAEA9BAAwBCyABIAVBDGpBAhARIAUoAgwEQCADQQJB8CxBABAPQQEMAQsgAkEGTQRAIANBAUHYI0EAEA9BAAwBCyABQQJqIAVBCGpBARARIAcoAvwrIgkhAAJAAkACQCAHKAKALCIGRQ0AIAUoAgghCANAIAAoAgAgCEYNASAAQRRqIQAgBEEBaiIEIAZHDQALDAELIAQgBkcNAQsgBygChCwgBkYEfyAHIAZBCmoiADYChCwgCSAAQRRsEBciAEUEQCAHKAL8KxAQIAdBADYChCwgB0IANwL8KyADQQFB8iNBABAPQQAMAwsgByAANgL8KyAAIAcoAoAsIgRBFGxqQQAgBygChCwgBGtBFGwQFRogBygC/CshCSAHKAKALAUgBgtBFGwgCWohAEEBIQsLIAAgBSgCCDYCACABQQNqIAVBDGpBAhARIAUoAgwEQCADQQJB8CxBABAPQQEMAQsgAUEFaiAFQQRqQQIQESAFKAIEIgRBAk8EQCADQQJBqBdBABAPQQEMAQsgAkEHayEGIAQEQCABQQdqIQJBACEJA0AgBkECTQRAIANBAUHYI0EAEA9BAAwDCyACIAVBDGpBARARIAUoAgxBAUcEQCADQQJBsipBABAPQQEMAwsgAkEBaiAFQQIQESAAIAUoAgAiBEH//wFxIgE2AgQgBkEDayIIIARBD3ZBAWoiBiABbEECaiIKSQRAIANBAUHYI0EAEA9BAAwDCyACQQNqIQJBACEEIAEEQANAIAIgBUEMaiAGEBEgBCAFKAIMRwRAIANBAkHaL0EAEA9BAQwFCyACIAZqIQIgBEEBaiIEIAAoAgRJDQALCyACIAVBAhARIAUgBSgCACIEQf//AXEiATYCACAAKAIEIAFHBEAgA0ECQdgYQQAQD0EBDAMLIAggCmsiCiAEQQ92QQFqIgYgAWxBA2oiDEkEQCADQQFB2CNBABAPQQAMAwsgAkECaiECQQAhBCABBEADQCACIAVBDGogBhARIAQgBSgCDEcEQCADQQJB2i9BABAPQQEMBQsgAiAGaiECIARBAWoiBCAAKAIESQ0ACwsgAiAFQQxqQQMQESAFKAIMIQYgAEIANwIIIAAgBkGAgARxRSAALQAQQf4BcXI6ABAgBSAGQf8BcSIINgIIAkAgCEUNACAHKAL0KyINBEAgBygC8CshBEEAIQEDQCAIIAQoAghGBEAgACAENgIIDAMLIARBFGohBCABQQFqIgEgDUcNAAsLIANBAUHYI0EAEA9BAAwDCyAFIAZBCHZB/wFxIgY2AggCQCAGRQ0AIAcoAvQrIggEQCAHKALwKyEEQQAhAQNAIAYgBCgCCEYEQCAAIAQ2AgwMAwsgBEEUaiEEIAFBAWoiASAIRw0ACwsgA0EBQdgjQQAQD0EADAMLIAogDGshBiACQQNqIQIgCUEBaiIJIAUoAgRJDQALCyAGBEAgA0EBQdgjQQAQD0EADAELQQEgC0UNABogByAHKAKALEEBajYCgCxBAQshDiAFQRBqJAAgDgv1AQEFfyMAQRBrIgQkAAJAIAIgACgCSCgCECIGQQJqRwRAIANBAUHwIkEAEA8MAQsgASAEQQxqQQIQESAGIAQoAgxHBEAgA0EBQfAiQQAQDwwBCyAGRQRAQQEhBQwBCyABQQJqIQIgACgCSCgCGCEAQQAhAQNAIAIgBEEIakEBEBEgACAEKAIIIgVB/wBxIgdBAWoiCDYCGCAAIAVBB3ZBAXE2AiAgB0EfTwRAIAQgCDYCBCAEIAE2AgAgA0EBQbfzACAEEA9BACEFDAILIABBNGohAEEBIQUgAkEBaiECIAFBAWoiASAGRw0ACwsgBEEQaiQAIAULmAUBCn8jAEEQayIHJAACfyAAKAIIQRBGBEAgACgCnAEgACgCzAFBjCxsagwBCyAAKAIMCyEFAn8gAkEBTQRAIANBAUHxHkEAEA9BAAwBCyABIAdBDGpBAhARAkAgBygCDARAIANBAkGGG0EAEA8MAQsgAkEGTQRAIANBAUHxHkEAEA9BAAwCCyABQQJqIAdBDGpBAhARIAUoAvArIQQgBy0ADCEKAkACQAJAIAUoAvQrIgZFBEAgBCEADAELIAQhAANAIAAoAgggCkYNASAAQRRqIQAgCEEBaiIIIAZHDQALDAELIAYgCEcNAQsgBSgC+CsgBkYEQCAFIAZBCmoiADYC+CsgBCAAQRRsEBchACAFKALwKyEEIABFBEAgBBAQIAVBADYC+CsgBUIANwLwKyADQQFBix9BABAPQQAMBAsCQCAAIARGDQAgBSgCgCwiC0UNACAFKAL8KyEMQQAhCANAIAwgCEEUbGoiBigCCCIJBEAgBiAAIAkgBGtqNgIICyAGKAIMIgkEQCAGIAAgCSAEa2o2AgwLIAhBAWoiCCALRw0ACwsgBSAANgLwKyAAIAUoAvQrIgRBFGxqQQAgBSgC+CsgBGtBFGwQFRogBSgC9CshBiAFKALwKyEECyAFIAZBAWo2AvQrIAQgBkEUbGohAAsgACgCDCIEBEAgBBAQIABCADcCDAsgACAKNgIIIAAgBygCDCIEQQp2QQNxNgIAIAAgBEEIdkEDcTYCBCABQQRqIAdBDGpBAhARIAcoAgwEQCADQQJBvRZBABAPDAELIAAgAkEGayICEBQiBDYCDCAERQRAIANBAUHxHkEAEA9BAAwCCyAEIAFBBmogAhASGiAAIAI2AhALQQELIQ0gB0EQaiQAIA0LJwBBASEBIAIgACgCSCgCEEECdEcEfyADQQFB1yFBABAPQQAFQQELC6sDAQV/IwBBEGsiBiQAAn8gAkEBTQRAIANBAUH9HUEAEA9BAAwBCyAALQC8AUEBcQRAIANBAUGJ3gBBABAPQQAMAQsgACgCnAEgACgCzAFBjCxsaiIAIAAtAIgsQQJyOgCILCABIAZBDGpBARARAkAgACgCrCgiBEUEQCAAIAYoAgxBAWoiBUEIEBMiBDYCrCggBEUEQCADQQFBlx5BABAPQQAMAwsgACAFNgKoKAwBCyAGKAIMIgUgACgCqChJDQAgBCAFQQFqIgRBA3QQFyIFRQRAIANBAUGXHkEAEA9BAAwCCyAAIAU2AqwoIAUgACgCqCgiB0EDdGpBACAEIAdrQQN0EBUaIAAgBDYCqCggACgCrCghBAsgBCAGKAIMIgVBA3RqKAIABEAgBiAFNgIAIANBAUG9NSAGEA9BAAwBCyACQQFrIgIQFCEEIAAoAqwoIgAgBigCDCIFQQN0aiAENgIAIARFBEAgA0EBQZceQQAQD0EADAELIAAgBUEDdGogAjYCBCAAIAYoAgxBA3RqKAIAIAFBAWogAhASGkEBCyEIIAZBEGokACAIC/UCAQV/IwBBEGsiBiQAAn8gAkEBTQRAIANBAUGkIEEAEA9BAAwBCyAAIAAtALwBQQFyOgC8ASABIAZBDGpBARARAkAgACgCdCIERQRAIAAgBigCDEEBaiIFQQgQEyIENgJ0IARFBEAgA0EBQb4gQQAQD0EADAMLIAAgBTYCcAwBCyAGKAIMIgUgACgCcEkNACAEIAVBAWoiBEEDdBAXIgVFBEAgA0EBQb4gQQAQD0EADAILIAAgBTYCdCAFIAAoAnAiB0EDdGpBACAEIAdrQQN0EBUaIAAgBDYCcCAAKAJ0IQQLIAQgBigCDCIFQQN0aigCAARAIAYgBTYCACADQQFB0zUgBhAPQQAMAQsgAkEBayICEBQhBCAAKAJ0IgAgBigCDCIFQQN0aiAENgIAIARFBEAgA0EBQb4gQQAQD0EADAELIAAgBUEDdGogAjYCBCAAIAYoAgxBA3RqKAIAIAFBAWogAhASGkEBCyEIIAZBEGokACAIC6ABAQR/IwBBEGsiBCQAAn8gAkUEQCADQQFB1x5BABAPQQAMAQsgASAEQQxqQQEQEUEBIAJBAWsiBUUNABpBACEAQQAhAgNAIAFBAWoiASAEQQhqQQEQESAEKAIIIgZBGHRBH3UgBkH/AHEgAnJBB3RxIQIgAEEBaiIAIAVHDQALQQEgAkUNABogA0EBQdceQQAQD0EACyEHIARBEGokACAHCxsAQQEhACACBH9BAQUgA0EBQf4gQQAQD0EACwuAAQEBfyMAQRBrIgAkAEEBIQQCQCACQQFNBEBBACEEIANBAUHkIEEAEA8MAQsgASAAQQxqQQEQESABQQFqIABBCGpBARARIAJBAmsgACgCCCIBQQV2QQJxIAFBBHZBA3FqQQJqcEUNAEEAIQQgA0EBQeQgQQAQDwsgAEEQaiQAIAQLBABBAAsLorwBIQBBgAgLkXVjYW5ub3QgYWxsb2NhdGUgb3BqX3RjZF9zZWdfZGF0YV9jaHVua190KiBhcnJheQAtKyAgIDBYMHgALTBYKzBYIDBYLTB4KzB4IDB4AFVua25vd24gZm9ybWF0AEZhaWxlZCB0byBzZXR1cCB0aGUgZGVjb2RlcgBGYWlsZWQgdG8gcmVhZCB0aGUgaGVhZGVyAG5hbgAqbF90aWxlX2xlbiA+IFVJTlRfTUFYIC0gT1BKX0NPTU1PTl9DQkxLX0RBVEFfRVhUUkEgLSBwX2oyay0+bV9zcGVjaWZpY19wYXJhbS5tX2RlY29kZXIubV9zb3RfbGVuZ3RoAGluZgBGYWlsZWQgdG8gZGVjb2RlIHRoZSBpbWFnZQBJbnZhbGlkIGFjY2VzcyB0byBwaS0+aW5jbHVkZQAvdG1wL29wZW5qcGVnL3NyYy9iaW4vY29tbW9uL2NvbG9yLmMAQUxMX0NQVVMAT1BKX05VTV9USFJFQURTAE5BTgBJTkYAcF9qMmstPm1fc3BlY2lmaWNfcGFyYW0ubV9kZWNvZGVyLm1fc290X2xlbmd0aCA+IFVJTlRfTUFYIC0gT1BKX0NPTU1PTl9DQkxLX0RBVEFfRVhUUkEACQkJIHByZWNjaW50c2l6ZSAodyxoKT0ACQkJIHN0ZXBzaXplcyAobSxlKT0ALgAobnVsbCkAKCVkLCVkKSAAJXN9CgAJCSB9CgBbREVWXSBEdW1wIGFuIGltYWdlX2NvbXBfaGVhZGVyIHN0cnVjdCB7CgBbREVWXSBEdW1wIGFuIGltYWdlX2hlYWRlciBzdHJ1Y3QgewoASW1hZ2UgaW5mbyB7CgAJIGRlZmF1bHQgdGlsZSB7CgAlcwkgY29tcG9uZW50ICVkIHsKAAkJIGNvbXAgJWQgewoACSBUaWxlIGluZGV4OiB7CgAJIE1hcmtlciBsaXN0OiB7CgBDb2Rlc3RyZWFtIGluZGV4IGZyb20gbWFpbiBoZWFkZXI6IHsKAENvZGVzdHJlYW0gaW5mbyBmcm9tIG1haW4gaGVhZGVyOiB7CgBTdHJlYW0gZXJyb3Igd2hpbGUgcmVhZGluZyBKUDIgSGVhZGVyIGJveAoARm91bmQgYSBtaXNwbGFjZWQgJyVjJWMlYyVjJyBib3ggb3V0c2lkZSBqcDJoIGJveAoATWFsZm9ybWVkIEpQMiBmaWxlIGZvcm1hdDogZmlyc3QgYm94IG11c3QgYmUgSlBFRyAyMDAwIHNpZ25hdHVyZSBib3gKAE1hbGZvcm1lZCBKUDIgZmlsZSBmb3JtYXQ6IHNlY29uZCBib3ggbXVzdCBiZSBmaWxlIHR5cGUgYm94CgBOb3QgZW5vdWdoIG1lbW9yeSB0byBoYW5kbGUganBlZzIwMDAgYm94CgBOb3QgZW5vdWdoIG1lbW9yeSB3aXRoIEZUWVAgQm94CgBBIG1hcmtlciBJRCB3YXMgZXhwZWN0ZWQgKDB4ZmYtLSkgaW5zdGVhZCBvZiAlLjh4CgAJCSBtY3Q9JXgKAAkJCSBjYmxrc3R5PSUjeAoACQkJIGNzdHk9JSN4CgAJCSBwcmc9JSN4CgBJbnRlZ2VyIG92ZXJmbG93CgAJIHRkeD0ldSwgdGR5PSV1CgAJIHR3PSV1LCB0aD0ldQoACSB0eDA9JXUsIHR5MD0ldQoASW52YWxpZCBjb21wb25lbnQgaW5kZXg6ICV1CgBTdHJlYW0gdG9vIHNob3J0CgBNYXJrZXIgaGFuZGxlciBmdW5jdGlvbiBmYWlsZWQgdG8gcmVhZCB0aGUgbWFya2VyIHNlZ21lbnQKAE5vdCBlbm91Z2ggbWVtb3J5IGZvciBjdXJyZW50IHByZWNpbmN0IGNvZGVibG9jayBlbGVtZW50CgBFcnJvciByZWFkaW5nIFNQQ29kIFNQQ29jIGVsZW1lbnQKAEVycm9yIHJlYWRpbmcgU1FjZCBvciBTUWNjIGVsZW1lbnQKAEEgQlBDQyBoZWFkZXIgYm94IGlzIGF2YWlsYWJsZSBhbHRob3VnaCBCUEMgZ2l2ZW4gYnkgdGhlIElIRFIgYm94ICglZCkgaW5kaWNhdGUgY29tcG9uZW50cyBiaXQgZGVwdGggaXMgY29uc3RhbnQKAEVycm9yIHdpdGggU0laIG1hcmtlcjogaWxsZWdhbCB0aWxlIG9mZnNldAoASW52YWxpZCBwcmVjaW5jdAoATm90IGVub3VnaCBtZW1vcnkgdG8gaGFuZGxlIGJhbmQgcHJlY2ludHMKAEZhaWxlZCB0byBkZWNvZGUgYWxsIHVzZWQgY29tcG9uZW50cwoAU2l6ZSBvZiBjb2RlIGJsb2NrIGRhdGEgZXhjZWVkcyBzeXN0ZW0gbGltaXRzCgBTaXplIG9mIHRpbGUgZGF0YSBleGNlZWRzIHN5c3RlbSBsaW1pdHMKAENhbm5vdCB0YWtlIGluIGNoYXJnZSBtdWx0aXBsZSBNQ1QgbWFya2VycwoAQ29ycnVwdGVkIFBQTSBtYXJrZXJzCgBOb3QgZW5vdWdoIG1lbW9yeSBmb3IgdGlsZSByZXNvbHV0aW9ucwoAQ2Fubm90IHRha2UgaW4gY2hhcmdlIG11bHRpcGxlIGNvbGxlY3Rpb25zCgBJbnZhbGlkIFBDTFIgYm94LiBSZXBvcnRzIDAgcGFsZXR0ZSBjb2x1bW5zCgBXZSBkbyBub3Qgc3VwcG9ydCBST0kgaW4gZGVjb2RpbmcgSFQgY29kZWJsb2NrcwoAQ2Fubm90IGhhbmRsZSBib3ggb2YgdW5kZWZpbmVkIHNpemVzCgBDYW5ub3QgdGFrZSBpbiBjaGFyZ2UgY29sbGVjdGlvbnMgd2l0aG91dCBzYW1lIG51bWJlciBvZiBpbmRpeGVzCgBJbnZhbGlkIHRpbGVjLT53aW5feHh4IHZhbHVlcwoAQ2Fubm90IGhhbmRsZSBib3ggb2YgbGVzcyB0aGFuIDggYnl0ZXMKAENhbm5vdCBoYW5kbGUgWEwgYm94IG9mIGxlc3MgdGhhbiAxNiBieXRlcwoAQ29tcG9uZW50IGluZGV4ICV1IHVzZWQgc2V2ZXJhbCB0aW1lcwoASW52YWxpZCBQQ0xSIGJveC4gUmVwb3J0cyAlZCBlbnRyaWVzCgBOb3QgZW5vdWdoIG1lbW9yeSB0byBjcmVhdGUgVGFnLXRyZWUgbm9kZXMKAENhbm5vdCB0YWtlIGluIGNoYXJnZSBtY3QgZGF0YSB3aXRoaW4gbXVsdGlwbGUgTUNUIHJlY29yZHMKAENhbm5vdCBkZWNvZGUgdGlsZSwgbWVtb3J5IGVycm9yCgBvcGpfajJrX2FwcGx5X25iX3RpbGVfcGFydHNfY29ycmVjdGlvbiBlcnJvcgoAUHJvYmxlbSB3aXRoIHNraXBwaW5nIEpQRUcyMDAwIGJveCwgc3RyZWFtIGVycm9yCgBQcm9ibGVtIHdpdGggcmVhZGluZyBKUEVHMjAwMCBib3gsIHN0cmVhbSBlcnJvcgoAVW5rbm93biBtYXJrZXIKAE5vdCBlbm91Z2ggbWVtb3J5IHRvIGFkZCB0bCBtYXJrZXIKAE5vdCBlbm91Z2ggbWVtb3J5IHRvIGFkZCBtaCBtYXJrZXIKAE5vdCBlbm91Z2ggbWVtb3J5IHRvIHRha2UgaW4gY2hhcmdlIFNJWiBtYXJrZXIKAEVycm9yIHJlYWRpbmcgUFBUIG1hcmtlcgoATm90IGVub3VnaCBtZW1vcnkgdG8gcmVhZCBQUFQgbWFya2VyCgBFcnJvciByZWFkaW5nIFNPVCBtYXJrZXIKAEVycm9yIHJlYWRpbmcgUExUIG1hcmtlcgoARXJyb3IgcmVhZGluZyBNQ1QgbWFya2VyCgBOb3QgZW5vdWdoIG1lbW9yeSB0byByZWFkIE1DVCBtYXJrZXIKAE5vdCBlbm91Z2ggc3BhY2UgZm9yIGV4cGVjdGVkIFNPUCBtYXJrZXIKAEV4cGVjdGVkIFNPUCBtYXJrZXIKAEVycm9yIHJlYWRpbmcgTUNPIG1hcmtlcgoARXJyb3IgcmVhZGluZyBSR04gbWFya2VyCgBFcnJvciByZWFkaW5nIFBQTSBtYXJrZXIKAE5vdCBlbm91Z2ggbWVtb3J5IHRvIHJlYWQgUFBNIG1hcmtlcgoARXJyb3IgcmVhZGluZyBUTE0gbWFya2VyCgBFcnJvciByZWFkaW5nIFBMTSBtYXJrZXIKAE5vdCBlbm91Z2ggc3BhY2UgZm9yIGV4cGVjdGVkIEVQSCBtYXJrZXIKAEV4cGVjdGVkIEVQSCBtYXJrZXIKAEVycm9yIHJlYWRpbmcgQ1JHIG1hcmtlcgoAVW5rbm93biBwcm9ncmVzc2lvbiBvcmRlciBpbiBDT0QgbWFya2VyCgBVbmtub3duIFNjb2QgdmFsdWUgaW4gQ09EIG1hcmtlcgoARXJyb3IgcmVhZGluZyBDT0QgbWFya2VyCgBFcnJvciByZWFkaW5nIFFDRCBtYXJrZXIKAENycm9yIHJlYWRpbmcgQ0JEIG1hcmtlcgoARXJyb3IgcmVhZGluZyBQT0MgbWFya2VyCgBFcnJvciByZWFkaW5nIENPQyBtYXJrZXIKAEVycm9yIHJlYWRpbmcgUUNDIG1hcmtlcgoARXJyb3IgcmVhZGluZyBNQ0MgbWFya2VyCgBOb3QgZW5vdWdoIG1lbW9yeSB0byByZWFkIE1DQyBtYXJrZXIKAHJlcXVpcmVkIFNJWiBtYXJrZXIgbm90IGZvdW5kIGluIG1haW4gaGVhZGVyCgByZXF1aXJlZCBDT0QgbWFya2VyIG5vdCBmb3VuZCBpbiBtYWluIGhlYWRlcgoAcmVxdWlyZWQgUUNEIG1hcmtlciBub3QgZm91bmQgaW4gbWFpbiBoZWFkZXIKAE5vdCBlbm91Z2ggbWVtb3J5IHRvIGhhbmRsZSBqcGVnMjAwMCBmaWxlIGhlYWRlcgoATm90IGVub3VnaCBtZW1vcnkgdG8gcmVhZCBoZWFkZXIKAEVycm9yIHdpdGggSlAgU2lnbmF0dXJlIDogYmFkIG1hZ2ljIG51bWJlcgoASW4gU09UIG1hcmtlciwgVFBTb3QgKCVkKSBpcyBub3QgdmFsaWQgcmVnYXJkcyB0byB0aGUgY3VycmVudCBudW1iZXIgb2YgdGlsZS1wYXJ0ICglZCksIGdpdmluZyB1cAoASW4gU09UIG1hcmtlciwgVFBTb3QgKCVkKSBpcyBub3QgdmFsaWQgcmVnYXJkcyB0byB0aGUgcHJldmlvdXMgbnVtYmVyIG9mIHRpbGUtcGFydCAoJWQpLCBnaXZpbmcgdXAKAEluIFNPVCBtYXJrZXIsIFRQU290ICglZCkgaXMgbm90IHZhbGlkIHJlZ2FyZHMgdG8gdGhlIGN1cnJlbnQgbnVtYmVyIG9mIHRpbGUtcGFydCAoaGVhZGVyKSAoJWQpLCBnaXZpbmcgdXAKAHRpbGVzIHJlcXVpcmUgYXQgbGVhc3Qgb25lIHJlc29sdXRpb24KAE1hcmtlciBpcyBub3QgY29tcGxpYW50IHdpdGggaXRzIHBvc2l0aW9uCgBQcm9ibGVtIHdpdGggc2VlayBmdW5jdGlvbgoARXJyb3IgcmVhZGluZyBTUENvZCBTUENvYyBlbGVtZW50LCBJbnZhbGlkIGNibGt3L2NibGtoIGNvbWJpbmF0aW9uCgBJbnZhbGlkIG11bHRpcGxlIGNvbXBvbmVudCB0cmFuc2Zvcm1hdGlvbgoAQ2Fubm90IHRha2UgaW4gY2hhcmdlIGNvbGxlY3Rpb25zIG90aGVyIHRoYW4gYXJyYXkgZGVjb3JyZWxhdGlvbgoAVG9vIGxhcmdlIHZhbHVlIGZvciBOcHBtCgBOb3QgZW5vdWdoIGJ5dGVzIHRvIHJlYWQgTnBwbQoAYmFkIHBsYWNlZCBqcGVnIGNvZGVzdHJlYW0KAAkgTWFpbiBoZWFkZXIgc3RhcnQgcG9zaXRpb249JWxsaQoJIE1haW4gaGVhZGVyIGVuZCBwb3NpdGlvbj0lbGxpCgBNYXJrZXIgc2l6ZSBpbmNvbnNpc3RlbnQgd2l0aCBzdHJlYW0gbGVuZ3RoCgBUaWxlIHBhcnQgbGVuZ3RoIHNpemUgaW5jb25zaXN0ZW50IHdpdGggc3RyZWFtIGxlbmd0aAoAQ2Fubm90IHRha2UgaW4gY2hhcmdlIG11bHRpcGxlIGRhdGEgc3Bhbm5pbmcKAFdyb25nIGZsYWcKAEVycm9yIHdpdGggRlRZUCBzaWduYXR1cmUgQm94IHNpemUKAEVycm9yIHdpdGggSlAgc2lnbmF0dXJlIEJveCBzaXplCgBJbnZhbGlkIHByZWNpbmN0IHNpemUKAEluY29uc2lzdGVudCBtYXJrZXIgc2l6ZQoASW52YWxpZCBtYXJrZXIgc2l6ZQoARXJyb3Igd2l0aCBTSVogbWFya2VyIHNpemUKAE5vdCBlbm91Z2ggbWVtb3J5IHRvIGFkZCBhIG5ldyB2YWxpZGF0aW9uIHByb2NlZHVyZQoATm90IGVub3VnaCBtZW1vcnkgdG8gZGVjb2RlIHRpbGUKAEZhaWxlZCB0byBkZWNvZGUgdGhlIGNvZGVzdHJlYW0gaW4gdGhlIEpQMiBmaWxlCgBDYW5ub3QgdGFrZSBpbiBjaGFyZ2UgY29sbGVjdGlvbnMgd2l0aCBpbmRpeCBzaHVmZmxlCgBDYW5ub3QgYWxsb2NhdGUgVGllciAxIGhhbmRsZQoATm8gZGVjb2RlZCBhcmVhIHBhcmFtZXRlcnMsIHNldCB0aGUgZGVjb2RlZCBhcmVhIHRvIHRoZSB3aG9sZSBpbWFnZQoATm90IGVub3VnaCBtZW1vcnkgdG8gY3JlYXRlIFRhZy10cmVlCgBOb3QgZW5vdWdoIG1lbW9yeSB0byByZWluaXRpYWxpemUgdGhlIHRhZyB0cmVlCgBFcnJvciByZWFkaW5nIFNQQ29kIFNQQ29jIGVsZW1lbnQsIEludmFsaWQgdHJhbnNmb3JtYXRpb24gZm91bmQKAEVycm9yIHJlYWRpbmcgU1BDb2QgU1BDb2MgZWxlbWVudC4gVW5zdXBwb3J0ZWQgTWl4ZWQgSFQgY29kZS1ibG9jayBzdHlsZSBmb3VuZAoAVGlsZSBZIGNvb3JkaW5hdGVzIGFyZSBub3Qgc3VwcG9ydGVkCgBUaWxlIFggY29vcmRpbmF0ZXMgYXJlIG5vdCBzdXBwb3J0ZWQKAEltYWdlIGNvb3JkaW5hdGVzIGFib3ZlIElOVF9NQVggYXJlIG5vdCBzdXBwb3J0ZWQKAEpQRUcyMDAwIEhlYWRlciBib3ggbm90IHJlYWQgeWV0LCAnJWMlYyVjJWMnIGJveCB3aWxsIGJlIGlnbm9yZWQKAG9wal9qMmtfbWVyZ2VfcHB0KCkgaGFzIGFscmVhZHkgYmVlbiBjYWxsZWQKAE5vdCBlbm91Z2ggbWVtb3J5IHRvIHJlYWQgU09UIG1hcmtlci4gVGlsZSBpbmRleCBhbGxvY2F0aW9uIGZhaWxlZAoASWdub3JpbmcgaWhkciBib3guIEZpcnN0IGloZHIgYm94IGFscmVhZHkgcmVhZAoAWnBwdCAldSBhbHJlYWR5IHJlYWQKAFpwcG0gJXUgYWxyZWFkeSByZWFkCgBQVEVSTSBjaGVjayBmYWlsdXJlOiAlZCBzeW50aGV0aXplZCAweEZGIG1hcmtlcnMgcmVhZAoACQkJIGNibGt3PTJeJWQKAAkJCSBjYmxraD0yXiVkCgAJCQkgcW50c3R5PSVkCgAlcyBkeD0lZCwgZHk9JWQKAAkJCSByb2lzaGlmdD0lZAoACQkJIG51bWdiaXRzPSVkCgAJCSBudW1sYXllcnM9JWQKACVzIG51bWNvbXBzPSVkCgBvcGpfanAyX2FwcGx5X2NkZWY6IGFjbj0lZCwgbnVtY29tcHM9JWQKAG9wal9qcDJfYXBwbHlfY2RlZjogY249JWQsIG51bWNvbXBzPSVkCgAJCQkgbnVtcmVzb2x1dGlvbnM9JWQKAAkJIHR5cGU9JSN4LCBwb3M9JWxsaSwgbGVuPSVkCgAlcyBzZ25kPSVkCgAJCQkgcW1mYmlkPSVkCgAlcyBwcmVjPSVkCgAJCSBuYiBvZiB0aWxlLXBhcnQgaW4gdGlsZSBbJWRdPSVkCgAlcyB4MT0lZCwgeTE9JWQKACVzIHgwPSVkLCB5MD0lZAoARmFpbGVkIHRvIGRlY29kZSB0aWxlICVkLyVkCgBTZXR0aW5nIGRlY29kaW5nIGFyZWEgdG8gJWQsJWQsJWQsJWQKAEZhaWxlZCB0byBkZWNvZGUgY29tcG9uZW50ICVkCgBJbnZhbGlkIHZhbHVlIGZvciBudW1yZXNvbHV0aW9ucyA6ICVkLCBtYXggdmFsdWUgaXMgc2V0IGluIG9wZW5qcGVnLmggYXQgJWQKAEludmFsaWQgY29tcG9uZW50IG51bWJlcjogJWQsIHJlZ2FyZGluZyB0aGUgbnVtYmVyIG9mIGNvbXBvbmVudHMgJWQKAFRvbyBtYW55IFBPQ3MgJWQKAEludmFsaWQgdGlsZSBudW1iZXIgJWQKAEludmFsaWQgdGlsZSBwYXJ0IGluZGV4IGZvciB0aWxlIG51bWJlciAlZC4gR290ICVkLCBleHBlY3RlZCAlZAoARXJyb3Igd2l0aCBTSVogbWFya2VyOiBudW1iZXIgb2YgY29tcG9uZW50IGlzIGlsbGVnYWwgLT4gJWQKAE5vdCBlbm91Z2ggbWVtb3J5IGZvciBjaWVsYWIKAENhbm5vdCBhbGxvY2F0ZSBjYmxrLT5kZWNvZGVkX2RhdGEKAEZhaWxlZCB0byBtZXJnZSBQUFQgZGF0YQoARmFpbGVkIHRvIG1lcmdlIFBQTSBkYXRhCgBJbnZhbGlkIG51bWJlciBvZiBsYXllcnMgaW4gQ09EIG1hcmtlciA6ICVkIG5vdCBpbiByYW5nZSBbMS02NTUzNV0KACVzOiVkOmNvbG9yX2NteWtfdG9fcmdiCglDQU4gTk9UIENPTlZFUlQKACVzOiVkOmNvbG9yX2VzeWNjX3RvX3JnYgoJQ0FOIE5PVCBDT05WRVJUCgAlczolZDpjb2xvcl9zeWNjX3RvX3JnYgoJQ0FOIE5PVCBDT05WRVJUCgBTdHJlYW0gdG9vIHNob3J0LCBleHBlY3RlZCBTT1QKAFVuYWJsZSB0byBzZXQgdDEgaGFuZGxlIGFzIFRMUwoAU3RyZWFtIGRvZXMgbm90IGVuZCB3aXRoIEVPQwoAQ2Fubm90IGhhbmRsZSBib3ggc2l6ZXMgaGlnaGVyIHRoYW4gMl4zMgoAb3BqX3BpX25leHRfbHJjcCgpOiBpbnZhbGlkIGNvbXBubzAvY29tcG5vMQoAb3BqX3BpX25leHRfcmxjcCgpOiBpbnZhbGlkIGNvbXBubzAvY29tcG5vMQoAb3BqX3BpX25leHRfY3BybCgpOiBpbnZhbGlkIGNvbXBubzAvY29tcG5vMQoAb3BqX3BpX25leHRfcGNybCgpOiBpbnZhbGlkIGNvbXBubzAvY29tcG5vMQoAb3BqX3BpX25leHRfcnBjbCgpOiBpbnZhbGlkIGNvbXBubzAvY29tcG5vMQoAb3BqX3QxX2RlY29kZV9jYmxrKCk6IHVuc3VwcG9ydGVkIGJwbm9fcGx1c19vbmUgPSAlZCA+PSAzMQoARmFpbGVkIHRvIGRlY29kZSB0aWxlIDEvMQoASW5zdWZmaWNpZW50IGRhdGEgZm9yIENNQVAgYm94LgoATmVlZCB0byByZWFkIGEgUENMUiBib3ggYmVmb3JlIHRoZSBDTUFQIGJveC4KAEluc3VmZmljaWVudCBkYXRhIGZvciBDREVGIGJveC4KAE51bWJlciBvZiBjaGFubmVsIGRlc2NyaXB0aW9uIGlzIGVxdWFsIHRvIHplcm8gaW4gQ0RFRiBib3guCgBTdHJlYW0gZXJyb3Igd2hpbGUgcmVhZGluZyBKUDIgSGVhZGVyIGJveDogbm8gJ2loZHInIGJveC4KAE5vbiBjb25mb3JtYW50IGNvZGVzdHJlYW0gVFBzb3Q9PVROc290LgoAU3RyZWFtIGVycm9yIHdoaWxlIHJlYWRpbmcgSlAyIEhlYWRlciBib3g6IGJveCBsZW5ndGggaXMgaW5jb25zaXN0ZW50LgoAQm94IGxlbmd0aCBpcyBpbmNvbnNpc3RlbnQuCgBSZXNvbHV0aW9uIGZhY3RvciBpcyBncmVhdGVyIHRoYW4gdGhlIG1heGltdW0gcmVzb2x1dGlvbiBpbiB0aGUgY29tcG9uZW50LgoAQ29tcG9uZW50IG1hcHBpbmcgc2VlbXMgd3JvbmcuIFRyeWluZyB0byBjb3JyZWN0LgoASW5jb21wbGV0ZSBjaGFubmVsIGRlZmluaXRpb25zLgoATWFsZm9ybWVkIEhUIGNvZGVibG9jay4gSW52YWxpZCBjb2RlYmxvY2sgbGVuZ3RoIHZhbHVlcy4KAFdlIGRvIG5vdCBzdXBwb3J0IG1vcmUgdGhhbiAzIGNvZGluZyBwYXNzZXMgaW4gYW4gSFQgY29kZWJsb2NrOyBUaGlzIGNvZGVibG9ja3MgaGFzICVkIHBhc3Nlcy4KAE1hbGZvcm1lZCBIVCBjb2RlYmxvY2suIERlY29kaW5nIHRoaXMgY29kZWJsb2NrIGlzIHN0b3BwZWQuIFRoZXJlIGFyZSAlZCB6ZXJvIGJpdHBsYW5lcyBpbiAlZCBiaXRwbGFuZXMuCgBDYW5ub3QgdGFrZSBpbiBjaGFyZ2UgbXVsdGlwbGUgdHJhbnNmb3JtYXRpb24gc3RhZ2VzLgoAVW5rbm93biBtYXJrZXIgaGFzIGJlZW4gZGV0ZWN0ZWQgYW5kIGdlbmVyYXRlZCBlcnJvci4KAENvZGVjIHByb3ZpZGVkIHRvIHRoZSBvcGpfc2V0dXBfZGVjb2RlciBmdW5jdGlvbiBpcyBub3QgYSBkZWNvbXByZXNzb3IgaGFuZGxlci4KAENvZGVjIHByb3ZpZGVkIHRvIHRoZSBvcGpfcmVhZF9oZWFkZXIgZnVuY3Rpb24gaXMgbm90IGEgZGVjb21wcmVzc29yIGhhbmRsZXIuCgBUaWxlcyBkb24ndCBhbGwgaGF2ZSB0aGUgc2FtZSBkaW1lbnNpb24uIFNraXAgdGhlIE1DVCBzdGVwLgoATnVtYmVyIG9mIGNvbXBvbmVudHMgKCVkKSBpcyBpbmNvbnNpc3RlbnQgd2l0aCBhIE1DVC4gU2tpcCB0aGUgTUNUIHN0ZXAuCgBKUDIgYm94IHdoaWNoIGFyZSBhZnRlciB0aGUgY29kZXN0cmVhbSB3aWxsIG5vdCBiZSByZWFkIGJ5IHRoaXMgZnVuY3Rpb24uCgBNYWxmb3JtZWQgSFQgY29kZWJsb2NrLiBXaGVuIHRoZSBudW1iZXIgb2YgemVybyBwbGFuZXMgYml0cGxhbmVzIGlzIGVxdWFsIHRvIHRoZSBudW1iZXIgb2YgYml0cGxhbmVzLCBvbmx5IHRoZSBjbGVhbnVwIHBhc3MgbWFrZXMgc2Vuc2UsIGJ1dCB3ZSBoYXZlICVkIHBhc3NlcyBpbiB0aGlzIGNvZGVibG9jay4gVGhlcmVmb3JlLCBvbmx5IHRoZSBjbGVhbnVwIHBhc3Mgd2lsbCBiZSBkZWNvZGVkLiBUaGlzIG1lc3NhZ2Ugd2lsbCBub3QgYmUgZGlzcGxheWVkIGFnYWluLgoASW1hZ2UgaGFzIGxlc3MgY29tcG9uZW50cyB0aGFuIGNvZGVzdHJlYW0uCgBOZWVkIHRvIGRlY29kZSB0aGUgbWFpbiBoZWFkZXIgYmVmb3JlIGJlZ2luIHRvIGRlY29kZSB0aGUgcmVtYWluaW5nIGNvZGVzdHJlYW0uCgBQc290IHZhbHVlIG9mIHRoZSBjdXJyZW50IHRpbGUtcGFydCBpcyBlcXVhbCB0byB6ZXJvLCB3ZSBhc3N1bWluZyBpdCBpcyB0aGUgbGFzdCB0aWxlLXBhcnQgb2YgdGhlIGNvZGVzdHJlYW0uCgBBIG1hbGZvcm1lZCBjb2RlYmxvY2sgdGhhdCBoYXMgbW9yZSB0aGFuIG9uZSBjb2RpbmcgcGFzcywgYnV0IHplcm8gbGVuZ3RoIGZvciAybmQgYW5kIHBvdGVudGlhbGx5IHRoZSAzcmQgcGFzcyBpbiBhbiBIVCBjb2RlYmxvY2suCgAJCQkgdGlsZS1wYXJ0WyVkXTogc3Rhcl9wb3M9JWxsaSwgZW5kX2hlYWRlcj0lbGxpLCBlbmRfcG9zPSVsbGkuCgBUaWxlICV1IGhhcyBUUHNvdCA9PSAwIGFuZCBUTnNvdCA9PSAwLCBidXQgbm8gb3RoZXIgdGlsZS1wYXJ0cyB3ZXJlIGZvdW5kLiBFT0MgaXMgYWxzbyBtaXNzaW5nLgoAQ29tcG9uZW50ICVkIGRvZXNuJ3QgaGF2ZSBhIG1hcHBpbmcuCgBBIGNvbmZvcm1pbmcgSlAyIHJlYWRlciBzaGFsbCBpZ25vcmUgYWxsIENvbG91ciBTcGVjaWZpY2F0aW9uIGJveGVzIGFmdGVyIHRoZSBmaXJzdCwgc28gd2UgaWdub3JlIHRoaXMgb25lLgoAVGhlIHNpZ25hdHVyZSBib3ggbXVzdCBiZSB0aGUgZmlyc3QgYm94IGluIHRoZSBmaWxlLgoAVGhlICBib3ggbXVzdCBiZSB0aGUgZmlyc3QgYm94IGluIHRoZSBmaWxlLgoAVGhlIGZ0eXAgYm94IG11c3QgYmUgdGhlIHNlY29uZCBib3ggaW4gdGhlIGZpbGUuCgBGYWlsZWQgdG8gZGVjb2RlLgoATWFsZm9ybWVkIEhUIGNvZGVibG9jay4gSW5jb3JyZWN0IE1FTCBzZWdtZW50IHNlcXVlbmNlLgoAQ29tcG9uZW50ICVkIGlzIG1hcHBlZCB0d2ljZS4KAE9ubHkgb25lIENNQVAgYm94IGlzIGFsbG93ZWQuCgBXZSBuZWVkIGFuIGltYWdlIHByZXZpb3VzbHkgY3JlYXRlZC4KAElIRFIgYm94X21pc3NpbmcuIFJlcXVpcmVkLgoASlAySCBib3ggbWlzc2luZy4gUmVxdWlyZWQuCgBOb3Qgc3VyZSBob3cgdGhhdCBoYXBwZW5lZC4KAE1haW4gaGVhZGVyIGhhcyBiZWVuIGNvcnJlY3RseSBkZWNvZGVkLgoAVGlsZSAlZC8lZCBoYXMgYmVlbiBkZWNvZGVkLgoASGVhZGVyIG9mIHRpbGUgJWQgLyAlZCBoYXMgYmVlbiByZWFkLgoARW1wdHkgU09UIG1hcmtlciBkZXRlY3RlZDogUHNvdD0lZC4KAERpcmVjdCB1c2UgYXQgIyVkIGhvd2V2ZXIgcGNvbD0lZC4KAEltcGxlbWVudGF0aW9uIGxpbWl0YXRpb246IGZvciBwYWxldHRlIG1hcHBpbmcsIHBjb2xbJWRdIHNob3VsZCBiZSBlcXVhbCB0byAlZCwgYnV0IGlzIGVxdWFsIHRvICVkLgoASW52YWxpZCBjb21wb25lbnQvcGFsZXR0ZSBpbmRleCBmb3IgZGlyZWN0IG1hcHBpbmcgJWQuCgBJbnZhbGlkIHZhbHVlIGZvciBjbWFwWyVkXS5tdHlwID0gJWQuCgBQc290IHZhbHVlIGlzIG5vdCBjb3JyZWN0IHJlZ2FyZHMgdG8gdGhlIEpQRUcyMDAwIG5vcm06ICVkLgoATWFsZm9ybWVkIEhUIGNvZGVibG9jay4gVkxDIGNvZGUgcHJvZHVjZXMgc2lnbmlmaWNhbnQgc2FtcGxlcyBvdXRzaWRlIHRoZSBjb2RlYmxvY2sgYXJlYS4KAFVuZXhwZWN0ZWQgT09NLgoAMzIgYml0cyBhcmUgbm90IGVub3VnaCB0byBkZWNvZGUgdGhpcyBjb2RlYmxvY2ssIHNpbmNlIHRoZSBudW1iZXIgb2YgYml0cGxhbmUsICVkLCBpcyBsYXJnZXIgdGhhbiAzMC4KAEJvdHRvbSBwb3NpdGlvbiBvZiB0aGUgZGVjb2RlZCBhcmVhIChyZWdpb25feTE9JWQpIHNob3VsZCBiZSA+IDAuCgBSaWdodCBwb3NpdGlvbiBvZiB0aGUgZGVjb2RlZCBhcmVhIChyZWdpb25feDE9JWQpIHNob3VsZCBiZSA+IDAuCgBVcCBwb3NpdGlvbiBvZiB0aGUgZGVjb2RlZCBhcmVhIChyZWdpb25feTA9JWQpIHNob3VsZCBiZSA+PSAwLgoATGVmdCBwb3NpdGlvbiBvZiB0aGUgZGVjb2RlZCBhcmVhIChyZWdpb25feDA9JWQpIHNob3VsZCBiZSA+PSAwLgoARXJyb3IgcmVhZGluZyBQUFQgbWFya2VyOiBwYWNrZXQgaGVhZGVyIGhhdmUgYmVlbiBwcmV2aW91c2x5IGZvdW5kIGluIHRoZSBtYWluIGhlYWRlciAoUFBNIG1hcmtlcikuCgBTdGFydCB0byByZWFkIGoyayBtYWluIGhlYWRlciAoJWxsZCkuCgBCb3R0b20gcG9zaXRpb24gb2YgdGhlIGRlY29kZWQgYXJlYSAocmVnaW9uX3kxPSVkKSBpcyBvdXRzaWRlIHRoZSBpbWFnZSBhcmVhIChZc2l6PSVkKS4KAFVwIHBvc2l0aW9uIG9mIHRoZSBkZWNvZGVkIGFyZWEgKHJlZ2lvbl95MD0lZCkgaXMgb3V0c2lkZSB0aGUgaW1hZ2UgYXJlYSAoWXNpej0lZCkuCgBSaWdodCBwb3NpdGlvbiBvZiB0aGUgZGVjb2RlZCBhcmVhIChyZWdpb25feDE9JWQpIGlzIG91dHNpZGUgdGhlIGltYWdlIGFyZWEgKFhzaXo9JWQpLgoATGVmdCBwb3NpdGlvbiBvZiB0aGUgZGVjb2RlZCBhcmVhIChyZWdpb25feDA9JWQpIGlzIG91dHNpZGUgdGhlIGltYWdlIGFyZWEgKFhzaXo9JWQpLgoAQm90dG9tIHBvc2l0aW9uIG9mIHRoZSBkZWNvZGVkIGFyZWEgKHJlZ2lvbl95MT0lZCkgaXMgb3V0c2lkZSB0aGUgaW1hZ2UgYXJlYSAoWU9zaXo9JWQpLgoAVXAgcG9zaXRpb24gb2YgdGhlIGRlY29kZWQgYXJlYSAocmVnaW9uX3kwPSVkKSBpcyBvdXRzaWRlIHRoZSBpbWFnZSBhcmVhIChZT3Npej0lZCkuCgBSaWdodCBwb3NpdGlvbiBvZiB0aGUgZGVjb2RlZCBhcmVhIChyZWdpb25feDE9JWQpIGlzIG91dHNpZGUgdGhlIGltYWdlIGFyZWEgKFhPc2l6PSVkKS4KAExlZnQgcG9zaXRpb24gb2YgdGhlIGRlY29kZWQgYXJlYSAocmVnaW9uX3gwPSVkKSBpcyBvdXRzaWRlIHRoZSBpbWFnZSBhcmVhIChYT3Npej0lZCkuCgBTaXplIHggb2YgdGhlIGRlY29kZWQgY29tcG9uZW50IGltYWdlIGlzIGluY29ycmVjdCAoY29tcFslZF0udz0lZCkuCgBTaXplIHkgb2YgdGhlIGRlY29kZWQgY29tcG9uZW50IGltYWdlIGlzIGluY29ycmVjdCAoY29tcFslZF0uaD0lZCkuCgBUaWxlIHJlYWQsIGRlY29kZWQgYW5kIHVwZGF0ZWQgaXMgbm90IHRoZSBkZXNpcmVkIG9uZSAoJWQgdnMgJWQpLgoASW52YWxpZCBjb21wb25lbnQgaW5kZXggJWQgKD49ICVkKS4KAG9wal9yZWFkX2hlYWRlcigpIHNob3VsZCBiZSBjYWxsZWQgYmVmb3JlIG9wal9zZXRfZGVjb2RlZF9jb21wb25lbnRzKCkuCgBNZW1vcnkgYWxsb2NhdGlvbiBmYWlsdXJlIGluIG9wal9qcDJfYXBwbHlfcGNscigpLgoAaW1hZ2UtPmNvbXBzWyVkXS5kYXRhID09IE5VTEwgaW4gb3BqX2pwMl9hcHBseV9wY2xyKCkuCgBpbnZhbGlkIGJveCBzaXplICVkICgleCkKAEZhaWwgdG8gcmVhZCB0aGUgY3VycmVudCBtYXJrZXIgc2VnbWVudCAoJSN4KQoARXJyb3Igd2l0aCBTSVogbWFya2VyOiBJSERSIHcoJXUpIGgoJXUpIHZzLiBTSVogdygldSkgaCgldSkKAEVycm9yIHJlYWRpbmcgQ09DIG1hcmtlciAoYmFkIG51bWJlciBvZiBjb21wb25lbnRzKQoASW52YWxpZCBudW1iZXIgb2YgdGlsZXMgOiAldSB4ICV1IChtYXhpbXVtIGZpeGVkIGJ5IGpwZWcyMDAwIG5vcm0gaXMgNjU1MzUgdGlsZXMpCgBJbnZhbGlkIG51bWJlciBvZiBjb21wb25lbnRzIChpaGRyKQoATm90IGVub3VnaCBtZW1vcnkgdG8gaGFuZGxlIGltYWdlIGhlYWRlciAoaWhkcikKAFdyb25nIHZhbHVlcyBmb3I6IHcoJWQpIGgoJWQpIG51bWNvbXBzKCVkKSAoaWhkcikKAEludmFsaWQgdmFsdWVzIGZvciBjb21wID0gJWQgOiBkeD0ldSBkeT0ldSAoc2hvdWxkIGJlIGJldHdlZW4gMSBhbmQgMjU1IGFjY29yZGluZyB0byB0aGUgSlBFRzIwMDAgbm9ybSkKAEJhZCBpbWFnZSBoZWFkZXIgYm94IChiYWQgc2l6ZSkKAEJhZCBDT0xSIGhlYWRlciBib3ggKGJhZCBzaXplKQoAQmFkIEJQQ0MgaGVhZGVyIGJveCAoYmFkIHNpemUpCgBFcnJvciB3aXRoIFNJWiBtYXJrZXI6IG5lZ2F0aXZlIG9yIHplcm8gaW1hZ2Ugc2l6ZSAoJWxsZCB4ICVsbGQpCgBza2lwOiBzZWdtZW50IHRvbyBsb25nICglZCkgd2l0aCBtYXggKCVkKSBmb3IgY29kZWJsb2NrICVkIChwPSVkLCBiPSVkLCByPSVkLCBjPSVkKQoAcmVhZDogc2VnbWVudCB0b28gbG9uZyAoJWQpIHdpdGggbWF4ICglZCkgZm9yIGNvZGVibG9jayAlZCAocD0lZCwgYj0lZCwgcj0lZCwgYz0lZCkKAERlc3BpdGUgSlAyIEJQQyE9MjU1LCBwcmVjaXNpb24gYW5kL29yIHNnbmQgdmFsdWVzIGZvciBjb21wWyVkXSBpcyBkaWZmZXJlbnQgdGhhbiBjb21wWzBdOgogICAgICAgIFswXSBwcmVjKCVkKSBzZ25kKCVkKSBbJWRdIHByZWMoJWQpIHNnbmQoJWQpCgBiYWQgY29tcG9uZW50IG51bWJlciBpbiBSR04gKCVkIHdoZW4gdGhlcmUgYXJlIG9ubHkgJWQpCgBFcnJvciB3aXRoIFNJWiBtYXJrZXI6IG51bWJlciBvZiBjb21wb25lbnQgaXMgbm90IGNvbXBhdGlibGUgd2l0aCB0aGUgcmVtYWluaW5nIG51bWJlciBvZiBwYXJhbWV0ZXJzICggJWQgdnMgJWQpCgBFcnJvciB3aXRoIFNJWiBtYXJrZXI6IGludmFsaWQgdGlsZSBzaXplICh0ZHg6ICVkLCB0ZHk6ICVkKQoAQmFkIENPTFIgaGVhZGVyIGJveCAoYmFkIHNpemU6ICVkKQoAQmFkIENPTFIgaGVhZGVyIGJveCAoQ0lFTGFiLCBiYWQgc2l6ZTogJWQpCgBQVEVSTSBjaGVjayBmYWlsdXJlOiAlZCByZW1haW5pbmcgYnl0ZXMgaW4gY29kZSBibG9jayAoJWQgdXNlZCAvICVkKQoATWFsZm9ybWVkIEhUIGNvZGVibG9jay4gT25lIG9mIHRoZSBmb2xsb3dpbmcgY29uZGl0aW9uIGlzIG5vdCBtZXQ6IDIgPD0gU2N1cCA8PSBtaW4oTGN1cCwgNDA3OSkKAEludmFsaWQgdmFsdWVzIGZvciBjb21wID0gJWQgOiBwcmVjPSV1IChzaG91bGQgYmUgYmV0d2VlbiAxIGFuZCAzOCBhY2NvcmRpbmcgdG8gdGhlIEpQRUcyMDAwIG5vcm0uIE9wZW5KcGVnIG9ubHkgc3VwcG9ydHMgdXAgdG8gMzEpCgBJbnZhbGlkIGJpdCBudW1iZXIgJWQgaW4gb3BqX3QyX3JlYWRfcGFja2V0X2hlYWRlcigpCgBTdHJlYW0gZXJyb3IhCgBFcnJvciBvbiB3cml0aW5nIHN0cmVhbSEKAFN0cmVhbSByZWFjaGVkIGl0cyBlbmQgIQoARXhwZWN0ZWQgYSBTT0MgbWFya2VyIAoASW52YWxpZCBib3ggc2l6ZSAlZCBmb3IgYm94ICclYyVjJWMlYycuIE5lZWQgJWQgYnl0ZXMsICVkIGJ5dGVzIHJlbWFpbmluZyAKAE1hbGZvcm1lZCBIVCBjb2RlYmxvY2suIERlY29kaW5nIHRoaXMgY29kZWJsb2NrIGlzIHN0b3BwZWQuIFVfcSBpcyBsYXJnZXIgdGhhbiB6ZXJvIGJpdHBsYW5lcyArIDEgCgBNYWxmb3JtZWQgSFQgY29kZWJsb2NrLiBEZWNvZGluZyB0aGlzIGNvZGVibG9jayBpcyBzdG9wcGVkLiBVX3EgaXNsYXJnZXIgdGhhbiBiaXRwbGFuZXMgKyAxIAoAQ09MUiBCT1ggbWV0aCB2YWx1ZSBpcyBub3QgYSByZWd1bGFyIHZhbHVlICglZCksIHNvIHdlIHdpbGwgaWdub3JlIHRoZSBlbnRpcmUgQ29sb3VyIFNwZWNpZmljYXRpb24gYm94LiAKAFdoaWxlIHJlYWRpbmcgQ0NQX1FOVFNUWSBlbGVtZW50IGluc2lkZSBRQ0Qgb3IgUUNDIG1hcmtlciBzZWdtZW50LCBudW1iZXIgb2Ygc3ViYmFuZHMgKCVkKSBpcyBncmVhdGVyIHRvIE9QSl9KMktfTUFYQkFORFMgKCVkKS4gU28gd2UgbGltaXQgdGhlIG51bWJlciBvZiBlbGVtZW50cyBzdG9yZWQgdG8gT1BKX0oyS19NQVhCQU5EUyAoJWQpIGFuZCBza2lwIHRoZSByZXN0LiAKAEpQMiBJSERSIGJveDogY29tcHJlc3Npb24gdHlwZSBpbmRpY2F0ZSB0aGF0IHRoZSBmaWxlIGlzIG5vdCBhIGNvbmZvcm1pbmcgSlAyIGZpbGUgKCVkKSAKAFRpbGUgaW5kZXggcHJvdmlkZWQgYnkgdGhlIHVzZXIgaXMgaW5jb3JyZWN0ICVkIChtYXggPSAlZCkgCgBFcnJvciBkZWNvZGluZyBjb21wb25lbnQgJWQuClRoZSBudW1iZXIgb2YgcmVzb2x1dGlvbnMgdG8gcmVtb3ZlICglZCkgaXMgZ3JlYXRlciBvciBlcXVhbCB0aGFuIHRoZSBudW1iZXIgb2YgcmVzb2x1dGlvbnMgb2YgdGhpcyBjb21wb25lbnQgKCVkKQpNb2RpZnkgdGhlIGNwX3JlZHVjZSBwYXJhbWV0ZXIuCgoASW1hZ2UgZGF0YSBoYXMgYmVlbiB1cGRhdGVkIHdpdGggdGlsZSAlZC4KCgBBoP0AC4AgIwClAEMAZgCDAO6oFADf2CMAvhBDAP/1gwB+IFUAX1EjADUAQwBORIMAzsQUAM/MIwD+4kMA/5mDAJYAxQA/MSMApQBDAF5EgwDOyBQA3xEjAP70QwD//IMAngBVAHcAIwA1AEMA//GDAK6IFAC3ACMA/vhDAO/kgwCOiMUAHxEjAKUAQwBmAIMA7qgUAN9UIwC+EEMA7yKDAH4gVQB/IiMANQBDAE5EgwDOxBQAvxEjAP7iQwD3AIMAlgDFAD8iIwClAEMAXkSDAM7IFADXACMA/vRDAP+6gwCeAFUAbwAjADUAQwD/5oMArogUAK+iIwD++EMA5wCDAI6IxQAvIgIAxQCEAH4gAgDOxCQA9wACAP6iRABWAAIAngAUANcAAgC+EIQAZgACAK6IJADfEQIA7qhEADYAAgCOiBQAHxECAMUAhABuAAIAzogkAP+IAgD+uEQATkQCAJYAFAC3AAIA/uSEAF5EAgCmACQA5wACAN5URAAuIgIAPgAUAHcAAgDFAIQAfiACAM7EJAD/8QIA/qJEAFYAAgCeABQAvxECAL4QhABmAAIArogkAO8iAgDuqEQANgACAI6IFAB/IgIAxQCEAG4AAgDOiCQA7+QCAP64RABORAIAlgAUAK+iAgD+5IQAXkQCAKYAJADf2AIA3lREAC4iAgA+ABQAX1ECAFUAhABmAAIA3ogkAP8yAgD+EUQATkQCAK4AFAC3AAIAfjGEAF5RAgDGACQA1wACAO4gRAAeEQIAngAUAHcAAgBVAIQAXlQCAM5EJADnAAIA/vFEADYAAgCmABQAX1UCAP50hAA+EQIAviAkAH90AgDexEQA//gCAJYAFAAvIgIAVQCEAGYAAgDeiCQA9wACAP4RRABORAIArgAUAI+IAgB+MYQAXlECAMYAJADPyAIA7iBEAB4RAgCeABQAbwACAFUAhABeVAIAzkQkAN/RAgD+8UQANgACAKYAFAB/IgIA/nSEAD4RAgC+ICQAvyICAN7ERADvIgIAlgAUAD8yAwDe1P30//wUAD4RVQCPiAMAvjKFAOcAJQBeUf6qf3IDAM5E/fjvRBQAfmRFAK+iAwCmAF1V35n98TYA/vVvYgMA3tH99P/mFAB+cVUAv7EDAK6IhQDf1SUATkT+8n9mAwDGAP347+IUAF5URQCfEQMAlgBdVc/I/fEeEe7IZwADAN7U/fT/8xQAPhFVAL8RAwC+MoUA39glAF5R/qovIgMAzkT9+PcAFAB+ZEUAn5gDAKYAXVXXAP3xNgD+9W9EAwDe0f30/7kUAH5xVQC3AAMAroiFAN/cJQBORP7ydwADAMYA/fjv5BQAXlRFAH9zAwCWAF1Vv7j98R4R7sg/MgIApQCEAH5AAgDeECQA3xECAP5yRABWAAIArqgUAL+yAgCWAIQAZgACAMYAJADnAAIA7shEAC4iAgCOiBQAdwACAKUAhABuAAIAzogkAPcAAgD+kUQANgACAK6iFACvqgIA/riEAF4AAgC+ACQAz8QCAO5ERAD/9AIAPiIUAB8RAgClAIQAfkACAN4QJAD/mQIA/nJEAFYAAgCuqBQAtwACAJYAhABmAAIAxgAkANcAAgDuyEQALiICAI6IFABPRAIApQCEAG4AAgDOiCQA7+ICAP6RRAA2AAIArqIUAH9EAgD+uIQAXgACAL4AJACfAAIA7kREAP92AgA+IhQAPzEDAMYAhQD/2f3yfmT+8b+ZAwCuoiUA72b99FYA7uJ/cwMAvphFAPcA/fhmAP52n4gDAI6IFQDf1aUALiLemE9EAwC+soUA//z98m4ilgC3AAMArqolAN/R/fQ2AN7Ub2QDAK6oRQDv6v34XkTu6H9xAwA+MhUAz8SlAP/6zog/MQMAxgCFAP93/fJ+ZP7xv7MDAK6iJQDnAP30VgDu4ncAAwC+mEUA7+T9+GYA/nZ/ZgMAjogVANcApQAuIt6YPzMDAL6yhQD/df3ybiKWAJ+RAwCuqiUA35n99DYA3tRfUQMArqhFAO/s/fheRO7of3IDAD4yFQC/saUA//POiB8RAwDeVP3yHhEUAH5k/vjPzAMAvpFFAO8iJQAuIv7zj4gDAMYAhQD3ABQAXhH+/K+oAwCmADUA38j98T4x/mZvZAMAzsj98v/1FABmAP70v7oDAK4iRQDnACUAPjL+6n9zAwC+soUA31UUAFYAfnGfEQMAlgA1AM/E/fE+M+7oT0QDAN5U/fIeERQAfmT++L+ZAwC+kUUA7+IlAC4i/vN/ZgMAxgCFAO/kFABeEf78n5gDAKYANQDXAP3xPjH+Zm8iAwDOyP3y/7kUAGYA/vS3AAMAriJFAN/RJQA+Mv7qdwADAL6yhQDv7BQAVgB+cX9yAwCWADUAv7j98T4z7uhfVPzx3tH9+tcA/PgWAP3/f3T89H5x/fO/s/zy7+ru6E9E/PGuIgUAv7j8+PcA/vx3APz0XhH99X91/PLf2O7iPzP88b6y/frPiPz4//v9/39z/PRuAP3ztwD88u9m/vk/MfzxngAFAL+6/Pj//f72ZwD89CYA/fWPiPzy39ze1C8i/PHe0f36z8T8+BYA/f9/cvz0fnH987+Z/PLv7O7oRwD88a4iBQCnAPz4//f+/FcA/PReEf31lwD88t/V7uI3APzxvrL9+scA/Pj//v3/f2b89G4A/fOvqPzy5wD++T8y/PGeAAUAv7H8+O/k/vZfVPz0JgD99YcA/PLfmd7UHxETAGUAQwDeAIMAjYgjAE5EEwClAEMAroiDADUAIwDXABMAxQBDAJ4AgwBVACMALiITAJUAQwB+AIMA/hAjAHcAEwBlAEMAzoiDAI2IIwAeERMApQBDAF4AgwA1ACMA5wATAMUAQwC+AIMAVQAjAP8REwCVAEMAPgCDAO5AIwCvohMAZQBDAN4AgwCNiCMATkQTAKUAQwCuiIMANQAjAO9EEwDFAEMAngCDAFUAIwAuIhMAlQBDAH4AgwD+ECMAtwATAGUAQwDOiIMAjYgjAB4REwClAEMAXgCDADUAIwDPxBMAxQBDAL4AgwBVACMA9wATAJUAQwA+AIMA7kAjAG8AAQCEAAEAVgABABQAAQDXAAEAJAABAJYAAQBFAAEAdwABAIQAAQDGAAEAFAABAI+IAQAkAAEA9wABADUAAQAvIgEAhAABAP5AAQAUAAEAtwABACQAAQC/AAEARQABAGcAAQCEAAEApgABABQAAQBPRAEAJAABAOcAAQA1AAEAPxEBAIQAAQBWAAEAFAABAM8AAQAkAAEAlgABAEUAAQBvAAEAhAABAMYAAQAUAAEAnwABACQAAQDvAAEANQABAD8yAQCEAAEA/kABABQAAQCvAAEAJAABAP9EAQBFAAEAXwABAIQAAQCmAAEAFAABAH8AAQAkAAEA3wABADUAAQAfEQEAJAABAFYAAQCFAAEAvwABABQAAQD3AAEAxgABAHcAAQAkAAEA//gBAEUAAQB/AAEAFAABAN8AAQCmAAEAPzEBACQAAQAuIgEAhQABALcAAQAUAAEA70QBAK6iAQBnAAEAJAABAP9RAQBFAAEAlwABABQAAQDPAAEANgABAD8iAQAkAAEAVgABAIUAAQC/sgEAFAABAO9AAQDGAAEAbwABACQAAQD/cgEARQABAJ8AAQAUAAEA1wABAKYAAQBPRAEAJAABAC4iAQCFAAEAr6gBABQAAQDnAAEArqIBAF8AAQAkAAEA/0QBAEUAAQCPiAEAFAABAK+qAQA2AAEAHxECAP74JABWAAIAtgCFAP9mAgDOABQAHhECAJYANQCvqAIA9gAkAD4xAgCmAEUAv7MCAL6yFAD/9QIAZgB+UV9UAgD+8iQALiICAK4ihQDvRAIAxgAUAP/0AgB2ADUAf0QCAN5AJAA+MgIAngBFANcAAgC+iBQA//oCAF4R/vFPRAIA/vgkAFYAAgC2AIUA78gCAM4AFAAeEQIAlgA1AI+IAgD2ACQAPjECAKYARQDfRAIAvrIUAP+oAgBmAH5RbwACAP7yJAAuIgIAriKFAOcAAgDGABQA7+ICAHYANQB/cgIA3kAkAD4yAgCeAEUAv7ECAL6IFAD/cwIAXhH+8T8zAQCEAAEA7iABAMUAAQDPxAEARAABAP8yAQAVAAEAj4gBAIQAAQBmAAEAJQABAK8AAQBEAAEA7yIBAKYAAQBfAAEAhAABAE5EAQDFAAEAz8wBAEQAAQD3AAEAFQABAG8AAQCEAAEAVgABACUAAQCfAAEARAABAN8AAQD+MAEALyIBAIQAAQDuIAEAxQABAM/IAQBEAAEA/xEBABUAAQB3AAEAhAABAGYAAQAlAAEAfwABAEQAAQDnAAEApgABADcAAQCEAAEATkQBAMUAAQC3AAEARAABAL8AAQAVAAEAPwABAIQAAQBWAAEAJQABAJcAAQBEAAEA1wABAP4wAQAfEQIA7qhEAI6IAgDWAMUA//MCAP78JQA+AAIAtgBVAN/YAgD++EQAZgACAH4ghQD/mQIA5gD1ADYAAgCmABUAnwACAP7yRAB2AAIAzkTFAP92AgD+8SUATkQCAK4AVQDPyAIA/vREAF5EAgC+EIUA7+QCAN5U9QAeEQIAlgAVAC8iAgDuqEQAjogCANYAxQD/+gIA/vwlAD4AAgC2AFUAvxECAP74RABmAAIAfiCFAO8iAgDmAPUANgACAKYAFQB/IgIA/vJEAHYAAgDORMUA/9UCAP7xJQBORAIArgBVAG8AAgD+9EQAXkQCAL4QhQDfEQIA3lT1AB4RAgCWABUAX1EDAPYAFAAeEUQAjoilAN/UAwCuolUA/3YkAD4itgCvqgMA5gAUAP/1RABmAIUAz8wDAJ4AxQDvRCQANgD++H8xAwDu6BQA//FEAHYApQDPxAMAfiJVAN/RJABORP70X1EDANYAFADv4kQAXkSFAL8iAwCWAMUA38gkAC4i/vJvIgMA9gAUAB4RRACOiKUAv7EDAK6iVQD/MyQAPiK2AK+oAwDmABQA/7lEAGYAhQC/qAMAngDFAO/kJAA2AP74b2QDAO7oFAD//EQAdgClAM/IAwB+IlUA7+okAE5E/vR/dAMA1gAUAP/6RABeRIUAv7IDAJYAxQDfRCQALiL+8j8x8wD++v3xNgAEAL4ydQDfEfMA3lT98u/k1QB+cf78f3PzAP7z/fgeEQQAlgBVAL+x8wDOALUA39j99GYA/rlfVPMA/nb98SYABACmAHUAnwDzAK4A/fL/99UARgD+9X908wDmAP34FgAEAIYAVQCPiPMAxgC1AO/i/fReEe6oPxHzAP76/fE2AAQAvjJ1AN/R8wDeVP3y//vVAH5x/vx/RPMA/vP9+B4RBACWAFUAf3LzAM4AtQDvIv30ZgD+uU9E8wD+dv3xJgAEAKYAdQC/EfMArgD98v//1QBGAP71PzLzAOYA/fgWAAQAhgBVAG8A8wDGALUAv7j99F4R7qgvIgBBrJ0BC6QeAQAAAAEAAAABAAAAAgAAAAIAAAACAAAAAwAAAAMAAAAEAAAABQAAALchQiFnIUIhERERETMzMzN3d3d3AAAAAAAAAAABVgAAAAAAABBPAAAgTwAAAVYAAAEAAAAgTwAAEE8AAAE0AAAAAAAAME8AALBPAAABNAAAAQAAAEBPAADATwAAARgAAAAAAABQTwAAEFAAAAEYAAABAAAAYE8AACBQAADBCgAAAAAAAHBPAABwUAAAwQoAAAEAAACATwAAgFAAACEFAAAAAAAAkE8AAJBSAAAhBQAAAQAAAKBPAACgUgAAIQIAAAAAAACwUwAAEFMAACECAAABAAAAwFMAACBTAAABVgAAAAAAANBPAADATwAAAVYAAAEAAADgTwAAsE8AAAFUAAAAAAAA8E8AALBQAAABVAAAAQAAAABQAADAUAAAAUgAAAAAAAAQUAAAsFAAAAFIAAABAAAAIFAAAMBQAAABOAAAAAAAADBQAACwUAAAATgAAAEAAABAUAAAwFAAAAEwAAAAAAAAUFAAABBRAAABMAAAAQAAAGBQAAAgUQAAASQAAAAAAABwUAAAMFEAAAEkAAABAAAAgFAAAEBRAAABHAAAAAAAAJBQAABwUQAAARwAAAEAAACgUAAAgFEAAAEWAAAAAAAAkFIAAJBRAAABFgAAAQAAAKBSAACgUQAAAVYAAAAAAADQUAAAwFAAAAFWAAABAAAA4FAAALBQAAABVAAAAAAAAPBQAACwUAAAAVQAAAEAAAAAUQAAwFAAAAFRAAAAAAAAEFEAANBQAAABUQAAAQAAACBRAADgUAAAAUgAAAAAAAAwUQAA8FAAAAFIAAABAAAAQFEAAABRAAABOAAAAAAAAFBRAAAQUQAAATgAAAEAAABgUQAAIFEAAAE0AAAAAAAAcFEAADBRAAABNAAAAQAAAIBRAABAUQAAATAAAAAAAACQUQAAUFEAAAEwAAABAAAAoFEAAGBRAAABKAAAAAAAALBRAABQUQAAASgAAAEAAADAUQAAYFEAAAEkAAAAAAAA0FEAAHBRAAABJAAAAQAAAOBRAACAUQAAASIAAAAAAADwUQAAkFEAAAEiAAABAAAAAFIAAKBRAAABHAAAAAAAABBSAACwUQAAARwAAAEAAAAgUgAAwFEAAAEYAAAAAAAAMFIAANBRAAABGAAAAQAAAEBSAADgUQAAARYAAAAAAABQUgAA8FEAAAEWAAABAAAAYFIAAABSAAABFAAAAAAAAHBSAAAQUgAAARQAAAEAAACAUgAAIFIAAAESAAAAAAAAkFIAADBSAAABEgAAAQAAAKBSAABAUgAAAREAAAAAAACwUgAAUFIAAAERAAABAAAAwFIAAGBSAADBCgAAAAAAANBSAABwUgAAwQoAAAEAAADgUgAAgFIAAMEJAAAAAAAA8FIAAJBSAADBCQAAAQAAAABTAACgUgAAoQgAAAAAAAAQUwAAsFIAAKEIAAABAAAAIFMAAMBSAAAhBQAAAAAAADBTAADQUgAAIQUAAAEAAABAUwAA4FIAAEEEAAAAAAAAUFMAAPBSAABBBAAAAQAAAGBTAAAAUwAAoQIAAAAAAABwUwAAEFMAAKECAAABAAAAgFMAACBTAAAhAgAAAAAAAJBTAAAwUwAAIQIAAAEAAACgUwAAQFMAAEEBAAAAAAAAsFMAAFBTAABBAQAAAQAAAMBTAABgUwAAEQEAAAAAAADQUwAAcFMAABEBAAABAAAA4FMAAIBTAACFAAAAAAAAAPBTAACQUwAAhQAAAAEAAAAAVAAAoFMAAEkAAAAAAAAAEFQAALBTAABJAAAAAQAAACBUAADAUwAAJQAAAAAAAAAwVAAA0FMAACUAAAABAAAAQFQAAOBTAAAVAAAAAAAAAFBUAADwUwAAFQAAAAEAAABgVAAAAFQAAAkAAAAAAAAAcFQAABBUAAAJAAAAAQAAAIBUAAAgVAAABQAAAAAAAACQVAAAMFQAAAUAAAABAAAAoFQAAEBUAAABAAAAAAAAAJBUAABQVAAAAQAAAAEAAACgVAAAYFQAAAFWAAAAAAAAsFQAALBUAAABVgAAAQAAAMBUAADAVAAAAAEDAwECAwMFBgcHBgYHBwABAwMBAgMDBQYHBwYGBwcFBgcHBgYHBwgICAgICAgIBQYHBwYGBwcICAgICAgICAECAwMCAgMDBgYHBwYGBwcBAgMDAgIDAwYGBwcGBgcHBgYHBwYGBwcICAgICAgICAYGBwcGBgcHCAgICAgICAgDAwQEAwMEBAcHBwcHBwcHAwMEBAMDBAQHBwcHBwcHBwcHBwcHBwcHCAgICAgICAgHBwcHBwcHBwgICAgICAgIAwMEBAMDBAQHBwcHBwcHBwMDBAQDAwQEBwcHBwcHBwcHBwcHBwcHBwgICAgICAgIBwcHBwcHBwcICAgICAgICAECAwMCAgMDBgYHBwYGBwcBAgMDAgIDAwYGBwcGBgcHBgYHBwYGBwcICAgICAgICAYGBwcGBgcHCAgICAgICAgCAgMDAgIDAwYGBwcGBgcHAgIDAwICAwMGBgcHBgYHBwYGBwcGBgcHCAgICAgICAgGBgcHBgYHBwgICAgICAgIAwMEBAMDBAQHBwcHBwcHBwMDBAQDAwQEBwcHBwcHBwcHBwcHBwcHBwgICAgICAgIBwcHBwcHBwcICAgICAgICAMDBAQDAwQEBwcHBwcHBwcDAwQEAwMEBAcHBwcHBwcHBwcHBwcHBwcICAgICAgICAcHBwcHBwcHCAgICAgICAgAAQUGAQIGBgMDBwcDAwcHAAEFBgECBgYDAwcHAwMHBwMDBwcDAwcHBAQHBwQEBwcDAwcHAwMHBwQEBwcEBAcHAQIGBgICBgYDAwcHAwMHBwECBgYCAgYGAwMHBwMDBwcDAwcHAwMHBwQEBwcEBAcHAwMHBwMDBwcEBAcHBAQHBwUGCAgGBggIBwcICAcHCAgFBggIBgYICAcHCAgHBwgIBwcICAcHCAgHBwgIBwcICAcHCAgHBwgIBwcICAcHCAgGBggIBgYICAcHCAgHBwgIBgYICAYGCAgHBwgIBwcICAcHCAgHBwgIBwcICAcHCAgHBwgIBwcICAcHCAgHBwgIAQIGBgICBgYDAwcHAwMHBwECBgYCAgYGAwMHBwMDBwcDAwcHAwMHBwQEBwcEBAcHAwMHBwMDBwcEBAcHBAQHBwICBgYCAgYGAwMHBwMDBwcCAgYGAgIGBgMDBwcDAwcHAwMHBwMDBwcEBAcHBAQHBwMDBwcDAwcHBAQHBwQEBwcGBggIBgYICAcHCAgHBwgIBgYICAYGCAgHBwgIBwcICAcHCAgHBwgIBwcICAcHCAgHBwgIBwcICAcHCAgHBwgIBgYICAYGCAgHBwgIBwcICAYGCAgGBggIBwcICAcHCAgHBwgIBwcICAcHCAgHBwgIBwcICAcHCAgHBwgIBwcICAABAwMBAgMDBQYHBwYGBwcAAQMDAQIDAwUGBwcGBgcHBQYHBwYGBwcICAgICAgICAUGBwcGBgcHCAgICAgICAgBAgMDAgIDAwYGBwcGBgcHAQIDAwICAwMGBgcHBgYHBwYGBwcGBgcHCAgICAgICAgGBgcHBgYHBwgICAgICAgIAwMEBAMDBAQHBwcHBwcHBwMDBAQDAwQEBwcHBwcHBwcHBwcHBwcHBwgICAgICAgIBwcHBwcHBwcICAgICAgICAMDBAQDAwQEBwcHBwcHBwcDAwQEAwMEBAcHBwcHBwcHBwcHBwcHBwcICAgICAgICAcHBwcHBwcHCAgICAgICAgBAgMDAgIDAwYGBwcGBgcHAQIDAwICAwMGBgcHBgYHBwYGBwcGBgcHCAgICAgICAgGBgcHBgYHBwgICAgICAgIAgIDAwICAwMGBgcHBgYHBwICAwMCAgMDBgYHBwYGBwcGBgcHBgYHBwgICAgICAgIBgYHBwYGBwcICAgICAgICAMDBAQDAwQEBwcHBwcHBwcDAwQEAwMEBAcHBwcHBwcHBwcHBwcHBwcICAgICAgICAcHBwcHBwcHCAgICAgICAgDAwQEAwMEBAcHBwcHBwcHAwMEBAMDBAQHBwcHBwcHBwcHBwcHBwcHCAgICAgICAgHBwcHBwcHBwgICAgICAgIAAMBBAMGBAcBBAIFBAcFBwADAQQDBgQHAQQCBQQHBQcBBAIFBAcFBwIFAgUFBwUHAQQCBQQHBQcCBQIFBQcFBwMGBAcGCAcIBAcFBwcIBwgDBgQHBggHCAQHBQcHCAcIBAcFBwcIBwgFBwUHBwgHCAQHBQcHCAcIBQcFBwcIBwgBBAIFBAcFBwIFAgUFBwUHAQQCBQQHBQcCBQIFBQcFBwIFAgUFBwUHAgUCBQUHBQcCBQIFBQcFBwIFAgUFBwUHBAcFBwcIBwgFBwUHBwgHCAQHBQcHCAcIBQcFBwcIBwgFBwUHBwgHCAUHBQcHCAcIBQcFBwcIBwgFBwUHBwgHCAMGBAcGCAcIBAcFBwcIBwgDBgQHBggHCAQHBQcHCAcIBAcFBwcIBwgFBwUHBwgHCAQHBQcHCAcIBQcFBwcIBwgGCAcICAgICAcIBwgICAgIBggHCAgICAgHCAcICAgICAcIBwgICAgIBwgHCAgICAgHCAcICAgICAcIBwgICAgIBAcFBwcIBwgFBwUHBwgHCAQHBQcHCAcIBQcFBwcIBwgFBwUHBwgHCAUHBQcHCAcIBQcFBwcIBwgFBwUHBwgHCAcIBwgICAgIBwgHCAgICAgHCAcICAgICAcIBwgICAgIBwgHCAgICAgHCAcICAgICAcIBwgICAgIBwgHCAgICAgJCQoKCQkKCgwMDQsMDA0LCQkKCgkJCgoMDAsNDAwLDQwMDQ0MDAsLDAkNCgkMCgsMDAsLDAwNDQwJCwoJDAoNCQkKCgkJCgoMDA0LDAwNCwkJCgoJCQoKDAwLDQwMCw0MDA0NDAwLCwwJDQoJDAoLDAwLCwwMDQ0MCQsKCQwKDQoKCgoKCgoKDQsNCw0LDQsKCgkJCgoJCQ0LDAwNCwwMDQ0NDQsLCwsNCg0KCgsKCw0NDAwLCwwMDQoMCQoLCQwKCgkJCgoJCQsNDAwLDQwMCgoKCgoKCgoLDQsNCw0LDQsLDAwNDQwMCwoMCQoNCQwLCwsLDQ0NDQsKCwoKDQoNAEHZuwELNwEAAQABAAEAAAEBAAABAQABAAEAAQABAAAAAAEBAQEAAAAAAAEAAQAAAAABAQEBAAAAAQABAQEAQZm8AQs3AQABAAEAAQAAAQEAAAEBAAEAAQABAAEAAAAAAQEBAQAAAAAAAQABAAAAAAEBAQEAAAABAAEBAQBB2bwBCwcBAAEAAQABAEHpvAELlQIBAAEAAQABAAAAAAEBAQEAAAAAAAEAAQAAAAABAQEBAAAAAAABAAEBAQAAAQEAAAABAAEAAQABAQEBAQEBAQEAAQABAAEAAQAAAAABAQEBAAEAAAEBAAEAAAAAAQEBAQABAAEBAQEBAgAAAAQAAAAEAAAACAAAAJD/AAAMAAAAGAAAAFL/AAAUAAAAGQAAAFP/AAAUAAAAGgAAAF7/AAAUAAAAGwAAAFz/AAAUAAAAHAAAAF3/AAAUAAAAHQAAAF//AAAUAAAAHgAAAFH/AAACAAAAHwAAAFX/AAAEAAAAIAAAAFf/AAAEAAAAIQAAAFj/AAAQAAAAIgAAAGD/AAAEAAAAIwAAAGH/AAAQAAAAJAAAAJH/AEGIvwELZWP/AAAEAAAAJQAAAGT/AAAUAAAAJgAAAHT/AAAUAAAAJwAAAHj/AAAEAAAAKAAAAFD/AAAEAAAAKQAAAFn/AAAEAAAAKgAAAHX/AAAUAAAAKwAAAHf/AAAUAAAALAAAAAAAAAAUAEGAwAELNS0AAAAuAAAALwAAADAAAAAxAAAAMgAAADMAAAA0AAAAICBQajYAAABweXRmNwAAAGgycGo4AEHAwAELMnJkaGk5AAAAcmxvYzoAAABjY3BiOwAAAHJsY3A8AAAAcGFtYz0AAABmZWRjPgAAAPhiAEGAwQELQRkACwAZGRkAAAAABQAAAAAAAAkAAAAACwAAAAAAAAAAGQAKChkZGQMKBwABAAkLGAAACQYLAAALAAYZAAAAGRkZAEHRwQELIQ4AAAAAAAAAABkACw0ZGRkADQAAAgAJDgAAAAkADgAADgBBi8IBCwEMAEGXwgELFRMAAAAAEwAAAAAJDAAAAAAADAAADABBxcIBCwEQAEHRwgELFQ8AAAAEDwAAAAAJEAAAAAAAEAAAEABB/8IBCwESAEGLwwELHhEAAAAAEQAAAAAJEgAAAAAAEgAAEgAAGgAAABoaGgBBwsMBCw4aAAAAGhoaAAAAAAAACQBB88MBCwEUAEH/wwELFRcAAAAAFwAAAAAJFAAAAAAAFAAAFABBrcQBCwEWAEG5xAELJxUAAAAAFQAAAAAJFgAAAAAAFgAAFgAAMDEyMzQ1Njc4OUFCQ0RFRgBB4MQBCwmQbAEAAAAAAAUAQfTEAQsBaQBBjMUBCwpqAAAAawAAAHhoAEGkxQELAQIAQbTFAQsI//////////8AQfjFAQsBBQBBhMYBCwFsAEGcxgELDmoAAABtAAAAiGgAAAAEAEG0xgELAQEAQcTGAQsF/////wo=");\nda=k(M,da);return S(da[0])}();m._malloc=qa.r;m._free=qa.s;m._jp2_decode=qa.u;var va;F=function da(){va||l();va||(F=da)};if(m.preInit)for("function"==typeof m.preInit&&(m.preInit=[m.preInit]);0<m.preInit.length;)m.preInit.pop()();l();return m}}(),In=function(a){function c(b){return a.call(this,b,"JpxError")||this}Pp(c,a);return c}(tc),pg=function(){function a(){}a.decode=function(c,b){b||(b={});this.__module||(this.__module=Pr({warn:T}));c=this.__module.decode(c,b);if("string"===typeof c)throw new In(c);\nreturn c};a.cleanup=function(){this.__module=null};a.parseImageProperties=function(c){for(var b=c.getByte();0<=b;){var d=b;b=c.getByte();if(65361===(d<<8|b)){c.skip(4);b=c.getInt32()>>>0;d=c.getInt32()>>>0;var e=c.getInt32()>>>0,g=c.getInt32()>>>0;c.skip(16);c=c.getUint16();return{width:b-e,height:d-g,bitsPerComponent:8,componentsCount:c}}}throw new In("No size marker found in JPX stream");};return a}();pg.__module=null;var Qr=function(a){function c(d,e,g){var f=a.call(this,e)||this;f.stream=d;f.dict=\nd.dict;f.maybeLength=e;f.params=g;return f}Rp(c,a);var b=c.prototype;b.ensureBuffer=function(){};b.readBlock=function(d){this.decodeImage(null,d)};b.decodeImage=function(d,e){if(this.eof)return this.buffer;d||(d=this.bytes);this.buffer=pg.decode(d,e);this.bufferLength=this.buffer.length;this.eof=!0;return this.buffer};return Qp(c,[{key:"bytes",get:function(){return Fa(this,"bytes",this.stream.getBytes(this.maybeLength))}},{key:"canAsyncDecodeImageFromBuffer",get:function(){return this.stream.isAsync}}])}(uc),\nJn=function(a){function c(d,e,g){e=a.call(this,e)||this;e.str=d;e.dict=d.dict;e.cachedData=0;e.bitsCached=0;d={earlyChange:g,codeLength:9,nextCode:258,dictionaryValues:new Uint8Array(4096),dictionaryLengths:new Uint16Array(4096),dictionaryPrevCodes:new Uint16Array(4096),currentSequence:new Uint8Array(4096),currentSequenceLength:0};for(g=0;256>g;++g)d.dictionaryValues[g]=g,d.dictionaryLengths[g]=1;e.lzwState=d;return e}Sp(c,a);var b=c.prototype;b.readBits=function(d){for(var e=this.bitsCached,g=this.cachedData;e<\nd;){var f=this.str.getByte();if(-1===f)return this.eof=!0,null;g=g<<8|f;e+=8}this.bitsCached=e-=d;this.cachedData=g;this.lastCode=null;return g>>>e&(1<<d)-1};b.readBlock=function(){var d=1024,e,g,f=this.lzwState;if(f){var h=f.earlyChange,k=f.nextCode,l=f.dictionaryValues,m=f.dictionaryLengths,n=f.dictionaryPrevCodes,p=f.codeLength,q=f.prevCode,r=f.currentSequence,t=f.currentSequenceLength,v=0,w=this.bufferLength,y=this.ensureBuffer(this.bufferLength+d);for(e=0;512>e;e++){var x=this.readBits(p),z=\n0<t;if(256>x)r[0]=x,t=1;else if(258<=x)if(x<k){t=m[x];var A=t-1;for(g=x;0<=A;A--)r[A]=l[g],g=n[g]}else r[t++]=r[0];else if(256===x){p=9;k=258;t=0;continue}else{this.eof=!0;delete this.lzwState;break}z&&(n[k]=q,m[k]=m[q]+1,l[k]=r[0],k++,p=k+h&k+h-1?p:Math.min(Math.log(k+h)/.6931471805599453+1,12)|0);q=x;v+=t;if(d<v){do d+=512;while(d<v);y=this.ensureBuffer(this.bufferLength+d)}for(A=0;A<t;A++)y[w++]=r[A]}f.nextCode=k;f.codeLength=p;f.prevCode=q;f.currentSequenceLength=t;this.bufferLength=w}};return c}(uc),\nKn=function(a){function c(d,e,g){e=a.call(this,e)||this;if(!(g instanceof ca))return d||Dh(e);var f=e.predictor=g.get("Predictor")||1;if(1>=f)return d||Dh(e);if(2!==f&&(10>f||15<f))throw new oa("Unsupported predictor: "+f);e.readBlock=2===f?e.readBlockTiff:e.readBlockPng;e.str=d;e.dict=d.dict;d=e.colors=g.get("Colors")||1;f=e.bits=g.get("BPC","BitsPerComponent")||8;g=e.columns=g.get("Columns")||1;e.pixBytes=d*f+7>>3;e.rowBytes=g*d*f+7>>3;return e||Dh(e)}Tp(c,a);var b=c.prototype;b.readBlockTiff=function(){var d=\nthis.rowBytes,e=this.bufferLength,g=this.ensureBuffer(e+d),f=this.bits,h=this.colors,k=this.str.getBytes(d);this.eof=!k.length;if(!this.eof){var l=0,m=0,n=0,p=0,q=e;if(1===f&&1===h)for(e=0;e<d;++e)f=k[e]^l,f^=f>>1,f^=f>>2,f^=f>>4,l=(f&1)<<7,g[q++]=f;else if(8===f){for(e=0;e<h;++e)g[q++]=k[e];for(;e<d;++e)g[q]=g[q-h]+k[e],q++}else if(16===f){l=2*h;for(e=0;e<l;++e)g[q++]=k[e];for(;e<d;e+=2)f=((k[e]&255)<<8)+(k[e+1]&255)+((g[q-l]&255)<<8)+(g[q-l+1]&255),g[q++]=f>>8&255,g[q++]=f&255}else{q=new Uint8Array(h+\n1);var r=(1<<f)-1,t=0,v=e,w=this.columns;for(e=0;e<w;++e)for(var y=0;y<h;++y)n<f&&(l=l<<8|k[t++]&255,n+=8),q[y]=q[y]+(l>>n-f)&r,n-=f,m=m<<f|q[y],p+=f,8<=p&&(g[v++]=m>>p-8&255,p-=8);0<p&&(g[v++]=(m<<8-p)+(l&(1<<8-p)-1))}this.bufferLength+=d}};b.readBlockPng=function(){var d=this.rowBytes,e=this.pixBytes,g=this.str.getByte(),f=this.str.getBytes(d);this.eof=!f.length;if(!this.eof){var h=this.bufferLength,k=this.ensureBuffer(h+d),l=k.subarray(h-d,h);0===l.length&&(l=new Uint8Array(d));switch(g){case 0:for(g=\n0;g<d;++g)k[h++]=f[g];break;case 1:for(g=0;g<e;++g)k[h++]=f[g];for(;g<d;++g)k[h]=k[h-e]+f[g]&255,h++;break;case 2:for(g=0;g<d;++g)k[h++]=l[g]+f[g]&255;break;case 3:for(g=0;g<e;++g)k[h++]=(l[g]>>1)+f[g];for(;g<d;++g)k[h]=(l[g]+k[h-e]>>1)+f[g]&255,h++;break;case 4:for(g=0;g<e;++g){var m=l[g];var n=f[g];k[h++]=m+n}for(;g<d;++g){m=l[g];var p=l[g-e],q=k[h-e];n=q+m-p;var r=n-q;0>r&&(r=-r);var t=n-m;0>t&&(t=-t);var v=n-p;0>v&&(v=-v);n=f[g];r<=t&&r<=v?k[h++]=q+n:t<=v?k[h++]=m+n:k[h++]=p+n}break;default:throw new oa("Unsupported predictor: "+\ng);}this.bufferLength+=d}};return c}(uc),Rr=function(a){function c(b,d){d=a.call(this,d)||this;d.str=b;d.dict=b.dict;return d}Up(c,a);c.prototype.readBlock=function(){var b=this.str.getBytes(2);if(!b||2>b.length||128===b[0])this.eof=!0;else{var d=this.bufferLength,e=b[0];if(128>e){var g=this.ensureBuffer(d+e+1);g[d++]=b[1];0<e&&(b=this.str.getBytes(e),g.set(b,d),d+=e)}else{e=257-e;b=b[1];g=this.ensureBuffer(d+e+1);for(var f=0;f<e;f++)g[d++]=b}this.bufferLength=d}};return c}(uc),Vd=function(){function a(b){var d=\nb.xref,e=void 0===b.allowStreams?!1:b.allowStreams,g=void 0===b.recoveryMode?!1:b.recoveryMode;this.lexer=b.lexer;this.xref=d;this.allowStreams=e;this.recoveryMode=g;this.imageCache=Object.create(null);this._imageId=0;this.refill()}var c=a.prototype;c.refill=function(){this.buf1=this.lexer.getObj();this.buf2=this.lexer.getObj()};c.shift=function(){this.buf2 instanceof Vb&&"ID"===this.buf2.cmd?(this.buf1=this.buf2,this.buf2=null):(this.buf1=this.buf2,this.buf2=this.lexer.getObj())};c.tryShift=function(){try{return this.shift(),\n!0}catch(b){if(b instanceof ub)throw b;return!1}};c.getObj=function(b){void 0===b&&(b=null);var d=this.buf1;this.shift();if(d instanceof Vb)switch(d.cmd){case "BI":return this.makeInlineImage(b);case "[":for(d=[];!Ub(this.buf1,"]")&&this.buf1!==$b;)d.push(this.getObj(b));if(this.buf1===$b){if(this.recoveryMode)return d;throw new hj("End of file inside array.");}this.shift();return d;case "<<":for(d=new ca(this.xref);!Ub(this.buf1,">>")&&this.buf1!==$b;)if(this.buf1 instanceof ka){var e=this.buf1.name;\nthis.shift();if(this.buf1===$b)break;d.set(e,this.getObj(b))}else Ya("Malformed dictionary: key must be a name object"),this.shift();if(this.buf1===$b){if(this.recoveryMode)return d;throw new hj("End of file inside dictionary.");}if(Ub(this.buf2,"stream"))return this.allowStreams?this.makeStream(d,b):d;this.shift();return d;default:return d}return Number.isInteger(d)?Number.isInteger(this.buf1)&&Ub(this.buf2,"R")?(b=Ha.get(d,this.buf1),this.shift(),this.shift(),b):d:"string"===typeof d&&b?b.decryptString(d):\nd};c.findDefaultInlineStreamEnd=function(b){for(var d=this.lexer.knownCommands,e=b.pos,g=0,f,h;-1!==(f=b.getByte());)if(0===g)g=69===f?1:0;else if(1===g)g=73===f?2:0;else if(32===f||10===f||13===f){h=b.pos;var k=b.peekBytes(15),l=k.length;if(0===l)break;for(var m=0;m<l;m++)if(f=k[m],(0!==f||0===k[m+1])&&10!==f&&13!==f&&(32>f||127<f)){g=0;break}if(2===g)if(d){k=new kd(new Mb(k.slice()),d);k._hexStringWarn=function(){};for(l=0;;){m=k.getObj();if(m===$b){g=0;break}if(m instanceof Vb){m=d[m.cmd];if(!m){g=\n0;break}else if(m.variableArgs?l<=m.numArgs:l===m.numArgs)break;l=0}else l++}if(2===g)break}else T("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.")}else g=0;-1===f&&(T("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker"),h&&(T(\'... trying to recover by using the last "EI" occurrence.\'),b.skip(-(b.pos-h))));d=4;b.skip(-d);f=b.peekByte();b.skip(d);Lc(f)||d--;return b.pos-d-e};c.findDCTDecodeInlineStreamEnd=function(b){for(var d=b.pos,e=!1,\ng,f;-1!==(g=b.getByte());)if(255===g){switch(b.getByte()){case 255:b.skip(-1);break;case 217:e=!0;break;case 192:case 193:case 194:case 195:case 197:case 198:case 199:case 201:case 202:case 203:case 205:case 206:case 207:case 196:case 204:case 218:case 219:case 220:case 221:case 222:case 223:case 224:case 225:case 226:case 227:case 228:case 229:case 230:case 231:case 232:case 233:case 234:case 235:case 236:case 237:case 238:case 239:case 254:f=b.getUint16(),2<f?b.skip(f-2):b.skip(-2)}if(e)break}d=\nb.pos-d;if(-1===g)return T("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead."),b.skip(-d),this.findDefaultInlineStreamEnd(b);this.inlineStreamSkipEI(b);return d};c.findASCII85DecodeInlineStreamEnd=function(b){for(var d=b.pos,e;-1!==(e=b.getByte());)if(126===e){var g=b.pos;for(e=b.peekByte();Lc(e);)b.skip(),e=b.peekByte();if(62===e){b.skip();break}if(b.pos>g&&(g=b.peekBytes(2),69===g[0]&&73===g[1]))break}d=b.pos-d;if(-1===e)return T("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead."),\nb.skip(-d),this.findDefaultInlineStreamEnd(b);this.inlineStreamSkipEI(b);return d};c.findASCIIHexDecodeInlineStreamEnd=function(b){for(var d=b.pos,e;-1!==(e=b.getByte())&&62!==e;);d=b.pos-d;if(-1===e)return T("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead."),b.skip(-d),this.findDefaultInlineStreamEnd(b);this.inlineStreamSkipEI(b);return d};c.inlineStreamSkipEI=function(b){for(var d=0,e;-1!==(e=b.getByte());)if(0===d)d=69===e?1:0;else if(1===d)d=73===e?2:0;else if(2===\nd)break};c.makeInlineImage=function(b){for(var d=this.lexer,e=d.stream,g=Object.create(null),f;!Ub(this.buf1,"ID")&&this.buf1!==$b;){if(!(this.buf1 instanceof ka))throw new oa("Dictionary key must be a name object");var h=this.buf1.name;this.shift();if(this.buf1===$b)break;g[h]=this.getObj(b)}-1!==d.beginInlineImagePos&&(f=e.pos-d.beginInlineImagePos);h=this.xref.fetchIfRef(g.F||g.Filter);if(h instanceof ka)var k=h.name;else Array.isArray(h)&&(h=this.xref.fetchIfRef(h[0]),h instanceof ka&&(k=h.name));\nh=e.pos;switch(k){case "DCT":case "DCTDecode":k=this.findDCTDecodeInlineStreamEnd(e);break;case "A85":case "ASCII85Decode":k=this.findASCII85DecodeInlineStreamEnd(e);break;case "AHx":case "ASCIIHexDecode":k=this.findASCIIHexDecodeInlineStreamEnd(e);break;default:k=this.findDefaultInlineStreamEnd(e)}if(1E3>k&&0<f){var l=e.pos;e.pos=d.beginInlineImagePos;var m=e.getBytes(f+k);d=[];f=m.length;for(var n=0;n<f-1;)d.push(m[n++]<<8|m[n++]);n<f&&d.push(m[n]);m=f+"_"+String.fromCharCode.apply(null,d);e.pos=\nl;d=this.imageCache[m];if(void 0!==d)return this.buf2=Vb.get("EI"),this.shift(),d.reset(),d}d=new ca(this.xref);for(var p in g)d.set(p,g[p]);e=e.makeSubStream(h,k,d);b&&(e=b.createStream(e,k));e=this.filter(e,d,k);e.dict=d;void 0!==m&&(e.cacheKey="inline_img_"+ ++this._imageId,this.imageCache[m]=e);this.buf2=Vb.get("EI");this.shift();return e};c.__findStreamLength=function(b){var d=this.lexer.stream;d.pos=b;for(var e=new Uint8Array([101,110,100]),g=e.length,f=[new Uint8Array([115,116,114,101,97,109]),\nnew Uint8Array([115,116,101,97,109]),new Uint8Array([115,116,114,101,97])],h=9-g;d.pos<d.end;){var k=d.peekBytes(2048),l=k.length-9;if(0>=l)break;for(var m=0;m<l;){for(var n=0;n<g&&k[m+n]===e[n];)n++;if(n>=g){for(var p=!1,q=u.makeIterator(f),r=q.next();!r.done;r=q.next()){r=r.value;for(var t=r.length,v=0;v<t&&k[m+n+v]===r[v];)v++;if(v>=h){p=!0;break}if(v>=t){Lc(k[m+n+v])&&(Ya(\'Found "\'+Ec([].concat(u.arrayFromIterable(e),u.arrayFromIterable(r)))+\'" when searching for endstream command.\'),p=!0);break}}if(p)return d.pos+=\nm,d.pos-b}m++}d.pos+=l}return-1};c.makeStream=function(b,d){var e=this.lexer,g=e.stream;e.skipToNextLine();var f=g.pos-1,h=b.get("Length");Number.isInteger(h)||(Ya(\'Bad length "\'+(h&&h.toString())+\'" in stream.\'),h=0);g.pos=f+h;e.nextChar();if(!this.tryShift()||!Ub(this.buf2,"endstream")){h=this.__findStreamLength(f);if(0>h)throw new oa("Missing endstream command.");e.nextChar();this.shift()}this.shift();this.shift();g=g.makeSubStream(f,h,b);d&&(g=d.createStream(g,h));g=this.filter(g,b,h);g.dict=\nb;return g};c.filter=function(b,d,e){var g=d.get("F","Filter");d=d.get("DP","DecodeParms");if(g instanceof ka)return Array.isArray(d)&&T("/DecodeParms should not be an Array, when /Filter is a Name."),this.makeFilter(b,g.name,e,d);if(Array.isArray(g))for(var f=g,h=d,k=0,l=f.length;k<l;++k){g=this.xref.fetchIfRef(f[k]);if(!(g instanceof ka))throw new oa(\'Bad filter name "\'+g+\'"\');d=null;Array.isArray(h)&&k in h&&(d=this.xref.fetchIfRef(h[k]));b=this.makeFilter(b,g.name,e,d);e=null}return b};c.makeFilter=\nfunction(b,d,e,g){if(0===e)return T(\'Empty "\'+d+\'" stream.\'),new jj;try{switch(d){case "Fl":case "FlateDecode":return g?new Kn(new Cn(b,e),e,g):new Cn(b,e);case "LZW":case "LZWDecode":return d=1,g?(g.has("EarlyChange")&&(d=g.get("EarlyChange")),new Kn(new Jn(b,e,d),e,g)):new Jn(b,e,d);case "DCT":case "DCTDecode":return new mj(b,e,g);case "JPX":case "JPXDecode":return new Qr(b,e,g);case "A85":case "ASCII85Decode":return new wr(b,e);case "AHx":case "ASCIIHexDecode":return new xr(b,e);case "CCF":case "CCITTFaxDecode":return new yr(b,\ne,g);case "RL":case "RunLengthDecode":return new Rr(b,e);case "JBIG2Decode":return new Jr(b,e,g)}T(\'Filter "\'+d+\'" is not supported.\');return b}catch(f){if(f instanceof ub)throw f;T(\'Invalid stream: "\'+f+\'"\');return new jj}};return a}(),Qe=[1,0,0,0,0,0,0,0,0,1,1,0,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,2,0,0,2,2,0,0,0,0,0,2,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,0,2,0,0,0,0,\n0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],kd=function(){function a(b,d){void 0===d&&(d=null);this.stream=b;this.nextChar();this.strBuf=[];this.knownCommands=d;this._hexStringNumWarn=0;this.beginInlineImagePos=-1}var c=a.prototype;c.nextChar=function(){return this.currentChar=this.stream.getByte()};\nc.peekChar=function(){return this.stream.peekByte()};c.getNumber=function(){var b=this.currentChar,d=!1,e=0,g=1;45===b?(g=-1,b=this.nextChar(),45===b&&(b=this.nextChar())):43===b&&(b=this.nextChar());if(10===b||13===b){do b=this.nextChar();while(10===b||13===b)}46===b&&(e=10,b=this.nextChar());if(48>b||57<b){d="Invalid number: "+String.fromCharCode(b)+" (charCode "+b+")";if(Lc(b)||-1===b)return Ya(\'Lexer.getNumber - "\'+d+\'".\'),0;throw new oa(d);}for(var f=b-48,h=0,k=1;0<=(b=this.nextChar());)if(48<=\nb&&57>=b)b-=48,d?h=10*h+b:(0!==e&&(e*=10),f=10*f+b);else if(46===b)if(0===e)e=1;else break;else if(45===b)T("Badly formatted number: minus sign in the middle");else if(69===b||101===b){b=this.peekChar();if(43===b||45===b)k=45===b?-1:1,this.nextChar();else if(48>b||57<b)break;d=!0}else break;0!==e&&(f/=e);d&&(f*=Math.pow(10,k*h));return g*f};c.getString=function(){var b=1,d=!1,e=this.strBuf;e.length=0;for(var g=this.nextChar();;){var f=!1;switch(g|0){case -1:T("Unterminated string");d=!0;break;case 40:++b;\ne.push("(");break;case 41:0===--b?(this.nextChar(),d=!0):e.push(")");break;case 92:g=this.nextChar();switch(g){case -1:T("Unterminated string");d=!0;break;case 110:e.push("\\n");break;case 114:e.push("\\r");break;case 116:e.push("\\t");break;case 98:e.push("\\b");break;case 102:e.push("\\f");break;case 92:case 40:case 41:e.push(String.fromCharCode(g));break;case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:var h=g&15;g=this.nextChar();f=!0;48<=g&&55>=g&&(h=(h<<3)+(g&15),g=this.nextChar(),\n48<=g&&55>=g&&(f=!1,h=(h<<3)+(g&15)));e.push(String.fromCharCode(h));break;case 13:10===this.peekChar()&&this.nextChar();break;case 10:break;default:e.push(String.fromCharCode(g))}break;default:e.push(String.fromCharCode(g))}if(d)break;f||(g=this.nextChar())}return e.join("")};c.getName=function(){var b,d=this.strBuf;for(d.length=0;0<=(b=this.nextChar())&&!Qe[b];)if(35===b){b=this.nextChar();if(Qe[b]){T("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.");d.push("#");break}var e=\nGh(b);if(-1!==e){var g=b;b=this.nextChar();var f=Gh(b);if(-1===f){T("Lexer_getName: Illegal digit ("+String.fromCharCode(b)+") in hexadecimal number.");d.push("#",String.fromCharCode(g));if(Qe[b])break;d.push(String.fromCharCode(b))}else d.push(String.fromCharCode(e<<4|f))}else d.push("#",String.fromCharCode(b))}else d.push(String.fromCharCode(b));127<d.length&&T("Name token is longer than allowed by the spec: "+d.length);return ka.get(d.join(""))};c._hexStringWarn=function(b){5===this._hexStringNumWarn++?\nT("getHexString - ignoring additional invalid characters."):5<this._hexStringNumWarn||T("getHexString - ignoring invalid character: "+b)};c.getHexString=function(){var b=this.strBuf;b.length=0;var d=this.currentChar,e=-1;for(this._hexStringNumWarn=0;;)if(0>d){T("Unterminated hex string");break}else if(62===d){this.nextChar();break}else{if(1!==Qe[d]){var g=Gh(d);-1===g?this._hexStringWarn(d):-1===e?e=g:(b.push(String.fromCharCode(e<<4|g)),e=-1)}d=this.nextChar()}-1!==e&&b.push(String.fromCharCode(e<<\n4));return b.join("")};c.getObj=function(){for(var b=!1,d=this.currentChar;;){if(0>d)return $b;if(b){if(10===d||13===d)b=!1}else if(37===d)b=!0;else if(1!==Qe[d])break;d=this.nextChar()}switch(d|0){case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:case 43:case 45:case 46:return this.getNumber();case 40:return this.getString();case 47:return this.getName();case 91:return this.nextChar(),Vb.get("[");case 93:return this.nextChar(),Vb.get("]");case 60:return d=this.nextChar(),\n60===d?(this.nextChar(),Vb.get("<<")):this.getHexString();case 62:return d=this.nextChar(),62===d?(this.nextChar(),Vb.get(">>")):Vb.get(">");case 123:return this.nextChar(),Vb.get("{");case 125:return this.nextChar(),Vb.get("}");case 41:throw this.nextChar(),new oa("Illegal character: "+d);}b=String.fromCharCode(d);if(32>d||127<d){var e=this.peekChar();if(32<=e&&127>=e)return this.nextChar(),Vb.get(b)}e=this.knownCommands;for(var g=void 0!==(null==e?void 0:e[b]);0<=(d=this.nextChar())&&!Qe[d];){var f=\nb+String.fromCharCode(d);if(g&&void 0===e[f])break;if(128===b.length)throw new oa("Command token too long: "+b.length);b=f;g=void 0!==(null==e?void 0:e[b])}if("true"===b)return!0;if("false"===b)return!1;if("null"===b)return null;"BI"===b&&(this.beginInlineImagePos=this.stream.pos);return Vb.get(b)};c.skipToNextLine=function(){for(var b=this.currentChar;0<=b;){if(13===b){b=this.nextChar();10===b&&this.nextChar();break}else if(10===b){this.nextChar();break}b=this.nextChar()}};return a}(),Sr=function(){function a(){}\na.create=function(c){function b(k,l,m){void 0===m&&(m=!1);k=k.get(l);if(Number.isInteger(k)&&(m?0<=k:0<k))return k;throw Error(\'The "\'+l+\'" parameter in the linearization dictionary is invalid.\');}var d=new Vd({lexer:new kd(c),xref:null}),e=d.getObj(),g=d.getObj(),f=d.getObj();d=d.getObj();var h;if(!(Number.isInteger(e)&&Number.isInteger(g)&&Ub(f,"obj")&&d instanceof ca&&"number"===typeof(h=d.get("Linearized"))&&0<h))return null;if((e=b(d,"L"))!==c.length)throw Error(\'The "L" parameter in the linearization dictionary does not equal the stream length.\');\nreturn{length:e,hints:function(k){k=k.get("H");var l;if(Array.isArray(k)&&(2===(l=k.length)||4===l)){for(var m=0;m<l;m++){var n=k[m];if(!(Number.isInteger(n)&&0<n))throw Error("Hint ("+m+") in the linearization dictionary is invalid.");}return k}throw Error("Hint array in the linearization dictionary is invalid.");}(d),objectNumberFirst:b(d,"O"),endFirst:b(d,"E"),numPages:b(d,"N"),mainXRefEntriesOffset:b(d,"T"),pageFirst:d.has("P")?b(d,"P",!0):0}};return a}(),Wp="Adobe-GB1-UCS2 Adobe-CNS1-UCS2 Adobe-Japan1-UCS2 Adobe-Korea1-UCS2 78-EUC-H 78-EUC-V 78-H 78-RKSJ-H 78-RKSJ-V 78-V 78ms-RKSJ-H 78ms-RKSJ-V 83pv-RKSJ-H 90ms-RKSJ-H 90ms-RKSJ-V 90msp-RKSJ-H 90msp-RKSJ-V 90pv-RKSJ-H 90pv-RKSJ-V Add-H Add-RKSJ-H Add-RKSJ-V Add-V Adobe-CNS1-0 Adobe-CNS1-1 Adobe-CNS1-2 Adobe-CNS1-3 Adobe-CNS1-4 Adobe-CNS1-5 Adobe-CNS1-6 Adobe-GB1-0 Adobe-GB1-1 Adobe-GB1-2 Adobe-GB1-3 Adobe-GB1-4 Adobe-GB1-5 Adobe-Japan1-0 Adobe-Japan1-1 Adobe-Japan1-2 Adobe-Japan1-3 Adobe-Japan1-4 Adobe-Japan1-5 Adobe-Japan1-6 Adobe-Korea1-0 Adobe-Korea1-1 Adobe-Korea1-2 B5-H B5-V B5pc-H B5pc-V CNS-EUC-H CNS-EUC-V CNS1-H CNS1-V CNS2-H CNS2-V ETHK-B5-H ETHK-B5-V ETen-B5-H ETen-B5-V ETenms-B5-H ETenms-B5-V EUC-H EUC-V Ext-H Ext-RKSJ-H Ext-RKSJ-V Ext-V GB-EUC-H GB-EUC-V GB-H GB-V GBK-EUC-H GBK-EUC-V GBK2K-H GBK2K-V GBKp-EUC-H GBKp-EUC-V GBT-EUC-H GBT-EUC-V GBT-H GBT-V GBTpc-EUC-H GBTpc-EUC-V GBpc-EUC-H GBpc-EUC-V H HKdla-B5-H HKdla-B5-V HKdlb-B5-H HKdlb-B5-V HKgccs-B5-H HKgccs-B5-V HKm314-B5-H HKm314-B5-V HKm471-B5-H HKm471-B5-V HKscs-B5-H HKscs-B5-V Hankaku Hiragana KSC-EUC-H KSC-EUC-V KSC-H KSC-Johab-H KSC-Johab-V KSC-V KSCms-UHC-H KSCms-UHC-HW-H KSCms-UHC-HW-V KSCms-UHC-V KSCpc-EUC-H KSCpc-EUC-V Katakana NWP-H NWP-V RKSJ-H RKSJ-V Roman UniCNS-UCS2-H UniCNS-UCS2-V UniCNS-UTF16-H UniCNS-UTF16-V UniCNS-UTF32-H UniCNS-UTF32-V UniCNS-UTF8-H UniCNS-UTF8-V UniGB-UCS2-H UniGB-UCS2-V UniGB-UTF16-H UniGB-UTF16-V UniGB-UTF32-H UniGB-UTF32-V UniGB-UTF8-H UniGB-UTF8-V UniJIS-UCS2-H UniJIS-UCS2-HW-H UniJIS-UCS2-HW-V UniJIS-UCS2-V UniJIS-UTF16-H UniJIS-UTF16-V UniJIS-UTF32-H UniJIS-UTF32-V UniJIS-UTF8-H UniJIS-UTF8-V UniJIS2004-UTF16-H UniJIS2004-UTF16-V UniJIS2004-UTF32-H UniJIS2004-UTF32-V UniJIS2004-UTF8-H UniJIS2004-UTF8-V UniJISPro-UCS2-HW-V UniJISPro-UCS2-V UniJISPro-UTF8-V UniJISX0213-UTF32-H UniJISX0213-UTF32-V UniJISX02132004-UTF32-H UniJISX02132004-UTF32-V UniKS-UCS2-H UniKS-UCS2-V UniKS-UTF16-H UniKS-UTF16-V UniKS-UTF32-H UniKS-UTF32-V UniKS-UTF8-H UniKS-UTF8-V V WP-Symbol".split(" "),\nnj=Math.pow(2,24)-1,Mh=function(){function a(b){void 0===b&&(b=!1);this.codespaceRanges=[[],[],[],[]];this.numCodespaceRanges=0;this._map=[];this.name="";this.vertical=!1;this.useCMap=null;this.builtInCMap=b}var c=a.prototype;c.addCodespaceRange=function(b,d,e){this.codespaceRanges[b-1].push(d,e);this.numCodespaceRanges++};c.mapCidRange=function(b,d,e){if(d-b>nj)throw Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");for(;b<=d;)this._map[b++]=e++};c.mapBfRange=function(b,d,e){if(d-b>nj)throw Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");\nfor(var g=e.length-1;b<=d;){this._map[b++]=e;var f=e.charCodeAt(g)+1;e=255<f?e.substring(0,g-1)+String.fromCharCode(e.charCodeAt(g-1)+1)+"\\x00":e.substring(0,g)+String.fromCharCode(f)}};c.mapBfRangeToArray=function(b,d,e){if(d-b>nj)throw Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");for(var g=e.length,f=0;b<=d&&f<g;)this._map[b]=e[f++],++b};c.mapOne=function(b,d){this._map[b]=d};c.lookup=function(b){return this._map[b]};c.contains=function(b){return void 0!==this._map[b]};c.forEach=\nfunction(b){var d=this._map,e=d.length;if(65536>=e)for(var g=0;g<e;g++)void 0!==d[g]&&b(g,d[g]);else for(g in d)b(g,d[g])};c.charCodeOf=function(b){var d=this._map;if(65536>=d.length)return d.indexOf(b);for(var e in d)if(d[e]===b)return e|0;return-1};c.getMap=function(){return this._map};c.readCharCode=function(b,d,e){for(var g=0,f=this.codespaceRanges,h=0,k=f.length;h<k;h++){g=(g<<8|b.charCodeAt(d+h))>>>0;for(var l=f[h],m=0,n=l.length;m<n;){var p=l[m++],q=l[m++];if(g>=p&&g<=q){e.charcode=g;e.length=\nh+1;return}}}e.charcode=0;e.length=1};c.getCharCodeLength=function(b){for(var d=this.codespaceRanges,e=0,g=d.length;e<g;e++)for(var f=d[e],h=0,k=f.length;h<k;){var l=f[h++],m=f[h++];if(b>=l&&b<=m)return e+1}return 1};return Rk(a,[{key:"length",get:function(){return this._map.length}},{key:"isIdentityCMap",get:function(){if("Identity-H"!==this.name&&"Identity-V"!==this.name||65536!==this._map.length)return!1;for(var b=0;65536>b;b++)if(this._map[b]!==b)return!1;return!0}}])}(),Ee=function(a){function c(d,\ne){var g=a.call(this)||this;g.vertical=d;g.addCodespaceRange(e,0,65535);return g}Vp(c,a);var b=c.prototype;b.mapCidRange=function(){db("should not call mapCidRange")};b.mapBfRange=function(){db("should not call mapBfRange")};b.mapBfRangeToArray=function(){db("should not call mapBfRangeToArray")};b.mapOne=function(){db("should not call mapCidOne")};b.lookup=function(d){return Number.isInteger(d)&&65535>=d?d:void 0};b.contains=function(d){return Number.isInteger(d)&&65535>=d};b.forEach=function(d){for(var e=\n0;65535>=e;e++)d(e,e)};b.charCodeOf=function(d){return Number.isInteger(d)&&65535>=d?d:-1};b.getMap=function(){for(var d=Array(65536),e=0;65535>=e;e++)d[e]=e;return d};return Rk(c,[{key:"length",get:function(){return 65536}},{key:"isIdentityCMap",get:function(){db("should not access .isIdentityCMap")}}])}(Mh),Lg=function(){function a(){}a.create=function(){var c=ig(function e(d){var g,f,h,k,l;return u.generator.createGenerator(e,function(m){if(1==m.nextAddress)return g=d,f=g.encoding,h=g.fetchBuiltInCMap,\nk=g.useCMap,f instanceof ka?m.return(Kh(f.name,h)):f instanceof $a?m.yield(Tk(new Mh,new kd(f),h,k),4):m.jumpTo(2);if(2!=m.nextAddress)return l=m.yieldResult,l.isIdentityCMap?m.return(Kh(l.name,h)):m.return(l);throw Error("Encoding required.");})});return function(d){return c.apply(this,arguments)}}();return a}();pa(1795);var Tr=".notdef space exclam quotedbl numbersign dollar percent ampersand quoteright parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore quoteleft a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde exclamdown cent sterling fraction yen florin section currency quotesingle quotedblleft guillemotleft guilsinglleft guilsinglright fi fl endash dagger daggerdbl periodcentered paragraph bullet quotesinglbase quotedblbase quotedblright guillemotright ellipsis perthousand questiondown grave acute circumflex tilde macron breve dotaccent dieresis ring cedilla hungarumlaut ogonek caron emdash AE ordfeminine Lslash Oslash OE ordmasculine ae dotlessi lslash oslash oe germandbls onesuperior logicalnot mu trademark Eth onehalf plusminus Thorn onequarter divide brokenbar degree thorn threequarters twosuperior registered minus eth multiply threesuperior copyright Aacute Acircumflex Adieresis Agrave Aring Atilde Ccedilla Eacute Ecircumflex Edieresis Egrave Iacute Icircumflex Idieresis Igrave Ntilde Oacute Ocircumflex Odieresis Ograve Otilde Scaron Uacute Ucircumflex Udieresis Ugrave Yacute Ydieresis Zcaron aacute acircumflex adieresis agrave aring atilde ccedilla eacute ecircumflex edieresis egrave iacute icircumflex idieresis igrave ntilde oacute ocircumflex odieresis ograve otilde scaron uacute ucircumflex udieresis ugrave yacute ydieresis zcaron".split(" "),\nUr=".notdef space exclamsmall Hungarumlautsmall dollaroldstyle dollarsuperior ampersandsmall Acutesmall parenleftsuperior parenrightsuperior twodotenleader onedotenleader comma hyphen period fraction zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle colon semicolon commasuperior threequartersemdash periodsuperior questionsmall asuperior bsuperior centsuperior dsuperior esuperior isuperior lsuperior msuperior nsuperior osuperior rsuperior ssuperior tsuperior ff fi fl ffi ffl parenleftinferior parenrightinferior Circumflexsmall hyphensuperior Gravesmall Asmall Bsmall Csmall Dsmall Esmall Fsmall Gsmall Hsmall Ismall Jsmall Ksmall Lsmall Msmall Nsmall Osmall Psmall Qsmall Rsmall Ssmall Tsmall Usmall Vsmall Wsmall Xsmall Ysmall Zsmall colonmonetary onefitted rupiah Tildesmall exclamdownsmall centoldstyle Lslashsmall Scaronsmall Zcaronsmall Dieresissmall Brevesmall Caronsmall Dotaccentsmall Macronsmall figuredash hypheninferior Ogoneksmall Ringsmall Cedillasmall onequarter onehalf threequarters questiondownsmall oneeighth threeeighths fiveeighths seveneighths onethird twothirds zerosuperior onesuperior twosuperior threesuperior foursuperior fivesuperior sixsuperior sevensuperior eightsuperior ninesuperior zeroinferior oneinferior twoinferior threeinferior fourinferior fiveinferior sixinferior seveninferior eightinferior nineinferior centinferior dollarinferior periodinferior commainferior Agravesmall Aacutesmall Acircumflexsmall Atildesmall Adieresissmall Aringsmall AEsmall Ccedillasmall Egravesmall Eacutesmall Ecircumflexsmall Edieresissmall Igravesmall Iacutesmall Icircumflexsmall Idieresissmall Ethsmall Ntildesmall Ogravesmall Oacutesmall Ocircumflexsmall Otildesmall Odieresissmall OEsmall Oslashsmall Ugravesmall Uacutesmall Ucircumflexsmall Udieresissmall Yacutesmall Thornsmall Ydieresissmall".split(" "),\nVr=".notdef space dollaroldstyle dollarsuperior parenleftsuperior parenrightsuperior twodotenleader onedotenleader comma hyphen period fraction zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle colon semicolon commasuperior threequartersemdash periodsuperior asuperior bsuperior centsuperior dsuperior esuperior isuperior lsuperior msuperior nsuperior osuperior rsuperior ssuperior tsuperior ff fi fl ffi ffl parenleftinferior parenrightinferior hyphensuperior colonmonetary onefitted rupiah centoldstyle figuredash hypheninferior onequarter onehalf threequarters oneeighth threeeighths fiveeighths seveneighths onethird twothirds zerosuperior onesuperior twosuperior threesuperior foursuperior fivesuperior sixsuperior sevensuperior eightsuperior ninesuperior zeroinferior oneinferior twoinferior threeinferior fourinferior fiveinferior sixinferior seveninferior eightinferior nineinferior centinferior dollarinferior periodinferior commainferior".split(" "),\nVk="                                space exclamsmall Hungarumlautsmall  dollaroldstyle dollarsuperior ampersandsmall Acutesmall parenleftsuperior parenrightsuperior twodotenleader onedotenleader comma hyphen period fraction zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle colon semicolon commasuperior threequartersemdash periodsuperior questionsmall  asuperior bsuperior centsuperior dsuperior esuperior    isuperior   lsuperior msuperior nsuperior osuperior   rsuperior ssuperior tsuperior  ff fi fl ffi ffl parenleftinferior  parenrightinferior Circumflexsmall hyphensuperior Gravesmall Asmall Bsmall Csmall Dsmall Esmall Fsmall Gsmall Hsmall Ismall Jsmall Ksmall Lsmall Msmall Nsmall Osmall Psmall Qsmall Rsmall Ssmall Tsmall Usmall Vsmall Wsmall Xsmall Ysmall Zsmall colonmonetary onefitted rupiah Tildesmall                                   exclamdownsmall centoldstyle Lslashsmall   Scaronsmall Zcaronsmall Dieresissmall Brevesmall Caronsmall  Dotaccentsmall   Macronsmall   figuredash hypheninferior   Ogoneksmall Ringsmall Cedillasmall    onequarter onehalf threequarters questiondownsmall oneeighth threeeighths fiveeighths seveneighths onethird twothirds   zerosuperior onesuperior twosuperior threesuperior foursuperior fivesuperior sixsuperior sevensuperior eightsuperior ninesuperior zeroinferior oneinferior twoinferior threeinferior fourinferior fiveinferior sixinferior seveninferior eightinferior nineinferior centinferior dollarinferior periodinferior commainferior Agravesmall Aacutesmall Acircumflexsmall Atildesmall Adieresissmall Aringsmall AEsmall Ccedillasmall Egravesmall Eacutesmall Ecircumflexsmall Edieresissmall Igravesmall Iacutesmall Icircumflexsmall Idieresissmall Ethsmall Ntildesmall Ogravesmall Oacutesmall Ocircumflexsmall Otildesmall Odieresissmall OEsmall Oslashsmall Ugravesmall Uacutesmall Ucircumflexsmall Udieresissmall Yacutesmall Thornsmall Ydieresissmall".split(" "),\nYp="                                space exclamsmall Hungarumlautsmall centoldstyle dollaroldstyle dollarsuperior ampersandsmall Acutesmall parenleftsuperior parenrightsuperior twodotenleader onedotenleader comma hyphen period fraction zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle colon semicolon  threequartersemdash  questionsmall     Ethsmall   onequarter onehalf threequarters oneeighth threeeighths fiveeighths seveneighths onethird twothirds       ff fi fl ffi ffl parenleftinferior  parenrightinferior Circumflexsmall hypheninferior Gravesmall Asmall Bsmall Csmall Dsmall Esmall Fsmall Gsmall Hsmall Ismall Jsmall Ksmall Lsmall Msmall Nsmall Osmall Psmall Qsmall Rsmall Ssmall Tsmall Usmall Vsmall Wsmall Xsmall Ysmall Zsmall colonmonetary onefitted rupiah Tildesmall   asuperior centsuperior     Aacutesmall Agravesmall Acircumflexsmall Adieresissmall Atildesmall Aringsmall Ccedillasmall Eacutesmall Egravesmall Ecircumflexsmall Edieresissmall Iacutesmall Igravesmall Icircumflexsmall Idieresissmall Ntildesmall Oacutesmall Ogravesmall Ocircumflexsmall Odieresissmall Otildesmall Uacutesmall Ugravesmall Ucircumflexsmall Udieresissmall  eightsuperior fourinferior threeinferior sixinferior eightinferior seveninferior Scaronsmall  centinferior twoinferior  Dieresissmall  Caronsmall osuperior fiveinferior  commainferior periodinferior Yacutesmall  dollarinferior   Thornsmall  nineinferior zeroinferior Zcaronsmall AEsmall Oslashsmall questiondownsmall oneinferior Lslashsmall       Cedillasmall      OEsmall figuredash hyphensuperior     exclamdownsmall  Ydieresissmall  onesuperior twosuperior threesuperior foursuperior fivesuperior sixsuperior sevensuperior ninesuperior zerosuperior  esuperior rsuperior tsuperior   isuperior ssuperior dsuperior      lsuperior Ogoneksmall Brevesmall Macronsmall bsuperior nsuperior msuperior commasuperior periodsuperior Dotaccentsmall Ringsmall    ".split(" "),\nNh="                                space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde  Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis space Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron".split(" "),\nBd="                                space exclam quotedbl numbersign dollar percent ampersand quoteright parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore quoteleft a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde                                   exclamdown cent sterling fraction yen florin section currency quotesingle quotedblleft guillemotleft guilsinglleft guilsinglright fi fl  endash dagger daggerdbl periodcentered  paragraph bullet quotesinglbase quotedblbase quotedblright guillemotright ellipsis perthousand  questiondown  grave acute circumflex tilde macron breve dotaccent dieresis  ring cedilla  hungarumlaut ogonek caron emdash                 AE  ordfeminine     Lslash Oslash OE ordmasculine      ae    dotlessi   lslash oslash oe germandbls    ".split(" "),\njf="                                space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde bullet Euro bullet quotesinglbase florin quotedblbase ellipsis dagger daggerdbl circumflex perthousand Scaron guilsinglleft OE bullet Zcaron bullet bullet quoteleft quoteright quotedblleft quotedblright bullet endash emdash tilde trademark scaron guilsinglright oe bullet zcaron Ydieresis space exclamdown cent sterling currency yen brokenbar section dieresis copyright ordfeminine guillemotleft logicalnot hyphen registered macron degree plusminus twosuperior threesuperior acute mu paragraph periodcentered cedilla onesuperior ordmasculine guillemotright onequarter onehalf threequarters questiondown Agrave Aacute Acircumflex Atilde Adieresis Aring AE Ccedilla Egrave Eacute Ecircumflex Edieresis Igrave Iacute Icircumflex Idieresis Eth Ntilde Ograve Oacute Ocircumflex Otilde Odieresis multiply Oslash Ugrave Uacute Ucircumflex Udieresis Yacute Thorn germandbls agrave aacute acircumflex atilde adieresis aring ae ccedilla egrave eacute ecircumflex edieresis igrave iacute icircumflex idieresis eth ntilde ograve oacute ocircumflex otilde odieresis divide oslash ugrave uacute ucircumflex udieresis yacute thorn ydieresis".split(" "),\nOh="                                space exclam universal numbersign existential percent ampersand suchthat parenleft parenright asteriskmath plus comma minus period slash zero one two three four five six seven eight nine colon semicolon less equal greater question congruent Alpha Beta Chi Delta Epsilon Phi Gamma Eta Iota theta1 Kappa Lambda Mu Nu Omicron Pi Theta Rho Sigma Tau Upsilon sigma1 Omega Xi Psi Zeta bracketleft therefore bracketright perpendicular underscore radicalex alpha beta chi delta epsilon phi gamma eta iota phi1 kappa lambda mu nu omicron pi theta rho sigma tau upsilon omega1 omega xi psi zeta braceleft bar braceright similar                                  Euro Upsilon1 minute lessequal fraction infinity florin club diamond heart spade arrowboth arrowleft arrowup arrowright arrowdown degree plusminus second greaterequal multiply proportional partialdiff bullet divide notequal equivalence approxequal ellipsis arrowvertex arrowhorizex carriagereturn aleph Ifraktur Rfraktur weierstrass circlemultiply circleplus emptyset intersection union propersuperset reflexsuperset notsubset propersubset reflexsubset element notelement angle gradient registerserif copyrightserif trademarkserif product radical dotmath logicalnot logicaland logicalor arrowdblboth arrowdblleft arrowdblup arrowdblright arrowdbldown lozenge angleleft registersans copyrightsans trademarksans summation parenlefttp parenleftex parenleftbt bracketlefttp bracketleftex bracketleftbt bracelefttp braceleftmid braceleftbt braceex  angleright integral integraltp integralex integralbt parenrighttp parenrightex parenrightbt bracketrighttp bracketrightex bracketrightbt bracerighttp bracerightmid bracerightbt ".split(" "),\nPh="                                space a1 a2 a202 a3 a4 a5 a119 a118 a117 a11 a12 a13 a14 a15 a16 a105 a17 a18 a19 a20 a21 a22 a23 a24 a25 a26 a27 a28 a6 a7 a8 a9 a10 a29 a30 a31 a32 a33 a34 a35 a36 a37 a38 a39 a40 a41 a42 a43 a44 a45 a46 a47 a48 a49 a50 a51 a52 a53 a54 a55 a56 a57 a58 a59 a60 a61 a62 a63 a64 a65 a66 a67 a68 a69 a70 a71 a72 a73 a74 a203 a75 a204 a76 a77 a78 a79 a81 a82 a83 a84 a97 a98 a99 a100  a89 a90 a93 a94 a91 a92 a205 a85 a206 a86 a87 a88 a95 a96                    a101 a102 a103 a104 a106 a107 a108 a112 a111 a110 a109 a120 a121 a122 a123 a124 a125 a126 a127 a128 a129 a130 a131 a132 a133 a134 a135 a136 a137 a138 a139 a140 a141 a142 a143 a144 a145 a146 a147 a148 a149 a150 a151 a152 a153 a154 a155 a156 a157 a158 a159 a160 a161 a163 a164 a196 a165 a192 a166 a167 a168 a169 a170 a171 a172 a173 a162 a174 a175 a176 a177 a178 a179 a193 a180 a199 a181 a200 a182  a201 a183 a184 a197 a185 a194 a198 a186 a195 a187 a188 a189 a190 a191 ".split(" "),\nMg=".notdef space exclam quotedbl numbersign dollar percent ampersand quoteright parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore quoteleft a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde exclamdown cent sterling fraction yen florin section currency quotesingle quotedblleft guillemotleft guilsinglleft guilsinglright fi fl endash dagger daggerdbl periodcentered paragraph bullet quotesinglbase quotedblbase quotedblright guillemotright ellipsis perthousand questiondown grave acute circumflex tilde macron breve dotaccent dieresis ring cedilla hungarumlaut ogonek caron emdash AE ordfeminine Lslash Oslash OE ordmasculine ae dotlessi lslash oslash oe germandbls onesuperior logicalnot mu trademark Eth onehalf plusminus Thorn onequarter divide brokenbar degree thorn threequarters twosuperior registered minus eth multiply threesuperior copyright Aacute Acircumflex Adieresis Agrave Aring Atilde Ccedilla Eacute Ecircumflex Edieresis Egrave Iacute Icircumflex Idieresis Igrave Ntilde Oacute Ocircumflex Odieresis Ograve Otilde Scaron Uacute Ucircumflex Udieresis Ugrave Yacute Ydieresis Zcaron aacute acircumflex adieresis agrave aring atilde ccedilla eacute ecircumflex edieresis egrave iacute icircumflex idieresis igrave ntilde oacute ocircumflex odieresis ograve otilde scaron uacute ucircumflex udieresis ugrave yacute ydieresis zcaron exclamsmall Hungarumlautsmall dollaroldstyle dollarsuperior ampersandsmall Acutesmall parenleftsuperior parenrightsuperior twodotenleader onedotenleader zerooldstyle oneoldstyle twooldstyle threeoldstyle fouroldstyle fiveoldstyle sixoldstyle sevenoldstyle eightoldstyle nineoldstyle commasuperior threequartersemdash periodsuperior questionsmall asuperior bsuperior centsuperior dsuperior esuperior isuperior lsuperior msuperior nsuperior osuperior rsuperior ssuperior tsuperior ff ffi ffl parenleftinferior parenrightinferior Circumflexsmall hyphensuperior Gravesmall Asmall Bsmall Csmall Dsmall Esmall Fsmall Gsmall Hsmall Ismall Jsmall Ksmall Lsmall Msmall Nsmall Osmall Psmall Qsmall Rsmall Ssmall Tsmall Usmall Vsmall Wsmall Xsmall Ysmall Zsmall colonmonetary onefitted rupiah Tildesmall exclamdownsmall centoldstyle Lslashsmall Scaronsmall Zcaronsmall Dieresissmall Brevesmall Caronsmall Dotaccentsmall Macronsmall figuredash hypheninferior Ogoneksmall Ringsmall Cedillasmall questiondownsmall oneeighth threeeighths fiveeighths seveneighths onethird twothirds zerosuperior foursuperior fivesuperior sixsuperior sevensuperior eightsuperior ninesuperior zeroinferior oneinferior twoinferior threeinferior fourinferior fiveinferior sixinferior seveninferior eightinferior nineinferior centinferior dollarinferior periodinferior commainferior Agravesmall Aacutesmall Acircumflexsmall Atildesmall Adieresissmall Aringsmall AEsmall Ccedillasmall Egravesmall Eacutesmall Ecircumflexsmall Edieresissmall Igravesmall Iacutesmall Icircumflexsmall Idieresissmall Ethsmall Ntildesmall Ogravesmall Oacutesmall Ocircumflexsmall Otildesmall Odieresissmall OEsmall Oslashsmall Ugravesmall Uacutesmall Ucircumflexsmall Udieresissmall Yacutesmall Thornsmall Ydieresissmall 001.000 001.001 001.002 001.003 Black Bold Book Light Medium Regular Roman Semibold".split(" "),\nRe=[null,{id:"hstem",min:2,stackClearing:!0,stem:!0},null,{id:"vstem",min:2,stackClearing:!0,stem:!0},{id:"vmoveto",min:1,stackClearing:!0},{id:"rlineto",min:2,resetStack:!0},{id:"hlineto",min:1,resetStack:!0},{id:"vlineto",min:1,resetStack:!0},{id:"rrcurveto",min:6,resetStack:!0},null,{id:"callsubr",min:1,undefStack:!0},{id:"return",min:0,undefStack:!0},null,null,{id:"endchar",min:0,stackClearing:!0},null,null,null,{id:"hstemhm",min:2,stackClearing:!0,stem:!0},{id:"hintmask",min:0,stackClearing:!0},\n{id:"cntrmask",min:0,stackClearing:!0},{id:"rmoveto",min:2,stackClearing:!0},{id:"hmoveto",min:1,stackClearing:!0},{id:"vstemhm",min:2,stackClearing:!0,stem:!0},{id:"rcurveline",min:8,resetStack:!0},{id:"rlinecurve",min:8,resetStack:!0},{id:"vvcurveto",min:4,resetStack:!0},{id:"hhcurveto",min:4,resetStack:!0},null,{id:"callgsubr",min:1,undefStack:!0},{id:"vhcurveto",min:4,resetStack:!0},{id:"hvcurveto",min:4,resetStack:!0}],Wr=[null,null,null,{id:"and",min:2,stackDelta:-1},{id:"or",min:2,stackDelta:-1},\n{id:"not",min:1,stackDelta:0},null,null,null,{id:"abs",min:1,stackDelta:0},{id:"add",min:2,stackDelta:-1,stackFn:function(a,c){a[c-2]+=a[c-1]}},{id:"sub",min:2,stackDelta:-1,stackFn:function(a,c){a[c-2]-=a[c-1]}},{id:"div",min:2,stackDelta:-1,stackFn:function(a,c){a[c-2]/=a[c-1]}},null,{id:"neg",min:1,stackDelta:0,stackFn:function(a,c){a[c-1]=-a[c-1]}},{id:"eq",min:2,stackDelta:-1},null,null,{id:"drop",min:1,stackDelta:-1},null,{id:"put",min:2,stackDelta:-2},{id:"get",min:1,stackDelta:0},{id:"ifelse",\nmin:4,stackDelta:-3},{id:"random",min:0,stackDelta:1},{id:"mul",min:2,stackDelta:-1,stackFn:function(a,c){a[c-2]*=a[c-1]}},null,{id:"sqrt",min:1,stackDelta:0},{id:"dup",min:1,stackDelta:1},{id:"exch",min:2,stackDelta:0},{id:"index",min:2,stackDelta:0},{id:"roll",min:3,stackDelta:-2},null,null,null,{id:"hflex",min:7,resetStack:!0},{id:"flex",min:13,resetStack:!0},{id:"hflex1",min:9,resetStack:!0},{id:"flex1",min:11,resetStack:!0}],sj=function(){function a(b,d,e){this.bytes=b.getBytes();this.properties=\nd;this.seacAnalysisEnabled=!!e}var c=a.prototype;c.parse=function(){var b=this.properties,d=new Ln;this.cff=d;var e=this.parseHeader(),g=this.parseIndex(e.endPos),f=this.parseIndex(g.endPos),h=this.parseIndex(f.endPos),k=this.parseIndex(h.endPos);f=this.parseDict(f.obj.get(0));f=this.createDict(oj,f,d.strings);d.header=e.obj;d.names=this.parseNameIndex(g.obj);d.strings=this.parseStringIndex(h.obj);d.topDict=f;d.globalSubrIndex=k.obj;this.parsePrivateDict(d.topDict);d.isCIDFont=f.hasName("ROS");e=\nf.getByName("CharStrings");e=this.parseIndex(e).obj;if(g=f.getByName("FontMatrix"))b.fontMatrix=g;if(g=f.getByName("FontBBox"))b.ascent=Math.max(g[3],g[1]),b.descent=Math.min(g[1],g[3]),b.ascentScaled=!0;if(d.isCIDFont){b=this.parseIndex(f.getByName("FDArray")).obj;g=0;for(h=b.count;g<h;++g){var l=b.get(g);l=this.createDict(oj,this.parseDict(l),d.strings);this.parsePrivateDict(l);d.fdArray.push(l)}b=null;g=this.parseCharsets(f.getByName("charset"),e.count,d.strings,!0);d.fdSelect=this.parseFDSelect(f.getByName("FDSelect"),\ne.count)}else g=this.parseCharsets(f.getByName("charset"),e.count,d.strings,!1),b=this.parseEncoding(f.getByName("Encoding"),b,d.strings,g.charset);d.charset=g;d.encoding=b;k=this.parseCharStrings({charStrings:e,localSubrIndex:f.privateDict.subrsIndex,globalSubrIndex:k.obj,fdSelect:d.fdSelect,fdArray:d.fdArray,privateDict:f.privateDict});d.charStrings=k.charStrings;d.seacs=k.seacs;d.widths=k.widths;return d};c.parseHeader=function(){for(var b=this.bytes,d=b.length,e=0;e<d&&1!==b[e];)++e;if(e>=d)throw new oa("Invalid CFF header");\n0!==e&&(Ya("cff data is shifted"),this.bytes=b=b.subarray(e));d=b[2];return{obj:new Oa(b[0],b[1],d,b[3]),endPos:d}};c.parseDict=function(b){function d(){var l=b[e++];if(30===l){l="";for(var m=["0","1","2","3","4","5","6","7","8","9",".","E","E-",null,"-"],n=b.length;e<n;){var p=b[e++],q=p>>4;p&=15;if(15===q)break;l+=m[q];if(15===p)break;l+=m[p]}return parseFloat(l)}if(28===l)return l=b[e++],l=(l<<24|b[e++]<<16)>>16;if(29===l)return l=b[e++],l=l<<8|b[e++],l=l<<8|b[e++],l=l<<8|b[e++];if(32<=l&&246>=\nl)return l-139;if(247<=l&&250>=l)return 256*(l-247)+b[e++]+108;if(251<=l&&254>=l)return-(256*(l-251))-b[e++]-108;T(\'CFFParser_parseDict: "\'+l+\'" is a reserved command.\');return NaN}var e=0,g=[],f=[];e=0;for(var h=b.length;e<h;){var k=b[e];21>=k?(12===k&&(k=k<<8|b[++e]),f.push([k,g]),g=[],++e):g.push(d())}return f};c.parseIndex=function(b){var d=new Wd,e=this.bytes,g=e[b++]<<8|e[b++],f=[],h=b,k;if(0!==g){h=e[b++];var l=b+(g+1)*h-1;var m=0;for(k=g+1;m<k;++m){for(var n=0,p=0;p<h;++p)n<<=8,n+=e[b++];\nf.push(l+n)}h=f[g]}m=0;for(k=f.length-1;m<k;++m)d.add(e.subarray(f[m],f[m+1]));return{obj:d,endPos:h}};c.parseNameIndex=function(b){for(var d=[],e=0,g=b.count;e<g;++e){var f=b.get(e);d.push(Ec(f))}return d};c.parseStringIndex=function(b){for(var d=new pj,e=0,g=b.count;e<g;++e){var f=b.get(e);d.add(Ec(f))}return d};c.createDict=function(b,d,e){b=new b(e);d=u.makeIterator(d);for(e=d.next();!e.done;e=d.next()){var g=u.makeIterator(e.value);e=g.next().value;g=g.next().value;b.setByKey(e,g)}return b};\nc.parseCharString=function(b,d,e,g){if(!d||10<b.callDepth)return!1;for(var f=b.stackSize,h=b.stack,k=d.length,l=0;l<k;){var m=d[l++],n=null;if(12===m){var p=d[l++];0===p?(d[l-2]=139,d[l-1]=22,f=0):n=Wr[p]}else if(28===m)h[f]=(d[l]<<24|d[l+1]<<16)>>16,l+=2,f++;else if(14===m){if(4<=f&&(f-=4,this.seacAnalysisEnabled))return b.seac=h.slice(f,f+4),!1;n=Re[m]}else if(32<=m&&246>=m)h[f]=m-139,f++;else if(247<=m&&254>=m)h[f]=251>m?(m-247<<8)+d[l]+108:-(m-251<<8)-d[l]-108,l++,f++;else if(255===m)h[f]=(d[l]<<\n24|d[l+1]<<16|d[l+2]<<8|d[l+3])/65536,l+=4,f++;else if(19===m||20===m){b.hints+=f>>1;if(0===b.hints){d.copyWithin(l-1,l,-1);--l;--k;continue}l+=b.hints+7>>3;f%=2;n=Re[m]}else if(10===m||29===m){n=10===m?e:g;if(!n)return n=Re[m],T("Missing subrsIndex for "+n.id),!1;p=32768;1240>n.count?p=107:33900>n.count&&(p=1131);p=h[--f]+p;if(0>p||p>=n.count||isNaN(p))return n=Re[m],T("Out of bounds subrIndex for "+n.id),!1;b.stackSize=f;b.callDepth++;if(!this.parseCharString(b,n.get(p),e,g))return!1;b.callDepth--;\nf=b.stackSize;continue}else{if(11===m)return b.stackSize=f,!0;if(0===m&&l===d.length)d[l-1]=14,n=Re[14];else if(9===m){d.copyWithin(l-1,l,-1);--l;--k;continue}else n=Re[m]}if(n){n.stem&&(b.hints+=f>>1,3===m||23===m?b.hasVStems=!0:!b.hasVStems||1!==m&&18!==m||(T("CFF stem hints are in wrong order"),d[l-1]=1===m?3:23));if("min"in n&&!b.undefStack&&f<n.min)return T("Not enough parameters for "+n.id+"; actual: "+f+", expected: "+n.min),0===f?(d[l-1]=14,!0):!1;b.firstStackClearing&&n.stackClearing&&(b.firstStackClearing=\n!1,f-=n.min,2<=f&&n.stem?f%=2:1<f&&T("Found too many parameters for stack-clearing command"),0<f&&(b.width=h[f-1]));"stackDelta"in n?("stackFn"in n&&n.stackFn(h,f),f+=n.stackDelta):n.stackClearing?f=0:n.resetStack?(f=0,b.undefStack=!1):n.undefStack&&(f=0,b.undefStack=!0,b.firstStackClearing=!1)}}k<d.length&&d.fill(14,k);b.stackSize=f;return!0};c.parseCharStrings=function(b){var d=b.charStrings,e=b.localSubrIndex,g=b.globalSubrIndex,f=b.fdSelect,h=b.fdArray;b=b.privateDict;for(var k=[],l=[],m=d.count,\nn=0;n<m;n++){var p=d.get(n),q={callDepth:0,stackSize:0,stack:[],undefStack:!0,hints:0,firstStackClearing:!0,seac:null,width:null,hasVStems:!1},r=!0,t=null,v=b;if(f&&h.length){var w=f.getFDIndex(n);-1===w&&(T("Glyph index is not in fd select."),r=!1);w>=h.length&&(T("Invalid fd index for glyph index."),r=!1);r&&(v=h[w].privateDict,t=v.subrsIndex)}else e&&(t=e);r&&(r=this.parseCharString(q,p,t,g));null!==q.width?(p=v.getByName("nominalWidthX"),l[n]=p+q.width):(p=v.getByName("defaultWidthX"),l[n]=p);\nnull!==q.seac&&(k[n]=q.seac);r||d.set(n,new Uint8Array([14]))}return{charStrings:d,seacs:k,widths:l}};c.emptyPrivateDictionary=function(b){var d=this.createDict(qj,[],b.strings);b.setByKey(18,[0,0]);b.privateDict=d};c.parsePrivateDict=function(b){if(b.hasName("Private")){var d=b.getByName("Private");if(Array.isArray(d)&&2===d.length){var e=d[0];d=d[1];if(0===e||d>=this.bytes.length)this.emptyPrivateDictionary(b);else if(e=this.bytes.subarray(d,d+e),e=this.parseDict(e),e=this.createDict(qj,e,b.strings),\nb.privateDict=e,0===e.getByName("ExpansionFactor")&&e.setByName("ExpansionFactor",.06),e.getByName("Subrs")){var g=e.getByName("Subrs");d+=g;0===g||d>=this.bytes.length?this.emptyPrivateDictionary(b):(b=this.parseIndex(d),e.subrsIndex=b.obj)}}else b.removeByName("Private")}else this.emptyPrivateDictionary(b)};c.parseCharsets=function(b,d,e,g){if(0===b)return new Ba(!0,rj.ISO_ADOBE,Tr);if(1===b)return new Ba(!0,rj.EXPERT,Ur);if(2===b)return new Ba(!0,rj.EXPERT_SUBSET,Vr);var f=this.bytes,h=b,k=f[b++],\nl=[g?0:".notdef"],m;--d;switch(k){case 0:for(m=0;m<d;m++){var n=f[b++]<<8|f[b++];l.push(g?n:e.get(n))}break;case 1:for(;l.length<=d;){n=f[b++]<<8|f[b++];var p=f[b++];for(m=0;m<=p;m++)l.push(g?n++:e.get(n++))}break;case 2:for(;l.length<=d;)for(n=f[b++]<<8|f[b++],p=f[b++]<<8|f[b++],m=0;m<=p;m++)l.push(g?n++:e.get(n++));break;default:throw new oa("Unknown charset format");}b=f.subarray(h,b);return new Ba(!1,k,l,b)};c.parseEncoding=function(b,d,e,g){d=Object.create(null);var f=this.bytes,h=!1,k,l=null;\nif(0===b||1===b){h=!0;e=(k=b)?Vk:Bd;var m=0;for(b=g.length;m<b;m++)f=e.indexOf(g[m]),-1!==f&&(d[f]=m)}else{l=b;k=f[b++];switch(k&127){case 0:var n=f[b++];for(m=1;m<=n;m++)d[f[b++]]=m;break;case 1:n=f[b++];var p=1;for(m=0;m<n;m++)for(var q=f[b++],r=f[b++],t=q;t<=q+r;t++)d[t]=p++;break;default:throw new oa("Unknown encoding format: "+k+" in CFF");}n=b;if(k&128)for(f[l]&=127,p=f[b++],m=0;m<p;m++)q=f[b++],r=(f[b++]<<8)+(f[b++]&255),d[q]=g.indexOf(e.get(r));l=f.subarray(l,n)}return new Qa(h,k&127,d,l)};\nc.parseFDSelect=function(b,d){var e=this.bytes,g=e[b++],f=[],h;switch(g){case 0:for(h=0;h<d;++h){var k=e[b++];f.push(k)}break;case 3:k=e[b++]<<8|e[b++];for(h=0;h<k;++h){var l=e[b++]<<8|e[b++];0===h&&0!==l&&(T("parseFDSelect: The first range must have a first GID of 0 -- trying to recover."),l=0);for(var m=e[b++],n=e[b]<<8|e[b+1];l<n;++l)f.push(m)}break;default:throw new oa(\'parseFDSelect: Unknown format "\'+g+\'".\');}if(f.length!==d)throw new oa("parseFDSelect: Invalid font data.");return new Xr(g,\nf)};return a}(),Ln=function(){function a(){this.header=null;this.names=[];this.topDict=null;this.strings=new pj;this.charStrings=this.charset=this.encoding=this.globalSubrIndex=null;this.fdArray=[];this.fdSelect=null;this.isCIDFont=!1}var c=a.prototype;c.duplicateFirstGlyph=function(){if(65535<=this.charStrings.count)T("Not enough space in charstrings to duplicate first glyph.");else{var b=this.charStrings.get(0);this.charStrings.add(b);this.isCIDFont&&this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0])}};\nc.hasGlyphId=function(b){return 0>b||b>=this.charStrings.count?!1:0<this.charStrings.get(b).length};return a}(),pj=function(){function a(){this.strings=[]}var c=a.prototype;c.get=function(b){return 0<=b&&390>=b?Mg[b]:b-391<=this.strings.length?this.strings[b-391]:Mg[0]};c.getSID=function(b){var d=Mg.indexOf(b);if(-1!==d)return d;d=this.strings.indexOf(b);return-1!==d?d+391:-1};c.add=function(b){this.strings.push(b)};return kf(a,[{key:"count",get:function(){return this.strings.length}}])}(),Wd=function(){function a(){this.objects=\n[];this.length=0}var c=a.prototype;c.add=function(b){this.length+=b.length;this.objects.push(b)};c.set=function(b,d){this.length+=d.length-this.objects[b].length;this.objects[b]=d};c.get=function(b){return this.objects[b]};return kf(a,[{key:"count",get:function(){return this.objects.length}}])}(),Mn=function(){function a(b,d){this.keyToNameMap=b.keyToNameMap;this.nameToKeyMap=b.nameToKeyMap;this.defaults=b.defaults;this.types=b.types;this.opcodes=b.opcodes;this.order=b.order;this.strings=d;this.values=\nObject.create(null)}var c=a.prototype;c.setByKey=function(b,d){if(!(b in this.keyToNameMap))return!1;if(0===d.length)return!0;for(var e=u.makeIterator(d),g=e.next();!g.done;g=e.next())if(isNaN(g.value))return T(\'Invalid CFFDict value: "\'+d+\'" for key "\'+b+\'".\'),!0;e=this.types[b];if("num"===e||"sid"===e||"offset"===e)d=d[0];this.values[b]=d;return!0};c.setByName=function(b,d){if(!(b in this.nameToKeyMap))throw new oa(\'Invalid dictionary name "\'+b+\'"\');this.values[this.nameToKeyMap[b]]=d};c.hasName=\nfunction(b){return this.nameToKeyMap[b]in this.values};c.getByName=function(b){if(!(b in this.nameToKeyMap))throw new oa("Invalid dictionary name "+b+\'"\');b=this.nameToKeyMap[b];return b in this.values?this.values[b]:this.defaults[b]};c.removeByName=function(b){delete this.values[this.nameToKeyMap[b]]};a.createTables=function(b){var d={keyToNameMap:{},nameToKeyMap:{},defaults:{},types:{},opcodes:{},order:[]};b=u.makeIterator(b);for(var e=b.next();!e.done;e=b.next()){e=e.value;var g=Array.isArray(e[0])?\n(e[0][0]<<8)+e[0][1]:e[0];d.keyToNameMap[g]=e[1];d.nameToKeyMap[e[1]]=g;d.types[g]=e[2];d.defaults[g]=e[3];d.opcodes[g]=Array.isArray(e[0])?e[0]:[e[0]];d.order.push(g)}return d};return a}(),Yr=[[[12,30],"ROS",["sid","sid","num"],null],[[12,20],"SyntheticBase","num",null],[0,"version","sid",null],[1,"Notice","sid",null],[[12,0],"Copyright","sid",null],[2,"FullName","sid",null],[3,"FamilyName","sid",null],[4,"Weight","sid",null],[[12,1],"isFixedPitch","num",0],[[12,2],"ItalicAngle","num",0],[[12,3],\n"UnderlinePosition","num",-100],[[12,4],"UnderlineThickness","num",50],[[12,5],"PaintType","num",0],[[12,6],"CharstringType","num",2],[[12,7],"FontMatrix","num num num num num num".split(" "),[.001,0,0,.001,0,0]],[13,"UniqueID","num",null],[5,"FontBBox",["num","num","num","num"],[0,0,0,0]],[[12,8],"StrokeWidth","num",0],[14,"XUID","array",null],[15,"charset","offset",0],[16,"Encoding","offset",0],[17,"CharStrings","offset",0],[18,"Private",["offset","offset"],null],[[12,21],"PostScript","sid",null],\n[[12,22],"BaseFontName","sid",null],[[12,23],"BaseFontBlend","delta",null],[[12,31],"CIDFontVersion","num",0],[[12,32],"CIDFontRevision","num",0],[[12,33],"CIDFontType","num",0],[[12,34],"CIDCount","num",8720],[[12,35],"UIDBase","num",null],[[12,37],"FDSelect","offset",null],[[12,36],"FDArray","offset",null],[[12,38],"FontName","sid",null]],oj=function(a){function c(b){b=a.call(this,c.tables,b)||this;b.privateDict=null;return b}Wk(c,a);return kf(c,null,[{key:"tables",get:function(){return Fa(this,\n"tables",this.createTables(Yr))}}])}(Mn),Zr=[[6,"BlueValues","delta",null],[7,"OtherBlues","delta",null],[8,"FamilyBlues","delta",null],[9,"FamilyOtherBlues","delta",null],[[12,9],"BlueScale","num",.039625],[[12,10],"BlueShift","num",7],[[12,11],"BlueFuzz","num",1],[10,"StdHW","num",null],[11,"StdVW","num",null],[[12,12],"StemSnapH","delta",null],[[12,13],"StemSnapV","delta",null],[[12,14],"ForceBold","num",0],[[12,17],"LanguageGroup","num",0],[[12,18],"ExpansionFactor","num",.06],[[12,19],"initialRandomSeed",\n"num",0],[20,"defaultWidthX","num",0],[21,"nominalWidthX","num",0],[19,"Subrs","offset",null]],qj=function(a){function c(b){b=a.call(this,c.tables,b)||this;b.subrsIndex=null;return b}Wk(c,a);return kf(c,null,[{key:"tables",get:function(){return Fa(this,"tables",this.createTables(Zr))}}])}(Mn),rj={ISO_ADOBE:0,EXPERT:1,EXPERT_SUBSET:2},Xr=function(){function a(c,b){this.format=c;this.fdSelect=b}a.prototype.getFDIndex=function(c){return 0>c||c>=this.fdSelect.length?-1:this.fdSelect[c]};return a}(),Nn=\nfunction(){function a(){this.offsets=Object.create(null)}var c=a.prototype;c.isTracking=function(b){return b in this.offsets};c.track=function(b,d){if(b in this.offsets)throw new oa("Already tracking location of "+b);this.offsets[b]=d};c.offset=function(b){for(var d in this.offsets)this.offsets[d]+=b};c.setEntryLocation=function(b,d,e){if(!(b in this.offsets))throw new oa("Not tracking location of "+b);e=e.data;b=this.offsets[b];for(var g=0,f=d.length;g<f;++g){var h=5*g+b,k=h+1,l=h+2,m=h+3,n=h+4;\nif(29!==e[h]||0!==e[k]||0!==e[l]||0!==e[m]||0!==e[n])throw new oa("writing to an offset that is not empty");var p=d[g];e[h]=29;e[k]=p>>24&255;e[l]=p>>16&255;e[m]=p>>8&255;e[n]=p&255}};return a}(),tj=function(){function a(b){this.cff=b}var c=a.prototype;c.compile=function(){var b=this.cff,d={data:[],length:0,add:function(k){try{this.data.push.apply(this.data,u.arrayFromIterable(k))}catch(l){this.data=this.data.concat(k)}this.length=this.data.length}},e=this.compileHeader(b.header);d.add(e);e=this.compileNameIndex(b.names);\nd.add(e);if(b.isCIDFont&&b.topDict.hasName("FontMatrix")){e=b.topDict.getByName("FontMatrix");b.topDict.removeByName("FontMatrix");for(var g=u.makeIterator(b.fdArray),f=g.next();!f.done;f=g.next()){f=f.value;var h=e.slice(0);f.hasName("FontMatrix")&&(h=Rb.transform(h,f.getByName("FontMatrix")));f.setByName("FontMatrix",h)}}e=b.topDict.getByName("XUID");16<(null==e?void 0:e.length)&&b.topDict.removeByName("XUID");b.topDict.setByName("charset",0);g=this.compileTopDicts([b.topDict],d.length,b.isCIDFont);\nd.add(g.output);e=g.trackers[0];g=this.compileStringIndex(b.strings.strings);d.add(g);g=this.compileIndex(b.globalSubrIndex);d.add(g);b.encoding&&b.topDict.hasName("Encoding")&&(b.encoding.predefined?e.setEntryLocation("Encoding",[b.encoding.format],d):(g=this.compileEncoding(b.encoding),e.setEntryLocation("Encoding",[d.length],d),d.add(g)));g=this.compileCharset(b.charset,b.charStrings.count,b.strings,b.isCIDFont);e.setEntryLocation("charset",[d.length],d);d.add(g);g=this.compileCharStrings(b.charStrings);\ne.setEntryLocation("CharStrings",[d.length],d);d.add(g);b.isCIDFont&&(e.setEntryLocation("FDSelect",[d.length],d),g=this.compileFDSelect(b.fdSelect),d.add(g),g=this.compileTopDicts(b.fdArray,d.length,!0),e.setEntryLocation("FDArray",[d.length],d),d.add(g.output),this.compilePrivateDicts(b.fdArray,g.trackers,d));this.compilePrivateDicts([b.topDict],[e],d);d.add([0]);return d.data};c.encodeNumber=function(b){return Number.isInteger(b)?this.encodeInteger(b):this.encodeFloat(b)};c.encodeFloat=function(b){var d=\nb.toString(),e=a.EncodeFloatRegExp.exec(d);e&&(d=parseFloat("1e"+((e[2]?+e[2]:0)+e[1].length)),d=(Math.round(b*d)/d).toString());b="";var g;e=0;for(g=d.length;e<g;++e){var f=d[e];b="e"===f?b+("-"===d[++e]?"c":"b"):"."===f?b+"a":"-"===f?b+"e":b+f}b+=b.length&1?"f":"ff";d=[30];e=0;for(g=b.length;e<g;e+=2)d.push(parseInt(b.substring(e,e+2),16));return d};c.encodeInteger=function(b){-107<=b&&107>=b?b=[b+139]:108<=b&&1131>=b?(b-=108,b=[(b>>8)+247,b&255]):-1131<=b&&-108>=b?(b=-b-108,b=[(b>>8)+251,b&255]):\nb=-32768<=b&&32767>=b?[28,b>>8&255,b&255]:[29,b>>24&255,b>>16&255,b>>8&255,b&255];return b};c.compileHeader=function(b){return[b.major,b.minor,4,b.offSize]};c.compileNameIndex=function(b){var d=new Wd;b=u.makeIterator(b);for(var e=b.next();!e.done;e=b.next()){e=e.value;for(var g=Math.min(e.length,127),f=Array(g),h=0;h<g;h++){var k=e[h];if("!">k||"~"<k||"["===k||"]"===k||"("===k||")"===k||"{"===k||"}"===k||"<"===k||">"===k||"/"===k||"%"===k)k="_";f[h]=k}f=f.join("");""===f&&(f="Bad_Font_Name");d.add(jc(f))}return this.compileIndex(d)};\nc.compileTopDicts=function(b,d,e){var g=[],f=new Wd;b=u.makeIterator(b);for(var h=b.next();!h.done;h=b.next()){var k=h.value;e&&(k.removeByName("CIDFontVersion"),k.removeByName("CIDFontRevision"),k.removeByName("CIDFontType"),k.removeByName("CIDCount"),k.removeByName("UIDBase"));h=new Nn;k=this.compileDict(k,h);g.push(h);f.add(k);h.offset(d)}f=this.compileIndex(f,g);return{trackers:g,output:f}};c.compilePrivateDicts=function(b,d,e){for(var g=0,f=b.length;g<f;++g){var h=b[g],k=h.privateDict;if(!k||\n!h.hasName("Private"))throw new oa("There must be a private dictionary.");h=new Nn;var l=this.compileDict(k,h),m=e.length;h.offset(m);l.length||(m=0);d[g].setEntryLocation("Private",[l.length,m],e);e.add(l);k.subrsIndex&&k.hasName("Subrs")&&(k=this.compileIndex(k.subrsIndex),h.setEntryLocation("Subrs",[l.length],e),e.add(k))}};c.compileDict=function(b,d){for(var e=[],g=u.makeIterator(b.order),f=g.next();!f.done;f=g.next())if(f=f.value,f in b.values){var h=b.values[f],k=b.types[f];Array.isArray(k)||\n(k=[k]);Array.isArray(h)||(h=[h]);if(0!==h.length){for(var l=0,m=k.length;l<m;++l){var n=k[l],p=h[l];switch(n){case "num":case "sid":e.push.apply(e,u.arrayFromIterable(this.encodeNumber(p)));break;case "offset":n=b.keyToNameMap[f];d.isTracking(n)||d.track(n,e.length);e.push(29,0,0,0,0);break;case "array":case "delta":e.push.apply(e,u.arrayFromIterable(this.encodeNumber(p)));n=1;for(p=h.length;n<p;++n)e.push.apply(e,u.arrayFromIterable(this.encodeNumber(h[n])));break;default:throw new oa("Unknown data type of "+\nn);}}e.push.apply(e,u.arrayFromIterable(b.opcodes[f]))}}return e};c.compileStringIndex=function(b){var d=new Wd;b=u.makeIterator(b);for(var e=b.next();!e.done;e=b.next())d.add(jc(e.value));return this.compileIndex(d)};c.compileCharStrings=function(b){for(var d=new Wd,e=0;e<b.count;e++){var g=b.get(e);0===g.length?d.add(new Uint8Array([139,14])):d.add(g)}return this.compileIndex(d)};c.compileCharset=function(b,d,e,g){--d;if(g)g=new Uint8Array([2,0,0,d>>8&255,d&255]);else{g=new Uint8Array(1+2*d);d=\ng[0]=0;for(var f=b.charset.length,h=!1,k=1;k<g.length;k+=2){var l=0;if(d<f){var m=b.charset[d++];l=e.getSID(m);-1===l&&(l=0,h||(h=!0,T("Couldn\'t find "+m+" in CFF strings")))}g[k]=l>>8&255;g[k+1]=l&255}}return this.compileTypedArray(g)};c.compileEncoding=function(b){return this.compileTypedArray(b.raw)};c.compileFDSelect=function(b){var d=b.format;switch(d){case 0:var e=new Uint8Array(1+b.fdSelect.length);e[0]=d;for(d=0;d<b.fdSelect.length;d++)e[d+1]=b.fdSelect[d];break;case 3:e=b.fdSelect[0];var g=\n[d,0,0,0,0,e];for(d=1;d<b.fdSelect.length;d++){var f=b.fdSelect[d];f!==e&&(g.push(d>>8&255,d&255,f),e=f)}b=(g.length-3)/3;g[1]=b>>8&255;g[2]=b&255;g.push(d>>8&255,d&255);e=new Uint8Array(g)}return this.compileTypedArray(e)};c.compileTypedArray=function(b){return Array.from(b)};c.compileIndex=function(b,d){void 0===d&&(d=[]);b=b.objects;var e=b.length;if(0===e)return[0,0];var g=[e>>8&255,e&255],f=1,h;for(h=0;h<e;++h)f+=b[h].length;f=256>f?1:65536>f?2:16777216>f?3:4;g.push(f);var k=1;for(h=0;h<e+1;h++)1===\nf?g.push(k&255):2===f?g.push(k>>8&255,k&255):3===f?g.push(k>>16&255,k>>8&255,k&255):g.push(k>>>24&255,k>>16&255,k>>8&255,k&255),b[h]&&(k+=b[h].length);for(h=0;h<e;h++)d[h]&&d[h].offset(g.length),g.push.apply(g,u.arrayFromIterable(b[h]));return g};return kf(a,null,[{key:"EncodeFloatRegExp",get:function(){return Fa(this,"EncodeFloatRegExp",/\\.(\\d*?)(?:9{5,20}|0{5,20})\\d{0,2}(?:e(.+)|$)/)}}])}(),ud=xb(function(a){a.A=65;a.AE=198;a.AEacute=508;a.AEmacron=482;a.AEsmall=63462;a.Aacute=193;a.Aacutesmall=\n63457;a.Abreve=258;a.Abreveacute=7854;a.Abrevecyrillic=1232;a.Abrevedotbelow=7862;a.Abrevegrave=7856;a.Abrevehookabove=7858;a.Abrevetilde=7860;a.Acaron=461;a.Acircle=9398;a.Acircumflex=194;a.Acircumflexacute=7844;a.Acircumflexdotbelow=7852;a.Acircumflexgrave=7846;a.Acircumflexhookabove=7848;a.Acircumflexsmall=63458;a.Acircumflextilde=7850;a.Acute=63177;a.Acutesmall=63412;a.Acyrillic=1040;a.Adblgrave=512;a.Adieresis=196;a.Adieresiscyrillic=1234;a.Adieresismacron=478;a.Adieresissmall=63460;a.Adotbelow=\n7840;a.Adotmacron=480;a.Agrave=192;a.Agravesmall=63456;a.Ahookabove=7842;a.Aiecyrillic=1236;a.Ainvertedbreve=514;a.Alpha=913;a.Alphatonos=902;a.Amacron=256;a.Amonospace=65313;a.Aogonek=260;a.Aring=197;a.Aringacute=506;a.Aringbelow=7680;a.Aringsmall=63461;a.Asmall=63329;a.Atilde=195;a.Atildesmall=63459;a.Aybarmenian=1329;a.B=66;a.Bcircle=9399;a.Bdotaccent=7682;a.Bdotbelow=7684;a.Becyrillic=1041;a.Benarmenian=1330;a.Beta=914;a.Bhook=385;a.Blinebelow=7686;a.Bmonospace=65314;a.Brevesmall=63220;a.Bsmall=\n63330;a.Btopbar=386;a.C=67;a.Caarmenian=1342;a.Cacute=262;a.Caron=63178;a.Caronsmall=63221;a.Ccaron=268;a.Ccedilla=199;a.Ccedillaacute=7688;a.Ccedillasmall=63463;a.Ccircle=9400;a.Ccircumflex=264;a.Cdot=266;a.Cdotaccent=266;a.Cedillasmall=63416;a.Chaarmenian=1353;a.Cheabkhasiancyrillic=1212;a.Checyrillic=1063;a.Chedescenderabkhasiancyrillic=1214;a.Chedescendercyrillic=1206;a.Chedieresiscyrillic=1268;a.Cheharmenian=1347;a.Chekhakassiancyrillic=1227;a.Cheverticalstrokecyrillic=1208;a.Chi=935;a.Chook=\n391;a.Circumflexsmall=63222;a.Cmonospace=65315;a.Coarmenian=1361;a.Csmall=63331;a.D=68;a.DZ=497;a.DZcaron=452;a.Daarmenian=1332;a.Dafrican=393;a.Dcaron=270;a.Dcedilla=7696;a.Dcircle=9401;a.Dcircumflexbelow=7698;a.Dcroat=272;a.Ddotaccent=7690;a.Ddotbelow=7692;a.Decyrillic=1044;a.Deicoptic=1006;a.Delta=8710;a.Deltagreek=916;a.Dhook=394;a.Dieresis=63179;a.DieresisAcute=63180;a.DieresisGrave=63181;a.Dieresissmall=63400;a.Digammagreek=988;a.Djecyrillic=1026;a.Dlinebelow=7694;a.Dmonospace=65316;a.Dotaccentsmall=\n63223;a.Dslash=272;a.Dsmall=63332;a.Dtopbar=395;a.Dz=498;a.Dzcaron=453;a.Dzeabkhasiancyrillic=1248;a.Dzecyrillic=1029;a.Dzhecyrillic=1039;a.E=69;a.Eacute=201;a.Eacutesmall=63465;a.Ebreve=276;a.Ecaron=282;a.Ecedillabreve=7708;a.Echarmenian=1333;a.Ecircle=9402;a.Ecircumflex=202;a.Ecircumflexacute=7870;a.Ecircumflexbelow=7704;a.Ecircumflexdotbelow=7878;a.Ecircumflexgrave=7872;a.Ecircumflexhookabove=7874;a.Ecircumflexsmall=63466;a.Ecircumflextilde=7876;a.Ecyrillic=1028;a.Edblgrave=516;a.Edieresis=203;\na.Edieresissmall=63467;a.Edot=278;a.Edotaccent=278;a.Edotbelow=7864;a.Efcyrillic=1060;a.Egrave=200;a.Egravesmall=63464;a.Eharmenian=1335;a.Ehookabove=7866;a.Eightroman=8551;a.Einvertedbreve=518;a.Eiotifiedcyrillic=1124;a.Elcyrillic=1051;a.Elevenroman=8554;a.Emacron=274;a.Emacronacute=7702;a.Emacrongrave=7700;a.Emcyrillic=1052;a.Emonospace=65317;a.Encyrillic=1053;a.Endescendercyrillic=1186;a.Eng=330;a.Enghecyrillic=1188;a.Enhookcyrillic=1223;a.Eogonek=280;a.Eopen=400;a.Epsilon=917;a.Epsilontonos=904;\na.Ercyrillic=1056;a.Ereversed=398;a.Ereversedcyrillic=1069;a.Escyrillic=1057;a.Esdescendercyrillic=1194;a.Esh=425;a.Esmall=63333;a.Eta=919;a.Etarmenian=1336;a.Etatonos=905;a.Eth=208;a.Ethsmall=63472;a.Etilde=7868;a.Etildebelow=7706;a.Euro=8364;a.Ezh=439;a.Ezhcaron=494;a.Ezhreversed=440;a.F=70;a.Fcircle=9403;a.Fdotaccent=7710;a.Feharmenian=1366;a.Feicoptic=996;a.Fhook=401;a.Fitacyrillic=1138;a.Fiveroman=8548;a.Fmonospace=65318;a.Fourroman=8547;a.Fsmall=63334;a.G=71;a.GBsquare=13191;a.Gacute=500;a.Gamma=\n915;a.Gammaafrican=404;a.Gangiacoptic=1002;a.Gbreve=286;a.Gcaron=486;a.Gcedilla=290;a.Gcircle=9404;a.Gcircumflex=284;a.Gcommaaccent=290;a.Gdot=288;a.Gdotaccent=288;a.Gecyrillic=1043;a.Ghadarmenian=1346;a.Ghemiddlehookcyrillic=1172;a.Ghestrokecyrillic=1170;a.Gheupturncyrillic=1168;a.Ghook=403;a.Gimarmenian=1331;a.Gjecyrillic=1027;a.Gmacron=7712;a.Gmonospace=65319;a.Grave=63182;a.Gravesmall=63328;a.Gsmall=63335;a.Gsmallhook=667;a.Gstroke=484;a.H=72;a.H18533=9679;a.H18543=9642;a.H18551=9643;a.H22073=\n9633;a.HPsquare=13259;a.Haabkhasiancyrillic=1192;a.Hadescendercyrillic=1202;a.Hardsigncyrillic=1066;a.Hbar=294;a.Hbrevebelow=7722;a.Hcedilla=7720;a.Hcircle=9405;a.Hcircumflex=292;a.Hdieresis=7718;a.Hdotaccent=7714;a.Hdotbelow=7716;a.Hmonospace=65320;a.Hoarmenian=1344;a.Horicoptic=1E3;a.Hsmall=63336;a.Hungarumlaut=63183;a.Hungarumlautsmall=63224;a.Hzsquare=13200;a.I=73;a.IAcyrillic=1071;a.IJ=306;a.IUcyrillic=1070;a.Iacute=205;a.Iacutesmall=63469;a.Ibreve=300;a.Icaron=463;a.Icircle=9406;a.Icircumflex=\n206;a.Icircumflexsmall=63470;a.Icyrillic=1030;a.Idblgrave=520;a.Idieresis=207;a.Idieresisacute=7726;a.Idieresiscyrillic=1252;a.Idieresissmall=63471;a.Idot=304;a.Idotaccent=304;a.Idotbelow=7882;a.Iebrevecyrillic=1238;a.Iecyrillic=1045;a.Ifraktur=8465;a.Igrave=204;a.Igravesmall=63468;a.Ihookabove=7880;a.Iicyrillic=1048;a.Iinvertedbreve=522;a.Iishortcyrillic=1049;a.Imacron=298;a.Imacroncyrillic=1250;a.Imonospace=65321;a.Iniarmenian=1339;a.Iocyrillic=1025;a.Iogonek=302;a.Iota=921;a.Iotaafrican=406;a.Iotadieresis=\n938;a.Iotatonos=906;a.Ismall=63337;a.Istroke=407;a.Itilde=296;a.Itildebelow=7724;a.Izhitsacyrillic=1140;a.Izhitsadblgravecyrillic=1142;a.J=74;a.Jaarmenian=1345;a.Jcircle=9407;a.Jcircumflex=308;a.Jecyrillic=1032;a.Jheharmenian=1355;a.Jmonospace=65322;a.Jsmall=63338;a.K=75;a.KBsquare=13189;a.KKsquare=13261;a.Kabashkircyrillic=1184;a.Kacute=7728;a.Kacyrillic=1050;a.Kadescendercyrillic=1178;a.Kahookcyrillic=1219;a.Kappa=922;a.Kastrokecyrillic=1182;a.Kaverticalstrokecyrillic=1180;a.Kcaron=488;a.Kcedilla=\n310;a.Kcircle=9408;a.Kcommaaccent=310;a.Kdotbelow=7730;a.Keharmenian=1364;a.Kenarmenian=1343;a.Khacyrillic=1061;a.Kheicoptic=998;a.Khook=408;a.Kjecyrillic=1036;a.Klinebelow=7732;a.Kmonospace=65323;a.Koppacyrillic=1152;a.Koppagreek=990;a.Ksicyrillic=1134;a.Ksmall=63339;a.L=76;a.LJ=455;a.LL=63167;a.Lacute=313;a.Lambda=923;a.Lcaron=317;a.Lcedilla=315;a.Lcircle=9409;a.Lcircumflexbelow=7740;a.Lcommaaccent=315;a.Ldot=319;a.Ldotaccent=319;a.Ldotbelow=7734;a.Ldotbelowmacron=7736;a.Liwnarmenian=1340;a.Lj=\n456;a.Ljecyrillic=1033;a.Llinebelow=7738;a.Lmonospace=65324;a.Lslash=321;a.Lslashsmall=63225;a.Lsmall=63340;a.M=77;a.MBsquare=13190;a.Macron=63184;a.Macronsmall=63407;a.Macute=7742;a.Mcircle=9410;a.Mdotaccent=7744;a.Mdotbelow=7746;a.Menarmenian=1348;a.Mmonospace=65325;a.Msmall=63341;a.Mturned=412;a.Mu=924;a.N=78;a.NJ=458;a.Nacute=323;a.Ncaron=327;a.Ncedilla=325;a.Ncircle=9411;a.Ncircumflexbelow=7754;a.Ncommaaccent=325;a.Ndotaccent=7748;a.Ndotbelow=7750;a.Nhookleft=413;a.Nineroman=8552;a.Nj=459;a.Njecyrillic=\n1034;a.Nlinebelow=7752;a.Nmonospace=65326;a.Nowarmenian=1350;a.Nsmall=63342;a.Ntilde=209;a.Ntildesmall=63473;a.Nu=925;a.O=79;a.OE=338;a.OEsmall=63226;a.Oacute=211;a.Oacutesmall=63475;a.Obarredcyrillic=1256;a.Obarreddieresiscyrillic=1258;a.Obreve=334;a.Ocaron=465;a.Ocenteredtilde=415;a.Ocircle=9412;a.Ocircumflex=212;a.Ocircumflexacute=7888;a.Ocircumflexdotbelow=7896;a.Ocircumflexgrave=7890;a.Ocircumflexhookabove=7892;a.Ocircumflexsmall=63476;a.Ocircumflextilde=7894;a.Ocyrillic=1054;a.Odblacute=336;\na.Odblgrave=524;a.Odieresis=214;a.Odieresiscyrillic=1254;a.Odieresissmall=63478;a.Odotbelow=7884;a.Ogoneksmall=63227;a.Ograve=210;a.Ogravesmall=63474;a.Oharmenian=1365;a.Ohm=8486;a.Ohookabove=7886;a.Ohorn=416;a.Ohornacute=7898;a.Ohorndotbelow=7906;a.Ohorngrave=7900;a.Ohornhookabove=7902;a.Ohorntilde=7904;a.Ohungarumlaut=336;a.Oi=418;a.Oinvertedbreve=526;a.Omacron=332;a.Omacronacute=7762;a.Omacrongrave=7760;a.Omega=8486;a.Omegacyrillic=1120;a.Omegagreek=937;a.Omegaroundcyrillic=1146;a.Omegatitlocyrillic=\n1148;a.Omegatonos=911;a.Omicron=927;a.Omicrontonos=908;a.Omonospace=65327;a.Oneroman=8544;a.Oogonek=490;a.Oogonekmacron=492;a.Oopen=390;a.Oslash=216;a.Oslashacute=510;a.Oslashsmall=63480;a.Osmall=63343;a.Ostrokeacute=510;a.Otcyrillic=1150;a.Otilde=213;a.Otildeacute=7756;a.Otildedieresis=7758;a.Otildesmall=63477;a.P=80;a.Pacute=7764;a.Pcircle=9413;a.Pdotaccent=7766;a.Pecyrillic=1055;a.Peharmenian=1354;a.Pemiddlehookcyrillic=1190;a.Phi=934;a.Phook=420;a.Pi=928;a.Piwrarmenian=1363;a.Pmonospace=65328;\na.Psi=936;a.Psicyrillic=1136;a.Psmall=63344;a.Q=81;a.Qcircle=9414;a.Qmonospace=65329;a.Qsmall=63345;a.R=82;a.Raarmenian=1356;a.Racute=340;a.Rcaron=344;a.Rcedilla=342;a.Rcircle=9415;a.Rcommaaccent=342;a.Rdblgrave=528;a.Rdotaccent=7768;a.Rdotbelow=7770;a.Rdotbelowmacron=7772;a.Reharmenian=1360;a.Rfraktur=8476;a.Rho=929;a.Ringsmall=63228;a.Rinvertedbreve=530;a.Rlinebelow=7774;a.Rmonospace=65330;a.Rsmall=63346;a.Rsmallinverted=641;a.Rsmallinvertedsuperior=694;a.S=83;a.SF010000=9484;a.SF020000=9492;a.SF030000=\n9488;a.SF040000=9496;a.SF050000=9532;a.SF060000=9516;a.SF070000=9524;a.SF080000=9500;a.SF090000=9508;a.SF100000=9472;a.SF110000=9474;a.SF190000=9569;a.SF200000=9570;a.SF210000=9558;a.SF220000=9557;a.SF230000=9571;a.SF240000=9553;a.SF250000=9559;a.SF260000=9565;a.SF270000=9564;a.SF280000=9563;a.SF360000=9566;a.SF370000=9567;a.SF380000=9562;a.SF390000=9556;a.SF400000=9577;a.SF410000=9574;a.SF420000=9568;a.SF430000=9552;a.SF440000=9580;a.SF450000=9575;a.SF460000=9576;a.SF470000=9572;a.SF480000=9573;\na.SF490000=9561;a.SF500000=9560;a.SF510000=9554;a.SF520000=9555;a.SF530000=9579;a.SF540000=9578;a.Sacute=346;a.Sacutedotaccent=7780;a.Sampigreek=992;a.Scaron=352;a.Scarondotaccent=7782;a.Scaronsmall=63229;a.Scedilla=350;a.Schwa=399;a.Schwacyrillic=1240;a.Schwadieresiscyrillic=1242;a.Scircle=9416;a.Scircumflex=348;a.Scommaaccent=536;a.Sdotaccent=7776;a.Sdotbelow=7778;a.Sdotbelowdotaccent=7784;a.Seharmenian=1357;a.Sevenroman=8550;a.Shaarmenian=1351;a.Shacyrillic=1064;a.Shchacyrillic=1065;a.Sheicoptic=\n994;a.Shhacyrillic=1210;a.Shimacoptic=1004;a.Sigma=931;a.Sixroman=8549;a.Smonospace=65331;a.Softsigncyrillic=1068;a.Ssmall=63347;a.Stigmagreek=986;a.T=84;a.Tau=932;a.Tbar=358;a.Tcaron=356;a.Tcedilla=354;a.Tcircle=9417;a.Tcircumflexbelow=7792;a.Tcommaaccent=354;a.Tdotaccent=7786;a.Tdotbelow=7788;a.Tecyrillic=1058;a.Tedescendercyrillic=1196;a.Tenroman=8553;a.Tetsecyrillic=1204;a.Theta=920;a.Thook=428;a.Thorn=222;a.Thornsmall=63486;a.Threeroman=8546;a.Tildesmall=63230;a.Tiwnarmenian=1359;a.Tlinebelow=\n7790;a.Tmonospace=65332;a.Toarmenian=1337;a.Tonefive=444;a.Tonesix=388;a.Tonetwo=423;a.Tretroflexhook=430;a.Tsecyrillic=1062;a.Tshecyrillic=1035;a.Tsmall=63348;a.Twelveroman=8555;a.Tworoman=8545;a.U=85;a.Uacute=218;a.Uacutesmall=63482;a.Ubreve=364;a.Ucaron=467;a.Ucircle=9418;a.Ucircumflex=219;a.Ucircumflexbelow=7798;a.Ucircumflexsmall=63483;a.Ucyrillic=1059;a.Udblacute=368;a.Udblgrave=532;a.Udieresis=220;a.Udieresisacute=471;a.Udieresisbelow=7794;a.Udieresiscaron=473;a.Udieresiscyrillic=1264;a.Udieresisgrave=\n475;a.Udieresismacron=469;a.Udieresissmall=63484;a.Udotbelow=7908;a.Ugrave=217;a.Ugravesmall=63481;a.Uhookabove=7910;a.Uhorn=431;a.Uhornacute=7912;a.Uhorndotbelow=7920;a.Uhorngrave=7914;a.Uhornhookabove=7916;a.Uhorntilde=7918;a.Uhungarumlaut=368;a.Uhungarumlautcyrillic=1266;a.Uinvertedbreve=534;a.Ukcyrillic=1144;a.Umacron=362;a.Umacroncyrillic=1262;a.Umacrondieresis=7802;a.Umonospace=65333;a.Uogonek=370;a.Upsilon=933;a.Upsilon1=978;a.Upsilonacutehooksymbolgreek=979;a.Upsilonafrican=433;a.Upsilondieresis=\n939;a.Upsilondieresishooksymbolgreek=980;a.Upsilonhooksymbol=978;a.Upsilontonos=910;a.Uring=366;a.Ushortcyrillic=1038;a.Usmall=63349;a.Ustraightcyrillic=1198;a.Ustraightstrokecyrillic=1200;a.Utilde=360;a.Utildeacute=7800;a.Utildebelow=7796;a.V=86;a.Vcircle=9419;a.Vdotbelow=7806;a.Vecyrillic=1042;a.Vewarmenian=1358;a.Vhook=434;a.Vmonospace=65334;a.Voarmenian=1352;a.Vsmall=63350;a.Vtilde=7804;a.W=87;a.Wacute=7810;a.Wcircle=9420;a.Wcircumflex=372;a.Wdieresis=7812;a.Wdotaccent=7814;a.Wdotbelow=7816;a.Wgrave=\n7808;a.Wmonospace=65335;a.Wsmall=63351;a.X=88;a.Xcircle=9421;a.Xdieresis=7820;a.Xdotaccent=7818;a.Xeharmenian=1341;a.Xi=926;a.Xmonospace=65336;a.Xsmall=63352;a.Y=89;a.Yacute=221;a.Yacutesmall=63485;a.Yatcyrillic=1122;a.Ycircle=9422;a.Ycircumflex=374;a.Ydieresis=376;a.Ydieresissmall=63487;a.Ydotaccent=7822;a.Ydotbelow=7924;a.Yericyrillic=1067;a.Yerudieresiscyrillic=1272;a.Ygrave=7922;a.Yhook=435;a.Yhookabove=7926;a.Yiarmenian=1349;a.Yicyrillic=1031;a.Yiwnarmenian=1362;a.Ymonospace=65337;a.Ysmall=63353;\na.Ytilde=7928;a.Yusbigcyrillic=1130;a.Yusbigiotifiedcyrillic=1132;a.Yuslittlecyrillic=1126;a.Yuslittleiotifiedcyrillic=1128;a.Z=90;a.Zaarmenian=1334;a.Zacute=377;a.Zcaron=381;a.Zcaronsmall=63231;a.Zcircle=9423;a.Zcircumflex=7824;a.Zdot=379;a.Zdotaccent=379;a.Zdotbelow=7826;a.Zecyrillic=1047;a.Zedescendercyrillic=1176;a.Zedieresiscyrillic=1246;a.Zeta=918;a.Zhearmenian=1338;a.Zhebrevecyrillic=1217;a.Zhecyrillic=1046;a.Zhedescendercyrillic=1174;a.Zhedieresiscyrillic=1244;a.Zlinebelow=7828;a.Zmonospace=\n65338;a.Zsmall=63354;a.Zstroke=437;a.a=97;a.aabengali=2438;a.aacute=225;a.aadeva=2310;a.aagujarati=2694;a.aagurmukhi=2566;a.aamatragurmukhi=2622;a.aarusquare=13059;a.aavowelsignbengali=2494;a.aavowelsigndeva=2366;a.aavowelsigngujarati=2750;a.abbreviationmarkarmenian=1375;a.abbreviationsigndeva=2416;a.abengali=2437;a.abopomofo=12570;a.abreve=259;a.abreveacute=7855;a.abrevecyrillic=1233;a.abrevedotbelow=7863;a.abrevegrave=7857;a.abrevehookabove=7859;a.abrevetilde=7861;a.acaron=462;a.acircle=9424;a.acircumflex=\n226;a.acircumflexacute=7845;a.acircumflexdotbelow=7853;a.acircumflexgrave=7847;a.acircumflexhookabove=7849;a.acircumflextilde=7851;a.acute=180;a.acutebelowcmb=791;a.acutecmb=769;a.acutecomb=769;a.acutedeva=2388;a.acutelowmod=719;a.acutetonecmb=833;a.acyrillic=1072;a.adblgrave=513;a.addakgurmukhi=2673;a.adeva=2309;a.adieresis=228;a.adieresiscyrillic=1235;a.adieresismacron=479;a.adotbelow=7841;a.adotmacron=481;a.ae=230;a.aeacute=509;a.aekorean=12624;a.aemacron=483;a.afii00208=8213;a.afii08941=8356;\na.afii10017=1040;a.afii10018=1041;a.afii10019=1042;a.afii10020=1043;a.afii10021=1044;a.afii10022=1045;a.afii10023=1025;a.afii10024=1046;a.afii10025=1047;a.afii10026=1048;a.afii10027=1049;a.afii10028=1050;a.afii10029=1051;a.afii10030=1052;a.afii10031=1053;a.afii10032=1054;a.afii10033=1055;a.afii10034=1056;a.afii10035=1057;a.afii10036=1058;a.afii10037=1059;a.afii10038=1060;a.afii10039=1061;a.afii10040=1062;a.afii10041=1063;a.afii10042=1064;a.afii10043=1065;a.afii10044=1066;a.afii10045=1067;a.afii10046=\n1068;a.afii10047=1069;a.afii10048=1070;a.afii10049=1071;a.afii10050=1168;a.afii10051=1026;a.afii10052=1027;a.afii10053=1028;a.afii10054=1029;a.afii10055=1030;a.afii10056=1031;a.afii10057=1032;a.afii10058=1033;a.afii10059=1034;a.afii10060=1035;a.afii10061=1036;a.afii10062=1038;a.afii10063=63172;a.afii10064=63173;a.afii10065=1072;a.afii10066=1073;a.afii10067=1074;a.afii10068=1075;a.afii10069=1076;a.afii10070=1077;a.afii10071=1105;a.afii10072=1078;a.afii10073=1079;a.afii10074=1080;a.afii10075=1081;a.afii10076=\n1082;a.afii10077=1083;a.afii10078=1084;a.afii10079=1085;a.afii10080=1086;a.afii10081=1087;a.afii10082=1088;a.afii10083=1089;a.afii10084=1090;a.afii10085=1091;a.afii10086=1092;a.afii10087=1093;a.afii10088=1094;a.afii10089=1095;a.afii10090=1096;a.afii10091=1097;a.afii10092=1098;a.afii10093=1099;a.afii10094=1100;a.afii10095=1101;a.afii10096=1102;a.afii10097=1103;a.afii10098=1169;a.afii10099=1106;a.afii10100=1107;a.afii10101=1108;a.afii10102=1109;a.afii10103=1110;a.afii10104=1111;a.afii10105=1112;a.afii10106=\n1113;a.afii10107=1114;a.afii10108=1115;a.afii10109=1116;a.afii10110=1118;a.afii10145=1039;a.afii10146=1122;a.afii10147=1138;a.afii10148=1140;a.afii10192=63174;a.afii10193=1119;a.afii10194=1123;a.afii10195=1139;a.afii10196=1141;a.afii10831=63175;a.afii10832=63176;a.afii10846=1241;a.afii299=8206;a.afii300=8207;a.afii301=8205;a.afii57381=1642;a.afii57388=1548;a.afii57392=1632;a.afii57393=1633;a.afii57394=1634;a.afii57395=1635;a.afii57396=1636;a.afii57397=1637;a.afii57398=1638;a.afii57399=1639;a.afii57400=\n1640;a.afii57401=1641;a.afii57403=1563;a.afii57407=1567;a.afii57409=1569;a.afii57410=1570;a.afii57411=1571;a.afii57412=1572;a.afii57413=1573;a.afii57414=1574;a.afii57415=1575;a.afii57416=1576;a.afii57417=1577;a.afii57418=1578;a.afii57419=1579;a.afii57420=1580;a.afii57421=1581;a.afii57422=1582;a.afii57423=1583;a.afii57424=1584;a.afii57425=1585;a.afii57426=1586;a.afii57427=1587;a.afii57428=1588;a.afii57429=1589;a.afii57430=1590;a.afii57431=1591;a.afii57432=1592;a.afii57433=1593;a.afii57434=1594;a.afii57440=\n1600;a.afii57441=1601;a.afii57442=1602;a.afii57443=1603;a.afii57444=1604;a.afii57445=1605;a.afii57446=1606;a.afii57448=1608;a.afii57449=1609;a.afii57450=1610;a.afii57451=1611;a.afii57452=1612;a.afii57453=1613;a.afii57454=1614;a.afii57455=1615;a.afii57456=1616;a.afii57457=1617;a.afii57458=1618;a.afii57470=1607;a.afii57505=1700;a.afii57506=1662;a.afii57507=1670;a.afii57508=1688;a.afii57509=1711;a.afii57511=1657;a.afii57512=1672;a.afii57513=1681;a.afii57514=1722;a.afii57519=1746;a.afii57534=1749;a.afii57636=\n8362;a.afii57645=1470;a.afii57658=1475;a.afii57664=1488;a.afii57665=1489;a.afii57666=1490;a.afii57667=1491;a.afii57668=1492;a.afii57669=1493;a.afii57670=1494;a.afii57671=1495;a.afii57672=1496;a.afii57673=1497;a.afii57674=1498;a.afii57675=1499;a.afii57676=1500;a.afii57677=1501;a.afii57678=1502;a.afii57679=1503;a.afii57680=1504;a.afii57681=1505;a.afii57682=1506;a.afii57683=1507;a.afii57684=1508;a.afii57685=1509;a.afii57686=1510;a.afii57687=1511;a.afii57688=1512;a.afii57689=1513;a.afii57690=1514;a.afii57694=\n64298;a.afii57695=64299;a.afii57700=64331;a.afii57705=64287;a.afii57716=1520;a.afii57717=1521;a.afii57718=1522;a.afii57723=64309;a.afii57793=1460;a.afii57794=1461;a.afii57795=1462;a.afii57796=1467;a.afii57797=1464;a.afii57798=1463;a.afii57799=1456;a.afii57800=1458;a.afii57801=1457;a.afii57802=1459;a.afii57803=1474;a.afii57804=1473;a.afii57806=1465;a.afii57807=1468;a.afii57839=1469;a.afii57841=1471;a.afii57842=1472;a.afii57929=700;a.afii61248=8453;a.afii61289=8467;a.afii61352=8470;a.afii61573=8236;\na.afii61574=8237;a.afii61575=8238;a.afii61664=8204;a.afii63167=1645;a.afii64937=701;a.agrave=224;a.agujarati=2693;a.agurmukhi=2565;a.ahiragana=12354;a.ahookabove=7843;a.aibengali=2448;a.aibopomofo=12574;a.aideva=2320;a.aiecyrillic=1237;a.aigujarati=2704;a.aigurmukhi=2576;a.aimatragurmukhi=2632;a.ainarabic=1593;a.ainfinalarabic=65226;a.aininitialarabic=65227;a.ainmedialarabic=65228;a.ainvertedbreve=515;a.aivowelsignbengali=2504;a.aivowelsigndeva=2376;a.aivowelsigngujarati=2760;a.akatakana=12450;a.akatakanahalfwidth=\n65393;a.akorean=12623;a.alef=1488;a.alefarabic=1575;a.alefdageshhebrew=64304;a.aleffinalarabic=65166;a.alefhamzaabovearabic=1571;a.alefhamzaabovefinalarabic=65156;a.alefhamzabelowarabic=1573;a.alefhamzabelowfinalarabic=65160;a.alefhebrew=1488;a.aleflamedhebrew=64335;a.alefmaddaabovearabic=1570;a.alefmaddaabovefinalarabic=65154;a.alefmaksuraarabic=1609;a.alefmaksurafinalarabic=65264;a.alefmaksurainitialarabic=65267;a.alefmaksuramedialarabic=65268;a.alefpatahhebrew=64302;a.alefqamatshebrew=64303;a.aleph=\n8501;a.allequal=8780;a.alpha=945;a.alphatonos=940;a.amacron=257;a.amonospace=65345;a.ampersand=38;a.ampersandmonospace=65286;a.ampersandsmall=63270;a.amsquare=13250;a.anbopomofo=12578;a.angbopomofo=12580;a.angbracketleft=12296;a.angbracketright=12297;a.angkhankhuthai=3674;a.angle=8736;a.anglebracketleft=12296;a.anglebracketleftvertical=65087;a.anglebracketright=12297;a.anglebracketrightvertical=65088;a.angleleft=9001;a.angleright=9002;a.angstrom=8491;a.anoteleia=903;a.anudattadeva=2386;a.anusvarabengali=\n2434;a.anusvaradeva=2306;a.anusvaragujarati=2690;a.aogonek=261;a.apaatosquare=13056;a.aparen=9372;a.apostrophearmenian=1370;a.apostrophemod=700;a.apple=63743;a.approaches=8784;a.approxequal=8776;a.approxequalorimage=8786;a.approximatelyequal=8773;a.araeaekorean=12686;a.araeakorean=12685;a.arc=8978;a.arighthalfring=7834;a.aring=229;a.aringacute=507;a.aringbelow=7681;a.arrowboth=8596;a.arrowdashdown=8675;a.arrowdashleft=8672;a.arrowdashright=8674;a.arrowdashup=8673;a.arrowdblboth=8660;a.arrowdbldown=\n8659;a.arrowdblleft=8656;a.arrowdblright=8658;a.arrowdblup=8657;a.arrowdown=8595;a.arrowdownleft=8601;a.arrowdownright=8600;a.arrowdownwhite=8681;a.arrowheaddownmod=709;a.arrowheadleftmod=706;a.arrowheadrightmod=707;a.arrowheadupmod=708;a.arrowhorizex=63719;a.arrowleft=8592;a.arrowleftdbl=8656;a.arrowleftdblstroke=8653;a.arrowleftoverright=8646;a.arrowleftwhite=8678;a.arrowright=8594;a.arrowrightdblstroke=8655;a.arrowrightheavy=10142;a.arrowrightoverleft=8644;a.arrowrightwhite=8680;a.arrowtableft=\n8676;a.arrowtabright=8677;a.arrowup=8593;a.arrowupdn=8597;a.arrowupdnbse=8616;a.arrowupdownbase=8616;a.arrowupleft=8598;a.arrowupleftofdown=8645;a.arrowupright=8599;a.arrowupwhite=8679;a.arrowvertex=63718;a.asciicircum=94;a.asciicircummonospace=65342;a.asciitilde=126;a.asciitildemonospace=65374;a.ascript=593;a.ascriptturned=594;a.asmallhiragana=12353;a.asmallkatakana=12449;a.asmallkatakanahalfwidth=65383;a.asterisk=42;a.asteriskaltonearabic=1645;a.asteriskarabic=1645;a.asteriskmath=8727;a.asteriskmonospace=\n65290;a.asterisksmall=65121;a.asterism=8258;a.asuperior=63209;a.asymptoticallyequal=8771;a.at=64;a.atilde=227;a.atmonospace=65312;a.atsmall=65131;a.aturned=592;a.aubengali=2452;a.aubopomofo=12576;a.audeva=2324;a.augujarati=2708;a.augurmukhi=2580;a.aulengthmarkbengali=2519;a.aumatragurmukhi=2636;a.auvowelsignbengali=2508;a.auvowelsigndeva=2380;a.auvowelsigngujarati=2764;a.avagrahadeva=2365;a.aybarmenian=1377;a.ayin=1506;a.ayinaltonehebrew=64288;a.ayinhebrew=1506;a.b=98;a.babengali=2476;a.backslash=\n92;a.backslashmonospace=65340;a.badeva=2348;a.bagujarati=2732;a.bagurmukhi=2604;a.bahiragana=12400;a.bahtthai=3647;a.bakatakana=12496;a.bar=124;a.barmonospace=65372;a.bbopomofo=12549;a.bcircle=9425;a.bdotaccent=7683;a.bdotbelow=7685;a.beamedsixteenthnotes=9836;a.because=8757;a.becyrillic=1073;a.beharabic=1576;a.behfinalarabic=65168;a.behinitialarabic=65169;a.behiragana=12409;a.behmedialarabic=65170;a.behmeeminitialarabic=64671;a.behmeemisolatedarabic=64520;a.behnoonfinalarabic=64621;a.bekatakana=\n12505;a.benarmenian=1378;a.bet=1489;a.beta=946;a.betasymbolgreek=976;a.betdagesh=64305;a.betdageshhebrew=64305;a.bethebrew=1489;a.betrafehebrew=64332;a.bhabengali=2477;a.bhadeva=2349;a.bhagujarati=2733;a.bhagurmukhi=2605;a.bhook=595;a.bihiragana=12403;a.bikatakana=12499;a.bilabialclick=664;a.bindigurmukhi=2562;a.birusquare=13105;a.blackcircle=9679;a.blackdiamond=9670;a.blackdownpointingtriangle=9660;a.blackleftpointingpointer=9668;a.blackleftpointingtriangle=9664;a.blacklenticularbracketleft=12304;\na.blacklenticularbracketleftvertical=65083;a.blacklenticularbracketright=12305;a.blacklenticularbracketrightvertical=65084;a.blacklowerlefttriangle=9699;a.blacklowerrighttriangle=9698;a.blackrectangle=9644;a.blackrightpointingpointer=9658;a.blackrightpointingtriangle=9654;a.blacksmallsquare=9642;a.blacksmilingface=9787;a.blacksquare=9632;a.blackstar=9733;a.blackupperlefttriangle=9700;a.blackupperrighttriangle=9701;a.blackuppointingsmalltriangle=9652;a.blackuppointingtriangle=9650;a.blank=9251;a.blinebelow=\n7687;a.block=9608;a.bmonospace=65346;a.bobaimaithai=3610;a.bohiragana=12412;a.bokatakana=12508;a.bparen=9373;a.bqsquare=13251;a.braceex=63732;a.braceleft=123;a.braceleftbt=63731;a.braceleftmid=63730;a.braceleftmonospace=65371;a.braceleftsmall=65115;a.bracelefttp=63729;a.braceleftvertical=65079;a.braceright=125;a.bracerightbt=63742;a.bracerightmid=63741;a.bracerightmonospace=65373;a.bracerightsmall=65116;a.bracerighttp=63740;a.bracerightvertical=65080;a.bracketleft=91;a.bracketleftbt=63728;a.bracketleftex=\n63727;a.bracketleftmonospace=65339;a.bracketlefttp=63726;a.bracketright=93;a.bracketrightbt=63739;a.bracketrightex=63738;a.bracketrightmonospace=65341;a.bracketrighttp=63737;a.breve=728;a.brevebelowcmb=814;a.brevecmb=774;a.breveinvertedbelowcmb=815;a.breveinvertedcmb=785;a.breveinverteddoublecmb=865;a.bridgebelowcmb=810;a.bridgeinvertedbelowcmb=826;a.brokenbar=166;a.bstroke=384;a.bsuperior=63210;a.btopbar=387;a.buhiragana=12406;a.bukatakana=12502;a.bullet=8226;a.bulletinverse=9688;a.bulletoperator=\n8729;a.bullseye=9678;a.c=99;a.caarmenian=1390;a.cabengali=2458;a.cacute=263;a.cadeva=2330;a.cagujarati=2714;a.cagurmukhi=2586;a.calsquare=13192;a.candrabindubengali=2433;a.candrabinducmb=784;a.candrabindudeva=2305;a.candrabindugujarati=2689;a.capslock=8682;a.careof=8453;a.caron=711;a.caronbelowcmb=812;a.caroncmb=780;a.carriagereturn=8629;a.cbopomofo=12568;a.ccaron=269;a.ccedilla=231;a.ccedillaacute=7689;a.ccircle=9426;a.ccircumflex=265;a.ccurl=597;a.cdot=267;a.cdotaccent=267;a.cdsquare=13253;a.cedilla=\n184;a.cedillacmb=807;a.cent=162;a.centigrade=8451;a.centinferior=63199;a.centmonospace=65504;a.centoldstyle=63394;a.centsuperior=63200;a.chaarmenian=1401;a.chabengali=2459;a.chadeva=2331;a.chagujarati=2715;a.chagurmukhi=2587;a.chbopomofo=12564;a.cheabkhasiancyrillic=1213;a.checkmark=10003;a.checyrillic=1095;a.chedescenderabkhasiancyrillic=1215;a.chedescendercyrillic=1207;a.chedieresiscyrillic=1269;a.cheharmenian=1395;a.chekhakassiancyrillic=1228;a.cheverticalstrokecyrillic=1209;a.chi=967;a.chieuchacirclekorean=\n12919;a.chieuchaparenkorean=12823;a.chieuchcirclekorean=12905;a.chieuchkorean=12618;a.chieuchparenkorean=12809;a.chochangthai=3594;a.chochanthai=3592;a.chochingthai=3593;a.chochoethai=3596;a.chook=392;a.cieucacirclekorean=12918;a.cieucaparenkorean=12822;a.cieuccirclekorean=12904;a.cieuckorean=12616;a.cieucparenkorean=12808;a.cieucuparenkorean=12828;a.circle=9675;a.circlecopyrt=169;a.circlemultiply=8855;a.circleot=8857;a.circleplus=8853;a.circlepostalmark=12342;a.circlewithlefthalfblack=9680;a.circlewithrighthalfblack=\n9681;a.circumflex=710;a.circumflexbelowcmb=813;a.circumflexcmb=770;a.clear=8999;a.clickalveolar=450;a.clickdental=448;a.clicklateral=449;a.clickretroflex=451;a.club=9827;a.clubsuitblack=9827;a.clubsuitwhite=9831;a.cmcubedsquare=13220;a.cmonospace=65347;a.cmsquaredsquare=13216;a.coarmenian=1409;a.colon=58;a.colonmonetary=8353;a.colonmonospace=65306;a.colonsign=8353;a.colonsmall=65109;a.colontriangularhalfmod=721;a.colontriangularmod=720;a.comma=44;a.commaabovecmb=787;a.commaaboverightcmb=789;a.commaaccent=\n63171;a.commaarabic=1548;a.commaarmenian=1373;a.commainferior=63201;a.commamonospace=65292;a.commareversedabovecmb=788;a.commareversedmod=701;a.commasmall=65104;a.commasuperior=63202;a.commaturnedabovecmb=786;a.commaturnedmod=699;a.compass=9788;a.congruent=8773;a.contourintegral=8750;a.control=8963;a.controlACK=6;a.controlBEL=7;a.controlBS=8;a.controlCAN=24;a.controlCR=13;a.controlDC1=17;a.controlDC2=18;a.controlDC3=19;a.controlDC4=20;a.controlDEL=127;a.controlDLE=16;a.controlEM=25;a.controlENQ=5;\na.controlEOT=4;a.controlESC=27;a.controlETB=23;a.controlETX=3;a.controlFF=12;a.controlFS=28;a.controlGS=29;a.controlHT=9;a.controlLF=10;a.controlNAK=21;a.controlNULL=0;a.controlRS=30;a.controlSI=15;a.controlSO=14;a.controlSOT=2;a.controlSTX=1;a.controlSUB=26;a.controlSYN=22;a.controlUS=31;a.controlVT=11;a.copyright=169;a.copyrightsans=63721;a.copyrightserif=63193;a.cornerbracketleft=12300;a.cornerbracketlefthalfwidth=65378;a.cornerbracketleftvertical=65089;a.cornerbracketright=12301;a.cornerbracketrighthalfwidth=\n65379;a.cornerbracketrightvertical=65090;a.corporationsquare=13183;a.cosquare=13255;a.coverkgsquare=13254;a.cparen=9374;a.cruzeiro=8354;a.cstretched=663;a.curlyand=8911;a.curlyor=8910;a.currency=164;a.cyrBreve=63185;a.cyrFlex=63186;a.cyrbreve=63188;a.cyrflex=63189;a.d=100;a.daarmenian=1380;a.dabengali=2470;a.dadarabic=1590;a.dadeva=2342;a.dadfinalarabic=65214;a.dadinitialarabic=65215;a.dadmedialarabic=65216;a.dagesh=1468;a.dageshhebrew=1468;a.dagger=8224;a.daggerdbl=8225;a.dagujarati=2726;a.dagurmukhi=\n2598;a.dahiragana=12384;a.dakatakana=12480;a.dalarabic=1583;a.dalet=1491;a.daletdagesh=64307;a.daletdageshhebrew=64307;a.dalethebrew=1491;a.dalfinalarabic=65194;a.dammaarabic=1615;a.dammalowarabic=1615;a.dammatanaltonearabic=1612;a.dammatanarabic=1612;a.danda=2404;a.dargahebrew=1447;a.dargalefthebrew=1447;a.dasiapneumatacyrilliccmb=1157;a.dblGrave=63187;a.dblanglebracketleft=12298;a.dblanglebracketleftvertical=65085;a.dblanglebracketright=12299;a.dblanglebracketrightvertical=65086;a.dblarchinvertedbelowcmb=\n811;a.dblarrowleft=8660;a.dblarrowright=8658;a.dbldanda=2405;a.dblgrave=63190;a.dblgravecmb=783;a.dblintegral=8748;a.dbllowline=8215;a.dbllowlinecmb=819;a.dbloverlinecmb=831;a.dblprimemod=698;a.dblverticalbar=8214;a.dblverticallineabovecmb=782;a.dbopomofo=12553;a.dbsquare=13256;a.dcaron=271;a.dcedilla=7697;a.dcircle=9427;a.dcircumflexbelow=7699;a.dcroat=273;a.ddabengali=2465;a.ddadeva=2337;a.ddagujarati=2721;a.ddagurmukhi=2593;a.ddalarabic=1672;a.ddalfinalarabic=64393;a.dddhadeva=2396;a.ddhabengali=\n2466;a.ddhadeva=2338;a.ddhagujarati=2722;a.ddhagurmukhi=2594;a.ddotaccent=7691;a.ddotbelow=7693;a.decimalseparatorarabic=1643;a.decimalseparatorpersian=1643;a.decyrillic=1076;a.degree=176;a.dehihebrew=1453;a.dehiragana=12391;a.deicoptic=1007;a.dekatakana=12487;a.deleteleft=9003;a.deleteright=8998;a.delta=948;a.deltaturned=397;a.denominatorminusonenumeratorbengali=2552;a.dezh=676;a.dhabengali=2471;a.dhadeva=2343;a.dhagujarati=2727;a.dhagurmukhi=2599;a.dhook=599;a.dialytikatonos=901;a.dialytikatonoscmb=\n836;a.diamond=9830;a.diamondsuitwhite=9826;a.dieresis=168;a.dieresisacute=63191;a.dieresisbelowcmb=804;a.dieresiscmb=776;a.dieresisgrave=63192;a.dieresistonos=901;a.dihiragana=12386;a.dikatakana=12482;a.dittomark=12291;a.divide=247;a.divides=8739;a.divisionslash=8725;a.djecyrillic=1106;a.dkshade=9619;a.dlinebelow=7695;a.dlsquare=13207;a.dmacron=273;a.dmonospace=65348;a.dnblock=9604;a.dochadathai=3598;a.dodekthai=3604;a.dohiragana=12393;a.dokatakana=12489;a.dollar=36;a.dollarinferior=63203;a.dollarmonospace=\n65284;a.dollaroldstyle=63268;a.dollarsmall=65129;a.dollarsuperior=63204;a.dong=8363;a.dorusquare=13094;a.dotaccent=729;a.dotaccentcmb=775;a.dotbelowcmb=803;a.dotbelowcomb=803;a.dotkatakana=12539;a.dotlessi=305;a.dotlessj=63166;a.dotlessjstrokehook=644;a.dotmath=8901;a.dottedcircle=9676;a.doubleyodpatah=64287;a.doubleyodpatahhebrew=64287;a.downtackbelowcmb=798;a.downtackmod=725;a.dparen=9375;a.dsuperior=63211;a.dtail=598;a.dtopbar=396;a.duhiragana=12389;a.dukatakana=12485;a.dz=499;a.dzaltone=675;a.dzcaron=\n454;a.dzcurl=677;a.dzeabkhasiancyrillic=1249;a.dzecyrillic=1109;a.dzhecyrillic=1119;a.e=101;a.eacute=233;a.earth=9793;a.ebengali=2447;a.ebopomofo=12572;a.ebreve=277;a.ecandradeva=2317;a.ecandragujarati=2701;a.ecandravowelsigndeva=2373;a.ecandravowelsigngujarati=2757;a.ecaron=283;a.ecedillabreve=7709;a.echarmenian=1381;a.echyiwnarmenian=1415;a.ecircle=9428;a.ecircumflex=234;a.ecircumflexacute=7871;a.ecircumflexbelow=7705;a.ecircumflexdotbelow=7879;a.ecircumflexgrave=7873;a.ecircumflexhookabove=7875;\na.ecircumflextilde=7877;a.ecyrillic=1108;a.edblgrave=517;a.edeva=2319;a.edieresis=235;a.edot=279;a.edotaccent=279;a.edotbelow=7865;a.eegurmukhi=2575;a.eematragurmukhi=2631;a.efcyrillic=1092;a.egrave=232;a.egujarati=2703;a.eharmenian=1383;a.ehbopomofo=12573;a.ehiragana=12360;a.ehookabove=7867;a.eibopomofo=12575;a.eight=56;a.eightarabic=1640;a.eightbengali=2542;a.eightcircle=9319;a.eightcircleinversesansserif=10129;a.eightdeva=2414;a.eighteencircle=9329;a.eighteenparen=9349;a.eighteenperiod=9369;a.eightgujarati=\n2798;a.eightgurmukhi=2670;a.eighthackarabic=1640;a.eighthangzhou=12328;a.eighthnotebeamed=9835;a.eightideographicparen=12839;a.eightinferior=8328;a.eightmonospace=65304;a.eightoldstyle=63288;a.eightparen=9339;a.eightperiod=9359;a.eightpersian=1784;a.eightroman=8567;a.eightsuperior=8312;a.eightthai=3672;a.einvertedbreve=519;a.eiotifiedcyrillic=1125;a.ekatakana=12456;a.ekatakanahalfwidth=65396;a.ekonkargurmukhi=2676;a.ekorean=12628;a.elcyrillic=1083;a.element=8712;a.elevencircle=9322;a.elevenparen=\n9342;a.elevenperiod=9362;a.elevenroman=8570;a.ellipsis=8230;a.ellipsisvertical=8942;a.emacron=275;a.emacronacute=7703;a.emacrongrave=7701;a.emcyrillic=1084;a.emdash=8212;a.emdashvertical=65073;a.emonospace=65349;a.emphasismarkarmenian=1371;a.emptyset=8709;a.enbopomofo=12579;a.encyrillic=1085;a.endash=8211;a.endashvertical=65074;a.endescendercyrillic=1187;a.eng=331;a.engbopomofo=12581;a.enghecyrillic=1189;a.enhookcyrillic=1224;a.enspace=8194;a.eogonek=281;a.eokorean=12627;a.eopen=603;a.eopenclosed=\n666;a.eopenreversed=604;a.eopenreversedclosed=606;a.eopenreversedhook=605;a.eparen=9376;a.epsilon=949;a.epsilontonos=941;a.equal=61;a.equalmonospace=65309;a.equalsmall=65126;a.equalsuperior=8316;a.equivalence=8801;a.erbopomofo=12582;a.ercyrillic=1088;a.ereversed=600;a.ereversedcyrillic=1101;a.escyrillic=1089;a.esdescendercyrillic=1195;a.esh=643;a.eshcurl=646;a.eshortdeva=2318;a.eshortvowelsigndeva=2374;a.eshreversedloop=426;a.eshsquatreversed=645;a.esmallhiragana=12359;a.esmallkatakana=12455;a.esmallkatakanahalfwidth=\n65386;a.estimated=8494;a.esuperior=63212;a.eta=951;a.etarmenian=1384;a.etatonos=942;a.eth=240;a.etilde=7869;a.etildebelow=7707;a.etnahtafoukhhebrew=1425;a.etnahtafoukhlefthebrew=1425;a.etnahtahebrew=1425;a.etnahtalefthebrew=1425;a.eturned=477;a.eukorean=12641;a.euro=8364;a.evowelsignbengali=2503;a.evowelsigndeva=2375;a.evowelsigngujarati=2759;a.exclam=33;a.exclamarmenian=1372;a.exclamdbl=8252;a.exclamdown=161;a.exclamdownsmall=63393;a.exclammonospace=65281;a.exclamsmall=63265;a.existential=8707;a.ezh=\n658;a.ezhcaron=495;a.ezhcurl=659;a.ezhreversed=441;a.ezhtail=442;a.f=102;a.fadeva=2398;a.fagurmukhi=2654;a.fahrenheit=8457;a.fathaarabic=1614;a.fathalowarabic=1614;a.fathatanarabic=1611;a.fbopomofo=12552;a.fcircle=9429;a.fdotaccent=7711;a.feharabic=1601;a.feharmenian=1414;a.fehfinalarabic=65234;a.fehinitialarabic=65235;a.fehmedialarabic=65236;a.feicoptic=997;a.female=9792;a.ff=64256;a.f_f=64256;a.ffi=64259;a.f_f_i=64259;a.ffl=64260;a.f_f_l=64260;a.fi=64257;a.f_i=64257;a.fifteencircle=9326;a.fifteenparen=\n9346;a.fifteenperiod=9366;a.figuredash=8210;a.filledbox=9632;a.filledrect=9644;a.finalkaf=1498;a.finalkafdagesh=64314;a.finalkafdageshhebrew=64314;a.finalkafhebrew=1498;a.finalmem=1501;a.finalmemhebrew=1501;a.finalnun=1503;a.finalnunhebrew=1503;a.finalpe=1507;a.finalpehebrew=1507;a.finaltsadi=1509;a.finaltsadihebrew=1509;a.firsttonechinese=713;a.fisheye=9673;a.fitacyrillic=1139;a.five=53;a.fivearabic=1637;a.fivebengali=2539;a.fivecircle=9316;a.fivecircleinversesansserif=10126;a.fivedeva=2411;a.fiveeighths=\n8541;a.fivegujarati=2795;a.fivegurmukhi=2667;a.fivehackarabic=1637;a.fivehangzhou=12325;a.fiveideographicparen=12836;a.fiveinferior=8325;a.fivemonospace=65301;a.fiveoldstyle=63285;a.fiveparen=9336;a.fiveperiod=9356;a.fivepersian=1781;a.fiveroman=8564;a.fivesuperior=8309;a.fivethai=3669;a.fl=64258;a.f_l=64258;a.florin=402;a.fmonospace=65350;a.fmsquare=13209;a.fofanthai=3615;a.fofathai=3613;a.fongmanthai=3663;a.forall=8704;a.four=52;a.fourarabic=1636;a.fourbengali=2538;a.fourcircle=9315;a.fourcircleinversesansserif=\n10125;a.fourdeva=2410;a.fourgujarati=2794;a.fourgurmukhi=2666;a.fourhackarabic=1636;a.fourhangzhou=12324;a.fourideographicparen=12835;a.fourinferior=8324;a.fourmonospace=65300;a.fournumeratorbengali=2551;a.fouroldstyle=63284;a.fourparen=9335;a.fourperiod=9355;a.fourpersian=1780;a.fourroman=8563;a.foursuperior=8308;a.fourteencircle=9325;a.fourteenparen=9345;a.fourteenperiod=9365;a.fourthai=3668;a.fourthtonechinese=715;a.fparen=9377;a.fraction=8260;a.franc=8355;a.g=103;a.gabengali=2455;a.gacute=501;\na.gadeva=2327;a.gafarabic=1711;a.gaffinalarabic=64403;a.gafinitialarabic=64404;a.gafmedialarabic=64405;a.gagujarati=2711;a.gagurmukhi=2583;a.gahiragana=12364;a.gakatakana=12460;a.gamma=947;a.gammalatinsmall=611;a.gammasuperior=736;a.gangiacoptic=1003;a.gbopomofo=12557;a.gbreve=287;a.gcaron=487;a.gcedilla=291;a.gcircle=9430;a.gcircumflex=285;a.gcommaaccent=291;a.gdot=289;a.gdotaccent=289;a.gecyrillic=1075;a.gehiragana=12370;a.gekatakana=12466;a.geometricallyequal=8785;a.gereshaccenthebrew=1436;a.gereshhebrew=\n1523;a.gereshmuqdamhebrew=1437;a.germandbls=223;a.gershayimaccenthebrew=1438;a.gershayimhebrew=1524;a.getamark=12307;a.ghabengali=2456;a.ghadarmenian=1394;a.ghadeva=2328;a.ghagujarati=2712;a.ghagurmukhi=2584;a.ghainarabic=1594;a.ghainfinalarabic=65230;a.ghaininitialarabic=65231;a.ghainmedialarabic=65232;a.ghemiddlehookcyrillic=1173;a.ghestrokecyrillic=1171;a.gheupturncyrillic=1169;a.ghhadeva=2394;a.ghhagurmukhi=2650;a.ghook=608;a.ghzsquare=13203;a.gihiragana=12366;a.gikatakana=12462;a.gimarmenian=\n1379;a.gimel=1490;a.gimeldagesh=64306;a.gimeldageshhebrew=64306;a.gimelhebrew=1490;a.gjecyrillic=1107;a.glottalinvertedstroke=446;a.glottalstop=660;a.glottalstopinverted=662;a.glottalstopmod=704;a.glottalstopreversed=661;a.glottalstopreversedmod=705;a.glottalstopreversedsuperior=740;a.glottalstopstroke=673;a.glottalstopstrokereversed=674;a.gmacron=7713;a.gmonospace=65351;a.gohiragana=12372;a.gokatakana=12468;a.gparen=9378;a.gpasquare=13228;a.gradient=8711;a.grave=96;a.gravebelowcmb=790;a.gravecmb=\n768;a.gravecomb=768;a.gravedeva=2387;a.gravelowmod=718;a.gravemonospace=65344;a.gravetonecmb=832;a.greater=62;a.greaterequal=8805;a.greaterequalorless=8923;a.greatermonospace=65310;a.greaterorequivalent=8819;a.greaterorless=8823;a.greateroverequal=8807;a.greatersmall=65125;a.gscript=609;a.gstroke=485;a.guhiragana=12368;a.guillemotleft=171;a.guillemotright=187;a.guilsinglleft=8249;a.guilsinglright=8250;a.gukatakana=12464;a.guramusquare=13080;a.gysquare=13257;a.h=104;a.haabkhasiancyrillic=1193;a.haaltonearabic=\n1729;a.habengali=2489;a.hadescendercyrillic=1203;a.hadeva=2361;a.hagujarati=2745;a.hagurmukhi=2617;a.haharabic=1581;a.hahfinalarabic=65186;a.hahinitialarabic=65187;a.hahiragana=12399;a.hahmedialarabic=65188;a.haitusquare=13098;a.hakatakana=12495;a.hakatakanahalfwidth=65418;a.halantgurmukhi=2637;a.hamzaarabic=1569;a.hamzalowarabic=1569;a.hangulfiller=12644;a.hardsigncyrillic=1098;a.harpoonleftbarbup=8636;a.harpoonrightbarbup=8640;a.hasquare=13258;a.hatafpatah=1458;a.hatafpatah16=1458;a.hatafpatah23=\n1458;a.hatafpatah2f=1458;a.hatafpatahhebrew=1458;a.hatafpatahnarrowhebrew=1458;a.hatafpatahquarterhebrew=1458;a.hatafpatahwidehebrew=1458;a.hatafqamats=1459;a.hatafqamats1b=1459;a.hatafqamats28=1459;a.hatafqamats34=1459;a.hatafqamatshebrew=1459;a.hatafqamatsnarrowhebrew=1459;a.hatafqamatsquarterhebrew=1459;a.hatafqamatswidehebrew=1459;a.hatafsegol=1457;a.hatafsegol17=1457;a.hatafsegol24=1457;a.hatafsegol30=1457;a.hatafsegolhebrew=1457;a.hatafsegolnarrowhebrew=1457;a.hatafsegolquarterhebrew=1457;a.hatafsegolwidehebrew=\n1457;a.hbar=295;a.hbopomofo=12559;a.hbrevebelow=7723;a.hcedilla=7721;a.hcircle=9431;a.hcircumflex=293;a.hdieresis=7719;a.hdotaccent=7715;a.hdotbelow=7717;a.he=1492;a.heart=9829;a.heartsuitblack=9829;a.heartsuitwhite=9825;a.hedagesh=64308;a.hedageshhebrew=64308;a.hehaltonearabic=1729;a.heharabic=1607;a.hehebrew=1492;a.hehfinalaltonearabic=64423;a.hehfinalalttwoarabic=65258;a.hehfinalarabic=65258;a.hehhamzaabovefinalarabic=64421;a.hehhamzaaboveisolatedarabic=64420;a.hehinitialaltonearabic=64424;a.hehinitialarabic=\n65259;a.hehiragana=12408;a.hehmedialaltonearabic=64425;a.hehmedialarabic=65260;a.heiseierasquare=13179;a.hekatakana=12504;a.hekatakanahalfwidth=65421;a.hekutaarusquare=13110;a.henghook=615;a.herutusquare=13113;a.het=1495;a.hethebrew=1495;a.hhook=614;a.hhooksuperior=689;a.hieuhacirclekorean=12923;a.hieuhaparenkorean=12827;a.hieuhcirclekorean=12909;a.hieuhkorean=12622;a.hieuhparenkorean=12813;a.hihiragana=12402;a.hikatakana=12498;a.hikatakanahalfwidth=65419;a.hiriq=1460;a.hiriq14=1460;a.hiriq21=1460;\na.hiriq2d=1460;a.hiriqhebrew=1460;a.hiriqnarrowhebrew=1460;a.hiriqquarterhebrew=1460;a.hiriqwidehebrew=1460;a.hlinebelow=7830;a.hmonospace=65352;a.hoarmenian=1392;a.hohipthai=3627;a.hohiragana=12411;a.hokatakana=12507;a.hokatakanahalfwidth=65422;a.holam=1465;a.holam19=1465;a.holam26=1465;a.holam32=1465;a.holamhebrew=1465;a.holamnarrowhebrew=1465;a.holamquarterhebrew=1465;a.holamwidehebrew=1465;a.honokhukthai=3630;a.hookabovecomb=777;a.hookcmb=777;a.hookpalatalizedbelowcmb=801;a.hookretroflexbelowcmb=\n802;a.hoonsquare=13122;a.horicoptic=1001;a.horizontalbar=8213;a.horncmb=795;a.hotsprings=9832;a.house=8962;a.hparen=9379;a.hsuperior=688;a.hturned=613;a.huhiragana=12405;a.huiitosquare=13107;a.hukatakana=12501;a.hukatakanahalfwidth=65420;a.hungarumlaut=733;a.hungarumlautcmb=779;a.hv=405;a.hyphen=45;a.hypheninferior=63205;a.hyphenmonospace=65293;a.hyphensmall=65123;a.hyphensuperior=63206;a.hyphentwo=8208;a.i=105;a.iacute=237;a.iacyrillic=1103;a.ibengali=2439;a.ibopomofo=12583;a.ibreve=301;a.icaron=\n464;a.icircle=9432;a.icircumflex=238;a.icyrillic=1110;a.idblgrave=521;a.ideographearthcircle=12943;a.ideographfirecircle=12939;a.ideographicallianceparen=12863;a.ideographiccallparen=12858;a.ideographiccentrecircle=12965;a.ideographicclose=12294;a.ideographiccomma=12289;a.ideographiccommaleft=65380;a.ideographiccongratulationparen=12855;a.ideographiccorrectcircle=12963;a.ideographicearthparen=12847;a.ideographicenterpriseparen=12861;a.ideographicexcellentcircle=12957;a.ideographicfestivalparen=12864;\na.ideographicfinancialcircle=12950;a.ideographicfinancialparen=12854;a.ideographicfireparen=12843;a.ideographichaveparen=12850;a.ideographichighcircle=12964;a.ideographiciterationmark=12293;a.ideographiclaborcircle=12952;a.ideographiclaborparen=12856;a.ideographicleftcircle=12967;a.ideographiclowcircle=12966;a.ideographicmedicinecircle=12969;a.ideographicmetalparen=12846;a.ideographicmoonparen=12842;a.ideographicnameparen=12852;a.ideographicperiod=12290;a.ideographicprintcircle=12958;a.ideographicreachparen=\n12867;a.ideographicrepresentparen=12857;a.ideographicresourceparen=12862;a.ideographicrightcircle=12968;a.ideographicsecretcircle=12953;a.ideographicselfparen=12866;a.ideographicsocietyparen=12851;a.ideographicspace=12288;a.ideographicspecialparen=12853;a.ideographicstockparen=12849;a.ideographicstudyparen=12859;a.ideographicsunparen=12848;a.ideographicsuperviseparen=12860;a.ideographicwaterparen=12844;a.ideographicwoodparen=12845;a.ideographiczero=12295;a.ideographmetalcircle=12942;a.ideographmooncircle=\n12938;a.ideographnamecircle=12948;a.ideographsuncircle=12944;a.ideographwatercircle=12940;a.ideographwoodcircle=12941;a.ideva=2311;a.idieresis=239;a.idieresisacute=7727;a.idieresiscyrillic=1253;a.idotbelow=7883;a.iebrevecyrillic=1239;a.iecyrillic=1077;a.ieungacirclekorean=12917;a.ieungaparenkorean=12821;a.ieungcirclekorean=12903;a.ieungkorean=12615;a.ieungparenkorean=12807;a.igrave=236;a.igujarati=2695;a.igurmukhi=2567;a.ihiragana=12356;a.ihookabove=7881;a.iibengali=2440;a.iicyrillic=1080;a.iideva=\n2312;a.iigujarati=2696;a.iigurmukhi=2568;a.iimatragurmukhi=2624;a.iinvertedbreve=523;a.iishortcyrillic=1081;a.iivowelsignbengali=2496;a.iivowelsigndeva=2368;a.iivowelsigngujarati=2752;a.ij=307;a.ikatakana=12452;a.ikatakanahalfwidth=65394;a.ikorean=12643;a.ilde=732;a.iluyhebrew=1452;a.imacron=299;a.imacroncyrillic=1251;a.imageorapproximatelyequal=8787;a.imatragurmukhi=2623;a.imonospace=65353;a.increment=8710;a.infinity=8734;a.iniarmenian=1387;a.integral=8747;a.integralbottom=8993;a.integralbt=8993;\na.integralex=63733;a.integraltop=8992;a.integraltp=8992;a.intersection=8745;a.intisquare=13061;a.invbullet=9688;a.invcircle=9689;a.invsmileface=9787;a.iocyrillic=1105;a.iogonek=303;a.iota=953;a.iotadieresis=970;a.iotadieresistonos=912;a.iotalatin=617;a.iotatonos=943;a.iparen=9380;a.irigurmukhi=2674;a.ismallhiragana=12355;a.ismallkatakana=12451;a.ismallkatakanahalfwidth=65384;a.issharbengali=2554;a.istroke=616;a.isuperior=63213;a.iterationhiragana=12445;a.iterationkatakana=12541;a.itilde=297;a.itildebelow=\n7725;a.iubopomofo=12585;a.iucyrillic=1102;a.ivowelsignbengali=2495;a.ivowelsigndeva=2367;a.ivowelsigngujarati=2751;a.izhitsacyrillic=1141;a.izhitsadblgravecyrillic=1143;a.j=106;a.jaarmenian=1393;a.jabengali=2460;a.jadeva=2332;a.jagujarati=2716;a.jagurmukhi=2588;a.jbopomofo=12560;a.jcaron=496;a.jcircle=9433;a.jcircumflex=309;a.jcrossedtail=669;a.jdotlessstroke=607;a.jecyrillic=1112;a.jeemarabic=1580;a.jeemfinalarabic=65182;a.jeeminitialarabic=65183;a.jeemmedialarabic=65184;a.jeharabic=1688;a.jehfinalarabic=\n64395;a.jhabengali=2461;a.jhadeva=2333;a.jhagujarati=2717;a.jhagurmukhi=2589;a.jheharmenian=1403;a.jis=12292;a.jmonospace=65354;a.jparen=9381;a.jsuperior=690;a.k=107;a.kabashkircyrillic=1185;a.kabengali=2453;a.kacute=7729;a.kacyrillic=1082;a.kadescendercyrillic=1179;a.kadeva=2325;a.kaf=1499;a.kafarabic=1603;a.kafdagesh=64315;a.kafdageshhebrew=64315;a.kaffinalarabic=65242;a.kafhebrew=1499;a.kafinitialarabic=65243;a.kafmedialarabic=65244;a.kafrafehebrew=64333;a.kagujarati=2709;a.kagurmukhi=2581;a.kahiragana=\n12363;a.kahookcyrillic=1220;a.kakatakana=12459;a.kakatakanahalfwidth=65398;a.kappa=954;a.kappasymbolgreek=1008;a.kapyeounmieumkorean=12657;a.kapyeounphieuphkorean=12676;a.kapyeounpieupkorean=12664;a.kapyeounssangpieupkorean=12665;a.karoriisquare=13069;a.kashidaautoarabic=1600;a.kashidaautonosidebearingarabic=1600;a.kasmallkatakana=12533;a.kasquare=13188;a.kasraarabic=1616;a.kasratanarabic=1613;a.kastrokecyrillic=1183;a.katahiraprolongmarkhalfwidth=65392;a.kaverticalstrokecyrillic=1181;a.kbopomofo=\n12558;a.kcalsquare=13193;a.kcaron=489;a.kcedilla=311;a.kcircle=9434;a.kcommaaccent=311;a.kdotbelow=7731;a.keharmenian=1412;a.kehiragana=12369;a.kekatakana=12465;a.kekatakanahalfwidth=65401;a.kenarmenian=1391;a.kesmallkatakana=12534;a.kgreenlandic=312;a.khabengali=2454;a.khacyrillic=1093;a.khadeva=2326;a.khagujarati=2710;a.khagurmukhi=2582;a.khaharabic=1582;a.khahfinalarabic=65190;a.khahinitialarabic=65191;a.khahmedialarabic=65192;a.kheicoptic=999;a.khhadeva=2393;a.khhagurmukhi=2649;a.khieukhacirclekorean=\n12920;a.khieukhaparenkorean=12824;a.khieukhcirclekorean=12906;a.khieukhkorean=12619;a.khieukhparenkorean=12810;a.khokhaithai=3586;a.khokhonthai=3589;a.khokhuatthai=3587;a.khokhwaithai=3588;a.khomutthai=3675;a.khook=409;a.khorakhangthai=3590;a.khzsquare=13201;a.kihiragana=12365;a.kikatakana=12461;a.kikatakanahalfwidth=65399;a.kiroguramusquare=13077;a.kiromeetorusquare=13078;a.kirosquare=13076;a.kiyeokacirclekorean=12910;a.kiyeokaparenkorean=12814;a.kiyeokcirclekorean=12896;a.kiyeokkorean=12593;a.kiyeokparenkorean=\n12800;a.kiyeoksioskorean=12595;a.kjecyrillic=1116;a.klinebelow=7733;a.klsquare=13208;a.kmcubedsquare=13222;a.kmonospace=65355;a.kmsquaredsquare=13218;a.kohiragana=12371;a.kohmsquare=13248;a.kokaithai=3585;a.kokatakana=12467;a.kokatakanahalfwidth=65402;a.kooposquare=13086;a.koppacyrillic=1153;a.koreanstandardsymbol=12927;a.koroniscmb=835;a.kparen=9382;a.kpasquare=13226;a.ksicyrillic=1135;a.ktsquare=13263;a.kturned=670;a.kuhiragana=12367;a.kukatakana=12463;a.kukatakanahalfwidth=65400;a.kvsquare=13240;\na.kwsquare=13246;a.l=108;a.labengali=2482;a.lacute=314;a.ladeva=2354;a.lagujarati=2738;a.lagurmukhi=2610;a.lakkhangyaothai=3653;a.lamaleffinalarabic=65276;a.lamalefhamzaabovefinalarabic=65272;a.lamalefhamzaaboveisolatedarabic=65271;a.lamalefhamzabelowfinalarabic=65274;a.lamalefhamzabelowisolatedarabic=65273;a.lamalefisolatedarabic=65275;a.lamalefmaddaabovefinalarabic=65270;a.lamalefmaddaaboveisolatedarabic=65269;a.lamarabic=1604;a.lambda=955;a.lambdastroke=411;a.lamed=1500;a.lameddagesh=64316;a.lameddageshhebrew=\n64316;a.lamedhebrew=1500;a.lamfinalarabic=65246;a.lamhahinitialarabic=64714;a.laminitialarabic=65247;a.lamjeeminitialarabic=64713;a.lamkhahinitialarabic=64715;a.lamlamhehisolatedarabic=65010;a.lammedialarabic=65248;a.lammeemhahinitialarabic=64904;a.lammeeminitialarabic=64716;a.largecircle=9711;a.lbar=410;a.lbelt=620;a.lbopomofo=12556;a.lcaron=318;a.lcedilla=316;a.lcircle=9435;a.lcircumflexbelow=7741;a.lcommaaccent=316;a.ldot=320;a.ldotaccent=320;a.ldotbelow=7735;a.ldotbelowmacron=7737;a.leftangleabovecmb=\n794;a.lefttackbelowcmb=792;a.less=60;a.lessequal=8804;a.lessequalorgreater=8922;a.lessmonospace=65308;a.lessorequivalent=8818;a.lessorgreater=8822;a.lessoverequal=8806;a.lesssmall=65124;a.lezh=622;a.lfblock=9612;a.lhookretroflex=621;a.lira=8356;a.liwnarmenian=1388;a.lj=457;a.ljecyrillic=1113;a.ll=63168;a.lladeva=2355;a.llagujarati=2739;a.llinebelow=7739;a.llladeva=2356;a.llvocalicbengali=2529;a.llvocalicdeva=2401;a.llvocalicvowelsignbengali=2531;a.llvocalicvowelsigndeva=2403;a.lmiddletilde=619;a.lmonospace=\n65356;a.lmsquare=13264;a.lochulathai=3628;a.logicaland=8743;a.logicalnot=172;a.logicalnotreversed=8976;a.logicalor=8744;a.lolingthai=3621;a.longs=383;a.lowlinecenterline=65102;a.lowlinecmb=818;a.lowlinedashed=65101;a.lozenge=9674;a.lparen=9383;a.lslash=322;a.lsquare=8467;a.lsuperior=63214;a.ltshade=9617;a.luthai=3622;a.lvocalicbengali=2444;a.lvocalicdeva=2316;a.lvocalicvowelsignbengali=2530;a.lvocalicvowelsigndeva=2402;a.lxsquare=13267;a.m=109;a.mabengali=2478;a.macron=175;a.macronbelowcmb=817;a.macroncmb=\n772;a.macronlowmod=717;a.macronmonospace=65507;a.macute=7743;a.madeva=2350;a.magujarati=2734;a.magurmukhi=2606;a.mahapakhhebrew=1444;a.mahapakhlefthebrew=1444;a.mahiragana=12414;a.maichattawalowleftthai=63637;a.maichattawalowrightthai=63636;a.maichattawathai=3659;a.maichattawaupperleftthai=63635;a.maieklowleftthai=63628;a.maieklowrightthai=63627;a.maiekthai=3656;a.maiekupperleftthai=63626;a.maihanakatleftthai=63620;a.maihanakatthai=3633;a.maitaikhuleftthai=63625;a.maitaikhuthai=3655;a.maitholowleftthai=\n63631;a.maitholowrightthai=63630;a.maithothai=3657;a.maithoupperleftthai=63629;a.maitrilowleftthai=63634;a.maitrilowrightthai=63633;a.maitrithai=3658;a.maitriupperleftthai=63632;a.maiyamokthai=3654;a.makatakana=12510;a.makatakanahalfwidth=65423;a.male=9794;a.mansyonsquare=13127;a.maqafhebrew=1470;a.mars=9794;a.masoracirclehebrew=1455;a.masquare=13187;a.mbopomofo=12551;a.mbsquare=13268;a.mcircle=9436;a.mcubedsquare=13221;a.mdotaccent=7745;a.mdotbelow=7747;a.meemarabic=1605;a.meemfinalarabic=65250;\na.meeminitialarabic=65251;a.meemmedialarabic=65252;a.meemmeeminitialarabic=64721;a.meemmeemisolatedarabic=64584;a.meetorusquare=13133;a.mehiragana=12417;a.meizierasquare=13182;a.mekatakana=12513;a.mekatakanahalfwidth=65426;a.mem=1502;a.memdagesh=64318;a.memdageshhebrew=64318;a.memhebrew=1502;a.menarmenian=1396;a.merkhahebrew=1445;a.merkhakefulahebrew=1446;a.merkhakefulalefthebrew=1446;a.merkhalefthebrew=1445;a.mhook=625;a.mhzsquare=13202;a.middledotkatakanahalfwidth=65381;a.middot=183;a.mieumacirclekorean=\n12914;a.mieumaparenkorean=12818;a.mieumcirclekorean=12900;a.mieumkorean=12609;a.mieumpansioskorean=12656;a.mieumparenkorean=12804;a.mieumpieupkorean=12654;a.mieumsioskorean=12655;a.mihiragana=12415;a.mikatakana=12511;a.mikatakanahalfwidth=65424;a.minus=8722;a.minusbelowcmb=800;a.minuscircle=8854;a.minusmod=727;a.minusplus=8723;a.minute=8242;a.miribaarusquare=13130;a.mirisquare=13129;a.mlonglegturned=624;a.mlsquare=13206;a.mmcubedsquare=13219;a.mmonospace=65357;a.mmsquaredsquare=13215;a.mohiragana=\n12418;a.mohmsquare=13249;a.mokatakana=12514;a.mokatakanahalfwidth=65427;a.molsquare=13270;a.momathai=3617;a.moverssquare=13223;a.moverssquaredsquare=13224;a.mparen=9384;a.mpasquare=13227;a.mssquare=13235;a.msuperior=63215;a.mturned=623;a.mu=181;a.mu1=181;a.muasquare=13186;a.muchgreater=8811;a.muchless=8810;a.mufsquare=13196;a.mugreek=956;a.mugsquare=13197;a.muhiragana=12416;a.mukatakana=12512;a.mukatakanahalfwidth=65425;a.mulsquare=13205;a.multiply=215;a.mumsquare=13211;a.munahhebrew=1443;a.munahlefthebrew=\n1443;a.musicalnote=9834;a.musicalnotedbl=9835;a.musicflatsign=9837;a.musicsharpsign=9839;a.mussquare=13234;a.muvsquare=13238;a.muwsquare=13244;a.mvmegasquare=13241;a.mvsquare=13239;a.mwmegasquare=13247;a.mwsquare=13245;a.n=110;a.nabengali=2472;a.nabla=8711;a.nacute=324;a.nadeva=2344;a.nagujarati=2728;a.nagurmukhi=2600;a.nahiragana=12394;a.nakatakana=12490;a.nakatakanahalfwidth=65413;a.napostrophe=329;a.nasquare=13185;a.nbopomofo=12555;a.nbspace=160;a.ncaron=328;a.ncedilla=326;a.ncircle=9437;a.ncircumflexbelow=\n7755;a.ncommaaccent=326;a.ndotaccent=7749;a.ndotbelow=7751;a.nehiragana=12397;a.nekatakana=12493;a.nekatakanahalfwidth=65416;a.newsheqelsign=8362;a.nfsquare=13195;a.ngabengali=2457;a.ngadeva=2329;a.ngagujarati=2713;a.ngagurmukhi=2585;a.ngonguthai=3591;a.nhiragana=12435;a.nhookleft=626;a.nhookretroflex=627;a.nieunacirclekorean=12911;a.nieunaparenkorean=12815;a.nieuncieuckorean=12597;a.nieuncirclekorean=12897;a.nieunhieuhkorean=12598;a.nieunkorean=12596;a.nieunpansioskorean=12648;a.nieunparenkorean=\n12801;a.nieunsioskorean=12647;a.nieuntikeutkorean=12646;a.nihiragana=12395;a.nikatakana=12491;a.nikatakanahalfwidth=65414;a.nikhahitleftthai=63641;a.nikhahitthai=3661;a.nine=57;a.ninearabic=1641;a.ninebengali=2543;a.ninecircle=9320;a.ninecircleinversesansserif=10130;a.ninedeva=2415;a.ninegujarati=2799;a.ninegurmukhi=2671;a.ninehackarabic=1641;a.ninehangzhou=12329;a.nineideographicparen=12840;a.nineinferior=8329;a.ninemonospace=65305;a.nineoldstyle=63289;a.nineparen=9340;a.nineperiod=9360;a.ninepersian=\n1785;a.nineroman=8568;a.ninesuperior=8313;a.nineteencircle=9330;a.nineteenparen=9350;a.nineteenperiod=9370;a.ninethai=3673;a.nj=460;a.njecyrillic=1114;a.nkatakana=12531;a.nkatakanahalfwidth=65437;a.nlegrightlong=414;a.nlinebelow=7753;a.nmonospace=65358;a.nmsquare=13210;a.nnabengali=2467;a.nnadeva=2339;a.nnagujarati=2723;a.nnagurmukhi=2595;a.nnnadeva=2345;a.nohiragana=12398;a.nokatakana=12494;a.nokatakanahalfwidth=65417;a.nonbreakingspace=160;a.nonenthai=3603;a.nonuthai=3609;a.noonarabic=1606;a.noonfinalarabic=\n65254;a.noonghunnaarabic=1722;a.noonghunnafinalarabic=64415;a.nooninitialarabic=65255;a.noonjeeminitialarabic=64722;a.noonjeemisolatedarabic=64587;a.noonmedialarabic=65256;a.noonmeeminitialarabic=64725;a.noonmeemisolatedarabic=64590;a.noonnoonfinalarabic=64653;a.notcontains=8716;a.notelement=8713;a.notelementof=8713;a.notequal=8800;a.notgreater=8815;a.notgreaternorequal=8817;a.notgreaternorless=8825;a.notidentical=8802;a.notless=8814;a.notlessnorequal=8816;a.notparallel=8742;a.notprecedes=8832;a.notsubset=\n8836;a.notsucceeds=8833;a.notsuperset=8837;a.nowarmenian=1398;a.nparen=9385;a.nssquare=13233;a.nsuperior=8319;a.ntilde=241;a.nu=957;a.nuhiragana=12396;a.nukatakana=12492;a.nukatakanahalfwidth=65415;a.nuktabengali=2492;a.nuktadeva=2364;a.nuktagujarati=2748;a.nuktagurmukhi=2620;a.numbersign=35;a.numbersignmonospace=65283;a.numbersignsmall=65119;a.numeralsigngreek=884;a.numeralsignlowergreek=885;a.numero=8470;a.nun=1504;a.nundagesh=64320;a.nundageshhebrew=64320;a.nunhebrew=1504;a.nvsquare=13237;a.nwsquare=\n13243;a.nyabengali=2462;a.nyadeva=2334;a.nyagujarati=2718;a.nyagurmukhi=2590;a.o=111;a.oacute=243;a.oangthai=3629;a.obarred=629;a.obarredcyrillic=1257;a.obarreddieresiscyrillic=1259;a.obengali=2451;a.obopomofo=12571;a.obreve=335;a.ocandradeva=2321;a.ocandragujarati=2705;a.ocandravowelsigndeva=2377;a.ocandravowelsigngujarati=2761;a.ocaron=466;a.ocircle=9438;a.ocircumflex=244;a.ocircumflexacute=7889;a.ocircumflexdotbelow=7897;a.ocircumflexgrave=7891;a.ocircumflexhookabove=7893;a.ocircumflextilde=7895;\na.ocyrillic=1086;a.odblacute=337;a.odblgrave=525;a.odeva=2323;a.odieresis=246;a.odieresiscyrillic=1255;a.odotbelow=7885;a.oe=339;a.oekorean=12634;a.ogonek=731;a.ogonekcmb=808;a.ograve=242;a.ogujarati=2707;a.oharmenian=1413;a.ohiragana=12362;a.ohookabove=7887;a.ohorn=417;a.ohornacute=7899;a.ohorndotbelow=7907;a.ohorngrave=7901;a.ohornhookabove=7903;a.ohorntilde=7905;a.ohungarumlaut=337;a.oi=419;a.oinvertedbreve=527;a.okatakana=12458;a.okatakanahalfwidth=65397;a.okorean=12631;a.olehebrew=1451;a.omacron=\n333;a.omacronacute=7763;a.omacrongrave=7761;a.omdeva=2384;a.omega=969;a.omega1=982;a.omegacyrillic=1121;a.omegalatinclosed=631;a.omegaroundcyrillic=1147;a.omegatitlocyrillic=1149;a.omegatonos=974;a.omgujarati=2768;a.omicron=959;a.omicrontonos=972;a.omonospace=65359;a.one=49;a.onearabic=1633;a.onebengali=2535;a.onecircle=9312;a.onecircleinversesansserif=10122;a.onedeva=2407;a.onedotenleader=8228;a.oneeighth=8539;a.onefitted=63196;a.onegujarati=2791;a.onegurmukhi=2663;a.onehackarabic=1633;a.onehalf=\n189;a.onehangzhou=12321;a.oneideographicparen=12832;a.oneinferior=8321;a.onemonospace=65297;a.onenumeratorbengali=2548;a.oneoldstyle=63281;a.oneparen=9332;a.oneperiod=9352;a.onepersian=1777;a.onequarter=188;a.oneroman=8560;a.onesuperior=185;a.onethai=3665;a.onethird=8531;a.oogonek=491;a.oogonekmacron=493;a.oogurmukhi=2579;a.oomatragurmukhi=2635;a.oopen=596;a.oparen=9386;a.openbullet=9702;a.option=8997;a.ordfeminine=170;a.ordmasculine=186;a.orthogonal=8735;a.oshortdeva=2322;a.oshortvowelsigndeva=2378;\na.oslash=248;a.oslashacute=511;a.osmallhiragana=12361;a.osmallkatakana=12457;a.osmallkatakanahalfwidth=65387;a.ostrokeacute=511;a.osuperior=63216;a.otcyrillic=1151;a.otilde=245;a.otildeacute=7757;a.otildedieresis=7759;a.oubopomofo=12577;a.overline=8254;a.overlinecenterline=65098;a.overlinecmb=773;a.overlinedashed=65097;a.overlinedblwavy=65100;a.overlinewavy=65099;a.overscore=175;a.ovowelsignbengali=2507;a.ovowelsigndeva=2379;a.ovowelsigngujarati=2763;a.p=112;a.paampssquare=13184;a.paasentosquare=\n13099;a.pabengali=2474;a.pacute=7765;a.padeva=2346;a.pagedown=8671;a.pageup=8670;a.pagujarati=2730;a.pagurmukhi=2602;a.pahiragana=12401;a.paiyannoithai=3631;a.pakatakana=12497;a.palatalizationcyrilliccmb=1156;a.palochkacyrillic=1216;a.pansioskorean=12671;a.paragraph=182;a.parallel=8741;a.parenleft=40;a.parenleftaltonearabic=64830;a.parenleftbt=63725;a.parenleftex=63724;a.parenleftinferior=8333;a.parenleftmonospace=65288;a.parenleftsmall=65113;a.parenleftsuperior=8317;a.parenlefttp=63723;a.parenleftvertical=\n65077;a.parenright=41;a.parenrightaltonearabic=64831;a.parenrightbt=63736;a.parenrightex=63735;a.parenrightinferior=8334;a.parenrightmonospace=65289;a.parenrightsmall=65114;a.parenrightsuperior=8318;a.parenrighttp=63734;a.parenrightvertical=65078;a.partialdiff=8706;a.paseqhebrew=1472;a.pashtahebrew=1433;a.pasquare=13225;a.patah=1463;a.patah11=1463;a.patah1d=1463;a.patah2a=1463;a.patahhebrew=1463;a.patahnarrowhebrew=1463;a.patahquarterhebrew=1463;a.patahwidehebrew=1463;a.pazerhebrew=1441;a.pbopomofo=\n12550;a.pcircle=9439;a.pdotaccent=7767;a.pe=1508;a.pecyrillic=1087;a.pedagesh=64324;a.pedageshhebrew=64324;a.peezisquare=13115;a.pefinaldageshhebrew=64323;a.peharabic=1662;a.peharmenian=1402;a.pehebrew=1508;a.pehfinalarabic=64343;a.pehinitialarabic=64344;a.pehiragana=12410;a.pehmedialarabic=64345;a.pekatakana=12506;a.pemiddlehookcyrillic=1191;a.perafehebrew=64334;a.percent=37;a.percentarabic=1642;a.percentmonospace=65285;a.percentsmall=65130;a.period=46;a.periodarmenian=1417;a.periodcentered=183;\na.periodhalfwidth=65377;a.periodinferior=63207;a.periodmonospace=65294;a.periodsmall=65106;a.periodsuperior=63208;a.perispomenigreekcmb=834;a.perpendicular=8869;a.perthousand=8240;a.peseta=8359;a.pfsquare=13194;a.phabengali=2475;a.phadeva=2347;a.phagujarati=2731;a.phagurmukhi=2603;a.phi=966;a.phi1=981;a.phieuphacirclekorean=12922;a.phieuphaparenkorean=12826;a.phieuphcirclekorean=12908;a.phieuphkorean=12621;a.phieuphparenkorean=12812;a.philatin=632;a.phinthuthai=3642;a.phisymbolgreek=981;a.phook=421;\na.phophanthai=3614;a.phophungthai=3612;a.phosamphaothai=3616;a.pi=960;a.pieupacirclekorean=12915;a.pieupaparenkorean=12819;a.pieupcieuckorean=12662;a.pieupcirclekorean=12901;a.pieupkiyeokkorean=12658;a.pieupkorean=12610;a.pieupparenkorean=12805;a.pieupsioskiyeokkorean=12660;a.pieupsioskorean=12612;a.pieupsiostikeutkorean=12661;a.pieupthieuthkorean=12663;a.pieuptikeutkorean=12659;a.pihiragana=12404;a.pikatakana=12500;a.pisymbolgreek=982;a.piwrarmenian=1411;a.planckover2pi=8463;a.planckover2pi1=8463;\na.plus=43;a.plusbelowcmb=799;a.pluscircle=8853;a.plusminus=177;a.plusmod=726;a.plusmonospace=65291;a.plussmall=65122;a.plussuperior=8314;a.pmonospace=65360;a.pmsquare=13272;a.pohiragana=12413;a.pointingindexdownwhite=9759;a.pointingindexleftwhite=9756;a.pointingindexrightwhite=9758;a.pointingindexupwhite=9757;a.pokatakana=12509;a.poplathai=3611;a.postalmark=12306;a.postalmarkface=12320;a.pparen=9387;a.precedes=8826;a.prescription=8478;a.primemod=697;a.primereversed=8245;a.product=8719;a.projective=\n8965;a.prolongedkana=12540;a.propellor=8984;a.propersubset=8834;a.propersuperset=8835;a.proportion=8759;a.proportional=8733;a.psi=968;a.psicyrillic=1137;a.psilipneumatacyrilliccmb=1158;a.pssquare=13232;a.puhiragana=12407;a.pukatakana=12503;a.pvsquare=13236;a.pwsquare=13242;a.q=113;a.qadeva=2392;a.qadmahebrew=1448;a.qafarabic=1602;a.qaffinalarabic=65238;a.qafinitialarabic=65239;a.qafmedialarabic=65240;a.qamats=1464;a.qamats10=1464;a.qamats1a=1464;a.qamats1c=1464;a.qamats27=1464;a.qamats29=1464;a.qamats33=\n1464;a.qamatsde=1464;a.qamatshebrew=1464;a.qamatsnarrowhebrew=1464;a.qamatsqatanhebrew=1464;a.qamatsqatannarrowhebrew=1464;a.qamatsqatanquarterhebrew=1464;a.qamatsqatanwidehebrew=1464;a.qamatsquarterhebrew=1464;a.qamatswidehebrew=1464;a.qarneyparahebrew=1439;a.qbopomofo=12561;a.qcircle=9440;a.qhook=672;a.qmonospace=65361;a.qof=1511;a.qofdagesh=64327;a.qofdageshhebrew=64327;a.qofhebrew=1511;a.qparen=9388;a.quarternote=9833;a.qubuts=1467;a.qubuts18=1467;a.qubuts25=1467;a.qubuts31=1467;a.qubutshebrew=\n1467;a.qubutsnarrowhebrew=1467;a.qubutsquarterhebrew=1467;a.qubutswidehebrew=1467;a.question=63;a.questionarabic=1567;a.questionarmenian=1374;a.questiondown=191;a.questiondownsmall=63423;a.questiongreek=894;a.questionmonospace=65311;a.questionsmall=63295;a.quotedbl=34;a.quotedblbase=8222;a.quotedblleft=8220;a.quotedblmonospace=65282;a.quotedblprime=12318;a.quotedblprimereversed=12317;a.quotedblright=8221;a.quoteleft=8216;a.quoteleftreversed=8219;a.quotereversed=8219;a.quoteright=8217;a.quoterightn=\n329;a.quotesinglbase=8218;a.quotesingle=39;a.quotesinglemonospace=65287;a.r=114;a.raarmenian=1404;a.rabengali=2480;a.racute=341;a.radeva=2352;a.radical=8730;a.radicalex=63717;a.radoverssquare=13230;a.radoverssquaredsquare=13231;a.radsquare=13229;a.rafe=1471;a.rafehebrew=1471;a.ragujarati=2736;a.ragurmukhi=2608;a.rahiragana=12425;a.rakatakana=12521;a.rakatakanahalfwidth=65431;a.ralowerdiagonalbengali=2545;a.ramiddlediagonalbengali=2544;a.ramshorn=612;a.ratio=8758;a.rbopomofo=12566;a.rcaron=345;a.rcedilla=\n343;a.rcircle=9441;a.rcommaaccent=343;a.rdblgrave=529;a.rdotaccent=7769;a.rdotbelow=7771;a.rdotbelowmacron=7773;a.referencemark=8251;a.reflexsubset=8838;a.reflexsuperset=8839;a.registered=174;a.registersans=63720;a.registerserif=63194;a.reharabic=1585;a.reharmenian=1408;a.rehfinalarabic=65198;a.rehiragana=12428;a.rekatakana=12524;a.rekatakanahalfwidth=65434;a.resh=1512;a.reshdageshhebrew=64328;a.reshhebrew=1512;a.reversedtilde=8765;a.reviahebrew=1431;a.reviamugrashhebrew=1431;a.revlogicalnot=8976;\na.rfishhook=638;a.rfishhookreversed=639;a.rhabengali=2525;a.rhadeva=2397;a.rho=961;a.rhook=637;a.rhookturned=635;a.rhookturnedsuperior=693;a.rhosymbolgreek=1009;a.rhotichookmod=734;a.rieulacirclekorean=12913;a.rieulaparenkorean=12817;a.rieulcirclekorean=12899;a.rieulhieuhkorean=12608;a.rieulkiyeokkorean=12602;a.rieulkiyeoksioskorean=12649;a.rieulkorean=12601;a.rieulmieumkorean=12603;a.rieulpansioskorean=12652;a.rieulparenkorean=12803;a.rieulphieuphkorean=12607;a.rieulpieupkorean=12604;a.rieulpieupsioskorean=\n12651;a.rieulsioskorean=12605;a.rieulthieuthkorean=12606;a.rieultikeutkorean=12650;a.rieulyeorinhieuhkorean=12653;a.rightangle=8735;a.righttackbelowcmb=793;a.righttriangle=8895;a.rihiragana=12426;a.rikatakana=12522;a.rikatakanahalfwidth=65432;a.ring=730;a.ringbelowcmb=805;a.ringcmb=778;a.ringhalfleft=703;a.ringhalfleftarmenian=1369;a.ringhalfleftbelowcmb=796;a.ringhalfleftcentered=723;a.ringhalfright=702;a.ringhalfrightbelowcmb=825;a.ringhalfrightcentered=722;a.rinvertedbreve=531;a.rittorusquare=\n13137;a.rlinebelow=7775;a.rlongleg=636;a.rlonglegturned=634;a.rmonospace=65362;a.rohiragana=12429;a.rokatakana=12525;a.rokatakanahalfwidth=65435;a.roruathai=3619;a.rparen=9389;a.rrabengali=2524;a.rradeva=2353;a.rragurmukhi=2652;a.rreharabic=1681;a.rrehfinalarabic=64397;a.rrvocalicbengali=2528;a.rrvocalicdeva=2400;a.rrvocalicgujarati=2784;a.rrvocalicvowelsignbengali=2500;a.rrvocalicvowelsigndeva=2372;a.rrvocalicvowelsigngujarati=2756;a.rsuperior=63217;a.rtblock=9616;a.rturned=633;a.rturnedsuperior=\n692;a.ruhiragana=12427;a.rukatakana=12523;a.rukatakanahalfwidth=65433;a.rupeemarkbengali=2546;a.rupeesignbengali=2547;a.rupiah=63197;a.ruthai=3620;a.rvocalicbengali=2443;a.rvocalicdeva=2315;a.rvocalicgujarati=2699;a.rvocalicvowelsignbengali=2499;a.rvocalicvowelsigndeva=2371;a.rvocalicvowelsigngujarati=2755;a.s=115;a.sabengali=2488;a.sacute=347;a.sacutedotaccent=7781;a.sadarabic=1589;a.sadeva=2360;a.sadfinalarabic=65210;a.sadinitialarabic=65211;a.sadmedialarabic=65212;a.sagujarati=2744;a.sagurmukhi=\n2616;a.sahiragana=12373;a.sakatakana=12469;a.sakatakanahalfwidth=65403;a.sallallahoualayhewasallamarabic=65018;a.samekh=1505;a.samekhdagesh=64321;a.samekhdageshhebrew=64321;a.samekhhebrew=1505;a.saraaathai=3634;a.saraaethai=3649;a.saraaimaimalaithai=3652;a.saraaimaimuanthai=3651;a.saraamthai=3635;a.saraathai=3632;a.saraethai=3648;a.saraiileftthai=63622;a.saraiithai=3637;a.saraileftthai=63621;a.saraithai=3636;a.saraothai=3650;a.saraueeleftthai=63624;a.saraueethai=3639;a.saraueleftthai=63623;a.sarauethai=\n3638;a.sarauthai=3640;a.sarauuthai=3641;a.sbopomofo=12569;a.scaron=353;a.scarondotaccent=7783;a.scedilla=351;a.schwa=601;a.schwacyrillic=1241;a.schwadieresiscyrillic=1243;a.schwahook=602;a.scircle=9442;a.scircumflex=349;a.scommaaccent=537;a.sdotaccent=7777;a.sdotbelow=7779;a.sdotbelowdotaccent=7785;a.seagullbelowcmb=828;a.second=8243;a.secondtonechinese=714;a.section=167;a.seenarabic=1587;a.seenfinalarabic=65202;a.seeninitialarabic=65203;a.seenmedialarabic=65204;a.segol=1462;a.segol13=1462;a.segol1f=\n1462;a.segol2c=1462;a.segolhebrew=1462;a.segolnarrowhebrew=1462;a.segolquarterhebrew=1462;a.segoltahebrew=1426;a.segolwidehebrew=1462;a.seharmenian=1405;a.sehiragana=12379;a.sekatakana=12475;a.sekatakanahalfwidth=65406;a.semicolon=59;a.semicolonarabic=1563;a.semicolonmonospace=65307;a.semicolonsmall=65108;a.semivoicedmarkkana=12444;a.semivoicedmarkkanahalfwidth=65439;a.sentisquare=13090;a.sentosquare=13091;a.seven=55;a.sevenarabic=1639;a.sevenbengali=2541;a.sevencircle=9318;a.sevencircleinversesansserif=\n10128;a.sevendeva=2413;a.seveneighths=8542;a.sevengujarati=2797;a.sevengurmukhi=2669;a.sevenhackarabic=1639;a.sevenhangzhou=12327;a.sevenideographicparen=12838;a.seveninferior=8327;a.sevenmonospace=65303;a.sevenoldstyle=63287;a.sevenparen=9338;a.sevenperiod=9358;a.sevenpersian=1783;a.sevenroman=8566;a.sevensuperior=8311;a.seventeencircle=9328;a.seventeenparen=9348;a.seventeenperiod=9368;a.seventhai=3671;a.sfthyphen=173;a.shaarmenian=1399;a.shabengali=2486;a.shacyrillic=1096;a.shaddaarabic=1617;a.shaddadammaarabic=\n64609;a.shaddadammatanarabic=64606;a.shaddafathaarabic=64608;a.shaddakasraarabic=64610;a.shaddakasratanarabic=64607;a.shade=9618;a.shadedark=9619;a.shadelight=9617;a.shademedium=9618;a.shadeva=2358;a.shagujarati=2742;a.shagurmukhi=2614;a.shalshelethebrew=1427;a.shbopomofo=12565;a.shchacyrillic=1097;a.sheenarabic=1588;a.sheenfinalarabic=65206;a.sheeninitialarabic=65207;a.sheenmedialarabic=65208;a.sheicoptic=995;a.sheqel=8362;a.sheqelhebrew=8362;a.sheva=1456;a.sheva115=1456;a.sheva15=1456;a.sheva22=\n1456;a.sheva2e=1456;a.shevahebrew=1456;a.shevanarrowhebrew=1456;a.shevaquarterhebrew=1456;a.shevawidehebrew=1456;a.shhacyrillic=1211;a.shimacoptic=1005;a.shin=1513;a.shindagesh=64329;a.shindageshhebrew=64329;a.shindageshshindot=64300;a.shindageshshindothebrew=64300;a.shindageshsindot=64301;a.shindageshsindothebrew=64301;a.shindothebrew=1473;a.shinhebrew=1513;a.shinshindot=64298;a.shinshindothebrew=64298;a.shinsindot=64299;a.shinsindothebrew=64299;a.shook=642;a.sigma=963;a.sigma1=962;a.sigmafinal=\n962;a.sigmalunatesymbolgreek=1010;a.sihiragana=12375;a.sikatakana=12471;a.sikatakanahalfwidth=65404;a.siluqhebrew=1469;a.siluqlefthebrew=1469;a.similar=8764;a.sindothebrew=1474;a.siosacirclekorean=12916;a.siosaparenkorean=12820;a.sioscieuckorean=12670;a.sioscirclekorean=12902;a.sioskiyeokkorean=12666;a.sioskorean=12613;a.siosnieunkorean=12667;a.siosparenkorean=12806;a.siospieupkorean=12669;a.siostikeutkorean=12668;a.six=54;a.sixarabic=1638;a.sixbengali=2540;a.sixcircle=9317;a.sixcircleinversesansserif=\n10127;a.sixdeva=2412;a.sixgujarati=2796;a.sixgurmukhi=2668;a.sixhackarabic=1638;a.sixhangzhou=12326;a.sixideographicparen=12837;a.sixinferior=8326;a.sixmonospace=65302;a.sixoldstyle=63286;a.sixparen=9337;a.sixperiod=9357;a.sixpersian=1782;a.sixroman=8565;a.sixsuperior=8310;a.sixteencircle=9327;a.sixteencurrencydenominatorbengali=2553;a.sixteenparen=9347;a.sixteenperiod=9367;a.sixthai=3670;a.slash=47;a.slashmonospace=65295;a.slong=383;a.slongdotaccent=7835;a.smileface=9786;a.smonospace=65363;a.sofpasuqhebrew=\n1475;a.softhyphen=173;a.softsigncyrillic=1100;a.sohiragana=12381;a.sokatakana=12477;a.sokatakanahalfwidth=65407;a.soliduslongoverlaycmb=824;a.solidusshortoverlaycmb=823;a.sorusithai=3625;a.sosalathai=3624;a.sosothai=3595;a.sosuathai=3626;a.space=32;a.spacehackarabic=32;a.spade=9824;a.spadesuitblack=9824;a.spadesuitwhite=9828;a.sparen=9390;a.squarebelowcmb=827;a.squarecc=13252;a.squarecm=13213;a.squarediagonalcrosshatchfill=9641;a.squarehorizontalfill=9636;a.squarekg=13199;a.squarekm=13214;a.squarekmcapital=\n13262;a.squareln=13265;a.squarelog=13266;a.squaremg=13198;a.squaremil=13269;a.squaremm=13212;a.squaremsquared=13217;a.squareorthogonalcrosshatchfill=9638;a.squareupperlefttolowerrightfill=9639;a.squareupperrighttolowerleftfill=9640;a.squareverticalfill=9637;a.squarewhitewithsmallblack=9635;a.srsquare=13275;a.ssabengali=2487;a.ssadeva=2359;a.ssagujarati=2743;a.ssangcieuckorean=12617;a.ssanghieuhkorean=12677;a.ssangieungkorean=12672;a.ssangkiyeokkorean=12594;a.ssangnieunkorean=12645;a.ssangpieupkorean=\n12611;a.ssangsioskorean=12614;a.ssangtikeutkorean=12600;a.ssuperior=63218;a.sterling=163;a.sterlingmonospace=65505;a.strokelongoverlaycmb=822;a.strokeshortoverlaycmb=821;a.subset=8834;a.subsetnotequal=8842;a.subsetorequal=8838;a.succeeds=8827;a.suchthat=8715;a.suhiragana=12377;a.sukatakana=12473;a.sukatakanahalfwidth=65405;a.sukunarabic=1618;a.summation=8721;a.sun=9788;a.superset=8835;a.supersetnotequal=8843;a.supersetorequal=8839;a.svsquare=13276;a.syouwaerasquare=13180;a.t=116;a.tabengali=2468;\na.tackdown=8868;a.tackleft=8867;a.tadeva=2340;a.tagujarati=2724;a.tagurmukhi=2596;a.taharabic=1591;a.tahfinalarabic=65218;a.tahinitialarabic=65219;a.tahiragana=12383;a.tahmedialarabic=65220;a.taisyouerasquare=13181;a.takatakana=12479;a.takatakanahalfwidth=65408;a.tatweelarabic=1600;a.tau=964;a.tav=1514;a.tavdages=64330;a.tavdagesh=64330;a.tavdageshhebrew=64330;a.tavhebrew=1514;a.tbar=359;a.tbopomofo=12554;a.tcaron=357;a.tccurl=680;a.tcedilla=355;a.tcheharabic=1670;a.tchehfinalarabic=64379;a.tchehinitialarabic=\n64380;a.tchehmedialarabic=64381;a.tcircle=9443;a.tcircumflexbelow=7793;a.tcommaaccent=355;a.tdieresis=7831;a.tdotaccent=7787;a.tdotbelow=7789;a.tecyrillic=1090;a.tedescendercyrillic=1197;a.teharabic=1578;a.tehfinalarabic=65174;a.tehhahinitialarabic=64674;a.tehhahisolatedarabic=64524;a.tehinitialarabic=65175;a.tehiragana=12390;a.tehjeeminitialarabic=64673;a.tehjeemisolatedarabic=64523;a.tehmarbutaarabic=1577;a.tehmarbutafinalarabic=65172;a.tehmedialarabic=65176;a.tehmeeminitialarabic=64676;a.tehmeemisolatedarabic=\n64526;a.tehnoonfinalarabic=64627;a.tekatakana=12486;a.tekatakanahalfwidth=65411;a.telephone=8481;a.telephoneblack=9742;a.telishagedolahebrew=1440;a.telishaqetanahebrew=1449;a.tencircle=9321;a.tenideographicparen=12841;a.tenparen=9341;a.tenperiod=9361;a.tenroman=8569;a.tesh=679;a.tet=1496;a.tetdagesh=64312;a.tetdageshhebrew=64312;a.tethebrew=1496;a.tetsecyrillic=1205;a.tevirhebrew=1435;a.tevirlefthebrew=1435;a.thabengali=2469;a.thadeva=2341;a.thagujarati=2725;a.thagurmukhi=2597;a.thalarabic=1584;a.thalfinalarabic=\n65196;a.thanthakhatlowleftthai=63640;a.thanthakhatlowrightthai=63639;a.thanthakhatthai=3660;a.thanthakhatupperleftthai=63638;a.theharabic=1579;a.thehfinalarabic=65178;a.thehinitialarabic=65179;a.thehmedialarabic=65180;a.thereexists=8707;a.therefore=8756;a.theta=952;a.theta1=977;a.thetasymbolgreek=977;a.thieuthacirclekorean=12921;a.thieuthaparenkorean=12825;a.thieuthcirclekorean=12907;a.thieuthkorean=12620;a.thieuthparenkorean=12811;a.thirteencircle=9324;a.thirteenparen=9344;a.thirteenperiod=9364;\na.thonangmonthothai=3601;a.thook=429;a.thophuthaothai=3602;a.thorn=254;a.thothahanthai=3607;a.thothanthai=3600;a.thothongthai=3608;a.thothungthai=3606;a.thousandcyrillic=1154;a.thousandsseparatorarabic=1644;a.thousandsseparatorpersian=1644;a.three=51;a.threearabic=1635;a.threebengali=2537;a.threecircle=9314;a.threecircleinversesansserif=10124;a.threedeva=2409;a.threeeighths=8540;a.threegujarati=2793;a.threegurmukhi=2665;a.threehackarabic=1635;a.threehangzhou=12323;a.threeideographicparen=12834;a.threeinferior=\n8323;a.threemonospace=65299;a.threenumeratorbengali=2550;a.threeoldstyle=63283;a.threeparen=9334;a.threeperiod=9354;a.threepersian=1779;a.threequarters=190;a.threequartersemdash=63198;a.threeroman=8562;a.threesuperior=179;a.threethai=3667;a.thzsquare=13204;a.tihiragana=12385;a.tikatakana=12481;a.tikatakanahalfwidth=65409;a.tikeutacirclekorean=12912;a.tikeutaparenkorean=12816;a.tikeutcirclekorean=12898;a.tikeutkorean=12599;a.tikeutparenkorean=12802;a.tilde=732;a.tildebelowcmb=816;a.tildecmb=771;a.tildecomb=\n771;a.tildedoublecmb=864;a.tildeoperator=8764;a.tildeoverlaycmb=820;a.tildeverticalcmb=830;a.timescircle=8855;a.tipehahebrew=1430;a.tipehalefthebrew=1430;a.tippigurmukhi=2672;a.titlocyrilliccmb=1155;a.tiwnarmenian=1407;a.tlinebelow=7791;a.tmonospace=65364;a.toarmenian=1385;a.tohiragana=12392;a.tokatakana=12488;a.tokatakanahalfwidth=65412;a.tonebarextrahighmod=741;a.tonebarextralowmod=745;a.tonebarhighmod=742;a.tonebarlowmod=744;a.tonebarmidmod=743;a.tonefive=445;a.tonesix=389;a.tonetwo=424;a.tonos=\n900;a.tonsquare=13095;a.topatakthai=3599;a.tortoiseshellbracketleft=12308;a.tortoiseshellbracketleftsmall=65117;a.tortoiseshellbracketleftvertical=65081;a.tortoiseshellbracketright=12309;a.tortoiseshellbracketrightsmall=65118;a.tortoiseshellbracketrightvertical=65082;a.totaothai=3605;a.tpalatalhook=427;a.tparen=9391;a.trademark=8482;a.trademarksans=63722;a.trademarkserif=63195;a.tretroflexhook=648;a.triagdn=9660;a.triaglf=9668;a.triagrt=9658;a.triagup=9650;a.ts=678;a.tsadi=1510;a.tsadidagesh=64326;\na.tsadidageshhebrew=64326;a.tsadihebrew=1510;a.tsecyrillic=1094;a.tsere=1461;a.tsere12=1461;a.tsere1e=1461;a.tsere2b=1461;a.tserehebrew=1461;a.tserenarrowhebrew=1461;a.tserequarterhebrew=1461;a.tserewidehebrew=1461;a.tshecyrillic=1115;a.tsuperior=63219;a.ttabengali=2463;a.ttadeva=2335;a.ttagujarati=2719;a.ttagurmukhi=2591;a.tteharabic=1657;a.ttehfinalarabic=64359;a.ttehinitialarabic=64360;a.ttehmedialarabic=64361;a.tthabengali=2464;a.tthadeva=2336;a.tthagujarati=2720;a.tthagurmukhi=2592;a.tturned=\n647;a.tuhiragana=12388;a.tukatakana=12484;a.tukatakanahalfwidth=65410;a.tusmallhiragana=12387;a.tusmallkatakana=12483;a.tusmallkatakanahalfwidth=65391;a.twelvecircle=9323;a.twelveparen=9343;a.twelveperiod=9363;a.twelveroman=8571;a.twentycircle=9331;a.twentyhangzhou=21316;a.twentyparen=9351;a.twentyperiod=9371;a.two=50;a.twoarabic=1634;a.twobengali=2536;a.twocircle=9313;a.twocircleinversesansserif=10123;a.twodeva=2408;a.twodotenleader=8229;a.twodotleader=8229;a.twodotleadervertical=65072;a.twogujarati=\n2792;a.twogurmukhi=2664;a.twohackarabic=1634;a.twohangzhou=12322;a.twoideographicparen=12833;a.twoinferior=8322;a.twomonospace=65298;a.twonumeratorbengali=2549;a.twooldstyle=63282;a.twoparen=9333;a.twoperiod=9353;a.twopersian=1778;a.tworoman=8561;a.twostroke=443;a.twosuperior=178;a.twothai=3666;a.twothirds=8532;a.u=117;a.uacute=250;a.ubar=649;a.ubengali=2441;a.ubopomofo=12584;a.ubreve=365;a.ucaron=468;a.ucircle=9444;a.ucircumflex=251;a.ucircumflexbelow=7799;a.ucyrillic=1091;a.udattadeva=2385;a.udblacute=\n369;a.udblgrave=533;a.udeva=2313;a.udieresis=252;a.udieresisacute=472;a.udieresisbelow=7795;a.udieresiscaron=474;a.udieresiscyrillic=1265;a.udieresisgrave=476;a.udieresismacron=470;a.udotbelow=7909;a.ugrave=249;a.ugujarati=2697;a.ugurmukhi=2569;a.uhiragana=12358;a.uhookabove=7911;a.uhorn=432;a.uhornacute=7913;a.uhorndotbelow=7921;a.uhorngrave=7915;a.uhornhookabove=7917;a.uhorntilde=7919;a.uhungarumlaut=369;a.uhungarumlautcyrillic=1267;a.uinvertedbreve=535;a.ukatakana=12454;a.ukatakanahalfwidth=65395;\na.ukcyrillic=1145;a.ukorean=12636;a.umacron=363;a.umacroncyrillic=1263;a.umacrondieresis=7803;a.umatragurmukhi=2625;a.umonospace=65365;a.underscore=95;a.underscoredbl=8215;a.underscoremonospace=65343;a.underscorevertical=65075;a.underscorewavy=65103;a.union=8746;a.universal=8704;a.uogonek=371;a.uparen=9392;a.upblock=9600;a.upperdothebrew=1476;a.upsilon=965;a.upsilondieresis=971;a.upsilondieresistonos=944;a.upsilonlatin=650;a.upsilontonos=973;a.uptackbelowcmb=797;a.uptackmod=724;a.uragurmukhi=2675;\na.uring=367;a.ushortcyrillic=1118;a.usmallhiragana=12357;a.usmallkatakana=12453;a.usmallkatakanahalfwidth=65385;a.ustraightcyrillic=1199;a.ustraightstrokecyrillic=1201;a.utilde=361;a.utildeacute=7801;a.utildebelow=7797;a.uubengali=2442;a.uudeva=2314;a.uugujarati=2698;a.uugurmukhi=2570;a.uumatragurmukhi=2626;a.uuvowelsignbengali=2498;a.uuvowelsigndeva=2370;a.uuvowelsigngujarati=2754;a.uvowelsignbengali=2497;a.uvowelsigndeva=2369;a.uvowelsigngujarati=2753;a.v=118;a.vadeva=2357;a.vagujarati=2741;a.vagurmukhi=\n2613;a.vakatakana=12535;a.vav=1493;a.vavdagesh=64309;a.vavdagesh65=64309;a.vavdageshhebrew=64309;a.vavhebrew=1493;a.vavholam=64331;a.vavholamhebrew=64331;a.vavvavhebrew=1520;a.vavyodhebrew=1521;a.vcircle=9445;a.vdotbelow=7807;a.vecyrillic=1074;a.veharabic=1700;a.vehfinalarabic=64363;a.vehinitialarabic=64364;a.vehmedialarabic=64365;a.vekatakana=12537;a.venus=9792;a.verticalbar=124;a.verticallineabovecmb=781;a.verticallinebelowcmb=809;a.verticallinelowmod=716;a.verticallinemod=712;a.vewarmenian=1406;\na.vhook=651;a.vikatakana=12536;a.viramabengali=2509;a.viramadeva=2381;a.viramagujarati=2765;a.visargabengali=2435;a.visargadeva=2307;a.visargagujarati=2691;a.vmonospace=65366;a.voarmenian=1400;a.voicediterationhiragana=12446;a.voicediterationkatakana=12542;a.voicedmarkkana=12443;a.voicedmarkkanahalfwidth=65438;a.vokatakana=12538;a.vparen=9393;a.vtilde=7805;a.vturned=652;a.vuhiragana=12436;a.vukatakana=12532;a.w=119;a.wacute=7811;a.waekorean=12633;a.wahiragana=12431;a.wakatakana=12527;a.wakatakanahalfwidth=\n65436;a.wakorean=12632;a.wasmallhiragana=12430;a.wasmallkatakana=12526;a.wattosquare=13143;a.wavedash=12316;a.wavyunderscorevertical=65076;a.wawarabic=1608;a.wawfinalarabic=65262;a.wawhamzaabovearabic=1572;a.wawhamzaabovefinalarabic=65158;a.wbsquare=13277;a.wcircle=9446;a.wcircumflex=373;a.wdieresis=7813;a.wdotaccent=7815;a.wdotbelow=7817;a.wehiragana=12433;a.weierstrass=8472;a.wekatakana=12529;a.wekorean=12638;a.weokorean=12637;a.wgrave=7809;a.whitebullet=9702;a.whitecircle=9675;a.whitecircleinverse=\n9689;a.whitecornerbracketleft=12302;a.whitecornerbracketleftvertical=65091;a.whitecornerbracketright=12303;a.whitecornerbracketrightvertical=65092;a.whitediamond=9671;a.whitediamondcontainingblacksmalldiamond=9672;a.whitedownpointingsmalltriangle=9663;a.whitedownpointingtriangle=9661;a.whiteleftpointingsmalltriangle=9667;a.whiteleftpointingtriangle=9665;a.whitelenticularbracketleft=12310;a.whitelenticularbracketright=12311;a.whiterightpointingsmalltriangle=9657;a.whiterightpointingtriangle=9655;a.whitesmallsquare=\n9643;a.whitesmilingface=9786;a.whitesquare=9633;a.whitestar=9734;a.whitetelephone=9743;a.whitetortoiseshellbracketleft=12312;a.whitetortoiseshellbracketright=12313;a.whiteuppointingsmalltriangle=9653;a.whiteuppointingtriangle=9651;a.wihiragana=12432;a.wikatakana=12528;a.wikorean=12639;a.wmonospace=65367;a.wohiragana=12434;a.wokatakana=12530;a.wokatakanahalfwidth=65382;a.won=8361;a.wonmonospace=65510;a.wowaenthai=3623;a.wparen=9394;a.wring=7832;a.wsuperior=695;a.wturned=653;a.wynn=447;a.x=120;a.xabovecmb=\n829;a.xbopomofo=12562;a.xcircle=9447;a.xdieresis=7821;a.xdotaccent=7819;a.xeharmenian=1389;a.xi=958;a.xmonospace=65368;a.xparen=9395;a.xsuperior=739;a.y=121;a.yaadosquare=13134;a.yabengali=2479;a.yacute=253;a.yadeva=2351;a.yaekorean=12626;a.yagujarati=2735;a.yagurmukhi=2607;a.yahiragana=12420;a.yakatakana=12516;a.yakatakanahalfwidth=65428;a.yakorean=12625;a.yamakkanthai=3662;a.yasmallhiragana=12419;a.yasmallkatakana=12515;a.yasmallkatakanahalfwidth=65388;a.yatcyrillic=1123;a.ycircle=9448;a.ycircumflex=\n375;a.ydieresis=255;a.ydotaccent=7823;a.ydotbelow=7925;a.yeharabic=1610;a.yehbarreearabic=1746;a.yehbarreefinalarabic=64431;a.yehfinalarabic=65266;a.yehhamzaabovearabic=1574;a.yehhamzaabovefinalarabic=65162;a.yehhamzaaboveinitialarabic=65163;a.yehhamzaabovemedialarabic=65164;a.yehinitialarabic=65267;a.yehmedialarabic=65268;a.yehmeeminitialarabic=64733;a.yehmeemisolatedarabic=64600;a.yehnoonfinalarabic=64660;a.yehthreedotsbelowarabic=1745;a.yekorean=12630;a.yen=165;a.yenmonospace=65509;a.yeokorean=\n12629;a.yeorinhieuhkorean=12678;a.yerahbenyomohebrew=1450;a.yerahbenyomolefthebrew=1450;a.yericyrillic=1099;a.yerudieresiscyrillic=1273;a.yesieungkorean=12673;a.yesieungpansioskorean=12675;a.yesieungsioskorean=12674;a.yetivhebrew=1434;a.ygrave=7923;a.yhook=436;a.yhookabove=7927;a.yiarmenian=1397;a.yicyrillic=1111;a.yikorean=12642;a.yinyang=9775;a.yiwnarmenian=1410;a.ymonospace=65369;a.yod=1497;a.yoddagesh=64313;a.yoddageshhebrew=64313;a.yodhebrew=1497;a.yodyodhebrew=1522;a.yodyodpatahhebrew=64287;\na.yohiragana=12424;a.yoikorean=12681;a.yokatakana=12520;a.yokatakanahalfwidth=65430;a.yokorean=12635;a.yosmallhiragana=12423;a.yosmallkatakana=12519;a.yosmallkatakanahalfwidth=65390;a.yotgreek=1011;a.yoyaekorean=12680;a.yoyakorean=12679;a.yoyakthai=3618;a.yoyingthai=3597;a.yparen=9396;a.ypogegrammeni=890;a.ypogegrammenigreekcmb=837;a.yr=422;a.yring=7833;a.ysuperior=696;a.ytilde=7929;a.yturned=654;a.yuhiragana=12422;a.yuikorean=12684;a.yukatakana=12518;a.yukatakanahalfwidth=65429;a.yukorean=12640;\na.yusbigcyrillic=1131;a.yusbigiotifiedcyrillic=1133;a.yuslittlecyrillic=1127;a.yuslittleiotifiedcyrillic=1129;a.yusmallhiragana=12421;a.yusmallkatakana=12517;a.yusmallkatakanahalfwidth=65389;a.yuyekorean=12683;a.yuyeokorean=12682;a.yyabengali=2527;a.yyadeva=2399;a.z=122;a.zaarmenian=1382;a.zacute=378;a.zadeva=2395;a.zagurmukhi=2651;a.zaharabic=1592;a.zahfinalarabic=65222;a.zahinitialarabic=65223;a.zahiragana=12374;a.zahmedialarabic=65224;a.zainarabic=1586;a.zainfinalarabic=65200;a.zakatakana=12470;\na.zaqefgadolhebrew=1429;a.zaqefqatanhebrew=1428;a.zarqahebrew=1432;a.zayin=1494;a.zayindagesh=64310;a.zayindageshhebrew=64310;a.zayinhebrew=1494;a.zbopomofo=12567;a.zcaron=382;a.zcircle=9449;a.zcircumflex=7825;a.zcurl=657;a.zdot=380;a.zdotaccent=380;a.zdotbelow=7827;a.zecyrillic=1079;a.zedescendercyrillic=1177;a.zedieresiscyrillic=1247;a.zehiragana=12380;a.zekatakana=12476;a.zero=48;a.zeroarabic=1632;a.zerobengali=2534;a.zerodeva=2406;a.zerogujarati=2790;a.zerogurmukhi=2662;a.zerohackarabic=1632;\na.zeroinferior=8320;a.zeromonospace=65296;a.zerooldstyle=63280;a.zeropersian=1776;a.zerosuperior=8304;a.zerothai=3664;a.zerowidthjoiner=65279;a.zerowidthnonjoiner=8204;a.zerowidthspace=8203;a.zeta=950;a.zhbopomofo=12563;a.zhearmenian=1386;a.zhebrevecyrillic=1218;a.zhecyrillic=1078;a.zhedescendercyrillic=1175;a.zhedieresiscyrillic=1245;a.zihiragana=12376;a.zikatakana=12472;a.zinorhebrew=1454;a.zlinebelow=7829;a.zmonospace=65370;a.zohiragana=12382;a.zokatakana=12478;a.zparen=9397;a.zretroflexhook=656;\na.zstroke=438;a.zuhiragana=12378;a.zukatakana=12474;a[".notdef"]=0;a.angbracketleftbig=9001;a.angbracketleftBig=9001;a.angbracketleftbigg=9001;a.angbracketleftBigg=9001;a.angbracketrightBig=9002;a.angbracketrightbig=9002;a.angbracketrightBigg=9002;a.angbracketrightbigg=9002;a.arrowhookleft=8618;a.arrowhookright=8617;a.arrowlefttophalf=8636;a.arrowleftbothalf=8637;a.arrownortheast=8599;a.arrownorthwest=8598;a.arrowrighttophalf=8640;a.arrowrightbothalf=8641;a.arrowsoutheast=8600;a.arrowsouthwest=8601;\na.backslashbig=8726;a.backslashBig=8726;a.backslashBigg=8726;a.backslashbigg=8726;a.bardbl=8214;a.bracehtipdownleft=65079;a.bracehtipdownright=65079;a.bracehtipupleft=65080;a.bracehtipupright=65080;a.braceleftBig=123;a.braceleftbig=123;a.braceleftbigg=123;a.braceleftBigg=123;a.bracerightBig=125;a.bracerightbig=125;a.bracerightbigg=125;a.bracerightBigg=125;a.bracketleftbig=91;a.bracketleftBig=91;a.bracketleftbigg=91;a.bracketleftBigg=91;a.bracketrightBig=93;a.bracketrightbig=93;a.bracketrightbigg=\n93;a.bracketrightBigg=93;a.ceilingleftbig=8968;a.ceilingleftBig=8968;a.ceilingleftBigg=8968;a.ceilingleftbigg=8968;a.ceilingrightbig=8969;a.ceilingrightBig=8969;a.ceilingrightbigg=8969;a.ceilingrightBigg=8969;a.circledotdisplay=8857;a.circledottext=8857;a.circlemultiplydisplay=8855;a.circlemultiplytext=8855;a.circleplusdisplay=8853;a.circleplustext=8853;a.contintegraldisplay=8750;a.contintegraltext=8750;a.coproductdisplay=8720;a.coproducttext=8720;a.floorleftBig=8970;a.floorleftbig=8970;a.floorleftbigg=\n8970;a.floorleftBigg=8970;a.floorrightbig=8971;a.floorrightBig=8971;a.floorrightBigg=8971;a.floorrightbigg=8971;a.hatwide=770;a.hatwider=770;a.hatwidest=770;a.intercal=7488;a.integraldisplay=8747;a.integraltext=8747;a.intersectiondisplay=8898;a.intersectiontext=8898;a.logicalanddisplay=8743;a.logicalandtext=8743;a.logicalordisplay=8744;a.logicalortext=8744;a.parenleftBig=40;a.parenleftbig=40;a.parenleftBigg=40;a.parenleftbigg=40;a.parenrightBig=41;a.parenrightbig=41;a.parenrightBigg=41;a.parenrightbigg=\n41;a.prime=8242;a.productdisplay=8719;a.producttext=8719;a.radicalbig=8730;a.radicalBig=8730;a.radicalBigg=8730;a.radicalbigg=8730;a.radicalbt=8730;a.radicaltp=8730;a.radicalvertex=8730;a.slashbig=47;a.slashBig=47;a.slashBigg=47;a.slashbigg=47;a.summationdisplay=8721;a.summationtext=8721;a.tildewide=732;a.tildewider=732;a.tildewidest=732;a.uniondisplay=8899;a.unionmultidisplay=8846;a.unionmultitext=8846;a.unionsqdisplay=8852;a.unionsqtext=8852;a.uniontext=8899;a.vextenddouble=8741;a.vextendsingle=\n8739}),$r=xb(function(a){a.space=32;a.a1=9985;a.a2=9986;a.a202=9987;a.a3=9988;a.a4=9742;a.a5=9990;a.a119=9991;a.a118=9992;a.a117=9993;a.a11=9755;a.a12=9758;a.a13=9996;a.a14=9997;a.a15=9998;a.a16=9999;a.a105=1E4;a.a17=10001;a.a18=10002;a.a19=10003;a.a20=10004;a.a21=10005;a.a22=10006;a.a23=10007;a.a24=10008;a.a25=10009;a.a26=10010;a.a27=10011;a.a28=10012;a.a6=10013;a.a7=10014;a.a8=10015;a.a9=10016;a.a10=10017;a.a29=10018;a.a30=10019;a.a31=10020;a.a32=10021;a.a33=10022;a.a34=10023;a.a35=9733;a.a36=10025;\na.a37=10026;a.a38=10027;a.a39=10028;a.a40=10029;a.a41=10030;a.a42=10031;a.a43=10032;a.a44=10033;a.a45=10034;a.a46=10035;a.a47=10036;a.a48=10037;a.a49=10038;a.a50=10039;a.a51=10040;a.a52=10041;a.a53=10042;a.a54=10043;a.a55=10044;a.a56=10045;a.a57=10046;a.a58=10047;a.a59=10048;a.a60=10049;a.a61=10050;a.a62=10051;a.a63=10052;a.a64=10053;a.a65=10054;a.a66=10055;a.a67=10056;a.a68=10057;a.a69=10058;a.a70=10059;a.a71=9679;a.a72=10061;a.a73=9632;a.a74=10063;a.a203=10064;a.a75=10065;a.a204=10066;a.a76=9650;\na.a77=9660;a.a78=9670;a.a79=10070;a.a81=9687;a.a82=10072;a.a83=10073;a.a84=10074;a.a97=10075;a.a98=10076;a.a99=10077;a.a100=10078;a.a101=10081;a.a102=10082;a.a103=10083;a.a104=10084;a.a106=10085;a.a107=10086;a.a108=10087;a.a112=9827;a.a111=9830;a.a110=9829;a.a109=9824;a.a120=9312;a.a121=9313;a.a122=9314;a.a123=9315;a.a124=9316;a.a125=9317;a.a126=9318;a.a127=9319;a.a128=9320;a.a129=9321;a.a130=10102;a.a131=10103;a.a132=10104;a.a133=10105;a.a134=10106;a.a135=10107;a.a136=10108;a.a137=10109;a.a138=10110;\na.a139=10111;a.a140=10112;a.a141=10113;a.a142=10114;a.a143=10115;a.a144=10116;a.a145=10117;a.a146=10118;a.a147=10119;a.a148=10120;a.a149=10121;a.a150=10122;a.a151=10123;a.a152=10124;a.a153=10125;a.a154=10126;a.a155=10127;a.a156=10128;a.a157=10129;a.a158=10130;a.a159=10131;a.a160=10132;a.a161=8594;a.a163=8596;a.a164=8597;a.a196=10136;a.a165=10137;a.a192=10138;a.a166=10139;a.a167=10140;a.a168=10141;a.a169=10142;a.a170=10143;a.a171=10144;a.a172=10145;a.a173=10146;a.a162=10147;a.a174=10148;a.a175=10149;\na.a176=10150;a.a177=10151;a.a178=10152;a.a179=10153;a.a193=10154;a.a180=10155;a.a199=10156;a.a181=10157;a.a200=10158;a.a182=10159;a.a201=10161;a.a183=10162;a.a184=10163;a.a197=10164;a.a185=10165;a.a194=10166;a.a198=10167;a.a186=10168;a.a195=10169;a.a187=10170;a.a188=10171;a.a189=10172;a.a190=10173;a.a191=10174;a.a89=10088;a.a90=10089;a.a93=10090;a.a94=10091;a.a91=10092;a.a92=10093;a.a205=10094;a.a85=10095;a.a206=10096;a.a86=10097;a.a87=10098;a.a88=10099;a.a95=10100;a.a96=10101;a[".notdef"]=0}),as=\nxb(function(a){a[63721]=169;a[63193]=169;a[63720]=174;a[63194]=174;a[63722]=8482;a[63195]=8482;a[63729]=9127;a[63730]=9128;a[63731]=9129;a[63740]=9131;a[63741]=9132;a[63742]=9133;a[63726]=9121;a[63727]=9122;a[63728]=9123;a[63737]=9124;a[63738]=9125;a[63739]=9126;a[63723]=9115;a[63724]=9116;a[63725]=9117;a[63734]=9118;a[63735]=9119;a[63736]=9120}),ai=[[0,127],[128,255],[256,383],[384,591],[592,687,7424,7551,7552,7615],[688,767,42752,42783],[768,879,7616,7679],[880,1023],[11392,11519],[1024,1279,1280,\n1327,11744,11775,42560,42655],[1328,1423],[1424,1535],[42240,42559],[1536,1791,1872,1919],[1984,2047],[2304,2431],[2432,2559],[2560,2687],[2688,2815],[2816,2943],[2944,3071],[3072,3199],[3200,3327],[3328,3455],[3584,3711],[3712,3839],[4256,4351,11520,11567],[6912,7039],[4352,4607],[7680,7935,11360,11391,42784,43007],[7936,8191],[8192,8303,11776,11903],[8304,8351],[8352,8399],[8400,8447],[8448,8527],[8528,8591],[8592,8703,10224,10239,10496,10623,11008,11263],[8704,8959,10752,11007,10176,10223,10624,\n10751],[8960,9215],[9216,9279],[9280,9311],[9312,9471],[9472,9599],[9600,9631],[9632,9727],[9728,9983],[9984,10175],[12288,12351],[12352,12447],[12448,12543,12784,12799],[12544,12591,12704,12735],[12592,12687],[43072,43135],[12800,13055],[13056,13311],[44032,55215],[55296,57343],[67840,67871],[19968,40959,11904,12031,12032,12255,12272,12287,13312,19903,131072,173791,12688,12703],[57344,63743],[12736,12783,63744,64255,194560,195103],[64256,64335],[64336,65023],[65056,65071],[65040,65055],[65104,65135],\n[65136,65279],[65280,65519],[65520,65535],[3840,4095],[1792,1871],[1920,1983],[3456,3583],[4096,4255],[4608,4991,4992,5023,11648,11743],[5024,5119],[5120,5759],[5760,5791],[5792,5887],[6016,6143],[6144,6319],[10240,10495],[40960,42127],[5888,5919,5920,5951,5952,5983,5984,6015],[66304,66351],[66352,66383],[66560,66639],[118784,119039,119040,119295,119296,119375],[119808,120831],[1044480,1048573],[65024,65039,917760,917999],[917504,917631],[6400,6479],[6480,6527],[6528,6623],[6656,6687],[11264,11359],\n[11568,11647],[19904,19967],[43008,43055],[65536,65663,65664,65791,65792,65855],[65856,65935],[66432,66463],[66464,66527],[66640,66687],[66688,66735],[67584,67647],[68096,68191],[119552,119647],[73728,74751,74752,74879],[119648,119679],[7040,7103],[7168,7247],[7248,7295],[43136,43231],[43264,43311],[43312,43359],[43520,43615],[65936,65999],[66E3,66047],[66208,66271,66176,66207,67872,67903],[127024,127135,126976,127023]],bs=RegExp("^(\\\\s)|(\\\\p{Mn})|(\\\\p{Cf})$","u"),ri=new Map,Zc={FixedPitch:1,Serif:2,\nSymbolic:4,Script:8,Nonsymbolic:32,Italic:64,AllCap:65536,SmallCap:131072,ForceBold:262144},On=".notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat".split(" "),\ncs=xb(function(a){a[8211]=65074;a[8212]=65073;a[8229]=65072;a[8230]=65049;a[12289]=65041;a[12290]=65042;a[12296]=65087;a[12297]=65088;a[12298]=65085;a[12299]=65086;a[12300]=65089;a[12301]=65090;a[12302]=65091;a[12303]=65092;a[12304]=65083;a[12305]=65084;a[12308]=65081;a[12309]=65082;a[12310]=65047;a[12311]=65048;a[65103]=65076;a[65281]=65045;a[65288]=65077;a[65289]=65078;a[65292]=65040;a[65306]=65043;a[65307]=65044;a[65311]=65046;a[65339]=65095;a[65341]=65096;a[65343]=65075;a[65371]=65079;a[65373]=\n65080}),jg=xb(function(a){a["Times-Roman"]="Times-Roman";a.Helvetica="Helvetica";a.Courier="Courier";a.Symbol="Symbol";a["Times-Bold"]="Times-Bold";a["Helvetica-Bold"]="Helvetica-Bold";a["Courier-Bold"]="Courier-Bold";a.ZapfDingbats="ZapfDingbats";a["Times-Italic"]="Times-Italic";a["Helvetica-Oblique"]="Helvetica-Oblique";a["Courier-Oblique"]="Courier-Oblique";a["Times-BoldItalic"]="Times-BoldItalic";a["Helvetica-BoldOblique"]="Helvetica-BoldOblique";a["Courier-BoldOblique"]="Courier-BoldOblique";\na.ArialNarrow="Helvetica";a["ArialNarrow-Bold"]="Helvetica-Bold";a["ArialNarrow-BoldItalic"]="Helvetica-BoldOblique";a["ArialNarrow-Italic"]="Helvetica-Oblique";a.ArialBlack="Helvetica";a["ArialBlack-Bold"]="Helvetica-Bold";a["ArialBlack-BoldItalic"]="Helvetica-BoldOblique";a["ArialBlack-Italic"]="Helvetica-Oblique";a["Arial-Black"]="Helvetica";a["Arial-Black-Bold"]="Helvetica-Bold";a["Arial-Black-BoldItalic"]="Helvetica-BoldOblique";a["Arial-Black-Italic"]="Helvetica-Oblique";a.Arial="Helvetica";\na["Arial-Bold"]="Helvetica-Bold";a["Arial-BoldItalic"]="Helvetica-BoldOblique";a["Arial-Italic"]="Helvetica-Oblique";a.ArialMT="Helvetica";a["Arial-BoldItalicMT"]="Helvetica-BoldOblique";a["Arial-BoldMT"]="Helvetica-Bold";a["Arial-ItalicMT"]="Helvetica-Oblique";a["Arial-BoldItalicMT-BoldItalic"]="Helvetica-BoldOblique";a["Arial-BoldMT-Bold"]="Helvetica-Bold";a["Arial-ItalicMT-Italic"]="Helvetica-Oblique";a.ArialUnicodeMS="Helvetica";a["ArialUnicodeMS-Bold"]="Helvetica-Bold";a["ArialUnicodeMS-BoldItalic"]=\n"Helvetica-BoldOblique";a["ArialUnicodeMS-Italic"]="Helvetica-Oblique";a["Courier-BoldItalic"]="Courier-BoldOblique";a["Courier-Italic"]="Courier-Oblique";a.CourierNew="Courier";a["CourierNew-Bold"]="Courier-Bold";a["CourierNew-BoldItalic"]="Courier-BoldOblique";a["CourierNew-Italic"]="Courier-Oblique";a["CourierNewPS-BoldItalicMT"]="Courier-BoldOblique";a["CourierNewPS-BoldMT"]="Courier-Bold";a["CourierNewPS-ItalicMT"]="Courier-Oblique";a.CourierNewPSMT="Courier";a["Helvetica-BoldItalic"]="Helvetica-BoldOblique";\na["Helvetica-Italic"]="Helvetica-Oblique";a["Symbol-Bold"]="Symbol";a["Symbol-BoldItalic"]="Symbol";a["Symbol-Italic"]="Symbol";a.TimesNewRoman="Times-Roman";a["TimesNewRoman-Bold"]="Times-Bold";a["TimesNewRoman-BoldItalic"]="Times-BoldItalic";a["TimesNewRoman-Italic"]="Times-Italic";a.TimesNewRomanPS="Times-Roman";a["TimesNewRomanPS-Bold"]="Times-Bold";a["TimesNewRomanPS-BoldItalic"]="Times-BoldItalic";a["TimesNewRomanPS-BoldItalicMT"]="Times-BoldItalic";a["TimesNewRomanPS-BoldMT"]="Times-Bold";\na["TimesNewRomanPS-Italic"]="Times-Italic";a["TimesNewRomanPS-ItalicMT"]="Times-Italic";a.TimesNewRomanPSMT="Times-Roman";a["TimesNewRomanPSMT-Bold"]="Times-Bold";a["TimesNewRomanPSMT-BoldItalic"]="Times-BoldItalic";a["TimesNewRomanPSMT-Italic"]="Times-Italic"}),ds=xb(function(a){a.Courier="FoxitFixed.pfb";a["Courier-Bold"]="FoxitFixedBold.pfb";a["Courier-BoldOblique"]="FoxitFixedBoldItalic.pfb";a["Courier-Oblique"]="FoxitFixedItalic.pfb";a.Helvetica="LiberationSans-Regular.ttf";a["Helvetica-Bold"]=\n"LiberationSans-Bold.ttf";a["Helvetica-BoldOblique"]="LiberationSans-BoldItalic.ttf";a["Helvetica-Oblique"]="LiberationSans-Italic.ttf";a["Times-Roman"]="FoxitSerif.pfb";a["Times-Bold"]="FoxitSerifBold.pfb";a["Times-BoldItalic"]="FoxitSerifBoldItalic.pfb";a["Times-Italic"]="FoxitSerifItalic.pfb";a.Symbol="FoxitSymbol.pfb";a.ZapfDingbats="FoxitDingbats.pfb";a["LiberationSans-Regular"]="LiberationSans-Regular.ttf";a["LiberationSans-Bold"]="LiberationSans-Bold.ttf";a["LiberationSans-Italic"]="LiberationSans-Italic.ttf";\na["LiberationSans-BoldItalic"]="LiberationSans-BoldItalic.ttf"}),bl=xb(function(a){a.Calibri="Helvetica";a["Calibri-Bold"]="Helvetica-Bold";a["Calibri-BoldItalic"]="Helvetica-BoldOblique";a["Calibri-Italic"]="Helvetica-Oblique";a.CenturyGothic="Helvetica";a["CenturyGothic-Bold"]="Helvetica-Bold";a["CenturyGothic-BoldItalic"]="Helvetica-BoldOblique";a["CenturyGothic-Italic"]="Helvetica-Oblique";a.ComicSansMS="Comic Sans MS";a["ComicSansMS-Bold"]="Comic Sans MS-Bold";a["ComicSansMS-BoldItalic"]="Comic Sans MS-BoldItalic";\na["ComicSansMS-Italic"]="Comic Sans MS-Italic";a.GillSansMT="Helvetica";a["GillSansMT-Bold"]="Helvetica-Bold";a["GillSansMT-BoldItalic"]="Helvetica-BoldOblique";a["GillSansMT-Italic"]="Helvetica-Oblique";a.Impact="Helvetica";a["ItcSymbol-Bold"]="Helvetica-Bold";a["ItcSymbol-BoldItalic"]="Helvetica-BoldOblique";a["ItcSymbol-Book"]="Helvetica";a["ItcSymbol-BookItalic"]="Helvetica-Oblique";a["ItcSymbol-Medium"]="Helvetica";a["ItcSymbol-MediumItalic"]="Helvetica-Oblique";a.LucidaConsole="Courier";a["LucidaConsole-Bold"]=\n"Courier-Bold";a["LucidaConsole-BoldItalic"]="Courier-BoldOblique";a["LucidaConsole-Italic"]="Courier-Oblique";a["LucidaSans-Demi"]="Helvetica-Bold";a["MS-Gothic"]="MS Gothic";a["MS-Gothic-Bold"]="MS Gothic-Bold";a["MS-Gothic-BoldItalic"]="MS Gothic-BoldItalic";a["MS-Gothic-Italic"]="MS Gothic-Italic";a["MS-Mincho"]="MS Mincho";a["MS-Mincho-Bold"]="MS Mincho-Bold";a["MS-Mincho-BoldItalic"]="MS Mincho-BoldItalic";a["MS-Mincho-Italic"]="MS Mincho-Italic";a["MS-PGothic"]="MS PGothic";a["MS-PGothic-Bold"]=\n"MS PGothic-Bold";a["MS-PGothic-BoldItalic"]="MS PGothic-BoldItalic";a["MS-PGothic-Italic"]="MS PGothic-Italic";a["MS-PMincho"]="MS PMincho";a["MS-PMincho-Bold"]="MS PMincho-Bold";a["MS-PMincho-BoldItalic"]="MS PMincho-BoldItalic";a["MS-PMincho-Italic"]="MS PMincho-Italic";a.NuptialScript="Times-Italic";a.SegoeUISymbol="Helvetica"}),Rh=xb(function(a){a["Adobe Jenson"]=!0;a["Adobe Text"]=!0;a.Albertus=!0;a.Aldus=!0;a.Alexandria=!0;a.Algerian=!0;a["American Typewriter"]=!0;a.Antiqua=!0;a.Apex=!0;a.Arno=\n!0;a.Aster=!0;a.Aurora=!0;a.Baskerville=!0;a.Bell=!0;a.Bembo=!0;a["Bembo Schoolbook"]=!0;a.Benguiat=!0;a["Berkeley Old Style"]=!0;a["Bernhard Modern"]=!0;a["Berthold City"]=!0;a.Bodoni=!0;a["Bauer Bodoni"]=!0;a["Book Antiqua"]=!0;a.Bookman=!0;a["Bordeaux Roman"]=!0;a["Californian FB"]=!0;a.Calisto=!0;a.Calvert=!0;a.Capitals=!0;a.Cambria=!0;a.Cartier=!0;a.Caslon=!0;a.Catull=!0;a.Centaur=!0;a["Century Old Style"]=!0;a["Century Schoolbook"]=!0;a.Chaparral=!0;a["Charis SIL"]=!0;a.Cheltenham=!0;a["Cholla Slab"]=\n!0;a.Clarendon=!0;a.Clearface=!0;a.Cochin=!0;a.Colonna=!0;a["Computer Modern"]=!0;a["Concrete Roman"]=!0;a.Constantia=!0;a["Cooper Black"]=!0;a.Corona=!0;a.Ecotype=!0;a.Egyptienne=!0;a.Elephant=!0;a.Excelsior=!0;a.Fairfield=!0;a["FF Scala"]=!0;a.Folkard=!0;a.Footlight=!0;a.FreeSerif=!0;a["Friz Quadrata"]=!0;a.Garamond=!0;a.Gentium=!0;a.Georgia=!0;a.Gloucester=!0;a["Goudy Old Style"]=!0;a["Goudy Schoolbook"]=!0;a["Goudy Pro Font"]=!0;a.Granjon=!0;a["Guardian Egyptian"]=!0;a.Heather=!0;a.Hercules=!0;\na["High Tower Text"]=!0;a.Hiroshige=!0;a["Hoefler Text"]=!0;a["Humana Serif"]=!0;a.Imprint=!0;a["Ionic No. 5"]=!0;a.Janson=!0;a.Joanna=!0;a.Korinna=!0;a.Lexicon=!0;a.LiberationSerif=!0;a["Liberation Serif"]=!0;a["Linux Libertine"]=!0;a.Literaturnaya=!0;a.Lucida=!0;a["Lucida Bright"]=!0;a.Melior=!0;a.Memphis=!0;a.Miller=!0;a.Minion=!0;a.Modern=!0;a["Mona Lisa"]=!0;a["Mrs Eaves"]=!0;a["MS Serif"]=!0;a["Museo Slab"]=!0;a["New York"]=!0;a["Nimbus Roman"]=!0;a["NPS Rawlinson Roadway"]=!0;a.NuptialScript=\n!0;a.Palatino=!0;a.Perpetua=!0;a.Plantin=!0;a["Plantin Schoolbook"]=!0;a.Playbill=!0;a["Poor Richard"]=!0;a["Rawlinson Roadway"]=!0;a.Renault=!0;a.Requiem=!0;a.Rockwell=!0;a.Roman=!0;a["Rotis Serif"]=!0;a.Sabon=!0;a.Scala=!0;a.Seagull=!0;a.Sistina=!0;a.Souvenir=!0;a.STIX=!0;a["Stone Informal"]=!0;a["Stone Serif"]=!0;a.Sylfaen=!0;a.Times=!0;a.Trajan=!0;a["Trinit\\u00e9"]=!0;a["Trump Mediaeval"]=!0;a.Utopia=!0;a["Vale Type"]=!0;a["Bitstream Vera"]=!0;a["Vera Serif"]=!0;a.Versailles=!0;a.Wanted=!0;a.Weiss=\n!0;a["Wide Latin"]=!0;a.Windsor=!0;a.XITS=!0}),Sh=xb(function(a){a.Dingbats=!0;a.Symbol=!0;a.ZapfDingbats=!0;a.Wingdings=!0;a["Wingdings-Bold"]=!0;a["Wingdings-Regular"]=!0}),Pn=xb(function(a){a[2]=10;a[3]=32;a[4]=33;a[5]=34;a[6]=35;a[7]=36;a[8]=37;a[9]=38;a[10]=39;a[11]=40;a[12]=41;a[13]=42;a[14]=43;a[15]=44;a[16]=45;a[17]=46;a[18]=47;a[19]=48;a[20]=49;a[21]=50;a[22]=51;a[23]=52;a[24]=53;a[25]=54;a[26]=55;a[27]=56;a[28]=57;a[29]=58;a[30]=894;a[31]=60;a[32]=61;a[33]=62;a[34]=63;a[35]=64;a[36]=65;\na[37]=66;a[38]=67;a[39]=68;a[40]=69;a[41]=70;a[42]=71;a[43]=72;a[44]=73;a[45]=74;a[46]=75;a[47]=76;a[48]=77;a[49]=78;a[50]=79;a[51]=80;a[52]=81;a[53]=82;a[54]=83;a[55]=84;a[56]=85;a[57]=86;a[58]=87;a[59]=88;a[60]=89;a[61]=90;a[62]=91;a[63]=92;a[64]=93;a[65]=94;a[66]=95;a[67]=96;a[68]=97;a[69]=98;a[70]=99;a[71]=100;a[72]=101;a[73]=102;a[74]=103;a[75]=104;a[76]=105;a[77]=106;a[78]=107;a[79]=108;a[80]=109;a[81]=110;a[82]=111;a[83]=112;a[84]=113;a[85]=114;a[86]=115;a[87]=116;a[88]=117;a[89]=118;a[90]=\n119;a[91]=120;a[92]=121;a[93]=122;a[94]=123;a[95]=124;a[96]=125;a[97]=126;a[98]=196;a[99]=197;a[100]=199;a[101]=201;a[102]=209;a[103]=214;a[104]=220;a[105]=225;a[106]=224;a[107]=226;a[108]=228;a[109]=227;a[110]=229;a[111]=231;a[112]=233;a[113]=232;a[114]=234;a[115]=235;a[116]=237;a[117]=236;a[118]=238;a[119]=239;a[120]=241;a[121]=243;a[122]=242;a[123]=244;a[124]=246;a[125]=245;a[126]=250;a[127]=249;a[128]=251;a[129]=252;a[130]=8224;a[131]=176;a[132]=162;a[133]=163;a[134]=167;a[135]=8226;a[136]=182;\na[137]=223;a[138]=174;a[139]=169;a[140]=8482;a[141]=180;a[142]=168;a[143]=8800;a[144]=198;a[145]=216;a[146]=8734;a[147]=177;a[148]=8804;a[149]=8805;a[150]=165;a[151]=181;a[152]=8706;a[153]=8721;a[154]=8719;a[156]=8747;a[157]=170;a[158]=186;a[159]=8486;a[160]=230;a[161]=248;a[162]=191;a[163]=161;a[164]=172;a[165]=8730;a[166]=402;a[167]=8776;a[168]=8710;a[169]=171;a[170]=187;a[171]=8230;a[179]=8220;a[180]=8221;a[181]=8216;a[182]=8217;a[200]=193;a[203]=205;a[207]=211;a[210]=218;a[223]=711;a[224]=321;\na[225]=322;a[226]=352;a[227]=353;a[228]=381;a[229]=382;a[233]=221;a[234]=253;a[252]=263;a[253]=268;a[254]=269;a[258]=258;a[260]=260;a[261]=261;a[265]=280;a[266]=281;a[267]=282;a[268]=283;a[269]=313;a[275]=323;a[276]=324;a[278]=328;a[283]=344;a[284]=345;a[285]=346;a[286]=347;a[292]=367;a[295]=377;a[296]=378;a[298]=380;a[305]=963;a[306]=964;a[307]=966;a[308]=8215;a[309]=8252;a[310]=8319;a[311]=8359;a[312]=8592;a[313]=8593;a[337]=9552;a[493]=1039;a[494]=1040;a[672]=1488;a[673]=1489;a[674]=1490;a[675]=\n1491;a[676]=1492;a[677]=1493;a[678]=1494;a[679]=1495;a[680]=1496;a[681]=1497;a[682]=1498;a[683]=1499;a[684]=1500;a[685]=1501;a[686]=1502;a[687]=1503;a[688]=1504;a[689]=1505;a[690]=1506;a[691]=1507;a[692]=1508;a[693]=1509;a[694]=1510;a[695]=1511;a[696]=1512;a[697]=1513;a[698]=1514;a[705]=1524;a[706]=8362;a[710]=64288;a[711]=64298;a[759]=1617;a[761]=1776;a[763]=1778;a[775]=1652;a[777]=1764;a[778]=1780;a[779]=1781;a[780]=1782;a[782]=771;a[783]=64726;a[786]=8363;a[788]=8532;a[790]=768;a[791]=769;a[792]=\n768;a[795]=803;a[797]=64336;a[798]=64337;a[799]=64342;a[800]=64343;a[801]=64344;a[802]=64345;a[803]=64362;a[804]=64363;a[805]=64364;a[2424]=7821;a[2425]=7822;a[2426]=7823;a[2427]=7824;a[2428]=7825;a[2429]=7826;a[2430]=7827;a[2433]=7682;a[2678]=8045;a[2679]=8046;a[2830]=1552;a[2838]=686;a[2840]=751;a[2842]=753;a[2843]=754;a[2844]=755;a[2846]=757;a[2856]=767;a[2857]=848;a[2858]=849;a[2862]=853;a[2863]=854;a[2864]=855;a[2865]=861;a[2866]=862;a[2906]=7460;a[2908]=7462;a[2909]=7463;a[2910]=7464;a[2912]=\n7466;a[2913]=7467;a[2914]=7468;a[2916]=7470;a[2917]=7471;a[2918]=7472;a[2920]=7474;a[2921]=7475;a[2922]=7476;a[2924]=7478;a[2925]=7479;a[2926]=7480;a[2928]=7482;a[2929]=7483;a[2930]=7484;a[2932]=7486;a[2933]=7487;a[2934]=7488;a[2936]=7490;a[2937]=7491;a[2938]=7492;a[2940]=7494;a[2941]=7495;a[2942]=7496;a[2944]=7498;a[2946]=7500;a[2948]=7502;a[2950]=7504;a[2951]=7505;a[2952]=7506;a[2954]=7508;a[2955]=7509;a[2956]=7510;a[2958]=7512;a[2959]=7513;a[2960]=7514;a[2962]=7516;a[2963]=7517;a[2964]=7518;a[2966]=\n7520;a[2967]=7521;a[2968]=7522;a[2970]=7524;a[2971]=7525;a[2972]=7526;a[2974]=7528;a[2975]=7529;a[2976]=7530;a[2978]=1537;a[2979]=1538;a[2980]=1539;a[2982]=1549;a[2983]=1551;a[2984]=1552;a[2986]=1554;a[2987]=1555;a[2988]=1556;a[2990]=1623;a[2991]=1624;a[2995]=1775;a[2999]=1791;a[3002]=64290;a[3003]=64291;a[3004]=64292;a[3006]=64294;a[3007]=64295;a[3008]=64296;a[3011]=1900;a[3014]=8223;a[3015]=8244;a[3017]=7532;a[3018]=7533;a[3019]=7534;a[3075]=7590;a[3076]=7591;a[3079]=7594;a[3080]=7595;a[3083]=7598;\na[3084]=7599;a[3087]=7602;a[3088]=7603;a[3091]=7606;a[3092]=7607;a[3095]=7610;a[3096]=7611;a[3099]=7614;a[3100]=7615;a[3103]=7618;a[3104]=7619;a[3107]=8337;a[3108]=8338;a[3116]=1884;a[3119]=1885;a[3120]=1885;a[3123]=1886;a[3124]=1886;a[3127]=1887;a[3128]=1887;a[3131]=1888;a[3132]=1888;a[3135]=1889;a[3136]=1889;a[3139]=1890;a[3140]=1890;a[3143]=1891;a[3144]=1891;a[3147]=1892;a[3148]=1892;a[3153]=580;a[3154]=581;a[3157]=584;a[3158]=585;a[3161]=588;a[3162]=589;a[3165]=891;a[3166]=892;a[3169]=1274;a[3170]=\n1275;a[3173]=1278;a[3174]=1279;a[3181]=7622;a[3182]=7623;a[3282]=11799;a[3316]=578;a[3379]=42785;a[3393]=1159;a[3416]=8377}),es=xb(function(a){a[227]=322;a[264]=261;a[291]=346}),fs=xb(function(a){a[1]=32;a[4]=65;a[5]=192;a[6]=193;a[9]=196;a[17]=66;a[18]=67;a[21]=268;a[24]=68;a[28]=69;a[29]=200;a[30]=201;a[32]=282;a[38]=70;a[39]=71;a[44]=72;a[47]=73;a[48]=204;a[49]=205;a[58]=74;a[60]=75;a[62]=76;a[68]=77;a[69]=78;a[75]=79;a[76]=210;a[80]=214;a[87]=80;a[89]=81;a[90]=82;a[92]=344;a[94]=83;a[97]=352;\na[100]=84;a[104]=85;a[109]=220;a[115]=86;a[116]=87;a[121]=88;a[122]=89;a[124]=221;a[127]=90;a[129]=381;a[258]=97;a[259]=224;a[260]=225;a[263]=228;a[268]=261;a[271]=98;a[272]=99;a[273]=263;a[275]=269;a[282]=100;a[286]=101;a[287]=232;a[288]=233;a[290]=283;a[295]=281;a[296]=102;a[336]=103;a[346]=104;a[349]=105;a[350]=236;a[351]=237;a[361]=106;a[364]=107;a[367]=108;a[371]=322;a[373]=109;a[374]=110;a[381]=111;a[382]=242;a[383]=243;a[386]=246;a[393]=112;a[395]=113;a[396]=114;a[398]=345;a[400]=115;a[401]=\n347;a[403]=353;a[410]=116;a[437]=117;a[442]=252;a[448]=118;a[449]=119;a[454]=120;a[455]=121;a[457]=253;a[460]=122;a[462]=382;a[463]=380;a[853]=44;a[855]=58;a[856]=46;a[876]=47;a[878]=45;a[882]=45;a[894]=40;a[895]=41;a[896]=91;a[897]=93;a[923]=64;a[1004]=48;a[1005]=49;a[1006]=50;a[1007]=51;a[1008]=52;a[1009]=53;a[1010]=54;a[1011]=55;a[1012]=56;a[1013]=57;a[1081]=37;a[1085]=43;a[1086]=45}),xf=function(){function a(b){void 0===b&&(b=[]);this._map=b}var c=a.prototype;c.forEach=function(b){for(var d in this._map)b(d,\nthis._map[d].charCodeAt(0))};c.has=function(b){return void 0!==this._map[b]};c.get=function(b){return this._map[b]};c.charCodeOf=function(b){var d=this._map;if(65536>=d.length)return d.indexOf(b);for(var e in d)if(d[e]===b)return e|0;return-1};c.amend=function(b){for(var d in b)this._map[d]=b[d]};return dl(a,[{key:"length",get:function(){return this._map.length}}])}(),ad=function(){function a(b,d){this.firstChar=b;this.lastChar=d}var c=a.prototype;c.forEach=function(b){for(var d=this.firstChar,e=\nthis.lastChar;d<=e;d++)b(d,d)};c.has=function(b){return this.firstChar<=b&&b<=this.lastChar};c.get=function(b){if(this.firstChar<=b&&b<=this.lastChar)return String.fromCharCode(b)};c.charCodeOf=function(b){return Number.isInteger(b)&&b>=this.firstChar&&b<=this.lastChar?b:-1};c.amend=function(){db("Should not call amend()")};return dl(a,[{key:"length",get:function(){return this.lastChar+1-this.firstChar}}])}(),uj=function(){function a(b,d){this.properties=d;this.cff=(new sj(b,d,!0)).parse();this.cff.duplicateFirstGlyph();\nvar e=new tj(this.cff);this.seacs=this.cff.seacs;try{this.data=e.compile()}catch(g){T("Failed to compile font "+d.loadedName),this.data=b}this._createBuiltInEncoding()}var c=a.prototype;c.getCharset=function(){return this.cff.charset.charset};c.getGlyphMapping=function(){var b=this.cff,d=this.properties,e=d.cidToGidMap,g=d.cMap,f=b.charset.charset;if(d.composite){if(0<(null==e?void 0:e.length)){var h=Object.create(null);d=0;for(var k=e.length;d<k;d++){var l=e[d];void 0!==l&&(h[l]=d)}}e=Object.create(null);\nif(b.isCIDFont)for(d=0;d<f.length;d++){var m;k=g.charCodeOf(f[d]);void 0!==(null==(m=h)?void 0:m[k])&&(k=h[k]);e[k]=d}else for(d=0;d<b.charStrings.count;d++)k=g.charCodeOf(d),e[k]=d;return e}b=b.encoding?b.encoding.encoding:null;d.isInternalFont&&(b=d.defaultEncoding);return e=Zk(d,b,f)};c.hasGlyphId=function(b){return this.cff.hasGlyphId(b)};c._createBuiltInEncoding=function(){var b=this.cff,d=b.charset;b=b.encoding;if(d&&b){d=d.charset;b=b.encoding;var e=[],g;for(g in b){var f=b[g];0<=f&&(f=d[f])&&\n(e[g]=f)}0<e.length&&(this.properties.builtInEncoding=e)}};return Zp(a,[{key:"numGlyphs",get:function(){return this.cff.charStrings.count}}])}(),Qn=[],gs=function(){function a(){this.cmds=[]}a.prototype.add=function(c,b){b?yc(b,null)?this.cmds.push.apply(this.cmds,[c].concat(u.arrayFromIterable(b))):(T(\'Commands.add - "\'+c+\'" has at least one non-number arg: "\'+b+\'".\'),b=b.map(function(d){return"number"===typeof d?d:0}),this.cmds.push.apply(this.cmds,[c].concat(u.arrayFromIterable(b)))):this.cmds.push(c)};\nreturn a}(),Rn=function(){function a(b){this.fontMatrix=b;this.compiledGlyphs=Object.create(null);this.compiledCharCodeToGlyphId=Object.create(null)}var c=a.prototype;c.getPathJs=function(b){var d,e,g=kg(this.cmap,b);b=g.charCode;g=g.glyphId;var f=this.compiledGlyphs[g];if(!f){try{f=this.compileGlyph(this.glyphs[g],g)}catch(k){f=Qn;var h=k}this.compiledGlyphs[g]=f}null!=(e=(d=this.compiledCharCodeToGlyphId)[b])?e:d[b]=g;if(h)throw h;return f};c.compileGlyph=function(b,d){if(!b||0===b.length||14===\nb[0])return Qn;var e=this.fontMatrix;if(this.isCFFCIDFont){var g=this.fdSelect.getFDIndex(d);0<=g&&g<this.fdArray.length?e=this.fdArray[g].getByName("FontMatrix")||ie:T("Invalid fd index for glyph index.")}g=new gs;g.add(Xb.SAVE);g.add(Xb.TRANSFORM,e.slice());g.add(Xb.SCALE);this.compileGlyphImpl(b,g,d);g.add(Xb.RESTORE);return g.cmds};c.compileGlyphImpl=function(){db("Children classes should implement this.")};c.hasBuiltPath=function(b){b=kg(this.cmap,b);var d=b.charCode;return void 0!==this.compiledGlyphs[b.glyphId]&&\nvoid 0!==this.compiledCharCodeToGlyphId[d]};return a}(),hs=function(a){function c(b,d,e){e=a.call(this,e||[4.88E-4,0,0,4.88E-4,0,0])||this;e.glyphs=b;e.cmap=d;return e}fl(c,a);c.prototype.compileGlyphImpl=function(b,d){gl(b,d,this)};return c}(Rn),is=function(a){function c(b,d,e,g){e=a.call(this,e||[.001,0,0,.001,0,0])||this;e.glyphs=b.glyphs;e.gsubrs=b.gsubrs||[];e.subrs=b.subrs||[];e.cmap=d;e.glyphNameMap=g||ud();e.gsubrsBias=Uh(e.gsubrs);e.subrsBias=Uh(e.subrs);e.isCFFCIDFont=b.isCFFCIDFont;e.fdSelect=\nb.fdSelect;e.fdArray=b.fdArray;return e}fl(c,a);c.prototype.compileGlyphImpl=function(b,d,e){Vh(b,d,this,e)};return c}(Rn),js=function(){function a(){}a.create=function(c,b){for(var d=new Uint8Array(c.data),e,g,f,h,k,l,m=Wb(d,4),n=0,p=12;n<m;n++,p+=16){var q=Ec(d.subarray(p,p+4)),r=Cd(d,p+8),t=Cd(d,p+12);switch(q){case "cmap":e=d;var v=r;r=1===Wb(e,v+2)?Cd(e,v+8):Cd(e,v+16);t=Wb(e,v+r);if(4===t){Wb(e,v+r+2);var w=Wb(e,v+r+6)>>1;t=v+r+14;q=[];for(r=0;r<w;r++,t+=2)q[r]={end:Wb(e,t)};t+=2;for(r=0;r<\nw;r++,t+=2)q[r].start=Wb(e,t);for(r=0;r<w;r++,t+=2)q[r].idDelta=Wb(e,t);for(r=0;r<w;r++,t+=2)if(v=Wb(e,t),0!==v){q[r].ids=[];for(var y=0,x=q[r].end-q[r].start+1;y<x;y++)q[r].ids[y]=Wb(e,t+v),v+=2}e=q}else if(12===t){w=Cd(e,v+r+12);t=v+r+16;q=[];for(r=0;r<w;r++)v=Cd(e,t),q.push({start:v,end:Cd(e,t+4),idDelta:Cd(e,t+8)-v}),t+=12;e=q}else throw new oa("unsupported cmap: "+t);break;case "glyf":g=d.subarray(r,r+t);break;case "loca":f=d.subarray(r,r+t);break;case "head":l=Wb(d,r+18);k=Wb(d,r+50);break;\ncase "CFF ":w=q=void 0,h=r,v=b,r=(new sj(new Mb(d,h,r+t-h),{},v)).parse(),h={glyphs:r.charStrings.objects,subrs:null==(w=r.topDict.privateDict)||null==(w=w.subrsIndex)?void 0:w.objects,gsubrs:null==(q=r.globalSubrIndex)?void 0:q.objects,isCFFCIDFont:r.isCIDFont,fdSelect:r.fdSelect,fdArray:r.fdArray}}}return g?(c=l?[1/l,0,0,1/l,0,0]:c.fontMatrix,new hs($p(g,f,k),e,c)):new is(h,e,c.fontMatrix,c.glyphNameMap)};return a}(),ks=xb(function(a){a.Courier=600;a["Courier-Bold"]=600;a["Courier-BoldOblique"]=\n600;a["Courier-Oblique"]=600;a.Helvetica=xb(function(c){c.space=278;c.exclam=278;c.quotedbl=355;c.numbersign=556;c.dollar=556;c.percent=889;c.ampersand=667;c.quoteright=222;c.parenleft=333;c.parenright=333;c.asterisk=389;c.plus=584;c.comma=278;c.hyphen=333;c.period=278;c.slash=278;c.zero=556;c.one=556;c.two=556;c.three=556;c.four=556;c.five=556;c.six=556;c.seven=556;c.eight=556;c.nine=556;c.colon=278;c.semicolon=278;c.less=584;c.equal=584;c.greater=584;c.question=556;c.at=1015;c.A=667;c.B=667;c.C=\n722;c.D=722;c.E=667;c.F=611;c.G=778;c.H=722;c.I=278;c.J=500;c.K=667;c.L=556;c.M=833;c.N=722;c.O=778;c.P=667;c.Q=778;c.R=722;c.S=667;c.T=611;c.U=722;c.V=667;c.W=944;c.X=667;c.Y=667;c.Z=611;c.bracketleft=278;c.backslash=278;c.bracketright=278;c.asciicircum=469;c.underscore=556;c.quoteleft=222;c.a=556;c.b=556;c.c=500;c.d=556;c.e=556;c.f=278;c.g=556;c.h=556;c.i=222;c.j=222;c.k=500;c.l=222;c.m=833;c.n=556;c.o=556;c.p=556;c.q=556;c.r=333;c.s=500;c.t=278;c.u=556;c.v=500;c.w=722;c.x=500;c.y=500;c.z=500;c.braceleft=\n334;c.bar=260;c.braceright=334;c.asciitilde=584;c.exclamdown=333;c.cent=556;c.sterling=556;c.fraction=167;c.yen=556;c.florin=556;c.section=556;c.currency=556;c.quotesingle=191;c.quotedblleft=333;c.guillemotleft=556;c.guilsinglleft=333;c.guilsinglright=333;c.fi=500;c.fl=500;c.endash=556;c.dagger=556;c.daggerdbl=556;c.periodcentered=278;c.paragraph=537;c.bullet=350;c.quotesinglbase=222;c.quotedblbase=333;c.quotedblright=333;c.guillemotright=556;c.ellipsis=1E3;c.perthousand=1E3;c.questiondown=611;c.grave=\n333;c.acute=333;c.circumflex=333;c.tilde=333;c.macron=333;c.breve=333;c.dotaccent=333;c.dieresis=333;c.ring=333;c.cedilla=333;c.hungarumlaut=333;c.ogonek=333;c.caron=333;c.emdash=1E3;c.AE=1E3;c.ordfeminine=370;c.Lslash=556;c.Oslash=778;c.OE=1E3;c.ordmasculine=365;c.ae=889;c.dotlessi=278;c.lslash=222;c.oslash=611;c.oe=944;c.germandbls=611;c.Idieresis=278;c.eacute=556;c.abreve=556;c.uhungarumlaut=556;c.ecaron=556;c.Ydieresis=667;c.divide=584;c.Yacute=667;c.Acircumflex=667;c.aacute=556;c.Ucircumflex=\n722;c.yacute=500;c.scommaaccent=500;c.ecircumflex=556;c.Uring=722;c.Udieresis=722;c.aogonek=556;c.Uacute=722;c.uogonek=556;c.Edieresis=667;c.Dcroat=722;c.commaaccent=250;c.copyright=737;c.Emacron=667;c.ccaron=500;c.aring=556;c.Ncommaaccent=722;c.lacute=222;c.agrave=556;c.Tcommaaccent=611;c.Cacute=722;c.atilde=556;c.Edotaccent=667;c.scaron=500;c.scedilla=500;c.iacute=278;c.lozenge=471;c.Rcaron=722;c.Gcommaaccent=778;c.ucircumflex=556;c.acircumflex=556;c.Amacron=667;c.rcaron=333;c.ccedilla=500;c.Zdotaccent=\n611;c.Thorn=667;c.Omacron=778;c.Racute=722;c.Sacute=667;c.dcaron=643;c.Umacron=722;c.uring=556;c.threesuperior=333;c.Ograve=778;c.Agrave=667;c.Abreve=667;c.multiply=584;c.uacute=556;c.Tcaron=611;c.partialdiff=476;c.ydieresis=500;c.Nacute=722;c.icircumflex=278;c.Ecircumflex=667;c.adieresis=556;c.edieresis=556;c.cacute=500;c.nacute=556;c.umacron=556;c.Ncaron=722;c.Iacute=278;c.plusminus=584;c.brokenbar=260;c.registered=737;c.Gbreve=778;c.Idotaccent=278;c.summation=600;c.Egrave=667;c.racute=333;c.omacron=\n556;c.Zacute=611;c.Zcaron=611;c.greaterequal=549;c.Eth=722;c.Ccedilla=722;c.lcommaaccent=222;c.tcaron=317;c.eogonek=556;c.Uogonek=722;c.Aacute=667;c.Adieresis=667;c.egrave=556;c.zacute=500;c.iogonek=222;c.Oacute=778;c.oacute=556;c.amacron=556;c.sacute=500;c.idieresis=278;c.Ocircumflex=778;c.Ugrave=722;c.Delta=612;c.thorn=556;c.twosuperior=333;c.Odieresis=778;c.mu=556;c.igrave=278;c.ohungarumlaut=556;c.Eogonek=667;c.dcroat=556;c.threequarters=834;c.Scedilla=667;c.lcaron=299;c.Kcommaaccent=667;c.Lacute=\n556;c.trademark=1E3;c.edotaccent=556;c.Igrave=278;c.Imacron=278;c.Lcaron=556;c.onehalf=834;c.lessequal=549;c.ocircumflex=556;c.ntilde=556;c.Uhungarumlaut=722;c.Eacute=667;c.emacron=556;c.gbreve=556;c.onequarter=834;c.Scaron=667;c.Scommaaccent=667;c.Ohungarumlaut=778;c.degree=400;c.ograve=556;c.Ccaron=722;c.ugrave=556;c.radical=453;c.Dcaron=722;c.rcommaaccent=333;c.Ntilde=722;c.otilde=556;c.Rcommaaccent=722;c.Lcommaaccent=556;c.Atilde=667;c.Aogonek=667;c.Aring=667;c.Otilde=778;c.zdotaccent=500;c.Ecaron=\n667;c.Iogonek=278;c.kcommaaccent=500;c.minus=584;c.Icircumflex=278;c.ncaron=556;c.tcommaaccent=278;c.logicalnot=584;c.odieresis=556;c.udieresis=556;c.notequal=549;c.gcommaaccent=556;c.eth=556;c.zcaron=500;c.ncommaaccent=556;c.onesuperior=333;c.imacron=278;c.Euro=556});a["Helvetica-Bold"]=xb(function(c){c.space=278;c.exclam=333;c.quotedbl=474;c.numbersign=556;c.dollar=556;c.percent=889;c.ampersand=722;c.quoteright=278;c.parenleft=333;c.parenright=333;c.asterisk=389;c.plus=584;c.comma=278;c.hyphen=\n333;c.period=278;c.slash=278;c.zero=556;c.one=556;c.two=556;c.three=556;c.four=556;c.five=556;c.six=556;c.seven=556;c.eight=556;c.nine=556;c.colon=333;c.semicolon=333;c.less=584;c.equal=584;c.greater=584;c.question=611;c.at=975;c.A=722;c.B=722;c.C=722;c.D=722;c.E=667;c.F=611;c.G=778;c.H=722;c.I=278;c.J=556;c.K=722;c.L=611;c.M=833;c.N=722;c.O=778;c.P=667;c.Q=778;c.R=722;c.S=667;c.T=611;c.U=722;c.V=667;c.W=944;c.X=667;c.Y=667;c.Z=611;c.bracketleft=333;c.backslash=278;c.bracketright=333;c.asciicircum=\n584;c.underscore=556;c.quoteleft=278;c.a=556;c.b=611;c.c=556;c.d=611;c.e=556;c.f=333;c.g=611;c.h=611;c.i=278;c.j=278;c.k=556;c.l=278;c.m=889;c.n=611;c.o=611;c.p=611;c.q=611;c.r=389;c.s=556;c.t=333;c.u=611;c.v=556;c.w=778;c.x=556;c.y=556;c.z=500;c.braceleft=389;c.bar=280;c.braceright=389;c.asciitilde=584;c.exclamdown=333;c.cent=556;c.sterling=556;c.fraction=167;c.yen=556;c.florin=556;c.section=556;c.currency=556;c.quotesingle=238;c.quotedblleft=500;c.guillemotleft=556;c.guilsinglleft=333;c.guilsinglright=\n333;c.fi=611;c.fl=611;c.endash=556;c.dagger=556;c.daggerdbl=556;c.periodcentered=278;c.paragraph=556;c.bullet=350;c.quotesinglbase=278;c.quotedblbase=500;c.quotedblright=500;c.guillemotright=556;c.ellipsis=1E3;c.perthousand=1E3;c.questiondown=611;c.grave=333;c.acute=333;c.circumflex=333;c.tilde=333;c.macron=333;c.breve=333;c.dotaccent=333;c.dieresis=333;c.ring=333;c.cedilla=333;c.hungarumlaut=333;c.ogonek=333;c.caron=333;c.emdash=1E3;c.AE=1E3;c.ordfeminine=370;c.Lslash=611;c.Oslash=778;c.OE=1E3;c.ordmasculine=\n365;c.ae=889;c.dotlessi=278;c.lslash=278;c.oslash=611;c.oe=944;c.germandbls=611;c.Idieresis=278;c.eacute=556;c.abreve=556;c.uhungarumlaut=611;c.ecaron=556;c.Ydieresis=667;c.divide=584;c.Yacute=667;c.Acircumflex=722;c.aacute=556;c.Ucircumflex=722;c.yacute=556;c.scommaaccent=556;c.ecircumflex=556;c.Uring=722;c.Udieresis=722;c.aogonek=556;c.Uacute=722;c.uogonek=611;c.Edieresis=667;c.Dcroat=722;c.commaaccent=250;c.copyright=737;c.Emacron=667;c.ccaron=556;c.aring=556;c.Ncommaaccent=722;c.lacute=278;c.agrave=\n556;c.Tcommaaccent=611;c.Cacute=722;c.atilde=556;c.Edotaccent=667;c.scaron=556;c.scedilla=556;c.iacute=278;c.lozenge=494;c.Rcaron=722;c.Gcommaaccent=778;c.ucircumflex=611;c.acircumflex=556;c.Amacron=722;c.rcaron=389;c.ccedilla=556;c.Zdotaccent=611;c.Thorn=667;c.Omacron=778;c.Racute=722;c.Sacute=667;c.dcaron=743;c.Umacron=722;c.uring=611;c.threesuperior=333;c.Ograve=778;c.Agrave=722;c.Abreve=722;c.multiply=584;c.uacute=611;c.Tcaron=611;c.partialdiff=494;c.ydieresis=556;c.Nacute=722;c.icircumflex=278;\nc.Ecircumflex=667;c.adieresis=556;c.edieresis=556;c.cacute=556;c.nacute=611;c.umacron=611;c.Ncaron=722;c.Iacute=278;c.plusminus=584;c.brokenbar=280;c.registered=737;c.Gbreve=778;c.Idotaccent=278;c.summation=600;c.Egrave=667;c.racute=389;c.omacron=611;c.Zacute=611;c.Zcaron=611;c.greaterequal=549;c.Eth=722;c.Ccedilla=722;c.lcommaaccent=278;c.tcaron=389;c.eogonek=556;c.Uogonek=722;c.Aacute=722;c.Adieresis=722;c.egrave=556;c.zacute=500;c.iogonek=278;c.Oacute=778;c.oacute=611;c.amacron=556;c.sacute=556;\nc.idieresis=278;c.Ocircumflex=778;c.Ugrave=722;c.Delta=612;c.thorn=611;c.twosuperior=333;c.Odieresis=778;c.mu=611;c.igrave=278;c.ohungarumlaut=611;c.Eogonek=667;c.dcroat=611;c.threequarters=834;c.Scedilla=667;c.lcaron=400;c.Kcommaaccent=722;c.Lacute=611;c.trademark=1E3;c.edotaccent=556;c.Igrave=278;c.Imacron=278;c.Lcaron=611;c.onehalf=834;c.lessequal=549;c.ocircumflex=611;c.ntilde=611;c.Uhungarumlaut=722;c.Eacute=667;c.emacron=556;c.gbreve=611;c.onequarter=834;c.Scaron=667;c.Scommaaccent=667;c.Ohungarumlaut=\n778;c.degree=400;c.ograve=611;c.Ccaron=722;c.ugrave=611;c.radical=549;c.Dcaron=722;c.rcommaaccent=389;c.Ntilde=722;c.otilde=611;c.Rcommaaccent=722;c.Lcommaaccent=611;c.Atilde=722;c.Aogonek=722;c.Aring=722;c.Otilde=778;c.zdotaccent=500;c.Ecaron=667;c.Iogonek=278;c.kcommaaccent=556;c.minus=584;c.Icircumflex=278;c.ncaron=611;c.tcommaaccent=333;c.logicalnot=584;c.odieresis=611;c.udieresis=611;c.notequal=549;c.gcommaaccent=611;c.eth=611;c.zcaron=500;c.ncommaaccent=611;c.onesuperior=333;c.imacron=278;c.Euro=\n556});a["Helvetica-BoldOblique"]=xb(function(c){c.space=278;c.exclam=333;c.quotedbl=474;c.numbersign=556;c.dollar=556;c.percent=889;c.ampersand=722;c.quoteright=278;c.parenleft=333;c.parenright=333;c.asterisk=389;c.plus=584;c.comma=278;c.hyphen=333;c.period=278;c.slash=278;c.zero=556;c.one=556;c.two=556;c.three=556;c.four=556;c.five=556;c.six=556;c.seven=556;c.eight=556;c.nine=556;c.colon=333;c.semicolon=333;c.less=584;c.equal=584;c.greater=584;c.question=611;c.at=975;c.A=722;c.B=722;c.C=722;c.D=\n722;c.E=667;c.F=611;c.G=778;c.H=722;c.I=278;c.J=556;c.K=722;c.L=611;c.M=833;c.N=722;c.O=778;c.P=667;c.Q=778;c.R=722;c.S=667;c.T=611;c.U=722;c.V=667;c.W=944;c.X=667;c.Y=667;c.Z=611;c.bracketleft=333;c.backslash=278;c.bracketright=333;c.asciicircum=584;c.underscore=556;c.quoteleft=278;c.a=556;c.b=611;c.c=556;c.d=611;c.e=556;c.f=333;c.g=611;c.h=611;c.i=278;c.j=278;c.k=556;c.l=278;c.m=889;c.n=611;c.o=611;c.p=611;c.q=611;c.r=389;c.s=556;c.t=333;c.u=611;c.v=556;c.w=778;c.x=556;c.y=556;c.z=500;c.braceleft=\n389;c.bar=280;c.braceright=389;c.asciitilde=584;c.exclamdown=333;c.cent=556;c.sterling=556;c.fraction=167;c.yen=556;c.florin=556;c.section=556;c.currency=556;c.quotesingle=238;c.quotedblleft=500;c.guillemotleft=556;c.guilsinglleft=333;c.guilsinglright=333;c.fi=611;c.fl=611;c.endash=556;c.dagger=556;c.daggerdbl=556;c.periodcentered=278;c.paragraph=556;c.bullet=350;c.quotesinglbase=278;c.quotedblbase=500;c.quotedblright=500;c.guillemotright=556;c.ellipsis=1E3;c.perthousand=1E3;c.questiondown=611;c.grave=\n333;c.acute=333;c.circumflex=333;c.tilde=333;c.macron=333;c.breve=333;c.dotaccent=333;c.dieresis=333;c.ring=333;c.cedilla=333;c.hungarumlaut=333;c.ogonek=333;c.caron=333;c.emdash=1E3;c.AE=1E3;c.ordfeminine=370;c.Lslash=611;c.Oslash=778;c.OE=1E3;c.ordmasculine=365;c.ae=889;c.dotlessi=278;c.lslash=278;c.oslash=611;c.oe=944;c.germandbls=611;c.Idieresis=278;c.eacute=556;c.abreve=556;c.uhungarumlaut=611;c.ecaron=556;c.Ydieresis=667;c.divide=584;c.Yacute=667;c.Acircumflex=722;c.aacute=556;c.Ucircumflex=\n722;c.yacute=556;c.scommaaccent=556;c.ecircumflex=556;c.Uring=722;c.Udieresis=722;c.aogonek=556;c.Uacute=722;c.uogonek=611;c.Edieresis=667;c.Dcroat=722;c.commaaccent=250;c.copyright=737;c.Emacron=667;c.ccaron=556;c.aring=556;c.Ncommaaccent=722;c.lacute=278;c.agrave=556;c.Tcommaaccent=611;c.Cacute=722;c.atilde=556;c.Edotaccent=667;c.scaron=556;c.scedilla=556;c.iacute=278;c.lozenge=494;c.Rcaron=722;c.Gcommaaccent=778;c.ucircumflex=611;c.acircumflex=556;c.Amacron=722;c.rcaron=389;c.ccedilla=556;c.Zdotaccent=\n611;c.Thorn=667;c.Omacron=778;c.Racute=722;c.Sacute=667;c.dcaron=743;c.Umacron=722;c.uring=611;c.threesuperior=333;c.Ograve=778;c.Agrave=722;c.Abreve=722;c.multiply=584;c.uacute=611;c.Tcaron=611;c.partialdiff=494;c.ydieresis=556;c.Nacute=722;c.icircumflex=278;c.Ecircumflex=667;c.adieresis=556;c.edieresis=556;c.cacute=556;c.nacute=611;c.umacron=611;c.Ncaron=722;c.Iacute=278;c.plusminus=584;c.brokenbar=280;c.registered=737;c.Gbreve=778;c.Idotaccent=278;c.summation=600;c.Egrave=667;c.racute=389;c.omacron=\n611;c.Zacute=611;c.Zcaron=611;c.greaterequal=549;c.Eth=722;c.Ccedilla=722;c.lcommaaccent=278;c.tcaron=389;c.eogonek=556;c.Uogonek=722;c.Aacute=722;c.Adieresis=722;c.egrave=556;c.zacute=500;c.iogonek=278;c.Oacute=778;c.oacute=611;c.amacron=556;c.sacute=556;c.idieresis=278;c.Ocircumflex=778;c.Ugrave=722;c.Delta=612;c.thorn=611;c.twosuperior=333;c.Odieresis=778;c.mu=611;c.igrave=278;c.ohungarumlaut=611;c.Eogonek=667;c.dcroat=611;c.threequarters=834;c.Scedilla=667;c.lcaron=400;c.Kcommaaccent=722;c.Lacute=\n611;c.trademark=1E3;c.edotaccent=556;c.Igrave=278;c.Imacron=278;c.Lcaron=611;c.onehalf=834;c.lessequal=549;c.ocircumflex=611;c.ntilde=611;c.Uhungarumlaut=722;c.Eacute=667;c.emacron=556;c.gbreve=611;c.onequarter=834;c.Scaron=667;c.Scommaaccent=667;c.Ohungarumlaut=778;c.degree=400;c.ograve=611;c.Ccaron=722;c.ugrave=611;c.radical=549;c.Dcaron=722;c.rcommaaccent=389;c.Ntilde=722;c.otilde=611;c.Rcommaaccent=722;c.Lcommaaccent=611;c.Atilde=722;c.Aogonek=722;c.Aring=722;c.Otilde=778;c.zdotaccent=500;c.Ecaron=\n667;c.Iogonek=278;c.kcommaaccent=556;c.minus=584;c.Icircumflex=278;c.ncaron=611;c.tcommaaccent=333;c.logicalnot=584;c.odieresis=611;c.udieresis=611;c.notequal=549;c.gcommaaccent=611;c.eth=611;c.zcaron=500;c.ncommaaccent=611;c.onesuperior=333;c.imacron=278;c.Euro=556});a["Helvetica-Oblique"]=xb(function(c){c.space=278;c.exclam=278;c.quotedbl=355;c.numbersign=556;c.dollar=556;c.percent=889;c.ampersand=667;c.quoteright=222;c.parenleft=333;c.parenright=333;c.asterisk=389;c.plus=584;c.comma=278;c.hyphen=\n333;c.period=278;c.slash=278;c.zero=556;c.one=556;c.two=556;c.three=556;c.four=556;c.five=556;c.six=556;c.seven=556;c.eight=556;c.nine=556;c.colon=278;c.semicolon=278;c.less=584;c.equal=584;c.greater=584;c.question=556;c.at=1015;c.A=667;c.B=667;c.C=722;c.D=722;c.E=667;c.F=611;c.G=778;c.H=722;c.I=278;c.J=500;c.K=667;c.L=556;c.M=833;c.N=722;c.O=778;c.P=667;c.Q=778;c.R=722;c.S=667;c.T=611;c.U=722;c.V=667;c.W=944;c.X=667;c.Y=667;c.Z=611;c.bracketleft=278;c.backslash=278;c.bracketright=278;c.asciicircum=\n469;c.underscore=556;c.quoteleft=222;c.a=556;c.b=556;c.c=500;c.d=556;c.e=556;c.f=278;c.g=556;c.h=556;c.i=222;c.j=222;c.k=500;c.l=222;c.m=833;c.n=556;c.o=556;c.p=556;c.q=556;c.r=333;c.s=500;c.t=278;c.u=556;c.v=500;c.w=722;c.x=500;c.y=500;c.z=500;c.braceleft=334;c.bar=260;c.braceright=334;c.asciitilde=584;c.exclamdown=333;c.cent=556;c.sterling=556;c.fraction=167;c.yen=556;c.florin=556;c.section=556;c.currency=556;c.quotesingle=191;c.quotedblleft=333;c.guillemotleft=556;c.guilsinglleft=333;c.guilsinglright=\n333;c.fi=500;c.fl=500;c.endash=556;c.dagger=556;c.daggerdbl=556;c.periodcentered=278;c.paragraph=537;c.bullet=350;c.quotesinglbase=222;c.quotedblbase=333;c.quotedblright=333;c.guillemotright=556;c.ellipsis=1E3;c.perthousand=1E3;c.questiondown=611;c.grave=333;c.acute=333;c.circumflex=333;c.tilde=333;c.macron=333;c.breve=333;c.dotaccent=333;c.dieresis=333;c.ring=333;c.cedilla=333;c.hungarumlaut=333;c.ogonek=333;c.caron=333;c.emdash=1E3;c.AE=1E3;c.ordfeminine=370;c.Lslash=556;c.Oslash=778;c.OE=1E3;c.ordmasculine=\n365;c.ae=889;c.dotlessi=278;c.lslash=222;c.oslash=611;c.oe=944;c.germandbls=611;c.Idieresis=278;c.eacute=556;c.abreve=556;c.uhungarumlaut=556;c.ecaron=556;c.Ydieresis=667;c.divide=584;c.Yacute=667;c.Acircumflex=667;c.aacute=556;c.Ucircumflex=722;c.yacute=500;c.scommaaccent=500;c.ecircumflex=556;c.Uring=722;c.Udieresis=722;c.aogonek=556;c.Uacute=722;c.uogonek=556;c.Edieresis=667;c.Dcroat=722;c.commaaccent=250;c.copyright=737;c.Emacron=667;c.ccaron=500;c.aring=556;c.Ncommaaccent=722;c.lacute=222;c.agrave=\n556;c.Tcommaaccent=611;c.Cacute=722;c.atilde=556;c.Edotaccent=667;c.scaron=500;c.scedilla=500;c.iacute=278;c.lozenge=471;c.Rcaron=722;c.Gcommaaccent=778;c.ucircumflex=556;c.acircumflex=556;c.Amacron=667;c.rcaron=333;c.ccedilla=500;c.Zdotaccent=611;c.Thorn=667;c.Omacron=778;c.Racute=722;c.Sacute=667;c.dcaron=643;c.Umacron=722;c.uring=556;c.threesuperior=333;c.Ograve=778;c.Agrave=667;c.Abreve=667;c.multiply=584;c.uacute=556;c.Tcaron=611;c.partialdiff=476;c.ydieresis=500;c.Nacute=722;c.icircumflex=278;\nc.Ecircumflex=667;c.adieresis=556;c.edieresis=556;c.cacute=500;c.nacute=556;c.umacron=556;c.Ncaron=722;c.Iacute=278;c.plusminus=584;c.brokenbar=260;c.registered=737;c.Gbreve=778;c.Idotaccent=278;c.summation=600;c.Egrave=667;c.racute=333;c.omacron=556;c.Zacute=611;c.Zcaron=611;c.greaterequal=549;c.Eth=722;c.Ccedilla=722;c.lcommaaccent=222;c.tcaron=317;c.eogonek=556;c.Uogonek=722;c.Aacute=667;c.Adieresis=667;c.egrave=556;c.zacute=500;c.iogonek=222;c.Oacute=778;c.oacute=556;c.amacron=556;c.sacute=500;\nc.idieresis=278;c.Ocircumflex=778;c.Ugrave=722;c.Delta=612;c.thorn=556;c.twosuperior=333;c.Odieresis=778;c.mu=556;c.igrave=278;c.ohungarumlaut=556;c.Eogonek=667;c.dcroat=556;c.threequarters=834;c.Scedilla=667;c.lcaron=299;c.Kcommaaccent=667;c.Lacute=556;c.trademark=1E3;c.edotaccent=556;c.Igrave=278;c.Imacron=278;c.Lcaron=556;c.onehalf=834;c.lessequal=549;c.ocircumflex=556;c.ntilde=556;c.Uhungarumlaut=722;c.Eacute=667;c.emacron=556;c.gbreve=556;c.onequarter=834;c.Scaron=667;c.Scommaaccent=667;c.Ohungarumlaut=\n778;c.degree=400;c.ograve=556;c.Ccaron=722;c.ugrave=556;c.radical=453;c.Dcaron=722;c.rcommaaccent=333;c.Ntilde=722;c.otilde=556;c.Rcommaaccent=722;c.Lcommaaccent=556;c.Atilde=667;c.Aogonek=667;c.Aring=667;c.Otilde=778;c.zdotaccent=500;c.Ecaron=667;c.Iogonek=278;c.kcommaaccent=500;c.minus=584;c.Icircumflex=278;c.ncaron=556;c.tcommaaccent=278;c.logicalnot=584;c.odieresis=556;c.udieresis=556;c.notequal=549;c.gcommaaccent=556;c.eth=556;c.zcaron=500;c.ncommaaccent=556;c.onesuperior=333;c.imacron=278;c.Euro=\n556});a.Symbol=xb(function(c){c.space=250;c.exclam=333;c.universal=713;c.numbersign=500;c.existential=549;c.percent=833;c.ampersand=778;c.suchthat=439;c.parenleft=333;c.parenright=333;c.asteriskmath=500;c.plus=549;c.comma=250;c.minus=549;c.period=250;c.slash=278;c.zero=500;c.one=500;c.two=500;c.three=500;c.four=500;c.five=500;c.six=500;c.seven=500;c.eight=500;c.nine=500;c.colon=278;c.semicolon=278;c.less=549;c.equal=549;c.greater=549;c.question=444;c.congruent=549;c.Alpha=722;c.Beta=667;c.Chi=722;\nc.Delta=612;c.Epsilon=611;c.Phi=763;c.Gamma=603;c.Eta=722;c.Iota=333;c.theta1=631;c.Kappa=722;c.Lambda=686;c.Mu=889;c.Nu=722;c.Omicron=722;c.Pi=768;c.Theta=741;c.Rho=556;c.Sigma=592;c.Tau=611;c.Upsilon=690;c.sigma1=439;c.Omega=768;c.Xi=645;c.Psi=795;c.Zeta=611;c.bracketleft=333;c.therefore=863;c.bracketright=333;c.perpendicular=658;c.underscore=500;c.radicalex=500;c.alpha=631;c.beta=549;c.chi=549;c.delta=494;c.epsilon=439;c.phi=521;c.gamma=411;c.eta=603;c.iota=329;c.phi1=603;c.kappa=549;c.lambda=\n549;c.mu=576;c.nu=521;c.omicron=549;c.pi=549;c.theta=521;c.rho=549;c.sigma=603;c.tau=439;c.upsilon=576;c.omega1=713;c.omega=686;c.xi=493;c.psi=686;c.zeta=494;c.braceleft=480;c.bar=200;c.braceright=480;c.similar=549;c.Euro=750;c.Upsilon1=620;c.minute=247;c.lessequal=549;c.fraction=167;c.infinity=713;c.florin=500;c.club=753;c.diamond=753;c.heart=753;c.spade=753;c.arrowboth=1042;c.arrowleft=987;c.arrowup=603;c.arrowright=987;c.arrowdown=603;c.degree=400;c.plusminus=549;c.second=411;c.greaterequal=549;\nc.multiply=549;c.proportional=713;c.partialdiff=494;c.bullet=460;c.divide=549;c.notequal=549;c.equivalence=549;c.approxequal=549;c.ellipsis=1E3;c.arrowvertex=603;c.arrowhorizex=1E3;c.carriagereturn=658;c.aleph=823;c.Ifraktur=686;c.Rfraktur=795;c.weierstrass=987;c.circlemultiply=768;c.circleplus=768;c.emptyset=823;c.intersection=768;c.union=768;c.propersuperset=713;c.reflexsuperset=713;c.notsubset=713;c.propersubset=713;c.reflexsubset=713;c.element=713;c.notelement=713;c.angle=768;c.gradient=713;c.registerserif=\n790;c.copyrightserif=790;c.trademarkserif=890;c.product=823;c.radical=549;c.dotmath=250;c.logicalnot=713;c.logicaland=603;c.logicalor=603;c.arrowdblboth=1042;c.arrowdblleft=987;c.arrowdblup=603;c.arrowdblright=987;c.arrowdbldown=603;c.lozenge=494;c.angleleft=329;c.registersans=790;c.copyrightsans=790;c.trademarksans=786;c.summation=713;c.parenlefttp=384;c.parenleftex=384;c.parenleftbt=384;c.bracketlefttp=384;c.bracketleftex=384;c.bracketleftbt=384;c.bracelefttp=494;c.braceleftmid=494;c.braceleftbt=\n494;c.braceex=494;c.angleright=329;c.integral=274;c.integraltp=686;c.integralex=686;c.integralbt=686;c.parenrighttp=384;c.parenrightex=384;c.parenrightbt=384;c.bracketrighttp=384;c.bracketrightex=384;c.bracketrightbt=384;c.bracerighttp=494;c.bracerightmid=494;c.bracerightbt=494;c.apple=790});a["Times-Roman"]=xb(function(c){c.space=250;c.exclam=333;c.quotedbl=408;c.numbersign=500;c.dollar=500;c.percent=833;c.ampersand=778;c.quoteright=333;c.parenleft=333;c.parenright=333;c.asterisk=500;c.plus=564;\nc.comma=250;c.hyphen=333;c.period=250;c.slash=278;c.zero=500;c.one=500;c.two=500;c.three=500;c.four=500;c.five=500;c.six=500;c.seven=500;c.eight=500;c.nine=500;c.colon=278;c.semicolon=278;c.less=564;c.equal=564;c.greater=564;c.question=444;c.at=921;c.A=722;c.B=667;c.C=667;c.D=722;c.E=611;c.F=556;c.G=722;c.H=722;c.I=333;c.J=389;c.K=722;c.L=611;c.M=889;c.N=722;c.O=722;c.P=556;c.Q=722;c.R=667;c.S=556;c.T=611;c.U=722;c.V=722;c.W=944;c.X=722;c.Y=722;c.Z=611;c.bracketleft=333;c.backslash=278;c.bracketright=\n333;c.asciicircum=469;c.underscore=500;c.quoteleft=333;c.a=444;c.b=500;c.c=444;c.d=500;c.e=444;c.f=333;c.g=500;c.h=500;c.i=278;c.j=278;c.k=500;c.l=278;c.m=778;c.n=500;c.o=500;c.p=500;c.q=500;c.r=333;c.s=389;c.t=278;c.u=500;c.v=500;c.w=722;c.x=500;c.y=500;c.z=444;c.braceleft=480;c.bar=200;c.braceright=480;c.asciitilde=541;c.exclamdown=333;c.cent=500;c.sterling=500;c.fraction=167;c.yen=500;c.florin=500;c.section=500;c.currency=500;c.quotesingle=180;c.quotedblleft=444;c.guillemotleft=500;c.guilsinglleft=\n333;c.guilsinglright=333;c.fi=556;c.fl=556;c.endash=500;c.dagger=500;c.daggerdbl=500;c.periodcentered=250;c.paragraph=453;c.bullet=350;c.quotesinglbase=333;c.quotedblbase=444;c.quotedblright=444;c.guillemotright=500;c.ellipsis=1E3;c.perthousand=1E3;c.questiondown=444;c.grave=333;c.acute=333;c.circumflex=333;c.tilde=333;c.macron=333;c.breve=333;c.dotaccent=333;c.dieresis=333;c.ring=333;c.cedilla=333;c.hungarumlaut=333;c.ogonek=333;c.caron=333;c.emdash=1E3;c.AE=889;c.ordfeminine=276;c.Lslash=611;c.Oslash=\n722;c.OE=889;c.ordmasculine=310;c.ae=667;c.dotlessi=278;c.lslash=278;c.oslash=500;c.oe=722;c.germandbls=500;c.Idieresis=333;c.eacute=444;c.abreve=444;c.uhungarumlaut=500;c.ecaron=444;c.Ydieresis=722;c.divide=564;c.Yacute=722;c.Acircumflex=722;c.aacute=444;c.Ucircumflex=722;c.yacute=500;c.scommaaccent=389;c.ecircumflex=444;c.Uring=722;c.Udieresis=722;c.aogonek=444;c.Uacute=722;c.uogonek=500;c.Edieresis=611;c.Dcroat=722;c.commaaccent=250;c.copyright=760;c.Emacron=611;c.ccaron=444;c.aring=444;c.Ncommaaccent=\n722;c.lacute=278;c.agrave=444;c.Tcommaaccent=611;c.Cacute=667;c.atilde=444;c.Edotaccent=611;c.scaron=389;c.scedilla=389;c.iacute=278;c.lozenge=471;c.Rcaron=667;c.Gcommaaccent=722;c.ucircumflex=500;c.acircumflex=444;c.Amacron=722;c.rcaron=333;c.ccedilla=444;c.Zdotaccent=611;c.Thorn=556;c.Omacron=722;c.Racute=667;c.Sacute=556;c.dcaron=588;c.Umacron=722;c.uring=500;c.threesuperior=300;c.Ograve=722;c.Agrave=722;c.Abreve=722;c.multiply=564;c.uacute=500;c.Tcaron=611;c.partialdiff=476;c.ydieresis=500;c.Nacute=\n722;c.icircumflex=278;c.Ecircumflex=611;c.adieresis=444;c.edieresis=444;c.cacute=444;c.nacute=500;c.umacron=500;c.Ncaron=722;c.Iacute=333;c.plusminus=564;c.brokenbar=200;c.registered=760;c.Gbreve=722;c.Idotaccent=333;c.summation=600;c.Egrave=611;c.racute=333;c.omacron=500;c.Zacute=611;c.Zcaron=611;c.greaterequal=549;c.Eth=722;c.Ccedilla=667;c.lcommaaccent=278;c.tcaron=326;c.eogonek=444;c.Uogonek=722;c.Aacute=722;c.Adieresis=722;c.egrave=444;c.zacute=444;c.iogonek=278;c.Oacute=722;c.oacute=500;c.amacron=\n444;c.sacute=389;c.idieresis=278;c.Ocircumflex=722;c.Ugrave=722;c.Delta=612;c.thorn=500;c.twosuperior=300;c.Odieresis=722;c.mu=500;c.igrave=278;c.ohungarumlaut=500;c.Eogonek=611;c.dcroat=500;c.threequarters=750;c.Scedilla=556;c.lcaron=344;c.Kcommaaccent=722;c.Lacute=611;c.trademark=980;c.edotaccent=444;c.Igrave=333;c.Imacron=333;c.Lcaron=611;c.onehalf=750;c.lessequal=549;c.ocircumflex=500;c.ntilde=500;c.Uhungarumlaut=722;c.Eacute=611;c.emacron=444;c.gbreve=500;c.onequarter=750;c.Scaron=556;c.Scommaaccent=\n556;c.Ohungarumlaut=722;c.degree=400;c.ograve=500;c.Ccaron=667;c.ugrave=500;c.radical=453;c.Dcaron=722;c.rcommaaccent=333;c.Ntilde=722;c.otilde=500;c.Rcommaaccent=667;c.Lcommaaccent=611;c.Atilde=722;c.Aogonek=722;c.Aring=722;c.Otilde=722;c.zdotaccent=444;c.Ecaron=611;c.Iogonek=333;c.kcommaaccent=500;c.minus=564;c.Icircumflex=333;c.ncaron=500;c.tcommaaccent=278;c.logicalnot=564;c.odieresis=500;c.udieresis=500;c.notequal=549;c.gcommaaccent=500;c.eth=500;c.zcaron=444;c.ncommaaccent=500;c.onesuperior=\n300;c.imacron=278;c.Euro=500});a["Times-Bold"]=xb(function(c){c.space=250;c.exclam=333;c.quotedbl=555;c.numbersign=500;c.dollar=500;c.percent=1E3;c.ampersand=833;c.quoteright=333;c.parenleft=333;c.parenright=333;c.asterisk=500;c.plus=570;c.comma=250;c.hyphen=333;c.period=250;c.slash=278;c.zero=500;c.one=500;c.two=500;c.three=500;c.four=500;c.five=500;c.six=500;c.seven=500;c.eight=500;c.nine=500;c.colon=333;c.semicolon=333;c.less=570;c.equal=570;c.greater=570;c.question=500;c.at=930;c.A=722;c.B=667;\nc.C=722;c.D=722;c.E=667;c.F=611;c.G=778;c.H=778;c.I=389;c.J=500;c.K=778;c.L=667;c.M=944;c.N=722;c.O=778;c.P=611;c.Q=778;c.R=722;c.S=556;c.T=667;c.U=722;c.V=722;c.W=1E3;c.X=722;c.Y=722;c.Z=667;c.bracketleft=333;c.backslash=278;c.bracketright=333;c.asciicircum=581;c.underscore=500;c.quoteleft=333;c.a=500;c.b=556;c.c=444;c.d=556;c.e=444;c.f=333;c.g=500;c.h=556;c.i=278;c.j=333;c.k=556;c.l=278;c.m=833;c.n=556;c.o=500;c.p=556;c.q=556;c.r=444;c.s=389;c.t=333;c.u=556;c.v=500;c.w=722;c.x=500;c.y=500;c.z=444;\nc.braceleft=394;c.bar=220;c.braceright=394;c.asciitilde=520;c.exclamdown=333;c.cent=500;c.sterling=500;c.fraction=167;c.yen=500;c.florin=500;c.section=500;c.currency=500;c.quotesingle=278;c.quotedblleft=500;c.guillemotleft=500;c.guilsinglleft=333;c.guilsinglright=333;c.fi=556;c.fl=556;c.endash=500;c.dagger=500;c.daggerdbl=500;c.periodcentered=250;c.paragraph=540;c.bullet=350;c.quotesinglbase=333;c.quotedblbase=500;c.quotedblright=500;c.guillemotright=500;c.ellipsis=1E3;c.perthousand=1E3;c.questiondown=\n500;c.grave=333;c.acute=333;c.circumflex=333;c.tilde=333;c.macron=333;c.breve=333;c.dotaccent=333;c.dieresis=333;c.ring=333;c.cedilla=333;c.hungarumlaut=333;c.ogonek=333;c.caron=333;c.emdash=1E3;c.AE=1E3;c.ordfeminine=300;c.Lslash=667;c.Oslash=778;c.OE=1E3;c.ordmasculine=330;c.ae=722;c.dotlessi=278;c.lslash=278;c.oslash=500;c.oe=722;c.germandbls=556;c.Idieresis=389;c.eacute=444;c.abreve=500;c.uhungarumlaut=556;c.ecaron=444;c.Ydieresis=722;c.divide=570;c.Yacute=722;c.Acircumflex=722;c.aacute=500;c.Ucircumflex=\n722;c.yacute=500;c.scommaaccent=389;c.ecircumflex=444;c.Uring=722;c.Udieresis=722;c.aogonek=500;c.Uacute=722;c.uogonek=556;c.Edieresis=667;c.Dcroat=722;c.commaaccent=250;c.copyright=747;c.Emacron=667;c.ccaron=444;c.aring=500;c.Ncommaaccent=722;c.lacute=278;c.agrave=500;c.Tcommaaccent=667;c.Cacute=722;c.atilde=500;c.Edotaccent=667;c.scaron=389;c.scedilla=389;c.iacute=278;c.lozenge=494;c.Rcaron=722;c.Gcommaaccent=778;c.ucircumflex=556;c.acircumflex=500;c.Amacron=722;c.rcaron=444;c.ccedilla=444;c.Zdotaccent=\n667;c.Thorn=611;c.Omacron=778;c.Racute=722;c.Sacute=556;c.dcaron=672;c.Umacron=722;c.uring=556;c.threesuperior=300;c.Ograve=778;c.Agrave=722;c.Abreve=722;c.multiply=570;c.uacute=556;c.Tcaron=667;c.partialdiff=494;c.ydieresis=500;c.Nacute=722;c.icircumflex=278;c.Ecircumflex=667;c.adieresis=500;c.edieresis=444;c.cacute=444;c.nacute=556;c.umacron=556;c.Ncaron=722;c.Iacute=389;c.plusminus=570;c.brokenbar=220;c.registered=747;c.Gbreve=778;c.Idotaccent=389;c.summation=600;c.Egrave=667;c.racute=444;c.omacron=\n500;c.Zacute=667;c.Zcaron=667;c.greaterequal=549;c.Eth=722;c.Ccedilla=722;c.lcommaaccent=278;c.tcaron=416;c.eogonek=444;c.Uogonek=722;c.Aacute=722;c.Adieresis=722;c.egrave=444;c.zacute=444;c.iogonek=278;c.Oacute=778;c.oacute=500;c.amacron=500;c.sacute=389;c.idieresis=278;c.Ocircumflex=778;c.Ugrave=722;c.Delta=612;c.thorn=556;c.twosuperior=300;c.Odieresis=778;c.mu=556;c.igrave=278;c.ohungarumlaut=500;c.Eogonek=667;c.dcroat=556;c.threequarters=750;c.Scedilla=556;c.lcaron=394;c.Kcommaaccent=778;c.Lacute=\n667;c.trademark=1E3;c.edotaccent=444;c.Igrave=389;c.Imacron=389;c.Lcaron=667;c.onehalf=750;c.lessequal=549;c.ocircumflex=500;c.ntilde=556;c.Uhungarumlaut=722;c.Eacute=667;c.emacron=444;c.gbreve=500;c.onequarter=750;c.Scaron=556;c.Scommaaccent=556;c.Ohungarumlaut=778;c.degree=400;c.ograve=500;c.Ccaron=722;c.ugrave=556;c.radical=549;c.Dcaron=722;c.rcommaaccent=444;c.Ntilde=722;c.otilde=500;c.Rcommaaccent=722;c.Lcommaaccent=667;c.Atilde=722;c.Aogonek=722;c.Aring=722;c.Otilde=778;c.zdotaccent=444;c.Ecaron=\n667;c.Iogonek=389;c.kcommaaccent=556;c.minus=570;c.Icircumflex=389;c.ncaron=556;c.tcommaaccent=333;c.logicalnot=570;c.odieresis=500;c.udieresis=556;c.notequal=549;c.gcommaaccent=500;c.eth=500;c.zcaron=444;c.ncommaaccent=556;c.onesuperior=300;c.imacron=278;c.Euro=500});a["Times-BoldItalic"]=xb(function(c){c.space=250;c.exclam=389;c.quotedbl=555;c.numbersign=500;c.dollar=500;c.percent=833;c.ampersand=778;c.quoteright=333;c.parenleft=333;c.parenright=333;c.asterisk=500;c.plus=570;c.comma=250;c.hyphen=\n333;c.period=250;c.slash=278;c.zero=500;c.one=500;c.two=500;c.three=500;c.four=500;c.five=500;c.six=500;c.seven=500;c.eight=500;c.nine=500;c.colon=333;c.semicolon=333;c.less=570;c.equal=570;c.greater=570;c.question=500;c.at=832;c.A=667;c.B=667;c.C=667;c.D=722;c.E=667;c.F=667;c.G=722;c.H=778;c.I=389;c.J=500;c.K=667;c.L=611;c.M=889;c.N=722;c.O=722;c.P=611;c.Q=722;c.R=667;c.S=556;c.T=611;c.U=722;c.V=667;c.W=889;c.X=667;c.Y=611;c.Z=611;c.bracketleft=333;c.backslash=278;c.bracketright=333;c.asciicircum=\n570;c.underscore=500;c.quoteleft=333;c.a=500;c.b=500;c.c=444;c.d=500;c.e=444;c.f=333;c.g=500;c.h=556;c.i=278;c.j=278;c.k=500;c.l=278;c.m=778;c.n=556;c.o=500;c.p=500;c.q=500;c.r=389;c.s=389;c.t=278;c.u=556;c.v=444;c.w=667;c.x=500;c.y=444;c.z=389;c.braceleft=348;c.bar=220;c.braceright=348;c.asciitilde=570;c.exclamdown=389;c.cent=500;c.sterling=500;c.fraction=167;c.yen=500;c.florin=500;c.section=500;c.currency=500;c.quotesingle=278;c.quotedblleft=500;c.guillemotleft=500;c.guilsinglleft=333;c.guilsinglright=\n333;c.fi=556;c.fl=556;c.endash=500;c.dagger=500;c.daggerdbl=500;c.periodcentered=250;c.paragraph=500;c.bullet=350;c.quotesinglbase=333;c.quotedblbase=500;c.quotedblright=500;c.guillemotright=500;c.ellipsis=1E3;c.perthousand=1E3;c.questiondown=500;c.grave=333;c.acute=333;c.circumflex=333;c.tilde=333;c.macron=333;c.breve=333;c.dotaccent=333;c.dieresis=333;c.ring=333;c.cedilla=333;c.hungarumlaut=333;c.ogonek=333;c.caron=333;c.emdash=1E3;c.AE=944;c.ordfeminine=266;c.Lslash=611;c.Oslash=722;c.OE=944;c.ordmasculine=\n300;c.ae=722;c.dotlessi=278;c.lslash=278;c.oslash=500;c.oe=722;c.germandbls=500;c.Idieresis=389;c.eacute=444;c.abreve=500;c.uhungarumlaut=556;c.ecaron=444;c.Ydieresis=611;c.divide=570;c.Yacute=611;c.Acircumflex=667;c.aacute=500;c.Ucircumflex=722;c.yacute=444;c.scommaaccent=389;c.ecircumflex=444;c.Uring=722;c.Udieresis=722;c.aogonek=500;c.Uacute=722;c.uogonek=556;c.Edieresis=667;c.Dcroat=722;c.commaaccent=250;c.copyright=747;c.Emacron=667;c.ccaron=444;c.aring=500;c.Ncommaaccent=722;c.lacute=278;c.agrave=\n500;c.Tcommaaccent=611;c.Cacute=667;c.atilde=500;c.Edotaccent=667;c.scaron=389;c.scedilla=389;c.iacute=278;c.lozenge=494;c.Rcaron=667;c.Gcommaaccent=722;c.ucircumflex=556;c.acircumflex=500;c.Amacron=667;c.rcaron=389;c.ccedilla=444;c.Zdotaccent=611;c.Thorn=611;c.Omacron=722;c.Racute=667;c.Sacute=556;c.dcaron=608;c.Umacron=722;c.uring=556;c.threesuperior=300;c.Ograve=722;c.Agrave=667;c.Abreve=667;c.multiply=570;c.uacute=556;c.Tcaron=611;c.partialdiff=494;c.ydieresis=444;c.Nacute=722;c.icircumflex=278;\nc.Ecircumflex=667;c.adieresis=500;c.edieresis=444;c.cacute=444;c.nacute=556;c.umacron=556;c.Ncaron=722;c.Iacute=389;c.plusminus=570;c.brokenbar=220;c.registered=747;c.Gbreve=722;c.Idotaccent=389;c.summation=600;c.Egrave=667;c.racute=389;c.omacron=500;c.Zacute=611;c.Zcaron=611;c.greaterequal=549;c.Eth=722;c.Ccedilla=667;c.lcommaaccent=278;c.tcaron=366;c.eogonek=444;c.Uogonek=722;c.Aacute=667;c.Adieresis=667;c.egrave=444;c.zacute=389;c.iogonek=278;c.Oacute=722;c.oacute=500;c.amacron=500;c.sacute=389;\nc.idieresis=278;c.Ocircumflex=722;c.Ugrave=722;c.Delta=612;c.thorn=500;c.twosuperior=300;c.Odieresis=722;c.mu=576;c.igrave=278;c.ohungarumlaut=500;c.Eogonek=667;c.dcroat=500;c.threequarters=750;c.Scedilla=556;c.lcaron=382;c.Kcommaaccent=667;c.Lacute=611;c.trademark=1E3;c.edotaccent=444;c.Igrave=389;c.Imacron=389;c.Lcaron=611;c.onehalf=750;c.lessequal=549;c.ocircumflex=500;c.ntilde=556;c.Uhungarumlaut=722;c.Eacute=667;c.emacron=444;c.gbreve=500;c.onequarter=750;c.Scaron=556;c.Scommaaccent=556;c.Ohungarumlaut=\n722;c.degree=400;c.ograve=500;c.Ccaron=667;c.ugrave=556;c.radical=549;c.Dcaron=722;c.rcommaaccent=389;c.Ntilde=722;c.otilde=500;c.Rcommaaccent=667;c.Lcommaaccent=611;c.Atilde=667;c.Aogonek=667;c.Aring=667;c.Otilde=722;c.zdotaccent=389;c.Ecaron=667;c.Iogonek=389;c.kcommaaccent=500;c.minus=606;c.Icircumflex=389;c.ncaron=556;c.tcommaaccent=278;c.logicalnot=606;c.odieresis=500;c.udieresis=556;c.notequal=549;c.gcommaaccent=500;c.eth=500;c.zcaron=389;c.ncommaaccent=556;c.onesuperior=300;c.imacron=278;c.Euro=\n500});a["Times-Italic"]=xb(function(c){c.space=250;c.exclam=333;c.quotedbl=420;c.numbersign=500;c.dollar=500;c.percent=833;c.ampersand=778;c.quoteright=333;c.parenleft=333;c.parenright=333;c.asterisk=500;c.plus=675;c.comma=250;c.hyphen=333;c.period=250;c.slash=278;c.zero=500;c.one=500;c.two=500;c.three=500;c.four=500;c.five=500;c.six=500;c.seven=500;c.eight=500;c.nine=500;c.colon=333;c.semicolon=333;c.less=675;c.equal=675;c.greater=675;c.question=500;c.at=920;c.A=611;c.B=611;c.C=667;c.D=722;c.E=611;\nc.F=611;c.G=722;c.H=722;c.I=333;c.J=444;c.K=667;c.L=556;c.M=833;c.N=667;c.O=722;c.P=611;c.Q=722;c.R=611;c.S=500;c.T=556;c.U=722;c.V=611;c.W=833;c.X=611;c.Y=556;c.Z=556;c.bracketleft=389;c.backslash=278;c.bracketright=389;c.asciicircum=422;c.underscore=500;c.quoteleft=333;c.a=500;c.b=500;c.c=444;c.d=500;c.e=444;c.f=278;c.g=500;c.h=500;c.i=278;c.j=278;c.k=444;c.l=278;c.m=722;c.n=500;c.o=500;c.p=500;c.q=500;c.r=389;c.s=389;c.t=278;c.u=500;c.v=444;c.w=667;c.x=444;c.y=444;c.z=389;c.braceleft=400;c.bar=\n275;c.braceright=400;c.asciitilde=541;c.exclamdown=389;c.cent=500;c.sterling=500;c.fraction=167;c.yen=500;c.florin=500;c.section=500;c.currency=500;c.quotesingle=214;c.quotedblleft=556;c.guillemotleft=500;c.guilsinglleft=333;c.guilsinglright=333;c.fi=500;c.fl=500;c.endash=500;c.dagger=500;c.daggerdbl=500;c.periodcentered=250;c.paragraph=523;c.bullet=350;c.quotesinglbase=333;c.quotedblbase=556;c.quotedblright=556;c.guillemotright=500;c.ellipsis=889;c.perthousand=1E3;c.questiondown=500;c.grave=333;\nc.acute=333;c.circumflex=333;c.tilde=333;c.macron=333;c.breve=333;c.dotaccent=333;c.dieresis=333;c.ring=333;c.cedilla=333;c.hungarumlaut=333;c.ogonek=333;c.caron=333;c.emdash=889;c.AE=889;c.ordfeminine=276;c.Lslash=556;c.Oslash=722;c.OE=944;c.ordmasculine=310;c.ae=667;c.dotlessi=278;c.lslash=278;c.oslash=500;c.oe=667;c.germandbls=500;c.Idieresis=333;c.eacute=444;c.abreve=500;c.uhungarumlaut=500;c.ecaron=444;c.Ydieresis=556;c.divide=675;c.Yacute=556;c.Acircumflex=611;c.aacute=500;c.Ucircumflex=722;\nc.yacute=444;c.scommaaccent=389;c.ecircumflex=444;c.Uring=722;c.Udieresis=722;c.aogonek=500;c.Uacute=722;c.uogonek=500;c.Edieresis=611;c.Dcroat=722;c.commaaccent=250;c.copyright=760;c.Emacron=611;c.ccaron=444;c.aring=500;c.Ncommaaccent=667;c.lacute=278;c.agrave=500;c.Tcommaaccent=556;c.Cacute=667;c.atilde=500;c.Edotaccent=611;c.scaron=389;c.scedilla=389;c.iacute=278;c.lozenge=471;c.Rcaron=611;c.Gcommaaccent=722;c.ucircumflex=500;c.acircumflex=500;c.Amacron=611;c.rcaron=389;c.ccedilla=444;c.Zdotaccent=\n556;c.Thorn=611;c.Omacron=722;c.Racute=611;c.Sacute=500;c.dcaron=544;c.Umacron=722;c.uring=500;c.threesuperior=300;c.Ograve=722;c.Agrave=611;c.Abreve=611;c.multiply=675;c.uacute=500;c.Tcaron=556;c.partialdiff=476;c.ydieresis=444;c.Nacute=667;c.icircumflex=278;c.Ecircumflex=611;c.adieresis=500;c.edieresis=444;c.cacute=444;c.nacute=500;c.umacron=500;c.Ncaron=667;c.Iacute=333;c.plusminus=675;c.brokenbar=275;c.registered=760;c.Gbreve=722;c.Idotaccent=333;c.summation=600;c.Egrave=611;c.racute=389;c.omacron=\n500;c.Zacute=556;c.Zcaron=556;c.greaterequal=549;c.Eth=722;c.Ccedilla=667;c.lcommaaccent=278;c.tcaron=300;c.eogonek=444;c.Uogonek=722;c.Aacute=611;c.Adieresis=611;c.egrave=444;c.zacute=389;c.iogonek=278;c.Oacute=722;c.oacute=500;c.amacron=500;c.sacute=389;c.idieresis=278;c.Ocircumflex=722;c.Ugrave=722;c.Delta=612;c.thorn=500;c.twosuperior=300;c.Odieresis=722;c.mu=500;c.igrave=278;c.ohungarumlaut=500;c.Eogonek=611;c.dcroat=500;c.threequarters=750;c.Scedilla=500;c.lcaron=300;c.Kcommaaccent=667;c.Lacute=\n556;c.trademark=980;c.edotaccent=444;c.Igrave=333;c.Imacron=333;c.Lcaron=611;c.onehalf=750;c.lessequal=549;c.ocircumflex=500;c.ntilde=500;c.Uhungarumlaut=722;c.Eacute=611;c.emacron=444;c.gbreve=500;c.onequarter=750;c.Scaron=500;c.Scommaaccent=500;c.Ohungarumlaut=722;c.degree=400;c.ograve=500;c.Ccaron=667;c.ugrave=500;c.radical=453;c.Dcaron=722;c.rcommaaccent=389;c.Ntilde=667;c.otilde=500;c.Rcommaaccent=611;c.Lcommaaccent=556;c.Atilde=611;c.Aogonek=611;c.Aring=611;c.Otilde=722;c.zdotaccent=389;c.Ecaron=\n611;c.Iogonek=333;c.kcommaaccent=444;c.minus=675;c.Icircumflex=333;c.ncaron=500;c.tcommaaccent=278;c.logicalnot=675;c.odieresis=500;c.udieresis=500;c.notequal=549;c.gcommaaccent=500;c.eth=500;c.zcaron=389;c.ncommaaccent=500;c.onesuperior=300;c.imacron=278;c.Euro=500});a.ZapfDingbats=xb(function(c){c.space=278;c.a1=974;c.a2=961;c.a202=974;c.a3=980;c.a4=719;c.a5=789;c.a119=790;c.a118=791;c.a117=690;c.a11=960;c.a12=939;c.a13=549;c.a14=855;c.a15=911;c.a16=933;c.a105=911;c.a17=945;c.a18=974;c.a19=755;\nc.a20=846;c.a21=762;c.a22=761;c.a23=571;c.a24=677;c.a25=763;c.a26=760;c.a27=759;c.a28=754;c.a6=494;c.a7=552;c.a8=537;c.a9=577;c.a10=692;c.a29=786;c.a30=788;c.a31=788;c.a32=790;c.a33=793;c.a34=794;c.a35=816;c.a36=823;c.a37=789;c.a38=841;c.a39=823;c.a40=833;c.a41=816;c.a42=831;c.a43=923;c.a44=744;c.a45=723;c.a46=749;c.a47=790;c.a48=792;c.a49=695;c.a50=776;c.a51=768;c.a52=792;c.a53=759;c.a54=707;c.a55=708;c.a56=682;c.a57=701;c.a58=826;c.a59=815;c.a60=789;c.a61=789;c.a62=707;c.a63=687;c.a64=696;c.a65=\n689;c.a66=786;c.a67=787;c.a68=713;c.a69=791;c.a70=785;c.a71=791;c.a72=873;c.a73=761;c.a74=762;c.a203=762;c.a75=759;c.a204=759;c.a76=892;c.a77=892;c.a78=788;c.a79=784;c.a81=438;c.a82=138;c.a83=277;c.a84=415;c.a97=392;c.a98=392;c.a99=668;c.a100=668;c.a89=390;c.a90=390;c.a93=317;c.a94=317;c.a91=276;c.a92=276;c.a205=509;c.a85=509;c.a206=410;c.a86=410;c.a87=234;c.a88=234;c.a95=334;c.a96=334;c.a101=732;c.a102=544;c.a103=544;c.a104=910;c.a106=667;c.a107=760;c.a108=760;c.a112=776;c.a111=595;c.a110=694;c.a109=\n626;c.a120=788;c.a121=788;c.a122=788;c.a123=788;c.a124=788;c.a125=788;c.a126=788;c.a127=788;c.a128=788;c.a129=788;c.a130=788;c.a131=788;c.a132=788;c.a133=788;c.a134=788;c.a135=788;c.a136=788;c.a137=788;c.a138=788;c.a139=788;c.a140=788;c.a141=788;c.a142=788;c.a143=788;c.a144=788;c.a145=788;c.a146=788;c.a147=788;c.a148=788;c.a149=788;c.a150=788;c.a151=788;c.a152=788;c.a153=788;c.a154=788;c.a155=788;c.a156=788;c.a157=788;c.a158=788;c.a159=788;c.a160=894;c.a161=838;c.a163=1016;c.a164=458;c.a196=748;c.a165=\n924;c.a192=748;c.a166=918;c.a167=927;c.a168=928;c.a169=928;c.a170=834;c.a171=873;c.a172=828;c.a173=924;c.a162=924;c.a174=917;c.a175=930;c.a176=931;c.a177=463;c.a178=883;c.a179=836;c.a193=836;c.a180=867;c.a199=867;c.a181=696;c.a200=696;c.a182=874;c.a201=874;c.a183=760;c.a184=946;c.a197=771;c.a185=865;c.a194=771;c.a198=888;c.a186=967;c.a195=888;c.a187=831;c.a188=873;c.a189=927;c.a190=970;c.a191=918})}),ls=xb(function(a){a.Courier={ascent:629,descent:-157,capHeight:562,xHeight:-426};a["Courier-Bold"]=\n{ascent:629,descent:-157,capHeight:562,xHeight:439};a["Courier-Oblique"]={ascent:629,descent:-157,capHeight:562,xHeight:426};a["Courier-BoldOblique"]={ascent:629,descent:-157,capHeight:562,xHeight:426};a.Helvetica={ascent:718,descent:-207,capHeight:718,xHeight:523};a["Helvetica-Bold"]={ascent:718,descent:-207,capHeight:718,xHeight:532};a["Helvetica-Oblique"]={ascent:718,descent:-207,capHeight:718,xHeight:523};a["Helvetica-BoldOblique"]={ascent:718,descent:-207,capHeight:718,xHeight:532};a["Times-Roman"]=\n{ascent:683,descent:-217,capHeight:662,xHeight:450};a["Times-Bold"]={ascent:683,descent:-217,capHeight:676,xHeight:461};a["Times-Italic"]={ascent:683,descent:-217,capHeight:653,xHeight:441};a["Times-BoldItalic"]={ascent:683,descent:-217,capHeight:669,xHeight:462};a.Symbol={ascent:Math.NaN,descent:Math.NaN,capHeight:Math.NaN,xHeight:Math.NaN};a.ZapfDingbats={ascent:Math.NaN,descent:Math.NaN,capHeight:Math.NaN,xHeight:Math.NaN}}),ms=function(){function a(b){var d=b.glyfTable,e=b.isGlyphLocationsLong,\ng=b.locaTable;b=b.numGlyphs;this.glyphs=[];g=new DataView(g.buffer,g.byteOffset,g.byteLength);d=new DataView(d.buffer,d.byteOffset,d.byteLength);for(var f=e?4:2,h=e?g.getUint32(0):2*g.getUint16(0),k=0,l=0;l<b;l++){k+=f;var m=e?g.getUint32(k):2*g.getUint16(k);m===h?this.glyphs.push(new Sn({})):(h=Sn.parse(h,d),this.glyphs.push(h),h=m)}}var c=a.prototype;c.getSize=function(){return this.glyphs.reduce(function(b,d){d=d.getSize();return b+(d+3&-4)},0)};c.write=function(){var b=this.getSize(),d=new DataView(new ArrayBuffer(b)),\ne=(b=131070<b)?4:2,g=new DataView(new ArrayBuffer((this.glyphs.length+1)*e));b?g.setUint32(0,0):g.setUint16(0,0);for(var f=0,h=0,k=u.makeIterator(this.glyphs),l=k.next();!l.done;l=k.next())f+=l.value.write(f,d),f=f+3&-4,h+=e,b?g.setUint32(h,f):g.setUint16(h,f>>1);return{isLocationLong:b,loca:new Uint8Array(g.buffer),glyf:new Uint8Array(d.buffer)}};c.scale=function(b){for(var d=0,e=this.glyphs.length;d<e;d++)this.glyphs[d].scale(b[d])};return a}(),Sn=function(){function a(b){var d=void 0===b.simple?\nnull:b.simple,e=void 0===b.composites?null:b.composites;this.header=void 0===b.header?null:b.header;this.simple=d;this.composites=e}a.parse=function(b,d){var e=u.makeIterator(ns.parse(b,d)),g=e.next().value;e=e.next().value;b+=g;if(0>e.numberOfContours){for(g=[];;){var f=u.makeIterator(os.parse(b,d)),h=f.next().value;f=f.next().value;b+=h;g.push(f);if(!(f.flags&32))break}return new a({header:e,composites:g})}b=ps.parse(b,d,e.numberOfContours);return new a({header:e,simple:b})};var c=a.prototype;c.getSize=\nfunction(){if(!this.header)return 0;var b=this.simple?this.simple.getSize():this.composites.reduce(function(d,e){return d+e.getSize()},0);return this.header.getSize()+b};c.write=function(b,d){if(!this.header)return 0;var e=b;b+=this.header.write(b,d);if(this.simple)b+=this.simple.write(b,d);else for(var g=u.makeIterator(this.composites),f=g.next();!f.done;f=g.next())b+=f.value.write(b,d);return b-e};c.scale=function(b){if(this.header){var d=(this.header.xMin+this.header.xMax)/2;this.header.scale(d,\nb);if(this.simple)this.simple.scale(d,b);else for(var e=u.makeIterator(this.composites),g=e.next();!g.done;g=e.next())g.value.scale(d,b)}};return a}(),ns=function(){function a(b){var d=b.xMin,e=b.yMin,g=b.xMax,f=b.yMax;this.numberOfContours=b.numberOfContours;this.xMin=d;this.yMin=e;this.xMax=g;this.yMax=f}a.parse=function(b,d){return[10,new a({numberOfContours:d.getInt16(b),xMin:d.getInt16(b+2),yMin:d.getInt16(b+4),xMax:d.getInt16(b+6),yMax:d.getInt16(b+8)})]};var c=a.prototype;c.getSize=function(){return 10};\nc.write=function(b,d){d.setInt16(b,this.numberOfContours);d.setInt16(b+2,this.xMin);d.setInt16(b+4,this.yMin);d.setInt16(b+6,this.xMax);d.setInt16(b+8,this.yMax);return 10};c.scale=function(b,d){this.xMin=Math.round(b+(this.xMin-b)*d);this.xMax=Math.round(b+(this.xMax-b)*d)};return a}(),ps=function(){function a(b){var d=b.instructions;this.contours=b.contours;this.instructions=d}a.parse=function(b,d,e){for(var g=[],f=0;f<e;f++){var h=d.getUint16(b);b+=2;g.push(h)}e=g[e-1]+1;h=d.getUint16(b);b+=2;\nf=(new Uint8Array(d)).slice(b,b+h);b+=h;h=[];for(var k=0;k<e;b++,k++){var l=d.getUint8(b);h.push(l);if(l&8){var m=d.getUint8(++b);l^=8;for(var n=0;n<m;n++)h.push(l);k+=m}}k=[];var p=[];l=[];m=[];n=[];for(var q=0,r=0,t=0;t<e;t++){var v=h[t];if(v&2){var w=d.getUint8(b++);r+=v&16?w:-w}else v&16||(r+=d.getInt16(b),b+=2);p.push(r);g[q]===t&&(q++,k.push(p),p=[])}for(t=q=r=0;t<e;t++)p=h[t],p&4?(v=d.getUint8(b++),r+=p&32?v:-v):p&32||(r+=d.getInt16(b),b+=2),l.push(r),m.push(p&1|p&64),g[q]===t&&(p=k[q],q++,\nn.push(new sa({flags:m,xCoordinates:p,yCoordinates:l})),l=[],m=[]);return new a({contours:n,instructions:f})};var c=a.prototype;c.getSize=function(){for(var b=2*this.contours.length+2+this.instructions.length,d=0,e=0,g=u.makeIterator(this.contours),f=g.next();!f.done;f=g.next()){f=f.value;b+=f.flags.length;for(var h=0,k=f.xCoordinates.length;h<k;h++){var l=f.xCoordinates[h],m=f.yCoordinates[h],n=Math.abs(l-d);255<n?b+=2:0<n&&(b+=1);d=l;n=Math.abs(m-e);255<n?b+=2:0<n&&(b+=1);e=m}}return b};c.write=\nfunction(b,d){for(var e=b,g=[],f=[],h=[],k=0,l=0,m=u.makeIterator(this.contours),n=m.next();!n.done;n=m.next()){n=n.value;for(var p=0,q=n.xCoordinates.length;p<q;p++){var r=n.flags[p],t=n.xCoordinates[p],v=t-k;0===v?(r|=16,g.push(0)):(k=Math.abs(v),255>=k?(r|=0<=v?18:2,g.push(k)):g.push(v));k=t;t=n.yCoordinates[p];v=t-l;0===v?(r|=32,f.push(0)):(l=Math.abs(v),255>=l?(r|=0<=v?36:4,f.push(l)):f.push(v));l=t;h.push(r)}d.setUint16(b,g.length-1);b+=2}d.setUint16(b,this.instructions.length);b+=2;this.instructions.length&&\n((new Uint8Array(d.buffer,0,d.buffer.byteLength)).set(this.instructions,b),b+=this.instructions.length);m=u.makeIterator(h);for(k=m.next();!k.done;k=m.next())k=k.value,d.setUint8(b++,k);m=0;for(k=g.length;m<k;m++)l=g[m],n=h[m],n&2?d.setUint8(b++,l):n&16||(d.setInt16(b,l),b+=2);g=0;for(m=f.length;g<m;g++)k=f[g],l=h[g],l&4?d.setUint8(b++,k):l&32||(d.setInt16(b,k),b+=2);return b-e};c.scale=function(b,d){for(var e=u.makeIterator(this.contours),g=e.next();!g.done;g=e.next())if(g=g.value,0!==g.xCoordinates.length)for(var f=\n0,h=g.xCoordinates.length;f<h;f++)g.xCoordinates[f]=Math.round(b+(g.xCoordinates[f]-b)*d)};return a}(),os=function(){function a(b){var d=b.glyphIndex,e=b.argument1,g=b.argument2,f=b.transf,h=b.instructions;this.flags=b.flags;this.glyphIndex=d;this.argument1=e;this.argument2=g;this.transf=f;this.instructions=h}a.parse=function(b,d){var e=b,g=[],f=d.getUint16(b),h=d.getUint16(b+2);b+=4;if(f&1){if(f&2){var k=d.getInt16(b);var l=d.getInt16(b+2)}else k=d.getUint16(b),l=d.getUint16(b+2);b+=4;f^=1}else f&\n2?(k=d.getInt8(b),l=d.getInt8(b+1)):(k=d.getUint8(b),l=d.getUint8(b+1)),b+=2;f&8?(g.push(d.getUint16(b)),b+=2):f&64?(g.push(d.getUint16(b),d.getUint16(b+2)),b+=4):f&128&&(g.push(d.getUint16(b),d.getUint16(b+2),d.getUint16(b+4),d.getUint16(b+6)),b+=8);var m=null;if(f&256){var n=d.getUint16(b);b+=2;m=(new Uint8Array(d)).slice(b,b+n);b+=n}return[b-e,new a({flags:f,glyphIndex:h,argument1:k,argument2:l,transf:g,instructions:m})]};var c=a.prototype;c.getSize=function(){var b=4+2*this.transf.length;this.flags&\n256&&(b+=2+this.instructions.length);b+=2;this.flags&2?-128<=this.argument1&&127>=this.argument1&&-128<=this.argument2&&127>=this.argument2||(b+=2):0<=this.argument1&&255>=this.argument1&&0<=this.argument2&&255>=this.argument2||(b+=2);return b};c.write=function(b,d){var e=b;this.flags&2?-128<=this.argument1&&127>=this.argument1&&-128<=this.argument2&&127>=this.argument2||(this.flags|=1):0<=this.argument1&&255>=this.argument1&&0<=this.argument2&&255>=this.argument2||(this.flags|=1);d.setUint16(b,this.flags);\nd.setUint16(b+2,this.glyphIndex);b+=4;this.flags&1?(this.flags&2?(d.setInt16(b,this.argument1),d.setInt16(b+2,this.argument2)):(d.setUint16(b,this.argument1),d.setUint16(b+2,this.argument2)),b+=4):(d.setUint8(b,this.argument1),d.setUint8(b+1,this.argument2),b+=2);this.flags&256&&(d.setUint16(b,this.instructions.length),b+=2,this.instructions.length&&((new Uint8Array(d.buffer,0,d.buffer.byteLength)).set(this.instructions,b),b+=this.instructions.length));return b-e};c.scale=function(){};return a}(),\n$h=function(){function a(b){this.sfnt=b;this.tables=Object.create(null)}a.getSearchParams=function(b,d){for(var e=1,g=0;(e^b)>e;)e<<=1,g++;e*=d;return{range:e,entry:g,rangeShift:d*b-e}};var c=a.prototype;c.toArray=function(){var b=this.sfnt,d=this.tables,e=Object.keys(d);e.sort();var g=e.length,f,h=12+16*g,k=[h];for(f=0;f<g;f++){var l=d[e[f]];h+=(l.length+3&-4)>>>0;k.push(h)}var m=new Uint8Array(h);for(f=0;f<g;f++){l=d[e[f]];h=m;var n=k[f];if(l instanceof Uint8Array)h.set(l,n);else if("string"===\ntypeof l)for(var p=0,q=l.length;p<q;p++)h[n++]=l.charCodeAt(p)&255;else for(l=u.makeIterator(l),p=l.next();!p.done;p=l.next())p=p.value,h[n++]=p&255}"true"===b&&(b=kc(65536));m[0]=b.charCodeAt(0)&255;m[1]=b.charCodeAt(1)&255;m[2]=b.charCodeAt(2)&255;m[3]=b.charCodeAt(3)&255;lg(m,4,g);f=a.getSearchParams(g,16);lg(m,6,f.range);lg(m,8,f.entry);lg(m,10,f.rangeShift);h=12;for(f=0;f<g;f++){l=e[f];m[h]=l.charCodeAt(0)&255;m[h+1]=l.charCodeAt(1)&255;m[h+2]=l.charCodeAt(2)&255;m[h+3]=l.charCodeAt(3)&255;p=\n0;b=k[f];for(n=k[f+1];b<n;b+=4)q=zb(m,b),p=p+q>>>0;Wh(m,h+4,p);Wh(m,h+8,k[f]);Wh(m,h+12,d[l].length);h+=16}return m};c.addTable=function(b,d){if(b in this.tables)throw Error("Table "+b+" already exists");this.tables[b]=d};return a}(),qs=[4],rs=[5],ss=[6],ts=[7],us=[8],vs=[12,35],vj=[14],Tn=[21],Un=[22],ws=[30],xs=[31],ys=function(){function a(){this.lsb=this.width=0;this.flexing=!1;this.output=[];this.stack=[]}var c=a.prototype;c.convert=function(b,d,e){for(var g=b.length,f=!1,h,k=0;k<g;k++)if(h=\nb[k],32>h){12===h&&(h=(h<<8)+b[++k]);switch(h){case 1:this.stack=[];break;case 3:this.stack=[];break;case 4:if(this.flexing){if(1>this.stack.length){f=!0;break}h=this.stack.pop();this.stack.push(0,h);break}f=this.executeCommand(1,qs);break;case 5:f=this.executeCommand(2,rs);break;case 6:f=this.executeCommand(1,ss);break;case 7:f=this.executeCommand(1,ts);break;case 8:f=this.executeCommand(6,us);break;case 9:this.stack=[];break;case 10:if(1>this.stack.length){f=!0;break}h=this.stack.pop();if(!d[h]){f=\n!0;break}f=this.convert(d[h],d,e);break;case 11:return f;case 13:if(2>this.stack.length){f=!0;break}f=this.stack.pop();this.lsb=h=this.stack.pop();this.width=f;this.stack.push(f,h);f=this.executeCommand(2,Un);break;case 14:this.output.push(vj[0]);break;case 21:if(this.flexing)break;f=this.executeCommand(2,Tn);break;case 22:if(this.flexing){this.stack.push(0);break}f=this.executeCommand(1,Un);break;case 30:f=this.executeCommand(4,ws);break;case 31:f=this.executeCommand(4,xs);break;case 3072:this.stack=\n[];break;case 3073:this.stack=[];break;case 3074:this.stack=[];break;case 3078:e?(f=this.stack.at(-5),this.seac=this.stack.splice(-4,4),this.seac[0]+=this.lsb-f,f=this.executeCommand(0,vj)):f=this.executeCommand(4,vj);break;case 3079:if(4>this.stack.length){f=!0;break}this.stack.pop();f=this.stack.pop();var l=this.stack.pop();this.lsb=h=this.stack.pop();this.width=f;this.stack.push(f,h,l);f=this.executeCommand(3,Tn);break;case 3084:if(2>this.stack.length){f=!0;break}h=this.stack.pop();l=this.stack.pop();\nthis.stack.push(l/h);break;case 3088:if(2>this.stack.length){f=!0;break}h=this.stack.pop();l=this.stack.pop();0===h&&3===l?(h=this.stack.splice(-17,17),this.stack.push(h[2]+h[0],h[3]+h[1],h[4],h[5],h[6],h[7],h[8],h[9],h[10],h[11],h[12],h[13],h[14]),f=this.executeCommand(13,vs,!0),this.flexing=!1,this.stack.push(h[15],h[16])):1===h&&0===l&&(this.flexing=!0);break;case 3089:break;case 3105:this.stack=[];break;default:T(\'Unknown type 1 charstring command of "\'+h+\'"\')}if(f)break}else h=246>=h?h-139:250>=\nh?256*(h-247)+b[++k]+108:254>=h?-(256*(h-251))-b[++k]-108:(b[++k]&255)<<24|(b[++k]&255)<<16|(b[++k]&255)<<8|(b[++k]&255)<<0,this.stack.push(h);return f};c.executeCommand=function(b,d,e){var g=this.stack.length;if(b>g)return!0;for(var f=g-b,h=f;h<g;h++){var k=this.stack[h];Number.isInteger(k)?this.output.push(28,k>>8&255,k&255):(k=65536*k|0,this.output.push(255,k>>24&255,k>>16&255,k>>8&255,k&255))}this.output.push.apply(this.output,u.arrayFromIterable(d));e?this.stack.splice(f,b):this.stack.length=\n0;return!1};return a}(),Vn=function(){function a(b,d,e){if(d){b=b.getBytes();if((vd(b[0])||Lc(b[0]))&&vd(b[1])&&vd(b[2])&&vd(b[3])&&vd(b[4])&&vd(b[5])&&vd(b[6])&&vd(b[7])){d=55665;var g=b.length,f=new Uint8Array(g>>>1),h,k;for(k=h=0;h<g;h++){var l=b[h];if(vd(l)){h++;for(var m=void 0;h<g&&!vd(m=b[h]);)h++;h<g&&(l=parseInt(String.fromCharCode(l,m),16),f[k++]=l^d>>8,d=52845*(l+d)+22719&65535)}}b=f.slice(4,k)}else b=hl(b,55665,4);b=new Mb(b)}this.seacAnalysisEnabled=!!e;this.stream=b;this.nextChar()}\nvar c=a.prototype;c.readNumberArray=function(){this.getToken();for(var b=[];;){var d=this.getToken();if(null===d||"]"===d||"}"===d)break;b.push(parseFloat(d||0))}return b};c.readNumber=function(){var b=this.getToken();return parseFloat(b||0)};c.readInt=function(){var b=this.getToken();return parseInt(b||0,10)|0};c.readBoolean=function(){return"true"===this.getToken()?1:0};c.nextChar=function(){return this.currentChar=this.stream.getByte()};c.prevChar=function(){this.stream.skip(-2);return this.currentChar=\nthis.stream.getByte()};c.getToken=function(){for(var b=!1,d=this.currentChar;;){if(-1===d)return null;if(b){if(10===d||13===d)b=!1}else if(37===d)b=!0;else if(!Lc(d))break;d=this.nextChar()}if(il(d))return this.nextChar(),String.fromCharCode(d);b="";do b+=String.fromCharCode(d),d=this.nextChar();while(0<=d&&!Lc(d)&&!il(d));return b};c.readCharStrings=function(b,d){return-1===d?b:hl(b,4330,d)};c.extractFontProgram=function(b){var d=this.stream,e=[],g=[],f=Object.create(null);f.lenIV=4;f={subrs:[],\ncharstrings:[],properties:{privateData:f}};for(var h,k;null!==(h=this.getToken());)if("/"===h)switch(h=this.getToken(),h){case "CharStrings":this.getToken();this.getToken();this.getToken();for(this.getToken();;){h=this.getToken();if(null===h||"end"===h)break;if("/"===h){var l=this.getToken();h=this.readInt();this.getToken();h=0<h?d.getBytes(h):new Uint8Array(0);k=f.properties.privateData.lenIV;k=this.readCharStrings(h,k);this.nextChar();h=this.getToken();"noaccess"===h?this.getToken():"/"===h&&this.prevChar();\ng.push({glyph:l,encoded:k})}}break;case "Subrs":this.readInt();for(this.getToken();"dup"===this.getToken();)l=this.readInt(),h=this.readInt(),this.getToken(),h=0<h?d.getBytes(h):new Uint8Array(0),k=f.properties.privateData.lenIV,k=this.readCharStrings(h,k),this.nextChar(),h=this.getToken(),"noaccess"===h&&this.getToken(),e[l]=k;break;case "BlueValues":case "OtherBlues":case "FamilyBlues":case "FamilyOtherBlues":this.readNumberArray();break;case "StemSnapH":case "StemSnapV":f.properties.privateData[h]=\nthis.readNumberArray();break;case "StdHW":case "StdVW":f.properties.privateData[h]=this.readNumberArray()[0];break;case "BlueShift":case "lenIV":case "BlueFuzz":case "BlueScale":case "LanguageGroup":f.properties.privateData[h]=this.readNumber();break;case "ExpansionFactor":f.properties.privateData[h]=this.readNumber()||.06;break;case "ForceBold":f.properties.privateData[h]=this.readBoolean()}d=u.makeIterator(g);for(g=d.next();!g.done;g=d.next())g=g.value,h=g.encoded,l=g.glyph,g=new ys,h=g.convert(h,\ne,this.seacAnalysisEnabled),k=g.output,h&&(k=[14]),h={glyphName:l,charstring:k,width:g.width,lsb:g.lsb,seac:g.seac},".notdef"===l?f.charstrings.unshift(h):f.charstrings.push(h),b.builtInEncoding&&(l=b.builtInEncoding.indexOf(l),-1<l&&void 0===b.widths[l]&&l>=b.firstChar&&l<=b.lastChar&&(b.widths[l]=g.width));return f};c.extractFontHeader=function(b){for(var d;null!==(d=this.getToken());)if("/"===d)switch(d=this.getToken(),d){case "FontMatrix":var e=this.readNumberArray();b.fontMatrix=e;break;case "Encoding":var g=\nthis.getToken();if(/^\\d+$/.test(g)){e=[];g=parseInt(g,10)|0;this.getToken();for(var f=0;f<g;f++){for(d=this.getToken();"dup"!==d&&"def"!==d;)if(d=this.getToken(),null===d)return;if("def"===d)break;d=this.readInt();this.getToken();var h=this.getToken();e[d]=h;this.getToken()}}else e=hf(g);b.builtInEncoding=e;break;case "FontBBox":e=this.readNumberArray(),b.ascent=Math.max(e[3],e[1]),b.descent=Math.min(e[1],e[3]),b.ascentScaled=!0}};return a}(),zs=function(){function a(b,d,e){var g=e.length1,f=d.peekBytes(6),\nh=128===f[0]&&1===f[1];h&&(d.skip(6),g=f[5]<<24|f[4]<<16|f[3]<<8|f[2]);a:{f=[101,101,120,101,99];var k=d.pos;try{var l=d.getBytes(g);var m=l.length}catch(q){}if(m===g&&(m=kl(l,f,g-2*f.length),m.found&&m.length===g)){var n=new Mb(l);break a}T(\'Invalid "Length1" property in Type1 font -- trying to recover.\');for(d.pos=k;;){l=d.peekBytes(2048);m=kl(l,f,0);if(0===m.length)break;d.pos+=m.length;if(m.found){n=d.pos-k;break}}d.pos=k;n?n=new Mb(d.getBytes(n)):(T(\'Unable to recover "Length1" property in Type1 font -- using as is.\'),\nn=new Mb(d.getBytes(g)))}(new Vn(n,!1,!0)).extractFontHeader(e);h&&d.getBytes(6);d=d.getBytes();if(0===d.length)throw new oa("getEexecBlock - no font program found.");d=new Mb(d);d=(new Vn(d,!0,!0)).extractFontProgram(e);for(var p in d.properties)e[p]=d.properties[p];p=d.charstrings;h=this.getType2Charstrings(p);n=this.getType2Subrs(d.subrs);this.charstrings=p;this.data=this.wrap(b,h,this.charstrings,n,e);this.seacs=this.getSeacs(d.charstrings)}var c=a.prototype;c.getCharset=function(){for(var b=\n[".notdef"],d=u.makeIterator(this.charstrings),e=d.next();!e.done;e=d.next())b.push(e.value.glyphName);return b};c.getGlyphMapping=function(b){var d=this.charstrings;if(b.composite){var e=Object.create(null),g=0;for(d=d.length;g<d;g++){var f=b.cMap.charCodeOf(g);e[f]=g+1}return e}e=[".notdef"];for(f=0;f<d.length;f++)e.push(d[f].glyphName);if(d=b.builtInEncoding){g=Object.create(null);for(var h in d)f=e.indexOf(d[h]),0<=f&&(g[h]=f)}return Zk(b,g,e)};c.hasGlyphId=function(b){return 0>b||b>=this.numGlyphs?\n!1:0===b?!0:0<this.charstrings[b-1].charstring.length};c.getSeacs=function(b){for(var d=[],e=0,g=b.length;e<g;e++){var f=b[e];f.seac&&(d[e+1]=f.seac)}return d};c.getType2Charstrings=function(b){var d=[];b=u.makeIterator(b);for(var e=b.next();!e.done;e=b.next())d.push(e.value.charstring);return d};c.getType2Subrs=function(b){var d=b.length;var e=1133>d?107:33769>d?1131:32768;var g=[],f;for(f=0;f<e;f++)g.push([11]);for(f=0;f<d;f++)g.push(b[f]);return g};c.wrap=function(b,d,e,g,f){var h=new Ln;h.header=\nnew Oa(1,0,4,4);h.names=[b];var k=new oj;k.setByName("version",391);k.setByName("Notice",392);k.setByName("FullName",393);k.setByName("FamilyName",394);k.setByName("Weight",395);k.setByName("Encoding",null);k.setByName("FontMatrix",f.fontMatrix);k.setByName("FontBBox",f.bbox);k.setByName("charset",null);k.setByName("CharStrings",null);k.setByName("Private",null);h.topDict=k;k=new pj;k.add("Version 0.11");k.add("See original notice");k.add(b);k.add(b);k.add("Medium");h.strings=k;h.globalSubrIndex=\nnew Wd;var l=d.length,m=[".notdef"];for(b=0;b<l;b++){var n=e[b].glyphName;-1===Mg.indexOf(n)&&k.add(n);m.push(n)}h.charset=new Ba(!1,0,m);e=new Wd;e.add([139,14]);for(b=0;b<l;b++)e.add(d[b]);h.charStrings=e;e=new qj;e.setByName("Subrs",null);k="BlueValues OtherBlues FamilyBlues FamilyOtherBlues StemSnapH StemSnapV BlueShift BlueFuzz BlueScale LanguageGroup ExpansionFactor ForceBold StdHW StdVW".split(" ");b=0;for(d=k.length;b<d;b++)if(l=k[b],l in f.privateData){m=f.privateData[l];if(Array.isArray(m))for(n=\nm.length-1;0<n;n--)m[n]-=m[n-1];e.setByName(l,m)}h.topDict.privateDict=e;f=new Wd;b=0;for(d=g.length;b<d;b++)f.add(g[b]);e.subrsIndex=f;return(new tj(h)).compile()};return aq(a,[{key:"numGlyphs",get:function(){return this.charstrings.length+1}}])}(),Dd=[[57344,63743],[1048576,1114109]],Wn="ascent bbox black bold charProcOperatorList composite cssFontInfo data defaultVMetrics defaultWidth descent fallbackName fontMatrix isInvalidPDFjsFont isType3Font italic loadedName mimetype missingFile name remeasure subtype systemFontInfo type vertical".split(" "),\nAs="cMap defaultEncoding differences isMonospace isSerifFont isSymbolicFont seacMap toFontChar toUnicode vmetrics widths".split(" "),Bs=function(){return ml(function(a,c,b,d,e,g,f,h,k){this.originalCharCode=a;this.fontChar=c;this.unicode=b;this.accent=d;this.width=e;this.vmetric=g;this.operatorListId=f;this.isSpace=h;this.isInFont=k},[{key:"category",get:function(){var a=this.unicode;var c=ri.get(a);c?a=c:(c=a.match(bs),c={isWhitespace:!(null==c||!c[1]),isZeroWidthDiacritic:!(null==c||!c[2]),isInvisibleFormatMark:!(null==\nc||!c[3])},ri.set(a,c),a=c);return Fa(this,"category",a,!0)}}])}(),Xn=function(){function a(b,d,e){var g;this.name=b;this.mimetype=this.psName=null;this.disableFontFace=!1;this.loadedName=e.loadedName;this.isType3Font=e.isType3Font;this.missingFile=!1;this.cssFontInfo=e.cssFontInfo;this._charsCache=Object.create(null);this._glyphCache=Object.create(null);var f=!!(e.flags&Zc.Serif);if(!f&&!e.isSimulatedFlags){var h=b.replaceAll(/[,_]/g,"-").split("-",1)[0],k=Rh();h=u.makeIterator(h.split("+"));for(var l=\nh.next();!l.done;l=h.next())if(k[l.value]){f=!0;break}}this.isSerifFont=f;this.isSymbolicFont=!!(e.flags&Zc.Symbolic);this.isMonospace=!!(e.flags&Zc.FixedPitch);f=e.type;k=e.subtype;this.type=f;this.subtype=k;this.systemFontInfo=e.systemFontInfo;f=b.match(/^InvalidPDFjsFont_(.*)_\\d+$/);this.fallbackName=(this.isInvalidPDFjsFont=!!f)?f[1]:this.isMonospace?"monospace":this.isSerifFont?"serif":"sans-serif";null!=(g=this.systemFontInfo)&&g.guessFallback&&(this.systemFontInfo.guessFallback=!1,this.systemFontInfo.css+=\n","+this.fallbackName);this.differences=e.differences;this.widths=e.widths;this.defaultWidth=e.defaultWidth;this.composite=e.composite;this.cMap=e.cMap;this.capHeight=e.capHeight/1E3;this.ascent=e.ascent/1E3;this.descent=e.descent/1E3;this.lineHeight=this.ascent-this.descent;this.fontMatrix=e.fontMatrix;this.bbox=e.bbox;this.defaultEncoding=e.defaultEncoding;this.toUnicode=e.toUnicode;this.toFontChar=[];if("Type3"===e.type)for(b=0;256>b;b++)this.toFontChar[b]=this.differences[b]||e.defaultEncoding[b];\nelse{this.cidEncoding=e.cidEncoding||"";if(this.vertical=!!e.vertical)this.vmetrics=e.vmetrics,this.defaultVMetrics=e.defaultVMetrics;if(!d||d.isEmpty)d&&T(\'Font file is empty in "\'+b+\'" (\'+this.loadedName+")"),this.fallbackToSystemFont(e);else{g=u;f=g.makeIterator;h=e.type;k=e.subtype;l=e.composite;var m=d.peekBytes(4);if(65536===zb(m,0)||"true"===Ec(m)||ol(d))h=l?"CIDFontType2":"TrueType";else if(m=d.peekBytes(4),"OTTO"===Ec(m))h=l?"CIDFontType2":"OpenType";else if(m=d.peekBytes(2),37===m[0]&&33===\nm[1]||128===m[0]&&1===m[1])h=l?"CIDFontType0":"MMType1"===h?"MMType1":"Type1";else{var n=d.peekBytes(4);1<=n[0]&&1<=n[3]&&4>=n[3]?l?(h="CIDFontType0",n="CIDFontType0C"):(h="MMType1"===h?"MMType1":"Type1",n="Type1C"):(T("getFontFileType: Unable to detect correct font file Type/Subtype."),n=k)}n=f.call(g,[h,n]);f=n.next().value;k=n.next().value;f===this.type&&k===this.subtype||Ya("Inconsistent font file Type/SubType, expected: "+(this.type+"/"+this.subtype+" but found: "+f+"/"+k+"."));try{switch(f){case "MMType1":Ya("MMType1 font ("+\nb+"), falling back to Type1.");case "Type1":case "CIDFontType0":this.mimetype="font/opentype";var p="Type1C"===k||"CIDFontType0C"===k?new uj(d,e):new zs(b,d,e);Xh(e);var q=this.convert(b,p,e);break;case "OpenType":case "TrueType":case "CIDFontType2":this.mimetype="font/opentype";q=this.checkAndRepair(b,d,e);this.isOpenType&&(Xh(e),f="OpenType");break;default:throw new oa("Font "+f+" is not supported");}}catch(r){T(r);this.fallbackToSystemFont(e);return}nl(e);this.data=q;this.type=f;this.subtype=k;\nthis.fontMatrix=e.fontMatrix;this.widths=e.widths;this.defaultWidth=e.defaultWidth;this.toUnicode=e.toUnicode;this.seacMap=e.seacMap}}}var c=a.prototype;c.exportData=function(b){void 0===b&&(b=!1);var d=b?[].concat(u.arrayFromIterable(Wn),u.arrayFromIterable(As)):Wn;b=Object.create(null);var e;d=u.makeIterator(d);for(e=d.next();!e.done;e=d.next()){e=e.value;var g=this[e];void 0!==g&&(b[e]=g)}return b};c.fallbackToSystemFont=function(b){var d=this;this.missingFile=!0;var e=this.name,g=this.type,f=\nlf(e),h=jg(),k=bl(),l=!!h[f],m=!(!k[f]||!h[k[f]]);f=h[f]||k[f]||f;if(h=ls()[f])isNaN(this.ascent)&&(this.ascent=h.ascent/1E3),isNaN(this.descent)&&(this.descent=h.descent/1E3),isNaN(this.capHeight)&&(this.capHeight=h.capHeight/1E3);this.bold=/bold/gi.test(f);this.italic=/oblique|italic/gi.test(f);this.black=/Black/g.test(e);h=/Narrow/g.test(e);this.remeasure=(!l||h)&&0<Object.keys(this.widths).length;if((l||m)&&"CIDFontType2"===g&&this.cidEncoding.startsWith("Identity-")){var n=b.cidToGidMap,p=[];\nmg(p,Pn());/Arial-?Black/i.test(e)?mg(p,es()):/Calibri/i.test(e)&&mg(p,fs());if(n){for(var q in p)e=p[q],void 0!==n[e]&&(p[+q]=n[e]);n.length!==this.toUnicode.length&&b.hasIncludedToUnicodeMap&&this.toUnicode instanceof ad&&this.toUnicode.forEach(function(w,y){void 0===n[p[w]]&&(p[+w]=y)})}this.toUnicode instanceof ad||this.toUnicode.forEach(function(w,y){p[+w]=y});this.toFontChar=p;this.toUnicode=new xf(p)}else if(/Symbol/i.test(f))this.toFontChar=Yh(Oh,ud(),this.differences);else if(/Dingbats/i.test(f))this.toFontChar=\nYh(Ph,$r(),this.differences);else if(l||m){var r=Yh(this.defaultEncoding,ud(),this.differences);"CIDFontType2"!==g||this.cidEncoding.startsWith("Identity-")||this.toUnicode instanceof ad||this.toUnicode.forEach(function(w,y){r[+w]=y});this.toFontChar=r}else{var t=ud(),v=[];this.toUnicode.forEach(function(w,y){if(!d.composite){var x=Fe(d.differences[w]||d.defaultEncoding[w],t);-1!==x&&(y=x)}v[+w]=y});this.composite&&this.toUnicode instanceof ad&&/Tahoma|Verdana/i.test(e)&&mg(v,Pn());this.toFontChar=\nv}nl(b);this.loadedName=f.split("-",1)[0]};c.checkAndRepair=function(b,d,e){function g(H,U){var N=Object.create(null);N["OS/2"]=null;N.cmap=null;N.head=null;N.hhea=null;N.hmtx=null;N.maxp=null;N.name=null;N.post=null;for(var ba=0;ba<U;ba++){var aa=H,X=aa.getString(4),ha=aa.getInt32()>>>0,ma=aa.getInt32()>>>0,V=aa.getInt32()>>>0,ea=aa.pos;aa.pos=aa.start||0;aa.skip(ma);var za=aa.getBytes(V);aa.pos=ea;"head"===X&&(za[8]=za[9]=za[10]=za[11]=0,za[17]|=32);aa={tag:X,checksum:ha,length:V,offset:ma,data:za};\nw.includes(aa.tag)&&0!==aa.length&&(N[aa.tag]=aa)}return N}function f(H){return{version:H.getString(4),numTables:H.getUint16(),searchRange:H.getUint16(),entrySelector:H.getUint16(),rangeShift:H.getUint16()}}function h(H,U){a:{var N=H.getString(4);xc("ttcf"===N,"Must be a TrueType Collection font.");var ba=H.getUint16();for(var aa=H.getUint16(),X=H.getInt32()>>>0,ha=[],ma=0;ma<X;ma++)ha.push(H.getInt32()>>>0);N={ttcTag:N,majorVersion:ba,minorVersion:aa,numFonts:X,offsetTable:ha};switch(ba){case 1:ba=\nN;break a;case 2:N.dsigTag=H.getInt32()>>>0;N.dsigLength=H.getInt32()>>>0;N.dsigOffset=H.getInt32()>>>0;ba=N;break a}throw new oa("Invalid TrueType Collection majorVersion: "+ba+".");}N=ba;ba=N.numFonts;N=N.offsetTable;aa=U.split("+");var V;for(X=0;X<ba;X++){H.pos=(H.start||0)+N[X];ha=f(H);ma=g(H,ha.numTables);if(!ma.name)throw new oa(\'TrueType Collection font must contain a "name" table.\');for(var ea=u.makeIterator(p(ma.name)).next().value,za=0,Ia=ea.length;za<Ia;za++)for(var wa=0,Aa=ea[za].length;wa<\nAa;wa++){var Ja,Sa=null==(Ja=ea[za][wa])?void 0:Ja.replaceAll(/\\s/g,"");if(Sa){if(Sa===U)return{header:ha,tables:ma};if(!(2>aa.length))for(var Wa=u.makeIterator(aa),La=Wa.next();!La.done;La=Wa.next())La=La.value,Sa===La&&(V={name:La,header:ha,tables:ma})}}}if(V)return T(\'TrueType Collection does not contain "\'+U+\'" font, falling back to "\'+(V.name+\'" font instead.\')),{header:V.header,tables:V.tables};throw new oa(\'TrueType Collection does not contain "\'+U+\'" font.\');}function k(H,U,N,ba){if(!H)return T("No cmap table available."),\n{platformId:-1,encodingId:-1,mappings:[],hasShortCmap:!1};var aa;H=(U.start||0)+H.offset;U.pos=H;U.skip(2);for(var X=U.getUint16(),ha,ma=!1,V=0;V<X;V++){var ea,za=U.getUint16(),Ia=U.getUint16(),wa=U.getInt32()>>>0,Aa=!1;if((null==(aa=ha)?void 0:aa.platformId)!==za||(null==(ea=ha)?void 0:ea.encodingId)!==Ia){if(0===za&&(0===Ia||1===Ia||3===Ia))Aa=!0;else if(1===za&&0===Ia)Aa=!0;else if(3===za&&1===Ia&&(ba||!ha))Aa=!0,N||(ma=!0);else if(N&&3===za&&0===Ia){var Ja=Aa=!0;if(V<X-1){var Sa=U.peekBytes(2);\n(Sa[0]<<8)+Sa[1]<za&&(Ja=!1)}Ja&&(ma=!0)}Aa&&(ha={platformId:za,encodingId:Ia,offset:wa});if(ma)break}}ha&&(U.pos=H+ha.offset);if(!ha||-1===U.peekByte())return T("Could not find a preferred cmap table."),{platformId:-1,encodingId:-1,mappings:[],hasShortCmap:!1};H=U.getUint16();ba=!1;N=[];if(0===H){U.skip(4);for(aa=0;256>aa;aa++)(ba=U.getByte())&&N.push({charCode:aa,glyphId:ba});ba=!0}else if(2===H){U.skip(4);H=[];for(ea=aa=0;256>ea;ea++)X=U.getUint16()>>3,H.push(X),aa=Math.max(X,aa);X=[];for(ea=0;ea<=\naa;ea++)X.push({firstCode:U.getUint16(),entryCount:U.getUint16(),idDelta:Mc(U.getByte(),U.getByte()),idRangePos:U.pos+U.getUint16()});for(ma=0;256>ma;ma++)if(0===H[ma])U.pos=X[0].idRangePos+2*ma,ea=U.getUint16(),N.push({charCode:ma,glyphId:ea});else for(V=X[H[ma]],aa=0;aa<V.entryCount;aa++)za=(ma<<8)+aa+V.firstCode,U.pos=V.idRangePos+2*aa,ea=U.getUint16(),0!==ea&&(ea=(ea+V.idDelta)%65536),N.push({charCode:za,glyphId:ea})}else if(4===H){U.skip(4);X=U.getUint16()>>1;U.skip(6);ma=[];for(V=0;V<X;V++)ma.push({end:U.getUint16()});\nU.skip(2);for(V=0;V<X;V++)ma[V].start=U.getUint16();for(V=0;V<X;V++)ma[V].delta=U.getUint16();for(V=H=0;V<X;V++)aa=ma[V],(ea=U.getUint16())?(za=(ea>>1)-(X-V),aa.offsetIndex=za,H=Math.max(H,za+aa.end-aa.start+1)):aa.offsetIndex=-1;Ia=[];for(aa=0;aa<H;aa++)Ia.push(U.getUint16());for(V=0;V<X;V++)for(aa=ma[V],H=aa.start,U=aa.end,wa=aa.delta,za=aa.offsetIndex,aa=H;aa<=U;aa++)65535!==aa&&(ea=0>za?aa:Ia[za+aa-H],ea=ea+wa&65535,N.push({charCode:aa,glyphId:ea}))}else if(6===H)for(U.skip(4),H=U.getUint16(),\nX=U.getUint16(),aa=0;aa<X;aa++)ea=U.getUint16(),N.push({charCode:H+aa,glyphId:ea});else if(12===H)for(U.skip(10),H=U.getInt32()>>>0,aa=0;aa<H;aa++)for(ma=U.getInt32()>>>0,ea=U.getInt32()>>>0,X=U.getInt32()>>>0;ma<=ea;ma++)N.push({charCode:ma,glyphId:X++});else return T("cmap table has unsupported format: "+H),{platformId:-1,encodingId:-1,mappings:[],hasShortCmap:!1};N.sort(function(Wa,La){return Wa.charCode-La.charCode});for(U=1;U<N.length;U++)N[U-1].charCode===N[U].charCode&&(N.splice(U,1),U--);\nreturn{platformId:ha.platformId,encodingId:ha.encodingId,mappings:N,hasShortCmap:ba}}function l(H,U,N,ba,aa,X){var ha={length:0,sizeOfInstructions:0};if(0>U||U>=H.length||N>H.length||12>=N-U)return ha;H=H.subarray(U,N);U=Mc(H[2],H[3]);N=Mc(H[4],H[5]);var ma=Mc(H[6],H[7]),V=Mc(H[8],H[9]);U>ma&&(mf(H,2,ma),mf(H,6,U));N>V&&(mf(H,4,V),mf(H,8,N));V=Mc(H[0],H[1]);if(0>V){if(-1>V)return ha;ba.set(H,aa);ha.length=H.length;return ha}N=10;for(U=ma=0;U<V;U++)ma=(H[N]<<8|H[N+1])+1,N+=2;V=N;var ea=H[N]<<8|H[N+\n1];ha.sizeOfInstructions=ea;var za=N+=2+ea,Ia=0;for(U=0;U<ma;U++){var wa=H[N++];wa&192&&(H[N-1]=wa&63);var Aa=2;wa&2?Aa=1:wa&16&&(Aa=0);var Ja=2;wa&4?Ja=1:wa&32&&(Ja=0);Aa+=Ja;Ia+=Aa;wa&8&&(wa=H[N++],0===wa&&(H[N-1]^=8),U+=wa,Ia+=wa*Aa)}if(0===Ia)return ha;U=N+Ia;if(U>H.length)return ha;if(!X&&0<ea)return ba.set(H.subarray(0,V),aa),ba.set([0,0],aa+V),ba.set(H.subarray(za,U),aa+V+2),U-=ea,3<H.length-U&&(U=U+3&-4),ha.length=U,ha;if(3<H.length-U)return U=U+3&-4,ba.set(H.subarray(0,U),aa),ha.length=U,\nha;ba.set(H,aa);ha.length=H.length;return ha}function m(H,U,N,ba,aa,X,ha){if(ba){ba=4;var ma=function(Xa,Na){return Xa[Na]<<24|Xa[Na+1]<<16|Xa[Na+2]<<8|Xa[Na+3]};var V=function(Xa,Na,hb){Xa[Na]=hb>>>24&255;Xa[Na+1]=hb>>16&255;Xa[Na+2]=hb>>8&255;Xa[Na+3]=hb&255}}else ba=2,ma=function(Xa,Na){return Xa[Na]<<9|Xa[Na+1]<<1},V=function(Xa,Na,hb){Xa[Na]=hb>>9&255;Xa[Na+1]=hb>>1&255};var ea=X?N+1:N,za=ba*(1+ea),Ia=new Uint8Array(za);Ia.set(H.data.subarray(0,za));H.data=Ia;var wa=U.data,Aa=wa.length;za=new Uint8Array(Aa);\nvar Ja,Sa,Wa=[];for(Sa=Ja=0;Ja<N+1;Ja++,Sa+=ba){var La=ma(Ia,Sa);La>Aa&&(La=Aa);Wa.push({index:Ja,offset:La,endOffset:0})}Wa.sort(function(Xa,Na){return Xa.offset-Na.offset});for(Ja=0;Ja<N;Ja++)Wa[Ja].endOffset=Wa[Ja+1].offset;Wa.sort(function(Xa,Na){return Xa.index-Na.index});for(Ja=0;Ja<N;Ja++){Sa=Wa[Ja];La=Sa.endOffset;if(0!==Sa.offset||0!==La)break;Sa=Wa[Ja+1].offset;if(0!==Sa){Wa[Ja].endOffset=Sa;break}}Ja=Wa.at(-2);0!==Ja.offset&&0===Ja.endOffset&&(Ja.endOffset=Aa);Aa=Object.create(null);La=\n0;V(Ia,0,La);Ja=0;for(Sa=ba;Ja<N;Ja++,Sa+=ba){var vb=l(wa,Wa[Ja].offset,Wa[Ja].endOffset,za,La,aa),eb=vb.length;0===eb&&(Aa[Ja]=!0);vb.sizeOfInstructions>ha&&(ha=vb.sizeOfInstructions);La+=eb;V(Ia,Sa,La)}if(0===La){H=new Uint8Array([0,1,0,0,0,0,0,0,0,0,0,0,0,0,49,0]);Ja=0;for(Sa=ba;Ja<ea;Ja++,Sa+=ba)V(Ia,Sa,H.length);U.data=H}else X?(N=ma(Ia,ba),za.length>N+La?U.data=za.subarray(0,N+La):(U.data=new Uint8Array(N+La),U.data.set(za.subarray(0,La))),U.data.set(za.subarray(0,N),La),V(H.data,Ia.length-\nba,La+N)):U.data=za.subarray(0,La);return{missingGlyphs:Aa,maxSizeOfInstructions:ha}}function n(H,U,N){var ba=(d.start||0)+H.offset;d.pos=ba;ba+=H.length;var aa=d.getInt32();d.skip(28);H=!0;switch(aa){case 65536:var X=On;break;case 131072:aa=d.getUint16();if(aa!==N){H=!1;break}var ha=[];for(N=0;N<aa;++N){var ma=d.getUint16();if(32768<=ma){H=!1;break}ha.push(ma)}if(!H)break;ma=[];for(X=[];d.pos<ba;){var V=d.getByte();X.length=V;for(N=0;N<V;++N)X[N]=String.fromCharCode(d.getByte());ma.push(X.join(""))}X=\n[];for(N=0;N<aa;++N)ba=ha[N],258>ba?X.push(On[ba]):X.push(ma[ba-258]);break;case 196608:break;default:T("Unknown/unsupported post table version "+aa),H=!1,U.defaultEncoding&&(X=U.defaultEncoding)}U.glyphNames=X;return H}function p(H){var U=(d.start||0)+H.offset;d.pos=U;var N=[[],[]],ba=[],aa=H.length;H=U+aa;if(0!==d.getUint16()||6>aa)return[N,ba];var X=d.getUint16();aa=d.getUint16();var ha;for(ha=0;ha<X&&d.pos+12<=H;ha++){var ma={platform:d.getUint16(),encoding:d.getUint16(),language:d.getUint16(),\nname:d.getUint16(),length:d.getUint16(),offset:d.getUint16()};(1===ma.platform&&0===ma.encoding&&0===ma.language||3===ma.platform&&1===ma.encoding&&1033===ma.language)&&ba.push(ma)}ha=0;for(X=ba.length;ha<X;ha++)if(ma=ba[ha],!(0>=ma.length)){var V=U+aa+ma.offset;if(!(V+ma.length>H))if(d.pos=V,V=ma.name,ma.encoding){var ea="",za=0;for(ma=ma.length;za<ma;za+=2)ea+=String.fromCharCode(d.getUint16());N[1][V]=ea}else N[0][V]=d.getString(ma.length)}return[N,ba]}function q(H,U){for(var N=H.data,ba=0,aa,\nX,ha,ma=0,V=0,ea=[],za=[],Ia=[],wa=U.tooComplexToFollowFunctions,Aa=!1,Ja=0,Sa=0,Wa=N.length;ba<Wa;){var La=N[ba++];if(64===La)if(X=N[ba++],Aa||Sa)ba+=X;else for(aa=0;aa<X;aa++)ea.push(N[ba++]);else if(65===La)if(X=N[ba++],Aa||Sa)ba+=2*X;else for(aa=0;aa<X;aa++)ha=N[ba++],ea.push(ha<<8|N[ba++]);else if(176===(La&248))if(X=La-176+1,Aa||Sa)ba+=X;else for(aa=0;aa<X;aa++)ea.push(N[ba++]);else if(184===(La&248))if(X=La-184+1,Aa||Sa)ba+=2*X;else for(aa=0;aa<X;aa++)ha=N[ba++],ea.push(Mc(ha,N[ba++]));else if(43!==\nLa||wa)if(44!==La||wa)if(45===La)if(Aa)Aa=!1,ma=ba;else{aa=za.pop();if(!aa){T("TT: ENDF bad stack");U.hintsValid=!1;return}X=Ia.pop();N=aa.data;ba=aa.i;U.functionsStackDeltas[X]=ea.length-aa.stackTop}else if(137===La){if(Aa||Sa)T("TT: nested IDEFs not allowed"),wa=!0;Aa=!0;V=ba}else 88===La?++Ja:27===La?Sa=Ja:89===La?(Sa===Ja&&(Sa=0),--Ja):28!==La||Aa||Sa||(X=ea.at(-1),0<X&&(ba+=X-1));else{if(Aa||Sa)T("TT: nested FDEFs not allowed"),wa=!0;Aa=!0;V=ba;X=ea.pop();U.functionsDefined[X]={data:N,i:ba}}else if(!Aa&&\n!Sa)if(X=ea.at(-1),isNaN(X))Ya("TT: CALL empty stack (or invalid entry).");else if(U.functionsUsed[X]=!0,X in U.functionsStackDeltas){X=ea.length+U.functionsStackDeltas[X];if(0>X){T("TT: CALL invalid functions stack delta.");U.hintsValid=!1;return}ea.length=X}else if(X in U.functionsDefined&&!Ia.includes(X)){za.push({data:N,i:ba,stackTop:ea.length-1});Ia.push(X);aa=U.functionsDefined[X];if(!aa){T("TT: CALL non-existent function");U.hintsValid=!1;return}N=aa.data;ba=aa.i}if(!Aa&&!Sa){aa=0;142>=La?\naa=y[La]:192<=La&&223>=La?aa=-1:224<=La&&(aa=-2);113<=La&&117>=La&&(X=ea.pop(),isNaN(X)||(aa=2*-X));for(;0>aa&&0<ea.length;)ea.pop(),aa++;for(;0<aa;)ea.push(NaN),aa--}}U.tooComplexToFollowFunctions=wa;U=[N];ba>N.length&&U.push(new Uint8Array(ba-N.length));V>ma&&(T("TT: complementing a missing function tail"),U.push(new Uint8Array([34,45])));if(1<U.length){ba=N=0;for(ma=U.length;ba<ma;ba++)N+=U[ba].length;N=N+3&-4;V=new Uint8Array(N);ba=ea=0;for(ma=U.length;ba<ma;ba++)V.set(U[ba],ea),ea+=U[ba].length;\nH.data=V;H.length=N}}function r(H){return!M[H]}var t,v,w="OS/2;cmap;head;hhea;hmtx;maxp;name;post;loca;glyf;fpgm;prep;cvt ;CFF ".split(";"),y=[0,0,0,0,0,0,0,0,-2,-2,-2,-2,0,0,-2,-5,-1,-1,-1,-1,-1,-1,-1,-1,0,0,-1,0,-1,-1,-1,-1,1,-1,-999,0,1,0,-1,-2,0,-1,-2,-1,-1,0,-1,-1,0,0,-999,-999,-1,-1,-1,-1,-2,-999,-2,-2,-999,0,-2,-2,0,0,-2,0,-2,0,0,0,-2,-1,-1,1,1,0,0,-1,-1,-1,-1,-1,-1,-1,0,0,-1,0,-1,-1,0,-999,-1,-1,-1,-1,-1,-1,0,0,0,0,0,0,0,0,0,0,0,0,-2,-999,-999,-999,-999,-999,-1,-1,-2,-2,0,0,0,0,-1,-1,-999,\n-2,-2,0,0,-1,-2,-2,0,0,0,-1,-1,-1,-2];d=new Mb(new Uint8Array(d.getBytes()));if(ol(d)){var x=h(d,this.name);var z=x.header;x=x.tables}else z=f(d),x=g(d,z.numTables);var A=!x["CFF "];if(A){if(!x.loca)throw new oa(\'Required "loca" table is not found\');x.glyf||(T(\'Required "glyf" table is not found -- trying to recover.\'),x.glyf={tag:"glyf",data:new Uint8Array(0)});this.isOpenType=!1}else{var B,C=e.composite&&(0<(null==(B=e.cidToGidMap)?void 0:B.length)||!(e.cMap instanceof Ee));if("OTTO"===z.version&&\n!C||!x.head||!x.hhea||!x.maxp||!x.post){var D=new Mb(x["CFF "].data);var E=new uj(D,e);Xh(e);return this.convert(b,E,e)}delete x.glyf;delete x.loca;delete x.fpgm;delete x.prep;delete x["cvt "];this.isOpenType=!0}if(!x.maxp)throw new oa(\'Required "maxp" table is not found\');d.pos=(d.start||0)+x.maxp.offset;C=d.getInt32();var G=d.getUint16();if(65536!==C&&20480!==C){if(6===x.maxp.length)C=20480;else if(32<=x.maxp.length)C=65536;else throw new oa(\'"maxp" table has a wrong version number\');dq(x.maxp.data,\n0,C)}if((null==(t=e.scaleFactors)?void 0:t.length)===G&&A){t=e.scaleFactors;B=(x.head.data[50]<<8)+x.head.data[51];var J=new ms({glyfTable:x.glyf.data,isGlyphLocationsLong:B,locaTable:x.loca.data,numGlyphs:G});J.scale(t);J=J.write();var F=J.loca,L=J.isLocationLong;x.glyf.data=J.glyf;x.loca.data=F;L!==!!B&&(x.head.data[50]=0,x.head.data[51]=L?1:0);B=x.hmtx.data;for(J=0;J<G;J++)F=4*J,L=Math.round(t[J]*((B[F]<<8)+B[F+1])),B[F]=L>>8&255,B[F+1]=L&255,L=Math.round(t[J]*Mc(B[F+2],B[F+3])),mf(B,F+2,L)}t=\nG+1;B=!0;65535<t&&(B=!1,t=G,T("Not enough space in glyfs to duplicate first glyph."));J=F=0;65536<=C&&32<=x.maxp.length&&(d.pos+=8,2<d.getUint16()&&(x.maxp.data[14]=0,x.maxp.data[15]=2),d.pos+=4,F=d.getUint16(),d.pos+=4,J=d.getUint16());x.maxp.data[4]=t>>8;x.maxp.data[5]=t&255;F=function(H,U,N,ba){var aa={functionsDefined:[],functionsUsed:[],functionsStackDeltas:[],tooComplexToFollowFunctions:!1,hintsValid:!0};H&&q(H,aa);U&&q(U,aa);if(H&&!aa.tooComplexToFollowFunctions)if(aa.functionsDefined.length>\nba)T("TT: more functions defined than expected"),aa.hintsValid=!1;else for(H=0,U=aa.functionsUsed.length;H<U;H++){if(H>ba){T("TT: invalid function id: "+H);aa.hintsValid=!1;break}if(aa.functionsUsed[H]&&!aa.functionsDefined[H]){T("TT: undefined function: "+H);aa.hintsValid=!1;break}}N&&N.length&1&&(ba=new Uint8Array(N.length+1),ba.set(N.data),N.data=ba);return aa.hintsValid}(x.fpgm,x.prep,x["cvt "],F);F||(delete x.fpgm,delete x.prep,delete x["cvt "]);(function(H,U,N,ba,aa,X){if(U){H.pos=(H.start||\n0)+U.offset;H.pos+=4;H.pos+=2;H.pos+=2;H.pos+=2;H.pos+=2;H.pos+=2;H.pos+=2;H.pos+=2;H.pos+=2;H.pos+=2;var ha=H.getUint16();H.pos+=8;H.pos+=2;H=H.getUint16();0===ha||(ba.data[44]<<8)+ba.data[45]&2||(U.data[22]=0,U.data[23]=0);H>aa&&(Ya("The numOfMetrics ("+H+") should not be greater than the numGlyphs ("+(aa+").")),H=aa,U.data[34]=(H&65280)>>8,U.data[35]=H&255);U=aa-H-(N.length-4*H>>1);0<U&&(U=new Uint8Array(N.length+2*U),U.set(N.data),X&&(U[N.length]=N.data[2],U[N.length+1]=N.data[3]),N.data=U)}else N&&\n(N.data=null)})(d,x.hhea,x.hmtx,x.head,t,B);if(!x.head)throw new oa(\'Required "head" table is not found\');(function(H,U,N){H=H.data;var ba=(H[0]<<24)+(H[1]<<16)+(H[2]<<8)+H[3];1!==ba>>16&&(Ya("Attempting to fix invalid version in head table: "+ba),H[0]=0,H[1]=1,H[2]=0,H[3]=0);ba=(H[50]<<8)+H[51];if(0>ba||1<ba)if(Ya("Attempting to fix invalid indexToLocFormat in head table: "+ba),U+=1,N===U<<1)H[50]=0,H[51]=0;else if(N===U<<2)H[50]=0,H[51]=1;else throw new oa("Could not fix indexToLocFormat: "+ba);\n})(x.head,G,A?x.loca.length:0);var M=Object.create(null);A&&(J=m(x.loca,x.glyf,G,(x.head.data[50]<<8)+x.head.data[51],F,B,J),M=J.missingGlyphs,65536<=C&&32<=x.maxp.length&&(x.maxp.data[26]=J.maxSizeOfInstructions>>8,x.maxp.data[27]=J.maxSizeOfInstructions&255));if(!x.hhea)throw new oa(\'Required "hhea" table is not found\');0===x.hhea.data[10]&&0===x.hhea.data[11]&&(x.hhea.data[10]=255,x.hhea.data[11]=255);C={unitsPerEm:(x.head.data[18]<<8)+x.head.data[19],yMax:Mc(x.head.data[42],x.head.data[43]),yMin:Mc(x.head.data[38],\nx.head.data[39]),ascent:Mc(x.hhea.data[4],x.hhea.data[5]),descent:Mc(x.hhea.data[6],x.hhea.data[7]),lineGap:Mc(x.hhea.data[8],x.hhea.data[9])};this.ascent=C.ascent/C.unitsPerEm;this.descent=C.descent/C.unitsPerEm;this.lineGap=C.lineGap/C.unitsPerEm;null!=(v=this.cssFontInfo)&&v.lineHeight?(this.lineHeight=this.cssFontInfo.metrics.lineHeight,this.lineGap=this.cssFontInfo.metrics.lineGap):this.lineHeight=this.ascent-this.descent+this.lineGap;x.post&&n(x.post,e,G);x.post={tag:"post",data:sl(e)};var W=\nObject.create(null);if(e.composite){var Q=e.cidToGidMap||[],la=0===Q.length;e.cMap.forEach(function(H,U){"string"===typeof U&&(U=Zh(H,U,!0));if(65535<U)throw new oa("Max size of CID is 65,535");var N=-1;la?N=U:void 0!==Q[U]&&(N=Q[U]);0<=N&&N<G&&!M[N]&&(W[H]=N)})}else{v=k(x.cmap,d,this.isSymbolicFont,e.hasEncoding);F=v.platformId;L=v.encodingId;var ta=v.mappings;v=[];J=!1;!e.hasEncoding||"MacRomanEncoding"!==e.baseEncodingName&&"WinAnsiEncoding"!==e.baseEncodingName||(v=hf(e.baseEncodingName));if(e.hasEncoding&&\n!this.isSymbolicFont&&(3===F&&1===L||1===F&&0===L))for(var qa=ud(),va=0;256>va;va++){var S=void 0;if(S=void 0!==this.differences[va]?this.differences[va]:v.length&&""!==v[va]?v[va]:Bd[va]){var da=Yk(S,qa);S=void 0;3===F&&1===L?S=qa[da]:1===F&&0===L&&(S=Nh.indexOf(da));if(void 0===S&&(e.glyphNames||!e.hasIncludedToUnicodeMap||this.toUnicode instanceof ad||(da=this.toUnicode.get(va))&&(S=da.codePointAt(0)),void 0===S))continue;da=u.makeIterator(ta);for(var R=da.next();!R.done;R=da.next())if(R=R.value,\nR.charCode===S){W[va]=R.glyphId;break}}}else if(0===F){J=u.makeIterator(ta);for(F=J.next();!F.done;F=J.next())F=F.value,W[F.charCode]=F.glyphId;J=!0}else if(3===F&&0===L)for(F=u.makeIterator(ta),L=F.next();!L.done;L=F.next())L=L.value,ta=L.charCode,61440<=ta&&61695>=ta&&(ta&=255),W[ta]=L.glyphId;else for(F=u.makeIterator(ta),L=F.next();!L.done;L=F.next())L=L.value,W[L.charCode]=L.glyphId;if(e.glyphNames&&(v.length||this.differences.length))for(F=0;256>F;++F)if(J||void 0===W[F])if(L=this.differences[F]||\nv[F])L=e.glyphNames.indexOf(L),0<L&&!M[L]&&(W[F]=L)}0===W.length&&(W[0]=0);v=t-1;B||(v=0);e.cssFontInfo||(B=pl(W,r,v,this.toUnicode),this.toFontChar=B.toFontChar,x.cmap={tag:"cmap",data:ql(B.charCodeToGlyphId,B.toUnicodeExtraMap,t)},x["OS/2"]&&fq(x["OS/2"],d)||(x["OS/2"]={tag:"OS/2",data:rl(e,B.charCodeToGlyphId,C)}));if(!A)try{D=new Mb(x["CFF "].data);E=(new sj(D,e,!0)).parse();E.duplicateFirstGlyph();var Y=new tj(E);x["CFF "].data=Y.compile()}catch(H){T("Failed to compile font "+e.loadedName)}x.name?\n(D=u.makeIterator(p(x.name)),E=D.next().value,D=D.next().value,x.name.data=bi(b,E),this.psName=E[0][6]||null,e.composite||bq(e,this.isSymbolicFont,D)):x.name={tag:"name",data:bi(this.name)};b=new $h(z.version);for(var fa in x)b.addTable(fa,x[fa].data);return b.toArray()};c.convert=function(b,d,e){function g(D,E){var G=null,J;for(J in D)E===D[J]&&(G||(G=[])).push(J|0);return G}function f(D,E){for(var G in D)if(E===D[G])return G|0;l.charCodeToGlyphId[l.nextAvailableFontCharCode]=E;return l.nextAvailableFontCharCode++}\ne.fixedPitch=!1;e.builtInEncoding&&cq(e,e.builtInEncoding);var h=1;d instanceof uj&&(h=d.numGlyphs-1);var k=d.getGlyphMapping(e),l=null,m=k,n=null;e.cssFontInfo||(l=pl(k,d.hasGlyphId.bind(d),h,this.toUnicode),this.toFontChar=l.toFontChar,m=l.charCodeToGlyphId,n=l.toUnicodeExtraMap);var p=d.numGlyphs;h=d.seacs;if(l&&null!=h&&h.length){var q=e.fontMatrix||ie,r=d.getCharset(),t=Object.create(null);for(C in h){C|=0;var v=h[C],w=Bd[v[3]],y=r.indexOf(Bd[v[2]]);w=r.indexOf(w);if(!(0>y||0>w)){v={x:v[0]*q[0]+\nv[1]*q[2]+q[4],y:v[0]*q[1]+v[1]*q[3]+q[5]};var x=g(k,C);if(x){x=u.makeIterator(x);for(var z=x.next();!z.done;z=x.next()){z=z.value;var A=l.charCodeToGlyphId,B=f(A,y);A=f(A,w);t[z]={baseFontCharCode:B,accentFontCharCode:A,accentOffset:v}}}}}e.seacMap=t}k=e.fontMatrix?1/Math.max.apply(Math,u.arrayFromIterable(e.fontMatrix.slice(0,4).map(Math.abs))):1E3;var C=new $h("OTTO");C.addTable("CFF ",d.data);C.addTable("OS/2",rl(e,m));C.addTable("cmap",ql(m,n,p));C.addTable("head","\\x00\\u0001\\x00\\x00\\x00\\x00\\u0010\\x00\\x00\\x00\\x00\\x00_\\u000f<\\u00f5\\x00\\x00"+\nje(k)+"\\x00\\x00\\x00\\x00\\u009e\\v~\'\\x00\\x00\\x00\\x00\\u009e\\v~\'\\x00\\x00"+je(e.descent)+"\\u000f\\u00ff"+je(e.ascent)+lb(e.italicAngle?2:0)+"\\x00\\u0011\\x00\\x00\\x00\\x00\\x00\\x00");C.addTable("hhea","\\x00\\u0001\\x00\\x00"+je(e.ascent)+je(e.descent)+"\\x00\\x00\\u00ff\\u00ff\\x00\\x00\\x00\\x00\\x00\\x00"+je(e.capHeight)+je(Math.tan(e.italicAngle)*e.xHeight)+"\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00\\x00"+lb(p));C.addTable("hmtx",function(){for(var D=d.charstrings,E=d.cff?d.cff.widths:null,G="\\x00\\x00\\x00\\x00",J=1;J<\np;J++){var F=0;D?(F=D[J-1],F="width"in F?F.width:0):E&&(F=Math.ceil(E[J]||0));G+=lb(F)+lb(0)}return G}());C.addTable("maxp","\\x00\\x00P\\x00"+lb(p));C.addTable("name",bi(b));C.addTable("post",sl(e));return C.toArray()};c._charToGlyph=function(b,d){var e,g,f,h;void 0===d&&(d=!1);var k=this._glyphCache[b];if((null==(e=k)?void 0:e.isSpace)===d)return k;var l;k=b;null!=(g=this.cMap)&&g.contains(b)&&(k=this.cMap.lookup(b),"string"===typeof k&&(k=Zh(b,k)));g=this.widths[k];"number"!==typeof g&&(g=this.defaultWidth);\ne=null==(f=this.vmetrics)?void 0:f[k];f=this.toUnicode.get(b)||b;"number"===typeof f&&(f=String.fromCharCode(f));k=void 0!==this.toFontChar[b];var m=this.toFontChar[b]||b;if(this.missingFile){var n=this.differences[b]||this.defaultEncoding[b];".notdef"!==n&&""!==n||"Type1"!==this.type||(m=32,""===n&&(g||(g=this._spaceWidth),f=String.fromCharCode(m)));m=65520<=m&&65535>=m?0:62976<=m&&63743>=m?as()[m]||m:173===m?45:m}this.isType3Font&&(l=m);n=null;null!=(h=this.seacMap)&&h[b]&&(k=!0,h=this.seacMap[b],\nm=h.baseFontCharCode,n={fontChar:String.fromCodePoint(h.accentFontCharCode),offset:h.accentOffset});h="";"number"===typeof m&&(1114111>=m?h=String.fromCodePoint(m):T("charToGlyph - invalid fontCharCode: "+m));this.missingFile&&this.vertical&&1===h.length&&(m=cs()[h.charCodeAt(0)])&&(h=f=String.fromCharCode(m));k=new Bs(b,h,f,n,g,e,l,d,k);return this._glyphCache[b]=k};c.charsToGlyphs=function(b){var d=this._charsCache[b];if(d)return d;d=[];if(this.cMap)for(var e=Object.create(null),g=b.length,f=0;f<\ng;){this.cMap.readCharCode(b,f,e);var h=e,k=h.charcode;h=h.length;f+=h;k=this._charToGlyph(k,1===h&&32===b.charCodeAt(f-1));d.push(k)}else for(e=0,g=b.length;e<g;++e)f=b.charCodeAt(e),f=this._charToGlyph(f,32===f),d.push(f);return this._charsCache[b]=d};c.getCharPositions=function(b){var d=[];if(this.cMap)for(var e=Object.create(null),g=0;g<b.length;){this.cMap.readCharCode(b,g,e);var f=e.length;d.push([g,g+f]);g+=f}else for(e=0,b=b.length;e<b;++e)d.push([e,e+1]);return d};c.encodeString=function(b){for(var d=\nthis,e=[],g=[],f=this.toUnicode instanceof ad?function(n){return d.toUnicode.charCodeOf(n)}:function(n){return d.toUnicode.charCodeOf(String.fromCodePoint(n))},h=0,k=b.length;h<k;h++){var l=b.codePointAt(h);55295<l&&(57344>l||65533<l)&&h++;if(this.toUnicode){var m=f(l);if(-1!==m){1===e.length%2&&(e.push(g.join("")),g.length=0);for(l=(this.cMap?this.cMap.getCharCodeLength(m):1)-1;0<=l;l--)g.push(String.fromCharCode(m>>8*l&255));continue}}1!==e.length%2&&(e.push(g.join("")),g.length=0);g.push(String.fromCodePoint(l))}e.push(g.join(""));\nreturn e};return ml(a,[{key:"renderer",get:function(){var b=js.create(this,!0);return Fa(this,"renderer",b)}},{key:"_spaceWidth",get:function(){for(var b,d=u.makeIterator(["space","minus","one","i","I"]),e=d.next();!e.done;e=d.next()){b=e.value;if(b in this.widths){b=this.widths[b];break}b=ud()[b];e=0;this.composite&&this.cMap.contains(b)&&(e=this.cMap.lookup(b),"string"===typeof e&&(e=Zh(b,e)));!e&&this.toUnicode&&(e=this.toUnicode.charCodeOf(b));0>=e&&(e=b);if(b=this.widths[e])break}return Fa(this,\n"_spaceWidth",b||this.defaultWidth)}},{key:"glyphCacheValues",get:function(){return Object.values(this._glyphCache)}}])}(),wj=function(){function a(b){this.error=b;this.loadedName="g_font_error";this.missingFile=!0}var c=a.prototype;c.charsToGlyphs=function(){return[]};c.encodeString=function(b){return[b]};c.exportData=function(){return{error:this.error}};return a}(),Es=function(){function a(){db("Cannot initialize Pattern.")}a.parseShading=function(c,b,d,e,g){var f=c instanceof $a?c.dict:c,h=f.get("ShadingType");\ntry{switch(h){case 2:case 3:return new Cs(f,b,d,e,g);case 4:case 5:case 6:case 7:return new Ng(c,b,d,e,g);default:throw new oa("Unsupported ShadingType: "+h);}}catch(k){if(k instanceof ub)throw k;T(k);return new Ds}};return a}(),Se=function(){function a(){}a.prototype.getIR=function(){db("Abstract method `getIR` called.")};return a}();Se.SMALL_NUMBER=1E-6;var Cs=function(a){function c(b,d,e,g,f){var h=a.call(this)||this;h.shadingType=b.get("ShadingType");var k=0;2===h.shadingType?k=4:3===h.shadingType&&\n(k=6);h.coordsArr=b.getArray("Coords");if(!yc(h.coordsArr,k))throw new oa("RadialAxialShading: Invalid /Coords array.");d=ab.parse({cs:b.getRaw("CS")||b.getRaw("ColorSpace"),xref:d,resources:e,pdfFunctionFactory:g,localColorSpaceCache:f});h.bbox=sd(b.getArray("BBox"),null);e=0;var l=1;f=b.getArray("Domain");yc(f,2)&&(f=u.makeIterator(f),e=f.next().value,l=f.next().value);k=f=!1;var m=b.getArray("Extend");kp(m,2)&&(k=u.makeIterator(m),f=k.next().value,k=k.next().value);if(!(3!==h.shadingType||f&&k)){var n=\nu.makeIterator(h.coordsArr),p=n.next().value,q=n.next().value;m=n.next().value;var r=n.next().value,t=n.next().value;n=n.next().value;p=Math.hypot(p-r,q-t);m<=n+p&&n<=m+p&&T("Unsupported radial gradient.")}h.extendStart=f;h.extendEnd=k;m=b.getRaw("Function");m=g.createFromArray(m);p=(l-e)/840;g=h.colorStops=[];if(e>=l||0>=p){Ya("Bad shading domain.");if(void 0===h)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return h}l=new Float32Array(d.numComps);q=new Float32Array(1);\nt=0;q[0]=e;m(q,0,l,0);n=d.getRgb(l,0);r=Rb.makeHexColor(n[0],n[1],n[2]);g.push([0,r]);var v=1;q[0]=e+p;m(q,0,l,0);for(var w=d.getRgb(l,0),y=w[0]-n[0]+1,x=w[1]-n[1]+1,z=w[2]-n[2]+1,A=w[0]-n[0]-1,B=w[1]-n[1]-1,C=w[2]-n[2]-1,D=2;840>D;D++){q[0]=e+D*p;m(q,0,l,0);r=d.getRgb(l,0);var E=D-t;y=Math.min(y,(r[0]-n[0]+1)/E);x=Math.min(x,(r[1]-n[1]+1)/E);z=Math.min(z,(r[2]-n[2]+1)/E);A=Math.max(A,(r[0]-n[0]-1)/E);B=Math.max(B,(r[1]-n[1]-1)/E);C=Math.max(C,(r[2]-n[2]-1)/E);A<=y&&B<=x&&C<=z||(t=Rb.makeHexColor(w[0],\nw[1],w[2]),g.push([v/840,t]),y=r[0]-w[0]+1,x=r[1]-w[1]+1,z=r[2]-w[2]+1,A=r[0]-w[0]-1,B=r[1]-w[1]-1,C=r[2]-w[2]-1,t=v,n=w);v=D;w=r}e=Rb.makeHexColor(w[0],w[1],w[2]);g.push([1,e]);e="transparent";b.has("Background")&&(r=d.getRgb(b.get("Background"),0),e=Rb.makeHexColor(r[0],r[1],r[2]));f||(g.unshift([0,e]),g[1][0]+=Se.SMALL_NUMBER);k||(g.at(-1)[0]-=Se.SMALL_NUMBER,g.push([1,e]));h.colorStops=g;return h}ci(c,a);c.prototype.getIR=function(){var b=this.coordsArr,d=this.shadingType,e;if(2===d){var g=[b[0],\nb[1]];var f=[b[2],b[3]];var h=e=null;var k="axial"}else 3===d?(g=[b[0],b[1]],f=[b[3],b[4]],e=b[2],h=b[5],k="radial"):db("getPattern type unknown: "+d);return["RadialAxial",k,this.bbox,this.colorStops,g,f,e,h]};return c}(Se),Fs=function(){function a(b,d){this.stream=b;this.context=d;this.bufferLength=this.buffer=0;this.tmpCompsBuf=new Float32Array(d.numComps);b=d.colorSpace.numComps;this.tmpCsCompsBuf=d.colorFn?new Float32Array(b):this.tmpCompsBuf}var c=a.prototype;c.readBits=function(b){var d=this.buffer,\ne=this.bufferLength;if(32===b){if(0===e)return(this.stream.getByte()<<24|this.stream.getByte()<<16|this.stream.getByte()<<8|this.stream.getByte())>>>0;d=d<<24|this.stream.getByte()<<16|this.stream.getByte()<<8|this.stream.getByte();b=this.stream.getByte();this.buffer=b&(1<<e)-1;return(d<<8-e|(b&255)>>e)>>>0}if(8===b&&0===e)return this.stream.getByte();for(;e<b;)d=d<<8|this.stream.getByte(),e+=8;this.bufferLength=e-=b;this.buffer=d&(1<<e)-1;return d>>e};c.align=function(){this.bufferLength=this.buffer=\n0};c.readFlag=function(){return this.readBits(this.context.bitsPerFlag)};c.readCoordinate=function(){var b=this.context.bitsPerCoordinate,d=this.readBits(b),e=this.readBits(b),g=this.context.decode;b=32>b?1/((1<<b)-1):2.3283064365386963E-10;return[d*b*(g[1]-g[0])+g[0],e*b*(g[3]-g[2])+g[2]]};c.readComponents=function(){for(var b=this.context.numComps,d=this.context.bitsPerComponent,e=32>d?1/((1<<d)-1):2.3283064365386963E-10,g=this.context.decode,f=this.tmpCompsBuf,h=0,k=4;h<b;h++,k+=2){var l=this.readBits(d);\nf[h]=l*e*(g[k+1]-g[k])+g[k]}b=this.tmpCsCompsBuf;this.context.colorFn&&this.context.colorFn(f,0,b,0);return this.context.colorSpace.getRgb(b,0)};return gq(a,[{key:"hasData",get:function(){if(this.stream.end)return this.stream.pos<this.stream.end;if(0<this.bufferLength)return!0;var b=this.stream.getByte();if(0>b)return!1;this.buffer=b;this.bufferLength=8;return!0}}])}(),vl=Object.create(null),Ng=function(a){function c(d,e,g,f,h){var k=a.call(this)||this;if(!(d instanceof $a))throw new oa("Mesh data is not a stream");\nvar l=d.dict;k.shadingType=l.get("ShadingType");k.bbox=sd(l.getArray("BBox"),null);e=ab.parse({cs:l.getRaw("CS")||l.getRaw("ColorSpace"),xref:e,resources:g,pdfFunctionFactory:f,localColorSpaceCache:h});k.background=l.has("Background")?e.getRgb(l.get("Background"),0):null;f=(g=l.getRaw("Function"))?f.createFromArray(g):null;k.coords=[];k.colors=[];k.figures=[];f={bitsPerCoordinate:l.get("BitsPerCoordinate"),bitsPerComponent:l.get("BitsPerComponent"),bitsPerFlag:l.get("BitsPerFlag"),decode:l.getArray("Decode"),\ncolorFn:f,colorSpace:e,numComps:f?1:e.numComps};d=new Fs(d,f);f=!1;switch(k.shadingType){case 4:k._decodeType4Shading(d);break;case 5:l=l.get("VerticesPerRow")|0;if(2>l)throw new oa("Invalid VerticesPerRow");k._decodeType5Shading(d,l);break;case 6:k._decodeType6Shading(d);f=!0;break;case 7:k._decodeType7Shading(d);f=!0;break;default:db("Unsupported mesh type.")}if(f)for(k._updateBounds(),l=0,d=k.figures.length;l<d;l++)k._buildFigureFromPatch(l);k._updateBounds();k._packData();return k}ci(c,a);var b=\nc.prototype;b._decodeType4Shading=function(d){for(var e=this.coords,g=this.colors,f=[],h=[],k=0;d.hasData;){var l=d.readFlag(),m=d.readCoordinate(),n=d.readComponents();if(0===k){if(!(0<=l&&2>=l))throw new oa("Unknown type4 flag");switch(l){case 0:k=3;break;case 1:h.push(h.at(-2),h.at(-1));k=1;break;case 2:h.push(h.at(-3),h.at(-1)),k=1}f.push(l)}h.push(e.length);e.push(m);g.push(n);k--;d.align()}this.figures.push({type:"triangles",coords:new Int32Array(h),colors:new Int32Array(h)})};b._decodeType5Shading=\nfunction(d,e){for(var g=this.coords,f=this.colors,h=[];d.hasData;){var k=d.readCoordinate(),l=d.readComponents();h.push(g.length);g.push(k);f.push(l)}this.figures.push({type:"lattice",coords:new Int32Array(h),colors:new Int32Array(h),verticesPerRow:e})};b._decodeType6Shading=function(d){for(var e=this.coords,g=this.colors,f=new Int32Array(16),h=new Int32Array(4);d.hasData;){var k=d.readFlag();if(!(0<=k&&3>=k))throw new oa("Unknown type6 flag");for(var l=e.length,m=0,n=0!==k?8:12;m<n;m++)e.push(d.readCoordinate());\nm=g.length;n=0;for(var p=0!==k?2:4;n<p;n++)g.push(d.readComponents());switch(k){case 0:f[12]=l+3;f[13]=l+4;f[14]=l+5;f[15]=l+6;f[8]=l+2;f[11]=l+7;f[4]=l+1;f[7]=l+8;f[0]=l;f[1]=l+11;f[2]=l+10;f[3]=l+9;h[2]=m+1;h[3]=m+2;h[0]=m;h[1]=m+3;break;case 1:k=f[12];n=f[13];p=f[14];var q=f[15];f[12]=q;f[13]=l+0;f[14]=l+1;f[15]=l+2;f[8]=p;f[11]=l+3;f[4]=n;f[7]=l+4;f[0]=k;f[1]=l+7;f[2]=l+6;f[3]=l+5;k=h[2];n=h[3];h[2]=n;h[3]=m;h[0]=k;h[1]=m+1;break;case 2:k=f[15];n=f[11];f[12]=f[3];f[13]=l+0;f[14]=l+1;f[15]=l+2;\nf[8]=f[7];f[11]=l+3;f[4]=n;f[7]=l+4;f[0]=k;f[1]=l+7;f[2]=l+6;f[3]=l+5;k=h[3];h[2]=h[1];h[3]=m;h[0]=k;h[1]=m+1;break;case 3:f[12]=f[0],f[13]=l+0,f[14]=l+1,f[15]=l+2,f[8]=f[1],f[11]=l+3,f[4]=f[2],f[7]=l+4,f[0]=f[3],f[1]=l+7,f[2]=l+6,f[3]=l+5,h[2]=h[0],h[3]=m,h[0]=h[1],h[1]=m+1}f[5]=e.length;e.push([(-4*e[f[0]][0]-e[f[15]][0]+6*(e[f[4]][0]+e[f[1]][0])-2*(e[f[12]][0]+e[f[3]][0])+3*(e[f[13]][0]+e[f[7]][0]))/9,(-4*e[f[0]][1]-e[f[15]][1]+6*(e[f[4]][1]+e[f[1]][1])-2*(e[f[12]][1]+e[f[3]][1])+3*(e[f[13]][1]+\ne[f[7]][1]))/9]);f[6]=e.length;e.push([(-4*e[f[3]][0]-e[f[12]][0]+6*(e[f[2]][0]+e[f[7]][0])-2*(e[f[0]][0]+e[f[15]][0])+3*(e[f[4]][0]+e[f[14]][0]))/9,(-4*e[f[3]][1]-e[f[12]][1]+6*(e[f[2]][1]+e[f[7]][1])-2*(e[f[0]][1]+e[f[15]][1])+3*(e[f[4]][1]+e[f[14]][1]))/9]);f[9]=e.length;e.push([(-4*e[f[12]][0]-e[f[3]][0]+6*(e[f[8]][0]+e[f[13]][0])-2*(e[f[0]][0]+e[f[15]][0])+3*(e[f[11]][0]+e[f[1]][0]))/9,(-4*e[f[12]][1]-e[f[3]][1]+6*(e[f[8]][1]+e[f[13]][1])-2*(e[f[0]][1]+e[f[15]][1])+3*(e[f[11]][1]+e[f[1]][1]))/\n9]);f[10]=e.length;e.push([(-4*e[f[15]][0]-e[f[0]][0]+6*(e[f[11]][0]+e[f[14]][0])-2*(e[f[12]][0]+e[f[3]][0])+3*(e[f[2]][0]+e[f[8]][0]))/9,(-4*e[f[15]][1]-e[f[0]][1]+6*(e[f[11]][1]+e[f[14]][1])-2*(e[f[12]][1]+e[f[3]][1])+3*(e[f[2]][1]+e[f[8]][1]))/9]);this.figures.push({type:"patch",coords:new Int32Array(f),colors:new Int32Array(h)})}};b._decodeType7Shading=function(d){for(var e=this.coords,g=this.colors,f=new Int32Array(16),h=new Int32Array(4);d.hasData;){var k=d.readFlag();if(!(0<=k&&3>=k))throw new oa("Unknown type7 flag");\nfor(var l=e.length,m=0,n=0!==k?12:16;m<n;m++)e.push(d.readCoordinate());m=g.length;n=0;for(var p=0!==k?2:4;n<p;n++)g.push(d.readComponents());switch(k){case 0:f[12]=l+3;f[13]=l+4;f[14]=l+5;f[15]=l+6;f[8]=l+2;f[9]=l+13;f[10]=l+14;f[11]=l+7;f[4]=l+1;f[5]=l+12;f[6]=l+15;f[7]=l+8;f[0]=l;f[1]=l+11;f[2]=l+10;f[3]=l+9;h[2]=m+1;h[3]=m+2;h[0]=m;h[1]=m+3;break;case 1:k=f[12];n=f[13];p=f[14];var q=f[15];f[12]=q;f[13]=l+0;f[14]=l+1;f[15]=l+2;f[8]=p;f[9]=l+9;f[10]=l+10;f[11]=l+3;f[4]=n;f[5]=l+8;f[6]=l+11;f[7]=\nl+4;f[0]=k;f[1]=l+7;f[2]=l+6;f[3]=l+5;k=h[2];n=h[3];h[2]=n;h[3]=m;h[0]=k;h[1]=m+1;break;case 2:k=f[15];n=f[11];f[12]=f[3];f[13]=l+0;f[14]=l+1;f[15]=l+2;f[8]=f[7];f[9]=l+9;f[10]=l+10;f[11]=l+3;f[4]=n;f[5]=l+8;f[6]=l+11;f[7]=l+4;f[0]=k;f[1]=l+7;f[2]=l+6;f[3]=l+5;k=h[3];h[2]=h[1];h[3]=m;h[0]=k;h[1]=m+1;break;case 3:f[12]=f[0],f[13]=l+0,f[14]=l+1,f[15]=l+2,f[8]=f[1],f[9]=l+9,f[10]=l+10,f[11]=l+3,f[4]=f[2],f[5]=l+8,f[6]=l+11,f[7]=l+4,f[0]=f[3],f[1]=l+7,f[2]=l+6,f[3]=l+5,h[2]=h[0],h[3]=m,h[0]=h[1],h[1]=\nm+1}this.figures.push({type:"patch",coords:new Int32Array(f),colors:new Int32Array(h)})}};b._buildFigureFromPatch=function(d){var e=this.figures[d];xc("patch"===e.type,"Unexpected patch mesh figure");var g=this.coords,f=this.colors,h=e.coords;e=e.colors;var k=Math.min(g[h[0]][1],g[h[3]][1],g[h[12]][1],g[h[15]][1]),l=Math.max(g[h[0]][1],g[h[3]][1],g[h[12]][1],g[h[15]][1]),m=Math.ceil((Math.max(g[h[0]][0],g[h[3]][0],g[h[12]][0],g[h[15]][0])-Math.min(g[h[0]][0],g[h[3]][0],g[h[12]][0],g[h[15]][0]))*c.TRIANGLE_DENSITY/\n(this.bounds[2]-this.bounds[0]));m=Math.max(c.MIN_SPLIT_PATCH_CHUNKS_AMOUNT,Math.min(c.MAX_SPLIT_PATCH_CHUNKS_AMOUNT,m));k=Math.ceil((l-k)*c.TRIANGLE_DENSITY/(this.bounds[3]-this.bounds[1]));k=Math.max(c.MIN_SPLIT_PATCH_CHUNKS_AMOUNT,Math.min(c.MAX_SPLIT_PATCH_CHUNKS_AMOUNT,k));l=m+1;for(var n=new Int32Array((k+1)*l),p=new Int32Array((k+1)*l),q=0,r=new Uint8Array(3),t=new Uint8Array(3),v=f[e[0]],w=f[e[1]],y=f[e[2]],x=f[e[3]],z=ul(k),A=ul(m),B=0;B<=k;B++){r[0]=(v[0]*(k-B)+y[0]*B)/k|0;r[1]=(v[1]*(k-\nB)+y[1]*B)/k|0;r[2]=(v[2]*(k-B)+y[2]*B)/k|0;t[0]=(w[0]*(k-B)+x[0]*B)/k|0;t[1]=(w[1]*(k-B)+x[1]*B)/k|0;t[2]=(w[2]*(k-B)+x[2]*B)/k|0;for(var C=0;C<=m;C++,q++)if(0!==B&&B!==k||0!==C&&C!==m){for(var D=0,E=0,G=0,J=0;3>=J;J++)for(var F=0;3>=F;F++,G++){var L=z[B][J]*A[C][F];D+=g[h[G]][0]*L;E+=g[h[G]][1]*L}n[q]=g.length;g.push([D,E]);p[q]=f.length;D=new Uint8Array(3);D[0]=(r[0]*(m-C)+t[0]*C)/m|0;D[1]=(r[1]*(m-C)+t[1]*C)/m|0;D[2]=(r[2]*(m-C)+t[2]*C)/m|0;f.push(D)}}n[0]=h[0];p[0]=e[0];n[m]=h[3];p[m]=e[1];n[l*\nk]=h[12];p[l*k]=e[2];n[l*k+m]=h[15];p[l*k+m]=e[3];this.figures[d]={type:"lattice",coords:n,colors:p,verticesPerRow:l}};b._updateBounds=function(){for(var d=this.coords[0][0],e=this.coords[0][1],g=d,f=e,h=1,k=this.coords.length;h<k;h++){var l=this.coords[h][0],m=this.coords[h][1];d=d>l?l:d;e=e>m?m:e;g=g<l?l:g;f=f<m?m:f}this.bounds=[d,e,g,f]};b._packData=function(){var d,e,g=this.coords,f=new Float32Array(2*g.length);var h=d=0;for(e=g.length;d<e;d++){var k=g[d];f[h++]=k[0];f[h++]=k[1]}this.coords=f;\ng=this.colors;f=new Uint8Array(3*g.length);h=d=0;for(e=g.length;d<e;d++)k=g[d],f[h++]=k[0],f[h++]=k[1],f[h++]=k[2];this.colors=f;g=this.figures;d=0;for(e=g.length;d<e;d++){h=g[d];f=h.coords;var l=h.colors;h=0;for(k=f.length;h<k;h++)f[h]*=2,l[h]*=3}};b.getIR=function(){var d=this.bounds;if(0===d[2]-d[0]||0===d[3]-d[1])throw new oa("Invalid MeshShading bounds: ["+d+"].");return["Mesh",this.shadingType,this.coords,this.colors,this.figures,d,this.bbox,this.background]};return c}(Se);Ng.MIN_SPLIT_PATCH_CHUNKS_AMOUNT=\n3;Ng.MAX_SPLIT_PATCH_CHUNKS_AMOUNT=20;Ng.TRIANGLE_DENSITY=20;var Ds=function(a){function c(){return a.apply(this,arguments)||this}ci(c,a);c.prototype.getIR=function(){return["Dummy"]};return c}(Se),Gs=[1.3877,1,1,1,.97801,.92482,.89552,.91133,.81988,.97566,.98152,.93548,.93548,1.2798,.85284,.92794,1,.96134,1.54657,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.82845,.82845,.85284,.85284,.85284,.75859,.92138,.83908,.7762,.73293,.87289,.73133,.7514,.81921,.87356,.95958,.59526,\n.75727,.69225,1.04924,.9121,.86943,.79795,.88198,.77958,.70864,.81055,.90399,.88653,.96017,.82577,.77892,.78257,.97507,1.54657,.97507,.85284,.89552,.90176,.88762,.8785,.75241,.8785,.90518,.95015,.77618,.8785,.88401,.91916,.86304,.88401,.91488,.8785,.8801,.8785,.8785,.91343,.7173,1.04106,.8785,.85075,.95794,.82616,.85162,.79492,.88331,1.69808,.88331,.85284,.97801,.89552,.91133,.89552,.91133,1.7801,.89552,1.24487,1.13254,1.12401,.96839,.85284,.68787,.70645,.85592,.90747,1.01466,1.0088,.90323,1,1.07463,\n1,.91056,.75806,1.19118,.96839,.78864,.82845,.84133,.75859,.83908,.83908,.83908,.83908,.83908,.83908,.77539,.73293,.73133,.73133,.73133,.73133,.95958,.95958,.95958,.95958,.88506,.9121,.86943,.86943,.86943,.86943,.86943,.85284,.87508,.90399,.90399,.90399,.90399,.77892,.79795,.90807,.88762,.88762,.88762,.88762,.88762,.88762,.8715,.75241,.90518,.90518,.90518,.90518,.88401,.88401,.88401,.88401,.8785,.8785,.8801,.8801,.8801,.8801,.8801,.90747,.89049,.8785,.8785,.8785,.8785,.85162,.8785,.85162,.83908,.88762,\n.83908,.88762,.83908,.88762,.73293,.75241,.73293,.75241,.73293,.75241,.73293,.75241,.87289,.83016,.88506,.93125,.73133,.90518,.73133,.90518,.73133,.90518,.73133,.90518,.73133,.90518,.81921,.77618,.81921,.77618,.81921,.77618,1,1,.87356,.8785,.91075,.89608,.95958,.88401,.95958,.88401,.95958,.88401,.95958,.88401,.95958,.88401,.76229,.90167,.59526,.91916,1,1,.86304,.69225,.88401,1,1,.70424,.79468,.91926,.88175,.70823,.94903,.9121,.8785,1,1,.9121,.8785,.87802,.88656,.8785,.86943,.8801,.86943,.8801,.86943,\n.8801,.87402,.89291,.77958,.91343,1,1,.77958,.91343,.70864,.7173,.70864,.7173,.70864,.7173,.70864,.7173,1,1,.81055,.75841,.81055,1.06452,.90399,.8785,.90399,.8785,.90399,.8785,.90399,.8785,.90399,.8785,.90399,.8785,.96017,.95794,.77892,.85162,.77892,.78257,.79492,.78257,.79492,.78257,.79492,.9297,.56892,.83908,.88762,.77539,.8715,.87508,.89049,1,1,.81055,1.04106,1.20528,1.20528,1,1.15543,.70674,.98387,.94721,1.33431,1.45894,.95161,1.06303,.83908,.80352,.57184,.6965,.56289,.82001,.56029,.81235,1.02988,\n.83908,.7762,.68156,.80367,.73133,.78257,.87356,.86943,.95958,.75727,.89019,1.04924,.9121,.7648,.86943,.87356,.79795,.78275,.81055,.77892,.9762,.82577,.99819,.84896,.95958,.77892,.96108,1.01407,.89049,1.02988,.94211,.96108,.8936,.84021,.87842,.96399,.79109,.89049,1.00813,1.02988,.86077,.87445,.92099,.84723,.86513,.8801,.75638,.85714,.78216,.79586,.87965,.94211,.97747,.78287,.97926,.84971,1.02988,.94211,.8801,.94211,.84971,.73133,1,1,1,1,1,1,1,1,1,1,1,1,.90264,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,\n1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.90518,1,1,1,1,1,1,1,1,1,1,1,1,.90548,1,1,1,1,1,1,.96017,.95794,.96017,.95794,.96017,.95794,.77892,.85162,1,1,.89552,.90527,1,.90363,.92794,.92794,.92794,.92794,.87012,.87012,.87012,.89552,.89552,1.42259,.71143,1.06152,1,1,1.03372,1.03372,.97171,1.4956,2.2807,.93835,.83406,.91133,.84107,.91133,1,1,1,.72021,1,1.23108,.83489,.88525,.88525,.81499,.90527,1.81055,.90527,1.81055,1.31006,1.53711,.94434,1.08696,\n1,.95018,.77192,.85284,.90747,1.17534,.69825,.9716,1.37077,.90747,.90747,.85356,.90747,.90747,1.44947,.85284,.8941,.8941,.70572,.8,.70572,.70572,.70572,.70572,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.99862,.99862,1,1,1,1,1,1.08004,.91027,1,1,1,.99862,1,1,1,1,1,1,1,1,1,1,1,1,.90727,.90727,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],Hs={lineHeight:1.2207,lineGap:.2207},Is=[1.3877,1,1,1,.97801,.92482,.89552,.91133,.81988,.97566,.98152,.93548,.93548,1.2798,.85284,\n.92794,1,.96134,1.56239,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.82845,.82845,.85284,.85284,.85284,.75859,.92138,.83908,.7762,.71805,.87289,.73133,.7514,.81921,.87356,.95958,.59526,.75727,.69225,1.04924,.90872,.85938,.79795,.87068,.77958,.69766,.81055,.90399,.88653,.96068,.82577,.77892,.78257,.97507,1.529,.97507,.85284,.89552,.90176,.94908,.86411,.74012,.86411,.88323,.95015,.86411,.86331,.88401,.91916,.86304,.88401,.9039,.86331,.86331,.86411,.86411,.90464,.70852,1.04106,\n.86331,.84372,.95794,.82616,.84548,.79492,.88331,1.69808,.88331,.85284,.97801,.89552,.91133,.89552,.91133,1.7801,.89552,1.24487,1.13254,1.19129,.96839,.85284,.68787,.70645,.85592,.90747,1.01466,1.0088,.90323,1,1.07463,1,.91056,.75806,1.19118,.96839,.78864,.82845,.84133,.75859,.83908,.83908,.83908,.83908,.83908,.83908,.77539,.71805,.73133,.73133,.73133,.73133,.95958,.95958,.95958,.95958,.88506,.90872,.85938,.85938,.85938,.85938,.85938,.85284,.87068,.90399,.90399,.90399,.90399,.77892,.79795,.90807,\n.94908,.94908,.94908,.94908,.94908,.94908,.85887,.74012,.88323,.88323,.88323,.88323,.88401,.88401,.88401,.88401,.8785,.86331,.86331,.86331,.86331,.86331,.86331,.90747,.89049,.86331,.86331,.86331,.86331,.84548,.86411,.84548,.83908,.94908,.83908,.94908,.83908,.94908,.71805,.74012,.71805,.74012,.71805,.74012,.71805,.74012,.87289,.79538,.88506,.92726,.73133,.88323,.73133,.88323,.73133,.88323,.73133,.88323,.73133,.88323,.81921,.86411,.81921,.86411,.81921,.86411,1,1,.87356,.86331,.91075,.8777,.95958,.88401,\n.95958,.88401,.95958,.88401,.95958,.88401,.95958,.88401,.76467,.90167,.59526,.91916,1,1,.86304,.69225,.88401,1,1,.70424,.77312,.91926,.88175,.70823,.94903,.90872,.86331,1,1,.90872,.86331,.86906,.88116,.86331,.85938,.86331,.85938,.86331,.85938,.86331,.87402,.86549,.77958,.90464,1,1,.77958,.90464,.69766,.70852,.69766,.70852,.69766,.70852,.69766,.70852,1,1,.81055,.75841,.81055,1.06452,.90399,.86331,.90399,.86331,.90399,.86331,.90399,.86331,.90399,.86331,.90399,.86331,.96068,.95794,.77892,.84548,.77892,\n.78257,.79492,.78257,.79492,.78257,.79492,.9297,.56892,.83908,.94908,.77539,.85887,.87068,.89049,1,1,.81055,1.04106,1.20528,1.20528,1,1.15543,.70088,.98387,.94721,1.33431,1.45894,.95161,1.48387,.83908,.80352,.57118,.6965,.56347,.79179,.55853,.80346,1.02988,.83908,.7762,.67174,.86036,.73133,.78257,.87356,.86441,.95958,.75727,.89019,1.04924,.90872,.74889,.85938,.87891,.79795,.7957,.81055,.77892,.97447,.82577,.97466,.87179,.95958,.77892,.94252,.95612,.8753,1.02988,.92733,.94252,.87411,.84021,.8728,.95612,\n.74081,.8753,1.02189,1.02988,.84814,.87445,.91822,.84723,.85668,.86331,.81344,.87581,.76422,.82046,.96057,.92733,.99375,.78022,.95452,.86015,1.02988,.92733,.86331,.92733,.86015,.73133,1,1,1,1,1,1,1,1,1,1,1,1,.90631,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.88323,1,1,1,1,1,1,1,1,1,1,1,1,.85174,1,1,1,1,1,1,.96068,.95794,.96068,.95794,.96068,.95794,.77892,.84548,1,1,.89552,.90527,1,.90363,.92794,.92794,.92794,\n.89807,.87012,.87012,.87012,.89552,.89552,1.42259,.71094,1.06152,1,1,1.03372,1.03372,.97171,1.4956,2.2807,.92972,.83406,.91133,.83326,.91133,1,1,1,.72021,1,1.23108,.83489,.88525,.88525,.81499,.90616,1.81055,.90527,1.81055,1.3107,1.53711,.94434,1.08696,1,.95018,.77192,.85284,.90747,1.17534,.69825,.9716,1.37077,.90747,.90747,.85356,.90747,.90747,1.44947,.85284,.8941,.8941,.70572,.8,.70572,.70572,.70572,.70572,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.99862,\n.99862,1,1,1,1,1,1.08004,.91027,1,1,1,.99862,1,1,1,1,1,1,1,1,1,1,1,1,.90727,.90727,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],Js={lineHeight:1.2207,lineGap:.2207},Ks=[1.3877,1,1,1,1.17223,1.1293,.89552,.91133,.80395,1.02269,1.15601,.91056,.91056,1.2798,.85284,.89807,1,.90861,1.39543,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.96309,.96309,.85284,.85284,.85284,.83319,.88071,.8675,.81552,.72346,.85193,.73206,.7522,.81105,.86275,.90685,.6377,.77892,.75593,1.02638,.89249,.84118,.77452,\n.85374,.75186,.67789,.79776,.88844,.85066,.94309,.77818,.7306,.76659,1.10369,1.38313,1.10369,1.06139,.89552,.8739,.9245,.9245,.83203,.9245,.85865,1.09842,.9245,.9245,1.03297,1.07692,.90918,1.03297,.94959,.9245,.92274,.9245,.9245,1.02933,.77832,1.20562,.9245,.8916,.98986,.86621,.89453,.79004,.94152,1.77256,.94152,.85284,.97801,.89552,.91133,.89552,.91133,1.91729,.89552,1.17889,1.13254,1.16359,.92098,.85284,.68787,.71353,.84737,.90747,1.0088,1.0044,.87683,1,1.09091,1,.92229,.739,1.15642,.92098,.76288,\n.80504,.80972,.75859,.8675,.8675,.8675,.8675,.8675,.8675,.76318,.72346,.73206,.73206,.73206,.73206,.90685,.90685,.90685,.90685,.86477,.89249,.84118,.84118,.84118,.84118,.84118,.85284,.84557,.88844,.88844,.88844,.88844,.7306,.77452,.86331,.9245,.9245,.9245,.9245,.9245,.9245,.84843,.83203,.85865,.85865,.85865,.85865,.82601,.82601,.82601,.82601,.94469,.9245,.92274,.92274,.92274,.92274,.92274,.90747,.86651,.9245,.9245,.9245,.9245,.89453,.9245,.89453,.8675,.9245,.8675,.9245,.8675,.9245,.72346,.83203,.72346,\n.83203,.72346,.83203,.72346,.83203,.85193,.8875,.86477,.99034,.73206,.85865,.73206,.85865,.73206,.85865,.73206,.85865,.73206,.85865,.81105,.9245,.81105,.9245,.81105,.9245,1,1,.86275,.9245,.90872,.93591,.90685,.82601,.90685,.82601,.90685,.82601,.90685,1.03297,.90685,.82601,.77896,1.05611,.6377,1.07692,1,1,.90918,.75593,1.03297,1,1,.76032,.9375,.98156,.93407,.77261,1.11429,.89249,.9245,1,1,.89249,.9245,.92534,.86698,.9245,.84118,.92274,.84118,.92274,.84118,.92274,.8667,.86291,.75186,1.02933,1,1,.75186,\n1.02933,.67789,.77832,.67789,.77832,.67789,.77832,.67789,.77832,1,1,.79776,.97655,.79776,1.23023,.88844,.9245,.88844,.9245,.88844,.9245,.88844,.9245,.88844,.9245,.88844,.9245,.94309,.98986,.7306,.89453,.7306,.76659,.79004,.76659,.79004,.76659,.79004,1.09231,.54873,.8675,.9245,.76318,.84843,.84557,.86651,1,1,.79776,1.20562,1.18622,1.18622,1,1.1437,.67009,.96334,.93695,1.35191,1.40909,.95161,1.48387,.8675,.90861,.6192,.7363,.64824,.82411,.56321,.85696,1.23516,.8675,.81552,.7286,.84134,.73206,.76659,\n.86275,.84369,.90685,.77892,.85871,1.02638,.89249,.75828,.84118,.85984,.77452,.76466,.79776,.7306,.90782,.77818,.903,.87291,.90685,.7306,.99058,1.03667,.94635,1.23516,.9849,.99058,.92393,.8916,.942,1.03667,.75026,.94635,1.0297,1.23516,.90918,.94048,.98217,.89746,.84153,.92274,.82507,.88832,.84438,.88178,1.03525,.9849,1.00225,.78086,.97248,.89404,1.23516,.9849,.92274,.9849,.89404,.73206,1,1,1,1,1,1,1,1,1,1,1,1,.89693,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,\n1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.85865,1,1,1,1,1,1,1,1,1,1,1,1,.90933,1,1,1,1,1,1,.94309,.98986,.94309,.98986,.94309,.98986,.7306,.89453,1,1,.89552,.90527,1,.90186,1.12308,1.12308,1.12308,1.12308,1.2566,1.2566,1.2566,.89552,.89552,1.42259,.68994,1.03809,1,1,1.0176,1.0176,1.11523,1.4956,2.01462,.97858,.82616,.91133,.83437,.91133,1,1,1,.70508,1,1.23108,.79801,.84426,.84426,.774,.90572,1.81055,.90749,1.81055,1.28809,1.55469,.94434,1.07806,1,.97094,.7589,.85284,.90747,1.19658,.69825,\n.97622,1.33512,.90747,.90747,.85284,.90747,.90747,1.44947,.85284,.8941,.8941,.70572,.8,.70572,.70572,.70572,.70572,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.99862,.99862,1,1,1,1,1,1.0336,.91027,1,1,1,.99862,1,1,1,1,1,1,1,1,1,1,1,1,1.05859,1.05859,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],Ls={lineHeight:1.2207,lineGap:.2207},Ms=[1.3877,1,1,1,1.17223,1.1293,.89552,.91133,.80395,1.02269,1.15601,.91056,.91056,1.2798,.85284,.89807,1,.90861,1.39016,.91133,.91133,\n.91133,.91133,.91133,.91133,.91133,.91133,.91133,.91133,.96309,.96309,.85284,.85284,.85284,.83319,.88071,.8675,.81552,.73834,.85193,.73206,.7522,.81105,.86275,.90685,.6377,.77892,.75593,1.02638,.89385,.85122,.77452,.86503,.75186,.68887,.79776,.88844,.85066,.94258,.77818,.7306,.76659,1.10369,1.39016,1.10369,1.06139,.89552,.8739,.86128,.94469,.8457,.94469,.89464,1.09842,.84636,.94469,1.03297,1.07692,.90918,1.03297,.95897,.94469,.9482,.94469,.94469,1.04692,.78223,1.20562,.94469,.90332,.98986,.86621,\n.90527,.79004,.94152,1.77256,.94152,.85284,.97801,.89552,.91133,.89552,.91133,1.91729,.89552,1.17889,1.13254,1.08707,.92098,.85284,.68787,.71353,.84737,.90747,1.0088,1.0044,.87683,1,1.09091,1,.92229,.739,1.15642,.92098,.76288,.80504,.80972,.75859,.8675,.8675,.8675,.8675,.8675,.8675,.76318,.73834,.73206,.73206,.73206,.73206,.90685,.90685,.90685,.90685,.86477,.89385,.85122,.85122,.85122,.85122,.85122,.85284,.85311,.88844,.88844,.88844,.88844,.7306,.77452,.86331,.86128,.86128,.86128,.86128,.86128,.86128,\n.8693,.8457,.89464,.89464,.89464,.89464,.82601,.82601,.82601,.82601,.94469,.94469,.9482,.9482,.9482,.9482,.9482,.90747,.86651,.94469,.94469,.94469,.94469,.90527,.94469,.90527,.8675,.86128,.8675,.86128,.8675,.86128,.73834,.8457,.73834,.8457,.73834,.8457,.73834,.8457,.85193,.92454,.86477,.9921,.73206,.89464,.73206,.89464,.73206,.89464,.73206,.89464,.73206,.89464,.81105,.84636,.81105,.84636,.81105,.84636,1,1,.86275,.94469,.90872,.95786,.90685,.82601,.90685,.82601,.90685,.82601,.90685,1.03297,.90685,\n.82601,.77741,1.05611,.6377,1.07692,1,1,.90918,.75593,1.03297,1,1,.76032,.90452,.98156,1.11842,.77261,1.11429,.89385,.94469,1,1,.89385,.94469,.95877,.86901,.94469,.85122,.9482,.85122,.9482,.85122,.9482,.8667,.90016,.75186,1.04692,1,1,.75186,1.04692,.68887,.78223,.68887,.78223,.68887,.78223,.68887,.78223,1,1,.79776,.92188,.79776,1.23023,.88844,.94469,.88844,.94469,.88844,.94469,.88844,.94469,.88844,.94469,.88844,.94469,.94258,.98986,.7306,.90527,.7306,.76659,.79004,.76659,.79004,.76659,.79004,1.09231,\n.54873,.8675,.86128,.76318,.8693,.85311,.86651,1,1,.79776,1.20562,1.18622,1.18622,1,1.1437,.67742,.96334,.93695,1.35191,1.40909,.95161,1.48387,.86686,.90861,.62267,.74359,.65649,.85498,.56963,.88254,1.23516,.8675,.81552,.75443,.84503,.73206,.76659,.86275,.85122,.90685,.77892,.85746,1.02638,.89385,.75657,.85122,.86275,.77452,.74171,.79776,.7306,.95165,.77818,.89772,.88831,.90685,.7306,.98142,1.02191,.96576,1.23516,.99018,.98142,.9236,.89258,.94035,1.02191,.78848,.96576,.9561,1.23516,.90918,.92578,\n.95424,.89746,.83969,.9482,.80113,.89442,.85208,.86155,.98022,.99018,1.00452,.81209,.99247,.89181,1.23516,.99018,.9482,.99018,.89181,.73206,1,1,1,1,1,1,1,1,1,1,1,1,.88844,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.89464,1,1,1,1,1,1,1,1,1,1,1,1,.96766,1,1,1,1,1,1,.94258,.98986,.94258,.98986,.94258,.98986,.7306,.90527,1,1,.89552,.90527,1,.90186,1.12308,1.12308,1.12308,1.12308,1.2566,1.2566,1.2566,.89552,.89552,\n1.42259,.69043,1.03809,1,1,1.0176,1.0176,1.11523,1.4956,2.01462,.99331,.82616,.91133,.84286,.91133,1,1,1,.70508,1,1.23108,.79801,.84426,.84426,.774,.90527,1.81055,.90527,1.81055,1.28809,1.55469,.94434,1.07806,1,.97094,.7589,.85284,.90747,1.19658,.69825,.97622,1.33512,.90747,.90747,.85356,.90747,.90747,1.44947,.85284,.8941,.8941,.70572,.8,.70572,.70572,.70572,.70572,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.99862,.99862,1,1,1,1,1,1.0336,.91027,1,1,1,.99862,\n1,1,1,1,1,1,1,1,1,1,1,1,1.05859,1.05859,1,1,1,1.07185,.99413,.96334,1.08065,1,1,1,1,1,1,1,1,1,1,1],Ns={lineHeight:1.2207,lineGap:.2207},Os=[.76116,1,1,1.0006,.99998,.99974,.99973,.99973,.99982,.99977,1.00087,.99998,.99998,.99959,1.00003,1.0006,.99998,1.0006,1.0006,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99998,1,1.00003,1.00003,1.00003,1.00026,.9999,.99977,.99977,.99977,.99977,1.00001,1.00026,1.00022,.99977,1.0006,.99973,.99977,1.00026,.99999,.99977,1.00022,1.00001,1.00022,\n.99977,1.00001,1.00026,.99977,1.00001,1.00016,1.00001,1.00001,1.00026,.99998,1.0006,.99998,1.00003,.99973,.99998,.99973,1.00026,.99973,1.00026,.99973,.99998,1.00026,1.00026,1.0006,1.0006,.99973,1.0006,.99982,1.00026,1.00026,1.00026,1.00026,.99959,.99973,.99998,1.00026,.99973,1.00022,.99973,.99973,1,.99959,1.00077,.99959,1.00003,.99998,.99973,.99973,.99973,.99973,1.00077,.99973,.99998,1.00025,.99968,.99973,1.00003,1.00025,.60299,1.00024,1.06409,1,1,.99998,1,.99973,1.0006,.99998,1,.99936,.99973,1.00002,\n1.00002,1.00002,1.00026,.99977,.99977,.99977,.99977,.99977,.99977,1,.99977,1.00001,1.00001,1.00001,1.00001,1.0006,1.0006,1.0006,1.0006,.99977,.99977,1.00022,1.00022,1.00022,1.00022,1.00022,1.00003,1.00022,.99977,.99977,.99977,.99977,1.00001,1.00001,1.00026,.99973,.99973,.99973,.99973,.99973,.99973,.99982,.99973,.99973,.99973,.99973,.99973,1.0006,1.0006,1.0006,1.0006,1.00026,1.00026,1.00026,1.00026,1.00026,1.00026,1.00026,1.06409,1.00026,1.00026,1.00026,1.00026,1.00026,.99973,1.00026,.99973,.99977,\n.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,1.03374,.99977,1.00026,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00022,1.00026,1.00022,1.00026,1.00022,1.00026,1.00022,1.00026,.99977,1.00026,.99977,1.00026,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.00042,.99973,.99973,1.0006,.99977,.99973,.99973,1.00026,1.0006,1.00026,1.0006,1.00026,1.03828,1.00026,.99999,1.00026,1.0006,.99977,1.00026,\n.99977,1.00026,.99977,1.00026,.9993,.9998,1.00026,1.00022,1.00026,1.00022,1.00026,1.00022,1.00026,1,1.00016,.99977,.99959,.99977,.99959,.99977,.99959,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00026,.99998,1.00026,.8121,1.00026,.99998,.99977,1.00026,.99977,1.00026,.99977,1.00026,.99977,1.00026,.99977,1.00026,.99977,1.00026,1.00016,1.00022,1.00001,.99973,1.00001,1.00026,1,1.00026,1,1.00026,1,1.0006,.99973,.99977,.99973,1,.99982,1.00022,1.00026,1.00001,.99973,1.00026,.99998,.99998,\n.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,1.00034,.99977,1,.99997,1.00026,1.00078,1.00036,.99973,1.00013,1.0006,.99977,.99977,.99988,.85148,1.00001,1.00026,.99977,1.00022,1.0006,.99977,1.00001,.99999,.99977,1.00069,1.00022,.99977,1.00001,.99984,1.00026,1.00001,1.00024,1.00001,.9999,1,1.0006,1.00001,1.00041,.99962,1.00026,1.0006,.99995,1.00041,.99942,.99973,.99927,1.00082,.99902,1.00026,1.00087,1.0006,1.00069,.99973,.99867,.99973,.9993,1.00026,1.00049,1.00056,1,.99988,.99935,.99995,\n.99954,1.00055,.99945,1.00032,1.0006,.99995,1.00026,.99995,1.00032,1.00001,1.00008,.99971,1.00019,.9994,1.00001,1.0006,1.00044,.99973,1.00023,1.00047,1,.99942,.99561,.99989,1.00035,.99977,1.00035,.99977,1.00019,.99944,1.00001,1.00021,.99926,1.00035,1.00035,.99942,1.00048,.99999,.99977,1.00022,1.00035,1.00001,.99977,1.00026,.99989,1.00057,1.00001,.99936,1.00052,1.00012,.99996,1.00043,1,1.00035,.9994,.99976,1.00035,.99973,1.00052,1.00041,1.00119,1.00037,.99973,1.00002,.99986,1.00041,1.00041,.99902,\n.9996,1.00034,.99999,1.00026,.99999,1.00026,.99973,1.00052,.99973,1,.99973,1.00041,1.00075,.9994,1.0003,.99999,1,1.00041,.99955,1,.99915,.99973,.99973,1.00026,1.00119,.99955,.99973,1.0006,.99911,1.0006,1.00026,.99972,1.00026,.99902,1.00041,.99973,.99999,1,1,1.00038,1.0005,1.00016,1.00022,1.00016,1.00022,1.00016,1.00022,1.00001,.99973,1,1,.99973,1,1,.99955,1.0006,1.0006,1.0006,1.0006,1,1,1,.99973,.99973,.99972,1,1,1.00106,.99999,.99998,.99998,.99999,.99998,1.66475,1,.99973,.99973,1.00023,.99973,.99971,\n1.00047,1.00023,1,.99991,.99984,1.00002,1.00002,1.00002,1.00002,1,1,1,1,1,1,1,.99972,1,1.20985,1.39713,1.00003,1.00031,1.00015,1,.99561,1.00027,1.00031,1.00031,.99915,1.00031,1.00031,.99999,1.00003,.99999,.99999,1.41144,1.6,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,\n1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.40579,1.40579,1.36625,.99999,1,.99861,.99861,1,1.00026,1.00026,1.00026,1.00026,.99972,.99999,.99999,.99999,.99999,1.40483,1,.99977,1.00054,1,1,.99953,.99962,1.00042,.9995,1,1,1,1,1,1,1,1,.99998,.99998,.99998,.99998,1,1,1,1,1,1,1,1,1,1,1],Ps={lineHeight:1.2,lineGap:.2},Qs=[.76116,1,1,1.0006,.99998,.99974,.99973,.99973,.99982,.99977,1.00087,.99998,.99998,.99959,1.00003,1.0006,.99998,1.0006,1.0006,.99973,.99973,.99973,.99973,.99973,.99973,\n.99973,.99973,.99973,.99973,.99998,1,1.00003,1.00003,1.00003,1.00026,.9999,.99977,.99977,.99977,.99977,1.00001,1.00026,1.00022,.99977,1.0006,.99973,.99977,1.00026,.99999,.99977,1.00022,1.00001,1.00022,.99977,1.00001,1.00026,.99977,1.00001,1.00016,1.00001,1.00001,1.00026,.99998,1.0006,.99998,1.00003,.99973,.99998,.99973,1.00026,.99973,1.00026,.99973,.99998,1.00026,1.00026,1.0006,1.0006,.99973,1.0006,.99982,1.00026,1.00026,1.00026,1.00026,.99959,.99973,.99998,1.00026,.99973,1.00022,.99973,.99973,1,\n.99959,1.00077,.99959,1.00003,.99998,.99973,.99973,.99973,.99973,1.00077,.99973,.99998,1.00025,.99968,.99973,1.00003,1.00025,.60299,1.00024,1.06409,1,1,.99998,1,.99973,1.0006,.99998,1,.99936,.99973,1.00002,1.00002,1.00002,1.00026,.99977,.99977,.99977,.99977,.99977,.99977,1,.99977,1.00001,1.00001,1.00001,1.00001,1.0006,1.0006,1.0006,1.0006,.99977,.99977,1.00022,1.00022,1.00022,1.00022,1.00022,1.00003,1.00022,.99977,.99977,.99977,.99977,1.00001,1.00001,1.00026,.99973,.99973,.99973,.99973,.99973,.99973,\n.99982,.99973,.99973,.99973,.99973,.99973,1.0006,1.0006,1.0006,1.0006,1.00026,1.00026,1.00026,1.00026,1.00026,1.00026,1.00026,1.06409,1.00026,1.00026,1.00026,1.00026,1.00026,.99973,1.00026,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,1.0044,.99977,1.00026,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00022,1.00026,1.00022,1.00026,1.00022,1.00026,1.00022,1.00026,.99977,1.00026,.99977,1.00026,1.0006,1.0006,\n1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,.99971,.99973,.99973,1.0006,.99977,.99973,.99973,1.00026,1.0006,1.00026,1.0006,1.00026,1.01011,1.00026,.99999,1.00026,1.0006,.99977,1.00026,.99977,1.00026,.99977,1.00026,.9993,.9998,1.00026,1.00022,1.00026,1.00022,1.00026,1.00022,1.00026,1,1.00016,.99977,.99959,.99977,.99959,.99977,.99959,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00026,.99998,1.00026,.8121,1.00026,.99998,.99977,1.00026,.99977,1.00026,.99977,1.00026,.99977,\n1.00026,.99977,1.00026,.99977,1.00026,1.00016,1.00022,1.00001,.99973,1.00001,1.00026,1,1.00026,1,1.00026,1,1.0006,.99973,.99977,.99973,1,.99982,1.00022,1.00026,1.00001,.99973,1.00026,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99977,1,1,1.00026,.99969,.99972,.99981,.9998,1.0006,.99977,.99977,1.00022,.91155,1.00001,1.00026,.99977,1.00022,1.0006,.99977,1.00001,.99999,.99977,.99966,1.00022,1.00032,1.00001,.99944,1.00026,1.00001,.99968,1.00001,1.00047,1,1.0006,\n1.00001,.99981,1.00101,1.00026,1.0006,.99948,.99981,1.00064,.99973,.99942,1.00101,1.00061,1.00026,1.00069,1.0006,1.00014,.99973,1.01322,.99973,1.00065,1.00026,1.00012,.99923,1,1.00064,1.00076,.99948,1.00055,1.00063,1.00007,.99943,1.0006,.99948,1.00026,.99948,.99943,1.00001,1.00001,1.00029,1.00038,1.00035,1.00001,1.0006,1.0006,.99973,.99978,1.00001,1.00057,.99989,.99967,.99964,.99967,.99977,.99999,.99977,1.00038,.99977,1.00001,.99973,1.00066,.99967,.99967,1.00041,.99998,.99999,.99977,1.00022,.99967,\n1.00001,.99977,1.00026,.99964,1.00031,1.00001,.99999,.99999,1,1.00023,1,1,.99999,1.00035,1.00001,.99999,.99973,.99977,.99999,1.00058,.99973,.99973,.99955,.9995,1.00026,1.00026,1.00032,.99989,1.00034,.99999,1.00026,1.00026,1.00026,.99973,.45998,.99973,1.00026,.99973,1.00001,.99999,.99982,.99994,.99996,1,1.00042,1.00044,1.00029,1.00023,.99973,.99973,1.00026,.99949,1.00002,.99973,1.0006,1.0006,1.0006,.99975,1.00026,1.00026,1.00032,.98685,.99973,1.00026,1,1,.99966,1.00044,1.00016,1.00022,1.00016,1.00022,\n1.00016,1.00022,1.00001,.99973,1,1,.99973,1,1,.99955,1.0006,1.0006,1.0006,1.0006,1,1,1,.99973,.99973,.99972,1,1,1.00106,.99999,.99998,.99998,.99999,.99998,1.66475,1,.99973,.99973,1,.99973,.99971,.99978,1,1,.99991,.99984,1.00002,1.00002,1.00002,1.00002,1.00098,1,1,1,1.00049,1,1,.99972,1,1.20985,1.39713,1.00003,1.00031,1.00015,1,.99561,1.00027,1.00031,1.00031,.99915,1.00031,1.00031,.99999,1.00003,.99999,.99999,1.41144,1.6,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,\n1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.40579,1.40579,1.36625,.99999,1,.99861,.99861,1,1.00026,1.00026,1.00026,1.00026,.99972,.99999,.99999,.99999,.99999,1.40483,1,.99977,1.00054,1,1,.99953,.99962,1.00042,.9995,1,1,1,1,1,1,1,1,.99998,.99998,.99998,.99998,1,1,1,1,1,1,1,1,1,1,\n1],Rs={lineHeight:1.35,lineGap:.2},Ss=[.76116,1,1,1.0006,1.0006,1.00006,.99973,.99973,.99982,1.00001,1.00043,.99998,.99998,.99959,1.00003,1.0006,.99998,1.0006,1.0006,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,1.0006,1,1.00003,1.00003,1.00003,.99973,.99987,1.00001,1.00001,.99977,.99977,1.00001,1.00026,1.00022,.99977,1.0006,1,1.00001,.99973,.99999,.99977,1.00022,1.00001,1.00022,.99977,1.00001,1.00026,.99977,1.00001,1.00016,1.00001,1.00001,1.00026,1.0006,1.0006,1.0006,.99949,\n.99973,.99998,.99973,.99973,1,.99973,.99973,1.0006,.99973,.99973,.99924,.99924,1,.99924,.99999,.99973,.99973,.99973,.99973,.99998,1,1.0006,.99973,1,.99977,1,1,1,1.00005,1.0009,1.00005,1.00003,.99998,.99973,.99973,.99973,.99973,1.0009,.99973,.99998,1.00025,.99968,.99973,1.00003,1.00025,.60299,1.00024,1.06409,1,1,.99998,1,.9998,1.0006,.99998,1,.99936,.99973,1.00002,1.00002,1.00002,1.00026,1.00001,1.00001,1.00001,1.00001,1.00001,1.00001,1,.99977,1.00001,1.00001,1.00001,1.00001,1.0006,1.0006,1.0006,1.0006,\n.99977,.99977,1.00022,1.00022,1.00022,1.00022,1.00022,1.00003,1.00022,.99977,.99977,.99977,.99977,1.00001,1.00001,1.00026,.99973,.99973,.99973,.99973,.99973,.99973,.99982,1,.99973,.99973,.99973,.99973,1.0006,1.0006,1.0006,1.0006,.99973,.99973,.99973,.99973,.99973,.99973,.99973,1.06409,1.00026,.99973,.99973,.99973,.99973,1,.99973,1,1.00001,.99973,1.00001,.99973,1.00001,.99973,.99977,1,.99977,1,.99977,1,.99977,1,.99977,1.0288,.99977,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,\n1.00001,.99973,1.00022,.99973,1.00022,.99973,1.00022,.99973,1.00022,.99973,.99977,.99973,.99977,.99973,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,.99924,1.0006,1.0006,.99946,1.00034,1,.99924,1.00001,1,1,.99973,.99924,.99973,.99924,.99973,1.06311,.99973,1.00024,.99973,.99924,.99977,.99973,.99977,.99973,.99977,.99973,1.00041,.9998,.99973,1.00022,.99973,1.00022,.99973,1.00022,.99973,1,1.00016,.99977,.99998,.99977,.99998,.99977,.99998,1.00001,1,1.00001,1,1.00001,1,1.00001,1,1.00026,1.0006,1.00026,\n.89547,1.00026,1.0006,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,1.00016,.99977,1.00001,1,1.00001,1.00026,1,1.00026,1,1.00026,1,.99924,.99973,1.00001,.99973,1,.99982,1.00022,1.00026,1.00001,1,1.00026,1.0006,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,1.00001,1,1.00054,.99977,1.00084,1.00007,.99973,1.00013,.99924,1.00001,1.00001,.99945,.91221,1.00001,1.00026,.99977,1.00022,1.0006,1.00001,1.00001,.99999,.99977,.99933,1.00022,\n1.00054,1.00001,1.00065,1.00026,1.00001,1.0001,1.00001,1.00052,1,1.0006,1.00001,.99945,.99897,.99968,.99924,1.00036,.99945,.99949,1,1.0006,.99897,.99918,.99968,.99911,.99924,1,.99962,1.01487,1,1.0005,.99973,1.00012,1.00043,1,.99995,.99994,1.00036,.99947,1.00019,1.00063,1.00025,.99924,1.00036,.99973,1.00036,1.00025,1.00001,1.00001,1.00027,1.0001,1.00068,1.00001,1.0006,1.0006,1,1.00008,.99957,.99972,.9994,.99954,.99975,1.00051,1.00001,1.00019,1.00001,1.0001,.99986,1.00001,1.00001,1.00038,.99954,.99954,\n.9994,1.00066,.99999,.99977,1.00022,1.00054,1.00001,.99977,1.00026,.99975,1.0001,1.00001,.99993,.9995,.99955,1.00016,.99978,.99974,1.00019,1.00022,.99955,1.00053,.99973,1.00089,1.00005,.99967,1.00048,.99973,1.00002,1.00034,.99973,.99973,.99964,1.00006,1.00066,.99947,.99973,.98894,.99973,1,.44898,1,.99946,1,1.00039,1.00082,.99991,.99991,.99985,1.00022,1.00023,1.00061,1.00006,.99966,.99973,.99973,.99973,1.00019,1.0008,1,.99924,.99924,.99924,.99983,1.00044,.99973,.99964,.98332,1,.99973,1,1,.99962,.99895,\n1.00016,.99977,1.00016,.99977,1.00016,.99977,1.00001,1,1,1,.99973,1,1,.99955,.99924,.99924,.99924,.99924,.99998,.99998,.99998,.99973,.99973,.99972,1,1,1.00267,.99999,.99998,.99998,1,.99998,1.66475,1,.99973,.99973,1.00023,.99973,1.00423,.99925,.99999,1,.99991,.99984,1.00002,1.00002,1.00002,1.00002,1.00049,1,1.00245,1,1,1,1,.96329,1,1.20985,1.39713,1.00003,.8254,1.00015,1,1.00035,1.00027,1.00031,1.00031,1.00003,1.00031,1.00031,.99999,1.00003,.99999,.99999,1.41144,1.6,1.41144,1.41144,1.41144,1.41144,\n1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.40579,1.40579,1.36625,.99999,1,.99861,.99861,1,1.00026,1.00026,1.00026,1.00026,.95317,.99999,.99999,.99999,.99999,1.40483,1,.99977,1.00054,1,1,.99953,.99962,1.00042,.9995,1,1,1,1,1,1,1,1,\n.99998,.99998,.99998,.99998,1,1,1,1,1,1,1,1,1,1,1],Ts={lineHeight:1.35,lineGap:.2},Us=[.76116,1,1,1.0006,1.0006,1.00006,.99973,.99973,.99982,1.00001,1.00043,.99998,.99998,.99959,1.00003,1.0006,.99998,1.0006,1.0006,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,.99973,1.0006,1,1.00003,1.00003,1.00003,.99973,.99987,1.00001,1.00001,.99977,.99977,1.00001,1.00026,1.00022,.99977,1.0006,1,1.00001,.99973,.99999,.99977,1.00022,1.00001,1.00022,.99977,1.00001,1.00026,.99977,1.00001,1.00016,1.00001,\n1.00001,1.00026,1.0006,1.0006,1.0006,.99949,.99973,.99998,.99973,.99973,1,.99973,.99973,1.0006,.99973,.99973,.99924,.99924,1,.99924,.99999,.99973,.99973,.99973,.99973,.99998,1,1.0006,.99973,1,.99977,1,1,1,1.00005,1.0009,1.00005,1.00003,.99998,.99973,.99973,.99973,.99973,1.0009,.99973,.99998,1.00025,.99968,.99973,1.00003,1.00025,.60299,1.00024,1.06409,1,1,.99998,1,.9998,1.0006,.99998,1,.99936,.99973,1.00002,1.00002,1.00002,1.00026,1.00001,1.00001,1.00001,1.00001,1.00001,1.00001,1,.99977,1.00001,1.00001,\n1.00001,1.00001,1.0006,1.0006,1.0006,1.0006,.99977,.99977,1.00022,1.00022,1.00022,1.00022,1.00022,1.00003,1.00022,.99977,.99977,.99977,.99977,1.00001,1.00001,1.00026,.99973,.99973,.99973,.99973,.99973,.99973,.99982,1,.99973,.99973,.99973,.99973,1.0006,1.0006,1.0006,1.0006,.99973,.99973,.99973,.99973,.99973,.99973,.99973,1.06409,1.00026,.99973,.99973,.99973,.99973,1,.99973,1,1.00001,.99973,1.00001,.99973,1.00001,.99973,.99977,1,.99977,1,.99977,1,.99977,1,.99977,1.04596,.99977,.99973,1.00001,.99973,\n1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00001,.99973,1.00022,.99973,1.00022,.99973,1.00022,.99973,1.00022,.99973,.99977,.99973,.99977,.99973,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,1.0006,.99924,1.0006,1.0006,1.00019,1.00034,1,.99924,1.00001,1,1,.99973,.99924,.99973,.99924,.99973,1.02572,.99973,1.00005,.99973,.99924,.99977,.99973,.99977,.99973,.99977,.99973,.99999,.9998,.99973,1.00022,.99973,1.00022,.99973,1.00022,.99973,1,1.00016,.99977,.99998,.99977,.99998,.99977,.99998,1.00001,1,1.00001,\n1,1.00001,1,1.00001,1,1.00026,1.0006,1.00026,.84533,1.00026,1.0006,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,.99977,.99973,1.00016,.99977,1.00001,1,1.00001,1.00026,1,1.00026,1,1.00026,1,.99924,.99973,1.00001,.99973,1,.99982,1.00022,1.00026,1.00001,1,1.00026,1.0006,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99998,.99928,1,.99977,1.00013,1.00055,.99947,.99945,.99941,.99924,1.00001,1.00001,1.0004,.91621,1.00001,1.00026,.99977,1.00022,1.0006,1.00001,\n1.00005,.99999,.99977,1.00015,1.00022,.99977,1.00001,.99973,1.00026,1.00001,1.00019,1.00001,.99946,1,1.0006,1.00001,.99978,1.00045,.99973,.99924,1.00023,.99978,.99966,1,1.00065,1.00045,1.00019,.99973,.99973,.99924,1,1,.96499,1,1.00055,.99973,1.00008,1.00027,1,.9997,.99995,1.00023,.99933,1.00019,1.00015,1.00031,.99924,1.00023,.99973,1.00023,1.00031,1.00001,.99928,1.00029,1.00092,1.00035,1.00001,1.0006,1.0006,1,.99988,.99975,1,1.00082,.99561,.9996,1.00035,1.00001,.99962,1.00001,1.00092,.99964,1.00001,\n.99963,.99999,1.00035,1.00035,1.00082,.99962,.99999,.99977,1.00022,1.00035,1.00001,.99977,1.00026,.9996,.99967,1.00001,1.00034,1.00074,1.00054,1.00053,1.00063,.99971,.99962,1.00035,.99975,.99977,.99973,1.00043,.99953,1.0007,.99915,.99973,1.00008,.99892,1.00073,1.00073,1.00114,.99915,1.00073,.99955,.99973,1.00092,.99973,1,.99998,1,1.0003,1,1.00043,1.00001,.99969,1.0003,1,1.00035,1.00001,.9995,1,1.00092,.99973,.99973,.99973,1.0007,.9995,1,.99924,1.0006,.99924,.99972,1.00062,.99973,1.00114,1.00073,1,\n.99955,1,1,1.00047,.99968,1.00016,.99977,1.00016,.99977,1.00016,.99977,1.00001,1,1,1,.99973,1,1,.99955,.99924,.99924,.99924,.99924,.99998,.99998,.99998,.99973,.99973,.99972,1,1,1.00267,.99999,.99998,.99998,1,.99998,1.66475,1,.99973,.99973,1.00023,.99973,.99971,.99925,1.00023,1,.99991,.99984,1.00002,1.00002,1.00002,1.00002,1,1,1,1,1,1,1,.96329,1,1.20985,1.39713,1.00003,.8254,1.00015,1,1.00035,1.00027,1.00031,1.00031,.99915,1.00031,1.00031,.99999,1.00003,.99999,.99999,1.41144,1.6,1.41144,1.41144,1.41144,\n1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.41144,1.40579,1.40579,1.36625,.99999,1,.99861,.99861,1,1.00026,1.00026,1.00026,1.00026,.95317,.99999,.99999,.99999,.99999,1.40483,1,.99977,1.00054,1,1,.99953,.99962,1.00042,.9995,1,1,1,1,\n1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],Vs={lineHeight:1.2,lineGap:.2},yf=[365,0,333,278,333,474,556,556,889,722,238,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,333,333,584,584,584,611,975,722,722,722,722,667,611,778,722,278,556,722,611,833,722,778,667,778,722,667,611,722,667,944,667,667,611,333,278,333,584,556,333,556,611,556,611,556,333,611,611,278,278,556,278,889,611,611,611,611,389,556,333,611,556,778,556,556,500,389,280,389,584,333,556,556,556,556,280,556,333,737,370,\n556,584,737,552,400,549,333,333,333,576,556,278,333,333,365,556,834,834,834,611,722,722,722,722,722,722,1E3,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,556,556,556,556,556,278,278,278,278,611,611,611,611,611,611,611,549,611,611,611,611,611,556,611,556,722,556,722,556,722,556,722,556,722,556,722,556,722,556,722,719,722,611,667,556,667,556,667,556,667,556,667,556,778,611,778,611,778,611,778,611,722,611,722,611,278,278,\n278,278,278,278,278,278,278,278,785,556,556,278,722,556,556,611,278,611,278,611,385,611,479,611,278,722,611,722,611,722,611,708,723,611,778,611,778,611,778,611,1E3,944,722,389,722,389,722,389,667,556,667,556,667,556,667,556,611,333,611,479,611,333,722,611,722,611,722,611,722,611,722,611,722,611,944,778,667,556,667,611,500,611,500,611,500,278,556,722,556,1E3,889,778,611,667,556,611,333,333,333,333,333,333,333,333,333,333,333,465,722,333,853,906,474,825,927,838,278,722,722,601,719,667,611,722,778,278,\n722,667,833,722,644,778,722,667,600,611,667,821,667,809,802,278,667,615,451,611,278,582,615,610,556,606,475,460,611,541,278,558,556,612,556,445,611,766,619,520,684,446,582,715,576,753,845,278,582,611,582,845,667,669,885,567,711,667,278,276,556,1094,1062,875,610,722,622,719,722,719,722,567,712,667,904,626,719,719,610,702,833,722,778,719,667,722,611,622,854,667,730,703,1005,1019,870,979,719,711,1031,719,556,618,615,417,635,556,709,497,615,615,500,635,740,604,611,604,611,556,490,556,875,556,615,581,\n833,844,729,854,615,552,854,583,556,556,611,417,552,556,278,281,278,969,906,611,500,615,556,604,778,611,487,447,944,778,944,778,944,778,667,556,333,333,556,1E3,1E3,552,278,278,278,278,500,500,500,556,556,350,1E3,1E3,240,479,333,333,604,333,167,396,556,556,1094,556,885,489,1115,1E3,768,600,834,834,834,834,1E3,500,1E3,500,1E3,500,500,494,612,823,713,584,549,713,979,722,274,549,549,583,549,549,604,584,604,604,708,625,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,\n708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,729,604,604,354,354,1E3,990,990,990,990,494,604,604,604,604,354,1021,1052,917,750,750,531,656,594,510,500,750,750,611,611,333,333,333,333,333,333,333,333,222,222,333,333,333,333,333,333,333,333],zf=[-1,-1,-1,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,\n98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,161,162,163,164,165,166,167,168,169,170,171,172,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255,256,257,258,\n259,260,261,262,263,264,265,266,267,268,269,270,271,272,273,274,275,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,305,306,307,308,309,310,311,312,313,314,315,316,317,318,319,320,321,322,323,324,325,326,327,328,329,330,331,332,333,334,335,336,337,338,339,340,341,342,343,344,345,346,347,348,349,350,351,352,353,354,355,356,357,358,359,360,361,362,363,364,365,366,367,368,369,370,371,372,373,374,375,376,377,378,379,380,381,382,383,402,\n506,507,508,509,510,511,536,537,538,539,710,711,713,728,729,730,731,732,733,900,901,902,903,904,905,906,908,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,931,932,933,934,935,936,937,938,939,940,941,942,943,944,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,962,963,964,965,966,967,968,969,970,971,972,973,974,1024,1025,1026,1027,1028,1029,1030,1031,1032,1033,1034,1035,1036,1037,1038,1039,1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,\n1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1138,1139,1168,1169,7808,7809,7810,7811,7812,7813,7922,7923,8208,8209,8211,8212,8213,8215,8216,8217,8218,8219,8220,8221,8222,8224,8225,8226,8230,8240,8242,8243,8249,\n8250,8252,8254,8260,8319,8355,8356,8359,8364,8453,8467,8470,8482,8486,8494,8539,8540,8541,8542,8592,8593,8594,8595,8596,8597,8616,8706,8710,8719,8721,8722,8730,8734,8735,8745,8747,8776,8800,8801,8804,8805,8962,8976,8992,8993,9472,9474,9484,9488,9492,9496,9500,9508,9516,9524,9532,9552,9553,9554,9555,9556,9557,9558,9559,9560,9561,9562,9563,9564,9565,9566,9567,9568,9569,9570,9571,9572,9573,9574,9575,9576,9577,9578,9579,9580,9600,9604,9608,9612,9616,9617,9618,9619,9632,9633,9642,9643,9644,9650,9658,9660,\n9668,9674,9675,9679,9688,9689,9702,9786,9787,9788,9792,9794,9824,9827,9829,9830,9834,9835,9836,61441,61442,61445,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],Af=[365,0,333,278,333,474,556,556,889,722,238,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,333,333,584,584,584,611,975,722,722,722,722,667,611,778,722,278,556,722,611,833,722,778,667,778,722,667,611,722,667,944,667,667,611,333,278,333,584,556,333,556,611,556,611,556,333,611,611,278,278,556,278,889,611,611,611,\n611,389,556,333,611,556,778,556,556,500,389,280,389,584,333,556,556,556,556,280,556,333,737,370,556,584,737,552,400,549,333,333,333,576,556,278,333,333,365,556,834,834,834,611,722,722,722,722,722,722,1E3,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,556,556,556,556,556,278,278,278,278,611,611,611,611,611,611,611,549,611,611,611,611,611,556,611,556,722,556,722,556,722,556,722,556,722,556,722,556,722,556,722,740,722,611,\n667,556,667,556,667,556,667,556,667,556,778,611,778,611,778,611,778,611,722,611,722,611,278,278,278,278,278,278,278,278,278,278,782,556,556,278,722,556,556,611,278,611,278,611,396,611,479,611,278,722,611,722,611,722,611,708,723,611,778,611,778,611,778,611,1E3,944,722,389,722,389,722,389,667,556,667,556,667,556,667,556,611,333,611,479,611,333,722,611,722,611,722,611,722,611,722,611,722,611,944,778,667,556,667,611,500,611,500,611,500,278,556,722,556,1E3,889,778,611,667,556,611,333,333,333,333,333,333,\n333,333,333,333,333,333,722,333,854,906,473,844,930,847,278,722,722,610,671,667,611,722,778,278,722,667,833,722,657,778,718,667,590,611,667,822,667,829,781,278,667,620,479,611,278,591,620,621,556,610,479,492,611,558,278,566,556,603,556,450,611,712,605,532,664,409,591,704,578,773,834,278,591,611,591,834,667,667,886,614,719,667,278,278,556,1094,1042,854,622,719,677,719,722,708,722,614,722,667,927,643,719,719,615,687,833,722,778,719,667,722,611,677,781,667,729,708,979,989,854,1E3,708,719,1042,729,556,\n619,604,534,618,556,736,510,611,611,507,622,740,604,611,611,611,556,889,556,885,556,646,583,889,935,707,854,594,552,865,589,556,556,611,469,563,556,278,278,278,969,906,611,507,619,556,611,778,611,575,467,944,778,944,778,944,778,667,556,333,333,556,1E3,1E3,552,278,278,278,278,500,500,500,556,556,350,1E3,1E3,240,479,333,333,604,333,167,396,556,556,1104,556,885,516,1146,1E3,768,600,834,834,834,834,999,500,1E3,500,1E3,500,500,494,612,823,713,584,549,713,979,722,274,549,549,583,549,549,604,584,604,604,\n708,625,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,729,604,604,354,354,1E3,990,990,990,990,494,604,604,604,604,354,1021,1052,917,750,750,531,656,594,510,500,750,750,611,611,333,333,333,333,333,333,333,333,222,222,333,333,333,333,333,333,333,333],Bf=[-1,-1,-1,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,\n67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,161,162,163,164,165,166,167,168,169,170,171,172,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,\n236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255,256,257,258,259,260,261,262,263,264,265,266,267,268,269,270,271,272,273,274,275,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,305,306,307,308,309,310,311,312,313,314,315,316,317,318,319,320,321,322,323,324,325,326,327,328,329,330,331,332,333,334,335,336,337,338,339,340,341,342,343,344,345,346,347,348,349,350,351,352,353,354,355,356,357,358,359,360,361,\n362,363,364,365,366,367,368,369,370,371,372,373,374,375,376,377,378,379,380,381,382,383,402,506,507,508,509,510,511,536,537,538,539,710,711,713,728,729,730,731,732,733,900,901,902,903,904,905,906,908,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,931,932,933,934,935,936,937,938,939,940,941,942,943,944,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,962,963,964,965,966,967,968,969,970,971,972,973,974,1024,1025,1026,1027,1028,1029,1030,1031,1032,\n1033,1034,1035,1036,1037,1038,1039,1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1138,1139,1168,1169,7808,7809,7810,7811,7812,7813,7922,7923,8208,8209,\n8211,8212,8213,8215,8216,8217,8218,8219,8220,8221,8222,8224,8225,8226,8230,8240,8242,8243,8249,8250,8252,8254,8260,8319,8355,8356,8359,8364,8453,8467,8470,8482,8486,8494,8539,8540,8541,8542,8592,8593,8594,8595,8596,8597,8616,8706,8710,8719,8721,8722,8730,8734,8735,8745,8747,8776,8800,8801,8804,8805,8962,8976,8992,8993,9472,9474,9484,9488,9492,9496,9500,9508,9516,9524,9532,9552,9553,9554,9555,9556,9557,9558,9559,9560,9561,9562,9563,9564,9565,9566,9567,9568,9569,9570,9571,9572,9573,9574,9575,9576,9577,\n9578,9579,9580,9600,9604,9608,9612,9616,9617,9618,9619,9632,9633,9642,9643,9644,9650,9658,9660,9668,9674,9675,9679,9688,9689,9702,9786,9787,9788,9792,9794,9824,9827,9829,9830,9834,9835,9836,61441,61442,61445,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],Cf=[365,0,333,278,278,355,556,556,889,667,191,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,278,278,584,584,584,556,1015,667,667,722,722,667,611,778,722,278,500,667,556,833,722,778,667,778,722,667,611,722,667,944,667,\n667,611,278,278,278,469,556,333,556,556,500,556,556,278,556,556,222,222,500,222,833,556,556,556,556,333,500,278,556,500,722,500,500,500,334,260,334,584,333,556,556,556,556,260,556,333,737,370,556,584,737,552,400,549,333,333,333,576,537,278,333,333,365,556,834,834,834,611,667,667,667,667,667,667,1E3,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,556,556,556,556,889,500,556,556,556,556,278,278,278,278,556,556,556,556,556,556,556,549,611,556,\n556,556,556,500,556,500,667,556,667,556,667,556,722,500,722,500,722,500,722,500,722,625,722,556,667,556,667,556,667,556,667,556,667,556,778,556,778,556,778,556,778,556,722,556,722,556,278,278,278,278,278,278,278,222,278,278,733,444,500,222,667,500,500,556,222,556,222,556,281,556,400,556,222,722,556,722,556,722,556,615,723,556,778,556,778,556,778,556,1E3,944,722,333,722,333,722,333,667,500,667,500,667,500,667,500,611,278,611,354,611,278,722,556,722,556,722,556,722,556,722,556,722,556,944,722,667,500,\n667,611,500,611,500,611,500,222,556,667,556,1E3,889,778,611,667,500,611,278,333,333,333,333,333,333,333,333,333,333,333,667,278,789,846,389,794,865,775,222,667,667,570,671,667,611,722,778,278,667,667,833,722,648,778,725,667,600,611,667,837,667,831,761,278,667,570,439,555,222,550,570,571,500,556,439,463,555,542,222,500,492,548,500,447,556,670,573,486,603,374,550,652,546,728,779,222,550,556,550,779,667,667,843,544,708,667,278,278,500,1066,982,844,589,715,639,724,667,651,667,544,704,667,917,614,715,\n715,589,686,833,722,778,725,667,722,611,639,795,667,727,673,920,923,805,886,651,694,1022,682,556,562,522,493,553,556,688,465,556,556,472,564,686,550,556,556,556,500,833,500,835,500,572,518,830,851,621,736,526,492,752,534,556,556,556,378,496,500,222,222,222,910,828,556,472,565,500,556,778,556,492,339,944,722,944,722,944,722,667,500,333,333,556,1E3,1E3,552,222,222,222,222,333,333,333,556,556,350,1E3,1E3,188,354,333,333,500,333,167,365,556,556,1094,556,885,323,1083,1E3,768,600,834,834,834,834,1E3,500,\n998,500,1E3,500,500,494,612,823,713,584,549,713,979,719,274,549,549,584,549,549,604,584,604,604,708,625,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,729,604,604,354,354,1E3,990,990,990,990,494,604,604,604,604,354,1021,1052,917,750,750,531,656,594,510,500,750,750,500,500,333,333,333,333,333,333,333,333,222,222,294,294,324,324,316,328,398,285],Df=[-1,-1,-1,32,33,34,\n35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,161,162,163,164,165,166,167,168,169,170,171,172,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,\n212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255,256,257,258,259,260,261,262,263,264,265,266,267,268,269,270,271,272,273,274,275,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,305,306,307,308,309,310,311,312,313,314,315,316,317,318,319,320,321,322,323,324,325,326,327,328,329,330,331,332,333,334,335,336,337,\n338,339,340,341,342,343,344,345,346,347,348,349,350,351,352,353,354,355,356,357,358,359,360,361,362,363,364,365,366,367,368,369,370,371,372,373,374,375,376,377,378,379,380,381,382,383,402,506,507,508,509,510,511,536,537,538,539,710,711,713,728,729,730,731,732,733,900,901,902,903,904,905,906,908,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,931,932,933,934,935,936,937,938,939,940,941,942,943,944,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,962,\n963,964,965,966,967,968,969,970,971,972,973,974,1024,1025,1026,1027,1028,1029,1030,1031,1032,1033,1034,1035,1036,1037,1038,1039,1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,1097,1098,1099,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,\n1115,1116,1117,1118,1119,1138,1139,1168,1169,7808,7809,7810,7811,7812,7813,7922,7923,8208,8209,8211,8212,8213,8215,8216,8217,8218,8219,8220,8221,8222,8224,8225,8226,8230,8240,8242,8243,8249,8250,8252,8254,8260,8319,8355,8356,8359,8364,8453,8467,8470,8482,8486,8494,8539,8540,8541,8542,8592,8593,8594,8595,8596,8597,8616,8706,8710,8719,8721,8722,8730,8734,8735,8745,8747,8776,8800,8801,8804,8805,8962,8976,8992,8993,9472,9474,9484,9488,9492,9496,9500,9508,9516,9524,9532,9552,9553,9554,9555,9556,9557,9558,\n9559,9560,9561,9562,9563,9564,9565,9566,9567,9568,9569,9570,9571,9572,9573,9574,9575,9576,9577,9578,9579,9580,9600,9604,9608,9612,9616,9617,9618,9619,9632,9633,9642,9643,9644,9650,9658,9660,9668,9674,9675,9679,9688,9689,9702,9786,9787,9788,9792,9794,9824,9827,9829,9830,9834,9835,9836,61441,61442,61445,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],Ef=[365,0,333,278,278,355,556,556,889,667,191,333,333,389,584,278,333,278,278,556,556,556,556,556,556,556,556,556,556,278,278,584,584,584,556,1015,\n667,667,722,722,667,611,778,722,278,500,667,556,833,722,778,667,778,722,667,611,722,667,944,667,667,611,278,278,278,469,556,333,556,556,500,556,556,278,556,556,222,222,500,222,833,556,556,556,556,333,500,278,556,500,722,500,500,500,334,260,334,584,333,556,556,556,556,260,556,333,737,370,556,584,737,552,400,549,333,333,333,576,537,278,333,333,365,556,834,834,834,611,667,667,667,667,667,667,1E3,722,667,667,667,667,278,278,278,278,722,722,778,778,778,778,778,584,778,722,722,722,722,667,667,611,556,556,\n556,556,556,556,889,500,556,556,556,556,278,278,278,278,556,556,556,556,556,556,556,549,611,556,556,556,556,500,556,500,667,556,667,556,667,556,722,500,722,500,722,500,722,500,722,615,722,556,667,556,667,556,667,556,667,556,667,556,778,556,778,556,778,556,778,556,722,556,722,556,278,278,278,278,278,278,278,222,278,278,735,444,500,222,667,500,500,556,222,556,222,556,292,556,334,556,222,722,556,722,556,722,556,604,723,556,778,556,778,556,778,556,1E3,944,722,333,722,333,722,333,667,500,667,500,667,500,\n667,500,611,278,611,375,611,278,722,556,722,556,722,556,722,556,722,556,722,556,944,722,667,500,667,611,500,611,500,611,500,222,556,667,556,1E3,889,778,611,667,500,611,278,333,333,333,333,333,333,333,333,333,333,333,667,278,784,838,384,774,855,752,222,667,667,551,668,667,611,722,778,278,667,668,833,722,650,778,722,667,618,611,667,798,667,835,748,278,667,578,446,556,222,547,578,575,500,557,446,441,556,556,222,500,500,576,500,448,556,690,569,482,617,395,547,648,525,713,781,222,547,556,547,781,667,667,\n865,542,719,667,278,278,500,1057,1010,854,583,722,635,719,667,656,667,542,677,667,923,604,719,719,583,656,833,722,778,719,667,722,611,635,760,667,740,667,917,938,792,885,656,719,1010,722,556,573,531,365,583,556,669,458,559,559,438,583,688,552,556,542,556,500,458,500,823,500,573,521,802,823,625,719,521,510,750,542,556,556,556,365,510,500,222,278,222,906,812,556,438,559,500,552,778,556,489,411,944,722,944,722,944,722,667,500,333,333,556,1E3,1E3,552,222,222,222,222,333,333,333,556,556,350,1E3,1E3,188,\n354,333,333,500,333,167,365,556,556,1094,556,885,323,1073,1E3,768,600,834,834,834,834,1E3,500,1E3,500,1E3,500,500,494,612,823,713,584,549,713,979,719,274,549,549,583,549,549,604,584,604,604,708,625,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,708,729,604,604,354,354,1E3,990,990,990,990,494,604,604,604,604,354,1021,1052,917,750,750,531,656,594,510,500,750,750,500,500,333,\n333,333,333,333,333,333,333,222,222,294,294,324,324,316,328,398,285],Ff=[-1,-1,-1,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,161,162,163,164,165,166,167,168,169,170,171,172,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,\n189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255,256,257,258,259,260,261,262,263,264,265,266,267,268,269,270,271,272,273,274,275,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,292,293,294,295,296,297,298,299,300,301,302,303,304,305,306,307,308,309,310,311,312,313,314,\n315,316,317,318,319,320,321,322,323,324,325,326,327,328,329,330,331,332,333,334,335,336,337,338,339,340,341,342,343,344,345,346,347,348,349,350,351,352,353,354,355,356,357,358,359,360,361,362,363,364,365,366,367,368,369,370,371,372,373,374,375,376,377,378,379,380,381,382,383,402,506,507,508,509,510,511,536,537,538,539,710,711,713,728,729,730,731,732,733,900,901,902,903,904,905,906,908,910,911,912,913,914,915,916,917,918,919,920,921,922,923,924,925,926,927,928,929,931,932,933,934,935,936,937,938,939,\n940,941,942,943,944,945,946,947,948,949,950,951,952,953,954,955,956,957,958,959,960,961,962,963,964,965,966,967,968,969,970,971,972,973,974,1024,1025,1026,1027,1028,1029,1030,1031,1032,1033,1034,1035,1036,1037,1038,1039,1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1062,1063,1064,1065,1066,1067,1068,1069,1070,1071,1072,1073,1074,1075,1076,1077,1078,1079,1080,1081,1082,1083,1084,1085,1086,1087,1088,1089,1090,1091,1092,1093,1094,1095,1096,\n1097,1098,1099,1100,1101,1102,1103,1104,1105,1106,1107,1108,1109,1110,1111,1112,1113,1114,1115,1116,1117,1118,1119,1138,1139,1168,1169,7808,7809,7810,7811,7812,7813,7922,7923,8208,8209,8211,8212,8213,8215,8216,8217,8218,8219,8220,8221,8222,8224,8225,8226,8230,8240,8242,8243,8249,8250,8252,8254,8260,8319,8355,8356,8359,8364,8453,8467,8470,8482,8486,8494,8539,8540,8541,8542,8592,8593,8594,8595,8596,8597,8616,8706,8710,8719,8721,8722,8730,8734,8735,8745,8747,8776,8800,8801,8804,8805,8962,8976,8992,8993,\n9472,9474,9484,9488,9492,9496,9500,9508,9516,9524,9532,9552,9553,9554,9555,9556,9557,9558,9559,9560,9561,9562,9563,9564,9565,9566,9567,9568,9569,9570,9571,9572,9573,9574,9575,9576,9577,9578,9579,9580,9600,9604,9608,9612,9616,9617,9618,9619,9632,9633,9642,9643,9644,9650,9658,9660,9668,9674,9675,9679,9688,9689,9702,9786,9787,9788,9792,9794,9824,9827,9829,9830,9834,9835,9836,61441,61442,61445,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1],Ws=[1.36898,1,1,.72706,.80479,.83734,.98894,.99793,.9897,\n.93884,.86209,.94292,.94292,1.16661,1.02058,.93582,.96694,.93582,1.19137,.99793,.99793,.99793,.99793,.99793,.99793,.99793,.99793,.99793,.99793,.78076,.78076,1.02058,1.02058,1.02058,.72851,.78966,.90838,.83637,.82391,.96376,.80061,.86275,.8768,.95407,1.0258,.73901,.85022,.83655,1.0156,.95546,.92179,.87107,.92179,.82114,.8096,.89713,.94438,.95353,.94083,.91905,.90406,.9446,.94292,1.18777,.94292,1.02058,.89903,.90088,.94938,.97898,.81093,.97571,.94938,1.024,.9577,.95933,.98621,1.0474,.97455,.98981,.9672,\n.95933,.9446,.97898,.97407,.97646,.78036,1.10208,.95442,.95298,.97579,.9332,.94039,.938,.80687,1.01149,.80687,1.02058,.80479,.99793,.99793,.99793,.99793,1.01149,1.00872,.90088,.91882,1.0213,.8361,1.02058,.62295,.54324,.89022,1.08595,1,1,.90088,1,.97455,.93582,.90088,1,1.05686,.8361,.99642,.99642,.99642,.72851,.90838,.90838,.90838,.90838,.90838,.90838,.868,.82391,.80061,.80061,.80061,.80061,1.0258,1.0258,1.0258,1.0258,.97484,.95546,.92179,.92179,.92179,.92179,.92179,1.02058,.92179,.94438,.94438,.94438,\n.94438,.90406,.86958,.98225,.94938,.94938,.94938,.94938,.94938,.94938,.9031,.81093,.94938,.94938,.94938,.94938,.98621,.98621,.98621,.98621,.93969,.95933,.9446,.9446,.9446,.9446,.9446,1.08595,.9446,.95442,.95442,.95442,.95442,.94039,.97898,.94039,.90838,.94938,.90838,.94938,.90838,.94938,.82391,.81093,.82391,.81093,.82391,.81093,.82391,.81093,.96376,.84313,.97484,.97571,.80061,.94938,.80061,.94938,.80061,.94938,.80061,.94938,.80061,.94938,.8768,.9577,.8768,.9577,.8768,.9577,1,1,.95407,.95933,.97069,\n.95933,1.0258,.98621,1.0258,.98621,1.0258,.98621,1.0258,.98621,1.0258,.98621,.887,1.01591,.73901,1.0474,1,1,.97455,.83655,.98981,1,1,.83655,.73977,.83655,.73903,.84638,1.033,.95546,.95933,1,1,.95546,.95933,.8271,.95417,.95933,.92179,.9446,.92179,.9446,.92179,.9446,.936,.91964,.82114,.97646,1,1,.82114,.97646,.8096,.78036,.8096,.78036,1,1,.8096,.78036,1,1,.89713,.77452,.89713,1.10208,.94438,.95442,.94438,.95442,.94438,.95442,.94438,.95442,.94438,.95442,.94438,.95442,.94083,.97579,.90406,.94039,.90406,\n.9446,.938,.9446,.938,.9446,.938,1,.99793,.90838,.94938,.868,.9031,.92179,.9446,1,1,.89713,1.10208,.90088,.90088,.90088,.90088,.90088,.90088,.90088,.90088,.90088,.90989,.9358,.91945,.83181,.75261,.87992,.82976,.96034,.83689,.97268,1.0078,.90838,.83637,.8019,.90157,.80061,.9446,.95407,.92436,1.0258,.85022,.97153,1.0156,.95546,.89192,.92179,.92361,.87107,.96318,.89713,.93704,.95638,.91905,.91709,.92796,1.0258,.93704,.94836,1.0373,.95933,1.0078,.95871,.94836,.96174,.92601,.9498,.98607,.95776,.95933,\n1.05453,1.0078,.98275,.9314,.95617,.91701,1.05993,.9446,.78367,.9553,1,.86832,1.0128,.95871,.99394,.87548,.96361,.86774,1.0078,.95871,.9446,.95871,.86774,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.94083,.97579,.94083,.97579,.94083,.97579,.90406,.94039,.96694,1,.89903,1,1,1,.93582,.93582,.93582,1,.908,.908,.918,.94219,.94219,.96544,1,1.285,1,\n1,.81079,.81079,1,1,.74854,1,1,1,1,.99793,1,1,1,.65,1,1.36145,1,1,1,1,1,1,1,1,1,1,1,1.17173,1,.80535,.76169,1.02058,1.0732,1.05486,1,1,1.30692,1.08595,1.08595,1,1.08595,1.08595,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1.16161,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],Xs={lineHeight:1.2,lineGap:.2},Ys=[1.36898,1,1,.66227,.80779,.81625,.97276,.97276,.97733,.92222,.83266,.94292,.94292,1.16148,\n1.02058,.93582,.96694,.93582,1.17337,.97276,.97276,.97276,.97276,.97276,.97276,.97276,.97276,.97276,.97276,.78076,.78076,1.02058,1.02058,1.02058,.71541,.76813,.85576,.80591,.80729,.94299,.77512,.83655,.86523,.92222,.98621,.71743,.81698,.79726,.98558,.92222,.90637,.83809,.90637,.80729,.76463,.86275,.90699,.91605,.9154,.85308,.85458,.90531,.94292,1.21296,.94292,1.02058,.89903,1.18616,.99613,.91677,.78216,.91677,.90083,.98796,.9135,.92168,.95381,.98981,.95298,.95381,.93459,.92168,.91513,.92004,.91677,\n.95077,.748,1.04502,.91677,.92061,.94236,.89544,.89364,.9,.80687,.8578,.80687,1.02058,.80779,.97276,.97276,.97276,.97276,.8578,.99973,1.18616,.91339,1.08074,.82891,1.02058,.55509,.71526,.89022,1.08595,1,1,1.18616,1,.96736,.93582,1.18616,1,1.04864,.82711,.99043,.99043,.99043,.71541,.85576,.85576,.85576,.85576,.85576,.85576,.845,.80729,.77512,.77512,.77512,.77512,.98621,.98621,.98621,.98621,.95961,.92222,.90637,.90637,.90637,.90637,.90637,1.02058,.90251,.90699,.90699,.90699,.90699,.85458,.83659,.94951,\n.99613,.99613,.99613,.99613,.99613,.99613,.85811,.78216,.90083,.90083,.90083,.90083,.95381,.95381,.95381,.95381,.9135,.92168,.91513,.91513,.91513,.91513,.91513,1.08595,.91677,.91677,.91677,.91677,.91677,.89364,.92332,.89364,.85576,.99613,.85576,.99613,.85576,.99613,.80729,.78216,.80729,.78216,.80729,.78216,.80729,.78216,.94299,.76783,.95961,.91677,.77512,.90083,.77512,.90083,.77512,.90083,.77512,.90083,.77512,.90083,.86523,.9135,.86523,.9135,.86523,.9135,1,1,.92222,.92168,.92222,.92168,.98621,.95381,\n.98621,.95381,.98621,.95381,.98621,.95381,.98621,.95381,.86036,.97096,.71743,.98981,1,1,.95298,.79726,.95381,1,1,.79726,.6894,.79726,.74321,.81691,1.0006,.92222,.92168,1,1,.92222,.92168,.79464,.92098,.92168,.90637,.91513,.90637,.91513,.90637,.91513,.909,.87514,.80729,.95077,1,1,.80729,.95077,.76463,.748,.76463,.748,1,1,.76463,.748,1,1,.86275,.72651,.86275,1.04502,.90699,.91677,.90699,.91677,.90699,.91677,.90699,.91677,.90699,.91677,.90699,.91677,.9154,.94236,.85458,.89364,.85458,.90531,.9,.90531,\n.9,.90531,.9,1,.97276,.85576,.99613,.845,.85811,.90251,.91677,1,1,.86275,1.04502,1.18616,1.18616,1.18616,1.18616,1.18616,1.18616,1.18616,1.18616,1.18616,1.00899,1.30628,.85576,.80178,.66862,.7927,.69323,.88127,.72459,.89711,.95381,.85576,.80591,.7805,.94729,.77512,.90531,.92222,.90637,.98621,.81698,.92655,.98558,.92222,.85359,.90637,.90976,.83809,.94523,.86275,.83509,.93157,.85308,.83392,.92346,.98621,.83509,.92886,.91324,.92168,.95381,.90646,.92886,.90557,.86847,.90276,.91324,.86842,.92168,.99531,\n.95381,.9224,.85408,.92699,.86847,1.0051,.91513,.80487,.93481,1,.88159,1.05214,.90646,.97355,.81539,.89398,.85923,.95381,.90646,.91513,.90646,.85923,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.9154,.94236,.9154,.94236,.9154,.94236,.85458,.89364,.96694,1,.89903,1,1,1,.91782,.91782,.91782,1,.896,.896,.896,.9332,.9332,.95973,1,1.26,1,1,.80479,.80178,\n1,1,.85633,1,1,1,1,.97276,1,1,1,.698,1,1.36145,1,1,1,1,1,1,1,1,1,1,1,1.14542,1,.79199,.78694,1.02058,1.03493,1.05486,1,1,1.23026,1.08595,1.08595,1,1.08595,1.08595,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1.20006,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],Zs={lineHeight:1.2,lineGap:.2},$s=[1.36898,1,1,.65507,.84943,.85639,.88465,.88465,.86936,.88307,.86948,.85283,.85283,1.06383,1.02058,\n.75945,.9219,.75945,1.17337,.88465,.88465,.88465,.88465,.88465,.88465,.88465,.88465,.88465,.88465,.75945,.75945,1.02058,1.02058,1.02058,.69046,.70926,.85158,.77812,.76852,.89591,.70466,.76125,.80094,.86822,.83864,.728,.77212,.79475,.93637,.87514,.8588,.76013,.8588,.72421,.69866,.77598,.85991,.80811,.87832,.78112,.77512,.8562,1.0222,1.18417,1.0222,1.27014,.89903,1.15012,.93859,.94399,.846,.94399,.81453,1.0186,.94219,.96017,1.03075,1.02175,.912,1.03075,.96998,.96017,.93859,.94399,.94399,.95493,.746,\n1.12658,.94578,.91,.979,.882,.882,.83,.85034,.83537,.85034,1.02058,.70869,.88465,.88465,.88465,.88465,.83537,.90083,1.15012,.9161,.94565,.73541,1.02058,.53609,.69353,.79519,1.08595,1,1,1.15012,1,.91974,.75945,1.15012,1,.9446,.73361,.9005,.9005,.9005,.62864,.85158,.85158,.85158,.85158,.85158,.85158,.773,.76852,.70466,.70466,.70466,.70466,.83864,.83864,.83864,.83864,.90561,.87514,.8588,.8588,.8588,.8588,.8588,1.02058,.85751,.85991,.85991,.85991,.85991,.77512,.76013,.88075,.93859,.93859,.93859,.93859,\n.93859,.93859,.8075,.846,.81453,.81453,.81453,.81453,.82424,.82424,.82424,.82424,.9278,.96017,.93859,.93859,.93859,.93859,.93859,1.08595,.8562,.94578,.94578,.94578,.94578,.882,.94578,.882,.85158,.93859,.85158,.93859,.85158,.93859,.76852,.846,.76852,.846,.76852,.846,.76852,.846,.89591,.8544,.90561,.94399,.70466,.81453,.70466,.81453,.70466,.81453,.70466,.81453,.70466,.81453,.80094,.94219,.80094,.94219,.80094,.94219,1,1,.86822,.96017,.86822,.96017,.83864,.82424,.83864,.82424,.83864,.82424,.83864,1.03075,\n.83864,.82424,.81402,1.02738,.728,1.02175,1,1,.912,.79475,1.03075,1,1,.79475,.83911,.79475,.66266,.80553,1.06676,.87514,.96017,1,1,.87514,.96017,.86865,.87396,.96017,.8588,.93859,.8588,.93859,.8588,.93859,.867,.84759,.72421,.95493,1,1,.72421,.95493,.69866,.746,.69866,.746,1,1,.69866,.746,1,1,.77598,.88417,.77598,1.12658,.85991,.94578,.85991,.94578,.85991,.94578,.85991,.94578,.85991,.94578,.85991,.94578,.87832,.979,.77512,.882,.77512,.8562,.83,.8562,.83,.8562,.83,1,.88465,.85158,.93859,.773,.8075,\n.85751,.8562,1,1,.77598,1.12658,1.15012,1.15012,1.15012,1.15012,1.15012,1.15313,1.15012,1.15012,1.15012,1.08106,1.03901,.85158,.77025,.62264,.7646,.65351,.86026,.69461,.89947,1.03075,.85158,.77812,.76449,.88836,.70466,.8562,.86822,.8588,.83864,.77212,.85308,.93637,.87514,.82352,.8588,.85701,.76013,.89058,.77598,.8156,.82565,.78112,.77899,.89386,.83864,.8156,.9486,.92388,.96186,1.03075,.91123,.9486,.93298,.878,.93942,.92388,.84596,.96186,.95119,1.03075,.922,.88787,.95829,.88,.93559,.93859,.78815,.93758,\n1,.89217,1.03737,.91123,.93969,.77487,.85769,.86799,1.03075,.91123,.93859,.91123,.86799,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.87832,.979,.87832,.979,.87832,.979,.77512,.882,.9219,1,.89903,1,1,1,.87321,.87321,.87321,1,1.027,1.027,1.027,.86847,.86847,.79121,1,1.124,1,1,.73572,.73572,1,1,.85034,1,1,1,1,.88465,1,1,1,.669,1,1.36145,1,1,1,1,1,\n1,1,1,1,1,1,1.04828,1,.74948,.75187,1.02058,.98391,1.02119,1,1,1.06233,1.08595,1.08595,1,1.08595,1.08595,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1.05233,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],at={lineHeight:1.2,lineGap:.2},bt=[1.36898,1,1,.76305,.82784,.94935,.89364,.92241,.89073,.90706,.98472,.85283,.85283,1.0664,1.02058,.74505,.9219,.74505,1.23456,.92241,.92241,.92241,.92241,.92241,\n.92241,.92241,.92241,.92241,.92241,.74505,.74505,1.02058,1.02058,1.02058,.73002,.72601,.91755,.8126,.80314,.92222,.73764,.79726,.83051,.90284,.86023,.74,.8126,.84869,.96518,.91115,.8858,.79761,.8858,.74498,.73914,.81363,.89591,.83659,.89633,.85608,.8111,.90531,1.0222,1.22736,1.0222,1.27014,.89903,.90088,.86667,1.0231,.896,1.01411,.90083,1.05099,1.00512,.99793,1.05326,1.09377,.938,1.06226,1.00119,.99793,.98714,1.0231,1.01231,.98196,.792,1.19137,.99074,.962,1.01915,.926,.942,.856,.85034,.92006,.85034,\n1.02058,.69067,.92241,.92241,.92241,.92241,.92006,.9332,.90088,.91882,.93484,.75339,1.02058,.56866,.54324,.79519,1.08595,1,1,.90088,1,.95325,.74505,.90088,1,.97198,.75339,.91009,.91009,.91009,.66466,.91755,.91755,.91755,.91755,.91755,.91755,.788,.80314,.73764,.73764,.73764,.73764,.86023,.86023,.86023,.86023,.92915,.91115,.8858,.8858,.8858,.8858,.8858,1.02058,.8858,.89591,.89591,.89591,.89591,.8111,.79611,.89713,.86667,.86667,.86667,.86667,.86667,.86667,.86936,.896,.90083,.90083,.90083,.90083,.84224,\n.84224,.84224,.84224,.97276,.99793,.98714,.98714,.98714,.98714,.98714,1.08595,.89876,.99074,.99074,.99074,.99074,.942,1.0231,.942,.91755,.86667,.91755,.86667,.91755,.86667,.80314,.896,.80314,.896,.80314,.896,.80314,.896,.92222,.93372,.92915,1.01411,.73764,.90083,.73764,.90083,.73764,.90083,.73764,.90083,.73764,.90083,.83051,1.00512,.83051,1.00512,.83051,1.00512,1,1,.90284,.99793,.90976,.99793,.86023,.84224,.86023,.84224,.86023,.84224,.86023,1.05326,.86023,.84224,.82873,1.07469,.74,1.09377,1,1,.938,\n.84869,1.06226,1,1,.84869,.83704,.84869,.81441,.85588,1.08927,.91115,.99793,1,1,.91115,.99793,.91887,.90991,.99793,.8858,.98714,.8858,.98714,.8858,.98714,.894,.91434,.74498,.98196,1,1,.74498,.98196,.73914,.792,.73914,.792,1,1,.73914,.792,1,1,.81363,.904,.81363,1.19137,.89591,.99074,.89591,.99074,.89591,.99074,.89591,.99074,.89591,.99074,.89591,.99074,.89633,1.01915,.8111,.942,.8111,.90531,.856,.90531,.856,.90531,.856,1,.92241,.91755,.86667,.788,.86936,.8858,.89876,1,1,.81363,1.19137,.90088,.90088,\n.90088,.90088,.90088,.90088,.90088,.90088,.90088,.90388,1.03901,.92138,.78105,.7154,.86169,.80513,.94007,.82528,.98612,1.06226,.91755,.8126,.81884,.92819,.73764,.90531,.90284,.8858,.86023,.8126,.91172,.96518,.91115,.83089,.8858,.87791,.79761,.89297,.81363,.88157,.89992,.85608,.81992,.94307,.86023,.88157,.95308,.98699,.99793,1.06226,.95817,.95308,.97358,.928,.98088,.98699,.92761,.99793,.96017,1.06226,.986,.944,.95978,.938,.96705,.98714,.80442,.98972,1,.89762,1.04552,.95817,.99007,.87064,.91879,.88888,\n1.06226,.95817,.98714,.95817,.88888,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.89633,1.01915,.89633,1.01915,.89633,1.01915,.8111,.942,.9219,1,.89903,1,1,1,.93173,.93173,.93173,1,1.06304,1.06304,1.06904,.89903,.89903,.80549,1,1.156,1,1,.76575,.76575,1,1,.72458,1,1,1,1,.92241,1,1,1,.619,1,1.36145,1,1,1,1,1,1,1,1,1,1,1,1.07257,1,.74705,.71119,1.02058,\n1.024,1.02119,1,1,1.1536,1.08595,1.08595,1,1.08595,1.08595,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1.05638,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],ct={lineHeight:1.2,lineGap:.2},dt=[1.76738,1,1,.99297,.9824,1.04016,1.06497,1.03424,.97529,1.17647,1.23203,1.1085,1.1085,1.16939,1.2107,.9754,1.21408,.9754,1.59578,1.03424,1.03424,1.03424,1.03424,1.03424,1.03424,1.03424,1.03424,1.03424,1.03424,\n.81378,.81378,1.2107,1.2107,1.2107,.71703,.97847,.97363,.88776,.8641,1.02096,.79795,.85132,.914,1.06085,1.1406,.8007,.89858,.83693,1.14889,1.09398,.97489,.92094,.97489,.90399,.84041,.95923,1.00135,1,1.06467,.98243,.90996,.99361,1.1085,1.56942,1.1085,1.2107,.74627,.94282,.96752,1.01519,.86304,1.01359,.97278,1.15103,1.01359,.98561,1.02285,1.02285,1.00527,1.02285,1.0302,.99041,1.0008,1.01519,1.01359,1.02258,.79104,1.16862,.99041,.97454,1.02511,.99298,.96752,.95801,.94856,1.16579,.94856,1.2107,.9824,\n1.03424,1.03424,1,1.03424,1.16579,.8727,1.3871,1.18622,1.10818,1.04478,1.2107,1.18622,.75155,.94994,1.28826,1.21408,1.21408,.91056,1,.91572,.9754,.64663,1.18328,1.24866,1.04478,1.14169,1.15749,1.17389,.71703,.97363,.97363,.97363,.97363,.97363,.97363,.93506,.8641,.79795,.79795,.79795,.79795,1.1406,1.1406,1.1406,1.1406,1.02096,1.09398,.97426,.97426,.97426,.97426,.97426,1.2107,.97489,1.00135,1.00135,1.00135,1.00135,.90996,.92094,1.02798,.96752,.96752,.96752,.96752,.96752,.96752,.93136,.86304,.97278,\n.97278,.97278,.97278,1.02285,1.02285,1.02285,1.02285,.97122,.99041,1,1,1,1,1,1.28826,1.0008,.99041,.99041,.99041,.99041,.96752,1.01519,.96752,.97363,.96752,.97363,.96752,.97363,.96752,.8641,.86304,.8641,.86304,.8641,.86304,.8641,.86304,1.02096,1.03057,1.02096,1.03517,.79795,.97278,.79795,.97278,.79795,.97278,.79795,.97278,.79795,.97278,.914,1.01359,.914,1.01359,.914,1.01359,1,1,1.06085,.98561,1.06085,1.00879,1.1406,1.02285,1.1406,1.02285,1.1406,1.02285,1.1406,1.02285,1.1406,1.02285,.97138,1.08692,\n.8007,1.02285,1,1,1.00527,.83693,1.02285,1,1,.83693,.9455,.83693,.90418,.83693,1.13005,1.09398,.99041,1,1,1.09398,.99041,.96692,1.09251,.99041,.97489,1.0008,.97489,1.0008,.97489,1.0008,.93994,.97931,.90399,1.02258,1,1,.90399,1.02258,.84041,.79104,.84041,.79104,.84041,.79104,.84041,.79104,1,1,.95923,1.07034,.95923,1.16862,1.00135,.99041,1.00135,.99041,1.00135,.99041,1.00135,.99041,1.00135,.99041,1.00135,.99041,1.06467,1.02511,.90996,.96752,.90996,.99361,.95801,.99361,.95801,.99361,.95801,1.07733,1.03424,\n.97363,.96752,.93506,.93136,.97489,1.0008,1,1,.95923,1.16862,1.15103,1.15103,1.01173,1.03959,.75953,.81378,.79912,1.15103,1.21994,.95161,.87815,1.01149,.81525,.7676,.98167,1.01134,1.02546,.84097,1.03089,1.18102,.97363,.88776,.85134,.97826,.79795,.99361,1.06085,.97489,1.1406,.89858,1.0388,1.14889,1.09398,.86039,.97489,1.0595,.92094,.94793,.95923,.90996,.99346,.98243,1.02112,.95493,1.1406,.90996,1.03574,1.02597,1.0008,1.18102,1.06628,1.03574,1.0192,1.01932,1.00886,.97531,1.0106,1.0008,1.13189,1.18102,\n1.02277,.98683,1.0016,.99561,1.07237,1.0008,.90434,.99921,.93803,.8965,1.23085,1.06628,1.04983,.96268,1.0499,.98439,1.18102,1.06628,1.0008,1.06628,.98439,.79795,1,1,1,1,1,1,1,1,1,1,1,1,1.09466,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.97278,1,1,1,1,1,1,1,1,1,1,1,1,1.02065,1,1,1,1,1,1,1.06467,1.02511,1.06467,1.02511,1.06467,1.02511,.90996,.96752,1,1.21408,.89903,1,1,.75155,1.04394,1.04394,1.04394,1.04394,.98633,\n.98633,.98633,.73047,.73047,1.20642,.91211,1.25635,1.222,1.02956,1.03372,1.03372,.96039,1.24633,1,1.12454,.93503,1.03424,1.19687,1.03424,1,1,1,.771,1,1,1.15749,1.15749,1.15749,1.10948,.86279,.94434,.86279,.94434,.86182,1,1,1.16897,1,.96085,.90137,1.2107,1.18416,1.13973,.69825,.9716,2.10339,1.29004,1.29004,1.21172,1.29004,1.29004,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1.42603,1,.99862,.99862,1,.87025,.87025,.87025,.87025,1.18874,1.42603,\n1,1.42603,1.42603,.99862,1,1,1,1,1,1.2886,1.04315,1.15296,1.34163,1,1,1,1.09193,1.09193,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],et={lineHeight:1.33008,lineGap:0},ft=[1.76738,1,1,.98946,1.03959,1.04016,1.02809,1.036,.97639,1.10953,1.23203,1.11144,1.11144,1.16939,1.21237,.9754,1.21261,.9754,1.59754,1.036,1.036,1.036,1.036,1.036,1.036,1.036,1.036,1.036,1.036,.81378,.81378,1.21237,1.21237,1.21237,.73541,.97847,.97363,.89723,.87897,1.0426,.79429,.85292,.91149,1.05815,1.1406,.79631,.90128,.83853,1.04396,1.10615,\n.97552,.94436,.97552,.88641,.80527,.96083,1.00135,1,1.06777,.9817,.91142,.99361,1.11144,1.57293,1.11144,1.21237,.74627,1.31818,1.06585,.97042,.83055,.97042,.93503,1.1261,.97042,.97922,1.14236,.94552,1.01054,1.14236,1.02471,.97922,.94165,.97042,.97042,1.0276,.78929,1.1261,.97922,.95874,1.02197,.98507,.96752,.97168,.95107,1.16579,.95107,1.21237,1.03959,1.036,1.036,1,1.036,1.16579,.87357,1.31818,1.18754,1.26781,1.05356,1.21237,1.18622,.79487,.94994,1.29004,1.24047,1.24047,1.31818,1,.91484,.9754,1.31818,\n1.1349,1.24866,1.05356,1.13934,1.15574,1.17389,.73541,.97363,.97363,.97363,.97363,.97363,.97363,.94385,.87897,.79429,.79429,.79429,.79429,1.1406,1.1406,1.1406,1.1406,1.0426,1.10615,.97552,.97552,.97552,.97552,.97552,1.21237,.97552,1.00135,1.00135,1.00135,1.00135,.91142,.94436,.98721,1.06585,1.06585,1.06585,1.06585,1.06585,1.06585,.96705,.83055,.93503,.93503,.93503,.93503,1.14236,1.14236,1.14236,1.14236,.93125,.97922,.94165,.94165,.94165,.94165,.94165,1.29004,.94165,.97922,.97922,.97922,.97922,.96752,\n.97042,.96752,.97363,1.06585,.97363,1.06585,.97363,1.06585,.87897,.83055,.87897,.83055,.87897,.83055,.87897,.83055,1.0426,1.0033,1.0426,.97042,.79429,.93503,.79429,.93503,.79429,.93503,.79429,.93503,.79429,.93503,.91149,.97042,.91149,.97042,.91149,.97042,1,1,1.05815,.97922,1.05815,.97922,1.1406,1.14236,1.1406,1.14236,1.1406,1.14236,1.1406,1.14236,1.1406,1.14236,.97441,1.04302,.79631,1.01582,1,1,1.01054,.83853,1.14236,1,1,.83853,1.09125,.83853,.90418,.83853,1.19508,1.10615,.97922,1,1,1.10615,.97922,\n1.01034,1.10466,.97922,.97552,.94165,.97552,.94165,.97552,.94165,.91602,.91981,.88641,1.0276,1,1,.88641,1.0276,.80527,.78929,.80527,.78929,.80527,.78929,.80527,.78929,1,1,.96083,1.05403,.95923,1.16862,1.00135,.97922,1.00135,.97922,1.00135,.97922,1.00135,.97922,1.00135,.97922,1.00135,.97922,1.06777,1.02197,.91142,.96752,.91142,.99361,.97168,.99361,.97168,.99361,.97168,1.23199,1.036,.97363,1.06585,.94385,.96705,.97552,.94165,1,1,.96083,1.1261,1.31818,1.31818,1.31818,1.31818,1.31818,1.31818,1.31818,\n1.31818,1.31818,.95161,1.27126,1.00811,.83284,.77702,.99137,.95253,1.0347,.86142,1.07205,1.14236,.97363,.89723,.86869,1.09818,.79429,.99361,1.05815,.97552,1.1406,.90128,1.06662,1.04396,1.10615,.84918,.97552,1.04694,.94436,.98015,.96083,.91142,1.00356,.9817,1.01945,.98999,1.1406,.91142,1.04961,.9898,1.00639,1.14236,1.07514,1.04961,.99607,1.02897,1.008,.9898,.95134,1.00639,1.11121,1.14236,1.00518,.97981,1.02186,1,1.08578,.94165,.99314,.98387,.93028,.93377,1.35125,1.07514,1.10687,.93491,1.04232,1.00351,\n1.14236,1.07514,.94165,1.07514,1.00351,.79429,1,1,1,1,1,1,1,1,1,1,1,1,1.09097,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.93503,1,1,1,1,1,1,1,1,1,1,1,1,.96609,1,1,1,1,1,1,1.06777,1.02197,1.06777,1.02197,1.06777,1.02197,.91142,.96752,1,1.21261,.89903,1,1,.75155,1.04745,1.04745,1.04745,1.04394,.98633,.98633,.98633,.72959,.72959,1.20502,.91406,1.26514,1.222,1.02956,1.03372,1.03372,.96039,1.24633,1,1.09125,.93327,\n1.03336,1.16541,1.036,1,1,1,.771,1,1,1.15574,1.15574,1.15574,1.15574,.86364,.94434,.86279,.94434,.86224,1,1,1.16798,1,.96085,.90068,1.21237,1.18416,1.13904,.69825,.9716,2.10339,1.29004,1.29004,1.21339,1.29004,1.29004,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1.42603,1,.99862,.99862,1,.87025,.87025,.87025,.87025,1.18775,1.42603,1,1.42603,1.42603,.99862,1,1,1,1,1,1.2886,1.04315,1.15296,1.34163,1,1,1,1.13269,1.13269,1,1,1,1,1,1,1,1,1,1,1,\n1,1,1,1,1,1,1],gt={lineHeight:1.33008,lineGap:0},ht=[1.76738,1,1,.98946,1.14763,1.05365,1.06234,.96927,.92586,1.15373,1.18414,.91349,.91349,1.07403,1.17308,.78383,1.20088,.78383,1.42531,.96927,.96927,.96927,.96927,.96927,.96927,.96927,.96927,.96927,.96927,.78383,.78383,1.17308,1.17308,1.17308,.77349,.94565,.94729,.85944,.88506,.9858,.74817,.80016,.88449,.98039,.95782,.69238,.89898,.83231,.98183,1.03989,.96924,.86237,.96924,.80595,.74524,.86091,.95402,.94143,.98448,.8858,.83089,.93285,1.0949,1.39016,\n1.0949,1.45994,.74627,1.04839,.97454,.97454,.87207,.97454,.87533,1.06151,.97454,1.00176,1.16484,1.08132,.98047,1.16484,1.02989,1.01054,.96225,.97454,.97454,1.06598,.79004,1.16344,1.00351,.94629,.9973,.91016,.96777,.9043,.91082,.92481,.91082,1.17308,.95748,.96927,.96927,1,.96927,.92481,.80597,1.04839,1.23393,1.1781,.9245,1.17308,1.20808,.63218,.94261,1.24822,1.09971,1.09971,1.04839,1,.85273,.78032,1.04839,1.09971,1.22326,.9245,1.09836,1.13525,1.15222,.70424,.94729,.94729,.94729,.94729,.94729,.94729,\n.85498,.88506,.74817,.74817,.74817,.74817,.95782,.95782,.95782,.95782,.9858,1.03989,.96924,.96924,.96924,.96924,.96924,1.17308,.96924,.95402,.95402,.95402,.95402,.83089,.86237,.88409,.97454,.97454,.97454,.97454,.97454,.97454,.92916,.87207,.87533,.87533,.87533,.87533,.93146,.93146,.93146,.93146,.93854,1.01054,.96225,.96225,.96225,.96225,.96225,1.24822,.8761,1.00351,1.00351,1.00351,1.00351,.96777,.97454,.96777,.94729,.97454,.94729,.97454,.94729,.97454,.88506,.87207,.88506,.87207,.88506,.87207,.88506,\n.87207,.9858,.95391,.9858,.97454,.74817,.87533,.74817,.87533,.74817,.87533,.74817,.87533,.74817,.87533,.88449,.97454,.88449,.97454,.88449,.97454,1,1,.98039,1.00176,.98039,1.00176,.95782,.93146,.95782,.93146,.95782,.93146,.95782,1.16484,.95782,.93146,.84421,1.12761,.69238,1.08132,1,1,.98047,.83231,1.16484,1,1,.84723,1.04861,.84723,.78755,.83231,1.23736,1.03989,1.01054,1,1,1.03989,1.01054,.9857,1.03849,1.01054,.96924,.96225,.96924,.96225,.96924,.96225,.92383,.90171,.80595,1.06598,1,1,.80595,1.06598,\n.74524,.79004,.74524,.79004,.74524,.79004,.74524,.79004,1,1,.86091,1.02759,.85771,1.16344,.95402,1.00351,.95402,1.00351,.95402,1.00351,.95402,1.00351,.95402,1.00351,.95402,1.00351,.98448,.9973,.83089,.96777,.83089,.93285,.9043,.93285,.9043,.93285,.9043,1.31868,.96927,.94729,.97454,.85498,.92916,.96924,.8761,1,1,.86091,1.16344,1.04839,1.04839,1.04839,1.04839,1.04839,1.04839,1.04839,1.04839,1.04839,.81965,.81965,.94729,.78032,.71022,.90883,.84171,.99877,.77596,1.05734,1.2,.94729,.85944,.82791,.9607,\n.74817,.93285,.98039,.96924,.95782,.89898,.98316,.98183,1.03989,.78614,.96924,.97642,.86237,.86075,.86091,.83089,.90082,.8858,.97296,1.01284,.95782,.83089,1.0976,1.04,1.03342,1.2,1.0675,1.0976,.98205,1.03809,1.05097,1.04,.95364,1.03342,1.05401,1.2,1.02148,1.0119,1.04724,1.0127,1.02732,.96225,.8965,.97783,.93574,.94818,1.30679,1.0675,1.11826,.99821,1.0557,1.0326,1.2,1.0675,.96225,1.0675,1.0326,.74817,1,1,1,1,1,1,1,1,1,1,1,1,1.03754,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,\n1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.87533,1,1,1,1,1,1,1,1,1,1,1,1,.98705,1,1,1,1,1,1,.98448,.9973,.98448,.9973,.98448,.9973,.83089,.96777,1,1.20088,.89903,1,1,.75155,.94945,.94945,.94945,.94945,1.12317,1.12317,1.12317,.67603,.67603,1.15621,.73584,1.21191,1.22135,1.06483,.94868,.94868,.95996,1.24633,1,1.07497,.87709,.96927,1.01473,.96927,1,1,1,.77295,1,1,1.09836,1.09836,1.09836,1.01522,.86321,.94434,.8649,.94434,.86182,1,1,1.083,1,.91578,.86438,1.17308,1.18416,1.14589,\n.69825,.97622,1.96791,1.24822,1.24822,1.17308,1.24822,1.24822,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1.42603,1,.99862,.99862,1,.87025,.87025,.87025,.87025,1.17984,1.42603,1,1.42603,1.42603,.99862,1,1,1,1,1,1.2886,1.04315,1.15296,1.34163,1,1,1,1.10742,1.10742,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],it={lineHeight:1.33008,lineGap:0},jt=[1.76738,1,1,.98594,1.02285,1.10454,1.06234,.96927,.92037,1.19985,1.2046,.90616,.90616,1.07152,1.1714,.78032,\n1.20088,.78032,1.40246,.96927,.96927,.96927,.96927,.96927,.96927,.96927,.96927,.96927,.96927,.78032,.78032,1.1714,1.1714,1.1714,.80597,.94084,.96706,.85944,.85734,.97093,.75842,.79936,.88198,.9831,.95782,.71387,.86969,.84636,1.07796,1.03584,.96924,.83968,.96924,.82826,.79649,.85771,.95132,.93119,.98965,.88433,.8287,.93365,1.08612,1.3638,1.08612,1.45786,.74627,.80499,.91484,1.05707,.92383,1.05882,.9403,1.12654,1.05882,1.01756,1.09011,1.09011,.99414,1.09011,1.034,1.01756,1.05356,1.05707,1.05882,1.04399,\n.84863,1.21968,1.01756,.95801,1.00068,.91797,.96777,.9043,.90351,.92105,.90351,1.1714,.85337,.96927,.96927,.99912,.96927,.92105,.80597,1.2434,1.20808,1.05937,.90957,1.1714,1.20808,.75155,.94261,1.24644,1.09971,1.09971,.84751,1,.85273,.78032,.61584,1.05425,1.17914,.90957,1.08665,1.11593,1.14169,.73381,.96706,.96706,.96706,.96706,.96706,.96706,.86035,.85734,.75842,.75842,.75842,.75842,.95782,.95782,.95782,.95782,.97093,1.03584,.96924,.96924,.96924,.96924,.96924,1.1714,.96924,.95132,.95132,.95132,.95132,\n.8287,.83968,.89049,.91484,.91484,.91484,.91484,.91484,.91484,.93575,.92383,.9403,.9403,.9403,.9403,.8717,.8717,.8717,.8717,1.00527,1.01756,1.05356,1.05356,1.05356,1.05356,1.05356,1.24644,.95923,1.01756,1.01756,1.01756,1.01756,.96777,1.05707,.96777,.96706,.91484,.96706,.91484,.96706,.91484,.85734,.92383,.85734,.92383,.85734,.92383,.85734,.92383,.97093,1.0969,.97093,1.05882,.75842,.9403,.75842,.9403,.75842,.9403,.75842,.9403,.75842,.9403,.88198,1.05882,.88198,1.05882,.88198,1.05882,1,1,.9831,1.01756,\n.9831,1.01756,.95782,.8717,.95782,.8717,.95782,.8717,.95782,1.09011,.95782,.8717,.84784,1.11551,.71387,1.09011,1,1,.99414,.84636,1.09011,1,1,.84636,1.0536,.84636,.94298,.84636,1.23297,1.03584,1.01756,1,1,1.03584,1.01756,1.00323,1.03444,1.01756,.96924,1.05356,.96924,1.05356,.96924,1.05356,.93066,.98293,.82826,1.04399,1,1,.82826,1.04399,.79649,.84863,.79649,.84863,.79649,.84863,.79649,.84863,1,1,.85771,1.17318,.85771,1.21968,.95132,1.01756,.95132,1.01756,.95132,1.01756,.95132,1.01756,.95132,1.01756,\n.95132,1.01756,.98965,1.00068,.8287,.96777,.8287,.93365,.9043,.93365,.9043,.93365,.9043,1.08571,.96927,.96706,.91484,.86035,.93575,.96924,.95923,1,1,.85771,1.21968,1.11437,1.11437,.93109,.91202,.60411,.84164,.55572,1.01173,.97361,.81818,.81818,.96635,.78032,.72727,.92366,.98601,1.03405,.77968,1.09799,1.2,.96706,.85944,.85638,.96491,.75842,.93365,.9831,.96924,.95782,.86969,.94152,1.07796,1.03584,.78437,.96924,.98715,.83968,.83491,.85771,.8287,.94492,.88433,.9287,1.0098,.95782,.8287,1.0625,.98248,1.03424,\n1.2,1.01071,1.0625,.95246,1.03809,1.04912,.98248,1.00221,1.03424,1.05443,1.2,1.04785,.99609,1.00169,1.05176,.99346,1.05356,.9087,1.03004,.95542,.93117,1.23362,1.01071,1.07831,1.02512,1.05205,1.03502,1.2,1.01071,1.05356,1.01071,1.03502,.75842,1,1,1,1,1,1,1,1,1,1,1,1,1.03719,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,.9403,1,1,1,1,1,1,1,1,1,1,1,1,1.04021,1,1,1,1,1,1,.98965,1.00068,.98965,1.00068,.98965,1.00068,\n.8287,.96777,1,1.20088,.89903,1,1,.75155,1.03077,1.03077,1.03077,1.03077,1.13196,1.13196,1.13196,.67428,.67428,1.16039,.73291,1.20996,1.22135,1.06483,.94868,.94868,.95996,1.24633,1,1.07497,.87796,.96927,1.01518,.96927,1,1,1,.77295,1,1,1.10539,1.10539,1.11358,1.06967,.86279,.94434,.86279,.94434,.86182,1,1,1.083,1,.91578,.86507,1.1714,1.18416,1.14589,.69825,.97622,1.9697,1.24822,1.24822,1.17238,1.24822,1.24822,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,\n1,1,1,1,1,1,1,1.42603,1,.99862,.99862,1,.87025,.87025,.87025,.87025,1.18083,1.42603,1,1.42603,1.42603,.99862,1,1,1,1,1,1.2886,1.04315,1.15296,1.34163,1,1,1,1.10938,1.10938,1,1,1,1.05425,1.09971,1.09971,1.09971,1,1,1,1,1,1,1,1,1,1,1],kt={lineHeight:1.33008,lineGap:0},hq=xb(function(a){a["MyriadPro-Regular"]=a["PdfJS-Fallback-Regular"]={name:"LiberationSans-Regular",factors:bt,baseWidths:Ef,baseMapping:Ff,metrics:ct};a["MyriadPro-Bold"]=a["PdfJS-Fallback-Bold"]={name:"LiberationSans-Bold",factors:Ws,\nbaseWidths:yf,baseMapping:zf,metrics:Xs};a["MyriadPro-It"]=a["MyriadPro-Italic"]=a["PdfJS-Fallback-Italic"]={name:"LiberationSans-Italic",factors:$s,baseWidths:Cf,baseMapping:Df,metrics:at};a["MyriadPro-BoldIt"]=a["MyriadPro-BoldItalic"]=a["PdfJS-Fallback-BoldItalic"]={name:"LiberationSans-BoldItalic",factors:Ys,baseWidths:Af,baseMapping:Bf,metrics:Zs};a.ArialMT=a.Arial=a["Arial-Regular"]={name:"LiberationSans-Regular",baseWidths:Ef,baseMapping:Ff};a["Arial-BoldMT"]=a["Arial-Bold"]={name:"LiberationSans-Bold",\nbaseWidths:yf,baseMapping:zf};a["Arial-ItalicMT"]=a["Arial-Italic"]={name:"LiberationSans-Italic",baseWidths:Cf,baseMapping:Df};a["Arial-BoldItalicMT"]=a["Arial-BoldItalic"]={name:"LiberationSans-BoldItalic",baseWidths:Af,baseMapping:Bf};a["Calibri-Regular"]={name:"LiberationSans-Regular",factors:Ms,baseWidths:Ef,baseMapping:Ff,metrics:Ns};a["Calibri-Bold"]={name:"LiberationSans-Bold",factors:Gs,baseWidths:yf,baseMapping:zf,metrics:Hs};a["Calibri-Italic"]={name:"LiberationSans-Italic",factors:Ks,\nbaseWidths:Cf,baseMapping:Df,metrics:Ls};a["Calibri-BoldItalic"]={name:"LiberationSans-BoldItalic",factors:Is,baseWidths:Af,baseMapping:Bf,metrics:Js};a["Segoeui-Regular"]={name:"LiberationSans-Regular",factors:jt,baseWidths:Ef,baseMapping:Ff,metrics:kt};a["Segoeui-Bold"]={name:"LiberationSans-Bold",factors:dt,baseWidths:yf,baseMapping:zf,metrics:et};a["Segoeui-Italic"]={name:"LiberationSans-Italic",factors:ht,baseWidths:Cf,baseMapping:Df,metrics:it};a["Segoeui-BoldItalic"]={name:"LiberationSans-BoldItalic",\nfactors:ft,baseWidths:Af,baseMapping:Bf,metrics:gt};a["Helvetica-Regular"]=a.Helvetica={name:"LiberationSans-Regular",factors:Us,baseWidths:Ef,baseMapping:Ff,metrics:Vs};a["Helvetica-Bold"]={name:"LiberationSans-Bold",factors:Os,baseWidths:yf,baseMapping:zf,metrics:Ps};a["Helvetica-Italic"]={name:"LiberationSans-Italic",factors:Ss,baseWidths:Cf,baseMapping:Df,metrics:Ts};a["Helvetica-BoldItalic"]={name:"LiberationSans-BoldItalic",factors:Qs,baseWidths:Af,baseMapping:Bf,metrics:Rs}}),lt=function(){function a(b){this.lexer=\nb;this.operators=[];this.prev=this.token=null}var c=a.prototype;c.nextToken=function(){this.prev=this.token;this.token=this.lexer.getToken()};c.accept=function(b){return this.token.type===b?(this.nextToken(),!0):!1};c.expect=function(b){if(this.accept(b))return!0;throw new oa("Unexpected symbol: found "+this.token.type+" expected "+b+".");};c.parse=function(){this.nextToken();this.expect(vc.LBRACE);this.parseBlock();this.expect(vc.RBRACE);return this.operators};c.parseBlock=function(){for(;;)if(this.accept(vc.NUMBER))this.operators.push(this.prev.value);\nelse if(this.accept(vc.OPERATOR))this.operators.push(this.prev.value);else if(this.accept(vc.LBRACE))this.parseCondition();else break};c.parseCondition=function(){var b=this.operators.length;this.operators.push(null,null);this.parseBlock();this.expect(vc.RBRACE);if(this.accept(vc.IF))this.operators[b]=this.operators.length,this.operators[b+1]="jz";else if(this.accept(vc.LBRACE)){var d=this.operators.length;this.operators.push(null,null);var e=this.operators.length;this.parseBlock();this.expect(vc.RBRACE);\nthis.expect(vc.IFELSE);this.operators[d]=this.operators.length;this.operators[d+1]="j";this.operators[b]=e;this.operators[b+1]="jz"}else throw new oa("PS Function: error parsing conditional.");};return a}(),vc={LBRACE:0,RBRACE:1,NUMBER:2,OPERATOR:3,IF:4,IFELSE:5},Te=function(){function a(c,b){this.type=c;this.value=b}a.getOperator=function(c){var b;return(b=a.opCache)[c]||(b[c]=new a(vc.OPERATOR,c))};return jq(a,null,[{key:"opCache",get:function(){return Fa(this,"opCache",Object.create(null))}},{key:"LBRACE",\nget:function(){return Fa(this,"LBRACE",new a(vc.LBRACE,"{"))}},{key:"RBRACE",get:function(){return Fa(this,"RBRACE",new a(vc.RBRACE,"}"))}},{key:"IF",get:function(){return Fa(this,"IF",new a(vc.IF,"IF"))}},{key:"IFELSE",get:function(){return Fa(this,"IFELSE",new a(vc.IFELSE,"IFELSE"))}}])}(),mt=function(){function a(b){this.stream=b;this.nextChar();this.strBuf=[]}var c=a.prototype;c.nextChar=function(){return this.currentChar=this.stream.getByte()};c.getToken=function(){for(var b=!1,d=this.currentChar;;){if(0>\nd)return $b;if(b){if(10===d||13===d)b=!1}else if(37===d)b=!0;else if(!Lc(d))break;d=this.nextChar()}switch(d|0){case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:case 43:case 45:case 46:return new Te(vc.NUMBER,this.getNumber());case 123:return this.nextChar(),Te.LBRACE;case 125:return this.nextChar(),Te.RBRACE}b=this.strBuf;b.length=0;for(b[0]=String.fromCharCode(d);0<=(d=this.nextChar())&&(65<=d&&90>=d||97<=d&&122>=d);)b.push(String.fromCharCode(d));d=b.join("");switch(d.toLowerCase()){case "if":return Te.IF;\ncase "ifelse":return Te.IFELSE;default:return Te.getOperator(d)}};c.getNumber=function(){var b=this.currentChar,d=this.strBuf;d.length=0;for(d[0]=String.fromCharCode(b);0<=(b=this.nextChar());)if(48<=b&&57>=b||45===b||46===b)d.push(String.fromCharCode(b));else break;b=parseFloat(d.join(""));if(isNaN(b))throw new oa("Invalid floating point number: "+b);return b};return a}(),Ue=function(){function a(b){this._onlyRefs=!0===(null==b?void 0:b.onlyRefs);this._onlyRefs||(this._nameRefMap=new Map,this._imageMap=\nnew Map);this._imageCache=new Pc}var c=a.prototype;c.getByName=function(b){this._onlyRefs&&db("Should not call `getByName` method.");var d=this._nameRefMap.get(b);return d?this.getByRef(d):this._imageMap.get(b)||null};c.getByRef=function(b){return this._imageCache.get(b)||null};c.set=function(){db("Abstract method `set` called.")};return a}(),Yn=function(a){function c(){return a.apply(this,arguments)||this}Ge(c,a);c.prototype.set=function(b,d,e){void 0===d&&(d=null);if("string"!==typeof b)throw Error(\'LocalImageCache.set - expected "name" argument.\');\nd?this._imageCache.has(d)||(this._nameRefMap.set(b,d),this._imageCache.put(d,e)):this._imageMap.has(b)||this._imageMap.set(b,e)};return c}(Ue),Zn=function(a){function c(){return a.apply(this,arguments)||this}Ge(c,a);c.prototype.set=function(b,d,e){void 0===b&&(b=null);void 0===d&&(d=null);if("string"!==typeof b&&!d)throw Error(\'LocalColorSpaceCache.set - expected "name" and/or "ref" argument.\');d?this._imageCache.has(d)||(null!==b&&this._nameRefMap.set(b,d),this._imageCache.put(d,e)):this._imageMap.has(b)||\nthis._imageMap.set(b,e)};return c}(Ue),nt=function(a){function c(){return a.call(this,{onlyRefs:!0})||this}Ge(c,a);c.prototype.set=function(b,d,e){if(!d)throw Error(\'LocalFunctionCache.set - expected "ref" argument.\');this._imageCache.has(d)||this._imageCache.put(d,e)};return c}(Ue),$n=function(a){function c(){return a.apply(this,arguments)||this}Ge(c,a);c.prototype.set=function(b,d,e){void 0===d&&(d=null);if("string"!==typeof b)throw Error(\'LocalGStateCache.set - expected "name" argument.\');d?this._imageCache.has(d)||\n(this._nameRefMap.set(b,d),this._imageCache.put(d,e)):this._imageMap.has(b)||this._imageMap.set(b,e)};return c}(Ue),ot=function(a){function c(){return a.call(this,{onlyRefs:!0})||this}Ge(c,a);c.prototype.set=function(b,d,e){if(!d)throw Error(\'LocalTilingPatternCache.set - expected "ref" argument.\');this._imageCache.has(d)||this._imageCache.put(d,e)};return c}(Ue),pt=function(a){function c(){return a.call(this,{onlyRefs:!0})||this}Ge(c,a);c.prototype.set=function(b,d,e){if(!d)throw Error(\'RegionalImageCache.set - expected "ref" argument.\');\nthis._imageCache.has(d)||this._imageCache.put(d,e)};return c}(Ue),Og=function(){function a(){this.__decodeFailedSet=new Zb;this._refCache=new Pc;this._imageCache=new Pc}var c=a.prototype;c.shouldCache=function(b,d){var e=this._refCache.get(b);e||(e=new Set,this._refCache.put(b,e));e.add(d);return e.size<a.NUM_PAGES_THRESHOLD||!this._imageCache.has(b)&&this.__cacheLimitReached?!1:!0};c.addDecodeFailed=function(b){this.__decodeFailedSet.put(b)};c.hasDecodeFailed=function(b){return this.__decodeFailedSet.has(b)};\nc.addByteSize=function(b,d){(b=this._imageCache.get(b))&&!b.byteSize&&(b.byteSize=d)};c.getData=function(b,d){var e=this._refCache.get(b);if(!e||e.size<a.NUM_PAGES_THRESHOLD)return null;b=this._imageCache.get(b);if(!b)return null;e.add(d);return b};c.setData=function(b,d){if(!this._refCache.has(b))throw Error(\'GlobalImageCache.setData - expected "shouldCache" to have been called.\');this._imageCache.has(b)||(this.__cacheLimitReached?T("GlobalImageCache.setData - cache limit reached."):this._imageCache.put(b,\nd))};c.clear=function(b){void 0===b&&(b=!1);b||(this.__decodeFailedSet.clear(),this._refCache.clear());this._imageCache.clear()};return kq(a,[{key:"__byteSize",get:function(){for(var b=0,d=u.makeIterator(this._imageCache),e=d.next();!e.done;e=d.next())b+=e.value.byteSize;return b}},{key:"__cacheLimitReached",get:function(){return this._imageCache.size<a.MIN_IMAGES_TO_CACHE||this.__byteSize<a.MAX_BYTE_SIZE?!1:!0}}])}();Og.NUM_PAGES_THRESHOLD=2;Og.MIN_IMAGES_TO_CACHE=10;Og.MAX_BYTE_SIZE=5E7;var bo=\nfunction(){function a(b){var d=void 0===b.isEvalSupported?!0:b.isEvalSupported;this.xref=b.xref;this.isEvalSupported=!1!==d}var c=a.prototype;c.create=function(b){var d=this.getCached(b);if(d)return d;d=ao.parse({xref:this.xref,isEvalSupported:this.isEvalSupported,fn:b instanceof Ha?this.xref.fetch(b):b});this._cache(b,d);return d};c.createFromArray=function(b){var d=this.getCached(b);if(d)return d;d=ao.parseArray({xref:this.xref,isEvalSupported:this.isEvalSupported,fnObj:b instanceof Ha?this.xref.fetch(b):\nb});this._cache(b,d);return d};c.getCached=function(b){if(b instanceof Ha)var d=b;else if(b instanceof ca)d=b.objId;else if(b instanceof $a){var e;d=null==(e=b.dict)?void 0:e.objId}return d&&(b=this._localFunctionCache.getByRef(d))?b:null};c._cache=function(b,d){if(!d)throw Error(\'PDFFunctionFactory._cache - expected "parsedFunction" argument.\');if(b instanceof Ha)var e=b;else if(b instanceof ca)e=b.objId;else if(b instanceof $a){var g;e=null==(g=b.dict)?void 0:g.objId}e&&this._localFunctionCache.set(null,\ne,d)};return lq(a,[{key:"_localFunctionCache",get:function(){return Fa(this,"_localFunctionCache",new nt)}}])}(),ao=function(){function a(){}a.getSampleArray=function(c,b,d,e){var g,f=1;var h=0;for(g=c.length;h<g;h++)f*=c[h];f*=b;c=Array(f);g=b=0;var k=1/(Math.pow(2,d)-1);e=e.getBytes((f*d+7)/8);var l=0;for(h=0;h<f;h++){for(;b<d;)g<<=8,g|=e[l++],b+=8;b-=d;c[h]=(g>>b)*k;g&=(1<<b)-1}return c};a.parse=function(c){var b=c.xref,d=c.isEvalSupported;c=c.fn;var e=c.dict||c;switch(e.get("FunctionType")){case 0:return this.constructSampled({xref:b,\nisEvalSupported:d,fn:c,dict:e});case 2:return this.constructInterpolated({xref:b,isEvalSupported:d,dict:e});case 3:return this.constructStiched({xref:b,isEvalSupported:d,dict:e});case 4:return this.constructPostScript({xref:b,isEvalSupported:d,fn:c,dict:e})}throw new oa("Unknown type of function");};a.parseArray=function(c){var b=c.xref,d=c.isEvalSupported;c=c.fnObj;if(!Array.isArray(c))return this.parse({xref:b,isEvalSupported:d,fn:c});var e=[];c=u.makeIterator(c);for(var g=c.next();!g.done;g=c.next())e.push(this.parse({xref:b,\nisEvalSupported:d,fn:b.fetchIfRef(g.value)}));return function(f,h,k,l){for(var m=0,n=e.length;m<n;m++)e[m](f,h,k,l+m)}};a.constructSampled=function(c){function b(r){for(var t=r.length,v=[],w=0,y=0;y<t;y+=2)v[w++]=[r[y],r[y+1]];return v}var d=c.fn;c=c.dict;var e=bd(c.getArray("Domain")),g=bd(c.getArray("Range"));if(!e||!g)throw new oa("No domain or range");var f=e.length/2,h=g.length/2;e=b(e);g=b(g);var k=bd(c.getArray("Size")),l=c.get("BitsPerSample"),m=c.get("Order")||1;1!==m&&Ya("No support for cubic spline interpolation: "+\nm);var n=bd(c.getArray("Encode"));if(n)n=b(n);else for(n=[],m=0;m<f;++m)n.push([0,k[m]-1]);var p=bd(c.getArray("Decode"));p=p?b(p):g;var q=this.getSampleArray(k,h,l,d);return function(r,t,v,w){var y=1<<f,x=new Float64Array(y),z=new Uint32Array(y),A,B;for(B=0;B<y;B++)x[B]=1;var C=h,D=1;for(A=0;A<f;++A){B=e[A][0];var E=e[A][1],G=B;var J=n[A][0];J+=(n[A][1]-J)/(E-G)*(Math.min(Math.max(r[t+A],B),E)-G);E=k[A];J=Math.min(Math.max(J,0),E-1);B=J<E-1?Math.floor(J):J-1;G=B+1-J;J-=B;var F=B*C,L=F+C;for(B=0;B<\ny;B++)B&D?(x[B]*=J,z[B]+=L):(x[B]*=G,z[B]+=F);C*=E;D<<=1}for(B=0;B<h;++B){for(A=r=0;A<y;A++)r+=q[z[A]+B]*x[A];A=p[B][0];r=A+(r-0)*(p[B][1]-A);v[w+B]=Math.min(Math.max(r,g[B][0]),g[B][1])}}};a.constructInterpolated=function(c){var b=c.dict,d=bd(b.getArray("C0"))||[0];c=bd(b.getArray("C1"))||[1];var e=b.get("N"),g=[];b=0;for(var f=d.length;b<f;++b)g.push(c[b]-d[b]);var h=g.length;return function(k,l,m,n){k=1===e?k[l]:Math.pow(k[l],e);for(l=0;l<h;++l)m[n+l]=d[l]+k*g[l]}};a.constructStiched=function(c){var b=\nc.xref,d=c.isEvalSupported;c=c.dict;var e=bd(c.getArray("Domain"));if(!e)throw new oa("No domain");if(1!==e.length/2)throw new oa("Bad domain for stiched function");for(var g=[],f=u.makeIterator(c.get("Functions")),h=f.next();!h.done;h=f.next())g.push(this.parse({xref:b,isEvalSupported:d,fn:b.fetchIfRef(h.value)}));var k=bd(c.getArray("Bounds")),l=bd(c.getArray("Encode")),m=new Float32Array(1);return function(n,p,q,r){n=n[p];p=e[0];var t=e[1];n>t?n=t:n<p&&(n=p);t=k.length;for(p=0;p<t&&!(n<k[p]);++p);\nt=e[0];0<p&&(t=k[p-1]);var v=e[1];p<k.length&&(v=k[p]);var w=l[2*p],y=l[2*p+1];m[0]=t===v?w:w+(n-t)*(y-w)/(v-t);g[p](m,0,q,r)}};a.constructPostScript=function(c){var b=c.isEvalSupported,d=c.fn,e=c.dict;c=bd(e.getArray("Domain"));var g=bd(e.getArray("Range"));if(!c)throw new oa("No domain.");if(!g)throw new oa("No range.");d=new mt(d);d=(new lt(d)).parse();if(b&&id.isEvalSupported&&(b=(new qt).compile(d,c,g)))return new Function("src","srcOffset","dest","destOffset",b);Ya("Unable to compile PS function");\nvar f=g.length>>1,h=c.length>>1,k=new rt(d),l=Object.create(null),m=8192,n=new Float32Array(h);return function(p,q,r,t){var v,w="";for(v=0;v<h;v++){var y=p[q+v];n[v]=y;w+=y+"_"}v=l[w];if(void 0!==v)r.set(v,t);else{p=new Float32Array(f);q=k.execute(n);var x=q.length-f;for(v=0;v<f;v++){y=q[x+v];var z=g[2*v];y<z?y=z:(z=g[2*v+1],y>z&&(y=z));p[v]=y}0<m&&(m--,l[w]=p);r.set(p,t)}}};return a}(),co=function(){function a(b){this.stack=b?Array.from(b):[]}var c=a.prototype;c.push=function(b){if(this.stack.length>=\na.MAX_STACK_SIZE)throw Error("PostScript function stack overflow.");this.stack.push(b)};c.pop=function(){if(0>=this.stack.length)throw Error("PostScript function stack underflow.");return this.stack.pop()};c.copy=function(b){if(this.stack.length+b>=a.MAX_STACK_SIZE)throw Error("PostScript function stack overflow.");var d=this.stack,e=d.length-b;for(--b;0<=b;b--,e++)d.push(d[e])};c.index=function(b){this.push(this.stack[this.stack.length-b-1])};c.roll=function(b,d){var e=this.stack,g=e.length-b,f=\ne.length-1;b=g+(d-Math.floor(d/b)*b);d=g;for(var h=f;d<h;d++,h--){var k=e[d];e[d]=e[h];e[h]=k}for(d=b-1;g<d;g++,d--)h=e[g],e[g]=e[d],e[d]=h;for(;b<f;b++,f--)g=e[b],e[b]=e[f],e[f]=g};return a}();co.MAX_STACK_SIZE=100;var rt=function(){function a(c){this.operators=c}a.prototype.execute=function(c){c=new co(c);for(var b=0,d=this.operators,e=d.length,g,f;b<e;)if(g=d[b++],"number"===typeof g)c.push(g);else switch(g){case "jz":f=c.pop();(g=c.pop())||(b=f);break;case "j":b=g=c.pop();break;case "abs":g=c.pop();\nc.push(Math.abs(g));break;case "add":f=c.pop();g=c.pop();c.push(g+f);break;case "and":f=c.pop();g=c.pop();"boolean"===typeof g&&"boolean"===typeof f?c.push(g&&f):c.push(g&f);break;case "atan":f=c.pop();g=c.pop();g=Math.atan2(g,f)/Math.PI*180;0>g&&(g+=360);c.push(g);break;case "bitshift":f=c.pop();g=c.pop();0<g?c.push(g<<f):c.push(g>>f);break;case "ceiling":g=c.pop();c.push(Math.ceil(g));break;case "copy":g=c.pop();c.copy(g);break;case "cos":g=c.pop();c.push(Math.cos(g%360/180*Math.PI));break;case "cvi":g=\nc.pop()|0;c.push(g);break;case "cvr":break;case "div":f=c.pop();g=c.pop();c.push(g/f);break;case "dup":c.copy(1);break;case "eq":f=c.pop();g=c.pop();c.push(g===f);break;case "exch":c.roll(2,1);break;case "exp":f=c.pop();g=c.pop();c.push(Math.pow(g,f));break;case "false":c.push(!1);break;case "floor":g=c.pop();c.push(Math.floor(g));break;case "ge":f=c.pop();g=c.pop();c.push(g>=f);break;case "gt":f=c.pop();g=c.pop();c.push(g>f);break;case "idiv":f=c.pop();g=c.pop();c.push(g/f|0);break;case "index":g=\nc.pop();c.index(g);break;case "le":f=c.pop();g=c.pop();c.push(g<=f);break;case "ln":g=c.pop();c.push(Math.log(g));break;case "log":g=c.pop();c.push(Math.log10(g));break;case "lt":f=c.pop();g=c.pop();c.push(g<f);break;case "mod":f=c.pop();g=c.pop();c.push(g%f);break;case "mul":f=c.pop();g=c.pop();c.push(g*f);break;case "ne":f=c.pop();g=c.pop();c.push(g!==f);break;case "neg":g=c.pop();c.push(-g);break;case "not":g=c.pop();"boolean"===typeof g?c.push(!g):c.push(~g);break;case "or":f=c.pop();g=c.pop();\n"boolean"===typeof g&&"boolean"===typeof f?c.push(g||f):c.push(g|f);break;case "pop":c.pop();break;case "roll":f=c.pop();g=c.pop();c.roll(g,f);break;case "round":g=c.pop();c.push(Math.round(g));break;case "sin":g=c.pop();c.push(Math.sin(g%360/180*Math.PI));break;case "sqrt":g=c.pop();c.push(Math.sqrt(g));break;case "sub":f=c.pop();g=c.pop();c.push(g-f);break;case "true":c.push(!0);break;case "truncate":g=c.pop();g=0>g?Math.ceil(g):Math.floor(g);c.push(g);break;case "xor":f=c.pop();g=c.pop();"boolean"===\ntypeof g&&"boolean"===typeof f?c.push(g!==f):c.push(g^f);break;default:throw new oa("Unknown operator "+g);}return c.stack};return a}(),Ve=function(){function a(c){this.type=c}a.prototype.visit=function(){db("abstract method")};return a}(),st=function(a){function c(b,d,e){var g=a.call(this,"args")||this;g.index=b;g.min=d;g.max=e;return g}He(c,a);c.prototype.visit=function(b){b.visitArgument(this)};return c}(Ve),ke=function(a){function c(b){var d=a.call(this,"literal")||this;d.number=b;d.min=b;d.max=\nb;return d}He(c,a);c.prototype.visit=function(b){b.visitLiteral(this)};return c}(Ve),ii=function(a){function c(b,d,e,g,f){var h=a.call(this,"binary")||this;h.op=b;h.arg1=d;h.arg2=e;h.min=g;h.max=f;return h}He(c,a);c.prototype.visit=function(b){b.visitBinaryOperation(this)};return c}(Ve),tt=function(a){function c(b,d){var e=a.call(this,"max")||this;e.arg=b;e.min=b.min;e.max=d;return e}He(c,a);c.prototype.visit=function(b){b.visitMin(this)};return c}(Ve),eo=function(a){function c(b,d,e){var g=a.call(this,\n"var")||this;g.index=b;g.min=d;g.max=e;return g}He(c,a);c.prototype.visit=function(b){b.visitVariable(this)};return c}(Ve),fo=function(a){function c(b,d){var e=a.call(this,"definition")||this;e.variable=b;e.arg=d;return e}He(c,a);c.prototype.visit=function(b){b.visitVariableDefinition(this)};return c}(Ve),go=function(){function a(){this.parts=[]}var c=a.prototype;c.visitArgument=function(b){this.parts.push("Math.max(",b.min,", Math.min(",b.max,", src[srcOffset + ",b.index,"]))")};c.visitVariable=\nfunction(b){this.parts.push("v",b.index)};c.visitLiteral=function(b){this.parts.push(b.number)};c.visitBinaryOperation=function(b){this.parts.push("(");b.arg1.visit(this);this.parts.push(" ",b.op," ");b.arg2.visit(this);this.parts.push(")")};c.visitVariableDefinition=function(b){this.parts.push("var ");b.variable.visit(this);this.parts.push(" = ");b.arg.visit(this);this.parts.push(";")};c.visitMin=function(b){this.parts.push("Math.min(");b.arg.visit(this);this.parts.push(", ",b.max,")")};c.toString=\nfunction(){return this.parts.join("")};return a}(),qt=function(){function a(){}a.prototype.compile=function(c,b,d){var e=[],g=[],f=b.length>>1,h=d.length>>1,k=0,l;for(l=0;l<f;l++)e.push(new st(l,b[2*l],b[2*l+1]));b=0;for(f=c.length;b<f;b++)if(l=c[b],"number"===typeof l)e.push(new ke(l));else switch(l){case "add":if(2>e.length)return null;var m=e.pop();l=e.pop();var n=e;var p=n.push;l="literal"===m.type&&0===m.number?l:"literal"===l.type&&0===l.number?m:"literal"===m.type&&"literal"===l.type?new ke(l.number+\nm.number):new ii("+",l,m,l.min+m.min,l.max+m.max);p.call(n,l);break;case "cvr":if(1>e.length)return null;break;case "mul":if(2>e.length)return null;m=e.pop();l=e.pop();e.push(mq(l,m));break;case "sub":if(2>e.length)return null;m=e.pop();l=e.pop();n=e;p=n.push;a:{if("literal"===m.type){if(0===m.number)break a;if("literal"===l.type){l=new ke(l.number-m.number);break a}}l="binary"===m.type&&"-"===m.op&&"literal"===l.type&&1===l.number&&"literal"===m.arg1.type&&1===m.arg1.number?m.arg2:new ii("-",l,m,\nl.min-m.max,l.max-m.min)}p.call(n,l);break;case "exch":if(2>e.length)return null;m=e.pop();l=e.pop();e.push(m,l);break;case "pop":if(1>e.length)return null;e.pop();break;case "index":if(1>e.length)return null;l=e.pop();if("literal"!==l.type)return null;l=l.number;if(0>l||!Number.isInteger(l)||e.length<l)return null;m=e[e.length-l-1];if("literal"===m.type||"var"===m.type){e.push(m);break}n=new eo(k++,m.min,m.max);e[e.length-l-1]=n;e.push(n);g.push(new fo(n,m));break;case "dup":if(1>e.length)return null;\nif("number"===typeof c[b+1]&&"gt"===c[b+2]&&c[b+3]===b+7&&"jz"===c[b+4]&&"pop"===c[b+5]&&c[b+6]===c[b+1]){l=e.pop();m=e;n=m.push;p=c[b+1];l=l.min>=p?new ke(p):l.max<=p?l:new tt(l,p);n.call(m,l);b+=6;break}m=e.at(-1);if("literal"===m.type||"var"===m.type){e.push(m);break}n=new eo(k++,m.min,m.max);e[e.length-1]=n;e.push(n);g.push(new fo(n,m));break;case "roll":if(2>e.length)return null;m=e.pop();l=e.pop();if("literal"!==m.type||"literal"!==l.type)return null;m=m.number;l=l.number;if(0>=l||!Number.isInteger(l)||\n!Number.isInteger(m)||e.length<l)return null;m=(m%l+l)%l;if(0===m)break;e.push.apply(e,u.arrayFromIterable(e.splice(e.length-l,l-m)));break;default:return null}if(e.length!==h)return null;c=[];g=u.makeIterator(g);for(h=g.next();!h.done;h=g.next())h=h.value,k=new go,h.visit(k),c.push(k.toString());g=0;for(h=e.length;g<h;g++)k=e[g],l=new go,k.visit(l),b=d[2*g],f=d[2*g+1],l=[l.toString()],b>k.min&&(l.unshift("Math.max(",b,", "),l.push(")")),f<k.max&&(l.unshift("Math.min(",f,", "),l.push(")")),l.unshift("dest[destOffset + ",\ng,"] = "),l.push(";"),c.push(l.join(""));return c.join("\\n")};return a}(),nq="BN BN BN BN BN BN BN BN BN S B S WS B BN BN BN BN BN BN BN BN BN BN BN BN BN BN B B B S WS ON ON ET ET ET ON ON ON ON ON ES CS ES CS CS EN EN EN EN EN EN EN EN EN EN CS ON ON ON ON ON ON L L L L L L L L L L L L L L L L L L L L L L L L L L ON ON ON ON ON ON L L L L L L L L L L L L L L L L L L L L L L L L L L ON ON ON ON BN BN BN BN BN BN B BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN BN CS ON ET ET ET ET ON ON ON ON L ON ON BN ON ON ET ET EN EN ON L ON ON ON EN L ON ON ON ON ON L L L L L L L L L L L L L L L L L L L L L L L ON L L L L L L L L L L L L L L L L L L L L L L L L L L L L L L L ON L L L L L L L L".split(" "),\noq="AN AN AN AN AN AN ON ON AL ET ET AL CS AL ON ON NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM AL AL  AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM NSM AN AN AN AN AN AN AN AN AN AN ET AN AN AL AL AL NSM AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL AL NSM NSM NSM NSM NSM NSM NSM AN ON NSM NSM NSM NSM NSM NSM AL AL NSM NSM ON NSM NSM NSM NSM AL AL EN EN EN EN EN EN EN EN EN EN AL AL AL AL AL AL".split(" "),\nPd=[],jb=[],oe={style:"normal",weight:"normal"},le={style:"normal",weight:"bold"},me={style:"italic",weight:"normal"},ne={style:"italic",weight:"bold"},nf=new Map([["Times-Roman",{local:"Times New Roman;Times-Roman;Times;Liberation Serif;Nimbus Roman;Nimbus Roman L;Tinos;Thorndale;TeX Gyre Termes;FreeSerif;Linux Libertine O;Libertinus Serif;DejaVu Serif;Bitstream Vera Serif;Ubuntu".split(";"),style:oe,ultimate:"serif"}],["Times-Bold",{alias:"Times-Roman",style:le,ultimate:"serif"}],["Times-Italic",\n{alias:"Times-Roman",style:me,ultimate:"serif"}],["Times-BoldItalic",{alias:"Times-Roman",style:ne,ultimate:"serif"}],["Helvetica",{local:"Helvetica;Helvetica Neue;Arial;Arial Nova;Liberation Sans;Arimo;Nimbus Sans;Nimbus Sans L;A030;TeX Gyre Heros;FreeSans;DejaVu Sans;Albany;Bitstream Vera Sans;Arial Unicode MS;Microsoft Sans Serif;Apple Symbols;Cantarell".split(";"),path:"LiberationSans-Regular.ttf",style:oe,ultimate:"sans-serif"}],["Helvetica-Bold",{alias:"Helvetica",path:"LiberationSans-Bold.ttf",\nstyle:le,ultimate:"sans-serif"}],["Helvetica-Oblique",{alias:"Helvetica",path:"LiberationSans-Italic.ttf",style:me,ultimate:"sans-serif"}],["Helvetica-BoldOblique",{alias:"Helvetica",path:"LiberationSans-BoldItalic.ttf",style:ne,ultimate:"sans-serif"}],["Courier",{local:"Courier;Courier New;Liberation Mono;Nimbus Mono;Nimbus Mono L;Cousine;Cumberland;TeX Gyre Cursor;FreeMono;Linux Libertine Mono O;Libertinus Mono".split(";"),style:oe,ultimate:"monospace"}],["Courier-Bold",{alias:"Courier",style:le,\nultimate:"monospace"}],["Courier-Oblique",{alias:"Courier",style:me,ultimate:"monospace"}],["Courier-BoldOblique",{alias:"Courier",style:ne,ultimate:"monospace"}],["ArialBlack",{local:["Arial Black"],style:{style:"normal",weight:"900"},fallback:"Helvetica-Bold"}],["ArialBlack-Bold",{alias:"ArialBlack"}],["ArialBlack-Italic",{alias:"ArialBlack",style:{style:"italic",weight:"900"},fallback:"Helvetica-BoldOblique"}],["ArialBlack-BoldItalic",{alias:"ArialBlack-Italic"}],["ArialNarrow",{local:["Arial Narrow",\n"Liberation Sans Narrow","Helvetica Condensed","Nimbus Sans Narrow","TeX Gyre Heros Cn"],style:oe,fallback:"Helvetica"}],["ArialNarrow-Bold",{alias:"ArialNarrow",style:le,fallback:"Helvetica-Bold"}],["ArialNarrow-Italic",{alias:"ArialNarrow",style:me,fallback:"Helvetica-Oblique"}],["ArialNarrow-BoldItalic",{alias:"ArialNarrow",style:ne,fallback:"Helvetica-BoldOblique"}],["Calibri",{local:["Calibri","Carlito"],style:oe,fallback:"Helvetica"}],["Calibri-Bold",{alias:"Calibri",style:le,fallback:"Helvetica-Bold"}],\n["Calibri-Italic",{alias:"Calibri",style:me,fallback:"Helvetica-Oblique"}],["Calibri-BoldItalic",{alias:"Calibri",style:ne,fallback:"Helvetica-BoldOblique"}],["Wingdings",{local:["Wingdings","URW Dingbats"],style:oe}],["Wingdings-Regular",{alias:"Wingdings"}],["Wingdings-Bold",{alias:"Wingdings"}]]),qq=new Map([["Arial-Black","ArialBlack"]]),yd=function(){function a(b,d){this._imgData=b;this._isMask=d}a.needsToBeResized=function(b,d){if(b<=this.__goodSquareLength&&d<=this.__goodSquareLength)return!1;\nvar e=this.MAX_DIM;if(b>e||d>e)return!0;var g=b*d;if(this._hasMaxArea)return g>this.MAX_AREA;if(g<Math.pow(this.__goodSquareLength,2))return!1;if(this._areGoodDims(b,d))return this.__goodSquareLength=Math.max(this.__goodSquareLength,Math.floor(Math.sqrt(b*d))),!1;this.__goodSquareLength=this._guessMax(this.__goodSquareLength,e,128,0);b=this.MAX_AREA=Math.pow(this.__goodSquareLength,2);return g>b};a.setMaxArea=function(b){this._hasMaxArea||(this.MAX_AREA=b>>2)};a.setOptions=function(b){var d,e;this.setMaxArea(null!=\n(d=b.maxArea)?d:-1);this.__isChrome=null!=(e=b.isChrome)?e:!1};a._areGoodDims=function(b,d){try{var e=new OffscreenCanvas(b,d),g=e.getContext("2d");g.fillRect(0,0,1,1);var f=g.getImageData(0,0,1,1).data[3];e.width=e.height=1;return 0!==f}catch(h){return!1}};a._guessMax=function(b,d,e,g){for(;b+e+1<d;){var f=Math.floor((b+d)/2);this._areGoodDims(f,g||f)?b=f:d=f}return b};a.createImage=function(){var b=Gl(function f(e,g){return u.generator.createGenerator(f,function(h){void 0===g&&(g=!1);return h.return((new a(e,\ng))._createImage())})});return function(e,g){return b.apply(this,arguments)}}();var c=a.prototype;c._createImage=function(){var b=Gl(function e(){var g=this,f,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la;return u.generator.createGenerator(e,function(ta){if(1==ta.nextAddress)return f=g,h=g._encodeBMP(),ta.yield(a.canUseImageDecoder,2);if(3!=ta.nextAddress)return ta.yieldResult?(k=new ImageDecoder({data:h,type:"image/bmp",preferAnimation:!1,transfer:[h.buffer]}),l=k.decode().catch(function(qa){T("BMP image decoding failed: "+\nqa);return createImageBitmap(new Blob([f._encodeBMP().buffer],{type:"image/bmp"}))}).finally(function(){k.close()})):l=createImageBitmap(new Blob([h.buffer],{type:"image/bmp"})),m=a,n=m.MAX_AREA,p=m.MAX_DIM,q=g,t=r=q._imgData,v=t.width,w=t.height,y=Math.max(v/p,w/p,Math.sqrt(v*w/n)),x=Math.max(y,2),z=Math.round(10*(y+1.25))/10/x,A=Math.floor(Math.log2(z)),B=Array(A+2).fill(2),B[0]=x,B.splice(-1,1,z/(1<<A)),C=v,D=w,ta.yield(l,3);E=ta.yieldResult;G=E.image||E;J=u.makeIterator(B);for(F=J.next();!F.done;F=\nJ.next())L=F.value,M=C,W=D,C=Math.floor(C/L)-1,D=Math.floor(D/L)-1,Q=new OffscreenCanvas(C,D),la=Q.getContext("2d"),la.drawImage(G,0,0,M,W,0,0,C,D),G.close(),G=Q.transferToImageBitmap();r.data=null;r.bitmap=G;r.width=C;r.height=D;return ta.return(r)})});return function(){return b.apply(this,arguments)}}();c._encodeBMP=function(){var b=this._imgData,d=b.width,e=b.height,g=b.kind;b=this._imgData.data;var f=new Uint8Array(0),h=f,k=0;switch(g){case 1:g=1;f=new Uint8Array(this._isMask?[255,255,255,255,\n0,0,0,0]:[0,0,0,0,255,255,255,255]);var l=d+7>>3,m=l+3&-4;if(l!==m){for(var n=new Uint8Array(m*e),p=0,q=0,r=e*l;q<r;q+=l,p+=m)n.set(b.subarray(q,q+l),p);b=n}break;case 2:g=24;if(d&3){l=3*d;n=l+3&-4;m=n-l;n=new Uint8Array(n*e);q=p=0;for(r=e*l;q<r;q+=l){for(var t=b.subarray(q,q+l),v=0;v<l;v+=3)n[p++]=t[v+2],n[p++]=t[v+1],n[p++]=t[v];p+=m}b=n}else for(l=0,m=b.length;l<m;l+=3)n=b[l],b[l]=b[l+2],b[l+2]=n;break;case 3:g=32;k=3;h=new Uint8Array(68);l=new DataView(h.buffer);id.isLittleEndian?(l.setUint32(0,\n255,!0),l.setUint32(4,65280,!0),l.setUint32(8,16711680,!0),l.setUint32(12,4278190080,!0)):(l.setUint32(0,4278190080,!0),l.setUint32(4,16711680,!0),l.setUint32(8,65280,!0),l.setUint32(12,255,!0));break;default:throw Error("invalid format");}l=0;m=40+h.length;n=14+m+f.length+b.length;p=new Uint8Array(n);q=new DataView(p.buffer);q.setUint16(l,19778,!0);l+=2;q.setUint32(l,n,!0);l+=4;q.setUint32(l,0,!0);l+=4;q.setUint32(l,14+m+f.length,!0);l+=4;q.setUint32(l,m,!0);l+=4;q.setInt32(l,d,!0);l+=4;q.setInt32(l,\n-e,!0);l+=4;q.setUint16(l,1,!0);l+=2;q.setUint16(l,g,!0);l+=2;q.setUint32(l,k,!0);l+=4;q.setUint32(l,0,!0);l+=4;q.setInt32(l,0,!0);l+=4;q.setInt32(l,0,!0);l+=4;q.setUint32(l,f.length/4,!0);l+=4;q.setUint32(l,0,!0);l+=4;p.set(h,l);l+=h.length;p.set(f,l);l+=f.length;p.set(b,l);return p};return rq(a,null,[{key:"canUseImageDecoder",get:function(){return Fa(this,"canUseImageDecoder",this.__isChrome||"undefined"===typeof ImageDecoder?Promise.resolve(!1):ImageDecoder.isTypeSupported("image/bmp"))}},{key:"MAX_DIM",\nget:function(){return Fa(this,"MAX_DIM",this._guessMax(2048,65537,0,1))}},{key:"MAX_AREA",get:function(){this._hasMaxArea=!0;return Fa(this,"MAX_AREA",Math.pow(this._guessMax(this.__goodSquareLength,this.MAX_DIM,128,0),2))},set:function(b){0<=b&&(this._hasMaxArea=!0,Fa(this,"MAX_AREA",b))}}])}();yd.__goodSquareLength=2048;yd.__isChrome=!1;var ut=function(){function a(b){this.h1=b?b&4294967295:3285377520;this.h2=b?b&4294967295:3285377520}var c=a.prototype;c.update=function(b){var d;if("string"===typeof b){var e=\nnew Uint8Array(2*b.length);for(var g=d=0,f=b.length;g<f;g++){var h=b.charCodeAt(g);255>=h?e[d++]=h:(e[d++]=h>>>8,e[d++]=h&255)}}else if(ArrayBuffer.isView(b))e=b.slice(),d=e.byteLength;else throw Error("Invalid data format, must be a string or TypedArray.");b=d>>2;d-=4*b;g=new Uint32Array(e.buffer,0,b);f=this.h1;h=this.h2;for(var k=0;k<b;k++)if(k&1){var l=g[k];l=3432918353*l&4294901760|11601*l&65535;l=l<<15|l>>>17;l=461845907*l&4294901760|13715*l&65535;f^=l;f=f<<13|f>>>19;f=5*f+3864292196}else l=\ng[k],l=3432918353*l&4294901760|11601*l&65535,l=l<<15|l>>>17,l=461845907*l&4294901760|13715*l&65535,h^=l,h=h<<13|h>>>19,h=5*h+3864292196;l=0;switch(d){case 3:l^=e[4*b+2]<<16;case 2:l^=e[4*b+1]<<8;case 1:l^=e[4*b],l=3432918353*l&4294901760|11601*l&65535,l=l<<15|l>>>17,l=461845907*l&4294901760|13715*l&65535,b&1?f^=l:h^=l}this.h1=f;this.h2=h};c.hexdigest=function(){var b=this.h1,d=this.h2;b^=d>>>1;b=3981806797*b&4294901760|36045*b&65535;d=4283543511*d&4294901760|(2950163797*(d<<16|b>>>16)&4294901760)>>>\n16;b^=d>>>1;b=444984403*b&4294901760|60499*b&65535;d=3301882366*d&4294901760|(3120437893*(d<<16|b>>>16)&4294901760)>>>16;return((b^d>>>1)>>>0).toString(16).padStart(8,"0")+(d>>>0).toString(16).padStart(8,"0")};return a}(),We=[];ng(We,[O.save,O.transform,O.paintInlineImageXObject,O.restore],null,function(a,c){var b=a.fnArray;a=(c-(a.iCurr-3))%4;switch(a){case 0:return b[c]===O.save;case 1:return b[c]===O.transform;case 2:return b[c]===O.paintInlineImageXObject;case 3:return b[c]===O.restore}throw Error("iterateInlineImageGroup - invalid pos: "+\na);},function(a,c){var b=a.fnArray,d=a.argsArray,e=a.iCurr,g=e-3,f=e-2,h=e-1;e=Math.min(Math.floor((c-g)/4),200);if(10>e)return c-(c-g)%4;var k=0;c=[];for(var l=0,m=1,n=1,p=0;p<e;p++){var q=d[f+(p<<2)],r=d[h+(p<<2)][0];1E3<m+r.width&&(k=Math.max(k,m),n+=l+2,l=m=0);c.push({transform:q,x:m,y:n,w:r.width,h:r.height});m+=r.width+2;l=Math.max(l,r.height)}f=Math.max(k,m)+1;l=n+l+1;n=new Uint8Array(f*l*4);k=f<<2;for(m=0;m<e;m++){p=d[h+(m<<2)][0].data;q=c[m].w<<2;r=0;var t=c[m].x+c[m].y*f<<2;n.set(p.subarray(0,\nq),t-k);for(var v=0,w=c[m].h;v<w;v++)n.set(p.subarray(r,r+q),t),r+=q,t+=k;for(n.set(p.subarray(r-q,r),t);0<=t;)p[t-4]=p[t],p[t-3]=p[t+1],p[t-2]=p[t+2],p[t-1]=p[t+3],p[t+q]=p[t+q-4],p[t+q+1]=p[t+q-3],p[t+q+2]=p[t+q-2],p[t+q+3]=p[t+q-1],t-=k}h={width:f,height:l};a.isOffscreenCanvasSupported?(a=new OffscreenCanvas(f,l),a.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(n.buffer),f,l),0,0),h.bitmap=a.transferToImageBitmap(),h.data=null):(h.kind=3,h.data=n);b.splice(g,4*e,O.paintInlineImageXObjectGroup);\nd.splice(g,4*e,[h,c]);return g+1});ng(We,[O.save,O.transform,O.paintImageMaskXObject,O.restore],null,function(a,c){var b=a.fnArray;a=(c-(a.iCurr-3))%4;switch(a){case 0:return b[c]===O.save;case 1:return b[c]===O.transform;case 2:return b[c]===O.paintImageMaskXObject;case 3:return b[c]===O.restore}throw Error("iterateImageMaskGroup - invalid pos: "+a);},function(a,c){var b=a.fnArray,d=a.argsArray,e=a.iCurr;a=e-3;var g=e-2,f=e-1;e=Math.floor((c-a)/4);if(10>e)return c-(c-a)%4;var h=!1,k=d[f][0],l=d[g][0],\nm=d[g][1],n=d[g][2],p=d[g][3];if(m===n){h=!0;var q=g+4;for(var r=f+4,t=1;t<e;t++,q+=4,r+=4)if(c=d[q],d[r][0]!==k||c[0]!==l||c[1]!==m||c[2]!==n||c[3]!==p){10>t?h=!1:e=t;break}}if(h){e=Math.min(e,1E3);f=new Float32Array(2*e);q=g;for(g=0;g<e;g++,q+=4)c=d[q],f[g<<1]=c[4],f[(g<<1)+1]=c[5];b.splice(a,4*e,O.paintImageMaskXObjectRepeat);d.splice(a,4*e,[k,l,m,n,p,f])}else{e=Math.min(e,100);q=[];for(k=0;k<e;k++)c=d[g+(k<<2)],l=d[f+(k<<2)][0],q.push({data:l.data,width:l.width,height:l.height,interpolate:l.interpolate,\ncount:l.count,transform:c});b.splice(a,4*e,O.paintImageMaskXObjectGroup);d.splice(a,4*e,[q])}return a+1});ng(We,[O.save,O.transform,O.paintImageXObject,O.restore],function(a){var c=a.argsArray;a=a.iCurr-2;return 0===c[a][1]&&0===c[a][2]},function(a,c){var b=a.fnArray,d=a.argsArray,e=(c-(a.iCurr-3))%4;switch(e){case 0:return b[c]===O.save;case 1:if(b[c]!==O.transform)return!1;a=a.iCurr-2;b=d[a][3];return d[c][0]!==d[a][0]||0!==d[c][1]||0!==d[c][2]||d[c][3]!==b?!1:!0;case 2:return b[c]!==O.paintImageXObject||\nd[c][0]!==d[a.iCurr-1][0]?!1:!0;case 3:return b[c]===O.restore}throw Error("iterateImageGroup - invalid pos: "+e);},function(a,c){var b=a.fnArray,d=a.argsArray,e=a.iCurr;a=e-3;var g=e-2,f=d[e-1][0],h=d[g][0],k=d[g][3];e=Math.min(Math.floor((c-a)/4),1E3);if(3>e)return c-(c-a)%4;c=new Float32Array(2*e);for(var l=0;l<e;l++,g+=4){var m=d[g];c[l<<1]=m[4];c[(l<<1)+1]=m[5]}f=[f,h,k,c];b.splice(a,4*e,O.paintImageXObjectRepeat);d.splice(a,4*e,f);return a+1});ng(We,[O.beginText,O.setFont,O.setTextMatrix,O.showText,\nO.endText],null,function(a,c){var b=a.fnArray,d=a.argsArray,e=(c-(a.iCurr-4))%5;switch(e){case 0:return b[c]===O.beginText;case 1:return b[c]===O.setFont;case 2:return b[c]===O.setTextMatrix;case 3:if(b[c]!==O.showText)return!1;a=a.iCurr-3;b=d[a][1];return d[c][0]!==d[a][0]||d[c][1]!==b?!1:!0;case 4:return b[c]===O.endText}throw Error("iterateShowTextGroup - invalid pos: "+e);},function(a,c){var b=a.fnArray,d=a.argsArray,e=a.iCurr,g=e-4,f=e-3,h=d[f][0],k=d[f][1];a=Math.min(Math.floor((c-g)/5),1E3);\nif(3>a)return c-(c-g)%5;c=g;4<=g&&b[g-4]===b[f]&&b[g-3]===b[e-2]&&b[g-2]===b[e-1]&&b[g-1]===b[e]&&d[g-4][0]===h&&d[g-4][1]===k&&(a++,c-=5);c+=4;for(e=1;e<a;e++)b.splice(c,3),d.splice(c,3),c+=2;return c+1});var ho=function(){function a(b){this.queue=b}var c=a.prototype;c._optimize=function(){};c.push=function(b,d){this.queue.fnArray.push(b);this.queue.argsArray.push(d);this._optimize()};c.flush=function(){};c.reset=function(){};return a}(),vt=function(a){function c(d){var e=a.call(this,d)||this;e.state=\nnull;e.context={iCurr:0,fnArray:d.fnArray,argsArray:d.argsArray,isOffscreenCanvasSupported:!1};e.match=null;e.lastProcessed=0;return e}sq(c,a);var b=c.prototype;b._optimize=function(){var d=this.queue.fnArray,e=this.lastProcessed,g=d.length,f=this.state,h=this.match;if(f||h||e+1!==g||We[d[e]]){for(var k=this.context;e<g;){if(h){if((0,h.iterateFn)(k,e)){e++;continue}e=(0,h.processFn)(k,e+1);g=d.length;f=h=null;if(e>=g)break}f=(f||We)[d[e]];if(!f||Array.isArray(f))e++;else{k.iCurr=e;e++;if(!f.checkFn||\n(0,f.checkFn)(k))h=f;f=null}}this.state=f;this.match=h;this.lastProcessed=e}else this.lastProcessed=g};b.flush=function(){for(;this.match;)this.lastProcessed=(0,this.match.processFn)(this.context,this.queue.fnArray.length),this.state=this.match=null,this._optimize()};b.reset=function(){this.match=this.state=null;this.lastProcessed=0};return Jl(c,[{key:"isOffscreenCanvasSupported",set:function(d){this.context.isOffscreenCanvasSupported=d}}])}(ho),Dc=function(){function a(b,d){void 0===b&&(b=0);this._streamSink=\nd;this.fnArray=[];this.argsArray=[];this.optimizer=!d||b&256?new ho(this):new vt(this);this.dependencies=new Set;this.weight=this._totalLength=0;this._resolved=d?null:Promise.resolve()}var c=a.prototype;c.addOp=function(b,d){this.optimizer.push(b,d);this.weight++;this._streamSink&&(this.weight>=a.CHUNK_SIZE?this.flush():this.weight>=a.CHUNK_SIZE_ABOUT&&(b===O.restore||b===O.endText)&&this.flush())};c.addImageOps=function(b,d,e){void 0!==e&&this.addOp(O.beginMarkedContentProps,["OC",e]);this.addOp(b,\nd);void 0!==e&&this.addOp(O.endMarkedContent,[])};c.addDependency=function(b){this.dependencies.has(b)||(this.dependencies.add(b),this.addOp(O.dependency,[b]))};c.addDependencies=function(b){b=u.makeIterator(b);for(var d=b.next();!d.done;d=b.next())this.addDependency(d.value)};c.addOpList=function(b){if(b instanceof a){for(var d=u.makeIterator(b.dependencies),e=d.next();!e.done;e=d.next())this.dependencies.add(e.value);d=0;for(e=b.length;d<e;d++)this.addOp(b.fnArray[d],b.argsArray[d])}else T(\'addOpList - ignoring invalid "opList" parameter.\')};\nc.getIR=function(){return{fnArray:this.fnArray,argsArray:this.argsArray,length:this.length}};c.flush=function(b,d){void 0===b&&(b=!1);void 0===d&&(d=null);this.optimizer.flush();var e=this.length;this._totalLength+=e;this._streamSink.enqueue({fnArray:this.fnArray,argsArray:this.argsArray,lastChunk:b,separateAnnots:d,length:e},1,this._transfers);this.dependencies.clear();this.fnArray.length=0;this.weight=this.argsArray.length=0;this.optimizer.reset()};return Jl(a,[{key:"isOffscreenCanvasSupported",\nset:function(b){this.optimizer.isOffscreenCanvasSupported=b}},{key:"length",get:function(){return this.argsArray.length}},{key:"ready",get:function(){return this._resolved||this._streamSink.ready}},{key:"totalLength",get:function(){return this._totalLength+this.length}},{key:"_transfers",get:function(){for(var b,d=[],e=this.fnArray,g=this.argsArray,f=this.length,h=0;h<f;h++)switch(e[h]){case O.paintInlineImageXObject:case O.paintInlineImageXObjectGroup:case O.paintImageMaskXObject:var k=g[h][0];!k.cached&&\n(null==(b=k.data)?void 0:b.buffer)instanceof ArrayBuffer&&d.push(k.data.buffer)}return d}}])}();Dc.CHUNK_SIZE=1E3;Dc.CHUNK_SIZE_ABOUT=Dc.CHUNK_SIZE-5;var Pg=function(){function a(b){var d=b.xref,e=b.res,g=b.image,f=void 0===b.isInline?!1:b.isInline,h=void 0===b.smask?null:b.smask,k=void 0===b.mask?null:b.mask,l=void 0===b.isMask?!1:b.isMask,m=b.pdfFunctionFactory;b=b.localColorSpaceCache;this.image=g;var n=g.dict,p=n.get("F","Filter");if(p instanceof ka)var q=p.name;else Array.isArray(p)&&(p=d.fetchIfRef(p[0]),\np instanceof ka&&(q=p.name));switch(q){case "JPXDecode":q=pg.parseImageProperties(g.stream);g.width=q.width;g.height=q.height;g.numComps=q.componentsCount;g.bitsPerComponent=q.bitsPerComponent;g.stream.reset();this.jpxDecoderOptions={numComponents:0,isIndexedColormap:!1,smaskInData:n.has("SMaskInData")};break;case "JBIG2Decode":g.bitsPerComponent=1,g.numComps=1}q=n.get("W","Width");p=n.get("H","Height");Number.isInteger(g.width)&&0<g.width&&Number.isInteger(g.height)&&0<g.height&&(g.width!==q||g.height!==\np)&&(T("PDFImage - using the Width/Height of the image data, rather than the image dictionary."),q=g.width,p=g.height);if(1>q||1>p)throw new oa("Invalid image width: "+q+" or height: "+p);this.width=q;this.height=p;this.interpolate=n.get("I","Interpolate");this.imageMask=n.get("IM","ImageMask")||!1;this.matte=n.get("Matte")||!1;q=g.bitsPerComponent;if(!q&&(q=n.get("BPC","BitsPerComponent"),!q))if(this.imageMask)q=1;else throw new oa("Bits per component missing in image: "+this.imageMask);this.bpc=\nq;if(!this.imageMask){var r;p=n.getRaw("CS")||n.getRaw("ColorSpace");var t=!!p;if(t)null!=(r=this.jpxDecoderOptions)&&r.smaskInData&&(p=ka.get("DeviceRGBA"));else if(this.jpxDecoderOptions)p=ka.get("DeviceRGBA");else switch(g.numComps){case 1:p=ka.get("DeviceGray");break;case 3:p=ka.get("DeviceRGB");break;case 4:p=ka.get("DeviceCMYK");break;default:throw Error("Images with "+g.numComps+" color components not supported.");}this.colorSpace=ab.parse({cs:p,xref:d,resources:f?e:null,pdfFunctionFactory:m,\nlocalColorSpaceCache:b});this.numComps=this.colorSpace.numComps;this.jpxDecoderOptions&&(this.jpxDecoderOptions.numComponents=t?this.numComp:0,this.jpxDecoderOptions.isIndexedColormap="Indexed"===this.colorSpace.name)}this.decode=n.getArray("D","Decode");this.needsDecode=!1;if(this.decode&&(this.colorSpace&&!this.colorSpace.isDefaultDecode(this.decode,q)||l&&!ab.isDefaultDecode(this.decode,1))){var v;this.needsDecode=!0;g=(1<<q)-1;this.decodeCoefficients=[];this.decodeAddends=[];l="Indexed"===(null==\n(v=this.colorSpace)?void 0:v.name);for(r=v=0;v<this.decode.length;v+=2,++r)n=this.decode[v],q=this.decode[v+1],this.decodeCoefficients[r]=l?(q-n)/g:q-n,this.decodeAddends[r]=l?n:g*n}h?this.smask=new a({xref:d,res:e,image:h,isInline:f,pdfFunctionFactory:m,localColorSpaceCache:b}):k&&(k instanceof $a?k.dict.get("IM","ImageMask")?this.mask=new a({xref:d,res:e,image:k,isInline:f,isMask:!0,pdfFunctionFactory:m,localColorSpaceCache:b}):T("Ignoring /Mask in image without /ImageMask."):this.mask=k)}a.buildImage=\nfunction(){var b=pe(function g(e){var f,h,k,l,m,n,p,q,r,t,v,w;return u.generator.createGenerator(g,function(y){f=e;h=f.xref;k=f.res;l=f.image;m=void 0===f.isInline?!1:f.isInline;n=f.pdfFunctionFactory;p=f.localColorSpaceCache;q=l;t=r=null;v=l.dict.get("SMask");w=l.dict.get("Mask");v?v instanceof $a?r=v:T("Unsupported /SMask format."):w&&(w instanceof $a||Array.isArray(w)?t=w:T("Unsupported /Mask format."));return y.return(new a({xref:h,res:k,image:q,isInline:m,smask:r,mask:t,pdfFunctionFactory:n,\nlocalColorSpaceCache:p}))})});return function(e){return b.apply(this,arguments)}}();a.createRawMask=function(b){var d=b.imgArray,e=b.width,g=b.height,f=b.inverseDecode,h=b.interpolate,k=(e+7>>3)*g,l=d.byteLength;!b.imageIsFromDecodeStream||f&&k!==l?f?(b=new Uint8Array(k),b.set(d),b.fill(255,l)):b=new Uint8Array(d):b=d;if(f)for(d=0;d<l;d++)b[d]^=255;return{data:b,width:e,height:g,interpolate:h}};a.createMask=function(){var b=pe(function g(e){var f,h,k,l,m,n,p,q,r,t,v,w,y,x,z=this;return u.generator.createGenerator(g,\nfunction(A){f=e;h=f.imgArray;k=f.width;l=f.height;m=f.imageIsFromDecodeStream;n=f.inverseDecode;p=f.interpolate;q=void 0===f.isOffscreenCanvasSupported?!1:f.isOffscreenCanvasSupported;if(r=1===k&&1===l&&n===(0===h.length||!!(h[0]&128)))return A.return({isSingleOpaquePixel:r});if(q){if(yd.needsToBeResized(k,l))return t=new Uint8ClampedArray(k*l*4),vh({src:h,dest:t,width:k,height:l,nonBlackColor:0,inverseDecode:n}),A.return(yd.createImage({kind:3,data:t,width:k,height:l,interpolate:p}));v=new OffscreenCanvas(k,\nl);w=v.getContext("2d");y=w.createImageData(k,l);vh({src:h,dest:y.data,width:k,height:l,nonBlackColor:0,inverseDecode:n});w.putImageData(y,0,0);x=v.transferToImageBitmap();return A.return({data:null,width:k,height:l,interpolate:p,bitmap:x})}return A.return(z.createRawMask({imgArray:h,width:k,height:l,inverseDecode:n,imageIsFromDecodeStream:m,interpolate:p}))})});return function(e){return b.apply(this,arguments)}}();var c=a.prototype;c.decodeBuffer=function(b){var d=this.bpc,e=this.numComps,g=this.decodeAddends,\nf=this.decodeCoefficients,h=(1<<d)-1,k;if(1===d)for(d=0,k=b.length;d<k;d++)b[d]=+!b[d];else{var l=0;d=0;for(k=this.width*this.height;d<k;d++)for(var m=0;m<e;m++){var n=l,p=b[l];p=g[m]+p*f[m];0>p?p=0:p>h&&(p=h);b[n]=p;l++}}};c.getComponents=function(b){var d=this.bpc;if(8===d)return b;var e=this.width,g=this.height,f=this.numComps,h=e*g*f,k=0;var l=8>=d?new Uint8Array(h):16>=d?new Uint16Array(h):new Uint32Array(h);e*=f;var m=(1<<d)-1;f=0;if(1===d)for(h=0;h<g;h++){m=f+(e&-8);for(d=f+e;f<m;){var n=b[k++];\nl[f]=n>>7&1;l[f+1]=n>>6&1;l[f+2]=n>>5&1;l[f+3]=n>>4&1;l[f+4]=n>>3&1;l[f+5]=n>>2&1;l[f+6]=n>>1&1;l[f+7]=n&1;f+=8}if(f<d)for(n=b[k++],m=128;f<d;)l[f++]=+!!(n&m),m>>=1}else for(f=n=g=0;f<h;++f){0===f%e&&(g=n=0);for(;g<d;)n=n<<8|b[k++],g+=8;g-=d;var p=n>>g;0>p?p=0:p>m&&(p=m);l[f]=p;n&=(1<<g)-1}return l};c.fillOpacity=function(){var b=pe(function l(e,g,f,h,k){var m=this,n,p,q,r,t,v,w,y,x,z,A,B,C;return u.generator.createGenerator(l,function(D){switch(D.nextAddress){case 1:n=m.smask;p=m.mask;if(n)return r=\nn.width,t=n.height,q=new Uint8ClampedArray(r*t),D.yield(n.fillGrayBuffer(q),7);if(!p){D.jumpTo(3);break}if(!(p instanceof a)){if(Array.isArray(p))for(q=new Uint8ClampedArray(g*f),x=m.numComps,v=0,w=g*f;v<w;++v){z=0;A=v*x;for(y=0;y<x;++y)if(B=k[A+y],C=2*y,B<p[C]||B>p[C+1]){z=255;break}q[v]=z}else throw new oa("Unknown mask format.");D.jumpTo(3);break}r=p.width;t=p.height;q=new Uint8ClampedArray(r*t);p.numComps=1;return D.yield(p.fillGrayBuffer(q),6);case 6:v=0;for(w=r*t;v<w;++v)q[v]=255-q[v];if(r!==\ng||t!==f)q=Ml(q,p.bpc,r,t,g,f);D.jumpTo(3);break;case 7:if(r!==g||t!==f)q=Ml(q,n.bpc,r,t,g,f);case 3:if(q)for(v=0,y=3,w=g*h;v<w;++v,y+=4)e[y]=q[v];else for(v=0,y=3,w=g*h;v<w;++v,y+=4)e[y]=255;D.jumpToEnd()}})});return function(e,g,f,h,k){return b.apply(this,arguments)}}();c.undoPreblend=function(b,d,e){var g,f=null==(g=this.smask)?void 0:g.matte;if(f){var h=this.colorSpace.getRgb(f,0);g=h[0];f=h[1];h=h[2];d=d*e*4;for(e=0;e<d;e+=4){var k=b[e+3];0===k?(b[e]=255,b[e+1]=255,b[e+2]=255):(k=255/k,b[e]=\n(b[e]-g)*k+g,b[e+1]=(b[e+1]-f)*k+f,b[e+2]=(b[e+2]-h)*k+h)}}};c.createImageData=function(){var b=pe(function f(e,g){var h=this,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da;return u.generator.createGenerator(f,function(R){switch(R.nextAddress){case 1:void 0===e&&(e=!1);void 0===g&&(g=!1);k=h.drawWidth;l=h.drawHeight;m={width:k,height:l,interpolate:h.interpolate,kind:0,data:null};n=h.numComps;p=h.width;q=h.height;r=h.bpc;t=p*n*r+7>>3;v=g&&yd.needsToBeResized(k,l);if(h.smask||h.mask||\n"DeviceRGBA"!==h.colorSpace.name){R.jumpTo(2);break}m.kind=3;return R.yield(h.getImageBytes(q*p*4,{}),3);case 3:return w=m.data=R.yieldResult,g?v?R.return(yd.createImage(m,!1)):R.return(h.createBitmap(3,k,l,w)):R.return(m);case 2:if(e){R.jumpTo(4);break}"DeviceGray"===h.colorSpace.name&&1===r?y=1:"DeviceRGB"!==h.colorSpace.name||8!==r||h.needsDecode||(y=2);if(!y||h.smask||h.mask||k!==p||l!==q){R.jumpTo(5);break}return R.yield(h.__getImage(p,q),6);case 6:return(x=R.yieldResult)?R.return(x):R.yield(h.getImageBytes(q*\nt,{}),7);case 7:z=R.yieldResult;if(g)return v?R.return(yd.createImage({data:z,kind:y,width:k,height:l,interpolate:h.interpolate},h.needsDecode)):R.return(h.createBitmap(y,p,q,z));m.kind=y;m.data=z;if(h.needsDecode)for(xc(1===y,"PDFImage.createImageData: The image must be grayscale."),A=m.data,B=0,C=A.length;B<C;B++)A[B]^=255;return R.return(m);case 5:if(!(h.image instanceof mj)||h.smask||h.mask||h.needsDecode){R.jumpTo(4);break}D=q*t;if(g&&!v){E=!1;switch(h.colorSpace.name){case "DeviceGray":D*=4;\nE=!0;break;case "DeviceRGB":D=D/3*4;E=!0;break;case "DeviceCMYK":E=!0}if(!E){R.jumpTo(4);break}return R.yield(h.__getImage(k,l),15)}switch(h.colorSpace.name){case "DeviceGray":D*=3;case "DeviceRGB":case "DeviceCMYK":return R.jumpTo(11)}R.jumpTo(4);break;case 11:return m.kind=2,R.yield(h.getImageBytes(D,{drawWidth:k,drawHeight:l,forceRGB:!0}),13);case 13:return m.data=R.yieldResult,v?R.return(yd.createImage(m)):R.return(m);case 15:return(G=R.yieldResult)?R.return(G):R.yield(h.getImageBytes(D,{drawWidth:k,\ndrawHeight:l,forceRGBA:!0}),16);case 16:return J=R.yieldResult,R.return(h.createBitmap(3,k,l,J));case 4:return R.yield(h.getImageBytes(q*t,{internal:!0}),17);case 17:F=R.yieldResult;L=0|F.length/t*l/q;M=h.getComponents(F);g&&!v&&(la=new OffscreenCanvas(k,l),ta=la.getContext("2d"),qa=ta.createImageData(k,l),va=qa.data);m.kind=3;if(!e&&!h.smask&&!h.mask){!g||v?(m.kind=2,va=new Uint8ClampedArray(k*l*3),W=0):(S=new Uint32Array(va.buffer),S.fill(id.isLittleEndian?4278190080:255),W=1);Q=!1;R.jumpTo(18);\nbreak}if(!g||v)va=new Uint8ClampedArray(k*l*4);W=1;Q=!0;return R.yield(h.fillOpacity(va,k,l,L,M),18);case 18:h.needsDecode&&h.decodeBuffer(M);h.colorSpace.fillRgb(va,p,q,k,l,L,r,M,W);Q&&h.undoPreblend(va,k,L);if(g&&!v)return ta.putImageData(qa,0,0),da=la.transferToImageBitmap(),R.return({data:null,width:k,height:l,bitmap:da,interpolate:h.interpolate});m.data=va;return v?R.return(yd.createImage(m)):R.return(m)}})});return function(e,g){return b.apply(this,arguments)}}();c.fillGrayBuffer=function(){var b=\npe(function g(e){var f=this,h,k,l,m,n,p,q,r,t,v;return u.generator.createGenerator(g,function(w){if(1==w.nextAddress){h=f.numComps;if(1!==h)throw new oa("Reading gray scale from a color image: "+h);k=f.width;l=f.height;m=f.bpc;n=k*h*m+7>>3;return w.yield(f.getImageBytes(l*n,{internal:!0}),2)}p=w.yieldResult;q=f.getComponents(p);if(1===m){t=k*l;if(f.needsDecode)for(r=0;r<t;++r)e[r]=q[r]-1&255;else for(r=0;r<t;++r)e[r]=-q[r]&255;return w.return()}f.needsDecode&&f.decodeBuffer(q);t=k*l;v=255/((1<<m)-\n1);for(r=0;r<t;++r)e[r]=v*q[r];w.jumpToEnd()})});return function(e){return b.apply(this,arguments)}}();c.createBitmap=function(b,d,e,g){var f=new OffscreenCanvas(d,e),h=f.getContext("2d");if(3===b)var k=new ImageData(g,d,e);else{k=h.createImageData(d,e);a:{var l={kind:b,src:g,dest:new Uint32Array(k.data.buffer),width:d,height:e,inverseDecode:this.needsDecode};switch(l.kind){case 1:vh(l);break a;case 2:b=l.src;g=l.dest;var m=void 0===l.destPos?0:l.destPos,n=0,p=b.length>>2;l=new Uint32Array(b.buffer,\nvoid 0===l.srcPos?0:l.srcPos,p);if(id.isLittleEndian){for(;n<p-2;n+=3,m+=4){var q=l[n],r=l[n+1],t=l[n+2];g[m]=q|4278190080;g[m+1]=q>>>24|r<<8|4278190080;g[m+2]=r>>>16|t<<16|4278190080;g[m+3]=t>>>8|4278190080}n*=4;for(p=b.length;n<p;n+=3)g[m++]=b[n]|b[n+1]<<8|b[n+2]<<16|4278190080}else{for(;n<p-2;n+=3,m+=4)q=l[n],r=l[n+1],t=l[n+2],g[m]=q|255,g[m+1]=q<<24|r>>>8|255,g[m+2]=r<<16|t>>>16|255,g[m+3]=t<<8|255;n*=4;for(p=b.length;n<p;n+=3)g[m++]=b[n]<<24|b[n+1]<<16|b[n+2]<<8|255}}}}h.putImageData(k,0,0);\nf=f.transferToImageBitmap();return{data:null,width:d,height:e,bitmap:f,interpolate:this.interpolate}};c.__getImage=function(){var b=pe(function f(e,g){var h=this,k;return u.generator.createGenerator(f,function(l){return 1==l.nextAddress?l.yield(h.image.getTransferableImage(),2):(k=l.yieldResult)?l.return({data:null,width:e,height:g,bitmap:k,interpolate:h.interpolate}):l.return(null)})});return function(e,g){return b.apply(this,arguments)}}();c.getImageBytes=function(){var b=pe(function f(e,g){var h,\nk,l,m,n,p,q=this,r;return u.generator.createGenerator(f,function(t){if(1==t.nextAddress)return h=g,k=h.drawWidth,l=h.drawHeight,m=void 0===h.forceRGBA?!1:h.forceRGBA,n=void 0===h.forceRGB?!1:h.forceRGB,p=void 0===h.internal?!1:h.internal,q.image.reset(),q.image.drawWidth=k||q.width,q.image.drawHeight=l||q.height,q.image.forceRGBA=!!m,q.image.forceRGB=!!n,t.yield(q.image.getImageData(e,q.jpxDecoderOptions),2);r=t.yieldResult;if(p||q.image instanceof uc)return t.return(r);xc(r instanceof Uint8Array,\n\'PDFImage.getImageBytes: Unsupported "imageBytes" type.\');return t.return(new Uint8Array(r))})});return function(e,g){return b.apply(this,arguments)}}();return tq(a,[{key:"drawWidth",get:function(){var b,d;return Math.max(this.width,(null==(b=this.smask)?void 0:b.width)||0,(null==(d=this.mask)?void 0:d.width)||0)}},{key:"drawHeight",get:function(){var b,d;return Math.max(this.height,(null==(b=this.smask)?void 0:b.height)||0,(null==(d=this.mask)?void 0:d.height)||0)}}])}(),io=Object.freeze({maxImageSize:-1,\ndisableFontFace:!1,ignoreErrors:!1,isEvalSupported:!0,isOffscreenCanvasSupported:!1,isChrome:!1,canvasMaxAreaInBytes:-1,fontExtraProperties:!1,useSystemFonts:!0,cMapUrl:null,standardFontDataUrl:null}),jo=Promise.resolve(),Qg=function(){function a(){this.reset()}var c=a.prototype;c.check=function(){if(++this.checked<a.CHECK_TIME_EVERY)return!1;this.checked=0;return this.endTime<=Date.now()};c.reset=function(){this.endTime=Date.now()+a.TIME_SLOT_DURATION_MS;this.checked=0};return a}();Qg.TIME_SLOT_DURATION_MS=\n20;Qg.CHECK_TIME_EVERY=100;var ue=function(){function a(b){var d=b.handler,e=b.pageIndex,g=b.idFactory,f=b.fontCache,h=b.builtInCMapCache,k=b.standardFontDataCache,l=b.globalImageCache,m=b.systemFontCache,n=void 0===b.options?null:b.options;this.xref=b.xref;this.handler=d;this.pageIndex=e;this.idFactory=g;this.fontCache=f;this.builtInCMapCache=h;this.standardFontDataCache=k;this.globalImageCache=l;this.systemFontCache=m;this.options=n||io;this.type3FontRefs=null;this._regionalImageCache=new pt;this._fetchBuiltInCMapBound=\nthis.fetchBuiltInCMap.bind(this);yd.setOptions({isChrome:this.options.isChrome,maxArea:this.options.canvasMaxAreaInBytes})}var c=a.prototype;c.clone=function(b){void 0===b&&(b=null);var d=Object.create(this);d.options=Object.assign(Object.create(null),this.options,b);return d};c.hasBlendModes=function(b,d){if(!(b instanceof ca)||b.objId&&d.has(b.objId))return!1;var e=new Zb(d);b.objId&&e.put(b.objId);b=[b];for(var g=this.xref;b.length;){var f=b.shift(),h=f.get("ExtGState");if(h instanceof ca){h=u.makeIterator(h.getRawValues());\nfor(var k=h.next();!k.done;k=h.next()){k=k.value;if(k instanceof Ha){if(e.has(k))continue;try{k=g.fetch(k)}catch(m){e.put(k);Ya(\'hasBlendModes - ignoring ExtGState: "\'+m+\'".\');continue}}if(k instanceof ca)if(k.objId&&e.put(k.objId),k=k.get("BM"),k instanceof ka){if("Normal"!==k.name)return!0}else if(void 0!==k&&Array.isArray(k)){k=u.makeIterator(k);for(var l=k.next();!l.done;l=k.next())if(l=l.value,l instanceof ka&&"Normal"!==l.name)return!0}}}f=f.get("XObject");if(f instanceof ca)for(f=u.makeIterator(f.getRawValues()),\nh=f.next();!h.done;h=f.next()){h=h.value;if(h instanceof Ha){if(e.has(h))continue;try{h=g.fetch(h)}catch(m){e.put(h);Ya(\'hasBlendModes - ignoring XObject: "\'+m+\'".\');continue}}h instanceof $a&&(h.dict.objId&&e.put(h.dict.objId),h=h.dict.get("Resources"),!(h instanceof ca)||h.objId&&e.has(h.objId)||(b.push(h),h.objId&&e.put(h.objId)))}}e=u.makeIterator(e);for(b=e.next();!b.done;b=e.next())d.put(b.value);return!1};c.fetchBuiltInCMap=function(){var b=Fc(function g(e){var f=this,h,k,l,m,n;return u.generator.createGenerator(g,\nfunction(p){switch(p.nextAddress){case 1:return(h=f.builtInCMapCache.get(e))?p.return(h):null!==f.options.cMapUrl?(l=""+f.options.cMapUrl+e+".bcmap",p.yield(fetch(l),5)):p.yield(f.handler.sendWithPromise("FetchBuiltInCMap",{name:e}),4);case 4:k=p.yieldResult;p.jumpTo(3);break;case 5:m=p.yieldResult;if(!m.ok)throw Error(\'fetchBuiltInCMap: failed to fetch file "\'+l+\'" with "\'+m.statusText+\'".\');n=Uint8Array;return p.yield(m.arrayBuffer(),6);case 6:k={cMapData:new n(p.yieldResult),isCompressed:!0};case 3:return f.builtInCMapCache.set(e,\nk),p.return(k)}})});return function(e){return b.apply(this,arguments)}}();c.fetchStandardFontData=function(){var b=Fc(function g(e){var f=this,h,k,l,m,n,p,q,r;return u.generator.createGenerator(g,function(t){switch(t.nextAddress){case 1:if(h=f.standardFontDataCache.get(e))return t.return(new Mb(h));if(f.options.useSystemFonts&&"Symbol"!==e&&"ZapfDingbats"!==e)return t.return(null);k=ds();l=k[e];if(null!==f.options.standardFontDataUrl)return p=""+f.options.standardFontDataUrl+l,t.yield(fetch(p),7);\nt.setCatchFinallyBlocks(4);return t.yield(f.handler.sendWithPromise("FetchStandardFontData",{filename:l}),6);case 6:m=t.yieldResult;t.leaveTryBlock(3);break;case 4:n=t.enterCatchBlock();T(\'fetchStandardFontData: failed to fetch file "\'+l+\'" with "\'+n+\'".\');t.jumpTo(3);break;case 7:q=t.yieldResult;if(!q.ok){T(\'fetchStandardFontData: failed to fetch file "\'+p+\'" with "\'+q.statusText+\'".\');t.jumpTo(3);break}r=Uint8Array;return t.yield(q.arrayBuffer(),9);case 9:m=new r(t.yieldResult);case 3:if(!m)return t.return(null);\nf.standardFontDataCache.set(e,m);return t.return(new Mb(m))}})});return function(e){return b.apply(this,arguments)}}();c.buildFormXObject=function(){var b=Fc(function n(e,g,f,h,k,l,m){var p,q,r,t,v,w=this,y,x,z,A,B,C;return u.generator.createGenerator(n,function(D){switch(D.nextAddress){case 1:p=g.dict;q=Md(p.getArray("Matrix"),null);r=sd(p.getArray("BBox"),null);if(!p.has("OC")){D.jumpTo(2);break}return D.yield(w.parseMarkedContentProps(p.get("OC"),e),3);case 3:t=D.yieldResult;case 2:void 0!==t&&\nh.addOp(O.beginMarkedContentProps,["OC",t]);y=p.get("Group");if(!y){D.jumpTo(4);break}v={matrix:q,bbox:r,smask:f,isolated:!1,knockout:!1};x=y.get("S");z=null;if(!Lb(x,"Transparency")){D.jumpTo(5);break}v.isolated=y.get("I")||!1;v.knockout=y.get("K")||!1;if(!y.has("CS")){D.jumpTo(5);break}A=y.getRaw("CS");if(B=ab.getCached(A,w.xref,m)){z=B;D.jumpTo(5);break}return D.yield(w.parseColorSpace({cs:A,resources:e,localColorSpaceCache:m}),8);case 8:z=D.yieldResult;case 5:null!=f&&f.backdrop&&(z||(z=ab.singletons.rgb),\nf.backdrop=z.getRgb(f.backdrop,0)),h.addOp(O.beginGroup,[v]);case 4:return C=y?[q,null]:[q,r],h.addOp(O.paintFormXObjectBegin,C),D.yield(w.getOperatorList({stream:g,task:k,resources:p.get("Resources")||e,operatorList:h,initialState:l}),9);case 9:h.addOp(O.paintFormXObjectEnd,[]),y&&h.addOp(O.endGroup,[v]),void 0!==t&&h.addOp(O.endMarkedContent,[]),D.jumpToEnd()}})});return function(e,g,f,h,k,l,m){return b.apply(this,arguments)}}();c._sendImgData=function(b,d,e){void 0===e&&(e=!1);var g=d?[d.bitmap||\nd.data.buffer]:null;return this.parsingType3Font||e?this.handler.send("commonobj",[b,"Image",d],g):this.handler.send("obj",[b,this.pageIndex,"Image",d],g)};c.buildPaintImageXObject=function(){var b=Fc(function g(e){var f=this,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R,Y;return u.generator.createGenerator(g,function(fa){switch(fa.nextAddress){case 1:k=h=f;l=e;m=l.resources;n=l.image;p=void 0===l.isInline?!1:l.isInline;q=l.operatorList;r=l.cacheKey;t=l.localImageCache;v=\nl.localColorSpaceCache;w=n.dict;y=w.objId;x=w.get("W","Width");z=w.get("H","Height");if(!x||"number"!==typeof x||!z||"number"!==typeof z)return T("Image dimensions are missing, or not numbers."),fa.return();A=f.options.maxImageSize;if(-1!==A&&x*z>A){if(f.options.ignoreErrors)return T("Image exceeded maximum allowed size and was removed."),fa.return();throw Error("Image exceeded maximum allowed size and was removed.");}if(!w.has("OC")){fa.jumpTo(2);break}return fa.yield(f.parseMarkedContentProps(w.get("OC"),\nm),3);case 3:B=fa.yieldResult;case 2:C=w.get("IM","ImageMask")||!1;if(!C){fa.jumpTo(4);break}G=w.get("I","Interpolate");J=x+7>>3;F=n.getBytes(J*z);L=w.getArray("D","Decode");return f.parsingType3Font?(D=Pg.createRawMask({imgArray:F,width:x,height:z,imageIsFromDecodeStream:n instanceof uc,inverseDecode:0<(null==L?void 0:L[0]),interpolate:G}),D.cached=!!r,E=[D],q.addImageOps(O.paintImageMaskXObject,E,B),r&&(M={fn:O.paintImageMaskXObject,args:E,optionalContent:B},t.set(r,y,M),y&&f._regionalImageCache.set(null,\ny,M)),fa.return()):fa.yield(Pg.createMask({imgArray:F,width:x,height:z,imageIsFromDecodeStream:n instanceof uc,inverseDecode:0<(null==L?void 0:L[0]),interpolate:G,isOffscreenCanvasSupported:f.options.isOffscreenCanvasSupported}),5);case 5:D=fa.yieldResult;if(D.isSingleOpaquePixel)return q.addImageOps(O.paintSolidColorImageMask,[],B),r&&(W={fn:O.paintSolidColorImageMask,args:[],optionalContent:B},t.set(r,y,W),y&&f._regionalImageCache.set(null,y,W)),fa.return();Q="mask_"+f.idFactory.createObjId();q.addDependency(Q);\nD.dataLen=D.bitmap?D.width*D.height*4:D.data.length;f._sendImgData(Q,D);E=[{data:Q,width:D.width,height:D.height,interpolate:D.interpolate,count:1}];q.addImageOps(O.paintImageMaskXObject,E,B);r&&(la={objId:Q,fn:O.paintImageMaskXObject,args:E,optionalContent:B},t.set(r,y,la),y&&f._regionalImageCache.set(null,y,la));return fa.return();case 4:if(!(p&&200>x+z)||w.has("SMask")||w.has("Mask")){fa.jumpTo(6);break}fa.setCatchFinallyBlocks(7);ta=new Pg({xref:f.xref,res:m,image:n,isInline:p,pdfFunctionFactory:f._pdfFunctionFactory,\nlocalColorSpaceCache:v});return fa.yield(ta.createImageData(!0,!1),9);case 9:D=fa.yieldResult;q.isOffscreenCanvasSupported=f.options.isOffscreenCanvasSupported;q.addImageOps(O.paintInlineImageXObject,[D],B);fa.leaveTryBlock(8);break;case 7:qa=fa.enterCatchBlock();va=\'Unable to decode inline image: "\'+qa+\'".\';if(!f.options.ignoreErrors)throw Error(va);T(va);case 8:return fa.return();case 6:S="img_"+f.idFactory.createObjId();da=!1;f.parsingType3Font?S=f.idFactory.getDocId()+"_type3_"+S:r&&y&&(da=f.globalImageCache.shouldCache(y,\nf.pageIndex))&&(xc(!p,"Cannot cache an inline image globally."),S=f.idFactory.getDocId()+"_"+S);q.addDependency(S);E=[S,x,z];q.addImageOps(O.paintImageXObject,E,B);if(!da){fa.jumpTo(10);break}if(f.globalImageCache.hasDecodeFailed(y))return f.globalImageCache.setData(y,{objId:S,fn:O.paintImageXObject,args:E,optionalContent:B,byteSize:0}),f._sendImgData(S,null,da),fa.return();if(!(25E4<x*z||w.has("SMask")||w.has("Mask"))){fa.jumpTo(10);break}return fa.yield(f.handler.sendWithPromise("commonobj",[S,\n"CopyLocalImage",{imageRef:y}]),12);case 12:if(R=fa.yieldResult)return f.globalImageCache.setData(y,{objId:S,fn:O.paintImageXObject,args:E,optionalContent:B,byteSize:0}),f.globalImageCache.addByteSize(y,R),fa.return();case 10:Pg.buildImage({xref:f.xref,res:m,image:n,isInline:p,pdfFunctionFactory:f._pdfFunctionFactory,localColorSpaceCache:v}).then(function(){var H=Fc(function ba(N){return u.generator.createGenerator(ba,function(aa){if(1==aa.nextAddress)return aa.yield(N.createImageData(!1,k.options.isOffscreenCanvasSupported),\n2);D=aa.yieldResult;D.dataLen=D.bitmap?D.width*D.height*4:D.data.length;D.ref=y;da&&k.globalImageCache.addByteSize(y,D.dataLen);return aa.return(k._sendImgData(S,D,da))})});return function(N){return H.apply(this,arguments)}}()).catch(function(H){T(\'Unable to decode image "\'+S+\'": "\'+H+\'".\');y&&h.globalImageCache.addDecodeFailed(y);return h._sendImgData(S,null,da)}),r&&(Y={objId:S,fn:O.paintImageXObject,args:E,optionalContent:B},t.set(r,y,Y),y&&(f._regionalImageCache.set(null,y,Y),da&&f.globalImageCache.setData(y,\n{objId:S,fn:O.paintImageXObject,args:E,optionalContent:B,byteSize:0}))),fa.jumpToEnd()}})});return function(e){return b.apply(this,arguments)}}();c.handleSMask=function(b,d,e,g,f,h){var k=b.get("G"),l={subtype:b.get("S").name,backdrop:b.get("BC")};b=b.get("TR");if(hi(b)){b=this._pdfFunctionFactory.create(b);for(var m=new Uint8Array(256),n=new Float32Array(1),p=0;256>p;p++)n[0]=p/255,b(n,0,n,0),m[p]=255*n[0]|0;l.transferMap=m}return this.buildFormXObject(d,k,l,e,g,f.state.clone(),h)};c.handleTransferFunction=\nfunction(b){if(Array.isArray(b))var d=b;else if(hi(b))d=[b];else return null;b=[];var e=0,g=0;d=u.makeIterator(d);for(var f=d.next();!f.done;f=d.next())if(f=this.xref.fetchIfRef(f.value),e++,Lb(f,"Identity"))b.push(null);else{if(!hi(f))return null;f=this._pdfFunctionFactory.create(f);for(var h=new Uint8Array(256),k=new Float32Array(1),l=0;256>l;l++)k[0]=l/255,f(k,0,k,0),h[l]=255*k[0]|0;b.push(h);g++}return 1!==e&&4!==e||0===g?null:b};c.handleTilingType=function(b,d,e,g,f,h,k,l){var m=this,n=new Dc;\ne=ca.merge({xref:this.xref,dictArray:[f.get("Resources"),e]});return this.getOperatorList({stream:g,task:k,resources:e,operatorList:n}).then(function(){var p=n.getIR(),q=wl(p,f,d);h.addDependencies(n.dependencies);h.addOp(b,q);f.objId&&l.set(null,f.objId,{operatorListIR:p,dict:f})}).catch(function(p){if(!(p instanceof rc))if(m.options.ignoreErrors)T(\'handleTilingType - ignoring pattern: "\'+p+\'".\');else throw p;})};c.handleSetFont=function(){var b=Fc(function p(e,g,f,h,k,l,m,n){var q,r=this,t,v;return u.generator.createGenerator(p,\nfunction(w){switch(w.nextAddress){case 1:return void 0===m&&(m=null),void 0===n&&(n=null),q=(null==g?void 0:g[0])instanceof ka?g[0].name:null,w.yield(r.loadFont(q,f,e,m,n),2);case 2:t=w.yieldResult;if(!t.font.isType3Font){w.jumpTo(3);break}w.setCatchFinallyBlocks(4);return w.yield(t.loadType3Data(r,e,k),6);case 6:h.addDependencies(t.type3Dependencies);w.leaveTryBlock(3);break;case 4:v=w.enterCatchBlock(),t=new Rg({loadedName:"g_font_error",font:new wj("Type3 font load error: "+v),dict:t.font,evaluatorOptions:r.options});\ncase 3:return l.font=t.font,t.send(r.handler),w.return(t.loadedName)}})});return function(e,g,f,h,k,l,m,n){return b.apply(this,arguments)}}();c.handleText=function(b,d){var e=d.font;b=e.charsToGlyphs(b);e.data&&(d.textRenderingMode&4||"Pattern"===d.fillColorSpace.name||e.disableFontFace||this.options.disableFontFace)&&a.buildFontPaths(e,b,this.handler,this.options);return b};c.ensureStateFont=function(b){if(!b.font)if(b=new oa("Missing setFont (Tf) operator before text rendering operator."),this.options.ignoreErrors)T(\'ensureStateFont: "\'+\nb+\'".\');else throw b;};c.setGState=function(){var b=Fc(function g(e){var f=this,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D;return u.generator.createGenerator(g,function(E){if(1==E.nextAddress){h=f;k=e;l=k.resources;m=k.gState;n=k.operatorList;p=k.cacheKey;q=k.task;r=k.stateManager;t=k.localGStateCache;v=k.localColorSpaceCache;w=m.objId;y=!0;x=[];z=Promise.resolve();A=u.makeIterator(m.getKeys());B=A.next();for(C={};!B.done;C={value$jscomp$227:void 0,key$jscomp$124:void 0},B=A.next())switch(C.key$jscomp$124=\nB.value,C.value$jscomp$227=m.get(C.key$jscomp$124),C.key$jscomp$124){case "Type":break;case "LW":case "LC":case "LJ":case "ML":case "D":case "RI":case "FL":case "CA":case "ca":x.push([C.key$jscomp$124,C.value$jscomp$227]);break;case "Font":y=!1;z=z.then(function(G){return function(){return h.handleSetFont(l,null,G.value$jscomp$227[0],n,q,r.state).then(function(J){n.addDependency(J);x.push([G.key$jscomp$124,[J,G.value$jscomp$227[1]]])})}}(C));break;case "BM":x.push([C.key$jscomp$124,Pl(C.value$jscomp$227)]);\nbreak;case "SMask":if(Lb(C.value$jscomp$227,"None")){x.push([C.key$jscomp$124,!1]);break}C.value$jscomp$227 instanceof ca?(y=!1,z=z.then(function(G){return function(){return h.handleSMask(G.value$jscomp$227,l,n,q,r,v)}}(C)),x.push([C.key$jscomp$124,!0])):T("Unsupported SMask type");break;case "TR":D=f.handleTransferFunction(C.value$jscomp$227);x.push([C.key$jscomp$124,D]);break;case "OP":case "op":case "OPM":case "BG":case "BG2":case "UCR":case "UCR2":case "TR2":case "HT":case "SM":case "SA":case "AIS":case "TK":Ya("graphic state operator "+\nC.key$jscomp$124);break;default:Ya("Unknown graphic state operator "+C.key$jscomp$124)}return E.yield(z,2)}0<x.length&&n.addOp(O.setGState,[x]);y&&t.set(p,w,x);E.jumpToEnd()})});return function(e){return b.apply(this,arguments)}}();c.loadFont=function(b,d,e,g,f){var h=this,k=this,l;void 0===g&&(g=null);void 0===f&&(f=null);var m=function(){var t=Fc(function w(){return u.generator.createGenerator(w,function(y){return y.return(new Rg({loadedName:"g_font_error",font:new wj(\'Font "\'+b+\'" is not available.\'),\ndict:d,evaluatorOptions:k.options}))})});return function(){return t.apply(this,arguments)}}(),n;d?d instanceof Ha&&(n=d):(e=e.get("Font"))&&(n=e.getRaw(b));if(n){var p;if(null!=(p=this.type3FontRefs)&&p.has(n))return m();if(this.fontCache.has(n))return this.fontCache.get(n);try{d=this.xref.fetchIfRef(n)}catch(t){T(\'loadFont - lookup failed: "\'+t+\'".\')}}if(!(d instanceof ca)){if(!this.options.ignoreErrors&&!this.parsingType3Font)return T(\'Font "\'+b+\'" is not available.\'),m();T(\'Font "\'+b+\'" is not available -- attempting to fallback to a default font.\');\nd=g||a.fallbackFontDict}if(d.cacheKey&&this.fontCache.has(d.cacheKey))return this.fontCache.get(d.cacheKey);p=Promise.withResolvers();g=p.promise;var q=p.resolve;try{var r=this.preEvaluateFont(d);r.cssFontInfo=f}catch(t){return T(\'loadFont - preEvaluateFont failed: "\'+t+\'".\'),m()}f=r;p=f.descriptor;m=f.hash;f=n instanceof Ha;if(m&&p instanceof ca){p=p.fontAliases||(p.fontAliases=Object.create(null));if(p[m]){if(e=p[m].aliasRef,f&&e&&this.fontCache.has(e))return this.fontCache.putAlias(n,e),this.fontCache.get(n)}else p[m]=\n{fontID:this.idFactory.createFontId()};f&&(p[m].aliasRef=n);m=p[m].fontID}else m=this.idFactory.createFontId();xc(null==(l=m)?void 0:l.startsWith("f"),\'The "fontID" must be (correctly) defined.\');f?this.fontCache.put(n,g):(d.cacheKey="cacheKey_"+m,this.fontCache.put(d.cacheKey,g));d.loadedName=this.idFactory.getDocId()+"_"+m;this.translateFont(r).then(function(t){q(new Rg({loadedName:d.loadedName,font:t,dict:d,evaluatorOptions:h.options}))}).catch(function(t){T(\'loadFont - translateFont failed: "\'+\nt+\'".\');q(new Rg({loadedName:d.loadedName,font:new wj(t instanceof Error?t.message:t),dict:d,evaluatorOptions:h.options}))});return g};c.buildPath=function(b,d,e,g){void 0===g&&(g=!1);var f=b.length-1;e||(e=[]);if(0>f||b.fnArray[f]!==O.constructPath){g&&(T(\'Encountered path operator "\'+d+\'" inside of a text object.\'),b.addOp(O.save,null));switch(d){case O.rectangle:f=e[0]+e[2];var h=e[1]+e[3];f=[Math.min(e[0],f),Math.min(e[1],h),Math.max(e[0],f),Math.max(e[1],h)];break;case O.moveTo:case O.lineTo:f=\n[e[0],e[1],e[0],e[1]];break;default:f=[Infinity,Infinity,-Infinity,-Infinity]}b.addOp(O.constructPath,[[d],e,f]);g&&b.addOp(O.restore,null)}else switch(b=b.argsArray[f],b[0].push(d),b[1].push.apply(b[1],u.arrayFromIterable(e)),b=b[2],d){case O.rectangle:d=e[0]+e[2];g=e[1]+e[3];b[0]=Math.min(b[0],e[0],d);b[1]=Math.min(b[1],e[1],g);b[2]=Math.max(b[2],e[0],d);b[3]=Math.max(b[3],e[1],g);break;case O.moveTo:case O.lineTo:b[0]=Math.min(b[0],e[0]),b[1]=Math.min(b[1],e[1]),b[2]=Math.max(b[2],e[0]),b[3]=Math.max(b[3],\ne[1])}};c.parseColorSpace=function(b){var d=this;return ab.parseAsync({cs:b.cs,xref:this.xref,resources:b.resources,pdfFunctionFactory:this._pdfFunctionFactory,localColorSpaceCache:b.localColorSpaceCache}).catch(function(e){if(e instanceof rc)return null;if(d.options.ignoreErrors)return T(\'parseColorSpace - ignoring ColorSpace: "\'+e+\'".\'),null;throw e;})};c.parseShading=function(b){var d=b.shading,e=b.resources,g=b.localColorSpaceCache;b=b.localShadingPatternCache;var f=b.get(d);if(f)return f;try{var h=\nEs.parseShading(d,this.xref,e,this._pdfFunctionFactory,g).getIR()}catch(k){if(k instanceof rc)return null;if(this.options.ignoreErrors)return T(\'parseShading - ignoring shading: "\'+k+\'".\'),b.set(d,null),null;throw k;}f="pattern_"+this.idFactory.createObjId();this.parsingType3Font&&(f=this.idFactory.getDocId()+"_type3_"+f);b.set(d,f);this.parsingType3Font?this.handler.send("commonobj",[f,"Pattern",h]):this.handler.send("obj",[f,this.pageIndex,"Pattern",h]);return f};c.handleColorN=function(b,d,e,g,\nf,h,k,l,m,n){var p=e.pop();if(p instanceof ka){f=f.getRaw(p.name);var q=f instanceof Ha&&m.getByRef(f);if(q)try{var r=g.base?g.base.getRgb(e,0):null,t=wl(q.operatorListIR,q.dict,r);b.addOp(d,t);return}catch(v){}if(r=this.xref.fetchIfRef(f)){p=r instanceof $a?r.dict:r;t=p.get("PatternType");if(1===t)return l=g.base?g.base.getRgb(e,0):null,this.handleTilingType(d,l,h,r,p,b,k,m);if(2===t){k=p.get("Shading");if(h=this.parseShading({shading:k,resources:h,localColorSpaceCache:l,localShadingPatternCache:n}))k=\nMd(p.getArray("Matrix"),null),b.addOp(d,["Shading",h,k]);return}throw new oa("Unknown PatternType: "+t);}}throw new oa("Unknown PatternName: "+p);};c._parseVisibilityExpression=function(b,d,e){if(10<++d)T("Visibility expression is too deeply nested");else{var g=b.length,f=this.xref.fetchIfRef(b[0]);if(2>g||!(f instanceof ka))T("Invalid visibility expression");else{switch(f.name){case "And":case "Or":case "Not":e.push(f.name);break;default:T("Invalid operator "+f.name+" in visibility expression");\nreturn}for(f=1;f<g;f++){var h=b[f],k=this.xref.fetchIfRef(h);Array.isArray(k)?(h=[],e.push(h),this._parseVisibilityExpression(k,d,h)):h instanceof Ha&&e.push(h.toString())}}}};c.parseMarkedContentProps=function(){var b=Fc(function f(e,g){var h,k,l,m,n,p,q=this,r,t,v,w,y;return u.generator.createGenerator(f,function(x){if(e instanceof ka)l=g.get("Properties"),k=l.get(e.name);else if(e instanceof ca)k=e;else throw new oa("Optional content properties malformed.");m=null==(h=k.get("Type"))?void 0:h.name;\nif("OCG"===m)return x.return({type:m,id:k.objId});if("OCMD"===m){n=k.get("VE");if(Array.isArray(n)&&(p=[],q._parseVisibilityExpression(n,0,p),0<p.length))return x.return({type:"OCMD",expression:p});r=k.get("OCGs");if(Array.isArray(r)||r instanceof ca){t=[];if(Array.isArray(r))for(v=u.makeIterator(r),w=v.next();!w.done;w=v.next())y=w.value,t.push(y.toString());else t.push(r.objId);return x.return({type:m,ids:t,policy:k.get("P")instanceof ka?k.get("P").name:null,expression:null})}if(r instanceof Ha)return x.return({type:m,\nid:r.toString()})}return x.return(null)})});return function(e,g){return b.apply(this,arguments)}}();c.getOperatorList=function(b){function d(){for(var D=0,E=B.savedStatesDepth;D<E;D++)k.addOp(O.restore,[])}var e=this,g=b.stream,f=b.task,h=b.resources,k=b.operatorList,l=void 0===b.initialState?null:b.initialState,m=void 0===b.fallbackFontDict?null:b.fallbackFontDict;h||(h=ca.empty);l||(l=new ko);if(!k)throw Error(\'getOperatorList: missing "operatorList" parameter\');var n=this,p=this.xref,q=!1,r=new Yn,\nt=new Zn,v=new $n,w=new ot,y=new Map,x=h.get("XObject")||ca.empty,z=h.get("Pattern")||ca.empty,A=new Sg(l),B=new Gf(g,p,A),C=new Qg;return(new Promise(function J(E,G){function F(R){Promise.all([R,k.ready]).then(function(){try{J(E,G)}catch(Y){G(Y)}},G)}f.ensureNotTerminated();C.reset();for(var L={},M,W,Q,la,ta;!(M=C.check());){L.args=null;if(!B.read(L))break;M=L.args;var qa=L.fn;switch(qa|0){case O.paintXObject:ta=M[0]instanceof ka;la=M[0].name;if(ta&&(M=r.getByName(la))){ni(k,M);M=null;continue}F((new Promise(function(R,\nY){if(!ta)throw new oa("XObject must be referred to by name.");var fa=x.getRaw(la);if(fa instanceof Ha){var H=r.getByRef(fa)||n._regionalImageCache.getByRef(fa);if(H){ni(k,H);R();return}if(H=n.globalImageCache.getData(fa,n.pageIndex)){k.addDependency(H.objId);k.addImageOps(H.fn,H.args,H.optionalContent);R();return}fa=p.fetch(fa)}if(!(fa instanceof $a))throw new oa("XObject should be a stream");H=fa.dict.get("Subtype");if(!(H instanceof ka))throw new oa("XObject should have a Name subtype");if("Form"===\nH.name)A.save(),n.buildFormXObject(h,fa,null,k,f,A.state.clone(),t).then(function(){A.restore();R()},Y);else if("Image"===H.name)n.buildPaintImageXObject({resources:h,image:fa,operatorList:k,cacheKey:la,localImageCache:r,localColorSpaceCache:t}).then(R,Y);else{if("PS"===H.name)Ya("Ignored XObject subtype PS");else throw new oa("Unhandled XObject subtype "+H.name);R()}})).catch(function(R){if(!(R instanceof rc))if(n.options.ignoreErrors)T(\'getOperatorList - ignoring XObject: "\'+R+\'".\');else throw R;\n}));return;case O.setFont:var va=M[1];F(n.handleSetFont(h,M,null,k,f,A.state,m).then(function(R){k.addDependency(R);k.addOp(O.setFont,[R,va])}));return;case O.beginText:q=!0;break;case O.endText:q=!1;break;case O.endInlineImage:if(W=M[0].cacheKey)if(Q=r.getByName(W)){ni(k,Q);M=null;continue}F(n.buildPaintImageXObject({resources:h,image:M[0],isInline:!0,operatorList:k,cacheKey:W,localImageCache:r,localColorSpaceCache:t}));return;case O.showText:if(!A.state.font){n.ensureStateFont(A.state);continue}M[0]=\nn.handleText(M[0],A.state);break;case O.showSpacedText:if(!A.state.font){n.ensureStateFont(A.state);continue}W=[];Q=A.state;qa=u.makeIterator(M[0]);for(var S=qa.next();!S.done;S=qa.next())S=S.value,"string"===typeof S?W.push.apply(W,u.arrayFromIterable(n.handleText(S,Q))):"number"===typeof S&&W.push(S);M[0]=W;qa=O.showText;break;case O.nextLineShowText:if(!A.state.font){n.ensureStateFont(A.state);continue}k.addOp(O.nextLine);M[0]=n.handleText(M[0],A.state);qa=O.showText;break;case O.nextLineSetSpacingShowText:if(!A.state.font){n.ensureStateFont(A.state);\ncontinue}k.addOp(O.nextLine);k.addOp(O.setWordSpacing,[M.shift()]);k.addOp(O.setCharSpacing,[M.shift()]);M[0]=n.handleText(M[0],A.state);qa=O.showText;break;case O.setTextRenderingMode:A.state.textRenderingMode=M[0];break;case O.setFillColorSpace:if(W=ab.getCached(M[0],p,t)){A.state.fillColorSpace=W;continue}F(n.parseColorSpace({cs:M[0],resources:h,localColorSpaceCache:t}).then(function(R){A.state.fillColorSpace=R||ab.singletons.gray}));return;case O.setStrokeColorSpace:if(W=ab.getCached(M[0],p,t)){A.state.strokeColorSpace=\nW;continue}F(n.parseColorSpace({cs:M[0],resources:h,localColorSpaceCache:t}).then(function(R){A.state.strokeColorSpace=R||ab.singletons.gray}));return;case O.setFillColor:W=A.state.fillColorSpace;M=W.getRgb(M,0);qa=O.setFillRGBColor;break;case O.setStrokeColor:W=A.state.strokeColorSpace;M=W.getRgb(M,0);qa=O.setStrokeRGBColor;break;case O.setFillGray:A.state.fillColorSpace=ab.singletons.gray;M=ab.singletons.gray.getRgb(M,0);qa=O.setFillRGBColor;break;case O.setStrokeGray:A.state.strokeColorSpace=ab.singletons.gray;\nM=ab.singletons.gray.getRgb(M,0);qa=O.setStrokeRGBColor;break;case O.setFillCMYKColor:A.state.fillColorSpace=ab.singletons.cmyk;M=ab.singletons.cmyk.getRgb(M,0);qa=O.setFillRGBColor;break;case O.setStrokeCMYKColor:A.state.strokeColorSpace=ab.singletons.cmyk;M=ab.singletons.cmyk.getRgb(M,0);qa=O.setStrokeRGBColor;break;case O.setFillRGBColor:A.state.fillColorSpace=ab.singletons.rgb;M=ab.singletons.rgb.getRgb(M,0);break;case O.setStrokeRGBColor:A.state.strokeColorSpace=ab.singletons.rgb;M=ab.singletons.rgb.getRgb(M,\n0);break;case O.setFillColorN:W=A.state.patternFillColorSpace;if(!W){if(yc(M,null)){M=ab.singletons.gray.getRgb(M,0);qa=O.setFillRGBColor;break}M=[];qa=O.setFillTransparent;break}if("Pattern"===W.name){F(n.handleColorN(k,O.setFillColorN,M,W,z,h,f,t,w,y));return}M=W.getRgb(M,0);qa=O.setFillRGBColor;break;case O.setStrokeColorN:W=A.state.patternStrokeColorSpace;if(!W){if(yc(M,null)){M=ab.singletons.gray.getRgb(M,0);qa=O.setStrokeRGBColor;break}M=[];qa=O.setStrokeTransparent;break}if("Pattern"===W.name){F(n.handleColorN(k,\nO.setStrokeColorN,M,W,z,h,f,t,w,y));return}M=W.getRgb(M,0);qa=O.setStrokeRGBColor;break;case O.shadingFill:W=void 0;try{var da=h.get("Shading");if(!da)throw new oa("No shading resource found");W=da.get(M[0].name);if(!W)throw new oa("No shading object found");}catch(R){if(R instanceof rc)continue;if(n.options.ignoreErrors){T(\'getOperatorList - ignoring Shading: "\'+R+\'".\');continue}throw R;}M=n.parseShading({shading:W,resources:h,localColorSpaceCache:t,localShadingPatternCache:y});if(!M)continue;M=\n[M];qa=O.shadingFill;break;case O.setGState:ta=M[0]instanceof ka;la=M[0].name;if(ta&&(M=v.getByName(la))){0<M.length&&k.addOp(O.setGState,[M]);M=null;continue}F((new Promise(function(R,Y){if(!ta)throw new oa("GState must be referred to by name.");var fa=h.get("ExtGState");if(!(fa instanceof ca))throw new oa("ExtGState should be a dictionary.");fa=fa.get(la);if(!(fa instanceof ca))throw new oa("GState should be a dictionary.");n.setGState({resources:h,gState:fa,operatorList:k,cacheKey:la,task:f,stateManager:A,\nlocalGStateCache:v,localColorSpaceCache:t}).then(R,Y)})).catch(function(R){if(!(R instanceof rc))if(n.options.ignoreErrors)T(\'getOperatorList - ignoring ExtGState: "\'+R+\'".\');else throw R;}));return;case O.moveTo:case O.lineTo:case O.curveTo:case O.curveTo2:case O.curveTo3:case O.closePath:case O.rectangle:n.buildPath(k,qa,M,q);continue;case O.markPoint:case O.markPointProps:case O.beginCompat:case O.endCompat:continue;case O.beginMarkedContentProps:if(!(M[0]instanceof ka)){T("Expected name for beginMarkedContentProps arg0="+\nM[0]);k.addOp(O.beginMarkedContentProps,["OC",null]);continue}if("OC"===M[0].name){F(n.parseMarkedContentProps(M[1],h).then(function(R){k.addOp(O.beginMarkedContentProps,["OC",R])}).catch(function(R){if(!(R instanceof rc))if(n.options.ignoreErrors)T(\'getOperatorList - ignoring beginMarkedContentProps: "\'+R+\'".\'),k.addOp(O.beginMarkedContentProps,["OC",null]);else throw R;}));return}M=[M[0].name,M[1]instanceof ca?M[1].get("MCID"):null];break;default:if(null!==M){W=0;for(Q=M.length;W<Q&&!(M[W]instanceof\nca);W++);if(W<Q){T("getOperatorList - ignoring operator: "+qa);continue}}}k.addOp(qa,M)}M?F(jo):(d(),E())})).catch(function(E){if(!(E instanceof rc))if(e.options.ignoreErrors)T(\'getOperatorList - ignoring errors during "\'+f.name+\'" task: "\'+(E+\'".\')),d();else throw E;})};c.getTextContent=function(b){function d(N){var ba=(ta+1)%2,aa=" "!==la[ta]&&" "===la[ba];la[ta]=N;ta=ba;return!M&&aa}function e(){return!M&&" "!==la[ta]&&" "===la[(ta+1)%2]}function g(){la[0]=la[1]=" ";ta=0}function f(N){W.items.push({str:" ",\ndir:"ltr",width:void 0===N.width?0:N.width,height:void 0===N.height?0:N.height,transform:void 0===N.transform?Q.prevTransform:N.transform,fontName:void 0===N.fontName?Q.fontName:N.fontName,hasEOL:!1})}function h(){var N=H.font,ba=[H.fontSize*H.textHScale,0,0,H.fontSize,0,H.textRise];N.isType3Font&&(1>=H.fontSize||N.isCharBBox)&&!ee(H.fontMatrix,ie)&&(N=N.bbox[3]-N.bbox[1],0<N&&(ba[3]=ba[3]*N*H.fontMatrix[3]));return Rb.transform(H.ctm,Rb.transform(H.textMatrix,ba))}function k(){if(Q.initialized){var N=\nMath.hypot(H.ctm[0],H.ctm[1])*Math.hypot(H.textLineMatrix[0],H.textLineMatrix[1]);N!==Q.textAdvanceScale&&(Q.vertical?(Q.totalHeight+=Q.height*Q.textAdvanceScale,Q.height=0):(Q.totalWidth+=Q.width*Q.textAdvanceScale,Q.width=0),Q.textAdvanceScale=N)}}function l(N,ba){return m.apply(this,arguments)}function m(){m=Fc(function X(ba,aa){var ha;return u.generator.createGenerator(X,function(ma){switch(ma.nextAddress){case 1:return ma.yield(qa.loadFont(ba,aa,A),2);case 2:ha=ma.yieldResult;if(!ha.font.isType3Font){ma.jumpTo(3);\nbreak}ma.setCatchFinallyBlocks(4);return ma.yield(ha.loadType3Data(qa,A,z),6);case 6:ma.leaveTryBlock(3);break;case 4:ma.enterCatchBlock();case 3:H.loadedName=ha.loadedName,H.font=ha.font,H.fontMatrix=ha.font.fontMatrix||ie,ma.jumpToEnd()}})});return m.apply(this,arguments)}function n(N,ba,aa){var X=Math.hypot(aa[0],aa[1]);return[(aa[0]*N+aa[1]*ba)/X,(aa[2]*N+aa[3]*ba)/X]}function p(N){var ba,aa=h(),X=aa[4],ha=aa[5];if(null!=(ba=H.font)&&ba.vertical){if(X<G[0]||X>G[2]||ha+N<G[1]||ha>G[3])return!1}else if(X+\nN<G[0]||X>G[2]||ha<G[1]||ha>G[3])return!1;if(!H.font||!Q.prevTransform)return!0;N=Q.prevTransform[4];ba=Q.prevTransform[5];if(N===X&&ba===ha)return!0;var ma=-1;aa[0]&&0===aa[1]&&0===aa[2]?ma=0<aa[0]?0:180:aa[1]&&0===aa[0]&&0===aa[3]&&(ma=0<aa[1]?90:270);switch(ma){case 0:break;case 90:ha=u.makeIterator([ha,X]);X=ha.next().value;ha=ha.next().value;ba=u.makeIterator([ba,N]);N=ba.next().value;ba=ba.next().value;break;case 180:ba=u.makeIterator([-X,-ha,-N,-ba]);X=ba.next().value;ha=ba.next().value;N=\nba.next().value;ba=ba.next().value;break;case 270:ha=u.makeIterator([-ha,-X]);X=ha.next().value;ha=ha.next().value;ba=u.makeIterator([-ba,-N]);N=ba.next().value;ba=ba.next().value;break;default:ha=u.makeIterator(n(X,ha,aa)),X=ha.next().value,ha=ha.next().value,ba=u.makeIterator(n(N,ba,Q.prevTransform)),N=ba.next().value,ba=ba.next().value}if(H.font.vertical){ha=(ba-ha)/Q.textAdvanceScale;X-=N;N=Math.sign(Q.height);if(ha<N*Q.negativeSpaceMax){if(Math.abs(X)>.5*Q.width)return r(),!0;g();v();return!0}if(Math.abs(X)>\nQ.width)return r(),!0;ha<=N*Q.notASpace&&g();ha<=N*Q.trackingSpaceMin?e()?(g(),v(),f({height:Math.abs(ha)})):Q.height+=ha:t(ha,Q.prevTransform,N)||(0===Q.str.length?(g(),f({height:Math.abs(ha)})):Q.height+=ha);Math.abs(X)>.25*Q.width&&v();return!0}X=(X-N)/Q.textAdvanceScale;N=ha-ba;ha=Math.sign(Q.width);if(X<ha*Q.negativeSpaceMax){if(Math.abs(N)>.5*Q.height)return r(),!0;g();v();return!0}if(Math.abs(N)>Q.height)return r(),!0;X<=ha*Q.notASpace&&g();X<=ha*Q.trackingSpaceMin?e()?(g(),v(),f({width:Math.abs(X)})):\nQ.width+=X:t(X,Q.prevTransform,ha)||(0===Q.str.length?(g(),f({width:Math.abs(X)})):Q.width+=X);Math.abs(N)>.25*Q.height&&v();return!0}function q(N){var ba=N.chars,aa=N.extraSpacing;N=H.font;if(ba){ba=N.charsToGlyphs(ba);for(var X=H.fontMatrix[0]*H.fontSize,ha=0,ma=ba.length;ha<ma;ha++){var V=ba[ha],ea=V.category;if(!ea.isInvisibleFormatMark){var za=H.charSpacing+(ha+1===ma?aa:0),Ia=V.width;N.vertical&&(Ia=V.vmetric?V.vmetric[0]:-Ia);Ia*=X;if(!M&&ea.isWhitespace)N.vertical?(za+=-Ia+H.wordSpacing,H.translateTextMatrix(0,\n-za)):(za+=Ia+H.wordSpacing,H.translateTextMatrix(za*H.textHScale,0)),d(" ");else if(ea.isZeroWidthDiacritic||p(Ia)){if(!Q.initialized){var wa=H;var Aa=wa.font;wa=wa.loadedName;if(!E.has(wa)&&(E.add(wa),W.styles[wa]={fontFamily:Aa.fallbackName,ascent:Aa.ascent,descent:Aa.descent,vertical:Aa.vertical},qa.options.fontExtraProperties&&Aa.systemFontInfo)){var Ja=W.styles[wa];Ja.fontSubstitution=Aa.systemFontInfo.css;Ja.fontSubstitutionLoadedName=Aa.systemFontInfo.loadedName}Q.fontName=wa;wa=Q.transform=\nh();Aa.vertical?(Q.width=Q.totalWidth=Math.hypot(wa[0],wa[1]),Q.height=Q.totalHeight=0,Q.vertical=!0):(Q.width=Q.totalWidth=0,Q.height=Q.totalHeight=Math.hypot(wa[2],wa[3]),Q.vertical=!1);Q.textAdvanceScale=Math.hypot(H.ctm[0],H.ctm[1])*Math.hypot(H.textLineMatrix[0],H.textLineMatrix[1]);Aa=H.fontSize;Q.trackingSpaceMin=.102*Aa;Q.notASpace=.03*Aa;Q.negativeSpaceMax=-.2*Aa;Q.spaceInFlowMin=.102*Aa;Q.spaceInFlowMax=.6*Aa;Q.hasEOL=!1;Q.initialized=!0}Aa=Q;ea.isZeroWidthDiacritic&&(Ia=0);N.vertical?(H.translateTextMatrix(0,\nIa),Ia=Math.abs(Ia),Aa.height+=Ia):(Ia*=H.textHScale,H.translateTextMatrix(Ia,0),Aa.width+=Ia);Ia&&(Aa.prevTransform=h());V=V.unicode;d(V)&&Aa.str.push(" ");Aa.str.push(V);za&&(N.vertical?H.translateTextMatrix(0,-za):H.translateTextMatrix(za*H.textHScale,0))}else N.vertical?H.translateTextMatrix(0,Ia):H.translateTextMatrix(Ia*H.textHScale,0)}}}else(aa=H.charSpacing+aa)&&(N.vertical?H.translateTextMatrix(0,-aa):H.translateTextMatrix(aa*H.textHScale,0)),M&&p(0)}function r(){g();Q.initialized?(Q.hasEOL=\n!0,v()):W.items.push({str:"",dir:"ltr",width:0,height:0,transform:h(),fontName:H.loadedName,hasEOL:!0})}function t(N,ba,aa){if(aa*Q.spaceInFlowMin<=N&&N<=aa*Q.spaceInFlowMax)return Q.initialized&&(g(),Q.str.push(" ")),!1;aa=Q.fontName;var X=0;Q.vertical&&(X=N,N=0);v();g();f({width:Math.abs(N),height:Math.abs(X),transform:ba||h(),fontName:aa});return!0}function v(){if(Q.initialized&&Q.str){Q.vertical?Q.totalHeight+=Q.height*Q.textAdvanceScale:Q.totalWidth+=Q.width*Q.textAdvanceScale;var N=W.items,\nba=N.push,aa=Q.str.join("");L||(aa=gp(aa));aa=Cl(aa,-1,Q.vertical);ba.call(N,{str:aa.str,dir:aa.dir,width:Math.abs(Q.totalWidth),height:Math.abs(Q.totalHeight),transform:Q.transform,fontName:Q.fontName,hasEOL:Q.hasEOL});Q.initialized=!1;Q.str.length=0}}function w(N){void 0===N&&(N=!1);var ba=W.items.length;0===ba||N&&10>ba||(D.enqueue(W,ba),W.items=[],W.styles=Object.create(null))}var y=this,x=b.stream,z=b.task,A=b.resources,B=void 0===b.stateManager?null:b.stateManager,C=void 0===b.includeMarkedContent?\n!1:b.includeMarkedContent,D=b.sink,E=void 0===b.seenStyles?new Set:b.seenStyles,G=b.viewBox,J=void 0===b.lang?null:b.lang,F=void 0===b.markedContentData?null:b.markedContentData,L=void 0===b.disableNormalization?!1:b.disableNormalization,M=void 0===b.keepWhiteSpace?!1:b.keepWhiteSpace;A||(A=ca.empty);B||(B=new Sg(new wt));C&&(F||(F={level:0}));var W={items:[],styles:Object.create(null),lang:J},Q={initialized:!1,str:[],totalWidth:0,totalHeight:0,width:0,height:0,vertical:!1,prevTransform:null,textAdvanceScale:0,\nspaceInFlowMin:0,spaceInFlowMax:0,trackingSpaceMin:Infinity,negativeSpaceMax:-Infinity,notASpace:-Infinity,transform:null,fontName:null,hasEOL:!1},la=[" "," "],ta=0,qa=this,va=this.xref,S=[],da=null,R=new Yn,Y=new $n,fa=new Gf(x,va,B),H,U=new Qg;return(new Promise(function X(ba,aa){function ha(La){w(!0);Promise.all([La,D.ready]).then(function(){try{X(ba,aa)}catch(vb){aa(vb)}},aa)}z.ensureNotTerminated();U.reset();for(var ma={},V,ea=[];!(V=U.check());){ea.length=0;ma.args=ea;if(!fa.read(ma))break;\nV=H;H=B.state;var za=ma.fn;ea=ma.args;switch(za|0){case O.setFont:V=ea[0].name;za=ea[1];if(H.font&&V===H.fontName&&za===H.fontSize)break;v();H.fontName=V;H.fontSize=za;ha(l(V,null));return;case O.setTextRise:H.textRise=ea[0];break;case O.setHScale:H.textHScale=ea[0]/100;break;case O.setLeading:H.leading=ea[0];break;case O.moveText:H.translateTextLineMatrix(ea[0],ea[1]);H.textMatrix=H.textLineMatrix.slice();break;case O.setLeadingMoveText:H.leading=-ea[1];H.translateTextLineMatrix(ea[0],ea[1]);H.textMatrix=\nH.textLineMatrix.slice();break;case O.nextLine:H.carriageReturn();break;case O.setTextMatrix:H.setTextMatrix(ea[0],ea[1],ea[2],ea[3],ea[4],ea[5]);H.setTextLineMatrix(ea[0],ea[1],ea[2],ea[3],ea[4],ea[5]);k();break;case O.setCharSpacing:H.charSpacing=ea[0];break;case O.setWordSpacing:H.wordSpacing=ea[0];break;case O.beginText:H.textMatrix=ld.slice();H.textLineMatrix=ld.slice();break;case O.showSpacedText:if(!B.state.font){qa.ensureStateFont(B.state);continue}V=(H.font.vertical?1:-1)*H.fontSize/1E3;\nza=ea[0];for(var Ia=0,wa=za.length;Ia<wa;Ia++){var Aa=za[Ia];if("string"===typeof Aa)S.push(Aa);else if("number"===typeof Aa&&0!==Aa){var Ja=S.join("");S.length=0;q({chars:Ja,extraSpacing:Aa*V})}}0<S.length&&(V=S.join(""),S.length=0,q({chars:V,extraSpacing:0}));break;case O.showText:if(!B.state.font){qa.ensureStateFont(B.state);continue}q({chars:ea[0],extraSpacing:0});break;case O.nextLineShowText:if(!B.state.font){qa.ensureStateFont(B.state);continue}H.carriageReturn();q({chars:ea[0],extraSpacing:0});\nbreak;case O.nextLineSetSpacingShowText:if(!B.state.font){qa.ensureStateFont(B.state);continue}H.wordSpacing=ea[0];H.charSpacing=ea[1];H.carriageReturn();q({chars:ea[2],extraSpacing:0});break;case O.paintXObject:v();da||(da=A.get("XObject")||ca.empty);var Sa=ea[0]instanceof ka,Wa=ea[0].name;if(Sa&&R.getByName(Wa))break;ha((new Promise(function(La,vb){if(!Sa)throw new oa("XObject must be referred to by name.");var eb=da.getRaw(Wa);if(eb instanceof Ha){if(R.getByRef(eb)){La();return}if(qa.globalImageCache.getData(eb,\nqa.pageIndex)){La();return}eb=va.fetch(eb)}if(!(eb instanceof $a))throw new oa("XObject should be a stream");var Xa=eb.dict.get("Subtype");if(!(Xa instanceof ka))throw new oa("XObject should have a Name subtype");if("Form"!==Xa.name)R.set(Wa,eb.dict.objId,!0),La();else{Xa=B.state.clone();Xa=new Sg(Xa);var Na=Md(eb.dict.getArray("Matrix"),null);Na&&Xa.transform(Na);w();var hb={enqueueInvoked:!1,enqueue:function(Kb,Za){this.enqueueInvoked=!0;D.enqueue(Kb,Za)},get desiredSize(){return D.desiredSize},\nget ready(){return D.ready}};qa.getTextContent({stream:eb,task:z,resources:eb.dict.get("Resources")||A,stateManager:Xa,includeMarkedContent:C,sink:hb,seenStyles:E,viewBox:G,lang:J,markedContentData:F,disableNormalization:L,keepWhiteSpace:M}).then(function(){hb.enqueueInvoked||R.set(Wa,eb.dict.objId,!0);La()},vb)}})).catch(function(La){if(!(La instanceof rc))if(qa.options.ignoreErrors)T(\'getTextContent - ignoring XObject: "\'+La+\'".\');else throw La;}));return;case O.setGState:Sa=ea[0]instanceof ka;\nWa=ea[0].name;if(Sa&&Y.getByName(Wa))break;ha((new Promise(function(La,vb){if(!Sa)throw new oa("GState must be referred to by name.");var eb=A.get("ExtGState");if(!(eb instanceof ca))throw new oa("ExtGState should be a dictionary.");eb=eb.get(Wa);if(!(eb instanceof ca))throw new oa("GState should be a dictionary.");var Xa=eb.get("Font");Xa?(v(),H.fontName=null,H.fontSize=Xa[1],l(null,Xa[0]).then(La,vb)):(Y.set(Wa,eb.objId,!0),La())})).catch(function(La){if(!(La instanceof rc))if(qa.options.ignoreErrors)T(\'getTextContent - ignoring ExtGState: "\'+\nLa+\'".\');else throw La;}));return;case O.beginMarkedContent:v();C&&(F.level++,W.items.push({type:"beginMarkedContent",tag:ea[0]instanceof ka?ea[0].name:null}));break;case O.beginMarkedContentProps:v();C&&(F.level++,V=null,ea[1]instanceof ca&&(V=ea[1].get("MCID")),W.items.push({type:"beginMarkedContentProps",id:Number.isInteger(V)?qa.idFactory.getPageObjId()+"_mc"+V:null,tag:ea[0]instanceof ka?ea[0].name:null}));break;case O.endMarkedContent:v();C&&0!==F.level&&(F.level--,W.items.push({type:"endMarkedContent"}));\nbreak;case O.restore:!V||V.font===H.font&&V.fontSize===H.fontSize&&V.fontName===H.fontName||v()}if(W.items.length>=D.desiredSize){V=!0;break}}V?ha(jo):(v(),w(),ba())})).catch(function(ba){if(!(ba instanceof rc))if(y.options.ignoreErrors)T(\'getTextContent - ignoring errors during "\'+z.name+\'" task: "\'+(ba+\'".\')),v(),w();else throw ba;})};c.extractDataStructures=function(){var b=Fc(function f(e,g){var h=this,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J;return u.generator.createGenerator(f,function(F){if(1==\nF.nextAddress){k=h.xref;m=h.readToUnicode(g.toUnicode);if(g.composite){n=e.get("CIDSystemInfo");n instanceof ca&&(g.cidSystemInfo={registry:ib(n.get("Registry")),ordering:ib(n.get("Ordering")),supplement:n.get("Supplement")});try{p=e.get("CIDToGIDMap"),p instanceof $a&&(l=p.getBytes())}catch(L){if(!h.options.ignoreErrors)throw L;T(\'extractDataStructures - ignoring CIDToGIDMap data: "\'+L+\'".\')}}q=[];r=null;if(e.has("Encoding")){t=e.get("Encoding");if(t instanceof ca){if(r=t.get("BaseEncoding"),r=r instanceof\nka?r.name:null,t.has("Differences"))for(v=t.get("Differences"),w=0,y=u.makeIterator(v),x=y.next();!x.done;x=y.next())if(z=x.value,A=k.fetchIfRef(z),"number"===typeof A)w=A;else if(A instanceof ka)q[w++]=A.name;else throw new oa("Invalid entry in \'Differences\' array: "+A);}else if(t instanceof ka)r=t.name;else{if(!h.options.ignoreErrors)throw new oa("Encoding is not a Name nor a Dict");T("Encoding is not a Name nor a Dict")}"MacRomanEncoding"!==r&&"MacExpertEncoding"!==r&&"WinAnsiEncoding"!==r&&(r=\nnull)}B=!g.file||g.isInternalFont;C=Sh()[g.name];r&&B&&C&&(r=null);if(r)g.defaultEncoding=hf(r);else{D=!!(g.flags&Zc.Symbolic);E=!!(g.flags&Zc.Nonsymbolic);t=Bd;"TrueType"!==g.type||E||(t=jf);if(D||C)t=Nh,B&&(/Symbol/i.test(g.name)?t=Oh:/Dingbats/i.test(g.name)?t=Ph:/Wingdings/i.test(g.name)&&(t=jf));g.defaultEncoding=t}g.differences=q;g.baseEncodingName=r;g.hasEncoding=!!r||0<q.length;g.dict=e;G=g;return F.yield(m,2)}if(3!=F.nextAddress)return G.toUnicode=F.yieldResult,F.yield(h.buildToUnicode(g),\n3);J=F.yieldResult;g.toUnicode=J;l&&(g.cidToGidMap=h.readCidToGidMap(l,J));return F.return(g)})});return function(e,g){return b.apply(this,arguments)}}();c._simpleFontToUnicode=function(b,d){void 0===d&&(d=!1);xc(!b.composite,"Must be a simple font.");var e=[],g=b.defaultEncoding.slice(),f=b.baseEncodingName,h=b.differences;for(m in h){var k=h[m];".notdef"!==k&&(g[m]=k)}h=ud();for(var l in g){var m=g[l];if(""!==m){var n=h[m];if(void 0!==n)e[l]=String.fromCharCode(n);else{k=0;switch(m[0]){case "G":3===\nm.length&&(k=parseInt(m.substring(1),16));break;case "g":5===m.length&&(k=parseInt(m.substring(1),16));break;case "C":case "c":if(3<=m.length&&4>=m.length)if(n=m.substring(1),d)k=parseInt(n,16);else if(k=+n,Number.isNaN(k)&&Number.isInteger(parseInt(n,16)))return this._simpleFontToUnicode(b,!0);break;case "u":n=Fe(m,h);-1!==n&&(k=n);break;default:switch(m){case "f_h":case "f_t":case "T_h":e[l]=m.replaceAll("_","");continue}}if(0<k&&1114111>=k&&Number.isInteger(k)){if(f&&k===+l&&(n=hf(f))&&(m=n[l])){e[l]=\nString.fromCharCode(h[m]);continue}e[l]=String.fromCodePoint(k)}}}}return e};c.buildToUnicode=function(){var b=Fc(function g(e){var f,h,k=this,l,m,n,p,q,r,t;return u.generator.createGenerator(g,function(v){if(1==v.nextAddress){e.hasIncludedToUnicodeMap=0<(null==(f=e.toUnicode)?void 0:f.length);if(e.hasIncludedToUnicodeMap)return!e.composite&&e.hasEncoding&&(e.fallbackToUnicode=k._simpleFontToUnicode(e)),v.return(e.toUnicode);if(!e.composite)return v.return(new xf(k._simpleFontToUnicode(e)));if(!e.composite||\n(!e.cMap.builtInCMap||e.cMap instanceof Ee)&&("Adobe"!==(null==(h=e.cidSystemInfo)?void 0:h.registry)||"GB1"!==e.cidSystemInfo.ordering&&"CNS1"!==e.cidSystemInfo.ordering&&"Japan1"!==e.cidSystemInfo.ordering&&"Korea1"!==e.cidSystemInfo.ordering))return v.jumpTo(2);l=e.cidSystemInfo;m=l.registry;n=l.ordering;p=ka.get(m+"-"+n+"-UCS2");return v.yield(Lg.create({encoding:p,fetchBuiltInCMap:k._fetchBuiltInCMapBound,useCMap:null}),3)}return 2!=v.nextAddress?(q=v.yieldResult,r=[],t=[],e.cMap.forEach(function(w,\ny){if(65535<y)throw new oa("Max size of CID is 65,535");if(y=q.lookup(y)){for(var x=t.length=0,z=y.length;x<z;x+=2)t.push((y.charCodeAt(x)<<8)+y.charCodeAt(x+1));r[w]=String.fromCharCode.apply(String,u.arrayFromIterable(t))}}),v.return(new xf(r))):v.return(new ad(e.firstChar,e.lastChar))})});return function(e){return b.apply(this,arguments)}}();c.readToUnicode=function(){var b=Fc(function g(e){var f=this,h,k,l,m;return u.generator.createGenerator(g,function(n){switch(n.nextAddress){case 1:if(!e)return n.return(null);\nif(!(e instanceof ka)){n.jumpTo(2);break}return n.yield(Lg.create({encoding:e,fetchBuiltInCMap:f._fetchBuiltInCMapBound,useCMap:null}),3);case 3:return h=n.yieldResult,h instanceof Ee?n.return(new ad(0,65535)):n.return(new xf(h.getMap()));case 2:if(!(e instanceof $a)){n.jumpTo(4);break}n.setCatchFinallyBlocks(5);return n.yield(Lg.create({encoding:e,fetchBuiltInCMap:f._fetchBuiltInCMapBound,useCMap:null}),7);case 7:k=n.yieldResult;if(k instanceof Ee)return n.return(new ad(0,65535));l=Array(k.length);\nk.forEach(function(p,q){if("number"===typeof q)l[p]=String.fromCodePoint(q);else{0!==q.length%2&&(q="\\x00"+q);for(var r=[],t=0;t<q.length;t+=2){var v=q.charCodeAt(t)<<8|q.charCodeAt(t+1);if(55296!==(v&63488))r.push(v);else{t+=2;var w=q.charCodeAt(t)<<8|q.charCodeAt(t+1);r.push(((v&1023)<<10)+(w&1023)+65536)}}l[p]=String.fromCodePoint.apply(String,u.arrayFromIterable(r))}});return n.return(new xf(l));case 5:m=n.enterCatchBlock();if(m instanceof rc)return n.return(null);if(f.options.ignoreErrors)return T(\'readToUnicode - ignoring ToUnicode data: "\'+\nm+\'".\'),n.return(null);throw m;case 4:return n.return(null)}})});return function(e){return b.apply(this,arguments)}}();c.readCidToGidMap=function(b,d){for(var e=[],g=0,f=b.length;g<f;g++){var h=b[g++]<<8|b[g],k=g>>1;if(0!==h||d.has(k))e[k]=h}return e};c.extractWidths=function(b,d,e){var g=this.xref,f=[],h=0,k=[];if(e.composite){h=b.get("DW");h="number"===typeof h?Math.ceil(h):1E3;d=b.get("W");if(Array.isArray(d))for(var l=0,m=d.length;l<m;l++){var n=g.fetchIfRef(d[l++]);if(!Number.isInteger(n))break;\nvar p=g.fetchIfRef(d[l]);if(Array.isArray(p)){p=u.makeIterator(p);for(var q=p.next();!q.done;q=p.next())q=g.fetchIfRef(q.value),"number"===typeof q&&(f[n]=q),n++}else if(Number.isInteger(p)){if(q=g.fetchIfRef(d[++l]),"number"===typeof q)for(;n<=p;n++)f[n]=q}else break}if(e.vertical){var r=b.getArray("DW2");d=yc(r,2)?r:[880,-1E3];r=[d[1],.5*h,d[0]];d=b.get("W2");if(Array.isArray(d))for(b=0,l=d.length;b<l;b++){n=g.fetchIfRef(d[b++]);if(!Number.isInteger(n))break;m=g.fetchIfRef(d[b]);if(Array.isArray(m))for(p=\n0,q=m.length;p<q;p++){var t=[g.fetchIfRef(m[p++]),g.fetchIfRef(m[p++]),g.fetchIfRef(m[p])];yc(t,null)&&(k[n]=t);n++}else if(Number.isInteger(m)){if(p=[g.fetchIfRef(d[++b]),g.fetchIfRef(d[++b]),g.fetchIfRef(d[++b])],yc(p,null))for(;n<=m;n++)k[n]=p}else break}}}else if(l=b.get("Widths"),Array.isArray(l)){h=e.firstChar;b=u.makeIterator(l);for(l=b.next();!l.done;l=b.next())l=g.fetchIfRef(l.value),"number"===typeof l&&(f[h]=l),h++;g=d.get("MissingWidth");h="number"===typeof g?g:0}else g=b.get("BaseFont"),\ng instanceof ka&&(g=this.getBaseFontMetrics(g.name),f=this.buildCharCodeToWidth(g.widths,e),h=g.defaultWidth);g=!0;b=h;for(var v in f)if(d=f[v])if(!b)b=d;else if(b!==d){g=!1;break}e.flags=g?e.flags|Zc.FixedPitch:e.flags&~Zc.FixedPitch;e.defaultWidth=h;e.widths=f;e.defaultVMetrics=r;e.vmetrics=k};c.isSerifFont=function(b){b=b.split("-",1)[0];return b in Rh()||/serif/gi.test(b)};c.getBaseFontMetrics=function(b){var d=0,e=Object.create(null),g=!1,f=jg()[b]||b,h=ks();f in h||(f=this.isSerifFont(b)?"Times-Roman":\n"Helvetica");b=h[f];"number"===typeof b?(d=b,g=!0):e=b();return{defaultWidth:d,monospace:g,widths:e}};c.buildCharCodeToWidth=function(b,d){var e=Object.create(null),g=d.differences;d=d.defaultEncoding;for(var f=0;256>f;f++)f in g&&b[g[f]]?e[f]=b[g[f]]:f in d&&b[d[f]]&&(e[f]=b[d[f]]);return e};c.preEvaluateFont=function(b){var d=b,e=b.get("Subtype");if(!(e instanceof ka))throw new oa("invalid font Subtype");var g=!1;if("Type0"===e.name){b=b.get("DescendantFonts");if(!b)throw new oa("Descendant fonts are not specified");\nb=Array.isArray(b)?this.xref.fetchIfRef(b[0]):b;if(!(b instanceof ca))throw new oa("Descendant font is not a dictionary.");e=b.get("Subtype");if(!(e instanceof ka))throw new oa("invalid font Subtype");g=!0}var f=b.get("FirstChar");Number.isInteger(f)||(f=0);var h=b.get("LastChar");Number.isInteger(h)||(h=g?65535:255);var k=b.get("FontDescriptor"),l=b.get("ToUnicode")||d.get("ToUnicode");if(k){var m=new ut;var n=d.getRaw("Encoding");if(n instanceof ka)m.update(n.name);else if(n instanceof Ha)m.update(n.toString());\nelse if(n instanceof ca){n=u.makeIterator(n.getRawValues());for(var p=n.next();!p.done;p=n.next())if(p=p.value,p instanceof ka)m.update(p.name);else if(p instanceof Ha)m.update(p.toString());else if(Array.isArray(p)){for(var q=p.length,r=Array(q),t=0;t<q;t++){var v=p[t];if(v instanceof ka)r[t]=v.name;else if("number"===typeof v||v instanceof Ha)r[t]=v.toString()}m.update(r.join())}}m.update(f+"-"+h);l instanceof $a?(n=l.str||l,n=n.buffer?new Uint8Array(n.buffer.buffer,0,n.bufferLength):new Uint8Array(n.bytes.buffer,\nn.start,n.end-n.start),m.update(n)):l instanceof ka&&m.update(l.name);p=b.get("Widths")||d.get("Widths");if(Array.isArray(p)){n=[];p=u.makeIterator(p);for(q=p.next();!q.done;q=p.next())q=q.value,("number"===typeof q||q instanceof Ha)&&n.push(q.toString());m.update(n.join())}if(g){m.update("compositeFont");p=b.get("W")||d.get("W");if(Array.isArray(p)){n=[];p=u.makeIterator(p);for(q=p.next();!q.done;q=p.next())if(r=q.value,"number"===typeof r||r instanceof Ha)n.push(r.toString());else if(Array.isArray(r)){q=\n[];r=u.makeIterator(r);for(t=r.next();!t.done;t=r.next())t=t.value,("number"===typeof t||t instanceof Ha)&&q.push(t.toString());n.push("["+q.join()+"]")}m.update(n.join())}n=b.getRaw("CIDToGIDMap")||d.getRaw("CIDToGIDMap");n instanceof ka?m.update(n.name):n instanceof Ha?m.update(n.toString()):n instanceof $a&&m.update(n.peekBytes())}}return{descriptor:k,dict:b,baseDict:d,composite:g,type:e.name,firstChar:f,lastChar:h,toUnicode:l,hash:m?m.hexdigest():""}};c.translateFont=function(){var b=Fc(function g(e){var f,\nh,k,l,m,n,p,q,r,t,v,w,y,x,z,A=this,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R,Y,fa,H,U,N,ba,aa,X,ha,ma,V,ea,za,Ia,wa,Aa,Ja,Sa,Wa,La,vb,eb,Xa;return u.generator.createGenerator(g,function(Na){switch(Na.nextAddress){case 1:k=e;l=k.descriptor;m=k.dict;n=k.baseDict;p=k.composite;q=k.type;r=k.firstChar;t=k.lastChar;v=k.toUnicode;w=k.cssFontInfo;y="Type3"===q;if(l){Na.jumpTo(2);break}if(y){x=sd(m.getArray("FontBBox"),[0,0,0,0]);l=new ca(null);l.set("FontName",ka.get(q));l.set("FontBBox",x);Na.jumpTo(2);break}z=\nm.get("BaseFont");if(!(z instanceof ka))throw new oa("Base font is not specified");z=z.name.replaceAll(/[,_]/g,"-");B=A.getBaseFontMetrics(z);C=z.split("-",1)[0];D=(A.isSerifFont(C)?Zc.Serif:0)|(B.monospace?Zc.FixedPitch:0)|(Sh()[C]?Zc.Symbolic:Zc.Nonsymbolic);E={type:q,name:z,loadedName:n.loadedName,systemFontInfo:null,widths:B.widths,defaultWidth:B.defaultWidth,isSimulatedFlags:!0,flags:D,firstChar:r,lastChar:t,toUnicode:v,xHeight:0,capHeight:0,italicAngle:0,isType3Font:y};G=m.get("Widths");J=$k(z);\nF=null;if(!J){Na.jumpTo(4);break}return Na.yield(A.fetchStandardFontData(J),5);case 5:F=Na.yieldResult,E.isInternalFont=!!F;case 4:return!E.isInternalFont&&A.options.useSystemFonts&&(E.systemFontInfo=El(A.systemFontCache,A.idFactory,A.options.standardFontDataUrl,z,J,q)),Na.yield(A.extractDataStructures(m,E),6);case 6:L=Na.yieldResult;if(Array.isArray(G)){M=[];W=r;Q=u.makeIterator(G);for(la=Q.next();!la.done;la=Q.next())ta=la.value,qa=A.xref.fetchIfRef(ta),"number"===typeof qa&&(M[W]=qa),W++;L.widths=\nM}else L.widths=A.buildCharCodeToWidth(B.widths,L);return Na.return(new Xn(z,F,L));case 2:va=l.get("FontName");S=m.get("BaseFont");"string"===typeof va&&(va=ka.get(va));"string"===typeof S&&(S=ka.get(S));da=null==(f=va)?void 0:f.name;R=null==(h=S)?void 0:h.name;y||da===R||(Ya("The FontDescriptor\'s FontName is \\""+da+\'" but should be the same as the Font\\\'s BaseFont "\'+(R+\'".\')),da&&R&&(R.startsWith(da)||!al(da)&&al(R))&&(va=null));va||(va=S);if(!(va instanceof ka))throw new oa("invalid font name");\ntry{if(Y=l.get("FontFile","FontFile2","FontFile3")){if(!(Y instanceof $a))throw new oa("FontFile should be a stream");if(Y.isEmpty)throw new oa("FontFile is empty");}}catch(hb){if(!A.options.ignoreErrors)throw hb;T(\'translateFont - fetching "\'+va.name+\'" font file: "\'+hb+\'".\');Y=null}ba=!1;X=aa=null;if(Y){Y.dict&&(ha=Y.dict.get("Subtype"),ha instanceof ka&&(fa=ha.name),H=Y.dict.get("Length1"),U=Y.dict.get("Length2"),N=Y.dict.get("Length3"));Na.jumpTo(7);break}if(w){V=ei(va.name);if(!V){Na.jumpTo(7);\nbreak}w.fontFamily+="-PdfJS-XFA";w.metrics=V.metrics||null;aa=V.factors||null;return Na.yield(A.fetchStandardFontData(V.name),14)}if(y){Na.jumpTo(7);break}ma=$k(va.name);if(!ma){Na.jumpTo(11);break}return Na.yield(A.fetchStandardFontData(ma),12);case 12:Y=Na.yieldResult,ba=!!Y;case 11:!ba&&A.options.useSystemFonts&&(X=El(A.systemFontCache,A.idFactory,A.options.standardFontDataUrl,va.name,ma,q));Na.jumpTo(7);break;case 14:Y=Na.yieldResult,ba=!!Y,n=m=xl(va.name),p=!0;case 7:ea=Md(m.getArray("FontMatrix"),\nie);za=sd(l.getArray("FontBBox")||m.getArray("FontBBox"),void 0);Ia=l.get("Ascent");"number"!==typeof Ia&&(Ia=void 0);wa=l.get("Descent");"number"!==typeof wa&&(wa=void 0);Aa=l.get("XHeight");"number"!==typeof Aa&&(Aa=0);Ja=l.get("CapHeight");"number"!==typeof Ja&&(Ja=0);Sa=l.get("Flags");Number.isInteger(Sa)||(Sa=0);Wa=l.get("ItalicAngle");"number"!==typeof Wa&&(Wa=0);La={type:q,name:va.name,subtype:fa,file:Y,length1:H,length2:U,length3:N,isInternalFont:ba,loadedName:n.loadedName,composite:p,fixedPitch:!1,\nfontMatrix:ea,firstChar:r,lastChar:t,toUnicode:v,bbox:za,ascent:Ia,descent:wa,xHeight:Aa,capHeight:Ja,flags:Sa,italicAngle:Wa,isType3Font:y,cssFontInfo:w,scaleFactors:aa,systemFontInfo:X};if(!p){Na.jumpTo(15);break}vb=n.get("Encoding");vb instanceof ka&&(La.cidEncoding=vb.name);return Na.yield(Lg.create({encoding:vb,fetchBuiltInCMap:A._fetchBuiltInCMapBound,useCMap:null}),16);case 16:eb=Na.yieldResult,La.cMap=eb,La.vertical=La.cMap.vertical;case 15:return Na.yield(A.extractDataStructures(m,La),17);\ncase 17:return Xa=Na.yieldResult,A.extractWidths(m,l,Xa),Na.return(new Xn(va.name,Y,Xa))}})});return function(e){return b.apply(this,arguments)}}();a.buildFontPaths=function(b,d,e,g){function f(k){var l=b.loadedName+"_path_"+k;try{b.renderer.hasBuiltPath(k)||e.send("commonobj",[l,"FontPath",b.renderer.getPathJs(k)])}catch(m){if(g.ignoreErrors)T("buildFontPaths - ignoring "+l+\' glyph: "\'+m+\'".\');else throw m;}}d=u.makeIterator(d);for(var h=d.next();!h.done;h=d.next())h=h.value,f(h.fontChar),h=h.accent,\nnull!=h&&h.fontChar&&f(h.fontChar)};return mi(a,[{key:"_pdfFunctionFactory",get:function(){var b=new bo({xref:this.xref,isEvalSupported:this.options.isEvalSupported});return Fa(this,"_pdfFunctionFactory",b)}},{key:"parsingType3Font",get:function(){return!!this.type3FontRefs}}],[{key:"fallbackFontDict",get:function(){var b=new ca;b.set("BaseFont",ka.get("Helvetica"));b.set("Type",ka.get("FallbackType"));b.set("Subtype",ka.get("FallbackType"));b.set("Encoding",ka.get("WinAnsiEncoding"));return Fa(this,\n"fallbackFontDict",b)}}])}(),Rg=function(){function a(b){var d=b.font,e=b.dict,g=b.evaluatorOptions;this.loadedName=b.loadedName;this.font=d;this.dict=e;this._evaluatorOptions=g||io;this.type3Loaded=null;this.type3Dependencies=d.isType3Font?new Set:null;this.sent=!1}var c=a.prototype;c.send=function(b){this.sent||(this.sent=!0,b.send("commonobj",[this.loadedName,"Font",this.font.exportData(this._evaluatorOptions.fontExtraProperties)]))};c.fallback=function(b){this.font.data&&(this.font.disableFontFace=\n!0,ue.buildFontPaths(this.font,this.font.glyphCacheValues,b,this._evaluatorOptions))};c.loadType3Data=function(b,d,e){var g=this;if(this.type3Loaded)return this.type3Loaded;if(!this.font.isType3Font)throw Error("Must be a Type3 font.");var f=b.clone({ignoreErrors:!1});b=new Zb(b.type3FontRefs);this.dict.objId&&!b.has(this.dict.objId)&&b.put(this.dict.objId);f.type3FontRefs=b;var h=this.font,k=this.type3Dependencies;b=Promise.resolve();var l=this.dict.get("CharProcs"),m=this.dict.get("Resources")||\nd,n=Object.create(null);d=Rb.normalizeRect(h.bbox||[0,0,0,0]);var p=Math.hypot(d[2]-d[0],d[3]-d[1]);d=u.makeIterator(l.getKeys());for(var q=d.next(),r={};!q.done;r={key$jscomp$125:void 0},q=d.next())r.key$jscomp$125=q.value,b=b.then(function(t){return function(){var v=l.get(t.key$jscomp$125),w=new Dc;return f.getOperatorList({stream:v,task:e,resources:m,operatorList:w}).then(function(){w.fnArray[0]===O.setCharWidthAndBounds&&g._removeType3ColorOperators(w,p);n[t.key$jscomp$125]=w.getIR();for(var y=\nu.makeIterator(w.dependencies),x=y.next();!x.done;x=y.next())k.add(x.value)}).catch(function(){T(\'Type3 font resource "\'+t.key$jscomp$125+\'" is not available.\');var y=new Dc;n[t.key$jscomp$125]=y.getIR()})}}(r));return this.type3Loaded=b.then(function(){h.charProcOperatorList=n;g._bbox&&(h.isCharBBox=!0,h.bbox=g._bbox)})};c._removeType3ColorOperators=function(b,d){void 0===d&&(d=NaN);var e=Rb.normalizeRect(b.argsArray[0].slice(2)),g=e[2]-e[0],f=e[3]-e[1],h=Math.hypot(g,f);if(0===g||0===f)b.fnArray.splice(0,\n1),b.argsArray.splice(0,1);else if(0===d||10<=Math.round(h/d))this._bbox||(this._bbox=[Infinity,Infinity,-Infinity,-Infinity]),this._bbox[0]=Math.min(this._bbox[0],e[0]),this._bbox[1]=Math.min(this._bbox[1],e[1]),this._bbox[2]=Math.max(this._bbox[2],e[2]),this._bbox[3]=Math.max(this._bbox[3],e[3]);d=0;for(e=b.length;d<e;){switch(b.fnArray[d]){case O.setStrokeColorSpace:case O.setFillColorSpace:case O.setStrokeColor:case O.setStrokeColorN:case O.setFillColor:case O.setFillColorN:case O.setStrokeGray:case O.setFillGray:case O.setStrokeRGBColor:case O.setFillRGBColor:case O.setStrokeCMYKColor:case O.setFillCMYKColor:case O.shadingFill:case O.setRenderingIntent:b.fnArray.splice(d,\n1);b.argsArray.splice(d,1);e--;continue;case O.setGState:for(g=u.makeIterator(b.argsArray[d]).next().value,f=0,h=g.length;f<h;){switch(u.makeIterator(g[f]).next().value){case "TR":case "TR2":case "HT":case "BG":case "BG2":case "UCR":case "UCR2":g.splice(f,1);h--;continue}f++}}d++}};return a}(),Sg=function(){function a(b){void 0===b&&(b=new ko);this.state=b;this.stateStack=[]}var c=a.prototype;c.save=function(){var b=this.state;this.stateStack.push(this.state);this.state=b.clone()};c.restore=function(){var b=\nthis.stateStack.pop();b&&(this.state=b)};c.transform=function(b){this.state.ctm=Rb.transform(this.state.ctm,b)};return a}(),wt=function(){function a(){this.ctm=new Float32Array(ld);this.fontName=null;this.fontSize=0;this.font=this.loadedName=null;this.fontMatrix=ie;this.textMatrix=ld.slice();this.textLineMatrix=ld.slice();this.leading=this.wordSpacing=this.charSpacing=0;this.textHScale=1;this.textRise=0}var c=a.prototype;c.setTextMatrix=function(b,d,e,g,f,h){var k=this.textMatrix;k[0]=b;k[1]=d;k[2]=\ne;k[3]=g;k[4]=f;k[5]=h};c.setTextLineMatrix=function(b,d,e,g,f,h){var k=this.textLineMatrix;k[0]=b;k[1]=d;k[2]=e;k[3]=g;k[4]=f;k[5]=h};c.translateTextMatrix=function(b,d){var e=this.textMatrix;e[4]=e[0]*b+e[2]*d+e[4];e[5]=e[1]*b+e[3]*d+e[5]};c.translateTextLineMatrix=function(b,d){var e=this.textLineMatrix;e[4]=e[0]*b+e[2]*d+e[4];e[5]=e[1]*b+e[3]*d+e[5]};c.carriageReturn=function(){this.translateTextLineMatrix(0,-this.leading);this.textMatrix=this.textLineMatrix.slice()};c.clone=function(){var b=\nObject.create(this);b.textMatrix=this.textMatrix.slice();b.textLineMatrix=this.textLineMatrix.slice();b.fontMatrix=this.fontMatrix.slice();return b};return a}(),ko=function(){function a(){this.ctm=new Float32Array(ld);this.font=null;this.textRenderingMode=0;this._strokeColorSpace=this._fillColorSpace=ab.singletons.gray;this.patternStrokeColorSpace=this.patternFillColorSpace=null}a.prototype.clone=function(){return Object.create(this)};return mi(a,[{key:"fillColorSpace",get:function(){return this._fillColorSpace},\nset:function(c){this._fillColorSpace=this.patternFillColorSpace=c}},{key:"strokeColorSpace",get:function(){return this._strokeColorSpace},set:function(c){this._strokeColorSpace=this.patternStrokeColorSpace=c}}])}(),Gf=function(){function a(b,d,e){void 0===e&&(e=new Sg);this.parser=new Vd({lexer:new kd(b,a.opMap),xref:d});this.stateManager=e;this.nonProcessedArgs=[];this._isPathOp=!1;this._numInvalidPathOPS=0}var c=a.prototype;c.read=function(b){for(var d=b.args;;){var e=this.parser.getObj();if(e instanceof\nVb){e=e.cmd;var g=a.opMap[e];if(!g){T(\'Unknown command "\'+e+\'".\');continue}var f=g.id,h=g.numArgs,k=null!==d?d.length:0;this._isPathOp||(this._numInvalidPathOPS=0);this._isPathOp=f>=O.moveTo&&f<=O.endPath;if(g.variableArgs)k>h&&Ya("Command "+e+": expected [0, "+h+"] args, but received "+(k+" args."));else{if(k!==h){for(g=this.nonProcessedArgs;k>h;)g.push(d.shift()),k--;for(;k<h&&0!==g.length;)null===d&&(d=[]),d.unshift(g.pop()),k++}if(k<h){e="command "+e+": expected "+h+" args, but received "+(k+\n" args.");if(this._isPathOp&&++this._numInvalidPathOPS>a.MAX_INVALID_PATH_OPS)throw new oa("Invalid "+e);T("Skipping "+e);null!==d&&(d.length=0);continue}}this.preprocessCommand(f,d);b.fn=f;b.args=d;return!0}if(e===$b)return!1;if(null!==e&&(null===d&&(d=[]),d.push(e),33<d.length))throw new oa("Too many arguments");}};c.preprocessCommand=function(b,d){switch(b|0){case O.save:this.stateManager.save();break;case O.restore:this.stateManager.restore();break;case O.transform:this.stateManager.transform(d)}};\nreturn mi(a,[{key:"savedStatesDepth",get:function(){return this.stateManager.stateStack.length}}],[{key:"opMap",get:function(){return Fa(this,"opMap",Object.assign(Object.create(null),{w:{id:O.setLineWidth,numArgs:1,variableArgs:!1},J:{id:O.setLineCap,numArgs:1,variableArgs:!1},j:{id:O.setLineJoin,numArgs:1,variableArgs:!1},M:{id:O.setMiterLimit,numArgs:1,variableArgs:!1},d:{id:O.setDash,numArgs:2,variableArgs:!1},ri:{id:O.setRenderingIntent,numArgs:1,variableArgs:!1},i:{id:O.setFlatness,numArgs:1,\nvariableArgs:!1},gs:{id:O.setGState,numArgs:1,variableArgs:!1},q:{id:O.save,numArgs:0,variableArgs:!1},Q:{id:O.restore,numArgs:0,variableArgs:!1},cm:{id:O.transform,numArgs:6,variableArgs:!1},m:{id:O.moveTo,numArgs:2,variableArgs:!1},l:{id:O.lineTo,numArgs:2,variableArgs:!1},c:{id:O.curveTo,numArgs:6,variableArgs:!1},v:{id:O.curveTo2,numArgs:4,variableArgs:!1},y:{id:O.curveTo3,numArgs:4,variableArgs:!1},h:{id:O.closePath,numArgs:0,variableArgs:!1},re:{id:O.rectangle,numArgs:4,variableArgs:!1},S:{id:O.stroke,\nnumArgs:0,variableArgs:!1},s:{id:O.closeStroke,numArgs:0,variableArgs:!1},f:{id:O.fill,numArgs:0,variableArgs:!1},F:{id:O.fill,numArgs:0,variableArgs:!1},"f*":{id:O.eoFill,numArgs:0,variableArgs:!1},B:{id:O.fillStroke,numArgs:0,variableArgs:!1},"B*":{id:O.eoFillStroke,numArgs:0,variableArgs:!1},b:{id:O.closeFillStroke,numArgs:0,variableArgs:!1},"b*":{id:O.closeEOFillStroke,numArgs:0,variableArgs:!1},n:{id:O.endPath,numArgs:0,variableArgs:!1},W:{id:O.clip,numArgs:0,variableArgs:!1},"W*":{id:O.eoClip,\nnumArgs:0,variableArgs:!1},BT:{id:O.beginText,numArgs:0,variableArgs:!1},ET:{id:O.endText,numArgs:0,variableArgs:!1},Tc:{id:O.setCharSpacing,numArgs:1,variableArgs:!1},Tw:{id:O.setWordSpacing,numArgs:1,variableArgs:!1},Tz:{id:O.setHScale,numArgs:1,variableArgs:!1},TL:{id:O.setLeading,numArgs:1,variableArgs:!1},Tf:{id:O.setFont,numArgs:2,variableArgs:!1},Tr:{id:O.setTextRenderingMode,numArgs:1,variableArgs:!1},Ts:{id:O.setTextRise,numArgs:1,variableArgs:!1},Td:{id:O.moveText,numArgs:2,variableArgs:!1},\nTD:{id:O.setLeadingMoveText,numArgs:2,variableArgs:!1},Tm:{id:O.setTextMatrix,numArgs:6,variableArgs:!1},"T*":{id:O.nextLine,numArgs:0,variableArgs:!1},Tj:{id:O.showText,numArgs:1,variableArgs:!1},TJ:{id:O.showSpacedText,numArgs:1,variableArgs:!1},"\'":{id:O.nextLineShowText,numArgs:1,variableArgs:!1},\'"\':{id:O.nextLineSetSpacingShowText,numArgs:3,variableArgs:!1},d0:{id:O.setCharWidth,numArgs:2,variableArgs:!1},d1:{id:O.setCharWidthAndBounds,numArgs:6,variableArgs:!1},CS:{id:O.setStrokeColorSpace,\nnumArgs:1,variableArgs:!1},cs:{id:O.setFillColorSpace,numArgs:1,variableArgs:!1},SC:{id:O.setStrokeColor,numArgs:4,variableArgs:!0},SCN:{id:O.setStrokeColorN,numArgs:33,variableArgs:!0},sc:{id:O.setFillColor,numArgs:4,variableArgs:!0},scn:{id:O.setFillColorN,numArgs:33,variableArgs:!0},G:{id:O.setStrokeGray,numArgs:1,variableArgs:!1},g:{id:O.setFillGray,numArgs:1,variableArgs:!1},RG:{id:O.setStrokeRGBColor,numArgs:3,variableArgs:!1},rg:{id:O.setFillRGBColor,numArgs:3,variableArgs:!1},K:{id:O.setStrokeCMYKColor,\nnumArgs:4,variableArgs:!1},k:{id:O.setFillCMYKColor,numArgs:4,variableArgs:!1},sh:{id:O.shadingFill,numArgs:1,variableArgs:!1},BI:{id:O.beginInlineImage,numArgs:0,variableArgs:!1},ID:{id:O.beginImageData,numArgs:0,variableArgs:!1},EI:{id:O.endInlineImage,numArgs:1,variableArgs:!1},Do:{id:O.paintXObject,numArgs:1,variableArgs:!1},MP:{id:O.markPoint,numArgs:1,variableArgs:!1},DP:{id:O.markPointProps,numArgs:2,variableArgs:!1},BMC:{id:O.beginMarkedContent,numArgs:1,variableArgs:!1},BDC:{id:O.beginMarkedContentProps,\nnumArgs:2,variableArgs:!1},EMC:{id:O.endMarkedContent,numArgs:0,variableArgs:!1},BX:{id:O.beginCompat,numArgs:0,variableArgs:!1},EX:{id:O.endCompat,numArgs:0,variableArgs:!1},BM:null,BD:null,true:null,fa:null,fal:null,fals:null,false:null,nu:null,nul:null,null:null}))}}])}();Gf.MAX_INVALID_PATH_OPS=10;var xj=function(a){function c(b){return a.call(this,new Qc(b))||this}Sl(c,a);c.prototype.parse=function(){var b={fn:0,args:[]},d={fontSize:0,fontName:"",fontColor:new Uint8ClampedArray(3)};try{for(;;){b.args.length=\n0;if(!this.read(b))break;if(0===this.savedStatesDepth){var e=b,g=e.args;switch(e.fn|0){case O.setFont:var f=u.makeIterator(g),h=f.next().value,k=f.next().value;h instanceof ka&&(d.fontName=h.name);"number"===typeof k&&0<k&&(d.fontSize=k);break;case O.setFillRGBColor:ab.singletons.rgb.getRgbItem(g,0,d.fontColor,0);break;case O.setFillGray:ab.singletons.gray.getRgbItem(g,0,d.fontColor,0);break;case O.setFillCMYKColor:ab.singletons.cmyk.getRgbItem(g,0,d.fontColor,0)}}}}catch(l){T(\'parseDefaultAppearance - ignoring errors: "\'+\nl+\'".\')}return d};return c}(Gf),xt=function(a){function c(b,d,e){var g;var f=a.call(this,b)||this;f.stream=b;f.evaluatorOptions=d;f.xref=e;f.resources=null==(g=b.dict)?void 0:g.get("Resources");return f}Sl(c,a);c.prototype.parse=function(){var b={fn:0,args:[]},d={scaleFactor:1,fontSize:0,fontName:"",fontColor:new Uint8ClampedArray(3),fillColorSpace:ab.singletons.gray},e=!1,g=[];try{for(;;){b.args.length=0;if(e||!this.read(b))break;var f=b,h=f.args;switch(f.fn|0){case O.save:g.push({scaleFactor:d.scaleFactor,\nfontSize:d.fontSize,fontName:d.fontName,fontColor:d.fontColor.slice(),fillColorSpace:d.fillColorSpace});break;case O.restore:d=g.pop()||d;break;case O.setTextMatrix:d.scaleFactor*=Math.hypot(h[0],h[1]);break;case O.setFont:var k=u.makeIterator(h),l=k.next().value,m=k.next().value;l instanceof ka&&(d.fontName=l.name);"number"===typeof m&&0<m&&(d.fontSize=m*d.scaleFactor);break;case O.setFillColorSpace:d.fillColorSpace=ab.parse({cs:h[0],xref:this.xref,resources:this.resources,pdfFunctionFactory:this._pdfFunctionFactory,\nlocalColorSpaceCache:this._localColorSpaceCache});break;case O.setFillColor:d.fillColorSpace.getRgbItem(h,0,d.fontColor,0);break;case O.setFillRGBColor:ab.singletons.rgb.getRgbItem(h,0,d.fontColor,0);break;case O.setFillGray:ab.singletons.gray.getRgbItem(h,0,d.fontColor,0);break;case O.setFillCMYKColor:ab.singletons.cmyk.getRgbItem(h,0,d.fontColor,0);break;case O.showText:case O.showSpacedText:case O.nextLineShowText:case O.nextLineSetSpacingShowText:e=!0}}}catch(n){T(\'parseAppearanceStream - ignoring errors: "\'+\nn+\'".\')}this.stream.reset();delete d.scaleFactor;delete d.fillColorSpace;return d};return Rl(c,[{key:"_localColorSpaceCache",get:function(){return Fa(this,"_localColorSpaceCache",new Zn)}},{key:"_pdfFunctionFactory",get:function(){var b=new bo({xref:this.xref,isEvalSupported:this.evaluatorOptions.isEvalSupported});return Fa(this,"_pdfFunctionFactory",b)}}])}(Gf),yj=function(){function a(b,d){this.xref=b;this.widths=null;this.firstChar=Infinity;this.lastChar=-Infinity;this.fontFamily=d;this.ctxMeasure=\n(new OffscreenCanvas(1,1)).getContext("2d",{willReadFrequently:!0});a._fontNameId||(a._fontNameId=1);this.fontName=ka.get("InvalidPDFjsFont_"+d+"_"+a._fontNameId++)}var c=a.prototype;c._createContext=function(){this.widths=new Map;this.ctxMeasure.font="1000px "+this.fontFamily;return this.ctxMeasure};c.createFontResources=function(b){var d=this._createContext();b=u.makeIterator(b.split(/\\r\\n?|\\n/));for(var e=b.next();!e.done;e=b.next()){e=u.makeIterator(e.value.split(""));for(var g=e.next();!g.done;g=\ne.next()){var f=g.value;g=f.charCodeAt(0);this.widths.has(g)||(f=d.measureText(f),this.widths.set(g,Math.ceil(f.width)),this.firstChar=Math.min(g,this.firstChar),this.lastChar=Math.max(g,this.lastChar))}}return this.resources};a.getFirstPositionInfo=function(b,d,e){var g=u.makeIterator(b),f=g.next().value;b=g.next().value;var h=g.next().value;g=g.next().value;f=h-f;b=g-b;0!==d%180&&(b=u.makeIterator([b,f]),f=b.next().value,b=b.next().value);h=1.35*e;return{coords:[0,b+.35*e-h],bbox:[0,0,f,b],matrix:0!==\nd?bg(d,b,h):void 0}};c.createAppearance=function(b,d,e,g,f,h){var k=this._createContext(),l=[],m=-Infinity;b=u.makeIterator(b.split(/\\r\\n?|\\n/));for(var n=b.next();!n.done;n=b.next()){n=n.value;l.push(n);var p=k.measureText(n).width;m=Math.max(m,p);n=u.makeIterator(nk(n));for(p=n.next();!p.done;p=n.next()){p=p.value;var q=String.fromCodePoint(p),r=this.widths.get(p);void 0===r&&(q=k.measureText(q),r=Math.ceil(q.width),this.widths.set(p,r),this.firstChar=Math.min(p,this.firstChar),this.lastChar=Math.max(p,\nthis.lastChar))}}m*=g/1E3;n=u.makeIterator(d);d=n.next().value;k=n.next().value;b=n.next().value;n=n.next().value;d=b-d;k=n-k;0!==e%180&&(k=u.makeIterator([k,d]),d=k.next().value,k=k.next().value);b=1;m>d&&(b=d/m);p=1;m=1.35*g;n=.35*g;q=m*l.length;q>k&&(p=k/q);g*=Math.min(b,p);g=["q","0 0 "+ob(d)+" "+ob(k)+" re W n","BT","1 0 0 1 0 "+ob(k+n)+" Tm 0 Tc "+Ed(f,!0),"/"+this.fontName.name+" "+ob(g)+" Tf"];f=this.resources;h="number"===typeof h&&0<=h&&1>=h?h:1;1!==h&&(g.push("/R0 gs"),b=new ca(this.xref),\nn=new ca(this.xref),n.set("ca",h),n.set("CA",h),n.set("Type",ka.get("ExtGState")),b.set("R0",n),f.set("ExtGState",b));h=ob(m);l=u.makeIterator(l);for(m=l.next();!m.done;m=l.next()){n=m.value;m=g;b=m.push;p=[];q=0;for(r=n.length;q<r;q++){var t=n.charCodeAt(q);p.push(Be[t>>8&255],Be[t&255])}n=p.join("");b.call(m,"0 -"+h+" Td <"+n+"> Tj")}g.push("ET","Q");h=g.join("\\n");l=new ca(this.xref);l.set("Subtype",ka.get("Form"));l.set("Type",ka.get("XObject"));l.set("BBox",[0,0,d,k]);l.set("Length",h.length);\nl.set("Resources",f);e&&(e=bg(e,d,k),l.set("Matrix",e));e=new Qc(h);e.dict=l;return e};return Rl(a,[{key:"fontDescriptorRef",get:function(){if(!a._fontDescriptorRef){var b=new ca(this.xref);b.set("Type",ka.get("FontDescriptor"));b.set("FontName",this.fontName);b.set("FontFamily","MyriadPro Regular");b.set("FontBBox",[0,0,0,0]);b.set("FontStretch",ka.get("Normal"));b.set("FontWeight",400);b.set("ItalicAngle",0);a._fontDescriptorRef=this.xref.getNewPersistentRef(b)}return a._fontDescriptorRef}},{key:"descendantFontRef",\nget:function(){var b=new ca(this.xref);b.set("BaseFont",this.fontName);b.set("Type",ka.get("Font"));b.set("Subtype",ka.get("CIDFontType0"));b.set("CIDToGIDMap",ka.get("Identity"));b.set("FirstChar",this.firstChar);b.set("LastChar",this.lastChar);b.set("FontDescriptor",this.fontDescriptorRef);b.set("DW",1E3);var d=[],e=[].concat(u.arrayFromIterable(this.widths.entries())).sort(),g=null,f=null;e=u.makeIterator(e);for(var h=e.next();!h.done;h=e.next()){var k=u.makeIterator(h.value);h=k.next().value;\nk=k.next().value;g?h===g+f.length?f.push(k):(d.push(g,f),g=h,f=[k]):(g=h,f=[k])}g&&d.push(g,f);b.set("W",d);d=new ca(this.xref);d.set("Ordering","Identity");d.set("Registry","Adobe");d.set("Supplement",0);b.set("CIDSystemInfo",d);return this.xref.getNewPersistentRef(b)}},{key:"baseFontRef",get:function(){var b=new ca(this.xref);b.set("BaseFont",this.fontName);b.set("Type",ka.get("Font"));b.set("Subtype",ka.get("Type0"));b.set("Encoding",ka.get("Identity-H"));b.set("DescendantFonts",[this.descendantFontRef]);\nb.set("ToUnicode",ka.get("Identity-H"));return this.xref.getNewPersistentRef(b)}},{key:"resources",get:function(){var b=new ca(this.xref),d=new ca(this.xref);d.set(this.fontName.name,this.baseFontRef);b.set("Font",d);return b}}])}();pa(3110);var lo=function(){function a(b,d,e){this.root=b;this.xref=d;this._type=e}var c=a.prototype;c.getAll=function(){var b=new Map;if(!this.root)return b;var d=this.xref,e=new Zb;e.put(this.root);for(var g=[this.root];0<g.length;){var f=d.fetchIfRef(g.shift());if(f instanceof\nca)if(f.has("Kids")){if(f=f.get("Kids"),Array.isArray(f)){f=u.makeIterator(f);for(var h=f.next();!h.done;h=f.next()){h=h.value;if(e.has(h))throw new oa(\'Duplicate entry in "\'+this._type+\'" tree.\');g.push(h);e.put(h)}}}else if(f=f.get(this._type),Array.isArray(f)){h=0;for(var k=f.length;h<k;h+=2)b.set(d.fetchIfRef(f[h]),d.fetchIfRef(f[h+1]))}}return b};c.getRaw=function(b){if(!this.root)return null;for(var d=this.xref,e=d.fetchIfRef(this.root),g=0;e.has("Kids");){if(10<++g)return T(\'Search depth limit reached for "\'+\nthis._type+\'" tree.\'),null;var f=e.get("Kids");if(!Array.isArray(f))return null;for(var h=0,k=f.length-1;h<=k;){var l=h+k>>1,m=d.fetchIfRef(f[l]),n=m.get("Limits");if(b<d.fetchIfRef(n[0]))k=l-1;else if(b>d.fetchIfRef(n[1]))h=l+1;else{e=m;break}}if(h>k)return null}e=e.get(this._type);if(Array.isArray(e))for(g=0,f=e.length-2;g<=f;)if(h=g+f>>1,h+=h&1,k=d.fetchIfRef(e[h]),b<k)f=h-2;else if(b>k)g=h+2;else return e[h+1];return null};c.get=function(b){return this.xref.fetchIfRef(this.getRaw(b))};return a}(),\nXe=function(a){function c(b,d){return a.call(this,b,d,"Names")||this}Tl(c,a);return c}(lo),Tg=function(a){function c(b,d){return a.call(this,b,d,"Nums")||this}Tl(c,a);return c}(lo),zj=function(){return uq(function(a,c,b){void 0===b&&(b=!1);this.__contentAvailable=!1;a instanceof ca&&(this.xref=c,this.root=a,a.has("FS")&&(this.fs=a.get("FS")),a.has("RF")&&T("Related file specifications are not supported"),b||(a.has("EF")?this.__contentAvailable=!0:T("Non-embedded file specifications are not supported")))},\n[{key:"filename",get:function(){var a="",c=Xl(this.root);c&&"string"===typeof c&&(a=ib(c).replaceAll("\\\\\\\\","\\\\").replaceAll("\\\\/","/").replaceAll("\\\\","/"));return Fa(this,"filename",a||"unnamed")}},{key:"content",get:function(){var a;if(!this.__contentAvailable)return null;this._contentRef||(this._contentRef=Xl(null==(a=this.root)?void 0:a.get("EF")));a=null;if(this._contentRef){var c=this.xref.fetchIfRef(this._contentRef);c instanceof $a?a=c.getBytes():T("Embedded file specification points to non-existing/invalid content")}else T("Embedded file specification does not have any content");\nreturn a}},{key:"description",get:function(){var a,c="",b=null==(a=this.root)?void 0:a.get("Desc");b&&"string"===typeof b&&(c=ib(b));return Fa(this,"description",c)}},{key:"serializable",get:function(){var a=this.filename;var c=this.filename;c=c.substring(c.lastIndexOf("/")+1);return{rawFilename:a,filename:c,content:this.content,description:this.description}}}])}();pa(2762);var mo=function(){function a(){}var c=a.prototype;c._resolveEntities=function(b){var d=this;return b.replaceAll(/&([^;]+);/g,\nfunction(e,g){if("#x"===g.substring(0,2))return String.fromCodePoint(parseInt(g.substring(2),16));if("#"===g.substring(0,1))return String.fromCodePoint(parseInt(g.substring(1),10));switch(g){case "lt":return"<";case "gt":return">";case "amp":return"&";case "quot":return\'"\';case "apos":return"\'"}return d.onResolveEntity(g)})};c._parseContent=function(b,d){function e(){for(;f<b.length&&Ie(b,f);)++f}for(var g=[],f=d;f<b.length&&!Ie(b,f)&&">"!==b[f]&&"/"!==b[f];)++f;var h=b.substring(d,f);for(e();f<b.length&&\n">"!==b[f]&&"/"!==b[f]&&"?"!==b[f];){e();for(var k="",l="";f<b.length&&!Ie(b,f)&&"="!==b[f];)k+=b[f],++f;e();if("="!==b[f])return null;++f;e();l=b[f];if(\'"\'!==l&&"\'"!==l)return null;var m=b.indexOf(l,++f);if(0>m)return null;l=b.substring(f,m);g.push({name:k,value:this._resolveEntities(l)});f=m+1;e()}return{name:h,attributes:g,parsed:f-d}};c._parseProcessingInstruction=function(b,d){for(var e=d;e<b.length&&!Ie(b,e)&&">"!==b[e]&&"?"!==b[e]&&"/"!==b[e];)++e;for(var g=b.substring(d,e);e<b.length&&Ie(b,\ne);)++e;for(var f=e;e<b.length&&("?"!==b[e]||">"!==b[e+1]);)++e;b=b.substring(f,e);return{name:g,value:b,parsed:e-d}};c.parseXml=function(b){for(var d=0;d<b.length;){var e=d;if("<"===b[d])switch(++e,b[e]){case "/":++e;d=b.indexOf(">",e);if(0>d){this.onError(-9);return}this.onEndElement(b.substring(e,d));e=d+1;break;case "?":++e;d=this._parseProcessingInstruction(b,e);if("?>"!==b.substring(e+d.parsed,e+d.parsed+2)){this.onError(-3);return}this.onPi(d.name,d.value);e+=d.parsed+2;break;case "!":if("--"===\nb.substring(e+1,e+3)){d=b.indexOf("--\\x3e",e+3);if(0>d){this.onError(-5);return}this.onComment(b.substring(e+3,d));e=d+3}else if("[CDATA["===b.substring(e+1,e+8)){d=b.indexOf("]]\\x3e",e+8);if(0>d){this.onError(-2);return}this.onCdata(b.substring(e+8,d));e=d+3}else if("DOCTYPE"===b.substring(e+1,e+8)){var g=b.indexOf("[",e+8),f=!1;d=b.indexOf(">",e+8);if(0>d){this.onError(-4);return}if(0<g&&d>g){d=b.indexOf("]>",e+8);if(0>d){this.onError(-4);return}f=!0}e=b.substring(e+8,d+(f?1:0));this.onDoctype(e);\ne=d+(f?2:1)}else{this.onError(-6);return}break;default:d=this._parseContent(b,e);if(null===d){this.onError(-6);return}f=!1;if("/>"===b.substring(e+d.parsed,e+d.parsed+2))f=!0;else if(">"!==b.substring(e+d.parsed,e+d.parsed+1)){this.onError(-9);return}this.onBeginElement(d.name,d.attributes,f);e+=d.parsed+(f?2:1)}else{for(;e<b.length&&"<"!==b[e];)e++;d=b.substring(d,e);this.onText(this._resolveEntities(d))}d=e}};c.onResolveEntity=function(b){return"&"+b+";"};c.onPi=function(){};c.onComment=function(){};\nc.onCdata=function(){};c.onDoctype=function(){};c.onText=function(){};c.onBeginElement=function(){};c.onEndElement=function(){};c.onError=function(){};return a}(),of=function(){function a(b,d){this.nodeName=b;this.nodeValue=d;Object.defineProperty(this,"parentNode",{value:null,writable:!0})}var c=a.prototype;c.hasChildNodes=function(){var b;return 0<(null==(b=this.childNodes)?void 0:b.length)};c.searchNode=function(b,d){if(d>=b.length)return this;var e=b[d];if(e.name.startsWith("#")&&d<b.length-1)return this.searchNode(b,\nd+1);for(var g=[],f=this;;){if(e.name===f.nodeName)if(0===e.pos){var h=f.searchNode(b,d+1);if(null!==h)return h}else{if(0===g.length)return null;var k=u.makeIterator(g.pop()).next().value;g=0;k=u.makeIterator(k.childNodes);for(h=k.next();!h.done;h=k.next())if(h=h.value,e.name===h.nodeName){if(g===e.pos)return h.searchNode(b,d+1);g++}return f.searchNode(b,d+1)}if(0<(null==(k=f.childNodes)?void 0:k.length))g.push([f,0]),f=f.childNodes[0];else{if(0===g.length)return null;for(;0!==g.length;){var l=u.makeIterator(g.pop());\nh=l.next().value;l=l.next().value+1;if(l<h.childNodes.length){g.push([h,l]);f=h.childNodes[l];break}}if(0===g.length)return null}}};c.dump=function(b){if("#text"===this.nodeName)b.push(De(this.nodeValue));else{b.push("<"+this.nodeName);if(this.attributes)for(var d=u.makeIterator(this.attributes),e=d.next();!e.done;e=d.next())e=e.value,b.push(" "+e.name+\'="\'+De(e.value)+\'"\');if(this.hasChildNodes()){b.push(">");d=u.makeIterator(this.childNodes);for(e=d.next();!e.done;e=d.next())e.value.dump(b);b.push("</"+\nthis.nodeName+">")}else this.nodeValue?b.push(">"+De(this.nodeValue)+"</"+this.nodeName+">"):b.push("/>")}};return wq(a,[{key:"firstChild",get:function(){var b;return null==(b=this.childNodes)?void 0:b[0]}},{key:"nextSibling",get:function(){var b=this.parentNode.childNodes;if(b){var d=b.indexOf(this);if(-1!==d)return b[d+1]}}},{key:"textContent",get:function(){return this.childNodes?this.childNodes.map(function(b){return b.textContent}).join(""):this.nodeValue||""}},{key:"children",get:function(){return this.childNodes||\n[]}}])}(),rg=function(a){function c(d){var e=void 0===d.hasAttributes?!1:d.hasAttributes,g=void 0===d.lowerCaseName?!1:d.lowerCaseName;d=a.call(this)||this;d._currentFragment=null;d._stack=null;d._errorCode=0;d._hasAttributes=e;d._lowerCaseName=g;return d}vq(c,a);var b=c.prototype;b.parseFromString=function(d){this._currentFragment=[];this._stack=[];this._errorCode=0;this.parseXml(d);if(0===this._errorCode&&(d=u.makeIterator(this._currentFragment).next().value))return{documentElement:d}};b.onText=\nfunction(d){a:{var e=0;for(var g=d.length;e<g;e++)if(!Ie(d,e)){e=!1;break a}e=!0}e||(d=new of("#text",d),this._currentFragment.push(d))};b.onCdata=function(d){d=new of("#text",d);this._currentFragment.push(d)};b.onBeginElement=function(d,e,g){this._lowerCaseName&&(d=d.toLowerCase());d=new of(d);d.childNodes=[];this._hasAttributes&&(d.attributes=e);this._currentFragment.push(d);g||(this._stack.push(this._currentFragment),this._currentFragment=d.childNodes)};b.onEndElement=function(){this._currentFragment=\nthis._stack.pop()||[];var d=this._currentFragment.at(-1);if(!d)return null;for(var e=u.makeIterator(d.childNodes),g=e.next();!g.done;g=e.next())g.value.parentNode=d;return d};b.onError=function(d){this._errorCode=d};return c}(mo),yt=function(){function a(b){b=this._repair(b);var d=(new rg({lowerCaseName:!0})).parseFromString(b);this._metadataMap=new Map;this._data=b;d&&this._parse(d)}var c=a.prototype;c._repair=function(b){return b.replace(/^[^<]+/,"").replaceAll(/>\\\\376\\\\377([^<]+)/g,function(d,\ne){d=e.replaceAll(/\\\\([0-3])([0-7])([0-7])/g,function(k,l,m,n){return String.fromCharCode(64*l+8*m+1*n)}).replaceAll(/&(amp|apos|gt|lt|quot);/g,function(k,l){switch(l){case "amp":return"&";case "apos":return"\'";case "gt":return">";case "lt":return"<";case "quot":return\'"\'}throw Error("_repair: "+l+" isn\'t defined.");});e=[">"];for(var g=0,f=d.length;g<f;g+=2){var h=256*d.charCodeAt(g)+d.charCodeAt(g+1);32<=h&&127>h&&60!==h&&62!==h&&38!==h?e.push(String.fromCharCode(h)):e.push("&#x"+(65536+h).toString(16).substring(1)+\n";")}return e.join("")})};c._getSequence=function(b){var d=b.nodeName;return"rdf:bag"!==d&&"rdf:seq"!==d&&"rdf:alt"!==d?null:b.childNodes.filter(function(e){return"rdf:li"===e.nodeName})};c._parseArray=function(b){if(b.hasChildNodes()){var d=u.makeIterator(b.childNodes).next().value;d=this._getSequence(d)||[];this._metadataMap.set(b.nodeName,d.map(function(e){return e.textContent.trim()}))}};c._parse=function(b){b=b.documentElement;if("rdf:rdf"!==b.nodeName)for(b=b.firstChild;b&&"rdf:rdf"!==b.nodeName;)b=\nb.nextSibling;if(b&&"rdf:rdf"===b.nodeName&&b.hasChildNodes()){b=u.makeIterator(b.childNodes);for(var d=b.next();!d.done;d=b.next())if(d=d.value,"rdf:description"===d.nodeName){d=u.makeIterator(d.childNodes);for(var e=d.next();!e.done;e=d.next()){e=e.value;var g=e.nodeName;switch(g){case "#text":continue;case "dc:creator":case "dc:subject":this._parseArray(e);continue}this._metadataMap.set(g,e.textContent.trim())}}}};return xq(a,[{key:"serializable",get:function(){return{parsedData:this._metadataMap,\nrawData:this._data}}}])}(),zt=function(a){function c(b,d,e){d=a.call(this,d)||this;d.str=b;d.dict=b.dict;d.decrypt=e;d.nextChunk=null;d.initialized=!1;return d}yq(c,a);c.prototype.readBlock=function(){var b;if(this.initialized)var d=this.nextChunk;else d=this.str.getBytes(512),this.initialized=!0;if(d&&0!==d.length){this.nextChunk=this.str.getBytes(512);var e=0<(null==(b=this.nextChunk)?void 0:b.length);b=this.decrypt;d=b(d,!e);e=this.bufferLength;b=e+d.length;this.ensureBuffer(b).set(d,e);this.bufferLength=\nb}else this.eof=!0};return c}(uc),ve=function(){function a(b){this.b=this.a=0;for(var d=new Uint8Array(256),e=b.length,g=0;256>g;++g)d[g]=g;for(var f=g=0;256>g;++g){var h=d[g];f=f+h+b[g%e]&255;d[g]=d[f];d[f]=h}this.s=d}var c=a.prototype;c.encryptBlock=function(b){for(var d=this.a,e=this.b,g=this.s,f=b.length,h=new Uint8Array(f),k=0;k<f;++k){d=d+1&255;var l=g[d];e=e+l&255;var m=g[e];g[d]=m;g[e]=l;h[k]=b[k]^g[l+m&255]}this.a=d;this.b=e;return h};c.decryptBlock=function(b){return this.encryptBlock(b)};\nc.encrypt=function(b){return this.encryptBlock(b)};return a}(),Qd=function(){var a=new Uint8Array([7,12,17,22,7,12,17,22,7,12,17,22,7,12,17,22,5,9,14,20,5,9,14,20,5,9,14,20,5,9,14,20,4,11,16,23,4,11,16,23,4,11,16,23,4,11,16,23,6,10,15,21,6,10,15,21,6,10,15,21,6,10,15,21]),c=new Int32Array([-680876936,-389564586,606105819,-1044525330,-176418897,1200080426,-1473231341,-45705983,1770035416,-1958414417,-42063,-1990404162,1804603682,-40341101,-1502002290,1236535329,-165796510,-1069501632,643717713,-373897302,\n-701558691,38016083,-660478335,-405537848,568446438,-1019803690,-187363961,1163531501,-1444681467,-51403784,1735328473,-1926607734,-378558,-2022574463,1839030562,-35309556,-1530992060,1272893353,-155497632,-1094730640,681279174,-358537222,-722521979,76029189,-640364487,-421815835,530742520,-995338651,-198630844,1126891415,-1416354905,-57434055,1700485571,-1894986606,-1051523,-2054922799,1873313359,-30611744,-1560198380,1309151649,-145523070,-1120210379,718787259,-343485551]);return function(b,d,e){var g=\n1732584193,f=-271733879,h=-1732584194,k=271733878,l=e+72&-64,m=new Uint8Array(l),n;for(n=0;n<e;++n)m[n]=b[d++];m[n++]=128;for(b=l-8;n<b;)m[n++]=0;m[n++]=e<<3&255;m[n++]=e>>5&255;m[n++]=e>>13&255;m[n++]=e>>21&255;m[n++]=e>>>29&255;m[n++]=0;m[n++]=0;m[n++]=0;b=new Int32Array(16);for(n=0;n<l;){for(e=0;16>e;++e,n+=4)b[e]=m[n]|m[n+1]<<8|m[n+2]<<16|m[n+3]<<24;var p=g;d=f;var q=h,r=k;for(e=0;64>e;++e){if(16>e){var t=d&q|~d&r;var v=e}else 32>e?(t=r&d|~r&q,v=5*e+1&15):48>e?(t=d^q^r,v=3*e+5&15):(t=q^(d|~r),\nv=7*e&15);var w=r;p=p+t+c[e]+b[v]|0;t=a[e];r=q;q=d;d=d+(p<<t|p>>>32-t)|0;p=w}g=g+p|0;f=f+d|0;h=h+q|0;k=k+r|0}return new Uint8Array([g&255,g>>8&255,g>>16&255,g>>>24&255,f&255,f>>8&255,f>>16&255,f>>>24&255,h&255,h>>8&255,h>>16&255,h>>>24&255,k&255,k>>8&255,k>>16&255,k>>>24&255])}}(),Ga=function(){function a(b,d){this.high=b|0;this.low=d|0}var c=a.prototype;c.and=function(b){this.high&=b.high;this.low&=b.low};c.xor=function(b){this.high^=b.high;this.low^=b.low};c.or=function(b){this.high|=b.high;this.low|=\nb.low};c.shiftRight=function(b){32<=b?(this.low=this.high>>>b-32|0,this.high=0):(this.low=this.low>>>b|this.high<<32-b,this.high=this.high>>>b|0)};c.shiftLeft=function(b){32<=b?(this.high=this.low<<b-32,this.low=0):(this.high=this.high<<b|this.low>>>32-b,this.low<<=b)};c.rotateRight=function(b){if(b&32){var d=this.low;var e=this.high}else e=this.low,d=this.high;b&=31;this.low=e>>>b|d<<32-b;this.high=d>>>b|e<<32-b};c.not=function(){this.high=~this.high;this.low=~this.low};c.add=function(b){var d=(this.low>>>\n0)+(b.low>>>0);b=(this.high>>>0)+(b.high>>>0);4294967295<d&&(b+=1);this.low=d|0;this.high=b|0};c.copyTo=function(b,d){b[d]=this.high>>>24&255;b[d+1]=this.high>>16&255;b[d+2]=this.high>>8&255;b[d+3]=this.high&255;b[d+4]=this.low>>>24&255;b[d+5]=this.low>>16&255;b[d+6]=this.low>>8&255;b[d+7]=this.low&255};c.assign=function(b){this.high=b.high;this.low=b.low};return a}(),Ye=function(){function a(b,d){return b>>>d|b<<32-d}var c=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,\n2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,\n1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];return function(b,d,e){var g=1779033703,f=3144134277,h=1013904242,k=2773480762,l=1359893119,m=2600822924,n=528734635,p=1541459225,q=64*Math.ceil((e+9)/64),r=new Uint8Array(q),t;for(t=0;t<e;++t)r[t]=b[d++];r[t++]=128;for(b=q-8;t<b;)r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=e>>>29&255;r[t++]=e>>21&255;r[t++]=e>>13&255;r[t++]=e>>5&255;r[t++]=e<<3&255;b=new Uint32Array(64);for(t=0;t<q;){for(e=\n0;16>e;++e)b[e]=r[t]<<24|r[t+1]<<16|r[t+2]<<8|r[t+3],t+=4;for(e=16;64>e;++e){d=e;var v=b[e-2];v=(a(v,17)^a(v,19)^v>>>10)+b[e-7];var w=b[e-15];w=a(w,7)^a(w,18)^w>>>3;b[d]=v+w+b[e-16]|0}d=g;v=f;w=h;var y=k,x=l,z=m,A=n,B=p;for(e=0;64>e;++e){var C=B;B=x;B=a(B,6)^a(B,11)^a(B,25);C=C+B+(x&z^~x&A)+c[e]+b[e];B=d;var D=(a(B,2)^a(B,13)^a(B,22))+(d&v^d&w^v&w);B=A;A=z;z=x;x=y+C|0;y=w;w=v;v=d;d=C+D|0}g=g+d|0;f=f+v|0;h=h+w|0;k=k+y|0;l=l+x|0;m=m+z|0;n=n+A|0;p=p+B|0}return new Uint8Array([g>>24&255,g>>16&255,g>>\n8&255,g&255,f>>24&255,f>>16&255,f>>8&255,f&255,h>>24&255,h>>16&255,h>>8&255,h&255,k>>24&255,k>>16&255,k>>8&255,k&255,l>>24&255,l>>16&255,l>>8&255,l&255,m>>24&255,m>>16&255,m>>8&255,m&255,n>>24&255,n>>16&255,n>>8&255,n&255,p>>24&255,p>>16&255,p>>8&255,p&255])}}(),no=function(){var a=[new Ga(1116352408,3609767458),new Ga(1899447441,602891725),new Ga(3049323471,3964484399),new Ga(3921009573,2173295548),new Ga(961987163,4081628472),new Ga(1508970993,3053834265),new Ga(2453635748,2937671579),new Ga(2870763221,\n3664609560),new Ga(3624381080,2734883394),new Ga(310598401,1164996542),new Ga(607225278,1323610764),new Ga(1426881987,3590304994),new Ga(1925078388,4068182383),new Ga(2162078206,991336113),new Ga(2614888103,633803317),new Ga(3248222580,3479774868),new Ga(3835390401,2666613458),new Ga(4022224774,944711139),new Ga(264347078,2341262773),new Ga(604807628,2007800933),new Ga(770255983,1495990901),new Ga(1249150122,1856431235),new Ga(1555081692,3175218132),new Ga(1996064986,2198950837),new Ga(2554220882,\n3999719339),new Ga(2821834349,766784016),new Ga(2952996808,2566594879),new Ga(3210313671,3203337956),new Ga(3336571891,1034457026),new Ga(3584528711,2466948901),new Ga(113926993,3758326383),new Ga(338241895,168717936),new Ga(666307205,1188179964),new Ga(773529912,1546045734),new Ga(1294757372,1522805485),new Ga(1396182291,2643833823),new Ga(1695183700,2343527390),new Ga(1986661051,1014477480),new Ga(2177026350,1206759142),new Ga(2456956037,344077627),new Ga(2730485921,1290863460),new Ga(2820302411,\n3158454273),new Ga(3259730800,3505952657),new Ga(3345764771,106217008),new Ga(3516065817,3606008344),new Ga(3600352804,1432725776),new Ga(4094571909,1467031594),new Ga(275423344,851169720),new Ga(430227734,3100823752),new Ga(506948616,1363258195),new Ga(659060556,3750685593),new Ga(883997877,3785050280),new Ga(958139571,3318307427),new Ga(1322822218,3812723403),new Ga(1537002063,2003034995),new Ga(1747873779,3602036899),new Ga(1955562222,1575990012),new Ga(2024104815,1125592928),new Ga(2227730452,\n2716904306),new Ga(2361852424,442776044),new Ga(2428436474,593698344),new Ga(2756734187,3733110249),new Ga(3204031479,2999351573),new Ga(3329325298,3815920427),new Ga(3391569614,3928383900),new Ga(3515267271,566280711),new Ga(3940187606,3454069534),new Ga(4118630271,4000239992),new Ga(116418474,1914138554),new Ga(174292421,2731055270),new Ga(289380356,3203993006),new Ga(460393269,320620315),new Ga(685471733,587496836),new Ga(852142971,1086792851),new Ga(1017036298,365543100),new Ga(1126000580,2618297676),\nnew Ga(1288033470,3409855158),new Ga(1501505948,4234509866),new Ga(1607167915,987167468),new Ga(1816402316,1246189591)];return function(c,b,d,e){void 0===e&&(e=!1);if(e){var g=new Ga(3418070365,3238371032);var f=new Ga(1654270250,914150663);var h=new Ga(2438529370,812702999);var k=new Ga(355462360,4144912697);var l=new Ga(1731405415,4290775857);var m=new Ga(2394180231,1750603025);var n=new Ga(3675008525,1694076839);var p=new Ga(1203062813,3204075428)}else g=new Ga(1779033703,4089235720),f=new Ga(3144134277,\n2227873595),h=new Ga(1013904242,4271175723),k=new Ga(2773480762,1595750129),l=new Ga(1359893119,2917565137),m=new Ga(2600822924,725511199),n=new Ga(528734635,4215389547),p=new Ga(1541459225,327033209);var q=128*Math.ceil((d+17)/128),r=new Uint8Array(q),t;for(t=0;t<d;++t)r[t]=c[b++];r[t++]=128;for(c=q-16;t<c;)r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=0;r[t++]=d>>>29&255;r[t++]=d>>21&255;r[t++]=d>>13&255;r[t++]=d>>5&255;r[t++]=d<<3&255;\nc=Array(80);for(t=0;80>t;t++)c[t]=new Ga(0,0);b=new Ga(0,0);var v=new Ga(0,0),w=new Ga(0,0),y=new Ga(0,0),x=new Ga(0,0),z=new Ga(0,0),A=new Ga(0,0),B=new Ga(0,0),C=new Ga(0,0),D=new Ga(0,0),E=new Ga(0,0),G=new Ga(0,0),J;for(t=0;t<q;){for(d=0;16>d;++d)c[d].high=r[t]<<24|r[t+1]<<16|r[t+2]<<8|r[t+3],c[d].low=r[t+4]<<24|r[t+5]<<16|r[t+6]<<8|r[t+7],t+=8;for(d=16;80>d;++d){var F=J=c[d],L=c[d-2];F.assign(L);F.rotateRight(19);G.assign(L);G.rotateRight(61);F.xor(G);G.assign(L);G.shiftRight(6);F.xor(G);J.add(c[d-\n7]);F=E;L=c[d-15];F.assign(L);F.rotateRight(1);G.assign(L);G.rotateRight(8);F.xor(G);G.assign(L);G.shiftRight(7);F.xor(G);J.add(E);J.add(c[d-16])}b.assign(g);v.assign(f);w.assign(h);y.assign(k);x.assign(l);z.assign(m);A.assign(n);B.assign(p);for(d=0;80>d;++d){C.assign(B);J=E;F=x;J.assign(F);J.rotateRight(14);G.assign(F);G.rotateRight(18);J.xor(G);G.assign(F);G.rotateRight(41);J.xor(G);C.add(E);J=E;F=x;L=z;var M=A;J.assign(F);J.and(L);G.assign(F);G.not();G.and(M);J.xor(G);C.add(E);C.add(a[d]);C.add(c[d]);\nJ=D;F=b;J.assign(F);J.rotateRight(28);G.assign(F);G.rotateRight(34);J.xor(G);G.assign(F);G.rotateRight(39);J.xor(G);J=E;F=b;L=v;M=w;J.assign(F);J.and(L);G.assign(F);G.and(M);J.xor(G);G.assign(L);G.and(M);J.xor(G);D.add(E);J=B;B=A;A=z;z=x;y.add(C);x=y;y=w;w=v;v=b;J.assign(C);J.add(D);b=J}g.add(b);f.add(v);h.add(w);k.add(y);l.add(x);m.add(z);n.add(A);p.add(B)}e?(e=new Uint8Array(48),g.copyTo(e,0),f.copyTo(e,8),h.copyTo(e,16),k.copyTo(e,24),l.copyTo(e,32),m.copyTo(e,40)):(e=new Uint8Array(64),g.copyTo(e,\n0),f.copyTo(e,8),h.copyTo(e,16),k.copyTo(e,24),l.copyTo(e,32),m.copyTo(e,40),n.copyTo(e,48),p.copyTo(e,56));return e}}(),At=function(){function a(){}var c=a.prototype;c.decryptBlock=function(b){return b};c.encrypt=function(b){return b};return a}(),Aj=function(){function a(){this._s=new Uint8Array([99,124,119,123,242,107,111,197,48,1,103,43,254,215,171,118,202,130,201,125,250,89,71,240,173,212,162,175,156,164,114,192,183,253,147,38,54,63,247,204,52,165,229,241,113,216,49,21,4,199,35,195,24,150,5,154,\n7,18,128,226,235,39,178,117,9,131,44,26,27,110,90,160,82,59,214,179,41,227,47,132,83,209,0,237,32,252,177,91,106,203,190,57,74,76,88,207,208,239,170,251,67,77,51,133,69,249,2,127,80,60,159,168,81,163,64,143,146,157,56,245,188,182,218,33,16,255,243,210,205,12,19,236,95,151,68,23,196,167,126,61,100,93,25,115,96,129,79,220,34,42,144,136,70,238,184,20,222,94,11,219,224,50,58,10,73,6,36,92,194,211,172,98,145,149,228,121,231,200,55,109,141,213,78,169,108,86,244,234,101,122,174,8,186,120,37,46,28,166,180,\n198,232,221,116,31,75,189,139,138,112,62,181,102,72,3,246,14,97,53,87,185,134,193,29,158,225,248,152,17,105,217,142,148,155,30,135,233,206,85,40,223,140,161,137,13,191,230,66,104,65,153,45,15,176,84,187,22]);this._inv_s=new Uint8Array([82,9,106,213,48,54,165,56,191,64,163,158,129,243,215,251,124,227,57,130,155,47,255,135,52,142,67,68,196,222,233,203,84,123,148,50,166,194,35,61,238,76,149,11,66,250,195,78,8,46,161,102,40,217,36,178,118,91,162,73,109,139,209,37,114,248,246,100,134,104,152,22,212,164,\n92,204,93,101,182,146,108,112,72,80,253,237,185,218,94,21,70,87,167,141,157,132,144,216,171,0,140,188,211,10,247,228,88,5,184,179,69,6,208,44,30,143,202,63,15,2,193,175,189,3,1,19,138,107,58,145,17,65,79,103,220,234,151,242,207,206,240,180,230,115,150,172,116,34,231,173,53,133,226,249,55,232,28,117,223,110,71,241,26,113,29,41,197,137,111,183,98,14,170,24,190,27,252,86,62,75,198,210,121,32,154,219,192,254,120,205,90,244,31,221,168,51,136,7,199,49,177,18,16,89,39,128,236,95,96,81,127,169,25,181,74,\n13,45,229,122,159,147,201,156,239,160,224,59,77,174,42,245,176,200,235,187,60,131,83,153,97,23,43,4,126,186,119,214,38,225,105,20,99,85,33,12,125]);this._mix=new Uint32Array([0,235474187,470948374,303765277,941896748,908933415,607530554,708780849,1883793496,2118214995,1817866830,1649639237,1215061108,1181045119,1417561698,1517767529,3767586992,4003061179,4236429990,4069246893,3635733660,3602770327,3299278474,3400528769,2430122216,2664543715,2362090238,2193862645,2835123396,2801107407,3035535058,3135740889,\n3678124923,3576870512,3341394285,3374361702,3810496343,3977675356,4279080257,4043610186,2876494627,2776292904,3076639029,3110650942,2472011535,2640243204,2403728665,2169303058,1001089995,899835584,666464733,699432150,59727847,226906860,530400753,294930682,1273168787,1172967064,1475418501,1509430414,1942435775,2110667444,1876241833,1641816226,2910219766,2743034109,2976151520,3211623147,2505202138,2606453969,2302690252,2269728455,3711829422,3543599269,3240894392,3475313331,3843699074,3943906441,4178062228,\n4144047775,1306967366,1139781709,1374988112,1610459739,1975683434,2076935265,1775276924,1742315127,1034867998,866637845,566021896,800440835,92987698,193195065,429456164,395441711,1984812685,2017778566,1784663195,1683407248,1315562145,1080094634,1383856311,1551037884,101039829,135050206,437757123,337553864,1042385657,807962610,573804783,742039012,2531067453,2564033334,2328828971,2227573024,2935566865,2700099354,3001755655,3168937228,3868552805,3902563182,4203181171,4102977912,3736164937,3501741890,\n3265478751,3433712980,1106041591,1340463100,1576976609,1408749034,2043211483,2009195472,1708848333,1809054150,832877231,1068351396,766945465,599762354,159417987,126454664,361929877,463180190,2709260871,2943682380,3178106961,3009879386,2572697195,2538681184,2236228733,2336434550,3509871135,3745345300,3441850377,3274667266,3910161971,3877198648,4110568485,4211818798,2597806476,2497604743,2261089178,2295101073,2733856160,2902087851,3202437046,2968011453,3936291284,3835036895,4136440770,4169408201,3535486456,\n3702665459,3467192302,3231722213,2051518780,1951317047,1716890410,1750902305,1113818384,1282050075,1584504582,1350078989,168810852,67556463,371049330,404016761,841739592,1008918595,775550814,540080725,3969562369,3801332234,4035489047,4269907996,3569255213,3669462566,3366754619,3332740144,2631065433,2463879762,2160117071,2395588676,2767645557,2868897406,3102011747,3069049960,202008497,33778362,270040487,504459436,875451293,975658646,675039627,641025152,2084704233,1917518562,1615861247,1851332852,1147550661,\n1248802510,1484005843,1451044056,933301370,967311729,733156972,632953703,260388950,25965917,328671808,496906059,1206477858,1239443753,1543208500,1441952575,2144161806,1908694277,1675577880,1842759443,3610369226,3644379585,3408119516,3307916247,4011190502,3776767469,4077384432,4245618683,2809771154,2842737049,3144396420,3043140495,2673705150,2438237621,2203032232,2370213795]);this._mixCol=new Uint8Array(256);for(var b=0;256>b;b++)this._mixCol[b]=128>b?b<<1:b<<1^27;this.buffer=new Uint8Array(16);this.bufferPosition=\n0}var c=a.prototype;c._expandKey=function(){db("Cannot call `_expandKey` on the base class")};c._decrypt=function(b,d){var e,g=new Uint8Array(16);g.set(b);b=0;for(e=this._keySize;16>b;++b,++e)g[b]^=d[e];for(b=this._cyclesOfRepetition-1;1<=b;--b){var f=g[13];g[13]=g[9];g[9]=g[5];g[5]=g[1];g[1]=f;f=g[14];e=g[10];g[14]=g[6];g[10]=g[2];g[6]=f;g[2]=e;f=g[15];e=g[11];var h=g[7];g[15]=g[3];g[11]=f;g[7]=e;g[3]=h;for(e=0;16>e;++e)g[e]=this._inv_s[g[e]];e=0;for(f=16*b;16>e;++e,++f)g[e]^=d[f];for(e=0;16>e;e+=\n4){f=this._mix[g[e+1]];h=this._mix[g[e+2]];var k=this._mix[g[e+3]];f=this._mix[g[e]]^f>>>8^f<<24^h>>>16^h<<16^k>>>24^k<<8;g[e]=f>>>24&255;g[e+1]=f>>16&255;g[e+2]=f>>8&255;g[e+3]=f&255}}f=g[13];g[13]=g[9];g[9]=g[5];g[5]=g[1];g[1]=f;f=g[14];e=g[10];g[14]=g[6];g[10]=g[2];g[6]=f;g[2]=e;f=g[15];e=g[11];h=g[7];g[15]=g[3];g[11]=f;g[7]=e;g[3]=h;for(b=0;16>b;++b)g[b]=this._inv_s[g[b]],g[b]^=d[b];return g};c._encrypt=function(b,d){var e=this._s,g,f=new Uint8Array(16);f.set(b);for(b=0;16>b;++b)f[b]^=d[b];for(b=\n1;b<this._cyclesOfRepetition;b++){for(g=0;16>g;++g)f[g]=e[f[g]];var h=f[1];f[1]=f[5];f[5]=f[9];f[9]=f[13];f[13]=h;h=f[2];var k=f[6];f[2]=f[10];f[6]=f[14];f[10]=h;f[14]=k;h=f[3];k=f[7];g=f[11];f[3]=f[15];f[7]=h;f[11]=k;f[15]=g;for(k=0;16>k;k+=4){h=f[k+0];var l=f[k+1],m=f[k+2],n=f[k+3];g=h^l^m^n;f[k+0]=f[k+0]^g^this._mixCol[h^l];f[k+1]=f[k+1]^g^this._mixCol[l^m];f[k+2]=f[k+2]^g^this._mixCol[m^n];f[k+3]=f[k+3]^g^this._mixCol[n^h]}g=0;for(k=16*b;16>g;++g,++k)f[g]^=d[k]}for(b=0;16>b;++b)f[b]=e[f[b]];h=\nf[1];f[1]=f[5];f[5]=f[9];f[9]=f[13];f[13]=h;h=f[2];k=f[6];f[2]=f[10];f[6]=f[14];f[10]=h;f[14]=k;h=f[3];k=f[7];g=f[11];f[3]=f[15];f[7]=h;f[11]=k;f[15]=g;e=0;for(b=this._keySize;16>e;++e,++b)f[e]^=d[b];return f};c._decryptBlock2=function(b,d){for(var e=b.length,g=this.buffer,f=this.bufferPosition,h=[],k=this.iv,l=0;l<e;++l)if(g[f]=b[l],++f,!(16>f)){f=this._decrypt(g,this._key);for(var m=0;16>m;++m)f[m]^=k[m];k=g;h.push(f);g=new Uint8Array(16);f=0}this.buffer=g;this.bufferLength=f;this.iv=k;if(0===h.length)return new Uint8Array(0);\nb=16*h.length;if(d&&(d=h.at(-1),e=d[15],16>=e)){g=15;for(k=16-e;g>=k;--g)if(d[g]!==e){e=0;break}b-=e;h[h.length-1]=d.subarray(0,16-e)}d=new Uint8Array(b);e=b=0;for(g=h.length;b<g;++b,e+=16)d.set(h[b],e);return d};c.decryptBlock=function(b,d,e){void 0===e&&(e=null);var g=b.length,f=this.buffer,h=this.bufferPosition;if(e)this.iv=e;else{for(e=0;16>h&&e<g;++e,++h)f[h]=b[e];if(16>h)return this.bufferLength=h,new Uint8Array(0);this.iv=f;b=b.subarray(16)}this.buffer=new Uint8Array(16);this.bufferLength=\n0;this.decryptBlock=this._decryptBlock2;return this.decryptBlock(b,d)};c.encrypt=function(b,d){var e=b.length,g=this.buffer,f=this.bufferPosition,h=[];d||(d=new Uint8Array(16));for(var k=0;k<e;++k)if(g[f]=b[k],++f,!(16>f)){for(f=0;16>f;++f)g[f]^=d[f];d=g=this._encrypt(g,this._key);h.push(g);g=new Uint8Array(16);f=0}this.buffer=g;this.bufferLength=f;this.iv=d;if(0===h.length)return new Uint8Array(0);b=new Uint8Array(16*h.length);e=d=0;for(k=h.length;d<k;++d,e+=16)b.set(h[d],e);return b};return a}(),\noo=function(a){function c(b){var d=a.call(this)||this;d._cyclesOfRepetition=10;d._keySize=160;d._rcon=new Uint8Array([141,1,2,4,8,16,32,64,128,27,54,108,216,171,77,154,47,94,188,99,198,151,53,106,212,179,125,250,239,197,145,57,114,228,211,189,97,194,159,37,74,148,51,102,204,131,29,58,116,232,203,141,1,2,4,8,16,32,64,128,27,54,108,216,171,77,154,47,94,188,99,198,151,53,106,212,179,125,250,239,197,145,57,114,228,211,189,97,194,159,37,74,148,51,102,204,131,29,58,116,232,203,141,1,2,4,8,16,32,64,128,\n27,54,108,216,171,77,154,47,94,188,99,198,151,53,106,212,179,125,250,239,197,145,57,114,228,211,189,97,194,159,37,74,148,51,102,204,131,29,58,116,232,203,141,1,2,4,8,16,32,64,128,27,54,108,216,171,77,154,47,94,188,99,198,151,53,106,212,179,125,250,239,197,145,57,114,228,211,189,97,194,159,37,74,148,51,102,204,131,29,58,116,232,203,141,1,2,4,8,16,32,64,128,27,54,108,216,171,77,154,47,94,188,99,198,151,53,106,212,179,125,250,239,197,145,57,114,228,211,189,97,194,159,37,74,148,51,102,204,131,29,58,116,\n232,203,141]);d._key=d._expandKey(b);return d}$l(c,a);c.prototype._expandKey=function(b){var d=this._s,e=this._rcon,g=new Uint8Array(176);g.set(b);b=16;for(var f=1;176>b;++f){var h=g[b-3],k=g[b-2],l=g[b-1],m=g[b-4];h=d[h];k=d[k];l=d[l];m=d[m];h^=e[f];for(var n=0;4>n;++n)g[b]=h^=g[b-16],b++,g[b]=k^=g[b-16],b++,g[b]=l^=g[b-16],b++,g[b]=m^=g[b-16],b++}return g};return c}(Aj),Hf=function(a){function c(b){var d=a.call(this)||this;d._cyclesOfRepetition=14;d._keySize=224;d._key=d._expandKey(b);return d}\n$l(c,a);c.prototype._expandKey=function(b){var d=this._s,e=new Uint8Array(240);e.set(b);b=1;for(var g,f,h,k,l=32,m=1;240>l;++m){16===l%32?(g=d[g],f=d[f],h=d[h],k=d[k]):0===l%32&&(g=e[l-3],f=e[l-2],h=e[l-1],k=e[l-4],g=d[g],f=d[f],h=d[h],k=d[k],g^=b,256<=(b<<=1)&&(b=(b^27)&255));for(var n=0;4>n;++n)e[l]=g^=e[l-32],l++,e[l]=f^=e[l-32],l++,e[l]=h^=e[l-32],l++,e[l]=k^=e[l-32],l++}return e};return c}(Aj),Bt=function(){function a(){}var c=a.prototype;c.checkOwnerPassword=function(b,d,e,g){var f=new Uint8Array(b.length+\n56);f.set(b,0);f.set(d,b.length);f.set(e,b.length+d.length);b=Ye(f,0,f.length);return ee(b,g)};c.checkUserPassword=function(b,d,e){var g=new Uint8Array(b.length+8);g.set(b,0);g.set(d,b.length);b=Ye(g,0,g.length);return ee(b,e)};c.getOwnerKey=function(b,d,e,g){var f=new Uint8Array(b.length+56);f.set(b,0);f.set(d,b.length);f.set(e,b.length+d.length);b=Ye(f,0,f.length);return(new Hf(b)).decryptBlock(g,!1,new Uint8Array(16))};c.getUserKey=function(b,d,e){var g=new Uint8Array(b.length+8);g.set(b,0);g.set(d,\nb.length);b=Ye(g,0,g.length);return(new Hf(b)).decryptBlock(e,!1,new Uint8Array(16))};return a}(),Ct=function(){function a(){}var c=a.prototype;c._hash=function(b,d,e){d=Ye(d,0,d.length).subarray(0,32);for(var g=[0],f=0;64>f||g.at(-1)>f-32;){g=b.length+d.length+e.length;var h=new Uint8Array(g),k=0;h.set(b,k);k+=b.length;h.set(d,k);k+=d.length;h.set(e,k);k=new Uint8Array(64*g);for(var l=0,m=0;64>l;l++,m+=g)k.set(h,m);g=(new oo(d.subarray(0,16))).encrypt(k,d.subarray(16,32));h=g.slice(0,16).reduce(function(n,\np){return n+p},0)%3;0===h?d=Ye(g,0,g.length):1===h?d=no(g,0,g.length,!0):2===h&&(d=no(g,0,g.length));f++}return d.subarray(0,32)};c.checkOwnerPassword=function(b,d,e,g){var f=new Uint8Array(b.length+56);f.set(b,0);f.set(d,b.length);f.set(e,b.length+d.length);b=this._hash(b,f,e);return ee(b,g)};c.checkUserPassword=function(b,d,e){var g=new Uint8Array(b.length+8);g.set(b,0);g.set(d,b.length);b=this._hash(b,g,[]);return ee(b,e)};c.getOwnerKey=function(b,d,e,g){var f=new Uint8Array(b.length+56);f.set(b,\n0);f.set(d,b.length);f.set(e,b.length+d.length);b=this._hash(b,f,e);return(new Hf(b)).decryptBlock(g,!1,new Uint8Array(16))};c.getUserKey=function(b,d,e){var g=new Uint8Array(b.length+8);g.set(b,0);g.set(d,b.length);b=this._hash(b,g,[]);return(new Hf(b)).decryptBlock(e,!1,new Uint8Array(16))};return a}(),po=function(){function a(b,d){this.StringCipherConstructor=b;this.StreamCipherConstructor=d}var c=a.prototype;c.createStream=function(b,d){var e=new this.StreamCipherConstructor;return new zt(b,d,\nfunction(g,f){return e.decryptBlock(g,f)})};c.decryptString=function(b){var d=new this.StringCipherConstructor;b=jc(b);b=d.decryptBlock(b,!0);return Ec(b)};c.encryptString=function(b){var d=new this.StringCipherConstructor;if(d instanceof Aj){var e=16-b.length%16;b+=String.fromCharCode(e).repeat(e);e=new Uint8Array(16);if("undefined"!==typeof crypto)crypto.getRandomValues(e);else for(var g=0;16>g;g++)e[g]=Math.floor(256*Math.random());b=jc(b);b=d.encrypt(b,e);d=new Uint8Array(16+b.length);d.set(e);\nd.set(b,16);return Ec(d)}e=jc(b);e=d.encrypt(e);return Ec(e)};return a}(),qo=function(){function a(b,d,e){var g=b.get("Filter");if(!Lb(g,"Standard"))throw new oa("unknown encryption method");this.filterName=g.name;this.dict=b;g=b.get("V");if(!Number.isInteger(g)||1!==g&&2!==g&&4!==g&&5!==g)throw new oa("unsupported encryption algorithm");this.algorithm=g;var f=b.get("Length");if(!f)if(3>=g)f=40;else{var h=b.get("CF"),k=b.get("StmF");h instanceof ca&&k instanceof ka&&(h.suppressEncryption=!0,f=h.get(k.name),\nf=(null==f?void 0:f.get("Length"))||128,40>f&&(f<<=3))}if(!Number.isInteger(f)||40>f||0!==f%8)throw new oa("invalid key length");var l=jc(b.get("O")),m=jc(b.get("U"));h=l.subarray(0,32);k=m.subarray(0,32);var n=b.get("P"),p=b.get("R"),q=(4===g||5===g)&&!1!==b.get("EncryptMetadata");this.encryptMetadata=q;d=jc(d);if(e){if(6===p)try{e=unescape(encodeURIComponent(e))}catch(A){T("CipherTransformFactory: Unable to convert UTF8 encoded password.")}var r=jc(e)}if(5!==g)var t=this.__prepareKeyData(d,r,h,\nk,n,p,f,q);else{t=l.subarray(32,40);l=l.subarray(40,48);var v=m.subarray(0,48),w=m.subarray(32,40);m=m.subarray(40,48);var y=jc(b.get("OE")),x=jc(b.get("UE")),z=jc(b.get("Perms"));t=this.__createEncryptionKey20(p,r,h,t,l,v,k,w,m,y,x,z)}if(!t&&!e)throw new Hg("No password given",1);!t&&e&&(e=this.__decodeUserPassword(r,h,p,f),t=this.__prepareKeyData(d,e,h,k,n,p,f,q));if(!t)throw new Hg("Incorrect Password",2);this.encryptionKey=t;4<=g&&(e=b.get("CF"),e instanceof ca&&(e.suppressEncryption=!0),this.cf=\ne,this.stmf=b.get("StmF")||ka.get("Identity"),this.strf=b.get("StrF")||ka.get("Identity"),this.eff=b.get("EFF")||this.stmf)}var c=a.prototype;c.__createEncryptionKey20=function(b,d,e,g,f,h,k,l,m,n,p){d=d?d.subarray(0,Math.min(127,d.length)):[];b=6===b?new Ct:new Bt;return b.checkUserPassword(d,l,k)?b.getUserKey(d,m,p):d.length&&b.checkOwnerPassword(d,g,h,e)?b.getOwnerKey(d,f,h,n):null};c.__prepareKeyData=function(b,d,e,g,f,h,k,l){var m=new Uint8Array(40+e.length+b.length),n=0,p;if(d)for(p=Math.min(32,\nd.length);n<p;++n)m[n]=d[n];for(d=0;32>n;)m[n++]=a.__defaultPasswordBytes[d++];d=0;for(p=e.length;d<p;++d)m[n++]=e[d];m[n++]=f&255;m[n++]=f>>8&255;m[n++]=f>>16&255;m[n++]=f>>>24&255;d=0;for(p=b.length;d<p;++d)m[n++]=b[d];4<=h&&!l&&(m[n++]=255,m[n++]=255,m[n++]=255,m[n++]=255);p=Qd(m,0,n);n=k>>3;if(3<=h)for(d=0;50>d;++d)p=Qd(p,0,n);k=p.subarray(0,n);if(3<=h){for(n=0;32>n;++n)m[n]=a.__defaultPasswordBytes[n];d=0;for(p=b.length;d<p;++d)m[n++]=b[d];b=new ve(k);m=b.encryptBlock(Qd(m,0,n));p=k.length;h=\nnew Uint8Array(p);for(d=1;19>=d;++d){for(b=0;b<p;++b)h[b]=k[b]^d;b=new ve(h);m=b.encryptBlock(m)}}else b=new ve(k),m=b.encryptBlock(a.__defaultPasswordBytes);d=0;for(p=m.length;d<p;++d)if(g[d]!==m[d])return null;return k};c.__decodeUserPassword=function(b,d,e,g){for(var f=new Uint8Array(32),h=0,k=Math.min(32,b.length);h<k;++h)f[h]=b[h];for(b=0;32>h;)f[h++]=a.__defaultPasswordBytes[b++];f=Qd(f,0,h);g>>=3;if(3<=e)for(b=0;50>b;++b)f=Qd(f,0,f.length);if(3<=e)for(h=new Uint8Array(g),b=19;0<=b;b--){for(e=\n0;e<g;++e)h[e]=f[e]^b;e=new ve(h);d=e.encryptBlock(d)}else e=new ve(f.subarray(0,g)),d=e.encryptBlock(d);return d};c.__buildObjectKey=function(b,d,e,g){void 0===g&&(g=!1);var f=new Uint8Array(e.length+9),h=e.length,k;for(k=0;k<h;++k)f[k]=e[k];f[k++]=b&255;f[k++]=b>>8&255;f[k++]=b>>16&255;f[k++]=d&255;f[k++]=d>>8&255;g&&(f[k++]=115,f[k++]=65,f[k++]=108,f[k++]=84);return Qd(f,0,k).subarray(0,Math.min(e.length+5,16))};c.__buildCipherConstructor=function(b,d,e,g,f){if(!(d instanceof ka))throw new oa("Invalid crypt filter name.");\nvar h=this;b=b.get(d.name);b=null==b?void 0:b.get("CFM");if(!b||"None"===b.name)return function(){return new At};if("V2"===b.name)return function(){return new ve(h.__buildObjectKey(e,g,f,!1))};if("AESV2"===b.name)return function(){return new oo(h.__buildObjectKey(e,g,f,!0))};if("AESV3"===b.name)return function(){return new Hf(f)};throw new oa("Unknown crypto method");};c.createCipherTransform=function(b,d){function e(){return new ve(g)}if(4===this.algorithm||5===this.algorithm)return new po(this.__buildCipherConstructor(this.cf,\nthis.strf,b,d,this.encryptionKey),this.__buildCipherConstructor(this.cf,this.stmf,b,d,this.encryptionKey));var g=this.__buildObjectKey(b,d,this.encryptionKey,!1);return new po(e,e)};return a}();qo.__defaultPasswordBytes=new Uint8Array([40,191,78,94,78,117,138,65,100,0,78,86,255,250,1,8,46,46,0,182,208,104,62,128,47,12,169,254,100,83,105,122]);var Bj=function(){function a(b,d){this.dict=b;this.ref=d instanceof Ha?d:null;this.roleMap=new Map;this.structParentIds=null}var c=a.prototype;c.init=function(){this.readRoleMap()};\nc.__addIdToPage=function(b,d,e){if(b instanceof Ha&&!(0>d)){this.structParentIds||(this.structParentIds=new Pc);var g=this.structParentIds.get(b);g||(g=[],this.structParentIds.put(b,g));g.push([d,e])}};c.addAnnotationIdToPage=function(b,d){this.__addIdToPage(b,d,4)};c.readRoleMap=function(){var b=this,d=this.dict.get("RoleMap");d instanceof ca&&d.forEach(function(e,g){g instanceof ka&&b.roleMap.set(e,g.name)})};a.canCreateStructureTree=function(){var b=Je(function g(e){var f,h,k,l,m,n,p,q,r,t,v,w,\ny,x,z,A,B,C,D,E,G,J,F,L;return u.generator.createGenerator(g,function(M){switch(M.nextAddress){case 1:f=e;h=f.catalogRef;k=f.pdfManager;l=f.newAnnotationsByPage;if(!(h instanceof Ha))return T("Cannot save the struct tree: no catalog reference."),M.return(!1);m=0;n=!0;p=u.makeIterator(l);q=p.next();case 2:if(q.done){M.jumpTo(4);break}r=q.value;t=u.makeIterator(r);v=t.next().value;w=t.next().value;return M.yield(k.getPage(v),5);case 5:y=M.yieldResult;x=y.ref;if(!(x instanceof Ha)){T("Cannot save the struct tree: page "+\nv+" has no ref.");n=!0;M.jumpTo(4);break}z=u.makeIterator(w);for(A=z.next();!A.done;A=z.next())B=A.value,null!=(C=B.accessibilityData)&&C.type&&(B.parentTreeId=m++,n=!1);q=p.next();M.jumpTo(2);break;case 4:if(n){D=u.makeIterator(l.values());for(E=D.next();!E.done;E=D.next())for(G=E.value,J=u.makeIterator(G),F=J.next();!F.done;F=J.next())L=F.value,delete L.parentTreeId;return M.return(!1)}return M.return(!0)}})});return function(e){return b.apply(this,arguments)}}();a.createStructureTree=function(){var b=\nJe(function g(e){var f,h,k,l,m,n,p,q,r,t,v,w,y,x,z=this,A,B,C,D,E,G,J,F;return u.generator.createGenerator(g,function(L){switch(L.nextAddress){case 1:return f=e,h=f.newAnnotationsByPage,k=f.xref,l=f.catalogRef,m=f.pdfManager,n=f.newRefs,p=m.catalog.cloneDict(),q=new Pc,q.put(l,p),r=k.getNewTemporaryRef(),p.set("StructTreeRoot",r),t=new ca(k),t.set("Type",ka.get("StructTreeRoot")),v=k.getNewTemporaryRef(),t.set("ParentTree",v),w=[],t.set("K",w),q.put(r,t),y=new ca(k),x=[],y.set("Nums",x),L.yield(z.__writeKids({newAnnotationsByPage:h,\nstructTreeRootRef:r,structTreeRoot:null,kids:w,nums:x,xref:k,pdfManager:m,newRefs:n,cache:q}),2);case 2:A=L.yieldResult,t.set("ParentTreeNextKey",A),q.put(v,y),B=[],C=u.makeIterator(q.items()),D=C.next();case 3:if(D.done){L.jumpTo(0);break}E=D.value;G=u.makeIterator(E);J=G.next().value;F=G.next().value;B.length=0;return L.yield(pc(J,F,B,k),6);case 6:n.push({ref:J,data:B.join("")}),D=C.next(),L.jumpTo(3)}})});return function(e){return b.apply(this,arguments)}}();c.canUpdateStructTree=function(){var b=\nJe(function g(e){var f,h,k,l,m=this,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R;return u.generator.createGenerator(g,function(Y){switch(Y.nextAddress){case 1:f=e;h=f.pdfManager;k=f.xref;l=f.newAnnotationsByPage;if(!m.ref)return T("Cannot update the struct tree: no root reference."),Y.return(!1);n=m.dict.get("ParentTreeNextKey");if(!Number.isInteger(n)||0>n)return T("Cannot update the struct tree: invalid next key."),Y.return(!1);p=m.dict.get("ParentTree");if(!(p instanceof ca))return T("Cannot update the struct tree: ParentTree isn\'t a dict."),\nY.return(!1);q=p.get("Nums");if(!Array.isArray(q))return T("Cannot update the struct tree: nums isn\'t an array."),Y.return(!1);r=new Tg(p,k);t=u.makeIterator(l.keys());v=t.next();case 2:if(v.done){Y.jumpTo(4);break}w=v.value;return Y.yield(h.getPage(w),5);case 5:y=Y.yieldResult;x=y.pageDict;if(!x.has("StructParents")){Y.jumpTo(3);break}z=x.get("StructParents");if(!Number.isInteger(z)||!Array.isArray(r.get(z)))return T("Cannot save the struct tree: page "+w+" has a wrong id."),Y.return(!1);case 3:v=\nt.next();Y.jumpTo(2);break;case 4:A=!0,B=u.makeIterator(l),C=B.next();case 6:if(C.done){Y.jumpTo(8);break}D=C.value;E=u.makeIterator(D);G=E.next().value;J=E.next().value;return Y.yield(h.getPage(G),9);case 9:F=Y.yieldResult;L=F.pageDict;a.__collectParents({elements:J,xref:m.dict.xref,pageDict:L,numberTree:r});M=u.makeIterator(J);for(W=M.next();!W.done;W=M.next())Q=W.value,null!=(la=Q.accessibilityData)&&la.type&&(0<=Q.accessibilityData.structParent||(Q.parentTreeId=n++),A=!1);C=B.next();Y.jumpTo(6);\nbreak;case 8:if(A){ta=u.makeIterator(l.values());for(qa=ta.next();!qa.done;qa=ta.next())for(va=qa.value,S=u.makeIterator(va),da=S.next();!da.done;da=S.next())R=da.value,delete R.parentTreeId,delete R.structTreeParent;return Y.return(!1)}return Y.return(!0)}})});return function(e){return b.apply(this,arguments)}}();c.updateStructureTree=function(){var b=Je(function g(e){var f,h,k,l,m=this,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G;return u.generator.createGenerator(g,function(J){switch(J.nextAddress){case 1:return f=\ne,h=f.newAnnotationsByPage,k=f.pdfManager,l=f.newRefs,n=m.dict.xref,p=m.dict.clone(),q=m.ref,r=new Pc,r.put(q,p),t=p.getRaw("ParentTree"),t instanceof Ha?v=n.fetch(t):(v=t,t=n.getNewTemporaryRef(),p.set("ParentTree",t)),v=v.clone(),r.put(t,v),w=v.getRaw("Nums"),y=null,w instanceof Ha&&(y=w,w=n.fetch(y)),w=w.slice(),y||v.set("Nums",w),J.yield(a.__writeKids({newAnnotationsByPage:h,structTreeRootRef:q,structTreeRoot:m,kids:null,nums:w,xref:n,pdfManager:k,newRefs:l,cache:r}),2);case 2:x=J.yieldResult;\nif(-1===x)return J.return();p.set("ParentTreeNextKey",x);y&&r.put(y,w);z=[];A=u.makeIterator(r.items());B=A.next();case 3:if(B.done){J.jumpTo(0);break}C=B.value;D=u.makeIterator(C);E=D.next().value;G=D.next().value;z.length=0;return J.yield(pc(E,G,z,n),6);case 6:l.push({ref:E,data:z.join("")}),B=A.next(),J.jumpTo(3)}})});return function(e){return b.apply(this,arguments)}}();a.__writeKids=function(){var b=Je(function g(e){var f,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R,\nY,fa,H,U,N,ba,aa,X=this,ha;return u.generator.createGenerator(g,function(ma){switch(ma.nextAddress){case 1:f=e,h=f.newAnnotationsByPage,k=f.structTreeRootRef,l=f.structTreeRoot,m=f.kids,n=f.nums,p=f.xref,q=f.pdfManager,r=f.newRefs,t=f.cache,v=ka.get("OBJR"),w=-1,x=[],z=u.makeIterator(h),A=z.next();case 2:if(A.done){ma.jumpTo(4);break}B=A.value;C=u.makeIterator(B);D=C.next().value;E=C.next().value;return ma.yield(q.getPage(D),5);case 5:J=G=ma.yieldResult,F=J.ref,L=F instanceof Ha,M=u.makeIterator(E),\nW=M.next();case 6:if(W.done){A=z.next();ma.jumpTo(2);break}la=Q=W.value;ta=la.accessibilityData;qa=la.ref;va=la.parentTreeId;S=la.structTreeParent;if(null==ta||!ta.type){ma.jumpTo(7);break}da=ta;R=da.structParent;if(!(l&&Number.isInteger(R)&&0<=R)){ma.jumpTo(9);break}fa=(y||(y=new Map)).get(D);void 0===fa&&(H=new ro(l,G.pageDict),fa=H.collectObjects(F),y.set(D,fa));U=null==(Y=fa)?void 0:Y.get(R);if(!U){ma.jumpTo(9);break}N=p.fetch(U).clone();a.__writeProperties(N,ta);x.length=0;return ma.yield(pc(U,\nN,x,p),11);case 11:r.push({ref:U,data:x.join("")});ma.jumpTo(7);break;case 9:return w=Math.max(w,va),ba=p.getNewTemporaryRef(),aa=new ca(p),a.__writeProperties(aa,ta),ma.yield(X.__updateParentTag({structTreeParent:S,tagDict:aa,newTagRef:ba,structTreeRootRef:k,fallbackKids:m,xref:p,cache:t}),12);case 12:ha=new ca(p),aa.set("K",ha),ha.set("Type",v),L&&ha.set("Pg",F),ha.set("Obj",qa),t.put(ba,aa),n.push(va,ba);case 7:W=M.next();ma.jumpTo(6);break;case 4:return ma.return(w+1)}})});return function(e){return b.apply(this,\narguments)}}();a.__writeProperties=function(b,d){var e=d.title,g=d.lang,f=d.alt,h=d.expanded,k=d.actualText;b.set("S",ka.get(d.type));e&&b.set("T",hd(e));g&&b.set("Lang",hd(g));f&&b.set("Alt",hd(f));h&&b.set("E",hd(h));k&&b.set("ActualText",hd(k))};a.__collectParents=function(b){var d=b.elements,e=b.xref,g=b.pageDict;b=b.numberTree;var f=new Map;d=u.makeIterator(d);for(var h=d.next();!h.done;h=d.next())if(h=h.value,h.structTreeParentId){var k=parseInt(h.structTreeParentId.split("_mc")[1],10),l=f.get(k);\nl||(l=[],f.set(k,l));l.push(h)}g=g.get("StructParents");if(Number.isInteger(g))for(b=b.get(g),g=function(m,n,p){if(m=f.get(m)){var q=n.getRaw("P"),r=e.fetchIfRef(q);if(q instanceof Ha&&r instanceof ca)for(n={ref:p,dict:n},p=u.makeIterator(m),m=p.next();!m.done;m=p.next())m.value.structTreeParent=n;return!0}return!1},b=u.makeIterator(b),d=b.next();!d.done;d=b.next())if(d=d.value,d instanceof Ha)if(h=e.fetch(d),k=h.get("K"),Number.isInteger(k))g(k,h,d);else if(Array.isArray(k))for(k=u.makeIterator(k),\nl=k.next();!l.done;l=k.next()){l=l.value;l=e.fetchIfRef(l);if(Number.isInteger(l)&&g(l,h,d))break;if(l instanceof ca){if(!Lb(l.get("Type"),"MCR"))break;l=l.get("MCID");if(Number.isInteger(l)&&g(l,h,d))break}}};a.__updateParentTag=function(){var b=Je(function g(e){var f,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B;return u.generator.createGenerator(g,function(C){f=e;h=f.structTreeParent;k=f.tagDict;l=f.newTagRef;m=f.structTreeRootRef;n=f.fallbackKids;p=f.xref;q=f.cache;r=null;h?(v=h,r=v.ref,t=h.dict.getRaw("P")||\nm):t=m;k.set("P",t);w=p.fetchIfRef(t);if(!w)return n.push(l),C.return();y=q.get(t);y||(y=w.clone(),q.put(t,y));x=y.getRaw("K");z=x instanceof Ha?q.get(x):null;z||(z=p.fetchIfRef(x),z=Array.isArray(z)?z.slice():[x],A=p.getNewTemporaryRef(),y.set("K",A),q.put(A,z));B=z.indexOf(r);z.splice(0<=B?B+1:z.length,0,l);C.jumpToEnd()})});return function(e){return b.apply(this,arguments)}}();return a}(),Dt=function(){function a(b,d){this.tree=b;this.dict=d;this.kids=[];this.parseKids()}var c=a.prototype;c.parseKids=\nfunction(){var b=null,d=this.dict.getRaw("Pg");d instanceof Ha&&(b=d.toString());d=this.dict.get("K");if(Array.isArray(d)){d=u.makeIterator(d);for(var e=d.next();!e.done;e=d.next())(e=this.parseKid(b,e.value))&&this.kids.push(e)}else(b=this.parseKid(b,d))&&this.kids.push(b)};c.parseKid=function(b,d){if(Number.isInteger(d))return this.tree.pageDict.objId!==b?null:new ia({type:1,mcid:d,pageObjId:b});var e=null;d instanceof Ha?e=this.dict.xref.fetch(d):d instanceof ca&&(e=d);if(!e)return null;d=e.getRaw("Pg");\nd instanceof Ha&&(b=d.toString());d=e.get("Type")instanceof ka?e.get("Type").name:null;if("MCR"===d){if(this.tree.pageDict.objId!==b)return null;d=e.getRaw("Stm");return new ia({type:2,refObjId:d instanceof Ha?d.toString():null,pageObjId:b,mcid:e.get("MCID")})}if("OBJR"===d){if(this.tree.pageDict.objId!==b)return null;e=e.getRaw("Obj");return new ia({type:3,refObjId:e instanceof Ha?e.toString():null,pageObjId:b})}return new ia({type:5,dict:e})};return im(a,[{key:"role",get:function(){var b=this.dict.get("S");\nb=b instanceof ka?b.name:"";var d=this.tree.root;return d.roleMap.has(b)?d.roleMap.get(b):b}}])}(),ro=function(){function a(b,d){this.rootDict=(this.root=b)?b.dict:null;this.pageDict=d;this.nodes=[]}var c=a.prototype;c.collectObjects=function(b){var d;if(!(this.root&&this.rootDict&&b instanceof Ha))return null;var e=this.rootDict.get("ParentTree");if(!e)return null;var g=null==(d=this.root.structParentIds)?void 0:d.get(b);if(!g)return null;b=new Map;e=new Tg(e,this.rootDict.xref);g=u.makeIterator(g);\nfor(d=g.next();!d.done;d=g.next()){d=u.makeIterator(d.value).next().value;var f=e.getRaw(d);f instanceof Ha&&b.set(d,f)}return b};c.parse=function(b){var d;if(this.root&&this.rootDict&&b instanceof Ha){var e=this.rootDict.get("ParentTree");if(e){var g=this.pageDict.get("StructParents"),f=null==(d=this.root.structParentIds)?void 0:d.get(b);if(Number.isInteger(g)||f){b=new Map;e=new Tg(e,this.rootDict.xref);if(Number.isInteger(g)&&(g=e.get(g),Array.isArray(g)))for(g=u.makeIterator(g),d=g.next();!d.done;d=\ng.next())d=d.value,d instanceof Ha&&this.addNode(this.rootDict.xref.fetch(d),b);if(f)for(f=u.makeIterator(f),g=f.next();!g.done;g=f.next())if(g=u.makeIterator(g.value),d=g.next().value,g=g.next().value,d=e.get(d)){var h;d=this.addNode(this.rootDict.xref.fetchIfRef(d),b);1===(null==d||null==(h=d.kids)?void 0:h.length)&&3===d.kids[0].type&&(d.kids[0].type=g)}}}}};c.addNode=function(b,d,e){void 0===e&&(e=0);if(40<e)return T("StructTree MAX_DEPTH reached."),null;if(!(b instanceof ca))return null;if(d.has(b))return d.get(b);\nvar g=new Dt(this,b);d.set(b,g);var f=b.get("P");if(!f||Lb(f.get("Type"),"StructTreeRoot"))return this.addTopLevelNode(b,g)||d.delete(b),g;f=this.addNode(f,d,e+1);if(!f)return g;e=!1;f=u.makeIterator(f.kids);for(var h=f.next();!h.done;h=f.next())h=h.value,5===h.type&&h.dict===b&&(h.parentNode=g,e=!0);e||d.delete(b);return g};c.addTopLevelNode=function(b,d){var e=this.rootDict.get("K");if(!e)return!1;if(e instanceof ca){if(e.objId!==b.objId)return!1;this.nodes[0]=d;return!0}if(!Array.isArray(e))return!0;\nfor(var g=!1,f=0;f<e.length;f++){var h=e[f];(null==h?void 0:h.toString())===b.objId&&(this.nodes[f]=d,g=!0)}return g};return im(a,[{key:"serializable",get:function(){function b(f,h,k){void 0===k&&(k=0);if(40<k)T("StructTree too deep to be fully serialized.");else{var l=Object.create(null);l.role=f.role;l.children=[];h.children.push(l);h=f.dict.get("Alt");"string"!==typeof h&&(h=f.dict.get("ActualText"));"string"===typeof h&&(l.alt=ib(h));h=f.dict.get("A");if(h instanceof ca){var m=sd(h.getArray("BBox"),\nnull);m?l.bbox=m:(m=h.get("Width"),h=h.get("Height"),"number"===typeof m&&0<m&&"number"===typeof h&&0<h&&(l.bbox=[0,0,m,h]))}h=f.dict.get("Lang");"string"===typeof h&&(l.lang=ib(h));f=u.makeIterator(f.kids);for(h=f.next();!h.done;h=f.next())h=h.value,(m=5===h.type?h.parentNode:null)?b(m,l,k+1):1===h.type||2===h.type?l.children.push({type:"content",id:"p"+h.pageObjId+"_mc"+h.mcid}):3===h.type?l.children.push({type:"object",id:h.refObjId}):4===h.type&&l.children.push({type:"annotation",id:"pdfjs_internal_id_"+\nh.refObjId})}}var d=Object.create(null);d.children=[];d.role="Root";for(var e=u.makeIterator(this.nodes),g=e.next();!g.done;g=e.next())(g=g.value)&&b(g,d);return d}}])}(),Cj=function(){function a(b,d){this.pdfManager=b;this.xref=d;this._catDict=d.getCatalogObj();if(!(this._catDict instanceof ca))throw new oa("Catalog object is not a dictionary.");this.toplevelPagesDict;this._actualNumPages=null;this.fontCache=new Pc;this.builtInCMapCache=new Map;this.standardFontDataCache=new Map;this.globalImageCache=\nnew Og;this.pageKidsCountCache=new Pc;this.pageIndexCache=new Pc;this.pageDictCache=new Pc;this.nonBlendModesSet=new Zb;this.systemFontCache=new Map}var c=a.prototype;c.cloneDict=function(){return this._catDict.clone()};c._readMarkInfo=function(){var b=this._catDict.get("MarkInfo");if(!(b instanceof ca))return null;var d={Marked:!1,UserProperties:!1,Suspects:!1},e;for(e in d){var g=b.get(e);"boolean"===typeof g&&(d[e]=g)}return d};c._readStructTreeRoot=function(){var b=this._catDict.getRaw("StructTreeRoot"),\nd=this.xref.fetchIfRef(b);if(!(d instanceof ca))return null;b=new Bj(d,b);b.init();return b};c._readDocumentOutline=function(){var b=this._catDict.get("Outlines");if(!(b instanceof ca))return null;b=b.getRaw("First");if(!(b instanceof Ha))return null;var d={items:[]},e=[{obj:b,parent:d}],g=new Zb;g.put(b);for(var f=this.xref,h=new Uint8ClampedArray(3);0<e.length;){var k=e.shift(),l=f.fetchIfRef(k.obj);if(null!==l){l.has("Title")||T("Invalid outline item encountered.");b={url:null,dest:null,action:null};\na.parseDestDictionary({destDict:l,resultObj:b,docBaseUrl:this.baseUrl,docAttachments:this.attachments});var m=l.get("Title"),n=l.get("F")||0,p=l.getArray("C"),q=l.get("Count"),r=h;!yc(p,3)||0===p[0]&&0===p[1]&&0===p[2]||(r=ab.singletons.rgb.getRgb(p,0));m={action:b.action,attachment:b.attachment,dest:b.dest,url:b.url,unsafeUrl:b.unsafeUrl,newWindow:b.newWindow,setOCGState:b.setOCGState,title:"string"===typeof m?ib(m):"",color:r,count:Number.isInteger(q)?q:void 0,bold:!!(n&2),italic:!!(n&1),items:[]};\nk.parent.items.push(m);b=l.getRaw("First");b instanceof Ha&&!g.has(b)&&(e.push({obj:b,parent:m}),g.put(b));b=l.getRaw("Next");b instanceof Ha&&!g.has(b)&&(e.push({obj:b,parent:k.parent}),g.put(b))}}return 0<d.items.length?d.items:null};c._readPermissions=function(){var b=this.xref.trailer.get("Encrypt");if(!(b instanceof ca))return null;b=b.get("P");if("number"!==typeof b)return null;b+=Math.pow(2,32);var d=[],e;for(e in rn){var g=rn[e];b&g&&d.push(g)}return d};c.__readOptionalContentGroup=function(b){var d=\nthis.xref.fetch(b);b={id:b.toString(),name:null,intent:null,usage:{print:null,view:null},rbGroups:[]};var e=d.get("Name");"string"===typeof e&&(b.name=ib(e));e=d.getArray("Intent");Array.isArray(e)||(e=[e]);e.every(function(f){return f instanceof ka})&&(b.intent=e.map(function(f){return f.name}));e=d.get("Usage");if(!(e instanceof ca))return b;d=b.usage;var g=e.get("Print");if(g instanceof ca&&(g=g.get("PrintState"),g instanceof ka))switch(g.name){case "ON":case "OFF":d.print={printState:g.name}}e=\ne.get("View");if(e instanceof ca&&(e=e.get("ViewState"),e instanceof ka))switch(e.name){case "ON":case "OFF":d.view={viewState:e.name}}return b};c.__readOptionalContentConfig=function(b,d){function e(l){var m=[];if(Array.isArray(l)){l=u.makeIterator(l);for(var n=l.next();!n.done;n=l.next())n=n.value,n instanceof Ha&&d.has(n)&&m.push(n.toString())}return m}function g(l,m){void 0===m&&(m=0);if(!Array.isArray(l))return null;var n=[];l=u.makeIterator(l);for(var p=l.next();!p.done;p=l.next())p=p.value,\np instanceof Ha&&d.has(p)?(k.put(p),n.push(p.toString())):(p=f(p,m))&&n.push(p);if(0<m)return n;m=[];l=u.makeIterator(d.items());for(p=l.next();!p.done;p=l.next())p=u.makeIterator(p.value).next().value,k.has(p)||m.push(p.toString());m.length&&n.push({name:null,order:m});return n}function f(l,m){if(10<++m)return T("parseNestedOrder - reached MAX_NESTED_LEVELS."),null;var n=h.fetchIfRef(l);if(!Array.isArray(n))return null;l=h.fetchIfRef(n[0]);return"string"!==typeof l?null:(m=g(n.slice(1),m))&&m.length?\n{name:ib(l),order:m}:null}var h=this.xref,k=new Zb;(function(l){if(Array.isArray(l)){l=u.makeIterator(l);for(var m=l.next();!m.done;m=l.next()){var n=h.fetchIfRef(m.value);if(Array.isArray(n)&&n.length){m=new Set;n=u.makeIterator(n);for(var p=n.next();!p.done;p=n.next())p=p.value,p instanceof Ha&&d.has(p)&&!m.has(p.toString())&&(m.add(p.toString()),d.get(p).rbGroups.push(m))}}}})(b.get("RBGroups"));return{name:"string"===typeof b.get("Name")?ib(b.get("Name")):null,creator:"string"===typeof b.get("Creator")?\nib(b.get("Creator")):null,baseState:b.get("BaseState")instanceof ka?b.get("BaseState").name:null,on:e(b.get("ON")),off:e(b.get("OFF")),order:g(b.get("Order")),groups:[].concat(u.arrayFromIterable(d))}};c.setActualNumPages=function(b){void 0===b&&(b=null);this._actualNumPages=b};c.getDestination=function(b){var d=this._readDests();if(d instanceof Xe){if(d=tg(d.get(b)))return d;if(d=this.destinations[b])return T(\'Found "\'+b+\'" at an incorrect position in the NameTree.\'),d}else if(d instanceof ca&&(b=\ntg(d.get(b))))return b;return null};c._readDests=function(){var b=this._catDict.get("Names");if(null!=b&&b.has("Dests"))return new Xe(b.getRaw("Dests"),this.xref);if(this._catDict.has("Dests"))return this._catDict.get("Dests")};c._readPageLabels=function(){var b=this._catDict.getRaw("PageLabels");if(!b)return null;var d=Array(this.numPages),e=null,g="";b=(new Tg(b,this.xref)).getAll();for(var f,h=1,k=0,l=this.numPages;k<l;k++){f=b.get(k);if(void 0!==f){if(!(f instanceof ca))throw new oa("PageLabel is not a dictionary.");\nif(f.has("Type")&&!Lb(f.get("Type"),"PageLabel"))throw new oa("Invalid type in PageLabel dictionary.");if(f.has("S")){e=f.get("S");if(!(e instanceof ka))throw new oa("Invalid style in PageLabel dictionary.");e=e.name}else e=null;if(f.has("P")){g=f.get("P");if("string"!==typeof g)throw new oa("Invalid prefix in PageLabel dictionary.");g=ib(g)}else g="";if(f.has("St")){if(h=f.get("St"),!(Number.isInteger(h)&&1<=h))throw new oa("Invalid start in PageLabel dictionary.");}else h=1}switch(e){case "D":f=\nh;break;case "R":case "r":var m=h;f="r"===e;void 0===f&&(f=!1);xc(Number.isInteger(m)&&0<m,"The number should be a positive integer.");for(var n=[];1E3<=m;)m-=1E3,n.push("M");var p=m/100|0;m%=100;n.push(ij[p]);p=m/10|0;m%=10;n.push(ij[10+p]);n.push(ij[20+m]);p=n.join("");f=f?p.toLowerCase():p;break;case "A":case "a":f=h-1;f=String.fromCharCode(("a"===e?97:65)+f%26).repeat(Math.floor(f/26)+1);break;default:if(e)throw new oa(\'Invalid style "\'+e+\'" in PageLabel dictionary.\');f=""}d[k]=g+f;h++}return d};\nc._collectJavaScript=function(){function b(h,k){if(k instanceof ca&&Lb(k.get("S"),"JavaScript")){k=k.get("JS");if(k instanceof $a)k=k.getString();else if("string"!==typeof k)return;(k=ib(k).replaceAll("\\x00",""))&&(e||(e=new Map)).set(h,k)}}var d=this._catDict.get("Names"),e=null;if(d instanceof ca&&d.has("JavaScript")){d=new Xe(d.getRaw("JavaScript"),this.xref);d=u.makeIterator(d.getAll());for(var g=d.next();!g.done;g=d.next()){var f=u.makeIterator(g.value);g=f.next().value;f=f.next().value;b(ib(g),\nf)}}(d=this._catDict.get("OpenAction"))&&b("OpenAction",d);return e};c.fontFallback=function(){var b=sg(function f(e,g){var h=this,k,l,m,n;return u.generator.createGenerator(f,function(p){if(1==p.nextAddress)return p.yield(Promise.all(h.fontCache),2);k=p.yieldResult;l=u.makeIterator(k);for(m=l.next();!m.done;m=l.next())if(n=m.value,n.loadedName===e)return n.fallback(g),p.return();p.jumpToEnd()})});return function(e,g){return b.apply(this,arguments)}}();c.cleanup=function(){var b=sg(function g(e){var f=\nthis,h,k,l,m,n,p;return u.generator.createGenerator(g,function(q){if(1==q.nextAddress)return void 0===e&&(e=!1),qi(),f.globalImageCache.clear(e),f.pageKidsCountCache.clear(),f.pageIndexCache.clear(),f.pageDictCache.clear(),f.nonBlendModesSet.clear(),q.yield(Promise.all(f.fontCache),2);h=q.yieldResult;k=u.makeIterator(h);for(l=k.next();!l.done;l=k.next())n=m=l.value,p=n.dict,delete p.cacheKey;f.fontCache.clear();f.builtInCMapCache.clear();f.standardFontDataCache.clear();f.systemFontCache.clear();q.jumpToEnd()})});\nreturn function(e){return b.apply(this,arguments)}}();c.getPageDict=function(){var b=sg(function g(e){var f=this,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E;return u.generator.createGenerator(g,function(G){switch(G.nextAddress){case 1:h=[f.toplevelPagesDict],k=new Zb,l=f._catDict.getRaw("Pages"),l instanceof Ha&&k.put(l),m=f.xref,n=f.pageKidsCountCache,p=f.pageIndexCache,q=f.pageDictCache,r=0;case 2:if(!h.length){G.jumpTo(4);break}t=h.pop();if(!(t instanceof Ha)){G.jumpTo(5);break}v=n.get(t);if(0<=v&&r+\nv<=e){r+=v;G.jumpTo(2);break}if(k.has(t))throw new oa("Pages tree contains circular reference.");k.put(t);return G.yield(q.get(t)||m.fetchAsync(t),6);case 6:w=G.yieldResult;if(!(w instanceof ca)){G.jumpTo(7);break}y=w.getRaw("Type");if(!(y instanceof Ha)){G.jumpTo(8);break}return G.yield(m.fetchAsync(y),9);case 9:y=G.yieldResult;case 8:if(Lb(y,"Page")||!w.has("Kids")){n.has(t)||n.put(t,1);p.has(t)||p.put(t,r);if(r===e)return G.return([w,t]);r++;G.jumpTo(2);break}case 7:h.push(w);G.jumpTo(2);break;\ncase 5:if(!(t instanceof ca))throw new oa("Page dictionary kid reference points to wrong type of object.");x=t;z=x.objId;A=t.getRaw("Count");if(!(A instanceof Ha)){G.jumpTo(10);break}return G.yield(m.fetchAsync(A),11);case 11:A=G.yieldResult;case 10:if(Number.isInteger(A)&&0<=A&&(z&&!n.has(z)&&n.put(z,A),r+A<=e)){r+=A;G.jumpTo(2);break}B=t.getRaw("Kids");if(!(B instanceof Ha)){G.jumpTo(12);break}return G.yield(m.fetchAsync(B),13);case 13:B=G.yieldResult;case 12:if(Array.isArray(B)){G.jumpTo(14);break}C=\nt.getRaw("Type");if(!(C instanceof Ha)){G.jumpTo(15);break}return G.yield(m.fetchAsync(C),16);case 16:C=G.yieldResult;case 15:if(Lb(C,"Page")||!t.has("Kids")){if(r===e)return G.return([t,null]);r++;G.jumpTo(2);break}throw new oa("Page dictionary kids object is not an array.");case 14:for(D=B.length-1;0<=D;D--)E=B[D],h.push(E),t===f.toplevelPagesDict&&E instanceof Ha&&!q.has(E)&&q.put(E,m.fetchAsync(E));G.jumpTo(2);break;case 4:throw Error("Page index "+e+" not found.");}})});return function(e){return b.apply(this,\narguments)}}();c.getAllPageDicts=function(){var b=sg(function g(e){function f(F){if(F instanceof Ud&&!e)throw F;e&&l&&0===v&&(T(\'getAllPageDicts - Skipping invalid first page: "\'+F+\'".\'),F=ca.empty);q.set(v++,[F,null])}var h=this,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J;return u.generator.createGenerator(g,function(F){switch(F.nextAddress){case 1:void 0===e&&(e=!1),k=h.pdfManager.evaluatorOptions,l=k.ignoreErrors,m=[{currentNode:h.toplevelPagesDict,posInKids:0}],n=new Zb,p=h._catDict.getRaw("Pages"),\np instanceof Ha&&n.put(p),q=new Map,r=h.xref,t=h.pageIndexCache,v=0;case 2:if(!(0<m.length)){F.jumpTo(4);break}y=w=m.at(-1);x=y.currentNode;z=y.posInKids;A=x.getRaw("Kids");if(!(A instanceof Ha)){F.jumpTo(5);break}F.setCatchFinallyBlocks(6);return F.yield(r.fetchAsync(A),8);case 8:A=F.yieldResult;F.leaveTryBlock(5);break;case 6:B=F.enterCatchBlock();f(B);F.jumpTo(4);break;case 5:if(!Array.isArray(A)){f(new oa("Page dictionary kids object is not an array."));F.jumpTo(4);break}if(z>=A.length){m.pop();\nF.jumpTo(2);break}C=A[z];D=void 0;if(!(C instanceof Ha)){D=C;F.jumpTo(9);break}if(n.has(C)){f(new oa("Pages tree contains circular reference."));F.jumpTo(4);break}n.put(C);F.setCatchFinallyBlocks(10);return F.yield(r.fetchAsync(C),12);case 12:D=F.yieldResult;F.leaveTryBlock(9);break;case 10:E=F.enterCatchBlock();f(E);F.jumpTo(4);break;case 9:if(!(D instanceof ca)){f(new oa("Page dictionary kid reference points to wrong type of object."));F.jumpTo(4);break}G=D.getRaw("Type");if(!(G instanceof Ha)){F.jumpTo(13);\nbreak}F.setCatchFinallyBlocks(14);return F.yield(r.fetchAsync(G),16);case 16:G=F.yieldResult;F.leaveTryBlock(13);break;case 14:J=F.enterCatchBlock();f(J);F.jumpTo(4);break;case 13:if(Lb(G,"Page")||!D.has("Kids")){var L=D,M=C instanceof Ha?C:null;M&&!t.has(M)&&t.put(M,v);q.set(v++,[L,M])}else m.push({currentNode:D,posInKids:0});w.posInKids++;F.jumpTo(2);break;case 4:return F.return(q)}})});return function(e){return b.apply(this,arguments)}}();c.getPageIndex=function(b){function d(l){return e(l).then(function(m){if(!m)return g.pageIndexCache.put(b,\nk),k;var n=u.makeIterator(m);m=n.next().value;n=n.next().value;k+=m;return d(n)})}function e(l){var m=0,n;return h.fetchAsync(l).then(function(p){if(Yf(l,b)&&!ik(p,"Page")&&!(p instanceof ca&&!p.has("Type")&&p.has("Contents")))throw new oa("The reference does not point to a /Page dictionary.");if(!p)return null;if(!(p instanceof ca))throw new oa("Node must be a dictionary.");n=p.getRaw("Parent");return p.getAsync("Parent")}).then(function(p){if(!p)return null;if(!(p instanceof ca))throw new oa("Parent must be a dictionary.");\nreturn p.getAsync("Kids")}).then(function(p){if(!p)return null;var q=[],r=!1;p=u.makeIterator(p);for(var t=p.next();!t.done;t=p.next()){t=t.value;if(!(t instanceof Ha))throw new oa("Kid must be a reference.");if(Yf(t,l)){r=!0;break}q.push(h.fetchAsync(t).then(function(v){if(!(v instanceof ca))throw new oa("Kid node must be a dictionary.");v.has("Count")?m+=v.get("Count"):m++}))}if(!r)throw new oa("Kid reference not found in parent\'s kids.");return Promise.all(q).then(function(){return[m,n]})})}var g=\nthis,f=this.pageIndexCache.get(b);if(void 0!==f)return Promise.resolve(f);var h=this.xref,k=0;return d(b)};a.parseDestDictionary=function(b){var d=b.destDict,e=b.resultObj,g=void 0===b.docBaseUrl?null:b.docBaseUrl,f=void 0===b.docAttachments?null:b.docAttachments;if(d instanceof ca){b=d.get("A");b instanceof ca||(d.has("Dest")?b=d.get("Dest"):(b=d.get("AA"),b instanceof ca&&(b.has("D")?b=b.get("D"):b.has("U")&&(b=b.get("U")))));if(b instanceof ca){d=b.get("S");if(!(d instanceof ka)){T("parseDestDictionary: Invalid type in Action dictionary.");\nreturn}d=d.name;switch(d){case "ResetForm":var h=b.get("Flags");h=0===(("number"===typeof h?h:0)&1);f=[];var k=[];b=u.makeIterator(b.get("Fields")||[]);for(d=b.next();!d.done;d=b.next())d=d.value,d instanceof Ha?k.push(d.toString()):"string"===typeof d&&f.push(ib(d));e.resetForm={fields:f,refs:k,include:h};break;case "URI":var l=b.get("URI");l instanceof ka&&(l="/"+l.name);break;case "GoTo":var m=b.get("D");break;case "Launch":case "GoToR":h=b.get("F");h instanceof ca?l=(new zj(h,null,!0)).serializable.rawFilename:\n"string"===typeof h&&(l=h);(h=mm(b))&&"string"===typeof l&&(l=l.split("#",1)[0]+"#"+h);b=b.get("NewWindow");"boolean"===typeof b&&(e.newWindow=b);break;case "GoToE":d=b.get("T");f&&d instanceof ca&&(k=d.get("R"),d=d.get("N"),Lb(k,"C")&&"string"===typeof d&&(h=f[ib(d)]));if(h){if(e.attachment=h,b=mm(b))e.attachmentDest=b}else T(\'parseDestDictionary - unimplemented "GoToE" action.\');break;case "Named":b=b.get("N");b instanceof ka&&(e.action=b.name);break;case "SetOCGState":h=b.get("State");b=b.get("PreserveRB");\nif(!Array.isArray(h)||0===h.length)break;f=[];k=u.makeIterator(h);for(d=k.next();!d.done;d=k.next())if(d=d.value,d instanceof ka)switch(d.name){case "ON":case "OFF":case "Toggle":f.push(d.name)}else d instanceof Ha&&f.push(d.toString());if(f.length!==h.length)break;e.setOCGState={state:f,preserveRB:"boolean"===typeof b?b:!0};break;case "JavaScript":if(b=b.get("JS"),b instanceof $a?k=b.getString():"string"===typeof b&&(k=b),b=k&&ok(ib(k))){l=b.url;e.newWindow=b.newWindow;break}default:"JavaScript"!==\nd&&"SubmitForm"!==d&&T(\'parseDestDictionary - unsupported action: "\'+d+\'".\')}}else d.has("Dest")&&(m=d.get("Dest"));if("string"===typeof l){if(g=Xf(l,g,{addDefaultProtocol:!0,tryConvertEncoding:!0}))e.url=g.href;e.unsafeUrl=l}m&&(m instanceof ka&&(m=m.name),"string"===typeof m?e.dest=ib(m):Fi(m)&&(e.dest=m))}else T("parseDestDictionary: `destDict` must be a dictionary.")};return Hq(a,[{key:"version",get:function(){var b=this._catDict.get("Version");if(b instanceof ka){if(tn.test(b.name))return Fa(this,\n"version",b.name);T("Invalid PDF catalog version: "+b.name)}return Fa(this,"version",null)}},{key:"lang",get:function(){var b=this._catDict.get("Lang");return Fa(this,"lang",b&&"string"===typeof b?ib(b):null)}},{key:"needsRendering",get:function(){var b=this._catDict.get("NeedsRendering");return Fa(this,"needsRendering","boolean"===typeof b?b:!1)}},{key:"collection",get:function(){var b=null;try{var d=this._catDict.get("Collection");d instanceof ca&&0<d.size&&(b=d)}catch(e){if(e instanceof ub)throw e;\nYa("Cannot fetch Collection entry; assuming no collection is present.")}return Fa(this,"collection",b)}},{key:"acroForm",get:function(){var b=null;try{var d=this._catDict.get("AcroForm");d instanceof ca&&0<d.size&&(b=d)}catch(e){if(e instanceof ub)throw e;Ya("Cannot fetch AcroForm entry; assuming no forms are present.")}return Fa(this,"acroForm",b)}},{key:"acroFormRef",get:function(){var b=this._catDict.getRaw("AcroForm");return Fa(this,"acroFormRef",b instanceof Ha?b:null)}},{key:"metadata",get:function(){var b=\nthis._catDict.getRaw("Metadata");if(!(b instanceof Ha))return Fa(this,"metadata",null);var d=null;try{var e,g=this.xref.fetch(b,!(null!=(e=this.xref.encrypt)&&e.encryptMetadata));if(g instanceof $a&&g.dict instanceof ca){var f=g.dict.get("Type"),h=g.dict.get("Subtype");if(Lb(f,"Metadata")&&Lb(h,"XML")){var k=decodeURIComponent(escape(g.getString()));k&&(d=(new yt(k)).serializable)}}}catch(l){if(l instanceof ub)throw l;Ya(\'Skipping invalid Metadata: "\'+l+\'".\')}return Fa(this,"metadata",d)}},{key:"markInfo",\nget:function(){var b=null;try{b=this._readMarkInfo()}catch(d){if(d instanceof ub)throw d;T("Unable to read mark info.")}return Fa(this,"markInfo",b)}},{key:"structTreeRoot",get:function(){var b=null;try{b=this._readStructTreeRoot()}catch(d){if(d instanceof ub)throw d;T("Unable read to structTreeRoot info.")}return Fa(this,"structTreeRoot",b)}},{key:"toplevelPagesDict",get:function(){var b=this._catDict.get("Pages");if(!(b instanceof ca))throw new oa("Invalid top-level pages dictionary.");return Fa(this,\n"toplevelPagesDict",b)}},{key:"documentOutline",get:function(){var b=null;try{b=this._readDocumentOutline()}catch(d){if(d instanceof ub)throw d;T("Unable to read document outline.")}return Fa(this,"documentOutline",b)}},{key:"permissions",get:function(){var b=null;try{b=this._readPermissions()}catch(d){if(d instanceof ub)throw d;T("Unable to read permissions.")}return Fa(this,"permissions",b)}},{key:"optionalContentConfig",get:function(){var b=null;try{var d=this._catDict.get("OCProperties");if(!d)return Fa(this,\n"optionalContentConfig",null);var e=d.get("D");if(!e)return Fa(this,"optionalContentConfig",null);var g=d.get("OCGs");if(!Array.isArray(g))return Fa(this,"optionalContentConfig",null);for(var f=new Pc,h=u.makeIterator(g),k=h.next();!k.done;k=h.next()){var l=k.value;l instanceof Ha&&!f.has(l)&&f.put(l,this.__readOptionalContentGroup(l))}b=this.__readOptionalContentConfig(e,f)}catch(m){if(m instanceof ub)throw m;T("Unable to read optional content config: "+m)}return Fa(this,"optionalContentConfig",\nb)}},{key:"hasActualNumPages",get:function(){return null!==this._actualNumPages}},{key:"_pagesCount",get:function(){var b=this.toplevelPagesDict.get("Count");if(!Number.isInteger(b))throw new oa("Page count in top-level pages dictionary is not an integer.");return Fa(this,"_pagesCount",b)}},{key:"numPages",get:function(){return this.hasActualNumPages?this._actualNumPages:this._pagesCount}},{key:"destinations",get:function(){var b=this._readDests(),d=Object.create(null);if(b instanceof Xe){b=u.makeIterator(b.getAll());\nfor(var e=b.next();!e.done;e=b.next()){var g=u.makeIterator(e.value);e=g.next().value;g=g.next().value;(g=tg(g))&&(d[ib(e)]=g)}}else b instanceof ca&&b.forEach(function(f,h){(h=tg(h))&&(d[f]=h)});return Fa(this,"destinations",d)}},{key:"pageLabels",get:function(){var b=null;try{b=this._readPageLabels()}catch(d){if(d instanceof ub)throw d;T("Unable to read page labels.")}return Fa(this,"pageLabels",b)}},{key:"pageLayout",get:function(){var b=this._catDict.get("PageLayout"),d="";if(b instanceof ka)switch(b.name){case "SinglePage":case "OneColumn":case "TwoColumnLeft":case "TwoColumnRight":case "TwoPageLeft":case "TwoPageRight":d=\nb.name}return Fa(this,"pageLayout",d)}},{key:"pageMode",get:function(){var b=this._catDict.get("PageMode"),d="UseNone";if(b instanceof ka)switch(b.name){case "UseNone":case "UseOutlines":case "UseThumbs":case "FullScreen":case "UseOC":case "UseAttachments":d=b.name}return Fa(this,"pageMode",d)}},{key:"viewerPreferences",get:function(){var b=this,d=this._catDict.get("ViewerPreferences");if(!(d instanceof ca))return Fa(this,"viewerPreferences",null);for(var e=null,g=u.makeIterator(d.getKeys()),f=g.next();!f.done;f=\ng.next()){f=f.value;var h=d.get(f),k=void 0;switch(f){case "HideToolbar":case "HideMenubar":case "HideWindowUI":case "FitWindow":case "CenterWindow":case "DisplayDocTitle":case "PickTrayByPDFSize":"boolean"===typeof h&&(k=h);break;case "NonFullScreenPageMode":if(h instanceof ka)switch(h.name){case "UseNone":case "UseOutlines":case "UseThumbs":case "UseOC":k=h.name;break;default:k="UseNone"}break;case "Direction":if(h instanceof ka)switch(h.name){case "L2R":case "R2L":k=h.name;break;default:k="L2R"}break;\ncase "ViewArea":case "ViewClip":case "PrintArea":case "PrintClip":if(h instanceof ka)switch(h.name){case "MediaBox":case "CropBox":case "BleedBox":case "TrimBox":case "ArtBox":k=h.name;break;default:k="CropBox"}break;case "PrintScaling":if(h instanceof ka)switch(h.name){case "None":case "AppDefault":k=h.name;break;default:k="AppDefault"}break;case "Duplex":if(h instanceof ka)switch(h.name){case "Simplex":case "DuplexFlipShortEdge":case "DuplexFlipLongEdge":k=h.name;break;default:k="None"}break;case "PrintPageRange":Array.isArray(h)&&\n0===h.length%2&&h.every(function(l,m,n){return Number.isInteger(l)&&0<l&&(0===m||l>=n[m-1])&&l<=b.numPages})&&(k=h);break;case "NumCopies":Number.isInteger(h)&&0<h&&(k=h);break;default:T("Ignoring non-standard key in ViewerPreferences: "+f+".");continue}void 0===k?T(\'Bad value, for key "\'+f+\'", in ViewerPreferences: \'+h+"."):(e||(e=Object.create(null)),e[f]=k)}return Fa(this,"viewerPreferences",e)}},{key:"openAction",get:function(){var b=this._catDict.get("OpenAction"),d=Object.create(null);if(b instanceof\nca){var e=new ca(this.xref);e.set("A",b);b={url:null,dest:null,action:null};a.parseDestDictionary({destDict:e,resultObj:b});Array.isArray(b.dest)?d.dest=b.dest:b.action&&(d.action=b.action)}else Array.isArray(b)&&(d.dest=b);return Fa(this,"openAction",0<Object.keys(d).length?d:null)}},{key:"attachments",get:function(){var b=this._catDict.get("Names"),d=null;if(b instanceof ca&&b.has("EmbeddedFiles")){b=new Xe(b.getRaw("EmbeddedFiles"),this.xref);b=u.makeIterator(b.getAll());for(var e=b.next();!e.done;e=\nb.next()){var g=u.makeIterator(e.value);e=g.next().value;g=g.next().value;g=new zj(g,this.xref);d||(d=Object.create(null));d[ib(e)]=g.serializable}}return Fa(this,"attachments",d)}},{key:"xfaImages",get:function(){var b=this._catDict.get("Names"),d=null;if(b instanceof ca&&b.has("XFAImages")){b=new Xe(b.getRaw("XFAImages"),this.xref);b=u.makeIterator(b.getAll());for(var e=b.next();!e.done;e=b.next()){var g=u.makeIterator(e.value);e=g.next().value;g=g.next().value;d||(d=new ca(this.xref));d.set(ib(e),\ng)}}return Fa(this,"xfaImages",d)}},{key:"jsActions",get:function(){var b=this._collectJavaScript(),d=ag(this.xref,this._catDict,gr);if(b){d||(d=Object.create(null));b=u.makeIterator(b);for(var e=b.next();!e.done;e=b.next()){var g=u.makeIterator(e.value);e=g.next().value;g=g.next().value;e in d?d[e].push(g):d[e]=[g]}}return Fa(this,"jsActions",d)}},{key:"baseUrl",get:function(){var b=this._catDict.get("URI");return b instanceof ca&&(b=b.get("Base"),"string"===typeof b&&(b=Xf(b,null,{tryConvertEncoding:!0})))?\nFa(this,"baseUrl",b.href):Fa(this,"baseUrl",this.pdfManager.docBaseUrl)}}])}(),Ug=function(){function a(b,d,e){this.dict=b;this.keys=d;this.xref=e;this.refSet=null}var c=a.prototype;c.load=function(){var b=om(function e(){var g=this,f,h,k,l,m,n,p,q;return u.generator.createGenerator(e,function(r){if(g.xref.stream.isDataLoaded)return r.return(void 0);f=g;h=f.keys;k=f.dict;g.refSet=new Zb;l=[];m=u.makeIterator(h);for(n=m.next();!n.done;n=m.next())p=n.value,q=k.getRaw(p),void 0!==q&&l.push(q);return r.return(g._walk(l))})});\nreturn function(){return b.apply(this,arguments)}}();c._walk=function(){var b=om(function g(e){var f,h,k,l=this,m,n,p,q,r,t,v,w,y,x;return u.generator.createGenerator(g,function(z){if(1==z.nextAddress){f=[];for(h=[];e.length;){k=e.pop();if(k instanceof Ha){if(l.refSet.has(k))continue;try{l.refSet.put(k),k=l.xref.fetch(k)}catch(D){if(!(D instanceof ub))return T(\'ObjectLoader._walk - requesting all data: "\'+D+\'".\'),l.refSet=null,m=l.xref.stream,n=m.manager,z.return(n.requestAllChunks());f.push(k);h.push({begin:D.begin,\nend:D.end})}}if(k instanceof $a&&(p=k.getBaseStreams())){q=!1;r=u.makeIterator(p);for(t=r.next();!t.done;t=r.next())v=t.value,v.isDataLoaded||(q=!0,h.push({begin:v.start,end:v.end}));q&&f.push(k)}a:{var A=k,B=e;if(A instanceof ca)A=A.getRawValues();else if(A instanceof $a)A=A.dict.getRawValues();else if(!Array.isArray(A))break a;A=u.makeIterator(A);for(var C=A.next();!C.done;C=A.next())C=C.value,(C instanceof Ha||C instanceof ca||C instanceof $a||Array.isArray(C))&&B.push(C)}}return h.length?z.yield(l.xref.stream.manager.requestRanges(h),\n3):z.jumpTo(2)}if(2!=z.nextAddress){w=u.makeIterator(f);for(y=w.next();!y.done;y=w.next())x=y.value,x instanceof Ha&&l.refSet.remove(x);return z.return(l._walk(f))}l.refSet=null;return z.return(void 0)})});return function(e){return b.apply(this,arguments)}}();return a}(),Vg=Symbol(),te=Symbol(),Cb=Symbol(),Xd=Symbol(),dd=Symbol(),Ze=Symbol(),Wg=Symbol(),od=Symbol(),zd=Symbol(),ra=Symbol("content"),ed=Symbol("data"),$e=Symbol(),ja=Symbol("extra"),sb=Symbol(),qf=Symbol(),Dj=Symbol(),so=Symbol(),we=\nSymbol(),xg=Symbol(),pf=Symbol(),If=Symbol(),Ej=Symbol(),lc=Symbol(),Jf=Symbol(),ac=Symbol(),Le=Symbol(),Kd=Symbol(),Nb=Symbol(),Va=Symbol(),Ob=Symbol(),rb=Symbol(),Kf=Symbol(),af=Symbol(),Fj=Symbol(),Xg=Symbol(),Gj=Symbol(),xe=Symbol(),bf=Symbol(),Yd=Symbol(),Lf=Symbol(),Gd=Symbol(),Fd=Symbol(),Mf=Symbol(),Nf=Symbol(),Et=Symbol(),Pb=Symbol("namespaceId"),kb=Symbol("nodeName"),Zd=Symbol(),Ad=Symbol(),Hj=Symbol(),Ld=Symbol(),xd=Symbol(),Jc=Symbol(),cf=Symbol(),$d=Symbol(),to=Symbol("root"),Of=Symbol(),\nHd=Symbol(),Ij=Symbol(),uo=Symbol(),Gc=Symbol(),nd=Symbol(),Sb=Symbol(),vo=Symbol(),Ra=Symbol(),Pf=Symbol(),gb=Symbol(),mb=Symbol("uid"),pd=Symbol(),Qb={config:{id:0,check:function(a){return a.startsWith("http://www.xfa.org/schema/xci/")}},connectionSet:{id:1,check:function(a){return a.startsWith("http://www.xfa.org/schema/xfa-connection-set/")}},datasets:{id:2,check:function(a){return a.startsWith("http://www.xfa.org/schema/xfa-data/")}},form:{id:3,check:function(a){return a.startsWith("http://www.xfa.org/schema/xfa-form/")}},\nlocaleSet:{id:4,check:function(a){return a.startsWith("http://www.xfa.org/schema/xfa-locale-set/")}},pdf:{id:5,check:function(a){return"http://ns.adobe.com/xdp/pdf/"===a}},signature:{id:6,check:function(a){return"http://www.w3.org/2000/09/xmldsig#"===a}},sourceSet:{id:7,check:function(a){return a.startsWith("http://www.xfa.org/schema/xfa-source-set/")}},stylesheet:{id:8,check:function(a){return"http://www.w3.org/1999/XSL/Transform"===a}},template:{id:9,check:function(a){return a.startsWith("http://www.xfa.org/schema/xfa-template/")}},\nxdc:{id:10,check:function(a){return a.startsWith("http://www.xfa.org/schema/xdc/")}},xdp:{id:11,check:function(a){return"http://ns.adobe.com/xdp/"===a}},xfdf:{id:12,check:function(a){return"http://ns.adobe.com/xfdf/"===a}},xhtml:{id:13,check:function(a){return"http://www.w3.org/1999/xhtml"===a}},xmpmeta:{id:14,check:function(a){return"http://ns.adobe.com/xmpmeta/"===a}}},Kq={pt:function(a){return a},cm:function(a){return a/2.54*72},mm:function(a){return a/25.4*72},in:function(a){return 72*a},px:function(a){return a}},\nJq=/([+-]?\\d+\\.?\\d*)(.*)/,Pa=function(){function a(c,b,d,e){this.success=c;this.html=b;this.bbox=d;this.breakNode=e}a.prototype.isBreak=function(){return!!this.breakNode};a.breakNode=function(c){return new a(!1,null,null,c)};a.success=function(c,b){void 0===b&&(b=null);return new a(!0,c,b,null)};return Iq(a,null,[{key:"FAILURE",get:function(){return Fa(this,"FAILURE",new a(!1,null,null,null))}},{key:"EMPTY",get:function(){return Fa(this,"EMPTY",new a(!0,null,null,null))}}])}(),Ft=function(){function a(b){this.fonts=\nnew Map;this.cache=new Map;this.warned=new Set;this.defaultFont=null;this.add(b)}var c=a.prototype;c.add=function(b,d){void 0===d&&(d=null);b=u.makeIterator(b);for(var e=b.next();!e.done;e=b.next())this.addPdfFont(e.value);b=u.makeIterator(this.fonts.values());for(e=b.next();!e.done;e=b.next())e=e.value,e.regular||(e.regular=e.italic||e.bold||e.bolditalic);if(d&&0!==d.size)for(b=this.fonts.get("PdfJS-Fallback-PdfJS-XFA"),d=u.makeIterator(d),e=d.next();!e.done;e=d.next())this.fonts.set(e.value,b)};\nc.addPdfFont=function(b){var d=b.cssFontInfo,e=d.fontFamily,g=this.fonts.get(e);g||(g=Object.create(null),this.fonts.set(e,g),this.defaultFont||(this.defaultFont=g));e="";var f=parseFloat(d.fontWeight);0!==parseFloat(d.italicAngle)?e=700<=f?"bolditalic":"italic":700<=f&&(e="bold");if(!e){var h,k,l;if(b.name.includes("Bold")||null!=(h=b.psName)&&h.includes("Bold"))e="bold";if(b.name.includes("Italic")||b.name.endsWith("It")||null!=(k=b.psName)&&k.includes("Italic")||null!=(l=b.psName)&&l.endsWith("It"))e+=\n"italic"}e||(e="regular");g[e]=b};c.getDefault=function(){return this.defaultFont};c.find=function(b,d){void 0===d&&(d=!0);var e=this.fonts.get(b)||this.cache.get(b);if(e)return e;var g=/,|-|_| |bolditalic|bold|italic|regular|it/gi,f=b.replaceAll(g,"");if(e=this.fonts.get(f))return this.cache.set(b,e),e;f=f.toLowerCase();e=[];for(var h=u.makeIterator(this.fonts.entries()),k=h.next();!k.done;k=h.next()){var l=u.makeIterator(k.value);k=l.next().value;l=l.next().value;k.replaceAll(g,"").toLowerCase().startsWith(f)&&\ne.push(l)}if(0===e.length)for(h=u.makeIterator(this.fonts.entries()),k=h.next();!k.done;k=h.next()){k=u.makeIterator(k.value);k.next();k=k.next().value;var m;null!=(m=k.regular.name)&&m.replaceAll(g,"").toLowerCase().startsWith(f)&&e.push(k)}if(0===e.length)for(f=f.replaceAll(/psmt|mt/gi,""),m=u.makeIterator(this.fonts.entries()),h=m.next();!h.done;h=m.next())k=u.makeIterator(h.value),h=k.next().value,k=k.next().value,h.replaceAll(g,"").toLowerCase().startsWith(f)&&e.push(k);if(0===e.length)for(m=\nu.makeIterator(this.fonts.values()),h=m.next();!h.done;h=m.next()){h=h.value;var n;null!=(n=h.regular.name)&&n.replaceAll(g,"").toLowerCase().startsWith(f)&&e.push(h)}if(1<=e.length)return 1!==e.length&&d&&T("XFA - Too many choices to guess the correct font: "+b),this.cache.set(b,e[0]),e[0];d&&!this.warned.has(b)&&(this.warned.add(b),T("XFA - Cannot find the font: "+b));return null};return a}(),wo=function(){function a(c,b,d,e){this.lineHeight=d;this.paraMargin=b||{top:0,bottom:0,left:0,right:0};\nc?(this.xfaFont={typeface:c.typeface,posture:c.posture,weight:c.weight,size:c.size,letterSpacing:c.letterSpacing},(b=e.find(c.typeface))?(this.pdfFont=Gi(c,b),this.pdfFont||(c=u.makeIterator(this.defaultFont(e)),this.pdfFont=c.next().value,this.xfaFont=c.next().value)):(c=u.makeIterator(this.defaultFont(e)),this.pdfFont=c.next().value,this.xfaFont=c.next().value)):(c=u.makeIterator(this.defaultFont(e)),this.pdfFont=c.next().value,this.xfaFont=c.next().value)}a.prototype.defaultFont=function(c){c=\nc.find("Helvetica",!1)||c.find("Myriad Pro",!1)||c.find("Arial",!1)||c.getDefault();return null!=c&&c.regular?(c=c.regular,[c,{typeface:c.cssFontInfo.fontFamily,posture:"normal",weight:"normal",size:10,letterSpacing:0}]):[null,{typeface:"Courier",posture:"normal",weight:"normal",size:10,letterSpacing:0}]};return a}(),Gt=function(){function a(b,d,e,g){this.fontFinder=g;this.stack=[new wo(b,d,e,g)]}var c=a.prototype;c.pushData=function(b,d,e){for(var g=this.stack.at(-1),f=u.makeIterator(["typeface",\n"posture","weight","size","letterSpacing"]),h=f.next();!h.done;h=f.next())h=h.value,b[h]||(b[h]=g.xfaFont[h]);f=u.makeIterator(["top","bottom","left","right"]);for(h=f.next();!h.done;h=f.next())h=h.value,isNaN(d[h])&&(d[h]=g.paraMargin[h]);b=new wo(b,d,e||g.lineHeight,this.fontFinder);b.pdfFont||(b.pdfFont=g.pdfFont);this.stack.push(b)};c.popFont=function(){this.stack.pop()};c.topFont=function(){return this.stack.at(-1)};return a}(),Pq=function(){function a(b,d,e,g){this.glyphs=[];this.fontSelector=\nnew Gt(b,d,e,g);this.extraHeight=0}var c=a.prototype;c.pushData=function(b,d,e){this.fontSelector.pushData(b,d,e)};c.popFont=function(){return this.fontSelector.popFont()};c.addPara=function(){var b=this.fontSelector.topFont();this.extraHeight+=b.paraMargin.top+b.paraMargin.bottom};c.addString=function(b){if(b){var d=this.fontSelector.topFont(),e=d.xfaFont.size;if(d.pdfFont){var g=d.xfaFont.letterSpacing,f=d.pdfFont,h=f.lineHeight||1.2;d=d.lineHeight||Math.max(1.2,h)*e;h=Math.max(1,h-(void 0===f.lineGap?\n.2:f.lineGap))*e;e/=1E3;var k=f.defaultWidth||f.charsToGlyphs(" ")[0].width;b=u.makeIterator(b.split(/[\\u2029\\n]/));for(var l=b.next();!l.done;l=b.next()){l=f.encodeString(l.value).join("");l=f.charsToGlyphs(l);l=u.makeIterator(l);for(var m=l.next();!m.done;m=l.next())m=m.value,this.glyphs.push([(m.width||k)*e+g,d,h,m.unicode,!1]);this.glyphs.push([0,0,0,"\\n",!0])}}else for(g=u.makeIterator(b.split(/[\\u2029\\n]/)),f=g.next();!f.done;f=g.next()){f=u.makeIterator(f.value.split(""));for(d=f.next();!d.done;d=\nf.next())this.glyphs.push([e,1.2*e,e,d.value,!1]);this.glyphs.push([0,0,0,"\\n",!0])}this.glyphs.pop()}};c.compute=function(b){for(var d=-1,e=0,g=0,f=0,h=0,k=0,l=!1,m=!0,n=0,p=this.glyphs.length;n<p;n++){var q=u.makeIterator(this.glyphs[n]),r=q.next().value,t=q.next().value,v=q.next().value,w=q.next().value;q=q.next().value;w=" "===w;t=m?v:t;q?(g=Math.max(g,h),h=0,f+=k,k=t,d=-1,e=0,m=!1):w?h+r>b?(g=Math.max(g,h),h=0,f+=k,k=t,d=-1,e=0,l=!0,m=!1):(k=Math.max(t,k),e=h,h+=r,d=n):h+r>b?(f+=k,k=t,-1!==d?\n(n=d,g=Math.max(g,e),h=0,d=-1,e=0):(g=Math.max(g,h),h=r),l=!0,m=!1):(h+=r,k=Math.max(t,k))}g=Math.max(g,h);f+=k+this.extraHeight;return{width:1.02*g,height:f,isBroken:l}};return a}(),sm=/^[^.[]+/,Nq=/^[^\\]]+/,Nc={dot:0,dotDot:1,dotHash:2,dotBracket:3,dotParen:4},tm=new Map([["$data",function(a){return a.datasets?a.datasets.data:a}],["$record",function(a){return(a.datasets?a.datasets.data:a)[ac]()[0]}],["$template",function(a){return a.template}],["$connectionSet",function(a){return a.connectionSet}],\n["$form",function(a){return a.form}],["$layout",function(a){return a.layout}],["$host",function(a){return a.host}],["$dataWindow",function(a){return a.dataWindow}],["$event",function(a){return a.event}],["!",function(a){return a.datasets}],["$xfa",function(a){return a}],["xfa",function(a){return a}],["$",function(a,c){return c}]]),um=new WeakMap,Yg=Symbol(),ye=Symbol(),df=Symbol(),bb=Symbol("_children"),Jj=Symbol(),ae=Symbol(),Kj=Symbol(),xo=Symbol(),Lj=Symbol(),yo=Symbol(),Mj=Symbol(),Qf=Symbol(),\nZg=Symbol(),fd=Symbol("parent"),Rf=Symbol(),Sf=Symbol(),Nj=Symbol(),Oj=0,zo=Qb.datasets.id,na=function(){function a(b,d,e){void 0===e&&(e=!1);this[Pb]=b;this[kb]=d;this[Mj]=e;this[fd]=null;this[bb]=[];this[mb]=""+d+Oj++;this[rb]=null}var c=a.prototype;c.createNodes=function(b){var d=this,e=null;b=u.makeIterator(b);for(var g=b.next();!g.done;g=b.next()){var f=g.value;g=f.name;var h=f.index;f=0;for(h=isFinite(h)?h:0;f<=h;f++)e=new ze(d[Pb]===zo?-1:d[Pb],g),d[Cb](e);d=e}return e};c[Ad]=function(b){if(!this[Mj]||\n!this[Hj](b))return!1;var d=b[kb],e=this[d];if(e instanceof P){if(e.push(b))return this[Cb](b),!0}else{if(null!==e)this[$d](e);this[d]=b;this[Cb](b);return!0}b="";this.id?b=" (id: "+this.id+")":this.name&&(b=" (name: "+this.name+" "+this.h.value+")");T(\'XFA - node "\'+this[kb]+\'"\'+b+\' has already enough "\'+d+\'"!\');return!1};c[Hj]=function(b){return this.hasOwnProperty(b[kb])&&b[Pb]===this[Pb]};c[Lf]=function(){return!1};c[Vg]=function(){return!1};c[Gj]=function(){return!1};c[xe]=function(){return!1};\nc[Jc]=function(){this.para&&this[Ob]()[ja].paraStack.pop()};c[cf]=function(){this[Ob]()[ja].paraStack.push(this.para)};c[Ij]=function(b){this.id&&this[Pb]===Qb.template.id&&b.set(this.id,this)};c[Ob]=function(){return this[rb].template};c[Gd]=function(){return!1};c[Fd]=function(){return!1};c[Cb]=function(b){b[fd]=this;this[bb].push(b);!b[rb]&&this[rb]&&(b[rb]=this[rb])};c[$d]=function(b){b=this[bb].indexOf(b);this[bb].splice(b,1)};c[Kf]=function(){return this.hasOwnProperty("value")};c[Gc]=function(){};\nc[Ld]=function(){};c[sb]=function(){};c[dd]=function(b){delete this[Mj];this[Wg]&&(b.clean(this[Wg]),delete this[Wg])};c[Fj]=function(b){return this[bb].indexOf(b)};c[Xg]=function(b,d){d[fd]=this;this[bb].splice(b,0,d);!d[rb]&&this[rb]&&(d[rb]=this[rb])};c[Mf]=function(){return!this.name};c[Et]=function(){return""};c[Sb]=function(){return 0===this[bb].length?this[ra]:this[bb].map(function(b){return b[Sb]()}).join("")};c[Yd]=function(b){for(var d=this;d;){if(d===b)return!0;d=d[Va]()}return!1};c[Va]=\nfunction(){return this[fd]};c[Nb]=function(){return this[Va]()};c[ac]=function(b){void 0===b&&(b=null);return b?this[b]:this[bb]};c[$e]=function(){var b=Object.create(null);this[ra]&&(b.$content=this[ra]);for(var d=u.makeIterator(Object.getOwnPropertyNames(this)),e=d.next();!e.done;e=d.next()){e=e.value;var g=this[e];null!==g&&(g instanceof a?b[e]=g[$e]():g instanceof P?g.isEmpty()||(b[e]=g.dump()):b[e]=g)}return b};c[gb]=function(){return null};c[Ra]=function(){return Pa.EMPTY};c[Le]=function d(){var e=\nthis,g,f,h;return u.generator.createGenerator(d,function(k){1==k.nextAddress&&(g=u.makeIterator(e[ac]()),f=g.next());if(3!=k.nextAddress){if(f.done)return k.jumpTo(0);h=f.value;return k.yield(h,3)}f=g.next();return k.jumpTo(2)})};c[xo]=function f(e,g){var h=this,k,l,m,n,p;return u.generator.createGenerator(f,function(q){1==q.nextAddress&&(k=u.makeIterator(h[Le]()),l=k.next());if(3!=q.nextAddress){if(l.done)return q.jumpTo(0);m=l.value;if(e&&g!==e.has(m[kb]))return q.jumpTo(3);n=h[we]();p=m[Ra](n);\np.success||(h[ja].failingNode=m);return q.yield(p,3)}l=k.next();return q.jumpTo(2)})};c[qf]=function(){return null};c[te]=function(e){this[ja].children.push(e)};c[we]=function(){};c[Xd]=function(e){var g=void 0===e.filter?null:e.filter;e=void 0===e.include?!0:e.include;if(this[ja].generator){g=this[we]();g=this[ja].failingNode[Ra](g);if(!g.success)return g;if(g.html)this[te](g.html,g.bbox);delete this[ja].failingNode}else this[ja].generator=this[xo](g,e);for(;;){g=this[ja].generator.next();if(g.done)break;\ng=g.value;if(!g.success)return g;if(g.html)this[te](g.html,g.bbox)}this[ja].generator=null;return Pa.EMPTY};c[uo]=function(e){this[Sf]=new Set(Object.keys(e))};c[yo]=function(e){var g=this[df],f=this[Sf];return[].concat(u.arrayFromIterable(e)).filter(function(h){return g.has(h)&&!f.has(h)})};c[Of]=function(e,g){void 0===g&&(g=new Set);for(var f=u.makeIterator(this[bb]),h=f.next();!h.done;h=f.next())h.value[Rf](e,g)};c[Rf]=function(e,g){var f=this[Lj](e,g);if(f)this[Yg](f,e,g);else this[Of](e,g)};\nc[Lj]=function(e,g){var f=this.use,h=this.usehref;if(!f&&!h)return null;var k=null,l=null,m=f;h?(m=h,h.startsWith("#som(")&&h.endsWith(")")?k=h.slice(5,-1):h.startsWith(".#som(")&&h.endsWith(")")?k=h.slice(6,-1):h.startsWith("#")?l=h.slice(1):h.startsWith(".#")&&(l=h.slice(2))):f.startsWith("#")?l=f.slice(1):k=f;this.use=this.usehref="";l?f=e.get(l):(f=Rd(e.get(to),this,k,!0,!1))&&(f=f[0]);if(!f)return T("XFA - Invalid prototype reference: "+m+"."),null;if(f[kb]!==this[kb])return T("XFA - Incompatible prototype: "+\nf[kb]+" !== "+this[kb]+"."),null;if(g.has(f))return T("XFA - Cycle detected in prototypes use."),null;g.add(f);if(m=f[Lj](e,g))f[Yg](m,e,g);f[Of](e,g);g.delete(f);return f};c[Yg]=function(e,g,f){if(f.has(e))T("XFA - Cycle detected in prototypes use.");else{!this[ra]&&e[ra]&&(this[ra]=e[ra]);(new Set(f)).add(e);for(var h=u.makeIterator(this[yo](e[Sf])),k=h.next();!k.done;k=h.next())k=k.value,this[k]=e[k],this[Sf]&&this[Sf].add(k);h=u.makeIterator(Object.getOwnPropertyNames(this));for(k=h.next();!k.done;k=\nh.next()){var l=k.value;if(!this[df].has(l)){k=this[l];var m=e[l];if(k instanceof P){l=u.makeIterator(k[bb]);for(var n=l.next();!n.done;n=l.next())n.value[Rf](g,f);l=k[bb].length;for(m=m[bb].length;l<m;l++)if(n=e[bb][l][od](),k.push(n))n[fd]=this,this[bb].push(n),n[Rf](g,f);else break}else if(null!==k){if(k[Of](g,f),m)k[Yg](m,g,f)}else null!==m&&(k=m[od](),k[fd]=this,this[l]=k,this[bb].push(k),k[Rf](g,f))}}}};a[Jj]=function(e){return Array.isArray(e)?e.map(function(g){return a[Jj](g)}):"object"===\ntypeof e&&null!==e?Object.assign({},e):e};c[od]=function(){for(var e=Object.create(Object.getPrototypeOf(this)),g=u.makeIterator(Object.getOwnPropertySymbols(this)),f=g.next();!f.done;f=g.next()){f=f.value;try{e[f]=this[f]}catch(k){Fa(e,f,this[f])}}e[mb]=""+e[kb]+Oj++;e[bb]=[];g=u.makeIterator(Object.getOwnPropertyNames(this));for(f=g.next();!f.done;f=g.next())if(f=f.value,this[df].has(f))e[f]=a[Jj](this[f]);else{var h=this[f];e[f]=h instanceof P?new P(h[Qf]):null}g=u.makeIterator(this[bb]);for(f=\ng.next();!f.done;f=g.next())h=f.value,f=h[kb],h=h[od](),e[bb].push(h),h[fd]=e,null===e[f]?e[f]=h:e[f][bb].push(h);return e};c[ac]=function(e){void 0===e&&(e=null);return e?this[bb].filter(function(g){return g[kb]===e}):this[bb]};c[xg]=function(e){return this[e]};c[pf]=function(e,g,f){void 0===f&&(f=!0);return Array.from(this[If](e,g,f))};c[If]=function(e,g,f){var h=this;void 0===f&&(f=!0);return function l(){var m,n,p;return u.generator.createGenerator(l,function(q){switch(q.nextAddress){case 1:if("parent"!==\ne){q.jumpTo(2);break}return q.yield(h[fd],3);case 3:return q.return();case 2:m=u.makeIterator(h[bb]),n=m.next();case 4:if(n.done){if(!f||!h[df].has(e)){q.jumpTo(0);break}return q.yield(new Pj(h,e,h[e]),0)}p=n.value;if(p[kb]!==e){q.jumpTo(7);break}return q.yield(p,7);case 7:if(p.name!==e){q.jumpTo(9);break}return q.yield(p,9);case 9:if(!g&&!p[Mf]()){q.jumpTo(5);break}return q.yieldAll(p[If](e,g,!1),5);case 5:n=m.next(),q.jumpTo(4)}})}()};return wm(a,[{key:"isXFAObject",get:function(){return!0}},{key:"isXFAObjectArray",\nget:function(){return!1}},{key:df,get:function(){var e=Object.getPrototypeOf(this);if(!e._attributes)for(var g=e._attributes=new Set,f=u.makeIterator(Object.getOwnPropertyNames(this)),h=f.next();!h.done;h=f.next()){h=h.value;if(null===this[h]||this[h]instanceof a||this[h]instanceof P)break;g.add(h)}return Fa(this,df,e._attributes)}}])}(),P=function(){function a(b){void 0===b&&(b=Infinity);this[Qf]=b;this[bb]=[]}var c=a.prototype;c.push=function(b){if(this[bb].length<=this[Qf])return this[bb].push(b),\n!0;T(\'XFA - node "\'+b[kb]+\'" accepts no more than \'+this[Qf]+" children");return!1};c.isEmpty=function(){return 0===this[bb].length};c.dump=function(){return 1===this[bb].length?this[bb][0][$e]():this[bb].map(function(b){return b[$e]()})};c[od]=function(){var b=new a(this[Qf]);b[bb]=this[bb].map(function(d){return d[od]()});return b};c.clear=function(){this[bb].length=0};return wm(a,[{key:"isXFAObject",get:function(){return!1}},{key:"isXFAObjectArray",get:function(){return!0}},{key:"children",get:function(){return this[bb]}}])}(),\nPj=function(){function a(b,d,e){this[fd]=b;this[kb]=d;this[ra]=e;this[zd]=!1;this[mb]="attribute"+Oj++}var c=a.prototype;c[Va]=function(){return this[fd]};c[bf]=function(){return!0};c[Ej]=function(){return this[ra].trim()};c[Gc]=function(b){b=b.value||"";this[ra]=b.toString()};c[Sb]=function(){return this[ra]};c[Yd]=function(b){return this[fd]===b||this[fd][Yd](b)};return a}(),ze=function(a){function c(d,e,g){void 0===g&&(g={});d=a.call(this,d,e)||this;d[ra]="";d[ae]=null;if("#text"!==e){e=new Map;\nd[ye]=e;for(var f=u.makeIterator(Object.entries(g)),h=f.next();!h.done;h=f.next()){var k=u.makeIterator(h.value);h=k.next().value;k=k.next().value;e.set(h,new Pj(d,h,k))}g.hasOwnProperty(Zd)&&(g=g[Zd].xfa.dataNode,void 0!==g&&("dataGroup"===g?d[ae]=!1:"dataValue"===g&&(d[ae]=!0)))}d[zd]=!1;return d}qe(c,a);var b=c.prototype;b[Pf]=function(d){var e=this[kb];if("#text"===e)d.push(De(this[ra]));else{e=unescape(encodeURIComponent(e));var g=this[Pb]===zo?"xfa:":"";d.push("<"+g+e);for(var f=u.makeIterator(this[ye].entries()),\nh=f.next();!h.done;h=f.next()){var k=u.makeIterator(h.value);h=k.next().value;k=k.next().value;h=unescape(encodeURIComponent(h));d.push(" "+h+\'="\'+De(k[ra])+\'"\')}null!==this[ae]&&(this[ae]?d.push(\' xfa:dataNode="dataValue"\'):d.push(\' xfa:dataNode="dataGroup"\'));if(this[ra]||0!==this[bb].length){d.push(">");if(this[ra])if("string"===typeof this[ra])d.push(De(this[ra]));else this[ra][Pf](d);else for(f=u.makeIterator(this[bb]),h=f.next();!h.done;h=f.next())h.value[Pf](d);d.push("</"+g+e+">")}else d.push("/>")}};\nb[Ad]=function(d){if(this[ra]){var e=new c(this[Pb],"#text");this[Cb](e);e[ra]=this[ra];this[ra]=""}this[Cb](d);return!0};b[Ld]=function(d){this[ra]+=d};b[sb]=function(){if(this[ra]&&0<this[bb].length){var d=new c(this[Pb],"#text");this[Cb](d);d[ra]=this[ra];delete this[ra]}};b[Ra]=function(){return"#text"===this[kb]?Pa.success({name:"#text",value:this[ra]}):Pa.EMPTY};b[ac]=function(d){void 0===d&&(d=null);return d?this[bb].filter(function(e){return e[kb]===d}):this[bb]};b[so]=function(){return this[ye]};\nb[xg]=function(d){var e=this[ye].get(d);return void 0!==e?e:this[ac](d)};b[If]=function f(e,g){var h=this,k,l,m,n;return u.generator.createGenerator(f,function(p){switch(p.nextAddress){case 1:k=h[ye].get(e);if(!k){p.jumpTo(2);break}return p.yield(k,2);case 2:l=u.makeIterator(h[bb]),m=l.next();case 4:if(m.done){p.jumpTo(0);break}n=m.value;if(n[kb]!==e){p.jumpTo(7);break}return p.yield(n,7);case 7:if(!g){p.jumpTo(5);break}return p.yieldAll(n[If](e,g),5);case 5:m=l.next(),p.jumpTo(4)}})};b[Dj]=function h(g,\nf){var k=this,l,m,n,p;return u.generator.createGenerator(h,function(q){switch(q.nextAddress){case 1:l=k[ye].get(g);if(!l||f&&l[zd]){q.jumpTo(2);break}return q.yield(l,2);case 2:m=u.makeIterator(k[bb]),n=m.next();case 4:if(n.done){q.jumpTo(0);break}p=n.value;return q.yieldAll(p[Dj](g,f),5);case 5:n=m.next(),q.jumpTo(4)}})};b[Jf]=function l(f,h,k){var m=this,n,p,q;return u.generator.createGenerator(l,function(r){switch(r.nextAddress){case 1:n=u.makeIterator(m[bb]),p=n.next();case 2:if(p.done){r.jumpTo(0);\nbreak}q=p.value;if(q[kb]!==f||k&&q[zd]){r.jumpTo(5);break}return r.yield(q,5);case 5:if(!h){r.jumpTo(3);break}return r.yieldAll(q[Jf](f,h,k),3);case 3:p=n.next(),r.jumpTo(2)}})};b[bf]=function(){return null===this[ae]?0===this[bb].length||this[bb][0][Pb]===Qb.xhtml.id:this[ae]};b[Ej]=function(){return null===this[ae]?0===this[bb].length?this[ra].trim():this[bb][0][Pb]===Qb.xhtml.id?this[bb][0][Sb]().trim():null:this[ra].trim()};b[Gc]=function(f){f=f.value||"";this[ra]=f.toString()};b[$e]=function(f){void 0===\nf&&(f=!1);var h=Object.create(null);f&&(h.$ns=this[Pb]);this[ra]&&(h.$content=this[ra]);h.$name=this[kb];h.children=[];for(var k=u.makeIterator(this[bb]),l=k.next();!l.done;l=k.next())h.children.push(l.value[$e](f));h.attributes=Object.create(null);f=u.makeIterator(this[ye]);for(k=f.next();!k.done;k=f.next())l=u.makeIterator(k.value),k=l.next().value,l=l.next().value,h.attributes[k]=l[ra];return h};return c}(na),Hb=function(a){function c(d,e){d=a.call(this,d,e)||this;d[ra]="";return d}qe(c,a);var b=\nc.prototype;b[Ld]=function(d){this[ra]+=d};b[sb]=function(){};return c}(na),nb=function(a){function c(d,e,g){d=a.call(this,d,e)||this;d[Zg]=g;return d}qe(c,a);var b=c.prototype;b[sb]=function(){var d=this;this[ra]=wg({data:this[ra],defaultValue:this[Zg][0],validate:function(e){return d[Zg].includes(e)}})};b[dd]=function(d){a.prototype[dd].call(this,d);delete this[Zg]};return c}(Hb),cb=function(a){function c(){return a.apply(this,arguments)||this}qe(c,a);c.prototype[sb]=function(){this[ra]=this[ra].trim()};\nreturn c}(Hb),qd=function(a){function c(d,e,g,f){d=a.call(this,d,e)||this;d[Kj]=g;d[Nj]=f;return d}qe(c,a);var b=c.prototype;b[sb]=function(){this[ra]=Ta({data:this[ra],defaultValue:this[Kj],validate:this[Nj]})};b[dd]=function(d){a.prototype[dd].call(this,d);delete this[Kj];delete this[Nj]};return c}(Hb),Tb=function(a){function c(b,d){return a.call(this,b,d,0,function(e){return 1===e})||this}qe(c,a);return c}(qd),Ao=function(a){function c(b,d){return a.call(this,b,d,1,function(e){return 0===e})||\nthis}qe(c,a);return c}(qd),Bm={anchorType:function(a,c){var b=a[Nb]();if(b&&(!b.layout||"position"===b.layout))switch("transform"in c||(c.transform=""),a.anchorType){case "bottomCenter":c.transform+="translate(-50%, -100%)";break;case "bottomLeft":c.transform+="translate(0,-100%)";break;case "bottomRight":c.transform+="translate(-100%,-100%)";break;case "middleCenter":c.transform+="translate(-50%,-50%)";break;case "middleLeft":c.transform+="translate(0,-50%)";break;case "middleRight":c.transform+=\n"translate(-100%,-50%)";break;case "topCenter":c.transform+="translate(-50%,0)";break;case "topRight":c.transform+="translate(-100%,0)"}},dimensions:function(a,c){var b,d=a[Nb](),e=a.w,g=a.h;null!=(b=d.layout)&&b.includes("row")&&(b=d[ja],d=a.colSpan,-1===d?(d=b.columnWidths.slice(b.currentColumn).reduce(function(f,h){return f+h},0),b.currentColumn=0):(d=b.columnWidths.slice(b.currentColumn,b.currentColumn+d).reduce(function(f,h){return f+h},0),b.currentColumn=(b.currentColumn+a.colSpan)%b.columnWidths.length),\nisNaN(d)||(e=a.w=d));c.width=""!==e?Ua(e):"auto";c.height=""!==g?Ua(g):"auto"},position:function(a,c){var b=a[Nb]();null!=b&&b.layout&&"position"!==b.layout||(c.position="absolute",c.left=Ua(a.x),c.top=Ua(a.y))},rotate:function(a,c){a.rotate&&("transform"in c||(c.transform=""),c.transform+="rotate(-"+a.rotate+"deg)",c.transformOrigin="top left")},presence:function(a,c){switch(a.presence){case "invisible":c.visibility="hidden";break;case "hidden":case "inactive":c.display="none"}},hAlign:function(a,\nc){if("para"===a[kb])switch(a.hAlign){case "justifyAll":c.textAlign="justify-all";break;case "radix":c.textAlign="left";break;default:c.textAlign=a.hAlign}else switch(a.hAlign){case "left":c.alignSelf="start";break;case "center":c.alignSelf="center";break;case "right":c.alignSelf="end"}},margin:function(a,c){a.margin&&(c.margin=a.margin[gb]().margin)}},Da=Qb.template.id,Rq=/^H(\\d+)$/,Ht=new Set("image/gif image/jpeg image/jpg image/pjpeg image/png image/apng image/x-png image/bmp image/x-ms-bmp image/tiff image/tif application/octet-stream".split(" ")),\nIt=[[[66,77],"image/bmp"],[[255,216,255],"image/jpeg"],[[73,73,42,0],"image/tiff"],[[77,77,0,42],"image/tiff"],[[71,73,70,56,57,97],"image/gif"],[[137,80,78,71,13,10,26,10],"image/png"]],Jt=function(a){function c(b){var d=a.call(this,Da,"appearanceFilter")||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(cb),Bo=function(a){function c(b){var d=a.call(this,Da,"arc",!0)||this;d.circular=Ta({data:b.circular,defaultValue:0,\nvalidate:function(e){return 1===e}});d.hand=ua(b.hand,["even","left","right"]);d.id=b.id||"";d.startAngle=vg({data:b.startAngle,defaultValue:0,validate:function(){return!0}});d.sweepAngle=vg({data:b.sweepAngle,defaultValue:360,validate:function(){return!0}});d.use=b.use||"";d.usehref=b.usehref||"";d.edge=null;d.fill=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b,d=this.edge||new Tf({}),e=d[gb](),g=Object.create(null);"visible"===(null==(b=this.fill)?void 0:b.presence)?Object.assign(g,this.fill[gb]()):\ng.fill="transparent";g.strokeWidth=Ua("visible"===d.presence?d.thickness:0);g.stroke=e.color;b={xmlns:"http://www.w3.org/2000/svg",style:{width:"100%",height:"100%",overflow:"visible"}};if(360===this.sweepAngle)g={name:"ellipse",attributes:{xmlns:"http://www.w3.org/2000/svg",cx:"50%",cy:"50%",rx:"50%",ry:"50%",style:g}};else{e=this.startAngle*Math.PI/180;var f=this.sweepAngle*Math.PI/180;d=180<this.sweepAngle?1:0;var h=u.makeIterator([50*(1+Math.cos(e)),50*(1-Math.sin(e)),50*(1+Math.cos(e+f)),50*\n(1-Math.sin(e+f))]);e=h.next().value;f=h.next().value;var k=h.next().value;h=h.next().value;g={name:"path",attributes:{xmlns:"http://www.w3.org/2000/svg",d:"M "+e+" "+f+" A 50 50 0 "+d+" 0 "+k+" "+h,vectorEffect:"non-scaling-stroke",style:g}};Object.assign(b,{viewBox:"0 0 100 100",preserveAspectRatio:"none"})}g={name:"svg",children:[g],attributes:b};b=this[Va]()[Va]();if(Li(b))return Pa.success({name:"div",attributes:{style:{display:"inline",width:"100%",height:"100%"}},children:[g]});g.attributes.style.position=\n"absolute";return Pa.success(g)};return c}(na),Kt=function(a){function c(d){var e=a.call(this,Da,"area",!0)||this;e.colSpan=Ta({data:d.colSpan,defaultValue:1,validate:function(g){return 1<=g||-1===g}});e.id=d.id||"";e.name=d.name||"";e.relevant=md(d.relevant);e.use=d.use||"";e.usehref=d.usehref||"";e.x=Ma(d.x,"0pt");e.y=Ma(d.y,"0pt");e.desc=null;e.extras=null;e.area=new P;e.draw=new P;e.exObject=new P;e.exclGroup=new P;e.field=new P;e.subform=new P;e.subformSet=new P;return e}Ca(c,a);var b=c.prototype;\nb[Le]=function e(){var g=this;return u.generator.createGenerator(e,function(f){return f.yieldAll(Ag(g),0)})};b[Mf]=function(){return!0};b[xe]=function(){return!0};b[te]=function(e,g){var f=u.makeIterator(g);g=f.next().value;var h=f.next().value,k=f.next().value;f=f.next().value;this[ja].width=Math.max(this[ja].width,g+k);this[ja].height=Math.max(this[ja].height,h+f);this[ja].children.push(e)};b[we]=function(){return this[ja].availableSpace};b[Ra]=function(e){var g=Ac(this,"position"),f={style:g,id:this[mb],\nclass:["xfaArea"]};Ke(this)&&f.class.push("xfaPrintOnly");this.name&&(f.xfaName=this.name);var h=[];this[ja]={children:h,width:0,height:0,availableSpace:e};e=this[Xd]({filter:new Set("area draw field exclGroup subform subformSet".split(" ")),include:!0});if(!e.success){if(e.isBreak())return e;delete this[ja];return Pa.FAILURE}g.width=Ua(this[ja].width);g.height=Ua(this[ja].height);g={name:"div",attributes:f,children:h};f=[this.x,this.y,this[ja].width,this[ja].height];delete this[ja];return Pa.success(g,\nf)};return c}(na),Lt=function(a){function c(b){var d=a.call(this,Da,"assist",!0)||this;d.id=b.id||"";d.role=b.role||"";d.use=b.use||"";d.usehref=b.usehref||"";d.speak=null;d.toolTip=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b;return(null==(b=this.toolTip)?void 0:b[ra])||null};return c}(na),Mt=function(a){function c(b){var d=a.call(this,Da,"barcode",!0)||this;d.charEncoding=wg({data:b.charEncoding?b.charEncoding.toLowerCase():"",defaultValue:"",validate:function(e){return"utf-8 big-five fontspecific gbk gb-18030 gb-2312 ksc-5601 none shift-jis ucs-2 utf-16".split(" ").includes(e)||\ne.match(/iso-8859-\\d{2}/)}});d.checksum=ua(b.checksum,["none","1mod10","1mod10_1mod11","2mod10","auto"]);d.dataColumnCount=Ta({data:b.dataColumnCount,defaultValue:-1,validate:function(e){return 0<=e}});d.dataLength=Ta({data:b.dataLength,defaultValue:-1,validate:function(e){return 0<=e}});d.dataPrep=ua(b.dataPrep,["none","flateCompress"]);d.dataRowCount=Ta({data:b.dataRowCount,defaultValue:-1,validate:function(e){return 0<=e}});d.endChar=b.endChar||"";d.errorCorrectionLevel=Ta({data:b.errorCorrectionLevel,\ndefaultValue:-1,validate:function(e){return 0<=e&&8>=e}});d.id=b.id||"";d.moduleHeight=Ma(b.moduleHeight,"5mm");d.moduleWidth=Ma(b.moduleWidth,"0.25mm");d.printCheckDigit=Ta({data:b.printCheckDigit,defaultValue:0,validate:function(e){return 1===e}});d.rowColumnRatio=qm(b.rowColumnRatio);d.startChar=b.startChar||"";d.textLocation=ua(b.textLocation,["below","above","aboveEmbedded","belowEmbedded","none"]);d.truncate=Ta({data:b.truncate,defaultValue:0,validate:function(e){return 1===e}});d.type=ua(b.type?\nb.type.toLowerCase():"","aztec codabar code2of5industrial code2of5interleaved code2of5matrix code2of5standard code3of9 code3of9extended code11 code49 code93 code128 code128a code128b code128c code128sscc datamatrix ean8 ean8add2 ean8add5 ean13 ean13add2 ean13add5 ean13pwcd fim logmars maxicode msi pdf417 pdf417macro plessey postauscust2 postauscust3 postausreplypaid postausstandard postukrm4scc postusdpbc postusimb postusstandard postus5zip qrcode rfid rss14 rss14expanded rss14limited rss14stacked rss14stackedomni rss14truncated telepen ucc128 ucc128random ucc128sscc upca upcaadd2 upcaadd5 upcapwcd upce upceadd2 upceadd5 upcean2 upcean5 upsmaxicode".split(" "));\nd.upsMode=ua(b.upsMode,["usCarrier","internationalCarrier","secureSymbol","standardSymbol"]);d.use=b.use||"";d.usehref=b.usehref||"";d.wideNarrowRatio=qm(b.wideNarrowRatio);d.encrypt=null;d.extras=null;return d}Ca(c,a);return c}(na),Nt=function(a){function c(b){var d=a.call(this,Da,"bind",!0)||this;d.match=ua(b.match,["once","dataRef","global","none"]);d.ref=b.ref||"";d.picture=null;return d}Ca(c,a);return c}(na),Qj=function(a){function c(b){var d=a.call(this,Da,"bindItems")||this;d.connection=b.connection||\n"";d.labelRef=b.labelRef||"";d.ref=b.ref||"";d.valueRef=b.valueRef||"";return d}Ca(c,a);return c}(na),Ot=function(a){function c(b){var d=a.call(this,Da,"bookend")||this;d.id=b.id||"";d.leader=b.leader||"";d.trailer=b.trailer||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(na),Pt=function(a){function c(b){var d=a.call(this,Da,"boolean")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);c.prototype[Ra]=function(){return Sd(1===this[ra]?\n"1":"0")};return c}(Tb),Co=function(a){function c(d){var e=a.call(this,Da,"border",!0)||this;e.break=ua(d.break,["close","open"]);e.hand=ua(d.hand,["even","left","right"]);e.id=d.id||"";e.presence=ua(d.presence,["visible","hidden","inactive","invisible"]);e.relevant=md(d.relevant);e.use=d.use||"";e.usehref=d.usehref||"";e.corner=new P(4);e.edge=new P(4);e.extras=null;e.fill=null;e.margin=null;return e}Ca(c,a);var b=c.prototype;b[lc]=function(){if(!this[ja]){var d=this.edge.children.slice();if(4>d.length)for(var e=\nd.at(-1)||new Tf({}),g=d.length;4>g;g++)d.push(e);e=d.map(function(f){return f.thickness});g=[0,0,0,0];this.margin&&(g[0]=this.margin.topInset,g[1]=this.margin.rightInset,g[2]=this.margin.bottomInset,g[3]=this.margin.leftInset);this[ja]={widths:e,insets:g,edges:d}}return this[ja]};b[gb]=function(){var d,e=this[lc]().edges.map(function(k){k=k[gb]();k.color||(k.color="#000000");return k}),g=Object.create(null);this.margin&&Object.assign(g,this.margin[gb]());"visible"===(null==(d=this.fill)?void 0:d.presence)&&\nObject.assign(g,this.fill[gb]());if(this.corner.children.some(function(k){return 0!==k.radius})){d=this.corner.children.map(function(k){return k[gb]()});if(2===d.length||3===d.length)for(var f=d.at(-1),h=d.length;4>h;h++)d.push(f);g.borderRadius=d.map(function(k){return k.radius}).join(" ")}switch(this.presence){case "invisible":case "hidden":g.borderStyle="";break;case "inactive":g.borderStyle="none";break;default:g.borderStyle=e.map(function(k){return k.style}).join(" ")}g.borderWidth=e.map(function(k){return k.width}).join(" ");\ng.borderColor=e.map(function(k){return k.color}).join(" ");return g};return c}(na),Qt=function(a){function c(b){var d=a.call(this,Da,"break",!0)||this;d.after=ua(b.after,["auto","contentArea","pageArea","pageEven","pageOdd"]);d.afterTarget=b.afterTarget||"";d.before=ua(b.before,["auto","contentArea","pageArea","pageEven","pageOdd"]);d.beforeTarget=b.beforeTarget||"";d.bookendLeader=b.bookendLeader||"";d.bookendTrailer=b.bookendTrailer||"";d.id=b.id||"";d.overflowLeader=b.overflowLeader||"";d.overflowTarget=\nb.overflowTarget||"";d.overflowTrailer=b.overflowTrailer||"";d.startNew=Ta({data:b.startNew,defaultValue:0,validate:function(e){return 1===e}});d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;return d}Ca(c,a);return c}(na),Do=function(a){function c(b){var d=a.call(this,Da,"breakAfter",!0)||this;d.id=b.id||"";d.leader=b.leader||"";d.startNew=Ta({data:b.startNew,defaultValue:0,validate:function(e){return 1===e}});d.target=b.target||"";d.targetType=ua(b.targetType,["auto","contentArea","pageArea"]);\nd.trailer=b.trailer||"";d.use=b.use||"";d.usehref=b.usehref||"";d.script=null;return d}Ca(c,a);return c}(na),Eo=function(a){function c(b){var d=a.call(this,Da,"breakBefore",!0)||this;d.id=b.id||"";d.leader=b.leader||"";d.startNew=Ta({data:b.startNew,defaultValue:0,validate:function(e){return 1===e}});d.target=b.target||"";d.targetType=ua(b.targetType,["auto","contentArea","pageArea"]);d.trailer=b.trailer||"";d.use=b.use||"";d.usehref=b.usehref||"";d.script=null;return d}Ca(c,a);c.prototype[Ra]=function(){this[ja]=\n{};return Pa.FAILURE};return c}(na),Rt=function(a){function c(b){var d=a.call(this,Da,"button",!0)||this;d.highlight=ua(b.highlight,["inverted","none","outline","push"]);d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b=this[Va]()[Va](),d={name:"button",attributes:{id:this[mb],class:["xfaButton"],style:{}},children:[]};b=u.makeIterator(b.event.children);for(var e=b.next();!e.done;e=b.next())if(e=e.value,"click"===e.activity&&e.script&&\n(e=ok(e.script[ra]))){var g=Gm(e.url);g&&d.children.push({name:"a",attributes:{id:"link"+this[mb],href:g,newWindow:e.newWindow,class:["xfaLink"],style:{}},children:[]})}return Pa.success(d)};return c}(na),St=function(a){function c(b){var d=a.call(this,Da,"calculate",!0)||this;d.id=b.id||"";d.override=ua(b.override,["disabled","error","ignore","warning"]);d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;d.message=null;d.script=null;return d}Ca(c,a);return c}(na),Tt=function(a){function c(d){var e=\na.call(this,Da,"caption",!0)||this;e.id=d.id||"";e.placement=ua(d.placement,["left","bottom","inline","right","top"]);e.presence=ua(d.presence,["visible","hidden","inactive","invisible"]);e.reserve=Math.ceil(Ma(d.reserve));e.use=d.use||"";e.usehref=d.usehref||"";e.extras=null;e.font=null;e.margin=null;e.para=null;e.value=null;return e}Ca(c,a);var b=c.prototype;b[Gc]=function(d){Mi(this,d)};b[lc]=function(d){if(!this[ja]){var e=d.width;d=d.height;switch(this.placement){case "left":case "right":case "inline":e=\n0>=this.reserve?e:this.reserve;break;case "top":case "bottom":d=0>=this.reserve?d:this.reserve}this[ja]=Ii(this,{width:e,height:d})}return this[ja]};b[Ra]=function(d){if(!this.value)return Pa.EMPTY;this[cf]();var e=this.value[Ra](d).html;if(!e)return this[Jc](),Pa.EMPTY;var g=this.reserve;if(0>=this.reserve){var f=this[lc](d);d=f.w;f=f.h;switch(this.placement){case "left":case "right":case "inline":this.reserve=d;break;case "top":case "bottom":this.reserve=f}}d=[];"string"===typeof e?d.push({name:"#text",\nvalue:e}):d.push(e);f=Ac(this,"font","margin","visibility");switch(this.placement){case "left":case "right":0<this.reserve&&(f.width=Ua(this.reserve));break;case "top":case "bottom":0<this.reserve&&(f.height=Ua(this.reserve))}Em(this,null,e);this[Jc]();this.reserve=g;return Pa.success({name:"div",attributes:{style:f,class:["xfaCaption"]},children:d})};return c}(na),Ut=function(a){function c(b){var d=a.call(this,Da,"certificate")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||\n"";return d}Ca(c,a);return c}(cb),Vt=function(a){function c(b){var d=a.call(this,Da,"certificates",!0)||this;d.credentialServerPolicy=ua(b.credentialServerPolicy,["optional","required"]);d.id=b.id||"";d.url=b.url||"";d.urlPolicy=b.urlPolicy||"";d.use=b.use||"";d.usehref=b.usehref||"";d.encryption=null;d.issuers=null;d.keyUsage=null;d.oids=null;d.signing=null;d.subjectDNs=null;return d}Ca(c,a);return c}(na),Go=function(a){function c(b){var d=a.call(this,Da,"checkButton",!0)||this;d.id=b.id||"";d.mark=\nua(b.mark,"default check circle cross diamond square star".split(" "));d.shape=ua(b.shape,["square","round"]);d.size=Ma(b.size,"10pt");d.use=b.use||"";d.usehref=b.usehref||"";d.border=null;d.extras=null;d.margin=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b,d=Ac("margin"),e=Ua(this.size);d.width=d.height=e;e=this[Va]()[Va]();var g=e.items.children.length&&e.items.children[0][Ra]().html||[],f=(void 0!==g[0]?g[0]:"on").toString();g=(void 0!==g[1]?g[1]:"off").toString();var h=((null==(b=e.value)?\nvoid 0:b[Sb]())||"off")===f||void 0,k=e[Nb](),l=e[mb];if(k instanceof Fo){var m;var n=k[mb];b="radio";var p="xfaRadio";var q=(null==(m=k[ed])?void 0:m[mb])||k[mb]}else{var r;b="checkbox";p="xfaCheckbox";q=(null==(r=e[ed])?void 0:r[mb])||e[mb]}d={name:"input",attributes:{class:[p],style:d,fieldId:l,dataId:q,type:b,checked:h,xfaOn:f,xfaOff:g,"aria-label":se(e),"aria-required":!1}};n&&(d.attributes.name=n);rf(e)&&(d.attributes["aria-required"]=!0,d.attributes.required=!0);return Pa.success({name:"label",\nattributes:{class:["xfaLabel"]},children:[d]})};return c}(na),Ho=function(a){function c(b){var d=a.call(this,Da,"choiceList",!0)||this;d.commitOn=ua(b.commitOn,["select","exit"]);d.id=b.id||"";d.open=ua(b.open,["userControl","always","multiSelect","onEntry"]);d.textEntry=Ta({data:b.textEntry,defaultValue:0,validate:function(e){return 1===e}});d.use=b.use||"";d.usehref=b.usehref||"";d.border=null;d.extras=null;d.margin=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b,d,e=Ac(this,"border","margin"),\ng=this[Va]()[Va](),f={fontSize:"calc("+((null==(b=g.font)?void 0:b.size)||10)+"px * var(--scale-factor))"};b=[];if(0<g.items.children.length){var h,k=g.items,l=0,m=0;2===k.children.length&&(l=k.children[0].save,m=1-l);l=k.children[l][Ra]().html;k=k.children[m][Ra]().html;m=!1;var n=(null==(h=g.value)?void 0:h[Sb]())||"";h=0;for(var p=l.length;h<p;h++){var q={name:"option",attributes:{value:k[h]||l[h],style:f},value:l[h]};k[h]===n&&(q.attributes.selected=m=!0);b.push(q)}m||b.splice(0,0,{name:"option",\nattributes:{hidden:!0,selected:!0},value:" "})}f={class:["xfaSelect"],fieldId:g[mb],dataId:(null==(d=g[ed])?void 0:d[mb])||g[mb],style:e,"aria-label":se(g),"aria-required":!1};rf(g)&&(f["aria-required"]=!0,f.required=!0);"multiSelect"===this.open&&(f.multiple=!0);return Pa.success({name:"label",attributes:{class:["xfaLabel"]},children:[{name:"select",children:b,attributes:f}]})};return c}(na),Wt=function(a){function c(d){var e=a.call(this,Da,"color",!0)||this;e.cSpace=ua(d.cSpace,["SRGB"]);e.id=d.id||\n"";e.use=d.use||"";e.usehref=d.usehref||"";e.value=d.value?Lq(d.value):"";e.extras=null;return e}Ca(c,a);var b=c.prototype;b[Kf]=function(){return!1};b[gb]=function(){return this.value?Rb.makeHexColor(this.value.r,this.value.g,this.value.b):null};return c}(na),Xt=function(a){function c(b){var d=a.call(this,Da,"comb")||this;d.id=b.id||"";d.numberOfCells=Ta({data:b.numberOfCells,defaultValue:0,validate:function(e){return 0<=e}});d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(na),\nYt=function(a){function c(b){var d=a.call(this,Da,"connect",!0)||this;d.connection=b.connection||"";d.id=b.id||"";d.ref=b.ref||"";d.usage=ua(b.usage,["exportAndImport","exportOnly","importOnly"]);d.use=b.use||"";d.usehref=b.usehref||"";d.picture=null;return d}Ca(c,a);return c}(na),Pi=function(a){function c(b){var d=a.call(this,Da,"contentArea",!0)||this;d.h=Ma(b.h);d.id=b.id||"";d.name=b.name||"";d.relevant=md(b.relevant);d.use=b.use||"";d.usehref=b.usehref||"";d.w=Ma(b.w);d.x=Ma(b.x,"0pt");d.y=Ma(b.y,\n"0pt");d.desc=null;d.extras=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b=Ua(this.x),d=Ua(this.y);b={left:b,top:d,width:Ua(this.w),height:Ua(this.h)};d=["xfaContentarea"];Ke(this)&&d.push("xfaPrintOnly");return Pa.success({name:"div",children:[],attributes:{style:b,class:d,id:this[mb]}})};return c}(na),Io=function(a){function c(b){var d=a.call(this,Da,"corner",!0)||this;d.id=b.id||"";d.inverted=Ta({data:b.inverted,defaultValue:0,validate:function(e){return 1===e}});d.join=ua(b.join,["square",\n"round"]);d.presence=ua(b.presence,["visible","hidden","inactive","invisible"]);d.radius=Ma(b.radius);d.stroke=ua(b.stroke,"solid dashDot dashDotDot dashed dotted embossed etched lowered raised".split(" "));d.thickness=Ma(b.thickness,"0.5pt");d.use=b.use||"";d.usehref=b.usehref||"";d.color=null;d.extras=null;return d}Ca(c,a);c.prototype[gb]=function(){var b=Ac(this,"visibility");b.radius=Ua("square"===this.join?0:this.radius);return b};return c}(na),Zt=function(a){function c(d){var e=a.call(this,\nDa,"date")||this;e.id=d.id||"";e.name=d.name||"";e.use=d.use||"";e.usehref=d.usehref||"";return e}Ca(c,a);var b=c.prototype;b[sb]=function(){var d=this[ra].trim();this[ra]=d?new Date(d):null};b[Ra]=function(){return Sd(this[ra]?this[ra].toString():"")};return c}(Hb),$t=function(a){function c(d){var e=a.call(this,Da,"dateTime")||this;e.id=d.id||"";e.name=d.name||"";e.use=d.use||"";e.usehref=d.usehref||"";return e}Ca(c,a);var b=c.prototype;b[sb]=function(){var d=this[ra].trim();this[ra]=d?new Date(d):\nnull};b[Ra]=function(){return Sd(this[ra]?this[ra].toString():"")};return c}(Hb),au=function(a){function c(b){var d=a.call(this,Da,"dateTimeEdit",!0)||this;d.hScrollPolicy=ua(b.hScrollPolicy,["auto","off","on"]);d.id=b.id||"";d.picker=ua(b.picker,["host","none"]);d.use=b.use||"";d.usehref=b.usehref||"";d.border=null;d.comb=null;d.extras=null;d.margin=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b,d=Ac(this,"border","font","margin"),e=this[Va]()[Va](),g={name:"input",attributes:{type:"text",\nfieldId:e[mb],dataId:(null==(b=e[ed])?void 0:b[mb])||e[mb],class:["xfaTextfield"],style:d,"aria-label":se(e),"aria-required":!1}};rf(e)&&(g.attributes["aria-required"]=!0,g.attributes.required=!0);return Pa.success({name:"label",attributes:{class:["xfaLabel"]},children:[g]})};return c}(na),bu=function(a){function c(d){var e=a.call(this,Da,"decimal")||this;e.fracDigits=Ta({data:d.fracDigits,defaultValue:2,validate:function(){return!0}});e.id=d.id||"";e.leadDigits=Ta({data:d.leadDigits,defaultValue:-1,\nvalidate:function(){return!0}});e.name=d.name||"";e.use=d.use||"";e.usehref=d.usehref||"";return e}Ca(c,a);var b=c.prototype;b[sb]=function(){var d=parseFloat(this[ra].trim());this[ra]=isNaN(d)?null:d};b[Ra]=function(){return Sd(null!==this[ra]?this[ra].toString():"")};return c}(Hb),cu=function(a){function c(b){var d=a.call(this,Da,"defaultUi",!0)||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;return d}Ca(c,a);return c}(na),du=function(a){function c(b){var d=a.call(this,\nDa,"desc",!0)||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.boolean=new P;d.date=new P;d.dateTime=new P;d.decimal=new P;d.exData=new P;d.float=new P;d.image=new P;d.integer=new P;d.text=new P;d.time=new P;return d}Ca(c,a);return c}(na),eu=function(a){function c(b){var d=a.call(this,Da,"digestMethod",["","SHA1","SHA256","SHA512","RIPEMD160"])||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(nb),fu=function(a){function c(b){var d=a.call(this,Da,\n"digestMethods",!0)||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";d.digestMethod=new P;return d}Ca(c,a);return c}(na),Jo=function(a){function c(d){var e=a.call(this,Da,"draw",!0)||this;e.anchorType=ua(d.anchorType,"topLeft bottomCenter bottomLeft bottomRight middleCenter middleLeft middleRight topCenter topRight".split(" "));e.colSpan=Ta({data:d.colSpan,defaultValue:1,validate:function(g){return 1<=g||-1===g}});e.h=d.h?Ma(d.h):"";e.hAlign=ua(d.hAlign,\n"left center justify justifyAll radix right".split(" "));e.id=d.id||"";e.locale=d.locale||"";e.maxH=Ma(d.maxH,"0pt");e.maxW=Ma(d.maxW,"0pt");e.minH=Ma(d.minH,"0pt");e.minW=Ma(d.minW,"0pt");e.name=d.name||"";e.presence=ua(d.presence,["visible","hidden","inactive","invisible"]);e.relevant=md(d.relevant);e.rotate=Ta({data:d.rotate,defaultValue:0,validate:function(g){return 0===g%90}});e.use=d.use||"";e.usehref=d.usehref||"";e.w=d.w?Ma(d.w):"";e.x=Ma(d.x,"0pt");e.y=Ma(d.y,"0pt");e.assist=null;e.border=\nnull;e.caption=null;e.desc=null;e.extras=null;e.font=null;e.keep=null;e.margin=null;e.para=null;e.traversal=null;e.ui=null;e.value=null;e.setProperty=new P;return e}Ca(c,a);var b=c.prototype;b[Gc]=function(d){Mi(this,d)};b[Ra]=function(d){Bg(this);if("hidden"===this.presence||"inactive"===this.presence)return Pa.EMPTY;yg(this);this[cf]();var e=this.w,g=this.h,f=Ii(this,d),h=f.w,k=f.h;f=f.isBroken;if(h&&""===this.w){if(f&&this[Nb]()[Fd]())return this[Jc](),Pa.FAILURE;this.w=h}k&&""===this.h&&(this.h=\nk);Dg(this);if(!zg(this,d))return this.w=e,this.h=g,this[Jc](),Pa.FAILURE;Eg(this);h=Ac(this,"font","hAlign","dimensions","position","presence","rotate","anchorType","border","margin");xm(this,h);h.margin&&(h.padding=h.margin,delete h.margin);k=["xfaDraw"];this.font&&k.push("xfaFont");Ke(this)&&k.push("xfaPrintOnly");f={style:h,id:this[mb],class:k};this.name&&(f.xfaName=this.name);k={name:"div",attributes:f,children:[]};Cg(this,f);f=zm(this,k,d);d=this.value?this.value[Ra](d).html:null;if(null===\nd)return this.w=e,this.h=g,this[Jc](),Pa.success(re(this,k),f);k.children.push(d);Em(this,h,d);this.w=e;this.h=g;this[Jc]();return Pa.success(re(this,k),f)};return c}(na),Tf=function(a){function c(b){var d=a.call(this,Da,"edge",!0)||this;d.cap=ua(b.cap,["square","butt","round"]);d.id=b.id||"";d.presence=ua(b.presence,["visible","hidden","inactive","invisible"]);d.stroke=ua(b.stroke,"solid dashDot dashDotDot dashed dotted embossed etched lowered raised".split(" "));d.thickness=Ma(b.thickness,"0.5pt");\nd.use=b.use||"";d.usehref=b.usehref||"";d.color=null;d.extras=null;return d}Ca(c,a);c.prototype[gb]=function(){var b=Ac(this,"visibility");Object.assign(b,{linecap:this.cap,width:Ua(this.thickness),color:this.color?this.color[gb]():"#000000",style:""});if("visible"!==this.presence)b.style="none";else switch(this.stroke){case "solid":b.style="solid";break;case "dashDot":b.style="dashed";break;case "dashDotDot":b.style="dashed";break;case "dashed":b.style="dashed";break;case "dotted":b.style="dotted";\nbreak;case "embossed":b.style="ridge";break;case "etched":b.style="groove";break;case "lowered":b.style="inset";break;case "raised":b.style="outset"}return b};return c}(na),gu=function(a){function c(b){var d=a.call(this,Da,"encoding",["adbe.x509.rsa_sha1","adbe.pkcs7.detached","adbe.pkcs7.sha1"])||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(nb),hu=function(a){function c(b){var d=a.call(this,Da,"encodings",!0)||this;d.id=b.id||"";d.type=ua(b.type,["optional",\n"required"]);d.use=b.use||"";d.usehref=b.usehref||"";d.encoding=new P;return d}Ca(c,a);return c}(na),iu=function(a){function c(b){var d=a.call(this,Da,"encrypt",!0)||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.certificate=null;return d}Ca(c,a);return c}(na),ju=function(a){function c(b){var d=a.call(this,Da,"encryptData",!0)||this;d.id=b.id||"";d.operation=ua(b.operation,["encrypt","decrypt"]);d.target=b.target||"";d.use=b.use||"";d.usehref=b.usehref||"";d.filter=null;d.manifest=null;\nreturn d}Ca(c,a);return c}(na),ku=function(a){function c(b){var d=a.call(this,Da,"encryption",!0)||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";d.certificate=new P;return d}Ca(c,a);return c}(na),lu=function(a){function c(b){var d=a.call(this,Da,"encryptionMethod",["","AES256-CBC","TRIPLEDES-CBC","AES128-CBC","AES192-CBC"])||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(nb),mu=function(a){function c(b){var d=\na.call(this,Da,"encryptionMethods",!0)||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";d.encryptionMethod=new P;return d}Ca(c,a);return c}(na),nu=function(a){function c(b){var d=a.call(this,Da,"event",!0)||this;d.activity=ua(b.activity,"click change docClose docReady enter exit full indexChange initialize mouseDown mouseEnter mouseExit mouseUp postExecute postOpen postPrint postSave postSign postSubmit preExecute preOpen prePrint preSave preSign preSubmit ready validationState".split(" "));\nd.id=b.id||"";d.listen=ua(b.listen,["refOnly","refAndDescendents"]);d.name=b.name||"";d.ref=b.ref||"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;d.encryptData=null;d.execute=null;d.script=null;d.signData=null;d.submit=null;return d}Ca(c,a);return c}(na),ou=function(a){function c(d){var e=a.call(this,Da,"exData")||this;e.contentType=d.contentType||"";e.href=d.href||"";e.id=d.id||"";e.maxLength=Ta({data:d.maxLength,defaultValue:-1,validate:function(g){return-1<=g}});e.name=d.name||"";e.rid=\nd.rid||"";e.transferEncoding=ua(d.transferEncoding,["none","base64","package"]);e.use=d.use||"";e.usehref=d.usehref||"";return e}Ca(c,a);var b=c.prototype;b[Gj]=function(){return"text/html"===this.contentType};b[Ad]=function(d){return"text/html"===this.contentType&&d[Pb]===Qb.xhtml.id||"text/xml"===this.contentType?(this[ra]=d,!0):!1};b[Ra]=function(d){return"text/html"===this.contentType&&this[ra]?this[ra][Ra](d):Pa.EMPTY};return c}(Hb),pu=function(a){function c(b){var d=a.call(this,Da,"exObject",\n!0)||this;d.archive=b.archive||"";d.classId=b.classId||"";d.codeBase=b.codeBase||"";d.codeType=b.codeType||"";d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;d.boolean=new P;d.date=new P;d.dateTime=new P;d.decimal=new P;d.exData=new P;d.exObject=new P;d.float=new P;d.image=new P;d.integer=new P;d.text=new P;d.time=new P;return d}Ca(c,a);return c}(na),Fo=function(a){function c(d){var e=a.call(this,Da,"exclGroup",!0)||this;e.access=ua(d.access,["open","nonInteractive",\n"protected","readOnly"]);e.accessKey=d.accessKey||"";e.anchorType=ua(d.anchorType,"topLeft bottomCenter bottomLeft bottomRight middleCenter middleLeft middleRight topCenter topRight".split(" "));e.colSpan=Ta({data:d.colSpan,defaultValue:1,validate:function(g){return 1<=g||-1===g}});e.h=d.h?Ma(d.h):"";e.hAlign=ua(d.hAlign,"left center justify justifyAll radix right".split(" "));e.id=d.id||"";e.layout=ua(d.layout,"position lr-tb rl-row rl-tb row table tb".split(" "));e.maxH=Ma(d.maxH,"0pt");e.maxW=\nMa(d.maxW,"0pt");e.minH=Ma(d.minH,"0pt");e.minW=Ma(d.minW,"0pt");e.name=d.name||"";e.presence=ua(d.presence,["visible","hidden","inactive","invisible"]);e.relevant=md(d.relevant);e.use=d.use||"";e.usehref=d.usehref||"";e.w=d.w?Ma(d.w):"";e.x=Ma(d.x,"0pt");e.y=Ma(d.y,"0pt");e.assist=null;e.bind=null;e.border=null;e.calculate=null;e.caption=null;e.desc=null;e.extras=null;e.margin=null;e.para=null;e.traversal=null;e.validate=null;e.connect=new P;e.event=new P;e.field=new P;e.setProperty=new P;return e}\nCa(c,a);var b=c.prototype;b[xe]=function(){return!0};b[Kf]=function(){return!0};b[Gc]=function(d){for(var e=u.makeIterator(this.field.children),g=e.next();!g.done;g=e.next()){g=g.value;if(!g.value){var f=new Ni({});g[Cb](f);g.value=f}g.value[Gc](d)}};b[Fd]=function(){return this.layout.endsWith("-tb")&&0===this[ja].attempt&&0<this[ja].numberInLine||this[Va]()[Fd]()};b[Gd]=function(){var d,e=this[Nb]();return e[Gd]()?void 0!==this[ja]._isSplittable?this[ja]._isSplittable:"position"===this.layout||\nthis.layout.includes("row")?this[ja]._isSplittable=!1:null!=(d=e.layout)&&d.endsWith("-tb")&&0!==e[ja].numberInLine?!1:this[ja]._isSplittable=!0:!1};b[qf]=function(){return Im(this)};b[te]=function(d,e){Jm(this,d,e)};b[we]=function(){return Km(this)};b[Ra]=function(d){Bg(this);if("hidden"===this.presence||"inactive"===this.presence||0===this.h||0===this.w)return Pa.EMPTY;yg(this);var e=[],g={id:this[mb],class:[]};Ji(this,g.class);this[ja]||(this[ja]=Object.create(null));Object.assign(this[ja],{children:e,\nattributes:g,attempt:0,line:null,numberInLine:0,availableSpace:{width:Math.min(this.w||Infinity,d.width),height:Math.min(this.h||Infinity,d.height)},width:0,height:0,prevHeight:0,currentWidth:0});var f=this[Gd]();f||Dg(this);if(!zg(this,d))return Pa.FAILURE;var h=new Set(["field"]);this.layout.includes("row")&&(d=this[Nb]().columnWidths,Array.isArray(d)&&0<d.length&&(this[ja].columnWidths=d,this[ja].currentColumn=0));d=Ac(this,"anchorType","dimensions","position","presence","border","margin","hAlign");\nvar k=["xfaExclgroup"],l=Am(this);l&&k.push(l);Ke(this)&&k.push("xfaPrintOnly");g.style=d;g.class=k;this.name&&(g.xfaName=this.name);this[cf]();for(l=(k="lr-tb"===this.layout||"rl-tb"===this.layout)?2:1;this[ja].attempt<l;this[ja].attempt++){k&&1===this[ja].attempt&&(this[ja].numberInLine=0);var m=this[Xd]({filter:h,include:!0});if(m.success)break;if(m.isBreak())return this[Jc](),m;if(k&&0===this[ja].attempt&&0===this[ja].numberInLine&&!this[Ob]()[ja].noLayoutFailure){this[ja].attempt=l;break}}this[Jc]();\nf||Eg(this);if(this[ja].attempt===l)return f||delete this[ja],Pa.FAILURE;h=f=0;this.margin&&(f=this.margin.leftInset+this.margin.rightInset,h=this.margin.topInset+this.margin.bottomInset);f=Math.max(this[ja].width+f,this.w||0);k=Math.max(this[ja].height+h,this.h||0);h=[this.x,this.y,f,k];""===this.w&&(d.width=Ua(f));""===this.h&&(d.height=Ua(k));e={name:"div",attributes:g,children:e};Cg(this,g);delete this[ja];return Pa.success(re(this,e),h)};return c}(na),qu=function(a){function c(b){var d=a.call(this,\nDa,"execute")||this;d.connection=b.connection||"";d.executeType=ua(b.executeType,["import","remerge"]);d.id=b.id||"";d.runAt=ua(b.runAt,["client","both","server"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(na),ru=function(a){function c(b){var d=a.call(this,Da,"extras",!0)||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";d.boolean=new P;d.date=new P;d.dateTime=new P;d.decimal=new P;d.exData=new P;d.extras=new P;d.float=new P;d.image=new P;d.integer=\nnew P;d.text=new P;d.time=new P;return d}Ca(c,a);return c}(na),Sj=function(a){function c(d){var e=a.call(this,Da,"field",!0)||this;e.access=ua(d.access,["open","nonInteractive","protected","readOnly"]);e.accessKey=d.accessKey||"";e.anchorType=ua(d.anchorType,"topLeft bottomCenter bottomLeft bottomRight middleCenter middleLeft middleRight topCenter topRight".split(" "));e.colSpan=Ta({data:d.colSpan,defaultValue:1,validate:function(g){return 1<=g||-1===g}});e.h=d.h?Ma(d.h):"";e.hAlign=ua(d.hAlign,"left center justify justifyAll radix right".split(" "));\ne.id=d.id||"";e.locale=d.locale||"";e.maxH=Ma(d.maxH,"0pt");e.maxW=Ma(d.maxW,"0pt");e.minH=Ma(d.minH,"0pt");e.minW=Ma(d.minW,"0pt");e.name=d.name||"";e.presence=ua(d.presence,["visible","hidden","inactive","invisible"]);e.relevant=md(d.relevant);e.rotate=Ta({data:d.rotate,defaultValue:0,validate:function(g){return 0===g%90}});e.use=d.use||"";e.usehref=d.usehref||"";e.w=d.w?Ma(d.w):"";e.x=Ma(d.x,"0pt");e.y=Ma(d.y,"0pt");e.assist=null;e.bind=null;e.border=null;e.calculate=null;e.caption=null;e.desc=\nnull;e.extras=null;e.font=null;e.format=null;e.items=new P(2);e.keep=null;e.margin=null;e.para=null;e.traversal=null;e.ui=null;e.validate=null;e.value=null;e.bindItems=new P;e.connect=new P;e.event=new P;e.setProperty=new P;return e}Ca(c,a);var b=c.prototype;b[xe]=function(){return!0};b[Gc]=function(d){Mi(this,d)};b[Ra]=function(d){var e;Bg(this);if(!this.ui){this.ui=new Rj({});this.ui[rb]=this[rb];this[Cb](this.ui);switch(this.items.children.length){case 0:var g=new Ko({});this.ui.textEdit=g;break;\ncase 1:g=new Go({});this.ui.checkButton=g;break;case 2:g=new Ho({}),this.ui.choiceList=g}this.ui[Cb](g)}if(!this.ui||"hidden"===this.presence||"inactive"===this.presence||0===this.h||0===this.w)return Pa.EMPTY;this.caption&&delete this.caption[ja];this[cf]();g=this.caption?this.caption[Ra](d).html:null;var f=this.w,h=this.h,k=0,l=0;this.margin&&(k=this.margin.leftInset+this.margin.rightInset,l=this.margin.topInset+this.margin.bottomInset);var m=null;if(""===this.w||""===this.h){var n=0,p;if(this.ui.checkButton)n=\np=this.ui.checkButton.size;else if(p=Ii(this,d),m=p.w,p=p.h,null!==m)n=m;else{m=this.font;p=!0;void 0===p&&(p=!1);var q=null;m&&(q=ug(m.typeface),q=m[rb].fontFinder.find(q),q=Gi(m,q));m=q?Math.max(1,(q.lineHeight?Math.max(p?0:1.2,q.lineHeight):1.2)-(void 0===q.lineGap?.2:q.lineGap))*(m.size||10):10;p=m}m=Mm(this.ui[lc]());n+=m.w;p+=m.h;if(this.caption){var r=this.caption[lc](d);var t=r.w;q=r.h;if(r.isBroken&&this[Nb]()[Fd]())return this[Jc](),Pa.FAILURE;r=t;switch(this.caption.placement){case "left":case "right":case "inline":r+=\nn;break;case "top":case "bottom":q+=p}}else r=n,q=p;r&&""===this.w&&(r+=k,this.w=Math.min(0>=this.maxW?Infinity:this.maxW,this.minW+1<r?r:this.minW));q&&""===this.h&&(q+=l,this.h=Math.min(0>=this.maxH?Infinity:this.maxH,this.minH+1<q?q:this.minH))}this[Jc]();yg(this);Dg(this);if(!zg(this,d))return this.w=f,this.h=h,this[Jc](),Pa.FAILURE;Eg(this);k=Ac(this,"font","dimensions","position","rotate","anchorType","presence","margin","hAlign");xm(this,k);n=["xfaField"];this.font&&n.push("xfaFont");Ke(this)&&\nn.push("xfaPrintOnly");p={style:k,id:this[mb],class:n};k.margin&&(k.padding=k.margin,delete k.margin);Ji(this,n);this.name&&(p.xfaName=this.name);r=[];n={name:"div",attributes:p,children:r};Cg(this,p);t=this.border?this.border[gb]():null;p=zm(this,n,d);q=this.ui[Ra]().html;if(!q)return Object.assign(k,t),Pa.success(re(this,n),p);if(this[nd]){var v;null!=(v=q.children)&&v[0]?q.children[0].attributes.tabindex=this[nd]:q.attributes.tabindex=this[nd]}q.attributes.style||(q.attributes.style=Object.create(null));\nv=null;this.ui.button?(1===q.children.length&&(v=u.makeIterator(q.children.splice(0,1)).next().value),Object.assign(q.attributes.style,t)):Object.assign(k,t);r.push(q);if(this.value)if(this.ui.imageEdit)q.children.push(this.value[Ra]().html);else if(!this.ui.button){var w;r="";this.value.exData?r=this.value.exData[Sb]():this.value.text?r=this.value.text[lc]():(t=this.value[Ra]().html,null!==t&&(r=t.children[0].value));this.ui.textEdit&&null!=(w=this.value.text)&&w.maxChars&&(q.children[0].attributes.maxLength=\nthis.value.text.maxChars);r&&(this.ui.numericEdit&&(r=parseFloat(r),r=isNaN(r)?"":r.toString()),"textarea"===q.children[0].name?q.children[0].attributes.textContent=r:q.children[0].attributes.value=r)}!this.ui.imageEdit&&null!=(e=q.children)&&e[0]&&this.h&&(m=m||Mm(this.ui[lc]()),this.caption&&["top","bottom"].includes(this.caption.placement)?(e=this.caption.reserve,0>=e&&(e=this.caption[lc](d).h),q.children[0].attributes.style.height=Ua(this.h-e-l-m.h)):q.children[0].attributes.style.height="100%");\nv&&q.children.push(v);if(!g)return q.attributes.class&&q.attributes.class.push("xfaLeft"),this.w=f,this.h=h,Pa.success(re(this,n),p);if(this.ui.button)return k.padding&&delete k.padding,"div"===g.name&&(g.name="span"),q.children.push(g),Pa.success(n,p);this.ui.checkButton&&(g.attributes.class[0]="xfaCaptionForCheckButton");q.attributes.class||(q.attributes.class=[]);q.children.splice(0,0,g);switch(this.caption.placement){case "left":q.attributes.class.push("xfaLeft");break;case "right":q.attributes.class.push("xfaRight");\nbreak;case "top":q.attributes.class.push("xfaTop");break;case "bottom":q.attributes.class.push("xfaBottom");break;case "inline":q.attributes.class.push("xfaLeft")}this.w=f;this.h=h;return Pa.success(re(this,n),p)};return c}(na),su=function(a){function c(b){var d=a.call(this,Da,"fill",!0)||this;d.id=b.id||"";d.presence=ua(b.presence,["visible","hidden","inactive","invisible"]);d.use=b.use||"";d.usehref=b.usehref||"";d.color=null;d.extras=null;d.linear=null;d.pattern=null;d.radial=null;d.solid=null;\nd.stipple=null;return d}Ca(c,a);c.prototype[gb]=function(){var b,d=this[Va](),e=d[Va]()[Va](),g=Object.create(null),f="color",h=f;d instanceof Co&&(f="background-color",h="background",e instanceof Rj&&(g.backgroundColor="white"));if(d instanceof Lo||d instanceof Bo)f=h="fill",g.fill="white";d=u.makeIterator(Object.getOwnPropertyNames(this));for(e=d.next();!e.done;e=d.next())if(e=e.value,"extras"!==e&&"color"!==e&&(e=this[e],e instanceof na))return(b=e[gb](this.color))&&(g[b.startsWith("#")?f:h]=b),\ng;null!=(b=this.color)&&b.value&&(b=this.color[gb](),g[b.startsWith("#")?f:h]=b);return g};return c}(na),tu=function(a){function c(b){var d=a.call(this,Da,"filter",!0)||this;d.addRevocationInfo=ua(b.addRevocationInfo,["","required","optional","none"]);d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";d.version=Ta({data:d.version,defaultValue:5,validate:function(e){return 1<=e&&5>=e}});d.appearanceFilter=null;d.certificates=null;d.digestMethods=null;d.encodings=null;d.encryptionMethods=\nnull;d.handler=null;d.lockDocument=null;d.mdp=null;d.reasons=null;d.timeStamp=null;return d}Ca(c,a);return c}(na),uu=function(a){function c(d){var e=a.call(this,Da,"float")||this;e.id=d.id||"";e.name=d.name||"";e.use=d.use||"";e.usehref=d.usehref||"";return e}Ca(c,a);var b=c.prototype;b[sb]=function(){var d=parseFloat(this[ra].trim());this[ra]=isNaN(d)?null:d};b[Ra]=function(){return Sd(null!==this[ra]?this[ra].toString():"")};return c}(Hb),vu=function(a){function c(d){var e=a.call(this,Da,"font",\n!0)||this;e.baselineShift=Ma(d.baselineShift);e.fontHorizontalScale=vg({data:d.fontHorizontalScale,defaultValue:100,validate:function(g){return 0<=g}});e.fontVerticalScale=vg({data:d.fontVerticalScale,defaultValue:100,validate:function(g){return 0<=g}});e.id=d.id||"";e.kerningMode=ua(d.kerningMode,["none","pair"]);e.letterSpacing=Ma(d.letterSpacing,"0");e.lineThrough=Ta({data:d.lineThrough,defaultValue:0,validate:function(g){return 1===g||2===g}});e.lineThroughPeriod=ua(d.lineThroughPeriod,["all",\n"word"]);e.overline=Ta({data:d.overline,defaultValue:0,validate:function(g){return 1===g||2===g}});e.overlinePeriod=ua(d.overlinePeriod,["all","word"]);e.posture=ua(d.posture,["normal","italic"]);e.size=Ma(d.size,"10pt");e.typeface=d.typeface||"Courier";e.underline=Ta({data:d.underline,defaultValue:0,validate:function(g){return 1===g||2===g}});e.underlinePeriod=ua(d.underlinePeriod,["all","word"]);e.use=d.use||"";e.usehref=d.usehref||"";e.weight=ua(d.weight,["normal","bold"]);e.extras=null;e.fill=\nnull;return e}Ca(c,a);var b=c.prototype;b[dd]=function(d){a.prototype[dd].call(this,d);this[rb].usedTypefaces.add(this.typeface)};b[gb]=function(){var d=Ac(this,"fill"),e=d.color;e&&("#000000"===e?delete d.color:e.startsWith("#")||(d.background=e,d.backgroundClip="text",d.color="transparent"));this.baselineShift&&(d.verticalAlign=Ua(this.baselineShift));d.fontKerning="none"===this.kerningMode?"none":"normal";d.letterSpacing=Ua(this.letterSpacing);0!==this.lineThrough&&(d.textDecoration="line-through",\n2===this.lineThrough&&(d.textDecorationStyle="double"));0!==this.overline&&(d.textDecoration="overline",2===this.overline&&(d.textDecorationStyle="double"));d.fontStyle=this.posture;d.fontSize=Ua(.99*this.size);Fm(this,this,this[rb].fontFinder,d);0!==this.underline&&(d.textDecoration="underline",2===this.underline&&(d.textDecorationStyle="double"));d.fontWeight=this.weight;return d};return c}(na),wu=function(a){function c(b){var d=a.call(this,Da,"format",!0)||this;d.id=b.id||"";d.use=b.use||"";d.usehref=\nb.usehref||"";d.extras=null;d.picture=null;return d}Ca(c,a);return c}(na),xu=function(a){function c(b){var d=a.call(this,Da,"handler")||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(cb),yu=function(a){function c(b){var d=a.call(this,Da,"hyphenation")||this;d.excludeAllCaps=Ta({data:b.excludeAllCaps,defaultValue:0,validate:function(e){return 1===e}});d.excludeInitialCap=Ta({data:b.excludeInitialCap,defaultValue:0,validate:function(e){return 1===\ne}});d.hyphenate=Ta({data:b.hyphenate,defaultValue:0,validate:function(e){return 1===e}});d.id=b.id||"";d.pushCharacterCount=Ta({data:b.pushCharacterCount,defaultValue:3,validate:function(e){return 0<=e}});d.remainCharacterCount=Ta({data:b.remainCharacterCount,defaultValue:3,validate:function(e){return 0<=e}});d.use=b.use||"";d.usehref=b.usehref||"";d.wordCharacterCount=Ta({data:b.wordCharacterCount,defaultValue:7,validate:function(e){return 0<=e}});return d}Ca(c,a);return c}(na),Mo=function(a){function c(b){var d=\na.call(this,Da,"image")||this;d.aspect=ua(b.aspect,["fit","actual","height","none","width"]);d.contentType=b.contentType||"";d.href=b.href||"";d.id=b.id||"";d.name=b.name||"";d.transferEncoding=ua(b.transferEncoding,["base64","none","package"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);c.prototype[Ra]=function(){if(this.contentType&&!Ht.has(this.contentType.toLowerCase()))return Pa.EMPTY;var b=this[rb].images&&this[rb].images.get(this.href);if(!b&&(this.href||!this[ra]))return Pa.EMPTY;\nb||"base64"!==this.transferEncoding||(b=hp(this[ra]));if(!b)return Pa.EMPTY;if(!this.contentType){for(var d=u.makeIterator(It),e=d.next();!e.done;e=d.next()){var g=u.makeIterator(e.value);e=g.next().value;g=g.next().value;if(b.length>e.length&&e.every(function(h,k){return h===b[k]})){this.contentType=g;break}}if(!this.contentType)return Pa.EMPTY}d=new Blob([b],{type:this.contentType});switch(this.aspect){case "height":var f={height:"100%",objectFit:"fill"};break;case "none":f={width:"100%",height:"100%",\nobjectFit:"fill"};break;case "width":f={width:"100%",objectFit:"fill"}}e=this[Va]();return Pa.success({name:"img",attributes:{class:["xfaImage"],style:f,src:URL.createObjectURL(d),alt:e?se(e[Va]()):null}})};return c}(cb),zu=function(a){function c(b){var d=a.call(this,Da,"imageEdit",!0)||this;d.data=ua(b.data,["link","embed"]);d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.border=null;d.extras=null;d.margin=null;return d}Ca(c,a);c.prototype[Ra]=function(){return"embed"===this.data?Pa.success({name:"div",\nchildren:[],attributes:{}}):Pa.EMPTY};return c}(na),Au=function(a){function c(d){var e=a.call(this,Da,"integer")||this;e.id=d.id||"";e.name=d.name||"";e.use=d.use||"";e.usehref=d.usehref||"";return e}Ca(c,a);var b=c.prototype;b[sb]=function(){var d=parseInt(this[ra].trim(),10);this[ra]=isNaN(d)?null:d};b[Ra]=function(){return Sd(null!==this[ra]?this[ra].toString():"")};return c}(Hb),Bu=function(a){function c(b){var d=a.call(this,Da,"issuers",!0)||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);\nd.use=b.use||"";d.usehref=b.usehref||"";d.certificate=new P;return d}Ca(c,a);return c}(na),Tj=function(a){function c(b){var d=a.call(this,Da,"items",!0)||this;d.id=b.id||"";d.name=b.name||"";d.presence=ua(b.presence,["visible","hidden","inactive","invisible"]);d.ref=b.ref||"";d.save=Ta({data:b.save,defaultValue:0,validate:function(e){return 1===e}});d.use=b.use||"";d.usehref=b.usehref||"";d.boolean=new P;d.date=new P;d.dateTime=new P;d.decimal=new P;d.exData=new P;d.float=new P;d.image=new P;d.integer=\nnew P;d.text=new P;d.time=new P;return d}Ca(c,a);c.prototype[Ra]=function(){for(var b=[],d=u.makeIterator(this[ac]()),e=d.next();!e.done;e=d.next())b.push(e.value[Sb]());return Pa.success(b)};return c}(na),Cu=function(a){function c(b){var d=a.call(this,Da,"keep",!0)||this;d.id=b.id||"";var e=["none","contentArea","pageArea"];d.intact=ua(b.intact,e);d.next=ua(b.next,e);d.previous=ua(b.previous,e);d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;return d}Ca(c,a);return c}(na),Du=function(a){function c(b){var d=\na.call(this,Da,"keyUsage")||this;var e=["","yes","no"];d.crlSign=ua(b.crlSign,e);d.dataEncipherment=ua(b.dataEncipherment,e);d.decipherOnly=ua(b.decipherOnly,e);d.digitalSignature=ua(b.digitalSignature,e);d.encipherOnly=ua(b.encipherOnly,e);d.id=b.id||"";d.keyAgreement=ua(b.keyAgreement,e);d.keyCertSign=ua(b.keyCertSign,e);d.keyEncipherment=ua(b.keyEncipherment,e);d.nonRepudiation=ua(b.nonRepudiation,e);d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,\na);return c}(na),Eu=function(a){function c(b){var d=a.call(this,Da,"line",!0)||this;d.hand=ua(b.hand,["even","left","right"]);d.id=b.id||"";d.slope=ua(b.slope,["\\\\","/"]);d.use=b.use||"";d.usehref=b.usehref||"";d.edge=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b=this[Va]()[Va](),d=this.edge||new Tf({}),e=d[gb](),g=Object.create(null);d="visible"===d.presence?d.thickness:0;g.strokeWidth=Ua(d);g.stroke=e.color;var f="100%",h="100%";if(b.w<=d){f=u.makeIterator(["50%",0,"50%","100%"]);d=f.next().value;\ne=f.next().value;var k=f.next().value;var l=f.next().value;f=g.strokeWidth}else b.h<=d?(h=u.makeIterator([0,"50%","100%","50%"]),d=h.next().value,e=h.next().value,k=h.next().value,l=h.next().value,h=g.strokeWidth):"\\\\"===this.slope?(l=u.makeIterator([0,0,"100%","100%"]),d=l.next().value,e=l.next().value,k=l.next().value,l=l.next().value):(l=u.makeIterator([0,"100%","100%",0]),d=l.next().value,e=l.next().value,k=l.next().value,l=l.next().value);g={name:"svg",children:[{name:"line",attributes:{xmlns:"http://www.w3.org/2000/svg",\nx1:d,y1:e,x2:k,y2:l,style:g}}],attributes:{xmlns:"http://www.w3.org/2000/svg",width:f,height:h,style:{overflow:"visible"}}};if(Li(b))return Pa.success({name:"div",attributes:{style:{display:"inline",width:"100%",height:"100%"}},children:[g]});g.attributes.style.position="absolute";return Pa.success(g)};return c}(na),Fu=function(a){function c(b){var d=a.call(this,Da,"linear",!0)||this;d.id=b.id||"";d.type=ua(b.type,["toRight","toBottom","toLeft","toTop"]);d.use=b.use||"";d.usehref=b.usehref||"";d.color=\nnull;d.extras=null;return d}Ca(c,a);c.prototype[gb]=function(b){b=b?b[gb]():"#FFFFFF";var d=this.type.replace(/([RBLT])/," $1").toLowerCase(),e=this.color?this.color[gb]():"#000000";return"linear-gradient("+d+", "+b+", "+e+")"};return c}(na),Gu=function(a){function c(b){var d=a.call(this,Da,"lockDocument")||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);c.prototype[sb]=function(){this[ra]=ua(this[ra],["auto","0","1"])};return c}(Hb),\nHu=function(a){function c(b){var d=a.call(this,Da,"manifest",!0)||this;d.action=ua(b.action,["include","all","exclude"]);d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;d.ref=new P;return d}Ca(c,a);return c}(na),Iu=function(a){function c(b){var d=a.call(this,Da,"margin",!0)||this;d.bottomInset=Ma(b.bottomInset,"0");d.id=b.id||"";d.leftInset=Ma(b.leftInset,"0");d.rightInset=Ma(b.rightInset,"0");d.topInset=Ma(b.topInset,"0");d.use=b.use||"";d.usehref=b.usehref||\n"";d.extras=null;return d}Ca(c,a);c.prototype[gb]=function(){return{margin:Ua(this.topInset)+" "+Ua(this.rightInset)+" "+Ua(this.bottomInset)+" "+Ua(this.leftInset)}};return c}(na),Ju=function(a){function c(b){var d=a.call(this,Da,"mdp")||this;d.id=b.id||"";d.permissions=Ta({data:b.permissions,defaultValue:2,validate:function(e){return 1===e||3===e}});d.signatureType=ua(b.signatureType,["filler","author"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(na),Ku=function(a){function c(b){var d=\na.call(this,Da,"medium")||this;d.id=b.id||"";d.imagingBBox=Mq(b.imagingBBox);d.long=Ma(b.long);d.orientation=ua(b.orientation,["portrait","landscape"]);d.short=Ma(b.short);d.stock=b.stock||"";d.trayIn=ua(b.trayIn,["auto","delegate","pageFront"]);d.trayOut=ua(b.trayOut,["auto","delegate"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(na),Lu=function(a){function c(b){var d=a.call(this,Da,"message",!0)||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.text=new P;return d}\nCa(c,a);return c}(na),Mu=function(a){function c(b){var d=a.call(this,Da,"numericEdit",!0)||this;d.hScrollPolicy=ua(b.hScrollPolicy,["auto","off","on"]);d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.border=null;d.comb=null;d.extras=null;d.margin=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b,d=Ac(this,"border","font","margin"),e=this[Va]()[Va](),g={name:"input",attributes:{type:"text",fieldId:e[mb],dataId:(null==(b=e[ed])?void 0:b[mb])||e[mb],class:["xfaTextfield"],style:d,"aria-label":se(e),\n"aria-required":!1}};rf(e)&&(g.attributes["aria-required"]=!0,g.attributes.required=!0);return Pa.success({name:"label",attributes:{class:["xfaLabel"]},children:[g]})};return c}(na),Nu=function(a){function c(b){var d=a.call(this,Da,"occur",!0)||this;d.id=b.id||"";d.initial=""!==b.initial?Ta({data:b.initial,defaultValue:"",validate:function(){return!0}}):"";d.max=""!==b.max?Ta({data:b.max,defaultValue:1,validate:function(){return!0}}):"";d.min=""!==b.min?Ta({data:b.min,defaultValue:1,validate:function(){return!0}}):\n"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;return d}Ca(c,a);c.prototype[dd]=function(){var b=this[Va](),d=this.min;""===this.min&&(this.min=b instanceof Me||b instanceof Uj?0:1);""===this.max&&(this.max=""===d?b instanceof Me||b instanceof Uj?-1:1:this.min);-1!==this.max&&this.max<this.min&&(this.max=this.min);""===this.initial&&(this.initial=b instanceof Vj?1:this.min)};return c}(na),Ou=function(a){function c(b){var d=a.call(this,Da,"oid")||this;d.id=b.id||"";d.name=b.name||"";d.use=\nb.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(cb),Pu=function(a){function c(b){var d=a.call(this,Da,"oids",!0)||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";d.oid=new P;return d}Ca(c,a);return c}(na),No=function(a){function c(b){var d=a.call(this,Da,"overflow")||this;d.id=b.id||"";d.leader=b.leader||"";d.target=b.target||"";d.trailer=b.trailer||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);c.prototype[lc]=function(){if(!this[ja]){var b=\nthis[Va](),d=this[Ob](),e=d[Hd](this.target,b),g=d[Hd](this.leader,b);b=d[Hd](this.trailer,b);this[ja]={target:(null==e?void 0:e[0])||null,leader:(null==g?void 0:g[0])||null,trailer:(null==b?void 0:b[0])||null,addLeader:!1,addTrailer:!1}}return this[ja]};return c}(na),Me=function(a){function c(d){var e=a.call(this,Da,"pageArea",!0)||this;e.blankOrNotBlank=ua(d.blankOrNotBlank,["any","blank","notBlank"]);e.id=d.id||"";e.initialNumber=Ta({data:d.initialNumber,defaultValue:1,validate:function(){return!0}});\ne.name=d.name||"";e.numbered=Ta({data:d.numbered,defaultValue:1,validate:function(){return!0}});e.oddOrEven=ua(d.oddOrEven,["any","even","odd"]);e.pagePosition=ua(d.pagePosition,["any","first","last","only","rest"]);e.relevant=md(d.relevant);e.use=d.use||"";e.usehref=d.usehref||"";e.desc=null;e.extras=null;e.medium=null;e.occur=null;e.area=new P;e.contentArea=new P;e.draw=new P;e.exclGroup=new P;e.field=new P;e.subform=new P;return e}Ca(c,a);var b=c.prototype;b[Nf]=function(){return this[ja]?!this.occur||\n-1===this.occur.max||this[ja].numberOfUse<this.occur.max:(this[ja]={numberOfUse:0},!0)};b[Ze]=function(){delete this[ja]};b[Kd]=function(){this[ja]||(this[ja]={numberOfUse:0});var d=this[Va]();return"orderedOccurrence"===d.relation&&this[Nf]()?(this[ja].numberOfUse+=1,this):d[Kd]()};b[we]=function(){return this[ja].space||{width:0,height:0}};b[Ra]=function(){this[ja]||(this[ja]={numberOfUse:1});var d=[];this[ja].children=d;var e=Object.create(null);if(this.medium&&this.medium.short&&this.medium.long){if(e.width=\nUa(this.medium.short),e.height=Ua(this.medium.long),this[ja].space={width:this.medium.short,height:this.medium.long},"landscape"===this.medium.orientation){var g=e.width;e.width=e.height;e.height=g;this[ja].space={width:this.medium.long,height:this.medium.short}}}else T("XFA - No medium specified in pageArea: please file a bug.");this[Xd]({filter:new Set(["area","draw","field","subform"]),include:!0});this[Xd]({filter:new Set(["contentArea"]),include:!0});return Pa.success({name:"div",children:d,\nattributes:{class:["xfaPage"],id:this[mb],style:e,xfaName:this.name}})};return c}(na),Uj=function(a){function c(d){var e=a.call(this,Da,"pageSet",!0)||this;e.duplexImposition=ua(d.duplexImposition,["longEdge","shortEdge"]);e.id=d.id||"";e.name=d.name||"";e.relation=ua(d.relation,["orderedOccurrence","duplexPaginated","simplexPaginated"]);e.relevant=md(d.relevant);e.use=d.use||"";e.usehref=d.usehref||"";e.extras=null;e.occur=null;e.pageArea=new P;e.pageSet=new P;return e}Ca(c,a);var b=c.prototype;\nb[Ze]=function(){for(var d=u.makeIterator(this.pageArea.children),e=d.next();!e.done;e=d.next())e.value[Ze]();d=u.makeIterator(this.pageSet.children);for(e=d.next();!e.done;e=d.next())e.value[Ze]()};b[Nf]=function(){return!this.occur||-1===this.occur.max||this[ja].numberOfUse<this.occur.max};b[Kd]=function(){this[ja]||(this[ja]={numberOfUse:1,pageIndex:-1,pageSetIndex:-1});if("orderedOccurrence"===this.relation){if(this[ja].pageIndex+1<this.pageArea.children.length)return this[ja].pageIndex+=1,this.pageArea.children[this[ja].pageIndex][Kd]();\nif(this[ja].pageSetIndex+1<this.pageSet.children.length)return this[ja].pageSetIndex+=1,this.pageSet.children[this[ja].pageSetIndex][Kd]();if(this[Nf]())return this[ja].numberOfUse+=1,this[ja].pageIndex=-1,this[ja].pageSetIndex=-1,this[Kd]();var d=this[Va]();if(d instanceof c)return d[Kd]();this[Ze]();return this[Kd]()}d=this[Ob]()[ja].pageNumber;var e=0===d%2?"even":"odd",g=0===d?"first":"rest";return(d=this.pageArea.children.find(function(f){return f.oddOrEven===e&&f.pagePosition===g}))||(d=this.pageArea.children.find(function(f){return"any"===\nf.oddOrEven&&f.pagePosition===g}))?d:(d=this.pageArea.children.find(function(f){return"any"===f.oddOrEven&&"any"===f.pagePosition}))?d:this.pageArea.children[0]};return c}(na),Qu=function(a){function c(b){var d=a.call(this,Da,"para",!0)||this;d.hAlign=ua(b.hAlign,"left center justify justifyAll radix right".split(" "));d.id=b.id||"";d.lineHeight=b.lineHeight?Ma(b.lineHeight,"0pt"):"";d.marginLeft=b.marginLeft?Ma(b.marginLeft,"0pt"):"";d.marginRight=b.marginRight?Ma(b.marginRight,"0pt"):"";d.orphans=\nTa({data:b.orphans,defaultValue:0,validate:function(e){return 0<=e}});d.preserve=b.preserve||"";d.radixOffset=b.radixOffset?Ma(b.radixOffset,"0pt"):"";d.spaceAbove=b.spaceAbove?Ma(b.spaceAbove,"0pt"):"";d.spaceBelow=b.spaceBelow?Ma(b.spaceBelow,"0pt"):"";d.tabDefault=b.tabDefault?Ma(d.tabDefault):"";d.tabStops=(b.tabStops||"").trim().split(/\\s+/).map(function(e,g){return 1===g%2?Ma(e):e});d.textIndent=b.textIndent?Ma(b.textIndent,"0pt"):"";d.use=b.use||"";d.usehref=b.usehref||"";d.vAlign=ua(b.vAlign,\n["top","bottom","middle"]);d.widows=Ta({data:b.widows,defaultValue:0,validate:function(e){return 0<=e}});d.hyphenation=null;return d}Ca(c,a);c.prototype[gb]=function(){var b=Ac(this,"hAlign");""!==this.marginLeft&&(b.paddingLeft=Ua(this.marginLeft));""!==this.marginRight&&(b.paddingight=Ua(this.marginRight));""!==this.spaceAbove&&(b.paddingTop=Ua(this.spaceAbove));""!==this.spaceBelow&&(b.paddingBottom=Ua(this.spaceBelow));""!==this.textIndent&&(b.textIndent=Ua(this.textIndent),Cm(b));0<this.lineHeight&&\n(b.lineHeight=Ua(this.lineHeight));""!==this.tabDefault&&(b.tabSize=Ua(this.tabDefault));this.hyphenatation&&Object.assign(b,this.hyphenatation[gb]());return b};return c}(na),Ru=function(a){function c(b){var d=a.call(this,Da,"passwordEdit",!0)||this;d.hScrollPolicy=ua(b.hScrollPolicy,["auto","off","on"]);d.id=b.id||"";d.passwordChar=b.passwordChar||"*";d.use=b.use||"";d.usehref=b.usehref||"";d.border=null;d.extras=null;d.margin=null;return d}Ca(c,a);return c}(na),Su=function(a){function c(b){var d=\na.call(this,Da,"pattern",!0)||this;d.id=b.id||"";d.type=ua(b.type,"crossHatch crossDiagonal diagonalLeft diagonalRight horizontal vertical".split(" "));d.use=b.use||"";d.usehref=b.usehref||"";d.color=null;d.extras=null;return d}Ca(c,a);c.prototype[gb]=function(b){b=b?b[gb]():"#FFFFFF";var d=this.color?this.color[gb]():"#000000";b=b+","+b+" 5px,"+d+" 5px,"+d+" 10px";switch(this.type){case "crossHatch":return"repeating-linear-gradient(to top,"+b+") repeating-linear-gradient(to right,"+b+")";case "crossDiagonal":return"repeating-linear-gradient(45deg,"+\nb+") repeating-linear-gradient(-45deg,"+b+")";case "diagonalLeft":return"repeating-linear-gradient(45deg,"+b+")";case "diagonalRight":return"repeating-linear-gradient(-45deg,"+b+")";case "horizontal":return"repeating-linear-gradient(to top,"+b+")";case "vertical":return"repeating-linear-gradient(to right,"+b+")"}return""};return c}(na),Tu=function(a){function c(b){var d=a.call(this,Da,"picture")||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(cb),Uu=function(a){function c(){var b=\na.call(this,Da,"proto",!0)||this;b.appearanceFilter=new P;b.arc=new P;b.area=new P;b.assist=new P;b.barcode=new P;b.bindItems=new P;b.bookend=new P;b.boolean=new P;b.border=new P;b.break=new P;b.breakAfter=new P;b.breakBefore=new P;b.button=new P;b.calculate=new P;b.caption=new P;b.certificate=new P;b.certificates=new P;b.checkButton=new P;b.choiceList=new P;b.color=new P;b.comb=new P;b.connect=new P;b.contentArea=new P;b.corner=new P;b.date=new P;b.dateTime=new P;b.dateTimeEdit=new P;b.decimal=new P;\nb.defaultUi=new P;b.desc=new P;b.digestMethod=new P;b.digestMethods=new P;b.draw=new P;b.edge=new P;b.encoding=new P;b.encodings=new P;b.encrypt=new P;b.encryptData=new P;b.encryption=new P;b.encryptionMethod=new P;b.encryptionMethods=new P;b.event=new P;b.exData=new P;b.exObject=new P;b.exclGroup=new P;b.execute=new P;b.extras=new P;b.field=new P;b.fill=new P;b.filter=new P;b.float=new P;b.font=new P;b.format=new P;b.handler=new P;b.hyphenation=new P;b.image=new P;b.imageEdit=new P;b.integer=new P;\nb.issuers=new P;b.items=new P;b.keep=new P;b.keyUsage=new P;b.line=new P;b.linear=new P;b.lockDocument=new P;b.manifest=new P;b.margin=new P;b.mdp=new P;b.medium=new P;b.message=new P;b.numericEdit=new P;b.occur=new P;b.oid=new P;b.oids=new P;b.overflow=new P;b.pageArea=new P;b.pageSet=new P;b.para=new P;b.passwordEdit=new P;b.pattern=new P;b.picture=new P;b.radial=new P;b.reason=new P;b.reasons=new P;b.rectangle=new P;b.ref=new P;b.script=new P;b.setProperty=new P;b.signData=new P;b.signature=new P;\nb.signing=new P;b.solid=new P;b.speak=new P;b.stipple=new P;b.subform=new P;b.subformSet=new P;b.subjectDN=new P;b.subjectDNs=new P;b.submit=new P;b.text=new P;b.textEdit=new P;b.time=new P;b.timeStamp=new P;b.toolTip=new P;b.traversal=new P;b.traverse=new P;b.ui=new P;b.validate=new P;b.value=new P;b.variables=new P;return b}Ca(c,a);return c}(na),Vu=function(a){function c(b){var d=a.call(this,Da,"radial",!0)||this;d.id=b.id||"";d.type=ua(b.type,["toEdge","toCenter"]);d.use=b.use||"";d.usehref=b.usehref||\n"";d.color=null;d.extras=null;return d}Ca(c,a);c.prototype[gb]=function(b){b=b?b[gb]():"#FFFFFF";var d=this.color?this.color[gb]():"#000000";return"radial-gradient(circle at center, "+("toEdge"===this.type?b+","+d:d+","+b)+")"};return c}(na),Wu=function(a){function c(b){var d=a.call(this,Da,"reason")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(cb),Xu=function(a){function c(b){var d=a.call(this,Da,"reasons",!0)||this;d.id=b.id||"";d.type=\nua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";d.reason=new P;return d}Ca(c,a);return c}(na),Lo=function(a){function c(b){var d=a.call(this,Da,"rectangle",!0)||this;d.hand=ua(b.hand,["even","left","right"]);d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.corner=new P(4);d.edge=new P(4);d.fill=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b,d=this.edge.children.length?this.edge.children[0]:new Tf({}),e=d[gb](),g=Object.create(null);"visible"===(null==(b=this.fill)?\nvoid 0:b.presence)?Object.assign(g,this.fill[gb]()):g.fill="transparent";g.strokeWidth=Ua("visible"===d.presence?d.thickness:0);g.stroke=e.color;b=(this.corner.children.length?this.corner.children[0]:new Io({}))[gb]();g={name:"svg",children:[{name:"rect",attributes:{xmlns:"http://www.w3.org/2000/svg",width:"100%",height:"100%",x:0,y:0,rx:b.radius,ry:b.radius,style:g}}],attributes:{xmlns:"http://www.w3.org/2000/svg",style:{overflow:"visible"},width:"100%",height:"100%"}};b=this[Va]()[Va]();if(Li(b))return Pa.success({name:"div",\nattributes:{style:{display:"inline",width:"100%",height:"100%"}},children:[g]});g.attributes.style.position="absolute";return Pa.success(g)};return c}(na),Yu=function(a){function c(b){var d=a.call(this,Da,"ref")||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(cb),Zu=function(a){function c(b){var d=a.call(this,Da,"script")||this;d.binding=b.binding||"";d.contentType=b.contentType||"";d.id=b.id||"";d.name=b.name||"";d.runAt=ua(b.runAt,["client","both","server"]);\nd.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(cb),Wj=function(a){function c(b){var d=a.call(this,Da,"setProperty")||this;d.connection=b.connection||"";d.ref=b.ref||"";d.target=b.target||"";return d}Ca(c,a);return c}(na),$u=function(a){function c(b){var d=a.call(this,Da,"signData",!0)||this;d.id=b.id||"";d.operation=ua(b.operation,["sign","clear","verify"]);d.ref=b.ref||"";d.target=b.target||"";d.use=b.use||"";d.usehref=b.usehref||"";d.filter=null;d.manifest=null;return d}Ca(c,\na);return c}(na),av=function(a){function c(b){var d=a.call(this,Da,"signature",!0)||this;d.id=b.id||"";d.type=ua(b.type,["PDF1.3","PDF1.6"]);d.use=b.use||"";d.usehref=b.usehref||"";d.border=null;d.extras=null;d.filter=null;d.manifest=null;d.margin=null;return d}Ca(c,a);return c}(na),bv=function(a){function c(b){var d=a.call(this,Da,"signing",!0)||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";d.certificate=new P;return d}Ca(c,a);return c}(na),\ncv=function(a){function c(b){var d=a.call(this,Da,"solid",!0)||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;return d}Ca(c,a);c.prototype[gb]=function(b){return b?b[gb]():"#FFFFFF"};return c}(na),dv=function(a){function c(b){var d=a.call(this,Da,"speak")||this;d.disable=Ta({data:b.disable,defaultValue:0,validate:function(e){return 1===e}});d.id=b.id||"";d.priority=ua(b.priority,["custom","caption","name","toolTip"]);d.rid=b.rid||"";d.use=b.use||"";d.usehref=b.usehref||"";\nreturn d}Ca(c,a);return c}(cb),ev=function(a){function c(b){var d=a.call(this,Da,"stipple",!0)||this;d.id=b.id||"";d.rate=Ta({data:b.rate,defaultValue:50,validate:function(e){return 0<=e&&100>=e}});d.use=b.use||"";d.usehref=b.usehref||"";d.color=null;d.extras=null;return d}Ca(c,a);c.prototype[gb]=function(b){var d=this.rate/100;return Rb.makeHexColor(Math.round(b.value.r*(1-d)+this.value.r*d),Math.round(b.value.g*(1-d)+this.value.g*d),Math.round(b.value.b*(1-d)+this.value.b*d))};return c}(na),Oo=\nfunction(a){function c(d){var e=a.call(this,Da,"subform",!0)||this;e.access=ua(d.access,["open","nonInteractive","protected","readOnly"]);e.allowMacro=Ta({data:d.allowMacro,defaultValue:0,validate:function(g){return 1===g}});e.anchorType=ua(d.anchorType,"topLeft bottomCenter bottomLeft bottomRight middleCenter middleLeft middleRight topCenter topRight".split(" "));e.colSpan=Ta({data:d.colSpan,defaultValue:1,validate:function(g){return 1<=g||-1===g}});e.columnWidths=(d.columnWidths||"").trim().split(/\\s+/).map(function(g){return"-1"===\ng?-1:Ma(g)});e.h=d.h?Ma(d.h):"";e.hAlign=ua(d.hAlign,"left center justify justifyAll radix right".split(" "));e.id=d.id||"";e.layout=ua(d.layout,"position lr-tb rl-row rl-tb row table tb".split(" "));e.locale=d.locale||"";e.maxH=Ma(d.maxH,"0pt");e.maxW=Ma(d.maxW,"0pt");e.mergeMode=ua(d.mergeMode,["consumeData","matchTemplate"]);e.minH=Ma(d.minH,"0pt");e.minW=Ma(d.minW,"0pt");e.name=d.name||"";e.presence=ua(d.presence,["visible","hidden","inactive","invisible"]);e.relevant=md(d.relevant);e.restoreState=\nua(d.restoreState,["manual","auto"]);e.scope=ua(d.scope,["name","none"]);e.use=d.use||"";e.usehref=d.usehref||"";e.w=d.w?Ma(d.w):"";e.x=Ma(d.x,"0pt");e.y=Ma(d.y,"0pt");e.assist=null;e.bind=null;e.bookend=null;e.border=null;e.break=null;e.calculate=null;e.desc=null;e.extras=null;e.keep=null;e.margin=null;e.occur=null;e.overflow=null;e.pageSet=null;e.para=null;e.traversal=null;e.validate=null;e.variables=null;e.area=new P;e.breakAfter=new P;e.breakBefore=new P;e.connect=new P;e.draw=new P;e.event=new P;\ne.exObject=new P;e.exclGroup=new P;e.field=new P;e.proto=new P;e.setProperty=new P;e.subform=new P;e.subformSet=new P;return e}Ca(c,a);var b=c.prototype;b[Nb]=function(){var d=this[Va]();return d instanceof Oi?d[Nb]():d};b[xe]=function(){return!0};b[Fd]=function(){return this.layout.endsWith("-tb")&&0===this[ja].attempt&&0<this[ja].numberInLine||this[Va]()[Fd]()};b[Le]=function e(){var g=this;return u.generator.createGenerator(e,function(f){return f.yieldAll(Ag(g),0)})};b[qf]=function(){return Im(this)};\nb[te]=function(e,g){Jm(this,e,g)};b[we]=function(){return Km(this)};b[Gd]=function(){var e,g=this[Nb]();return g[Gd]()?void 0!==this[ja]._isSplittable?this[ja]._isSplittable:"position"===this.layout||this.layout.includes("row")||this.keep&&"none"!==this.keep.intact?this[ja]._isSplittable=!1:null!=(e=g.layout)&&e.endsWith("-tb")&&0!==g[ja].numberInLine?!1:this[ja]._isSplittable=!0:!1};b[Ra]=function(e){var g;Bg(this);if(this.break){if("auto"!==this.break.after||""!==this.break.afterTarget){var f=new Do({targetType:this.break.after,\ntarget:this.break.afterTarget,startNew:this.break.startNew.toString()});f[rb]=this[rb];this[Cb](f);this.breakAfter.push(f)}if("auto"!==this.break.before||""!==this.break.beforeTarget)f=new Eo({targetType:this.break.before,target:this.break.beforeTarget,startNew:this.break.startNew.toString()}),f[rb]=this[rb],this[Cb](f),this.breakBefore.push(f);""!==this.break.overflowTarget&&(f=new No({target:this.break.overflowTarget,leader:this.break.overflowLeader,trailer:this.break.overflowTrailer}),f[rb]=this[rb],\nthis[Cb](f),this.overflow.push(f));this[$d](this.break);this.break=null}if("hidden"===this.presence||"inactive"===this.presence)return Pa.EMPTY;(1<this.breakBefore.children.length||1<this.breakAfter.children.length)&&T("XFA - Several breakBefore or breakAfter in subforms: please file a bug.");if(1<=this.breakBefore.children.length&&(f=this.breakBefore.children[0],Nm(f)))return Pa.breakNode(f);if(null!=(g=this[ja])&&g.afterBreakAfter)return Pa.EMPTY;yg(this);f=[];g={id:this[mb],class:[]};Ji(this,g.class);\nthis[ja]||(this[ja]=Object.create(null));Object.assign(this[ja],{children:f,line:null,attributes:g,attempt:0,numberInLine:0,availableSpace:{width:Math.min(this.w||Infinity,e.width),height:Math.min(this.h||Infinity,e.height)},width:0,height:0,prevHeight:0,currentWidth:0});var h=this[Ob](),k=h[ja].noLayoutFailure,l=this[Gd]();l||Dg(this);if(!zg(this,e))return Pa.FAILURE;var m=new Set("area draw exclGroup field subform subformSet".split(" "));if(this.layout.includes("row")){var n=this[Nb]().columnWidths;\nArray.isArray(n)&&0<n.length&&(this[ja].columnWidths=n,this[ja].currentColumn=0)}n=Ac(this,"anchorType","dimensions","position","presence","border","margin","hAlign");var p=["xfaSubform"],q=Am(this);q&&p.push(q);g.style=n;g.class=p;this.name&&(g.xfaName=this.name);this.overflow&&(p=this.overflow[lc](),p.addLeader&&(p.addLeader=!1,Om(this,p.leader,e)));this[cf]();for(q=(p="lr-tb"===this.layout||"rl-tb"===this.layout)?2:1;this[ja].attempt<q;this[ja].attempt++){p&&1===this[ja].attempt&&(this[ja].numberInLine=\n0);var r=this[Xd]({filter:m,include:!0});if(r.success)break;if(r.isBreak())return this[Jc](),r;if(p&&0===this[ja].attempt&&0===this[ja].numberInLine&&!h[ja].noLayoutFailure){this[ja].attempt=q;break}}this[Jc]();l||Eg(this);h[ja].noLayoutFailure=k;if(this[ja].attempt===q)return this.overflow&&(this[Ob]()[ja].overflowNode=this.overflow),l||delete this[ja],Pa.FAILURE;this.overflow&&(h=this.overflow[lc](),h.addTrailer&&(h.addTrailer=!1,Om(this,h.trailer,e)));h=e=0;this.margin&&(e=this.margin.leftInset+\nthis.margin.rightInset,h=this.margin.topInset+this.margin.bottomInset);e=Math.max(this[ja].width+e,this.w||0);k=Math.max(this[ja].height+h,this.h||0);h=[this.x,this.y,e,k];""===this.w&&(n.width=Ua(e));""===this.h&&(n.height=Ua(k));if(("0px"===n.width||"0px"===n.height)&&0===f.length)return Pa.EMPTY;e={name:"div",attributes:g,children:f};Cg(this,g);g=Pa.success(re(this,e),h);if(1<=this.breakAfter.children.length&&(e=this.breakAfter.children[0],Nm(e)))return this[ja].afterBreakAfter=g,Pa.breakNode(e);\ndelete this[ja];return g};return c}(na),Oi=function(a){function c(d){var e=a.call(this,Da,"subformSet",!0)||this;e.id=d.id||"";e.name=d.name||"";e.relation=ua(d.relation,["ordered","choice","unordered"]);e.relevant=md(d.relevant);e.use=d.use||"";e.usehref=d.usehref||"";e.bookend=null;e.break=null;e.desc=null;e.extras=null;e.occur=null;e.overflow=null;e.breakAfter=new P;e.breakBefore=new P;e.subform=new P;e.subformSet=new P;return e}Ca(c,a);var b=c.prototype;b[Le]=function e(){var g=this;return u.generator.createGenerator(e,\nfunction(f){return f.yieldAll(Ag(g),0)})};b[Nb]=function(){for(var e=this[Va]();!(e instanceof Oo);)e=e[Va]();return e};b[xe]=function(){return!0};return c}(na),fv=function(a){function c(b){var d=a.call(this,Da,"subjectDN")||this;d.delimiter=b.delimiter||",";d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);c.prototype[sb]=function(){this[ra]=new Map(this[ra].split(this.delimiter).map(function(b){b=b.split("=",2);b[0]=b[0].trim();return b}))};return c}(Hb),gv=\nfunction(a){function c(b){var d=a.call(this,Da,"subjectDNs",!0)||this;d.id=b.id||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";d.subjectDN=new P;return d}Ca(c,a);return c}(na),hv=function(a){function c(b){var d=a.call(this,Da,"submit",!0)||this;d.embedPDF=Ta({data:b.embedPDF,defaultValue:0,validate:function(e){return 1===e}});d.format=ua(b.format,"xdp formdata pdf urlencoded xfd xml".split(" "));d.id=b.id||"";d.target=b.target||"";d.textEncoding=wg({data:b.textEncoding?\nb.textEncoding.toLowerCase():"",defaultValue:"",validate:function(e){return"utf-8 big-five fontspecific gbk gb-18030 gb-2312 ksc-5601 none shift-jis ucs-2 utf-16".split(" ").includes(e)||e.match(/iso-8859-\\d{2}/)}});d.use=b.use||"";d.usehref=b.usehref||"";d.xdpContent=b.xdpContent||"";d.encrypt=null;d.encryptData=new P;d.signData=new P;return d}Ca(c,a);return c}(na),Vj=function(a){function c(d){var e=a.call(this,Da,"template",!0)||this;e.baseProfile=ua(d.baseProfile,["full","interactiveForms"]);e.extras=\nnull;e.subform=new P;return e}Ca(c,a);var b=c.prototype;b[sb]=function(){0===this.subform.children.length&&T("XFA - No subforms in template node.");2<=this.subform.children.length&&T("XFA - Several subforms in template node: please file a bug.");this[nd]=5E3};b[Gd]=function(){return!0};b[Hd]=function(d,e){return d.startsWith("#")?[this[af].get(d.slice(1))]:Rd(this,e,d,!0,!0)};b[vo]=function e(){var g,f,h=this,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S;return u.generator.createGenerator(e,\nfunction(da){if(1==da.nextAddress){if(!h.subform.children.length)return da.return(Pa.success({name:"div",children:[]}));h[ja]={overflowNode:null,firstUnsplittable:null,currentContentArea:null,currentPageArea:null,noLayoutFailure:!1,pageNumber:1,pagePosition:"first",oddOrEven:"odd",blankOrNotBlank:"nonBlank",paraStack:[]};k=h.subform.children[0];k.pageSet[Ze]();l=k.pageSet.pageArea.children;m={name:"div",children:[]};q=p=n=null;1<=k.breakBefore.children.length?(p=k.breakBefore.children[0],q=p.target):\n1<=k.subform.children.length&&1<=k.subform.children[0].breakBefore.children.length?(p=k.subform.children[0].breakBefore.children[0],q=p.target):null!=(g=k.break)&&g.beforeTarget?(p=k.break,q=p.beforeTarget):1<=k.subform.children.length&&null!=(f=k.subform.children[0].break)&&f.beforeTarget&&(p=k.subform.children[0].break,q=p.beforeTarget);p&&(r=h[Hd](q,p[Va]()),r instanceof Me&&(n=r,p[ja]={}));n||(n=l[0]);n[ja]={numberOfUse:1};t=n[Va]();t[ja]={numberOfUse:1,pageIndex:t.pageArea.children.indexOf(n),\npageSetIndex:0};y=w=null;x=!0;A=z=0;B={}}if(3!=da.nextAddress){if(x)z=0;else if(m.children.pop(),3===++z)return T("XFA - Something goes wrong: please file a bug."),da.return(m);v=null;h[ja].currentPageArea=n;C=n[Ra]().html;m.children.push(C);w&&(h[ja].noLayoutFailure=!0,C.children.push(w[Ra](n[ja].space).html),w=null);y&&(h[ja].noLayoutFailure=!0,C.children.push(y[Ra](n[ja].space).html),y=null);D=n.contentArea.children;B.htmlContentAreas=C.children.filter(function(R){return R.attributes.class.includes("xfaContentarea")});\nx=!1;h[ja].firstUnsplittable=null;h[ja].noLayoutFailure=!1;E=function(R){return function(Y){var fa=k[qf]();if(fa){var H;x||(x=0<(null==(H=fa.children)?void 0:H.length));R.htmlContentAreas[Y].children.push(fa)}}}(B);G=A;for(J=D.length;G<J;G++){F=h[ja].currentContentArea=D[G];L={width:F.w,height:F.h};A=0;w&&(B.htmlContentAreas[G].children.push(w[Ra](L).html),w=null);y&&(B.htmlContentAreas[G].children.push(y[Ra](L).html),y=null);M=k[Ra](L);if(M.success)return M.html?(x||(x=0<(null==(W=M.html.children)?\nvoid 0:W.length)),B.htmlContentAreas[G].children.push(M.html)):!x&&1<m.children.length&&m.children.pop(),da.return(m);M.isBreak()?(Q=M.breakNode,E(G),"auto"!==Q.targetType&&(Q.leader&&(w=(w=h[Hd](Q.leader,Q[Va]()))?w[0]:null),Q.trailer&&(y=(y=h[Hd](Q.trailer,Q[Va]()))?y[0]:null),"pageArea"===Q.targetType?(v=Q[ja].target,G=Infinity):Q[ja].target?(v=Q[ja].target,A=Q[ja].index+1,G=Infinity):G=Q[ja].index)):h[ja].overflowNode?(la=h[ja].overflowNode,h[ja].overflowNode=null,ta=la[lc](),qa=ta.target,ta.addLeader=\nnull!==ta.leader,ta.addTrailer=null!==ta.trailer,E(G),va=G,G=Infinity,qa instanceof Me?v=qa:qa instanceof Pi&&(S=D.indexOf(qa),-1!==S?S>va?G=S-1:A=S:(v=qa[Va](),A=v.contentArea.children.indexOf(qa)))):E(G)}h[ja].pageNumber+=1;v&&(v[Nf]()?v[ja].numberOfUse+=1:v=null);n=v||n[Kd]();return da.yield(null,3)}B={htmlContentAreas:void 0};return da.jumpTo(2)})};return c}(na),Pm=function(a){function c(d){var e=a.call(this,Da,"text")||this;e.id=d.id||"";e.maxChars=Ta({data:d.maxChars,defaultValue:0,validate:function(g){return 0<=\ng}});e.name=d.name||"";e.rid=d.rid||"";e.use=d.use||"";e.usehref=d.usehref||"";return e}Ca(c,a);var b=c.prototype;b[Vg]=function(){return!0};b[Ad]=function(d){if(d[Pb]===Qb.xhtml.id)return this[ra]=d,!0;T("XFA - Invalid content in Text: "+d[kb]+".");return!1};b[Ld]=function(d){this[ra]instanceof na||a.prototype[Ld].call(this,d)};b[sb]=function(){"string"===typeof this[ra]&&(this[ra]=this[ra].replaceAll("\\r\\n","\\n"))};b[lc]=function(){return"string"===typeof this[ra]?this[ra].split(/[\\u2029\\u2028\\n]/).reduce(function(d,\ne){e&&d.push(e);return d},[]).join("\\n"):this[ra][Sb]()};b[Ra]=function(d){if("string"===typeof this[ra]){var e=Sd(this[ra]).html;this[ra].includes("\\u2029")?(e.name="div",e.children=[],this[ra].split("\\u2029").map(function(g){return g.split(/[\\u2028\\n]/).reduce(function(f,h){f.push({name:"span",value:h},{name:"br"});return f},[])}).forEach(function(g){e.children.push({name:"p",children:g})})):/[\\u2028\\n]/.test(this[ra])&&(e.name="div",e.children=[],this[ra].split(/[\\u2028\\n]/).forEach(function(g){e.children.push({name:"span",\nvalue:g},{name:"br"})}));return Pa.success(e)}return this[ra][Ra](d)};return c}(Hb),Ko=function(a){function c(b){var d=a.call(this,Da,"textEdit",!0)||this;d.allowRichText=Ta({data:b.allowRichText,defaultValue:0,validate:function(e){return 1===e}});d.hScrollPolicy=ua(b.hScrollPolicy,["auto","off","on"]);d.id=b.id||"";d.multiLine=Ta({data:b.multiLine,defaultValue:"",validate:function(e){return 0===e||1===e}});d.use=b.use||"";d.usehref=b.usehref||"";d.vScrollPolicy=ua(b.vScrollPolicy,["auto","off","on"]);\nd.border=null;d.comb=null;d.extras=null;d.margin=null;return d}Ca(c,a);c.prototype[Ra]=function(){var b=Ac(this,"border","font","margin"),d=this[Va]()[Va]();""===this.multiLine&&(this.multiLine=d instanceof Jo?1:0);if(1===this.multiLine){var e;var g={name:"textarea",attributes:{dataId:(null==(e=d[ed])?void 0:e[mb])||d[mb],fieldId:d[mb],class:["xfaTextfield"],style:b,"aria-label":se(d),"aria-required":!1}}}else{var f;g={name:"input",attributes:{type:"text",dataId:(null==(f=d[ed])?void 0:f[mb])||d[mb],\nfieldId:d[mb],class:["xfaTextfield"],style:b,"aria-label":se(d),"aria-required":!1}}}rf(d)&&(g.attributes["aria-required"]=!0,g.attributes.required=!0);return Pa.success({name:"label",attributes:{class:["xfaLabel"]},children:[g]})};return c}(na),iv=function(a){function c(d){var e=a.call(this,Da,"time")||this;e.id=d.id||"";e.name=d.name||"";e.use=d.use||"";e.usehref=d.usehref||"";return e}Ca(c,a);var b=c.prototype;b[sb]=function(){var d=this[ra].trim();this[ra]=d?new Date(d):null};b[Ra]=function(){return Sd(this[ra]?\nthis[ra].toString():"")};return c}(cb),jv=function(a){function c(b){var d=a.call(this,Da,"timeStamp")||this;d.id=b.id||"";d.server=b.server||"";d.type=ua(b.type,["optional","required"]);d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(na),kv=function(a){function c(b){var d=a.call(this,Da,"toolTip")||this;d.id=b.id||"";d.rid=b.rid||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}Ca(c,a);return c}(cb),lv=function(a){function c(b){var d=a.call(this,Da,"traversal",!0)||this;d.id=\nb.id||"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;d.traverse=new P;return d}Ca(c,a);return c}(na),mv=function(a){function c(b){var d=a.call(this,Da,"traverse",!0)||this;d.id=b.id||"";d.operation=ua(b.operation,"next back down first left right up".split(" "));d.ref=b.ref||"";d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;d.script=null;return d}Ca(c,a);c.prototype[Mf]=function(){return!1};return Qq(c,[{key:"name",get:function(){return this.operation}}])}(na),Rj=function(a){function c(d){var e=\na.call(this,Da,"ui",!0)||this;e.id=d.id||"";e.use=d.use||"";e.usehref=d.usehref||"";e.extras=null;e.picture=null;e.barcode=null;e.button=null;e.checkButton=null;e.choiceList=null;e.dateTimeEdit=null;e.defaultUi=null;e.imageEdit=null;e.numericEdit=null;e.passwordEdit=null;e.signature=null;e.textEdit=null;return e}Ca(c,a);var b=c.prototype;b[lc]=function(){if(void 0===this[ja]){for(var d=u.makeIterator(Object.getOwnPropertyNames(this)),e=d.next();!e.done;e=d.next())if(e=e.value,"extras"!==e&&"picture"!==\ne&&(e=this[e],e instanceof na))return this[ja]=e;this[ja]=null}return this[ja]};b[Ra]=function(d){var e=this[lc]();return e?e[Ra](d):Pa.EMPTY};return c}(na),nv=function(a){function c(b){var d=a.call(this,Da,"validate",!0)||this;d.formatTest=ua(b.formatTest,["warning","disabled","error"]);d.id=b.id||"";d.nullTest=ua(b.nullTest,["disabled","error","warning"]);d.scriptTest=ua(b.scriptTest,["error","disabled","warning"]);d.use=b.use||"";d.usehref=b.usehref||"";d.extras=null;d.message=null;d.picture=null;\nd.script=null;return d}Ca(c,a);return c}(na),Ni=function(a){function c(d){var e=a.call(this,Da,"value",!0)||this;e.id=d.id||"";e.override=Ta({data:d.override,defaultValue:0,validate:function(g){return 1===g}});e.relevant=md(d.relevant);e.use=d.use||"";e.usehref=d.usehref||"";e.arc=null;e.boolean=null;e.date=null;e.dateTime=null;e.decimal=null;e.exData=null;e.float=null;e.image=null;e.integer=null;e.line=null;e.rectangle=null;e.text=null;e.time=null;return e}Ca(c,a);var b=c.prototype;b[Gc]=function(d){var e=\nthis[Va]();if(e instanceof Sj){var g;if(null!=(g=e.ui)&&g.imageEdit){this.image||(this.image=new Mo({}),this[Cb](this.image));this.image[ra]=d[ra];return}}e=d[kb];if(null!==this[e])this[e][ra]=d[ra];else{e=u.makeIterator(Object.getOwnPropertyNames(this));for(g=e.next();!g.done;g=e.next()){g=g.value;var f=this[g];f instanceof na&&(this[g]=null,this[$d](f))}this[d[kb]]=d;this[Cb](d)}};b[Sb]=function(){if(this.exData)return"string"===typeof this.exData[ra]?this.exData[ra].trim():this.exData[ra][Sb]().trim();\nfor(var d=u.makeIterator(Object.getOwnPropertyNames(this)),e=d.next();!e.done;e=d.next())if(e=e.value,"image"!==e&&(e=this[e],e instanceof na))return(e[ra]||"").toString().trim();return null};b[Ra]=function(d){for(var e=u.makeIterator(Object.getOwnPropertyNames(this)),g=e.next();!g.done;g=e.next())if(g=this[g.value],g instanceof na)return g[Ra](d);return Pa.EMPTY};return c}(na),ov=function(a){function c(b){var d=a.call(this,Da,"variables",!0)||this;d.id=b.id||"";d.use=b.use||"";d.usehref=b.usehref||\n"";d.boolean=new P;d.date=new P;d.dateTime=new P;d.decimal=new P;d.exData=new P;d.float=new P;d.image=new P;d.integer=new P;d.manifest=new P;d.script=new P;d.text=new P;d.time=new P;return d}Ca(c,a);c.prototype[Mf]=function(){return!0};return c}(na),pv=function(){function a(){}a[pd]=function(c,b){if(a.hasOwnProperty(c))return c=a[c](b),c[uo](b),c};a.appearanceFilter=function(c){return new Jt(c)};a.arc=function(c){return new Bo(c)};a.area=function(c){return new Kt(c)};a.assist=function(c){return new Lt(c)};\na.barcode=function(c){return new Mt(c)};a.bind=function(c){return new Nt(c)};a.bindItems=function(c){return new Qj(c)};a.bookend=function(c){return new Ot(c)};a.boolean=function(c){return new Pt(c)};a.border=function(c){return new Co(c)};a.break=function(c){return new Qt(c)};a.breakAfter=function(c){return new Do(c)};a.breakBefore=function(c){return new Eo(c)};a.button=function(c){return new Rt(c)};a.calculate=function(c){return new St(c)};a.caption=function(c){return new Tt(c)};a.certificate=function(c){return new Ut(c)};\na.certificates=function(c){return new Vt(c)};a.checkButton=function(c){return new Go(c)};a.choiceList=function(c){return new Ho(c)};a.color=function(c){return new Wt(c)};a.comb=function(c){return new Xt(c)};a.connect=function(c){return new Yt(c)};a.contentArea=function(c){return new Pi(c)};a.corner=function(c){return new Io(c)};a.date=function(c){return new Zt(c)};a.dateTime=function(c){return new $t(c)};a.dateTimeEdit=function(c){return new au(c)};a.decimal=function(c){return new bu(c)};a.defaultUi=\nfunction(c){return new cu(c)};a.desc=function(c){return new du(c)};a.digestMethod=function(c){return new eu(c)};a.digestMethods=function(c){return new fu(c)};a.draw=function(c){return new Jo(c)};a.edge=function(c){return new Tf(c)};a.encoding=function(c){return new gu(c)};a.encodings=function(c){return new hu(c)};a.encrypt=function(c){return new iu(c)};a.encryptData=function(c){return new ju(c)};a.encryption=function(c){return new ku(c)};a.encryptionMethod=function(c){return new lu(c)};a.encryptionMethods=\nfunction(c){return new mu(c)};a.event=function(c){return new nu(c)};a.exData=function(c){return new ou(c)};a.exObject=function(c){return new pu(c)};a.exclGroup=function(c){return new Fo(c)};a.execute=function(c){return new qu(c)};a.extras=function(c){return new ru(c)};a.field=function(c){return new Sj(c)};a.fill=function(c){return new su(c)};a.filter=function(c){return new tu(c)};a.float=function(c){return new uu(c)};a.font=function(c){return new vu(c)};a.format=function(c){return new wu(c)};a.handler=\nfunction(c){return new xu(c)};a.hyphenation=function(c){return new yu(c)};a.image=function(c){return new Mo(c)};a.imageEdit=function(c){return new zu(c)};a.integer=function(c){return new Au(c)};a.issuers=function(c){return new Bu(c)};a.items=function(c){return new Tj(c)};a.keep=function(c){return new Cu(c)};a.keyUsage=function(c){return new Du(c)};a.line=function(c){return new Eu(c)};a.linear=function(c){return new Fu(c)};a.lockDocument=function(c){return new Gu(c)};a.manifest=function(c){return new Hu(c)};\na.margin=function(c){return new Iu(c)};a.mdp=function(c){return new Ju(c)};a.medium=function(c){return new Ku(c)};a.message=function(c){return new Lu(c)};a.numericEdit=function(c){return new Mu(c)};a.occur=function(c){return new Nu(c)};a.oid=function(c){return new Ou(c)};a.oids=function(c){return new Pu(c)};a.overflow=function(c){return new No(c)};a.pageArea=function(c){return new Me(c)};a.pageSet=function(c){return new Uj(c)};a.para=function(c){return new Qu(c)};a.passwordEdit=function(c){return new Ru(c)};\na.pattern=function(c){return new Su(c)};a.picture=function(c){return new Tu(c)};a.proto=function(c){return new Uu(c)};a.radial=function(c){return new Vu(c)};a.reason=function(c){return new Wu(c)};a.reasons=function(c){return new Xu(c)};a.rectangle=function(c){return new Lo(c)};a.ref=function(c){return new Yu(c)};a.script=function(c){return new Zu(c)};a.setProperty=function(c){return new Wj(c)};a.signData=function(c){return new $u(c)};a.signature=function(c){return new av(c)};a.signing=function(c){return new bv(c)};\na.solid=function(c){return new cv(c)};a.speak=function(c){return new dv(c)};a.stipple=function(c){return new ev(c)};a.subform=function(c){return new Oo(c)};a.subformSet=function(c){return new Oi(c)};a.subjectDN=function(c){return new fv(c)};a.subjectDNs=function(c){return new gv(c)};a.submit=function(c){return new hv(c)};a.template=function(c){return new Vj(c)};a.text=function(c){return new Pm(c)};a.textEdit=function(c){return new Ko(c)};a.time=function(c){return new iv(c)};a.timeStamp=function(c){return new jv(c)};\na.toolTip=function(c){return new kv(c)};a.traversal=function(c){return new lv(c)};a.traverse=function(c){return new mv(c)};a.ui=function(c){return new Rj(c)};a.validate=function(c){return new nv(c)};a.value=function(c){return new Ni(c)};a.variables=function(c){return new ov(c)};return a}(),Po=Qb.datasets.id,qv=function(){function a(b){var d;this.root=b;this.datasets=b.datasets;this.data=(null==(d=b.datasets)?void 0:d.data)||new ze(Qb.datasets.id,"data");this.emptyMerge=0===this.data[ac]().length;\nthis.root.form=this.form=b.template[od]()}var c=a.prototype;c._isConsumeData=function(){return!this.emptyMerge&&this._mergeMode};c._isMatchTemplate=function(){return!this._isConsumeData()};c.bind=function(){this._bindElement(this.form,this.data);return this.form};c.getData=function(){return this.data};c._bindValue=function(b,d){b[ed]=d;if(b[Kf]()){var e;d[bf]()?(d=d[Ej](),b[Gc](Fg(d))):b instanceof Sj&&"multiSelect"===(null==(e=b.ui)||null==(e=e.choiceList)?void 0:e.open)?(d=d[ac]().map(function(g){return g[ra].trim()}).join("\\n"),\nb[Gc](Fg(d))):this._isConsumeData()&&T("XFA - Nodes haven\'t the same type.")}else!d[bf]()||this._isMatchTemplate()?this._bindElement(b,d):T("XFA - Nodes haven\'t the same type.")};c._findDataByNameToConsume=function(b,d,e,g){var f;if(!b)return null;for(var h,k,l=0;3>l;l++){for(h=e[Jf](b,!1,!0);;){k=h.next().value;if(!k)break;if(d===k[bf]())return k}if(e[Pb]===Qb.datasets.id&&"data"===e[kb])break;e=e[Va]()}if(!g)return null;h=this.data[Jf](b,!0,!1);if(k=h.next().value)return k;h=this.data[Dj](b,!0);\nk=h.next().value;return null!=(f=k)&&f[bf]()?k:null};c._setProperties=function(b,d){if(b.hasOwnProperty("setProperty"))for(var e=u.makeIterator(b.setProperty.children),g=e.next();!g.done;g=e.next()){var f=g.value;g=f.ref;var h=f.target;if(!f.connection&&g)if(f=Rd(this.root,d,g,!1,!1))if(g=u.makeIterator(f).next().value,g[Yd](this.data))if(f=Rd(this.root,b,h,!1,!1)){var k=u.makeIterator(f).next().value;if(k[Yd](b))if(h=k[Va](),k instanceof Wj||h instanceof Wj)T("XFA - Invalid target: cannot be a setProperty or one of its properties.");\nelse if(k instanceof Qj||h instanceof Qj)T("XFA - Invalid target: cannot be a bindItems or one of its properties.");else{var l=g[Sb]();f=k[kb];k instanceof Pj?(g=Object.create(null),g[f]=l,g=Reflect.construct(Object.getPrototypeOf(h).constructor,[g]),h[f]=g[f]):k.hasOwnProperty(ra)?(k[ed]=g,k[ra]=l,k[sb]()):T("XFA - Invalid node to use in setProperty")}else T("XFA - Invalid target: must be a property or subproperty.")}else T("XFA - Invalid target: "+h+".");else T("XFA - Invalid node: must be a data node.");\nelse T("XFA - Invalid reference: "+g+".")}};c._bindItems=function(b,d){if(b.hasOwnProperty("items")&&b.hasOwnProperty("bindItems")&&!b.bindItems.isEmpty()){for(var e=u.makeIterator(b.items.children),g=e.next();!g.done;g=e.next())b[$d](g.value);b.items.clear();e=new Tj({});g=new Tj({});b[Cb](e);b.items.push(e);b[Cb](g);b.items.push(g);b=u.makeIterator(b.bindItems.children);for(var f=b.next();!f.done;f=b.next()){var h=f.value;f=h.ref;var k=h.labelRef,l=h.valueRef;if(!h.connection&&f)if(h=Rd(this.root,\nd,f,!1,!1)){h=u.makeIterator(h);for(var m=h.next();!m.done;m=h.next()){var n=m.value;n[Yd](this.datasets)?(m=Rd(this.root,n,k,!0,!1))?(m=u.makeIterator(m).next().value,m[Yd](this.datasets)?(n=Rd(this.root,n,l,!0,!1))?(n=u.makeIterator(n).next().value,n[Yd](this.datasets)?(m=Fg(m[Sb]()),n=Fg(n[Sb]()),e[Cb](m),e.text.push(m),g[Cb](n),g.text.push(n)):T("XFA - Invalid value: must be a datasets child.")):T("XFA - Invalid value: "+l+"."):T("XFA - Invalid label: must be a datasets child.")):T("XFA - Invalid label: "+\nk+"."):T("XFA - Invalid ref ("+f+"): must be a datasets child.")}}else T("XFA - Invalid reference: "+f+".")}}};c._bindOccurrences=function(b,d,e){if(1<d.length){var g=b[od]();g[$d](g.occur);g.occur=null}this._bindValue(b,d[0],e);this._setProperties(b,d[0]);this._bindItems(b,d[0]);if(1!==d.length){var f=b[Va](),h=b[kb];b=f[Fj](b);for(var k=1,l=d.length;k<l;k++){var m=d[k],n=g[od]();f[h].push(n);f[Xg](b+k,n);this._bindValue(n,m,e);this._setProperties(n,m);this._bindItems(n,m)}}};c._createOccurrences=\nfunction(b){if(this.emptyMerge){var d=b.occur;if(d&&!(1>=d.initial)){var e=b[Va](),g=b[kb];if(e[g]instanceof P){var f=b.name?e[g].children.filter(function(m){return m.name===b.name}).length:e[g].children.length;var h=e[Fj](b)+1;if(d=d.initial-f){f=b[od]();f[$d](f.occur);f.occur=null;e[g].push(f);e[Xg](h,f);for(var k=1;k<d;k++){var l=f[od]();e[g].push(l);e[Xg](h+k,l)}}}}}};c._getOccurInfo=function(b){var d=b.name;return(b=b.occur)&&d?[b.min,-1===b.max?Infinity:b.max]:[1,1]};c._setAndBind=function(b,\nd){this._setProperties(b,d);this._bindItems(b,d);this._bindElement(b,d)};c._bindElement=function(b,d){var e=[];this._createOccurrences(b);b=u.makeIterator(b[ac]());for(var g=b.next();!g.done;g=b.next())if(g=g.value,!g[ed])if(void 0===this._mergeMode&&"subform"===g[kb]){this._mergeMode="consumeData"===g.mergeMode;var f=d[ac]();0<f.length?this._bindOccurrences(g,[f[0]],null):this.emptyMerge&&(f=g[ed]=new ze(d[Pb]===Po?-1:d[Pb],g.name||"root"),d[Cb](f),this._bindElement(g,f))}else if(g[xe]()){f=!1;var h=\nnull,k=null,l=null;if(g.bind){switch(g.bind.match){case "none":this._setAndBind(g,d);continue;case "global":f=!0;break;case "dataRef":if(!g.bind.ref){T("XFA - ref is empty in node "+g[kb]+".");this._setAndBind(g,d);continue}k=g.bind.ref}g.bind.picture&&(h=g.bind.picture[ra])}var m=u.makeIterator(this._getOccurInfo(g)),n=m.next().value;m=m.next().value;if(k)if(l=Rd(this.root,d,k,!0,!1),null===l){l=Oq(this.data,d,k);if(!l)continue;this._isConsumeData()&&(l[zd]=!0);this._setAndBind(g,l);continue}else this._isConsumeData()&&\n(l=l.filter(function(p){return!p[zd]})),l.length>m?l=l.slice(0,m):0===l.length&&(l=null),l&&this._isConsumeData()&&l.forEach(function(p){p[zd]=!0});else{if(!g.name){this._setAndBind(g,d);continue}if(this._isConsumeData()){for(k=[];k.length<m;){l=this._findDataByNameToConsume(g.name,g[Kf](),d,f);if(!l)break;l[zd]=!0;k.push(l)}l=0<k.length?k:null}else{l=d[Jf](g.name,!1,this.emptyMerge).next().value;if(!l){if(0===n){e.push(g);continue}l=g[ed]=new ze(d[Pb]===Po?-1:d[Pb],g.name);this.emptyMerge&&(l[zd]=\n!0);d[Cb](l);this._setAndBind(g,l);continue}this.emptyMerge&&(l[zd]=!0);l=[l]}}l?this._bindOccurrences(g,l,h):0<n?this._setAndBind(g,d):e.push(g)}e.forEach(function(p){return p[Va]()[$d](p)})};return a}(),rv=function(){function a(c,b){this.data=b;this.dataset=c.datasets||null}a.prototype.serialize=function(c){for(var b=[[-1,this.data[ac]()]];0<b.length;){var d=b.at(-1),e=u.makeIterator(d),g=e.next().value;e=e.next().value;if(g+1===e.length)b.pop();else{d=e[++d[0]];if(g=c.get(d[mb]))d[Gc](g);else for(g=\nd[so](),g=u.makeIterator(g.values()),e=g.next();!e.done;e=g.next()){e=e.value;var f=c.get(e[mb]);if(f){e[Gc](f);break}}d=d[ac]();0<d.length&&b.push([-1,d])}}c=[\'<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">\'];if(this.dataset)for(b=u.makeIterator(this.dataset[ac]()),d=b.next();!d.done;d=b.next())if(d=d.value,"data"!==d[kb])d[Pf](c);this.data[Pf](c);c.push("</xfa:datasets>");return c.join("")};return a}(),ya=Qb.config.id,sv=function(a){function c(){var b=a.call(this,ya,"acrobat",\n!0)||this;b.acrobat7=null;b.autoSave=null;b.common=null;b.validate=null;b.validateApprovalSignatures=null;b.submitUrl=new P;return b}xa(c,a);return c}(na),tv=function(a){function c(){var b=a.call(this,ya,"acrobat7",!0)||this;b.dynamicRender=null;return b}xa(c,a);return c}(na),uv=function(a){function c(){return a.call(this,ya,"ADBE_JSConsole",["delegate","Enable","Disable"])||this}xa(c,a);return c}(nb),vv=function(a){function c(){return a.call(this,ya,"ADBE_JSDebugger",["delegate","Enable","Disable"])||\nthis}xa(c,a);return c}(nb),wv=function(a){function c(){return a.call(this,ya,"addSilentPrint")||this}xa(c,a);return c}(Tb),xv=function(a){function c(){return a.call(this,ya,"addViewerPreferences")||this}xa(c,a);return c}(Tb),yv=function(a){function c(){return a.call(this,ya,"adjustData")||this}xa(c,a);return c}(Ao),zv=function(a){function c(){return a.call(this,ya,"adobeExtensionLevel",0,function(b){return 1<=b&&8>=b})||this}xa(c,a);return c}(qd),Av=function(a){function c(b){var d=a.call(this,ya,\n"agent",!0)||this;d.name=b.name?b.name.trim():"";d.common=new P;return d}xa(c,a);return c}(na),Bv=function(a){function c(){return a.call(this,ya,"alwaysEmbed")||this}xa(c,a);return c}(Hb),Cv=function(a){function c(){return a.call(this,ya,"amd")||this}xa(c,a);return c}(cb),Dv=function(a){function c(b){var d=a.call(this,ya,"area")||this;d.level=Ta({data:b.level,defaultValue:0,validate:function(e){return 1<=e&&3>=e}});d.name=ua(b.name," barcode coreinit deviceDriver font general layout merge script signature sourceSet templateCache".split(" "));\nreturn d}xa(c,a);return c}(na),Ev=function(a){function c(){return a.call(this,ya,"attributes",["preserve","delegate","ignore"])||this}xa(c,a);return c}(nb),Fv=function(a){function c(){return a.call(this,ya,"autoSave",["disabled","enabled"])||this}xa(c,a);return c}(nb),Gv=function(a){function c(){return a.call(this,ya,"base")||this}xa(c,a);return c}(cb),Hv=function(a){function c(b){var d=a.call(this,ya,"batchOutput")||this;d.format=ua(b.format,["none","concat","zip","zipCompress"]);return d}xa(c,a);\nreturn c}(na),Iv=function(a){function c(){return a.call(this,ya,"behaviorOverride")||this}xa(c,a);c.prototype[sb]=function(){this[ra]=new Map(this[ra].trim().split(/\\s+/).filter(function(b){return b.includes(":")}).map(function(b){return b.split(":",2)}))};return c}(Hb),Jv=function(a){function c(){var b=a.call(this,ya,"cache",!0)||this;b.templateCache=null;return b}xa(c,a);return c}(na),Kv=function(a){function c(){return a.call(this,ya,"change")||this}xa(c,a);return c}(Tb),Lv=function(a){function c(){var b=\na.call(this,ya,"common",!0)||this;b.data=null;b.locale=null;b.localeSet=null;b.messaging=null;b.suppressBanner=null;b.template=null;b.validationMessaging=null;b.versionControl=null;b.log=new P;return b}xa(c,a);return c}(na),Mv=function(a){function c(b){var d=a.call(this,ya,"compress")||this;d.scope=ua(b.scope,["imageOnly","document"]);return d}xa(c,a);return c}(na),Nv=function(a){function c(){return a.call(this,ya,"compressLogicalStructure")||this}xa(c,a);return c}(Tb),Ov=function(a){function c(){return a.call(this,\nya,"compressObjectStream")||this}xa(c,a);return c}(Ao),Pv=function(a){function c(){var b=a.call(this,ya,"compression",!0)||this;b.compressLogicalStructure=null;b.compressObjectStream=null;b.level=null;b.type=null;return b}xa(c,a);return c}(na),Qv=function(a){function c(){var b=a.call(this,ya,"config",!0)||this;b.acrobat=null;b.present=null;b.trace=null;b.agent=new P;return b}xa(c,a);return c}(na),Rv=function(a){function c(){return a.call(this,ya,"conformance",["A","B"])||this}xa(c,a);return c}(nb),\nSv=function(a){function c(){return a.call(this,ya,"contentCopy")||this}xa(c,a);return c}(Tb),Tv=function(a){function c(){return a.call(this,ya,"copies",1,function(b){return 1<=b})||this}xa(c,a);return c}(qd),Uv=function(a){function c(){return a.call(this,ya,"creator")||this}xa(c,a);return c}(cb),Vv=function(a){function c(){return a.call(this,ya,"currentPage",0,function(b){return 0<=b})||this}xa(c,a);return c}(qd),Wv=function(a){function c(){var b=a.call(this,ya,"data",!0)||this;b.adjustData=null;\nb.attributes=null;b.incrementalLoad=null;b.outputXSL=null;b.range=null;b.record=null;b.startNode=null;b.uri=null;b.window=null;b.xsl=null;b.excludeNS=new P;b.transform=new P;return b}xa(c,a);return c}(na),Xv=function(a){function c(){var b=a.call(this,ya,"debug",!0)||this;b.uri=null;return b}xa(c,a);return c}(na),Yv=function(a){function c(b){var d=a.call(this,ya,"defaultTypeface")||this;d.writingScript=ua(b.writingScript,"* Arabic Cyrillic EastEuropeanRoman Greek Hebrew Japanese Korean Roman SimplifiedChinese Thai TraditionalChinese Vietnamese".split(" "));\nreturn d}xa(c,a);return c}(Hb),Zv=function(a){function c(){return a.call(this,ya,"destination",["pdf","pcl","ps","webClient","zpl"])||this}xa(c,a);return c}(nb),$v=function(a){function c(){return a.call(this,ya,"documentAssembly")||this}xa(c,a);return c}(Tb),aw=function(a){function c(b){var d=a.call(this,ya,"driver",!0)||this;d.name=b.name?b.name.trim():"";d.fontInfo=null;d.xdc=null;return d}xa(c,a);return c}(na),bw=function(a){function c(){return a.call(this,ya,"duplexOption",["simplex","duplexFlipLongEdge",\n"duplexFlipShortEdge"])||this}xa(c,a);return c}(nb),cw=function(a){function c(){return a.call(this,ya,"dynamicRender",["forbidden","required"])||this}xa(c,a);return c}(nb),dw=function(a){function c(){return a.call(this,ya,"embed")||this}xa(c,a);return c}(Tb),ew=function(a){function c(){return a.call(this,ya,"encrypt")||this}xa(c,a);return c}(Tb),fw=function(a){function c(){var b=a.call(this,ya,"encryption",!0)||this;b.encrypt=null;b.encryptionLevel=null;b.permissions=null;return b}xa(c,a);return c}(na),\ngw=function(a){function c(){return a.call(this,ya,"encryptionLevel",["40bit","128bit"])||this}xa(c,a);return c}(nb),hw=function(a){function c(){return a.call(this,ya,"enforce")||this}xa(c,a);return c}(cb),iw=function(a){function c(b){var d=a.call(this,ya,"equate")||this;d.force=Ta({data:b.force,defaultValue:1,validate:function(e){return 0===e}});d.from=b.from||"";d.to=b.to||"";return d}xa(c,a);return c}(na),jw=function(a){function c(b){var d=a.call(this,ya,"equateRange")||this;d.from=b.from||"";d.to=\nb.to||"";d._unicodeRange=b.unicodeRange||"";return d}xa(c,a);return Sq(c,[{key:"unicodeRange",get:function(){for(var b=[],d=/U\\+([0-9a-fA-F]+)/,e=u.makeIterator(this._unicodeRange.split(",").map(function(f){return f.trim()}).filter(function(f){return!!f})),g=e.next();!g.done;g=e.next())g=g.value,g=g.split("-",2).map(function(f){return(f=f.match(d))?parseInt(f[1],16):0}),1===g.length&&g.push(g[0]),b.push(g);return Fa(this,"unicodeRange",b)}}])}(na),kw=function(a){function c(){return a.call(this,ya,\n"exclude")||this}xa(c,a);c.prototype[sb]=function(){this[ra]=this[ra].trim().split(/\\s+/).filter(function(b){return b&&"calculate close enter exit initialize ready validate".split(" ").includes(b)})};return c}(Hb),lw=function(a){function c(){return a.call(this,ya,"excludeNS")||this}xa(c,a);return c}(cb),mw=function(a){function c(){return a.call(this,ya,"flipLabel",["usePrinterSetting","on","off"])||this}xa(c,a);return c}(nb),nw=function(a){function c(){var b=a.call(this,ya,"fontInfo",!0)||this;b.embed=\nnull;b.map=null;b.subsetBelow=null;b.alwaysEmbed=new P;b.defaultTypeface=new P;b.neverEmbed=new P;return b}xa(c,a);return c}(na),ow=function(a){function c(){return a.call(this,ya,"formFieldFilling")||this}xa(c,a);return c}(Tb),pw=function(a){function c(){return a.call(this,ya,"groupParent")||this}xa(c,a);return c}(cb),qw=function(a){function c(){return a.call(this,ya,"ifEmpty",["dataValue","dataGroup","ignore","remove"])||this}xa(c,a);return c}(nb),rw=function(a){function c(){return a.call(this,ya,\n"includeXDPContent")||this}xa(c,a);return c}(cb),sw=function(a){function c(){return a.call(this,ya,"incrementalLoad",["none","forwardOnly"])||this}xa(c,a);return c}(nb),tw=function(a){function c(){return a.call(this,ya,"incrementalMerge")||this}xa(c,a);return c}(Tb),uw=function(a){function c(){return a.call(this,ya,"interactive")||this}xa(c,a);return c}(Tb),vw=function(a){function c(){return a.call(this,ya,"jog",["usePrinterSetting","none","pageSet"])||this}xa(c,a);return c}(nb),ww=function(a){function c(b){var d=\na.call(this,ya,"labelPrinter",!0)||this;d.name=ua(b.name,["zpl","dpl","ipl","tcpl"]);d.batchOutput=null;d.flipLabel=null;d.fontInfo=null;d.xdc=null;return d}xa(c,a);return c}(na),xw=function(a){function c(){return a.call(this,ya,"layout",["paginate","panel"])||this}xa(c,a);return c}(nb),yw=function(a){function c(){return a.call(this,ya,"level",0,function(b){return 0<b})||this}xa(c,a);return c}(qd),zw=function(a){function c(){return a.call(this,ya,"linearized")||this}xa(c,a);return c}(Tb),Aw=function(a){function c(){return a.call(this,\nya,"locale")||this}xa(c,a);return c}(cb),Bw=function(a){function c(){return a.call(this,ya,"localeSet")||this}xa(c,a);return c}(cb),Cw=function(a){function c(){var b=a.call(this,ya,"log",!0)||this;b.mode=null;b.threshold=null;b.to=null;b.uri=null;return b}xa(c,a);return c}(na),Dw=function(a){function c(){var b=a.call(this,ya,"map",!0)||this;b.equate=new P;b.equateRange=new P;return b}xa(c,a);return c}(na),Ew=function(a){function c(){var b=a.call(this,ya,"mediumInfo",!0)||this;b.map=null;return b}\nxa(c,a);return c}(na),Fw=function(a){function c(){var b=a.call(this,ya,"message",!0)||this;b.msgId=null;b.severity=null;return b}xa(c,a);return c}(na),Gw=function(a){function c(){var b=a.call(this,ya,"messaging",!0)||this;b.message=new P;return b}xa(c,a);return c}(na),Hw=function(a){function c(){return a.call(this,ya,"mode",["append","overwrite"])||this}xa(c,a);return c}(nb),Iw=function(a){function c(){return a.call(this,ya,"modifyAnnots")||this}xa(c,a);return c}(Tb),Jw=function(a){function c(){return a.call(this,\nya,"msgId",1,function(b){return 1<=b})||this}xa(c,a);return c}(qd),Kw=function(a){function c(){return a.call(this,ya,"nameAttr")||this}xa(c,a);return c}(cb),Lw=function(a){function c(){return a.call(this,ya,"neverEmbed")||this}xa(c,a);return c}(Hb),Mw=function(a){function c(){return a.call(this,ya,"numberOfCopies",null,function(b){return 2<=b&&5>=b})||this}xa(c,a);return c}(qd),Nw=function(a){function c(){var b=a.call(this,ya,"openAction",!0)||this;b.destination=null;return b}xa(c,a);return c}(na),\nOw=function(a){function c(){var b=a.call(this,ya,"output",!0)||this;b.to=null;b.type=null;b.uri=null;return b}xa(c,a);return c}(na),Pw=function(a){function c(){return a.call(this,ya,"outputBin")||this}xa(c,a);return c}(cb),Qw=function(a){function c(){var b=a.call(this,ya,"outputXSL",!0)||this;b.uri=null;return b}xa(c,a);return c}(na),Rw=function(a){function c(){return a.call(this,ya,"overprint",["none","both","draw","field"])||this}xa(c,a);return c}(nb),Sw=function(a){function c(){return a.call(this,\nya,"packets")||this}xa(c,a);c.prototype[sb]=function(){"*"!==this[ra]&&(this[ra]=this[ra].trim().split(/\\s+/).filter(function(b){return["config","datasets","template","xfdf","xslt"].includes(b)}))};return c}(cb),Tw=function(a){function c(b){var d=a.call(this,ya,"pageOffset")||this;d.x=Ta({data:b.x,defaultValue:"useXDCSetting",validate:function(){return!0}});d.y=Ta({data:b.y,defaultValue:"useXDCSetting",validate:function(){return!0}});return d}xa(c,a);return c}(na),Uw=function(a){function c(){return a.call(this,\nya,"pageRange")||this}xa(c,a);c.prototype[sb]=function(){for(var b=this[ra].trim().split(/\\s+/).map(function(f){return parseInt(f,10)}),d=[],e=0,g=b.length;e<g;e+=2)d.push(b.slice(e,e+2));this[ra]=d};return c}(cb),Vw=function(a){function c(){return a.call(this,ya,"pagination",["simplex","duplexShortEdge","duplexLongEdge"])||this}xa(c,a);return c}(nb),Ww=function(a){function c(){return a.call(this,ya,"paginationOverride",["none","forceDuplex","forceDuplexLongEdge","forceDuplexShortEdge","forceSimplex"])||\nthis}xa(c,a);return c}(nb),Xw=function(a){function c(){return a.call(this,ya,"part",1,function(){return!1})||this}xa(c,a);return c}(qd),Yw=function(a){function c(b){var d=a.call(this,ya,"pcl",!0)||this;d.name=b.name||"";d.batchOutput=null;d.fontInfo=null;d.jog=null;d.mediumInfo=null;d.outputBin=null;d.pageOffset=null;d.staple=null;d.xdc=null;return d}xa(c,a);return c}(na),Zw=function(a){function c(b){var d=a.call(this,ya,"pdf",!0)||this;d.name=b.name||"";d.adobeExtensionLevel=null;d.batchOutput=null;\nd.compression=null;d.creator=null;d.encryption=null;d.fontInfo=null;d.interactive=null;d.linearized=null;d.openAction=null;d.pdfa=null;d.producer=null;d.renderPolicy=null;d.scriptModel=null;d.silentPrint=null;d.submitFormat=null;d.tagged=null;d.version=null;d.viewerPreferences=null;d.xdc=null;return d}xa(c,a);return c}(na),$w=function(a){function c(){var b=a.call(this,ya,"pdfa",!0)||this;b.amd=null;b.conformance=null;b.includeXDPContent=null;b.part=null;return b}xa(c,a);return c}(na),ax=function(a){function c(){var b=\na.call(this,ya,"permissions",!0)||this;b.accessibleContent=null;b.change=null;b.contentCopy=null;b.documentAssembly=null;b.formFieldFilling=null;b.modifyAnnots=null;b.plaintextMetadata=null;b.print=null;b.printHighQuality=null;return b}xa(c,a);return c}(na),bx=function(a){function c(){return a.call(this,ya,"pickTrayByPDFSize")||this}xa(c,a);return c}(Tb),cx=function(a){function c(){return a.call(this,ya,"picture")||this}xa(c,a);return c}(cb),dx=function(a){function c(){return a.call(this,ya,"plaintextMetadata")||\nthis}xa(c,a);return c}(Tb),ex=function(a){function c(){return a.call(this,ya,"presence",["preserve","dissolve","dissolveStructure","ignore","remove"])||this}xa(c,a);return c}(nb),fx=function(a){function c(){var b=a.call(this,ya,"present",!0)||this;b.behaviorOverride=null;b.cache=null;b.common=null;b.copies=null;b.destination=null;b.incrementalMerge=null;b.layout=null;b.output=null;b.overprint=null;b.pagination=null;b.paginationOverride=null;b.script=null;b.validate=null;b.xdp=null;b.driver=new P;\nb.labelPrinter=new P;b.pcl=new P;b.pdf=new P;b.ps=new P;b.submitUrl=new P;b.webClient=new P;b.zpl=new P;return b}xa(c,a);return c}(na),gx=function(a){function c(){return a.call(this,ya,"print")||this}xa(c,a);return c}(Tb),hx=function(a){function c(){return a.call(this,ya,"printHighQuality")||this}xa(c,a);return c}(Tb),ix=function(a){function c(){return a.call(this,ya,"printScaling",["appdefault","noScaling"])||this}xa(c,a);return c}(nb),jx=function(a){function c(){return a.call(this,ya,"printerName")||\nthis}xa(c,a);return c}(cb),kx=function(a){function c(){return a.call(this,ya,"producer")||this}xa(c,a);return c}(cb),lx=function(a){function c(b){var d=a.call(this,ya,"ps",!0)||this;d.name=b.name||"";d.batchOutput=null;d.fontInfo=null;d.jog=null;d.mediumInfo=null;d.outputBin=null;d.staple=null;d.xdc=null;return d}xa(c,a);return c}(na),mx=function(a){function c(){return a.call(this,ya,"range")||this}xa(c,a);c.prototype[sb]=function(){this[ra]=this[ra].trim().split(/\\s*,\\s*/,2).map(function(b){return b.split("-").map(function(d){return parseInt(d.trim(),\n10)})}).filter(function(b){return b.every(function(d){return!isNaN(d)})}).map(function(b){1===b.length&&b.push(b[0]);return b})};return c}(Hb),nx=function(a){function c(){return a.call(this,ya,"record")||this}xa(c,a);c.prototype[sb]=function(){this[ra]=this[ra].trim();var b=parseInt(this[ra],10);!isNaN(b)&&0<=b&&(this[ra]=b)};return c}(Hb),ox=function(a){function c(){return a.call(this,ya,"relevant")||this}xa(c,a);c.prototype[sb]=function(){this[ra]=this[ra].trim().split(/\\s+/)};return c}(Hb),px=\nfunction(a){function c(){return a.call(this,ya,"rename")||this}xa(c,a);c.prototype[sb]=function(){this[ra]=this[ra].trim();(this[ra].toLowerCase().startsWith("xml")||RegExp("[\\\\p{L}_][\\\\p{L}\\\\d._\\\\p{M}-]*","u").test(this[ra]))&&T("XFA - Rename: invalid XFA name")};return c}(Hb),qx=function(a){function c(){return a.call(this,ya,"renderPolicy",["server","client"])||this}xa(c,a);return c}(nb),rx=function(a){function c(){return a.call(this,ya,"runScripts",["both","client","none","server"])||this}xa(c,\na);return c}(nb),sx=function(a){function c(){var b=a.call(this,ya,"script",!0)||this;b.currentPage=null;b.exclude=null;b.runScripts=null;return b}xa(c,a);return c}(na),tx=function(a){function c(){return a.call(this,ya,"scriptModel",["XFA","none"])||this}xa(c,a);return c}(nb),ux=function(a){function c(){return a.call(this,ya,"severity",["ignore","error","information","trace","warning"])||this}xa(c,a);return c}(nb),vx=function(a){function c(){var b=a.call(this,ya,"silentPrint",!0)||this;b.addSilentPrint=\nnull;b.printerName=null;return b}xa(c,a);return c}(na),wx=function(a){function c(b){var d=a.call(this,ya,"staple")||this;d.mode=ua(b.mode,["usePrinterSetting","on","off"]);return d}xa(c,a);return c}(na),xx=function(a){function c(){return a.call(this,ya,"startNode")||this}xa(c,a);return c}(cb),yx=function(a){function c(){return a.call(this,ya,"startPage",0,function(){return!0})||this}xa(c,a);return c}(qd),zx=function(a){function c(){return a.call(this,ya,"submitFormat",["html","delegate","fdf","xml",\n"pdf"])||this}xa(c,a);return c}(nb),Ax=function(a){function c(){return a.call(this,ya,"submitUrl")||this}xa(c,a);return c}(cb),Bx=function(a){function c(){return a.call(this,ya,"subsetBelow",100,function(b){return 0<=b&&100>=b})||this}xa(c,a);return c}(qd),Cx=function(a){function c(){return a.call(this,ya,"suppressBanner")||this}xa(c,a);return c}(Tb),Dx=function(a){function c(){return a.call(this,ya,"tagged")||this}xa(c,a);return c}(Tb),Ex=function(a){function c(){var b=a.call(this,ya,"template",\n!0)||this;b.base=null;b.relevant=null;b.startPage=null;b.uri=null;b.xsl=null;return b}xa(c,a);return c}(na),Fx=function(a){function c(){return a.call(this,ya,"threshold",["trace","error","information","warning"])||this}xa(c,a);return c}(nb),Gx=function(a){function c(){return a.call(this,ya,"to","null memory stderr stdout system uri".split(" "))||this}xa(c,a);return c}(nb),Hx=function(a){function c(b){var d=a.call(this,ya,"templateCache")||this;d.maxEntries=Ta({data:b.maxEntries,defaultValue:5,validate:function(e){return 0<=\ne}});return d}xa(c,a);return c}(na),Ix=function(a){function c(){var b=a.call(this,ya,"trace",!0)||this;b.area=new P;return b}xa(c,a);return c}(na),Jx=function(a){function c(){var b=a.call(this,ya,"transform",!0)||this;b.groupParent=null;b.ifEmpty=null;b.nameAttr=null;b.picture=null;b.presence=null;b.rename=null;b.whitespace=null;return b}xa(c,a);return c}(na),Kx=function(a){function c(){return a.call(this,ya,"type","none ascii85 asciiHex ccittfax flate lzw runLength native xdp mergedXDP".split(" "))||\nthis}xa(c,a);return c}(nb),Lx=function(a){function c(){return a.call(this,ya,"uri")||this}xa(c,a);return c}(cb),Mx=function(a){function c(){return a.call(this,ya,"validate",["preSubmit","prePrint","preExecute","preSave"])||this}xa(c,a);return c}(nb),Nx=function(a){function c(){return a.call(this,ya,"validateApprovalSignatures")||this}xa(c,a);c.prototype[sb]=function(){this[ra]=this[ra].trim().split(/\\s+/).filter(function(b){return["docReady","postSign"].includes(b)})};return c}(Hb),Ox=function(a){function c(){return a.call(this,\nya,"validationMessaging",["allMessagesIndividually","allMessagesTogether","firstMessageOnly","noMessages"])||this}xa(c,a);return c}(nb),Px=function(a){function c(){return a.call(this,ya,"version","1.7 1.6 1.5 1.4 1.3 1.2".split(" "))||this}xa(c,a);return c}(nb),Qx=function(a){function c(b){var d=a.call(this,ya,"VersionControl")||this;d.outputBelow=ua(b.outputBelow,["warn","error","update"]);d.sourceAbove=ua(b.sourceAbove,["warn","error"]);d.sourceBelow=ua(b.sourceBelow,["update","maintain"]);return d}\nxa(c,a);return c}(na),Rx=function(a){function c(){var b=a.call(this,ya,"viewerPreferences",!0)||this;b.ADBE_JSConsole=null;b.ADBE_JSDebugger=null;b.addViewerPreferences=null;b.duplexOption=null;b.enforce=null;b.numberOfCopies=null;b.pageRange=null;b.pickTrayByPDFSize=null;b.printScaling=null;return b}xa(c,a);return c}(na),Sx=function(a){function c(b){var d=a.call(this,ya,"webClient",!0)||this;d.name=b.name?b.name.trim():"";d.fontInfo=null;d.xdc=null;return d}xa(c,a);return c}(na),Tx=function(a){function c(){return a.call(this,\nya,"whitespace",["preserve","ltrim","normalize","rtrim","trim"])||this}xa(c,a);return c}(nb),Ux=function(a){function c(){return a.call(this,ya,"window")||this}xa(c,a);c.prototype[sb]=function(){var b=this[ra].trim().split(/\\s*,\\s*/,2).map(function(d){return parseInt(d,10)});b.some(function(d){return isNaN(d)})?this[ra]=[0,0]:(1===b.length&&b.push(b[0]),this[ra]=b)};return c}(Hb),Vx=function(a){function c(){var b=a.call(this,ya,"xdc",!0)||this;b.uri=new P;b.xsl=new P;return b}xa(c,a);return c}(na),\nWx=function(a){function c(){var b=a.call(this,ya,"xdp",!0)||this;b.packets=null;return b}xa(c,a);return c}(na),Xx=function(a){function c(){var b=a.call(this,ya,"xsl",!0)||this;b.debug=null;b.uri=null;return b}xa(c,a);return c}(na),Yx=function(a){function c(b){var d=a.call(this,ya,"zpl",!0)||this;d.name=b.name?b.name.trim():"";d.batchOutput=null;d.flipLabel=null;d.fontInfo=null;d.xdc=null;return d}xa(c,a);return c}(na),Zx=function(){function a(){}a[pd]=function(c,b){if(a.hasOwnProperty(c))return a[c](b)};\na.acrobat=function(c){return new sv(c)};a.acrobat7=function(c){return new tv(c)};a.ADBE_JSConsole=function(c){return new uv(c)};a.ADBE_JSDebugger=function(c){return new vv(c)};a.addSilentPrint=function(c){return new wv(c)};a.addViewerPreferences=function(c){return new xv(c)};a.adjustData=function(c){return new yv(c)};a.adobeExtensionLevel=function(c){return new zv(c)};a.agent=function(c){return new Av(c)};a.alwaysEmbed=function(c){return new Bv(c)};a.amd=function(c){return new Cv(c)};a.area=function(c){return new Dv(c)};\na.attributes=function(c){return new Ev(c)};a.autoSave=function(c){return new Fv(c)};a.base=function(c){return new Gv(c)};a.batchOutput=function(c){return new Hv(c)};a.behaviorOverride=function(c){return new Iv(c)};a.cache=function(c){return new Jv(c)};a.change=function(c){return new Kv(c)};a.common=function(c){return new Lv(c)};a.compress=function(c){return new Mv(c)};a.compressLogicalStructure=function(c){return new Nv(c)};a.compressObjectStream=function(c){return new Ov(c)};a.compression=function(c){return new Pv(c)};\na.config=function(c){return new Qv(c)};a.conformance=function(c){return new Rv(c)};a.contentCopy=function(c){return new Sv(c)};a.copies=function(c){return new Tv(c)};a.creator=function(c){return new Uv(c)};a.currentPage=function(c){return new Vv(c)};a.data=function(c){return new Wv(c)};a.debug=function(c){return new Xv(c)};a.defaultTypeface=function(c){return new Yv(c)};a.destination=function(c){return new Zv(c)};a.documentAssembly=function(c){return new $v(c)};a.driver=function(c){return new aw(c)};\na.duplexOption=function(c){return new bw(c)};a.dynamicRender=function(c){return new cw(c)};a.embed=function(c){return new dw(c)};a.encrypt=function(c){return new ew(c)};a.encryption=function(c){return new fw(c)};a.encryptionLevel=function(c){return new gw(c)};a.enforce=function(c){return new hw(c)};a.equate=function(c){return new iw(c)};a.equateRange=function(c){return new jw(c)};a.exclude=function(c){return new kw(c)};a.excludeNS=function(c){return new lw(c)};a.flipLabel=function(c){return new mw(c)};\na.fontInfo=function(c){return new nw(c)};a.formFieldFilling=function(c){return new ow(c)};a.groupParent=function(c){return new pw(c)};a.ifEmpty=function(c){return new qw(c)};a.includeXDPContent=function(c){return new rw(c)};a.incrementalLoad=function(c){return new sw(c)};a.incrementalMerge=function(c){return new tw(c)};a.interactive=function(c){return new uw(c)};a.jog=function(c){return new vw(c)};a.labelPrinter=function(c){return new ww(c)};a.layout=function(c){return new xw(c)};a.level=function(c){return new yw(c)};\na.linearized=function(c){return new zw(c)};a.locale=function(c){return new Aw(c)};a.localeSet=function(c){return new Bw(c)};a.log=function(c){return new Cw(c)};a.map=function(c){return new Dw(c)};a.mediumInfo=function(c){return new Ew(c)};a.message=function(c){return new Fw(c)};a.messaging=function(c){return new Gw(c)};a.mode=function(c){return new Hw(c)};a.modifyAnnots=function(c){return new Iw(c)};a.msgId=function(c){return new Jw(c)};a.nameAttr=function(c){return new Kw(c)};a.neverEmbed=function(c){return new Lw(c)};\na.numberOfCopies=function(c){return new Mw(c)};a.openAction=function(c){return new Nw(c)};a.output=function(c){return new Ow(c)};a.outputBin=function(c){return new Pw(c)};a.outputXSL=function(c){return new Qw(c)};a.overprint=function(c){return new Rw(c)};a.packets=function(c){return new Sw(c)};a.pageOffset=function(c){return new Tw(c)};a.pageRange=function(c){return new Uw(c)};a.pagination=function(c){return new Vw(c)};a.paginationOverride=function(c){return new Ww(c)};a.part=function(c){return new Xw(c)};\na.pcl=function(c){return new Yw(c)};a.pdf=function(c){return new Zw(c)};a.pdfa=function(c){return new $w(c)};a.permissions=function(c){return new ax(c)};a.pickTrayByPDFSize=function(c){return new bx(c)};a.picture=function(c){return new cx(c)};a.plaintextMetadata=function(c){return new dx(c)};a.presence=function(c){return new ex(c)};a.present=function(c){return new fx(c)};a.print=function(c){return new gx(c)};a.printHighQuality=function(c){return new hx(c)};a.printScaling=function(c){return new ix(c)};\na.printerName=function(c){return new jx(c)};a.producer=function(c){return new kx(c)};a.ps=function(c){return new lx(c)};a.range=function(c){return new mx(c)};a.record=function(c){return new nx(c)};a.relevant=function(c){return new ox(c)};a.rename=function(c){return new px(c)};a.renderPolicy=function(c){return new qx(c)};a.runScripts=function(c){return new rx(c)};a.script=function(c){return new sx(c)};a.scriptModel=function(c){return new tx(c)};a.severity=function(c){return new ux(c)};a.silentPrint=\nfunction(c){return new vx(c)};a.staple=function(c){return new wx(c)};a.startNode=function(c){return new xx(c)};a.startPage=function(c){return new yx(c)};a.submitFormat=function(c){return new zx(c)};a.submitUrl=function(c){return new Ax(c)};a.subsetBelow=function(c){return new Bx(c)};a.suppressBanner=function(c){return new Cx(c)};a.tagged=function(c){return new Dx(c)};a.template=function(c){return new Ex(c)};a.templateCache=function(c){return new Hx(c)};a.threshold=function(c){return new Fx(c)};a.to=\nfunction(c){return new Gx(c)};a.trace=function(c){return new Ix(c)};a.transform=function(c){return new Jx(c)};a.type=function(c){return new Kx(c)};a.uri=function(c){return new Lx(c)};a.validate=function(c){return new Mx(c)};a.validateApprovalSignatures=function(c){return new Nx(c)};a.validationMessaging=function(c){return new Ox(c)};a.version=function(c){return new Px(c)};a.versionControl=function(c){return new Qx(c)};a.viewerPreferences=function(c){return new Rx(c)};a.webClient=function(c){return new Sx(c)};\na.whitespace=function(c){return new Tx(c)};a.window=function(c){return new Ux(c)};a.xdc=function(c){return new Vx(c)};a.xdp=function(c){return new Wx(c)};a.xsl=function(c){return new Xx(c)};a.zpl=function(c){return new Yx(c)};return a}(),gd=Qb.connectionSet.id,$x=function(a){function c(){var b=a.call(this,gd,"connectionSet",!0)||this;b.wsdlConnection=new P;b.xmlConnection=new P;b.xsdConnection=new P;return b}cd(c,a);return c}(na),ay=function(a){function c(b){var d=a.call(this,gd,"effectiveInputPolicy")||\nthis;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}cd(c,a);return c}(na),by=function(a){function c(b){var d=a.call(this,gd,"effectiveOutputPolicy")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}cd(c,a);return c}(na),cy=function(a){function c(b){var d=a.call(this,gd,"operation")||this;d.id=b.id||"";d.input=b.input||"";d.name=b.name||"";d.output=b.output||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}cd(c,a);return c}(cb),\ndy=function(a){function c(b){var d=a.call(this,gd,"rootElement")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}cd(c,a);return c}(cb),ey=function(a){function c(b){var d=a.call(this,gd,"soapAction")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}cd(c,a);return c}(cb),fy=function(a){function c(b){var d=a.call(this,gd,"soapAddress")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}cd(c,\na);return c}(cb),gy=function(a){function c(b){var d=a.call(this,gd,"uri")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}cd(c,a);return c}(cb),hy=function(a){function c(b){var d=a.call(this,gd,"wsdlAddress")||this;d.id=b.id||"";d.name=b.name||"";d.use=b.use||"";d.usehref=b.usehref||"";return d}cd(c,a);return c}(cb),iy=function(a){function c(b){var d=a.call(this,gd,"wsdlConnection",!0)||this;d.dataDescription=b.dataDescription||"";d.name=b.name||"";d.effectiveInputPolicy=\nnull;d.effectiveOutputPolicy=null;d.operation=null;d.soapAction=null;d.soapAddress=null;d.wsdlAddress=null;return d}cd(c,a);return c}(na),jy=function(a){function c(b){var d=a.call(this,gd,"xmlConnection",!0)||this;d.dataDescription=b.dataDescription||"";d.name=b.name||"";d.uri=null;return d}cd(c,a);return c}(na),ky=function(a){function c(b){var d=a.call(this,gd,"xsdConnection",!0)||this;d.dataDescription=b.dataDescription||"";d.name=b.name||"";d.rootElement=null;d.uri=null;return d}cd(c,a);return c}(na),\nly=function(){function a(){}a[pd]=function(c,b){if(a.hasOwnProperty(c))return a[c](b)};a.connectionSet=function(c){return new $x(c)};a.effectiveInputPolicy=function(c){return new ay(c)};a.effectiveOutputPolicy=function(c){return new by(c)};a.operation=function(c){return new cy(c)};a.rootElement=function(c){return new dy(c)};a.soapAction=function(c){return new ey(c)};a.soapAddress=function(c){return new fy(c)};a.uri=function(c){return new gy(c)};a.wsdlAddress=function(c){return new hy(c)};a.wsdlConnection=\nfunction(c){return new iy(c)};a.xmlConnection=function(c){return new jy(c)};a.xsdConnection=function(c){return new ky(c)};return a}(),Xj=Qb.datasets.id,my=function(a){function c(b){return a.call(this,Xj,"data",b)||this}Rm(c,a);c.prototype[Lf]=function(){return!0};return c}(ze),ny=function(a){function c(){var b=a.call(this,Xj,"datasets",!0)||this;b.data=null;b.Signature=null;return b}Rm(c,a);c.prototype[Ad]=function(b){var d=b[kb];if("data"===d&&b[Pb]===Xj||"Signature"===d&&b[Pb]===Qb.signature.id)this[d]=\nb;this[Cb](b)};return c}(na),oy=function(){function a(){}a[pd]=function(c,b){if(a.hasOwnProperty(c))return a[c](b)};a.datasets=function(c){return new ny(c)};a.data=function(c){return new my(c)};return a}(),Ib=Qb.localeSet.id,py=function(a){function c(){var b=a.call(this,Ib,"calendarSymbols",!0)||this;b.name="gregorian";b.dayNames=new P(2);b.eraNames=null;b.meridiemNames=null;b.monthNames=new P(2);return b}Db(c,a);return c}(na),qy=function(a){function c(b){var d=a.call(this,Ib,"currencySymbol")||this;\nd.name=ua(b.name,["symbol","isoname","decimal"]);return d}Db(c,a);return c}(cb),ry=function(a){function c(){var b=a.call(this,Ib,"currencySymbols",!0)||this;b.currencySymbol=new P(3);return b}Db(c,a);return c}(na),sy=function(a){function c(b){var d=a.call(this,Ib,"datePattern")||this;d.name=ua(b.name,["full","long","med","short"]);return d}Db(c,a);return c}(cb),ty=function(a){function c(){var b=a.call(this,Ib,"datePatterns",!0)||this;b.datePattern=new P(4);return b}Db(c,a);return c}(na),uy=function(a){function c(){return a.call(this,\nIb,"dateTimeSymbols")||this}Db(c,a);return c}(Hb),vy=function(a){function c(){return a.call(this,Ib,"day")||this}Db(c,a);return c}(cb),wy=function(a){function c(b){var d=a.call(this,Ib,"dayNames",!0)||this;d.abbr=Ta({data:b.abbr,defaultValue:0,validate:function(e){return 1===e}});d.day=new P(7);return d}Db(c,a);return c}(na),xy=function(a){function c(){return a.call(this,Ib,"era")||this}Db(c,a);return c}(cb),yy=function(a){function c(){var b=a.call(this,Ib,"eraNames",!0)||this;b.era=new P(2);return b}\nDb(c,a);return c}(na),zy=function(a){function c(b){var d=a.call(this,Ib,"locale",!0)||this;d.desc=b.desc||"";d.name="isoname";d.calendarSymbols=null;d.currencySymbols=null;d.datePatterns=null;d.dateTimeSymbols=null;d.numberPatterns=null;d.numberSymbols=null;d.timePatterns=null;d.typeFaces=null;return d}Db(c,a);return c}(na),Ay=function(a){function c(){var b=a.call(this,Ib,"localeSet",!0)||this;b.locale=new P;return b}Db(c,a);return c}(na),By=function(a){function c(){return a.call(this,Ib,"meridiem")||\nthis}Db(c,a);return c}(cb),Cy=function(a){function c(){var b=a.call(this,Ib,"meridiemNames",!0)||this;b.meridiem=new P(2);return b}Db(c,a);return c}(na),Dy=function(a){function c(){return a.call(this,Ib,"month")||this}Db(c,a);return c}(cb),Ey=function(a){function c(b){var d=a.call(this,Ib,"monthNames",!0)||this;d.abbr=Ta({data:b.abbr,defaultValue:0,validate:function(e){return 1===e}});d.month=new P(12);return d}Db(c,a);return c}(na),Fy=function(a){function c(b){var d=a.call(this,Ib,"numberPattern")||\nthis;d.name=ua(b.name,["full","long","med","short"]);return d}Db(c,a);return c}(cb),Gy=function(a){function c(){var b=a.call(this,Ib,"numberPatterns",!0)||this;b.numberPattern=new P(4);return b}Db(c,a);return c}(na),Hy=function(a){function c(b){var d=a.call(this,Ib,"numberSymbol")||this;d.name=ua(b.name,["decimal","grouping","percent","minus","zero"]);return d}Db(c,a);return c}(cb),Iy=function(a){function c(){var b=a.call(this,Ib,"numberSymbols",!0)||this;b.numberSymbol=new P(5);return b}Db(c,a);\nreturn c}(na),Jy=function(a){function c(b){var d=a.call(this,Ib,"timePattern")||this;d.name=ua(b.name,["full","long","med","short"]);return d}Db(c,a);return c}(cb),Ky=function(a){function c(){var b=a.call(this,Ib,"timePatterns",!0)||this;b.timePattern=new P(4);return b}Db(c,a);return c}(na),Ly=function(a){function c(b){var d=a.call(this,Ib,"typeFace",!0)||this;d.name=b.name|0;return d}Db(c,a);return c}(na),My=function(a){function c(){var b=a.call(this,Ib,"typeFaces",!0)||this;b.typeFace=new P;return b}\nDb(c,a);return c}(na),Ny=function(){function a(){}a[pd]=function(c,b){if(a.hasOwnProperty(c))return a[c](b)};a.calendarSymbols=function(c){return new py(c)};a.currencySymbol=function(c){return new qy(c)};a.currencySymbols=function(c){return new ry(c)};a.datePattern=function(c){return new sy(c)};a.datePatterns=function(c){return new ty(c)};a.dateTimeSymbols=function(c){return new uy(c)};a.day=function(c){return new vy(c)};a.dayNames=function(c){return new wy(c)};a.era=function(c){return new xy(c)};\na.eraNames=function(c){return new yy(c)};a.locale=function(c){return new zy(c)};a.localeSet=function(c){return new Ay(c)};a.meridiem=function(c){return new By(c)};a.meridiemNames=function(c){return new Cy(c)};a.month=function(c){return new Dy(c)};a.monthNames=function(c){return new Ey(c)};a.numberPattern=function(c){return new Fy(c)};a.numberPatterns=function(c){return new Gy(c)};a.numberSymbol=function(c){return new Hy(c)};a.numberSymbols=function(c){return new Iy(c)};a.timePattern=function(c){return new Jy(c)};\na.timePatterns=function(c){return new Ky(c)};a.typeFace=function(c){return new Ly(c)};a.typeFaces=function(c){return new My(c)};return a}(),Oy=Qb.signature.id,Py=function(a){function c(){return a.call(this,Oy,"signature",!0)||this}Tq(c,a);return c}(na),Qy=function(){function a(){}a[pd]=function(c,b){if(a.hasOwnProperty(c))return a[c](b)};a.signature=function(c){return new Py(c)};return a}(),Ry=Qb.stylesheet.id,Sy=function(a){function c(){return a.call(this,Ry,"stylesheet",!0)||this}Uq(c,a);return c}(na),\nTy=function(){function a(){}a[pd]=function(c,b){if(a.hasOwnProperty(c))return a[c](b)};a.stylesheet=function(c){return new Sy(c)};return a}(),Uy=Qb.xdp.id,Vy=function(a){function c(b){var d=a.call(this,Uy,"xdp",!0)||this;d.uuid=b.uuid||"";d.timeStamp=b.timeStamp||"";d.config=null;d.connectionSet=null;d.datasets=null;d.localeSet=null;d.stylesheet=new P;d.template=null;return d}Vq(c,a);c.prototype[Hj]=function(b){var d=Qb[b[kb]];return d&&b[Pb]===d.id};return c}(na),Wy=function(){function a(){}a[pd]=\nfunction(c,b){if(a.hasOwnProperty(c))return a[c](b)};a.xdp=function(c){return new Vy(c)};return a}(),Xy=Qb.xhtml.id,$g=Symbol(),Zq=new Set("color font font-family font-size font-stretch font-style font-weight margin margin-bottom margin-left margin-right margin-top letter-spacing line-height orphans page-break-after page-break-before page-break-inside tab-interval tab-stop text-align text-decoration text-indent vertical-align widows kerning-mode xfa-font-horizontal-scale xfa-font-vertical-scale xfa-spacerun xfa-tab-stops".split(" ")),\nXq=new Map([["page-break-after","breakAfter"],["page-break-before","breakBefore"],["page-break-inside","breakInside"],["kerning-mode",function(a){return"none"===a?"none":"normal"}],["xfa-font-horizontal-scale",function(a){return"scaleX("+Math.max(0,Math.min(parseInt(a)/100)).toFixed(2)+")"}],["xfa-font-vertical-scale",function(a){return"scaleY("+Math.max(0,Math.min(parseInt(a)/100)).toFixed(2)+")"}],["xfa-spacerun",""],["xfa-tab-stops",""],["font-size",function(a,c){a=c.fontSize=Ma(a);return Ua(.99*\na)}],["letter-spacing",function(a){return Ua(Ma(a))}],["line-height",function(a){return Ua(Ma(a))}],["margin",function(a){return Ua(Ma(a))}],["margin-bottom",function(a){return Ua(Ma(a))}],["margin-left",function(a){return Ua(Ma(a))}],["margin-right",function(a){return Ua(Ma(a))}],["margin-top",function(a){return Ua(Ma(a))}],["text-indent",function(a){return Ua(Ma(a))}],["font-family",function(a){return a}],["vertical-align",function(a){return Ua(Ma(a))}]]),Yy=/\\s+/g,Zy=/[\\r\\n]+/g,$y=/\\r\\n?/g,az=\nnew Set(["body","html"]),Xc=function(a){function c(d,e){e=a.call(this,Xy,e)||this;e[$g]=!1;e.style=d.style||"";return e}Hc(c,a);var b=c.prototype;b[dd]=function(d){a.prototype[dd].call(this,d);this.style=Yq(this)};b[Vg]=function(){return!az.has(this[kb])};b[Ld]=function(d,e){void 0===e&&(e=!1);e?this[$g]=!0:(d=d.replaceAll(Zy,""),this.style.includes("xfa-spacerun:yes")||(d=d.replaceAll(Yy," ")));d&&(this[ra]+=d)};b[xd]=function(d,e){void 0===e&&(e=!0);for(var g=Object.create(null),f={top:NaN,bottom:NaN,\nleft:NaN,right:NaN},h=null,k=u.makeIterator(this.style.split(";").map(function(n){return n.split(":",2)})),l=k.next();!l.done;l=k.next()){var m=u.makeIterator(l.value);l=m.next().value;m=m.next().value;switch(l){case "font-family":g.typeface=ug(m);break;case "font-size":g.size=Ma(m);break;case "font-weight":g.weight=m;break;case "font-style":g.posture=m;break;case "letter-spacing":g.letterSpacing=Ma(m);break;case "margin":l=m.split(/ \\t/).map(function(n){return Ma(n)});switch(l.length){case 1:f.top=\nf.bottom=f.left=f.right=l[0];break;case 2:f.top=f.bottom=l[0];f.left=f.right=l[1];break;case 3:f.top=l[0];f.bottom=l[2];f.left=f.right=l[1];break;case 4:f.top=l[0],f.left=l[1],f.bottom=l[2],f.right=l[3]}break;case "margin-top":f.top=Ma(m);break;case "margin-bottom":f.bottom=Ma(m);break;case "margin-left":f.left=Ma(m);break;case "margin-right":f.right=Ma(m);break;case "line-height":h=Ma(m)}}d.pushData(g,f,h);if(this[ra])d.addString(this[ra]);else for(g=u.makeIterator(this[ac]()),f=g.next();!f.done;f=\ng.next())if(f=f.value,"#text"===f[kb])d.addString(f[ra]);else f[xd](d);e&&d.popFont()};b[Ra]=function(){var d=[];this[ja]={children:d};this[Xd]({});if(0===d.length&&!this[ra])return Pa.EMPTY;var e=this[$g]?this[ra]?this[ra].replaceAll($y,"\\n"):void 0:this[ra]||void 0;return Pa.success({name:this[kb],attributes:{href:this.href,style:Wq(this.style,this,this[$g])},children:d,value:e})};return c}(ze),bz=function(a){function c(b){var d=a.call(this,b,"a")||this;d.href=Gm(b.href)||"";return d}Hc(c,a);return c}(Xc),\ncz=function(a){function c(b){return a.call(this,b,"b")||this}Hc(c,a);c.prototype[xd]=function(b){b.pushFont({weight:"bold"});a.prototype[xd].call(this,b);b.popFont()};return c}(Xc),dz=function(a){function c(b){return a.call(this,b,"body")||this}Hc(c,a);c.prototype[Ra]=function(b){b=a.prototype[Ra].call(this,b);var d=b.html;if(!d)return Pa.EMPTY;d.name="div";d.attributes.class=["xfaRich"];return b};return c}(Xc),ez=function(a){function c(d){return a.call(this,d,"br")||this}Hc(c,a);var b=c.prototype;\nb[Sb]=function(){return"\\n"};b[xd]=function(d){d.addString("\\n")};b[Ra]=function(){return Pa.success({name:"br"})};return c}(Xc),fz=function(a){function c(b){return a.call(this,b,"html")||this}Hc(c,a);c.prototype[Ra]=function(){var b=[];this[ja]={children:b};this[Xd]({});if(0===b.length)return Pa.success({name:"div",attributes:{class:["xfaRich"],style:{}},value:this[ra]||""});if(1===b.length){var d,e=b[0];if(null!=(d=e.attributes)&&d.class.includes("xfaRich"))return Pa.success(e)}return Pa.success({name:"div",\nattributes:{class:["xfaRich"],style:{}},children:b})};return c}(Xc),gz=function(a){function c(b){return a.call(this,b,"i")||this}Hc(c,a);c.prototype[xd]=function(b){b.pushFont({posture:"italic"});a.prototype[xd].call(this,b);b.popFont()};return c}(Xc),hz=function(a){function c(b){return a.call(this,b,"li")||this}Hc(c,a);return c}(Xc),iz=function(a){function c(b){return a.call(this,b,"ol")||this}Hc(c,a);return c}(Xc),jz=function(a){function c(d){return a.call(this,d,"p")||this}Hc(c,a);var b=c.prototype;\nb[xd]=function(d){a.prototype[xd].call(this,d,!1);d.addString("\\n");d.addPara();d.popFont()};b[Sb]=function(){return this[Va]()[ac]().at(-1)===this?a.prototype[Sb].call(this):a.prototype[Sb].call(this)+"\\n"};return c}(Xc),kz=function(a){function c(b){return a.call(this,b,"span")||this}Hc(c,a);return c}(Xc),lz=function(a){function c(b){return a.call(this,b,"sub")||this}Hc(c,a);return c}(Xc),mz=function(a){function c(b){return a.call(this,b,"sup")||this}Hc(c,a);return c}(Xc),nz=function(a){function c(b){return a.call(this,\nb,"ul")||this}Hc(c,a);return c}(Xc),Yj=function(){function a(){}a[pd]=function(c,b){if(a.hasOwnProperty(c))return a[c](b)};a.a=function(c){return new bz(c)};a.b=function(c){return new cz(c)};a.body=function(c){return new dz(c)};a.br=function(c){return new ez(c)};a.html=function(c){return new fz(c)};a.i=function(c){return new gz(c)};a.li=function(c){return new hz(c)};a.ol=function(c){return new iz(c)};a.p=function(c){return new jz(c)};a.span=function(c){return new kz(c)};a.sub=function(c){return new lz(c)};\na.sup=function(c){return new mz(c)};a.ul=function(c){return new nz(c)};return a}(),Qo={config:Zx,connection:ly,datasets:oy,localeSet:Ny,signature:Qy,stylesheet:Ty,template:pv,xdp:Wy,xhtml:Yj},Ro=function(){function a(c){this.namespaceId=c}a.prototype[pd]=function(c,b){return new ze(this.namespaceId,c,b)};return a}(),oz=function(a){function c(d){var e=a.call(this,-1,"root",Object.create(null))||this;e.element=null;e[af]=d;return e}Sm(c,a);var b=c.prototype;b[Ad]=function(d){this.element=d;return!0};\nb[sb]=function(){a.prototype[sb].call(this);this.element.template instanceof Vj&&(this[af].set(to,this.element),this.element.template[Of](this[af]),this.element.template[af]=this[af])};return c}(na),pz=function(a){function c(){return a.call(this,-1,"",Object.create(null))||this}Sm(c,a);c.prototype[Ad]=function(){return!1};return c}(na),qz=function(){function a(b){void 0===b&&(b=null);this._namespaceStack=[];this._nsAgnosticLevel=0;this._namespacePrefixes=new Map;this._namespaces=new Map;this._nextNsId=\nMath.max.apply(Math,u.arrayFromIterable(Object.values(Qb).map(function(d){return d.id})));this._currentNamespace=b||new Ro(++this._nextNsId)}var c=a.prototype;c.buildRoot=function(b){return new oz(b)};c.build=function(b){var d=b.nsPrefix,e=b.name,g=b.attributes,f=b.namespace;b=b.prefixes;var h=null!==f;h&&(this._namespaceStack.push(this._currentNamespace),this._currentNamespace=this._searchNamespace(f));b&&this._addNamespacePrefix(b);if(g.hasOwnProperty(Zd)){f=Qo.datasets;for(var k=null,l=u.makeIterator(Object.entries(g[Zd])),\nm=l.next();!m.done;m=l.next()){var n=u.makeIterator(m.value);m=n.next().value;n=n.next().value;if(this._getNamespaceToUse(m)===f){k={xfa:n};break}}k?g[Zd]=k:delete g[Zd]}d=this._getNamespaceToUse(d);e=(null==d?void 0:d[pd](e,g))||new pz;e[Lf]()&&this._nsAgnosticLevel++;if(h||b||e[Lf]())e[Wg]={hasNamespace:h,prefixes:b,nsAgnostic:e[Lf]()};return e};c.isNsAgnostic=function(){return 0<this._nsAgnosticLevel};c._searchNamespace=function(b){var d=this._namespaces.get(b);if(d)return d;d=u.makeIterator(Object.entries(Qb));\nfor(var e=d.next();!e.done;e=d.next()){var g=u.makeIterator(e.value);e=g.next().value;g=g.next().value.check;if(g(b)){if(d=Qo[e])return this._namespaces.set(b,d),d;break}}d=new Ro(++this._nextNsId);this._namespaces.set(b,d);return d};c._addNamespacePrefix=function(b){b=u.makeIterator(b);for(var d=b.next();!d.done;d=b.next()){var e=d.value;d=e.prefix;e=this._searchNamespace(e.value);var g=this._namespacePrefixes.get(d);g||(g=[],this._namespacePrefixes.set(d,g));g.push(e)}};c._getNamespaceToUse=function(b){if(!b)return this._currentNamespace;\nvar d=this._namespacePrefixes.get(b);if(0<(null==d?void 0:d.length))return d.at(-1);T("Unknown namespace prefix: "+b+".");return null};c.clean=function(b){var d=this,e=b.prefixes,g=b.nsAgnostic;b.hasNamespace&&(this._currentNamespace=this._namespaceStack.pop());e&&e.forEach(function(f){d._namespacePrefixes.get(f.prefix).pop()});g&&this._nsAgnosticLevel--};return a}(),So=function(a){function c(d,e){void 0===d&&(d=null);void 0===e&&(e=!1);var g=a.call(this)||this;g._builder=new qz(d);g._stack=[];g._globalData=\n{usedTypefaces:new Set};g._ids=new Map;g._current=g._builder.buildRoot(g._ids);g._errorCode=0;g._whiteRegex=/^\\s+$/;g._nbsps=/\\xa0+/g;g._richText=e;return g}$q(c,a);var b=c.prototype;b.parse=function(d){this.parseXml(d);if(0===this._errorCode)return this._current[sb](),this._current.element};b.onText=function(d){d=d.replace(this._nbsps,function(e){return e.slice(1)+" "});if(this._richText||this._current[Vg]())this._current[Ld](d,this._richText);else if(!this._whiteRegex.test(d))this._current[Ld](d.trim())};\nb.onCdata=function(d){this._current[Ld](d)};b._mkAttributes=function(d,e){var g=null,f=null,h=Object.create({});d=u.makeIterator(d);for(var k=d.next();!k.done;k=d.next()){k=k.value;var l=k.name;k=k.value;if("xmlns"===l)g?T("XFA - multiple namespace definition in <"+e+">"):g=k;else if(l.startsWith("xmlns:")){var m=l.substring(6);f||(f=[]);f.push({prefix:m,value:k})}else{var n=l.indexOf(":");if(-1===n)h[l]=k;else{var p;(m=h[Zd])||(m=h[Zd]=Object.create(null));n=u.makeIterator([l.slice(0,n),l.slice(n+\n1)]);l=n.next().value;n=n.next().value;((p=m)[l]||(p[l]=Object.create(null)))[n]=k}}}return[g,f,h]};b._getNameAndPrefix=function(d,e){var g=d.indexOf(":");return-1===g?[d,null]:[d.substring(g+1),e?"":d.substring(0,g)]};b.onBeginElement=function(d,e,g){var f=u.makeIterator(this._mkAttributes(e,d));e=f.next().value;var h=f.next().value;f=f.next().value;var k=u.makeIterator(this._getNameAndPrefix(d,this._builder.isNsAgnostic()));d=k.next().value;k=k.next().value;e=this._builder.build({nsPrefix:k,name:d,\nattributes:f,namespace:e,prefixes:h});e[rb]=this._globalData;if(g){e[sb]();if(this._current[Ad](e))e[Ij](this._ids);e[dd](this._builder)}else this._stack.push(this._current),this._current=e};b.onEndElement=function(){var d=this._current;if(d[Gj]()&&"string"===typeof d[ra]){var e=new c;e._globalData=this._globalData;e=e.parse(d[ra]);d[ra]=null;d[Ad](e)}d[sb]();this._current=this._stack.pop();if(this._current[Ad](d))d[Ij](this._ids);d[dd](this._builder)};b.onError=function(d){this._errorCode=d};return c}(mo),\nZj=function(){function a(b){try{this.root=(new So).parse(a._createDocument(b));var d=new qv(this.root);this.form=d.bind();this.dataHandler=new rv(this.root,d.getData());this.form[rb].template=this.form}catch(e){T("XFA - an error occurred during parsing and binding: "+e)}}var c=a.prototype;c.isValid=function(){return this.root&&this.form};c._createPagesHelper=function(){var b=this.form[vo]();return new Promise(function(d,e){function g(){try{var f=b.next();f.done?d(f.value):setTimeout(g,0)}catch(h){e(h)}}\nsetTimeout(g,0)})};c._createPages=function(){var b=$i(function e(){var g=this,f;return u.generator.createGenerator(e,function(h){if(1==h.nextAddress)return h.setCatchFinallyBlocks(2),h.yield(g._createPagesHelper(),4);if(2!=h.nextAddress)return g.pages=h.yieldResult,g.dims=g.pages.children.map(function(k){k=k.attributes.style;var l=k.height;return[0,0,parseInt(k.width),parseInt(l)]}),h.leaveTryBlock(0);f=h.enterCatchBlock();T("XFA - an error occurred during layout: "+f);h.jumpToEnd()})});return function(){return b.apply(this,\narguments)}}();c.getBoundingBox=function(b){return this.dims[b]};c.getNumPages=function(){var b=$i(function e(){var g=this;return u.generator.createGenerator(e,function(f){return 1==f.nextAddress?g.pages?f.jumpTo(2):f.yield(g._createPages(),2):f.return(g.dims.length)})});return function(){return b.apply(this,arguments)}}();c.setImages=function(b){this.form[rb].images=b};c.setFonts=function(b){this.form[rb].fontFinder=new Ft(b);b=[];for(var d=u.makeIterator(this.form[rb].usedTypefaces),e=d.next();!e.done;e=\nd.next())e=e.value,e=ug(e),this.form[rb].fontFinder.find(e)||b.push(e);return 0<b.length?b:null};c.appendFonts=function(b,d){this.form[rb].fontFinder.add(b,d)};c.getPages=function(){var b=$i(function e(){var g=this,f;return u.generator.createGenerator(e,function(h){if(1==h.nextAddress)return g.pages?h.jumpTo(2):h.yield(g._createPages(),2);f=g.pages;g.pages=null;return h.return(f)})});return function(){return b.apply(this,arguments)}}();c.serializeData=function(b){return this.dataHandler.serialize(b)};\na._createDocument=function(b){return b["/xdp:xdp"]?Object.values(b).join(""):b["xdp:xdp"]};a.getRichTextAsHtml=function(b){if(!b||"string"!==typeof b)return null;try{var d=(new So(Yj,!0)).parse(b);if(!["body","xhtml"].includes(d[kb])){var e=Yj.body({});e[Cb](d);d=e}var g=d[Ra]();if(!g.success)return null;var f=g.html,h=f.attributes;h&&(h.class&&(h.class=h.class.filter(function(k){return!k.startsWith("xfa")})),h.dir="auto");return{html:f,str:d[Sb]()}}catch(k){T("XFA - an error occurred during parsing of rich text: "+\nk)}return null};return a}(),ce=function(){function a(){}a.createGlobals=function(c){return Promise.all([c.ensureCatalog("acroForm"),c.ensureDoc("xfaDatasets"),c.ensureCatalog("structTreeRoot"),c.ensureCatalog("baseUrl"),c.ensureCatalog("attachments")]).then(function(b){var d=u.makeIterator(b);b=d.next().value;var e=d.next().value,g=d.next().value,f=d.next().value;d=d.next().value;return{pdfManager:c,acroForm:b instanceof ca?b:ca.empty,xfaDatasets:e,structTreeRoot:g,baseUrl:f,attachments:d}},function(b){T(\'createGlobals: "\'+\nb+\'".\');return null})};a.create=function(){var c=Bb(function m(d,e,g,f,h,k,l){var n,p=this,q;return u.generator.createGenerator(m,function(r){if(1==r.nextAddress)return h?r.yield(p._getPageIndex(d,e,g.pdfManager),3):(n=null,r.jumpTo(2));2!=r.nextAddress&&(n=r.yieldResult);q=n;return r.return(g.pdfManager.ensure(p,"_create",[d,e,g,f,h,k,q,l]))})});return function(d,e,g,f,h,k,l){return c.apply(this,arguments)}}();a._create=function(c,b,d,e,g,f,h,k){void 0===g&&(g=!1);void 0===f&&(f=null);void 0===h&&\n(h=null);void 0===k&&(k=null);var l=c.fetchIfRef(b);if(l instanceof ca){var m=d.acroForm,n=d.pdfManager,p=b instanceof Ha?b.toString():"annot_"+e.createObjId();e=l.get("Subtype");e=e instanceof ka?e.name:null;c={xref:c,ref:b,dict:l,subtype:e,id:p,annotationGlobals:d,collectFields:g,orphanFields:f,needAppearances:!g&&!0===m.get("NeedAppearances"),pageIndex:h,evaluatorOptions:n.evaluatorOptions,pageRef:k};switch(e){case "Link":return new rz(c);case "Text":return new sz(c);case "Widget":g=Yc({dict:l,\nkey:"FT"});g=g instanceof ka?g.name:null;switch(g){case "Tx":return new tz(c);case "Btn":return new uz(c);case "Ch":return new vz(c);case "Sig":return new To(c)}T(\'Unimplemented widget field type "\'+g+\'", falling back to base field type.\');return new be(c);case "Popup":return new Uo(c);case "FreeText":return new ak(c);case "Line":return new wz(c);case "Square":return new xz(c);case "Circle":return new yz(c);case "PolyLine":return new Vo(c);case "Polygon":return new Wo(c);case "Caret":return new zz(c);\ncase "Ink":return new Uf(c);case "Highlight":return new bk(c);case "Underline":return new Az(c);case "Squiggly":return new Bz(c);case "StrikeOut":return new Cz(c);case "Stamp":return new ah(c);case "FileAttachment":return new Dz(c);default:return g||(e?T(\'Unimplemented annotation type "\'+e+\'", falling back to base annotation.\'):T("Annotation is missing the required /Subtype.")),new Vf(c)}}};a._getPageIndex=function(){var c=Bb(function f(d,e,g){var h,k,l,m,n,p,q,r,t,v,w,y;return u.generator.createGenerator(f,\nfunction(x){switch(x.nextAddress){case 1:return x.setCatchFinallyBlocks(2),x.yield(d.fetchIfRefAsync(e),4);case 4:h=x.yieldResult;if(!(h instanceof ca))return x.return(-1);k=h.getRaw("P");if(!(k instanceof Ha)){x.jumpTo(5);break}x.setCatchFinallyBlocks(6);return x.yield(g.ensureCatalog("getPageIndex",[k]),8);case 8:return l=x.yieldResult,x.return(l);case 6:m=x.enterCatchBlock(2),Ya(\'_getPageIndex -- not a valid page reference: "\'+m+\'".\');case 5:return h.has("Kids")?x.return(-1):x.yield(g.ensureDoc("numPages"),\n9);case 9:n=x.yieldResult,p=0;case 10:if(!(p<n)){x.leaveTryBlock(3);break}return x.yield(g.getPage(p),13);case 13:return q=x.yieldResult,x.yield(g.ensure(q,"annotations"),14);case 14:r=x.yieldResult;t=u.makeIterator(r);for(v=t.next();!v.done;v=t.next())if(w=v.value,w instanceof Ha&&Yf(w,e))return x.return(p);p++;x.jumpTo(10);break;case 2:y=x.enterCatchBlock(),T(\'_getPageIndex: "\'+y+\'".\');case 3:return x.return(-1)}})});return function(d,e,g){return c.apply(this,arguments)}}();a.generateImages=function(c,\nb,d){if(!d)return T("generateImages: OffscreenCanvas is not supported, cannot save or print some annotations with images."),null;var e;c=u.makeIterator(c);for(d=c.next();!d.done;d=c.next()){var g=d.value;d=g.bitmapId;if(g=g.bitmap)e||(e=new Map),e.set(d,ah.createImage(g,b))}return e};a.saveNewAnnotations=function(){var c=Bb(function h(d,e,g,f){var k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G;return u.generator.createGenerator(h,function(J){switch(J.nextAddress){case 1:k=d.xref,m=[],n=[],p=d.options,q=p.isOffscreenCanvasSupported,\nr=u.makeIterator(g),t=r.next();case 2:if(t.done)return J.yield(Promise.all(n),16);v=t.value;if(v.deleted){J.jumpTo(3);break}switch(v.annotationType){case 3:return J.jumpTo(5);case 9:v.quadPoints?n.push(bk.createNewAnnotation(k,v,m)):n.push(Uf.createNewAnnotation(k,v,m));break;case 15:n.push(Uf.createNewAnnotation(k,v,m));break;case 13:return J.jumpTo(6)}J.jumpTo(3);break;case 5:if(l){J.jumpTo(8);break}w=new ca(k);w.set("BaseFont",ka.get("Helvetica"));w.set("Type",ka.get("Font"));w.set("Subtype",ka.get("Type1"));\nw.set("Encoding",ka.get("WinAnsiEncoding"));y=[];l=k.getNewTemporaryRef();return J.yield(pc(l,w,y,k),9);case 9:m.push({ref:l,data:y.join("")});case 8:n.push(ak.createNewAnnotation(k,v,m,{evaluator:d,task:e,baseFontRef:l}));J.jumpTo(3);break;case 6:if(!q){x=null;J.jumpTo(10);break}return J.yield(null==f?void 0:f.get(v.bitmapId),11);case 11:x=J.yieldResult;case 10:z=x;if(null==z||!z.imageStream){J.jumpTo(12);break}A=z;B=A.imageStream;C=A.smaskStream;D=[];if(!C){J.jumpTo(13);break}E=k.getNewTemporaryRef();\nreturn J.yield(pc(E,C,D,k),14);case 14:m.push({ref:E,data:D.join("")}),B.dict.set("SMask",E),D.length=0;case 13:return G=z.imageRef=k.getNewTemporaryRef(),J.yield(pc(G,B,D,k),15);case 15:m.push({ref:G,data:D.join("")}),z.imageStream=z.smaskStream=null;case 12:n.push(ah.createNewAnnotation(k,v,m,{image:z}));J.jumpTo(3);break;case 3:t=r.next();J.jumpTo(2);break;case 16:return J.return({annotations:J.yieldResult,dependencies:m})}})});return function(d,e,g,f){return c.apply(this,arguments)}}();a.printNewAnnotations=\nfunction(){var c=Bb(function k(d,e,g,f,h){var l,m,n,p,q,r,t,v,w,y,x,z;return u.generator.createGenerator(k,function(A){switch(A.nextAddress){case 1:if(!f)return A.return(null);l=e;m=l.options;n=l.xref;p=[];q=u.makeIterator(f);r=q.next();case 2:if(r.done){A.jumpTo(4);break}t=r.value;if(t.deleted){A.jumpTo(3);break}switch(t.annotationType){case 3:p.push(ak.createNewPrintAnnotation(d,n,t,{evaluator:e,task:g,evaluatorOptions:m}));break;case 9:t.quadPoints?p.push(bk.createNewPrintAnnotation(d,n,t,{evaluatorOptions:m})):\np.push(Uf.createNewPrintAnnotation(d,n,t,{evaluatorOptions:m}));break;case 15:p.push(Uf.createNewPrintAnnotation(d,n,t,{evaluatorOptions:m}));break;case 13:return A.jumpTo(5)}A.jumpTo(3);break;case 5:if(!m.isOffscreenCanvasSupported){v=null;A.jumpTo(7);break}return A.yield(null==h?void 0:h.get(t.bitmapId),8);case 8:v=A.yieldResult;case 7:w=v;null!=w&&w.imageStream&&(y=w,x=y.imageStream,(z=y.smaskStream)&&x.dict.set("SMask",z),w.imageRef=new mj(x,x.length),w.imageStream=w.smaskStream=null);p.push(ah.createNewPrintAnnotation(d,\nn,t,{image:w,evaluatorOptions:m}));A.jumpTo(3);break;case 3:r=q.next();A.jumpTo(2);break;case 4:return A.return(Promise.all(p))}})});return function(d,e,g,f,h){return c.apply(this,arguments)}}();return a}(),Vf=function(){function a(b){var d=b.dict,e=b.xref,g=b.annotationGlobals,f=b.ref,h=b.orphanFields;(f=null==h?void 0:h.get(f))&&d.set("Parent",f);this.setTitle(d.get("T"));this.setContents(d.get("Contents"));this.setModificationDate(d.get("M"));this.setFlags(d.get("F"));this.setRectangle(d.getArray("Rect"));\nthis.setColor(d.getArray("C"));this.setBorderStyle(d);this.setAppearance(d);this.setOptionalContent(d);f=d.get("MK");this.setBorderAndBackgroundColors(f);this.setRotation(f,d);this.ref=b.ref instanceof Ha?b.ref:null;this._streams=[];this.appearance&&this._streams.push(this.appearance);f=!!(this.flags&512);this.data={annotationFlags:this.flags,borderStyle:this.borderStyle,color:this.color,backgroundColor:this.backgroundColor,borderColor:this.borderColor,rotation:this.rotation,contentsObj:this._contents,\nhasAppearance:!!this.appearance,id:b.id,modificationDate:this.modificationDate,rect:this.rectangle,subtype:b.subtype,hasOwnCanvas:!1,noRotate:!!(this.flags&16),noHTML:!!(this.flags&128)&&f,isEditable:!1,structParent:-1};g.structTreeRoot&&(f=d.get("StructParent"),this.data.structParent=f=Number.isInteger(f)&&0<=f?f:-1,g.structTreeRoot.addAnnotationIdToPage(b.pageRef,f));if(b.collectFields){f=d.get("Kids");if(Array.isArray(f)){g=[];f=u.makeIterator(f);for(h=f.next();!h.done;h=f.next())h=h.value,h instanceof\nHa&&g.push(h.toString());0!==g.length&&(this.data.kidIds=g)}this.data.actions=ag(e,d,sn);this.data.fieldName=this._constructFieldName(d);this.data.pageIndex=b.pageIndex}d=d.get("IT");d instanceof ka&&(this.data.it=d.name);this._isOffscreenCanvasSupported=b.evaluatorOptions.isOffscreenCanvasSupported;this._fallbackFontDict=null;this._needAppearances=!1}var c=a.prototype;c._hasFlag=function(b,d){return!!(b&d)};c._buildFlags=function(b,d){var e=this.flags;if(void 0===b)return void 0===d?void 0:d?e&-5:\ne&-3|4;if(b)return e|=4,d?e&-33|2:e&-3|32;e&=-35;return d?e&-5:e|4};c._isViewable=function(b){return!this._hasFlag(b,1)&&!this._hasFlag(b,32)};c._isPrintable=function(b){return this._hasFlag(b,4)&&!this._hasFlag(b,2)&&!this._hasFlag(b,1)};c.mustBeViewed=function(b){var d;b=null==b||null==(d=b.get(this.data.id))?void 0:d.noView;return void 0!==b?!b:this.viewable&&!this._hasFlag(this.flags,2)};c.mustBePrinted=function(b){var d;b=null==b||null==(d=b.get(this.data.id))?void 0:d.noPrint;return void 0!==\nb?!b:this.printable};c.mustBeViewedWhenEditing=function(b,d){var e;void 0===d&&(d=null);return b?!this.data.isEditable:!(null!=(e=d)&&e.has(this.data.id))};c._parseStringHelper=function(b){var d=(b="string"===typeof b?ib(b):"")&&"rtl"===Cl(b).dir?"rtl":"ltr";return{str:b,dir:d}};c.setDefaultAppearance=function(b){var d=b.annotationGlobals;b=Yc({dict:b.dict,key:"DA"})||d.acroForm.get("DA");this._defaultAppearance="string"===typeof b?b:"";this.data.defaultAppearanceData=(new xj(this._defaultAppearance)).parse()};\nc.setTitle=function(b){this._title=this._parseStringHelper(b)};c.setContents=function(b){this._contents=this._parseStringHelper(b)};c.setModificationDate=function(b){this.modificationDate="string"===typeof b?b:null};c.setFlags=function(b){this.flags=Number.isInteger(b)&&0<b?b:0;this.flags&1&&"Annotation"!==this.constructor.name&&(this.flags^=1)};c.hasFlag=function(b){return this._hasFlag(this.flags,b)};c.setRectangle=function(b){this.rectangle=sd(b,[0,0,0,0])};c.setColor=function(b){this.color=Ne(b)};\nc.setLineEndings=function(b){this.lineEndings=["None","None"];if(Array.isArray(b)&&2===b.length)for(var d=0;2>d;d++){var e=b[d];if(e instanceof ka)switch(e.name){case "None":continue;case "Square":case "Circle":case "Diamond":case "OpenArrow":case "ClosedArrow":case "Butt":case "ROpenArrow":case "RClosedArrow":case "Slash":this.lineEndings[d]=e.name;continue}T("Ignoring invalid lineEnding: "+e)}};c.setRotation=function(b,d){this.rotation=0;b=b instanceof ca?b.get("R")||0:d.get("Rotate")||0;Number.isInteger(b)&&\n0!==b&&(b%=360,0>b&&(b+=360),0===b%90&&(this.rotation=b))};c.setBorderAndBackgroundColors=function(b){b instanceof ca?(this.borderColor=Ne(b.getArray("BC"),null),this.backgroundColor=Ne(b.getArray("BG"),null)):this.borderColor=this.backgroundColor=null};c.setBorderStyle=function(b){this.borderStyle=new Ez;if(b instanceof ca)if(b.has("BS")){if(b=b.get("BS"),b instanceof ca){var d=b.get("Type");if(!d||Lb(d,"Border"))this.borderStyle.setWidth(b.get("W"),this.rectangle),this.borderStyle.setStyle(b.get("S")),\nthis.borderStyle.setDashArray(b.getArray("D"))}}else b.has("Border")?(b=b.getArray("Border"),Array.isArray(b)&&3<=b.length&&(this.borderStyle.setHorizontalCornerRadius(b[0]),this.borderStyle.setVerticalCornerRadius(b[1]),this.borderStyle.setWidth(b[2],this.rectangle),4===b.length&&this.borderStyle.setDashArray(b[3],!0))):this.borderStyle.setWidth(0)};c.setAppearance=function(b){this.appearance=null;var d=b.get("AP");d instanceof ca&&(d=d.get("N"),d instanceof $a?this.appearance=d:d instanceof ca&&\n(b=b.get("AS"),b instanceof ka&&d.has(b.name)&&(b=d.get(b.name),b instanceof $a&&(this.appearance=b))))};c.setOptionalContent=function(b){this.oc=null;b=b.get("OC");b instanceof ka?T("setOptionalContent: Support for /Name-entry is not implemented."):b instanceof ca&&(this.oc=b)};c.loadResources=function(b,d){return d.dict.getAsync("Resources").then(function(e){if(e)return(new Ug(e,b,e.xref)).load().then(function(){return e})})};c.getOperatorList=function(){var b=Bb(function h(e,g,f){var k=this,l,\nm,n,p,q,r,t,v,w,y,x,z,A;return u.generator.createGenerator(h,function(B){switch(B.nextAddress){case 1:l=k.data;m=l.hasOwnCanvas;n=l.id;p=l.rect;q=k.appearance;if((r=!!(m&&f&2))&&(p[0]===p[2]||p[1]===p[3]))return k.data.hasOwnCanvas=!1,B.return({opList:new Dc,separateForm:!1,separateCanvas:!1});if(!q){if(!r)return B.return({opList:new Dc,separateForm:!1,separateCanvas:!1});q=new Qc("");q.dict=new ca}t=q.dict;return B.yield(k.loadResources("ExtGState ColorSpace Pattern Shading XObject Font".split(" "),\nq),2);case 2:v=B.yieldResult;w=fh(t.getArray("BBox"),[0,0,1,1]);y=Md(t.getArray("Matrix"),ld);x=bj(p,w,y);z=new Dc;if(!k.oc){B.jumpTo(3);break}return B.yield(e.parseMarkedContentProps(k.oc,null),4);case 4:A=B.yieldResult;case 3:return void 0!==A&&z.addOp(O.beginMarkedContentProps,["OC",A]),z.addOp(O.beginAnnotation,[n,p,x,y,r]),B.yield(e.getOperatorList({stream:q,task:g,resources:v,operatorList:z,fallbackFontDict:k._fallbackFontDict}),5);case 5:return z.addOp(O.endAnnotation,[]),void 0!==A&&z.addOp(O.endMarkedContent,\n[]),k.reset(),B.return({opList:z,separateForm:!1,separateCanvas:r})}})});return function(e,g,f,h){return b.apply(this,arguments)}}();c.save=function(){var b=Bb(function e(){return u.generator.createGenerator(e,function(g){return g.return(null)})});return function(e,g,f){return b.apply(this,arguments)}}();c.extractTextContent=function(){var b=Bb(function h(e,g,f){var k=this,l,m,n,p,q,r,t,v;return u.generator.createGenerator(h,function(w){if(1==w.nextAddress)return k.appearance?w.yield(k.loadResources(["ExtGState",\n"Font","Properties","XObject"],k.appearance),2):w.return();if(3!=w.nextAddress)return l=w.yieldResult,m=[],n=[],p=null,q={desiredSize:Math.Infinity,ready:!0,enqueue:function(y){y=u.makeIterator(y.items);for(var x=y.next();!x.done;x=y.next())x=x.value,void 0!==x.str&&(p||(p=x.transform.slice(-2)),n.push(x.str),x.hasEOL&&(m.push(n.join("").trimEnd()),n.length=0))}},w.yield(e.getTextContent({stream:k.appearance,task:g,resources:l,includeMarkedContent:!0,keepWhiteSpace:!0,sink:q,viewBox:f}),3);k.reset();\nn.length&&m.push(n.join("").trimEnd());if(1<m.length||m[0])r=k.appearance.dict,t=fh(r.getArray("BBox"),null),v=Md(r.getArray("Matrix"),null),k.data.textPosition=k._transformPoint(p,t,v),k.data.textContent=m;w.jumpToEnd()})});return function(e,g,f){return b.apply(this,arguments)}}();c._transformPoint=function(b,d,e){var g=this.data.rect;d||(d=[0,0,1,1]);e||(e=[1,0,0,1,0,0]);d=bj(g,d,e);d[4]-=g[0];d[5]-=g[1];b=Rb.applyTransform(b,d);return Rb.applyTransform(b,e)};c.getFieldObject=function(){return this.data.kidIds?\n{id:this.data.id,actions:this.data.actions,name:this.data.fieldName,strokeColor:this.data.borderColor,fillColor:this.data.backgroundColor,type:"",kidIds:this.data.kidIds,page:this.data.pageIndex,rotation:this.rotation}:null};c.reset=function(){for(var b=u.makeIterator(this._streams),d=b.next();!d.done;d=b.next())d.value.reset()};c._constructFieldName=function(b){if(!b.has("T")&&!b.has("Parent"))return T("Unknown field name, falling back to empty field name."),"";if(!b.has("Parent"))return ib(b.get("T"));\nvar d=[];b.has("T")&&d.unshift(ib(b.get("T")));var e=b,g=new Zb;for(b.objId&&g.put(b.objId);e.has("Parent");){e=e.get("Parent");if(!(e instanceof ca)||e.objId&&g.has(e.objId))break;e.objId&&g.put(e.objId);e.has("T")&&d.unshift(ib(e.get("T")))}return d.join(".")};return Gg(a,[{key:"viewable",get:function(){return null===this.data.quadPoints?!1:0===this.flags?!0:this._isViewable(this.flags)}},{key:"printable",get:function(){return null===this.data.quadPoints||0===this.flags?!1:this._isPrintable(this.flags)}},\n{key:"hasTextContent",get:function(){return!1}}])}(),Ez=function(){function a(){this.style=this.rawWidth=this.width=1;this.dashArray=[3];this.verticalCornerRadius=this.horizontalCornerRadius=0}var c=a.prototype;c.setWidth=function(b,d){void 0===d&&(d=[0,0,0,0]);if(b instanceof ka)this.width=0;else if("number"===typeof b){if(0<b){this.rawWidth=b;var e=(d[2]-d[0])/2;d=(d[3]-d[1])/2;0<e&&0<d&&(b>e||b>d)&&(T("AnnotationBorderStyle.setWidth - ignoring width: "+b),b=1)}this.width=b}};c.setStyle=function(b){if(b instanceof\nka)switch(b.name){case "S":this.style=1;break;case "D":this.style=2;break;case "B":this.style=3;break;case "I":this.style=4;break;case "U":this.style=5}};c.setDashArray=function(b,d){void 0===d&&(d=!1);if(Array.isArray(b)){for(var e=!0,g=!0,f=u.makeIterator(b),h=f.next();!h.done;h=f.next())if(h=h.value,0<=+h)0<h&&(g=!1);else{e=!1;break}0===b.length||e&&!g?(this.dashArray=b,d&&this.setStyle(ka.get("D"))):this.width=0}else b&&(this.width=0)};c.setHorizontalCornerRadius=function(b){Number.isInteger(b)&&\n(this.horizontalCornerRadius=b)};c.setVerticalCornerRadius=function(b){Number.isInteger(b)&&(this.verticalCornerRadius=b)};return a}(),Kc=function(a){function c(d){var e=a.call(this,d)||this;d=d.dict;if(d.has("IRT")){var g=d.getRaw("IRT");e.data.inReplyTo=g instanceof Ha?g.toString():null;g=d.get("RT");e.data.replyType=g instanceof ka?g.name:"R"}if("Group"===e.data.replyType){var f=d.get("IRT");e.setTitle(f.get("T"));e.data.titleObj=e._title;e.setContents(f.get("Contents"));e.data.contentsObj=e._contents;\nf.has("CreationDate")?(e.setCreationDate(f.get("CreationDate")),e.data.creationDate=e.creationDate):e.data.creationDate=null;f.has("M")?(e.setModificationDate(f.get("M")),e.data.modificationDate=e.modificationDate):e.data.modificationDate=null;g=f.getRaw("Popup");f.has("C")?(e.setColor(f.getArray("C")),e.data.color=e.color):e.data.color=null}else e.data.titleObj=e._title,e.setCreationDate(d.get("CreationDate")),e.data.creationDate=e.creationDate,g=d.getRaw("Popup"),d.has("C")||(e.data.color=null);\ne.data.popupRef=g instanceof Ha?g.toString():null;d.has("RC")&&(e.data.richText=Zj.getRichTextAsHtml(d.get("RC")));return e}Jb(c,a);var b=c.prototype;b.setCreationDate=function(d){this.creationDate="string"===typeof d?d:null};b._setDefaultAppearance=function(d){var e=d.xref,g=d.extra,f=d.strokeColor,h=d.fillColor,k=d.blendMode,l=d.strokeAlpha,m=d.fillAlpha,n=d.pointsCallback,p=d=Number.MAX_VALUE,q=Number.MIN_VALUE,r=Number.MIN_VALUE,t=["q"];g&&t.push(g);f&&t.push(f[0]+" "+f[1]+" "+f[2]+" RG");h&&\nt.push(h[0]+" "+h[1]+" "+h[2]+" rg");(g=this.data.quadPoints)||(g=Float32Array.from([this.rectangle[0],this.rectangle[3],this.rectangle[2],this.rectangle[3],this.rectangle[0],this.rectangle[1],this.rectangle[2],this.rectangle[1]]));f=0;for(h=g.length;f<h;f+=8){var v=u.makeIterator(n(t,g.subarray(f,f+8))),w=v.next().value,y=v.next().value,x=v.next().value;v=v.next().value;d=Math.min(d,w);q=Math.max(q,y);p=Math.min(p,x);r=Math.max(r,v)}t.push("Q");n=new ca(e);g=new ca(e);g.set("Subtype",ka.get("Form"));\nt=new Qc(t.join(" "));t.dict=g;n.set("Fm0",t);g=new ca(e);k&&g.set("BM",ka.get(k));"number"===typeof l&&g.set("CA",l);"number"===typeof m&&g.set("ca",m);k=new ca(e);k.set("GS0",g);l=new ca(e);l.set("ExtGState",k);l.set("XObject",n);e=new ca(e);e.set("Resources",l);d=this.data.rect=[d,p,q,r];e.set("BBox",d);this.appearance=new Qc("/GS0 gs /Fm0 Do");this.appearance.dict=e;this._streams.push(this.appearance,t)};c.createNewAnnotation=function(){var d=Bb(function l(g,f,h,k){var m,n=this,p,q,r,t;return u.generator.createGenerator(l,\nfunction(v){switch(v.nextAddress){case 1:return f.ref||(f.ref=g.getNewTemporaryRef()),m=f.ref,v.yield(n.createNewAppearanceStream(f,g,k),2);case 2:p=v.yieldResult;q=[];if(!p){r=n.createNewDict(f,g,{});v.jumpTo(3);break}t=g.getNewTemporaryRef();r=n.createNewDict(f,g,{apRef:t});return v.yield(pc(t,p,q,g),4);case 4:h.push({ref:t,data:q.join("")});case 3:return Number.isInteger(f.parentTreeId)&&r.set("StructParent",f.parentTreeId),q.length=0,v.yield(pc(m,r,q,g),5);case 5:return v.return({ref:m,data:q.join("")})}})});\nreturn function(g,f,h,k){return d.apply(this,arguments)}}();c.createNewPrintAnnotation=function(){var d=Bb(function l(g,f,h,k){var m=this,n,p,q;return u.generator.createGenerator(l,function(r){if(1==r.nextAddress)return r.yield(m.createNewAppearanceStream(h,f,k),2);n=r.yieldResult;p=m.createNewDict(h,f,n?{ap:n}:{});q=new m.prototype.constructor({dict:p,xref:f,annotationGlobals:g,evaluatorOptions:k.evaluatorOptions});h.ref&&(q.ref=q.refToReplace=h.ref);return r.return(q)})});return function(g,f,h,\nk){return d.apply(this,arguments)}}();return c}(Vf),be=function(a){function c(d){var e;var g=a.call(this,d)||this;var f=d.dict,h=d.xref,k=d.annotationGlobals,l=g.data;g._needAppearances=d.needAppearances;l.annotationType=20;void 0===l.fieldName&&(l.fieldName=g._constructFieldName(f));void 0===l.actions&&(l.actions=ag(h,f,sn));var m=Yc({dict:f,key:"V",getArray:!0});l.fieldValue=g._decodeFormValue(m);var n=Yc({dict:f,key:"DV",getArray:!0});l.defaultFieldValue=g._decodeFormValue(n);void 0===m&&k.xfaDatasets&&\n(n=g._title.str)&&(g._hasValueFromXFA=!0,l.fieldValue=m=k.xfaDatasets.getValue(n));void 0===m&&null!==l.defaultFieldValue&&(l.fieldValue=l.defaultFieldValue);l.alternativeText=ib(f.get("TU")||"");g.setDefaultAppearance(d);l.hasAppearance||(l.hasAppearance=g._needAppearances&&void 0!==l.fieldValue&&null!==l.fieldValue);d=Yc({dict:f,key:"FT"});l.fieldType=d instanceof ka?d.name:null;d=Yc({dict:f,key:"DR"});k=k.acroForm.get("DR");m=null==(e=g.appearance)?void 0:e.dict.get("Resources");g._fieldResources=\n{localResources:d,acroFormResources:k,appearanceResources:m,mergedResources:ca.merge({xref:h,dictArray:[d,m,k],mergeSubDicts:!0})};l.fieldFlags=Yc({dict:f,key:"Ff"});if(!Number.isInteger(l.fieldFlags)||0>l.fieldFlags)l.fieldFlags=0;l.readOnly=g.hasFieldFlag(1);l.required=g.hasFieldFlag(2);l.hidden=g._hasFlag(l.annotationFlags,2)||g._hasFlag(l.annotationFlags,32);return g}Jb(c,a);var b=c.prototype;b._decodeFormValue=function(d){return Array.isArray(d)?d.filter(function(e){return"string"===typeof e}).map(function(e){return ib(e)}):\nd instanceof ka?ib(d.name):"string"===typeof d?ib(d):null};b.hasFieldFlag=function(d){return!!(this.data.fieldFlags&d)};b._isViewable=function(){return!0};b.mustBeViewed=function(d,e){return e?this.viewable:a.prototype.mustBeViewed.call(this,d,e)&&!this._hasFlag(this.flags,32)};b.getRotationMatrix=function(d){var e;d=null==d||null==(e=d.get(this.data.id))?void 0:e.rotation;void 0===d&&(d=this.rotation);return 0===d?ld:bg(d,this.data.rect[2]-this.data.rect[0],this.data.rect[3]-this.data.rect[1])};\nb.getBorderAndBackgroundAppearances=function(d){var e;d=null==d||null==(e=d.get(this.data.id))?void 0:e.rotation;void 0===d&&(d=this.rotation);if(!this.backgroundColor&&!this.borderColor)return"";e=this.data.rect[2]-this.data.rect[0];var g=this.data.rect[3]-this.data.rect[1];d=0===d||180===d?"0 0 "+e+" "+g+" re":"0 0 "+g+" "+e+" re";e="";this.backgroundColor&&(e=Ed(this.backgroundColor,!0)+" "+d+" f ");this.borderColor&&(e+=(this.borderStyle.width||1)+" w "+Ed(this.borderColor,!1)+" "+d+" S ");return e};\nb.getOperatorList=function(){var d=Bb(function l(g,f,h,k){var m=this,n,p,q,r,t,v,w,y;return u.generator.createGenerator(l,function(x){switch(x.nextAddress){case 1:return!(h&16)||m instanceof To||m.data.noHTML||m.data.hasOwnCanvas?m._hasText?x.yield(m._getAppearance(g,f,h,k),2):x.return(a.prototype.getOperatorList.call(m,g,f,h,k)):x.return({opList:new Dc,separateForm:!0,separateCanvas:!1});case 2:n=x.yieldResult;if(m.appearance&&null===n)return x.return(a.prototype.getOperatorList.call(m,g,f,h,k));\np=new Dc;if(!m._defaultAppearance||null===n)return x.return({opList:p,separateForm:!1,separateCanvas:!1});q=!!(m.data.hasOwnCanvas&&h&2);r=[1,0,0,1,0,0];t=[0,0,m.data.rect[2]-m.data.rect[0],m.data.rect[3]-m.data.rect[1]];v=bj(m.data.rect,t,r);if(!m.oc){x.jumpTo(3);break}return x.yield(g.parseMarkedContentProps(m.oc,null),4);case 4:w=x.yieldResult;case 3:return void 0!==w&&p.addOp(O.beginMarkedContentProps,["OC",w]),p.addOp(O.beginAnnotation,[m.data.id,m.data.rect,v,m.getRotationMatrix(k),q]),y=new Qc(n),\nx.yield(g.getOperatorList({stream:y,task:f,resources:m._fieldResources.mergedResources,operatorList:p}),5);case 5:return p.addOp(O.endAnnotation,[]),void 0!==w&&p.addOp(O.endMarkedContent,[]),x.return({opList:p,separateForm:!1,separateCanvas:q})}})});return function(g,f,h,k){return d.apply(this,arguments)}}();b._getMKDict=function(d){var e=new ca(null);d&&e.set("R",d);this.borderColor&&e.set("BC",Ic(this.borderColor));this.backgroundColor&&e.set("BG",Ic(this.backgroundColor));return 0<e.size?e:null};\nb.amendSavedDict=function(){};b.save=function(){var d=Bb(function k(g,f,h){var l,m=this,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta;return u.generator.createGenerator(k,function(qa){switch(qa.nextAddress){case 1:n=null==h?void 0:h.get(m.data.id);p=m._buildFlags(null==n?void 0:n.noView,null==n?void 0:n.noPrint);q=null==n?void 0:n.value;r=null==n?void 0:n.rotation;if(q===m.data.fieldValue||void 0===q){if(!m._hasValueFromXFA&&void 0===r&&void 0===p)return qa.return(null);q||(q=m.data.fieldValue)}if(void 0===\nr&&!m._hasValueFromXFA&&Array.isArray(q)&&Array.isArray(m.data.fieldValue)&&ee(q,m.data.fieldValue)&&void 0===p)return qa.return(null);void 0===r&&(r=m.rotation);t=null;if(m._needAppearances){qa.jumpTo(2);break}return qa.yield(m._getAppearance(g,f,8,h),3);case 3:if(t=qa.yieldResult,null===t&&void 0===p)return qa.return(null);case 2:v=!1;null!=(l=t)&&l.needAppearances&&(v=!0,t=null);w=g;y=w.xref;x=y.fetchIfRef(m.ref);if(!(x instanceof ca))return qa.return(null);z=new ca(y);A=u.makeIterator(x.getKeys());\nfor(B=A.next();!B.done;B=A.next())C=B.value,"AP"!==C&&z.set(C,x.getRaw(C));void 0!==p&&(z.set("F",p),null!==t||v||(D=x.getRaw("AP"))&&z.set("AP",D));E={path:m.data.fieldName,value:q};z.set("V",Array.isArray(q)?q.map(hd):hd(q));m.amendSavedDict(h,z);(G=m._getMKDict(r))&&z.set("MK",G);J=[];F=[{ref:m.ref,data:"",xfa:E,needAppearances:v}];if(null===t){qa.jumpTo(4);break}L=y.getNewTemporaryRef();M=new ca(y);z.set("AP",M);M.set("N",L);W=m._getSaveFieldResources(y);Q=new Qc(t);la=Q.dict=new ca(y);la.set("Subtype",\nka.get("Form"));la.set("Resources",W);la.set("BBox",[0,0,m.data.rect[2]-m.data.rect[0],m.data.rect[3]-m.data.rect[1]]);ta=m.getRotationMatrix(h);ta!==ld&&la.set("Matrix",ta);return qa.yield(pc(L,Q,J,y),5);case 5:F.push({ref:L,data:J.join(""),xfa:null,needAppearances:!1}),J.length=0;case 4:return z.set("M","D:"+rd()),qa.yield(pc(m.ref,z,J,y),6);case 6:return F[0].data=J.join(""),qa.return(F)}})});return function(g,f,h){return d.apply(this,arguments)}}();b._getAppearance=function(){var d=Bb(function l(g,\nf,h,k){var m=this,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R,Y,fa,H,U,N,ba,aa,X,ha,ma,V,ea,za,Ia;return u.generator.createGenerator(l,function(wa){switch(wa.nextAddress){case 1:if(n=m.hasFieldFlag(8192))return wa.return(null);if(p=null==k?void 0:k.get(m.data.id))q=p.formattedValue||p.value,r=p.rotation;if(void 0===r&&void 0===q&&!m._needAppearances&&(!m._hasValueFromXFA||m.appearance))return wa.return(null);t=m.getBorderAndBackgroundAppearances(k);if(void 0===q&&(q=m.data.fieldValue,\n!q))return wa.return("/Tx BMC q "+t+"Q EMC");Array.isArray(q)&&1===q.length&&(q=q[0]);xc("string"===typeof q,"Expected `value` to be a string.");q=q.trimEnd();m.data.combo&&(v=m.data.options.find(function(Aa){return q===Aa.exportValue}),q=(null==v?void 0:v.displayValue)||q);if(""===q)return wa.return("/Tx BMC q "+t+"Q EMC");void 0===r&&(r=m.rotation);w=-1;m.data.multiLine?(y=q.split(/\\r\\n?|\\n/).map(function(Aa){return Aa.normalize("NFC")}),w=y.length):y=[q.replace(/\\r\\n?|\\n/,"").normalize("NFC")];\nx=1;z=2;A=m.data.rect[3]-m.data.rect[1];B=m.data.rect[2]-m.data.rect[0];if(90===r||270===r)C=u.makeIterator([A,B]),B=C.next().value,A=C.next().value;m._defaultAppearance||(m.data.defaultAppearanceData=(new xj(m._defaultAppearance="/Helvetica 0 Tf 0 g")).parse());return wa.yield(c._getFontData(g,f,m.data.defaultAppearanceData,m._fieldResources.mergedResources),2);case 2:D=wa.yieldResult;F=[];L=!1;M=u.makeIterator(y);for(W=M.next();!W.done;W=M.next())Q=W.value,la=D.encodeString(Q),1<la.length&&(L=!0),\nF.push(la.join(""));if(L&&h&8)return wa.return({needAppearances:!0});if(!L||!m._isOffscreenCanvasSupported){m._isOffscreenCanvasSupported||T("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly.");ta=u.makeIterator(m._computeFontSize(A-2*x,B-2*z,q,D,w));E=ta.next().value;G=ta.next().value;J=ta.next().value;wa.jumpTo(3);break}qa=m.data.comb?"monospace":"sans-serif";va=new yj(g.xref,qa);S=va.createFontResources(y.join(""));da=S.getRaw("Font");if(m._fieldResources.mergedResources.has("Font"))for(R=\nm._fieldResources.mergedResources.get("Font"),Y=u.makeIterator(da.getKeys()),fa=Y.next();!fa.done;fa=Y.next())H=fa.value,R.set(H,da.getRaw(H));else m._fieldResources.mergedResources.set("Font",da);U=va.fontName.name;return wa.yield(c._getFontData(g,f,{fontName:U,fontSize:0},S),4);case 4:D=wa.yieldResult;N=0;for(ba=F.length;N<ba;N++)F[N]=qk(y[N]);aa=Object.assign(Object.create(null),m.data.defaultAppearanceData);m.data.defaultAppearanceData.fontSize=0;m.data.defaultAppearanceData.fontName=U;X=u.makeIterator(m._computeFontSize(A-\n2*x,B-2*z,q,D,w));E=X.next().value;G=X.next().value;J=X.next().value;m.data.defaultAppearanceData=aa;case 3:ha=D.descent;ha=isNaN(ha)?qn*J:Math.max(qn*J,Math.abs(ha)*G);ma=Math.min(Math.floor((A-G)/2),x);V=m.data.textAlignment;if(m.data.multiLine)return wa.return(m._getMultilineAppearance(E,F,D,G,B,A,V,z,ma,ha,J,k));if(m.data.comb)return wa.return(m._getCombAppearance(E,D,F[0],G,B,A,z,ma,ha,J,k));ea=ma+ha;if(0===V||2<V)return wa.return("/Tx BMC q "+t+"BT "+E+(" 1 0 0 1 "+ob(z)+" "+ob(ea)+" Tm ("+\nCe(F[0])+") Tj ET Q EMC"));za={shift:0};Ia=m._renderText(F[0],D,G,B,V,za,z,ea);return wa.return("/Tx BMC q "+t+"BT "+E+(" 1 0 0 1 0 0 Tm "+Ia)+" ET Q EMC")}})});return function(g,f,h,k){return d.apply(this,arguments)}}();c._getFontData=function(){var d=Bb(function l(g,f,h,k){var m,n,p,q,r;return u.generator.createGenerator(l,function(t){return 1==t.nextAddress?(m=new Dc,n={font:null,clone:function(){return this}},p=h,q=p.fontName,r=p.fontSize,t.yield(g.handleSetFont(k,[q&&ka.get(q),r],null,m,f,n,\nnull),2)):t.return(n.font)})});return function(g,f,h,k){return d.apply(this,arguments)}}();b._getTextWidth=function(d,e){return e.charsToGlyphs(d).reduce(function(g,f){return g+f.width},0)/1E3};b._computeFontSize=function(d,e,g,f,h){var k=this.data.defaultAppearanceData.fontSize,l=Math.round(d/(1.35*(k||12)));if(!k){if(-1===h)l=this._getTextWidth(g,f),k=Math.floor(100*Math.min(d/1.35,e/l))/100,l=1;else{k=g.split(/\\r\\n?|\\n/);g=[];k=u.makeIterator(k);for(var m=k.next();!m.done;m=k.next()){m=f.encodeString(m.value).join("");\nvar n=f.charsToGlyphs(m),p=f.getCharPositions(m);g.push({line:m,glyphs:n,positions:p})}for(l=Math.max(l,h);;){k=d/l;k=Math.floor(k/1.35*100)/100;a:{h=k;m=0;n=u.makeIterator(g);for(p=n.next();!p.done;p=n.next())if(p=this._splitLine(null,f,h,e,p.value),m+=p.length*h,m>d){h=!0;break a}h=!1}if(h)l++;else break}}e=this.data.defaultAppearanceData;f=k;g=e.fontColor;this._defaultAppearance="/"+gh(e.fontName)+" "+f+" Tf "+Ed(g,!0)}return[this._defaultAppearance,k,d/l]};b._renderText=function(d,e,g,f,h,k,l,\nm){1===h?(l=this._getTextWidth(d,e)*g,f=(f-l)/2):2===h?(e=this._getTextWidth(d,e)*g,f=f-e-l):f=l;l=ob(f-k.shift);k.shift=f;m=ob(m);return l+" "+m+" Td ("+Ce(d)+") Tj"};b._getSaveFieldResources=function(d){var e,g=this._fieldResources,f=g.localResources,h=g.appearanceResources,k=g.acroFormResources;g=null==(e=this.data.defaultAppearanceData)?void 0:e.fontName;if(!g)return f||ca.empty;e=u.makeIterator([f,h]);for(h=e.next();!h.done;h=e.next())if(h=h.value,h instanceof ca){var l=h.get("Font");if(l instanceof\nca&&l.has(g))return h}return k instanceof ca&&(e=k.get("Font"),e instanceof ca&&e.has(g))?(k=new ca(d),k.set(g,e.getRaw(g)),g=new ca(d),g.set("Font",k),ca.merge({xref:d,dictArray:[g,f],mergeSubDicts:!0})):f||ca.empty};b.getFieldObject=function(){return null};return c}(Vf),tz=function(a){function c(d){var e=a.call(this,d)||this;d=d.dict;d.has("PMD")&&(e.flags|=2,e.data.hidden=!0,T("Barcodes are not supported"));e.data.hasOwnCanvas=e.data.readOnly&&!e.data.noHTML;e._hasText=!0;"string"!==typeof e.data.fieldValue&&\n(e.data.fieldValue="");var g=Yc({dict:d,key:"Q"});if(!Number.isInteger(g)||0>g||2<g)g=null;e.data.textAlignment=g;d=Yc({dict:d,key:"MaxLen"});if(!Number.isInteger(d)||0>d)d=0;e.data.maxLen=d;e.data.multiLine=e.hasFieldFlag(4096);e.data.comb=e.hasFieldFlag(16777216)&&!e.hasFieldFlag(4096)&&!e.hasFieldFlag(8192)&&!e.hasFieldFlag(1048576)&&0!==e.data.maxLen;e.data.doNotScroll=e.hasFieldFlag(8388608);return e}Jb(c,a);var b=c.prototype;b._getCombAppearance=function(d,e,g,f,h,k,l,m,n,p,q){f=h/this.data.maxLen;\nq=this.getBorderAndBackgroundAppearances(q);h=[];e=e.getCharPositions(g);e=u.makeIterator(e);for(k=e.next();!k.done;k=e.next())p=u.makeIterator(k.value),k=p.next().value,p=p.next().value,h.push("("+Ce(g.substring(k,p))+") Tj");g=h.join(" "+ob(f)+" 0 Td ");return"/Tx BMC q "+q+"BT "+d+(" 1 0 0 1 "+ob(l)+" "+ob(m+n)+" Tm "+g)+" ET Q EMC"};b._getMultilineAppearance=function(d,e,g,f,h,k,l,m,n,p,q,r){for(var t=[],v=h-2*m,w={shift:0},y=0,x=e.length;y<x;y++)for(var z=this._splitLine(e[y],g,f,v),A=0,B=z.length;A<\nB;A++)t.push(this._renderText(z[A],g,f,h,l,w,m,0===y&&0===A?-n-(q-p):-q));e=this.getBorderAndBackgroundAppearances(r);t=t.join("\\n");return"/Tx BMC q "+e+"BT "+d+(" 1 0 0 1 0 "+ob(k)+" Tm "+t)+" ET Q EMC"};b._splitLine=function(d,e,g,f,h){void 0===h&&(h={});d=h.line||d;var k=h.glyphs||e.charsToGlyphs(d);if(1>=k.length)return[d];e=h.positions||e.getCharPositions(d);g/=1E3;h=[];for(var l=-1,m=-1,n=-1,p=0,q=0,r=0,t=k.length;r<t;r++){var v=u.makeIterator(e[r]),w=v.next().value;v=v.next().value;var y=\nk[r],x=y.width*g;" "===y.unicode?q+x>f?(h.push(d.substring(p,w)),p=w,q=x,n=l=-1):(q+=x,l=w,m=v,n=r):q+x>f?-1!==l?(h.push(d.substring(p,m)),p=m,r=n+1,l=-1,q=0):(h.push(d.substring(p,w)),p=w,q=x):q+=x}p<d.length&&h.push(d.substring(p,d.length));return h};b.extractTextContent=function(){var d=Bb(function k(g,f,h){var l=this,m,n,p;return u.generator.createGenerator(k,function(q){if(1==q.nextAddress)return q.yield(a.prototype.extractTextContent.call(l,g,f,h),2);m=l.data.textContent;if(!m)return q.return();\nn=m.join("\\n");if(n===l.data.fieldValue)return q.return();p=n.replaceAll(/([.*+?^${}()|[\\]\\\\])|(\\s+)/g,function(r,t){return t?"\\\\"+t:"\\\\s+"});(new RegExp("^\\\\s*"+p+"\\\\s*$")).test(l.data.fieldValue)&&(l.data.textContent=l.data.fieldValue.split("\\n"));q.jumpToEnd()})});return function(g,f,h){return d.apply(this,arguments)}}();b.getFieldObject=function(){return{id:this.data.id,value:this.data.fieldValue,defaultValue:this.data.defaultFieldValue||"",multiline:this.data.multiLine,password:this.hasFieldFlag(8192),\ncharLimit:this.data.maxLen,comb:this.data.comb,editable:!this.data.readOnly,hidden:this.data.hidden,name:this.data.fieldName,rect:this.data.rect,actions:this.data.actions,page:this.data.pageIndex,strokeColor:this.data.borderColor,fillColor:this.data.backgroundColor,rotation:this.rotation,type:"text"}};return Gg(c,[{key:"hasTextContent",get:function(){return!!this.appearance&&!this._needAppearances}}])}(be),uz=function(a){function c(d){var e=a.call(this,d)||this;e.checkedAppearance=null;e.uncheckedAppearance=\nnull;e.data.checkBox=!e.hasFieldFlag(32768)&&!e.hasFieldFlag(65536);e.data.radioButton=e.hasFieldFlag(32768)&&!e.hasFieldFlag(65536);e.data.pushButton=e.hasFieldFlag(65536);e.data.isTooltipOnly=!1;e.data.checkBox?e._processCheckBox(d):e.data.radioButton?e._processRadioButton(d):e.data.pushButton?(e.data.hasOwnCanvas=!0,e.data.noHTML=!1,e._processPushButton(d)):T("Invalid field flags for button widget annotation");return e}Jb(c,a);var b=c.prototype;b.getOperatorList=function(){var d=Bb(function l(g,\nf,h,k){var m=this,n,p,q,r,t,v,w;return u.generator.createGenerator(l,function(y){if(m.data.pushButton)return y.return(a.prototype.getOperatorList.call(m,g,f,h,!1,k));p=n=null;k&&(n=(q=k.get(m.data.id))?q.value:null,p=q?q.rotation:null);if(null===n&&m.appearance)return y.return(a.prototype.getOperatorList.call(m,g,f,h,k));if(null===n||void 0===n)n=m.data.checkBox?m.data.fieldValue===m.data.exportValue:m.data.fieldValue===m.data.buttonValue;return(r=n?m.checkedAppearance:m.uncheckedAppearance)?(t=m.appearance,\nv=Md(r.dict.getArray("Matrix"),ld),p&&r.dict.set("Matrix",m.getRotationMatrix(k)),m.appearance=r,w=a.prototype.getOperatorList.call(m,g,f,h,k),m.appearance=t,r.dict.set("Matrix",v),y.return(w)):y.return({opList:new Dc,separateForm:!1,separateCanvas:!1})})});return function(g,f,h,k){return d.apply(this,arguments)}}();b.save=function(){var d=Bb(function k(g,f,h){var l=this;return u.generator.createGenerator(k,function(m){return l.data.checkBox?m.return(l._saveCheckbox(g,f,h)):l.data.radioButton?m.return(l._saveRadioButton(g,\nf,h)):m.return(null)})});return function(g,f,h){return d.apply(this,arguments)}}();b._saveCheckbox=function(){var d=Bb(function k(g,f,h){var l=this,m,n,p,q,r,t,v,w,y,x;return u.generator.createGenerator(k,function(z){if(1==z.nextAddress){if(!h)return z.return(null);m=h.get(l.data.id);n=l._buildFlags(null==m?void 0:m.noView,null==m?void 0:m.noPrint);p=null==m?void 0:m.rotation;q=null==m?void 0:m.value;if(void 0===p&&void 0===n){if(void 0===q)return z.return(null);r=l.data.fieldValue===l.data.exportValue;\nif(r===q)return z.return(null)}t=g.xref.fetchIfRef(l.ref);if(!(t instanceof ca))return z.return(null);t=t.clone();void 0===p&&(p=l.rotation);void 0===q&&(q=l.data.fieldValue===l.data.exportValue);v={path:l.data.fieldName,value:q?l.data.exportValue:""};w=ka.get(q?l.data.exportValue:"Off");t.set("V",w);t.set("AS",w);t.set("M","D:"+rd());void 0!==n&&t.set("F",n);(y=l._getMKDict(p))&&t.set("MK",y);x=[];return z.yield(pc(l.ref,t,x,g.xref),2)}return z.return([{ref:l.ref,data:x.join(""),xfa:v}])})});return function(g,\nf,h){return d.apply(this,arguments)}}();b._saveRadioButton=function(){var d=Bb(function k(g,f,h){var l=this,m,n,p,q,r,t,v,w,y,x,z,A,B;return u.generator.createGenerator(k,function(C){switch(C.nextAddress){case 1:if(!h)return C.return(null);m=h.get(l.data.id);n=l._buildFlags(null==m?void 0:m.noView,null==m?void 0:m.noPrint);p=null==m?void 0:m.rotation;q=null==m?void 0:m.value;if(void 0===p&&void 0===n){if(void 0===q)return C.return(null);r=l.data.fieldValue===l.data.buttonValue;if(r===q)return C.return(null)}t=\ng.xref.fetchIfRef(l.ref);if(!(t instanceof ca))return C.return(null);t=t.clone();void 0===q&&(q=l.data.fieldValue===l.data.buttonValue);void 0===p&&(p=l.rotation);v={path:l.data.fieldName,value:q?l.data.buttonValue:""};w=ka.get(q?l.data.buttonValue:"Off");y=[];x=null;if(!q){C.jumpTo(2);break}if(!(l.parent instanceof Ha)){l.parent instanceof ca&&l.parent.set("V",w);C.jumpTo(2);break}z=g.xref.fetch(l.parent);z.set("V",w);return C.yield(pc(l.parent,z,y,g.xref),4);case 4:x=y.join(""),y.length=0;case 2:return l.parent||\nt.set("V",w),t.set("AS",w),t.set("M","D:"+rd()),void 0!==n&&t.set("F",n),(A=l._getMKDict(p))&&t.set("MK",A),C.yield(pc(l.ref,t,y,g.xref),5);case 5:return B=[{ref:l.ref,data:y.join(""),xfa:v}],x&&B.push({ref:l.parent,data:x,xfa:null}),C.return(B)}})});return function(g,f,h){return d.apply(this,arguments)}}();b._getDefaultCheckedAppearance=function(d,e){var g=this.data.rect[2]-this.data.rect[0],f=this.data.rect[3]-this.data.rect[1],h=[0,0,g,f],k=.8*Math.min(g,f);if("check"===e){var l=.755*k;var m=.705*\nk;var n="3"}else"disc"===e?(l=.791*k,m=.705*k,n="l"):db("_getDefaultCheckedAppearance - unsupported type: "+e);e=ob((g-l)/2);m=ob((f-m)/2);k="q BT /PdfJsZaDb "+k+" Tf 0 g "+e+" "+m+" Td ("+n+") Tj ET Q";n=new ca(d.xref);n.set("FormType",1);n.set("Subtype",ka.get("Form"));n.set("Type",ka.get("XObject"));n.set("BBox",h);n.set("Matrix",[1,0,0,1,0,0]);n.set("Length",k.length);h=new ca(d.xref);d=new ca(d.xref);d.set("PdfJsZaDb",this.fallbackFontDict);h.set("Font",d);n.set("Resources",h);this.checkedAppearance=\nnew Qc(k);this.checkedAppearance.dict=n;this._streams.push(this.checkedAppearance)};b._processCheckBox=function(d){var e=d.dict.get("AP");if(e instanceof ca&&(e=e.get("N"),e instanceof ca)){var g=this._decodeFormValue(d.dict.get("AS"));"string"===typeof g&&(this.data.fieldValue=g);var f=null!==this.data.fieldValue&&"Off"!==this.data.fieldValue?this.data.fieldValue:"Yes";g=e.getKeys();0===g.length?g.push("Off",f):1===g.length?"Off"===g[0]?g.push(f):g.unshift("Off"):g.includes(f)?(g.length=0,g.push("Off",\nf)):(f=g.find(function(h){return"Off"!==h}),g.length=0,g.push("Off",f));g.includes(this.data.fieldValue)||(this.data.fieldValue="Off");this.data.exportValue=g[1];g=e.get(this.data.exportValue);this.checkedAppearance=g instanceof $a?g:null;e=e.get("Off");this.uncheckedAppearance=e instanceof $a?e:null;this.checkedAppearance?this._streams.push(this.checkedAppearance):this._getDefaultCheckedAppearance(d,"check");this.uncheckedAppearance&&this._streams.push(this.uncheckedAppearance);this._fallbackFontDict=\nthis.fallbackFontDict;null===this.data.defaultFieldValue&&(this.data.defaultFieldValue="Off")}};b._processRadioButton=function(d){this.data.buttonValue=null;var e=d.dict.get("Parent");e instanceof ca&&(this.parent=d.dict.getRaw("Parent"),e=e.get("V"),e instanceof ka&&(this.data.fieldValue=this._decodeFormValue(e)));e=d.dict.get("AP");if(e instanceof ca&&(e=e.get("N"),e instanceof ca)){for(var g=u.makeIterator(e.getKeys()),f=g.next();!f.done;f=g.next())if(f=f.value,"Off"!==f){this.data.buttonValue=\nthis._decodeFormValue(f);break}g=e.get(this.data.buttonValue);this.checkedAppearance=g instanceof $a?g:null;e=e.get("Off");this.uncheckedAppearance=e instanceof $a?e:null;this.checkedAppearance?this._streams.push(this.checkedAppearance):this._getDefaultCheckedAppearance(d,"disc");this.uncheckedAppearance&&this._streams.push(this.uncheckedAppearance);this._fallbackFontDict=this.fallbackFontDict;null===this.data.defaultFieldValue&&(this.data.defaultFieldValue="Off")}};b._processPushButton=function(d){var e=\nd.dict;d=d.annotationGlobals;e.has("A")||e.has("AA")||this.data.alternativeText?(this.data.isTooltipOnly=!e.has("A")&&!e.has("AA"),Cj.parseDestDictionary({destDict:e,resultObj:this.data,docBaseUrl:d.baseUrl,docAttachments:d.attachments})):T("Push buttons without action dictionaries are not supported")};b.getFieldObject=function(){var d="button";if(this.data.checkBox){d="checkbox";var e=this.data.exportValue}else this.data.radioButton&&(d="radiobutton",e=this.data.buttonValue);return{id:this.data.id,\nvalue:this.data.fieldValue||"Off",defaultValue:this.data.defaultFieldValue,exportValues:e,editable:!this.data.readOnly,name:this.data.fieldName,rect:this.data.rect,hidden:this.data.hidden,actions:this.data.actions,page:this.data.pageIndex,strokeColor:this.data.borderColor,fillColor:this.data.backgroundColor,rotation:this.rotation,type:d}};return Gg(c,[{key:"fallbackFontDict",get:function(){var d=new ca;d.set("BaseFont",ka.get("ZapfDingbats"));d.set("Type",ka.get("FallbackType"));d.set("Subtype",ka.get("FallbackType"));\nd.set("Encoding",ka.get("ZapfDingbatsEncoding"));return Fa(this,"fallbackFontDict",d)}}])}(be),vz=function(a){function c(d){var e=a.call(this,d)||this;var g=d.dict;d=d.xref;e.indices=g.getArray("I");e.hasIndices=Array.isArray(e.indices)&&0<e.indices.length;e.data.options=[];g=Yc({dict:g,key:"Opt"});if(Array.isArray(g))for(var f=0,h=g.length;f<h;f++){var k=d.fetchIfRef(g[f]),l=Array.isArray(k);e.data.options[f]={exportValue:e._decodeFormValue(l?d.fetchIfRef(k[0]):k),displayValue:e._decodeFormValue(l?\nd.fetchIfRef(k[1]):k)}}if(e.hasIndices)for(e.data.fieldValue=[],d=e.data.options.length,g=u.makeIterator(e.indices),f=g.next();!f.done;f=g.next())f=f.value,Number.isInteger(f)&&0<=f&&f<d&&e.data.fieldValue.push(e.data.options[f].exportValue);else"string"===typeof e.data.fieldValue?e.data.fieldValue=[e.data.fieldValue]:e.data.fieldValue||(e.data.fieldValue=[]);e.data.combo=e.hasFieldFlag(131072);e.data.multiSelect=e.hasFieldFlag(2097152);e._hasText=!0;return e}Jb(c,a);var b=c.prototype;b.getFieldObject=\nfunction(){return{id:this.data.id,value:0<this.data.fieldValue.length?this.data.fieldValue[0]:null,defaultValue:this.data.defaultFieldValue,editable:!this.data.readOnly,name:this.data.fieldName,rect:this.data.rect,numItems:this.data.fieldValue.length,multipleSelection:this.data.multiSelect,hidden:this.data.hidden,actions:this.data.actions,items:this.data.options,page:this.data.pageIndex,strokeColor:this.data.borderColor,fillColor:this.data.backgroundColor,rotation:this.rotation,type:this.data.combo?\n"combobox":"listbox"}};b.amendSavedDict=function(d,e){var g;if(this.hasIndices){d=null==d||null==(g=d.get(this.data.id))?void 0:g.value;Array.isArray(d)||(d=[d]);g=[];for(var f=this.data.options,h=0,k=0,l=f.length;h<l;h++)f[h].exportValue===d[k]&&(g.push(h),k+=1);e.set("I",g)}};b._getAppearance=function(){var d=Bb(function l(g,f,h,k){var m=this,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R,Y,fa,H,U,N,ba,aa,X,ha,ma,V,ea,za,Ia;return u.generator.createGenerator(l,function(wa){if(1==\nwa.nextAddress){if(m.data.combo)return wa.return(a.prototype._getAppearance.call(m,g,f,h,k));if(q=null==k?void 0:k.get(m.data.id))p=q.rotation,n=q.value;if(void 0===p&&void 0===n&&!m._needAppearances)return wa.return(null);void 0===n?n=m.data.fieldValue:Array.isArray(n)||(n=[n]);r=1;t=2;v=m.data.rect[3]-m.data.rect[1];w=m.data.rect[2]-m.data.rect[0];if(90===p||270===p)y=u.makeIterator([v,w]),w=y.next().value,v=y.next().value;x=m.data.options.length;z=[];for(A=0;A<x;A++)B=m.data.options[A],C=B.exportValue,\nn.includes(C)&&z.push(A);m._defaultAppearance||(m.data.defaultAppearanceData=(new xj(m._defaultAppearance="/Helvetica 0 Tf 0 g")).parse());return wa.yield(be._getFontData(g,f,m.data.defaultAppearanceData,m._fieldResources.mergedResources),2)}D=wa.yieldResult;G=m.data.defaultAppearanceData;if(J=G.fontSize)E=m._defaultAppearance;else{F=(v-r)/x;L=-1;W=u.makeIterator(m.data.options);for(Q=W.next();!Q.done;Q=W.next())ta=la=Q.value,qa=ta.displayValue,va=m._getTextWidth(qa,D),va>L&&(L=va,M=qa);S=u.makeIterator(m._computeFontSize(F,\nw-2*t,M,D,-1));E=S.next().value;J=S.next().value}da=1.35*J;R=(da-J)/2;Y=Math.floor(v/da);fa=0;0<z.length&&(H=Math.min.apply(Math,u.arrayFromIterable(z)),U=Math.max.apply(Math,u.arrayFromIterable(z)),fa=Math.max(0,U-Y+1),fa>H&&(fa=H));N=Math.min(fa+Y+1,x);ba=["/Tx BMC q","1 1 "+w+" "+v+" re W n"];if(z.length)for(ba.push("0.600006 0.756866 0.854904 rg"),aa=u.makeIterator(z),X=aa.next();!X.done;X=aa.next())ha=X.value,fa<=ha&&ha<N&&ba.push("1 "+(v-(ha-fa+1)*da)+" "+w+" "+da+" re f");ba.push("BT",E,"1 0 0 1 0 "+\nv+" Tm");ma={shift:0};for(V=fa;V<N;V++)ea=m.data.options[V],za=ea.displayValue,Ia=V===fa?R:0,ba.push(m._renderText(za,D,J,w,0,ma,t,-da+Ia));ba.push("ET Q EMC");return wa.return(ba.join("\\n"))})});return function(g,f,h,k){return d.apply(this,arguments)}}();return c}(be),To=function(a){function c(b){b=a.call(this,b)||this;b.data.fieldValue=null;b.data.hasOwnCanvas=b.data.noRotate;b.data.noHTML=!b.data.hasOwnCanvas;return b}Jb(c,a);c.prototype.getFieldObject=function(){return{id:this.data.id,value:null,\npage:this.data.pageIndex,type:"signature"}};return c}(be),sz=function(a){function c(b){var d=a.call(this,b)||this;d.data.noRotate=!0;d.data.hasOwnCanvas=d.data.noRotate;d.data.noHTML=!1;b=b.dict;d.data.annotationType=1;d.data.hasAppearance?d.data.name="NoIcon":(d.data.rect[1]=d.data.rect[3]-22,d.data.rect[2]=d.data.rect[0]+22,d.data.name=b.has("Name")?b.get("Name").name:"Note");b.has("State")?(d.data.state=b.get("State")||null,d.data.stateModel=b.get("StateModel")||null):(d.data.state=null,d.data.stateModel=\nnull);return d}Jb(c,a);return c}(Kc),rz=function(a){function c(b){var d;var e=a.call(this,b)||this;var g=b.dict;b=b.annotationGlobals;e.data.annotationType=2;e.data.noHTML=!1;var f=tf(g,e.rectangle);f&&(e.data.quadPoints=f);(d=e.data).borderColor||(d.borderColor=e.data.color);Cj.parseDestDictionary({destDict:g,resultObj:e.data,docBaseUrl:b.baseUrl,docAttachments:b.attachments});return e}Jb(c,a);return c}(Vf),Uo=function(a){function c(b){var d=a.call(this,b)||this;b=b.dict;d.data.annotationType=16;\nd.data.noHTML=!1;if(d.data.rect[0]===d.data.rect[2]||d.data.rect[1]===d.data.rect[3])d.data.rect=null;var e=b.get("Parent");if(!e)return T("Popup annotation has a missing or invalid parent annotation."),sf(d);d.data.parentRect=sd(e.getArray("Rect"),null);var g=e.get("RT");Lb(g,"Group")&&(e=e.get("IRT"));e.has("M")?(d.setModificationDate(e.get("M")),d.data.modificationDate=d.modificationDate):d.data.modificationDate=null;e.has("C")?(d.setColor(e.getArray("C")),d.data.color=d.color):d.data.color=null;\nd.viewable||(g=e.get("F"),d._isViewable(g)&&d.setFlags(g));d.setTitle(e.get("T"));d.data.titleObj=d._title;d.setContents(e.get("Contents"));d.data.contentsObj=d._contents;e.has("RC")&&(d.data.richText=Zj.getRichTextAsHtml(e.get("RC")));d.data.open=!!b.get("Open");return d}Jb(c,a);return c}(Vf),ak=function(a){function c(b){var d=a.call(this,b)||this;d.data.hasOwnCanvas=d.data.noRotate;d.data.isEditable=!d.data.noHTML;d.data.noHTML=!1;var e=b.evaluatorOptions,g=b.xref;d.data.annotationType=3;d.setDefaultAppearance(b);\nd._hasAppearance=!!d.appearance;if(d._hasAppearance)g=(new xt(d.appearance,e,g)).parse(),b=g.fontSize,d.data.defaultAppearanceData.fontColor=g.fontColor,d.data.defaultAppearanceData.fontSize=b||10;else{var f;(f=d.data.defaultAppearanceData).fontSize||(f.fontSize=10);f=d.data.defaultAppearanceData;e=f.fontColor;f=f.fontSize;if(d._contents.str){d.data.textContent=d._contents.str.split(/\\r\\n?|\\n/).map(function(k){return k.trimEnd()});var h=yj.getFirstPositionInfo(d.rectangle,d.rotation,f);d.data.textPosition=\nd._transformPoint(h.coords,h.bbox,h.matrix)}d._isOffscreenCanvasSupported?(b=b.dict.get("CA"),g=new yj(g,"sans-serif"),d.appearance=g.createAppearance(d._contents.str,d.rectangle,d.rotation,f,e,b),d._streams.push(d.appearance)):T("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.")}return d}Jb(c,a);c.createNewDict=function(b,d,e){var g=e.apRef;e=e.ap;var f=b.color,h=b.fontSize,k=b.oldAnnotation,l=b.rect,m=b.rotation,n=b.user,p=b.value;b=k||new ca(d);b.set("Type",\nka.get("Annot"));b.set("Subtype",ka.get("FreeText"));k?(b.set("M","D:"+rd()),b.delete("RC")):b.set("CreationDate","D:"+rd());b.set("Rect",l);f="/Helv "+h+" Tf "+Ed(f,!0);b.set("DA",f);b.set("Contents",hd(p));b.set("F",4);b.set("Border",[0,0,0]);b.set("Rotate",m);n&&b.set("T",hd(n));if(g||e)d=new ca(d),b.set("AP",d),g?d.set("N",g):d.set("N",e);return b};c.createNewAppearanceStream=function(){var b=Bb(function h(e,g,f){var k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R,Y,fa,H,\nU,N,ba,aa,X,ha,ma,V,ea,za,Ia,wa,Aa,Ja,Sa,Wa,La,vb;return u.generator.createGenerator(h,function(eb){if(1==eb.nextAddress)return k=f,l=k.baseFontRef,m=k.evaluator,n=k.task,p=e,q=p.color,r=p.fontSize,t=p.rect,v=p.rotation,w=p.value,y=new ca(g),x=new ca(g),l?x.set("Helv",l):(z=new ca(g),z.set("BaseFont",ka.get("Helvetica")),z.set("Type",ka.get("Font")),z.set("Subtype",ka.get("Type1")),z.set("Encoding",ka.get("WinAnsiEncoding")),x.set("Helv",z)),y.set("Font",x),eb.yield(be._getFontData(m,n,{fontName:"Helv",\nfontSize:r},y),2);A=eb.yieldResult;B=u.makeIterator(t);C=B.next().value;D=B.next().value;E=B.next().value;G=B.next().value;J=E-C;F=G-D;0!==v%180&&(L=u.makeIterator([F,J]),J=L.next().value,F=L.next().value);M=w.split("\\n");W=r/1E3;Q=-Infinity;la=[];ta=u.makeIterator(M);for(qa=ta.next();!qa.done;qa=ta.next()){va=qa.value;S=A.encodeString(va);if(1<S.length)return eb.return(null);va=S.join("");la.push(va);da=0;R=A.charsToGlyphs(va);Y=u.makeIterator(R);for(fa=Y.next();!fa.done;fa=Y.next())H=fa.value,da+=\nH.width*W;Q=Math.max(Q,da)}U=1;Q>J&&(U=J/Q);N=1;ba=1.35*r;aa=1*r;X=ba*M.length;X>F&&(N=F/X);ha=Math.min(U,N);ma=r*ha;switch(v){case 0:za=[1,0,0,1];ea=[t[0],t[1],J,F];V=[t[0],t[3]-aa];break;case 90:za=[0,1,-1,0];ea=[t[1],-t[2],J,F];V=[t[1],-t[0]-aa];break;case 180:za=[-1,0,0,-1];ea=[-t[2],-t[3],J,F];V=[-t[2],-t[1]-aa];break;case 270:za=[0,-1,1,0],ea=[-t[3],t[0],J,F],V=[-t[3],t[2]-aa]}Ia=["q",za.join(" ")+" 0 0 cm",ea.join(" ")+" re W n","BT",""+Ed(q,!0),"0 Tc /Helv "+ob(ma)+" Tf"];Ia.push(V.join(" ")+\n" Td ("+Ce(la[0])+") Tj");wa=ob(ba);Aa=1;for(Ja=la.length;Aa<Ja;Aa++)Sa=la[Aa],Ia.push("0 -"+wa+" Td ("+Ce(Sa)+") Tj");Ia.push("ET","Q");Wa=Ia.join("\\n");La=new ca(g);La.set("FormType",1);La.set("Subtype",ka.get("Form"));La.set("Type",ka.get("XObject"));La.set("BBox",t);La.set("Resources",y);La.set("Matrix",[1,0,0,1,-t[0],-t[1]]);vb=new Qc(Wa);vb.dict=La;return eb.return(vb)})});return function(e,g,f){return b.apply(this,arguments)}}();return Gg(c,[{key:"hasTextContent",get:function(){return this._hasAppearance}}])}(Kc),\nwz=function(a){function c(b){var d=a.call(this,b)||this;var e=b.dict;b=b.xref;d.data.annotationType=4;d.data.hasOwnCanvas=d.data.noRotate;d.data.noHTML=!1;var g=fh(e.getArray("L"),[0,0,0,0]);d.data.lineCoordinates=Rb.normalizeRect(g);d.setLineEndings(e.getArray("LE"));d.data.lineEndings=d.lineEndings;if(!d.appearance){var f=d.color?Ic(d.color):[0,0,0],h=e.get("CA"),k=(e=(e=Ne(e.getArray("IC"),null))?Ic(e):null)?h:null,l=d.borderStyle.width||1,m=2*l;m=[d.data.lineCoordinates[0]-m,d.data.lineCoordinates[1]-\nm,d.data.lineCoordinates[2]+m,d.data.lineCoordinates[3]+m];Rb.intersect(d.rectangle,m)||(d.rectangle=m);d._setDefaultAppearance({xref:b,extra:l+" w",strokeColor:f,fillColor:e,strokeAlpha:h,fillAlpha:k,pointsCallback:function(n,p){n.push(g[0]+" "+g[1]+" m",g[2]+" "+g[3]+" l","S");return[p[0]-l,p[2]+l,p[7]-l,p[3]+l]}})}return d}Jb(c,a);return c}(Kc),xz=function(a){function c(b){var d=a.call(this,b)||this;var e=b.dict;b=b.xref;d.data.annotationType=5;d.data.hasOwnCanvas=d.data.noRotate;d.data.noHTML=\n!1;if(!d.appearance){var g=d.color?Ic(d.color):[0,0,0],f=e.get("CA"),h=(e=Ne(e.getArray("IC"),null))?Ic(e):null;e=h?f:null;if(0===d.borderStyle.width&&!h)return sf(d);d._setDefaultAppearance({xref:b,extra:d.borderStyle.width+" w",strokeColor:g,fillColor:h,strokeAlpha:f,fillAlpha:e,pointsCallback:function(k,l){k.push(l[4]+d.borderStyle.width/2+" "+(l[5]+d.borderStyle.width/2)+" "+(l[6]-l[4]-d.borderStyle.width)+" "+(l[3]-l[7]-d.borderStyle.width)+" re");h?k.push("B"):k.push("S");return[l[0],l[2],l[7],\nl[3]]}})}return d}Jb(c,a);return c}(Kc),yz=function(a){function c(b){var d=a.call(this,b)||this;var e=b.dict;b=b.xref;d.data.annotationType=6;if(!d.appearance){var g=d.color?Ic(d.color):[0,0,0],f=e.get("CA"),h=(e=Ne(e.getArray("IC"),null))?Ic(e):null;e=h?f:null;if(0===d.borderStyle.width&&!h)return sf(d);var k=4/3*Math.tan(Math.PI/8);d._setDefaultAppearance({xref:b,extra:d.borderStyle.width+" w",strokeColor:g,fillColor:h,strokeAlpha:f,fillAlpha:e,pointsCallback:function(l,m){var n=m[0]+d.borderStyle.width/\n2,p=m[1]-d.borderStyle.width/2,q=m[6]-d.borderStyle.width/2,r=m[7]+d.borderStyle.width/2,t=n+(q-n)/2,v=p+(r-p)/2,w=(q-n)/2*k,y=(r-p)/2*k;l.push(t+" "+r+" m",t+w+" "+r+" "+q+" "+(v+y)+" "+q+" "+v+" c",q+" "+(v-y)+" "+(t+w)+" "+p+" "+t+" "+p+" c",t-w+" "+p+" "+n+" "+(v-y)+" "+n+" "+v+" c",n+" "+(v+y)+" "+(t-w)+" "+r+" "+t+" "+r+" c","h");h?l.push("B"):l.push("S");return[m[0],m[2],m[7],m[3]]}})}return d}Jb(c,a);return c}(Kc),Vo=function(a){function c(b){var d=a.call(this,b)||this;var e=b.dict;b=b.xref;\nd.data.annotationType=8;d.data.hasOwnCanvas=d.data.noRotate;d.data.noHTML=!1;d.data.vertices=null;d instanceof Wo||(d.setLineEndings(e.getArray("LE")),d.data.lineEndings=d.lineEndings);var g=e.getArray("Vertices");if(!yc(g,null))return sf(d);var f=d.data.vertices=Float32Array.from(g);if(!d.appearance){g=d.color?Ic(d.color):[0,0,0];e=e.get("CA");for(var h=d.borderStyle.width||1,k=2*h,l=[Infinity,Infinity,-Infinity,-Infinity],m=0,n=f.length;m<n;m+=2)l[0]=Math.min(l[0],f[m]-k),l[1]=Math.min(l[1],f[m+\n1]-k),l[2]=Math.max(l[2],f[m]+k),l[3]=Math.max(l[3],f[m+1]+k);Rb.intersect(d.rectangle,l)||(d.rectangle=l);d._setDefaultAppearance({xref:b,extra:h+" w",strokeColor:g,strokeAlpha:e,pointsCallback:function(p,q){for(var r=0,t=f.length;r<t;r+=2)p.push(f[r]+" "+f[r+1]+" "+(0===r?"m":"l"));p.push("S");return[q[0],q[2],q[7],q[3]]}})}return d}Jb(c,a);return c}(Kc),Wo=function(a){function c(b){b=a.call(this,b)||this;b.data.annotationType=7;return b}Jb(c,a);return c}(Vo),zz=function(a){function c(b){b=a.call(this,\nb)||this;b.data.annotationType=14;return b}Jb(c,a);return c}(Kc),Uf=function(a){function c(b){var d=a.call(this,b)||this;d.data.hasOwnCanvas=d.data.noRotate;d.data.noHTML=!1;var e=b.dict;b=b.xref;d.data.annotationType=15;d.data.inkLists=[];d.data.isEditable=!d.data.noHTML&&"InkHighlight"===d.data.it;d.data.noHTML=!1;d.data.opacity=e.get("CA")||1;var g=e.getArray("InkList");if(!Array.isArray(g))return sf(d);for(var f=0,h=g.length;f<h;++f)if(Array.isArray(g[f])){var k=new Float32Array(g[f].length);\nd.data.inkLists.push(k);for(var l=0,m=g[f].length;l<m;l+=2){var n=b.fetchIfRef(g[f][l]),p=b.fetchIfRef(g[f][l+1]);"number"===typeof n&&"number"===typeof p&&(k[l]=n,k[l+1]=p)}}if(!d.appearance){g=d.color?Ic(d.color):[0,0,0];e=e.get("CA");f=d.borderStyle.width||1;h=2*f;k=[Infinity,Infinity,-Infinity,-Infinity];l=u.makeIterator(d.data.inkLists);for(m=l.next();!m.done;m=l.next())for(m=m.value,n=0,p=m.length;n<p;n+=2)k[0]=Math.min(k[0],m[n]-h),k[1]=Math.min(k[1],m[n+1]-h),k[2]=Math.max(k[2],m[n]+h),k[3]=\nMath.max(k[3],m[n+1]+h);Rb.intersect(d.rectangle,k)||(d.rectangle=k);d._setDefaultAppearance({xref:b,extra:f+" w",strokeColor:g,strokeAlpha:e,pointsCallback:function(q,r){for(var t=u.makeIterator(d.data.inkLists),v=t.next();!v.done;v=t.next()){v=v.value;for(var w=0,y=v.length;w<y;w+=2)q.push(v[w]+" "+v[w+1]+" "+(0===w?"m":"l"));q.push("S")}return[r[0],r[2],r[7],r[3]]}})}return d}Jb(c,a);c.createNewDict=function(b,d,e){var g=e.apRef;e=e.ap;var f=b.color,h=b.opacity,k=b.paths,l=b.outlines,m=b.rect,\nn=b.rotation,p=b.thickness;b=new ca(d);b.set("Type",ka.get("Annot"));b.set("Subtype",ka.get("Ink"));b.set("CreationDate","D:"+rd());b.set("Rect",m);b.set("InkList",(null==l?void 0:l.points)||k.map(function(q){return q.points}));b.set("F",4);b.set("Rotate",n);l&&b.set("IT",ka.get("InkHighlight"));k=new ca(d);b.set("BS",k);k.set("W",p);b.set("C",Array.from(f,function(q){return q/255}));b.set("CA",h);d=new ca(d);b.set("AP",d);g?d.set("N",g):d.set("N",e);return b};c.createNewAppearanceStream=function(){var b=\nBb(function h(e,g,f){var k=this,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M;return u.generator.createGenerator(h,function(W){if(e.outlines)return W.return(k.createNewAppearanceStreamForHighlight(e,g,f));l=e;m=l.color;n=l.rect;p=l.paths;q=l.thickness;r=l.opacity;t=[q+" w 1 J 1 j",""+Ed(m,!1)];1!==r&&t.push("/R0 gs");v=[];w=u.makeIterator(p);for(y=w.next();!y.done;y=w.next()){z=x=y.value;A=z.bezier;v.length=0;v.push(ob(A[0])+" "+ob(A[1])+" m");if(2===A.length)v.push(ob(A[0])+" "+ob(A[1])+" l S");else{B=\n2;for(C=A.length;B<C;B+=6)D=A.slice(B,B+6).map(ob).join(" "),v.push(D+" c");v.push("S")}t.push(v.join("\\n"))}E=t.join("\\n");G=new ca(g);G.set("FormType",1);G.set("Subtype",ka.get("Form"));G.set("Type",ka.get("XObject"));G.set("BBox",n);G.set("Length",E.length);1!==r&&(J=new ca(g),F=new ca(g),L=new ca(g),L.set("CA",r),L.set("Type",ka.get("ExtGState")),F.set("R0",L),J.set("ExtGState",F),G.set("Resources",J));M=new Qc(E);M.dict=G;return W.return(M)})});return function(e,g,f){return b.apply(this,arguments)}}();\nc.createNewAppearanceStreamForHighlight=function(){var b=Bb(function f(e,g){var h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B;return u.generator.createGenerator(f,function(C){h=e;k=h.color;l=h.rect;m=h.outlines;n=m.outline;p=h.opacity;q=[""+Ed(k,!0),"/R0 gs"];q.push(ob(n[4])+" "+ob(n[5])+" m");r=6;for(t=n.length;r<t;r+=6)isNaN(n[r])||null===n[r]?q.push(ob(n[r+4])+" "+ob(n[r+5])+" l"):(v=n.slice(r,r+6).map(ob).join(" "),q.push(v+" c"));q.push("h f");w=q.join("\\n");y=new ca(g);y.set("FormType",1);y.set("Subtype",\nka.get("Form"));y.set("Type",ka.get("XObject"));y.set("BBox",l);y.set("Length",w.length);x=new ca(g);z=new ca(g);x.set("ExtGState",z);y.set("Resources",x);A=new ca(g);z.set("R0",A);A.set("BM",ka.get("Multiply"));1!==p&&(A.set("ca",p),A.set("Type",ka.get("ExtGState")));B=new Qc(w);B.dict=y;return C.return(B)})});return function(e,g,f){return b.apply(this,arguments)}}();return c}(Kc),bk=function(a){function c(b){var d=a.call(this,b)||this;var e=b.dict;b=b.xref;d.data.annotationType=9;d.data.isEditable=\n!d.data.noHTML;d.data.noHTML=!1;d.data.opacity=e.get("CA")||1;if(d.data.quadPoints=tf(e,null)){var g,f=null==(g=d.appearance)?void 0:g.dict.get("Resources");d.appearance&&null!=f&&f.has("ExtGState")||(d.appearance&&T("HighlightAnnotation - ignoring built-in appearance stream."),g=d.color?Ic(d.color):[1,1,0],e=e.get("CA"),d._setDefaultAppearance({xref:b,fillColor:g,blendMode:"Multiply",fillAlpha:e,pointsCallback:function(h,k){h.push(k[0]+" "+k[1]+" m",k[2]+" "+k[3]+" l",k[6]+" "+k[7]+" l",k[4]+" "+\nk[5]+" l","f");return[k[0],k[2],k[7],k[3]]}}))}else d.data.popupRef=null;return d}Jb(c,a);c.createNewDict=function(b,d,e){var g=e.apRef;e=e.ap;var f=b.color,h=b.oldAnnotation,k=b.opacity,l=b.rect,m=b.rotation,n=b.user,p=b.quadPoints;b=h||new ca(d);b.set("Type",ka.get("Annot"));b.set("Subtype",ka.get("Highlight"));b.set(h?"M":"CreationDate","D:"+rd());b.set("CreationDate","D:"+rd());b.set("Rect",l);b.set("F",4);b.set("Border",[0,0,0]);b.set("Rotate",m);b.set("QuadPoints",p);b.set("C",Array.from(f,\nfunction(q){return q/255}));b.set("CA",k);n&&b.set("T",hd(n));if(g||e)d=new ca(d),b.set("AP",d),d.set("N",g||e);return b};c.createNewAppearanceStream=function(){var b=Bb(function f(e,g){var h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D;return u.generator.createGenerator(f,function(E){h=e;k=h.color;l=h.rect;m=h.outlines;n=h.opacity;p=[""+Ed(k,!0),"/R0 gs"];q=[];r=u.makeIterator(m);for(t=r.next();!t.done;t=r.next()){v=t.value;q.length=0;q.push(ob(v[0])+" "+ob(v[1])+" m");w=2;for(y=v.length;w<y;w+=2)q.push(ob(v[w])+\n" "+ob(v[w+1])+" l");q.push("h");p.push(q.join("\\n"))}p.push("f*");x=p.join("\\n");z=new ca(g);z.set("FormType",1);z.set("Subtype",ka.get("Form"));z.set("Type",ka.get("XObject"));z.set("BBox",l);z.set("Length",x.length);A=new ca(g);B=new ca(g);A.set("ExtGState",B);z.set("Resources",A);C=new ca(g);B.set("R0",C);C.set("BM",ka.get("Multiply"));1!==n&&(C.set("ca",n),C.set("Type",ka.get("ExtGState")));D=new Qc(x);D.dict=z;return E.return(D)})});return function(e,g,f){return b.apply(this,arguments)}}();\nreturn c}(Kc),Az=function(a){function c(b){var d=a.call(this,b)||this;var e=b.dict;b=b.xref;d.data.annotationType=10;if(d.data.quadPoints=tf(e,null)){if(!d.appearance){var g=d.color?Ic(d.color):[0,0,0];e=e.get("CA");d._setDefaultAppearance({xref:b,extra:"[] 0 d 0.571 w",strokeColor:g,strokeAlpha:e,pointsCallback:function(f,h){f.push(h[4]+" "+(h[5]+1.3)+" m",h[6]+" "+(h[7]+1.3)+" l","S");return[h[0],h[2],h[7],h[3]]}})}}else d.data.popupRef=null;return d}Jb(c,a);return c}(Kc),Bz=function(a){function c(b){var d=\na.call(this,b)||this;var e=b.dict;b=b.xref;d.data.annotationType=11;if(d.data.quadPoints=tf(e,null)){if(!d.appearance){var g=d.color?Ic(d.color):[0,0,0];e=e.get("CA");d._setDefaultAppearance({xref:b,extra:"[] 0 d 1 w",strokeColor:g,strokeAlpha:e,pointsCallback:function(f,h){var k=(h[1]-h[5])/6,l=k,m=h[4],n=h[5],p=h[6];f.push(m+" "+(n+l)+" m");do m+=2,l=0===l?k:0,f.push(m+" "+(n+l)+" l");while(m<p);f.push("S");return[h[4],p,n-2*k,n+2*k]}})}}else d.data.popupRef=null;return d}Jb(c,a);return c}(Kc),\nCz=function(a){function c(b){var d=a.call(this,b)||this;var e=b.dict;b=b.xref;d.data.annotationType=12;if(d.data.quadPoints=tf(e,null)){if(!d.appearance){var g=d.color?Ic(d.color):[0,0,0];e=e.get("CA");d._setDefaultAppearance({xref:b,extra:"[] 0 d 1 w",strokeColor:g,strokeAlpha:e,pointsCallback:function(f,h){f.push((h[0]+h[4])/2+" "+((h[1]+h[5])/2+" m"),(h[2]+h[6])/2+" "+((h[3]+h[7])/2+" l"),"S");return[h[0],h[2],h[7],h[3]]}})}}else d.data.popupRef=null;return d}Jb(c,a);return c}(Kc),ah=function(a){function c(b){b=\na.call(this,b)||this;b.__savedHasOwnCanvas=void 0;b.data.annotationType=13;b.__savedHasOwnCanvas=b.data.hasOwnCanvas=b.data.noRotate;b.data.isEditable=!b.data.noHTML;b.data.noHTML=!1;return b}Jb(c,a);c.prototype.mustBeViewedWhenEditing=function(b,d){var e;void 0===d&&(d=null);if(b){if(!this.data.isEditable)return!1;this.__savedHasOwnCanvas=this.data.hasOwnCanvas;return this.data.hasOwnCanvas=!0}this.data.hasOwnCanvas=this.__savedHasOwnCanvas;return!(null!=(e=d)&&e.has(this.data.id))};c.createImage=\nfunction(){var b=Bb(function f(e,g){var h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J;return u.generator.createGenerator(f,function(F){if(1==F.nextAddress){h=e;k=h.width;l=h.height;m=new OffscreenCanvas(k,l);n=m.getContext("2d",{alpha:!0});n.drawImage(e,0,0);p=n.getImageData(0,0,k,l).data;q=new Uint32Array(p.buffer);if(r=q.some(id.isLittleEndian?function(L){return 255!==L>>>24}:function(L){return 255!==(L&255)}))n.fillStyle="white",n.fillRect(0,0,k,l),n.drawImage(e,0,0);t=m.convertToBlob({type:"image/jpeg",\nquality:1}).then(function(L){return L.arrayBuffer()});v=ka.get("XObject");w=ka.get("Image");y=new ca(g);y.set("Type",v);y.set("Subtype",w);y.set("BitsPerComponent",8);y.set("ColorSpace",ka.get("DeviceRGB"));y.set("Filter",ka.get("DCTDecode"));y.set("BBox",[0,0,k,l]);y.set("Width",k);y.set("Height",l);x=null;if(r){z=new Uint8Array(q.length);if(id.isLittleEndian)for(A=0,B=q.length;A<B;A++)z[A]=q[A]>>>24;else for(C=0,D=q.length;C<D;C++)z[C]=q[C]&255;E=new ca(g);E.set("Type",v);E.set("Subtype",w);E.set("BitsPerComponent",\n8);E.set("ColorSpace",ka.get("DeviceGray"));E.set("Width",k);E.set("Height",l);x=new Mb(z,0,0,E)}G=Mb;return F.yield(t,2)}J=new G(F.yieldResult,0,0,y);return F.return({imageStream:J,smaskStream:x,width:k,height:l})})});return function(e,g){return b.apply(this,arguments)}}();c.createNewDict=function(b,d,e){var g=e.apRef;e=e.ap;var f=b.oldAnnotation,h=b.rect,k=b.rotation,l=b.user;b=f||new ca(d);b.set("Type",ka.get("Annot"));b.set("Subtype",ka.get("Stamp"));b.set(f?"M":"CreationDate","D:"+rd());b.set("CreationDate",\n"D:"+rd());b.set("Rect",h);b.set("F",4);b.set("Border",[0,0,0]);b.set("Rotate",k);l&&b.set("T",hd(l));if(g||e)d=new ca(d),b.set("AP",d),g?d.set("N",g):d.set("N",e);return b};c.createNewAppearanceStream=function(){var b=Bb(function h(e,g,f){var k,l,m,n,p,q,r,t,v,w,y,x;return u.generator.createGenerator(h,function(z){if(e.oldAnnotation)return z.return(null);k=e;l=k.rotation;m=f.image;n=m.imageRef;p=m.width;q=m.height;r=new ca(g);t=new ca(g);r.set("XObject",t);t.set("Im0",n);v="q "+p+" 0 0 "+q+" 0 0 cm /Im0 Do Q";\nw=new ca(g);w.set("FormType",1);w.set("Subtype",ka.get("Form"));w.set("Type",ka.get("XObject"));w.set("BBox",[0,0,p,q]);w.set("Resources",r);l&&(y=bg(l,p,q),w.set("Matrix",y));x=new Qc(v);x.dict=w;return z.return(x)})});return function(e,g,f){return b.apply(this,arguments)}}();return c}(Kc),Dz=function(a){function c(b){var d=a.call(this,b)||this;var e=b.dict;b=b.xref;b=new zj(e.get("FS"),b);d.data.annotationType=17;d.data.hasOwnCanvas=d.data.noRotate;d.data.noHTML=!1;d.data.file=b.serializable;b=\ne.get("Name");d.data.name=b instanceof ka?ib(b.name):"PushPin";e=e.get("ca");d.data.fillAlpha="number"===typeof e&&0<=e&&1>=e?e:null;return d}Jb(c,a);return c}(Kc),Fz=function(a){function c(b){b=a.call(this,b)||this;b.node=null;return b}ar(c,a);c.prototype.onEndElement=function(b){var d=a.prototype.onEndElement.call(this,b);if(d&&"xfa:datasets"===b)throw this.node=d,Error("Aborting DatasetXMLParser.");};return c}(rg),Gz=function(){function a(c){if(c.datasets)this.node=(new rg({hasAttributes:!0})).parseFromString(c.datasets).documentElement;\nelse{var b=new Fz({hasAttributes:!0});try{b.parseFromString(c["xdp:xdp"])}catch(d){}this.node=b.node}}a.prototype.getValue=function(c){if(!this.node||!c)return"";c=this.node.searchNode(mk(c),0);if(!c)return"";var b=c.firstChild;return"value"===(null==b?void 0:b.nodeName)?c.children.map(function(d){return Wm(d.textContent)}):Wm(c.textContent)};return a}(),Hz=function(){function a(b,d){this.__firstXRefStmPos=null;this.stream=b;this.pdfManager=d;this.entries=[];this._xrefStms=new Set;this._cacheMap=\nnew Map;this._pendingRefs=new Zb;this._persistentRefsCache=this._newTemporaryRefNum=this._newPersistentRefNum=null}var c=a.prototype;c.getNewPersistentRef=function(b){null===this._newPersistentRefNum&&(this._newPersistentRefNum=this.entries.length||1);var d=this._newPersistentRefNum++;this._cacheMap.set(d,b);return Ha.get(d,0)};c.getNewTemporaryRef=function(){if(null===this._newTemporaryRefNum&&(this._newTemporaryRefNum=this.entries.length||1,this._newPersistentRefNum)){this._persistentRefsCache=\nnew Map;for(var b=this._newTemporaryRefNum;b<this._newPersistentRefNum;b++)this._persistentRefsCache.set(b,this._cacheMap.get(b)),this._cacheMap.delete(b)}return Ha.get(this._newTemporaryRefNum++,0)};c.resetNewTemporaryRef=function(){this._newTemporaryRefNum=null;if(this._persistentRefsCache)for(var b=u.makeIterator(this._persistentRefsCache),d=b.next();!d.done;d=b.next()){var e=u.makeIterator(d.value);d=e.next().value;e=e.next().value;this._cacheMap.set(d,e)}this._persistentRefsCache=null};c.setStartXRef=\nfunction(b){this.startXRefQueue=[b]};c.parse=function(b){void 0===b&&(b=!1);if(b){T("Indexing all PDF objects");var d=this.indexObjects()}else d=this.readXRef();d.assignXref(this);this.trailer=d;try{var e=d.get("Encrypt")}catch(h){if(h instanceof ub)throw h;T(\'XRef.parse - Invalid "Encrypt" reference: "\'+h+\'".\')}if(e instanceof ca){var g=d.get("ID");g=null!=g&&g.length?g[0]:"";e.suppressEncryption=!0;this.encrypt=new qo(e,g,this.pdfManager.password)}try{var f=d.get("Root")}catch(h){if(h instanceof\nub)throw h;T(\'XRef.parse - Invalid "Root" reference: "\'+h+\'".\')}if(f instanceof ca)try{if(f.get("Pages")instanceof ca){this.root=f;return}}catch(h){if(h instanceof ub)throw h;T(\'XRef.parse - Invalid "Pages" reference: "\'+h+\'".\')}if(!b)throw new Oe;throw new Kg("Invalid Root reference.");};c.processXRefTable=function(b){"tableState"in this||(this.tableState={entryNum:0,streamPos:b.lexer.stream.pos,parserBuf1:b.buf1,parserBuf2:b.buf2});var d=this.readXRefTable(b);if(!Ub(d,"trailer"))throw new oa("Invalid XRef table: could not find trailer dictionary");\nb=b.getObj();b instanceof ca||!b.dict||(b=b.dict);if(!(b instanceof ca))throw new oa("Invalid XRef table: could not parse trailer dictionary");delete this.tableState;return b};c.readXRefTable=function(b){var d=b.lexer.stream,e=this.tableState;d.pos=e.streamPos;b.buf1=e.parserBuf1;b.buf2=e.parserBuf2;for(var g;;){if(!("firstEntryNum"in e&&"entryCount"in e)){if(Ub(g=b.getObj(),"trailer"))break;e.firstEntryNum=g;e.entryCount=b.getObj()}g=e.firstEntryNum;var f=e.entryCount;if(!Number.isInteger(g)||!Number.isInteger(f))throw new oa("Invalid XRef table: wrong types in subsection header");\nfor(var h=e.entryNum;h<f;h++){e.streamPos=d.pos;e.entryNum=h;e.parserBuf1=b.buf1;e.parserBuf2=b.buf2;var k={};k.offset=b.getObj();k.gen=b.getObj();var l=b.getObj();if(l instanceof Vb)switch(l.cmd){case "f":k.free=!0;break;case "n":k.uncompressed=!0}if(!Number.isInteger(k.offset)||!Number.isInteger(k.gen)||!k.free&&!k.uncompressed)throw new oa("Invalid entry in XRef subsection: "+g+", "+f);0===h&&k.free&&1===g&&(g=0);this.entries[h+g]||(this.entries[h+g]=k)}e.entryNum=0;e.streamPos=d.pos;e.parserBuf1=\nb.buf1;e.parserBuf2=b.buf2;delete e.firstEntryNum;delete e.entryCount}if(this.entries[0]&&!this.entries[0].free)throw new oa("Invalid XRef table: unexpected first object");return g};c.processXRefStream=function(b){if(!("streamState"in this)){var d=b.dict,e=d.get("W"),g=d.get("Index");g||(g=[0,d.get("Size")]);this.streamState={entryRanges:g,byteWidths:e,entryNum:0,streamPos:b.pos}}this.readXRefStream(b);delete this.streamState;return b.dict};c.readXRefStream=function(b){var d=this.streamState;b.pos=\nd.streamPos;var e=u.makeIterator(d.byteWidths),g=e.next().value,f=e.next().value;e=e.next().value;for(var h=d.entryRanges;0<h.length;){var k=u.makeIterator(h),l=k.next().value;k=k.next().value;if(!Number.isInteger(l)||!Number.isInteger(k))throw new oa("Invalid XRef range fields: "+l+", "+k);if(!Number.isInteger(g)||!Number.isInteger(f)||!Number.isInteger(e))throw new oa("Invalid XRef entry fields length: "+l+", "+k);for(var m=d.entryNum;m<k;++m){d.entryNum=m;d.streamPos=b.pos;for(var n=0,p=0,q=0,\nr=0;r<g;++r){var t=b.getByte();if(-1===t)throw new oa("Invalid XRef byteWidths \'type\'.");n=n<<8|t}0===g&&(n=1);for(r=0;r<f;++r){t=b.getByte();if(-1===t)throw new oa("Invalid XRef byteWidths \'offset\'.");p=p<<8|t}for(r=0;r<e;++r){t=b.getByte();if(-1===t)throw new oa("Invalid XRef byteWidths \'generation\'.");q=q<<8|t}r={};r.offset=p;r.gen=q;switch(n){case 0:r.free=!0;break;case 1:r.uncompressed=!0;break;case 2:break;default:throw new oa("Invalid XRef entry type: "+n);}this.entries[l+m]||(this.entries[l+\nm]=r)}d.entryNum=0;d.streamPos=b.pos;h.splice(0,2)}};c.indexObjects=function(){function b(J,F){for(var L="",M=J[F];10!==M&&13!==M&&60!==M&&!(++F>=J.length);)L+=String.fromCharCode(M),M=J[F];return L}function d(J,F,L){for(var M=L.length,W=J.length,Q=0;F<W;){for(var la=0;la<M&&J[F+la]===L[la];)++la;if(la>=M)break;F++;Q++}return Q}var e=/\\b(endobj|\\d+\\s+\\d+\\s+obj|xref|trailer\\s*<<)\\b/g,g=/\\b(startxref|\\d+\\s+\\d+\\s+obj)\\b/g,f=/^(\\d+)\\s+(\\d+)\\s+obj\\b/,h=new Uint8Array([116,114,97,105,108,101,114]),k=new Uint8Array([115,\n116,97,114,116,120,114,101,102]),l=new Uint8Array([47,88,82,101,102]);this.entries.length=0;this._cacheMap.clear();var m=this.stream;m.pos=0;for(var n=m.getBytes(),p=Ec(n),q=n.length,r=m.start,t=[],v=[];r<q;){var w=n[r];if(9===w||10===w||13===w||32===w)++r;else if(37===w){do{++r;if(r>=q)break;w=n[r]}while(10!==w&&13!==w)}else{w=b(n,r);var y=void 0;if(w.startsWith("xref")&&(4===w.length||/\\s/.test(w[4])))r+=d(n,r,h),t.push(r),r+=d(n,r,k);else if(y=f.exec(w)){var x=y[1]|0,z=y[2]|0,A=r+w.length;y=void 0;\ny=!1;if(!this.entries[x])y=!0;else if(this.entries[x].gen===z)try{(new Vd({lexer:new kd(m.makeSubStream(A))})).getObj(),y=!0}catch(J){J instanceof hj?T("indexObjects -- checking object ("+w+\'): "\'+J+\'".\'):y=!0}y&&(this.entries[x]={offset:r-m.start,gen:z,uncompressed:!0});e.lastIndex=A;(w=e.exec(p))?(y=e.lastIndex+1-r,"endobj"!==w[1]&&(T(\'indexObjects: Found "\'+w[1]+\'" inside of another "obj", caused by missing "endobj" -- trying to recover.\'),y-=w[1].length+1)):y=q-r;w=n.subarray(r,r+y);x=d(w,0,l);\nx<y&&64>w[x+5]&&(v.push(r-m.start),this._xrefStms.add(r-m.start));r+=y}else w.startsWith("trailer")&&(7===w.length||/\\s/.test(w[7]))?(t.push(r),y=void 0,g.lastIndex=r+w.length,(w=g.exec(p))?(y=g.lastIndex+1-r,"startxref"!==w[1]&&(T(\'indexObjects: Found "\'+w[1]+\'" after "trailer", caused by missing "startxref" -- trying to recover.\'),y-=w[1].length+1)):y=q-r,r+=y):r+=w.length+1}}e=u.makeIterator(v);for(g=e.next();!g.done;g=e.next())this.startXRefQueue.push(g.value),this.readXRef(!0);g=[];e=!1;t=u.makeIterator(t);\nfor(f=t.next();!f.done;f=t.next())m.pos=f.value,f=new Vd({lexer:new kd(m),xref:this,allowStreams:!0,recoveryMode:!0}),h=f.getObj(),Ub(h,"trailer")&&(f=f.getObj(),f instanceof ca&&(g.push(f),f.has("Encrypt")&&(e=!0)));m=u.makeIterator([].concat(u.arrayFromIterable(g),["genFallback"],u.arrayFromIterable(g)));for(t=m.next();!t.done;t=m.next())if(t=t.value,"genFallback"===t){if(!E)break;this._generationFallback=!0}else{g=!1;try{var B=t.get("Root");if(!(B instanceof ca))continue;var C=B.get("Pages");if(!(C instanceof\nca))continue;var D=C.get("Count");Number.isInteger(D)&&(g=!0)}catch(J){var E=J;continue}if(g&&(!e||t.has("Encrypt"))&&t.has("ID"))return t;var G=t}if(G)return G;if(this.topDict)return this.topDict;throw new Kg("Invalid PDF structure.");};c.readXRef=function(b){void 0===b&&(b=!1);for(var d=this.stream,e=new Set;this.startXRefQueue.length;){try{var g=this.startXRefQueue[0];if(e.has(g)){T("readXRef - skipping XRef table since it was already parsed.");this.startXRefQueue.shift();continue}e.add(g);d.pos=\ng+d.start;var f=new Vd({lexer:new kd(d),xref:this,allowStreams:!0}),h=f.getObj(),k=void 0;if(Ub(h,"xref")){if(k=this.processXRefTable(f),this.topDict||(this.topDict=k),h=k.get("XRefStm"),Number.isInteger(h)&&!this._xrefStms.has(h)){var l;this._xrefStms.add(h);this.startXRefQueue.push(h);null!=(l=this.__firstXRefStmPos)?l:this.__firstXRefStmPos=h}}else if(Number.isInteger(h)){if(!(Number.isInteger(f.getObj())&&Ub(f.getObj(),"obj")&&(h=f.getObj())instanceof $a))throw new oa("Invalid XRef stream");k=\nthis.processXRefStream(h);this.topDict||(this.topDict=k);if(!k)throw new oa("Failed to read XRef stream");}else throw new oa("Invalid XRef stream header");h=k.get("Prev");Number.isInteger(h)?this.startXRefQueue.push(h):h instanceof Ha&&this.startXRefQueue.push(h.num)}catch(m){if(m instanceof ub)throw m;Ya("(while reading XRef): "+m)}this.startXRefQueue.shift()}if(this.topDict)return this.topDict;if(!b)throw new Oe;};c.getEntry=function(b){return(b=this.entries[b])&&!b.free&&b.offset?b:null};c.fetchIfRef=\nfunction(b,d){void 0===d&&(d=!1);return b instanceof Ha?this.fetch(b,d):b};c.fetch=function(b,d){void 0===d&&(d=!1);if(!(b instanceof Ha))throw Error("ref object is not a reference");var e=b.num,g=this._cacheMap.get(e);if(void 0!==g)return g instanceof ca&&!g.objId&&(g.objId=b.toString()),g;g=this.getEntry(e);if(null===g)return this._cacheMap.set(e,g),g;if(this._pendingRefs.has(b))return this._pendingRefs.remove(b),T("Ignoring circular reference: "+b+"."),ir;this._pendingRefs.put(b);try{g=g.uncompressed?\nthis.fetchUncompressed(b,g,d):this.fetchCompressed(b,g,d),this._pendingRefs.remove(b)}catch(f){throw this._pendingRefs.remove(b),f;}g instanceof ca?g.objId=b.toString():g instanceof $a&&(g.dict.objId=b.toString());return g};c.fetchUncompressed=function(b,d,e){void 0===e&&(e=!1);var g=b.gen,f=b.num;if(d.gen!==g){b="Inconsistent generation in XRef: "+b;if(this._generationFallback&&d.gen<g)return T(b),this.fetchUncompressed(Ha.get(f,d.gen),d,e);throw new Ud(b);}d=this.stream.makeSubStream(d.offset+this.stream.start);\nd=new Vd({lexer:new kd(d),xref:this,allowStreams:!0});var h=d.getObj(),k=d.getObj(),l=d.getObj();if(h!==f||k!==g||!(l instanceof Vb))throw new Ud("Bad (uncompressed) XRef entry: "+b);if("obj"!==l.cmd){if(l.cmd.startsWith("obj")&&(f=parseInt(l.cmd.substring(3),10),!Number.isNaN(f)))return f;throw new Ud("Bad (uncompressed) XRef entry: "+b);}d=this.encrypt&&!e?d.getObj(this.encrypt.createCipherTransform(f,g)):d.getObj();d instanceof $a||this._cacheMap.set(f,d);return d};c.fetchCompressed=function(b,\nd){var e=d.offset,g=this.fetch(Ha.get(e,0));if(!(g instanceof $a))throw new oa("bad ObjStm stream");var f=g.dict.get("First"),h=g.dict.get("N");if(!Number.isInteger(f)||!Number.isInteger(h))throw new oa("invalid first and n parameters for ObjStm stream");for(var k=new Vd({lexer:new kd(g),xref:this,allowStreams:!0}),l=Array(h),m=Array(h),n=0;n<h;++n){var p=k.getObj();if(!Number.isInteger(p))throw new oa("invalid object number in the ObjStm stream: "+p);var q=k.getObj();if(!Number.isInteger(q))throw new oa("invalid object offset in the ObjStm stream: "+\nq);l[n]=p;m[n]=q}f=(g.start||0)+f;n=Array(h);for(p=0;p<h;++p){k=p<h-1?m[p+1]-m[p]:void 0;if(0>k)throw new oa("Invalid offset in the ObjStm stream.");k=new Vd({lexer:new kd(g.makeSubStream(f+m[p],k,g.dict)),xref:this,allowStreams:!0});k=k.getObj();n[p]=k;if(!(k instanceof $a)){q=l[p];var r=this.entries[q];r&&r.offset===e&&r.gen===p&&this._cacheMap.set(q,k)}}d=n[d.gen];if(void 0===d)throw new Ud("Bad (compressed) XRef entry: "+b);return d};c.fetchIfRefAsync=function(){var b=Ym(function f(e,g){var h=\nthis;return u.generator.createGenerator(f,function(k){return e instanceof Ha?k.return(h.fetchAsync(e,g)):k.return(e)})});return function(e,g){return b.apply(this,arguments)}}();c.fetchAsync=function(){var b=Ym(function f(e,g){var h=this,k;return u.generator.createGenerator(f,function(l){if(1==l.nextAddress)return l.setCatchFinallyBlocks(2),l.return(h.fetch(e,g));if(4!=l.nextAddress){k=l.enterCatchBlock();if(!(k instanceof ub))throw k;return l.yield(h.pdfManager.requestRange(k.begin,k.end),4)}return l.return(h.fetchAsync(e,\ng))})});return function(e,g){return b.apply(this,arguments)}}();c.getCatalogObj=function(){return this.root};return br(a,[{key:"lastXRefStreamPos",get:function(){var b;return null!=(b=this.__firstXRefStmPos)?b:0<this._xrefStms.size?Math.max.apply(Math,u.arrayFromIterable(this._xrefStms)):null}}])}(),Iz=[0,0,612,792],Xo=function(){function a(b){var d=b.pdfManager,e=b.xref,g=b.pageIndex,f=b.pageDict,h=b.ref,k=b.globalIdFactory,l=b.fontCache,m=b.builtInCMapCache,n=b.standardFontDataCache,p=b.globalImageCache,\nq=b.systemFontCache,r=b.nonBlendModesSet;b=b.xfaFactory;this.pdfManager=d;this.pageIndex=g;this.pageDict=f;this.xref=e;this.ref=h;this.fontCache=l;this.builtInCMapCache=m;this.standardFontDataCache=n;this.globalImageCache=p;this.systemFontCache=q;this.nonBlendModesSet=r;this.evaluatorOptions=d.evaluatorOptions;this.resourcesPromise=null;this.xfaFactory=b;var t=0;this._localIdFactory=function(v){function w(){return v.apply(this,arguments)||this}cr(w,v);w.createObjId=function(){return"p"+g+"_"+ ++t};\nw.getPageObjId=function(){return"p"+h.toString()};return w}(k)}var c=a.prototype;c._getInheritableProperty=function(b,d){void 0===d&&(d=!1);b=Yc({dict:this.pageDict,key:b,getArray:d,stopWhenFound:!1});return Array.isArray(b)?1!==b.length&&b[0]instanceof ca?ca.merge({xref:this.xref,dictArray:b}):b[0]:b};c._getBoundingBox=function(b){if(this.xfaData)return this.xfaData.bbox;var d=sd(this._getInheritableProperty(b,!0),null);if(d){if(0<d[2]-d[0]&&0<d[3]-d[1])return d;T("Empty, or invalid, /"+b+" entry.")}return null};\nc._onSubStreamError=function(b,d){if(this.evaluatorOptions.ignoreErrors)T("getContentStream - ignoring sub-stream ("+d+\'): "\'+b+\'".\');else throw b;};c.getContentStream=function(){var b=this;return this.pdfManager.ensure(this,"content").then(function(d){return d instanceof $a?d:Array.isArray(d)?new vr(d,b._onSubStreamError.bind(b)):new jj})};c.__replaceIdByRef=function(){var b=qc(function h(e,g,f){var k,l,m,n,p,q=this;return u.generator.createGenerator(h,function(r){k=[];l=u.makeIterator(e);m=l.next();\nfor(n={};!m.done;n={annotation$jscomp$13:void 0,ref$jscomp$55:void 0},m=l.next())n.annotation$jscomp$13=m.value,n.annotation$jscomp$13.id&&(n.ref$jscomp$55=Ha.fromString(n.annotation$jscomp$13.id),n.ref$jscomp$55?n.annotation$jscomp$13.deleted?(g.put(n.ref$jscomp$55,n.ref$jscomp$55),n.annotation$jscomp$13.popupRef&&(p=Ha.fromString(n.annotation$jscomp$13.popupRef))&&g.put(p,p)):(null==f||f.put(n.ref$jscomp$55),n.annotation$jscomp$13.ref=n.ref$jscomp$55,k.push(q.xref.fetchAsync(n.ref$jscomp$55).then(function(t){return function(v){v instanceof\nca&&(t.annotation$jscomp$13.oldAnnotation=v.clone())}}(n),function(t){return function(){T("Cannot fetch `oldAnnotation` for: "+t.ref$jscomp$55+".")}}(n))),delete n.annotation$jscomp$13.id):T("A non-linked annotation cannot be modified: "+n.annotation$jscomp$13.id));return r.yield(Promise.all(k),0)})});return function(e,g,f){return b.apply(this,arguments)}}();c.saveNewAnnotations=function(){var b=qc(function k(e,g,f,h){var l=this,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G;return u.generator.createGenerator(k,\nfunction(J){switch(J.nextAddress){case 1:if(l.xfaFactory)throw Error("XFA: Cannot save new annotations.");m=new ue({xref:l.xref,handler:e,pageIndex:l.pageIndex,idFactory:l._localIdFactory,fontCache:l.fontCache,builtInCMapCache:l.builtInCMapCache,standardFontDataCache:l.standardFontDataCache,globalImageCache:l.globalImageCache,systemFontCache:l.systemFontCache,options:l.evaluatorOptions});n=new Pc;p=new Zb;return J.yield(l.__replaceIdByRef(f,n,p),2);case 2:return q=l.pageDict,r=l.annotations.filter(function(F){return!(F instanceof\nHa&&n.has(F))}),J.yield(ce.saveNewAnnotations(m,g,f,h),3);case 3:t=J.yieldResult;v=u.makeIterator(t.annotations);for(w=v.next();!w.done;w=v.next())x=y=w.value,z=x.ref,z instanceof Ha&&!p.has(z)&&r.push(z);A=q.get("Annots");q.set("Annots",r);B=[];return J.yield(pc(l.ref,q,B,l.xref),4);case 4:A&&q.set("Annots",A);C=t.dependencies;C.push.apply(C,[{ref:l.ref,data:B.join("")}].concat(u.arrayFromIterable(t.annotations)));D=u.makeIterator(n);for(E=D.next();!E.done;E=D.next())G=E.value,C.push({ref:G,data:null});\nreturn J.return(C)}})});return function(e,g,f,h){return b.apply(this,arguments)}}();c.save=function(b,d,e){var g=new ue({xref:this.xref,handler:b,pageIndex:this.pageIndex,idFactory:this._localIdFactory,fontCache:this.fontCache,builtInCMapCache:this.builtInCMapCache,standardFontDataCache:this.standardFontDataCache,globalImageCache:this.globalImageCache,systemFontCache:this.systemFontCache,options:this.evaluatorOptions});return this._parsedAnnotations.then(function(f){var h=[];f=u.makeIterator(f);for(var k=\nf.next();!k.done;k=f.next())h.push(k.value.save(g,d,e).catch(function(l){T(\'save - ignoring annotation data during "\'+(d.name+\'" task: "\'+l+\'".\'));return null}));return Promise.all(h).then(function(l){return l.filter(function(m){return!!m})})})};c.loadResources=function(b){var d=this;this.resourcesPromise||(this.resourcesPromise=this.pdfManager.ensure(this,"resources"));return this.resourcesPromise.then(function(){return(new Ug(d.resources,b,d.xref)).load()})};c.getOperatorList=function(b){var d=\nthis,e=b.handler,g=b.sink,f=b.task,h=b.intent,k=b.cacheKey,l=void 0===b.annotationStorage?null:b.annotationStorage,m=void 0===b.modifiedIds?null:b.modifiedIds;b=this.getContentStream();var n=this.loadResources("ColorSpace ExtGState Font Pattern Properties Shading XObject".split(" ")),p=new ue({xref:this.xref,handler:e,pageIndex:this.pageIndex,idFactory:this._localIdFactory,fontCache:this.fontCache,builtInCMapCache:this.builtInCMapCache,standardFontDataCache:this.standardFontDataCache,globalImageCache:this.globalImageCache,\nsystemFontCache:this.systemFontCache,options:this.evaluatorOptions}),q=this.xfaFactory?null:pk(l),r=null==q?void 0:q.get(this.pageIndex);q=Promise.resolve(null);var t=null;if(r){q=this.pdfManager.ensureDoc("annotationGlobals");for(var v,w=new Set,y=u.makeIterator(r),x=y.next();!x.done;x=y.next()){var z=x.value;x=z.bitmapId;z=z.bitmap;!x||z||w.has(x)||w.add(x)}y=this.evaluatorOptions.isOffscreenCanvasSupported;if(0<w.size){x=r.slice();z=u.makeIterator(l);for(var A=z.next();!A.done;A=z.next()){var B=\nu.makeIterator(A.value);A=B.next().value;B=B.next().value;A.startsWith("pdfjs_internal_editor_")&&B.bitmap&&w.has(B.bitmapId)&&x.push(B)}v=ce.generateImages(x,this.xref,y)}else v=ce.generateImages(r,this.xref,y);t=new Zb;q=Promise.all([q,this.__replaceIdByRef(r,t,null)]).then(function(C){return(C=u.makeIterator(C).next().value)?ce.printNewAnnotations(C,p,f,r,v):null})}b=Promise.all([b,n]).then(function(C){C=u.makeIterator(C).next().value;var D=new Dc(h,g);e.send("StartRenderPage",{transparency:p.hasBlendModes(d.resources,\nd.nonBlendModesSet),pageIndex:d.pageIndex,cacheKey:k});return p.getOperatorList({stream:C,task:f,resources:d.resources,operatorList:D}).then(function(){return D})});return Promise.all([b,this._parsedAnnotations,q]).then(function(C){var D=u.makeIterator(C),E=D.next().value;C=D.next().value;if(D=D.next().value){C=C.filter(function(Q){return!(Q.ref&&t.has(Q.ref))});for(var G={},J=0,F=D.length;J<F;G={newAnnotation$jscomp$1:void 0},J++)if(G.newAnnotation$jscomp$1=D[J],G.newAnnotation$jscomp$1.refToReplace){var L=\nC.findIndex(function(Q){return function(la){return la.ref&&Yf(la.ref,Q.newAnnotation$jscomp$1.refToReplace)}}(G));0<=L&&(C.splice(L,1,G.newAnnotation$jscomp$1),D.splice(J--,1),F--)}C=C.concat(D)}if(0===C.length||h&64)return E.flush(!0),{length:E.totalLength};D=!!(h&16);G=!!(h&128);J=!!(h&1);F=!!(h&2);L=!!(h&4);var M=[];C=u.makeIterator(C);for(var W=C.next();!W.done;W=C.next())W=W.value,(J||F&&W.mustBeViewed(l,D)&&W.mustBeViewedWhenEditing(G,m)||L&&W.mustBePrinted(l))&&M.push(W.getOperatorList(p,f,\nh,l).catch(function(Q){T(\'getOperatorList - ignoring annotation data during "\'+(f.name+\'" task: "\'+Q+\'".\'));return{opList:null,separateForm:!1,separateCanvas:!1}}));return Promise.all(M).then(function(Q){var la=!1,ta=!1;Q=u.makeIterator(Q);for(var qa=Q.next();!qa.done;qa=Q.next()){qa=qa.value;var va=qa.separateForm,S=qa.separateCanvas;E.addOpList(qa.opList);la||(la=va);ta||(ta=S)}E.flush(!0,{form:la,canvas:ta});return{length:E.totalLength}})})};c.extractTextContent=function(){var b=qc(function g(e){var f,\nh,k,l,m,n,p=this,q,r,t,v,w,y,x,z,A;return u.generator.createGenerator(g,function(B){if(1==B.nextAddress)return f=e,h=f.handler,k=f.task,l=f.includeMarkedContent,m=f.disableNormalization,n=f.sink,q=p.getContentStream(),r=p.loadResources(["ExtGState","Font","Properties","XObject"]),t=p.pdfManager.ensureCatalog("lang"),v=u,w=v.makeIterator,B.yield(Promise.all([q,r,t]),2);y=w.call(v,B.yieldResult);x=y.next().value;y.next();z=y.next().value;A=new ue({xref:p.xref,handler:h,pageIndex:p.pageIndex,idFactory:p._localIdFactory,\nfontCache:p.fontCache,builtInCMapCache:p.builtInCMapCache,standardFontDataCache:p.standardFontDataCache,globalImageCache:p.globalImageCache,systemFontCache:p.systemFontCache,options:p.evaluatorOptions});return B.return(A.getTextContent({stream:x,task:k,resources:p.resources,includeMarkedContent:l,disableNormalization:m,sink:n,viewBox:p.view,lang:z}))})});return function(e){return b.apply(this,arguments)}}();c.getStructTree=function(){var b=qc(function e(){var g=this,f,h;return u.generator.createGenerator(e,\nfunction(k){switch(k.nextAddress){case 1:return k.yield(g.pdfManager.ensureCatalog("structTreeRoot"),2);case 2:return(f=k.yieldResult)?k.yield(g._parsedAnnotations,3):k.return(null);case 3:return k.yield(g.pdfManager.ensure(g,"_parseStructTree",[f]),4);case 4:return h=k.yieldResult,k.return(g.pdfManager.ensure(h,"serializable"))}})});return function(){return b.apply(this,arguments)}}();c._parseStructTree=function(b){b=new ro(b,this.pageDict);b.parse(this.ref);return b};c.getAnnotationsData=function(){var b=\nqc(function h(e,g,f){var k=this,l,m,n,p,q,r,t,v,w,y,x;return u.generator.createGenerator(h,function(z){if(1==z.nextAddress)return z.yield(k._parsedAnnotations,2);if(3!=z.nextAddress){l=z.yieldResult;if(0===l.length)return z.return(l);m=[];n=[];q=!!(f&1);r=!!(f&2);t=!!(f&4);v=u.makeIterator(l);for(w=v.next();!w.done;w=v.next())y=w.value,((x=q||r&&y.viewable)||t&&y.printable)&&m.push(y.data),y.hasTextContent&&x&&(p||(p=new ue({xref:k.xref,handler:e,pageIndex:k.pageIndex,idFactory:k._localIdFactory,\nfontCache:k.fontCache,builtInCMapCache:k.builtInCMapCache,standardFontDataCache:k.standardFontDataCache,globalImageCache:k.globalImageCache,systemFontCache:k.systemFontCache,options:k.evaluatorOptions})),n.push(y.extractTextContent(p,g,[-Infinity,-Infinity,Infinity,Infinity]).catch(function(A){T(\'getAnnotationsData - ignoring textContent during "\'+g.name+\'" task: "\'+A+\'".\')})));return z.yield(Promise.all(n),3)}return z.return(m)})});return function(e,g,f){return b.apply(this,arguments)}}();return bn(a,\n[{key:"content",get:function(){return this.pageDict.getArray("Contents")}},{key:"resources",get:function(){var b=this._getInheritableProperty("Resources");return Fa(this,"resources",b instanceof ca?b:ca.empty)}},{key:"mediaBox",get:function(){return Fa(this,"mediaBox",this._getBoundingBox("MediaBox")||Iz)}},{key:"cropBox",get:function(){return Fa(this,"cropBox",this._getBoundingBox("CropBox")||this.mediaBox)}},{key:"userUnit",get:function(){var b=this.pageDict.get("UserUnit");if("number"!==typeof b||\n0>=b)b=1;return Fa(this,"userUnit",b)}},{key:"view",get:function(){var b=this.cropBox,d=this.mediaBox;if(b!==d&&!ee(b,d)){if((b=Rb.intersect(b,d))&&0<b[2]-b[0]&&0<b[3]-b[1])return Fa(this,"view",b);T("Empty /CropBox and /MediaBox intersection.")}return Fa(this,"view",d)}},{key:"rotate",get:function(){var b=this._getInheritableProperty("Rotate")||0;0!==b%90?b=0:360<=b?b%=360:0>b&&(b=(b%360+360)%360);return Fa(this,"rotate",b)}},{key:"xfaData",get:function(){return Fa(this,"xfaData",this.xfaFactory?\n{bbox:this.xfaFactory.getBoundingBox(this.pageIndex)}:null)}},{key:"annotations",get:function(){var b=this._getInheritableProperty("Annots");return Fa(this,"annotations",Array.isArray(b)?b:[])}},{key:"_parsedAnnotations",get:function(){var b=this,d=this.pdfManager.ensure(this,"annotations").then(function(){var e=qc(function h(f){var k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E;return u.generator.createGenerator(h,function(G){if(1==G.nextAddress){if(0===f.length)return G.return(f);k=u;l=k.makeIterator;return G.yield(Promise.all([b.pdfManager.ensureDoc("annotationGlobals"),\nb.pdfManager.ensureDoc("fieldObjects")]),2)}if(3!=G.nextAddress){m=l.call(k,G.yieldResult);n=m.next().value;p=m.next().value;if(!n)return G.return([]);q=null==p?void 0:p.orphanFields;r=[];t=u.makeIterator(f);for(v=t.next();!v.done;v=t.next())w=v.value,r.push(ce.create(b.xref,w,n,b._localIdFactory,!1,q,b.ref).catch(function(J){T(\'_parsedAnnotations: "\'+J+\'".\');return null}));y=[];A=u;B=A.makeIterator;return G.yield(Promise.all(r),3)}C=B.call(A,G.yieldResult);for(D=C.next();!D.done;D=C.next())(E=D.value)&&\n(E instanceof be?(z||(z=[])).push(E):E instanceof Uo?(x||(x=[])).push(E):y.push(E));z&&y.push.apply(y,u.arrayFromIterable(z));x&&y.push.apply(y,u.arrayFromIterable(x));return G.return(y)})});return function(f){return e.apply(this,arguments)}}());return Fa(this,"_parsedAnnotations",d)}},{key:"jsActions",get:function(){var b=ag(this.xref,this.pageDict,hr);return Fa(this,"jsActions",b)}}])}(),Yo=new Uint8Array([37,80,68,70,45]),Zo=new Uint8Array([115,116,97,114,116,120,114,101,102]),Jz=new Uint8Array([101,\n110,100,111,98,106]),$o=function(){function a(b,d){if(0>=d.length)throw new Kg("The PDF file is empty, i.e. its size is zero bytes.");this.pdfManager=b;this.stream=d;this.xref=new Hz(d,b);this._pagePromises=new Map;this._version=null;var e=0;this._globalIdFactory=function(){function g(){}g.getDocId=function(){return"g_"+b.docId};g.createFontId=function(){return"f"+ ++e};g.createObjId=function(){db("Abstract method `createObjId` called.")};g.getPageObjId=function(){db("Abstract method `getPageObjId` called.")};\nreturn g}()}var c=a.prototype;c.parse=function(b){this.xref.parse(b);this.catalog=new Cj(this.pdfManager,this.xref)};c.checkHeader=function(){var b=this.stream;b.reset();if(ej(b,Yo)){b.moveStart();b.skip(Yo.length);for(var d="",e;32<(e=b.getByte())&&7>d.length;)d+=String.fromCharCode(e);tn.test(d)?this._version=d:T("Invalid PDF header version: "+d)}};c.parseStartXRef=function(){this.xref.setStartXRef(this.startXRef)};c._hasOnlyDocumentSignatures=function(b,d){var e=this;void 0===d&&(d=0);return Array.isArray(b)?\nb.every(function(g){g=e.xref.fetchIfRef(g);if(!(g instanceof ca))return!1;if(g.has("Kids"))return 10<++d?(T("_hasOnlyDocumentSignatures: maximum recursion depth reached"),!1):e._hasOnlyDocumentSignatures(g.get("Kids"),d);var f=Lb(g.get("FT"),"Sig");g=g.get("Rect");g=Array.isArray(g)&&g.every(function(h){return 0===h});return f&&g}):!1};c.loadXfaImages=function(){var b=qc(function e(){var g=this,f,h,k,l,m,n,p,q;return u.generator.createGenerator(e,function(r){if(1==r.nextAddress)return r.yield(g.pdfManager.ensureCatalog("xfaImages"),\n2);if(3!=r.nextAddress){f=r.yieldResult;if(!f)return r.return();h=f.getKeys();k=new Ug(f,h,g.xref);return r.yield(k.load(),3)}l=new Map;m=u.makeIterator(h);for(n=m.next();!n.done;n=m.next())p=n.value,q=f.get(p),q instanceof $a&&l.set(p,q.getBytes());g.xfaFactory.setImages(l);r.jumpToEnd()})});return function(){return b.apply(this,arguments)}}();c.loadXfaFonts=function(){var b=qc(function f(e,g){var h=this,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R,Y,fa,H;return u.generator.createGenerator(f,\nfunction(U){switch(U.nextAddress){case 1:return U.yield(h.pdfManager.ensureCatalog("acroForm"),2);case 2:return(k=U.yieldResult)?U.yield(k.getAsync("DR"),3):U.return();case 3:l=U.yieldResult;if(!(l instanceof ca))return U.return();m=new Ug(l,["Font"],h.xref);return U.yield(m.load(),4);case 4:n=l.get("Font");if(!(n instanceof ca))return U.return();p=Object.assign(Object.create(null),h.pdfManager.evaluatorOptions);p.useSystemFonts=!1;q=new ue({xref:h.xref,handler:e,pageIndex:-1,idFactory:h._globalIdFactory,\nfontCache:h.catalog.fontCache,builtInCMapCache:h.catalog.builtInCMapCache,standardFontDataCache:h.catalog.standardFontDataCache,options:p});r=new Dc;t=[];v={get font(){return t.at(-1)},set font(N){t.push(N)},clone:function(){return this}};w=new Map;n.forEach(function(N,ba){w.set(N,ba)});y=[];x=u.makeIterator(w);for(z=x.next();!z.done;z=x.next())A=z.value,B=u.makeIterator(A),C=B.next().value,D=B.next().value,E=D.get("FontDescriptor"),E instanceof ca&&(G=E.get("FontFamily"),G=G.replaceAll(/[ ]+(\\d)/g,\n"$1"),J=E.get("FontWeight"),F=-E.get("ItalicAngle"),L={fontFamily:G,fontWeight:J,italicAngle:F},mp(L)&&y.push(q.handleSetFont(l,[ka.get(C),1],null,r,g,v,null,L).catch(function(N){T(\'loadXfaFonts: "\'+N+\'".\');return null})));return U.yield(Promise.all(y),5);case 5:M=h.xfaFactory.setFonts(t);if(!M)return U.return();p.ignoreErrors=!0;y.length=0;t.length=0;W=new Set;Q=u.makeIterator(M);for(la=Q.next();!la.done;la=Q.next())ta=la.value,ei(ta+"-Regular")||W.add(ta);W.size&&M.push("PdfJS-Fallback");qa=u.makeIterator(M);\nfor(va=qa.next();!va.done;va=qa.next())if(S=va.value,!W.has(S))for(da=u.makeIterator([{name:"Regular",fontWeight:400,italicAngle:0},{name:"Bold",fontWeight:700,italicAngle:0},{name:"Italic",fontWeight:400,italicAngle:12},{name:"BoldItalic",fontWeight:700,italicAngle:12}]),R=da.next();!R.done;R=da.next())Y=R.value,fa=S+"-"+Y.name,H=xl(fa),y.push(q.handleSetFont(l,[ka.get(fa),1],null,r,g,v,H,{fontFamily:S,fontWeight:Y.fontWeight,italicAngle:Y.italicAngle}).catch(function(N){T(\'loadXfaFonts: "\'+N+\'".\');\nreturn null}));return U.yield(Promise.all(y),6);case 6:h.xfaFactory.appendFonts(t,W),U.jumpToEnd()}})});return function(e,g){return b.apply(this,arguments)}}();c.serializeXfaData=function(){var b=qc(function g(e){var f=this;return u.generator.createGenerator(g,function(h){return h.return(f.xfaFactory?f.xfaFactory.serializeData(e):null)})});return function(e){return b.apply(this,arguments)}}();c._getLinearizationPage=function(){var b=qc(function g(e){var f=this,h,k,l,m,n,p,q,r;return u.generator.createGenerator(g,\nfunction(t){switch(t.nextAddress){case 1:return h=f,k=h.catalog,l=h.linearization,m=h.xref,n=Ha.get(l.objectNumberFirst,0),t.setCatchFinallyBlocks(2),t.yield(m.fetchAsync(n),4);case 4:p=t.yieldResult;if(!(p instanceof ca)){t.jumpTo(5);break}q=p.getRaw("Type");if(!(q instanceof Ha)){t.jumpTo(6);break}return t.yield(m.fetchAsync(q),7);case 7:q=t.yieldResult;case 6:if(Lb(q,"Page")||!p.has("Type")&&!p.has("Kids")&&p.has("Contents"))return k.pageKidsCountCache.has(n)||k.pageKidsCountCache.put(n,1),k.pageIndexCache.has(n)||\nk.pageIndexCache.put(n,0),t.return([p,n]);case 5:throw new oa("The Linearization dictionary doesn\'t point to a valid Page dictionary.");case 2:return r=t.enterCatchBlock(),T(\'_getLinearizationPage: "\'+r.message+\'".\'),t.return(k.getPageDict(e))}})});return function(e){return b.apply(this,arguments)}}();c.getPage=function(b){var d=this,e=this._pagePromises.get(b);if(e)return e;var g=this.catalog;e=this.linearization;var f=this.xfaFactory;e=f?Promise.resolve([ca.empty,null]):(null==e?void 0:e.pageFirst)===\nb?this._getLinearizationPage(b):g.getPageDict(b);e=e.then(function(h){var k=u.makeIterator(h);h=k.next().value;k=k.next().value;return new Xo({pdfManager:d.pdfManager,xref:d.xref,pageIndex:b,pageDict:h,ref:k,globalIdFactory:d._globalIdFactory,fontCache:g.fontCache,builtInCMapCache:g.builtInCMapCache,standardFontDataCache:g.standardFontDataCache,globalImageCache:g.globalImageCache,systemFontCache:g.systemFontCache,nonBlendModesSet:g.nonBlendModesSet,xfaFactory:f})});this._pagePromises.set(b,e);return e};\nc.checkFirstPage=function(){var b=qc(function g(e){var f=this,h;return u.generator.createGenerator(g,function(k){switch(k.nextAddress){case 1:void 0===e&&(e=!1);if(e)return k.return();k.setCatchFinallyBlocks(2);return k.yield(f.getPage(0),4);case 4:k.leaveTryBlock(0);break;case 2:h=k.enterCatchBlock();if(!(h instanceof Ud)){k.jumpTo(0);break}f._pagePromises.delete(0);return k.yield(f.cleanup(),6);case 6:throw new Oe;}})});return function(e){return b.apply(this,arguments)}}();c.checkLastPage=function(){var b=\nqc(function g(e){var f=this,h,k,l,m,n,p,q,r,t,v,w,y,x,z,A,B;return u.generator.createGenerator(g,function(C){switch(C.nextAddress){case 1:return void 0===e&&(e=!1),h=f,k=h.catalog,l=h.pdfManager,k.setActualNumPages(),C.setCatchFinallyBlocks(2),C.yield(Promise.all([l.ensureDoc("xfaFactory"),l.ensureDoc("linearization"),l.ensureCatalog("numPages")]),4);case 4:if(f.xfaFactory)return C.return();m=f.linearization?f.linearization.numPages:k.numPages;if(!Number.isInteger(m))throw new oa("Page count is not an integer.");\nreturn 1>=m?C.return():C.yield(f.getPage(m-1),5);case 5:C.leaveTryBlock(0);break;case 2:return n=C.enterCatchBlock(),f._pagePromises.delete(m-1),C.yield(f.cleanup(),6);case 6:if(n instanceof Ud&&!e)throw new Oe;T("checkLastPage - invalid /Pages tree /Count: "+m+".");C.setCatchFinallyBlocks(7);return C.yield(k.getAllPageDicts(e),9);case 9:p=C.yieldResult;C.leaveTryBlock(8);break;case 7:q=C.enterCatchBlock();if(q instanceof Ud&&!e)throw new Oe;k.setActualNumPages(1);return C.return();case 8:r=u.makeIterator(p);\nfor(t=r.next();!t.done;t=r.next())v=t.value,w=u.makeIterator(v),y=w.next().value,x=u.makeIterator(w.next().value),z=x.next().value,A=x.next().value,B=void 0,z instanceof Error?(B=Promise.reject(z),B.catch(function(){})):B=Promise.resolve(new Xo({pdfManager:l,xref:f.xref,pageIndex:y,pageDict:z,ref:A,globalIdFactory:f._globalIdFactory,fontCache:k.fontCache,builtInCMapCache:k.builtInCMapCache,standardFontDataCache:k.standardFontDataCache,globalImageCache:k.globalImageCache,systemFontCache:k.systemFontCache,\nnonBlendModesSet:k.nonBlendModesSet,xfaFactory:null})),f._pagePromises.set(y,B);k.setActualNumPages(p.size);C.jumpToEnd()}})});return function(e){return b.apply(this,arguments)}}();c.fontFallback=function(b,d){return this.catalog.fontFallback(b,d)};c.cleanup=function(){var b=qc(function g(e){var f=this;return u.generator.createGenerator(g,function(h){void 0===e&&(e=!1);return h.return(f.catalog?f.catalog.cleanup(e):qi())})});return function(e){return b.apply(this,arguments)}}();c.__collectFieldObjects=\nfunction(){var b=qc(function n(e,g,f,h,k,l,m){var p=this,q,r,t,v,w,y,x,z,A,B,C,D;return u.generator.createGenerator(n,function(E){switch(E.nextAddress){case 1:q=p;r=q.xref;if(!(f instanceof Ha)||l.has(f))return E.return();l.put(f);return E.yield(r.fetchAsync(f),2);case 2:t=E.yieldResult;if(!(t instanceof ca))return E.return();if(t.has("T"))return x=ib,E.yield(t.getAsync("T"),12);v=t;case 5:v=v.getRaw("Parent")||g;if(!(v instanceof Ha)){E.jumpTo(8);break}if(l.has(v)){E.jumpTo(4);break}return E.yield(r.fetchAsync(v),\n9);case 9:v=E.yieldResult;case 8:if(!(v instanceof ca)){E.jumpTo(4);break}if(!v.has("T")){E.jumpTo(5);break}w=ib;return E.yield(v.getAsync("T"),11);case 11:y=w(E.yieldResult);e=""===e?y:e+"."+y;E.jumpTo(4);break;case 12:z=x(E.yieldResult),e=""===e?z:e+"."+z;case 4:return g&&!t.has("Parent")&&Lb(t.get("Subtype"),"Widget")&&m.put(f,g),h.has(e)||h.set(e,[]),h.get(e).push(ce.create(r,f,k,null,!0,m,null).then(function(G){return null==G?void 0:G.getFieldObject()}).catch(function(G){T(\'#collectFieldObjects: "\'+\nG+\'".\');return null})),t.has("Kids")?E.yield(t.getAsync("Kids"),13):E.return();case 13:A=E.yieldResult;if(!Array.isArray(A)){E.jumpTo(0);break}B=u.makeIterator(A);C=B.next();case 15:if(C.done){E.jumpTo(0);break}D=C.value;return E.yield(p.__collectFieldObjects(e,f,D,h,k,l,m),16);case 16:C=B.next(),E.jumpTo(15)}})});return function(e,g,f,h,k,l,m){return b.apply(this,arguments)}}();c._parseHasJSActions=function(){var b=qc(function e(){var g,f,h=this,k,l,m;return u.generator.createGenerator(e,function(n){if(1==\nn.nextAddress)return g=u,f=g.makeIterator,n.yield(Promise.all([h.pdfManager.ensureCatalog("jsActions"),h.pdfManager.ensureDoc("fieldObjects")]),2);k=f.call(g,n.yieldResult);l=k.next().value;m=k.next().value;return l?n.return(!0):m?n.return(Object.values(m.allFields).some(function(p){return p.some(function(q){return null!==q.actions})})):n.return(!1)})});return function(){return b.apply(this,arguments)}}();return bn(a,[{key:"linearization",get:function(){var b=null;try{b=Sr.create(this.stream)}catch(d){if(d instanceof\nub)throw d;Ya(d)}return Fa(this,"linearization",b)}},{key:"startXRef",get:function(){var b=this.stream,d=0;if(this.linearization){if(b.reset(),ej(b,Jz)){b.skip(6);for(d=b.peekByte();Lc(d);)b.pos++,d=b.peekByte();d=b.pos-b.start}}else{for(var e=Zo.length,g=!1,f=b.end;!g&&0<f;)f-=1024-e,0>f&&(f=0),b.pos=f,g=ej(b,Zo,1024,!0);if(g){b.skip(9);do d=b.getByte();while(Lc(d));for(e="";32<=d&&57>=d;)e+=String.fromCharCode(d),d=b.getByte();d=parseInt(e,10);isNaN(d)&&(d=0)}}return Fa(this,"startXRef",d)}},{key:"numPages",\nget:function(){var b=this.catalog.hasActualNumPages?this.catalog.numPages:this.xfaFactory?this.xfaFactory.getNumPages():this.linearization?this.linearization.numPages:this.catalog.numPages;return Fa(this,"numPages",b)}},{key:"_xfaStreams",get:function(){var b=this.catalog.acroForm;if(!b)return null;b=b.get("XFA");var d={"xdp:xdp":"",template:"",datasets:"",config:"",connectionSet:"",localeSet:"",stylesheet:"","/xdp:xdp":""};if(b instanceof $a&&!b.isEmpty)return d["xdp:xdp"]=b,d;if(!Array.isArray(b)||\n0===b.length)return null;for(var e=0,g=b.length;e<g;e+=2){var f=0===e?"xdp:xdp":e===g-2?"/xdp:xdp":b[e];if(d.hasOwnProperty(f)){var h=this.xref.fetchIfRef(b[e+1]);h instanceof $a&&!h.isEmpty&&(d[f]=h)}}return d}},{key:"xfaDatasets",get:function(){var b=this._xfaStreams;if(!b)return Fa(this,"xfaDatasets",null);for(var d=u.makeIterator(["datasets","xdp:xdp"]),e=d.next();!e.done;e=d.next()){e=e.value;var g=b[e];if(g)try{var f=decodeURIComponent(escape(g.getString()));b={};var h=(b[e]=f,b);return Fa(this,\n"xfaDatasets",new Gz(h))}catch(k){T("XFA - Invalid utf-8 string.");break}}return Fa(this,"xfaDatasets",null)}},{key:"xfaData",get:function(){var b=this._xfaStreams;if(!b)return null;var d=Object.create(null);b=u.makeIterator(Object.entries(b));for(var e=b.next();!e.done;e=b.next()){var g=u.makeIterator(e.value);e=g.next().value;if(g=g.next().value)try{d[e]=decodeURIComponent(escape(g.getString()))}catch(f){return T("XFA - Invalid utf-8 string."),null}}return d}},{key:"xfaFactory",get:function(){if(this.pdfManager.enableXfa&&\nthis.catalog.needsRendering&&this.formInfo.hasXfa&&!this.formInfo.hasAcroForm)var b=this.xfaData;return Fa(this,"xfaFactory",b?new Zj(b):null)}},{key:"isPureXfa",get:function(){return this.xfaFactory?this.xfaFactory.isValid():!1}},{key:"htmlForXfa",get:function(){return this.xfaFactory?this.xfaFactory.getPages():null}},{key:"version",get:function(){return this.catalog.version||this._version}},{key:"formInfo",get:function(){var b={hasFields:!1,hasAcroForm:!1,hasXfa:!1,hasSignatures:!1},d=this.catalog.acroForm;\nif(!d)return Fa(this,"formInfo",b);try{var e=d.get("Fields"),g=Array.isArray(e)&&0<e.length;b.hasFields=g;var f=d.get("XFA");b.hasXfa=Array.isArray(f)&&0<f.length||f instanceof $a&&!f.isEmpty;var h=!!(d.get("SigFlags")&1),k=h&&this._hasOnlyDocumentSignatures(e);b.hasAcroForm=g&&!k;b.hasSignatures=h}catch(l){if(l instanceof ub)throw l;T(\'Cannot fetch form information: "\'+l+\'".\')}return Fa(this,"formInfo",b)}},{key:"documentInfo",get:function(){var b={PDFFormatVersion:this.version,Language:this.catalog.lang,\nEncryptFilterName:this.xref.encrypt?this.xref.encrypt.filterName:null,IsLinearized:!!this.linearization,IsAcroFormPresent:this.formInfo.hasAcroForm,IsXFAPresent:this.formInfo.hasXfa,IsCollectionPresent:!!this.catalog.collection,IsSignaturesPresent:this.formInfo.hasSignatures};try{var d=this.xref.trailer.get("Info")}catch(k){if(k instanceof ub)throw k;Ya("The document information dictionary is invalid.")}if(!(d instanceof ca))return Fa(this,"documentInfo",b);for(var e=u.makeIterator(d.getKeys()),g=\ne.next();!g.done;g=e.next()){g=g.value;var f=d.get(g);switch(g){case "Title":case "Author":case "Subject":case "Keywords":case "Creator":case "Producer":case "CreationDate":case "ModDate":if("string"===typeof f){b[g]=ib(f);continue}break;case "Trapped":if(f instanceof ka){b[g]=f;continue}break;default:var h=void 0;switch(typeof f){case "string":h=ib(f);break;case "number":case "boolean":h=f;break;default:f instanceof ka&&(h=f)}if(void 0===h){T(\'Bad value, for custom key "\'+g+\'", in Info: \'+f+".");\ncontinue}b.Custom||(b.Custom=Object.create(null));b.Custom[g]=h;continue}T(\'Bad value, for key "\'+g+\'", in Info: \'+f+".")}return Fa(this,"documentInfo",b)}},{key:"fingerprints",get:function(){function b(h){return"string"===typeof h&&16===h.length&&h!==d}var d="\\x00".repeat(16),e=this.xref.trailer.get("ID"),g;if(Array.isArray(e)&&b(e[0])){var f=jc(e[0]);e[1]!==e[0]&&b(e[1])&&(g=jc(e[1]))}else f=Qd(this.stream.getByteRange(0,1024),0,1024);return Fa(this,"fingerprints",[ek(f),g?ek(g):null])}},{key:"fieldObjects",\nget:function(){var b=this,d=this.pdfManager.ensureDoc("formInfo").then(function(){var e=qc(function h(f){var k,l,m,n,p,q,r,t,v,w,y,x,z,A,B,C,D,E,G,J,F;return u.generator.createGenerator(h,function(L){switch(L.nextAddress){case 1:if(!f.hasFields)return L.return(null);k=u;l=k.makeIterator;return L.yield(Promise.all([b.pdfManager.ensureDoc("annotationGlobals"),b.pdfManager.ensureCatalog("acroForm")]),2);case 2:m=l.call(k,L.yieldResult);n=m.next().value;p=m.next().value;if(!n)return L.return(null);q=\nnew Zb;r=Object.create(null);t=new Map;v=new Pc;w=u;y=w.makeIterator;return L.yield(p.getAsync("Fields"),3);case 3:x=y.call(w,L.yieldResult),z=x.next();case 4:if(z.done){B=[];C=u.makeIterator(t);D=C.next();for(E={};!D.done;E={name$jscomp$221:void 0},D=C.next())G=D.value,J=u.makeIterator(G),E.name$jscomp$221=J.next().value,F=J.next().value,B.push(Promise.all(F).then(function(M){return function(W){W=W.filter(function(Q){return!!Q});0<W.length&&(r[M.name$jscomp$221]=W)}}(E)));return L.yield(Promise.all(B),\n8)}A=z.value;return L.yield(b.__collectFieldObjects("",null,A,t,n,q,v),5);case 5:z=x.next();L.jumpTo(4);break;case 8:return L.return({allFields:r,orphanFields:v})}})});return function(f){return e.apply(this,arguments)}}());return Fa(this,"fieldObjects",d)}},{key:"hasJSActions",get:function(){var b=this.pdfManager.ensureDoc("_parseHasJSActions");return Fa(this,"hasJSActions",b)}},{key:"calculationOrderIds",get:function(){var b,d=null==(b=this.catalog.acroForm)?void 0:b.get("CO");if(!Array.isArray(d)||\n0===d.length)return Fa(this,"calculationOrderIds",null);b=[];d=u.makeIterator(d);for(var e=d.next();!e.done;e=d.next())e=e.value,e instanceof Ha&&b.push(e.toString());return Fa(this,"calculationOrderIds",b.length?b:null)}},{key:"annotationGlobals",get:function(){return Fa(this,"annotationGlobals",ce.createGlobals(this.pdfManager))}}])}(),ap=function(){function a(b){var d,e;a:{if(e=b.docBaseUrl){var g=Xf(e);if(g){e=g.href;break a}T(\'Invalid absolute docBaseUrl: "\'+e+\'".\')}e=null}this._docBaseUrl=e;\nthis._docId=b.docId;this._password=b.password;this.enableXfa=b.enableXfa;(d=b.evaluatorOptions).isOffscreenCanvasSupported&&(d.isOffscreenCanvasSupported=id.isOffscreenCanvasSupported);this.evaluatorOptions=Object.freeze(b.evaluatorOptions)}var c=a.prototype;c.ensureDoc=function(b,d){return this.ensure(this.pdfDocument,b,d)};c.ensureXRef=function(b,d){return this.ensure(this.pdfDocument.xref,b,d)};c.ensureCatalog=function(b,d){return this.ensure(this.pdfDocument.catalog,b,d)};c.getPage=function(b){return this.pdfDocument.getPage(b)};\nc.fontFallback=function(b,d){return this.pdfDocument.fontFallback(b,d)};c.loadXfaFonts=function(b,d){return this.pdfDocument.loadXfaFonts(b,d)};c.loadXfaImages=function(){return this.pdfDocument.loadXfaImages()};c.serializeXfaData=function(b){return this.pdfDocument.serializeXfaData(b)};c.cleanup=function(b){void 0===b&&(b=!1);return this.pdfDocument.cleanup(b)};c.ensure=function(){var b=gj(function e(){return u.generator.createGenerator(e,function(g){db("Abstract method `ensure` called");g.jumpToEnd()})});\nreturn function(e,g,f){return b.apply(this,arguments)}}();c.requestRange=function(){db("Abstract method `requestRange` called")};c.requestLoadedStream=function(){db("Abstract method `requestLoadedStream` called")};c.sendProgressiveData=function(){db("Abstract method `sendProgressiveData` called")};c.updatePassword=function(b){this._password=b};c.terminate=function(){db("Abstract method `terminate` called")};return dr(a,[{key:"docId",get:function(){return this._docId}},{key:"password",get:function(){return this._password}},\n{key:"docBaseUrl",get:function(){return this._docBaseUrl}},{key:"catalog",get:function(){return this.pdfDocument.catalog}}])}(),bp=function(a){function c(d){var e=a.call(this,d)||this;d=new Mb(d.source);e.pdfDocument=new $o(e,d);e._loadedStreamPromise=Promise.resolve(d);return e}cn(c,a);var b=c.prototype;b.ensure=function(){var d=gj(function k(g,f,h){var l;return u.generator.createGenerator(k,function(m){l=g[f];return"function"===typeof l?m.return(l.apply(g,h)):m.return(l)})});return function(g,f,\nh){return d.apply(this,arguments)}}();b.requestRange=function(){return Promise.resolve()};b.requestLoadedStream=function(){return this._loadedStreamPromise};b.terminate=function(){};return c}(ap),Kz=function(a){function c(d){var e=a.call(this,d)||this;e.streamManager=new kr(d.source,{msgHandler:d.handler,length:d.length,disableAutoFetch:d.disableAutoFetch,rangeChunkSize:d.rangeChunkSize});e.pdfDocument=new $o(e,e.streamManager.getStream());return e}cn(c,a);var b=c.prototype;b.ensure=function(){var d=\ngj(function k(g,f,h){var l,m,n=this;return u.generator.createGenerator(k,function(p){if(1==p.nextAddress)return p.setCatchFinallyBlocks(2),l=g[f],"function"===typeof l?p.return(l.apply(g,h)):p.return(l);if(4!=p.nextAddress){m=p.enterCatchBlock();if(!(m instanceof ub))throw m;return p.yield(n.requestRange(m.begin,m.end),4)}return p.return(n.ensure(g,f,h))})});return function(g,f,h){return d.apply(this,arguments)}}();b.requestRange=function(d,e){return this.streamManager.requestRange(d,e)};b.requestLoadedStream=\nfunction(d){void 0===d&&(d=!1);return this.streamManager.requestAllChunks(d)};b.sendProgressiveData=function(d){this.streamManager.onReceiveData({chunk:d})};b.terminate=function(d){this.streamManager.abort(d)};return c}(ap);pa(6167);var cp=function(){function a(b,d,e){this.__messageAC=new AbortController;this.sourceName=b;this.targetName=d;this.comObj=e;this.streamId=this.callbackId=1;this.streamSinks=Object.create(null);this.streamControllers=Object.create(null);this.callbackCapabilities=Object.create(null);\nthis.actionHandler=Object.create(null);e.addEventListener("message",this.__onMessage.bind(this),{signal:this.__messageAC.signal})}var c=a.prototype;c.__onMessage=function(b){var d=b.data;if(d.targetName===this.sourceName)if(d.stream)this.__processStreamMessage(d);else if(d.callback){b=d.callbackId;var e=this.callbackCapabilities[b];if(!e)throw Error("Cannot resolve callback "+b);delete this.callbackCapabilities[b];if(1===d.callback)e.resolve(d.data);else if(2===d.callback)e.reject(Oc(d.reason));else throw Error("Unexpected callback case");\n}else{var g=this.actionHandler[d.action];if(!g)throw Error("Unknown action from worker: "+d.action);if(d.callbackId){var f=this.sourceName,h=d.sourceName,k=this.comObj;(new Promise(function(l){l(g(d.data))})).then(function(l){k.postMessage({sourceName:f,targetName:h,callback:1,callbackId:d.callbackId,data:l})},function(l){k.postMessage({sourceName:f,targetName:h,callback:2,callbackId:d.callbackId,reason:Oc(l)})})}else d.streamId?this.__createStreamSink(d):g(d.data)}};c.on=function(b,d){var e=this.actionHandler;\nif(e[b])throw Error(\'There is already an actionName called "\'+b+\'"\');e[b]=d};c.send=function(b,d,e){this.comObj.postMessage({sourceName:this.sourceName,targetName:this.targetName,action:b,data:d},e)};c.sendWithPromise=function(b,d,e){var g=this.callbackId++,f=Promise.withResolvers();this.callbackCapabilities[g]=f;try{this.comObj.postMessage({sourceName:this.sourceName,targetName:this.targetName,action:b,callbackId:g,data:d},e)}catch(h){f.reject(h)}return f.promise};c.sendWithStream=function(b,d,e,\ng){var f=this,h=this.streamId++,k=this.sourceName,l=this.targetName,m=this.comObj;return new ReadableStream({start:function(n){var p=Promise.withResolvers();f.streamControllers[h]={controller:n,startCall:p,pullCall:null,cancelCall:null,isClosed:!1};m.postMessage({sourceName:k,targetName:l,action:b,streamId:h,data:d,desiredSize:n.desiredSize},g);return p.promise},pull:function(n){var p=Promise.withResolvers();f.streamControllers[h].pullCall=p;m.postMessage({sourceName:k,targetName:l,stream:6,streamId:h,\ndesiredSize:n.desiredSize});return p.promise},cancel:function(n){xc(n instanceof Error,"cancel must have a valid reason");var p=Promise.withResolvers();f.streamControllers[h].cancelCall=p;f.streamControllers[h].isClosed=!0;m.postMessage({sourceName:k,targetName:l,stream:1,streamId:h,reason:Oc(n)});return p.promise}},e)};c.__createStreamSink=function(b){var d=b.streamId,e=this.sourceName,g=b.sourceName,f=this.comObj,h=this,k=this.actionHandler[b.action],l={enqueue:function(m,n,p){void 0===n&&(n=1);\nif(!this.isCancelled){var q=this.desiredSize;this.desiredSize-=n;0<q&&0>=this.desiredSize&&(this.sinkCapability=Promise.withResolvers(),this.ready=this.sinkCapability.promise);f.postMessage({sourceName:e,targetName:g,stream:4,streamId:d,chunk:m},p)}},close:function(){this.isCancelled||(this.isCancelled=!0,f.postMessage({sourceName:e,targetName:g,stream:3,streamId:d}),delete h.streamSinks[d])},error:function(m){xc(m instanceof Error,"error must have a valid reason");this.isCancelled||(this.isCancelled=\n!0,f.postMessage({sourceName:e,targetName:g,stream:5,streamId:d,reason:Oc(m)}))},sinkCapability:Promise.withResolvers(),onPull:null,onCancel:null,isCancelled:!1,desiredSize:b.desiredSize,ready:null};l.sinkCapability.resolve();l.ready=l.sinkCapability.promise;this.streamSinks[d]=l;(new Promise(function(m){m(k(b.data,l))})).then(function(){f.postMessage({sourceName:e,targetName:g,stream:8,streamId:d,success:!0})},function(m){f.postMessage({sourceName:e,targetName:g,stream:8,streamId:d,reason:Oc(m)})})};\nc.__processStreamMessage=function(b){var d=b.streamId,e=this.sourceName,g=b.sourceName,f=this.comObj,h=this.streamControllers[d],k=this.streamSinks[d];switch(b.stream){case 8:b.success?h.startCall.resolve():h.startCall.reject(Oc(b.reason));break;case 7:b.success?h.pullCall.resolve():h.pullCall.reject(Oc(b.reason));break;case 6:if(!k){f.postMessage({sourceName:e,targetName:g,stream:7,streamId:d,success:!0});break}0>=k.desiredSize&&0<b.desiredSize&&k.sinkCapability.resolve();k.desiredSize=b.desiredSize;\n(new Promise(function(l){l(null==k.onPull?void 0:k.onPull())})).then(function(){f.postMessage({sourceName:e,targetName:g,stream:7,streamId:d,success:!0})},function(l){f.postMessage({sourceName:e,targetName:g,stream:7,streamId:d,reason:Oc(l)})});break;case 4:xc(h,"enqueue should have stream controller");if(h.isClosed)break;h.controller.enqueue(b.chunk);break;case 3:xc(h,"close should have stream controller");if(h.isClosed)break;h.isClosed=!0;h.controller.close();this.__deleteStreamController(h,d);\nbreak;case 5:xc(h,"error should have stream controller");h.controller.error(Oc(b.reason));this.__deleteStreamController(h,d);break;case 2:b.success?h.cancelCall.resolve():h.cancelCall.reject(Oc(b.reason));this.__deleteStreamController(h,d);break;case 1:if(!k)break;(new Promise(function(l){l(null==k.onCancel?void 0:k.onCancel(Oc(b.reason)))})).then(function(){f.postMessage({sourceName:e,targetName:g,stream:2,streamId:d,success:!0})},function(l){f.postMessage({sourceName:e,targetName:g,stream:2,streamId:d,\nreason:Oc(l)})});k.sinkCapability.reject(Oc(b.reason));k.isCancelled=!0;delete this.streamSinks[d];break;default:throw Error("Unexpected stream case");}};c.__deleteStreamController=function(){var b=er(function f(e,g){var h,k,l,m=this;return u.generator.createGenerator(f,function(n){if(1==n.nextAddress)return n.yield(Promise.allSettled([null==(h=e.startCall)?void 0:h.promise,null==(k=e.pullCall)?void 0:k.promise,null==(l=e.cancelCall)?void 0:l.promise]),2);delete m.streamControllers[g];n.jumpToEnd()})});\nreturn function(e,g){return b.apply(this,arguments)}}();c.destroy=function(){var b;null==(b=this.__messageAC)||b.abort();this.__messageAC=null};return a}(),Nz=function(){function a(b){this._msgHandler=b;this._fullRequestReader=this._contentLength=null;this._rangeRequestReaders=[]}var c=a.prototype;c.getFullReader=function(){xc(!this._fullRequestReader,"PDFWorkerStream.getFullReader can only be called once.");return this._fullRequestReader=new Lz(this._msgHandler)};c.getRangeReader=function(b,d){b=\nnew Mz(b,d,this._msgHandler);this._rangeRequestReaders.push(b);return b};c.cancelAllRequests=function(b){var d;null==(d=this._fullRequestReader)||d.cancel(b);d=u.makeIterator(this._rangeRequestReaders.slice(0));for(var e=d.next();!e.done;e=d.next())e.value.cancel(b)};return a}(),Lz=function(){function a(b){var d=this;this._msgHandler=b;this._contentLength=this.onProgress=null;this._isStreamingSupported=this._isRangeSupported=!1;this._reader=this._msgHandler.sendWithStream("GetReader").getReader();\nthis._headersReady=this._msgHandler.sendWithPromise("ReaderHeadersReady").then(function(e){d._isStreamingSupported=e.isStreamingSupported;d._isRangeSupported=e.isRangeSupported;d._contentLength=e.contentLength})}var c=a.prototype;c.read=function(){var b=kn(function e(){var g=this,f,h,k;return u.generator.createGenerator(e,function(l){if(1==l.nextAddress)return l.yield(g._reader.read(),2);f=l.yieldResult;h=f.value;return(k=f.done)?l.return({value:void 0,done:!0}):l.return({value:h.buffer,done:!1})})});\nreturn function(){return b.apply(this,arguments)}}();c.cancel=function(b){this._reader.cancel(b)};return mn(a,[{key:"headersReady",get:function(){return this._headersReady}},{key:"contentLength",get:function(){return this._contentLength}},{key:"isStreamingSupported",get:function(){return this._isStreamingSupported}},{key:"isRangeSupported",get:function(){return this._isRangeSupported}}])}(),Mz=function(){function a(b,d,e){this._msgHandler=e;this.onProgress=null;this._reader=this._msgHandler.sendWithStream("GetRangeReader",\n{begin:b,end:d}).getReader()}var c=a.prototype;c.read=function(){var b=kn(function e(){var g=this,f,h,k;return u.generator.createGenerator(e,function(l){if(1==l.nextAddress)return l.yield(g._reader.read(),2);f=l.yieldResult;h=f.value;return(k=f.done)?l.return({value:void 0,done:!0}):l.return({value:h.buffer,done:!1})})});return function(){return b.apply(this,arguments)}}();c.cancel=function(b){this._reader.cancel(b)};return mn(a,[{key:"isStreamingSupported",get:function(){return!1}}])}(),Ae=function(){function a(b){this.name=\nb;this.terminated=!1;this._capability=Promise.withResolvers()}var c=a.prototype;c.finish=function(){this._capability.resolve()};c.terminate=function(){this.terminated=!0};c.ensureNotTerminated=function(){if(this.terminated)throw Error("Worker task was terminated");};return fr(a,[{key:"finished",get:function(){return this._capability.promise}}])}(),pn=function(){function a(){}a.setup=function(c,b){var d=!1;c.on("test",function(e){d||(d=!0,c.send("test",e instanceof Uint8Array))});c.on("configure",\nfunction(e){e=e.verbosity;Number.isInteger(e)&&(Wf=e)});c.on("GetDocRequest",function(e){return a.createDocumentHandler(e,b)})};a.createDocumentHandler=function(c,b){function d(){if(m)throw Error("Worker was terminated");}function e(y){y.finish();p.delete(y)}function g(y){return f.apply(this,arguments)}function f(){f=Jg(function z(x){var A,B,C,D,E,G,J,F,L;return u.generator.createGenerator(z,function(M){switch(M.nextAddress){case 1:return M.yield(l.ensureDoc("checkHeader"),2);case 2:return M.yield(l.ensureDoc("parseStartXRef"),\n3);case 3:return M.yield(l.ensureDoc("parse",[x]),4);case 4:return M.yield(l.ensureDoc("checkFirstPage",[x]),5);case 5:return M.yield(l.ensureDoc("checkLastPage",[x]),6);case 6:return M.yield(l.ensureDoc("isPureXfa"),7);case 7:A=M.yieldResult;if(!A){M.jumpTo(8);break}B=new Ae("loadXfaFonts");p.add(B);return M.yield(Promise.all([l.loadXfaFonts(w,B).catch(function(){}).then(function(){return e(B)}),l.loadXfaImages()]),8);case 8:return C=u,D=C.makeIterator,M.yield(Promise.all([l.ensureDoc("numPages"),\nl.ensureDoc("fingerprints")]),10);case 10:E=D.call(C,M.yieldResult);G=E.next().value;J=E.next().value;if(!A){F=null;M.jumpTo(11);break}return M.yield(l.ensureDoc("htmlForXfa"),12);case 12:F=M.yieldResult;case 11:return L=F,M.return({numPages:G,fingerprints:J,htmlForXfa:L})}})});return f.apply(this,arguments)}function h(y){var x=y.data,z=y.length,A={source:null,disableAutoFetch:y.disableAutoFetch,docBaseUrl:y.docBaseUrl,docId:t,enableXfa:y.enableXfa,evaluatorOptions:y.evaluatorOptions,handler:w,length:z,\npassword:y.password,rangeChunkSize:y.rangeChunkSize},B=Promise.withResolvers();if(x){try{A.source=x;var C=new bp(A);B.resolve(C)}catch(F){B.reject(F)}return B.promise}var D=[],E=0;try{var G=new Nz(w)}catch(F){return B.reject(F),B.promise}var J=G.getFullReader();J.headersReady.then(function(){if(J.isRangeSupported){A.source=G;A.length=J.contentLength;A.disableAutoFetch||(A.disableAutoFetch=J.isStreamingSupported);C=new Kz(A);for(var F=u.makeIterator(D),L=F.next();!L.done;L=F.next())C.sendProgressiveData(L.value);\nD=[];B.resolve(C);n=null}}).catch(function(F){B.reject(F);n=null});(new Promise(function(F,L){function M(W){var Q=W.value;W=W.done;try{if(d(),W){if(!C){var la=lk(D);D=[];z&&la.length!==z&&T("reported HTTP length is different from actual");A.source=la;C=new bp(A);B.resolve(C)}n=null}else E+=Q.byteLength,J.isStreamingSupported||w.send("DocProgress",{loaded:E,total:Math.max(E,J.contentLength||0)}),C?C.sendProgressiveData(Q):D.push(Q),J.read().then(M,L)}catch(ta){L(ta)}}J.read().then(M,L)})).catch(function(F){B.reject(F);\nn=null});n=function(F){G.cancelAllRequests(F)};return B.promise}function k(y){function x(B){d();w.send("GetDoc",{pdfInfo:B})}function z(B){d();if(B instanceof Hg){var C=new Ae("PasswordException: response "+B.code);p.add(C);w.sendWithPromise("PasswordRequest",B).then(function(D){D=D.password;e(C);l.updatePassword(D);A()}).catch(function(){e(C);w.send("DocException",B)})}else B instanceof Kg||B instanceof gn||B instanceof hn||B instanceof Ig?w.send("DocException",B):w.send("DocException",new Ig(B.message,\nB.toString()))}function A(){d();g(!1).then(x,function(B){d();B instanceof Oe?l.requestLoadedStream().then(function(){d();g(!0).then(x,z)}):z(B)})}d();h(y).then(function(B){if(m)throw B.terminate(new rc("Worker was terminated.")),Error("Worker was terminated");l=B;l.requestLoadedStream(!0).then(function(C){w.send("DataLoaded",{length:C.bytes.byteLength})})}).then(A,z)}var l,m=!1,n=null,p=new Set,q=Wf,r=c,t=r.docId;r=r.apiVersion;if("4.8.73"!==r)throw Error(\'The API version "\'+r+\'" does not match the Worker version "4.8.73".\');\nr=[];for(var v in[])r.push(v);if(r.length)throw Error("The `Array.prototype` contains unexpected enumerable properties: "+r.join(", ")+"; thus breaking e.g. `for...in` iteration of `Array`s.");v=t+"_worker";var w=new cp(v,t,b);w.on("GetPage",function(y){return l.getPage(y.pageIndex).then(function(x){return Promise.all([l.ensure(x,"rotate"),l.ensure(x,"ref"),l.ensure(x,"userUnit"),l.ensure(x,"view")]).then(function(z){var A,B=u.makeIterator(z);z=B.next().value;var C=B.next().value,D=B.next().value;\nB=B.next().value;return{rotate:z,ref:C,refStr:null!=(A=null==C?void 0:C.toString())?A:null,userUnit:D,view:B}})})});w.on("GetPageIndex",function(y){y=Ha.get(y.num,y.gen);return l.ensureCatalog("getPageIndex",[y])});w.on("GetDestinations",function(){return l.ensureCatalog("destinations")});w.on("GetDestination",function(y){return l.ensureCatalog("getDestination",[y.id])});w.on("GetPageLabels",function(){return l.ensureCatalog("pageLabels")});w.on("GetPageLayout",function(){return l.ensureCatalog("pageLayout")});\nw.on("GetPageMode",function(){return l.ensureCatalog("pageMode")});w.on("GetViewerPreferences",function(){return l.ensureCatalog("viewerPreferences")});w.on("GetOpenAction",function(){return l.ensureCatalog("openAction")});w.on("GetAttachments",function(){return l.ensureCatalog("attachments")});w.on("GetDocJSActions",function(){return l.ensureCatalog("jsActions")});w.on("GetPageJSActions",function(y){return l.getPage(y.pageIndex).then(function(x){return l.ensure(x,"jsActions")})});w.on("GetOutline",\nfunction(){return l.ensureCatalog("documentOutline")});w.on("GetOptionalContentConfig",function(){return l.ensureCatalog("optionalContentConfig")});w.on("GetPermissions",function(){return l.ensureCatalog("permissions")});w.on("GetMetadata",function(){return Promise.all([l.ensureDoc("documentInfo"),l.ensureCatalog("metadata")])});w.on("GetMarkInfo",function(){return l.ensureCatalog("markInfo")});w.on("GetData",function(){return l.requestLoadedStream().then(function(y){return y.bytes})});w.on("GetAnnotations",\nfunction(y){var x=y.pageIndex,z=y.intent;return l.getPage(x).then(function(A){var B=new Ae("GetAnnotations: page "+x);p.add(B);return A.getAnnotationsData(w,B,z).then(function(C){e(B);return C},function(C){e(B);throw C;})})});w.on("GetFieldObjects",function(){return l.ensureDoc("fieldObjects").then(function(y){return(null==y?void 0:y.allFields)||null})});w.on("HasJSActions",function(){return l.ensureDoc("hasJSActions")});w.on("GetCalculationOrderIds",function(){return l.ensureDoc("calculationOrderIds")});\nw.on("SaveDocument",function(){var y=Jg(function A(z){var B,C,D,E,G,J,F,L,M,W,Q,la,ta,qa,va,S,da,R,Y,fa,H,U,N,ba,aa,X,ha,ma,V,ea,za,Ia,wa,Aa,Ja,Sa,Wa,La,vb,eb,Xa;return u.generator.createGenerator(A,function(Na){switch(Na.nextAddress){case 1:return B=z,C=B.isPureXfa,D=B.numPages,E=B.annotationStorage,G=B.filename,J=[l.requestLoadedStream(),l.ensureCatalog("acroForm"),l.ensureCatalog("acroFormRef"),l.ensureDoc("startXRef"),l.ensureDoc("xref"),l.ensureDoc("linearization"),l.ensureCatalog("structTreeRoot")],\nF=[],L=C?null:pk(E),M=u,W=M.makeIterator,Na.yield(Promise.all(J),2);case 2:Q=W.call(M,Na.yieldResult);la=Q.next().value;ta=Q.next().value;qa=Q.next().value;va=Q.next().value;S=Q.next().value;da=Q.next().value;R=Q.next().value;Y=S.trailer.getRaw("Root")||null;if(!L){Na.jumpTo(3);break}return R?Na.yield(R.canUpdateStructTree({pdfManager:l,xref:S,newAnnotationsByPage:L}),6):Na.yield(Bj.canCreateStructureTree({catalogRef:Y,pdfManager:l,newAnnotationsByPage:L}),7);case 6:Na.yieldResult&&(fa=R);Na.jumpTo(5);\nbreak;case 7:Na.yieldResult&&(fa=null);case 5:H=ce.generateImages(E.values(),S,l.evaluatorOptions.isOffscreenCanvasSupported);U=void 0===fa?F:[];N=u.makeIterator(L);ba=N.next();for(aa={};!ba.done;aa={pageIndex$jscomp$21:void 0,annotations$jscomp$10:void 0},ba=N.next())X=ba.value,ha=u.makeIterator(X),aa.pageIndex$jscomp$21=ha.next().value,aa.annotations$jscomp$10=ha.next().value,U.push(l.getPage(aa.pageIndex$jscomp$21).then(function(hb){return function(Kb){var Za=new Ae("Save (editor): page "+hb.pageIndex$jscomp$21);\nreturn Kb.saveNewAnnotations(w,Za,hb.annotations$jscomp$10,H).finally(function(){e(Za)})}}(aa)));null===fa?F.push(Promise.all(U).then(function(){var hb=Jg(function mc(Za){return u.generator.createGenerator(mc,function(tb){return 1==tb.nextAddress?tb.yield(Bj.createStructureTree({newAnnotationsByPage:L,xref:S,catalogRef:Y,pdfManager:l,newRefs:Za}),2):tb.return(Za)})});return function(Za){return hb.apply(this,arguments)}}())):fa&&F.push(Promise.all(U).then(function(){var hb=Jg(function mc(Za){return u.generator.createGenerator(mc,\nfunction(tb){return 1==tb.nextAddress?tb.yield(fa.updateStructureTree({newAnnotationsByPage:L,pdfManager:l,newRefs:Za}),2):tb.return(Za)})});return function(Za){return hb.apply(this,arguments)}}()));case 3:if(C)F.push(l.serializeXfaData(E));else for(ma={pageIndex$jscomp$22:0};ma.pageIndex$jscomp$22<D;ma={pageIndex$jscomp$22:ma.pageIndex$jscomp$22},ma.pageIndex$jscomp$22++)F.push(l.getPage(ma.pageIndex$jscomp$22).then(function(hb){return function(Kb){var Za=new Ae("Save: page "+hb.pageIndex$jscomp$22);\nreturn Kb.save(w,Za,E).finally(function(){e(Za)})}}(ma)));return Na.yield(Promise.all(F),8);case 8:V=Na.yieldResult;ea=[];za=null;if(C){if(za=V[0],!za)return Na.return(la.bytes)}else if(ea=V.flat(2),0===ea.length)return Na.return(la.bytes);Ia=qa&&ta instanceof ca&&ea.some(function(hb){return hb.needAppearances});wa=ta instanceof ca&&ta.get("XFA")||null;Aa=null;Ja=!1;if(Array.isArray(wa)){Sa=0;for(Wa=wa.length;Sa<Wa;Sa+=2)"datasets"===wa[Sa]&&(Aa=wa[Sa+1],Ja=!0);null===Aa&&(Aa=S.getNewTemporaryRef())}else wa&&\nT("Unsupported XFA type.");La=Object.create(null);S.trailer&&(eb=Object.create(null),Xa=S.trailer.get("Info")||null,Xa instanceof ca&&Xa.forEach(function(hb,Kb){"string"===typeof Kb&&(eb[hb]=ib(Kb))}),La={rootRef:Y,encryptRef:S.trailer.getRaw("Encrypt")||null,newRef:S.getNewTemporaryRef(),infoRef:S.trailer.getRaw("Info")||null,info:eb,fileIds:S.trailer.get("ID")||null,startXRef:da?va:null!=(vb=S.lastXRefStreamPos)?vb:va,filename:G});return Na.return(Gq({originalData:la.bytes,xrefInfo:La,newRefs:ea,\nxref:S,hasXfa:!!wa,xfaDatasetsRef:Aa,hasXfaDatasetsEntry:Ja,needAppearances:Ia,acroFormRef:qa,acroForm:ta,xfaData:za,useXrefStream:ik(S.topDict,"XRef")}).finally(function(){S.resetNewTemporaryRef()}))}})});return function(z){return y.apply(this,arguments)}}());w.on("GetOperatorList",function(y,x){var z=y.pageIndex;l.getPage(z).then(function(A){var B=new Ae("GetOperatorList: page "+z);p.add(B);var C=q>=ef.INFOS?Date.now():0;A.getOperatorList({handler:w,sink:x,task:B,intent:y.intent,cacheKey:y.cacheKey,\nannotationStorage:y.annotationStorage,modifiedIds:y.modifiedIds}).then(function(D){e(B);C&&Ya("page="+(z+1)+" - getOperatorList: time="+(Date.now()-C+"ms, len="+D.length));x.close()},function(D){e(B);B.terminated||x.error(D)})})});w.on("GetTextContent",function(y,x){var z=y.pageIndex,A=y.includeMarkedContent,B=y.disableNormalization;l.getPage(z).then(function(C){var D=new Ae("GetTextContent: page "+z);p.add(D);var E=q>=ef.INFOS?Date.now():0;C.extractTextContent({handler:w,task:D,sink:x,includeMarkedContent:A,\ndisableNormalization:B}).then(function(){e(D);E&&Ya("page="+(z+1)+" - getTextContent: time="+(Date.now()-E+"ms"));x.close()},function(G){e(D);D.terminated||x.error(G)})})});w.on("GetStructTree",function(y){return l.getPage(y.pageIndex).then(function(x){return l.ensure(x,"getStructTree")})});w.on("FontFallback",function(y){return l.fontFallback(y.id,w)});w.on("Cleanup",function(){return l.cleanup(!0)});w.on("Terminate",function(){m=!0;var y=[];if(l){l.terminate(new rc("Worker was terminated."));var x=\nl.cleanup();y.push(x);l=null}else qi();null==n||n(new rc("Worker was terminated."));x=u.makeIterator(p);for(var z=x.next();!z.done;z=x.next())z=z.value,y.push(z.finished),z.terminate();return Promise.all(y).then(function(){w.destroy();w=null})});w.on("Ready",function(){k(c);c=null});return v};a.initializeFromPort=function(c){var b=new cp("worker","main",c);a.setup(b,c);b.send("ready",null)};return a}();"undefined"===typeof window&&"undefined"!==typeof self&&"function"===typeof self.postMessage&&"onmessage"in\nself&&pn.initializeFromPort(self);for(var dp in vf)Z[dp]=vf[dp];vf.__esModule&&Object.defineProperty(Z,"__esModule",{value:!0})})()},{}],2:[function(I,K){K.exports=I("colibrio-pdf-js-dist/legacy/build/pdf.worker")},{"colibrio-pdf-js-dist/legacy/build/pdf.worker":1}]},{},[2]);\n\nvar __lib__base64_js = (function () { var exports = {}; var module = { exports: exports }; var define = void 0; (function(d){"object"===typeof exports&&"undefined"!==typeof module?module.exports=d():"function"===typeof define&&define.amd?define([],d):("undefined"!==typeof window?window:"undefined"!==typeof global?global:"undefined"!==typeof self?self:this).lib=d()})(function(){return function(){function d(m,l,p){function h(a,b){if(!l[a]){if(!m[a]){var c="function"==typeof require&&require;if(!b&&c)return c(a,!0);if(e)return e(a,!0);b=Error("Cannot find module \'"+a+"\'");throw b.code="MODULE_NOT_FOUND",b;}b=\nl[a]={exports:{}};m[a][0].call(b.exports,function(f){return h(m[a][1][f]||f)},b,b.exports,d,m,l,p)}return l[a].exports}for(var e="function"==typeof require&&require,q=0;q<p.length;q++)h(p[q]);return h}return d}()({1:[function(d,m,l){function p(a){var b=a.length;if(0<b%4)throw Error("Invalid string. Length must be a multiple of 4");a=a.indexOf("=");-1===a&&(a=b);return[a,a===b?0:4-a%4]}l.byteLength=function(a){a=p(a);var b=a[1];return 3*(a[0]+b)/4-b};l.toByteArray=function(a){var b=p(a);var c=b[0];\nb=b[1];var f=new q(3*(c+b)/4-b),k=0,r=0<b?c-4:c,g;for(g=0;g<r;g+=4)c=e[a.charCodeAt(g)]<<18|e[a.charCodeAt(g+1)]<<12|e[a.charCodeAt(g+2)]<<6|e[a.charCodeAt(g+3)],f[k++]=c>>16&255,f[k++]=c>>8&255,f[k++]=c&255;2===b&&(c=e[a.charCodeAt(g)]<<2|e[a.charCodeAt(g+1)]>>4,f[k++]=c&255);1===b&&(c=e[a.charCodeAt(g)]<<10|e[a.charCodeAt(g+1)]<<4|e[a.charCodeAt(g+2)]>>2,f[k++]=c>>8&255,f[k++]=c&255);return f};l.fromByteArray=function(a){for(var b=a.length,c=b%3,f=[],k=0,r=b-c;k<r;k+=16383){for(var g=f,w=g.push,\nn,u=a,x=k+16383>r?r:k+16383,v=[],t=k;t<x;t+=3)n=(u[t]<<16&16711680)+(u[t+1]<<8&65280)+(u[t+2]&255),v.push(h[n>>18&63]+h[n>>12&63]+h[n>>6&63]+h[n&63]);n=v.join("");w.call(g,n)}1===c?(a=a[b-1],f.push(h[a>>2]+h[a<<4&63]+"==")):2===c&&(a=(a[b-2]<<8)+a[b-1],f.push(h[a>>10]+h[a>>4&63]+h[a<<2&63]+"="));return f.join("")};var h=[],e=[],q="undefined"!==typeof Uint8Array?Uint8Array:Array;for(d=0;64>d;++d)h[d]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[d],e["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(d)]=\nd;e[45]=62;e[95]=63},{}],2:[function(d,m){m.exports=d("base64-js")},{"base64-js":1}]},{},[2])(2)});\n return module.exports; })(); (function () { var r;function aa(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var t="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};\nfunction ba(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var u=ba(this);function w(a,b){if(b)a:{var c=u;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))break a;c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&t(c,a,{configurable:!0,writable:!0,value:b})}}\nw("Symbol",function(a){function b(f){if(this instanceof b)throw new TypeError("Symbol is not a constructor");return new c(d+(f||"")+"_"+e++,f)}function c(f,h){this.g=f;t(this,"description",{configurable:!0,writable:!0,value:h})}if(a)return a;c.prototype.toString=function(){return this.g};var d="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",e=0;return b});\nw("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=u[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&t(d.prototype,a,{configurable:!0,writable:!0,value:function(){return ca(aa(this))}})}return a});function ca(a){a={next:a};a[Symbol.iterator]=function(){return this};return a}\nfunction x(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];if(b)return b.call(a);if("number"==typeof a.length)return{next:aa(a)};throw Error(String(a)+" is not an iterable or ArrayLike");}function da(a){if(!(a instanceof Array)){a=x(a);for(var b,c=[];!(b=a.next()).done;)c.push(b.value);a=c}return a}var ea="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},fa;\nif("function"==typeof Object.setPrototypeOf)fa=Object.setPrototypeOf;else{var ha;a:{var ia={a:!0},ja={};try{ja.__proto__=ia;ha=ja.a;break a}catch(a){}ha=!1}fa=ha?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var ka=fa;\nfunction la(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return{value:b(f,a[f]),done:!1}}d=!0;return{done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e}w("Array.prototype.find",function(a){return a?a:function(b,c){a:{var d=this;d instanceof String&&(d=String(d));for(var e=d.length,f=0;f<e;f++){var h=d[f];if(b.call(c,h,f,d)){b=h;break a}}b=void 0}return b}});\nfunction ma(a,b,c){if(null==a)throw new TypeError("The \'this\' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""}w("String.prototype.startsWith",function(a){return a?a:function(b,c){var d=ma(this,b,"startsWith"),e=d.length,f=b.length;c=Math.max(0,Math.min(c|0,d.length));for(var h=0;h<f&&c<e;)if(d[c++]!=b[h++])return!1;return h>=f}});\nfunction y(a,b){return Object.prototype.hasOwnProperty.call(a,b)}\nw("WeakMap",function(a){function b(k){this.g=(g+=Math.random()+1).toString();if(k){k=x(k);for(var l;!(l=k.next()).done;)l=l.value,this.set(l[0],l[1])}}function c(){}function d(k){var l=typeof k;return"object"===l&&null!==k||"function"===l}function e(k){if(!y(k,h)){var l=new c;t(k,h,{value:l})}}function f(k){var l=Object[k];l&&(Object[k]=function(m){if(m instanceof c)return m;Object.isExtensible(m)&&e(m);return l(m)})}if(function(){if(!a||!Object.seal)return!1;try{var k=Object.seal({}),l=Object.seal({}),\nm=new a([[k,2],[l,3]]);if(2!=m.get(k)||3!=m.get(l))return!1;m.delete(k);m.set(l,4);return!m.has(k)&&4==m.get(l)}catch(n){return!1}}())return a;var h="$jscomp_hidden_"+Math.random();f("freeze");f("preventExtensions");f("seal");var g=0;b.prototype.set=function(k,l){if(!d(k))throw Error("Invalid WeakMap key");e(k);if(!y(k,h))throw Error("WeakMap key fail: "+k);k[h][this.g]=l;return this};b.prototype.get=function(k){return d(k)&&y(k,h)?k[h][this.g]:void 0};b.prototype.has=function(k){return d(k)&&y(k,\nh)&&y(k[h],this.g)};b.prototype.delete=function(k){return d(k)&&y(k,h)&&y(k[h],this.g)?delete k[h][this.g]:!1};return b});\nw("Map",function(a){function b(){var g={};return g.J=g.next=g.head=g}function c(g,k){var l=g[1];return ca(function(){if(l){for(;l.head!=g[1];)l=l.J;for(;l.next!=l.head;)return l=l.next,{done:!1,value:k(l)};l=null}return{done:!0,value:void 0}})}function d(g,k){var l=k&&typeof k;"object"==l||"function"==l?f.has(k)?l=f.get(k):(l=""+ ++h,f.set(k,l)):l="p_"+k;var m=g[0][l];if(m&&y(g[0],l))for(g=0;g<m.length;g++){var n=m[g];if(k!==k&&n.key!==n.key||k===n.key)return{id:l,list:m,index:g,C:n}}return{id:l,\nlist:m,index:-1,C:void 0}}function e(g){this[0]={};this[1]=b();this.size=0;if(g){g=x(g);for(var k;!(k=g.next()).done;)k=k.value,this.set(k[0],k[1])}}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return!1;try{var g=Object.seal({x:4}),k=new a(x([[g,"s"]]));if("s"!=k.get(g)||1!=k.size||k.get({x:4})||k.set({x:4},"t")!=k||2!=k.size)return!1;var l=k.entries(),m=l.next();if(m.done||m.value[0]!=g||"s"!=m.value[1])return!1;m=l.next();return m.done||4!=m.value[0].x||\n"t"!=m.value[1]||!l.next().done?!1:!0}catch(n){return!1}}())return a;var f=new WeakMap;e.prototype.set=function(g,k){g=0===g?0:g;var l=d(this,g);l.list||(l.list=this[0][l.id]=[]);l.C?l.C.value=k:(l.C={next:this[1],J:this[1].J,head:this[1],key:g,value:k},l.list.push(l.C),this[1].J.next=l.C,this[1].J=l.C,this.size++);return this};e.prototype.delete=function(g){g=d(this,g);return g.C&&g.list?(g.list.splice(g.index,1),g.list.length||delete this[0][g.id],g.C.J.next=g.C.next,g.C.next.J=g.C.J,g.C.head=null,\nthis.size--,!0):!1};e.prototype.clear=function(){this[0]={};this[1]=this[1].J=b();this.size=0};e.prototype.has=function(g){return!!d(this,g).C};e.prototype.get=function(g){return(g=d(this,g).C)&&g.value};e.prototype.entries=function(){return c(this,function(g){return[g.key,g.value]})};e.prototype.keys=function(){return c(this,function(g){return g.key})};e.prototype.values=function(){return c(this,function(g){return g.value})};e.prototype.forEach=function(g,k){for(var l=this.entries(),m;!(m=l.next()).done;)m=\nm.value,g.call(k,m[1],m[0],this)};e.prototype[Symbol.iterator]=e.prototype.entries;var h=0;return e});\nw("Set",function(a){function b(c){this.g=new Map;if(c){c=x(c);for(var d;!(d=c.next()).done;)this.add(d.value)}this.size=this.g.size}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return!1;try{var c=Object.seal({x:4}),d=new a(x([c]));if(!d.has(c)||1!=d.size||d.add(c)!=d||1!=d.size||d.add({x:4})!=d||2!=d.size)return!1;var e=d.entries(),f=e.next();if(f.done||f.value[0]!=c||f.value[1]!=c)return!1;f=e.next();return f.done||f.value[0]==c||4!=f.value[0].x||\nf.value[1]!=f.value[0]?!1:e.next().done}catch(h){return!1}}())return a;b.prototype.add=function(c){c=0===c?0:c;this.g.set(c,c);this.size=this.g.size;return this};b.prototype.delete=function(c){c=this.g.delete(c);this.size=this.g.size;return c};b.prototype.clear=function(){this.g.clear();this.size=0};b.prototype.has=function(c){return this.g.has(c)};b.prototype.entries=function(){return this.g.entries()};b.prototype.values=function(){return this.g.values()};b.prototype.keys=b.prototype.values;b.prototype[Symbol.iterator]=\nb.prototype.values;b.prototype.forEach=function(c,d){var e=this;this.g.forEach(function(f){return c.call(d,f,f,e)})};return b});w("Math.trunc",function(a){return a?a:function(b){b=Number(b);if(isNaN(b)||Infinity===b||-Infinity===b||0===b)return b;var c=Math.floor(Math.abs(b));return 0>b?-c:c}});w("Array.prototype.values",function(a){return a?a:function(){return la(this,function(b,c){return c})}});w("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}});\nw("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length;c=c||0;for(0>c&&(c=Math.max(c+e,0));c<e;c++){var f=d[c];if(f===b||Object.is(f,b))return!0}return!1}});w("String.prototype.includes",function(a){return a?a:function(b,c){return-1!==ma(this,b,"includes").indexOf(b,c||0)}});\nw("Array.from",function(a){return a?a:function(b,c,d){c=null!=c?c:function(g){return g};var e=[],f="undefined"!=typeof Symbol&&Symbol.iterator&&b[Symbol.iterator];if("function"==typeof f){b=f.call(b);for(var h=0;!(f=b.next()).done;)e.push(c.call(d,f.value,h++))}else for(f=b.length,h=0;h<f;h++)e.push(c.call(d,b[h],h));return e}});w("Object.entries",function(a){return a?a:function(b){var c=[],d;for(d in b)y(b,d)&&c.push([d,b[d]]);return c}});function z(a){return 97<=a&&122>=a||65<=a&&90>=a}function A(a){return 48<=a&&57>=a}function na(a){return A(a)||65<=a&&70>=a||97<=a&&102>=a};function oa(){if("object"===typeof self)return self;if("object"===typeof window)return window;if("object"===typeof global)return global;throw Error("Unable to get global this");}var pa=Array.isArray;var qa=new Uint16Array(1);qa[0]=4660;new Uint8Array(qa.buffer);var B=__lib__base64_js;function C(a){var b=Error.call(this,"[colibrio.internal] "+(a||""));this.message=b.message;"stack"in b&&(this.stack=b.stack);this.errorMessage=a}var D=Error;C.prototype=ea(D.prototype);C.prototype.constructor=C;if(ka)ka(C,D);else for(var E in D)if("prototype"!=E)if(Object.defineProperties){var ra=Object.getOwnPropertyDescriptor(D,E);ra&&Object.defineProperty(C,E,ra)}else C[E]=D[E];function sa(a,b){var c=F(a.g,b);return ta(a,b,c.O,c.L,c.N,c.M)}function ta(a,b,c,d,e,f){for(var h=b>>f&15,g=(c[e]&15)+1,k=e+1,l=0,m=0,n=0,p=0;m<g;){var q=c[k+m],v=q&15;if(h===v){n=q>>4;p=0===n?1:n;break}else if(h<v){m--;l-=p;break}else n=q>>4,p=0===n?1:n,l+=p;m++}m===g&&(l-=p);h=k+g+l;p=1===p?c[h]:2===p?G(d,h):ua(d,h);return 0===n?p:ta(a,b,c,d,e+p,f-4)};function va(a,b){var c=F(a.g,b);return wa(a,b,c.O,c.L,c.N,c.M)}\nfunction wa(a,b,c,d,e,f){var h=b>>f&15,g=c[e],k=(g&15)+1,l=g>>4&3,m=e+1+(g>>6<<1),n=0,p=0;g=0;var q=-1;if(2===l)h&1?(n=1,p=c[m]>>4&15,g=c[m+1]>>4&15):g=c[m]>>4&15;else{for(;n<k;){var v=c[m+n],K=v&15;if(h<K){n--;p-=g;break}else if(g=v>>4&15,15===g&&(q++,g=c[e+1+(q<<1)]),h===K)break;else p+=g;n++}n===k&&(n--,p-=g)}m+=k;h=m+p;1!==l?(m+=n,h+=k):h++;n=c[m];k=n&7;l=!!(n&8);if(1===k||2===k||3===k)return H(k,l,null);n>>=4;15===n&&(n=c[e+2+(q<<1)]);q=[];if(n)for(g/=n,p=0;p<n;p++){switch(g){case 1:m=c[h++];\nbreak;case 2:m=G(d,h);h+=2;break;default:m=ua(d,h),h+=3}q.push(m)}if(0===k)return wa(a,b,c,d,e+q[0],f-4);if(4===k||5===k)return H(k,l,q);if(6===k)return q[0]=b+q[0],H(5,l,q);q[0]=b-q[0];return H(5,l,q)}function H(a,b,c){return{T:b,type:a,values:c}};function xa(a,b){var c=F(a.g,b);return ya(a,b,c.O,c.L,c.N,c.M)}function ya(a,b,c,d,e,f){for(var h=b>>f&15,g=(c[e]&15)+1,k=e+1,l=0,m=0,n=0,p=0;m<g;){var q=c[k+m],v=q&15;if(h===v){n=q>>4;p=6===n?1:7===n?2:0;break}else if(h<v){m--;l-=p;break}else n=q>>4,p=6===n?1:7===n?2:0,l+=p;m++}m===g&&(l-=p);if(!p)return n;h=k+g+l;return ya(a,b,c,d,e+(1===p?c[h]:G(d,h)),f-4)};function za(a,b,c,d,e,f){for(var h=b>>f&15,g=(c[e]&15)+1,k=e+1,l=0,m=0,n=0,p=0;m<g;){var q=c[k+m],v=q&15;if(h===v){n=q>>4&3;p=q>>6;break}else if(h<v){m--;l-=p;break}else n=q>>4&3,p=q>>6,l+=p;m++}m===g&&(l-=p);if(0===n)return!1;if(1===n)return!0;h=k+g+l;return za(a,b,c,d,e+(1===p?c[h]:G(d,h)),f-4)};function Aa(a){this.g=a}function G(a,b){return a.g[b]+(a.g[b+1]<<8)}function ua(a,b){return a.g[b]+(a.g[b+1]<<8)+(a.g[b+2]<<16)};function I(a){this.h=a;this.g=new Aa(a)}function F(a,b){if(255>=b){b=0;var c=4}else 65535>=b?(b=1,c=12):(b=2,c=20);return{L:a.g,M:c,N:G(a.g,2*b),O:a.h}};var Ba=!1,Ca=new Set,J=[32,34,60,62,96],Da=new Set(J);J.push(35,63,123,125);var Ea=new Set(J);J.push(47,58,59,61,64,91,92,93,94,124);var Fa=new Set(J);function Ga(a){return 57>=a?a-48:70>=a?a-65+10:a-97+10}function L(a){if(2048>a.length)return String.fromCharCode.apply(null,a);for(var b="",c=0;c+2048<a.length;){var d=c+2048;b+=String.fromCharCode.apply(null,a.slice(c,d));c=d}return b+String.fromCharCode.apply(null,a.slice(c))}\nfunction Ha(a){for(var b=[],c=0;c<a.length;c++){var d=a[c];65535>=d?b.push(d):(d-=65536,b.push((d>>10)+55296,d%1024+56320))}return b}function Ia(a){return 10>a?a+48:a+65-10}function Ja(a){for(var b=a.length,c=new Uint8Array(b),d=0,e=0;e<b;e++){var f=a[e];37!==f?c[d++]=f:2<b-e&&na(a[e+1])&&na(a[e+2])?(f=16*Ga(a[e+1])+Ga(a[e+2]),c[d++]=f,e+=2):c[d++]=f}return Ka.decode(d<b?c.subarray(0,d):c)}function M(a,b){a.push(37);16>b?a.push(48,Ia(b)):a.push(Ia(b>>4),Ia(b&15))}\nfunction La(a,b){return 31>=b||126<b||a.has(b)}function Ma(a){for(var b=[],c=a.length,d=0;d<c;d++){var e=a.charCodeAt(d);if(55296>e||57343<e)b.push(e);else if(56320<=e||1===c-d)b.push(65533);else{var f=a.charCodeAt(d+1);56320<=f&&57343>=f?(b.push(1024*(e-55296)+f-56320+65536),d++):b.push(65533)}}return b}function N(a){a=""+a;var b=O(a);return Ba?L(b):a}\nfunction O(a){var b=a.length,c=Array(b);Ba=!1;for(var d=0;d<b;d++){var e=a.charCodeAt(d);if(55296>e||57343<e)c[d]=e;else if(56320<=e||1===b-d)c[d]=65533,Ba=!0;else{var f=a.charCodeAt(d+1);56320<=f&&57343>=f?(c[d]=e,c[++d]=f):(c[d]=65533,Ba=!0)}}return c}\nfunction P(a){for(var b=[],c,d,e=a.length,f=0;f<e;f++){var h=a[f];if(0<=h&&127>=h)b.push(h);else for(2047>=h?(b.push((h>>6)+192),d=1):(55296<=h&&56319>=h&&(h=1024*(h-55296)+a[++f]-56320+65536),65535>=h?(d=2,c=224):(d=3,c=240),b.push((h>>6*d)+c));0<d;)d--,b.push(h>>6*d&63|128)}return b}var Ka=new TextDecoder;function Na(a){var b=128,c=0,d=72,e=[],f=a.lastIndexOf(45);if(0<f)for(var h=0;h<f;h++){var g=a[h];if(127<g)return null;e.push(g)}for(f=f&&f+1;f<a.length;){h=c;g=1;for(var k=36;;k+=36){if(f>=a.length)return null;var l=a[f++];l=65<=l&&90>=l?l-65:97<=l&&122>=l?l-97:A(l)?l-48+26:-1;if(-1===l)return null;c+=l*g;if(2147483647<c)return null;var m=k<=d?1:k>=d+26?26:k-d;if(l<m)break;g*=36-m;if(2147483647<g)return null}d=Oa(c-h,e.length+1,!h);b+=Math.trunc(c/(e.length+1));if(2147483647<b)return null;c%=e.length+\n1;e.splice(c++,0,b)}return e}function Oa(a,b,c){a=c?Math.trunc(a/700):a>>1;a+=Math.trunc(a/b);for(b=0;455<a;b+=36)a=Math.trunc(a/35);return b+Math.trunc(36*a/(a+38))};function Pa(a,b,c,d,e){this.j=a;this.A=b;this.u=c;this.h=d;this.i=e;this.g=null;String.prototype.normalize||(this.g=new URL("http://a.com"))}\nfunction Qa(a,b){var c={aa:!0,ba:!1,R:!0,U:!1,V:!1,P:!1};a=Ra(a,b,c);if(!a)return null;for(b=0;b<a.length;b++){var d=a[b],e;a:{for(e=0;e<d.length;e++)if(127<d[e]){e=!0;break a}e=!1}if(e){a:{e=[];for(var f=128,h=0,g=72,k=d.length,l=0,m=0;m<k;m++){var n=d[m];127>=n&&(e.push(n),l++)}0<l&&e.push(45);for(m=l;m<k;){n=1114111;for(var p=0;p<k;p++){var q=d[p];q>=f&&q<n&&(n=q)}h+=(n-f)*(m+1);if(2147483647<h){d=null;break a}f=n;for(n=0;n<k;n++){p=d[n];if(p<f&&(h++,2147483647<h)){d=null;break a}if(p===f){p=h;\nfor(q=36;;q+=36){var v=q<=g?1:q>=g+26?26:q-g;if(p<v)break;var K=v+(p-v)%(36-v);e.push(26>K?97+K:22+K);p=Math.trunc((p-v)/(36-v))}e.push(26>p?97+p:22+p);g=Oa(h,m+1,m===l);h=0;m++}}h++;f++}d=e}if(!d)return null;d.unshift(120,110,45,45);a[b]=d}}if(c.P)for(b=0;b<a.length;b++)if(d=a[b].length,1>d&&b!==a.length-1||63<d)return null;b=[];for(d=0;d<a.length;d++)b.push(L(a[d]));a=b.join(".");return c.P&&!Sa(a)?null:a}\nPa.prototype.R=function(a){for(var b=0;b<a.length;b++){var c=a[b];if(8205===c){if(0===b||!this.h.g.has(a[b-1]))return!1}else if(8204===c&&!(0<b&&this.h.g.has(a[b-1]))){c=!1;for(var d=b-1;0<=d&&!c;d--){var e=xa(this.u,a[d]);if(2===e||3===e)c=!0;else if(5!==e)break}if(!c)return!1;c=!1;for(b++;b<a.length&&!c;b++)if(d=xa(this.u,a[b]),1===d||3===d)c=!0;else if(5!==d)break;if(!c)return!1}}return!0};\nfunction Ta(a,b,c){var d=b.length;if(!d)return c;c=Array(d);for(var e=0;e<d;e++)c[e]=sa(a.i,b[e]);if(0===c[0])a=!1;else if(1===c[0]||2===c[0])a=!0;else return!1;if(a){for(a=0;a<d;a++)switch(c[a]){case 1:case 2:case 6:case 3:case 4:case 7:case 5:case 13:case 9:case 8:break;default:return!1}a=!1;for(b=d-1;0<=b;b--){e=c[b];if(1===e||2===e||3===e||6===e){a=!0;break}if(8!==e)break}if(!a)return!1;b=a=!1;for(e=0;e<d;e++){var f=c[e];3===f?a=!0:6===f&&(b=!0)}if(a&&b)return!1}else{for(a=0;a<d;a++)switch(c[a]){case 0:case 3:case 4:case 7:case 5:case 13:case 9:case 8:break;\ndefault:return!1}a=!1;for(--d;0<=d;d--){b=c[d];if(0===b||3===b){a=!0;break}if(8!==b)break}if(!a)return!1}return!0}function Ua(a,b,c,d,e){if(!c.length)return!0;if(!(b=b&&b.normalize&&b.normalize("NFC")!==b||d.ba&&(3<c.length&&45===c[2]&&45===c[3]||45===c[0]||45===c[c.length-1])||c.includes(46))){b=a.A;var f=c[0],h=F(b.g,f);b=za(b,f,h.O,h.L,h.N,h.M)}if(b)return!1;for(b=0;b<c.length;b++)if(f=va(a.j,c[b]),e&&1!==f.type||!e&&1!==f.type&&4!==f.type||d.V&&f.T)return!1;return d.R&&!a.R(c)?!1:!0}\nfunction Ra(a,b,c){a:{for(var d=c.U,e=c.V,f=[],h=0;h<b.length;h++){var g=b[h],k=va(a.j,g);if(e&&k.T){b=null;break a}switch(k.type){case 1:f.push(g);break;case 2:b=null;break a;case 4:d?k.values&&0<k.values.length&&f.push.apply(f,da(k.values)):f.push(g);break;case 5:f.push.apply(f,da(k.values))}}b=f}if(!b)return null;b=L(Ha(b));if(a.g&&"a.a"!==b){if(a.g.hostname=b,b=a.g.hostname,a.g.hostname="a.a","a.a"===b)return null}else b=b.normalize("NFC");if(c.P&&!Sa(b))return null;d=b.split(".");h=!1;b=[];for(e=\n0;e<d.length;e++){g=d[e];if(c.P&&(1>g.length&&e!==d.length-1||63<g.length))return null;if(g.startsWith("xn--")){f=Na(Ma(g.slice(4)));if(!f)return null;g=L(Ha(f));g=Ua(a,g,f,c,!1)}else f=Ma(g),g=Ua(a,null,f,c,c.U);if(!g)return null;if(!h)a:{for(h=0;h<f.length;h++)if(g=sa(a.i,f[h]),1===g||2===g||6===g){h=!0;break a}h=!1}b.push(f)}if(h&&c.aa)for(c=0;c<b.length;c++)if(!Ta(a,b[c],c===b.length-1))return null;return b}function Sa(a){var b=a.length;return 1<=b&&(253>=b||46===a.charCodeAt(b-1)&&254>=b)};function Va(a,b,c,d,e){for(;d<e;d+=c)a.g.add(2===c?G(b,d):ua(b,d))};var Wa=null;var Q={W:B.toByteArray("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"),\nX:B.toByteArray("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"),\nY:B.toByteArray("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"),\nZ:B.toByteArray("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"),\n$:B.toByteArray("BgAGAEgATQnNCU0KzQpNC80LTQzNDDsNPA1NDcoNOg66DoQPORA6EBQXNBfSF2AaRBuqG6sb8hvzG38tBqjEqFOpwKn2qu2rPwoBRhABfxABuRABMxEBNBEBwBEBNRIB6hIBTRMBQhQBwhQBvxUBPxYBthYBKxcBORgB4BkBNBoBRxoBmRoBPxwBRB0BRR0Blx0B")};Wa=new Pa(new function(a){this.g=a}(new I(Q.X)),new function(a){this.g=a}(new I(Q.Z)),new function(a){this.g=a}(new I(Q.Y)),new function(a){this.g=new Set;a=a.g;var b=G(a,4);Va(this,a,2,G(a,2),b);Va(this,a,3,b,a.g.length)}(new I(Q.$)),new function(a){this.g=a}(new I(Q.W)));function Xa(){if(!Wa)throw new C("Uts46 instance not set.");this.ca=Wa;this.j=null;this.A=!1;this.S=new Uint16Array(0);this.u=this.h=this.i=this.K=0;this.g=null}var Ya;function R(){Ya||(Ya=new Xa);return Ya}\nXa.prototype.parse=function(a,b,c,d){if(1E6<a.length)return null;var e=0,f=a.length;if(c)this.g=c;else if(this.g={H:!1,I:null,l:null,B:!1,s:!1,F:"",m:[],v:-1,o:null,G:"",D:""},e<f&&(Za(a.charCodeAt(e))||Za(a.charCodeAt(f-1)))){for(;e<f&&Za(a.charCodeAt(e));e++);for(;f>e&&Za(a.charCodeAt(f-1));f--);}c=new Uint16Array(f-e);for(var h=0;e<f;e++){var g=a.charCodeAt(e);if(55296>g||57343<g)9===g||10===g||13===g||(c[h++]=g);else if(56320<=g||1===f-e)c[h++]=65533;else{var k=a.charCodeAt(e+1);56320<=k&&57343>=\nk?(c[h++]=g,c[h++]=k,e++):c[h++]=65533}}this.j=b;this.A=!1;this.S=c;this.K=h;this.i=-1;this.h=d||1;for(this.u=d;this.i<this.K&&0!==this.h&&!this.A;)switch(this.h){case 1:z(S(this,1))?this.h=2:this.u?this.A=!0:this.h=3;break;case 2:a=[];do if(this.i++,b=S(this,0),65<=b&&90>=b)a.push(b+32);else if(97<=b&&122>=b||A(b)||43===b||45===b||46===b)a.push(b);else if(58===b){b=L(a);d=$a.has(b);e="file"===b;if(f=this.u)(f=this.g.s&&!d||!this.g.s&&d)||(f=this.g,f=(!!f.D||!!f.F||-1!==this.g.v)&&e),f=f||this.g.B&&\n!this.g.l;if(f){this.h=0;break}this.g.G=b;this.g.s=d;this.g.B=e;if(this.u){this.g.v===ab(b)&&(this.g.v=-1);this.h=0;break}e?this.h=14:d?this.h=this.j&&this.j.G===this.g.G?4:8:47===S(this,1)?(this.h=5,this.i++):(this.g.H=!0,this.g.m.push(""),this.h=19)}else if(this.u){this.A=!0;break}else this.h=3,this.i=-1;while(2===this.h);break;case 3:a=S(this,1);!this.j||this.j.H&&35!==a?this.A=!0:this.j.H&&35===a?(this.g.G=this.j.G,this.g.B=this.j.B,this.g.s=this.j.s,this.g.m=this.j.m.slice(),this.g.o=this.j.o,\nthis.g.I="",this.g.H=!0,this.h=21,this.i++):this.h=this.j.B?14:6;break;case 4:47===S(this,1)&&47===S(this,2)?(this.h=9,this.i+=2):this.h=6;break;case 5:47===S(this,1)?(this.h=10,this.i++):this.h=18;break;case 6:this.j?(this.g.G=this.j.G,this.g.B=this.j.B,this.g.s=this.j.s,this.i++,a=S(this,0),b=!0,d=!1,-1===a?this.g.o=this.j.o:47===a||this.g.s&&92===a?(b=!1,this.h=7):63===a?(this.g.o="",this.h=20):35===a?(this.g.o=this.j.o,this.g.I="",this.h=21):(d=!0,this.h=18,this.i--),b&&(this.g.D=this.j.D,this.g.F=\nthis.j.F,this.g.l=this.j.l,this.g.v=this.j.v,this.g.m=this.j.m.slice(),d&&0<this.g.m.length&&this.g.m.pop())):this.A=!0;break;case 7:this.i++;a=S(this,0);!this.g.s||47!==a&&92!==a?47===a?this.h=10:this.j?(this.g.D=this.j.D,this.g.F=this.j.F,this.g.l=this.j.l,this.g.v=this.j.v,this.h=18,this.i--):this.A=!0:this.h=9;break;case 8:47===S(this,1)&&47===S(this,2)&&(this.i+=2);this.h=9;break;case 9:do a=S(this,1),47===a||92===a?this.i++:this.h=10;while(9===this.h&&this.i<this.K);break;case 10:b=a=!1;d=[];\ndo if(this.i++,e=S(this,0),64===e){a&&d.unshift(37,52,48);a=!0;e=P(d);d=[];for(f=0;f<e.length;f++)c=e[f],58!==c||b?La(Fa,c)?M(d,c):d.push(c):(this.g.D+=L(d),d=[],b=!0);0<d.length&&(b?this.g.F+=L(d):this.g.D+=L(d),d=[])}else if(-1===e||47===e||63===e||35===e||92===e&&this.g.s){if(a&&0===d.length){this.A=!0;break}this.i-=d.length+1;this.h=11}else d.push(e);while(10===this.h);break;case 11:case 12:if(this.u&&this.g.B)this.h=16;else{a=[];b=!1;do if(this.i++,d=S(this,0),58!==d||b)if(-1===d||47===d||63===\nd||35===d||92===d&&this.g.s){this.i--;if(0===a.length&&this.g.s){this.A=!0;break}(d=this.u&&0===a.length)&&!(d=-1!==this.g.v)&&(d=this.g,d=!!d.D||!!d.F);if(d){this.h=0;break}d=bb(this,a,!this.g.s);if(null===d){this.A=!0;break}this.g.l=d;this.h=17;this.u&&(this.h=0)}else 91===d?b=!0:93===d&&(b=!1),a.push(d);else{if(0===a.length){this.A=!0;break}d=bb(this,a,!this.g.s);if(null===d){this.A=!0;break}this.g.l=d;this.h=13;12===this.u&&(this.h=0)}while(11===this.h||12===this.h)}break;case 13:a=[];do if(this.i++,\nb=S(this,0),A(b))a.push(b);else if(-1===b||47===b||63===b||35===b||this.u||92===b&&this.g.s){if(0<a.length){b=parseInt(L(a),10);if(isNaN(b)||65535<b){this.A=!0;break}ab(this.g.G)===b?this.g.v=-1:this.g.v=b}this.u?this.h=0:(this.h=17,this.i--)}else{this.A=!0;break}while(13===this.h);break;case 14:this.g.G="file";this.g.B=!0;this.g.s=!0;this.i++;a=S(this,0);if(47===a||92===a)this.h=15;else if(this.j&&this.j.B){b=!0;d=!1;switch(a){case -1:this.g.o=this.j.o;break;case 63:this.g.o="";this.h=20;break;case 35:this.g.o=\nthis.j.o;this.g.I="";this.h=21;break;default:cb(this)?b=!1:d=!0,this.h=18,this.i--}b&&(this.g.l=this.j.l,this.g.m=this.j.m.slice(),d&&db(this))}else this.h=18,this.i--;break;case 15:this.i++;a=S(this,0);47===a||92===a?this.h=16:(this.j&&this.j.B&&!cb(this)&&(a=this.j.m,0<a.length&&z(a[0].charCodeAt(0))&&58===a[0].charCodeAt(1)?this.g.m.push(a[0]):this.g.l=this.j.l),this.h=18,this.i--);break;case 16:a=[];do if(this.i++,b=S(this,0),-1===b||47===b||92===b||63===b||35===b)if(this.i--,!this.u&&eb(a))this.h=\n18,fb(this,a);else{if(0===a.length)this.g.l="";else{b=bb(this,a,!this.g.s);if(null===b){this.A=!0;break}"localhost"===b&&(b="");this.g.l=b}if(this.u){this.h=0;break}this.h=17}else a.push(b);while(16===this.h);break;case 17:this.i++;a=S(this,0);this.g.s?(this.h=18,47!==a&&92!==a&&this.i--):this.u||63!==a?this.u||35!==a?-1!==a&&(this.h=18,47!==a&&this.i--):(this.g.I="",this.h=21):(this.g.o="",this.h=20);break;case 18:fb(this,[]);break;case 19:a=[];do this.i++,b=S(this,0),63===b?(this.g.o="",this.h=\n20):35===b?(this.g.I="",this.h=21):-1!==b&&a.push(b);while(19===this.h&&this.i<this.K);0<a.length&&(a=gb(a,Ca),this.g.m[0]+=L(a));break;case 20:a=[];do this.i++,b=S(this,0),this.u||35!==b?-1!==b&&a.push(b):(this.g.I="",this.h=21);while(20===this.h&&this.i<this.K);if(0<a.length){b=P(a);d=this.g.s;a=[];for(e=0;e<b.length;e++)f=b[e],33>f||126<f||34===f||35===f||60===f||62===f||39===f&&d?M(a,f):a.push(f);this.g.o=L(a)}break;case 21:a=[];do this.i++,b=S(this,0),0<b&&a.push(b);while(21===this.h&&this.i<\nthis.K);a=gb(a,Da);this.g.I=L(a)}a=this.A?null:this.g;this.S=this.j=this.g=null;return a};function S(a,b){b+=a.i;return a.K>b?a.S[b]:-1}\nfunction fb(a,b){var c=a.g.s,d=a.g.B,e=a.g.m;do{a.i++;var f=S(a,0);if(-1===f||47===f||c&&92===f||!a.u&&(63===f||35===f)){if(b.length&&46===b[0]?hb(b,1,!1):hb(b,0,!0)&&hb(b,3,!1))db(a),47===f||c&&92===f||e.push("");else{var h=hb(b,0,!1);!h||47===f||c&&92===f?h||(d&&0===e.length&&eb(b)&&(a.g.l&&(a.g.l=""),b[1]=58),b=gb(b,Ea),e.push(L(b))):e.push("")}b=[];if(d&&(-1===f||63===f||35===f))for(;1<e.length&&!e[0];)e.shift();63===f?(a.g.o="",a.h=20):35===f&&(a.g.I="",a.h=21)}else b.push(f)}while(18===a.h&&\na.i<a.K)}\nfunction bb(a,b,c){if(91===b[0]){if(93!==b[b.length-1])return null;if(a=ib(b)){b="[";for(var d=c=-1,e=1,f=0;f<a.length;f++)a[f]?-1!==d&&(f-d>e&&(e=f-d,c=d),d=-1):-1===d&&(d=f);-1!==d&&8-d>e&&(c=d);d=!1;for(e=0;8>e;e++){if(d){if(0===a[e])continue;d=!1}c===e?(b+=0===e?"::":":",d=!0):(b+=a[e].toString(16),7!==e&&(b+=":"))}a=b+"]"}else a=null;return a}if(c){a:{a=P(b);b=[];for(c=0;c<a.length;c++){d=a[c];if(37!==d&&jb.has(d)){a=null;break a}La(Ca,d)?M(b,d):b.push(d)}a=L(b)}return a}b=P(b);b=Ja(b);b=Qa(a.ca,\nMa(b));if(!b)return null;for(a=0;a<b.length;a++)if(jb.has(b.charCodeAt(a)))return null;a=kb(b);if(-1===a)a=null;else if(-2===a)a=b;else{b=[];for(c=24;0<=c;c-=8)b.push(a>>>c&255);a=b.join(".")}return a}\nfunction kb(a){var b=a.split(".");1<b.length&&!b[b.length-1]&&b.pop();a=b.length;if(4<a)return-2;for(var c=[],d=0;d<a;d++){var e=b[d];if(!e)return-2;var f=NaN;"0"===e[0]?e.startsWith("0x")||e.startsWith("0X")?f=2<e.length?Number(e):0:2<=e.length&&/^[0-7]*$/.test(e)?f=parseInt(e,8):1===e.length&&(f=0):/^[0-9]*$/.test(e)&&(f=Number(e));if(isNaN(f))return-2;c.push(f)}for(b=0;b<a-1;b++)if(255<c[b])return-1;b=c[a-1];if(b>=Math.pow(256,5-a))return-1;for(d=0;d<a-1;d++)b+=c[d]*Math.pow(256,3-d);return b}\nfunction ib(a){var b=[0,0,0,0,0,0,0,0],c=0,d=-1,e=1,f=a[e];if(58===f){if(a.length>e+1&&58!==a[e+1])return null;e+=2;f=a[e];c++;d=c}for(;93!==f;){if(8===c)return null;if(58===f){if(-1!==d)return null;f=a[++e];d=c}else{for(var h=0,g=0;4>g&&na(f);)h=16*h+Ga(f),f=a[++e],g++;if(46===f){if(0===g)return null;e-=g;f=a[e];if(6<c)return null;for(h=0;93!==f;){g=null;if(0<h)if(46===f&&4>h)f=a[++e];else return null;if(!A(f))return null;for(;A(f);){f-=48;if(null===g)g=f;else{if(0===g)return null;g=10*g+f}if(255<\ng)return null;f=a[++e]}b[c]=256*b[c]+g;h++;2!==h&&4!==h||c++}if(4!==h)return null;break}if(58===f){if(f=a[++e],93===f)return null}else if(93!==f)return null;b[c++]=h}}if(-1!==d)for(a=c-d,c=7;0!==c&&0<a;)e=d+a-1,f=b[c],b[c]=b[e],b[e]=f,c--,a--;else if(8!==c)return null;return b}function gb(a,b){a=P(a);for(var c=[],d=0;d<a.length;d++){var e=a[d];La(b,e)?M(c,e):c.push(e)}return c}\nfunction db(a){var b=a.g.m;a.g.B&&1===b.length&&2===b[0].length&&z(b[0].charCodeAt(0))&&58===b[0].charCodeAt(1)||0<b.length&&b.pop()}function cb(a){var b=S(a,1),c=S(a,2);return z(S(a,0))&&(58===b||124===b)&&(-1===c||47===c||92===c||63===c||35===c)}var $a=new Map([["ftp",21],["file",0],["http",80],["https",443],["ws",80],["wss",443]]),jb=new Set([0,9,10,13,32,35,37,47,58,63,64,91,92,93]);function ab(a){return"file"!==a&&$a.has(a)?$a.get(a):-1}function Za(a){return 0<=a&&32>=a}\nfunction hb(a,b,c){var d=a.length-b;return(c&&0<d||!c&&1===d)&&46===a[b]||(c&&2<d||!c&&3===d)&&37===a[b]&&50===a[b+1]&&(101===a[b+2]||69===a[b+2])}function eb(a){return 2===a.length&&z(a[0])&&58===a[1]||124===a[1]};var T=Symbol(),U=Symbol(),lb=Symbol(),V=Symbol();function mb(a){a=a.split("&");for(var b=[],c=0;c<a.length;c++){for(var d=O(a[c]),e=d,f=0;f<e.length;f++)43===e[f]&&(e[f]=32);f=d.indexOf(61);-1!==f?(e=P(d.slice(0,f)),d=P(d.slice(f+1))):(e=P(d),d=[]);b.push([Ja(e),Ja(d)])}return b}function nb(a){for(var b="",c=0;c<a.length;c++){var d=a[c],e=P(O(d[0]));e=ob(e);d=P(O(d[1]));d=ob(d);0!==c&&(b+="&");b+=e+"="+d}return b}\nfunction ob(a){for(var b=[],c=0;c<a.length;c++){var d=a[c];32===d?b.push(43):42===d||45===d||46===d||A(d)||z(d)||95===d?b.push(d):M(b,d)}return L(b)};var W=Symbol();function X(a){a=pa(a)?pb(a):a&&!pa(a)&&"object"===typeof a?"function"===typeof a[Symbol.iterator]?pb(Array.from(a)):pb(Object.entries(a)):"string"===typeof a&&0<a.length?mb("?"===a[0]?a.slice(1):a):[];Object.defineProperty(this,V,{value:a,writable:!0});Object.defineProperty(this,lb,{value:null,writable:!0})}X.prototype[Symbol.iterator]=function(){return this[V][Symbol.iterator]()};r=X.prototype;r.append=function(a,b){this[V].push([N(a),N(b)]);this[W]()};\nr.delete=function(a){a=N(a);this[V]=this[V].filter(function(b){return b[0]!==a});this[W]()};r.entries=function(){return this[V][Symbol.iterator]()};r.forEach=function(a,b){for(var c=this[V],d=0;d<c.length;d++){var e=c[0];a.call(b,e[1],e[0],this)}};r.get=function(a){a=N(a);var b=this[V].find(function(c){return c[0]===a});return b?b[1]:null};r.getAll=function(a){a=N(a);for(var b=[],c=this[V],d=0;d<c.length;d++){var e=c[d];e[0]===a&&b.push(e[1])}return b};r.has=function(a){return null!==this.get(a)};\nr.keys=function(){return this[V].map(function(a){a=x(a);var b=a.next().value;a.next();return b})[Symbol.iterator]()};r.set=function(a,b){a=N(a);b=N(b);var c=this[V],d=c.find(function(e){return e[0]===a});d?d[1]=b:c.push([a,b]);this[W]()};r.sort=function(){this[V].sort(function(a,b){return a[0]<b[0]?-1:a[0]>b[0]?1:0});this[W]()};r.toString=function(){return nb(this[V])};r.values=function(){return this[V].map(function(a){a=x(a);a.next();return a.next().value})[Symbol.iterator]()};\nX.prototype[W]=function(){var a=this[lb];if(a){var b=nb(this[V]);if(a=a[T])a.o=b||null}};u.Object.defineProperties(X.prototype,{size:{configurable:!0,enumerable:!0,get:function(){return this[V].length}}});function pb(a){var b=[];a=x(a);for(var c=a.next();!c.done;c=a.next()){c=c.value;if(!pa(c)||2!==c.length)throw new TypeError("Failed to construct URLSearchParams: Sequence initializer must only contain pair elements");b.push([N(c[0]),N(c[1])])}return b};function Y(a,b){if(!(this instanceof Y))throw new TypeError("Failed to construct URL: Please use the new operator");var c=null;if("undefined"!==typeof b)if(b instanceof Y)c=b[T];else if(c=R().parse(""+b,null,null,0),!c)throw new TypeError("Failed to construct URL: Invalid base URL");a=R().parse(""+a,c,null,0);if(!a)throw new TypeError("Failed to construct URL: Invalid URL");Object.defineProperty(this,T,{value:a,writable:!0});Object.defineProperty(this,U,{value:null,writable:!0})}\nY.canParse=function(a,b){try{return new Y(a,b),!0}catch(c){return!1}};Y.parse=function(a,b){try{return new Y(a,b)}catch(c){return null}};Y.prototype.toJSON=function(){return this.href};Y.prototype.toString=function(){return this.href};\nu.Object.defineProperties(Y.prototype,{hash:{configurable:!0,enumerable:!0,get:function(){var a=this[T].I;return a?"#"+a:""},set:function(a){var b=this[T];a?("#"===a[0]&&(a=a.slice(1)),R().parse(a,null,b,21)):b.I=null}},host:{configurable:!0,enumerable:!0,get:function(){var a=this[T];return null===a.l?"":-1===a.v?a.l:a.l+":"+a.v},set:function(a){var b=this[T];b.H||R().parse(a,null,b,11)}},hostname:{configurable:!0,enumerable:!0,get:function(){return this[T].l||""},set:function(a){var b=this[T];b.H||\nR().parse(a,null,b,12)}},href:{configurable:!0,enumerable:!0,get:function(){var a=this[T],b=a.G+":";if(null!==a.l){b+="//";if(a.D||a.F)b+=a.D,a.F&&(b+=":"+a.F),b+="@";b+=a.l;-1!==a.v&&(b+=":"+a.v)}else a.B&&(b+="//");if(a.H&&0<a.m.length)var c=a.m[0];else{c="";for(var d=a.m,e=0;e<d.length;e++)c+="/"+d[e]}b+=c;null!==a.o&&(b+="?"+a.o);null===a.I||(b+="#"+a.I);return b},set:function(a){a=R().parse(a,null,null,0);if(!a)throw new TypeError("Failed to set URL.href: Invalid URL");this[T]=a;this[U]=null}},\norigin:{configurable:!0,enumerable:!0,get:function(){return qb(this[T])}},password:{configurable:!0,enumerable:!0,get:function(){return this[T].F},set:function(a){var b=this[T];!b.l||b.H||b.B||(b.F=rb(a))}},pathname:{configurable:!0,enumerable:!0,get:function(){var a=this[T];return a.H?0<a.m.length?a.m[0]:"":0<a.m.length?"/"+a.m.join("/"):""},set:function(a){var b=this[T];b.H||(b.m=[],R().parse(a,null,b,17))}},port:{configurable:!0,enumerable:!0,get:function(){var a=this[T].v;return-1===a?"":""+a},\nset:function(a){var b=this[T];!b.l||b.H||b.B||(a?R().parse(a,null,b,13):b.v=-1)}},protocol:{configurable:!0,enumerable:!0,get:function(){return this[T].G+":"},set:function(a){R().parse(a+":",null,this[T],1)}},search:{configurable:!0,enumerable:!0,get:function(){var a=this[T].o;return a?"?"+a:""},set:function(a){var b=this[T];a?("?"===a[0]&&(a=a.slice(1)),b.o="",R().parse(a,null,b,20),(a=this[U])&&(a[V]=mb(b.o))):(b.o=null,(b=this[U])&&(b[V]=[]))}},searchParams:{configurable:!0,enumerable:!0,get:function(){if(!this[U]){var a=\nthis[T].o;a=a?mb(a):[];var b=this[U]=new X;b[V]=a;b[lb]=this}return this[U]}},username:{configurable:!0,enumerable:!0,get:function(){return this[T].D},set:function(a){var b=this[T];!b.l||b.H||b.B||(b.D=rb(a))}}});function qb(a){switch(a.G){case "blob":var b=(a=R().parse(a.m[0],null,null,0))?qb(a):"null";break;case "ftp":case "http":case "https":case "ws":case "wss":b=a.G+"://"+a.l;-1!==a.v&&(b+=":"+a.v);break;default:b="null"}return b}\nfunction rb(a){a=P(O(a));for(var b=[],c=0;c<a.length;c++){var d=a[c];La(Fa,d)?M(b,d):b.push(d)}return L(b)};var sb=new ArrayBuffer(8);new DataView(sb);new Uint8Array(sb);var Z=null;"function"===typeof URL?Z=URL:"function"===typeof webkitURL&&(Z=webkitURL);Z&&(Y.createObjectURL=Z.createObjectURL,Y.revokeObjectURL=Z.revokeObjectURL);try{var tb=oa();tb&&(tb.URL=Y,tb.URLSearchParams=X)}catch(a){console.error("Failed to polyfill URL and URLSearchParams"),console.error(a)}; }).call(__self); })(typeof self !== \'undefined\' && self ? self : typeof window !== \'undefined\' && window ? window : typeof global !== \'undefined\' && global ? global : this)\n';
    var api = {};
    (function() {
        var g;
        function aa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var l = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function ba(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var n = ba(this);
        function r(a, b) {
            if (b) a: {
                var c = n;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var f = a[d];
                    if (!(f in c)) break a;
                    c = c[f];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && l(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        r("Symbol", function(a) {
            function b(e) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (e || "") + "_" + f++, e);
            }
            function c(e, h) {
                this.g = e;
                l(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: h
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", f = 0;
            return b;
        });
        r("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = n[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && l(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return ca(aa(this));
                    }
                });
            }
            return a;
        });
        function ca(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        var da = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, t;
        if ("function" == typeof Object.setPrototypeOf) t = Object.setPrototypeOf;
        else {
            var u;
            a: {
                var ea = {
                    a: !0
                }, v = {};
                try {
                    v.__proto__ = ea;
                    u = v.a;
                    break a;
                } catch (a) {}
                u = !1;
            }
            t = u ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var w = t;
        function x(a, b) {
            a.prototype = da(b.prototype);
            a.prototype.constructor = a;
            if (w) w(a, b);
            else for(var c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.$ = b.prototype;
        }
        function y() {
            this.l = !1;
            this.g = null;
            this.A = void 0;
            this.h = 1;
            this.D = 0;
            this.j = null;
        }
        function z(a) {
            if (a.l) throw new TypeError("Generator is already running");
            a.l = !0;
        }
        y.prototype.v = function(a) {
            this.A = a;
        };
        function B(a, b) {
            a.j = {
                W: b,
                Z: !0
            };
            a.h = a.D;
        }
        y.prototype.return = function(a) {
            this.j = {
                return: a
            };
            this.h = this.D;
        };
        function fa(a) {
            this.g = new y;
            this.h = a;
        }
        function ha(a, b) {
            z(a.g);
            var c = a.g.g;
            if (c) return C(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return D(a);
        }
        function C(a, b, c, d) {
            try {
                var f = b.call(a.g.g, c);
                if (!(f instanceof Object)) throw new TypeError("Iterator result " + f + " is not an object");
                if (!f.done) return a.g.l = !1, f;
                var e = f.value;
            } catch (h) {
                return a.g.g = null, B(a.g, h), D(a);
            }
            a.g.g = null;
            d.call(a.g, e);
            return D(a);
        }
        function D(a) {
            for(; a.g.h;)try {
                var b = a.h(a.g);
                if (b) return a.g.l = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.A = void 0, B(a.g, c);
            }
            a.g.l = !1;
            if (a.g.j) {
                b = a.g.j;
                a.g.j = null;
                if (b.Z) throw b.W;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function ia(a) {
            this.next = function(b) {
                z(a.g);
                a.g.g ? b = C(a, a.g.g.next, b, a.g.v) : (a.g.v(b), b = D(a));
                return b;
            };
            this.throw = function(b) {
                z(a.g);
                a.g.g ? b = C(a, a.g.g["throw"], b, a.g.v) : (B(a.g, b), b = D(a));
                return b;
            };
            this.return = function(b) {
                return ha(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function ja(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, f) {
                function e(h) {
                    h.done ? d(h.value) : Promise.resolve(h.value).then(b, c).then(e, f);
                }
                e(a.next());
            });
        }
        var E = __dep__colibrio_core_base;
        var F = __dep__colibrio_core_io_base;
        var G = __dep__colibrio_core_publication_base;
        function H(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), f = 0; f < d.length; f++){
                var e = d[f], h = a[e];
                null !== h && "object" === typeof h ? b[e] = H(h, b[e], c) : "undefined" === typeof h ? c && delete b[e] : b[e] = h;
            }
            return b;
        }
        function I(a) {
            return H(a, {
                chunkSize: 128E3,
                disableFontFace: !1,
                enableDeterministicChunkRequests: !1,
                password: null
            }, !1);
        }
        function ka(a, b) {
            var c;
            if (a && !la(a) && "object" === typeof a) {
                var d = Object.keys(a);
                var f = 0;
                for(c = d.length; f < c; f++){
                    var e = d[f];
                    b(a[e], e);
                }
            }
        }
        var la = Array.isArray;
        var J = new Uint16Array(1);
        J[0] = 4660;
        new Uint8Array(J.buffer);
        function ma(a) {
            var b, c, d, f;
            return ja(new ia(new fa(function(e) {
                switch(e.h){
                    case 1:
                        b = a.getReader(), c = [], d = !1;
                    case 2:
                        if (d) {
                            e.h = 4;
                            break;
                        }
                        var h = b.read();
                        e.h = 5;
                        return {
                            value: h
                        };
                    case 5:
                        f = e.A;
                        f.value && c.push(f.value);
                        d = f.done;
                        e.h = 2;
                        break;
                    case 4:
                        return e.return(c);
                }
            })));
        }
        function K(a, b) {
            return E.ColibrioError.call(this, "core.publication.pdf", a, b) || this;
        }
        x(K, E.ColibrioError);
        function L(a) {
            this.g = a;
        }
        L.prototype.fetchChunk = function(a, b) {
            var c = this.g.slice(a, b);
            return new Promise(function(d, f) {
                var e = new FileReader;
                e.onload = function() {
                    d(e.result);
                };
                e.onerror = function(h) {
                    h = new K("BLOB_SRC_READ_ERROR", 'Failed to load slice "' + a + "-" + b + '": ' + String(h));
                    E.Logger.logError(h);
                    f(h);
                };
                e.readAsArrayBuffer(c);
            });
        };
        L.prototype.getSize = function() {
            return this.g.size;
        };
        function M(a, b, c) {
            this.j = a;
            this.g = c;
            this.h = new URL("" + c, b);
        }
        g = M.prototype;
        g.getContentUrl = function() {
            return this.h;
        };
        g.getIndexInSpine = function() {
            return this.g - 1;
        };
        g.getLayout = function() {
            return G.ContentDocumentLayout.PRE_PAGINATED;
        };
        g.getMediaType = function() {
            return F.MediaType.APPLICATION_PDF;
        };
        g.getPageNumber = function() {
            return this.g;
        };
        g.getPageSpreadSlot = function() {
            return G.PageSpreadSlot.AUTO;
        };
        g.getPublication = function() {
            return this.j;
        };
        g.getSyntheticSpreadBehavior = function() {
            return G.SyntheticSpreadBehavior.AUTO;
        };
        g.hasRemoteResources = function() {
            return !1;
        };
        g.isInLinearContent = function() {
            return !0;
        };
        g.isScripted = function() {
            return !1;
        };
        g.toJSON = function() {
            return {
                contentUrl: this.getContentUrl().toString(),
                hasRemoteResources: !1,
                indexInSpine: this.g - 1,
                inLinearContent: !0,
                layout: G.ContentDocumentLayout.PRE_PAGINATED,
                mediaType: F.MediaType.APPLICATION_PDF,
                pageSpreadSlot: G.PageSpreadSlot.AUTO,
                scripted: !1,
                syntheticSpreadBehavior: G.SyntheticSpreadBehavior.AUTO
            };
        };
        function na(a) {
            return new Promise(function(b, c) {
                var d = new FileReader;
                d.onload = function() {
                    d.onabort = null;
                    d.onload = null;
                    d.onerror = null;
                    b(d.result);
                };
                d.onabort = d.onerror = function() {
                    d.onabort = null;
                    d.onload = null;
                    d.onerror = null;
                    c(d.error);
                };
                d.readAsArrayBuffer(a);
            });
        }
        function N(a) {
            var b = __worker__colibrio_core_publication_pdf_webworker;
            this.g = null;
            var c = new Blob([
                b
            ]);
            try {
                this.g = URL.createObjectURL(c), this.h = new Worker(this.g);
            } catch (d) {
                this.g && URL.revokeObjectURL(this.g), a = a((new TextEncoder).encode(b)), this.h = new Worker(new URL("data:text/javascript;base64," + a));
            }
        }
        N.prototype.terminate = function() {
            this.h.terminate();
            this.g && URL.revokeObjectURL(this.g);
        };
        var O = __lib__pdfjs;
        function oa(a) {
            var b = this;
            this.g = [];
            this.h = [];
            ka(a.info, function(c, d) {
                "string" === typeof d && "string" === typeof c && b.g.push({
                    content: {
                        dir: null,
                        lang: null,
                        value: c
                    },
                    contentScheme: null,
                    property: {
                        name: d,
                        namespace: null
                    },
                    refinedBy: []
                });
            });
            a = this.g.findIndex(function(c) {
                return "Title" === c.property.name;
            });
            -1 !== a && this.h.push(a);
        }
        g = oa.prototype;
        g.getAll = function() {
            return this.g.slice();
        };
        g.getIdentifiers = function() {
            return [];
        };
        g.getLanguages = function() {
            return [];
        };
        g.getTitles = function() {
            var a = this;
            return this.h.map(function(b) {
                return a.g[b];
            });
        };
        g.toJSON = function() {
            return {
                all: this.g.slice(),
                identifierIndexes: [],
                languageIndexes: [],
                titleIndexes: this.h.slice(),
                type: G.PublicationMetadataType.PDF_PUBLICATION_METADATA
            };
        };
        function pa(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        x(pa, Error);
        function P() {
            this.u = 0;
            this.h = Q(null, null, null);
            this.g = Q(null, this.h, null);
            this.h.i = this.g;
        }
        g = P.prototype;
        g.every = function(a) {
            for(var b = this.h.i, c = !0; b !== this.g && c;){
                var d = b.i;
                c = a(b);
                b = null === b.i ? d : b.i;
            }
            return c;
        };
        g.find = function(a) {
            for(var b = this.h.i, c = null; b !== this.g && null === c;){
                var d = b.i;
                a(b) && (c = b);
                b = null === b.i ? d : b.i;
            }
            return c;
        };
        g.forEach = function(a) {
            for(var b = this.h.i; b !== this.g;){
                var c = b.i;
                a(b);
                b = null === b.i ? c : b.i;
            }
        };
        function R(a) {
            return a.u ? a.h.i : null;
        }
        function S(a, b) {
            return (b = b.i) && a.g !== b ? b : null;
        }
        function qa(a, b, c) {
            b && b.m ? (c = Q(c, b.m, b), b.m.i = c, b.m = c, a.u++) : T(a, c);
        }
        function T(a, b) {
            b = Q(b, a.g.m, a.g);
            b.m.i = b;
            a.g.m = b;
            a.u++;
            return b;
        }
        g.remove = function(a) {
            for(var b = this.h, c = !1; !c && b !== this.g;)b = b.i, c = b.o === a;
            c && b !== this.g && U(this, b);
        };
        g.size = function() {
            return this.u;
        };
        function Q(a, b, c) {
            return {
                o: a,
                i: c,
                m: b
            };
        }
        function U(a, b) {
            if (b.m && b.i) {
                var c = b.m, d = b.i;
                c.i = d;
                d.m = c;
                b.i = null;
                b.m = null;
                a.u--;
            }
        }
        function ra(a) {
            this.v = a;
            this.A = null;
            this.j = !1;
            this.D = null;
            this.h = !1;
            this.g = new P;
            this.l = new P;
        }
        g = ra.prototype;
        g.destroy = function(a) {
            this.j = !0;
            this.A = a;
            for(var b = R(this.g); b;)b.o.H(a), b = S(this.g, b);
            a = this.g;
            a.h = Q(null, null, null);
            a.g = Q(null, a.h, null);
            a.h.i = a.g;
            a.u = 0;
        };
        g.getNumberOfRunningTasks = function() {
            return this.l.size();
        };
        g.getNumberOfTasksInQueue = function() {
            return this.g.size();
        };
        g.isDestroyed = function() {
            return this.j;
        };
        g.isPaused = function() {
            return this.h;
        };
        g.pause = function() {
            this.h = !0;
        };
        g.resume = function() {
            this.h && (this.h = !1, V(this));
        };
        g.scheduleDefaultTask = function(a, b) {
            var c = this;
            return this.j ? Promise.reject(this.A) : this.v ? new Promise(function(d, f) {
                for(var e = R(c.g); e && e.o.G < b;)e = S(c.g, e);
                qa(c.g, e, {
                    L: a,
                    G: b,
                    H: f,
                    R: d,
                    I: null
                });
                V(c);
            }) : Promise.reject(new pa("Cannot call scheduleDefaultTask() because no defaultTask was specified."));
        };
        g.scheduleTask = function(a, b) {
            var c = this;
            return this.j ? Promise.reject(this.A) : new Promise(function(d, f) {
                for(var e = R(c.g); e && e.o.G < b;)e = S(c.g, e);
                qa(c.g, e, {
                    L: null,
                    G: b,
                    H: f,
                    R: d,
                    I: a
                });
                V(c);
            });
        };
        g.setOnBeforeExecuteNextTask = function(a) {
            this.D = a;
        };
        function sa(a, b) {
            var c = T(a.l, b);
            Promise.resolve().then(function() {
                if (b.I) return b.I();
                if (a.v) return a.v(b.L);
            }).then(function(d) {
                b.R(d);
            }).catch(function(d) {
                b.H(d);
            }).finally(function() {
                U(a.l, c);
                V(a);
            }).catch(function(d) {
                console.error(d);
            });
        }
        function V(a) {
            Promise.resolve().then(function() {
                if (4 > a.l.size()) {
                    var b;
                    null == (b = a.D) || b.call(a);
                    if (!a.h) {
                        b = a.g;
                        if (0 === b.u) b = null;
                        else {
                            var c = b.g.m;
                            U(b, c);
                            b = c;
                        }
                        b && sa(a, b.o);
                    }
                }
            }).catch(function(b) {
                console.error("Unexpected error in InternalAsyncTaskQueue.maybeExecuteNextTask", b);
            });
        }
        function W() {
            this.h = {
                U: 16E6,
                O: 16E6,
                P: 0,
                F: 0
            };
            this.g = new P;
            this.l = new Map;
            this.j = 0;
        }
        function X(a, b) {
            var c = a.l.get(b);
            c && (a.l.delete(b), U(a.g, c), a.j -= c.o.u);
        }
        W.prototype.find = function(a) {
            var b = this.g;
            b = b.u ? b.g.m : null;
            for(var c; b && void 0 === c;)a(b.o.J, b.o.N) ? c = b.o.J : b = (b = b.m) && this.g.h !== b ? b : null;
            b && ta(this, b);
            return c;
        };
        W.prototype.get = function(a) {
            return (a = this.l.get(a)) ? (ta(this, a), a.o.J) : null;
        };
        W.prototype.has = function(a) {
            return this.l.has(a);
        };
        W.prototype.set = function(a, b, c) {
            if (!(c > this.h.U || !this.h.P && c > this.h.O)) {
                var d = this.h.F;
                b = {
                    N: a,
                    V: 0,
                    u: c,
                    S: d ? Date.now() + d : 0,
                    J: b
                };
                X(this, a);
                b = T(this.g, b);
                this.l.set(a, b);
                this.j += c;
                ua(this);
            }
        };
        function ua(a) {
            var b = a.h.O, c = a.h.P, d = a.h.F;
            if (d && a.j > b && a.g.size() > c) {
                d = d ? Date.now() : 0;
                for(var f = R(a.g); a.j > b && a.g.size() > c && f && f.o.S <= d;){
                    var e = S(a.g, f);
                    0 >= f.o.V && X(a, f.o.N);
                    f = e;
                }
            }
        }
        function ta(a, b) {
            var c = a.h.F, d = a.g;
            b.m && b.i && (U(d, b), b.m = d.g.m, b.i = d.g, b.m.i = b, d.g.m = b, d.u++);
            c && (b.o.S = Date.now() + c);
            c && ua(a);
        }
        var va = new WeakMap;
        function Y(a, b, c) {
            var d = O.PDFDataRangeTransport.call(this, a.getSize(), new Uint8Array, !1) || this;
            b = {
                K: c ? new W : null,
                B: b,
                T: a.getSize(),
                M: new ra(function(f) {
                    var e = f.C - f.s;
                    return a.fetchChunk(f.s, f.C).then(function(h) {
                        if (h instanceof Uint8Array) return h.length !== e && E.Logger.logError(new F.IoError(F.IoErrorType.INVALID_DATA_CHUNK, "Expected RandomAccessDataSource.fetchChunk(" + f.s + ", " + f.C + ") to return " + e + " bytes of data. Actually got " + h.length + " bytes.")), 0 < h.byteOffset || h.byteLength !== h.buffer.byteLength ? h.buffer.slice(h.byteOffset, h.byteOffset + h.byteLength) : h.buffer;
                        if (h instanceof ArrayBuffer) return h.byteLength !== e && E.Logger.logError(new F.IoError(F.IoErrorType.INVALID_DATA_CHUNK, "Expected RandomAccessDataSource.fetchChunk(" + f.s + ", " + f.C + ") to return " + e + " bytes of data. Actually got " + h.byteLength + " bytes.")), h;
                        if (h instanceof ReadableStream) return ma(h).then(function(k) {
                            if (0 === k.length) k = new Uint8Array(0);
                            else if (1 === k.length) k = k[0];
                            else {
                                for(var m = 0, q = 0; q < k.length; q++)m += k[q].byteLength;
                                m = new Uint8Array(m);
                                for(var p = q = 0; p < k.length; p++){
                                    var A = k[p];
                                    m.set(A, q);
                                    q += A.byteLength;
                                }
                                k = m;
                            }
                            return k.buffer;
                        });
                        throw new K("INVALID_RANDOM_ACCESS_DATA_SOURCE_RESPONSE");
                    });
                })
            };
            va.set(d, b);
            return d;
        }
        x(Y, O.PDFDataRangeTransport);
        Y.prototype.requestDataRange = function(a, b) {
            var c = va.get(this);
            c && (c.K ? wa(this, a, b, c, c.K) : xa(this, a, b, c));
        };
        function wa(a, b, c, d, f) {
            for(var e = new Uint8Array(c - b), h = [], k = b - b % d.B; k < c; k += d.B)h.push({
                s: k,
                C: Math.min(k + d.B, d.T)
            });
            h = h.map(function(m) {
                var q = f.get(m.s);
                q || (q = d.M.scheduleDefaultTask(m, 0).catch(function(p) {
                    X(f, m.s);
                    E.ColibrioError.isColibrioAbortedError(p) || E.Logger.logError(p);
                    throw p;
                }), f.set(m.s, q, d.B));
                return q.then(function(p) {
                    var A = Math.max(0, b - m.s);
                    p = new Uint8Array(p, A, p.byteLength - Math.max(0, m.C - c) - A);
                    e.set(p, Math.max(0, m.s - b));
                });
            });
            Promise.all(h).then(function() {
                a.onDataRange(b, e);
            }).catch(function(m) {
                E.ColibrioError.isColibrioAbortedError(m) || E.Logger.logError(m);
            });
        }
        function xa(a, b, c, d) {
            for(var f = [], e = b; e < c; e += d.B)f.push({
                s: e,
                C: Math.min(c, e + d.B)
            });
            var h = new Uint8Array(c - b);
            c = f.map(function(k) {
                return d.M.scheduleDefaultTask(k, 0).then(function(m) {
                    h.set(new Uint8Array(m), k.s - b);
                });
            });
            Promise.all(c).then(function() {
                a.onDataRange(b, h);
            }).catch(function(k) {
                E.ColibrioError.isColibrioAbortedError(k) || E.Logger.logError(k);
            });
        }
        function Z(a, b, c) {
            this.j = a;
            this.h = c;
            this.l = !1;
            this.A = new URL("com.colibrio.pdfjs://" + a.fingerprints[0] + "/");
            this.g = [];
            this.g.length = a.numPages;
            for(a = 0; a < this.g.length; a++)this.g[a] = new M(this, this.A, a + 1);
            this.v = new oa(b);
        }
        function ya(a, b) {
            return za(a, b);
        }
        g = Z.prototype;
        g._getPdfDocumentProxy = function() {
            return this.j;
        };
        g._getPdfJs = function() {
            return O;
        };
        g.destroy = function() {
            var a = this;
            this.l || (this.l = !0, this.g = [], this.j.cleanup().catch(function() {
                return E.Logger.logError("PDFjs Cleanup failed");
            }), this.j.destroy().finally(function() {
                a.h.port && "function" === typeof a.h.port.terminate && a.h.port.terminate();
                a.h.destroyed || a.h.destroy();
            }).catch(E.Logger.logError));
        };
        g.getDefaultLayout = function() {
            return G.ContentDocumentLayout.PRE_PAGINATED;
        };
        g.getHashSignature = function() {
            return this.j.fingerprints[0];
        };
        g.getMetadata = function() {
            return this.v;
        };
        g.getPageProgressionDirection = function() {
            return G.PageProgressionDirection.AUTO;
        };
        g.getPreferredFlowMode = function() {
            return G.ContentDocumentFlowMode.PAGINATED;
        };
        g.getPreferredOrientation = function() {
            return G.PublicationOrientation.AUTO;
        };
        g.getPreferredSyntheticSpreadBehavior = function() {
            return G.SyntheticSpreadBehavior.AUTO;
        };
        g.getSpine = function() {
            return this.g;
        };
        g.getType = function() {
            return G.PublicationType.PDF;
        };
        g.isDestroyed = function() {
            return this.l;
        };
        g.toJSON = function() {
            return {
                defaultLayout: G.ContentDocumentLayout.PRE_PAGINATED,
                hashSignature: this.getHashSignature(),
                metadata: this.v.toJSON(),
                pageProgressionDirection: G.PageProgressionDirection.AUTO,
                preferredFlowMode: G.ContentDocumentFlowMode.PAGINATED,
                preferredOrientation: G.PublicationOrientation.AUTO,
                preferredSyntheticSpreadBehavior: G.SyntheticSpreadBehavior.AUTO,
                spine: this.g.map(function(a) {
                    return a.toJSON();
                }),
                type: G.PublicationType.PDF
            };
        };
        Z.createFromArrayBuffer = Aa;
        Z.createFromBlob = Ba;
        Z.createFromRandomAccessDataSource = za;
        function Aa(a, b) {
            b = I(b);
            var c = null !== b.password ? b.password : void 0;
            return Ca({
                data: new Uint8Array(a.slice(0)),
                disableFontFace: b.disableFontFace,
                password: c
            });
        }
        function Ba(a, b) {
            return E.BrowserDetector.isBrowser("Safari") ? na(a).then(function(c) {
                return Aa(c, b);
            }) : ya(new L(a), b);
        }
        function za(a, b) {
            b = I(b);
            return Ca({
                disableFontFace: b.disableFontFace,
                password: null !== b.password ? b.password : void 0,
                range: new Y(a, b.chunkSize, b.enableDeterministicChunkRequests)
            });
        }
        function Ca(a) {
            var b = Da();
            a.disableRange = !1;
            a.disableAutoFetch = !0;
            a.isEvalSupported = !1;
            a.worker = b;
            return O.getDocument(a).promise.then(function(c) {
                return c.getMetadata().then(function(d) {
                    return new Z(c, d, b);
                });
            }).catch(function(c) {
                var d = Promise, f = d.reject;
                a: if (void 0 !== c.code) {
                    switch(c.code){
                        case 2:
                            c = new K("PASSWORD_INCORRECT");
                            break a;
                        case 1:
                            c = new K("PASSWORD_REQUIRED");
                            break a;
                    }
                    c = void 0;
                }
                return f.call(d, c);
            });
        }
        function Da() {
            var a = new N(function(b) {
                return E.Base64.encode(b);
            });
            return new O.PDFWorker({
                name: "PDFWorker",
                port: a.h
            });
        }
        api = {
            PdfPublication: Z,
            PdfPublicationError: K,
            PdfPublicationErrorType: {
                BLOB_SRC_READ_ERROR: "BLOB_SRC_READ_ERROR",
                INVALID_RANDOM_ACCESS_DATA_SOURCE_RESPONSE: "INVALID_RANDOM_ACCESS_DATA_SOURCE_RESPONSE",
                PASSWORD_REQUIRED: "PASSWORD_REQUIRED",
                PASSWORD_INCORRECT: "PASSWORD_INCORRECT"
            }
        };
        var Ea = new ArrayBuffer(8);
        new DataView(Ea);
        new Uint8Array(Ea);
    }).call(__self);
    return api;
});

});

parcelRegister("1dwvc", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";







(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("kj8wo")), (parcelRequire("acQau")), (parcelRequire("a75zb")), (parcelRequire("gWxKE")), (parcelRequire("fQRpb")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_io_resourceprovider_zip, __dep__colibrio_core_publication_base, __dep__colibrio_core_url, __dep__colibrio_core_xml, __dep__colibrio_core_selector_media) {
    var api = {};
    (function() {
        var k;
        function aa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var q = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function ba(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var ca = ba(this);
        function da(a, b) {
            if (b) a: {
                var c = ca;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var e = a[d];
                    if (!(e in c)) break a;
                    c = c[e];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && q(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        da("Symbol", function(a) {
            function b(g) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (g || "") + "_" + e++, g);
            }
            function c(g, f) {
                this.g = g;
                q(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: f
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        });
        da("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = ca[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && q(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return ea(aa(this));
                    }
                });
            }
            return a;
        });
        function ea(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        function r(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return {
                next: aa(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        var fa = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, t;
        if ("function" == typeof Object.setPrototypeOf) t = Object.setPrototypeOf;
        else {
            var v;
            a: {
                var ha = {
                    a: !0
                }, ia = {};
                try {
                    ia.__proto__ = ha;
                    v = ia.a;
                    break a;
                } catch (a) {}
                v = !1;
            }
            t = v ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var ja = t;
        function ka(a, b) {
            a.prototype = fa(b.prototype);
            a.prototype.constructor = a;
            if (ja) ja(a, b);
            else for(var c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.aa = b.prototype;
        }
        function w() {
            this.v = !1;
            this.j = null;
            this.h = void 0;
            this.g = 1;
            this.F = this.o = 0;
            this.l = null;
        }
        function x(a) {
            if (a.v) throw new TypeError("Generator is already running");
            a.v = !0;
        }
        w.prototype.B = function(a) {
            this.h = a;
        };
        function y(a, b) {
            a.l = {
                O: b,
                R: !0
            };
            a.g = a.o || a.F;
        }
        w.prototype.return = function(a) {
            this.l = {
                return: a
            };
            this.g = this.F;
        };
        function z(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        function A(a) {
            a.o = 0;
            var b = a.l.O;
            a.l = null;
            return b;
        }
        function la(a) {
            this.g = new w;
            this.h = a;
        }
        function ma(a, b) {
            x(a.g);
            var c = a.g.j;
            if (c) return na(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return B(a);
        }
        function na(a, b, c, d) {
            try {
                var e = b.call(a.g.j, c);
                if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                if (!e.done) return a.g.v = !1, e;
                var g = e.value;
            } catch (f) {
                return a.g.j = null, y(a.g, f), B(a);
            }
            a.g.j = null;
            d.call(a.g, g);
            return B(a);
        }
        function B(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.v = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.h = void 0, y(a.g, c);
            }
            a.g.v = !1;
            if (a.g.l) {
                b = a.g.l;
                a.g.l = null;
                if (b.R) throw b.O;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function oa(a) {
            this.next = function(b) {
                x(a.g);
                a.g.j ? b = na(a, a.g.j.next, b, a.g.B) : (a.g.B(b), b = B(a));
                return b;
            };
            this.throw = function(b) {
                x(a.g);
                a.g.j ? b = na(a, a.g.j["throw"], b, a.g.B) : (y(a.g, b), b = B(a));
                return b;
            };
            this.return = function(b) {
                return ma(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function pa(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function g(f) {
                    f.done ? d(f.value) : Promise.resolve(f.value).then(b, c).then(g, e);
                }
                g(a.next());
            });
        }
        function C(a) {
            return pa(new oa(new la(a)));
        }
        var E = __dep__colibrio_core_base;
        var qa = __dep__colibrio_core_io_resourceprovider_zip;
        var F = __dep__colibrio_core_publication_base;
        var ra = __dep__colibrio_core_selector_media;
        var G = __dep__colibrio_core_url;
        var sa = __dep__colibrio_core_xml;
        function H(a) {
            return "undefined" === typeof a;
        }
        function ta(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), e = 0; e < d.length; e++){
                var g = d[e], f = a[g];
                null !== f && "object" === typeof f ? b[g] = ta(f, b[g], c) : H(f) ? c && delete b[g] : b[g] = f;
            }
            return b;
        }
        var I = Array.isArray;
        function J(a) {
            return a && !I(a) && "object" === typeof a;
        }
        function K(a) {
            return "string" === typeof a;
        }
        var ua = Function.prototype.call.bind(Object.prototype.hasOwnProperty);
        var va = new Uint16Array(1);
        va[0] = 4660;
        new Uint8Array(va.buffer);
        function wa(a) {
            return /^(?:(en-GB-oed|i-ami|i-bnn|i-default|i-enochian|i-hak|i-klingon|i-lux|i-mingo|i-navajo|i-pwn|i-tao|i-tay|i-tsu|sgn-BE-FR|sgn-BE-NL|sgn-CH-DE)|(art-lojban|cel-gaulish|no-bok|no-nyn|zh-guoyu|zh-hakka|zh-min|zh-min-nan|zh-xiang))$|^((?:[a-z]{2,3}(?:(?:-[a-z]{3}){1,3})?)|[a-z]{4}|[a-z]{5,8})(?:-([a-z]{4}))?(?:-([a-z]{2}|\d{3}))?((?:-(?:[\da-z]{5,8}|\d[\da-z]{3}))*)?((?:-[\da-wy-z](?:-[\da-z]{2,8})+)*)?(-x(?:-[\da-z]{1,8})+)?$|^(x(?:-[\da-z]{1,8})+)$/i.test(a);
        }
        function xa(a, b, c) {
            this.l = a;
            this.j = b;
            this.g = c;
            a = a.getManifest().getManifestResourceProvider().getBaseUrl();
            this.h = new URL(c.url, a);
        }
        k = xa.prototype;
        k.getContentUrl = function() {
            return this.h;
        };
        k.getIndexInSpine = function() {
            return this.j;
        };
        k.getLayout = function() {
            return F.ContentDocumentLayout.REFLOWABLE;
        };
        k.getLinkedResource = function() {
            return this.g;
        };
        k.getMediaType = function() {
            return this.g.encodingFormat || null;
        };
        k.getPageSpreadSlot = function() {
            return F.PageSpreadSlot.AUTO;
        };
        k.getPublication = function() {
            return this.l;
        };
        k.getSyntheticSpreadBehavior = function() {
            return F.SyntheticSpreadBehavior.AUTO;
        };
        k.hasRemoteResources = function() {
            return !1;
        };
        k.isInLinearContent = function() {
            return !0;
        };
        k.isScripted = function() {
            return !1;
        };
        k.toJSON = function() {
            return {
                contentUrl: this.getContentUrl().toString(),
                hasRemoteResources: this.hasRemoteResources(),
                indexInSpine: this.getIndexInSpine(),
                inLinearContent: this.isInLinearContent(),
                layout: this.getLayout(),
                mediaType: this.getMediaType(),
                pageSpreadSlot: this.getPageSpreadSlot(),
                scripted: this.isScripted(),
                syntheticSpreadBehavior: this.getSyntheticSpreadBehavior()
            };
        };
        function ya(a) {
            this.l = a;
            this.g = [];
            this.h = "";
            this.j = [];
        }
        function L(a, b, c, d) {
            a.j.push({
                path: a.g.slice(),
                W: a.h,
                Z: c,
                $: b,
                value: d
            });
        }
        function za(a) {
            var b = [];
            I(a) && a.forEach(function(c) {
                "ItemList" === c.type && I(c.S) && c.S.forEach(function(d) {
                    K(d) && !b.includes(d) && b.push(d);
                });
            });
            return b;
        }
        function Aa(a, b, c) {
            if (c.type) {
                if (I(c.type)) {
                    for(var d = c.type, e = !1, g = 0; g < d.length && !e; g++)switch(d[g]){
                        case "boolean":
                            e = "boolean" === typeof b;
                            break;
                        case "object":
                            e = J(b);
                            break;
                        case "array":
                            e = I(b);
                            break;
                        case "string":
                            e = K(b);
                    }
                    e || (L(a, "type", "[" + d.join(", ") + "]", b), b = void 0);
                } else {
                    d = c.type;
                    e = !1;
                    switch(d){
                        case "boolean":
                            e = "boolean" !== typeof b;
                            break;
                        case "object":
                            J(b) || (c.J ? (g = {}, b = (g[c.J] = b, g)) : e = !0);
                            break;
                        case "array":
                            I(b) || (b = [
                                b
                            ]);
                            break;
                        case "itemlist":
                            b = za(b);
                            break;
                        case "string":
                            K(b) || ("number" !== typeof b || isNaN(b) ? e = !0 : b = "" + b);
                    }
                    e && (L(a, "type", d, b), b = void 0);
                }
            }
            if (J(b)) {
                d = b = Object.assign({}, b);
                e = Object.keys(d);
                g = c.C;
                for(var f = 0; f < e.length; f++){
                    var h = e[f];
                    if ("@context" === h) d[h] = ta(d[h], {}, !1);
                    else if (!g || !g[h]) switch(c.K){
                        case "KEEP_AND_WARN":
                            L(a, "unknownProperty", h, d[h]);
                            break;
                        case "REMOVE_AND_WARN":
                        case void 0:
                            L(a, "unknownProperty", h, d[h]), delete d[h];
                    }
                }
                if (c.C) for(d = b, e = Object.entries(c.C), g = 0; g < e.length; g++)h = e[g], f = h[0], h = h[1], h.i && (h = Ba(a.l, h.i)), !H(h.default) && H(d[f]) && (d[f] = h.default), H(d[f]) || (a.g.push(f), h = Aa(a, d[f], h), H(h) ? delete d[f] : d[f] = h, a.g.pop());
                if (c.required) {
                    a: for(c = c.required, d = 0; d < c.length; d++)if (e = c[d], !ua(b, e)) {
                        L(a, "required", e, "");
                        b = void 0;
                        break a;
                    }
                }
            } else if (I(b)) {
                if (c.items) {
                    c = c.items;
                    c.i && (c = Ba(a.l, c.i));
                    d = [];
                    e = a.h;
                    c.u && (a.h = c.u);
                    for(g = 0; g < b.length; g++)a.g.push(g), f = Aa(a, b[g], c), a.g.pop(), H(f) || d.push(f);
                    a.h = e;
                    a = d;
                } else a = ta(b, {}, !1);
                b = a;
            }
            return b;
        }
        function Ca(a, b) {
            var c = a["@context"];
            if (!I(c)) return !1;
            a = c.indexOf("https://schema.org");
            b = c.indexOf(b);
            return -1 !== a && -1 !== b && b > a;
        }
        function M(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        ka(M, Error);
        function Da() {
            this.g = new Map;
        }
        function N(a, b) {
            if (!b.u) throw new M("Schema is missing $id");
            a.g.set(b.u, b);
        }
        function Ba(a, b) {
            a = a.g.get(b);
            if (!a) throw new M("Schema not found: " + b);
            if (a.i) throw new M("Schema $ref chain not supported: " + b);
            return a;
        }
        function Ea(a) {
            a = Date.parse(a);
            return !isNaN(a);
        }
        function O(a) {
            return /^P(?!$)(\d+(?:\.\d+)?Y)?(\d+(?:\.\d+)?M)?(\d+(?:\.\d+)?W)?(\d+(?:\.\d+)?D)?(T(?=\d)(\d+(?:\.\d+)?H)?(\d+(?:\.\d+)?M)?(\d+(?:\.\d+)?S)?)?$/.test(a);
        }
        function Fa(a) {
            var b = 0, c = !1;
            a = a.replace(/,/g, ".");
            for(var d = 0, e = 0; e < a.length; e++)switch(a[e]){
                case "Y":
                    b = P(a, b, e + 1);
                    d += 31556952E3 * b;
                    b = e + 1;
                    break;
                case "D":
                    b = P(a, b, e + 1);
                    d += 864E5 * b;
                    b = e + 1;
                    break;
                case "H":
                    b = P(a, b, e + 1);
                    d += 36E5 * b;
                    b = e + 1;
                    break;
                case "M":
                    b = P(a, b, e + 1);
                    d = c ? d + 6E4 * b : d + 2629746E3 * b;
                    b = e + 1;
                    break;
                case "S":
                    b = P(a, b, e + 1);
                    d += 1E3 * b;
                    b = e + 1;
                    break;
                case "P":
                    b = e + 1;
                    break;
                case "T":
                    c = !0, b = e + 1;
            }
            return d;
        }
        function P(a, b, c) {
            a = parseFloat(a.slice(b, c));
            return isNaN(a) ? 0 : a;
        }
        function Q(a, b) {
            return E.ColibrioError.call(this, "core.publication.wp", a, b) || this;
        }
        ka(Q, E.ColibrioError);
        var Ga = {
            AUDIOBOOKS: "https://www.w3.org/TR/audiobooks/",
            GENERIC: "https://www.w3.org/TR/pub-manifest/"
        };
        function R(a, b) {
            var c;
            return (null == (c = a.rel) ? void 0 : c.some(function(d) {
                return d.toLowerCase() === b;
            })) || !1;
        }
        function Ha(a, b, c) {
            this.j = a;
            this.h = b;
            this.s = c;
            this.g = [];
        }
        function S(a) {
            return a.conformsTo.includes("https://www.w3.org/TR/audiobooks/");
        }
        function Ia(a, b) {
            a.type || (a.type = []);
            0 === a.type.length && a.type.push(b);
        }
        function Ja(a, b, c) {
            a.forEach(function(d) {
                d = G.URLUtils.normalizePathnameEncoding(new URL(d.url, b));
                c.add(G.URLUtils.getUrlWithoutHash(d));
            });
        }
        function Ka(a, b, c, d) {
            for(var e = new Set, g = 0; g < b.length; g++){
                var f = b[g];
                f = K(f) ? f : f.url;
                var h = G.URLUtils.normalizePathnameEncoding(new URL(f, c));
                h = G.URLUtils.getUrlWithoutHash(h);
                e.has(h) ? a.logWarning(d, "contains duplicate URL: " + f) : e.add(h);
            }
            return e;
        }
        Ha.prototype.logError = function(a, b) {
            this.g.push({
                message: b,
                property: a
            });
            var c = "Validation error :: ";
            a && (c += a + ": ");
            E.Logger.logError(new Q("INVALID_MANIFEST", c + b));
        };
        Ha.prototype.logWarning = function(a, b) {
            this.g.push({
                message: b,
                property: a
            });
            var c = "Validation error :: ";
            a && (c += a + ": ");
            E.Logger.logWarning(new Q("INVALID_MANIFEST", c + b));
        };
        function La(a, b) {
            if (0 === b.conformsTo.length) a.logWarning("conformsTo", 'conformsTo property is missing! Defaulting to the generic "https://www.w3.org/TR/pub-manifest/"'), b.conformsTo = [
                "https://www.w3.org/TR/pub-manifest/"
            ];
            else {
                var c = Object.values(Ga);
                b.conformsTo.forEach(function(d) {
                    c.includes(d) || a.logWarning("conformsTo", 'Unsupported profile found: "' + d + '"');
                });
            }
        }
        function Ma(a, b) {
            var c = -1;
            b.duration && (O(b.duration) ? c = Fa(b.duration) : (a.logWarning("duration", "Invalid ISO 8601 duration: " + b.duration), b.duration = void 0));
            var d = 0;
            b.readingOrder.forEach(function(e) {
                e.duration ? O(e.duration) ? d += Fa(e.duration) : (a.logWarning("readingOrder", '"readingOrder" - Invalid ISO 8601 duration for resource "' + e.url + '": ' + e.duration), e.duration = void 0) : S(b) && a.logWarning("readingOrder", 'Duration missing for resource "' + e.url + '"');
            });
            -1 !== c && 1E3 < Math.abs(d - c) && a.logWarning("duration", "The sum of the readingOrder items' duration (" + Math.round(d / 1E3) + ") does not match the declared total duration (" + (Math.round(c / 1E3) + ")."));
            b.resources.forEach(function(e) {
                e.duration && !O(e.duration) && (e.duration = void 0, a.logWarning("resources", 'Invalid ISO 8601 duration for resource "' + e.url + '": ' + e.duration));
            });
            b.links.forEach(function(e) {
                e.duration && !O(e.duration) && (e.duration = void 0, a.logWarning("links", 'Invalid ISO 8601 duration for resource "' + e.url + '": ' + e.duration));
            });
        }
        function Na(a, b) {
            for(var c = [
                "cover",
                "pagelist",
                "contents"
            ], d = {}, e = b.links.length - 1; 0 <= e; d = {
                L: void 0
            }, e--){
                var g = b.links[e];
                d.L = "";
                g.rel ? g.rel.some(function(f) {
                    return function(h) {
                        return c.includes(h.toLowerCase()) ? (f.L = h, !0) : !1;
                    };
                }(d)) && (a.logWarning("links", 'Must not include cover, pagelist or contents. Removed link "' + g.url + '" with rel: "' + d.L + '"'), b.links.splice(e, 1)) : a.logWarning("links", 'The link "' + g.url + '" is missing a "rel" attribute.');
            }
        }
        function Oa(a, b) {
            var c = new Set;
            Ja(a.readingOrder, b, c);
            Ja(a.resources, b, c);
            var d = [];
            c.forEach(function(e) {
                return d.push(e);
            });
            a.uniqueResources = d;
        }
        function T(a, b, c, d) {
            for(var e = 0; e < b.length; e++){
                var g = b[e];
                g = K(g) ? g : g.url;
                try {
                    new URL(g, c);
                } catch (f) {
                    a.logWarning(d, 'Removed invalid resource URL: "' + g + '"'), b.splice(e--, 1);
                }
            }
        }
        function Pa(a, b) {
            for(var c = r("abridged accessibilityFeature accessibilityHazard accessibilitySummary accessMode accessModeSufficient author duration dateModified datePublished id inLanguage readBy readingProgression resources type url".split(" ")), d = c.next(); !d.done; d = c.next())d = d.value, H(b[d]) && a.logWarning(d, "Recommended property missing.");
            b.resources.some(function(e) {
                return R(e, "cover");
            }) || b.readingOrder.some(function(e) {
                return R(e, "cover");
            }) || a.logWarning(null, 'Audiobook :: Recommended link relation "cover" not found in "resources" or "readingOrder"');
        }
        function Qa(a, b) {
            function c(e, g) {
                e.forEach(function(f) {
                    R(f, "cover") && (!f.name && f.encodingFormat && f.encodingFormat.startsWith("image") && a.logWarning(g, 'The resource "' + f.url + '" is marked as "cover" but is missing the "name" property.'), d ? a.logWarning(null, 'Manifest should not contain multiple "cover" resources.') : d = !0);
                });
            }
            var d = !1;
            c(b.readingOrder, "readingOrder");
            c(b.resources, "resources");
        }
        function Ra(a, b) {
            var c = !1;
            b.readingOrder.concat(b.resources).forEach(function(d) {
                R(d, "pagelist") && (c ? a.logWarning(null, 'Manifest should not contain multiple "pagelist" resources.') : c = !0);
            });
        }
        function Sa(a, b, c) {
            var d = !1;
            S(b) && c && c.A.querySelector("[role=doc-toc]") && (d = !0);
            b.readingOrder.concat(b.resources).forEach(function(e) {
                R(e, "contents") && (d ? a.logWarning(null, 'Manifest should not contain multiple "contents" resources.') : d = !0);
            });
            S(b) && !d && a.logWarning(null, "Table of contents not found");
        }
        function U(a, b, c) {
            var d;
            this.D = a;
            try {
                var e = JSON.parse(b);
            } catch (D) {
                throw E.Logger.logError(D), new Q("INVALID_MANIFEST", 'Failed parsing the JSON manifest located at "' + this.D.getBaseUrl() + '": ' + D);
            }
            b = e;
            if (!Ca(b, "https://www.w3.org/ns/pub-context")) {
                if (Ca(b, "https://www.w3.org/ns/wp-context")) E.Logger.logWarning(new Q("INVALID_MANIFEST", "WpPublication - Old version of manifest @context: https://www.w3.org/ns/wp-context Expected: https://www.w3.org/ns/pub-context"));
                else throw new Q("INVALID_MANIFEST", 'Invalid JSON-LD @context, it must include "https://www.w3.org/ns/pub-context" and "https://schema.org"');
            }
            var g;
            e = b["@context"];
            if (I(e)) for(var f = 0; f < e.length; f++){
                var h = e[f];
                J(h) && (h = h.direction, K(h) && (g = h));
            }
            else g = void 0;
            void 0 !== g && "ltr" !== g && "rtl" !== g && (E.Logger.logWarning("WpPublication - Invalid manifest base direction specified in @context: Must be ltr or rtl."), g = void 0);
            e = b["@context"];
            if (I(e)) for(f = 0; f < e.length; f++)h = e[f], J(h) && (h = h.hasOwnProperty("language") ? h.language : void 0, K(h) && (wa(h) ? d = h : E.Logger.logWarning("Invalid BCP 47 language tag: " + h)));
            else d = void 0;
            e = new Da;
            N(e, {
                u: "WpLocalizableString",
                C: {
                    direction: {
                        default: g,
                        type: "string"
                    },
                    language: {
                        default: d,
                        type: "string"
                    },
                    value: {
                        type: "string"
                    }
                },
                required: [
                    "value"
                ],
                type: "object",
                J: "value"
            });
            N(e, {
                u: "WpEntity",
                K: "KEEP_AND_WARN",
                C: {
                    id: {
                        type: "string"
                    },
                    identifier: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    name: {
                        items: {
                            i: "WpLocalizableString"
                        },
                        type: "array"
                    },
                    type: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    url: {
                        type: "string"
                    }
                },
                required: [
                    "name"
                ],
                type: "object",
                J: "name"
            });
            N(e, {
                u: "WpLinkedResource",
                K: "KEEP_AND_WARN",
                C: {
                    alternate: {
                        items: {
                            i: "WpLinkedResource"
                        },
                        type: "array"
                    },
                    description: {
                        i: "WpLocalizableString"
                    },
                    duration: {
                        type: "string"
                    },
                    encodingFormat: {
                        type: "string"
                    },
                    integrity: {
                        type: "string"
                    },
                    name: {
                        items: {
                            i: "WpLocalizableString"
                        },
                        type: "array"
                    },
                    rel: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    type: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    url: {
                        type: "string"
                    }
                },
                required: [
                    "url"
                ],
                type: "object",
                J: "url"
            });
            N(e, {
                u: "WpManifest",
                K: "KEEP",
                C: {
                    abridged: {
                        type: "boolean"
                    },
                    accessibilityFeature: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    accessibilityHazard: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    accessibilitySummary: {
                        i: "WpLocalizableString"
                    },
                    accessMode: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    accessModeSufficient: {
                        items: {
                            type: "string"
                        },
                        type: "itemlist"
                    },
                    artist: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    author: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    colorist: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    conformsTo: {
                        default: [],
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    contributor: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    creator: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    dateModified: {
                        type: "string"
                    },
                    datePublished: {
                        type: "string"
                    },
                    direction: {
                        type: "string"
                    },
                    duration: {
                        type: "string"
                    },
                    editor: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    id: {
                        type: "string"
                    },
                    illustrator: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    inker: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    inLanguage: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    letterer: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    links: {
                        default: [],
                        items: {
                            i: "WpLinkedResource"
                        },
                        type: "array"
                    },
                    name: {
                        items: {
                            i: "WpLocalizableString"
                        },
                        type: "array"
                    },
                    penciler: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    publisher: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    readBy: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    readingOrder: {
                        items: {
                            i: "WpLinkedResource"
                        },
                        type: "array"
                    },
                    readingProgression: {
                        type: "string"
                    },
                    resources: {
                        default: [],
                        items: {
                            i: "WpLinkedResource"
                        },
                        type: "array"
                    },
                    translator: {
                        items: {
                            i: "WpEntity"
                        },
                        type: "array"
                    },
                    type: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    },
                    uniqueResources: {
                        items: {
                            i: "WpLinkedResource"
                        },
                        type: "array"
                    },
                    url: {
                        items: {
                            type: "string"
                        },
                        type: "array"
                    }
                },
                required: [],
                type: "object"
            });
            d = new ya(e);
            g = Ba(d.l, "WpManifest");
            d.h = g.u || "";
            d.g = [];
            d.j = [];
            b = Aa(d, b, g);
            d = d.j;
            0 < d.length && (E.Logger.logWarning("WP Manifest JSON errors"), E.Logger.logWarning(d));
            if (!b) throw new Q("INVALID_MANIFEST", "Failed to normalize the Manifest, required properties are missing");
            c = new Ha(b, a.getBaseUrl(), c);
            c.g = [];
            a = c.j;
            d = c.h;
            b = c.s;
            g = new ra.MediaFragmentSelectorParser;
            a.readingOrder || (a.readingOrder = []);
            if (0 === a.readingOrder.length) {
                if (b) a.readingOrder.push({
                    url: G.URLUtils.getUrlWithoutHash(b.I)
                });
                else throw new Q("INVALID_MANIFEST", '"readingOrder" is empty!');
            }
            if (a.inLanguage) for(e = a.inLanguage.length - 1; 0 <= e; e--)f = a.inLanguage[e], wa(f) || (c.logWarning("inLanguage", "Invalid BCP 47 language tag: " + f), a.inLanguage.splice(e, 1));
            La(c, a);
            T(c, a.readingOrder, d, "readingOrder");
            T(c, a.resources, d, "resources");
            T(c, a.links, d, "links");
            a.url && T(c, a.url, d, "url");
            e = a.readingOrder;
            for(f = 0; f < e.length; f++){
                h = e[f];
                var n = K(h) ? h : h.url, u = new URL(n, d);
                g.canParseFragment(u.hash) && (u = G.URLUtils.getUrlWithoutHash(u), c.logWarning("readingOrder", 'Removed fragment selectors from resource URL: "' + n + '"'), K(h) ? e[f] = u : (h.url = u, e[f] = h));
            }
            g = Ka(c, a.readingOrder, d, "readingOrder");
            e = Ka(c, a.resources, d, "resources");
            for(f = a.links.length - 1; 0 <= f; f--)h = a.links[f].url, n = G.URLUtils.normalizePathnameEncoding(new URL(h, d)), n = G.URLUtils.getUrlWithoutHash(n), g.has(n) ? (c.logWarning("links", 'The URL "' + h + '" was removed from links because it already appears in "readingOrder"'), a.links.splice(f, 1)) : e.has(n) && (c.logWarning("links", 'The URL "' + h + '" was removed from links because it already appears in "resources"'), a.links.splice(f, 1));
            a.id ? G.URLUtils.isValidUrl(a.id) || (c.logWarning("id", 'Property removed because it is not a valid URL. Got: "' + a.id + '"'), a.id = void 0) : c.logWarning("id", "Property is missing.");
            Ma(c, a);
            a.dateModified && !Ea(a.dateModified) && (c.logWarning("dateModified", "Invalid date format: " + a.dateModified), a.dateModified = void 0);
            a.datePublished && !Ea(a.datePublished) && (c.logWarning("datePublished", "Invalid date format: " + a.datePublished), a.datePublished = void 0);
            var p;
            (g = null == (p = a.readingProgression) ? void 0 : p.toLowerCase()) && "ltr" !== g && "rtl" !== g && (c.logWarning("readingProgression", 'Must be either "ltr" or "rtl". Got: "' + a.readingProgression + '"'), a.readingProgression = void 0);
            Na(c, a);
            Qa(c, a);
            Ra(c, a);
            Sa(c, a, b);
            Oa(a, d);
            if (b) {
                g = p = !1;
                e = G.URLUtils.getUrlWithoutHash(b.I);
                f = r(a.readingOrder);
                for(h = f.next(); !h.done; h = f.next()){
                    h = h.value;
                    try {
                        var m = G.URLUtils.normalizePathnameEncoding(new URL(h.url, d));
                        G.URLUtils.getUrlWithoutHash(m) === e && (p = !0);
                    } catch (D) {
                        c.logWarning("readingOrder", "Invalid resource URL found: " + h.url);
                    }
                }
                m = r(a.resources);
                for(f = m.next(); !f.done; f = m.next()){
                    f = f.value;
                    try {
                        var l = G.URLUtils.normalizePathnameEncoding(new URL(f.url, d));
                        G.URLUtils.getUrlWithoutHash(l) === e && (g = !0);
                    } catch (D) {
                        c.logWarning("resources", "Invalid resource URL found: " + f.url);
                    }
                }
                p || g || c.logWarning(null, 'Entry page URL not found in either "resources" or "readingOrder"');
            }
            a.name || (a.name = []);
            0 === a.name.length && b && (l = b.A.documentElement.getAttribute("lang"), m = b.A.documentElement.getAttribute("dir"), (p = b.A.querySelector("title")) && a.name.push({
                direction: "ltr" === m || "rtl" === m ? m : void 0,
                language: l || void 0,
                value: p.innerText
            }));
            0 === a.name.length && (c.logWarning("name", 'Property is missing and no "Primary Entry Page" title is available. Defaulting "name" to "Untitled Publication"'), a.name.push({
                direction: "ltr",
                language: "en",
                value: "Untitled Publication"
            }));
            if (S(a)) {
                Pa(c, a);
                l = !1;
                for(m = a.readingOrder.length - 1; 0 <= m; m--)p = a.readingOrder[m], p.encodingFormat ? p.encodingFormat.toLowerCase().startsWith("audio") ? l = !0 : (a.readingOrder.splice(m, 1), c.logWarning("readingOrder", 'Removed non-audio resource "' + p.url + '" with encodingFormat "' + p.encodingFormat + '"')) : c.logWarning("readingOrder", 'Resource with URL "' + p.url + ' is missing the "encodingFormat" property.');
                l || c.logError("readingOrder", "Must contain at least one audio resource.");
                Ia(a, "Audiobook");
            } else Ia(a, "CreativeWork");
            l = c.g;
            this.h = a;
            this.g = l;
        }
        U.prototype.getValidationErrors = function() {
            return this.g;
        };
        U.prototype.getManifestResourceProvider = function() {
            return this.D;
        };
        U.prototype.getProcessedManifestData = function() {
            return this.h;
        };
        function Ta(a, b) {
            this.m = a;
            this.g = b;
        }
        k = Ta.prototype;
        k.acceptsUrl = function(a) {
            a = V(this, a);
            return this.m.acceptsUrl(a);
        };
        k.fetch = function(a, b) {
            a = V(this, a);
            return this.m.fetch(a, b);
        };
        k.fetchMetadata = function(a, b) {
            a = V(this, a);
            return this.m.fetchMetadata(a, b);
        };
        k.getBackingResourceProvider = function() {
            return this.m;
        };
        k.getBaseUrl = function() {
            return G.URLUtils.cloneUrl(this.g);
        };
        k.getResourceManifest = function() {
            return this.m.getResourceManifest();
        };
        k.isUrlSupportedByBrowser = function(a, b) {
            a = V(this, a);
            return this.m.isUrlSupportedByBrowser(a, b);
        };
        function V(a, b) {
            return K(b) ? G.URLUtils.normalizePathnameEncoding(new URL(b, a.g)) : b;
        }
        function Ua(a) {
            this.g = a;
            this.j = [];
            this.h = 0;
            this.l = [];
            this.o = [];
            this.v = [];
            this.B = [];
            this.F = [];
            this.P = [];
            Va(this);
        }
        k = Ua.prototype;
        k.getAll = function() {
            return this.j;
        };
        k.getIdentifiers = function() {
            return this.o;
        };
        k.getLanguages = function() {
            return this.B;
        };
        k.getTitles = function() {
            return this.P;
        };
        k.toJSON = function() {
            return {
                all: this.j,
                identifierIndexes: this.l,
                languageIndexes: this.v,
                titleIndexes: this.F,
                type: F.PublicationMetadataType.WP_PUBLICATION_METADATA
            };
        };
        function Va(a) {
            Object.keys(a.g).forEach(function(b) {
                var c;
                switch(b){
                    case "abridged":
                        (c = a.g[b]) && W(a, b, [
                            {
                                content: {
                                    dir: null,
                                    lang: null,
                                    value: c + ""
                                },
                                contentScheme: null,
                                property: {
                                    name: b,
                                    namespace: X(b)
                                },
                                refinedBy: []
                            }
                        ]);
                        break;
                    case "accessMode":
                    case "accessModeSufficient":
                    case "accessibilityFeature":
                    case "accessibilityHazard":
                    case "conformsTo":
                    case "inLanguage":
                    case "type":
                    case "url":
                        (c = a.g[b]) && W(a, b, Wa(b, c));
                        break;
                    case "accessibilitySummary":
                        (c = a.g[b]) && W(a, b, [
                            Xa(b, c)
                        ]);
                        break;
                    case "name":
                        (c = a.g[b]) && W(a, b, Ya(b, c));
                        break;
                    case "artist":
                    case "author":
                    case "colorist":
                    case "contributor":
                    case "creator":
                    case "editor":
                    case "illustrator":
                    case "inker":
                    case "letterer":
                    case "penciler":
                    case "publisher":
                    case "readBy":
                    case "translator":
                        (c = a.g[b]) && W(a, b, Za(b, c));
                        break;
                    case "dateModified":
                    case "datePublished":
                    case "direction":
                    case "duration":
                    case "id":
                    case "readingProgression":
                        (c = a.g[b]) && W(a, b, [
                            $a(b, c)
                        ]);
                        break;
                    case "links":
                    case "readingOrder":
                    case "resources":
                        (c = a.g[b]) && W(a, b, ab(b, c));
                }
            });
        }
        function W(a, b, c) {
            c = r(c);
            for(var d = c.next(); !d.done; d = c.next())d = d.value, a.j.push(d), "inLanguage" === b ? (a.B.push(d), a.v.push(a.h)) : "id" === b ? (a.o.push(d), a.l.push(a.h)) : "name" === b && (a.P.push(d), a.F.push(a.h)), a.h++;
        }
        function ab(a, b) {
            return b.map(function(c) {
                return {
                    content: {
                        dir: null,
                        lang: null,
                        value: c.url
                    },
                    contentScheme: null,
                    property: {
                        name: a,
                        namespace: X(a)
                    },
                    refinedBy: []
                };
            });
        }
        function Za(a, b) {
            var c = [];
            b.forEach(function(d) {
                var e = c.push, g = e.apply;
                d = bb(a, d);
                if (!(d instanceof Array)) {
                    d = r(d);
                    for(var f, h = []; !(f = d.next()).done;)h.push(f.value);
                    d = h;
                }
                g.call(e, c, d);
            });
            return c;
        }
        function bb(a, b) {
            var c = X(a);
            return b.name.map(function(d) {
                var e;
                return {
                    content: {
                        dir: cb(d.direction),
                        lang: null != (e = d.language) ? e : null,
                        value: d.value
                    },
                    contentScheme: null,
                    property: {
                        name: a,
                        namespace: c
                    },
                    refinedBy: []
                };
            });
        }
        function Ya(a, b) {
            return b.map(function(c) {
                return Xa(a, c);
            });
        }
        function cb(a) {
            return "ltr" === a ? E.TextDirection.LTR : "rtl" === a ? E.TextDirection.RTL : null;
        }
        function Xa(a, b) {
            return {
                content: {
                    dir: cb(b.direction),
                    lang: b.language || null,
                    value: b.value
                },
                contentScheme: null,
                property: {
                    name: a,
                    namespace: X(a)
                },
                refinedBy: []
            };
        }
        function Wa(a, b) {
            return b.map(function(c) {
                return $a(a, c);
            });
        }
        function $a(a, b) {
            return {
                content: {
                    dir: null,
                    lang: null,
                    value: b
                },
                contentScheme: null,
                property: {
                    name: a,
                    namespace: X(a)
                },
                refinedBy: []
            };
        }
        function X(a) {
            a = db[a];
            return K(a) ? a : null;
        }
        var db = {
            accessibilityFeature: "https://schema.org/",
            accessibilityHazard: "https://schema.org/",
            accessMode: "https://schema.org/",
            accessModeSufficient: "https://schema.org/",
            alternate: "https://www.w3.org/ns/pub-vocab/manifest#",
            artist: "https://schema.org/",
            author: "https://schema.org/",
            colorist: "https://schema.org/",
            conformsTo: "http://purl.org/dc/terms/",
            contributor: "https://schema.org/",
            creator: "https://schema.org/",
            duration: "https://schema.org/",
            editor: "https://schema.org/",
            encodingFormat: "https://schema.org/",
            identifier: "https://schema.org/",
            illustrator: "https://schema.org/",
            inker: "https://schema.org/",
            inLanguage: "https://schema.org/",
            integrity: "https://www.w3.org/ns/pub-vocab/manifest-vocab/manifest#",
            V: "https://www.w3.org/ns/pub-vocab/manifest#",
            letterer: "https://schema.org/",
            links: "https://www.w3.org/ns/pub-vocab/manifest-vocab/manifest#",
            penciler: "https://schema.org/",
            publisher: "https://schema.org/",
            readBy: "https://schema.org/",
            readingOrder: "https://www.w3.org/ns/pub-vocab/manifest#",
            rel: "https://www.w3.org/ns/pub-vocab/manifest#",
            resources: "https://www.w3.org/ns/pub-vocab/manifest#",
            translator: "https://schema.org/"
        };
        function Y(a) {
            this.h = void 0;
            this.j = !1;
            this.l = void 0;
            this.m = a.m;
            this.s = a.s;
            this.G = a.G;
            this.H = a.H;
            this.g = new U(a.D, a.N, a.M ? null : a.s);
            this.o = new Ua(this.g.getProcessedManifestData());
        }
        function eb(a) {
            var b;
            return C(function(c) {
                if (1 == c.g) return z(c, qa.ZipResourceProvider.createFromBlob(a), 2);
                b = c.h;
                return c.return(fb(b, b.getCentralDirectorySha1Signature(), function() {
                    return b.destroy();
                }));
            });
        }
        function fb(a, b, c) {
            var d, e, g, f;
            return C(function(h) {
                switch(h.g){
                    case 1:
                        return h.o = 2, z(h, a.fetchMetadata("publication.json"), 4);
                    case 4:
                        return h.return(gb(a, "publication.json", b, c));
                    case 2:
                        d = g = A(h);
                    case 3:
                        return h.o = 5, z(h, a.fetchMetadata(Z), 7);
                    case 7:
                        return h.return(hb(a, Z, b, c));
                    case 5:
                        e = f = A(h);
                    case 6:
                        throw new Q("PARSE_ERROR", 'Failed to load WpPublication from publication.json or index.html. "publication.json" error: ' + d + ', "index.html" error: ' + e);
                }
            });
        }
        function gb(a, b, c, d, e) {
            e = void 0 === e ? !1 : e;
            var g, f, h, n, u, p;
            return C(function(m) {
                switch(m.g){
                    case 1:
                        if (K(b)) try {
                            b = G.URLUtils.normalizePathnameEncoding(new URL(b, a.getBaseUrl() || void 0));
                        } catch (l) {
                            throw new Q("INVALID_RESOURCE_URL", "Invalid manifest URL specified: " + b);
                        }
                        return z(m, a.fetch(b), 2);
                    case 2:
                        return g = m.h, z(m, g.asText(), 3);
                    case 3:
                        f = m.h;
                        h = new Ta(a, b);
                        if (e) {
                            n = null;
                            m.g = 4;
                            break;
                        }
                        return z(m, ib(a), 5);
                    case 5:
                        n = m.h;
                    case 4:
                        return u = n, p = {
                            m: a,
                            M: !0,
                            s: u,
                            G: c,
                            D: h,
                            N: f,
                            H: d
                        }, m.return(new Y(p));
                }
            });
        }
        function hb(a, b, c, d) {
            var e, g, f, h, n, u, p, m;
            return C(function(l) {
                if (1 == l.g) {
                    if (K(b)) try {
                        b = G.URLUtils.normalizePathnameEncoding(new URL(b, a.getBaseUrl() || void 0));
                    } catch (D) {
                        throw new Q("INVALID_RESOURCE_URL", "Invalid Primary Entry Page URL specified: " + b);
                    }
                    return z(l, jb(a, b), 2);
                }
                if (3 != l.g) {
                    e = l.h;
                    if (f = null == (g = e.querySelector("base")) ? void 0 : g.getAttribute("href")) try {
                        h = G.URLUtils.normalizePathnameEncoding(new URL(f, b));
                    } catch (D) {
                        E.Logger.logError(new Q("PARSE_ERROR", "<base> element in the primary entry page has an invalid href: " + f + ". Reason: " + D)), h = b;
                    }
                    else h = b;
                    return z(l, kb(e, a, h), 3);
                }
                n = l.h;
                u = n.U;
                p = n.T;
                m = {
                    m: a,
                    M: !1,
                    s: {
                        A: e,
                        I: b
                    },
                    G: c,
                    D: new Ta(a, p),
                    N: u,
                    H: d
                };
                return l.return(new Y(m));
            });
        }
        function lb(a, b) {
            var c;
            return C(function(d) {
                if (1 == d.g) return z(d, qa.ZipResourceProvider.createFromRandomAccessDataSource(a, b), 2);
                c = d.h;
                return d.return(fb(c, c.getCentralDirectorySha1Signature(), function() {
                    return c.destroy();
                }));
            });
        }
        function kb(a, b, c) {
            var d, e, g, f, h, n, u, p, m;
            return C(function(l) {
                switch(l.g){
                    case 1:
                        f = null == (g = a.querySelector('link[rel="publication"]')) ? void 0 : g.getAttribute("href");
                        if (!f) {
                            if (h = a.querySelector('script[type="application/ld+json"]')) e = h.innerHTML, d = c;
                            else throw new Q("MANIFEST_NOT_FOUND", 'Unable to find <link rel="publication" /> or <script type="application/ld+json"> in primary entry page containing the Publication Manifest.');
                            l.g = 2;
                            break;
                        }
                        if (f.startsWith("#")) {
                            n = a.querySelector(f);
                            if (!n) throw new Q("INVALID_RESOURCE_URL", 'Failed to fetch the publication manifest from the <link rel="publication"> element with href: ' + f);
                            e = n.innerHTML;
                            d = c;
                            l.g = 2;
                            break;
                        }
                        l.o = 4;
                        u = G.URLUtils.normalizePathnameEncoding(new URL(f, c));
                        return z(l, b.fetch(u), 6);
                    case 6:
                        return p = l.h, z(l, p.asText(), 7);
                    case 7:
                        e = l.h;
                        l.g = 5;
                        l.o = 0;
                        break;
                    case 4:
                        throw m = A(l), new Q("INVALID_RESOURCE_URL", 'Failed to fetch the publication manifest from the <link rel="publication"> element with href: ' + f + ". Reason: " + m);
                    case 5:
                        d = u;
                    case 2:
                        return l.return({
                            T: d,
                            U: e
                        });
                }
            });
        }
        function ib(a) {
            return C(function(b) {
                return b.return(a.fetchMetadata(Z).then(function() {
                    var c = G.URLUtils.normalizePathnameEncoding(new URL(Z, a.getBaseUrl() || void 0));
                    return jb(a, c).then(function(d) {
                        return {
                            A: d,
                            I: c
                        };
                    });
                }).catch(function() {
                    return null;
                }));
            });
        }
        function jb(a, b) {
            var c, d, e, g, f, h;
            return C(function(n) {
                if (1 == n.g) return z(n, a.fetch(b), 2);
                if (3 != n.g) return c = n.h, z(n, c.asText(), 3);
                d = n.h;
                e = c.getMetadata();
                g = new sa.XhtmlParser(d, e.pathRelativeToBaseUrl || e.url, !0);
                f = g.getDocument();
                if (!f) throw new Q("PARSE_ERROR", "Failed to parse entry page as HTML: " + (null == (h = g.getParserError()) ? void 0 : h.textContent));
                return n.return(f);
            });
        }
        k = Y.prototype;
        k.destroy = function() {
            if (!this.j) {
                this.j = !0;
                var a;
                null == (a = this.H) || a.call(this);
            }
        };
        k.getBackingResourceProvider = function() {
            return this.m;
        };
        k.getCoverImageResourceUrl = function() {
            if (void 0 === this.h) {
                var a = this.g.getProcessedManifestData();
                if (a = a.readingOrder.concat(a.resources).find(function(b) {
                    return R(b, "cover");
                })) try {
                    this.h = new URL(a.url, this.g.getManifestResourceProvider().getBaseUrl());
                } catch (b) {
                    E.Logger.logError(new Q("INVALID_RESOURCE_URL", 'Invalid "cover" resource URL: ' + a.url)), this.h = null;
                }
                else this.h = null;
            }
            return this.h;
        };
        k.getDefaultLayout = function() {
            return F.ContentDocumentLayout.REFLOWABLE;
        };
        k.getHashSignature = function() {
            return this.G;
        };
        k.getManifest = function() {
            return this.g;
        };
        k.getMetadata = function() {
            return this.o;
        };
        k.getNavigationResourceUrl = function() {
            var a = null;
            if (this.s && this.s.A.querySelector("[role=doc-toc]")) a = this.s.I;
            else {
                var b = this.getSpine().find(function(c) {
                    return R(c.getLinkedResource(), "contents");
                });
                if (b) a = b.getContentUrl();
                else if (b = this.g.getProcessedManifestData().resources.find(function(c) {
                    return R(c, "contents");
                })) try {
                    a = new URL(b.url, this.g.getManifestResourceProvider().getBaseUrl());
                } catch (c) {
                    E.Logger.logError(new Q("INVALID_RESOURCE_URL", "Invalid resource URL " + b.url));
                }
            }
            return a;
        };
        k.getPageProgressionDirection = function() {
            switch(this.g.getProcessedManifestData().readingProgression){
                case "ltr":
                    return F.PageProgressionDirection.LTR;
                case "rtl":
                    return F.PageProgressionDirection.RTL;
            }
            return F.PageProgressionDirection.AUTO;
        };
        k.getPreferredFlowMode = function() {
            return F.ContentDocumentFlowMode.AUTO;
        };
        k.getPreferredOrientation = function() {
            return F.PublicationOrientation.AUTO;
        };
        k.getPreferredSyntheticSpreadBehavior = function() {
            return F.SyntheticSpreadBehavior.AUTO;
        };
        k.getProfiles = function() {
            return this.g.getProcessedManifestData().conformsTo;
        };
        k.getSpine = function() {
            var a = this;
            this.l || (this.l = this.g.getProcessedManifestData().readingOrder.map(function(b, c) {
                return new xa(a, c, b);
            }));
            return this.l;
        };
        k.getType = function() {
            return F.PublicationType.WP;
        };
        k.isDestroyed = function() {
            return this.j;
        };
        k.toJSON = function() {
            var a;
            return {
                coverImageUrl: (null == (a = this.getCoverImageResourceUrl()) ? void 0 : a.toString()) || null,
                defaultLayout: this.getDefaultLayout(),
                hashSignature: this.getHashSignature(),
                manifest: this.g.getProcessedManifestData(),
                manifestValidationErrors: this.g.getValidationErrors(),
                metadata: this.getMetadata().toJSON(),
                pageProgressionDirection: this.getPageProgressionDirection(),
                preferredFlowMode: this.getPreferredFlowMode(),
                preferredOrientation: this.getPreferredOrientation(),
                preferredSyntheticSpreadBehavior: this.getPreferredSyntheticSpreadBehavior(),
                spine: this.getSpine().map(function(b) {
                    return b.toJSON();
                }),
                type: F.PublicationType.WP
            };
        };
        var Z = "index.html";
        Y.createFromBlob = function(a) {
            return eb(a);
        };
        Y.createFromPrimaryEntryPageUrl = function(a, b, c, d) {
            return hb(a, b, c, d);
        };
        Y.createFromManifestUrl = function(a, b, c, d) {
            return gb(a, b, c, d, !0);
        };
        Y.createFromRandomAccessDataSource = function(a, b) {
            return lb(a, b);
        };
        Y.createFromResourceProvider = function(a, b, c) {
            return fb(a, b, c);
        };
        api = {
            WpPublication: Y,
            WpPublicationError: Q,
            WpPublicationErrorType: {
                INVALID_MANIFEST: "INVALID_MANIFEST",
                INVALID_RESOURCE_URL: "INVALID_RESOURCE_URL",
                MANIFEST_NOT_FOUND: "MANIFEST_NOT_FOUND",
                NOT_IMPLEMENTED: "NOT_IMPLEMENTED",
                PARSE_ERROR: "PARSE_ERROR",
                RESOURCE_PROVIDER_MISSING_BASE_URL: "RESOURCE_PROVIDER_MISSING_BASE_URL"
            }
        };
        var mb = new ArrayBuffer(8);
        new DataView(mb);
        new Uint8Array(mb);
    }).call(__self);
    return api;
});

});

parcelRegister("kxrNj", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";



(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("7uZag")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_io_mediatypedetector) {
    var api = {};
    (function() {
        var f = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, g;
        if ("function" == typeof Object.setPrototypeOf) g = Object.setPrototypeOf;
        else {
            var h;
            a: {
                var k = {
                    a: !0
                }, l = {};
                try {
                    l.__proto__ = k;
                    h = l.a;
                    break a;
                } catch (a) {}
                h = !1;
            }
            g = h ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var m = g;
        var n = __dep__colibrio_core_base;
        var p = __dep__colibrio_core_io_base;
        var q = __dep__colibrio_core_io_mediatypedetector;
        var r = new Uint16Array(1);
        r[0] = 4660;
        new Uint8Array(r.buffer);
        function t(a, b) {
            return n.ColibrioError.call(this, "colibrio.core.media", a, b) || this;
        }
        var v = n.ColibrioError;
        t.prototype = f(v.prototype);
        t.prototype.constructor = t;
        if (m) m(t, v);
        else for(var w in v)if ("prototype" != w) {
            if (Object.defineProperties) {
                var x = Object.getOwnPropertyDescriptor(v, w);
                x && Object.defineProperty(t, w, x);
            } else t[w] = v[w];
        }
        function y(a) {
            this.g = a;
        }
        function z(a, b) {
            return (a.g[b] << 8) + a.g[b + 1];
        }
        function A(a, b) {
            return a.g[b] + (a.g[b + 1] << 8);
        }
        function B(a, b) {
            return (a.g[b] << 24 >>> 0) + (a.g[b + 1] << 16) + (a.g[b + 2] << 8) + a.g[b + 3];
        }
        function C(a, b, c) {
            a.g[b] = c & 255;
            a.g[b + 1] = c >>> 8 & 255;
        }
        function E(a) {
            if (2 > a.length) return null;
            var b = new y(a);
            if (255 !== a[0] || 216 !== a[1]) return null;
            for(var c = 2;;){
                if (a.length < c + 2 || 255 != a[c++]) return null;
                for(var d = a[c++]; 255 === d;)d = a[c++];
                var e;
                208 <= d && 217 >= d || 1 === d ? e = 0 : 221 === d ? e = 4 : 192 <= d && 254 >= d ? b.g.length < c + 2 ? e = null : e = z(b, c) : e = null;
                if (null === e) return null;
                if (192 <= d && 207 >= d && 196 != d && 200 != d && 204 != d) {
                    if (a.length < c + e) return null;
                    if (7 <= e) return {
                        height: z(b, c + 3),
                        width: z(b, c + 5)
                    };
                }
                if (217 === d || 218 === d) return null;
                c += e;
            }
        }
        function F() {
            this.h = this.g = void 0;
            this.i = new TextDecoder("utf-8");
        }
        var G;
        F.prototype.decode = function(a) {
            return 2 <= a.length && 254 === a[0] && 255 === a[1] && (void 0 === this.g && (this.g = H("utf-16be")), this.g) ? this.g.decode(a) : 2 <= a.length && 255 === a[0] && 254 === a[1] && (void 0 === this.h && (this.h = H("utf-16le")), this.h) ? this.h.decode(a) : this.i.decode(a);
        };
        function H(a) {
            try {
                return new TextDecoder(a);
            } catch (b) {
                return console.error(b), null;
            }
        }
        function I(a) {
            return 32 === a || 9 === a || 13 === a || 10 === a;
        }
        function J(a) {
            switch(a[15]){
                case 32:
                    if (30 > a.length) a = null;
                    else {
                        var b = new y(a);
                        a = 157 !== a[23] || 1 !== a[24] || 42 !== a[25] ? null : {
                            height: A(b, 28) & 16383,
                            width: A(b, 26) & 16383
                        };
                    }
                    return a;
                case 76:
                    return 25 > a.length || 47 !== a[20] ? a = null : (a = new y(a), a = a.g[21] + (a.g[22] << 8) + (a.g[23] << 16) + (a.g[24] << 24 >>> 0), a = {
                        height: (a >> 14 & 16383) + 1,
                        width: (a & 16383) + 1
                    }), a;
                case 88:
                    return 30 > a.length ? a = null : (a = new y(a), a = {
                        height: a.g[27] + (a.g[28] << 8) + (a.g[29] << 16) + 1,
                        width: a.g[24] + (a.g[25] << 8) + (a.g[26] << 16) + 1
                    }), a;
            }
            return null;
        }
        api = {
            ColibrioMediaError: t,
            ColibrioMediaErrorType: {
                MEDIA_LOAD_TIMEOUT: "MEDIA_LOAD_TIMEOUT"
            },
            ImageUtils: {
                createBlankGifImageData: function(a, b) {
                    var c = new Uint8Array(35), d = new y(c);
                    c[0] = 71;
                    c[1] = 73;
                    c[2] = 70;
                    c[3] = 56;
                    c[4] = 57;
                    c[5] = 97;
                    C(d, 6, a);
                    C(d, 8, b);
                    c[10] = 128;
                    c[19] = 44;
                    C(d, 24, 1);
                    C(d, 26, 1);
                    c[29] = 2;
                    c[30] = 2;
                    c[31] = 68;
                    c[32] = 1;
                    c[33] = 0;
                    c[34] = 59;
                    return c;
                },
                createBlankSvgImageDataUri: function(a, b, c) {
                    return "data:image/svg+xml;base64," + btoa('<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="' + a + '" height="' + b + '" viewBox="0 0 ' + a + " " + b + '">\n    <path d="M0 0h' + a + "v" + b + 'H0z" fill="' + c + '"/>\n</svg>\n');
                },
                getImageDimensions: function(a) {
                    var b = q.MediaTypeDetector.detectFromUint8Array(a);
                    if (b === p.MediaType.IMAGE_JPEG) var c = E(a);
                    else if (b === p.MediaType.IMAGE_GIF) 10 > a.length ? c = null : (c = new y(a), c = {
                        height: A(c, 8),
                        width: A(c, 6)
                    });
                    else if (b === p.MediaType.IMAGE_PNG) a: if (24 > a.length) c = null;
                    else {
                        c = [
                            73,
                            72,
                            68,
                            82
                        ];
                        for(var d = 0; d < c.length; d++)if (a[d + 12] !== c[d]) {
                            c = null;
                            break a;
                        }
                        c = new y(a);
                        c = {
                            height: B(c, 20),
                            width: B(c, 16)
                        };
                    }
                    else if (b === p.MediaType.IMAGE_BMP) 24 > a.length ? c = null : (c = new y(a), c = {
                        height: A(c, 22),
                        width: A(c, 18)
                    });
                    else {
                        a: if (16 > a.length) b = !1;
                        else {
                            b = [
                                87,
                                69,
                                66,
                                80
                            ];
                            for(var e = 0; e < b.length; e++)if (a[e + 8] !== b[e]) {
                                b = !1;
                                break a;
                            }
                            b = !0;
                        }
                        if (b) c = J(a);
                        else {
                            for(b = 0; I(a[b]);)b++;
                            60 !== a[b] || 63 !== a[b + 1] && 115 !== a[b + 1] && 83 !== a[b + 1] ? c = null : (G || (G = new F), a = G.decode(a), b = a.match(/<svg[^>]*width\s*=\s*["']?(\d+)["']?[^>]*>/), e = a.match(/<svg[^>]*height\s*=\s*["']?(\d+)["']?[^>]*>/), b && 2 <= b.length && e && 2 <= e.length ? (c = parseInt(b[1]), d = parseInt(e[1])) : (a = a.match(/<svg[^>]*viewBox\s*=\s*["']([-]?\d+\s+[-]?\d+\s+\d+\s+\d+\s*)["'][^>]*>/)) && 2 <= a.length && (a = a[1].split(" "), 4 === a.length && (c = parseInt(a[2]), d = parseInt(a[3]))), c = c && d ? {
                                height: d,
                                width: c
                            } : null);
                        }
                    }
                    return c;
                },
                waitUntilImageLoaded: function(a, b) {
                    return a.complete ? Promise.resolve() : new Promise(function(c, d) {
                        function e() {
                            D();
                            d();
                        }
                        function u() {
                            D();
                            c();
                        }
                        function D() {
                            a.removeEventListener("load", u, !1);
                            a.removeEventListener("error", e, !1);
                            a.removeEventListener("abort", e, !1);
                            clearTimeout(L);
                        }
                        var L = setTimeout(function() {
                            console.warn("ImageUtils.waitUntilImageLoaded() timed out.");
                            u();
                        }, b);
                        a.addEventListener("load", u, !1);
                        a.addEventListener("error", e, !1);
                        a.addEventListener("abort", e, !1);
                    });
                }
            }
        };
        var K = new ArrayBuffer(8);
        new DataView(K);
        new Uint8Array(K);
    }).call(__self);
    return api;
});

});

parcelRegister("9mLnx", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";



(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("bkFGj")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_selector_base) {
    var api = {};
    (function() {
        var h;
        function aa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        function q(a) {
            if (!(a instanceof Array)) {
                var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
                if (b) a = b.call(a);
                else if ("number" == typeof a.length) a = {
                    next: aa(a)
                };
                else throw Error(String(a) + " is not an iterable or ArrayLike");
                for(var c = []; !(b = a.next()).done;)c.push(b.value);
                a = c;
            }
            return a;
        }
        var ca = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, da;
        if ("function" == typeof Object.setPrototypeOf) da = Object.setPrototypeOf;
        else {
            var ea;
            a: {
                var fa = {
                    a: !0
                }, ha = {};
                try {
                    ha.__proto__ = fa;
                    ea = ha.a;
                    break a;
                } catch (a) {}
                ea = !1;
            }
            da = ea ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var ia = da;
        function ja(a, b) {
            a.prototype = ca(b.prototype);
            a.prototype.constructor = a;
            if (ia) ia(a, b);
            else for(var c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.F = b.prototype;
        }
        var ka = __dep__colibrio_core_base;
        var u = __dep__colibrio_core_selector_base;
        function v(a) {
            return 0 < a.length ? a[a.length - 1] : void 0;
        }
        function x(a) {
            return a && 9 === a.nodeType;
        }
        function z(a) {
            return a && 1 === a.nodeType;
        }
        function la(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), e = 0; e < d.length; e++){
                var f = d[e], g = a[f];
                null !== g && "object" === typeof g ? b[f] = la(g, b[f], c) : "undefined" === typeof g ? c && delete b[f] : b[f] = g;
            }
            return b;
        }
        var ma = Array.isArray;
        function A(a) {
            return "number" === typeof a && !isNaN(a);
        }
        function B(a) {
            for(var b = 0; a = a.previousSibling;)b++;
            return b;
        }
        var na = new Uint16Array(1);
        na[0] = 4660;
        new Uint8Array(na.buffer);
        function C(a, b) {
            return ka.ColibrioError.call(this, "colibrio.core.selector.epubcfi", a, b) || this;
        }
        ja(C, ka.ColibrioError);
        function D(a) {
            switch(a.type){
                case "ASSERTION_GENERIC":
                    return oa(a);
                case "ASSERTION_TEXT_LOCATION":
                    return pa(a);
                case "ASSERTION_XML_ID":
                    return qa(a);
            }
        }
        function E(a) {
            return {
                indirection: a.indirection,
                srcOffset: a.srcOffset,
                steps: a.steps.map(function(b) {
                    return F(b);
                }),
                type: a.type
            };
        }
        function G(a) {
            switch(a.type){
                case "OFFSET_CHARACTER":
                    return {
                        assertion: a.assertion ? D(a.assertion) : null,
                        characterOffset: a.characterOffset,
                        srcOffset: a.srcOffset,
                        type: a.type
                    };
                case "OFFSET_SPATIAL":
                    return {
                        assertion: a.assertion ? D(a.assertion) : null,
                        srcOffset: a.srcOffset,
                        type: a.type,
                        x: a.x,
                        y: a.y
                    };
                case "OFFSET_TEMPORAL":
                    return {
                        assertion: a.assertion ? D(a.assertion) : null,
                        seconds: a.seconds,
                        srcOffset: a.srcOffset,
                        type: a.type,
                        x: a.x,
                        y: a.y
                    };
            }
        }
        function ra(a) {
            return {
                complete: a.complete,
                localPaths: a.localPaths.map(function(b) {
                    return E(b);
                }),
                offset: a.offset ? G(a.offset) : null,
                srcOffset: a.srcOffset,
                type: a.type
            };
        }
        function H(a) {
            return {
                errors: [],
                parentPath: a.parentPath ? ra(a.parentPath) : null,
                rangeEndPath: a.rangeEndPath ? ra(a.rangeEndPath) : null,
                rangeStartPath: a.rangeStartPath ? ra(a.rangeStartPath) : null,
                src: a.src,
                srcModified: a.srcModified,
                srcOffset: a.srcOffset,
                type: a.type
            };
        }
        function F(a) {
            switch(a.type){
                case "STEP_ELEMENT":
                    return {
                        assertion: a.assertion ? qa(a.assertion) : null,
                        srcOffset: a.srcOffset,
                        stepValue: a.stepValue,
                        type: a.type
                    };
                case "STEP_TEXT":
                    return {
                        assertion: a.assertion ? D(a.assertion) : null,
                        srcOffset: a.srcOffset,
                        stepValue: a.stepValue,
                        type: a.type
                    };
            }
        }
        function J() {
            return {
                complete: !1,
                localPaths: [],
                offset: null,
                type: "PATH"
            };
        }
        function sa() {
            return {
                indirection: !1,
                steps: [],
                type: "LOCAL_PATH"
            };
        }
        function ta() {
            return {
                errors: [],
                parentPath: null,
                rangeEndPath: null,
                rangeStartPath: null,
                src: "",
                srcModified: !1,
                type: "ROOT"
            };
        }
        function va(a) {
            return {
                name: a.name,
                srcOffset: a.srcOffset,
                type: a.type,
                values: a.values.slice()
            };
        }
        function oa(a) {
            return {
                parameters: a.parameters.map(function(b) {
                    return va(b);
                }),
                srcOffset: a.srcOffset,
                type: a.type
            };
        }
        function pa(a) {
            return {
                parameters: a.parameters.map(function(b) {
                    return va(b);
                }),
                srcOffset: a.srcOffset,
                textAfter: a.textAfter,
                textBefore: a.textBefore,
                type: a.type
            };
        }
        function qa(a) {
            return {
                parameters: a.parameters.map(function(b) {
                    return va(b);
                }),
                srcOffset: a.srcOffset,
                type: a.type,
                xmlId: a.xmlId
            };
        }
        function wa(a) {
            var b = [
                "epubcfi("
            ];
            a.parentPath && xa(a.parentPath, b);
            if (a.rangeStartPath || a.rangeEndPath) b.push(","), a.rangeStartPath && xa(a.rangeStartPath, b), a.rangeEndPath && (b.push(","), xa(a.rangeEndPath, b));
            b.push(")");
            return b.join("");
        }
        function ya(a, b) {
            b.push("[");
            "ASSERTION_XML_ID" === a.type ? a.xmlId && b.push(K(a.xmlId)) : "ASSERTION_TEXT_LOCATION" === a.type && (a.textBefore && b.push(K(a.textBefore)), a.textAfter && b.push(",", K(a.textAfter)));
            for(var c = 0; c < a.parameters.length; c++){
                var d = a.parameters[c];
                b.push(";", K(d.name));
                for(var e = "=", f = 0; f < d.values.length; f++)b.push(e, K(d.values[f])), e = ",";
            }
            b.push("]");
        }
        function xa(a, b) {
            for(var c = 0; c < a.localPaths.length; c++){
                var d = a.localPaths[c], e = b;
                d.indirection && e.push("!");
                for(var f = 0; f < d.steps.length; f++){
                    var g = d.steps[f], k = e;
                    k.push("/", g.stepValue);
                    g.assertion && ya(g.assertion, k);
                }
            }
            a.offset && (a = a.offset, "OFFSET_CHARACTER" === a.type ? b.push(":", a.characterOffset) : "OFFSET_SPATIAL" === a.type ? b.push("@", a.x, ":", a.y) : "OFFSET_TEMPORAL" === a.type && (b.push("~", a.seconds), A(a.x) && A(a.y) && b.push("@", a.x, ":", a.y)), a.assertion && ya(a.assertion, b));
        }
        function K(a) {
            return a.replace(/[\^\[\]\(\),;=]/g, function(b) {
                return "^" + b;
            });
        }
        function za(a, b, c, d) {
            var e = null;
            if (z(a)) {
                var f = b < a.childNodes.length ? a.childNodes[b] : null;
                z(f) ? d = L(f, d) : f ? (d = L(a, d), d.push(Aa(f)), e = Ba(f)) : (d = L(a, d), d.push({
                    assertion: null,
                    stepValue: 0 === b ? 0 : 2 * a.childElementCount + 2,
                    type: "STEP_ELEMENT"
                }));
            } else if (z(a.parentNode)) a === d ? d = null : (d = L(a.parentNode, d), d.push(Aa(a))), (e = Ba(a)) && a && 3 === a.nodeType && (e.characterOffset += b);
            else throw new C("CONTAINER_NOT_ATTACHED_TO_DOCUMENT", "" + a);
            c || (c = J());
            d && c.localPaths.push({
                indirection: 0 < c.localPaths.length,
                steps: d,
                type: "LOCAL_PATH"
            });
            c.offset = e;
        }
        function Ba(a) {
            if (z(a)) return null;
            a = a.previousSibling;
            for(var b = 0; a && !z(a);)a && 3 === a.nodeType && (b += a.data.length), a = a.previousSibling;
            return {
                assertion: null,
                characterOffset: b,
                type: "OFFSET_CHARACTER"
            };
        }
        function Ca(a, b) {
            return {
                indirection: b,
                steps: L(a),
                type: "LOCAL_PATH"
            };
        }
        function L(a, b) {
            for(var c = [], d = []; a.parentNode && !x(a.parentNode) && a !== b;)c.push(a), a = a.parentNode;
            for(a = c.length - 1; 0 <= a; a--){
                b = c[a];
                var e = null;
                b.id && (e = {
                    parameters: [],
                    type: "ASSERTION_XML_ID",
                    xmlId: b.id
                });
                d.push({
                    assertion: e,
                    stepValue: 2 * (Da(b) + 1),
                    type: "STEP_ELEMENT"
                });
            }
            return d;
        }
        function Aa(a) {
            for(a = a.previousSibling; a && !z(a);)a = a.previousSibling;
            return {
                assertion: null,
                stepValue: a ? 2 * Da(a) + 3 : 1,
                type: "STEP_TEXT"
            };
        }
        function Da(a) {
            for(var b = 0; a = a.previousElementSibling;)b++;
            return b;
        }
        function M(a) {
            this.h = a ? a : ta();
        }
        h = M.prototype;
        h.appendLocalPathTo = function(a) {
            if (this.h.rangeStartPath || this.h.rangeEndPath) throw new C("RANGE_PATHS_ALREADY_SET");
            a = L(a);
            this.h.parentPath || (this.h.parentPath = J());
            this.h.parentPath.localPaths.push({
                indirection: 0 < this.h.parentPath.localPaths.length,
                steps: a,
                type: "LOCAL_PATH"
            });
        };
        h.appendTerminalDomPosition = function(a, b) {
            b = Math.round(b);
            if (this.h.rangeStartPath || this.h.rangeEndPath) throw new C("RANGE_PATHS_ALREADY_SET");
            this.h.parentPath || (this.h.parentPath = J());
            za(a, b, this.h.parentPath);
        };
        h.appendTerminalDomRange = function(a) {
            var b = this.h;
            b || (b = ta());
            if (a.collapsed) b.parentPath || (b.parentPath = J()), za(a.startContainer, a.startOffset, b.parentPath);
            else {
                b.parentPath || (b.parentPath = J());
                if (b.rangeStartPath || b.rangeEndPath) throw new C("RANGE_PATHS_ALREADY_SET");
                b.rangeStartPath = J();
                b.rangeEndPath = J();
                za(a.startContainer, a.startOffset, b.rangeStartPath, a.commonAncestorContainer);
                za(a.endContainer, a.endOffset, b.rangeEndPath, a.commonAncestorContainer);
                var c = 0 < b.parentPath.localPaths.length;
                if (z(a.commonAncestorContainer)) b.parentPath.localPaths.push(Ca(a.commonAncestorContainer, c));
                else if (z(a.commonAncestorContainer.parentNode)) c = Ca(a.commonAncestorContainer.parentNode, c), c.steps.push(Aa(a.commonAncestorContainer)), b.parentPath.localPaths.push(c);
                else throw new C("CONTAINER_NOT_ATTACHED_TO_DOCUMENT", "" + a.commonAncestorContainer);
            }
        };
        h.appendTerminalIndirection = function() {
            if (this.h.rangeStartPath || this.h.rangeEndPath) throw new C("RANGE_PATHS_ALREADY_SET");
            this.h.parentPath || (this.h.parentPath = J());
            this.h.parentPath.localPaths.push({
                indirection: !0,
                steps: [
                    {
                        assertion: null,
                        stepValue: 0,
                        type: "STEP_ELEMENT"
                    }
                ],
                type: "LOCAL_PATH"
            });
        };
        h.clone = function() {
            var a = la(this.h, {}, !1);
            return new M(a);
        };
        h.collapseToEnd = function() {
            this.h.rangeEndPath && Ea(this, this.h.rangeEndPath);
        };
        h.collapseToStart = function() {
            this.h.rangeStartPath && Ea(this, this.h.rangeStartPath);
        };
        h.getEpubCfiRootNode = function() {
            return this.h;
        };
        h.prependLocalPathTo = function(a) {
            a = L(a);
            this.h.parentPath || (this.h.parentPath = J());
            var b = this.h.parentPath.localPaths[0];
            b && (b.indirection = !0);
            this.h.parentPath.localPaths.unshift({
                indirection: !1,
                steps: a,
                type: "LOCAL_PATH"
            });
        };
        h.toString = function() {
            return wa(this.h);
        };
        function Ea(a, b) {
            a.h.rangeStartPath = null;
            a.h.rangeEndPath = null;
            a.h.parentPath || (a.h.parentPath = J());
            a = a.h.parentPath;
            if (a.localPaths) {
                var c = b.localPaths;
                c = 0 < c.length ? c[0] : void 0;
                var d = v(a.localPaths);
                c && (d && !c.indirection && (d.steps.push.apply(d.steps, q(c.steps)), b.localPaths.shift()), a.localPaths.push.apply(a.localPaths, q(b.localPaths)));
            } else a.localPaths = b.localPaths;
            a.offset = b.offset;
        }
        function N(a) {
            var b = u.FragmentSelector.call(this) || this;
            b.h = a;
            b.m = "";
            return b;
        }
        ja(N, u.FragmentSelector);
        h = N.prototype;
        h.collapseToStart = function() {
            if (!this.isRangeSelector()) return this;
            var a = new M(H(this.h));
            a.collapseToStart();
            return new N(a.getEpubCfiRootNode());
        };
        h.collapseToEnd = function() {
            if (!this.isRangeSelector()) return this;
            var a = new M(H(this.h));
            a.collapseToEnd();
            return new N(a.getEpubCfiRootNode());
        };
        h.createRangeSelectorTo = function(a) {
            if (!(a instanceof N)) return null;
            var b = this.h.parentPath;
            this.h.rangeStartPath && (b = new M(H(this.h)), b.collapseToStart(), b = b.getEpubCfiRootNode().parentPath);
            var c = a.h.parentPath;
            a.h.rangeEndPath && (c = new M(H(a.h)), c.collapseToEnd(), c = c.getEpubCfiRootNode().parentPath);
            if (!c || !b) return null;
            a = ta();
            for(var d = J(), e = J(), f = J(), g = Math.min(b.localPaths.length, c.localPaths.length), k = !1, l = 0; !k && l < g;){
                var n = b.localPaths[l], p = c.localPaths[l];
                if (n.indirection !== p.indirection) k = !0;
                else {
                    var m = n.steps;
                    p = p.steps;
                    for(var y = Math.min(m.length, p.length), t = 0; !k && t < y;){
                        var w = m[t];
                        var r = p[t];
                        w.stepValue !== r.stepValue || w.assertion && !r.assertion || !w.assertion && r.assertion ? r = !1 : (w = w.assertion, r = r.assertion, r = w && r ? Fa(w, r) : !0);
                        r ? t++ : k = !0;
                    }
                    m.length !== p.length && (k = !0);
                    if (k) {
                        if (0 < t) {
                            y = sa();
                            y.indirection = n.indirection;
                            for(n = 0; n < t; n++)y.steps.push(F(m[n]));
                            d.localPaths.push(y);
                            if (t < m.length) {
                                n = sa();
                                for(y = t; y < m.length; y++)n.steps.push(F(m[y]));
                                e.localPaths.push(n);
                            }
                            if (t < p.length) {
                                for(m = sa(); t < p.length; t++)m.steps.push(F(p[t]));
                                f.localPaths.push(m);
                            }
                            l++;
                        }
                    } else d.localPaths.push(E(n)), l++;
                }
            }
            b.localPaths.length !== c.localPaths.length && (k = !0);
            if (k) {
                for(g = l; g < b.localPaths.length; g++)e.localPaths.push(E(b.localPaths[g]));
                for(; l < c.localPaths.length; l++)f.localPaths.push(E(c.localPaths[l]));
                b.offset && (e.offset = G(b.offset));
                c.offset && (f.offset = G(c.offset));
            } else b = b.offset, c = c.offset, b && !c || !b && c || b && c && !Ga(b, c) ? (e.offset = b ? G(b) : null, f.offset = c ? G(c) : null, k = !0) : d.offset = b ? G(b) : null;
            a.parentPath = d;
            k && (a.rangeStartPath = e, a.rangeEndPath = f);
            return new N(a);
        };
        h.getFragmentSpecificationIri = function() {
            return u.FragmentSpecificationIri.EPUB3;
        };
        h.getRefinementSelectors = function() {
            return [];
        };
        h.getRootNode = function() {
            return this.h;
        };
        h.getValue = function() {
            this.m || (this.m = wa(this.h));
            return this.m;
        };
        h.isRangeSelector = function() {
            return !!this.h.rangeEndPath;
        };
        function Fa(a, b) {
            if (a.type !== b.type || a.parameters.length !== b.parameters.length || !a.parameters.every(function(c, d) {
                var e = b.parameters[d];
                return c.name === e.name && c.values.length === e.values.length && c.values.every(function(f, g) {
                    return f === e.values[g];
                });
            })) return !1;
            switch(a.type){
                case "ASSERTION_TEXT_LOCATION":
                    if (a.textAfter !== b.textAfter || a.textBefore !== b.textBefore) return !1;
                    break;
                case "ASSERTION_XML_ID":
                    if (a.xmlId !== b.xmlId) return !1;
            }
            return !0;
        }
        function Ga(a, b) {
            if (a.type !== b.type) return !1;
            switch(a.type){
                case "OFFSET_CHARACTER":
                    if (a.characterOffset !== b.characterOffset) return !1;
                    break;
                case "OFFSET_SPATIAL":
                    if (a.x !== b.x || a.y !== b.y) return !1;
                    break;
                case "OFFSET_TEMPORAL":
                    if (a.seconds !== b.seconds || a.x !== b.x || a.y !== b.y) return !1;
            }
            if (a.assertion && !b.assertion || !a.assertion && b.assertion) return !1;
            a = a.assertion;
            b = b.assertion;
            return a && b ? Fa(a, b) : !0;
        }
        function O(a) {
            this.g = a;
            this.i = 0;
        }
        O.prototype.next = function() {
            return this.g[this.i++];
        };
        O.prototype.peek = function() {
            return this.g[this.i];
        };
        function Ha(a) {
            this.j = !1;
            this.i = void 0;
            this.src = "string" === typeof a ? a.replace(/[^\x09\x0A\x0D\u0020-\uFFFD]/g, "") : "";
            var b = this.src.indexOf("epubcfi(");
            0 < b && (this.src = this.src.substring(b));
            -1 === b ? (this.g = 0, this.j = !0, this.i = {
                srcOffset: 0,
                type: -1,
                value: this.src
            }) : (this.g = 8, this.i = {
                srcOffset: 0,
                type: 0,
                value: "epubcfi("
            });
            this.srcModified = this.src !== a;
        }
        Ha.prototype.next = function() {
            if (void 0 !== this.i) {
                var a = this.i;
                this.i = void 0;
                return a;
            }
            return Ia(this);
        };
        Ha.prototype.peek = function() {
            void 0 === this.i && (this.i = Ia(this));
            return this.i;
        };
        function Ia(a) {
            if (!a.j) {
                var b = a.g++, c = a.src.charCodeAt(b);
                if (33 === c) b = P(40, "!", b);
                else if (44 === c) b = P(41, ",", b);
                else if (47 === c) {
                    for(var d = c = a.g; Q(a.src.charCodeAt(c));)c++;
                    a.g = c;
                    b = d === c ? P(-1, "/", b) : {
                        srcOffset: d,
                        type: 11,
                        value: Number(a.src.substring(d, c))
                    };
                } else if (58 === c) b = P(42, ":", b);
                else if (64 === c) b = P(45, "@", b);
                else if (126 === c) b = P(46, "~", b);
                else if (91 === c) {
                    c = !0;
                    for(d = []; c;){
                        var e = void 0, f = a.g++, g = a.src.charCodeAt(f);
                        if (44 === g) e = P(41, ",", f);
                        else if (59 === g) e = P(43, ";", f);
                        else if (61 === g) e = P(44, "=", f);
                        else if (93 === g) c = !1;
                        else if (isNaN(g)) e = P(-2, "", f), c = !1;
                        else if (91 === g || 40 === g || 41 === g) e = P(-1, String.fromCharCode(g), f);
                        else {
                            e = a;
                            for(var k = g = f, l = !1, n = "", p = !0; p;){
                                var m = e.src.charCodeAt(g);
                                94 === m ? (m = e.src.charCodeAt(g + 1), isNaN(m) ? p = !1 : (n += e.src.substring(k, g), 55296 <= m && 56319 >= m ? (n += String.fromCharCode(m, e.src.charCodeAt(g + 2)), g += 3) : (n += String.fromCharCode(m), g += 2), k = g)) : 91 === m || 93 === m || 40 === m || 41 === m || 44 === m || 59 === m || 61 === m || isNaN(m) ? p = !1 : (32 === m && (l = !0), g++);
                            }
                            e.g = g;
                            e = {
                                C: l,
                                srcOffset: f,
                                type: 30,
                                value: n + e.src.substring(k, g)
                            };
                        }
                        e && d.push(e);
                    }
                    b = {
                        srcOffset: b,
                        type: 20,
                        value: d
                    };
                } else if (41 === c) b = P(1, ")", b), a.j = !0;
                else if (isNaN(c)) b = P(-2, "", b), a.j = !0;
                else if (Q(c)) {
                    for(c = a.g; Q(d = a.src.charCodeAt(c));)c++;
                    if (46 === d && Q(a.src.charCodeAt(c + 1))) for(c += 2; Q(a.src.charCodeAt(c));)c++;
                    a.g = c;
                    b = {
                        srcOffset: b,
                        type: 10,
                        value: Number(a.src.substring(b, c))
                    };
                } else {
                    for(c = a.g; Ja(a.src.charCodeAt(c));)c++;
                    a.g = c;
                    b = P(-1, a.src.substring(b, c), b);
                }
                return b;
            }
        }
        function P(a, b, c) {
            return {
                srcOffset: c,
                type: a,
                value: b
            };
        }
        function Ja(a) {
            return 128 < a || 97 <= a && 122 >= a || 65 <= a && 97 >= a;
        }
        function Q(a) {
            return 48 <= a && 57 >= a;
        }
        function S(a, b) {
            var c;
            if (b && !ma(b) && "object" === typeof b) {
                var d = b.srcOffset;
                "string" === typeof b.value ? c = b.value : c = ma(b.value) ? "[" + b.value.map(function(e) {
                    return e.value;
                }).join("") + "]" : "" + b.value;
            } else d = b;
            return {
                srcOffset: d,
                type: a,
                value: c || ""
            };
        }
        function T(a) {
            this.errors = [];
            this.g = new Ha(a);
        }
        T.prototype.parse = function() {
            var a = null, b = null, c = null;
            if (U(this, 0, "INVALID_EPUBCFI_START")) {
                a = Ka(this);
                var d = this.g.peek();
                d && 41 === d.type && (this.g.next(), b = Ka(this), U(this, 41, "MISSING_END_RANGE") && (c = Ka(this)));
                U(this, 1, "INVALID_EPUBCFI_END");
            }
            return {
                errors: this.errors,
                parentPath: a,
                rangeEndPath: c,
                rangeStartPath: b,
                src: this.g.src,
                srcModified: this.g.srcModified,
                srcOffset: 0,
                type: "ROOT"
            };
        };
        function U(a, b, c, d, e) {
            e = e || a.g;
            var f = e.peek();
            if (f && f.type === b) return e.next();
            V(a, c, f || {
                srcOffset: d ? d.srcOffset : a.g.g,
                type: -2,
                value: ""
            });
        }
        function La(a, b) {
            var c = Ma(a, new O(b.value));
            return 0 === c.length ? (V(a, "INVALID_ASSERTION", b), null) : Na(c, b.srcOffset);
        }
        function Oa(a, b) {
            var c = b.next();
            if (!c) return null;
            if (43 !== c.type) return V(a, "INVALID_PARAMETER", c), null;
            var d = U(a, 30, "INVALID_PARAMETER", c, b);
            if (!d) return null;
            if (d.C) return V(a, "INVALID_PARAMETER", d), null;
            if (!U(a, 44, "INVALID_PARAMETER", d, b)) return null;
            var e = U(a, 30, "INVALID_PARAMETER", c, b);
            if (!e) return null;
            for(var f = [
                e.value
            ], g; (g = b.peek()) && 43 !== g.type;)b.next(), 41 !== g.type ? V(a, "INVALID_PARAMETER", g) : (e = U(a, 30, "INVALID_PARAMETER", g, b)) && f.push(e.value);
            return {
                name: d.value,
                srcOffset: c.srcOffset,
                type: "PARAMETER",
                values: f
            };
        }
        function Ma(a, b) {
            for(var c = []; b.peek();){
                var d = Oa(a, b);
                d && c.push(d);
            }
            return c;
        }
        function Ka(a) {
            var b = [], c = a.g.g, d = null, e = a.g.peek();
            if (e && (11 === e.type || 40 === e.type)) {
                b = !1;
                var f;
                e = [];
                for(var g = !1; !b && (f = a.g.peek());)if (11 === f.type) {
                    for(var k = void 0, l = a, n = []; (k = l.g.peek()) && 11 === k.type;){
                        var p = l, m = l.g.next(), y = 0 === m.value % 2 ? "STEP_ELEMENT" : "STEP_TEXT", t = m ? m.srcOffset : p.g.g, w = null, r = p.g.peek();
                        if (r && 20 === r.type) {
                            if ("STEP_TEXT" === y) w = La(p, p.g.next());
                            else {
                                w = void 0;
                                r = p;
                                p = p.g.next();
                                var I = new O(p.value), ba = null, ua = I.peek();
                                ua && 30 === ua.type && (ba = ua.value, I.next());
                                I = Ma(r, I);
                                null === ba && 0 === I.length && V(r, "INVALID_ASSERTION", p);
                                ba ? w = {
                                    parameters: I,
                                    srcOffset: p.srcOffset,
                                    type: "ASSERTION_XML_ID",
                                    xmlId: ba
                                } : w = Na(I, p.srcOffset);
                            }
                        }
                        n.push({
                            assertion: w,
                            srcOffset: t,
                            stepValue: m.value,
                            type: y
                        });
                    }
                    e.push({
                        indirection: g,
                        srcOffset: f.srcOffset,
                        steps: n,
                        type: "LOCAL_PATH"
                    });
                    g = !1;
                } else 40 === f.type ? (g && V(a, "INVALID_INDIRECTION", f), g = !0, a.g.next()) : b = !0;
                g && f && e.push({
                    indirection: !0,
                    srcOffset: f.srcOffset,
                    steps: [],
                    type: "LOCAL_PATH"
                });
                b = e;
                e = a.g.peek();
            }
            if (f = e) f = e.type, f = 46 === f || 45 === f || 42 === f;
            if (f) {
                d = null;
                if (f = a.g.peek()) {
                    if (46 === f.type) {
                        var R = a.g.next();
                        if (d = U(a, 10, "INVALID_TEMPORAL_OFFSET", R)) {
                            f = a.g.peek();
                            g = e = null;
                            if (f && 45 === f.type) {
                                if (e = Pa(a, a.g.next())) g = e.assertion;
                                f = a.g.peek();
                            }
                            !g && f && 20 === f.type && (g = La(a, a.g.next()));
                            d = {
                                assertion: g,
                                seconds: d.value,
                                srcOffset: R.srcOffset,
                                type: "OFFSET_TEMPORAL",
                                x: e ? e.x : null,
                                y: e ? e.y : null
                            };
                        } else d = null;
                    } else 45 === f.type ? d = Pa(a, a.g.next()) : 42 === f.type && (d = a.g.next(), (f = U(a, 10, "INVALID_CHARACTER_OFFSET", d)) ? (e = null, (g = a.g.peek()) && 20 === g.type && (e = a.g.next(), l = new O(e.value), k = g = null, (n = l.peek()) && 30 === n.type && (g = n, l.next(), n = l.peek()), n && 41 === n.type && (l.next(), k = U(a, 30, "INVALID_ASSERTION", n, l)), l = Ma(a, l), null === g && null === k && 0 === l.length ? (V(a, "INVALID_ASSERTION", e), e = null) : (g || k ? R = {
                        parameters: l,
                        srcOffset: e.srcOffset,
                        textAfter: k ? k.value : null,
                        textBefore: g ? g.value : null,
                        type: "ASSERTION_TEXT_LOCATION"
                    } : R = Na(l, e.srcOffset), e = R)), d = {
                        assertion: e,
                        characterOffset: f.value,
                        srcOffset: d.srcOffset,
                        type: "OFFSET_CHARACTER"
                    }) : d = null);
                }
                e = a.g.peek();
            }
            return {
                complete: !!e && (41 === e.type || 1 === e.type),
                localPaths: b,
                offset: d,
                srcOffset: c,
                type: "PATH"
            };
        }
        function Pa(a, b) {
            var c = U(a, 10, "INVALID_SPATIAL_OFFSET", b);
            if (!c) return null;
            var d = c.value;
            if (0 > d || 100 < d) V(a, "INVALID_SPATIAL_OFFSET_VALUE", c), d = 0 > d ? 0 : 100 < d ? 100 : d;
            c = U(a, 42, "INVALID_SPATIAL_OFFSET", c);
            if (!c) return null;
            var e = U(a, 10, "INVALID_SPATIAL_OFFSET", c);
            if (!e) return null;
            c = e.value;
            if (0 > c || 100 < c) V(a, "INVALID_SPATIAL_OFFSET_VALUE", e), c = 0 > c ? 0 : 100 < c ? 100 : c;
            e = a.g.peek();
            var f = null;
            e && 20 === e.type && (f = La(a, a.g.next()));
            return {
                assertion: f,
                srcOffset: b.srcOffset,
                type: "OFFSET_SPATIAL",
                x: d,
                y: c
            };
        }
        function V(a, b, c) {
            a.errors.push(S(b, c));
        }
        T.isEpubCfi = Qa;
        T.parse = Ra;
        function Na(a, b) {
            return {
                parameters: a,
                srcOffset: b,
                type: "ASSERTION_GENERIC"
            };
        }
        function Qa(a) {
            return 0 <= a.indexOf("epubcfi(");
        }
        function Ra(a) {
            return new T(a).parse();
        }
        function Sa() {}
        Sa.prototype.canParseFragment = function(a) {
            return a.startsWith("epubcfi(");
        };
        Sa.prototype.getFragmentSpecificationIri = function() {
            return u.FragmentSpecificationIri.EPUB3;
        };
        Sa.prototype.parseFragment = function(a) {
            a = Ra(a);
            return a.parentPath ? new N(a) : null;
        };
        function W(a, b, c, d, e, f) {
            this.repairedWithXmlIdAssertions = this.missingXmlIdAssertions = !1;
            this.resolverErrors = [];
            this.stepsResolved = !0;
            this.ast = a;
            this.documentUrl = b;
            this.container = c;
            this.offset = d;
            this.isOpfDocument = "package" === this.getDocument().documentElement.nodeName;
            this.intendedTargetType = e;
            this.virtualTarget = f;
        }
        W.prototype.createResolverError = function(a, b, c) {
            this.resolverErrors.push({
                documentUrl: this.documentUrl,
                errorData: c,
                node: b,
                type: a
            });
        };
        W.prototype.getDocument = function() {
            return x(this.container) ? this.container : this.container.ownerDocument;
        };
        W.prototype.getTargetElement = function() {
            if ("ELEMENT" === this.intendedTargetType && null === this.virtualTarget && (z(this.container) || x(this.container))) {
                var a = this.container.childNodes[this.offset];
                return z(a) ? a : null;
            }
            return null;
        };
        W.prototype.getTargetNode = function() {
            var a = null;
            null === this.virtualTarget && (a = z(this.container) || x(this.container) ? this.container.childNodes[this.offset] : this.container);
            return a;
        };
        function Ta(a, b, c) {
            this.j = a;
            this.g = b;
            this.i = c;
        }
        function Ua(a) {
            for(var b = a.j.steps, c = 0; c < b.length; c++){
                var d = b[c];
                if ("STEP_ELEMENT" === d.type) {
                    var e = a;
                    e.g.intendedTargetType = "ELEMENT";
                    if (e.g.virtualTarget) Va(e, d) && (e.g.stepsResolved = !0, e.g.virtualTarget = null);
                    else if (z(e.i)) {
                        var f = e, g = e.i, k = d, l = k.stepValue / 2 - 1, n = g.children, p = n.length;
                        0 <= l && l < p ? f.i = n[l] : 0 > l ? f.g.virtualTarget = "FIRST_CHILD" : (f.g.virtualTarget = "LAST_CHILD", l !== p && (f.g.createResolverError("STEP_VALUE_OUT_OF_BOUNDS", g, k), f.g.stepsResolved = !1));
                        Va(e, d);
                    }
                } else if (f = a, g = d, f.g.intendedTargetType = "TEXT", !f.g.virtualTarget && z(f.i)) {
                    if (e = void 0, d = f, f = f.i, k = g, g = (k.stepValue >> 1) - 1, g < f.childElementCount) {
                        if (k = -1 === g ? 0 : B(f.children[g]) + 1, k < f.childNodes.length) {
                            for(g = f = f.childNodes[k]; !e && g && !z(g);)g && 3 === g.nodeType && (e = g), g = g.nextSibling;
                            d.i = e || f;
                        } else d.g.virtualTarget = -1 === g ? "FIRST_CHILD" : "LAST_CHILD";
                    } else d.g.virtualTarget = "LAST_CHILD", d.g.createResolverError("STEP_VALUE_OUT_OF_BOUNDS", f, k), d.g.stepsResolved = !1;
                }
            }
            a.g.virtualTarget ? (a.g.container = a.i, a.g.offset = "FIRST_CHILD" === a.g.virtualTarget ? 0 : a.i.childNodes.length) : (a.g.container = a.i.parentNode, a.g.offset = B(a.i));
            return a.g;
        }
        function Va(a, b) {
            var c = !1, d = a.i;
            if ((b = b.assertion) && b.xmlId) {
                if (null !== a.g.virtualTarget || !z(d) || d.id !== b.xmlId) {
                    var e = d.ownerDocument.getElementById(b.xmlId);
                    !e || "itemref" === d.nodeName && "itemref" !== e.nodeName ? a.g.createResolverError("XML_ID_ASSERTION_FAILED", d, b) : (a.i = e, a.g.repairedWithXmlIdAssertions = !0, a.g.virtualTarget = null, c = !0);
                }
            } else null === a.g.virtualTarget && z(d) && d.id && (a.g.missingXmlIdAssertions = !0);
            return c;
        }
        function Wa(a, b) {
            this.characterOffsetOutOfBounds = !1;
            this.elementCharacterOffset = null;
            this.indirectionsResolved = !0;
            this.spatialOffset = this.sideBias = null;
            this.stepsResolved = !0;
            this.temporalOffset = null;
            this.ast = a;
            this.localPaths = [];
            this.addResolvedLocalPath(b);
        }
        h = Wa.prototype;
        h.addResolvedLocalPath = function(a) {
            this.localPaths.push(a);
            this.stepsResolved = a.stepsResolved;
            this.container = a.container;
            this.documentUrl = a.documentUrl;
            this.intendedTargetType = a.intendedTargetType;
            this.offset = a.offset;
            this.virtualTarget = a.virtualTarget;
        };
        h.getDocument = function() {
            return x(this.container) ? this.container : this.container.ownerDocument;
        };
        h.getResolverErrors = function() {
            for(var a = [], b = 0; b < this.localPaths.length; b++){
                var c = this.localPaths[b];
                0 < c.resolverErrors.length && a.push.apply(a, q(c.resolverErrors));
            }
            return a;
        };
        h.getTargetElement = function() {
            return v(this.localPaths).getTargetElement();
        };
        h.getTargetNode = function() {
            return v(this.localPaths).getTargetNode();
        };
        h.getTerminalLocalPath = function() {
            return v(this.localPaths);
        };
        h.isMissingXmlIdAssertions = function() {
            return this.localPaths.some(function(a) {
                return a.missingXmlIdAssertions;
            });
        };
        h.isRepairedWithXmlIdAssertions = function() {
            return this.localPaths.some(function(a) {
                return a.repairedWithXmlIdAssertions;
            });
        };
        h.isTargetingOpfDocument = function() {
            return v(this.localPaths).isOpfDocument;
        };
        function Xa(a) {
            this.indirectionErrors = [];
            this.rangeStartPath = this.rangeEndPath = this.parentPath = null;
            this.ast = a;
        }
        h = Xa.prototype;
        h.createDomRange = function() {
            if (this.isTargetingOpfDocument()) return null;
            var a = null;
            if (this.rangeStartPath && this.rangeEndPath) {
                var b = this.rangeStartPath.getDocument();
                a = b.createRange();
                a.setStart(this.rangeStartPath.container, this.rangeStartPath.offset);
                this.rangeEndPath.getDocument() === b && a.setEnd(this.rangeEndPath.container, this.rangeEndPath.offset);
            } else this.parentPath && (a = this.parentPath.getDocument().createRange(), a.setStart(this.parentPath.container, this.parentPath.offset));
            return a;
        };
        h.getElementCharacterOffsets = function() {
            return Ya(this, "elementCharacterOffset", {
                characterOffset: 0
            });
        };
        h.getParserErrors = function() {
            return this.ast.errors;
        };
        h.getResolverErrors = function() {
            for(var a = [], b = [
                this.parentPath,
                this.rangeStartPath,
                this.rangeEndPath
            ], c = 0; c < b.length; c++){
                var d = b[c];
                d && a.push.apply(a, q(d.getResolverErrors()));
            }
            return a;
        };
        h.getSideBias = function() {
            return !this.parentPath || this.rangeStartPath || this.rangeEndPath ? null : this.parentPath.sideBias;
        };
        h.getSpatialOffsets = function() {
            return Ya(this, "spatialOffset", {
                x: 0,
                y: 0
            });
        };
        h.getTargetElement = function() {
            if (this.rangeStartPath && this.rangeEndPath) {
                var a = this.rangeStartPath.getTargetElement();
                return null !== a && a === this.rangeEndPath.getTargetElement() ? a : null;
            }
            return this.parentPath ? this.parentPath.getTargetElement() : null;
        };
        h.getTemporalOffsets = function() {
            return Ya(this, "temporalOffset", {
                seconds: 0
            });
        };
        h.hasElementOffsets = function() {
            return null !== this.getSpatialOffsets() || null !== this.getTemporalOffsets() || null !== this.getElementCharacterOffsets();
        };
        h.hasErrors = function() {
            return !this.hasParentPathOrRangePaths() || this.isTargetingOpfDocument() || !this.isEveryIndirectionResolved() || 0 < this.ast.errors.length || !this.isEveryStepAndOffsetParsed() || !this.isEveryStepResolved() || this.isSomeCharacterOffsetOutOfBounds();
        };
        h.hasParentPathOrRangePaths = function() {
            return null !== this.parentPath && (null === this.rangeStartPath && null === this.rangeStartPath || null !== this.rangeStartPath && null !== this.rangeEndPath);
        };
        h.hasRangePaths = function() {
            return null !== this.rangeStartPath && null !== this.rangeEndPath;
        };
        h.hasWarnings = function() {
            return this.isMissingXmlIdAssertions() || this.isRepairedWithXmlIdAssertions();
        };
        h.isDomRange = function() {
            var a = this.rangeStartPath, b = this.rangeEndPath;
            return !!a && !!b && !this.isTargetingOpfDocument() && a.getDocument() === b.getDocument() && (a.container !== b.container || a.offset !== b.offset);
        };
        h.isEveryIndirectionResolved = function() {
            return 0 === this.indirectionErrors.length;
        };
        h.isEveryStepAndOffsetParsed = function() {
            return null !== this.ast.parentPath && this.ast.parentPath.complete && (!this.ast.rangeStartPath || this.ast.rangeStartPath.complete) && (!this.ast.rangeEndPath || this.ast.rangeEndPath.complete);
        };
        h.isEveryStepResolved = function() {
            return null !== this.parentPath && this.parentPath.stepsResolved && (!this.rangeStartPath || this.rangeStartPath.stepsResolved) && (!this.rangeEndPath || this.rangeEndPath.stepsResolved);
        };
        h.isMissingXmlIdAssertions = function() {
            return null !== this.parentPath && this.parentPath.isMissingXmlIdAssertions() || null !== this.rangeStartPath && this.rangeStartPath.isMissingXmlIdAssertions() || null !== this.rangeEndPath && this.rangeEndPath.isMissingXmlIdAssertions();
        };
        h.isOwnedBySingleDocument = function() {
            return this.rangeStartPath && this.rangeEndPath ? this.rangeStartPath.getDocument() === this.rangeEndPath.getDocument() : !0;
        };
        h.isRepairedWithXmlIdAssertions = function() {
            return null !== this.parentPath && this.parentPath.isRepairedWithXmlIdAssertions() || null !== this.rangeStartPath && this.rangeStartPath.isRepairedWithXmlIdAssertions() || null !== this.rangeEndPath && this.rangeEndPath.isRepairedWithXmlIdAssertions();
        };
        h.isSomeCharacterOffsetOutOfBounds = function() {
            return [
                this.parentPath,
                this.rangeStartPath,
                this.rangeEndPath
            ].some(function(a) {
                return null !== a && a.characterOffsetOutOfBounds;
            });
        };
        h.isTargetingElement = function() {
            return null !== this.getTargetElement();
        };
        h.isTargetingOpfDocument = function() {
            return this.rangeStartPath && this.rangeEndPath ? this.rangeStartPath.isTargetingOpfDocument() || this.rangeEndPath.isTargetingOpfDocument() : null !== this.parentPath && this.parentPath.isTargetingOpfDocument();
        };
        function Ya(a, b, c) {
            var d = null, e = a.rangeStartPath, f = a.rangeEndPath;
            e && f ? f[b] ? d = {
                end: f[b],
                start: e[b] || c
            } : e[b] && (d = {
                end: null,
                start: e[b]
            }) : (a = a.parentPath) && a[b] && (d = {
                end: null,
                start: a[b]
            });
            return d;
        }
        function Za(a) {
            var b = a.ast.offset;
            if ("ELEMENT" === a.intendedTargetType && b && a.stepsResolved) {
                if ("OFFSET_TEMPORAL" === b.type) a.temporalOffset = {
                    seconds: b.seconds
                }, A(b.x) && A(b.y) && (a.spatialOffset = {
                    x: b.x,
                    y: b.y
                });
                else if ("OFFSET_SPATIAL" === b.type) a.spatialOffset = {
                    x: b.x,
                    y: b.y
                };
                else if ("OFFSET_CHARACTER" === b.type) {
                    var c = a.getTargetElement();
                    c && "img" === c.localName && (a.elementCharacterOffset = b.characterOffset);
                }
            } else "TEXT" === a.intendedTargetType && (c = !1, b && ("OFFSET_CHARACTER" === b.type && a.stepsResolved && ($a(a, b.characterOffset), c = !0), b.assertion && (c = !0)), c || $a(a, 0));
        }
        function $a(a, b) {
            for(var c = a.getTargetNode(), d = []; c && !z(c);)c && 3 === c.nodeType && d.push(c), c = c.nextSibling;
            0 < d.length ? (c = d.find(function(e) {
                if (b < e.length) return !0;
                b -= e.length;
                return !1;
            })) ? (a.container = c, a.offset = b) : (d = d[d.length - 1], a.container = d, a.offset = d.data.length, a.characterOffsetOutOfBounds = 0 !== b) : 0 < b && (a.characterOffsetOutOfBounds = !0);
        }
        function X(a) {
            this.o = 0;
            this.B = !1;
            this.u = this.s = 0;
            this.A = !1;
            this.h = a = "string" === typeof a ? Ra(a) : a;
            this.l = a.parentPath;
            this.j = a.rangeStartPath;
            this.i = a.rangeEndPath;
            this.g = new Xa(a);
        }
        X.prototype.continueResolving = function(a, b) {
            var c = null;
            x(a) ? c = a.documentElement : a && 11 === a.nodeType && z(a.firstChild) ? c = a.firstChild : z(a) && a.parentNode && (c = a);
            if (!c) {
                var d;
                this.g.indirectionErrors.push({
                    from: null,
                    fromPath: (null == (d = ab(this)) ? void 0 : d.documentUrl) || null,
                    target: c,
                    targetPath: b
                });
                return null;
            }
            if (this.l) a: {
                for(a = bb(this, 1, c, b); this.l;){
                    if (Y(this, 1)) {
                        this.g.parentPath && (this.g.parentPath.indirectionsResolved = !1);
                        break a;
                    }
                    cb(this, 1, a, b);
                }
                db(this, a, b);
                eb(this, a, b);
            }
            else this.j ? (a = bb(this, 2, c, b), db(this, a, b)) : this.i && (a = bb(this, 3, c, b), eb(this, a, b));
            b = ab(this);
            fb(this);
            return b;
        };
        X.prototype.getResolvedTarget = function() {
            return this.g;
        };
        X.prototype.skipNextIndirection = function() {
            gb(this);
            var a = ab(this);
            fb(this);
            return a;
        };
        X.prototype.addResolvedLocalPath = function(a, b) {
            a: {
                switch(a){
                    case 1:
                        var c = this.g.parentPath;
                        break a;
                    case 3:
                        c = this.g.rangeEndPath;
                        break a;
                    case 2:
                        c = this.g.rangeStartPath;
                        break a;
                }
                c = void 0;
            }
            if (c) c.addResolvedLocalPath(b), c.indirectionsResolved = !0;
            else switch(a){
                case 1:
                    c = this.g.parentPath = new Wa(this.h.parentPath, b);
                    break;
                case 2:
                    c = this.g.rangeStartPath = new Wa(this.h.rangeStartPath, b);
                    break;
                case 3:
                    c = this.g.rangeEndPath = new Wa(this.h.rangeEndPath, b);
            }
            return c;
        };
        function hb(a, b) {
            var c = null;
            switch(b){
                case 1:
                    a.l && (c = Z(a.l, a.o++), Z(a.l, a.o) || (a.l = null));
                    break;
                case 2:
                    a.j && (c = Z(a.j, a.u++), Z(a.j, a.u) || (a.j = null));
                    break;
                case 3:
                    a.i && (c = Z(a.i, a.s++), Z(a.i, a.s) || (a.i = null));
            }
            return c;
        }
        function eb(a, b, c) {
            for(; a.i;){
                if (Y(a, 3)) {
                    a.g.rangeEndPath && (a.g.rangeEndPath.indirectionsResolved = !1);
                    break;
                }
                b = cb(a, 3, b, c);
            }
        }
        function db(a, b, c) {
            for(; a.j;){
                if (Y(a, 2)) {
                    a.g.rangeStartPath && (a.g.rangeStartPath.indirectionsResolved = !1);
                    break;
                }
                b = cb(a, 2, b, c);
            }
        }
        function Z(a, b) {
            return b < a.localPaths.length ? a.localPaths[b] : null;
        }
        function ab(a) {
            var b = null, c = null;
            Y(a, 1) ? b = a.g.parentPath : Y(a, 2) ? b = a.g.rangeStartPath || a.g.parentPath : Y(a, 3) && (b = a.g.rangeEndPath || a.g.parentPath);
            b && ((c = b.getTargetElement()) ? c = {
                documentUrl: b.documentUrl,
                element: c
            } : (a.g.indirectionErrors.push({
                from: b.getTargetNode(),
                fromPath: b.documentUrl,
                target: null,
                targetPath: null
            }), gb(a), c = ab(a)));
            return c;
        }
        function ib(a) {
            var b = null;
            if (a.ast.offset && a.ast.offset.assertion) b = a.ast.offset.assertion;
            else {
                var c = a.getTerminalLocalPath();
                c.ast && (c = v(c.ast.steps)) && (b = c.assertion);
            }
            b && (b = b.parameters.find(function(d) {
                return "s" === d.name && 0 < d.values.length;
            })) && (a.sideBias = "b" === b.values[0] ? "BEFORE" : "AFTER");
        }
        function gb(a) {
            a.l ? (a.l = null, a.j = null, a.i = null, a.g.parentPath && (a.g.parentPath.indirectionsResolved = !1, a.g.parentPath.stepsResolved = !1)) : a.j ? (a.j = null, a.g.rangeStartPath && (a.g.rangeStartPath.indirectionsResolved = !1, a.g.rangeStartPath.stepsResolved = !1)) : a.i && (a.i = null, a.g.rangeEndPath && (a.g.rangeEndPath.indirectionsResolved = !1, a.g.rangeEndPath.stepsResolved = !1));
        }
        function Y(a, b) {
            var c = !1;
            switch(b){
                case 1:
                    a.l && (a = Z(a.l, a.o), c = null !== a && a.indirection);
                    break;
                case 2:
                    a.j && (a = Z(a.j, a.u), c = null !== a && a.indirection);
                    break;
                case 3:
                    a.i && (a = Z(a.i, a.s), c = null !== a && a.indirection);
            }
            return c;
        }
        function fb(a) {
            !a.g.parentPath || a.l || a.B || (Za(a.g.parentPath), ib(a.g.parentPath), a.B = !0);
            !a.g.rangeStartPath || a.j || a.A || (Za(a.g.rangeStartPath), ib(a.g.rangeStartPath), a.A = !0);
            a.g.rangeEndPath && !a.i && (Za(a.g.rangeEndPath), ib(a.g.rangeEndPath), a.A = !0);
        }
        function cb(a, b, c, d) {
            var e = hb(a, b);
            e ? (c = new W(e, c.documentUrl, c.container, c.offset, c.intendedTargetType, c.virtualTarget), e = new Ta(e, c, c.getTargetNode() || c.container), e = Ua(e)) : e = new W(null, d, c.container, c.offset, c.intendedTargetType, c.virtualTarget);
            return a.addResolvedLocalPath(b, e);
        }
        function bb(a, b, c, d) {
            var e = hb(a, b);
            e ? (d = new W(e, d, c.parentNode, B(c), "ELEMENT", null), c = Ua(new Ta(e, d, c))) : c = new W(null, d, c.parentNode, B(c), "ELEMENT", null);
            return a.addResolvedLocalPath(b, c);
        }
        function jb(a) {
            function b(d) {
                var e = v(d.localPaths);
                e && (e = v(e.steps)) && "STEP_TEXT" === e.type && !d.offset && (d.offset = {
                    assertion: null,
                    characterOffset: 0,
                    type: "OFFSET_CHARACTER"
                }, c = !0);
            }
            var c = !1;
            a.parentPath && b(a.parentPath);
            a.rangeStartPath && b(a.rangeStartPath);
            a.rangeEndPath && b(a.rangeEndPath);
            return c;
        }
        function kb(a, b) {
            var c = !1;
            a.parentPath && 0 !== a.parentPath.localPaths.length && 0 !== a.parentPath.localPaths[0].steps.length ? a.rangeStartPath && !a.rangeEndPath ? (b || a.errors.push(S("MISSING_END_RANGE")), c = !0, a.rangeStartPath = null) : a.rangeEndPath && (0 === a.rangeEndPath.localPaths.length || 0 === a.rangeEndPath.localPaths[0].steps.length && null === a.rangeEndPath.offset) && (b || a.errors.push(S("PATH_EMPTY", a.rangeEndPath.srcOffset)), c = !0, a.rangeStartPath = null, a.rangeEndPath = null) : (b || a.errors.push(S("PATH_EMPTY", a.srcOffset)), c = !0, a.parentPath = null, a.rangeStartPath = null, a.rangeEndPath = null);
            return c;
        }
        function lb(a, b) {
            function c(f) {
                f.offset || (f = v(f.localPaths)) && f.indirection && 0 === f.steps.length && (b || a.errors.push(S("PATH_ENDS_WITH_INDIRECTION", f.srcOffset)), d = !0, f.steps.push({
                    assertion: null,
                    stepValue: 0,
                    type: "STEP_ELEMENT"
                }));
            }
            var d = !1;
            if (a.parentPath && !a.parentPath.offset) {
                var e = v(a.parentPath.localPaths);
                e && e.indirection && 0 === e.steps.length && (b || a.errors.push(S("PATH_ENDS_WITH_INDIRECTION", e.srcOffset)), d = !0, a.rangeStartPath && a.rangeEndPath ? (mb(a.rangeStartPath), mb(a.rangeEndPath), a.parentPath.localPaths.length--) : (e.steps.push({
                    assertion: null,
                    stepValue: 0,
                    type: "STEP_ELEMENT"
                }), a.rangeStartPath = null, a.rangeEndPath = null));
            }
            a.rangeStartPath && c(a.rangeStartPath);
            a.rangeEndPath && c(a.rangeEndPath);
            return d;
        }
        function nb(a, b) {
            var c = !1;
            a.parentPath && (c = ob(a, a.parentPath, b));
            a.rangeStartPath && (c = ob(a, a.rangeStartPath, b) || c);
            a.rangeEndPath && (c = ob(a, a.rangeEndPath, b) || c);
            return c;
        }
        function pb(a, b) {
            var c = !1, d = a.rangeStartPath ? a.rangeStartPath.offset : null, e = a.rangeEndPath ? a.rangeEndPath.offset : null, f = !1;
            if (d && e) d.type !== e.type ? f = !0 : "OFFSET_TEMPORAL" === d.type && (null !== d.x && null === e.x || null === d.x && null !== e.x) && (d.x = null, d.y = null, e.x = null, e.y = null, c = !0);
            else if (!d && e && "OFFSET_CHARACTER" !== e.type || d && !e) f = !0;
            f && (a.rangeStartPath && (a.rangeStartPath.offset = null), a.rangeEndPath && (a.rangeEndPath.offset = null), c = !0);
            c && !b && a.errors.push(S("INCOMPATIBLE_OFFSET_TYPE"));
            return c;
        }
        function qb(a, b) {
            var c = !1;
            if (a.parentPath) {
                var d = a.parentPath.localPaths[0];
                d && d.indirection && (d.indirection = !1, c = !0, b || a.errors.push(S("INVALID_INDIRECTION", d.srcOffset)));
            }
            return c;
        }
        function rb(a, b) {
            var c = !1;
            if (a.parentPath && a.parentPath.offset) {
                var d = a.parentPath.offset;
                d = "OFFSET_TEMPORAL" === d.type && null === d.x;
                a.rangeStartPath && sb(a, a.rangeStartPath, d, b) && (a.rangeStartPath = null, c = !0);
                a.rangeEndPath && sb(a, a.rangeEndPath, d, b) && (a.rangeEndPath = null, c = !0);
            }
            return c;
        }
        function tb(a, b) {
            var c = !1;
            if (a.parentPath) {
                var d = ub(a, a.parentPath, b);
                d.v ? (c = !0, a.rangeStartPath = null, a.rangeEndPath = null) : d.D && (a.rangeStartPath && 0 < a.rangeStartPath.localPaths.length && (c = !0, a.rangeStartPath = null), a.rangeEndPath && 0 < a.rangeEndPath.localPaths.length && (c = !0, a.rangeEndPath = null));
            }
            a.rangeStartPath && (d = ub(a, a.rangeStartPath, b), c = c || d.v);
            a.rangeEndPath && (d = ub(a, a.rangeEndPath, b), c = c || d.v);
            return c;
        }
        function mb(a) {
            if (a.localPaths[0]) a.localPaths[0].indirection = !0;
            else {
                var b = {
                    assertion: null,
                    stepValue: 0,
                    type: "STEP_ELEMENT"
                };
                a.localPaths.push({
                    indirection: !0,
                    steps: a.offset ? [] : [
                        b
                    ],
                    type: "LOCAL_PATH"
                });
            }
        }
        function ub(a, b, c) {
            var d = !1, e = !1, f = b.localPaths.findIndex(function(g) {
                var k = g.steps.findIndex(function(l) {
                    return "STEP_TEXT" === l.type;
                });
                return -1 !== k ? (e = !0, k < g.steps.length - 1 && (c || a.errors.push(S("INVALID_STEP", g.steps[k].srcOffset)), g.steps = g.steps.slice(0, k + 1), b.offset = null, d = !0), !0) : !1;
            });
            -1 !== f && f < b.localPaths.length - 1 && (b.localPaths = b.localPaths.slice(0, f + 1), d = !0);
            return {
                v: d,
                D: e
            };
        }
        function ob(a, b, c) {
            var d = !1;
            if (b.offset) {
                var e = v(b.localPaths);
                e && e.indirection && 0 === e.steps.length && (c || a.errors.push(S("PATH_ENDS_WITH_INDIRECTION", e.srcOffset)), b.localPaths.length--, d = !0);
            }
            return d;
        }
        function sb(a, b, c, d) {
            var e = !1;
            0 < b.localPaths.length ? (d || a.errors.push(S("INVALID_RANGE_PATH", b.srcOffset)), e = !0) : !b.offset || c && "OFFSET_SPATIAL" === b.offset.type || (d || a.errors.push(S("INCOMPATIBLE_OFFSET_TYPE", b.offset.srcOffset)), e = !0);
            return e;
        }
        api = {
            EpubCfiBuilder: M,
            EpubCfiError: C,
            EpubCfiErrorType: {
                RANGE_PATHS_ALREADY_SET: "RANGE_PATHS_ALREADY_SET",
                CONTAINER_NOT_ATTACHED_TO_DOCUMENT: "CONTAINER_NOT_ATTACHED_TO_DOCUMENT"
            },
            EpubCfiFragmentSelectorParser: Sa,
            EpubCfiIntendedTargetType: {
                ELEMENT: "ELEMENT",
                TEXT: "TEXT"
            },
            EpubCfiNodeType: {
                ROOT: "ROOT",
                PATH: "PATH",
                LOCAL_PATH: "LOCAL_PATH",
                STEP_ELEMENT: "STEP_ELEMENT",
                STEP_TEXT: "STEP_TEXT",
                ASSERTION_TEXT_LOCATION: "ASSERTION_TEXT_LOCATION",
                ASSERTION_XML_ID: "ASSERTION_XML_ID",
                ASSERTION_GENERIC: "ASSERTION_GENERIC",
                PARAMETER: "PARAMETER",
                OFFSET_CHARACTER: "OFFSET_CHARACTER",
                OFFSET_TEMPORAL: "OFFSET_TEMPORAL",
                OFFSET_SPATIAL: "OFFSET_SPATIAL"
            },
            EpubCfiParser: T,
            EpubCfiParserErrorType: {
                INVALID_RANGE_PATH: "INVALID_RANGE_PATH",
                INCOMPATIBLE_OFFSET_TYPE: "INCOMPATIBLE_OFFSET_TYPE",
                INVALID_CHARACTER_OFFSET: "INVALID_CHARACTER_OFFSET",
                INVALID_ASSERTION: "INVALID_ASSERTION",
                INVALID_EPUBCFI_START: "INVALID_EPUBCFI_START",
                INVALID_EPUBCFI_END: "INVALID_EPUBCFI_END",
                INVALID_PARAMETER: "INVALID_PARAMETER",
                PATH_ENDS_WITH_INDIRECTION: "PATH_ENDS_WITH_INDIRECTION",
                INVALID_SPATIAL_OFFSET: "INVALID_SPATIAL_OFFSET",
                INVALID_SPATIAL_OFFSET_VALUE: "INVALID_SPATIAL_OFFSET_VALUE",
                INVALID_STEP: "INVALID_STEP",
                INVALID_INDIRECTION: "INVALID_INDIRECTION",
                INVALID_TEMPORAL_OFFSET: "INVALID_TEMPORAL_OFFSET",
                MISSING_END_RANGE: "MISSING_END_RANGE",
                PATH_EMPTY: "PATH_EMPTY"
            },
            EpubCfiResolver: X,
            EpubCfiResolverErrorType: {
                XML_ID_ASSERTION_FAILED: "XML_ID_ASSERTION_FAILED",
                STEP_VALUE_OUT_OF_BOUNDS: "STEP_VALUE_OUT_OF_BOUNDS"
            },
            EpubCfiSelector: N,
            EpubCfiSideBias: {
                BEFORE: "BEFORE",
                AFTER: "AFTER"
            },
            EpubCfiStringifier: {
                stringifyRootNode: wa
            },
            EpubCfiUtils: {
                copyRootNode: H
            },
            EpubCfiValidator: {
                addExplicitCharacterOffsets: jb,
                checkEmptyParentPathAndRangeEnd: kb,
                expandEmptyIndirectionLocalPaths: lb,
                removeEmptyIndirectionBeforeOffsets: nb,
                removeIncompatibleRangeOffsets: pb,
                removeInitialIndirectionFromParentPath: qb,
                removeInvalidRangeAfterParentPathOffset: rb,
                removeStepsAfterTextSteps: tb,
                runAllValidations: function(a, b) {
                    var c = !1;
                    c = tb(a, b) || c;
                    c = qb(a, b) || c;
                    c = rb(a, b) || c;
                    c = pb(a, b) || c;
                    c = kb(a, b) || c;
                    c = jb(a) || c;
                    c = lb(a, b) || c;
                    return c = nb(a, b) || c;
                }
            },
            EpubCfiVirtualTarget: {
                FIRST_CHILD: "FIRST_CHILD",
                LAST_CHILD: "LAST_CHILD"
            }
        };
        var vb = new ArrayBuffer(8);
        new DataView(vb);
        new Uint8Array(vb);
    }).call(__self);
    return api;
});

});

parcelRegister("2ifeC", function(module, exports) {
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";

(function(s, f) {
    if (0, module.exports) module.exports = f(s, (parcelRequire("bkFGj")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : module.exports, function(__self, __dep__colibrio_core_selector_base) {
    var api = {};
    (function() {
        var g, h = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, k;
        if ("function" == typeof Object.setPrototypeOf) k = Object.setPrototypeOf;
        else {
            var l;
            a: {
                var m = {
                    a: !0
                }, n = {};
                try {
                    n.__proto__ = m;
                    l = n.a;
                    break a;
                } catch (a) {}
                l = !1;
            }
            k = l ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var p = k;
        var q = __dep__colibrio_core_selector_base;
        var r = new Uint16Array(1);
        r[0] = 4660;
        new Uint8Array(r.buffer);
        function t(a) {
            var b = a.highlight, c = a.viewRect;
            return {
                highlight: b && new DOMRect(b.x, b.y, b.width, b.height),
                namedDest: a.namedDest,
                pageNumber: a.pageNumber,
                pageRects: a.pageRects && u(a.pageRects),
                viewRect: c && new DOMRect(c.x, c.y, c.width, c.height)
            };
        }
        function u(a) {
            return a.map(function(b) {
                return new DOMRect(b.x, b.y, b.width, b.height);
            });
        }
        function v(a, b, c) {
            c = void 0 === c ? !1 : c;
            var e = q.FragmentSelector.call(this) || this;
            e.g = a;
            e.m = b;
            e.h = c;
            e.l = "";
            a.highlight && ("undefined" === typeof a.pageRects && (a.pageRects = [
                a.highlight
            ]), a.highlight = void 0);
            return e;
        }
        var w = q.FragmentSelector;
        v.prototype = h(w.prototype);
        v.prototype.constructor = v;
        if (p) p(v, w);
        else for(var x in w)if ("prototype" != x) {
            if (Object.defineProperties) {
                var y = Object.getOwnPropertyDescriptor(w, x);
                y && Object.defineProperty(v, x, y);
            } else v[x] = w[x];
        }
        g = v.prototype;
        g.collapseToEnd = function() {
            var a = t(this.g);
            if (this.g.pageRects && 0 < this.g.pageRects.length) {
                var b = z(this.g.pageRects);
                b = new DOMRect(b.right, b.bottom, 0, 0);
                a.pageRects = [
                    b
                ];
            }
            return new v(a, this.m.map(function(c) {
                return c.collapseToEnd();
            }), this.h);
        };
        g.collapseToStart = function() {
            var a = t(this.g);
            if (this.g.pageRects && 0 < this.g.pageRects.length) {
                var b = z(this.g.pageRects);
                b = new DOMRect(b.left, b.top, 0, 0);
                a.pageRects = [
                    b
                ];
            }
            return new v(a, this.m.map(function(c) {
                return c.collapseToStart();
            }), this.h);
        };
        g.createRangeSelectorTo = function(a) {
            if (a instanceof v && (this.g.pageNumber === a.g.pageNumber || "undefined" !== typeof this.g.namedDest && this.g.namedDest === a.g.namedDest)) {
                var b = t(this.g), c, e = null != (c = this.getHighlight()) ? c : new DOMRect(0, 0, 0, 0), d;
                c = null != (d = a.getHighlight()) ? d : new DOMRect(0, 0, 0, 0);
                if (e && c) {
                    d = Math.min(e.left, c.left);
                    var f = Math.min(e.top, c.top);
                    e = new DOMRect(d, f, Math.max(e.right, c.right) - d, Math.max(e.bottom, c.bottom) - f);
                    b.pageRects = [
                        e
                    ];
                }
                return new v(b, [], this.h || a.h);
            }
            return null;
        };
        g.getFragmentSpecificationIri = function() {
            return q.FragmentSpecificationIri.PDF;
        };
        g.getHighlight = function() {
            return this.g.pageRects && 0 < this.g.pageRects.length ? z(this.g.pageRects) : null;
        };
        g.getNamedDest = function() {
            return this.g.namedDest || null;
        };
        g.getPageNumber = function() {
            return this.g.pageNumber || null;
        };
        g.getPageRects = function() {
            if (this.h) return this.g.pageRects || null;
            var a = this.getHighlight();
            return a ? [
                a
            ] : null;
        };
        g.getRefinementSelectors = function() {
            return this.m;
        };
        g.getValue = function() {
            if (!this.l) {
                var a = this.g, b = [], c = a.namedDest;
                "string" === typeof c && /\S/.test(c) ? b.push("nameddest=" + encodeURIComponent(a.namedDest)) : (c = a.pageNumber, "number" === typeof c && !isNaN(c) && b.push("page=" + a.pageNumber));
                (c = this.getHighlight()) && b.push("highlight=" + this.v(c));
                a.pageRects && this.h && b.push("colibrio-pagerects=" + a.pageRects.map(this.v).join(";"));
                a.viewRect && (a = a.viewRect, b.push("viewrect=" + a.left + "," + a.top + "," + a.width + "," + a.height));
                this.l = b.join("&");
            }
            return this.l;
        };
        g.getViewRect = function() {
            return this.g.viewRect || null;
        };
        g.isRangeSelector = function() {
            var a = this.g.pageRects;
            return !!a && (1 < a.length || 0 < a[0].height && 0 < a[0].width);
        };
        function z(a) {
            a = a.reduce(function(b, c) {
                return {
                    o: Math.max(b.o, c.x + c.width),
                    s: Math.max(b.s, c.y + c.height),
                    i: Math.min(b.i, c.x),
                    j: Math.min(b.j, c.y)
                };
            }, {
                o: a[0].x + a[0].width,
                s: a[0].y + a[0].height,
                i: a[0].x,
                j: a[0].y
            });
            return new DOMRect(a.i, a.j, a.o - a.i, a.s - a.j);
        }
        g.v = function(a) {
            return "" + Math.round(a.left) + "," + Math.round(a.right) + "," + Math.round(a.top) + "," + Math.round(a.bottom);
        };
        function A(a) {
            this.h = void 0 === a ? !1 : a;
        }
        A.prototype.canParseFragment = function(a) {
            return /(?:highlight|nameddest|page|viewrect|colibrio-pagerects)=/.test(a);
        };
        A.prototype.getFragmentSpecificationIri = function() {
            return q.FragmentSpecificationIri.PDF;
        };
        A.prototype.parseFragment = function(a, b, c) {
            b = {};
            a = a.split("&");
            for(var e = 0; e < a.length; e++){
                var d = a[e].split("=");
                if (2 <= d.length) {
                    var f = decodeURIComponent(d[0]).toLowerCase();
                    d = decodeURIComponent(d[1]);
                    switch(f){
                        case "colibrio-pagerects":
                            f = B(this, d);
                            0 < f.length && (b.pageRects = 2E4 < f.length ? f.slice(0, 2E4) : f);
                            break;
                        case "highlight":
                            b.highlight = this.u(d);
                            break;
                        case "nameddest":
                            b.namedDest = d;
                            break;
                        case "page":
                            f = parseInt(d);
                            isNaN(f) || (b.pageNumber = f);
                            break;
                        case "viewrect":
                            f = void 0, d = d.split(","), 4 <= d.length && (d = d.map(parseFloat), d.some(isNaN) || (f = new DOMRect(d[0], d[1], d[2], d[3]))), b.viewRect = f;
                    }
                }
            }
            return b.pageNumber || b.namedDest ? new v(b, c, this.h) : null;
        };
        function B(a, b) {
            return b.split(";").map(a.u).filter(function(c) {
                return !!c;
            });
        }
        A.prototype.u = function(a) {
            a = a.split(",");
            var b;
            4 <= a.length && (a = a.map(parseFloat), a.some(isNaN) || (b = new DOMRect(a[0], a[2], a[1] - a[0], a[3] - a[2])));
            return b;
        };
        api = {
            PdfFragmentSelector: v,
            PdfFragmentSelectorParser: A
        };
        var C = new ArrayBuffer(8);
        new DataView(C);
        new Uint8Array(C);
    }).call(__self);
    return api;
});

});

var $8923837e63dc4ee8$exports = {};
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";
(function(s, f) {
    if (0, $8923837e63dc4ee8$exports) $8923837e63dc4ee8$exports = f(s);
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : $8923837e63dc4ee8$exports, function(__self) {
    var api = {};
    (function() {
        "undefined" !== typeof Element && Element.prototype && !Element.prototype.matches && (Element.prototype.matches = Element.prototype.webkitMatchesSelector || function(b) {
            b = this.ownerDocument.querySelectorAll(b);
            for(var a = b.length; 0 <= --a && b[a] !== this;);
            return -1 < a;
        });
        function e(b) {
            "children" in b.prototype || Object.defineProperty(b.prototype, "children", {
                get: function() {
                    for(var a = 0, c, d = this.childNodes, f = []; c = d[a++];)1 === c.nodeType && f.push(c);
                    return f;
                }
            });
        }
        function g(b) {
            "childElementCount" in b.prototype || Object.defineProperty(b.prototype, "childElementCount", {
                get: function() {
                    for(var a = 0, c = 0, d, f = this.childNodes; d = f[a++];)1 === d.nodeType && c++;
                    return c;
                }
            });
        }
        function h(b) {
            "firstElementChild" in b.prototype || (Object.defineProperty(b.prototype, "firstElementChild", {
                get: function() {
                    for(var a, c = this.childNodes, d = 0; a = c[d++];)if (1 === a.nodeType) return a;
                    return null;
                }
            }), Object.defineProperty(b.prototype, "lastElementChild", {
                get: function() {
                    for(var a, c = this.childNodes, d = c.length - 1; a = c[d--];)if (1 === a.nodeType) return a;
                    return null;
                }
            }));
        }
        var k = "undefined" !== typeof Element && Element.prototype, l = "undefined" !== typeof DocumentFragment && DocumentFragment.prototype;
        "undefined" !== typeof Document && Document.prototype && l && k ? (g(Element), e(Element), h(Element), g(Document), e(Document), h(Document), g(DocumentFragment), e(DocumentFragment), h(DocumentFragment)) : typeof Node && Node.prototype && (e(Node), g(Node), h(Node));
    }).call(__self);
    return api;
});




var $621be1864ea93828$exports = {};
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";
(function(s, f) {
    if (0, $621be1864ea93828$exports) $621be1864ea93828$exports = f(s);
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : $621be1864ea93828$exports, function(__self) {
    var api = {};
    (function() {
        var f = "function" == typeof Object.defineProperties ? Object.defineProperty : function(b, a, c) {
            if (b == Array.prototype || b == Object.prototype) return b;
            b[a] = c.value;
            return b;
        };
        function p(b) {
            b = [
                "object" == typeof globalThis && globalThis,
                b,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var a = 0; a < b.length; ++a){
                var c = b[a];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var r = p(this);
        function u(b, a) {
            if (a) a: {
                var c = r;
                b = b.split(".");
                for(var d = 0; d < b.length - 1; d++){
                    var e = b[d];
                    if (!(e in c)) break a;
                    c = c[e];
                }
                b = b[b.length - 1];
                d = c[b];
                a = a(d);
                a != d && null != a && f(c, b, {
                    configurable: !0,
                    writable: !0,
                    value: a
                });
            }
        }
        u("Math.trunc", function(b) {
            return b ? b : function(a) {
                a = Number(a);
                if (isNaN(a) || Infinity === a || -Infinity === a || 0 === a) return a;
                var c = Math.floor(Math.abs(a));
                return 0 > a ? -c : c;
            };
        });
        function v(b) {
            b = Math.trunc(b) || 0;
            0 > b && (b += this.length);
            if (!(0 > b || b >= this.length)) return this[b];
        }
        u("Array.prototype.at", function(b) {
            return b ? b : v;
        });
        u("Array.prototype.copyWithin", function(b) {
            function a(c) {
                c = Number(c);
                return Infinity === c || -Infinity === c ? c : c | 0;
            }
            return b ? b : function(c, d, e) {
                var l = this.length;
                c = a(c);
                d = a(d);
                e = void 0 === e ? l : a(e);
                c = 0 > c ? Math.max(l + c, 0) : Math.min(c, l);
                d = 0 > d ? Math.max(l + d, 0) : Math.min(d, l);
                e = 0 > e ? Math.max(l + e, 0) : Math.min(e, l);
                if (c < d) for(; d < e;)d in this ? this[c++] = this[d++] : (delete this[c++], d++);
                else for(e = Math.min(e, l + d - c), c += e - d; e > d;)--e in this ? this[--c] = this[e] : delete this[--c];
                return this;
            };
        });
        function w(b) {
            var a = 0;
            return function() {
                return a < b.length ? {
                    done: !1,
                    value: b[a++]
                } : {
                    done: !0
                };
            };
        }
        u("Symbol", function(b) {
            function a(l) {
                if (this instanceof a) throw new TypeError("Symbol is not a constructor");
                return new c(d + (l || "") + "_" + e++, l);
            }
            function c(l, g) {
                this.g = l;
                f(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (b) return b;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return a;
        });
        u("Symbol.iterator", function(b) {
            if (b) return b;
            b = Symbol("Symbol.iterator");
            for(var a = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < a.length; c++){
                var d = r[a[c]];
                "function" === typeof d && "function" != typeof d.prototype[b] && f(d.prototype, b, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return x(w(this));
                    }
                });
            }
            return b;
        });
        u("Symbol.asyncIterator", function(b) {
            return b ? b : Symbol("Symbol.asyncIterator");
        });
        function x(b) {
            b = {
                next: b
            };
            b[Symbol.iterator] = function() {
                return this;
            };
            return b;
        }
        function y(b, a) {
            b instanceof String && (b += "");
            var c = 0, d = !1, e = {
                next: function() {
                    if (!d && c < b.length) {
                        var l = c++;
                        return {
                            value: a(l, b[l]),
                            done: !1
                        };
                    }
                    d = !0;
                    return {
                        done: !0,
                        value: void 0
                    };
                }
            };
            e[Symbol.iterator] = function() {
                return e;
            };
            return e;
        }
        u("Array.prototype.entries", function(b) {
            return b ? b : function() {
                return y(this, function(a, c) {
                    return [
                        a,
                        c
                    ];
                });
            };
        });
        u("Array.prototype.fill", function(b) {
            return b ? b : function(a, c, d) {
                var e = this.length || 0;
                0 > c && (c = Math.max(0, e + c));
                if (null == d || d > e) d = e;
                d = Number(d);
                0 > d && (d = Math.max(0, e + d));
                for(c = Number(c || 0); c < d; c++)this[c] = a;
                return this;
            };
        });
        function z(b, a, c) {
            b instanceof String && (b = String(b));
            for(var d = b.length, e = 0; e < d; e++){
                var l = b[e];
                if (a.call(c, l, e, b)) return {
                    m: e,
                    o: l
                };
            }
            return {
                m: -1,
                o: void 0
            };
        }
        u("Array.prototype.find", function(b) {
            return b ? b : function(a, c) {
                return z(this, a, c).o;
            };
        });
        u("Array.prototype.findIndex", function(b) {
            return b ? b : function(a, c) {
                return z(this, a, c).m;
            };
        });
        function B(b, a, c) {
            b instanceof String && (b = String(b));
            for(var d = b.length - 1; 0 <= d; d--){
                var e = b[d];
                if (a.call(c, e, d, b)) return {
                    m: d,
                    o: e
                };
            }
            return {
                m: -1,
                o: void 0
            };
        }
        u("Array.prototype.findLast", function(b) {
            return b ? b : function(a, c) {
                return B(this, a, c).o;
            };
        });
        u("Array.prototype.findLastIndex", function(b) {
            return b ? b : function(a, c) {
                return B(this, a, c).m;
            };
        });
        u("Array.prototype.flat", function(b) {
            return b ? b : function(a) {
                a = void 0 === a ? 1 : a;
                var c = [];
                Array.prototype.forEach.call(this, function(d) {
                    Array.isArray(d) && 0 < a ? (d = Array.prototype.flat.call(d, a - 1), c.push.apply(c, d)) : c.push(d);
                });
                return c;
            };
        });
        u("Array.prototype.flatMap", function(b) {
            return b ? b : function(a, c) {
                var d = [];
                Array.prototype.forEach.call(this, function(e, l) {
                    e = a.call(c, e, l, this);
                    Array.isArray(e) ? d.push.apply(d, e) : d.push(e);
                });
                return d;
            };
        });
        u("Array.from", function(b) {
            return b ? b : function(a, c, d) {
                c = null != c ? c : function(h) {
                    return h;
                };
                var e = [], l = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
                if ("function" == typeof l) {
                    a = l.call(a);
                    for(var g = 0; !(l = a.next()).done;)e.push(c.call(d, l.value, g++));
                } else for(l = a.length, g = 0; g < l; g++)e.push(c.call(d, a[g], g));
                return e;
            };
        });
        u("Object.is", function(b) {
            return b ? b : function(a, c) {
                return a === c ? 0 !== a || 1 / a === 1 / c : a !== a && c !== c;
            };
        });
        u("Array.prototype.includes", function(b) {
            return b ? b : function(a, c) {
                var d = this;
                d instanceof String && (d = String(d));
                var e = d.length;
                c = c || 0;
                for(0 > c && (c = Math.max(c + e, 0)); c < e; c++){
                    var l = d[c];
                    if (l === a || Object.is(l, a)) return !0;
                }
                return !1;
            };
        });
        u("Array.prototype.keys", function(b) {
            return b ? b : function() {
                return y(this, function(a) {
                    return a;
                });
            };
        });
        u("Array.of", function(b) {
            return b ? b : function(a) {
                return Array.from(arguments);
            };
        });
        u("Array.prototype.values", function(b) {
            return b ? b : function() {
                return y(this, function(a, c) {
                    return c;
                });
            };
        });
        function C(b) {
            var a = "undefined" != typeof Symbol && Symbol.iterator && b[Symbol.iterator];
            if (a) return a.call(b);
            if ("number" == typeof b.length) return {
                next: w(b)
            };
            throw Error(String(b) + " is not an iterable or ArrayLike");
        }
        var D;
        if ("function" == typeof Object.setPrototypeOf) D = Object.setPrototypeOf;
        else {
            var E;
            a: {
                var F = {
                    a: !0
                }, G = {};
                try {
                    G.__proto__ = F;
                    E = G.a;
                    break a;
                } catch (b) {}
                E = !1;
            }
            D = E ? function(b, a) {
                b.__proto__ = a;
                if (b.__proto__ !== a) throw new TypeError(b + " is not extensible");
                return b;
            } : null;
        }
        var H = D;
        u("globalThis", function(b) {
            return b || r;
        });
        function I(b, a) {
            return Object.prototype.hasOwnProperty.call(b, a);
        }
        u("WeakMap", function(b) {
            function a(k) {
                this.g = (h += Math.random() + 1).toString();
                if (k) {
                    k = C(k);
                    for(var m; !(m = k.next()).done;)m = m.value, this.set(m[0], m[1]);
                }
            }
            function c() {}
            function d(k) {
                var m = typeof k;
                return "object" === m && null !== k || "function" === m;
            }
            function e(k) {
                if (!I(k, g)) {
                    var m = new c;
                    f(k, g, {
                        value: m
                    });
                }
            }
            function l(k) {
                var m = Object[k];
                m && (Object[k] = function(n) {
                    if (n instanceof c) return n;
                    Object.isExtensible(n) && e(n);
                    return m(n);
                });
            }
            if (function() {
                if (!b || !Object.seal) return !1;
                try {
                    var k = Object.seal({}), m = Object.seal({}), n = new b([
                        [
                            k,
                            2
                        ],
                        [
                            m,
                            3
                        ]
                    ]);
                    if (2 != n.get(k) || 3 != n.get(m)) return !1;
                    n.delete(k);
                    n.set(m, 4);
                    return !n.has(k) && 4 == n.get(m);
                } catch (q) {
                    return !1;
                }
            }()) return b;
            var g = "$jscomp_hidden_" + Math.random();
            l("freeze");
            l("preventExtensions");
            l("seal");
            var h = 0;
            a.prototype.set = function(k, m) {
                if (!d(k)) throw Error("Invalid WeakMap key");
                e(k);
                if (!I(k, g)) throw Error("WeakMap key fail: " + k);
                k[g][this.g] = m;
                return this;
            };
            a.prototype.get = function(k) {
                return d(k) && I(k, g) ? k[g][this.g] : void 0;
            };
            a.prototype.has = function(k) {
                return d(k) && I(k, g) && I(k[g], this.g);
            };
            a.prototype.delete = function(k) {
                return d(k) && I(k, g) && I(k[g], this.g) ? delete k[g][this.g] : !1;
            };
            return a;
        });
        u("Map", function(b) {
            function a() {
                var h = {};
                return h.j = h.next = h.head = h;
            }
            function c(h, k) {
                var m = h[1];
                return x(function() {
                    if (m) {
                        for(; m.head != h[1];)m = m.j;
                        for(; m.next != m.head;)return m = m.next, {
                            done: !1,
                            value: k(m)
                        };
                        m = null;
                    }
                    return {
                        done: !0,
                        value: void 0
                    };
                });
            }
            function d(h, k) {
                var m = k && typeof k;
                "object" == m || "function" == m ? l.has(k) ? m = l.get(k) : (m = "" + ++g, l.set(k, m)) : m = "p_" + k;
                var n = h[0][m];
                if (n && I(h[0], m)) for(h = 0; h < n.length; h++){
                    var q = n[h];
                    if (k !== k && q.key !== q.key || k === q.key) return {
                        id: m,
                        list: n,
                        index: h,
                        h: q
                    };
                }
                return {
                    id: m,
                    list: n,
                    index: -1,
                    h: void 0
                };
            }
            function e(h) {
                this[0] = {};
                this[1] = a();
                this.size = 0;
                if (h) {
                    h = C(h);
                    for(var k; !(k = h.next()).done;)k = k.value, this.set(k[0], k[1]);
                }
            }
            if (function() {
                if (!b || "function" != typeof b || !b.prototype.entries || "function" != typeof Object.seal) return !1;
                try {
                    var h = Object.seal({
                        x: 4
                    }), k = new b(C([
                        [
                            h,
                            "s"
                        ]
                    ]));
                    if ("s" != k.get(h) || 1 != k.size || k.get({
                        x: 4
                    }) || k.set({
                        x: 4
                    }, "t") != k || 2 != k.size) return !1;
                    var m = k.entries(), n = m.next();
                    if (n.done || n.value[0] != h || "s" != n.value[1]) return !1;
                    n = m.next();
                    return n.done || 4 != n.value[0].x || "t" != n.value[1] || !m.next().done ? !1 : !0;
                } catch (q) {
                    return !1;
                }
            }()) return b;
            var l = new WeakMap;
            e.prototype.set = function(h, k) {
                h = 0 === h ? 0 : h;
                var m = d(this, h);
                m.list || (m.list = this[0][m.id] = []);
                m.h ? m.h.value = k : (m.h = {
                    next: this[1],
                    j: this[1].j,
                    head: this[1],
                    key: h,
                    value: k
                }, m.list.push(m.h), this[1].j.next = m.h, this[1].j = m.h, this.size++);
                return this;
            };
            e.prototype.delete = function(h) {
                h = d(this, h);
                return h.h && h.list ? (h.list.splice(h.index, 1), h.list.length || delete this[0][h.id], h.h.j.next = h.h.next, h.h.next.j = h.h.j, h.h.head = null, this.size--, !0) : !1;
            };
            e.prototype.clear = function() {
                this[0] = {};
                this[1] = this[1].j = a();
                this.size = 0;
            };
            e.prototype.has = function(h) {
                return !!d(this, h).h;
            };
            e.prototype.get = function(h) {
                return (h = d(this, h).h) && h.value;
            };
            e.prototype.entries = function() {
                return c(this, function(h) {
                    return [
                        h.key,
                        h.value
                    ];
                });
            };
            e.prototype.keys = function() {
                return c(this, function(h) {
                    return h.key;
                });
            };
            e.prototype.values = function() {
                return c(this, function(h) {
                    return h.value;
                });
            };
            e.prototype.forEach = function(h, k) {
                for(var m = this.entries(), n; !(n = m.next()).done;)n = n.value, h.call(k, n[1], n[0], this);
            };
            e.prototype[Symbol.iterator] = e.prototype.entries;
            var g = 0;
            return e;
        });
        u("Math.acosh", function(b) {
            return b ? b : function(a) {
                a = Number(a);
                return Math.log(a + Math.sqrt(a * a - 1));
            };
        });
        u("Math.asinh", function(b) {
            return b ? b : function(a) {
                a = Number(a);
                if (0 === a) return a;
                var c = Math.log(Math.abs(a) + Math.sqrt(a * a + 1));
                return 0 > a ? -c : c;
            };
        });
        u("Math.log1p", function(b) {
            return b ? b : function(a) {
                a = Number(a);
                if (.25 > a && -0.25 < a) {
                    for(var c = a, d = 1, e = a, l = 0, g = 1; l != e;)c *= a, g *= -1, e = (l = e) + g * c / ++d;
                    return e;
                }
                return Math.log(1 + a);
            };
        });
        u("Math.atanh", function(b) {
            if (b) return b;
            var a = Math.log1p;
            return function(c) {
                c = Number(c);
                return (a(c) - a(-c)) / 2;
            };
        });
        u("Math.cbrt", function(b) {
            return b ? b : function(a) {
                if (0 === a) return a;
                a = Number(a);
                var c = Math.pow(Math.abs(a), 1 / 3);
                return 0 > a ? -c : c;
            };
        });
        u("Math.clz32", function(b) {
            return b ? b : function(a) {
                a = Number(a) >>> 0;
                if (0 === a) return 32;
                var c = 0;
                0 === (a & 4294901760) && (a <<= 16, c += 16);
                0 === (a & 4278190080) && (a <<= 8, c += 8);
                0 === (a & 4026531840) && (a <<= 4, c += 4);
                0 === (a & 3221225472) && (a <<= 2, c += 2);
                0 === (a & 2147483648) && c++;
                return c;
            };
        });
        u("Math.cosh", function(b) {
            if (b) return b;
            var a = Math.exp;
            return function(c) {
                c = Number(c);
                return (a(c) + a(-c)) / 2;
            };
        });
        u("Math.expm1", function(b) {
            return b ? b : function(a) {
                a = Number(a);
                if (.25 > a && -0.25 < a) {
                    for(var c = a, d = 1, e = a, l = 0; l != e;)c *= a / ++d, e = (l = e) + c;
                    return e;
                }
                return Math.exp(a) - 1;
            };
        });
        u("Math.fround", function(b) {
            if (b) return b;
            if ("function" !== typeof Float32Array) return function(c) {
                return c;
            };
            var a = new Float32Array(1);
            return function(c) {
                a[0] = c;
                return a[0];
            };
        });
        u("Math.hypot", function(b) {
            return b ? b : function(a) {
                if (2 > arguments.length) return arguments.length ? Math.abs(arguments[0]) : 0;
                var c, d, e;
                for(c = e = 0; c < arguments.length; c++)e = Math.max(e, Math.abs(arguments[c]));
                if (1E100 < e || 1E-100 > e) {
                    if (!e) return e;
                    for(c = d = 0; c < arguments.length; c++){
                        var l = Number(arguments[c]) / e;
                        d += l * l;
                    }
                    return Math.sqrt(d) * e;
                }
                for(c = d = 0; c < arguments.length; c++)l = Number(arguments[c]), d += l * l;
                return Math.sqrt(d);
            };
        });
        u("Math.imul", function(b) {
            return b ? b : function(a, c) {
                a = Number(a);
                c = Number(c);
                var d = a & 65535, e = c & 65535;
                return d * e + ((a >>> 16 & 65535) * e + d * (c >>> 16 & 65535) << 16 >>> 0) | 0;
            };
        });
        u("Math.log10", function(b) {
            return b ? b : function(a) {
                return Math.log(a) / Math.LN10;
            };
        });
        u("Math.log2", function(b) {
            return b ? b : function(a) {
                return Math.log(a) / Math.LN2;
            };
        });
        u("Math.sign", function(b) {
            return b ? b : function(a) {
                a = Number(a);
                return 0 === a || isNaN(a) ? a : 0 < a ? 1 : -1;
            };
        });
        u("Math.sinh", function(b) {
            if (b) return b;
            var a = Math.exp;
            return function(c) {
                c = Number(c);
                return 0 === c ? c : (a(c) - a(-c)) / 2;
            };
        });
        u("Math.tanh", function(b) {
            return b ? b : function(a) {
                a = Number(a);
                if (0 === a) return a;
                var c = Math.exp(-2 * Math.abs(a));
                c = (1 - c) / (1 + c);
                return 0 > a ? -c : c;
            };
        });
        u("Number.EPSILON", function() {
            return Math.pow(2, -52);
        });
        u("Number.MAX_SAFE_INTEGER", function() {
            return 9007199254740991;
        });
        u("Number.MIN_SAFE_INTEGER", function() {
            return -9007199254740991;
        });
        u("Number.isFinite", function(b) {
            return b ? b : function(a) {
                return "number" !== typeof a ? !1 : !isNaN(a) && Infinity !== a && -Infinity !== a;
            };
        });
        u("Number.isInteger", function(b) {
            return b ? b : function(a) {
                return Number.isFinite(a) ? a === Math.floor(a) : !1;
            };
        });
        u("Number.isNaN", function(b) {
            return b ? b : function(a) {
                return "number" === typeof a && isNaN(a);
            };
        });
        u("Number.isSafeInteger", function(b) {
            return b ? b : function(a) {
                return Number.isInteger(a) && Math.abs(a) <= Number.MAX_SAFE_INTEGER;
            };
        });
        u("Number.parseFloat", function(b) {
            return b || parseFloat;
        });
        u("Number.parseInt", function(b) {
            return b || parseInt;
        });
        var L = "function" == typeof Object.assign ? Object.assign : function(b, a) {
            for(var c = 1; c < arguments.length; c++){
                var d = arguments[c];
                if (d) for(var e in d)I(d, e) && (b[e] = d[e]);
            }
            return b;
        };
        u("Object.assign", function(b) {
            return b || L;
        });
        u("Object.entries", function(b) {
            return b ? b : function(a) {
                var c = [], d;
                for(d in a)I(a, d) && c.push([
                    d,
                    a[d]
                ]);
                return c;
            };
        });
        u("Object.fromEntries", function(b) {
            return b ? b : function(a) {
                var c = {};
                if (!(Symbol.iterator in a)) throw new TypeError("" + a + " is not iterable");
                a = a[Symbol.iterator].call(a);
                for(var d = a.next(); !d.done; d = a.next()){
                    d = d.value;
                    if (Object(d) !== d) throw new TypeError("iterable for fromEntries should yield objects");
                    c[d[0]] = d[1];
                }
                return c;
            };
        });
        u("Reflect", function(b) {
            return b ? b : {};
        });
        u("Object.getOwnPropertySymbols", function(b) {
            return b ? b : function() {
                return [];
            };
        });
        u("Reflect.ownKeys", function(b) {
            return b ? b : function(a) {
                var c = [], d = Object.getOwnPropertyNames(a);
                a = Object.getOwnPropertySymbols(a);
                for(var e = 0; e < d.length; e++)("jscomp_symbol_" == d[e].substring(0, 14) ? a : c).push(d[e]);
                return c.concat(a);
            };
        });
        u("Object.getOwnPropertyDescriptors", function(b) {
            return b ? b : function(a) {
                for(var c = {}, d = Reflect.ownKeys(a), e = 0; e < d.length; e++)c[d[e]] = Object.getOwnPropertyDescriptor(a, d[e]);
                return c;
            };
        });
        u("Object.setPrototypeOf", function(b) {
            return b || H;
        });
        u("Object.values", function(b) {
            return b ? b : function(a) {
                var c = [], d;
                for(d in a)I(a, d) && c.push(a[d]);
                return c;
            };
        });
        u("Object.hasOwn", function(b) {
            return b ? b : function(a, c) {
                return Object.prototype.hasOwnProperty.call(a, c);
            };
        });
        u("Promise", function(b) {
            function a(g) {
                this.i = 0;
                this.l = void 0;
                this.g = [];
                this.B = !1;
                var h = this.s();
                try {
                    g(h.resolve, h.reject);
                } catch (k) {
                    h.reject(k);
                }
            }
            function c() {
                this.g = null;
            }
            function d(g) {
                return g instanceof a ? g : new a(function(h) {
                    h(g);
                });
            }
            if (b) return b;
            c.prototype.i = function(g) {
                if (null == this.g) {
                    this.g = [];
                    var h = this;
                    this.l(function() {
                        h.u();
                    });
                }
                this.g.push(g);
            };
            var e = r.setTimeout;
            c.prototype.l = function(g) {
                e(g, 0);
            };
            c.prototype.u = function() {
                for(; this.g && this.g.length;){
                    var g = this.g;
                    this.g = [];
                    for(var h = 0; h < g.length; ++h){
                        var k = g[h];
                        g[h] = null;
                        try {
                            k();
                        } catch (m) {
                            this.s(m);
                        }
                    }
                }
                this.g = null;
            };
            c.prototype.s = function(g) {
                this.l(function() {
                    throw g;
                });
            };
            a.prototype.s = function() {
                function g(m) {
                    return function(n) {
                        k || (k = !0, m.call(h, n));
                    };
                }
                var h = this, k = !1;
                return {
                    resolve: g(this.H),
                    reject: g(this.u)
                };
            };
            a.prototype.H = function(g) {
                if (g === this) this.u(new TypeError("A Promise cannot resolve to itself"));
                else if (g instanceof a) this.J(g);
                else {
                    a: switch(typeof g){
                        case "object":
                            var h = null != g;
                            break a;
                        case "function":
                            h = !0;
                            break a;
                        default:
                            h = !1;
                    }
                    h ? this.G(g) : this.A(g);
                }
            };
            a.prototype.G = function(g) {
                var h = void 0;
                try {
                    h = g.then;
                } catch (k) {
                    this.u(k);
                    return;
                }
                "function" == typeof h ? this.K(h, g) : this.A(g);
            };
            a.prototype.u = function(g) {
                this.C(2, g);
            };
            a.prototype.A = function(g) {
                this.C(1, g);
            };
            a.prototype.C = function(g, h) {
                if (0 != this.i) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.i);
                this.i = g;
                this.l = h;
                2 === this.i && this.I();
                this.D();
            };
            a.prototype.I = function() {
                var g = this;
                e(function() {
                    if (g.F()) {
                        var h = r.console;
                        "undefined" !== typeof h && h.error(g.l);
                    }
                }, 1);
            };
            a.prototype.F = function() {
                if (this.B) return !1;
                var g = r.CustomEvent, h = r.Event, k = r.dispatchEvent;
                if ("undefined" === typeof k) return !0;
                "function" === typeof g ? g = new g("unhandledrejection", {
                    cancelable: !0
                }) : "function" === typeof h ? g = new h("unhandledrejection", {
                    cancelable: !0
                }) : (g = r.document.createEvent("CustomEvent"), g.initCustomEvent("unhandledrejection", !1, !0, g));
                g.promise = this;
                g.reason = this.l;
                return k(g);
            };
            a.prototype.D = function() {
                if (null != this.g) {
                    for(var g = 0; g < this.g.length; ++g)l.i(this.g[g]);
                    this.g = null;
                }
            };
            var l = new c;
            a.prototype.J = function(g) {
                var h = this.s();
                g.v(h.resolve, h.reject);
            };
            a.prototype.K = function(g, h) {
                var k = this.s();
                try {
                    g.call(h, k.resolve, k.reject);
                } catch (m) {
                    k.reject(m);
                }
            };
            a.prototype.then = function(g, h) {
                function k(t, A) {
                    return "function" == typeof t ? function(J) {
                        try {
                            m(t(J));
                        } catch (K) {
                            n(K);
                        }
                    } : A;
                }
                var m, n, q = new a(function(t, A) {
                    m = t;
                    n = A;
                });
                this.v(k(g, m), k(h, n));
                return q;
            };
            a.prototype.catch = function(g) {
                return this.then(void 0, g);
            };
            a.prototype.v = function(g, h) {
                function k() {
                    switch(m.i){
                        case 1:
                            g(m.l);
                            break;
                        case 2:
                            h(m.l);
                            break;
                        default:
                            throw Error("Unexpected state: " + m.i);
                    }
                }
                var m = this;
                null == this.g ? l.i(k) : this.g.push(k);
                this.B = !0;
            };
            a.resolve = d;
            a.reject = function(g) {
                return new a(function(h, k) {
                    k(g);
                });
            };
            a.race = function(g) {
                return new a(function(h, k) {
                    for(var m = C(g), n = m.next(); !n.done; n = m.next())d(n.value).v(h, k);
                });
            };
            a.all = function(g) {
                var h = C(g), k = h.next();
                return k.done ? d([]) : new a(function(m, n) {
                    function q(J) {
                        return function(K) {
                            t[J] = K;
                            A--;
                            0 == A && m(t);
                        };
                    }
                    var t = [], A = 0;
                    do t.push(void 0), A++, d(k.value).v(q(t.length - 1), n), k = h.next();
                    while (!k.done);
                });
            };
            return a;
        });
        u("Promise.allSettled", function(b) {
            function a(d) {
                return {
                    status: "fulfilled",
                    value: d
                };
            }
            function c(d) {
                return {
                    status: "rejected",
                    reason: d
                };
            }
            return b ? b : function(d) {
                var e = this;
                d = Array.from(d, function(l) {
                    return e.resolve(l).then(a, c);
                });
                return e.all(d);
            };
        });
        u("Promise.prototype.finally", function(b) {
            return b ? b : function(a) {
                return this.then(function(c) {
                    return Promise.resolve(a()).then(function() {
                        return c;
                    });
                }, function(c) {
                    return Promise.resolve(a()).then(function() {
                        throw c;
                    });
                });
            };
        });
        var M = "function" == typeof Object.create ? Object.create : function(b) {
            function a() {}
            a.prototype = b;
            return new a;
        };
        function N(b, a) {
            b.prototype = M(a.prototype);
            b.prototype.constructor = b;
            if (H) H(b, a);
            else for(var c in a)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(a, c);
                    d && Object.defineProperty(b, c, d);
                } else b[c] = a[c];
            }
            b.L = a.prototype;
        }
        u("AggregateError", function(b) {
            function a(c, d) {
                d = Error(d);
                "stack" in d && (this.stack = d.stack);
                this.errors = c;
                this.message = d.message;
            }
            if (b) return b;
            N(a, Error);
            a.prototype.name = "AggregateError";
            return a;
        });
        u("Promise.any", function(b) {
            return b ? b : function(a) {
                a = a instanceof Array ? a : Array.from(a);
                return Promise.all(a.map(function(c) {
                    return Promise.resolve(c).then(function(d) {
                        throw d;
                    }, function(d) {
                        return d;
                    });
                })).then(function(c) {
                    throw new AggregateError(c, "All promises were rejected");
                }, function(c) {
                    return c;
                });
            };
        });
        u("Reflect.apply", function(b) {
            if (b) return b;
            var a = Function.prototype.apply;
            return function(c, d, e) {
                return a.call(c, d, e);
            };
        });
        var O = function() {
            function b() {
                function c() {}
                new c;
                Reflect.construct(c, [], function() {});
                return new c instanceof c;
            }
            if ("undefined" != typeof Reflect && Reflect.construct) {
                if (b()) return Reflect.construct;
                var a = Reflect.construct;
                return function(c, d, e) {
                    c = a(c, d);
                    e && Reflect.setPrototypeOf(c, e.prototype);
                    return c;
                };
            }
            return function(c, d, e) {
                void 0 === e && (e = c);
                e = M(e.prototype || Object.prototype);
                return Function.prototype.apply.call(c, e, d) || e;
            };
        }();
        u("Reflect.construct", function() {
            return O;
        });
        u("Reflect.defineProperty", function(b) {
            return b ? b : function(a, c, d) {
                try {
                    Object.defineProperty(a, c, d);
                    var e = Object.getOwnPropertyDescriptor(a, c);
                    return e ? e.configurable === (d.configurable || !1) && e.enumerable === (d.enumerable || !1) && ("value" in e ? e.value === d.value && e.writable === (d.writable || !1) : e.get === d.get && e.set === d.set) : !1;
                } catch (l) {
                    return !1;
                }
            };
        });
        u("Reflect.deleteProperty", function(b) {
            return b ? b : function(a, c) {
                if (!I(a, c)) return !0;
                try {
                    return delete a[c];
                } catch (d) {
                    return !1;
                }
            };
        });
        u("Reflect.getOwnPropertyDescriptor", function(b) {
            return b || Object.getOwnPropertyDescriptor;
        });
        u("Reflect.getPrototypeOf", function(b) {
            return b || Object.getPrototypeOf;
        });
        function P(b, a) {
            for(; b;){
                var c = Reflect.getOwnPropertyDescriptor(b, a);
                if (c) return c;
                b = Reflect.getPrototypeOf(b);
            }
        }
        u("Reflect.get", function(b) {
            return b ? b : function(a, c, d) {
                if (2 >= arguments.length) return a[c];
                var e = P(a, c);
                if (e) return e.get ? e.get.call(d) : e.value;
            };
        });
        u("Reflect.has", function(b) {
            return b ? b : function(a, c) {
                return c in a;
            };
        });
        u("Reflect.isExtensible", function(b) {
            return b ? b : "function" == typeof Object.isExtensible ? Object.isExtensible : function() {
                return !0;
            };
        });
        u("Reflect.preventExtensions", function(b) {
            return b ? b : "function" != typeof Object.preventExtensions ? function() {
                return !1;
            } : function(a) {
                Object.preventExtensions(a);
                return !Object.isExtensible(a);
            };
        });
        u("Reflect.set", function(b) {
            return b ? b : function(a, c, d, e) {
                var l = P(a, c);
                return l ? l.set ? (l.set.call(3 < arguments.length ? e : a, d), !0) : l.writable && !Object.isFrozen(a) ? (a[c] = d, !0) : !1 : Reflect.isExtensible(a) ? (a[c] = d, !0) : !1;
            };
        });
        u("Reflect.setPrototypeOf", function(b) {
            return b ? b : H ? function(a, c) {
                try {
                    return H(a, c), !0;
                } catch (d) {
                    return !1;
                }
            } : null;
        });
        u("Set", function(b) {
            function a(c) {
                this.g = new Map;
                if (c) {
                    c = C(c);
                    for(var d; !(d = c.next()).done;)this.add(d.value);
                }
                this.size = this.g.size;
            }
            if (function() {
                if (!b || "function" != typeof b || !b.prototype.entries || "function" != typeof Object.seal) return !1;
                try {
                    var c = Object.seal({
                        x: 4
                    }), d = new b(C([
                        c
                    ]));
                    if (!d.has(c) || 1 != d.size || d.add(c) != d || 1 != d.size || d.add({
                        x: 4
                    }) != d || 2 != d.size) return !1;
                    var e = d.entries(), l = e.next();
                    if (l.done || l.value[0] != c || l.value[1] != c) return !1;
                    l = e.next();
                    return l.done || l.value[0] == c || 4 != l.value[0].x || l.value[1] != l.value[0] ? !1 : e.next().done;
                } catch (g) {
                    return !1;
                }
            }()) return b;
            a.prototype.add = function(c) {
                c = 0 === c ? 0 : c;
                this.g.set(c, c);
                this.size = this.g.size;
                return this;
            };
            a.prototype.delete = function(c) {
                c = this.g.delete(c);
                this.size = this.g.size;
                return c;
            };
            a.prototype.clear = function() {
                this.g.clear();
                this.size = 0;
            };
            a.prototype.has = function(c) {
                return this.g.has(c);
            };
            a.prototype.entries = function() {
                return this.g.entries();
            };
            a.prototype.values = function() {
                return this.g.values();
            };
            a.prototype.keys = a.prototype.values;
            a.prototype[Symbol.iterator] = a.prototype.values;
            a.prototype.forEach = function(c, d) {
                var e = this;
                this.g.forEach(function(l) {
                    return c.call(d, l, l, e);
                });
            };
            return a;
        });
        u("String.prototype.at", function(b) {
            return b ? b : v;
        });
        function Q(b, a, c) {
            if (null == b) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
            if (a instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
            return b + "";
        }
        u("String.prototype.codePointAt", function(b) {
            return b ? b : function(a) {
                var c = Q(this, null, "codePointAt"), d = c.length;
                a = Number(a) || 0;
                if (0 <= a && a < d) {
                    a |= 0;
                    var e = c.charCodeAt(a);
                    if (55296 > e || 56319 < e || a + 1 === d) return e;
                    a = c.charCodeAt(a + 1);
                    return 56320 > a || 57343 < a ? e : 1024 * (e - 55296) + a + 9216;
                }
            };
        });
        u("String.prototype.endsWith", function(b) {
            return b ? b : function(a, c) {
                var d = Q(this, a, "endsWith");
                void 0 === c && (c = d.length);
                c = Math.max(0, Math.min(c | 0, d.length));
                for(var e = a.length; 0 < e && 0 < c;)if (d[--c] != a[--e]) return !1;
                return 0 >= e;
            };
        });
        u("String.fromCodePoint", function(b) {
            return b ? b : function(a) {
                for(var c = "", d = 0; d < arguments.length; d++){
                    var e = Number(arguments[d]);
                    if (0 > e || 1114111 < e || e !== Math.floor(e)) throw new RangeError("invalid_code_point " + e);
                    65535 >= e ? c += String.fromCharCode(e) : (e -= 65536, c += String.fromCharCode(e >>> 10 & 1023 | 55296), c += String.fromCharCode(e & 1023 | 56320));
                }
                return c;
            };
        });
        u("String.prototype.includes", function(b) {
            return b ? b : function(a, c) {
                return -1 !== Q(this, a, "includes").indexOf(a, c || 0);
            };
        });
        u("String.prototype.matchAll", function(b) {
            return b ? b : function(a) {
                if (a instanceof RegExp && !a.global) throw new TypeError("RegExp passed into String.prototype.matchAll() must have global tag.");
                var c = new RegExp(a, a instanceof RegExp ? void 0 : "g"), d = this, e = !1, l = {
                    next: function() {
                        if (e) return {
                            value: void 0,
                            done: !0
                        };
                        var g = c.exec(d);
                        if (!g) return e = !0, {
                            value: void 0,
                            done: !0
                        };
                        "" === g[0] && (c.lastIndex += 1);
                        return {
                            value: g,
                            done: !1
                        };
                    }
                };
                l[Symbol.iterator] = function() {
                    return l;
                };
                return l;
            };
        });
        u("String.prototype.repeat", function(b) {
            return b ? b : function(a) {
                var c = Q(this, null, "repeat");
                if (0 > a || 1342177279 < a) throw new RangeError("Invalid count value");
                a |= 0;
                for(var d = ""; a;)if (a & 1 && (d += c), a >>>= 1) c += c;
                return d;
            };
        });
        function R(b, a) {
            b = void 0 !== b ? String(b) : " ";
            return 0 < a && b ? b.repeat(Math.ceil(a / b.length)).substring(0, a) : "";
        }
        u("String.prototype.padEnd", function(b) {
            return b ? b : function(a, c) {
                var d = Q(this, null, "padStart");
                return d + R(c, a - d.length);
            };
        });
        u("String.prototype.padStart", function(b) {
            return b ? b : function(a, c) {
                var d = Q(this, null, "padStart");
                return R(c, a - d.length) + d;
            };
        });
        u("String.raw", function(b) {
            return b ? b : function(a, c) {
                if (null == a) throw new TypeError("Cannot convert undefined or null to object");
                for(var d = a.raw, e = d.length, l = "", g = 0; g < e; ++g)l += d[g], g + 1 < e && g + 1 < arguments.length && (l += String(arguments[g + 1]));
                return l;
            };
        });
        u("String.prototype.replaceAll", function(b) {
            return b ? b : function(a, c) {
                if (a instanceof RegExp && !a.global) throw new TypeError("String.prototype.replaceAll called with a non-global RegExp argument.");
                return a instanceof RegExp ? this.replace(a, c) : this.replace(new RegExp(String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08"), "g"), c);
            };
        });
        u("String.prototype.startsWith", function(b) {
            return b ? b : function(a, c) {
                var d = Q(this, a, "startsWith"), e = d.length, l = a.length;
                c = Math.max(0, Math.min(c | 0, d.length));
                for(var g = 0; g < l && c < e;)if (d[c++] != a[g++]) return !1;
                return g >= l;
            };
        });
        u("String.prototype.trimRight", function(b) {
            function a() {
                return this.replace(/[\s\xa0]+$/, "");
            }
            return b || a;
        });
        u("String.prototype.trimEnd", function(b) {
            return b || String.prototype.trimRight;
        });
        u("String.prototype.trimLeft", function(b) {
            function a() {
                return this.replace(/^[\s\xa0]+/, "");
            }
            return b || a;
        });
        u("String.prototype.trimStart", function(b) {
            return b || String.prototype.trimLeft;
        });
        function S(b) {
            return b ? b : v;
        }
        u("Int8Array.prototype.at", S);
        u("Uint8Array.prototype.at", S);
        u("Uint8ClampedArray.prototype.at", S);
        u("Int16Array.prototype.at", S);
        u("Uint16Array.prototype.at", S);
        u("Int32Array.prototype.at", S);
        u("Uint32Array.prototype.at", S);
        u("Float32Array.prototype.at", S);
        u("Float64Array.prototype.at", S);
        function T(b) {
            return b ? b : Array.prototype.copyWithin;
        }
        u("Int8Array.prototype.copyWithin", T);
        u("Uint8Array.prototype.copyWithin", T);
        u("Uint8ClampedArray.prototype.copyWithin", T);
        u("Int16Array.prototype.copyWithin", T);
        u("Uint16Array.prototype.copyWithin", T);
        u("Int32Array.prototype.copyWithin", T);
        u("Uint32Array.prototype.copyWithin", T);
        u("Float32Array.prototype.copyWithin", T);
        u("Float64Array.prototype.copyWithin", T);
        function U(b) {
            return b ? b : Array.prototype.fill;
        }
        u("Int8Array.prototype.fill", U);
        u("Uint8Array.prototype.fill", U);
        u("Uint8ClampedArray.prototype.fill", U);
        u("Int16Array.prototype.fill", U);
        u("Uint16Array.prototype.fill", U);
        u("Int32Array.prototype.fill", U);
        u("Uint32Array.prototype.fill", U);
        u("Float32Array.prototype.fill", U);
        u("Float64Array.prototype.fill", U);
        function V(b) {
            return b ? b : function(a, c) {
                return B(this, a, c).o;
            };
        }
        u("Int8Array.prototype.findLast", V);
        u("Uint8Array.prototype.findLast", V);
        u("Uint8ClampedArray.prototype.findLast", V);
        u("Int16Array.prototype.findLast", V);
        u("Uint16Array.prototype.findLast", V);
        u("Int32Array.prototype.findLast", V);
        u("Uint32Array.prototype.findLast", V);
        u("Float32Array.prototype.findLast", V);
        u("Float64Array.prototype.findLast", V);
        function W(b) {
            return b ? b : function(a, c) {
                return B(this, a, c).m;
            };
        }
        u("Int8Array.prototype.findLastIndex", W);
        u("Uint8Array.prototype.findLastIndex", W);
        u("Uint8ClampedArray.prototype.findLastIndex", W);
        u("Int16Array.prototype.findLastIndex", W);
        u("Uint16Array.prototype.findLastIndex", W);
        u("Int32Array.prototype.findLastIndex", W);
        u("Uint32Array.prototype.findLastIndex", W);
        u("Float32Array.prototype.findLastIndex", W);
        u("Float64Array.prototype.findLastIndex", W);
        u("WeakSet", function(b) {
            function a(c) {
                this.g = new WeakMap;
                if (c) {
                    c = C(c);
                    for(var d; !(d = c.next()).done;)this.add(d.value);
                }
            }
            if (function() {
                if (!b || !Object.seal) return !1;
                try {
                    var c = Object.seal({}), d = Object.seal({}), e = new b([
                        c
                    ]);
                    if (!e.has(c) || e.has(d)) return !1;
                    e.delete(c);
                    e.add(d);
                    return !e.has(c) && e.has(d);
                } catch (l) {
                    return !1;
                }
            }()) return b;
            a.prototype.add = function(c) {
                this.g.set(c, !0);
                return this;
            };
            a.prototype.has = function(c) {
                return this.g.has(c);
            };
            a.prototype.delete = function(c) {
                return this.g.delete(c);
            };
            return a;
        });
        var X = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        function Y(b, a) {
            var c = this.length;
            "number" !== typeof b && (b = 0);
            "number" !== typeof a && (a = c);
            0 > b && (b = c + b);
            0 > a && (a = c + a);
            c = this.constructor;
            b = b * c.BYTES_PER_ELEMENT + this.byteOffset;
            a = a * c.BYTES_PER_ELEMENT + this.byteOffset;
            return new c(this.buffer.slice(b, a));
        }
        if (!("slice" in X[0].prototype)) for(var Z = 0; Z < X.length; Z++)Object.defineProperty(X[Z].prototype, "slice", {
            configurable: !0,
            value: Y,
            writable: !0
        });
    }).call(__self);
    return api;
});




var $5d17fc6f2a0ac19e$exports = {};
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";
(function(s, f) {
    if (0, $5d17fc6f2a0ac19e$exports) $5d17fc6f2a0ac19e$exports = f(s);
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : $5d17fc6f2a0ac19e$exports, function(__self) {
    var api = {};
    (function() {
        function d(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var f = d(this);
        if ("undefined" === typeof DOMRect) {
            var g = function(a, b, c, e) {
                this.x = a ? +a : 0;
                this.y = b ? +b : 0;
                this.width = c ? +c : 0;
                this.height = e ? +e : 0;
            };
            g.prototype.toJSON = function() {
                return {
                    bottom: this.bottom,
                    height: this.height,
                    left: this.left,
                    right: this.right,
                    top: this.top,
                    width: this.width,
                    x: this.x,
                    y: this.y
                };
            };
            f.Object.defineProperties(g.prototype, {
                bottom: {
                    configurable: !0,
                    enumerable: !0,
                    get: function() {
                        return 0 < this.height ? this.y + this.height : this.y;
                    }
                },
                left: {
                    configurable: !0,
                    enumerable: !0,
                    get: function() {
                        return 0 < this.width ? this.x : this.x + this.width;
                    }
                },
                right: {
                    configurable: !0,
                    enumerable: !0,
                    get: function() {
                        return 0 < this.width ? this.x + this.width : this.x;
                    }
                },
                top: {
                    configurable: !0,
                    enumerable: !0,
                    get: function() {
                        return 0 < this.height ? this.y : this.y + this.height;
                    }
                }
            });
            g.fromRect = h;
            Object.defineProperty(window, "DOMRect", {
                configurable: !0,
                value: g,
                writable: !0
            });
        }
        function h(a) {
            return a ? new DOMRect(a.x, a.y, a.width, a.height) : new DOMRect;
        }
    }).call(__self);
    return api;
});




var $ce379e9879808339$exports = {};
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";
(function(s, f1) {
    if (0, $ce379e9879808339$exports) $ce379e9879808339$exports = f1(s);
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : $ce379e9879808339$exports, function(__self) {
    var y = y || {};
    y.scope = {};
    y.ASSUME_ES5 = !1;
    y.ASSUME_NO_NATIVE_MAP = !1;
    y.ASSUME_NO_NATIVE_SET = !1;
    y.SIMPLE_FROUND_POLYFILL = !1;
    y.ISOLATE_POLYFILLS = !1;
    y.FORCE_POLYFILL_PROMISE = !1;
    y.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
    y.defineProperty = y.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(D, B, w) {
        if (D == Array.prototype || D == Object.prototype) return D;
        D[B] = w.value;
        return D;
    };
    y.getGlobal = function(D) {
        D = [
            "object" == typeof globalThis && globalThis,
            D,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $parcel$global && $parcel$global
        ];
        for(var B = 0; B < D.length; ++B){
            var w = D[B];
            if (w && w.Math == Math) return w;
        }
        throw Error("Cannot find global object");
    };
    y.global = y.getGlobal(this);
    y.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
    y.TRUST_ES6_POLYFILLS = !y.ISOLATE_POLYFILLS || y.IS_SYMBOL_NATIVE;
    y.polyfills = {};
    y.propertyToPolyfillSymbol = {};
    y.POLYFILL_PREFIX = "$jscp$";
    y.polyfill = function(D, B, w, A) {
        B && (y.ISOLATE_POLYFILLS ? y.polyfillIsolated(D, B, w, A) : y.polyfillUnisolated(D, B, w, A));
    };
    y.polyfillUnisolated = function(D, B) {
        var w = y.global;
        D = D.split(".");
        for(var A = 0; A < D.length - 1; A++){
            var d = D[A];
            if (!(d in w)) return;
            w = w[d];
        }
        D = D[D.length - 1];
        A = w[D];
        B = B(A);
        B != A && null != B && y.defineProperty(w, D, {
            configurable: !0,
            writable: !0,
            value: B
        });
    };
    y.polyfillIsolated = function(D, B, w) {
        var A = D.split(".");
        D = 1 === A.length;
        var d = A[0];
        d = !D && d in y.polyfills ? y.polyfills : y.global;
        for(var p = 0; p < A.length - 1; p++){
            var q = A[p];
            if (!(q in d)) return;
            d = d[q];
        }
        A = A[A.length - 1];
        w = y.IS_SYMBOL_NATIVE && "es6" === w ? d[A] : null;
        B = B(w);
        null != B && (D ? y.defineProperty(y.polyfills, A, {
            configurable: !0,
            writable: !0,
            value: B
        }) : B !== w && (void 0 === y.propertyToPolyfillSymbol[A] && (D = 1E9 * Math.random() >>> 0, y.propertyToPolyfillSymbol[A] = y.IS_SYMBOL_NATIVE ? y.global.Symbol(A) : y.POLYFILL_PREFIX + D + "$" + A), y.defineProperty(d, y.propertyToPolyfillSymbol[A], {
            configurable: !0,
            writable: !0,
            value: B
        })));
    };
    y.polyfill("Array.prototype.fill", function(D) {
        return D ? D : function(B, w, A) {
            var d = this.length || 0;
            0 > w && (w = Math.max(0, d + w));
            if (null == A || A > d) A = d;
            A = Number(A);
            0 > A && (A = Math.max(0, d + A));
            for(w = Number(w || 0); w < A; w++)this[w] = B;
            return this;
        };
    }, "es6", "es3");
    y.typedArrayFill = function(D) {
        return D ? D : Array.prototype.fill;
    };
    y.polyfill("Int8Array.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Uint8Array.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Uint8ClampedArray.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Int16Array.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Uint16Array.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Int32Array.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Uint32Array.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Float32Array.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Float64Array.prototype.fill", y.typedArrayFill, "es6", "es5");
    y.polyfill("Array.from", function(D) {
        return D ? D : function(B, w, A) {
            w = null != w ? w : function(f1) {
                return f1;
            };
            var d = [], p = "undefined" != typeof Symbol && Symbol.iterator && B[Symbol.iterator];
            if ("function" == typeof p) {
                B = p.call(B);
                for(var q = 0; !(p = B.next()).done;)d.push(w.call(A, p.value, q++));
            } else for(p = B.length, q = 0; q < p; q++)d.push(w.call(A, B[q], q));
            return d;
        };
    }, "es6", "es3");
    (function() {
        function D(B, w, A) {
            function d(f1, g) {
                if (!w[f1]) {
                    if (!B[f1]) {
                        var k = undefined;
                        if (!g && k) return k(f1, !0);
                        if (p) return p(f1, !0);
                        g = Error("Cannot find module '" + f1 + "'");
                        throw g.code = "MODULE_NOT_FOUND", g;
                    }
                    g = w[f1] = {
                        exports: {}
                    };
                    B[f1][0].call(g.exports, function(c) {
                        return d(B[f1][1][c] || c);
                    }, g, g.exports, D, B, w, A);
                }
                return w[f1].exports;
            }
            for(var p = undefined, q = 0; q < A.length; q++)d(A[q]);
            return d;
        }
        return D;
    })()({
        1: [
            function() {
                !function() {
                    var D = {}, B = {};
                    !function(w) {
                        function A(r1) {
                            return r1;
                        }
                        function d() {
                            this._endDelay = this._delay = 0;
                            this._fill = "none";
                            this._iterationStart = 0;
                            this._iterations = 1;
                            this._duration = 0;
                            this._playbackRate = 1;
                            this._direction = "normal";
                            this._easing = "linear";
                            this._easingFunction = A;
                        }
                        function p() {
                            return w.isDeprecated("Invalid timing inputs", "2016-03-02", "TypeError exceptions will be thrown instead.", !0);
                        }
                        function q(r1, C) {
                            var x = new d;
                            return C && (x.fill = "both", x.duration = "auto"), "number" != typeof r1 || isNaN(r1) ? void 0 !== r1 && Object.getOwnPropertyNames(r1).forEach(function(E) {
                                "auto" == r1[E] || ("number" == typeof x[E] || "duration" == E) && ("number" != typeof r1[E] || isNaN(r1[E])) || "fill" == E && -1 == b.indexOf(r1[E]) || "direction" == E && -1 == n.indexOf(r1[E]) || "playbackRate" == E && 1 !== r1[E] && w.isDeprecated("AnimationEffectTiming.playbackRate", "2014-11-28", "Use Animation.playbackRate instead.") || (x[E] = r1[E]);
                            }) : x.duration = r1, x;
                        }
                        function f1(r1, C, x, E) {
                            return 0 > r1 || 1 < r1 || 0 > x || 1 < x ? A : function(J) {
                                if (0 >= J) {
                                    var L = 0;
                                    return 0 < r1 ? L = C / r1 : !C && 0 < x && (L = E / x), L * J;
                                }
                                if (1 <= J) return L = 0, 1 > x ? L = (E - 1) / (x - 1) : 1 == x && 1 > r1 && (L = (C - 1) / (r1 - 1)), 1 + L * (J - 1);
                                L = 0;
                                for(var N = 1; L < N;){
                                    var H = (L + N) / 2, M = 3 * r1 * (1 - H) * (1 - H) * H + 3 * x * (1 - H) * H * H + H * H * H;
                                    if (1E-5 > Math.abs(J - M)) break;
                                    M < J ? L = H : N = H;
                                }
                                return 3 * C * (1 - H) * (1 - H) * H + 3 * E * (1 - H) * H * H + H * H * H;
                            };
                        }
                        function g(r1, C) {
                            return function(x) {
                                if (1 <= x) return 1;
                                var E = 1 / r1;
                                return (x += C * E) - x % E;
                            };
                        }
                        function k(r1) {
                            v || (v = document.createElement("div").style);
                            v.animationTimingFunction = "";
                            v.animationTimingFunction = r1;
                            var C = v.animationTimingFunction;
                            if ("" == C && p()) throw new TypeError(r1 + " is not a valid value for easing");
                            return C;
                        }
                        function c(r1) {
                            if ("linear" == r1) return A;
                            var C = l.exec(r1);
                            return C ? f1.apply(this, C.slice(1).map(Number)) : (C = u.exec(r1)) ? g(Number(C[1]), m) : (C = z.exec(r1)) ? g(Number(C[1]), {
                                start: h1,
                                middle: e,
                                end: m
                            }[C[2]]) : t[r1] || A;
                        }
                        function a(r1, C, x) {
                            if (null == C) return F;
                            var E = x.delay + r1 + x.endDelay;
                            return C < Math.min(x.delay, E) ? K : C >= Math.min(x.delay + r1, E) ? I : G;
                        }
                        var b = [
                            "backwards",
                            "forwards",
                            "both",
                            "none"
                        ], n = [
                            "reverse",
                            "alternate",
                            "alternate-reverse"
                        ];
                        d.prototype = {
                            _setMember: function(r1, C) {
                                this["_" + r1] = C;
                                this._effect && (this._effect._timingInput[r1] = C, this._effect._timing = w.normalizeTimingInput(this._effect._timingInput), this._effect.activeDuration = w.calculateActiveDuration(this._effect._timing), this._effect._animation && this._effect._animation._rebuildUnderlyingAnimation());
                            },
                            get playbackRate () {
                                return this._playbackRate;
                            },
                            set delay (r){
                                this._setMember("delay", r);
                            },
                            get delay () {
                                return this._delay;
                            },
                            set endDelay (r){
                                this._setMember("endDelay", r);
                            },
                            get endDelay () {
                                return this._endDelay;
                            },
                            set fill (r){
                                this._setMember("fill", r);
                            },
                            get fill () {
                                return this._fill;
                            },
                            set iterationStart (r){
                                if ((isNaN(r) || 0 > r) && p()) throw new TypeError("iterationStart must be a non-negative number, received: " + r);
                                this._setMember("iterationStart", r);
                            },
                            get iterationStart () {
                                return this._iterationStart;
                            },
                            set duration (r){
                                if ("auto" != r && (isNaN(r) || 0 > r) && p()) throw new TypeError("duration must be non-negative or auto, received: " + r);
                                this._setMember("duration", r);
                            },
                            get duration () {
                                return this._duration;
                            },
                            set direction (r){
                                this._setMember("direction", r);
                            },
                            get direction () {
                                return this._direction;
                            },
                            set easing (r){
                                this._easingFunction = c(k(r));
                                this._setMember("easing", r);
                            },
                            get easing () {
                                return this._easing;
                            },
                            set iterations (r){
                                if ((isNaN(r) || 0 > r) && p()) throw new TypeError("iterations must be non-negative, received: " + r);
                                this._setMember("iterations", r);
                            },
                            get iterations () {
                                return this._iterations;
                            }
                        };
                        var h1 = 1, e = .5, m = 0, t = {
                            ease: f1(.25, .1, .25, 1),
                            "ease-in": f1(.42, 0, 1, 1),
                            "ease-out": f1(0, 0, .58, 1),
                            "ease-in-out": f1(.42, 0, .58, 1),
                            "step-start": g(1, h1),
                            "step-middle": g(1, e),
                            "step-end": g(1, m)
                        }, v = null, l = RegExp("cubic-bezier\\(\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*,\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*,\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*,\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*\\)"), u = /steps\(\s*(\d+)\s*\)/, z = /steps\(\s*(\d+)\s*,\s*(start|middle|end)\s*\)/, F = 0, K = 1, I = 2, G = 3;
                        w.cloneTimingInput = function(r1) {
                            if ("number" == typeof r1) return r1;
                            var C = {}, x;
                            for(x in r1)C[x] = r1[x];
                            return C;
                        };
                        w.makeTiming = q;
                        w.numericTimingToObject = function(r1) {
                            return "number" == typeof r1 && (r1 = isNaN(r1) ? {
                                duration: 0
                            } : {
                                duration: r1
                            }), r1;
                        };
                        w.normalizeTimingInput = function(r1, C) {
                            return r1 = w.numericTimingToObject(r1), q(r1, C);
                        };
                        w.calculateActiveDuration = function(r1) {
                            return Math.abs((0 === r1.duration || 0 === r1.iterations ? 0 : r1.duration * r1.iterations) / r1.playbackRate);
                        };
                        w.calculateIterationProgress = function(r1, C, x) {
                            var E = a(r1, C, x);
                            a: {
                                var J = x.fill;
                                switch(E){
                                    case K:
                                        r1 = "backwards" == J || "both" == J ? 0 : null;
                                        break a;
                                    case G:
                                        r1 = C - x.delay;
                                        break a;
                                    case I:
                                        r1 = "forwards" == J || "both" == J ? r1 : null;
                                        break a;
                                    case F:
                                        r1 = null;
                                        break a;
                                }
                                r1 = void 0;
                            }
                            if (null === r1) return null;
                            J = x.duration;
                            var L = x.iterationStart;
                            C = (0 === J ? E !== K && (L += x.iterations) : L += r1 / J, L);
                            J = C === 1 / 0 ? x.iterationStart % 1 : C % 1;
                            r1 = (0 !== J || E !== I || 0 === x.iterations || 0 === r1 && 0 !== x.duration || (J = 1), J);
                            J = E === I && x.iterations === 1 / 0 ? 1 / 0 : 1 === r1 ? Math.floor(C) - 1 : Math.floor(C);
                            C = E = x.direction;
                            "normal" !== E && "reverse" !== E && ("alternate-reverse" === E && (J += 1), C = "normal", J !== 1 / 0 && 0 != J % 2 && (C = "reverse"));
                            return x._easingFunction("normal" === C ? r1 : 1 - r1);
                        };
                        w.calculatePhase = a;
                        w.normalizeEasing = k;
                        w.parseEasingFunction = c;
                    }(D);
                    (function(w) {
                        function A(g) {
                            var k = [], c;
                            for(c in g)if (!(c in [
                                "easing",
                                "offset",
                                "composite"
                            ])) {
                                var a = g[c];
                                Array.isArray(a) || (a = [
                                    a
                                ]);
                                for(var b, n = a.length, h1 = 0; h1 < n; h1++)b = {}, b.offset = "offset" in g ? g.offset : 1 == n ? 1 : h1 / (n - 1), "easing" in g && (b.easing = g.easing), "composite" in g && (b.composite = g.composite), b[c] = a[h1], k.push(b);
                            }
                            return k.sort(function(e, m) {
                                return e.offset - m.offset;
                            }), k;
                        }
                        var d = {
                            background: "backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundAttachment backgroundOrigin backgroundClip backgroundColor".split(" "),
                            border: "borderTopColor borderTopStyle borderTopWidth borderRightColor borderRightStyle borderRightWidth borderBottomColor borderBottomStyle borderBottomWidth borderLeftColor borderLeftStyle borderLeftWidth".split(" "),
                            borderBottom: [
                                "borderBottomWidth",
                                "borderBottomStyle",
                                "borderBottomColor"
                            ],
                            borderColor: [
                                "borderTopColor",
                                "borderRightColor",
                                "borderBottomColor",
                                "borderLeftColor"
                            ],
                            borderLeft: [
                                "borderLeftWidth",
                                "borderLeftStyle",
                                "borderLeftColor"
                            ],
                            borderRadius: [
                                "borderTopLeftRadius",
                                "borderTopRightRadius",
                                "borderBottomRightRadius",
                                "borderBottomLeftRadius"
                            ],
                            borderRight: [
                                "borderRightWidth",
                                "borderRightStyle",
                                "borderRightColor"
                            ],
                            borderTop: [
                                "borderTopWidth",
                                "borderTopStyle",
                                "borderTopColor"
                            ],
                            borderWidth: [
                                "borderTopWidth",
                                "borderRightWidth",
                                "borderBottomWidth",
                                "borderLeftWidth"
                            ],
                            flex: [
                                "flexGrow",
                                "flexShrink",
                                "flexBasis"
                            ],
                            font: "fontFamily fontSize fontStyle fontVariant fontWeight lineHeight".split(" "),
                            margin: [
                                "marginTop",
                                "marginRight",
                                "marginBottom",
                                "marginLeft"
                            ],
                            outline: [
                                "outlineColor",
                                "outlineStyle",
                                "outlineWidth"
                            ],
                            padding: [
                                "paddingTop",
                                "paddingRight",
                                "paddingBottom",
                                "paddingLeft"
                            ]
                        }, p = document.createElementNS("http://www.w3.org/1999/xhtml", "div"), q = {
                            thin: "1px",
                            medium: "3px",
                            thick: "5px"
                        }, f1 = {
                            borderBottomWidth: q,
                            borderLeftWidth: q,
                            borderRightWidth: q,
                            borderTopWidth: q,
                            fontSize: {
                                "xx-small": "60%",
                                "x-small": "75%",
                                small: "89%",
                                medium: "100%",
                                large: "120%",
                                "x-large": "150%",
                                "xx-large": "200%"
                            },
                            fontWeight: {
                                normal: "400",
                                bold: "700"
                            },
                            outlineWidth: q,
                            textShadow: {
                                none: "0px 0px 0px transparent"
                            },
                            boxShadow: {
                                none: "0px 0px 0px 0px transparent"
                            }
                        };
                        w.convertToArrayForm = A;
                        w.normalizeKeyframes = function(g) {
                            function k() {
                                var h1 = c.length;
                                null == c[h1 - 1].offset && (c[h1 - 1].offset = 1);
                                1 < h1 && null == c[0].offset && (c[0].offset = 0);
                                for(var e = 0, m = c[0].offset, t = 1; t < h1; t++){
                                    var v = c[t].offset;
                                    if (null != v) {
                                        for(var l = 1; l < t - e; l++)c[e + l].offset = m + (v - m) * l / (t - e);
                                        e = t;
                                        m = v;
                                    }
                                }
                            }
                            if (null == g) return [];
                            window.Symbol && Symbol.iterator && Array.prototype.from && g[Symbol.iterator] && (g = Array.from(g));
                            Array.isArray(g) || (g = A(g));
                            var c = g.map(function(h1) {
                                var e = {}, m;
                                for(m in h1){
                                    var t = h1[m];
                                    if ("offset" == m) {
                                        if (null != t) {
                                            if (t = Number(t), !isFinite(t)) throw new TypeError("Keyframe offsets must be numbers.");
                                            if (0 > t || 1 < t) throw new TypeError("Keyframe offsets must be between 0 and 1.");
                                        }
                                    } else if ("composite" == m) {
                                        if ("add" == t || "accumulate" == t) throw {
                                            type: DOMException.NOT_SUPPORTED_ERR,
                                            name: "NotSupportedError",
                                            message: "add compositing is not supported"
                                        };
                                        if ("replace" != t) throw new TypeError("Invalid composite mode " + t + ".");
                                    } else t = "easing" == m ? w.normalizeEasing(t) : "" + t;
                                    var v = void 0, l = m, u = t;
                                    t = e;
                                    var z = l;
                                    if ("display" !== z && 0 !== z.lastIndexOf("animation", 0) && 0 !== z.lastIndexOf("transition", 0)) {
                                        if (z = d[l]) for(v in p.style[l] = u, z){
                                            u = l = z[v];
                                            var F = p.style[l];
                                            t[l] = u in f1 ? f1[u][F] || F : F;
                                        }
                                        else t[l] = l in f1 ? f1[l][u] || u : u;
                                    }
                                }
                                return void 0 == e.offset && (e.offset = null), void 0 == e.easing && (e.easing = "linear"), e;
                            });
                            g = !0;
                            for(var a = -1 / 0, b = 0; b < c.length; b++){
                                var n = c[b].offset;
                                if (null != n) {
                                    if (n < a) throw new TypeError("Keyframes are not loosely sorted by offset. Sort or specify offsets.");
                                    a = n;
                                } else g = !1;
                            }
                            return c = c.filter(function(h1) {
                                return 0 <= h1.offset && 1 >= h1.offset;
                            }), g || k(), c;
                        };
                    })(D);
                    (function(w) {
                        var A = {};
                        w.isDeprecated = function(d, p, q, f1) {
                            f1 = f1 ? "are" : "is";
                            var g = new Date;
                            p = new Date(p);
                            return p.setMonth(p.getMonth() + 3), !(g < p && (d in A || console.warn("Web Animations: " + d + " " + f1 + " deprecated and will stop working on " + p.toDateString() + ". " + q), A[d] = !0, 1));
                        };
                        w.deprecated = function(d, p, q, f1) {
                            var g = f1 ? "are" : "is";
                            if (w.isDeprecated(d, p, q, f1)) throw Error(d + " " + g + " no longer supported. " + q);
                        };
                    })(D);
                    (function() {
                        if (document.documentElement.animate) {
                            var w = document.documentElement.animate([], 0), A = !0;
                            if (w && (A = !1, "play currentTime pause reverse playbackRate cancel finish startTime playState".split(" ").forEach(function(d) {
                                void 0 === w[d] && (A = !0);
                            })), !A) return;
                        }
                        !function(d, p) {
                            function q(g) {
                                for(var k = {}, c = 0; c < g.length; c++)for(var a in g[c])if ("offset" != a && "easing" != a && "composite" != a) {
                                    var b = {
                                        offset: g[c].offset,
                                        easing: g[c].easing,
                                        value: g[c][a]
                                    };
                                    k[a] = k[a] || [];
                                    k[a].push(b);
                                }
                                for(var n in k)if (g = k[n], 0 != g[0].offset || 1 != g[g.length - 1].offset) throw {
                                    type: DOMException.NOT_SUPPORTED_ERR,
                                    name: "NotSupportedError",
                                    message: "Partial keyframes are not supported"
                                };
                                return k;
                            }
                            function f1(g) {
                                var k = [], c;
                                for(c in g)for(var a = g[c], b = 0; b < a.length - 1; b++){
                                    var n = b, h1 = b + 1, e = a[n].offset, m = a[h1].offset, t = e, v = m;
                                    0 == b && (t = -1 / 0, 0 == m && (h1 = n));
                                    b == a.length - 2 && (v = 1 / 0, 1 == e && (n = h1));
                                    k.push({
                                        applyFrom: t,
                                        applyTo: v,
                                        startOffset: a[n].offset,
                                        endOffset: a[h1].offset,
                                        easingFunction: d.parseEasingFunction(a[n].easing),
                                        property: c,
                                        interpolation: p.propertyInterpolation(c, a[n].value, a[h1].value)
                                    });
                                }
                                return k.sort(function(l, u) {
                                    return l.startOffset - u.startOffset;
                                }), k;
                            }
                            p.convertEffectInput = function(g) {
                                g = d.normalizeKeyframes(g);
                                var k = q(g), c = f1(k);
                                return function(a, b) {
                                    if (null != b) c.filter(function(h1) {
                                        return b >= h1.applyFrom && b < h1.applyTo;
                                    }).forEach(function(h1) {
                                        var e = b - h1.startOffset, m = h1.endOffset - h1.startOffset;
                                        e = 0 == m ? 0 : h1.easingFunction(e / m);
                                        p.apply(a, h1.property, h1.interpolation(e));
                                    });
                                    else for(var n in k)"offset" != n && "easing" != n && "composite" != n && p.clear(a, n);
                                };
                            };
                        }(D, B);
                        (function(d, p) {
                            function q(k) {
                                return k.replace(/-(.)/g, function(c, a) {
                                    return a.toUpperCase();
                                });
                            }
                            var f1 = {};
                            p.addPropertiesHandler = function(k, c, a) {
                                for(var b = 0; b < a.length; b++){
                                    var n = k, h1 = c, e = q(a[b]);
                                    f1[e] = f1[e] || [];
                                    f1[e].push([
                                        n,
                                        h1
                                    ]);
                                }
                            };
                            var g = {
                                backgroundColor: "transparent",
                                backgroundPosition: "0% 0%",
                                borderBottomColor: "currentColor",
                                borderBottomLeftRadius: "0px",
                                borderBottomRightRadius: "0px",
                                borderBottomWidth: "3px",
                                borderLeftColor: "currentColor",
                                borderLeftWidth: "3px",
                                borderRightColor: "currentColor",
                                borderRightWidth: "3px",
                                borderSpacing: "2px",
                                borderTopColor: "currentColor",
                                borderTopLeftRadius: "0px",
                                borderTopRightRadius: "0px",
                                borderTopWidth: "3px",
                                bottom: "auto",
                                clip: "rect(0px, 0px, 0px, 0px)",
                                color: "black",
                                fontSize: "100%",
                                fontWeight: "400",
                                height: "auto",
                                left: "auto",
                                letterSpacing: "normal",
                                lineHeight: "120%",
                                marginBottom: "0px",
                                marginLeft: "0px",
                                marginRight: "0px",
                                marginTop: "0px",
                                maxHeight: "none",
                                maxWidth: "none",
                                minHeight: "0px",
                                minWidth: "0px",
                                opacity: "1.0",
                                outlineColor: "invert",
                                outlineOffset: "0px",
                                outlineWidth: "3px",
                                paddingBottom: "0px",
                                paddingLeft: "0px",
                                paddingRight: "0px",
                                paddingTop: "0px",
                                right: "auto",
                                strokeDasharray: "none",
                                strokeDashoffset: "0px",
                                textIndent: "0px",
                                textShadow: "0px 0px 0px transparent",
                                top: "auto",
                                transform: "",
                                verticalAlign: "0px",
                                visibility: "visible",
                                width: "auto",
                                wordSpacing: "normal",
                                zIndex: "auto"
                            };
                            p.propertyInterpolation = function(k, c, a) {
                                var b = k;
                                /-/.test(k) && !d.isDeprecated("Hyphenated property names", "2016-03-22", "Use camelCase instead.", !0) && (b = q(k));
                                "initial" != c && "initial" != a || ("initial" == c && (c = g[b]), "initial" == a && (a = g[b]));
                                k = c == a ? [] : f1[b];
                                for(b = 0; k && b < k.length; b++){
                                    var n = k[b][0](c), h1 = k[b][0](a);
                                    if (void 0 !== n && void 0 !== h1 && (n = k[b][1](n, h1))) {
                                        var e = p.Interpolation.apply(null, n);
                                        return function(m) {
                                            return 0 == m ? c : 1 == m ? a : e(m);
                                        };
                                    }
                                }
                                return p.Interpolation(!1, !0, function(m) {
                                    return m ? a : c;
                                });
                            };
                        })(D, B);
                        (function(d, p) {
                            function q(f1) {
                                function g(c) {
                                    return d.calculateIterationProgress(k, c, f1);
                                }
                                var k = d.calculateActiveDuration(f1);
                                return g._totalDuration = f1.delay + k + f1.endDelay, g;
                            }
                            p.KeyframeEffect = function(f1, g, k, c) {
                                function a() {
                                    h1(f1, b);
                                }
                                var b, n = q(d.normalizeTimingInput(k)), h1 = p.convertEffectInput(g);
                                return a._update = function(e) {
                                    return null !== (b = n(e));
                                }, a._clear = function() {
                                    h1(f1, null);
                                }, a._hasSameTarget = function(e) {
                                    return f1 === e;
                                }, a._target = f1, a._totalDuration = n._totalDuration, a._id = c, a;
                            };
                        })(D, B);
                        (function(d) {
                            function p(h1, e, m) {
                                m.enumerable = !0;
                                m.configurable = !0;
                                Object.defineProperty(h1, e, m);
                            }
                            function q(h1) {
                                this._element = h1;
                                this._surrogateStyle = document.createElementNS("http://www.w3.org/1999/xhtml", "div").style;
                                this._style = h1.style;
                                this._length = 0;
                                this._isAnimatedProperty = {};
                                var e = window;
                                this._updateSvgTransformAttr = !(!h1.namespaceURI || -1 == h1.namespaceURI.indexOf("/svg")) && (g in e || (e[g] = /Trident|MSIE|IEMobile|Edge|Android 4/i.test(e.navigator.userAgent)), e[g]);
                                this._savedTransformAttr = null;
                                for(h1 = 0; h1 < this._style.length; h1++)e = this._style[h1], this._surrogateStyle[e] = this._style[e];
                                this._updateIndices();
                            }
                            function f1(h1) {
                                if (!h1._webAnimationsPatchedStyle) {
                                    var e = new q(h1);
                                    try {
                                        p(h1, "style", {
                                            get: function() {
                                                return e;
                                            }
                                        });
                                    } catch (m) {
                                        h1.style._set = function(t, v) {
                                            h1.style[t] = v;
                                        }, h1.style._clear = function(t) {
                                            h1.style[t] = "";
                                        };
                                    }
                                    h1._webAnimationsPatchedStyle = h1.style;
                                }
                            }
                            var g = "_webAnimationsUpdateSvgTransformAttr", k = {
                                cssText: 1,
                                length: 1,
                                parentRule: 1
                            }, c = {
                                getPropertyCSSValue: 1,
                                getPropertyPriority: 1,
                                getPropertyValue: 1,
                                item: 1,
                                removeProperty: 1,
                                setProperty: 1
                            }, a = {
                                removeProperty: 1,
                                setProperty: 1
                            };
                            q.prototype = {
                                get cssText () {
                                    return this._surrogateStyle.cssText;
                                },
                                set cssText (h){
                                    for(var e = {}, m = 0; m < this._surrogateStyle.length; m++)e[this._surrogateStyle[m]] = !0;
                                    this._surrogateStyle.cssText = h;
                                    this._updateIndices();
                                    for(m = 0; m < this._surrogateStyle.length; m++)e[this._surrogateStyle[m]] = !0;
                                    for(var t in e)this._isAnimatedProperty[t] || this._style.setProperty(t, this._surrogateStyle.getPropertyValue(t));
                                },
                                get length () {
                                    return this._surrogateStyle.length;
                                },
                                get parentRule () {
                                    return this._style.parentRule;
                                },
                                _updateIndices: function() {
                                    for(; this._length < this._surrogateStyle.length;)Object.defineProperty(this, this._length, {
                                        configurable: !0,
                                        enumerable: !1,
                                        get: function(h1) {
                                            return function() {
                                                return this._surrogateStyle[h1];
                                            };
                                        }(this._length)
                                    }), this._length++;
                                    for(; this._length > this._surrogateStyle.length;)this._length--, Object.defineProperty(this, this._length, {
                                        configurable: !0,
                                        enumerable: !1,
                                        value: void 0
                                    });
                                },
                                _set: function(h1, e) {
                                    this._style[h1] = e;
                                    this._isAnimatedProperty[h1] = !0;
                                    this._updateSvgTransformAttr && "transform" == d.unprefixedPropertyName(h1) && (null == this._savedTransformAttr && (this._savedTransformAttr = this._element.getAttribute("transform")), this._element.setAttribute("transform", d.transformToSvgMatrix(e)));
                                },
                                _clear: function(h1) {
                                    this._style[h1] = this._surrogateStyle[h1];
                                    this._updateSvgTransformAttr && "transform" == d.unprefixedPropertyName(h1) && (this._savedTransformAttr ? this._element.setAttribute("transform", this._savedTransformAttr) : this._element.removeAttribute("transform"), this._savedTransformAttr = null);
                                    delete this._isAnimatedProperty[h1];
                                }
                            };
                            for(var b in c)q.prototype[b] = function(h1, e) {
                                return function() {
                                    var m = this._surrogateStyle[h1].apply(this._surrogateStyle, arguments);
                                    return e && (this._isAnimatedProperty[arguments[0]] || this._style[h1].apply(this._style, arguments), this._updateIndices()), m;
                                };
                            }(b, b in a);
                            for(var n in document.documentElement.style)n in k || n in c || function(h1) {
                                p(q.prototype, h1, {
                                    get: function() {
                                        return this._surrogateStyle[h1];
                                    },
                                    set: function(e) {
                                        this._surrogateStyle[h1] = e;
                                        this._updateIndices();
                                        this._isAnimatedProperty[h1] || (this._style[h1] = e);
                                    }
                                });
                            }(n);
                            d.apply = function(h1, e, m) {
                                f1(h1);
                                h1.style._set(d.propertyName(e), m);
                            };
                            d.clear = function(h1, e) {
                                h1._webAnimationsPatchedStyle && h1.style._clear(d.propertyName(e));
                            };
                        })(B);
                        (function(d) {
                            window.Element.prototype.animate = function(p, q) {
                                var f1 = "";
                                return q && q.id && (f1 = q.id), d.timeline._play(d.KeyframeEffect(this, p, q, f1));
                            };
                        })(B);
                        (function(d) {
                            function p(q, f1, g) {
                                if ("number" == typeof q && "number" == typeof f1) return q * (1 - g) + f1 * g;
                                if ("boolean" == typeof q && "boolean" == typeof f1) return .5 > g ? q : f1;
                                if (q.length == f1.length) {
                                    for(var k = [], c = 0; c < q.length; c++)k.push(p(q[c], f1[c], g));
                                    return k;
                                }
                                throw "Mismatched interpolation arguments " + q + ":" + f1;
                            }
                            d.Interpolation = function(q, f1, g) {
                                return function(k) {
                                    return g(p(q, f1, k));
                                };
                            };
                        })(B);
                        (function(d) {
                            var p = function() {
                                function q(f1, g) {
                                    for(var k = [
                                        [
                                            0,
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0,
                                            0
                                        ]
                                    ], c = 0; 4 > c; c++)for(var a = 0; 4 > a; a++)for(var b = 0; 4 > b; b++)k[c][a] += g[c][b] * f1[b][a];
                                    return k;
                                }
                                return function(f1, g, k, c, a) {
                                    for(var b = [
                                        [
                                            1,
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            1,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            1,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0,
                                            1
                                        ]
                                    ], n = 0; 4 > n; n++)b[n][3] = a[n];
                                    for(n = 0; 3 > n; n++)for(a = 0; 3 > a; a++)b[3][n] += f1[a] * b[a][n];
                                    f1 = c[0];
                                    n = c[1];
                                    a = c[2];
                                    c = c[3];
                                    var h1 = [
                                        [
                                            1,
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            1,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            1,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0,
                                            1
                                        ]
                                    ];
                                    h1[0][0] = 1 - 2 * (n * n + a * a);
                                    h1[0][1] = 2 * (f1 * n - a * c);
                                    h1[0][2] = 2 * (f1 * a + n * c);
                                    h1[1][0] = 2 * (f1 * n + a * c);
                                    h1[1][1] = 1 - 2 * (f1 * f1 + a * a);
                                    h1[1][2] = 2 * (n * a - f1 * c);
                                    h1[2][0] = 2 * (f1 * a - n * c);
                                    h1[2][1] = 2 * (n * a + f1 * c);
                                    h1[2][2] = 1 - 2 * (f1 * f1 + n * n);
                                    b = q(b, h1);
                                    c = [
                                        [
                                            1,
                                            0,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            1,
                                            0,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            1,
                                            0
                                        ],
                                        [
                                            0,
                                            0,
                                            0,
                                            1
                                        ]
                                    ];
                                    k[2] && (c[2][1] = k[2], b = q(b, c));
                                    k[1] && (c[2][1] = 0, c[2][0] = k[0], b = q(b, c));
                                    k[0] && (c[2][0] = 0, c[1][0] = k[0], b = q(b, c));
                                    for(n = 0; 3 > n; n++)for(a = 0; 3 > a; a++)b[n][a] *= g[n];
                                    return 0 == b[0][2] && 0 == b[0][3] && 0 == b[1][2] && 0 == b[1][3] && 0 == b[2][0] && 0 == b[2][1] && 1 == b[2][2] && 0 == b[2][3] && 0 == b[3][2] && 1 == b[3][3] ? [
                                        b[0][0],
                                        b[0][1],
                                        b[1][0],
                                        b[1][1],
                                        b[3][0],
                                        b[3][1]
                                    ] : b[0].concat(b[1], b[2], b[3]);
                                };
                            }();
                            d.composeMatrix = p;
                            d.quat = function(q, f1, g) {
                                var k = d.dot(q, f1);
                                k = Math.max(Math.min(k, 1), -1);
                                var c = [];
                                if (1 === k) c = q;
                                else for(var a = Math.acos(k), b = 1 * Math.sin(g * a) / Math.sqrt(1 - k * k), n = 0; 4 > n; n++)c.push(q[n] * (Math.cos(g * a) - k * b) + f1[n] * b);
                                return c;
                            };
                        })(B);
                        (function(d, p) {
                            function q(f1, g, k) {
                                this.target = f1;
                                this.currentTime = g;
                                this.timelineTime = k;
                                this.type = "finish";
                                this.cancelable = this.bubbles = !1;
                                this.currentTarget = f1;
                                this.defaultPrevented = !1;
                                this.eventPhase = Event.AT_TARGET;
                                this.timeStamp = Date.now();
                            }
                            d.sequenceNumber = 0;
                            p.Animation = function(f1) {
                                this.id = "";
                                f1 && f1._id && (this.id = f1._id);
                                this._sequenceNumber = d.sequenceNumber++;
                                this._currentTime = 0;
                                this._startTime = null;
                                this._paused = !1;
                                this._playbackRate = 1;
                                this._finishedFlag = this._inTimeline = !0;
                                this.onfinish = null;
                                this._finishHandlers = [];
                                this._effect = f1;
                                this._inEffect = this._effect._update(0);
                                this._idle = !0;
                                this._currentTimePending = !1;
                            };
                            p.Animation.prototype = {
                                _ensureAlive: function() {
                                    0 > this.playbackRate && 0 === this.currentTime ? this._inEffect = this._effect._update(-1) : this._inEffect = this._effect._update(this.currentTime);
                                    this._inTimeline || !this._inEffect && this._finishedFlag || (this._inTimeline = !0, p.timeline._animations.push(this));
                                },
                                _tickCurrentTime: function(f1, g) {
                                    f1 != this._currentTime && (this._currentTime = f1, this._isFinished && !g && (this._currentTime = 0 < this._playbackRate ? this._totalDuration : 0), this._ensureAlive());
                                },
                                get currentTime () {
                                    return this._idle || this._currentTimePending ? null : this._currentTime;
                                },
                                set currentTime (f){
                                    f = +f;
                                    isNaN(f) || (p.restart(), this._paused || null == this._startTime || (this._startTime = this._timeline.currentTime - f / this._playbackRate), this._currentTimePending = !1, this._currentTime != f && (this._idle && (this._idle = !1, this._paused = !0), this._tickCurrentTime(f, !0), p.applyDirtiedAnimation(this)));
                                },
                                get startTime () {
                                    return this._startTime;
                                },
                                set startTime (f){
                                    f = +f;
                                    isNaN(f) || this._paused || this._idle || (this._startTime = f, this._tickCurrentTime((this._timeline.currentTime - this._startTime) * this.playbackRate), p.applyDirtiedAnimation(this));
                                },
                                get playbackRate () {
                                    return this._playbackRate;
                                },
                                set playbackRate (f){
                                    if (f != this._playbackRate) {
                                        var g = this.currentTime;
                                        this._playbackRate = f;
                                        this._startTime = null;
                                        "paused" != this.playState && "idle" != this.playState && (this._finishedFlag = !1, this._idle = !1, this._ensureAlive(), p.applyDirtiedAnimation(this));
                                        null != g && (this.currentTime = g);
                                    }
                                },
                                get _isFinished () {
                                    return !this._idle && (0 < this._playbackRate && this._currentTime >= this._totalDuration || 0 > this._playbackRate && 0 >= this._currentTime);
                                },
                                get _totalDuration () {
                                    return this._effect._totalDuration;
                                },
                                get playState () {
                                    return this._idle ? "idle" : null == this._startTime && !this._paused && 0 != this.playbackRate || this._currentTimePending ? "pending" : this._paused ? "paused" : this._isFinished ? "finished" : "running";
                                },
                                _rewind: function() {
                                    if (0 <= this._playbackRate) this._currentTime = 0;
                                    else {
                                        if (!(this._totalDuration < 1 / 0)) throw new DOMException("Unable to rewind negative playback rate animation with infinite duration", "InvalidStateError");
                                        this._currentTime = this._totalDuration;
                                    }
                                },
                                play: function() {
                                    this._paused = !1;
                                    (this._isFinished || this._idle) && (this._rewind(), this._startTime = null);
                                    this._idle = this._finishedFlag = !1;
                                    this._ensureAlive();
                                    p.applyDirtiedAnimation(this);
                                },
                                pause: function() {
                                    this._isFinished || this._paused || this._idle ? this._idle && (this._rewind(), this._idle = !1) : this._currentTimePending = !0;
                                    this._startTime = null;
                                    this._paused = !0;
                                },
                                finish: function() {
                                    this._idle || (this.currentTime = 0 < this._playbackRate ? this._totalDuration : 0, this._startTime = this._totalDuration - this.currentTime, this._currentTimePending = !1, p.applyDirtiedAnimation(this));
                                },
                                cancel: function() {
                                    this._inEffect && (this._inEffect = !1, this._idle = !0, this._paused = !1, this._finishedFlag = !0, this._currentTime = 0, this._startTime = null, this._effect._update(null), p.applyDirtiedAnimation(this));
                                },
                                reverse: function() {
                                    this.playbackRate *= -1;
                                    this.play();
                                },
                                addEventListener: function(f1, g) {
                                    "function" == typeof g && "finish" == f1 && this._finishHandlers.push(g);
                                },
                                removeEventListener: function(f1, g) {
                                    "finish" == f1 && (f1 = this._finishHandlers.indexOf(g), 0 <= f1 && this._finishHandlers.splice(f1, 1));
                                },
                                _fireEvents: function(f1) {
                                    if (this._isFinished) {
                                        if (!this._finishedFlag) {
                                            var g = new q(this, this._currentTime, f1), k = this._finishHandlers.concat(this.onfinish ? [
                                                this.onfinish
                                            ] : []);
                                            setTimeout(function() {
                                                k.forEach(function(c) {
                                                    c.call(g.target, g);
                                                });
                                            }, 0);
                                            this._finishedFlag = !0;
                                        }
                                    } else this._finishedFlag = !1;
                                },
                                _tick: function(f1, g) {
                                    this._idle || this._paused || (null == this._startTime ? g && (this.startTime = f1 - this._currentTime / this.playbackRate) : this._isFinished || this._tickCurrentTime((f1 - this._startTime) * this.playbackRate));
                                    g && (this._currentTimePending = !1, this._fireEvents(f1));
                                },
                                get _needsTick () {
                                    return this.playState in {
                                        pending: 1,
                                        running: 1
                                    } || !this._finishedFlag;
                                },
                                _targetAnimations: function() {
                                    var f1 = this._effect._target;
                                    return f1._activeAnimations || (f1._activeAnimations = []), f1._activeAnimations;
                                },
                                _markTarget: function() {
                                    var f1 = this._targetAnimations();
                                    -1 === f1.indexOf(this) && f1.push(this);
                                },
                                _unmarkTarget: function() {
                                    var f1 = this._targetAnimations(), g = f1.indexOf(this);
                                    -1 !== g && f1.splice(g, 1);
                                }
                            };
                        })(D, B);
                        (function(d, p) {
                            function q(l) {
                                var u = b;
                                b = [];
                                l < v.currentTime && (l = v.currentTime);
                                v._animations.sort(f1);
                                v._animations = c(l, !0, v._animations)[0];
                                u.forEach(function(z) {
                                    z[1](l);
                                });
                                k();
                            }
                            function f1(l, u) {
                                return l._sequenceNumber - u._sequenceNumber;
                            }
                            function g() {
                                this._animations = [];
                                this.currentTime = window.performance && performance.now ? performance.now() : 0;
                            }
                            function k() {
                                m.forEach(function(l) {
                                    l();
                                });
                                m.length = 0;
                            }
                            function c(l, u, z) {
                                t = !0;
                                e = !1;
                                p.timeline.currentTime = l;
                                h1 = !1;
                                var F = [], K = [], I = [], G = [];
                                return z.forEach(function(r1) {
                                    r1._tick(l, u);
                                    r1._inEffect ? (K.push(r1._effect), r1._markTarget()) : (F.push(r1._effect), r1._unmarkTarget());
                                    r1._needsTick && (h1 = !0);
                                    var C = r1._inEffect || r1._needsTick;
                                    (r1._inTimeline = C) ? I.push(r1) : G.push(r1);
                                }), m.push.apply(m, F), m.push.apply(m, K), h1 && requestAnimationFrame(function() {}), t = !1, [
                                    I,
                                    G
                                ];
                            }
                            var a = window.requestAnimationFrame, b = [], n = 0;
                            window.requestAnimationFrame = function(l) {
                                var u = n++;
                                return 0 == b.length && a(q), b.push([
                                    u,
                                    l
                                ]), u;
                            };
                            window.cancelAnimationFrame = function(l) {
                                b.forEach(function(u) {
                                    u[0] == l && (u[1] = function() {});
                                });
                            };
                            g.prototype = {
                                _play: function(l) {
                                    l._timing = d.normalizeTimingInput(l.timing);
                                    l = new p.Animation(l);
                                    return l._idle = !1, l._timeline = this, this._animations.push(l), p.restart(), p.applyDirtiedAnimation(l), l;
                                }
                            };
                            var h1 = !1, e = !1;
                            p.restart = function() {
                                return h1 || (h1 = !0, requestAnimationFrame(function() {}), e = !0), e;
                            };
                            p.applyDirtiedAnimation = function(l) {
                                t || (l._markTarget(), l = l._targetAnimations(), l.sort(f1), c(p.timeline.currentTime, !1, l.slice())[1].forEach(function(u) {
                                    u = v._animations.indexOf(u);
                                    -1 !== u && v._animations.splice(u, 1);
                                }), k());
                            };
                            var m = [], t = !1, v = new g;
                            p.timeline = v;
                        })(D, B);
                        (function(d) {
                            function p(a, b) {
                                for(var n = 0, h1 = 0; h1 < a.length; h1++)n += a[h1] * b[h1];
                                return n;
                            }
                            function q(a, b) {
                                return [
                                    a[0] * b[0] + a[4] * b[1] + a[8] * b[2] + a[12] * b[3],
                                    a[1] * b[0] + a[5] * b[1] + a[9] * b[2] + a[13] * b[3],
                                    a[2] * b[0] + a[6] * b[1] + a[10] * b[2] + a[14] * b[3],
                                    a[3] * b[0] + a[7] * b[1] + a[11] * b[2] + a[15] * b[3],
                                    a[0] * b[4] + a[4] * b[5] + a[8] * b[6] + a[12] * b[7],
                                    a[1] * b[4] + a[5] * b[5] + a[9] * b[6] + a[13] * b[7],
                                    a[2] * b[4] + a[6] * b[5] + a[10] * b[6] + a[14] * b[7],
                                    a[3] * b[4] + a[7] * b[5] + a[11] * b[6] + a[15] * b[7],
                                    a[0] * b[8] + a[4] * b[9] + a[8] * b[10] + a[12] * b[11],
                                    a[1] * b[8] + a[5] * b[9] + a[9] * b[10] + a[13] * b[11],
                                    a[2] * b[8] + a[6] * b[9] + a[10] * b[10] + a[14] * b[11],
                                    a[3] * b[8] + a[7] * b[9] + a[11] * b[10] + a[15] * b[11],
                                    a[0] * b[12] + a[4] * b[13] + a[8] * b[14] + a[12] * b[15],
                                    a[1] * b[12] + a[5] * b[13] + a[9] * b[14] + a[13] * b[15],
                                    a[2] * b[12] + a[6] * b[13] + a[10] * b[14] + a[14] * b[15],
                                    a[3] * b[12] + a[7] * b[13] + a[11] * b[14] + a[15] * b[15]
                                ];
                            }
                            function f1(a) {
                                return 2 * ((a.deg || 0) / 360 + (a.grad || 0) / 400 + (a.turn || 0)) * Math.PI + (a.rad || 0);
                            }
                            function g(a) {
                                switch(a.t){
                                    case "rotatex":
                                        return a = f1(a.d[0]), [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            Math.cos(a),
                                            Math.sin(a),
                                            0,
                                            0,
                                            -Math.sin(a),
                                            Math.cos(a),
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "rotatey":
                                        return a = f1(a.d[0]), [
                                            Math.cos(a),
                                            0,
                                            -Math.sin(a),
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            Math.sin(a),
                                            0,
                                            Math.cos(a),
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "rotate":
                                    case "rotatez":
                                        return a = f1(a.d[0]), [
                                            Math.cos(a),
                                            Math.sin(a),
                                            0,
                                            0,
                                            -Math.sin(a),
                                            Math.cos(a),
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "rotate3d":
                                        var b = a.d[0], n = a.d[1], h1 = a.d[2];
                                        a = f1(a.d[3]);
                                        var e = b * b + n * n + h1 * h1;
                                        0 === e ? (b = 1, h1 = n = 0) : 1 !== e && (e = Math.sqrt(e), b /= e, n /= e, h1 /= e);
                                        e = Math.sin(a / 2);
                                        a = e * Math.cos(a / 2);
                                        e *= e;
                                        return [
                                            1 - 2 * (n * n + h1 * h1) * e,
                                            2 * (b * n * e + h1 * a),
                                            2 * (b * h1 * e - n * a),
                                            0,
                                            2 * (b * n * e - h1 * a),
                                            1 - 2 * (b * b + h1 * h1) * e,
                                            2 * (n * h1 * e + b * a),
                                            0,
                                            2 * (b * h1 * e + n * a),
                                            2 * (n * h1 * e - b * a),
                                            1 - 2 * (b * b + n * n) * e,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "scale":
                                        return [
                                            a.d[0],
                                            0,
                                            0,
                                            0,
                                            0,
                                            a.d[1],
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "scalex":
                                        return [
                                            a.d[0],
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "scaley":
                                        return [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            a.d[0],
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "scalez":
                                        return [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            a.d[0],
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "scale3d":
                                        return [
                                            a.d[0],
                                            0,
                                            0,
                                            0,
                                            0,
                                            a.d[1],
                                            0,
                                            0,
                                            0,
                                            0,
                                            a.d[2],
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "skew":
                                        return b = f1(a.d[0]), n = f1(a.d[1]), [
                                            1,
                                            Math.tan(n),
                                            0,
                                            0,
                                            Math.tan(b),
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "skewx":
                                        return a = f1(a.d[0]), [
                                            1,
                                            0,
                                            0,
                                            0,
                                            Math.tan(a),
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "skewy":
                                        return a = f1(a.d[0]), [
                                            1,
                                            Math.tan(a),
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "translate":
                                        return b = a.d[0].px || 0, n = a.d[1].px || 0, [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            b,
                                            n,
                                            0,
                                            1
                                        ];
                                    case "translatex":
                                        return b = a.d[0].px || 0, [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            b,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "translatey":
                                        return n = a.d[0].px || 0, [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            n,
                                            0,
                                            1
                                        ];
                                    case "translatez":
                                        return h1 = a.d[0].px || 0, [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            h1,
                                            1
                                        ];
                                    case "translate3d":
                                        return b = a.d[0].px || 0, n = a.d[1].px || 0, h1 = a.d[2].px || 0, [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            b,
                                            n,
                                            h1,
                                            1
                                        ];
                                    case "perspective":
                                        return [
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            a.d[0].px ? -1 / a.d[0].px : 0,
                                            0,
                                            0,
                                            0,
                                            1
                                        ];
                                    case "matrix":
                                        return [
                                            a.d[0],
                                            a.d[1],
                                            0,
                                            0,
                                            a.d[2],
                                            a.d[3],
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            0,
                                            a.d[4],
                                            a.d[5],
                                            0,
                                            1
                                        ];
                                    case "matrix3d":
                                        return a.d;
                                }
                            }
                            function k(a) {
                                return 0 === a.length ? [
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    1
                                ] : a.map(g).reduce(q);
                            }
                            var c = function() {
                                function a(e) {
                                    return e[0][0] * e[1][1] * e[2][2] + e[1][0] * e[2][1] * e[0][2] + e[2][0] * e[0][1] * e[1][2] - e[0][2] * e[1][1] * e[2][0] - e[1][2] * e[2][1] * e[0][0] - e[2][2] * e[0][1] * e[1][0];
                                }
                                function b(e) {
                                    var m = n(e);
                                    return [
                                        e[0] / m,
                                        e[1] / m,
                                        e[2] / m
                                    ];
                                }
                                function n(e) {
                                    return Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
                                }
                                function h1(e, m, t, v) {
                                    return [
                                        t * e[0] + v * m[0],
                                        t * e[1] + v * m[1],
                                        t * e[2] + v * m[2]
                                    ];
                                }
                                return function(e) {
                                    e = [
                                        e.slice(0, 4),
                                        e.slice(4, 8),
                                        e.slice(8, 12),
                                        e.slice(12, 16)
                                    ];
                                    if (1 !== e[3][3]) return null;
                                    for(var m = [], t = 0; 4 > t; t++)m.push(e[t].slice());
                                    for(t = 0; 3 > t; t++)m[t][3] = 0;
                                    if (0 === a(m)) return null;
                                    var v = [];
                                    if (e[0][3] || e[1][3] || e[2][3]) {
                                        v.push(e[0][3]);
                                        v.push(e[1][3]);
                                        v.push(e[2][3]);
                                        v.push(e[3][3]);
                                        var l = 1 / a(m), u = m[0][0], z = m[0][1];
                                        t = m[0][2];
                                        var F = m[1][0], K = m[1][1], I = m[1][2], G = m[2][0], r1 = m[2][1], C = m[2][2];
                                        l = [
                                            [
                                                (K * C - I * r1) * l,
                                                (t * r1 - z * C) * l,
                                                (z * I - t * K) * l,
                                                0
                                            ],
                                            [
                                                (I * G - F * C) * l,
                                                (u * C - t * G) * l,
                                                (t * F - u * I) * l,
                                                0
                                            ],
                                            [
                                                (F * r1 - K * G) * l,
                                                (G * z - u * r1) * l,
                                                (u * K - z * F) * l,
                                                0
                                            ]
                                        ];
                                        u = [];
                                        for(z = 0; 3 > z; z++){
                                            for(F = t = 0; 3 > F; F++)t += m[3][F] * l[F][z];
                                            u.push(t);
                                        }
                                        m = (u.push(1), l.push(u), l);
                                        m = [
                                            [
                                                m[0][0],
                                                m[1][0],
                                                m[2][0],
                                                m[3][0]
                                            ],
                                            [
                                                m[0][1],
                                                m[1][1],
                                                m[2][1],
                                                m[3][1]
                                            ],
                                            [
                                                m[0][2],
                                                m[1][2],
                                                m[2][2],
                                                m[3][2]
                                            ],
                                            [
                                                m[0][3],
                                                m[1][3],
                                                m[2][3],
                                                m[3][3]
                                            ]
                                        ];
                                        l = [];
                                        for(u = 0; 4 > u; u++){
                                            for(t = z = 0; 4 > t; t++)z += v[t] * m[t][u];
                                            l.push(z);
                                        }
                                        v = l;
                                    } else v = [
                                        0,
                                        0,
                                        0,
                                        1
                                    ];
                                    m = e[3].slice(0, 3);
                                    l = [];
                                    l.push(e[0].slice(0, 3));
                                    u = [];
                                    u.push(n(l[0]));
                                    l[0] = b(l[0]);
                                    z = [];
                                    l.push(e[1].slice(0, 3));
                                    z.push(p(l[0], l[1]));
                                    l[1] = h1(l[1], l[0], 1, -z[0]);
                                    u.push(n(l[1]));
                                    l[1] = b(l[1]);
                                    z[0] /= u[1];
                                    l.push(e[2].slice(0, 3));
                                    z.push(p(l[0], l[2]));
                                    l[2] = h1(l[2], l[0], 1, -z[1]);
                                    z.push(p(l[1], l[2]));
                                    l[2] = h1(l[2], l[1], 1, -z[2]);
                                    u.push(n(l[2]));
                                    l[2] = b(l[2]);
                                    z[1] /= u[2];
                                    z[2] /= u[2];
                                    e = l[1];
                                    t = l[2];
                                    if (0 > p(l[0], [
                                        e[1] * t[2] - e[2] * t[1],
                                        e[2] * t[0] - e[0] * t[2],
                                        e[0] * t[1] - e[1] * t[0]
                                    ])) for(t = 0; 3 > t; t++)u[t] *= -1, l[t][0] *= -1, l[t][1] *= -1, l[t][2] *= -1;
                                    var x, E;
                                    e = l[0][0] + l[1][1] + l[2][2] + 1;
                                    return 1E-4 < e ? (x = .5 / Math.sqrt(e), E = [
                                        (l[2][1] - l[1][2]) * x,
                                        (l[0][2] - l[2][0]) * x,
                                        (l[1][0] - l[0][1]) * x,
                                        .25 / x
                                    ]) : l[0][0] > l[1][1] && l[0][0] > l[2][2] ? (x = 2 * Math.sqrt(1 + l[0][0] - l[1][1] - l[2][2]), E = [
                                        .25 * x,
                                        (l[0][1] + l[1][0]) / x,
                                        (l[0][2] + l[2][0]) / x,
                                        (l[2][1] - l[1][2]) / x
                                    ]) : l[1][1] > l[2][2] ? (x = 2 * Math.sqrt(1 + l[1][1] - l[0][0] - l[2][2]), E = [
                                        (l[0][1] + l[1][0]) / x,
                                        .25 * x,
                                        (l[1][2] + l[2][1]) / x,
                                        (l[0][2] - l[2][0]) / x
                                    ]) : (x = 2 * Math.sqrt(1 + l[2][2] - l[0][0] - l[1][1]), E = [
                                        (l[0][2] + l[2][0]) / x,
                                        (l[1][2] + l[2][1]) / x,
                                        .25 * x,
                                        (l[1][0] - l[0][1]) / x
                                    ]), [
                                        m,
                                        u,
                                        z,
                                        E,
                                        v
                                    ];
                                };
                            }();
                            d.dot = p;
                            d.makeMatrixDecomposition = function(a) {
                                return [
                                    c(k(a))
                                ];
                            };
                            d.transformListToMatrix = k;
                        })(B);
                        (function(d) {
                            function p(k, c) {
                                var a = k.exec(c);
                                if (a) return a = k.ignoreCase ? a[0].toLowerCase() : a[0], [
                                    a,
                                    c.substr(a.length)
                                ];
                            }
                            function q(k, c) {
                                c = c.replace(/^\s*/, "");
                                if (k = k(c)) return [
                                    k[0],
                                    k[1].replace(/^\s*/, "")
                                ];
                            }
                            function f1(k, c) {
                                for(var a = k, b = c; a && b;)a > b ? a %= b : b %= a;
                                return k * c / (a + b);
                            }
                            function g(k, c, a, b, n) {
                                for(var h1 = [], e = [], m = [], t = f1(b.length, n.length), v = 0; v < t; v++){
                                    var l = c(b[v % b.length], n[v % n.length]);
                                    if (!l) return;
                                    h1.push(l[0]);
                                    e.push(l[1]);
                                    m.push(l[2]);
                                }
                                return [
                                    h1,
                                    e,
                                    function(u) {
                                        u = u.map(function(z, F) {
                                            return m[F](z);
                                        }).join(a);
                                        return k ? k(u) : u;
                                    }
                                ];
                            }
                            d.consumeToken = p;
                            d.consumeTrimmed = q;
                            d.consumeRepeated = function(k, c, a) {
                                k = q.bind(null, k);
                                for(var b = [];;){
                                    var n = k(a);
                                    if (!n || (b.push(n[0]), a = n[1], !(n = p(c, a)) || "" == n[1])) return [
                                        b,
                                        a
                                    ];
                                    a = n[1];
                                }
                            };
                            d.consumeParenthesised = function(k, c) {
                                for(var a = 0, b = 0; b < c.length && (!/\s|,/.test(c[b]) || 0 != a); b++)if ("(" == c[b]) a++;
                                else if (")" == c[b] && (a--, 0 == a && b++, 0 >= a)) break;
                                k = k(c.substr(0, b));
                                return void 0 == k ? void 0 : [
                                    k,
                                    c.substr(b)
                                ];
                            };
                            d.ignore = function(k) {
                                return function(c) {
                                    c = k(c);
                                    return c && (c[0] = void 0), c;
                                };
                            };
                            d.optional = function(k, c) {
                                return function(a) {
                                    return k(a) || [
                                        c,
                                        a
                                    ];
                                };
                            };
                            d.consumeList = function(k, c) {
                                for(var a = [], b = 0; b < k.length; b++){
                                    c = d.consumeTrimmed(k[b], c);
                                    if (!c || "" == c[0]) return;
                                    void 0 !== c[0] && a.push(c[0]);
                                    c = c[1];
                                }
                                if ("" == c) return a;
                            };
                            d.mergeNestedRepeated = g.bind(null, null);
                            d.mergeWrappedNestedRepeated = g;
                            d.mergeList = function(k, c, a) {
                                for(var b = [], n = [], h1 = [], e = 0, m = 0; m < a.length; m++)if ("function" == typeof a[m]) {
                                    var t = a[m](k[e], c[e++]);
                                    b.push(t[0]);
                                    n.push(t[1]);
                                    h1.push(t[2]);
                                } else !function(v) {
                                    b.push(!1);
                                    n.push(!1);
                                    h1.push(function() {
                                        return a[v];
                                    });
                                }(m);
                                return [
                                    b,
                                    n,
                                    function(v) {
                                        for(var l = "", u = 0; u < v.length; u++)l += h1[u](v[u]);
                                        return l;
                                    }
                                ];
                            };
                        })(B);
                        (function(d) {
                            function p(f1) {
                                var g = {
                                    inset: !1,
                                    lengths: [],
                                    color: null
                                };
                                if ((f1 = d.consumeRepeated(function(k) {
                                    var c = d.consumeToken(/^inset/i, k);
                                    return c ? (g.inset = !0, c) : (c = d.consumeLengthOrPercent(k)) ? (g.lengths.push(c[0]), c) : (c = d.consumeColor(k), c ? (g.color = c[0], c) : void 0);
                                }, /^/, f1)) && f1[0].length) return [
                                    g,
                                    f1[1]
                                ];
                            }
                            var q = (function(f1, g, k, c) {
                                function a(t) {
                                    return {
                                        inset: t,
                                        color: [
                                            0,
                                            0,
                                            0,
                                            0
                                        ],
                                        lengths: [
                                            {
                                                px: 0
                                            },
                                            {
                                                px: 0
                                            },
                                            {
                                                px: 0
                                            },
                                            {
                                                px: 0
                                            }
                                        ]
                                    };
                                }
                                for(var b = [], n = [], h1 = 0; h1 < k.length || h1 < c.length; h1++){
                                    var e = k[h1] || a(c[h1].inset), m = c[h1] || a(k[h1].inset);
                                    b.push(e);
                                    n.push(m);
                                }
                                return d.mergeNestedRepeated(f1, g, b, n);
                            }).bind(null, function(f1, g) {
                                for(; f1.lengths.length < Math.max(f1.lengths.length, g.lengths.length);)f1.lengths.push({
                                    px: 0
                                });
                                for(; g.lengths.length < Math.max(f1.lengths.length, g.lengths.length);)g.lengths.push({
                                    px: 0
                                });
                                if (f1.inset == g.inset && !!f1.color == !!g.color) {
                                    for(var k, c = [], a = [
                                        [],
                                        0
                                    ], b = [
                                        [],
                                        0
                                    ], n = 0; n < f1.lengths.length; n++){
                                        var h1 = d.mergeDimensions(f1.lengths[n], g.lengths[n], 2 == n);
                                        a[0].push(h1[0]);
                                        b[0].push(h1[1]);
                                        c.push(h1[2]);
                                    }
                                    f1.color && g.color && (g = d.mergeColors(f1.color, g.color), a[1] = g[0], b[1] = g[1], k = g[2]);
                                    return [
                                        a,
                                        b,
                                        function(e) {
                                            for(var m = f1.inset ? "inset " : " ", t = 0; t < c.length; t++)m += c[t](e[0][t]) + " ";
                                            return k && (m += k(e[1])), m;
                                        }
                                    ];
                                }
                            }, ", ");
                            d.addPropertiesHandler(function(f1) {
                                if ((f1 = d.consumeRepeated(p, /^,/, f1)) && "" == f1[1]) return f1[0];
                            }, q, [
                                "box-shadow",
                                "text-shadow"
                            ]);
                        })(B);
                        (function(d) {
                            function p(c) {
                                return c.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
                            }
                            function q(c, a, b) {
                                return Math.min(a, Math.max(c, b));
                            }
                            function f1(c) {
                                if (/^\s*[-+]?(\d*\.)?\d+\s*$/.test(c)) return Number(c);
                            }
                            function g(c, a) {
                                return function(b, n) {
                                    return [
                                        b,
                                        n,
                                        function(h1) {
                                            return p(q(c, a, h1));
                                        }
                                    ];
                                };
                            }
                            function k(c) {
                                c = c.trim().split(/\s*[\s,]\s*/);
                                if (0 !== c.length) {
                                    for(var a = [], b = 0; b < c.length; b++){
                                        var n = f1(c[b]);
                                        if (void 0 === n) return;
                                        a.push(n);
                                    }
                                    return a;
                                }
                            }
                            d.clamp = q;
                            d.addPropertiesHandler(k, function(c, a) {
                                if (c.length == a.length) return [
                                    c,
                                    a,
                                    function(b) {
                                        return b.map(p).join(" ");
                                    }
                                ];
                            }, [
                                "stroke-dasharray"
                            ]);
                            d.addPropertiesHandler(f1, g(0, 1 / 0), [
                                "border-image-width",
                                "line-height"
                            ]);
                            d.addPropertiesHandler(f1, g(0, 1), [
                                "opacity",
                                "shape-image-threshold"
                            ]);
                            d.addPropertiesHandler(f1, function(c, a) {
                                if (0 != c) return g(0, 1 / 0)(c, a);
                            }, [
                                "flex-grow",
                                "flex-shrink"
                            ]);
                            d.addPropertiesHandler(f1, function(c, a) {
                                return [
                                    c,
                                    a,
                                    function(b) {
                                        return Math.round(q(1, 1 / 0, b));
                                    }
                                ];
                            }, [
                                "orphans",
                                "widows"
                            ]);
                            d.addPropertiesHandler(f1, function(c, a) {
                                return [
                                    c,
                                    a,
                                    Math.round
                                ];
                            }, [
                                "z-index"
                            ]);
                            d.parseNumber = f1;
                            d.parseNumberList = k;
                            d.mergeNumbers = function(c, a) {
                                return [
                                    c,
                                    a,
                                    p
                                ];
                            };
                            d.numberToString = p;
                        })(B);
                        (function(d) {
                            d.addPropertiesHandler(String, function(p, q) {
                                if ("visible" == p || "visible" == q) return [
                                    0,
                                    1,
                                    function(f1) {
                                        return 0 >= f1 ? p : 1 <= f1 ? q : "visible";
                                    }
                                ];
                            }, [
                                "visibility"
                            ]);
                        })(B);
                        (function(d) {
                            function p(k) {
                                k = k.trim();
                                g.fillStyle = "#000";
                                g.fillStyle = k;
                                var c = g.fillStyle;
                                if (g.fillStyle = "#fff", g.fillStyle = k, c == g.fillStyle) return g.fillRect(0, 0, 1, 1), k = g.getImageData(0, 0, 1, 1).data, g.clearRect(0, 0, 1, 1), c = k[3] / 255, [
                                    k[0] * c,
                                    k[1] * c,
                                    k[2] * c,
                                    c
                                ];
                            }
                            function q(k, c) {
                                return [
                                    k,
                                    c,
                                    function(a) {
                                        if (a[3]) for(var b = 0; 3 > b; b++)a[b] = Math.round(Math.max(0, Math.min(255, a[b] / a[3])));
                                        return a[3] = d.numberToString(d.clamp(0, 1, a[3])), "rgba(" + a.join(",") + ")";
                                    }
                                ];
                            }
                            var f1 = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
                            f1.width = f1.height = 1;
                            var g = f1.getContext("2d");
                            d.addPropertiesHandler(p, q, "background-color border-bottom-color border-left-color border-right-color border-top-color color fill flood-color lighting-color outline-color stop-color stroke text-decoration-color".split(" "));
                            d.consumeColor = d.consumeParenthesised.bind(null, p);
                            d.mergeColors = q;
                        })(B);
                        (function(d) {
                            function p(n) {
                                function h1() {
                                    var u = l.exec(n);
                                    v = u ? u[0] : void 0;
                                }
                                function e() {
                                    if ("(" !== v) {
                                        var u = Number(v);
                                        return h1(), u;
                                    }
                                    h1();
                                    u = t();
                                    return ")" !== v ? NaN : (h1(), u);
                                }
                                function m() {
                                    for(var u = e(); "*" === v || "/" === v;){
                                        var z = v;
                                        h1();
                                        var F = e();
                                        "*" === z ? u *= F : u /= F;
                                    }
                                    return u;
                                }
                                function t() {
                                    for(var u = m(); "+" === v || "-" === v;){
                                        var z = v;
                                        h1();
                                        var F = m();
                                        "+" === z ? u += F : u -= F;
                                    }
                                    return u;
                                }
                                var v, l = /([\+\-\w\.]+|[\(\)\*\/])/g;
                                return h1(), t();
                            }
                            function q(n, h1) {
                                if ("0" == (h1 = h1.trim().toLowerCase()) && 0 <= "px".search(n)) return {
                                    px: 0
                                };
                                if (/^[^(]*$|^calc/.test(h1)) {
                                    h1 = h1.replace(/calc\(/g, "(");
                                    var e = {};
                                    h1 = h1.replace(n, function(u) {
                                        return e[u] = null, "U" + u;
                                    });
                                    n = "U(" + n.source + ")";
                                    for(var m = h1.replace(/[-+]?(\d*\.)?\d+([Ee][-+]?\d+)?/g, "N").replace(new RegExp("N" + n, "g"), "D").replace(/\s[+-]\s/g, "O").replace(/\s/g, ""), t = [
                                        /N\*(D)/g,
                                        /(N|D)[*\/]N/g,
                                        /(N|D)O\1/g,
                                        /\((N|D)\)/g
                                    ], v = 0; v < t.length;)t[v].test(m) ? (m = m.replace(t[v], "$1"), v = 0) : v++;
                                    if ("D" == m) {
                                        for(var l in e){
                                            m = p(h1.replace(new RegExp("U" + l, "g"), "").replace(new RegExp(n, "g"), "*0"));
                                            if (!isFinite(m)) return;
                                            e[l] = m;
                                        }
                                        return e;
                                    }
                                }
                            }
                            function f1(n, h1) {
                                return g(n, h1, !0);
                            }
                            function g(n, h1, e) {
                                var m, t = [];
                                for(m in n)t.push(m);
                                for(m in h1)0 > t.indexOf(m) && t.push(m);
                                return n = t.map(function(v) {
                                    return n[v] || 0;
                                }), h1 = t.map(function(v) {
                                    return h1[v] || 0;
                                }), [
                                    n,
                                    h1,
                                    function(v) {
                                        var l = v.map(function(u, z) {
                                            return 1 == v.length && e && (u = Math.max(u, 0)), d.numberToString(u) + t[z];
                                        }).join(" + ");
                                        return 1 < v.length ? "calc(" + l + ")" : l;
                                    }
                                ];
                            }
                            var k = q.bind(null, RegExp("px|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc", "g")), c = q.bind(null, RegExp("px|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|%", "g")), a = q.bind(null, /deg|rad|grad|turn/g);
                            d.parseLength = k;
                            d.parseLengthOrPercent = c;
                            d.consumeLengthOrPercent = d.consumeParenthesised.bind(null, c);
                            d.parseAngle = a;
                            d.mergeDimensions = g;
                            k = d.consumeParenthesised.bind(null, k);
                            k = d.consumeRepeated.bind(void 0, k, /^/);
                            var b = d.consumeRepeated.bind(void 0, k, /^,/);
                            d.consumeSizePairList = b;
                            k = d.mergeNestedRepeated.bind(void 0, f1, " ");
                            a = d.mergeNestedRepeated.bind(void 0, k, ",");
                            d.mergeNonNegativeSizePair = k;
                            d.addPropertiesHandler(function(n) {
                                if ((n = b(n)) && "" == n[1]) return n[0];
                            }, a, [
                                "background-size"
                            ]);
                            d.addPropertiesHandler(c, f1, "border-bottom-width border-image-width border-left-width border-right-width border-top-width flex-basis font-size height line-height max-height max-width outline-width width".split(" "));
                            d.addPropertiesHandler(c, g, "border-bottom-left-radius border-bottom-right-radius border-top-left-radius border-top-right-radius bottom left letter-spacing margin-bottom margin-left margin-right margin-top min-height min-width outline-offset padding-bottom padding-left padding-right padding-top perspective right shape-margin stroke-dashoffset text-indent top vertical-align word-spacing".split(" "));
                        })(B);
                        (function(d) {
                            function p(g) {
                                return d.consumeLengthOrPercent(g) || d.consumeToken(/^auto/, g);
                            }
                            function q(g) {
                                if ((g = d.consumeList([
                                    d.ignore(d.consumeToken.bind(null, /^rect/)),
                                    d.ignore(d.consumeToken.bind(null, /^\(/)),
                                    d.consumeRepeated.bind(null, p, /^,/),
                                    d.ignore(d.consumeToken.bind(null, /^\)/))
                                ], g)) && 4 == g[0].length) return g[0];
                            }
                            var f1 = d.mergeWrappedNestedRepeated.bind(null, function(g) {
                                return "rect(" + g + ")";
                            }, function(g, k) {
                                return "auto" == g || "auto" == k ? [
                                    !0,
                                    !1,
                                    function(c) {
                                        c = c ? g : k;
                                        if ("auto" == c) return "auto";
                                        c = d.mergeDimensions(c, c);
                                        return c[2](c[0]);
                                    }
                                ] : d.mergeDimensions(g, k);
                            }, ", ");
                            d.parseBox = q;
                            d.mergeBoxes = f1;
                            d.addPropertiesHandler(q, f1, [
                                "clip"
                            ]);
                        })(B);
                        (function(d) {
                            function p(e) {
                                return function(m) {
                                    var t = 0;
                                    return e.map(function(v) {
                                        return v === a ? m[t++] : v;
                                    });
                                };
                            }
                            function q(e) {
                                return e;
                            }
                            function f1(e) {
                                if ("none" == (e = e.toLowerCase().trim())) return [];
                                for(var m, t = /\s*(\w+)\(([^)]*)\)/g, v = [], l = 0; (m = t.exec(e)) && m.index == l;){
                                    l = m.index + m[0].length;
                                    var u = m[1], z = h1[u];
                                    if (!z) break;
                                    m = m[2].split(",");
                                    z = z[0];
                                    if (z.length < m.length) break;
                                    for(var F = [], K = 0; K < z.length; K++){
                                        var I = m[K];
                                        var G = z[K];
                                        if (void 0 === (I = I ? ({
                                            A: function(r1) {
                                                return "0" == r1.trim() ? n : d.parseAngle(r1);
                                            },
                                            N: d.parseNumber,
                                            T: d.parseLengthOrPercent,
                                            L: d.parseLength
                                        })[G.toUpperCase()](I) : ({
                                            a: n,
                                            n: F[0],
                                            t: b
                                        })[G])) return;
                                        F.push(I);
                                    }
                                    if (v.push({
                                        t: u,
                                        d: F
                                    }), t.lastIndex == e.length) return v;
                                }
                            }
                            function g(e) {
                                return e.toFixed(6).replace(".000000", "");
                            }
                            function k(e, m) {
                                if (e.decompositionPair !== m) {
                                    e.decompositionPair = m;
                                    var t = d.makeMatrixDecomposition(e);
                                }
                                if (m.decompositionPair !== e) {
                                    m.decompositionPair = e;
                                    var v = d.makeMatrixDecomposition(m);
                                }
                                return null == t[0] || null == v[0] ? [
                                    [
                                        !1
                                    ],
                                    [
                                        !0
                                    ],
                                    function(l) {
                                        return l ? m[0].d : e[0].d;
                                    }
                                ] : (t[0].push(0), v[0].push(1), [
                                    t,
                                    v,
                                    function(l) {
                                        var u = d.quat(t[0][3], v[0][3], l[5]);
                                        return d.composeMatrix(l[0], l[1], l[2], u, l[4]).map(g).join(",");
                                    }
                                ]);
                            }
                            function c(e) {
                                return e.replace(/(x|y|z|3d)?$/, "3d");
                            }
                            var a = null, b = {
                                px: 0
                            }, n = {
                                deg: 0
                            }, h1 = {
                                matrix: [
                                    "NNNNNN",
                                    [
                                        a,
                                        a,
                                        0,
                                        0,
                                        a,
                                        a,
                                        0,
                                        0,
                                        0,
                                        0,
                                        1,
                                        0,
                                        a,
                                        a,
                                        0,
                                        1
                                    ],
                                    q
                                ],
                                matrix3d: [
                                    "NNNNNNNNNNNNNNNN",
                                    q
                                ],
                                rotate: [
                                    "A"
                                ],
                                rotatex: [
                                    "A"
                                ],
                                rotatey: [
                                    "A"
                                ],
                                rotatez: [
                                    "A"
                                ],
                                rotate3d: [
                                    "NNNA"
                                ],
                                perspective: [
                                    "L"
                                ],
                                scale: [
                                    "Nn",
                                    p([
                                        a,
                                        a,
                                        1
                                    ]),
                                    q
                                ],
                                scalex: [
                                    "N",
                                    p([
                                        a,
                                        1,
                                        1
                                    ]),
                                    p([
                                        a,
                                        1
                                    ])
                                ],
                                scaley: [
                                    "N",
                                    p([
                                        1,
                                        a,
                                        1
                                    ]),
                                    p([
                                        1,
                                        a
                                    ])
                                ],
                                scalez: [
                                    "N",
                                    p([
                                        1,
                                        1,
                                        a
                                    ])
                                ],
                                scale3d: [
                                    "NNN",
                                    q
                                ],
                                skew: [
                                    "Aa",
                                    null,
                                    q
                                ],
                                skewx: [
                                    "A",
                                    null,
                                    p([
                                        a,
                                        n
                                    ])
                                ],
                                skewy: [
                                    "A",
                                    null,
                                    p([
                                        n,
                                        a
                                    ])
                                ],
                                translate: [
                                    "Tt",
                                    p([
                                        a,
                                        a,
                                        b
                                    ]),
                                    q
                                ],
                                translatex: [
                                    "T",
                                    p([
                                        a,
                                        b,
                                        b
                                    ]),
                                    p([
                                        a,
                                        b
                                    ])
                                ],
                                translatey: [
                                    "T",
                                    p([
                                        b,
                                        a,
                                        b
                                    ]),
                                    p([
                                        b,
                                        a
                                    ])
                                ],
                                translatez: [
                                    "L",
                                    p([
                                        b,
                                        b,
                                        a
                                    ])
                                ],
                                translate3d: [
                                    "TTL",
                                    q
                                ]
                            };
                            d.addPropertiesHandler(f1, function(e, m) {
                                var t = d.makeMatrixDecomposition && !0, v = !1;
                                if (!e.length || !m.length) {
                                    e.length || (v = !0, e = m, m = []);
                                    for(var l = 0; l < e.length; l++){
                                        var u = e[l].t, z = e[l].d, F = "scale" == u.substr(0, 5) ? 1 : 0;
                                        m.push({
                                            t: u,
                                            d: z.map(function(N) {
                                                if ("number" == typeof N) return F;
                                                var H = {}, M;
                                                for(M in N)H[M] = F;
                                                return H;
                                            })
                                        });
                                    }
                                }
                                z = [];
                                var K = [], I = [];
                                if (e.length != m.length) {
                                    if (!t) return;
                                    var G = k(e, m);
                                    z = [
                                        G[0]
                                    ];
                                    K = [
                                        G[1]
                                    ];
                                    I = [
                                        [
                                            "matrix",
                                            [
                                                G[2]
                                            ]
                                        ]
                                    ];
                                } else for(l = 0; l < e.length; l++){
                                    u = e[l].t;
                                    var r1 = m[l].t, C = e[l].d, x = m[l].d;
                                    G = h1[u];
                                    var E = h1[r1];
                                    if ("perspective" == u && "perspective" == r1 || !("matrix" != u && "matrix3d" != u || "matrix" != r1 && "matrix3d" != r1)) {
                                        if (!t) return;
                                        G = k([
                                            e[l]
                                        ], [
                                            m[l]
                                        ]);
                                        z.push(G[0]);
                                        K.push(G[1]);
                                        I.push([
                                            "matrix",
                                            [
                                                G[2]
                                            ]
                                        ]);
                                    } else {
                                        if (u != r1) {
                                            if (G[2] && E[2] && u.replace(/[xy]/, "") == r1.replace(/[xy]/, "")) u = u.replace(/[xy]/, ""), C = G[2](C), x = E[2](x);
                                            else {
                                                if (!G[1] || !E[1] || c(u) != c(r1)) {
                                                    if (!t) return;
                                                    G = k(e, m);
                                                    z = [
                                                        G[0]
                                                    ];
                                                    K = [
                                                        G[1]
                                                    ];
                                                    I = [
                                                        [
                                                            "matrix",
                                                            [
                                                                G[2]
                                                            ]
                                                        ]
                                                    ];
                                                    break;
                                                }
                                                u = c(u);
                                                C = G[1](C);
                                                x = E[1](x);
                                            }
                                        }
                                        E = [];
                                        r1 = [];
                                        for(var J = [], L = 0; L < C.length; L++)G = ("number" == typeof C[L] ? d.mergeNumbers : d.mergeDimensions)(C[L], x[L]), E[L] = G[0], r1[L] = G[1], J.push(G[2]);
                                        z.push(E);
                                        K.push(r1);
                                        I.push([
                                            u,
                                            J
                                        ]);
                                    }
                                }
                                v && (e = z, z = K, K = e);
                                return [
                                    z,
                                    K,
                                    function(N) {
                                        return N.map(function(H, M) {
                                            H = H.map(function(O, P) {
                                                return I[M][1][P](O);
                                            }).join(",");
                                            return "matrix" == I[M][0] && 16 == H.split(",").length && (I[M][0] = "matrix3d"), I[M][0] + "(" + H + ")";
                                        }).join(" ");
                                    }
                                ];
                            }, [
                                "transform"
                            ]);
                            d.transformToSvgMatrix = function(e) {
                                e = d.transformListToMatrix(f1(e));
                                return "matrix(" + g(e[0]) + " " + g(e[1]) + " " + g(e[4]) + " " + g(e[5]) + " " + g(e[12]) + " " + g(e[13]) + ")";
                            };
                        })(B);
                        (function(d) {
                            function p(q) {
                                return q = 100 * Math.round(q / 100), q = d.clamp(100, 900, q), 400 === q ? "normal" : 700 === q ? "bold" : String(q);
                            }
                            d.addPropertiesHandler(function(q) {
                                q = Number(q);
                                if (!(isNaN(q) || 100 > q || 900 < q || 0 != q % 100)) return q;
                            }, function(q, f1) {
                                return [
                                    q,
                                    f1,
                                    p
                                ];
                            }, [
                                "font-weight"
                            ]);
                        })(B);
                        (function(d) {
                            function p(c) {
                                return d.consumeToken(/^(left|center|right|top|bottom)\b/i, c) || d.consumeLengthOrPercent(c);
                            }
                            function q(c, a) {
                                if ((a = d.consumeRepeated(p, /^/, a)) && "" == a[1] && (a = a[0], a[0] = a[0] || "center", a[1] = a[1] || "center", 3 == c && (a[2] = a[2] || {
                                    px: 0
                                }), a.length == c)) {
                                    if (/top|bottom/.test(a[0]) || /left|right/.test(a[1])) c = a[0], a[0] = a[1], a[1] = c;
                                    if (/left|right|center|Object/.test(a[0]) && /top|bottom|center|Object/.test(a[1])) return a.map(function(b) {
                                        return "object" == typeof b ? b : g[b];
                                    });
                                }
                            }
                            function f1(c) {
                                if (c = d.consumeRepeated(p, /^/, c)) {
                                    for(var a = c[0], b = [
                                        {
                                            "%": 50
                                        },
                                        {
                                            "%": 50
                                        }
                                    ], n = 0, h1 = !1, e = 0; e < a.length; e++){
                                        var m = a[e];
                                        if ("string" == typeof m) h1 = /bottom|right/.test(m), n = ({
                                            left: 0,
                                            right: 0,
                                            center: n,
                                            top: 1,
                                            bottom: 1
                                        })[m], b[n] = g[m], "center" == m && n++;
                                        else {
                                            if (h1) {
                                                h1 = void 0;
                                                var t = {};
                                                for(h1 in m)t[h1] = -m[h1];
                                                m = t;
                                                m["%"] = (m["%"] || 0) + 100;
                                            }
                                            b[n] = m;
                                            n++;
                                            h1 = !1;
                                        }
                                    }
                                    return [
                                        b,
                                        c[1]
                                    ];
                                }
                            }
                            var g = {
                                left: {
                                    "%": 0
                                },
                                center: {
                                    "%": 50
                                },
                                right: {
                                    "%": 100
                                },
                                top: {
                                    "%": 0
                                },
                                bottom: {
                                    "%": 100
                                }
                            }, k = d.mergeNestedRepeated.bind(null, d.mergeDimensions, " ");
                            d.addPropertiesHandler(q.bind(null, 3), k, [
                                "transform-origin"
                            ]);
                            d.addPropertiesHandler(q.bind(null, 2), k, [
                                "perspective-origin"
                            ]);
                            d.consumePosition = f1;
                            d.mergeOffsetList = k;
                            k = d.mergeNestedRepeated.bind(null, k, ", ");
                            d.addPropertiesHandler(function(c) {
                                if ((c = d.consumeRepeated(f1, /^,/, c)) && "" == c[1]) return c[0];
                            }, k, [
                                "background-position",
                                "object-position"
                            ]);
                        })(B);
                        (function(d) {
                            var p = d.consumeParenthesised.bind(null, d.parseLengthOrPercent), q = d.consumeRepeated.bind(void 0, p, /^/), f1 = d.mergeNestedRepeated.bind(void 0, d.mergeDimensions, " "), g = d.mergeNestedRepeated.bind(void 0, f1, ",");
                            d.addPropertiesHandler(function(k) {
                                var c = d.consumeToken(/^circle/, k);
                                return c && c[0] ? [
                                    "circle"
                                ].concat(d.consumeList([
                                    d.ignore(d.consumeToken.bind(void 0, /^\(/)),
                                    p,
                                    d.ignore(d.consumeToken.bind(void 0, /^at/)),
                                    d.consumePosition,
                                    d.ignore(d.consumeToken.bind(void 0, /^\)/))
                                ], c[1])) : (c = d.consumeToken(/^ellipse/, k)) && c[0] ? [
                                    "ellipse"
                                ].concat(d.consumeList([
                                    d.ignore(d.consumeToken.bind(void 0, /^\(/)),
                                    q,
                                    d.ignore(d.consumeToken.bind(void 0, /^at/)),
                                    d.consumePosition,
                                    d.ignore(d.consumeToken.bind(void 0, /^\)/))
                                ], c[1])) : (k = d.consumeToken(/^polygon/, k)) && k[0] ? [
                                    "polygon"
                                ].concat(d.consumeList([
                                    d.ignore(d.consumeToken.bind(void 0, /^\(/)),
                                    d.optional(d.consumeToken.bind(void 0, /^nonzero\s*,|^evenodd\s*,/), "nonzero,"),
                                    d.consumeSizePairList,
                                    d.ignore(d.consumeToken.bind(void 0, /^\)/))
                                ], k[1])) : void 0;
                            }, function(k, c) {
                                if (k[0] === c[0]) return "circle" == k[0] ? d.mergeList(k.slice(1), c.slice(1), [
                                    "circle(",
                                    d.mergeDimensions,
                                    " at ",
                                    d.mergeOffsetList,
                                    ")"
                                ]) : "ellipse" == k[0] ? d.mergeList(k.slice(1), c.slice(1), [
                                    "ellipse(",
                                    d.mergeNonNegativeSizePair,
                                    " at ",
                                    d.mergeOffsetList,
                                    ")"
                                ]) : "polygon" == k[0] && k[1] == c[1] ? d.mergeList(k.slice(2), c.slice(2), [
                                    "polygon(",
                                    k[1],
                                    g,
                                    ")"
                                ]) : void 0;
                            }, [
                                "shape-outside"
                            ]);
                        })(B);
                        (function(d) {
                            function p(g, k) {
                                k.concat([
                                    g
                                ]).forEach(function(c) {
                                    c in document.documentElement.style && (q[g] = c);
                                    f1[c] = g;
                                });
                            }
                            var q = {}, f1 = {};
                            p("transform", [
                                "webkitTransform",
                                "msTransform"
                            ]);
                            p("transformOrigin", [
                                "webkitTransformOrigin"
                            ]);
                            p("perspective", [
                                "webkitPerspective"
                            ]);
                            p("perspectiveOrigin", [
                                "webkitPerspectiveOrigin"
                            ]);
                            d.propertyName = function(g) {
                                return q[g] || g;
                            };
                            d.unprefixedPropertyName = function(g) {
                                return f1[g] || g;
                            };
                        })(B);
                    })();
                    (function() {
                        if (void 0 === document.createElement("div").animate([]).oncancel) {
                            var w = window.performance && performance.now ? function() {
                                return performance.now();
                            } : function() {
                                return Date.now();
                            };
                            var A = function(p, q, f1) {
                                this.target = p;
                                this.currentTime = q;
                                this.timelineTime = f1;
                                this.type = "cancel";
                                this.cancelable = this.bubbles = !1;
                                this.currentTarget = p;
                                this.defaultPrevented = !1;
                                this.eventPhase = Event.AT_TARGET;
                                this.timeStamp = Date.now();
                            }, d = window.Element.prototype.animate;
                            window.Element.prototype.animate = function(p, q) {
                                p = d.call(this, p, q);
                                p._cancelHandlers = [];
                                p.oncancel = null;
                                var f1 = p.cancel;
                                p.cancel = function() {
                                    f1.call(this);
                                    var c = new A(this, null, w()), a = this._cancelHandlers.concat(this.oncancel ? [
                                        this.oncancel
                                    ] : []);
                                    setTimeout(function() {
                                        a.forEach(function(b) {
                                            b.call(c.target, c);
                                        });
                                    }, 0);
                                };
                                var g = p.addEventListener;
                                p.addEventListener = function(c, a) {
                                    "function" == typeof a && "cancel" == c ? this._cancelHandlers.push(a) : g.call(this, c, a);
                                };
                                var k = p.removeEventListener;
                                return p.removeEventListener = function(c, a) {
                                    "cancel" == c ? (c = this._cancelHandlers.indexOf(a), 0 <= c && this._cancelHandlers.splice(c, 1)) : k.call(this, c, a);
                                }, p;
                            };
                        }
                    })();
                    (function(w) {
                        var A = document.documentElement, d = null, p = !1;
                        try {
                            var q = "0" == getComputedStyle(A).getPropertyValue("opacity") ? "1" : "0";
                            d = A.animate({
                                opacity: [
                                    q,
                                    q
                                ]
                            }, {
                                duration: 1
                            });
                            d.currentTime = 0;
                            p = getComputedStyle(A).getPropertyValue("opacity") == q;
                        } catch (g) {} finally{
                            d && d.cancel();
                        }
                        if (!p) {
                            var f1 = window.Element.prototype.animate;
                            window.Element.prototype.animate = function(g, k) {
                                return window.Symbol && Symbol.iterator && Array.prototype.from && g[Symbol.iterator] && (g = Array.from(g)), Array.isArray(g) || null === g || (g = w.convertToArrayForm(g)), f1.call(this, g, k);
                            };
                        }
                    })(D);
                }();
            },
            {}
        ],
        2: [
            function(D) {
                if (Element.prototype.animate && (/iphone|ipad|ipod/i.test(navigator.userAgent) || "MacIntel" === navigator.platform && 1 < navigator.maxTouchPoints || "undefined" !== typeof window.safari)) try {
                    Element.prototype.animate = void 0;
                } catch (B) {}
                D("web-animations-js");
            },
            {
                "web-animations-js": 1
            }
        ]
    }, {}, [
        2
    ]);
    var api = {};
    (function() {}).call(__self);
    return api;
});




/**
 * # VanillaReaderEventBus
 *
 *  ## RESPONSIBILITIES
 *
 * The VanillaReaderEventBus is the application's communication channel. It lets any of our components
 * dispatch and add listeners for CustomEvents (https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events).
 *
 * The actual element that acts as the "dispatch central" for the event bus is by default the "<body>" element in index.html.
 *
 * Any component that you write "on top" of the VanillaReader will need to include this file as it is the common "protocol"
 * and channel for communicating between the components.
 *
 * ## EVENT TYPES
 *
 * This file contains `VanillaReaderAppEvents` which holds all the event names used by the VanillaReader. It also
 * contains all the various `IVanillaReaderAppEvent` types that specify what data is sent along with each event.
 *
 * ## NOTES:
 *
 * The naming convention for events are as follows:
 *
 * - An "INTENT" is dispatched to trigger an action (typically sent from the UI)
 * - Any other event is sent **after** an action has completed and reflects the changed state.
 *
 * The exception to this convention is the "APP_UNLOADING" event which fires as part of the browser `window`'s unload process.
 *
 */ class $84c7b345e247d474$export$51b4df07290407 {
    static{
        this._listeners = new Map();
    }
    constructor(){}
    static addEventListener(event, listener, once = false) {
        $84c7b345e247d474$export$51b4df07290407._getBus().addEventListener(event, listener, {
            once: once
        });
        /* If the `once` parameter is set to true, the DOM API will take care of the event listener life cycle
        *  so we should not save it to our own `listeners` set.
        */ if (!once) {
            let listeners = $84c7b345e247d474$export$51b4df07290407._listeners.get(event);
            if (!listeners) {
                listeners = new Set();
                $84c7b345e247d474$export$51b4df07290407._listeners.set(event, listeners);
            }
            listeners.add(listener);
        }
    }
    static destroy() {
        $84c7b345e247d474$export$51b4df07290407._listeners.forEach((listeners, eventType)=>{
            listeners.forEach((listener)=>{
                $84c7b345e247d474$export$51b4df07290407._getBus().removeEventListener(eventType, listener);
            });
        });
        $84c7b345e247d474$export$51b4df07290407._listeners.clear();
    }
    static dispatchEvent(event) {
        console.log(`<<< Colibrio (${event.type})`, event.detail);
        try {
            window.parent.postMessage({
                type: event.type,
                value: event.detail
            }, "*");
        } catch (e) {
            console.warn(e);
        }
        $84c7b345e247d474$export$51b4df07290407._getBus().dispatchEvent(event);
    }
    static removeEventListener(eventType, listener) {
        $84c7b345e247d474$export$51b4df07290407._getBus().removeEventListener(eventType, listener);
        let listeners = $84c7b345e247d474$export$51b4df07290407._listeners.get(eventType);
        if (listeners) listeners.delete(listener);
    }
    static _getBus() {
        if (!$84c7b345e247d474$export$51b4df07290407.eventBusElement) $84c7b345e247d474$export$51b4df07290407.eventBusElement = document.documentElement;
        return $84c7b345e247d474$export$51b4df07290407.eventBusElement;
    }
    static createEvent(type, detail) {
        return new CustomEvent(type, {
            detail: detail
        });
    }
}


class $da1a1533b140aa86$export$495676b7a762bc7f {
    constructor(start, end){
        this.start = start;
        this.end = end;
        this.start = Math.round(start);
        this.end = Math.round(end);
        if (end < start) throw new Error("Invalid range. End offset must be greater than start offset");
    }
    get length() {
        return this.end - this.start;
    }
    contains(range) {
        /**
         * |--------------------|
         *     |----------|
         * */ return this.start <= range.start && this.end >= range.end;
    }
    intersects(range) {
        /**
         * |-------|
         *     |----------|
         * */ const isOutside = this.isBefore(range) || this.isAfter(range);
        return !isOutside;
    }
    isAdjacent(range) {
        return this.end === range.start || this.start === range.end;
    }
    isBefore(range) {
        /**
         * |-------|
         *          |-----|
         * */ return this.end <= range.start;
    }
    isAfter(range) {
        /**
         *          |-------|
         *  |-----|
         * */ return this.start >= range.end;
    }
    intersection(range) {
        /**
         *  |--------------|
         *         |=======|-----|
         * */ if (!this.intersects(range)) return null;
        return new $da1a1533b140aa86$export$495676b7a762bc7f(Math.max(this.start, range.start), Math.min(this.end, range.end));
    }
    // difference(range: IntRange): IntRange[] {
    //
    //     /**
    //      * |===|---------|===|
    //      *     |---------|
    //      *
    //      *     |---------|
    //      * |===|---------|===|
    //      *
    //      *     |--------|====|
    //      * |===|--------|
    //      *
    //      * |-------------|
    //      *      |--------|===|
    //      *
    //      * */
    //
    //     if(!this.intersects(range)) {
    //         return [];
    //     }
    //
    //     if(this.contains(range)) {
    //         return [new IntRange(this.start, range.start), new IntRange(range.end, this.end)];
    //     }
    //
    //     if(range.contains(this)) {
    //         return [new IntRange(range.start, this.start), new IntRange(this.end, range.end)];
    //     }
    //
    //     if(range.start < this.start) {
    //         return [new IntRange(range.start, this.start), new IntRange(range.end, this.end)];
    //     } else{
    //         return [new IntRange(this.end, range.end)];
    //     }
    // }
    merge(range) {
        /**
         * |=======
         *     ===========|
         * */ let startIndex = Math.min(this.start, range.start);
        let endIndex = Math.max(this.end, range.end);
        return new $da1a1533b140aa86$export$495676b7a762bc7f(startIndex, endIndex);
    }
}



class $632829fca60d0ba6$export$98bf3bbab5d20daf {
    constructor(length){
        this.length = length;
        this.sequence = [];
        this.sorter = (entry, entry2)=>{
            if (entry.start < entry2.start) return -1;
            if (entry.start > entry2.start) return 1;
            return 0;
        };
        this.length = Math.round(length);
    }
    add(entry) {
        if (entry > this.length) throw new Error("Entry can not exceed IntSequence length.");
        entry = Math.round(entry);
        this.sequence.push(new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(entry, entry));
        this.sequence.sort(this.sorter);
        this.merge();
    }
    addRange(start, end) {
        if (end > this.length) throw new Error("Range end can not exceed IntSequence length.");
        start = Math.round(start);
        end = Math.round(end);
        this.sequence.push(new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(start, end));
        this.sequence.sort(this.sorter);
        this.merge();
    }
    getEmptySlots() {
        let i = 0;
        let emptySlots = [];
        let firstEntry = this.sequence[0];
        if (firstEntry.start > 0) emptySlots.push(new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(0, firstEntry.start));
        while(this.sequence.length > i + 1){
            let lowerEntry = this.sequence[i];
            let higherEntry = this.sequence[i + 1];
            if (higherEntry.start - lowerEntry.end > 1) emptySlots.push(new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(lowerEntry.end, higherEntry.start));
            i++;
        }
        let lastEntry = this.sequence[this.sequence.length - 1];
        if (lastEntry.end < this.length) emptySlots.push(new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(lastEntry.end, this.length));
        return emptySlots;
    }
    getEntries() {
        return this.sequence;
    }
    /**
     *
     * Note, array must be sorted.
     *
     * */ merge() {
        let i = 0;
        while(this.sequence.length > i + 1){
            let lowerEntry = this.sequence[i];
            let lowerIndex = i;
            let higherIndex = i + 1;
            let higherEntry = this.sequence[higherIndex];
            if (lowerEntry.intersects(higherEntry) || lowerEntry.isAdjacent(higherEntry)) {
                let mergedEntry = lowerEntry.merge(higherEntry);
                this.sequence.splice(lowerIndex, 2, mergedEntry);
            } else i++;
        }
    }
}



var $i64v9 = parcelRequire("i64v9");
const { AsyncTaskQueue: $91ca8664a4c236f4$export$baf5959a4c58e910, Axis: $91ca8664a4c236f4$export$d06866a9fb0606da, Base64: $91ca8664a4c236f4$export$f436b0c2107cbd35, BrowserDetector: $91ca8664a4c236f4$export$e8551d08bf651ea9, ColibrioError: $91ca8664a4c236f4$export$8e1be21f3d2d8c40, ColibrioErrorType: $91ca8664a4c236f4$export$5af3030eed7640f3, KeyCode: $91ca8664a4c236f4$export$e9e0d96f49f57c33, LengthUnit: $91ca8664a4c236f4$export$8cba090a009adf02, LengthUtils: $91ca8664a4c236f4$export$ca1858e8fc920618, Logger: $91ca8664a4c236f4$export$efa9a398d6368992, NodeDataUtils: $91ca8664a4c236f4$export$c4902f7c1411fd62, NodeType: $91ca8664a4c236f4$export$f06e977173f1857c, RuntimePlatform: $91ca8664a4c236f4$export$33e0f72934bdbee6, TextDirection: $91ca8664a4c236f4$export$63e1cbbb2c6e2c2, TimeIntervalUtils: $91ca8664a4c236f4$export$f4b6b065cc40e462, TreeNodeWalker: $91ca8664a4c236f4$export$1dc4171992fdbf4b, XmlNamespace: $91ca8664a4c236f4$export$f37e8e42cc01c14 } = (0, (/*@__PURE__*/$parcel$interopDefault($i64v9)));



var $loFPd = parcelRequire("loFPd");
const { BlobUrlManager: $ba5c9d217d86588f$export$f31b06a38674c8e1, Endianness: $ba5c9d217d86588f$export$c590ef2020908539, ErrorResourceResponse: $ba5c9d217d86588f$export$fc21d4e17d0dd468, IoError: $ba5c9d217d86588f$export$796567d9cc867772, IoErrorType: $ba5c9d217d86588f$export$8871bac14285a922, MediaType: $ba5c9d217d86588f$export$483c11740a902fcd, MediaTypeCategory: $ba5c9d217d86588f$export$def5bddc25089c06, ReadableStreamResourceResponse: $ba5c9d217d86588f$export$4222b93025fe382d, Uint8ArrayResourceResponse: $ba5c9d217d86588f$export$f373312231289749 } = (0, (/*@__PURE__*/$parcel$interopDefault($loFPd)));



var $csyWb = parcelRequire("csyWb");
const { Locator: $385fc9d0f36a8af6$export$a5324b29b7a0a294, LocatorError: $385fc9d0f36a8af6$export$2f008db7fef01203, LocatorErrorType: $385fc9d0f36a8af6$export$a512f2f3c156b180, LocatorFactory: $385fc9d0f36a8af6$export$7896dcffc6e8b080 } = (0, (/*@__PURE__*/$parcel$interopDefault($csyWb)));



var $7kECq = parcelRequire("7kECq");
const { ContainerContentBlockType: $f8f5cf2c043414f4$export$a9ac7502a865bef, ContentBlockClass: $f8f5cf2c043414f4$export$2ee5c33d08cc139d, ContentBlockMarkType: $f8f5cf2c043414f4$export$1e281fb1d4091501, ContentBlockMicrodataAttribute: $f8f5cf2c043414f4$export$d083aeeb3c0ed2e0, ContentBlockRdfAttribute: $f8f5cf2c043414f4$export$cb6a34877884a4e1, ContentBlockTargetAnchorPoint: $f8f5cf2c043414f4$export$22031b45aac9426d, ContentBlockTargetFetchMode: $f8f5cf2c043414f4$export$4d9b0aff04ca78b4, ContentDisplayAreaType: $f8f5cf2c043414f4$export$b7a4396de6d4d70b, ContentPositionTimelineUnit: $f8f5cf2c043414f4$export$45587b7b78af24ff, CustomReaderViewContentLayout: $f8f5cf2c043414f4$export$73f4a02232f5da7f, EngineEventDataObjectType: $f8f5cf2c043414f4$export$c979f574278326bf, EngineEventTargetFrameworkComponent: $f8f5cf2c043414f4$export$1d65de24d737ed61, EngineEventTargetNodeUtils: $f8f5cf2c043414f4$export$2e6f4d02e9d02b2e, EngineEventTargetObjectType: $f8f5cf2c043414f4$export$225346b1021e50a9, FocusOnReadingPositionTarget: $f8f5cf2c043414f4$export$9cdf30c71408d7df, MediaContentBlockType: $f8f5cf2c043414f4$export$dfc5e1a852a6126b, NavigationAction: $f8f5cf2c043414f4$export$3fe606efa32546a8, NavigationCollectionType: $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca, PageFlowDirection: $f8f5cf2c043414f4$export$567a5d6d72563ef8, PageProgressionTimelineType: $f8f5cf2c043414f4$export$6d975c70ec49941a, ReaderDocumentEventState: $f8f5cf2c043414f4$export$ce06c08e13a84fea, ReaderPublicationStorageAreaType: $f8f5cf2c043414f4$export$56e6f277b0d3e589, ReaderViewGestureType: $f8f5cf2c043414f4$export$7f084d699ccf1fe7, ReaderViewPageProgressionDirection: $f8f5cf2c043414f4$export$207e7183bf57d8cd, ReadingSystemError: $f8f5cf2c043414f4$export$64fce2efd87cc7ea, ReadingSystemErrorType: $f8f5cf2c043414f4$export$906bab8cb24c7669, RenderableState: $f8f5cf2c043414f4$export$16235d8046c742f2, RendererSpreadMode: $f8f5cf2c043414f4$export$9d12e497c395db20, SearchResultItem: $f8f5cf2c043414f4$export$56e008c8bd1ccf7c, SyncMediaFormat: $f8f5cf2c043414f4$export$7960feb13fa25a07, SyncMediaObjectRefType: $f8f5cf2c043414f4$export$a8f572f75f837490, SyncMediaPlayerErrorType: $f8f5cf2c043414f4$export$dc48a1ed60f43311, SyncMediaPositionRelativeToVisibleRange: $f8f5cf2c043414f4$export$1ea911e6802371d3, SyncMediaRangePlaybackRemoveReason: $f8f5cf2c043414f4$export$ee7152505770fb8c, SyncMediaRangeSeekBehavior: $f8f5cf2c043414f4$export$47ac58310cdfef71, SyncMediaReaderViewSynchronizationMethod: $f8f5cf2c043414f4$export$40ec828707122085, SyncMediaReaderViewSynchronizationWaitBehavior: $f8f5cf2c043414f4$export$ceb4e9a06f43b77e, SyncMediaSegmentDurationType: $f8f5cf2c043414f4$export$1021470bac105207, SyncMediaSyncEventTrigger: $f8f5cf2c043414f4$export$f402ba953d67e88, TextAlignment: $f8f5cf2c043414f4$export$84b2d1b68830363f, TextContentBlockType: $f8f5cf2c043414f4$export$5acfff906ca012a5, TextSearchQueryWhitespaceMode: $f8f5cf2c043414f4$export$721ba1b8a28abc20, TextSearchResultExpandMode: $f8f5cf2c043414f4$export$65b6ab25bb4e7d43, TransformEasing: $f8f5cf2c043414f4$export$7d260260b1058ee8, VisibleContentRectType: $f8f5cf2c043414f4$export$da36a7d6e3b6c54f } = (0, (/*@__PURE__*/$parcel$interopDefault($7kECq)));





var $9eVOO = parcelRequire("9eVOO");
const { ContentLocationUtils: $6978732dc0bb5e4e$export$7a481d2fc97f3e3f, ContentPositionTimelineUtils: $6978732dc0bb5e4e$export$b38fc424e0d547ba, EmptyContentBlockTree: $6978732dc0bb5e4e$export$c87afb1064fc04fd, EmptyPublicationStorage: $6978732dc0bb5e4e$export$b7c519b0d66423, EngineError: $6978732dc0bb5e4e$export$b8fa7a3f4682b096, EngineErrorType: $6978732dc0bb5e4e$export$b460989ad9091b3b, LocatorUtils: $6978732dc0bb5e4e$export$ca3ae94d1a663b78, MediaSourceFactory: $6978732dc0bb5e4e$export$95ac79d897b6597b, ReaderDocumentContentPositionTimelineBuilder: $6978732dc0bb5e4e$export$a39085b39e3a0b74, ReadingSystemAsyncTaskScheduler: $6978732dc0bb5e4e$export$9904e937bc216771, ReadingSystemEngine: $6978732dc0bb5e4e$export$f9f0294ddb2c14dc, ReadingSystemUtils: $6978732dc0bb5e4e$export$d5e6355eb4ce17a4, ResponsiveViewRule: $6978732dc0bb5e4e$export$579d6fbe4efb400e, SyncMediaAudioRenderer: $6978732dc0bb5e4e$export$d3d22b23ab039045, SyncMediaObjectRendererRuntimeHelper: $6978732dc0bb5e4e$export$b81e4ae6a0027bb2, SyncMediaTimelinePosition: $6978732dc0bb5e4e$export$4cbca0b50906dc0e, SyncMediaTimelineTimeMapper: $6978732dc0bb5e4e$export$43f021a71eff1c44, SyncMediaTimelineUtils: $6978732dc0bb5e4e$export$c6e3374785dcb500, SyncMediaTtsContentBlockRenderer: $6978732dc0bb5e4e$export$8ac38e6ab98cfa5a, TtsSyncMediaTimelineBuilder: $6978732dc0bb5e4e$export$67e4a2c224942fe, WebSpeechTtsSynthesizer: $6978732dc0bb5e4e$export$fc39a7efb817638a, event: $6978732dc0bb5e4e$export$6cd530ed55e06764 } = (0, (/*@__PURE__*/$parcel$interopDefault($9eVOO)));




var $fQRpb = parcelRequire("fQRpb");
const { MediaFragmentSelector: $bf500a63b220407b$export$adb0a6894b75cdde, MediaFragmentSelectorParser: $bf500a63b220407b$export$74fd29a408e7e44a } = (0, (/*@__PURE__*/$parcel$interopDefault($fQRpb)));



class $de4a35bce141ce77$export$f1ea124360fd869c {
    constructor(_colibrioSyncMediaPlayer){
        this._colibrioSyncMediaPlayer = _colibrioSyncMediaPlayer;
        this._timelineUpdateIntentCallback = undefined;
        this._colibrioTimelineInstance = this._colibrioSyncMediaPlayer.getTimeline();
    }
    fetchTimelinePosition(locator) {
        let startPosition = locator.getSelectors()[0];
        if (!(startPosition instanceof (0, $bf500a63b220407b$export$adb0a6894b75cdde))) return Promise.reject();
        let startMs = startPosition.getTimeInterval()?.startMs;
        if (typeof startMs !== "number") return Promise.reject("VanillaReaderAudiobookProgressionTimeline.updateTimelinePosition(): unable to resolve start position for locator " + locator.toString());
        return Promise.resolve(startMs);
    }
    async fetchContentLocation(timelinePosition) {
        let mediaFragmentSelector = new (0, $bf500a63b220407b$export$adb0a6894b75cdde)({
            timeInterval: {
                startMs: timelinePosition
            }
        }, []);
        let locator = new (0, $385fc9d0f36a8af6$export$a5324b29b7a0a294)(this._colibrioTimelineInstance.getReaderPublication().getDefaultLocatorUrl(), [
            mediaFragmentSelector
        ]);
        let position = await this._colibrioTimelineInstance.fetchTimelinePosition(locator);
        return this._colibrioTimelineInstance.fetchContentLocation(position);
    }
    async fetchContentLocationAsRange(_start, _end) {
        return Promise.resolve(undefined);
    }
    async fetchTimelineRange(_location) {
        return Promise.reject("Not implemented for VanillaReaderAudiobookProgressionTimeline");
    }
    updateTimelinePosition(locator) {
        const updateFn = ()=>{
            let startPosition = locator.getSelectors()[0];
            if (startPosition instanceof (0, $bf500a63b220407b$export$adb0a6894b75cdde)) {
                let startMs = startPosition.getTimeInterval()?.startMs;
                if (typeof startMs !== "number") {
                    console.warn("VanillaReaderAudiobookProgressionTimeline.updateTimelinePosition(): unable to resolve start position for locator " + locator.toString());
                    return;
                }
                if (this._timelineUpdateIntentCallback) this._timelineUpdateIntentCallback(startMs);
            }
        };
        if (!this._colibrioTimelineInstance) (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("TIMELINE_READY", updateFn, true);
        else updateFn();
    }
    getLength() {
        return this._colibrioTimelineInstance.getApproximateDurationMs();
    }
    toSerializedData() {
        return undefined;
    }
    onTimelineReady(callback) {
        Promise.resolve().then(()=>{
            return this._fetchDocumentPositionData(this._colibrioTimelineInstance).then((sections)=>{
                callback({
                    length: this._colibrioTimelineInstance.getApproximateDurationMs(),
                    unit: undefined,
                    sections: sections
                });
            });
        }).catch();
    }
    onTimelinePositionUpdated(callback) {
        this._timelineUpdateIntentCallback = callback;
    }
    isReady() {
        return this._colibrioSyncMediaPlayer.isReady();
    }
    getBackingTimelineImplementation() {
        return this._colibrioTimelineInstance;
    }
    serialize() {
        return Promise.resolve(undefined);
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ async _fetchDocumentPositionData(timeline) {
        let documentContentLocations = [];
        let approxStartTimeMs = 0;
        let approxEndTimeMs = 0;
        for (let segment of timeline.getSegments()){
            approxStartTimeMs = approxEndTimeMs;
            approxEndTimeMs += segment.getApproximateDurationMs();
            let timelinePosition = timeline.getTimelinePositionFromApproximateOffsetMs(approxEndTimeMs);
            let contentLocation = await timeline.fetchContentLocation(timelinePosition);
            documentContentLocations.push({
                contentPositionData: {
                    locator: contentLocation.getLocator().toString(this._colibrioTimelineInstance.getReaderPublication().getDefaultLocatorUrl()),
                    timestamp: Date.now()
                },
                range: {
                    start: approxStartTimeMs,
                    end: approxEndTimeMs
                }
            });
        }
        return documentContentLocations;
    }
}


class $d81cf4a2310ad240$export$4c677816971e17bc {
    constructor(_vanillaReaderPublication){
        this._vanillaReaderPublication = _vanillaReaderPublication;
        this._event_segmentActive = async (_ev)=>{
            this._currentActiveNavigationItems = undefined;
            if (this._onMediaPlayerTrackChangedCallback) {
                let currentPlaybackState = await this._getPlaybackStateData(_ev);
                this._onMediaPlayerTrackChangedCallback(currentPlaybackState);
            }
        };
        this._event_playing = async (_ev)=>{
            if (this._onMediaPlayerPlaybackStateChangedCallback) {
                let currentPlaybackState = await this._getPlaybackStateData(_ev);
                this._onMediaPlayerPlaybackStateChangedCallback(currentPlaybackState);
            }
        };
        this._event_paused = async (_ev)=>{
            if (this._onMediaPlayerPlaybackStateChangedCallback) {
                let currentPlaybackState = await this._getPlaybackStateData(_ev);
                this._onMediaPlayerPlaybackStateChangedCallback(currentPlaybackState);
            }
        };
        this._event_seeking = async (_ev)=>{
            if (this._onMediaPlayerPlaybackStateChangedCallback) {
                let currentPlaybackState = await this._getPlaybackStateData(_ev);
                this._onMediaPlayerPlaybackStateChangedCallback(currentPlaybackState);
            }
        };
        this._event_seekCompleted = async (_ev)=>{
            if (this._onMediaPlayerPlaybackStateChangedCallback) {
                let currentPlaybackState = await this._getPlaybackStateData(_ev);
                this._onMediaPlayerPlaybackStateChangedCallback(currentPlaybackState);
            }
        };
        this._event_endReached = async (_ev)=>{
            if (this._onMediaPlayerPlaybackStateChangedCallback) {
                let currentPlaybackState = await this._getPlaybackStateData(_ev);
                this._onMediaPlayerPlaybackStateChangedCallback(currentPlaybackState);
            }
        };
        this._event_timelinePositionChanged = async (_ev)=>{
            // If the `_timelinePositionEventTimeoutHandle` is not undefined it is not yet time to run the
            // `_onMediaPlayerPlaybackPositionChangedCallback` so we return.
            if (this._timelinePositionEventTimeoutHandle) return;
            // The SyncMediaTimeline emits this event every 100ms. That's a little to generous, so we set a timeout
            // to only emit it every second instead.
            this._timelinePositionEventTimeoutHandle = window.setTimeout(async ()=>{
                this._timelinePositionEventTimeoutHandle = undefined;
                if (this._onMediaPlayerPlaybackPositionChangedCallback) {
                    let currentPlaybackState = await this._getPlaybackStateData(_ev);
                    this._onMediaPlayerPlaybackPositionChangedCallback(currentPlaybackState);
                }
            }, 1000);
        };
        this._colibrioReaderPublication = this._vanillaReaderPublication.getColibrioReaderPublication();
        this._colibrioReaderReadingSystem = this._colibrioReaderPublication.getReadingSystemEngine();
    }
    /**
     * Call this before using the VanillaReaderAudiobookPlayer, to create the actual player and timeline.
     */ createSyncMediaTimeLine() {
        /**
         * Creating the timeline can take a while depending on the book. The `progressCallback` is fired continuously
         * during the process to let the UI update its state.
         */ return this._colibrioReaderPublication.createSyncMediaTimeline(this._colibrioReaderPublication.getSpine(), {
            name: "audiobookPlayer"
        }, (progress)=>{
            if (this._onMediaPlayerCreateProgressUpdated) this._onMediaPlayerCreateProgressUpdated(progress);
        }).then((colibrioSyncMediaTimeline)=>{
            // All done, let's move on...
            this._onAfterSyncMediaTimelineCreated(colibrioSyncMediaTimeline);
        }).catch((_reason)=>{
            console.warn("Unable to create SyncMediaTimeline");
        });
    }
    _onAfterSyncMediaTimelineCreated(colibrioSyncMediaTimeline) {
        this._colibrioSyncMediaTimeline = colibrioSyncMediaTimeline;
        this._colibrioSyncMediaPlayer = this._colibrioReaderReadingSystem.createSyncMediaPlayer(this._colibrioSyncMediaTimeline, {
            addDefaultMediaObjectRenderers: false
        });
        // We set the `audioElementPoolSize` to 1 in order to make sure that we reuse the same audio element. This
        // makes it less likely that background playback will be disrupted by garbage collection.
        let audioRenderer = new (0, $6978732dc0bb5e4e$export$d3d22b23ab039045)({
            audioElementPoolSize: 1
        });
        this._colibrioSyncMediaPlayer.addMediaObjectRenderer(audioRenderer);
        this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaSegmentActive", this._event_segmentActive);
        this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaSeeking", this._event_seeking);
        this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaSeeked", this._event_seekCompleted);
        this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaPlay", this._event_playing);
        this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaPaused", this._event_paused);
        this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaEndReached", this._event_endReached);
        this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaTimelinePositionChanged", this._event_timelinePositionChanged);
        this._vanillaReadingProgressionTimeline = new (0, $de4a35bce141ce77$export$f1ea124360fd869c)(this._colibrioSyncMediaPlayer);
        this._publicationDurationMs = this._vanillaReadingProgressionTimeline.getLength();
        if (this._onMediaPlayerCreated) this._onMediaPlayerCreated();
    }
    get hasBeenCreated() {
        return this._colibrioSyncMediaPlayer != undefined;
    }
    get hasTimelineBeenCreated() {
        return this._colibrioSyncMediaTimeline != undefined;
    }
    onMediaPlayerCreated(callback) {
        this._onMediaPlayerCreated = callback;
    }
    onMediaPlayerCreateProgressUpdated(callback) {
        this._onMediaPlayerCreateProgressUpdated = callback;
    }
    onMediaPlayerTrackChanged(callback) {
        this._onMediaPlayerTrackChangedCallback = callback;
    }
    onMediaPlayerPlaybackPositionChanged(callback) {
        this._onMediaPlayerPlaybackPositionChangedCallback = callback;
    }
    onMediaPlayerPlaybackStateChanged(callback) {
        this._onMediaPlayerPlaybackStateChangedCallback = callback;
    }
    getSyncMediaPlayer() {
        return this._colibrioSyncMediaPlayer;
    }
    /**
     * Gets the approximate elapsed time from timeline start to current position in milliseconds.
     */ getApproximateElapsedTimeMs() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.getApproximateElapsedTimeMs();
    }
    /**
     * Get the approximate elapsed time from timeline start in milliseconds to the specified timeline position.
     */ getApproximateElapsedTimeMsForTimelinePosition(timelinePosition) {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return timelinePosition.getTimeline().getApproximateOffsetMs(timelinePosition);
    }
    /**
     * Get the current playback rate, where 1.0 means normal speed.
     * For example: 0.5 is half speed, and 2.0 is double speed.
     */ getPlaybackRate() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.getPlaybackRate();
    }
    /**
     * Get the SyncMediaTimeline that this player is using.
     */ getTimeline() {
        if (!this._vanillaReadingProgressionTimeline) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._vanillaReadingProgressionTimeline;
    }
    /**
     * Get this player's current timeline position.
     */ getTimelinePosition() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.getTimelinePosition();
    }
    /**
     * Get the current volume as a value between 0.0 and 1.0
     */ getVolume() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.getVolume();
    }
    /**
     * If the player is currently at the start of the timeline.
     */ isAtStart() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.isAtStart();
    }
    /**
     * Checks if this instance has been destroyed.
     */ isDestroyed() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.isDestroyed();
    }
    /**
     * If the player has reached the end of the timeline.
     * Calling play() has no effect when this method returns true.
     */ isAtEnd() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.isAtEnd();
    }
    /**
     * If audio is muted.
     */ isMuted() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.isMuted();
    }
    /**
     * If the player is currently paused.
     *
     * Even if this method returns false,
     * the player might still be waiting for media to load or for ReaderView synchronization.
     * Also see `isWaitingForMediaObjectRenderers()` and `isWaitingForReaderViewSynchronization()`.
     */ isPaused() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.isPaused();
    }
    /**
     * If the player is currently playing media.
     * This is a shorthand for: `!isPaused() && isReady()`
     */ isPlaying() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.isPlaying();
    }
    /**
     * True if the media player is ready to play.
     * False if either isWaitingForReaderViewSynchronization() or isWaitingForMediaObjectRenderers() returns true.
     *
     * Clients can still call play() to make the media player resume playback when it has reached ready state.
     */ isReady() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.isReady();
    }
    /**
     * Returns true if the player is currently seeking to a new timeline position.
     */ isSeeking() {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        return this._colibrioSyncMediaPlayer.isSeeking();
    }
    /**
     * Pause playback.
     */ async pause() {
        this._colibrioSyncMediaPlayer?.pause();
        if (this._onMediaPlayerPlaybackStateChangedCallback) {
            let playbackState = await this._getPlaybackStateData();
            this._onMediaPlayerPlaybackStateChangedCallback(playbackState);
        }
        return;
    }
    /**
     * Attempts to resume playback from the current timeline position as soon as the player is ready.
     * The player will pause if it fails to resume playback.
     */ async play() {
        this._colibrioSyncMediaPlayer?.play();
        if (this._onMediaPlayerPlaybackStateChangedCallback) {
            let playbackState = await this._getPlaybackStateData();
            this._onMediaPlayerPlaybackStateChangedCallback(playbackState);
        }
        return;
    }
    seekForward(offsetMs = 10000) {
        if (this._colibrioSyncMediaPlayer) this._colibrioSyncMediaPlayer.seekToApproximateTimeMs(this._colibrioSyncMediaPlayer.getApproximateElapsedTimeMs() + offsetMs);
    }
    seekBackward(offsetMs = 10000) {
        if (this._colibrioSyncMediaPlayer) this._colibrioSyncMediaPlayer.seekToApproximateTimeMs(this._colibrioSyncMediaPlayer.getApproximateElapsedTimeMs() - offsetMs);
    }
    /**
     * Seek to the approximate time from timeline start in milliseconds.
     *
     * @return true if the player started seeking, false if it was not possible to do so.
     */ async seekToApproximateTimeMs(timeMs) {
        const seekResult = this._colibrioSyncMediaPlayer?.seekToApproximateTimeMs(timeMs) || false;
        if (seekResult) {
            let location = await this._vanillaReadingProgressionTimeline?.fetchContentLocation(timeMs);
            if (location) this._vanillaReadingProgressionTimeline?.updateTimelinePosition(location.getLocator());
        } else console.warn("VanillaReaderAudiobookPlayer.seekToApproximateTimeMs(): Unable to seek to time offset " + timeMs);
        return seekResult;
    }
    async seekToLocator(locator) {
        let seekResult = false;
        let position = await this._vanillaReadingProgressionTimeline?.fetchTimelinePosition(locator);
        if (position && position >= 0) {
            seekResult = this._colibrioSyncMediaPlayer?.seekToApproximateTimeMs(position) || false;
            if (seekResult) this._vanillaReadingProgressionTimeline?.updateTimelinePosition(locator);
            else console.warn("VanillaReaderAudiobookPlayer.seekToLocator(): Unable to seek to position ", locator.toString());
        } else console.warn("VanillaReaderAudiobookPlayer.seekToLocator(): Could resolve WpAudiobook timeline position using locator ", locator.toString());
        return seekResult;
    }
    /**
     * Seeks to the next segment in the timeline, if such segment exists.
     *
     * @return true if the player started seeking to the new segment, false if it was not possible to do so.
     */ async seekToNextSegment() {
        let seekResult = this._colibrioSyncMediaPlayer?.seekToNextSegment();
        let position = this._colibrioSyncMediaPlayer?.getApproximateElapsedTimeMs() || 0;
        let locator = await this._vanillaReadingProgressionTimeline?.fetchContentLocation(position);
        if (locator) this._vanillaReadingProgressionTimeline?.updateTimelinePosition(locator.getLocator());
        else console.warn("VanillaReaderAudiobookPlayer.seekToNextSegment(): Unable to fetch ContentLocation for timeline position ", position);
        return seekResult || false;
    }
    /**
     * Seeks to the previous segment in the timeline, if such segment exists.
     *
     * @return true if the player started seeking to the new segment, false if it was not possible to do so.
     */ async seekToPreviousSegment() {
        let seekResult = this._colibrioSyncMediaPlayer?.seekToPreviousSegment();
        let position = this._colibrioSyncMediaPlayer?.getApproximateElapsedTimeMs() || 0;
        let locator = await this._vanillaReadingProgressionTimeline?.fetchContentLocation(position);
        if (locator) this._vanillaReadingProgressionTimeline?.updateTimelinePosition(locator.getLocator());
        else console.warn("VanillaReaderAudiobookPlayer.seekToPreviousSegment(): Unable to fetch ContentLocation for timeline position ", position);
        return seekResult || false;
    }
    /**
     * Seek to a position in the timeline.
     *
     * @return true if the player started seeking to the new position, false if it was not possible to do so.
     */ seekToTimelinePosition(timelinePosition) {
        return this._colibrioSyncMediaPlayer?.seekToTimelinePosition(timelinePosition) || false;
    }
    /**
     * Set if audio should be muted.
     */ setMuted(muted) {
        return this._colibrioSyncMediaPlayer?.setMuted(muted);
    }
    /**
     * Sets the playback rate of the media player as a value between 0.25 and 5.0.
     *
     * A value of 1.0 means "normal speed".
     * Values less than 1.0 make the media to play slower than normal.
     * Values greater than 1.0 make it play faster.
     *
     * @param playbackRate - The new playback rate. The value will be clamped between 0.25 and 5.0.
     */ setPlaybackRate(playbackRate) {
        return this._colibrioSyncMediaPlayer?.setPlaybackRate(playbackRate);
    }
    /**
     * Sets the volume for the media player as a value between 0.0 and 1.0.
     *
     * @param volume - The new volume. The value will be clamped between 0.0 and 1.0.
     */ setVolume(volume) {
        return this._colibrioSyncMediaPlayer?.setVolume(volume);
    }
    /**
     * Returns the complete runtime state of the audio player. This data is generated continuously as the
     *`onMediaPlayerPlaybackStateChanged` is triggered. A callback function the `VanillaReader` class then sends this
     * data to the UI as an event.
     *
     * */ async _getPlaybackStateData(ev) {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderAudiobookPlayer: ColibrioSyncMediaPlayer instance does not exist");
        let position = this._colibrioSyncMediaPlayer.getApproximateElapsedTimeMs();
        let location = await this._vanillaReadingProgressionTimeline?.fetchContentLocation(position);
        let rate = this._colibrioSyncMediaPlayer.getPlaybackRate();
        let volume = this._colibrioSyncMediaPlayer.getVolume();
        let isSeeking = this._colibrioSyncMediaPlayer.isSeeking();
        let isMuted = this._colibrioSyncMediaPlayer.isMuted();
        let isPaused = this._colibrioSyncMediaPlayer.isPaused();
        let locator;
        let navigationItems = [];
        let navigationItemRefs;
        let segmentData = this._colibrioSyncMediaPlayer.getTimelinePosition().getSegment()?.toJSON();
        let positionWithinSegment = this._colibrioSyncMediaPlayer.getTimelinePosition().getOffsetWithinSegmentMs();
        let segmentIndex = this._colibrioSyncMediaPlayer.getTimelinePosition().getSegmentIndex();
        let publicationDurationMs = this._publicationDurationMs;
        let segmentTimelineStartPosition;
        segmentTimelineStartPosition = this._colibrioSyncMediaTimeline ? new (0, $6978732dc0bb5e4e$export$4cbca0b50906dc0e)(this._colibrioSyncMediaTimeline, segmentIndex, 0) : undefined;
        if (segmentData && segmentTimelineStartPosition) segmentData.segmentTimelineStartOffsetMs = segmentTimelineStartPosition.getTimeline().getApproximateOffsetMs(segmentTimelineStartPosition);
        if (!this._currentActiveNavigationItems) {
            navigationItemRefs = await location?.fetchNavigationItemReferences({
                collectionTypes: [
                    (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC
                ],
                greedy: false
            });
            navigationItemRefs?.getItemsInRange()?.forEach((ref)=>{
                const navigationItem = {
                    locator: ref.getNavigationItem()?.getLocator()?.toString(),
                    children: [],
                    collectionType: ref.getNavigationCollection().getType(),
                    title: ref.getNavigationItem().getTextContent()
                };
                navigationItems.push(navigationItem);
            });
            // Store this value for upcoming calls. The `this._currentActiveNavigationItems` field is "reset" in the
            // `_event_segmentActive` event handler, when we have a new segment.
            this._currentActiveNavigationItems = navigationItems;
        } else navigationItems = this._currentActiveNavigationItems;
        if (location) locator = location?.getLocator().toString();
        return Promise.resolve({
            type: ev?.type,
            locator: locator,
            position: position,
            positionWithinSegment: positionWithinSegment,
            segmentIndex: segmentIndex,
            navigationItems: navigationItems,
            rate: rate,
            volume: volume,
            isSeeking: isSeeking,
            isMuted: isMuted,
            isPaused: isPaused,
            segmentData: segmentData,
            publicationDurationMs: publicationDurationMs
        });
    }
}


/***
 * Sync Media Player
 */ 

/**
 *
 * WebSpeechUtils
 *
 * This utility class helps out with getting voices in a cross-platform manner. It is not pretty folks, but `setInterval`
 * is the recommended quirkfix to this issue.
 *
 * */ class $410aa1fb5d04a699$export$aa8547013ca2283b {
    static{
        this.fetchTtsVoices = ()=>{
            let iterationsCount = 0;
            let intervalHandle;
            return new Promise((resolve, reject)=>{
                const getVoices = ()=>{
                    if (iterationsCount > 5) {
                        window.clearInterval(intervalHandle);
                        reject("TTS voices request took too long.");
                    }
                    iterationsCount++;
                    let voicesList = window.speechSynthesis.getVoices();
                    if (voicesList.length > 0) {
                        window.clearInterval(intervalHandle);
                        resolve($410aa1fb5d04a699$export$aa8547013ca2283b.createCollectionFromVoicesList(voicesList));
                    }
                };
                /**
             * We need to run the `getVoices` function until we get a voice list from the browser, or until
             * we have reached the maximum of 5 iterations.
             * The main reason for this quirkfix is that Safari does not support the `voicesChanged` event, so there
             * is no way of knowing when it has finished building its list of available voices.
             *
             */ intervalHandle = window.setInterval(getVoices, 500);
            });
        };
    }
    static createCollectionFromVoicesList(voicesList) {
        let voiceCollection = {
            allVoices: [],
            languages: new Map(),
            remoteVoices: [],
            localVoices: []
        };
        voiceCollection.allVoices = voicesList;
        voicesList.forEach((voice)=>{
            // Split lang code so that we separate language "family" and regional dialect.
            let langFamilyCode = voice.lang.includes("-") ? voice.lang.split("-")[0] : voice.lang.split("_")[0];
            if (!voiceCollection.languages.has(langFamilyCode)) voiceCollection.languages.set(langFamilyCode, []);
            voiceCollection.languages.get(langFamilyCode)?.push(voice);
            if (voice.localService) voiceCollection.localVoices.push(voice);
            if (voice.voiceURI) voiceCollection.remoteVoices.push(voice);
        });
        return voiceCollection;
    }
}



var $d2c66ead28054c71$export$98a63c97d3a2bbdf;
(function(VanillaReaderUiActionNames) {
    VanillaReaderUiActionNames["ACTIONS_MENU_OPEN"] = "uiaction_actions_menu_open";
    VanillaReaderUiActionNames["MAIN_MENU_OPEN"] = "uiaction_main_menu_open";
    VanillaReaderUiActionNames["WHERE_AM_I"] = "uiaction_where_am_i";
    VanillaReaderUiActionNames["TOC_OPEN_DIALOG"] = "uiaction_toc_open";
    VanillaReaderUiActionNames["NAVIGATE_NEXT"] = "uiaction_navigate_next";
    VanillaReaderUiActionNames["NAVIGATE_PREVIOUS"] = "uiaction_navigate_previous";
    VanillaReaderUiActionNames["NAVIGATE_NEXT_HEADING"] = "uiaction_navigate_next_heading";
    VanillaReaderUiActionNames["NAVIGATE_PREVIOUS_HEADING"] = "uiaction_navigate_previous_heading";
    VanillaReaderUiActionNames["HIGHLIGHT_OPEN_DIALOG_ALL"] = "uiaction_highlight_open_dialog_all";
    VanillaReaderUiActionNames["HIGHLIGHT_OPEN_DIALOG_ACTIVE"] = "uiaction_highlight_open_dialog_active";
    VanillaReaderUiActionNames["HIGHLIGHT_SELECTION"] = "uiaction_highlight_selection";
    VanillaReaderUiActionNames["HIGHLIGHT_CLIPBOARD"] = "uiaction_highlight_clipboard";
    VanillaReaderUiActionNames["HIGHLIGHT_READING_POSITION"] = "uiaction_highlight_reading_position";
    VanillaReaderUiActionNames["HIGHLIGHT_ACTIVE_CONTENT"] = "uiaction_highlight_active_content";
    VanillaReaderUiActionNames["BOOKMARK_SELECTION"] = "uiaction_bookmark_selection";
    VanillaReaderUiActionNames["BOOKMARK_CLIPBOARD"] = "uiaction_bookmark_clipboard";
    VanillaReaderUiActionNames["BOOKMARK_READING_POSITION"] = "uiaction_bookmark_reading_position";
    VanillaReaderUiActionNames["BOOKMARK_OPEN_DIALOG_ALL"] = "uiaction_bookmark_open_dialog_all";
    VanillaReaderUiActionNames["BOOKMARK_OPEN_DIALOG_ACTIVE"] = "uiaction_bookmark_open_dialog_active";
    VanillaReaderUiActionNames["SEARCH_DIALOG_OPEN"] = "uiaction_search_open_dialog_active";
    VanillaReaderUiActionNames["SEARCH_CLEAR"] = "uiaction_search_clear";
    VanillaReaderUiActionNames["MEDIA_PLAYBACK_START"] = "uiaction_media_playback_start";
    VanillaReaderUiActionNames["MEDIA_PLAYBACK_STOP"] = "uiaction_media_playback_stop";
    VanillaReaderUiActionNames["MEDIA_PLAYBACK_SKIP_FORWARD"] = "uiaction_media_playback_skip_forward";
    VanillaReaderUiActionNames["MEDIA_PLAYBACK_SKIP_BACKWARD"] = "uiaction_media_playback_skip_backward";
    VanillaReaderUiActionNames["MEDIA_PLAYBACK_ESCAPE_ACTIVE_SEGMENT"] = "uiaction_media_playback_escape_segment";
    VanillaReaderUiActionNames["MEDIA_PLAYBACK_ESCAPE_ALL"] = "uiaction_media_playback_escape_all";
    VanillaReaderUiActionNames["HELP_DIALOG_OPEN"] = "uiaction_help_dialog_open";
    VanillaReaderUiActionNames["ACCESSIBILITY_MODE_ENTER"] = "uiaction_accessibility_mode_enter";
    VanillaReaderUiActionNames["ACCESSIBILITY_MODE_EXIT"] = "uiaction_accessibility_mode_exit";
    VanillaReaderUiActionNames["SETTINGS_DIALOG_OPEN"] = "uiaction_settings_dialog_open";
    VanillaReaderUiActionNames["SETTINGS_RESET"] = "uiaction_settings_reset";
    VanillaReaderUiActionNames["BOOKSHELF_DIALOG_OPEN"] = "uiaction_bookshelf_dialog_open";
    VanillaReaderUiActionNames["CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION"] = "uiaction_close_dialogs_and_focus_on_reading_position";
    VanillaReaderUiActionNames["GOTO_PAGE_DIALOG_OPEN"] = "uiaction_goto_page_dialog_open";
    VanillaReaderUiActionNames["ZOOM_TOOL_ACTIVATE"] = "uiaction_zoom_mode_enter";
    VanillaReaderUiActionNames["ZOOM_TOOL_DEACTIVATE"] = "uiaction_zoom_mode_exit";
    VanillaReaderUiActionNames["ZOOM_OUT"] = "uiaction_zoom_out";
    VanillaReaderUiActionNames["ZOOM_IN"] = "uiaction_zoom_in";
    VanillaReaderUiActionNames["ZOOM_RESET"] = "uiaction_zoom_reset";
    VanillaReaderUiActionNames["READING_RULER_ACTIVATE"] = "uiaction_ruler_activate";
    VanillaReaderUiActionNames["READING_RULER_DEACTIVATE"] = "uiaction_ruler_deactivate";
    VanillaReaderUiActionNames["READING_RULER_MOVE_NEXT"] = "uiaction_ruler_move_next";
    VanillaReaderUiActionNames["READING_RULER_MOVE_PREVIOUS"] = "uiaction_ruler_move_previous";
    VanillaReaderUiActionNames["LANDMARKS_DIALOG_OPEN"] = "uiaction_landmarks_dialog_open";
    VanillaReaderUiActionNames["NAVIGATION_HISTORY_DIALOG_OPEN"] = "uiaction_navigation_history_dialog_open";
})($d2c66ead28054c71$export$98a63c97d3a2bbdf || ($d2c66ead28054c71$export$98a63c97d3a2bbdf = {}));
var $d2c66ead28054c71$export$d297325fca76c218;
(function(CssMixBlendModeValues) {
    CssMixBlendModeValues["INHERIT"] = "inherit";
    CssMixBlendModeValues["INITIAL"] = "initial";
    CssMixBlendModeValues["REVERT"] = "revert";
    CssMixBlendModeValues["REVERT_LAYER"] = "revert-layer";
    CssMixBlendModeValues["UNSET"] = "unset";
    CssMixBlendModeValues["NORMAL"] = "normal";
    CssMixBlendModeValues["MULTIPLY"] = "multiply";
    CssMixBlendModeValues["SCREEN"] = "screen";
    CssMixBlendModeValues["OVERLAY"] = "overlay";
    CssMixBlendModeValues["DARKEN"] = "darken";
    CssMixBlendModeValues["LIGHTEN"] = "lighten";
    CssMixBlendModeValues["COLOR_DODGE"] = "color-dodge";
    CssMixBlendModeValues["COLOR_BURN"] = "color-burn";
    CssMixBlendModeValues["HARD_LIGHT"] = "hard-light";
    CssMixBlendModeValues["SOFT_LIGHT"] = "soft-light";
    CssMixBlendModeValues["DIFFERENCE"] = "difference";
    CssMixBlendModeValues["EXCLUSION"] = "exclusion";
    CssMixBlendModeValues["HUE"] = "hue";
    CssMixBlendModeValues["SATURATION"] = "saturation";
    CssMixBlendModeValues["COLOR"] = "color";
    CssMixBlendModeValues["LUMINOSITY"] = "luminosity";
})($d2c66ead28054c71$export$d297325fca76c218 || ($d2c66ead28054c71$export$d297325fca76c218 = {}));
var $d2c66ead28054c71$export$82747f63b1a1778f;
(function(VanillaReaderUiOptionsPresetNames) {
    VanillaReaderUiOptionsPresetNames["GUIDED_READING_MODE"] = "GUIDED_READING_MODE";
    VanillaReaderUiOptionsPresetNames["AT_READING_MODE"] = "AT_READING_MODE";
    VanillaReaderUiOptionsPresetNames["READING_RULER_MODE"] = "READING_RULER_MODE";
})($d2c66ead28054c71$export$82747f63b1a1778f || ($d2c66ead28054c71$export$82747f63b1a1778f = {}));


/**
 * A const enum that includes all non-printable string values one can expect from $event.key.
 * For example, this enum includes values like "CapsLock", "Backspace", and "AudioVolumeMute",
 * but does not include values like "a", "A", "#", "é", or "¿".
 * Auto generated from MDN: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#Speech_recognition_keys
 */ var $83aeb96f47fc070f$export$cd0f44441c3b7719;
(function(Key) {
    /** The user agent wasn't able to map the event's virtual keycode to a specific key value. This can happen due to hardware or software constraints, or because of constraints around the platform on which the user agent is running. */ Key["Unidentified"] = "Unidentified";
    /** The Alt (Alternative) key. */ Key["Alt"] = "Alt";
    /** The AltGr or AltGraph (Alternate Graphics) key. Enables the ISO Level 3 shift modifier (where Shift is the level 2 modifier). */ Key["AltGraph"] = "AltGraph";
    /** The Caps Lock key. Toggles the capital character lock on and off for subsequent input. */ Key["CapsLock"] = "CapsLock";
    /** The Control, Ctrl, or Ctl key. Allows typing control characters. */ Key["Control"] = "Control";
    /** The Fn (Function modifier) key. Used to allow generating function key (F1-F15, for instance) characters on keyboards without a dedicated function key area. Often handled in hardware so that events aren't generated for this key. */ Key["Fn"] = "Fn";
    /** The FnLock or F-Lock (Function Lock) key.Toggles the function key mode described by "Fn" on and off. Often handled in hardware so that events aren't generated for this key. */ Key["FnLock"] = "FnLock";
    /** The Hyper key. */ Key["Hyper"] = "Hyper";
    /** The Meta key. Allows issuing special command inputs. This is the Windows logo key, or the Command or ⌘ key on Mac keyboards. */ Key["Meta"] = "Meta";
    /** The NumLock (Number Lock) key. Toggles the numeric keypad between number entry some other mode (often directional arrows). */ Key["NumLock"] = "NumLock";
    /** The Scroll Lock key. Toggles beteen scrolling and cursor movement modes. */ Key["ScrollLock"] = "ScrollLock";
    /** The Shift key. Modifies keystrokes to allow typing upper (or other) case letters, and to support typing punctuation and other special characters. */ Key["Shift"] = "Shift";
    /** The Super key. */ Key["Super"] = "Super";
    /** The Symbol modifier key (found on certain virtual keyboards). */ Key["Symbol"] = "Symbol";
    /** The Symbol Lock key. */ Key["SymbolLock"] = "SymbolLock";
    /** The Enter or ↵ key (sometimes labeled Return). */ Key["Enter"] = "Enter";
    /** The Horizontal Tab key, Tab. */ Key["Tab"] = "Tab";
    /** The down arrow key. */ Key["ArrowDown"] = "ArrowDown";
    /** The left arrow key. */ Key["ArrowLeft"] = "ArrowLeft";
    /** The right arrow key. */ Key["ArrowRight"] = "ArrowRight";
    /** The up arrow key. */ Key["ArrowUp"] = "ArrowUp";
    /** The End key. Moves to the end of content. */ Key["End"] = "End";
    /** The Home key. Moves to the start of content. */ Key["Home"] = "Home";
    /** The Page Down (or PgDn) key. Scrolls down or displays the next page of content. */ Key["PageDown"] = "PageDown";
    /** The Page Up (or PgUp) key. Scrolls up or displays the previous page of content. */ Key["PageUp"] = "PageUp";
    /** The Backspace key. This key is labeled Delete on Mac keyboards. */ Key["Backspace"] = "Backspace";
    /** The Clear key. Removes the currently selected input. */ Key["Clear"] = "Clear";
    /** The Copy key (on certain extended keyboards). */ Key["Copy"] = "Copy";
    /** The Cursor Select key, CrSel. */ Key["CrSel"] = "CrSel";
    /** The Cut key (on certain extended keyboards). */ Key["Cut"] = "Cut";
    /** The Delete key, Del. */ Key["Delete"] = "Delete";
    /** Erase to End of Field. Deletes all characters from the current cursor position to the end of the current field. */ Key["EraseEof"] = "EraseEof";
    /** The ExSel (Extend Selection) key. */ Key["ExSel"] = "ExSel";
    /** The Insert key, Ins. Toggles  between inserting and overwriting text. */ Key["Insert"] = "Insert";
    /** Paste from the clipboard. */ Key["Paste"] = "Paste";
    /** Redo the last action. */ Key["Redo"] = "Redo";
    /** Undo the last action. */ Key["Undo"] = "Undo";
    /** The Accept, Commit, or OK key or button. Accepts the currently selected option or input method sequence conversion. */ Key["Accept"] = "Accept";
    /** The Again key. Redoes or repeats a previous action. */ Key["Again"] = "Again";
    /** The Attn (Attention) key. */ Key["Attn"] = "Attn";
    /** The Cancel key. */ Key["Cancel"] = "Cancel";
    /** Shows the context menu. Typically found between the Windows (or OS) key and the Control key on the right side of the keyboard. */ Key["ContextMenu"] = "ContextMenu";
    /** The Esc (Escape) key. Typically used as an exit, cancel, or "escape this operation" button. Historically, the Escape character was used to signal the start of a special control sequence of characters called an "escape sequence." */ Key["Escape"] = "Escape";
    /** The Execute key. */ Key["Execute"] = "Execute";
    /** The Find key. Opens an interface (typically a dialog box) for performing a find/search operation. */ Key["Find"] = "Find";
    /** The Finish key. */ Key["Finish"] = "Finish";
    /** The Help key. Opens or toggles the display of help information. */ Key["Help"] = "Help";
    /**
   * The Pause key. Pauses the current application or state, if applicable.
   * This shouldn't be confused with the "MediaPause" key value, which is used for media controllers, rather than to control applications and processes.
   */ Key["Pause"] = "Pause";
    /**
   * The Play key. Resumes a previously paused application, if applicable.
   * This shouldn't be confused with the "MediaPlay" key value, which is used for media controllers, rather than to control applications and processes.
   */ Key["Play"] = "Play";
    /** The Props (Properties) key. */ Key["Props"] = "Props";
    /** The Select key. */ Key["Select"] = "Select";
    /** The ZoomIn key. */ Key["ZoomIn"] = "ZoomIn";
    /** The ZoomOut key. */ Key["ZoomOut"] = "ZoomOut";
    /** The Brightness Down key. Typically used to reduce the brightness of the display. */ Key["BrightnessDown"] = "BrightnessDown";
    /** The Brightness Up key. Typically increases the brightness of the display. */ Key["BrightnessUp"] = "BrightnessUp";
    /** The Eject key. Ejects removable media (or toggles an optical storage device tray open and closed). */ Key["Eject"] = "Eject";
    /** The LogOff key. */ Key["LogOff"] = "LogOff";
    /**
   * The Power button or key, to toggle power on and off.
   * Not all systems pass this key through to to the user agent.
   */ Key["Power"] = "Power";
    /** The PowerOff or PowerDown key. Shuts off the system. */ Key["PowerOff"] = "PowerOff";
    /** The PrintScreen or PrtScr key. Sometimes SnapShot. Captures the screen and prints it or saves it to disk. */ Key["PrintScreen"] = "PrintScreen";
    /** The Hibernate key. This saves the state of the computer to disk and then shuts down; the computer can be returned to its previous state by restoring the saved state information. */ Key["Hibernate"] = "Hibernate";
    /** The Standby key; also known as Suspend or Sleep. This turns off the display and puts the computer in a low power consumption mode, without completely powering off. */ Key["Standby"] = "Standby";
    /** The WakeUp key; used to wake the computer from the hibernation or standby modes. */ Key["WakeUp"] = "WakeUp";
    /** The All Candidates key, which starts multi-candidate mode, in which multiple candidates are displayed for the ongoing input. */ Key["AllCandidates"] = "AllCandidates";
    /** The Alphanumeric key. */ Key["Alphanumeric"] = "Alphanumeric";
    /** The Code Input key, which enables code input mode, which lets the user enter characters by typing their code points (their Unicode character numbers, typically). */ Key["CodeInput"] = "CodeInput";
    /** The Compose key. */ Key["Compose"] = "Compose";
    /** The Convert key, which instructs the IME to convert the current input method sequence into the resulting character. */ Key["Convert"] = "Convert";
    /** A dead "combining" key; that is, a key which is used in tandem with other keys to generate accented and other modified characters. If pressed by itself, it doesn't generate a character. If you wish to identify which specific dead key was pressed (in cases where more than one exists), you can do so by examining the KeyboardEvent's associated compositionupdate event's  data property. */ Key["Dead"] = "Dead";
    /** The Final (Final Mode) key is used on some Asian keyboards to enter final mode when using IMEs. */ Key["FinalMode"] = "FinalMode";
    /** Switches to the first character group on an ISO/IEC 9995 keyboard. Each key may have multiple groups of characters, each in its own column. Pressing this key instructs the device to interpret keypresses as coming from the first column on subsequent keystrokes. */ Key["GroupFirst"] = "GroupFirst";
    /** Switches to the last character group on an ISO/IEC 9995 keyboard. */ Key["GroupLast"] = "GroupLast";
    /** Switches to the next character group on an ISO/IEC 9995 keyboard. */ Key["GroupNext"] = "GroupNext";
    /** Switches to the previous character group on an ISO/IEC 9995 keyboard. */ Key["GroupPrevious"] = "GroupPrevious";
    /** The Mode Change key. Toggles or cycles among input modes of IMEs. */ Key["ModeChange"] = "ModeChange";
    /** The Next Candidate function key. Selects the next possible match for the ongoing input. */ Key["NextCandidate"] = "NextCandidate";
    /** The NonConvert ("Don't convert") key. This accepts the current input method sequence without running conversion when using an IME. */ Key["NonConvert"] = "NonConvert";
    /** The Previous Candidate key. Selects the previous possible match for the ongoing input. */ Key["PreviousCandidate"] = "PreviousCandidate";
    /** The Process key. Instructs the IME to process the conversion. */ Key["Process"] = "Process";
    /** The Single Candidate key. Enables single candidate mode (as opposed to multi-candidate mode); in this mode, only one candidate is displayed at a time. */ Key["SingleCandidate"] = "SingleCandidate";
    /** The Hangul (Korean character set) mode key, which toggles between Hangul and English entry modes. */ Key["HangulMode"] = "HangulMode";
    /** Selects the Hanja mode, for converting Hangul characters to the more specific Hanja characters. */ Key["HanjaMode"] = "HanjaMode";
    /** Selects the Junja mode, in which Korean is represented using single-byte Latin characters. */ Key["JunjaMode"] = "JunjaMode";
    /** The Eisu key. This key's purpose is defined by the IME, but may be used to close the IME. */ Key["Eisu"] = "Eisu";
    /** The Hankaku (half-width characters) key. */ Key["Hankaku"] = "Hankaku";
    /** The Hiragana key; selects Kana characters mode. */ Key["Hiragana"] = "Hiragana";
    /** Toggles between the Hiragana and Katakana writing systems. */ Key["HiraganaKatakana"] = "HiraganaKatakana";
    /** The Kana Mode (Kana Lock) key. */ Key["KanaMode"] = "KanaMode";
    /** The Kanji Mode key. Enables entering Japanese text using the ideographic characters of Chinese origin. */ Key["KanjiMode"] = "KanjiMode";
    /** The Katakana key. */ Key["Katakana"] = "Katakana";
    /** The Romaji key; selects the Roman character set. */ Key["Romaji"] = "Romaji";
    /** The Zenkaku (full width) characters key. */ Key["Zenkaku"] = "Zenkaku";
    /** The Zenkaku/Hankaku (full width/half width) toggle key. */ Key["ZenkakuHanaku"] = "ZenkakuHanaku";
    /** The first general-purpose function key, F1. */ Key["F1"] = "F1";
    /** The F2 key. */ Key["F2"] = "F2";
    /** The F3 key. */ Key["F3"] = "F3";
    /** The F4 key. */ Key["F4"] = "F4";
    /** The F5 key. */ Key["F5"] = "F5";
    /** The F6 key. */ Key["F6"] = "F6";
    /** The F7 key. */ Key["F7"] = "F7";
    /** The F8 key. */ Key["F8"] = "F8";
    /** The F9 key. */ Key["F9"] = "F9";
    /** The F10 key. */ Key["F10"] = "F10";
    /** The F11 key. */ Key["F11"] = "F11";
    /** The F12 key. */ Key["F12"] = "F12";
    /** The F13 key. */ Key["F13"] = "F13";
    /** The F14 key. */ Key["F14"] = "F14";
    /** The F15 key. */ Key["F15"] = "F15";
    /** The F16 key. */ Key["F16"] = "F16";
    /** The F17 key. */ Key["F17"] = "F17";
    /** The F18 key. */ Key["F18"] = "F18";
    /** The F19 key. */ Key["F19"] = "F19";
    /** The F20 key. */ Key["F20"] = "F20";
    /** The first general-purpose virtual function key. */ Key["Soft1"] = "Soft1";
    /** The second general-purpose virtual function key. */ Key["Soft2"] = "Soft2";
    /** The third general-purpose virtual function key. */ Key["Soft3"] = "Soft3";
    /** The fourth general-purpose virtual function key. */ Key["Soft4"] = "Soft4";
    /** Presents a list of recently-used applications which lets the user change apps quickly. */ Key["AppSwitch"] = "AppSwitch";
    /** The Call key; dials the number which has been entered. */ Key["Call"] = "Call";
    /** The Camera key; activates the camera. */ Key["Camera"] = "Camera";
    /** The Focus key; focuses the camera. */ Key["CameraFocus"] = "CameraFocus";
    /** The End Call or Hang Up button. */ Key["EndCall"] = "EndCall";
    /** The Back button. */ Key["GoBack"] = "GoBack";
    /** The Home button, which takes the user to the phone's main screen (usually an application launcher). */ Key["GoHome"] = "GoHome";
    /** The Headset Hook key. This is typically actually a button on the headset which is used to hang up calls and play or pause media. */ Key["HeadsetHook"] = "HeadsetHook";
    /** The Redial button, which redials the last-called number. */ Key["LastNumberRedial"] = "LastNumberRedial";
    /** The Notification key. */ Key["Notification"] = "Notification";
    /** A button which cycles among the notification modes: silent, vibrate, ring, and so forth. */ Key["MannerMode"] = "MannerMode";
    /** The Voice Dial key. Initiates voice dialing. */ Key["VoiceDial"] = "VoiceDial";
    /** Switches to the previous channel. */ Key["ChannelDown"] = "ChannelDown";
    /** Switches to the next channel. */ Key["ChannelUp"] = "ChannelUp";
    /** Starts, continues, or increases the speed of fast forwarding the media. */ Key["MediaFastForward"] = "MediaFastForward";
    /** Pauses the currently playing media. Some older applications use simply "Pause" but this is not correct. */ Key["MediaPause"] = "MediaPause";
    /** Starts or continues playing media at normal speed, if not already doing so. Has no effect otherwise. */ Key["MediaPlay"] = "MediaPlay";
    /** Toggles between playing and pausing the current media. */ Key["MediaPlayPause"] = "MediaPlayPause";
    /** Starts or resumes recording media. */ Key["MediaRecord"] = "MediaRecord";
    /** Starts, continues, or increases the speed of rewinding the media. */ Key["MediaRewind"] = "MediaRewind";
    /** Stops the current media activity (such as playing, recording, pausing, forwarding, or rewinding). Has no effect if the media is currently stopped already. */ Key["MediaStop"] = "MediaStop";
    /** Seeks to the next media or program track. */ Key["MediaTrackNext"] = "MediaTrackNext";
    /** Seeks to the previous media or program track. */ Key["MediaTrackPrevious"] = "MediaTrackPrevious";
    /** Adjusts audio balance toward the left. */ Key["AudioBalanceLeft"] = "AudioBalanceLeft";
    /** Adjusts audio balance twoard the right. */ Key["AudioBalanceRight"] = "AudioBalanceRight";
    /** Decreases the amount of bass. */ Key["AudioBassDown"] = "AudioBassDown";
    /** Reduces bass boosting or cycles downward through bass boost modes or states. */ Key["AudioBassBoostDown"] = "AudioBassBoostDown";
    /** Toggles bass boosting on and off. */ Key["AudioBassBoostToggle"] = "AudioBassBoostToggle";
    /** Increases the amoung of bass boosting, or cycles upward through a set of bass boost modes or states. */ Key["AudioBassBoostUp"] = "AudioBassBoostUp";
    /** Increases the amount of bass. */ Key["AudioBassUp"] = "AudioBassUp";
    /** Adjusts the audio fader toward the front. */ Key["AudioFaderFront"] = "AudioFaderFront";
    /** Adjustts the audio fader toward the rear. */ Key["AudioFaderRear"] = "AudioFaderRear";
    /** Selects the next available surround sound mode. */ Key["AudioSurroundModeNext"] = "AudioSurroundModeNext";
    /** Decreases the amount of treble. */ Key["AudioTrebleDown"] = "AudioTrebleDown";
    /** Increases the amount of treble. */ Key["AudioTrebleUp"] = "AudioTrebleUp";
    /** Decreases the audio volume. */ Key["AudioVolumeDown"] = "AudioVolumeDown";
    /** Mutes the audio. */ Key["AudioVolumeMute"] = "AudioVolumeMute";
    /** Increases the audio volume. */ Key["AudioVolumeUp"] = "AudioVolumeUp";
    /** Toggles the microphone on and off. */ Key["MicrophoneToggle"] = "MicrophoneToggle";
    /** Decreases the microphone's input volume. */ Key["MicrophoneVolumeDown"] = "MicrophoneVolumeDown";
    /** Mutes the microphone input. */ Key["MicrophoneVolumeMute"] = "MicrophoneVolumeMute";
    /** Increases the microphone's input volume. */ Key["MicrophoneVolumeUp"] = "MicrophoneVolumeUp";
    /** Switches into TV viewing mode. */ Key["TV"] = "TV";
    /** Toggles 3D TV mode on and off. */ Key["TV3DMode"] = "TV3DMode";
    /** Toggles between antenna and cable inputs. */ Key["TVAntennaCable"] = "TVAntennaCable";
    /** Toggles audio description mode on and off. */ Key["TVAudioDescription"] = "TVAudioDescription";
    /** Decreases trhe audio description's mixing volume; reduces the volume of the audio descriptions relative to the program sound. */ Key["TVAudioDescriptionMixDown"] = "TVAudioDescriptionMixDown";
    /** Increases the audio description's mixing volume; increases the volume of the audio descriptions relative to the program sound. */ Key["TVAudioDescriptionMixUp"] = "TVAudioDescriptionMixUp";
    /** Displays or hides the media contents available for playback (this may be a channel guide showing the currently airing programs, or a list of media files to play). */ Key["TVContentsMenu"] = "TVContentsMenu";
    /** Displays or hides the TV's data service menu. */ Key["TVDataService"] = "TVDataService";
    /** Cycles the input mode on an external TV. */ Key["TVInput"] = "TVInput";
    /** Switches to the input "Component 1." */ Key["TVInputComponent1"] = "TVInputComponent1";
    /** Switches to the input "Component 2." */ Key["TVInputComponent2"] = "TVInputComponent2";
    /** Switches to the input "Composite 1." */ Key["TVInputComposite1"] = "TVInputComposite1";
    /** Switches to the input "Composite 2." */ Key["TVInputComposite2"] = "TVInputComposite2";
    /** Switches to the input "HDMI 1." */ Key["TVInputHDMI1"] = "TVInputHDMI1";
    /** Switches to the input "HDMI 2." */ Key["TVInputHDMI2"] = "TVInputHDMI2";
    /** Switches to the input "HDMI 3." */ Key["TVInputHDMI3"] = "TVInputHDMI3";
    /** Switches to the input "HDMI 4." */ Key["TVInputHDMI4"] = "TVInputHDMI4";
    /** Switches to the input "VGA 1." */ Key["TVInputVGA1"] = "TVInputVGA1";
    /** The Media Context menu key. */ Key["TVMediaContext"] = "TVMediaContext";
    /** Toggle the TV's network connection on and off. */ Key["TVNetwork"] = "TVNetwork";
    /** Put the TV into number entry mode. */ Key["TVNumberEntry"] = "TVNumberEntry";
    /** The device's power button. */ Key["TVPower"] = "TVPower";
    /** Radio button. */ Key["TVRadioService"] = "TVRadioService";
    /** Satellite button. */ Key["TVSatellite"] = "TVSatellite";
    /** Broadcast Satellite button. */ Key["TVSatelliteBS"] = "TVSatelliteBS";
    /** Communication Satellite button. */ Key["TVSatelliteCS"] = "TVSatelliteCS";
    /** Toggles among available satellites. */ Key["TVSatelliteToggle"] = "TVSatelliteToggle";
    /** Selects analog terrestrial television service (analog cable or antenna reception). */ Key["TVTerrestrialAnalog"] = "TVTerrestrialAnalog";
    /** Selects digital terrestrial television service (digital cable or antenna receiption). */ Key["TVTerrestrialDigital"] = "TVTerrestrialDigital";
    /** Timer programming button. */ Key["TVTimer"] = "TVTimer";
    /** Changes the input mode on an external audio/video receiver (AVR) unit. */ Key["AVRInput"] = "AVRInput";
    /** Toggles the power on an external AVR unit. */ Key["AVRPower"] = "AVRPower";
    /** General-purpose media function key, color-coded red; this has index 0 among the colored keys. */ Key["ColorF0Red"] = "ColorF0Red";
    /** General-purpose media funciton key, color-coded green; this has index 1 among the colored keys. */ Key["ColorF1Green"] = "ColorF1Green";
    /** General-purpose media funciton key, color-coded yellow; this has index 2 among the colored keys. */ Key["ColorF2Yellow"] = "ColorF2Yellow";
    /** General-purpose media funciton key, color-coded blue; this has index 3 among the colored keys. */ Key["ColorF3Blue"] = "ColorF3Blue";
    /** General-purpose media funciton key, color-coded grey; this has index 4 among the colored keys. */ Key["ColorF4Grey"] = "ColorF4Grey";
    /** General-purpose media funciton key, color-coded brown; this has index 5 among the colored keys. */ Key["ColorF5Brown"] = "ColorF5Brown";
    /** Toggles closed captioning on and off. */ Key["ClosedCaptionToggle"] = "ClosedCaptionToggle";
    /** Adjusts the brightness of the device by toggling between two brightness levels or by cycling among multiple brightness levels. */ Key["Dimmer"] = "Dimmer";
    /** Cycles among video sources. */ Key["DisplaySwap"] = "DisplaySwap";
    /** Switches the input source to the Digital Video Recorder (DVR). */ Key["DVR"] = "DVR";
    /** The Exit button, which exits the curreent application or menu. */ Key["Exit"] = "Exit";
    /** Clears the program or content stored in the first favorites list slot. */ Key["FavoriteClear0"] = "FavoriteClear0";
    /** Clears the program or content stored in the second favorites list slot. */ Key["FavoriteClear1"] = "FavoriteClear1";
    /** Clears the program or content stored in the third favorites list slot. */ Key["FavoriteClear2"] = "FavoriteClear2";
    /** Clears the program or content stored in the fourth favorites list slot. */ Key["FavoriteClear3"] = "FavoriteClear3";
    /** Selects (recalls) the program or content stored in the first favorites list slot. */ Key["FavoriteRecall0"] = "FavoriteRecall0";
    /** Selects (recalls) the program or content stored in the second favorites list slot. */ Key["FavoriteRecall1"] = "FavoriteRecall1";
    /** Selects (recalls) the program or content stored in the third favorites list slot. */ Key["FavoriteRecall2"] = "FavoriteRecall2";
    /** Selects (recalls) the program or content stored in the fourth favorites list slot. */ Key["FavoriteRecall3"] = "FavoriteRecall3";
    /** Stores the current program or content into the first favorites list slot. */ Key["FavoriteStore0"] = "FavoriteStore0";
    /** Stores the current program or content into the second favorites list slot. */ Key["FavoriteStore1"] = "FavoriteStore1";
    /** Stores the current program or content into the third favorites list slot. */ Key["FavoriteStore2"] = "FavoriteStore2";
    /** Stores the current program or content into the fourth favorites list slot. */ Key["FavoriteStore3"] = "FavoriteStore3";
    /** Toggles the display of the program or content guide. */ Key["Guide"] = "Guide";
    /** If the guide is currently displayed, this button tells the guide to display the next day's content. */ Key["GuideNextDay"] = "GuideNextDay";
    /** If the guide is currently displayed, this button tells the guide to display the previous day's content. */ Key["GuidePreviousDay"] = "GuidePreviousDay";
    /** Toggles the display of information about the currently selected content, program, or media. */ Key["Info"] = "Info";
    /** Tellls the device to perform an instant replay (typically some form of jumping back a short amount of time then playing it again, possibly but not usually in slow motion). */ Key["InstantReplay"] = "InstantReplay";
    /** Opens content liniked to the current program, if available and possible. */ Key["Link"] = "Link";
    /** Lists the current program. */ Key["ListProgram"] = "ListProgram";
    /** Toggles a display listing currently available live content or programs. */ Key["LiveContent"] = "LiveContent";
    /** Locks or unlocks the currently selected content or pgoram. */ Key["Lock"] = "Lock";
    /** Presents a list of media applications, such as photo viewers, audio and video players, and games. [1] */ Key["MediaApps"] = "MediaApps";
    /** The Audio Track key. */ Key["MediaAudioTrack"] = "MediaAudioTrack";
    /** Jumps back to the last-viewed content, program, or other media. */ Key["MediaLast"] = "MediaLast";
    /** Skips backward to the previous content or program. */ Key["MediaSkipBackward"] = "MediaSkipBackward";
    /** Skips forward to the next content or program. */ Key["MediaSkipForward"] = "MediaSkipForward";
    /** Steps backward to the previous content or program. */ Key["MediaStepBackward"] = "MediaStepBackward";
    /** Steps forward to the next content or program. */ Key["MediaStepForward"] = "MediaStepForward";
    /** Top Menu button; opens the media's main menu, such as on a DVD or Blu-Ray disc. */ Key["MediaTopMenu"] = "MediaTopMenu";
    /** Navigates into a submenu or option. */ Key["NavigateIn"] = "NavigateIn";
    /** Navigates to the next item. */ Key["NavigateNext"] = "NavigateNext";
    /** Navigates out of the current screen or menu. */ Key["NavigateOut"] = "NavigateOut";
    /** Navigates to the previous item. */ Key["NavigatePrevious"] = "NavigatePrevious";
    /** Cycles to the next channel in the favorites list. */ Key["NextFavoriteChannel"] = "NextFavoriteChannel";
    /** Cycles to the next saved user profile, if this feature is supported and multiple profiles exist. */ Key["NextUserProfile"] = "NextUserProfile";
    /** Opens the user interface for selecting on demand content or programs to watch. */ Key["OnDemand"] = "OnDemand";
    /** Starts the process of pairing the remote with a device to be controlled. */ Key["Pairing"] = "Pairing";
    /** A button to move the picture-in-picture view downward. */ Key["PinPDown"] = "PinPDown";
    /** A button to control moving the picture-in-picture view. */ Key["PinPMove"] = "PinPMove";
    /** Toggles display of th epicture-in-picture view on and off. */ Key["PinPToggle"] = "PinPToggle";
    /** A button to move the picture-in-picture view upward. */ Key["PinPUp"] = "PinPUp";
    /** Decreases the media playback rate. */ Key["PlaySpeedDown"] = "PlaySpeedDown";
    /** Returns the media playback rate to normal. */ Key["PlaySpeedReset"] = "PlaySpeedReset";
    /** Increases the media playback rate. */ Key["PlaySpeedUp"] = "PlaySpeedUp";
    /** Toggles random media (also known as "shuffle mode") on and off. */ Key["RandomToggle"] = "RandomToggle";
    /** A code sent when the remote control's battery is low. This doesn't actually correspond to a physical key at all. */ Key["RcLowBattery"] = "RcLowBattery";
    /** Cycles among the available media recording speeds. */ Key["RecordSpeedNext"] = "RecordSpeedNext";
    /** Toggles radio frequency (RF) input bypass mode on and off. RF bypass mode passes RF input directly to the RF output without any processing or filtering. */ Key["RfBypass"] = "RfBypass";
    /** Toggles the channel scan mode on and off; this is a mode which flips through channels automatically until the user stops the scan. */ Key["ScanChannelsToggle"] = "ScanChannelsToggle";
    /** Cycles through the available screen display modes. */ Key["ScreenModeNext"] = "ScreenModeNext";
    /** Toggles display of the device's settings screen on and off. */ Key["Settings"] = "Settings";
    /** Toggles split screen display mode on and off. */ Key["SplitScreenToggle"] = "SplitScreenToggle";
    /** Cycles among input modes on an external set-top box (STB). */ Key["STBInput"] = "STBInput";
    /** Toggles on and off an external STB. */ Key["STBPower"] = "STBPower";
    /** Toggles the display of subtitles on and off if they're available. */ Key["Subtitle"] = "Subtitle";
    /** Toggles display of teletext, if available. */ Key["Teletext"] = "Teletext";
    /** Cycles through the available video modes. */ Key["VideoModeNext"] = "VideoModeNext";
    /** Causes the device to identify itself in some fashion, such as by flashing a light, briefly changing the brightness of indicator lights, or emitting a tone. */ Key["Wink"] = "Wink";
    /** Toggles between full-screen and scaled content display, or otherwise change the magnification level. */ Key["ZoomToggle"] = "ZoomToggle";
    /** Presents a list of possible corrections for a word which was incorrectly identified. */ Key["SpeechCorrectionList"] = "SpeechCorrectionList";
    /** Toggles between dictation mode and command/control mode. This lets the speech engine know whether to interpret spoken words as input text or as commands. */ Key["SpeechInputToggle"] = "SpeechInputToggle";
    /** Closes the current document or message. Must not exit the application. */ Key["Close"] = "Close";
    /** Creates a new document or message. */ Key["New"] = "New";
    /** Opens an existing document or message. */ Key["Open"] = "Open";
    /** Prints the current document or message. */ Key["Print"] = "Print";
    /** Saves the current document or message. */ Key["Save"] = "Save";
    /** Starts spell checking the current document. */ Key["SpellCheck"] = "SpellCheck";
    /** Opens the user interface to forward a message. */ Key["MailForward"] = "MailForward";
    /** Opens the user interface to reply to a message. */ Key["MailReply"] = "MailReply";
    /** Sends the current message. */ Key["MailSend"] = "MailSend";
    /** The Calculator key, often labeled with an icon such as . This is often used as a generic application launcher key (APPCOMMAND_LAUNCH_APP2). */ Key["LaunchCalculator"] = "LaunchCalculator";
    /** The Calendar key, often labeled with an icon like . */ Key["LaunchCalendar"] = "LaunchCalendar";
    /** The Contacts key. */ Key["LaunchContacts"] = "LaunchContacts";
    /** The Mail key. This is often displayed as . */ Key["LaunchMail"] = "LaunchMail";
    /** The Media Player key. */ Key["LaunchMediaPlayer"] = "LaunchMediaPlayer";
    /** The Music Player key, often labeled with an icon such as . */ Key["LaunchMusicPlayer"] = "LaunchMusicPlayer";
    /** The My Computer key on Windows keyboards. This is often used as a generic application launcher key (APPCOMMAND_LAUNCH_APP1). */ Key["LaunchMyComputer"] = "LaunchMyComputer";
    /** The Phone key, to open the phone dialer application if one is present. */ Key["LaunchPhone"] = "LaunchPhone";
    /** The Screen Saver key. */ Key["LaunchScreenSaver"] = "LaunchScreenSaver";
    /** The Spreadsheet key. This key may be labeled with an icon such as  or that of a specific spreadsheet application. */ Key["LaunchSpreadsheet"] = "LaunchSpreadsheet";
    /** The Web Browser key. This key is frequently labeled with an icon such as  or the icon of a specific browser, depending on the device manufacturer. */ Key["LaunchWebBrowser"] = "LaunchWebBrowser";
    /** The WebCam key. Opens the webcam application. */ Key["LaunchWebCam"] = "LaunchWebCam";
    /** The Word Processor key. This may be an icon of a specific word processor application, or a generic document icon. */ Key["LaunchWordProcessor"] = "LaunchWordProcessor";
    /** The first generic application launcher button. */ Key["LaunchApplication1"] = "LaunchApplication1";
    /** The second generic application launcher button. */ Key["LaunchApplication2"] = "LaunchApplication2";
    /** The third generic application launcher button. */ Key["LaunchApplication3"] = "LaunchApplication3";
    /** The fourth generic application launcher button. */ Key["LaunchApplication4"] = "LaunchApplication4";
    /** The fifth generic application launcher button. */ Key["LaunchApplication5"] = "LaunchApplication5";
    /** The sixth generic application launcher button. */ Key["LaunchApplication6"] = "LaunchApplication6";
    /** The seventh generic application launcher button. */ Key["LaunchApplication7"] = "LaunchApplication7";
    /** The eighth generic application launcher button. */ Key["LaunchApplication8"] = "LaunchApplication8";
    /** The ninth generic application launcher button. */ Key["LaunchApplication9"] = "LaunchApplication9";
    /** The 10th generic application launcher button. */ Key["LaunchApplication10"] = "LaunchApplication10";
    /** The 11th generic application launcher button. */ Key["LaunchApplication11"] = "LaunchApplication11";
    /** The 12th generic application launcher button. */ Key["LaunchApplication12"] = "LaunchApplication12";
    /** The 13th generic application launcher button. */ Key["LaunchApplication13"] = "LaunchApplication13";
    /** The 14th generic application launcher button. */ Key["LaunchApplication14"] = "LaunchApplication14";
    /** The 15th generic application launcher button. */ Key["LaunchApplication15"] = "LaunchApplication15";
    /** The 16th generic application launcher button. */ Key["LaunchApplication16"] = "LaunchApplication16";
    /** Navigates to the previous content or page in the current Web view's history. */ Key["BrowserBack"] = "BrowserBack";
    /** Opens the user's list of bookmarks/favorites. */ Key["BrowserFavorites"] = "BrowserFavorites";
    /** Navigates to the next content or page in the current Web view's history. */ Key["BrowserForward"] = "BrowserForward";
    /** Navigates to the user's preferred home page. */ Key["BrowserHome"] = "BrowserHome";
    /** Refreshes the current page or contentl. */ Key["BrowserRefresh"] = "BrowserRefresh";
    /** Activates the user's preferred search engine or the search interface within their browser. */ Key["BrowserSearch"] = "BrowserSearch";
    /** Stops loading the currently displayed Web view or content. */ Key["BrowserStop"] = "BrowserStop";
    /** The decimal point key (typically . or , depending on the region. In newer browsers, this value to simply be the character generated by the decimal key (one of those two characters). [1] */ Key["Decimal"] = "Decimal";
    /** The 11 key found on certain media numeric keypads. */ Key["Key11"] = "Key11";
    /** The 12 key found on certain media numeric keypads. */ Key["Key12"] = "Key12";
    /** The numeric keypad's multiplication key, *. */ Key["Multiply"] = "Multiply";
    /** The numeric keypad's addition key, +. */ Key["Add"] = "Add";
    /** The numeric keypad's division key, /. */ Key["Divide"] = "Divide";
    /** The numeric keypad's subtraction key, -. */ Key["Subtract"] = "Subtract";
    /** The numeric keypad's places separator character (in the United States, this is a comma, but elsewhere it is frequently a period). */ Key["Separator"] = "Separator";
})($83aeb96f47fc070f$export$cd0f44441c3b7719 || ($83aeb96f47fc070f$export$cd0f44441c3b7719 = {}));



var $652e6cb51d594b1d$export$25e50d252a728e80;
(function(VanillaReaderNavigationType) {
    VanillaReaderNavigationType["GOTO"] = "vanillareader_navigationtype_goto";
    VanillaReaderNavigationType["TIMELINEPOSITION"] = "vanillareader_navigationtype_timelineposition";
    VanillaReaderNavigationType["GOTOSTART"] = "vanillareader_navigationtype_gotostart";
    VanillaReaderNavigationType["NEXT"] = "vanillareader_navigationtype_next";
    VanillaReaderNavigationType["PREVIOUS"] = "vanillareader_navigationtype_previous";
    VanillaReaderNavigationType["EXTERNAL"] = "vanillareader_navigationtype_external";
})($652e6cb51d594b1d$export$25e50d252a728e80 || ($652e6cb51d594b1d$export$25e50d252a728e80 = {}));
var $652e6cb51d594b1d$export$7ef357ac666ee52;
(function(VanillaReaderRendererNames) {
    VanillaReaderRendererNames["RESPONSIVE"] = "__responsive__";
    VanillaReaderRendererNames["FLIPBOOK"] = "FlipBookRenderer";
    VanillaReaderRendererNames["STACK"] = "StackRenderer";
    VanillaReaderRendererNames["SCROLL"] = "SingleDocumentScrollRenderer";
    VanillaReaderRendererNames["SWIPE_SINGLE"] = "SinglePageSwipeRenderer";
    VanillaReaderRendererNames["SWIPE_SPREAD"] = "SpreadSwipeRenderer";
})($652e6cb51d594b1d$export$7ef357ac666ee52 || ($652e6cb51d594b1d$export$7ef357ac666ee52 = {}));
var $652e6cb51d594b1d$export$c4f812898744dac4;
(function(VanillaReaderPublicationLandmarkTypeNote) {
    VanillaReaderPublicationLandmarkTypeNote["FOOTNOTE"] = "FOOTNOTE";
    VanillaReaderPublicationLandmarkTypeNote["REARNOTE"] = "REARNOTE";
    VanillaReaderPublicationLandmarkTypeNote["ENDNOTE"] = "ENDNOTE";
})($652e6cb51d594b1d$export$c4f812898744dac4 || ($652e6cb51d594b1d$export$c4f812898744dac4 = {}));
var $652e6cb51d594b1d$export$87e364cacb5e9f8f;
(function(VanillaReaderPublicationLandmarkType) {
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["ASIDE"] = (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).ASIDE] = "ASIDE";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["ARTICLE"] = (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).ARTICLE] = "ARTICLE";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["FIGURE"] = (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).FIGURE] = "FIGURE";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["TABLE"] = (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).TABLE] = "TABLE";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["SECTION"] = (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).SECTION] = "SECTION";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["DESCRIPTION_LIST"] = (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).DESCRIPTION_LIST] = "DESCRIPTION_LIST";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["ORDERED_LIST"] = (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).ORDERED_LIST] = "ORDERED_LIST";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["UNORDERED_LIST"] = (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).UNORDERED_LIST] = "UNORDERED_LIST";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["IMAGE"] = (0, $f8f5cf2c043414f4$export$dfc5e1a852a6126b).IMAGE] = "IMAGE";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["AUDIO"] = (0, $f8f5cf2c043414f4$export$dfc5e1a852a6126b).AUDIO] = "AUDIO";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["VIDEO"] = (0, $f8f5cf2c043414f4$export$dfc5e1a852a6126b).VIDEO] = "VIDEO";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["HEADING1"] = (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING1] = "HEADING1";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["HEADING2"] = (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING2] = "HEADING2";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["HEADING3"] = (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING3] = "HEADING3";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["HEADING4"] = (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING4] = "HEADING4";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["HEADING5"] = (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING5] = "HEADING5";
    VanillaReaderPublicationLandmarkType[VanillaReaderPublicationLandmarkType["HEADING6"] = (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING6] = "HEADING6";
    VanillaReaderPublicationLandmarkType["FOOTNOTE"] = "FOOTNOTE";
    VanillaReaderPublicationLandmarkType["REARNOTE"] = "REARNOTE";
    VanillaReaderPublicationLandmarkType["ENDNOTE"] = "ENDNOTE";
})($652e6cb51d594b1d$export$87e364cacb5e9f8f || ($652e6cb51d594b1d$export$87e364cacb5e9f8f = {}));
var $652e6cb51d594b1d$export$5eef632beec47929;
(function(VanillaReaderPaginationType) {
    VanillaReaderPaginationType["SECTIONS"] = "sections";
    VanillaReaderPaginationType["PAGE_LIST"] = "pagelist";
    VanillaReaderPaginationType["SYNTHETIC"] = "synthetic";
    VanillaReaderPaginationType["ESTIMATED"] = "estimated";
})($652e6cb51d594b1d$export$5eef632beec47929 || ($652e6cb51d594b1d$export$5eef632beec47929 = {}));
var $652e6cb51d594b1d$export$588bd69d50f9b677;
(function(VanillaReaderSyntheticPaginationSegmentationMethod) {
    // All these codepoints are the ones in Unicode General_Category=Z (Zs | Zl | Zp) except FEFF
    VanillaReaderSyntheticPaginationSegmentationMethod["UNICODE_WHITESPACE_SEGMENTATION"] = "unicode_whitespace_segmentation";
    // https://unicode.org/reports/tr29/#Table_Word_Break_Property_Values
    VanillaReaderSyntheticPaginationSegmentationMethod["UNICODE_DEFAULT_WORD_BREAK_SEGMENTATION"] = "unicode_default_word_break_segmentation";
})($652e6cb51d594b1d$export$588bd69d50f9b677 || ($652e6cb51d594b1d$export$588bd69d50f9b677 = {}));


class $6c430f2d57d8d4ff$export$e84536440c3ffd38 {
    static{
        this.highlightColorValues = {
            red: "#FF8080",
            green: "#AFE9DD",
            blue: "#80B3FF",
            yellow: "#FFDD55"
        };
    }
    static{
        this.readingRulerColorValues = {
            transparent: "transparent",
            red: "#ffabab",
            green: "#AFE9DD",
            blue: "#bbd7ff",
            yellow: "#ffe39a"
        };
    }
    static{
        this.options = {
            publicationStyleOptions: {
                fontSizeScaleFactor: 1,
                lineHeightScaleFactor: 1.2,
                textAlignment: null,
                pageMargins: {
                    top: {
                        unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                        value: 6
                    },
                    bottom: {
                        unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                        value: 6
                    },
                    left: {
                        unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                        value: 8
                    },
                    right: {
                        unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                        value: 8
                    }
                }
            },
            dateCreated: undefined,
            showNarrationControls: false,
            useAccessibilityMode: false,
            ignoreAspectRatio: false,
            useReducedMotion: false,
            useDarkMode: false,
            activeRendererTypeName: (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE,
            activeUiPaletteName: "Dark",
            activePublicationFontSetName: "default",
            activePublicationPaletteName: "default",
            mediaPlayerPlaybackRate: 1,
            readingRulerOptions: {
                lineBoxBorderTopWidth: 4,
                lineBoxBorderTopColor: "rgba(0,0,0,0.6)",
                lineBoxBorderBottomWidth: 4,
                lineBoxBorderBottomColor: "rgba(0,0,0,0.6)",
                lineBoxBorderLeftWidth: 0,
                lineBoxBorderLeftColor: "transparent",
                lineBoxBorderRightWidth: 0,
                lineBoxBorderRightColor: "transparent",
                lineBoxMixBlendMode: (0, $d2c66ead28054c71$export$d297325fca76c218).NORMAL,
                lineBoxBackgroundColor: "#ffabab",
                lineBoxOpacity: 1,
                lineBoxMinHeight: 22,
                lineBoxMaxHeight: 128,
                lineBoxLineSpan: 3,
                lineBoxLineVerticalSpacing: 1.5,
                overlayBackgroundColor: "#ffffff",
                overlayOpacity: 0.8,
                overlayMixBlendMode: (0, $d2c66ead28054c71$export$d297325fca76c218).NORMAL,
                overlayIsVisible: true,
                rulerBorderTopWidth: 48,
                rulerBorderTopColor: "rgba(0,0,0,0.0)",
                rulerBorderBottomWidth: 48,
                rulerBorderBottomColor: "rgba(0,0,0,0.0)",
                rulerBorderLeftWidth: 0,
                rulerBorderLeftColor: "transparent",
                rulerBorderRightWidth: 0,
                rulerBorderRightColor: "transparent",
                rulerBackgroundColor: "transparent",
                rulerOpacity: 1,
                rulerMixBlendMode: (0, $d2c66ead28054c71$export$d297325fca76c218).MULTIPLY,
                rulerMinHeight: 128,
                rulerDragThreshold: 16,
                snapToLineBoxes: true
            },
            showPageNumbers: true,
            scrollOverflowingTables: false,
            uIActionKeyCommands: [
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT,
                    key: "ArrowRight",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS,
                    key: "ArrowLeft",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT,
                    key: "ArrowUp",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS,
                    key: "ArrowDown",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MAIN_MENU_OPEN,
                    key: "m",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_DIALOG_OPEN,
                    key: "s",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_CLEAR,
                    key: "S",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_READING_POSITION,
                    key: "b",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_CLIPBOARD,
                    key: "B",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).TOC_OPEN_DIALOG,
                    key: "c",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_DIALOG_OPEN,
                    key: "t",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_RESET,
                    key: "T",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKSHELF_DIALOG_OPEN,
                    key: "q",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION,
                    key: "x",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ALL,
                    key: "o",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ACTIVE,
                    key: "O",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ALL,
                    key: "h",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ACTIVE,
                    key: "H",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HELP_DIALOG_OPEN,
                    key: "F1",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HELP_DIALOG_OPEN,
                    key: "/",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_SELECTION,
                    key: "i",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_CLIPBOARD,
                    key: "I",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).WHERE_AM_I,
                    key: "w",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT_HEADING,
                    key: "g",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS_HEADING,
                    key: "G",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_START,
                    key: "r",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_STOP,
                    key: "R",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_SKIP_FORWARD,
                    key: "k",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_SKIP_BACKWARD,
                    key: "K",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_ESCAPE_ACTIVE_SEGMENT,
                    key: "a",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_ESCAPE_ALL,
                    key: "A",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_ENTER,
                    key: "z",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_EXIT,
                    key: "Z",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).GOTO_PAGE_DIALOG_OPEN,
                    key: "p",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACTIONS_MENU_OPEN,
                    key: "F2",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_IN,
                    key: "+",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_TOOL_ACTIVATE,
                    key: "?",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_OUT,
                    key: "-",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_TOOL_DEACTIVATE,
                    key: "_",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_ACTIVATE,
                    key: "u",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_DEACTIVATE,
                    key: "U",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_MOVE_PREVIOUS,
                    key: "<",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_MOVE_NEXT,
                    key: ">",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt,
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).LANDMARKS_DIALOG_OPEN,
                    key: "l",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                },
                {
                    actionName: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATION_HISTORY_DIALOG_OPEN,
                    key: "y",
                    modifiers: [
                        (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Alt
                    ]
                }
            ]
        };
    }
}



var $acQau = parcelRequire("acQau");
const { ContentDocumentFlowMode: $9b29a4abfb1f6cfd$export$fad795be4194f755, ContentDocumentLayout: $9b29a4abfb1f6cfd$export$b90993b519b61b8e, PageProgressionDirection: $9b29a4abfb1f6cfd$export$2df703bbd154f122, PageSpreadSlot: $9b29a4abfb1f6cfd$export$31e3bdb29bfb50d5, PublicationMetadataType: $9b29a4abfb1f6cfd$export$684ee4fde6f1e1f6, PublicationOrientation: $9b29a4abfb1f6cfd$export$54361f1e9bd773ce, PublicationType: $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43, SyntheticSpreadBehavior: $9b29a4abfb1f6cfd$export$3ef5819f18ba366a } = (0, (/*@__PURE__*/$parcel$interopDefault($acQau)));


class $98c664707733d94d$export$d4671a61002987ce {
    static isEpubReaderPublication(readerPublication) {
        return readerPublication.getSourcePublication().getType() === (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).EPUB;
    }
    static isPdfReaderPublication(readerPublication) {
        return readerPublication.getSourcePublication().getType() === (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).PDF;
    }
    static isWpAudiobookReaderPublication(readerPublication) {
        return readerPublication.getSourcePublication().getType() === (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).WP;
    }
}




class $bac0d168c44bc41a$export$d84b148792860613 extends (0, $6978732dc0bb5e4e$export$fc39a7efb817638a) {
    constructor(onConfigureUtterance){
        super(onConfigureUtterance);
    }
    get supportsWordBoundaries() {
        return true;
    }
    setActiveVoice(voice) {
        const voiceName = voice.name;
        this._activeVoice = this._ttsVoiceCollection?.allVoices.find((voice)=>voice.name === voiceName);
    }
    getActiveVoice() {
        return this._activeVoice;
    }
    async fetchVoices() {
        if (this._ttsVoiceCollection) return Promise.resolve(this._ttsVoiceCollection);
        this._ttsVoiceCollection = await (0, $410aa1fb5d04a699$export$aa8547013ca2283b).fetchTtsVoices();
        return this._ttsVoiceCollection;
    }
}



class $69e0beaac038bdf1$export$768bbf8f69747591 {
    constructor(_vanillaReaderView, _vanillaReaderSyncMediaOptions, _timelineCreationProgressCallback){
        this._vanillaReaderView = _vanillaReaderView;
        this._vanillaReaderSyncMediaOptions = _vanillaReaderSyncMediaOptions;
        this._timelineCreationProgressCallback = _timelineCreationProgressCallback;
        this.playerIsAttachedToView = false;
        this._colibrioReaderPublication = null;
        this._colibrioSyncMediaPlayer = null;
        this._colibrioSyncMediaTimeline = null;
        this._vanillaReaderPublication = null;
        this._escapableContentBlockTypes = [];
        this._escapabilityContext = [];
        this./*
    *
    * EVENT HANDLERS
    *
    * */ _onSyncMediaPlayerPaused = (_ev)=>{
            this._maybeDispatchPlaybackStateChangedEvent(_ev);
        };
        this._onSyncMediaPlayerPlay = (_ev)=>{
            this._maybeDispatchPlaybackStateChangedEvent(_ev);
        };
        this._onSyncMediaSegmentActive = async (ev)=>{
            let timelinePosition = ev.timelinePosition;
            let contentLocation = await ev.syncMediaPlayer.getTimeline().fetchContentLocation(timelinePosition);
            this._escapabilityContext = await this._getEscapabilityContextFromContentLocation(contentLocation);
            if (this._escapabilityContextChangedCallback) this._escapabilityContextChangedCallback(this._escapabilityContext);
            this._maybeDispatchPlaybackStateChangedEvent(ev);
        };
        this._onSyncMediaSegmentFinished = (ev)=>{
            this._maybeDispatchPlaybackStateChangedEvent(ev);
        };
        this._onRangePlaybackRemoved = (ev)=>{
            if (this._mediaPlayerRangePlaybackRangeRemovedCallback) this._fetchPlaybackStateData(ev).then((playbackState)=>{
                if (ev.playbackRange && this._mediaPlayerRangePlaybackRangeRemovedCallback) {
                    // The just canceled range was not available to the async `_fetchPlaybackStateData` so we need
                    // to set it here where we still have the event data.
                    playbackState.playbackRangeData = {
                        id: ev.playbackRange.id,
                        range: {
                            start: ev.playbackRange.range.start.toJSON(),
                            end: ev.playbackRange.range.end.toJSON()
                        }
                    };
                    this._mediaPlayerRangePlaybackRangeRemovedCallback(playbackState, ev.reason);
                }
            }).catch(console.warn);
        };
        this._onRangePlaybackEndReached = async (ev)=>{
            let playbackState = await this._fetchPlaybackStateData(ev);
            if (ev.playbackRange.options.removeRangeOnEndReached) {
                if (this._mediaPlayerRangePlaybackRangeRemovedCallback) {
                    // The just canceled range was not available to the async `_fetchPlaybackStateData` so we need
                    // to set it here where we still have the event data.
                    playbackState.playbackRangeData = {
                        id: ev.playbackRange.id,
                        range: {
                            start: ev.playbackRange.range.start.toJSON(),
                            end: ev.playbackRange.range.end.toJSON()
                        }
                    };
                    this._mediaPlayerRangePlaybackRangeRemovedCallback(playbackState);
                }
            }
            if (playbackState && this._mediaPlayerRangePlaybackEndReachedCallback) this._mediaPlayerRangePlaybackEndReachedCallback(playbackState);
        };
        this._colibrioReadingSystem = this._vanillaReaderView.colibrioReaderView.getReadingSystemEngine();
        this._vanillaReaderPublication = this._vanillaReaderView.getVanillaReaderPublication();
        this._ttsSynthesizer = this._vanillaReaderSyncMediaOptions?.webSpeechTtsSynthesizer;
        this._syncMediaTtsColibrioAnnotationLayer = this._vanillaReaderView.colibrioReaderView.createAnnotationLayer("syncmedia-tts-highlights");
        this._vanillaReaderRangePlaybackOptions = {
            rangeHighlightColor: this._vanillaReaderSyncMediaOptions?.rangePlaybackOptions?.rangeHighlightColor || (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.green,
            rangeHighlightVisible: this._vanillaReaderSyncMediaOptions?.rangePlaybackOptions?.rangeHighlightVisible || true
        };
    }
    get escapabilityContext() {
        return this._escapabilityContext;
    }
    onEscapabilityContextChanged(callback) {
        this._escapabilityContextChangedCallback = callback;
    }
    onCreated(callback) {
        this._createdCallback = callback;
    }
    onPlaybackStateChanged(callback) {
        this._mediaPlayerPlaybackStateChangedCallback = callback;
    }
    onRangePlaybackRemoved(callback) {
        this._mediaPlayerRangePlaybackRangeRemovedCallback = callback;
    }
    onRangePlaybackEndReached(callback) {
        this._mediaPlayerRangePlaybackEndReachedCallback = callback;
    }
    onAttached(callback) {
        this._attachedCallback = callback;
    }
    onDetached(callback) {
        this._detachedCallback = callback;
    }
    get activePlaybackRange() {
        return this._colibrioSyncMediaPlayer?.getPlaybackRange() || null;
    }
    attach() {
        if (this._colibrioSyncMediaPlayer) {
            this._vanillaReaderView.colibrioReaderView.setSyncMediaPlayer(this._colibrioSyncMediaPlayer);
            this._syncMediaTtsColibrioAnnotationLayer?.setVisible(true);
            this.playerIsAttachedToView = true;
            if (this._attachedCallback) this._attachedCallback();
        }
    }
    detach() {
        if (this._colibrioSyncMediaPlayer) {
            this._vanillaReaderView.colibrioReaderView.setSyncMediaPlayer(null);
            this._syncMediaTtsColibrioAnnotationLayer?.setVisible(false);
            this.playerIsAttachedToView = false;
            if (this._detachedCallback) this._detachedCallback();
        }
    }
    toggle(attach) {
        if (attach) this.attach();
        else this.detach();
    }
    play() {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.play();
    }
    pause() {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.pause();
    }
    playTimelineRange(timelineRange, options) {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) {
            let startPosition = new (0, $6978732dc0bb5e4e$export$4cbca0b50906dc0e)(this._colibrioSyncMediaPlayer.getTimeline(), timelineRange.start.segmentIndex, timelineRange.start.offsetWithinSegmentMs);
            let endPosition = new (0, $6978732dc0bb5e4e$export$4cbca0b50906dc0e)(this._colibrioSyncMediaPlayer.getTimeline(), timelineRange.end.segmentIndex, timelineRange.end.offsetWithinSegmentMs);
            options = options ? options : {
                pauseOnRangeRemoved: false,
                removeRangeOnEndReached: true,
                seekBehaviour: (0, $f8f5cf2c043414f4$export$47ac58310cdfef71).REMOVE_IF_OUTSIDE_RANGE
            };
            this._colibrioSyncMediaPlayer.setPlaybackRange({
                start: startPosition,
                end: endPosition
            }, options);
            this.play();
        }
    }
    async playLocatorRange(locator, options) {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) {
            let location = await this._vanillaReaderPublication?.getColibrioReaderPublication().fetchContentLocation(locator);
            if (!location) {
                console.warn("VanillaReaderMediaPlayer.playLocator(), Unable to fetch a valid content location");
                return;
            }
            let timeline = this._colibrioSyncMediaPlayer.getTimeline();
            let startPosition = await timeline.fetchTimelinePosition(location.collapseToStart());
            let endPosition = await timeline.fetchTimelinePosition(location.collapseToEnd());
            this.playTimelineRange({
                start: startPosition.toJSON(),
                end: endPosition.toJSON()
            }, options);
        }
    }
    cancelRangePlayback() {
        this._colibrioSyncMediaPlayer?.removePlaybackRange();
    }
    seekToNext() {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.seekToNextSegment(true);
    }
    seekToPrevious() {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.seekToPreviousSegment(true);
    }
    seekForward(offsetMs = 10000) {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.seekToApproximateTimeMs(this._colibrioSyncMediaPlayer.getApproximateElapsedTimeMs() + offsetMs);
    }
    seekBackward(offsetMs = 10000) {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.seekToApproximateTimeMs(this._colibrioSyncMediaPlayer.getApproximateElapsedTimeMs() - offsetMs);
    }
    seekToApproximateMs(ms) {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.seekToApproximateTimeMs(ms);
    }
    seekToPlaybackRangeStart() {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView && this.activePlaybackRange) this._colibrioSyncMediaPlayer.seekToTimelinePosition(this.activePlaybackRange.range.start);
    }
    setVolume(volume) {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.setVolume(volume);
    }
    setPlaybackRate(rate) {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) this._colibrioSyncMediaPlayer.setPlaybackRate(rate);
    }
    async setTtsVoiceByName(voiceName) {
        let voicesCollection = await this._ttsSynthesizer?.fetchVoices();
        let voices = voicesCollection?.allVoices;
        if (!voices || !voiceName) {
            this._ttsVoice = undefined;
            return;
        }
        this._ttsVoice = voices.find((voice)=>{
            return voice.name.includes(voiceName);
        });
        this._ttsSynthesizer?.setActiveVoice(this._ttsVoice);
    }
    async seekToLocatorWithinVisibleRange(locator) {
        const syncMediaPlayer = this._colibrioSyncMediaPlayer;
        let visibleRange = this._vanillaReaderView.getVisibleRange();
        if (syncMediaPlayer && this.playerIsAttachedToView && visibleRange) {
            let timeline = syncMediaPlayer.getTimeline();
            const visibleRangeStartTimelinePosition = await timeline.fetchTimelinePosition(visibleRange.collapseToStart());
            const pos = await timeline.fetchTimelinePosition(locator);
            const contentLocation = await timeline.fetchContentLocation(pos);
            if (visibleRange.contains(contentLocation)) {
                const posAtStartOfSegment = new (0, $6978732dc0bb5e4e$export$4cbca0b50906dc0e)(pos.getTimeline(), pos.getSegmentIndex(), 0);
                if (posAtStartOfSegment.isBefore(visibleRangeStartTimelinePosition)) syncMediaPlayer.seekToTimelinePosition(visibleRangeStartTimelinePosition);
                else syncMediaPlayer.seekToTimelinePosition(posAtStartOfSegment);
            }
        }
    }
    async seekToLocator(locator) {
        if (this._colibrioSyncMediaPlayer && this.playerIsAttachedToView) {
            const mediaPlayer = this._vanillaReaderView.colibrioReaderView.getSyncMediaPlayer();
            if (mediaPlayer && locator) {
                let timeline = mediaPlayer.getTimeline();
                let pos = await timeline.fetchTimelinePosition(locator);
                // Always seek to beginning of segment by setting offsetMs to 0
                let newPosition = new (0, $6978732dc0bb5e4e$export$4cbca0b50906dc0e)(pos.getTimeline(), pos.getSegmentIndex(), 0);
                mediaPlayer.seekToTimelinePosition(newPosition);
            }
        }
    }
    destroy() {}
    get isPaused() {
        if (this._colibrioSyncMediaPlayer) return this._colibrioSyncMediaPlayer.isPaused();
        return true;
    }
    getTtsPlaybackOptions() {
        return {
            rate: this._colibrioSyncMediaPlayer?.getPlaybackRate() || 1,
            volume: this._colibrioSyncMediaPlayer?.getVolume() || 1,
            highlightColor: this._vanillaReaderPublication?.ttsOptions?.highlightColor || (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow,
            voiceName: this._ttsVoice?.name
        };
    }
    getPlaybackOptions() {
        return {
            rate: this._colibrioSyncMediaPlayer?.getPlaybackRate() || 1,
            volume: this._colibrioSyncMediaPlayer?.getVolume() || 1,
            highlightColor: this._vanillaReaderPublication?.ttsOptions?.highlightColor || (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow
        };
    }
    getColibrioSyncMediaPlayerInstance() {
        return this._colibrioSyncMediaPlayer;
    }
    setEscapabableContentBlockTypes(blockTypes) {
        this._escapableContentBlockTypes = blockTypes;
    }
    async fetchTtsVoiceCollection() {
        let voicesCollection;
        if (this._ttsSynthesizer) voicesCollection = await this._ttsSynthesizer.fetchVoices();
        else voicesCollection = await (0, $410aa1fb5d04a699$export$aa8547013ca2283b).fetchTtsVoices();
        return voicesCollection;
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _initTtsAnnotationLayer() {
        // The TTS SyncMedia can use an annotation layer to highlight the current reading position. Let's set up
        // the layer and set the styling options for the layer and the highlight annotations.
        this._syncMediaTtsColibrioAnnotationLayer.setLayerOptions({
            layerStyle: {
                "mix-blend-mode": "multiply",
                opacity: "1"
            }
        });
        this._syncMediaTtsColibrioAnnotationLayer.setDefaultAnnotationOptions({
            rangeStyle: {
                "background-color": (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow,
                "opacity": "0.4"
            }
        });
    }
    _setUpEventHandlers() {}
    async create() {
        this._setUpEventHandlers();
        this._colibrioReaderPublication = this._vanillaReaderView.colibrioReaderView.getReaderPublications()[0];
        if (this._colibrioReaderPublication && ((0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(this._colibrioReaderPublication) || (0, $98c664707733d94d$export$d4671a61002987ce).isPdfReaderPublication(this._colibrioReaderPublication))) {
            // Let's see if this is publication has Media Overlays, if so we create a `IEpubMediaOverlaySyncMediaTimeline`
            if ((0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(this._colibrioReaderPublication) && this._colibrioReaderPublication.isMediaOverlaySyncMediaAvailable()) {
                let moOptions = {
                    defaultAudioRendererOptions: {
                        enableMediaStreaming: true
                    }
                };
                this._colibrioSyncMediaTimeline = await this._colibrioReaderPublication.createMediaOverlaySyncMediaTimeline(this._vanillaReaderView.colibrioReaderView.getReaderDocuments(), moOptions);
                this._colibrioSyncMediaPlayer = this._colibrioReadingSystem.createSyncMediaPlayer(this._colibrioSyncMediaTimeline, {
                    preloadAheadMs: 30000
                });
            } else {
                // This publication has no Media Overlay so let's create a TTS timeline instead.
                let wordHighlightEnabled = true;
                let highlightFirstWordOnSegmentActive = true;
                let voices;
                let voiceCollection;
                if (!this._ttsSynthesizer) {
                    // In order to use the correct `SpeechSynthesisVoice` instance as specified in the `VanillaReaderPublication`'s
                    // `ttsOptions.voiceName` string, we need to get all available voices.
                    voiceCollection = await (0, $410aa1fb5d04a699$export$aa8547013ca2283b).fetchTtsVoices();
                    voices = voiceCollection.allVoices;
                    // Now we filter out the matching `SpeechSynthesisVoice` instance.
                    this._ttsVoice = voices.find((voice)=>{
                        return this._vanillaReaderPublication?.ttsOptions?.voiceName ? voice.name.includes(this._vanillaReaderPublication.ttsOptions.voiceName) : false;
                    });
                    this._ttsSynthesizer = new (0, $bac0d168c44bc41a$export$d84b148792860613)((utterance, _utteranceAdditionalData)=>{
                        if (this._ttsVoice) {
                            utterance.lang = this._ttsVoice.lang;
                            utterance.voice = this._ttsVoice;
                        }
                    });
                } else voiceCollection = await this._ttsSynthesizer.fetchVoices();
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_VOICE_LIST_CHANGED", {
                    voiceCollection: voiceCollection
                }));
                if (!this._ttsSynthesizer.supportsWordBoundaries) {
                    wordHighlightEnabled = false;
                    highlightFirstWordOnSegmentActive = false;
                }
                this._initTtsAnnotationLayer();
                let syncMediaTimelineOptions = {
                    defaultTtsHighlightLayer: this._syncMediaTtsColibrioAnnotationLayer,
                    defaultTtsRendererOptions: {
                        highlightFirstWordOnSegmentActive: highlightFirstWordOnSegmentActive,
                        wordHighlightEnabled: wordHighlightEnabled,
                        segmentHighlightEnabled: true,
                        wordHighlightAnnotationOptions: {
                            rangeStyle: {
                                "filter": "brightness(1)",
                                "opacity": "1"
                            }
                        }
                    },
                    defaultTtsSynthesizer: this._ttsSynthesizer
                };
                // Now that we have the highlight layer set up we can create the SyncMedia Timeline.
                this._colibrioSyncMediaTimeline = await this._colibrioReaderPublication.createTtsSyncMediaTimeline(this._vanillaReaderView.colibrioReaderView.getReaderDocuments(), syncMediaTimelineOptions, this._timelineCreationProgressCallback);
                this._colibrioSyncMediaPlayer = this._colibrioReadingSystem.createSyncMediaPlayer(this._colibrioSyncMediaTimeline);
            }
            this.attach();
            this.playerIsAttachedToView = true;
            this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaRangeEndReached", this._onRangePlaybackEndReached);
            this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaRangeRemoved", this._onRangePlaybackRemoved);
            this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaPaused", this._onSyncMediaPlayerPaused);
            this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaPlay", this._onSyncMediaPlayerPlay);
            this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaSegmentActive", this._onSyncMediaSegmentActive);
            this._colibrioSyncMediaPlayer.addEngineEventListener("syncMediaSegmentFinished", this._onSyncMediaSegmentFinished);
            if (this._vanillaReaderSyncMediaOptions?.rate) this.setPlaybackRate(this._vanillaReaderSyncMediaOptions.rate);
            if (this._vanillaReaderSyncMediaOptions?.volume) this.setPlaybackRate(this._vanillaReaderSyncMediaOptions.volume);
            if (this._createdCallback) this._createdCallback();
        } else console.warn("VanillaReader.syncMediaPlayer_create()", "Cannot create SyncMediaPlayer. No Colibrio ReaderPublication loaded.");
    }
    async _fetchPlaybackStateData(ev) {
        if (!this._colibrioSyncMediaPlayer) throw new DOMException("VanillaReaderMediaPlayer: ColibrioSyncMediaPlayer instance does not exist");
        let positionMs = this._colibrioSyncMediaPlayer.getApproximateElapsedTimeMs() || 0;
        let position = this._colibrioSyncMediaPlayer.getTimelinePosition();
        let location;
        if (position) location = await this._colibrioSyncMediaPlayer.getTimeline()?.fetchContentLocation(position);
        let rate = this._colibrioSyncMediaPlayer.getPlaybackRate();
        let volume = this._colibrioSyncMediaPlayer.getVolume();
        let isSeeking = this._colibrioSyncMediaPlayer.isSeeking();
        let isMuted = this._colibrioSyncMediaPlayer.isMuted();
        let isPaused = this._colibrioSyncMediaPlayer.isPaused();
        let locator;
        let navigationItems = [];
        let navigationItemRefs;
        let segmentData = this._colibrioSyncMediaPlayer.getTimelinePosition().getSegment()?.toJSON();
        let segmentIndex = this._colibrioSyncMediaPlayer.getTimelinePosition().getSegmentIndex();
        let publicationDurationMs = this._colibrioSyncMediaPlayer.getTimeline().getApproximateDurationMs();
        let positionWithinSegment = this._colibrioSyncMediaPlayer.getTimelinePosition().getOffsetWithinSegmentMs();
        let playbackRange = this._colibrioSyncMediaPlayer.getPlaybackRange() || undefined;
        let segmentTimelineStartPosition;
        segmentTimelineStartPosition = this._colibrioSyncMediaTimeline ? new (0, $6978732dc0bb5e4e$export$4cbca0b50906dc0e)(this._colibrioSyncMediaTimeline, segmentIndex, 0) : undefined;
        if (segmentData && segmentTimelineStartPosition) segmentData.segmentTimelineStartOffsetMs = segmentTimelineStartPosition.getTimeline().getApproximateOffsetMs(segmentTimelineStartPosition);
        if (!this._currentActiveNavigationItems) {
            navigationItemRefs = await location?.fetchNavigationItemReferences({
                collectionTypes: [
                    (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC
                ],
                greedy: false
            });
            navigationItemRefs?.getItemsInRange()?.forEach((ref)=>{
                navigationItems.push({
                    locator: ref.getNavigationItem()?.getLocator()?.toString(),
                    children: [],
                    collectionType: ref.getNavigationCollection().getType(),
                    title: ref.getNavigationItem().getTextContent()
                });
            });
            // Store this value for upcoming calls. The `this._currentActiveNavigationItems` field is "reset" in the
            // `_event_segmentActive` event handler, when we have a new segment.
            this._currentActiveNavigationItems = navigationItems;
        } else navigationItems = this._currentActiveNavigationItems;
        if (location) locator = location?.getLocator().toString();
        const stateData = {
            type: ev.type,
            locator: locator,
            position: positionMs,
            positionWithinSegment: positionWithinSegment,
            navigationItems: navigationItems,
            rate: rate,
            volume: volume,
            isSeeking: isSeeking,
            isMuted: isMuted,
            isPaused: isPaused,
            segmentIndex: segmentIndex,
            segmentData: segmentData,
            publicationDurationMs: publicationDurationMs,
            playbackRangeData: playbackRange?.range.start && playbackRange.range.end ? {
                id: playbackRange.id,
                range: {
                    start: playbackRange.range.start.toJSON(),
                    end: playbackRange.range.end.toJSON()
                },
                options: {
                    pauseOnRangeCanceled: playbackRange.options.pauseOnRangeRemoved,
                    removeRangeOnEndReached: playbackRange.options.removeRangeOnEndReached,
                    seekBehaviour: playbackRange.options.seekBehaviour,
                    rangeHighlightVisible: this._vanillaReaderRangePlaybackOptions.rangeHighlightVisible,
                    rangeHighlightColor: this._vanillaReaderRangePlaybackOptions.rangeHighlightColor
                }
            } : undefined
        };
        return Promise.resolve(stateData);
    }
    _maybeDispatchPlaybackStateChangedEvent(_ev) {
        if (this._mediaPlayerPlaybackStateChangedCallback) this._fetchPlaybackStateData(_ev).then((state)=>{
            if (state && this._mediaPlayerPlaybackStateChangedCallback) this._mediaPlayerPlaybackStateChangedCallback(state);
        }).catch(console.warn);
    }
    async _getEscapabilityContextFromContentLocation(contentLocation) {
        let targets = await contentLocation.fetchContentBlockTargets((0, $f8f5cf2c043414f4$export$4d9b0aff04ca78b4).INTERSECTING);
        if (!targets || targets.length < 1) return [];
        let contentBlock = targets[0].getContentBlock();
        const __getNearestEscapableContentBlock = async (contentBlock, context)=>{
            if (this._escapableContentBlockTypes.includes(contentBlock.getBlockType())) context.push(contentBlock);
            let parentContentBlock = contentBlock.getParent();
            if (!parentContentBlock) return context;
            return __getNearestEscapableContentBlock(parentContentBlock, context);
        };
        let context = await __getNearestEscapableContentBlock(contentBlock, []);
        return context.map((block)=>{
            let blockLocation = block.getContentLocation();
            return {
                blockId: block.getId(),
                block: block,
                blockRangeLocation: blockLocation.createRangeTo(blockLocation.collapseToEnd())
            };
        }).reverse();
    }
}



/**
 *
 * UI Intents
 *
 * */ 
class $d708d48eab9f1a42$export$209340836e0e189 {
    constructor(_vanillaReader){
        this._vanillaReader = _vanillaReader;
        this._uiEvent_appWindowResized = (_ev)=>{
            this._vanillaReader.vanillaReaderView?.refresh();
        };
        /*
            * All the following events are dispatched by the `VanillaReaderUI` component. You can basically see this as a list
            * of all the main features that are offered by the reading app.
            * */ (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_WINDOW_RESIZED", this._uiEvent_appWindowResized);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_STORED_RESOURCES_DELETED", ()=>{});
    }
}




var $kj8wo = parcelRequire("kj8wo");
const { ZipResourceProvider: $20da6be62b58b032$export$b93701cceb925c09, ZipResourceProviderError: $20da6be62b58b032$export$1f191a24145035e4, ZipResourceProviderErrorType: $20da6be62b58b032$export$7f4d29b48ca8c654 } = (0, (/*@__PURE__*/$parcel$interopDefault($kj8wo)));




var $lrB5E = parcelRequire("lrB5E");
const { EpubAppleBooksOptionsPlatformType: $50771de7f4ce2444$export$d14433e075e24049, EpubPublicationError: $50771de7f4ce2444$export$7d256c35f6a59061, EpubPublicationErrorType: $50771de7f4ce2444$export$2f1063f75d63032f, EpubOcfResourceProvider: $50771de7f4ce2444$export$6cad6c1e494eabac, drm: $50771de7f4ce2444$export$d3e7fe978a081a15 } = (0, (/*@__PURE__*/$parcel$interopDefault($lrB5E)));



var $8v4lP = parcelRequire("8v4lP");
const { PdfPublication: $ecd9c96e15a01777$export$11db94ba744530e5, PdfPublicationError: $ecd9c96e15a01777$export$13dd426ffb9c09e6, PdfPublicationErrorType: $ecd9c96e15a01777$export$23b37d2ab3ebac53 } = (0, (/*@__PURE__*/$parcel$interopDefault($8v4lP)));



var $1dwvc = parcelRequire("1dwvc");
const { WpPublication: $7172dc67046a15e4$export$cb0ba341f61aba5e, WpPublicationError: $7172dc67046a15e4$export$dc033858bfc29ac8, WpPublicationErrorType: $7172dc67046a15e4$export$efed0187fbb4e3e0 } = (0, (/*@__PURE__*/$parcel$interopDefault($1dwvc)));



var $71281c9a3a3a369e$exports = {};
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";















(function(s, f) {
    if (0, $71281c9a3a3a369e$exports) $71281c9a3a3a369e$exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("hrxPB")), (parcelRequire("7uZag")), (parcelRequire("cLeaP")), (parcelRequire("csyWb")), (parcelRequire("kxrNj")), (parcelRequire("acQau")), (parcelRequire("lrB5E")), (parcelRequire("bkFGj")), (parcelRequire("9mLnx")), (parcelRequire("a75zb")), (parcelRequire("gWxKE")), (parcelRequire("7kECq")), (parcelRequire("9eVOO")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : $71281c9a3a3a369e$exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_io_resourcecache, __dep__colibrio_core_io_mediatypedetector, __dep__colibrio_core_encryption, __dep__colibrio_core_locator, __dep__colibrio_core_media, __dep__colibrio_core_publication_base, __dep__colibrio_core_publication_epub, __dep__colibrio_core_selector_base, __dep__colibrio_core_selector_epubcfi, __dep__colibrio_core_url, __dep__colibrio_core_xml, __dep__colibrio_readingsystem_base, __dep__colibrio_readingsystem_engine) {
    var __lib__timsort = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        (function(u) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = u() : "function" === typeof define && define.amd ? define([], u) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = u();
        })(function() {
            return (function() {
                function u(x, C, z) {
                    function y(r, t) {
                        if (!C[r]) {
                            if (!x[r]) {
                                var D = undefined;
                                if (!t && D) return D(r, !0);
                                if (A) return A(r, !0);
                                t = Error("Cannot find module '" + r + "'");
                                throw t.code = "MODULE_NOT_FOUND", t;
                            }
                            t = C[r] = {
                                exports: {}
                            };
                            x[r][0].call(t.exports, function(F) {
                                return y(x[r][1][F] || F);
                            }, t, t.exports, u, x, C, z);
                        }
                        return C[r].exports;
                    }
                    for(var A = undefined, E = 0; E < z.length; E++)y(z[E]);
                    return y;
                }
                return u;
            })()({
                1: [
                    function(u, x, C) {
                        (function(z, y) {
                            if ("undefined" !== typeof C) y(C);
                            else {
                                var A = {};
                                y(A);
                                z.timsort = A;
                            }
                        })(void 0, function(z) {
                            function y(g) {
                                return 1E5 > g ? 100 > g ? 10 > g ? 0 : 1 : 1E4 > g ? 1E3 > g ? 2 : 3 : 4 : 1E7 > g ? 1E6 > g ? 5 : 6 : 1E9 > g ? 1E8 > g ? 7 : 8 : 9;
                            }
                            function A(g, a) {
                                if (g === a) return 0;
                                if (~~g === g && ~~a === a) {
                                    if (0 === g || 0 === a) return g < a ? -1 : 1;
                                    if (0 > g || 0 > a) {
                                        if (0 <= a) return -1;
                                        if (0 <= g) return 1;
                                        g = -g;
                                        a = -a;
                                    }
                                    var h = y(g), c = y(a), e = 0;
                                    h < c ? (g *= G[c - h - 1], a /= 10, e = -1) : h > c && (a *= G[h - c - 1], g /= 10, e = 1);
                                    return g === a ? e : g < a ? -1 : 1;
                                }
                                g = String(g);
                                a = String(a);
                                return g === a ? 0 : g < a ? -1 : 1;
                            }
                            function E(g, a, h, c) {
                                var e = a + 1;
                                if (e === h) return 1;
                                if (0 > c(g[e++], g[a])) {
                                    for(; e < h && 0 > c(g[e], g[e - 1]);)e++;
                                    h = a;
                                    c = e;
                                    for(c--; h < c;){
                                        var k = g[h];
                                        g[h++] = g[c];
                                        g[c--] = k;
                                    }
                                } else for(; e < h && 0 <= c(g[e], g[e - 1]);)e++;
                                return e - a;
                            }
                            function r(g, a, h, c, e) {
                                for(c === a && c++; c < h; c++){
                                    for(var k = g[c], d = a, b = c; d < b;){
                                        var f = d + b >>> 1;
                                        0 > e(k, g[f]) ? b = f : d = f + 1;
                                    }
                                    b = c - d;
                                    switch(b){
                                        case 3:
                                            g[d + 3] = g[d + 2];
                                        case 2:
                                            g[d + 2] = g[d + 1];
                                        case 1:
                                            g[d + 1] = g[d];
                                            break;
                                        default:
                                            for(; 0 < b;)g[d + b] = g[d + b - 1], b--;
                                    }
                                    g[d] = k;
                                }
                            }
                            function t(g, a, h, c, e, k) {
                                var d = 0, b = 1;
                                if (0 < k(g, a[h + e])) {
                                    for(c -= e; b < c && 0 < k(g, a[h + e + b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    d += e;
                                    b += e;
                                } else {
                                    for(c = e + 1; b < c && 0 >= k(g, a[h + e - b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    c = d;
                                    d = e - b;
                                    b = e - c;
                                }
                                for(d++; d < b;)e = d + (b - d >>> 1), 0 < k(g, a[h + e]) ? d = e + 1 : b = e;
                                return b;
                            }
                            function D(g, a, h, c, e, k) {
                                var d = 0, b = 1;
                                if (0 > k(g, a[h + e])) {
                                    for(c = e + 1; b < c && 0 > k(g, a[h + e - b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    c = d;
                                    d = e - b;
                                    b = e - c;
                                } else {
                                    for(c -= e; b < c && 0 <= k(g, a[h + e + b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    d += e;
                                    b += e;
                                }
                                for(d++; d < b;)e = d + (b - d >>> 1), 0 > k(g, a[h + e]) ? b = e : d = e + 1;
                                return b;
                            }
                            z.__esModule = !0;
                            z.sort = function(g, a, h, c) {
                                if (!Array.isArray(g)) throw new TypeError("Can only sort arrays");
                                a ? "function" !== typeof a && (c = h, h = a, a = A) : a = A;
                                h || (h = 0);
                                c || (c = g.length);
                                var e = c - h;
                                if (!(2 > e)) {
                                    if (e < F) {
                                        var k = E(g, h, c, a);
                                        r(g, h, c, h + k, a);
                                    } else {
                                        var d = new H(g, a), b;
                                        k = e;
                                        for(b = 0; k >= F;)b |= k & 1, k >>= 1;
                                        b = k + b;
                                        do {
                                            k = E(g, h, c, a);
                                            if (k < b) {
                                                var f = e;
                                                f > b && (f = b);
                                                r(g, h, h + f, h + k, a);
                                                k = f;
                                            }
                                            d.pushRun(h, k);
                                            d.mergeRuns();
                                            e -= k;
                                            h += k;
                                        }while (0 !== e);
                                        d.forceMergeRuns();
                                    }
                                }
                            };
                            var F = 32, G = [
                                1,
                                10,
                                100,
                                1E3,
                                1E4,
                                1E5,
                                1E6,
                                1E7,
                                1E8,
                                1E9
                            ], H = function() {
                                function g(a, h) {
                                    if (!(this instanceof g)) throw new TypeError("Cannot call a class as a function");
                                    this.compare = this.array = null;
                                    this.minGallop = 7;
                                    this.length = 0;
                                    this.tmpStorageLength = 256;
                                    this.stackLength = 0;
                                    this.runLength = this.runStart = null;
                                    this.stackSize = 0;
                                    this.array = a;
                                    this.compare = h;
                                    this.length = a.length;
                                    512 > this.length && (this.tmpStorageLength = this.length >>> 1);
                                    this.tmp = Array(this.tmpStorageLength);
                                    this.stackLength = 120 > this.length ? 5 : 1542 > this.length ? 10 : 119151 > this.length ? 19 : 40;
                                    this.runStart = Array(this.stackLength);
                                    this.runLength = Array(this.stackLength);
                                }
                                g.prototype.pushRun = function(a, h) {
                                    this.runStart[this.stackSize] = a;
                                    this.runLength[this.stackSize] = h;
                                    this.stackSize += 1;
                                };
                                g.prototype.mergeRuns = function() {
                                    for(; 1 < this.stackSize;){
                                        var a = this.stackSize - 2;
                                        if (1 <= a && this.runLength[a - 1] <= this.runLength[a] + this.runLength[a + 1] || 2 <= a && this.runLength[a - 2] <= this.runLength[a] + this.runLength[a - 1]) this.runLength[a - 1] < this.runLength[a + 1] && a--;
                                        else if (this.runLength[a] > this.runLength[a + 1]) break;
                                        this.mergeAt(a);
                                    }
                                };
                                g.prototype.forceMergeRuns = function() {
                                    for(; 1 < this.stackSize;){
                                        var a = this.stackSize - 2;
                                        0 < a && this.runLength[a - 1] < this.runLength[a + 1] && a--;
                                        this.mergeAt(a);
                                    }
                                };
                                g.prototype.mergeAt = function(a) {
                                    var h = this.compare, c = this.array, e = this.runStart[a], k = this.runLength[a], d = this.runStart[a + 1], b = this.runLength[a + 1];
                                    this.runLength[a] = k + b;
                                    a === this.stackSize - 3 && (this.runStart[a + 1] = this.runStart[a + 2], this.runLength[a + 1] = this.runLength[a + 2]);
                                    this.stackSize--;
                                    a = D(c[d], c, e, k, 0, h);
                                    e += a;
                                    k -= a;
                                    0 !== k && (b = t(c[e + k - 1], c, d, b, b - 1, h), 0 !== b && (k <= b ? this.mergeLow(e, k, d, b) : this.mergeHigh(e, k, d, b)));
                                };
                                g.prototype.mergeLow = function(a, h, c, e) {
                                    var k = this.compare, d = this.array, b = this.tmp, f;
                                    for(f = 0; f < h; f++)b[f] = d[a + f];
                                    var m = 0;
                                    d[a++] = d[c++];
                                    if (0 === --e) for(f = 0; f < h; f++)d[a + f] = b[m + f];
                                    else if (1 === h) {
                                        for(f = 0; f < e; f++)d[a + f] = d[c + f];
                                        d[a + e] = b[m];
                                    } else {
                                        for(var p = this.minGallop;;){
                                            var l = 0, n = 0, q = !1;
                                            do if (0 > k(d[c], b[m])) {
                                                if (d[a++] = d[c++], n++, l = 0, 0 === --e) {
                                                    q = !0;
                                                    break;
                                                }
                                            } else if (d[a++] = b[m++], l++, n = 0, 1 === --h) {
                                                q = !0;
                                                break;
                                            }
                                            while ((l | n) < p);
                                            if (q) break;
                                            do {
                                                l = D(d[c], b, m, h, 0, k);
                                                if (0 !== l) {
                                                    for(f = 0; f < l; f++)d[a + f] = b[m + f];
                                                    a += l;
                                                    m += l;
                                                    h -= l;
                                                    if (1 >= h) {
                                                        q = !0;
                                                        break;
                                                    }
                                                }
                                                d[a++] = d[c++];
                                                if (0 === --e) {
                                                    q = !0;
                                                    break;
                                                }
                                                n = t(b[m], d, c, e, 0, k);
                                                if (0 !== n) {
                                                    for(f = 0; f < n; f++)d[a + f] = d[c + f];
                                                    a += n;
                                                    c += n;
                                                    e -= n;
                                                    if (0 === e) {
                                                        q = !0;
                                                        break;
                                                    }
                                                }
                                                d[a++] = b[m++];
                                                if (1 === --h) {
                                                    q = !0;
                                                    break;
                                                }
                                                p--;
                                            }while (7 <= l || 7 <= n);
                                            if (q) break;
                                            0 > p && (p = 0);
                                            p += 2;
                                        }
                                        this.minGallop = p;
                                        1 > p && (this.minGallop = 1);
                                        if (1 === h) {
                                            for(f = 0; f < e; f++)d[a + f] = d[c + f];
                                            d[a + e] = b[m];
                                        } else {
                                            if (0 === h) throw Error("mergeLow preconditions were not respected");
                                            for(f = 0; f < h; f++)d[a + f] = b[m + f];
                                        }
                                    }
                                };
                                g.prototype.mergeHigh = function(a, h, c, e) {
                                    var k = this.compare, d = this.array, b = this.tmp, f;
                                    for(f = 0; f < e; f++)b[f] = d[c + f];
                                    var m = a + h - 1, p = e - 1;
                                    c = c + e - 1;
                                    d[c--] = d[m--];
                                    if (0 === --h) {
                                        var l = c - (e - 1);
                                        for(f = 0; f < e; f++)d[l + f] = b[f];
                                    } else if (1 === e) {
                                        c -= h;
                                        var n = c + 1;
                                        l = m - h + 1;
                                        for(f = h - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                        d[c] = b[p];
                                    } else {
                                        for(var q = this.minGallop;;){
                                            var v = 0, w = 0, B = !1;
                                            do if (0 > k(b[p], d[m])) {
                                                if (d[c--] = d[m--], v++, w = 0, 0 === --h) {
                                                    B = !0;
                                                    break;
                                                }
                                            } else if (d[c--] = b[p--], w++, v = 0, 1 === --e) {
                                                B = !0;
                                                break;
                                            }
                                            while ((v | w) < q);
                                            if (B) break;
                                            do {
                                                v = h - D(b[p], d, a, h, h - 1, k);
                                                if (0 !== v) {
                                                    c -= v;
                                                    m -= v;
                                                    h -= v;
                                                    n = c + 1;
                                                    l = m + 1;
                                                    for(f = v - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                                    if (0 === h) {
                                                        B = !0;
                                                        break;
                                                    }
                                                }
                                                d[c--] = b[p--];
                                                if (1 === --e) {
                                                    B = !0;
                                                    break;
                                                }
                                                w = e - t(d[m], b, 0, e, e - 1, k);
                                                if (0 !== w) {
                                                    c -= w;
                                                    p -= w;
                                                    e -= w;
                                                    n = c + 1;
                                                    l = p + 1;
                                                    for(f = 0; f < w; f++)d[n + f] = b[l + f];
                                                    if (1 >= e) {
                                                        B = !0;
                                                        break;
                                                    }
                                                }
                                                d[c--] = d[m--];
                                                if (0 === --h) {
                                                    B = !0;
                                                    break;
                                                }
                                                q--;
                                            }while (7 <= v || 7 <= w);
                                            if (B) break;
                                            0 > q && (q = 0);
                                            q += 2;
                                        }
                                        this.minGallop = q;
                                        1 > q && (this.minGallop = 1);
                                        if (1 === e) {
                                            c -= h;
                                            n = c + 1;
                                            l = m - h + 1;
                                            for(f = h - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                            d[c] = b[p];
                                        } else {
                                            if (0 === e) throw Error("mergeHigh preconditions were not respected");
                                            l = c - (e - 1);
                                            for(f = 0; f < e; f++)d[l + f] = b[f];
                                        }
                                    }
                                };
                                return g;
                            }();
                        });
                    },
                    {}
                ],
                2: [
                    function(u, x) {
                        x.exports = u("./build/timsort.js");
                    },
                    {
                        "./build/timsort.js": 1
                    }
                ],
                3: [
                    function(u, x) {
                        x.exports = u("timsort");
                    },
                    {
                        timsort: 2
                    }
                ]
            }, {}, [
                3
            ])(3);
        });
        return module1.exports;
    }();
    var __lib__webfontloader = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        var h = h || {};
        h.scope = {};
        h.arrayIteratorImpl = function(m) {
            var g = 0;
            return function() {
                return g < m.length ? {
                    done: !1,
                    value: m[g++]
                } : {
                    done: !0
                };
            };
        };
        h.arrayIterator = function(m) {
            return {
                next: h.arrayIteratorImpl(m)
            };
        };
        h.makeIterator = function(m) {
            var g = "undefined" != typeof Symbol && Symbol.iterator && m[Symbol.iterator];
            if (g) return g.call(m);
            if ("number" == typeof m.length) return h.arrayIterator(m);
            throw Error(String(m) + " is not an iterable or ArrayLike");
        };
        h.ASSUME_ES5 = !1;
        h.ASSUME_NO_NATIVE_MAP = !1;
        h.ASSUME_NO_NATIVE_SET = !1;
        h.SIMPLE_FROUND_POLYFILL = !1;
        h.ISOLATE_POLYFILLS = !1;
        h.FORCE_POLYFILL_PROMISE = !1;
        h.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1;
        h.getGlobal = function(m) {
            m = [
                "object" == typeof globalThis && globalThis,
                m,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var g = 0; g < m.length; ++g){
                var t = m[g];
                if (t && t.Math == Math) return t;
            }
            throw Error("Cannot find global object");
        };
        h.global = h.getGlobal(this);
        h.defineProperty = h.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(m, g, t) {
            if (m == Array.prototype || m == Object.prototype) return m;
            m[g] = t.value;
            return m;
        };
        h.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
        h.TRUST_ES6_POLYFILLS = !h.ISOLATE_POLYFILLS || h.IS_SYMBOL_NATIVE;
        h.polyfills = {};
        h.propertyToPolyfillSymbol = {};
        h.POLYFILL_PREFIX = "$jscp$";
        h.polyfill = function(m, g, t, q) {
            g && (h.ISOLATE_POLYFILLS ? h.polyfillIsolated(m, g, t, q) : h.polyfillUnisolated(m, g, t, q));
        };
        h.polyfillUnisolated = function(m, g) {
            var t = h.global;
            m = m.split(".");
            for(var q = 0; q < m.length - 1; q++){
                var u = m[q];
                if (!(u in t)) return;
                t = t[u];
            }
            m = m[m.length - 1];
            q = t[m];
            g = g(q);
            g != q && null != g && h.defineProperty(t, m, {
                configurable: !0,
                writable: !0,
                value: g
            });
        };
        h.polyfillIsolated = function(m, g, t) {
            var q = m.split(".");
            m = 1 === q.length;
            var u = q[0];
            u = !m && u in h.polyfills ? h.polyfills : h.global;
            for(var F = 0; F < q.length - 1; F++){
                var e = q[F];
                if (!(e in u)) return;
                u = u[e];
            }
            q = q[q.length - 1];
            t = h.IS_SYMBOL_NATIVE && "es6" === t ? u[q] : null;
            g = g(t);
            null != g && (m ? h.defineProperty(h.polyfills, q, {
                configurable: !0,
                writable: !0,
                value: g
            }) : g !== t && (void 0 === h.propertyToPolyfillSymbol[q] && (m = 1E9 * Math.random() >>> 0, h.propertyToPolyfillSymbol[q] = h.IS_SYMBOL_NATIVE ? h.global.Symbol(q) : h.POLYFILL_PREFIX + m + "$" + q), h.defineProperty(u, h.propertyToPolyfillSymbol[q], {
                configurable: !0,
                writable: !0,
                value: g
            })));
        };
        h.polyfill("Promise", function(m) {
            function g(e) {
                this.state_ = 0;
                this.result_ = void 0;
                this.onSettledCallbacks_ = [];
                this.isRejectionHandled_ = !1;
                var k = this.createResolveAndReject_();
                try {
                    e(k.resolve, k.reject);
                } catch (p) {
                    k.reject(p);
                }
            }
            function t() {
                this.batch_ = null;
            }
            function q(e) {
                return e instanceof g ? e : new g(function(k) {
                    k(e);
                });
            }
            if (m && (!(h.FORCE_POLYFILL_PROMISE || h.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION && "undefined" === typeof h.global.PromiseRejectionEvent) || !h.global.Promise || -1 === h.global.Promise.toString().indexOf("[native code]"))) return m;
            t.prototype.asyncExecute = function(e) {
                if (null == this.batch_) {
                    this.batch_ = [];
                    var k = this;
                    this.asyncExecuteFunction(function() {
                        k.executeBatch_();
                    });
                }
                this.batch_.push(e);
            };
            var u = h.global.setTimeout;
            t.prototype.asyncExecuteFunction = function(e) {
                u(e, 0);
            };
            t.prototype.executeBatch_ = function() {
                for(; this.batch_ && this.batch_.length;){
                    var e = this.batch_;
                    this.batch_ = [];
                    for(var k = 0; k < e.length; ++k){
                        var p = e[k];
                        e[k] = null;
                        try {
                            p();
                        } catch (v) {
                            this.asyncThrow_(v);
                        }
                    }
                }
                this.batch_ = null;
            };
            t.prototype.asyncThrow_ = function(e) {
                this.asyncExecuteFunction(function() {
                    throw e;
                });
            };
            g.prototype.createResolveAndReject_ = function() {
                function e(v) {
                    return function(A) {
                        p || (p = !0, v.call(k, A));
                    };
                }
                var k = this, p = !1;
                return {
                    resolve: e(this.resolveTo_),
                    reject: e(this.reject_)
                };
            };
            g.prototype.resolveTo_ = function(e) {
                if (e === this) this.reject_(new TypeError("A Promise cannot resolve to itself"));
                else if (e instanceof g) this.settleSameAsPromise_(e);
                else {
                    a: switch(typeof e){
                        case "object":
                            var k = null != e;
                            break a;
                        case "function":
                            k = !0;
                            break a;
                        default:
                            k = !1;
                    }
                    k ? this.resolveToNonPromiseObj_(e) : this.fulfill_(e);
                }
            };
            g.prototype.resolveToNonPromiseObj_ = function(e) {
                var k = void 0;
                try {
                    k = e.then;
                } catch (p) {
                    this.reject_(p);
                    return;
                }
                "function" == typeof k ? this.settleSameAsThenable_(k, e) : this.fulfill_(e);
            };
            g.prototype.reject_ = function(e) {
                this.settle_(2, e);
            };
            g.prototype.fulfill_ = function(e) {
                this.settle_(1, e);
            };
            g.prototype.settle_ = function(e, k) {
                if (0 != this.state_) throw Error("Cannot settle(" + e + ", " + k + "): Promise already settled in state" + this.state_);
                this.state_ = e;
                this.result_ = k;
                2 === this.state_ && this.scheduleUnhandledRejectionCheck_();
                this.executeOnSettledCallbacks_();
            };
            g.prototype.scheduleUnhandledRejectionCheck_ = function() {
                var e = this;
                u(function() {
                    if (e.notifyUnhandledRejection_()) {
                        var k = h.global.console;
                        "undefined" !== typeof k && k.error(e.result_);
                    }
                }, 1);
            };
            g.prototype.notifyUnhandledRejection_ = function() {
                if (this.isRejectionHandled_) return !1;
                var e = h.global.CustomEvent, k = h.global.Event, p = h.global.dispatchEvent;
                if ("undefined" === typeof p) return !0;
                "function" === typeof e ? e = new e("unhandledrejection", {
                    cancelable: !0
                }) : "function" === typeof k ? e = new k("unhandledrejection", {
                    cancelable: !0
                }) : (e = h.global.document.createEvent("CustomEvent"), e.initCustomEvent("unhandledrejection", !1, !0, e));
                e.promise = this;
                e.reason = this.result_;
                return p(e);
            };
            g.prototype.executeOnSettledCallbacks_ = function() {
                if (null != this.onSettledCallbacks_) {
                    for(var e = 0; e < this.onSettledCallbacks_.length; ++e)F.asyncExecute(this.onSettledCallbacks_[e]);
                    this.onSettledCallbacks_ = null;
                }
            };
            var F = new t;
            g.prototype.settleSameAsPromise_ = function(e) {
                var k = this.createResolveAndReject_();
                e.callWhenSettled_(k.resolve, k.reject);
            };
            g.prototype.settleSameAsThenable_ = function(e, k) {
                var p = this.createResolveAndReject_();
                try {
                    e.call(k, p.resolve, p.reject);
                } catch (v) {
                    p.reject(v);
                }
            };
            g.prototype.then = function(e, k) {
                function p(D, G) {
                    return "function" == typeof D ? function(J) {
                        try {
                            v(D(J));
                        } catch (K) {
                            A(K);
                        }
                    } : G;
                }
                var v, A, M = new g(function(D, G) {
                    v = D;
                    A = G;
                });
                this.callWhenSettled_(p(e, v), p(k, A));
                return M;
            };
            g.prototype.catch = function(e) {
                return this.then(void 0, e);
            };
            g.prototype.callWhenSettled_ = function(e, k) {
                function p() {
                    switch(v.state_){
                        case 1:
                            e(v.result_);
                            break;
                        case 2:
                            k(v.result_);
                            break;
                        default:
                            throw Error("Unexpected state: " + v.state_);
                    }
                }
                var v = this;
                null == this.onSettledCallbacks_ ? F.asyncExecute(p) : this.onSettledCallbacks_.push(p);
                this.isRejectionHandled_ = !0;
            };
            g.resolve = q;
            g.reject = function(e) {
                return new g(function(k, p) {
                    p(e);
                });
            };
            g.race = function(e) {
                return new g(function(k, p) {
                    for(var v = h.makeIterator(e), A = v.next(); !A.done; A = v.next())q(A.value).callWhenSettled_(k, p);
                });
            };
            g.all = function(e) {
                var k = h.makeIterator(e), p = k.next();
                return p.done ? q([]) : new g(function(v, A) {
                    function M(J) {
                        return function(K) {
                            D[J] = K;
                            G--;
                            0 == G && v(D);
                        };
                    }
                    var D = [], G = 0;
                    do D.push(void 0), G++, q(p.value).callWhenSettled_(M(D.length - 1), A), p = k.next();
                    while (!p.done);
                });
            };
            return g;
        }, "es6", "es3");
        (function(m) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = m() : "function" === typeof define && define.amd ? define([], m) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = m();
        })(function() {
            return (function() {
                function m(g, t, q) {
                    function u(k, p) {
                        if (!t[k]) {
                            if (!g[k]) {
                                var v = undefined;
                                if (!p && v) return v(k, !0);
                                if (F) return F(k, !0);
                                p = Error("Cannot find module '" + k + "'");
                                throw p.code = "MODULE_NOT_FOUND", p;
                            }
                            p = t[k] = {
                                exports: {}
                            };
                            g[k][0].call(p.exports, function(A) {
                                return u(g[k][1][A] || A);
                            }, p, p.exports, m, g, t, q);
                        }
                        return t[k].exports;
                    }
                    for(var F = undefined, e = 0; e < q.length; e++)u(q[e]);
                    return u;
                }
                return m;
            })()({
                1: [
                    function(m, g) {
                        (function() {
                            function t(a, b, c) {
                                return a.call.apply(a.bind, arguments);
                            }
                            function q(a, b, c) {
                                if (!a) throw Error();
                                if (2 < arguments.length) {
                                    var d = Array.prototype.slice.call(arguments, 2);
                                    return function() {
                                        var f = Array.prototype.slice.call(arguments);
                                        Array.prototype.unshift.apply(f, d);
                                        return a.apply(b, f);
                                    };
                                }
                                return function() {
                                    return a.apply(b, arguments);
                                };
                            }
                            function u(a, b, c) {
                                u = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? t : q;
                                return u.apply(null, arguments);
                            }
                            function F(a, b) {
                                this.a = a;
                                this.o = b || a;
                                this.c = this.o.document;
                            }
                            function e(a, b, c, d) {
                                b = a.c.createElement(b);
                                if (c) for(var f in c)c.hasOwnProperty(f) && ("style" == f ? b.style.cssText = c[f] : b.setAttribute(f, c[f]));
                                d && b.appendChild(a.c.createTextNode(d));
                                return b;
                            }
                            function k(a, b, c) {
                                (a = a.c.getElementsByTagName(b)[0]) || (a = document.documentElement);
                                a.insertBefore(c, a.lastChild);
                            }
                            function p(a) {
                                a.parentNode && a.parentNode.removeChild(a);
                            }
                            function v(a, b, c) {
                                b = b || [];
                                c = c || [];
                                for(var d = a.className.split(/\s+/), f = 0; f < b.length; f += 1){
                                    for(var l = !1, n = 0; n < d.length; n += 1)if (b[f] === d[n]) {
                                        l = !0;
                                        break;
                                    }
                                    l || d.push(b[f]);
                                }
                                b = [];
                                for(f = 0; f < d.length; f += 1){
                                    l = !1;
                                    for(n = 0; n < c.length; n += 1)if (d[f] === c[n]) {
                                        l = !0;
                                        break;
                                    }
                                    l || b.push(d[f]);
                                }
                                a.className = b.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
                            }
                            function A(a, b) {
                                a = a.className.split(/\s+/);
                                for(var c = 0, d = a.length; c < d; c++)if (a[c] == b) return !0;
                                return !1;
                            }
                            function M(a) {
                                return a.o.location.hostname || a.a.location.hostname;
                            }
                            function D(a, b, c) {
                                function d() {
                                    r && f && l && (r(n), r = null);
                                }
                                b = e(a, "link", {
                                    rel: "stylesheet",
                                    href: b,
                                    media: "all"
                                });
                                var f = !1, l = !0, n = null, r = c || null;
                                ra ? (b.onload = function() {
                                    f = !0;
                                    d();
                                }, b.onerror = function() {
                                    f = !0;
                                    n = Error("Stylesheet failed to load");
                                    d();
                                }) : setTimeout(function() {
                                    f = !0;
                                    d();
                                }, 0);
                                k(a, "head", b);
                            }
                            function G(a, b, c, d) {
                                var f = a.c.getElementsByTagName("head")[0];
                                if (f) {
                                    var l = e(a, "script", {
                                        src: b
                                    }), n = !1;
                                    l.onload = l.onreadystatechange = function() {
                                        n || this.readyState && "loaded" != this.readyState && "complete" != this.readyState || (n = !0, c && c(null), l.onload = l.onreadystatechange = null, "HEAD" == l.parentNode.tagName && f.removeChild(l));
                                    };
                                    f.appendChild(l);
                                    setTimeout(function() {
                                        n || (n = !0, c && c(Error("Script load timeout")));
                                    }, d || 5E3);
                                    return l;
                                }
                                return null;
                            }
                            function J() {
                                this.a = 0;
                                this.c = null;
                            }
                            function K(a) {
                                a.a++;
                                return function() {
                                    a.a--;
                                    W(a);
                                };
                            }
                            function X(a, b) {
                                a.c = b;
                                W(a);
                            }
                            function W(a) {
                                0 == a.a && a.c && (a.c(), a.c = null);
                            }
                            function Y(a) {
                                this.a = a || "-";
                            }
                            function H(a, b) {
                                this.c = a;
                                this.f = 4;
                                this.a = "n";
                                (a = (b || "n4").match(/^([nio])([1-9])$/i)) && (this.a = a[1], this.f = parseInt(a[2], 10));
                            }
                            function sa(a) {
                                return Z(a) + " " + (a.f + "00 300px ") + aa(a.c);
                            }
                            function aa(a) {
                                var b = [];
                                a = a.split(/,\s*/);
                                for(var c = 0; c < a.length; c++){
                                    var d = a[c].replace(/['"]/g, "");
                                    -1 != d.indexOf(" ") || /^\d/.test(d) ? b.push("'" + d + "'") : b.push(d);
                                }
                                return b.join(",");
                            }
                            function E(a) {
                                return a.a + a.f;
                            }
                            function Z(a) {
                                var b = "normal";
                                "o" === a.a ? b = "oblique" : "i" === a.a && (b = "italic");
                                return b;
                            }
                            function ta(a, b) {
                                this.c = a;
                                this.f = a.o.document.documentElement;
                                this.h = b;
                                this.a = new Y("-");
                                this.j = !1 !== b.events;
                                this.g = !1 !== b.classes;
                            }
                            function ua(a) {
                                a.g && v(a.f, [
                                    a.a.c("wf", "loading")
                                ]);
                                L(a, "loading");
                            }
                            function ba(a) {
                                if (a.g) {
                                    var b = A(a.f, a.a.c("wf", "active")), c = [], d = [
                                        a.a.c("wf", "loading")
                                    ];
                                    b || c.push(a.a.c("wf", "inactive"));
                                    v(a.f, c, d);
                                }
                                L(a, "inactive");
                            }
                            function L(a, b, c) {
                                if (a.j && a.h[b]) {
                                    if (c) a.h[b](c.c, E(c));
                                    else a.h[b]();
                                }
                            }
                            function va() {
                                this.c = {};
                            }
                            function wa(a, b, c) {
                                var d = [], f;
                                for(f in b)if (b.hasOwnProperty(f)) {
                                    var l = a.c[f];
                                    l && d.push(l(b[f], c));
                                }
                                return d;
                            }
                            function N(a, b) {
                                this.c = a;
                                this.f = b;
                                this.a = e(this.c, "span", {
                                    "aria-hidden": "true"
                                }, this.f);
                            }
                            function O(a) {
                                k(a.c, "body", a.a);
                            }
                            function P(a) {
                                return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + aa(a.c) + ";font-style:" + (Z(a) + ";font-weight:" + (a.f + "00;"));
                            }
                            function ca(a, b, c, d, f, l) {
                                this.g = a;
                                this.j = b;
                                this.a = d;
                                this.c = c;
                                this.f = f || 3E3;
                                this.h = l || void 0;
                            }
                            function da(a, b, c, d, f, l, n) {
                                this.v = a;
                                this.B = b;
                                this.c = c;
                                this.a = d;
                                this.s = n || "BESbswy";
                                this.f = {};
                                this.w = f || 3E3;
                                this.u = l || null;
                                this.m = this.j = this.h = this.g = null;
                                this.g = new N(this.c, this.s);
                                this.h = new N(this.c, this.s);
                                this.j = new N(this.c, this.s);
                                this.m = new N(this.c, this.s);
                                a = new H(this.a.c + ",serif", E(this.a));
                                a = P(a);
                                this.g.a.style.cssText = a;
                                a = new H(this.a.c + ",sans-serif", E(this.a));
                                a = P(a);
                                this.h.a.style.cssText = a;
                                a = new H("serif", E(this.a));
                                a = P(a);
                                this.j.a.style.cssText = a;
                                a = new H("sans-serif", E(this.a));
                                a = P(a);
                                this.m.a.style.cssText = a;
                                O(this.g);
                                O(this.h);
                                O(this.j);
                                O(this.m);
                            }
                            function ea() {
                                if (null === T) {
                                    var a = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
                                    T = !!a && (536 > parseInt(a[1], 10) || 536 === parseInt(a[1], 10) && 11 >= parseInt(a[2], 10));
                                }
                                return T;
                            }
                            function fa(a, b, c) {
                                for(var d in Q)if (Q.hasOwnProperty(d) && b === a.f[Q[d]] && c === a.f[Q[d]]) return !0;
                                return !1;
                            }
                            function ha(a) {
                                var b = a.g.a.offsetWidth, c = a.h.a.offsetWidth, d;
                                (d = b === a.f.serif && c === a.f["sans-serif"]) || (d = ea() && fa(a, b, c));
                                d ? R() - a.A >= a.w ? ea() && fa(a, b, c) && (null === a.u || a.u.hasOwnProperty(a.a.c)) ? U(a, a.v) : U(a, a.B) : xa(a) : U(a, a.v);
                            }
                            function xa(a) {
                                setTimeout(u(function() {
                                    ha(this);
                                }, a), 50);
                            }
                            function U(a, b) {
                                setTimeout(u(function() {
                                    p(this.g.a);
                                    p(this.h.a);
                                    p(this.j.a);
                                    p(this.m.a);
                                    b(this.a);
                                }, a), 0);
                            }
                            function V(a, b, c) {
                                this.c = a;
                                this.a = b;
                                this.f = 0;
                                this.m = this.j = !1;
                                this.s = c;
                            }
                            function ia(a) {
                                0 == --a.f && a.j && (a.m ? (a = a.a, a.g && v(a.f, [
                                    a.a.c("wf", "active")
                                ], [
                                    a.a.c("wf", "loading"),
                                    a.a.c("wf", "inactive")
                                ]), L(a, "active")) : ba(a.a));
                            }
                            function ja(a) {
                                this.j = a;
                                this.a = new va;
                                this.h = 0;
                                this.f = this.g = !0;
                            }
                            function ya(a, b, c, d, f) {
                                var l = 0 == --a.h;
                                (a.f || a.g) && setTimeout(function() {
                                    var n = f || null, r = d || {};
                                    if (0 === c.length && l) ba(b.a);
                                    else {
                                        b.f += c.length;
                                        l && (b.j = l);
                                        var w, x = [];
                                        for(w = 0; w < c.length; w++){
                                            var y = c[w], z = r[y.c], C = b.a, B = y;
                                            C.g && v(C.f, [
                                                C.a.c("wf", B.c, E(B).toString(), "loading")
                                            ]);
                                            L(C, "fontloading", B);
                                            C = null;
                                            if (null === S) {
                                                if (window.FontFace) {
                                                    B = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent);
                                                    var za = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                                                    S = B ? 42 < parseInt(B[1], 10) : za ? !1 : !0;
                                                } else S = !1;
                                            }
                                            S ? C = new ca(u(b.g, b), u(b.h, b), b.c, y, b.s, z) : C = new da(u(b.g, b), u(b.h, b), b.c, y, b.s, n, z);
                                            x.push(C);
                                        }
                                        for(w = 0; w < x.length; w++)x[w].start();
                                    }
                                }, 0);
                            }
                            function Aa(a, b, c) {
                                var d = [], f = c.timeout;
                                ua(b);
                                d = wa(a.a, c, a.c);
                                var l = new V(a.c, b, f);
                                a.h = d.length;
                                b = 0;
                                for(c = d.length; b < c; b++)d[b].load(function(n, r, w) {
                                    ya(a, l, n, r, w);
                                });
                            }
                            function ka(a, b) {
                                this.c = a;
                                this.a = b;
                            }
                            function la(a, b) {
                                this.c = a;
                                this.a = b;
                            }
                            function Ba(a, b) {
                                a ? this.c = a : this.c = Ca;
                                this.a = [];
                                this.f = [];
                                this.g = b || "";
                            }
                            function Da(a, b) {
                                for(var c = b.length, d = 0; d < c; d++){
                                    var f = b[d].split(":");
                                    3 == f.length && a.f.push(f.pop());
                                    var l = "";
                                    2 == f.length && "" != f[1] && (l = ":");
                                    a.a.push(f.join(l));
                                }
                            }
                            function Ea(a) {
                                if (0 == a.a.length) throw Error("No fonts to load!");
                                if (-1 != a.c.indexOf("kit=")) return a.c;
                                for(var b = a.a.length, c = [], d = 0; d < b; d++)c.push(a.a[d].replace(/ /g, "+"));
                                b = a.c + "?family=" + c.join("%7C");
                                0 < a.f.length && (b += "&subset=" + a.f.join(","));
                                0 < a.g.length && (b += "&text=" + encodeURIComponent(a.g));
                                return b;
                            }
                            function Fa(a) {
                                this.f = a;
                                this.a = [];
                                this.c = {};
                            }
                            function Ga(a) {
                                for(var b = a.f.length, c = 0; c < b; c++){
                                    var d = a.f[c].split(":"), f = d[0].replace(/\+/g, " "), l = [
                                        "n4"
                                    ];
                                    if (2 <= d.length) {
                                        var n = d[1];
                                        var r = [];
                                        if (n) {
                                            n = n.split(",");
                                            for(var w = n.length, x = 0; x < w; x++){
                                                var y = n[x];
                                                if (y.match(/^[\w-]+$/)) {
                                                    var z = Ha.exec(y.toLowerCase());
                                                    if (null == z) y = "";
                                                    else {
                                                        y = z[2];
                                                        y = null == y || "" == y ? "n" : Ia[y];
                                                        z = z[1];
                                                        if (null == z || "" == z) z = "4";
                                                        else {
                                                            var C = Ja[z];
                                                            z = C ? C : isNaN(z) ? "4" : z.substr(0, 1);
                                                        }
                                                        y = [
                                                            y,
                                                            z
                                                        ].join("");
                                                    }
                                                } else y = "";
                                                y && r.push(y);
                                            }
                                        }
                                        0 < r.length && (l = r);
                                        3 == d.length && (d = d[2], r = [], d = d ? d.split(",") : r, 0 < d.length && (d = ma[d[0]]) && (a.c[f] = d));
                                    }
                                    a.c[f] || (d = ma[f]) && (a.c[f] = d);
                                    for(d = 0; d < l.length; d += 1)a.a.push(new H(f, l[d]));
                                }
                            }
                            function na(a, b) {
                                this.c = a;
                                this.a = b;
                            }
                            function oa(a, b) {
                                this.c = a;
                                this.a = b;
                            }
                            function pa(a, b) {
                                this.c = a;
                                this.f = b;
                                this.a = [];
                            }
                            var R = Date.now || function() {
                                return +new Date;
                            }, ra = !!window.FontFace;
                            Y.prototype.c = function(a) {
                                for(var b = [], c = 0; c < arguments.length; c++)b.push(arguments[c].replace(/[\W_]+/g, "").toLowerCase());
                                return b.join(this.a);
                            };
                            ca.prototype.start = function() {
                                var a = this.c.o.document, b = this, c = R(), d = new Promise(function(n, r) {
                                    function w() {
                                        R() - c >= b.f ? r() : a.fonts.load(sa(b.a), b.h).then(function(x) {
                                            1 <= x.length ? n() : setTimeout(w, 25);
                                        }, function() {
                                            r();
                                        });
                                    }
                                    w();
                                }), f = null, l = new Promise(function(n, r) {
                                    f = setTimeout(r, b.f);
                                });
                                Promise.race([
                                    l,
                                    d
                                ]).then(function() {
                                    f && (clearTimeout(f), f = null);
                                    b.g(b.a);
                                }, function() {
                                    b.j(b.a);
                                });
                            };
                            var Q = {
                                D: "serif",
                                C: "sans-serif"
                            }, T = null;
                            da.prototype.start = function() {
                                this.f.serif = this.j.a.offsetWidth;
                                this.f["sans-serif"] = this.m.a.offsetWidth;
                                this.A = R();
                                ha(this);
                            };
                            var S = null;
                            V.prototype.g = function(a) {
                                var b = this.a;
                                b.g && v(b.f, [
                                    b.a.c("wf", a.c, E(a).toString(), "active")
                                ], [
                                    b.a.c("wf", a.c, E(a).toString(), "loading"),
                                    b.a.c("wf", a.c, E(a).toString(), "inactive")
                                ]);
                                L(b, "fontactive", a);
                                this.m = !0;
                                ia(this);
                            };
                            V.prototype.h = function(a) {
                                var b = this.a;
                                if (b.g) {
                                    var c = A(b.f, b.a.c("wf", a.c, E(a).toString(), "active")), d = [], f = [
                                        b.a.c("wf", a.c, E(a).toString(), "loading")
                                    ];
                                    c || d.push(b.a.c("wf", a.c, E(a).toString(), "inactive"));
                                    v(b.f, d, f);
                                }
                                L(b, "fontinactive", a);
                                ia(this);
                            };
                            ja.prototype.load = function(a) {
                                this.c = new F(this.j, a.context || this.j);
                                this.g = !1 !== a.events;
                                this.f = !1 !== a.classes;
                                Aa(this, new ta(this.c, a), a);
                            };
                            ka.prototype.load = function(a) {
                                function b() {
                                    if (l["__mti_fntLst" + d]) {
                                        var n = l["__mti_fntLst" + d](), r = [], w;
                                        if (n) for(var x = 0; x < n.length; x++){
                                            var y = n[x].fontfamily;
                                            void 0 != n[x].fontStyle && void 0 != n[x].fontWeight ? (w = n[x].fontStyle + n[x].fontWeight, r.push(new H(y, w))) : r.push(new H(y));
                                        }
                                        a(r);
                                    } else setTimeout(function() {
                                        b();
                                    }, 50);
                                }
                                var c = this, d = c.a.projectId, f = c.a.version;
                                if (d) {
                                    var l = c.c.o;
                                    G(this.c, (c.a.api || "https://fast.fonts.net/jsapi") + "/" + d + ".js" + (f ? "?v=" + f : ""), function(n) {
                                        n ? a([]) : (l["__MonotypeConfiguration__" + d] = function() {
                                            return c.a;
                                        }, b());
                                    }).id = "__MonotypeAPIScript__" + d;
                                } else a([]);
                            };
                            la.prototype.load = function(a) {
                                var b, c = this.a.urls || [], d = this.a.families || [], f = this.a.testStrings || {}, l = new J;
                                var n = 0;
                                for(b = c.length; n < b; n++)D(this.c, c[n], K(l));
                                var r = [];
                                n = 0;
                                for(b = d.length; n < b; n++)if (c = d[n].split(":"), c[1]) for(var w = c[1].split(","), x = 0; x < w.length; x += 1)r.push(new H(c[0], w[x]));
                                else r.push(new H(c[0]));
                                X(l, function() {
                                    a(r, f);
                                });
                            };
                            var Ca = "https://fonts.googleapis.com/css", ma = {
                                latin: "BESbswy",
                                "latin-ext": "\xe7\xf6\xfc\u011F\u015F",
                                cyrillic: "\u0439\u044F\u0416",
                                greek: "\u03B1\u03B2\u03A3",
                                khmer: "\u1780\u1781\u1782",
                                Hanuman: "\u1780\u1781\u1782"
                            }, Ja = {
                                thin: "1",
                                extralight: "2",
                                "extra-light": "2",
                                ultralight: "2",
                                "ultra-light": "2",
                                light: "3",
                                regular: "4",
                                book: "4",
                                medium: "5",
                                "semi-bold": "6",
                                semibold: "6",
                                "demi-bold": "6",
                                demibold: "6",
                                bold: "7",
                                "extra-bold": "8",
                                extrabold: "8",
                                "ultra-bold": "8",
                                ultrabold: "8",
                                black: "9",
                                heavy: "9",
                                l: "3",
                                r: "4",
                                b: "7"
                            }, Ia = {
                                i: "i",
                                italic: "i",
                                n: "n",
                                normal: "n"
                            }, Ha = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/, Ka = {
                                Arimo: !0,
                                Cousine: !0,
                                Tinos: !0
                            };
                            na.prototype.load = function(a) {
                                var b = new J, c = this.c, d = new Ba(this.a.api, this.a.text), f = this.a.families;
                                Da(d, f);
                                var l = new Fa(f);
                                Ga(l);
                                D(c, Ea(d), K(b));
                                X(b, function() {
                                    a(l.a, l.c, Ka);
                                });
                            };
                            oa.prototype.load = function(a) {
                                var b = this.a.id, c = this.c.o;
                                b ? G(this.c, (this.a.api || "https://use.typekit.net") + "/" + b + ".js", function(d) {
                                    if (d) a([]);
                                    else if (c.Typekit && c.Typekit.config && c.Typekit.config.fn) {
                                        d = c.Typekit.config.fn;
                                        for(var f = [], l = 0; l < d.length; l += 2)for(var n = d[l], r = d[l + 1], w = 0; w < r.length; w++)f.push(new H(n, r[w]));
                                        try {
                                            c.Typekit.load({
                                                events: !1,
                                                classes: !1,
                                                async: !0
                                            });
                                        } catch (x) {}
                                        a(f);
                                    }
                                }, 2E3) : a([]);
                            };
                            pa.prototype.load = function(a) {
                                var b = this.f.id, c = this.c.o, d = this;
                                b ? (c.__webfontfontdeckmodule__ || (c.__webfontfontdeckmodule__ = {}), c.__webfontfontdeckmodule__[b] = function(f, l) {
                                    f = 0;
                                    for(var n = l.fonts.length; f < n; ++f){
                                        var r = l.fonts[f], w = d.a, x = w.push, y = r.name;
                                        r = "font-weight:" + r.weight + ";font-style:" + r.style;
                                        var z = 4, C = "n", B = null;
                                        r && ((B = r.match(/(normal|oblique|italic)/i)) && B[1] && (C = B[1].substr(0, 1).toLowerCase()), (B = r.match(/([1-9]00|normal|bold)/i)) && B[1] && (/bold/i.test(B[1]) ? z = 7 : /[1-9]00/.test(B[1]) && (z = parseInt(B[1].substr(0, 1), 10))));
                                        x.call(w, new H(y, C + z));
                                    }
                                    a(d.a);
                                }, G(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + M(this.c) + "/" + b + ".js", function(f) {
                                    f && a([]);
                                })) : a([]);
                            };
                            var I = new ja(window);
                            I.a.c.custom = function(a, b) {
                                return new la(b, a);
                            };
                            I.a.c.fontdeck = function(a, b) {
                                return new pa(b, a);
                            };
                            I.a.c.monotype = function(a, b) {
                                return new ka(b, a);
                            };
                            I.a.c.typekit = function(a, b) {
                                return new oa(b, a);
                            };
                            I.a.c.google = function(a, b) {
                                return new na(b, a);
                            };
                            var qa = {
                                load: u(I.load, I)
                            };
                            "undefined" !== typeof g && g.exports ? g.exports = qa : (window.WebFont = qa, window.WebFontConfig && I.load(window.WebFontConfig));
                        })();
                    },
                    {}
                ],
                2: [
                    function(m, g) {
                        function t(q) {
                            "@babel/helpers - typeof";
                            return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(u) {
                                return typeof u;
                            } : function(u) {
                                return u && "function" == typeof Symbol && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
                            }, t(q);
                        }
                        "object" === ("undefined" === typeof window ? "undefined" : t(window)) ? g.exports = m("webfontloader") : g.exports = {};
                    },
                    {
                        webfontloader: 1
                    }
                ]
            }, {}, [
                2
            ])(2);
        });
        return module1.exports;
    }();
    var __worker__colibrio_readingsystem_formatadapter_epub_iframe = '\'use strict\'; (function (__self) { var __lib__base64_js = (function () { var exports = {}; var module = { exports: exports }; var define = void 0; (function(d){"object"===typeof exports&&"undefined"!==typeof module?module.exports=d():"function"===typeof define&&define.amd?define([],d):("undefined"!==typeof window?window:"undefined"!==typeof global?global:"undefined"!==typeof self?self:this).lib=d()})(function(){return function(){function d(m,l,p){function h(a,b){if(!l[a]){if(!m[a]){var c="function"==typeof require&&require;if(!b&&c)return c(a,!0);if(e)return e(a,!0);b=Error("Cannot find module \'"+a+"\'");throw b.code="MODULE_NOT_FOUND",b;}b=\nl[a]={exports:{}};m[a][0].call(b.exports,function(f){return h(m[a][1][f]||f)},b,b.exports,d,m,l,p)}return l[a].exports}for(var e="function"==typeof require&&require,q=0;q<p.length;q++)h(p[q]);return h}return d}()({1:[function(d,m,l){function p(a){var b=a.length;if(0<b%4)throw Error("Invalid string. Length must be a multiple of 4");a=a.indexOf("=");-1===a&&(a=b);return[a,a===b?0:4-a%4]}l.byteLength=function(a){a=p(a);var b=a[1];return 3*(a[0]+b)/4-b};l.toByteArray=function(a){var b=p(a);var c=b[0];\nb=b[1];var f=new q(3*(c+b)/4-b),k=0,r=0<b?c-4:c,g;for(g=0;g<r;g+=4)c=e[a.charCodeAt(g)]<<18|e[a.charCodeAt(g+1)]<<12|e[a.charCodeAt(g+2)]<<6|e[a.charCodeAt(g+3)],f[k++]=c>>16&255,f[k++]=c>>8&255,f[k++]=c&255;2===b&&(c=e[a.charCodeAt(g)]<<2|e[a.charCodeAt(g+1)]>>4,f[k++]=c&255);1===b&&(c=e[a.charCodeAt(g)]<<10|e[a.charCodeAt(g+1)]<<4|e[a.charCodeAt(g+2)]>>2,f[k++]=c>>8&255,f[k++]=c&255);return f};l.fromByteArray=function(a){for(var b=a.length,c=b%3,f=[],k=0,r=b-c;k<r;k+=16383){for(var g=f,w=g.push,\nn,u=a,x=k+16383>r?r:k+16383,v=[],t=k;t<x;t+=3)n=(u[t]<<16&16711680)+(u[t+1]<<8&65280)+(u[t+2]&255),v.push(h[n>>18&63]+h[n>>12&63]+h[n>>6&63]+h[n&63]);n=v.join("");w.call(g,n)}1===c?(a=a[b-1],f.push(h[a>>2]+h[a<<4&63]+"==")):2===c&&(a=(a[b-2]<<8)+a[b-1],f.push(h[a>>10]+h[a>>4&63]+h[a<<2&63]+"="));return f.join("")};var h=[],e=[],q="undefined"!==typeof Uint8Array?Uint8Array:Array;for(d=0;64>d;++d)h[d]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[d],e["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(d)]=\nd;e[45]=62;e[95]=63},{}],2:[function(d,m){m.exports=d("base64-js")},{"base64-js":1}]},{},[2])(2)});\n return module.exports; })();\nvar __lib__bowser = (function () { var exports = {}; var module = { exports: exports }; var define = void 0; var k=k||{};k.scope={};k.arrayIteratorImpl=function(f){var m=0;return function(){return m<f.length?{done:!1,value:f[m++]}:{done:!0}}};k.arrayIterator=function(f){return{next:k.arrayIteratorImpl(f)}};k.ASSUME_ES5=!1;k.ASSUME_NO_NATIVE_MAP=!1;k.ASSUME_NO_NATIVE_SET=!1;k.SIMPLE_FROUND_POLYFILL=!1;k.ISOLATE_POLYFILLS=!1;k.FORCE_POLYFILL_PROMISE=!1;k.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION=!1;\nk.defineProperty=k.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(f,m,r){if(f==Array.prototype||f==Object.prototype)return f;f[m]=r.value;return f};k.getGlobal=function(f){f=["object"==typeof globalThis&&globalThis,f,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var m=0;m<f.length;++m){var r=f[m];if(r&&r.Math==Math)return r}throw Error("Cannot find global object");};k.global=k.getGlobal(this);\nk.IS_SYMBOL_NATIVE="function"===typeof Symbol&&"symbol"===typeof Symbol("x");k.TRUST_ES6_POLYFILLS=!k.ISOLATE_POLYFILLS||k.IS_SYMBOL_NATIVE;k.polyfills={};k.propertyToPolyfillSymbol={};k.POLYFILL_PREFIX="$jscp$";k.polyfill=function(f,m,r,n){m&&(k.ISOLATE_POLYFILLS?k.polyfillIsolated(f,m,r,n):k.polyfillUnisolated(f,m,r,n))};\nk.polyfillUnisolated=function(f,m){var r=k.global;f=f.split(".");for(var n=0;n<f.length-1;n++){var p=f[n];if(!(p in r))return;r=r[p]}f=f[f.length-1];n=r[f];m=m(n);m!=n&&null!=m&&k.defineProperty(r,f,{configurable:!0,writable:!0,value:m})};\nk.polyfillIsolated=function(f,m,r){var n=f.split(".");f=1===n.length;var p=n[0];p=!f&&p in k.polyfills?k.polyfills:k.global;for(var e=0;e<n.length-1;e++){var t=n[e];if(!(t in p))return;p=p[t]}n=n[n.length-1];r=k.IS_SYMBOL_NATIVE&&"es6"===r?p[n]:null;m=m(r);null!=m&&(f?k.defineProperty(k.polyfills,n,{configurable:!0,writable:!0,value:m}):m!==r&&(void 0===k.propertyToPolyfillSymbol[n]&&(f=1E9*Math.random()>>>0,k.propertyToPolyfillSymbol[n]=k.IS_SYMBOL_NATIVE?k.global.Symbol(n):k.POLYFILL_PREFIX+f+"$"+\nn),k.defineProperty(p,k.propertyToPolyfillSymbol[n],{configurable:!0,writable:!0,value:m})))};k.initSymbol=function(){};\nk.polyfill("Symbol",function(f){function m(e){if(this instanceof m)throw new TypeError("Symbol is not a constructor");return new r(n+(e||"")+"_"+p++,e)}function r(e,t){this.$jscomp$symbol$id_=e;k.defineProperty(this,"description",{configurable:!0,writable:!0,value:t})}if(f)return f;r.prototype.toString=function(){return this.$jscomp$symbol$id_};var n="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",p=0;return m},"es6","es3");\nk.polyfill("Symbol.iterator",function(f){if(f)return f;f=Symbol("Symbol.iterator");for(var m="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),r=0;r<m.length;r++){var n=k.global[m[r]];"function"===typeof n&&"function"!=typeof n.prototype[f]&&k.defineProperty(n.prototype,f,{configurable:!0,writable:!0,value:function(){return k.iteratorPrototype(k.arrayIteratorImpl(this))}})}return f},"es6","es3");\nk.iteratorPrototype=function(f){f={next:f};f[Symbol.iterator]=function(){return this};return f};k.iteratorFromArray=function(f,m){f instanceof String&&(f+="");var r=0,n=!1,p={next:function(){if(!n&&r<f.length){var e=r++;return{value:m(e,f[e]),done:!1}}n=!0;return{done:!0,value:void 0}}};p[Symbol.iterator]=function(){return p};return p};k.polyfill("Array.prototype.keys",function(f){return f?f:function(){return k.iteratorFromArray(this,function(m){return m})}},"es6","es3");\nk.findInternal=function(f,m,r){f instanceof String&&(f=String(f));for(var n=f.length,p=0;p<n;p++){var e=f[p];if(m.call(r,e,p,f))return{i:p,v:e}}return{i:-1,v:void 0}};k.polyfill("Array.prototype.find",function(f){return f?f:function(m,r){return k.findInternal(this,m,r).v}},"es6","es3");\n(function(f){"object"===typeof exports&&"undefined"!==typeof module?module.exports=f():"function"===typeof define&&define.amd?define([],f):("undefined"!==typeof window?window:"undefined"!==typeof global?global:"undefined"!==typeof self?self:this).lib=f()})(function(){return function(){function f(m,r,n){function p(h,d){if(!r[h]){if(!m[h]){var c="function"==typeof require&&require;if(!d&&c)return c(h,!0);if(e)return e(h,!0);d=Error("Cannot find module \'"+h+"\'");throw d.code="MODULE_NOT_FOUND",d;}d=\nr[h]={exports:{}};m[h][0].call(d.exports,function(a){return p(m[h][1][a]||a)},d,d.exports,f,m,r,n)}return r[h].exports}for(var e="function"==typeof require&&require,t=0;t<n.length;t++)p(n[t]);return p}return f}()({1:[function(f,m,r){function n(p){"@babel/helpers - typeof";return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n(p)}!function(p,\ne){"object"==("undefined"===typeof r?"undefined":n(r))&&"object"==("undefined"===typeof m?"undefined":n(m))?m.exports=e():"object"==("undefined"===typeof r?"undefined":n(r))?r.bowser=e():p.bowser=e()}(void 0,function(){return function(p){function e(h){if(t[h])return t[h].exports;var d=t[h]={i:h,l:!1,exports:{}};return p[h].call(d.exports,d,d.exports,e),d.l=!0,d.exports}var t={};return e.m=p,e.c=t,e.d=function(h,d,c){e.o(h,d)||Object.defineProperty(h,d,{enumerable:!0,get:c})},e.r=function(h){"undefined"!=\ntypeof Symbol&&Symbol.toStringTag&&Object.defineProperty(h,Symbol.toStringTag,{value:"Module"});Object.defineProperty(h,"__esModule",{value:!0})},e.t=function(h,d){if((1&d&&(h=e(h)),8&d)||4&d&&"object"==n(h)&&h&&h.__esModule)return h;var c=Object.create(null);if(e.r(c),Object.defineProperty(c,"default",{enumerable:!0,value:h}),2&d&&"string"!=typeof h)for(var a in h)e.d(c,a,function(b){return h[b]}.bind(null,a));return c},e.n=function(h){var d=h&&h.__esModule?function(){return h.default}:function(){return h};\nreturn e.d(d,"a",d),d},e.o=function(h,d){return Object.prototype.hasOwnProperty.call(h,d)},e.p="",e(e.s=90)}({17:function(p,e,t){e.__esModule=!0;e.default=void 0;var h=t(18);t=function(){function d(){}return d.getFirstMatch=function(c,a){return(c=a.match(c))&&0<c.length&&c[1]||""},d.getSecondMatch=function(c,a){return(c=a.match(c))&&1<c.length&&c[2]||""},d.matchAndReturnConst=function(c,a,b){if(c.test(a))return b},d.getWindowsVersionName=function(c){switch(c){case "NT":return"NT";case "XP":return"XP";\ncase "NT 5.0":return"2000";case "NT 5.1":return"XP";case "NT 5.2":return"2003";case "NT 6.0":return"Vista";case "NT 6.1":return"7";case "NT 6.2":return"8";case "NT 6.3":return"8.1";case "NT 10.0":return"10"}},d.getMacOSVersionName=function(c){c=c.split(".").splice(0,2).map(function(a){return parseInt(a,10)||0});if(c.push(0),10===c[0])switch(c[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";\ncase 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina"}},d.getAndroidVersionName=function(c){c=c.split(".").splice(0,2).map(function(a){return parseInt(a,10)||0});if(c.push(0),!(1===c[0]&&5>c[1]))return 1===c[0]&&6>c[1]?"Cupcake":1===c[0]&&6<=c[1]?"Donut":2===c[0]&&2>c[1]?"Eclair":2===c[0]&&2===c[1]?"Froyo":2===c[0]&&2<c[1]?"Gingerbread":3===c[0]?"Honeycomb":4===c[0]&&1>c[1]?"Ice Cream Sandwich":4===c[0]&&4>c[1]?"Jelly Bean":4===c[0]&&4<=c[1]?"KitKat":5===\nc[0]?"Lollipop":6===c[0]?"Marshmallow":7===c[0]?"Nougat":8===c[0]?"Oreo":9===c[0]?"Pie":void 0},d.getVersionPrecision=function(c){return c.split(".").length},d.compareVersions=function(c,a,b){void 0===b&&(b=!1);var v=d.getVersionPrecision(c),w=d.getVersionPrecision(a),l=Math.max(v,w),g=0;c=d.map([c,a],function(q){var u=l-d.getVersionPrecision(q);q+=Array(u+1).join(".0");return d.map(q.split("."),function(x){return Array(20-x.length).join("0")+x}).reverse()});b&&(g=l-Math.min(v,w));for(--l;l>=g;){if(c[0][l]>\nc[1][l])return 1;if(c[0][l]===c[1][l]){if(l===g)return 0;--l}else if(c[0][l]<c[1][l])return-1}},d.map=function(c,a){var b,v=[];if(Array.prototype.map)return Array.prototype.map.call(c,a);for(b=0;b<c.length;b+=1)v.push(a(c[b]));return v},d.find=function(c,a){var b;if(Array.prototype.find)return Array.prototype.find.call(c,a);var v=0;for(b=c.length;v<b;v+=1){var w=c[v];if(a(w,v))return w}},d.assign=function(c){function a(){var g=v[l];"object"==n(g)&&null!==g&&Object.keys(g).forEach(function(q){c[q]=\ng[q]})}var b=arguments.length;for(var v=Array(1<b?b-1:0),w=1;w<b;w++)v[w-1]=arguments[w];if(Object.assign)return Object.assign.apply(Object,[c].concat(v));var l=0;for(b=v.length;l<b;l+=1)a();return c},d.getBrowserAlias=function(c){return h.BROWSER_ALIASES_MAP[c]},d.getBrowserTypeByAlias=function(c){return h.BROWSER_MAP[c]||""},d}();e.default=t;p.exports=e.default},18:function(p,e){e.__esModule=!0;e.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",\nChrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",\nSeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};e.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",\nmaxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};e.PLATFORMS_MAP={tablet:"tablet",\nmobile:"mobile",desktop:"desktop",tv:"tv"};e.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};e.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(p,e,t){function h(b,v){for(var w=0;w<v.length;w++){var l=v[w];l.enumerable=l.enumerable||!1;\nl.configurable=!0;"value"in l&&(l.writable=!0);Object.defineProperty(b,l.key,l)}}e.__esModule=!0;e.default=void 0;var d,c=(d=t(91))&&d.__esModule?d:{default:d},a=t(18);t=function(){function b(){}var v;return b.getParser=function(w,l){if(void 0===l&&(l=!1),"string"!=typeof w)throw Error("UserAgent should be a string");return new c.default(w,l)},b.parse=function(w){return(new c.default(w)).getResult()},v=[{key:"BROWSER_MAP",get:function(){return a.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return a.ENGINE_MAP}},\n{key:"OS_MAP",get:function(){return a.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return a.PLATFORMS_MAP}}],v&&h(b,v),b}();e.default=t;p.exports=e.default},91:function(p,e,t){function h(w){return w&&w.__esModule?w:{default:w}}e.__esModule=!0;e.default=void 0;var d=h(t(92)),c=h(t(93)),a=h(t(94)),b=h(t(95)),v=h(t(17));t=function(){function w(g,q){if(void 0===q&&(q=!1),null==g||""===g)throw Error("UserAgent parameter can\'t be empty");this._ua=g;this.parsedResult={};!0!==q&&this.parse()}var l=w.prototype;\nreturn l.getUA=function(){return this._ua},l.test=function(g){return g.test(this._ua)},l.parseBrowser=function(){var g=this;this.parsedResult.browser={};var q=v.default.find(d.default,function(u){if("function"==typeof u.test)return u.test(g);if(u.test instanceof Array)return u.test.some(function(x){return g.test(x)});throw Error("Browser\'s test function is not valid");});return q&&(this.parsedResult.browser=q.describe(this.getUA())),this.parsedResult.browser},l.getBrowser=function(){return this.parsedResult.browser?\nthis.parsedResult.browser:this.parseBrowser()},l.getBrowserName=function(g){return g?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},l.getBrowserVersion=function(){return this.getBrowser().version},l.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},l.parseOS=function(){var g=this;this.parsedResult.os={};var q=v.default.find(c.default,function(u){if("function"==typeof u.test)return u.test(g);if(u.test instanceof Array)return u.test.some(function(x){return g.test(x)});\nthrow Error("Browser\'s test function is not valid");});return q&&(this.parsedResult.os=q.describe(this.getUA())),this.parsedResult.os},l.getOSName=function(g){var q=this.getOS().name;return g?String(q).toLowerCase()||"":q||""},l.getOSVersion=function(){return this.getOS().version},l.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},l.getPlatformType=function(g){void 0===g&&(g=!1);var q=this.getPlatform().type;return g?String(q).toLowerCase()||\n"":q||""},l.parsePlatform=function(){var g=this;this.parsedResult.platform={};var q=v.default.find(a.default,function(u){if("function"==typeof u.test)return u.test(g);if(u.test instanceof Array)return u.test.some(function(x){return g.test(x)});throw Error("Browser\'s test function is not valid");});return q&&(this.parsedResult.platform=q.describe(this.getUA())),this.parsedResult.platform},l.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},l.getEngineName=\nfunction(g){return g?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},l.parseEngine=function(){var g=this;this.parsedResult.engine={};var q=v.default.find(b.default,function(u){if("function"==typeof u.test)return u.test(g);if(u.test instanceof Array)return u.test.some(function(x){return g.test(x)});throw Error("Browser\'s test function is not valid");});return q&&(this.parsedResult.engine=q.describe(this.getUA())),this.parsedResult.engine},l.parse=function(){return this.parseBrowser(),\nthis.parseOS(),this.parsePlatform(),this.parseEngine(),this},l.getResult=function(){return v.default.assign({},this.parsedResult)},l.satisfies=function(g){var q=this,u={},x=0,A={},D=0;if(Object.keys(g).forEach(function(z){var C=g[z];"string"==typeof C?(A[z]=C,D+=1):"object"==n(C)&&(u[z]=C,x+=1)}),0<x){var y=Object.keys(u),B=v.default.find(y,function(z){return q.isOS(z)});if(B&&(B=this.satisfies(u[B]),void 0!==B))return B;if(y=v.default.find(y,function(z){return q.isPlatform(z)}))if(y=this.satisfies(u[y]),\nvoid 0!==y)return y}if(0<D&&(y=Object.keys(A),y=v.default.find(y,function(z){return q.isBrowser(z,!0)}),void 0!==y))return this.compareVersion(A[y])},l.isBrowser=function(g,q){void 0===q&&(q=!1);var u=this.getBrowserName().toLowerCase();g=g.toLowerCase();var x=v.default.getBrowserTypeByAlias(g);return q&&x&&(g=x.toLowerCase()),g===u},l.compareVersion=function(g){var q=[0],u=g,x=!1,A=this.getBrowserVersion();if("string"==typeof A)return">"===g[0]||"<"===g[0]?(u=g.substr(1),"="===g[1]?(x=!0,u=g.substr(2)):\nq=[],">"===g[0]?q.push(1):q.push(-1)):"="===g[0]?u=g.substr(1):"~"===g[0]&&(x=!0,u=g.substr(1)),-1<q.indexOf(v.default.compareVersions(A,u,x))},l.isOS=function(g){return this.getOSName(!0)===String(g).toLowerCase()},l.isPlatform=function(g){return this.getPlatformType(!0)===String(g).toLowerCase()},l.isEngine=function(g){return this.getEngineName(!0)===String(g).toLowerCase()},l.is=function(g,q){return void 0===q&&(q=!1),this.isBrowser(g,q)||this.isOS(g)||this.isPlatform(g)},l.some=function(g){var q=\nthis;return void 0===g&&(g=[]),g.some(function(u){return q.is(u)})},w}();e.default=t;p.exports=e.default},92:function(p,e,t){e.__esModule=!0;e.default=void 0;var h,d=(h=t(17))&&h.__esModule?h:{default:h},c=/version\\/(\\d+(\\.?_?\\d+)+)/i;e.default=[{test:[/googlebot/i],describe:function(a){var b={name:"Googlebot"};a=d.default.getFirstMatch(/googlebot\\/(\\d+(\\.\\d+))/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/opera/i],describe:function(a){var b={name:"Opera"};a=d.default.getFirstMatch(c,\na)||d.default.getFirstMatch(/(?:opera)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/opr\\/|opios/i],describe:function(a){var b={name:"Opera"};a=d.default.getFirstMatch(/(?:opr|opios)[\\s/](\\S+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/SamsungBrowser/i],describe:function(a){var b={name:"Samsung Internet for Android"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:SamsungBrowser)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/Whale/i],\ndescribe:function(a){var b={name:"NAVER Whale Browser"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:whale)[\\s/](\\d+(?:\\.\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/MZBrowser/i],describe:function(a){var b={name:"MZ Browser"};a=d.default.getFirstMatch(/(?:MZBrowser)[\\s/](\\d+(?:\\.\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/focus/i],describe:function(a){var b={name:"Focus"};a=d.default.getFirstMatch(/(?:focus)[\\s/](\\d+(?:\\.\\d+)+)/i,a)||d.default.getFirstMatch(c,\na);return a&&(b.version=a),b}},{test:[/swing/i],describe:function(a){var b={name:"Swing"};a=d.default.getFirstMatch(/(?:swing)[\\s/](\\d+(?:\\.\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/coast/i],describe:function(a){var b={name:"Opera Coast"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:coast)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/opt\\/\\d+(?:.?_?\\d+)+/i],describe:function(a){var b={name:"Opera Touch"};a=d.default.getFirstMatch(/(?:opt)[\\s/](\\d+(\\.?_?\\d+)+)/i,\na)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/yabrowser/i],describe:function(a){var b={name:"Yandex Browser"};a=d.default.getFirstMatch(/(?:yabrowser)[\\s/](\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/ucbrowser/i],describe:function(a){var b={name:"UC Browser"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:ucbrowser)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/Maxthon|mxios/i],describe:function(a){var b=\n{name:"Maxthon"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:Maxthon|mxios)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/epiphany/i],describe:function(a){var b={name:"Epiphany"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:epiphany)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/puffin/i],describe:function(a){var b={name:"Puffin"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:puffin)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=\na),b}},{test:[/sleipnir/i],describe:function(a){var b={name:"Sleipnir"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:sleipnir)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/k-meleon/i],describe:function(a){var b={name:"K-Meleon"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:k-meleon)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/micromessenger/i],describe:function(a){var b={name:"WeChat"};a=d.default.getFirstMatch(/(?:micromessenger)[\\s/](\\d+(\\.?_?\\d+)+)/i,\na)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/qqbrowser/i],describe:function(a){var b={name:/qqbrowserlite/i.test(a)?"QQ Browser Lite":"QQ Browser"};a=d.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/msie|trident/i],describe:function(a){var b={name:"Internet Explorer"};a=d.default.getFirstMatch(/(?:msie |rv:)(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/\\sedg\\//i],describe:function(a){var b=\n{name:"Microsoft Edge"};a=d.default.getFirstMatch(/\\sedg\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/edg([ea]|ios)/i],describe:function(a){var b={name:"Microsoft Edge"};a=d.default.getSecondMatch(/edg([ea]|ios)\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/vivaldi/i],describe:function(a){var b={name:"Vivaldi"};a=d.default.getFirstMatch(/vivaldi\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/seamonkey/i],describe:function(a){var b={name:"SeaMonkey"};a=d.default.getFirstMatch(/seamonkey\\/(\\d+(\\.?_?\\d+)+)/i,\na);return a&&(b.version=a),b}},{test:[/sailfish/i],describe:function(a){var b={name:"Sailfish"};a=d.default.getFirstMatch(/sailfish\\s?browser\\/(\\d+(\\.\\d+)?)/i,a);return a&&(b.version=a),b}},{test:[/silk/i],describe:function(a){var b={name:"Amazon Silk"};a=d.default.getFirstMatch(/silk\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/phantom/i],describe:function(a){var b={name:"PhantomJS"};a=d.default.getFirstMatch(/phantomjs\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/slimerjs/i],\ndescribe:function(a){var b={name:"SlimerJS"};a=d.default.getFirstMatch(/slimerjs\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/blackberry|\\bbb\\d+/i,/rim\\stablet/i],describe:function(a){var b={name:"BlackBerry"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/blackberry[\\d]+\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/(web|hpw)[o0]s/i],describe:function(a){var b={name:"WebOS Browser"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\\/(\\d+(\\.?_?\\d+)+)/i,\na);return a&&(b.version=a),b}},{test:[/bada/i],describe:function(a){var b={name:"Bada"};a=d.default.getFirstMatch(/dolfin\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/tizen/i],describe:function(a){var b={name:"Tizen"};a=d.default.getFirstMatch(/(?:tizen\\s?)?browser\\/(\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/qupzilla/i],describe:function(a){var b={name:"QupZilla"};a=d.default.getFirstMatch(/(?:qupzilla)[\\s/](\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,\na);return a&&(b.version=a),b}},{test:[/firefox|iceweasel|fxios/i],describe:function(a){var b={name:"Firefox"};a=d.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/electron/i],describe:function(a){var b={name:"Electron"};a=d.default.getFirstMatch(/(?:electron)\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/MiuiBrowser/i],describe:function(a){var b={name:"Miui"};a=d.default.getFirstMatch(/(?:MiuiBrowser)[\\s/](\\d+(\\.?_?\\d+)+)/i,\na);return a&&(b.version=a),b}},{test:[/chromium/i],describe:function(a){var b={name:"Chromium"};a=d.default.getFirstMatch(/(?:chromium)[\\s/](\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/chrome|crios|crmo/i],describe:function(a){var b={name:"Chrome"};a=d.default.getFirstMatch(/(?:chrome|crios|crmo)\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/GSA/i],describe:function(a){var b={name:"Google Search"};a=d.default.getFirstMatch(/(?:GSA)\\/(\\d+(\\.?_?\\d+)+)/i,\na);return a&&(b.version=a),b}},{test:function(a){var b=!a.test(/like android/i);a=a.test(/android/i);return b&&a},describe:function(a){var b={name:"Android Browser"};a=d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/playstation 4/i],describe:function(a){var b={name:"PlayStation 4"};a=d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/safari|applewebkit/i],describe:function(a){var b={name:"Safari"};a=d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/.*/i],\ndescribe:function(a){var b=-1!==a.search("\\\\(")?/^(.*)\\/(.*)[ \\t]\\((.*)/:/^(.*)\\/(.*) /;return{name:d.default.getFirstMatch(b,a),version:d.default.getSecondMatch(b,a)}}}];p.exports=e.default},93:function(p,e,t){e.__esModule=!0;e.default=void 0;var h,d=(h=t(17))&&h.__esModule?h:{default:h},c=t(18);e.default=[{test:[/Roku\\/DVP/],describe:function(a){a=d.default.getFirstMatch(/Roku\\/DVP-(\\d+\\.\\d+)/i,a);return{name:c.OS_MAP.Roku,version:a}}},{test:[/windows phone/i],describe:function(a){a=d.default.getFirstMatch(/windows phone (?:os)?\\s?(\\d+(\\.\\d+)*)/i,\na);return{name:c.OS_MAP.WindowsPhone,version:a}}},{test:[/windows /i],describe:function(a){a=d.default.getFirstMatch(/Windows ((NT|XP)( \\d\\d?.\\d)?)/i,a);var b=d.default.getWindowsVersionName(a);return{name:c.OS_MAP.Windows,version:a,versionName:b}}},{test:[/Macintosh(.*?) FxiOS(.*?)\\//],describe:function(a){var b={name:c.OS_MAP.iOS};a=d.default.getSecondMatch(/(Version\\/)(\\d[\\d.]+)/,a);return a&&(b.version=a),b}},{test:[/macintosh/i],describe:function(a){var b=d.default.getFirstMatch(/mac os x (\\d+(\\.?_?\\d+)+)/i,\na).replace(/[_\\s]/g,".");a=d.default.getMacOSVersionName(b);b={name:c.OS_MAP.MacOS,version:b};return a&&(b.versionName=a),b}},{test:[/(ipod|iphone|ipad)/i],describe:function(a){a=d.default.getFirstMatch(/os (\\d+([_\\s]\\d+)*) like mac os x/i,a).replace(/[_\\s]/g,".");return{name:c.OS_MAP.iOS,version:a}}},{test:function(a){var b=!a.test(/like android/i);a=a.test(/android/i);return b&&a},describe:function(a){var b=d.default.getFirstMatch(/android[\\s/-](\\d+(\\.\\d+)*)/i,a);a=d.default.getAndroidVersionName(b);\nb={name:c.OS_MAP.Android,version:b};return a&&(b.versionName=a),b}},{test:[/(web|hpw)[o0]s/i],describe:function(a){a=d.default.getFirstMatch(/(?:web|hpw)[o0]s\\/(\\d+(\\.\\d+)*)/i,a);var b={name:c.OS_MAP.WebOS};return a&&a.length&&(b.version=a),b}},{test:[/blackberry|\\bbb\\d+/i,/rim\\stablet/i],describe:function(a){a=d.default.getFirstMatch(/rim\\stablet\\sos\\s(\\d+(\\.\\d+)*)/i,a)||d.default.getFirstMatch(/blackberry\\d+\\/(\\d+([_\\s]\\d+)*)/i,a)||d.default.getFirstMatch(/\\bbb(\\d+)/i,a);return{name:c.OS_MAP.BlackBerry,\nversion:a}}},{test:[/bada/i],describe:function(a){a=d.default.getFirstMatch(/bada\\/(\\d+(\\.\\d+)*)/i,a);return{name:c.OS_MAP.Bada,version:a}}},{test:[/tizen/i],describe:function(a){a=d.default.getFirstMatch(/tizen[/\\s](\\d+(\\.\\d+)*)/i,a);return{name:c.OS_MAP.Tizen,version:a}}},{test:[/linux/i],describe:function(){return{name:c.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:c.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(a){a=d.default.getFirstMatch(/PlayStation 4[/\\s](\\d+(\\.\\d+)*)/i,\na);return{name:c.OS_MAP.PlayStation4,version:a}}}];p.exports=e.default},94:function(p,e,t){e.__esModule=!0;e.default=void 0;var h,d=(h=t(17))&&h.__esModule?h:{default:h},c=t(18);e.default=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(a){a=d.default.getFirstMatch(/(can-l01)/i,a)&&"Nova";var b={type:c.PLATFORMS_MAP.mobile,vendor:"Huawei"};return a&&(b.model=a),b}},{test:[/nexus\\s*(?:7|8|9|10).*/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet,\nvendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\\//],describe:function(){return{type:c.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet}}},\n{test:function(a){var b=a.test(/ipod|iphone/i);a=a.test(/like (ipod|iphone)/i);return b&&!a},describe:function(a){a=d.default.getFirstMatch(/(ipod|iphone)/i,a);return{type:c.PLATFORMS_MAP.mobile,vendor:"Apple",model:a}}},{test:[/nexus\\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:c.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:c.PLATFORMS_MAP.mobile}}},{test:function(a){return"blackberry"===a.getBrowserName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.mobile,\nvendor:"BlackBerry"}}},{test:function(a){return"bada"===a.getBrowserName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.mobile}}},{test:function(a){return"windows phone"===a.getBrowserName()},describe:function(){return{type:c.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(a){var b=Number(String(a.getOSVersion()).split(".")[0]);return"android"===a.getOSName(!0)&&3<=b},describe:function(){return{type:c.PLATFORMS_MAP.tablet}}},{test:function(a){return"android"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.mobile}}},\n{test:function(a){return"macos"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(a){return"windows"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.desktop}}},{test:function(a){return"linux"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.desktop}}},{test:function(a){return"playstation 4"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.tv}}},{test:function(a){return"roku"===a.getOSName(!0)},\ndescribe:function(){return{type:c.PLATFORMS_MAP.tv}}}];p.exports=e.default},95:function(p,e,t){e.__esModule=!0;e.default=void 0;var h,d=(h=t(17))&&h.__esModule?h:{default:h},c=t(18);e.default=[{test:function(a){return"microsoft edge"===a.getBrowserName(!0)},describe:function(a){if(/\\sedg\\//i.test(a))return{name:c.ENGINE_MAP.Blink};a=d.default.getFirstMatch(/edge\\/(\\d+(\\.?_?\\d+)+)/i,a);return{name:c.ENGINE_MAP.EdgeHTML,version:a}}},{test:[/trident/i],describe:function(a){var b={name:c.ENGINE_MAP.Trident};\na=d.default.getFirstMatch(/trident\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:function(a){return a.test(/presto/i)},describe:function(a){var b={name:c.ENGINE_MAP.Presto};a=d.default.getFirstMatch(/presto\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:function(a){var b=a.test(/gecko/i);a=a.test(/like gecko/i);return b&&!a},describe:function(a){var b={name:c.ENGINE_MAP.Gecko};a=d.default.getFirstMatch(/gecko\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/(apple)?webkit\\/537\\.36/i],\ndescribe:function(){return{name:c.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(a){var b={name:c.ENGINE_MAP.WebKit};a=d.default.getFirstMatch(/webkit\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}}];p.exports=e.default}})})},{}],2:[function(f,m){m.exports=f("bowser")},{bowser:1}]},{},[2])(2)});\n return module.exports; })(); (function () { var q;function aa(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var ba="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};\nfunction ca(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var ea=ca(this);function u(a,b){if(b)a:{var c=ea;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))break a;c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&ba(c,a,{configurable:!0,writable:!0,value:b})}}\nu("Symbol",function(a){function b(f){if(this instanceof b)throw new TypeError("Symbol is not a constructor");return new c(d+(f||"")+"_"+e++,f)}function c(f,g){this.g=f;ba(this,"description",{configurable:!0,writable:!0,value:g})}if(a)return a;c.prototype.toString=function(){return this.g};var d="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",e=0;return b});\nu("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=ea[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&ba(d.prototype,a,{configurable:!0,writable:!0,value:function(){return fa(aa(this))}})}return a});function fa(a){a={next:a};a[Symbol.iterator]=function(){return this};return a}\nfunction v(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];if(b)return b.call(a);if("number"==typeof a.length)return{next:aa(a)};throw Error(String(a)+" is not an iterable or ArrayLike");}function x(a){if(!(a instanceof Array)){a=v(a);for(var b,c=[];!(b=a.next()).done;)c.push(b.value);a=c}return a}var ha="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},ia;\nif("function"==typeof Object.setPrototypeOf)ia=Object.setPrototypeOf;else{var ja;a:{var ka={a:!0},la={};try{la.__proto__=ka;ja=la.a;break a}catch(a){}ja=!1}ia=ja?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var oa=ia;\nfunction pa(a,b){a.prototype=ha(b.prototype);a.prototype.constructor=a;if(oa)oa(a,b);else for(var c in b)if("prototype"!=c)if(Object.defineProperties){var d=Object.getOwnPropertyDescriptor(b,c);d&&Object.defineProperty(a,c,d)}else a[c]=b[c];a.Yc=b.prototype}function qa(){this.I=!1;this.j=null;this.A=void 0;this.g=1;this.s=this.l=0;this.T=this.h=null}function ra(a){if(a.I)throw new TypeError("Generator is already running");a.I=!0}qa.prototype.O=function(a){this.A=a};\nfunction sa(a,b){a.h={nc:b,rc:!0};a.g=a.l||a.s}qa.prototype.return=function(a){this.h={return:a};this.g=this.s};function ta(a,b,c){a.g=c;return{value:b}}qa.prototype.la=function(a){this.g=a};function ua(a){a.l=0;var b=a.h.nc;a.h=null;return b}function va(a){var b=a.T.splice(0)[0];(b=a.h=a.h||b)?b.rc?a.g=a.l||a.s:void 0!=b.la&&a.s<b.la?(a.g=b.la,a.h=null):a.g=a.s:a.g=0}function wa(a){this.g=new qa;this.h=a}\nfunction xa(a,b){ra(a.g);var c=a.g.j;if(c)return ya(a,"return"in c?c["return"]:function(d){return{value:d,done:!0}},b,a.g.return);a.g.return(b);return za(a)}function ya(a,b,c,d){try{var e=b.call(a.g.j,c);if(!(e instanceof Object))throw new TypeError("Iterator result "+e+" is not an object");if(!e.done)return a.g.I=!1,e;var f=e.value}catch(g){return a.g.j=null,sa(a.g,g),za(a)}a.g.j=null;d.call(a.g,f);return za(a)}\nfunction za(a){for(;a.g.g;)try{var b=a.h(a.g);if(b)return a.g.I=!1,{value:b.value,done:!1}}catch(c){a.g.A=void 0,sa(a.g,c)}a.g.I=!1;if(a.g.h){b=a.g.h;a.g.h=null;if(b.rc)throw b.nc;return{value:b.return,done:!0}}return{value:void 0,done:!0}}\nfunction Aa(a){this.next=function(b){ra(a.g);a.g.j?b=ya(a,a.g.j.next,b,a.g.O):(a.g.O(b),b=za(a));return b};this.throw=function(b){ra(a.g);a.g.j?b=ya(a,a.g.j["throw"],b,a.g.O):(sa(a.g,b),b=za(a));return b};this.return=function(b){return xa(a,b)};this[Symbol.iterator]=function(){return this}}function Ba(a){function b(d){return a.next(d)}function c(d){return a.throw(d)}return new Promise(function(d,e){function f(g){g.done?d(g.value):Promise.resolve(g.value).then(b,c).then(f,e)}f(a.next())})}\nfunction Ca(a){return Ba(new Aa(new wa(a)))}function Da(){for(var a=Number(this),b=[],c=a;c<arguments.length;c++)b[c-a]=arguments[c];return b}\nu("Promise",function(a){function b(g){this.h=0;this.j=void 0;this.g=[];this.I=!1;var h=this.l();try{g(h.resolve,h.reject)}catch(k){h.reject(k)}}function c(){this.g=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.h=function(g){if(null==this.g){this.g=[];var h=this;this.j(function(){h.s()})}this.g.push(g)};var e=ea.setTimeout;c.prototype.j=function(g){e(g,0)};c.prototype.s=function(){for(;this.g&&this.g.length;){var g=this.g;this.g=[];for(var h=0;h<g.length;++h){var k=\ng[h];g[h]=null;try{k()}catch(l){this.l(l)}}}this.g=null};c.prototype.l=function(g){this.j(function(){throw g;})};b.prototype.l=function(){function g(l){return function(m){k||(k=!0,l.call(h,m))}}var h=this,k=!1;return{resolve:g(this.Z),reject:g(this.s)}};b.prototype.Z=function(g){if(g===this)this.s(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.ma(g);else{a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.Y(g):this.A(g)}};\nb.prototype.Y=function(g){var h=void 0;try{h=g.then}catch(k){this.s(k);return}"function"==typeof h?this.ra(h,g):this.A(g)};b.prototype.s=function(g){this.O(2,g)};b.prototype.A=function(g){this.O(1,g)};b.prototype.O=function(g,h){if(0!=this.h)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.h);this.h=g;this.j=h;2===this.h&&this.fa();this.T()};b.prototype.fa=function(){var g=this;e(function(){if(g.X()){var h=ea.console;"undefined"!==typeof h&&h.error(g.j)}},1)};b.prototype.X=\nfunction(){if(this.I)return!1;var g=ea.CustomEvent,h=ea.Event,k=ea.dispatchEvent;if("undefined"===typeof k)return!0;"function"===typeof g?g=new g("unhandledrejection",{cancelable:!0}):"function"===typeof h?g=new h("unhandledrejection",{cancelable:!0}):(g=ea.document.createEvent("CustomEvent"),g.initCustomEvent("unhandledrejection",!1,!0,g));g.promise=this;g.reason=this.j;return k(g)};b.prototype.T=function(){if(null!=this.g){for(var g=0;g<this.g.length;++g)f.h(this.g[g]);this.g=null}};var f=new c;\nb.prototype.ma=function(g){var h=this.l();g.tb(h.resolve,h.reject)};b.prototype.ra=function(g,h){var k=this.l();try{g.call(h,k.resolve,k.reject)}catch(l){k.reject(l)}};b.prototype.then=function(g,h){function k(p,r){return"function"==typeof p?function(t){try{l(p(t))}catch(w){m(w)}}:r}var l,m,n=new b(function(p,r){l=p;m=r});this.tb(k(g,l),k(h,m));return n};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.tb=function(g,h){function k(){switch(l.h){case 1:g(l.j);break;case 2:h(l.j);\nbreak;default:throw Error("Unexpected state: "+l.h);}}var l=this;null==this.g?f.h(k):this.g.push(k);this.I=!0};b.resolve=d;b.reject=function(g){return new b(function(h,k){k(g)})};b.race=function(g){return new b(function(h,k){for(var l=v(g),m=l.next();!m.done;m=l.next())d(m.value).tb(h,k)})};b.all=function(g){var h=v(g),k=h.next();return k.done?d([]):new b(function(l,m){function n(t){return function(w){p[t]=w;r--;0==r&&l(p)}}var p=[],r=0;do p.push(void 0),r++,d(k.value).tb(n(p.length-1),m),k=h.next();\nwhile(!k.done)})};return b});function Ea(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return{value:b(f,a[f]),done:!1}}d=!0;return{done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e}u("Array.prototype.keys",function(a){return a?a:function(){return Ea(this,function(b){return b})}});u("Number.EPSILON",function(){return Math.pow(2,-52)});u("Number.MIN_SAFE_INTEGER",function(){return-9007199254740991});\nfunction Fa(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var f=a[e];if(b.call(c,f,e,a))return{qc:e,vc:f}}return{qc:-1,vc:void 0}}u("Array.prototype.find",function(a){return a?a:function(b,c){return Fa(this,b,c).vc}});\nfunction Ga(a,b,c){if(null==a)throw new TypeError("The \'this\' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""}u("String.prototype.startsWith",function(a){return a?a:function(b,c){var d=Ga(this,b,"startsWith"),e=d.length,f=b.length;c=Math.max(0,Math.min(c|0,d.length));for(var g=0;g<f&&c<e;)if(d[c++]!=b[g++])return!1;return g>=f}});\nu("Promise.prototype.finally",function(a){return a?a:function(b){return this.then(function(c){return Promise.resolve(b()).then(function(){return c})},function(c){return Promise.resolve(b()).then(function(){throw c;})})}});function Ha(a,b){return Object.prototype.hasOwnProperty.call(a,b)}\nu("WeakMap",function(a){function b(k){this.g=(h+=Math.random()+1).toString();if(k){k=v(k);for(var l;!(l=k.next()).done;)l=l.value,this.set(l[0],l[1])}}function c(){}function d(k){var l=typeof k;return"object"===l&&null!==k||"function"===l}function e(k){if(!Ha(k,g)){var l=new c;ba(k,g,{value:l})}}function f(k){var l=Object[k];l&&(Object[k]=function(m){if(m instanceof c)return m;Object.isExtensible(m)&&e(m);return l(m)})}if(function(){if(!a||!Object.seal)return!1;try{var k=Object.seal({}),l=Object.seal({}),\nm=new a([[k,2],[l,3]]);if(2!=m.get(k)||3!=m.get(l))return!1;m.delete(k);m.set(l,4);return!m.has(k)&&4==m.get(l)}catch(n){return!1}}())return a;var g="$jscomp_hidden_"+Math.random();f("freeze");f("preventExtensions");f("seal");var h=0;b.prototype.set=function(k,l){if(!d(k))throw Error("Invalid WeakMap key");e(k);if(!Ha(k,g))throw Error("WeakMap key fail: "+k);k[g][this.g]=l;return this};b.prototype.get=function(k){return d(k)&&Ha(k,g)?k[g][this.g]:void 0};b.prototype.has=function(k){return d(k)&&Ha(k,\ng)&&Ha(k[g],this.g)};b.prototype.delete=function(k){return d(k)&&Ha(k,g)&&Ha(k[g],this.g)?delete k[g][this.g]:!1};return b});\nu("Map",function(a){function b(){var h={};return h.za=h.next=h.head=h}function c(h,k){var l=h[1];return fa(function(){if(l){for(;l.head!=h[1];)l=l.za;for(;l.next!=l.head;)return l=l.next,{done:!1,value:k(l)};l=null}return{done:!0,value:void 0}})}function d(h,k){var l=k&&typeof k;"object"==l||"function"==l?f.has(k)?l=f.get(k):(l=""+ ++g,f.set(k,l)):l="p_"+k;var m=h[0][l];if(m&&Ha(h[0],l))for(h=0;h<m.length;h++){var n=m[h];if(k!==k&&n.key!==n.key||k===n.key)return{id:l,list:m,index:h,W:n}}return{id:l,\nlist:m,index:-1,W:void 0}}function e(h){this[0]={};this[1]=b();this.size=0;if(h){h=v(h);for(var k;!(k=h.next()).done;)k=k.value,this.set(k[0],k[1])}}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return!1;try{var h=Object.seal({x:4}),k=new a(v([[h,"s"]]));if("s"!=k.get(h)||1!=k.size||k.get({x:4})||k.set({x:4},"t")!=k||2!=k.size)return!1;var l=k.entries(),m=l.next();if(m.done||m.value[0]!=h||"s"!=m.value[1])return!1;m=l.next();return m.done||4!=m.value[0].x||\n"t"!=m.value[1]||!l.next().done?!1:!0}catch(n){return!1}}())return a;var f=new WeakMap;e.prototype.set=function(h,k){h=0===h?0:h;var l=d(this,h);l.list||(l.list=this[0][l.id]=[]);l.W?l.W.value=k:(l.W={next:this[1],za:this[1].za,head:this[1],key:h,value:k},l.list.push(l.W),this[1].za.next=l.W,this[1].za=l.W,this.size++);return this};e.prototype.delete=function(h){h=d(this,h);return h.W&&h.list?(h.list.splice(h.index,1),h.list.length||delete this[0][h.id],h.W.za.next=h.W.next,h.W.next.za=h.W.za,h.W.head=\nnull,this.size--,!0):!1};e.prototype.clear=function(){this[0]={};this[1]=this[1].za=b();this.size=0};e.prototype.has=function(h){return!!d(this,h).W};e.prototype.get=function(h){return(h=d(this,h).W)&&h.value};e.prototype.entries=function(){return c(this,function(h){return[h.key,h.value]})};e.prototype.keys=function(){return c(this,function(h){return h.key})};e.prototype.values=function(){return c(this,function(h){return h.value})};e.prototype.forEach=function(h,k){for(var l=this.entries(),m;!(m=\nl.next()).done;)m=m.value,h.call(k,m[1],m[0],this)};e.prototype[Symbol.iterator]=e.prototype.entries;var g=0;return e});u("Array.prototype.findIndex",function(a){return a?a:function(b,c){return Fa(this,b,c).qc}});\nu("Set",function(a){function b(c){this.g=new Map;if(c){c=v(c);for(var d;!(d=c.next()).done;)this.add(d.value)}this.size=this.g.size}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return!1;try{var c=Object.seal({x:4}),d=new a(v([c]));if(!d.has(c)||1!=d.size||d.add(c)!=d||1!=d.size||d.add({x:4})!=d||2!=d.size)return!1;var e=d.entries(),f=e.next();if(f.done||f.value[0]!=c||f.value[1]!=c)return!1;f=e.next();return f.done||f.value[0]==c||4!=f.value[0].x||\nf.value[1]!=f.value[0]?!1:e.next().done}catch(g){return!1}}())return a;b.prototype.add=function(c){c=0===c?0:c;this.g.set(c,c);this.size=this.g.size;return this};b.prototype.delete=function(c){c=this.g.delete(c);this.size=this.g.size;return c};b.prototype.clear=function(){this.g.clear();this.size=0};b.prototype.has=function(c){return this.g.has(c)};b.prototype.entries=function(){return this.g.entries()};b.prototype.values=function(){return this.g.values()};b.prototype.keys=b.prototype.values;b.prototype[Symbol.iterator]=\nb.prototype.values;b.prototype.forEach=function(c,d){var e=this;this.g.forEach(function(f){return c.call(d,f,f,e)})};return b});u("String.fromCodePoint",function(a){return a?a:function(b){for(var c="",d=0;d<arguments.length;d++){var e=Number(arguments[d]);if(0>e||1114111<e||e!==Math.floor(e))throw new RangeError("invalid_code_point "+e);65535>=e?c+=String.fromCharCode(e):(e-=65536,c+=String.fromCharCode(e>>>10&1023|55296),c+=String.fromCharCode(e&1023|56320))}return c}});\nu("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}});u("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length;c=c||0;for(0>c&&(c=Math.max(c+e,0));c<e;c++){var f=d[c];if(f===b||Object.is(f,b))return!0}return!1}});u("String.prototype.includes",function(a){return a?a:function(b,c){return-1!==Ga(this,b,"includes").indexOf(b,c||0)}});\nu("Array.from",function(a){return a?a:function(b,c,d){c=null!=c?c:function(h){return h};var e=[],f="undefined"!=typeof Symbol&&Symbol.iterator&&b[Symbol.iterator];if("function"==typeof f){b=f.call(b);for(var g=0;!(f=b.next()).done;)e.push(c.call(d,f.value,g++))}else for(f=b.length,g=0;g<f;g++)e.push(c.call(d,b[g],g));return e}});u("Array.prototype.entries",function(a){return a?a:function(){return Ea(this,function(b,c){return[b,c]})}});\nu("String.prototype.replaceAll",function(a){return a?a:function(b,c){if(b instanceof RegExp&&!b.global)throw new TypeError("String.prototype.replaceAll called with a non-global RegExp argument.");return b instanceof RegExp?this.replace(b,c):this.replace(new RegExp(String(b).replace(/([-()\\[\\]{}+?*.$\\^|,:#<!\\\\])/g,"\\\\$1").replace(/\\x08/g,"\\\\x08"),"g"),c)}});\nu("WeakSet",function(a){function b(c){this.g=new WeakMap;if(c){c=v(c);for(var d;!(d=c.next()).done;)this.add(d.value)}}if(function(){if(!a||!Object.seal)return!1;try{var c=Object.seal({}),d=Object.seal({}),e=new a([c]);if(!e.has(c)||e.has(d))return!1;e.delete(c);e.add(d);return!e.has(c)&&e.has(d)}catch(f){return!1}}())return a;b.prototype.add=function(c){this.g.set(c,!0);return this};b.prototype.has=function(c){return this.g.has(c)};b.prototype.delete=function(c){return this.g.delete(c)};return b});\nu("Promise.allSettled",function(a){function b(d){return{status:"fulfilled",value:d}}function c(d){return{status:"rejected",reason:d}}return a?a:function(d){var e=this;d=Array.from(d,function(f){return e.resolve(f).then(b,c)});return e.all(d)}});u("String.prototype.repeat",function(a){return a?a:function(b){var c=Ga(this,null,"repeat");if(0>b||1342177279<b)throw new RangeError("Invalid count value");b|=0;for(var d="";b;)if(b&1&&(d+=c),b>>>=1)c+=c;return d}});\nu("Math.sign",function(a){return a?a:function(b){b=Number(b);return 0===b||isNaN(b)?b:0<b?1:-1}});u("Object.entries",function(a){return a?a:function(b){var c=[],d;for(d in b)Ha(b,d)&&c.push([d,b[d]]);return c}});function Ia(a,b,c){return Ja(a,2,0,b,c)}function Ja(a,b,c,d,e){if(0>=d)return-1;d=c+d-1;for(var f=c,g=1;g&&c<=d;)f=c+d>>>1,g=e(a,f),0>g?d=f-1:0<g&&(c=f+1);0!==g&&0===b?f=-1:0>g&&1===b?f--:0<g&&2===b&&f++;return f};function Ka(){if("object"===typeof self)return self;if("object"===typeof window)return window;if("object"===typeof global)return global;throw Error("Unable to get global this");}function A(a){return a&&1===a.nodeType}function B(a){return a&&C(a.nodeType)}function D(a){return a&&A(a)&&"http://www.w3.org/1999/xhtml"===a.namespaceURI}function La(a){return a&&A(a)&&"http://www.w3.org/2000/svg"===a.namespaceURI}function Ma(a){return E(a)&&/\\S/.test(a)}function Na(a){return E(a)&&/^\\s*$/.test(a)}\nfunction F(a){return a&&3===a.nodeType}function Oa(a){return F(a)&&Ma(a.data)}function Pa(a){return"undefined"===typeof a}function H(a,b,c){return a<b?b:a>c?c:a}var Qa=Array.isArray;function I(a){return"function"===typeof a}function C(a){return"number"===typeof a&&!isNaN(a)}function Ra(a){return a&&!Qa(a)&&"object"===typeof a}function E(a){return"string"===typeof a}function Sa(){}var Ta=Function.prototype.call.bind(Object.prototype.hasOwnProperty);function Ua(a,b){for(var c=Math.min(a.length,b.length),d=0;d<c;d++){var e=a[d],f=b[d];if(e<f)return-1;if(e>f)return 1}return a.length===b.length?0:a.length<b.length?-1:1}\nfunction Va(){for(var a=[{name:"style",value:"position: absolute; z-index: -100000000; left: 0; right: 0; top: 0; bottom: 0; opacity: 0"},{name:"id",value:"colibrio-ios-nativezoom-preventer"}],b=document.createElement("div"),c=0;c<a.length;c++){var d=a[c];d.namespaceUri?b.setAttributeNS(d.namespaceUri,d.name,d.value):b.setAttribute(d.name,d.value)}return b}function K(a){if(a.body)return a.body;var b=a.documentElement.children[1];return b&&"body"===b.localName?b:a.documentElement}\nfunction L(a){return a.ownerDocument.defaultView.getComputedStyle(a)}function Wa(a){return a.head?a.head:a.firstElementChild&&"head"===a.firstElementChild.localName?a.firstElementChild:a.documentElement}function Xa(a){for(var b=0;a=a.previousSibling;)b++;return b}function Ya(a){for(var b=0;a.parentNode;)b++,a=a.parentNode;return b}function Za(a,b){for(var c=[];b&&b!==a;)c.push(Xa(b)),b=b.parentNode;return b===a?c.reverse():null}\nfunction $a(a){a=a.getBoundingClientRect();return 0<a.width||0<a.height}function ab(a){return"base"===a||"head"===a||"link"===a||"meta"===a||"noscript"===a||"script"===a||"style"===a||"title"===a}\nfunction bb(a){var b=a.localName,c=[{tag:"button"},{tag:"details"},{tag:"embed"},{tag:"label"},{tag:"select"},{tag:"textarea"},{tag:"iframe"},{$a:"href",tag:"a"},{$a:"controls",tag:"audio"},{$a:"usemap",tag:"img"},{$a:"usemap",tag:"object"},{$a:"controls",tag:"video"}],d="input"===b&&"hidden"!==a.getAttribute("type");return a.hasAttribute("contenteditable")||d||c.some(function(e){var f=e.tag;return(e=e.$a)?f===b&&a.hasAttribute(e):f===b})}function cb(a){return A(a)?"math"===a.localName:!1}\nfunction db(a){if(D(a))switch(a.localName){case "img":case "video":case "audio":return!0}return La(a)&&"image"===a.localName}function N(a,b,c){if(a.style)a.style.setProperty(b,c,"important");else{var d=a.getAttribute("style")||"";a.setAttribute("style",d+"; "+b+": "+c+" !important;")}};function eb(a){return"x"in a?a:new DOMRect(a.left,a.top,a.width,a.height)};function fb(a,b){return a.reduce(function(c,d){return c.then(function(){return b(d)})},Promise.resolve())}function gb(a){return Ca(function(b){return b.return(new Promise(function(c){return setTimeout(c,a)}))})};var hb=new Uint16Array(1);hb[0]=4660;new Uint8Array(hb.buffer);function ib(a,b){return"data:"+a+";base64,"+b}function jb(a){return/^\\s*data:/.test(a)||/^\\s*blob:/.test(a)||/^\\s*https?:/.test(a)};function kb(a,b,c){var d=Error.call(this,"["+a+"] "+b+" :: "+(c||""));this.message=d.message;"stack"in d&&(this.stack=d.stack);this.namespace=a;this.errorType=b;this.errorMessage=c||""}pa(kb,Error);kb.isColibrioError=lb;kb.isColibrioAbortedError=mb;function lb(a){return a instanceof kb||a&&E(a.errorType)&&E(a.namespace)}function mb(a){return lb(a)&&"ABORTED"===a.errorType||a instanceof DOMException&&(a.code===DOMException.ABORT_ERR||"AbortError"===a.name)};var nb=[Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array];function ob(a,b){var c=this.length;"number"!==typeof a&&(a=0);"number"!==typeof b&&(b=c);0>a&&(a=c+a);0>b&&(b=c+b);c=this.constructor;a=a*c.BYTES_PER_ELEMENT+this.byteOffset;b=b*c.BYTES_PER_ELEMENT+this.byteOffset;return new c(this.buffer.slice(a,b))}\nif(!("slice"in nb[0].prototype))for(var pb=0;pb<nb.length;pb++)Object.defineProperty(nb[pb].prototype,"slice",{configurable:!0,value:ob,writable:!0});function O(a){var b=Error.call(this,"[colibrio.internal] "+(a||""));this.message=b.message;"stack"in b&&(this.stack=b.stack);this.errorMessage=a}pa(O,Error);function qb(){this.j=0;this.g=rb(null,null,null);this.h=rb(null,this.g,null);this.g.K=this.h}q=qb.prototype;q.clear=function(){this.g=rb(null,null,null);this.h=rb(null,this.g,null);this.g.K=this.h;this.j=0};q.every=function(a){for(var b=this.g.K,c=!0;b!==this.h&&c;){var d=b.K;c=a(b);b=null===b.K?d:b.K}return c};q.find=function(a){for(var b=this.g.K,c=null;b!==this.h&&null===c;){var d=b.K;a(b)&&(c=b);b=null===b.K?d:b.K}return c};\nq.forEach=function(a){for(var b=this.g.K;b!==this.h;){var c=b.K;a(b);b=null===b.K?c:b.K}};function sb(a,b){return(b=b.K)&&a.h!==b?b:null}q.pop=function(){var a=tb(this);return a?a.U:null};function tb(a){if(0===a.j)return null;var b=a.h.$;ub(a,b);return b}q.push=function(a){a=rb(a,this.h.$,this.h);a.$.K=a;this.h.$=a;this.j++;return a};q.remove=function(a){for(var b=this.g,c=!1;!c&&b!==this.h;)b=b.K,c=b.U===a;c&&b!==this.h&&ub(this,b)};\nq.shift=function(){if(0===this.j)var a=null;else a=this.g.K,ub(this,a);return a?a.U:null};q.size=function(){return this.j};q.unshift=function(a){a=rb(a,this.g,this.g.K);a.K.$=a;this.g.K=a;this.j++;return a};function rb(a,b,c){return{U:a,K:c,$:b}}function ub(a,b){if(b.$&&b.K){var c=b.$,d=b.K;c.K=d;d.$=c;b.K=null;b.$=null;a.j--}};function vb(a){this.h=a;this.l=null;this.g=new qb;this.j=new qb}function wb(a,b){return a.h?new Promise(function(c,d){var e,f=a.g;for(e=f.j?f.g.K:null;e&&0>e.U.Jc;)e=sb(a.g,e);f=a.g;c={zc:b,Jc:0,ka:d,Ea:c,jc:null};e&&e.$?(c=rb(c,e.$,e),e.$.K=c,e.$=c,f.j++):f.push(c);xb(a)}):Promise.reject(new O("Cannot call scheduleDefaultTask() because no defaultTask was specified."))}\nfunction yb(a,b){var c=a.j.push(b);Promise.resolve().then(function(){if(b.jc)return b.jc();if(a.h)return a.h(b.zc)}).then(function(d){b.Ea(d)}).catch(function(d){b.ka(d)}).finally(function(){ub(a.j,c);xb(a)}).catch(function(d){console.error(d)})}function xb(a){Promise.resolve().then(function(){if(4>a.j.size()){var b;null==(b=a.l)||b.call(a);(b=tb(a.g))&&yb(a,b.U)}}).catch(function(b){console.error("Unexpected error in InternalAsyncTaskQueue.maybeExecuteNextTask",b)})};function zb(a,b,c){var d=Error.call(this,"["+a+"] "+b+" :: "+(c||""));this.message=d.message;"stack"in d&&(this.stack=d.stack);this.namespace=a;this.errorType=b;this.errorMessage=c||""}pa(zb,Error);function Ab(a,b,c){this.A=a;this.fa=b;this.ma=c;this.s=!1;this.T=null;this.j=new Map;this.X=this.l=1;this.h=[];this.I=-1}function Bb(a){var b=Cb(a,1,{}),c=Db(a,b);Eb(a,Fb(a));Gb(a,b);return c.then(function(){return a})}\nfunction Hb(){var a=new Ib(self,window.parent,"*","colibrio.readingsystem.formatadapter.epub.iframe",3E4,Jb);return new Promise(function(b,c){function d(f){Kb(a,f)&&(f=f.data,a.Y.removeEventListener("message",d,!1),1===f.type?(a.s=!0,a.l=f.msgId+1,Eb(a,Fb(a)),Gb(a,{msg:null,msgId:f.msgId,type:2}),clearTimeout(e),b()):c("Received invalid connect message"))}var e=setTimeout(function(){a.Y.removeEventListener("message",d,!1);c(new zb(a.A,"TIMEOUT"))},a.fa);Eb(a,d)})}\nfunction P(a,b){b=Cb(a,4,b);try{Gb(a,b)}catch(c){throw a.X--,c;}}Ab.prototype.g=function(a,b,c){if(!this.s)throw new zb(this.A,"NOT_CONNECTED");a=Cb(this,3,a);c=Db(this,a,c);try{Gb(this,a,b)}catch(d){this.X--,a.msg=d.toString(),Lb(this,a)}return c};function Cb(a,b,c){return{msg:c,msgId:a.X++,type:b}}\nfunction Lb(a,b){var c=a.j.get(b.msgId);c&&(a.j.delete(b.msgId),-1!==c.Xa&&clearTimeout(c.Xa),a=(b=b.msg)&&b.errorMessage&&b.errorType?new zb(a.A,"ABORTED"===b.errorType?"ABORTED":"REMOTE_ERROR",b.errorType+" :: "+b.errorMessage+" :: "+b.stack):new zb(a.A,"ABORTED"===(null==b?void 0:b.errorType)?"ABORTED":"REMOTE_ERROR",E(b)?b:JSON.stringify(b)),c.ka(a))}function Mb(a,b){var c=a.j.get(b.msgId);c&&(a.j.delete(b.msgId),-1!==c.Xa&&clearTimeout(c.Xa),c.Ea(b.msg))}\nfunction Fb(a){a.T||(a.T=function(b){if(Kb(a,b))switch(b=b.data,b.type){case 2:a.s=!0;Mb(a,b);break;case 3:case 4:a.l===b.msgId?(a.l++,Nb(a,b),0<a.h.length&&Ob(a,!1)):Pb(a,b);break;case 5:Mb(a,b);break;case 6:Lb(a,b)}});return a.T}function Pb(a,b){console.log("Incoming out of order message: ",b.msgId,", expected: ",a.l);var c=a.h.findIndex(function(d){return d.msgId>b.msgId});0<=c?a.h.splice(c,0,b):a.h.push(b);-1===a.I&&(a.I=setTimeout(function(){a.I=-1;Ob(a,!0)},2E3))}\nfunction Nb(a,b){switch(b.type){case 3:try{a.ma.pc(b.msg,a).then(function(c){if(c&&c.Tb&&c.message){var d=c.Tb;c=c.message}a.s&&Gb(a,{msg:c,msgId:b.msgId,type:5},d)}).catch(function(c){c&&"ABORTED"!==c.errorType&&console.error(c);Qb(a,b,c)})}catch(c){c&&"ABORTED"!==c.errorType&&console.error(c),Qb(a,b,c)}break;case 4:a.ma.oc(b.msg,a)}}function Ob(a,b){for(;0<a.h.length&&(b||a.h[0].msgId===a.l);){var c=a.h.shift();a.l=c.msgId+1;Nb(a,c)}0===a.h.length&&-1!==a.I&&clearTimeout(a.I)}\nfunction Qb(a,b,c){var d;c&&E(c.errorType)&&E(c.errorMessage)?d={errorMessage:c.errorMessage,errorType:c.errorType,stack:E(c.stack)?c.stack:""}:c&&(c.message?d={errorMessage:c.message,errorType:c.constructor?c.constructor.name:""+c,stack:E(c.stack)?c.stack:""}:d=E(c.stack)?c.stack:""+c);Gb(a,{msg:d,msgId:b.msgId,type:6})}\nfunction Db(a,b,c){return new Promise(function(d,e){d={ka:e,Ea:d,Xa:-1};a.j.set(b.msgId,d);d.Xa=setTimeout(function(){a.j.has(b.msgId)&&(a.j.delete(b.msgId),e(new zb(a.A,"TIMEOUT")))},c||a.fa)})};function Rb(a,b,c,d,e,f){Ab.call(this,d,e,f);this.Y=a;this.Z=b;this.O=c}pa(Rb,Ab);function Eb(a,b){a.Y.addEventListener("message",b,!1)}function Kb(a,b){if(b.source!==a.Z||!b.data||"*"!==a.O&&a.O!==b.origin)return!1;a=b.data;return C(a.type)&&C(a.msgId)}function Gb(a,b,c){c?a.Z.postMessage(b,a.O,c):a.Z.postMessage(b,a.O)};function Ib(a,b,c,d,e,f){Rb.call(this,a,b,c,d,e,f);var g=this;this.ra=new vb(function(h){return Rb.prototype.g.call(g,h.Fc,h.Pc,h.Nc)})}pa(Ib,Rb);Ib.prototype.g=function(a,b,c){return wb(this.ra,{Fc:a,Nc:c,Pc:b})};function Sb(a,b,c){this.B=b;this.F=c;Q(a,"copy",this,!0)}Sb.prototype.Ma=function(a){P(this.B,{type:41});var b=this.F.allowCopy,c=this.F.textToAppendOnCopy,d=this.F.textToPrependOnCopy;if(!b||c||d)a.stopImmediatePropagation(),a.cancelable&&a.preventDefault();b&&a.clipboardData&&(b=document.getSelection())&&(a.clipboardData.setData("text/plain",(d||"")+(-1<b.toString().indexOf(" ")?b.toString():b.getRangeAt(0).toString())+(c||"")),a.preventDefault())};function Tb(){}Tb.prototype.logError=function(){this.g.apply(this,["error"].concat(x(Da.apply(0,arguments))))};Tb.prototype.logInfo=function(){this.g.apply(this,["info"].concat(x(Da.apply(0,arguments))))};Tb.prototype.logWarning=function(){this.g.apply(this,["warn"].concat(x(Da.apply(0,arguments))))};Tb.prototype.g=function(a){var b=Da.apply(1,arguments);"undefined"!==typeof console&&console[a]&&console[a].apply(console,x(b))};var Ub;function R(){Ub.logError.apply(Ub,x(Da.apply(0,arguments)))}function Vb(){Ub.logInfo.apply(Ub,x(Da.apply(0,arguments)))}function S(){Ub.logWarning.apply(Ub,x(Da.apply(0,arguments)))}var Wb=!1;(function(a){if(!Wb){Wb=!0;var b=Ka();b&&I(b.addEventListener)&&b.addEventListener("unhandledrejection",function(c){R("Unhandled Promise rejection",c.reason);c.cancelable&&c.preventDefault()})}Ub=a})(new Tb);function Xb(){this.ta=[]}Xb.prototype.Ta=function(){for(var a=0;a<this.ta.length;a++){var b=this.ta[a];if(b.Ta)try{b.Ta()}catch(c){S(c)}}};Xb.prototype.da=function(){for(var a=0;a<this.ta.length;a++){var b=this.ta[a];if(b.da)try{b.da()}catch(c){S(c)}}};function Yb(a){if(!A(a))return null;var b=null;A(a.parentNode)&&(b=Yb(a.parentNode));for(var c=[],d=0;d<a.attributes.length;d++){var e=a.attributes[d];"src"!==e.localName&&(1E4<e.value.length?console.warn(\'Skipped attribute "\'+e.name+\'" on <\'+a.tagName+">. The value exceeded the maximum length."):c.push({localName:e.localName,namespaceURI:e.namespaceURI,prefix:e.prefix,value:e.value}))}return{attributes:c,namespaceURI:a.namespaceURI,nodeName:a.localName,nodeType:1,parent:b,prefix:a.prefix}};function $b(a,b){kb.call(this,"colibrio.readingsystem.formatadapter.epub.iframe",a,b)}pa($b,kb);function ac(a){return a.ownerDocument?Za(K(a.ownerDocument),a):null}function U(a){var b=a.parentNode;return A(b)?(b=ac(b))?{o:b,i:Xa(a)}:{o:[],i:0}:null}function bc(a,b){return(a=ac(a))?{o:a,i:b}:null}function cc(a,b){for(var c=-1,d=0;d<a.o.length&&-1===c;d++){var e=a.o[d];0>e?c=0:e>=b.childNodes.length?c=b.childNodes.length:b=b.childNodes[e]}-1===c&&(c=A(b)?H(a.i,0,b.childNodes.length):F(b)?H(a.i,0,b.data.length):0);return{m:b,i:c}}\nfunction dc(a,b){var c=a.o,d=b.o.length,e=c.findIndex(function(g){return 0<g});-1===e&&(e=c.length);for(var f=0;f<d&&f<e;f++)c[f]+=b.o[f];e>d?c[d]+=b.i:e===d?c.length>e?c[e]+=b.i:a.i+=b.i:e<c.length?c[e]+=b.o[e]:a.i+=b.o[e]}function V(a,b){return a.length<=b.length&&a.every(function(c,d){return b[d]===c})}\nfunction ec(a){return a.map(function(b){var c=b.containerPath,d=b.offset,e=b.type,f="text"===b.containerType?Node.TEXT_NODE:Node.ELEMENT_NODE;return 6===b.type?{o:c,Aa:f,i:d,kc:b.textLengths,u:e}:10===b.type?{o:c,Aa:f,Da:b.endOffset,i:d,Qb:b.textNodeLength,u:e}:{o:c,Aa:f,i:d,u:e}})};function fc(a,b){var c={o:a.o.slice(),i:a.i};b=v(b);for(var d=b.next();!d.done;d=b.next()){var e=d.value;switch(e.u){case 1:d=e;e=c;var f=d.o,g=e.o,h=f.length,k=g.length;V(f,g)&&(h<k?d.i<=g[h]&&g[h]++:d.i<=e.i&&e.i++);break;case 2:d=e;e=c;h=d.o;f=e.o;g=h.length;k=f.length;V(h,f)&&(g<k?(h=f[g],d.i<h?f[g]--:d.i===h&&(f.length=g,e.i=h)):d.i<e.i&&e.i--);break;case 4:d=e;e=c;f=d.o;g=e.o;h=f.length;k=g.length;for(var l=-1,m=0;m<h&&m<k&&-1===l;m++)g[m]!==f[m]?l=m:g[m]=0;0<=l?g[l]-=f[l]:h>k?e.i-=f[k]:h===\nk?e.i-=d.i:g[h]-=d.i;break;case 5:d=e;e=c;f=d.o;g=e.o;h=f.length;k=g.length;l=f.slice(0,h-1);m=f[h-1];!V(f,g)&&V(l,g)&&(k===l.length?e.i===m+1?(g.push(m),e.i=d.i):e.i>m&&e.i--:k===h?g[k-1]===f[h-1]+1&&(g[h-1]--,e.i+=d.i):g[h-1]>f[h-1]&&g[h-1]--);break;case 6:d=e;e=c;f=a;k=d.o;g=e.o;h=k.length;l=g.length;if(V(k,g))if(k=d.kc,h<l)if(d.i<g[h])g[h]+=k.length-1;else{if(h===l-1&&d.i===g[h])for(m=l=0;m<k.length;m++){var n=l+k[m];if(n>=f.i){g[h]=m+d.i;g.push(0);e.i=f.i-l;break}l=n}}else h===l&&(d.i===e.i?\n(g.push(0),e.i=0):d.i<e.i&&(e.i+=k.length-1));break;case 7:d=c;e=e.o;f=d.o;g=e.length;h=f.length;V(e,f)&&g===h&&(d.i=0);break;case 8:d=e;e=c;f=d.o;g=e.o;h=f.length;k=g.length;V(f,g)&&(h<k?g[h]===d.i&&g.splice(h+1,0,0):h===k&&d.i===e.i&&(g.push(d.i),e.i=0));break;case 9:d=e.o;e=c.o;V(d,e)&&e.splice(d.length,0,0);break;case 10:d=e;e=c;f=d.o;g=e.o;h=f.length;k=g.length;l=f.slice(0,h-1);m=l.length;n=0===d.i;var p=d.Da===d.Qb,r=n&&p;V(l,g)&&(h<k?!r&&f[m]<g[m]&&(g[h-1]+=n||p?1:2):m===k?!r&&f[h-1]<e.i?e.i+=\nn||p?1:2:f[h-1]===e.i&&n&&g.push(0):h===k&&f[h-1]<g[h-1]?r||(g[h-1]+=n||p?1:2):f[h-1]===g[k-1]&&d.i<=e.i&&(d.Da>e.i||d.Da===e.i&&p?(g[k-1]+=n?0:1,g.push(0),e.i-=d.i):d.Da<=e.i&&(g[k-1]+=n?1:2,e.i-=d.Da)))}}return c};function gc(a,b){this.j=!0;this.R=this.g=a;this.h=b||null}function W(a,b){if(null!==a.g){var c=a.l(b);for(a.j=!1;null!==a.g&&a.h&&!a.h(a.g);)c+=a.l(b)}}gc.prototype.next=function(a){if(this.j&&(!this.h||this.h(this.g)))return this.j=!1,this.g;W(this,a);return this.g};\ngc.prototype.l=function(a){var b=this.g,c=0;if(b.firstChild&&(I(a)?a(b):a))this.g=b.firstChild,c=1;else if(b!==this.R&&b.nextSibling)this.g=b.nextSibling;else{for(;b!==this.R&&!b.nextSibling;)b=b.parentNode,c--;b===this.R?this.g=null:this.g=b.nextSibling}return c};function hc(){gc.apply(this,arguments)}pa(hc,gc);hc.prototype.l=function(a){var b=this.g,c=0;if(this.j&&b.lastChild&&(I(a)?a(b):a)){for(;b.lastChild&&(I(a)?a(b):a);)b=b.lastChild,c++;this.g=b}else if(b!==this.R&&b.previousSibling){for(b=b.previousSibling;b.lastChild&&(I(a)?a(b):a);)b=b.lastChild,c++;this.g=b}else b!==this.R&&b.parentNode?(this.g=b.parentNode,c=-1):this.g=null;return c};hc.prototype.next=function(a){W(this,a);return this.g};function ic(a,b,c){c=void 0===c?null:c;var d=jc(a),e=a;d?kc(d)||(e=lc(d)):e=lc(a.m,{Sb:!0});if(null===e)return null;a=jc(e);if(null===a)return null;if(mc(a))return nc(a);if(A(a))return a;for(F(a)&&A(e.m)&&(e={m:a,i:0});e.i<a.data.length&&Na(a.data[e.i]);)e.i++;if(e.i===a.data.length)return ic(e,b);e.i=oc(a,e.i,{direction:"backward",granularity:b,publicationLanguage:c});var f;return Na(a.data.slice(0,e.i))&&(null==(f=a.parentElement)?void 0:f.firstChild)===a&&A(d)?a.parentElement:{i:e.i,Pb:e.m}}\nfunction pc(a){var b=jc(a),c=a;b?kc(b)||(c=lc(b)):c=lc(a.m,{Sb:!0});a=c?jc(c):null;if(null===a)return null;if(mc(a))return nc(a);if(A(a))return a;var d;if((null==(d=a.parentElement)?void 0:d.firstChild)===a)return a.parentElement;d=new hc(a);d.R=a.parentElement;W(d,!0);for(b=null;null===b&&d.g;)kc(d.g)&&(b=d.g),W(d,!0);d=b;return null===d?a.parentElement:F(d)?d.parentElement:d}\nfunction oc(a,b,c){var d=a.data,e=c.granularity,f="sentence"===e?d.replace(/\\s/g," "):d;if("undefined"!==typeof Intl&&"function"===typeof Intl.Segmenter){a:{d=A(a)?a:a.parentNode;for(a=null;!a&&A(d);){if(a=d.getAttribute("lang")||d.getAttribute("xml:lang")){d=a;break a}d=d.parentNode}d=void 0}if(!d){var g;d=null!=(g=c.publicationLanguage)?g:void 0}e=(new Intl.Segmenter(d,{granularity:e})).segment(f).containing(b);b=e.index;e=e.index+e.segment.length;return"forward"===c.direction?e:b}if("grapheme"===\ne)return e=d.charCodeAt(b),56320<=e&&57343>=e?"forward"===c.direction?b+1:b-1:55296<=e&&56319>=e?"forward"===c.direction?b+2:b:"forward"===c.direction?b+1:b;if("backward"===c.direction)for(;0<b&&Ma(d[b-1]);)b--;else for(;b<d.length&&Ma(d[b]);)b++;return b}function jc(a){return A(a.m)?a.i<a.m.childNodes.length?a.m.childNodes[a.i]:null:F(a.m)&&a.i<a.m.data.length?a.m:null}\nfunction lc(a,b){b=void 0===b?{Sb:!1}:b;a=new gc(a);a.R=null;b.Sb&&W(a,!1);for(b=null;null===b&&a.g;)kc(a.g)&&(b=a.g),W(a,!0);if(!b)return null;a=b.ownerDocument;if(!a)throw new O("Failed to get document for focusableNode");a=K(a);b=U(b);if(!b)throw new O("Failed to get domPosition for focusableNode");return cc(b,a)}\nfunction kc(a){var b=A(a)&&a.hasAttribute("aria-hidden")?"true"===a.getAttribute("aria-hidden"):!1;if(A(a)&&$a(a)&&!b){if(!(b=bb(a)||db(a)||cb(a)||La(a))){b=a.getAttribute("role");var c=!1;b&&(c=qc.has(b));b=c}b=b||a.hasAttribute("tabindex")}else b=!1;return b||!!(Oa(a)&&A(a.parentElement)&&$a(a.parentElement))}function mc(a){return F(a)?A(a.parentElement)&&!D(a.parentElement):A(a)&&!D(a)}function nc(a){for(var b=null;!b&&a.parentNode;)D(a.parentNode)&&(b=a),a=a.parentNode;return b}var qc=new Set("grid treegrid tree listbox combobox tablist menu menubar radiogroup toolbar button link checkbox switch radio slider spinbutton textbox searchbox".split(" "));function rc(a,b){this.h=a;this.l=b;this.g=null;this.j=0}\nfunction sc(a,b){var c,d,e,f,g,h,k;return Ca(function(l){c=b;d=c.focusTargetOptions;a.g&&(a.h.Ub(a.g),a.g=null);if(!b.focusOnPageContainer&&!b.focusOnPageBodyElement&&!b.focusNearContentLocation&&"none"===d.target)return l.return();e=null;if(b.focusOnPageContainer)e=document.documentElement;else if(b.focusOnPageBodyElement)e=document.body;else switch(f=fc({o:b.containerPath,i:b.offset},a.l),g=cc(f,K(document)),d.target){case "element":e=pc(g);break;case "character":case "sentence":case "word":h="character"===\nd.target?"grapheme":d.target;e=ic(g,h,b.publicationLanguage);if(Ra(e)&&F(e.Pb)&&C(e.i)){var m=e,n=a.h,p=b.publicationLanguage;p=oc(m.Pb,m.i,{direction:"forward",granularity:h,publicationLanguage:void 0===p?null:p});m=n.Yb(m.Pb,m.i,p,"x-colibrio-focus");m.Za.style.cssText="all: unset !important";k=m;e=k.Za;a.g=k}break;default:b.focusNearContentLocation&&(e=pc(g))}if(A(e))return l.return(tc(a,e,b));throw new $b("FOCUS_TARGETS_END_OF_DOCUMENT");})}\nfunction tc(a,b,c){var d,e;return Ca(function(f){if(1==f.g)return d=K(b.ownerDocument),d.hasAttribute("tabindex")||d.setAttribute("tabindex","-1"),b.hasAttribute("tabindex")||bb(b)||b.setAttribute("tabindex","-1"),e=++a.j,b.ownerDocument.activeElement===b&&c.isAndroidNativeFramework?(b.blur(),ta(f,gb(500),3)):ta(f,gb(100),3);if(e!==a.j)throw new $b("ABORTED");b.focus({preventScroll:!0});f.g=0})};function uc(a,b,c){for(;a&&a!==b&&c(a);)a=a.parentNode;return a===b?null:a}function vc(a){for(a=a.previousSibling;a&&!wc(a);)a=a.previousSibling;return!a}function wc(a){return a&&A(a)&&a.getBoundingClientRect&&!/^(br|colgroup|col)$/i.test(a.tagName)?(a=a.getBoundingClientRect(),0<a.width&&0<a.height):F(a)&&Ma(a.data)}function xc(a){for(a=a.nextSibling;a&&!wc(a);)a=a.nextSibling;return!a}function yc(a){return/^(?:video|img|picture)$/i.test(a.tagName)};function zc(a,b){if(a=a.attributes)for(var c=0;c<a.length;c++){var d=a[c];d.namespaceUri?b.setAttributeNS(d.namespaceUri,d.name,d.value):b.setAttribute(d.name,d.value)}}\nfunction Ac(a,b){switch(a.nodeType){case 1:var c=a.namespaceUri?b.createElementNS(a.namespaceUri,a.nodeName):b.createElement(a.nodeName);zc(a,c);a=a.childNodes;for(var d=0;d<a.length;d++)c.appendChild(Ac(a[d],b));return c;case 3:return b.createTextNode(a.data||"");case 4:return b.createCDATASection(a.data||"");case 8:return b.createComment(a.data||"")}throw Error("ColibrioDom: Unsupported nodeType");};function Bc(a,b){a={o:a.o.slice(),i:a.i};for(var c=b.length-1;0<=c;c--){var d=b[c];switch(d.u){case 1:Cc(d,a);break;case 2:Dc(d,a);break;case 4:dc(a,d);break;case 5:Ec(d,a);break;case 6:Fc(d,a);break;case 7:Gc(d,a);break;case 8:Hc(d,a);break;case 9:Ic(d,a);break;case 10:Jc(d,a)}}return a}\nfunction Kc(a,b){var c=a.o.slice();a={o:c,i:a.i};for(var d=b.length-1;0<=d;d--){var e=b[d];switch(e.u){case 1:var f=[].concat(x(e.o),[e.i]),g=[].concat(x(c),[a.i]);if(V(f,g))return!0;Cc(e,a);break;case 2:Dc(e,a);break;case 4:dc(a,e);break;case 5:Ec(e,a);break;case 6:Fc(e,a);break;case 7:f=[].concat(x(c),[a.i]);if(V(e.o,f)&&e.o.length===f.length)return!0;Gc(e,a);break;case 8:Hc(e,a);break;case 9:Ic(e,a);break;case 10:Jc(e,a)}}return!1}\nfunction Cc(a,b){var c=a.o,d=b.o,e=c.length,f=d.length;V(c,d)&&(e<f?(c=d[e],c>a.i?d[e]--:c===a.i&&(d.length=e,b.i=d.pop())):b.i>a.i?b.i--:b.i===a.i&&(b.i=d.pop()))}function Dc(a,b){var c=a.o,d=b.o,e=c.length,f=d.length;V(c,d)&&(e<f?d[e]>=a.i&&d[e]++:b.i>=a.i&&b.i++)}function Ec(a,b){var c=a.o,d=b.o,e=c.length,f=d.length,g=c.slice(0,e-1),h=c[e-1];V(c,d)?b.i>=a.i&&(d[f-1]++,b.i-=a.i):V(g,d)&&(g.length===f?b.i>h&&(b.i+=1):d[e-1]>h&&d[e-1]++)}\nfunction Fc(a,b){var c=a.o,d=b.o,e=c.length,f=d.length,g=a.kc;if(V(c,d))if(e<f)if(a.i+g.length<=d[e])d[e]-=g.length-1;else if(e+1===f&&a.i===d[e])d.pop(),b.i=a.i;else{if(e+2===f&&a.i<=d[e]&&a.i+g.length>d[e]&&(d.pop(),c=d.pop()-a.i,c<g.length)){e=b.i;for(f=0;f<c;f++)e+=g[f];b.i=e;d.push(a.i)}}else if(a.i<b.i)if(a.i+g.length<=b.i)b.i-=g.length-1;else{c=0;e=b.i-a.i;for(f=0;f<e;f++)c+=g[f];d.push(a.i);b.i=c}}function Gc(a,b){a=a.o;var c=b.o,d=a.length,e=c.length;V(a,c)&&d===e&&(b.i=0)}\nfunction Hc(a,b){var c=a.o,d=b.o,e=c.length,f=d.length;V(c,d)&&e<f&&(e+1===f&&d[e]===a.i&&0===b.i?b.i=d.pop():d[e]===a.i&&0===d[e+1]&&d.splice(e+1,1))}function Ic(a,b){a=a.o;b=b.o;var c=a.length,d=b.length;V(a,b)&&c!==d&&b.splice(c,1)}\nfunction Jc(a,b){var c=a.o,d=b.o,e=c.length,f=d.length,g=c.slice(0,e-1),h=g.length,k=0===a.i,l=a.Da===a.Qb,m=k&&l,n=[].concat(x(c));n[e-1]+=k?0:1;V(g,d)&&(e<f?n[e-1]<d[e-1]?m||(d[e-1]-=k||l?1:2):n[e-1]===d[e-1]&&(d.pop(),d[d.length-1]-=k?0:1,b.i+=a.i):h===f&&n[e-1]<b.i?m||(b.i-=k||l?1:2):e===f&&n[e-1]<d[e-1]?m||(d[e-1]-=k||l?1:2,c[e-1]===d[e-1]&&(b.i+=a.Da)):n[e-1]===d[e-1]&&(d.pop(),d[d.length-1]-=k?0:1,b.i+=a.i))};var Lc={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",\ndarkgrey:"#a9a9a9",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkslategrey:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dimgrey:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",\nghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",grey:"#808080",honeydew:"#f0fff0",hotpink:"#ff69b4",indianred:"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgray:"#d3d3d3",lightgreen:"#90ee90",lightgrey:"#d3d3d3",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",\nlightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightslategrey:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370db",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",\nmoccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#db7093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",rebeccapurple:"#663399",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",\nseagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",slategrey:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"};function Mc(){this.alpha=1;this.g=this.h=null}function Nc(a){a=a.match(/^#?([a-f0-9]{8}|[a-f0-9]{6}|[a-f0-9]{3,4})$/i);if(!a||!a[1])return null;var b=a[1];if(3===b.length||4===b.length)b=b.split("").map(function(f){return f+f}).join("");var c=parseInt(b,16),d=c>>16&255,e=c>>8&255;a=c&255;8===b.length?(b=Oc(c>>24&255,d,e),b.alpha=H(a/255,0,1)):b=Oc(d,e,a);return b}function Oc(a,b,c,d){var e=new Mc;e.g=[H(a,0,255),H(b,0,255),H(c,0,255)];e.h=null;C(d)&&(e.alpha=H(d,0,1));return e}\nfunction Pc(){var a=new Mc;a.g=[0,0,0];a.alpha=0;return a}function Qc(a){var b=new Mc;b.alpha=a.alpha;a.g&&(b.g=a.g.slice());a.h&&(b.h=a.h.slice());return b}Mc.prototype.toString=function(){var a=this.alpha;if(0===a)a="transparent";else if(this.g){var b=Rc(this.g).join(", ");a=1>a?"rgba("+b+", "+a+")":"rgb("+b+")"}else b=Rc(this.h),b=b[0]+", "+b[1]+"%, "+b[2]+"%",a=1>a?"hsla("+b+", "+a+")":"hsl("+b+")";return a};function Rc(a){return a.map(function(b){return Math.round(b)})};function Sc(a,b){return{u:a,G:b}}function Tc(a,b,c){return{u:a,sb:c,G:b}}function X(a,b){return{u:a,G:b}}function Uc(a,b){return{Ac:b,Lc:a,u:50}}function Vc(a){a=a.u;return 40===a||41===a||42===a}Oc(255,255,255);function Wc(a,b){return b.some(function(c){return c===a.u})};function Xc(a){this.l=[];this.j=void 0;this.h=0;this.g=a.replace(/\\r\\n|\\r|\\f/g,"\\n")}function Yc(a){var b=a.h,c=a.g.charCodeAt(b++);if(isNaN(c))c=String.fromCharCode(65533);else if(Zc(c)){for(var d=1,e=57>=c?c-48:70>=c?c-65+10:c-97+10;6>d++&&Zc(c=a.g.charCodeAt(b));)e=e<<4|(57>=c?c-48:70>=c?c-65+10:c-97+10),b++;$c(a.g.charCodeAt(b))&&b++;c=String.fromCodePoint(e)}else c=55296<=c&&56319>=c?String.fromCharCode(c,a.g.charCodeAt(b++)):String.fromCharCode(c);a.h=b;return c}\nfunction ad(a,b){b=bd(a,b);if(40===a.g.charCodeAt(a.h)){a.h++;if(/^url$/i.test(b)){b=cd(a);if(isNaN(b))b=Sc(-1,"EOF");else if(34===b||39===b)if(a.h++,b=dd(a,b),-2===b.u)ed(a),b=Sc(-1,b.G);else{for(var c;$c(c=a.g.charCodeAt(a.h));)a.h++;41===c||isNaN(c)?(a.h++,a=!0):(ed(a),a=!1);a?b=X(5,b.G):b=Sc(-1,"Unexpected end of URL")}else b=fd(a);a=b}else a=X(1,b);return a}return X(0,b)}\nfunction bd(a,b){for(var c="",d=a.h;;){var e=a.g.charCodeAt(d);if(gd(e)||Y(e)||45===e)d++;else if(92===e&&92===e&&10!==a.g.charCodeAt(d+1))c+=a.g.substring(b,d++),a.h=d,c+=Yc(a),d=b=a.h;else return a.h=d,c?c+a.g.substring(b,d):a.g.substring(b,d)}}\nfunction hd(a,b,c,d){for(var e=a.h,f;Y(c=a.g.charCodeAt(e));)e++;if(!d&&46===c&&Y(a.g.charCodeAt(e+1)))for(e+=2;Y(c=a.g.charCodeAt(e));)e++;if(69===c||101===c)if(c=a.g.charCodeAt(e+1),45!==c&&43!==c||!Y(a.g.charCodeAt(e+2))?Y(c)&&(e+=2,f=!0):(e+=3,f=!0),f)for(;Y(a.g.charCodeAt(e));)e++;a.h=e;b=Number(a.g.substring(b,e));d=a.h;c=a.g.charCodeAt(d);return id(c,a.g.charCodeAt(d+1),a.g.charCodeAt(d+2))?Tc(42,b,bd(a,d)):37===c?(a.h++,Tc(41,b,"%")):Tc(40,b,"")}\nfunction ed(a){for(var b;(b=a.g.charCodeAt(a.h++))&&(41!==b||isNaN(b));)92===b&&10!==a.g.charCodeAt(a.h)&&Yc(a)}function dd(a,b){for(var c,d=c=a.h,e,f="",g;!e;)g=a.g.charCodeAt(c++),g===b||isNaN(g)?e=X(4,f+a.g.substring(d,c-1)):10===g?(e=Sc(-2,f+a.g.substring(d,c-1)),c--):92===g&&(g=a.g.charCodeAt(c),isNaN(g)?e=X(4,f+a.g.substring(d,c-1)):(f+=a.g.substring(d,c-1),10===g?c++:(a.h=c,f+=Yc(a),c=a.h),d=c));a.h=c;return e}function cd(a){for(var b;$c(b=a.g.charCodeAt(a.h));)a.h++;return b}\nfunction fd(a){for(var b,c="",d=a.h,e;;){e=a.g.charCodeAt(a.h++);if(41===e||isNaN(e))return X(5,c+a.g.substring(d,a.h-1));if($c(e)){b=a.h-1;e=cd(a);if(41===e||isNaN(e))return a.h++,X(5,c+a.g.substring(d,b));ed(a);return Sc(-1,c+a.g.substring(d,a.h))}if(34===e||39===e||40===e)return ed(a),Sc(-1,c+a.g.substring(d,a.h));92===e&&(e=a.g.charCodeAt(a.h),10!==e?(c+=a.g.substring(d,a.h-1),c+=Yc(a),d=a.h):ed(a))}}q=Xc.prototype;\nq.getNextTokenHigh=function(a,b){117===b?a=jd(this,a):gd(b)?a=ad(this,a):91===b?a={u:32}:92===b?10!==this.g.charCodeAt(a+1)?(this.h--,a=ad(this,a)):a=X(11,"\\\\"):93===b?a=X(35,"]"):94===b?61===this.g.charCodeAt(a+1)?(this.h++,a=X(14,"^=")):a=X(11,"^"):123===b?a={u:30}:125===b?a=X(33,"}"):124===b?(a=this.g.charCodeAt(a+1),61===a?(this.h++,a=X(13,"|=")):124===a?(this.h++,a=X(17,"||")):a=X(11,"|")):126===b?61===this.g.charCodeAt(a+1)?(this.h++,a=X(12,"~=")):a=X(11,"~"):isNaN(b)?a=void 0:(55296<=b&&56319>=\nb?(a=String.fromCharCode(b,this.g.charCodeAt(a+1)),this.h++):a=String.fromCharCode(b),a=X(11,a));return a};\nq.getNextTokenLow=function(a,b){switch(b){case 9:case 10:case 32:for(a=this.h;$c(this.g.charCodeAt(a));)a++;this.h=a;return X(10," ");case 34:return dd(this,34);case 35:b=this.g.charCodeAt(a+1);var c=this.g.charCodeAt(a+2);return gd(b)||Y(b)||45===b||92===b&&10!==c?X(3,bd(this,a+1)):X(11,"#");case 36:return 61===this.g.charCodeAt(a+1)?(this.h++,a=X(15,"$=")):a=X(11,"$"),a;case 39:return dd(this,39);case 40:return{u:31};case 41:return X(34,")");case 42:return 61===this.g.charCodeAt(a+1)?(this.h++,\na=X(16,"*=")):a=X(11,"*"),a;case 43:return kd(b,this.g.charCodeAt(a+1),this.g.charCodeAt(a+2))?hd(this,a,b,!1):X(11,"+");case 44:return X(22,",");case 45:c=this.g.charCodeAt(a+1);var d=this.g.charCodeAt(a+2);kd(b,c,d)?a=hd(this,a,b,!1):45===c&&62===d?(this.h+=2,a=X(19,"--\\x3e")):a=id(b,c,d)?ad(this,a):X(11,"-");return a;case 46:return Y(this.g.charCodeAt(a+1))?hd(this,a,b,!0):X(11,".");case 47:if(42===this.g.charCodeAt(a+1)){this.h++;a=this.h;b=this.g.charCodeAt(a++);for(c=this.g.charCodeAt(a++);!isNaN(b)&&\n(42!==b||47!==c);)b=c,c=this.g.charCodeAt(a++);this.h=a;a=this.next()}else a=X(11,"/");return a}return isNaN(b)?void 0:X(11,String.fromCharCode(b))};\nq.getNextTokenMid=function(a,b){57>=b?a=hd(this,a,b,!1):58===b?a=X(20,":"):59===b?a=X(21,";"):60===b?33===this.g.charCodeAt(a+1)&&45===this.g.charCodeAt(a+2)&&45===this.g.charCodeAt(a+3)?(this.h+=3,a=X(18,"\\x3c!--")):a=X(11,"<"):a=64===b?id(this.g.charCodeAt(a+1),this.g.charCodeAt(a+2),this.g.charCodeAt(a+3))?X(2,bd(this,a+1)):X(11,"@"):85===b?jd(this,a):gd(b)?ad(this,a):isNaN(b)?void 0:X(11,String.fromCharCode(b));return a};\nfunction jd(a,b){var c=a.g.charCodeAt(b+2);if(43===a.g.charCodeAt(b+1)&&(34===c||Y(c))){a.h++;b=c=a.h;for(var d=0,e,f=!1,g;6>d&&Zc(e=a.g.charCodeAt(b));)b++,d++;if(6>d&&63===e)for(b++,d++,f=!0;6>d&&63===a.g.charCodeAt(b);)d++,b++;g=a.g.substring(c,b);if(f)c=Uc(parseInt(g.replace(/\\?/g,"0"),16),parseInt(g.replace(/\\?/g,"F"),16));else if(45===a.g.charCodeAt(b)&&Zc(a.g.charCodeAt(b+1))){c=b+1;b+=2;for(d=1;6>d&&Zc(a.g.charCodeAt(b));)b++,d++;c=Uc(parseInt(g,16),parseInt(a.g.substring(c,b),16))}else c=\nUc(e=parseInt(g,16),e);a.h=b;return c}return ad(a,b)}q.next=function(){if(void 0!==this.j){var a=this.j;this.j=void 0;return a}return ld(this)};q.peek=function(){void 0===this.j&&(this.j=ld(this));return this.j};function ld(a){var b=a.h++,c=a.g.charCodeAt(b);return(b=48>c?a.getNextTokenLow(b,c):91>c?a.getNextTokenMid(b,c):a.getNextTokenHigh(b,c))&&0>b.u?(a.l.push(b),a.next()):b}function $c(a){return 9===a||32===a||10===a}function Y(a){return 48<=a&&57>=a}\nfunction Zc(a){return 48<=a&&57>=a||65<=a&&70>=a||97<=a&&102>=a}function gd(a){return 65<=a&&90>=a||97<=a&&122>=a||128<=a||95===a}function kd(a,b,c){return 43===a||45===a?Y(b)||46===b&&Y(c):Y(a)||46===a&&Y(b)}function id(a,b,c){return 45===a?gd(b)||45===b||92===b&&10!==c:gd(a)||92===a&&10!==b};function md(a){this.g=new Xc(a)}function nd(a,b,c){var d=c.u;if(30===d||31===d||32===d){var e,f=c.u+3;for(d=[];(e=b.next())&&e.u!==f;)d.push(nd(a,b,e));a={u:c.u+30,G:d}}else if(1===d){for(e=[];(f=b.next())&&34!==f.u;)e.push(nd(a,b,f));a={N:c.G.toLowerCase(),u:80,G:e}}else a=c;return a};function od(){this.ac=!0;this.bc="transparent";this.qb=!1}\nod.prototype.La=function(a,b){if(!this.qb&&!ab(b)){var c=L(a),d=c.backgroundColor;var e=c.backgroundColor;if("none"!==c.backgroundImage)var f=!1;else if("transparent"===e||"inherit"===e)f=!0;else{var g,h;var k=new md(e);for(e=[];(f=k.g.next())&&34!==f.u&&35!==f.u&&33!==f.u;)e.push(nd(k,k.g,f));if(0===e.length)f=null;else c:{f=Pc(),k=e[0];var l;if(80===k.u){e=[];for(var m=0;m<k.G.length;m++){var n=k.G[m];Vc(n)&&e.push(n)}var p;3<e.length&&(m=e[3],40===m.u?p=m.G:41===m.u&&(p=m.G/100));if("rgb"===k.N||\n"rgba"===k.N){k=[40,41];if(3>e.length||!Wc(e[0],k)||!Wc(e[1],k)||!Wc(e[2],k))e=null;else{k=[];k.length=3;for(m=0;3>m;m++)n=e[m],k[m]=40===n.u?n.G:255*n.G/100;e=k}e&&(l=Oc(e[0],e[1],e[2],p))}else if("hsl"===k.N||"hsla"===k.N)3>e.length||!Wc(e[0],[40,42])||!Wc(e[1],[40,41])||!Wc(e[2],[40,41])?e=null:(k=[],k.length=3,m=e[0],k[0]=40===m.u?m.G:42===m.u?"grad"===m.sb?360*m.G/400:"rad"===m.sb?360*m.G/(2*Math.PI):"turn"===m.sb?360*m.G:m.G:360*m.G/100,k[1]=40===e[1].u?100*e[1].G:e[1].G,k[2]=40===e[2].u?100*\ne[2].G:e[2].G,e=k),e&&(l=p,p=new Mc,k=e[0],k%=360,0>k&&(k+=360),p.h=[k,H(e[1],0,100),H(e[2],0,100)],p.g=null,C(l)&&(p.alpha=H(l,0,1)),l=p)}else if(3===k.u)(p=Nc(k.G))&&(l=p);else if(0===k.u){l=k.G.toLowerCase();if("inherit"===l||"unset"===l){f=null;break c}"initial"===l||"revert"===l?l=Qc(f):(l=l.toLowerCase(),l=(Lc.hasOwnProperty(l)?Nc(Lc[l]):"transparent"===l?Pc():null)||f)}l||(l=Qc(f));f=l}f=null!=(h=null==(g=f)?void 0:0===g.alpha)?h:!1}g=f;h=!g&&d!==this.bc&&pd(c);if(b="html"===b||"body"===b&&\n(!h||this.ac)||"body"!==b&&!h)this.bc=d,this.ac=g;if(b)if(pd(c)&&D(a)&&(N(a,"margin-left","0"),N(a,"margin-right","0")),d=parseFloat(c.borderRightWidth),0<parseFloat(c.borderLeftWidth)||0<d)this.qb=!0;else{d=parseFloat(c.paddingRight);0===parseFloat(c.paddingLeft)&&0===d||!D(a)||(N(a,"padding-left","0"),N(a,"padding-right","0"));a:{c=a.childNodes;for(d=0;d<c.length;d++)if(Oa(c[d])){c=!1;break a}c=!0}a:{a=a.childNodes;for(b=d=0;b<a.length;b++)if(g=a[b],D(g)&&!ab(g.localName)&&d++,1<d){a=!1;break a}a=\n1===d}a&&c||(this.qb=!0)}else this.qb=!0}};function pd(a){var b=parseFloat(a.marginRight);return 0!==parseFloat(a.marginLeft)||0!==b};function qd(a){for(var b=[];a.parentElement;){a=a.parentElement;for(var c=0,d=0;d<a.childNodes.length;d++){var e=a.childNodes[d];(A(e)||Oa(e))&&c++}d=void 0;if(1<c||a===(null==(d=a.ownerDocument)?void 0:d.documentElement))break;c=window.getComputedStyle(a);"auto"!==c.height&&b.push(a);c=c.position;if("static"!==c&&"relative"!==c)break}return b}function rd(a,b){return"math"===b?!0:L(a).display.includes("math")}\nfunction sd(a){var b=a.parentElement;if(!b)return!1;a=0;b=b.childNodes;for(var c=0;c<b.length;c++){var d=b[c];if(Oa(d)||A(d))if(a++,2<=a)return!1}return!0}\nfunction td(a,b){var c=!1,d=qd(a);0===d.length&&(c=!0);var e=d.map(function(k){return window.getComputedStyle(k)}),f=e.map(function(k){return parseFloat(k.height)});f.every(function(k){return k<b})&&(c=!0);Pa()?N(a,"height","auto"):N(a,"height",b-NaN+"px");if(!c&&!e.map(function(k){return parseFloat(k.height)}).map(function(k,l){return[k,f[l]]}).every(function(k){return k[0]<k[1]}))for(a=0;a<d.length;a++){c=d[a];var g=f[a],h=parseFloat(e[a].height);if(!isNaN(h)&&!isNaN(g)&&h===g){Pa()?N(c,"height",\n"auto"):N(c,"height",g-NaN+"px");N(c,"width","auto");c=!0;for(g=a+1;g<d.length;g++)parseFloat(e[g].height)===f[g]&&(c=!1);if(c)break}}};function ud(a,b,c,d,e){this.Mc=c;this.cc=d;this.Dc=e;this.ga=null;this.wa=this.nb=this.Ha=0;this.dc=a*b}\nud.prototype.La=function(a,b,c,d){var e;if(e=!this.ga)if(e=a!==d.documentElement){e=a.parentNode;for(var f=!0;f&&e&&D(e);)f=e,f="visible"===L(f).overflowX||f.scrollWidth===f.clientWidth,e=e.parentNode;e=f&&!ab(b)}if(e){if(vd(this,a)){e=L(a);f="pre"===e.whiteSpace||"nowrap"===e.whiteSpace;var g="visible"===e.overflowX;if("block"===e.display&&f&&g&&D(a)){this.ga=a;wd(this,a)&&xd(a);return}if(rd(a,b)){this.ga=a;b=a.scrollWidth-a.clientWidth;e=L(a);N(a,"width",parseFloat(e.width)+b+"px");"SCROLL"===this.cc?\nwd(this,a)&&yd(a,c,d):zd(this,a);return}}Ad(this,a)?(e=L(a).position,"absolute"===e||"fixed"===e?D(a)&&(this.ga=a,zd(this,a)):yc(a)?D(a)&&(this.ga=a,Bd(this,a)):La(a)?(this.ga=a,d=L(a),c=parseInt(d.width),d=parseInt(d.height),a.getAttribute("viewBox")||a.setAttribute("viewBox","0 0 "+c+" "+d),Bd(this,a)):(b=rd(a,b),e=L(a).display,e="table"===e||"inline-table"===e,b||e?(this.ga=a,e&&D(a)&&N(a,"width","auto"),Ad(this,a)&&(b&&"SCROLL"===this.cc||e&&"SCROLL"===this.Mc?yd(a,c,d):zd(this,a))):"inline"!==\nL(a).display&&D(a)&&(N(a,"width","auto"),N(a,"height","auto"),a.setAttribute("data-colibrio-pending-down-scale","true")))):(La(a)&&(this.ga=a),rd(a,b)&&(this.ga=a))}};\nud.prototype.ya=function(a,b,c,d){if(a===this.ga)this.ga=null;else if(!this.ga&&a!==d.documentElement&&!ab(b))if(vd(this,a)&&D(a)&&"visible"===L(a).overflowX){for(b=a;b.firstElementChild&&sd(b.firstElementChild)&&D(b.firstElementChild);)b=b.firstElementChild;c=L(b).fontSize;a:{if(c&&(c=parseFloat(c),!isNaN(c)&&(d=a.clientWidth/a.scrollWidth*c-.1,d<this.dc&&(d=Math.min(this.dc,c)),d<c))){c=d;break a}c=void 0}c&&N(b,"font-size",c+"px");N(a,"overflow-wrap","break-word");vd(this,a)&&D(a)&&wd(this,a)&&\nxd(a)}else if((D(a)||rd(a,b))&&Ad(this,a)&&"true"===a.getAttribute("data-colibrio-pending-down-scale")){a.removeAttribute("data-colibrio-pending-down-scale");b=a.getBoundingClientRect();c=L(a);d=parseFloat(c.marginRight);var e=!1;0>parseFloat(c.marginLeft)&&b.left<this.Ha&&(N(a,"margin-left","0"),e=!0);0>d&&b.right>this.wa&&(N(a,"margin-right","0"),e=!0);e&&!Ad(this,a)||zd(this,a)}};\nud.prototype.ub=function(a){var b=a.documentElement.getBoundingClientRect().width/a.documentElement.offsetWidth;this.nb=a.defaultView.innerWidth*b;a=L(a.documentElement);a=parseFloat(a.marginLeft);isNaN(a)&&(a=0);this.Ha=a*b;this.wa=this.nb-this.Ha};\nfunction yd(a,b,c){a.parentElement&&(sd(a)&&a.parentElement!==a.ownerDocument.body?N(a.parentElement,"overflow-x","auto"):(c=c.createElement("x-colibrio-scroll-container"),c.style.display="block",c.style.width="auto",c.style.height="auto",b.Xb(a,c),N(c,"overflow-x","auto")))}function xd(a){N(a,"overflow-x","auto");N(a,"width","auto")}\nfunction Bd(a,b){var c=L(b);c=parseInt(c.width);var d=b.getBoundingClientRect();d.left>a.wa||d.right<a.Ha||d.left+d.width>a.wa&&Cd(b,c,c-((a.wa-d.left)/(d.width/c)|0))}\nfunction zd(a,b){var c=b.getBoundingClientRect(),d=parseInt(L(b).width)/c.width,e=(a.Ha-c.left)*d;d*=a.wa-c.right;if(c.width<=a.nb){var f=0;c.right>a.wa?f=d:c.left<a.Ha&&(f=e);0!==f&&N(b,"transform","translateX("+f+"px)")}else a=a.nb/c.width,c=e,d=0,c===d?c=!0:(f=Math.abs(c-d),c=Math.abs(c),d=Math.abs(d),c=f<=(d>c?d:c)*Number.EPSILON),e=c?"scale("+a+")":"translateX("+e+"px) scale("+a+")",N(b,"transform-origin","left center"),N(b,"transform",e)}\nfunction vd(a,b){var c=0<b.clientWidth&&b.scrollWidth>b.clientWidth;if(a.Dc&&c&&b===b.ownerDocument.body){c=L(b);a=parseFloat(c.marginLeft);c=parseFloat(c.marginRight);if(!C(a)||0>a)a=0;if(!C(c)||0>c)c=0;b=b.scrollWidth-a-c>b.clientWidth}else b=c;return b}function Ad(a,b){b=b.getBoundingClientRect();return 0<b.height&&0<b.width&&(b.left<a.Ha||b.right>a.wa)}\nfunction wd(a,b){if("visible"!==L(b).overflowX)return!1;var c=b.getBoundingClientRect();return c.left+c.width/b.clientWidth*b.scrollWidth>a.wa+1}\nfunction Cd(a,b,c){var d=!1,e=qd(a);0===e.length&&(d=!0);var f=e.map(function(l){return L(l)}),g=f.map(function(l){return parseFloat(l.width)});g.every(function(l){return l<b})&&(d=!0);N(a,"width",b-c+"px");N(a,"height","auto");if(!d&&!f.map(function(l){return parseFloat(l.width)}).map(function(l,m){return[l,g[m]]}).every(function(l){return l[0]<l[1]}))for(a=0;a<e.length;a++){d=e[a];var h=g[a],k=parseFloat(f[a].width);if(!isNaN(k)&&!isNaN(h)&&k>=h&&h>=b){N(d,"width",h-c+"px");N(d,"height","auto");\nd=!0;for(h=a+1;h<e.length;h++)parseFloat(f[h].width)===g[h]&&(d=!1);if(d)break}}};function Dd(){}\nDd.prototype.ya=function(a){if(D(a)&&a.scrollWidth>a.clientWidth+1){var b=L(a);if("block"===b.display&&"visible"===b.overflowX&&"static"===b.position){var c=parseFloat(b.marginLeft)||0;b=parseFloat(b.marginRight)||0;var d=c+b;if(0<d){var e=a.style.getPropertyValue("position"),f=a.style.getPropertyPriority("position");N(a,"position","absolute");var g=a.clientWidth;a.style.setProperty("position",e,f);N(a,"margin-left","0");N(a,"margin-right","0");e=a.clientWidth-g-1;0<e&&(N(a,"margin-left",e/d*c+"px"),\nN(a,"margin-right",e/d*b+"px"))}}}};function Ed(){}Ed.prototype.La=function(a,b,c,d){"img"===b&&(c=d.defaultView.getComputedStyle(a),b=parseFloat(c.width),c=parseFloat(c.height),0<a.naturalWidth&&0<a.naturalHeight&&.03<Math.abs(b/c-a.naturalWidth/a.naturalHeight)&&td(a,c))};function Fd(a){if(Oa(a))return!0;var b=!a.hasChildNodes()||db(a)||La(a)||cb(a);return!(D(a)&&"script"===a.localName)&&A(a)&&b}function Gd(a,b,c){var d=/^\\s*/.exec(c.data),e=1+(d?d[0].length:0);return Ia(c,c.data.length,function(f,g){b.setStart(f,H(g,e,f.data.length));b.setEnd(f,f.data.length);f=b.getBoundingClientRect().top;return f>a?-1:f<a?1:0})}\nfunction Hd(a){var b;(b=a.ownerDocument)&&b.defaultView?D(a)?(b=b.defaultView.getComputedStyle(a),b="sticky"===b.position||"fixed"===b.position):b=!1:b=!1;return!b&&!db(a)&&!(D(a)&&"script"===a.localName)&&!La(a)&&!cb(a)};function Id(a){if(0===a.length)return[];for(var b=[],c=a[0],d=1;d<a.length;d++){var e=a[d],f;if(f=1===c.u&&1===e.u){f=c.pa;var g=e.pa;f=Jd(f,g)||Jd(g,f)}if(f){f=e.Ba;g=c.Ca;c=c.pa;e=e.pa;var h=Math.min(c.left,e.left),k=Math.min(c.top,e.top);e=new DOMRect(h,k,Math.max(c.right,e.right)-h,Math.max(c.bottom,e.bottom)-k);c={Ba:f,Ca:g,pa:e,u:1}}else b.push(c),c=e}b.push(c);return b}\nfunction Kd(a){var b=a.startOffset,c=a.Qc,d=a.Sc,e=a.Wc,f=a.Xc;if(4<a.Uc){a=b+c;for(var g=0;a<d&&2>g;)a=Math.min(a+c,d),e.setEnd(f,a),g=e.getClientRects().length;a=Math.min(a,d)}else a=d;c=Ja(e,1,b+1,a-b,function(k,l){k.setEnd(f,l);return 1>=k.getClientRects().length?1:-1});c===b&&c<d&&c++;e.setEnd(f,c);b=e.getClientRects();var h;b=null!=(h=Ld(b))?h:new DOMRect(0,0,0,0);return{Tc:c,rect:eb(b)}}\nfunction Ld(a){if(1<a.length){for(var b=a[0],c=1;c<a.length;c++){var d=a[c];d.top>b.top&&(b=d)}return b}return 1===a.length?a[0]:null}function Jd(a,b){var c=Math.min(.2*a.height,.2*b.height);return a.top-c<=b.top&&a.bottom+c>=b.bottom};function Md(a,b,c){var d=[];a=Nd(a,c);b=Nd(b,c);var e=a,f=b;if(e.m===f.m)var g=e.i<=f.i;else{g=e.m;g=(g&&9===g.nodeType?e.m:e.m.ownerDocument).createRange();g.setStart(e.m,e.i);g.collapse(!0);b:{e=f.m;var h=f.i;try{var k=g.comparePoint(e,h);break b}catch(l){if(l instanceof DOMException&&("InvalidNodeTypeError"===l.name||"IndexSizeError"===l.name))throw l;}if(e.ownerDocument!==g.startContainer.ownerDocument)throw new DOMException(\'Failed to execute Range.comparePoint and compareRangeWithDomPosition. The provided "range" and "container" belongs to a different documents\',\n"WrongDocumentError");k=e.ownerDocument.documentElement;f=Za(k,e);f.push(h);e=Za(k,g.startContainer);e.push(g.startOffset);e=Ua(f,e);g.collapsed||1!==e?k=e:(k=Za(k,g.endContainer),k.push(g.endOffset),k=1===Ua(f,k)?1:0)}g=0<k}if(!g)return[];if(F(a.m)&&b.m===a.m)Od(d,c.fb(a.m,a.i,b.i));else{a:{g=a.m;if(A(g)){if(a.i<g.childNodes.length){g={Ab:!1,Mb:!1,Nb:g.childNodes[a.i]};break a}}else if(F(g)&&a.i<g.data.length){g={Ab:!0,Mb:!1,Nb:g};break a}g={Ab:!1,Mb:!0,Nb:g}}k=b.m;k=A(k)?b.i<k.childNodes.length?\n{R:k.childNodes[b.i],mb:!1,rb:!0}:{R:k,mb:!1,rb:!1}:!F(k)||0>=b.i?{R:k,mb:!1,rb:!0}:{R:k,mb:!0,rb:!1};f=new gc(g.Nb);f.R=k.R;g.Mb?W(f,!1):g.Ab&&F(a.m)&&(Od(d,c.fb(a.m,a.i,a.m.data.length)),W(f,!1));for(;f.g;){if(f.g===k.R){if(k.rb)break;if(k.mb&&F(k.R)){Od(d,c.fb(k.R,0,b.i));break}}A(f.g)?(Od(d,c.wc(f.g)),W(f,c.Rb(f.g))):(F(f.g)&&Od(d,c.fb(f.g,0,f.g.data.length)),W(f,!1))}}return d}\nfunction Nd(a,b){var c=a.m;A(c)||(c=c.parentNode);for(var d=null;A(c);)b.Rb(c)||(d=c),c=c.parentNode;return d&&d.parentNode?{m:d.parentNode,i:Xa(d)+1}:a}function Od(a,b){Qa(b)?a.push.apply(a,x(b)):Pa(b)||a.push(b)};function Pd(a,b){a=Md(a,b,{Rb:function(c){return!ab(c.tagName)},wc:function(c){if(yc(c)){var d=eb(c.getBoundingClientRect()),e=c.parentNode;if(e)return c=Xa(c),{Ba:{m:e,i:c+1},Ca:{m:e,i:c},pa:d,u:2}}},fb:function(c,d,e){var f=c.parentNode,g;if(g=A(f))g=(g=f.ownerDocument.defaultView)?"visible"===g.getComputedStyle(f).visibility:!1;if(g){g=c.ownerDocument.createRange();g.setStart(c,d);g.setEnd(c,e);var h=g.getClientRects();if(0===h.length)c=[];else{f=[];var k=(e-d)/h.length|0,l=h.length;if(e===d)c=\n{m:c,i:d},e=Ld(h),f.push({Ba:c,Ca:c,pa:e?eb(e):new DOMRect(0,0,0,0),u:1});else for(;d<e;){h=Kd({Qc:k,Sc:e,Uc:l,Wc:g,startOffset:d,Xc:c});var m=h.Tc;f.push({Ba:{m:c,i:m},Ca:{m:c,i:d},pa:h.rect,u:1});d=m;g.setStart(c,d);l--}c=f}}else c=[];return c}}).filter(function(c){return 0<c.pa.width||0<c.pa.height});return Id(a)}\nfunction Qd(a,b,c){return Md(b,c,{Rb:function(d){return!ab(d.localName)},wc:function(d){if(yc(d)||0===d.childNodes.length)if(d=d.getBoundingClientRect(),0<d.width&&0<d.height)return d},fb:function(d,e,f){var g=a.createRange();g.setStart(d,e);g.setEnd(d,f);d=g.getClientRects();return Array.from(d).filter(function(h){return 0<h.width&&0<h.height})}})}function Rd(a){return a?A(a)?(a=a.getBoundingClientRect(),0<a.width&&0<a.height):F(a)?!Na(a.data):!1:!1}\nfunction Sd(a,b){var c=K(a.ownerDocument);b<a.childNodes.length?a=a.childNodes[b]:(a=new gc(a.lastChild||a),a.R=c,W(a,!1),a=a.g);if(a&&(a=new gc(a,Rd),a.R=c,a=a.next(!0))){if(F(a)){c=a.ownerDocument.createRange();if(Ma(a.data)){b=/^\\s*/.exec(a.data);b=Math.max(1+(b?b[0].length:0),0);var d=Math.min(a.data.length,Math.max(b+1,1));b>=d?c=null:(c.setStart(a,b),c.setEnd(a,d))}else c=null;if(!c)return null;c=c.getBoundingClientRect()}else c=a.getBoundingClientRect();return new DOMRect(c.left,c.top)}c=c.getBoundingClientRect();\nreturn new DOMRect(c.left,c.bottom)};function Td(a){this.g=a=void 0===a?[]:a}function Ud(a,b,c){var d=c.parentNode;if(!d)throw new O("DomMutationRecorder: Node not attached to container");(d=ac(d))&&a.g.push({o:d,Aa:1,i:Xa(c),u:b})};function Vd(a){var b=document.body,c=this;this.C=a=void 0===a?[]:a;this.g=new MutationObserver(function(d){Wd(c,d)});this.g.observe(b,{characterData:!0,childList:!0,subtree:!0});this.h=new Td(this.C)}function Xd(a){a.g.takeRecords()}function Yd(a){var b=a.g.takeRecords();Wd(a,b)}\nfunction Wd(a,b){var c=new Map;b=v(b);for(var d=b.next();!d.done;d=b.next()){d=d.value;var e=d.target;if(e.isConnected){var f=c.get(e);f?f.push(d):c.set(e,[d])}}c=Array.from(c.entries()).sort(function(g,h){g=v(g).next().value;h=v(h).next().value;return Ya(g)-Ya(h)});c=v(c);for(b=c.next();!b.done;b=c.next()){b=v(b.value);d=b.next().value;b=b.next().value;d=Array.from(d.childNodes);e=[];for(f=b.length-1;0<=f;f--)Zd(a,b[f],d,e);a.C.push.apply(a.C,x(e.reverse()))}}\nfunction Zd(a,b,c,d){var e=ac(b.target);if(e){var f="characterData"===b.type,g=U(b.target);if(!g||!Kc(g,[].concat(x(a.C),x([].concat(x(d)).reverse()))))if(f)d.push({o:e,Aa:3,i:0,u:7});else{var h=b.previousSibling?c.indexOf(b.previousSibling)+1:0;for(a=b.addedNodes.length-1;0<=a;a--)d.push({o:e,Aa:1,i:h+a,u:1});b.removedNodes.forEach(function(){return d.push({o:e,Aa:1,i:h,u:2})});c.splice.apply(c,[h,b.addedNodes.length].concat(x(Array.from(b.removedNodes))))}}};function $d(a){this.g=a?a:new Td}q=$d.prototype;q.append=function(a,b){b.appendChild(a);Ud(this.g,1,a)};q.insertBefore=function(a,b){b.parentNode.insertBefore(a,b);Ud(this.g,1,a)};q.prepend=function(a,b){b.insertBefore(a,b.firstChild);Ud(this.g,1,a)};q.remove=function(a){if(a.parentNode){Ud(this.g,2,a);var b=a.previousSibling,c=a.nextSibling;a.parentNode.removeChild(a);if(F(b)&&F(c)&&b.parentNode){a=this.g;var d=b.data.length,e=ac(b);e&&a.g.push({o:e,Aa:3,i:d,u:5});c.data=b.data+c.data;b.parentNode.removeChild(b)}}};\nq.Xb=function(a,b){var c=a.parentElement;c&&(c.insertBefore(b,a),b.appendChild(a),Ud(this.g,8,b))};\nq.Yb=function(a,b,c,d){var e=ac(a),f=a.data.length;if(!e)throw new O("Text node not attached to container");if(0>b||0>c||b>=c||c>a.data.length)throw new O("Invalid startOffset or endOffset: startOffset="+b+", endOffset="+c);var g=a.ownerDocument,h=a.parentElement;if(!h)throw new O("Text node has no parent");var k=a.data.length;0<b&&(a=a.splitText(b));c<k&&a.splitText(c-b);d=g.createElement(d);h.replaceChild(d,a);d.appendChild(a);b={o:e,Aa:3,Da:c,i:b,Qb:f,u:10};this.g.g.push(b);return{Kc:b,Za:d}};\nq.Ub=function(a){var b=this.g.g;if(b[b.length-1]!==a.Kc)throw new O("DomMutator: wrapText result record does not match last record");var c=a.Za.parentElement;if(!c)throw new O("DomMutator: wrapText result element has no parent");b.pop();c.replaceChild(a.Za.childNodes[0],a.Za);c.normalize()};function ae(a){this.g=a;this.h=new $d(this.g.h)}q=ae.prototype;q.append=function(a,b){Yd(this.g);this.h.append(a,b);Xd(this.g)};q.insertBefore=function(a,b){Yd(this.g);this.h.insertBefore(a,b);Xd(this.g)};q.prepend=function(a,b){Yd(this.g);this.h.prepend(a,b);Xd(this.g)};q.remove=function(a){Yd(this.g);this.h.remove(a);Xd(this.g)};q.Xb=function(a,b){Yd(this.g);this.h.Xb(a,b);Xd(this.g)};q.Yb=function(a,b,c,d){Yd(this.g);a=this.h.Yb(a,b,c,d);Xd(this.g);return a};\nq.Ub=function(a){Yd(this.g);this.h.Ub(a);Xd(this.g)};function be(a){this.j=a;this.s=this.l=this.h=null;this.g=!1}function ce(a,b){a.s=b;a.l=b;a.h=b;a.g=b===a.h;a.j.ub(b,b);de(a,a.h)}function ee(a,b){var c=!1,d=!1;a.g&&(d=a.j.La(b));if(!(d||a.g&&null===b.parentNode)){c=!1;for(var e=b.firstChild;e&&!c;)d=e.nextSibling,c=de(a,e),e=d;d=c;c=!0}!d&&a.g&&(d=a.j.ya(b,c));return d}function de(a,b){b===a.s&&(a.g=!0);var c=!1;a.g?c=1===b.nodeType?ee(a,b):!1:A(b)&&(c=ee(a,b));return c||b===a.l};function fe(a,b){this.j=b;this.g=[];this.h=[];for(b=0;b<a.length;b++){var c=a[b];c.La&&this.h.push(c);c.ya&&this.g.push(c)}}fe.prototype.La=function(a){for(var b=a.localName,c=0;c<this.h.length;c++)this.h[c].La(a,b,this.j,a.ownerDocument);return!1};fe.prototype.ya=function(a){for(var b=a.localName,c=0;c<this.g.length;c++)this.g[c].ya(a,b,this.j,a.ownerDocument);return!1};fe.prototype.ub=function(){};function ge(){this.g=[]}function he(a,b){a.g.push.apply(a.g,x(b))}ge.prototype.transform=function(a,b){for(var c=ie(a),d=0;d<this.g.length;d++){var e=this.g[d];e.ub&&e.ub(a,b)}d=new fe(this.g,b);ce(new be(d),a.documentElement);d=[];for(e=0;e<this.g.length;e++){var f=this.g[e];f.sc&&(f=f.sc(a,b,c),d.push(f))}return Promise.all(d).then(function(){})};function ie(a){return(a=a.head||a.documentElement.firstElementChild)&&"head"===a.localName?a:void 0};function je(a,b,c){this.j=a;this.g=b;this.h=c}\nje.prototype.oc=function(a){switch(a.type){case 5:break;case 34:case 36:a.iframeResourceId=this.h;var b=a.engineEventDef,c=this.j.getBoundingClientRect(),d=c.width/b.windowInnerWidth;b.clientX=d*b.clientX+c.left;b.clientY=d*b.clientY+c.top;b.pageX=d*b.clientX+c.left+window.scrollX;b.pageY=d*b.clientY+c.top+window.scrollY;b.windowInnerWidth=window.innerWidth;b.windowInnerHeight=window.innerHeight;P(this.g,a);break;case 30:case 31:case 40:case 38:a.iframeResourceId=this.h;P(this.g,a);break;case 41:case 37:case 2:P(this.g,\na);break;default:Vb("Unhandled child iframe message type: "+a.type)}};je.prototype.pc=function(a){switch(a.type){case 8:return a.iframeId=this.h,this.g.g(a);case 11:return ke(this,a);case 13:return le(this,a);case 21:return me(this,a);case 24:return le(this,a);case 26:return a.iframeId=this.h,this.g.g(a)}Vb("Unhandled child iframe request type: "+a.type);return Promise.reject("IFrameMessageType not implemented: "+a.type)};\nfunction ke(a,b){b.iframeId=a.h;return a.g.g(b).then(function(c){return{message:c,Tb:[c.buffer]}})}function me(a,b){return a.g.g(b).then(function(c){return{message:c,Tb:c.data?[c.data]:[]}})}function le(a,b){b.iframeId=a.h;return a.g.g(b)};function ne(a,b,c,d,e){var f=this;this.j=a;this.h=b;this.F=c;this.s=d;this.A=new je(this.j,this.s,b.iframeResourceId);this.g=new Rb(window,this.j.contentWindow,"*","colibrio.readingsystem.formatadapter.epub.iframe.host",1E4,this.A);this.l=Bb(this.g).then(function(g){g.g({addTabIndexToMediaElements:f.F.addTabIndexToMediaElements,allowAudioElementAutoplay:f.F.allowAudioElementAutoplay,allowCopy:f.F.allowCopy,allowRemoteResources:f.F.allowRemoteResources,allowVideoElementAutoplay:f.F.allowVideoElementAutoplay,\nalwaysEmitPointerMoveEvents:f.F.alwaysEmitPointerMoveEvents,baseUrl:b.baseUrl,body:null,childIframeResourceId:b.iframeResourceId,disableScripts:f.F.disableScripts,domMutationRecords:f.F.domMutationRecords,fontSizeScaleFactor:c.fontSizeScaleFactor,forceTouchEvents:f.F.forceTouchEvents,hasInlineNegativeHorizontalMarginStyles:f.F.hasInlineNegativeHorizontalMarginStyles,horizontalOverflowFixerMathScroll:f.F.horizontalOverflowFixerMathScroll,horizontalOverflowFixerMinFontSize:f.F.horizontalOverflowFixerMinFontSize,\nhorizontalOverflowFixerTableScroll:f.F.horizontalOverflowFixerTableScroll,iframeStorageId:e,includeContentLocationInPointerMoveEvents:f.F.includeContentLocationInPointerMoveEvents,isMouseSwipeNavigationAllowed:f.F.isMouseSwipeNavigationAllowed,layoutStyle:f.F.layoutStyle,mediaOverlayActiveElementClass:f.F.mediaOverlayActiveElementClass,mediaOverlayAncestorElementClass:f.F.mediaOverlayAncestorElementClass,mediaOverlayPlaybackActiveClass:f.F.mediaOverlayPlaybackActiveClass,needsReflowableLayoutFixes:!1,\nnegativeHorizontalMarginSelectors:f.F.negativeHorizontalMarginSelectors,preventDefaultContextMenu:f.F.preventDefaultContextMenu,preventDefaultContextMenuOnMediaElements:f.F.preventDefaultContextMenuOnMediaElements,preventDragAndDropActions:f.F.preventDragAndDropActions,publicationLocalStorage:f.F.publicationLocalStorage,publicationSessionStorage:f.F.publicationSessionStorage,publicationStorageSizeLimit:f.F.publicationStorageSizeLimit,removePublicationDefinedHorizontalPageMargins:f.F.removePublicationDefinedHorizontalPageMargins,\nresourceProviderBaseUrl:f.F.resourceProviderBaseUrl,scaleFactor:f.F.scaleFactor,scriptedContentDocumentEventHandlersEnabled:f.F.scriptedContentDocumentEventHandlersEnabled,scripts:f.h.scripts,styleDefs:f.h.styleDefs,textToAppendOnCopy:f.F.textToAppendOnCopy,textToPrependOnCopy:f.F.textToPrependOnCopy,transitionStylesheet:f.h.transitionStylesheet,type:3}).catch(function(h){mb(h)||R(h)})})}\nfunction oe(a,b,c,d){return new Promise(function(e,f){var g="data:"+b.mediaType+";charset=UTF-8,"+encodeURIComponent(b.xml),h=window.setTimeout(function(){return f("Timeout while loading child iframe")},2E4);a.addEventListener("load",function(){window.clearTimeout(h);d.g({type:17}).then(function(k){e(new ne(a,b,c,d,k.storageId))}).catch(function(k){mb(k)||R(k)})},!1);a.addEventListener("error",f,!1);a.src=g})}ne.prototype.da=function(){var a=this;this.l.then(function(){P(a.g,{type:7})}).catch(function(b){return R(b)})};\nfunction pe(a,b){a.l.then(function(){P(a.g,b)}).catch(function(c){return R(c)})};function qe(a,b){this.F=a;this.B=b;this.ib=[];this.Zb=[]}qe.prototype.ya=function(a,b){var c=this;if("iframe"===b&&(b=a.getAttribute("data-colibrio-iframe-src"))){var d=jb(b),e=a.getAttribute("sandbox");d||null!==e&&-1===e.indexOf("allow-scripts")?b.startsWith("http")?this.F.allowRemoteResources&&this.ib.push(a):(null===e||-1!==e.indexOf("allow-scripts"))&&this.ib.push(a):(b=this.B.g({iframeSrc:b,type:15}).then(function(f){return oe(a,f.config,c.F,c.B)}).catch(function(f){R(f);return null}),this.Zb.push(b))}};\nfunction re(a){return Promise.all(a.Zb).then(function(b){return b.filter(function(c){return null!==c})})}function se(a){for(var b=0;b<a.ib.length;b++){var c=a.ib[b];c.src=c.getAttribute("data-colibrio-iframe-src")}};function te(){}te.prototype.ya=function(a,b){"script"===b&&a.hasAttribute("data-colibrio-iframe-runtime")&&(b=a.parentNode)&&b.removeChild(a)};function ue(a){this.wb=a;this.ta=[]}function ve(a,b){a.ta.push(b)}ue.prototype.La=function(a,b){if(a.parentNode)for(var c=0;c<this.wb.length;c++){var d=this.wb[c];d.ba(a,b,document)&&(this.ta.push(d.aa(a)),d.ca()&&(this.wb.splice(c,1),c--))}};function we(a){return a.complete?Promise.resolve():new Promise(function(b,c){function d(){f();c()}function e(){f();b()}function f(){a.removeEventListener("load",e,!1);a.removeEventListener("error",d,!1);a.removeEventListener("abort",d,!1);clearTimeout(g)}var g=setTimeout(function(){console.warn("ImageUtils.waitUntilImageLoaded() timed out.");e()},4E3);a.addEventListener("load",e,!1);a.addEventListener("error",d,!1);a.addEventListener("abort",d,!1)})};function xe(a){var b=ye(a),c=b.width,d=b.height;return null!==d&&null!==c?Promise.resolve():we(a).finally(function(){null===d&&null===c?(a.setAttribute("height",""+a.height),a.setAttribute("width",""+a.width)):null===d&&null!==c?a.setAttribute("height",""+(0===a.width?a.height:c/a.width*a.height)):null===c&&null!==d&&a.setAttribute("width",""+(0===a.height?a.width:d/a.height*a.width))})}\nfunction ze(a){var b=!0;try{a.poster&&(b=!1)}catch(g){}var c=1>a.readyState?new Promise(function(g){function h(){a.removeEventListener("loadedmetadata",h,!1);clearTimeout(k);g()}var k=setTimeout(h,1E3);a.addEventListener("loadedmetadata",h,!1)}):Promise.resolve();if(!b&&a.poster)b=new Promise(function(g){function h(){k.removeEventListener("load",h,!1);k.removeEventListener("error",h,!1);k.removeEventListener("abort",h,!1);clearTimeout(l);e=k.width;f=k.height;g()}var k=new Image,l=setTimeout(h,4E3);\nk.addEventListener("load",h,!1);k.addEventListener("error",h,!1);k.addEventListener("abort",h,!1);k.src=a.poster});else{b=Number(a.getAttribute("data-colibrio-video-width"))|0;var d=Number(a.getAttribute("data-colibrio-video-height"))|0;b&&d||(d=.25*a.ownerDocument.defaultView.innerHeight,b=16*d/9);a.poster="data:image/svg+xml;base64,"+btoa(\'<?xml version="1.0" encoding="UTF-8"?>\\n<svg xmlns="http://www.w3.org/2000/svg" width="\'+b+\'" height="\'+d+\'" viewBox="0 0 \'+b+" "+d+\'">\\n    <path d="M0 0h\'+\nb+"v"+d+\'H0z" fill="#000"/>\\n</svg>\\n\');var e=b;var f=d;b=new Promise(function(g){setTimeout(function(){g()},16)})}return Promise.all([b,c]).then(function(){if(1<=a.readyState||a.width&&a.height)e=a.width,f=a.height;var g=ye(a),h=g.width;g=g.height;if(null===g||null===h)null===g&&null===h?(a.setAttribute("height",""+f),a.setAttribute("width",""+e)):null===g&&null!==h?a.setAttribute("height",""+(0===a.width?a.height:h/a.width*a.height)):null===h&&null!==g&&a.setAttribute("width",""+(0===a.height?a.width:\ng/a.height*a.width))})}function ye(a){var b=/^\\s*\\d+(.\\d*)?%/,c=a.getAttribute("height"),d=a.getAttribute("width"),e=c&&b.test(c);b=d&&b.test(d);c=parseFloat(c);if(e||isNaN(c)||0>c)a.removeAttribute("height"),c=null;d=parseFloat(d);if(b||isNaN(d)||0>d)a.removeAttribute("width"),d=null;return{height:c,width:d}};function Ae(a,b){this.xb=a;this.ec=b;this.ic=[]}Ae.prototype.ya=function(a,b){if(a.hasAttribute("data-colibrio-image-src")){var c=a.getAttribute("data-colibrio-image-src");if(c){c=JSON.parse(c);var d;switch(b){case "img":Be(this.xb,a,c.src);this.ec&&(d=xe(a));break;case "video":Ce(this.xb,a,c.src);this.ec&&(d=ze(a));break;case "image":De(this.xb,a,c.src)}d&&this.ic.push(d.catch(function(e){mb(e)||R(e)}))}}};Ae.prototype.sc=function(){return Promise.all(this.ic)};function Ee(){this.hc=28}Ee.prototype.ya=function(a){for(var b=a.attributes,c=[],d=0,e=b.length;d<e;d++){var f=b[d];/^data-colibrio-inline-script-/i.test(f.localName||f.name)&&c.push(f)}for(d=0;d<c.length;d++)e=c[d],f=e.localName||e.name,e.prefix&&e.namespaceURI?(a.setAttributeNS(e.namespaceURI,f.slice(this.hc),e.value),b.g(e.namespaceURI,f)):(a.setAttribute(f.slice(this.hc),e.value),b.removeNamedItem(f))};function Fe(a,b){var c=this;this.g=new Map;this.h=new Map;b.ia.forEach(function(d){try{Ge(a,d.N);var e;if(d.kb)var f=e=Sa;else{var g=He(a,d.N);e=g.get||Sa;f=g.set||Sa}g={configurable:!0};d.V&&(g.get=function(){return d.V(this,e)});d.xa&&(g.set=function(h){d.xa(this,f,h)});Object.defineProperty(a,d.N,g);c.g.set(d.N,{get:e,set:f})}catch(h){S(h)}});b.ja.forEach(function(d){try{Ge(a,d.J);var e=He(a,d.J);if(I(e.value)){var f=e.value;Object.defineProperty(a,d.J,{configurable:!0,value:function(){return d.L(this,\nf,Da.apply(0,arguments))}});c.h.set(d.J,f)}else S(Error(a.constructor.name+"."+d.J+" is not a method."))}catch(g){S(g)}})}function Ge(a,b){var c=Object.getOwnPropertyDescriptor(a,b);if(c&&!c.configurable)throw Error(a.constructor.name+"."+b+" not configurable");}function He(a,b){var c=Object.getOwnPropertyDescriptor(a,b);if(!c){if((a=Object.getPrototypeOf(a))&&a.constructor!==Object)return He(a,b);throw Error("Property descriptor not found: "+b);}return c};function Ie(){var a=this;this.M="loading";new Fe(Document.prototype,{ia:[{V:function(){return a.M},N:"readyState"}],ja:[{L:function(){S("Ignoring call to document.write() in publication script.")},J:"write"}]})};var Je=__lib__base64_js;var Ke=__lib__bowser;var Le=null,Me=null,Ne=null;function Oe(){Me||(Me=Ke.getParser(navigator.userAgent));return Me}function Pe(){if(null===Le){var a=Oe(),b;null===Ne&&(Ne=(b=Oe().getOSVersion())?parseInt(b.split(".")[0]):NaN);b=Ne;Le=I(URL.createObjectURL)&&(isNaN(b)||"iOS"!==a.getOSName()||9<b)}return Le};function Qe(a,b){return b||"WebKit"===Oe().getEngine().name||!Pe()?{mediaCategoryOrType:"image/*",src:a,type:11}:{mediaCategoryOrType:"image/*",src:a,type:13}}function Re(a,b){var c="";12===a.type?c=b||!Pe()?ib(a.metadata.mediaType||"",Je.fromByteArray(new Uint8Array(a.buffer))):URL.createObjectURL(a.metadata.mediaType?new Blob([a.buffer],{type:a.metadata.mediaType}):new Blob([a.buffer])):14===a.type&&(c=URL.createObjectURL(a.blob));return c};function Se(a,b){var c=this;this.B=a;this.F=b;this.s=[];this.A=[];this.l=new Map;this.g=new Map;this.h=new Map;this.j=new Fe(HTMLIFrameElement.prototype,{ia:[{V:function(d){return c.h.get(d)||""},N:"src",xa:function(d,e,f){Te(c,d,f)}}],ja:[{L:function(d,e,f){var g=f[1];"src"===f[0]?Te(c,d,g):e.apply(d,f)},J:"setAttribute"}]});(new MutationObserver(function(d){for(var e=0;e<d.length;e++)for(var f=d[e].addedNodes,g=0;g<f.length;g++){var h=f[g];A(h)&&Ue(c,h)}})).observe(document.documentElement,{childList:!0,\nsubtree:!0})}function Ue(a,b){if("iframe"===b.localName){var c,d=a.j.g.get("src");(c=a.l.get(b))||d&&(c=d.get.call(b));c||(d=a.j.h.get("getAttribute"))&&(c=d.call(b,"src"));c&&Te(a,b,c)}else for(b=b.firstChild;b;)A(b)&&Ue(a,b),b=b.nextSibling}\nfunction Ve(a,b,c,d){We(a.g.get(c))||a.g.set(c,{status:"loaded",value:d});if(c===a.h.get(b)&&a.j.g.get("src")){if(c=b.getAttribute("sandbox"))c=c.replaceAll("allow-same-origin",""),b.setAttribute("sandbox",c);oe(b,d,a.F,a.B).then(function(e){a.A.push(e);for(var f=v(a.s),g=f.next();!g.done;g=f.next())pe(e,g.value);e.da()}).catch(function(e){mb(e)||R(e)})}}\nfunction Xe(a,b){var c=a.h.get(b),d=b.getAttribute("sandbox");d=!d||-1!==d.indexOf("allow-scripts");c&&(d?(d=a.g.get(c),Pa(d)?(d=a.B.g({iframeSrc:c,type:15}).then(function(e){return e.config}),a.g.set(c,{promise:d,ea:1,status:"loading"}),d.then(function(e){Ve(a,b,c,e)}).catch(function(e){mb(e)||R(e)})):"loaded"===d.status?Ve(a,b,c,d.value):(d.ea++,d.promise.then(function(e){Ve(a,b,c,e)}).catch(function(e){mb(e)||R(e)}))):R(new $b("IFRAME_SANDBOX_MISSING_ALLOW_SCRIPTS","Unable to load Iframe with sandbox attribute that is missing \'allow-scripts\'")))}\nfunction Te(a,b,c){if(b.isConnected){a.l.delete(b);var d=a.h.get(b);if(d!==c){if(d){var e=a.g.get(d);"loading"===(null==e?void 0:e.status)&&(e.ea--,0===e.ea&&a.g.delete(d))}a.h.set(b,c);d=!0}else d=!1;d&&(jb(c)?(a=a.j.g.get("src"))&&a.set.call(b,c):Xe(a,b))}else a.l.set(b,c)}function We(a){return"loaded"===(null==a?void 0:a.status)};function Ye(a){var b=this;this.B=a;this.j=new WeakSet;this.g=new Map;this.h=new WeakMap;this.l=new Fe(HTMLImageElement.prototype,{ia:[{V:function(c){return b.h.get(c)||""},N:"src",xa:function(c,d,e){Be(b,c,e)}},{V:function(c,d){return b.j.has(c)?!1:d.call(c)},N:"complete"}],ja:[{L:function(c,d,e){var f=e[1];"src"===e[0]?Be(b,c,f):d.apply(c,e)},J:"setAttribute"},{L:function(c,d,e){return"src"===e[0]?b.h.get(c)||null:d.apply(c,e)},J:"getAttribute"}]});this.A=new Fe(HTMLVideoElement.prototype,{ia:[{V:function(c){return b.h.get(c)||\n""},N:"poster",xa:function(c,d,e){Ce(b,c,e)}}],ja:[{L:function(c,d,e){var f=e[1];"poster"===e[0]?Ce(b,c,f):d.apply(c,e)},J:"setAttribute"},{L:function(c,d,e){return"poster"===e[0]?b.h.get(c)||null:d.apply(c,e)},J:"getAttribute"}]});this.s=new Fe(SVGImageElement.prototype,{ia:[],ja:[{L:function(c,d,e){var f=e[1],g=e[2];"http://www.w3.org/1999/xlink"===e[0]&&"href"===f?De(b,c,g):d.apply(c,e)},J:"setAttributeNS"},{L:function(c,d,e){var f=e[1];return"http://www.w3.org/1999/xlink"===e[0]&&"href"===f?b.h.get(c)||\nnull:d.apply(c,e)},J:"getAttributeNS"}]});(new MutationObserver(function(c){for(var d=0;d<c.length;d++)for(var e=c[d].addedNodes,f=0;f<e.length;f++){var g=e[f];A(g)&&Ze(b,g)}})).observe(document.documentElement,{childList:!0,subtree:!0})}function Be(a,b,c){$e(a,b,c)&&(jb(c)?(a.g.set(c,c),(a=a.l.g.get("src"))&&a.set.call(b,c)):af(a,b,a.l,"src",!1))}\nfunction De(a,b,c){$e(a,b,c)&&(jb(c)?(a.g.set(c,c),(a=a.s.h.get("setAttributeNS"))&&a.call(b,"http://www.w3.org/1999/xlink","href",c)):af(a,b,a.s,"href",!0))}function Ce(a,b,c){$e(a,b,c)&&(jb(c)?(a.g.set(c,c),(a=a.A.g.get("poster"))&&a.set.call(b,c)):af(a,b,a.A,"poster",!1))}\nfunction Ze(a,b){if("img"===b.localName){var c=bf(b,a.l,"src",!1);c&&Be(a,b,c)}else if("video"===b.localName)(c=bf(b,a.A,"poster",!1))&&Ce(a,b,c);else if("image"===b.localName)(c=bf(b,a.s,"href",!0))&&De(a,b,c);else for(b=b.firstChild;b;)A(b)&&Ze(a,b),b=b.nextSibling}function bf(a,b,c,d){var e;d?(b=b.h.get("getAttributeNS"))&&(e=b.call(a,"http://www.w3.org/1999/xlink",c)):((d=b.g.get(c))&&(e=d.get.call(a)),e||(b=b.h.get("getAttribute"))&&(e=b.call(a,c)));return e}\nfunction cf(a,b,c,d,e,f,g){E(a.g.get(c))||a.g.set(c,d);c===a.h.get(b)&&(g?(a=e.h.get("setAttributeNS"))&&a.call(b,"http://www.w3.org/1999/xlink","href",d):(a=e.g.get(f))&&a.set.call(b,d))}\nfunction af(a,b,c,d,e){var f=a.h.get(b);if(f){var g=a.g.get(f);if(Pa(g)){g=Qe(f,!1);g=a.B.g(g).then(function(k){if(0>=h.ea)throw new $b("ABORTED");return Re(k,!1)});var h={promise:g,ea:1};a.g.set(f,h);a.j.add(b);g.then(function(k){a.j.delete(b);cf(a,b,f,k,c,d,e)}).catch(function(k){mb(k)||(a.j.delete(b),R(k))})}else E(g)?cf(a,b,f,g,c,d,e):(g.ea++,a.j.add(b),g.promise.then(function(k){a.j.delete(b);cf(a,b,f,k,c,d,e)}).catch(function(k){mb(k)||(a.j.delete(b),R(k))}))}}\nfunction $e(a,b,c){var d=a.h.get(b);if(d!==c){var e;(e=a.h.get(b))?(e=a.g.get(e),e=!(E(e)||Pa(e))):e=!1;e&&(e=a.g.get(d),E(e)||Pa(e)||(e.ea--,0===e.ea&&a.g.delete(d)));a.h.set(b,c);return!0}return!1};var df=document;function ef(){var a;"http://www.w3.org/1999/xhtml"===df.documentElement.namespaceURI?a=df.createElement("style"):a=df.createElementNS(df.documentElement.namespaceURI,"style");return a}function ff(a){var b=null;0<a.childNodes.length&&E(a.childNodes[0].data)&&(b=a.childNodes[0].data,a.childNodes=[]);a=Ac(a,df);null!==b&&a.appendChild(document.createTextNode(b));return a}\nfunction gf(a){var b=null;0<a.childNodes.length&&E(a.childNodes[0].data)&&(b=a.childNodes[0].data,a.childNodes=[]);if(b){var c=ef();zc(a,c);hf(c,b)}else c=Ac(a,df);return c}function hf(a,b){"style"===a.localName&&a.appendChild(document.createTextNode(b))};function jf(a){var b=this;this.B=a;this.g=new WeakMap;this.j=new Fe(HTMLLinkElement.prototype,{ia:[{V:function(c){return kf(b,c)},N:"href",xa:function(c,d,e){lf(b,c,e)}}],ja:[{L:function(c,d,e){var f=e[1];"href"===e[0]?lf(b,c,f):d.apply(c,e)},J:"setAttribute"},{L:function(c,d,e){return"href"===e[0]?kf(b,c):d.apply(c,e)},J:"getAttribute"},{L:function(c,d,e){return"href"===e[0]?null!==kf(b,c):d.apply(c,e)},J:"hasAttribute"}]});a=this.j.g.get("href");this.l=a.get;this.h=a.set}\nfunction mf(a,b,c){a.B.g({mediaCategoryOrType:"text/css",src:c,type:26}).then(function(d){if(a.g.get(b)===c){var e=ef();hf(e,d.data);Wa(document).appendChild(e);d=new Event("load",{bubbles:!1,cancelable:!1});b.dispatchEvent(d)}}).catch(function(d){return R(d)})}function kf(a,b){return a.g.has(b)?a.g.get(b):a.l.call(b)}function lf(a,b,c){E(c)?/^(?:blob:|data:|https?:)/.test(c)?(a.g.delete(b),a.h.call(b,c)):(a.g.set(b,c),mf(a,b,c)):(a.g.delete(b),a.h.call(b,""))};function nf(a,b){var c=this;this.A=a;this.B=b;this.j=null;this.h=[];this.g=!1;this.Ea=this.ka=null;this.s=1;this.l=null;this.I=new Promise(function(d,e){c.Ea=d;c.ka=e})}function of(a){a.g=!0;a.Ea=null;a.ka&&(a.ka(new $b("ABORTED")),a.ka=null)}nf.prototype.start=function(){var a=this;this.B.g({path:this.A,type:8}).then(function(b){a.g||(a.l=b.streamId,b.metadata.mediaType&&(a.j=b.metadata.mediaType),pf(a).catch(function(c){a.ka&&a.ka(c);of(a)}))}).catch(function(b){a.ka&&a.ka(b);of(a)});return this.I};\nfunction pf(a){var b,c,d,e,f,g,h;return Ca(function(k){switch(k.g){case 1:if(!a.l){k.la(0);break}b=!1;c=a.s;case 3:if(b||a.g||c!==a.s){k.la(5);break}d={streamId:a.l,type:21};return ta(k,a.B.g(d),6);case 6:e=k.A;e.data&&a.h.push(e.data);b=e.done;k.la(3);break;case 5:if(b&&!a.g){if(Pe())g=a.j?new Blob(a.h,{type:a.j}):new Blob(a.h),f=URL.createObjectURL(g);else{for(var l=a.h,m=0,n=0;n<l.length;n++)m+=l[n].byteLength;m=new Uint8Array(m);for(var p=n=0;p<l.length;p++){var r=l[p];m.set(new Uint8Array(r),\nn);n+=r.byteLength}h=m;f=ib(a.j||"",Je.fromByteArray(h))}a.Ea&&a.Ea(f);of(a)}k.g=0}})};function qf(a,b,c){this.D=a;this.B=b;this.C=c;this.j=!1;this.s=rf++;this.l=-1;this.g=!0;this.h=!1}function sf(a){a.j=!0;tf(a,"mediaElementInsideVisiblePages");3<=a.D.readyState&&(a.h=!0,tf(a,"mediaElementReady"));a.D.paused||(a.g=!1,tf(a,"mediaElementPlay"));a.D.addEventListener("canplay",a);a.D.addEventListener("play",a);a.D.addEventListener("pause",a);a.D.addEventListener("seeked",a);a.D.addEventListener("timeupdate",a);a.D.addEventListener("waiting",a)}\nqf.prototype.handleEvent=function(a){switch(a.type){case "canplay":this.h||(this.h=!0,tf(this,"mediaElementReady"));break;case "play":this.g&&(this.g=!1,tf(this,"mediaElementPlay"));break;case "pause":this.g||(this.g=!0,tf(this,"mediaElementCurrentTimeChanged"),tf(this,"mediaElementPaused"));break;case "seeked":tf(this,"mediaElementCurrentTimeChanged");tf(this,"mediaElementSeeked");break;case "timeupdate":a=Date.now();1E3<a-this.l&&(this.l=a,tf(this,"mediaElementCurrentTimeChanged"));break;case "waiting":this.h&&\n(this.h=!1,tf(this,"mediaElementWaiting"))}};function tf(a,b){var c=U(a.D);if(c=c?Bc(c,a.C):null)b={containerPath:c.o,currentTimeMs:Math.round(1E3*a.D.currentTime),durationMs:Math.round(1E3*a.D.duration),engineEventType:b,instanceId:a.s,nodeData:Yb(a.D),nodeOffset:c.i,paused:a.D.paused,ready:3<=a.D.readyState,type:31},P(a.B,b)}var rf=1;function uf(a,b){var c=this;this.B=a;this.C=b;this.A=!1;this.j=new Map;this.g=new WeakMap;this.l=new Map;this.s=new WeakMap;this.I=new Fe(HTMLSourceElement.prototype,{ia:[],ja:[{L:function(d,e,f){var g=f[0],h=f[1];E(g)&&"src"===g.toLowerCase()?vf(c,d,String(h)):e.apply(d,f)},J:"setAttribute"},{L:function(d,e,f){var g=f[0],h=c.s.get(d);return h&&E(g)&&"src"===g.toLowerCase()?h.cb:e.apply(d,f)},J:"getAttribute"}]});this.h=new Fe(HTMLMediaElement.prototype,{ia:[{V:function(d){var e;return(null==(e=c.g.get(d))?\nvoid 0:e.Na)||""},N:"src",xa:function(d,e,f){wf(c,d,f)}},{V:function(d,e){var f=c.g.get(d);return f&&"done"!==f.Sa?f.currentTime:e.call(d)},N:"currentTime",xa:function(d,e,f){if(C(f)){var g=c.g.get(d);g&&"done"!==g.Sa?g.currentTime=f:e.call(d,f)}}}],ja:[{L:function(d,e){var f=c.g.get(d);if(!f)return S(new O("mediaElement.play() called, but element is not tracked by MediaElementProxy.")),e.call(d);f.paused=!1;if("done"===f.Sa)return e.call(d);xf(c,d,"");yf(c,d).forEach(function(h){zf(c,h.element,"")});\nvar g;null==(g=c.h.h.get("load"))||g.call(d);d.autoplay=!0;return Af(c,d,f).then(function(){if(!f.paused)return e.call(d)}).catch(function(h){mb(h)||R(h);return Promise.reject(new DOMException("Play aborted","AbortError"))})},J:"play"},{L:function(d,e){var f=c.g.get(d);f&&(f.paused=!0);return e.call(d)},J:"pause"},{L:function(d,e){xf(c,d,"");yf(c,d).forEach(function(l){zf(c,l.element,"")});e.call(d);e=c.h.g.get("paused");var f,g,h,k={currentTime:0,vb:null,Sa:"unloaded",Na:null!=(g=null==(f=c.g.get(d))?\nvoid 0:f.Na)?g:"",paused:null!=(h=null==e?void 0:e.get.call(d))?h:!0};c.g.set(d,k);Af(c,d,k).catch(function(l){mb(l)||R(l)})},J:"load"},{L:function(d,e,f){var g=f[0],h=f[1];if(E(g)&&"src"===g.toLowerCase())wf(c,d,String(h));else return e.apply(d,f)},J:"setAttribute"},{L:function(d,e,f){var g=f[0];if(E(g)&&"src"===g.toLowerCase()){var h,k;return null!=(k=null==(h=c.g.get(d))?void 0:h.Na)?k:""}return e.apply(d,f)},J:"getAttribute"}]});(new MutationObserver(function(d){for(var e=0;e<d.length;e++){for(var f=\nd[e].addedNodes,g=0;g<f.length;g++){var h=f[g];A(h)&&Bf(c,h)}f=d[e].removedNodes;for(g=0;g<f.length;g++)if(h=f[g],A(h)&&("audio"===h.localName||"video"===h.localName)){var k=c.j.get(h);k&&(k.j&&(tf(k,"mediaElementOutsideVisiblePages"),k.D.removeEventListener("canplay",k,!0),k.D.removeEventListener("play",k,!0),k.D.removeEventListener("pause",k,!0),k.D.removeEventListener("seeked",k,!0),k.D.removeEventListener("timeupdate",k,!0),k.D.removeEventListener("waiting",k,!0)),c.j.delete(h))}}})).observe(document.documentElement,\n{childList:!0,subtree:!0})}function Ef(a){return A(a)&&"source"===a.localName}function Ff(a){a.A||(a.A=!0,a.j.forEach(function(b){return sf(b)}))}function wf(a,b,c){var d=a.g.get(b);d&&d.Na===c||(d&&Gf(a,d.Na),c={currentTime:0,vb:null,Sa:"unloaded",Na:c,paused:b.paused},a.g.set(b,c),Af(a,b,c).catch(function(e){mb(e)||R(e)}))}function vf(a,b,c){var d=a.s.get(b);d?d.cb=c:a.s.set(b,{cb:c,Wb:""})}\nfunction Hf(a,b,c){var d,e,f,g,h,k,l;return Ca(function(m){switch(m.g){case 1:c.Sa="loading";a.j.has(b)||(d=new qf(b,a.B,a.C),a.j.set(b,d),a.A&&sf(d));if(e=c.Na){k=If(a,e);if(k.url){xf(a,b,k.url);m.la(3);break}return ta(m,k.Vb,6)}f=yf(a,b).map(function(n){var p=n.Vc,r=n.element;n=If(a,p.cb);p.Wb!==p.cb&&(Gf(a,p.Wb),p.Wb=p.cb);return n.url?Promise.resolve({tc:r,url:n.url}):n.Vb.then(function(t){return{tc:r,url:t}}).catch(function(t){throw t;})});return ta(m,Promise.allSettled(f),4);case 4:g=m.A;if(Jf(a,\nb,c))throw new $b("ABORTED");g.forEach(function(n){"fulfilled"===n.status&&zf(a,n.value.tc,n.value.url)});null==(h=a.h.h.get("load"))||h.call(b);m.la(3);break;case 6:l=m.A;if(Jf(a,b,c))throw new $b("ABORTED");xf(a,b,l);case 3:Kf(a,b,c.currentTime),c.Sa="done",m.g=0}})}function yf(a,b){var c=[];b=b.childNodes;for(var d=0;d<b.length;d++){var e=b[d];if(Ef(e)){var f=a.s.get(e);f?c.push({element:e,Vc:f}):S(new O(\'Found untracked <source> element with src="\'+e.src))}}return c}\nfunction If(a,b){if(/^\\s*blob:/.test(b)||/^\\s*data:/.test(b)||/^\\s*[a-zA-Z0-9]{1,20}:/.test(b))return{ea:0,eb:null,url:b,Vb:Promise.resolve(b)};var c=a.l.get(b);if(c)return c.url||c.ea++,c;c=new nf(b,a.B);var d={ea:1,eb:c,url:null,Vb:c.start().then(function(e){d.url=e;d.eb=null;return e})};a.l.set(b,d);return d}function Bf(a,b){if("audio"===b.localName||"video"===b.localName)Lf(a,b);else if(Ef(b))Mf(a,b);else for(b=b.firstChild;b;)A(b)&&Bf(a,b),b=b.nextSibling}\nfunction Lf(a,b){var c=a.h.g.get("src");c&&(b.childNodes.forEach(function(d){Ef(d)&&Mf(a,d)}),a.g.has(b)||(c=c.get.call(b),wf(a,b,c)))}function Mf(a,b){var c=a.I.h.get("getAttribute");c&&(c=c.call(b,"src"),vf(a,b,c))}function Jf(a,b,c){return a.g.get(b)!==c}function Af(a,b,c){c.vb||(c.vb=Hf(a,b,c));return c.vb}function Gf(a,b){if(b){var c=a.l.get(b);c&&c.eb&&(c.ea--,0===c.ea&&(of(c.eb),c.eb=null,a.l.delete(b)))}}function Kf(a,b,c){(a=a.h.g.get("currentTime"))&&a.set.call(b,c)}\nfunction xf(a,b,c){c?(a=a.h.g.get("src"))&&a.set.call(b,c):b.removeAttribute("src")}function zf(a,b,c){c?(a=a.I.h.get("setAttribute"))&&a.call(b,"src",c):b.removeAttribute("src")};function Nf(a){var b=this;this.B=a;this.g=new WeakMap;this.j=new Fe(HTMLScriptElement.prototype,{ia:[{V:function(c){return Of(b,c)},N:"src",xa:function(c,d,e){Pf(b,c,e)}}],ja:[{L:function(c,d,e){return"src"===e[0]?null!==Of(b,c):d.apply(c,e)},J:"hasAttribute"},{L:function(c,d,e){var f=e[1];"src"===e[0]?Pf(b,c,f):d.apply(c,e)},J:"setAttribute"},{L:function(c,d,e){return"src"===e[0]?Of(b,c):d.apply(c,e)},J:"getAttribute"}]});a=this.j.g.get("src");this.l=a.get;this.h=a.set}\nfunction Qf(a,b,c){a.B.g({mediaCategoryOrType:"text/javascript",src:c,type:26}).then(function(d){b.appendChild(document.createTextNode(d.data));d=new Event("load",{bubbles:!1,cancelable:!1});b.dispatchEvent(d)}).catch(function(d){return R(d)})}function Of(a,b){return a.g.has(b)?a.g.get(b):b.hasAttribute("data-colibrio-org-src")?b.getAttribute("data-colibrio-org-src"):a.l.call(b)}\nfunction Pf(a,b,c){E(c)?/^(?:blob:|data:|https?:)/.test(c)?(a.g.delete(b),a.h.call(b,c)):(a.g.set(b,c),Qf(a,b,c)):(a.g.delete(b),a.h.call(b,""))};function Rf(a,b){var c=this;this.B=a;this.g=function(d){d&&P(c.B,{href:d,type:40})};new Fe(window,{ia:[{V:function(d,e){return e.call(d)*b},N:"devicePixelRatio"}],ja:[{L:function(d,e,f){c.g(0<f.length?f[0]+"":void 0)},J:"open"},{L:function(){},J:"alert"},{L:function(){},J:"confirm"},{L:function(){},J:"prompt"}]})};function Sf(a){this.D=a}Sf.prototype.da=function(){try{this.D.play().catch(function(a){return S(a)})}catch(a){S("Auto-play prevented by browser"),S(a)}};function Tf(a){this.g=a}Tf.prototype.aa=function(a){return new Sf(a)};Tf.prototype.ba=function(a){var b;if(b=a.hasAttribute("data-colibrio-autoplay"))a:{switch(a.localName){case "audio":b=this.g.allowAudioElementAutoplay;break a;case "video":b=this.g.allowVideoElementAutoplay;break a}b=!1}return b};Tf.prototype.ca=function(){return!1};function Uf(a,b,c){var d=[];d=void 0===d?[]:d;this.j=a;this.l=b;this.s=c;this.g=d;this.h=""}Uf.prototype.toString=function(){return this.j+"."+this.l+"."+this.s+(0<this.g.length?"-"+this.g.join("."):"")+(this.h?"+"+this.h:"")};function Vf(a,b,c){this.B=a;this.v=b;this.C=c;this.$b=[];this.mc=function(){}}\nVf.prototype.Ma=function(a,b){var c=a.type,d=B(a.target)?U(a.target):null,e,f="";if(!a.defaultPrevented&&A(a.target)){if(A(a.target)){for(e=a.target;A(e)&&"a"!==e.localName&&"area"!==e.localName;)e=e.parentNode;e=A(e)?e:null}else e=null;e&&(f=e.getAttribute("href")||"")}f&&a.preventDefault();d=d?Bc(d,this.C):null;P(this.B,{engineEventDef:{button:a.button,buttons:a.buttons,clientX:a.clientX,clientY:a.clientY,containerPath:d?d.o:null,ctrlKey:a.ctrlKey,defaultPrevented:a.defaultPrevented,href:f||"",\nisTrusted:a.isTrusted,metaKey:a.metaKey,nodeData:b,nodeOffset:d?d.i:-1,pageX:a.pageX,pageY:a.pageY,processedByDocument:a._processed,screenX:a.screenX,screenY:a.screenY,windowInnerHeight:window.innerHeight,windowInnerWidth:window.innerWidth},engineEventType:c,type:34})};\nVf.prototype.da=function(){var a=Oe();if("iOS"===a.getOS().name||"macOS"===a.getOS().name){var b=K(document);var c=(a.getOSVersion()||"").trim(),d=/^(\\d+)(?:\\.(\\d+))?(?:\\.(\\d+))?/.exec(c);if(d){if(a=d.length,a=new Uf(1<a&&d[1]?Number(d[1]):0,2<a&&d[2]?Number(d[2]):0,3<a&&d[3]?Number(d[3]):0),c.length>d[0].length)b:if(c=c.slice(d[0].length),"+"===c[0])a.h=c.slice(1);else if("-"===c[0])for(d=c.indexOf("+"),-1!==d?(a.h=c.slice(d+1),c=c.slice(1,d)):c=c.slice(1),c=c.split("."),d=0;d<c.length;d++){var e=\nc[d];if(/^[0-9]+$/.test(e))a.g.push(Number(e));else if(/^[0-9A-Za-z]+$/.test(e))a.g.push(e);else{a.g=[];break b}}}else a=null;if(a&&12>=a.j)for(b=b.firstElementChild;b;)D(b)&&b.style.setProperty("-webkit-tap-highlight-color","transparent","important"),this.v.l.call(b,"click",this.mc,!1),this.$b.push(b),b=b.nextElementSibling;else b.firstElementChild&&(b=b.firstElementChild,D(b)&&b.style.setProperty("-webkit-tap-highlight-color","transparent","important"),this.v.l.call(b,"click",this.mc,!1),this.$b.push(b))}Q(this.v,\n"click",this,!1);Q(this.v,"dblclick",this,!1)};function Wf(a,b,c){this.B=a;this.v=b;this.C=c}Wf.prototype.aa=function(){return new Vf(this.B,this.v,this.C)};Wf.prototype.ba=function(a,b,c){return a===c.documentElement};Wf.prototype.ca=function(){return!0};function Xf(a){this.D=a;this.D.addEventListener("contextmenu",this,!0)}Xf.prototype.handleEvent=function(a){a.preventDefault()};function Yf(){}Yf.prototype.aa=function(a){return new Xf(a.ownerDocument.defaultView.document.documentElement)};Yf.prototype.ba=function(a,b,c){return a===c.documentElement};Yf.prototype.ca=function(){return!0};function Zf(){}Zf.prototype.aa=function(a){return new Xf(a)};Zf.prototype.ba=function(a,b){switch(b){case "img":case "image":case "video":case "audio":return!0}return!1};Zf.prototype.ca=function(){return!1};function $f(a){this.fc=a;this.Ic=a.parentNode}$f.prototype.da=function(){var a=this.fc.sheet;a?a.disabled=!0:this.Ic.removeChild(this.fc)};function ag(){}ag.prototype.aa=function(a){return new $f(a)};ag.prototype.ba=function(a){return a.hasAttribute("data-colibrio-css-pause-animation")};ag.prototype.ca=function(){return!0};function bg(a){this.D=a;this.Cc=a.getAttribute("style")||""}bg.prototype.da=function(){var a=this.D.getAttribute("data-colibrio-css-animation-original")||this.Cc,b=this.D.getAttribute("data-colibrio-css-transition");b&&(a+=";"+b);this.D.setAttribute("style",a)};function cg(){}cg.prototype.aa=function(a){return new bg(a)};cg.prototype.ba=function(a){return a.hasAttribute("data-colibrio-css-transition")||a.hasAttribute("data-colibrio-css-animation-original")};cg.prototype.ca=function(){return!1};function dg(a){this.Bc=Wa(Z);this.Ya=null;a?(this.Ya=ef(),hf(this.Ya,a)):this.Ya=null}dg.prototype.da=function(){this.Ya&&this.Bc.appendChild(this.Ya)};function eg(a,b){this.D=a;this.v=b;b.l.call(a,"dragstart",this,!0)}eg.prototype.handleEvent=function(a){a.cancelable&&a.preventDefault()};function fg(a){this.v=a}fg.prototype.aa=function(a){return new eg(a,this.v)};fg.prototype.ba=function(a,b,c){return a===c.documentElement};fg.prototype.ca=function(){return!0};function gg(a,b,c){this.B=a;this.v=b;this.C=c}\ngg.prototype.Ma=function(a,b){var c=a.type,d=B(a.target)?U(a.target):null;d=d?Bc(d,this.C):null;var e=a.code,f=d?d.o:null,g=a.defaultPrevented,h=a.isComposing,k=a.isTrusted,l=a.key,m=a.keyCode,n=a.location;var p={alt:a.getModifierState("Alt"),altGraph:a.getModifierState("AltGraph"),capsLock:a.getModifierState("CapsLock"),control:a.getModifierState("Control"),meta:a.getModifierState("Meta"),numLock:a.getModifierState("NumLock"),os:a.getModifierState("OS"),scrollLock:a.getModifierState("ScrollLock"),\nshift:a.getModifierState("shift")};P(this.B,{engineEventDef:{code:e,containerPath:f,defaultPrevented:g,isComposing:h,isTrusted:k,key:l,keyCode:m,location:n,modifiers:p,nodeData:b,nodeOffset:d?d.i:-1,processedByDocument:a._processed,repeat:a.repeat},engineEventType:c,type:30})};gg.prototype.Ta=function(){Q(this.v,"keydown",this,!1);Q(this.v,"keyup",this,!1)};function hg(a,b,c){this.B=a;this.v=b;this.C=c}hg.prototype.aa=function(){return new gg(this.B,this.v,this.C)};hg.prototype.ba=function(a,b,c){return a===c.documentElement};hg.prototype.ca=function(){return!0};function ig(a){this.D=a}ig.prototype.Ta=function(){this.D.setAttribute("tabindex","0")};function jg(){}jg.prototype.aa=function(a){return new ig(a)};jg.prototype.ba=function(a){return db(a)&&$a(a)&&!bb(a)};jg.prototype.ca=function(){return!1};function kg(a,b){this.D=a;this.pb=b;var c=this.D.getAttribute("data-colibrio-media-sources");this.D.setAttribute("playsinline","true");b=[];var d=[];if(c)try{var e=JSON.parse(c);for(c=0;c<e.length;c++){var f=e[c];if(f.type)switch(a.canPlayType(f.type)){case "probably":b.push(f);break;case "maybe":d.push(f)}else d.push(f)}0===b.length&&0===d.length&&(b=e)}catch(g){R(g)}0<b.length?wf(this.pb,this.D,b[0].src):0<d.length&&wf(this.pb,this.D,d[0].src)};function lg(a){this.pb=a}lg.prototype.aa=function(a){return new kg(a,this.pb)};lg.prototype.ba=function(a,b){return"audio"===b||"video"===b};lg.prototype.ca=function(){return!1};function mg(a){this.D=a}mg.prototype.Ta=function(){var a=this.D.getAttribute("data-colibrio-inline-overflow-x-changed");a?this.D.style.setProperty("overflow-x",a):this.D.style.removeProperty("overflow-x")};function ng(){}ng.prototype.aa=function(a){return new mg(a)};ng.prototype.ba=function(a){return a.hasAttribute("data-colibrio-overflow-x-changed")||a.hasAttribute("data-colibrio-inline-overflow-x-changed")};ng.prototype.ca=function(){return!1};function og(a){var b=this;this.v=a;this.s=!1;this.h=new Set;this.A=0;this.j=null;this.I=function(c){var d=Date.now();c.cancelable&&400>=d-b.A&&c.preventDefault();b.A=d};this.l=function(c){c.cancelable&&2<=c.touches.length&&c.preventDefault()};this.g=Va();this.g=document.createElement("div");this.g.style.position="absolute";this.g.style.zIndex=""+Number.MIN_SAFE_INTEGER;this.g.style.top="0";this.g.style.bottom="0";this.g.style.left="0";this.g.style.right="0";this.g.style.opacity="0"}\nfunction pg(a){a.s&&(a.s=!1,qg(a.v,"touchmove",a,!0),qg(a.v,"touchend",a,!0),a.j&&(a.j.disconnect(),a.j=null),a.h.forEach(function(b){return b.removeEventListener("touchmove",a.l)}),a.h.clear(),a.g&&a.g.parentNode&&a.g.parentNode.removeChild(a.g))}function rg(a){pg(a);a.s=!0;a.g&&document.body.appendChild(a.g);for(var b=document.body.childNodes,c=0;c<b.length;c++){var d=b[c];1===d.nodeType&&sg(a,d)}Q(a.v,"touchmove",a,!0);Q(a.v,"touchend",a,!0)}\nog.prototype.Ma=function(a){"touchmove"===a.type?this.l(a):"touchend"===a.type&&this.I(a)};\nfunction tg(a){rg(a);a.j=new MutationObserver(function(b){b=v(b);for(var c=b.next();!c.done;c=b.next())if(c=c.value,"childList"===c.type){for(var d=0;d<c.removedNodes.length;d++){var e=c.removedNodes[d];if(1===e.nodeType){var f=a;f.h.has(e)&&(f.h.delete(e),e.removeEventListener("touchmove",f.l,!0))}}for(d=0;d<c.addedNodes.length;d++)f=c.addedNodes[d],1===f.nodeType&&sg(a,f)}});a.j.observe(document.body,{childList:!0,subtree:!1})}\nfunction sg(a,b){a.h.has(b)||(a.h.add(b),b.addEventListener("touchmove",a.l,!0))};var ug=window;function vg(a,b,c,d,e){this.B=a;this.v=b;this.Ga=c;this.ha=d;this.C=e;this.Wa=null;this.lb=0;this.Pa=!1;this.ua=0;this.ob=null;(this.lc="ontouchstart"in ug)&&"iOS"===Oe().getOSName()&&tg(new og(b))}\nvg.prototype.Ma=function(a,b){switch(a.type){case "touchstart":0===this.ua&&(Q(this.v,"touchmove",this,!1),Q(this.v,"touchend",this,!1),Q(this.v,"touchcancel",this,!1));this.ua+=a.changedTouches.length;this.lb=Date.now();wg(this);xg(this,"pointerdown",a,B(a.target)?U(a.target):null,b);break;case "touchmove":if(0<this.ua){var c=this.Ga&&B(a.target)?U(a.target):null;xg(this,"pointermove",a,c,b)}this.lb=Date.now();break;case "touchend":case "touchcancel":"touchend"===a.type?xg(this,"pointerup",a,B(a.target)?\nU(a.target):null,b):xg(this,"pointercancel",a,null,b);this.ua=Math.max(0,this.ua-a.changedTouches.length);this.lb=Date.now();0===this.ua&&(qg(this.v,"touchmove",this,!1),qg(this.v,"touchend",this,!1),qg(this.v,"touchcancel",this,!1),this.ua=0,this.ob=null);break;case "mousedown":0===this.ua&&1E3<Date.now()-this.lb&&(this.ha||Q(this.v,"mousemove",this,!1),Q(this.v,"mouseup",this,!1),this.Pa=!0,this.Wa=a,yg(this,"pointerdown",a,B(a.target)?U(a.target):null,b));break;case "mousemove":this.Pa&&(this.Wa=\na);if(this.Pa||this.ha)c=this.Ga&&B(a.target)?U(a.target):null,yg(this,"pointermove",a,c,b);break;case "mouseup":this.Pa&&(yg(this,"pointerup",a,B(a.target)?U(a.target):null,b),zg(this));break;case "dragstart":wg(this)}};vg.prototype.da=function(){if(this.lc){Q(this.v,"touchstart",this,!1);var a=ug.document.documentElement;a.ontouchstart||(a.ontouchstart=function(){})}this.ha&&Q(this.v,"mousemove",this,!1);Q(this.v,"mousedown",this,!1);Q(this.v,"dragstart",this,!1)};\nfunction wg(a){a.Pa&&(a.Wa&&yg(a,"pointercancel",a.Wa,null,null),zg(a))}\nfunction yg(a,b,c,d,e){P(a.B,{engineEventDef:{button:c.button,buttons:c.buttons,clientX:c.clientX,clientY:c.clientY,containerPath:d?d.o:null,ctrlKey:c.ctrlKey,defaultPrevented:c.defaultPrevented,href:"",isPrimary:0===c.button,isTrusted:c.isTrusted,metaKey:c.metaKey,nodeData:e,nodeOffset:d?d.i:-1,pageX:c.pageX,pageY:c.pageY,pointerId:-1,pointerType:"mouse",processedByDocument:c._processed,screenX:c.screenX,screenY:c.screenY,windowInnerHeight:window.innerHeight,windowInnerWidth:window.innerWidth},engineEventType:b,\ntype:36})}\nfunction xg(a,b,c,d,e){d=d?Bc(d,a.C):null;for(var f=c.changedTouches,g=0;g<f.length;g++){var h=f.item(g);null===a.ob&&(a.ob=h.identifier);P(a.B,{engineEventDef:{button:0,buttons:1,clientX:h.clientX,clientY:h.clientY,containerPath:d?d.o:null,ctrlKey:c.ctrlKey,defaultPrevented:c.defaultPrevented,href:"",isPrimary:a.ob===h.identifier,isTrusted:c.isTrusted,metaKey:c.metaKey,nodeData:e,nodeOffset:d?d.i:-1,pageX:h.pageX,pageY:h.pageY,pointerId:h.identifier,pointerType:"touch",processedByDocument:c._processed,screenX:h.screenX,\nscreenY:h.screenY,windowInnerHeight:window.innerHeight,windowInnerWidth:window.innerWidth},engineEventType:b,type:36})}}function zg(a){a.ha||qg(a.v,"mousemove",a,!1);qg(a.v,"mouseup",a,!1);a.Pa=!1;a.Wa=null};function Ag(a,b,c,d,e,f){this.B=a;this.v=b;this.Ga=c;this.yb=d;this.ha=e;this.C=f;this.sa=new Map}\nAg.prototype.Ma=function(a,b){var c=a.defaultPrevented,d=1===a.buttons,e="mouse"===a.pointerType&&this.yb;switch(a.type){case "pointerdown":0===this.sa.size&&(this.ha||Q(this.v,"pointermove",this,!1),Q(this.v,"pointerup",this,!1),Q(this.v,"pointercancel",this,!1));var f=document.getSelection();if(e&&d||"mouse"!==a.pointerType)if(!f||f.isCollapsed)A(a.target)?a.target.setPointerCapture(a.pointerId):document.documentElement.setPointerCapture(a.pointerId);this.sa.set(a.pointerId,a);a.cancelable&&2<=\nthis.sa.size&&a.preventDefault();Bg(this,a.type,a,B(a.target)?U(a.target):null,b,c);break;case "pointermove":a.cancelable&&2<=this.sa.size&&a.preventDefault();d=this.ha;this.sa.has(a.pointerId)&&(this.sa.set(a.pointerId,a),d=!0);d&&(d=this.Ga&&B(a.target)?U(a.target):null,Bg(this,a.type,a,d,b,c));break;case "pointerup":case "pointercancel":a.cancelable&&2<=this.sa.size&&a.preventDefault();try{if(e||"mouse"!==a.pointerType)A(a.target)?a.target.releasePointerCapture(a.pointerId):document.documentElement.releasePointerCapture(a.pointerId)}catch(g){}this.sa.delete(a.pointerId)&&\nBg(this,a.type,a,"pointerup"===a.type&&B(a.target)?U(a.target):null,b,c);0===this.sa.size&&(this.ha||qg(this.v,"pointermove",this,!1),qg(this.v,"pointerup",this,!1),qg(this.v,"pointercancel",this,!1))}};Ag.prototype.da=function(){Q(this.v,"pointerdown",this,!1);this.ha&&Q(this.v,"pointermove",this,!1)};\nfunction Bg(a,b,c,d,e,f){d=d?Bc(d,a.C):null;P(a.B,{engineEventDef:{button:c.button,buttons:c.buttons,clientX:c.clientX,clientY:c.clientY,containerPath:d?d.o:null,ctrlKey:c.ctrlKey,defaultPrevented:f,href:"",isPrimary:c.isPrimary,isTrusted:c.isTrusted,metaKey:c.metaKey,nodeData:e,nodeOffset:d?d.i:-1,pageX:c.pageX,pageY:c.pageY,pointerId:c.pointerId,pointerType:c.pointerType,processedByDocument:c._processed,screenX:c.screenX,screenY:c.screenY,windowInnerHeight:window.innerHeight,windowInnerWidth:window.innerWidth},\nengineEventType:b,type:36})};function Cg(a,b,c,d,e,f,g){this.B=a;this.v=b;this.Ga=c;this.g=d;this.yb=e;this.ha=f;this.C=g}Cg.prototype.aa=function(){return!this.g&&"onpointerdown"in window?new Ag(this.B,this.v,this.Ga,this.yb,this.ha,this.C):new vg(this.B,this.v,this.Ga,this.ha,this.C)};Cg.prototype.ba=function(a,b,c){return a===c.documentElement};Cg.prototype.ca=function(){return!0};function Dg(a,b,c,d){this.g=Z;this.B=a;this.oa=b;this.v=c;this.C=d;this.j=0;Q(this.v,"selectionchange",this,!0);Q(this.v,"selectstart",this,!0);this.h=b.g.get("contentSelectionEnabled");this.oa.h.push(this)}\nDg.prototype.Ma=function(a){if("selectstart"===a.type)a.cancelable&&!this.h&&a.preventDefault();else if("selectionchange"===a.type)if(this.j)this.j--;else{a=this.g.getSelection();if(a&&0<a.rangeCount){var b=a.getRangeAt(0);a=-1<a.toString().indexOf(" ")?a.toString():a.getRangeAt(0).toString();var c=Za(K(this.g),b.startContainer),d=null;b.collapsed||(d=Za(K(this.g),b.endContainer));c=c?Bc({o:c,i:b.startOffset},this.C):{o:null,i:-1};b=d?Bc({o:d,i:b.endOffset},this.C):{o:null,i:-1};b={endContainerPath:b.o,\nendOffset:b.i,selectionText:a,startContainerPath:c.o,startOffset:c.i,type:38}}b||(b={endContainerPath:null,endOffset:-1,selectionText:null,startContainerPath:null,startOffset:-1,type:38});P(this.B,b)}};Dg.prototype.onReaderViewPropertyChanged=function(a,b){"contentSelectionEnabled"===a?(this.h=b)||this.clearContentSelection():"clearContentSelection"===a&&this.clearContentSelection()};Dg.prototype.clearContentSelection=function(){var a=this.g.getSelection();a&&0<a.rangeCount&&(this.j++,a.removeAllRanges())};function Eg(a,b){this.D=a;this.oa=b;Fg(this,b.g.get("hasActiveTransform"));this.oa.h.push(this)}Eg.prototype.onReaderViewPropertyChanged=function(a,b){"hasActiveTransform"===a&&Fg(this,b)};function Fg(a,b){a=a.D.classList;b?a.add("colibrio-readerview--transform-manager-active"):a.remove("colibrio-readerview--transform-manager-active")};function Gg(a){this.oa=a}Gg.prototype.aa=function(a){return new Eg(a,this.oa)};Gg.prototype.ba=function(a,b,c){return a===c.documentElement};Gg.prototype.ca=function(){return!0};function Hg(a){var b=this;this.h=new Map;this.T=new Map;this.X=!0;this.g=new WeakMap;this.Y=new Map;this.O=new Map;this.j=!0;this.I=new Map;this.xc=function(e){b.j=!1;Ig(b,e,!1);var f="on"+e.type;if(I(window[f])){try{!1===window[f](e)&&e.preventDefault()}catch(g){S(g)}e.stopImmediatePropagation()}Jg(e,!0,b.h);b.j=!0};this.yc=function(e){b.j=!1;Jg(e,!0,b.T);if(b.gb.has(e.type)||!b.X)"click"===e.type&&e.preventDefault(),e.stopImmediatePropagation();else{if(B(e.target)&&e.target.parentNode){for(var f=\n"on"+e.type,g=e.target,h=!1;g&&!h;)h=A(g)&&(!!g[f]||!!g.getAttribute(f)),g=g.parentNode;h&&(f=b.g.get(e),f||(f={_immediatePropagationStopped:!1,_processed:!0,_propagationStopped:!1},b.g.set(e,f)))}1===e.eventPhase&&Ig(b,e,!0)}e._propagationStopped&&Jg(e,!0,b.h);b.j=!0};var c=Oe().getOSName();"iOS"!==c&&"macOS"!==c||document.documentElement.addEventListener("click",function(){},!1);this.X=a.g.get("contentDocumentEventHandlersEnabled");a.h.push(this);this.gb=new Set([]);this.Z=Window.prototype.addEventListener;\nthis.l=Element.prototype.addEventListener;this.ma=Document.prototype.addEventListener;this.hb=Window.prototype.removeEventListener;this.Ua=Element.prototype.removeEventListener;this.ra=Document.prototype.removeEventListener;a=Kg(this);c=Lg(this);"undefined"!==typeof EventTarget&&EventTarget.prototype&&EventTarget.prototype.addEventListener?(this.s=EventTarget.prototype.addEventListener,this.A=EventTarget.prototype.removeEventListener,EventTarget.prototype.addEventListener=a,EventTarget.prototype.removeEventListener=\nc):this.A=this.s=null;Window.prototype.addEventListener=a;Element.prototype.addEventListener=a;Document.prototype.addEventListener=a;Window.prototype.removeEventListener=c;Element.prototype.removeEventListener=c;Document.prototype.removeEventListener=c;new Fe(Event.prototype,{ia:[{V:function(e){return(e=b.g.get(e))?e._propagationStopped:!1},kb:!0,N:"_propagationStopped"},{V:function(e){return(e=b.g.get(e))?e._immediatePropagationStopped:!1},kb:!0,N:"_immediatePropagationStopped"},{V:function(e){return(e=\nb.g.get(e))?e._processed:!1},kb:!0,N:"_processed"}],ja:[{L:function(e,f){f.call(e);f=!1;var g=b.g.get(e);g?(f=g._propagationStopped,g._propagationStopped=!0):(g={_immediatePropagationStopped:!1,_processed:!1,_propagationStopped:!0},b.g.set(e,g));!f&&b.j&&Jg(e,!1,b.h)},J:"stopPropagation"},{L:function(e,f){f.call(e);f=!1;var g=b.g.get(e);g?(f=g._propagationStopped,g._propagationStopped=!0,g._immediatePropagationStopped=!0):(g={_immediatePropagationStopped:!0,_processed:!1,_propagationStopped:!0},b.g.set(e,\ng));!f&&b.j&&Jg(e,!1,b.h)},J:"stopImmediatePropagation"}]});a="auxclick blur click copy cut compositionstart compositionupdate compositionend contextmenu dblclick drag dragend dragstart dragleave dragover drop focus gotpointercapture keydown keypress keyup lostpointercapture mousedown mouseenter mouseleave mousemove mouseover mouseout mouseup paste pointercancel pointerdown pointerenter pointerleave pointermove pointerout pointerover pointerup scroll select selectionchange selectstart touchcancel touchend touchmove touchstart wheel".split(" ");\nthis.fa=new Set(a);for(c=0;c<a.length;c++){var d=a[c];this.Z.call(window,d,this.yc,!0);this.Z.call(window,d,this.xc,!1)}}function Q(a,b,c,d){if(!a.fa.has(b))throw Error("Unsupported colibrio event type: "+b);a=d?a.T:a.h;d=a.get(b);d||(d=new qb,a.set(b,d));d.find(function(e){return e.U===c})||d.push(c)}Hg.prototype.onReaderViewPropertyChanged=function(a,b){"contentDocumentEventHandlersEnabled"===a&&(this.X=b)};\nfunction qg(a,b,c,d){(a=(d?a.T:a.h).get(b))&&(b=a.find(function(e){return e.U===c}))&&ub(a,b)}function Ig(a,b,c){if(a=a.I.get(b.type))for(var d=a.j?a.g.K:null;d&&!b._immediatePropagationStopped;){var e=sb(a,d);if(c?d.U.na:!d.U.na||2===b.eventPhase){var f=d.U.zb;d.U.Hc&&ub(a,d);try{I(f)?f(b):Ra(f)&&I(f.handleEvent)&&f.handleEvent(b)}catch(g){S(g)}}d=sb(a,d)||e}}\nfunction Kg(a){return function(b,c,d){if((I(c)||Ra(c))&&b)if(b=String(b),a.fa.has(b)){var e=!1,f=!1,g=!1;Ra(d)?(e=!!d.capture,f=!!d.once,g=!!d.passive):e=d=!!d;if(this===window)d=a.I.get(b),d||(d=new qb,a.I.set(b,d)),d.find(function(k){return k.U.zb===c&&k.U.na===e})||d.push({na:e,zb:c,Hc:f});else{g&&(d={capture:e,once:f,passive:!1});g=a.O.get(b);g||(g=new WeakMap,a.O.set(b,g));var h=g.get(this);h||(h={Oa:null,na:null},g.set(this,h));e?(h.na||(h.na=new Map),g=h.na):(h.Oa||(h.Oa=new Map),g=h.Oa);g.has(c)||\n(f=Mg(a,b,c,f?d:null),g.set(c,f),g=a.Y.get(b),a.Y.set(b,C(g)?g+1:1),a.s?a.s.call(this,b,f,d):this===document?a.ma.call(this,b,f,d):a.l.call(this,b,f,d))}}else a.s?a.s.call(this,b,c,d):this===document?a.ma.call(this,b,c,d):this===window?a.Z.call(this,b,c,d):a.l.call(this,b,c,d)}}\nfunction Mg(a,b,c,d){return function(e){var f=a.g.get(e);f?f._processed=!0:(f={_immediatePropagationStopped:!1,_processed:!0,_propagationStopped:!1},a.g.set(e,f));d&&this.removeEventListener(b,c,d);I(c)?c.call(this,e):I(c.handleEvent)&&c.handleEvent(e)}}\nfunction Lg(a){return function(b,c,d){if((I(c)||Ra(c))&&b)if(b=String(b),a.fa.has(b)){var e=!!d&&("boolean"===typeof d||!!d.capture);if(this===window){if(d=a.I.get(b)){var f=d.find(function(l){return l.U.zb===c||l.U.na===e});f&&(ub(d,f),0===d.size()&&a.I.delete(b))}}else if(f=a.O.get(b)){var g=f.get(this);if(g){var h=null;if(h=e?g.na:g.Oa){var k=h.get(c);k&&(h.delete(c),h=a.Y.get(b),C(h)||(S(new O("Event listener counter was NaN: "+b)),h=1),h--,0===h&&a.O.delete(b),a.A?a.A.call(this,b,k,d):this===\ndocument?a.ra.call(this,b,k,d):a.Ua.call(this,b,k,d))}g.na&&0!==g.na.size||g.Oa&&0!==g.Oa.size||f.delete(this)}}}else a.A?a.A.call(this,b,c,d):this===document?a.ra.call(this,b,c,d):this===window?a.hb.call(this,b,c,d):a.Ua.call(this,b,c,d)}}function Ng(a,b,c){a.find(function(d){d.U.Ma(b,c);return b._immediatePropagationStopped})}\nfunction Jg(a,b,c){var d=c.get(a.type);if(d&&0<d.size()){c=a.target;var e=A(c)?Yb(c):null;b?Ng(d,a,e):Promise.resolve().then(function(){return Ng(d,a,e)}).catch(function(f){return R(f)})}};function Og(a){var b=Z,c=this;this.B=a;this.l=b;this.j=!1;this.g=null;this.h=b.documentElement.getBoundingClientRect().height;this.A=new MutationObserver(function(){Pg(c)});this.A.observe(b,{attributes:!0,characterData:!0,childList:!0,subtree:!0});this.s=new MutationObserver(function(d){if(!c.j){d=v(d);for(var e=d.next();!e.done;e=d.next())if(e=e.value,0<e.addedNodes.length||0<e.removedNodes.length)c.j=!0,P(c.B,{type:1})}});this.s.observe(K(b),{characterData:!0,childList:!0,subtree:!0})}\nfunction Pg(a){null!==a.g&&window.clearTimeout(a.g);a.g=window.setTimeout(function(){a.g=null;var b=a.l.documentElement.getBoundingClientRect().height;b!==a.h&&(a.h=b,P(a.B,{height:b,type:5}))},200)};function Qg(){this.h=[];this.g=new Map;this.g.set("contentDocumentEventHandlersEnabled",!0);this.g.set("contentSelectionEnabled",!0);this.g.set("clearContentSelection",null);this.g.set("hasActiveTransform",!1)}function Rg(a,b){a.g.set(b.key,b.value);for(var c=0;c<a.h.length;c++)try{a.h[c].onReaderViewPropertyChanged(b.key,b.value)}catch(d){R(d)}};function Sg(a,b,c){this.g=a;this.s=b;this.j=c;this.l=null;this.h=0;b=Object.keys(a);for(c=0;c<b.length;c++){var d=b[c];this.h+=d.length+a[d].length}}function Tg(a){a.l||(a.l=Ug(a));return a.l}function Vg(a,b,c){var d=null,e=!0;b?(Ta(a.g,b)&&(d=a.g[b]),null===c&&null!==d?delete a.g[b]:null!==c&&c!==d?a.g[b]=c:e=!1,Wg(a,b,c,d,!1)):0<Object.keys(a.g).length?(a.g={},a.h=0):e=!1;e&&Xg(a,b,c,d)}\nfunction Wg(a,b,c,d,e){if(null!==c){if(e&&a.h+c.length>a.s)throw Error("Quota exceeded. LocalStorage size limit is "+a.s);a.h+=c.length}else a.h-=b.length;a.h=null!==d?a.h-d.length:a.h+b.length}\nfunction Ug(a){function b(){}b.prototype=Object.create(null);b.prototype.constructor=b;Object.defineProperty(b.prototype,"length",{get:function(){return Object.keys(a.g).length}});var c=b.prototype;c.key=function(d){var e=Object.keys(a.g);return 0>d||d>=e.length?null:e[d]};c.clear=function(){a.g={};a.h=0;a.j(null,null);Xg(a,null,null,null)};c.getItem=function(d){d=String(d);return Ta(a.g,d)?a.g[d]:null};c.setItem=function(d,e){d=String(d);e=String(e);var f=Ta(a.g,d)?a.g[d]:null;Wg(a,d,e,f,!0);a.g[d]=\ne;a.j(d,e);Xg(a,d,e,f)};c.removeItem=function(d){d=String(d);if(Ta(a.g,d)){var e=a.g[d];Wg(a,d,e,null,!1);a.j(d,null);Xg(a,d,null,e);delete a.g[d]}};c=new b;"undefined"!==typeof Proxy&&(c=new Proxy(c,{deleteProperty:function(d,e){d.removeItem(e);return!0},get:function(d,e){e=String(e);return e in d?d[e]:d.getItem(e)},set:function(d,e,f){d.setItem(e,f);return!0}}));return c}\nfunction Xg(a,b,c,d){try{var e=document.createEvent("Event");e.initEvent("storage",!1,!1);e.key=b;e.oldValue=d;e.newValue=c;e.storageArea=Tg(a);e.url=location.href;window.dispatchEvent(e)}catch(f){S(f)}};function Yg(a,b,c){this.A=[];this.l=!1;this.g=null;this.s=a||"-epub-media-overlay-active";this.j=b||"-epub-media-overlay-playing";this.j=b||"-epub-media-overlay-playing";this.h=c||null}\nfunction Zg(a,b){var c=null;b.elemId&&(c=document.getElementById(b.elemId));a.g&&a.g!==c&&a.g.classList.remove(a.s);c&&c.classList.add(a.s);a.g=c;if(a.h){b=[];if(c&&c.parentNode){b=document.documentElement;var d=[];for(c=c.parentNode;c&&c!==b;)d.push(c),c=c.parentNode;c&&d.push(b);b=d.reverse()}c=a.A;for(d=0;d<b.length;d++){var e=b[d];if(A(e)){var f=c.indexOf(e);-1===f?e.classList.add(a.h):c.splice(f,1)}}for(d=0;d<c.length;d++)e=c[d],A(e)&&e.classList.remove(a.h);a.A=b}}\nfunction $g(a,b){var c=document.documentElement;b=b.playing;a.l&&!b?c.classList.remove(a.j):!a.l&&b&&c.classList.add(a.j);a.l=b};function ah(a){return a.replace(/\\s/g,function(b){return"\\\\"+b.charCodeAt(0).toString(16)})}function bh(a,b){for(var c=0;c<a.length;c++)ch(a[c],b)}\nfunction ch(a,b){if(60>a.u){var c=a.u;if(9>c)if(c=ah(a.G),0===a.u){a=!1;for(var d=0;d<c.length;d++){var e=c.charCodeAt(d);if(33<=e&&126>=e&&!(48<=e&&57>=e||97<=e&&122>=e||65<=e&&90>=e)){a=!0;break}}a=a?c.replace(/[!"#$%&()*+,./:;<=>?@\\[\\]^{}|~\'\\\\`]/g,"\\\\$&"):c;c=a.charCodeAt(0);b.push(48<=c&&57>=c?"\\\\3"+a[0]+" "+a.slice(1):a)}else 2===a.u?b.push("@",c):3===a.u?b.push("#",c):4===a.u?b.push(\'"\',-1===c.indexOf(\'"\')?c:c.replace(/"/g,\'\\\\"\'),\'"\'):5===a.u&&b.push(\'url("\',-1===c.indexOf(\'"\')?c:c.replace(/"/g,\n\'\\\\"\'),\'")\');else 29>c?b.push(a.G):49>c?(b.push(a.G),40!==c&&b.push(a.sb)):b.push("u+",a.Lc.toString(16),"-",a.Ac.toString(16))}else 69>=a.u?(c=a.u,60===c?(b.push("{"),c="}"):61===c?(b.push("("),c=")"):(b.push("["),c="]"),bh(a.G,b),b.push(c)):(b.push(a.N,"("),a.N.startsWith("nth-")?dh(a.G,b):bh(a.G,b),b.push(")"))}function dh(a,b){var c=a.filter(function(d){return 10!==d.u});2===c.length&&Vc(c[0])&&Vc(c[1])?(ch(c[0],b),1===Math.sign(c[1].G)&&b.push("+"),ch(c[1],b)):bh(a,b)};function eh(a,b){"undefined"!==typeof CSSStyleDeclaration&&CSSStyleDeclaration.prototype&&new Fe(CSSStyleDeclaration.prototype,{ia:[{V:function(c){return c.getPropertyValue("background-image")},kb:!0,N:"backgroundImage",xa:function(c,d,e){c.setProperty("background-image",e);var f;E(e)&&(d=(new Xc(e)).next())&&5===d.u&&(f=d);if(f)try{var g=new URL(f.G,a.baseUrl);if("http:"!==g.protocol&&"https:"!==g.protocol||a.resourceProviderBaseUrl&&g.toString().startsWith(a.resourceProviderBaseUrl)){var h=Qe(f.G);\ne=c.getPropertyValue("background-image");b.g(h).then(function(k){e===c.getPropertyValue("background-image")&&(f.G=Re(k),k=[],ch(f,k),c.setProperty("background-image",k.join("")))}).catch(function(k){S(k)})}}catch(k){S("Invalid backgroundImage URL: "+f.G)}}}],ja:[]})};var fh=XMLHttpRequest;\nfunction gh(a,b){function c(){this.H=new fh;this.jb=new Map;this.Qa=d++;this.Ra=this.Kb="";this.P=!1;this.Lb="";this.qa=null;this.Ia=!1;this.Ib=this.Hb=this.Gb=this.Fb=this.Eb=this.Db=this.Cb=this.Bb=null;this.M=0;this.S=null;this.va="";this.Fa=0;this.Ja=""}var d=1;c.prototype.abort=function(){this.P?this.H.abort():(this.Ia&&4!==this.M&&this.handleError("aborted"),4===this.M&&(this.Fa=this.M=0,this.Ja="",this.S=null),this.Qa=d++)};c.prototype.addEventListener=function(e,f,g){var h={Va:null,Jb:f};\nI(f)&&(h.Va=f.bind(this));var k=this.jb.get(e);k||(k=[],this.jb.set(e,k));k.push(h);this.H.addEventListener(e,h.Va||f,g)};c.prototype.dispatchEvent=function(e){if(this.P)return this.H.dispatchEvent(e);var f=null;switch(e.type){case "abort":f=this.Bb;break;case "error":f=this.Cb;break;case "load":f=this.Db;break;case "loadstart":f=this.Fb;break;case "loadend":f=this.Eb;break;case "progress":f=this.Gb;break;case "readystatechange":f=this.Hb;break;case "timeout":f=this.Ib}f&&f.call(this,e);if(f=this.jb.get(e.type))for(var g=\n0;g<f.length;g++){var h=f[g];h.Va?h.Va(e):(h=h.Jb,I(h)?h(e):h.handleEvent&&h.handleEvent(e))}return!1};c.prototype.getAllResponseHeaders=function(){return this.P?this.H.getAllResponseHeaders():this.qa?"content-length: "+this.qa.size+"\\r\\ncontent-type: "+this.qa.mediaType+"\\r\\n":""};c.prototype.getResponseHeader=function(e){var f=null;if(this.P)f=this.H.getResponseHeader(e);else if(this.qa)switch(e.toLowerCase()){case "content-length":f=""+this.qa.size;break;case "content-type":f=this.qa.mediaType}return f};\nc.prototype.open=function(e,f,g,h,k){var l=new URL(f,a.baseUrl);if(a.resourceProviderBaseUrl&&l.toString().startsWith(a.resourceProviderBaseUrl)||"http:"!==l.protocol&&"https:"!==l.protocol){if(!1===g)throw new DOMException("XMLHttpRequest.open(): Sync requests for intra-publication request not supported","InvalidAccessError");switch(e.toUpperCase()){case "GET":break;case "DELETE":case "HEAD":case "OPTIONS":case "POST":case "PUT":throw new DOMException("XMLHttpRequest.open(): Forbidden method for intra-publication request: "+\ne,"SecurityError");default:throw new DOMException("XMLHttpRequest.open(): Invalid method: "+e,"SyntaxError");}this.P&&this.H.abort();this.P=!1;this.Lb=l.hash||l.search?l.href.slice(0,-(l.hash.length+l.search.length)):l.href;this.Ra=f}else{if(!a.allowRemoteResources)throw new DOMException("XMLHttpRequest.open(): Remote resources not allowed. See IEpubReaderPublicationOptions.remoteResourcesScriptedDocumentsOptions");Pa(g)&&Pa(h)&&Pa(k)?this.H.open(e,f):this.H.open(e,f,Pa(g)?!0:g,h,k);this.P||this.abort();\nthis.P=!0;this.M=0;this.Ra=this.Lb=""}this.Qa=d++;this.qa=this.S=null;this.Ia=!1;this.Fa=0;this.Ja="";this.P||1===this.M||(this.M=1,this.ab())};c.prototype.overrideMimeType=function(e){this.H.overrideMimeType(e);if(!this.P&&(3===this.M||4===this.M))throw new DOMException("XMLHttpRequest.overrideMimeType: readyState is already LOADING or DONE","InvalidStateError");this.Kb=e};c.prototype.removeEventListener=function(e,f,g){var h=null,k=this.jb.get(e);if(k){var l=k.findIndex(function(m){return m.Jb===\nf});-1!==l&&(h=k[l].Va||k[l].Jb,k.splice(l,1))}this.H.removeEventListener(e,h||f,g)};c.prototype.send=function(e){var f=this;if(this.P)this.H.send(e);else{if(this.Ia||1!==this.M)throw new DOMException("XMLHttpRequest.send: readyState is not OPENED or the request has already been sent.","InvalidStateError");this.Ia=!0;this.Ka("loadstart",0,0);var g=this.Qa;this.Rc().then(function(h){if(f.Qa===g&&1===f.M&&(f.qa=h,f.M=2,f.ab(),2===f.M)){var k=f.Kb||h.mediaType;switch(f.va){case "arraybuffer":k={mediaCategoryOrType:k,\nsrc:f.Ra,type:11};break;case "blob":k={mediaCategoryOrType:k,src:f.Ra,type:13};break;default:k={mediaCategoryOrType:k,src:f.Ra,type:26}}f.Fa=200;f.M=3;f.ab();if(3===f.M){var l=h.size;f.Ka("progress",0,l);if(3===f.M)return b.g(k,void 0,f.H.timeout).then(function(m){if(f.Qa===g&&3===f.M){switch(m.type){case 12:f.S=m.buffer;break;case 14:f.S=m.blob;break;case 27:f.S=m.data}f.Ka("progress",l,l);3===f.M&&(f.M=4,f.Ia=!1,f.ab(),f.Ka("load",l,l),f.Ka("loadend",l,l))}})}}}).catch(function(h){g===f.Qa&&(h&&\n"RESOURCE_NOT_FOUND"===h.errorType?f.handleError("notFound"):f.handleError(h))})}};c.prototype.setRequestHeader=function(e,f){if(this.P)this.H.setRequestHeader(e,f);else if(1!==this.M||this.Ia)throw new DOMException("XMLHttpRequest.setRequestHeader: readyState is not OPENED or the request has already been sent.","InvalidStateError");};c.prototype.Ka=function(e,f,g){e=new hh(this,e,f,g);try{this.dispatchEvent(e)}catch(h){R(h)}};c.prototype.ab=function(){var e=new hh(this,"readystatechange",0,0);try{this.dispatchEvent(e)}catch(f){R(f)}};\nc.prototype.Rc=function(){return b.g({mediaCategoryOrType:this.Kb,src:this.Ra,type:24})};c.prototype.handleError=function(e){this.Ia=!1;this.M=4;this.S=null;e instanceof zb?"TIMEOUT"===e.errorType?(this.Fa=0,this.Ja="Timeout",e="timeout"):(this.Fa=500,this.Ja=e.message,e="error"):"aborted"===e?(this.Fa=0,this.Ja="Aborted",e="abort"):(this.Fa=404,this.Ja="Not Found",e="error");this.ab();this.Ka(e,0,0);this.Ka("loadend",0,0)};ea.Object.defineProperties(c.prototype,{DONE:{configurable:!0,enumerable:!0,\nget:function(){return 4}},HEADERS_RECEIVED:{configurable:!0,enumerable:!0,get:function(){return 2}},LOADING:{configurable:!0,enumerable:!0,get:function(){return 3}},OPENED:{configurable:!0,enumerable:!0,get:function(){return 1}},UNSENT:{configurable:!0,enumerable:!0,get:function(){return 0}},onabort:{configurable:!0,enumerable:!0,get:function(){return this.Bb},set:function(e){this.Bb=e;this.H.onabort=e?e.bind(this):null}},onerror:{configurable:!0,enumerable:!0,get:function(){return this.Cb},set:function(e){this.Cb=\ne;this.H.onerror=e?e.bind(this):null}},onload:{configurable:!0,enumerable:!0,get:function(){return this.Db},set:function(e){this.Db=e;this.H.onload=e?e.bind(this):null}},onloadend:{configurable:!0,enumerable:!0,get:function(){return this.Eb},set:function(e){this.Eb=e;this.H.onloadend=e?e.bind(this):null}},onloadstart:{configurable:!0,enumerable:!0,get:function(){return this.Fb},set:function(e){this.Fb=e;this.H.onloadstart=e?e.bind(this):null}},onprogress:{configurable:!0,enumerable:!0,get:function(){return this.Gb},\nset:function(e){this.Gb=e;this.H.onprogress=e?e.bind(this):null}},onreadystatechange:{configurable:!0,enumerable:!0,get:function(){return this.Hb},set:function(e){this.Hb=e;this.H.onreadystatechange=e?e.bind(this):null}},ontimeout:{configurable:!0,enumerable:!0,get:function(){return this.Ib},set:function(e){this.Ib=e;this.H.ontimeout=e?e.bind(this):null}},readyState:{configurable:!0,enumerable:!0,get:function(){return this.P?this.H.readyState:this.M}},response:{configurable:!0,enumerable:!0,get:function(){if(this.P)return this.H.response;\nif(E(this.S))if("document"===this.va)var e=this.responseXML;else if("json"===this.va)try{e=JSON.parse(this.S)}catch(f){R(f),e=null}else e=this.S;else e=this.S;return e}},responseType:{configurable:!0,enumerable:!0,get:function(){return this.va},set:function(e){switch(this.readyState){case 3:case 4:throw new DOMException("XMLHttpRequest.responseType: Cannot set responseType when readyState is LOADING or DONE","InvalidStateError");}this.va=this.H.responseType=e}},status:{configurable:!0,enumerable:!0,\nget:function(){return this.P?this.H.status:this.Fa}},statusText:{configurable:!0,enumerable:!0,get:function(){return this.P?this.H.statusText:this.Ja}},responseText:{configurable:!0,enumerable:!0,get:function(){if(this.P)return this.H.responseText;if(null===this.S)return"";if(""!==this.va&&"text"!==this.va&&!E(this.S))throw new DOMException(\'XMLHttpRequest.responseText: responseType is not "" or "text"\',"InvalidStateError");return this.S}},responseURL:{configurable:!0,enumerable:!0,get:function(){return this.P?\nthis.H.responseURL:this.Lb}},responseXML:{configurable:!0,enumerable:!0,get:function(){if(this.P)return this.H.responseXML;if(null===this.S||!this.qa)return null;if(""!==this.va&&"document"!==this.va||!E(this.S))throw new DOMException(\'XMLHttpRequest.responseXML: responseType is not "" or "document"\',"InvalidStateError");var e=new DOMParser,f=this.qa.mediaType;return"text/html"===f||"application/html"===f?e.parseFromString(this.S,"text/html"):"application/xhtml+xml"===f?e.parseFromString(this.S,f):\ne.parseFromString(this.S,"application/xml")}},timeout:{configurable:!0,enumerable:!0,get:function(){return this.H.timeout},set:function(e){this.H.timeout=e}},upload:{configurable:!0,enumerable:!0,get:function(){return this.H.upload}},withCredentials:{configurable:!0,enumerable:!0,get:function(){return this.H.withCredentials},set:function(e){this.H.withCredentials=e}}});c.DONE=4;c.HEADERS_RECEIVED=2;c.LOADING=3;c.OPENED=1;c.UNSENT=0;return Object.freeze(c)}\nfunction hh(a,b,c,d){this.Ob=a;this.u=b;this.Ec=c;this.Oc=d;this.cancelBubble=this._immediatePropagationStopped=!1;this.Gc=Date.now()}q=hh.prototype;q.composedPath=function(){return[]};q.deepPath=function(){return[this.Ob]};q.initEvent=function(){};q.preventDefault=function(){};q.stopImmediatePropagation=function(){this._immediatePropagationStopped=!0};q.stopPropagation=function(){};\nea.Object.defineProperties(hh.prototype,{AT_TARGET:{configurable:!0,enumerable:!0,get:function(){return 2}},BUBBLING_PHASE:{configurable:!0,enumerable:!0,get:function(){return 3}},CAPTURING_PHASE:{configurable:!0,enumerable:!0,get:function(){return 1}},NONE:{configurable:!0,enumerable:!0,get:function(){return 0}},bubbles:{configurable:!0,enumerable:!0,get:function(){return!1}},cancelable:{configurable:!0,enumerable:!0,get:function(){return!1}},composed:{configurable:!0,enumerable:!0,get:function(){return!1}},\ncurrentTarget:{configurable:!0,enumerable:!0,get:function(){return this.Ob}},defaultPrevented:{configurable:!0,enumerable:!0,get:function(){return!1}},eventPhase:{configurable:!0,enumerable:!0,get:function(){return this.AT_TARGET}},isTrusted:{configurable:!0,enumerable:!0,get:function(){return!1}},lengthComputable:{configurable:!0,enumerable:!0,get:function(){return 0!==this.total}},loaded:{configurable:!0,enumerable:!0,get:function(){return this.Ec}},returnValue:{configurable:!0,enumerable:!0,get:function(){return!0}},\nsrcElement:{configurable:!0,enumerable:!0,get:function(){return null}},target:{configurable:!0,enumerable:!0,get:function(){return this.Ob}},timeStamp:{configurable:!0,enumerable:!0,get:function(){return this.Gc}},total:{configurable:!0,enumerable:!0,get:function(){return this.Oc}},type:{configurable:!0,enumerable:!0,get:function(){return this.u}}});var Z=document;function ih(){this.l=this.g=this.j=null;this.I=!1;this.X=null;this.ra=!1;this.Y=this.Ua=this.v=this.C=null;this.gb="uninitialized";this.h=this.A=this.O=this.s=null;this.Z=[];this.hb=!1;this.fa=this.T=null;this.oa=new Qg;this.ma=!1}function jh(a,b){var c=Object.getOwnPropertyDescriptor(window,"XMLHttpRequest");c&&c.configurable?Object.defineProperty(window,"XMLHttpRequest",{value:gh(a,b)}):S("XMLHttpRequest is not configurable")}\nfunction kh(a,b){var c,d,e,f,g,h,k;return Ca(function(l){c=a.findShallowestContentLocation;d=a.chooseLocationAfterElement;var m=a.y,n=Z,p=K(Z);if(d){var r=n.createRange(),t=new hc(p,Fd);W(t,Hd);n=null;for(var w=0,y=null;t.g;){var T=!0,J=t.g;if(A(J)){if("colibrio-ios-nativezoom-preventer"!==J.id){var z=J.getBoundingClientRect();if(0<z.width&&0<z.height&&(T=!1,z.top<m)){n=y;break}}}else if(Oa(J)&&(r.selectNodeContents(J),z=r.getBoundingClientRect(),0<z.width&&0<z.height&&(T=!1,z.top<m))){z.bottom-1<=\nm?n=y:(m=Gd(m,r,J),m>=J.data.length?n=y:(n=J,w=m));break}T||(y=J);W(t,Hd)}p=null===n?null===y?{m:p,i:p.childNodes.length}:y.parentNode?F(y)?{m:y,i:0}:{m:y.parentNode,i:Xa(y)}:{m:p,i:p.childNodes.length}:F(n)?{m:n,i:w}:n.parentNode?{m:n.parentNode,i:Xa(n)}:{m:p,i:p.childNodes.length}}else{t=n.createRange();n=new gc(p,Fd);W(n,Hd);w=null;y=0;for(J=null;n.g;){T=!0;r=n.g;if(A(r)){if("colibrio-ios-nativezoom-preventer"!==r.id&&(z=r.getBoundingClientRect(),0<z.top||0<z.width&&0<z.height)&&(T=!1,z.bottom>\nm)){w=r;break}}else if(Oa(r)&&(t.selectNodeContents(r),z=eb(t.getBoundingClientRect()),0<z.width&&0<z.height&&(T=eb(r.parentNode.getBoundingClientRect()),z.top<T.top&&(z=new DOMRect(z.x,T.y,z.width,z.height-(T.y-z.y))),T=!1,z.bottom>m))){z.top+1>=m?w=r:(m=Gd(m,t,r),m>=r.data.length?(W(n,Hd),w=n.g):(w=r,y=m));break}T||(J=r);W(n,Hd)}p=null===w?null===J?{m:p,i:0}:{m:p,i:p.childNodes.length}:F(w)?{m:w,i:y}:w.parentNode?{m:w.parentNode,i:Xa(w)}:{m:p,i:p.childNodes.length}}e=p;f=K(Z);if(c&&D(f)){p=f;m=\ne;var M;F(m.m)?M=m.m.data.length:M=m.m.childNodes.length;if(!d){var ma;0>=m.i&&F(m.m)?ma=m.m:A(m.m)&&(ma=0<M?m.m.childNodes[H(m.i,0,M-1)]:m.m);ma&&(m=(M=uc(ma,p,vc))?{m:M.parentNode,i:Xa(M)}:{m:p,i:0})}else if(d){var G;m.i>=M&&F(m.m)?G=m.m:A(m.m)&&(G=0<M?m.m.childNodes[H(m.i,0,M-1)]:m.m);G&&(m=(M=uc(G,p,xc))?{m:M.parentNode,i:Xa(M)}:{m:p,i:p.childNodes.length})}e=m}g=Za(f,e.m);h=e.i;g||(g=[],h=0);k=Bc({o:g,i:h},b);return l.return({containerPath:k.o,offset:k.i,type:10})})}\nfunction lh(a,b){var c,d,e,f,g,h;return Ca(function(k){c=fc({o:a.startContainerPath,i:a.startOffset},b);Qa(a.endContainerPath)&&C(a.endContainerOffset)&&(d=fc({o:a.endContainerPath,i:a.endContainerOffset},b));e=K(Z);f=cc(c,e);g=[];if(f.m){h=null;d&&(h=cc(d,e),h.m||(h=null));var l=f,m=h,n=Z,p="iOS"===Oe().getOSName(),r=[];if(!m){var t=null;if(A(l.m)){var w=l.i<l.m.childNodes.length?l.m.childNodes[l.i]:null;if(Rd(w))if(A(w))t=w.getBoundingClientRect();else{if(F(w)&&0<w.data.length){var y=n.createRange();\ny.selectNode(w);t=y.getBoundingClientRect();y.detach()}}else t=Sd(l.m,l.i)}else F(l.m)&&(Rd(l.m)?(t=l.m,w=l.i,y=n.createRange(),t.data[w]?(y.setStart(t,w),y.setEnd(t,w+1)):0<w&&(y.setStart(t,w-1),y.setEnd(t,w)),t=y.getBoundingClientRect()):t=Sd(l.m,l.i));t&&r.push({bottom:t.top,height:0,left:t.left,right:t.left,top:t.top,width:0})}0===r.length&&m&&l.m&&m.m&&(r=Qd(n,l,m),p&&1<r.length&&(l=r[r.length-1],0===l.left&&0===l.top&&r.pop()));g=r}return k.return({data:g,type:35})})}\nfunction mh(a,b){var c,d,e,f,g,h,k,l,m,n,p,r,t,w,y;return Ca(function(T){c=K(Z);d=fc({o:a.startContainerPath,i:a.startOffset},b);e=cc(d,c);a.endContainerPath&&C(a.endOffset)?(g=fc({o:a.endContainerPath,i:a.endOffset},b),f=cc(g,c)):f=e;h=Pd(e,f);if(a.includeNodeData){var J=Yb;for(var z=[],M=Z.createRange(),ma=v(h),G=ma.next();!G.done;G=ma.next())G=G.value,M.setStart(G.Ca.m,G.Ca.i),M.setEnd(G.Ba.m,G.Ba.i),G=M.commonAncestorContainer,A(G)||(G=G.parentNode),G=J(G),z.push(G||void 0);J=z}else J=null;k=\nJ;l=[];for(m=0;m<h.length;m++)n=h[m],p=bc(n.Ca.m,n.Ca.i),r=bc(n.Ba.m,n.Ba.i),p&&r?(t=eb(n.pa),w=Bc(p,b),y=Bc(r,b),l.push({endContainerPath:y.o,endOffset:y.i,nodeData:k?k[m]:void 0,rect:{height:t.height,width:t.width,x:t.x,y:t.y},startContainerPath:w.o,startOffset:w.i,type:n.u})):R("Iframe fetchVisibleContentRects: Expected startPosition and endPosition in internal rect.");return T.return({rects:l,type:20})})}function nh(a,b){var c=new ge;he(c,a);return c.transform(Z,b)}\nfunction oh(a,b){var c=fc({o:a.startContainerPath,i:a.startOffset},b),d;Qa(a.endContainerPath)&&C(a.endContainerOffset)&&(d=fc({o:a.endContainerPath,i:a.endContainerOffset},b));a=K(Z);c=cc(c,a);if((b=Z.getSelection())&&c.m){var e=null;d&&(e=cc(d,a),e.m||(e=null));e?null==b||b.setBaseAndExtent(c.m,c.i,e.m,e.i):null==b||b.setPosition(c.m,c.i);document.body.focus()}}\nih.prototype.oc=function(a,b){switch(a.type){case 7:this.ma=!0;var c;null==(c=this.O)||Ff(c);ph(this,b).catch(function(e){S(e)});break;case 33:this.A&&Zg(this.A,a);break;case 32:this.A&&$g(this.A,a);qh(this,a);break;case 37:rh(this,a);break;case 39:Rg(this.oa,a);qh(this,a);break;case 42:var d;null==(d=Z.defaultView)||d.print();break;case 43:this.C?oh(a,this.C):R("IframeMessageHandler.setContentSelection: DOM mutation records not available.")}};\nih.prototype.pc=function(a,b){var c=this;return Ca(function(d){switch(d.g){case 1:switch(a.type){case 3:return d.return(sh(c,b,a));case 10:if(!c.C)throw new O("IframeMessageHandler.fetchOverlayRects: DOM mutation records not available.");return d.return(kh(a,c.C));case 23:if(!c.C)throw new O("IframeMessageHandler.fetchOverlayRects: DOM mutation records not available.");return d.return(lh(a,c.C));case 19:if(!c.C)throw new O("IframeMessageHandler.fetchVisibleContentRects: DOM mutation records not available.");\nreturn d.return(mh(a,c.C));case 28:return d.la(2)}d.la(3);break;case 2:if(!c.C)throw new O("IframeMessageHandler.focusOnDomLocation: DOM mutation records not available.");if(!c.Y)throw new O("IframeMessageHandler.focusOnDomLocation: No iframe focus manager available.");return ta(d,sc(c.Y,a),4);case 4:return d.return({type:29});case 3:throw new O("IframeMessageHandler.handleMessage: Unknown message type.");}})};\nfunction sh(a,b,c){var d,e,f,g,h,k,l,m,n,p,r,t,w,y,T,J,z,M,ma,G,Cf,Zb;return Ca(function(da){switch(da.g){case 1:a.gb=c.iframeStorageId;Object.defineProperty(window,"history",{configurable:!0,value:void 0});c.transitionStylesheet&&(a.fa=c.transitionStylesheet);a.I=c.disableScripts;c.disableScripts||(a.Z=c.scripts);a.oa.g.set("contentDocumentEventHandlersEnabled",c.scriptedContentDocumentEventHandlersEnabled);th(c);uh(a,c,b);vh(a,c,b);a.C=ec(c.domMutationRecords);d=new Vd(a.C);e=new ae(d);a.Y=new rc(e,\na.C);jh(c,b);a.X=new Ie;a.O=new uf(b,a.C);a.ma&&Ff(a.O);f=new Ye(b);new Rf(b,c.scaleFactor);a.Ua=new Se(b,c);a.A=new Yg(c.mediaOverlayActiveElementClass,c.mediaOverlayPlaybackActiveClass,c.mediaOverlayAncestorElementClass);a.h=[];if(c.body)for(g=JSON.parse(c.body),h=g.childNodes,k=0;k<h.length;k++)Z.body.appendChild(Ac(h[k],Z));l=wh(c);a.v=new Hg(a.oa);m=[new ag,new cg,new lg(a.O),new Tf(c),new Cg(b,a.v,c.includeContentLocationInPointerMoveEvents,c.forceTouchEvents,c.isMouseSwipeNavigationAllowed,\nc.alwaysEmitPointerMoveEvents,a.C),new Wf(b,a.v,a.C),new hg(b,a.v,a.C),new Gg(a.oa),new ng];c.preventDefaultContextMenuOnMediaElements&&m.push(new Zf);c.preventDefaultContextMenu&&m.push(new Yf);c.preventDragAndDropActions&&m.push(new fg(a.v));c.addTabIndexToMediaElements&&m.push(new jg);n=new ue(m);a.fa&&ve(n,new dg(a.fa));new Dg(b,a.oa,a.v,a.C);new Sb(a.v,b,c);p=new ge;he(p,[new te,n,new Ae(f,c.needsReflowableLayoutFixes)]);a.j=new qe(c,b);he(p,[a.j]);a.I||he(p,[new Ee]);da.l=2;return ta(da,Promise.all([p.transform(Z,\ne),l]),4);case 4:r=Z.documentElement;(t=r.getAttribute("data-colibrio-org-style"))?r.setAttribute("style",t):r.removeAttribute("style");a.l=new Xb;a.l.ta=n.ta;a.l.Ta();if(!c.needsReflowableLayoutFixes){da.la(5);break}return ta(da,nh([new Ed,new Dd],e),6);case 6:return w=Oe(),T="iOS"===w.getOS()&&!0===(null==(y=w.getOSVersion())?void 0:y.startsWith("12.")),J=new ud(c.horizontalOverflowFixerMinFontSize,c.fontSizeScaleFactor,c.horizontalOverflowFixerTableScroll,c.horizontalOverflowFixerMathScroll,T),\nz=xh(c),M=c.removePublicationDefinedHorizontalPageMargins&&z?[new od,J]:[J],ta(da,nh(M,e),5);case 5:da.g=3;da.l=0;break;case 2:ma=ua(da),R(ma);case 3:return ta(da,a.j?re(a.j):[],8);case 8:a.g=da.A;if(a.h){for(G=0;G<a.g.length;G++)for(Cf=a.g[G],Zb=0;Zb<a.h.length;Zb++)pe(Cf,a.h[Zb]);a.h=null}eh(c,b);new Nf(b);new jf(b);a.ra=!0;return da.return(new Promise(function(Ah,Bh){setTimeout(function(){var Df;return Ca(function(na){if(1==na.g){if(!b.s)return Bh(),na.la(0);Df=function(){setTimeout(function(){P(b,\n{height:Z.documentElement.scrollHeight,type:5});Ah({type:4})},32)};na.l=0;na.s=3;return ta(na,ph(a,b),3)}na.T=[na.h];na.l=0;na.s=0;Df();return va(na)})},16)}))}})}\nfunction uh(a,b,c){try{var d=JSON.parse(b.publicationLocalStorage)}catch(f){d={},S(f)}a.s=new Sg(d,b.publicationStorageSizeLimit,function(f,g){P(c,{iframeStorageId:b.iframeStorageId,key:f,target:0,type:37,value:g})});try{var e=Object.getOwnPropertyDescriptor(window,"localStorage")}catch(f){}e&&e.configurable?Object.defineProperty(window,"localStorage",{value:Tg(a.s)}):S("window.localStorage is not configurable");Object.defineProperty(window,"colibrioLocalStorage",{value:Tg(a.s)})}\nfunction th(a){var b=Object.create(null);Object.defineProperties(b,{hasFeature:{value:function(c){switch(c){case "dom-manipulation":case "layout-changes":case "mouse-events":case "keyboard-events":case "spine-scripting":return!0;case "touch-events":return"ontouchstart"in window}return!1}},layoutStyle:{value:a.layoutStyle},name:{value:"Colibrio"},version:{value:"1.0.0"}});Object.defineProperty(window.navigator,"epubReadingSystem",{value:b})}\nfunction vh(a,b,c){try{var d=JSON.parse(b.publicationSessionStorage)}catch(f){d={},S(f)}a.T=new Sg(d,b.publicationStorageSizeLimit,function(f,g){P(c,{iframeStorageId:b.iframeStorageId,key:f,target:1,type:37,value:g})});try{var e=Object.getOwnPropertyDescriptor(window,"sessionStorage")}catch(f){}e&&e.configurable?Object.defineProperty(window,"sessionStorage",{value:Tg(a.T)}):S("window.sessionStorage is not configurable")}\nfunction yh(a,b){new Og(b);var c=Wa(Z);return fb(a.Z,function(d){return new Promise(function(e){var f=ff(d),g=f.getAttribute("src");if(g&&/^\\s*(?:data:|blob:|https?:)/.test(g)){g=function(){f.onload=null;f.onerror=null;window.clearTimeout(h);e()};f.onload=g;f.onerror=g;var h=window.setTimeout(g,5E3);c.appendChild(f)}else c.appendChild(f),e()})}).finally(function(){a.Z=[]})}\nfunction rh(a,b){a.gb!==b.iframeStorageId&&(0===b.target&&a.s?Vg(a.s,b.key,b.value):1===b.target&&a.T&&Vg(a.T,b.key,b.value));qh(a,b)}function xh(a){var b=Z,c;if(!(c=a.hasInlineNegativeHorizontalMarginStyles))if(a.negativeHorizontalMarginSelectors&&0<a.negativeHorizontalMarginSelectors.length)try{c=null!==b.querySelector(a.negativeHorizontalMarginSelectors.join(", "))}catch(d){c=!0}else c=!1;return c}\nfunction wh(a){for(var b=Wa(Z),c=[],d=Z.createDocumentFragment(),e={},f=0;f<a.styleDefs.length;e={bb:void 0},f++)e.bb=gf(a.styleDefs[f]),d.appendChild(e.bb),"link"===e.bb.localName&&(e=new Promise(function(g){return function(h){g.bb.onload=function(){h()};g.bb.onerror=function(k){k&&console.error(k);h()}}}(e)),c.push(e));a.styleDefs=[];b.appendChild(d);return 0<c.length?new Promise(function(g){var h=window.setTimeout(function(){S("Unable to load stylesheets");g()},5E3);Promise.all(c).then(function(){window.clearTimeout(h);\ng()}).catch(R)}):Promise.resolve()}\nfunction ph(a,b){if(a.ra&&a.ma&&!a.hb){a.hb=!0;if(a.g)for(var c=0;c<a.g.length;c++)try{a.g[c].da()}catch(d){S(d)}a.j&&se(a.j);b=a.I?Promise.resolve():yh(a,b);b=b.then(function(){a.l&&a.l.da();if(a.X){var d=a.X;if("complete"!==d.M){d.M="complete";try{var e=new Event("readystatechange",{bubbles:!1,cancelable:!1});document.dispatchEvent(e)}catch(h){S(h)}}}if(!a.I){try{var f=new Event("DOMContentLoaded",{bubbles:!0,cancelable:!1});Z.dispatchEvent(f)}catch(h){S(h)}try{var g=new UIEvent("load",{bubbles:!1,\ncancelable:!1,detail:0,view:Z.defaultView});window.dispatchEvent(g)}catch(h){S(h)}}})}else b=Promise.resolve();return b}function qh(a,b){if(a.h)a.h.push(b);else if(a.g)for(var c=0;c<a.g.length;c++)pe(a.g[c],b);if(null!=(a=a.Ua))for(a.s.push(b),a=v(a.A),c=a.next();!c.done;c=a.next())pe(c.value,b)};var zh=null;try{zh=null===window.frameElement}catch(a){zh=!0}if(zh){var Jb=new ih;Hb().catch(function(a){console.error(a)})}else console.error("Non-sandbox mode! Scripted document loading aborted.");var Ch=new ArrayBuffer(8);new DataView(Ch);new Uint8Array(Ch); }).call(__self); })(typeof self !== \'undefined\' && self ? self : typeof window !== \'undefined\' && window ? window : typeof global !== \'undefined\' && global ? global : this)\n';
    var __worker__colibrio_readingsystem_formatadapter_epub_webworker = '\'use strict\'; (function (__self) { var __lib__base64_js = (function () { var exports = {}; var module = { exports: exports }; var define = void 0; (function(d){"object"===typeof exports&&"undefined"!==typeof module?module.exports=d():"function"===typeof define&&define.amd?define([],d):("undefined"!==typeof window?window:"undefined"!==typeof global?global:"undefined"!==typeof self?self:this).lib=d()})(function(){return function(){function d(m,l,p){function h(a,b){if(!l[a]){if(!m[a]){var c="function"==typeof require&&require;if(!b&&c)return c(a,!0);if(e)return e(a,!0);b=Error("Cannot find module \'"+a+"\'");throw b.code="MODULE_NOT_FOUND",b;}b=\nl[a]={exports:{}};m[a][0].call(b.exports,function(f){return h(m[a][1][f]||f)},b,b.exports,d,m,l,p)}return l[a].exports}for(var e="function"==typeof require&&require,q=0;q<p.length;q++)h(p[q]);return h}return d}()({1:[function(d,m,l){function p(a){var b=a.length;if(0<b%4)throw Error("Invalid string. Length must be a multiple of 4");a=a.indexOf("=");-1===a&&(a=b);return[a,a===b?0:4-a%4]}l.byteLength=function(a){a=p(a);var b=a[1];return 3*(a[0]+b)/4-b};l.toByteArray=function(a){var b=p(a);var c=b[0];\nb=b[1];var f=new q(3*(c+b)/4-b),k=0,r=0<b?c-4:c,g;for(g=0;g<r;g+=4)c=e[a.charCodeAt(g)]<<18|e[a.charCodeAt(g+1)]<<12|e[a.charCodeAt(g+2)]<<6|e[a.charCodeAt(g+3)],f[k++]=c>>16&255,f[k++]=c>>8&255,f[k++]=c&255;2===b&&(c=e[a.charCodeAt(g)]<<2|e[a.charCodeAt(g+1)]>>4,f[k++]=c&255);1===b&&(c=e[a.charCodeAt(g)]<<10|e[a.charCodeAt(g+1)]<<4|e[a.charCodeAt(g+2)]>>2,f[k++]=c>>8&255,f[k++]=c&255);return f};l.fromByteArray=function(a){for(var b=a.length,c=b%3,f=[],k=0,r=b-c;k<r;k+=16383){for(var g=f,w=g.push,\nn,u=a,x=k+16383>r?r:k+16383,v=[],t=k;t<x;t+=3)n=(u[t]<<16&16711680)+(u[t+1]<<8&65280)+(u[t+2]&255),v.push(h[n>>18&63]+h[n>>12&63]+h[n>>6&63]+h[n&63]);n=v.join("");w.call(g,n)}1===c?(a=a[b-1],f.push(h[a>>2]+h[a<<4&63]+"==")):2===c&&(a=(a[b-2]<<8)+a[b-1],f.push(h[a>>10]+h[a>>4&63]+h[a<<2&63]+"="));return f.join("")};var h=[],e=[],q="undefined"!==typeof Uint8Array?Uint8Array:Array;for(d=0;64>d;++d)h[d]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"[d],e["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(d)]=\nd;e[45]=62;e[95]=63},{}],2:[function(d,m){m.exports=d("base64-js")},{"base64-js":1}]},{},[2])(2)});\n return module.exports; })();\nvar __lib__bowser = (function () { var exports = {}; var module = { exports: exports }; var define = void 0; var k=k||{};k.scope={};k.arrayIteratorImpl=function(f){var m=0;return function(){return m<f.length?{done:!1,value:f[m++]}:{done:!0}}};k.arrayIterator=function(f){return{next:k.arrayIteratorImpl(f)}};k.ASSUME_ES5=!1;k.ASSUME_NO_NATIVE_MAP=!1;k.ASSUME_NO_NATIVE_SET=!1;k.SIMPLE_FROUND_POLYFILL=!1;k.ISOLATE_POLYFILLS=!1;k.FORCE_POLYFILL_PROMISE=!1;k.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION=!1;\nk.defineProperty=k.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(f,m,r){if(f==Array.prototype||f==Object.prototype)return f;f[m]=r.value;return f};k.getGlobal=function(f){f=["object"==typeof globalThis&&globalThis,f,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var m=0;m<f.length;++m){var r=f[m];if(r&&r.Math==Math)return r}throw Error("Cannot find global object");};k.global=k.getGlobal(this);\nk.IS_SYMBOL_NATIVE="function"===typeof Symbol&&"symbol"===typeof Symbol("x");k.TRUST_ES6_POLYFILLS=!k.ISOLATE_POLYFILLS||k.IS_SYMBOL_NATIVE;k.polyfills={};k.propertyToPolyfillSymbol={};k.POLYFILL_PREFIX="$jscp$";k.polyfill=function(f,m,r,n){m&&(k.ISOLATE_POLYFILLS?k.polyfillIsolated(f,m,r,n):k.polyfillUnisolated(f,m,r,n))};\nk.polyfillUnisolated=function(f,m){var r=k.global;f=f.split(".");for(var n=0;n<f.length-1;n++){var p=f[n];if(!(p in r))return;r=r[p]}f=f[f.length-1];n=r[f];m=m(n);m!=n&&null!=m&&k.defineProperty(r,f,{configurable:!0,writable:!0,value:m})};\nk.polyfillIsolated=function(f,m,r){var n=f.split(".");f=1===n.length;var p=n[0];p=!f&&p in k.polyfills?k.polyfills:k.global;for(var e=0;e<n.length-1;e++){var t=n[e];if(!(t in p))return;p=p[t]}n=n[n.length-1];r=k.IS_SYMBOL_NATIVE&&"es6"===r?p[n]:null;m=m(r);null!=m&&(f?k.defineProperty(k.polyfills,n,{configurable:!0,writable:!0,value:m}):m!==r&&(void 0===k.propertyToPolyfillSymbol[n]&&(f=1E9*Math.random()>>>0,k.propertyToPolyfillSymbol[n]=k.IS_SYMBOL_NATIVE?k.global.Symbol(n):k.POLYFILL_PREFIX+f+"$"+\nn),k.defineProperty(p,k.propertyToPolyfillSymbol[n],{configurable:!0,writable:!0,value:m})))};k.initSymbol=function(){};\nk.polyfill("Symbol",function(f){function m(e){if(this instanceof m)throw new TypeError("Symbol is not a constructor");return new r(n+(e||"")+"_"+p++,e)}function r(e,t){this.$jscomp$symbol$id_=e;k.defineProperty(this,"description",{configurable:!0,writable:!0,value:t})}if(f)return f;r.prototype.toString=function(){return this.$jscomp$symbol$id_};var n="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",p=0;return m},"es6","es3");\nk.polyfill("Symbol.iterator",function(f){if(f)return f;f=Symbol("Symbol.iterator");for(var m="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),r=0;r<m.length;r++){var n=k.global[m[r]];"function"===typeof n&&"function"!=typeof n.prototype[f]&&k.defineProperty(n.prototype,f,{configurable:!0,writable:!0,value:function(){return k.iteratorPrototype(k.arrayIteratorImpl(this))}})}return f},"es6","es3");\nk.iteratorPrototype=function(f){f={next:f};f[Symbol.iterator]=function(){return this};return f};k.iteratorFromArray=function(f,m){f instanceof String&&(f+="");var r=0,n=!1,p={next:function(){if(!n&&r<f.length){var e=r++;return{value:m(e,f[e]),done:!1}}n=!0;return{done:!0,value:void 0}}};p[Symbol.iterator]=function(){return p};return p};k.polyfill("Array.prototype.keys",function(f){return f?f:function(){return k.iteratorFromArray(this,function(m){return m})}},"es6","es3");\nk.findInternal=function(f,m,r){f instanceof String&&(f=String(f));for(var n=f.length,p=0;p<n;p++){var e=f[p];if(m.call(r,e,p,f))return{i:p,v:e}}return{i:-1,v:void 0}};k.polyfill("Array.prototype.find",function(f){return f?f:function(m,r){return k.findInternal(this,m,r).v}},"es6","es3");\n(function(f){"object"===typeof exports&&"undefined"!==typeof module?module.exports=f():"function"===typeof define&&define.amd?define([],f):("undefined"!==typeof window?window:"undefined"!==typeof global?global:"undefined"!==typeof self?self:this).lib=f()})(function(){return function(){function f(m,r,n){function p(h,d){if(!r[h]){if(!m[h]){var c="function"==typeof require&&require;if(!d&&c)return c(h,!0);if(e)return e(h,!0);d=Error("Cannot find module \'"+h+"\'");throw d.code="MODULE_NOT_FOUND",d;}d=\nr[h]={exports:{}};m[h][0].call(d.exports,function(a){return p(m[h][1][a]||a)},d,d.exports,f,m,r,n)}return r[h].exports}for(var e="function"==typeof require&&require,t=0;t<n.length;t++)p(n[t]);return p}return f}()({1:[function(f,m,r){function n(p){"@babel/helpers - typeof";return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n(p)}!function(p,\ne){"object"==("undefined"===typeof r?"undefined":n(r))&&"object"==("undefined"===typeof m?"undefined":n(m))?m.exports=e():"object"==("undefined"===typeof r?"undefined":n(r))?r.bowser=e():p.bowser=e()}(void 0,function(){return function(p){function e(h){if(t[h])return t[h].exports;var d=t[h]={i:h,l:!1,exports:{}};return p[h].call(d.exports,d,d.exports,e),d.l=!0,d.exports}var t={};return e.m=p,e.c=t,e.d=function(h,d,c){e.o(h,d)||Object.defineProperty(h,d,{enumerable:!0,get:c})},e.r=function(h){"undefined"!=\ntypeof Symbol&&Symbol.toStringTag&&Object.defineProperty(h,Symbol.toStringTag,{value:"Module"});Object.defineProperty(h,"__esModule",{value:!0})},e.t=function(h,d){if((1&d&&(h=e(h)),8&d)||4&d&&"object"==n(h)&&h&&h.__esModule)return h;var c=Object.create(null);if(e.r(c),Object.defineProperty(c,"default",{enumerable:!0,value:h}),2&d&&"string"!=typeof h)for(var a in h)e.d(c,a,function(b){return h[b]}.bind(null,a));return c},e.n=function(h){var d=h&&h.__esModule?function(){return h.default}:function(){return h};\nreturn e.d(d,"a",d),d},e.o=function(h,d){return Object.prototype.hasOwnProperty.call(h,d)},e.p="",e(e.s=90)}({17:function(p,e,t){e.__esModule=!0;e.default=void 0;var h=t(18);t=function(){function d(){}return d.getFirstMatch=function(c,a){return(c=a.match(c))&&0<c.length&&c[1]||""},d.getSecondMatch=function(c,a){return(c=a.match(c))&&1<c.length&&c[2]||""},d.matchAndReturnConst=function(c,a,b){if(c.test(a))return b},d.getWindowsVersionName=function(c){switch(c){case "NT":return"NT";case "XP":return"XP";\ncase "NT 5.0":return"2000";case "NT 5.1":return"XP";case "NT 5.2":return"2003";case "NT 6.0":return"Vista";case "NT 6.1":return"7";case "NT 6.2":return"8";case "NT 6.3":return"8.1";case "NT 10.0":return"10"}},d.getMacOSVersionName=function(c){c=c.split(".").splice(0,2).map(function(a){return parseInt(a,10)||0});if(c.push(0),10===c[0])switch(c[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";\ncase 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina"}},d.getAndroidVersionName=function(c){c=c.split(".").splice(0,2).map(function(a){return parseInt(a,10)||0});if(c.push(0),!(1===c[0]&&5>c[1]))return 1===c[0]&&6>c[1]?"Cupcake":1===c[0]&&6<=c[1]?"Donut":2===c[0]&&2>c[1]?"Eclair":2===c[0]&&2===c[1]?"Froyo":2===c[0]&&2<c[1]?"Gingerbread":3===c[0]?"Honeycomb":4===c[0]&&1>c[1]?"Ice Cream Sandwich":4===c[0]&&4>c[1]?"Jelly Bean":4===c[0]&&4<=c[1]?"KitKat":5===\nc[0]?"Lollipop":6===c[0]?"Marshmallow":7===c[0]?"Nougat":8===c[0]?"Oreo":9===c[0]?"Pie":void 0},d.getVersionPrecision=function(c){return c.split(".").length},d.compareVersions=function(c,a,b){void 0===b&&(b=!1);var v=d.getVersionPrecision(c),w=d.getVersionPrecision(a),l=Math.max(v,w),g=0;c=d.map([c,a],function(q){var u=l-d.getVersionPrecision(q);q+=Array(u+1).join(".0");return d.map(q.split("."),function(x){return Array(20-x.length).join("0")+x}).reverse()});b&&(g=l-Math.min(v,w));for(--l;l>=g;){if(c[0][l]>\nc[1][l])return 1;if(c[0][l]===c[1][l]){if(l===g)return 0;--l}else if(c[0][l]<c[1][l])return-1}},d.map=function(c,a){var b,v=[];if(Array.prototype.map)return Array.prototype.map.call(c,a);for(b=0;b<c.length;b+=1)v.push(a(c[b]));return v},d.find=function(c,a){var b;if(Array.prototype.find)return Array.prototype.find.call(c,a);var v=0;for(b=c.length;v<b;v+=1){var w=c[v];if(a(w,v))return w}},d.assign=function(c){function a(){var g=v[l];"object"==n(g)&&null!==g&&Object.keys(g).forEach(function(q){c[q]=\ng[q]})}var b=arguments.length;for(var v=Array(1<b?b-1:0),w=1;w<b;w++)v[w-1]=arguments[w];if(Object.assign)return Object.assign.apply(Object,[c].concat(v));var l=0;for(b=v.length;l<b;l+=1)a();return c},d.getBrowserAlias=function(c){return h.BROWSER_ALIASES_MAP[c]},d.getBrowserTypeByAlias=function(c){return h.BROWSER_MAP[c]||""},d}();e.default=t;p.exports=e.default},18:function(p,e){e.__esModule=!0;e.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",\nChrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",\nSeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};e.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",\nmaxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};e.PLATFORMS_MAP={tablet:"tablet",\nmobile:"mobile",desktop:"desktop",tv:"tv"};e.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};e.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(p,e,t){function h(b,v){for(var w=0;w<v.length;w++){var l=v[w];l.enumerable=l.enumerable||!1;\nl.configurable=!0;"value"in l&&(l.writable=!0);Object.defineProperty(b,l.key,l)}}e.__esModule=!0;e.default=void 0;var d,c=(d=t(91))&&d.__esModule?d:{default:d},a=t(18);t=function(){function b(){}var v;return b.getParser=function(w,l){if(void 0===l&&(l=!1),"string"!=typeof w)throw Error("UserAgent should be a string");return new c.default(w,l)},b.parse=function(w){return(new c.default(w)).getResult()},v=[{key:"BROWSER_MAP",get:function(){return a.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return a.ENGINE_MAP}},\n{key:"OS_MAP",get:function(){return a.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return a.PLATFORMS_MAP}}],v&&h(b,v),b}();e.default=t;p.exports=e.default},91:function(p,e,t){function h(w){return w&&w.__esModule?w:{default:w}}e.__esModule=!0;e.default=void 0;var d=h(t(92)),c=h(t(93)),a=h(t(94)),b=h(t(95)),v=h(t(17));t=function(){function w(g,q){if(void 0===q&&(q=!1),null==g||""===g)throw Error("UserAgent parameter can\'t be empty");this._ua=g;this.parsedResult={};!0!==q&&this.parse()}var l=w.prototype;\nreturn l.getUA=function(){return this._ua},l.test=function(g){return g.test(this._ua)},l.parseBrowser=function(){var g=this;this.parsedResult.browser={};var q=v.default.find(d.default,function(u){if("function"==typeof u.test)return u.test(g);if(u.test instanceof Array)return u.test.some(function(x){return g.test(x)});throw Error("Browser\'s test function is not valid");});return q&&(this.parsedResult.browser=q.describe(this.getUA())),this.parsedResult.browser},l.getBrowser=function(){return this.parsedResult.browser?\nthis.parsedResult.browser:this.parseBrowser()},l.getBrowserName=function(g){return g?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},l.getBrowserVersion=function(){return this.getBrowser().version},l.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},l.parseOS=function(){var g=this;this.parsedResult.os={};var q=v.default.find(c.default,function(u){if("function"==typeof u.test)return u.test(g);if(u.test instanceof Array)return u.test.some(function(x){return g.test(x)});\nthrow Error("Browser\'s test function is not valid");});return q&&(this.parsedResult.os=q.describe(this.getUA())),this.parsedResult.os},l.getOSName=function(g){var q=this.getOS().name;return g?String(q).toLowerCase()||"":q||""},l.getOSVersion=function(){return this.getOS().version},l.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},l.getPlatformType=function(g){void 0===g&&(g=!1);var q=this.getPlatform().type;return g?String(q).toLowerCase()||\n"":q||""},l.parsePlatform=function(){var g=this;this.parsedResult.platform={};var q=v.default.find(a.default,function(u){if("function"==typeof u.test)return u.test(g);if(u.test instanceof Array)return u.test.some(function(x){return g.test(x)});throw Error("Browser\'s test function is not valid");});return q&&(this.parsedResult.platform=q.describe(this.getUA())),this.parsedResult.platform},l.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},l.getEngineName=\nfunction(g){return g?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},l.parseEngine=function(){var g=this;this.parsedResult.engine={};var q=v.default.find(b.default,function(u){if("function"==typeof u.test)return u.test(g);if(u.test instanceof Array)return u.test.some(function(x){return g.test(x)});throw Error("Browser\'s test function is not valid");});return q&&(this.parsedResult.engine=q.describe(this.getUA())),this.parsedResult.engine},l.parse=function(){return this.parseBrowser(),\nthis.parseOS(),this.parsePlatform(),this.parseEngine(),this},l.getResult=function(){return v.default.assign({},this.parsedResult)},l.satisfies=function(g){var q=this,u={},x=0,A={},D=0;if(Object.keys(g).forEach(function(z){var C=g[z];"string"==typeof C?(A[z]=C,D+=1):"object"==n(C)&&(u[z]=C,x+=1)}),0<x){var y=Object.keys(u),B=v.default.find(y,function(z){return q.isOS(z)});if(B&&(B=this.satisfies(u[B]),void 0!==B))return B;if(y=v.default.find(y,function(z){return q.isPlatform(z)}))if(y=this.satisfies(u[y]),\nvoid 0!==y)return y}if(0<D&&(y=Object.keys(A),y=v.default.find(y,function(z){return q.isBrowser(z,!0)}),void 0!==y))return this.compareVersion(A[y])},l.isBrowser=function(g,q){void 0===q&&(q=!1);var u=this.getBrowserName().toLowerCase();g=g.toLowerCase();var x=v.default.getBrowserTypeByAlias(g);return q&&x&&(g=x.toLowerCase()),g===u},l.compareVersion=function(g){var q=[0],u=g,x=!1,A=this.getBrowserVersion();if("string"==typeof A)return">"===g[0]||"<"===g[0]?(u=g.substr(1),"="===g[1]?(x=!0,u=g.substr(2)):\nq=[],">"===g[0]?q.push(1):q.push(-1)):"="===g[0]?u=g.substr(1):"~"===g[0]&&(x=!0,u=g.substr(1)),-1<q.indexOf(v.default.compareVersions(A,u,x))},l.isOS=function(g){return this.getOSName(!0)===String(g).toLowerCase()},l.isPlatform=function(g){return this.getPlatformType(!0)===String(g).toLowerCase()},l.isEngine=function(g){return this.getEngineName(!0)===String(g).toLowerCase()},l.is=function(g,q){return void 0===q&&(q=!1),this.isBrowser(g,q)||this.isOS(g)||this.isPlatform(g)},l.some=function(g){var q=\nthis;return void 0===g&&(g=[]),g.some(function(u){return q.is(u)})},w}();e.default=t;p.exports=e.default},92:function(p,e,t){e.__esModule=!0;e.default=void 0;var h,d=(h=t(17))&&h.__esModule?h:{default:h},c=/version\\/(\\d+(\\.?_?\\d+)+)/i;e.default=[{test:[/googlebot/i],describe:function(a){var b={name:"Googlebot"};a=d.default.getFirstMatch(/googlebot\\/(\\d+(\\.\\d+))/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/opera/i],describe:function(a){var b={name:"Opera"};a=d.default.getFirstMatch(c,\na)||d.default.getFirstMatch(/(?:opera)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/opr\\/|opios/i],describe:function(a){var b={name:"Opera"};a=d.default.getFirstMatch(/(?:opr|opios)[\\s/](\\S+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/SamsungBrowser/i],describe:function(a){var b={name:"Samsung Internet for Android"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:SamsungBrowser)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/Whale/i],\ndescribe:function(a){var b={name:"NAVER Whale Browser"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:whale)[\\s/](\\d+(?:\\.\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/MZBrowser/i],describe:function(a){var b={name:"MZ Browser"};a=d.default.getFirstMatch(/(?:MZBrowser)[\\s/](\\d+(?:\\.\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/focus/i],describe:function(a){var b={name:"Focus"};a=d.default.getFirstMatch(/(?:focus)[\\s/](\\d+(?:\\.\\d+)+)/i,a)||d.default.getFirstMatch(c,\na);return a&&(b.version=a),b}},{test:[/swing/i],describe:function(a){var b={name:"Swing"};a=d.default.getFirstMatch(/(?:swing)[\\s/](\\d+(?:\\.\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/coast/i],describe:function(a){var b={name:"Opera Coast"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:coast)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/opt\\/\\d+(?:.?_?\\d+)+/i],describe:function(a){var b={name:"Opera Touch"};a=d.default.getFirstMatch(/(?:opt)[\\s/](\\d+(\\.?_?\\d+)+)/i,\na)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/yabrowser/i],describe:function(a){var b={name:"Yandex Browser"};a=d.default.getFirstMatch(/(?:yabrowser)[\\s/](\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/ucbrowser/i],describe:function(a){var b={name:"UC Browser"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:ucbrowser)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/Maxthon|mxios/i],describe:function(a){var b=\n{name:"Maxthon"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:Maxthon|mxios)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/epiphany/i],describe:function(a){var b={name:"Epiphany"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:epiphany)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/puffin/i],describe:function(a){var b={name:"Puffin"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:puffin)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=\na),b}},{test:[/sleipnir/i],describe:function(a){var b={name:"Sleipnir"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:sleipnir)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/k-meleon/i],describe:function(a){var b={name:"K-Meleon"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/(?:k-meleon)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/micromessenger/i],describe:function(a){var b={name:"WeChat"};a=d.default.getFirstMatch(/(?:micromessenger)[\\s/](\\d+(\\.?_?\\d+)+)/i,\na)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/qqbrowser/i],describe:function(a){var b={name:/qqbrowserlite/i.test(a)?"QQ Browser Lite":"QQ Browser"};a=d.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/msie|trident/i],describe:function(a){var b={name:"Internet Explorer"};a=d.default.getFirstMatch(/(?:msie |rv:)(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/\\sedg\\//i],describe:function(a){var b=\n{name:"Microsoft Edge"};a=d.default.getFirstMatch(/\\sedg\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/edg([ea]|ios)/i],describe:function(a){var b={name:"Microsoft Edge"};a=d.default.getSecondMatch(/edg([ea]|ios)\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/vivaldi/i],describe:function(a){var b={name:"Vivaldi"};a=d.default.getFirstMatch(/vivaldi\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/seamonkey/i],describe:function(a){var b={name:"SeaMonkey"};a=d.default.getFirstMatch(/seamonkey\\/(\\d+(\\.?_?\\d+)+)/i,\na);return a&&(b.version=a),b}},{test:[/sailfish/i],describe:function(a){var b={name:"Sailfish"};a=d.default.getFirstMatch(/sailfish\\s?browser\\/(\\d+(\\.\\d+)?)/i,a);return a&&(b.version=a),b}},{test:[/silk/i],describe:function(a){var b={name:"Amazon Silk"};a=d.default.getFirstMatch(/silk\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/phantom/i],describe:function(a){var b={name:"PhantomJS"};a=d.default.getFirstMatch(/phantomjs\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/slimerjs/i],\ndescribe:function(a){var b={name:"SlimerJS"};a=d.default.getFirstMatch(/slimerjs\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/blackberry|\\bbb\\d+/i,/rim\\stablet/i],describe:function(a){var b={name:"BlackBerry"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/blackberry[\\d]+\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/(web|hpw)[o0]s/i],describe:function(a){var b={name:"WebOS Browser"};a=d.default.getFirstMatch(c,a)||d.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\\/(\\d+(\\.?_?\\d+)+)/i,\na);return a&&(b.version=a),b}},{test:[/bada/i],describe:function(a){var b={name:"Bada"};a=d.default.getFirstMatch(/dolfin\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/tizen/i],describe:function(a){var b={name:"Tizen"};a=d.default.getFirstMatch(/(?:tizen\\s?)?browser\\/(\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/qupzilla/i],describe:function(a){var b={name:"QupZilla"};a=d.default.getFirstMatch(/(?:qupzilla)[\\s/](\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,\na);return a&&(b.version=a),b}},{test:[/firefox|iceweasel|fxios/i],describe:function(a){var b={name:"Firefox"};a=d.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\\s/](\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/electron/i],describe:function(a){var b={name:"Electron"};a=d.default.getFirstMatch(/(?:electron)\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/MiuiBrowser/i],describe:function(a){var b={name:"Miui"};a=d.default.getFirstMatch(/(?:MiuiBrowser)[\\s/](\\d+(\\.?_?\\d+)+)/i,\na);return a&&(b.version=a),b}},{test:[/chromium/i],describe:function(a){var b={name:"Chromium"};a=d.default.getFirstMatch(/(?:chromium)[\\s/](\\d+(\\.?_?\\d+)+)/i,a)||d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/chrome|crios|crmo/i],describe:function(a){var b={name:"Chrome"};a=d.default.getFirstMatch(/(?:chrome|crios|crmo)\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/GSA/i],describe:function(a){var b={name:"Google Search"};a=d.default.getFirstMatch(/(?:GSA)\\/(\\d+(\\.?_?\\d+)+)/i,\na);return a&&(b.version=a),b}},{test:function(a){var b=!a.test(/like android/i);a=a.test(/android/i);return b&&a},describe:function(a){var b={name:"Android Browser"};a=d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/playstation 4/i],describe:function(a){var b={name:"PlayStation 4"};a=d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/safari|applewebkit/i],describe:function(a){var b={name:"Safari"};a=d.default.getFirstMatch(c,a);return a&&(b.version=a),b}},{test:[/.*/i],\ndescribe:function(a){var b=-1!==a.search("\\\\(")?/^(.*)\\/(.*)[ \\t]\\((.*)/:/^(.*)\\/(.*) /;return{name:d.default.getFirstMatch(b,a),version:d.default.getSecondMatch(b,a)}}}];p.exports=e.default},93:function(p,e,t){e.__esModule=!0;e.default=void 0;var h,d=(h=t(17))&&h.__esModule?h:{default:h},c=t(18);e.default=[{test:[/Roku\\/DVP/],describe:function(a){a=d.default.getFirstMatch(/Roku\\/DVP-(\\d+\\.\\d+)/i,a);return{name:c.OS_MAP.Roku,version:a}}},{test:[/windows phone/i],describe:function(a){a=d.default.getFirstMatch(/windows phone (?:os)?\\s?(\\d+(\\.\\d+)*)/i,\na);return{name:c.OS_MAP.WindowsPhone,version:a}}},{test:[/windows /i],describe:function(a){a=d.default.getFirstMatch(/Windows ((NT|XP)( \\d\\d?.\\d)?)/i,a);var b=d.default.getWindowsVersionName(a);return{name:c.OS_MAP.Windows,version:a,versionName:b}}},{test:[/Macintosh(.*?) FxiOS(.*?)\\//],describe:function(a){var b={name:c.OS_MAP.iOS};a=d.default.getSecondMatch(/(Version\\/)(\\d[\\d.]+)/,a);return a&&(b.version=a),b}},{test:[/macintosh/i],describe:function(a){var b=d.default.getFirstMatch(/mac os x (\\d+(\\.?_?\\d+)+)/i,\na).replace(/[_\\s]/g,".");a=d.default.getMacOSVersionName(b);b={name:c.OS_MAP.MacOS,version:b};return a&&(b.versionName=a),b}},{test:[/(ipod|iphone|ipad)/i],describe:function(a){a=d.default.getFirstMatch(/os (\\d+([_\\s]\\d+)*) like mac os x/i,a).replace(/[_\\s]/g,".");return{name:c.OS_MAP.iOS,version:a}}},{test:function(a){var b=!a.test(/like android/i);a=a.test(/android/i);return b&&a},describe:function(a){var b=d.default.getFirstMatch(/android[\\s/-](\\d+(\\.\\d+)*)/i,a);a=d.default.getAndroidVersionName(b);\nb={name:c.OS_MAP.Android,version:b};return a&&(b.versionName=a),b}},{test:[/(web|hpw)[o0]s/i],describe:function(a){a=d.default.getFirstMatch(/(?:web|hpw)[o0]s\\/(\\d+(\\.\\d+)*)/i,a);var b={name:c.OS_MAP.WebOS};return a&&a.length&&(b.version=a),b}},{test:[/blackberry|\\bbb\\d+/i,/rim\\stablet/i],describe:function(a){a=d.default.getFirstMatch(/rim\\stablet\\sos\\s(\\d+(\\.\\d+)*)/i,a)||d.default.getFirstMatch(/blackberry\\d+\\/(\\d+([_\\s]\\d+)*)/i,a)||d.default.getFirstMatch(/\\bbb(\\d+)/i,a);return{name:c.OS_MAP.BlackBerry,\nversion:a}}},{test:[/bada/i],describe:function(a){a=d.default.getFirstMatch(/bada\\/(\\d+(\\.\\d+)*)/i,a);return{name:c.OS_MAP.Bada,version:a}}},{test:[/tizen/i],describe:function(a){a=d.default.getFirstMatch(/tizen[/\\s](\\d+(\\.\\d+)*)/i,a);return{name:c.OS_MAP.Tizen,version:a}}},{test:[/linux/i],describe:function(){return{name:c.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:c.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(a){a=d.default.getFirstMatch(/PlayStation 4[/\\s](\\d+(\\.\\d+)*)/i,\na);return{name:c.OS_MAP.PlayStation4,version:a}}}];p.exports=e.default},94:function(p,e,t){e.__esModule=!0;e.default=void 0;var h,d=(h=t(17))&&h.__esModule?h:{default:h},c=t(18);e.default=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(a){a=d.default.getFirstMatch(/(can-l01)/i,a)&&"Nova";var b={type:c.PLATFORMS_MAP.mobile,vendor:"Huawei"};return a&&(b.model=a),b}},{test:[/nexus\\s*(?:7|8|9|10).*/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet,\nvendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\\//],describe:function(){return{type:c.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:c.PLATFORMS_MAP.tablet}}},\n{test:function(a){var b=a.test(/ipod|iphone/i);a=a.test(/like (ipod|iphone)/i);return b&&!a},describe:function(a){a=d.default.getFirstMatch(/(ipod|iphone)/i,a);return{type:c.PLATFORMS_MAP.mobile,vendor:"Apple",model:a}}},{test:[/nexus\\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:c.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:c.PLATFORMS_MAP.mobile}}},{test:function(a){return"blackberry"===a.getBrowserName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.mobile,\nvendor:"BlackBerry"}}},{test:function(a){return"bada"===a.getBrowserName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.mobile}}},{test:function(a){return"windows phone"===a.getBrowserName()},describe:function(){return{type:c.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(a){var b=Number(String(a.getOSVersion()).split(".")[0]);return"android"===a.getOSName(!0)&&3<=b},describe:function(){return{type:c.PLATFORMS_MAP.tablet}}},{test:function(a){return"android"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.mobile}}},\n{test:function(a){return"macos"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(a){return"windows"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.desktop}}},{test:function(a){return"linux"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.desktop}}},{test:function(a){return"playstation 4"===a.getOSName(!0)},describe:function(){return{type:c.PLATFORMS_MAP.tv}}},{test:function(a){return"roku"===a.getOSName(!0)},\ndescribe:function(){return{type:c.PLATFORMS_MAP.tv}}}];p.exports=e.default},95:function(p,e,t){e.__esModule=!0;e.default=void 0;var h,d=(h=t(17))&&h.__esModule?h:{default:h},c=t(18);e.default=[{test:function(a){return"microsoft edge"===a.getBrowserName(!0)},describe:function(a){if(/\\sedg\\//i.test(a))return{name:c.ENGINE_MAP.Blink};a=d.default.getFirstMatch(/edge\\/(\\d+(\\.?_?\\d+)+)/i,a);return{name:c.ENGINE_MAP.EdgeHTML,version:a}}},{test:[/trident/i],describe:function(a){var b={name:c.ENGINE_MAP.Trident};\na=d.default.getFirstMatch(/trident\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:function(a){return a.test(/presto/i)},describe:function(a){var b={name:c.ENGINE_MAP.Presto};a=d.default.getFirstMatch(/presto\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:function(a){var b=a.test(/gecko/i);a=a.test(/like gecko/i);return b&&!a},describe:function(a){var b={name:c.ENGINE_MAP.Gecko};a=d.default.getFirstMatch(/gecko\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}},{test:[/(apple)?webkit\\/537\\.36/i],\ndescribe:function(){return{name:c.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(a){var b={name:c.ENGINE_MAP.WebKit};a=d.default.getFirstMatch(/webkit\\/(\\d+(\\.?_?\\d+)+)/i,a);return a&&(b.version=a),b}}];p.exports=e.default}})})},{}],2:[function(f,m){m.exports=f("bowser")},{bowser:1}]},{},[2])(2)});\n return module.exports; })();\nvar __lib__timsort = (function () { var exports = {}; var module = { exports: exports }; var define = void 0; (function(u){"object"===typeof exports&&"undefined"!==typeof module?module.exports=u():"function"===typeof define&&define.amd?define([],u):("undefined"!==typeof window?window:"undefined"!==typeof global?global:"undefined"!==typeof self?self:this).lib=u()})(function(){return function(){function u(x,C,z){function y(r,t){if(!C[r]){if(!x[r]){var D="function"==typeof require&&require;if(!t&&D)return D(r,!0);if(A)return A(r,!0);t=Error("Cannot find module \'"+r+"\'");throw t.code="MODULE_NOT_FOUND",t;}t=\nC[r]={exports:{}};x[r][0].call(t.exports,function(F){return y(x[r][1][F]||F)},t,t.exports,u,x,C,z)}return C[r].exports}for(var A="function"==typeof require&&require,E=0;E<z.length;E++)y(z[E]);return y}return u}()({1:[function(u,x,C){(function(z,y){if("undefined"!==typeof C)y(C);else{var A={};y(A);z.timsort=A}})(void 0,function(z){function y(g){return 1E5>g?100>g?10>g?0:1:1E4>g?1E3>g?2:3:4:1E7>g?1E6>g?5:6:1E9>g?1E8>g?7:8:9}function A(g,a){if(g===a)return 0;if(~~g===g&&~~a===a){if(0===g||0===a)return g<\na?-1:1;if(0>g||0>a){if(0<=a)return-1;if(0<=g)return 1;g=-g;a=-a}var h=y(g),c=y(a),e=0;h<c?(g*=G[c-h-1],a/=10,e=-1):h>c&&(a*=G[h-c-1],g/=10,e=1);return g===a?e:g<a?-1:1}g=String(g);a=String(a);return g===a?0:g<a?-1:1}function E(g,a,h,c){var e=a+1;if(e===h)return 1;if(0>c(g[e++],g[a])){for(;e<h&&0>c(g[e],g[e-1]);)e++;h=a;c=e;for(c--;h<c;){var k=g[h];g[h++]=g[c];g[c--]=k}}else for(;e<h&&0<=c(g[e],g[e-1]);)e++;return e-a}function r(g,a,h,c,e){for(c===a&&c++;c<h;c++){for(var k=g[c],d=a,b=c;d<b;){var f=\nd+b>>>1;0>e(k,g[f])?b=f:d=f+1}b=c-d;switch(b){case 3:g[d+3]=g[d+2];case 2:g[d+2]=g[d+1];case 1:g[d+1]=g[d];break;default:for(;0<b;)g[d+b]=g[d+b-1],b--}g[d]=k}}function t(g,a,h,c,e,k){var d=0,b=1;if(0<k(g,a[h+e])){for(c-=e;b<c&&0<k(g,a[h+e+b]);)d=b,b=(b<<1)+1,0>=b&&(b=c);b>c&&(b=c);d+=e;b+=e}else{for(c=e+1;b<c&&0>=k(g,a[h+e-b]);)d=b,b=(b<<1)+1,0>=b&&(b=c);b>c&&(b=c);c=d;d=e-b;b=e-c}for(d++;d<b;)e=d+(b-d>>>1),0<k(g,a[h+e])?d=e+1:b=e;return b}function D(g,a,h,c,e,k){var d=0,b=1;if(0>k(g,a[h+e])){for(c=\ne+1;b<c&&0>k(g,a[h+e-b]);)d=b,b=(b<<1)+1,0>=b&&(b=c);b>c&&(b=c);c=d;d=e-b;b=e-c}else{for(c-=e;b<c&&0<=k(g,a[h+e+b]);)d=b,b=(b<<1)+1,0>=b&&(b=c);b>c&&(b=c);d+=e;b+=e}for(d++;d<b;)e=d+(b-d>>>1),0>k(g,a[h+e])?b=e:d=e+1;return b}z.__esModule=!0;z.sort=function(g,a,h,c){if(!Array.isArray(g))throw new TypeError("Can only sort arrays");a?"function"!==typeof a&&(c=h,h=a,a=A):a=A;h||(h=0);c||(c=g.length);var e=c-h;if(!(2>e))if(e<F){var k=E(g,h,c,a);r(g,h,c,h+k,a)}else{var d=new H(g,a),b;k=e;for(b=0;k>=F;)b|=\nk&1,k>>=1;b=k+b;do{k=E(g,h,c,a);if(k<b){var f=e;f>b&&(f=b);r(g,h,h+f,h+k,a);k=f}d.pushRun(h,k);d.mergeRuns();e-=k;h+=k}while(0!==e);d.forceMergeRuns()}};var F=32,G=[1,10,100,1E3,1E4,1E5,1E6,1E7,1E8,1E9],H=function(){function g(a,h){if(!(this instanceof g))throw new TypeError("Cannot call a class as a function");this.compare=this.array=null;this.minGallop=7;this.length=0;this.tmpStorageLength=256;this.stackLength=0;this.runLength=this.runStart=null;this.stackSize=0;this.array=a;this.compare=h;this.length=\na.length;512>this.length&&(this.tmpStorageLength=this.length>>>1);this.tmp=Array(this.tmpStorageLength);this.stackLength=120>this.length?5:1542>this.length?10:119151>this.length?19:40;this.runStart=Array(this.stackLength);this.runLength=Array(this.stackLength)}g.prototype.pushRun=function(a,h){this.runStart[this.stackSize]=a;this.runLength[this.stackSize]=h;this.stackSize+=1};g.prototype.mergeRuns=function(){for(;1<this.stackSize;){var a=this.stackSize-2;if(1<=a&&this.runLength[a-1]<=this.runLength[a]+\nthis.runLength[a+1]||2<=a&&this.runLength[a-2]<=this.runLength[a]+this.runLength[a-1])this.runLength[a-1]<this.runLength[a+1]&&a--;else if(this.runLength[a]>this.runLength[a+1])break;this.mergeAt(a)}};g.prototype.forceMergeRuns=function(){for(;1<this.stackSize;){var a=this.stackSize-2;0<a&&this.runLength[a-1]<this.runLength[a+1]&&a--;this.mergeAt(a)}};g.prototype.mergeAt=function(a){var h=this.compare,c=this.array,e=this.runStart[a],k=this.runLength[a],d=this.runStart[a+1],b=this.runLength[a+1];this.runLength[a]=\nk+b;a===this.stackSize-3&&(this.runStart[a+1]=this.runStart[a+2],this.runLength[a+1]=this.runLength[a+2]);this.stackSize--;a=D(c[d],c,e,k,0,h);e+=a;k-=a;0!==k&&(b=t(c[e+k-1],c,d,b,b-1,h),0!==b&&(k<=b?this.mergeLow(e,k,d,b):this.mergeHigh(e,k,d,b)))};g.prototype.mergeLow=function(a,h,c,e){var k=this.compare,d=this.array,b=this.tmp,f;for(f=0;f<h;f++)b[f]=d[a+f];var m=0;d[a++]=d[c++];if(0===--e)for(f=0;f<h;f++)d[a+f]=b[m+f];else if(1===h){for(f=0;f<e;f++)d[a+f]=d[c+f];d[a+e]=b[m]}else{for(var p=this.minGallop;;){var l=\n0,n=0,q=!1;do if(0>k(d[c],b[m])){if(d[a++]=d[c++],n++,l=0,0===--e){q=!0;break}}else if(d[a++]=b[m++],l++,n=0,1===--h){q=!0;break}while((l|n)<p);if(q)break;do{l=D(d[c],b,m,h,0,k);if(0!==l){for(f=0;f<l;f++)d[a+f]=b[m+f];a+=l;m+=l;h-=l;if(1>=h){q=!0;break}}d[a++]=d[c++];if(0===--e){q=!0;break}n=t(b[m],d,c,e,0,k);if(0!==n){for(f=0;f<n;f++)d[a+f]=d[c+f];a+=n;c+=n;e-=n;if(0===e){q=!0;break}}d[a++]=b[m++];if(1===--h){q=!0;break}p--}while(7<=l||7<=n);if(q)break;0>p&&(p=0);p+=2}this.minGallop=p;1>p&&(this.minGallop=\n1);if(1===h){for(f=0;f<e;f++)d[a+f]=d[c+f];d[a+e]=b[m]}else{if(0===h)throw Error("mergeLow preconditions were not respected");for(f=0;f<h;f++)d[a+f]=b[m+f]}}};g.prototype.mergeHigh=function(a,h,c,e){var k=this.compare,d=this.array,b=this.tmp,f;for(f=0;f<e;f++)b[f]=d[c+f];var m=a+h-1,p=e-1;c=c+e-1;d[c--]=d[m--];if(0===--h){var l=c-(e-1);for(f=0;f<e;f++)d[l+f]=b[f]}else if(1===e){c-=h;var n=c+1;l=m-h+1;for(f=h-1;0<=f;f--)d[n+f]=d[l+f];d[c]=b[p]}else{for(var q=this.minGallop;;){var v=0,w=0,B=!1;do if(0>\nk(b[p],d[m])){if(d[c--]=d[m--],v++,w=0,0===--h){B=!0;break}}else if(d[c--]=b[p--],w++,v=0,1===--e){B=!0;break}while((v|w)<q);if(B)break;do{v=h-D(b[p],d,a,h,h-1,k);if(0!==v){c-=v;m-=v;h-=v;n=c+1;l=m+1;for(f=v-1;0<=f;f--)d[n+f]=d[l+f];if(0===h){B=!0;break}}d[c--]=b[p--];if(1===--e){B=!0;break}w=e-t(d[m],b,0,e,e-1,k);if(0!==w){c-=w;p-=w;e-=w;n=c+1;l=p+1;for(f=0;f<w;f++)d[n+f]=b[l+f];if(1>=e){B=!0;break}}d[c--]=d[m--];if(0===--h){B=!0;break}q--}while(7<=v||7<=w);if(B)break;0>q&&(q=0);q+=2}this.minGallop=\nq;1>q&&(this.minGallop=1);if(1===e){c-=h;n=c+1;l=m-h+1;for(f=h-1;0<=f;f--)d[n+f]=d[l+f];d[c]=b[p]}else{if(0===e)throw Error("mergeHigh preconditions were not respected");l=c-(e-1);for(f=0;f<e;f++)d[l+f]=b[f]}}};return g}()})},{}],2:[function(u,x){x.exports=u("./build/timsort.js")},{"./build/timsort.js":1}],3:[function(u,x){x.exports=u("timsort")},{timsort:2}]},{},[3])(3)});\n return module.exports; })(); (function () { var n;function aa(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}var ba="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a};\nfunction da(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");}var r=da(this);function t(a,b){if(b)a:{var c=r;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];if(!(e in c))break a;c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&ba(c,a,{configurable:!0,writable:!0,value:b})}}\nt("Symbol",function(a){function b(f){if(this instanceof b)throw new TypeError("Symbol is not a constructor");return new c(d+(f||"")+"_"+e++,f)}function c(f,g){this.g=f;ba(this,"description",{configurable:!0,writable:!0,value:g})}if(a)return a;c.prototype.toString=function(){return this.g};var d="jscomp_symbol_"+(1E9*Math.random()>>>0)+"_",e=0;return b});\nt("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=r[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&ba(d.prototype,a,{configurable:!0,writable:!0,value:function(){return ea(aa(this))}})}return a});function ea(a){a={next:a};a[Symbol.iterator]=function(){return this};return a}\nfunction v(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];if(b)return b.call(a);if("number"==typeof a.length)return{next:aa(a)};throw Error(String(a)+" is not an iterable or ArrayLike");}function w(a){if(!(a instanceof Array)){a=v(a);for(var b,c=[];!(b=a.next()).done;)c.push(b.value);a=c}return a}var fa="function"==typeof Object.create?Object.create:function(a){function b(){}b.prototype=a;return new b},ha;\nif("function"==typeof Object.setPrototypeOf)ha=Object.setPrototypeOf;else{var ia;a:{var ja={a:!0},ka={};try{ka.__proto__=ja;ia=ka.a;break a}catch(a){}ia=!1}ha=ia?function(a,b){a.__proto__=b;if(a.__proto__!==b)throw new TypeError(a+" is not extensible");return a}:null}var la=ha;\nfunction ma(a,b){a.prototype=fa(b.prototype);a.prototype.constructor=a;if(la)la(a,b);else for(var c in b)if("prototype"!=c)if(Object.defineProperties){var d=Object.getOwnPropertyDescriptor(b,c);d&&Object.defineProperty(a,c,d)}else a[c]=b[c];a.Ra=b.prototype}function na(){this.s=!1;this.g=null;this.P=void 0;this.i=1;this.I=0;this.l=null}function oa(a){if(a.s)throw new TypeError("Generator is already running");a.s=!0}na.prototype.F=function(a){this.P=a};function pa(a,b){a.l={Na:b,Oa:!0};a.i=a.I}\nna.prototype.return=function(a){this.l={return:a};this.i=this.I};function qa(a,b,c){a.i=c;return{value:b}}function ra(a){this.g=new na;this.i=a}function sa(a,b){oa(a.g);var c=a.g.g;if(c)return ta(a,"return"in c?c["return"]:function(d){return{value:d,done:!0}},b,a.g.return);a.g.return(b);return ua(a)}\nfunction ta(a,b,c,d){try{var e=b.call(a.g.g,c);if(!(e instanceof Object))throw new TypeError("Iterator result "+e+" is not an object");if(!e.done)return a.g.s=!1,e;var f=e.value}catch(g){return a.g.g=null,pa(a.g,g),ua(a)}a.g.g=null;d.call(a.g,f);return ua(a)}function ua(a){for(;a.g.i;)try{var b=a.i(a.g);if(b)return a.g.s=!1,{value:b.value,done:!1}}catch(c){a.g.P=void 0,pa(a.g,c)}a.g.s=!1;if(a.g.l){b=a.g.l;a.g.l=null;if(b.Oa)throw b.Na;return{value:b.return,done:!0}}return{value:void 0,done:!0}}\nfunction va(a){this.next=function(b){oa(a.g);a.g.g?b=ta(a,a.g.g.next,b,a.g.F):(a.g.F(b),b=ua(a));return b};this.throw=function(b){oa(a.g);a.g.g?b=ta(a,a.g.g["throw"],b,a.g.F):(pa(a.g,b),b=ua(a));return b};this.return=function(b){return sa(a,b)};this[Symbol.iterator]=function(){return this}}function wa(a){function b(d){return a.next(d)}function c(d){return a.throw(d)}return new Promise(function(d,e){function f(g){g.done?d(g.value):Promise.resolve(g.value).then(b,c).then(f,e)}f(a.next())})}\nfunction x(){for(var a=Number(this),b=[],c=a;c<arguments.length;c++)b[c-a]=arguments[c];return b}\nt("Promise",function(a){function b(g){this.i=0;this.l=void 0;this.g=[];this.P=!1;var h=this.s();try{g(h.resolve,h.reject)}catch(k){h.reject(k)}}function c(){this.g=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.i=function(g){if(null==this.g){this.g=[];var h=this;this.l(function(){h.F()})}this.g.push(g)};var e=r.setTimeout;c.prototype.l=function(g){e(g,0)};c.prototype.F=function(){for(;this.g&&this.g.length;){var g=this.g;this.g=[];for(var h=0;h<g.length;++h){var k=\ng[h];g[h]=null;try{k()}catch(l){this.s(l)}}}this.g=null};c.prototype.s=function(g){this.l(function(){throw g;})};b.prototype.s=function(){function g(l){return function(m){k||(k=!0,l.call(h,m))}}var h=this,k=!1;return{resolve:g(this.Fa),reject:g(this.F)}};b.prototype.Fa=function(g){if(g===this)this.F(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.Ha(g);else{a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.ja(g):\nthis.I(g)}};b.prototype.ja=function(g){var h=void 0;try{h=g.then}catch(k){this.F(k);return}"function"==typeof h?this.Ia(h,g):this.I(g)};b.prototype.F=function(g){this.ba(2,g)};b.prototype.I=function(g){this.ba(1,g)};b.prototype.ba=function(g,h){if(0!=this.i)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.i);this.i=g;this.l=h;2===this.i&&this.Ga();this.ha()};b.prototype.Ga=function(){var g=this;e(function(){if(g.ia()){var h=r.console;"undefined"!==typeof h&&h.error(g.l)}},\n1)};b.prototype.ia=function(){if(this.P)return!1;var g=r.CustomEvent,h=r.Event,k=r.dispatchEvent;if("undefined"===typeof k)return!0;"function"===typeof g?g=new g("unhandledrejection",{cancelable:!0}):"function"===typeof h?g=new h("unhandledrejection",{cancelable:!0}):(g=r.document.createEvent("CustomEvent"),g.initCustomEvent("unhandledrejection",!1,!0,g));g.promise=this;g.reason=this.l;return k(g)};b.prototype.ha=function(){if(null!=this.g){for(var g=0;g<this.g.length;++g)f.i(this.g[g]);this.g=null}};\nvar f=new c;b.prototype.Ha=function(g){var h=this.s();g.pa(h.resolve,h.reject)};b.prototype.Ia=function(g,h){var k=this.s();try{g.call(h,k.resolve,k.reject)}catch(l){k.reject(l)}};b.prototype.then=function(g,h){function k(q,u){return"function"==typeof q?function(z){try{l(q(z))}catch(B){m(B)}}:u}var l,m,p=new b(function(q,u){l=q;m=u});this.pa(k(g,l),k(h,m));return p};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.pa=function(g,h){function k(){switch(l.i){case 1:g(l.l);break;\ncase 2:h(l.l);break;default:throw Error("Unexpected state: "+l.i);}}var l=this;null==this.g?f.i(k):this.g.push(k);this.P=!0};b.resolve=d;b.reject=function(g){return new b(function(h,k){k(g)})};b.race=function(g){return new b(function(h,k){for(var l=v(g),m=l.next();!m.done;m=l.next())d(m.value).pa(h,k)})};b.all=function(g){var h=v(g),k=h.next();return k.done?d([]):new b(function(l,m){function p(z){return function(B){q[z]=B;u--;0==u&&l(q)}}var q=[],u=0;do q.push(void 0),u++,d(k.value).pa(p(q.length-\n1),m),k=h.next();while(!k.done)})};return b});function xa(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return{value:b(f,a[f]),done:!1}}d=!0;return{done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e}t("Array.prototype.keys",function(a){return a?a:function(){return xa(this,function(b){return b})}});t("Number.MAX_SAFE_INTEGER",function(){return 9007199254740991});\nfunction ya(a,b,c){a instanceof String&&(a=String(a));for(var d=a.length,e=0;e<d;e++){var f=a[e];if(b.call(c,f,e,a))return{Da:e,Ea:f}}return{Da:-1,Ea:void 0}}t("Array.prototype.find",function(a){return a?a:function(b,c){return ya(this,b,c).Ea}});\nfunction za(a,b,c){if(null==a)throw new TypeError("The \'this\' value for String.prototype."+c+" must not be null or undefined");if(b instanceof RegExp)throw new TypeError("First argument to String.prototype."+c+" must not be a regular expression");return a+""}t("String.prototype.startsWith",function(a){return a?a:function(b,c){var d=za(this,b,"startsWith"),e=d.length,f=b.length;c=Math.max(0,Math.min(c|0,d.length));for(var g=0;g<f&&c<e;)if(d[c++]!=b[g++])return!1;return g>=f}});\nfunction y(a,b){return Object.prototype.hasOwnProperty.call(a,b)}\nt("WeakMap",function(a){function b(k){this.g=(h+=Math.random()+1).toString();if(k){k=v(k);for(var l;!(l=k.next()).done;)l=l.value,this.set(l[0],l[1])}}function c(){}function d(k){var l=typeof k;return"object"===l&&null!==k||"function"===l}function e(k){if(!y(k,g)){var l=new c;ba(k,g,{value:l})}}function f(k){var l=Object[k];l&&(Object[k]=function(m){if(m instanceof c)return m;Object.isExtensible(m)&&e(m);return l(m)})}if(function(){if(!a||!Object.seal)return!1;try{var k=Object.seal({}),l=Object.seal({}),\nm=new a([[k,2],[l,3]]);if(2!=m.get(k)||3!=m.get(l))return!1;m.delete(k);m.set(l,4);return!m.has(k)&&4==m.get(l)}catch(p){return!1}}())return a;var g="$jscomp_hidden_"+Math.random();f("freeze");f("preventExtensions");f("seal");var h=0;b.prototype.set=function(k,l){if(!d(k))throw Error("Invalid WeakMap key");e(k);if(!y(k,g))throw Error("WeakMap key fail: "+k);k[g][this.g]=l;return this};b.prototype.get=function(k){return d(k)&&y(k,g)?k[g][this.g]:void 0};b.prototype.has=function(k){return d(k)&&y(k,\ng)&&y(k[g],this.g)};b.prototype.delete=function(k){return d(k)&&y(k,g)&&y(k[g],this.g)?delete k[g][this.g]:!1};return b});\nt("Map",function(a){function b(){var h={};return h.V=h.next=h.head=h}function c(h,k){var l=h[1];return ea(function(){if(l){for(;l.head!=h[1];)l=l.V;for(;l.next!=l.head;)return l=l.next,{done:!1,value:k(l)};l=null}return{done:!0,value:void 0}})}function d(h,k){var l=k&&typeof k;"object"==l||"function"==l?f.has(k)?l=f.get(k):(l=""+ ++g,f.set(k,l)):l="p_"+k;var m=h[0][l];if(m&&y(h[0],l))for(h=0;h<m.length;h++){var p=m[h];if(k!==k&&p.key!==p.key||k===p.key)return{id:l,list:m,index:h,K:p}}return{id:l,\nlist:m,index:-1,K:void 0}}function e(h){this[0]={};this[1]=b();this.size=0;if(h){h=v(h);for(var k;!(k=h.next()).done;)k=k.value,this.set(k[0],k[1])}}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return!1;try{var h=Object.seal({x:4}),k=new a(v([[h,"s"]]));if("s"!=k.get(h)||1!=k.size||k.get({x:4})||k.set({x:4},"t")!=k||2!=k.size)return!1;var l=k.entries(),m=l.next();if(m.done||m.value[0]!=h||"s"!=m.value[1])return!1;m=l.next();return m.done||4!=m.value[0].x||\n"t"!=m.value[1]||!l.next().done?!1:!0}catch(p){return!1}}())return a;var f=new WeakMap;e.prototype.set=function(h,k){h=0===h?0:h;var l=d(this,h);l.list||(l.list=this[0][l.id]=[]);l.K?l.K.value=k:(l.K={next:this[1],V:this[1].V,head:this[1],key:h,value:k},l.list.push(l.K),this[1].V.next=l.K,this[1].V=l.K,this.size++);return this};e.prototype.delete=function(h){h=d(this,h);return h.K&&h.list?(h.list.splice(h.index,1),h.list.length||delete this[0][h.id],h.K.V.next=h.K.next,h.K.next.V=h.K.V,h.K.head=null,\nthis.size--,!0):!1};e.prototype.clear=function(){this[0]={};this[1]=this[1].V=b();this.size=0};e.prototype.has=function(h){return!!d(this,h).K};e.prototype.get=function(h){return(h=d(this,h).K)&&h.value};e.prototype.entries=function(){return c(this,function(h){return[h.key,h.value]})};e.prototype.keys=function(){return c(this,function(h){return h.key})};e.prototype.values=function(){return c(this,function(h){return h.value})};e.prototype.forEach=function(h,k){for(var l=this.entries(),m;!(m=l.next()).done;)m=\nm.value,h.call(k,m[1],m[0],this)};e.prototype[Symbol.iterator]=e.prototype.entries;var g=0;return e});\nt("Set",function(a){function b(c){this.g=new Map;if(c){c=v(c);for(var d;!(d=c.next()).done;)this.add(d.value)}this.size=this.g.size}if(function(){if(!a||"function"!=typeof a||!a.prototype.entries||"function"!=typeof Object.seal)return!1;try{var c=Object.seal({x:4}),d=new a(v([c]));if(!d.has(c)||1!=d.size||d.add(c)!=d||1!=d.size||d.add({x:4})!=d||2!=d.size)return!1;var e=d.entries(),f=e.next();if(f.done||f.value[0]!=c||f.value[1]!=c)return!1;f=e.next();return f.done||f.value[0]==c||4!=f.value[0].x||\nf.value[1]!=f.value[0]?!1:e.next().done}catch(g){return!1}}())return a;b.prototype.add=function(c){c=0===c?0:c;this.g.set(c,c);this.size=this.g.size;return this};b.prototype.delete=function(c){c=this.g.delete(c);this.size=this.g.size;return c};b.prototype.clear=function(){this.g.clear();this.size=0};b.prototype.has=function(c){return this.g.has(c)};b.prototype.entries=function(){return this.g.entries()};b.prototype.values=function(){return this.g.values()};b.prototype.keys=b.prototype.values;b.prototype[Symbol.iterator]=\nb.prototype.values;b.prototype.forEach=function(c,d){var e=this;this.g.forEach(function(f){return c.call(d,f,f,e)})};return b});t("String.fromCodePoint",function(a){return a?a:function(b){for(var c="",d=0;d<arguments.length;d++){var e=Number(arguments[d]);if(0>e||1114111<e||e!==Math.floor(e))throw new RangeError("invalid_code_point "+e);65535>=e?c+=String.fromCharCode(e):(e-=65536,c+=String.fromCharCode(e>>>10&1023|55296),c+=String.fromCharCode(e&1023|56320))}return c}});\nt("Math.sign",function(a){return a?a:function(b){b=Number(b);return 0===b||isNaN(b)?b:0<b?1:-1}});var Aa="function"==typeof Object.assign?Object.assign:function(a,b){for(var c=1;c<arguments.length;c++){var d=arguments[c];if(d)for(var e in d)y(d,e)&&(a[e]=d[e])}return a};t("Object.assign",function(a){return a||Aa});t("Array.prototype.findIndex",function(a){return a?a:function(b,c){return ya(this,b,c).Da}});\nt("Object.is",function(a){return a?a:function(b,c){return b===c?0!==b||1/b===1/c:b!==b&&c!==c}});t("Array.prototype.includes",function(a){return a?a:function(b,c){var d=this;d instanceof String&&(d=String(d));var e=d.length;c=c||0;for(0>c&&(c=Math.max(c+e,0));c<e;c++){var f=d[c];if(f===b||Object.is(f,b))return!0}return!1}});t("String.prototype.includes",function(a){return a?a:function(b,c){return-1!==za(this,b,"includes").indexOf(b,c||0)}});function Ba(a){return 0<a.length?a[a.length-1]:void 0};function Da(){if("object"===typeof self)return self;if("object"===typeof window)return window;if("object"===typeof global)return global;throw Error("Unable to get global this");}function A(a,b){return 0>a?0:a>b?b:a}function Ea(a,b,c){Array.isArray(a)?b=[]:b||(b={});if("object"===typeof a&&null!==a)for(var d=Object.keys(a),e=0;e<d.length;e++){var f=d[e],g=a[f];null!==g&&"object"===typeof g?b[f]=Ea(g,b[f],c):"undefined"===typeof g?c&&delete b[f]:b[f]=g}return b}var Fa=Array.isArray;\nfunction Ga(a){return"number"===typeof a&&!isNaN(a)}function C(a){return"string"===typeof a}function Ha(a){return a.replace(/([A-Z])/g,function(b){return"-"+b.toLowerCase()}).replace(/^ms-/,"-ms-")}function Ia(a,b,c,d,e){return(e-d)/(c-b)*(a-b)+d}function Ja(a){throw Error("assertNever called with "+a);};var Ka=new Uint16Array(1);Ka[0]=4660;new Uint8Array(Ka.buffer);var La=[Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array];function Ma(a,b){var c=this.length;"number"!==typeof a&&(a=0);"number"!==typeof b&&(b=c);0>a&&(a=c+a);0>b&&(b=c+b);c=this.constructor;a=a*c.BYTES_PER_ELEMENT+this.byteOffset;b=b*c.BYTES_PER_ELEMENT+this.byteOffset;return new c(this.buffer.slice(a,b))}\nif(!("slice"in La[0].prototype))for(var Na=0;Na<La.length;Na++)Object.defineProperty(La[Na].prototype,"slice",{configurable:!0,value:Ma,writable:!0});function D(a,b,c){var d=Error.call(this,"["+a+"] "+b+" :: "+(c||""));this.message=d.message;"stack"in d&&(this.stack=d.stack);this.namespace=a;this.errorType=b;this.errorMessage=c||""}ma(D,Error);D.isColibrioError=Oa;D.isColibrioAbortedError=Pa;function Oa(a){return a instanceof D||a&&C(a.errorType)&&C(a.namespace)}function Pa(a){return Oa(a)&&"ABORTED"===a.errorType||a instanceof DOMException&&(a.code===DOMException.ABORT_ERR||"AbortError"===a.name)};function Qa(){}Qa.prototype.logError=function(){this.g.apply(this,["error"].concat(w(x.apply(0,arguments))))};Qa.prototype.logInfo=function(){this.g.apply(this,["info"].concat(w(x.apply(0,arguments))))};Qa.prototype.logWarning=function(){this.g.apply(this,["warn"].concat(w(x.apply(0,arguments))))};Qa.prototype.g=function(a){var b=x.apply(1,arguments);"undefined"!==typeof console&&console[a]&&console[a].apply(console,w(b))};var Ra;function E(){Ra.logError.apply(Ra,w(x.apply(0,arguments)))}function Sa(){Ra.logWarning.apply(Ra,w(x.apply(0,arguments)))}var Ta=!1;(function(a){if(!Ta){Ta=!0;var b=Da();b&&"function"===typeof b.addEventListener&&b.addEventListener("unhandledrejection",function(c){E("Unhandled Promise rejection",c.reason);c.cancelable&&c.preventDefault()})}Ra=a})(new Qa);var Ua=__lib__timsort;function F(a,b){D.call(this,"colibrio.readingsystem.formatadapter.epub.worker",a,b)}ma(F,D);function Va(){this.L=0;this.i={B:null,A:null,H:null};this.g={B:null,A:null,H:this.i};this.i.A=this.g}n=Va.prototype;n.every=function(a){for(var b=this.i.A,c=!0;b!==this.g&&c;){var d=b.A;c=a(b);b=null===b.A?d:b.A}return c};n.find=function(a){for(var b=this.i.A,c=null;b!==this.g&&null===c;){var d=b.A;a(b)&&(c=b);b=null===b.A?d:b.A}return c};n.forEach=function(a){for(var b=this.i.A;b!==this.g;){var c=b.A;a(b);b=null===b.A?c:b.A}};\nn.pop=function(){if(0===this.L)var a=null;else a=this.g.H,Wa(this,a);return a?a.B:null};n.push=function(a){a={B:a,A:this.g,H:this.g.H};a.H.A=a;this.g.H=a;this.L++;return a};n.shift=function(){if(0===this.L)var a=null;else a=this.i.A,Wa(this,a);return a?a.B:null};n.size=function(){return this.L};n.unshift=function(a){a={B:a,A:this.i.A,H:this.i};a.A.H=a;this.i.A=a;this.L++;return a};function Wa(a,b){if(b.H&&b.A){var c=b.H,d=b.A;c.A=d;d.H=c;b.A=null;b.H=null;a.L--}};function G(a){this.o=a;this.g=new Va;this.i=new Map;this.l=0}function H(a,b){var c=a.i.get(b);c&&(a.i.delete(b),Wa(a.g,c),a.l-=c.B.L)}G.prototype.find=function(a){var b=this.g;b=b.L?b.g.H:null;for(var c;b&&void 0===c;)a(b.B.h,b.B.S)?c=b.B.h:b=(b=b.H)&&this.g.i!==b?b:null;b&&Xa(this,b,!1);return c};G.prototype.get=function(a){return(a=this.i.get(a))?(Xa(this,a,!1),a.B.h):null};G.prototype.has=function(a){return this.i.has(a)};\nG.prototype.set=function(a,b,c){c>this.o.ua||!this.o.oa&&c>this.o.na||Ya(this,a,b,c,!1)};function Ya(a,b,c,d,e){var f=a.o.da;c={S:b,U:e?1:0,L:d,Aa:f?Date.now()+f:0,h:c};H(a,b);c=a.g.push(c);a.i.set(b,c);a.l+=d;Za(a)}function Za(a){var b=a.o.na,c=a.o.oa,d=a.o.da;if(d&&a.l>b&&a.g.size()>c){d=d?Date.now():0;var e=a.g;for(e=e.L?e.i.A:null;a.l>b&&a.g.size()>c&&e&&e.B.Aa<=d;){var f=(f=e.A)&&a.g.g!==f?f:null;0>=e.B.U&&H(a,e.B.S);e=f}}}\nfunction Xa(a,b,c){var d=a.o.da,e=a.g;b.H&&b.A&&(Wa(e,b),b.H=e.g.H,b.A=e.g,b.H.A=b,e.g.H=b,e.L++);d&&(b.B.Aa=Date.now()+d);(d||c)&&Za(a)};function $a(){this.g=new Map;this.i=new G({ua:Number.MAX_SAFE_INTEGER,na:16E6,oa:2,da:0})}function ab(){bb||(bb=new $a);return bb}function cb(a,b){var c=a.g.get(b);c&&(c.U--,0===c.U&&c.ea.forEach(function(d){var e=a.i;if(d=e.i.get(d))--d.B.U,0>=d.B.U&&Za(e)}),a.g.delete(b))}function db(a,b,c,d){if((b=a.g.get(b))&&!b.ea.has(c)){b.ea.add(c);a=a.i;b=2*d.length;var e=a.i.get(c);e?(e.B.U++,e.B.h=d,a.l+=b-e.B.L,e.B.L=b,Xa(a,e,!0)):Ya(a,c,d,b,!0)}}var bb=null;var eb={aliceblue:"#f0f8ff",antiquewhite:"#faebd7",aqua:"#00ffff",aquamarine:"#7fffd4",azure:"#f0ffff",beige:"#f5f5dc",bisque:"#ffe4c4",black:"#000000",blanchedalmond:"#ffebcd",blue:"#0000ff",blueviolet:"#8a2be2",brown:"#a52a2a",burlywood:"#deb887",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",cornflowerblue:"#6495ed",cornsilk:"#fff8dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkgray:"#a9a9a9",darkgreen:"#006400",\ndarkgrey:"#a9a9a9",darkkhaki:"#bdb76b",darkmagenta:"#8b008b",darkolivegreen:"#556b2f",darkorange:"#ff8c00",darkorchid:"#9932cc",darkred:"#8b0000",darksalmon:"#e9967a",darkseagreen:"#8fbc8f",darkslateblue:"#483d8b",darkslategray:"#2f4f4f",darkslategrey:"#2f4f4f",darkturquoise:"#00ced1",darkviolet:"#9400d3",deeppink:"#ff1493",deepskyblue:"#00bfff",dimgray:"#696969",dimgrey:"#696969",dodgerblue:"#1e90ff",firebrick:"#b22222",floralwhite:"#fffaf0",forestgreen:"#228b22",fuchsia:"#ff00ff",gainsboro:"#dcdcdc",\nghostwhite:"#f8f8ff",gold:"#ffd700",goldenrod:"#daa520",gray:"#808080",green:"#008000",greenyellow:"#adff2f",grey:"#808080",honeydew:"#f0fff0",hotpink:"#ff69b4",indianred:"#cd5c5c",indigo:"#4b0082",ivory:"#fffff0",khaki:"#f0e68c",lavender:"#e6e6fa",lavenderblush:"#fff0f5",lawngreen:"#7cfc00",lemonchiffon:"#fffacd",lightblue:"#add8e6",lightcoral:"#f08080",lightcyan:"#e0ffff",lightgoldenrodyellow:"#fafad2",lightgray:"#d3d3d3",lightgreen:"#90ee90",lightgrey:"#d3d3d3",lightpink:"#ffb6c1",lightsalmon:"#ffa07a",\nlightseagreen:"#20b2aa",lightskyblue:"#87cefa",lightslategray:"#778899",lightslategrey:"#778899",lightsteelblue:"#b0c4de",lightyellow:"#ffffe0",lime:"#00ff00",limegreen:"#32cd32",linen:"#faf0e6",magenta:"#ff00ff",maroon:"#800000",mediumaquamarine:"#66cdaa",mediumblue:"#0000cd",mediumorchid:"#ba55d3",mediumpurple:"#9370db",mediumseagreen:"#3cb371",mediumslateblue:"#7b68ee",mediumspringgreen:"#00fa9a",mediumturquoise:"#48d1cc",mediumvioletred:"#c71585",midnightblue:"#191970",mintcream:"#f5fffa",mistyrose:"#ffe4e1",\nmoccasin:"#ffe4b5",navajowhite:"#ffdead",navy:"#000080",oldlace:"#fdf5e6",olive:"#808000",olivedrab:"#6b8e23",orange:"#ffa500",orangered:"#ff4500",orchid:"#da70d6",palegoldenrod:"#eee8aa",palegreen:"#98fb98",paleturquoise:"#afeeee",palevioletred:"#db7093",papayawhip:"#ffefd5",peachpuff:"#ffdab9",peru:"#cd853f",pink:"#ffc0cb",plum:"#dda0dd",powderblue:"#b0e0e6",purple:"#800080",rebeccapurple:"#663399",red:"#ff0000",rosybrown:"#bc8f8f",royalblue:"#4169e1",saddlebrown:"#8b4513",salmon:"#fa8072",sandybrown:"#f4a460",\nseagreen:"#2e8b57",seashell:"#fff5ee",sienna:"#a0522d",silver:"#c0c0c0",skyblue:"#87ceeb",slateblue:"#6a5acd",slategray:"#708090",slategrey:"#708090",snow:"#fffafa",springgreen:"#00ff7f",steelblue:"#4682b4",tan:"#d2b48c",teal:"#008080",thistle:"#d8bfd8",tomato:"#ff6347",turquoise:"#40e0d0",violet:"#ee82ee",wheat:"#f5deb3",white:"#ffffff",whitesmoke:"#f5f5f5",yellow:"#ffff00",yellowgreen:"#9acd32"};function fb(){this.alpha=1;this.g=this.i=null}function I(a){a=a.match(/^#?([a-f0-9]{8}|[a-f0-9]{6}|[a-f0-9]{3,4})$/i);if(!a||!a[1])return null;var b=a[1];if(3===b.length||4===b.length)b=b.split("").map(function(f){return f+f}).join("");var c=parseInt(b,16),d=c>>16&255,e=c>>8&255;a=c&255;8===b.length?(b=J(c>>24&255,d,e),b.alpha=A(a/255,1)):b=J(d,e,a);return b}function J(a,b,c,d){var e=new fb;gb(e,a,b,c);Ga(d)&&(e.alpha=A(d,1));return e}function hb(){var a=new fb;a.g=[0,0,0];a.alpha=0;return a}\nfunction ib(a){var b=new fb;b.alpha=a.alpha;a.g&&(b.g=a.g.slice());a.i&&(b.i=a.i.slice());return b}function jb(a){kb(a);return a.i[2]}function lb(a){if(null===a.g){var b=a.i[0]/360,c=a.i[1]/100,d=a.i[2]/100;if(0===c){var e=255*d;a.g=[e,e,e]}else{c=.5>d?d*(1+c):d+c-d*c;d=2*d-c;var f=[0,0,0];for(var g=0;3>g;g++)e=b+1/3*-(g-1),0>e&&e++,1<e&&e--,e=1>6*e?d+6*(c-d)*e:1>2*e?c:2>3*e?d+(c-d)*(2/3-e)*6:d,f[g]=255*e;a.g=f}}return a.g}\nfunction mb(a,b){a.alpha=b.alpha;a.g=b.g?b.g.slice(0):null;a.i=b.i?b.i.slice(0):null}function gb(a,b,c,d){a.g=[A(b,255),A(c,255),A(d,255)];a.i=null}fb.prototype.toString=function(){var a=this.alpha;if(0===a)a="transparent";else if(this.g){var b=nb(this.g).join(", ");a=1>a?"rgba("+b+", "+a+")":"rgb("+b+")"}else b=nb(this.i),b=b[0]+", "+b[1]+"%, "+b[2]+"%",a=1>a?"hsla("+b+", "+a+")":"hsl("+b+")";return a};\nfunction kb(a){if(null===a.i){var b=a.g[0]/255,c=a.g[1]/255,d=a.g[2]/255,e=Math.min(b,c,d),f=Math.max(b,c,d),g=f-e;b=Math.min(60*(f===e?0:b===f?(c-d)/g:c===f?2+(d-b)/g:4+(b-c)/g),360);0>b&&(b+=360);c=(e+f)/2;a.i=[b,100*(f===e?0:.5>=c?g/(f+e):g/(2-f-e)),100*c]}}function qb(a){var b=a[0],c=a[1],d=a[2],e=Math.min(b,c,d);a=Math.max(b,c,d);var f=a-e;b=Math.min(60*(a===e?0:b===a?(c-d)/f:c===a?2+(d-b)/f:4+(b-c)/f),360);0>b&&(b+=360);return[b,0===a?0:f/a*1E3/10,a/255*1E3/10]}\nfunction rb(a){var b=a[0],c=a[1]/100;a=a[2]/100;var d=c,e=Math.max(a,.01);a*=2;c*=1>=a?a:2-a;d*=1>=e?e:2-e;return[b,100*(0===a?2*d/(e+d):2*c/(a+c)),(a+c)/2*100]}function nb(a){return a.map(function(b){return Math.round(b)})};function sb(a,b,c){return{C:!1,m:a,v:b,j:70,h:c}}function tb(a,b,c){return{C:!1,m:a,v:b,j:71,h:c}}function K(a,b){return{j:a,h:b}}function ub(a,b,c){return{C:!1,ma:c,m:a.toLowerCase(),j:81,h:b}}function vb(a){return{C:!1,v:[],j:82,Ca:a,h:[]}}function wb(a,b){for(var c=[],d=0;d<b.length;d++)0<d&&(c.push(L(22,",")),c.push(M())),c.push(b[d]);return xb(a,c)}function xb(a,b){return{m:a,j:80,h:b}}function N(a,b,c){return{j:a,J:c,h:b}}function yb(a,b){return{C:!1,v:a,j:73,h:b}}\nfunction L(a,b){return{j:a,h:b}}function zb(a,b){return{C:!1,v:a,j:72,h:b}}function Ab(a,b){return{xa:b,za:a,j:50}}function M(){return L(10," ")}function Bb(a){return a.filter(function(b){return 10!==b.j})}\nfunction Cb(a,b){var c=Ba(a);if(!c||72!==c.j)return null;a=null;c=c.v;for(var d=!0,e=0,f=c.length;e<f&&!a;e++){var g=c[e];if(d&&0===g.j&&(d=g,"html"===d.h||"body"===d.h))if(e<c.length-1&&b){var h=c[e+1];if(22===h.j||10===h.j&&e<c.length-2&&22===c[e+2].j)a=d.h}else a=d.h;d=22===g.j||10===g.j}return a}\nfunction Db(a){var b=Ba(a);if(!b||72!==b.j)return null;a=null;b=b.v;for(var c=!1,d=!0,e=0,f=b.length;e<f&&!a;e++){var g=b[e];if(0===g.j){var h=g;d&&"html"===h.h?a="html":c&&"root"===h.h&&(a=":root");null!==a&&(c=b.length>e+1?b[e+1]:void 0,h=b.length>e+2?b[e+2]:void 0,(c=c&&10!==c.j?c:h)&&22!==c.j&&(a=null))}c=d&&20===g.j;d=22===g.j||10===g.j}return a}\nfunction Eb(a){var b=!1;if(80===a.j)switch(a.m){case "rgb":case "rgba":case "hsl":case "hsla":b=!0}else 3===a.j?b=!0:0===a.j&&(a=a.h.toLowerCase(),b="initial"===a||"revert"===a||"transparent"===a||eb.hasOwnProperty(a));return b}function Fb(a){a=a.j;return 40===a||41===a||42===a}function Gb(a){return 70<=a.j&&79>=a.j}\nfunction O(a,b,c){var d;if(80===a.j){b=[];for(var e=0;e<a.h.length;e++){var f=a.h[e];Fb(f)&&b.push(f)}var g;3<b.length&&(e=b[3],40===e.j?g=e.h:41===e.j&&(g=e.h/100));if("rgb"===a.m||"rgba"===a.m){a=[40,41];if(3>b.length||!P(b[0],a)||!P(b[1],a)||!P(b[2],a))b=null;else{a=[];a.length=3;for(e=0;3>e;e++)f=b[e],a[e]=40===f.j?f.h:255*f.h/100;b=a}b&&(d=J(b[0],b[1],b[2],g))}else if("hsl"===a.m||"hsla"===a.m)3>b.length||!P(b[0],[40,42])||!P(b[1],[40,41])||!P(b[2],[40,41])?b=null:(a=[],a.length=3,e=b[0],a[0]=\n40===e.j?e.h:42===e.j?"grad"===e.J?360*e.h/400:"rad"===e.J?360*e.h/(2*Math.PI):"turn"===e.J?360*e.h:e.h:360*e.h/100,a[1]=40===b[1].j?100*b[1].h:b[1].h,a[2]=40===b[2].j?100*b[2].h:b[2].h,b=a),b&&(d=g,g=new fb,a=b[0],a%=360,0>a&&(a+=360),g.i=[a,A(b[1],100),A(b[2],100)],g.g=null,Ga(d)&&(g.alpha=A(d,1)),d=g)}else if(3===a.j)(g=I(a.h))&&(d=g);else if(0===a.j){d=a.h.toLowerCase();if("inherit"===d||"unset"===d)return null;"initial"===d||"revert"===d?d=ib(b):(d=d.toLowerCase(),d=(eb.hasOwnProperty(d)?I(eb[d]):\n"transparent"===d?hb():null)||b)}d||(d=ib(c));return d}var Hb=J(255,255,255);function P(a,b){return b.some(function(c){return c===a.j})};function Ib(a){for(var b=Array(a.length),c=0;c<a.length;c++){var d=a[c],e=d.j;switch(e){case 70:b[c]=Jb(d);break;case 71:b[c]=Kb(d);break;case 72:e=c;d=zb(Q(d.v),Lb(d.h));b[e]=d;break;case 73:e=c;d=yb(Q(d.v),Q(d.h));b[e]=d;break;case 82:e=c;var f=vb(d.Ca);f.h=Ib(d.h);b[e]=f;break;default:Ja(e)}}return b}function Jb(a){return sb(a.m,Q(a.v),a.h?Lb(a.h):null)}function Kb(a){return tb(a.m,Q(a.v),a.h?Ib(a.h):null)}\nfunction Q(a){for(var b=Array(a.length),c=0;c<a.length;c++){var d=c;var e=a[c];if(60>e.j){var f=void 0,g=e.j;29>g?f=L(g,e.h):49>g?f=N(g,e.h,e.J):f=Ab(e.za,e.xa);e=f}else 69>=e.j?(f=e.j,e=Q(e.h),e={j:f,h:e}):e=xb(e.m,Q(e.h));b[d]=e}return b}function Lb(a){for(var b=Array(a.length),c=0;c<a.length;c++){var d=a[c];if(81===d.j){var e=c;d=ub(d.m,Q(d.h),d.ma);b[e]=d}else 70===d.j?b[c]=Jb(d):71===d.j&&(b[c]=Kb(d))}return b};function Mb(a){this.s=[];this.l=void 0;this.i=0;this.g=a.replace(/\\r\\n|\\r|\\f/g,"\\n")}function Nb(a){var b=a.i,c=a.g.charCodeAt(b++);if(isNaN(c))c=String.fromCharCode(65533);else if(Ob(c)){for(var d=1,e=57>=c?c-48:70>=c?c-65+10:c-97+10;6>d++&&Ob(c=a.g.charCodeAt(b));)e=e<<4|(57>=c?c-48:70>=c?c-65+10:c-97+10),b++;Pb(a.g.charCodeAt(b))&&b++;c=String.fromCodePoint(e)}else c=55296<=c&&56319>=c?String.fromCharCode(c,a.g.charCodeAt(b++)):String.fromCharCode(c);a.i=b;return c}\nfunction Qb(a,b){b=Rb(a,b);if(40===a.g.charCodeAt(a.i)){a.i++;if(/^url$/i.test(b)){b=Sb(a);if(isNaN(b))b=K(-1,"EOF");else if(34===b||39===b)if(a.i++,b=Tb(a,b),-2===b.j)Ub(a),b=K(-1,b.h);else{for(var c;Pb(c=a.g.charCodeAt(a.i));)a.i++;41===c||isNaN(c)?(a.i++,a=!0):(Ub(a),a=!1);a?b=L(5,b.h):b=K(-1,"Unexpected end of URL")}else b=Vb(a);a=b}else a=L(1,b);return a}return L(0,b)}\nfunction Rb(a,b){for(var c="",d=a.i;;){var e=a.g.charCodeAt(d);if(S(e)||T(e)||45===e)d++;else if(92===e&&92===e&&10!==a.g.charCodeAt(d+1))c+=a.g.substring(b,d++),a.i=d,c+=Nb(a),d=b=a.i;else return a.i=d,c?c+a.g.substring(b,d):a.g.substring(b,d)}}\nfunction Wb(a,b,c,d){for(var e=a.i,f;T(c=a.g.charCodeAt(e));)e++;if(!d&&46===c&&T(a.g.charCodeAt(e+1)))for(e+=2;T(c=a.g.charCodeAt(e));)e++;if(69===c||101===c)if(c=a.g.charCodeAt(e+1),45!==c&&43!==c||!T(a.g.charCodeAt(e+2))?T(c)&&(e+=2,f=!0):(e+=3,f=!0),f)for(;T(a.g.charCodeAt(e));)e++;a.i=e;b=Number(a.g.substring(b,e));d=a.i;c=a.g.charCodeAt(d);return Xb(c,a.g.charCodeAt(d+1),a.g.charCodeAt(d+2))?N(42,b,Rb(a,d)):37===c?(a.i++,N(41,b,"%")):N(40,b,"")}\nfunction Ub(a){for(var b;(b=a.g.charCodeAt(a.i++))&&(41!==b||isNaN(b));)92===b&&10!==a.g.charCodeAt(a.i)&&Nb(a)}function Tb(a,b){for(var c,d=c=a.i,e,f="",g;!e;)g=a.g.charCodeAt(c++),g===b||isNaN(g)?e=L(4,f+a.g.substring(d,c-1)):10===g?(e=K(-2,f+a.g.substring(d,c-1)),c--):92===g&&(g=a.g.charCodeAt(c),isNaN(g)?e=L(4,f+a.g.substring(d,c-1)):(f+=a.g.substring(d,c-1),10===g?c++:(a.i=c,f+=Nb(a),c=a.i),d=c));a.i=c;return e}function Sb(a){for(var b;Pb(b=a.g.charCodeAt(a.i));)a.i++;return b}\nfunction Vb(a){for(var b,c="",d=a.i,e;;){e=a.g.charCodeAt(a.i++);if(41===e||isNaN(e))return L(5,c+a.g.substring(d,a.i-1));if(Pb(e)){b=a.i-1;e=Sb(a);if(41===e||isNaN(e))return a.i++,L(5,c+a.g.substring(d,b));Ub(a);return K(-1,c+a.g.substring(d,a.i))}if(34===e||39===e||40===e)return Ub(a),K(-1,c+a.g.substring(d,a.i));92===e&&(e=a.g.charCodeAt(a.i),10!==e?(c+=a.g.substring(d,a.i-1),c+=Nb(a),d=a.i):Ub(a))}}n=Mb.prototype;\nn.getNextTokenHigh=function(a,b){117===b?a=Yb(this,a):S(b)?a=Qb(this,a):91===b?a={j:32}:92===b?10!==this.g.charCodeAt(a+1)?(this.i--,a=Qb(this,a)):a=L(11,"\\\\"):93===b?a=L(35,"]"):94===b?61===this.g.charCodeAt(a+1)?(this.i++,a=L(14,"^=")):a=L(11,"^"):123===b?a={j:30}:125===b?a=L(33,"}"):124===b?(a=this.g.charCodeAt(a+1),61===a?(this.i++,a=L(13,"|=")):124===a?(this.i++,a=L(17,"||")):a=L(11,"|")):126===b?61===this.g.charCodeAt(a+1)?(this.i++,a=L(12,"~=")):a=L(11,"~"):isNaN(b)?a=void 0:(55296<=b&&56319>=\nb?(a=String.fromCharCode(b,this.g.charCodeAt(a+1)),this.i++):a=String.fromCharCode(b),a=L(11,a));return a};\nn.getNextTokenLow=function(a,b){switch(b){case 9:case 10:case 32:for(a=this.i;Pb(this.g.charCodeAt(a));)a++;this.i=a;return L(10," ");case 34:return Tb(this,34);case 35:b=this.g.charCodeAt(a+1);var c=this.g.charCodeAt(a+2);return S(b)||T(b)||45===b||92===b&&10!==c?L(3,Rb(this,a+1)):L(11,"#");case 36:return 61===this.g.charCodeAt(a+1)?(this.i++,a=L(15,"$=")):a=L(11,"$"),a;case 39:return Tb(this,39);case 40:return{j:31};case 41:return L(34,")");case 42:return 61===this.g.charCodeAt(a+1)?(this.i++,a=\nL(16,"*=")):a=L(11,"*"),a;case 43:return Zb(b,this.g.charCodeAt(a+1),this.g.charCodeAt(a+2))?Wb(this,a,b,!1):L(11,"+");case 44:return L(22,",");case 45:c=this.g.charCodeAt(a+1);var d=this.g.charCodeAt(a+2);Zb(b,c,d)?a=Wb(this,a,b,!1):45===c&&62===d?(this.i+=2,a=L(19,"--\\x3e")):a=Xb(b,c,d)?Qb(this,a):L(11,"-");return a;case 46:return T(this.g.charCodeAt(a+1))?Wb(this,a,b,!0):L(11,".");case 47:if(42===this.g.charCodeAt(a+1)){this.i++;a=this.i;b=this.g.charCodeAt(a++);for(c=this.g.charCodeAt(a++);!isNaN(b)&&\n(42!==b||47!==c);)b=c,c=this.g.charCodeAt(a++);this.i=a;a=this.next()}else a=L(11,"/");return a}return isNaN(b)?void 0:L(11,String.fromCharCode(b))};\nn.getNextTokenMid=function(a,b){57>=b?a=Wb(this,a,b,!1):58===b?a=L(20,":"):59===b?a=L(21,";"):60===b?33===this.g.charCodeAt(a+1)&&45===this.g.charCodeAt(a+2)&&45===this.g.charCodeAt(a+3)?(this.i+=3,a=L(18,"\\x3c!--")):a=L(11,"<"):a=64===b?Xb(this.g.charCodeAt(a+1),this.g.charCodeAt(a+2),this.g.charCodeAt(a+3))?L(2,Rb(this,a+1)):L(11,"@"):85===b?Yb(this,a):S(b)?Qb(this,a):isNaN(b)?void 0:L(11,String.fromCharCode(b));return a};\nfunction Yb(a,b){var c=a.g.charCodeAt(b+2);if(43===a.g.charCodeAt(b+1)&&(34===c||T(c))){a.i++;b=c=a.i;for(var d=0,e,f=!1,g;6>d&&Ob(e=a.g.charCodeAt(b));)b++,d++;if(6>d&&63===e)for(b++,d++,f=!0;6>d&&63===a.g.charCodeAt(b);)d++,b++;g=a.g.substring(c,b);if(f)c=Ab(parseInt(g.replace(/\\?/g,"0"),16),parseInt(g.replace(/\\?/g,"F"),16));else if(45===a.g.charCodeAt(b)&&Ob(a.g.charCodeAt(b+1))){c=b+1;b+=2;for(d=1;6>d&&Ob(a.g.charCodeAt(b));)b++,d++;c=Ab(parseInt(g,16),parseInt(a.g.substring(c,b),16))}else c=\nAb(e=parseInt(g,16),e);a.i=b;return c}return Qb(a,b)}n.next=function(){if(void 0!==this.l){var a=this.l;this.l=void 0;return a}return $b(this)};n.peek=function(){void 0===this.l&&(this.l=$b(this));return this.l};function $b(a){var b=a.i++,c=a.g.charCodeAt(b);return(b=48>c?a.getNextTokenLow(b,c):91>c?a.getNextTokenMid(b,c):a.getNextTokenHigh(b,c))&&0>b.j?(a.s.push(b),a.next()):b}function Pb(a){return 9===a||32===a||10===a}function T(a){return 48<=a&&57>=a}\nfunction Ob(a){return 48<=a&&57>=a||65<=a&&70>=a||97<=a&&102>=a}function S(a){return 65<=a&&90>=a||97<=a&&122>=a||128<=a||95===a}function Zb(a,b,c){return 43===a||45===a?T(b)||46===b&&T(c):T(a)||46===a&&T(b)}function Xb(a,b,c){return 45===a?S(b)||45===b||92===b&&10!==c:S(a)||92===a&&10!==b};function ac(a){this.g=a;this.i=0}ac.prototype.next=function(){return this.g[this.i++]};ac.prototype.peek=function(){return this.g[this.i]};function bc(a){this.l=Array(16);this.g=[];this.i=new Mb(a)}function cc(a){a=new bc(a);for(var b,c=[];(b=a.i.next())&&34!==b.j&&35!==b.j&&33!==b.j;)c.push(dc(a,a.i,b));return c}function ec(a){a=new bc(a);var b=fc(a,a.i,{j:30});return gc(a,new ac(b.h))}function hc(a,b){a=cc(a);b=ec(b);return zb(a,b)}function U(a,b){a=new bc(a);b=vb(b);b.h=ic(a,a.i,!0);a.g=a.g.concat(a.i.s);a.l.length=0;return b}\nfunction jc(a,b,c){for(var d,e,f=[],g;!g&&(d=b.next())&&21!==d.j;)e=d.j,30===e?g=fc(a,b,d).h:60===e?g=d.h:f.push(dc(a,b,d));if(g)switch(b=new ac(g),c.h){case "container":case "document":case "font-feature-values":case "keyframes":case "layer":case "media":case "scope":case "supports":case "-webkit-keyframes":a=ic(a,b,!1);c=tb(c.h,f,a);break;default:a=gc(a,b),c=sb(c.h,f,a)}else c=sb(c.h,f,null);return c}\nfunction dc(a,b,c){var d=c.j;if(30===d||31===d||32===d)a=fc(a,b,c);else if(1===d){d=[];for(var e;(e=b.next())&&34!==e.j;)d.push(dc(a,b,e));a=xb(c.h.toLowerCase(),d)}else a=c;return a}\nfunction kc(a,b,c){var d=0,e=!1,f=a.l;var g=lc(b);if(!g)return a.g.push(c),null;if(20!==g.j){a.g.push(g);for(var h;(h=b.next())&&21!==h.j;);return null}g=lc(b);if(!g||21===g.j)return a.g.push(g||c),null;for(f[d++]=g;(g=b.next())&&21!==g.j;)f[d++]=g;d=mc(f,d);b=f[d-1];2<d&&0===b.j&&"important"===b.h&&(g=d,d=mc(f,d-1),b=f[d-1],1<d&&11===b.j&&"!"===b.h?(e=!0,d=mc(a.l,d-1)):d=g);return 0===d?(a.g.push(c),null):(a=f.slice(0,d))?ub(c.h,a,e):null}\nfunction gc(a,b){for(var c=[],d,e;d=b.next();)e=d.j,2===e?(d=jc(a,b,d))&&c.push(d):0===e?(d=kc(a,b,d))&&c.push(d):10!==e&&21!==e&&a.g.push(d);return c}\nfunction ic(a,b,c){for(var d=[],e,f,g;f=b.next();)if(e=f.j,2===e)g=jc(a,b,f),d.push(g);else if(!c||18!==e&&19!==e){if(e=10!==e){a:{g=a;e=b;var h=f,k=[];if(30===h.j)f=yb(k,fc(g,e,h).h);else{for(k.push(dc(g,e,h));f=e.next();){if(30===f.j){f=yb(k,fc(g,e,f).h);break a}if(60===f.j){f=yb(k,f.h);break a}k.push(dc(g,e,f))}g.g.push(h);f=null}}e=g=f}e&&(g=0===g.v.length?null:zb(g.v,gc(a,new ac(g.h))))&&d.push(g)}return d}\nfunction fc(a,b,c){for(var d,e=c.j+3,f=[];(d=b.next())&&d.j!==e;)f.push(dc(a,b,d));return{j:c.j+30,h:f}}function mc(a,b){for(;0<b&&10===a[b-1].j;)b--;return b}function lc(a){for(var b;(b=a.next())&&10===b.j;);return b};function nc(a){this.i=a;this.g=[]}function oc(a,b,c){c=pc(c);if(0<a.g.length){var d=ec(c);a.g.forEach(function(e){e.h.forEach(function(f){return f.C=!0});e.h.push.apply(e.h,w(Lb(d)))})}else b.h.push(hc("."+a.i,c))}nc.prototype.ra=function(a){var b=this,c=a.v;c.some(function(d,e){return 11===d.j&&"."===d.h&&e<c.length-1?(d=c[e+1],0===d.j&&d.h===b.i):!1})&&this.g.push(a)};function pc(a){return Object.keys(a).map(function(b){var c=a[b];return Ha(b)+":"+c}).join(";")};function qc(a){var b=a.activeElementClass||a.fallbackActiveElementClass||"-epub-media-overlay-active";this.Ja=a.activeElementStylesOverride;this.u=new nc(b)}qc.prototype.getResult=function(){return null};qc.prototype.M=function(a,b){oc(this.u,b,this.Ja);return Promise.resolve()};qc.prototype.D=function(a){a.i.push(this.u)};function rc(a){this.g=a}rc.prototype.G=function(a){this.g.has(a.m)&&(a.C=!0)};function sc(){}sc.prototype.getResult=function(){return null};sc.prototype.D=function(a){var b;(b=tc)||(b=tc=new Set("animation animation-delay animation-duration animation-direction animation-name animation-fill-mode animation-play-state animation-timeline animation-timing-function transition transition-delay transition-duration transition-property transition-timing-function".split(" ")));V(a,new rc(b))};var tc;function uc(a){var b=[];W(a,b);return b.join("")}function vc(a){var b=[];wc(a,b);return b.join("")}function xc(a){var b=[];yc(a.h,b);return b.join("")}function zc(a){return a.replace(/\\s/g,function(b){return"\\\\"+b.charCodeAt(0).toString(16)})}\nfunction yc(a,b){for(var c=0;c<a.length;c++){var d=a[c];if(!d.C){var e=d.j;switch(e){case 70:Ac(d,b);break;case 71:Bc(d,b);break;case 72:e=b;C(d.v)?e.push(d.v):W(d.v,e);e.push("{");wc(d.h,e);e.push("}");break;case 73:e=b;W(d.v,e);e.push("{");W(d.h,e);e.push("}");break;case 82:yc(d.h,b);break;default:Ja(e)}b.push("\\n")}}}function Ac(a,b){b.push("@",a.m);0<a.v.length&&10!==a.v[0].j&&b.push(" ");W(a.v,b);a.h?(b.push("{"),wc(a.h,b),b.push("}")):b.push(";")}\nfunction Bc(a,b){b.push("@",a.m);0<a.v.length&&10!==a.v[0].j&&b.push(" ");W(a.v,b);a.h?(b.push("{"),yc(a.h,b),b.push("}")):b.push(";")}function W(a,b){for(var c=0;c<a.length;c++)Cc(a[c],b)}\nfunction Cc(a,b){if(60>a.j){var c=a.j;if(9>c)if(c=zc(a.h),0===a.j){a=!1;for(var d=0;d<c.length;d++){var e=c.charCodeAt(d);if(33<=e&&126>=e&&!(48<=e&&57>=e||97<=e&&122>=e||65<=e&&90>=e)){a=!0;break}}a=a?c.replace(/[!"#$%&()*+,./:;<=>?@\\[\\]^{}|~\'\\\\`]/g,"\\\\$&"):c;c=a.charCodeAt(0);b.push(48<=c&&57>=c?"\\\\3"+a[0]+" "+a.slice(1):a)}else 2===a.j?b.push("@",c):3===a.j?b.push("#",c):4===a.j?b.push(\'"\',-1===c.indexOf(\'"\')?c:c.replace(/"/g,\'\\\\"\'),\'"\'):5===a.j&&b.push(\'url("\',-1===c.indexOf(\'"\')?c:c.replace(/"/g,\n\'\\\\"\'),\'")\');else 29>c?b.push(a.h):49>c?(b.push(a.h),40!==c&&b.push(a.J)):b.push("u+",a.za.toString(16),"-",a.xa.toString(16))}else 69>=a.j?(c=a.j,60===c?(b.push("{"),c="}"):61===c?(b.push("("),c=")"):(b.push("["),c="]"),W(a.h,b),b.push(c)):(b.push(a.m,"("),a.m.startsWith("nth-")?Dc(a.h,b):W(a.h,b),b.push(")"))}function Dc(a,b){var c=a.filter(function(d){return 10!==d.j});2===c.length&&Fb(c[0])&&Fb(c[1])?(Cc(c[0],b),1===Math.sign(c[1].h)&&b.push("+"),Cc(c[1],b)):W(a,b)}\nfunction wc(a,b){for(var c=0;c<a.length;c++){var d=a[c];if(!d.C){if(81===d.j){var e=b;e.push(d.m,":");W(d.h,e);d.ma&&e.push(" !important")}else 70===d.j?Ac(d,b):71===d.j&&Bc(d,b);b.push(";")}}};function Ec(a){this.g=new Set;this.i=new Map;this.s=vb(a);this.l=vb(a)}\nEc.prototype.G=function(a,b,c,d,e){switch(a.m){case "animation":case "animation-name":if(-1===e){a=Lb(Fc);for(e=c.length-1;0<=e;e--)Gb(c[e])&&(b=Object.assign({},c[e]),b.h=a,a=[b]);c=a[0];Gb(c)&&this.l.h.push(c)}else this.g.has(e)||this.g.add(e);break;case "transition":case "transition-property":if(-1===e){e=Ea(a,{},!1);for(b=c.length-1;0<=b;b--)Gb(c[b])&&(d=Object.assign({},c[b]),d.h=[e],e=d);Gb(e)&&this.s.h.push(e)}else this.i.has(e)||(c=[Ea(a,{},!1)],this.i.set(e,c));a.C=!0}};var Fc=ec("animation-play-state: paused !important");function Gc(a){this.ya=[];this.Ba=[];this.u=new Ec(a)}Gc.prototype.getResult=function(){return{pauseAnimationDeclarationsIndexes:this.ya,pauseAnimationStylesheet:xc(this.u.l),transitionDeclarations:this.Ba,transitionStylesheet:xc(this.u.s)}};Gc.prototype.M=function(){var a=this;this.u.i.forEach(function(b,c){a.Ba.push({declarationCss:vc(b),index:c})});this.u.g.forEach(function(b){a.ya.push(b)});return Promise.resolve()};Gc.prototype.D=function(a){V(a,this.u)};function X(a,b,c){var d=Error.call(this,"["+a+"] "+b+" :: "+(c||""));this.message=d.message;"stack"in d&&(this.stack=d.stack);this.namespace=a;this.errorType=b;this.errorMessage=c||""}ma(X,Error);function Hc(){this.i=[];this.g=[]}Hc.prototype.G=function(a,b,c,d,e){-1!==e||"background-image"!==a.m&&"background"!==a.m||a.h.some(function(f){return 5===f.j&&!/^\\s*data:/.test(f.h)})&&Ic(this,a,c)};function Jc(a,b){b.forEach(function(c,d){c||(a.i[d].C=!0)})}function Ic(a,b,c){for(var d=c.length-1;0<=d;d--){var e=c[d];if(72===e.j){c=Kc(e.v);c=uc(c);a.g.push(c);a.i.push(b);break}}}function Kc(a){var b=a.findIndex(function(c){return 20===c.j});return-1!==b?a.slice(0,b):a};function Lc(a,b){this.o=a;this.va=b;this.u=new Hc}Lc.prototype.getResult=function(){return null};Lc.prototype.M=function(){var a=this,b=this.u.g;return 0<b.length?Mc(this.va,{channelId:this.o.jobId,selectors:b,type:17}).then(function(c){Jc(a.u,c.selectorsEnabled)}).catch(function(c){c instanceof X&&"ABORTED"===c.errorType||E(c)}):Promise.resolve()};Lc.prototype.D=function(a){V(a,this.u)};function Nc(a){this.o=a}Nc.prototype.Z=function(){return this.o.cssAfter.join("\\n")};Nc.prototype.O=function(){return this.o.cssBefore.join("\\n")};Nc.prototype.getResult=function(){return null};var Oc=J(0,0,0),Y=hb(),Pc=J(255,255,255);function Qc(){this.l=[];this.i=[];this.g=[]}\nQc.prototype.G=function(a){switch(a.m){case "color":if(a=Rc(a,Oc,Oc))this.g.push(a),this.i.push(a.color);break;case "border":case "border-bottom":case "border-top":case "border-left":case "border-right":case "outline":for(var b=null,c=0,d=a.h.length;c<d&&!b;c++){var e=a.h[c];Eb(e)&&(e=O(e,Y,Oc))&&(b={color:e,node:a,sa:c})}if(a=b)this.g.push(a),this.i.push(a.color);break;case "border-color":case "border-top-color":case "border-left-color":case "border-bottom-color":case "border-right-color":case "outline-color":if(a=Rc(a,\nOc,Y))this.g.push(a),this.i.push(a.color);break;case "background-color":if(a=Rc(a,Pc,Y))this.g.push(a),this.l.push(a.color);break;case "background":for(a=Sc(a),b=0;b<a.length;b++)if(c=a[b])this.g.push(c),this.l.push(c.color)}};\nfunction Tc(a,b){for(var c=new Map,d=[],e=0;e<a.length;e++){var f=a[e],g=f.i?rb(f.i):qb(f.g);g=g[1]/100*f.alpha*(g[2]/100);var h=c.get(g);h||(h=[],d.push({Y:h,component:g}),c.set(g,h));h.push(f)}c=d.filter(function(k){return.5<k.component});for(d=0;d<c.length;d++)for(e=c[d],f=0;f<e.Y.length;f++)g=e.Y[f],h=a.indexOf(g),-1!==h&&a.splice(h,1),mb(g,b)}\nfunction Uc(a,b,c,d){for(var e=new Map,f=[],g=0;g<a.length;g++){var h=a[g];if(0<h.alpha){var k=Math.round(jb(h)),l=e.get(k);l||(l=[],f.push({Y:l,component:k}),e.set(k,l));l.push(h)}}f.sort(function(p,q){return p.component-q.component});if(1===f.length)for(a=d?b:c,d=0;d<f[0].Y.length;d++)mb(f[0].Y[d],a);else if(1<f.length)for(a=f[0].component,d=f[f.length-1].component,c=lb(c),b=lb(b),e=0;e<f.length;e++){g=f[e];l=Ia(g.component,a,d,0,1);h=Ia(l,0,1,b[0],c[0]);k=Ia(l,0,1,b[1],c[1]);l=Ia(l,0,1,b[2],c[2]);\nfor(var m=0;m<g.Y.length;m++)gb(g.Y[m],h,k,l)}}function Rc(a,b,c){var d;a.h[0]?d=O(a.h[0],b,c):d=ib(c);return d?{color:d,node:a,sa:0}:null}\nfunction Sc(a){var b=[],c,d=-1;var e=0;for(c=a.h.length;e<c;e++){var f=a.h[e];a:{if(80===f.j)switch(f.m){case "linear-gradient":case "repeating-linear-gradient":case "radial-gradient":case "repeating-radial-gradient":var g=!0;break a}g=!1}g?f.h.forEach(function(h,k){Eb(h)&&(h=O(h,Y,Y))&&b.push({color:h,node:f,sa:k})}):22===f.j&&(d=e)}for(e=d+1;e<c;e++)f=a.h[e],Eb(f)&&(d=O(f,Y,Y))&&b.push({color:d,node:a,sa:e});return b};function Vc(a){this.ta=new Qc;this.Ka={accent:I(a.accent),backgroundDark:I(a.backgroundDark),backgroundLight:I(a.backgroundLight),foregroundDark:I(a.foregroundDark),foregroundLight:I(a.foregroundLight)}}Vc.prototype.O=function(){return"html{color:#000}a{color:red}"};Vc.prototype.getResult=function(){return null};\nVc.prototype.M=function(){var a=this.ta,b=this.Ka;b.accent&&Tc(a.i,b.accent);b.foregroundDark&&b.foregroundLight&&Uc(a.i,b.foregroundDark,b.foregroundLight,!0);b.backgroundDark&&b.backgroundLight&&Uc(a.l,b.backgroundDark,b.backgroundLight,!1);for(b=0;b<a.g.length;b++){var c=a.g[b],d=c.node.h,e=c.sa;var f=c.color;c=f.alpha;0===c?c=L(0,"transparent"):(null!==f.g?(f=lb(f),f=[N(40,Math.round(f[0]),""),N(40,Math.round(f[1]),""),N(40,Math.round(f[2]),"")],1>c?(f.push(N(40,c,"")),c="rgba"):c="rgb"):(kb(f),\nf=f.i,f=[N(40,Math.round(f[0]),""),N(41,Math.round(f[1]),"%"),N(41,Math.round(f[2]),"%")],c=1>c?"hsla":"hsl"),c=wb(c,f));d[e]=c}a=this.ta;a.l=[];a.i=[];return Promise.resolve()};Vc.prototype.D=function(a){V(a,this.ta)};function Wc(a,b){this.o=a;this.N=b}Wc.prototype.getResult=function(){return null};Wc.prototype.M=function(a,b){for(var c=v(this.o.injectionPointStartUnprocessed),d=c.next();!d.done;d=c.next())d=U(d.value,this.N),a.h.push.apply(a.h,w(d.h));a=v(this.o.injectionPointEndUnprocessed);for(c=a.next();!c.done;c=a.next())c=U(c.value,this.N),b.h.push.apply(b.h,w(c.h));return Promise.resolve()};function Xc(){}Xc.prototype.G=function(a){switch(a.m){case "-webkit-user-select":a.C=!0}};function Yc(a){this.o=a}Yc.prototype.Z=function(){return this.o.preventContextMenu?"*{-webkit-touch-callout:none!important}":this.o.preventContextMenuOnMediaElements?"audio,image,img,video{-webkit-touch-callout:none!important}":""};\nYc.prototype.O=function(){return"x-colibrio-text-split{display:block;margin:0;padding:0}html{-webkit-text-size-adjust:100%}"+(this.o.enableNormalizeCss?"/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */html{-webkit-text-size-adjust:100%;line-height:1.15}body{margin:0}h1{font-size:2em;margin:.67em 0}hr{-webkit-box-sizing:content-box;box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}":"")};\nYc.prototype.getResult=function(){return null};Yc.prototype.D=function(a){this.o.webkitUserSelectRemoverEnabled&&V(a,new Xc)};function Zc(){}Zc.prototype.Z=function(){return"body,html{position:static!important}p[data-colibrio-fragmented-at-start]{text-indent:0!important}"};Zc.prototype.O=function(){return"img{height:auto;max-width:100%}body,html{margin:0;padding:0}"};Zc.prototype.getResult=function(){return null};function $c(){}$c.prototype.ra=function(a){a=a.v;for(var b=!1,c=0;c<a.length&&!b;c++)if(20===a[c].j){b=a;var d=c,e=b[d+1];20===e.j&&(e=b[d+2]);var f=!1;if(0===e.j)switch(e.h){case "first-letter":case "first-line":e=cc(":not([data-colibrio-fragmented-at-start])"),b.splice.apply(b,[d,0].concat(w(e))),f=!0}b=f}};function ad(){}ad.prototype.getResult=function(){return null};ad.prototype.D=function(a){a.i.push(new $c)};function bd(a){var b=a.h.slice(),c;a=[];for(var d=0;d<b.length;d++){var e=b[d],f;if(f=!g)f=e.h,f=0===e.j&&("normal"===f||"italic"===f||"oblique"===f);if(f)var g=e;else if(m||0!==e.j||"normal"!==e.h&&"small-caps"!==e.h){if(f=!h)f=e.h,f=40===e.j?100===f||200===f||300===f||400===f||500===f||600===f||700===f||800===f||900===f:"normal"===f||"bold"===f||"bolder"===f||"lighter"===f;if(f)var h=e;else{if(f=!k)f=e.h,f=0===e.j&&("normal"===f||"ultra-condensed"===f||"extra-condensed"===f||"condensed"===f||"semi-condensed"===\nf||"semi-expanded"===f||"expanded"===f||"extra-expanded"===f||"ultra-expanded"===f);if(f)var k=e;else{if(f=!l)0===e.j?(f=e.h,f="xx-small"===f||"x-small"===f||"small"===f||"medium"===f||"large"===f||"x-large"===f||"xx-large"===f||"smaller"===f||"larger"===f):f=42===e.j||41===e.j;if(f){var l=e;(e=b[d+1])&&"/"===e.h&&(d+=2,(e=b[d])&&(c=e))}else 0!==e.j&&4!==e.j||a.push(e)}}}else var m=e}b=null;0<a.length&&l&&(b={X:a,fontSize:l,fontStretch:k,fontStyle:g,fontVariant:m,fontWeight:h,lineHeight:c});return b}\nfunction cd(a){var b=[];a.fontStyle&&b.push(a.fontStyle,M());a.fontVariant&&b.push(a.fontVariant,M());a.fontWeight&&b.push(a.fontWeight,M());a.fontStretch&&b.push(a.fontStretch,M());a.fontSize&&(b.push(a.fontSize),a.lineHeight&&b.push(L(11,"/"),a.lineHeight,M()));if(a.X)for(var c=0;c<a.X.length;c++){var d=a.X[c];0<c&&b.push(L(22,","),M());b.push(d)}return b};function dd(a){switch(a){case "serif":case "sans-serif":case "cursive":case "fantasy":case "monospace":return!0}return!1};function ed(a,b){this.g=a;this.S=b}ed.prototype.i=function(){return this.g.fontFaces.filter(function(a){return!dd(a.family)}).map(function(a){return a.family})};ed.prototype.qa=function(a){var b=this;"font-face"===a.m&&a.h&&!a.h.some(function(c){return c.m==="-colibrio-custom-"+b.S?c.C=!0:!1})&&(a.C=!0)};ed.prototype.G=function(a){"font-family"===a.m?fd(this,a):"font"===a.m?gd(this,a):a.m==="-colibrio-font-family-"+this.S&&(a.m="font-family")};\nfunction hd(a,b){a=a.g.defaults;b=Ba(b);if(b){switch(b.h.toLowerCase()){case "sans-serif":var c=a.sansSerif;break;case "serif":c=a.serif;break;case "cursive":c=a.cursive;break;case "fantasy":c=a.fantasy;break;case "monospace":c=a.monospace}c||(c=a.fallback);c=L(dd(c)?0:4,c)}else c=a.fallback,c=L(dd(c)?0:4,c);return c}function fd(a,b){var c=b.h.filter(function(d){return 0===d.j});b.h=[hd(a,c)]}\nfunction gd(a,b){var c=bd(b);if(c){var d=c.X.filter(function(e){return 0===e.j});c.X=[hd(a,d)];b.h=cd(c)}};var id=__lib__bowser;var jd=null;function kd(a,b){this.l=a;this.F=b;this.g=[];this.s=[]}kd.prototype.i=function(){return this.g};kd.prototype.qa=function(a,b){if("font-face"===a.m&&a.h)for(var c=0;c<a.h.length;c++){var d=a.h[c];81===d.j&&("src"===d.m?ld(this,d,b):"font-family"===d.m&&md(this,d))}};function nd(a,b,c){for(var d=["woff","opentype","truetype"],e=0;e<d.length;e++){var f=od(a,b,d[e],c);if(f)return f}return null}\nfunction od(a,b,c,d){var e=b.findIndex(function(g){return null!==g.W&&g.W.h===c}),f=null;-1!==e&&(f=b[e],pd(a,f,d),b.splice(e,1));return f||null}function pd(a,b,c){c=a.F?qd(a.l,b.R,c,["font/*"]).then(function(d){b.aa.h=d.B}).catch(function(d){b.aa.h="";Pa(d)||E(d)}):rd(a.l,b.R,c,["font/*"]).then(function(d){b.aa.h=d}).catch(function(d){b.aa.h="";Pa(d)||E(d)});a.s.push(c)}\nfunction ld(a,b,c){for(var d=null,e=[],f=[],g=0;g<b.h.length;g++){var h=b.h[g];5===h.j?h.h.startsWith("data:")?(d={W:null,R:null,aa:h},f.push(d)):(d={W:null,R:h.h,aa:h},e.push(d)):22===h.j?d=null:80===h.j&&"format"===h.m&&d&&(h=h.h.find(function(l){return 4===l.j}))&&(d.W=h)}sd(e);var k;null===jd&&(jd=id.getParser(navigator.userAgent));jd.satisfies({Chrome:">=36",Chromium:">=36",Firefox:">=39","Microsoft Edge":">=14",Opera:">=23",Safari:">=10.2"})&&(k=od(a,e,"woff2",c));k||(k=nd(a,e,c));k&&f.push(k);\nfor(a=0;a<e.length;a++)c=e[a],c.R&&f.push(c);e=[];for(a=0;a<f.length;a++)c=f[a],0<a&&(e.push(L(22,",")),e.push(M())),e.push(c.aa),c.W&&(e.push(M()),e.push(wb("format",[c.W])));b.h=e}function md(a,b){(b=b.h.find(function(c){return 4===c.j||0===c.j}))&&-1===a.g.indexOf(b.h)&&a.g.push(b.h)}\nfunction sd(a){for(var b=0;b<a.length;b++){var c=a[b];if(!c.W&&c.R){var d=void 0,e=c.R,f=e.lastIndexOf(".");switch((-1===f?"":e.slice(f+1)).toLowerCase()){case "woff2":d="woff2";break;case "woff":d="woff";break;case "ttc":case "ttf":d="truetype";break;case "otf":d="opentype"}d&&(c.W=L(4,d))}}};function td(a){this.i=this.l=null;var b=new Uint8Array(8);if("undefined"!==typeof crypto&&crypto.getRandomValues)crypto.getRandomValues(b);else for(var c=0;8>c;c++)b[c]=256*Math.random()|0;c=[];for(var d=0;d<b.length;d++)16>b[d]&&c.push("0"),c.push(b[d].toString(16));this.S=c.join("");this.g=a.fontSet;this.s=a.inline;this.F=ud(a.defaultFontFamily)}\nfunction vd(a){switch(a.mediaType){case "font/opentype":return"opentype";case "font/truetype":return"truetype";case "font/woff2":return"woff2"}return"woff"}function ud(a){return dd(a)?a:\'"\'+a+\'"\'}n=td.prototype;n.Z=function(){var a=this,b="";this.g&&this.g.selectors&&(b=this.g.selectors.map(function(c){return c.selector+" { -colibrio-font-family-"+a.S+": "+ud(c.family)+" !important }"}).join(" "));return b};\nn.O=function(){var a=this,b="html { font-family: "+this.F+" } ";if(this.g){var c=this.g.fontFaces.map(function(d){if(dd(d.family)){Sa("Invalid custom font-family: "+d.family);var e=null}else e=d.family;if(d.srcUrl)var f=d.srcUrl;else d.src?f="data:"+d.mediaType+";base64,"+d.src:(E("Missing url for font-face:"+d.family),f=null);var g=vd(d),h=d.fontStyle?"font-style: "+d.fontStyle+"; ":"",k=d.fontWeight?"font-weight: "+d.fontWeight+"; ":"";d=d.fontStretch?"font-stretch: "+d.fontStretch+"; ":"";var l=\n"";e&&f&&(l=\'@font-face { font-family: "\'+e+\'"; -colibrio-custom-\'+a.S+\': true; src: url("\'+f+\'")\'+(g?\' format("\'+g+\'"); \':"; "),l=l+h+k+d,l+="}");return l});b+=c.join(" ")}return b};n.getResult=function(){return{fontFamilyNames:this.i?this.i.i():this.l?this.l.i():[]}};n.M=function(){return this.i?Promise.all(this.i.s):Promise.resolve()};n.D=function(a,b){this.g?(this.l=new ed(this.g,this.S),a.g.push(this.l),V(a,this.l)):(this.i=new kd(b,this.s),a.g.push(this.i))};function wd(a){this.o=a}wd.prototype.G=function(a,b,c){if("font-size"===a.m&&this.o.removeFontSize)a.C=!0;else if("line-height"===a.m&&this.o.removeLineHeight)a.C=!0;else if("font"===a.m){b=Ba(c);c=bd(a);var d=b&&72===b.j,e=this.o.removeFontSize||this.o.removeLineHeight&&(null==c?void 0:c.lineHeight);c&&d&&e&&(a.C=!0,xd(this,b,c))}};\nfunction xd(a,b,c){var d=c.X.length;if(c.X&&0<d){var e=c.X.reduce(function(f,g,h){f.push(g);h<d-1&&f.push({j:22,h:","});return f},[]);b.h.push(Z("font-families",e))}c.fontStretch&&b.h.push(Z("font-stretch",[c.fontStretch]));c.fontStyle&&b.h.push(Z("font-style",[c.fontStyle]));c.fontWeight&&b.h.push(Z("font-weight",[c.fontWeight]));c.fontVariant&&b.h.push(Z("font-variant",[c.fontVariant]));a.o.removeFontSize||b.h.push(Z("font-size",[c.fontSize]));!a.o.removeLineHeight&&c.lineHeight&&b.h.push(Z("line-height",\n[c.lineHeight]))}function Z(a,b){return{C:!1,ma:!1,m:a,j:81,h:b}};function yd(a){this.o=a}yd.prototype.getResult=function(){return null};yd.prototype.D=function(a){V(a,new wd(this.o))};var zd=["inherit","unset"];function Ad(a){this.g=a}Ad.prototype.G=function(a,b,c,d){"font-size"===a.m?Bd(a.h[0],this.g,c):"font"===a.m?(b=bd(a))?(Bd(b.fontSize,this.g,c),(a=b.lineHeight)&&Fb(a)&&Cd(a,this.g,c,!0)):(b=a.h[0],0===b.j&&(b=b.h,null===Db(c)&&zd.includes(b)||d.push.apply(d,w(ec("font-size: 16px"+(a.ma?" !important":"")))))):"line-height"===a.m&&(a=a.h,(d=a[0])&&42===d.j&&Cd(a[0],this.g,c,!0))};\nfunction Bd(a,b,c){if(42===a.j)Cd(a,b,c,!1);else if(c=null!==Db(c),0===a.j){var d=0,e=a.h.toLowerCase();switch(e){case "xx-small":d=9;break;case "x-small":d=10;break;case "small":d=13;break;case "medium":d=16;break;case "large":d=18;break;case "x-large":d=24;break;case "xx-large":d=32;break;default:if(c||!zd.includes(e))d=16}0<d&&(a.j=42,a.h=d*b,a.J="px")}else c&&(41===a.j?(a.j=42,a.h=16*b*a.h/100):(a.j=42,a.h=16*b),a.J="px")}\nfunction Cd(a,b,c,d){var e=a.J;(e="px"===e||"mm"===e||"q"===e||"cm"===e||"in"===e||"pt"===e||"pc"===e)||(e=a.J,e="vh"===e||"vw"===e||"vi"===e||"vb"===e||"vmin"===e||"vmax"===e);if(e)a.h*=b;else if(!d&&Db(c)){switch(a.J){case "cap":case "rcap":c=1;break;case "ch":case "rch":c=1;break;case "em":case "rem":c=1;break;case "ex":case "rex":c=.5;break;case "ic":case "ric":c=1;break;case "lh":case "rlh":c=1;break;default:c=a.h=1}a.h*=16*c*b;a.J="px"}};function Dd(a){this.u=new Ad(a.scaleFactor)}Dd.prototype.getResult=function(){return null};Dd.prototype.M=function(a){var b=hc("html","font-size: "+16*this.u.g+"px");a.h.push(b);return Promise.resolve()};Dd.prototype.D=function(a){V(a,this.u)};function Ed(){this.l=this.i=this.g=!1}Ed.prototype.G=function(a,b,c){if("background"===a.m||"background-color"===a.m){"body"===Cb(c,!1)&&(this.g=!0);if(c=b=Cb(c,!0)){a=a.h;var d;var e=-1;c=0;for(d=a.length;c<d;c++)22===a[c].j&&(e=c);var f=!1;for(c=e+1;c<d;c++)e=a[c],Eb(e)&&(f=(f=O(e,Hb,Hb))?0===f.alpha:!0);c=!f}c&&("html"===b?this.l=!0:"body"===b&&(this.i=!0))}};function Fd(){this.u=new Ed}Fd.prototype.getResult=function(){return null};Fd.prototype.M=function(a,b){a=this.u;a.l||a.i||(a=hc(a.g?"body":"html","background-color: #fff"),b.h.push(a));return Promise.resolve()};Fd.prototype.D=function(a){V(a,this.u)};function Gd(a){var b=Error.call(this,"[colibrio.internal] "+(a||""));this.message=b.message;"stack"in b&&(this.stack=b.stack);this.errorMessage=a}ma(Gd,Error);function Hd(){this.g=[];this.s=[];this.l=[];this.i=[]}function V(a,b){a.l.push(b)}function Id(a,b,c){c.push(b);Jd(a,b.h,b.Ca,c);c.pop()}function Kd(a,b,c,d){for(var e=0;e<a.s.length;e++)a.s[e].Qa(b,d);b.h&&(d.push(b),Jd(a,b.h,c,d),d.pop())}\nfunction Ld(a,b,c,d,e){for(var f=0;f<b.length;f++){var g=b[f];if(!g.C)switch(g.j){case 81:for(var h=a,k=c,l=d,m=b,p=e,q=0;q<h.l.length;q++)h.l[q].G(g,k,l,m,p);break;case 70:h=a;k=c;l=d;m=f;for(p=0;p<h.g.length;p++)h.g[p].qa(g,k,l,m);break;case 71:Kd(a,g,c,d);break;default:Ja(g)}}}\nfunction Jd(a,b,c,d){for(var e=0;e<b.length;e++){var f=b[e],g=f.j;switch(g){case 72:g=a;for(var h=c,k=d,l=0;l<g.i.length;l++)g.i[l].ra(f);k.push(f);Ld(g,f.h,h,k,-1);k.pop();break;case 70:g=a;h=c;k=d;l=e;for(var m=0;m<g.g.length;m++)g.g[m].qa(f,h,k,l);break;case 71:Kd(a,f,c,d);break;case 73:Md||(Md=!0,console.warn(new Gd("Unexpected qualified rule encountered in stylesheet: "+c)));break;case 82:Id(a,f,d);break;default:Ja(g)}}}var Md=!1;function Nd(a,b){this.l=a;this.i=b;this.g=[]}\nNd.prototype.qa=function(a,b,c,d){if("import"===a.m)if(c=c[c.length-1],82===c.j||71===c.j){var e=Bb(a.v);if(4===e[0].j||5===e[0].j){var f=e[0].h,g=1;if(g<e.length){var h=e[g];80===h.j&&"supports"===h.m&&(h=tb("supports",[{j:61,h:h.h}],null),c.h&&0<c.h.length?c.h[d]=h:c.h=[h],c=h,d=0,g++)}if(g<e.length){e=e.slice(g);g=Array(2*e.length-1);for(var k=h=0;k<e.length-1;k++)g[h++]=e[k],g[h++]=M();0<e.length&&(g[h++]=e[e.length-1]);e=tb("media",g,null);c.h&&0<c.h.length?c.h[d]=e:c.h=[e];c=e;d=0}Od(this,f,\nb,a,c,d)}}else Sa("Ignored @import rule. Parent was not a stylesheet")};function Od(a,b,c,d,e,f){b=Pd(a.l,b,c).then(function(g){if(a.i.has(g.$.url))Sa(\'CSS file "\'+g.$.url+\'" defined or imported multiple times in document.\'),d.C=!0;else{a.i.add(g.$.url);var h=U(g.B,g.$.url);g=new Hd;var k=new Nd(a.l,a.i);g.g.push(k);Id(g,h,[]);return Promise.all(k.g).then(function(){e.h&&0<e.h.length?e.h[f]=h:e.h=[h]})}}).catch(function(g){E(g)});a.g.push(b)};function Qd(){this.la=null}Qd.prototype.getResult=function(){return null};Qd.prototype.M=function(){return this.la?Promise.all(this.la.g):Promise.resolve()};Qd.prototype.D=function(a,b,c){this.la=new Nd(b,new Set(c));a.g.push(this.la)};function Rd(a){this.o=a}function Sd(a,b){return xb("calc",[a,{j:10,h:" "},{j:11,h:"+"},{j:10,h:" "},Td(b)])}function Td(a){return a.isPercentage?{j:42,J:"em",h:a.value/100}:{j:42,J:"px",h:a.value}}function Wd(a,b){switch(a.h){case "normal":return 3;case "initial":return 3;case "revert":return 3;case "unset":return b?3:1}return 0}\nRd.prototype.G=function(a,b,c){if("word-spacing"===a.m)switch(b=a.h[0],42===b.j?2:40===b.j?3:0===b.j?Wd(b,!!Db(c)):1){case 0:a.C=!0;break;case 2:a.h=[Sd(b,this.o)];break;case 3:a.h=[Td(this.o)]}};function Xd(a){this.o=a}Xd.prototype.G=function(a,b,c){if("letter-spacing"===a.m)switch(b=a.h[0],42===b.j?2:40===b.j?3:0===b.j?Wd(b,!!Db(c)):1){case 0:a.C=!0;break;case 2:a.h=[Sd(b,this.o)];break;case 3:a.h=[Td(this.o)]}};function Yd(a){this.o=a}Yd.prototype.O=function(){return"html{letter-spacing:0}"};Yd.prototype.getResult=function(){return null};Yd.prototype.D=function(a){V(a,new Xd(this.o))};function Zd(a){this.g=a}Zd.prototype.G=function(a){"line-height"===a.m?$d(a.h[0],this.g):"font"===a.m&&(a=bd(a))&&a.lineHeight&&$d(a.lineHeight,this.g)};function $d(a,b){Fb(a)?a.h*=b:"normal"===a.h&&(a.j=40,a.h=1.2*b)};function ae(a){this.u=new Zd(a.scaleFactor)}ae.prototype.getResult=function(){return null};ae.prototype.M=function(a){var b=hc("html","line-height: "+1.2*this.u.g);a.h.push(b);return Promise.resolve()};ae.prototype.D=function(a){V(a,this.u)};function be(){}be.prototype.Z=function(){return\'math{display:inline-block;font-family:serif}merror{color:red}mi{font-style:oblique}mfenced:before{content:"("}mfenced[open="["]:before{content:"["}mfenced[open="{"]:before{content:"{"}mfenced:after{content:")"}mfenced[close="]"]:after{content:"]"}mfenced[close="}"]:after{content:"}"}mfenced>*+:before{content:", "}mphantom{visibility:hidden}msup>*+*{vertical-align:top}msub>*+*,msup>*+*{display:inline-block;font-size:.7em}msub>*+*{vertical-align:bottom}mfrac{display:inline-block;font-size:.85em;text-align:center;vertical-align:middle}mfrac>*{display:list-item;list-style:none;padding-left:.25em;padding-right:.25em}mfrac>*+*,mroot,msqrt{border-top:.1em solid}mroot,msqrt{display:inline-block;font-size:.85em;margin-left:.5em;padding-left:.25em;padding-right:.25em;position:relative;vertical-align:middle}mroot:before,msqrt:before{border-bottom:.125em solid;border-right:.0675em solid;content:"";height:1em;left:-.35em;top:-.25em;-webkit-transform:skew(-11.25deg,63.435deg);transform:skew(-11.25deg,63.435deg);width:.25em}mroot:before,mroot>*+*,msqrt:before{display:inline-block;position:absolute}mroot>*+*{font-size:.5em;padding-right:.25em;right:100%;top:-.375em}mtable{display:inline-block;vertical-align:middle}mtable>*{display:table-row}mtr>*{display:table-cell}mtr>mi,mtr>mn,mtr>mo,mtr>mrow{padding-left:.25em;padding-right:.25em}[mathvariant=bold-italic],[mathvariant=bold-sans-serif],[mathvariant=bold],[mathvariant=sans-serif-bold-italic]{font-style:normal;font-weight:700}[mathvariant=monospace]{font-family:monospace;font-style:normal}[mathvariant=bold-sans-serif],[mathvariant=sans-serif-bold-italic],[mathvariant=sans-serif-italic],[mathvariant=sans-serif]{font-family:sans-serif;font-style:normal}[mathvariant=bold-italic],[mathvariant=italic],[mathvariant=sans-serif-bold-italic],[mathvariant=sans-serif-italic]{font-style:italic}[mathvariant=normal]{font-style:normal}semantics>:first-child{display:inline}annotation,annotation-xml{display:none!important;font-family:monospace}math:active>semantics>:first-child{display:none!important}math:active annotation:first-of-type{display:inline!important}\'};\nbe.prototype.getResult=function(){return null};function ce(){}function de(a,b){for(var c=0;c<b.length;c++){var d=b[c];17===d.j?d.h="\\\\:":(62===d.j||61===d.j)&&de(a,d.h)}}ce.prototype.ra=function(a){Fa(a.v)&&de(this,a.v)};function ee(){}ee.prototype.getResult=function(){return null};ee.prototype.D=function(a){a.i.push(new ce)};function fe(){this.g=!1;this.i=[];this.l=[]}fe.prototype.G=function(a,b,c){switch(a.m){case "text-indent":case "margin-left":ge(this,a,c);break;case "margin":ge(this,a,c);he(this,a,c);break;case "margin-top":he(this,a,c)}};function ge(a,b,c){var d=[];b=b.h;for(var e=0;e<b.length;e++){var f=b[e];42!==f.j&&41!==f.j||d.push(f)}switch(d.length){case 1:d=d[0];break;case 2:case 3:d=d[1];break;default:d=d[3]}d&&0>d.h&&((c=ie(c))?a.i.push(c):a.g=!0)}\nfunction he(a,b,c){(b=b.h[0])&&(42===b.j||41===b.j)&&0>b.h&&(c=ie(c))&&a.l.push(c)}function ie(a){for(var b=null,c=a.length-1;0<=c&&!b;c--)72===a[c].j&&(b=uc(a[c].v),-1!==b.indexOf("|")&&(b=null));return b};function je(){this.u=new fe}je.prototype.getResult=function(){return{hasInlineNegativeHorizontalMarginStyles:this.u.g,negativeHorizontalMarginSelectors:this.u.i,negativeVerticalMarginSelectors:this.u.l}};je.prototype.D=function(a){V(a,this.u)};function ke(){this.i=[];this.g=[]}ke.prototype.G=function(a,b,c,d,e){if("overflow-x"===a.m&&"visible"!==uc(a.h))if(-1===e)for(a=c.length-1;0<=a;a--){if(b=c[a],72===b.j){c=uc(b.v);this.g.push(c.trim());break}}else this.i.push(e)};function le(){this.u=new ke}le.prototype.getResult=function(){return{elementIndexes:this.u.i,selectors:this.u.g}};le.prototype.D=function(a){V(a,this.u)};function me(){this.g="";this.i=null}me.prototype.G=function(a,b,c){if("background"===a.m||"background-color"===a.m)if(b=Cb(c,!0),"html"===b||"body"===b&&"html"!==this.i){a=a.h;var d;var e=-1;c=0;for(d=a.length;c<d;c++)22===a[c].j&&(e=c);var f=null;for(c=e+1;c<d;c++)e=a[c],Eb(e)&&(f=O(e,Hb,Hb));if(a=f&&0!==f.alpha?f.toString():null)this.g=a,this.i=b}};function ne(){this.u=new me}ne.prototype.getResult=function(){return{backgroundColor:this.u.g}};ne.prototype.D=function(a){V(a,this.u)};function oe(){this.g=0;this.i=[]}\noe.prototype.ra=function(a){a=a.v;for(var b=0;b<a.length;b++)if(20===a[b].j){var c;a:{if(c=a[b+1])if(0===c.j)switch(c.h){case "first-child":case "last-child":case "only-child":case "first-of-type":case "last-of-type":case "only-of-type":c="data-colibrio-"+c.h;break a}else if(80===c.j&&80===c.j)switch(c=c.m,c){case "nth-child":case "nth-last-child":case "nth-of-type":case "nth-last-of-type":c="data-colibrio-"+c;break a}c=void 0}if(c){var d=cc("["+c+\'~="\'+this.g+\'"]\'),e=uc(a.slice(0,b+2));this.i.push({attributeName:c,\nattributeValue:this.g,selector:e});this.g++;a.splice.apply(a,[b,2].concat(w(d)))}}};function pe(){this.u=null}pe.prototype.getResult=function(){var a,b;return null!=(b=null==(a=this.u)?void 0:a.i)?b:[]};pe.prototype.D=function(a){this.u=new oe;a.i.push(this.u)};function qe(a,b){this.i=a;this.g=b}qe.prototype.G=function(a){var b=this;"text-align"===a.m&&a.h.forEach(function(c){0!==c.j||b.i.includes(c.h)||(c.h=b.g)})};function re(a){this.o=a}re.prototype.O=function(){return"html { text-align: "+this.o.defaultAlignment+" }"};re.prototype.getResult=function(){return null};re.prototype.D=function(a){V(a,new qe(this.o.preserved,this.o.defaultAlignment))};function se(a){this.o=a}se.prototype.Z=function(){var a=[];this.o.fullTouchActionSupport?(this.o.nativePanXAllowed&&a.push("pan-x"),this.o.nativePanYAllowed&&a.push("pan-y"),0===a.length&&a.push("none")):a.push("manipulation");return 0<a.length?"html, body { touch-action: "+a.join(" ")+" !important }":""};se.prototype.getResult=function(){return null};function te(){}te.prototype.getResult=function(){return null};te.prototype.D=function(a){var b;(b=ue)||(b=ue=new Set("column column-count column-fill column-rule column-span column-width".split(" ")));V(a,new rc(b))};var ue;function ve(a,b,c){this.i=a;this.l=b;this.s=c;this.g=new Map}ve.prototype.G=function(a,b,c,d,e){a.C||we(this,a,b,c,e)};function xe(a){var b=[];a.g.forEach(function(c){c=a.l?ye(a,c):ze(a,c);b.push(c)});return Promise.all(b)}function ye(a,b){return qd(a.i,b.R,b.wa,["image/*"]).then(function(c){for(var d=0;d<b.T.length;d++)b.T[d].h=c.B}).catch(function(c){Sa(c);for(c=0;c<b.T.length;c++)b.T[c].h=""})}\nfunction ze(a,b){return rd(a.i,b.R,b.wa,["image/*"]).then(function(c){for(var d=0;d<b.T.length;d++)b.T[d].h=c}).catch(function(c){Sa(c);for(c=0;c<b.T.length;c++)b.T[c].h=""})}\nfunction we(a,b,c,d,e){for(var f=0;f<b.h.length;f++){var g=b.h[f];if(5===g.j)if(/^\\s*data:/.test(g.h))g=(g=/^\\s*data:([a-z]+\\/[a-z]+)/.exec(g.h))&&g[1]?g[1]:null,g&&g.startsWith("image/")||(81===b.j?b.C=!0:(b.h.splice(f,1),f--));else{var h=g.h;if(h){var k=a.g.get(h);k||(k={wa:c,R:h,T:[]},a.g.set(h,k));k.T.push(g)}else a.s||(b.h.splice(f,1),f--)}else 61!==g.j&&80!==g.j||we(a,g,c,d,e)}};function Ae(a){this.o=a;this.ka=null}Ae.prototype.getResult=function(){return null};Ae.prototype.M=function(){return this.ka?xe(this.ka):Promise.resolve()};Ae.prototype.D=function(a,b){this.ka=new ve(b,this.o.inline,this.o.allowRemoteResources);V(a,this.ka)};function Be(){}Be.prototype.G=function(a){switch(a.m){case "user-select":case "-webkit-user-select":case "-moz-user-select":case "-ms-user-select":for(var b=a.h,c=0;c<b.length&&!a.C;c++){var d=b[c];0===d.j&&"text"!==d.h&&"none"!==d.h&&(a.C=!0)}}};function Ce(){}Ce.prototype.O=function(){return"body{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}"};Ce.prototype.getResult=function(){return null};Ce.prototype.M=function(){return Promise.resolve(void 0)};Ce.prototype.D=function(a){V(a,new Be)};function De(){var a;(a=Ee)||(a=Ee=new Set("animation animation-delay animation-duration animation-fill-mode animation-iteration-count animation-name animation-play-state animation-timing-function column column-count column-fill column-rule column-span column-width transition transition-delay transition-duration transition-property transition-timing-function".split(" ")));this.g=a}\nDe.prototype.G=function(a,b,c){var d;/^-webkit-/.test(a.m)?d=a.m.slice(8):/^-ms-/.test(a.m)?d=a.m.slice(4):/^-moz-/.test(a.m)&&(d=a.m.slice(5));d&&Fe(this,d,a,c)};function Fe(a,b,c,d){a.g.has(b)&&(a=Ba(d))&&72===a.j&&(a.h.some(function(e){return e.m===b})?c.C=!0:c.m=b)};function Ge(){}Ge.prototype.getResult=function(){return null};Ge.prototype.D=function(a){V(a,new De)};var Ee;function He(a){this.g=a}He.prototype.G=function(a){for(var b=0;b<a.h.length;b++){var c=a.h[b];42===c.j&&"vh"===c.J&&(c.h=c.h/100*this.g,c.J="px")}};function Ie(a){this.o=a}Ie.prototype.getResult=function(){return null};Ie.prototype.D=function(a){V(a,new He(this.o.pageHeight))};function Je(a){this.o=a}Je.prototype.O=function(){return"html{word-spacing:0}"};Je.prototype.getResult=function(){return null};Je.prototype.D=function(a){V(a,new Rd(this.o))};function Ke(a,b,c){var d=a.options;switch(a.name){case "animationDisabler":var e=new sc;break;case "animationExtractor":e=new Gc(c);break;case "backgroundImageFilter":e=new Lc(d,b);break;case "customCss":e=new Nc(d);break;case "customPalette":e=new Vc(d);break;case "customUnprocessedCss":e=new Wc(d,c);break;case "defaultCss":e=new Yc(d);break;case "defaultReflowableCss":e=new Zc;break;case "firstPseudoSelectorRewriter":e=new ad;break;case "fontLoader":e=new td(d);break;case "fontReset":e=new yd(d);\nbreak;case "fontScale":e=new Dd(d);break;case "forceOpaqueDocumentBackground":e=new Fd;break;case "import":e=new Qd;break;case "letterSpacing":e=new Yd(d);break;case "lineHeightScale":e=new ae(d);break;case "mathMLFallback":e=new be;break;case "namespaceRemover":e=new ee;break;case "negativeMarginDetector":e=new je;break;case "overflowXDetector":e=new le;break;case "pageBackgroundGetter":e=new ne;break;case "touchAction":e=new se(d);break;case "unsupportedReflowDeclarationRemover":e=new te;break;\ncase "urlLoader":e=new Ae(d);break;case "userSelectText":e=new Ce;break;case "vendorUnprefixer":e=new Ge;break;case "vhToPx":e=new Ie(d);break;case "textAlign":e=new re(d);break;case "pseudoSelectorRewriter":e=new pe;break;case "wordSpacing":e=new Je(d);break;case "activeElementCssOverride":e=new qc(d)}return e};function Le(a,b,c){this.N=a;this.s=b;this.va=c;this.I=new Set;this.i=!1;this.F=[];this.l=[];this.g=[];b=ab();(c=b.g.get(a))?c.U++:b.g.set(a,{U:1,ea:new Set})}\nfunction Me(a,b){var c,d,e,f,g,h,k,l,m,p,q,u,z,B,Ca,ob,Ud,pb,Vd;return wa(new va(new ra(function(ca){switch(ca.i){case 1:if(a.i)throw new F("ABORTED");c=[];d=[];e=[];f=[];g=v(b.passes);for(h=g.next();!h.done;h=g.next()){k=h.value;l=[];m=v(k.pluginEntries);for(p=m.next();!p.done;p=m.next())q=p.value,u=Ke(q,a.va,a.N),c.push(u),l.push(u),u.O&&e.push(u.O()),u.Z&&f.push(u.Z());d.push(l)}z=U(e.join("\\n"),a.N);B=U(f.join("\\n"),a.N);return qa(ca,Promise.all(a.F),2);case 2:if(a.i)throw new F("ABORTED");Ua.sort(a.g,\nfunction(R,bf){return R.ca-bf.ca});Ca=v(d);ob=Ca.next();case 3:if(ob.done){ca.i=5;break}Ud=ob.value;return qa(ca,Ne(a,Ud,z,B),6);case 6:if(a.i)throw new F("ABORTED");ob=Ca.next();ca.i=3;break;case 5:return pb=b.compiledStylesheetsAsUrls,Vd={channelId:b.channelId,declarationLists:a.l.map(function(R){return vc(R)}),extraCssAfter:Oe(a,B,pb),extraCssBefore:Oe(a,z,pb),pluginResults:c.map(function(R){return R.getResult()}),stylesheets:a.g.map(function(R){return Oe(a,R.fa,pb)}),type:5},a.g=[],a.l=[],a.F=\n[],ca.return(Vd)}})))}function Pe(a,b){a.i||(a.l=b.items.map(function(c){return ec(c)}))}function Qe(a,b,c){var d=Pd(a.s,b).then(function(e){if(!a.i&&(a.I.add(e.$.url),!Re(a,b,c))){e=U(e.B,b);var f=JSON.stringify(e);db(ab(),a.N,b,f);a.g.push({ca:c,fa:e})}}).catch(function(e){Pa(e)||E(e);a.g.push({ca:c,fa:U(" ",b)})});a.F.push(d)}\nfunction Re(a,b,c){var d=ab(),e=d.g.get(a.N);var f=null;e&&(f=d.i.get(b))&&!e.ea.has(b)&&(e.ea.add(b),d=d.i,b=d.i.get(b))&&(b.B.U++,Xa(d,b,!0));f&&(b=JSON.parse(f),a.g.push({ca:c,fa:b}));return null!==f}\nfunction Oe(a,b,c){b=xc(b);if(c){a=a.s;if(a.l)throw new F("ABORTED");if(a.I)b=URL.createObjectURL(new Blob(Fa(b)?b:[b],{type:"text/css"}));else if(C(b))b="data:text/css;charset=UTF-8,"+encodeURIComponent(b);else{if(Fa(b)){for(var d=c=0;d<b.length;d++)c+=b[d].byteLength;c=new Uint8Array(c);for(var e=d=0;e<b.length;e++)c.set(new Uint8Array(b[e]),d),d+=b[e].byteLength}else c=new Uint8Array(b);b="data:text/css;base64,"+Se.fromByteArray(c)}a.s.push(b)}return b}\nfunction Ne(a,b,c,d){var e,f,g,h,k,l,m,p,q,u,z,B;return wa(new va(new ra(function(Ca){e=new Hd;for(f=0;f<b.length;f++)g=b[f],g.D&&g.D(e,a.s,a.I);Id(e,c,[]);h=v(a.g);for(k=h.next();!k.done;k=h.next())l=k.value,Id(e,l.fa,[]);Id(e,d,[]);for(m=0;m<a.l.length;m++)p=a.l[m],Ld(e,p,a.N,[zb([],p)],m);q=[];for(u=0;u<b.length;u++)z=b[u],z.M&&(B=z.M(c,d),q.push(B));return qa(Ca,Promise.all(q),0)})))};var Se=__lib__base64_js;var Te=new G({ua:Number.MAX_SAFE_INTEGER,na:16E6,oa:6,da:1E4}),Ue=new G({ua:Number.MAX_SAFE_INTEGER,na:16E6,oa:6,da:1E4});function Ve(a,b,c,d){this.I=a;this.F=b;this.i=c;this.g=d;this.s=[];this.l=!1}\nfunction qd(a,b,c,d){return Mc(a.g,{baseUrl:c,channelId:a.i,href:b,type:11}).then(function(e){var f=e.url,g=Te.get(f);g||(g=Mc(a.g,{accept:d,channelId:a.i,type:15,url:e.url}).then(function(h){var k=h.metadata.mediaType;h={B:"data:"+(k?k:"")+";base64,"+Se.fromByteArray(h.data),$:h.metadata};H(Te,f);Te.set(f,Promise.resolve(h),2*h.B.length);return h}).catch(function(h){H(Te,f);return Promise.reject(h)}),Te.set(f,g,0));return g})}\nfunction rd(a,b,c,d){return Mc(a.g,{accept:d,baseUrl:c,channelId:a.F,href:b,type:9}).then(function(e){return e.data})}function Pd(a,b,c){var d=["text/css"];return Mc(a.g,{baseUrl:c,channelId:a.i,href:b,type:11}).then(function(e){var f=e.url,g=Ue.get(f);g||(g=Mc(a.g,{accept:d,channelId:a.i,type:13,url:e.url}).then(function(h){h={B:h.data,$:h.metadata};H(Ue,f);Ue.set(f,Promise.resolve(h),2*h.B.length);return h}).catch(function(h){H(Ue,f);return Promise.reject(h)}),Ue.set(f,g,0));return g})};function We(){this.g=new Map;this.i=new Map}\nfunction Xe(a,b,c){switch(b.type){case 1:if((a=a.g.get(b.channelId))&&!a.i&&!Re(a,b.url,b.index))if(null!==b.css){c=b.url;var d=b.index;b=U(b.css,c);var e=JSON.stringify(b);db(ab(),a.N,c,e);a.g.push({ca:d,fa:b})}else Qe(a,b.url,b.index);break;case 2:a.g.has(b.channelId)&&console.warn("CSS compiler already created for channelId: "+b.channelId);(d=a.i.get(b.channelId))?(c=new Le(b.documentUrl,d,c),a.g.set(b.channelId,c)):console.error("Resource provider not found for channel id: "+b.channelId);break;\ncase 3:if(c=a.g.get(b.channelId))c.i||(c.i=!0,cb(ab(),c.N),c.g=[],c.l=[]),a.g.delete(b.channelId);break;case 6:(a=a.g.get(b.channelId))&&Pe(a,b);break;case 7:a.i.has(b.channelId)&&console.warn("Resource Provider already created for channelId: "+b.channelId);a.i.set(b.channelId,new Ve(b.blobUrlSupported,b.channelId,b.resourceProviderChannelId,c));break;case 8:if(c=a.i.get(b.channelId)){if(!c.l)for(c.l=!0,d=0;d<c.s.length;d++)URL.revokeObjectURL(c.s[d]);a.i.delete(b.channelId)}break;default:console.error("Invalid EPUB worker message type: "+\nb.type)}}function Ye(a,b){switch(b.type){case 4:a=a.g.get(b.channelId);if(!a)throw new F("CSS_COMPILER_NOT_FOUND","channelId: "+b.channelId);return Me(a,b)}throw new F("INVALID_REQUEST_TYPE","type: "+b.type);};function Ze(a,b,c){this.F=a;this.ha=b;this.ia=c;this.P=!1;this.ba=null;this.i=new Map;this.ja=this.l=1;this.g=[];this.I=-1}function Mc(a,b){if(!a.P)throw new X(a.F,"NOT_CONNECTED");b={msg:b,msgId:a.ja++,type:3};var c=$e(a,b);try{af(a,b)}catch(d){a.ja--,b.msg=d.toString(),cf(a,b)}return c}\nfunction cf(a,b){var c=a.i.get(b.msgId);c&&(a.i.delete(b.msgId),-1!==c.ga&&clearTimeout(c.ga),a=(b=b.msg)&&b.errorMessage&&b.errorType?new X(a.F,"ABORTED"===b.errorType?"ABORTED":"REMOTE_ERROR",b.errorType+" :: "+b.errorMessage+" :: "+b.stack):new X(a.F,"ABORTED"===(null==b?void 0:b.errorType)?"ABORTED":"REMOTE_ERROR",C(b)?b:JSON.stringify(b)),c.La(a))}function df(a,b){var c=a.i.get(b.msgId);c&&(a.i.delete(b.msgId),-1!==c.ga&&clearTimeout(c.ga),c.Ma(b.msg))}\nfunction ef(a){a.ba||(a.ba=function(b){if(ff(b))switch(b=b.data,b.type){case 2:a.P=!0;df(a,b);break;case 3:case 4:a.l===b.msgId?(a.l++,gf(a,b),0<a.g.length&&hf(a,!1)):jf(a,b);break;case 5:df(a,b);break;case 6:cf(a,b)}});return a.ba}function jf(a,b){console.log("Incoming out of order message: ",b.msgId,", expected: ",a.l);var c=a.g.findIndex(function(d){return d.msgId>b.msgId});0<=c?a.g.splice(c,0,b):a.g.push(b);-1===a.I&&(a.I=setTimeout(function(){a.I=-1;hf(a,!0)},2E3))}\nfunction gf(a,b){switch(b.type){case 3:try{Ye(a.ia,b.msg).then(function(c){if(c&&c.Pa&&c.message){var d=c.Pa;c=c.message}a.P&&af(a,{msg:c,msgId:b.msgId,type:5},d)}).catch(function(c){c&&"ABORTED"!==c.errorType&&console.error(c);kf(a,b,c)})}catch(c){c&&"ABORTED"!==c.errorType&&console.error(c),kf(a,b,c)}break;case 4:Xe(a.ia,b.msg,a)}}function hf(a,b){for(;0<a.g.length&&(b||a.g[0].msgId===a.l);){var c=a.g.shift();a.l=c.msgId+1;gf(a,c)}0===a.g.length&&-1!==a.I&&clearTimeout(a.I)}\nfunction kf(a,b,c){var d;c&&C(c.errorType)&&C(c.errorMessage)?d={errorMessage:c.errorMessage,errorType:c.errorType,stack:C(c.stack)?c.stack:""}:c&&(c.message?d={errorMessage:c.message,errorType:c.constructor?c.constructor.name:""+c,stack:C(c.stack)?c.stack:""}:d=C(c.stack)?c.stack:""+c);af(a,{msg:d,msgId:b.msgId,type:6})}\nfunction $e(a,b){return new Promise(function(c,d){c={La:d,Ma:c,ga:-1};a.i.set(b.msgId,c);c.ga=setTimeout(function(){a.i.has(b.msgId)&&(a.i.delete(b.msgId),d(new X(a.F,"TIMEOUT")))},a.ha)})};function lf(a,b,c,d){Ze.call(this,b,c,d);this.s=a}ma(lf,Ze);function ff(a){a=a.data;return Ga(a.type)&&Ga(a.msgId)}function af(a,b,c){c?a.s.postMessage(b,c):a.s.postMessage(b)};(function(){var a=new lf(self,"colibrio.readingsystem.formatadapter.epub.webworker",2E4,new We);return new Promise(function(b,c){function d(f){if(ff(f))if(f=f.data,a.s.removeEventListener("message",d,!1),1===f.type){a.P=!0;a.l=f.msgId+1;var g=ef(a);a.s.addEventListener("message",g,!1);af(a,{msg:null,msgId:f.msgId,type:2});clearTimeout(e);b()}else c("Received invalid connect message")}var e=setTimeout(function(){a.s.removeEventListener("message",d,!1);c(new X(a.F,"TIMEOUT"))},a.ha);a.s.addEventListener("message",\nd,!1)})})().catch(function(a){console.error(a)});var mf=new ArrayBuffer(8);new DataView(mf);new Uint8Array(mf); }).call(__self); })(typeof self !== \'undefined\' && self ? self : typeof window !== \'undefined\' && window ? window : typeof global !== \'undefined\' && global ? global : this)\n';
    var api = {};
    (function() {
        var k, q = q || {};
        q.scope = {};
        q.fg = function(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        };
        q.Ch = function(a) {
            return {
                next: q.fg(a)
            };
        };
        q.xf = !1;
        q.bi = !1;
        q.ci = !1;
        q.fi = !1;
        q.Af = !1;
        q.di = !1;
        q.ei = !1;
        q.defineProperty = q.xf || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        q.Ih = function(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        };
        q.global = q.Ih(this);
        q.se = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
        q.ue = !q.Af || q.se;
        q.qf = {};
        q.rf = {};
        q.Kg = "$jscp$";
        q.pf = function(a, b, c) {
            b && (q.Af ? q.Vh(a, b, c) : q.Wh(a, b));
        };
        q.Wh = function(a, b) {
            var c = q.global;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) return;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && q.defineProperty(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        };
        q.Vh = function(a, b, c) {
            var d = a.split(".");
            a = 1 === d.length;
            var e = d[0], f;
            !a && e in q.qf ? f = q.qf : f = q.global;
            for(e = 0; e < d.length - 1; e++){
                var g = d[e];
                if (!(g in f)) return;
                f = f[g];
            }
            d = d[d.length - 1];
            c = q.se && "es6" === c ? f[d] : null;
            b = b(c);
            null != b && (a ? q.defineProperty(q.qf, d, {
                configurable: !0,
                writable: !0,
                value: b
            }) : b !== c && (void 0 === q.rf[d] && (a = 1E9 * Math.random() >>> 0, q.rf[d] = q.se ? q.global.Symbol(d) : q.Kg + a + "$" + d), q.defineProperty(f, q.rf[d], {
                configurable: !0,
                writable: !0,
                value: b
            })));
        };
        q.ri = function() {};
        q.pf("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, g) {
                this.g = f;
                q.defineProperty(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        }, "es6");
        q.pf("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = q.global[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && q.defineProperty(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return q.Kh(q.fg(this));
                    }
                });
            }
            return a;
        }, "es6");
        q.Kh = function(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        };
        q.ni = function(a) {
            return a.raw = a;
        };
        q.oi = function(a, b) {
            a.raw = b;
            return a;
        };
        q.na = function(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return q.Ch(a);
            throw Error(String(a) + " is not an iterable or ArrayLike");
        };
        q.Bh = function(a) {
            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
            return c;
        };
        q.Qc = function(a) {
            return a instanceof Array ? a : q.Bh(q.na(a));
        };
        q.Uh = function(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        };
        q.assign = q.ue && "function" == typeof Object.assign ? Object.assign : function(a, b) {
            for(var c = 1; c < arguments.length; c++){
                var d = arguments[c];
                if (d) for(var e in d)q.Uh(d, e) && (a[e] = d[e]);
            }
            return a;
        };
        q.pf("Object.assign", function(a) {
            return a || q.assign;
        }, "es6");
        q.xg = q.xf || "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        };
        q.Hh = function() {
            function a() {
                function c() {}
                new c;
                Reflect.construct(c, [], function() {});
                return new c instanceof c;
            }
            if (q.ue && "undefined" != typeof Reflect && Reflect.construct) {
                if (a()) return Reflect.construct;
                var b = Reflect.construct;
                return function(c, d, e) {
                    c = b(c, d);
                    e && Reflect.setPrototypeOf(c, e.prototype);
                    return c;
                };
            }
            return function(c, d, e) {
                void 0 === e && (e = c);
                e = q.xg(e.prototype || Object.prototype);
                return Function.prototype.apply.call(c, e, d) || e;
            };
        };
        q.construct = ({
            valueOf: q.Hh
        }).valueOf();
        q.$h = function() {
            var a = {
                a: !0
            }, b = {};
            try {
                return b.__proto__ = a, b.a;
            } catch (c) {}
            return !1;
        };
        q.setPrototypeOf = q.ue && "function" == typeof Object.setPrototypeOf ? Object.setPrototypeOf : q.$h() ? function(a, b) {
            a.__proto__ = b;
            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
            return a;
        } : null;
        q.inherits = function(a, b) {
            a.prototype = q.xg(b.prototype);
            a.prototype.constructor = a;
            if (q.setPrototypeOf) {
                var c = q.setPrototypeOf;
                c(a, b);
            } else for(c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.si = b.prototype;
        };
        q.cb = {};
        q.cb.Gh = function(a) {
            if (!(a instanceof Object)) throw new TypeError("Iterator result " + a + " is not an object");
        };
        q.cb.Xc = function() {
            this.H = !1;
            this.A = null;
            this.h = void 0;
            this.g = 1;
            this.o = this.m = 0;
            this.Z = this.j = null;
        };
        function aa(a) {
            if (a.H) throw new TypeError("Generator is already running");
            a.H = !0;
        }
        q.cb.Xc.prototype.U = function(a) {
            this.h = a;
        };
        function ca(a, b) {
            a.j = {
                kg: b,
                wg: !0
            };
            a.g = a.m || a.o;
        }
        q.cb.Xc.prototype.return = function(a) {
            this.j = {
                return: a
            };
            this.g = this.o;
        };
        function r(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        q.cb.Xc.prototype.$ = function(a) {
            this.g = a;
        };
        function da(a, b, c) {
            a.m = b;
            void 0 != c && (a.o = c);
        }
        function fa(a) {
            a.m = 0;
            var b = a.j.kg;
            a.j = null;
            return b;
        }
        function ia(a) {
            a.Z = [
                a.j
            ];
            a.m = 0;
            a.o = 0;
        }
        function ja(a, b) {
            var c = a.Z.splice(0)[0];
            (c = a.j = a.j || c) ? c.wg ? a.g = a.m || a.o : void 0 != c.$ && a.o < c.$ ? (a.g = c.$, a.j = null) : a.g = a.o : a.g = b;
        }
        q.cb.Xc.g = function(a) {
            this.g = [];
            for(var b in a)this.g.push(b);
            this.g.reverse();
        };
        q.cb.yf = function(a) {
            this.g = new q.cb.Xc;
            this.h = a;
        };
        function la(a, b) {
            aa(a.g);
            var c = a.g.A;
            if (c) return ma(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return na(a);
        }
        function ma(a, b, c, d) {
            try {
                var e = b.call(a.g.A, c);
                q.cb.Gh(e);
                if (!e.done) return a.g.H = !1, e;
                var f = e.value;
            } catch (g) {
                return a.g.A = null, ca(a.g, g), na(a);
            }
            a.g.A = null;
            d.call(a.g, f);
            return na(a);
        }
        function na(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.H = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.h = void 0, ca(a.g, c);
            }
            a.g.H = !1;
            if (a.g.j) {
                b = a.g.j;
                a.g.j = null;
                if (b.wg) throw b.kg;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        q.cb.zf = function(a) {
            this.next = function(b) {
                aa(a.g);
                a.g.A ? b = ma(a, a.g.A.next, b, a.g.U) : (a.g.U(b), b = na(a));
                return b;
            };
            this.throw = function(b) {
                aa(a.g);
                a.g.A ? b = ma(a, a.g.A["throw"], b, a.g.U) : (ca(a.g, b), b = na(a));
                return b;
            };
            this.return = function(b) {
                return la(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        };
        q.cb.mi = function(a, b) {
            b = new q.cb.zf(new q.cb.yf(b));
            q.setPrototypeOf && a.prototype && q.setPrototypeOf(b, a.prototype);
            return b;
        };
        q.gg = function(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function f(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        };
        q.li = function(a) {
            return q.gg(a());
        };
        q.K = function(a) {
            return q.gg(new q.cb.zf(new q.cb.yf(a)));
        };
        q.pi = function() {
            for(var a = Number(this), b = [], c = a; c < arguments.length; c++)b[c - a] = arguments[c];
            return b;
        };
        var t = __dep__colibrio_core_base;
        var y = __dep__colibrio_core_io_base;
        var oa = __dep__colibrio_core_io_resourcecache;
        var qa = __dep__colibrio_core_locator;
        var ra = __dep__colibrio_core_media;
        var sa = __dep__colibrio_core_publication_base;
        var ta = __dep__colibrio_core_selector_base;
        var ua = __dep__colibrio_core_selector_epubcfi;
        var B = __dep__colibrio_core_url;
        var va = __dep__colibrio_core_xml;
        var D = __dep__colibrio_readingsystem_base;
        var E = __dep__colibrio_readingsystem_engine;
        function xa(a, b) {
            return a === b ? !0 : a.length !== b.length ? !1 : a.every(function(c, d) {
                return c === b[d];
            });
        }
        function ya(a, b, c, d) {
            return za(a, b, 0, c, d);
        }
        function za(a, b, c, d, e) {
            if (0 >= d) return -1;
            d = c + d - 1;
            for(var f = c, g = 1; g && c <= d;)f = c + d >>> 1, g = e(a, f), 0 > g ? d = f - 1 : 0 < g && (c = f + 1);
            0 !== g && 0 === b ? f = -1 : 0 > g && 1 === b ? f-- : 0 < g && 2 === b && f++;
            return f;
        }
        function Ca(a) {
            return a.reduce(function(b, c) {
                return b.concat(c);
            }, []);
        }
        function Da(a) {
            return 0 < a.length ? a[a.length - 1] : void 0;
        }
        function Ea(a) {
            return 32 === a || 12 === a || 10 === a || 13 === a || 9 === a || 11 === a || 133 === a || 160 === a || 5760 === a || 8192 <= a && 8202 >= a || 8232 === a || 8233 === a || 8239 === a || 8287 === a || 12288 === a || 65279 === a;
        }
        function H(a) {
            return a && 1 === a.nodeType;
        }
        function I(a) {
            return a && H(a) && "http://www.w3.org/1999/xhtml" === a.namespaceURI;
        }
        function Fa(a) {
            return a && H(a) && "http://www.w3.org/2000/svg" === a.namespaceURI;
        }
        function Ga(a) {
            return Ha(a) && /\S/.test(a);
        }
        function Ia(a) {
            return Ha(a) && /^\s*$/.test(a);
        }
        function J(a) {
            return a && 3 === a.nodeType;
        }
        function Ja(a) {
            return J(a) && Ga(a.data);
        }
        function Ka(a) {
            return "undefined" === typeof a;
        }
        function La(a, b, c) {
            return a < b ? b : a > c ? c : a;
        }
        function Ma(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), e = 0; e < d.length; e++){
                var f = d[e], g = a[f];
                null !== g && "object" === typeof g ? b[f] = Ma(g, b[f], c) : Ka(g) ? c && delete b[f] : b[f] = g;
            }
            return b;
        }
        function Na(a, b, c) {
            return Ma(a, b, c || !1);
        }
        function Oa(a, b) {
            var c;
            if (a && !Pa(a) && "object" === typeof a) {
                var d = Object.keys(a);
                var e = 0;
                for(c = d.length; e < c; e++){
                    var f = d[e];
                    b(a[f], f);
                }
            }
        }
        var Pa = Array.isArray;
        function Qa(a) {
            return "function" === typeof a;
        }
        function K(a) {
            return "number" === typeof a && !isNaN(a);
        }
        function Ha(a) {
            return "string" === typeof a;
        }
        function Ra(a, b) {
            if (a === b) return !0;
            var c = Math.abs(a - b);
            a = Math.abs(a);
            b = Math.abs(b);
            return c <= (b > a ? b : a) * Number.EPSILON;
        }
        function Sa(a, b, c, d, e) {
            return (e - d) / (c - b) * (a - b) + d;
        }
        function Ta(a, b) {
            var c = a.style;
            Oa(b, function(d, e) {
                Ha(c[e]) && (c[e] = d);
            });
        }
        function Wa(a, b) {
            for(var c = Math.min(a.length, b.length), d = 0; d < c; d++){
                var e = a[d], f = b[d];
                if (e < f) return -1;
                if (e > f) return 1;
            }
            return a.length === b.length ? 0 : a.length < b.length ? -1 : 1;
        }
        function Xa(a, b, c) {
            try {
                return a.comparePoint(b, c);
            } catch (e) {
                if (e instanceof DOMException && ("InvalidNodeTypeError" === e.name || "IndexSizeError" === e.name)) throw e;
            }
            if (b.ownerDocument !== a.startContainer.ownerDocument) throw new DOMException('Failed to execute Range.comparePoint and compareRangeWithDomPosition. The provided "range" and "container" belongs to a different documents', "WrongDocumentError");
            var d = b.ownerDocument.documentElement;
            b = Ya(d, b);
            b.push(c);
            c = Ya(d, a.startContainer);
            c.push(a.startOffset);
            c = Wa(b, c);
            if (a.collapsed || 1 !== c) return c;
            d = Ya(d, a.endContainer);
            d.push(a.endOffset);
            return 1 === Wa(b, d) ? 1 : 0;
        }
        function Za(a) {
            var b = [
                {
                    name: "style",
                    value: "position: absolute; z-index: -10000000; left: 0; right: 0; top: 0; bottom: 0; opacity: 0"
                },
                {
                    name: "id",
                    value: "colibrio-ios-nativezoom-preventer"
                }
            ];
            a = a.createElement("div");
            for(var c = 0; c < b.length; c++){
                var d = b[c];
                d.namespaceUri ? a.setAttributeNS(d.namespaceUri, d.name, d.value) : a.setAttribute(d.name, d.value);
            }
            return a;
        }
        function $a(a, b) {
            for(a = a.nextSibling; a;){
                if (b(a)) return a;
                a = a.nextSibling;
            }
            return null;
        }
        function ab(a, b) {
            for(a = a.previousSibling; a;){
                if (b(a)) return a;
                a = a.previousSibling;
            }
            return null;
        }
        function bb(a, b) {
            a = a.children;
            for(var c = 0, d = a.length; c < d; c++)b(a[c], c);
        }
        function M(a) {
            if (a.body) return a.body;
            var b = a.documentElement.children[1];
            return b && "body" === b.localName ? b : a.documentElement;
        }
        function N(a) {
            return a.ownerDocument.defaultView.getComputedStyle(a);
        }
        function cb(a, b) {
            for(var c = 0; b && b !== a;)b = b.parentNode, c++;
            return c;
        }
        function db(a) {
            for(var b = 0; a = a.previousSibling;)H(a) && b++;
            return b;
        }
        function eb(a) {
            return a.head ? a.head : a.firstElementChild && "head" === a.firstElementChild.localName ? a.firstElementChild : a.documentElement;
        }
        function fb(a) {
            a = H(a) ? a : a.parentNode;
            for(var b = null; !b && H(a);){
                if (b = a.getAttribute("lang") || a.getAttribute("xml:lang")) return b;
                a = a.parentNode;
            }
        }
        function gb(a, b) {
            for(var c = 0; c < a.length && b; c++)b = b.childNodes[a[c]] || null;
            return b;
        }
        function O(a) {
            for(var b = 0; a = a.previousSibling;)b++;
            return b;
        }
        function hb(a, b) {
            for(var c = []; b && b !== a;)c.push(b), b = b.parentNode;
            b && c.push(a);
            return c.reverse();
        }
        function Ya(a, b) {
            for(var c = []; b && b !== a;)c.push(O(b)), b = b.parentNode;
            return b === a ? c.reverse() : null;
        }
        function ib(a) {
            return ("auto" === N(a).overflowX || "scroll" === N(a).overflowX) && a.scrollWidth > a.clientWidth;
        }
        function jb(a) {
            return ("auto" === N(a).overflowY || "scroll" === N(a).overflowY) && a.scrollHeight > a.clientHeight;
        }
        function kb(a) {
            a = a.getBoundingClientRect();
            return 0 < a.width || 0 < a.height;
        }
        function lb(a) {
            return "base" === a || "head" === a || "link" === a || "meta" === a || "noscript" === a || "script" === a || "style" === a || "title" === a;
        }
        function mb(a) {
            var b = a.localName, c = [
                {
                    tag: "button"
                },
                {
                    tag: "details"
                },
                {
                    tag: "embed"
                },
                {
                    tag: "label"
                },
                {
                    tag: "select"
                },
                {
                    tag: "textarea"
                },
                {
                    tag: "iframe"
                },
                {
                    vd: "href",
                    tag: "a"
                },
                {
                    vd: "controls",
                    tag: "audio"
                },
                {
                    vd: "usemap",
                    tag: "img"
                },
                {
                    vd: "usemap",
                    tag: "object"
                },
                {
                    vd: "controls",
                    tag: "video"
                }
            ], d = "input" === b && "hidden" !== a.getAttribute("type");
            return a.hasAttribute("contenteditable") || d || c.some(function(e) {
                var f = e.tag;
                return (e = e.vd) ? f === b && a.hasAttribute(e) : f === b;
            });
        }
        function nb(a) {
            return H(a) ? "math" === a.localName : !1;
        }
        function ob(a) {
            if (I(a)) switch(a.localName){
                case "img":
                case "video":
                case "audio":
                    return !0;
            }
            return Fa(a) && "image" === a.localName;
        }
        function pb(a) {
            for(; a.firstChild;)a.removeChild(a.firstChild);
        }
        function qb(a) {
            var b = a.parentNode;
            b && b.removeChild(a);
        }
        function Q(a, b, c) {
            if (a.style) a.style.setProperty(b, c, "important");
            else {
                var d = a.getAttribute("style") || "";
                a.setAttribute("style", d + "; " + b + ": " + c + " !important;");
            }
        }
        function rb(a) {
            return "x" in a ? a : new DOMRect(a.left, a.top, a.width, a.height);
        }
        function sb() {
            return "function" === typeof WeakRef;
        }
        function tb(a, b) {
            return a.reduce(function(c, d) {
                return c.then(function() {
                    return b(d);
                });
            }, Promise.resolve());
        }
        function ub(a) {
            return q.K(function(b) {
                return b.return(new Promise(function(c) {
                    return setTimeout(c, a);
                }));
            });
        }
        var vb = new Uint16Array(1);
        vb[0] = 4660;
        new Uint8Array(vb.buffer);
        function wb(a) {
            var b, c, d, e;
            return q.K(function(f) {
                switch(f.g){
                    case 1:
                        b = 0, c = !1, d = [];
                    case 2:
                        if (c || !(1E3 > b)) {
                            f.$(4);
                            break;
                        }
                        return r(f, a.read(), 5);
                    case 5:
                        e = f.h;
                        e.value && (d.push(e.value), b += e.value.length);
                        c = e.done;
                        f.$(2);
                        break;
                    case 4:
                        var g = f.return;
                        if (0 === d.length) var h = new Uint8Array(0);
                        else if (1 === d.length) h = d[0];
                        else {
                            for(var l = h = 0; l < d.length; l++)h += d[l].byteLength;
                            h = new Uint8Array(h);
                            for(var m = l = 0; m < d.length; m++){
                                var n = d[m];
                                h.set(n, l);
                                l += n.byteLength;
                            }
                        }
                        return g.call(f, h);
                }
            });
        }
        function xb(a, b) {
            return "data:" + a + ";base64," + b;
        }
        function yb(a) {
            return (a = /^\s*data:([a-z]+\/[a-z]+)/.exec(a)) && a[1] ? a[1] : null;
        }
        function zb(a) {
            return /^\s*data:/.test(a);
        }
        function Ab(a, b) {
            a = yb(a);
            return !!a && a.startsWith(b);
        }
        function R(a, b) {
            this.j = !0;
            this.aa = this.g = a;
            this.h = b || null;
        }
        function S(a, b) {
            if (null === a.g) return 0;
            var c = a.m(b);
            for(a.j = !1; null !== a.g && a.h && !a.h(a.g);)c += a.m(b);
            return c;
        }
        R.prototype.next = function(a) {
            if (this.j && (!this.h || this.h(this.g))) return this.j = !1, this.g;
            S(this, a);
            return this.g;
        };
        function Bb(a, b) {
            a.aa = b;
        }
        R.prototype.m = function(a) {
            var b = this.g, c = 0;
            if (b.firstChild && (Qa(a) ? a(b) : a)) this.g = b.firstChild, c = 1;
            else if (b !== this.aa && b.nextSibling) this.g = b.nextSibling;
            else {
                for(; b !== this.aa && !b.nextSibling;)b = b.parentNode, c--;
                b === this.aa ? this.g = null : this.g = b.nextSibling;
            }
            return c;
        };
        var Cb = __lib__timsort;
        function Db() {
            this.g = [];
            this.h = [];
        }
        function Eb(a, b) {
            a.h.push(b);
        }
        function Fb(a, b) {
            if (0 < a.h.length) {
                var c = a.h.slice(), d = new R(b, function(m) {
                    return 1 === m.nodeType;
                });
                b = b.ownerDocument;
                for(var e = []; d.g;){
                    for(var f = d.g, g = f.localName, h = 0; h < c.length; h++){
                        var l = c[h];
                        try {
                            l.wa(f, g, b) && (e.push(l.va(f)), l.xa() && (c.splice(h, 1), h--));
                        } catch (m) {
                            t.Logger.logWarning(m);
                        }
                    }
                    S(d, !0);
                }
                Gb(a, e);
            }
        }
        k = Db.prototype;
        k.destroy = function() {
            this.h = [];
        };
        k.pb = function() {
            for(var a = 0; a < this.g.length; a++){
                var b = this.g[a];
                if (b.pb) try {
                    b.pb();
                } catch (c) {
                    t.Logger.logWarning(c);
                }
            }
            this.g = [];
        };
        k.hb = function() {
            for(var a = 0; a < this.g.length; a++){
                var b = this.g[a];
                if (b.hb) try {
                    b.hb();
                } catch (c) {
                    t.Logger.logWarning(c);
                }
            }
        };
        k.eb = function() {
            for(var a = 0; a < this.g.length; a++){
                var b = this.g[a];
                if (b.eb) try {
                    b.eb();
                } catch (c) {
                    t.Logger.logWarning(c);
                }
            }
        };
        k.ib = function() {
            for(var a = 0; a < this.g.length; a++){
                var b = this.g[a];
                if (b.ib) try {
                    b.ib();
                } catch (c) {
                    t.Logger.logWarning(c);
                }
            }
        };
        function Gb(a, b) {
            Cb.sort(b, function(c, d) {
                return (d.priority || 0) - (c.priority || 0);
            });
            a.g = 0 === a.g.length ? b : a.g.concat(b);
        }
        function Hb(a) {
            this.g = a;
            this.Ya = this.m = this.j = null;
            this.h = !1;
        }
        function Ib(a, b) {
            a.Ya = b;
            a.m = b;
            a.j = b;
            a.h = b === a.j;
            a.g.init(b, b);
            Lb(a, a.j);
        }
        function Mb(a, b) {
            var c = !1, d = !1;
            a.h && (d = a.g.sa(b));
            if (!d && (!a.h || a.g.Jb(b))) {
                c = !1;
                for(var e = b.firstChild; e && !c;)d = e.nextSibling, c = Lb(a, e), e = d;
                d = c;
                c = !0;
            }
            !d && a.h && (d = a.g.ia(b, c));
            return d;
        }
        function Lb(a, b) {
            b === a.Ya && (a.h = !0);
            var c = !1;
            a.h ? (c = b.nodeType, c = 1 === c ? Mb(a, b) : 3 === c ? a.g.$b(b) : 8 === c ? a.g.Zb(b) : a.g.Kb(b)) : H(b) && (c = Mb(a, b));
            return c || b === a.m;
        }
        function Nb(a, b) {
            this.j = b;
            this.g = [];
            this.h = [];
            for(b = 0; b < a.length; b++){
                var c = a[b];
                c.sa && this.g.push(c);
                c.ia && this.h.push(c);
            }
        }
        k = Nb.prototype;
        k.Jb = function(a) {
            return null !== a.parentNode;
        };
        k.sa = function(a) {
            for(var b = a.localName, c = 0; c < this.g.length; c++){
                var d = this.g[c];
                try {
                    d.sa(a, b, this.j, a.ownerDocument);
                } catch (e) {
                    t.Logger.logWarning(e);
                }
            }
            return !1;
        };
        k.ia = function(a) {
            for(var b = a.localName, c = 0; c < this.h.length; c++){
                var d = this.h[c];
                try {
                    d.ia(a, b, this.j, a.ownerDocument);
                } catch (e) {
                    t.Logger.logWarning(e);
                }
            }
            return !1;
        };
        k.init = function() {};
        k.Zb = function() {
            return !1;
        };
        k.Kb = function() {
            return !1;
        };
        k.$b = function() {
            return !1;
        };
        function Ob() {
            this.Qa = [];
        }
        function Pb(a, b) {
            a.Qa.push.apply(a.Qa, q.Qc(b));
        }
        Ob.prototype.transform = function(a, b) {
            var c = this, d, e, f, g, h, l, m, n, p;
            return q.K(function(u) {
                if (1 == u.g) {
                    d = eb(a);
                    for(e = 0; e < c.Qa.length; e++)f = c.Qa[e], f.init && f.init(a, b);
                    g = new Nb(c.Qa, b);
                    if (0 < g.g.length || 0 < g.h.length) h = new Hb(g), Ib(h, a.documentElement);
                    l = [];
                    for(m = 0; m < c.Qa.length; m++)n = c.Qa[m], n.nc && (p = n.nc(a, b, d), l.push(p));
                    return r(u, Promise.all(l), 2);
                }
                return u.return(b);
            });
        };
        function Qb(a) {
            this.Mf = a;
        }
        Qb.prototype.sa = function(a, b) {
            "html" !== b || a.hasAttribute("lang") || a.hasAttribute("xml:lang") || 0 < this.Mf.length && a.setAttribute("lang", this.Mf[0].content.value);
        };
        function Rb(a) {
            this.Ja = a;
            this.rc = this.Hf = !1;
        }
        Rb.prototype.sa = function(a, b, c) {
            if ("head" === b) this.rc = !0;
            else if (this.rc && "title" === b) {
                if (this.Hf = !0, t.BrowserDetector.isOS("iOS")) Ia(a.textContent) && (a.textContent = "Page");
                else for(; a.firstChild;)c.remove(a.firstChild);
            }
        };
        Rb.prototype.ia = function(a, b, c) {
            if ("head" === b && (this.rc = !1, t.BrowserDetector.isOS("iOS") && !this.Hf)) {
                b = this.Ja.createElementNS(t.XmlNamespace.HTML, "title");
                var d = this.Ja.createTextNode("Page");
                c.append(b, a);
                c.append(d, b);
            }
        };
        function Sb() {}
        Sb.prototype.sa = function(a) {
            a = a.attributes;
            for(var b = [], c = 0, d = a.length; c < d; c++){
                var e = a[c];
                e.name.startsWith("data-colibrio-") && b.push(e.name);
            }
            for(c = 0; c < b.length; c++)a.removeNamedItem(b[c]);
        };
        function Tb() {
            this.rc = !1;
        }
        Tb.prototype.sa = function(a, b, c) {
            "head" === b ? this.rc = !0 : !this.rc || "title" === b || "script" === b || "style" === b || "link" === b && /stylesheet/i.test(a.getAttribute("rel") || "") || "meta" === b && !a.hasAttribute("http-equiv") || /^(?:viewport|author|creator|description|generator|googlebot|keywords|publisher|robots|slurp)$/i.test(a.getAttribute("name") || "") || c.remove(a);
        };
        Tb.prototype.ia = function(a, b) {
            "head" === b && (this.rc = !1);
        };
        function Ub() {
            this.Bc = null;
        }
        Ub.prototype.sa = function(a, b, c) {
            "meta" === b && "viewport" === a.getAttribute("name") && (this.Bc ? c.remove(a) : this.Bc = a);
        };
        Ub.prototype.nc = function(a, b, c) {
            !this.Bc && c && (this.Bc = a.createElementNS(t.XmlNamespace.HTML, "meta"), this.Bc.setAttribute("name", "viewport"), this.Bc.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"), c.insertBefore(this.Bc, c.firstChild));
            return Promise.resolve();
        };
        function T(a, b) {
            return t.ColibrioError.call(this, "colibrio.readingsystem.formatadapter.epub", a, b) || this;
        }
        q.inherits(T, t.ColibrioError);
        function Vb(a) {
            switch(a.nodeType){
                case 1:
                    var b = a.attributes, c = [];
                    if (0 < b.length) for(var d = 0; d < b.length; d++){
                        var e = b[d];
                        c.push({
                            name: e.name,
                            namespaceUri: "http://www.w3.org/1999/xhtml" !== e.namespaceURI ? e.namespaceURI : void 0,
                            value: e.value
                        });
                    }
                    b = [];
                    d = a.childNodes;
                    for(e = 0; e < d.length; e++)b.push(Vb(d[e]));
                    return {
                        attributes: c,
                        childNodes: b,
                        namespaceUri: "http://www.w3.org/1999/xhtml" !== a.namespaceURI ? a.namespaceURI : void 0,
                        nodeName: a.localName,
                        nodeType: 1
                    };
                case 3:
                    return {
                        childNodes: [],
                        data: a.data,
                        nodeName: "#text",
                        nodeType: 3
                    };
                case 4:
                    return {
                        childNodes: [],
                        data: a.data,
                        nodeName: "#cdata-section",
                        nodeType: 4
                    };
                case 8:
                    return {
                        childNodes: [],
                        data: a.data,
                        nodeName: "#comment",
                        nodeType: 8
                    };
                default:
                    throw Error("Unsupported nodeType for colibrio DOM: " + a.nodeType);
            }
        }
        function Wb() {
            this.Ie = [];
        }
        Wb.prototype.sa = function(a, b, c) {
            "script" === b && (this.Ie.push(a), c.remove(a));
        };
        function Xb(a, b, c, d) {
            for(var e = [], f = {}, g = 0; g < a.Ie.length; f = {
                Wc: void 0
            }, g++){
                var h = a.Ie[g], l = h.getAttribute("src");
                try {
                    if (l) {
                        pb(h);
                        var m = B.URLUtils.normalizePathnameEncoding(new URL(l, d));
                        if (b.acceptsUrl(m) && !b.isUrlSupportedByBrowser(m)) {
                            h.removeAttribute("src");
                            f.Wc = Vb(h);
                            f.Wc.attributes || (f.Wc.attributes = []);
                            f.Wc.attributes.push({
                                name: "data-colibrio-org-src",
                                value: l
                            });
                            var n = c.fetchText(m, [
                                y.MediaType.TEXT_JAVASCRIPT
                            ]).then(function(v) {
                                return function(w) {
                                    v.Wc.childNodes.push({
                                        childNodes: [],
                                        data: w.data,
                                        nodeName: "#text",
                                        nodeType: 3
                                    });
                                    return v.Wc;
                                };
                            }(f)).catch(function(v) {
                                t.Logger.logError(v);
                                return null;
                            });
                            e.push(n);
                        } else e.push(Promise.resolve(Vb(h)));
                    } else {
                        var p = h.textContent;
                        if (p) {
                            pb(h);
                            var u = Vb(h);
                            u.childNodes.push({
                                childNodes: [],
                                data: p,
                                nodeName: "#text",
                                nodeType: 3
                            });
                            e.push(Promise.resolve(u));
                        }
                    }
                } catch (v) {
                    t.Logger.logWarning(new T("INVALID_URL_IN_PUBLICATION_RESOURCE", String(v) + (' - source="' + d.pathname + '", src="' + l + '"')));
                }
            }
            return Promise.all(e).then(function(v) {
                return v.filter(function(w) {
                    return null !== w;
                });
            });
        }
        function Yb(a, b) {
            this.fb = a;
            this.fd = b;
            this.Rd = [];
        }
        Yb.prototype.ia = function(a, b, c) {
            if ("style" === b) b = a.textContent, c.remove(a), b && (a = {
                Vd: "style",
                Lc: a.getAttribute("media"),
                mb: !1,
                ag: b
            }, this.Rd.push(a));
            else if ("link" === b) {
                var d = a.getAttribute("rel");
                if ((b = a.getAttribute("href")) && d && "stylesheet" === d.toLowerCase().trim()) {
                    if (c.remove(a), zb(b) && Ab(b, "text/css")) {
                        c = b.indexOf(",");
                        var e = null;
                        if (-1 !== c) {
                            var f = b.slice(0, c);
                            e = decodeURIComponent(b.slice(c + 1));
                            f.endsWith("base64") && (e = atob(e));
                        }
                        if (b = e) a = {
                            Vd: "style",
                            Lc: a.getAttribute("media"),
                            mb: !1,
                            ag: b
                        }, this.Rd.push(a);
                    } else try {
                        e = B.URLUtils.normalizePathnameEncoding(new URL(b, this.fd));
                        f = !this.fb.acceptsUrl(e) && e.protocol.startsWith("http");
                        var g = {
                            ec: b,
                            Vd: "link",
                            Lc: a.getAttribute("media"),
                            mb: f
                        };
                        this.Rd.push(g);
                    } catch (h) {
                        t.Logger.logError(h);
                    }
                }
            }
        };
        function Zb(a, b) {
            return a.Rd.filter(function(c) {
                return !c.mb || b;
            });
        }
        function U(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        q.inherits(U, Error);
        function $b(a, b) {
            for(var c = a.v.length, d = b.v.length, e = Math.min(c, d), f = 0; f < e; f++){
                var g = a.v[f], h = b.v[f];
                if (g < h) return -1;
                if (g > h) return 1;
            }
            c < d ? (a = a.i, b = b.v[c], c = -1) : c > d ? (a = a.v[d], b = b.i, c = 1) : (a = a.i, b = b.i, c = 0);
            return a < b ? -1 : a > b ? 1 : c;
        }
        function ac(a) {
            return a.ownerDocument ? Ya(M(a.ownerDocument), a) : null;
        }
        function bc(a) {
            var b = a.parentNode;
            return H(b) ? (b = ac(b)) ? {
                v: b,
                i: O(a)
            } : {
                v: [],
                i: 0
            } : null;
        }
        function cc(a, b) {
            return (a = ac(a)) ? {
                v: a,
                i: b
            } : null;
        }
        function dc(a, b) {
            for(var c = -1, d = 0; d < a.v.length && -1 === c; d++){
                var e = a.v[d];
                0 > e ? c = 0 : e >= b.childNodes.length ? c = b.childNodes.length : b = b.childNodes[e];
            }
            -1 === c && (c = H(b) ? La(a.i, 0, b.childNodes.length) : J(b) ? La(a.i, 0, b.data.length) : 0);
            return {
                s: b,
                i: c
            };
        }
        function ec(a, b) {
            var c = a.v, d = b.v.length, e = c.findIndex(function(g) {
                return 0 < g;
            });
            -1 === e && (e = c.length);
            for(var f = 0; f < d && f < e; f++)c[f] += b.v[f];
            e > d ? c[d] += b.i : e === d ? c.length > e ? c[e] += b.i : a.i += b.i : e < c.length ? c[e] += b.v[e] : a.i += b.v[e];
        }
        function fc(a, b) {
            return a.length <= b.length && a.every(function(c, d) {
                return b[d] === c;
            });
        }
        function gc(a) {
            return a.map(function(b) {
                var c = b.v, d = b.i, e = b.J, f = b.sb === Node.TEXT_NODE ? "text" : "element";
                return 6 === b.J ? {
                    containerPath: c,
                    containerType: f,
                    offset: d,
                    textLengths: b.Me,
                    type: e
                } : 10 === b.J ? {
                    containerPath: c,
                    containerType: f,
                    endOffset: b.Db,
                    offset: d,
                    textNodeLength: b.Oe,
                    type: e
                } : {
                    containerPath: c,
                    containerType: f,
                    offset: d,
                    type: e
                };
            });
        }
        function hc(a) {
            this.g = a = void 0 === a ? [] : a;
        }
        function ic(a, b, c, d) {
            var e = a.g.slice(0);
            a.g.push({
                v: c.slice(),
                sb: b,
                i: d,
                J: 3
            });
            a = e.length - 1;
            var f = e[a];
            f && 4 === f.J ? (e[a] = {
                v: c.slice(),
                sb: b,
                i: d,
                J: 4
            }, ec(e[a], f)) : e.push({
                v: c.slice(),
                sb: b,
                i: d,
                J: 4
            });
            return new hc(e);
        }
        function jc(a, b, c) {
            var d = b.parentNode;
            if (!d) throw new U("DomMutationRecorder: Node not attached to container");
            (d = ac(d)) && a.g.push({
                v: d,
                sb: 1,
                i: O(b),
                Me: c,
                J: 6
            });
        }
        function kc(a, b, c) {
            var d = c.parentNode;
            if (!d) throw new U("DomMutationRecorder: Node not attached to container");
            (d = ac(d)) && a.g.push({
                v: d,
                sb: 1,
                i: O(c),
                J: b
            });
        }
        function lc(a) {
            this.Ra = a ? a : new hc;
        }
        lc.prototype.append = function(a, b) {
            b.appendChild(a);
            kc(this.Ra, 1, a);
        };
        lc.prototype.insertBefore = function(a, b) {
            b.parentNode.insertBefore(a, b);
            kc(this.Ra, 1, a);
        };
        lc.prototype.prepend = function(a, b) {
            b.insertBefore(a, b.firstChild);
            kc(this.Ra, 1, a);
        };
        lc.prototype.remove = function(a) {
            if (a.parentNode) {
                kc(this.Ra, 2, a);
                var b = a.previousSibling, c = a.nextSibling;
                a.parentNode.removeChild(a);
                if (J(b) && J(c) && b.parentNode) {
                    a = this.Ra;
                    var d = b.data.length, e = ac(b);
                    e && a.g.push({
                        v: e,
                        sb: 3,
                        i: d,
                        J: 5
                    });
                    c.data = b.data + c.data;
                    b.parentNode.removeChild(b);
                }
            }
        };
        function mc(a, b, c, d, e) {
            var f = c.data.length, g = [], h = La(e.gh, 1, f);
            e = e.lh.filter(function(z) {
                return 0 < z.length;
            });
            for(var l = Math.min(500, h - 1), m = 0; m < f;){
                var n = m + h;
                if (n >= f) n = f;
                else for(var p = Math.max(0, n - l), u = 0, v = c.data.substring(p, n), w = q.na(e), x = w.next(); !x.done; x = w.next()){
                    x = x.value;
                    var A = v.lastIndexOf(x);
                    -1 !== A && A + x.length > u && (u = A + x.length, n = p + u);
                }
                g.push(c.data.slice(m, n));
                m = n;
            }
            f = g.map(function(z) {
                return z.length;
            });
            jc(a.Ra, c, f);
            a = q.na(g);
            for(g = a.next(); !g.done; g = a.next())f = b.createElement("x-colibrio-text-split"), f.appendChild(b.createTextNode(g.value)), d.insertBefore(f, c);
            d.removeChild(c);
        }
        function nc(a, b) {
            for(var c = a.cloneNode(!1), d = a.firstChild; d; d = d.nextSibling)d === a.documentElement ? c.appendChild(b) : c.appendChild(d.cloneNode(!0));
            return c;
        }
        function oc(a, b, c, d) {
            d = void 0 === d ? !0 : d;
            var e, f, g, h, l, m, n, p;
            return q.K(function(u) {
                if (1 == u.g) return e = new Wb, f = new Yb(a.W.getResourceProvider(), a.tb), g = [
                    e,
                    f,
                    new Qb(a.ta.getPublication().getMetadata().getLanguages()),
                    new Rb(b)
                ], h = new Ob, h.Qa = g.slice(), d && Pb(h, [
                    new Tb,
                    new Ub,
                    new Sb
                ]), l = new lc(c), r(u, h.transform(b, l), 2);
                if (3 != u.g) {
                    var v = Xb(e, a.W.getResourceProvider(), a.kc, a.ta.getContentUrl());
                    return r(u, v, 3);
                }
                m = u.h;
                var w = null == (v = a.M.remoteResourcesNonScriptedDocumentsOptions) ? void 0 : v.policyType;
                n = "ALLOW_ALL" === w || "WHITELIST" === w;
                p = Zb(f, n);
                return u.return({
                    Ag: m,
                    styleDefs: p
                });
            });
        }
        function pc(a) {
            this.C = a;
            switch(this.C.whitespaceBehaviour){
                case "COLLAPSE":
                    this.sd = 0;
                    break;
                case "PRESERVE":
                    this.sd = 1;
                    break;
                case "IGNORE":
                    this.sd = 2;
            }
        }
        k = pc.prototype;
        k.Xe = function() {
            return {
                Cb: !1,
                Mb: !1,
                ab: !1,
                Sb: !0
            };
        };
        k.je = function(a, b) {
            var c = 0;
            switch(a.localName){
                case "img":
                case "svg":
                    c = this.C.imageElementWeight;
                    break;
                case "video":
                    c = this.C.videoElementWeight;
                    break;
                case "audio":
                    c = this.C.audioElementWeight;
                    break;
                case "iframe":
                    c = this.C.iframeElementWeight;
            }
            0 < c && (b.Sb = !1);
            return c;
        };
        k.ke = function() {
            return 1E3;
        };
        k.getUnit = function() {
            return D.ContentPositionTimelineUnit.CHARACTERS;
        };
        k.Cd = function(a) {
            a.Cb = !0;
            a.Mb = !1;
            a.ab = !1;
        };
        k.me = function(a, b) {
            1 !== this.sd && Ea(a) ? (a = 0 === this.sd && !b.Sb, b.Cb = b.ab, b.Mb = a, b.ab = a, b.Sb = !0) : (a = 56320 <= a && 57343 >= a, b.Cb = b.ab && !a, b.Mb = !a, b.ab = !0, b.Sb = !1);
        };
        k.Bg = function(a) {
            return 0 !== this.sd || !a.Sb;
        };
        function qc() {
            R.apply(this, arguments);
        }
        q.inherits(qc, R);
        qc.prototype.m = function(a) {
            var b = this.g, c = 0;
            if (b.lastChild && (Qa(a) ? a(b) : a)) this.g = b.lastChild, c = 1;
            else if (b !== this.aa && b.previousSibling) this.g = b.previousSibling;
            else {
                for(; b !== this.aa && !b.previousSibling;)b = b.parentNode, c--;
                b === this.aa ? this.g = null : this.g = b.previousSibling;
            }
            return c;
        };
        function rc(a, b) {
            a = a.attributes;
            for(var c = 0; c < a.length; c++)if (b.includes(a[c].name)) return !0;
            return !1;
        }
        function sc(a) {
            return a.startsWith("aria-") || tc.has(a);
        }
        var uc = new Set("a abbr b bdi bdo cite code dfn em i mark q rt rtc ruby s samp small span strong sub sup time u".split(" ")), vc = [
            [
                "article",
                D.ContainerContentBlockType.ARTICLE
            ],
            [
                "aside",
                D.ContainerContentBlockType.ASIDE
            ],
            [
                "blockquote",
                D.ContainerContentBlockType.BLOCK_QUOTE
            ],
            [
                "dl",
                D.ContainerContentBlockType.DESCRIPTION_LIST
            ],
            [
                "dt",
                D.ContainerContentBlockType.DESCRIPTION_TERM
            ],
            [
                "dd",
                D.ContainerContentBlockType.DESCRIPTION_DEFINITION
            ],
            [
                "figure",
                D.ContainerContentBlockType.FIGURE
            ],
            [
                "ol",
                D.ContainerContentBlockType.ORDERED_LIST
            ],
            [
                "ul",
                D.ContainerContentBlockType.UNORDERED_LIST
            ],
            [
                "li",
                D.ContainerContentBlockType.LIST_ITEM
            ],
            [
                "section",
                D.ContainerContentBlockType.SECTION
            ],
            [
                "table",
                D.ContainerContentBlockType.TABLE
            ],
            [
                "tbody",
                D.ContainerContentBlockType.TABLE_BODY
            ],
            [
                "tfoot",
                D.ContainerContentBlockType.TABLE_FOOTER
            ],
            [
                "thead",
                D.ContainerContentBlockType.TABLE_HEADER
            ],
            [
                "td",
                D.ContainerContentBlockType.TABLE_CELL
            ],
            [
                "th",
                D.ContainerContentBlockType.TABLE_HEADER
            ],
            [
                "tr",
                D.ContainerContentBlockType.TABLE_ROW
            ]
        ], wc = new Map(vc), xc = [
            [
                "pre",
                D.ContainerContentBlockType.PREFORMATTED
            ]
        ], yc = new Map(xc), zc = [
            [
                "math",
                D.ContainerContentBlockType.MATHML
            ],
            [
                "merror",
                D.ContainerContentBlockType.MATHML_ERROR
            ],
            [
                "mfrac",
                D.ContainerContentBlockType.MATHML_FRACTION
            ],
            [
                "mi",
                D.ContainerContentBlockType.MATHML_IDENTIFIER
            ],
            [
                "mmultiscripts",
                D.ContainerContentBlockType.MATHML_MULTISCRIPT
            ],
            [
                "mn",
                D.ContainerContentBlockType.MATHML_NUMERIC
            ],
            [
                "mo",
                D.ContainerContentBlockType.MATHML_OPERATOR
            ],
            [
                "mover",
                D.ContainerContentBlockType.MATHML_OVERSCRIPT
            ],
            [
                "mpadded",
                D.ContainerContentBlockType.MATHML_PADDED
            ],
            [
                "mphantom",
                D.ContainerContentBlockType.MATHML_PHANTOM
            ],
            [
                "mroot",
                D.ContainerContentBlockType.MATHML_ROOT
            ],
            [
                "mrow",
                D.ContainerContentBlockType.MATHML_ROW
            ],
            [
                "ms",
                D.ContainerContentBlockType.MATHML_STRING
            ],
            [
                "mspace",
                D.ContainerContentBlockType.MATHML_SPACE
            ],
            [
                "msqrt",
                D.ContainerContentBlockType.MATHML_SQUARE_ROOT
            ],
            [
                "mstyle",
                D.ContainerContentBlockType.MATHML_STYLE
            ],
            [
                "msub",
                D.ContainerContentBlockType.MATHML_SUBSCRIPT
            ],
            [
                "msubsup",
                D.ContainerContentBlockType.MATHML_SUB_SUPERSCRIPT
            ],
            [
                "msup",
                D.ContainerContentBlockType.MATHML_SUPERSCRIPT
            ],
            [
                "mtable",
                D.ContainerContentBlockType.MATHML_TABLE
            ],
            [
                "mtd",
                D.ContainerContentBlockType.MATHML_TABLE_CELL
            ],
            [
                "mtr",
                D.ContainerContentBlockType.MATHML_TABLE_ROW
            ],
            [
                "mtext",
                D.ContainerContentBlockType.MATHML_TEXT
            ],
            [
                "munder",
                D.ContainerContentBlockType.MATHML_UNDERSCRIPT
            ],
            [
                "munderover",
                D.ContainerContentBlockType.MATHML_UNDER_OVERSCRIPT
            ],
            [
                "semantics",
                D.ContainerContentBlockType.MATHML_SEMANTICS
            ]
        ], Ac = new Map(zc), Bc = vc.concat(zc, xc), Dc = new Map(Bc.map(Cc)), Ec = [
            [
                "h1",
                D.TextContentBlockType.HEADING1
            ],
            [
                "h2",
                D.TextContentBlockType.HEADING2
            ],
            [
                "h3",
                D.TextContentBlockType.HEADING3
            ],
            [
                "h4",
                D.TextContentBlockType.HEADING4
            ],
            [
                "h5",
                D.TextContentBlockType.HEADING5
            ],
            [
                "h6",
                D.TextContentBlockType.HEADING6
            ],
            [
                "p",
                D.TextContentBlockType.PARAGRAPH
            ]
        ], Fc = new Map(Ec), Gc = new Map(Ec.map(Cc)), Hc = [
            [
                "audio",
                D.MediaContentBlockType.AUDIO
            ],
            [
                "img",
                D.MediaContentBlockType.IMAGE
            ],
            [
                "picture",
                D.MediaContentBlockType.IMAGE
            ],
            [
                "video",
                D.MediaContentBlockType.VIDEO
            ]
        ], Ic = new Map(Hc), Jc = new Map(Hc.map(Cc)), tc = new Set([
            "epub:type",
            "role",
            "lang",
            "xml:lang",
            D.ContentBlockMicrodataAttribute.ITEMSCOPE,
            D.ContentBlockMicrodataAttribute.ITEMPROP,
            D.ContentBlockMicrodataAttribute.ITEMID,
            D.ContentBlockMicrodataAttribute.ITEMREF,
            D.ContentBlockMicrodataAttribute.ITEMTYPE,
            D.ContentBlockRdfAttribute.VOCAB,
            D.ContentBlockRdfAttribute.TYPEOF,
            D.ContentBlockRdfAttribute.PROPERTY
        ]), Kc = new Set([
            "id",
            "alt",
            "alttext",
            "title"
        ]);
        function Cc(a, b) {
            return [
                a[0],
                b
            ];
        }
        function Lc(a) {
            this.g = a;
        }
        Lc.prototype.getTextContent = function() {
            var a = this.g.map(function(b) {
                return b.toString();
            }).join(" ");
            return Mc(a);
        };
        Lc.prototype.getTextContentAfter = function(a) {
            if (0 === this.g.length) return "";
            var b = this.g[this.g.length - 1], c = b.endContainer, d = "", e = !0;
            J(c) ? (d = c.data.slice(b.endOffset), d = Mc(d), d.length > a && (d = d.slice(0, a))) : b.endOffset < c.childNodes.length && (c = c.childNodes[b.endOffset], e = !1);
            if (c && 0 < a - d.length) for(b = new R(c), b.aa = null, e && S(b, !1); b.g && 0 < a - d.length;)J(b.g) && !lb(b.g.parentNode.localName) && (e = Mc(b.g.data), c = a - d.length, d = e.length > c ? d + e.slice(0, c) : d + e, d = Mc(d)), S(b, !0);
            return d;
        };
        Lc.prototype.getTextContentBefore = function(a) {
            if (0 === this.g.length) return "";
            var b = this.g[0], c = b.startContainer, d = "", e = !0;
            J(c) ? (d = c.data.slice(0, b.startOffset), d = Mc(d), d.length > a && (d = d.slice(d.length - a))) : 0 < b.startOffset && (c = c.childNodes[b.startOffset - 1], e = !1);
            if (c && 0 < a - d.length) for(b = new qc(c), b.aa = null, e && S(b, !1); b.g && 0 < a - d.length;)J(b.g) && (e = b.g, lb(e.parentNode.localName) || (e = Mc(e.data), c = a - d.length, d = e.length > c ? e.slice(e.length - c) + d : e + d, d = Mc(d))), S(b, !0);
            return d;
        };
        function Mc(a) {
            return a.replace(/\s+/g, " ");
        }
        function Nc(a, b, c) {
            this.h = a;
            this.j = b;
            this.g = c;
        }
        Nc.prototype.getItemsAfter = function() {
            return this.g;
        };
        Nc.prototype.getItemsBefore = function() {
            return this.h;
        };
        Nc.prototype.getItemsInRange = function() {
            return this.j;
        };
        Nc.prototype.toJSON = function() {
            return {
                itemsAfter: this.g.map(function(a) {
                    return a.toJSON();
                }),
                itemsBefore: this.h.map(function(a) {
                    return a.toJSON();
                }),
                itemsInRange: this.j.map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function Oc(a, b, c) {
            this.g = a;
            this.h = b;
            this.F = c;
        }
        Oc.prototype.getNavigationCollection = function() {
            return this.g;
        };
        Oc.prototype.getNavigationItem = function() {
            return this.h;
        };
        Oc.prototype.getReaderDocument = function() {
            return this.F;
        };
        Oc.prototype.toJSON = function() {
            return {
                collectionIndex: this.g.getIndex(),
                collectionType: this.g.getType(),
                navigationItemId: this.h.getId(),
                readerDocumentIndexInSpine: this.F.getIndexInSpine(),
                readerPublicationDefaultLocatorUrl: this.F.getReaderPublication().getDefaultLocatorUrl()
            };
        };
        function Pc(a, b, c, d, e, f, g, h) {
            var l = M(b), m = [], n = [], p = [], u = db(f);
            f = dc(c.P, l);
            var v = !1;
            h ? H(f.s) ? v = Qc(l, f.s.childNodes[f.i], !0) : J(f.s) && Ga(f.s.data.slice(0, f.i)) || (v = Qc(l, f.s, !0)) : v = !0;
            !c.O && v && (c = new R(l), S(c, !0), Rc(c, !0), c.g && d.setStartBefore(c.g));
            e.h.forEach(function(w, x) {
                if (!a.collectionTypes || a.collectionTypes.includes(x.getType())) {
                    for(var A = ya(w, 1, w.length, function(L, P) {
                        return u - L[P].g;
                    }), z = A; 0 <= z && w[z].g >= u;)z--;
                    z++;
                    for(A += 1; A < w.length && w[A].g <= u;)A++;
                    for(var C = !1; z < A; z++){
                        var F = w[z].kd;
                        if (F && "#" !== F) {
                            if (F = b.getElementById(F.slice(1))) {
                                if (F !== l && F !== b.documentElement || !v) {
                                    var G = O(F);
                                    if (d.startContainer === F.parentNode && d.startOffset === G) {
                                        C = !0;
                                        break;
                                    }
                                    G = Xa(d, F.parentNode, G);
                                    if (0 === G) {
                                        H(d.startContainer) ? C = Qc(d.startContainer.childNodes[d.startOffset], F, !1) : J(d.startContainer) ? Ga(d.startContainer.data.slice(d.startOffset)) || (C = Qc(d.startContainer, F, !0)) : C = Qc(d.startContainer, F, !1);
                                        break;
                                    } else if (1 === G) {
                                        A = z;
                                        break;
                                    }
                                } else {
                                    C = !0;
                                    break;
                                }
                            }
                        } else if (v) {
                            C = !0;
                            break;
                        }
                    }
                    for(A--; z < A; A--)if ((F = w[A].kd) && "#" !== F) {
                        if (F = b.getElementById(F.slice(1))) {
                            if (F === l || F === b.documentElement) break;
                            else if (0 === Xa(d, F.parentNode, O(F))) break;
                        }
                    } else break;
                    A++;
                    a.greedy && 0 < z && !C && z--;
                    m.push.apply(m, q.Qc(w.slice(z, A).map(function(L) {
                        return new Oc(x, L, g);
                    })));
                    0 < z && n.push(new Oc(x, w[z - 1], g));
                    A < w.length && p.push(new Oc(x, w[A], g));
                }
            });
            return new Nc(n, m, p);
        }
        function Qc(a, b, c) {
            function d(e) {
                return e !== b;
            }
            a = new R(a);
            a.aa = b;
            c && S(a, d);
            return !Rc(a, d);
        }
        function Rc(a, b) {
            for(; a.g;){
                var c = a.g, d = !1;
                H(c) ? (c = c.localName, d = Ic.has(c) || "iframe" === c) : J(c) && (d = Ga(c.data));
                if (d) return !0;
                S(a, b);
            }
            return !1;
        }
        function X(a, b, c, d) {
            this.pa = a;
            this.R = b;
            this.V = c;
            this.qa = d;
        }
        k = X.prototype;
        k.collapseToEnd = function() {
            var a = {
                Ca: !1,
                O: null,
                Ka: !0,
                P: this.qa.O || this.qa.P
            }, b = this.V.getLocatorFactory().collapseRangeLocatorToEnd(this.pa);
            return new X(b, [
                Da(this.R)
            ], this.V, a);
        };
        k.collapseToStart = function() {
            var a = {
                Ca: !1,
                O: null,
                Ka: !0,
                P: this.qa.P
            }, b = this.V.getLocatorFactory().collapseRangeLocatorToStart(this.pa);
            return new X(b, [
                this.R[0]
            ], this.V, a);
        };
        k.contains = function(a) {
            if (!(a instanceof X) || this.V !== a.V) return !1;
            var b = this.qa, c = a.qa, d = this.R[0], e = Da(this.R), f = a.R[0];
            a = Da(a.R);
            if (d.getIndexInSpine() > f.getIndexInSpine() || e.getIndexInSpine() < a.getIndexInSpine()) return !1;
            if (d !== f && e !== a) return !0;
            if (!b.O) return c.O ? !1 : 0 === $b(b.P, c.P);
            if (d === f && 0 < $b(b.P, c.P)) return !1;
            if (e === a) {
                if (c.O) {
                    if (0 > $b(b.O, c.O)) return !1;
                } else if (0 >= $b(b.O, c.P)) return !1;
            }
            return !0;
        };
        k.createRangeTo = function(a) {
            if (!(a instanceof X) || this.V !== a.V) throw new T("INCOMPATIBLE_LOCATION", "Incompatible ContentLocation instance.");
            var b = this.R[0].getIndexInSpine(), c = Da(a.R).getIndexInSpine();
            if (c < b) {
                var d = "endLocation is before startLocation, selector for startLocation: " + this.getLocator().getSelectors()[0] + " endLocation: " + a.getLocator().getSelectors()[0];
                throw new T("INCOMPATIBLE_END_LOCATION", d);
            }
            d = a.qa.O || a.qa.P;
            if (b === c) {
                var e = $b(this.qa.P, d);
                if (0 < e) throw d = "endLocation is before startLocation, selector for startLocation: " + this.getLocator().getSelectors()[0] + " endLocation: " + a.getLocator().getSelectors()[0], new T("INCOMPATIBLE_END_LOCATION", d);
                if (0 === e) return this.collapseToStart();
            }
            e = this.V.getLocatorFactory().createRangeLocator(this.pa, a.pa);
            a = e.locator;
            if (!a) {
                var f, g;
                throw new T("INCOMPATIBLE_END_LOCATION", (null == (f = e.error) ? void 0 : f.errorType) + ", " + (null == (g = e.error) ? void 0 : g.errorMessage));
            }
            b = this.V.getSpine().slice(b, c + 1);
            return new X(a, b, this.V, {
                Ca: !1,
                O: d,
                Ka: 1 === b.length,
                P: this.qa.P
            });
        };
        k.equals = function(a) {
            if (!(a instanceof X) || this.V !== a.V) return !1;
            var b = this.qa, c = a.qa, d = Da(this.R), e = Da(a.R);
            return this.R[0] !== a.R[0] || d !== e || 0 !== $b(b.P, c.P) ? !1 : b.O && c.O ? 0 === $b(b.O, c.O) : !b.O && !c.O;
        };
        k.fetchContentBlockTargets = function(a) {
            var b = this;
            return Promise.all(this.R.map(function(c) {
                return c.Ea().then(function(d) {
                    return c.fetchContentBlockTree().then(function(e) {
                        var f = Sc(b, b.qa, c, d);
                        if (f.collapsed) var g = (g = Tc(e, f.startContainer, f.startOffset, a, !0)) ? [
                            g
                        ] : [];
                        else {
                            var h = q, l = h.na;
                            if (a === D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_BEFORE) var m = Uc(e, f.startContainer, f.startOffset, a, D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_AFTER);
                            else m = Tc(e, f.startContainer, f.startOffset, D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_AFTER, !1), m = Vc(m);
                            a === D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_AFTER ? f = Uc(e, f.endContainer, f.endOffset, a, D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_BEFORE, !0) : (f = Tc(e, f.endContainer, f.endOffset, D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_BEFORE, !1, !0), f = Vc(f));
                            l = l.call(h, [
                                m,
                                f
                            ]);
                            h = l.next().value;
                            f = l.next().value;
                            if (h && f) {
                                m = [];
                                var n = f.getContentBlock();
                                l = h.getContentBlock();
                                if (l === n) g = f.getCharLength() - h.getCharOffset(), g = new Wc(l, D.ContentBlockTargetAnchorPoint.INTERSECTS_CONTENT_LOCATION, g), e = h.getCharOffset(), g.g = e, g = [
                                    g
                                ];
                                else if (l.isAfter(n)) g = [];
                                else {
                                    e = new t.TreeNodeWalker(e.getContentBlocks());
                                    e.advanceToNode(l);
                                    e.hasNext() && (e.next(), m.push(h));
                                    for(; e.hasNext() && (g = e.next()) && g !== n;)m.push(new Wc(g, D.ContentBlockTargetAnchorPoint.INTERSECTS_CONTENT_LOCATION, g.getTextContent().length));
                                    f && m.push(f);
                                    g = m;
                                }
                            } else g = [];
                        }
                        return g;
                    });
                });
            })).then(function(c) {
                return Ca(c);
            });
        };
        k.fetchContentResolver = function() {
            var a = this, b, c;
            return q.K(function(d) {
                if (1 == d.g) return b = a.R.map(function(e) {
                    var f;
                    return q.K(function(g) {
                        if (1 == g.g) return r(g, e.Ea(), 2);
                        f = g.h;
                        return g.return(Sc(a, a.qa, e, f));
                    });
                }), r(d, Promise.all(b), 2);
                c = d.h;
                return d.return(new Lc(c));
            });
        };
        k.fetchNavigationItemReferences = function(a) {
            var b = this, c, d, e, f, g, h, l;
            return q.K(function(m) {
                if (1 == m.g) return r(m, Xc(b), 2);
                if (3 != m.g) return c = m.h, r(m, b.V.fetchPublicationNavigation(), 3);
                d = m.h;
                e = c.map(function(n) {
                    return Pc(a, n.Eh, b.qa, n.range, d, n.Xh, n.readerDocument, n.Jh);
                });
                f = Yc(e);
                g = Zc(f);
                h = e.flatMap(function(n) {
                    return n.getItemsAfter();
                }).filter(g);
                l = e.flatMap(function(n) {
                    return n.getItemsBefore();
                }).filter(g);
                return m.return(new Nc(l, f, h));
            });
        };
        function $c(a, b, c) {
            if (!a.R.includes(b)) throw new T("INVALID_READER_DOCUMENT", "ReaderDocument not in ContentLocation");
            var d, e;
            b === a.R[0] ? d = a.qa.P : d = {
                v: [],
                i: 0
            };
            a.qa.O ? b === Da(a.R) ? e = a.qa.O : e = {
                v: [],
                i: M(c).childNodes.length
            } : e = null;
            return {
                Ca: a.qa.Ca,
                O: e,
                Ka: !0,
                P: d
            };
        }
        k.getLocator = function() {
            return this.pa;
        };
        k.getReaderDocuments = function() {
            return this.R;
        };
        k.getReaderPublication = function() {
            return this.V;
        };
        k.intersects = function(a) {
            if (!(a instanceof X) || this.V !== a.V) return !1;
            var b = this.R[0], c = Da(this.R), d = a.R[0], e = Da(a.R);
            if (b.getIndexInSpine() > e.getIndexInSpine() || c.getIndexInSpine() < d.getIndexInSpine()) return !1;
            if (b !== e && c !== d) return !0;
            var f = this.qa;
            a = a.qa;
            if (b === e) {
                if (a.O) {
                    if (0 <= $b(f.P, a.O)) return !1;
                } else if (0 < $b(f.P, a.P)) return !1;
            }
            if (c === d) {
                if (f.O) {
                    if (0 >= $b(f.O, a.P)) return !1;
                } else if (0 > $b(f.P, a.P)) return !1;
            }
            return !0;
        };
        k.isAfter = function(a) {
            if (!(a instanceof X) || this.V !== a.V) return !1;
            var b = this.R[0], c = Da(a.R);
            if (b.getIndexInSpine() > c.getIndexInSpine()) return !0;
            if (b.getIndexInSpine() < c.getIndexInSpine()) return !1;
            b = this.qa;
            a = a.qa;
            return a.O ? 0 <= $b(b.P, a.O) : 0 < $b(b.P, a.P);
        };
        k.isBefore = function(a) {
            if (!(a instanceof X) || this.V !== a.V) return !1;
            var b = Da(this.R), c = a.R[0];
            if (b.getIndexInSpine() < c.getIndexInSpine()) return !0;
            if (b.getIndexInSpine() > c.getIndexInSpine()) return !1;
            b = this.qa;
            a = a.qa;
            return b.O ? 0 >= $b(b.O, a.P) : 0 > $b(b.P, a.P);
        };
        k.isRange = function() {
            return null !== this.qa.O;
        };
        k.toJSON = function() {
            return this.pa.toJSON();
        };
        function Sc(a, b, c, d) {
            var e = M(d);
            d = d.createRange();
            if (c === a.R[0]) {
                var f = dc(b.P, e);
                d.setStart(f.s, f.i);
            } else d.setStart(e, 0);
            b.O && (c === Da(a.R) ? (a = dc(b.O, e), d.setEnd(a.s, a.i)) : d.setEnd(e, e.childNodes.length));
            return d;
        }
        function Xc(a) {
            for(var b = [], c = {
                Sc: 0
            }; c.Sc < a.R.length; c = {
                Ed: void 0,
                Sc: c.Sc,
                uf: void 0
            }, c.Sc++)if (c.Ed = a.R[c.Sc], c.uf = c.Ed.getSourceContentDocument().getOpfSpineItemElement(), c.uf) {
                var d = c.Ed.Ea().then(function(e) {
                    return function(f) {
                        var g = Sc(a, a.qa, e.Ed, f);
                        return {
                            Eh: f,
                            Jh: 0 === e.Sc,
                            range: g,
                            readerDocument: e.Ed,
                            Xh: e.uf
                        };
                    };
                }(c));
                b.push(d);
            }
            return Promise.all(b);
        }
        function Yc(a) {
            return a.flatMap(function(b) {
                return b.getItemsInRange();
            }).filter(function(b, c, d) {
                return d.findIndex(function(e) {
                    return e.getNavigationItem().getId() === b.getNavigationItem().getId();
                }) === c;
            });
        }
        function Zc(a) {
            var b = a.map(function(c) {
                return c.getNavigationItem().getId();
            });
            return function(c, d, e) {
                return !b.includes(c.getNavigationItem().getId()) && e.findIndex(function(f) {
                    return f.getNavigationItem().getId() === c.getNavigationItem().getId();
                }) === d;
            };
        }
        function ad(a, b) {
            a = {
                v: a.v.slice(),
                i: a.i
            };
            for(var c = b.length - 1; 0 <= c; c--){
                var d = b[c];
                switch(d.J){
                    case 1:
                        var e = d;
                        d = a;
                        var f = e.v, g = d.v, h = f.length, l = g.length;
                        fc(f, g) && (h < l ? (f = g[h], f > e.i ? g[h]-- : f === e.i && (g.length = h, d.i = g.pop())) : d.i > e.i ? d.i-- : d.i === e.i && (d.i = g.pop()));
                        break;
                    case 2:
                        e = d;
                        d = a;
                        g = e.v;
                        h = d.v;
                        f = g.length;
                        l = h.length;
                        fc(g, h) && (f < l ? h[f] >= e.i && h[f]++ : d.i >= e.i && d.i++);
                        break;
                    case 4:
                        ec(a, d);
                        break;
                    case 5:
                        e = d;
                        d = a;
                        g = e.v;
                        h = d.v;
                        f = g.length;
                        l = h.length;
                        var m = g.slice(0, f - 1), n = g[f - 1];
                        fc(g, h) ? d.i >= e.i && (h[l - 1]++, d.i -= e.i) : fc(m, h) && (m.length === l ? d.i > n && (d.i += 1) : h[f - 1] > n && h[f - 1]++);
                        break;
                    case 6:
                        e = d;
                        d = a;
                        f = e.v;
                        g = d.v;
                        l = f.length;
                        m = g.length;
                        h = e.Me;
                        if (fc(f, g)) {
                            if (l < m) {
                                if (e.i + h.length <= g[l]) g[l] -= h.length - 1;
                                else if (l + 1 === m && e.i === g[l]) g.pop(), d.i = e.i;
                                else if (l + 2 === m && e.i <= g[l] && e.i + h.length > g[l] && (g.pop(), f = g.pop() - e.i, f < h.length)) {
                                    l = d.i;
                                    for(m = 0; m < f; m++)l += h[m];
                                    d.i = l;
                                    g.push(e.i);
                                }
                            } else if (e.i < d.i) {
                                if (e.i + h.length <= d.i) d.i -= h.length - 1;
                                else {
                                    f = 0;
                                    l = d.i - e.i;
                                    for(m = 0; m < l; m++)f += h[m];
                                    g.push(e.i);
                                    d.i = f;
                                }
                            }
                        }
                        break;
                    case 7:
                        e = a;
                        d = d.v;
                        g = e.v;
                        h = d.length;
                        f = g.length;
                        fc(d, g) && h === f && (e.i = 0);
                        break;
                    case 8:
                        e = d;
                        d = a;
                        g = e.v;
                        h = d.v;
                        f = g.length;
                        l = h.length;
                        fc(g, h) && f < l && (f + 1 === l && h[f] === e.i && 0 === d.i ? d.i = h.pop() : h[f] === e.i && 0 === h[f + 1] && h.splice(f + 1, 1));
                        break;
                    case 9:
                        e = d.v;
                        d = a.v;
                        g = e.length;
                        h = d.length;
                        fc(e, d) && g !== h && d.splice(g, 1);
                        break;
                    case 10:
                        e = d;
                        d = a;
                        g = e.v;
                        h = d.v;
                        f = g.length;
                        l = h.length;
                        m = g.slice(0, f - 1);
                        n = m.length;
                        var p = 0 === e.i, u = e.Db === e.Oe, v = p && u, w = [].concat(q.Qc(g));
                        w[f - 1] += p ? 0 : 1;
                        fc(m, h) && (f < l ? w[f - 1] < h[f - 1] ? v || (h[f - 1] -= p || u ? 1 : 2) : w[f - 1] === h[f - 1] && (h.pop(), h[h.length - 1] -= p ? 0 : 1, d.i += e.i) : n === l && w[f - 1] < d.i ? v || (d.i -= p || u ? 1 : 2) : f === l && w[f - 1] < h[f - 1] ? v || (h[f - 1] -= p || u ? 1 : 2, g[f - 1] === h[f - 1] && (d.i += e.Db)) : w[f - 1] === h[f - 1] && (h.pop(), h[h.length - 1] -= p ? 0 : 1, d.i += e.i));
                }
            }
            return a;
        }
        function bd(a, b, c, d, e, f, g, h) {
            a = ad(a, d);
            b = b ? ad(b, d) : null;
            c = cd(a, b, c, e, h);
            return new X(c, [
                g
            ], f, {
                Ca: !1,
                O: b,
                Ka: !0,
                P: a
            });
        }
        function cd(a, b, c, d, e) {
            var f = M(c);
            a = dc(a, f);
            (b = b ? dc(b, f) : null) && b.s ? (c = c.createRange(), -1 === a.i ? c.setStartBefore(a.s) : c.setStart(a.s, a.i), -1 === b.i ? c.setEndAfter(b.s) : c.setEnd(b.s, b.i), d = dd(e, d, c), c.detach()) : d = -1 === a.i ? ed(e, d, a.s) : fd(e, d, a.s, a.i);
            return d;
        }
        function gd(a, b) {
            if (E.ReadingSystemUtils.isContentLocation(a)) return Promise.resolve(a);
            if (E.ReadingSystemUtils.isUnresolvedContentLocation(a)) return a.resolve();
            a = E.LocatorUtils.getLocator(a);
            return null === a ? Promise.reject(new E.EngineError(E.EngineErrorType.NAVIGATION_ITEM_MISSING_LOCATOR)) : b.fetchContentLocation(a);
        }
        function hd(a, b, c) {
            null != c || (c = b);
            for(a.init(b, c); null !== b;)b = id(a, b) ? null : jd(a, b, c);
        }
        function jd(a, b, c) {
            if (H(b)) {
                var d = a.Jb(b);
                if (b.firstChild && d) return b.firstChild;
                if (a.ia(b, d)) return null;
            }
            for(; b !== c && !b.nextSibling;){
                if (!b.parentNode) throw new U("IterativeNodeTraverser: Illegal node removal by visitor!");
                b = b.parentNode;
                if (H(b) && a.ia(b, !0)) return null;
            }
            return b === c ? null : b.nextSibling;
        }
        function id(a, b) {
            switch(b.nodeType){
                case 1:
                    return a.sa(b);
                case 3:
                    return a.$b(b);
                case 8:
                    return a.Zb(b);
                default:
                    return a.Kb(b);
            }
        }
        function kd(a) {
            return !lb(a.localName) && "svg" !== a.localName;
        }
        function ld(a, b, c, d, e) {
            !e.ab && c - (0 < a.length ? a[a.length - 1].Aa : 0) >= d && (b = bc(b)) && a.push({
                Qg: Object.assign({}, e),
                Ef: b,
                Aa: c
            });
        }
        function md(a, b, c, d, e, f) {
            this.j = a;
            this.g = b;
            this.h = d;
            this.m = e;
            this.o = f;
            this.Va = null;
            this.Aa = c;
        }
        k = md.prototype;
        k.Jb = function(a) {
            return kd(a);
        };
        k.sa = function(a) {
            nd(this, a);
            ld(this.o, a, this.Aa, this.j.ke(), this.g);
            if (null !== this.Va) return !0;
            var b = this.j.je(a, this.g);
            this.Aa === this.h && 0 < b ? this.Va = {
                s: a.parentNode,
                i: O(a)
            } : (this.Aa += b, this.Aa > this.h && (this.Va = {
                s: a.parentNode,
                i: O(a) + (this.m ? 1 : 0)
            }));
            return null !== this.Va;
        };
        k.ia = function(a, b) {
            b && nd(this, a);
            return null !== this.Va;
        };
        k.cf = function() {
            return this.Va;
        };
        k.init = function() {};
        k.Zb = function() {
            return !1;
        };
        k.Kb = function() {
            return !1;
        };
        k.$b = function(a) {
            for(var b = a.data, c = 0; c < b.length && this.Aa <= this.h; c++)this.j.me(b.charCodeAt(c), this.g), this.m ? this.g.Cb && this.Aa++ : this.g.Mb && this.Aa++;
            -1 === this.h - this.Aa && (this.Va = {
                s: a,
                i: Math.max(0, c - 1)
            });
            return null !== this.Va;
        };
        function nd(a, b) {
            a.g.ab && !uc.has(b.localName) && (a.j.Cd(a.g), a.m && a.g.Cb && (a.Aa++, a.Aa > a.h && (a.Va = {
                s: b.parentNode,
                i: O(b) + 1
            })));
        }
        function od(a, b, c) {
            this.h = a;
            this.g = b;
            this.j = c;
            this.Aa = 0;
        }
        k = od.prototype;
        k.Jb = function(a) {
            return kd(a);
        };
        k.sa = function(a) {
            this.g.ab && !uc.has(a.localName) && this.h.Cd(this.g);
            ld(this.j, a, this.Aa, this.h.ke(), this.g);
            this.Aa += this.h.je(a, this.g);
            return !1;
        };
        k.ia = function(a, b) {
            b && this.g.ab && !uc.has(a.localName) && this.h.Cd(this.g);
            return !1;
        };
        k.init = function() {};
        k.Zb = function() {
            return !1;
        };
        k.Kb = function() {
            return !1;
        };
        k.$b = function(a) {
            a = a.data;
            for(var b = 0; b < a.length; b++)this.h.me(a.charCodeAt(b), this.g), this.g.Mb && this.Aa++;
            return !1;
        };
        function pd(a, b, c, d, e, f, g) {
            this.j = a;
            this.g = b;
            this.m = d;
            this.A = e;
            this.o = f;
            this.H = g;
            this.h = c;
        }
        k = pd.prototype;
        k.Jb = function(a) {
            return kd(a);
        };
        k.sa = function(a) {
            qd(this, a);
            ld(this.H, a, this.h, this.j.ke(), this.g);
            var b = a === this.m;
            b || (this.h += this.j.je(a, this.g));
            return b;
        };
        k.ia = function(a, b) {
            b && qd(this, a);
            return !1;
        };
        k.init = function() {};
        k.Zb = function(a) {
            return a === this.m;
        };
        k.Kb = function(a) {
            return a === this.m;
        };
        k.$b = function(a) {
            var b = a.data;
            a = Math.min(b.length, (a === this.m ? 0 : a === this.A.s ? this.A.i : 1073741822) + (this.o ? 0 : 1));
            for(var c = 0; c < a; c++)this.j.me(b.charCodeAt(c), this.g), this.o ? this.g.Mb && this.h++ : this.g.Cb && this.h++;
            return !1;
        };
        function qd(a, b) {
            a.g.ab && !uc.has(b.localName) && (a.j.Cd(a.g), !a.o && a.g.Cb && a.h++);
        }
        function rd(a, b) {
            this.g = a;
            this.h = [];
            for(a = 0; a < b; a++)this.h.push([]);
        }
        function sd(a, b, c, d, e) {
            var f = td(a, b, c, function(g) {
                return d - g.Aa;
            });
            b = M(b);
            a = new md(a.g, f.state, f.vg, d, e, a.h[c]);
            hd(a, f.Ya, b);
            return a.cf() || {
                s: b,
                i: b.childNodes.length
            };
        }
        function ud(a, b, c, d, e, f) {
            var g = M(b), h = dc(d, g);
            g = hb(g, h.s).find(function(m) {
                return H(m) && !kd(m);
            });
            var l = null;
            g || (g = (l = H(h.s) && h.i < h.s.childNodes.length ? h.s.childNodes[h.i] : null) || h.s);
            b = td(a, b, c, function(m) {
                return $b(d, m.Ef);
            });
            a = new pd(a.g, b.state, b.vg, l, h, f, a.h[c]);
            hd(a, b.Ya, g);
            return La(a.h, 0, e);
        }
        rd.prototype.getUnit = function() {
            return this.g.getUnit();
        };
        function td(a, b, c, d) {
            b = M(b);
            c = a.h[c];
            var e = ya(c, 1, c.length, function(f, g) {
                return d(f[g]);
            });
            if (-1 === e) a = a.g.Xe(), c = 0;
            else {
                c = c[e];
                b = dc(c.Ef, b);
                b = b.s.childNodes[b.i];
                if (!b) throw new U("EpubContentPositionTimeline: Invalid DOM position in cache point");
                a = Object.assign({}, c.Qg);
                c = c.Aa;
            }
            return {
                vg: c,
                Ya: b,
                state: a
            };
        }
        function vd(a) {
            this.C = a;
        }
        k = vd.prototype;
        k.Xe = function() {
            return {
                Cb: !1,
                Mb: !1,
                ab: !1
            };
        };
        k.je = function(a) {
            var b = 0;
            switch(a.localName){
                case "img":
                case "svg":
                    b = this.C.imageElementWeight;
                    break;
                case "video":
                    b = this.C.videoElementWeight;
                    break;
                case "audio":
                    b = this.C.audioElementWeight;
                    break;
                case "iframe":
                    b = this.C.iframeElementWeight;
            }
            return b;
        };
        k.ke = function() {
            return 200;
        };
        k.getUnit = function() {
            return D.ContentPositionTimelineUnit.WORDS;
        };
        k.Cd = function(a) {
            a.Cb = !0;
            a.Mb = !1;
            a.ab = !1;
        };
        k.me = function(a, b) {
            a = Ea(a);
            b.Mb = !b.ab && !a;
            b.Cb = b.ab && a;
            b.ab = !a;
        };
        k.Bg = function() {
            return !0;
        };
        function wd(a, b, c, d, e, f, g) {
            this.m = a;
            this.V = b;
            this.R = c;
            this.j = d;
            this.N = e;
            this.h = f;
            this.o = g;
            this.g = d.reduce(function(h, l) {
                return h + l;
            }, 0);
        }
        function xd(a, b, c, d, e, f) {
            var g = E.ReadingSystemUtils.getReaderDocumentListErrorForTimelineCreation(b, a);
            if (g) return Promise.reject(g);
            g = new rd(d, b.length);
            d = d.getUnit();
            d = (d === D.ContentPositionTimelineUnit.WORDS || d === D.ContentPositionTimelineUnit.CHARACTERS) && e.fetchWithLowPriority;
            var h = Object.assign({}, e, {
                fetchWithLowPriority: void 0,
                name: void 0,
                serializedData: void 0
            });
            h = t.Base64.encode((new TextEncoder).encode(JSON.stringify(h)));
            if (e.serializedData) {
                var l = E.ContentPositionTimelineUtils.deserialize(e.serializedData);
                if (l && yd(l, a, b, h)) return E.ContentPositionTimelineUtils.sendProgressEvent(a, e.name, f, 1), Promise.resolve(new wd(g, a, b, l.documentsLength, c, d, h));
                t.Logger.logError(new T("INVALID_SERIALIZED_TIMELINE_DATA", "Failed to deserialize timeline, creating new timeline"));
            }
            return zd(a, e.name, f, b, g, c, d, h);
        }
        function Cd(a) {
            var b = (null == a ? void 0 : a.unit) || D.ContentPositionTimelineUnit.CHARACTERS;
            a = (null == a ? void 0 : a.name) || E.ContentPositionTimelineUtils.getOrGenerateTimelineName(null == a ? void 0 : a.name);
            switch(b){
                case D.ContentPositionTimelineUnit.CHARACTERS:
                    return {
                        fetchWithLowPriority: !1,
                        mappingOptions: {
                            audioElementWeight: 50,
                            iframeElementWeight: 50,
                            imageElementWeight: 50,
                            videoElementWeight: 50,
                            whitespaceBehaviour: "COLLAPSE"
                        },
                        name: a,
                        serializedData: "",
                        unit: D.ContentPositionTimelineUnit.CHARACTERS
                    };
                case D.ContentPositionTimelineUnit.DOCUMENTS:
                    return {
                        fetchWithLowPriority: !1,
                        name: a,
                        serializedData: "",
                        unit: D.ContentPositionTimelineUnit.DOCUMENTS
                    };
                case D.ContentPositionTimelineUnit.PAGES:
                    return {
                        fetchWithLowPriority: !1,
                        name: a,
                        serializedData: "",
                        unit: D.ContentPositionTimelineUnit.PAGES
                    };
                case D.ContentPositionTimelineUnit.WORDS:
                    return {
                        fetchWithLowPriority: !1,
                        mappingOptions: {
                            audioElementWeight: 10,
                            iframeElementWeight: 10,
                            imageElementWeight: 10,
                            videoElementWeight: 10
                        },
                        name: a,
                        serializedData: "",
                        unit: D.ContentPositionTimelineUnit.WORDS
                    };
            }
        }
        function Dd(a, b, c, d, e, f) {
            var g;
            return q.K(function(h) {
                E.ContentPositionTimelineUtils.sendProgressEvent(a, b, c, 0);
                g = d.map(function(l, m) {
                    return e.scheduleTask(function() {
                        var n, p, u;
                        return q.K(function(v) {
                            if (1 == v.g) return da(v, 2), r(v, l.Ea(), 4);
                            if (2 != v.g) {
                                n = v.h;
                                var w = f.g.Xe(), x = new od(f.g, w, f.h[m]);
                                hd(x, M(n));
                                x = x.Aa;
                                f.g.Bg(w) || x--;
                                p = Math.max(0, x);
                                E.ContentPositionTimelineUtils.sendProgressEvent(a, b, c, (m + 1) / d.length);
                                return v.return(0 === p ? 1 : p);
                            }
                            u = fa(v);
                            if (t.ColibrioError.isColibrioAbortedError(u)) throw u;
                            t.Logger.logError(u);
                            return v.return(1);
                        });
                    }, 0);
                });
                return h.return(Promise.all(g));
            });
        }
        function zd(a, b, c, d, e, f, g, h) {
            var l, m;
            return q.K(function(n) {
                if (1 == n.g) return l = Ed(a), n.m = 0, n.o = 2, r(n, Dd(a, b, c, d, l, e), 4);
                if (2 != n.g) return m = n.h, n.return(new wd(e, a, d, m, f, g, h));
                ia(n);
                l.destroy();
                return ja(n, 0);
            });
        }
        function Ed(a) {
            return new E.ReadingSystemAsyncTaskScheduler(a.getReadingSystemEngine(), {
                concurrency: 1,
                pauseOnOffscreenContentRendering: !0,
                pauseOnReaderViewGesture: !0,
                pauseOnReaderViewNavigation: !0,
                pauseOnVisibleContentRendering: !0
            });
        }
        function yd(a, b, c, d) {
            return a.signature === b.getSourcePublication().getHashSignature() && xa(a.indexesInSpine, c.map(function(e) {
                return e.getIndexInSpine();
            })) && d == a.optionsHash;
        }
        k = wd.prototype;
        k.fetchContentLocation = function(a) {
            var b = this;
            return q.K(function(c) {
                return b.h ? c.return(Fd(b, function() {
                    return Gd(b, a);
                })) : c.return(Gd(b, a));
            });
        };
        k.fetchContentLocationAsRange = function(a, b) {
            var c = this;
            return q.K(function(d) {
                return c.h ? d.return(Fd(c, function() {
                    return Hd(c, a, b);
                })) : d.return(Hd(c, a, b));
            });
        };
        k.fetchTimelinePosition = function(a) {
            var b = this;
            return this.h ? Fd(this, function() {
                return Id(b, a);
            }) : Id(this, a);
        };
        k.fetchTimelinePositions = function(a) {
            var b = this, c, d, e, f, g, h, l, m, n, p, u, v, w, x, A, z, C, F, G, L, P, Y, ba, ka;
            return q.K(function(V) {
                switch(V.g){
                    case 1:
                        return r(V, Jd(b, a), 2);
                    case 2:
                        c = V.h, d = {}, e = {}, f = {}, g = [], h = q.na(c), l = h.next();
                    case 3:
                        if (l.done) {
                            V.$(5);
                            break;
                        }
                        m = l.value;
                        if ("fulfilled" !== m.status) {
                            g.push(m);
                            V.$(4);
                            break;
                        }
                        n = m.value;
                        p = n.location;
                        u = n.Yh;
                        v = u.getIndexInSpine();
                        w = d[v];
                        x = void 0;
                        A = null != (x = w) ? x : b.R.indexOf(u);
                        z = void 0;
                        if (null != (z = e[v])) {
                            C = z;
                            V.$(7);
                            break;
                        }
                        return r(V, b.Ea(u), 8);
                    case 8:
                        C = V.h;
                    case 7:
                        F = C;
                        G = void 0;
                        L = null != (G = f[v]) ? G : Kd(b, A);
                        Ka(w) && (d[v] = A, -1 !== A && (e[v] = F, f[v] = L));
                        P = void 0;
                        if (-1 === A) {
                            P = Ld(b, v);
                            V.$(9);
                            break;
                        }
                        return r(V, Md(b, p), 10);
                    case 10:
                        Y = V.h, ba = Y.collapseToStart(), P = Nd(b, A, u, F, L, ba, !1);
                    case 9:
                        ka = La(P, 0, b.g), g.push({
                            status: "fulfilled",
                            value: ka
                        });
                    case 4:
                        l = h.next();
                        V.$(3);
                        break;
                    case 5:
                        return V.return(g);
                }
            });
        };
        k.fetchTimelineRange = function(a) {
            var b = this;
            return q.K(function(c) {
                return b.h ? c.return(Fd(b, function() {
                    return Od(b, a);
                })) : c.return(Od(b, a));
            });
        };
        k.getLength = function() {
            return this.g;
        };
        k.getReaderDocuments = function() {
            return this.R.slice();
        };
        k.getUnit = function() {
            return this.m.getUnit();
        };
        k.intersectsContentLocation = function(a) {
            var b = this;
            return a.getReaderDocuments().some(function(c) {
                return b.R.includes(c);
            });
        };
        k.toSerializedData = function() {
            var a = this.V.getSourcePublication().getHashSignature(), b = this.R.map(function(c) {
                return c.getIndexInSpine();
            });
            return E.ContentPositionTimelineUtils.serialize({
                documentsLength: this.j,
                indexesInSpine: b,
                optionsHash: this.o,
                signature: a
            });
        };
        function Gd(a, b) {
            var c, d, e;
            return q.K(function(f) {
                if (1 == f.g) {
                    c = La(b, 0, a.g);
                    if (c !== a.g) return f.$(2);
                    d = Da(a.R);
                    return r(f, d.fetchContentLocationForEntireDocument(), 3);
                }
                return 2 != f.g ? (e = f.h, f.return(e.collapseToEnd())) : f.return(Pd(a, c));
            });
        }
        function Hd(a, b, c) {
            var d, e, f, g, h, l, m, n;
            return q.K(function(p) {
                switch(p.g){
                    case 1:
                        d = La(b, 0, a.g);
                        K(c) || (c = d + 1);
                        e = La(c, d, a.g);
                        if (d !== a.g) {
                            p.$(2);
                            break;
                        }
                        f = Da(a.R);
                        return r(p, f.fetchContentLocationForEntireDocument(), 3);
                    case 3:
                        return g = p.h, p.return(g.collapseToEnd());
                    case 2:
                        return d === e ? p.return(Pd(a, d)) : r(p, Pd(a, d), 4);
                    case 4:
                        return h = p.h, l = e - 1, d === l ? r(p, Pd(a, l, !1, !0), 9) : e > d ? r(p, Pd(a, l, !0, !0), 8) : p.return(h);
                    case 8:
                        return m = p.h, p.return(h.createRangeTo(m));
                    case 9:
                        return n = p.h, p.return(h.createRangeTo(n));
                }
            });
        }
        function Md(a, b) {
            return a.h ? Fd(a, function() {
                return gd(b, a.V);
            }) : gd(b, a.V);
        }
        function Pd(a, b, c, d) {
            c = void 0 === c ? !1 : c;
            d = void 0 === d ? !1 : d;
            var e, f, g, h, l, m;
            return q.K(function(n) {
                if (1 == n.g) return e = b, f = a.j.findIndex(function(p) {
                    if (c && e <= p || !c && e < p) return !0;
                    e -= p;
                    return !1;
                }), g = a.R[f], r(n, g.Ea(), 2);
                h = n.h;
                l = sd(a.m, h, f, e, d);
                m = fd(a.N, g.getSourceContentDocument(), l.s, l.i);
                return n.return(new X(m, [
                    g
                ], g.getReaderPublication(), {
                    Ca: !1,
                    O: null,
                    Ka: !0,
                    P: cc(l.s, l.i)
                }));
            });
        }
        k.Ea = function(a) {
            return this.h ? Fd(this, function() {
                return a.Ea();
            }) : a.Ea();
        };
        function Qd(a, b, c) {
            var d, e, f, g, h, l, m;
            return q.K(function(n) {
                if (1 == n.g) return d = b.getReaderDocuments(), e = c ? Da(d) : 0 < d.length ? d[0] : void 0, f = a.R.indexOf(e), h = e.getIndexInSpine(), -1 === f ? (g = Ld(a, h), n.$(2)) : r(n, e.Ea(), 3);
                2 != n.g && (l = n.h, m = Kd(a, f), g = Nd(a, f, e, l, m, b, c));
                return n.return(La(g, 0, a.g));
            });
        }
        function Id(a, b) {
            return gd(b, a.V).then(function(c) {
                return Qd(a, c.collapseToStart(), !1);
            });
        }
        function Od(a, b) {
            var c, d, e, f, g, h, l, m, n;
            return q.K(function(p) {
                if (1 == p.g) return r(p, gd(b, a.V), 2);
                if (3 != p.g) {
                    c = p.h;
                    d = Da(c.getReaderDocuments());
                    if (d.getIndexInSpine() < a.R[0].getIndexInSpine()) return p.return({
                        end: 0,
                        start: 0
                    });
                    e = q;
                    f = e.na;
                    return r(p, Promise.all([
                        Qd(a, c, !1),
                        Qd(a, c, !0)
                    ]), 3);
                }
                g = f.call(e, p.h);
                h = g.next().value;
                l = g.next().value;
                m = h;
                n = l;
                return p.return({
                    end: n,
                    start: m
                });
            });
        }
        function Ld(a, b) {
            var c = ya(a.R, 2, a.R.length, function(d, e) {
                return b - d[e].getIndexInSpine();
            });
            return Kd(a, c);
        }
        function Jd(a, b) {
            var c;
            return q.K(function(d) {
                c = b.map(function(e) {
                    var f;
                    return q.K(function(g) {
                        if (1 == g.g) return E.ReadingSystemUtils.isContentLocation(e) || E.ReadingSystemUtils.isUnresolvedContentLocation(e) ? g.$(2) : r(g, a.V.fetchUnresolvedContentLocation(e), 3);
                        2 != g.g && (e = g.h);
                        return (f = e.getReaderDocuments()[0]) ? g.return({
                            location: e,
                            Yh: f
                        }) : g.return(Promise.reject());
                    });
                });
                return d.return(Promise.allSettled(c));
            });
        }
        function Kd(a, b) {
            for(var c = 0, d = 0; d < b; d++)c += a.j[d];
            return c;
        }
        function Nd(a, b, c, d, e, f, g) {
            c = $c(f, c, d);
            a = ud(a.m, d, b, g && c.O ? c.O : c.P, a.j[b], g);
            return e + a;
        }
        function Fd(a, b) {
            var c, d;
            return q.K(function(e) {
                switch(e.g){
                    case 1:
                        return c = Ed(a.V), da(e, 2, 3), r(e, c.scheduleTask(b, 0), 5);
                    case 5:
                        return e.return(e.h);
                    case 3:
                        ia(e);
                        c.destroy();
                        ja(e, 0);
                        break;
                    case 2:
                        return d = fa(e), t.Logger.logError(d), e.return(Promise.reject(d));
                }
            });
        }
        function Rd(a, b) {
            var c = [
                new Sd
            ];
            this.g = a;
            this.h = c;
            this.nd = b;
            this.kb = this.g.getDefaultLocatorUrl();
        }
        function fd(a, b, c, d) {
            var e = Td(a, function() {
                return Ud(b, c, d);
            });
            return new qa.Locator(a.kb, e);
        }
        function Vd(a, b) {
            var c = Td(a, function() {
                var d;
                (d = Wd(b)) ? (d.appendTerminalIndirection(), d = new ua.EpubCfiSelector(d.getEpubCfiRootNode())) : d = null;
                return d;
            });
            return new qa.Locator(a.kb, c);
        }
        function Xd(a, b, c) {
            var d = Td(a, function() {
                return Yd(b, c);
            });
            return new qa.Locator(a.kb, d);
        }
        function dd(a, b, c) {
            var d = Td(a, function() {
                return Zd(b, c);
            });
            return new qa.Locator(a.kb, d);
        }
        function ed(a, b, c) {
            var d = Td(a, function() {
                var e;
                (e = Wd(b)) ? (e.appendLocalPathTo(c), e = new ua.EpubCfiSelector(e.getEpubCfiRootNode())) : e = null;
                return e;
            });
            return new qa.Locator(a.kb, d);
        }
        function $d(a, b) {
            var c = a.g.getSourcePublication().getContentDocumentByUrl(b);
            if (c) {
                if (b.hash.startsWith("#")) {
                    var d = b.hash.slice(1);
                    b = Td(a, function() {
                        return Yd(c, d);
                    });
                    return new qa.Locator(a.kb, b);
                }
                return Vd(a, c);
            }
            return a.nd.parse(b).locator;
        }
        Rd.prototype.getLocatorFactory = function() {
            return this.nd;
        };
        function Td(a, b) {
            for(var c = [], d = 0; d < a.h.length; d++){
                var e = b(a.h[d]);
                e && c.push(e);
            }
            return c;
        }
        function Sd() {}
        function Ud(a, b, c) {
            c = Math.round(c);
            a = Wd(a);
            if (!a) return null;
            a.appendTerminalDomPosition(b, c);
            return new ua.EpubCfiSelector(a.getEpubCfiRootNode());
        }
        function Zd(a, b) {
            a = Wd(a);
            if (!a) return null;
            a.appendTerminalDomRange(b);
            return new ua.EpubCfiSelector(a.getEpubCfiRootNode());
        }
        function Yd(a, b) {
            if (a = Wd(a)) {
                a = a.getEpubCfiRootNode();
                var c = a.parentPath;
                if (c) {
                    var d;
                    b ? d = {
                        parameters: [],
                        srcOffset: 0,
                        type: ua.EpubCfiNodeType.ASSERTION_XML_ID,
                        xmlId: b
                    } : d = null;
                    c.localPaths.push({
                        indirection: !0,
                        steps: [
                            {
                                assertion: d,
                                stepValue: 0,
                                type: ua.EpubCfiNodeType.STEP_ELEMENT
                            }
                        ],
                        type: ua.EpubCfiNodeType.LOCAL_PATH
                    });
                    return new ua.EpubCfiSelector(a);
                }
            }
            return null;
        }
        function Wd(a) {
            a = a.getOpfSpineItemElement();
            if (!a) return null;
            var b = new ua.EpubCfiBuilder;
            b.appendLocalPathTo(a);
            return b;
        }
        function ae(a, b, c, d, e, f) {
            this.pa = a;
            this.R = b;
            this.V = c;
            this.h = e;
            this.j = f;
            this.g = d;
        }
        function be(a) {
            return new ae(a.getLocator(), a.getReaderDocuments(), a.getReaderPublication(), null, null, Promise.resolve(a));
        }
        function ce(a, b) {
            var c = null;
            if (0 < a.getResolverErrors().length || 0 < a.getParserErrors().length || a.isRepairedWithXmlIdAssertions()) {
                var d = a.createDomRange();
                if (d && (c = b[0].getSourceContentDocument(), (c = Zd(c, d)) && !a.isOwnedBySingleDocument() && a.rangeEndPath)) return b = b[b.length - 1].getSourceContentDocument(), a = Ud(b, a.rangeEndPath.container, a.rangeEndPath.offset), null !== a ? c.createRangeSelectorTo(a) : null;
            }
            return c;
        }
        k = ae.prototype;
        k.collapseToEnd = function() {
            return this.resolve().then(function(a) {
                a = a.collapseToEnd();
                return be(a);
            });
        };
        k.collapseToStart = function() {
            return this.resolve().then(function(a) {
                a = a.collapseToStart();
                return be(a);
            });
        };
        k.contains = function(a) {
            return Promise.all([
                this.resolve(),
                de(this, a)
            ]).then(function(b) {
                return b[0].contains(b[1]);
            }).catch(function(b) {
                t.Logger.logError(b);
                return !1;
            });
        };
        k.createRangeTo = function(a) {
            return Promise.all([
                this.resolve(),
                de(this, a)
            ]).then(function(b) {
                b = b[0].createRangeTo(b[1]);
                return be(b);
            });
        };
        k.equals = function(a) {
            return Promise.all([
                this.resolve(),
                de(this, a)
            ]).then(function(b) {
                return b[0].equals(b[1]);
            }).catch(function(b) {
                t.Logger.logError(b);
                return !1;
            });
        };
        k.fetchContentBlockTargets = function(a) {
            return this.resolve().then(function(b) {
                return b.fetchContentBlockTargets(a);
            });
        };
        k.fetchContentResolver = function() {
            return this.resolve().then(function(a) {
                return a.fetchContentResolver();
            });
        };
        k.fetchNavigationItemReferences = function(a) {
            return this.resolve().then(function(b) {
                return b.fetchNavigationItemReferences(a);
            });
        };
        k.getLocator = function() {
            return this.pa;
        };
        k.getReaderDocuments = function() {
            return this.R;
        };
        k.getReaderPublication = function() {
            return this.V;
        };
        k.intersects = function(a) {
            return Promise.all([
                this.resolve(),
                de(this, a)
            ]).then(function(b) {
                return b[0].intersects(b[1]);
            }).catch(function(b) {
                t.Logger.logError(b);
                return !1;
            });
        };
        k.isAfter = function(a) {
            return Promise.all([
                this.resolve(),
                de(this, a)
            ]).then(function(b) {
                return b[0].isAfter(b[1]);
            }).catch(function(b) {
                t.Logger.logError(b);
                return !1;
            });
        };
        k.isBefore = function(a) {
            return Promise.all([
                this.resolve(),
                de(this, a)
            ]).then(function(b) {
                return b[0].isBefore(b[1]);
            }).catch(function(b) {
                t.Logger.logError(b);
                return !1;
            });
        };
        k.isRange = function() {
            return this.resolve().then(function(a) {
                return a.isRange();
            });
        };
        k.resolve = function() {
            var a = this;
            this.j || (this.j = ee(this).then(function(b) {
                var c = null !== b.selector ? new qa.Locator(a.pa.getSourceUrl(), [
                    b.selector
                ]) : a.pa;
                return new X(c, a.R, a.V, b.result);
            }));
            return this.j;
        };
        k.toJSON = function() {
            return this.pa.toJSON();
        };
        function de(a, b) {
            var c;
            E.ReadingSystemUtils.isUnresolvedContentLocation(b) ? c = b.resolve() : E.ReadingSystemUtils.isContentLocation(b) ? c = Promise.resolve(b) : c = a.V.fetchUnresolvedContentLocation(b).then(function(d) {
                return d.resolve();
            });
            return c.then(function(d) {
                if (!(d instanceof X)) throw Promise.reject(new T("INCOMPATIBLE_LOCATION", "Incompatible ContentLocation instance."));
                return d;
            });
        }
        function ee(a) {
            var b, c, d, e, f, g, h, l, m, n, p;
            return q.K(function(u) {
                switch(u.g){
                    case 1:
                        if (!a.g) throw new U("EpubCfiUnresolvedContentLocation.resolver was null");
                        b = {};
                    case 2:
                        if (!a.h || !a.g) {
                            e = a.g.getResolvedTarget();
                            f = ce(e, a.R);
                            a.g = null;
                            if (!e.rangeStartPath || !e.rangeEndPath) {
                                h = null;
                                e.isTargetingOpfDocument() ? g = {
                                    v: [],
                                    i: 0
                                } : g = fe(e.parentPath);
                                u.$(7);
                                break;
                            }
                            l = e.rangeStartPath;
                            m = e.rangeEndPath;
                            l.isTargetingOpfDocument() ? g = {
                                v: [],
                                i: 0
                            } : g = fe(l);
                            if (!m.isTargetingOpfDocument()) {
                                h = fe(m);
                                u.$(7);
                                break;
                            }
                            if (1 === a.R.length) {
                                h = {
                                    v: [],
                                    i: M(l.getDocument()).childNodes.length
                                };
                                u.$(7);
                                break;
                            }
                            n = Da(a.R);
                            return r(u, n.Ea(), 10);
                        }
                        if ("itemref" !== a.h.element.localName) {
                            a.h = a.g.skipNextIndirection();
                            u.$(3);
                            break;
                        }
                        b.ug = a.h.element;
                        c = a.R.find(function(v) {
                            return function(w) {
                                return w.getSourceContentDocument().getOpfSpineItemElement() === v.ug;
                            };
                        }(b));
                        return r(u, c.Ea(), 6);
                    case 6:
                        d = u.h, a.h = a.g.continueResolving(d, c.getSourceContentDocument().getContentUrl());
                    case 3:
                        b = {
                            ug: void 0
                        };
                        u.$(2);
                        break;
                    case 10:
                        p = u.h, h = {
                            v: [],
                            i: M(p).childNodes.length
                        };
                    case 7:
                        return u.return({
                            result: {
                                Ca: e.getSideBias() === ua.EpubCfiSideBias.BEFORE,
                                O: h,
                                Ka: 1 === a.R.length,
                                P: g
                            },
                            selector: f
                        });
                }
            });
        }
        function fe(a) {
            var b = ac(a.container);
            b ? a = {
                v: b,
                i: a.offset
            } : (b = M(a.container.ownerDocument), a = a.container.parentNode === a.container.ownerDocument ? a.offset <= O(b) ? {
                v: [],
                i: 0
            } : {
                v: [],
                i: b.childNodes.length
            } : {
                v: [],
                i: 0
            });
            return a;
        }
        function ge(a) {
            a = a.getSelectors().find(he) || null;
            if (!a) return [];
            a = a.getRootNode().parentPath;
            if (!a) return [];
            a = a.localPaths[0].steps;
            for(var b = [], c = 0; c < a.length; c++)b.push(a[c].stepValue);
            return b;
        }
        function he(a) {
            return a instanceof ua.EpubCfiSelector;
        }
        function ie(a, b, c, d) {
            this.fa = a;
            this.g = b;
            this.J = c;
            this.ld = d;
        }
        k = ie.prototype;
        k.getChildren = function() {
            return this.fa;
        };
        k.getIndex = function() {
            return this.ld;
        };
        k.getTitle = function() {
            return this.g;
        };
        k.getType = function() {
            return this.J;
        };
        k.toJSON = function() {
            return {
                children: this.fa.map(function(a) {
                    return a.toJSON();
                }),
                index: this.ld,
                title: this.g,
                type: this.J
            };
        };
        function je(a, b, c, d, e, f, g) {
            this.fa = a;
            this.kd = b;
            this.ba = c;
            this.j = d;
            this.pa = e;
            this.h = f;
            this.ec = g;
            this.qd = null;
            this.g = -1;
        }
        k = je.prototype;
        k.getChildren = function() {
            return this.fa || [];
        };
        k.getHref = function() {
            return this.ec;
        };
        k.getId = function() {
            return this.ba;
        };
        k.getLocator = function() {
            return this.pa;
        };
        k.getParent = function() {
            return this.qd;
        };
        k.getTextContent = function() {
            return this.h;
        };
        k.isTargetingReaderDocumentInSpine = function() {
            return this.j;
        };
        k.toJSON = function() {
            return {
                children: this.fa ? this.fa.map(function(a) {
                    return a.toJSON();
                }) : [],
                href: this.ec,
                id: this.ba,
                isTargetingReaderDocumentInSpine: this.j,
                locator: this.pa && this.pa.toJSON(),
                parentId: this.qd && this.qd.getId(),
                textContent: this.h
            };
        };
        function ke(a, b, c, d) {
            this.j = a;
            this.g = b;
            this.N = c;
            this.ra = d;
            this.h = 1;
        }
        function le(a, b) {
            for(var c = null, d = !1, e = null, f = null, g = null, h = a.h++, l = null, m = b.firstChild; m;){
                if (H(m)) {
                    var n = m.tagName;
                    if ("a" === n) {
                        if (c = m.getAttribute("href")) try {
                            var p = B.URLUtils.normalizePathnameEncoding(new URL(c, a.g));
                            d = a.isTargetingReaderDocumentInSpine(p);
                            e = $d(a.N, p);
                            f = p.hash;
                            d || (l = B.URLUtils.getSanitizedRemoteHref(p));
                        } catch (u) {
                            t.Logger.logWarning(new T("INVALID_URL_IN_PUBLICATION_RESOURCE", String(u) + (' - source="' + a.g.pathname + '", href="' + c + '"')));
                        }
                        c = m.textContent;
                        Ga(c) || (c = m.getAttribute("title") || "");
                    } else "span" === n ? c = m.textContent : "ol" === n && (g = me(a, m));
                }
                m = m.nextSibling;
            }
            c && (c = c.replace(/\s{2,}/g, " ").trim());
            if (!c) {
                c = "";
                a = new R(b, function(u) {
                    return 3 === u.nodeType;
                });
                b = function(u) {
                    return H(u) && "ol" !== u.tagName;
                };
                for(S(a, b); a.g;)c += a.g.data, S(a, b);
                c = c.replace(/\s{2,}/g, " ").trim();
            }
            if (!c && !g) return null;
            d = new je(g, f, h, d, e, c, l);
            if (g) for(e = 0; e < g.length; e++)g[e].qd = d;
            return d;
        }
        function me(a, b) {
            var c = [];
            bb(b, function(d) {
                "li" === d.localName && (d = le(a, d)) && c.push(d);
            });
            return 0 < c.length ? c : null;
        }
        function ne(a, b, c, d) {
            var e = null, f = null;
            bb(b, function(g) {
                var h = g.localName;
                /h[1-6]/.test(h) ? e = g.textContent : "ol" === h && (f = me(a, g));
            });
            return f ? new ie(f, e, c, d) : null;
        }
        ke.prototype.isTargetingReaderDocumentInSpine = function(a) {
            var b = B.URLUtils.getUrlWithoutHash(a);
            return this.ra.some(function(c) {
                return B.URLUtils.getUrlWithoutHash(c.getSourceContentDocument().getContentUrl()) === b;
            });
        };
        function oe(a, b, c, d) {
            this.h = a;
            this.j = b;
            this.N = c;
            this.ra = d;
            this.g = 1;
        }
        function pe(a, b) {
            var c = b.getAttribute("src");
            b = null;
            var d = !1, e = null, f = null;
            c && (c = B.URLUtils.normalizePathnameEncoding(new URL(c, a.j)), d = a.isTargetingReaderDocumentInSpine(c), b = $d(a.N, c), e = c.hash, d || (f = B.URLUtils.getSanitizedRemoteHref(c)));
            return {
                kd: e,
                ec: f,
                Kf: d,
                pa: b
            };
        }
        function qe(a) {
            return (a = a.firstElementChild) && J(a.firstChild) ? a.firstChild.data : null;
        }
        function re(a, b) {
            var c = null, d = null, e = a.g++, f = !1, g = null, h = null, l = null;
            b = b.firstElementChild;
            var m = null;
            b && "navLabel" === b.localName && (g = qe(b), b = b.nextElementSibling);
            if (b && "content" === b.localName) {
                try {
                    m = pe(a, b);
                } catch (p) {
                    t.Logger.logWarning(p);
                }
                b = b.nextElementSibling;
            }
            if (g) for(; b;){
                if ("navPoint" === b.localName) {
                    var n = re(a, b);
                    n && (d || (d = []), d.push(n));
                }
                b = b.nextElementSibling;
            }
            if (g) {
                m && (c = m.pa, f = m.Kf, h = m.kd, l = m.ec);
                a = new je(d, h, e, f, c, g, l);
                if (d) for(c = 0; c < d.length; c++)d[c].qd = a;
                return a;
            }
            return null;
        }
        function se(a, b) {
            var c = b.firstElementChild, d = null, e = null;
            c && "navLabel" === c.localName && (d = qe(c), c = c.nextElementSibling);
            c && "content" === c.localName && (e = pe(a, c));
            d || (d = b.getAttribute("value"));
            return null === d ? null : new je(null, e && e.kd, a.g++, e ? e.Kf : !1, e && e.pa, d, e && e.ec);
        }
        oe.prototype.isTargetingReaderDocumentInSpine = function(a) {
            var b = B.URLUtils.getUrlWithoutHash(a);
            return this.ra.some(function(c) {
                return B.URLUtils.getUrlWithoutHash(c.getSourceContentDocument().getContentUrl()) === b;
            });
        };
        function te(a, b) {
            this.j = a;
            this.h = new Map;
            this.g = [];
            b = 2 * (b + 1);
            for(var c = 0; c < a.length; c++){
                for(var d = a[c], e = new t.TreeNodeWalker(d.getChildren()), f = []; e.hasNext();){
                    var g = e.next(), h = g.getLocator();
                    h && g.isTargetingReaderDocumentInSpine() && (h = ge(h), 2 === h.length && h[0] === b && (g.g = (h[1] >> 1) - 1, f.push(g), this.g.push(g)));
                }
                Cb.sort(f, function(l, m) {
                    return l.g - m.g;
                });
                this.h.set(d, f);
            }
            Cb.sort(this.g, function(l, m) {
                return l.getId() - m.getId();
            });
        }
        function ue(a, b, c) {
            return a.fetchNavigationDocument().then(function(d) {
                var e = a.getOpfDocument().querySelector("package > spine");
                e = e ? db(e) : -1;
                var f = d.getType();
                if ("nav" === f) {
                    f = d.getDocument();
                    d = d.getUrl();
                    d = new ke(f, d, b, c);
                    f = [];
                    for(var g = d.j.getElementsByTagName("nav"), h = 0; h < g.length; h++){
                        var l = g[h], m = void 0;
                        a: {
                            var n = l.attributes;
                            for(var p = 0; p < n.length; p++){
                                var u = n.item(p);
                                if (u && "epub:type" === u.name) {
                                    n = u.value;
                                    break a;
                                }
                            }
                            n = void 0;
                        }
                        switch(n){
                            case "toc":
                                m = D.NavigationCollectionType.TOC;
                                break;
                            case "landmarks":
                                m = D.NavigationCollectionType.LANDMARKS;
                                break;
                            case "loa":
                                m = D.NavigationCollectionType.LIST_OF_AUDIO_CLIPS;
                                break;
                            case "loi":
                                m = D.NavigationCollectionType.LIST_OF_ILLUSTRATIONS;
                                break;
                            case "lot":
                                m = D.NavigationCollectionType.LIST_OF_TABLES;
                                break;
                            case "lov":
                                m = D.NavigationCollectionType.LIST_OF_VIDEO_CLIPS;
                                break;
                            case "page-list":
                                m = D.NavigationCollectionType.PAGE_LIST;
                        }
                        m && (l = ne(d, l, m, f.length)) && f.push(l);
                    }
                    return new te(f, e);
                }
                if ("ncx" === f) {
                    f = d.getDocument();
                    d = d.getUrl();
                    d = new oe(f, d, b, c);
                    f = [];
                    for(g = d.h.documentElement.firstElementChild; g;){
                        h = null;
                        l = f.length;
                        switch(g.localName){
                            case "navMap":
                                h = d;
                                m = [];
                                for(n = g.firstElementChild; n;)"navPoint" === n.localName && (p = re(h, n)) && m.push(p), n = n.nextElementSibling;
                                h = 0 === m.length ? null : new ie(m, null, D.NavigationCollectionType.TOC, l);
                                break;
                            case "pageList":
                                h = d;
                                m = [];
                                for(n = g.firstElementChild; n;)"pageTarget" === n.localName && (p = se(h, n)) && m.push(p), n = n.nextElementSibling;
                                h = 0 === m.length ? null : new ie(m, null, D.NavigationCollectionType.PAGE_LIST, l);
                                break;
                            case "navList":
                                h = d;
                                m = [];
                                n = g.firstElementChild;
                                p = null;
                                n && "navLabel" === n.localName && (p = qe(n), n = n.nextElementSibling);
                                for(; n;)"navTarget" === n.localName && (u = se(h, n)) && m.push(u), n = n.nextElementSibling;
                                h = 0 === m.length ? null : new ie(m, p, D.NavigationCollectionType.CUSTOM, l);
                        }
                        h && f.push(h);
                        g = g.nextElementSibling;
                    }
                    return new te(f, e);
                }
                throw new T("NAVIGATION_DOCUMENT_TYPE_UNSUPPORTED", 'type="' + f + '"');
            });
        }
        te.prototype.getNavigationCollections = function() {
            return this.j;
        };
        te.prototype.getNavigationItemById = function(a) {
            return this.g[a - 1];
        };
        te.prototype.toJSON = function() {
            return {
                navigationCollections: this.j.map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function ve(a, b, c) {
            this.ra = b;
            this.W = c;
            this.j = this.h = null;
            this.L = !1;
            this.g = new Map;
            this.m = -1;
            this.C = Na(a, {
                audioElementWeight: 50,
                iframeElementWeight: 50,
                imageElementWeight: 50,
                videoElementWeight: 50
            });
        }
        ve.prototype.destroy = function() {
            this.L = !0;
            this.g.clear();
        };
        ve.prototype.getEstimatedNumberOfPages = function(a, b) {
            var c = this;
            this.h || (this.h = we(this));
            return this.h.then(function() {
                c.j && c.m === b.getRenderingSessionId() || (c.m = b.getRenderingSessionId(), c.j = xe(c, b));
                return c.j;
            }).then(function(d) {
                if (c.L || b.isCanceled()) return Promise.reject(new T(t.ColibrioErrorType.ABORTED));
                var e = c.g.get(a);
                K(e) || (e = 1);
                return e / d;
            });
        };
        function we(a) {
            var b, c, d, e, f;
            return q.K(function(g) {
                switch(g.g){
                    case 1:
                        b = q.na(a.ra), c = b.next();
                    case 2:
                        if (c.done) {
                            g.$(0);
                            break;
                        }
                        d = c.value;
                        if (!d.isReflowable()) {
                            g.$(3);
                            break;
                        }
                        da(g, 6);
                        return r(g, ye(a, d), 8);
                    case 8:
                        e = g.h;
                        a.g.set(d, e);
                        g.g = 3;
                        g.m = 0;
                        break;
                    case 6:
                        f = fa(g), t.ColibrioError.isColibrioAbortedError(f) || t.Logger.logError(f), a.g.set(d, 1);
                    case 3:
                        c = b.next(), g.$(2);
                }
            });
        }
        function xe(a, b) {
            for(var c = ze(a, 1E4), d = 2; !c.Ga && 16 >= d;)d *= 2, c = ze(a, 2E4 / d);
            if (!c.Ga && (c = ze(a, 1), !c.Ga)) throw new T("PAGE_ESTIMATION_ERROR", "No reflowable documents in publication");
            var e = c.Ga, f = b.getPageStream();
            return f && f.isReaderDocumentLoaded(e) ? f.loadFirstPageInReaderDocument(e).then(function(g) {
                try {
                    var h = g.getPageFragmentationContext();
                    if (h) {
                        var l = h.getDocumentHeight() / b.getUnconstrainedPageDimensions(g.getSpreadSlot()).height;
                        return c.Fe / l;
                    }
                    return Ae(e, b, c.Fe);
                } finally{
                    f.unloadPage(g);
                }
            }) : Ae(e, b, c.Fe);
        }
        function Ae(a, b, c) {
            return a.createRenderableDocument(b).then(function(d) {
                return d.sections[0].createPageIterator();
            }).then(function(d) {
                var e = d.getEstimatedNumberOfPages();
                d.destroy();
                return c / e;
            });
        }
        function ye(a, b) {
            return Be(a.W.lb, b.getSourceContentDocument()).then(function(c) {
                if (a.L) throw new T(t.ColibrioErrorType.ABORTED);
                var d = c.Ga;
                c = 0;
                if (d) for(d = new R(M(d)), S(d, Ce); d.g;){
                    var e = d.g;
                    if (J(e)) {
                        e = e.data;
                        for(var f = 0; f < e.length; f++){
                            var g = e.charCodeAt(f);
                            13 < g && 32 !== g && (55296 > g || 56319 < g) && c++;
                        }
                    } else if (H(e)) switch(e.localName){
                        case "img":
                        case "svg":
                        case "picture":
                            c += a.C.imageElementWeight;
                            break;
                        case "video":
                            c += a.C.videoElementWeight;
                            break;
                        case "audio":
                            c += a.C.audioElementWeight;
                            break;
                        case "iframe":
                            c += a.C.iframeElementWeight;
                    }
                    S(d, Ce);
                }
                return Math.max(c, 1);
            });
        }
        function ze(a, b) {
            var c = Number.MAX_SAFE_INTEGER, d = null, e = 1;
            a.g.forEach(function(f, g) {
                var h = Math.abs(2E4 - f) * (2E4 > f ? 2 : 1);
                h < c && f >= b && (d = g, c = h, e = f);
            });
            return {
                Ga: d,
                Fe: e
            };
        }
        function Ce(a) {
            return H(a) && !lb(a.localName) && "svg" !== a.localName;
        }
        function De(a, b) {
            this.ra = a;
            this.m = b;
            this.h = null;
            this.L = !1;
            this.g = new Map;
            this.j = null;
        }
        De.prototype.destroy = function() {
            this.L || (this.L = !0, this.g.clear(), this.h = null);
        };
        De.prototype.getEstimatedNumberOfPages = function(a, b) {
            var c = this;
            if (this.L) return Promise.reject(new T(t.ColibrioErrorType.ABORTED));
            this.h && this.j === b.getRenderingSessionId() || (this.j = b.getRenderingSessionId(), this.h = Ee(this, b));
            return this.h.then(function(d) {
                if (c.L || b.isCanceled()) return Promise.reject(new T(t.ColibrioErrorType.ABORTED));
                var e = c.g.get(a);
                return K(e) ? e / d : (e = c.m.getResourceProvider(), Fe(e, a).then(function(f) {
                    c.g.set(a, f);
                    return f / d;
                }));
            });
        };
        function Ee(a, b) {
            var c, d, e, f;
            return q.K(function(g) {
                if (1 == g.g) {
                    if (0 !== a.g.size) return g.$(2);
                    c = [];
                    d = a.m.getResourceProvider();
                    a.ra.forEach(function(h) {
                        if (h.isReflowable()) {
                            var l = Fe(d, h).then(function(m) {
                                a.L || a.g.set(h, m);
                            });
                            c.push(l);
                        }
                    });
                    return r(g, Promise.all(c), 2);
                }
                if (a.L) throw new T(t.ColibrioErrorType.ABORTED);
                e = Ge(a, 2E4);
                for(f = 2; !e.Ga && 16 >= f;)f *= 2, e = Ge(a, 4E4 / f);
                if (!e.Ga && (e = Ge(a, 1), !e.Ga)) throw new T("PAGE_ESTIMATION_ERROR", "No reflowable documents in publication");
                return g.return(e.Ga.createRenderableDocument(b).then(function(h) {
                    return h.sections[0].createPageIterator();
                }).then(function(h) {
                    var l = h.getEstimatedNumberOfPages();
                    h.destroy();
                    return e.La / l;
                }));
            });
        }
        function Fe(a, b) {
            var c = b.getSourceContentDocument().getContentUrl(), d = {
                accept: [
                    y.MediaType.APPLICATION_XHTML,
                    y.MediaType.TEXT_HTML,
                    y.MediaType.APPLICATION_HTML
                ]
            };
            return a.fetchMetadata(c, d).then(function(e) {
                e = e.size;
                return Ka(e) ? a.fetch(c, d).then(function(f) {
                    return f.asUint8Array();
                }).then(function(f) {
                    return f.length;
                }) : e;
            }).catch(function() {
                return 0;
            });
        }
        function Ge(a, b) {
            var c = Number.MAX_SAFE_INTEGER, d = null, e = 1;
            a.g.forEach(function(f, g) {
                var h = Math.abs(4E4 - f) * (4E4 > f ? 2 : 1);
                h < c && f >= b && (d = g, c = h, e = f);
            });
            return {
                Ga: d,
                La: e
            };
        }
        function He() {
            this.g = [];
            this.h = !1;
        }
        He.prototype.add = function(a) {
            this.g.includes(a) || (this.g = this.g.concat(a));
        };
        He.prototype.clear = function() {
            this.g = [];
        };
        function Ie(a, b, c) {
            a.h = !0;
            for(var d = a.g, e = 0; e < d.length; e++){
                var f = d[e];
                if (a.g.includes(f)) try {
                    f(b);
                } catch (g) {
                    c(g);
                }
            }
        }
        He.prototype.remove = function(a) {
            this.g = this.g.filter(function(b) {
                return b !== a;
            });
        };
        He.prototype.size = function() {
            return this.g.length;
        };
        var Je = E.event.PublicationStorageChangedEngineEvent;
        function Ke(a, b, c) {
            this.J = a;
            this.j = b;
            this.m = c;
            this.h = new He;
            this.g = new Map;
        }
        k = Ke.prototype;
        k.clear = function() {
            Le(this);
            Me(this, null, null, null, null);
        };
        k.getItem = function(a) {
            var b;
            return null != (b = this.g.get(a)) ? b : null;
        };
        k.getItems = function() {
            return Array.from(this.g);
        };
        k.getStorageSizeLimit = function() {
            return this.j;
        };
        k.getType = function() {
            return this.J;
        };
        k.publicationClear = function(a) {
            Le(this);
            Me(this, null, null, null, a);
        };
        k.publicationRemoveItem = function(a, b) {
            var c, d = null != (c = this.g.get(a)) ? c : null;
            Ne(this, a, d);
            Me(this, a, null, d, b);
        };
        k.publicationSetItem = function(a, b, c) {
            var d = Oe(this, a, b);
            Me(this, a, b, d, c);
        };
        k.removeItem = function(a) {
            var b, c = null != (b = this.g.get(a)) ? b : null;
            Ne(this, a, c);
            Me(this, a, null, c, null);
        };
        k.setItem = function(a, b) {
            var c = Oe(this, a, b);
            Me(this, a, b, c, null);
        };
        k.setItems = function(a, b) {
            var c = this;
            a.forEach(function(d) {
                var e = q.na(d);
                d = e.next().value;
                e = e.next().value;
                var f = Oe(c, d, e);
                b && Me(c, d, e, f, null);
            });
        };
        k.setStorageSizeLimit = function(a) {
            this.j = a;
        };
        function Le(a) {
            a.g.clear();
            Ie(a.h, {
                sc: null,
                Sf: null,
                ca: null
            }, function(b) {
                t.ColibrioError.isColibrioAbortedError(b) || t.Logger.logError(b);
            });
        }
        function Me(a, b, c, d, e) {
            b = new Je({
                key: b,
                newValue: c,
                oldValue: d,
                readerDocumentIndexInSpine: e,
                readerPublication: a.m,
                readerView: null,
                storageAreaType: a.J
            });
            a.m.getReadingSystemEngine().getEventBus().emitAsync(b);
        }
        function Ne(a, b, c) {
            a.g.delete(b);
            Ie(a.h, {
                sc: b,
                Sf: c,
                ca: null
            }, function(d) {
                t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logError(d);
            });
        }
        function Oe(a, b, c) {
            var d, e = null != (d = a.g.get(b)) ? d : null;
            a.g.set(b, c);
            Ie(a.h, {
                sc: b,
                Sf: e,
                ca: c
            }, function(f) {
                t.ColibrioError.isColibrioAbortedError(f) || t.Logger.logError(f);
            });
            return e;
        }
        function Pe(a) {
            this.g = 5E6;
            this.h = new Ke(D.ReaderPublicationStorageAreaType.LOCAL_STORAGE, this.g, a);
            this.j = new Ke(D.ReaderPublicationStorageAreaType.SESSION_STORAGE, this.g, a);
        }
        k = Pe.prototype;
        k.getStorageArea = function(a) {
            return a === D.ReaderPublicationStorageAreaType.LOCAL_STORAGE ? this.h : this.j;
        };
        k.getStorageSizeLimit = function() {
            return this.g;
        };
        k.getStorageState = function() {
            return {
                localStorage: JSON.stringify(Object.fromEntries(this.h.g))
            };
        };
        k.setStorageSizeLimit = function(a) {
            this.g = a;
            this.h.setStorageSizeLimit(a);
            this.j.setStorageSizeLimit(a);
        };
        k.setStorageState = function(a) {
            if (!Ha(a.localStorage)) throw new T("UNSUPPORTED_RESOURCE_DATA_FORMAT", "Invalid IPublicationStorageState");
            try {
                var b = JSON.parse(a.localStorage), c = Object.keys(b).map(function(d) {
                    return [
                        d,
                        b[d]
                    ];
                });
                this.h.setItems(c, !1);
            } catch (d) {
                throw new T("UNSUPPORTED_RESOURCE_DATA_FORMAT", d.message || "");
            }
        };
        function Qe() {
            this.name = "DefaultFragmenterPlugin";
        }
        k = Qe.prototype;
        k.breakElement = function(a, b) {
            for(var c = a.cloneNode(!1), d = 0; d < b; d++)c.appendChild(a.firstChild);
            return c;
        };
        k.breakText = function(a, b) {
            a.splitText(b);
            return a;
        };
        k.install = function(a) {
            a.elementFragmenters.push(this);
            a.textFragmenters.push(this);
        };
        k.isFragmenterForElement = function() {
            return !0;
        };
        k.isFragmenterForText = function() {
            return !0;
        };
        function Re(a, b) {
            return t.ColibrioError.call(this, "colibrio.readingsystem.reflow", a, b) || this;
        }
        q.inherits(Re, t.ColibrioError);
        function Se(a, b, c, d, e, f, g) {
            function h(u) {
                m.push(u);
            }
            var l = [], m = [];
            if (3 === a.nodeType) {
                var n = 3;
                d = d(a, b);
                d = d.breakText(a, b);
            } else if (1 === a.nodeType) n = 1, d = e(a, b), d = d.breakElement(a, b, h), g && a.setAttribute(g, ""), f && d.setAttribute(f, "");
            else throw new Re("ILLEGAL_BREAK_POINT_CONTAINER", String(a));
            for(; a !== c;){
                var p = O(a);
                l.unshift(p);
                a = a.parentNode;
                p = e(a, p).breakElement(a, p, h);
                p.appendChild(d);
                d = p;
                g && a.setAttribute(g, "");
                f && d.setAttribute(f, "");
            }
            c = c.ownerDocument.createDocumentFragment();
            c.appendChild(d);
            return {
                v: l,
                sb: n,
                ye: m,
                Sd: c,
                zc: b
            };
        }
        function Te(a, b) {
            var c = {
                v: a.v.slice(),
                i: a.i
            };
            b = q.na(b);
            for(var d = b.next(); !d.done; d = b.next()){
                var e = d.value;
                switch(e.J){
                    case 1:
                        d = e;
                        e = c;
                        var f = d.v, g = e.v, h = f.length, l = g.length;
                        fc(f, g) && (h < l ? d.i <= g[h] && g[h]++ : d.i <= e.i && e.i++);
                        break;
                    case 2:
                        d = e;
                        e = c;
                        h = d.v;
                        f = e.v;
                        g = h.length;
                        l = f.length;
                        fc(h, f) && (g < l ? (h = f[g], d.i < h ? f[g]-- : d.i === h && (f.length = g, e.i = h)) : d.i < e.i && e.i--);
                        break;
                    case 4:
                        d = e;
                        e = c;
                        f = d.v;
                        g = e.v;
                        h = f.length;
                        l = g.length;
                        for(var m = -1, n = 0; n < h && n < l && -1 === m; n++)g[n] !== f[n] ? m = n : g[n] = 0;
                        0 <= m ? g[m] -= f[m] : h > l ? e.i -= f[l] : h === l ? e.i -= d.i : g[h] -= d.i;
                        break;
                    case 5:
                        d = e;
                        e = c;
                        f = d.v;
                        g = e.v;
                        h = f.length;
                        l = g.length;
                        m = f.slice(0, h - 1);
                        n = f[h - 1];
                        !fc(f, g) && fc(m, g) && (l === m.length ? e.i === n + 1 ? (g.push(n), e.i = d.i) : e.i > n && e.i-- : l === h ? g[l - 1] === f[h - 1] + 1 && (g[h - 1]--, e.i += d.i) : g[h - 1] > f[h - 1] && g[h - 1]--);
                        break;
                    case 6:
                        d = e;
                        e = c;
                        f = a;
                        l = d.v;
                        g = e.v;
                        h = l.length;
                        m = g.length;
                        if (fc(l, g)) {
                            if (l = d.Me, h < m) {
                                if (d.i < g[h]) g[h] += l.length - 1;
                                else {
                                    if (h === m - 1 && d.i === g[h]) for(n = m = 0; n < l.length; n++){
                                        var p = m + l[n];
                                        if (p >= f.i) {
                                            g[h] = n + d.i;
                                            g.push(0);
                                            e.i = f.i - m;
                                            break;
                                        }
                                        m = p;
                                    }
                                }
                            } else h === m && (d.i === e.i ? (g.push(0), e.i = 0) : d.i < e.i && (e.i += l.length - 1));
                        }
                        break;
                    case 7:
                        d = c;
                        e = e.v;
                        f = d.v;
                        g = e.length;
                        h = f.length;
                        fc(e, f) && g === h && (d.i = 0);
                        break;
                    case 8:
                        d = e;
                        e = c;
                        f = d.v;
                        g = e.v;
                        h = f.length;
                        l = g.length;
                        fc(f, g) && (h < l ? g[h] === d.i && g.splice(h + 1, 0, 0) : h === l && d.i === e.i && (g.push(d.i), e.i = 0));
                        break;
                    case 9:
                        d = e.v;
                        e = c.v;
                        fc(d, e) && e.splice(d.length, 0, 0);
                        break;
                    case 10:
                        d = e;
                        e = c;
                        f = d.v;
                        g = e.v;
                        h = f.length;
                        l = g.length;
                        m = f.slice(0, h - 1);
                        n = m.length;
                        p = 0 === d.i;
                        var u = d.Db === d.Oe, v = p && u;
                        fc(m, g) && (h < l ? !v && f[n] < g[n] && (g[h - 1] += p || u ? 1 : 2) : n === l ? !v && f[h - 1] < e.i ? e.i += p || u ? 1 : 2 : f[h - 1] === e.i && p && g.push(0) : h === l && f[h - 1] < g[h - 1] ? v || (g[h - 1] += p || u ? 1 : 2) : f[h - 1] === g[l - 1] && d.i <= e.i && (d.Db > e.i || d.Db === e.i && u ? (g[l - 1] += p ? 0 : 1, g.push(0), e.i -= d.i) : d.Db <= e.i && (g[l - 1] += p ? 1 : 2, e.i -= d.Db)));
                }
            }
            return c;
        }
        var Ue = /^\s*$/;
        function Ve(a) {
            if (H(a)) {
                var b = [];
                b.length = a.attributes.length;
                for(var c = 0; c < a.attributes.length; c++){
                    var d = a.attributes[c];
                    b[c] = {
                        name: d.name,
                        value: d.value
                    };
                }
            } else b = null;
            return b;
        }
        function We(a, b, c) {
            for(; a && a !== b && c(a);)a = a.parentNode;
            return a === b ? null : a;
        }
        function Xe(a, b) {
            return We(a, b, Ye);
        }
        function Ze(a, b) {
            return We(a, b, $e);
        }
        function af(a, b) {
            return We(a, b, bf);
        }
        function cf(a, b) {
            return We(a, b, df);
        }
        function ef(a) {
            return J(a) && Ue.test(a.data);
        }
        function ff(a, b, c) {
            b = new R(b, gf);
            b.g = a;
            return hf(b, c);
        }
        function jf(a, b, c) {
            b = new qc(b, gf);
            b.g = a;
            return hf(b, c);
        }
        function hf(a, b) {
            b && S(a, !1);
            do {
                b = a.g;
                var c = S(a, !0);
            }while (0 < c);
            return b;
        }
        function $e(a) {
            for(a = a.previousSibling; a && !gf(a);)a = a.previousSibling;
            return !a;
        }
        function kf(a) {
            return a && H(a) && !!a.getBoundingClientRect;
        }
        function gf(a) {
            return kf(a) && !/^(br|colgroup|col)$/i.test(a.tagName) ? (a = a.getBoundingClientRect(), 0 < a.width && 0 < a.height) : lf(a);
        }
        function Ye(a) {
            for(a = a.nextSibling; a && !gf(a);)a = a.nextSibling;
            return !a;
        }
        function lf(a) {
            return J(a) && Ga(a.data);
        }
        function mf(a) {
            return /^(?:video|img|picture)$/i.test(a.tagName);
        }
        function bf(a) {
            for(a = a.previousSibling; a && !H(a) && !lf(a);)a = a.previousSibling;
            return !a;
        }
        function df(a) {
            for(a = a.nextSibling; a && !H(a) && !lf(a);)a = a.nextSibling;
            return !a;
        }
        function nf(a, b, c, d, e, f, g, h, l) {
            var m, n, p, u, v, w, x, A, z, C, F, G, L, P, Y, ba, ka, V;
            return q.K(function(ea) {
                switch(ea.g){
                    case 1:
                        m = [], n = new hc(b.slice()), p = h.collapseToStart(), u = function() {
                            return new Qe;
                        }, v = q.na(l), w = v.next();
                    case 2:
                        if (w.done) {
                            ea.$(4);
                            break;
                        }
                        x = w.value;
                        A = of(x, c.body);
                        if (!A) {
                            ea.$(3);
                            break;
                        }
                        z = A.parentNode;
                        C = O(A);
                        F = "AFTER" === x.ve ? C + 1 : C;
                        G = Se(z, F, c.body, u, u, "data-colibrio-fragmented-at-end", "data-colibrio-fragmented-at-start");
                        L = ic(n, 1, G.v, G.zc);
                        P = n.g;
                        n = L;
                        Y = pf(c, G);
                        return r(ea, qf(G, P, a), 6);
                    case 6:
                        ba = ea.h, ka = p.createRangeTo(ba), V = {
                            T: P,
                            yb: d,
                            Ja: Y,
                            Oc: ka,
                            Wa: e,
                            bb: f,
                            Bb: g
                        }, m.push(V), p = ba;
                    case 3:
                        w = v.next();
                        ea.$(2);
                        break;
                    case 4:
                        return m.push({
                            T: n.g,
                            yb: d,
                            Ja: c,
                            Oc: p.createRangeTo(h.collapseToEnd()),
                            Wa: e,
                            bb: f,
                            Bb: g
                        }), ea.return(m);
                }
            });
        }
        function pf(a, b) {
            var c = a.documentElement.cloneNode(!1);
            c.appendChild(a.documentElement.querySelector("head").cloneNode(!0));
            c.appendChild(b.Sd);
            return nc(a, c);
        }
        function qf(a, b, c) {
            a = ad({
                v: a.v,
                i: a.zc
            }, b);
            a = cd(a, null, c.da, c.F.getSourceContentDocument(), c.N);
            return c.F.getReaderPublication().fetchContentLocation(a);
        }
        function of(a, b) {
            return "AFTER" === a.ve ? cf(a.u, b) : "BEFORE" === a.ve ? af(a.u, b) : null;
        }
        function rf(a, b) {
            if (2 * a.cg < b.minimumCharactersPerSection) return [];
            var c = a.kh.flat();
            a = a.cg - b.minimumCharactersPerSection;
            var d = [];
            c = q.na(c);
            for(var e = c.next(), f = {}; !e.done; f = {
                ud: void 0
            }, e = c.next())f.ud = e.value, e = f.ud.Ec <= a, f.ud.Ec >= b.minimumCharactersPerSection && e && d.every(function(g) {
                return function(h) {
                    return Math.abs(g.ud.Ec - h.Ec) >= b.minimumCharactersPerSection;
                };
            }(f)) && d.push(f.ud);
            return d.sort(function(g, h) {
                var l = g.Ec - h.Ec;
                0 === l ? (g = g.u, h = h.u, g === h ? h = 0 : (g = Ya(g.ownerDocument, g), h = Ya(h.ownerDocument, h), h = Wa(g, h))) : h = l;
                return h;
            });
        }
        function sf() {
            this.Sb = !1;
        }
        function tf(a) {
            this.j = 0;
            this.A = new sf;
            this.Va = this.h = null;
            this.m = new Map;
            this.g = [];
            this.g = a.selectors.filter(function(b) {
                return uf(b.selector);
            });
            this.o = uf(a.disableSectioningInsideSelector) ? a.disableSectioningInsideSelector : void 0;
            for(a = 0; a < this.g.length; a++)this.m.set(this.g[a], []);
        }
        function uf(a) {
            try {
                return document.body.matches(a), !0;
            } catch (b) {
                return t.Logger.logError('Invalid documentSectioningOptions: Selector "' + a + '" is not valid and will not be used to section the document.'), !1;
            }
        }
        k = tf.prototype;
        k.Jb = function(a) {
            return !lb(a.localName);
        };
        k.sa = function(a) {
            if (this.h) return !1;
            for(var b = 0; b < this.g.length; b++){
                var c = this.g[b];
                a.matches(c.selector) && "BEFORE" === c.breakPosition && vf(this, a, c);
            }
            this.o && a.matches(this.o) && (this.h = a);
            return !1;
        };
        k.ia = function(a) {
            a === this.h && (this.h = null);
            if (this.h) return !1;
            for(var b = 0; b < this.g.length; b++){
                var c = this.g[b];
                a.matches(c.selector) && "AFTER" === c.breakPosition && vf(this, a, c);
            }
            return !1;
        };
        k.init = function() {};
        k.Zb = function() {
            return !1;
        };
        k.Kb = function() {
            return !1;
        };
        k.$b = function(a) {
            for(var b = this.j, c = this.A, d = 0, e = 0; e < a.data.length; e++){
                var f = c, g = a.data.charCodeAt(e), h = 0;
                Ea(g) ? (f.Sb || (h = 1), f.Sb = !0) : (56320 <= g && 57343 >= g || (h = 1), f.Sb = !1);
                d += h;
            }
            this.j = b + d;
            return !1;
        };
        function vf(a, b, c) {
            b = {
                ve: c.breakPosition,
                Ec: a.j,
                u: b
            };
            a = a.m.get(c);
            if (!a) throw new U("storeCandidateBreakPoint: Sectioning algorithm map missing selector: " + c.selector);
            a.push(b);
        }
        function wf(a, b, c, d, e, f, g) {
            var h, l, m, n, p, u, v, w;
            return q.K(function(x) {
                if (1 == x.g) return h = xf(a, f, g), l = h.Mh, m = h.Fh, r(x, oc(a, l, m), 2);
                n = x.h;
                p = n.Ag;
                u = n.styleDefs;
                if (a.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                if (e.enabled && d) {
                    var A = new tf(e.algorithm);
                    Ib(new Hb(A), l.body);
                    if (!A.Va) {
                        for(var z = [], C = 0; C < A.g.length; C++){
                            var F = A.g[C], G = A.m.get(F);
                            if (!G) throw new U("buildScanningResult: Sectioning algorithm map missing selector: " + F.selector);
                            z.push(G);
                        }
                        A.Va = {
                            kh: z,
                            cg: A.j
                        };
                    }
                    v = A.Va;
                    w = rf(v, e.algorithm);
                    return x.return(nf(a, m.g, l, c, p, u, b, f, w));
                }
                return x.return([
                    {
                        T: m.g,
                        yb: c,
                        Ja: l,
                        Oc: f,
                        Wa: p,
                        bb: u,
                        Bb: b
                    }
                ]);
            });
        }
        function xf(a, b, c) {
            var d = a.da.cloneNode(!0), e = new hc;
            if (c && b instanceof X) {
                b = $c(b, a.F, a.da);
                c = dc(b.P, d.body);
                a = function() {
                    return new Qe;
                };
                var f = Se(c.s, c.i, d.body, a, a, "data-colibrio-fragmented-at-end", "data-colibrio-fragmented-at-start");
                e = ic(e, 3 === c.s.nodeType ? 3 : 1, f.v, f.zc);
                b.O && (b = Te(b.O, e.g), b = dc(b, d.body), a = Se(b.s, b.i, d.body, a, a, "data-colibrio-fragmented-at-end", "data-colibrio-fragmented-at-start"), ic(e, 3 === b.s.nodeType ? 3 : 1, a.v, a.zc), d = pf(d, a));
            }
            return {
                Fh: e,
                Mh: d
            };
        }
        function yf() {}
        yf.prototype.ia = function(a, b) {
            "audio" !== b && "video" !== b || !a.hasAttribute("autoplay") || (a.setAttribute("data-colibrio-autoplay", "true"), a.removeAttribute("autoplay"));
        };
        function zf(a) {
            this.l = a;
            this.Hc = !1;
        }
        zf.prototype.ia = function(a, b) {
            "iframe" === b && (b = a.getAttribute("src"), a.removeAttribute("srcdoc"), a.removeAttribute("src"), b && (a.setAttribute("data-colibrio-iframe-src", b), a.setAttribute("allow", "autoplay *; fullscreen *"), Af(this, b) && (a.setAttribute("colibrio-iframe-sandbox-required", "true"), this.Hc = !0)));
        };
        function Af(a, b) {
            var c = a.l.M.remoteResourcesNonScriptedDocumentsOptions, d;
            if (!("ALLOW_ALL" === c.policyType || "WHITELIST" === c.policyType && (null == (d = c.whitelistDirectives) ? 0 : d.some(function(g) {
                return "frame-src" === g.directive;
            })))) return !0;
            if (B.URLUtils.isValidUrl(b)) try {
                var e = new URL(b), f = "http:" === e.protocol || "https:" === e.protocol;
                if (e.origin === window.location.origin || !f) return !0;
            } catch (g) {
                return !0;
            }
            else if (c = a.l.W.getResourceProvider(), a = c.acceptsUrl(b), b = c.isUrlSupportedByBrowser(b), a && !b) return !0;
            return !1;
        }
        function Bf() {
            this.sh = /^\s*javascript:/i;
            this.Zf = !1;
        }
        Bf.prototype.ia = function(a) {
            for(var b = a.attributes, c = [], d = 0, e = b.length; d < e; d++){
                var f = b[d];
                if (/^on/i.test(f.localName || f.name) || this.sh.test(f.value)) c.push(f), this.Zf = !0;
            }
            for(d = 0; d < c.length; d++)e = c[d], f = e.localName || e.name, e.prefix && e.namespaceURI ? (a.setAttributeNS(e.namespaceURI, "data-colibrio-inline-script-" + f, e.value), b.g(e.namespaceURI, f)) : (a.setAttribute("data-colibrio-inline-script-" + f, e.value), b.removeNamedItem(f));
        };
        function Cf() {
            this.De = !1;
        }
        Cf.prototype.ia = function(a, b) {
            "math" === b && (this.De = !0);
        };
        Cf.prototype.nc = function() {
            if (this.De && null === Df) {
                var a = document, b = a.createElementNS(t.XmlNamespace.HTML, "div");
                b.setAttribute("style", "border: 0; clip: rect(0 0 0 0); height: 1px; margin: -1px; overflow: hidden; padding: 0; position: absolute; width: 1px; left: -10000px; top: 0px");
                var c = a.createElementNS(t.XmlNamespace.MATHML, "math"), d = a.createElementNS(t.XmlNamespace.MATHML, "mspace");
                d.setAttribute("width", "77px");
                d.setAttribute("height", "23px");
                c.appendChild(d);
                b.appendChild(c);
                a.body.appendChild(b);
                c = d.getBoundingClientRect();
                a.body.removeChild(b);
                Df = 1 < Math.abs(c.height - 23) && 1 < Math.abs(c.width - 77);
            }
            return Promise.resolve();
        };
        var Df = null;
        function Ef() {}
        Ef.prototype.ia = function(a, b) {
            if ("video" === b || "audio" === b) b = (a.getAttribute("controlslist") || "").split(/\s+/), b.includes("nodownload") || b.push("nodownload"), a.setAttribute("controlslist", b.join(" "));
        };
        function Ff(a) {
            this.Df = a;
            this.Mc = [];
        }
        Ff.prototype.sa = function(a, b, c) {
            "video" === b ? Gf(this, a, b, c, y.MediaTypeCategory.VIDEO) : "audio" === b ? Gf(this, a, b, c, y.MediaTypeCategory.AUDIO) : "picture" === b ? Gf(this, a, b, c, y.MediaTypeCategory.IMAGE) : "img" === b ? (b = Hf(this, a), a.removeAttribute("src"), b && (a = {
                category: y.MediaTypeCategory.IMAGE,
                element: a,
                imgSource: b,
                sources: [],
                tagName: "img"
            }, If(a), this.Mc.push(a))) : "image" === b && (b = a.getAttributeNS(t.XmlNamespace.XLINK, "href"), c = null, b && "#" !== b[0] && (c = Jf(this, b, null)) && a.removeAttributeNS(t.XmlNamespace.XLINK, "href"), a = {
                category: y.MediaTypeCategory.IMAGE,
                element: a,
                imgSource: c,
                sources: [],
                tagName: "image"
            }, If(a), this.Mc.push(a));
        };
        function If(a) {
            var b = a.element;
            0 < a.sources.length && b.setAttribute("data-colibrio-media-sources", JSON.stringify(a.sources));
            a.imgSource && b.setAttribute("data-colibrio-image-src", JSON.stringify(a.imgSource));
        }
        function Jf(a, b, c) {
            var d = null;
            try {
                var e = !0, f = !0, g = zb(b);
                if (g) {
                    var h = yb(b);
                    h && (h.startsWith("audio/") || h.startsWith("video/") || h.startsWith("image/")) ? (c = h, e = !1) : f = !1;
                } else {
                    var l = new URL(b, a.Df);
                    e = "http:" === l.protocol || "https:" === l.protocol;
                }
                f && (d = {
                    isDataUrl: g,
                    remote: e,
                    src: b,
                    type: c
                });
            } catch (m) {
                t.Logger.logWarning(new T("UNSUPPORTED_RESOURCE_DATA_FORMAT", "Invalid src attribute on media element in: " + a.Df.pathname));
            }
            return d;
        }
        function Hf(a, b) {
            var c = null, d = b.getAttribute("src");
            d && (c = Jf(a, d, b.getAttribute("type")));
            return c;
        }
        function Gf(a, b, c, d, e) {
            var f = [], g = Hf(a, b);
            g && f.push(g);
            b.removeAttribute("src");
            for(var h = b.firstChild; h;){
                var l = h.nextSibling;
                H(h) && "source" === h.localName && ((g = Hf(a, h)) && f.push(g), d.remove(h));
                h = l;
            }
            d = null;
            if (g = b.getAttribute("poster")) d = Jf(a, g, null), b.removeAttribute("poster");
            b = {
                category: e,
                element: b,
                imgSource: d,
                sources: f,
                tagName: c
            };
            If(b);
            a.Mc.push(b);
        }
        function Kf(a) {
            this.C = a;
        }
        Kf.prototype.ia = function(a, b, c, d) {
            if (!lb(b)) for(b = 0; b < a.childNodes.length; b++){
                var e = a.childNodes[b];
                J(e) && e.data.length > this.C.maxTextNodeLength && mc(c, d, e, a, {
                    gh: this.C.maxTextNodeLength,
                    lh: [
                        ".",
                        "&",
                        "!"
                    ]
                });
            }
        };
        function Lf(a, b, c) {
            var d, e, f, g, h, l, m, n, p, u, v, w;
            return q.K(function(x) {
                if (1 == x.g) return d = a.Ja, e = a.T.slice(), f = b.F.getSourceContentDocument().getContentUrl(), g = new Ff(f), h = new Bf, l = new zf(b), m = new Cf, n = new Ob, n.Qa = [
                    new yf,
                    new Ef,
                    g,
                    h,
                    l,
                    m
                ].slice(), (null == (p = b.M.textSplitOptions) ? 0 : p.enableTextSplit) && c && Pb(n, [
                    new Kf(b.M.textSplitOptions)
                ]), r(x, n.transform(d, new lc(new hc(e))), 2);
                u = x.h;
                v = h.Zf || 0 < a.Wa.length;
                w = {
                    T: u.Ra.g,
                    Hc: l.Hc,
                    Zg: v,
                    xb: m.De && !!Df,
                    Mc: g.Mc,
                    yb: a.yb,
                    Ja: d,
                    Wa: a.Wa,
                    bb: a.bb,
                    Bb: a.Bb
                };
                return x.return(w);
            });
        }
        function Mf(a) {
            this.Na = a;
        }
        Mf.prototype.gf = function(a) {
            switch(a.type){
                case 9:
                    return Nf(this, a);
            }
            return Promise.reject("ResourceProvider message not implemented: " + a.type);
        };
        function Nf(a, b) {
            var c = B.URLUtils.normalizePathnameEncoding(new URL(b.href, b.baseUrl));
            return a.Na.fetchBrowserNativeUrl(c, b.accept, !1).then(function(d) {
                return {
                    channelId: b.channelId,
                    data: d.data,
                    type: 10
                };
            });
        }
        function Of(a, b, c, d) {
            this.U = a;
            this.fd = b;
            this.Gc = [];
            this.L = !1;
            this.H = 0;
            this.m = this.j = null;
            this.A = 0;
            this.o = [];
            this.h = [];
            this.g = Pf(a);
            a = this.g.jb;
            this.g.qc.g.set(a, new Mf(d));
            c = {
                blobUrlSupported: t.RuntimePlatform.isBlobUrlSupported(),
                channelId: a,
                resourceProviderChannelId: c,
                type: 7
            };
            Qf(this.g.D, c);
            Qf(this.g.D, {
                channelId: a,
                documentUrl: b.href,
                type: 2
            });
        }
        function Rf(a, b, c, d) {
            a.Gc.push({
                Ld: d,
                Sg: c,
                u: b
            });
        }
        function Sf(a, b, c) {
            var d = new URL("?style=" + a.H++, a.fd), e = a.A++;
            c = {
                Ld: c,
                ld: e
            };
            Tf(a, e, b, d.href);
            a.o.push(c);
        }
        function Uf(a, b, c) {
            var d = a.A++;
            c = {
                Ld: c,
                ld: d
            };
            Tf(a, d, null, b.href);
            a.o.push(c);
        }
        function Vf(a, b) {
            a.h.push({
                Qa: b
            });
        }
        Of.prototype.destroy = function() {
            if (!this.L) {
                this.L = !0;
                this.m = this.j = null;
                this.o = [];
                for(var a = 0; a < this.h.length; a++)for(var b = this.h[a].Qa, c = 0; c < b.length; c++){
                    var d = b[c];
                    d.destroy && d.destroy();
                }
                Qf(this.g.D, {
                    channelId: this.g.jb,
                    type: 3
                });
                Qf(this.g.D, {
                    channelId: this.g.jb,
                    type: 8
                });
                this.g.qc.g.delete(this.g.jb);
            }
        };
        function Wf(a, b) {
            var c, d, e, f, g, h, l, m, n, p, u, v, w, x, A, z, C, F;
            return q.K(function(G) {
                if (1 == G.g) {
                    0 < a.Gc.length && (c = {
                        channelId: a.g.jb,
                        items: a.Gc.map(function(L) {
                            return L.Sg;
                        }),
                        type: 6
                    }, Qf(a.g.D, c));
                    d = [];
                    e = [];
                    for(f = 0; f < a.h.length; f++){
                        g = a.h[f].Qa;
                        h = [];
                        for(l = 0; l < g.length; l++)m = g[l], e.push(m), h.push(m.ea(a.U));
                        d.push({
                            pluginEntries: h
                        });
                    }
                    n = {
                        channelId: a.g.jb,
                        compiledStylesheetsAsUrls: b,
                        passes: d,
                        type: 4
                    };
                    return r(G, Xf(a.g.D, n), 2);
                }
                p = G.h;
                if (a.L) throw new T(t.ColibrioErrorType.ABORTED);
                u = p.pluginResults;
                for(v = 0; v < u.length; v++)w = e[v], w.Dc && w.Dc(u[v], p.declarationLists, a);
                a.m && a.m(p.extraCssBefore, b);
                x = q.na(a.o);
                for(A = x.next(); !A.done; A = x.next())z = A.value, z.Ld(p.stylesheets[z.ld], b);
                a.j && a.j(p.extraCssAfter, b);
                for(C = 0; C < a.Gc.length; C++)F = a.Gc[C], F.Ld(p.declarationLists[C], C);
                G.g = 0;
            });
        }
        function Yf(a, b) {
            a.j = b;
        }
        function Zf(a, b) {
            a.m = b;
        }
        function Tf(a, b, c, d) {
            Qf(a.g.D, {
                channelId: a.g.jb,
                css: c,
                index: b,
                type: 1,
                url: d
            });
        }
        function $f(a, b, c) {
            this.Zc = a;
            this.Yg = b;
            this.Lg = c;
        }
        $f.prototype.ea = function() {
            return {
                name: "activeElementCssOverride",
                options: {
                    activeElementClass: this.Zc,
                    activeElementStylesOverride: this.Lg,
                    fallbackActiveElementClass: this.Yg
                }
            };
        };
        function ag() {}
        ag.prototype.ea = function() {
            return {
                name: "animationDisabler",
                options: null
            };
        };
        function bg() {
            this.gb = this.Tf = "";
        }
        bg.prototype.ea = function() {
            return {
                name: "animationExtractor",
                options: null
            };
        };
        bg.prototype.Dc = function(a, b, c) {
            this.Tf = a.pauseAnimationStylesheet;
            this.gb = a.transitionStylesheet;
            c = c.Gc;
            for(var d = q.na(a.transitionDeclarations), e = d.next(); !e.done; e = d.next())e = e.value, c[e.index].u.setAttribute("data-colibrio-css-transition", e.declarationCss);
            a = q.na(a.pauseAnimationDeclarationsIndexes);
            for(d = a.next(); !d.done; d = a.next())d = d.value, e = b[d], c[d].u.setAttribute("data-colibrio-css-animation-original", e), b[d] = e + ";animation-play-state: paused !important";
        };
        function cg(a, b) {
            this.ka = a;
            this.ga = b;
            this.Xb = null;
        }
        cg.prototype.destroy = function() {
            this.Xb && this.Xb.qc.g.delete(this.Xb.jb);
        };
        cg.prototype.ea = function(a) {
            this.Xb = Pf(a);
            this.Xb.qc.g.set(this.Xb.jb, this);
            return {
                name: "backgroundImageFilter",
                options: {
                    jobId: this.Xb.jb
                }
            };
        };
        cg.prototype.gf = function(a) {
            var b = this;
            if (!this.Xb) return Promise.reject(new U("_workerJob was null"));
            a = a.selectors.map(function(c) {
                try {
                    return null !== b.ga.querySelector(c);
                } catch (d) {
                    t.Logger.logWarning("Invalid CSS selector found for document: " + b.ka.getContentUrl().toString());
                }
                return !1;
            });
            return Promise.resolve({
                channelId: this.Xb.jb,
                selectorsEnabled: a,
                type: 18
            });
        };
        function dg(a, b) {
            this.Xg = a;
            this.Wg = b;
        }
        dg.prototype.ea = function() {
            return {
                name: "customCss",
                options: {
                    cssAfter: this.Wg,
                    cssBefore: this.Xg
                }
            };
        };
        function eg(a) {
            this.pd = a;
        }
        eg.prototype.ea = function() {
            return {
                name: "customPalette",
                options: {
                    accent: this.pd.accent,
                    backgroundDark: this.pd.backgroundDark,
                    backgroundLight: this.pd.backgroundLight,
                    foregroundDark: this.pd.foregroundDark,
                    foregroundLight: this.pd.foregroundLight
                }
            };
        };
        function fg(a, b) {
            this.ah = a;
            this.$g = b;
        }
        fg.prototype.ea = function() {
            return {
                name: "customUnprocessedCss",
                options: {
                    injectionPointEndUnprocessed: this.$g,
                    injectionPointStartUnprocessed: this.ah
                }
            };
        };
        function gg(a) {
            this.M = a;
        }
        gg.prototype.ea = function() {
            var a = t.BrowserDetector.isOS("iOS");
            return {
                name: "defaultCss",
                options: {
                    enableNormalizeCss: this.M.customPublicationCss.enableNormalizeCss,
                    preventContextMenu: this.M.preventDefaultContextMenu,
                    preventContextMenuOnMediaElements: this.M.preventDefaultContextMenuOnMediaElements,
                    webkitUserSelectRemoverEnabled: a
                }
            };
        };
        function hg(a) {
            this.M = a;
        }
        hg.prototype.ea = function() {
            return {
                name: "defaultReflowableCss",
                options: {
                    removeBottomMarginsOnFragmentedElements: this.M.reflowOptions.removeBottomMarginsOnFragmentedElements,
                    removeTopMarginsOnFragmentedElements: this.M.reflowOptions.removeTopMarginsOnFragmentedElements
                }
            };
        };
        function ig() {}
        ig.prototype.ea = function() {
            return {
                name: "firstPseudoSelectorRewriter",
                options: null
            };
        };
        function jg(a, b, c) {
            this.Ce = a;
            this.Ug = b;
            this.Pb = [];
            if (c) {
                var d = URL.parse(document.baseURI);
                a = c.fontFaces.map(function(e) {
                    e = Object.assign({}, e);
                    if (e.srcUrl && d) {
                        var f = URL.parse(e.srcUrl, d);
                        f && (e.srcUrl = f.href);
                    }
                    return e;
                });
                this.Gf = {
                    defaults: c.defaults,
                    fontFaces: a,
                    selectors: c.selectors || []
                };
            } else this.Gf = null;
        }
        jg.prototype.ea = function() {
            return {
                name: "fontLoader",
                options: {
                    defaultFontFamily: this.Ug,
                    fontSet: this.Gf,
                    inline: this.Ce
                }
            };
        };
        jg.prototype.Dc = function(a) {
            this.Pb = a.fontFamilyNames;
        };
        function kg(a, b) {
            this.oh = a;
            this.ph = b;
        }
        kg.prototype.ea = function() {
            return {
                name: "fontReset",
                options: {
                    removeFontSize: this.oh,
                    removeLineHeight: this.ph
                }
            };
        };
        function lg(a) {
            this.He = a;
        }
        lg.prototype.ea = function() {
            return {
                name: "fontScale",
                options: {
                    scaleFactor: this.He
                }
            };
        };
        function mg() {}
        mg.prototype.ea = function() {
            return {
                name: "forceOpaqueDocumentBackground",
                options: null
            };
        };
        function ng() {}
        ng.prototype.ea = function() {
            return {
                name: "import",
                options: null
            };
        };
        function og(a) {
            var b = a.value;
            a.unit === t.LengthUnit.DEVICE_PIXELS && (b = Math.round(a.value) / window.devicePixelRatio);
            return {
                isPercentage: a.unit === t.LengthUnit.PERCENT,
                value: b
            };
        }
        function pg(a) {
            this.eh = a;
        }
        pg.prototype.ea = function() {
            return {
                name: "letterSpacing",
                options: og(this.eh)
            };
        };
        function qg(a) {
            this.He = a;
        }
        qg.prototype.ea = function() {
            return {
                name: "lineHeightScale",
                options: {
                    scaleFactor: this.He
                }
            };
        };
        function rg() {}
        rg.prototype.ea = function() {
            return {
                name: "mathMLFallback",
                options: null
            };
        };
        function sg() {}
        sg.prototype.ea = function() {
            return {
                name: "namespaceRemover",
                options: null
            };
        };
        function tg() {
            this.vb = !1;
            this.Ta = [];
        }
        tg.prototype.ea = function() {
            return {
                name: "negativeMarginDetector",
                options: null
            };
        };
        tg.prototype.Dc = function(a) {
            this.Ta = a.negativeHorizontalMarginSelectors;
            this.vb = a.hasInlineNegativeHorizontalMarginStyles;
        };
        function ug() {
            this.Va = {
                elementIndexes: [],
                selectors: []
            };
        }
        ug.prototype.cf = function() {
            return this.Va;
        };
        ug.prototype.ea = function() {
            return {
                name: "overflowXDetector",
                options: null
            };
        };
        ug.prototype.Dc = function(a) {
            this.Va = a;
        };
        function vg() {
            this.zb = "";
        }
        vg.prototype.Bd = function() {
            return this.zb;
        };
        vg.prototype.ea = function() {
            return {
                name: "pageBackgroundGetter",
                options: null
            };
        };
        vg.prototype.Dc = function(a) {
            this.zb = a.backgroundColor;
        };
        function wg(a, b) {
            this.Rg = a;
            this.ga = b;
        }
        wg.prototype.ea = function() {
            return {
                name: "pseudoSelectorRewriter",
                options: null
            };
        };
        wg.prototype.Dc = function(a) {
            var b = this;
            a.forEach(function(c) {
                try {
                    b.ga.querySelectorAll(c.selector).forEach(function(d) {
                        var e = d.getAttribute(c.attributeName);
                        d.setAttribute(c.attributeName, (e ? e + " " : "") + c.attributeValue.toString());
                    });
                } catch (d) {
                    t.Logger.logWarning("Invalid CSS selector found for document: " + b.Rg);
                }
            });
        };
        function xg(a) {
            this.Bf = a;
        }
        xg.prototype.ea = function() {
            return {
                name: "textAlign",
                options: {
                    defaultAlignment: this.Bf.defaultAlignment,
                    preserved: this.Bf.preserved
                }
            };
        };
        function yg(a) {
            this.Fa = a;
        }
        yg.prototype.ea = function() {
            var a = this.Fa.getRendererRuntime();
            return {
                name: "touchAction",
                options: {
                    fullTouchActionSupport: t.RuntimePlatform.isCssDeclarationSupported("touch-action", "pan-x"),
                    nativePanXAllowed: a.isNativePanXAllowed(),
                    nativePanYAllowed: a.isNativePanYAllowed()
                }
            };
        };
        function zg() {}
        zg.prototype.ea = function() {
            return {
                name: "unsupportedReflowDeclarationRemover",
                options: null
            };
        };
        function Ag(a, b) {
            this.Ce = a;
            this.Mg = b;
        }
        Ag.prototype.ea = function() {
            return {
                name: "urlLoader",
                options: {
                    allowRemoteResources: this.Mg,
                    inline: this.Ce
                }
            };
        };
        function Bg() {}
        Bg.prototype.ea = function() {
            return {
                name: "userSelectText",
                options: null
            };
        };
        function Cg() {}
        Cg.prototype.ea = function() {
            return {
                name: "vendorUnprefixer",
                options: null
            };
        };
        function Dg(a) {
            this.$d = a;
        }
        Dg.prototype.ea = function() {
            return {
                name: "vhToPx",
                options: {
                    pageHeight: this.$d
                }
            };
        };
        function Eg(a) {
            this.Ah = a;
        }
        Eg.prototype.ea = function() {
            return {
                name: "wordSpacing",
                options: og(this.Ah)
            };
        };
        function Fg(a, b, c, d, e) {
            b = b.createElement("div");
            b.style.display = "block";
            b.style.boxSizing = "border-box";
            b.style.width = a.width + "px";
            b.style.height = a.height + "px";
            e && (b.style.position = "absolute");
            d && (b.style.backgroundColor = d);
            if (c) {
                a = a.width;
                var f = c.pageMargins;
                c = t.LengthUtils.getLengthAsCssPixels(f.left, a);
                d = t.LengthUtils.getLengthAsCssPixels(f.top, a);
                e = t.LengthUtils.getLengthAsCssPixels(f.right, a);
                a = t.LengthUtils.getLengthAsCssPixels(f.bottom, a);
                b.style.padding = d + "px " + e + "px " + a + "px " + c + "px";
                c = {
                    Te: c,
                    Pc: d
                };
            } else c = {
                Te: 0,
                Pc: 0
            };
            return {
                u: b,
                i: c
            };
        }
        function Gg(a, b, c) {
            var d = this;
            this.Na = a;
            this.dd = b;
            this.fd = c;
            this.ac = [];
            this.hd = this.gd = null;
            Zf(this.dd, function(e, f) {
                d.hd = f ? Hg(e, null) : Ig(e, null);
            });
            Yf(this.dd, function(e, f) {
                d.gd = f ? Hg(e, null) : Ig(e, null);
            });
        }
        function Ig(a, b) {
            var c = [];
            b && c.push({
                name: "media",
                value: b
            });
            return {
                attributes: c,
                childNodes: [
                    {
                        childNodes: [],
                        data: a,
                        nodeName: "#text",
                        nodeType: 3
                    }
                ],
                nodeName: "style",
                nodeType: 1
            };
        }
        function Hg(a, b) {
            a = [
                {
                    name: "href",
                    value: a
                },
                {
                    name: "rel",
                    value: "stylesheet"
                }
            ];
            b && a.push({
                name: "media",
                value: b
            });
            return {
                attributes: a,
                childNodes: [],
                nodeName: "link",
                nodeType: 1
            };
        }
        function Jg(a, b) {
            if ("style" === b.Vd) Sf(a.dd, b.ag, function(d, e) {
                var f = b.Lc;
                d = e ? Hg(d, f) : Ig(d, f);
                a.ac.push({
                    vc: d,
                    mb: b.mb
                });
            });
            else if ("link" === b.Vd) {
                if (b.mb) {
                    var c = Hg(b.ec, b.Lc);
                    a.ac.push({
                        vc: c,
                        mb: b.mb
                    });
                } else try {
                    c = B.URLUtils.normalizePathnameEncoding(new URL(b.ec, a.fd)), Uf(a.dd, c, function(d, e) {
                        d = e ? Hg(d, b.Lc) : Ig(d, b.Lc);
                        a.ac.push({
                            vc: d,
                            mb: b.mb
                        });
                    });
                } catch (d) {
                    t.Logger.logError(d);
                }
            }
        }
        Gg.prototype.ia = function(a) {
            a.hasAttribute("style") && Kg(this, a);
        };
        function Lg(a, b) {
            var c = [];
            a.hd && c.push(a.hd);
            for(var d = 0; d < a.ac.length; d++){
                var e = a.ac[d];
                !e.vc || e.mb && !b || c.push(e.vc);
            }
            a.gd && c.push(a.gd);
            return c;
        }
        function Mg(a, b, c) {
            var d = eb(b);
            if (a.hd) {
                var e = Ng(a, b, a.hd);
                d.appendChild(e);
            }
            for(e = 0; e < a.ac.length; e++){
                var f = a.ac[e];
                !f.vc || f.mb && !c || (f = Ng(a, b, f.vc), d.appendChild(f));
            }
            a.gd && (a = Ng(a, b, a.gd), d.appendChild(a));
        }
        function Ng(a, b, c) {
            b = b.createElementNS(t.XmlNamespace.HTML, "link");
            if (c.attributes) for(var d = 0; d < c.attributes.length; d++){
                var e = c.attributes[d];
                b.setAttribute(e.name, e.value);
            }
            b.setAttribute("rel", "stylesheet");
            (c = c.childNodes[0]) && 3 === c.nodeType && c.data && (a = a.Na.createUrlForContent([
                c.data
            ], y.MediaType.TEXT_CSS, !1), b.setAttribute("href", a));
            return b;
        }
        function Kg(a, b) {
            var c = b.getAttribute("style");
            b.removeAttribute("style");
            Rf(a.dd, b, c, function(d, e) {
                b.setAttribute("style", d);
                b.setAttribute("data-colibrio-inline-style-index", String(e));
            });
        }
        function Og(a, b) {
            this.hg = a;
            this.Oh = b;
        }
        function Pg(a, b) {
            return b ? "ALLOW_ALL" === b.policyType ? a.map(function(c) {
                c = q.na(c);
                var d = c.next().value;
                c.next();
                return {
                    directive: d,
                    sources: [
                        "*"
                    ]
                };
            }) : "WHITELIST" === b.policyType ? b.whitelistDirectives : [] : [];
        }
        Og.prototype.nc = function(a, b) {
            var c = "default-src blob:; " + Qg(this);
            t.BrowserDetector.isBrowser("Firefox") && (c += " connect-src https://license.colibrio.com", this.hg && (c += " " + this.hg.join(" ")), c += ";");
            var d = a.createElementNS(t.XmlNamespace.HTML, "meta");
            d.setAttribute("http-equiv", "Content-Security-Policy");
            d.setAttribute("content", c);
            b.prepend(d, a.documentElement.firstElementChild);
            return Promise.resolve();
        };
        function Qg(a) {
            var b = [
                [
                    "frame-src",
                    "blob: data: 'self'"
                ],
                [
                    "style-src",
                    "blob: data: 'unsafe-inline' 'self'"
                ],
                [
                    "media-src",
                    "blob: data: android-webview-video-poster: 'self' https://appinternal.colibrio.com com.colibrio:"
                ],
                [
                    "font-src",
                    "blob: data: 'self' https://appinternal.colibrio.com com.colibrio:"
                ],
                [
                    "img-src",
                    "blob: data: 'self' https://appinternal.colibrio.com com.colibrio:"
                ]
            ], c = Pg(b, a.Oh);
            a = "script-src " + (0 < c.length ? "'none';" : "blob: https://license.colibrio.com; ");
            var d = "object-src " + (0 < c.length ? "'none';" : "blob: data: 'self'; ");
            return b.map(function(e) {
                e = q.na(e);
                var f = e.next().value;
                e = e.next().value;
                var g = c.find(function(h) {
                    return h.directive === f;
                });
                return f + " " + e + (g ? " " + g.sources.join(" ") : "") + ";";
            }).concat([
                a,
                d
            ]).join(" ");
        }
        var Rg = new Set("allow align alt autoplay border cite class colspan content controls controlslist coords datetime default dir draggable frameborder headers height hidden high href hreflang http-equiv ibooks:readaloud ibooks:readaloud-turn-style ibooks:pause-readaloud id kind label lang loop low marginheight marginwidth max media min muted name optimum playsinline poster rel reversed role rowspan scope scrolling shape sizes span src srclang start style summary title translate usemap value width xml:id xml:lang".split(" "));
        var Sg = new Set("style address article aside footer header h1 h2 h3 h4 h5 h6 hgroup main nav section blockquote dd dir div dl dt figcaption figure hr li ol p pre ul details summary a abbr b bdi bdo br cite code data dfn em i kbd mark q rb rp rt rtc ruby s samp small span strong sub sup time tt u var wbr area audio img map track video object picture source noscript del ins caption col colgroup table tbody td tfoot th thead tr meter progress iframe acronym big blink center font strike tt x-colibrio-text-split".split(" "));
        var Tg = new Set("accent accentunder actiontype align alignmentscope altimg altimg-width altimg-height altimg-valign alttext bevelled charalign close columnalign columnlines columnspacing columnspan columnwidth crossout decimalpoint denomalign depth dir display displaystyle edge equalcolumns equalrows fence form frame framespacing groupalign height href id indentalign indentalignfirst indentalignlast indentshift indentshiftfirst indentshiftlast indenttarget infixlinebreakstyle largeop length linebreak linebreakmultchar linebreakstyle lineleading linethickness location longdivstyle lspace lquote mathbackground mathcolor mathsize mathvariant maxsize minlabelspacing minsize movablelimits notation numalign open overflow position rowalign rowlines rowspacing rowspan rspace rquote scriptlevel scriptminsize scriptsizemultiplier selection separator separators shift side src stackalign stretchy subscriptshift supscriptshift symmetric voffset width xlink:href xmlns".split(" "));
        var Ug = new Set("annotation-xml maction maligngroup malignmark math menclose merror mfenced mfrac mglyph mi mlabeledtr mlongdiv mmultiscripts mn mo mover mpadded mphantom mprescripts mroot mrow ms msline mspace msqrt mstyle mscarries mscarry msgroup msrow mstack msub msubsup msup munder munderover mtable mtext mtd mtr semantics".split(" "));
        var Vg = new Set("vocab property typeof itemscope itemtype itemprop".split(" "));
        var Wg = new Set("accumulate additive alignment-baseline attributeName attributeType azimuth baseFrequency baseline-shift baseProfile bias calcMode class clip clipPathUnits clip-path clip-rule color color-interpolation color-interpolation-filters color-profile color-rendering cursor cx cy d diffuseConstant direction display divisor dominant-baseline dur dx dy edgeMode elevation end exponent externalResourceRequired fill fill-opacity fill-rule filter filterUnits flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight fr fx fy gradientTransform gradientUnits height href id image-rendering in in2 k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lang lengthAdjust letter-spacing lighting-color limitingConeAngle local marker-end marker-mid marker-start markerHeight markerUnits markerWidth mask maskContentUnits maskUnits max media method min mode name numOctaves offset opacity operator order orient overflow paint-order path pathLength patternContentUnits patternTransform patternUnits pointer-events points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY repeatCount repeatDur requiredFeatures restart result rotate rx ry scale seed shape-rendering slope spacing specularConstant specularExponent spreadMethod startOffset stdDeviation stitchTiles style stop-color stop-opacity strikethrough-position strikethrough-thickness stroke stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width style surfaceScale tabindex tableValues targetX targetY text-anchor text-decoration text-rendering textLength title transform type values vector-effect version viewBox visibility width word-spacing writing-mode x x1 x2 xChannelSelector xlink:href xlink:title xml:space xml:lang xmlns xmlns:xlink y y1 y2 yChannelSelector z".split(" "));
        var Xg = new Set("a animation animateMotion animateTransform circle clipPath defs desc discard ellipse feBlend feColorMatrix feComponentTransfer feComposite feConvolveMatrix feDiffuseLighting feDisplacementMap feDistantLight feDropShadow feFlood feFuncA feFuncB feFuncG feFuncR feGaussianBlur feImage feMerge feMergeNode feMorphology feOffset fePointLight feSpecularLighting feSpotLight feTile feTurbulence filter g image line linearGradient marker mask metadata mpath path pattern polygon polyline radialGradient rect stop style svg switch symbol text textPath title tspan use view".split(" "));
        function Yg(a) {
            this.Cc = a;
            this.Fc = null;
            this.Ud = !1;
        }
        Yg.prototype.sa = function(a, b, c, d) {
            if (a === d.documentElement && "html" !== b) throw new T("READER_DOCUMENT_LOAD_ERROR", "Root elements was not <html>: Got <" + b + ">");
            if (a.namespaceURI === t.XmlNamespace.HTML) {
                var e = !1;
                a.parentNode === d.documentElement ? "head" === b || "body" === b ? this.Fc = b : (c.remove(a), e = !0) : "head" === this.Fc ? ((b = "title" === b || "style" === b || "link" === b && "stylesheet" === (a.getAttribute("rel") || "").toLowerCase() || "meta" === b && !a.hasAttribute("http-equiv") && /^(?:viewport|author|creator|description|generator|googlebot|keywords|publisher|robots|slurp)$/i.test(a.getAttribute("name") || "") || this.Cc.tagNames.includes(b)) || c.remove(a), e = !b) : "body" === this.Fc && (this.Ud ? Ug.has(b) || (c.remove(a), e = !0) : "math" === b ? this.Ud = !0 : Sg.has(b) || this.Cc.tagNames.includes(b) || (c.remove(a), e = !0));
                if (!e) {
                    if (this.Ud) Zg(this, a);
                    else {
                        a = a.attributes;
                        c = [];
                        for(b = 0; b < a.length; b++)d = a[b], d.name.startsWith("data-colibrio-") || (Rg.has(d.name) || $g(d) || d.name.startsWith("data-") || Vg.has(d.name) || this.Cc.attributeNames.includes(d.name) ? zb(d.value) ? (e = yb(d.value)) && ah.test(e) || c.push(d) : bh.test(d.value) && c.push(d) : ch(d) || Vg.has(d.name) || c.push(d));
                        dh(c, a);
                    }
                }
            } else if ("body" === this.Fc && a.namespaceURI === t.XmlNamespace.SVG) {
                if (Xg.has(b) || this.Cc.tagNames.includes(b)) {
                    c = a.attributes;
                    b = [];
                    for(d = 0; d < c.length; d++)if (e = c[d], !e.name.startsWith("data-colibrio-")) {
                        if (Wg.has(e.name) || $g(e) || e.name.startsWith("data-") || Vg.has(e.name) || this.Cc.attributeNames.includes(e.name)) {
                            if (zb(e.value)) {
                                var f = yb(e.value);
                                f && ah.test(f) && "image" === a.localName || b.push(e);
                            } else bh.test(e.value) ? b.push(e) : /^\s*url\s*\([^#]/i.test(e.value) && b.push(e);
                        } else ch(e) || Vg.has(e.name) || b.push(e);
                    }
                    dh(b, c);
                } else c.remove(a);
            } else "body" === this.Fc && a.namespaceURI === t.XmlNamespace.MATHML ? Ug.has(b) || this.Cc.tagNames.includes(b) ? Zg(this, a) : c.remove(a) : c.remove(a);
        };
        Yg.prototype.ia = function(a, b, c, d) {
            a.parentNode === d.documentElement ? this.Fc = null : "math" === b && (this.Ud = !1);
        };
        function Zg(a, b) {
            b = b.attributes;
            for(var c = [], d = 0; d < b.length; d++){
                var e = b[d];
                if (!e.name.startsWith("data-colibrio-")) {
                    if (Tg.has(e.name) || $g(e) || e.name.startsWith("data-") || Vg.has(e.name) || a.Cc.attributeNames.includes(e.name)) {
                        if (zb(e.value)) {
                            var f = yb(e.value);
                            f && ah.test(f) || c.push(e);
                        } else bh.test(e.value) && c.push(e);
                    } else ch(e) || Vg.has(e.name) || c.push(e);
                }
            }
            dh(c, b);
        }
        var bh = /^\s*(?:javascript:|vbscript:)/i, ah = /^(?:text\/css|image\/|audio\/|video\/)/;
        function dh(a, b) {
            if (0 < a.length) for(var c = 0; c < a.length; c++)b.removeNamedItem(a[c].name);
        }
        function ch(a) {
            return a.namespaceURI === t.XmlNamespace.EPUB || a.namespaceURI === t.XmlNamespace.HTML && a.name.startsWith("epub:");
        }
        function $g(a) {
            return a.name.startsWith("aria-") || "role" === a.name;
        }
        function eh(a, b, c, d) {
            var e = [];
            a.Mc.forEach(function(f) {
                if (f.element.parentNode) switch(f.tagName){
                    case "image":
                    case "img":
                        e.push(fh(f, b, c, d));
                        break;
                    case "video":
                        e.push(fh(f, b, c, d));
                }
            });
            return Promise.all(e);
        }
        function fh(a, b, c, d) {
            var e, f = b.kc, g = b.W.getResourceProvider(), h = a.imgSource;
            h && (h.isDataUrl ? Ab(h.src, "image/") && gh(a, h.src) : (b = B.URLUtils.normalizePathnameEncoding(new URL(h.src, b.tb)), g.acceptsUrl(b) ? g.isUrlSupportedByBrowser(b) ? gh(a, b.toString()) : e = f.fetchBrowserNativeUrl(b, [
                h.type || y.MediaTypeCategory.IMAGE
            ], c).then(function(l) {
                gh(a, l.data);
            }).catch(function(l) {
                t.ColibrioError.isColibrioAbortedError(l) || t.Logger.logWarning(l);
            }) : d && ("http:" === b.protocol || "https:" === b.protocol) && gh(a, b.toString())));
            return e || Promise.resolve();
        }
        function gh(a, b) {
            switch(a.tagName){
                case "img":
                    a.element.setAttribute("src", b);
                    break;
                case "video":
                    a.element.setAttribute("poster", b);
                    break;
                case "image":
                    a.element.setAttributeNS(t.XmlNamespace.XLINK, "href", b);
            }
        }
        function hh(a) {
            this.nh = a;
        }
        function ih(a, b, c, d) {
            var e = "ALLOW_ALL" === d.policyType ? "* " : "", f = jh.map(function(h) {
                return h + " 'self' blob: data: " + e + (kh.has(h) ? kh.get(h) : "") + (e ? "" : " https://appinternal.colibrio.com com.colibrio:");
            });
            if ("WHITELIST" === d.policyType && 0 < d.whitelistDirectives.length) {
                d = d.whitelistDirectives.map(function(h) {
                    return [
                        h.directive,
                        h.sources
                    ];
                });
                var g = new Map(d);
                jh.forEach(function(h, l) {
                    g.has(h) && (f[l] += " " + g.get(h).join(" "));
                });
            }
            d = f.join("; ");
            a = a.createElementNS(t.XmlNamespace.HTML, "meta");
            a.setAttribute("http-equiv", "Content-Security-Policy");
            a.setAttribute("content", d);
            b ? b.prepend(a, c) : c.insertBefore(a, c.firstChild);
        }
        function lh(a) {
            for(a = a.firstChild; a;){
                var b = a.nextSibling;
                H(a) && "meta" === a.localName && "Content-Security-Policy" === a.getAttribute("http-equiv") && qb(a);
                a = b;
            }
        }
        hh.prototype.nc = function(a, b, c) {
            c && (lh(c), ih(a, b, c, this.nh));
            return Promise.resolve();
        };
        var kh = new Map([
            [
                "connect-src",
                "'unsafe-inline' 'unsafe-eval'"
            ],
            [
                "img-src",
                "android-webview-video-poster:"
            ],
            [
                "script-src",
                "'unsafe-inline' 'unsafe-eval'"
            ],
            [
                "style-src",
                "'unsafe-inline' 'unsafe-eval'"
            ]
        ]), jh = "child-src frame-src connect-src default-src font-src img-src media-src object-src script-src style-src".split(" ");
        function mh() {}
        function nh(a, b, c) {
            var d = c ? a.createElementNS(t.XmlNamespace.HTML, "script") : a.createElementNS(a.documentElement.namespaceURI, "script");
            d.setAttribute("data-colibrio-iframe-runtime", "");
            if ("SCRIPT" === d.tagName) {
                var e = a.createTextNode;
                oh || (oh = "(new Function(" + JSON.stringify(__worker__colibrio_readingsystem_formatadapter_epub_iframe) + "))();");
                d.appendChild(e.call(a, oh));
            } else d.appendChild(a.createCDATASection(__worker__colibrio_readingsystem_formatadapter_epub_iframe));
            b ? b.append(d, c || a.documentElement) : (c || a.documentElement).appendChild(d);
        }
        mh.prototype.nc = function(a, b, c) {
            nh(a, b, c);
            return Promise.resolve();
        };
        var oh;
        function ph(a, b, c) {
            var d = Error.call(this, "[" + a + "] " + b + " :: " + (c || ""));
            this.message = d.message;
            "stack" in d && (this.stack = d.stack);
            this.namespace = a;
            this.errorType = b;
            this.errorMessage = c || "";
        }
        q.inherits(ph, Error);
        function qh(a, b, c) {
            this.A = a;
            this.Lb = b;
            this.za = c;
            this.o = !1;
            this.H = null;
            this.g = new Map;
            this.ja = this.U = 1;
            this.h = [];
            this.j = -1;
        }
        function rh(a) {
            var b = sh(a, 1, {}), c = th(a, b);
            a.Ma(uh(a));
            a.m(b);
            return c.then(function() {
                return a;
            });
        }
        qh.prototype.destroy = function() {
            var a = this;
            this.g.forEach(function(b) {
                -1 !== b.Ac && clearTimeout(b.Ac);
                b.Yf(new ph(a.A, "ABORTED"));
            });
            this.g.clear();
            this.o = !1;
            this.H && this.Za(this.H);
            -1 !== this.j && (clearTimeout(this.j), this.j = -1);
            this.h = [];
        };
        function Qf(a, b) {
            b = sh(a, 4, b);
            try {
                a.m(b);
            } catch (c) {
                throw a.ja--, c;
            }
        }
        function Xf(a, b) {
            if (!a.o) throw new ph(a.A, "NOT_CONNECTED");
            b = sh(a, 3, b);
            var c = th(a, b);
            try {
                a.m(b);
            } catch (d) {
                a.ja--, b.msg = d.toString(), vh(a, b);
            }
            return c;
        }
        function sh(a, b, c) {
            return {
                msg: c,
                msgId: a.ja++,
                type: b
            };
        }
        function vh(a, b) {
            var c = a.g.get(b.msgId);
            c && (a.g.delete(b.msgId), -1 !== c.Ac && clearTimeout(c.Ac), a = (b = b.msg) && b.errorMessage && b.errorType ? new ph(a.A, "ABORTED" === b.errorType ? "ABORTED" : "REMOTE_ERROR", b.errorType + " :: " + b.errorMessage + " :: " + b.stack) : new ph(a.A, "ABORTED" === (null == b ? void 0 : b.errorType) ? "ABORTED" : "REMOTE_ERROR", Ha(b) ? b : JSON.stringify(b)), c.Yf(a));
        }
        function wh(a, b) {
            var c = a.g.get(b.msgId);
            c && (a.g.delete(b.msgId), -1 !== c.Ac && clearTimeout(c.Ac), c.qh(b.msg));
        }
        function uh(a) {
            a.H || (a.H = function(b) {
                if (a.Sa(b)) switch(b = b.data, b.type){
                    case 2:
                        a.o = !0;
                        wh(a, b);
                        break;
                    case 3:
                    case 4:
                        a.U === b.msgId ? (a.U++, xh(a, b), 0 < a.h.length && yh(a, !1)) : zh(a, b);
                        break;
                    case 5:
                        wh(a, b);
                        break;
                    case 6:
                        vh(a, b);
                }
            });
            return a.H;
        }
        function zh(a, b) {
            console.log("Incoming out of order message: ", b.msgId, ", expected: ", a.U);
            var c = a.h.findIndex(function(d) {
                return d.msgId > b.msgId;
            });
            0 <= c ? a.h.splice(c, 0, b) : a.h.push(b);
            -1 === a.j && (a.j = setTimeout(function() {
                a.j = -1;
                yh(a, !0);
            }, 2E3));
        }
        function xh(a, b) {
            switch(b.type){
                case 3:
                    try {
                        a.za.sg(b.msg).then(function(c) {
                            if (c && c.Eg && c.message) {
                                var d = c.Eg;
                                c = c.message;
                            }
                            a.o && a.m({
                                msg: c,
                                msgId: b.msgId,
                                type: 5
                            }, d);
                        }).catch(function(c) {
                            c && "ABORTED" !== c.errorType && console.error(c);
                            Ah(a, b, c);
                        });
                    } catch (c) {
                        c && "ABORTED" !== c.errorType && console.error(c), Ah(a, b, c);
                    }
                    break;
                case 4:
                    a.za.rg(b.msg);
            }
        }
        function yh(a, b) {
            for(; 0 < a.h.length && (b || a.h[0].msgId === a.U);){
                var c = a.h.shift();
                a.U = c.msgId + 1;
                xh(a, c);
            }
            0 === a.h.length && -1 !== a.j && clearTimeout(a.j);
        }
        function Ah(a, b, c) {
            var d;
            c && Ha(c.errorType) && Ha(c.errorMessage) ? d = {
                errorMessage: c.errorMessage,
                errorType: c.errorType,
                stack: Ha(c.stack) ? c.stack : ""
            } : c && (c.message ? d = {
                errorMessage: c.message,
                errorType: c.constructor ? c.constructor.name : "" + c,
                stack: Ha(c.stack) ? c.stack : ""
            } : d = Ha(c.stack) ? c.stack : "" + c);
            a.m({
                msg: d,
                msgId: b.msgId,
                type: 6
            });
        }
        function th(a, b) {
            return new Promise(function(c, d) {
                c = {
                    Yf: d,
                    qh: c,
                    Ac: -1
                };
                a.g.set(b.msgId, c);
                c.Ac = setTimeout(function() {
                    a.g.has(b.msgId) && (a.g.delete(b.msgId), d(new ph(a.A, "TIMEOUT")));
                }, a.Lb);
            });
        }
        function Bh(a, b, c, d) {
            qh.call(this, b, c, d);
            this.Z = a;
        }
        q.inherits(Bh, qh);
        Bh.prototype.Ma = function(a) {
            this.Z.addEventListener("message", a, !1);
        };
        Bh.prototype.Sa = function(a) {
            a = a.data;
            return K(a.type) && K(a.msgId);
        };
        Bh.prototype.m = function(a, b) {
            b ? this.Z.postMessage(a, b) : this.Z.postMessage(a);
        };
        Bh.prototype.Za = function(a) {
            this.Z.removeEventListener("message", a, !1);
        };
        function Ch(a) {
            var b = __worker__colibrio_readingsystem_formatadapter_epub_webworker;
            this.g = null;
            var c = new Blob([
                b
            ]);
            try {
                this.g = URL.createObjectURL(c), this.h = new Worker(this.g);
            } catch (d) {
                this.g && URL.revokeObjectURL(this.g), a = xb("text/javascript", a((new TextEncoder).encode(b))), this.h = new Worker(new URL(a));
            }
        }
        Ch.prototype.terminate = function() {
            this.h.terminate();
            this.g && URL.revokeObjectURL(this.g);
        };
        function Dh() {
            this.g = new Map;
        }
        Dh.prototype.rg = function(a) {
            this.g.get(a.channelId);
        };
        Dh.prototype.sg = function(a) {
            var b = this.g.get(a.channelId);
            return b ? b.gf(a) : Promise.reject(new T(t.ColibrioErrorType.ABORTED));
        };
        function Eh(a, b, c) {
            this.g = a;
            this.D = b;
            this.qc = c;
            this.h = 1;
        }
        function Fh() {
            Gh--;
            if (0 === Gh && Hh) {
                var a = Hh;
                Hh = null;
                a.then(function(b) {
                    return b.destroy();
                }).catch(function(b) {
                    t.ColibrioError.isColibrioAbortedError(b) || t.Logger.logError(b);
                });
            }
        }
        function Ih() {
            if (!Hh) {
                if (0 >= Gh) return Promise.reject(new T(t.ColibrioErrorType.ABORTED));
                var a = new Ch(function(d) {
                    return t.Base64.encode(d);
                });
                var b = new Dh, c = new Bh(a.h, "colibrio.readingsystem.formatadapter.epub", 2E4, b);
                Hh = rh(c).then(function(d) {
                    return new Eh(a, d, b);
                }).catch(function(d) {
                    c.destroy();
                    a.terminate();
                    Hh = null;
                    throw d;
                });
            }
            return Hh;
        }
        function Jh() {
            Gh++;
            1 === Gh && Ih().catch(function(a) {
                t.ColibrioError.isColibrioAbortedError(a) || t.Logger.logError(a);
            });
        }
        function Pf(a) {
            return {
                D: a.D,
                jb: a.h++,
                qc: a.qc
            };
        }
        Eh.prototype.destroy = function() {
            this.D.destroy();
            this.g.terminate();
        };
        var Hh = null, Gh = 0;
        function Kh(a, b, c) {
            a = (new va.XmlSerializer).serializeXml(a);
            return {
                Ob: c.Ob,
                vb: c.vb,
                Ic: b,
                xb: c.xb,
                ic: !1,
                Ta: c.Ta,
                Tb: c.Tb,
                zb: c.zb,
                Wa: [],
                yc: a,
                Da: c.Da,
                bb: c.bb,
                gb: c.gb
            };
        }
        function Lh(a, b) {
            var c, d, e, f, g, h, l, m, n, p, u, v, w, x, A, z, C, F, G, L, P, Y, ba, ka, V, ea, pa, W;
            return q.K(function(ha) {
                if (1 == ha.g) return c = Mh(a.M), d = a.F, e = !1, f = a.G.getReaderViewOptions().publicationStyleOptions, g = d.isReflowable() || a.M.fixedLayoutStyleOptions.allowFontSetCustomization ? f.fontSet : null, h = new jg(e, f.defaultFontFamily, g), l = [
                    new cg(d.getSourceContentDocument(), a.da)
                ], a.F.isReflowable() && l.push(new hg(a.M)), m = d.getReaderPublication().getReadingSystemEngine().getOptions(), n = c ? a.M.remoteResourcesNonScriptedDocumentsOptions : void 0, p = [
                    new Yg(a.M.elementWhitelistOptions),
                    new Og(m.platformWorkaroundOptions.firefoxCspConnectDomains, n)
                ], u = new Ob, u.Qa = p.slice(), r(ha, u.transform(b.Ja, new lc(new hc(b.T.slice()))), 2);
                if (3 != ha.g) return v = ha.h, w = Nh(a, b, {
                    Nd: l,
                    Od: [
                        new Ag(e, c),
                        h
                    ],
                    Le: !1,
                    Se: !1
                }, v.Ra.g), x = eh(b, a, e, c), A = q, z = A.na, r(ha, Promise.all([
                    w,
                    x
                ]), 3);
                C = z.call(A, ha.h);
                G = F = C.next().value;
                Mg(G.wd, b.Ja, c);
                L = b.xb;
                P = G.negativeHorizontalMarginSelectors;
                Y = G.hasInlineNegativeHorizontalMarginStyles;
                ba = G.nf;
                ka = G.pageBackgroundColor;
                V = G.wf;
                ea = Lg(G.wd, c);
                pa = new va.XmlSerializer;
                W = pa.serializeXml(b.Ja);
                return ha.return({
                    Ob: h.Pb,
                    vb: Y,
                    Ic: G.domMutationRecords,
                    xb: L,
                    ic: a.F.isReflowable(),
                    Ta: P,
                    Tb: ba,
                    zb: ka,
                    Wa: b.Wa,
                    yc: W,
                    Da: b.yb,
                    bb: ea,
                    gb: V
                });
            });
        }
        function Oh(a, b) {
            var c, d, e, f, g, h, l, m, n, p, u, v, w, x, A, z, C, F, G, L, P, Y, ba, ka, V, ea, pa;
            return q.K(function(W) {
                if (1 == W.g) return c = a.Hc, d = b.G.getReaderViewOptions().publicationStyleOptions, e = new jg(c, d.defaultFontFamily, d.fontSet), f = Mh(b.M), g = b.F.getReaderPublication().getReadingSystemEngine().getOptions(), h = f ? b.M.remoteResourcesNonScriptedDocumentsOptions : void 0, l = [
                    new Yg(b.M.elementWhitelistOptions),
                    new Og(g.platformWorkaroundOptions.firefoxCspConnectDomains, h)
                ], m = new Ob, m.Qa = l.slice(), r(W, m.transform(a.Ja, new lc(new hc(a.T.slice()))), 2);
                if (3 != W.g) return n = W.h, p = Nh(b, a, {
                    Nd: [
                        new hg(b.M),
                        new cg(b.F.getSourceContentDocument(), b.da)
                    ],
                    Od: [
                        new ig,
                        new zg,
                        new Ag(c, f),
                        e
                    ],
                    Le: a.Hc,
                    Se: !0
                }, n.Ra.g), u = eh(a, b, c, f), v = q, w = v.na, r(W, Promise.all([
                    p,
                    u
                ]), 3);
                x = w.call(v, W.h);
                z = A = x.next().value;
                Mg(z.wd, a.Ja, f);
                C = a.xb;
                F = z.negativeHorizontalMarginSelectors;
                G = z.hasInlineNegativeHorizontalMarginStyles;
                L = z.nf;
                P = z.pageBackgroundColor;
                Y = a.Wa;
                ba = Lg(z.wd, f);
                ka = z.wf;
                V = a.yb;
                ea = new va.XmlSerializer;
                pa = ea.serializeXml(a.Ja);
                return W.return({
                    Ob: e.Pb,
                    vb: G,
                    Ic: n.Ra.g.slice(),
                    xb: C,
                    ic: !1,
                    Ta: F,
                    Tb: L,
                    zb: P,
                    Wa: Y,
                    yc: pa,
                    Da: V,
                    bb: ba,
                    gb: ka
                });
            });
        }
        function Ph(a, b, c, d) {
            var e = a.querySelector("head");
            e && (nh(e.ownerDocument, null, e), lh(e), ih(e.ownerDocument, null, e, d.M.remoteResourcesScriptedDocumentsOptions));
            d = a.documentElement.querySelectorAll('link[rel="stylesheet"]');
            for(e = 0; e < d.length; e++)qb(d[e]);
            Qh(a.documentElement);
            a = (new va.XmlSerializer).serializeXml(a);
            return {
                Ob: [],
                vb: c.vb,
                Ic: b,
                xb: c.xb,
                ic: !1,
                Ta: c.Ta,
                Tb: c.Tb,
                zb: c.zb,
                Wa: [],
                yc: a,
                Da: c.Da,
                bb: c.bb,
                gb: c.gb
            };
        }
        function Rh(a, b, c) {
            var d, e, f, g, h, l, m, n, p, u, v, w, x, A, z, C, F;
            return q.K(function(G) {
                if (1 == G.g) return d = !0, e = b.F, f = b.G.getReaderViewOptions(), g = f.publicationStyleOptions, h = e.isReflowable() || b.M.fixedLayoutStyleOptions.allowFontSetCustomization ? g.fontSet : null, l = new jg(d, g.defaultFontFamily, h), m = Mh(b.M), n = [
                    new mh,
                    new hh(b.M.remoteResourcesScriptedDocumentsOptions)
                ], p = new Ob, p.Qa = n.slice(), r(G, p.transform(a.Ja, new lc(new hc(a.T.slice()))), 2);
                if (3 != G.g) return u = G.h, v = b.M.contentProcessingOptions.skipUnusedImagesInScriptedPublicationCss ? [
                    new cg(e.getSourceContentDocument(), b.da)
                ] : [], w = Nh(b, a, {
                    Nd: v,
                    Od: [
                        new Ag(d, m),
                        l
                    ],
                    Le: !0,
                    Se: !1
                }, u.Ra.g), Qh(a.Ja.documentElement), r(G, w, 3);
                x = G.h;
                A = Lg(x.wd, m);
                z = new va.XmlSerializer;
                C = z.serializeXml(a.Ja);
                F = a.yb == y.MediaType.IMAGE_SVG ? y.MediaType.TEXT_HTML : a.yb;
                return G.return({
                    Ob: [],
                    vb: x.hasInlineNegativeHorizontalMarginStyles,
                    Ic: x.domMutationRecords,
                    xb: a.xb,
                    ic: c,
                    Ta: x.negativeHorizontalMarginSelectors,
                    Tb: x.nf,
                    zb: x.pageBackgroundColor,
                    Wa: a.Wa,
                    yc: C,
                    Da: F,
                    bb: A,
                    gb: x.wf
                });
            });
        }
        function Sh(a) {
            var b, c, d, e, f, g, h, l, m;
            return q.K(function(n) {
                if (1 == n.g) return b = q, c = b.na, r(n, Promise.all([
                    Ih(),
                    a.W.rh
                ]), 2);
                d = c.call(b, n.h);
                e = d.next().value;
                f = d.next().value;
                g = e;
                h = f;
                l = a.ta.getContentUrl();
                m = new Of(g, l, h, a.kc);
                a.Md.push(m);
                return n.return(m);
            });
        }
        function Qh(a) {
            if (a) {
                var b = a.getAttribute("style");
                b && a.setAttribute("data-colibrio-org-style", b);
                a.setAttribute("style", "display: none !important");
            }
        }
        function Mh(a) {
            var b;
            a = null == (b = a.remoteResourcesNonScriptedDocumentsOptions) ? void 0 : b.policyType;
            return "ALLOW_ALL" === a || "WHITELIST" === a;
        }
        function Nh(a, b, c, d) {
            var e, f, g, h, l, m, n, p, u, v, w, x, A, z, C, F, G, L, P, Y, ba, ka, V, ea, pa, W, ha, Ua, wa, Ad, Va, Jb;
            return q.K(function(Aa) {
                switch(Aa.g){
                    case 1:
                        if (a.G.isCanceled()) return Aa.return(Promise.reject(new T(t.ColibrioErrorType.ABORTED)));
                        f = a.ta;
                        g = f.getLayout() === sa.ContentDocumentLayout.REFLOWABLE;
                        h = a.G.getReaderView().getOptions().publicationStyleOptions;
                        l = b.yb == y.MediaType.IMAGE_SVG;
                        m = !l && (g || a.M.fixedLayoutStyleOptions.allowPaletteCustomization);
                        n = [
                            new ng
                        ];
                        return r(Aa, Sh(a), 2);
                    case 2:
                        p = Aa.h;
                        Vf(p, n);
                        u = [
                            new gg(a.M),
                            new Cg,
                            new yg(a.G)
                        ];
                        b.yb === y.MediaType.TEXT_HTML && u.push(new sg);
                        b.xb && u.push(new rg);
                        h.disableCssAnimations && u.push(new ag);
                        v = a.M.customPublicationCss;
                        (0 < v.injectionPointStart.length || 0 < v.injectionPointEnd.length) && u.unshift(new dg(v.injectionPointStart, v.injectionPointEnd));
                        w = a.bc ? a.G.getConstrainedPageDimensions(a.bc, f.getPageSpreadSlot()) : a.G.getUnconstrainedPageDimensions(f.getPageSpreadSlot());
                        if (g) {
                            x = h.typographyResetOptions;
                            (x.removePublicationDefinedFontSizes || x.removePublicationDefinedLineHeights) && u.push(new kg(x.removePublicationDefinedFontSizes, x.removePublicationDefinedLineHeights));
                            var Ba = w, Kb = h.pageMargins, Bd = Ba.width;
                            t.LengthUtils.getLengthAsCssPixels(Kb.left, Bd);
                            t.LengthUtils.getLengthAsCssPixels(Kb.right, Bd);
                            Kb = t.LengthUtils.getLengthAsCssPixels(Kb.top, Bd) + t.LengthUtils.getLengthAsCssPixels(Kb.bottom, Bd);
                            e = Ba.height - Kb;
                            u.push(new Dg(e));
                        } else u.push(new Dg(w.height));
                        h.palette && m && u.push(new mg);
                        c.Nd && (u = u.concat(c.Nd));
                        Vf(p, u);
                        A = [];
                        h.palette && m && A.push(new eg(h.palette));
                        (0 < v.injectionPointStartUnprocessed.length || 0 < v.injectionPointEndUnprocessed.length) && A.push(new fg(v.injectionPointStartUnprocessed, v.injectionPointEndUnprocessed));
                        a.M.mediaOverlayOptions.activeElementStylesOverride && (z = a.F.getReaderPublication(), A.push(new $f(z.getSourcePublication().getMetadata().getMediaOverlayMetadata().getActiveClassName(), z.getOptions().mediaOverlayOptions.fallbackActiveElementClass, a.M.mediaOverlayOptions.activeElementStylesOverride)));
                        g && (A.push(new lg(h.fontSizeScaleFactor)), h.letterSpacing && 0 !== h.letterSpacing.value && A.push(new pg(h.letterSpacing)), A.push(new qg(h.lineHeightScaleFactor)), h.textAlignment && A.push(new xg(h.textAlignment)), h.wordSpacing && 0 !== h.wordSpacing.value && A.push(new Eg(h.wordSpacing)));
                        c.Od && (A = A.concat(c.Od));
                        a.M.preventDefaultContextMenuOnMediaElements && !t.BrowserDetector.isOS("iOS") && A.push(new Bg);
                        c.Se && (C = f.getContentUrl().toString(), A.push(new wg(C, b.Ja)));
                        0 < A.length && Vf(p, A);
                        F = new bg;
                        G = new vg;
                        P = L = null;
                        Y = [
                            F,
                            G
                        ];
                        g && (L = new tg, P = new ug, Y.push(L), Y.push(P));
                        c.Tg && (Y = Y.concat(c.Tg));
                        Vf(p, Y);
                        ba = new Gg(a.kc, p, a.tb);
                        ka = new Ob;
                        ka.Qa = [
                            ba
                        ].slice();
                        return r(Aa, ka.transform(b.Ja, new lc(new hc(d))), 3);
                    case 3:
                        V = Aa.h;
                        ea = q.na(b.bb);
                        for(pa = ea.next(); !pa.done; pa = ea.next())W = pa.value, Jg(ba, W);
                        ha = !c.Le && location.protocol.startsWith("http");
                        return r(Aa, Wf(p, ha), 4);
                    case 4:
                        if (a.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                        Ua = F.Tf;
                        wa = Ig(Ua, null);
                        wa.attributes || (wa.attributes = []);
                        wa.attributes.push({
                            name: "data-colibrio-css-pause-animation",
                            value: ""
                        });
                        ba.ac.push({
                            vc: wa,
                            mb: !1
                        });
                        return Aa.return({
                            wd: ba,
                            domMutationRecords: V.Ra.g,
                            hasInlineNegativeHorizontalMarginStyles: (null == (Ad = L) ? void 0 : Ad.vb) || null,
                            negativeHorizontalMarginSelectors: (null == (Va = L) ? void 0 : Va.Ta) || null,
                            nf: (null == (Jb = P) ? void 0 : Jb.cf()) || null,
                            pageBackgroundColor: G.Bd(),
                            wf: F.gb
                        });
                }
            });
        }
        function Th(a, b, c) {
            this.boundingClientRect = a;
            this.contentLocation = b;
            this.rects = c;
        }
        Th.prototype.toJSON = function() {
            var a = this.boundingClientRect;
            return {
                boundingClientRect: a ? {
                    height: a.height,
                    width: a.width,
                    x: a.x,
                    y: a.y
                } : null,
                locator: this.contentLocation.toJSON(),
                rects: this.rects.map(function(b) {
                    return b.toJSON();
                })
            };
        };
        function Uh(a, b, c) {
            var d = this;
            this.g = a;
            this.N = b;
            this.re = c;
            this.Ba = !1;
            this.h = this.B = null;
            this.Ma = !1;
            this.j = D.RenderableState.CREATED;
            this.Za = this.o = null;
            this.Lb = new He;
            this.U = Vh();
            this.Z = [];
            this.ja = 1;
            this.ua = this.A = !1;
            this.Sa = new He;
            this.m = D.RenderableState.CREATED;
            this.Yc = function(e) {
                d.o && (Ta(e, d.U), d.o.appendChild(e));
            };
            this.Jg = function() {
                return Ie(d.Lb, void 0, function(e) {
                    t.ColibrioError.isColibrioAbortedError(e) || t.Logger.logError(e);
                });
            };
            this.I = this.g.pg();
            this.l = this.g.qg();
            this.H = this.l.ta.getPageSpreadSlot();
        }
        k = Uh.prototype;
        k.addOverflowingElementScrolledListener = function(a) {
            this.m !== D.RenderableState.DESTROYED && this.Lb.add(a);
        };
        k.addStateChangeListener = function(a) {
            this.m !== D.RenderableState.DESTROYED && this.Sa.add(a);
        };
        k.createOverlayElement = function(a) {
            var b = this.l.G.getReaderView().getElement();
            b = (b ? b.ownerDocument : document).createElement("div");
            Ta(b, a);
            b.setAttribute("role", "presentation");
            this.Z.push(b);
            this.Yc(b);
            return b;
        };
        k.destroy = function() {
            Wh(this, D.RenderableState.DESTROYED, this.A);
            this.j === D.RenderableState.VISIBLE && Xh(this, !1);
            this.j === D.RenderableState.ATTACHED_TO_DOM && Yh(this);
            this.o = null;
            this.j === D.RenderableState.CREATED && (this.B && (this.B = null), this.Z = [], this.j = D.RenderableState.DESTROYED);
            this.Sa.clear();
            this.g && this.g.destroy();
        };
        k.destroyOverlayElement = function(a) {
            var b = this.Z.indexOf(a);
            -1 !== b && (this.Z.splice(b, 1), qb(a));
        };
        k.fetchContentLocationByTopOffset = function(a, b, c) {
            var d = 0;
            this.h && (d = this.h.i.Pc);
            return this.B ? this.g.mg(this.B, a - d, b, c) : Promise.resolve(null);
        };
        k.fetchContentRangeByTopOffsets = function(a, b) {
            var c = 0;
            this.h && (c = this.h.i.Pc);
            return this.B ? this.g.fetchContentRangeByTopOffsets(this.B, a - c, b - c) : Promise.resolve(null);
        };
        k.fetchContentRangesByTopOffsets = function(a) {
            var b = 0;
            this.h && (b = this.h.i.Pc);
            a = a.map(function(c) {
                return c - b;
            });
            return this.B ? this.g.fetchContentRangesByTopOffsets(this.B, a) : Promise.resolve({
                next: null,
                previous: null,
                visible: null
            });
        };
        k.fetchOverlayRectsForContentLocation = function(a) {
            var b = this, c = this.ja;
            if (this.B && a instanceof X) {
                if (!this.B || c !== this.ja) return Promise.reject(new T(t.ColibrioErrorType.ABORTED));
                var d = $c(a, this.l.F, this.l.da);
                return this.g.lg(this.B, d.P, d.O).then(function(e) {
                    return {
                        collapsed: !d.O,
                        rects: Zh(b, e)
                    };
                });
            }
            return Promise.resolve({
                collapsed: !0,
                rects: []
            });
        };
        k.fetchRectsForVisibleContent = function(a, b) {
            var c = this, d, e, f, g, h, l, m, n, p, u, v;
            return q.K(function(w) {
                if (1 == w.g) {
                    if (!c.B) throw new T("DOCUMENT_NOT_RENDERED");
                    if (!(a instanceof X)) throw new T("INCOMPATIBLE_LOCATION", "Passed ContentLocation is not intended for EPUB");
                    d = $c(a, c.l.F, c.l.da);
                    return r(w, c.g.ng(c.B, d.P, d.O, b), 2);
                }
                e = w.h;
                if (0 === e.length) return w.return(new Th(null, a, e));
                f = rb(c.B.getBoundingClientRect());
                g = f.width / c.B.offsetWidth;
                e.forEach(function(x) {
                    x = x.clientRect;
                    x.x = g * x.x + f.x;
                    x.y = g * x.y + f.y;
                    x.width *= g;
                    x.height *= g;
                });
                l = h = Number.MAX_SAFE_INTEGER;
                n = m = Number.MIN_SAFE_INTEGER;
                p = q.na(e);
                for(u = p.next(); !u.done; u = p.next())v = u.value, h = Math.min(h, v.clientRect.left), l = Math.min(l, v.clientRect.top), m = Math.max(m, v.clientRect.right), n = Math.max(n, v.clientRect.bottom);
                return w.return(new Th(new DOMRect(h, l, m - h, n - l), a, e));
            });
        };
        k.focusOnContentLocation = function(a, b) {
            if (!(a instanceof X)) return Promise.reject(new T("INCOMPATIBLE_LOCATION", "focusOnContentLocation(): Wrong instance type"));
            if (!this.B || !this.A || this.m !== D.RenderableState.VISIBLE) return Promise.reject(new T("DOCUMENT_NOT_RENDERED", "focusOnContentLocation() not rendered"));
            a = $c(a, this.l.F, this.l.da);
            var c = this.l.F.getReaderPublication().getSourcePublication().getMetadata().getLanguages();
            return this.g.af(this.B, a.P, b, 0 < c.length ? c[0].content.value : null);
        };
        k.getPageContentElement = function() {
            var a;
            return (null == (a = this.B) ? void 0 : a.parentElement) || null;
        };
        k.getPageDimensions = function() {
            var a = this.l.bc, b = this.l.G;
            return a ? b.getConstrainedPageDimensions(a, this.H) : b.getUnconstrainedPageDimensions(this.H);
        };
        k.getPageFragmentationContext = function() {
            return null;
        };
        k.getPageIndexInSection = function() {
            return 0;
        };
        k.getRangeContentLocation = function() {
            if (!this.Za) {
                var a = this.l.da, b = M(a), c = a.createRange();
                c.selectNodeContents(b);
                a = dd(this.N, this.l.ta, c);
                c.detach();
                c = this.l.F;
                this.Za = new X(a, [
                    c
                ], c.getReaderPublication(), {
                    Ca: !1,
                    O: {
                        v: [],
                        i: b.childNodes.length
                    },
                    Ka: !0,
                    P: {
                        v: [],
                        i: 0
                    }
                });
            }
            return this.Za;
        };
        k.getReaderDocument = function() {
            return this.l.F;
        };
        k.getSectionIndex = function() {
            return this.re;
        };
        k.getSpreadSlot = function() {
            return this.H;
        };
        k.getStartContentLocation = function() {
            return this.l.F.getContentLocation();
        };
        k.getState = function() {
            return this.m;
        };
        k.handleEvent = function(a) {
            var b = this;
            if ("load" === a.type && this.B) {
                if (this.Ba) t.Logger.logWarning(new T("IFRAME_LOAD_MULTIPLE_TIMES", "Received unexpected extra load event on iframe."));
                else {
                    this.Ba = !0;
                    var c = this.ja;
                    this.g.lf(this.B, this.I.Ic.slice(), this.Jg).finally(function() {
                        if (b.l.G.isCanceled()) b.destroy();
                        else if (b.B && c === b.ja) {
                            b.Ma = !0;
                            b.j === D.RenderableState.VISIBLE && b.g.le(b.B);
                            var d = b.g.Bd();
                            b.h && d && (b.h.u.style.backgroundColor = d);
                            !0 !== b.A && Wh(b, b.m, !0);
                        }
                    }).catch(function(d) {
                        t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logError(d);
                    });
                }
            }
        };
        k.isCustomPageContent = function() {
            return !1;
        };
        k.isRenderingCompleted = function() {
            return this.A;
        };
        k.isRenderingPaused = function() {
            return this.ua;
        };
        k.print = function() {
            this.g.print(this.B);
        };
        k.remove = function() {
            this.m !== D.RenderableState.DESTROYED && (Wh(this, D.RenderableState.CREATED, !1), Yh(this), this.o = null);
        };
        k.removeOverflowingElementScrolledListener = function(a) {
            this.Lb.remove(a);
        };
        k.removeStateChangeListener = function(a) {
            this.Sa.remove(a);
        };
        k.renderTo = function(a) {
            this.m !== D.RenderableState.DESTROYED && (Wh(this, D.RenderableState.ATTACHED_TO_DOM, this.A), this.j !== D.RenderableState.CREATED && Yh(this), this.o = a, this.ua || $h(this));
        };
        k.setContentSelection = function(a) {
            var b = this, c;
            return q.K(function(d) {
                if (!b.B) throw new T("DOCUMENT_NOT_RENDERED");
                if (!(a instanceof X)) throw new T("INCOMPATIBLE_LOCATION", "Passed ContentLocation is not intended for EPUB");
                c = $c(a, b.l.F, b.l.da);
                return d.return(b.g.setContentSelection(b.B, c.P, c.O).then(function() {
                    var e;
                    return null == (e = b.B) ? void 0 : e.focus();
                }));
            });
        };
        k.setRenderingPaused = function(a) {
            var b = this.ua && !a;
            this.ua = a;
            b && (this.j !== D.RenderableState.CREATED || this.m !== D.RenderableState.ATTACHED_TO_DOM && this.m !== D.RenderableState.VISIBLE || $h(this), this.j === D.RenderableState.ATTACHED_TO_DOM && this.m === D.RenderableState.VISIBLE && Xh(this, !0));
        };
        k.setSpreadSlot = function(a) {
            this.H = a;
            this.B && ai(this, this.B);
        };
        k.setVisible = function(a) {
            if (!this.o) throw new U("setVisible() called before renderTo()");
            Wh(this, a ? D.RenderableState.VISIBLE : D.RenderableState.ATTACHED_TO_DOM, this.A);
            a && this.ua || Xh(this, a);
        };
        function Yh(a) {
            a.j !== D.RenderableState.DESTROYED && (a.j === D.RenderableState.VISIBLE && Xh(a, !1), a.Z.forEach(qb), a.Ba = !1, a.Ma = !1, a.ja++, !1 !== a.A && Wh(a, a.m, !1), a.B && (a.g.mf(a.B), qb(a.B), a.B.removeEventListener("load", a, !1), a.B = null), a.h && (qb(a.h.u), a.h = null), a.j = D.RenderableState.CREATED);
        }
        function $h(a) {
            if (a.j !== D.RenderableState.DESTROYED && a.o) {
                a.j !== D.RenderableState.CREATED && Yh(a);
                var b = a.o, c = a.o.ownerDocument;
                a.ja++;
                a.U = Vh();
                var d = a.l.F.getSourceContentDocument().getLayout() === sa.ContentDocumentLayout.REFLOWABLE;
                if (!a.B) {
                    a.B = c.createElement("iframe");
                    a.B.style.display = "block";
                    a.B.setAttribute("allow", "autoplay *; fullscreen *");
                    a.B.setAttribute("allowfullscreen", "true");
                    a.B.setAttribute("tabindex", "-1");
                    a.B.setAttribute("src", a.g.og());
                    ai(a, a.B);
                    var e = a.l.bc, f = a.l.G, g = f.getUnconstrainedPageDimensions(a.H), h = f.getRenderer().getSupportedFlowModes().includes(sa.ContentDocumentFlowMode.PAGINATED);
                    e ? (d = f.getConstrainedPageDimensions(e, a.H), a.h = Fg(d, c, null, a.I.zb, h), a.B.style.width = e.width + "px", a.B.style.height = e.height + "px", a.B.style.transformOrigin = "0 0", c = f.getConstrainedPageScaleFactor(e, a.H), a.B.style.transform = "scale(" + c + ")", a.B.setAttribute("data-colibrio-iframe-scale-factor", "" + c), b = a.h.u, a.o.appendChild(b), a.H === sa.PageSpreadSlot.LEFT && (a.B.style.marginLeft = Math.ceil(d.width - e.width * c) + "px"), f = f.getConstrainedPageOffsets(d, a.H), b.style.top = f.top + "px", b.style.left = f.left + "px", a.U.width = Math.ceil(e.width * c) + "px", a.U.height = Math.ceil(e.height * c) + "px", a.U.top = f.top + "px", a.U.left = f.left + "px") : (d ? (a.h = Fg(g, c, f.getReaderViewOptions().publicationStyleOptions, a.I.zb, h), f.getRenderer().getSupportedFlowModes().some(function(l) {
                        return l === sa.ContentDocumentFlowMode.SCROLLED_CONTINUOUS || l === sa.ContentDocumentFlowMode.SCROLLED_DOC;
                    }) && (a.h.u.style.height = ""), b = a.h.u, a.o.appendChild(b), a.B.style.height = "100%", a.B.style.width = "100%") : (a.B.style.width = g.width + "px", a.B.style.height = g.height + "px", a.U.width = g.width + "px", a.U.height = g.height + "px"), a.B.setAttribute("data-colibrio-iframe-scale-factor", "1"));
                    a.B.style.border = "none";
                    a.g.sf(a.B);
                }
                a.B.addEventListener("load", a, !1);
                b.setAttribute("role", "document");
                b.appendChild(a.B);
                a.Z.forEach(a.Yc);
                a.j = D.RenderableState.ATTACHED_TO_DOM;
            }
        }
        function Xh(a, b) {
            a.B && (a.j !== D.RenderableState.VISIBLE || b ? a.j === D.RenderableState.ATTACHED_TO_DOM && b && (a.j = D.RenderableState.VISIBLE, a.Ma && a.g.le(a.B)) : (a.j = D.RenderableState.ATTACHED_TO_DOM, a.Ba && (a.g.yg ? a.Ma && a.g.yg(a.B) : a.o && a.m === D.RenderableState.ATTACHED_TO_DOM && (Yh(a), $h(a)))));
        }
        function Zh(a, b) {
            if (0 === b.length) return b;
            var c = bi(a);
            1 !== c && (b = b.map(function(e) {
                return {
                    bottom: e.bottom * c,
                    height: e.height * c,
                    left: e.left * c,
                    right: e.right * c,
                    top: e.top * c,
                    width: e.width * c
                };
            }));
            if (a.h) {
                var d = a.h.i;
                b = b.map(function(e) {
                    return {
                        bottom: e.bottom + d.Pc,
                        height: e.height,
                        left: e.left + d.Te,
                        right: e.right + d.Te,
                        top: e.top + d.Pc,
                        width: e.width
                    };
                });
            }
            return b;
        }
        function Vh() {
            return {
                height: "100%",
                left: "0",
                position: "absolute",
                top: "0",
                width: "100%"
            };
        }
        function bi(a) {
            if (!a.B) throw new T(t.ColibrioErrorType.ABORTED);
            return (a = a.B.getAttribute("data-colibrio-iframe-scale-factor")) ? Number(a) : 1;
        }
        function Wh(a, b, c) {
            if (a.m !== b || a.A !== c) a.m = b, a.A = c, Ie(a.Sa, a, function(d) {
                t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logError(d);
            });
        }
        function ai(a, b) {
            var c = a.l.G;
            a = E.ReadingSystemUtils.getPageContainerIframeTitle(c.getReaderViewOptions(), a.H, c.getRenderer());
            null === a ? b.removeAttribute("title") : b.setAttribute("title", a);
        }
        var ci = {
            aliceblue: "#f0f8ff",
            antiquewhite: "#faebd7",
            aqua: "#00ffff",
            aquamarine: "#7fffd4",
            azure: "#f0ffff",
            beige: "#f5f5dc",
            bisque: "#ffe4c4",
            black: "#000000",
            blanchedalmond: "#ffebcd",
            blue: "#0000ff",
            blueviolet: "#8a2be2",
            brown: "#a52a2a",
            burlywood: "#deb887",
            cadetblue: "#5f9ea0",
            chartreuse: "#7fff00",
            chocolate: "#d2691e",
            coral: "#ff7f50",
            cornflowerblue: "#6495ed",
            cornsilk: "#fff8dc",
            crimson: "#dc143c",
            cyan: "#00ffff",
            darkblue: "#00008b",
            darkcyan: "#008b8b",
            darkgoldenrod: "#b8860b",
            darkgray: "#a9a9a9",
            darkgreen: "#006400",
            darkgrey: "#a9a9a9",
            darkkhaki: "#bdb76b",
            darkmagenta: "#8b008b",
            darkolivegreen: "#556b2f",
            darkorange: "#ff8c00",
            darkorchid: "#9932cc",
            darkred: "#8b0000",
            darksalmon: "#e9967a",
            darkseagreen: "#8fbc8f",
            darkslateblue: "#483d8b",
            darkslategray: "#2f4f4f",
            darkslategrey: "#2f4f4f",
            darkturquoise: "#00ced1",
            darkviolet: "#9400d3",
            deeppink: "#ff1493",
            deepskyblue: "#00bfff",
            dimgray: "#696969",
            dimgrey: "#696969",
            dodgerblue: "#1e90ff",
            firebrick: "#b22222",
            floralwhite: "#fffaf0",
            forestgreen: "#228b22",
            fuchsia: "#ff00ff",
            gainsboro: "#dcdcdc",
            ghostwhite: "#f8f8ff",
            gold: "#ffd700",
            goldenrod: "#daa520",
            gray: "#808080",
            green: "#008000",
            greenyellow: "#adff2f",
            grey: "#808080",
            honeydew: "#f0fff0",
            hotpink: "#ff69b4",
            indianred: "#cd5c5c",
            indigo: "#4b0082",
            ivory: "#fffff0",
            khaki: "#f0e68c",
            lavender: "#e6e6fa",
            lavenderblush: "#fff0f5",
            lawngreen: "#7cfc00",
            lemonchiffon: "#fffacd",
            lightblue: "#add8e6",
            lightcoral: "#f08080",
            lightcyan: "#e0ffff",
            lightgoldenrodyellow: "#fafad2",
            lightgray: "#d3d3d3",
            lightgreen: "#90ee90",
            lightgrey: "#d3d3d3",
            lightpink: "#ffb6c1",
            lightsalmon: "#ffa07a",
            lightseagreen: "#20b2aa",
            lightskyblue: "#87cefa",
            lightslategray: "#778899",
            lightslategrey: "#778899",
            lightsteelblue: "#b0c4de",
            lightyellow: "#ffffe0",
            lime: "#00ff00",
            limegreen: "#32cd32",
            linen: "#faf0e6",
            magenta: "#ff00ff",
            maroon: "#800000",
            mediumaquamarine: "#66cdaa",
            mediumblue: "#0000cd",
            mediumorchid: "#ba55d3",
            mediumpurple: "#9370db",
            mediumseagreen: "#3cb371",
            mediumslateblue: "#7b68ee",
            mediumspringgreen: "#00fa9a",
            mediumturquoise: "#48d1cc",
            mediumvioletred: "#c71585",
            midnightblue: "#191970",
            mintcream: "#f5fffa",
            mistyrose: "#ffe4e1",
            moccasin: "#ffe4b5",
            navajowhite: "#ffdead",
            navy: "#000080",
            oldlace: "#fdf5e6",
            olive: "#808000",
            olivedrab: "#6b8e23",
            orange: "#ffa500",
            orangered: "#ff4500",
            orchid: "#da70d6",
            palegoldenrod: "#eee8aa",
            palegreen: "#98fb98",
            paleturquoise: "#afeeee",
            palevioletred: "#db7093",
            papayawhip: "#ffefd5",
            peachpuff: "#ffdab9",
            peru: "#cd853f",
            pink: "#ffc0cb",
            plum: "#dda0dd",
            powderblue: "#b0e0e6",
            purple: "#800080",
            rebeccapurple: "#663399",
            red: "#ff0000",
            rosybrown: "#bc8f8f",
            royalblue: "#4169e1",
            saddlebrown: "#8b4513",
            salmon: "#fa8072",
            sandybrown: "#f4a460",
            seagreen: "#2e8b57",
            seashell: "#fff5ee",
            sienna: "#a0522d",
            silver: "#c0c0c0",
            skyblue: "#87ceeb",
            slateblue: "#6a5acd",
            slategray: "#708090",
            slategrey: "#708090",
            snow: "#fffafa",
            springgreen: "#00ff7f",
            steelblue: "#4682b4",
            tan: "#d2b48c",
            teal: "#008080",
            thistle: "#d8bfd8",
            tomato: "#ff6347",
            turquoise: "#40e0d0",
            violet: "#ee82ee",
            wheat: "#f5deb3",
            white: "#ffffff",
            whitesmoke: "#f5f5f5",
            yellow: "#ffff00",
            yellowgreen: "#9acd32"
        };
        function di() {
            this.alpha = 1;
            this.g = this.h = null;
        }
        function ei(a) {
            a = a.match(/^#?([a-f0-9]{8}|[a-f0-9]{6}|[a-f0-9]{3,4})$/i);
            if (!a || !a[1]) return null;
            var b = a[1];
            if (3 === b.length || 4 === b.length) b = b.split("").map(function(f) {
                return f + f;
            }).join("");
            var c = parseInt(b, 16), d = c >> 16 & 255, e = c >> 8 & 255;
            a = c & 255;
            8 === b.length ? (b = fi(c >> 24 & 255, d, e), b.alpha = La(a / 255, 0, 1)) : b = fi(d, e, a);
            return b;
        }
        function fi(a, b, c, d) {
            var e = new di;
            e.g = [
                La(a, 0, 255),
                La(b, 0, 255),
                La(c, 0, 255)
            ];
            e.h = null;
            K(d) && (e.alpha = La(d, 0, 1));
            return e;
        }
        function gi() {
            var a = new di;
            a.g = [
                0,
                0,
                0
            ];
            a.alpha = 0;
            return a;
        }
        di.prototype.clone = function() {
            var a = new di;
            a.alpha = this.alpha;
            this.g && (a.g = this.g.slice());
            this.h && (a.h = this.h.slice());
            return a;
        };
        di.prototype.toString = function() {
            var a = this.alpha;
            if (0 === a) a = "transparent";
            else if (this.g) {
                var b = hi(this.g).join(", ");
                a = 1 > a ? "rgba(" + b + ", " + a + ")" : "rgb(" + b + ")";
            } else b = hi(this.h), b = b[0] + ", " + b[1] + "%, " + b[2] + "%", a = 1 > a ? "hsla(" + b + ", " + a + ")" : "hsl(" + b + ")";
            return a;
        };
        function hi(a) {
            return a.map(function(b) {
                return Math.round(b);
            });
        }
        function ii(a, b) {
            return {
                J: a,
                ca: b
            };
        }
        function ji(a, b, c) {
            return {
                J: a,
                Re: c,
                ca: b
            };
        }
        function Z(a, b) {
            return {
                J: a,
                ca: b
            };
        }
        function ki(a, b) {
            return {
                gi: b,
                ji: a,
                J: 50
            };
        }
        fi(255, 255, 255);
        function li(a, b) {
            return b.some(function(c) {
                return c === a.J;
            });
        }
        function mi(a) {
            this.m = [];
            this.j = void 0;
            this.h = 0;
            this.g = a.replace(/\r\n|\r|\f/g, "\n");
        }
        function ni(a) {
            var b = a.h, c = a.g.charCodeAt(b++);
            if (isNaN(c)) c = String.fromCharCode(65533);
            else if (oi(c)) {
                for(var d = 1, e = 57 >= c ? c - 48 : 70 >= c ? c - 65 + 10 : c - 97 + 10; 6 > d++ && oi(c = a.g.charCodeAt(b));)e = e << 4 | (57 >= c ? c - 48 : 70 >= c ? c - 65 + 10 : c - 97 + 10), b++;
                pi(a.g.charCodeAt(b)) && b++;
                c = String.fromCodePoint(e);
            } else c = 55296 <= c && 56319 >= c ? String.fromCharCode(c, a.g.charCodeAt(b++)) : String.fromCharCode(c);
            a.h = b;
            return c;
        }
        function qi(a, b) {
            b = ri(a, b);
            if (40 === a.g.charCodeAt(a.h)) {
                a.h++;
                if (/^url$/i.test(b)) {
                    b = si(a);
                    if (isNaN(b)) b = ii(-1, "EOF");
                    else if (34 === b || 39 === b) {
                        if (a.h++, b = ti(a, b), -2 === b.J) ui(a), b = ii(-1, b.ca);
                        else {
                            for(var c; pi(c = a.g.charCodeAt(a.h));)a.h++;
                            41 === c || isNaN(c) ? (a.h++, a = !0) : (ui(a), a = !1);
                            a ? b = Z(5, b.ca) : b = ii(-1, "Unexpected end of URL");
                        }
                    } else b = vi(a);
                    a = b;
                } else a = Z(1, b);
                return a;
            }
            return Z(0, b);
        }
        function ri(a, b) {
            for(var c = "", d = a.h;;){
                var e = a.g.charCodeAt(d);
                if (wi(e) || xi(e) || 45 === e) d++;
                else if (92 === e && 92 === e && 10 !== a.g.charCodeAt(d + 1)) c += a.g.substring(b, d++), a.h = d, c += ni(a), d = b = a.h;
                else return a.h = d, c ? c + a.g.substring(b, d) : a.g.substring(b, d);
            }
        }
        function yi(a, b, c, d) {
            for(var e = a.h, f; xi(c = a.g.charCodeAt(e));)e++;
            if (!d && 46 === c && xi(a.g.charCodeAt(e + 1))) for(e += 2; xi(c = a.g.charCodeAt(e));)e++;
            if (69 === c || 101 === c) {
                if (c = a.g.charCodeAt(e + 1), 45 !== c && 43 !== c || !xi(a.g.charCodeAt(e + 2)) ? xi(c) && (e += 2, f = !0) : (e += 3, f = !0), f) for(; xi(a.g.charCodeAt(e));)e++;
            }
            a.h = e;
            b = Number(a.g.substring(b, e));
            d = a.h;
            c = a.g.charCodeAt(d);
            return zi(c, a.g.charCodeAt(d + 1), a.g.charCodeAt(d + 2)) ? ji(42, b, ri(a, d)) : 37 === c ? (a.h++, ji(41, b, "%")) : ji(40, b, "");
        }
        function ui(a) {
            for(var b; (b = a.g.charCodeAt(a.h++)) && (41 !== b || isNaN(b));)92 === b && 10 !== a.g.charCodeAt(a.h) && ni(a);
        }
        function ti(a, b) {
            for(var c, d = c = a.h, e, f = "", g; !e;)g = a.g.charCodeAt(c++), g === b || isNaN(g) ? e = Z(4, f + a.g.substring(d, c - 1)) : 10 === g ? (e = ii(-2, f + a.g.substring(d, c - 1)), c--) : 92 === g && (g = a.g.charCodeAt(c), isNaN(g) ? e = Z(4, f + a.g.substring(d, c - 1)) : (f += a.g.substring(d, c - 1), 10 === g ? c++ : (a.h = c, f += ni(a), c = a.h), d = c));
            a.h = c;
            return e;
        }
        function si(a) {
            for(var b; pi(b = a.g.charCodeAt(a.h));)a.h++;
            return b;
        }
        function vi(a) {
            for(var b, c = "", d = a.h, e;;){
                e = a.g.charCodeAt(a.h++);
                if (41 === e || isNaN(e)) return Z(5, c + a.g.substring(d, a.h - 1));
                if (pi(e)) {
                    b = a.h - 1;
                    e = si(a);
                    if (41 === e || isNaN(e)) return a.h++, Z(5, c + a.g.substring(d, b));
                    ui(a);
                    return ii(-1, c + a.g.substring(d, a.h));
                }
                if (34 === e || 39 === e || 40 === e) return ui(a), ii(-1, c + a.g.substring(d, a.h));
                92 === e && (e = a.g.charCodeAt(a.h), 10 !== e ? (c += a.g.substring(d, a.h - 1), c += ni(a), d = a.h) : ui(a));
            }
        }
        k = mi.prototype;
        k.getNextTokenHigh = function(a, b) {
            117 === b ? a = Ai(this, a) : wi(b) ? a = qi(this, a) : 91 === b ? a = {
                J: 32
            } : 92 === b ? 10 !== this.g.charCodeAt(a + 1) ? (this.h--, a = qi(this, a)) : a = Z(11, "\\") : 93 === b ? a = Z(35, "]") : 94 === b ? 61 === this.g.charCodeAt(a + 1) ? (this.h++, a = Z(14, "^=")) : a = Z(11, "^") : 123 === b ? a = {
                J: 30
            } : 125 === b ? a = Z(33, "}") : 124 === b ? (a = this.g.charCodeAt(a + 1), 61 === a ? (this.h++, a = Z(13, "|=")) : 124 === a ? (this.h++, a = Z(17, "||")) : a = Z(11, "|")) : 126 === b ? 61 === this.g.charCodeAt(a + 1) ? (this.h++, a = Z(12, "~=")) : a = Z(11, "~") : isNaN(b) ? a = void 0 : (55296 <= b && 56319 >= b ? (a = String.fromCharCode(b, this.g.charCodeAt(a + 1)), this.h++) : a = String.fromCharCode(b), a = Z(11, a));
            return a;
        };
        k.getNextTokenLow = function(a, b) {
            switch(b){
                case 9:
                case 10:
                case 32:
                    for(a = this.h; pi(this.g.charCodeAt(a));)a++;
                    this.h = a;
                    return Z(10, " ");
                case 34:
                    return ti(this, 34);
                case 35:
                    b = this.g.charCodeAt(a + 1);
                    var c = this.g.charCodeAt(a + 2);
                    return wi(b) || xi(b) || 45 === b || 92 === b && 10 !== c ? Z(3, ri(this, a + 1)) : Z(11, "#");
                case 36:
                    return 61 === this.g.charCodeAt(a + 1) ? (this.h++, a = Z(15, "$=")) : a = Z(11, "$"), a;
                case 39:
                    return ti(this, 39);
                case 40:
                    return {
                        J: 31
                    };
                case 41:
                    return Z(34, ")");
                case 42:
                    return 61 === this.g.charCodeAt(a + 1) ? (this.h++, a = Z(16, "*=")) : a = Z(11, "*"), a;
                case 43:
                    return Bi(b, this.g.charCodeAt(a + 1), this.g.charCodeAt(a + 2)) ? yi(this, a, b, !1) : Z(11, "+");
                case 44:
                    return Z(22, ",");
                case 45:
                    c = this.g.charCodeAt(a + 1);
                    var d = this.g.charCodeAt(a + 2);
                    Bi(b, c, d) ? a = yi(this, a, b, !1) : 45 === c && 62 === d ? (this.h += 2, a = Z(19, "-->")) : a = zi(b, c, d) ? qi(this, a) : Z(11, "-");
                    return a;
                case 46:
                    return xi(this.g.charCodeAt(a + 1)) ? yi(this, a, b, !0) : Z(11, ".");
                case 47:
                    if (42 === this.g.charCodeAt(a + 1)) {
                        this.h++;
                        a = this.h;
                        b = this.g.charCodeAt(a++);
                        for(c = this.g.charCodeAt(a++); !isNaN(b) && (42 !== b || 47 !== c);)b = c, c = this.g.charCodeAt(a++);
                        this.h = a;
                        a = this.next();
                    } else a = Z(11, "/");
                    return a;
            }
            return isNaN(b) ? void 0 : Z(11, String.fromCharCode(b));
        };
        k.getNextTokenMid = function(a, b) {
            57 >= b ? a = yi(this, a, b, !1) : 58 === b ? a = Z(20, ":") : 59 === b ? a = Z(21, ";") : 60 === b ? 33 === this.g.charCodeAt(a + 1) && 45 === this.g.charCodeAt(a + 2) && 45 === this.g.charCodeAt(a + 3) ? (this.h += 3, a = Z(18, "<!--")) : a = Z(11, "<") : a = 64 === b ? zi(this.g.charCodeAt(a + 1), this.g.charCodeAt(a + 2), this.g.charCodeAt(a + 3)) ? Z(2, ri(this, a + 1)) : Z(11, "@") : 85 === b ? Ai(this, a) : wi(b) ? qi(this, a) : isNaN(b) ? void 0 : Z(11, String.fromCharCode(b));
            return a;
        };
        function Ai(a, b) {
            var c = a.g.charCodeAt(b + 2);
            if (43 === a.g.charCodeAt(b + 1) && (34 === c || xi(c))) {
                a.h++;
                b = c = a.h;
                for(var d = 0, e, f = !1, g; 6 > d && oi(e = a.g.charCodeAt(b));)b++, d++;
                if (6 > d && 63 === e) for(b++, d++, f = !0; 6 > d && 63 === a.g.charCodeAt(b);)d++, b++;
                g = a.g.substring(c, b);
                if (f) c = ki(parseInt(g.replace(/\?/g, "0"), 16), parseInt(g.replace(/\?/g, "F"), 16));
                else if (45 === a.g.charCodeAt(b) && oi(a.g.charCodeAt(b + 1))) {
                    c = b + 1;
                    b += 2;
                    for(d = 1; 6 > d && oi(a.g.charCodeAt(b));)b++, d++;
                    c = ki(parseInt(g, 16), parseInt(a.g.substring(c, b), 16));
                } else c = ki(e = parseInt(g, 16), e);
                a.h = b;
                return c;
            }
            return qi(a, b);
        }
        k.next = function() {
            if (void 0 !== this.j) {
                var a = this.j;
                this.j = void 0;
                return a;
            }
            return Ci(this);
        };
        k.peek = function() {
            void 0 === this.j && (this.j = Ci(this));
            return this.j;
        };
        function Ci(a) {
            var b = a.h++, c = a.g.charCodeAt(b);
            return (b = 48 > c ? a.getNextTokenLow(b, c) : 91 > c ? a.getNextTokenMid(b, c) : a.getNextTokenHigh(b, c)) && 0 > b.J ? (a.m.push(b), a.next()) : b;
        }
        function pi(a) {
            return 9 === a || 32 === a || 10 === a;
        }
        function xi(a) {
            return 48 <= a && 57 >= a;
        }
        function oi(a) {
            return 48 <= a && 57 >= a || 65 <= a && 70 >= a || 97 <= a && 102 >= a;
        }
        function wi(a) {
            return 65 <= a && 90 >= a || 97 <= a && 122 >= a || 128 <= a || 95 === a;
        }
        function Bi(a, b, c) {
            return 43 === a || 45 === a ? xi(b) || 46 === b && xi(c) : xi(a) || 46 === a && xi(b);
        }
        function zi(a, b, c) {
            return 45 === a ? wi(b) || 45 === b || 92 === b && 10 !== c : wi(a) || 92 === a && 10 !== b;
        }
        function Di(a) {
            this.g = new mi(a);
        }
        function Ei(a) {
            var b = new Di(a), c;
            for(a = []; (c = b.g.next()) && 34 !== c.J && 35 !== c.J && 33 !== c.J;)a.push(Fi(b, b.g, c));
            if (0 === a.length) return null;
            c = gi();
            a: {
                b = a[0];
                var d;
                if (80 === b.J) {
                    a = [];
                    for(var e = 0; e < b.ca.length; e++){
                        var f = b.ca[e], g = f.J;
                        40 !== g && 41 !== g && 42 !== g || a.push(f);
                    }
                    var h;
                    3 < a.length && (e = a[3], 40 === e.J ? h = e.ca : 41 === e.J && (h = e.ca / 100));
                    if ("rgb" === b.Yd || "rgba" === b.Yd) {
                        b = [
                            40,
                            41
                        ];
                        if (3 > a.length || !li(a[0], b) || !li(a[1], b) || !li(a[2], b)) a = null;
                        else {
                            b = [];
                            b.length = 3;
                            for(e = 0; 3 > e; e++)f = a[e], b[e] = 40 === f.J ? f.ca : 255 * f.ca / 100;
                            a = b;
                        }
                        a && (d = fi(a[0], a[1], a[2], h));
                    } else if ("hsl" === b.Yd || "hsla" === b.Yd) 3 > a.length || !li(a[0], [
                        40,
                        42
                    ]) || !li(a[1], [
                        40,
                        41
                    ]) || !li(a[2], [
                        40,
                        41
                    ]) ? a = null : (b = [], b.length = 3, e = a[0], b[0] = 40 === e.J ? e.ca : 42 === e.J ? "grad" === e.Re ? 360 * e.ca / 400 : "rad" === e.Re ? 360 * e.ca / (2 * Math.PI) : "turn" === e.Re ? 360 * e.ca : e.ca : 360 * e.ca / 100, b[1] = 40 === a[1].J ? 100 * a[1].ca : a[1].ca, b[2] = 40 === a[2].J ? 100 * a[2].ca : a[2].ca, a = b), a && (d = h, h = new di, b = a[0], b %= 360, 0 > b && (b += 360), h.h = [
                        b,
                        La(a[1], 0, 100),
                        La(a[2], 0, 100)
                    ], h.g = null, K(d) && (h.alpha = La(d, 0, 1)), d = h);
                } else if (3 === b.J) (h = ei(b.ca)) && (d = h);
                else if (0 === b.J) {
                    d = b.ca.toLowerCase();
                    if ("inherit" === d || "unset" === d) {
                        c = null;
                        break a;
                    }
                    "initial" === d || "revert" === d ? d = c.clone() : (d = d.toLowerCase(), d = (ci.hasOwnProperty(d) ? ei(ci[d]) : "transparent" === d ? gi() : null) || c);
                }
                d || (d = c.clone());
                c = d;
            }
            return c;
        }
        function Fi(a, b, c) {
            var d = c.J;
            if (30 === d || 31 === d || 32 === d) {
                var e, f = c.J + 3;
                for(d = []; (e = b.next()) && e.J !== f;)d.push(Fi(a, b, e));
                a = {
                    J: c.J + 30,
                    ca: d
                };
            } else if (1 === d) {
                for(e = []; (f = b.next()) && 34 !== f.J;)e.push(Fi(a, b, f));
                a = {
                    Yd: c.ca.toLowerCase(),
                    J: 80,
                    ca: e
                };
            } else a = c;
            return a;
        }
        function Gi() {
            this.Lf = !0;
            this.Nf = "transparent";
            this.de = !1;
        }
        Gi.prototype.sa = function(a, b) {
            if (!this.de && !lb(b)) {
                var c = N(a), d = c.backgroundColor;
                var e = c.backgroundColor;
                if ("none" !== c.backgroundImage) e = !1;
                else if ("transparent" === e || "inherit" === e) e = !0;
                else {
                    var f, g;
                    e = null != (g = null == (f = Ei(e)) ? void 0 : 0 === f.alpha) ? g : !1;
                }
                f = e;
                g = !f && d !== this.Nf && Hi(c);
                if (b = "html" === b || "body" === b && (!g || this.Lf) || "body" !== b && !g) this.Nf = d, this.Lf = f;
                if (b) {
                    if (Hi(c) && I(a) && (Q(a, "margin-left", "0"), Q(a, "margin-right", "0")), d = parseFloat(c.borderRightWidth), 0 < parseFloat(c.borderLeftWidth) || 0 < d) this.de = !0;
                    else {
                        d = parseFloat(c.paddingRight);
                        0 === parseFloat(c.paddingLeft) && 0 === d || !I(a) || (Q(a, "padding-left", "0"), Q(a, "padding-right", "0"));
                        a: {
                            c = a.childNodes;
                            for(d = 0; d < c.length; d++)if (Ja(c[d])) {
                                c = !1;
                                break a;
                            }
                            c = !0;
                        }
                        a: {
                            a = a.childNodes;
                            for(b = d = 0; b < a.length; b++)if (f = a[b], I(f) && !lb(f.localName) && d++, 1 < d) {
                                a = !1;
                                break a;
                            }
                            a = 1 === d;
                        }
                        a && c || (this.de = !0);
                    }
                } else this.de = !0;
            }
        };
        function Hi(a) {
            var b = parseFloat(a.marginRight);
            return 0 !== parseFloat(a.marginLeft) || 0 !== b;
        }
        function Ii(a) {
            for(var b = []; a.parentElement;){
                a = a.parentElement;
                for(var c = 0, d = 0; d < a.childNodes.length; d++){
                    var e = a.childNodes[d];
                    (H(e) || Ja(e)) && c++;
                }
                d = void 0;
                if (1 < c || a === (null == (d = a.ownerDocument) ? void 0 : d.documentElement)) break;
                c = window.getComputedStyle(a);
                "auto" !== c.height && b.push(a);
                c = c.position;
                if ("static" !== c && "relative" !== c) break;
            }
            return b;
        }
        function Ji(a, b) {
            return "math" === b ? !0 : N(a).display.includes("math");
        }
        function Ki(a) {
            var b = a.parentElement;
            if (!b) return !1;
            a = 0;
            b = b.childNodes;
            for(var c = 0; c < b.length; c++){
                var d = b[c];
                if (Ja(d) || H(d)) {
                    if (a++, 2 <= a) return !1;
                }
            }
            return !0;
        }
        function Li(a, b, c) {
            var d = !1, e = Ii(a);
            0 === e.length && (d = !0);
            var f = e.map(function(m) {
                return window.getComputedStyle(m);
            }), g = f.map(function(m) {
                return parseFloat(m.height);
            });
            g.every(function(m) {
                return m < b;
            }) && (d = !0);
            Ka(c) ? Q(a, "height", "auto") : Q(a, "height", b - c + "px");
            if (!d && !f.map(function(m) {
                return parseFloat(m.height);
            }).map(function(m, n) {
                return [
                    m,
                    g[n]
                ];
            }).every(function(m) {
                return m[0] < m[1];
            })) for(a = 0; a < e.length; a++){
                d = e[a];
                var h = g[a], l = parseFloat(f[a].height);
                if (!isNaN(l) && !isNaN(h) && l === h) {
                    Ka(c) ? Q(d, "height", "auto") : Q(d, "height", h - c + "px");
                    Q(d, "width", "auto");
                    d = !0;
                    for(h = a + 1; h < e.length; h++)parseFloat(f[h].height) === g[h] && (d = !1);
                    if (d) break;
                }
            }
        }
        function Mi(a, b, c, d, e) {
            this.xh = c;
            this.Of = d;
            this.bh = e;
            this.qb = null;
            this.Wb = this.ae = this.uc = 0;
            this.Qf = a * b;
        }
        Mi.prototype.sa = function(a, b, c, d) {
            var e;
            if (e = !this.qb) {
                if (e = a !== d.documentElement) {
                    e = a.parentNode;
                    for(var f = !0; f && e && I(e);)f = e, f = "visible" === N(f).overflowX || f.scrollWidth === f.clientWidth, e = e.parentNode;
                    e = f && !lb(b);
                }
            }
            if (e) {
                if (this.isOverflowing(a)) {
                    e = N(a);
                    f = "pre" === e.whiteSpace || "nowrap" === e.whiteSpace;
                    var g = "visible" === e.overflowX;
                    if ("block" === e.display && f && g && I(a)) {
                        this.qb = a;
                        Ni(this, a) && Oi(a);
                        return;
                    }
                    if (Ji(a, b)) {
                        this.qb = a;
                        b = a.scrollWidth - a.clientWidth;
                        e = N(a);
                        Q(a, "width", parseFloat(e.width) + b + "px");
                        "SCROLL" === this.Of ? Ni(this, a) && Pi(a, c, d) : Qi(this, a);
                        return;
                    }
                }
                Ri(this, a) ? (e = N(a).position, "absolute" === e || "fixed" === e ? I(a) && (this.qb = a, Qi(this, a)) : mf(a) ? I(a) && (this.qb = a, Si(this, a)) : Fa(a) ? (this.qb = a, d = N(a), c = parseInt(d.width), d = parseInt(d.height), a.getAttribute("viewBox") || a.setAttribute("viewBox", "0 0 " + c + " " + d), Si(this, a)) : (b = Ji(a, b), e = N(a).display, e = "table" === e || "inline-table" === e, b || e ? (this.qb = a, e && I(a) && Q(a, "width", "auto"), Ri(this, a) && (b && "SCROLL" === this.Of || e && "SCROLL" === this.xh ? Pi(a, c, d) : Qi(this, a))) : "inline" !== N(a).display && I(a) && (Q(a, "width", "auto"), Q(a, "height", "auto"), a.setAttribute("data-colibrio-pending-down-scale", "true")))) : (Fa(a) && (this.qb = a), Ji(a, b) && (this.qb = a));
            }
        };
        Mi.prototype.ia = function(a, b, c, d) {
            if (a === this.qb) this.qb = null;
            else if (!this.qb && a !== d.documentElement && !lb(b)) {
                if (this.isOverflowing(a) && I(a) && "visible" === N(a).overflowX) {
                    for(b = a; b.firstElementChild && Ki(b.firstElementChild) && I(b.firstElementChild);)b = b.firstElementChild;
                    c = N(b).fontSize;
                    a: {
                        if (c && (c = parseFloat(c), !isNaN(c) && (d = a.clientWidth / a.scrollWidth * c - .1, d < this.Qf && (d = Math.min(this.Qf, c)), d < c))) {
                            c = d;
                            break a;
                        }
                        c = void 0;
                    }
                    c && Q(b, "font-size", c + "px");
                    Q(a, "overflow-wrap", "break-word");
                    this.isOverflowing(a) && I(a) && Ni(this, a) && Oi(a);
                } else if ((I(a) || Ji(a, b)) && Ri(this, a) && "true" === a.getAttribute("data-colibrio-pending-down-scale")) {
                    a.removeAttribute("data-colibrio-pending-down-scale");
                    b = a.getBoundingClientRect();
                    c = N(a);
                    d = parseFloat(c.marginRight);
                    var e = !1;
                    0 > parseFloat(c.marginLeft) && b.left < this.uc && (Q(a, "margin-left", "0"), e = !0);
                    0 > d && b.right > this.Wb && (Q(a, "margin-right", "0"), e = !0);
                    e && !Ri(this, a) || Qi(this, a);
                }
            }
        };
        Mi.prototype.init = function(a) {
            var b = a.documentElement.getBoundingClientRect().width / a.documentElement.offsetWidth;
            this.ae = a.defaultView.innerWidth * b;
            a = N(a.documentElement);
            a = parseFloat(a.marginLeft);
            isNaN(a) && (a = 0);
            this.uc = a * b;
            this.Wb = this.ae - this.uc;
        };
        function Pi(a, b, c) {
            if (a.parentElement) {
                if (Ki(a) && a.parentElement !== a.ownerDocument.body) Q(a.parentElement, "overflow-x", "auto");
                else {
                    c = c.createElement("x-colibrio-scroll-container");
                    c.style.display = "block";
                    c.style.width = "auto";
                    c.style.height = "auto";
                    var d = a.parentElement;
                    d && (d.insertBefore(c, a), c.appendChild(a), kc(b.Ra, 8, c));
                    Q(c, "overflow-x", "auto");
                }
            }
        }
        function Oi(a) {
            Q(a, "overflow-x", "auto");
            Q(a, "width", "auto");
        }
        function Si(a, b) {
            var c = N(b);
            c = parseInt(c.width);
            var d = b.getBoundingClientRect();
            d.left > a.Wb || d.right < a.uc || d.left + d.width > a.Wb && Ti(b, c, c - ((a.Wb - d.left) / (d.width / c) | 0));
        }
        function Qi(a, b) {
            var c = b.getBoundingClientRect(), d = parseInt(N(b).width) / c.width, e = (a.uc - c.left) * d;
            d *= a.Wb - c.right;
            if (c.width <= a.ae) {
                var f = 0;
                c.right > a.Wb ? f = d : c.left < a.uc && (f = e);
                0 !== f && Q(b, "transform", "translateX(" + f + "px)");
            } else a = a.ae / c.width, e = Ra(e, 0) ? "scale(" + a + ")" : "translateX(" + e + "px) scale(" + a + ")", Q(b, "transform-origin", "left center"), Q(b, "transform", e);
        }
        Mi.prototype.isOverflowing = function(a) {
            var b = 0 < a.clientWidth && a.scrollWidth > a.clientWidth;
            if (this.bh && b && a === a.ownerDocument.body) {
                var c = N(a);
                b = parseFloat(c.marginLeft);
                c = parseFloat(c.marginRight);
                if (!K(b) || 0 > b) b = 0;
                if (!K(c) || 0 > c) c = 0;
                a = a.scrollWidth - b - c > a.clientWidth;
            } else a = b;
            return a;
        };
        function Ri(a, b) {
            b = b.getBoundingClientRect();
            return 0 < b.height && 0 < b.width && (b.left < a.uc || b.right > a.Wb);
        }
        function Ni(a, b) {
            if ("visible" !== N(b).overflowX) return !1;
            var c = b.getBoundingClientRect();
            return c.left + c.width / b.clientWidth * b.scrollWidth > a.Wb + 1;
        }
        function Ti(a, b, c) {
            var d = !1, e = Ii(a);
            0 === e.length && (d = !0);
            var f = e.map(function(m) {
                return N(m);
            }), g = f.map(function(m) {
                return parseFloat(m.width);
            });
            g.every(function(m) {
                return m < b;
            }) && (d = !0);
            Q(a, "width", b - c + "px");
            Q(a, "height", "auto");
            if (!d && !f.map(function(m) {
                return parseFloat(m.width);
            }).map(function(m, n) {
                return [
                    m,
                    g[n]
                ];
            }).every(function(m) {
                return m[0] < m[1];
            })) for(a = 0; a < e.length; a++){
                d = e[a];
                var h = g[a], l = parseFloat(f[a].width);
                if (!isNaN(l) && !isNaN(h) && l >= h && h >= b) {
                    Q(d, "width", h - c + "px");
                    Q(d, "height", "auto");
                    d = !0;
                    for(h = a + 1; h < e.length; h++)parseFloat(f[h].width) === g[h] && (d = !1);
                    if (d) break;
                }
            }
        }
        function Ui() {}
        Ui.prototype.ia = function(a) {
            if (I(a) && a.scrollWidth > a.clientWidth + 1) {
                var b = N(a);
                if ("block" === b.display && "visible" === b.overflowX && "static" === b.position) {
                    var c = parseFloat(b.marginLeft) || 0;
                    b = parseFloat(b.marginRight) || 0;
                    var d = c + b;
                    if (0 < d) {
                        var e = a.style.getPropertyValue("position"), f = a.style.getPropertyPriority("position");
                        Q(a, "position", "absolute");
                        var g = a.clientWidth;
                        a.style.setProperty("position", e, f);
                        Q(a, "margin-left", "0");
                        Q(a, "margin-right", "0");
                        e = a.clientWidth - g - 1;
                        0 < e && (Q(a, "margin-left", Sa(c, 0, d, 0, e) + "px"), Q(a, "margin-right", Sa(b, 0, d, 0, e) + "px"));
                    }
                }
            }
        };
        function Vi() {}
        Vi.prototype.sa = function(a, b, c, d) {
            "img" === b && (c = d.defaultView.getComputedStyle(a), b = parseFloat(c.width), c = parseFloat(c.height), 0 < a.naturalWidth && 0 < a.naturalHeight && .03 < Math.abs(b / c - a.naturalWidth / a.naturalHeight) && Li(a, c));
        };
        function Wi() {
            R.apply(this, arguments);
        }
        q.inherits(Wi, R);
        Wi.prototype.m = function(a) {
            var b = this.g, c = 0;
            if (this.j && b.lastChild && (Qa(a) ? a(b) : a)) {
                for(; b.lastChild && (Qa(a) ? a(b) : a);)b = b.lastChild, c++;
                this.g = b;
            } else if (b !== this.aa && b.previousSibling) {
                for(b = b.previousSibling; b.lastChild && (Qa(a) ? a(b) : a);)b = b.lastChild, c++;
                this.g = b;
            } else b !== this.aa && b.parentNode ? (this.g = b.parentNode, c = -1) : this.g = null;
            return c;
        };
        Wi.prototype.next = function(a) {
            S(this, a);
            return this.g;
        };
        function Xi(a, b, c) {
            c = void 0 === c ? null : c;
            var d = Yi(a), e = a;
            d ? Zi(d) || (e = $i(d)) : e = $i(a.s, {
                tf: !0
            });
            if (null === e) return null;
            a = Yi(e);
            if (null === a) return null;
            if (aj(a)) return bj(a);
            if (H(a)) return a;
            for(J(a) && H(e.s) && (e = {
                s: a,
                i: 0
            }); e.i < a.data.length && Ia(a.data[e.i]);)e.i++;
            if (e.i === a.data.length) return Xi(e, b);
            e.i = cj(a, e.i, {
                direction: "backward",
                granularity: b,
                publicationLanguage: c
            });
            var f;
            return Ia(a.data.slice(0, e.i)) && (null == (f = a.parentElement) ? void 0 : f.firstChild) === a && H(d) ? a.parentElement : {
                i: e.i,
                Ne: e.s
            };
        }
        function dj(a) {
            var b = Yi(a), c = a;
            b ? Zi(b) || (c = $i(b)) : c = $i(a.s, {
                tf: !0
            });
            a = c ? Yi(c) : null;
            if (null === a) return null;
            if (aj(a)) return bj(a);
            if (H(a)) return a;
            var d;
            if ((null == (d = a.parentElement) ? void 0 : d.firstChild) === a) return a.parentElement;
            d = new Wi(a);
            d.aa = a.parentElement;
            S(d, !0);
            for(b = null; null === b && d.g;)Zi(d.g) && (b = d.g), S(d, !0);
            d = b;
            return null === d ? a.parentElement : J(d) ? d.parentElement : d;
        }
        function cj(a, b, c) {
            var d = a.data, e = c.granularity, f = "sentence" === e ? d.replace(/\s/g, " ") : d;
            if ("undefined" !== typeof Intl && "function" === typeof Intl.Segmenter) {
                d = fb(a);
                if (!d) {
                    var g;
                    d = null != (g = c.publicationLanguage) ? g : void 0;
                }
                d = new Intl.Segmenter(d, {
                    granularity: e
                }).segment(f).containing(b);
                b = d.index;
                d = d.index + d.segment.length;
                return "forward" === c.direction ? d : b;
            }
            if ("grapheme" === e) return d = d.charCodeAt(b), 56320 <= d && 57343 >= d ? "forward" === c.direction ? b + 1 : b - 1 : 55296 <= d && 56319 >= d ? "forward" === c.direction ? b + 2 : b : "forward" === c.direction ? b + 1 : b;
            if ("backward" === c.direction) for(; 0 < b && Ga(d[b - 1]);)b--;
            else for(; b < d.length && Ga(d[b]);)b++;
            return b;
        }
        function Yi(a) {
            return H(a.s) ? a.i < a.s.childNodes.length ? a.s.childNodes[a.i] : null : J(a.s) && a.i < a.s.data.length ? a.s : null;
        }
        function $i(a, b) {
            b = void 0 === b ? {
                tf: !1
            } : b;
            a = new R(a);
            a.aa = null;
            b.tf && S(a, !1);
            for(b = null; null === b && a.g;)Zi(a.g) && (b = a.g), S(a, !0);
            if (!b) return null;
            a = b.ownerDocument;
            if (!a) throw new U("Failed to get document for focusableNode");
            a = M(a);
            b = bc(b);
            if (!b) throw new U("Failed to get domPosition for focusableNode");
            return dc(b, a);
        }
        function Zi(a) {
            var b = H(a) && a.hasAttribute("aria-hidden") ? "true" === a.getAttribute("aria-hidden") : !1;
            if (H(a) && kb(a) && !b) {
                if (!(b = mb(a) || ob(a) || nb(a) || Fa(a))) {
                    b = a.getAttribute("role");
                    var c = !1;
                    b && (c = ej.has(b));
                    b = c;
                }
                b = b || a.hasAttribute("tabindex");
            } else b = !1;
            return b || !!(Ja(a) && H(a.parentElement) && kb(a.parentElement));
        }
        function aj(a) {
            return J(a) ? H(a.parentElement) && !I(a.parentElement) : H(a) && !I(a);
        }
        function bj(a) {
            for(var b = null; !b && a.parentNode;)I(a.parentNode) && (b = a), a = a.parentNode;
            return b;
        }
        var ej = new Set("grid treegrid tree listbox combobox tablist menu menubar radiogroup toolbar button link checkbox switch radio slider spinbutton textbox searchbox".split(" "));
        function fj(a) {
            this.Og = a;
        }
        fj.prototype.hb = function() {
            var a = this.Og.ownerDocument;
            a && a.activeElement && Qa(a.activeElement.blur) && a.activeElement.blur();
        };
        fj.prototype.eb = function() {};
        fj.prototype.ib = function() {};
        function gj() {}
        gj.prototype.va = function(a) {
            return new fj(a);
        };
        gj.prototype.wa = function(a, b, c) {
            return a === c.body;
        };
        gj.prototype.xa = function() {
            return !0;
        };
        function hj(a, b) {
            this.ga = a;
            this.bd = b;
        }
        hj.prototype.eb = function() {
            var a = this.ga.defaultView;
            if (a) {
                var b = a.getComputedStyle(this.ga.documentElement).backgroundColor;
                if (b = ij(b)) this.bd(b.toString());
                else {
                    b = M(this.ga);
                    if (this.ga.documentElement !== b && (a = a.getComputedStyle(b).backgroundColor, a = ij(a))) {
                        this.bd(a.toString());
                        return;
                    }
                    this.bd("#fff");
                }
            }
        };
        function ij(a) {
            return (a = Ei(a)) && 0 !== a.alpha ? (a.alpha = La(1, 0, 1), a) : null;
        }
        function jj(a) {
            this.bd = a;
        }
        jj.prototype.va = function(a) {
            return new hj(a.ownerDocument, this.bd);
        };
        jj.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        jj.prototype.xa = function() {
            return !0;
        };
        function kj(a) {
            this.u = a;
        }
        kj.prototype.eb = function() {
            var a = N(this.u), b = this.u.ownerDocument.documentElement, c = b.scrollHeight;
            Q(this.u, "display", "inline");
            b.scrollHeight <= c || (Q(this.u, "display", "block"), b = a.getPropertyValue("object-fit"), c = "fill" !== b && "contain" !== b || "left" === a.textAlign || "start" === a.textAlign || "justify" === a.textAlign ? "auto" : "100%", Q(this.u, "height", a.height), Q(this.u, "width", c), "fill" === b && (Q(this.u, "object-fit", "contain"), a = a.textAlign, "center" === a ? Q(this.u, "object-position", "center") : "right" === a ? Q(this.u, "object-position", "right") : Q(this.u, "object-position", "left")));
        };
        function lj() {}
        lj.prototype.va = function(a) {
            return new kj(a);
        };
        lj.prototype.wa = function(a) {
            return a.hasAttribute("data-colibrio-blockified") && I(a);
        };
        lj.prototype.xa = function() {
            return !1;
        };
        function mj(a, b, c) {
            var d = [];
            d = void 0 === d ? [] : d;
            this.j = a;
            this.m = b;
            this.o = c;
            this.g = d;
            this.h = "";
        }
        mj.prototype.compareTo = function(a) {
            var b = this.j - a.j;
            if (0 !== b) return b;
            b = this.m - a.m;
            if (0 !== b) return b;
            b = this.o - a.o;
            if (0 !== b) return b;
            b = this.g.length;
            var c = a.g.length;
            if (0 === b && 0 < c) return 1;
            if (0 < b && 0 === c) return -1;
            for(var d = Math.min(b, c), e = 0; e < d; e++){
                var f = this.g[e], g = a.g[e], h = K(f), l = K(g);
                if (h && !l) return -1;
                if (!h && l) return 1;
                if (f < g) return -1;
                if (f > g) return 1;
            }
            return b - c;
        };
        mj.prototype.toString = function() {
            return this.j + "." + this.m + "." + this.o + (0 < this.g.length ? "-" + this.g.join(".") : "") + (this.h ? "+" + this.h : "");
        };
        function nj(a, b, c, d) {
            this.m = a;
            this.g = b;
            this.tb = c;
            this.W = d;
            this.j = "";
            this.Na = this.h = null;
            this.Ab = 0;
            this.o = null;
        }
        function oj(a, b, c) {
            var d = "";
            switch(a.localName){
                case "img":
                case "image":
                    d = y.MediaTypeCategory.IMAGE;
                    break;
                case "audio":
                    d = y.MediaTypeCategory.AUDIO;
                    break;
                case "video":
                    d = y.MediaTypeCategory.VIDEO;
            }
            if (d) {
                if (a.hasAttribute("data-colibrio-media-sources")) {
                    if (a = JSON.parse(a.getAttribute("data-colibrio-media-sources")), 0 < a.length) return new nj(d, a[0], b, c);
                } else if (a.hasAttribute("data-colibrio-image-src")) return a = JSON.parse(a.getAttribute("data-colibrio-image-src")), new nj(d, a, b, c);
            }
            return null;
        }
        k = nj.prototype;
        k.createUrl = function() {
            if (this.g.isDataUrl) return Promise.resolve(this.g.src);
            if (this.g.remote) {
                var a = pj(this, this.g.src);
                return a ? Promise.resolve(a) : Promise.reject("Failed to create URL");
            }
            return qj(this);
        };
        k.getMediaTypeCategory = function() {
            return this.m;
        };
        k.getResourceUrl = function() {
            if (this.g.isDataUrl) return this.g.src;
            this.o || (this.o = pj(this, this.g.src));
            return this.o;
        };
        k.isDataUrl = function() {
            return this.g.isDataUrl;
        };
        k.isRemoteUrl = function() {
            return this.g.remote;
        };
        k.revokeUrl = function(a) {
            a && a === this.j && (this.Ab--, 0 === this.Ab && (this.j = "", this.Na && (this.Na.destroy(), this.h = this.Na = null)));
        };
        k.toJSON = function() {
            var a = this.getResourceUrl();
            return {
                isDataUrl: this.g.isDataUrl,
                isRemoteUrl: this.g.remote,
                mediaTypeCategory: this.m,
                resourceUrl: this.g.isDataUrl && null !== a && 5E6 < a.length ? null : a
            };
        };
        function pj(a, b) {
            try {
                return B.URLUtils.normalizePathnameEncoding(new URL(b, a.tb)).toString();
            } catch (c) {
                return t.Logger.logError(c), null;
            }
        }
        function qj(a) {
            if (!a.h) try {
                var b = B.URLUtils.normalizePathnameEncoding(new URL(a.g.src, a.tb));
                a.Na || (a.Na = new oa.ResourceCacheClient(a.W.ad));
                a.h = a.Na.fetchBrowserNativeUrl(b, [
                    a.m
                ], !1).then(function(c) {
                    return a.j = c.data;
                }).catch(function(c) {
                    var d;
                    null == (d = a.Na) || d.destroy();
                    a.Na = null;
                    a.Ab = 0;
                    a.h = null;
                    return Promise.reject(c);
                });
            } catch (c) {
                return c instanceof t.ColibrioError ? Promise.reject(c) : Promise.reject(new T("INVALID_URL_IN_PUBLICATION_RESOURCE", c + ""));
            }
            a.Ab++;
            return a.h;
        }
        var rj = E.event.MouseEngineEvent, sj = E.event.NavigationIntentEngineEvent;
        function tj(a, b, c, d, e) {
            this.S = a;
            this.ub = b;
            this.I = c;
            this.l = d;
            this.T = e;
            this.Pd = [];
            this.$e = function() {};
            this.Qd = a.document.documentElement;
        }
        tj.prototype.handleEvent = function(a) {
            if ("click" === a.type || "dblclick" === a.type) {
                var b = a.type, c = this.S.frameElement.getBoundingClientRect(), d = c.width / this.S.innerWidth, e = null, f = null, g = null;
                if (H(a.target)) {
                    e = oj(a.target, this.l.tb, this.l.W);
                    for(f = a.target; H(f) && "a" !== f.localName && "area" !== f.localName;)f = f.parentNode;
                    f = H(f) ? f : null;
                    if (a.target.parentNode) {
                        var h = bc(a.target);
                        h || (h = {
                            v: [],
                            i: 0
                        });
                        g = bd(h, null, this.l.da, this.T, this.l.ta, this.l.F.getReaderPublication(), this.l.F, this.l.N);
                    }
                }
                var l;
                h = null == (l = f) ? void 0 : l.getAttribute("href");
                f && (h || "" === h) && a.cancelable && a.preventDefault();
                c = {
                    button: a.button,
                    buttons: a.buttons,
                    cancelable: !0,
                    clientX: d * a.clientX + c.left,
                    clientY: d * a.clientY + c.top,
                    ctrlKey: a.ctrlKey,
                    isTrusted: a.isTrusted,
                    mediaResource: e,
                    metaKey: a.metaKey,
                    pageX: d * a.clientX + c.left + window.scrollX,
                    pageY: d * a.clientY + c.top + window.scrollY,
                    readerDocumentEventState: a.defaultPrevented ? D.ReaderDocumentEventState.DEFAULT_PREVENTED : D.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: this.l.G.getReaderView(),
                    screenX: a.screenX,
                    screenY: a.screenY,
                    target: {
                        contentLocation: g,
                        frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                        mediaType: this.I.Da,
                        nodeData: D.EngineEventTargetNodeUtils.createEventTargetXmlElementNodeData(a.target)
                    },
                    userGenerated: a.isTrusted
                };
                a = new rj(b, c, null);
                this.ub.emit(new rj(b, c, null));
                if (f && h && "" !== h && this.l.G.getReaderViewProperty("contentDocumentEventHandlersEnabled")) a: {
                    c = f;
                    b = this.l.F;
                    f = b.getSourceContentDocument().getContentUrl();
                    c = c.getAttribute("href");
                    try {
                        var m = B.URLUtils.normalizePathnameEncoding(new URL(c, f));
                    } catch (n) {
                        t.Logger.logError(new T("INVALID_URL_IN_PUBLICATION_RESOURCE", String(n) + (' - source="' + f.pathname + '", href="' + c + '"')));
                        break a;
                    }
                    f = b.getReaderPublication();
                    if (m = (c = f.getSourcePublication().getContentDocumentByUrl(m)) ? m.hash.startsWith("#") ? Xd(this.l.N, c, m.hash.slice(1)) : Vd(this.l.N, c) : this.l.N.getLocatorFactory().parse(m).locator) m = new sj({
                        cancelable: !0,
                        locator: m,
                        readerDocument: c && f.getReaderDocument(c),
                        readerView: this.l.G.getReaderView(),
                        relatedEvent: a,
                        sourceReaderDocument: b
                    }), this.ub.emit(m);
                }
            }
        };
        tj.prototype.hb = function() {
            var a = this;
            this.Qd.removeEventListener("click", this, !1);
            this.Qd.removeEventListener("dblclick", this, !1);
            this.Pd.forEach(function(b) {
                return b.removeEventListener("click", a.$e, !1);
            });
            this.Pd = [];
        };
        tj.prototype.ib = function() {
            if (t.BrowserDetector.isOS("iOS")) {
                var a = M(this.S.document);
                var b = t.BrowserDetector.getOsVersion().trim(), c = /^(\d+)(?:\.(\d+))?(?:\.(\d+))?/.exec(b);
                if (c) {
                    var d = c.length;
                    d = new mj(1 < d && c[1] ? Number(c[1]) : 0, 2 < d && c[2] ? Number(c[2]) : 0, 3 < d && c[3] ? Number(c[3]) : 0);
                    if (b.length > c[0].length) {
                        b: if (b = b.slice(c[0].length), "+" === b[0]) d.h = b.slice(1);
                        else if ("-" === b[0]) for(c = b.indexOf("+"), -1 !== c ? (d.h = b.slice(c + 1), b = b.slice(1, c)) : b = b.slice(1), b = b.split("."), c = 0; c < b.length; c++){
                            var e = b[c];
                            if (/^[0-9]+$/.test(e)) d.g.push(Number(e));
                            else if (/^[0-9A-Za-z]+$/.test(e)) d.g.push(e);
                            else {
                                d.g = [];
                                break b;
                            }
                        }
                    }
                } else d = null;
                if (d && 12 >= d.j) for(a = a.firstElementChild; a;)I(a) && a.style.setProperty("-webkit-tap-highlight-color", "transparent", "important"), a.addEventListener("click", this.$e, !1), this.Pd.push(a), a = a.nextElementSibling;
                else a.firstElementChild && (a = a.firstElementChild, I(a) && a.style.setProperty("-webkit-tap-highlight-color", "transparent", "important"), a.addEventListener("click", this.$e, !1), this.Pd.push(a));
            }
            this.Qd.addEventListener("click", this, !1);
            this.Qd.addEventListener("dblclick", this, !1);
        };
        function uj(a, b, c, d) {
            this.ub = a;
            this.I = b;
            this.l = c;
            this.T = d;
        }
        uj.prototype.va = function(a) {
            return new tj(a.ownerDocument.defaultView, this.ub, this.I, this.l, this.T);
        };
        uj.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        uj.prototype.xa = function() {
            return !0;
        };
        function vj(a, b, c) {
            this.ga = a;
            this.ze = b;
            this.we = c;
        }
        vj.prototype.handleEvent = function(a) {
            this.ze.dispatchClipboardEvent(a);
            var b = this.we.allowCopy, c = this.we.textToAppendOnCopy, d = this.we.textToPrependOnCopy;
            a.cancelable && (!b || c || d) && a.preventDefault();
            b && a.clipboardData && (b = this.ga.getSelection()) && (a.clipboardData.setData("text/plain", (d || "") + (-1 < b.toString().indexOf(" ") ? b.toString() : b.getRangeAt(0).toString()) + (c || "")), a.preventDefault());
        };
        vj.prototype.pb = function() {
            this.ga.removeEventListener("copy", this, !0);
        };
        vj.prototype.eb = function() {
            this.ga.addEventListener("copy", this, !0);
        };
        function wj(a, b) {
            this.ze = a;
            this.C = b;
        }
        wj.prototype.va = function(a) {
            return new vj(a.ownerDocument, this.ze, this.C);
        };
        wj.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        wj.prototype.xa = function() {
            return !0;
        };
        function xj(a) {
            this.u = a;
            this.u.addEventListener("contextmenu", this, !0);
        }
        xj.prototype.handleEvent = function(a) {
            a.preventDefault();
        };
        xj.prototype.pb = function() {
            this.u.removeEventListener("contextmenu", this, !0);
        };
        function yj() {}
        yj.prototype.va = function(a) {
            return new xj(a.ownerDocument.defaultView.document.documentElement);
        };
        yj.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        yj.prototype.xa = function() {
            return !0;
        };
        function zj() {}
        zj.prototype.va = function(a) {
            return new xj(a);
        };
        zj.prototype.wa = function(a, b) {
            switch(b){
                case "img":
                case "image":
                case "video":
                case "audio":
                    return !0;
            }
            return !1;
        };
        zj.prototype.xa = function() {
            return !1;
        };
        function Aj(a) {
            this.m = a;
            this.h = null;
            this.g = a.parentNode;
            a = a.ownerDocument;
            this.j = a.createElement("style");
            this.j.appendChild(a.createTextNode(" * { animation: none; !important; -webkit-animation: none !important}"));
        }
        Aj.prototype.pb = function() {
            Bj(this);
        };
        Aj.prototype.hb = function() {
            this.g.appendChild(this.m);
            Cj(this);
        };
        Aj.prototype.eb = function() {
            Cj(this);
        };
        Aj.prototype.ib = function() {
            this.g.removeChild(this.m);
        };
        function Bj(a) {
            a.h && (window.clearTimeout(a.h), a.h = null);
        }
        function Cj(a) {
            Bj(a);
            a.g.appendChild(a.j);
            a.h = window.setTimeout(function() {
                a.g.removeChild(a.j);
            }, 16);
        }
        function Dj() {}
        Dj.prototype.va = function(a) {
            return new Aj(a);
        };
        Dj.prototype.wa = function(a) {
            return a.hasAttribute("data-colibrio-css-pause-animation");
        };
        Dj.prototype.xa = function() {
            return !0;
        };
        function Ej(a) {
            this.u = a;
            this.Jf = a.getAttribute("style") || "";
        }
        Ej.prototype.hb = function() {
            this.u.setAttribute("style", this.Jf);
        };
        Ej.prototype.ib = function() {
            var a = this.u.getAttribute("data-colibrio-css-animation-original") || this.Jf, b = this.u.getAttribute("data-colibrio-css-transition");
            b && (a += ";" + b);
            this.u.setAttribute("style", a);
        };
        function Fj() {}
        Fj.prototype.va = function(a) {
            return new Ej(a);
        };
        Fj.prototype.wa = function(a) {
            return a.hasAttribute("data-colibrio-css-transition") || a.hasAttribute("data-colibrio-css-animation-original");
        };
        Fj.prototype.xa = function() {
            return !1;
        };
        function Gj(a, b, c) {
            this.If = a;
            b = c.createUrlForContent([
                b
            ], y.MediaType.TEXT_CSS, !1);
            this.ge = a.ownerDocument.createElement("link");
            this.ge.setAttribute("rel", "stylesheet");
            this.ge.setAttribute("href", b);
        }
        Gj.prototype.hb = function() {
            this.If.removeChild(this.ge);
        };
        Gj.prototype.ib = function() {
            this.If.appendChild(this.ge);
        };
        function Hj(a, b) {
            this.gb = a;
            this.Na = b;
        }
        Hj.prototype.va = function(a) {
            return new Gj(a, this.gb, this.Na);
        };
        Hj.prototype.wa = function(a, b) {
            return "head" === b;
        };
        Hj.prototype.xa = function() {
            return !0;
        };
        function Ij(a) {
            this.u = a;
        }
        Ij.prototype.handleEvent = function(a) {
            a.cancelable && a.preventDefault();
        };
        Ij.prototype.pb = function() {
            this.u.removeEventListener("dragstart", this, !0);
        };
        Ij.prototype.eb = function() {
            this.u.addEventListener("dragstart", this, !0);
        };
        function Jj() {}
        Jj.prototype.va = function(a) {
            return new Ij(a);
        };
        Jj.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        Jj.prototype.xa = function() {
            return !0;
        };
        function Kj(a, b, c, d) {
            this.u = a;
            this.Fa = b;
            this.m = c;
            this.o = d;
            this.g = this.j = this.h = 0;
        }
        Kj.prototype.df = function() {
            this.g = 0;
        };
        Kj.prototype.ef = function(a) {
            if (0 !== this.g) {
                var b = a.touches;
                if (1 !== b.length || a.defaultPrevented) this.g = 0;
                else {
                    var c = b[0];
                    b = this.h - c.screenX;
                    this.h = c.screenX;
                    var d = this.j - c.screenY;
                    this.j = c.screenY;
                    1 === this.g && (c = Math.abs(d) >= Math.abs(b), this.m && this.o || this.m && !c || this.o && c ? (this.g = 2, this.Fa.getReaderView().abortActiveGesture()) : this.g = 0);
                    2 === this.g && (this.m && (this.u.scrollLeft += b), this.o && (this.u.scrollTop += d), a.cancelable && a.preventDefault());
                }
            }
        };
        Kj.prototype.ff = function(a) {
            a = a.touches;
            1 === a.length ? (this.g = 1, this.h = a[0].screenX, this.j = a[0].screenY) : this.g = 0;
        };
        Kj.prototype.isScrolling = function() {
            return 2 === this.g;
        };
        function Lj(a, b, c) {
            var d = this;
            this.u = a;
            this.Fa = b;
            this.ce = c;
            this.Rb = this.Qb = this.jd = this.Kd = this.Jd = !1;
            this.fc = null;
            this.Pe = new Map;
            this.Qe = new Map;
            this.tg = function() {
                d.ce && d.ce();
            };
            this.Qb = ib(a);
            this.Rb = jb(a);
            this.Qb || this.Rb ? (this.Jd = Mj(this, a, ib) || b.getRendererRuntime().isNativePanXAllowed(), this.Kd = Mj(this, a, jb) || b.getRendererRuntime().isNativePanYAllowed(), a.setAttribute("tabindex", "-1"), (this.Qb || this.Jd) && (this.Rb || this.Kd) ? Q(a, "touch-action", "pan-x pan-y") : this.Qb ? Q(a, "touch-action", "pan-x") : this.Rb && Q(a, "touch-action", "pan-y")) : Q(a, "overflow", "visible");
        }
        k = Lj.prototype;
        k.handleEvent = function(a) {
            switch(a.type){
                case "touchstart":
                    this.ff(a);
                    break;
                case "touchmove":
                    this.ef(a);
                    break;
                case "touchend":
                case "touchcancel":
                    this.df(a);
            }
        };
        k.hb = function() {
            if (this.Qb || this.Rb) this.u.removeEventListener("touchstart", this, !1), this.u.removeEventListener("touchmove", this, !1), this.u.removeEventListener("touchend", this, !1), this.u.removeEventListener("touchcancel", this, !1), this.u.removeEventListener("scroll", this.tg, !1), this.jd = !1, this.u.setAttribute("tabindex", "-1");
        };
        k.ib = function() {
            if (this.Qb || this.Rb) this.u.addEventListener("touchstart", this, {
                passive: !1
            }), this.u.addEventListener("touchmove", this, {
                passive: !1
            }), this.u.addEventListener("touchend", this, {
                passive: !1
            }), this.u.addEventListener("touchcancel", this, {
                passive: !1
            }), this.u.addEventListener("scroll", this.tg, {
                passive: !1
            }), this.u.setAttribute("tabindex", "0");
        };
        k.df = function(a) {
            for(var b = a.changedTouches, c = 0; c < b.length; c++){
                var d = b[c];
                this.Pe.delete(d.identifier);
                this.Qe.delete(d.identifier);
            }
            this.jd = !1;
            var e;
            null == (e = this.fc) || e.df(a);
        };
        k.ef = function(a) {
            var b = a.changedTouches, c;
            if (null == (c = this.fc) || !c.isScrolling()) for(c = 0; c < b.length; c++){
                var d = b[c], e = this.Pe.get(d.identifier), f = this.Qe.get(d.identifier);
                K(e) && K(f) && (e = d.screenX - e, d = d.screenY - f, f = Math.abs(d) >= Math.abs(e), this.Rb && f && 0 > d ? this.u.scrollTop + this.u.clientHeight >= this.u.scrollHeight - 1 && Nj(this, a) : this.Rb && f && 0 < d ? 0 === this.u.scrollTop && Nj(this, a) : this.Qb && !f && 0 > e ? this.u.scrollLeft + this.u.clientWidth >= this.u.scrollWidth - 1 && Nj(this, a) : this.Qb && !f && 0 < e && 0 === this.u.scrollLeft && Nj(this, a));
            }
            this.jd = !1;
            var g;
            null == (g = this.fc) || g.ef(a);
        };
        k.ff = function(a) {
            var b = a.changedTouches;
            1 === a.touches.length && (this.jd = !0);
            for(var c = 0; c < b.length; c++){
                var d = b[c];
                this.Pe.set(d.identifier, d.screenX);
                this.Qe.set(d.identifier, d.screenY);
            }
            var e;
            null == (e = this.fc) || e.ff(a);
        };
        function Mj(a, b, c) {
            b = b.parentNode;
            return I(b) ? c(b) ? !0 : Mj(a, b, c) : !1;
        }
        function Nj(a, b) {
            b.cancelable ? b.preventDefault() : a.fc ? a.fc.g = 0 : a.fc || !a.jd || b.defaultPrevented || (Q(a.u, "touch-action", a.Jd && a.Kd ? "pan-x pan-y" : a.Jd ? "pan-x" : a.Kd ? "pan-y" : "none"), a.fc = new Kj(a.u, a.Fa, a.Qb, a.Rb));
        }
        function Oj(a, b) {
            this.Fa = a;
            this.ce = b;
        }
        Oj.prototype.va = function(a) {
            return new Lj(a, this.Fa, this.ce);
        };
        Oj.prototype.wa = function(a) {
            return I(a) ? "auto" === N(a).overflowX || "scroll" === N(a).overflowX || "auto" === N(a).overflowY || "scroll" === N(a).overflowY : !1;
        };
        Oj.prototype.xa = function() {
            return !1;
        };
        function Pj(a) {
            this.B = a;
        }
        Pj.prototype.hb = function() {
            this.B.removeAttribute("src");
        };
        Pj.prototype.ib = function() {
            var a = this.B.getAttribute("data-colibrio-iframe-src");
            a && this.B.setAttribute("src", a);
        };
        function Qj() {}
        Qj.prototype.va = function(a) {
            return new Pj(a);
        };
        Qj.prototype.wa = function(a, b) {
            return "iframe" === b && null !== a.getAttribute("data-colibrio-iframe-src");
        };
        Qj.prototype.xa = function() {
            return !1;
        };
        function Rj(a, b, c, d) {
            this.S = a;
            this.I = b;
            this.l = c;
            this.T = d;
        }
        Rj.prototype.handleEvent = function(a) {
            var b = null;
            H(a.target) && a.target.parentNode && ((b = bc(a.target)) || (b = {
                v: [],
                i: 0
            }), b = bd(b, null, this.l.da, this.T, this.l.ta, this.l.F.getReaderPublication(), this.l.F, this.l.N));
            b = {
                contentLocation: b,
                frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                mediaType: this.I.Da,
                nodeData: D.EngineEventTargetNodeUtils.createEventTargetXmlElementNodeData(a.target)
            };
            this.l.G.getEngineEventDispatcher().dispatchKeyboardEvent(a, b, a.defaultPrevented ? D.ReaderDocumentEventState.DEFAULT_PREVENTED : D.ReaderDocumentEventState.NOT_PROCESSED, a.isTrusted);
        };
        Rj.prototype.pb = function() {
            this.S.removeEventListener("keydown", this, !1);
            this.S.removeEventListener("keyup", this, !1);
        };
        Rj.prototype.eb = function() {
            this.S.addEventListener("keydown", this, !1);
            this.S.addEventListener("keyup", this, !1);
        };
        function Sj(a, b, c) {
            this.I = a;
            this.l = b;
            this.T = c;
        }
        Sj.prototype.va = function(a) {
            return new Rj(a.ownerDocument.defaultView, this.I, this.l, this.T);
        };
        Sj.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        Sj.prototype.xa = function() {
            return !0;
        };
        function Tj(a, b) {
            this.u = a;
            var c = !1;
            switch(a.localName){
                case "audio":
                    c = b.allowAudioElementAutoplay;
                    break;
                case "video":
                    c = b.allowVideoElementAutoplay;
            }
            this.Ng = c && a.hasAttribute("data-colibrio-autoplay");
        }
        Tj.prototype.hb = function() {
            try {
                this.u.paused || this.u.pause(), Ra(0, this.u.currentTime) || (this.u.currentTime = 0);
            } catch (a) {
                t.Logger.logInfo("Media pause prevented by browser");
            }
        };
        Tj.prototype.ib = function() {
            try {
                this.Ng && (this.u.currentTime = 0, this.u.play().catch(function(a) {
                    t.Logger.logWarning(a);
                }));
            } catch (a) {
                t.Logger.logInfo("Auto-play prevented by browser");
            }
        };
        function Uj(a) {
            this.C = a;
        }
        Uj.prototype.va = function(a) {
            return new Tj(a, this.C);
        };
        Uj.prototype.wa = function(a, b) {
            return "video" === b || "audio" === b;
        };
        Uj.prototype.xa = function() {
            return !1;
        };
        function Vj(a) {
            this.u = a;
        }
        Vj.prototype.eb = function() {
            this.u.setAttribute("tabindex", "0");
        };
        function Wj() {}
        Wj.prototype.va = function(a) {
            return new Vj(a);
        };
        Wj.prototype.wa = function(a) {
            return ob(a) && kb(a) && !mb(a);
        };
        Wj.prototype.xa = function() {
            return !1;
        };
        function Xj(a, b, c, d, e) {
            this.u = a;
            this.G = c;
            this.m = d;
            this.j = -1;
            this.g = !0;
            this.h = !1;
            this.o = {
                contentLocation: e,
                frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                mediaType: b,
                nodeData: D.EngineEventTargetNodeUtils.createEventTargetXmlElementNodeData(a)
            };
            this.dispatchMediaElementEvent("mediaElementInsideVisiblePages");
            3 <= this.u.readyState && (this.h = !0, this.dispatchMediaElementEvent("mediaElementReady"));
            this.u.paused || (this.g = !1, this.dispatchMediaElementEvent("mediaElementPlay"));
            a.addEventListener("canplay", this);
            a.addEventListener("play", this);
            a.addEventListener("pause", this);
            a.addEventListener("seeked", this);
            a.addEventListener("timeupdate", this);
            a.addEventListener("waiting", this);
        }
        Xj.prototype.destroy = function() {
            this.dispatchMediaElementEvent("mediaElementOutsideVisiblePages");
            this.u.removeEventListener("canplay", this);
            this.u.removeEventListener("play", this);
            this.u.removeEventListener("pause", this);
            this.u.removeEventListener("seeked", this);
            this.u.removeEventListener("timeupdate", this);
            this.u.removeEventListener("waiting", this);
        };
        Xj.prototype.handleEvent = function(a) {
            switch(a.type){
                case "canplay":
                    this.h || (this.h = !0, this.dispatchMediaElementEvent("mediaElementReady"));
                    break;
                case "play":
                    this.g && (this.g = !1, this.dispatchMediaElementEvent("mediaElementPlay"));
                    break;
                case "pause":
                    this.g || (this.g = !0, this.dispatchMediaElementEvent("mediaElementCurrentTimeChanged"), this.dispatchMediaElementEvent("mediaElementPaused"));
                    break;
                case "seeked":
                    this.dispatchMediaElementEvent("mediaElementCurrentTimeChanged");
                    this.dispatchMediaElementEvent("mediaElementSeeked");
                    break;
                case "timeupdate":
                    a = Date.now();
                    1E3 < a - this.j && (this.j = a, this.dispatchMediaElementEvent("mediaElementCurrentTimeChanged"));
                    break;
                case "waiting":
                    this.h && (this.h = !1, this.dispatchMediaElementEvent("mediaElementWaiting"));
            }
        };
        Xj.prototype.dispatchMediaElementEvent = function(a) {
            this.G.getEngineEventDispatcher().dispatchMediaElementEvent(a, {
                currentTimeMs: Math.round(1E3 * this.u.currentTime),
                durationMs: Math.round(1E3 * this.u.duration),
                paused: this.u.paused,
                ready: 3 <= this.u.readyState
            }, this.m, this.o);
        };
        function Yj(a, b, c, d, e) {
            var f = this;
            this.u = a;
            this.I = b;
            this.l = c;
            this.j = d;
            this.T = e;
            this.L = !1;
            this.g = null;
            this.m = [];
            this.o = 0;
            this.h = [];
            this.nb = !1;
            if (b = this.u.getAttribute("data-colibrio-media-sources")) try {
                var g = JSON.parse(b).map(function(l) {
                    var m = B.URLUtils.normalizePathnameEncoding(new URL(l.src, f.l.ta.getContentUrl()));
                    return {
                        J: l.type,
                        dg: m
                    };
                }), h = g.filter(function(l) {
                    return !l.J || a.canPlayType(l.J);
                });
                this.h = 0 === h.length ? g : h;
            } catch (l) {
                t.Logger.logError(l);
            }
        }
        Yj.prototype.pb = function() {
            var a = this;
            this.L = !0;
            this.m.forEach(function(b) {
                return a.j.revokeUrl(b);
            });
        };
        Yj.prototype.hb = function() {
            this.nb = !1;
            this.g && (this.g.destroy(), this.g = null);
        };
        Yj.prototype.eb = function() {
            var a = this;
            if (1 === this.h.length) {
                var b = this.j.createUrl(this.u, this.h[0].dg);
                this.m.push(b.mediaSourceId);
                b.urlPromise.then(function(c) {
                    a.L || (a.u.src = c, Zj(a));
                }).catch(function(c) {
                    t.ColibrioError.isColibrioAbortedError(c) || t.Logger.logError(c);
                });
            } else tb(this.h, function(c) {
                var d = c.J;
                c = a.j.createUrl(a.u, c.dg);
                a.m.push(c.mediaSourceId);
                return c.urlPromise.then(function(e) {
                    if (!a.L) {
                        var f = a.u.ownerDocument.createElement("source");
                        f.setAttribute("src", e);
                        d && f.setAttribute("type", d);
                        a.u.appendChild(f);
                        ak(a);
                    }
                }).catch(function(e) {
                    ak(a);
                    t.ColibrioError.isColibrioAbortedError(e) || t.Logger.logError(e);
                });
            }).catch(function(c) {
                t.ColibrioError.isColibrioAbortedError(c) || t.Logger.logError(c);
            });
        };
        Yj.prototype.ib = function() {
            this.nb = !0;
            Zj(this);
        };
        function Zj(a) {
            if (!a.g && a.nb) {
                var b = oj(a.u, a.l.tb, a.l.W), c = bc(a.u);
                c && (c = bd(c, null, a.l.da, a.T, a.l.ta, a.l.F.getReaderPublication(), a.l.F, a.l.N), b && (a.g = new Xj(a.u, a.I.Da, a.l.G, b, c)));
            }
        }
        function ak(a) {
            a.o++;
            a.o !== a.h.length || a.L || (a.u.load(), Zj(a));
        }
        function bk(a, b, c, d) {
            this.I = a;
            this.l = b;
            this.g = c;
            this.T = d;
        }
        bk.prototype.va = function(a) {
            return new Yj(a, this.I, this.l, this.g, this.T);
        };
        bk.prototype.wa = function(a, b) {
            return "audio" === b || "video" === b;
        };
        bk.prototype.xa = function() {
            return !1;
        };
        function ck(a) {
            this.u = a;
        }
        ck.prototype.eb = function() {
            var a = this.u.getAttribute("data-colibrio-inline-overflow-x-changed");
            a ? this.u.style.setProperty("overflow-x", a) : this.u.style.removeProperty("overflow-x");
        };
        function dk() {}
        dk.prototype.va = function(a) {
            return new ck(a);
        };
        dk.prototype.wa = function(a) {
            return a.hasAttribute("data-colibrio-overflow-x-changed") || a.hasAttribute("data-colibrio-inline-overflow-x-changed");
        };
        dk.prototype.xa = function() {
            return !1;
        };
        var ek = E.event.PointerEngineEvent;
        function fk(a, b, c, d, e, f) {
            this.S = a;
            this.ub = b;
            this.I = c;
            this.l = d;
            this.C = e;
            this.T = f;
            this.Kc = this.tc = this.md = null;
            this.Wd = 0;
            this.hc = !1;
            this.Eb = 0;
            this.be = null;
            this.Uf = function(g) {
                g.cancelable && 2 <= g.touches.length && g.preventDefault();
            };
            this.fe = "ontouchstart" in a;
            this.wb = this.l.G.getReaderViewOptions().emitPointerMoveEventsOnHover;
            if (this.fe && t.BrowserDetector.isOS("iOS")) for(this.md = Za(a.document), a.document.body.appendChild(this.md), a = a.document.body.childNodes, b = 0; b < a.length; b++)c = a[b], 1 === c.nodeType && c.addEventListener("touchmove", this.Uf);
        }
        k = fk.prototype;
        k.handleEvent = function(a) {
            switch(a.type){
                case "touchstart":
                    0 === this.Eb && (this.S.addEventListener("touchmove", this, !1), this.S.addEventListener("touchend", this, !1), this.S.addEventListener("touchcancel", this, !1));
                    this.Eb += a.changedTouches.length;
                    this.Kc = a;
                    this.Wd = Date.now();
                    gk(this, "pointerdown", a, H(a.target) ? this.Xa(a.target) : null);
                    this.hc && this.tc && hk(this, "pointercancel", this.tc, null);
                    break;
                case "touchmove":
                    if (0 < this.Eb) {
                        this.Kc = a;
                        var b = H(a.target) && this.C.includeContentLocationInPointerMoveEvents ? this.Xa(a.target) : null;
                        gk(this, "pointermove", a, b);
                    }
                    this.Wd = Date.now();
                    break;
                case "touchend":
                case "touchcancel":
                    "touchend" === a.type ? gk(this, "pointerup", a, H(a.target) ? this.Xa(a.target) : null) : gk(this, "pointercancel", a, null);
                    this.Eb = Math.max(0, this.Eb - a.changedTouches.length);
                    this.Kc = a;
                    this.Wd = Date.now();
                    0 === this.Eb && ik(this);
                    break;
                case "mousedown":
                    0 === this.Eb && 1E3 < Date.now() - this.Wd && (this.wb || this.S.addEventListener("mousemove", this, !1), this.S.addEventListener("mouseup", this, !1), this.hc = !0, this.tc = a, hk(this, "pointerdown", a, H(a.target) ? this.Xa(a.target) : null));
                    break;
                case "mousemove":
                    this.hc && (this.tc = a);
                    if (this.hc || this.wb) b = H(a.target) && this.C.includeContentLocationInPointerMoveEvents ? this.Xa(a.target) : null, hk(this, "pointermove", a, b);
                    break;
                case "mouseup":
                    this.hc && (hk(this, "pointerup", a, H(a.target) ? this.Xa(a.target) : null), jk(this));
                    break;
                case "dragstart":
                    this.hc && this.tc && (hk(this, "pointercancel", this.tc, null), jk(this));
            }
        };
        k.pb = function() {
            if (this.fe && t.BrowserDetector.isOS("iOS")) {
                for(var a = this.S.document.body.childNodes, b = 0; b < a.length; b++){
                    var c = a[b];
                    1 === c.nodeType && c.removeEventListener("touchmove", this.Uf);
                }
                this.md && (qb(this.md), this.md = null);
            }
        };
        k.hb = function() {
            this.fe && (this.S.removeEventListener("touchstart", this, !1), 0 < this.Eb && (this.Kc && gk(this, "pointercancel", this.Kc, null, !0), ik(this)));
            this.wb && this.S.removeEventListener("mousemove", this, !1);
            this.S.removeEventListener("mousedown", this, !1);
            this.S.removeEventListener("dragstart", this, !1);
            this.hc && jk(this);
        };
        k.ib = function() {
            var a = this;
            this.fe && (this.S.addEventListener("touchstart", this, !1), this.S.setTimeout(function() {
                a.S.document.documentElement.ontouchstart = function() {};
            }, 0));
            this.wb && this.S.addEventListener("mousemove", this, !1);
            this.S.addEventListener("mousedown", this, !1);
            this.S.addEventListener("dragstart", this, !1);
        };
        k.Xa = function(a) {
            (a = bc(a)) || (a = {
                v: [],
                i: 0
            });
            return bd(a, null, this.l.da, this.T, this.l.ta, this.l.F.getReaderPublication(), this.l.F, this.l.N);
        };
        function hk(a, b, c, d) {
            var e = a.S.frameElement.getBoundingClientRect(), f = e.width / a.S.innerWidth;
            c = {
                button: c.button,
                buttons: c.buttons,
                cancelable: !0,
                clientX: f * c.clientX + e.left,
                clientY: f * c.clientY + e.top,
                ctrlKey: c.ctrlKey,
                isPrimary: 0 === c.button,
                isTrusted: c.isTrusted,
                mediaResource: null,
                metaKey: c.metaKey,
                pageX: f * c.clientX + e.left + window.scrollX,
                pageY: f * c.clientY + e.top + window.scrollY,
                pointerId: -1,
                pointerType: "mouse",
                readerDocumentEventState: D.ReaderDocumentEventState.NOT_PROCESSED,
                readerView: a.l.G.getReaderView(),
                screenX: c.screenX,
                screenY: c.screenY,
                target: {
                    contentLocation: d,
                    frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                    mediaType: a.I.Da,
                    nodeData: D.EngineEventTargetNodeUtils.createEventTargetXmlElementNodeData(c.target)
                },
                userGenerated: c.isTrusted
            };
            a.ub.emit(new ek(b, c, null));
        }
        function gk(a, b, c, d, e) {
            e = e ? c.targetTouches : c.changedTouches;
            for(var f = a.S.frameElement.getBoundingClientRect(), g = f.width / a.S.innerWidth, h = 0; h < e.length; h++){
                var l = e.item(h);
                null === a.be && (a.be = l.identifier);
                l = {
                    button: 0,
                    buttons: 1,
                    cancelable: !0,
                    clientX: g * l.clientX + f.left,
                    clientY: g * l.clientY + f.top,
                    ctrlKey: c.ctrlKey,
                    isPrimary: a.be === l.identifier,
                    isTrusted: c.isTrusted,
                    mediaResource: null,
                    metaKey: c.metaKey,
                    pageX: g * l.clientX + f.left + window.scrollX,
                    pageY: g * l.clientY + f.top + window.scrollY,
                    pointerId: l.identifier,
                    pointerType: "touch",
                    readerDocumentEventState: D.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: a.l.G.getReaderView(),
                    screenX: l.screenX,
                    screenY: l.screenY,
                    target: {
                        contentLocation: d,
                        frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                        mediaType: a.I.Da,
                        nodeData: D.EngineEventTargetNodeUtils.createEventTargetXmlElementNodeData(l.target)
                    },
                    userGenerated: c.isTrusted
                };
                a.ub.emit(new ek(b, l, null));
            }
        }
        function jk(a) {
            a.wb || a.S.removeEventListener("mousemove", a, !1);
            a.S.removeEventListener("mouseup", a, !1);
            a.hc = !1;
            a.tc = null;
        }
        function ik(a) {
            a.S.removeEventListener("touchmove", a, !1);
            a.S.removeEventListener("touchend", a, !1);
            a.S.removeEventListener("touchcancel", a, !1);
            a.Eb = 0;
            a.be = null;
            a.Kc = null;
        }
        var kk = E.event.PointerEngineEvent;
        function lk(a, b, c, d, e, f) {
            this.S = a;
            this.ub = b;
            this.I = c;
            this.l = d;
            this.C = e;
            this.T = f;
            this.rb = new Map;
            a = this.l.G.getReaderViewOptions();
            this.dh = a.gestureOptions.swipeNavigation.pointerTypes.mouse;
            this.wb = a.emitPointerMoveEventsOnHover;
        }
        lk.prototype.handleEvent = function(a) {
            var b = 1 === a.buttons, c = "mouse" === a.pointerType && this.dh;
            switch(a.type){
                case "pointerdown":
                    0 === this.rb.size && (this.wb || this.S.addEventListener("pointermove", this, !1), this.S.addEventListener("pointerup", this, !1), this.S.addEventListener("pointercancel", this, !1));
                    var d = this.S.document.getSelection();
                    if (c && b || "mouse" !== a.pointerType) {
                        if (!d || d.isCollapsed) H(a.target) ? a.target.setPointerCapture(a.pointerId) : this.S.document.documentElement.setPointerCapture(a.pointerId);
                    }
                    this.rb.set(a.pointerId, a);
                    a.cancelable && 2 <= this.rb.size && a.preventDefault();
                    mk(this, a.type, a, H(a.target) ? this.Xa(a.target) : null);
                    break;
                case "pointermove":
                    a.cancelable && 2 <= this.rb.size && a.preventDefault();
                    b = this.wb;
                    this.rb.has(a.pointerId) && (this.rb.set(a.pointerId, a), b = !0);
                    b && (b = H(a.target) && this.C.includeContentLocationInPointerMoveEvents ? this.Xa(a.target) : null, mk(this, a.type, a, b));
                    break;
                case "pointerup":
                case "pointercancel":
                    a.cancelable && 2 <= this.rb.size && a.preventDefault();
                    try {
                        if (c || "mouse" !== a.pointerType) H(a.target) ? a.target.releasePointerCapture(a.pointerId) : this.S.document.documentElement.releasePointerCapture(a.pointerId);
                    } catch (e) {}
                    this.rb.delete(a.pointerId) && ("pointerup" === a.type ? mk(this, a.type, a, H(a.target) ? this.Xa(a.target) : null) : mk(this, a.type, a, null));
                    0 === this.rb.size && nk(this);
            }
        };
        lk.prototype.hb = function() {
            var a = this;
            this.S.removeEventListener("pointerdown", this, !1);
            this.wb && this.S.removeEventListener("pointermove", this, !1);
            0 < this.rb.size && (this.rb.forEach(function(b) {
                mk(a, "pointercancel", b, null);
            }), nk(this), this.rb.clear());
        };
        lk.prototype.ib = function() {
            this.S.addEventListener("pointerdown", this, !1);
            this.wb && this.S.addEventListener("pointermove", this, !1);
        };
        lk.prototype.Xa = function(a) {
            (a = bc(a)) || (a = {
                v: [],
                i: 0
            });
            return bd(a, null, this.l.da, this.T, this.l.ta, this.l.F.getReaderPublication(), this.l.F, this.l.N);
        };
        function mk(a, b, c, d) {
            var e = a.S.frameElement.getBoundingClientRect(), f = e.width / a.S.innerWidth;
            c = {
                button: c.button,
                buttons: c.buttons,
                cancelable: !0,
                clientX: f * c.clientX + e.left,
                clientY: f * c.clientY + e.top,
                ctrlKey: c.ctrlKey,
                isPrimary: c.isPrimary,
                isTrusted: c.isTrusted,
                mediaResource: null,
                metaKey: c.metaKey,
                pageX: f * c.clientX + e.left + window.scrollX,
                pageY: f * c.clientY + e.top + window.scrollY,
                pointerId: c.pointerId,
                pointerType: c.pointerType,
                readerDocumentEventState: D.ReaderDocumentEventState.NOT_PROCESSED,
                readerView: a.l.G.getReaderView(),
                screenX: c.screenX,
                screenY: c.screenY,
                target: {
                    contentLocation: d,
                    frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                    mediaType: a.I.Da,
                    nodeData: D.EngineEventTargetNodeUtils.createEventTargetXmlElementNodeData(c.target)
                },
                userGenerated: c.isTrusted
            };
            a.ub.emit(new kk(b, c, null));
        }
        function nk(a) {
            a.wb || a.S.removeEventListener("pointermove", a, !1);
            a.S.removeEventListener("pointerup", a, !1);
            a.S.removeEventListener("pointercancel", a, !1);
        }
        function ok(a, b, c, d, e) {
            this.ub = a;
            this.I = b;
            this.l = c;
            this.C = d;
            this.T = e;
        }
        ok.prototype.va = function(a) {
            a = a.ownerDocument.defaultView;
            var b = this.l.G.getReaderView().getReadingSystemEngine();
            return !E.ReadingSystemUtils.isTouchEventsForced(b) && "onpointerdown" in a ? new lk(a, this.ub, this.I, this.l, this.C, this.T) : new fk(a, this.ub, this.I, this.l, this.C, this.T);
        };
        ok.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        ok.prototype.xa = function() {
            return !0;
        };
        var pk = E.event.SelectionChangedEngineEvent;
        function qk(a, b, c) {
            this.ga = a;
            this.l = b;
            this.T = c;
            this.Be = 0;
            this.ga.addEventListener("selectionchange", this, !0);
            this.ga.addEventListener("selectstart", this, !0);
            a = this.l.G;
            this.cd = a.getReaderViewProperty("contentSelectionEnabled");
            a.addReaderViewPropertyChangedListener("contentSelectionEnabled", this);
            a.addReaderViewPropertyChangedListener("clearContentSelection", this);
            rk(this);
        }
        qk.prototype.handleEvent = function(a) {
            if ("selectstart" === a.type) a.cancelable && !this.cd && a.preventDefault();
            else if ("selectionchange" === a.type) {
                if (this.Be) this.Be--;
                else if (this.cd) {
                    var b = this.ga.getSelection();
                    a = this.l.G;
                    var c = null;
                    if (b && 0 < b.rangeCount) {
                        var d = b.getRangeAt(0);
                        var e = this.l.da;
                        var f = this.T, g = this.l.ta, h = this.l.F.getReaderPublication(), l = this.l.F, m = this.l.N, n = cc(d.startContainer, d.startOffset);
                        if (n) {
                            var p = d.collapsed ? null : cc(d.endContainer, d.endOffset);
                            e = bd(n, p, e, f, g, h, l, m);
                        } else e = null;
                        b = -1 < b.toString().indexOf(" ") ? b.toString() : b.getRangeAt(0).toString();
                        e && (c = new pk({
                            contentLocation: e,
                            isRange: !d.collapsed,
                            readerView: a.getReaderView(),
                            selectionText: b
                        }));
                    }
                    a.onSelectionChanged(c, this);
                } else this.clearContentSelection();
            }
        };
        qk.prototype.pb = function() {
            this.ga.removeEventListener("selectionchange", this, !0);
            this.ga.removeEventListener("selectstart", this, !0);
            this.l.G.removeReaderViewPropertyChangedListener("contentSelectionEnabled", this);
            this.l.G.removeReaderViewPropertyChangedListener("clearContentSelection", this);
            this.clearContentSelection();
        };
        qk.prototype.onReaderViewPropertyChanged = function(a, b) {
            "contentSelectionEnabled" === a ? ((this.cd = b) || this.clearContentSelection(), rk(this)) : "clearContentSelection" === a && this.clearContentSelection();
        };
        qk.prototype.clearContentSelection = function() {
            var a = this.ga.getSelection();
            a && 0 < a.rangeCount && (this.Be++, a.removeAllRanges());
        };
        function rk(a) {
            if (t.BrowserDetector.isOS("iOS")) {
                var b = M(a.ga);
                I(b) && (a.cd ? b.style.setProperty("-webkit-user-select", "") : b.style.setProperty("-webkit-user-select", "none", "important"));
            }
        }
        function sk(a, b) {
            this.l = a;
            this.T = b;
        }
        sk.prototype.va = function(a) {
            return new qk(a.ownerDocument, this.l, this.T);
        };
        sk.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        sk.prototype.xa = function() {
            return !0;
        };
        function tk(a, b) {
            this.u = a;
            this.Fa = b;
            a = null !== b.getReaderViewProperty("activeTransform");
            uk(this, a);
            this.Fa.addReaderViewPropertyChangedListener("activeTransform", this);
        }
        tk.prototype.pb = function() {
            this.Fa.removeReaderViewPropertyChangedListener("activeTransform", this);
        };
        tk.prototype.onReaderViewPropertyChanged = function(a, b) {
            "activeTransform" === a && uk(this, null !== b);
        };
        function uk(a, b) {
            a = a.u.classList;
            b ? a.add("colibrio-readerview--transform-manager-active") : a.remove("colibrio-readerview--transform-manager-active");
        }
        function vk(a) {
            this.Fa = a;
        }
        vk.prototype.va = function(a) {
            return new tk(a, this.Fa);
        };
        vk.prototype.wa = function(a, b, c) {
            return a === c.documentElement;
        };
        vk.prototype.xa = function() {
            return !0;
        };
        function wk(a, b) {
            return (a = a.selector ? xk(a.selector) : null) ? b.getElementById(a) : null;
        }
        function xk(a) {
            return a && 1 < a.length && "#" === a[0] ? a.slice(1) : null;
        }
        function yk(a) {
            this.j = null;
            this.o = [];
            this.L = !1;
            this.g = null;
            this.A = !1;
            this.h = null;
            var b = a.getSourcePublication().getMetadata().getMediaOverlayMetadata(), c = b.getActiveClassName();
            a = a.getOptions().mediaOverlayOptions;
            c ? this.Zc = c : this.Zc = a.fallbackActiveElementClass || "-epub-media-overlay-active";
            this.H = b.getPlaybackActiveClassName() || "-epub-media-overlay-playing";
            this.m = a.activeElementAncestorClass || null;
        }
        k = yk.prototype;
        k.destroy = function() {
            this.L = !0;
            this.j = this.h = this.g = null;
        };
        k.pause = function() {};
        k.play = function() {};
        k.ne = function(a) {
            this.L || this.j === a || (this.j = a, this.g && zk(this, a, this.g));
        };
        function Ak(a, b) {
            a.g === b || a.L || (a.g = b, a.h = null, a.o = [], Bk(a), b && a.j && zk(a, a.j, b));
        }
        k.setMuted = function() {};
        k.oe = function(a) {
            this.A = !a;
            Bk(this);
        };
        k.setVolume = function() {};
        function zk(a, b, c) {
            var d = null;
            b && (d = (b = b.xc ? xk(b.xc) : null) ? c.getElementById(b) : null);
            a.h && a.h !== d && a.h.classList.remove(a.Zc);
            d && d.classList.add(a.Zc);
            a.h = d;
            if (a.m) {
                b = [];
                d && d.parentNode && (b = hb(c.documentElement, d.parentNode));
                c = a.o;
                for(d = 0; d < b.length; d++){
                    var e = b[d];
                    if (H(e)) {
                        var f = c.indexOf(e);
                        -1 === f ? e.classList.add(a.m) : c.splice(f, 1);
                    }
                }
                for(d = 0; d < c.length; d++)e = c[d], H(e) && e.classList.remove(a.m);
                a.o = b;
            }
        }
        function Bk(a) {
            if (a.g) {
                var b = a.g.documentElement.classList;
                a.A ? b.add(a.H) : b.remove(a.H);
            }
        }
        var Ck = __lib__webfontloader;
        function Dk(a) {
            this.Ob = a;
        }
        Dk.prototype.nc = function(a) {
            var b = this;
            return new Promise(function(c) {
                var d = a.fonts;
                if (d && d.ready && d.ready.then) {
                    var e = setTimeout(c, 2E3);
                    d.ready.then(function() {
                        clearTimeout(e);
                        t.BrowserDetector.isBrowser("Safari") || t.BrowserDetector.isOS("iOS") ? Ek(b, a, 500, c) : c();
                    }).catch(function(f) {
                        t.Logger.logError(new T("FONT_LOAD_ERROR", f));
                        c();
                    });
                } else Ek(b, a, 2E3, c);
            });
        };
        function Ek(a, b, c, d) {
            Ck.load({
                active: function() {
                    return d();
                },
                classes: !1,
                context: b.defaultView,
                custom: {
                    families: a.Ob
                },
                inactive: function() {
                    return d();
                },
                timeout: c
            });
        }
        function Fk(a) {
            this.g = a;
        }
        function Gk(a, b) {
            return (a.g[b] << 24 >>> 0) + (a.g[b + 1] << 16) + (a.g[b + 2] << 8) + a.g[b + 3];
        }
        function Hk(a) {
            return a.complete ? Promise.resolve() : new Promise(function(b, c) {
                function d() {
                    f();
                    c();
                }
                function e() {
                    f();
                    b();
                }
                function f() {
                    a.removeEventListener("load", e, !1);
                    a.removeEventListener("error", d, !1);
                    a.removeEventListener("abort", d, !1);
                    clearTimeout(g);
                }
                var g = setTimeout(function() {
                    console.warn("ImageUtils.waitUntilImageLoaded() timed out.");
                    e();
                }, 4E3);
                a.addEventListener("load", e, !1);
                a.addEventListener("error", d, !1);
                a.addEventListener("abort", d, !1);
            });
        }
        function Ik(a) {
            var b = Jk(a), c = b.width, d = b.height;
            return null !== d && null !== c ? Promise.resolve() : Hk(a).finally(function() {
                null === d && null === c ? (a.setAttribute("height", "" + a.height), a.setAttribute("width", "" + a.width)) : null === d && null !== c ? a.setAttribute("height", "" + (0 === a.width ? a.height : c / a.width * a.height)) : null === c && null !== d && a.setAttribute("width", "" + (0 === a.height ? a.width : d / a.height * a.width));
            });
        }
        function Kk(a) {
            var b = !0;
            try {
                a.poster && (b = !1);
            } catch (g) {}
            var c = 1 > a.readyState ? new Promise(function(g) {
                function h() {
                    a.removeEventListener("loadedmetadata", h, !1);
                    clearTimeout(l);
                    g();
                }
                var l = setTimeout(h, 1E3);
                a.addEventListener("loadedmetadata", h, !1);
            }) : Promise.resolve();
            if (!b && a.poster) b = new Promise(function(g) {
                function h() {
                    l.removeEventListener("load", h, !1);
                    l.removeEventListener("error", h, !1);
                    l.removeEventListener("abort", h, !1);
                    clearTimeout(m);
                    e = l.width;
                    f = l.height;
                    g();
                }
                var l = new Image, m = setTimeout(h, 4E3);
                l.addEventListener("load", h, !1);
                l.addEventListener("error", h, !1);
                l.addEventListener("abort", h, !1);
                l.src = a.poster;
            });
            else {
                b = Number(a.getAttribute("data-colibrio-video-width")) | 0;
                var d = Number(a.getAttribute("data-colibrio-video-height")) | 0;
                b && d || (d = .25 * a.ownerDocument.defaultView.innerHeight, b = 16 * d / 9);
                a.poster = "data:image/svg+xml;base64," + btoa('<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" width="' + b + '" height="' + d + '" viewBox="0 0 ' + b + " " + d + '">\n    <path d="M0 0h' + b + "v" + d + 'H0z" fill="#000"/>\n</svg>\n');
                var e = b;
                var f = d;
                b = new Promise(function(g) {
                    setTimeout(function() {
                        g();
                    }, 16);
                });
            }
            return Promise.all([
                b,
                c
            ]).then(function() {
                if (1 <= a.readyState || a.width && a.height) e = a.width, f = a.height;
                var g = Jk(a), h = g.width;
                g = g.height;
                if (null === g || null === h) null === g && null === h ? (a.setAttribute("height", "" + f), a.setAttribute("width", "" + e)) : null === g && null !== h ? a.setAttribute("height", "" + (0 === a.width ? a.height : h / a.width * a.height)) : null === h && null !== g && a.setAttribute("width", "" + (0 === a.height ? a.width : g / a.height * a.width));
            });
        }
        function Jk(a) {
            var b = /^\s*\d+(.\d*)?%/, c = a.getAttribute("height"), d = a.getAttribute("width"), e = c && b.test(c);
            b = d && b.test(d);
            c = parseFloat(c);
            if (e || isNaN(c) || 0 > c) a.removeAttribute("height"), c = null;
            d = parseFloat(d);
            if (b || isNaN(d) || 0 > d) a.removeAttribute("width"), d = null;
            return {
                height: c,
                width: d
            };
        }
        function Lk() {
            this.Vf = [];
        }
        Lk.prototype.ia = function(a, b) {
            var c;
            "img" === b ? c = Ik(a) : "video" === b && (c = Kk(a));
            c && this.Vf.push(c.catch(function(d) {
                t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logError(d);
            }));
        };
        Lk.prototype.nc = function() {
            return Promise.all(this.Vf);
        };
        function Mk(a, b, c, d) {
            this.clientRect = a;
            this.contentLocation = b;
            this.nodeData = c;
            this.type = d;
        }
        Mk.prototype.toJSON = function() {
            return {
                clientRect: {
                    height: this.clientRect.height,
                    width: this.clientRect.width,
                    x: this.clientRect.x,
                    y: this.clientRect.y
                },
                locator: this.contentLocation.getLocator().toJSON(),
                nodeData: this.nodeData,
                type: this.type
            };
        };
        function Nk(a, b, c, d) {
            if (d) {
                var e = a.createRange(), f = new Wi(b, Ok);
                S(f, Pk);
                a = null;
                d = 0;
                for(var g = null; f.g;){
                    var h = !0, l = f.g;
                    if (H(l)) {
                        if ("colibrio-ios-nativezoom-preventer" !== l.id) {
                            var m = l.getBoundingClientRect();
                            if (0 < m.width && 0 < m.height && (h = !1, m.top < c)) {
                                a = g;
                                break;
                            }
                        }
                    } else if (Ja(l) && (e.selectNodeContents(l), m = e.getBoundingClientRect(), 0 < m.width && 0 < m.height && (h = !1, m.top < c))) {
                        m.bottom - 1 <= c ? a = g : (c = Qk(c, e, l), c >= l.data.length ? a = g : (a = l, d = c));
                        break;
                    }
                    h || (g = l);
                    S(f, Pk);
                }
                b = null === a ? null === g ? {
                    s: b,
                    i: b.childNodes.length
                } : g.parentNode ? J(g) ? {
                    s: g,
                    i: 0
                } : {
                    s: g.parentNode,
                    i: O(g)
                } : {
                    s: b,
                    i: b.childNodes.length
                } : J(a) ? {
                    s: a,
                    i: d
                } : a.parentNode ? {
                    s: a.parentNode,
                    i: O(a)
                } : {
                    s: b,
                    i: b.childNodes.length
                };
            } else {
                f = a.createRange();
                a = new R(b, Ok);
                S(a, Pk);
                d = null;
                g = 0;
                for(l = null; a.g;){
                    h = !0;
                    e = a.g;
                    if (H(e)) {
                        if ("colibrio-ios-nativezoom-preventer" !== e.id && (m = e.getBoundingClientRect(), 0 < m.top || 0 < m.width && 0 < m.height) && (h = !1, m.bottom > c)) {
                            d = e;
                            break;
                        }
                    } else if (Ja(e) && (f.selectNodeContents(e), m = rb(f.getBoundingClientRect()), 0 < m.width && 0 < m.height && (h = rb(e.parentNode.getBoundingClientRect()), m.top < h.top && (m = new DOMRect(m.x, h.y, m.width, m.height - (h.y - m.y))), h = !1, m.bottom > c))) {
                        m.top + 1 >= c ? d = e : (c = Qk(c, f, e), c >= e.data.length ? (S(a, Pk), d = a.g) : (d = e, g = c));
                        break;
                    }
                    h || (l = e);
                    S(a, Pk);
                }
                b = null === d ? null === l ? {
                    s: b,
                    i: 0
                } : {
                    s: b,
                    i: b.childNodes.length
                } : J(d) ? {
                    s: d,
                    i: g
                } : d.parentNode ? {
                    s: d.parentNode,
                    i: O(d)
                } : {
                    s: b,
                    i: b.childNodes.length
                };
            }
            return b;
        }
        function Rk(a, b, c, d, e) {
            var f;
            J(b.s) ? f = b.s.data.length : f = b.s.childNodes.length;
            if (!c) {
                var g;
                0 >= b.i && J(b.s) ? g = b.s : H(b.s) && (g = 0 < f ? b.s.childNodes[La(b.i, 0, f - 1)] : b.s);
                g && (b = (b = d(g, a)) ? {
                    s: b.parentNode,
                    i: O(b)
                } : {
                    s: a,
                    i: 0
                });
            } else if (c) {
                var h;
                b.i >= f && J(b.s) ? h = b.s : H(b.s) && (h = 0 < f ? b.s.childNodes[La(b.i, 0, f - 1)] : b.s);
                h && (b = (b = e(h, a)) ? {
                    s: b.parentNode,
                    i: O(b)
                } : {
                    s: a,
                    i: a.childNodes.length
                });
            }
            return b;
        }
        function Ok(a) {
            if (Ja(a)) return !0;
            var b = !a.hasChildNodes() || ob(a) || Fa(a) || nb(a);
            return !(I(a) && "script" === a.localName) && H(a) && b;
        }
        function Qk(a, b, c) {
            var d = /^\s*/.exec(c.data), e = 1 + (d ? d[0].length : 0);
            return ya(c, 2, c.data.length, function(f, g) {
                b.setStart(f, La(g, e, f.data.length));
                b.setEnd(f, f.data.length);
                f = b.getBoundingClientRect().top;
                return f > a ? -1 : f < a ? 1 : 0;
            });
        }
        function Pk(a) {
            var b;
            (b = a.ownerDocument) && b.defaultView ? I(a) ? (b = b.defaultView.getComputedStyle(a), b = "sticky" === b.position || "fixed" === b.position) : b = !1 : b = !1;
            return !b && !ob(a) && !(I(a) && "script" === a.localName) && !Fa(a) && !nb(a);
        }
        function Sk(a) {
            if (0 === a.length) return [];
            for(var b = [], c = a[0], d = 1; d < a.length; d++){
                var e = a[d], f;
                if (f = 1 === c.J && 1 === e.J) {
                    f = c.Hb;
                    var g = e.Hb;
                    f = Tk(f, g) || Tk(g, f);
                }
                if (f) {
                    f = e.cc;
                    g = c.dc;
                    c = c.Hb;
                    e = e.Hb;
                    var h = Math.min(c.left, e.left), l = Math.min(c.top, e.top);
                    e = new DOMRect(h, l, Math.max(c.right, e.right) - h, Math.max(c.bottom, e.bottom) - l);
                    c = {
                        cc: f,
                        dc: g,
                        Hb: e,
                        J: 1
                    };
                } else b.push(c), c = e;
            }
            b.push(c);
            return b;
        }
        function Uk(a) {
            var b = a.startOffset, c = a.Dh, d = a.Lh, e = a.range, f = a.Zh;
            if (4 < a.Ph) {
                a = b + c;
                for(var g = 0; a < d && 2 > g;)a = Math.min(a + c, d), e.setEnd(f, a), g = e.getClientRects().length;
                a = Math.min(a, d);
            } else a = d;
            c = za(e, 1, b + 1, a - b, function(l, m) {
                l.setEnd(f, m);
                return 1 >= l.getClientRects().length ? 1 : -1;
            });
            c === b && c < d && c++;
            e.setEnd(f, c);
            b = e.getClientRects();
            var h;
            b = null != (h = Vk(b)) ? h : new DOMRect(0, 0, 0, 0);
            return {
                Nh: c,
                rect: rb(b)
            };
        }
        function Vk(a) {
            if (1 < a.length) {
                for(var b = a[0], c = 1; c < a.length; c++){
                    var d = a[c];
                    d.top > b.top && (b = d);
                }
                return b;
            }
            return 1 === a.length ? a[0] : null;
        }
        function Tk(a, b) {
            var c = Math.min(.2 * a.height, .2 * b.height);
            return a.top - c <= b.top && a.bottom + c >= b.bottom;
        }
        function Wk(a, b, c) {
            var d = [];
            a = Xk(a, c);
            b = Xk(b, c);
            var e = a;
            var f = b;
            if (e.s === f.s) e = e.i <= f.i;
            else {
                var g = e.s;
                g = (g && 9 === g.nodeType ? e.s : e.s.ownerDocument).createRange();
                g.setStart(e.s, e.i);
                g.collapse(!0);
                e = 0 < Xa(g, f.s, f.i);
            }
            if (!e) return [];
            if (J(a.s) && b.s === a.s) Yk(d, c.Hd(a.s, a.i, b.i));
            else {
                a: {
                    e = a.s;
                    if (H(e)) {
                        if (a.i < e.childNodes.length) {
                            e = {
                                Ge: !1,
                                Je: !1,
                                lc: e.childNodes[a.i]
                            };
                            break a;
                        }
                    } else if (J(e) && a.i < e.data.length) {
                        e = {
                            Ge: !0,
                            Je: !1,
                            lc: e
                        };
                        break a;
                    }
                    e = {
                        Ge: !1,
                        Je: !0,
                        lc: e
                    };
                }
                f = b.s;
                f = H(f) ? b.i < f.childNodes.length ? {
                    aa: f.childNodes[b.i],
                    Zd: !1,
                    ee: !0
                } : {
                    aa: f,
                    Zd: !1,
                    ee: !1
                } : !J(f) || 0 >= b.i ? {
                    aa: f,
                    Zd: !1,
                    ee: !0
                } : {
                    aa: f,
                    Zd: !0,
                    ee: !1
                };
                g = new R(e.lc);
                g.aa = f.aa;
                e.Je ? S(g, !1) : e.Ge && J(a.s) && (Yk(d, c.Hd(a.s, a.i, a.s.data.length)), S(g, !1));
                for(; g.g;){
                    if (g.g === f.aa) {
                        if (f.ee) break;
                        if (f.Zd && J(f.aa)) {
                            Yk(d, c.Hd(f.aa, 0, b.i));
                            break;
                        }
                    }
                    H(g.g) ? (Yk(d, c.Fg(g.g)), S(g, c.We(g.g))) : (J(g.g) && Yk(d, c.Hd(g.g, 0, g.g.data.length)), S(g, !1));
                }
            }
            return d;
        }
        function Xk(a, b) {
            var c = a.s;
            H(c) || (c = c.parentNode);
            for(var d = null; H(c);)b.We(c) || (d = c), c = c.parentNode;
            return d && d.parentNode ? {
                s: d.parentNode,
                i: O(d) + 1
            } : a;
        }
        function Yk(a, b) {
            Pa(b) ? a.push.apply(a, q.Qc(b)) : Ka(b) || a.push(b);
        }
        function Zk(a, b) {
            a = Wk(a, b, {
                We: function(c) {
                    return !lb(c.tagName);
                },
                Fg: function(c) {
                    if (mf(c)) {
                        var d = rb(c.getBoundingClientRect()), e = c.parentNode;
                        if (e) return c = O(c), {
                            cc: {
                                s: e,
                                i: c + 1
                            },
                            dc: {
                                s: e,
                                i: c
                            },
                            Hb: d,
                            J: 2
                        };
                    }
                },
                Hd: function(c, d, e) {
                    var f = c.parentNode, g;
                    if (g = H(f)) g = (g = f.ownerDocument.defaultView) ? "visible" === g.getComputedStyle(f).visibility : !1;
                    if (g) {
                        g = c.ownerDocument.createRange();
                        g.setStart(c, d);
                        g.setEnd(c, e);
                        var h = g.getClientRects();
                        if (0 === h.length) c = [];
                        else {
                            f = [];
                            var l = (e - d) / h.length | 0, m = h.length;
                            if (e === d) c = {
                                s: c,
                                i: d
                            }, e = Vk(h), f.push({
                                cc: c,
                                dc: c,
                                Hb: e ? rb(e) : new DOMRect(0, 0, 0, 0),
                                J: 1
                            });
                            else for(; d < e;){
                                h = Uk({
                                    Dh: l,
                                    Lh: e,
                                    Ph: m,
                                    range: g,
                                    startOffset: d,
                                    Zh: c
                                });
                                var n = h.Nh;
                                f.push({
                                    cc: {
                                        s: c,
                                        i: n
                                    },
                                    dc: {
                                        s: c,
                                        i: d
                                    },
                                    Hb: h.rect,
                                    J: 1
                                });
                                d = n;
                                g.setStart(c, d);
                                m--;
                            }
                            c = f;
                        }
                    } else c = [];
                    return c;
                }
            }).filter(function(c) {
                return 0 < c.Hb.width || 0 < c.Hb.height;
            });
            return Sk(a);
        }
        function $k(a, b, c) {
            return Wk(b, c, {
                We: function(d) {
                    return !lb(d.localName);
                },
                Fg: function(d) {
                    if (mf(d) || 0 === d.childNodes.length) {
                        if (d = d.getBoundingClientRect(), 0 < d.width && 0 < d.height) return d;
                    }
                },
                Hd: function(d, e, f) {
                    var g = a.createRange();
                    g.setStart(d, e);
                    g.setEnd(d, f);
                    d = g.getClientRects();
                    return Array.from(d).filter(function(h) {
                        return 0 < h.width && 0 < h.height;
                    });
                }
            });
        }
        function al(a) {
            return a ? H(a) ? (a = a.getBoundingClientRect(), 0 < a.width && 0 < a.height) : J(a) ? !Ia(a.data) : !1 : !1;
        }
        function bl(a, b) {
            var c = M(a.ownerDocument);
            b < a.childNodes.length ? a = a.childNodes[b] : (a = new R(a.lastChild || a), a.aa = c, S(a, !1), a = a.g);
            if (a && (a = new R(a, al), a.aa = c, a = a.next(!0))) {
                if (J(a)) {
                    c = a.ownerDocument.createRange();
                    if (Ga(a.data)) {
                        b = /^\s*/.exec(a.data);
                        b = Math.max(1 + (b ? b[0].length : 0), 0);
                        var d = Math.min(a.data.length, Math.max(b + 1, 1));
                        b >= d ? c = null : (c.setStart(a, b), c.setEnd(a, d));
                    } else c = null;
                    if (!c) return null;
                    c = c.getBoundingClientRect();
                } else c = a.getBoundingClientRect();
                return new DOMRect(c.left, c.top);
            }
            c = c.getBoundingClientRect();
            return new DOMRect(c.left, c.bottom);
        }
        function cl(a, b, c) {
            var d, e = M(a);
            if (!e || Fa(e)) return null;
            b = dc(b, e);
            var f = b.s;
            H(b.s) && (f = b.s.childNodes[Math.min(b.s.childNodes.length - 1, b.i)]);
            f || (f = b.s);
            c ? d = new R(f, Ok) : d = new Wi(f, Ok);
            d.aa = M(a);
            S(d, function(g) {
                return g !== f;
            });
            a = d.g;
            if (!a) return null;
            a = bc(a);
            if (!a) return null;
            c = Rk(e, dc(a, e), c, af, cf);
            return cc(c.s, c.i);
        }
        function dl(a, b) {
            this.I = a;
            this.l = b;
            this.g = this.Ha = this.ya = null;
        }
        k = dl.prototype;
        k.destroy = function() {
            this.Ha && (URL.revokeObjectURL(this.Ha), this.Ha = null);
        };
        k.lg = function(a, b, c) {
            a = a.contentDocument;
            if (!a) return Promise.resolve([]);
            try {
                var d = el(this, a, b, c);
                if (d) {
                    b = Promise;
                    var e = b.resolve, f = d.he, g = d.Ze, h = t.BrowserDetector.isOS("iOS");
                    d = [];
                    if (!g) {
                        c = null;
                        if (H(f.s)) {
                            var l = f.i < f.s.childNodes.length ? f.s.childNodes[f.i] : null;
                            if (al(l)) {
                                if (H(l)) c = l.getBoundingClientRect();
                                else if (J(l) && 0 < l.data.length) {
                                    var m = a.createRange();
                                    m.selectNode(l);
                                    c = m.getBoundingClientRect();
                                    m.detach();
                                }
                            } else c = bl(f.s, f.i);
                        } else if (J(f.s)) {
                            if (al(f.s)) {
                                var n = f.s, p = f.i, u = a.createRange();
                                n.data[p] ? (u.setStart(n, p), u.setEnd(n, p + 1)) : 0 < p && (u.setStart(n, p - 1), u.setEnd(n, p));
                                c = u.getBoundingClientRect();
                            } else c = bl(f.s, f.i);
                        }
                        c && d.push({
                            bottom: c.top,
                            height: 0,
                            left: c.left,
                            right: c.left,
                            top: c.top,
                            width: 0
                        });
                    }
                    if (0 === d.length && g && f.s && g.s && (d = $k(a, f, g), h && 1 < d.length)) {
                        var v = d[d.length - 1];
                        0 === v.left && 0 === v.top && d.pop();
                    }
                    var w = e.call(b, d);
                } else w = Promise.resolve([]);
                return w;
            } catch (x) {
                return Promise.reject(x);
            }
        };
        k.mg = function(a, b, c, d) {
            var e = a.contentDocument;
            if (!e || !this.ya) return Promise.resolve(null);
            a = M(e);
            b = Nk(e, a, b, c);
            d && I(a) && (b = Rk(a, b, c, Ze, Xe));
            var f;
            c = cc(b.s, b.i);
            d = null;
            c && (d = ad(c, this.ya.T));
            d && (f = this.ob(d, null));
            f || (f = this.l.F.getContentLocation());
            return Promise.resolve(f);
        };
        k.fetchContentRangeByTopOffsets = function(a, b, c) {
            var d = a.contentDocument;
            if (!d || !this.ya) return Promise.resolve(null);
            a = M(d);
            b = Nk(d, a, b, !1);
            c = Nk(d, a, c, !0);
            I(a) && (b = Rk(a, b, !1, Ze, Xe), c = Rk(a, c, !0, Ze, Xe));
            a = cc(b.s, b.i);
            c = cc(c.s, c.i);
            return a && c ? (a = ad(a, this.ya.T), c = ad(c, this.ya.T), Promise.resolve(this.ob(a, c))) : Promise.resolve(null);
        };
        k.fetchContentRangesByTopOffsets = function(a, b) {
            var c = a.contentDocument;
            if (!c || !this.ya) return Promise.reject(new T("DOCUMENT_NOT_RENDERED"));
            var d = M(c);
            a = this.l.da;
            if (0 === M(a).childNodes.length) return Promise.resolve({
                next: null,
                previous: null,
                visible: this.ob({
                    v: [],
                    i: 0
                }, null)
            });
            var e = Array(4), f = [];
            if (I(d)) for(var g = 0; g < e.length; g++){
                var h = 2 <= g;
                e[g] = Nk(c, d, b[g], h);
                e[g] = Rk(d, e[g], h, Ze, Xe);
                h = cc(e[g].s, e[g].i);
                f[g] = h ? ad(h, this.ya.T) : null;
            }
            b = f[1];
            c = f[2];
            if (b && c) {
                if (0 === $b(c, b) && (c = cl(a, c, !0), null === c)) return Promise.resolve({
                    next: null,
                    previous: null,
                    visible: null
                });
            } else return Promise.resolve({
                next: null,
                previous: null,
                visible: null
            });
            (d = f[0]) && b && 0 <= $b(d, b) && (d = cl(a, b, !1));
            f = f[3];
            c && f && 0 >= $b(f, c) && (f = cl(a, c, !0));
            a = null;
            e = this.ob(b, c);
            g = null;
            d && (a = this.ob(d, b));
            f && (g = this.ob(c, f));
            return Promise.resolve({
                next: g,
                previous: a,
                visible: e
            });
        };
        k.ng = function(a, b, c, d) {
            a = a.contentDocument;
            try {
                if (!a || !this.ya) throw new U("fetchContentRects failed: Document not rendered.");
                var e = el(this, a, b, c);
                if (!e) throw new U("fetchContentRects received unexpected DOM positions.");
                var f = Zk(e.he, e.Ze || e.he);
                if (d.includeNodeData) {
                    var g = D.EngineEventTargetNodeUtils.createEventTargetXmlElementNodeData;
                    b = [];
                    for(var h = a.createRange(), l = q.na(f), m = l.next(); !m.done; m = l.next()){
                        var n = m.value;
                        h.setStart(n.dc.s, n.dc.i);
                        h.setEnd(n.cc.s, n.cc.i);
                        var p = h.commonAncestorContainer;
                        H(p) || (p = p.parentNode);
                        var u = g(p);
                        b.push(u || void 0);
                    }
                    var v = b;
                } else v = null;
                g = [];
                for(h = 0; h < f.length; h++){
                    var w = f[h];
                    l = void 0;
                    var x = null == (l = v) ? void 0 : l[h];
                    l = w;
                    m = x;
                    var A = this.l, z = this.ya.T, C = cc(l.dc.s, l.dc.i), F = cc(l.cc.s, l.cc.i);
                    if (C && F) {
                        var G = bd(C, F, A.da, z, A.ta, A.F.getReaderPublication(), A.F, A.N);
                        var L = new Mk(l.Hb, G, m, l.J);
                    } else t.Logger.logError(new U("Failed to create EpubContentLocation from content rect")), L = void 0;
                    (l = L) && g.push(l);
                }
                return Promise.resolve(g);
            } catch (P) {
                return Promise.reject(P);
            }
        };
        k.og = function() {
            if (!this.Ha) {
                var a = this.bf();
                this.Ha = URL.createObjectURL(new Blob([
                    a
                ], {
                    type: this.I.Da
                }));
            }
            return this.Ha;
        };
        k.bf = function() {
            this.g || (this.g = this.I.yc);
            return this.g;
        };
        k.pg = function() {
            return this.I;
        };
        k.qg = function() {
            return this.l;
        };
        k.print = function(a) {
            var b;
            null == a || null == (b = a.contentWindow) || b.print();
        };
        k.setContentSelection = function(a, b, c) {
            var d = this, e, f, g, h, l;
            return q.K(function(m) {
                e = a.contentDocument;
                if (!e) throw new U("setContentSelection failed: Document not rendered.");
                f = el(d, e, b, c);
                if (!f) throw new U("setContentSelection failed: received unexpected DOM positions.");
                g = e.getSelection();
                if (!g) throw new U("setContentSelection failed: Selection API not available.");
                h = f.he;
                (l = f.Ze) ? g.setBaseAndExtent(h.s, h.i, l.s, l.i) : g.setPosition(h.s, h.i);
                return m.return(Promise.resolve());
            });
        };
        k.ob = function(a, b) {
            var c = this.l.F, d = cd(a, b, this.l.da, c.getSourceContentDocument(), this.l.N);
            return new X(d, [
                c
            ], c.getReaderPublication(), {
                Ca: !1,
                O: b,
                Ka: !0,
                P: a
            });
        };
        function el(a, b, c, d) {
            a = a.Ad();
            if (!a) throw new U("mapSrcDomPositionsToDom failed: DOM mutation records not available.");
            b = M(b);
            c = Te(c, a);
            c = dc(c, b);
            if (c.s) {
                var e = null;
                d && (d = Te(d, a), e = dc(d, b), e.s || (e = null));
                return {
                    Ze: e,
                    he: c
                };
            }
        }
        function fl(a, b, c) {
            dl.call(this, a, b);
            this.eg = c;
            this.Cf = null;
            this.ma = new Db;
            this.Ia = this.B = null;
            this.$f = !0;
            this.Ib = 0;
            this.nb = !1;
            this.Jc = null;
            this.Ff = 0;
            this.Pb = a.Ob;
        }
        q.inherits(fl, dl);
        k = fl.prototype;
        k.destroy = function() {
            this.Ia && this.Ia.destroy();
            this.ma.pb();
            this.ma.destroy();
            this.Jc = this.B = null;
            this.nb = !1;
            dl.prototype.destroy.call(this);
        };
        k.af = function(a, b, c, d) {
            var e = this, f, g, h, l, m, n, p, u, v;
            return q.K(function(w) {
                f = a.contentDocument;
                if (!f) throw new T("DOCUMENT_NOT_RENDERED");
                var x = e.Ad();
                if (!x) throw new U("Attempted to get domMutator before iframe was loaded");
                g = new lc(new hc(x));
                if (e.Jc) {
                    x = e.Jc;
                    var A = g.Ra.g;
                    if (A[A.length - 1] !== x.mh) throw new U("DomMutator: wrapText result record does not match last record");
                    var z = x.td.parentElement;
                    if (!z) throw new U("DomMutator: wrapText result element has no parent");
                    A.pop();
                    z.replaceChild(x.td.childNodes[0], x.td);
                    z.normalize();
                    e.Jc = null;
                }
                if (!c.focusOnPageContainer && !c.focusOnPageBodyElement && !c.focusNearContentLocation && c.focusTargetOptions.target === D.FocusOnReadingPositionTarget.NONE) return w.return();
                h = null;
                if (c.focusOnPageContainer) h = a;
                else if (c.focusOnPageBodyElement) h = f.body;
                else switch(l = Te(b, g.Ra.g), m = dc(l, f.body), n = c, p = n.focusTargetOptions, p.target){
                    case D.FocusOnReadingPositionTarget.NEAREST_ELEMENT:
                        h = dj(m);
                        break;
                    case D.FocusOnReadingPositionTarget.NEAREST_CHARACTER:
                    case D.FocusOnReadingPositionTarget.NEAREST_WORD:
                    case D.FocusOnReadingPositionTarget.NEAREST_SENTENCE:
                        u = "grapheme";
                        p.target === D.FocusOnReadingPositionTarget.NEAREST_WORD ? u = "word" : p.target === D.FocusOnReadingPositionTarget.NEAREST_SENTENCE && (u = "sentence");
                        if ((h = Xi(m, u, d)) && !Pa(h) && "object" === typeof h && J(h.Ne) && K(h.i)) {
                            z = h;
                            x = g;
                            A = cj(z.Ne, z.i, {
                                direction: "forward",
                                granularity: u,
                                publicationLanguage: void 0 === d ? null : d
                            });
                            var C = z.Ne;
                            z = z.i;
                            var F = ac(C), G = C.data.length;
                            if (!F) throw new U("Text node not attached to container");
                            if (0 > z || 0 > A || z >= A || A > C.data.length) throw new U("Invalid startOffset or endOffset: startOffset=" + z + ", endOffset=" + A);
                            var L = C.ownerDocument, P = C.parentElement;
                            if (!P) throw new U("Text node has no parent");
                            var Y = C.data.length;
                            0 < z && (C = C.splitText(z));
                            A < Y && C.splitText(A - z);
                            L = L.createElement("x-colibrio-focus");
                            P.replaceChild(L, C);
                            L.appendChild(C);
                            A = {
                                v: F,
                                sb: 3,
                                Db: A,
                                i: z,
                                Oe: G,
                                J: 10
                            };
                            x.Ra.g.push(A);
                            x = {
                                mh: A,
                                td: L
                            };
                            x.td.style.cssText = "all: unset !important";
                            v = x;
                            h = v.td;
                            e.Jc = v;
                        }
                        break;
                    default:
                        c.focusNearContentLocation && (h = dj(m));
                }
                if (H(h)) return w.return(gl(e, h));
                throw new T(t.ColibrioErrorType.FOCUS_TARGETS_END_OF_DOCUMENT);
            });
        };
        function gl(a, b) {
            var c, d;
            return q.K(function(e) {
                if (1 == e.g) return c = M(b.ownerDocument), c.hasAttribute("tabindex") || c.setAttribute("tabindex", "-1"), b.hasAttribute("tabindex") || mb(b) || b.setAttribute("tabindex", "-1"), d = ++a.Ff, b.ownerDocument.activeElement === b && window.__colibrioAndroid ? (b.blur(), r(e, ub(500), 3)) : r(e, ub(100), 3);
                if (!a.nb || d !== a.Ff) throw new T(t.ColibrioErrorType.ABORTED);
                b.focus({
                    preventScroll: !0
                });
                e.g = 0;
            });
        }
        k.Rc = function() {
            if (!this.Ha) return null;
            if (!this.Ia) {
                var a = this.l.F.getReaderPublication();
                this.Ia = new yk(a);
                hl(this);
            }
            return this.Ia;
        };
        k.Bd = function() {
            return this.Cf;
        };
        k.yg = function(a) {
            this.ma.hb();
            this.nb = !1;
            a.setAttribute("aria-hidden", "true");
            a.setAttribute("tabindex", "-1");
        };
        k.lf = function(a, b, c) {
            var d = this, e, f, g, h, l, m, n, p, u, v, w;
            return q.K(function(x) {
                switch(x.g){
                    case 1:
                        if (d.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                        d.Ib++;
                        e = d.Ib;
                        if (!a.contentDocument) throw new U("SameOrigin onIframeLoaded: iframeElement.contentDocument not available!");
                        d.ya = {
                            T: b,
                            B: a
                        };
                        if (!(0 < d.Pb.length)) {
                            x.$(2);
                            break;
                        }
                        return r(x, d.Vc(a, e, d.ya.T, [
                            new Dk(d.Pb)
                        ]), 2);
                    case 2:
                        if (!d.I.ic) {
                            x.$(4);
                            break;
                        }
                        return r(x, d.Vc(a, e, d.ya.T, [
                            new Lk
                        ]), 5);
                    case 5:
                        return r(x, d.Vc(a, e, d.ya.T, [
                            new Vi,
                            new Ui
                        ]), 6);
                    case 6:
                        return f = d.l.G.getReaderViewOptions().publicationStyleOptions, h = null != (g = f.fontSizeScaleFactor) ? g : 1, l = d.l.M.contentProcessingOptions, m = t.BrowserDetector.isOS("iOS") && t.BrowserDetector.getOsVersion().startsWith("12."), n = new Mi(l.horizontalOverflowMitigationMinFontSize, h, l.horizontalOverflowTableStrategy, l.horizontalOverflowMathMLStrategy, m), p = d.jf(a.contentDocument), u = f.removePublicationDefinedHorizontalPageMargins && !p ? [
                            new Gi,
                            n
                        ] : [
                            n
                        ], r(x, d.Vc(a, e, b, u), 4);
                    case 4:
                        if (!a.contentDocument) throw new U("SameOrigin onIframeLoaded: iframeElement.contentDocument not available!");
                        d.B = a;
                        v = a.contentDocument.documentElement;
                        il(v, d.l.M.reflowOptions);
                        d.eg && jl(d.eg, v, b, d.l.M.contentProcessingOptions.verticalOverflowMitigationStrategy, d.l.tb.pathname);
                        d.$f && (kl(d, c), d.$f = !1);
                        Fb(d.ma, v);
                        d.ma.eb();
                        (w = d.l.ta.getLayout() === sa.ContentDocumentLayout.REFLOWABLE) && d.I.ic && (a.style.height = a.contentDocument.documentElement.scrollHeight + "px");
                        hl(d);
                        return x.return(new Promise(function(A, z) {
                            setTimeout(function() {
                                e === d.Ib ? (a.style.visibility = "", A()) : z(new T(t.ColibrioErrorType.ABORTED));
                            }, 0);
                        }));
                }
            });
        };
        k.mf = function(a) {
            this.Ia && Ak(this.Ia, null);
            this.ya = this.Jc = null;
            this.Ib++;
            this.ma.pb();
            a.style.visibility = "hidden";
            this.B = null;
        };
        k.le = function(a) {
            this.nb = !0;
            this.ma.ib();
            a.removeAttribute("aria-hidden");
            a.setAttribute("tabindex", "0");
        };
        k.sf = function(a) {
            a.setAttribute("nwdisable", "true");
            a.setAttribute("scrolling", "no");
            a.setAttribute("aria-hidden", "true");
            a.style.display = "block";
            a.style.overflow = "hidden";
            a.style.visibility = "hidden";
        };
        k.Ad = function() {
            var a, b;
            return null != (b = null == (a = this.ya) ? void 0 : a.T) ? b : null;
        };
        function kl(a, b) {
            if (!a.ya) throw new U("Attempted to add directive factories before iframe was loaded");
            var c = a.l.G, d = a.l.kc, e = a.l.F.getReaderPublication().getReadingSystemEngine().getEventBus();
            Eb(a.ma, new Oj(c, b));
            Eb(a.ma, new Fj);
            Eb(a.ma, new Dj);
            Eb(a.ma, new wj(a.l.G.getEngineEventDispatcher(), a.l.M.clipboardOptions));
            (b = a.I.gb) && Eb(a.ma, new Hj(b, d));
            a.l.M.preventDefaultContextMenuOnMediaElements && Eb(a.ma, new zj);
            a.l.M.preventDefaultContextMenu && Eb(a.ma, new yj);
            (a.l.M.preventDragAndDropActions || c.getReaderViewOptions().gestureOptions.swipeNavigation.pointerTypes.mouse) && Eb(a.ma, new Jj);
            (c = a.l.Xd) && Eb(a.ma, new bk(a.I, a.l, c, a.ya.T));
            Eb(a.ma, new Uj(a.l.M));
            Eb(a.ma, new ok(e, a.I, a.l, a.l.M, a.ya.T));
            Eb(a.ma, new uj(e, a.I, a.l, a.ya.T));
            Eb(a.ma, new Sj(a.I, a.l, a.ya.T));
            Eb(a.ma, new sk(a.l, a.ya.T));
            Eb(a.ma, new jj(function(f) {
                return a.Cf = f;
            }));
            Eb(a.ma, new gj);
            Eb(a.ma, new Qj);
            Eb(a.ma, new lj);
            Eb(a.ma, new vk(a.l.G));
            Eb(a.ma, new dk);
            a.l.M.contentProcessingOptions.addTabIndexToMediaElements && Eb(a.ma, new Wj);
        }
        k.hf = function(a) {
            if (this.I.Ta && 0 < this.I.Ta.length) try {
                return null !== a.querySelector(this.I.Ta.join(", "));
            } catch (b) {
                return !0;
            }
            else return !1;
        };
        k.jf = function(a) {
            return this.I.vb || this.hf(a);
        };
        function hl(a) {
            a.B && a.B.contentDocument && a.Ia && Ak(a.Ia, a.B.contentDocument);
        }
        function il(a, b) {
            a.querySelectorAll("[data-colibrio-fragmented-at-end]").forEach(function(c) {
                c.style.setProperty("border-bottom", "none", "important");
                c.style.setProperty("border-bottom-right-radius", "0", "important");
                c.style.setProperty("border-bottom-left-radius", "0", "important");
                c.style.setProperty("height", "auto", "important");
                b.removeBottomMarginsOnFragmentedElements && (c.style.setProperty("margin-bottom", "0", "important"), c.style.setProperty("padding-bottom", "0", "important"));
            });
        }
        k.Vc = function(a, b, c, d) {
            var e = this, f, g, h;
            return q.K(function(l) {
                if (1 == l.g) {
                    f = a.contentDocument;
                    if (!f) throw new T(t.ColibrioErrorType.ABORTED);
                    g = new Ob;
                    Pb(g, d);
                    h = new lc(new hc(c));
                    return r(l, g.transform(f, h), 2);
                }
                if (e.Ib !== b || e.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                l.g = 0;
            });
        };
        function ll(a, b, c, d, e, f) {
            qh.call(this, d, e, f);
            this.Ba = a;
            this.ua = b;
            this.Z = c;
        }
        q.inherits(ll, qh);
        ll.prototype.Ma = function(a) {
            this.Ba.addEventListener("message", a, !1);
        };
        ll.prototype.Sa = function(a) {
            if (a.source !== this.ua || !a.data || "*" !== this.Z && this.Z !== a.origin) return !1;
            a = a.data;
            return K(a.type) && K(a.msgId);
        };
        ll.prototype.m = function(a, b) {
            b ? this.ua.postMessage(a, this.Z, b) : this.ua.postMessage(a, this.Z);
        };
        ll.prototype.Za = function(a) {
            this.Ba.removeEventListener("message", a, !1);
        };
        function ml() {
            this.D = this.g = null;
            this.h = this.L = !1;
        }
        k = ml.prototype;
        k.destroy = function() {
            this.L = !0;
            this.D = null;
        };
        k.pause = function() {};
        k.play = function() {};
        k.ne = function(a) {
            this.L || this.g === a || (this.g = a, this.D && Qf(this.D, {
                elemId: a ? a.xc ? xk(a.xc) : null : null,
                type: 33
            }));
        };
        function nl(a, b) {
            a.L || (a.D = b, a.h && ol(a), b && a.g && (a = a.g, Qf(b, {
                elemId: a ? a.xc ? xk(a.xc) : null : null,
                type: 33
            })));
        }
        k.setMuted = function() {};
        k.oe = function(a) {
            this.h = !a;
            ol(this);
        };
        k.setVolume = function() {};
        function ol(a) {
            !a.L && a.D && Qf(a.D, {
                playing: a.h,
                type: 32
            });
        }
        var pl = E.event.MouseEngineEvent, ql = E.event.NavigationIntentEngineEvent, rl = E.event.PointerEngineEvent, sl = E.event.SelectionChangedEngineEvent, tl = 1;
        function ul(a, b, c) {
            var d = this;
            this.I = a;
            this.l = b;
            this.g = c;
            this.h = new Map;
            this.D = null;
            this.m = new Map;
            this.L = !1;
            this.o = 0;
            this.H = this.A = null;
            this.j = new Map;
            this.U = !1;
            this.F = b.F;
            this.Pa = b.F.getIndexInSpine();
            this.Na = b.kc;
            this.Z = function(e) {
                d.D && Qf(d.D, {
                    iframeStorageId: d.A,
                    key: e.sc,
                    target: 0,
                    type: 37,
                    value: e.ca
                });
                d.A = null;
            };
            this.l.jc.h.add(this.Z);
            this.ja = function(e) {
                d.D && Qf(d.D, {
                    iframeStorageId: d.H,
                    key: e.sc,
                    target: 1,
                    type: 37,
                    value: e.ca
                });
                d.H = null;
            };
            this.l.wc.h.add(this.ja);
        }
        function vl(a) {
            var b;
            return (null != (b = a.iframeId) ? b : "") + ":" + a.instanceId;
        }
        function wl(a, b) {
            return {
                key: a,
                type: 39,
                value: b
            };
        }
        k = ul.prototype;
        k.destroy = function() {
            var a = this;
            if (!this.L) {
                this.L = !0;
                this.j.forEach(function(c) {
                    c.cancel().catch(function(d) {
                        t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logWarning(d);
                    });
                });
                this.l.jc.h.remove(this.Z);
                this.l.wc.h.remove(this.ja);
                this.D = null;
                var b = this.l.G;
                b.removeReaderViewPropertyChangedListener("clearContentSelection", this);
                b.removeReaderViewPropertyChangedListener("contentDocumentEventHandlersEnabled", this);
                b.removeReaderViewPropertyChangedListener("contentSelectionEnabled", this);
                b.removeReaderViewPropertyChangedListener("activeTransform", this);
                this.h.forEach(function(c) {
                    return xl(a, c, !0);
                });
                yl(this);
            }
        };
        k.rg = function(a) {
            switch(a.type){
                case 1:
                    this.U = !0;
                    break;
                case 2:
                    var b = this.l.G.getReaderView().getSyncMediaPlayer();
                    if (b) switch(a.action){
                        case "start":
                            b.play();
                            break;
                        case "stop":
                            b.pause();
                            break;
                        case "startstop":
                            !b.isPaused() && b.isReady() ? b.pause() : b.play();
                    }
                    break;
                case 5:
                    b = this.l.bc;
                    if (!this.L && null === b) {
                        if (a.height !== parseInt(this.g.style.height || "", 10) && (this.g.style.height = a.height + "px", b = this.l.G.getRendererRuntime(), b.onContentHeightChanged)) b.onContentHeightChanged();
                        this.I.ic || this.g.style.transform || (b = this.l.G.getUnconstrainedPageDimensions(this.l.ta.getPageSpreadSlot()).height, K(b) && a.height > b + 1 && (a = b / a.height, this.g.style.transform = "scale(" + a + ")", this.g.setAttribute("data-colibrio-iframe-scale-factor", "" + a), this.g.style.transformOrigin = "50% 0"));
                    }
                    break;
                case 30:
                    if (Qa(KeyboardEvent)) {
                        b = a.engineEventDef;
                        var c = new KeyboardEvent(a.engineEventType, {
                            code: b.code,
                            isComposing: b.isComposing,
                            key: b.key,
                            keyCode: b.keyCode,
                            location: b.location,
                            repeat: b.repeat
                        });
                        var d = b.defaultPrevented ? D.ReaderDocumentEventState.DEFAULT_PREVENTED : b.processedByDocument ? D.ReaderDocumentEventState.PROCESSED : D.ReaderDocumentEventState.NOT_PROCESSED;
                        var e = null;
                        b.containerPath && (e = {
                            v: b.containerPath,
                            i: b.nodeOffset
                        });
                        a = {
                            contentLocation: e && !a.iframeResourceId ? this.Xa(e, null) : this.F.getContentLocation(),
                            frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                            mediaType: this.I.Da,
                            nodeData: b.nodeData
                        };
                        this.l.G.getEngineEventDispatcher().dispatchKeyboardEvent(c, a, d, b.isTrusted, b.modifiers);
                    }
                    break;
                case 31:
                    xl(this, a, !1);
                    break;
                case 34:
                    b = a.engineEventDef;
                    c = zl(this, b);
                    d = c.clientRect;
                    e = c.scale;
                    var f = b.nodeData && Al(this, b.nodeData);
                    d = {
                        button: b.button,
                        buttons: b.buttons,
                        cancelable: !0,
                        clientX: e * b.clientX + d.left,
                        clientY: e * b.clientY + d.top,
                        ctrlKey: b.ctrlKey,
                        mediaResource: f,
                        metaKey: b.metaKey,
                        pageX: e * b.clientX + d.left + window.scrollX,
                        pageY: e * b.clientY + d.top + window.scrollY,
                        readerDocumentEventState: c.jg,
                        readerView: this.l.G.getReaderView(),
                        screenX: b.screenX,
                        screenY: b.screenY,
                        target: {
                            contentLocation: c.qe && !a.iframeResourceId ? this.Xa(c.qe, null) : this.F.getContentLocation(),
                            frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                            mediaType: this.I.Da,
                            nodeData: b.nodeData
                        },
                        userGenerated: b.isTrusted
                    };
                    c = this.F.getReaderPublication().getReadingSystemEngine().getEventBus();
                    d = new pl(a.engineEventType, d, null);
                    c.emit(d);
                    b.href && this.l.G.getReaderViewProperty("contentDocumentEventHandlersEnabled") && Bl(this, b.href, d, a.iframeResourceId);
                    break;
                case 36:
                    b = a.engineEventDef;
                    c = zl(this, b);
                    d = c.scale;
                    e = c.clientRect;
                    c = {
                        button: b.button,
                        buttons: b.buttons,
                        cancelable: !0,
                        clientX: d * b.clientX + e.left,
                        clientY: d * b.clientY + e.top,
                        ctrlKey: b.ctrlKey,
                        isPrimary: b.isPrimary,
                        mediaResource: null,
                        metaKey: b.metaKey,
                        pageX: d * b.clientX + e.left + window.scrollX,
                        pageY: d * b.clientY + e.top + window.scrollY,
                        pointerId: b.pointerId,
                        pointerType: b.pointerType,
                        readerDocumentEventState: c.jg,
                        readerView: this.l.G.getReaderView(),
                        screenX: b.screenX,
                        screenY: b.screenY,
                        target: {
                            contentLocation: c.qe && !a.iframeResourceId ? this.Xa(c.qe, null) : this.F.getContentLocation(),
                            frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                            mediaType: this.I.Da,
                            nodeData: b.nodeData
                        },
                        userGenerated: b.isTrusted
                    };
                    b = this.F.getReaderPublication().getReadingSystemEngine().getEventBus();
                    a = new rl(a.engineEventType, c, null);
                    b.emit(a);
                    break;
                case 37:
                    0 === a.target ? (this.A = a.iframeStorageId, null === a.key ? this.l.jc.publicationClear(this.Pa) : null === a.value ? this.l.jc.publicationRemoveItem(a.key, this.Pa) : this.l.jc.publicationSetItem(a.key, a.value, this.Pa)) : 1 === a.target && (this.H = a.iframeStorageId, null === a.key ? this.l.wc.publicationClear(this.Pa) : null === a.value ? this.l.wc.publicationRemoveItem(a.key, this.Pa) : this.l.wc.publicationSetItem(a.key, a.value, this.Pa));
                    break;
                case 38:
                    if (!a.iframeResourceId) {
                        if (b = null, a.startContainerPath && (b = {
                            v: a.startContainerPath,
                            i: a.startOffset
                        }, c = null, a.endContainerPath && (c = {
                            v: a.endContainerPath,
                            i: a.endOffset
                        }), b = this.Xa(b, c)), b) a = new sl({
                            contentLocation: b,
                            isRange: !!a.endContainerPath,
                            readerView: this.l.G.getReaderView(),
                            selectionText: a.selectionText
                        }), this.l.G.onSelectionChanged(a, this);
                        else this.l.G.onSelectionChanged(null, this);
                    }
                    break;
                case 40:
                    try {
                        Bl(this, a.href, null, a.iframeResourceId);
                    } catch (g) {
                        t.Logger.logWarning("Bad url in navigation intent");
                    }
                    break;
                case 41:
                    this.l.G.getEngineEventDispatcher().dispatchClipboardEvent();
            }
        };
        k.sg = function(a) {
            if (this.L) return Promise.reject(new T(t.ColibrioErrorType.ABORTED));
            switch(a.type){
                case 8:
                    return Cl(this, a);
                case 11:
                    return Dl(this, a);
                case 13:
                    return this.fetchBlob(a);
                case 15:
                    return El(this, a);
                case 17:
                    return Promise.resolve({
                        storageId: ++this.o + "",
                        type: 18
                    });
                case 21:
                    return Fl(this, a);
                case 24:
                    return Gl(this, a);
                case 26:
                    return Hl(this, a);
            }
            return Promise.reject("IFrameMessageType not implemented!");
        };
        k.onReaderViewPropertyChanged = function(a, b) {
            if (this.D) switch(a){
                case "activeTransform":
                    Qf(this.D, wl("hasActiveTransform", null !== b));
                    break;
                case "clearContentSelection":
                case "contentDocumentEventHandlersEnabled":
                case "contentSelectionEnabled":
                    Qf(this.D, wl(a, b));
            }
        };
        k.Xa = function(a, b) {
            var c = this.l.da, d = this.l.F, e = d.getSourceContentDocument(), f = d.getReaderPublication();
            c = cd(a, b, c, e, this.l.N);
            return new X(c, [
                d
            ], f, {
                Ca: !1,
                O: b,
                Ka: !0,
                P: a
            });
        };
        function Cl(a, b) {
            var c = Il(a, b.iframeId);
            b = B.URLUtils.normalizePathnameEncoding(new URL(b.path, c));
            var d = tl++;
            return a.l.W.getResourceProvider().fetch(b).then(function(e) {
                if (a.L) throw e.abort(), new T(t.ColibrioErrorType.ABORTED);
                a.j.set(d, e.getReadableStream().getReader());
                return {
                    metadata: e.getMetadata(),
                    streamId: d,
                    type: 9
                };
            });
        }
        function Al(a, b) {
            var c = null, d = "";
            switch(b.nodeName){
                case "img":
                case "image":
                    d = y.MediaTypeCategory.IMAGE;
                    break;
                case "audio":
                    d = y.MediaTypeCategory.AUDIO;
                    break;
                case "video":
                    d = y.MediaTypeCategory.VIDEO;
            }
            if (d) {
                var e = b.attributes.find(function(g) {
                    return "data-colibrio-media-sources" === g.localName;
                }), f = a.l.F.getSourceContentDocument().getContentUrl();
                a = a.l.W;
                if (e) b = JSON.parse(e.value), 0 < b.length && (c = new nj(d, b[0], f, a));
                else if (b = b.attributes.find(function(g) {
                    return "data-colibrio-image-src" === g.localName;
                })) c = JSON.parse(b.value), c = new nj(d, c, f, a);
            }
            return c;
        }
        function yl(a) {
            a.m.forEach(function(b) {
                b.Uc.destroy();
            });
            a.m = new Map;
        }
        function Bl(a, b, c, d) {
            c = void 0 === c ? null : c;
            d = Il(a, d);
            var e = B.URLUtils.normalizePathnameEncoding(new URL(b, d));
            b = a.F.getReaderPublication();
            if (e = (d = b.getSourcePublication().getContentDocumentByUrl(e)) ? e.hash.startsWith("#") ? Xd(a.l.N, d, e.hash.slice(1)) : Vd(a.l.N, d) : a.l.N.getLocatorFactory().parse(e).locator) a = new ql({
                cancelable: !0,
                locator: e,
                readerDocument: d && b.getReaderDocument(d),
                readerView: a.l.G.getReaderView(),
                relatedEvent: c,
                sourceReaderDocument: a.l.F
            }), b.getReadingSystemEngine().getEventBus().emit(a);
        }
        function Dl(a, b) {
            var c = Jl(a, b);
            return a.Na.fetchUint8Array(c, b.mediaCategoryOrType ? [
                b.mediaCategoryOrType
            ] : void 0).then(function(d) {
                if (a.L) throw new T(t.ColibrioErrorType.ABORTED);
                var e = d.data;
                return {
                    buffer: 0 !== e.byteOffset || e.byteLength !== e.buffer.byteLength ? e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength) : e.buffer,
                    metadata: d.metadata,
                    type: 12
                };
            }).catch(function(d) {
                t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logError(d);
                return Promise.reject(d);
            });
        }
        k.fetchBlob = function(a) {
            var b = this, c = Jl(this, a);
            return this.Na.fetchBlob(c, a.mediaCategoryOrType ? [
                a.mediaCategoryOrType
            ] : void 0).then(function(d) {
                if (b.L) throw new T(t.ColibrioErrorType.ABORTED);
                return {
                    blob: d.data,
                    type: 14
                };
            }).catch(function(d) {
                t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logError(d);
                return Promise.reject("" + d);
            });
        };
        function Fl(a, b) {
            var c = a.j.get(b.streamId);
            if (c) return c.read().then(function(e) {
                if (a.L) throw new T(t.ColibrioErrorType.ABORTED);
                if (e.value) {
                    var f = e.value;
                    f = 0 !== f.byteOffset || f.byteLength !== f.buffer.byteLength ? f.buffer.slice(f.byteOffset, f.byteOffset + f.byteLength) : f.buffer;
                    f = {
                        message: {
                            data: f,
                            done: e.done,
                            type: 22
                        },
                        Eg: [
                            f
                        ]
                    };
                } else f = {
                    data: null,
                    done: e.done,
                    type: 22
                };
                e.done && a.j.delete(b.streamId);
                return f;
            }).catch(function(e) {
                t.ColibrioError.isColibrioAbortedError(e) || t.Logger.logError(e);
                c && (c.cancel().catch(function(f) {
                    t.ColibrioError.isColibrioAbortedError(f) || t.Logger.logWarning(f);
                }), a.j.delete(b.streamId));
                return Promise.reject(e);
            });
            var d = new T("INVALID_MESSAGE_FROM_SCRIPTED_IFRAME", a.F.getSourceContentDocument().getContentUrl().pathname + ": streamId=" + b.streamId);
            t.Logger.logError(d);
            return Promise.reject(d);
        }
        function Gl(a, b) {
            var c = Jl(a, b);
            return a.l.W.getResourceProvider().fetchMetadata(c, {
                accept: b.mediaCategoryOrType ? [
                    b.mediaCategoryOrType
                ] : void 0
            }).then(function(d) {
                return {
                    mediaType: d.mediaType || "",
                    size: d.size || 0,
                    type: 25
                };
            });
        }
        function Hl(a, b) {
            var c = Jl(a, b);
            return a.Na.fetchText(c, b.mediaCategoryOrType ? [
                b.mediaCategoryOrType
            ] : void 0).then(function(d) {
                if (a.L) throw new T(t.ColibrioErrorType.ABORTED);
                return {
                    data: d.data,
                    type: 27
                };
            }).catch(function(d) {
                t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logError(d);
                return Promise.reject("" + d);
            });
        }
        function zl(a, b) {
            var c = a.g.getBoundingClientRect();
            a = a.l.bc;
            a = null === a ? 1 : c.width / a.width;
            var d = b.defaultPrevented ? D.ReaderDocumentEventState.DEFAULT_PREVENTED : b.processedByDocument ? D.ReaderDocumentEventState.PROCESSED : D.ReaderDocumentEventState.NOT_PROCESSED;
            var e = null;
            b.containerPath && (e = {
                v: b.containerPath,
                i: b.nodeOffset
            });
            return {
                clientRect: c,
                jg: d,
                scale: a,
                qe: e
            };
        }
        function Jl(a, b) {
            a = Il(a, b.iframeId);
            return B.URLUtils.normalizePathnameEncoding(new URL(b.src, a));
        }
        function Il(a, b) {
            var c;
            b && (b = a.m.get(b)) && (c = new URL(b.config.baseUrl));
            return c || a.F.getSourceContentDocument().getContentUrl();
        }
        function El(a, b) {
            var c, d, e, f, g, h, l, m, n, p, u;
            return q.K(function(v) {
                switch(v.g){
                    case 1:
                        c = B.URLUtils.normalizePathnameEncoding(new URL(b.iframeSrc, a.l.tb));
                        if (!a.l.W.getResourceProvider().acceptsUrl(c)) throw new T("IFRAME_DOCUMENT_NOT_FOUND", "Resource provider does not accept URL, iframe src: " + b.iframeSrc);
                        d = a.l.F.getReaderPublication();
                        e = d.getSourcePublication().getContentDocumentByUrl(c);
                        if (!e) throw new T("IFRAME_DOCUMENT_NOT_FOUND", "Content Document not found, iframe src: " + b.iframeSrc);
                        f = d.getReaderDocument(e);
                        return r(v, f.ig(a.l.G), 2);
                    case 2:
                        return g = v.h, h = g.Uc, l = g.Dg, m = h.sections[0], r(v, Lf(m.j(), l, !1), 3);
                    case 3:
                        return n = v.h, r(v, Rh(n, l, f.isReflowable()), 4);
                    case 4:
                        p = v.h;
                        var w = f.getSourceContentDocument().getContentUrl(), x = B.URLUtils.getUrlWithoutHash(w);
                        w = ++a.o + "";
                        x = {
                            baseUrl: x,
                            iframeResourceId: w,
                            mediaType: p.Da,
                            scripts: p.Wa,
                            styleDefs: p.bb,
                            transitionStylesheet: p.gb,
                            xml: p.yc
                        };
                        a.m.set(w, {
                            config: x,
                            Uc: h
                        });
                        u = x;
                        return v.return({
                            config: u,
                            type: 16
                        });
                }
            });
        }
        function xl(a, b, c) {
            var d = b.nodeData && Al(a, b.nodeData);
            if (d) {
                if (!c) {
                    if ("mediaElementInsideVisiblePages" === b.engineEventType) a.h.set(vl(b), b);
                    else if ("mediaElementOutsideVisiblePages" === b.engineEventType) a.h.delete(vl(b));
                    else {
                        var e = vl(b);
                        a.h.has(e) ? a.h.set(e, b) : t.Logger.logError(new U("Unexpected scripted iframe media element event " + b.engineEventType));
                    }
                }
                e = b.containerPath ? {
                    v: b.containerPath,
                    i: b.nodeOffset
                } : null;
                a.l.G.getEngineEventDispatcher().dispatchMediaElementEvent(c ? "mediaElementOutsideVisiblePages" : b.engineEventType, {
                    currentTimeMs: b.currentTimeMs,
                    durationMs: b.durationMs,
                    paused: b.paused,
                    ready: b.ready
                }, d, {
                    contentLocation: e && !b.iframeId ? a.Xa(e, null) : a.F.getContentLocation(),
                    frameworkComponent: D.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                    mediaType: a.I.Da,
                    nodeData: b.nodeData
                });
            }
        }
        function Kl(a, b) {
            this.I = a;
            this.l = b;
            this.za = this.Ia = this.Ha = this.B = this.xe = this.Oa = this.D = this.Pg = null;
            this.nb = !1;
        }
        function Ll(a) {
            a = a.remoteResourcesScriptedDocumentsOptions.policyType;
            return "ALLOW_ALL" === a || "WHITELIST" === a;
        }
        k = Kl.prototype;
        k.destroy = function() {
            this.Ia && this.Ia.destroy();
            this.za && (this.za.destroy(), this.za = null);
            this.D && (this.D.destroy(), this.D = null);
            this.Ha && (URL.revokeObjectURL(this.Ha), this.Ha = null);
        };
        k.lg = function(a, b, c) {
            var d = this;
            if (this.D && this.Oa) {
                var e = this.D;
                return this.Oa.then(function() {
                    if (e !== d.D) throw new T(t.ColibrioErrorType.ABORTED);
                    return Xf(d.D, {
                        endContainerOffset: c ? c.i : null,
                        endContainerPath: c ? c.v : null,
                        startContainerPath: b.v,
                        startOffset: b.i,
                        type: 23
                    }).then(function(f) {
                        return f.data;
                    });
                });
            }
            return Promise.resolve([]);
        };
        k.mg = function(a, b, c, d) {
            var e = this, f, g, h, l, m, n;
            return q.K(function(p) {
                switch(p.g){
                    case 1:
                        if (!e.D || !e.Oa) {
                            p.$(2);
                            break;
                        }
                        f = e.D;
                        return r(p, e.Oa, 3);
                    case 3:
                        if (f !== e.D) throw new T(t.ColibrioErrorType.ABORTED);
                        g = {
                            chooseLocationAfterElement: c,
                            findShallowestContentLocation: d,
                            type: 10,
                            y: b
                        };
                        return r(p, Xf(f, g), 4);
                    case 4:
                        if (h = p.h, l = e.l.F, m = {
                            v: h.containerPath,
                            i: h.offset
                        }, n = cd(m, null, e.l.da, l.getSourceContentDocument(), e.l.N)) return p.return(new X(n, [
                            l
                        ], l.getReaderPublication(), {
                            Ca: !1,
                            O: null,
                            Ka: !0,
                            P: m
                        }));
                    case 2:
                        return p.return(e.l.F.getContentLocation());
                }
            });
        };
        k.fetchContentRangeByTopOffsets = function(a, b, c) {
            var d = this, e, f, g, h, l, m, n, p, u, v, w, x, A, z, C, F;
            return q.K(function(G) {
                switch(G.g){
                    case 1:
                        if (null == (e = d.za) ? 0 : e.U) return f = M(d.l.da), g = {
                            v: [],
                            i: 0
                        }, h = {
                            v: [],
                            i: f.childNodes.length
                        }, G.return(d.ob(g, h));
                        if (!d.D || !d.Oa) {
                            G.$(2);
                            break;
                        }
                        l = d.D;
                        return r(G, d.Oa, 3);
                    case 3:
                        if (l !== d.D) throw new T(t.ColibrioErrorType.ABORTED);
                        m = {
                            chooseLocationAfterElement: !1,
                            findShallowestContentLocation: !0,
                            type: 10,
                            y: b
                        };
                        n = {
                            chooseLocationAfterElement: !0,
                            findShallowestContentLocation: !0,
                            type: 10,
                            y: c
                        };
                        p = q;
                        u = p.na;
                        return r(G, Promise.all([
                            Xf(l, m),
                            Xf(l, n)
                        ]), 4);
                    case 4:
                        return v = u.call(p, G.h), w = v.next().value, x = v.next().value, A = w, z = x, C = {
                            v: A.containerPath,
                            i: A.offset
                        }, F = {
                            v: z.containerPath,
                            i: z.offset
                        }, G.return(d.ob(C, F));
                    case 2:
                        return G.return(d.l.F.getContentLocation());
                }
            });
        };
        k.fetchContentRangesByTopOffsets = function(a, b) {
            var c = this, d, e, f, g, h, l, m, n, p, u, v, w, x, A, z, C, F, G;
            return q.K(function(L) {
                if (1 == L.g) {
                    if (!c.D || !c.Oa) return L.return({
                        next: null,
                        previous: null,
                        visible: null
                    });
                    if (null == (d = c.za) ? 0 : d.U) return e = M(c.l.da), f = {
                        v: [],
                        i: 0
                    }, g = {
                        v: [],
                        i: e.childNodes.length
                    }, L.return({
                        next: null,
                        previous: null,
                        visible: c.ob(f, g)
                    });
                    h = c.D;
                    return r(L, c.Oa, 2);
                }
                if (3 != L.g) {
                    if (h !== c.D) throw new T(t.ColibrioErrorType.ABORTED);
                    l = [];
                    for(m = 0; m < b.length; m++)n = !1, 2 <= m && (n = !0), l.push({
                        chooseLocationAfterElement: n,
                        findShallowestContentLocation: !0,
                        type: 10,
                        y: b[m]
                    });
                    return r(L, Promise.all(l.map(function(P) {
                        return Xf(h, P);
                    })), 3);
                }
                p = L.h;
                u = p.map(function(P) {
                    return {
                        v: P.containerPath,
                        i: P.offset
                    };
                });
                v = c.l.da;
                w = u[1];
                x = u[2];
                if (w && x) {
                    if (0 === $b(x, w) && (x = cl(v, x, !0), null === x)) return L.return({
                        next: null,
                        previous: null,
                        visible: null
                    });
                } else return L.return({
                    next: null,
                    previous: null,
                    visible: null
                });
                (A = u[0]) && w && 0 <= $b(A, w) && (A = cl(v, w, !1));
                z = u[3];
                x && z && 0 >= $b(z, x) && (z = cl(v, x, !0));
                C = null;
                F = c.ob(w, x);
                G = null;
                A && (C = c.ob(A, w));
                z && (G = c.ob(x, z));
                return L.return({
                    next: G,
                    previous: C,
                    visible: F
                });
            });
        };
        k.ng = function(a, b, c, d) {
            var e = this, f, g, h, l, m;
            return q.K(function(n) {
                if (1 == n.g) {
                    if (!e.D || !e.Oa || !e.nb) throw new U("fetchVisibleContentRects failed: scripted document channel not available");
                    f = e.D;
                    return r(n, e.Oa, 2);
                }
                if (3 != n.g) {
                    if (f !== e.D) throw new T(t.ColibrioErrorType.ABORTED);
                    l = {
                        endContainerPath: null == (g = c) ? void 0 : g.v,
                        endOffset: null == (h = c) ? void 0 : h.i,
                        includeNodeData: d.includeNodeData,
                        startContainerPath: b.v,
                        startOffset: b.i,
                        type: 19
                    };
                    return r(n, Xf(f, l), 3);
                }
                m = n.h;
                if (f !== e.D) throw new T(t.ColibrioErrorType.ABORTED);
                return n.return(m.rects.map(function(p) {
                    var u = e.l, v = {
                        v: p.startContainerPath,
                        i: p.startOffset
                    }, w = {
                        v: p.endContainerPath,
                        i: p.endOffset
                    }, x = u.da, A = u.F, z = A.getSourceContentDocument(), C = A.getReaderPublication();
                    u = cd(v, w, x, z, u.N);
                    v = new X(u, [
                        A
                    ], C, {
                        Ca: !1,
                        O: v,
                        Ka: !0,
                        P: w
                    });
                    w = p.rect;
                    return new Mk(new DOMRect(w.x, w.y, w.width, w.height), v, p.nodeData, p.type);
                }));
            });
        };
        k.af = function(a, b, c, d) {
            var e = this, f, g, h;
            return q.K(function(l) {
                switch(l.g){
                    case 1:
                        if (!e.D || !e.Oa) {
                            l.$(2);
                            break;
                        }
                        f = e.D;
                        return r(l, e.Oa, 3);
                    case 3:
                        if (f !== e.D) throw new T(t.ColibrioErrorType.ABORTED);
                        c.focusOnPageContainer && a.focus({
                            preventScroll: !0
                        });
                        switch(c.focusTargetOptions.target){
                            case D.FocusOnReadingPositionTarget.NEAREST_WORD:
                                g = "word";
                                break;
                            case D.FocusOnReadingPositionTarget.NEAREST_CHARACTER:
                                g = "character";
                                break;
                            case D.FocusOnReadingPositionTarget.NEAREST_SENTENCE:
                                g = "sentence";
                                break;
                            case D.FocusOnReadingPositionTarget.NEAREST_ELEMENT:
                                g = "element";
                                break;
                            case D.FocusOnReadingPositionTarget.NONE:
                                g = "none";
                        }
                        h = {
                            containerPath: b.v,
                            focusNearContentLocation: c.focusNearContentLocation,
                            focusOnPageBodyElement: c.focusOnPageBodyElement,
                            focusOnPageContainer: c.focusOnPageContainer,
                            focusTargetOptions: {
                                target: g
                            },
                            isAndroidNativeFramework: !!window.__colibrioAndroid,
                            offset: b.i,
                            publicationLanguage: d,
                            type: 28
                        };
                        return r(l, Xf(f, h), 4);
                    case 4:
                        return l.return();
                    case 2:
                        throw new T("DOCUMENT_NOT_RENDERED", "scripted document channel not available");
                }
            });
        };
        k.og = function() {
            if (!this.Ha) {
                var a = this.bf();
                "https:" === window.location.protocol && t.BrowserDetector.isSupportedBrowser({
                    Safari: ">=14"
                }) ? (a = (new TextEncoder).encode(a), this.Ha = xb(this.I.Da, t.Base64.encode(a))) : this.Ha = URL.createObjectURL(new Blob([
                    a
                ], {
                    type: this.I.Da
                }));
            }
            return this.Ha;
        };
        k.bf = function() {
            return this.I.yc;
        };
        k.Rc = function() {
            if (!this.Ha) return null;
            this.Ia || (this.Ia = new ml, Ml(this));
            return this.Ia;
        };
        k.Bd = function() {
            return null;
        };
        k.pg = function() {
            return this.I;
        };
        k.qg = function() {
            return this.l;
        };
        k.lf = function(a, b) {
            this.D && (this.D.destroy(), this.D = null);
            this.za && (this.za.destroy(), this.za = null);
            this.xe = b;
            return Nl(this, a, b);
        };
        k.mf = function() {
            this.B = null;
            this.nb = !1;
            this.xe = this.I.Ic.slice();
            this.Ia && nl(this.Ia, null);
            this.D && (this.D.destroy(), this.Oa = this.D = null);
            this.za && (this.za.destroy(), this.za = null);
        };
        k.le = function(a) {
            var b = this;
            this.nb = !0;
            this.Oa && this.Oa.then(function() {
                b.D && b.nb && a === b.B && (Qf(b.D, {
                    type: 7
                }), a.removeAttribute("aria-hidden"), a.setAttribute("tabindex", "0"));
            }).catch(function() {});
        };
        k.print = function() {
            var a;
            null == (a = this.D) || Qf(a, {
                type: 42
            });
        };
        k.setContentSelection = function(a, b, c) {
            var d = this;
            if (this.D && this.Oa) {
                var e = this.D;
                return this.Oa.then(function() {
                    if (e !== d.D) throw new T(t.ColibrioErrorType.ABORTED);
                    Qf(d.D, {
                        endContainerOffset: c ? c.i : null,
                        endContainerPath: c ? c.v : null,
                        startContainerPath: b.v,
                        startOffset: b.i,
                        type: 43
                    });
                });
            }
            return Promise.reject(new T("DOCUMENT_NOT_RENDERED", "scripted document channel not available"));
        };
        k.sf = function(a) {
            a.setAttribute("aria-hidden", "true");
            a.setAttribute("sandbox", "allow-scripts allow-modals");
            a.setAttribute("scrolling", "no");
            a.setAttribute("nwdisable", "true");
            a.style.overflow = "hidden";
            a.style.visibility = "hidden";
            this.B = a;
        };
        k.Ad = function() {
            return this.xe;
        };
        k.ob = function(a, b) {
            var c = this.l.F, d = cd(a, b, this.l.da, c.getSourceContentDocument(), this.l.N);
            return new X(d, [
                c
            ], c.getReaderPublication(), {
                Ca: !1,
                O: b,
                Ka: !0,
                P: a
            });
        };
        function Ml(a) {
            a.D && a.D.o && a.Ia && nl(a.Ia, a.D);
        }
        function Nl(a, b, c) {
            var d = a.l.G, e = a.l.bc, f = a.l.F;
            a.za = new ul(a.I, a.l, b);
            a.D = new ll(b.ownerDocument.defaultView, b.contentWindow, "*", "colibrio.readingsystem.formatadapter.epub", 3E4, a.za);
            return a.Oa = rh(a.D).then(function(g) {
                if (g !== a.D || !a.za) throw new T("INVALID_CHANNEL_FOR_SCRIPTED_READER_DOCUMENT");
                var h = f.getReaderPublication(), l = h.getSourcePublication().getMetadata().getMediaOverlayMetadata(), m = a.l.M.mediaOverlayOptions;
                a.za.D = g;
                var n = d.getReaderViewOptions(), p = a.l.M.clipboardOptions, u = null !== e ? d.getConstrainedPageScaleFactor(e, a.l.F.getSourceContentDocument().getPageSpreadSlot()) : 1, v, w, x = null != (w = null == (v = a.l.G.getReaderViewOptions().publicationStyleOptions) ? void 0 : v.fontSizeScaleFactor) ? w : 1;
                v = h.getOptions().contentProcessingOptions;
                w = n.gestureOptions.swipeNavigation.pointerTypes.mouse;
                var A = ++a.za.o + "", z;
                h = {
                    addTabIndexToMediaElements: v.addTabIndexToMediaElements,
                    allowAudioElementAutoplay: a.l.M.allowAudioElementAutoplay,
                    allowCopy: p.allowCopy,
                    allowRemoteResources: Ll(a.l.M),
                    allowVideoElementAutoplay: a.l.M.allowVideoElementAutoplay,
                    alwaysEmitPointerMoveEvents: n.emitPointerMoveEventsOnHover,
                    baseUrl: B.URLUtils.getOriginAndPath(a.l.tb),
                    body: a.Pg,
                    childIframeResourceId: null,
                    disableScripts: !a.l.M.allowDocumentScripting,
                    domMutationRecords: gc(c),
                    fontSizeScaleFactor: x,
                    forceTouchEvents: E.ReadingSystemUtils.isTouchEventsForced(h.getReadingSystemEngine()),
                    hasInlineNegativeHorizontalMarginStyles: a.I.vb,
                    horizontalOverflowFixerMathScroll: v.horizontalOverflowMathMLStrategy,
                    horizontalOverflowFixerMinFontSize: v.horizontalOverflowMitigationMinFontSize,
                    horizontalOverflowFixerTableScroll: v.horizontalOverflowTableStrategy,
                    iframeStorageId: A,
                    includeContentLocationInPointerMoveEvents: a.l.M.includeContentLocationInPointerMoveEvents,
                    isMouseSwipeNavigationAllowed: w,
                    layoutStyle: f.getSourceContentDocument().getLayout() === sa.ContentDocumentLayout.REFLOWABLE ? "scrolling" : "paginated",
                    mediaOverlayActiveElementClass: l.getActiveClassName() || m.fallbackActiveElementClass,
                    mediaOverlayAncestorElementClass: m.activeElementAncestorClass,
                    mediaOverlayPlaybackActiveClass: l.getPlaybackActiveClassName() || m.fallbackPlaybackActiveClass,
                    needsReflowableLayoutFixes: a.I.ic,
                    negativeHorizontalMarginSelectors: a.I.Ta,
                    preventDefaultContextMenu: a.l.M.preventDefaultContextMenu,
                    preventDefaultContextMenuOnMediaElements: a.l.M.preventDefaultContextMenuOnMediaElements,
                    preventDragAndDropActions: a.l.M.preventDragAndDropActions || w,
                    publicationLocalStorage: JSON.stringify(Object.fromEntries(a.l.jc.g)),
                    publicationSessionStorage: JSON.stringify(Object.fromEntries(a.l.wc.g)),
                    publicationStorageSizeLimit: a.l.jc.getStorageSizeLimit(),
                    removePublicationDefinedHorizontalPageMargins: n.publicationStyleOptions.removePublicationDefinedHorizontalPageMargins,
                    resourceProviderBaseUrl: null == (z = a.l.W.getResourceProvider().getBaseUrl()) ? void 0 : z.toString(),
                    scaleFactor: u,
                    scriptedContentDocumentEventHandlersEnabled: d.getReaderViewProperty("contentDocumentEventHandlersEnabled"),
                    scripts: a.l.M.allowDocumentScripting ? a.I.Wa : [],
                    styleDefs: a.I.bb,
                    textToAppendOnCopy: p.textToAppendOnCopy,
                    textToPrependOnCopy: p.textToPrependOnCopy,
                    transitionStylesheet: a.I.gb,
                    type: 3
                };
                return Xf(g, h).then(function() {
                    if (g === a.D && a.za) {
                        var C = a.za;
                        if (C.D) {
                            var F = C.l.G;
                            Qf(C.D, wl("contentSelectionEnabled", F.getReaderViewProperty("contentSelectionEnabled")));
                            Qf(C.D, wl("contentDocumentEventHandlersEnabled", F.getReaderViewProperty("contentDocumentEventHandlersEnabled")));
                            Qf(C.D, wl("hasActiveTransform", null !== F.getReaderViewProperty("activeTransform")));
                            F.addReaderViewPropertyChangedListener("clearContentSelection", C);
                            F.addReaderViewPropertyChangedListener("contentDocumentEventHandlersEnabled", C);
                            F.addReaderViewPropertyChangedListener("contentSelectionEnabled", C);
                            F.addReaderViewPropertyChangedListener("activeTransform", C);
                        }
                    }
                });
            }).finally(function() {
                Ml(a);
                b === a.B && (b.style.visibility = "");
            });
        }
        function Ol(a, b, c, d) {
            this.l = a;
            this.g = b;
            this.Ae = c;
            this.h = d;
            this.rangeContentLocation = this.g.Oc;
        }
        Ol.prototype.createPageIterator = function() {
            var a = this, b, c;
            return q.K(function(d) {
                if (1 == d.g) {
                    if (!a.isReflowable()) throw new T("CONTENT_DOCUMENT_NOT_FRAGMENTABLE", a.l.F.getSourceContentDocument().getContentUrl().pathname);
                    return r(d, Lf(a.g, a.l, !0), 2);
                }
                b = d.h;
                if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                c = $c(a.rangeContentLocation, a.rangeContentLocation.getReaderDocuments()[0], a.l.da);
                if (!c.O) throw new U("createPageIterator(): Expected contentLocationResult._endPosition to be non-null");
                return d.return(Pl(a.Ae, a.l, b, a.h, c.P, c.O));
            });
        };
        Ol.prototype.createRenderablePage = function() {
            var a = this, b;
            return q.K(function(c) {
                if (1 == c.g) return r(c, Ql(a), 2);
                b = c.h;
                if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                return c.return(Promise.resolve(new Uh(b, a.l.N, a.h)));
            });
        };
        Ol.prototype.j = function() {
            return this.g;
        };
        Ol.prototype.isReflowable = function() {
            return this.l.F.getSourceContentDocument().getLayout() === sa.ContentDocumentLayout.REFLOWABLE;
        };
        function Ql(a) {
            var b, c, d;
            return q.K(function(e) {
                if (1 == e.g) {
                    b = !1;
                    try {
                        (c = Object.getOwnPropertyDescriptor(Document.prototype, "readyState")) && c.configurable && (b = !0);
                    } catch (f) {}
                    return r(e, Lf(a.g, a.l, !1), 2);
                }
                d = e.h;
                if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                return b ? a.l.M.allowDocumentScripting && (d.Zg || d.Hc) ? e.return(Rh(d, a.l, a.l.F.isReflowable()).then(function(f) {
                    if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                    return new Kl(f, a.l);
                })) : e.return(Lh(a.l, d).then(function(f) {
                    if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                    return new fl(f, a.l, null);
                })) : e.return(Lh(a.l, d).then(function(f) {
                    if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                    return new fl(f, a.l, null);
                }));
            });
        }
        function Rl(a) {
            a.Md.forEach(function(b) {
                return b.destroy();
            });
            a.Md = [];
            a.kc.destroy();
            a.ta.getMediaType() === y.MediaType.IMAGE_SVG ? Sl(a.W.lb, a.ta) : Tl(a.W.lb, a.ta);
            a.Xd && a.Xd.destroy();
        }
        function Ul(a, b, c, d) {
            this.l = a;
            this.rangeContentLocation = c;
            this.sections = [];
            this.L = !1;
            this.sections = b.map(function(e, f) {
                return new Ol(a, e, d, f);
            });
        }
        Ul.prototype.destroy = function() {
            this.L = !0;
            Rl(this.l);
        };
        Ul.prototype.isDestroyed = function() {
            return this.L;
        };
        function Vl(a, b) {
            var c, d, e, f, g, h;
            return q.K(function(l) {
                switch(l.g){
                    case 1:
                        c = a.getCoverImageResourceUrl();
                        if (!c) {
                            l.$(2);
                            break;
                        }
                        d = null;
                        da(l, 3, 4);
                        return r(l, b.fetch(c), 6);
                    case 6:
                        return e = l.h, d = e.getReadableStream().getReader(), r(l, wb(d), 7);
                    case 7:
                        return f = l.h, l.return(ra.ImageUtils.getImageDimensions(f));
                    case 4:
                        ia(l);
                        null == (g = d) || g.cancel().catch(t.Logger.logError);
                        ja(l, 2);
                        break;
                    case 3:
                        h = fa(l);
                        t.Logger.logError(h);
                        l.$(4);
                        break;
                    case 2:
                        return l.return(null);
                }
            });
        }
        function Wl(a, b) {
            return Be(b.lb, a).then(function(c) {
                c = c.Ga;
                if (!c) return null;
                c = c.documentElement.firstElementChild;
                if (!c || "head" !== c.localName) return null;
                var d = new R(c, function(g) {
                    return H(g) && "meta" === g.localName && "viewport" === g.getAttribute("name");
                });
                S(d, !0);
                c = null;
                if (d = d.g) {
                    var e = d.getAttribute("content");
                    if (e) {
                        var f = /width\s*=\s*(\d+)/.exec(e);
                        d = Number(f && f[1]);
                        f = /height\s*=\s*(\d+)/.exec(e);
                        e = Number(f && f[1]);
                        d && e && 0 < d && 0 < e && (c = {
                            height: e,
                            width: d
                        });
                    }
                }
                return c;
            });
        }
        function Xl(a, b) {
            return Yl(b.lb, a, !1).then(function(c) {
                c = c.documentElement;
                if (c.hasAttribute("width") && c.hasAttribute("height")) {
                    var d = Number(c.getAttribute("width")), e = Number(c.getAttribute("height"));
                    if (0 < d && 0 < e) return {
                        height: e,
                        width: d
                    };
                }
                return c.hasAttribute("viewBox") && (d = c.getAttribute("viewBox").trim().split(/\s+/), c = Number(d[2]), d = Number(d[3]), 0 < c && 0 < d) ? {
                    height: d,
                    width: c
                } : null;
            });
        }
        function Zl(a, b, c) {
            var d = M(b);
            b = b.createRange();
            b.selectNodeContents(d);
            c = dd(c, a.getSourceContentDocument(), b);
            return new X(c, [
                a
            ], a.getReaderPublication(), {
                Ca: !1,
                O: {
                    v: [],
                    i: d.childNodes.length
                },
                Ka: !0,
                P: {
                    v: [],
                    i: 0
                }
            });
        }
        function $l(a, b, c, d, e, f, g, h, l) {
            this.ka = a;
            this.Ae = b;
            this.V = c;
            this.C = d;
            this.W = e;
            this.Vb = f;
            this.Nc = g;
            this.N = h;
            this.Pa = l;
            this.mc = this.Nb = null;
            this.pa = Vd(this.N, a);
        }
        k = $l.prototype;
        k.canHaveMultipleRenderingSections = function() {
            return this.isReflowable() && this.C.documentSectioningOptions.enabled;
        };
        k.createRenderableDocument = function(a, b) {
            return this.xd(a, b, !1).then(function(c) {
                return c.Uc;
            });
        };
        k.ig = function(a) {
            return this.xd(a, void 0, !0);
        };
        k.fetchContentBlockTree = function() {
            var a = this;
            return am(this, function(b) {
                return a.W.lb.getContentBlockTree(a, b, a.N, a.C);
            });
        };
        k.fetchContentBlocks = function(a) {
            return this.fetchContentBlockTree().then(function(b) {
                return b.toSerializableData({
                    createLocators: a ? a.createLocators : !1,
                    recursive: !0
                });
            });
        };
        k.fetchContentLocationForEntireDocument = function() {
            var a = this;
            this.Nb || (this.Nb = this.Ea().then(function(b) {
                return Zl(a, b, a.N);
            }).catch(function(b) {
                a.Nb = null;
                throw b;
            }));
            return this.Nb;
        };
        k.Ea = function() {
            return Be(this.W.lb, this.ka).then(function(a) {
                if (!a.Ga) throw new T("CONTENT_DOCUMENT_PARSING_FAILED", "fetchDomDocument() failed.");
                return a.Ga;
            });
        };
        k.fetchEstimatedHeight = function(a) {
            var b = a.getUnconstrainedPageDimensions(this.ka.getPageSpreadSlot()).height;
            return this.isReflowable() ? this.Nc.getEstimatedNumberOfPages(this, a).then(function(c) {
                return b * c;
            }) : Promise.resolve(b);
        };
        k.fetchEstimatedNumberOfPages = function(a) {
            return this.isReflowable() ? this.Nc.getEstimatedNumberOfPages(this, a) : Promise.resolve(1);
        };
        k.fetchLocatorForContentBlockData = function(a, b, c) {
            return this.fetchContentBlockTree().then(function(d) {
                d = d.getContentBlockById(a.id);
                if (!d) throw new T("CONTENT_BLOCK_NOT_FOUND", "Failed to getContentBlockById: " + a.id);
                return d.getLocator(b, c);
            });
        };
        k.fetchViewportDimensions = function() {
            var a = this;
            this.mc || (this.mc = Wl(this.ka, this.W).catch(function(b) {
                a.mc = null;
                return Promise.reject(b);
            }));
            return this.mc;
        };
        k.getAvailableSyncMediaFormats = function() {
            return null !== this.ka.getMediaOverlayUrl() ? [
                D.SyncMediaFormat.EPUB_MEDIA_OVERLAY,
                D.SyncMediaFormat.CONTENT_BLOCK_TTS
            ] : [
                D.SyncMediaFormat.CONTENT_BLOCK_TTS
            ];
        };
        k.getContentLocation = function() {
            return new X(this.pa, [
                this
            ], this.V, {
                Ca: !1,
                O: null,
                Ka: !0,
                P: {
                    v: [],
                    i: 0
                }
            });
        };
        k.getIndexInSpine = function() {
            return this.Pa;
        };
        k.getLocator = function() {
            return this.pa;
        };
        k.getReaderPublication = function() {
            return this.V;
        };
        k.getSourceContentDocument = function() {
            return this.ka;
        };
        k.isReflowable = function() {
            return this.ka.getLayout() === sa.ContentDocumentLayout.REFLOWABLE;
        };
        k.isRenderable = function() {
            return !0;
        };
        k.setOptions = function(a) {
            this.C = a;
        };
        k.toJSON = function() {
            return {
                availableSyncMediaFormats: this.getAvailableSyncMediaFormats(),
                indexInSpine: this.Pa,
                locator: this.pa.toJSON(),
                reflowable: this.isReflowable(),
                renderable: this.isRenderable(),
                sourceContentDocumentIndexInSpine: this.ka.getIndexInSpine()
            };
        };
        function bm(a) {
            var b = a.getReaderPublication().getOptions().remoteResourcesNonScriptedDocumentsOptions, c;
            b = "ALLOW_ALL" === (null == b ? void 0 : b.policyType) || "WHITELIST" === (null == b ? void 0 : b.policyType) && (null == (c = b.whitelistDirectives) ? void 0 : c.some(function(d) {
                return "media-src" === d.directive;
            }));
            return new E.MediaSourceFactory(a.W.getResourceProvider(), a.W.ad, {
                allowRemoteUrls: b,
                enableMediaStreaming: a.C.enableMediaStreaming,
                highPrecisionSeek: !1
            });
        }
        k.Ye = function(a, b, c) {
            var d = this.Vb.getStorageArea(D.ReaderPublicationStorageAreaType.LOCAL_STORAGE), e = this.Vb.getStorageArea(D.ReaderPublicationStorageAreaType.SESSION_STORAGE);
            return {
                Md: [],
                tb: this.ka.getContentUrl(),
                bc: a,
                M: this.C,
                N: this.N,
                Xd: bm(this),
                jc: d,
                wc: e,
                F: this,
                G: b,
                kc: new oa.ResourceCacheClient(this.W.ad),
                W: this.W,
                ta: this.ka,
                da: c
            };
        };
        k.xd = function(a, b, c) {
            var d = this, e = this.isReflowable() ? Promise.resolve(null) : this.fetchViewportDimensions(), f = cm(this.W.lb, this.ka, !0), g, h = this.fetchContentLocationForEntireDocument();
            return Promise.all([
                e,
                f,
                h
            ]).then(function(l) {
                var m, n, p, u, v, w, x, A;
                return q.K(function(z) {
                    if (1 == z.g) {
                        m = l[0];
                        n = l[1];
                        p = l[2];
                        if (a.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                        d.isReflowable() || m || t.Logger.logError(new T("INVALID_READER_DOCUMENT", 'Content document is declared fixed-layout ("pre-paginated") but no valid viewport dimensions were found in "' + d.ka.getContentUrl().pathname + '"'));
                        if (b) {
                            if (!b.isRange() || b.isAfter(p) || b.isBefore(p)) throw new T("INVALID_RENDERABLE_DOCUMENT_CONTENT_RANGE");
                            u = E.ContentLocationUtils.clampContentLocationToRange(b, p);
                            v = !0;
                        } else u = p, v = !1;
                        w = n.ed ? y.MediaType.APPLICATION_XHTML : y.MediaType.TEXT_HTML;
                        g = d.Ye(m, a, n.Ga);
                        x = d.canHaveMultipleRenderingSections() && a.getRendererRuntime().canHandleMultipleRenderingSections() && !c;
                        return r(z, wf(g, n.Bb, w, x, d.C.documentSectioningOptions, u, v), 2);
                    }
                    A = z.h;
                    if (a.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                    return z.return({
                        Uc: new Ul(g, A, u, d.Ae),
                        Dg: g
                    });
                });
            }).catch(function(l) {
                g && Rl(g);
                return Promise.reject(l);
            });
        };
        function am(a, b) {
            return Be(a.W.lb, a.ka).then(function(c) {
                return b(c.Ga);
            });
        }
        function dm(a, b, c) {
            var d, e, f, g, h, l;
            return q.K(function(m) {
                if (1 == m.g) {
                    d = a.da.cloneNode(!0);
                    e = new hc;
                    var n = d, p = t.BrowserDetector.isOS("iOS") ? n.title : "";
                    p = n.implementation.createHTMLDocument(p);
                    n = p.adoptNode(n.documentElement);
                    p.body.appendChild(n);
                    n.setAttribute("style", "width: " + b.width + "px; height: " + b.height + "px");
                    n = p.createElement("meta");
                    n.setAttribute("name", "viewport");
                    n.setAttribute("value", "width=" + b.width + ", height=" + b.height);
                    p.head.appendChild(n);
                    n = p.createElement("style");
                    n.appendChild(p.createTextNode(" html { margin: 0; padding: 0;} body { margin: 0; padding: 0}"));
                    p.head.appendChild(n);
                    f = p;
                    return r(m, oc(a, f, e, !1), 2);
                }
                g = m.h;
                h = g.Ag;
                l = g.styleDefs;
                if (a.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                return m.return([
                    {
                        T: e.g,
                        yb: y.MediaType.IMAGE_SVG,
                        Ja: f,
                        Oc: c,
                        Wa: h,
                        bb: l,
                        Bb: ""
                    }
                ]);
            });
        }
        function em(a, b, c) {
            this.l = a;
            this.g = b;
            this.rangeContentLocation = c;
            this.h = a.ta.getContentUrl().pathname;
        }
        em.prototype.createPageIterator = function() {
            throw new T("CONTENT_DOCUMENT_NOT_FRAGMENTABLE", this.h);
        };
        em.prototype.createRenderablePage = function() {
            var a = this, b;
            return q.K(function(c) {
                if (1 == c.g) return r(c, fm(a), 2);
                b = c.h;
                if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                return c.return(Promise.resolve(new Uh(b, a.l.N, 0)));
            });
        };
        em.prototype.j = function() {
            return this.g;
        };
        function fm(a) {
            var b;
            return q.K(function(c) {
                if (1 == c.g) return r(c, Lf(a.g, a.l, !1), 2);
                b = c.h;
                if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                return c.return(Rh(b, a.l, !1).then(function(d) {
                    if (a.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                    return new Kl(d, a.l);
                }));
            });
        }
        function gm(a, b, c) {
            this.l = a;
            this.rangeContentLocation = c;
            this.L = !1;
            this.sections = [
                new em(a, b, c)
            ];
        }
        gm.prototype.destroy = function() {
            this.L = !0;
            Rl(this.l);
        };
        gm.prototype.isDestroyed = function() {
            return this.L;
        };
        function hm(a, b, c, d, e, f, g) {
            this.ka = a;
            this.V = b;
            this.M = c;
            this.W = d;
            this.Vb = e;
            this.N = f;
            this.Pa = g;
            this.mc = this.Nb = null;
            this.pa = Vd(f, a);
        }
        k = hm.prototype;
        k.canHaveMultipleRenderingSections = function() {
            return !1;
        };
        k.createRenderableDocument = function(a) {
            return this.xd(a).then(function(b) {
                return b.Uc;
            });
        };
        k.ig = function(a) {
            return this.xd(a);
        };
        k.xd = function(a) {
            var b = this, c = this.fetchViewportDimensions(), d = Yl(this.W.lb, this.ka, !0), e = this.fetchContentLocationForEntireDocument(), f;
            return Promise.all([
                c,
                d,
                e
            ]).then(function(g) {
                var h, l, m, n;
                return q.K(function(p) {
                    if (1 == p.g) {
                        h = g[0];
                        l = g[1];
                        m = g[2];
                        if (!h) throw new T("CONTENT_DOCUMENT_PARSING_FAILED", "SVG is missing dimensions");
                        if (a.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                        f = b.Ye(h, a, l);
                        return r(p, dm(f, h, m), 2);
                    }
                    n = p.h;
                    if (a.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                    return p.return({
                        Uc: new gm(f, n[0], m),
                        Dg: f
                    });
                });
            }).catch(function(g) {
                f && Rl(f);
                return Promise.reject(g);
            });
        };
        k.fetchContentBlockTree = function() {
            var a = this;
            return this.Ea().then(function(b) {
                return a.W.lb.getContentBlockTree(a, b, a.N, a.M);
            });
        };
        k.fetchContentBlocks = function(a) {
            return this.fetchContentBlockTree().then(function(b) {
                return b.getContentBlocks().map(function(c) {
                    return c.toSerializableData(a);
                });
            });
        };
        k.fetchContentLocationForEntireDocument = function() {
            var a = this;
            this.Nb || (this.Nb = this.Ea().then(function(b) {
                return Zl(a, b, a.N);
            }).catch(function(b) {
                a.Nb = null;
                throw b;
            }));
            return this.Nb;
        };
        k.Ea = function() {
            return Be(this.W.lb, this.ka).then(function(a) {
                if (!a.Ga) throw new T("CONTENT_DOCUMENT_PARSING_FAILED", "fetchDomDocument() failed.");
                return a.Ga;
            });
        };
        k.fetchEstimatedHeight = function(a) {
            return Promise.resolve(a.getUnconstrainedPageDimensions(this.ka.getPageSpreadSlot()).height);
        };
        k.fetchEstimatedNumberOfPages = function() {
            return Promise.resolve(1);
        };
        k.fetchLocatorForContentBlockData = function(a, b, c) {
            return this.fetchContentBlockTree().then(function(d) {
                d = d.getContentBlockById(a.id);
                if (!d) throw new T("CONTENT_BLOCK_NOT_FOUND", "Failed to getContentBlockById: " + a.id);
                return d.getLocator(b, c);
            });
        };
        k.fetchViewportDimensions = function() {
            this.mc || (this.mc = Xl(this.ka, this.W));
            return this.mc;
        };
        k.getAvailableSyncMediaFormats = function() {
            return null !== this.ka.getMediaOverlayUrl() ? [
                D.SyncMediaFormat.EPUB_MEDIA_OVERLAY,
                D.SyncMediaFormat.CONTENT_BLOCK_TTS
            ] : [
                D.SyncMediaFormat.CONTENT_BLOCK_TTS
            ];
        };
        k.getContentLocation = function() {
            return new X(this.pa, [
                this
            ], this.V, {
                Ca: !0,
                O: null,
                Ka: !0,
                P: {
                    v: [],
                    i: 0
                }
            });
        };
        k.getIndexInSpine = function() {
            return this.Pa;
        };
        k.getLocator = function() {
            return this.pa;
        };
        k.getReaderPublication = function() {
            return this.V;
        };
        k.getSourceContentDocument = function() {
            return this.ka;
        };
        k.isReflowable = function() {
            return !1;
        };
        k.isRenderable = function() {
            return !0;
        };
        k.setOptions = function(a) {
            this.M = a;
        };
        k.toJSON = function() {
            return {
                availableSyncMediaFormats: this.getAvailableSyncMediaFormats(),
                indexInSpine: this.Pa,
                locator: this.pa.toJSON(),
                reflowable: !1,
                renderable: this.isRenderable(),
                sourceContentDocumentIndexInSpine: this.ka.getIndexInSpine()
            };
        };
        k.Ye = function(a, b, c) {
            var d = this.Vb.getStorageArea(D.ReaderPublicationStorageAreaType.LOCAL_STORAGE), e = this.Vb.getStorageArea(D.ReaderPublicationStorageAreaType.SESSION_STORAGE);
            return {
                Md: [],
                tb: this.ka.getContentUrl(),
                bc: a,
                M: this.M,
                N: this.N,
                Xd: null,
                jc: d,
                wc: e,
                F: this,
                G: b,
                kc: new oa.ResourceCacheClient(this.W.ad),
                W: this.W,
                ta: this.ka,
                da: c
            };
        };
        function im() {
            this.name = "CssForcedPageBreakPlugin";
        }
        im.prototype.detectForcedBreakAfter = function(a) {
            return jm(a, "pageBreakAfter") || jm(a, "breakAfter");
        };
        im.prototype.detectForcedBreakBefore = function(a) {
            return jm(a, "pageBreakBefore") || jm(a, "breakBefore");
        };
        im.prototype.install = function(a) {
            a.forcedBreakDetectors.push(this);
        };
        function jm(a, b) {
            a = a.getStyle(b);
            b = null;
            "left" === a ? b = "left" : "right" === a ? b = "right" : "always" === a || "page" === a ? b = "page" : "recto" === a ? b = "recto" : "verso" === a && (b = "verso");
            return b;
        }
        function km(a) {
            this.name = "CustomCssValuePenalizerPlugin";
            this.h = a.fragmentation;
            this.j = a.orphans;
            this.m = a.widows;
        }
        km.prototype.getFragmentationPenalty = function(a) {
            return kf(a) ? lm(this.g.getRfElement(a), this.h) : 0;
        };
        km.prototype.getOrphanElementPenalty = function(a) {
            return kf(a) ? lm(this.g.getRfElement(a), this.j) : 0;
        };
        km.prototype.getWidowElementPenalty = function(a) {
            return kf(a) ? lm(this.g.getRfElement(a), this.m) : 0;
        };
        km.prototype.install = function(a) {
            0 < this.h.length && a.fragmentationPenalizers.push(this);
            0 < this.j.length && a.orphanElementPenalizers.push(this);
            0 < this.m.length && a.widowElementPenalizers.push(this);
            this.g = a;
        };
        function lm(a, b) {
            for(var c = 0, d = {}, e = 0; e < b.length; d = {
                Yb: void 0
            }, e++)d.Yb = b[e], d.Yb.properties.some(function(f) {
                return function(g) {
                    var h = a.getStyle(g);
                    g = !1;
                    if (f.Yb.values) -1 !== f.Yb.values.indexOf(h) && (c += f.Yb.penalty, g = !0);
                    else if (f.Yb.numericValueCondition) {
                        var l = f.Yb.numericValueCondition.value;
                        h = parseFloat(h);
                        switch(f.Yb.numericValueCondition.comparator){
                            case "EQUAL":
                                g = h === l;
                                break;
                            case "GREATER_THAN":
                                g = h > l;
                                break;
                            case "LESS_THAN":
                                g = h < l;
                        }
                        g && (c += f.Yb.penalty);
                    }
                    return g;
                };
            }(d));
            return c;
        }
        function mm(a) {
            var b;
            Ha(a) ? (a = a.split(","), 1 === a.length ? b = nm(a[0]) : b = new om(a.map(function(c) {
                return nm(c);
            }))) : a.tagName || a.attributeName || a.classNames ? b = new pm(a.tagName || null, a.attributeName || null, a.attributeValue || null, a.classNames || null) : b = new qm;
            return b;
        }
        function pm(a, b, c, d) {
            this.tagName = a;
            this.attributeName = b;
            this.attributeValue = c;
            this.classNames = d;
        }
        function nm(a) {
            a = a.trim();
            var b = a.match(/^[^\s\.\[]+/), c = b ? b[0].toLowerCase() : null, d = (b = a.match(/\["?([^\s="\]]+)/)) ? b[1] : null, e = (b = a.match(/="?([^"\]]+)/)) ? b[1] : null;
            if (b = a.match(/(?:\.[^\s\.\[]+)/g)) {
                a = [];
                for(var f = 0; f < b.length; f++)a.push(b[f].slice(1));
            } else a = null;
            return c || d || a ? new pm(c, d, e, a) : new qm;
        }
        pm.prototype.matches = function(a) {
            if (this.tagName && this.tagName !== a.localName) return !1;
            if (this.attributeValue) {
                if (this.attributeName && a.getAttribute(this.attributeName) !== this.attributeValue) return !1;
            } else if (this.attributeName && !a.hasAttribute(this.attributeName)) return !1;
            return this.classNames ? this.classNames.every(function(b) {
                return a.classList.contains(b);
            }) : !0;
        };
        function om(a) {
            this.selectors = a;
        }
        om.prototype.matches = function(a) {
            return this.selectors.some(function(b) {
                return b.matches(a);
            });
        };
        function qm() {}
        qm.prototype.matches = function() {
            return !1;
        };
        function rm(a) {
            this.name = "CustomElementPenalizerPlugin";
            this.g = a.fragmentation.map(sm);
            this.h = a.orphans.map(sm);
            this.j = a.widows.map(sm);
        }
        rm.prototype.getFragmentationPenalty = function(a, b) {
            return tm(a, this.g, !0, b);
        };
        rm.prototype.getOrphanElementPenalty = function(a, b, c) {
            return tm(a, this.h, b, c);
        };
        rm.prototype.getWidowElementPenalty = function(a, b, c) {
            return tm(a, this.j, b, c);
        };
        rm.prototype.install = function(a) {
            0 < this.g.length && a.fragmentationPenalizers.push(this);
            0 < this.h.length && a.orphanElementPenalizers.push(this);
            0 < this.j.length && a.widowElementPenalizers.push(this);
        };
        function sm(a) {
            return {
                overrides: a.overrides ? um(a.overrides) : [],
                penalty: a.penalty,
                selector: mm(a.selector),
                skipIfFragmented: a.skipIfFragmented || !1
            };
        }
        function um(a) {
            return a.map(function(b) {
                return {
                    context: b.context,
                    penalty: b.penalty,
                    selector: mm(b.selector)
                };
            });
        }
        function tm(a, b, c, d) {
            if (!H(a)) return 0;
            for(var e = 0, f = 0; f < b.length; f++){
                var g = b[f];
                if ((!g.skipIfFragmented || !c) && g.selector.matches(a)) {
                    var h = g.overrides.find(function(l) {
                        return "descendant" === l.context ? vm(l.selector, d) : !1;
                    });
                    e = h ? e + h.penalty : e + g.penalty;
                }
            }
            return e;
        }
        function vm(a, b) {
            return b.some(function(c) {
                return H(c) && a.matches(c);
            });
        }
        function wm(a) {
            this.name = "CustomForcedPageBreakPlugin";
            this.g = a.breakAfterRules.map(xm);
            this.h = a.breakBeforeRules.map(xm);
            this.j = a.breakMarkersRules.map(xm);
        }
        wm.prototype.detectForcedBreakAfter = function(a) {
            return ym(a.element, this.g);
        };
        wm.prototype.detectForcedBreakBefore = function(a) {
            return ym(a.element, this.h);
        };
        wm.prototype.detectForcedBreakMarker = function(a) {
            return ym(a.element, this.j);
        };
        wm.prototype.install = function(a) {
            a.forcedBreakDetectors.push(this);
        };
        function xm(a) {
            return {
                breakMode: a.breakMode,
                selector: mm(a.selector)
            };
        }
        function ym(a, b) {
            return (b = b.find(function(c) {
                return c.selector.matches(a);
            })) ? b.breakMode : null;
        }
        function zm(a, b, c) {
            this.scope = a;
            this.Yc = b;
            this.Z = c;
            this.Lb = this.Ba = this.h = null;
            this.A = 0;
            this.U = this.H = this.j = this.g = null;
            b = a.rfElement;
            this.m = b.getStyleAsNumber("marginBottom");
            this.o = b.getStyleAsNumber("marginTop");
            this.ja = b.getStyleAsNumber("borderBottomWidth");
            this.Ma = b.getStyleAsNumber("paddingBottom");
            this.Za = b.getStyleAsNumber("paddingTop");
            this.ua = b.getStyleAsNumber("borderTopWidth");
            this.position = b.getStyle("position");
            c = b.element.nextSibling;
            this.Sa = null === c || ef(c) && null === c.nextSibling;
            if ("absolute" === this.position) for(a = a.element.offsetParent; null === this.h && I(a);)if (b = this.scope.root.getScopeForNode(a)) b.isParentScope() ? this.h = b : (this.A += a.offsetTop, a = a.offsetParent);
            else break;
            else if (this.scope.parent && this.scope.parent.element !== b.element.parentNode) for(a = b.element.parentNode; I(a) && a !== this.scope.parent.element;)"relative" === a.ownerDocument.defaultView.getComputedStyle(a).position && (this.A += a.offsetTop), a = a.parentNode;
            this.re = 0 === this.ja && 0 === this.Ma;
            this.te = 0 === this.ua && 0 === this.Za;
        }
        k = zm.prototype;
        k.getChildOffsetBottomLimitWithoutMargin = function(a, b) {
            if (null === this.Ba || null === this.Lb) this.Ba = Am(this, !1), this.Lb = this.Z ? Am(this, !0) : this.Ba;
            return b && this.Z ? this.Lb : a ? this.Ba - this.ja : this.Ba - this.Ma - this.ja;
        };
        k.getOffsetBottomLimit = function(a, b) {
            if (null === this.g || null === this.j) {
                if ("absolute" === this.position || "fixed" === this.position ? this.j = this.g = this.h ? this.h.containerMeasurer.getChildOffsetBottomLimitWithoutMargin(!0, !1) : this.scope.root.getPageOffsetBottomLimit(!0) : this.scope.parent ? (this.g = this.scope.parent.containerMeasurer.getChildOffsetBottomLimitWithoutMargin(!1, !1), this.j = this.Z ? this.scope.parent.containerMeasurer.getChildOffsetBottomLimitWithoutMargin(!1, !0) : this.g) : this.j = this.g = this.scope.getPageOffsetBottomLimit(!1), this.g -= this.A, this.j -= this.A, this.g -= this.getTotalMarginBottom(0, 0, !1), this.j -= this.getTotalMarginBottom(0, 0, !0), this.Yc) {
                    var c = this.scope.rfElement.getStyleAsNumber("zoom");
                    0 !== c && 1 !== c && (this.g /= c);
                }
            }
            return b && this.Z ? this.j : a ? this.g : this.g - this.Ma - this.ja;
        };
        k.getTotalMarginBottom = function(a, b, c) {
            var d = 0;
            !this.re || c && this.Z ? (d = a + b, c ? b = a = 0 : (a = 0 < this.m ? this.m : 0, b = 0 > this.m ? this.m : 0)) : 0 < this.m ? a = Math.max(a, this.m) : 0 > this.m && (b = Math.min(b, this.m));
            var e = 0;
            this.scope.parent && (c = c || !this.Sa, "absolute" === this.position || "fixed" === this.position ? e = this.h ? this.h.containerMeasurer.getTotalMarginBottom(0, 0, !1) : 0 : "none" !== this.scope.rfElement.getStyle("cssFloat") ? e = this.scope.parent.containerMeasurer.getTotalMarginBottom(0, 0, c) : (e = this.scope.parent.containerMeasurer.getTotalMarginBottom(a, b, c), b = a = 0));
            return e + d + a + b;
        };
        k.getTotalMarginTop = function(a, b) {
            var c = 0;
            this.te ? 0 < this.o ? a = Math.max(a, this.o) : 0 > this.o && (b = Math.min(b, this.o)) : (c = a + b, a = 0 < this.o ? this.o : 0, b = 0 > this.o ? this.o : 0);
            var d = 0;
            this.scope.parent && ("absolute" === this.position || "fixed" === this.position ? d = this.h ? this.h.containerMeasurer.getTotalMarginTop(0, 0) : 0 : "none" !== this.scope.rfElement.getStyle("cssFloat") ? d = this.scope.parent.containerMeasurer.getTotalMarginTop(0, 0) : (d = this.scope.parent.containerMeasurer.getTotalMarginTop(a, b), b = a = 0));
            return d + c + a + b;
        };
        k.getTotalVerticalPaddingAndBorder = function(a) {
            if (null === this.H || null === this.U) this.H = this.Ma + this.ja + this.Za + this.ua, this.U = this.Za + this.ua, this.scope.parent && ("absolute" === this.position || "fixed" === this.position ? this.h && this.h.parent && (this.H += this.h.parent.containerMeasurer.getTotalVerticalPaddingAndBorder(!1), this.U += this.h.parent.containerMeasurer.getTotalVerticalPaddingAndBorder(!0)) : (this.H += this.scope.parent.containerMeasurer.getTotalVerticalPaddingAndBorder(!this.Sa), this.U += this.scope.parent.containerMeasurer.getTotalVerticalPaddingAndBorder(!0)));
            return a && this.Z ? this.U : this.H;
        };
        function Am(a, b) {
            var c = a.scope.rfElement, d = c.element;
            b = "absolute" === a.position || "fixed" === a.position ? a.h ? a.h.containerMeasurer.getChildOffsetBottomLimitWithoutMargin(!0, !1) : a.scope.root.getPageOffsetBottomLimit(!0) : a.scope.parent ? a.scope.parent.containerMeasurer.getChildOffsetBottomLimitWithoutMargin(!1, b || !a.Sa) : a.scope.getPageOffsetBottomLimit(!1);
            b -= a.A;
            var e = a.scope.element;
            b -= e.offsetHeight > e.clientHeight ? Math.max(0, e.offsetHeight - e.clientHeight - a.ua - a.ja) : 0;
            a: {
                e = a.scope.element;
                if (e.scrollHeight > e.clientHeight && (e = e.ownerDocument.defaultView.getComputedStyle(e, ":after"), e = parseFloat(e.height), K(e))) break a;
                e = 0;
            }
            b -= e;
            a: {
                e = a.scope.element.childNodes;
                for(var f = 0; f < e.length; f++){
                    var g = e[f];
                    if (g.offsetParent) {
                        e = a.scope.element === g.offsetParent;
                        break a;
                    }
                }
                e = !1;
            }
            e && (b -= d.offsetTop + a.ua);
            a.Yc && (a = c.getStyleAsNumber("zoom"), 0 !== a && 1 !== a && (b /= a));
            return b;
        }
        function Bm(a) {
            this.scope = a;
            this.h = this.g = null;
            var b = a.rfElement;
            this.o = b.getStyleAsNumber("marginTop");
            this.m = b.getStyleAsNumber("marginBottom");
            this.position = b.getStyle("position");
            b = b.element.nextSibling;
            this.j = null === b || ef(b) && null === b.nextSibling;
            if ("absolute" === this.position) {
                b = a.parent.rfElement;
                var c = b.element;
                "static" !== b.getStyle("position") || /^(?:table|td|th)$/i.test(c.nodeName) ? this.g = a.parent : this.g = c.offsetParent ? a.root.getScopeForNode(c.offsetParent) : null;
            }
        }
        k = Bm.prototype;
        k.getChildOffsetBottomLimitWithoutMargin = function() {
            throw new Re("CHILD_OFFSET_BOTTOM_LIMIT_NOT_SUPPORTED");
        };
        k.getOffsetBottomLimit = function() {
            if (null !== this.h) return this.h;
            this.h = "absolute" === this.position || "fixed" === this.position ? this.g ? this.g.containerMeasurer.getChildOffsetBottomLimitWithoutMargin(!0, !1) : this.scope.root.getPageOffsetBottomLimit(!0) : this.scope.parent.containerMeasurer.getChildOffsetBottomLimitWithoutMargin(!1, !this.j);
            return this.h -= this.getTotalMarginBottom(0, 0);
        };
        k.getTotalMarginBottom = function(a, b) {
            var c = a + b;
            a = 0 < this.m ? this.m : 0;
            b = 0 > this.m ? this.m : 0;
            if ("absolute" === this.position || "fixed" === this.position) var d = this.g ? this.g.containerMeasurer.getTotalMarginBottom(0, 0, !1) : 0;
            else "none" !== this.scope.rfElement.getStyle("cssFloat") ? d = this.scope.parent.containerMeasurer.getTotalMarginBottom(0, 0, !this.j) : (d = this.scope.parent.containerMeasurer.getTotalMarginBottom(a, b, !this.j), b = a = 0);
            return d + c + a + b;
        };
        k.getTotalMarginTop = function(a, b) {
            var c = a + b;
            a = 0 < this.o ? this.o : 0;
            b = 0 > this.o ? this.o : 0;
            if ("absolute" === this.position || "fixed" === this.position) var d = this.g ? this.g.containerMeasurer.getTotalMarginTop(0, 0) : 0;
            else "none" !== this.scope.rfElement.getStyle("cssFloat") ? d = this.scope.parent.containerMeasurer.getTotalMarginTop(0, 0) : (d = this.scope.parent.containerMeasurer.getTotalMarginTop(a, b), b = a = 0);
            return d + c + a + b;
        };
        k.getTotalVerticalPaddingAndBorder = function() {
            return this.scope.parent.containerMeasurer.getTotalVerticalPaddingAndBorder(!this.j);
        };
        function Cm(a) {
            this.h = a;
            this.name = "DefaultContainerMeasurerPlugin";
            this.g = !1;
        }
        Cm.prototype.createContainerMeasurer = function(a) {
            return a.isParentScope() ? new zm(a, this.g, this.h) : new Bm(a);
        };
        Cm.prototype.install = function(a) {
            a.containerMeasurerFactories.push(this);
            this.g = "zoom" in document.documentElement.style;
        };
        Cm.prototype.isContainerMeasurerFactoryFor = function() {
            return !0;
        };
        function Dm(a) {
            this.name = "FloatingOrphanPenalizerPlugin";
            this.h = a.penalty;
        }
        Dm.prototype.getOrphanElementPenalty = function(a, b, c, d) {
            c = d.rootScope;
            if (!kf(a)) return 0;
            b = this.g.getRfElement(a).getStyle("cssFloat");
            if (d = "none" !== b) {
                var e = c.element, f = a.parentElement, g;
                for(c = !0; !g && f && f !== e;)d = this.g.getRfElement(f), "visible" !== d.getStyle("overflowY") && (g = f), f = f.parentElement;
                g || (g = e);
                a = new R(a, gf);
                a.aa = g;
                S(a, !1);
                if (null === a.g) c = !1;
                else do (g = a.g) && kf(g) && (d = this.g.getRfElement(g), g = d.getStyle("clear"), "both" === g || g === b) && (c = !1), g = S(a, !0);
                while (c && 0 < g);
                d = c;
            }
            return d ? this.h : 0;
        };
        Dm.prototype.install = function(a) {
            this.g = a;
            0 < this.h && a.orphanElementPenalizers.push(this);
        };
        function Em(a) {
            this.name = "FragmentableElementsPlugin";
            this.selectors = (this.allowByDefault = a.allowByDefault) ? a.blacklistSelectors.map(mm) : a.whitelistSelectors.map(mm);
            this.blacklistStyles = a.blacklistStyles;
        }
        Em.prototype.install = function(a) {
            a.fragmentableDetectors.push(this);
        };
        Em.prototype.isElementFragmentable = function(a) {
            var b = a.element, c = this.selectors.some(function(d) {
                return d.matches(b);
            });
            (c = this.allowByDefault ? !c : c) && this.blacklistStyles && (c = this.blacklistStyles.every(function(d) {
                var e = a.getStyle(d.property);
                return -1 === d.values.indexOf(e);
            }));
            return c;
        };
        Em.prototype.isFragmentableDetectorFor = function() {
            return !0;
        };
        function Fm() {
            this.g = t.BrowserDetector.isBrowser("Firefox");
            this.name = "FragmentableVerticalOverflowDetectorPlugin";
        }
        Fm.prototype.install = function(a) {
            a.fragmentableDetectors.push(this);
        };
        Fm.prototype.isElementFragmentable = function() {
            return !1;
        };
        Fm.prototype.isFragmentableDetectorFor = function(a) {
            return this.g ? !1 : a.element.scrollHeight > a.element.clientHeight && "visible" !== a.getStyle("overflowY");
        };
        var Gm = /^li$/i;
        function Hm(a) {
            this.name = "ListBreakPlugin";
            this.j = this.h = this.m = this.g = 0;
            this.h = a.widows.minItems;
            this.j = a.widows.penalty;
            this.g = a.orphans.minItems;
            this.m = a.orphans.penalty;
        }
        k = Hm.prototype;
        k.breakElement = function(a, b) {
            var c = a.cloneNode(!1);
            if (Gm.test(a.nodeName)) {
                a.style.listStyleType = "none";
                for(var d = 0; d < b; d++)c.appendChild(a.firstChild);
            } else {
                d = a.hasAttribute("start") ? +a.getAttribute("start") : 1;
                for(var e = 0; e < b; e++)Gm.test(a.firstChild.nodeName) && d++, c.appendChild(a.firstChild);
                a.setAttribute("start", d + "");
            }
            return c;
        };
        k.getOrphanElementPenalty = function(a, b, c) {
            return !Gm.test(a.tagName) || null === a.nextElementSibling || Im(c) ? 0 : Jm(a, this.g, Km, this.m);
        };
        k.getWidowElementPenalty = function(a, b, c, d) {
            var e = a.tagName, f = 0;
            !b && /^(?:ul|ol)$/i.test(e) && Im(hb(d.rootScope.element, a)) ? f = this.j : Gm.test(a.tagName) && null !== a.previousElementSibling && !Im(c) && (f = Jm(a, this.h, Lm, this.j));
            return f;
        };
        k.install = function(a) {
            a.elementFragmenters.push(this);
            1 < this.h && a.widowElementPenalizers.push(this);
            1 < this.g && a.orphanElementPenalizers.push(this);
        };
        k.isFragmenterForElement = function(a) {
            return /^(?:ol|li)$/i.test(a.tagName);
        };
        function Jm(a, b, c, d) {
            for(var e = 0; a;)Gm.test(a.nodeName) && e++, a = c(a);
            return e < b ? d : 0;
        }
        function Im(a) {
            return a.some(function(b) {
                return Gm.test(b.nodeName);
            });
        }
        function Lm(a) {
            return a.nextElementSibling;
        }
        function Km(a) {
            return a.previousElementSibling;
        }
        function Mm(a) {
            this.name = "OrphanTextPatternPlugin";
            this.rules = [];
            if (a.rules) for(var b = 0; b < a.rules.length; b++){
                var c = a.rules[b];
                this.rules.push({
                    pattern: new RegExp(c.pattern, c.flags),
                    penalty: c.penalty | 0
                });
            }
        }
        Mm.prototype.getOrphanTextPenalty = function(a, b) {
            if (b) return 0;
            a = a.getRange().toString();
            for(var c = b = 0; c < this.rules.length; c++){
                var d = this.rules[c];
                d.pattern.test(a) && (b += d.penalty);
            }
            return b;
        };
        Mm.prototype.install = function(a) {
            0 < this.rules.length && a.orphanTextPenalizers.push(this);
        };
        function Nm() {
            this.name = "FragmentableTableDetectorPlugin";
        }
        Nm.prototype.install = function(a) {
            a.fragmentableDetectors.push(this);
        };
        Nm.prototype.isElementFragmentable = function(a) {
            return 1 === a.element.childElementCount;
        };
        Nm.prototype.isFragmentableDetectorFor = function(a) {
            return "tr" === a.element.localName || "table-row" === a.getStyle("display");
        };
        function Om() {
            this.name = "TableFragmenterPlugin";
        }
        Om.prototype.breakElement = function(a, b, c) {
            for(var d = a.cloneNode(!1), e = 0; e < b; e++){
                var f = a.firstChild;
                I(f) && "colgroup" === f.localName && Pm(a, f.cloneNode(!0), c);
                d.appendChild(f);
            }
            return d;
        };
        Om.prototype.install = function(a) {
            a.elementFragmenters.push(this);
        };
        Om.prototype.isFragmenterForElement = function(a) {
            return "table" === a.localName && null !== a.querySelector("colgroup");
        };
        function Pm(a, b, c) {
            c(function(d) {
                return d.prepend(b, a);
            });
        }
        function Qm(a, b) {
            var c = b.getScopeForNode(a);
            c || (c = b.root.getScopeForNode(a));
            if (!c) throw new Re("NODE_SCOPE_NOT_FOUND", String(a));
            return c;
        }
        function Rm(a, b, c, d) {
            this.container = a;
            this.offset = b;
            this.shrinkingEnabled = c;
            this.rootScope = d;
            this.m = this.j = null;
        }
        Rm.prototype.equals = function(a) {
            return !!a && this.container === a.container && this.offset === a.offset && this.shrinkingEnabled === a.shrinkingEnabled;
        };
        Rm.prototype.getFragmentedNodes = function(a) {
            a || (a = this.rootScope.element);
            var b = hb(a, this.container);
            if (b[0] !== a) throw new Re("INVALID_BREAK_POINT_ROOT");
            return b;
        };
        function Sm(a, b) {
            for(var c, d = a.offset - 1; 0 <= d && !c; d--){
                var e = a.container.childNodes[d];
                if (kf(e) || lf(e)) c = Qm(e, b);
            }
            return c || b.getPreviousBottomUp();
        }
        Rm.prototype.isInsideElement = function() {
            return 1 === this.container.nodeType;
        };
        Rm.prototype.isInsideText = function() {
            return 3 === this.container.nodeType;
        };
        function Tm(a, b) {
            if (a.j) return a.j;
            var c = null;
            if (a.isInsideElement()) {
                var d = jf(a.container.childNodes[a.offset], b.root.element, !0);
                null !== d && (b = Qm(d, b), !b.isDisplayed() && (b = b.getPreviousLeaf(!0)) && (d = b.getEndNode(), 0 === d.childNodes.length && gf(d) || (d = jf(d, b.root.element, !1), b = Qm(d, b))), b && d && (c = {
                    node: d,
                    scope: b
                }));
            } else b = Qm(a.container, b), c = {
                node: a.container,
                scope: b
            };
            return a.j = c;
        }
        function Um(a, b) {
            if (a.m) return a.m;
            b || (b = a.rootScope);
            var c = null;
            if (a.isInsideElement()) {
                var d = ff(a.container.childNodes[a.offset - 1], b.root.element, !0);
                null !== d && (b = Qm(d, b), !b.isDisplayed() && (b = b.getNextLeaf(!0)) && (d = b.getStartNode(), 0 === d.childNodes.length && gf(d) || (d = ff(d, b.root.element, !1), b = Qm(d, b))), b && d && (c = {
                    node: d,
                    scope: b
                }));
            } else b = Qm(a.container, b), c = {
                node: a.container,
                scope: b
            };
            return a.m = c;
        }
        function Vm(a, b) {
            return !(!Tm(a, b) || !Um(a, b));
        }
        function Wm(a, b, c, d) {
            Rm.call(this, a, b, c, d.root);
            this.g = d;
            if (H(a)) this.h = Sm(this, d);
            else if (J(a)) this.h = Qm(a, d);
            else throw new Re("ILLEGAL_BREAK_POINT_CONTAINER");
        }
        q.inherits(Wm, Rm);
        function Xm(a, b, c) {
            var d = Xe(a, c.root.element);
            if (d) {
                a = O(d) + 1;
                d = d.parentNode;
                var e = d.childNodes[a];
                e = c.isRangeScope() && c.containsNode(e, !0);
                e || (c.isLeaf() ? e = c.getNextLeaf(!0) : (e = c.getPreviousLeaf(!0)) && (e = e.getNextLeaf(!0)), e = !!e);
                if (e) return new Wm(d, a, b, c);
            }
            return null;
        }
        function Ym(a, b, c) {
            if (a = Ze(a, c.root.element)) {
                var d = O(a), e = a.parentNode, f = e.childNodes[d - 1];
                f = c.isRangeScope() && c.containsNode(f, !0);
                f || (c.isLeaf() ? f = c.getPreviousLeaf(!0) : (f = c.getNextLeaf(!0)) && (f = f.getPreviousLeaf(!0)), f = !!f);
                if (f) return a ? new Wm(e, d, b, c) : null;
            }
            return null;
        }
        function Zm(a, b) {
            return Ym(a.getStartNode(), b, a);
        }
        function $m(a, b, c, d) {
            var e;
            0 >= b ? e = Ym(a, c, d) : b >= a.data.length ? e = Xm(a, c, d) : e = new Wm(a, b, c, d);
            return e;
        }
        Wm.prototype.getDeepestOrphan = function() {
            var a = Tm(this, this.h);
            if (!a) throw new Re("ORPHAN_NOT_FOUND");
            return a;
        };
        Wm.prototype.getDeepestWidow = function() {
            var a = Um(this, this.h);
            if (!a) throw new Re("WIDOW_NOT_FOUND");
            return a;
        };
        Wm.prototype.getScopeBeforeBreakPoint = function() {
            return this.h;
        };
        Wm.prototype.isValid = function() {
            return Vm(this, this.h);
        };
        function an() {
            this.name = "UnforcedContainerBreakPlugin";
        }
        an.prototype.getUnforcedBreakPointCandidates = function(a, b) {
            return [
                Zm(a, b)
            ];
        };
        an.prototype.install = function(a) {
            a.unforcedBreakDetectors.push(this);
        };
        an.prototype.isUnforcedBreakDetectorFor = function(a) {
            return a.isParentScope();
        };
        function bn() {
            this.name = "UnforcedRowspanTrBreakPlugin";
        }
        bn.prototype.getUnforcedBreakPointCandidates = function(a, b) {
            var c = a.getStartNode();
            if (I(c)) {
                var d = c.parentElement;
                return d ? cn(c, d) ? [] : [
                    Zm(a, b)
                ] : [
                    Zm(a, b)
                ];
            }
            return [];
        };
        bn.prototype.install = function(a) {
            a.unforcedBreakDetectors.push(this);
        };
        bn.prototype.isUnforcedBreakDetectorFor = function(a) {
            a = a.getStartNode();
            var b = a.parentElement;
            return I(a) && "tr" === a.localName && null !== b && null !== b.querySelector("tr > td[rowspan], tr > th[rowspan]");
        };
        function cn(a, b) {
            if (b) {
                var c = Array.from(b.querySelectorAll("tr > td[rowspan], tr > th[rowspan]")), d = Array.from(b.children).filter(function(f) {
                    return "tr" === f.localName;
                }), e = d.findIndex(function(f) {
                    return f === a;
                });
                return c.some(function(f) {
                    try {
                        var g, h = parseInt(null != (g = f.getAttribute("rowspan")) ? g : "0"), l = f.parentNode, m = d.findIndex(function(n) {
                            return n === l;
                        });
                        f = e - m;
                        return 0 < f && f < h;
                    } catch (n) {
                        return t.Logger.logWarning("Rowspan attribute value not a number"), !1;
                    }
                });
            }
            return !1;
        }
        function dn() {
            this.Ya = this.o = this.j = null;
            this.h = !1;
        }
        function en(a, b, c, d) {
            a.Ya = b;
            a.o = c || b;
            a.j = d || b;
            a.h = b === a.j;
            a.g.init(b, c || b);
            fn(a, a.j);
        }
        function fn(a, b) {
            b === a.Ya && (a.h = !0);
            if (a.h) {
                var c = b.nodeType;
                c = 1 === c ? I(b) ? a.m(b) : a.g.Kb(b) : 3 === c ? a.g.$b(b) : 8 === c ? a.g.Zb(b) : a.g.Kb(b);
            } else I(b) && (c = a.m(b));
            return c || b === a.o;
        }
        function gn(a, b) {
            for(var c = !1, d, e = b.firstChild; e && !c;)d = e.nextSibling, c = fn(a, e), a.g.Cg(e) && b.removeChild(e), e = d;
            return c;
        }
        function hn(a) {
            dn.call(this);
            this.g = a;
        }
        q.inherits(hn, dn);
        hn.prototype.m = function(a) {
            var b = !1, c = !1;
            this.h && (b = this.g.sa(a));
            b || this.h && !this.g.Jb(a) || (b = gn(this, a), c = !0);
            !b && this.h && (b = this.g.ia(a, c));
            return b;
        };
        function jn(a, b, c) {
            this.scope = a;
            this.shrinkingEnabled = c;
            this.g = [];
            this.j = !0;
            this.range = a.getStartNode().ownerDocument.createRange();
            this.h = b - a.getLineBoxBottomMarginInClientRectPx();
        }
        k = jn.prototype;
        k.Jb = function(a) {
            return this.j && this.scope.config.isElementFragmentable(this.scope.config.getRfElement(a), this.scope.root.isXml);
        };
        k.destroy = function() {
            this.range.detach();
        };
        k.sa = function(a) {
            (this.j = a.getBoundingClientRect().bottom > this.h) && 0 < this.scope.config.getFragmentationPenalty(a, [], this.scope.root.isXml) && this.g.push(Ym(a, this.shrinkingEnabled, this.scope));
            return !1;
        };
        k.ia = function(a) {
            if (0 === a.childNodes.length) {
                if ("BR" === a.tagName || "br" === a.tagName) this.g.push(Ym(a, this.shrinkingEnabled, this.scope));
                else {
                    var b = a.getBoundingClientRect();
                    if (0 < b.height && b.bottom > this.h) return this.g.push(Ym(a, this.shrinkingEnabled, this.scope)), !0;
                }
            }
            return !1;
        };
        k.init = function() {};
        k.Cg = function() {
            return !1;
        };
        k.Zb = function() {
            return !1;
        };
        k.Kb = function() {
            return !1;
        };
        k.$b = function(a) {
            if (ef(a)) return !1;
            this.range.selectNode(a);
            for(var b = this.range.getClientRects(), c = Number.MIN_VALUE, d = Number.MAX_VALUE, e = 0; e < b.length; e++){
                var f = b[e];
                d = Math.min(f.bottom, d);
                c = Math.max(f.bottom, c);
            }
            return d > this.h ? (this.g.push(Ym(a, this.shrinkingEnabled, this.scope)), !0) : c > this.h ? ((b = kn(this, a)) || (b = Ym(a, this.shrinkingEnabled, this.scope)), this.g.push(b), !0) : !1;
        };
        function kn(a, b) {
            var c = a.range, d = /^\s*/.exec(b.data), e = 1 + (d ? d[0].length : 0);
            if (e >= b.data.length) return null;
            c.setStart(b, e);
            d = ln(a, b);
            var f = 0;
            d = (b.data.match(d) || []).map(function(h) {
                return f += h.length;
            });
            var g = ya(d, 1, d.length, function(h, l) {
                h = h[l];
                return h > e && (c.setEnd(b, h), !(c.getBoundingClientRect().bottom > a.h)) ? 1 : -1;
            });
            return 0 <= g ? $m(b, d[g], a.shrinkingEnabled, a.scope) : null;
        }
        function ln(a, b) {
            var c = /\s*\S+\s*/g, d = /\s*?(?:\S+|\n|$)/g, e = /[\s\S]*/g;
            b = b.parentElement;
            if (!b) return c;
            a = a.scope.config.getRfElement(b).getStyle("whiteSpace");
            return "normal" === a ? c : "nowrap" === a ? e : d;
        }
        function mn(a) {
            this.name = "UnforcedTextBreakPlugin";
            this.orphans = a.orphans;
            this.widows = a.widows;
            this.loneWidowNotFragmented = a.loneWidowNotFragmented;
            this.textFragmentationPenalty = a.textFragmentationPenalty;
        }
        k = mn.prototype;
        k.getFragmentationPenalty = function(a) {
            return 3 === a.nodeType ? this.textFragmentationPenalty : 0;
        };
        k.getOrphanTextPenalty = function(a, b, c) {
            if (!b) return 0;
            var d = this.orphans.minLinesFromCss ? a.parent.rfElement.getStyleAsNumber("orphans") : this.orphans.minLines;
            if (2 > d) return 0;
            b = a.createNewRange();
            b.setStartBefore(a.getStartNode());
            b.setEnd(c.container, c.offset);
            a = a.getLineHeightInClientRectPx();
            a *= d - .5;
            return b.getBoundingClientRect().height < a ? this.orphans.penalty : 0;
        };
        k.getUnforcedBreakPointCandidates = function(a, b) {
            var c = a.getLineHeightInClientRectPx(), d = [], e = a.getBoundingClientRect(), f = a.getClientRectBottomLimit(b, !0);
            if (f - e.top > c) {
                d.push.apply(d, nn(a, f, b));
                var g = Math.max(1, this.widows.minLinesFromCss ? a.parent.rfElement.getStyleAsNumber("widows") : this.widows.minLines), h = Math.max(1, this.orphans.minLinesFromCss ? a.parent.rfElement.getStyleAsNumber("orphans") : this.orphans.minLines);
                g *= c;
                var l = .5 * c;
                f = e.bottom - f < g - l;
                e.height > c * h + g - l && f && d.push.apply(d, nn(a, e.bottom - (g - l), b));
            }
            d.push(Zm(a, b));
            return d;
        };
        k.getWidowTextPenalty = function(a, b, c) {
            var d = 0;
            if (b) {
                var e = this.widows.minLinesFromCss ? a.parent.rfElement.getStyleAsNumber("widows") : this.widows.minLines;
                if (1 < e) {
                    var f = a.createNewRange();
                    f.setStart(c.container, c.offset);
                    f.setEndAfter(a.getEndNode());
                    f.getBoundingClientRect().height < (e - .5) * a.getLineHeightInClientRectPx() && (d += this.widows.penalty);
                    f.detach();
                }
            }
            b || null !== a.getNextLeaf(!0) || (e = this.loneWidowNotFragmented.minLinesFromCss ? a.parent.rfElement.getStyleAsNumber("widows") : this.loneWidowNotFragmented.minLines, 1 < e && a.getBoundingClientRect().height < (e - .5) * a.getLineHeightInClientRectPx() && (d += this.loneWidowNotFragmented.penalty));
            return d;
        };
        k.install = function(a) {
            a.unforcedBreakDetectors.push(this);
            (this.widows.minLinesFromCss || this.widows.minLines || this.loneWidowNotFragmented.minLinesFromCss || this.loneWidowNotFragmented.minLines) && a.widowTextPenalizers.push(this);
            (this.orphans.minLinesFromCss || this.widows.minLines) && a.orphanTextPenalizers.push(this);
            this.textFragmentationPenalty && a.fragmentationPenalizers.push(this);
        };
        k.isUnforcedBreakDetectorFor = function(a) {
            return a.isRangeScope();
        };
        function nn(a, b, c) {
            b = new jn(a, b, c);
            en(new hn(b), a.getStartNode(), a.getEndNode(), a.parent.element);
            b.destroy();
            return b.g;
        }
        function on(a) {
            this.name = "VerticalWhitespacePenalizerPlugin";
            a = a.stops;
            a.sort(function(d, e) {
                return d.penalty - e.penalty;
            });
            for(var b = 0; b < a.length; b++){
                var c = a[b];
                c.whitespaceRatio = Math.min(1, Math.max(0, c.whitespaceRatio));
            }
            b = a[0];
            1 === a.length ? 0 === b.whitespaceRatio ? a.push({
                penalty: b.penalty,
                whitespaceRatio: 1
            }) : a = [
                {
                    penalty: 0,
                    whitespaceRatio: 0
                },
                {
                    penalty: b.penalty / b.whitespaceRatio,
                    whitespaceRatio: 1
                }
            ] : 1 < a.length && (0 !== b.whitespaceRatio && a.unshift({
                penalty: 0,
                whitespaceRatio: 0
            }), b = a[a.length - 1], 1 !== b.whitespaceRatio && (c = a[a.length - 2], a.push({
                penalty: Sa(1, c.whitespaceRatio, b.whitespaceRatio, c.penalty, b.penalty),
                whitespaceRatio: 1
            })));
            this.g = a;
        }
        on.prototype.getWhitespacePenalty = function(a) {
            var b = this.g, c = b.findIndex(function(e) {
                return e.whitespaceRatio >= a;
            });
            if (0 === c) return b[0].penalty;
            -1 === c && (c = b.length - 1);
            var d = b[c];
            b = b[c - 1];
            return Sa(a, b.whitespaceRatio, d.whitespaceRatio, b.penalty, d.penalty);
        };
        on.prototype.install = function(a) {
            a.whitespacePenalizers.push(this);
        };
        function pn(a) {
            this.g = a;
            this.ua = [];
            this.A = [];
            this.Ma = this.o = this.Z = this.j = this.h = this.Za = this.U = 0;
            this.Sa = !0;
            this.m = this.ja = 0;
            this.H = [];
            this.Ba = a.getFragmentedNodes(a.rootScope.element);
        }
        function qn(a) {
            a.Ma = a.Sa ? a.Z + rn(a.A) + rn(a.H) + rn(a.ua) : Number.MAX_SAFE_INTEGER;
            a.o = a.Ma + a.ja;
        }
        function sn(a) {
            var b = a.Ba.map(function(d) {
                return {
                    attributes: Ve(d),
                    nodeName: d.nodeName
                };
            }), c = null;
            a.g.isInsideElement() && (c = a.g.container.childNodes[a.g.offset], c = {
                attributes: Ve(c),
                nodeName: c.nodeName
            });
            return {
                breakBeforeNodeInfo: c,
                breakOffset: a.g.offset,
                breakPath: b,
                fragmentation: a.ua,
                orphans: a.A,
                pageShrinkFactor: a.U,
                remainingWhitespacePx: a.Za,
                shrinkAmountRegisteredPx: a.h,
                shrinkAmountRequiredPx: a.j,
                shrinkingEnabled: a.g.shrinkingEnabled,
                shrinkPenalty: a.Z,
                totalPenalty: a.o,
                valid: a.Sa,
                whitespacePenalty: a.ja,
                whitespaceRatio: a.m,
                widows: a.H
            };
        }
        function rn(a) {
            for(var b = 0, c = 0; c < a.length; c++)b += a[c].penalty;
            return b;
        }
        function tn(a) {
            this.config = a;
        }
        function un(a, b) {
            var c = [], d = [];
            vn(b, d);
            b = [];
            for(var e = 0; e < d.length; e++){
                var f = d[e];
                -1 === b.indexOf(f.g) && b.push(f.g);
            }
            for(e = 0; e < d.length; e++){
                f = d[e];
                var g = !1, h = f.shrinkingEnabled;
                f.isValid() ? (g = wn(a, f), c.push(g), g = !h && (0 !== g.Ma || g.m < a.config.options.minBreakPointSearchRatio)) : g = !0;
                g && (g = void 0, f.g.isLeaf() ? g = f.g.getPreviousLeaf(!0) : (g = f.g.getNextLeaf(!0)) && (g = g.getPreviousLeaf(!0)), g && -1 === b.indexOf(g) && (b.push(g), f = xn(g, h), vn(f, d)));
            }
            return c.sort(function(l, m) {
                if (l.o !== m.o) return l.o - m.o;
                var n = l.g.container, p = m.g.container;
                return n === p ? m.g.offset - l.g.offset : n.compareDocumentPosition(p) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1;
            });
        }
        function wn(a, b) {
            for(var c = new pn(b), d = c.Ba.slice(0), e = c.g.rootScope.isXml; 0 < d.length;){
                var f = d.shift();
                (f = yn(a.config, f, d, e)) && c.ua.push(f);
            }
            if (!b.isValid()) return c.Sa = !1, qn(c), c;
            e = b.getDeepestOrphan();
            d = e.scope;
            f = e.node;
            if (b instanceof Wm) {
                if (b.isInsideText()) {
                    for(e = c.Ba.slice(0); 0 < e.length;)f = e.shift(), kf(f) && (zn(a, f, c, !0, e), An(a, f, c, !0, e));
                    d.isRangeScope() && ((e = Bn(a.config, d, !0, c.g)) && c.A.push(e), (e = Cn(a.config, d, !0, c.g)) && c.H.push(e));
                } else {
                    var g = b.getDeepestWidow();
                    e = g.scope;
                    g = g.node;
                    var h = d.root.element;
                    f = hb(h, f);
                    for(g = hb(h, g); 0 < f.length || 0 < g.length;){
                        h = f.shift();
                        var l = g.shift();
                        h && h === l ? kf(h) && (zn(a, h, c, !0, f), An(a, l, c, !0, g)) : (kf(h) && zn(a, h, c, !1, f), kf(l) && An(a, l, c, !1, g));
                    }
                    d.isRangeScope() && (f = Bn(a.config, d, d === e, c.g)) && c.A.push(f);
                    e.isRangeScope() && (e = Cn(a.config, e, d === e, c.g)) && c.H.push(e);
                }
            }
            d = d.root;
            e = b.getScopeBeforeBreakPoint();
            var m;
            e.isRangeScope() ? m = e.getRemainingWhiteSpaceAfterBreakpoint(!1, b) : m = e.getRemainingWhiteSpaceAfter(!1);
            f = e;
            if (b.shrinkingEnabled) for(g = e.getPreviousBottomUp(); g;)g.isForked() && (h = g.getRemainingWhiteSpaceAfter(!1), h < m && (m = h, f = g)), g = g.getPreviousBottomUp();
            c.h = e.getTotalShrinkableAmount();
            c.j = Math.max(0, -m);
            c.U = c.j / d.getPageContentHeight(!0);
            e = f.parent ? f.parent.getTotalNonUsableWhitespace() : 0;
            c.m = Math.max(0, m) / (d.getPageContentHeight(!0) - e);
            c.Za = c.j > c.h ? m - c.h : Math.max(0, m);
            b.shrinkingEnabled && (b = a.config.getShrinkPenalty(c.j, c.h), c.Z += b);
            a = a.config.getWhitespacePenalty(c.m);
            c.ja += a;
            qn(c);
            return c;
        }
        function Dn(a, b) {
            var c = null, d = null, e = [];
            0 < b.h.length && (c = b.h[0].g, e.push.apply(e, b.h));
            0 < b.j.length && (d = b.j[0].g, e.push.apply(e, b.j));
            if (d) for(d.isLeaf() || (d = d.getNextLeaf(!1) || d), b = d.getPreviousLeaf(!1); b && b !== c;)e.push.apply(e, xn(b, !0)), b = b.getPreviousLeaf(!1);
            return un(a, e);
        }
        function zn(a, b, c, d, e) {
            (a = En(a.config, b, d, e, c.g)) && c.A.push(a);
        }
        function An(a, b, c, d, e) {
            (a = Fn(a.config, b, d, e, c.g)) && c.H.push(a);
        }
        function vn(a, b) {
            for(var c = {}, d = 0; d < a.length; c = {
                kf: void 0
            }, d++)c.kf = a[d], b.every(function(e) {
                return function(f) {
                    return !f.equals(e.kf);
                };
            }(c)) && b.push(c.kf);
        }
        function Gn(a, b, c, d, e) {
            Rm.call(this, a, b, c, d);
            this.zd = e;
            this.g = null;
        }
        q.inherits(Gn, Rm);
        function Hn(a, b, c, d) {
            return (a = Xe(a, b.element)) ? new Gn(a.parentNode, O(a) + 1, c, b, d) : null;
        }
        function In(a, b, c, d) {
            return (a = Ze(a, b.element)) ? new Gn(a.parentNode, O(a), c, b, d) : null;
        }
        Gn.prototype.getDeepestOrphan = function() {
            return Tm(this, this.rootScope);
        };
        Gn.prototype.getDeepestWidow = function() {
            return Um(this, this.rootScope);
        };
        Gn.prototype.getScopeBeforeBreakPoint = function() {
            return Sm(this, this.rootScope);
        };
        Gn.prototype.isValid = function() {
            return Vm(this, this.rootScope);
        };
        function Jn(a, b) {
            this.config = a;
            this.data = b;
            this.isXml = !1;
            this.g = this.h = null;
        }
        function Kn(a, b) {
            var c = a.config.forcedBreakDetectors;
            0 < c.length && (a.detectForcedBreakMarker(b, c), Ln(a.data) && a.detectForcedBreakBefore(b, c));
        }
        function Mn(a, b) {
            for(var c = a.config.forcedBreakDetectors, d = null, e = 0; e < c.length && !d; e++)d = c[e].detectForcedBreakAfter(b, a.isXml);
            d && a.data.rootScope && (b = Hn(b.element, a.data.rootScope, 2 === a.data.g, Nn(b.element, "after", d))) && a.data.m.push(b);
        }
        Jn.prototype.detectForcedBreakBefore = function(a, b) {
            for(var c = null, d = 0; d < b.length && !c; d++)c = b[d].detectForcedBreakBefore(a, this.isXml);
            c && this.data.rootScope && (a = In(a.element, this.data.rootScope, 2 === this.data.g, Nn(a.element, "before", c))) && this.data.m.push(a);
        };
        Jn.prototype.detectForcedBreakMarker = function(a, b) {
            for(var c, d = 0; d < b.length && !c; d++)c = b[d], c = c.detectForcedBreakMarker ? c.detectForcedBreakMarker(a, this.isXml) : null;
            c && (b = c, a = a.element, d = Xe(a, this.g), c = Ze(a, this.g), d && c && this.data.rootScope ? (b = Nn(a, "marker", b), (b = cb(this.g, d) < cb(this.g, c) ? Hn(d, this.data.rootScope, 2 === this.data.g, b) : In(c, this.data.rootScope, 2 === this.data.g, b)) ? (b.g = a, this.data.m.push(b)) : this.h = a) : this.h = a);
        };
        function Nn(a, b, c) {
            return {
                attributes: Ve(a),
                mode: c,
                nodeName: a.nodeName,
                position: b
            };
        }
        function On() {
            this.m = [];
            this.o = !1;
            this.A = null;
            this.j = [];
            this.h = [];
            this.g = 1;
        }
        function Ln(a) {
            return 1 === a.g || 2 === a.g;
        }
        function Pn(a) {
            this.parent = a;
            this.fragmentable = !0;
            this.Gd = this.vf = this.oc = this.previous = this.next = null;
            a && (a.children.push(this), this.parent = a, a.lastChild && (a.lastChild.next = this, this.previous = a.lastChild), a.lastChild = this, this.root = a.root, this.config = this.root.config);
        }
        k = Pn.prototype;
        k.createNewRange = function(a, b) {
            var c = this.getStartNode().ownerDocument.createRange();
            a && (b ? (c.setStartBefore(a), c.setEndAfter(b)) : c.selectNode(a));
            return c;
        };
        k.destroy = function() {
            this.parent = this.previous = this.next = null;
        };
        k.getClientRectBottomLimit = function(a, b) {
            var c = this.parent.element, d = c.offsetTop;
            c = d + c.offsetHeight;
            var e = this.parent.getBoundingClientRect();
            a = a ? this.getTotalShrinkableAmount() : 0;
            var f = e.top;
            e = e.bottom;
            d === c && (c++, e++);
            return Sa(this.parent.containerMeasurer.getOffsetBottomLimit(!1, b) + a, d, c, f, e);
        };
        k.getNextBottomUp = function() {
            var a = this.next;
            if (a) for(; a && a.isParentScope() && !a.isLeaf();)a = a.children[0];
            else a = this.parent;
            return a;
        };
        k.getNextLeaf = function(a) {
            for(var b = this.getNextTopDown(); b && (!b.isLeaf() || a && !b.isDisplayed());)b = b.getNextTopDown();
            return b;
        };
        k.getNextTopDown = function() {
            var a = this.next;
            if (!a) for(var b = this; !a && (b = b.parent);)a = b.next;
            return a;
        };
        k.getOffsetBottomLimit = function(a, b) {
            return this.parent.containerMeasurer.getChildOffsetBottomLimitWithoutMargin(!1, b) + (a ? this.getTotalShrinkableAmount() : 0) - this.getTotalMarginBottom(b);
        };
        k.getPreviousBottomUp = function() {
            var a = this.previous;
            if (!a) for(var b = this; !a && (b = b.parent);)a = b.previous;
            return a;
        };
        k.getPreviousLeaf = function(a) {
            for(var b = this.getPreviousBottomUp(); b && (!b.isLeaf() || a && !b.isDisplayed());)b = b.getPreviousBottomUp();
            return b;
        };
        k.getPreviousTopDown = function() {
            var a = this.previous;
            if (a) for(; a && a.isParentScope() && !a.isLeaf();)a = a.children[a.children.length - 1];
            else a = this.parent;
            return a;
        };
        k.getTotalShrinkableAmount = function() {
            if (null === this.Gd) {
                for(var a = this.getPreviousBottomUp(); a && null === a.Gd;)a = a.getPreviousBottomUp();
                this.Gd = a ? a.Gd + (this.oc || 0) : this.oc || 0;
            }
            return this.Gd;
        };
        function xn(a, b) {
            var c = Qn(a.config, a);
            return c ? c.getUnforcedBreakPointCandidates(a, b).filter(function(d) {
                return null !== d;
            }) : (a = Zm(a, b)) ? [
                a
            ] : [];
        }
        k.isDisplayed = function() {
            var a = this.getBoundingClientRect();
            return 0 < a.height && 0 < a.width;
        };
        k.isOverflowing = function(a) {
            return 0 > this.getRemainingWhiteSpaceAfter(a);
        };
        k.processShrinkableElements = function(a) {
            for(var b = [], c = this; c;){
                if (c.isParentScope() && null !== c.oc) {
                    var d = c.oc * a;
                    b.push({
                        element: c.element,
                        maxShrinkAmount: c.oc,
                        shrinkAmount: d
                    });
                    var e = Rn(this.config, c);
                    e && Qa(e.postProcessShrink) && e.postProcessShrink(c, d, c.oc);
                }
                c = c.getPreviousBottomUp();
            }
            return b;
        };
        k.getTotalMarginBottom = function(a) {
            null === this.vf && (this.vf = this.parent.containerMeasurer.getTotalMarginBottom(0, 0, a));
            return this.vf;
        };
        function Sn(a, b, c) {
            Pn.call(this, a);
            this.rfElement = b;
            this.children = [];
            this.clientRect = this.lastChild = null;
            this.element = b.element;
            this.A = !!c;
            this.config && (this.containerMeasurer = Tn(this.config, this).createContainerMeasurer(this));
        }
        q.inherits(Sn, Pn);
        k = Sn.prototype;
        k.containsNode = function(a, b) {
            var c = a === this.element;
            if (b) for(; !c && a;)a = a.parentNode, c = a === this.element;
            return c;
        };
        k.destroy = function() {
            for(var a = 0; a < this.children.length; a++)this.children[a].destroy();
            this.containerMeasurer = this.rfElement = this.element = this.clientRect = this.lastChild = this.children = null;
            Pn.prototype.destroy.call(this);
        };
        k.getBoundingClientRect = function() {
            null === this.clientRect && (this.clientRect = this.element.getBoundingClientRect());
            return this.clientRect;
        };
        k.getClientRectBottomLimit = function(a, b) {
            var c = this.element.offsetTop, d = c + this.element.offsetHeight, e = this.getBoundingClientRect();
            c === d && d++;
            return Sa(this.getOffsetBottomLimit(a, b), c, d, e.top, e.bottom);
        };
        k.getClientRectScalingFactor = function() {
            var a = this.getBoundingClientRect().height;
            return 0 >= a ? this.parent ? this.parent.getClientRectScalingFactor() : 1 : this.element.offsetHeight / a;
        };
        k.getEndNode = function() {
            return this.element;
        };
        k.getLineHeightInClientRectPx = function() {
            return Sa(this.getLineHeightInCssPx(), 0, Math.max(this.element.offsetHeight, 1), 0, Math.max(this.getBoundingClientRect().height, 1));
        };
        k.getLineHeightInCssPx = function() {
            var a = this.rfElement.getStyle("lineHeight");
            a = parseFloat(a);
            return isNaN(a) ? 1.2 * this.rfElement.getStyleAsNumber("fontSize") : a;
        };
        k.getNextTopDown = function() {
            return this.isLeaf() ? Pn.prototype.getNextTopDown.call(this) : this.children[0];
        };
        k.getOffsetBottomLimit = function(a, b) {
            return this.containerMeasurer.getOffsetBottomLimit(!0, b) + (a ? this.getTotalShrinkableAmount() : 0);
        };
        k.getPreviousBottomUp = function() {
            return this.isLeaf() ? Pn.prototype.getPreviousBottomUp.call(this) : this.lastChild;
        };
        k.getRemainingWhiteSpaceAfter = function(a) {
            return this.getOffsetBottomLimit(a, !1) - this.element.offsetTop - this.element.offsetHeight;
        };
        k.getRemainingWhiteSpaceBefore = function(a) {
            return this.getOffsetBottomLimit(a, !1) - this.element.offsetTop;
        };
        k.getScopeForNode = function(a) {
            var b = null;
            if (this.element === a) b = this;
            else if (a = hb(this.element, a), a.shift() === this.element) for(b = this; 0 < a.length && !b.isLeaf() && b instanceof Sn;){
                var c = a.shift();
                var d = b.children.find(function(e) {
                    return e.containsNode(c, !1);
                });
                d && (b = d);
            }
            return b;
        };
        k.getStartNode = function() {
            return this.element;
        };
        k.getTotalNonUsableWhitespace = function() {
            return this.containerMeasurer.getTotalMarginBottom(0, 0, !1) + this.containerMeasurer.getTotalMarginTop(0, 0) + this.containerMeasurer.getTotalVerticalPaddingAndBorder(!1);
        };
        k.isDisplayed = function() {
            return Pn.prototype.isDisplayed.call(this) || 0 < this.element.scrollHeight && "visible" === this.rfElement.getStyle("overflowY") || 0 < this.rfElement.getStyleAsNumber("marginTop");
        };
        k.isForked = function() {
            return this.A;
        };
        k.isLeaf = function() {
            return 0 === this.children.length;
        };
        k.isParentScope = function() {
            return !0;
        };
        k.isRangeScope = function() {
            return !1;
        };
        k.zg = function() {
            if (null === this.oc) {
                var a = Rn(this.config, this);
                a && (this.oc = a.getMaxShrinkAmountPx(this), this.getTotalShrinkableAmount());
            }
        };
        function Un(a, b) {
            Pn.call(this, a);
            this.Ya = b;
            this.g = this.clientRect = null;
            this.h = 0;
            this.j = !1;
            this.range = null;
        }
        q.inherits(Un, Pn);
        k = Un.prototype;
        k.containsNode = function(a) {
            var b = new R(this.Ya);
            for(b.aa = this.g || this.Ya; null !== b.g && b.g !== a;)S(b, !0);
            return b.g === a;
        };
        k.destroy = function() {
            this.range && (this.range.detach(), this.range = null);
            this.Ya = this.clientRect = this.g = null;
            Pn.prototype.destroy.call(this);
        };
        k.getBoundingClientRect = function() {
            this.clientRect || (this.clientRect = Vn(this, this.getRange()));
            return this.clientRect;
        };
        k.getEndNode = function() {
            return this.g || this.Ya;
        };
        k.getLineBoxBottomMarginInClientRectPx = function() {
            return this.getLineBoxBottomMarginInCssPx() / this.parent.getClientRectScalingFactor();
        };
        k.getLineBoxBottomMarginInCssPx = function() {
            var a = this.parent.rfElement;
            return this.config.h.getLineBoxBottomMarginInCssPx(this.Ya.ownerDocument, a.getStyle("fontFamily"), a.getStyleAsNumber("fontSize"), this.getLineHeightInCssPx());
        };
        k.getLineHeightInClientRectPx = function() {
            this.h || (this.h = this.parent.getLineHeightInClientRectPx());
            return this.h;
        };
        k.getLineHeightInCssPx = function() {
            return this.parent.getLineHeightInCssPx();
        };
        k.getRange = function() {
            null === this.range && (this.range = this.createNewRange(this.Ya, this.g || void 0));
            return this.range;
        };
        k.getRemainingWhiteSpaceAfter = function(a) {
            return (this.getClientRectBottomLimit(a, !1) - this.getBoundingClientRect().bottom) * this.parent.getClientRectScalingFactor();
        };
        k.getRemainingWhiteSpaceAfterBreakpoint = function(a, b) {
            a = this.getClientRectBottomLimit(a, !0) - this.getBoundingClientRect().top;
            var c = this.getRange().cloneRange();
            c.setEnd(b.container, b.offset);
            b = c.getBoundingClientRect();
            c.detach();
            b = b.height + this.getLineBoxBottomMarginInClientRectPx();
            return (a - b) * this.parent.getClientRectScalingFactor();
        };
        k.getRemainingWhiteSpaceBefore = function(a) {
            return (this.getClientRectBottomLimit(a, !0) - this.getBoundingClientRect().top) * this.parent.getClientRectScalingFactor();
        };
        k.getScopeForNode = function(a) {
            return this.containsNode(a) ? this : null;
        };
        k.getStartNode = function() {
            return this.Ya;
        };
        k.getTotalNonUsableWhitespace = function() {
            return this.parent.containerMeasurer.getTotalVerticalPaddingAndBorder(!1) + this.parent.containerMeasurer.getTotalMarginBottom(0, 0, !1) + this.parent.containerMeasurer.getTotalMarginTop(0, 0);
        };
        k.hasText = function() {
            return this.j;
        };
        k.isForked = function() {
            return !1;
        };
        k.isLeaf = function() {
            return !0;
        };
        k.isParentScope = function() {
            return !1;
        };
        k.isRangeScope = function() {
            return !0;
        };
        function Vn(a, b) {
            var c, d;
            I(b.startContainer) ? c = b.startContainer.childNodes[b.startOffset] : c = b.startContainer;
            I(b.endContainer) ? d = b.endContainer.childNodes[b.endOffset - 1] : d = b.endContainer;
            b = [
                b.getBoundingClientRect()
            ];
            I(c) && mf(c) && b.push(c.getBoundingClientRect());
            c = new R(c, function(l) {
                return I(l) && mf(l);
            });
            for(c.aa = d; c.g;)S(c, !0), c.g && b.push(c.g.getBoundingClientRect());
            var e, f;
            d = e = Number.MAX_VALUE;
            c = f = Number.MIN_VALUE;
            for(var g = 0; g < b.length; g++){
                var h = b[g];
                h.left < d && (d = h.left);
                h.top < e && (e = h.top);
                h.right > c && (c = h.right);
                h.bottom > f && (f = h.bottom);
            }
            f += a.getLineBoxBottomMarginInClientRectPx();
            return {
                bottom: f,
                height: f - e,
                left: d,
                right: c,
                top: e,
                width: c - d
            };
        }
        function Wn(a, b, c) {
            Sn.call(this, null, b);
            this.o = this.m = this.j = this.h = null;
            this.isXml = this.element.tagName === this.element.tagName.toLowerCase();
            this.root = this;
            this.config = a;
            this.containerMeasurer = Tn(a, this).createContainerMeasurer(this);
            this.g = c;
        }
        q.inherits(Wn, Sn);
        k = Wn.prototype;
        k.destroy = function() {
            Sn.prototype.destroy.call(this);
        };
        k.getPageContentHeight = function(a) {
            null === this.h && (this.h = this.g.getPageHeight(this));
            return a ? this.h : this.h - this.getPagePaddingBottom() + this.getPagePaddingTop();
        };
        k.getPageOffsetBottomLimit = function(a) {
            null === this.j && (this.j = this.g.getPageOffsetBottomLimit(this));
            return a ? this.j : this.j - this.getPagePaddingBottom();
        };
        k.getPagePaddingBottom = function() {
            null === this.m && (this.m = this.g.getPagePaddingBottom(this));
            return this.m;
        };
        k.getPagePaddingTop = function() {
            null === this.o && (this.o = this.g.getPagePaddingTop(this));
            return this.o;
        };
        k.getTotalNonUsableWhitespace = function() {
            return Sn.prototype.getTotalNonUsableWhitespace.call(this) + this.getPagePaddingTop() + this.getPagePaddingBottom();
        };
        function Xn(a, b) {
            Sn.call(this, a, b);
            this.rfElement = b;
        }
        q.inherits(Xn, Sn);
        k = Xn.prototype;
        k.getClientRectScalingFactor = function() {
            return 1;
        };
        k.getRemainingWhiteSpaceAfter = function() {
            return Number.MAX_SAFE_INTEGER;
        };
        k.isDisplayed = function() {
            return !1;
        };
        k.isLeaf = function() {
            return !0;
        };
        k.isOverflowing = function() {
            return !1;
        };
        k.zg = function() {};
        function Yn(a, b) {
            Pn.call(this, a);
            this.node = b;
        }
        q.inherits(Yn, Pn);
        k = Yn.prototype;
        k.containsNode = function(a, b) {
            var c = a === this.node;
            if (b) for(; !c && a;)a = a.parentNode, c = a === a;
            return c;
        };
        k.getBoundingClientRect = function() {
            return this.parent.getBoundingClientRect();
        };
        k.getEndNode = function() {
            return this.node;
        };
        k.getLineHeightInClientRectPx = function() {
            return this.parent.getLineHeightInClientRectPx();
        };
        k.getLineHeightInCssPx = function() {
            return this.parent.getLineHeightInCssPx();
        };
        k.getRemainingWhiteSpaceAfter = function(a) {
            var b = this.getPreviousBottomUp();
            return b ? b.getRemainingWhiteSpaceAfter(a) : this.root.getRemainingWhiteSpaceAfter(a);
        };
        k.getRemainingWhiteSpaceBefore = function(a) {
            var b = this.getPreviousBottomUp();
            return b ? b.getRemainingWhiteSpaceAfter(a) : this.root.getRemainingWhiteSpaceAfter(a);
        };
        k.getScopeForNode = function(a) {
            return this.containsNode(a, !0) ? this : null;
        };
        k.getStartNode = function() {
            return this.node;
        };
        k.isForked = function() {
            return !1;
        };
        k.isLeaf = function() {
            return !0;
        };
        k.isOverflowing = function(a) {
            return 0 > this.getRemainingWhiteSpaceAfter(a);
        };
        k.isParentScope = function() {
            return !1;
        };
        k.isRangeScope = function() {
            return !1;
        };
        function Zn(a, b, c) {
            Pn.call(this, a);
            this.rfElement = b;
            this.clientRect = null;
            this.element = b.element;
            this.g = !!c;
            this.config && (this.containerMeasurer = Tn(this.config, this).createContainerMeasurer(this));
        }
        q.inherits(Zn, Pn);
        k = Zn.prototype;
        k.containsNode = function(a, b) {
            var c = a === this.element;
            if (b) for(; !c && a;)a = a.parentNode, c = a === a;
            return c;
        };
        k.getBoundingClientRect = function() {
            null === this.clientRect && (this.clientRect = this.element.getBoundingClientRect());
            return this.clientRect;
        };
        k.getEndNode = function() {
            return this.element;
        };
        k.getLineHeightInClientRectPx = function() {
            return this.parent.getLineHeightInClientRectPx();
        };
        k.getLineHeightInCssPx = function() {
            return this.parent.getLineHeightInCssPx();
        };
        k.getOffsetBottomLimit = function(a, b) {
            return this.containerMeasurer.getOffsetBottomLimit(!0, b) + (a ? this.getTotalShrinkableAmount() : 0);
        };
        k.getRemainingWhiteSpaceAfter = function(a) {
            return (this.getClientRectBottomLimit(a, !1) - this.getBoundingClientRect().bottom) * this.parent.getClientRectScalingFactor();
        };
        k.getRemainingWhiteSpaceBefore = function(a) {
            return (this.getClientRectBottomLimit(a, !1) - this.getBoundingClientRect().top) * this.parent.getClientRectScalingFactor();
        };
        k.getScopeForNode = function(a) {
            return this.containsNode(a, !0) ? this : null;
        };
        k.getStartNode = function() {
            return this.element;
        };
        k.isForked = function() {
            return this.g;
        };
        k.isLeaf = function() {
            return !0;
        };
        k.isParentScope = function() {
            return !1;
        };
        k.isRangeScope = function() {
            return !1;
        };
        function $n(a, b, c) {
            this.config = a;
            this.data = b;
            this.o = c;
            this.h = null;
            this.j = !1;
            this.m = 0;
            this.rootScope = this.g = null;
        }
        function ao(a, b) {
            if (!a.config.options.blockifyFullWidthReplacedElements) return !1;
            var c = !1;
            b = b.element;
            var d = a.g.rfElement, e = d.getStyleAsNumber("paddingLeft") + d.getStyleAsNumber("paddingRight");
            2 >= Math.abs(a.g.element.scrollWidth - e - b.offsetWidth) ? c = !0 : b.parentNode === d.element && (d = function(f) {
                return lf(f) || H(f) && "none" !== N(f).display;
            }, c = ab(b, d), d = $a(b, d), e = function(f) {
                return J(f) || H(f) && N(f).display.includes("inline");
            }, c = !e(c) && !e(d));
            return c ? (b.style.setProperty("display", "block", "important"), (a = a.config.options.blockifiedReplacedElementAttrName) && b.setAttribute(a, ""), !0) : !1;
        }
        function bo(a) {
            if (a.h) {
                if (a.h.g) co(a, a.h), eo(a, a.h);
                else {
                    var b = a.h.parent, c = a.h, d = b.children.indexOf(c);
                    -1 !== d && (b.children.splice(d, 1), c.previous && (c.previous.next = c.next), c.next ? c.next.previous = c.previous : b.lastChild = c.previous, c.destroy());
                }
                a.h = null;
            }
        }
        function eo(a, b) {
            if (Ln(a.data) && b.isDisplayed()) {
                var c = 2 === a.data.g;
                a.config.options.debuggingEnabled && b instanceof Sn && (b.element.setAttribute("data-reflow-leaf", b.isLeaf() + ""), c ? b.element.setAttribute("data-reflow-remaining-whitespace-after-shrink", b.getRemainingWhiteSpaceAfter(!0) + "") : b.element.setAttribute("data-reflow-remaining-whitespace-after", b.getRemainingWhiteSpaceAfter(!1) + ""));
                if (c) b.isOverflowing(!0) ? a.data.o && b.isLeaf() ? (c = xn(b, !0), a.data.j.push.apply(a.data.j, c), fo(a, b)) : b.isRangeScope() || fo(a, b) : 0 < b.getTotalShrinkableAmount() && (a.data.o = !0);
                else if (b.isLeaf() && b.isOverflowing(!1)) {
                    for(c = b; c && 0 === a.data.h.length;){
                        var d = xn(c, !1);
                        a.data.h.push.apply(a.data.h, d);
                        c = c.getPreviousLeaf(!0);
                    }
                    fo(a, b);
                }
            }
        }
        function co(a, b) {
            3 === a.data.g && (a.j || 0 !== a.data.h.length || 0 !== a.data.m.length ? (a.m++, 1 <= a.m && (a.data.g = 4)) : Zm(b, !0) && (a.j = !0));
        }
        function fo(a, b) {
            1 === a.data.g ? 0 < a.config.shrinkDetectors.length ? (a.data.g = 2, eo(a, b)) : a.data.g = 3 : 2 === a.data.g && (a.data.g = 3);
        }
        function go(a, b) {
            this.config = a;
            this.data = new On;
            this.h = new Jn(a, this.data);
            this.g = new $n(a, this.data, b);
        }
        k = go.prototype;
        k.Jb = function(a) {
            var b = this.g;
            return b.g.isDisplayed() && b.config.isElementFragmentable(a, b.rootScope.isXml) && this.h.h !== a.element && null !== a.element;
        };
        k.sa = function(a) {
            Ln(this.data) && !this.g.h && Kn(this.h, a);
            if (4 !== this.data.g) {
                var b = this.g;
                if (null === b.rootScope) {
                    if (a.isInnerInline()) throw new Re("ROOT_IS_INLINE");
                    b.data.rootScope = b.g = b.rootScope = new Wn(b.config, a, b.o);
                } else if (!a.isInnerInline() || mf(a.element) && ao(b, a)) {
                    bo(b);
                    var c = a.getStyle("display");
                    "none" === c || "table-column" === c || "table-column-group" === c ? b.g = new Xn(b.g, a) : (c = a.getStyle("position"), c = "fixed" === c || "absolute" === c || "none" !== a.getStyle("cssFloat"), b.g = new Sn(b.g, a, c));
                } else b.h || (b.h = new Un(b.g, a.element));
            }
            return 4 === this.data.g;
        };
        k.ia = function(a, b) {
            var c = this.g;
            c.h && (a.isInnerInline() && a !== c.g.rfElement ? c.h.g = a.element : bo(c));
            a === c.g.rfElement && (c.g.fragmentable = b, c.g.zg(), c.data.A = c.g, c.g.isLeaf() && c.g.isDisplayed() && co(c, c.g), eo(c, c.g), c.g = c.g.parent);
            Ln(this.data) && !this.g.h && Mn(this.h, a);
            return 4 === this.data.g;
        };
        k.init = function(a) {
            if (!I(a)) throw new Re("ROOT_IS_NO_HTML_ELEMENT");
            var b = this.h;
            b.g = a;
            b.isXml = b.g.tagName === b.g.tagName.toLowerCase();
        };
        k.Cg = function(a) {
            var b = this.h;
            b.h === a ? (b.h = null, a = !0) : a = !1;
            return a;
        };
        k.Zb = function() {
            return !1;
        };
        k.Kb = function(a) {
            if (H(a)) {
                a = this.config.getRfElement(a);
                var b = this.g;
                bo(b);
                if ("none" !== a.getStyle("display") && a.element.getBoundingClientRect) {
                    var c = a.getStyle("position");
                    c = "fixed" === c || "absolute" === c || "none" !== a.getStyle("cssFloat");
                    c = new Zn(b.g, a, c);
                    co(b, c);
                    eo(b, c);
                } else new Xn(b.g, a);
                Ln(this.data) && (Kn(this.h, a), Mn(this.h, a));
            } else b = this.g, bo(b), new Yn(b.g, a);
            return 4 === this.data.g;
        };
        k.$b = function(a) {
            var b = this.g;
            ef(a) || (b.h || (b.h = new Un(b.g, a)), b.h.g = a, b.h.j = !0);
            return 4 === this.data.g;
        };
        function ho(a) {
            this.element = a;
            this.g = a.ownerDocument.defaultView.getComputedStyle(a);
        }
        ho.prototype.getStyle = function(a) {
            return this.g[a] || "";
        };
        ho.prototype.getStyleAsNumber = function(a) {
            a = parseFloat(this.getStyle(a));
            return isNaN(a) ? 0 : a;
        };
        ho.prototype.isBlockified = function() {
            var a = this.getStyle("position");
            return "fixed" === a || "absolute" === a || "none" !== this.g.cssFloat;
        };
        ho.prototype.isInnerInline = function() {
            var a = this.getStyle("display");
            return "inline" === a || "inline flow" === a ? !this.isBlockified() : !1;
        };
        function io(a) {
            ho.call(this, a);
            this.cache = new Map;
        }
        q.inherits(io, ho);
        io.prototype.getStyle = function(a) {
            var b = this.cache.get(a);
            b || (b = this.g[a] || "", this.cache.set(a, b));
            return b;
        };
        function jo(a) {
            a && "function" === typeof WeakMap ? this.cache = new WeakMap : this.cache = null;
        }
        jo.prototype.clear = function() {
            this.cache && (this.cache = new WeakMap);
        };
        jo.prototype.getRfElement = function(a) {
            if (this.cache) {
                var b = this.cache.get(a);
                b || (b = new io(a), this.cache.set(a, b));
            } else b = new ho(a);
            return b;
        };
        function ko() {
            this.g = new Map;
        }
        ko.prototype.getLineBoxBottomMarginInCssPx = function(a, b, c, d) {
            c = Math.round(c);
            d = Math.round(d);
            var e = b + ":" + c + ":" + d, f = this.g.get(e);
            if (!K(f)) {
                var g = a.createElement("x-colibrio-measurer");
                Q(g, "display", "block");
                Q(g, "position", "absolute");
                Q(g, "left", "0");
                Q(g, "top", "0");
                Q(g, "padding", "0");
                Q(g, "border-width", "0");
                Q(g, "width", "auto");
                Q(g, "height", "auto");
                Q(g, "font-family", b);
                Q(g, "font-size", c + "px");
                Q(g, "line-height", d + "px");
                c = a.createTextNode("BESbswy");
                g.appendChild(c);
                a.body.appendChild(g);
                f = g.getBoundingClientRect();
                b = a.createRange();
                b.selectNodeContents(c);
                c = b.getBoundingClientRect();
                f = g.offsetHeight / f.height * Math.max(0, f.bottom - c.bottom);
                this.g.set(e, f);
                b.detach();
                a.body.removeChild(g);
            }
            return f;
        };
        function lo(a, b) {
            this.containerMeasurerFactories = [];
            this.elementFragmenters = [];
            this.forcedBreakDetectors = [];
            this.fragmentableDetectors = [];
            this.fragmentationPenalizers = [];
            this.orphanElementPenalizers = [];
            this.orphanTextPenalizers = [];
            this.shrinkDetectors = [];
            this.shrinkPenalizers = [];
            this.textFragmenters = [];
            this.unforcedBreakDetectors = [];
            this.whitespacePenalizers = [];
            this.widowElementPenalizers = [];
            this.widowTextPenalizers = [];
            this.h = new ko;
            this.options = Na({
                blockifiedReplacedElementAttrName: "data-colibrio-blockified",
                blockifyFullWidthReplacedElements: !0,
                debuggingEnabled: !1,
                fragmentAttributeNameAfterBreak: "data-colibrio-fragmented-at-start",
                fragmentAttributeNameBeforeBreak: "data-colibrio-fragmented-at-end",
                minBreakPointSearchRatio: .15
            }, {
                debuggingEnabled: !1,
                forceCachedRfElement: !1,
                minBreakPointSearchRatio: 1
            });
            if (a) for(var c = 0; c < a.length; c++)a[c].install(this);
            if (b) for(a = 0; a < b.length; a++)b[a].install(this);
            this.g = new jo(this.options.forceCachedRfElement);
        }
        function Tn(a, b) {
            var c = a.containerMeasurerFactories.find(function(d) {
                return d.isContainerMeasurerFactoryFor(b);
            });
            c || (c = new Cm(!0)).install(a);
            return c;
        }
        function mo(a, b, c) {
            var d = a.elementFragmenters.find(function(e) {
                return e.isFragmenterForElement(b, c);
            });
            d || (d = new Qe).install(a);
            return d;
        }
        k = lo.prototype;
        k.getFragmentationPenalty = function(a, b, c) {
            for(var d = 0, e = 0; e < this.fragmentationPenalizers.length; e++)d += this.fragmentationPenalizers[e].getFragmentationPenalty(a, b, c);
            return d;
        };
        function yn(a, b, c, d) {
            return no(b, a.fragmentationPenalizers, function(e) {
                return e.getFragmentationPenalty(b, c, d);
            });
        }
        k.getOrphanElementPenalty = function(a, b, c, d) {
            for(var e = 0, f = 0; f < this.orphanElementPenalizers.length; f++)e += this.orphanElementPenalizers[f].getOrphanElementPenalty(a, b, c, d);
            return e;
        };
        function En(a, b, c, d, e) {
            return no(b, a.orphanElementPenalizers, function(f) {
                return f.getOrphanElementPenalty(b, c, d, e);
            });
        }
        function Bn(a, b, c, d) {
            return no(null, a.orphanTextPenalizers, function(e) {
                return e.getOrphanTextPenalty(b, c, d);
            });
        }
        k.getRfElement = function(a) {
            return this.g.getRfElement(a);
        };
        function Rn(a, b) {
            return a.shrinkDetectors.find(function(c) {
                return c.isShrinkDetectorFor(b);
            }) || null;
        }
        k.getShrinkPenalty = function(a, b) {
            for(var c = 0, d = 0; d < this.shrinkPenalizers.length; d++)c += this.shrinkPenalizers[d].getShrinkPenalty(a, b);
            return c;
        };
        function oo(a, b, c) {
            var d = a.textFragmenters.find(function(e) {
                return e.isFragmenterForText(b, c);
            });
            d || (d = new Qe).install(a);
            return d;
        }
        function Qn(a, b) {
            return a.unforcedBreakDetectors.find(function(c) {
                return c.isUnforcedBreakDetectorFor(b);
            }) || null;
        }
        k.getWhitespacePenalty = function(a) {
            for(var b = 0, c = 0; c < this.whitespacePenalizers.length; c++)b += this.whitespacePenalizers[c].getWhitespacePenalty(a);
            return b;
        };
        k.getWidowElementPenalty = function(a, b, c, d) {
            for(var e = 0, f = 0; f < this.widowElementPenalizers.length; f++)e += this.widowElementPenalizers[f].getWidowElementPenalty(a, b, c, d);
            return e;
        };
        function Fn(a, b, c, d, e) {
            return no(b, a.widowElementPenalizers, function(f) {
                return f.getWidowElementPenalty(b, c, d, e);
            });
        }
        function Cn(a, b, c, d) {
            return no(null, a.widowTextPenalizers, function(e) {
                return e.getWidowTextPenalty(b, c, d);
            });
        }
        k.isElementFragmentable = function(a, b) {
            var c = this.fragmentableDetectors.find(function(d) {
                return d.isFragmentableDetectorFor(a, b);
            });
            return c ? c.isElementFragmentable(a, b) : !1;
        };
        function no(a, b, c) {
            for(var d = [], e = 0, f, g = 0; g < b.length; g++){
                var h = b[g];
                f = c(h);
                0 !== f && (e += f, d.push({
                    penalty: f,
                    plugin: h.name
                }));
            }
            return 0 === d.length ? null : {
                attributes: a ? Ve(a) : null,
                entries: d,
                nodeName: a ? a.nodeName : "#text",
                penalty: e
            };
        }
        function po(a, b) {
            dn.call(this);
            this.g = a;
            this.A = b;
        }
        q.inherits(po, dn);
        po.prototype.m = function(a) {
            var b = this.A.getRfElement(a), c = !1, d = !0;
            this.h && (c = this.g.sa(b));
            !c && (d = this.g.Jb(b)) && (c = gn(this, a));
            !c && this.h && (c = this.g.ia(b, d));
            return c;
        };
        function qo(a, b) {
            var c = this;
            this.g = function(d, e) {
                return Se(d.container, d.offset, e, function(f, g) {
                    return oo(c.config, f, g);
                }, function(f, g) {
                    return mo(c.config, f, g);
                }, c.config.options.fragmentAttributeNameBeforeBreak, c.config.options.fragmentAttributeNameAfterBreak);
            };
            this.config = new lo(a, b);
        }
        function ro(a) {
            [
                "data-reflow-leaf",
                "data-reflow-remaining-whitespace-after",
                "data-reflow-remaining-whitespace-after-shrink"
            ].forEach(function(b) {
                a.querySelectorAll("[" + b + "]").forEach(function(c) {
                    c.removeAttribute(b);
                });
            });
        }
        function so(a, b) {
            if (b.isEmpty()) return null;
            b.mount();
            var c = b.getContentRootElement();
            if (!c) throw new Re("ROOT_ELEMENT_NOT_FOUND");
            a.config.options.debuggingEnabled && ro(c);
            var d = new go(a.config, b.getPageMeasurer());
            en(new po(d, a.config.g), c);
            var e = d.data;
            d = e.rootScope;
            var f = e.m.find(function(g) {
                var h = g.isValid();
                g = g.g;
                !h && g && g.parentNode.replaceChild(g.ownerDocument.createComment("ReflowEngine: Removed forced-break marker: " + g.nodeName), g);
                return h;
            });
            b = f ? to(a, f, c) : 1 === e.g && 0 === e.h.length || 2 === e.g && e.o ? uo(e, b) : 0 < e.h.length || 0 < e.j.length ? vo(a, e, b, c) : wo(a, e, b);
            d.destroy();
            a.config.g.clear();
            return b;
        }
        function to(a, b, c) {
            var d = wn(new tn(a.config), b), e = [
                sn(d)
            ], f = b.getScopeBeforeBreakPoint().processShrinkableElements(d.j / d.h);
            a = a.g(b, c);
            d = {
                Ue: e,
                containerPath: a.v,
                containerType: a.sb,
                yd: a.ye,
                zd: b.zd,
                ie: a.Sd,
                pageShrinkFactor: d.U,
                shrinkAmountRegisteredPx: d.h,
                shrinkAmountRequiredPx: d.j,
                pe: f,
                Fd: a.zc,
                type: "FORCED",
                whitespaceRatio: d.m
            };
            (b = b.g) && b.parentNode.replaceChild(b.ownerDocument.createComment("ReflowEngine - Used forced-break marker: " + b.nodeName), b);
            return d;
        }
        function wo(a, b, c) {
            var d = b.rootScope, e = d.getNextLeaf(!0);
            if (e) {
                var f;
                if (f = Xm(e.getEndNode(), !0, e)) {
                    b = wn(new tn(a.config), f);
                    c = [
                        sn(b)
                    ];
                    var g = Math.max(0, b.j - b.h) / d.getPageContentHeight(!0);
                    e = 0 < b.h ? e.processShrinkableElements(Math.min(b.j / b.h, 1)) : [];
                    a = a.g(f, d.element);
                    return {
                        Ue: c,
                        containerPath: a.v,
                        containerType: a.sb,
                        yd: a.ye,
                        zd: null,
                        ie: a.Sd,
                        pageShrinkFactor: g,
                        shrinkAmountRegisteredPx: b.h,
                        shrinkAmountRequiredPx: b.j,
                        pe: e,
                        Fd: a.zc,
                        type: "EMERGENCY",
                        whitespaceRatio: b.m
                    };
                }
            }
            return uo(b, c, "EMERGENCY");
        }
        function vo(a, b, c, d) {
            var e = Dn(new tn(a.config), b);
            if (0 === e.length) return wo(a, b, c);
            b = e[0];
            c = b.g;
            e = e.map(function(g) {
                return sn(g);
            });
            var f = [];
            c.shrinkingEnabled && (f = b.j / b.h, f = c.getScopeBeforeBreakPoint().processShrinkableElements(f));
            a = a.g(c, d);
            return {
                Ue: e,
                containerPath: a.v,
                containerType: a.sb,
                yd: a.ye,
                zd: null,
                ie: a.Sd,
                pageShrinkFactor: b.U,
                shrinkAmountRegisteredPx: b.h,
                shrinkAmountRequiredPx: b.j,
                pe: f,
                Fd: a.zc,
                type: "UNFORCED",
                whitespaceRatio: b.m
            };
        }
        function uo(a, b, c) {
            var d = b.getContentRootElement(), e = a.rootScope, f = e.getPreviousLeaf(!0);
            f || (f = e);
            var g = f.getRemainingWhiteSpaceAfter(!1), h = f, l = 2 === a.g || "EMERGENCY" === c;
            if (l) for(f = f.getPreviousBottomUp(); f;){
                if (f.isForked()) {
                    var m = f.getRemainingWhiteSpaceAfter(!1);
                    m < g && (g = m, h = f);
                }
                f = f.getPreviousBottomUp();
            }
            f = Math.max(0, -g);
            m = e.getTotalShrinkableAmount();
            var n = Math.max(0, f - m) / e.getPageContentHeight(!0);
            h = h.parent ? h.parent.getTotalNonUsableWhitespace() : 0;
            e = Math.max(0, g) / (e.getPageContentHeight(!0) - h);
            a = l && 0 < m ? a.rootScope.processShrinkableElements(Math.min(f / m, 1)) : [];
            l = d.ownerDocument.createDocumentFragment();
            l.appendChild(d.cloneNode(!0));
            b.onAllContentConsumed();
            return {
                Ue: null,
                containerPath: [],
                containerType: null,
                yd: [],
                zd: null,
                ie: l,
                pageShrinkFactor: n,
                shrinkAmountRegisteredPx: m,
                shrinkAmountRequiredPx: f,
                pe: a,
                Fd: null,
                type: c || "ALL_CONTENT",
                whitespaceRatio: e
            };
        }
        var xo = /^(?:img|video|picture)$/;
        function yo(a) {
            return H(a) && xo.test(a.localName);
        }
        function zo(a) {
            this.C = a;
            this.name = "MediaShrinkPlugin";
        }
        k = zo.prototype;
        k.getMaxShrinkAmountPx = function(a) {
            a = Ao(this, a);
            for(var b = 0, c = 0; c < a.length; c++)b += a[c].uh;
            return b;
        };
        k.getShrinkPenalty = function(a, b) {
            return this.C.penaltyAtMaxShrinkage * a / b;
        };
        k.install = function(a) {
            a.shrinkPenalizers.push(this);
            a.shrinkDetectors.push(this);
        };
        k.isShrinkDetectorFor = function(a) {
            for(var b = a, c = !1; !c && b !== b.root;)c = b.isForked(), b = b.parent;
            return !c && 0 < Ao(this, a).length;
        };
        k.postProcessShrink = function(a, b) {
            a = Ao(this, a);
            for(var c = 0; c < a.length; c++)a[c].u.setAttribute("data-colibrio-shrinking-element", "" + b);
        };
        function Bo(a, b, c, d) {
            var e = b.offsetHeight;
            return e <= c ? null : {
                u: b,
                uh: Math.max(e - d, (e - c) * a.C.maxShrinkFactor)
            };
        }
        function Ao(a, b) {
            var c = b.root.getPageContentHeight(!1) * a.C.activationThreshold, d = b.root.getPageContentHeight(!0) - b.getTotalNonUsableWhitespace(), e = [];
            if (xo.test(b.element.localName)) (a = Bo(a, b.element, c, d)) && e.push(a);
            else for(var f = 0; f < b.children.length; f++){
                var g = b.children[f];
                if (g.isRangeScope() && !g.hasText()) {
                    var h = g.getStartNode(), l = new R(h, yo), m = l;
                    g = g.getEndNode();
                    m.aa = g;
                    m = void 0;
                    g = 0;
                    yo(h) && (g++, (h = Bo(a, h, c, d)) && (m = h));
                    for(S(l, !0); l.g && 2 > g;)h = Bo(a, l.g, c, d), g++, h && (m = h), S(l, !0);
                    1 === g && m && e.push(m);
                }
            }
            return e;
        }
        function Co(a) {
            this.name = "IframePageMeasurer";
            if (!a.contentDocument) throw new Re("IFRAME_NOT_READY", "iframe.contentDocument empty");
            if (!a.contentWindow) throw new Re("IFRAME_NOT_READY", "iframe.contentWindow empty");
            this.ka = a.contentDocument;
            this.g = a.contentWindow;
        }
        k = Co.prototype;
        k.getPageHeight = function(a) {
            a = a.config.getRfElement(this.ka.documentElement);
            return this.g.innerHeight - a.getStyleAsNumber("borderBottomWidth") - a.getStyleAsNumber("borderTopWidth") - a.getStyleAsNumber("marginTop") - a.getStyleAsNumber("marginBottom");
        };
        k.getPageOffsetBottomLimit = function(a) {
            return this.getPageHeight(a);
        };
        k.getPagePaddingBottom = function(a) {
            return a.config.getRfElement(this.ka.documentElement).getStyleAsNumber("paddingBottom");
        };
        k.getPagePaddingTop = function(a) {
            return a.config.getRfElement(this.ka.documentElement).getStyleAsNumber("paddingTop");
        };
        k.isPageMeasurerFor = function() {
            return !0;
        };
        function Do(a) {
            this.g = a;
            this.h = !1;
            this.j = new Co(a);
        }
        k = Do.prototype;
        k.getContentRootElement = function() {
            return this.g.contentDocument ? this.g.contentDocument.body : null;
        };
        k.getPageMeasurer = function() {
            return this.j;
        };
        k.isEmpty = function() {
            return this.h || !this.g.contentDocument || !this.g.contentDocument.body || 0 === this.g.contentDocument.body.childNodes.length;
        };
        k.mount = function() {};
        k.onAllContentConsumed = function() {
            this.h = !0;
        };
        function Eo(a, b, c, d, e, f, g, h) {
            Uh.call(this, a, b, d);
            this.Hg = e;
            this.Ig = f;
            this.Oc = g;
            this.te = h;
            this.setSpreadSlot(c);
        }
        q.inherits(Eo, Uh);
        Eo.prototype.getPageFragmentationContext = function() {
            return this.te;
        };
        Eo.prototype.getPageIndexInSection = function() {
            return this.Hg;
        };
        Eo.prototype.getRangeContentLocation = function() {
            return this.Oc;
        };
        Eo.prototype.getStartContentLocation = function() {
            return this.Ig;
        };
        function Fo() {
            this.$d = 0;
        }
        Fo.prototype.sa = function(a, b) {
            "body" === b || "html" === b || lb(b) || (a.getBoundingClientRect().height > this.$d && (mf(a) || I(a) && Q(a, "height", "auto")), a.scrollHeight > a.clientHeight && (mf(a) || I(a) && Q(a, "height", "auto")));
        };
        Fo.prototype.init = function(a) {
            this.$d = a.defaultView.innerHeight;
        };
        function Go() {}
        Go.prototype.ia = function(a) {
            if (I(a) && "inline" === N(a).display) {
                for(var b = !1, c = !1, d = a.firstChild; d && !b;){
                    if (Ja(d)) c = b = !0;
                    else if (H(d)) {
                        var e = N(d).display;
                        e.includes("inline") && (b = !0);
                        "none" !== e && (c = !0);
                    }
                    d = d.nextSibling;
                }
                c && !b && Q(a, "display", "block");
            }
        };
        function Ho() {}
        Ho.prototype.ia = function(a, b) {
            "table" === b && Io(a);
        };
        function Io(a) {
            function b(m) {
                return H(m) && "td" !== m.localName && "th" !== m.localName;
            }
            var c = [], d = new R(a, function(m) {
                return H(m) && ("td" === m.localName || "th" === m.localName);
            });
            d.aa = a;
            S(d, b);
            for(var e = 0; d.g;){
                var f = d.g, g = f.ownerDocument.defaultView.getComputedStyle(f).width || "auto";
                try {
                    var h = parseInt(g);
                } catch (m) {
                    h = 0;
                }
                var l = h;
                l > e && (e = l);
                c.push({
                    u: f,
                    jh: l,
                    zh: g
                });
                S(d, b);
            }
            d = a.parentNode;
            f = a.nextSibling;
            d.removeChild(a);
            Q(a, "table-layout", "fixed");
            for(g = 0; g < c.length; g++)h = c[g], h.jh !== e ? Q(h.u, "width", h.zh) : Q(h.u, "width", "auto");
            d.insertBefore(a, f);
        }
        function Jo(a, b) {
            dl.call(this, a, b);
            this.Ib = 0;
            this.T = null;
            this.Pb = a.Ob;
        }
        q.inherits(Jo, dl);
        k = Jo.prototype;
        k.af = function() {
            return Promise.resolve();
        };
        k.Rc = function() {
            return null;
        };
        k.Bd = function() {
            return null;
        };
        k.Ad = function() {
            return this.T;
        };
        k.lf = function(a, b) {
            var c = this, d, e, f, g, h, l, m, n, p, u, v, w, x, A;
            return q.K(function(z) {
                switch(z.g){
                    case 1:
                        c.Ib++;
                        d = c.Ib;
                        c.T = b;
                        if (!(0 < c.Pb.length)) {
                            z.$(2);
                            break;
                        }
                        return r(z, c.Vc(a, d, b, [
                            new Dk(c.Pb)
                        ]), 2);
                    case 2:
                        return e = new lc(new hc(b)), f = new Ob, da(z, 4), g = [
                            new Lk,
                            new Go
                        ], Pb(f, g), r(z, f.transform(a.contentDocument, e), 6);
                    case 6:
                        if (null === c.Ha || !a.contentDocument || c.l.G.isCanceled()) return z.return(Promise.reject(new T(t.ColibrioErrorType.ABORTED)));
                        Ko(c, a.contentDocument);
                        f.Qa = [
                            new Ui
                        ].slice();
                        return r(z, f.transform(a.contentDocument, e), 7);
                    case 7:
                        if (null === c.Ha || !a.contentDocument || c.l.G.isCanceled()) return z.return(Promise.reject(new T(t.ColibrioErrorType.ABORTED)));
                        h = new Fo;
                        l = c.l.M.contentProcessingOptions;
                        m = c.l.G.getReaderViewOptions().publicationStyleOptions;
                        p = null != (n = m.fontSizeScaleFactor) ? n : 1;
                        u = t.BrowserDetector.isOS("iOS") && t.BrowserDetector.getOsVersion().startsWith("12.");
                        v = new Mi(l.horizontalOverflowMitigationMinFontSize, p, l.horizontalOverflowTableStrategy, l.horizontalOverflowMathMLStrategy, u);
                        w = c.jf(a.contentDocument);
                        var C = f, F = [
                            h,
                            new Vi
                        ].concat(q.Qc(m.removePublicationDefinedHorizontalPageMargins && !w ? [
                            new Gi
                        ] : []), [
                            v,
                            new Ho
                        ]);
                        C.Qa = F.slice();
                        return r(z, f.transform(a.contentDocument, e), 8);
                    case 8:
                        if (null === c.Ha || !a.contentDocument || c.l.G.isCanceled()) return z.return(Promise.reject(new T(t.ColibrioErrorType.ABORTED)));
                        C = a.contentDocument;
                        if (c.I.Tb) {
                            F = q.na(c.I.Tb.selectors);
                            for(var G = F.next(); !G.done; G = F.next())Lo(C, G.value, !1);
                            F = q.na(c.I.Tb.elementIndexes);
                            for(G = F.next(); !G.done; G = F.next())Lo(C, "[data-colibrio-inline-style-index=" + G.value + "]", !0);
                        }
                        z.g = 0;
                        z.m = 0;
                        break;
                    case 4:
                        x = fa(z);
                        if (t.ColibrioError.isColibrioAbortedError(x)) return z.return(Promise.reject(x));
                        t.Logger.logError(x);
                        A = c.l.ta.getContentUrl().pathname;
                        throw new T("READER_DOCUMENT_LOAD_ERROR", "path=" + A);
                }
            });
        };
        k.mf = function() {
            this.Ib++;
        };
        k.le = function() {};
        k.sf = function(a) {
            a.setAttribute("nwdisable", "true");
            a.setAttribute("scrolling", "no");
            a.style.display = "block";
            a.style.width = "100%";
            a.style.height = "100%";
            a.style.visibility = "hidden";
            a.style.border = "none";
            a.style.overflow = "hidden";
        };
        function Ko(a, b) {
            var c = a.I.Ta;
            if (c && 0 < c.length) {
                a = b.documentElement;
                for(var d = a.getBoundingClientRect(), e = 0, f = 0; f < c.length; f++){
                    var g = c[f];
                    try {
                        for(var h = b.querySelectorAll(g), l = 0; l < h.length; l++){
                            var m = h[l], n = m.getBoundingClientRect();
                            if (n.left < d.left) e = Math.max(d.left - n.left, e);
                            else {
                                var p = new R(m, function(v) {
                                    return 3 === v.nodeType;
                                });
                                S(p, !0);
                                if (p.g) {
                                    var u = b.createRange();
                                    u.selectNode(p.g);
                                    n = u.getBoundingClientRect();
                                    n.left < d.left && (e = Math.max(d.left - n.left, e));
                                }
                            }
                        }
                    } catch (v) {
                        t.Logger.logWarning(new T("INVALID_CSS_SELECTOR", g));
                    }
                }
                0 < e && (b = b.defaultView.getComputedStyle(a), b = b.paddingLeft ? parseInt(b.paddingLeft) : 0, isNaN(b) && (b = 0), a.style.paddingLeft = b + e + "px");
            }
        }
        k.hf = function(a) {
            if (this.I.Ta && 0 < this.I.Ta.length) try {
                return null !== a.querySelector(this.I.Ta.join(", "));
            } catch (b) {
                return !0;
            }
            else return !1;
        };
        k.jf = function(a) {
            return this.I.vb || this.hf(a);
        };
        k.Vc = function(a, b, c, d) {
            var e = this, f, g;
            return q.K(function(h) {
                if (1 == h.g) {
                    f = a.contentDocument;
                    if (!f) throw new T(t.ColibrioErrorType.ABORTED);
                    g = new Ob;
                    Pb(g, d);
                    return r(h, g.transform(f, new lc(new hc(c))), 2);
                }
                if (e.Ib !== b || e.l.G.isCanceled()) throw new T(t.ColibrioErrorType.ABORTED);
                h.g = 0;
            });
        };
        function Lo(a, b, c) {
            try {
                if (c) {
                    var d = a.querySelector(b);
                    var e = d ? [
                        d
                    ] : [];
                } else e = a.querySelectorAll(b);
                e.forEach(function(f) {
                    var g = N(f), h = g.getPropertyValue("overflow-x"), l = g.getPropertyValue("overflow-y");
                    Q(f, "overflow-x", "visible");
                    c ? g.overflowY !== l ? f.setAttribute("data-colibrio-inline-overflow-x-changed", h) : f.style.setProperty("overflow-x", h) : g.overflowY !== l ? f.setAttribute("data-colibrio-overflow-x-changed", "") : f.style.removeProperty("overflow-x");
                });
            } catch (f) {
                f instanceof DOMException && "SyntaxError" === f.name ? t.Logger.logWarning(new T("INVALID_CSS_SELECTOR", "Invalid selector found in CSS:' " + b + ", Error: " + f.message)) : t.Logger.logError(f);
            }
        }
        function Mo(a, b, c, d) {
            this.h = a;
            this.g = b;
            this.Ke = c;
            this.Db = d;
        }
        k = Mo.prototype;
        k.getDocumentHeight = function() {
            return this.g;
        };
        k.getDocumentWidth = function() {
            return this.h;
        };
        k.getEndOffset = function() {
            return this.Db;
        };
        k.getPageFlowDirection = function() {
            return D.PageFlowDirection.TB;
        };
        k.getStartOffset = function() {
            return this.Ke;
        };
        function No(a) {
            if (H(a)) {
                var b = a.getBoundingClientRect();
                if (0 < b.height && 0 < b.width) return !1;
                if ("none" === N(a).display) return !0;
                for(b = 0; b < a.childNodes.length; b++)if (!No(a.childNodes[b])) return !1;
                return !0;
            }
            return a && 8 === a.nodeType || ef(a) ? !0 : !1;
        }
        function Oo(a) {
            this.u = a;
        }
        Oo.prototype.eb = function() {
            var a = this.u.getAttribute("data-colibrio-shrinking-element");
            if (a && (a = Number(a)) && !isNaN(a)) {
                var b = N(this.u);
                b.height && (Li(this.u, parseFloat(b.height), a), Q(this.u, "width", "auto"));
            }
        };
        function Po(a) {
            this.vh = 0 < a;
            this.wh = 1 === a;
        }
        Po.prototype.va = function(a) {
            return new Oo(a);
        };
        Po.prototype.wa = function(a) {
            return a.hasAttribute("data-colibrio-shrinking-element");
        };
        Po.prototype.xa = function() {
            return this.wh;
        };
        function Qo(a, b, c) {
            this.u = a;
            this.j = b;
            this.h = c;
            this.g = [];
        }
        function Ro(a) {
            Q(a, "box-sizing", "border-box");
            Q(a, "height", "100vh");
            Q(a, "overflow-y", "auto");
        }
        function So(a) {
            return a.u.scrollHeight - a.u.ownerDocument.defaultView.innerHeight;
        }
        function To(a) {
            this.g = a;
        }
        function jl(a, b, c, d, e) {
            a = new Po(a.g);
            if (a.vh) {
                var f = new Db;
                Eb(f, a);
                Fb(f, b);
                f.eb();
                f.destroy();
            }
            a = new Wi(b.ownerDocument.body);
            S(a, !0);
            f = !1;
            for(var g = a.g; !f && g;){
                var h = null === g.firstChild;
                0 >= S(a, !0) && H(g) && (f = !0);
                !h || g && 8 === g.nodeType || (J(g) && Ia(g.data) ? g.data = g.data.replaceAll(/\s/g, " ") : f = !0);
                g = a.g;
            }
            c = new lc(new hc(c));
            a = b;
            f = 0;
            for(H(a) && (f = parseFloat(N(a).borderBottomWidth)); a;)I(a) && "br" === a.localName ? (g = a.parentNode, c.remove(a), a = g ? g.lastChild : null) : No(a) ? a = a.previousSibling : 0 < f ? a = null : a = a.lastChild;
            for(a = b; a;){
                (I(a) || nb(a)) && Q(a, "margin-bottom", "0");
                a: {
                    if (H(a) && (f = N(a), g = parseFloat(f.paddingBottom), 0 < parseFloat(f.borderBottomWidth) || 0 < g)) {
                        f = !0;
                        break a;
                    }
                    f = !1;
                }
                if (f) break;
                for(a = a.lastChild; a && No(a);)a = a.previousSibling;
            }
            b = new Qo(b, d, e);
            e = c.Ra;
            if (3 < So(b)) {
                d = [];
                c = b.u.ownerDocument.body;
                a = b.u.ownerDocument.documentElement;
                Q(c, "margin-top", "0");
                Q(c, "margin-bottom", "0");
                Q(c, "padding-top", "0");
                Q(c, "padding-bottom", "0");
                Q(a, "margin-top", "0");
                Q(a, "margin-bottom", "0");
                Q(a, "padding-top", "0");
                Q(a, "padding-bottom", "0");
                d.push({
                    name: "marginPadding"
                });
                a = 1;
                c = So(b);
                if (3 < So(b)) {
                    a = b.u.querySelectorAll("img, video");
                    f = So(b);
                    for(h = g = 0; h < a.length; h++)g += a[h].offsetHeight;
                    if (0 < g) {
                        f = Math.min(.01 + f / g, .75);
                        for(g = 0; g < a.length; g++){
                            h = a[g];
                            var l = N(h);
                            l = parseFloat(l.height);
                            if (!isNaN(l)) {
                                var m = h.style.getPropertyValue("height"), n = h.style.getPropertyPriority("height"), p = h.style.getPropertyValue("width"), u = h.style.getPropertyPriority("width");
                                b.g.push({
                                    element: h,
                                    Qh: m,
                                    Rh: n,
                                    Sh: p,
                                    Th: u
                                });
                                Q(h, "height", l * (1 - f) + "px");
                                Q(h, "width", "auto");
                            }
                        }
                        a = 1 - f;
                    } else a = 1;
                }
                if (3 < So(b)) {
                    if (So(b) >= c || "SCROLL" === b.j) {
                        c = q.na(b.g);
                        for(a = c.next(); !a.done; a = c.next())a = a.value, a.element.style.setProperty("height", a.Qh, a.Rh), a.element.style.setProperty("width", a.Sh, a.Th);
                        b.g = [];
                    } else d.push({
                        name: "mediaShrink",
                        scaleFactor: a
                    });
                    switch(b.j){
                        case "SCALE":
                            e = b.u.ownerDocument.defaultView;
                            e = e.innerHeight / (So(b) + e.innerHeight);
                            Q(b.u, "transform", "scale(" + e + ")");
                            Q(b.u, "transform-origin", "50% 0");
                            d.push({
                                name: "scale",
                                scaleFactor: e
                            });
                            break;
                        case "SCROLL":
                            b: {
                                a = new R(b.u.ownerDocument.body, H);
                                for(c = null; a.g;){
                                    if (I(a.g) && ib(a.g)) {
                                        if (null === c) c = a.g;
                                        else {
                                            c = null;
                                            break b;
                                        }
                                    }
                                    S(a, !0);
                                }
                                null !== c && (a = parseInt(N(c).height), f = a - So(b), g = b.u.ownerDocument.defaultView.innerHeight, !isNaN(a) && a > So(b) && f >= .5 * g || (c = null));
                            }
                            null !== c ? (a = c.style.getPropertyValue("height"), f = c.style.getPropertyPriority("height"), g = c.style.getPropertyValue("overflow-y"), h = c.style.getPropertyPriority("overflow-y"), l = parseInt(N(c).height) - So(b), Q(c, "height", l.toString() + "px"), Q(c, "overflow-y", "auto"), 3 < So(b) ? (c.style.setProperty("height", a, f), c.style.setProperty("overflow-y", g, h), c = !1) : c = !0) : c = !1;
                            if (!c) {
                                c = b.u.ownerDocument.body;
                                a: {
                                    a = c.childNodes;
                                    for(f = 0; f < a.length; f++)if (g = a[f], Ja(g) || H(g)) {
                                        a = g;
                                        break a;
                                    }
                                    a = null;
                                }
                                if (a && I(a) && "block" === N(a).display && !Ji(a, a.tagName) && !mf(a) && Ki(a)) Ro(a);
                                else {
                                    a = new lc(e);
                                    e = b.u.ownerDocument.createElement("x-colibrio-scroll-container");
                                    e.style.display = "block";
                                    e.style.width = "auto";
                                    for(e.style.position = "relative"; c.firstChild;)e.appendChild(c.firstChild);
                                    c.appendChild(e);
                                    a = a.Ra;
                                    (c = ac(c)) && a.g.push({
                                        v: c,
                                        sb: 1,
                                        i: 0,
                                        J: 9
                                    });
                                    Ro(e);
                                }
                                t.Logger.logInfo(new T("CONTENT_DOCUMENT_VERTICAL_OVERFLOW_MITIGATED", 'Document set to scroll in "' + b.h + '"'));
                            }
                            d.push({
                                name: "scroll"
                            });
                    }
                } else d.push({
                    name: "mediaShrink",
                    scaleFactor: a
                });
                if (0 !== d.length) {
                    b = 'In "' + b.h + '". ';
                    d = q.na(d);
                    for(e = d.next(); !e.done; e = d.next())switch(e = e.value, e.name){
                        case "scroll":
                            b += "Document set to scroll. ";
                            break;
                        case "scale":
                            b += 'Document scale factor set to "' + e.scaleFactor + '". ';
                            break;
                        case "marginPadding":
                            b += "Document top and bottom margins/padding removed. ";
                            break;
                        case "mediaShrink":
                            b += 'Media elements scale factor set to "' + e.scaleFactor + '". ';
                    }
                    t.Logger.logInfo(new T("CONTENT_DOCUMENT_VERTICAL_OVERFLOW_MITIGATED", b));
                }
            } else d = N(b.u), d = parseFloat(d.marginBottom) + parseFloat(d.marginTop), Q(b.u, "box-sizing", "border-box"), Q(b.u, "height", "calc(100% - " + d + "px)");
        }
        function Uo(a) {
            return H(a) ? "none" === N(a).display : a && 8 === a.nodeType || ef(a) ? !0 : !1;
        }
        function Vo(a, b, c, d, e, f, g, h, l) {
            this.ua = a;
            this.ja = b;
            this.U = c;
            this.I = d;
            this.l = f;
            this.Ba = g;
            this.Za = h;
            this.Sa = l;
            this.Z = 0;
            this.L = !1;
            this.o = this.j = 0;
            this.g = null;
            this.h = [];
            this.g = new Do(c.B);
            this.m = new hc(e);
            a = this.g.getContentRootElement();
            if (!a) throw new T("READER_DOCUMENT_LOAD_ERROR", "Content root element not found. path=" + f.F.getSourceContentDocument().getContentUrl().pathname);
            this.H = this.A = a.scrollHeight;
            this.Ma = a.scrollWidth;
        }
        function Wo(a, b, c, d, e, f) {
            var g, h, l, m, n;
            return q.K(function(p) {
                if (1 == p.g) return r(p, Oh(c, b), 2);
                g = p.h;
                h = new Jo(g, b);
                l = new Uh(h, b.N, d);
                m = b.G.getReaderView().getElement().ownerDocument;
                n = m.createElement("div");
                n.style.opacity = "0";
                n.style.visibility = "hidden";
                n.style.position = "absolute";
                n.style.left = "-100000px";
                n.style.top = "0px";
                n.setAttribute("aria-hidden", "true");
                m.body.appendChild(n);
                return p.return(new Promise(function(u, v) {
                    function w(x) {
                        if (x.isRenderingCompleted()) {
                            l.removeStateChangeListener(w);
                            x = l.g.Ad();
                            if (!l.A || !x) throw new U("getCurrentDomMutationRecordsAfterRenderingCompleted() can only be called when page rendering has completed");
                            u(new Vo(a, n, l, g, x.slice(), b, d, e, f));
                        } else x.getState() === D.RenderableState.DESTROYED && (l.removeStateChangeListener(w), v(new T(t.ColibrioErrorType.ABORTED)));
                    }
                    l.addStateChangeListener(w);
                    l.renderTo(n);
                }));
            });
        }
        function Xo(a, b) {
            for(var c = {
                v: [],
                i: 0
            }; 0 < b;)c.v.push(0), b--;
            return ad(c, a.g);
        }
        k = Vo.prototype;
        k.destroy = function() {
            if (!this.L) {
                qb(this.ja);
                this.U.destroy();
                this.g = null;
                this.L = !0;
                for(var a = 0; a < this.h.length; a++){
                    var b = this.h[a];
                    b && b.destroy();
                }
                this.h = [];
            }
        };
        k.getEstimatedNumberOfPages = function() {
            var a = this.U.B;
            return a && a.contentDocument ? (a = this.l.G.getUnconstrainedPageDimensions(this.l.ta.getPageSpreadSlot()), this.A / a.height) : 1;
        };
        k.hasNext = function() {
            return !this.L && (this.j < this.h.length || null !== this.g && !this.g.isEmpty());
        };
        k.next = function() {
            if (!this.hasNext()) return null;
            this.j === this.h.length && Yo(this);
            return this.h[this.j++];
        };
        k.skipNext = function() {
            if (!this.hasNext()) return !1;
            if (this.j !== this.h.length) return this.j++, !0;
            if (!this.g || this.g.isEmpty()) return Zo(this), !1;
            $o(this, this.U.B.contentDocument);
            var a = so(this.ua, this.g);
            ap(this, a);
            bp(this, a);
            Zo(this);
            this.o++;
            this.h[this.j++] = null;
            return !0;
        };
        function cp(a) {
            var b = a.A - a.H, c;
            a.g && (c = a.g.getContentRootElement()) ? a.H = c.scrollHeight : a.H = 0;
            return new Mo(a.Ma, a.A, b, a.A - a.H);
        }
        function dp(a, b) {
            a.querySelectorAll("[data-colibrio-fragmented-at-start]").forEach(function(c) {
                c.style.setProperty("border-top", "none", "important");
                c.style.setProperty("border-top-right-radius", "0", "important");
                c.style.setProperty("border-top-left-radius", "0", "important");
                c.style.setProperty("height", "auto", "important");
                b.removeTopMarginsOnFragmentedElements && (c.style.setProperty("margin-top", "0", "important"), c.style.setProperty("padding-top", "0", "important"));
            });
        }
        function $o(a, b) {
            dp(b, a.l.M.reflowOptions);
            if (b.body && (0 < a.o || 0 < a.Ba) && a.l.M.reflowOptions.removeTopMarginsOnFragmentedElements) for(a = b.body; a && H(a);){
                b = N(a);
                var c = parseFloat(b.borderTopWidth), d = parseFloat(b.paddingTop);
                0 !== parseFloat(b.marginTop) && (I(a) || nb(a)) && Q(a, "margin-top", "0");
                if (0 < c || 0 < d) break;
                for(a = a.firstChild; a && Uo(a);)a = a.nextSibling;
            }
        }
        function Yo(a) {
            if (!a.L && a.g && !a.g.isEmpty()) {
                var b = a.U.B.contentDocument;
                $o(a, b);
                var c = so(a.ua, a.g), d = a.m, e = a.l.F, f = a.l.da, g = e.getSourceContentDocument(), h = f.createRange(), l = M(f);
                var m = 0 === a.o ? a.Za : Xo(d, a.Z);
                f = dc(m, l);
                h.setStart(f.s, f.i);
                f = fd(a.l.N, g, f.s, m.i);
                f = new X(f, [
                    e
                ], e.getReaderPublication(), {
                    Ca: !1,
                    O: null,
                    Ka: !0,
                    P: m
                });
                ap(a, c);
                var n = "ALL_CONTENT" === c.type ? a.Sa : Xo(a.m, a.Z);
                l = dc(n, l);
                h.setEnd(l.s, l.i);
                g = dd(a.l.N, g, h);
                g = new X(g, [
                    e
                ], e.getReaderPublication(), {
                    Ca: !1,
                    O: n,
                    Ka: !0,
                    P: m
                });
                h = b.documentElement.cloneNode(!1);
                h.appendChild(b.querySelector("head").cloneNode(!0));
                h.appendChild(c.ie);
                bp(a, c);
                m = h.querySelectorAll("iframe");
                m = 0 < m.length && Array.from(m).some(function(u) {
                    return "true" === u.getAttribute("colibrio-iframe-sandbox-required");
                });
                b = nc(b, h);
                m ? (d = Ph(b, d.g, a.I, a.l), d = new Kl(d, a.l)) : (c = new To(c.pe.length), d = Kh(b, d.g, a.I), d = new fl(d, a.l, c));
                var p;
                0 === a.o ? p = e.getSourceContentDocument().getPageSpreadSlot() : p = sa.PageSpreadSlot.AUTO;
                e = new Eo(d, a.l.N, p, a.Ba, a.o++, f, g, cp(a));
                a.h.push(e);
            }
            Zo(a);
        }
        function Zo(a) {
            a.g && a.g.isEmpty() && a.ja.parentNode && (qb(a.ja), a.g = null);
        }
        function bp(a, b) {
            if (0 < b.yd.length) {
                var c = new lc(a.m);
                b.yd.forEach(function(d) {
                    return d(c);
                });
            }
        }
        function ap(a, b) {
            null !== b.containerType && null !== b.Fd && (a.m = ic(a.m, 1 === b.containerType ? 1 : 3, b.containerPath, b.Fd), a.Z = b.containerPath.length);
        }
        function ep(a) {
            this.g = fp(a);
        }
        function fp(a) {
            var b = a.plugins;
            a = [
                new bn,
                new an,
                new Cm(a.removeBottomMarginsOnFragmentedElements)
            ];
            b.customForcedPageBreak && a.push(new wm(b.customForcedPageBreak));
            a.push(new on(b.verticalWhitespacePenalizer));
            a.push(new mn(b.unforcedTextBreak));
            b.orphanTextPattern && a.push(new Mm(b.orphanTextPattern));
            a.push(new Hm(b.listBreak));
            a.push(new Om);
            a.push(new zo(b.mediaShrink));
            b.cssForcedPageBreak && a.push(new im);
            b.floatingOrphanPenalizer && a.push(new Dm(b.floatingOrphanPenalizer));
            a.push(new rm(b.customElementPenalizer));
            a.push(new km(b.customCssValuePenalizer));
            b = [
                new Fm,
                new Nm,
                new Em(b.fragmentableElements)
            ];
            return new qo(a, b);
        }
        function Pl(a, b, c, d, e, f) {
            return q.K(function(g) {
                return g.return(Wo(a.g, b, c, d, e, f));
            });
        }
        function gp(a) {
            this.fb = a;
            this.L = !1;
        }
        gp.prototype.gf = function(a) {
            if (this.L) throw new T(t.ColibrioErrorType.ABORTED);
            switch(a.type){
                case 13:
                    return hp(this, a);
                case 15:
                    return ip(this, a);
                case 11:
                    var b = B.URLUtils.normalizePathnameEncoding(new URL(a.href, a.baseUrl));
                    a = {
                        ki: this.fb.acceptsUrl(b),
                        channelId: a.channelId,
                        ti: this.fb.isUrlSupportedByBrowser(b),
                        type: 12,
                        url: b.toString()
                    };
                    return Promise.resolve(a);
            }
            return Promise.reject("ResourceProvider message not implemented: " + a.type);
        };
        function hp(a, b) {
            var c = new URL(b.url);
            return a.fb.fetch(c, {
                accept: b.accept
            }).then(function(d) {
                return d.asText().then(function(e) {
                    return {
                        channelId: b.channelId,
                        data: e,
                        metadata: d.getMetadata(),
                        type: 14
                    };
                });
            });
        }
        function ip(a, b) {
            var c = new URL(b.url);
            return a.fb.fetch(c, {
                accept: b.accept
            }).then(function(d) {
                return d.asUint8Array().then(function(e) {
                    return {
                        channelId: b.channelId,
                        data: e,
                        metadata: d.getMetadata(),
                        type: 16
                    };
                });
            });
        }
        function jp() {
            this.La = 0;
            this.h = kp(null, null, null);
            this.g = kp(null, this.h, null);
            this.h.ha = this.g;
        }
        k = jp.prototype;
        k.clear = function() {
            this.h = kp(null, null, null);
            this.g = kp(null, this.h, null);
            this.h.ha = this.g;
            this.La = 0;
        };
        k.every = function(a) {
            for(var b = this.h.ha, c = !0; b !== this.g && c;){
                var d = b.ha;
                c = a(b);
                b = null === b.ha ? d : b.ha;
            }
            return c;
        };
        k.find = function(a) {
            for(var b = this.h.ha, c = null; b !== this.g && null === c;){
                var d = b.ha;
                a(b) && (c = b);
                b = null === b.ha ? d : b.ha;
            }
            return c;
        };
        k.forEach = function(a) {
            for(var b = this.h.ha; b !== this.g;){
                var c = b.ha;
                a(b);
                b = null === b.ha ? c : b.ha;
            }
        };
        k.pop = function() {
            if (0 === this.La) var a = null;
            else a = this.g.Ua, lp(this, a);
            return a ? a.la : null;
        };
        k.push = function(a) {
            a = kp(a, this.g.Ua, this.g);
            a.Ua.ha = a;
            this.g.Ua = a;
            this.La++;
            return a;
        };
        k.remove = function(a) {
            for(var b = this.h, c = !1; !c && b !== this.g;)b = b.ha, c = b.la === a;
            c && b !== this.g && lp(this, b);
        };
        k.shift = function() {
            if (0 === this.La) var a = null;
            else a = this.h.ha, lp(this, a);
            return a ? a.la : null;
        };
        k.size = function() {
            return this.La;
        };
        k.unshift = function(a) {
            a = kp(a, this.h, this.h.ha);
            a.ha.Ua = a;
            this.h.ha = a;
            this.La++;
            return a;
        };
        function kp(a, b, c) {
            return {
                la: a,
                ha: c,
                Ua: b
            };
        }
        function lp(a, b) {
            if (b.Ua && b.ha) {
                var c = b.Ua, d = b.ha;
                c.ha = d;
                d.Ua = c;
                b.ha = null;
                b.Ua = null;
                a.La--;
            }
        }
        function mp() {
            this.C = {
                fh: Number.MAX_SAFE_INTEGER,
                Pf: 1E6,
                Rf: 6,
                Ee: 1E4
            };
            this.g = new jp;
            this.h = new Map;
            this.j = 0;
        }
        k = mp.prototype;
        k.clear = function() {
            this.h.clear();
            this.g = new jp;
            this.j = 0;
        };
        function np(a, b) {
            var c = a.h.get(b);
            c && (a.h.delete(b), lp(a.g, c), a.j -= c.la.La);
        }
        k.find = function(a) {
            var b = this.g;
            b = b.La ? b.g.Ua : null;
            for(var c; b && void 0 === c;)a(b.la.ca, b.la.sc) ? c = b.la.ca : b = (b = b.Ua) && this.g.h !== b ? b : null;
            b && op(this, b, !1);
            return c;
        };
        k.get = function(a) {
            return (a = this.h.get(a)) ? (op(this, a, !1), a.la.ca) : null;
        };
        function pp(a, b) {
            if (b = a.h.get(b)) b.la.Ab++, op(a, b, !0);
            return b ? b.la.ca : null;
        }
        k.has = function(a) {
            return this.h.has(a);
        };
        function qp(a, b) {
            b = a.h.get(b);
            var c = 0;
            b && (c = --b.la.Ab, 0 >= b.la.Ab && rp(a));
            return c;
        }
        k.set = function(a, b, c) {
            c > this.C.fh || !this.C.Rf && c > this.C.Pf || sp(this, a, b, c, !1);
        };
        function tp(a, b, c, d) {
            var e = a.h.get(b);
            e ? (e.la.Ab++, e.la.ca = c, a.j += d - e.la.La, e.la.La = d, op(a, e, !0)) : sp(a, b, c, d, !0);
        }
        function sp(a, b, c, d, e) {
            var f = a.C.Ee;
            c = {
                sc: b,
                Ab: e ? 1 : 0,
                La: d,
                bg: f ? Date.now() + f : 0,
                ca: c
            };
            np(a, b);
            c = a.g.push(c);
            a.h.set(b, c);
            a.j += d;
            rp(a);
        }
        function rp(a) {
            var b = a.C.Pf, c = a.C.Rf, d = a.C.Ee;
            if (d && a.j > b && a.g.size() > c) {
                d = d ? Date.now() : 0;
                var e = a.g;
                for(e = e.La ? e.h.ha : null; a.j > b && a.g.size() > c && e && e.la.bg <= d;){
                    var f = (f = e.ha) && a.g.g !== f ? f : null;
                    0 >= e.la.Ab && np(a, e.la.sc);
                    e = f;
                }
            }
        }
        function op(a, b, c) {
            var d = a.C.Ee, e = a.g;
            b.Ua && b.ha && (lp(e, b), b.Ua = e.g.Ua, b.ha = e.g, b.Ua.ha = b, e.g.Ua = b, e.La++);
            d && (b.la.bg = Date.now() + d);
            (d || c) && rp(a);
        }
        function up(a) {
            this.la = a;
            this.g = 0;
            this.i = 1;
        }
        function vp(a, b, c) {
            for(var d = Array(b), e = 0; e < b; e++){
                var f = a.la[a.i++], g = a.la[a.i++], h = a.g++, l = f >>> 24 & 255, m = f >>> 16 & 255, n = wp(a, f >>> 8 & 255, c);
                f = 2 === l ? wp(a, f & 255, c) : [];
                g = g ? vp(a, g, 0 === l ? n : c) : [];
                d[e] = {
                    $a: l,
                    pc: m,
                    fa: g,
                    ba: h,
                    Fb: f,
                    Gb: n
                };
            }
            return d;
        }
        function wp(a, b, c) {
            c = c.slice();
            for(var d = 0; d < b; d++)c.push(a.la[a.i++]);
            return c;
        }
        function xp(a, b) {
            this.m = b;
            this.o = !1;
            this.H = [];
            this.A = null;
            this.j = [];
            this.h = 127;
            this.g = null;
            this.U = a.documentElement;
            yp(this, this.U, []);
            zp(this);
            Ap(this, this.H, 0);
        }
        function Bp(a, b) {
            0 === a.j.length ? a.H.push(b) : a.j[a.j.length - 1].fa.push(b);
        }
        function Ap(a, b, c) {
            for(var d = 0; d < b.length; d++){
                var e = b[d];
                e.ba = c++;
                e.fa && (c = Ap(a, e.fa, c));
            }
            return c;
        }
        function zp(a) {
            a.g && a.o && null !== a.A && Bp(a, {
                $a: 2,
                pc: a.h,
                fa: [],
                ba: -1,
                Fb: a.A,
                Gb: a.g
            });
            a.h = 127;
            a.g = null;
            a.A = null;
            a.o = !1;
        }
        function Cp(a, b, c, d) {
            255 > b.length && (b.push(c), yp(a, d, b), b.pop());
        }
        function yp(a, b, c) {
            b = b.childNodes;
            for(var d = 0; d < b.length; d++){
                var e = b[d];
                if (J(e) && e.data) a.o || (a.o = Ga(e.data)), a.g || (e = a, e.g = c.concat(d), e.h = 127), a.A = c.concat(d);
                else if (H(e)) {
                    var f = e.localName;
                    if (Fc.has(f)) {
                        zp(a);
                        var g = a, h = c, l = d;
                        f = Gc.get(f);
                        g.g = h.concat(l);
                        g.h = f;
                        Cp(a, c, d, e);
                        zp(a);
                    } else if (Ic.has(f)) zp(a), e = a, g = c, h = d, f = Jc.get(f), Bp(e, {
                        $a: 1,
                        pc: f,
                        fa: [],
                        ba: -1,
                        Fb: [],
                        Gb: g.concat(h)
                    });
                    else if (lb(f)) zp(a);
                    else {
                        g = a.m.attributeNamesThatCreateContentBlocks;
                        if (null === g) {
                            a: {
                                g = e.attributes;
                                for(h = 0; h < g.length; h++)if (sc(g[h].name)) {
                                    g = !0;
                                    break a;
                                }
                                g = !1;
                            }
                            g = g || 127 === a.h && e.hasAttribute("id");
                        } else g = rc(e, g);
                        wc.has(f) || a.m.includeMathMlContentBlocks && Ac.has(f) || a.m.includePreContentBlocks && yc.has(f) || g ? (zp(a), f = Dc.get(f), a.j.push({
                            $a: 0,
                            pc: K(f) ? f : 127,
                            fa: [],
                            ba: -1,
                            Fb: [],
                            Gb: c.concat(d)
                        }), Cp(a, c, d, e), zp(a), f = a, g = f.m.attributeNamesThatCreateContentBlocks, e = null === g ? e.hasAttribute("id") : rc(e, g), g = f.j.pop(), (0 < g.fa.length || e) && Bp(f, g)) : uc.has(e.localName) ? (a.g || (f = a, f.g = c.concat(d), f.h = 127), Cp(a, c, d, e)) : (zp(a), Cp(a, c, d, e), zp(a));
                    }
                }
            }
        }
        function Dp(a, b) {
            for(var c = 2 * a.length, d = 0; d < a.length; d++){
                var e = a[d];
                c += e.Gb.length - b + e.fa.length;
                0 < e.Fb.length && (c += e.Fb.length - b);
                0 < e.fa.length && (c += Dp(e.fa, 0 === e.$a ? e.Gb.length : b));
            }
            return c;
        }
        function Ep(a, b, c, d) {
            for(var e = 0; e < c.length; e++){
                var f = c[e];
                a[b++] = f.$a << 24 | f.pc << 16 | f.Gb.length - d << 8 | (2 === f.$a ? f.Fb.length - d : 0);
                a[b++] = f.fa.length;
                b = Fp(a, b, f.Gb, d);
                2 === f.$a && (b = Fp(a, b, f.Fb, d));
                0 < f.fa.length && (b = Ep(a, b, f.fa, 0 === f.$a ? f.Gb.length : d));
            }
            return b;
        }
        function Fp(a, b, c, d) {
            for(; d < c.length; d++)a[b++] = c[d];
            return b;
        }
        function Gp(a, b, c, d) {
            this.g = a;
            this.A = b;
            this.Z = c;
            this.h = d;
            this.$c = null;
            this.m = "";
            this.lc = this.H = this.j = this.o = this.aa = this.fa = null;
            this.U = "";
        }
        function Hp(a, b) {
            var c = a.h.ga.createRange();
            c.setStartBefore(a.getStartNode());
            c.setEndAfter(a.getEndNode());
            var d = Xa(c, b.s, b.i), e = 0;
            1 === d ? e = a.getTextContent().length : 0 === d && (c.setEnd(b.s, b.i), e = c.toString().length);
            c.detach();
            return e;
        }
        k = Gp.prototype;
        k.contains = function(a) {
            if (a instanceof Gp && a.g.ba > this.g.ba) {
                for(a = a.getParent(); a && a.g.ba > this.g.ba;)a = a.getParent();
                return null !== a && a.g.ba === this.g.ba;
            }
            return !1;
        };
        k.equals = function(a) {
            return a instanceof Gp && a.g.ba === this.g.ba;
        };
        k.getAttributes = function() {
            if (!this.$c) {
                var a = this.getStartNode();
                this.$c = H(a) ? Ip(this, a) : [];
            }
            return this.$c;
        };
        k.getBlockClass = function() {
            switch(this.g.$a){
                case 0:
                    return D.ContentBlockClass.CONTAINER;
                case 1:
                    return D.ContentBlockClass.MEDIA;
                default:
                case 2:
                    return D.ContentBlockClass.TEXT;
            }
        };
        k.getBlockType = function() {
            if (!this.m) switch(this.g.$a){
                case 0:
                    var a = this.g.pc;
                    this.m = a < Bc.length ? Bc[a][1] : D.ContainerContentBlockType.GENERIC;
                    break;
                case 1:
                    this.m = Hc[this.g.pc][1];
                    break;
                default:
                case 2:
                    a = this.g.pc, this.m = a < Ec.length ? Ec[a][1] : D.TextContentBlockType.TEXT;
            }
            return this.m;
        };
        k.getChildren = function() {
            var a = this;
            this.fa || (this.fa = this.g.fa.map(function(b, c) {
                return Jp(a.h, b, a.g.ba, c);
            }));
            return this.fa;
        };
        k.getCommonAncestorContainer = function(a, b) {
            if (null === this.getEndNode()) return this.getStartNode();
            a = this.getRange(a, b);
            return J(a.commonAncestorContainer) ? a.commonAncestorContainer.parentElement : a.commonAncestorContainer;
        };
        k.getContentBlockTree = function() {
            return this.h;
        };
        k.getContentLocation = function(a, b) {
            a = this.getRange(a, b);
            b = dd(this.h.N, this.h.getReaderDocument().getSourceContentDocument(), a);
            var c = {
                v: ac(a.startContainer),
                i: a.startOffset
            }, d = a.collapsed ? null : {
                v: ac(a.endContainer),
                i: a.endOffset
            }, e = this.h.getReaderDocument();
            b = new X(b, [
                e
            ], e.getReaderPublication(), {
                Ca: !1,
                O: d,
                Ka: !0,
                P: c
            });
            a.detach();
            return b;
        };
        k.getId = function() {
            return this.g.ba;
        };
        k.getLanguage = function() {
            if (!this.o) {
                var a = this.getStartNode(), b;
                this.o = null != (b = fb(a)) ? b : null;
                this.o || (a = this.getContentBlockTree().getReaderDocument().getReaderPublication().getSourcePublication().getMetadata().getLanguages(), this.o = 0 < a.length ? a[0].content.value : null);
            }
            return this.o;
        };
        k.getLocator = function(a, b) {
            a = this.getRange(a, b);
            b = dd(this.h.N, this.h.getReaderDocument().getSourceContentDocument(), a);
            a.detach();
            return b;
        };
        k.getMarks = function() {
            if (!this.j && (this.j = [], 2 === this.g.$a)) {
                var a = this.getStartNode(), b = new R(a);
                Bb(b, this.getEndNode());
                for(var c = a = 0, d = []; b.g;){
                    var e = b.g;
                    if (H(e)) {
                        a: {
                            switch(e.localName){
                                case "a":
                                    var f = D.ContentBlockMarkType.ANCHOR;
                                    break a;
                                case "i":
                                case "em":
                                    f = D.ContentBlockMarkType.EMPHASIS;
                                    break a;
                                case "b":
                                case "strong":
                                    f = D.ContentBlockMarkType.STRONG;
                                    break a;
                            }
                            f = void 0;
                        }
                        f && d.push({
                            $c: Ip(this, e),
                            Vg: c,
                            Ke: a,
                            J: f
                        });
                    } else J(e) && (a += e.data.length);
                    for(c += S(b, !0); 0 < d.length && c <= Da(d).Vg;)e = Kp(d.pop(), a), this.j.push(e);
                }
                for(; 0 < d.length;)b = Kp(d.pop(), a), this.j.push(b);
                this.j.reverse().sort(function(g, h) {
                    return g.startOffset - h.startOffset;
                });
            }
            return this.j;
        };
        k.getNextSibling = function() {
            return Lp(this, this.Z + 1);
        };
        k.getParent = function() {
            return -1 === this.A ? null : this.h.getContentBlockById(this.A);
        };
        k.getPreviousSibling = function() {
            return Lp(this, this.Z - 1);
        };
        k.getResourceHrefs = function() {
            if (!this.H && 1 === this.g.$a) {
                this.H = [];
                var a = this.getStartNode(), b = a.getAttribute("src");
                if (b) this.H.push(b);
                else if ("audio" === a.localName || "video" === a.localName) for(a = new R(a, function(c) {
                    return H(c) && "source" === c.localName;
                }), S(a, !0); a.g;)(b = a.g.getAttribute("src")) && this.H.push(b), S(a, !0);
            }
            return this.H;
        };
        function Lp(a, b) {
            var c = a.getParent();
            c ? (c = c.g.fa, c = 0 <= b && b < c.length ? c[b] : null) : (c = a.h, c = 0 <= b && b < c.h.length ? c.h[b] : null);
            return c && Jp(a.h, c, a.A, b);
        }
        k.getStartNode = function() {
            if (!this.lc && (this.lc = gb(this.g.Gb, this.h.ga.documentElement), !this.lc)) throw new T("INVALID_NODE_PATH", "contentBlockHeader.pathStart id: " + this.g.ba + ", doc: " + this.h.getReaderDocument().getSourceContentDocument().getContentUrl().pathname);
            return this.lc;
        };
        k.getTextContent = function() {
            if (!this.U && 2 === this.g.$a) {
                var a = this.getStartNode(), b = new R(a, J), c = this.getEndNode();
                b.aa = c;
                for(J(a) || S(b, !0); b.g;)this.U += b.g.data, S(b, !0);
            }
            return this.U;
        };
        k.isAfter = function(a) {
            return a instanceof Gp && this.g.ba > a.g.ba && !this.contains(a);
        };
        k.isBefore = function(a) {
            return a instanceof Gp && this.g.ba < a.g.ba;
        };
        k.isLeaf = function() {
            return 0 === this.g.fa.length;
        };
        k.toSerializableData = function(a) {
            return {
                attributes: this.getAttributes(),
                blockClass: this.getBlockClass(),
                blockType: this.getBlockType(),
                children: a && !1 === a.recursive ? [] : this.getChildren().map(function(b) {
                    return b.toSerializableData(a);
                }),
                id: this.g.ba,
                locator: a && a.createLocators ? this.getLocator() : null,
                marks: this.getMarks(),
                parentId: -1 === this.A ? null : this.A,
                resourceHrefs: this.getResourceHrefs(),
                textContent: this.getTextContent()
            };
        };
        function Kp(a, b) {
            return {
                attributes: a.$c,
                endOffset: b,
                startOffset: a.Ke,
                type: a.J
            };
        }
        k.getEndNode = function() {
            if (!this.aa && 0 < this.g.Fb.length && (this.aa = gb(this.g.Fb, this.h.ga.documentElement), !this.aa)) throw new T("INVALID_NODE_PATH", "contentBlockHeader.endPath id: " + this.g.ba + ", doc: " + this.h.getReaderDocument().getSourceContentDocument().getContentUrl().pathname);
            return this.aa;
        };
        function Ip(a, b) {
            var c = [];
            b = b.attributes;
            var d = a.h.Gg;
            a = d.disableDefaultAttributeFiltering;
            d = d.attributeNamesThatCreateContentBlocks;
            for(var e = 0; e < b.length; e++){
                var f = b[e], g = void 0, h;
                (h = a) || (h = f.name, h = sc(h) || Kc.has(h));
                (h || (null == (g = d) ? 0 : g.includes(f.name))) && c.push({
                    localName: f.localName,
                    namespaceURI: f.namespaceURI,
                    prefix: f.prefix,
                    value: f.value
                });
            }
            return c;
        }
        k.getRange = function(a, b) {
            var c = this.h.ga, d = this.getStartNode(), e = this.getEndNode();
            if (e) {
                if (2 === this.g.$a && K(a)) {
                    var f = K(b) ? b : -1;
                    b = null;
                    c = -1;
                    var g = null, h = -1, l = a + f, m = 0, n = new R(d, J);
                    n.aa = e;
                    J(d) || S(n, !0);
                    for(-1 === f && (h = 0); n.g && (-1 === c || -1 === h);)d = n.g, f = m + d.data.length, -1 === c && f > a && (b = d, c = a - m), -1 === h && f >= l && (g = d, h = l - m), m = f, S(n, !0);
                    a = this.h.ga.createRange();
                    b ? g ? (a.setStart(b, c), a.setEnd(g, h)) : (a.setStart(b, c), a.setEndAfter(e)) : (a.setStartAfter(e), a.setEndAfter(e));
                } else a = c.createRange(), a.setStartBefore(d), a.setEndAfter(e);
            } else a = c.createRange(), a.selectNode(d);
            return a;
        };
        function Wc(a, b, c) {
            this.h = a;
            this.j = b;
            this.m = c;
            this.g = 0;
        }
        k = Wc.prototype;
        k.getAnchorPoint = function() {
            return this.j;
        };
        k.getCharLength = function() {
            return this.m;
        };
        k.getCharOffset = function() {
            return this.g;
        };
        k.getContentBlock = function() {
            return this.h;
        };
        k.toJSON = function() {
            return {
                anchorPoint: this.j,
                charLength: this.m,
                charOffset: this.g,
                contentBlockId: this.h.getId(),
                readerDocumentIndexInSpine: this.h.getContentBlockTree().getReaderDocument().getIndexInSpine()
            };
        };
        function Mp(a, b, c, d, e) {
            this.F = a;
            this.ga = b;
            this.h = c;
            this.N = d;
            this.Gg = e;
            this.g = new Map;
            this.m = this.j = null;
        }
        function Np(a, b, c, d, e) {
            return d ? 0 : b ? a.getTextContent().length : e ? Hp(a, c) : a.getTextContent().length - Hp(a, c);
        }
        function Vc(a) {
            return a ? (a.j = D.ContentBlockTargetAnchorPoint.INTERSECTS_CONTENT_LOCATION, a) : null;
        }
        function Jp(a, b, c, d) {
            if (a.g.has(b.ba)) return a.g.get(b.ba);
            c = new Gp(b, c, d, a);
            a.g.set(b.ba, c);
            return c;
        }
        k = Mp.prototype;
        k.destroy = function() {
            this.g.clear();
        };
        k.getContentBlockById = function(a) {
            var b = null;
            this.g.has(a) ? b = this.g.get(a) : 0 < this.h.length && (b = Op(this, a));
            return b;
        };
        k.getContentBlocks = function() {
            var a = this;
            this.m || (this.m = this.h.map(function(b, c) {
                return Jp(a, b, -1, c);
            }));
            return this.m;
        };
        k.getReaderDocument = function() {
            return this.F;
        };
        k.toSerializableData = function(a) {
            return this.getContentBlocks().map(function(b) {
                return b.toSerializableData(a);
            });
        };
        function Op(a, b) {
            function c(m, n) {
                return b - m[n].ba;
            }
            for(var d = null, e = a.h, f = e[0], g = !1, h = -1, l = -1; 0 < e.length && !g;){
                l = ya(e, 1, e.length, c);
                if (-1 === l) return null;
                f = e[l];
                g = f.ba === b;
                g || (a.g.has(f.ba) || a.g.set(f.ba, new Gp(f, h, l, a)), e = f.fa, h = f.ba);
            }
            g && (d = new Gp(f, h, l, a), a.g.set(f.ba, d));
            return d;
        }
        function Tc(a, b, c, d, e, f) {
            f = void 0 === f ? !1 : f;
            var g = Ya(a.ga.documentElement, b);
            H(b) && g.push(c);
            return Pp(a, g, {
                s: b,
                i: c
            }, d, e, f);
        }
        function Pp(a, b, c, d, e, f) {
            function g(u, v, w) {
                v = u[v];
                u = 0;
                w = w ? v.Fb : v.Gb;
                for(v = Math.min(w.length, b.length); u < v && w[u] === b[u];)u++;
                return u === w.length ? b.length - u : u === b.length ? -1 : b[u] - w[u];
            }
            f = void 0 === f ? !1 : f;
            if (0 === a.h.length) return null;
            var h = Qp(a), l = null, m = ya(h, 1, h.length, g);
            if (-1 === m) d === D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_AFTER && (c = a.getContentBlockById(h[0].ba), e = e ? 0 : c.getTextContent().length, l = new Wc(c, D.ContentBlockTargetAnchorPoint.AFTER_CONTENT_LOCATION, e));
            else {
                var n = h[m], p = 2 === n.$a;
                0 === g(h, m) ? (a = a.getContentBlockById(n.ba), e = Np(a, !p, c, e, f), l = new Wc(a, D.ContentBlockTargetAnchorPoint.INTERSECTS_CONTENT_LOCATION, e), p && (l.g = f ? 0 : Hp(l.h, c))) : 0 >= g(h, m, !0) ? (a = a.getContentBlockById(n.ba), e = Np(a, !p, c, e, f), l = new Wc(a, D.ContentBlockTargetAnchorPoint.INTERSECTS_CONTENT_LOCATION, e), p && (l.g = f ? 0 : Hp(l.h, c))) : d === D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_AFTER ? (c = m + 1, c < h.length && (c = a.getContentBlockById(h[c].ba), e = e ? 0 : c.getTextContent().length, l = new Wc(c, D.ContentBlockTargetAnchorPoint.AFTER_CONTENT_LOCATION, e))) : d === D.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_BEFORE && (a = a.getContentBlockById(n.ba), e = Np(a, !p, c, e, f), l = new Wc(a, D.ContentBlockTargetAnchorPoint.BEFORE_CONTENT_LOCATION, e), p && (l.g = f ? 0 : Hp(l.h, c)));
            }
            return l;
        }
        function Uc(a, b, c, d, e, f) {
            f = void 0 === f ? !1 : f;
            if (d = Tc(a, b, c, d, !1, f)) return d;
            a = Tc(a, b, c, e, !1, f);
            return Vc(a);
        }
        function Qp(a) {
            if (!a.j) {
                a.j = [];
                for(var b = new t.TreeNodeWalker(a.h, function(c) {
                    return c.fa;
                }); b.hasNext();)a.j.push(b.next());
            }
            return a.j;
        }
        function Rp(a) {
            this.W = a;
            this.j = new Map;
            this.L = !1;
            this.g = new mp;
            this.m = new Map;
            this.o = new Map;
            this.h = new mp;
            this.A = new Map;
            this.H = new Map;
        }
        Rp.prototype.destroy = function() {
            this.j.clear();
            this.g.clear();
            this.m.clear();
            this.o.clear();
            this.h.clear();
            this.A.clear();
            this.H.clear();
            this.L = !0;
        };
        function Be(a, b) {
            return cm(a, b, !1);
        }
        Rp.prototype.getContentBlockTree = function(a, b, c, d) {
            var e = a.getSourceContentDocument();
            if (this.j.has(e)) var f = this.j.get(e);
            else {
                var g;
                f = null == (g = this.H.get(e)) ? void 0 : g.deref();
                if (!f) {
                    if (this.o.has(e)) f = new up(this.o.get(e)), f = vp(f, f.la[0], []);
                    else {
                        g = f = new xp(b, d.contentBlockOptions).H;
                        var h = new Int32Array(Dp(g, 0) + 1);
                        h[0] = g.length;
                        Ep(h, 1, g, 0);
                        this.o.set(e, h);
                    }
                    f = new Mp(a, b, f, c, d.contentBlockOptions);
                    sb() && this.H.set(e, new WeakRef(f));
                }
                a = (e.getMediaType() === y.MediaType.IMAGE_SVG ? this.h : this.g).h.get(e);
                0 < (a ? a.la.Ab : 0) && this.j.set(e, f);
            }
            return f;
        };
        function Tl(a, b) {
            0 === qp(a.g, b) && a.j.delete(b);
        }
        function Sl(a, b) {
            0 === qp(a.h, b) && a.j.delete(b);
        }
        function cm(a, b, c) {
            if (a.L) return Promise.reject(new T(t.ColibrioErrorType.ABORTED));
            var d = b.getContentUrl(), e = c ? pp(a.g, b) : a.g.get(b);
            if (e) return e;
            if (e = a.m.get(b)) {
                var f = e.yh.deref();
                if (f) return f = Promise.resolve({
                    Ga: f,
                    ed: e.ed,
                    Bb: e.Bb
                }), c ? tp(a.g, b, f, e.La) : a.g.set(b, f, e.La), f;
                a.m.delete(b);
            }
            e = a.W.getResourceProvider();
            var g = b.getMediaType();
            e = e.fetch(d, {
                accept: g ? [
                    g
                ] : void 0
            }).then(function(h) {
                return h.asText();
            }).then(function(h) {
                var l = new va.XhtmlParser(h, d.pathname, g === y.MediaType.TEXT_HTML || g === y.MediaType.APPLICATION_HTML), m = l.getDocument();
                if (!m) throw h = l.getParserError(), new T("CONTENT_DOCUMENT_PARSING_FAILED", h ? h.documentElement.textContent || "" : "");
                l = {
                    Ga: m,
                    ed: l.isXhtmlDocument(),
                    Bb: l.getXmlHeader()
                };
                a.g.has(b) && (np(a.g, b), c ? tp(a.g, b, Promise.resolve(l), h.length) : a.g.set(b, Promise.resolve(l), h.length));
                sb() && a.m.set(b, {
                    ed: l.ed,
                    La: h.length,
                    yh: new WeakRef(m),
                    Bb: l.Bb
                });
                return l;
            }).catch(function(h) {
                np(a.g, b);
                return Promise.reject(h);
            });
            c ? tp(a.g, b, e, 0) : a.g.set(b, e, 0);
            return e;
        }
        function Yl(a, b, c) {
            if (a.L) return Promise.reject(new T(t.ColibrioErrorType.ABORTED));
            var d = b.getContentUrl(), e = c ? pp(a.h, b) : a.h.get(b);
            if (e) return e;
            if (e = a.A.get(b)) {
                var f = e.ai.deref();
                if (f) return d = Promise.resolve(f), c ? tp(a.h, b, d, e.size) : a.h.set(b, d, e.size), d;
                a.A.delete(b);
            }
            e = a.W.getResourceProvider();
            f = b.getMediaType();
            var g = e.fetch(d, {
                accept: f ? [
                    f
                ] : void 0
            }).then(function(h) {
                return h.asText().then(function(l) {
                    var m = new va.DomParser, n = h.getMetadata(), p;
                    m = m.parseXmlString(l, null != (p = n.pathRelativeToBaseUrl) ? p : n.url);
                    a.h.has(b) && (np(a.h, b), c ? tp(a.h, b, g, l.length) : a.h.set(b, g, l.length));
                    sb() && a.A.set(b, {
                        size: l.length,
                        ai: new WeakRef(m)
                    });
                    return m;
                });
            }).catch(function(h) {
                np(a.h, b);
                return Promise.reject(h);
            });
            c ? tp(a.h, b, g, 0) : a.h.set(b, g, 0);
            return g;
        }
        function Sp(a) {
            this.g = a;
        }
        function Tp(a, b) {
            this.g = a;
            this.h = b;
        }
        Tp.prototype.getLength = function() {
            return Gk(this.g, this.h + 12);
        };
        function Up(a, b) {
            this.la = a;
            this.g = !0;
            this.h = !1;
            this.o = [];
            this.j = new Fk(a);
            this.m = new Sp(this.j);
            a = Gk(this.m.g, 0);
            if (this.g = this.h = 65536 === a || 1330926671 === a) {
                a = 12;
                var c = this.m.g;
                c = (c.g[4] << 8) + c.g[5];
                if (256 < c) this.g = !1, t.Logger.logError(new T("INVALID_OPENTYPE_FONT", "Got too many OTF tables: " + c + ", file: " + b));
                else for(var d = 0; d < c && this.g; d++){
                    var e = new Tp(this.j, a);
                    Gk(e.g, e.h + 8) + e.getLength() > this.la.byteLength ? (this.g = !1, t.Logger.logError(new T("INVALID_OPENTYPE_FONT", "Invalid table record offset, file: " + b))) : this.o.push(e);
                    a += 16;
                }
            }
        }
        function Vp(a) {
            this.g = a;
        }
        k = Vp.prototype;
        k.acceptsUrl = function(a) {
            return this.g.acceptsUrl(a);
        };
        k.fetch = function(a, b) {
            return this.g.fetch(a, b).then(function(c) {
                switch(c.getMetadata().mediaType){
                    case y.MediaType.FONT_OTF:
                    case y.MediaType.FONT_TTF:
                    case y.MediaType.APPLICATION_VND_MS_OPENTYPE:
                        return Wp(c);
                }
                return c;
            });
        };
        k.fetchMetadata = function(a, b) {
            return this.g.fetchMetadata(a, b);
        };
        k.getBaseUrl = function() {
            var a = this.g.getBaseUrl();
            return null !== a ? B.URLUtils.cloneUrl(a) : null;
        };
        k.getResourceManifest = function() {
            return this.g.getResourceManifest();
        };
        k.isUrlSupportedByBrowser = function(a, b) {
            return this.g.isUrlSupportedByBrowser(a, b);
        };
        function Wp(a) {
            var b = !1, c = a.getMetadata(), d = new ReadableStream({
                cancel: function() {
                    b = !0;
                    a.abort();
                },
                start: function(e) {
                    var f, g, h;
                    return q.K(function(l) {
                        if (1 == l.g) return r(l, a.asUint8Array(), 2);
                        f = l.h;
                        if (b) return l.return();
                        g = c.pathRelativeToBaseUrl || c.url;
                        h = new Up(f, g);
                        if (h.h && !h.g) throw new T("INVALID_OPENTYPE_FONT", "Skipping font: " + g);
                        e.enqueue(f);
                        e.close();
                        l.g = 0;
                    });
                }
            });
            return new y.ReadableStreamResourceResponse(c, d, function() {
                return a.abort();
            });
        }
        function Xp(a) {
            var b = this;
            this.lb = new Rp(this);
            this.fb = new Vp(a.getEpubResourceProvider());
            this.ad = new oa.ResourceCacheHost(a.getEpubResourceProvider());
            this.rh = Ih().then(function(c) {
                c = Pf(c);
                c.qc.g.set(c.jb, new gp(b.fb));
                return c.jb;
            });
        }
        Xp.prototype.destroy = function() {
            this.lb.destroy();
            this.ad.destroy();
        };
        Xp.prototype.getResourceProvider = function() {
            return this.fb;
        };
        function Yp(a, b, c, d, e) {
            this.g = a;
            this.oa = b;
            this.V = c;
            this.h = d;
            this.N = e;
            this.j = new Map;
            this.ra = c.getSpine();
        }
        function Zp(a, b) {
            var c = b.getSegmentIndex();
            if (c < a.oa.length) var d = a.oa[c];
            else c = a.oa.length - 1, d = a.oa[c], b = new E.SyncMediaTimelinePosition(a.g, c, d.getApproximateDurationMs());
            var e = d.g[0], f = a.ra[d.getReaderDocumentIndexInSpine()];
            return f.Ea().then(function(g) {
                var h = wk(e, g), l = d.getApproximateDurationMs(), m = Math.min(b.getOffsetWithinSegmentMs(), l);
                var n = f.getSourceContentDocument();
                0 < m && 0 < l && h ? (g = $p(a, h, m, l)) ? (n = fd(a.N, n, g.s, g.i), h = {
                    v: ac(g.s),
                    i: g.i
                }) : (n = ed(a.N, n, h), h = bc(h)) : (h || (h = M(g)), n = ed(a.N, n, h), h = bc(h));
                return new X(n, [
                    f
                ], f.getReaderPublication(), {
                    Ca: !1,
                    O: null,
                    Ka: !0,
                    P: h
                });
            });
        }
        function aq(a, b) {
            return gd(b, a.V).then(function(c) {
                return bq(a, c);
            });
        }
        function cq(a, b) {
            return gd(b, a.V).then(function(c) {
                var d = c.collapseToStart(), e = c.collapseToEnd();
                return c.isRange() ? Promise.all([
                    bq(a, d),
                    bq(a, e)
                ]).then(function(f) {
                    return {
                        end: f[1],
                        start: f[0]
                    };
                }) : bq(a, d).then(function(f) {
                    return {
                        end: f,
                        start: f
                    };
                });
            });
        }
        function dq(a, b) {
            if (J(b)) return b.data.length;
            b = b.childNodes;
            for(var c = 0, d = 0; d < b.length; d++)c += dq(a, b[d]);
            return c;
        }
        function bq(a, b) {
            var c = b.getReaderDocuments()[0];
            if (!(b instanceof X) || c.getReaderPublication() !== a.V) return Promise.reject(new T("INCOMPATIBLE_LOCATION", "fetchTimelinePositionFromLocator: The location does not target this publication"));
            for(var d = c.getIndexInSpine(), e = a.h.length, f = a.h.length - 1; 0 <= f; f--){
                var g = a.h[f];
                if (g < a.oa.length) {
                    if (g = a.oa[g].getReaderDocumentIndexInSpine(), d > g) break;
                    else if (e = f, d === g) break;
                }
            }
            if (e >= a.h.length) return Promise.resolve(new E.SyncMediaTimelinePosition(a.g, a.oa.length, 0));
            var h = a.h[e];
            return h >= a.oa.length ? Promise.resolve(new E.SyncMediaTimelinePosition(a.g, a.oa.length, 0)) : a.oa[h].getReaderDocumentIndexInSpine() > d ? Promise.resolve(new E.SyncMediaTimelinePosition(a.g, h, 0)) : c.Ea().then(function(l) {
                var m = $c(b, c, l), n = e < a.h.length - 1 ? a.h[e + 1] : a.oa.length;
                if (c.isReflowable()) {
                    m = m.P;
                    var p = m.v.slice(), u = m.i;
                    if (0 === p.length && 0 === u) l = new E.SyncMediaTimelinePosition(a.g, h, 0);
                    else {
                        p.push(u);
                        u = -1;
                        for(var v = h; v < n && -1 === u; v++){
                            var w = a.j.get(v);
                            w || (w = (w = wk(a.oa[v].g[0], l)) ? ac(w) || [] : [], a.j.set(v, w));
                            for(var x = 0; x < w.length && x < p.length && w[x] === p[x];)x++;
                            x < w.length && x < p.length ? p[x] < w[x] && (u = v) : u = v;
                        }
                        -1 === u && (u = n);
                        p = 0;
                        u < n && (n = a.oa[u], p = eq(n.g[0], m, l, n));
                        l = new E.SyncMediaTimelinePosition(a.g, u, p);
                    }
                } else a: if (m = m.P, u = m.v.slice(), p = m.i, 0 === u.length && 0 === p) l = new E.SyncMediaTimelinePosition(a.g, h, 0);
                else {
                    u.push(p);
                    v = -1;
                    w = [];
                    x = -1;
                    var A = [];
                    for(p = h; p < n; p++){
                        var z = a.j.get(p), C = a.oa[p];
                        z || (z = (z = wk(C.g[0], l)) ? ac(z) || [] : [], a.j.set(p, z));
                        var F = Wa(u, z);
                        if (0 > F) -1 === x ? (x = p, A = z) : 0 < Wa(A, z) && (x = p, A = z);
                        else if (0 < F) -1 === v ? (v = p, w = z) : 0 > Wa(w, z) && (v = p, w = z);
                        else {
                            l = eq(C.g[0], m, l, C);
                            l = new E.SyncMediaTimelinePosition(a.g, p, l);
                            break a;
                        }
                    }
                    fq(w, u) || (v = -1, w = []);
                    u = -1 === v && -1 === x ? n : -1 === v && -1 !== x ? x : -1 !== v && -1 === x ? v : fq(w, A) ? x : v;
                    p = 0;
                    u < n && (n = a.oa[u], p = eq(n.g[0], m, l, n));
                    l = new E.SyncMediaTimelinePosition(a.g, u, p);
                }
                return l;
            });
        }
        function eq(a, b, c, d) {
            function e(u) {
                var v = u === g;
                v && (l || (p = !1), J(u) && (m += b.i));
                J(u) && (n += u.data.length, p && (m += u.data.length));
                u = u.childNodes;
                for(var w = 0; w < u.length; w++)e(u[w]);
                v && l && (p = !1);
            }
            for(var f = b.v, g = M(c), h = 0; h < f.length; h++)if (g = g.childNodes[f[h]], !g) return 0;
            var l = !1;
            H(g) && (b.i < g.childNodes.length ? g = g.childNodes[b.i] : l = !0);
            var m = 0, n = 0, p = !0;
            (a = wk(a, c)) && (c = bc(a)) && 0 <= $b(b, c) && e(a);
            return 0 !== n ? d.getApproximateDurationMs() * (m / n) : l ? d.getApproximateDurationMs() : 0;
        }
        function $p(a, b, c, d) {
            function e(h) {
                if (J(h)) {
                    if (g + h.data.length >= f) return {
                        s: h,
                        i: f - g
                    };
                    g += h.data.length;
                } else for(h = h.firstChild; h;){
                    var l = e(h);
                    if (l) return l;
                    h = h.nextSibling;
                }
                return null;
            }
            var f = Math.round(c / d * dq(a, b)), g = 0;
            return e(b);
        }
        function fq(a, b) {
            return a.length < b.length && a.every(function(c, d) {
                return b[d] === c;
            });
        }
        function gq(a, b) {
            this.m = b;
            this.L = !1;
            this.h = new Map;
            this.g = new Map;
            this.j = new Map;
            this.oa = a.getSegments();
            this.ra = a.getReaderPublication().getSpine();
        }
        gq.prototype.destroy = function() {
            this.h.clear();
        };
        function hq(a, b, c) {
            return (c = iq(a, b, c)) ? Promise.resolve(c) : a.g.get(b) || Promise.reject(new T("INVALID_SYNC_MEDIA_SEGMENT_INDEX", "EpubSyncMediaOverlaySegmentCache - Bad segmentIndex: " + b));
        }
        function iq(a, b, c) {
            var d = q.na(E.SyncMediaObjectRendererRuntimeHelper.getSegmentPreloadRange(a.oa, a.m, b, c));
            c = d.next().value;
            d = d.next().value;
            for(var e = c; e < d; e++)jq(a, e);
            kq(a, c, d);
            return a.j.get(b) || null;
        }
        function lq(a, b) {
            if (a.h.has(b)) return a.h.get(b);
            var c = a.ra[b].Ea().catch(function(d) {
                t.ColibrioError.isColibrioAbortedError(d) || t.Logger.logError(d);
                return null;
            });
            a.h.set(b, c);
            return c;
        }
        function jq(a, b) {
            if (!a.j.has(b) && !a.g.has(b)) {
                var c = a.oa[b], d = c.getMediaObjectRefs().find(mq), e = c.getReaderDocumentIndexInSpine();
                d ? (c = lq(a, e).then(function(f) {
                    f = {
                        ga: f,
                        Pa: e,
                        hh: d.moContainerPath,
                        ih: d.moNodeIndex,
                        th: b,
                        xc: d.selector
                    };
                    a.g.has(b) && !a.L && (a.g.delete(b), a.j.set(b, f));
                    return f;
                }).catch(function(f) {
                    t.ColibrioError.isColibrioAbortedError(f) || t.Logger.logError(f);
                    return Promise.reject(f);
                }), a.g.set(b, c)) : a.j.set(b, {
                    ga: null,
                    Pa: e,
                    hh: [],
                    ih: 0,
                    th: b,
                    xc: null
                });
            }
        }
        function kq(a, b, c) {
            for(var d = new Set, e = b; e < c; e++){
                var f = a.oa[e];
                f.getMediaObjectRefs().find(mq) && d.add(f.getReaderDocumentIndexInSpine());
            }
            a.j.forEach(function(h, l) {
                (l < b || l >= c) && a.j.delete(l);
            });
            a.g.forEach(function(h, l) {
                (l < b || l >= c) && a.g.delete(l);
            });
            var g = new Map;
            a.h.forEach(function(h, l) {
                d.has(l) && g.set(l, h);
            });
            a.h = g;
        }
        function mq(a) {
            return a.type === D.SyncMediaObjectRefType.EPUB_MEDIA_OVERLAY_TEXT;
        }
        function nq(a, b, c) {
            var d = this;
            this.H = a;
            this.Fa = b;
            this.h = null;
            this.g = new Set;
            this.o = 1;
            this.A = !0;
            this.m = function(e) {
                d.g.has(e) ? e.isRenderingCompleted() && (e.removeStateChangeListener(d.m), oq(d, e)) : e.removeStateChangeListener(d.m);
            };
            this.j = new gq(a, c);
        }
        k = nq.prototype;
        k.bindRenderableDocumentPage = function(a) {
            if (a instanceof Uh) {
                if (this.g.add(a), a.isRenderingCompleted()) {
                    var b = a.g.Rc();
                    b && b.oe(this.A);
                    oq(this, a);
                } else a.addStateChangeListener(this.m);
            }
        };
        k.clearRangeEndPosition = function() {};
        k.destroy = function() {
            var a = this;
            this.j.destroy();
            this.g.forEach(function(b) {
                a.unbindRenderableDocumentPage(b);
            });
        };
        k.getSegmentTargets = function() {
            return [];
        };
        k.onSyncMediaPlayerPauseStateChanged = function(a) {
            var b = this;
            this.A = a;
            this.g.forEach(function(c) {
                (c = c.g.Rc()) && c.oe(b.A);
            });
        };
        k.pause = function() {};
        k.play = function() {};
        k.playUntilRangeEnd = function() {};
        k.seekToTimelinePosition = function(a) {
            var b = this, c = ++this.o, d = a.getSegmentIndex();
            this.Fa.onRuntimeWaiting();
            pq(this, null);
            var e = this.H.getSegments();
            d === e.length ? (iq(this.j, d, 0), this.Fa.onRuntimeReady()) : hq(this.j, d, a.getOffsetWithinSegmentMs()).then(function(f) {
                b.o === c && (pq(b, f), b.Fa.onRuntimeReady(), b.Fa.onActiveSegmentFinished(d));
            }).catch(function(f) {
                b.o === c && (pq(b, null), b.Fa.onSegmentError(d, D.SyncMediaPlayerErrorType.MEDIA_LOAD_ERROR, f, !1));
            });
        };
        k.setActiveSegmentIndex = function(a) {
            var b = iq(this.j, a, 0);
            b ? (pq(this, b), this.Fa.onActiveSegmentFinished(a)) : this.seekToTimelinePosition(new E.SyncMediaTimelinePosition(this.H, a, 0));
        };
        k.setMuted = function() {};
        k.setPlaybackRate = function() {};
        k.setVolume = function() {};
        k.unbindRenderableDocumentPage = function(a) {
            a instanceof Uh && (this.g.delete(a), a.removeStateChangeListener(this.m), a = a.g.Rc()) && (a.ne(null), a.oe(!0));
        };
        k.willCallPlaybackPositionUpdated = function() {
            return !1;
        };
        function pq(a, b) {
            a.h !== b && (a.h = b, a.g.forEach(function(c) {
                return oq(a, c);
            }));
        }
        function oq(a, b) {
            var c = b.g.Rc();
            c && (a.h && a.h.Pa === b.getReaderDocument().getIndexInSpine() ? c.ne(a.h) : c.ne(null));
        }
        function qq() {}
        qq.prototype.createRuntime = function(a, b, c) {
            var d = a.getReaderPublication().getSourcePublication().getType();
            if (d !== sa.PublicationType.EPUB) throw new T("MEDIA_OVERLAY_RENDERER_ERROR", "Incompatible ReaderPublication, expected " + sa.PublicationType.EPUB + ", actual: " + d);
            return new nq(a, b, c);
        };
        qq.prototype.destroyRuntime = function(a) {
            a instanceof nq && a.destroy();
        };
        qq.prototype.getSupportedMediaObjectRefType = function() {
            return D.SyncMediaObjectRefType.EPUB_MEDIA_OVERLAY_TEXT;
        };
        function rq(a, b, c, d, e, f, g, h) {
            this.m = a;
            this.oa = b;
            this.V = c;
            this.R = d;
            this.fb = e;
            this.C = f;
            this.g = 0;
            if (0 === this.oa.length) throw new T("INVALID_SYNC_MEDIA_TIMELINE", "The resulting SyncMediaTimeline have no segments.");
            this.h = new Yp(this, b, c, g, h);
            this.j = new E.SyncMediaTimelineTimeMapper(this);
            for(a = 0; a < b.length; a++)this.g += b[a].getApproximateDurationMs();
        }
        k = rq.prototype;
        k.createDefaultMediaObjectRenderers = function() {
            return [
                new E.SyncMediaAudioRenderer(this.C.defaultAudioRendererOptions),
                new qq
            ];
        };
        k.fetchContentLocation = function(a) {
            return Zp(this.h, a);
        };
        k.fetchTimelinePosition = function(a) {
            return aq(this.h, a);
        };
        k.fetchTimelineRange = function(a) {
            return cq(this.h, a);
        };
        k.getApproximateDurationMs = function() {
            return this.g;
        };
        k.getApproximateOffsetMs = function(a) {
            return this.j.getApproximateElapsedTimeMsForTimelinePosition(a);
        };
        k.getMediaObjectRefTypes = function() {
            return [
                D.SyncMediaObjectRefType.AUDIO,
                D.SyncMediaObjectRefType.EPUB_MEDIA_OVERLAY_TEXT
            ];
        };
        k.getMediaObjects = function() {
            return this.m;
        };
        k.getReaderDocuments = function() {
            return this.R;
        };
        k.getReaderPublication = function() {
            return this.V;
        };
        k.getResourceProvider = function() {
            return this.fb;
        };
        k.getSegments = function() {
            return this.oa;
        };
        k.getSyncMediaFormat = function() {
            return D.SyncMediaFormat.EPUB_MEDIA_OVERLAY;
        };
        k.getTimelinePositionFromApproximateOffsetMs = function(a) {
            return this.j.getTimelinePositionForApproximateTimeMs(a);
        };
        k.toJSON = function() {
            return {
                approximateDurationMs: this.g,
                mediaObjectRefTypes: this.getMediaObjectRefTypes(),
                mediaObjects: this.m.map(function(a) {
                    return a.toJSON();
                }),
                publicationHashSignature: this.V.getSourcePublication().getHashSignature(),
                readerDocumentIndexes: this.R.map(function(a) {
                    return a.getIndexInSpine();
                }),
                readerPublicationDefaultLocatorUrl: this.V.getDefaultLocatorUrl(),
                segments: this.oa.map(function(a) {
                    return a.toJSON();
                }),
                syncMediaFormat: D.SyncMediaFormat.EPUB_MEDIA_OVERLAY
            };
        };
        k.updateSegmentDuration = function(a, b) {
            var c = this.oa[a];
            if (c) {
                var d = c.getApproximateDurationMs();
                this.j._onSegmentDurationChanged({
                    newDurationMs: b,
                    oldDurationMs: d,
                    segmentIndex: a
                });
                this.g += b - c.getApproximateDurationMs();
                c.h = b;
                c.j = D.SyncMediaSegmentDurationType.FIXED;
            }
        };
        function sq(a) {
            this.g = a;
        }
        sq.prototype.getDuration = function() {
            return null;
        };
        sq.prototype.getResourceMetadata = function() {
            return this.g;
        };
        sq.prototype.toJSON = function() {
            return {
                durationMs: null,
                resourceMetadata: this.g
            };
        };
        function tq(a, b, c) {
            this.Pa = c;
            this.g = b ? [
                a,
                b
            ] : [
                a
            ];
            b && b.endMs ? (this.h = b.endMs - b.startMs, this.j = D.SyncMediaSegmentDurationType.FIXED) : (this.h = 0, this.j = D.SyncMediaSegmentDurationType.UNKNOWN);
        }
        k = tq.prototype;
        k.getApproximateDurationMs = function() {
            return this.h;
        };
        k.getDurationType = function() {
            return this.j;
        };
        k.getMediaObjectRefs = function() {
            return this.g;
        };
        k.getReaderDocumentIndexInSpine = function() {
            return this.Pa;
        };
        k.toJSON = function() {
            return {
                approximateDurationMs: this.h,
                durationType: this.j,
                readerDocumentIndexInSpine: this.Pa,
                refs: this.g
            };
        };
        function uq(a, b, c, d, e, f, g) {
            this.A = b;
            this.g = c;
            this.m = d;
            this.H = e;
            this.fb = f;
            this.j = new Map;
            this.o = [];
            this.h = new Map;
            for(b = 0; b < g.length; b++)c = g[b], this.h.set(c, []), d = c.getSourceContentDocument().getContentUrl(), this.j.set(B.URLUtils.getOriginAndPath(d), c);
            vq(this, a.body, a.childNodes.indexOf(a.body), []);
        }
        function vq(a, b, c, d) {
            if (b && "par" === b.nodeName && b.text) {
                try {
                    var e = B.URLUtils.normalizePathnameEncoding(new URL(b.text.src, a.g));
                } catch (w) {
                    t.Logger.logError(new T("INVALID_MEDIA_OVERLAY", "Invalid text node src: " + b.text.src));
                    return;
                }
                var f = B.URLUtils.getOriginAndPath(e);
                if (f = a.j.get(f)) {
                    d = {
                        moContainerPath: d.slice(),
                        moNodeIndex: c,
                        objectIndex: a.A,
                        selector: e.hash,
                        type: D.SyncMediaObjectRefType.EPUB_MEDIA_OVERLAY_TEXT
                    };
                    c = null;
                    if (b.audio) try {
                        var g = b.audio, h = B.URLUtils.normalizePathnameEncoding(new URL(g.src, a.g)), l = B.URLUtils.getOriginAndPath(h), m = a.m.get(l);
                        if (!K(m)) {
                            if (a.fb.acceptsUrl(h)) {
                                m = a.H++;
                                var n = a.fb.fetchMetadata(h, {
                                    accept: [
                                        y.MediaTypeCategory.AUDIO
                                    ]
                                }).then(function(w) {
                                    return new sq(w);
                                }).catch(function(w) {
                                    t.ColibrioError.isColibrioAbortedError(w) || t.Logger.logError(w);
                                    return new sq({
                                        url: h.toString()
                                    });
                                });
                                a.o.push(n);
                                a.m.set(l, m);
                            } else t.Logger.logError(new T("INVALID_MEDIA_OVERLAY", "Invalid audio node. Resource URL not accepted by resource provider: " + b.audio.src));
                        }
                        if (K(m)) {
                            var p = g.clipBeginMs | 0;
                            if (K(g.clipEndMs)) {
                                var u = g.clipEndMs | 0;
                                if (u < p) {
                                    var v = new T("INVALID_MEDIA_OVERLAY", 'Invalid audio node found in "' + a.g + '". clipEnd is before clipBegin.');
                                    t.Logger.logWarning(v);
                                    u = p;
                                }
                            } else u = null;
                            c = {
                                endMs: u,
                                objectIndex: m,
                                startMs: p,
                                type: D.SyncMediaObjectRefType.AUDIO
                            };
                        }
                    } catch (w) {
                        t.Logger.logError(new T("INVALID_MEDIA_OVERLAY", "Invalid audio node src: " + b.audio.src));
                    }
                    b = a.h.get(f);
                    b || (b = [], a.h.set(f, b));
                    b.push(new tq(d, c, f.getIndexInSpine()));
                } else a = new T("INVALID_MEDIA_OVERLAY", 'Media Overlay file "' + a.g + '" has a <text> element that refers to document "' + b.text.src + '". But no such document exists, or its manifest item has an incorrect "media-overlay" attribute.'), t.Logger.logError(a);
            } else if (b && ("seq" === b.nodeName || "body" === b.nodeName) && Pa(b.children)) {
                b = b.childNodes;
                d.push(c);
                for(f = 0; f < b.length; f++)vq(a, b[f], f, d);
                d.pop();
            }
        }
        function wq(a, b, c, d, e, f) {
            var g, h, l, m, n, p, u, v, w, x, A, z, C, F, G, L, P, Y, ba, ka, V, ea, pa;
            return q.K(function(W) {
                switch(W.g){
                    case 1:
                        return g = a.getSourcePublication(), h = [], l = new Map, m = new Map, n = new Map, p = [], u = E.SyncMediaTimelineUtils.getOrGenerateTimelineName(e.name), E.SyncMediaTimelineUtils.sendProgressEvent(a, u, f, 0), v = new E.ReadingSystemAsyncTaskScheduler(a.getReadingSystemEngine(), {
                            concurrency: 2,
                            pauseOnOffscreenContentRendering: !0,
                            pauseOnReaderViewGesture: !0,
                            pauseOnReaderViewNavigation: !0,
                            pauseOnVisibleContentRendering: !0
                        }), W.m = 0, W.o = 2, w = 0, b.forEach(function(ha) {
                            var Ua = ha.getSourceContentDocument().getMediaOverlayUrl();
                            if (Ua) {
                                var wa = B.URLUtils.getOriginAndPath(Ua);
                                if (n.has(wa)) n.get(wa).push(ha);
                                else {
                                    var Ad = v.scheduleTask(function() {
                                        var Va, Jb, Aa;
                                        return q.K(function(Ba) {
                                            switch(Ba.g){
                                                case 1:
                                                    return Va = null, da(Ba, 2), r(Ba, g.fetchMediaOverlay(Ua), 4);
                                                case 4:
                                                    Jb = Ba.h;
                                                    Va = Jb.mediaOverlay;
                                                    m.set(Va, h.length);
                                                    h.push(new sq(Jb.metadata));
                                                    l.set(Va, wa);
                                                    E.SyncMediaTimelineUtils.sendProgressEvent(a, u, f, Sa(w + 1, 0, p.length, 0, .5));
                                                    Ba.g = 3;
                                                    Ba.m = 0;
                                                    break;
                                                case 2:
                                                    Aa = fa(Ba), t.Logger.logError(Aa);
                                                case 3:
                                                    return w++, Ba.return(Va);
                                            }
                                        });
                                    }, 0);
                                    p.push(Ad);
                                    n.set(wa, [
                                        ha
                                    ]);
                                }
                            }
                        }), r(W, Promise.all(p), 4);
                    case 4:
                        x = W.h, A = new Map, z = new Map, C = {}, F = 0;
                    case 5:
                        if (!(F < x.length)) {
                            W.$(7);
                            break;
                        }
                        C.Tc = x[F];
                        if (!C.Tc) {
                            W.$(8);
                            break;
                        }
                        C.Dd = l.get(C.Tc);
                        if (!C.Dd) {
                            W.$(8);
                            break;
                        }
                        G = n.get(C.Dd);
                        if (!G) {
                            W.$(8);
                            break;
                        }
                        C.Ve = new uq(C.Tc, m.get(C.Tc), C.Dd, z, h.length, c, G);
                        return r(W, v.scheduleTask(function(ha) {
                            return function() {
                                return Promise.all(ha.Ve.o);
                            };
                        }(C), 0), 11);
                    case 11:
                        L = W.h, h.push.apply(h, q.Qc(L)), C.Ve.h.forEach(function(ha) {
                            return function(Ua, wa) {
                                A.set(wa, {
                                    hi: ha.Dd,
                                    ii: ha.Tc,
                                    oa: Ua
                                });
                            };
                        }(C));
                    case 8:
                        E.SyncMediaTimelineUtils.sendProgressEvent(a, u, f, Sa(F + 1, 0, x.length, .5, 1));
                        C = {
                            Ve: void 0,
                            Dd: void 0,
                            Tc: void 0
                        };
                        F++;
                        W.$(5);
                        break;
                    case 7:
                        P = [];
                        Y = [];
                        for(ba = 0; ba < b.length; ba++)if (ka = b[ba], Y.push(P.length), (V = A.get(ka)) && 0 < V.oa.length) for(ea = V.oa, pa = 0; pa < ea.length; pa++)P.push(ea[pa]);
                        return W.return(new rq(h, P, a, b, c, e, Y, d));
                    case 2:
                        ia(W), v.destroy(), ja(W, 0);
                }
            });
        }
        function xq(a, b, c) {
            this.Ub = a;
            this.Wf = b;
            this.Id = new Map;
            this.Td = this.L = !1;
            this.rd = this.od = null;
            this.ra = [];
            this.Vb = new Pe(this);
            try {
                Jh();
                this.C = Na(c, this.getDefaultOptions());
                this.kb = this.C.defaultLocatorUrl;
                var d = new ta.SelectorFactory([
                    new ua.EpubCfiFragmentSelectorParser
                ]);
                this.nd = new qa.LocatorFactory(d);
                this.N = new Rd(this, this.nd);
                this.W = new Xp(a);
                this.Xf = new ep(this.C.reflowOptions);
                switch(this.C.pageCountEstimationAlgorithm.type){
                    case "CHARACTERS":
                        this.Nc = new ve(this.C.pageCountEstimationAlgorithm.options, this.ra, this.W);
                        break;
                    case "FILE_SIZE":
                        this.Nc = new De(this.ra, this.W);
                }
                var e = this.Ub.getSpine();
                for(a = 0; a < e.length; a++){
                    var f = e[a];
                    !this.Td && f.getMediaOverlayUrl() && (this.Td = !0);
                    var g = this.getReaderDocument(f, this.ra.length);
                    this.ra.push(g);
                }
            } catch (h) {
                throw Fh(), h;
            }
        }
        k = xq.prototype;
        k.createContentPositionTimeline = function(a, b, c) {
            b = Na(b, Cd(b));
            switch(b.unit){
                case D.ContentPositionTimelineUnit.CHARACTERS:
                    return xd(this, a, this.N, new pc(b.mappingOptions), b, c);
                case D.ContentPositionTimelineUnit.DOCUMENTS:
                    return E.ReaderDocumentContentPositionTimelineBuilder.createTimeline(D.ContentPositionTimelineUnit.DOCUMENTS, a, this, b.name, c);
                case D.ContentPositionTimelineUnit.PAGES:
                    return E.ReaderDocumentContentPositionTimelineBuilder.createTimeline(D.ContentPositionTimelineUnit.PAGES, a, this, b.name, c);
                case D.ContentPositionTimelineUnit.WORDS:
                    return xd(this, a, this.N, new vd(b.mappingOptions), b, c);
            }
            throw new T("UNSUPPORTED_CONTENT_POSITION_TIMELINE_UNIT", b.unit);
        };
        k.createMediaOverlaySyncMediaTimeline = function(a, b, c) {
            var d = E.ReadingSystemUtils.getReaderDocumentListErrorForTimelineCreation(a, this);
            return d ? Promise.reject(d) : wq(this, a, this.Ub.getEpubResourceProvider(), this.N, b || {}, c);
        };
        k.createTtsSyncMediaTimeline = function(a, b, c) {
            return E.TtsSyncMediaTimelineBuilder.createTimeline(a, b || null, c);
        };
        k.destroy = function() {
            this.L || (this.L = !0, this.Nc.destroy(), this.Id.clear(), this.W.destroy(), Fh(), this.Wf.unloadPublication(this));
        };
        k.fetchContentLocation = function(a) {
            return this.fetchUnresolvedContentLocation(a).then(function(b) {
                return b.resolve();
            });
        };
        k.fetchContentLocationFromHref = function(a, b) {
            var c = this;
            try {
                var d, e = null != (d = null != b ? b : this.W.getResourceProvider().getBaseUrl()) ? d : void 0;
                var f = B.URLUtils.normalizePathnameEncoding(new URL(a, e));
            } catch (g) {
                return Promise.reject(new T("INVALID_URL", "Invalid url. baseUrl: " + b + ", href: " + a));
            }
            return (a = this.getSourcePublication().getContentDocumentByUrl(f)) ? f.hash.startsWith("#") ? (b = this.getReaderDocument(a), yq(this, b, a, f).then(function(g) {
                return c.fetchContentLocation(g);
            })) : this.fetchContentLocation(Vd(this.N, a)) : Promise.reject(new T("TARGET_DOCUMENT_NOT_FOUND", "Target document not found: " + f.toString()));
        };
        k.fetchPreferredPageAspectRatio = function() {
            var a = this;
            this.rd || (this.rd = zq(this), this.rd.catch(function() {
                a.rd = null;
            }));
            return this.rd;
        };
        k.fetchPublicationNavigation = function() {
            var a = this;
            this.od || (this.od = ue(this.Ub, this.N, this.ra), this.od.catch(function() {
                a.od = null;
            }));
            return this.od;
        };
        k.fetchUnresolvedContentLocation = function(a) {
            a = E.LocatorUtils.getLocator(a);
            if (null === a) return Promise.reject(new E.EngineError(E.EngineErrorType.NAVIGATION_ITEM_MISSING_LOCATOR));
            var b = this.N.getLocatorFactory().parse(a, this.kb);
            a = b.locator;
            if (!a) return Promise.reject(b.error);
            var c = a.getSelectors().find(Aq);
            if (!c) return Promise.reject(new T("UNSUPPORTED_EPUB_ANNOTATION_TARGET_SELECTOR", JSON.stringify(a.getSelectors())));
            b = new ua.EpubCfiResolver(c.getRootNode());
            var d = b.continueResolving(this.Ub.getOpfDocument(), this.Ub.getOpfDocumentUrl()), e = b.getResolvedTarget();
            if (e.rangeStartPath && e.rangeEndPath) {
                var f = e.rangeStartPath.getTargetElement(), g = e.rangeEndPath.getTargetElement();
                if (!f || !g || "itemref" !== f.localName || "itemref" !== g.localName) return Promise.reject(new T("EPUBCFI_TARGET_DOCUMENT_NOT_FOUND", "Target documents not found: " + c.getValue()));
                var h = this.ra.findIndex(function(n) {
                    return n.getSourceContentDocument().getOpfSpineItemElement() === f;
                }), l = this.ra.findIndex(function(n) {
                    return n.getSourceContentDocument().getOpfSpineItemElement() === g;
                });
                e.rangeEndPath.indirectionsResolved && l--;
                if (Ka(h) || Ka(l) || h > l) return Promise.reject(new T("EPUBCFI_TARGET_INVALID_RANGE", "Invalid range in epubcfi: " + c.getValue()));
                c = this.ra.slice(h, l + 1);
            } else if (e.parentPath) {
                var m = e.parentPath.getTargetElement();
                if (!m || "itemref" !== m.localName) return Promise.reject(new T("EPUBCFI_TARGET_DOCUMENT_NOT_FOUND", "Target documents not found: " + c.getValue()));
                e = this.ra.find(function(n) {
                    return n.getSourceContentDocument().getOpfSpineItemElement() === m;
                });
                if (!e) return Promise.reject(new T("EPUBCFI_TARGET_DOCUMENT_NOT_FOUND", "Target document not present in runtime spine: " + c.getValue()));
                c = [
                    e
                ];
            } else return Promise.reject(new T("EPUBCFI_TARGET_DOCUMENT_NOT_FOUND", "Target document not found: " + c.getValue()));
            return Promise.resolve(new ae(a, c, this, b, d, null));
        };
        k.getAvailableContentPositionTimelineUnits = function() {
            var a = this.ra.every(function(c) {
                return c.getSourceContentDocument().getLayout() === sa.ContentDocumentLayout.PRE_PAGINATED;
            }), b = [
                D.ContentPositionTimelineUnit.CHARACTERS,
                D.ContentPositionTimelineUnit.DOCUMENTS,
                D.ContentPositionTimelineUnit.WORDS
            ];
            a && b.push(D.ContentPositionTimelineUnit.PAGES);
            return b;
        };
        k.getAvailableSyncMediaFormats = function() {
            return this.Td ? [
                D.SyncMediaFormat.EPUB_MEDIA_OVERLAY,
                D.SyncMediaFormat.CONTENT_BLOCK_TTS
            ] : [
                D.SyncMediaFormat.CONTENT_BLOCK_TTS
            ];
        };
        k.getDefaultLocatorUrl = function() {
            return this.kb;
        };
        k.getLocatorFactory = function() {
            return this.nd;
        };
        k.getOptions = function() {
            return this.C;
        };
        k.getReaderDocument = function(a, b) {
            var c = this.Id.get(a);
            Ka(b) && (b = -1);
            if (!c) {
                switch(a.getMediaType()){
                    case y.MediaType.IMAGE_SVG:
                        c = new hm(a, this, this.C, this.W, this.Vb, this.N, b);
                        break;
                    case y.MediaType.APPLICATION_XHTML:
                    case y.MediaType.TEXT_HTML:
                    case y.MediaType.APPLICATION_HTML:
                        c = new $l(a, this.Xf, this, this.C, this.W, this.Vb, this.Nc, this.N, b);
                        break;
                    default:
                        throw new T("UNSUPPORTED_EPUB_CONTENT_DOCUMENT_TYPE", a.getContentUrl().pathname + ": " + a.getMediaType());
                }
                this.Id.set(a, c);
            }
            return c;
        };
        k.getReaderPublicationStorage = function() {
            return this.Vb;
        };
        k.getReadingSystemEngine = function() {
            return this.Wf;
        };
        k.getSourcePublication = function() {
            return this.Ub;
        };
        k.getSpine = function() {
            return this.ra.slice();
        };
        k.isDestroyed = function() {
            return this.L;
        };
        k.isLocatorSourceUrlInPublication = function(a) {
            return E.LocatorUtils.isLocatorSourceUrlInPublication(a, this.N.getLocatorFactory(), this.kb, this.C.additionalLocatorUrls);
        };
        k.isMediaOverlaySyncMediaAvailable = function() {
            return this.Td;
        };
        k.setOptions = function(a) {
            var b = this, c = this.C;
            a = Na(a, Ma(this.C, {}, !1), !0);
            this.C = Na(a, this.getDefaultOptions());
            a = this.C.contentBlockOptions.attributeNamesThatCreateContentBlocks;
            var d = c.contentBlockOptions.attributeNamesThatCreateContentBlocks, e = a !== d;
            e && a && d && (e = a.length !== d.length || a.some(function(f, g) {
                return f !== d[g];
            }));
            e && (this.C.contentBlockOptions.attributeNamesThatCreateContentBlocks = d, a = new T("SET_OPTIONS_ERROR", "contentBlockOptions.attributeNamesThatCreateContentBlocks cannot be changed with readerPublication.setOptions()."), t.Logger.logError(a));
            this.C.contentBlockOptions.disableDefaultAttributeFiltering !== c.contentBlockOptions.disableDefaultAttributeFiltering && (this.C.contentBlockOptions.disableDefaultAttributeFiltering = c.contentBlockOptions.disableDefaultAttributeFiltering, a = new T("SET_OPTIONS_ERROR", "contentBlockOptions.disableDefaultAttributeFiltering cannot be changed with readerPublication.setOptions()."), t.Logger.logError(a));
            this.C.contentBlockOptions.includeMathMlContentBlocks !== c.contentBlockOptions.includeMathMlContentBlocks && (this.C.contentBlockOptions.includeMathMlContentBlocks = c.contentBlockOptions.includeMathMlContentBlocks, a = new T("SET_OPTIONS_ERROR", "contentBlockOptions.includeMathMlContentBlocks cannot be changed with readerPublication.setOptions()."), t.Logger.logError(a));
            this.C.contentBlockOptions.includePreContentBlocks !== c.contentBlockOptions.includePreContentBlocks && (this.C.contentBlockOptions.includePreContentBlocks = c.contentBlockOptions.includePreContentBlocks, c = new T("SET_OPTIONS_ERROR", "contentBlockOptions.includePreContentBlocks cannot be changed with readerPublication.setOptions()."), t.Logger.logError(c));
            this.C.defaultLocatorUrl !== this.kb && (this.C.defaultLocatorUrl = this.kb, c = new T("SET_OPTIONS_ERROR", "defaultLocatorUrl cannot be changed with readerPublication.setOptions()."), t.Logger.logError(c));
            this.Id.forEach(function(f) {
                return f.setOptions(b.C);
            });
            this.Xf.g = fp(this.C.reflowOptions);
        };
        k.toJSON = function() {
            return {
                availableContentPositionTimelineUnits: this.getAvailableContentPositionTimelineUnits(),
                availableSyncMediaFormats: this.getAvailableSyncMediaFormats(),
                defaultLocatorUrl: this.kb,
                sourcePublicationHashSignature: this.Ub.getHashSignature(),
                spine: this.getSpine().map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function zq(a) {
            var b = a.ra.filter(function(c) {
                return c.getSourceContentDocument().getLayout() === sa.ContentDocumentLayout.PRE_PAGINATED;
            });
            return E.ReadingSystemUtils.fetchAverageAspectRatioFromReaderDocuments(b.slice(0, 3)).then(function(c) {
                return null === c ? Vl(a.Ub, a.W.getResourceProvider()).then(function(d) {
                    return null === d ? null : d.width / d.height;
                }) : c;
            }).catch(function(c) {
                t.Logger.logWarning(c);
                return null;
            });
        }
        function yq(a, b, c, d) {
            return b.Ea().then(function(e) {
                return (e = e.getElementById(d.hash.slice(1))) ? ed(a.N, c, e) : Promise.reject(new T("TARGET_ELEMENT_NOT_FOUND", "Target element not found: " + d.hash.slice(1)));
            });
        }
        k.getDefaultOptions = function() {
            return {
                additionalLocatorUrls: [],
                allowAudioElementAutoplay: !0,
                allowDocumentScripting: !0,
                allowVideoElementAutoplay: !0,
                clipboardOptions: {
                    allowCopy: !0,
                    textToAppendOnCopy: null,
                    textToPrependOnCopy: null
                },
                contentBlockOptions: {
                    attributeNamesThatCreateContentBlocks: null,
                    disableDefaultAttributeFiltering: !1,
                    includeMathMlContentBlocks: !1,
                    includePreContentBlocks: !1
                },
                contentProcessingOptions: {
                    addTabIndexToMediaElements: !1,
                    horizontalOverflowMathMLStrategy: "SCROLL",
                    horizontalOverflowMitigationMinFontSize: 16,
                    horizontalOverflowTableStrategy: "SCROLL",
                    skipUnusedImagesInScriptedPublicationCss: !1,
                    verticalOverflowMitigationStrategy: "SCROLL"
                },
                customPublicationCss: {
                    enableNormalizeCss: !0,
                    injectionPointEnd: [],
                    injectionPointEndUnprocessed: [],
                    injectionPointStart: [],
                    injectionPointStartUnprocessed: []
                },
                defaultLocatorUrl: "com.colibrio.epub.signature:" + this.Ub.getHashSignature(),
                documentSectioningOptions: {
                    algorithm: {
                        disableSectioningInsideSelector: "aside, blockquote, details, dialog, dl, figure, form, math, menu, nav, ol, pre, svg, table, ul",
                        minimumCharactersPerSection: 1E4,
                        selectors: [
                            {
                                breakPosition: "BEFORE",
                                selector: "h1"
                            },
                            {
                                breakPosition: "BEFORE",
                                selector: "h2"
                            },
                            {
                                breakPosition: "BEFORE",
                                selector: "h3"
                            }
                        ],
                        type: "SELECTOR"
                    },
                    enabled: !1
                },
                elementWhitelistOptions: {
                    attributeNames: [],
                    tagNames: []
                },
                enableMediaStreaming: !1,
                fixedLayoutStyleOptions: {
                    allowFontSetCustomization: !1,
                    allowPaletteCustomization: !1
                },
                includeContentLocationInPointerMoveEvents: !1,
                mediaOverlayOptions: {
                    activeElementAncestorClass: null,
                    activeElementStylesOverride: null,
                    fallbackActiveElementClass: "-epub-media-overlay-active",
                    fallbackPlaybackActiveClass: "-epub-media-overlay-playing"
                },
                pageCountEstimationAlgorithm: {
                    type: "FILE_SIZE"
                },
                preventDefaultContextMenu: !1,
                preventDefaultContextMenuOnMediaElements: !1,
                preventDragAndDropActions: !0,
                reflowOptions: {
                    plugins: {
                        cssForcedPageBreak: !0,
                        customCssValuePenalizer: {
                            fragmentation: [
                                {
                                    numericValueCondition: {
                                        comparator: "GREATER_THAN",
                                        value: 0
                                    },
                                    penalty: 400,
                                    properties: [
                                        "borderBottomWidth",
                                        "borderTopWidth"
                                    ]
                                },
                                {
                                    penalty: 400,
                                    properties: [
                                        "pageBreakInside",
                                        "breakInside"
                                    ],
                                    values: [
                                        "avoid",
                                        "avoid-page"
                                    ]
                                },
                                {
                                    penalty: 400,
                                    properties: [
                                        "whiteSpace"
                                    ],
                                    values: [
                                        "pre-wrap",
                                        "pre",
                                        "pre-line"
                                    ]
                                }
                            ],
                            orphans: [
                                {
                                    penalty: 400,
                                    properties: [
                                        "pageBreakAfter",
                                        "breakAfter"
                                    ],
                                    values: [
                                        "avoid",
                                        "avoid-page"
                                    ]
                                }
                            ],
                            widows: [
                                {
                                    penalty: 400,
                                    properties: [
                                        "pageBreakBefore",
                                        "breakBefore"
                                    ],
                                    values: [
                                        "avoid",
                                        "avoid-page"
                                    ]
                                }
                            ]
                        },
                        customElementPenalizer: {
                            fragmentation: [
                                {
                                    penalty: 1E3,
                                    selector: "h1, h2, h3, h4, h5, h6"
                                },
                                {
                                    penalty: 1E3,
                                    selector: "figure"
                                },
                                {
                                    overrides: [
                                        {
                                            context: "descendant",
                                            penalty: 100,
                                            selector: "ol, ul"
                                        }
                                    ],
                                    penalty: 300,
                                    selector: "li"
                                },
                                {
                                    penalty: 700,
                                    selector: "blockquote"
                                },
                                {
                                    penalty: 400,
                                    selector: "aside"
                                },
                                {
                                    penalty: 500,
                                    selector: "a[href]"
                                },
                                {
                                    penalty: 700,
                                    selector: "dt"
                                },
                                {
                                    overrides: [
                                        {
                                            context: "descendant",
                                            penalty: 50,
                                            selector: "dl"
                                        }
                                    ],
                                    penalty: 100,
                                    selector: "dl"
                                },
                                {
                                    overrides: [
                                        {
                                            context: "descendant",
                                            penalty: 100,
                                            selector: "dd, dl"
                                        }
                                    ],
                                    penalty: 300,
                                    selector: "dd"
                                }
                            ],
                            orphans: [
                                {
                                    penalty: 800,
                                    selector: "h1, h2, h3, h4, h5, h6"
                                },
                                {
                                    penalty: 800,
                                    selector: "[epub:type=bridgehead]"
                                },
                                {
                                    penalty: 800,
                                    selector: "dt"
                                }
                            ],
                            widows: [
                                {
                                    penalty: -80,
                                    selector: "h1, h2",
                                    skipIfFragmented: !0
                                }
                            ]
                        },
                        customForcedPageBreak: {
                            breakAfterRules: [],
                            breakBeforeRules: [],
                            breakMarkersRules: []
                        },
                        floatingOrphanPenalizer: {
                            penalty: 500
                        },
                        fragmentableElements: {
                            allowByDefault: !0,
                            blacklistSelectors: [
                                "tr",
                                "video",
                                "audio",
                                "picture",
                                "math"
                            ],
                            blacklistStyles: [
                                {
                                    property: "position",
                                    values: [
                                        "absolute",
                                        "fixed"
                                    ]
                                },
                                {
                                    property: "display",
                                    values: [
                                        "table-row"
                                    ]
                                }
                            ],
                            whitelistSelectors: []
                        },
                        listBreak: {
                            orphans: {
                                minItems: 2,
                                penalty: 200
                            },
                            widows: {
                                minItems: 2,
                                penalty: 100
                            }
                        },
                        mediaShrink: {
                            activationThreshold: .15,
                            maxShrinkFactor: .7,
                            penaltyAtMaxShrinkage: 10
                        },
                        orphanTextPattern: {
                            rules: [
                                {
                                    flags: "",
                                    pattern: ":\\s*$",
                                    penalty: 60
                                }
                            ]
                        },
                        unforcedTextBreak: {
                            loneWidowNotFragmented: {
                                minLines: 3,
                                minLinesFromCss: !1,
                                penalty: 500
                            },
                            orphans: {
                                minLines: 2,
                                minLinesFromCss: !1,
                                penalty: 400
                            },
                            textFragmentationPenalty: 0,
                            widows: {
                                minLines: 3,
                                minLinesFromCss: !1,
                                penalty: 400
                            }
                        },
                        verticalWhitespacePenalizer: {
                            stops: [
                                {
                                    penalty: 100,
                                    whitespaceRatio: .2
                                },
                                {
                                    penalty: 1E3,
                                    whitespaceRatio: 1
                                }
                            ]
                        }
                    },
                    removeBottomMarginsOnFragmentedElements: !0,
                    removeTopMarginsOnFragmentedElements: !0
                },
                remoteResourcesNonScriptedDocumentsOptions: {
                    policyType: "DENY_ALL",
                    whitelistDirectives: []
                },
                remoteResourcesScriptedDocumentsOptions: {
                    policyType: "DENY_ALL",
                    whitelistDirectives: []
                },
                textSplitOptions: {
                    enableTextSplit: !1,
                    maxTextNodeLength: 5E3
                }
            };
        };
        function Aq(a) {
            return a instanceof ua.EpubCfiSelector;
        }
        function Bq() {}
        Bq.prototype.createReaderPublication = function(a, b, c) {
            return Promise.resolve(new xq(a, b, c));
        };
        Bq.prototype.isPublicationSupported = function(a) {
            return a.getType() === sa.PublicationType.EPUB;
        };
        api = {
            EpubContentOverflowStrategy: {
                SCALE: "SCALE",
                SCROLL: "SCROLL"
            },
            EpubContentPositionTimelineWhitespaceBehavior: {
                COLLAPSE: "COLLAPSE",
                PRESERVE: "PRESERVE",
                IGNORE: "IGNORE"
            },
            EpubDocumentSectioningAlgorithmType: {
                SELECTOR: "SELECTOR"
            },
            EpubFormatAdapter: Bq,
            EpubFormatAdapterError: T,
            EpubFormatAdapterErrorType: {
                CONTENT_BLOCK_NOT_FOUND: "CONTENT_BLOCK_NOT_FOUND",
                CONTENT_DOCUMENT_NOT_FRAGMENTABLE: "CONTENT_DOCUMENT_NOT_FRAGMENTABLE",
                CONTENT_DOCUMENT_PARSING_FAILED: "CONTENT_DOCUMENT_PARSING_FAILED",
                CONTENT_DOCUMENT_HORIZONTAL_OVERFLOW_MITIGATED: "CONTENT_DOCUMENT_HORIZONTAL_OVERFLOW_MITIGATED",
                CONTENT_DOCUMENT_VERTICAL_OVERFLOW_MITIGATED: "CONTENT_DOCUMENT_VERTICAL_OVERFLOW_MITIGATED",
                DOCUMENT_NOT_RENDERED: "DOCUMENT_NOT_RENDERED",
                DOM_MUTATION_RECORDER_ERROR: "DOM_MUTATION_RECORDER_ERROR",
                EPUBCFI_TARGET_CONTENT_NOT_FOUND: "EPUBCFI_TARGET_CONTENT_NOT_FOUND",
                EPUBCFI_TARGET_DOCUMENT_NOT_FOUND: "EPUBCFI_TARGET_DOCUMENT_NOT_FOUND",
                TARGET_DOCUMENT_NOT_FOUND: "TARGET_DOCUMENT_NOT_FOUND",
                TARGET_ELEMENT_NOT_FOUND: "TARGET_ELEMENT_NOT_FOUND",
                EPUBCFI_TARGET_INVALID_RANGE: "EPUBCFI_TARGET_INVALID_RANGE",
                FAILED_TO_RESOLVE_CONTENT_BLOCK: "FAILED_TO_RESOLVE_CONTENT_BLOCK",
                FONT_LOAD_ERROR: "FONT_LOAD_ERROR",
                IFRAME_DOCUMENT_NOT_FOUND: "IFRAME_DOCUMENT_NOT_FOUND",
                IFRAME_LOAD_MULTIPLE_TIMES: "IFRAME_LOAD_MULTIPLE_TIMES",
                INCOMPATIBLE_END_LOCATION: "INCOMPATIBLE_END_LOCATION",
                INCOMPATIBLE_LOCATION: "INCOMPATIBLE_LOCATION",
                INVALID_CHANNEL_FOR_SCRIPTED_READER_DOCUMENT: "INVALID_CHANNEL_FOR_SCRIPTED_READER_DOCUMENT",
                INVALID_CSS_SELECTOR: "INVALID_CSS_SELECTOR",
                INVALID_PROCESSED_DOCUMENT_OPERATION: "INVALID_PROCESSED_DOCUMENT_OPERATION",
                INVALID_LOCATOR: "INVALID_LOCATOR",
                INVALID_PUBLICATION_STORAGE_STATE: "INVALID_PUBLICATION_STORAGE_STATE",
                INVALID_SYNC_MEDIA_TIMELINE: "INVALID_SYNC_MEDIA_TIMELINE",
                INVALID_SYNC_MEDIA_POSITION: "INVALID_SYNC_MEDIA_POSITION",
                INVALID_SYNC_MEDIA_SEGMENT_INDEX: "INVALID_SYNC_MEDIA_SEGMENT_INDEX",
                INVALID_SYNC_MEDIA_COMPONENT: "INVALID_SYNC_MEDIA_COMPONENT",
                INVALID_MEDIA_OVERLAY: "INVALID_MEDIA_OVERLAY",
                INVALID_MESSAGE_FROM_SCRIPTED_IFRAME: "INVALID_MESSAGE_FROM_SCRIPTED_IFRAME",
                INVALID_NODE_PATH: "INVALID_NODE_PATH",
                INVALID_OPENTYPE_FONT: "INVALID_OPENTYPE_FONT",
                INVALID_READER_DOCUMENT: "INVALID_READER_DOCUMENT",
                INVALID_RENDERER_STATE: "INVALID_RENDERER_STATE",
                INVALID_RENDERABLE_DOCUMENT_CONTENT_RANGE: "INVALID_RENDERABLE_DOCUMENT_CONTENT_RANGE",
                INVALID_URL_IN_PUBLICATION_RESOURCE: "INVALID_URL_IN_PUBLICATION_RESOURCE",
                INVALID_URL: "INVALID_URL",
                INVALID_SERIALIZED_TIMELINE_DATA: "INVALID_SERIALIZED_TIMELINE_DATA",
                MEDIA_LOAD_TIMEOUT: "MEDIA_LOAD_TIMEOUT",
                MEDIA_OVERLAY_RENDERER_ERROR: "MEDIA_OVERLAY_RENDERER_ERROR",
                NAVIGATION_DOCUMENT_TYPE_UNSUPPORTED: "NAVIGATION_DOCUMENT_TYPE_UNSUPPORTED",
                PAGE_ESTIMATION_ERROR: "PAGE_ESTIMATION_ERROR",
                READER_DOCUMENT_EMPTY: "READER_DOCUMENT_EMPTY",
                READER_DOCUMENT_LOAD_ERROR: "READER_DOCUMENT_LOAD_ERROR",
                RENDERER_PAGE_DIMENSIONS_MISSING: "RENDERER_PAGE_DIMENSIONS_MISSING",
                SET_OPTIONS_ERROR: "SET_OPTIONS_ERROR",
                UNSUPPORTED_CONTENT_POSITION_TIMELINE_UNIT: "UNSUPPORTED_CONTENT_POSITION_TIMELINE_UNIT",
                UNSUPPORTED_EPUB_SELECTOR: "UNSUPPORTED_EPUB_ANNOTATION_TARGET_SELECTOR",
                UNSUPPORTED_EPUB_CONTENT_DOCUMENT_TYPE: "UNSUPPORTED_EPUB_CONTENT_DOCUMENT_TYPE",
                UNSUPPORTED_RESOURCE_DATA_FORMAT: "UNSUPPORTED_RESOURCE_DATA_FORMAT"
            },
            EpubPageCountEstimationAlgorithmType: {
                FILE_SIZE: "FILE_SIZE",
                CHARACTERS: "CHARACTERS"
            },
            EpubRemoteResourcePolicyType: {
                DENY_ALL: "DENY_ALL",
                WHITELIST: "WHITELIST",
                ALLOW_ALL: "ALLOW_ALL"
            },
            ForcedBreakMode: {
                PAGE: "page",
                LEFT: "left",
                RIGHT: "right",
                RECTO: "recto",
                VERSO: "verso"
            },
            SectionBreakPosition: {
                BEFORE: "BEFORE",
                AFTER: "AFTER"
            }
        };
        var Cq = new ArrayBuffer(8);
        new DataView(Cq);
        new Uint8Array(Cq);
    }).call(__self);
    return api;
});


const { EpubContentOverflowStrategy: $c285ff458aea1783$export$fa085cc4a659b0c9, EpubContentPositionTimelineWhitespaceBehavior: $c285ff458aea1783$export$7f2d0e81a87736cd, EpubDocumentSectioningAlgorithmType: $c285ff458aea1783$export$b5d97ace6a1cf8a7, EpubFormatAdapter: $c285ff458aea1783$export$6cce81df6c9fb52, EpubFormatAdapterError: $c285ff458aea1783$export$212795412c5d3fdc, EpubFormatAdapterErrorType: $c285ff458aea1783$export$1767e07ba76353a3, EpubPageCountEstimationAlgorithmType: $c285ff458aea1783$export$e828f3764e5997bc, EpubRemoteResourcePolicyType: $c285ff458aea1783$export$6c55d60f0ae7a3de, ForcedBreakMode: $c285ff458aea1783$export$3bd17cd463656297, SectionBreakPosition: $c285ff458aea1783$export$a7736013b892b8c5 } = (0, (/*@__PURE__*/$parcel$interopDefault($71281c9a3a3a369e$exports)));


var $e8a69a69bb220635$exports = {};
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";










(function(s, f) {
    if (0, $e8a69a69bb220635$exports) $e8a69a69bb220635$exports = f(s, (parcelRequire("i64v9")), (parcelRequire("cLeaP")), (parcelRequire("loFPd")), (parcelRequire("csyWb")), (parcelRequire("acQau")), (parcelRequire("8v4lP")), (parcelRequire("bkFGj")), (parcelRequire("2ifeC")), (parcelRequire("7kECq")), (parcelRequire("9eVOO")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : $e8a69a69bb220635$exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_encryption, __dep__colibrio_core_io_base, __dep__colibrio_core_locator, __dep__colibrio_core_publication_base, __dep__colibrio_core_publication_pdf, __dep__colibrio_core_selector_base, __dep__colibrio_core_selector_pdf, __dep__colibrio_readingsystem_base, __dep__colibrio_readingsystem_engine) {
    var __lib__timsort = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        (function(u) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = u() : "function" === typeof define && define.amd ? define([], u) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = u();
        })(function() {
            return (function() {
                function u(x, C, z) {
                    function y(r, t) {
                        if (!C[r]) {
                            if (!x[r]) {
                                var D = undefined;
                                if (!t && D) return D(r, !0);
                                if (A) return A(r, !0);
                                t = Error("Cannot find module '" + r + "'");
                                throw t.code = "MODULE_NOT_FOUND", t;
                            }
                            t = C[r] = {
                                exports: {}
                            };
                            x[r][0].call(t.exports, function(F) {
                                return y(x[r][1][F] || F);
                            }, t, t.exports, u, x, C, z);
                        }
                        return C[r].exports;
                    }
                    for(var A = undefined, E = 0; E < z.length; E++)y(z[E]);
                    return y;
                }
                return u;
            })()({
                1: [
                    function(u, x, C) {
                        (function(z, y) {
                            if ("undefined" !== typeof C) y(C);
                            else {
                                var A = {};
                                y(A);
                                z.timsort = A;
                            }
                        })(void 0, function(z) {
                            function y(g) {
                                return 1E5 > g ? 100 > g ? 10 > g ? 0 : 1 : 1E4 > g ? 1E3 > g ? 2 : 3 : 4 : 1E7 > g ? 1E6 > g ? 5 : 6 : 1E9 > g ? 1E8 > g ? 7 : 8 : 9;
                            }
                            function A(g, a) {
                                if (g === a) return 0;
                                if (~~g === g && ~~a === a) {
                                    if (0 === g || 0 === a) return g < a ? -1 : 1;
                                    if (0 > g || 0 > a) {
                                        if (0 <= a) return -1;
                                        if (0 <= g) return 1;
                                        g = -g;
                                        a = -a;
                                    }
                                    var h = y(g), c = y(a), e = 0;
                                    h < c ? (g *= G[c - h - 1], a /= 10, e = -1) : h > c && (a *= G[h - c - 1], g /= 10, e = 1);
                                    return g === a ? e : g < a ? -1 : 1;
                                }
                                g = String(g);
                                a = String(a);
                                return g === a ? 0 : g < a ? -1 : 1;
                            }
                            function E(g, a, h, c) {
                                var e = a + 1;
                                if (e === h) return 1;
                                if (0 > c(g[e++], g[a])) {
                                    for(; e < h && 0 > c(g[e], g[e - 1]);)e++;
                                    h = a;
                                    c = e;
                                    for(c--; h < c;){
                                        var k = g[h];
                                        g[h++] = g[c];
                                        g[c--] = k;
                                    }
                                } else for(; e < h && 0 <= c(g[e], g[e - 1]);)e++;
                                return e - a;
                            }
                            function r(g, a, h, c, e) {
                                for(c === a && c++; c < h; c++){
                                    for(var k = g[c], d = a, b = c; d < b;){
                                        var f = d + b >>> 1;
                                        0 > e(k, g[f]) ? b = f : d = f + 1;
                                    }
                                    b = c - d;
                                    switch(b){
                                        case 3:
                                            g[d + 3] = g[d + 2];
                                        case 2:
                                            g[d + 2] = g[d + 1];
                                        case 1:
                                            g[d + 1] = g[d];
                                            break;
                                        default:
                                            for(; 0 < b;)g[d + b] = g[d + b - 1], b--;
                                    }
                                    g[d] = k;
                                }
                            }
                            function t(g, a, h, c, e, k) {
                                var d = 0, b = 1;
                                if (0 < k(g, a[h + e])) {
                                    for(c -= e; b < c && 0 < k(g, a[h + e + b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    d += e;
                                    b += e;
                                } else {
                                    for(c = e + 1; b < c && 0 >= k(g, a[h + e - b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    c = d;
                                    d = e - b;
                                    b = e - c;
                                }
                                for(d++; d < b;)e = d + (b - d >>> 1), 0 < k(g, a[h + e]) ? d = e + 1 : b = e;
                                return b;
                            }
                            function D(g, a, h, c, e, k) {
                                var d = 0, b = 1;
                                if (0 > k(g, a[h + e])) {
                                    for(c = e + 1; b < c && 0 > k(g, a[h + e - b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    c = d;
                                    d = e - b;
                                    b = e - c;
                                } else {
                                    for(c -= e; b < c && 0 <= k(g, a[h + e + b]);)d = b, b = (b << 1) + 1, 0 >= b && (b = c);
                                    b > c && (b = c);
                                    d += e;
                                    b += e;
                                }
                                for(d++; d < b;)e = d + (b - d >>> 1), 0 > k(g, a[h + e]) ? b = e : d = e + 1;
                                return b;
                            }
                            z.__esModule = !0;
                            z.sort = function(g, a, h, c) {
                                if (!Array.isArray(g)) throw new TypeError("Can only sort arrays");
                                a ? "function" !== typeof a && (c = h, h = a, a = A) : a = A;
                                h || (h = 0);
                                c || (c = g.length);
                                var e = c - h;
                                if (!(2 > e)) {
                                    if (e < F) {
                                        var k = E(g, h, c, a);
                                        r(g, h, c, h + k, a);
                                    } else {
                                        var d = new H(g, a), b;
                                        k = e;
                                        for(b = 0; k >= F;)b |= k & 1, k >>= 1;
                                        b = k + b;
                                        do {
                                            k = E(g, h, c, a);
                                            if (k < b) {
                                                var f = e;
                                                f > b && (f = b);
                                                r(g, h, h + f, h + k, a);
                                                k = f;
                                            }
                                            d.pushRun(h, k);
                                            d.mergeRuns();
                                            e -= k;
                                            h += k;
                                        }while (0 !== e);
                                        d.forceMergeRuns();
                                    }
                                }
                            };
                            var F = 32, G = [
                                1,
                                10,
                                100,
                                1E3,
                                1E4,
                                1E5,
                                1E6,
                                1E7,
                                1E8,
                                1E9
                            ], H = function() {
                                function g(a, h) {
                                    if (!(this instanceof g)) throw new TypeError("Cannot call a class as a function");
                                    this.compare = this.array = null;
                                    this.minGallop = 7;
                                    this.length = 0;
                                    this.tmpStorageLength = 256;
                                    this.stackLength = 0;
                                    this.runLength = this.runStart = null;
                                    this.stackSize = 0;
                                    this.array = a;
                                    this.compare = h;
                                    this.length = a.length;
                                    512 > this.length && (this.tmpStorageLength = this.length >>> 1);
                                    this.tmp = Array(this.tmpStorageLength);
                                    this.stackLength = 120 > this.length ? 5 : 1542 > this.length ? 10 : 119151 > this.length ? 19 : 40;
                                    this.runStart = Array(this.stackLength);
                                    this.runLength = Array(this.stackLength);
                                }
                                g.prototype.pushRun = function(a, h) {
                                    this.runStart[this.stackSize] = a;
                                    this.runLength[this.stackSize] = h;
                                    this.stackSize += 1;
                                };
                                g.prototype.mergeRuns = function() {
                                    for(; 1 < this.stackSize;){
                                        var a = this.stackSize - 2;
                                        if (1 <= a && this.runLength[a - 1] <= this.runLength[a] + this.runLength[a + 1] || 2 <= a && this.runLength[a - 2] <= this.runLength[a] + this.runLength[a - 1]) this.runLength[a - 1] < this.runLength[a + 1] && a--;
                                        else if (this.runLength[a] > this.runLength[a + 1]) break;
                                        this.mergeAt(a);
                                    }
                                };
                                g.prototype.forceMergeRuns = function() {
                                    for(; 1 < this.stackSize;){
                                        var a = this.stackSize - 2;
                                        0 < a && this.runLength[a - 1] < this.runLength[a + 1] && a--;
                                        this.mergeAt(a);
                                    }
                                };
                                g.prototype.mergeAt = function(a) {
                                    var h = this.compare, c = this.array, e = this.runStart[a], k = this.runLength[a], d = this.runStart[a + 1], b = this.runLength[a + 1];
                                    this.runLength[a] = k + b;
                                    a === this.stackSize - 3 && (this.runStart[a + 1] = this.runStart[a + 2], this.runLength[a + 1] = this.runLength[a + 2]);
                                    this.stackSize--;
                                    a = D(c[d], c, e, k, 0, h);
                                    e += a;
                                    k -= a;
                                    0 !== k && (b = t(c[e + k - 1], c, d, b, b - 1, h), 0 !== b && (k <= b ? this.mergeLow(e, k, d, b) : this.mergeHigh(e, k, d, b)));
                                };
                                g.prototype.mergeLow = function(a, h, c, e) {
                                    var k = this.compare, d = this.array, b = this.tmp, f;
                                    for(f = 0; f < h; f++)b[f] = d[a + f];
                                    var m = 0;
                                    d[a++] = d[c++];
                                    if (0 === --e) for(f = 0; f < h; f++)d[a + f] = b[m + f];
                                    else if (1 === h) {
                                        for(f = 0; f < e; f++)d[a + f] = d[c + f];
                                        d[a + e] = b[m];
                                    } else {
                                        for(var p = this.minGallop;;){
                                            var l = 0, n = 0, q = !1;
                                            do if (0 > k(d[c], b[m])) {
                                                if (d[a++] = d[c++], n++, l = 0, 0 === --e) {
                                                    q = !0;
                                                    break;
                                                }
                                            } else if (d[a++] = b[m++], l++, n = 0, 1 === --h) {
                                                q = !0;
                                                break;
                                            }
                                            while ((l | n) < p);
                                            if (q) break;
                                            do {
                                                l = D(d[c], b, m, h, 0, k);
                                                if (0 !== l) {
                                                    for(f = 0; f < l; f++)d[a + f] = b[m + f];
                                                    a += l;
                                                    m += l;
                                                    h -= l;
                                                    if (1 >= h) {
                                                        q = !0;
                                                        break;
                                                    }
                                                }
                                                d[a++] = d[c++];
                                                if (0 === --e) {
                                                    q = !0;
                                                    break;
                                                }
                                                n = t(b[m], d, c, e, 0, k);
                                                if (0 !== n) {
                                                    for(f = 0; f < n; f++)d[a + f] = d[c + f];
                                                    a += n;
                                                    c += n;
                                                    e -= n;
                                                    if (0 === e) {
                                                        q = !0;
                                                        break;
                                                    }
                                                }
                                                d[a++] = b[m++];
                                                if (1 === --h) {
                                                    q = !0;
                                                    break;
                                                }
                                                p--;
                                            }while (7 <= l || 7 <= n);
                                            if (q) break;
                                            0 > p && (p = 0);
                                            p += 2;
                                        }
                                        this.minGallop = p;
                                        1 > p && (this.minGallop = 1);
                                        if (1 === h) {
                                            for(f = 0; f < e; f++)d[a + f] = d[c + f];
                                            d[a + e] = b[m];
                                        } else {
                                            if (0 === h) throw Error("mergeLow preconditions were not respected");
                                            for(f = 0; f < h; f++)d[a + f] = b[m + f];
                                        }
                                    }
                                };
                                g.prototype.mergeHigh = function(a, h, c, e) {
                                    var k = this.compare, d = this.array, b = this.tmp, f;
                                    for(f = 0; f < e; f++)b[f] = d[c + f];
                                    var m = a + h - 1, p = e - 1;
                                    c = c + e - 1;
                                    d[c--] = d[m--];
                                    if (0 === --h) {
                                        var l = c - (e - 1);
                                        for(f = 0; f < e; f++)d[l + f] = b[f];
                                    } else if (1 === e) {
                                        c -= h;
                                        var n = c + 1;
                                        l = m - h + 1;
                                        for(f = h - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                        d[c] = b[p];
                                    } else {
                                        for(var q = this.minGallop;;){
                                            var v = 0, w = 0, B = !1;
                                            do if (0 > k(b[p], d[m])) {
                                                if (d[c--] = d[m--], v++, w = 0, 0 === --h) {
                                                    B = !0;
                                                    break;
                                                }
                                            } else if (d[c--] = b[p--], w++, v = 0, 1 === --e) {
                                                B = !0;
                                                break;
                                            }
                                            while ((v | w) < q);
                                            if (B) break;
                                            do {
                                                v = h - D(b[p], d, a, h, h - 1, k);
                                                if (0 !== v) {
                                                    c -= v;
                                                    m -= v;
                                                    h -= v;
                                                    n = c + 1;
                                                    l = m + 1;
                                                    for(f = v - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                                    if (0 === h) {
                                                        B = !0;
                                                        break;
                                                    }
                                                }
                                                d[c--] = b[p--];
                                                if (1 === --e) {
                                                    B = !0;
                                                    break;
                                                }
                                                w = e - t(d[m], b, 0, e, e - 1, k);
                                                if (0 !== w) {
                                                    c -= w;
                                                    p -= w;
                                                    e -= w;
                                                    n = c + 1;
                                                    l = p + 1;
                                                    for(f = 0; f < w; f++)d[n + f] = b[l + f];
                                                    if (1 >= e) {
                                                        B = !0;
                                                        break;
                                                    }
                                                }
                                                d[c--] = d[m--];
                                                if (0 === --h) {
                                                    B = !0;
                                                    break;
                                                }
                                                q--;
                                            }while (7 <= v || 7 <= w);
                                            if (B) break;
                                            0 > q && (q = 0);
                                            q += 2;
                                        }
                                        this.minGallop = q;
                                        1 > q && (this.minGallop = 1);
                                        if (1 === e) {
                                            c -= h;
                                            n = c + 1;
                                            l = m - h + 1;
                                            for(f = h - 1; 0 <= f; f--)d[n + f] = d[l + f];
                                            d[c] = b[p];
                                        } else {
                                            if (0 === e) throw Error("mergeHigh preconditions were not respected");
                                            l = c - (e - 1);
                                            for(f = 0; f < e; f++)d[l + f] = b[f];
                                        }
                                    }
                                };
                                return g;
                            }();
                        });
                    },
                    {}
                ],
                2: [
                    function(u, x) {
                        x.exports = u("./build/timsort.js");
                    },
                    {
                        "./build/timsort.js": 1
                    }
                ],
                3: [
                    function(u, x) {
                        x.exports = u("timsort");
                    },
                    {
                        timsort: 2
                    }
                ]
            }, {}, [
                3
            ])(3);
        });
        return module1.exports;
    }();
    var api = {};
    (function() {
        var g, m = m || {};
        m.scope = {};
        m.mb = function(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        };
        m.Db = function(a) {
            return {
                next: m.mb(a)
            };
        };
        m.Ya = !1;
        m.Mb = !1;
        m.Nb = !1;
        m.Qb = !1;
        m.ab = !1;
        m.Ob = !1;
        m.Pb = !1;
        m.defineProperty = m.Ya || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        m.Gb = function(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        };
        m.global = m.Gb(this);
        m.Ka = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
        m.eb = !m.ab || m.Ka;
        m.Wa = {};
        m.Xa = {};
        m.ub = "$jscp$";
        m.sb = function(a, b, c) {
            b && (m.ab ? m.Jb(a, b, c) : m.Kb(a, b));
        };
        m.Kb = function(a, b) {
            var c = m.global;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) return;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && null != b && m.defineProperty(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        };
        m.Jb = function(a, b, c) {
            var d = a.split(".");
            a = 1 === d.length;
            var e = d[0], f;
            !a && e in m.Wa ? f = m.Wa : f = m.global;
            for(e = 0; e < d.length - 1; e++){
                var k = d[e];
                if (!(k in f)) return;
                f = f[k];
            }
            d = d[d.length - 1];
            c = m.Ka && "es6" === c ? f[d] : null;
            b = b(c);
            null != b && (a ? m.defineProperty(m.Wa, d, {
                configurable: !0,
                writable: !0,
                value: b
            }) : b !== c && (void 0 === m.Xa[d] && (a = 1E9 * Math.random() >>> 0, m.Xa[d] = m.Ka ? m.global.Symbol(d) : m.ub + a + "$" + d), m.defineProperty(f, m.Xa[d], {
                configurable: !0,
                writable: !0,
                value: b
            })));
        };
        m.Xb = function() {};
        m.sb("Symbol", function(a) {
            function b(f) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (f || "") + "_" + e++, f);
            }
            function c(f, k) {
                this.g = f;
                m.defineProperty(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: k
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        }, "es6");
        m.sb("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = m.global[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && m.defineProperty(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return m.Hb(m.mb(this));
                    }
                });
            }
            return a;
        }, "es6");
        m.Hb = function(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        };
        m.Tb = function(a) {
            return a.raw = a;
        };
        m.Ub = function(a, b) {
            a.raw = b;
            return a;
        };
        m.W = function(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return m.Db(a);
            throw Error(String(a) + " is not an iterable or ArrayLike");
        };
        m.Cb = function(a) {
            for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
            return c;
        };
        m.lb = function(a) {
            return a instanceof Array ? a : m.Cb(m.W(a));
        };
        m.qb = m.Ya || "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        };
        m.Fb = function() {
            function a() {
                function c() {}
                new c;
                Reflect.construct(c, [], function() {});
                return new c instanceof c;
            }
            if (m.eb && "undefined" != typeof Reflect && Reflect.construct) {
                if (a()) return Reflect.construct;
                var b = Reflect.construct;
                return function(c, d, e) {
                    c = b(c, d);
                    e && Reflect.setPrototypeOf(c, e.prototype);
                    return c;
                };
            }
            return function(c, d, e) {
                void 0 === e && (e = c);
                e = m.qb(e.prototype || Object.prototype);
                return Function.prototype.apply.call(c, e, d) || e;
            };
        };
        m.construct = ({
            valueOf: m.Fb
        }).valueOf();
        m.Lb = function() {
            var a = {
                a: !0
            }, b = {};
            try {
                return b.__proto__ = a, b.a;
            } catch (c) {}
            return !1;
        };
        m.setPrototypeOf = m.eb && "function" == typeof Object.setPrototypeOf ? Object.setPrototypeOf : m.Lb() ? function(a, b) {
            a.__proto__ = b;
            if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
            return a;
        } : null;
        m.inherits = function(a, b) {
            a.prototype = m.qb(b.prototype);
            a.prototype.constructor = a;
            if (m.setPrototypeOf) {
                var c = m.setPrototypeOf;
                c(a, b);
            } else for(c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.$b = b.prototype;
        };
        m.M = {};
        m.M.Eb = function(a) {
            if (!(a instanceof Object)) throw new TypeError("Iterator result " + a + " is not an object");
        };
        m.M.ia = function() {
            this.H = !1;
            this.s = null;
            this.h = void 0;
            this.g = 1;
            this.F = this.j = 0;
            this.N = this.i = null;
        };
        function aa(a) {
            if (a.H) throw new TypeError("Generator is already running");
            a.H = !0;
        }
        m.M.ia.prototype.I = function(a) {
            this.h = a;
        };
        function ba(a, b) {
            a.i = {
                ob: b,
                pb: !0
            };
            a.g = a.j || a.F;
        }
        m.M.ia.prototype.return = function(a) {
            this.i = {
                return: a
            };
            this.g = this.F;
        };
        function q(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        m.M.ia.prototype.V = function(a) {
            this.g = a;
        };
        function t(a) {
            a.j = 0;
            var b = a.i.ob;
            a.i = null;
            return b;
        }
        m.M.ia.g = function(a) {
            this.g = [];
            for(var b in a)this.g.push(b);
            this.g.reverse();
        };
        m.M.Za = function(a) {
            this.g = new m.M.ia;
            this.h = a;
        };
        function ca(a, b) {
            aa(a.g);
            var c = a.g.s;
            if (c) return da(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return y(a);
        }
        function da(a, b, c, d) {
            try {
                var e = b.call(a.g.s, c);
                m.M.Eb(e);
                if (!e.done) return a.g.H = !1, e;
                var f = e.value;
            } catch (k) {
                return a.g.s = null, ba(a.g, k), y(a);
            }
            a.g.s = null;
            d.call(a.g, f);
            return y(a);
        }
        function y(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.H = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.h = void 0, ba(a.g, c);
            }
            a.g.H = !1;
            if (a.g.i) {
                b = a.g.i;
                a.g.i = null;
                if (b.pb) throw b.ob;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        m.M.$a = function(a) {
            this.next = function(b) {
                aa(a.g);
                a.g.s ? b = da(a, a.g.s.next, b, a.g.I) : (a.g.I(b), b = y(a));
                return b;
            };
            this.throw = function(b) {
                aa(a.g);
                a.g.s ? b = da(a, a.g.s["throw"], b, a.g.I) : (ba(a.g, b), b = y(a));
                return b;
            };
            this.return = function(b) {
                return ca(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        };
        m.M.Sb = function(a, b) {
            b = new m.M.$a(new m.M.Za(b));
            m.setPrototypeOf && a.prototype && m.setPrototypeOf(b, a.prototype);
            return b;
        };
        m.nb = function(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function f(k) {
                    k.done ? d(k.value) : Promise.resolve(k.value).then(b, c).then(f, e);
                }
                f(a.next());
            });
        };
        m.Rb = function(a) {
            return m.nb(a());
        };
        m.L = function(a) {
            return m.nb(new m.M.$a(new m.M.Za(a)));
        };
        m.Wb = function() {
            for(var a = Number(this), b = [], c = a; c < arguments.length; c++)b[c - a] = arguments[c];
            return b;
        };
        function ea() {
            var a = document.createElement("style");
            a.appendChild(document.createTextNode(".colibrio-pdf-renderable-page-text-layer-iframe{border:none;height:100%;overflow:hidden;width:100%}.colibrio-pdf-renderable-page-text-layer-iframe-container{mix-blend-mode:multiply;position:absolute;-webkit-transform:translateZ(0);transform:translateZ(0)}.hiddenCanvasElement{display:none;height:0;left:0;position:absolute;top:0;width:0}"));
            var b = document.head;
            b.insertBefore(a, b.firstChild);
        }
        "object" === typeof document && (document.head ? ea() : document.addEventListener("DOMContentLoaded", ea, !1));
        var B = __dep__colibrio_core_base;
        var fa = __dep__colibrio_core_io_base;
        var C = __dep__colibrio_core_locator;
        var ha = __dep__colibrio_core_publication_base;
        var ia = __dep__colibrio_core_selector_base;
        var E = __dep__colibrio_core_selector_pdf;
        var F = __dep__colibrio_readingsystem_base;
        var H = __dep__colibrio_readingsystem_engine;
        function ja(a, b, c) {
            var d = 0;
            if (0 >= b) a = -1;
            else {
                b = d + b - 1;
                for(var e = d, f = 1; f && d <= b;)e = d + b >>> 1, f = c(a, e), 0 > f ? b = e - 1 : 0 < f && (d = e + 1);
                0 > f && e--;
                a = e;
            }
            return a;
        }
        function ma(a) {
            return a && 1 === a.nodeType;
        }
        function I(a) {
            return a && 3 === a.nodeType;
        }
        function na(a) {
            var b;
            if (b = I(a)) a = a.data, b = J(a) && /\S/.test(a);
            return b;
        }
        function M(a) {
            return "undefined" === typeof a;
        }
        function N(a, b, c) {
            return a < b ? b : a > c ? c : a;
        }
        function O(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), e = 0; e < d.length; e++){
                var f = d[e], k = a[f];
                null !== k && "object" === typeof k ? b[f] = O(k, b[f], c) : M(k) ? c && delete b[f] : b[f] = k;
            }
            return b;
        }
        function oa(a, b) {
            var c;
            if (a && !P(a) && "object" === typeof a) {
                var d = Object.keys(a);
                var e = 0;
                for(c = d.length; e < c; e++){
                    var f = d[e];
                    b(a[f], f);
                }
            }
        }
        var P = Array.isArray;
        function Q(a) {
            return "number" === typeof a && !isNaN(a);
        }
        function J(a) {
            return "string" === typeof a;
        }
        function pa(a, b) {
            var c = a.style;
            oa(b, function(d, e) {
                J(c[e]) && (c[e] = d);
            });
        }
        function qa(a) {
            var b = [
                {
                    name: "style",
                    value: "position: absolute; z-index: -10000000; left: 0; right: 0; top: 0; bottom: 0; opacity: 0"
                }
            ];
            a = a.createElement("div");
            for(var c = 0; c < b.length; c++){
                var d = b[c];
                d.Ib ? a.setAttributeNS(d.Ib, d.name, d.value) : a.setAttribute(d.name, d.value);
            }
            return a;
        }
        function ra(a) {
            if (a.body) return a.body;
            var b = a.documentElement.children[1];
            return b && "body" === b.localName ? b : a.documentElement;
        }
        function R(a) {
            var b = a.parentNode;
            b && b.removeChild(a);
        }
        function sa(a) {
            return "x" in a ? a : new DOMRect(a.left, a.top, a.width, a.height);
        }
        var ta = new Uint16Array(1);
        ta[0] = 4660;
        new Uint8Array(ta.buffer);
        function S(a, b) {
            return B.ColibrioError.call(this, "colibrio.readingsystem.formatadapter.pdf", a, b) || this;
        }
        m.inherits(S, B.ColibrioError);
        function ua(a) {
            this.g = a;
        }
        g = ua.prototype;
        g.getAnchorPoint = function() {
            return F.ContentBlockTargetAnchorPoint.INTERSECTS_CONTENT_LOCATION;
        };
        g.getCharLength = function() {
            return 0;
        };
        g.getCharOffset = function() {
            return 0;
        };
        g.getContentBlock = function() {
            return this.g;
        };
        g.toJSON = function() {
            return {
                anchorPoint: this.getAnchorPoint(),
                charLength: this.getCharLength(),
                charOffset: this.getCharOffset(),
                contentBlockId: this.g.getId(),
                readerDocumentIndexInSpine: this.g.getContentBlockTree().getReaderDocument().getIndexInSpine()
            };
        };
        function va(a) {
            return a instanceof E.PdfFragmentSelector;
        }
        function wa(a) {
            return a instanceof ia.RangeSelector && a.getStartSelector() instanceof E.PdfFragmentSelector && a.getEndSelector() instanceof E.PdfFragmentSelector;
        }
        function ya() {}
        ya.prototype.getTextContent = function() {
            return "";
        };
        ya.prototype.getTextContentAfter = function() {
            return "";
        };
        ya.prototype.getTextContentBefore = function() {
            return "";
        };
        function U(a, b, c) {
            this.g = a;
            this.h = b;
            this.C = c;
        }
        U.prototype.getNavigationCollection = function() {
            return this.g;
        };
        U.prototype.getNavigationItem = function() {
            return this.h;
        };
        U.prototype.getReaderDocument = function() {
            return this.C;
        };
        U.prototype.toJSON = function() {
            return {
                collectionIndex: this.g.getIndex(),
                collectionType: this.g.getType(),
                navigationItemId: this.h.getId(),
                readerDocumentIndexInSpine: this.C.getIndexInSpine(),
                readerPublicationDefaultLocatorUrl: this.C.getReaderPublication().getDefaultLocatorUrl()
            };
        };
        function za(a, b, c) {
            this.h = a;
            this.i = b;
            this.g = c;
        }
        za.prototype.getItemsAfter = function() {
            return this.g;
        };
        za.prototype.getItemsBefore = function() {
            return this.h;
        };
        za.prototype.getItemsInRange = function() {
            return this.i;
        };
        za.prototype.toJSON = function() {
            return {
                itemsAfter: this.g.map(function(a) {
                    return a.toJSON();
                }),
                itemsBefore: this.h.map(function(a) {
                    return a.toJSON();
                }),
                itemsInRange: this.i.map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function Aa(a, b, c, d) {
            return d[0].getReaderPublication().fetchPublicationNavigation().then(function(e) {
                var f = [], k = [], n = [];
                e.h.forEach(function(h, p) {
                    if (!a.collectionTypes || a.collectionTypes.includes(p.getType())) {
                        for(var l = ja(h, h.length, function(u, z) {
                            return b - u[z].getPageIndex();
                        }), r = l; 0 <= r && h[r].getPageIndex() >= b;)r--;
                        r++;
                        for(l += 1; l < h.length && h[l].getPageIndex() <= c;)l++;
                        a.greedy && 0 < r && (r === h.length || h[r].getPageIndex() > b) && r--;
                        f.push.apply(f, m.lb(h.slice(r, l).map(function(u) {
                            return new U(p, u, d[u.getPageIndex()]);
                        })));
                        0 < r && (r = h[r - 1], k.push(new U(p, r, d[r.getPageIndex()])));
                        l < h.length && (h = h[l], n.push(new U(p, h, d[h.getPageIndex()])));
                    }
                });
                return new za(k, f, n);
            });
        }
        function V(a, b, c, d, e) {
            this.i = b;
            this.j = c;
            c = e && Ba(e.v, e.G);
            Ba(d.v, d.G) || c ? (this.h = Ca(d), this.g = e && Ca(e), this.s = Da(b.A, this.h, this.g || void 0)) : (this.h = d, this.g = e, this.s = a);
        }
        function Ba(a, b) {
            return b ? 0 > a.u || 0 > a.m || a.u > b.width || a.m > b.height : 0 > a.u || 0 > a.m;
        }
        function W(a, b) {
            if (a._pageIndex !== b._pageIndex) return a._pageIndex - b._pageIndex;
            a = a.v;
            b = b.v;
            return a.m !== b.m ? a.m - b.m : a.u - b.u;
        }
        function Ca(a) {
            var b = a.G, c = a.v;
            return {
                G: b,
                _pageIndex: a._pageIndex,
                v: {
                    u: b ? N(c.u, 0, b.width) : Math.max(0, c.u),
                    m: b ? N(c.m, 0, b.height) : Math.max(0, c.m)
                }
            };
        }
        g = V.prototype;
        g.collapseToEnd = function() {
            if (!this.g) return this;
            var a = this.i.getLocatorFactory().collapseRangeLocatorToEnd(this.s);
            return new V(a, this.i, this.j, this.g, null);
        };
        g.collapseToStart = function() {
            if (!this.g) return this;
            var a = this.i.getLocatorFactory().collapseRangeLocatorToStart(this.s);
            return new V(a, this.i, this.j, this.h, null);
        };
        g.contains = function(a) {
            return a instanceof V && this.i === a.i ? this.g ? a.g ? 0 >= W(this.h, a.h) && 0 <= W(this.g, a.g) : 0 >= W(this.h, a.h) && 0 < W(this.g, a.h) : !a.g && 0 === W(this.h, a.h) : !1;
        };
        g.createRangeTo = function(a) {
            if (!(a instanceof V)) throw new S("INVALID_LOCATION", "Expected a PdfContentLocation instance");
            if (a.i !== this.i) throw new S("INVALID_LOCATION", "endLocation uses a different ReaderPublication instance");
            if (this.equals(a)) return this;
            var b = this.collapseToStart(), c = a.collapseToEnd(), d = W(b.h, c.h);
            if (0 < d) throw b = "endLocation is before startLocation, selector for startLocation: " + this.getLocator().getSelectors()[0] + " endLocation: " + a.getLocator().getSelectors()[0], new S("INCOMPATIBLE_END_LOCATION", b);
            if (0 === d) return b;
            a = this.i.getLocatorFactory().createRangeLocator(b.s, c.s);
            if (!a.locator) throw a.error;
            return new V(a.locator, this.i, this.j, b.h, c.h);
        };
        g.equals = function(a) {
            return a instanceof V && this.i === a.i && 0 === W(this.h, a.h) ? this.g && a.g ? 0 === W(this.g, a.g) : !this.g && !a.g : !1;
        };
        g.fetchContentBlockTargets = function(a) {
            var b = this;
            return this.j[this.h._pageIndex].fetchContentBlockTree().then(function(c) {
                var d;
                c = c.getContentBlocks();
                var e = c.find(function(f) {
                    return f.getContentLocation().intersects(b);
                });
                e ? d = e : a === F.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_AFTER ? d = Ea(b, c) : a === F.ContentBlockTargetFetchMode.INTERSECTING_OR_NEAREST_BEFORE && (d = Fa(b, c));
                return d ? [
                    new ua(d)
                ] : [];
            });
        };
        g.fetchContentResolver = function() {
            return Promise.resolve(new ya);
        };
        g.fetchNavigationItemReferences = function(a) {
            return Aa(a, this.h._pageIndex, this.g ? this.g._pageIndex : this.h._pageIndex, this.j);
        };
        function Ga(a, b, c) {
            var d = null;
            b = b.getIndexInSpine();
            b === a.h._pageIndex ? (d = a.h.v, d = a.g ? a.g._pageIndex === a.h._pageIndex ? new DOMRect(d.u, d.m, a.g.v.u - d.u, a.g.v.m - d.m) : new DOMRect(d.u, d.m, c.width - d.u, c.height - d.m) : new DOMRect(d.u, d.m)) : a.g && (b !== a.g._pageIndex || Ha(a) ? b > a.h._pageIndex && b < a.g._pageIndex && (d = new DOMRect(0, 0, c.width, c.height)) : d = new DOMRect(0, 0, a.g.v.u, a.g.v.m));
            return d;
        }
        g.getLocator = function() {
            return this.s;
        };
        g.getPageRects = function(a, b) {
            var c = a.getIndexInSpine(), d = this.s.getSelectors().find(va);
            if (d && this.h._pageIndex === c) {
                var e;
                return null != (e = d.getPageRects()) ? e : void 0;
            }
            return (a = Ga(this, a, b)) ? [
                a
            ] : void 0;
        };
        g.getReaderDocuments = function() {
            return this.g ? this.j.slice(this.h._pageIndex, Ha(this) ? this.g._pageIndex : this.g._pageIndex + 1) : [
                this.j[this.h._pageIndex]
            ];
        };
        g.getReaderPublication = function() {
            return this.i;
        };
        g.intersects = function(a) {
            return !this.isAfter(a) && !this.isBefore(a);
        };
        g.isAfter = function(a) {
            return a instanceof V && this.i === a.i ? a.g ? 0 <= W(this.h, a.g) : 0 < W(this.h, a.h) : !1;
        };
        g.isBefore = function(a) {
            return a instanceof V && this.i === a.i ? this.g ? 0 >= W(this.g, a.h) : 0 > W(this.h, a.h) : !1;
        };
        g.isRange = function() {
            return !!this.g;
        };
        g.toJSON = function() {
            return this.s.toJSON();
        };
        function Ea(a, b) {
            var c = void 0, d = void 0;
            b = m.W(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = null !== a.g ? a.g : a.h, k = e.getContentLocation(), n = W(k.h, f), h = null !== a.g ? 0 <= n : 0 < n;
                if (k.h.v.m === f.v.m) {
                    if (h && (M(d) || n < d)) {
                        d = n;
                        var p = e;
                    }
                } else M(d) && h && (M(c) || n < c) && (c = n, p = e);
            }
            return p;
        }
        function Fa(a, b) {
            var c = void 0, d = void 0;
            b = m.W(b);
            for(var e = b.next(); !e.done; e = b.next()){
                e = e.value;
                var f = e.getContentLocation(), k = null !== f.g ? f.g : f.h, n = W(k, a.h), h = null !== f.g ? 0 >= n : 0 > n;
                if (f.h.v.m === k.v.m) {
                    if (h && (M(d) || n > d)) {
                        d = n;
                        var p = e;
                    }
                } else M(d) && h && (M(c) || n > c) && (c = n, p = e);
            }
            return p;
        }
        function Ha(a) {
            if (!a.g) return !0;
            var b = a.g.v;
            return 0 === b.u && 0 === b.m || a.g._pageIndex >= a.j.length;
        }
        function Ia(a, b, c, d, e, f) {
            this.j = a;
            this.s = b;
            this.h = c;
            this.i = d;
            this.g = e;
            this.F = f ? Promise.resolve(f) : null;
        }
        g = Ia.prototype;
        g.collapseToEnd = function() {
            return this.g ? this.resolve().then(function(a) {
                return Ja(a.collapseToEnd());
            }) : Promise.resolve(this);
        };
        g.collapseToStart = function() {
            return this.g ? this.resolve().then(function(a) {
                return Ja(a.collapseToStart());
            }) : Promise.resolve(this);
        };
        g.contains = function(a) {
            var b = this, c, d, e, f, k, n, h, p;
            return m.L(function(l) {
                if (1 == l.g) return l.j = 2, c = m, d = c.W, q(l, Promise.all([
                    b.resolve(),
                    X(b, a)
                ]), 4);
                if (2 != l.g) return e = d.call(c, l.h), f = e.next().value, k = e.next().value, n = f, h = k, l.return(n.contains(h));
                p = t(l);
                B.ColibrioError.isColibrioAbortedError(p) || B.Logger.logWarning(p);
                return l.return(!1);
            });
        };
        g.createRangeTo = function(a) {
            var b = this, c, d, e, f, k, n, h;
            return m.L(function(p) {
                if (1 == p.g) return c = m, d = c.W, q(p, Promise.all([
                    b.resolve(),
                    X(b, a)
                ]), 2);
                e = d.call(c, p.h);
                f = e.next().value;
                k = e.next().value;
                n = f;
                h = k;
                return p.return(Ja(n.createRangeTo(h)));
            });
        };
        g.equals = function(a) {
            var b = this, c, d, e, f, k, n, h, p;
            return m.L(function(l) {
                if (1 == l.g) return l.j = 2, c = m, d = c.W, q(l, Promise.all([
                    b.resolve(),
                    X(b, a)
                ]), 4);
                if (2 != l.g) return e = d.call(c, l.h), f = e.next().value, k = e.next().value, n = f, h = k, l.return(n.equals(h));
                p = t(l);
                B.ColibrioError.isColibrioAbortedError(p) || B.Logger.logWarning(p);
                return l.return(!1);
            });
        };
        g.fetchContentBlockTargets = function(a) {
            return this.resolve().then(function(b) {
                return b.fetchContentBlockTargets(a);
            });
        };
        g.fetchContentResolver = function() {
            return this.resolve().then(function(a) {
                return a.fetchContentResolver();
            });
        };
        g.fetchNavigationItemReferences = function(a) {
            return this.resolve().then(function(b) {
                return b.fetchNavigationItemReferences(a);
            });
        };
        g.getLocator = function() {
            return this.j;
        };
        g.getReaderDocuments = function() {
            var a = this.i._pageIndex;
            return this.g ? this.h.slice(a, Ka(this) ? Math.min(this.g._pageIndex, this.h.length) : this.g._pageIndex + 1) : [
                this.h[a]
            ];
        };
        g.getReaderPublication = function() {
            return this.s;
        };
        g.intersects = function(a) {
            var b = this, c, d, e, f, k, n, h, p;
            return m.L(function(l) {
                if (1 == l.g) return l.j = 2, c = m, d = c.W, q(l, Promise.all([
                    b.resolve(),
                    X(b, a)
                ]), 4);
                if (2 != l.g) return e = d.call(c, l.h), f = e.next().value, k = e.next().value, n = f, h = k, l.return(n.intersects(h));
                p = t(l);
                B.ColibrioError.isColibrioAbortedError(p) || B.Logger.logWarning(p);
                return l.return(!1);
            });
        };
        g.isAfter = function(a) {
            var b = this, c, d, e, f, k, n, h, p;
            return m.L(function(l) {
                if (1 == l.g) return l.j = 2, c = m, d = c.W, q(l, Promise.all([
                    b.resolve(),
                    X(b, a)
                ]), 4);
                if (2 != l.g) return e = d.call(c, l.h), f = e.next().value, k = e.next().value, n = f, h = k, l.return(n.isAfter(h));
                p = t(l);
                B.ColibrioError.isColibrioAbortedError(p) || B.Logger.logWarning(p);
                return l.return(!1);
            });
        };
        g.isBefore = function(a) {
            var b = this, c, d, e, f, k, n, h, p;
            return m.L(function(l) {
                if (1 == l.g) return l.j = 2, c = m, d = c.W, q(l, Promise.all([
                    b.resolve(),
                    X(b, a)
                ]), 4);
                if (2 != l.g) return e = d.call(c, l.h), f = e.next().value, k = e.next().value, n = f, h = k, l.return(n.isBefore(h));
                p = t(l);
                B.ColibrioError.isColibrioAbortedError(p) || B.Logger.logWarning(p);
                return l.return(!1);
            });
        };
        g.isRange = function() {
            return this.resolve().then(function(a) {
                return a.isRange();
            });
        };
        g.resolve = function() {
            var a = this, b, c, d, e, f, k, n, h, p;
            return m.L(function(l) {
                switch(l.g){
                    case 1:
                        if (a.F) {
                            l.V(2);
                            break;
                        }
                        b = a.h[a.i._pageIndex];
                        return q(l, b.fetchViewportDimensions(), 3);
                    case 3:
                        c = {
                            G: l.h,
                            _pageIndex: a.i._pageIndex,
                            v: a.i.v || {
                                u: 0,
                                m: 0
                            }
                        };
                        d = null;
                        e = a.j;
                        if (!a.g) {
                            l.V(4);
                            break;
                        }
                        k = a.g.v;
                        n = a.g._pageIndex;
                        h = !1;
                        Ka(a) ? (n = Math.min(n, a.h.length) - 1, f = a.h[n], k = null, h = !0) : f = a.h[n];
                        return q(l, f.fetchViewportDimensions(), 5);
                    case 5:
                        p = l.h, d = {
                            G: p,
                            _pageIndex: n,
                            v: k || {
                                u: p.width,
                                m: p.height
                            }
                        }, h && (e = Da(a.s.A, c, d));
                    case 4:
                        a.F = Promise.resolve(new V(e, a.s, a.h, c, d));
                    case 2:
                        return l.return(a.F);
                }
            });
        };
        g.toJSON = function() {
            return this.j.toJSON();
        };
        function Ja(a) {
            var b = a.h, c = a.g;
            return new Ia(a.getLocator(), a.getReaderPublication(), a.j, {
                _pageIndex: b._pageIndex,
                v: b.v
            }, c ? {
                _pageIndex: c._pageIndex,
                v: c.v
            } : null, a);
        }
        function X(a, b) {
            var c;
            H.ReadingSystemUtils.isContentLocation(b) ? c = Promise.resolve(b) : c = H.ReadingSystemUtils.isUnresolvedContentLocation(b) ? b.resolve() : a.getReaderPublication().fetchContentLocation(b);
            return c.then(function(d) {
                if (!(d instanceof V)) throw new S("INVALID_LOCATION", "Expected a PdfContentLocation instance");
                return d;
            });
        }
        function Ka(a) {
            if (!a.g) return !0;
            var b = a.g.v;
            return !b || 0 === b.u && 0 === b.m || a.g._pageIndex >= a.h.length;
        }
        function La(a) {
            this.na = a;
        }
        function Ma(a, b, c) {
            return new E.PdfFragmentSelector({
                pageNumber: b,
                pageRects: M(c) ? void 0 : c
            }, [], a.na);
        }
        function Na(a, b, c) {
            this.g = a;
            this.h = b;
            this.i = c;
        }
        function Oa(a, b) {
            var c = Pa(a, function(d) {
                return Ma(d, b.getPageNumber());
            });
            return new C.Locator(a.g, c);
        }
        function Qa(a, b) {
            var c = Pa(a, function(d) {
                return new E.PdfFragmentSelector({
                    namedDest: b
                }, [], d.na);
            });
            return new C.Locator(a.g, c);
        }
        function Ra(a, b, c) {
            var d = Pa(a, function(e) {
                return Ma(e, b, c);
            });
            return new C.Locator(a.g, d);
        }
        function Da(a, b, c) {
            var d = Pa(a, function(e) {
                var f = c, k = b.v ? {
                    u: Math.max(0, b.v.u),
                    m: Math.max(0, b.v.m)
                } : {
                    u: 0,
                    m: 0
                };
                f && f._pageIndex < b._pageIndex && (f = void 0);
                if (f && f._pageIndex !== b._pageIndex) {
                    var n, h = (null == (n = f) ? 0 : n.v) ? {
                        u: Math.max(0, f.v.u),
                        m: Math.max(0, f.v.m)
                    } : {
                        u: 0,
                        m: 0
                    };
                    k = 0 < k.u || 0 < k.m ? new DOMRect(k.u, k.m) : void 0;
                    h = 0 < h.u || 0 < h.m ? new DOMRect(h.u, h.m) : void 0;
                    k = new E.PdfFragmentSelector({
                        pageNumber: b._pageIndex + 1,
                        pageRects: k && [
                            k
                        ]
                    }, [], e.na);
                    e = new E.PdfFragmentSelector({
                        pageNumber: f._pageIndex + 1,
                        pageRects: h && [
                            h
                        ]
                    }, [], e.na);
                    e = new ia.RangeSelector(k, e);
                } else {
                    var p = n = 0;
                    if (null == (h = f) ? 0 : h.v) n = Math.max(0, f.v.u - k.u), p = Math.max(0, f.v.m - k.m);
                    if (0 < n || 0 < p || 0 < k.u || 0 < k.m) var l = new DOMRect(k.u, k.m, n, p);
                    e = new E.PdfFragmentSelector({
                        pageNumber: b._pageIndex + 1,
                        pageRects: l && [
                            l
                        ]
                    }, [], e.na);
                }
                return e;
            });
            return new C.Locator(a.g, d);
        }
        Na.prototype.getLocatorFactory = function() {
            return this.i;
        };
        function Pa(a, b) {
            for(var c = [], d = 0; d < a.h.length; d++){
                var e = b(a.h[d]);
                e && c.push(e);
            }
            return c;
        }
        var Sa = __lib__timsort;
        function Ta(a, b) {
            return m.L(function(c) {
                return J(b) ? c.return(a.getDestination(b).then(function(d) {
                    return Ua(d, a);
                })) : c.return(Ua(b, a));
            });
        }
        function Ua(a, b) {
            return (a = P(a) && 0 < a.length ? a[0] : a) && a && !P(a) && "object" === typeof a ? b.getPageIndex(a) : Q(a) ? Promise.resolve(a) : Promise.reject(new S("UNKNOWN_DEST_ARRAY_FORMAT", "Invalid destination: " + JSON.stringify(a)));
        }
        function Va(a) {
            var b = F.NavigationCollectionType.TOC;
            this.g = a;
            this.h = b;
        }
        g = Va.prototype;
        g.getChildren = function() {
            return this.g;
        };
        g.getIndex = function() {
            return 0;
        };
        g.getTitle = function() {
            return null;
        };
        g.getType = function() {
            return this.h;
        };
        g.toJSON = function() {
            return {
                children: this.g.map(function(a) {
                    return a.toJSON();
                }),
                index: 0,
                title: null,
                type: this.h
            };
        };
        function Wa(a, b, c, d) {
            this.i = a;
            this.j = b;
            this.s = c;
            this.ca = d;
            this.h = this._pageIndex = this.g = null;
        }
        g = Wa.prototype;
        g.getChildren = function() {
            return this.i || [];
        };
        g.getHref = function() {
            return null;
        };
        g.getId = function() {
            return this.j;
        };
        g.getLocator = function() {
            return this.g;
        };
        g.getPageIndex = function() {
            return this._pageIndex;
        };
        g.getParent = function() {
            return this.h;
        };
        g.getTextContent = function() {
            return this.ca;
        };
        g.isTargetingReaderDocumentInSpine = function() {
            return this.s;
        };
        g.toJSON = function() {
            return {
                children: this.i ? this.i.map(function(a) {
                    return a.toJSON();
                }) : [],
                href: null,
                id: this.j,
                isTargetingReaderDocumentInSpine: this.s,
                locator: this.g && this.g.toJSON(),
                parentId: this.h && this.h.getId(),
                textContent: this.ca
            };
        };
        function Xa(a, b, c) {
            this.g = a;
            this.A = b;
            this.h = c;
            this.i = 1;
        }
        function Ya(a) {
            var b, c, d;
            return m.L(function(e) {
                if (1 == e.g) return a.g && 0 < a.g.length ? q(e, Za(a, a.g), 3) : (b = null, e.V(2));
                2 != e.g && (b = e.h);
                return (c = b) && 0 < c.length ? (d = new Va(c), e.return(Promise.resolve([
                    d
                ]))) : e.return(Promise.resolve([]));
            });
        }
        function Za(a, b) {
            var c, d, e, f, k, n, h;
            return m.L(function(p) {
                switch(p.g){
                    case 1:
                        c = [], d = {}, e = 0;
                    case 2:
                        if (!(e < b.length)) {
                            p.V(4);
                            break;
                        }
                        d.da = b[e];
                        f = null;
                        k = a.i++;
                        n = !0;
                        if (!(d.da.items && 0 < d.da.items.length)) {
                            p.V(5);
                            break;
                        }
                        return q(p, Za(a, d.da.items), 6);
                    case 6:
                        f = p.h;
                    case 5:
                        d.Ja = new Wa(f, k, n, d.da.title);
                        if (f) for(h = 0; h < f.length; h++)f[h].h = d.Ja;
                        return q(p, Ta(a.h, d.da.dest).then(function(l) {
                            return function(r) {
                                var u = l.Ja, z = l.da.dest;
                                J(z) ? (z = Qa(a.A, z), u.g = z) : P(z) && (z = Ra(a.A, r + 1), u.g = z);
                                u._pageIndex = r;
                            };
                        }(d)).catch(function(l) {
                            return B.Logger.logWarning(l);
                        }), 7);
                    case 7:
                        c.push(d.Ja);
                        d = {
                            Ja: void 0,
                            da: void 0
                        };
                        e++;
                        p.V(2);
                        break;
                    case 4:
                        return p.return(c);
                }
            });
        }
        function $a(a) {
            this.i = a;
            this.h = new Map;
            this.g = [];
            for(var b = 0; b < a.length; b++){
                for(var c = a[b], d = new B.TreeNodeWalker(c.getChildren()), e = [], f = 0; d.hasNext();){
                    var k = d.next(), n = k.getPageIndex();
                    null === n ? k._pageIndex = f : f = n;
                    e.push(k);
                    this.g.push(k);
                }
                Sa.sort(e, function(h, p) {
                    return h.getPageIndex() - p.getPageIndex();
                });
                this.h.set(c, e);
            }
            Sa.sort(this.g, function(h, p) {
                return h.getId() - p.getId();
            });
        }
        function ab(a, b) {
            return b.getOutline().then(function(c) {
                return Ya(new Xa(c, a, b)).then(function(d) {
                    return new $a(d);
                });
            });
        }
        $a.prototype.getNavigationCollections = function() {
            return this.i;
        };
        $a.prototype.getNavigationItemById = function(a) {
            return this.g[a - 1];
        };
        $a.prototype.toJSON = function() {
            return {
                navigationCollections: this.i.map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function bb(a) {
            var b = Error.call(this, "[colibrio.internal] " + (a || ""));
            this.message = b.message;
            "stack" in b && (this.stack = b.stack);
            this.errorMessage = a;
        }
        m.inherits(bb, Error);
        function cb(a) {
            this.h = a;
            this.g = new Map;
        }
        function db(a, b) {
            var c = a.g.get(b);
            if (c) return c.Ha++, c.Bb;
            c = a.h.getPage(b);
            a.g.set(b, {
                Bb: c,
                Ha: 1
            });
            c.catch(function(d) {
                B.Logger.logError(d);
                a.g.delete(b);
            });
            return c;
        }
        function eb(a, b, c) {
            return db(a, b).then(function(d) {
                return m.L(function(e) {
                    if (1 == e.g) return e.j = 0, e.F = 2, q(e, c(d), 4);
                    if (2 != e.g) return e.return(e.h);
                    e.N = [
                        e.i
                    ];
                    e.j = 0;
                    e.F = 0;
                    fb(a, d);
                    a: {
                        var f = e.N.splice(0)[0];
                        if (f = e.i = e.i || f) {
                            if (f.pb) {
                                e.g = e.j || e.F;
                                e = void 0;
                                break a;
                            }
                            void 0 != f.V && e.F < f.V ? (e.g = f.V, e.i = null) : e.g = e.F;
                        } else e.g = 0;
                        e = void 0;
                    }
                    return e;
                });
            });
        }
        function fb(a, b) {
            var c = a.g.get(b.pageNumber);
            c && 0 !== c.Ha ? (c.Ha--, 0 === c.Ha && (b.cleanup(), a.g.delete(b.pageNumber))) : B.Logger.logWarning(new bb("PdfPageProxyManager.release called for an unused IPdfjsPageProxy"));
        }
        function gb() {
            this.g = 0;
        }
        g = gb.prototype;
        g.getStorageArea = function() {
            throw new S("PUBLICATION_STORAGE_AREA_NOT_SUPPORTED");
        };
        g.getStorageSizeLimit = function() {
            return this.g;
        };
        g.getStorageState = function() {
            return {};
        };
        g.setStorageSizeLimit = function(a) {
            this.g = a;
        };
        g.setStorageState = function() {};
        function hb(a, b, c, d, e) {
            this.g = a;
            this.h = b;
            this.A = c;
            this.j = d;
            this.i = e;
        }
        function ib(a) {
            if (!jb) {
                var b = document.createElement("canvas");
                b.width = 1;
                b.height = 1;
                if (b = jb = b.getContext("2d", {
                    alpha: !1
                })) b.font = "10px sans-serif";
            }
            return (b = jb) ? b.measureText(a).width : 5 * a.length;
        }
        g = hb.prototype;
        g.contains = function() {
            return !1;
        };
        g.equals = function(a) {
            return a instanceof hb && this.h === a.h;
        };
        g.getAttributes = function() {
            return [];
        };
        g.getBlockClass = function() {
            return F.ContentBlockClass.TEXT;
        };
        g.getBlockType = function() {
            return F.TextContentBlockType.TEXT;
        };
        g.getChildren = function() {
            return [];
        };
        g.getCommonAncestorContainer = function() {
            return null;
        };
        g.getContentBlockTree = function() {
            return this.j;
        };
        g.getContentLocation = function(a, b) {
            b = m.W(kb(this, a, b));
            a = b.next().value;
            var c = b.next().value, d = this.j.getReaderDocument();
            b = d.getReaderPublication();
            var e = {
                height: this.i[3] - this.i[1],
                width: this.i[2] - this.i[0]
            }, f = {
                G: e,
                _pageIndex: d.getIndexInSpine(),
                v: {
                    u: c.left,
                    m: c.top
                }
            };
            c = 0 < c.width || 0 < c.height ? {
                G: e,
                _pageIndex: d.getIndexInSpine(),
                v: {
                    u: c.right,
                    m: c.bottom
                }
            } : null;
            return new V(a, b, b.getSpine(), f, c);
        };
        g.getId = function() {
            return this.h;
        };
        g.getLanguage = function() {
            var a = this.getContentBlockTree().getReaderDocument().getReaderPublication().getSourcePublication().getMetadata().getLanguages();
            return 0 < a.length ? a[0].content.value : null;
        };
        g.getLocator = function(a, b) {
            return kb(this, a, b)[0];
        };
        g.getMarks = function() {
            return [];
        };
        g.getNextSibling = function() {
            return this.j.getContentBlockById(this.h + 1);
        };
        g.getParent = function() {
            return null;
        };
        g.getPreviousSibling = function() {
            return this.j.getContentBlockById(this.h - 1);
        };
        g.getResourceHrefs = function() {
            return null;
        };
        g.getStartNode = function() {
            return null;
        };
        g.getTextContent = function() {
            return this.g.str;
        };
        g.isAfter = function(a) {
            return a instanceof hb && this.h > a.h;
        };
        g.isBefore = function(a) {
            return a instanceof hb && this.h < a.h;
        };
        g.isLeaf = function() {
            return !0;
        };
        g.toSerializableData = function(a) {
            return {
                attributes: [],
                blockClass: F.ContentBlockClass.TEXT,
                blockType: F.TextContentBlockType.TEXT,
                children: [],
                id: this.h,
                locator: a && a.createLocators ? this.getLocator() : null,
                marks: [],
                parentId: null,
                resourceHrefs: [],
                textContent: this.g.str
            };
        };
        function kb(a, b, c) {
            var d = Math.round(a.g.transform[4]), e = Math.round(a.i[3] - (a.g.transform[5] + a.g.height)), f = Math.round(d + a.g.width), k = Math.round(e + a.g.height);
            d -= a.i[0];
            f -= a.i[0];
            var n = d, h = f, p = a.g.str.length;
            if (Q(b) || Q(c)) {
                var l = ib(a.g.str);
                Q(b) && (b = N(b, 0, p), d = ib(a.g.str.slice(0, b)), d = Math.round((f - n) / l * d + n));
                Q(c) && (b = ib(a.g.str.slice(0, N((b || 0) + c, b || 0, p))), f = Math.round((f - n) / l * b + n));
            }
            "rtl" === a.g.dir && (l = (n - h) / (h - n) * (d - n) + h, d = (n - h) / (h - n) * (f - n) + h, f = l);
            e = new DOMRect(d, e, f - d, k - e);
            return [
                Ra(a.A, a.j.getPageNumber(), [
                    e
                ]),
                e
            ];
        }
        var jb = null;
        function lb(a, b, c, d) {
            this.C = a;
            this.g = [];
            b = b.items;
            this.h = a.getSourceContentDocument().getPageNumber();
            for(a = 0; a < b.length; a++)this.g.push(new hb(b[a], a, c, this, d));
        }
        g = lb.prototype;
        g.getContentBlockById = function(a) {
            return 0 <= a && a < this.g.length ? this.g[a] : null;
        };
        g.getContentBlocks = function() {
            return this.g;
        };
        g.getPageNumber = function() {
            return this.h;
        };
        g.getReaderDocument = function() {
            return this.C;
        };
        g.toSerializableData = function(a) {
            return this.g.map(function(b) {
                return b.toSerializableData(a);
            });
        };
        function mb() {
            this.g = [];
            this.h = !1;
        }
        mb.prototype.add = function(a) {
            this.g.includes(a) || (this.g = this.g.concat(a));
        };
        mb.prototype.clear = function() {
            this.g = [];
        };
        function nb(a, b, c) {
            a.h = !0;
            for(var d = a.g, e = 0; e < d.length; e++){
                var f = d[e];
                if (a.g.includes(f)) try {
                    f(b);
                } catch (k) {
                    c(k);
                }
            }
        }
        mb.prototype.remove = function(a) {
            this.g = this.g.filter(function(b) {
                return b !== a;
            });
        };
        mb.prototype.size = function() {
            return this.g.length;
        };
        function Y(a, b) {
            this.j = !0;
            this.h = this.g = a;
            this.i = b || null;
        }
        function ob(a, b) {
            if (null !== a.g) {
                var c = pb(a, b);
                for(a.j = !1; null !== a.g && a.i && !a.i(a.g);)c += pb(a, b);
            }
        }
        Y.prototype.next = function(a) {
            if (this.j && (!this.i || this.i(this.g))) return this.j = !1, this.g;
            ob(this, a);
            return this.g;
        };
        function pb(a, b) {
            var c = a.g, d = 0;
            if (c.firstChild && ("function" === typeof b ? b(c) : b)) a.g = c.firstChild, d = 1;
            else if (c !== a.h && c.nextSibling) a.g = c.nextSibling;
            else {
                for(; c !== a.h && !c.nextSibling;)c = c.parentNode, d--;
                c === a.h ? a.g = null : a.g = c.nextSibling;
            }
            return d;
        }
        var qb = H.event.MouseEngineEvent, rb = H.event.NavigationIntentEngineEvent;
        function sb(a, b, c, d, e, f, k, n) {
            var h = this;
            this.g = a;
            this.j = c;
            this.o = d;
            this.A = e;
            this.C = f;
            this.s = k;
            this.G = n;
            this.i = function(p) {
                var l = Oa(h.A, h.C.getSourceContentDocument());
                l = new V(l, h.C.getReaderPublication(), h.s, {
                    G: h.G,
                    _pageIndex: h.C.getIndexInSpine(),
                    v: {
                        u: 0,
                        m: 0
                    }
                }, null);
                l = {
                    button: p.button,
                    buttons: p.buttons,
                    cancelable: !0,
                    clientX: p.clientX,
                    clientY: p.clientY,
                    ctrlKey: p.ctrlKey,
                    isTrusted: p.isTrusted,
                    mediaResource: null,
                    metaKey: p.metaKey,
                    pageX: p.clientX + window.scrollX,
                    pageY: p.clientY + window.scrollY,
                    readerDocumentEventState: F.ReaderDocumentEventState.DEFAULT_PREVENTED,
                    readerView: h.o.getReaderView(),
                    screenX: p.screenX,
                    screenY: p.screenY,
                    target: {
                        contentLocation: l,
                        frameworkComponent: F.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                        mediaType: "",
                        nodeData: null
                    },
                    userGenerated: p.isTrusted
                };
                var r = new qb("click", l, p);
                r.preventDefault();
                h.o.getReaderView().getReadingSystemEngine().getEventBus().emit(r);
                l = h.g.dest;
                J(l) ? tb(h, Qa(h.A, l), !0, r, !0) : P(l) ? Ta(h.j, l).then(function(u) {
                    u = Ra(h.A, u + 1);
                    tb(h, u, !0, r, !1);
                }).catch(function(u) {
                    B.ColibrioError.isColibrioAbortedError(u) || B.Logger.logError(u);
                }) : h.g.url && (l = h.A.getLocatorFactory().parse(h.g.url).locator) && tb(h, l, !1, r, p.isTrusted);
            };
            (a = b.querySelector('[data-element-id="' + a.id + '"]')) && a.parentElement && (this.h = a.parentElement, this.h.setAttribute("href", "javascript:void(0)"), this.h.addEventListener("click", this.i));
        }
        sb.prototype.destroy = function() {
            var a;
            null == (a = this.h) || a.removeEventListener("click", this.i);
        };
        function ub(a, b, c, d, e, f) {
            var k = a.o.getReaderView().getReadingSystemEngine();
            a = new rb({
                cancelable: !0,
                isTrusted: f,
                locator: b,
                readerDocument: c,
                readerView: a.o.getReaderView(),
                relatedEvent: e,
                sourceReaderDocument: d
            });
            k.getEventBus().emit(a);
        }
        function tb(a, b, c, d, e) {
            c ? a.C.getReaderPublication().fetchUnresolvedContentLocation(b).then(function(f) {
                ub(a, b, f.getReaderDocuments()[0], a.C, d, !1);
            }).catch(function(f) {
                B.ColibrioError.isColibrioAbortedError(f) || B.Logger.logError(f);
            }) : ub(a, b, null, a.C, d, e);
        }
        function vb(a, b, c, d, e, f) {
            c = wb(c, d, e, b.view);
            c = xb(c.left, c.top, c.right, c.bottom, b, a);
            b = c.startPosition;
            c = c.endPosition;
            a = a.getReaderPublication();
            f = Da(f, b, c || void 0);
            return new V(f, a, a.g, b, c);
        }
        function xb(a, b, c, d, e, f) {
            e = e.view;
            f = f.getIndexInSpine();
            e = {
                height: e[3] - e[1],
                width: e[2] - e[0]
            };
            return {
                endPosition: 0 < c - a || 0 < d - b ? {
                    G: e,
                    _pageIndex: f,
                    v: {
                        u: c,
                        m: d
                    }
                } : null,
                startPosition: {
                    G: e,
                    _pageIndex: f,
                    v: {
                        u: a,
                        m: b
                    }
                }
            };
        }
        function wb(a, b, c, d) {
            var e = a.convertToPdfPoint(b.left - c.left, b.top - c.top);
            a = a.convertToPdfPoint(b.right - c.left, b.bottom - c.top);
            return {
                bottom: Math.round(a[1] - d[1]),
                left: Math.round(e[0] - d[0]),
                right: Math.round(a[0] - d[0]),
                top: Math.round(e[1] - d[1])
            };
        }
        function yb(a, b) {
            this.i = a;
            this.h = b;
        }
        function zb(a) {
            a.g = a.h.ownerDocument.createElement("iframe");
            a.g.style.visibility = "hidden";
            a.g.style.left = "-10000px";
            a.g.style.top = "0";
            a.g.style.position = "absolute";
            a.g.srcdoc = "\n                <html>\n                    <head>\n                        <style>\n                          /* CSS to make the image scale when printing */\n                          @media print {\n                            body, html {\n                              width: 100%;\n                              height: 100%;\n                              margin: 0;\n                              padding: 0;\n                              page-break-inside: avoid;\n                            }\n                            img {\n                              width: 100%;\n                              height: 100%;\n                              display: block;\n                              margin: 0 auto;\n                              object-fit: contain; /* scale inside page without cropping */\n                              page-break-inside: avoid;\n                            }\n                          }\n                        </style>\n                    </head>\n                    <body></body>\n                </html>";
            var b = a.h.toDataURL();
            a.g.addEventListener("load", function() {
                if (a.g && a.g.contentDocument) {
                    var c = a.g.contentDocument.createElement("img");
                    c.src = b;
                    c.addEventListener("load", function() {
                        a.g && a.g.contentWindow ? (a.g.contentWindow.print(), B.BrowserDetector.isOS("iOS") || B.BrowserDetector.isOS("macOS") && 1 < navigator.maxTouchPoints || a.destroy()) : a.destroy();
                    });
                    a.g.contentDocument.body.appendChild(c);
                } else a.destroy();
            });
            a.i.appendChild(a.g);
        }
        yb.prototype.destroy = function() {
            this.g && (this.i.removeChild(this.g), this.g = void 0);
        };
        function Ab(a, b) {
            var c = F.VisibleContentRectType.LINE_BOX;
            this.clientRect = a;
            this.contentLocation = b;
            this.nodeData = void 0;
            this.type = c;
        }
        Ab.prototype.toJSON = function() {
            return {
                clientRect: {
                    height: this.clientRect.height,
                    width: this.clientRect.width,
                    x: this.clientRect.x,
                    y: this.clientRect.y
                },
                locator: this.contentLocation.toJSON(),
                nodeData: this.nodeData,
                type: this.type
            };
        };
        function Bb(a, b, c) {
            this.boundingClientRect = a;
            this.contentLocation = b;
            this.rects = c;
        }
        Bb.prototype.toJSON = function() {
            return {
                boundingClientRect: this.boundingClientRect ? {
                    height: this.boundingClientRect.height,
                    width: this.boundingClientRect.width,
                    x: this.boundingClientRect.x,
                    y: this.boundingClientRect.y
                } : null,
                locator: this.contentLocation.getLocator().toJSON(),
                rects: this.rects.map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function Cb(a, b, c) {
            var d = [];
            d = void 0 === d ? [] : d;
            this.i = a;
            this.j = b;
            this.s = c;
            this.g = d;
            this.h = "";
        }
        function Db() {
            var a = B.BrowserDetector.getOsVersion().trim(), b = /^(\d+)(?:\.(\d+))?(?:\.(\d+))?/.exec(a);
            if (!b) return null;
            var c = b.length;
            c = new Cb(1 < c && b[1] ? Number(b[1]) : 0, 2 < c && b[2] ? Number(b[2]) : 0, 3 < c && b[3] ? Number(b[3]) : 0);
            var d;
            if (d = a.length > b[0].length) {
                a: {
                    a = a.slice(b[0].length);
                    if ("+" === a[0]) c.h = a.slice(1);
                    else if ("-" === a[0]) for(b = a.indexOf("+"), -1 !== b ? (c.h = a.slice(b + 1), a = a.slice(1, b)) : a = a.slice(1), a = a.split("."), b = 0; b < a.length; b++)if (d = a[b], /^[0-9]+$/.test(d)) c.g.push(Number(d));
                    else if (/^[0-9A-Za-z]+$/.test(d)) c.g.push(d);
                    else {
                        c.g = [];
                        a = !1;
                        break a;
                    }
                    a = !0;
                }
                d = !a && !1;
            }
            return d ? null : c;
        }
        Cb.prototype.compareTo = function(a) {
            var b = this.i - a.i;
            if (0 !== b) return b;
            b = this.j - a.j;
            if (0 !== b) return b;
            b = this.s - a.s;
            if (0 !== b) return b;
            b = this.g.length;
            var c = a.g.length;
            if (0 === b && 0 < c) return 1;
            if (0 < b && 0 === c) return -1;
            for(var d = Math.min(b, c), e = 0; e < d; e++){
                var f = this.g[e], k = a.g[e], n = Q(f), h = Q(k);
                if (n && !h) return -1;
                if (!n && h) return 1;
                if (f < k) return -1;
                if (f > k) return 1;
            }
            return b - c;
        };
        Cb.prototype.toString = function() {
            return this.i + "." + this.j + "." + this.s + (0 < this.g.length ? "-" + this.g.join(".") : "") + (this.h ? "+" + this.h : "");
        };
        var Eb = H.event.MouseEngineEvent;
        function Fb(a, b, c, d, e, f) {
            this.D = a;
            this.pa = b;
            this.A = c;
            this.l = d;
            this.o = e;
            this.C = f;
            this.za = [];
            this.Ta = function() {};
            d.document.documentElement.addEventListener("click", this, !1);
            d.document.documentElement.addEventListener("dblclick", this, !1);
            if (B.BrowserDetector.isOS("iOS")) {
                if (a = Db(), d = ra(d.document), a && 12 >= a.i) for(d = d.firstElementChild; d;)d.addEventListener("click", this.Ta, !1), this.za.push(d), d = d.nextElementSibling;
                else if (d = d.firstElementChild) d.addEventListener("click", this.Ta, !1), this.za.push(d);
            }
        }
        Fb.prototype.destroy = function() {
            var a = this;
            this.za.forEach(function(d) {
                return d.removeEventListener("click", a.Ta, !1);
            });
            this.za = [];
            var b, c;
            "function" === typeof (null == (b = this.l.document) ? void 0 : null == (c = b.documentElement) ? void 0 : c.removeEventListener) && (this.l.document.documentElement.removeEventListener("click", this, !1), this.l.document.documentElement.removeEventListener("dblclick", this, !1));
        };
        Fb.prototype.handleEvent = function(a) {
            if ("click" === a.type || "dblclick" === a.type) {
                var b = a.type, c = vb(this.C, this.D, this.pa, {
                    bottom: a.pageY,
                    height: 0,
                    left: a.pageX,
                    right: a.pageX,
                    top: a.pageY,
                    width: 0
                }, this.l.document.documentElement.getBoundingClientRect(), this.A), d = this.l.frameElement.getBoundingClientRect();
                a = {
                    button: a.button,
                    buttons: a.buttons,
                    cancelable: !0,
                    clientX: a.clientX + d.left,
                    clientY: a.clientY + d.top,
                    ctrlKey: a.ctrlKey,
                    isTrusted: a.isTrusted,
                    mediaResource: null,
                    metaKey: a.metaKey,
                    pageX: a.clientX + d.left + window.scrollX,
                    pageY: a.clientY + d.top + window.scrollY,
                    readerDocumentEventState: a.defaultPrevented ? F.ReaderDocumentEventState.DEFAULT_PREVENTED : F.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: this.o.getReaderView(),
                    screenX: a.screenX,
                    screenY: a.screenY,
                    target: {
                        contentLocation: c,
                        frameworkComponent: F.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                        mediaType: "",
                        nodeData: null
                    },
                    userGenerated: a.isTrusted
                };
                this.o.getReaderView().getReadingSystemEngine().getEventBus().emit(new Eb(b, a, null));
            }
        };
        function Gb(a, b, c) {
            this.l = a;
            this.yb = b;
            this.Oa = c;
            a.document.addEventListener("copy", this, !1);
        }
        Gb.prototype.destroy = function() {
            this.l.document.removeEventListener("copy", this, !1);
        };
        Gb.prototype.handleEvent = function(a) {
            this.yb.dispatchClipboardEvent(a);
            var b = this.Oa.allowCopy, c = this.Oa.textToAppendOnCopy, d = this.Oa.textToPrependOnCopy;
            a.cancelable && (!b || c || d) && a.preventDefault();
            b && (d || c) && a.clipboardData && (b = this.l.document.getSelection()) && (a.clipboardData.setData("text/plain", (d || "") + (-1 < b.toString().indexOf(" ") ? b.toString() : b.getRangeAt(0).toString()) + (c || "")), a.preventDefault());
        };
        function Hb(a) {
            this.Qa = a;
            a.addEventListener("contextmenu", this, !0);
        }
        Hb.prototype.destroy = function() {
            this.Qa.removeEventListener("contextmenu", this, !0);
        };
        Hb.prototype.handleEvent = function(a) {
            a.preventDefault();
        };
        function Ib(a) {
            this.Qa = a;
            a.addEventListener("dragstart", this, !0);
        }
        Ib.prototype.destroy = function() {
            this.Qa.removeEventListener("dragstart", this, !0);
        };
        Ib.prototype.handleEvent = function(a) {
            a.cancelable && a.preventDefault();
        };
        function Jb(a, b, c) {
            this.l = a;
            this.o = b;
            this.C = c;
            a.addEventListener("keydown", this, !1);
            a.addEventListener("keyup", this, !1);
        }
        Jb.prototype.handleEvent = function(a) {
            var b = {
                contentLocation: this.C.getContentLocation(),
                frameworkComponent: F.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                mediaType: "",
                nodeData: null
            }, c = a.defaultPrevented ? F.ReaderDocumentEventState.DEFAULT_PREVENTED : F.ReaderDocumentEventState.NOT_PROCESSED;
            this.o.getEngineEventDispatcher().dispatchKeyboardEvent(a, b, c, a.isTrusted);
        };
        Jb.prototype.destroy = function() {
            this.l.removeEventListener("keydown", this, !1);
            this.l.removeEventListener("keyup", this, !1);
        };
        var Kb = H.event.PointerEngineEvent;
        function Lb(a, b, c, d, e, f, k) {
            this.D = a;
            this.pa = b;
            this.A = c;
            this.l = d;
            this.o = e;
            this.C = f;
            this.B = k;
            this.ha = this.aa = this.oa = null;
            this.Ba = 0;
            this.$ = !1;
            this.T = 0;
            this.Da = null;
            this.ib = function(n) {
                n.cancelable && 2 <= n.touches.length && n.preventDefault();
            };
            this.Fa = "ontouchstart" in d;
            this.R = e.getReaderViewOptions().emitPointerMoveEventsOnHover;
            if (this.Fa && B.BrowserDetector.isOS("iOS")) for(this.oa = qa(d.document), d.document.body.appendChild(this.oa), a = d.document.body.childNodes, b = 0; b < a.length; b++)c = a[b], 1 === c.nodeType && c.addEventListener("touchmove", this.ib);
        }
        g = Lb.prototype;
        g.handleEvent = function(a) {
            switch(a.type){
                case "touchstart":
                    0 === this.T && (this.l.addEventListener("touchmove", this, !1), this.l.addEventListener("touchend", this, !1), this.l.addEventListener("touchcancel", this, !1));
                    this.T += a.changedTouches.length;
                    this.ha = a;
                    this.Ba = Date.now();
                    Mb(this, "pointerdown", a, Nb(this, a));
                    this.$ && this.aa && Ob(this, "pointercancel", this.aa, null);
                    break;
                case "touchmove":
                    if (0 < this.T) {
                        this.ha = a;
                        var b = this.B.includeContentLocationInPointerMoveEvents ? Nb(this, a) : null;
                        Mb(this, "pointermove", a, b);
                    }
                    this.Ba = Date.now();
                    break;
                case "touchend":
                case "touchcancel":
                    "touchend" === a.type ? Mb(this, "pointerup", a, Nb(this, a)) : Mb(this, "pointercancel", a, null);
                    this.T = Math.max(0, this.T - a.changedTouches.length);
                    this.ha = a;
                    this.Ba = Date.now();
                    0 === this.T && Pb(this);
                    break;
                case "mousedown":
                    0 === this.T && 1E3 < Date.now() - this.Ba && (this.R || this.l.addEventListener("mousemove", this, !1), this.l.addEventListener("mouseup", this, !1), this.$ = !0, this.aa = a, Ob(this, "pointerdown", a, this.getContentLocation(a)));
                    break;
                case "mousemove":
                    this.$ && (this.aa = a);
                    if (this.$ || this.R) b = this.B.includeContentLocationInPointerMoveEvents ? this.getContentLocation(a) : null, Ob(this, "pointermove", a, b);
                    break;
                case "mouseup":
                    this.$ && (Ob(this, "pointerup", a, this.getContentLocation(a)), Rb(this));
                    break;
                case "dragstart":
                    this.$ && this.aa && (Ob(this, "pointercancel", this.aa, null), Rb(this));
            }
        };
        g.rb = function() {
            if (this.Fa && B.BrowserDetector.isOS("iOS")) {
                if (this.l.document) for(var a = this.l.document.body.childNodes, b = 0; b < a.length; b++){
                    var c = a[b];
                    1 === c.nodeType && c.removeEventListener("touchmove", this.ib);
                }
                this.oa && (R(this.oa), this.oa = null);
            }
        };
        g.Ua = function() {
            this.Fa && (this.l.removeEventListener("touchstart", this, !1), 0 < this.T && (this.ha && Mb(this, "pointercancel", this.ha, null, !0), Pb(this)));
            this.R && this.l.removeEventListener("mousemove", this, !1);
            this.l.removeEventListener("mousedown", this, !1);
            this.l.removeEventListener("dragstart", this, !1);
            this.$ && Rb(this);
        };
        g.Va = function() {
            var a = this;
            this.Fa && (this.l.addEventListener("touchstart", this, !1), this.l.setTimeout(function() {
                a.l.document.documentElement.ontouchstart = function() {};
            }, 0));
            this.R && this.l.addEventListener("mousemove", this, !1);
            this.l.addEventListener("mousedown", this, !1);
            this.l.addEventListener("dragstart", this, !1);
        };
        function Ob(a, b, c, d) {
            var e = a.l.frameElement.getBoundingClientRect(), f = e.width / a.l.innerWidth;
            c = {
                button: c.button,
                buttons: c.buttons,
                cancelable: !0,
                clientX: f * c.clientX + e.left,
                clientY: f * c.clientY + e.top,
                ctrlKey: c.ctrlKey,
                isPrimary: 0 === c.button,
                isTrusted: c.isTrusted,
                mediaResource: null,
                metaKey: c.metaKey,
                pageX: f * c.clientX + e.left + window.scrollX,
                pageY: f * c.clientY + e.top + window.scrollY,
                pointerId: -1,
                pointerType: "mouse",
                readerDocumentEventState: F.ReaderDocumentEventState.NOT_PROCESSED,
                readerView: a.o.getReaderView(),
                screenX: c.screenX,
                screenY: c.screenY,
                target: {
                    contentLocation: d,
                    frameworkComponent: F.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                    mediaType: "",
                    nodeData: null
                },
                userGenerated: c.isTrusted
            };
            a.o.getReaderView().getReadingSystemEngine().getEventBus().emit(new Kb(b, c, null));
        }
        function Mb(a, b, c, d, e) {
            e = e ? c.targetTouches : c.changedTouches;
            for(var f = a.l.frameElement.getBoundingClientRect(), k = f.width / a.l.innerWidth, n = 0; n < e.length; n++){
                var h = e.item(n);
                null === a.Da && (a.Da = h.identifier);
                h = {
                    button: 0,
                    buttons: 1,
                    cancelable: !0,
                    clientX: k * h.clientX + f.left,
                    clientY: k * h.clientY + f.top,
                    ctrlKey: c.ctrlKey,
                    isPrimary: a.Da === h.identifier,
                    isTrusted: c.isTrusted,
                    mediaResource: null,
                    metaKey: c.metaKey,
                    pageX: k * h.clientX + f.left + window.scrollX,
                    pageY: k * h.clientY + f.top + window.scrollY,
                    pointerId: h.identifier,
                    pointerType: "touch",
                    readerDocumentEventState: F.ReaderDocumentEventState.NOT_PROCESSED,
                    readerView: a.o.getReaderView(),
                    screenX: h.screenX,
                    screenY: h.screenY,
                    target: {
                        contentLocation: d,
                        frameworkComponent: F.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                        mediaType: "",
                        nodeData: null
                    },
                    userGenerated: c.isTrusted
                };
                a.C.getReaderPublication().getReadingSystemEngine().getEventBus().emit(new Kb(b, h, null));
            }
        }
        g.getContentLocation = function(a) {
            return vb(this.C, this.D, this.pa, {
                bottom: a.pageY,
                height: 0,
                left: a.pageX,
                right: a.pageX,
                top: a.pageY,
                width: 0
            }, this.l.document.documentElement.getBoundingClientRect(), this.A);
        };
        function Nb(a, b) {
            return 0 === b.changedTouches.length ? null : a.getContentLocation(b.changedTouches[0]);
        }
        function Rb(a) {
            a.R || a.l.removeEventListener("mousemove", a, !1);
            a.l.removeEventListener("mouseup", a, !1);
            a.$ = !1;
            a.aa = null;
        }
        function Pb(a) {
            a.l.removeEventListener("touchmove", a, !1);
            a.l.removeEventListener("touchend", a, !1);
            a.l.removeEventListener("touchcancel", a, !1);
            a.T = 0;
            a.Da = null;
            a.ha = null;
        }
        var Sb = H.event.PointerEngineEvent;
        function Tb(a, b, c, d, e, f, k) {
            this.D = a;
            this.pa = b;
            this.A = c;
            this.l = d;
            this.o = e;
            this.C = f;
            this.B = k;
            this.P = new Map;
            a = [];
            B.RuntimePlatform.isCssDeclarationSupported("touch-action", "pan-x") ? (e = e.getRendererRuntime(), e.isNativePanXAllowed() && a.push("pan-x"), e.isNativePanYAllowed() && a.push("pan-y"), 0 === a.length && a.push("none")) : a.push("manipulation");
            0 < a.length && (d.document.documentElement.style.touchAction = a.join(" "));
            d = this.o.getReaderViewOptions();
            this.zb = d.gestureOptions.swipeNavigation.pointerTypes.mouse;
            this.R = d.emitPointerMoveEventsOnHover;
        }
        g = Tb.prototype;
        g.handleEvent = function(a) {
            var b = 1 === a.buttons, c = "mouse" === a.pointerType && this.zb;
            switch(a.type){
                case "pointerdown":
                    0 === this.P.size && (this.R || this.l.addEventListener("pointermove", this, !1), this.l.addEventListener("pointerup", this, !1), this.l.addEventListener("pointercancel", this, !1));
                    var d = this.l.document.getSelection();
                    if (c && b || "mouse" !== a.pointerType) {
                        if (!d || d.isCollapsed) ma(a.target) ? a.target.setPointerCapture(a.pointerId) : this.l.document.documentElement.setPointerCapture(a.pointerId);
                    }
                    this.P.set(a.pointerId, a);
                    a.cancelable && 2 <= this.P.size && a.preventDefault();
                    Ub(this, a.type, a, this.getContentLocation(a));
                    break;
                case "pointermove":
                    a.cancelable && 2 <= this.P.size && a.preventDefault();
                    b = this.R;
                    this.P.has(a.pointerId) && (this.P.set(a.pointerId, a), b = !0);
                    b && (b = this.B.includeContentLocationInPointerMoveEvents ? this.getContentLocation(a) : null, Ub(this, a.type, a, b));
                    break;
                case "pointerup":
                case "pointercancel":
                    a.cancelable && 2 <= this.P.size && a.preventDefault();
                    try {
                        if (c || "mouse" !== a.pointerType) ma(a.target) ? a.target.releasePointerCapture(a.pointerId) : this.l.document.documentElement.releasePointerCapture(a.pointerId);
                    } catch (e) {}
                    this.P.delete(a.pointerId) && ("pointerup" === a.type ? Ub(this, a.type, a, this.getContentLocation(a)) : Ub(this, a.type, a, null));
                    0 === this.P.size && Vb(this);
            }
        };
        g.rb = function() {
            this.R && this.l.removeEventListener("pointermove", this, !1);
        };
        g.Ua = function() {
            var a = this;
            this.l.removeEventListener("pointerdown", this, !1);
            0 < this.P.size && (this.P.forEach(function(b) {
                Ub(a, "pointercancel", b, null);
            }), Vb(this), this.P.clear());
        };
        g.Va = function() {
            this.l.addEventListener("pointerdown", this, !1);
            this.R && this.l.addEventListener("pointermove", this, !1);
        };
        function Ub(a, b, c, d) {
            var e = a.l.frameElement.getBoundingClientRect(), f = e.width / a.l.innerWidth;
            c = {
                button: c.button,
                buttons: c.buttons,
                cancelable: !0,
                clientX: f * c.clientX + e.left,
                clientY: f * c.clientY + e.top,
                ctrlKey: c.ctrlKey,
                isPrimary: c.isPrimary,
                isTrusted: c.isTrusted,
                mediaResource: null,
                metaKey: c.metaKey,
                pageX: f * c.clientX + e.left + window.scrollX,
                pageY: f * c.clientY + e.top + window.scrollY,
                pointerId: c.pointerId,
                pointerType: c.pointerType,
                readerDocumentEventState: F.ReaderDocumentEventState.NOT_PROCESSED,
                readerView: a.o.getReaderView(),
                screenX: c.screenX,
                screenY: c.screenY,
                target: {
                    contentLocation: d,
                    frameworkComponent: F.EngineEventTargetFrameworkComponent.READER_DOCUMENT,
                    mediaType: "",
                    nodeData: null
                },
                userGenerated: c.isTrusted
            };
            b = new Sb(b, c, null);
            a.o.getReaderView().getReadingSystemEngine().getEventBus().emit(b);
        }
        g.getContentLocation = function(a) {
            return vb(this.C, this.D, this.pa, {
                bottom: a.pageY,
                height: 0,
                left: a.pageX,
                right: a.pageX,
                top: a.pageY,
                width: 0
            }, this.l.document.documentElement.getBoundingClientRect(), this.A);
        };
        function Vb(a) {
            a.R || a.l.removeEventListener("pointermove", a, !1);
            a.l.removeEventListener("pointerup", a, !1);
            a.l.removeEventListener("pointercancel", a, !1);
        }
        var Wb = H.event.SelectionChangedEngineEvent;
        function Xb(a, b, c, d, e, f) {
            this.g = a;
            this.ba = b;
            this.D = c;
            this.j = d;
            this.o = e;
            this.A = f;
            this.i = 0;
            a.addEventListener("selectionchange", this);
            a.addEventListener("selectstart", this);
            this.h = e.getReaderViewProperty("contentSelectionEnabled");
            e.addReaderViewPropertyChangedListener("clearContentSelection", this);
            e.addReaderViewPropertyChangedListener("contentSelectionEnabled", this);
        }
        Xb.prototype.destroy = function() {
            this.g.removeEventListener("selectionchange", this);
            this.g.removeEventListener("selectstart", this);
            this.clearContentSelection();
            this.o.removeReaderViewPropertyChangedListener("clearContentSelection", this);
            this.o.removeReaderViewPropertyChangedListener("contentSelectionEnabled", this);
        };
        Xb.prototype.handleEvent = function(a) {
            if ("selectstart" === a.type) a.cancelable && !this.h && a.preventDefault();
            else if ("selectionchange" === a.type) {
                if (this.i) this.i--;
                else if ((a = this.g.getSelection()) && 0 < a.rangeCount) {
                    a = a.getRangeAt(0);
                    for(var b = [], c = a.getClientRects(), d = 0; d < c.length; d++){
                        var e = c[d];
                        0 < e.width && 0 < e.height && 2E4 > d && b.push(e);
                    }
                    0 === b.length && b.push(a.getBoundingClientRect());
                    c = this.ba.getReaderDocument();
                    d = this.D;
                    for(var f = this.j, k = this.g.documentElement.getBoundingClientRect(), n = this.A, h = c.getIndexInSpine() + 1, p = [], l = e = 0, r = 0, u = 0, z = 0; z < b.length; z++){
                        var x = wb(f, b[z], k, d.view);
                        if (x.top < r || x.top === r && x.left < e) r = x.top, e = x.left;
                        if (x.bottom > u || x.bottom === u && x.right > l) u = x.bottom, l = x.right;
                        x = new DOMRect(x.left, x.top, x.right - x.left, x.bottom - x.top);
                        p.push(x);
                    }
                    b = Ra(n, h, p);
                    e = xb(e, r, l, u, d, c);
                    d = e.startPosition;
                    e = e.endPosition;
                    c = c.getReaderPublication();
                    c = new V(b, c, c.g, d, e);
                    b = !a.collapsed;
                    d = this.o.getReaderView();
                    if (I(a.startContainer) && a.endContainer === a.startContainer) a = a.startContainer.data.slice(a.startOffset, a.endOffset).trim();
                    else {
                        e = [];
                        l = null;
                        u = r = !1;
                        ma(a.startContainer) ? (f = a.startContainer.childNodes, 0 === f.length ? f = new Y(a.startContainer) : a.startOffset < f.length ? f = new Y(f[a.startOffset]) : (f = new Y(f[f.length - 1]), u = !0)) : I(a.startContainer) ? (e.push(a.startContainer.data.slice(a.startOffset).trim()), f = new Y(a.startContainer), u = !0) : f = new Y(a.startContainer);
                        ma(a.endContainer) ? (k = a.endContainer.childNodes, 0 === k.length || a.endOffset === k.length ? l = a.endContainer : a.endOffset < k.length ? l = k[a.endOffset] : l = a.endContainer, f.h = l) : I(a.endContainer) ? (l = a.endContainer, f.h = l, r = !0) : (l = a.endContainer, f.h = l);
                        for(u && ob(f, !1); f.g && f.g !== l;)I(f.g) && e.push(f.g.data.trim()), ob(f, !0);
                        r && e.push(a.endContainer.data.slice(0, a.endOffset).trim());
                        a = e.join(" ");
                    }
                    a = new Wb({
                        contentLocation: c,
                        isRange: b,
                        readerView: d,
                        selectionText: a
                    });
                    this.o.onSelectionChanged(a, this);
                }
            }
        };
        Xb.prototype.onReaderViewPropertyChanged = function(a, b) {
            "contentSelectionEnabled" === a ? (this.h = b) || this.clearContentSelection() : "clearContentSelection" === a && this.clearContentSelection();
        };
        Xb.prototype.clearContentSelection = function() {
            var a = this.g.getSelection();
            a && 0 < a.rangeCount && (this.i++, a.removeAllRanges());
        };
        function Yb(a, b) {
            this.g = a;
            this.o = b;
            a = null !== this.o.getReaderViewProperty("activeTransform");
            Zb(this, a);
            this.o.addReaderViewPropertyChangedListener("activeTransform", this);
        }
        Yb.prototype.destroy = function() {
            this.o.removeReaderViewPropertyChangedListener("activeTransform", this);
        };
        Yb.prototype.onReaderViewPropertyChanged = function(a, b) {
            "activeTransform" === a && Zb(this, null !== b);
        };
        function Zb(a, b) {
            a = a.g.documentElement.classList;
            b ? a.add("colibrio-readerview--transform-manager-active") : a.remove("colibrio-readerview--transform-manager-active");
        }
        function $b(a, b, c, d, e, f, k, n, h, p, l) {
            this.Ca = a;
            this.ba = b;
            this.D = c;
            this.o = d;
            this.S = e;
            this.A = n;
            this.B = h;
            this.Ab = p;
            this.K = l;
            this.gb = new fa.BlobUrlManager;
            this.Pa = this.xa = this.wa = null;
            this.O = !1;
            this.ya = null;
            this.Ra = !1;
            this.ca = this.Ea = this.U = this.Aa = null;
            this.kb = this.jb = !1;
            this.Ga = this.Sa = null;
            this.Ia = !1;
            a = document.createElement("iframe");
            b = e.height;
            e = e.width;
            a.classList.add("colibrio-pdf-renderable-page-text-layer-iframe");
            a.setAttribute("tabindex", "-1");
            a.setAttribute("aria-hidden", "true");
            a.width = e + "px";
            a.height = b + "px";
            a.style.width = e + "px";
            a.style.height = b + "px";
            a.addEventListener("load", this, !0);
            this.J = a;
            c = document.createElement("div");
            c.setAttribute("role", "document");
            c.classList.add("colibrio-pdf-renderable-page-text-layer-iframe-container");
            c.style.width = e + "px";
            c.style.height = b + "px";
            c.style.top = f + "px";
            c.style.left = k + "px";
            c.appendChild(a);
            this.hb = c;
            "srcdoc" in a ? a.srcdoc = ac(this) : a.src = "data:text/html," + ac(this);
            this.setVisible(!1);
        }
        $b.prototype.destroy = function() {
            this.O = !0;
            this.gb.revokeAllUrls();
            this.Ea && (this.Ea.destroy(), this.Ea = null);
            this.U && (this.Ia && this.U.Ua(), this.U.rb(), this.U = null);
            this.xa && (this.xa.destroy(), this.xa = null);
            this.wa && (this.wa.destroy(), this.wa = null);
            this.Aa && (this.Aa.destroy(), this.Aa = null);
            this.ya && (this.ya.destroy(), this.ya = null);
            this.Ga && (this.Ga.destroy(), this.Ga = null);
            this.Pa && this.Pa.destroy();
            this.J.removeEventListener("load", this, !0);
            R(this.hb);
            this.ca = null;
            var a;
            null == (a = this.Sa) || a.cancel();
        };
        $b.prototype.handleEvent = function(a) {
            "load" === a.type && bc(this);
        };
        function cc(a, b) {
            var c = a.J.contentDocument;
            c && a.Ra ? dc(a, c, b).then(function() {
                a.O || ec(a, a.J, c);
            }).catch(function(d) {
                B.ColibrioError.isColibrioAbortedError(d) || B.Logger.logError(d);
            }) : a.ca = b;
        }
        $b.prototype.setVisible = function(a) {
            this.J.style.visibility = a ? "visible" : "hidden";
            this.Ia = a;
            this.U && (a ? this.U.Va() : this.U.Ua());
            this.Ra && this.J.contentDocument && this.jb && ec(this, this.J, this.J.contentDocument);
        };
        function dc(a, b, c) {
            if (a.kb || a.O) return Promise.reject(new S(B.ColibrioErrorType.ABORTED));
            a.kb = !0;
            a.Ea = new Xb(b, a.ba, a.D, a.S.clone({
                dontFlip: 0 === a.S.rotation % 180
            }), a.o, a.A);
            b = b.querySelector(".colibrio-pdf-renderable-page-text-layer");
            c = {
                container: b,
                textContentSource: c,
                viewport: a.S
            };
            b.style.setProperty("--scale-factor", a.S.scale.toString());
            a.Sa = new a.Ca.TextLayer(c);
            return a.Sa.render().then(function() {
                a.O || (a.jb = !0, a.Ab());
            });
        }
        function ac(a) {
            var b = B.BrowserDetector.isOS("iOS"), c = a.B.textLayerOptions.customCss;
            a = c ? a.gb.createUrl([
                c
            ], fa.MediaType.TEXT_CSS, !1) : null;
            return '<!DOCTYPE html>\n<html lang="en" style="padding: 0; margin: 0; background-color: transparent">\n<head>\n<meta charset="UTF-8" />\n<meta name="viewport" content="width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,user-scalable=no">\n<style>body,html{-webkit-tap-highlight-color:transparent;background-color:transparent;height:100%;margin:0;overflow:hidden;padding:0;width:100%}.colibrio-pdf-renderable-page-text-layer{text-rendering:optimizeSpeed}.colibrio-pdf-renderable-page-text-layer ::-moz-selection{background-color:orchid;color:transparent}.colibrio-pdf-renderable-page-text-layer ::selection{background-color:orchid;color:transparent}.colibrio-pdf-renderable-page-text-layer br::-moz-selection{background-color:transparent}.colibrio-pdf-renderable-page-text-layer br::selection{background-color:transparent}.colibrio-pdf-renderable-page-text-layer *{color:transparent;cursor:text;position:absolute;-webkit-transform-origin:0 0;transform-origin:0 0;white-space:pre}.colibrio-pdf-renderable-page-annotation-layer{color:transparent;left:0;line-height:1;overflow:hidden;pointer-events:none;position:absolute;top:0}.colibrio-pdf-renderable-page-annotation-layer>*{cursor:pointer;pointer-events:auto;position:absolute}</style>\n' + (a ? '<link rel="stylesheet" href="' + a.url + '" />' : "") + "\n<title>" + (b ? "Page text" : "") + '</title>\n</head>\n<body >\n    <div class="colibrio-pdf-renderable-page-text-layer"></div>\n</body>\n</html>\n';
        }
        function bc(a) {
            if (!a.O) {
                a.Ra = !0;
                var b = a.S.clone({
                    dontFlip: !0
                }), c = a.J.contentWindow;
                if (c) {
                    var d = a.o.getReaderView().getReadingSystemEngine();
                    !H.ReadingSystemUtils.isTouchEventsForced(d) && "onpointerdown" in c ? a.U = new Tb(a.D, b, a.A, c, a.o, a.ba.getReaderDocument(), a.B) : a.U = new Lb(a.D, b, a.A, c, a.o, a.ba.getReaderDocument(), a.B);
                    a.Ia && a.U.Va();
                    a.wa = new Fb(a.D, b, a.A, c, a.o, a.ba.getReaderDocument());
                    a.Aa = new Jb(c, a.o, a.ba.getReaderDocument());
                    a.Ga = new Yb(c.document, a.o);
                    a.xa = new Gb(c, a.o.getEngineEventDispatcher(), a.B.clipboardOptions);
                    a.B.preventDefaultContextMenu && (a.Pa = new Hb(c.document.documentElement));
                    a.B.preventDragAndDropActions && (a.ya = new Ib(c.document.documentElement));
                    a.K && c.document.body.appendChild(a.K);
                }
                if (a.J.contentDocument && a.ca) {
                    var e = a.J.contentDocument;
                    dc(a, e, a.ca).then(function() {
                        a.O || ec(a, a.J, e);
                    }).catch(function(f) {
                        B.ColibrioError.isColibrioAbortedError(f) || B.Logger.logError(f);
                    });
                }
            }
        }
        function ec(a, b, c) {
            c.body && (a.Ia ? (b.setAttribute("tabindex", "0"), c.body.setAttribute("tabindex", "-1"), b.removeAttribute("aria-hidden")) : (b.setAttribute("tabindex", "-1"), c.body.removeAttribute("tabindex"), b.setAttribute("aria-hidden", "true")));
        }
        var fc = 96 / 72;
        function gc(a, b, c, d, e, f, k, n, h, p) {
            var l = this;
            this.C = a;
            this.wb = b;
            this.vb = c;
            this.D = d;
            this.tb = e;
            this.A = f;
            this.o = k;
            this.B = n;
            this.La = h;
            this.xb = p;
            this.i = this.K = this.ea = null;
            this.ja = !1;
            this.H = this.g = this.F = null;
            this.Ma = this.ka = !1;
            this.Na = 0;
            this.bb = !1;
            this.fa = [];
            this.ra = this.qa = 0;
            this.N = this.la = this.sa = null;
            this.ma = this.ta = !1;
            this.h = F.RenderableState.CREATED;
            this.ua = new mb;
            this.S = this.s = this.va = this.j = null;
            this.ga = !1;
            this.I = null;
            this.cb = function(r) {
                l.j && (pa(r, {
                    height: l.G ? l.G.height + "px" : "100%",
                    left: l.qa + "px",
                    position: "absolute",
                    top: l.ra + "px",
                    width: l.G ? l.G.width + "px" : "100%"
                }), l.j.appendChild(r));
            };
            this.fb = function() {
                hc(l, l.h, l.ja, !0);
            };
            this.Ca = a.getSourceContentDocument().getPublication()._getPdfJs();
            this.Z = this.C.getSourceContentDocument().getPageSpreadSlot();
        }
        function ic(a, b, c) {
            return new DOMRect(a.left * b + c.left, a.top * b + c.top, a.width * b, a.height * b);
        }
        g = gc.prototype;
        g.addOverflowingElementScrolledListener = function() {};
        g.addStateChangeListener = function(a) {
            this.h !== F.RenderableState.DESTROYED && this.ua.add(a);
        };
        g.createOverlayElement = function(a) {
            var b = this.o.getReaderView().getElement();
            b = (b ? b.ownerDocument : document).createElement("div");
            pa(b, a);
            b.setAttribute("role", "presentation");
            this.fa.push(b);
            this.cb(b);
            return b;
        };
        g.destroy = function() {
            this.h === F.RenderableState.VISIBLE && this.setVisible(!1);
            this.h === F.RenderableState.ATTACHED_TO_DOM && this.remove();
            if (this.h === F.RenderableState.CREATED) {
                jc(this, F.RenderableState.DESTROYED);
                this.fa = [];
                this.i && (this.i = null);
                this.g && (this.g = null);
                this.N && !this.ta && this.N.cancel();
                this.N = null;
                this.H && !this.ka && this.H.cancel();
                this.F = this.H = null;
                if (this.ea) {
                    for(var a = 0; a < this.ea.length; a++)this.ea[a].destroy();
                    this.ea = null;
                }
                this.va = this.sa = null;
                this.ua.clear();
                this.xb();
            }
        };
        g.destroyOverlayElement = function(a) {
            var b = this.fa.indexOf(a);
            -1 !== b && (this.fa.splice(b, 1), R(a));
        };
        g.fetchContentLocationByTopOffset = function() {
            return Promise.resolve(this.C.getContentLocation());
        };
        g.fetchContentRangeByTopOffsets = function() {
            return Promise.resolve(this.getRangeContentLocation());
        };
        g.fetchContentRangesByTopOffsets = function() {
            return Promise.resolve({
                next: null,
                previous: null,
                visible: this.getRangeContentLocation()
            });
        };
        g.fetchOverlayRectsForContentLocation = function(a) {
            var b = this, c, d, e, f;
            return m.L(function(k) {
                if (1 == k.g) return c = [], d = !1, e = null, a instanceof Ia ? q(k, a.resolve(), 3) : (a instanceof V && (e = a), k.V(2));
                2 != k.g && (e = k.h);
                e && b.I && (f = kc(b, e), !M(f) && 0 < f.length && (c.push.apply(c, m.lb(f)), d = 1 === c.length && (0 === c[0].width || 0 === c[0].height)));
                return k.return({
                    collapsed: d,
                    rects: c
                });
            });
        };
        g.fetchRectsForVisibleContent = function(a) {
            var b = this, c, d, e, f, k, n, h, p, l, r;
            return m.L(function(u) {
                d = null == (c = b.s) ? void 0 : c.J;
                if (b.j && b.I && d && d.contentDocument && (e = sa(d.getBoundingClientRect()), f = d.contentDocument.documentElement.getBoundingClientRect(), k = Math.min(e.width / f.width, e.height / f.height), n = b.getBoundingClientRect(a))) {
                    h = sa(n);
                    var z = d.contentDocument, x = e, A = h, xa = b.I, D = new Y(ra(z), na);
                    z = sa(z.documentElement.getBoundingClientRect());
                    for(var K = new Range, T = [], v, L = new DOMRect(0, 0, 0, 0); v = D.next(!0);){
                        var w = K;
                        w.setStart(v, 0);
                        w.setEnd(v, v.data.length);
                        w = sa(w.getBoundingClientRect());
                        v = w.left < A.right && w.right > A.left;
                        var G = 0 === A.width;
                        if (w.top >= A.top - 5 && w.bottom <= A.bottom + 5 && v) {
                            if (w.left < A.left || w.right > A.right) v = N(w.left, A.left, A.right), G = N(w.top, A.top, A.bottom), w = new DOMRect(v, G, N(w.right, A.left, A.right) - v, N(w.bottom, A.top, A.bottom) - G);
                            v = w;
                            w = b.getContentLocation(v, z, xa);
                            G = v = ic(v, k, x);
                            var ka = w, la = .3 * v.height, Qb = .3 * L.height;
                            if (v.top - la <= L.top && v.bottom + la >= L.bottom || L.top - Qb <= v.top && L.bottom + Qb >= v.bottom) {
                                if (L = T.pop()) G = L.clientRect, ka = Math.min(G.left, v.left), la = Math.min(G.top, v.top), G = new DOMRect(ka, la, Math.max(G.right, v.right) - ka, Math.max(G.bottom, v.bottom) - la), ka = L.contentLocation.createRangeTo(w);
                            }
                            T.push(new Ab(G, ka));
                            L = G;
                        } else {
                            if (v = G) v = A.bottom + 5, v = w.bottom > A.top + 5 && w.right > A.left && w.top < v && w.left < A.right;
                            v && (v = new DOMRect(w.x, w.y, 0, w.height), w = ic(v, k, x), v = b.getContentLocation(v, z, xa), T.push(new Ab(w, v)));
                        }
                    }
                    p = T;
                    l = 0 < p.length ? ic(h, k, e) : null;
                    r = new Bb(l, a, p);
                    return u.return(Promise.resolve(r));
                }
                return u.return(Promise.reject(new S(B.ColibrioErrorType.ABORTED)));
            });
        };
        g.focusOnContentLocation = function(a, b) {
            if (a instanceof V) {
                if (this.ga && this.h === F.RenderableState.VISIBLE && this.s) {
                    if (a = this.s, a.J.contentDocument) {
                        var c = ra(a.J.contentDocument);
                        c.hasAttribute("tabindex") || c.setAttribute("tabindex", "-1");
                        b.focusOnPageContainer && a.J.focus({
                            preventScroll: !0
                        });
                        b.focusOnPageBodyElement && c.focus({
                            preventScroll: !0
                        });
                        b = Promise.resolve();
                    } else b = Promise.reject(new S("DOCUMENT_NOT_RENDERED", "Unable to focus(), textLayer not rendered"));
                } else b = Promise.reject(new S("DOCUMENT_NOT_RENDERED"));
            } else b = Promise.reject(new S("INVALID_LOCATION", "focusOnContentLocation(): Wrong instance type"));
            return b;
        };
        g.getPageContentElement = function() {
            var a;
            if (null == (a = this.i) ? 0 : a.parentElement) return this.i;
            var b;
            return (null == (b = this.g) ? 0 : b.parentElement) ? this.g : null;
        };
        g.getPageDimensions = function() {
            return void 0 !== this.G ? this.G : this.o.getUnconstrainedPageDimensions(this.Z);
        };
        g.getPageFragmentationContext = function() {
            return null;
        };
        g.getPageIndexInSection = function() {
            return 0;
        };
        g.getRangeContentLocation = function() {
            return this.tb;
        };
        g.getReaderDocument = function() {
            return this.C;
        };
        g.getSectionIndex = function() {
            return 0;
        };
        g.getSpreadSlot = function() {
            return this.Z;
        };
        g.getStartContentLocation = function() {
            return this.C.getContentLocation();
        };
        g.getState = function() {
            return this.h;
        };
        g.isCustomPageContent = function() {
            return !1;
        };
        g.isRenderingCompleted = function() {
            return this.ja && this.ga;
        };
        g.isRenderingPaused = function() {
            return this.ma;
        };
        g.onReaderViewPropertyChanged = function(a, b) {
            "activeTransform" === a && (this.Ma = b ? b.scale >= this.B.highResScaleThreshold : !1, lc(this));
        };
        g.print = function() {
            if (this.i && this.j && this.h === F.RenderableState.VISIBLE && this.ta) {
                var a;
                null == (a = this.la) || a.destroy();
                this.la = new yb(this.j, this.i);
                zb(this.la);
            }
        };
        g.remove = function() {
            this.h !== F.RenderableState.DESTROYED && (this.h === F.RenderableState.VISIBLE && this.setVisible(!1), this.j = null, this.fa.forEach(R), this.i && R(this.i), this.g && R(this.g), this.s && (this.s.destroy(), this.s = null), this.K && R(this.K), hc(this, F.RenderableState.CREATED, !1, !1));
        };
        g.removeOverflowingElementScrolledListener = function() {};
        g.removeStateChangeListener = function(a) {
            this.ua.remove(a);
        };
        g.renderTo = function(a) {
            var b = this;
            if (this.h !== F.RenderableState.DESTROYED) {
                this.h !== F.RenderableState.CREATED && this.remove();
                this.j = a;
                this.N || mc(this, a, this.Z);
                this.F && !this.ma && (this.F(), this.F = null);
                this.i && a.appendChild(this.i);
                if (this.S && this.va) {
                    var c = this.s = new $b(this.Ca, this, this.D, this.o, this.S, this.ra, this.qa, this.A, this.B, this.fb, this.K);
                    nc(this, c.J);
                    a.appendChild(this.s.hb);
                    this.va.then(function(d) {
                        c === b.s && cc(c, d);
                    }).catch(function(d) {
                        b.h !== F.RenderableState.DESTROYED && B.Logger.logWarning(d);
                    });
                } else this.fb();
                this.fa.forEach(this.cb);
                jc(this, F.RenderableState.ATTACHED_TO_DOM);
                this.ta && Z(this, !0);
            }
        };
        g.setContentSelection = function() {
            return m.L(function(a) {
                B.Logger.logWarning("setContentSelection is not implemented for PDF");
                return a.return(Promise.resolve());
            });
        };
        g.setRenderingPaused = function(a) {
            var b = this.ma && !a && this.h !== F.RenderableState.CREATED;
            this.ma = a;
            b && this.F && (this.F(), this.F = null);
        };
        g.setSpreadSlot = function(a) {
            this.Z = a;
            var b;
            (a = null == (b = this.s) ? void 0 : b.J) && nc(this, a);
        };
        g.setVisible = function(a) {
            if (this.h !== F.RenderableState.VISIBLE || a) this.h === F.RenderableState.ATTACHED_TO_DOM && a && (jc(this, F.RenderableState.VISIBLE), this.s && this.s.setVisible(!0), this.o.addReaderViewPropertyChangedListener("activeTransform", this), a = this.o.getReaderViewProperty("activeTransform"), this.onReaderViewPropertyChanged("activeTransform", a));
            else {
                this.H && !this.ka && this.H.cancel();
                this.H = null;
                this.ka = !1;
                this.g && (R(this.g), this.g = null);
                this.o.removeReaderViewPropertyChangedListener("activeTransform", this);
                jc(this, F.RenderableState.ATTACHED_TO_DOM);
                this.j && this.i && !this.i.parentNode && this.j.insertBefore(this.i, this.j.childNodes[0]);
                this.s && this.s.setVisible(!1);
                var b;
                null == (b = this.la) || b.destroy();
                this.la = null;
            }
        };
        function oc(a) {
            a.j && a.g && (a.j.insertBefore(a.g, a.j.childNodes[0]), B.BrowserDetector.isOS("iOS") && a.Na && (a.g.style.transformOrigin = "0 0", a.g.style.transform = "scale(" + a.Na + ")"));
        }
        function Z(a, b) {
            hc(a, a.h, b, a.ga);
        }
        function mc(a, b, c) {
            var d = b.ownerDocument.createElement("canvas");
            a.i = d;
            var e = d.getContext("2d", {
                alpha: !1
            });
            if (!e) throw new S("FAILED_TO_GET_CANVAS_2D_CONTEXT");
            var f = (window.devicePixelRatio || 1) / (e.webkitBackingStorePixelRatio || e.mozBackingStorePixelRatio || e.msBackingStorePixelRatio || e.backingStorePixelRatio || 1), k = a.D.getViewport({
                scale: fc
            }), n = a.o.getUnconstrainedPageDimensions(a.Z);
            n = a.o.getRenderer().getSupportedFlowModes().includes(ha.ContentDocumentFlowMode.SCROLLED_DOC) ? n.width / k.width : Math.min(n.width / k.width, n.height / k.height);
            var h = k.width * n * f, p = k.height * n * f, l = h * p, r = p, u = h;
            l >= a.B.maxCanvasPixels && (p = Math.sqrt(a.B.maxCanvasPixels * p * p / l), h = Math.sqrt(a.B.maxCanvasPixels * h * h / l), a.bb = !0);
            d.width = Math.ceil(h);
            d.height = Math.ceil(p);
            var z = Math.ceil(k.width * n), x = Math.ceil(k.height * n);
            a.G = {
                height: x,
                width: z
            };
            c = a.o.getConstrainedPageOffsets(a.G, c);
            a.ra = c.top;
            a.qa = c.left;
            d.style.width = z + "px";
            d.style.height = x + "px";
            a.o.getRenderer().getSupportedFlowModes().includes(ha.ContentDocumentFlowMode.PAGINATED) && (d.style.position = "absolute", d.style.top = c.top + "px", d.style.left = c.left + "px");
            d.style.display = "none";
            f = [
                Math.ceil(h) / u * f * n,
                0,
                0,
                Math.ceil(p) / r * f * n,
                0,
                0
            ];
            Z(a, !1);
            a.N = a.D.render({
                canvasContext: e,
                transform: f,
                viewport: k
            });
            a.N.onContinue = function(D) {
                a.ma || a.h === F.RenderableState.CREATED ? a.F = D : D();
            };
            a.N.promise.then(function() {
                a.ta = !0;
                d.style.display = "block";
                a.h !== F.RenderableState.ATTACHED_TO_DOM && a.h !== F.RenderableState.VISIBLE || Z(a, !0);
            }).catch(function(D) {
                D && J(D.message) && D.message.startsWith("Rendering cancelled") || B.Logger.logError(D);
                a.h !== F.RenderableState.ATTACHED_TO_DOM && a.h !== F.RenderableState.VISIBLE || Z(a, !0);
            });
            a.S = k.clone({
                scale: fc * n
            });
            var A = a.S.clone({
                dontFlip: 0 === a.S.rotation % 180
            });
            a.I = A;
            a.va = a.D.getTextContent();
            a.K = b.ownerDocument.createElement("div");
            a.K.classList.add("colibrio-pdf-renderable-page-annotation-layer");
            a.sa = new a.Ca.AnnotationLayer({
                accessibilityManager: null,
                annotationCanvasMap: null,
                annotationEditorUIManager: null,
                div: a.K,
                page: a.D,
                structTreeLayer: null,
                viewport: A
            });
            var xa = {
                addLinkAttributes: function() {},
                executeNamedAction: function() {},
                executeSetOCGState: function() {},
                Vb: !1,
                getAnchorUrl: function() {
                    return "";
                },
                getDestinationHash: function() {
                    return "javascript:void(0)";
                },
                goToDestination: function() {
                    return Promise.resolve();
                },
                goToPage: function() {},
                Yb: !1,
                page: 0,
                Zb: 0,
                rotation: 0,
                setHash: function() {}
            };
            a.D.getAnnotations({
                intent: "display"
            }).then(function(D) {
                a.K && a.sa && a.sa.render({
                    annotations: D.filter(function(K) {
                        return 2 === K.annotationType;
                    }),
                    div: a.K,
                    linkService: xa,
                    page: a.D,
                    renderForms: !1,
                    viewport: A
                }).then(function() {
                    if (a.K) {
                        a.K.style.width = z + "px";
                        a.K.style.height = x + "px";
                        a.ea = [];
                        for(var K = 0; K < D.length; K++){
                            var T = new sb(D[K], a.K, a.vb, a.o, a.A, a.C, a.wb, a.La);
                            a.ea.push(T);
                        }
                    }
                }).catch(function(K) {
                    a.h !== F.RenderableState.DESTROYED && B.Logger.logWarning(K);
                });
            }).catch(function(D) {
                a.h !== F.RenderableState.DESTROYED && B.Logger.logWarning(D);
            });
        }
        g.getBoundingClientRect = function(a) {
            var b = this.D.view;
            if ((a = Ga(a, this.C, this.La)) && this.I) return pc(a, b, this.I);
        };
        function kc(a, b) {
            var c = a.D.view;
            if ((b = b.getPageRects(a.C, a.La)) && a.I) {
                var d = a.I;
                return b.map(function(e) {
                    return pc(e, c, d);
                });
            }
        }
        g.getContentLocation = function(a, b, c) {
            return vb(this.C, this.D, c, a, b, this.A);
        };
        function lc(a) {
            if (a.i && a.j) {
                if (!a.Ma) a.g && R(a.g), a.i.parentNode || a.j.insertBefore(a.i, a.j.childNodes[0]);
                else if (a.g && a.ka && !a.g.parentElement) oc(a), R(a.i);
                else if (!a.g && !a.bb && a.h === F.RenderableState.VISIBLE) {
                    var b = a.i.ownerDocument.defaultView.getComputedStyle(a.i);
                    if (b && b.width && b.height) {
                        var c = parseFloat(b.width), d = parseFloat(b.height);
                        if (c && d) {
                            a.g = a.i.ownerDocument.createElement("canvas");
                            b = a.g.getContext("2d", {
                                alpha: !1
                            });
                            if (!b) throw new S("FAILED_TO_GET_CANVAS_2D_CONTEXT");
                            var e = B.BrowserDetector.isOS("iOS"), f = (window.devicePixelRatio || 1) / (b.webkitBackingStorePixelRatio || b.mozBackingStorePixelRatio || b.msBackingStorePixelRatio || b.backingStorePixelRatio || 1), k = a.D.getViewport({
                                scale: fc
                            }), n = a.o.getUnconstrainedPageDimensions(a.Z);
                            n = Math.min(n.width / k.width, n.height / k.height);
                            a.o.getRenderer().getSupportedFlowModes().includes(ha.ContentDocumentFlowMode.PAGINATED) && (a.g.style.position = "absolute", a.g.style.top = a.ra + "px", a.g.style.left = a.qa + "px");
                            e || (a.g.style.width = Math.ceil(c) + "px", a.g.style.height = Math.ceil(d) + "px");
                            a.g.style.pointerEvents = "none";
                            var h = k.width * n * f;
                            d = k.height * n * f;
                            e = h * d;
                            var p = d, l = h;
                            d = Math.sqrt(a.B.maxCanvasPixels * d * d / e);
                            h = Math.sqrt(a.B.maxCanvasPixels * h * h / e);
                            a.g.width = Math.ceil(h);
                            a.g.height = Math.ceil(d);
                            a.g.style.display = "none";
                            f = [
                                Math.ceil(h) / l * f * n,
                                0,
                                0,
                                Math.ceil(d) / p * f * n,
                                0,
                                0
                            ];
                            Z(a, !1);
                            a.H = a.D.render({
                                canvasContext: b,
                                transform: f,
                                viewport: k
                            });
                            a.H.promise.then(function() {
                                a.h !== F.RenderableState.DESTROYED && a.g && a.j && (a.ka = !0, a.Na = Math.ceil(c) / h, a.g.style.display = "block", a.Ma && (oc(a), a.i && R(a.i)), a.h !== F.RenderableState.ATTACHED_TO_DOM && a.h !== F.RenderableState.VISIBLE || Z(a, !0));
                            }).catch(function(r) {
                                r && J(r.message) && r.message.startsWith("Rendering cancelled") || B.Logger.logError(r);
                                Z(a, !1);
                            });
                        }
                    }
                }
            }
        }
        function jc(a, b) {
            hc(a, b, a.ja, a.ga);
        }
        function hc(a, b, c, d) {
            if (a.h !== b || a.ja !== c || a.ga !== d) a.h = b, a.ja = c, a.ga = d, nb(a.ua, a, function(e) {
                B.ColibrioError.isColibrioAbortedError(e) || B.Logger.logError(e);
            });
        }
        function pc(a, b, c) {
            a = c.convertToViewportRectangle([
                a.left + b[0],
                a.top + b[1],
                a.right + b[0],
                a.bottom + b[1]
            ]);
            return {
                bottom: a[3],
                height: a[3] - a[1],
                left: a[0],
                right: a[2],
                top: a[1],
                width: a[2] - a[0]
            };
        }
        function nc(a, b) {
            a = H.ReadingSystemUtils.getPageContainerIframeTitle(a.o.getReaderViewOptions(), a.Z, a.o.getRenderer());
            null === a ? b.removeAttribute("title") : b.setAttribute("title", a);
        }
        function qc(a, b, c, d, e, f, k, n, h, p) {
            this.rangeContentLocation = a;
            this.C = b;
            this.g = c;
            this.h = d;
            this.A = e;
            this.i = f;
            this.B = k;
            this.D = n;
            this.o = h;
            this.j = p;
        }
        qc.prototype.createPageIterator = function() {
            throw new S("CONTENT_DOCUMENT_NOT_FRAGMENTABLE");
        };
        qc.prototype.createRenderablePage = function() {
            var a = this;
            return Promise.resolve(new gc(this.C, this.i, this.g, this.D, this.rangeContentLocation, this.A, this.o, this.B, this.j, function() {
                fb(a.h, a.D);
            }));
        };
        function rc(a, b, c, d, e, f, k, n, h, p) {
            this.rangeContentLocation = a;
            this.O = !1;
            this.sections = [
                new qc(a, b, c, d, e, f, k, n, h, p)
            ];
        }
        rc.prototype.destroy = function() {
            this.O = !0;
        };
        rc.prototype.isDestroyed = function() {
            return this.O;
        };
        function sc(a, b, c, d, e, f, k, n) {
            this.N = a;
            this.i = b;
            this.g = c;
            this.s = d;
            this.A = e;
            this.F = f;
            this.h = k;
            this.B = n;
            this.I = this.H = null;
            this.j = Oa(this.A, c);
        }
        g = sc.prototype;
        g.canHaveMultipleRenderingSections = function() {
            return !1;
        };
        g.createRenderableDocument = function(a, b) {
            var c = this, d = this.g.getPageNumber();
            return Promise.all([
                db(this.i, d),
                this.fetchViewportDimensions(),
                this.fetchContentLocationForEntireDocument()
            ]).then(function(e) {
                var f = e[2];
                return new rc(b ? b : f, c, c.N, c.i, c.A, c.F, c.B, e[0], a, e[1]);
            });
        };
        g.fetchContentBlockTree = function() {
            var a = this, b = this.g.getPageNumber();
            return eb(this.i, b, function(c) {
                var d;
                return m.L(function(e) {
                    if (1 == e.g) return q(e, c.getTextContent(), 2);
                    d = e.h;
                    return e.return(new lb(a, d, a.A, c.view));
                });
            });
        };
        g.fetchContentBlocks = function(a) {
            return this.fetchContentBlockTree().then(function(b) {
                return b.toSerializableData(a);
            });
        };
        g.fetchContentLocationForEntireDocument = function() {
            var a = this;
            this.H || (this.H = this.fetchViewportDimensions().then(function(b) {
                var c = new DOMRect(0, 0, b.width, b.height);
                c = Ra(a.A, a.g.getPageNumber(), [
                    c
                ]);
                return new V(c, a.s, a.F, {
                    G: b,
                    _pageIndex: a.h,
                    v: {
                        u: 0,
                        m: 0
                    }
                }, {
                    G: b,
                    _pageIndex: a.h,
                    v: {
                        u: b.width,
                        m: b.height
                    }
                });
            }));
            return this.H;
        };
        g.fetchEstimatedHeight = function(a) {
            return Promise.resolve(a.getUnconstrainedPageDimensions(this.g.getPageSpreadSlot()).height);
        };
        g.fetchEstimatedNumberOfPages = function() {
            return Promise.resolve(1);
        };
        g.fetchLocatorForContentBlockData = function(a, b, c) {
            return this.fetchContentBlockTree().then(function(d) {
                d = d.getContentBlockById(a.id);
                if (!d) throw new S("CONTENT_BLOCK_NOT_FOUND", "fetchLocatorForContentBlock failed for contentBlock id: " + a.id);
                return d.getLocator(b, c);
            });
        };
        g.fetchViewportDimensions = function() {
            var a = this.g.getPageNumber();
            return eb(this.i, a, function(b) {
                b = b.getViewport({
                    scale: 96 / 72
                });
                return {
                    height: b.height,
                    width: b.width
                };
            });
        };
        g.getAvailableSyncMediaFormats = function() {
            return [
                F.SyncMediaFormat.CONTENT_BLOCK_TTS
            ];
        };
        g.getContentLocation = function() {
            this.I || (this.I = new V(this.j, this.s, this.F, {
                G: null,
                _pageIndex: this.h,
                v: {
                    u: 0,
                    m: 0
                }
            }, null));
            return this.I;
        };
        g.getIndexInSpine = function() {
            return this.h;
        };
        g.getLocator = function() {
            return this.j;
        };
        g.getReaderPublication = function() {
            return this.s;
        };
        g.getSourceContentDocument = function() {
            return this.g;
        };
        g.isReflowable = function() {
            return !1;
        };
        g.isRenderable = function() {
            return !0;
        };
        g.toJSON = function() {
            return {
                availableSyncMediaFormats: [
                    F.SyncMediaFormat.CONTENT_BLOCK_TTS
                ],
                indexInSpine: this.h,
                locator: this.j.toJSON(),
                reflowable: !1,
                renderable: this.isRenderable(),
                sourceContentDocumentIndexInSpine: this.g.getIndexInSpine()
            };
        };
        function tc(a, b, c) {
            this.s = a;
            this.I = b;
            this.O = !1;
            this.F = this.j = null;
            this.Z = new gb;
            b = uc(this);
            this.B = O(c, b, !1);
            this.h = this.B.defaultLocatorUrl;
            c = new ia.SelectorFactory([
                new E.PdfFragmentSelectorParser(this.B.addColibrioSpecificFragmentSelectorData),
                new ia.RangeSelectorDataParser
            ]);
            this.H = new C.LocatorFactory(c);
            this.A = new Na(this.h, [
                new La(this.B.addColibrioSpecificFragmentSelectorData)
            ], this.H);
            this.i = a._getPdfDocumentProxy();
            this.N = new cb(this.i);
            a = a.getSpine();
            this.g = [];
            for(c = 0; c < a.length; c++)b = new sc(this.i, this.N, a[c], this, this.A, this.g, c, this.B), this.g.push(b);
        }
        g = tc.prototype;
        g.createContentPositionTimeline = function(a, b, c) {
            return H.ReaderDocumentContentPositionTimelineBuilder.createTimeline((null == b ? void 0 : b.unit) || F.ContentPositionTimelineUnit.PAGES, a, this, null == b ? void 0 : b.name, c);
        };
        g.createTtsSyncMediaTimeline = function(a, b, c) {
            return H.TtsSyncMediaTimelineBuilder.createTimeline(a, b || null, c);
        };
        g.destroy = function() {
            this.O || (this.O = !0, this.g = [], this.I.unloadPublication(this));
        };
        g.fetchContentLocation = function(a) {
            return this.fetchUnresolvedContentLocation(a).then(function(b) {
                return b.resolve();
            });
        };
        function vc(a, b) {
            var c = b.getPageNumber();
            if (Q(c)) return Promise.resolve(c - 1);
            c = b.getNamedDest();
            return J(c) ? Ta(a.i, c) : Promise.reject(new S("UNSUPPORTED_PDF_SELECTOR", "Invalid pdf fragment selector. page or nameddest required: " + b.getValue()));
        }
        g.fetchPreferredPageAspectRatio = function() {
            this.F || (this.F = H.ReadingSystemUtils.fetchAverageAspectRatioFromReaderDocuments(this.g.slice(0, 3)));
            return this.F;
        };
        g.fetchPublicationNavigation = function() {
            this.j || (this.j = ab(this.A, this.i));
            return this.j;
        };
        g.fetchUnresolvedContentLocation = function(a) {
            var b = this;
            a = H.LocatorUtils.getLocator(a);
            if (null === a) return Promise.reject(new H.EngineError(H.EngineErrorType.NAVIGATION_ITEM_MISSING_LOCATOR));
            a = this.A.getLocatorFactory().parse(a, this.h);
            var c = a.locator;
            if (!c) return Promise.reject(a.error);
            var d = c.getSelectors().find(va);
            if (d) return vc(this, d).then(function(n) {
                if (0 > n || n >= b.g.length) throw new S("INVALID_LOCATOR", "Page number out of range: " + d.getValue());
                var h = d.getHighlight(), p = {
                    _pageIndex: n,
                    v: h ? {
                        u: h.left,
                        m: h.top
                    } : null
                }, l = null;
                h && (0 < h.width || 0 < h.height) && (l = {
                    _pageIndex: n,
                    v: {
                        u: h.right,
                        m: h.bottom
                    }
                });
                return new Ia(c, b, b.g, p, l, null);
            });
            var e = c.getSelectors().find(wa);
            if (e) {
                var f = e.getStartSelector(), k = e.getEndSelector();
                return Promise.all([
                    vc(this, f),
                    vc(this, k)
                ]).then(function(n) {
                    var h = n[0];
                    n = n[1];
                    if (0 > h || h >= b.g.length) throw new S("INVALID_LOCATOR", "Start page number out of range: " + e.toString());
                    if (n < h) throw new S("INVALID_LOCATOR", "End page number must be greater than start number: " + e.toString());
                    if (n > b.g.length) throw new S("INVALID_LOCATOR", "End page number out of range: " + e.toString());
                    var p = f.getHighlight();
                    p = p ? {
                        u: p.left,
                        m: p.top
                    } : {
                        u: 0,
                        m: 0
                    };
                    var l = {
                        _pageIndex: h,
                        v: p
                    }, r = k.getHighlight(), u = null;
                    n > h ? u = {
                        _pageIndex: n,
                        v: r ? {
                            u: r.right,
                            m: r.bottom
                        } : null
                    } : r && (h = Math.max(p.u, r.right), r = Math.max(p.m, r.bottom), h > p.u || r > p.m) && (u = {
                        _pageIndex: n,
                        v: {
                            u: h,
                            m: r
                        }
                    });
                    return new Ia(c, b, b.g, l, u, null);
                });
            }
            return Promise.reject(new S("UNSUPPORTED_PDF_SELECTOR", "Invalid pdf fragment selector. page or nameddest required"));
        };
        g.getAvailableContentPositionTimelineUnits = function() {
            return [
                F.ContentPositionTimelineUnit.PAGES,
                F.ContentPositionTimelineUnit.DOCUMENTS
            ];
        };
        g.getAvailableSyncMediaFormats = function() {
            return [
                F.SyncMediaFormat.CONTENT_BLOCK_TTS
            ];
        };
        g.getDefaultLocatorUrl = function() {
            return this.h;
        };
        g.getLocatorFactory = function() {
            return this.H;
        };
        g.getOptions = function() {
            return O(this.B, {}, !1);
        };
        g.getReaderPublicationStorage = function() {
            return this.Z;
        };
        g.getReadingSystemEngine = function() {
            return this.I;
        };
        g.getSourcePublication = function() {
            return this.s;
        };
        g.getSpine = function() {
            return this.g.slice();
        };
        g.isDestroyed = function() {
            return this.O;
        };
        g.isLocatorSourceUrlInPublication = function(a) {
            return H.LocatorUtils.isLocatorSourceUrlInPublication(a, this.A.getLocatorFactory(), this.h, this.B.additionalLocatorUrls);
        };
        g.setOptions = function(a) {
            a = O(a, this.B, !0);
            var b = uc(this);
            this.B = O(a, b, !1);
        };
        g.toJSON = function() {
            return {
                availableContentPositionTimelineUnits: this.getAvailableContentPositionTimelineUnits(),
                availableSyncMediaFormats: this.getAvailableSyncMediaFormats(),
                defaultLocatorUrl: this.h,
                sourcePublicationHashSignature: this.s.getHashSignature(),
                spine: this.g.map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function uc(a) {
            var b = !B.BrowserDetector.isPlatform("desktop") || "MacIntel" === navigator.platform && 1 < navigator.maxTouchPoints ? 8388608 : 16777216;
            return {
                addColibrioSpecificFragmentSelectorData: !1,
                additionalLocatorUrls: [],
                clipboardOptions: {
                    allowCopy: !0,
                    textToAppendOnCopy: null,
                    textToPrependOnCopy: null
                },
                defaultLocatorUrl: "com.colibrio.pdf.signature:" + a.s.getHashSignature(),
                highResScaleThreshold: 1.1,
                includeContentLocationInPointerMoveEvents: !1,
                maxCanvasPixels: b,
                preventDefaultContextMenu: !1,
                preventDragAndDropActions: !0,
                textLayerOptions: {
                    customCss: null
                }
            };
        }
        function wc() {}
        wc.prototype.createReaderPublication = function(a, b, c) {
            return Promise.resolve(new tc(a, b, c));
        };
        wc.prototype.isPublicationSupported = function(a) {
            return a.getType() === ha.PublicationType.PDF;
        };
        api = {
            PdfFormatAdapter: wc,
            PdfFormatAdapterError: S,
            PdfFormatAdapterErrorType: {
                CONTENT_BLOCK_NOT_FOUND: "CONTENT_BLOCK_NOT_FOUND",
                CONTENT_DOCUMENT_NOT_FRAGMENTABLE: "CONTENT_DOCUMENT_NOT_FRAGMENTABLE",
                DOCUMENT_NOT_RENDERED: "DOCUMENT_NOT_RENDERED",
                FAILED_TO_GET_CANVAS_2D_CONTEXT: "FAILED_TO_GET_CANVAS_2D_CONTEXT",
                INCOMPATIBLE_END_LOCATION: "INCOMPATIBLE_END_LOCATION",
                INVALID_LOCATION: "INVALID_LOCATION",
                INVALID_LOCATOR: "INVALID_LOCATOR",
                SYNC_MEDIA_NOT_AVAILABLE: "SYNC_MEDIA_NOT_AVAILABLE",
                UNKNOWN_DEST_ARRAY_FORMAT: "UNKNOWN_DEST_ARRAY_FORMAT",
                UNSUPPORTED_METHOD: "UNSUPPORTED_METHOD",
                UNSUPPORTED_PDF_SELECTOR: "UNSUPPORTED_PDF_SELECTOR",
                PUBLICATION_STORAGE_AREA_NOT_SUPPORTED: "PUBLICATION_STORAGE_AREA_NOT_SUPPORTED"
            }
        };
        var xc = new ArrayBuffer(8);
        new DataView(xc);
        new Uint8Array(xc);
    }).call(__self);
    return api;
});


const { PdfFormatAdapter: $08a2f01c74df8fd0$export$6edbcdb1c3d1e8e7, PdfFormatAdapterError: $08a2f01c74df8fd0$export$cec28cd39000147, PdfFormatAdapterErrorType: $08a2f01c74df8fd0$export$ea83709663b4eb11 } = (0, (/*@__PURE__*/$parcel$interopDefault($e8a69a69bb220635$exports)));


var $e16339ee60d0cab6$exports = {};
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";













(function(s, f) {
    if (0, $e16339ee60d0cab6$exports) $e16339ee60d0cab6$exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("7uZag")), (parcelRequire("csyWb")), (parcelRequire("kxrNj")), (parcelRequire("acQau")), (parcelRequire("1dwvc")), (parcelRequire("bkFGj")), (parcelRequire("fQRpb")), (parcelRequire("a75zb")), (parcelRequire("gWxKE")), (parcelRequire("7kECq")), (parcelRequire("9eVOO")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : $e16339ee60d0cab6$exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_io_mediatypedetector, __dep__colibrio_core_locator, __dep__colibrio_core_media, __dep__colibrio_core_publication_base, __dep__colibrio_core_publication_wp, __dep__colibrio_core_selector_base, __dep__colibrio_core_selector_media, __dep__colibrio_core_url, __dep__colibrio_core_xml, __dep__colibrio_readingsystem_base, __dep__colibrio_readingsystem_engine) {
    var api = {};
    (function() {
        var f;
        function aa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function da(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var ea = da(this);
        function fa(a, b) {
            if (b) a: {
                var c = ea;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var e = a[d];
                    if (!(e in c)) break a;
                    c = c[e];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && ba(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        fa("Symbol", function(a) {
            function b(h) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (h || "") + "_" + e++, h);
            }
            function c(h, g) {
                this.g = h;
                ba(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: g
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        });
        fa("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = ea[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return ha(aa(this));
                    }
                });
            }
            return a;
        });
        function ha(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        function p(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return {
                next: aa(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        function ia(a) {
            if (!(a instanceof Array)) {
                a = p(a);
                for(var b, c = []; !(b = a.next()).done;)c.push(b.value);
                a = c;
            }
            return a;
        }
        var ja = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, ka;
        if ("function" == typeof Object.setPrototypeOf) ka = Object.setPrototypeOf;
        else {
            var la;
            a: {
                var ma = {
                    a: !0
                }, na = {};
                try {
                    na.__proto__ = ma;
                    la = na.a;
                    break a;
                } catch (a) {}
                la = !1;
            }
            ka = la ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var oa = ka;
        function pa() {
            this.l = !1;
            this.h = null;
            this.v = void 0;
            this.g = 1;
            this.J = this.m = 0;
            this.i = null;
        }
        function qa(a) {
            if (a.l) throw new TypeError("Generator is already running");
            a.l = !0;
        }
        pa.prototype.A = function(a) {
            this.v = a;
        };
        function ya(a, b) {
            a.i = {
                P: b,
                V: !0
            };
            a.g = a.m || a.J;
        }
        pa.prototype.return = function(a) {
            this.i = {
                return: a
            };
            this.g = this.J;
        };
        function za(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        function Aa(a) {
            this.g = new pa;
            this.h = a;
        }
        function Ba(a, b) {
            qa(a.g);
            var c = a.g.h;
            if (c) return Ca(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return q(a);
        }
        function Ca(a, b, c, d) {
            try {
                var e = b.call(a.g.h, c);
                if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                if (!e.done) return a.g.l = !1, e;
                var h = e.value;
            } catch (g) {
                return a.g.h = null, ya(a.g, g), q(a);
            }
            a.g.h = null;
            d.call(a.g, h);
            return q(a);
        }
        function q(a) {
            for(; a.g.g;)try {
                var b = a.h(a.g);
                if (b) return a.g.l = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.v = void 0, ya(a.g, c);
            }
            a.g.l = !1;
            if (a.g.i) {
                b = a.g.i;
                a.g.i = null;
                if (b.V) throw b.P;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function Da(a) {
            this.next = function(b) {
                qa(a.g);
                a.g.h ? b = Ca(a, a.g.h.next, b, a.g.A) : (a.g.A(b), b = q(a));
                return b;
            };
            this.throw = function(b) {
                qa(a.g);
                a.g.h ? b = Ca(a, a.g.h["throw"], b, a.g.A) : (ya(a.g, b), b = q(a));
                return b;
            };
            this.return = function(b) {
                return Ba(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function Ea(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function h(g) {
                    g.done ? d(g.value) : Promise.resolve(g.value).then(b, c).then(h, e);
                }
                h(a.next());
            });
        }
        function v(a) {
            return Ea(new Da(new Aa(a)));
        }
        var w = __dep__colibrio_core_base;
        var Fa = __dep__colibrio_core_io_base;
        var Ga = __dep__colibrio_core_io_mediatypedetector;
        var x = __dep__colibrio_core_locator;
        var Ha = __dep__colibrio_core_publication_base;
        var Ia = __dep__colibrio_core_selector_base;
        var z = __dep__colibrio_core_selector_media;
        var B = __dep__colibrio_core_url;
        var Ja = __dep__colibrio_core_xml;
        var G = __dep__colibrio_readingsystem_base;
        var K = __dep__colibrio_readingsystem_engine;
        function Ka(a, b, c) {
            var d = 0;
            if (0 >= b) a = -1;
            else {
                b = d + b - 1;
                for(var e = d, h = 1; h && d <= b;)e = d + b >>> 1, h = c(a, e), 0 > h ? b = e - 1 : 0 < h && (d = e + 1);
                0 < h && e++;
                a = e;
            }
            return a;
        }
        function L(a) {
            return 0 < a.length ? a[a.length - 1] : void 0;
        }
        function La(a, b) {
            return 0 > a ? 0 : a > b ? b : a;
        }
        function Ma(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), e = 0; e < d.length; e++){
                var h = d[e], g = a[h];
                null !== g && "object" === typeof g ? b[h] = Ma(g, b[h], c) : "undefined" === typeof g ? c && delete b[h] : b[h] = g;
            }
            return b;
        }
        function Qa(a, b, c) {
            return Ma(a, b, c || !1);
        }
        function Ra(a, b) {
            a = a.children;
            for(var c = 0, d = a.length; c < d; c++)b(a[c], c);
        }
        function Sa(a, b, c) {
            this.T = a;
            this.g = b;
            this.R = c;
        }
        Sa.prototype.get = function() {
            return this.g;
        };
        var Ta = new Uint16Array(1);
        Ta[0] = 4660;
        new Uint8Array(Ta.buffer);
        function M(a, b) {
            return w.ColibrioError.call(this, "colibrio.readingsystem.formatadapter.wp.audiobook", a, b) || this;
        }
        var N = w.ColibrioError;
        M.prototype = ja(N.prototype);
        M.prototype.constructor = M;
        if (oa) oa(M, N);
        else for(var O in N)if ("prototype" != O) {
            if (Object.defineProperties) {
                var Ua = Object.getOwnPropertyDescriptor(N, O);
                Ua && Object.defineProperty(M, O, Ua);
            } else M[O] = N[O];
        }
        function P() {}
        P.prototype.getTextContent = function() {
            return "";
        };
        P.prototype.getTextContentAfter = function() {
            return "";
        };
        P.prototype.getTextContentBefore = function() {
            return "";
        };
        function Q(a, b, c) {
            this.g = a;
            this.i = b;
            this.h = c;
        }
        Q.prototype.getNavigationCollection = function() {
            return this.g;
        };
        Q.prototype.getNavigationItem = function() {
            return this.i;
        };
        Q.prototype.getReaderDocument = function() {
            return this.h;
        };
        Q.prototype.toJSON = function() {
            return {
                collectionIndex: this.g.getIndex(),
                collectionType: this.g.getType(),
                navigationItemId: this.i.getId(),
                readerDocumentIndexInSpine: this.h.getIndexInSpine(),
                readerPublicationDefaultLocatorUrl: this.h.getReaderPublication().getDefaultLocatorUrl()
            };
        };
        function R(a, b, c) {
            this.h = a;
            this.g = b;
            this.i = c;
        }
        R.prototype.getItemsAfter = function() {
            return this.g;
        };
        R.prototype.getItemsBefore = function() {
            return this.h;
        };
        R.prototype.getItemsInRange = function() {
            return this.i;
        };
        R.prototype.toJSON = function() {
            return {
                itemsAfter: this.g.map(function(a) {
                    return a.toJSON();
                }),
                itemsBefore: this.h.map(function(a) {
                    return a.toJSON();
                }),
                itemsInRange: this.i.map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function Va(a, b, c, d) {
            var e, h, g, l, k, m, n, C, E, u, r, F, H, Na, D, y, t, ra, I, Oa, sa, J, Pa, ta, ua, tb, U, va, wa, xa, ca;
            return v(function(V) {
                if (1 == V.g) {
                    e = c.o;
                    l = null != (g = null == (h = d) ? void 0 : h.o) ? g : c.o;
                    k = b.getSpine().slice(e, l + 1);
                    if (a.collectionTypes && !a.collectionTypes.includes(G.NavigationCollectionType.TOC)) return V.return(Promise.resolve(new R([], [], [])));
                    m = 0;
                    n = b.getSpine();
                    C = k[0];
                    E = L(k);
                    u = 0;
                    r = null;
                    for(F = 0; F < n.length; F++){
                        H = n[F];
                        if (H === C && (u = m + c.j, null === d)) break;
                        if (null !== d && H === E) {
                            r = m + d.j;
                            break;
                        }
                        m += H.getDurationMs();
                    }
                    r === u && (r = null);
                    return za(V, b.fetchPublicationNavigation(), 2);
                }
                Na = V.v;
                D = Wa(n, Na);
                y = null;
                t = [];
                ra = !1;
                for(I = 0; I < D.length && null === y; I++){
                    Oa = D[I];
                    sa = Oa.timeInterval;
                    J = sa.startMs;
                    Pa = Xa({
                        U: D,
                        W: sa.endMs,
                        Z: I,
                        $: J
                    });
                    ua = ta = void 0;
                    if (tb = w.TimeIntervalUtils.isIntersecting({
                        endMs: null != (ta = r) ? ta : u,
                        startMs: u
                    }, {
                        endMs: null != (ua = Pa) ? ua : J,
                        startMs: J
                    })) J <= u && 0 === t.length && (ra = !0), t.push(I);
                    if (null !== r && J > r || null === r && J > u) y = I;
                }
                a.greedy && (!ra && 0 < t.length && 0 < t[0] && t.unshift(t[0] - 1), 0 === t.length && null !== y && 0 < y && t.push(y - 1));
                U = [];
                0 < t.length && 0 < t[0] ? U = [
                    t[0] - 1
                ] : 0 === t.length && null !== y && 0 < y ? U = [
                    y - 1
                ] : null === y && 0 < D.length && 0 === t.length && (U = [
                    D.length - 1
                ]);
                va = [];
                wa = [];
                xa = [];
                U.forEach(function(A) {
                    A = D[A];
                    va.push(new Q(A.M, A.item, A.readerDocument));
                });
                t.forEach(function(A) {
                    A = D[A];
                    xa.push(new Q(A.M, A.item, A.readerDocument));
                });
                null !== y && (ca = D[y], wa.push(new Q(ca.M, ca.item, ca.readerDocument)));
                return V.return(new R(va, wa, xa));
            });
        }
        function Xa(a) {
            var b = a.$, c = a.W;
            if (void 0 === c) return null;
            var d = c;
            (a = a.U[a.Z + 1]) && a.timeInterval.startMs < c && (d = Math.max(b, a.timeInterval.startMs));
            d === b && (d = null);
            return d;
        }
        function Ya(a) {
            var b = [];
            b.push.apply(b, ia(a));
            a.forEach(function(c) {
                b.push.apply(b, ia(Ya(c.getChildren())));
            });
            return b;
        }
        function Wa(a, b) {
            var c = [];
            b.getNavigationCollections().filter(function(d) {
                return d.getType() === G.NavigationCollectionType.TOC;
            }).forEach(function(d) {
                Ya(d.getChildren()).forEach(function(e) {
                    var h, g = null == (h = e.getLocator()) ? void 0 : h.getSelectors()[0];
                    if (g instanceof z.MediaFragmentSelector && (h = g.getTimeInterval())) {
                        a: {
                            g = h.startMs;
                            if (!(0 > g)) for(var l = 0, k = 0; k < a.length; k++){
                                l += a[k].getDurationMs();
                                var m = k === a.length - 1 && g === l;
                                if (g < l || m) {
                                    g = k;
                                    break a;
                                }
                            }
                            g = null;
                        }
                        null !== g && c.push({
                            M: d,
                            item: e,
                            readerDocument: a[g],
                            timeInterval: h
                        });
                    }
                });
            });
            c.sort(function(d, e) {
                var h;
                d = null == (h = d.item.getLocator()) ? void 0 : h.getSelectors()[0];
                var g;
                e = null == (g = e.item.getLocator()) ? void 0 : g.getSelectors()[0];
                if (d instanceof z.MediaFragmentSelector && e instanceof z.MediaFragmentSelector) {
                    var l;
                    g = null == (l = d.getTimeInterval()) ? void 0 : l.startMs;
                    var k;
                    l = null == (k = e.getTimeInterval()) ? void 0 : k.startMs;
                    if (void 0 !== g && void 0 !== l && g !== l) return g < l ? -1 : 1;
                }
                return 0;
            });
            return c;
        }
        function S(a, b, c, d) {
            this.m = a;
            this.l = b;
            this.g = c;
            (this.h = d) && d.j === c.j && d.o === c.o && (this.h = null, this.m = this.l.getLocatorFactory().collapseRangeLocatorToStart(this.m));
            a = c.o;
            var e;
            d = null != (e = null == d ? void 0 : d.o) ? e : c.o;
            this.i = b.getSpine().slice(a, d + 1);
        }
        f = S.prototype;
        f.collapseToEnd = function() {
            var a = this.g;
            this.h && (a = this.h);
            var b = this.l.getLocatorFactory().collapseRangeLocatorToEnd(this.m);
            return new S(b, this.l, a, null);
        };
        f.collapseToStart = function() {
            var a = this.l.getLocatorFactory().collapseRangeLocatorToStart(this.m);
            return new S(a, this.l, this.g, null);
        };
        f.contains = function(a) {
            if (!(a instanceof S) || this.l !== a.l) return !1;
            var b = this.i[0], c = L(this.i), d = a.i[0], e = L(a.i);
            if (b.getIndexInSpine() > d.getIndexInSpine() || c.getIndexInSpine() < e.getIndexInSpine()) return !1;
            if (b !== d && c !== e) return !0;
            if (!this.h) return a.h ? !1 : b === d && this.g.j === a.g.j;
            if (b === d && a.g.j < this.g.j) return !1;
            if (c === e) {
                if (a.h) {
                    if (a.h.j > this.h.j) return !1;
                } else if (this.h.j <= a.g.j) return !1;
            }
            return !0;
        };
        f.createRangeTo = function(a) {
            if (!(a instanceof S) || this.l !== a.l) throw new M("INCOMPATIBLE_LOCATION", "Incompatible ContentLocation instance.");
            var b = this.i[0].getIndexInSpine(), c = L(a.i).getIndexInSpine();
            if (c < b) throw new M("INCOMPATIBLE_LOCATION", "endLocation is in an earlier ReaderDocument. this location startIndex: " + b + " endLocation endIndex: " + c);
            var d = this.g.j, e, h, g = null != (h = null == (e = a.h) ? void 0 : e.j) ? h : a.g.j;
            if (b === c) {
                if (g < d) throw b = "endLocation is before startLocation, selector for startLocation: " + this.getLocator().getSelectors()[0] + " endLocation: " + a.getLocator().getSelectors()[0], new M("INCOMPATIBLE_LOCATION", b);
                if (g === d) return this.collapseToStart();
            }
            a = this.l.getLocatorFactory().createRangeLocator(this.m, a.m);
            e = a.locator;
            if (!e) {
                var l, k;
                throw new M("INCOMPATIBLE_LOCATION", (null == (l = a.error) ? void 0 : l.errorType) + ", " + (null == (k = a.error) ? void 0 : k.errorMessage));
            }
            return new S(e, this.l, {
                j: d,
                o: b
            }, {
                j: g,
                o: c
            });
        };
        f.equals = function(a) {
            if (!(a instanceof S) || this.l !== a.l) return !1;
            var b = L(this.i), c = L(a.i), d, e;
            return this.i[0] === a.i[0] && b === c && this.g.j === a.g.j && (null == (d = this.h) ? void 0 : d.j) === (null == (e = a.h) ? void 0 : e.j);
        };
        f.fetchContentBlockTargets = function() {
            return Promise.resolve([]);
        };
        f.fetchContentResolver = function() {
            return Promise.resolve(new P);
        };
        f.fetchNavigationItemReferences = function(a) {
            return Va(a, this.l, this.g, this.h);
        };
        f.getLocator = function() {
            return this.m;
        };
        f.getReaderDocuments = function() {
            return this.h && 0 === this.h.j ? this.i.slice(0, this.i.length - 1) : this.i;
        };
        f.getReaderPublication = function() {
            return this.l;
        };
        f.intersects = function(a) {
            if (!(a instanceof S) || this.l !== a.l) return !1;
            var b = this.i[0], c = L(this.i), d = a.i[0], e = L(a.i);
            if (b.getIndexInSpine() > e.getIndexInSpine() || c.getIndexInSpine() < d.getIndexInSpine()) return !1;
            if (b !== e && c !== d) return !0;
            if (b === e) {
                if (a.h) {
                    if (this.g.j >= a.h.j) return !1;
                } else if (this.g.j > a.g.j) return !1;
            }
            if (c === d) {
                if (this.h) {
                    if (this.h.j <= a.g.j) return !1;
                } else if (this.g.j < a.g.j) return !1;
            }
            return !0;
        };
        f.isAfter = function(a) {
            if (!(a instanceof S) || this.l !== a.l) return !1;
            var b = this.i[0], c = L(a.i);
            return b.getIndexInSpine() > c.getIndexInSpine() ? !0 : b.getIndexInSpine() < c.getIndexInSpine() ? !1 : a.h ? this.g.j >= a.h.j : this.g.j > a.g.j;
        };
        f.isBefore = function(a) {
            if (!(a instanceof S) || this.l !== a.l) return !1;
            var b = L(this.i), c = a.i[0];
            return b.getIndexInSpine() < c.getIndexInSpine() ? !0 : b.getIndexInSpine() > c.getIndexInSpine() ? !1 : this.h ? this.h.j <= a.g.j : this.g.j < a.g.j;
        };
        f.isRange = function() {
            return !!this.h;
        };
        f.toJSON = function() {
            return this.m.toJSON();
        };
        function Za(a, b, c, d) {
            this.g = a;
            this.h = b;
            this.m = c;
            this.i = d;
            a = c.o;
            var e;
            d = null != (e = null == d ? void 0 : d.o) ? e : c.o;
            this.l = b.getSpine().slice(a, d + 1);
        }
        function $a(a) {
            return new Za(a.getLocator(), a.getReaderPublication(), a.g, a.h);
        }
        f = Za.prototype;
        f.collapseToEnd = function() {
            return this.resolve().then(function(a) {
                return $a(a.collapseToEnd());
            });
        };
        f.collapseToStart = function() {
            return this.resolve().then(function(a) {
                return $a(a.collapseToStart());
            });
        };
        f.contains = function(a) {
            return Promise.all([
                this.resolve(),
                T(this, a)
            ]).then(function(b) {
                return b[0].contains(b[1]);
            });
        };
        f.createRangeTo = function(a) {
            return Promise.all([
                this.resolve(),
                T(this, a)
            ]).then(function(b) {
                return b[0].createRangeTo(b[1]);
            }).then(function(b) {
                return $a(b);
            });
        };
        f.equals = function(a) {
            return Promise.all([
                this.resolve(),
                T(this, a)
            ]).then(function(b) {
                return b[0].equals(b[1]);
            });
        };
        f.fetchContentBlockTargets = function() {
            return Promise.resolve([]);
        };
        f.fetchContentResolver = function() {
            return Promise.resolve(new P);
        };
        f.fetchNavigationItemReferences = function(a) {
            return this.resolve().then(function(b) {
                return b.fetchNavigationItemReferences(a);
            });
        };
        f.getLocator = function() {
            return this.g;
        };
        f.getReaderDocuments = function() {
            return this.l;
        };
        f.getReaderPublication = function() {
            return this.h;
        };
        f.intersects = function(a) {
            return Promise.all([
                this.resolve(),
                T(this, a)
            ]).then(function(b) {
                return b[0].intersects(b[1]);
            });
        };
        f.isAfter = function(a) {
            return Promise.all([
                this.resolve(),
                T(this, a)
            ]).then(function(b) {
                return b[0].isAfter(b[1]);
            });
        };
        f.isBefore = function(a) {
            return Promise.all([
                this.resolve(),
                T(this, a)
            ]).then(function(b) {
                return b[0].isBefore(b[1]);
            });
        };
        f.isRange = function() {
            return this.resolve().then(function(a) {
                return a.isRange();
            });
        };
        f.resolve = function() {
            return Promise.resolve(new S(this.g, this.h, this.m, this.i));
        };
        f.toJSON = function() {
            return this.g.toJSON();
        };
        function T(a, b) {
            var c;
            K.ReadingSystemUtils.isUnresolvedContentLocation(b) ? c = b.resolve() : c = K.ReadingSystemUtils.isContentLocation(b) ? Promise.resolve(b) : a.h.fetchUnresolvedContentLocation(b).then(function(d) {
                return d.resolve();
            });
            return c.then(function(d) {
                if (!(d instanceof S)) throw new M("INCOMPATIBLE_LOCATION", "Incompatible ContentLocation instance.");
                return d;
            });
        }
        var ab = {
            endMs: void 0,
            startMs: 0
        };
        function bb(a, b) {
            this.D = a;
            this.H = b;
        }
        function cb(a, b) {
            return b.slice(0, a).reduce(function(c, d) {
                return c + d.getDurationMs();
            }, 0);
        }
        function db(a, b, c, d) {
            d = void 0 === d ? ab : d;
            c = cb(b.getIndexInSpine(), c);
            var e = "undefined" === typeof d.endMs ? b.getDurationMs() : d.endMs;
            e = c + La(e, b.getDurationMs());
            b = c + La(d.startMs, b.getDurationMs());
            b = [
                new z.MediaFragmentSelector({
                    timeInterval: {
                        endMs: e,
                        startMs: b
                    }
                }, [])
            ];
            return new x.Locator(a.D, b);
        }
        bb.prototype.getLocatorFactory = function() {
            return this.H;
        };
        function eb(a) {
            var b = W;
            this.l = !0;
            this.h = this.g = a;
            this.i = b || null;
        }
        function X(a, b) {
            if (null !== a.g) {
                var c = fb(a, b);
                for(a.l = !1; null !== a.g && a.i && !a.i(a.g);)c += fb(a, b);
            }
        }
        eb.prototype.next = function(a) {
            if (this.l && (!this.i || this.i(this.g))) return this.l = !1, this.g;
            X(this, a);
            return this.g;
        };
        function fb(a, b) {
            var c = a.g, d = 0;
            if (c.firstChild && ("function" === typeof b ? b(c) : b)) a.g = c.firstChild, d = 1;
            else if (c !== a.h && c.nextSibling) a.g = c.nextSibling;
            else {
                for(; c !== a.h && !c.nextSibling;)c = c.parentNode, d--;
                c === a.h ? a.g = null : a.g = c.nextSibling;
            }
            return d;
        }
        function gb(a, b, c) {
            this.g = a;
            this.h = b;
            this.i = c;
        }
        f = gb.prototype;
        f.getChildren = function() {
            return this.g;
        };
        f.getIndex = function() {
            return 0;
        };
        f.getTitle = function() {
            return this.h;
        };
        f.getType = function() {
            return this.i;
        };
        f.toJSON = function() {
            return {
                children: this.g.map(function(a) {
                    return a.toJSON();
                }),
                index: 0,
                title: this.h,
                type: this.i
            };
        };
        function hb(a, b, c, d, e) {
            this.i = a;
            this.m = b;
            this.v = c;
            this.A = d;
            this.l = e;
            this.h = this.g = null;
        }
        f = hb.prototype;
        f.getChildren = function() {
            return this.i || [];
        };
        f.getHref = function() {
            return this.l;
        };
        f.getId = function() {
            return this.m;
        };
        f.getLocator = function() {
            return this.g;
        };
        f.getParent = function() {
            return this.h;
        };
        f.getTextContent = function() {
            return this.A;
        };
        f.isTargetingReaderDocumentInSpine = function() {
            return this.v;
        };
        f.toJSON = function() {
            return {
                children: this.i ? this.i.map(function(a) {
                    return a.toJSON();
                }) : [],
                href: this.l,
                id: this.m,
                isTargetingReaderDocumentInSpine: this.v,
                locator: this.g && this.g.toJSON(),
                parentId: this.h && this.h.getId(),
                textContent: this.A
            };
        };
        function ib(a, b, c, d) {
            this.h = a;
            this.g = b;
            this.B = c;
            this.s = d;
            this.i = 1;
        }
        function jb(a, b, c) {
            var d = null, e = !1, h = null, g = null, l = null, k = a.i++;
            c = new eb(c);
            for(X(c, W); c.g && !g;){
                var m = c.g, n = m.localName;
                if (d || "a" !== n) d && "ol" === n && (g = kb(a, b, m));
                else if (d = m.textContent, "string" === typeof d && /\S/.test(d) && (m = m.getAttribute("href"))) try {
                    var C = B.URLUtils.normalizePathnameEncoding(new URL(m, b)), E = a.getReaderDocument(C);
                    e = void 0 !== E;
                    h = lb(a, C, E);
                    e || (l = B.URLUtils.getSanitizedRemoteHref(C));
                } catch (r) {
                    w.Logger.logWarning(new M("INVALID_URL_IN_PUBLICATION_RESOURCE", String(r) + (' - source="' + a.g.pathname + '", href="' + m + '"')));
                }
                X(c, W);
            }
            if (d || g) {
                var u = new hb(g, k, e, d ? d.replace(/s{2,}/g, " ").trim() : "", l);
                h && (u.g = h);
                g && g.forEach(function(r) {
                    r.h = u;
                });
                return u;
            }
            return null;
        }
        function kb(a, b, c) {
            var d = [];
            Ra(c, function(e) {
                "li" !== e.localName || e.hasAttribute("hidden") || (e = jb(a, b, e)) && d.push(e);
            });
            return 0 < d.length ? d : null;
        }
        function lb(a, b, c) {
            return c ? (b = a.getTimeInterval(b), db(a.B, c, a.s, b)) : a.B.getLocatorFactory().parse(b).locator;
        }
        function mb(a, b) {
            var c = G.NavigationCollectionType.TOC, d = null, e = null, h = new eb(b);
            h.h = b;
            X(h, function(m) {
                return W(m) || m === b;
            });
            for(var g = a.getBaseUrl(); h.g && !e;){
                var l = h.g, k = l.localName;
                if (!d && /h[1-6]/.test(k)) d = l.textContent;
                else if ("ol" === k || "ul" === k) e = kb(a, g, l);
                X(h, W);
            }
            return e ? new gb(e, d, c) : null;
        }
        ib.prototype.getBaseUrl = function() {
            var a, b = null == (a = this.h.querySelector("base")) ? void 0 : a.getAttribute("href");
            return b ? B.URLUtils.normalizePathnameEncoding(new URL(b, this.g)) : this.g;
        };
        ib.prototype.getReaderDocument = function(a) {
            var b = this;
            return this.s.find(function(c) {
                if (B.URLUtils.getUrlWithoutHash(c.getSourceContentDocument().getContentUrl()) === B.URLUtils.getUrlWithoutHash(a)) {
                    var d = b.getTimeInterval(a);
                    c = {
                        endMs: c.getDurationMs(),
                        startMs: 0
                    };
                    d = d ? w.TimeIntervalUtils.isIntersecting(d, c) : !0;
                } else d = !1;
                return d;
            });
        };
        ib.prototype.getTimeInterval = function(a) {
            var b;
            if (a = null == (b = this.B.getLocatorFactory().parse(a).locator) ? void 0 : b.getSelectors()) {
                for(b = p(a), a = b.next(); !a.done; a = b.next())if (a = a.value, a instanceof z.MediaFragmentSelector) return a.getTimeInterval() || void 0;
            }
        };
        function W(a) {
            return a && 1 === a.nodeType && !/^(?:article|aside|nav|section)$/.test(a.localName) && !/^(?:blockquote|body|details|dialog|fieldset|figure|td)$/.test(a.localName) && !a.hasAttribute("hidden");
        }
        function Y(a) {
            var b = this;
            this.h = a;
            this.g = [];
            a.forEach(function(c) {
                b.g.push.apply(b.g, ia(c.getChildren()));
            });
            this.g = this.g.sort(function(c, d) {
                return c.getId() - d.getId();
            });
        }
        function nb(a, b, c) {
            var d = a.getBackingResourceProvider(), e = a.getNavigationResourceUrl();
            if (e) return d.fetch(e).then(function(h) {
                return h.asText().then(function(g) {
                    var l = new Ja.XhtmlParser(g, e.pathname, !0);
                    if (g = l.getDocument()) {
                        var k = new ib(g, e, b, c), m = [], n = k.h.querySelector('[role="doc-toc"]');
                        n && (k = mb(k, n)) && m.push(k);
                        return new Y(m);
                    }
                    g = h.getMetadata();
                    l = null == (k = l.getParserError()) ? void 0 : null == (n = k.documentElement) ? void 0 : n.textContent;
                    k = new M("INVALID_NAVIGATION_DOCUMENT", 'Failed to parse the file "' + (null != (m = g.pathRelativeToBaseUrl) ? m : g.url) + '" as HTML: ' + l);
                    return Promise.reject(k);
                });
            });
            if (a = ob(c)) return Promise.resolve(a);
            a = new M("INVALID_NAVIGATION_DOCUMENT", "The publication does not have any navigation document");
            return Promise.reject(a);
        }
        function ob(a) {
            a = a.reduce(function(b, c, d) {
                var e = c.getSourceContentDocument().getLinkedResource().name;
                e && (d = new hb([], d, !0, e[0].value, null), c = c.getLocator(), d.g = c, b.push(d));
                return b;
            }, []);
            if (0 < a.length) return new Y([
                new gb(a, null, G.NavigationCollectionType.TOC)
            ]);
        }
        Y.prototype.getNavigationCollections = function() {
            return this.h;
        };
        Y.prototype.getNavigationItemById = function(a) {
            return this.g[a - 1];
        };
        Y.prototype.toJSON = function() {
            return {
                navigationCollections: this.h.map(function(a) {
                    return a.toJSON();
                })
            };
        };
        function Z(a) {
            this.g = a;
            this.u = null;
        }
        Z.prototype.getDuration = function() {
            return this.u;
        };
        Z.prototype.getResourceMetadata = function() {
            return this.g;
        };
        Z.prototype.toJSON = function() {
            return {
                durationMs: this.u,
                resourceMetadata: this.g
            };
        };
        function pb(a, b, c) {
            this.u = a;
            this.h = b;
            this.g = c;
        }
        f = pb.prototype;
        f.getApproximateDurationMs = function() {
            return this.u;
        };
        f.getDurationType = function() {
            return G.SyncMediaSegmentDurationType.FIXED;
        };
        f.getMediaObjectRefs = function() {
            return [
                this.h
            ];
        };
        f.getReaderDocumentIndexInSpine = function() {
            return this.g;
        };
        f.toJSON = function() {
            return {
                approximateDurationMs: this.u,
                durationType: G.SyncMediaSegmentDurationType.FIXED,
                readerDocumentIndexInSpine: this.g,
                refs: [
                    this.h
                ]
            };
        };
        function qb(a, b) {
            this.h = a;
            this.g = b;
            this.i = this.g.getSpine().reduce(function(c, d) {
                return c + d.getDurationMs();
            }, 0);
        }
        function rb(a, b) {
            var c;
            K.ReadingSystemUtils.isContentLocation(b) ? c = Promise.resolve(b) : K.ReadingSystemUtils.isUnresolvedContentLocation(b) ? c = b.resolve() : c = a.g.fetchContentLocation(b);
            return c.then(function(d) {
                return sb(a, d);
            });
        }
        function ub(a, b) {
            var c;
            K.ReadingSystemUtils.isContentLocation(b) ? c = Promise.resolve(b) : K.ReadingSystemUtils.isUnresolvedContentLocation(b) ? c = b.resolve() : c = a.g.fetchContentLocation(b);
            return c.then(function(d) {
                var e = d.collapseToStart(), h = d.collapseToEnd();
                return d.isRange() ? Promise.all([
                    sb(a, e),
                    sb(a, h)
                ]).then(function(g) {
                    return {
                        end: g[1],
                        start: g[0]
                    };
                }) : sb(a, e).then(function(g) {
                    return {
                        end: g,
                        start: g
                    };
                });
            });
        }
        function vb(a, b) {
            b = new z.MediaFragmentSelector({
                timeInterval: {
                    endMs: b,
                    startMs: b
                }
            }, []);
            return new x.Locator(a.g.getDefaultLocatorUrl(), [
                b
            ]);
        }
        function sb(a, b) {
            var c = b.getReaderDocuments()[0];
            if (!(b instanceof S) || c.getReaderPublication() !== a.g) return Promise.reject(new M("INCOMPATIBLE_LOCATION", "The location does not target this publication"));
            var d = c.getIndexInSpine();
            c = a.h.getSegments();
            var e = !1, h = Ka(c, c.length, function(g, l) {
                g = g[l].getReaderDocumentIndexInSpine();
                if (g > d) return -1;
                if (g < d) return 1;
                e = !0;
                return 0;
            });
            b = b.g.j;
            e || (b = 0);
            b = h >= c.length ? 0 : La(b, c[h].getApproximateDurationMs() - 1);
            return Promise.resolve(new K.SyncMediaTimelinePosition(a.h, h, b));
        }
        function wb(a, b, c, d, e, h) {
            this.A = a;
            this.h = b;
            this.i = c;
            this.v = d;
            this.J = e;
            this.C = h;
            this.g = 0;
            if (0 === this.h.length) throw new M("INVALID_SYNC_MEDIA_TIMELINE", "The resulting SyncMediaTimeline have no segments.");
            this.l = new qb(this, this.i);
            this.m = new K.SyncMediaTimelineTimeMapper(this);
            a = p(this.h);
            for(b = a.next(); !b.done; b = a.next())this.g += b.value.getApproximateDurationMs();
        }
        f = wb.prototype;
        f.createDefaultMediaObjectRenderers = function() {
            return [
                new K.SyncMediaAudioRenderer(this.C.defaultAudioRendererOptions)
            ];
        };
        f.fetchContentLocation = function(a) {
            a: {
                var b = this.l;
                var c = a.getSegmentIndex(), d = b.g.getSpine();
                a = a.getOffsetWithinSegmentMs();
                var e = b.h.getSegments();
                if (c < e.length) c = e[c], c = c.getReaderDocumentIndexInSpine();
                else {
                    a = L(e).getReaderDocumentIndexInSpine();
                    if (a >= d.length - 1) {
                        d = vb(b, b.i);
                        b = b.g.fetchContentLocation(d);
                        break a;
                    }
                    c = a + 1;
                    a = 0;
                }
                for(var h = e = 0; h < c;)e += d[h].getDurationMs(), h++;
                a = La(a, d[c].getDurationMs() - 1);
                d = vb(b, e + a);
                b = b.g.fetchContentLocation(d);
            }
            return b;
        };
        f.fetchTimelinePosition = function(a) {
            return rb(this.l, a);
        };
        f.fetchTimelineRange = function(a) {
            return ub(this.l, a);
        };
        f.getApproximateDurationMs = function() {
            return this.g;
        };
        f.getApproximateOffsetMs = function(a) {
            return this.m.getApproximateElapsedTimeMsForTimelinePosition(a);
        };
        f.getMediaObjectRefTypes = function() {
            return [
                G.SyncMediaObjectRefType.AUDIO
            ];
        };
        f.getMediaObjects = function() {
            return this.A;
        };
        f.getReaderDocuments = function() {
            return this.v;
        };
        f.getReaderPublication = function() {
            return this.i;
        };
        f.getResourceProvider = function() {
            return this.J;
        };
        f.getSegments = function() {
            return this.h;
        };
        f.getSyncMediaFormat = function() {
            return G.SyncMediaFormat.WP_AUDIOBOOK;
        };
        f.getTimelinePositionFromApproximateOffsetMs = function(a) {
            return this.m.getTimelinePositionForApproximateTimeMs(a);
        };
        f.toJSON = function() {
            return {
                approximateDurationMs: this.g,
                mediaObjectRefTypes: this.getMediaObjectRefTypes(),
                mediaObjects: this.A.map(function(a) {
                    return a.toJSON();
                }),
                publicationHashSignature: this.i.getSourcePublication().getHashSignature(),
                readerDocumentIndexes: this.v.map(function(a) {
                    return a.getIndexInSpine();
                }),
                readerPublicationDefaultLocatorUrl: this.i.getDefaultLocatorUrl(),
                segments: this.h.map(function(a) {
                    return a.toJSON();
                }),
                syncMediaFormat: G.SyncMediaFormat.WP_AUDIOBOOK
            };
        };
        f.updateSegmentDuration = function(a, b) {
            var c = this.h[a];
            if (c) {
                var d = c.getApproximateDurationMs();
                this.m._onSegmentDurationChanged({
                    newDurationMs: b,
                    oldDurationMs: d,
                    segmentIndex: a
                });
                this.g += b - c.getApproximateDurationMs();
                c.u = b;
            }
        };
        function xb(a, b, c, d, e) {
            var h, g, l, k, m, n, C, E, u;
            return v(function(r) {
                switch(r.g){
                    case 1:
                        if (0 === b.length) throw new M("INVALID_SYNC_MEDIA_TIMELINE", "Can not create a timeline with no ReaderDocuments");
                        g = K.SyncMediaTimelineUtils.getOrGenerateTimelineName(null == (h = d) ? void 0 : h.name);
                        l = [];
                        k = [];
                        K.SyncMediaTimelineUtils.sendProgressEvent(a, g, e, 0);
                        m = {};
                        n = 0;
                    case 2:
                        if (!(n < b.length)) {
                            r.g = 4;
                            break;
                        }
                        m.G = b[n];
                        C = m.G.getDurationMs();
                        E = {
                            endMs: C,
                            objectIndex: n,
                            startMs: 0,
                            type: G.SyncMediaObjectRefType.AUDIO
                        };
                        k.push(new pb(C, E, m.G.getIndexInSpine()));
                        return za(r, c.fetchMetadata(m.G.getSourceContentDocument().getContentUrl(), {
                            accept: [
                                Fa.MediaTypeCategory.AUDIO
                            ]
                        }).then(function(F) {
                            l.push(new Z(F));
                        }).catch(function(F) {
                            return function(H) {
                                w.ColibrioError.isColibrioAbortedError(H) || w.Logger.logError(H);
                                return new Z({
                                    url: F.G.getSourceContentDocument().getContentUrl().toString()
                                });
                            };
                        }(m)), 5);
                    case 5:
                        u = (n + 1) / b.length;
                        K.SyncMediaTimelineUtils.sendProgressEvent(a, g, e, u);
                        m = {
                            G: void 0
                        };
                        n++;
                        r.g = 2;
                        break;
                    case 4:
                        return r.return(new wb(l, k, a, b, c, d));
                }
            });
        }
        function yb(a) {
            var b = 0, c = !1;
            a = a.replace(/,/g, ".");
            for(var d = 0, e = 0; e < a.length; e++)switch(a[e]){
                case "Y":
                    b = zb(a, b, e + 1);
                    d += 31556952E3 * b;
                    b = e + 1;
                    break;
                case "D":
                    b = zb(a, b, e + 1);
                    d += 864E5 * b;
                    b = e + 1;
                    break;
                case "H":
                    b = zb(a, b, e + 1);
                    d += 36E5 * b;
                    b = e + 1;
                    break;
                case "M":
                    b = zb(a, b, e + 1);
                    d = c ? d + 6E4 * b : d + 2629746E3 * b;
                    b = e + 1;
                    break;
                case "S":
                    b = zb(a, b, e + 1);
                    d += 1E3 * b;
                    b = e + 1;
                    break;
                case "P":
                    b = e + 1;
                    break;
                case "T":
                    c = !0, b = e + 1;
            }
            return d;
        }
        function zb(a, b, c) {
            a = parseFloat(a.slice(b, c));
            return isNaN(a) ? 0 : a;
        }
        function Ab(a, b, c, d, e) {
            this.K = a;
            this.g = b;
            this.B = c;
            this.h = d;
            this.u = e;
            this.l = this.i = null;
            this.m = void 0;
            this.s = [];
        }
        f = Ab.prototype;
        f.canHaveMultipleRenderingSections = function() {
            return !1;
        };
        f.createRenderableDocument = function() {
            var a = new M("UNSUPPORTED_PUBLICATION_TYPE", "renderable documents are not available for Web Publication Audiobook publications.");
            return Promise.reject(a);
        };
        f.fetchContentBlockTree = function() {
            return Promise.resolve(new K.EmptyContentBlockTree(this));
        };
        f.fetchContentBlocks = function() {
            return Promise.resolve([]);
        };
        f.fetchContentLocationForEntireDocument = function() {
            if (!this.l) {
                var a = Bb(this);
                a = new z.MediaFragmentSelector({
                    timeInterval: {
                        endMs: a + this.u,
                        startMs: a
                    }
                }, []);
                a = new x.Locator(this.g.getDefaultLocatorUrl(), [
                    a
                ]);
                this.l = this.g.fetchContentLocation(a);
            }
            return this.l;
        };
        f.fetchEstimatedHeight = function() {
            return Promise.resolve(0);
        };
        f.fetchEstimatedNumberOfPages = function() {
            return Promise.resolve(0);
        };
        f.fetchLocatorForContentBlockData = function() {
            var a = new M("UNSUPPORTED_METHOD", "content block data are not available for Web Publication Audiobook publications.");
            return Promise.reject(a);
        };
        f.fetchViewportDimensions = function() {
            return Promise.resolve(null);
        };
        f.getAvailableSyncMediaFormats = function() {
            return [
                G.SyncMediaFormat.WP_AUDIOBOOK
            ];
        };
        f.getContentLocation = function() {
            if (!this.i) {
                var a = Bb(this);
                a = new z.MediaFragmentSelector({
                    timeInterval: {
                        endMs: a,
                        startMs: a
                    }
                }, []);
                a = new x.Locator(this.g.getDefaultLocatorUrl(), [
                    a
                ]);
                this.i = new S(a, this.g, {
                    j: 0,
                    o: this.h
                }, null);
            }
            return this.i;
        };
        f.getDurationMs = function() {
            return this.u;
        };
        f.getIndexInSpine = function() {
            return this.h;
        };
        f.getLocator = function() {
            this.m || (this.m = db(this.B, this, this.s));
            return this.m;
        };
        f.getReaderPublication = function() {
            return this.g;
        };
        f.getSourceContentDocument = function() {
            return this.K;
        };
        f.isReflowable = function() {
            return !1;
        };
        f.isRenderable = function() {
            return !1;
        };
        f.N = function(a) {
            this.s = a;
        };
        f.toJSON = function() {
            return {
                availableSyncMediaFormats: this.getAvailableSyncMediaFormats(),
                indexInSpine: this.getIndexInSpine(),
                locator: this.getLocator().toJSON(),
                reflowable: this.isReflowable(),
                renderable: this.isRenderable(),
                sourceContentDocumentIndexInSpine: this.getSourceContentDocument().getIndexInSpine()
            };
        };
        function Bb(a) {
            for(var b = 0, c = 0; c < a.h; c++)b += a.s[c].getDurationMs();
            return b;
        }
        var Cb = w.Logger.logError, Db = w.Logger.logWarning;
        function Eb(a, b, c, d) {
            var e;
            return v(function(h) {
                e = Fb(a, c);
                return h.return(e.then(function(g) {
                    return p(g.reduce(function(l, k) {
                        var m = p(l);
                        l = m.next().value;
                        m = m.next().value;
                        k.T ? (k = k.get(), k = new Ab(k.K, b, d, m, k.u)) : (Cb("Failed to create audiobook reader document: ", k.R), k = null);
                        return k ? (l.push(k), [
                            l,
                            m + 1
                        ]) : [
                            l,
                            m
                        ];
                    }, [
                        [],
                        0
                    ])).next().value;
                }));
            });
        }
        function Gb(a, b) {
            var c = document.createElement("audio"), d = new K.MediaSourceFactory(b, void 0, {}), e = d.createUrl(c, a.url), h, g;
            return e.urlPromise.then(function(l) {
                return new Promise(function(k, m) {
                    h = function() {
                        return k(c);
                    };
                    g = function() {
                        return m(c.error);
                    };
                    c.addEventListener("loadedmetadata", h);
                    c.addEventListener("abort", g);
                    c.addEventListener("error", g);
                    c.src = l;
                }).then(function(k) {
                    return Math.floor(1E3 * k.duration);
                }).catch(function(k) {
                    return Promise.reject(k);
                }).finally(function() {
                    h && c.removeEventListener("loadedmetadata", h);
                    g && (c.removeEventListener("abort", g), c.removeEventListener("error", g));
                    d.revokeUrl(e.mediaSourceId);
                    c.src = "";
                });
            });
        }
        function Fb(a, b) {
            var c, d, e, h, g, l;
            return v(function(k) {
                switch(k.g){
                    case 1:
                        c = [], d = p(a), e = d.next();
                    case 2:
                        if (e.done) {
                            k.g = 4;
                            break;
                        }
                        h = e.value;
                        k.m = 5;
                        var m = h;
                        Hb(m) ? m = Ib(m.getLinkedResource(), b) : (m = "Unsupported publication type. " + m.getContentUrl().pathname + ": " + m.getMediaType(), m = Promise.reject(m));
                        return za(k, m, 7);
                    case 7:
                        g = k.v;
                        c.push(new Sa(!0, {
                            K: h,
                            u: g
                        }));
                        k.g = 3;
                        k.m = 0;
                        break;
                    case 5:
                        k.m = 0, m = k.i.P, k.i = null, l = m, c.push(new Sa(!1, void 0, l));
                    case 3:
                        e = d.next();
                        k.g = 2;
                        break;
                    case 4:
                        return k.return(c);
                }
            });
        }
        function Hb(a) {
            var b = a.getMediaType();
            return Ga.MediaTypeDetector.getMediaTypesFromCategory(Fa.MediaTypeCategory.AUDIO).some(function(c) {
                return c === b;
            });
        }
        function Ib(a, b) {
            return v(function(c) {
                if (a.duration) {
                    if (/^P(?!$)(\d+(?:\.\d+)?Y)?(\d+(?:\.\d+)?M)?(\d+(?:\.\d+)?W)?(\d+(?:\.\d+)?D)?(T(?=\d)(\d+(?:\.\d+)?H)?(\d+(?:\.\d+)?M)?(\d+(?:\.\d+)?S)?)?$/.test(a.duration)) return c.return(Promise.resolve(yb(a.duration)));
                    Db("Invalid ISO 8601 duration: " + a.duration + ", using the audio file's duration");
                    return c.return(Gb(a, b).then(function(d) {
                        return d;
                    }));
                }
                Db("No duration for document, using the audio file's duration");
                return c.return(Gb(a, b).then(function(d) {
                    return d;
                }));
            });
        }
        var Jb = w.Logger.logError;
        function Kb(a, b, c, d, e, h) {
            this.I = a;
            this.O = b;
            this.H = c;
            this.B = d;
            this.D = e;
            this.C = h;
            this.L = !1;
            this.F = null;
            this.s = [];
            this.S = new K.EmptyPublicationStorage;
        }
        function Lb(a, b, c) {
            var d, e, h, g, l, k;
            return v(function(m) {
                d = Qa(c, Mb(a.getHashSignature()));
                e = d.defaultLocatorUrl;
                h = new Ia.SelectorFactory([
                    new z.MediaFragmentSelectorParser
                ]);
                g = new x.LocatorFactory(h);
                l = new bb(e, g);
                k = new Kb(a, b, g, l, e, d);
                return m.return(Eb(a.getSpine(), k, a.getBackingResourceProvider(), l).then(function(n) {
                    k.N(n);
                    return k;
                }).catch(function(n) {
                    Jb("Failed to load spine", n);
                    return k;
                }));
            });
        }
        function Mb(a) {
            return {
                additionalLocatorUrls: [],
                clipboardOptions: {
                    allowCopy: !0,
                    textToAppendOnCopy: null,
                    textToPrependOnCopy: null
                },
                defaultLocatorUrl: "com.colibrio.wp-audiobook.signature:" + a,
                preventDefaultContextMenu: !1,
                preventDragAndDropActions: !1
            };
        }
        f = Kb.prototype;
        f.createSyncMediaTimeline = function(a, b, c) {
            var d = K.ReadingSystemUtils.getReaderDocumentListErrorForTimelineCreation(a, this);
            return d ? Promise.reject(d) : xb(this, a, this.getSourcePublication().getBackingResourceProvider(), b || {}, c);
        };
        f.destroy = function() {
            this.L || (this.L = !0, this.O.unloadPublication(this));
        };
        f.fetchContentLocation = function(a) {
            return this.fetchUnresolvedContentLocation(a).then(function(b) {
                return b.resolve();
            });
        };
        f.fetchPreferredPageAspectRatio = function() {
            return Promise.resolve(null);
        };
        f.fetchPublicationNavigation = function() {
            var a = this;
            this.F || (this.F = nb(this.I, this.B, this.getSpine()), this.F.catch(function() {
                return a.F = null;
            }));
            return this.F;
        };
        f.fetchUnresolvedContentLocation = function(a) {
            a = K.LocatorUtils.getLocator(a);
            if (null === a) return Promise.reject(new K.EngineError(K.EngineErrorType.NAVIGATION_ITEM_MISSING_LOCATOR));
            a = this.H.parse(a, this.D);
            if (!a.locator) return Promise.reject(a.error);
            a = a.locator;
            var b = a.getSelectors().find(function(n) {
                return n instanceof z.MediaFragmentSelector;
            });
            if (!(b instanceof z.MediaFragmentSelector)) return Promise.reject(new M("UNSUPPORTED_AUDIOBOOK_SELECTOR", JSON.stringify(a.getSelectors())));
            (b = b.getTimeInterval()) || (b = {
                endMs: void 0,
                startMs: 0
            });
            if (void 0 !== b.endMs && b.endMs < b.startMs) return Promise.reject(new M("UNSUPPORTED_AUDIOBOOK_SELECTOR", "end time is before start time"));
            for(var c = {
                j: L(this.s).getDurationMs(),
                o: this.s.length - 1
            }, d = {
                j: L(this.s).getDurationMs(),
                o: this.s.length - 1
            }, e = !1, h = !1, g = 0, l = 0; l < this.s.length; l++){
                var k = this.s[l], m = k.getDurationMs() - 1;
                !e && g + m >= b.startMs && (e = !0, c = {
                    j: b.startMs - g,
                    o: l
                });
                !h && void 0 !== b.endMs && g + m >= b.endMs && (h = b.endMs - g, h === c.j && l === c.o ? d = null : d = {
                    j: h,
                    o: l
                }, h = !0);
                if (e && (h || void 0 === b.endMs)) break;
                g += k.getDurationMs();
            }
            return Promise.resolve(new Za(a, this, c, d));
        };
        f.getAvailableContentPositionTimelineUnits = function() {
            return [];
        };
        f.getAvailableSyncMediaFormats = function() {
            return [
                G.SyncMediaFormat.WP_AUDIOBOOK
            ];
        };
        f.getDefaultLocatorUrl = function() {
            return this.D;
        };
        f.getLocatorFactory = function() {
            return this.H;
        };
        f.getOptions = function() {
            return this.C;
        };
        f.getReaderPublicationStorage = function() {
            return this.S;
        };
        f.getReadingSystemEngine = function() {
            return this.O;
        };
        f.getSourcePublication = function() {
            return this.I;
        };
        f.getSpine = function() {
            return this.s.slice();
        };
        f.isDestroyed = function() {
            return this.L;
        };
        f.isLocatorSourceUrlInPublication = function(a) {
            return K.LocatorUtils.isLocatorSourceUrlInPublication(a, this.B.getLocatorFactory(), this.D, this.C.additionalLocatorUrls);
        };
        f.setOptions = function(a) {
            a.defaultLocatorUrl = this.C.defaultLocatorUrl;
            a = Qa(a, this.C, !0);
            this.C = Qa(a, Mb(this.I.getHashSignature()));
        };
        f.toJSON = function() {
            return {
                availableContentPositionTimelineUnits: this.getAvailableContentPositionTimelineUnits(),
                availableSyncMediaFormats: this.getAvailableSyncMediaFormats(),
                defaultLocatorUrl: this.D,
                sourcePublicationHashSignature: this.I.getHashSignature(),
                spine: this.getSpine().map(function(a) {
                    return a.toJSON();
                })
            };
        };
        f.N = function(a) {
            this.s = a;
            a.forEach(function(b) {
                return b.N(a);
            });
        };
        function Nb() {}
        Nb.prototype.createReaderPublication = function(a, b, c) {
            return Lb(a, b, c);
        };
        Nb.prototype.isPublicationSupported = function(a) {
            return a.getType() === Ha.PublicationType.WP;
        };
        api = {
            WpAudiobookFormatAdapter: Nb,
            WpAudiobookFormatAdapterError: M,
            WpAudiobookFormatAdapterErrorType: {
                DOCUMENT_NOT_IN_PUBLICATION: "DOCUMENT_NOT_IN_PUBLICATION",
                INCOMPATIBLE_LOCATION: "INCOMPATIBLE_LOCATION",
                INVALID_NAVIGATION_DOCUMENT: "INVALID_NAVIGATION_DOCUMENT",
                INVALID_SYNC_MEDIA_TIMELINE: "INVALID_SYNC_MEDIA_TIMELINE",
                INVALID_URL_IN_PUBLICATION_RESOURCE: "INVALID_URL_IN_PUBLICATION_RESOURCE",
                SYNC_MEDIA_SEGMENT_NOT_IN_TIMELINE: "SYNC_MEDIA_SEGMENT_NOT_IN_TIMELINE",
                TARGET_DOCUMENT_NOT_FOUND: "TARGET_DOCUMENT_NOT_FOUND",
                UNSUPPORTED_AUDIOBOOK_SELECTOR: "UNSUPPORTED_AUDIOBOOK_SELECTOR",
                UNSUPPORTED_METHOD: "UNSUPPORTED_METHOD",
                UNSUPPORTED_PUBLICATION_TYPE: "UNSUPPORTED_PUBLICATION_TYPE",
                WRONG_SYNC_MEDIA_SEGMENT_TYPE: "WRONG_SYNC_MEDIA_SEGMENT_TYPE"
            }
        };
        var Ob = new ArrayBuffer(8);
        new DataView(Ob);
        new Uint8Array(Ob);
    }).call(__self);
    return api;
});


const { WpAudiobookFormatAdapter: $98c649c5274356f6$export$456372773820dea5, WpAudiobookFormatAdapterError: $98c649c5274356f6$export$c8f3d5a38d533fca, WpAudiobookFormatAdapterErrorType: $98c649c5274356f6$export$8db66caf70568a5b } = (0, (/*@__PURE__*/$parcel$interopDefault($e16339ee60d0cab6$exports)));


class $1938aacd5d915abb$export$7587955500404ec3 {
    static sendRangeRequest(url, start, end) {
        return new Promise((resolve, reject)=>{
            let request = $1938aacd5d915abb$export$7587955500404ec3.createRequest("GET", url, reject);
            request.setRequestHeader("Range", `bytes=${start}-${end}`);
            request.onload = ()=>{
                resolve(request.response);
            };
            request.send();
        });
    }
    static sendHeadRequest(url) {
        return new Promise((resolve, reject)=>{
            let request = $1938aacd5d915abb$export$7587955500404ec3.createRequest("HEAD", url, reject);
            request.onload = ()=>{
                try {
                    let contentLengthStr = request.getResponseHeader("Content-Length");
                    if (!contentLengthStr) {
                        reject("Missing Content-Length header");
                        return;
                    }
                    let contentLength = parseInt(contentLengthStr, 10);
                    if (isNaN(contentLength)) reject("Invalid Content-Length: " + contentLengthStr);
                    resolve({
                        contentLength: contentLength,
                        contentType: request.getResponseHeader("Content-Type")
                    });
                } catch (e) {
                    reject(e);
                }
            };
            request.send();
        });
    }
    static createRequest(verb, url, rejectFn) {
        let request = new XMLHttpRequest();
        request.open(verb, url, true);
        request.responseType = "arraybuffer";
        request.onerror = ()=>{
            rejectFn(request.status + ": " + request.statusText);
        };
        request.onabort = ()=>{
            rejectFn(request.status + ": " + request.statusText);
        };
        request.ontimeout = ()=>{
            rejectFn("TIMEOUT");
        };
        return request;
    }
}


class $e7d53bebb8fdaac8$export$1c493a9933b41063 {
    constructor(storageClient, url, size = 0, chunkDescriptors){
        this.url = url;
        this.size = size;
        this._numPriorityRequests = 0;
        this._totalNumOfChunks = 0;
        this._numOfChunksDownloaded = 0;
        this._chunkCache = new Map();
        this._chunkDescriptorsToPreload = [];
        this._isPreloading = false;
        this._appStorage = storageClient;
        if (chunkDescriptors) {
            this._chunkDescriptorsToPreload = chunkDescriptors;
            this._totalNumOfChunks = chunkDescriptors.length;
            this._totalNumOfChunks = this._chunkDescriptorsToPreload.length;
        }
    }
    setChunkDescriptors(chunkDescriptors) {
        if (chunkDescriptors) {
            this._chunkDescriptorsToPreload = chunkDescriptors;
            this._totalNumOfChunks = chunkDescriptors.length;
            this._totalNumOfChunks = this._chunkDescriptorsToPreload.length;
        }
    }
    onPreloadProgressUpdated(callback) {
        this._preloadProgressCallback = callback;
    }
    async fetchChunk(startOffset, _endOffset) {
        this._numPriorityRequests++;
        // Check for the chunk in the db
        try {
            let result = await this._appStorage.fetchChunkAtOffset(startOffset);
            this._numPriorityRequests--;
            await this._preload();
            if (result) {
                console.log("HttpCachingRandomAccessDataSource.fetchChunk returning cached data");
                return result.data;
            }
        } catch (e) {
            console.log("HttpCachingRandomAccessDataSource.fetchChunk: getPublicationDataByStartOffset returned nothing", e);
        }
        // Check for the chunk in the cache
        if (this._chunkCache.has(startOffset)) {
            console.log("HttpCachingRandomAccessDataSource.fetchChunk: found " + startOffset + " in the cache");
            this._numPriorityRequests--;
            this._preload().catch(console.error);
            return this._chunkCache.get(startOffset);
        }
        // It wasn't in the cache so let's initiate a request and place it in the cache to be resolved
        console.log("HttpCachingRandomAccessDataSource.fetchChunk: Nothing found in cache, calling sendHttpRangeRequest()");
        let chunkRequestPromise = this.sendHttpRangeRequest(startOffset, _endOffset).finally(()=>{
            this._numPriorityRequests--;
            this._preload().catch(console.error);
            this._updatePreloadProgress();
        });
        this._chunkCache.set(startOffset, chunkRequestPromise);
        return chunkRequestPromise;
    }
    sendHttpRangeRequest(startOffset, endOffset) {
        return (0, $1938aacd5d915abb$export$7587955500404ec3).sendRangeRequest(this.url, startOffset, endOffset - 1).then((arrayBuffer)=>{
            // Add resolved result to the AppStorage
            this._appStorage.addChunk(startOffset, endOffset, arrayBuffer).then(()=>{
                this._chunkCache.delete(startOffset);
            }).catch((err)=>{
                console.warn("HttpCachingRandomAccessDataSource.sendHttpRangeRequest: ", err);
            });
            return arrayBuffer;
        }).catch((err)=>{
            return new Promise((_resolve, reject)=>{
                window.setTimeout(()=>reject(err), 2000);
            });
        });
    }
    getSize() {
        return this.size;
    }
    _updatePreloadProgress() {
        this._numOfChunksDownloaded++;
        if (this._preloadProgressCallback) this._preloadProgressCallback(this._numOfChunksDownloaded / this._totalNumOfChunks, this.url);
    }
    async _preload() {
        // If there are no ongoing requests we can continue preloading resources
        if (this._numPriorityRequests > 0 || this._chunkDescriptorsToPreload.length === 0 || this._isPreloading) return;
        this._isPreloading = true;
        let chunkDesc;
        let foundEntryToPreload = false;
        // Also handles clean-up of descriptors that have already been downloaded.
        while(!foundEntryToPreload && this._chunkDescriptorsToPreload.length > 0){
            chunkDesc = this._chunkDescriptorsToPreload.shift();
            if (!this._chunkCache.has(chunkDesc.start)) {
                let storedInDb = await this._appStorage.hasChunkAtOffset(chunkDesc.start);
                foundEntryToPreload = !storedInDb;
                if (!storedInDb) console.log("HttpCachingRandomAccessDataSource._preload", "Entry NOT stored in db: " + chunkDesc.start);
            }
        }
        if (chunkDesc && foundEntryToPreload) {
            if (this._numPriorityRequests > 0) {
                this._chunkDescriptorsToPreload.unshift(chunkDesc);
                this._isPreloading = false;
            } else if (!this._chunkCache.has(chunkDesc.start)) {
                console.log("HttpCachingRandomAccessDataSource._preload", "Preloading starting for offset: ", chunkDesc.start);
                let chunkRequestPromise = this.sendHttpRangeRequest(chunkDesc.start, chunkDesc.end).catch((err)=>{
                    this._chunkDescriptorsToPreload.unshift(chunkDesc);
                    return Promise.reject(err);
                }).finally(()=>{
                    console.log("HttpCachingRandomAccessDataSource._preload", "Preloading finished for offset: ", chunkDesc.start);
                    this._updatePreloadProgress();
                    this._isPreloading = false;
                    this._preload().catch(console.error);
                });
                this._chunkCache.set(chunkDesc.start, chunkRequestPromise);
            // console.log('preload', chunkDesc.start);
            } else {
                this._isPreloading = false;
                console.log("HttpCachingRandomAccessDataSource._preload", chunkDesc.start + " was already in the cache");
            }
        } else this._isPreloading = false;
    }
    async preload() {
        console.log("HttpCachingRandomAccessDataSource.preload", "number of ChunkDescriptors", this._chunkDescriptorsToPreload.length);
        await this._preload();
    }
}



class $5ae55c0801306360$export$163500108bc478dc {
    constructor(url, size){
        this.url = url;
        this.size = size;
    }
    /**
     * Fetch a chunk of data from the data source between a start and end offset.
     * This method must not throw an exception in case of a non-recoverable error.
     *
     * @param startOffset - An index into the data source indicating the first byte to include in the result buffer
     * @param endOffset - An index into the data source indicating the first byte that will *not* be included in the result buffer. Must be larger than 'start', and less than or equal to the value returned by getSize().
     * @return Resolved with an ArrayBuffer containing the requested data. Rejected if it is not possible to fetch the requested data.
     */ fetchChunk(startOffset, endOffset) {
        return (0, $1938aacd5d915abb$export$7587955500404ec3).sendRangeRequest(this.url, startOffset, endOffset - 1);
    }
    /**
     * Get the size of the data in bytes.
     */ getSize() {
        return this.size;
    }
}




var $7uZag = parcelRequire("7uZag");
const { MediaTypeDetector: $515eead6db681c17$export$433a31b80ab1705d, MediaTypeDetectorError: $515eead6db681c17$export$99750d99ade8c929, MediaTypeDetectorErrorType: $515eead6db681c17$export$554a660f698fceb0 } = (0, (/*@__PURE__*/$parcel$interopDefault($7uZag)));


class $4286f65dd2c5d352$export$97716d06f30ebaad {
    static fromUrl(url) {
        // Try fetch some data and figure out the format
        return (0, $1938aacd5d915abb$export$7587955500404ec3).sendHeadRequest(url).then((response)=>{
            return (0, $1938aacd5d915abb$export$7587955500404ec3).sendRangeRequest(url, 0, Math.min(response.contentLength, 16000)).then((buffer)=>{
                let mediaType = (0, $515eead6db681c17$export$433a31b80ab1705d).detectFromUint8Array(new Uint8Array(buffer));
                if (!mediaType) throw new Error("Unable to detect the media-type");
                return {
                    mediaType: mediaType,
                    size: response.contentLength
                };
            });
        });
    }
}





const $38cfb96512f51532$export$4d10705320489167 = {
    // Media will be streamed from the EPUB file when possible. This is currently supported for constant bitrate
    // MP3 audio that has been added to the EPUB using the ZIP "store" method.
    enableMediaStreaming: true,
    // Prevent users from right-clicking and downloading images and video etc.
    preventDefaultContextMenuOnMediaElements: true,
    // Reflow is the Colibrio module that paginates reflowable EPUBs. It is highly configurable. In the options
    // below we tell Reflow that it is ok to divide HTML elements as a default, except for the black listed
    // selectors specified.
    reflowOptions: {
        plugins: {
            fragmentableElements: {
                allowByDefault: true,
                blacklistSelectors: [
                    "details",
                    "figure",
                    "mathml"
                ]
            },
            mediaShrink: {
                activationThreshold: .15,
                maxShrinkFactor: .7,
                penaltyAtMaxShrinkage: 10
            }
        }
    },
    // Sometimes you will want to override certain CSS in one or more publication. The following options
    // injects a CSS rule that "turns off" the focus marker *before* any of the publications own CSS, and
    // also injects CSS rules *after* the publications own CSS, thus overriding it.
    customPublicationCss: {
        enableNormalizeCss: false,
        injectionPointStart: [
            ":focus-visible {outline: none;}",
            "a:focus-visible {outline: initial;}"
        ],
        injectionPointEnd: [
            "col:empty {display: none;}",
            "details, figure {page-break-inside: avoid;}",
            "details[open] {height: auto; overflow-y: scroll; background-color: Canvas; }",
            "svg {text-rendering: optimizespeed; shape-rendering: optimizespeed; will-change: contents}"
        ]
    },
    remoteResourcesNonScriptedDocumentsOptions: {
        policyType: (0, $c285ff458aea1783$export$6c55d60f0ae7a3de).ALLOW_ALL
    },
    remoteResourcesScriptedDocumentsOptions: {
        policyType: (0, $c285ff458aea1783$export$6c55d60f0ae7a3de).ALLOW_ALL
    },
    contentBlockOptions: {
        disableDefaultAttributeFiltering: true,
        includePreContentBlocks: true,
        includeMathMlContentBlocks: true
    }
};
const $38cfb96512f51532$export$d4f3843f8950ba40 = {
    transformManagerOptions: {
        removeTransformOnNavigation: false,
        maxPanOffsetHorizontal: {
            unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
            value: 50
        },
        maxPanOffsetVertical: {
            unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
            value: 50
        }
    },
    gestureOptions: {
        panZoom: {
            allowSinglePointerPan: true,
            pointerTypes: {
                pen: true,
                mouse: true,
                touch: true
            }
        }
    },
    emitPointerMoveEventsOnHover: true
};
const $38cfb96512f51532$export$b3fe42a96808e529 = {
    pageBackgroundColor: "#fffff",
    ignoreAspectRatio: false
};



class $fcdd956fa7ae09fe$export$597a7f79900d6aad {
    static sendHeadRequest(url) {
        return new Promise((resolve, reject)=>{
            let request = $fcdd956fa7ae09fe$export$597a7f79900d6aad.createRequest("GET", url, reject);
            request.setRequestHeader("Range", `bytes=1-2`);
            request.onerror = (e)=>{
                console.warn(e);
            };
            request.onload = ()=>{
                try {
                    let contentLength = 0;
                    let contentRange = request.getResponseHeader("Content-Range");
                    if (contentRange) contentLength = parseInt(contentRange.slice(contentRange.indexOf("/") + 1), 10);
                    else {
                        reject("Missing Content-Range header");
                        return;
                    }
                    if (isNaN(contentLength)) {
                        reject("Invalid Content-Length: " + contentLength);
                        return;
                    }
                    resolve({
                        contentLength: contentLength,
                        contentType: request.getResponseHeader("Content-Type")
                    });
                } catch (e) {
                    reject("Unknown error: " + e);
                }
            };
            request.send();
        });
    }
    static sendRangeRequest(url, start, end) {
        return new Promise((resolve, reject)=>{
            let request = $fcdd956fa7ae09fe$export$597a7f79900d6aad.createRequest("GET", url, reject);
            request.setRequestHeader("Range", `bytes=${start}-${end}`);
            request.setRequestHeader("Accept", `application/pdf`);
            request.onload = ()=>{
                resolve(request.response);
            };
            request.send();
        });
    }
    static createRequest(verb, url, rejectFn) {
        let request = new XMLHttpRequest();
        request.open(verb, url, true);
        request.responseType = "arraybuffer";
        request.onerror = ()=>{
            rejectFn(request.status + ": " + request.statusText);
        };
        request.onabort = ()=>{
            rejectFn(request.status + ": " + request.statusText);
        };
        request.ontimeout = ()=>{
            rejectFn("TIMEOUT");
        };
        return request;
    }
}


class $fc8bd558eed898ab$export$cc54d9f6df5e6659 {
    static async fromUrl(url) {
        return (0, $fcdd956fa7ae09fe$export$597a7f79900d6aad).sendHeadRequest(url).then(async (response)=>{
            return (0, $fcdd956fa7ae09fe$export$597a7f79900d6aad).sendRangeRequest(url, 0, Math.min(response.contentLength, 16000)).then((buffer)=>{
                let mediaType = (0, $515eead6db681c17$export$433a31b80ab1705d).detectFromUint8Array(new Uint8Array(buffer));
                if (!mediaType) {
                    if (response.contentType) mediaType = response.contentType;
                    else throw new Error("Unable to detect the media-type");
                }
                return {
                    mediaType: mediaType,
                    size: response.contentLength
                };
            });
        });
    }
}



class $5d2a63b68ee7cb73$export$549b3ba6272f2872 {
    constructor(){
        this.headers = null;
    }
}
class $5d2a63b68ee7cb73$export$83afea118c1cea15 {
    constructor(url, size, options){
        this.url = url;
        this.size = size;
        this.options = options;
    }
    /**
     * Fetch a chunk of data from the data source between a start and end offset.
     * This method must not throw an exception in case of a non-recoverable error.
     *
     * @param startOffset - An index into the data source indicating the first byte to include in the result buffer
     * @param endOffset - An index into the data source indicating the first byte that will *not* be included in the result buffer. Must be larger than 'start', and less than or equal to the value returned by getSize().
     * @return Resolved with an ArrayBuffer containing the requested data. Rejected if it is not possible to fetch the requested data.
     */ fetchChunk(startOffset, endOffset) {
        return (0, $fcdd956fa7ae09fe$export$597a7f79900d6aad).sendRangeRequest(this.url, startOffset, endOffset - 1).catch((err)=>{
            // Is it time to fetch a new signed url?
            if (err.status == 403) {
                console.log("STATUS 403");
                return this.options.urlResolver(this.url).then((url)=>{
                    if (url) {
                        this.url = url;
                        return this.fetchChunk(startOffset, endOffset);
                    }
                    return new Promise(()=>{});
                });
            }
        });
    }
    /**
     * Get the size of the data in bytes.
     */ getSize() {
        return this.size;
    }
}


class $c0755b65389d3173$export$8e0d8beae376a163 {
    constructor(licenseApiKey, vanillaUserProfileData){
        this._navigationStartedCallback = undefined;
        this._navigationEndedCallback = undefined;
        this._readingPositionUpdatedCallback = undefined;
        this._navigationIntentCallback = undefined;
        this._selectionChangedCallback = undefined;
        this._clickCallback = undefined;
        this._pointerDownCallback = undefined;
        this._pointerUpCallback = undefined;
        this._pointerMoveCallback = undefined;
        this._visibleRangeChangedCallback = undefined;
        this._visibleContentRenderedCallback = undefined;
        this._visiblePagesChangedCallback = undefined;
        this._keyDownCallback = undefined;
        this._keyUpCallback = undefined;
        this._publicationDownloadProgressCallback = undefined;
        this._publicationRenderedCallback = undefined;
        this._activeViewTransformChangedCallback = undefined;
        // private _activeViewTransformResetCallback: VanillaVoidCallback | undefined = undefined;
        // private _currentActiveViewTransform: ITransformData | null = null;
        this._isOffline = false;
        /*
    *
    * EVENT HANDLERS
    *
    * */ this._event_onlineStateChanged = (ev)=>{
            this._isOffline = !ev.detail.isOnline;
        };
        this._colibrioReadingSystem_event_navigationIntent = (ev)=>{
            if (this._navigationIntentCallback) this._navigationIntentCallback(ev);
        };
        this._colibrioReadingSystem_event_readingPositionUpdated = (ev)=>{
            if (this._readingPositionUpdatedCallback) this._readingPositionUpdatedCallback(ev);
        };
        this._colibrioReadingSystem_event_navigationStarted = (ev)=>{
            if (this._navigationStartedCallback) this._navigationStartedCallback(ev);
        };
        this._colibrioReadingSystem_event_navigationEnded = (ev)=>{
            if (this._navigationEndedCallback) this._navigationEndedCallback(ev);
        };
        this._colibrioReadingSystem_event_click = (ev)=>{
            if (this._clickCallback) this._clickCallback(ev);
        };
        this._colibrioReadingSystem_event_pointerDown = (ev)=>{
            if (this._pointerDownCallback) this._pointerDownCallback(ev);
        };
        this._colibrioReadingSystem_event_pointerUp = (ev)=>{
            if (this._pointerUpCallback) this._pointerUpCallback(ev);
        };
        this._colibrioReadingSystem_event_pointerMove = (ev)=>{
            if (this._pointerMoveCallback) this._pointerMoveCallback(ev);
        };
        this._colibrioReadingSystem_event_visibleRangeChanged = (ev)=>{
            if (this._visibleRangeChangedCallback) this._visibleRangeChangedCallback(ev);
        };
        this._colibrioReadingSystem_event_visiblePagesChanged = (ev)=>{
            if (this._visiblePagesChangedCallback) this._visiblePagesChangedCallback(ev);
        };
        this._colibrioReadingSystem_event_visibleContentRendered = (ev)=>{
            if (this._visibleContentRenderedCallback) this._visibleContentRenderedCallback(ev);
        };
        this._colibrioReadingSystem_event_activeTransformChanged = (ev)=>{
            if (this._activeViewTransformChangedCallback) this._activeViewTransformChangedCallback(ev.transform);
        };
        this._colibrioReadingSystem_event_selectionChanged = (ev)=>{
            if (this._selectionChangedCallback) this._selectionChangedCallback(ev);
        };
        this._colibrioReadingSystem_event_keyDown = (ev)=>{
            if (this._keyDownCallback) this._keyDownCallback(ev);
        };
        this._colibrioReadingSystem_event_keyUp = (ev)=>{
            if (this._keyUpCallback) this._keyUpCallback(ev);
        };
        this._colibrioReadingSystem = new (0, $6978732dc0bb5e4e$export$f9f0294ddb2c14dc)({
            licenseApiKey: licenseApiKey,
            platformWorkaroundOptions: {
                prepareSyncMediaAudioElementsOnFirstUserInteraction: true
            }
        });
        // The IVanillaReaderUserProfileData holds the user token for the current user. This is provided by you and
        // is used in the communication with the Colibrio license server whenever a publication is loaded.
        this._vanillaReaderUserProfileData = vanillaUserProfileData;
        this.create();
        // Here we define the default EPUB publication options that will be used when an EPUB is loaded.
        this._colibrioEpubReaderPublicationOptions = (0, $38cfb96512f51532$export$4d10705320489167);
    }
    create() {
        /*
        *
        * The Colibrio Reader Framework is an event driven system. All state changes etc. within the framework are
        * communicated using so called `IEngineEvent`s (see the event type map in the API reference for a full list
        * https://learn.colibrio.com/api/3.0/interfaces/_colibrio_readingsystem_base_d_.iengineeventtypemap.html).
        *
        * Here we set up some listeners that we will need.
        *
        * */ /**
         * TODO Add license related events
         * licenseReadingSessionBlocked
         * licenseReadingSessionContinued
         * licenseReadingSessionOffline
         * licenseReadingSessionPending
         * licenseReadingSessionStarted
         * */ // Add listener for the event that tells us if the device has lost internet connectivity.
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_ONLINE_STATE_CHANGED", this._event_onlineStateChanged);
        // TODO These events should really be moved to VanillaReaderView since they are all ReaderView related.
        this._colibrioReadingSystem.addEngineEventListener("click", this._colibrioReadingSystem_event_click);
        this._colibrioReadingSystem.addEngineEventListener("keydown", this._colibrioReadingSystem_event_keyDown);
        this._colibrioReadingSystem.addEngineEventListener("keyup", this._colibrioReadingSystem_event_keyUp);
        this._colibrioReadingSystem.addEngineEventListener("navigationIntent", this._colibrioReadingSystem_event_navigationIntent);
        this._colibrioReadingSystem.addEngineEventListener("navigationStarted", this._colibrioReadingSystem_event_navigationStarted);
        this._colibrioReadingSystem.addEngineEventListener("navigationEnded", this._colibrioReadingSystem_event_navigationEnded);
        this._colibrioReadingSystem.addEngineEventListener("readingPositionChanged", this._colibrioReadingSystem_event_readingPositionUpdated);
        this._colibrioReadingSystem.addEngineEventListener("pointerdown", this._colibrioReadingSystem_event_pointerDown);
        this._colibrioReadingSystem.addEngineEventListener("pointerup", this._colibrioReadingSystem_event_pointerUp);
        this._colibrioReadingSystem.addEngineEventListener("pointermove", this._colibrioReadingSystem_event_pointerMove);
        this._colibrioReadingSystem.addEngineEventListener("selectionChanged", this._colibrioReadingSystem_event_selectionChanged);
        this._colibrioReadingSystem.addEngineEventListener("visibleRangeChanged", this._colibrioReadingSystem_event_visibleRangeChanged);
        this._colibrioReadingSystem.addEngineEventListener("visiblePagesChanged", this._colibrioReadingSystem_event_visiblePagesChanged);
        this._colibrioReadingSystem.addEngineEventListener("visibleContentRendered", this._colibrioReadingSystem_event_visibleContentRendered);
        this._colibrioReadingSystem.addEngineEventListener("activeTransformChanged", this._colibrioReadingSystem_event_activeTransformChanged);
    }
    destroy() {
        this._colibrioReadingSystem.destroy();
    }
    /**
     *
     * CALLBACKS
     *
     * */ onNavigationStarted(callback) {
        this._navigationStartedCallback = callback;
    }
    onNavigationEnded(callback) {
        this._navigationEndedCallback = callback;
    }
    onReadingPositionChanged(callback) {
        this._readingPositionUpdatedCallback = callback;
    }
    onNavigationIntent(callback) {
        this._navigationIntentCallback = callback;
    }
    onSelectionChanged(callback) {
        this._selectionChangedCallback = callback;
    }
    onClick(callback) {
        this._clickCallback = callback;
    }
    onPointerDown(callback) {
        this._pointerDownCallback = callback;
    }
    onPointerUp(callback) {
        this._pointerUpCallback = callback;
    }
    onPointerMove(callback) {
        this._pointerMoveCallback = callback;
    }
    onVisibleRangeChanged(callback) {
        this._visibleRangeChangedCallback = callback;
    }
    onVisibleContentRendered(callback) {
        this._visibleContentRenderedCallback = callback;
    }
    onVisiblePagesChanged(callback) {
        this._visiblePagesChangedCallback = callback;
    }
    onKeyDown(callback) {
        this._keyDownCallback = callback;
    }
    onKeyUp(callback) {
        this._keyUpCallback = callback;
    }
    onPublicationDownloadProgress(callback) {
        this._publicationDownloadProgressCallback = callback;
    }
    /**
     * onPublicationRendered fires the first time the Colibrio `ReaderView` renders publication content on the screen.
     * */ onPublicationRendered(callback) {
        this._publicationRenderedCallback = callback;
    }
    onActiveReaderViewTransformChanged(callback) {
        this._activeViewTransformChangedCallback = callback;
    }
    createReaderView(_initialViewOptions) {
        return this._colibrioReadingSystem.createReaderView((0, $38cfb96512f51532$export$d4f3843f8950ba40));
    }
    createSyncMediaPlayer(timeline, options) {
        return this._colibrioReadingSystem.createSyncMediaPlayer(timeline, options);
    }
    destroySyncMediaPlayer(player) {
        this._colibrioReadingSystem.destroySyncMediaPlayer(player);
    }
    getColibrioReaderPublication() {
        return this._colibrioReadingSystem.getReaderPublications()[0];
    }
    getColibrioReadingSystemEngine() {
        return this._colibrioReadingSystem;
    }
    async loadPublicationFromUrl(publicationUrl, shelfItem, size, storeOnDevice) {
        return this._getPublicationFromUrl(publicationUrl, shelfItem, size, storeOnDevice).then(async (publication)=>{
            let loadPublicationPromise;
            const readingSessionOptions = {
                publicationToken: publication.getHashSignature(),
                userToken: this._vanillaReaderUserProfileData.token
            };
            const onVisibleContentRendered = (_e)=>{
                if (this._publicationRenderedCallback) this._publicationRenderedCallback();
                this._colibrioReadingSystem.removeEngineEventListener("visibleContentRendered", onVisibleContentRendered);
            };
            // Add a one-off event listener for `visibleContentRendered`. This way we can tell the `VanillaReader` when
            // something has actually been rendered to the screen.
            this._colibrioReadingSystem.addEngineEventListener("visibleContentRendered", onVisibleContentRendered);
            switch(publication.getType()){
                case (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).EPUB:
                    loadPublicationPromise = this._colibrioReadingSystem.loadPublication(publication, this._colibrioEpubReaderPublicationOptions, readingSessionOptions);
                    break;
                case (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).PDF:
                    let pdfReaderPublicationOptions = {};
                    loadPublicationPromise = this._colibrioReadingSystem.loadPublication(publication, pdfReaderPublicationOptions, readingSessionOptions);
                    break;
                case (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).WP:
                default:
                    let defaultReaderPublicationOptions = {};
                    loadPublicationPromise = this._colibrioReadingSystem.loadPublication(publication, defaultReaderPublicationOptions, readingSessionOptions);
            }
            return loadPublicationPromise;
        });
    }
    async loadPublicationFromAwsLambda(publicationUrl, urlResolver, shelfItem, size, storeOnDevice) {
        return this._getPublicationFromAws(publicationUrl, urlResolver, shelfItem, size, storeOnDevice).then(async (publication)=>{
            let loadPublicationPromise;
            const readingSessionOptions = {
                publicationToken: publication.getHashSignature(),
                userToken: this._vanillaReaderUserProfileData.token
            };
            const onVisibleContentRendered = (_e)=>{
                if (this._publicationRenderedCallback) this._publicationRenderedCallback();
                this._colibrioReadingSystem.removeEngineEventListener("visibleContentRendered", onVisibleContentRendered);
            };
            // Add a one-off event listener for `visibleContentRendered`. This way we can tell the `VanillaReader` when
            // something has actually been rendered to the screen.
            this._colibrioReadingSystem.addEngineEventListener("visibleContentRendered", onVisibleContentRendered);
            switch(publication.getType()){
                case (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).EPUB:
                    loadPublicationPromise = this._colibrioReadingSystem.loadPublication(publication, this._colibrioEpubReaderPublicationOptions, readingSessionOptions);
                    break;
                case (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).PDF:
                    let pdfReaderPublicationOptions = {};
                    loadPublicationPromise = this._colibrioReadingSystem.loadPublication(publication, pdfReaderPublicationOptions, readingSessionOptions);
                    break;
                case (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).WP:
                default:
                    let defaultReaderPublicationOptions = {};
                    loadPublicationPromise = this._colibrioReadingSystem.loadPublication(publication, defaultReaderPublicationOptions, readingSessionOptions);
            }
            return loadPublicationPromise;
        });
    }
    async loadPublicationFromArrayBuffer(fileBuffer, fileName, storeOnDevice = false, shelfItem) {
        let file = new File([
            fileBuffer
        ], fileName);
        return this.loadPublicationFromFile(file, storeOnDevice, shelfItem);
    }
    async loadPublicationFromFile(file, storeOnDevice = false, shelfItem) {
        let fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1).toUpperCase();
        let readerPublicationPromise;
        switch(fileExtension){
            case "EPUB":
                this._colibrioReadingSystem.addFormatAdapter(new (0, $c285ff458aea1783$export$6cce81df6c9fb52)());
                readerPublicationPromise = $c0755b65389d3173$export$8e0d8beae376a163._getEpubPublicationFromFile(file).then(async (publication)=>{
                    const readingSessionOptions = {
                        publicationToken: publication.getHashSignature(),
                        userToken: this._vanillaReaderUserProfileData.token
                    };
                    if (storeOnDevice) this._maybeAddPublicationToStorage(shelfItem, file).catch(console.warn);
                    return this._colibrioReadingSystem.loadPublication(publication, this._colibrioEpubReaderPublicationOptions, readingSessionOptions);
                });
                break;
            case "PDF":
                this._colibrioReadingSystem.addFormatAdapter(new (0, $08a2f01c74df8fd0$export$6edbcdb1c3d1e8e7)());
                readerPublicationPromise = $c0755b65389d3173$export$8e0d8beae376a163._getPdfPublicationFromFile(file).then(async (publication)=>{
                    const readerPublicationOptions = {};
                    const readingSessionOptions = {
                        publicationToken: publication.getHashSignature(),
                        userToken: this._vanillaReaderUserProfileData.token
                    };
                    if (storeOnDevice) this._maybeAddPublicationToStorage(shelfItem, file).catch(console.warn);
                    return this._colibrioReadingSystem.loadPublication(publication, readerPublicationOptions, readingSessionOptions);
                });
                break;
            case "LPF":
                this._colibrioReadingSystem.addFormatAdapter(new (0, $98c649c5274356f6$export$456372773820dea5)());
                readerPublicationPromise = $c0755b65389d3173$export$8e0d8beae376a163._getWpAudiobookPublicationFromFile(file).then((publication)=>{
                    const readerPublicationOptions = {};
                    const readingSessionOptions = {
                        publicationToken: publication.getHashSignature(),
                        userToken: this._vanillaReaderUserProfileData.token
                    };
                    if (storeOnDevice) this._maybeAddPublicationToStorage(shelfItem, file).catch(console.warn);
                    return this._colibrioReadingSystem.loadPublication(publication, readerPublicationOptions, readingSessionOptions);
                });
                break;
            default:
                throw new DOMException("loadPublicationFromFile", 'file format "' + file.type + '" not supported.');
        }
        const onVisibleContentRendered = (_e)=>{
            if (this._publicationRenderedCallback) this._publicationRenderedCallback();
            this._colibrioReadingSystem.removeEngineEventListener("visibleContentRendered", onVisibleContentRendered);
        };
        // Add a one-off event listener for `visibleContentRendered`. This way we can tell the `VanillaReader` when
        // something has actually been rendered to the screen.
        this._colibrioReadingSystem.addEngineEventListener("visibleContentRendered", onVisibleContentRendered);
        return readerPublicationPromise;
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ async _getPublicationFromAws(url, urlResolver, shelfItem, size, storeOnDevice = false) {
        let mediaType = "";
        let publication = null;
        let chunkDescriptors = [];
        let dataSource;
        let resourceInfo;
        let resourceSize;
        if (this._isOffline && !shelfItem) throw new DOMException("Device is not connected to the Internet, and no IResourceStorage has been set.");
        if (!this._isOffline) {
            if (!size) {
                resourceInfo = await (0, $fc8bd558eed898ab$export$cc54d9f6df5e6659).fromUrl(url);
                resourceSize = resourceInfo.size;
                mediaType = resourceInfo.mediaType;
            } else resourceSize = size;
        } else {
            let resource;
            if (shelfItem && !await shelfItem.hasStoredResource()) resource = await shelfItem.createStoredResource(size);
            else if (shelfItem) resource = await shelfItem.fetchStoredResource();
            resourceSize = resource?.size;
        }
        if (storeOnDevice && !shelfItem) {
            console.warn("VanillaReaderReadingSystem.loadPublicationFromUrl", "Can not store publication data on device as no IResourceStorage has been set.");
            storeOnDevice = false;
        }
        if (!resourceSize) throw Error("VanillaReaderReadingSystem._getPublicationFromUrl(): Unable to resolve resource size.");
        if (storeOnDevice && shelfItem) {
            let storedResource;
            let hasOfflineData = await shelfItem.hasOfflineData();
            if (!hasOfflineData) storedResource = await shelfItem.createStoredResource(size);
            else storedResource = await shelfItem.fetchStoredResource();
            if (!storedResource) throw new DOMException(`VanillaReaderReadingSystem._getPublicationFromUrl(), Unable to create StoredResource for file with url "${url}"`);
            storedResource.size = resourceSize;
            dataSource = new (0, $e7d53bebb8fdaac8$export$1c493a9933b41063)(storedResource, url, resourceSize);
        } else dataSource = new (0, $5d2a63b68ee7cb73$export$83afea118c1cea15)(url, resourceSize, {
            urlResolver: urlResolver
        });
        switch(mediaType){
            case (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_EPUB_ZIP.toString():
                this._colibrioReadingSystem.addFormatAdapter(new (0, $c285ff458aea1783$export$6cce81df6c9fb52)());
                //let epubCore = await this._importEpubSupport();
                let zipResourceProvider = await (0, $20da6be62b58b032$export$b93701cceb925c09).createFromRandomAccessDataSource(dataSource, {
                    transferBuffers: true
                });
                if (storeOnDevice) chunkDescriptors = zipResourceProvider.getDataChunkDescriptors();
                let epubOcfResourceProvider = await (0, $50771de7f4ce2444$export$6cad6c1e494eabac).createFromBackingResourceProvider(zipResourceProvider, zipResourceProvider.getCentralDirectorySha1Signature());
                publication = epubOcfResourceProvider.getDefaultPublication();
                break;
            case (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_PDF.toString():
                this._colibrioReadingSystem.addFormatAdapter(new (0, $08a2f01c74df8fd0$export$6edbcdb1c3d1e8e7)());
                let chunkSize = 128000;
                let fileSize = dataSource.getSize();
                publication = await (0, $ecd9c96e15a01777$export$11db94ba744530e5).createFromRandomAccessDataSource(dataSource, {
                    enableDeterministicChunkRequests: true,
                    chunkSize: chunkSize
                });
                if (storeOnDevice) // Fill the chunkDescriptors array with all the byte ranges that will be requested by the data source.
                for(let i = 0; i < fileSize; i += chunkSize)chunkDescriptors.push({
                    start: i,
                    end: Math.min(i + chunkSize, fileSize)
                });
                break;
            case (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_LPF_ZIP.toString():
                this._colibrioReadingSystem.addFormatAdapter(new (0, $98c649c5274356f6$export$456372773820dea5)());
                let backingZipResourceProvider = await (0, $20da6be62b58b032$export$b93701cceb925c09).createFromRandomAccessDataSource(dataSource, {
                    transferBuffers: true
                });
                publication = await (0, $7172dc67046a15e4$export$cb0ba341f61aba5e).createFromManifestUrl(backingZipResourceProvider, "publication.json", backingZipResourceProvider.getCentralDirectorySha1Signature(), ()=>{
                    backingZipResourceProvider.destroy();
                });
                if (storeOnDevice) chunkDescriptors = backingZipResourceProvider.getDataChunkDescriptors();
                break;
        }
        if (storeOnDevice && dataSource instanceof (0, $e7d53bebb8fdaac8$export$1c493a9933b41063)) {
            dataSource.setChunkDescriptors(chunkDescriptors);
            dataSource.preload().catch(console.error);
            dataSource.onPreloadProgressUpdated((progress)=>{
                if (this._publicationDownloadProgressCallback) this._publicationDownloadProgressCallback(progress, url);
            });
        }
        if (!publication) throw new Error("The file did not contain any supported publication type");
        return publication;
    }
    async _getPublicationFromUrl(url, shelfItem, size, storeOnDevice = false) {
        //let mediaType = '';
        let publication = null;
        let chunkDescriptors = [];
        let dataSource;
        let resourceInfo;
        let resourceSize;
        let fileExtension = url.slice(url.lastIndexOf(".") + 1).toUpperCase();
        if (this._isOffline && !shelfItem) throw new DOMException("Device is not connected to the Internet, and no IResourceStorage has been set.");
        if (!this._isOffline) {
            if (!size) {
                resourceInfo = await (0, $4286f65dd2c5d352$export$97716d06f30ebaad).fromUrl(url);
                resourceSize = resourceInfo.size;
            //mediaType = resourceInfo.mediaType;
            } else resourceSize = size;
        } else {
            let resource;
            if (!await shelfItem.hasStoredResource()) resource = await shelfItem.createStoredResource(size);
            else resource = await shelfItem.fetchStoredResource();
            resourceSize = resource?.size;
        }
        if (storeOnDevice && !shelfItem) {
            console.warn("VanillaReaderReadingSystem.loadPublicationFromUrl", "Can not store publication data on device as no IResourceStorage has been set.");
            storeOnDevice = false;
        }
        if (!resourceSize) throw Error("VanillaReaderReadingSystem._getPublicationFromUrl(): Unable to resolve resource size.");
        if (storeOnDevice && shelfItem) {
            let storedResource;
            let hasOfflineData = await shelfItem.hasOfflineData();
            if (!hasOfflineData) storedResource = await shelfItem.createStoredResource(size);
            else storedResource = await shelfItem.fetchStoredResource();
            if (!storedResource) throw new DOMException(`VanillaReaderReadingSystem._getPublicationFromUrl(), Unable to create StoredResource for file with url "${url}"`);
            storedResource.size = resourceSize;
            dataSource = new (0, $e7d53bebb8fdaac8$export$1c493a9933b41063)(storedResource, url, resourceSize);
        } else dataSource = new (0, $5ae55c0801306360$export$163500108bc478dc)(url, resourceSize);
        switch(fileExtension){
            case "EPUB":
                this._colibrioReadingSystem.addFormatAdapter(new (0, $c285ff458aea1783$export$6cce81df6c9fb52)());
                //let epubCore = await this._importEpubSupport();
                let zipResourceProvider = await (0, $20da6be62b58b032$export$b93701cceb925c09).createFromRandomAccessDataSource(dataSource, {
                    transferBuffers: true
                });
                if (storeOnDevice) chunkDescriptors = zipResourceProvider.getDataChunkDescriptors();
                let epubOcfResourceProvider = await (0, $50771de7f4ce2444$export$6cad6c1e494eabac).createFromBackingResourceProvider(zipResourceProvider, zipResourceProvider.getCentralDirectorySha1Signature());
                publication = epubOcfResourceProvider.getDefaultPublication();
                break;
            case "PDF":
                this._colibrioReadingSystem.addFormatAdapter(new (0, $08a2f01c74df8fd0$export$6edbcdb1c3d1e8e7)());
                let chunkSize = 128000;
                let fileSize = dataSource.getSize();
                publication = await (0, $ecd9c96e15a01777$export$11db94ba744530e5).createFromRandomAccessDataSource(dataSource, {
                    enableDeterministicChunkRequests: true,
                    chunkSize: chunkSize
                });
                if (storeOnDevice) // Fill the chunkDescriptors array with all the byte ranges that will be requested by the data source.
                for(let i = 0; i < fileSize; i += chunkSize)chunkDescriptors.push({
                    start: i,
                    end: Math.min(i + chunkSize, fileSize)
                });
                break;
            case "LPF":
                this._colibrioReadingSystem.addFormatAdapter(new (0, $98c649c5274356f6$export$456372773820dea5)());
                let backingZipResourceProvider = await (0, $20da6be62b58b032$export$b93701cceb925c09).createFromRandomAccessDataSource(dataSource, {
                    transferBuffers: true
                });
                publication = await (0, $7172dc67046a15e4$export$cb0ba341f61aba5e).createFromManifestUrl(backingZipResourceProvider, "publication.json", backingZipResourceProvider.getCentralDirectorySha1Signature(), ()=>{
                    backingZipResourceProvider.destroy();
                });
                if (storeOnDevice) chunkDescriptors = backingZipResourceProvider.getDataChunkDescriptors();
                break;
        }
        if (storeOnDevice && dataSource instanceof (0, $e7d53bebb8fdaac8$export$1c493a9933b41063)) {
            dataSource.setChunkDescriptors(chunkDescriptors);
            dataSource.preload().catch(console.error);
            dataSource.onPreloadProgressUpdated((progress)=>{
                if (this._publicationDownloadProgressCallback) this._publicationDownloadProgressCallback(progress, url);
            });
        }
        if (!publication) throw new Error("The file did not contain any supported publication type");
        return publication;
    }
    static async _getEpubPublicationFromFile(file) {
        let epubOcfResourceProvider;
        epubOcfResourceProvider = await (0, $50771de7f4ce2444$export$6cad6c1e494eabac).createFromBlob(file);
        let publication = epubOcfResourceProvider.getDefaultPublication();
        if (!publication) throw new Error("VanillaReadingSystem._getEpubPublicationFromFile(): The file did not contain any EPUB publication");
        return publication;
    }
    static async _getPdfPublicationFromFile(file) {
        let publication;
        publication = await (0, $ecd9c96e15a01777$export$11db94ba744530e5).createFromBlob(file);
        if (!publication) throw new Error("VanillaReadingSystem._getPdfPublicationFromFile(): File did not contain a valid PDF.");
        return publication;
    }
    static async _getWpAudiobookPublicationFromFile(file) {
        let publication = (0, $7172dc67046a15e4$export$cb0ba341f61aba5e).createFromBlob(file);
        if (!publication) throw new Error("VanillaReadingSystem._getWpAudiobookPublicationFromFile(): The file did not contain any EPUB publication");
        return publication;
    }
    async _maybeAddPublicationToStorage(shelfItem, file) {
        if (!shelfItem) return;
        let fileUrl = `file://${file.name}`;
        let publicationHasStoredResources = await shelfItem.hasStoredResource();
        if (!publicationHasStoredResources) {
            let storedResource = await shelfItem.createStoredResource(file.size, file);
            if (!storedResource) throw new DOMException(`VanillaReaderReadingSystem._maybeAddPublicationToStorage(), Unable to create StoredResource for file with name "${file.name}"`);
            if (this._publicationDownloadProgressCallback) this._publicationDownloadProgressCallback(1, fileUrl);
        }
    }
}








class $32ee6384f09b291b$export$43a52b481c2cf436 {
    constructor(){
        this._hasBeenBuilt = false;
        this._tree = {
            collections: [],
            items: []
        };
    }
    get hasBeenBuilt() {
        return this._hasBeenBuilt;
    }
    async build(publicationNavigation, timeline) {
        this._colibrioPublicationNavigation = publicationNavigation;
        this._timeline = timeline;
        await this._buildVanillaReaderNavigationTree();
    }
    getTreeData() {
        return this._tree;
    }
    setTreeData(treeData) {
        this._tree = treeData;
        this._hasBeenBuilt = true;
    }
    async fetchItemsInVisibleRange(types, greedy = true, vanillaReaderView) {
        let items = await vanillaReaderView?.getVisibleRange()?.fetchNavigationItemReferences({
            collectionTypes: types,
            greedy: greedy
        });
        return items?.getItemsInRange();
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ async _buildVanillaReaderNavigationTree() {
        if (this._colibrioPublicationNavigation) {
            let collections = this._colibrioPublicationNavigation.getNavigationCollections();
            for (const collection of collections){
                let newCollection = {
                    type: collection.getType(),
                    children: []
                };
                for (const item of collection.getChildren()){
                    let navItem = await this._createNavigationItem(item);
                    if (navItem) {
                        this._tree.items.push(navItem);
                        newCollection.children.push(navItem);
                    }
                }
                this._tree.collections.push(newCollection);
            }
            this._hasBeenBuilt = true;
        }
    }
    async _createNavigationItem(navItem) {
        const locator = navItem.getLocator();
        let textContent;
        textContent = navItem.getTextContent();
        let timelineStartPos;
        if (locator && this._timeline) timelineStartPos = await this._timeline.fetchTimelinePosition(locator);
        let newItem = {
            locator: locator?.toString() || undefined,
            title: textContent,
            children: [],
            timelineStartPosition: timelineStartPos
        };
        let children = navItem.getChildren();
        if (children && children.length > 0) for (const item of children){
            let newChildItem = await this._createNavigationItem(item);
            newItem.children.push(newChildItem);
        }
        return newItem;
    }
}






class $289a2fbee35e33d8$export$90a2828921e9d10e {
    constructor(_contentBlock, _navigationTree, _timeline){
        this._contentBlock = _contentBlock;
        this._navigationTree = _navigationTree;
        this._timeline = _timeline;
        let description = this._getDescriptionAttributeFromContentBlock(this._contentBlock, "aria-label") || this._getDescriptionFromContentBlockStructure(this._contentBlock) || undefined;
        let documentsArray = this._contentBlock.getContentLocation().getReaderDocuments();
        let documentIndex = documentsArray.length > 0 ? documentsArray[0].getIndexInSpine() : undefined;
        this._textContent = this._contentBlock.getTextContent();
        this._id = this._contentBlock.getId();
        this._documentIndex = documentIndex;
        this._resourceHrefs = this._contentBlock.getResourceHrefs();
        this._attributes = this._contentBlock.getAttributes();
        this._marks = this._contentBlock.getMarks();
        this._description = description;
        this._children = this._contentBlock.getChildren();
        this._blockType = this._contentBlock.getBlockType();
        this._blockClass = this._contentBlock.getBlockClass();
        // Let's see if this ContentBlock is also a footnote or endnote
        let hasFootnoteAttribute = this.attributes.some((attribute)=>{
            return attribute.localName === "role" && attribute.value === "doc-footnote" || attribute.localName === "role" && attribute.value === "doc-endnote" || attribute.localName === "type" && attribute.value === "footnote" || attribute.localName === "type" && attribute.value === "endnote" || attribute.localName === "type" && attribute.value === "rearnote";
        });
        if (hasFootnoteAttribute) this.subType = (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FOOTNOTE;
    }
    get id() {
        return this._id;
    }
    get attributes() {
        return this._attributes;
    }
    get blockClass() {
        return this._blockClass;
    }
    get blockType() {
        return this._blockType;
    }
    get children() {
        return this._children;
    }
    get description() {
        return this._description;
    }
    get documentIndex() {
        return this._documentIndex;
    }
    get marks() {
        return this._marks;
    }
    get resourceHrefs() {
        return this._resourceHrefs;
    }
    get subType() {
        return this._subType;
    }
    set subType(subType) {
        this._subType = subType;
    }
    get textContent() {
        return this._textContent;
    }
    get locatorUrl() {
        if (this._locatorUrl !== undefined) return this._locatorUrl;
        this._locatorUrl = this._contentBlock.getLocator().toUrl().toString();
        return this._locatorUrl;
    }
    getLocator(charOffset, charLength) {
        if (this._locator !== undefined) return this._locator;
        this._locator = this._contentBlock.getLocator(charOffset, charLength);
        return this._locator;
    }
    async fetchTimelinePosition() {
        if (this._timelinePosition !== undefined) return this._timelinePosition;
        this._timelinePosition = await this._timeline?.fetchTimelinePosition(this._contentBlock.getLocator());
        return this._timelinePosition;
    }
    fetchNavigationItem() {
        return this._fetchNavigationItem();
    }
    isBefore(contentBlock) {
        return this._contentBlock.getContentLocation().isBefore(contentBlock.getContentLocation());
    }
    isAfter(contentBlock) {
        return this._contentBlock.getContentLocation().isAfter(contentBlock.getContentLocation());
    }
    contains(contentBlock) {
        return this._contentBlock.getContentLocation().contains(contentBlock.getContentLocation());
    }
    async serialize(createLocators, recursive) {
        if (this._serializedData !== undefined) return this._serializedData;
        const contentBlockData = this._contentBlock.toSerializableData({
            createLocators: createLocators,
            recursive: recursive
        });
        this._serializedData = {
            timelinePosition: await this.fetchTimelinePosition(),
            parentId: contentBlockData.parentId,
            id: this.id,
            attributes: this.attributes,
            marks: this.marks,
            resourceHrefs: this.resourceHrefs,
            description: this.description,
            navigationItem: await this.fetchNavigationItem(),
            children: contentBlockData.children,
            locator: this.getLocator(),
            textContent: this.textContent || "",
            blockClass: this.blockClass,
            blockType: this.blockType,
            subType: this.subType,
            documentIndex: this.documentIndex,
            locatorUrl: this.getLocator().toUrl().toString()
        };
        return this._serializedData;
    }
    async _fetchNavigationItem() {
        if (this._navigationItem !== undefined) return this._navigationItem;
        let colibrioNavigationItemRefs = await this._contentBlock.getContentLocation().fetchNavigationItemReferences({
            collectionTypes: [
                (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC
            ],
            greedy: true
        });
        let navigationItem = undefined;
        if (colibrioNavigationItemRefs.getItemsInRange().length > 0) {
            let locator = colibrioNavigationItemRefs.getItemsInRange()[0].getNavigationItem().getLocator()?.toUrl().toString();
            if (locator) navigationItem = this._navigationTree?.items.find((item)=>{
                return item.locator === locator;
            });
        }
        this._navigationItem = navigationItem;
        return navigationItem;
    }
    _getDescriptionFromContentBlockStructure(block) {
        let childTextBlock = block.getChildren().filter((block)=>block.getBlockType() === (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).TEXT);
        if (childTextBlock.length === 0) return;
        return childTextBlock.map((block)=>block.getTextContent()).join(" ").trim();
    }
    _getDescriptionAttributeFromContentBlock(block, preferredAttributeName) {
        let blockAttributes = block.getAttributes();
        let descAttribute = undefined;
        if (preferredAttributeName) {
            let attr = blockAttributes.find((attr)=>{
                return attr.localName == preferredAttributeName;
            });
            if (attr) return attr.value;
        }
        blockAttributes.forEach((attr)=>{
            switch(attr.localName){
                case "title":
                    descAttribute = attr.value;
                    break;
                case "alt":
                    descAttribute = attr.value;
                    break;
                case "aria-label":
                    descAttribute = attr.value;
                    break;
            }
        });
        return descAttribute;
    }
}


class $bca99108001aacff$export$a2ed43cb6446f58f {
    constructor(_vanillaReaderPublication, _vanillaReadingProgressionTimeline){
        this._vanillaReaderPublication = _vanillaReaderPublication;
        this._vanillaReadingProgressionTimeline = _vanillaReadingProgressionTimeline;
        this._documentIndexToLandmarksMap = new Map();
        this._landmarkToDocumentIndex = new Map();
        this._blockIdToLandmarkMap = new Map();
        this._hasBeenPopulated = false;
        this._colibrioReaderPublication = this._vanillaReaderPublication.colibrioReaderPublication;
    }
    async populate(documentIndexes, landmarkTypes) {
        await this._populate(this._colibrioReaderPublication, documentIndexes, landmarkTypes).catch(console.error);
    }
    getAll() {
        let publicationLandmarkData = {
            publicationId: this._colibrioReaderPublication.getSourcePublication().getMetadata().getIdentifiers()[0]?.content.value.toString(),
            documents: []
        };
        let landmarks = [];
        this._documentIndexToLandmarksMap.forEach((_doc, key)=>{
            let landmark = this._documentIndexToLandmarksMap.get(key);
            if (landmark && landmarks.findIndex((item)=>item === landmark) < 0) landmarks.push(landmark);
        });
        publicationLandmarkData.documents = landmarks;
        return publicationLandmarkData;
    }
    getHeadings(level) {
        let filteredResult = Array.from(this._landmarkToDocumentIndex.keys());
        let headings = filteredResult.filter((item)=>{
            if (level) return item.blockType.indexOf(level) >= 0;
            else return item.blockType.indexOf("HEADING") >= 0;
        });
        return headings.length > 0 ? headings : undefined;
    }
    getFootnotes() {
        let filteredResult = Array.from(this._landmarkToDocumentIndex.keys());
        let footnotes = filteredResult.filter((item)=>{
            return item.subType && item.subType.toString().indexOf("FOOTNOTE") >= 0;
        });
        return footnotes.length > 0 ? footnotes : undefined;
    }
    getFigures() {
        let filteredResult = Array.from(this._landmarkToDocumentIndex.keys());
        let figures = filteredResult.filter((item)=>{
            return item.blockType.includes("IMAGE") || item.blockType.includes("FIGURE");
        });
        return figures.length > 0 ? figures : undefined;
    }
    getTables() {
        let filteredResult = Array.from(this._landmarkToDocumentIndex.keys());
        let tables = filteredResult.filter((item)=>{
            return item.blockType === "TABLE";
        });
        return tables.length > 0 ? tables : undefined;
    }
    getLists() {
        let filteredResult = Array.from(this._landmarkToDocumentIndex.keys());
        let lists = filteredResult.filter((item)=>{
            return item.blockType.includes("_LIST");
        });
        return lists.length ? lists : undefined;
    }
    async _populate(readerPublication, documentIndexes, landmarkTypes) {
        if (this._hasBeenPopulated) return;
        let documentsToSearch = readerPublication.getSpine();
        // Check if we should search only some elements as listed in the `documentIndexes` argument.
        if (documentIndexes) documentsToSearch = readerPublication.getSpine().filter((doc)=>{
            return documentIndexes.includes(doc.getSourceContentDocument().getIndexInSpine());
        });
        for (const doc of documentsToSearch){
            let documentIndex = doc.getSourceContentDocument().getIndexInSpine();
            if (this._documentIndexToLandmarksMap.has(documentIndex)) continue;
            let docLandmarks = {
                documentIndex: documentIndex
            };
            let contentBlockTree = await doc.fetchContentBlockTree();
            let walker = new (0, $91ca8664a4c236f4$export$1dc4171992fdbf4b)(contentBlockTree.getContentBlocks());
            while(walker.hasNext()){
                let addBlock = false;
                let block = walker.next();
                let blockType = block.getBlockType();
                let collectionToAddTo;
                let blockAttributes = [];
                let currentLandmarkData;
                if (!landmarkTypes) landmarkTypes = Object.values((0, $652e6cb51d594b1d$export$87e364cacb5e9f8f));
                if (landmarkTypes.includes(blockType)) switch(blockType){
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).ARTICLE:
                        addBlock = true;
                        docLandmarks.articles = [];
                        collectionToAddTo = docLandmarks.articles;
                        break;
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).SECTION:
                        addBlock = true;
                        docLandmarks.sections = [];
                        collectionToAddTo = docLandmarks.sections;
                        break;
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).ASIDE:
                        addBlock = true;
                        docLandmarks.asides = undefined;
                        collectionToAddTo = docLandmarks.asides;
                        break;
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING1:
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING2:
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING3:
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING4:
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING5:
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING6:
                        addBlock = true;
                        docLandmarks.headings = [];
                        collectionToAddTo = docLandmarks.headings;
                        break;
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).AUDIO:
                        addBlock = true;
                        docLandmarks.audio = [];
                        collectionToAddTo = docLandmarks.audio;
                        break;
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).VIDEO:
                        addBlock = true;
                        docLandmarks.video = [];
                        collectionToAddTo = docLandmarks.video;
                        break;
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).IMAGE:
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FIGURE:
                        addBlock = true;
                        docLandmarks.figures = [];
                        collectionToAddTo = docLandmarks.figures;
                        break;
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).TABLE:
                        addBlock = true;
                        docLandmarks.tables = [];
                        collectionToAddTo = docLandmarks.tables;
                        break;
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).DESCRIPTION_LIST:
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).UNORDERED_LIST:
                    case (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).ORDERED_LIST:
                        addBlock = true;
                        docLandmarks.lists = [];
                        collectionToAddTo = docLandmarks.lists;
                        break;
                    default:
                }
                if (landmarkTypes.includes((0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FOOTNOTE)) {
                    docLandmarks.footnotes = [];
                    currentLandmarkData = await this._fetchLandmarkForContentBlock(block);
                    if (currentLandmarkData.subType === (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FOOTNOTE) {
                        addBlock = true;
                        docLandmarks.footnotes.push(currentLandmarkData);
                    }
                }
                if (addBlock) {
                    collectionToAddTo = collectionToAddTo ? collectionToAddTo : [];
                    if (!currentLandmarkData) currentLandmarkData = await this._fetchLandmarkForContentBlock(block);
                    collectionToAddTo.push(currentLandmarkData);
                    this._landmarkToDocumentIndex.set(currentLandmarkData, documentIndex);
                    let blockIdAttribute = blockAttributes.find((attribute)=>{
                        return attribute.localName === "id";
                    });
                    if (blockIdAttribute && !this._blockIdToLandmarkMap.has(blockIdAttribute.value)) this._blockIdToLandmarkMap.set(blockIdAttribute.value, currentLandmarkData);
                    currentLandmarkData = undefined;
                }
            }
            this._documentIndexToLandmarksMap.set(documentIndex, docLandmarks);
            this._hasBeenPopulated = true;
        }
    }
    async _fetchLandmarkForContentBlock(block) {
        return new (0, $289a2fbee35e33d8$export$90a2828921e9d10e)(block, this._vanillaReaderPublication.navigationTree.getTreeData(), this._vanillaReadingProgressionTimeline);
    }
}






class $ad1c600685383a2f$export$8f3e697321b1b1c8 {
    constructor(_vanillaReaderProgressionTimeline, _vanillaReaderNavigationTree, _pageSizeInWordCount = 500){
        this._vanillaReaderProgressionTimeline = _vanillaReaderProgressionTimeline;
        this._vanillaReaderNavigationTree = _vanillaReaderNavigationTree;
        this._pageSizeInWordCount = _pageSizeInWordCount;
        this._pageList = [];
        this._navigationTreeData = this._vanillaReaderNavigationTree.getTreeData();
    }
    async build() {
        if (!this._timelineData) {
            this._timelineData = await this._vanillaReaderProgressionTimeline.serialize();
            if (!this._timelineData) throw new Error("VanillaReaderPublicationPageList.build(), Unable to serialize VanillaReaderProgressionTimeline instance.");
        }
        let hasPageList = this._navigationTreeData.collections.find((collection)=>collection.type === (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).PAGE_LIST);
        if (!hasPageList) this._pageList = await this._buildSyntheticPageListFromTimelineData(this._timelineData, this._pageSizeInWordCount);
        else this._pageList = await this._buildSyntheticPageListFromNavTreeData(this._navigationTreeData);
        return this.serialize();
    }
    get pageSize() {
        return this._pageSizeInWordCount;
    }
    serialize() {
        let paginationType = this.paginationType;
        let syntheticPaginationSegmentationMethod = paginationType === (0, $652e6cb51d594b1d$export$5eef632beec47929).SYNTHETIC ? (0, $652e6cb51d594b1d$export$588bd69d50f9b677).UNICODE_WHITESPACE_SEGMENTATION : undefined;
        return {
            pages: this._pageList,
            paginationType: paginationType,
            syntheticPaginationSegmentationMethod: syntheticPaginationSegmentationMethod
        };
    }
    get pageCount() {
        return this._pageList.length;
    }
    get paginationType() {
        let returnValue;
        let pageList = this._navigationTreeData?.collections.find((collection)=>collection.type === (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).PAGE_LIST);
        switch(this._timelineData?.unit){
            case (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).PAGES:
                returnValue = (0, $652e6cb51d594b1d$export$5eef632beec47929).SECTIONS;
                break;
            case (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).DOCUMENTS:
                returnValue = (0, $652e6cb51d594b1d$export$5eef632beec47929).SECTIONS;
                break;
            default:
                returnValue = pageList ? (0, $652e6cb51d594b1d$export$5eef632beec47929).PAGE_LIST : (0, $652e6cb51d594b1d$export$5eef632beec47929).SYNTHETIC;
        }
        return returnValue;
    }
    get activeSyntheticPage() {
        return this._activePage;
    }
    async fetchPagesForLocator(locator) {
        const timelineRange = await this._vanillaReaderProgressionTimeline.fetchTimelineRange(locator);
        if (!timelineRange) {
            console.warn("VanillaReaderPublicationPageList.getPagesInVisibleRange(), visible range locator did not resolve to any timeline range.", locator);
            return;
        }
        let startIndex = timelineRange.start;
        let endIndex = timelineRange.end;
        // If this is not a range, we "expand it".
        if (timelineRange.start === timelineRange.end) endIndex = endIndex + 1;
        return this._pageList.filter((page)=>{
            return page.range.intersects(new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(startIndex, endIndex));
        });
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ async _buildSyntheticPageListFromTimelineData(timelineData, pageSize) {
        let pageList = [];
        if (timelineData.sections) {
            let currentPageIndex = 0;
            for (let section of timelineData.sections){
                let currentSectionStartPosition = section.range.start;
                let currentSectionEndPosition = section.range.end;
                let nextPageStartPosition = currentSectionStartPosition;
                // If it's a fixed layout publication, such as a PDF, the range will have the same start and end index.
                // In the while loop below we expect an "end exclusive" range however, so we need to increment the
                // end by one index.
                if (timelineData.unit === (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).PAGES && currentSectionStartPosition === currentSectionEndPosition) currentSectionEndPosition++;
                while(nextPageStartPosition < currentSectionEndPosition){
                    let nextPageEndPosition = nextPageStartPosition + pageSize >= currentSectionEndPosition ? currentSectionEndPosition : nextPageStartPosition + pageSize;
                    let navItem = this._getNearestNavItemFromNavCollection(nextPageStartPosition, (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC);
                    let navItems = navItem ? [
                        navItem
                    ] : undefined;
                    let locator = (await this._vanillaReaderProgressionTimeline.fetchContentLocationAsRange(nextPageStartPosition, nextPageEndPosition))?.getLocator().toString();
                    pageList.push({
                        label: (currentPageIndex + 1).toString(),
                        index: currentPageIndex,
                        navItems: navItems,
                        range: new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(nextPageStartPosition, nextPageEndPosition),
                        locatorData: locator,
                        section: new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(section.range.start, section.range.end)
                    });
                    currentPageIndex++;
                    nextPageStartPosition = nextPageEndPosition;
                }
            }
        }
        return pageList;
    }
    async _buildSyntheticPageListFromNavTreeData(navigationTreeData) {
        let pages;
        pages = [];
        let currentPageIndex = 0;
        let pageListCollection = navigationTreeData.collections.find((item)=>{
            return item.type === (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).PAGE_LIST;
        });
        if (!pageListCollection) {
            console.warn("VanillaReaderPublicationPageList._buildSyntheticPageListFromNavTreeData(), navigation tree data has no page-list collection");
            return [];
        }
        for (let page of pageListCollection.children){
            if (page.timelineStartPosition !== undefined) {
                let nextPageIndex = Math.min(currentPageIndex + 1, pageListCollection.children.length - 1);
                let nextPageStartPosition = pageListCollection.children[nextPageIndex].timelineStartPosition || page.timelineStartPosition + 1;
                if (nextPageStartPosition >= page.timelineStartPosition) {
                    let range = new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(page.timelineStartPosition, nextPageStartPosition);
                    let integerRange = this._getSectionFromTimelinePosition(page.timelineStartPosition)?.range;
                    let section = integerRange ? new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(integerRange.start, integerRange.end) : undefined;
                    let navItem = this._getNearestNavItemFromNavCollection(page.timelineStartPosition, (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC);
                    let navItems = navItem ? [
                        navItem
                    ] : undefined;
                    let locator = (await this._vanillaReaderProgressionTimeline.fetchContentLocationAsRange(page.timelineStartPosition, nextPageStartPosition))?.getLocator().toString();
                    pages.push({
                        label: page.title,
                        index: currentPageIndex,
                        range: range,
                        section: section,
                        locatorData: locator,
                        navItems: navItems
                    });
                }
            } else console.warn(`VanillaReaderPublicationPageList._buildSyntheticPageListFromNavTreeData, Page has no start position`, page);
            currentPageIndex++;
        }
        return pages;
    }
    _getNearestNavItemFromNavCollection(position, collectionType) {
        if (this._navigationTreeData) {
            let tree = this._navigationTreeData;
            if (!tree) {
                console.warn("VanillaReaderPublicationPageList._getNearestNavItemFromNavCollection(), No navigation tree data.");
                return undefined;
            }
            let collection = tree.collections.find((collection)=>collection.type === collectionType);
            if (!collection) {
                console.warn("VanillaReaderPublicationPageList._getNearestNavItemFromNavCollection(), Publication has no TOC.");
                return undefined;
            }
            let currentPos = 0;
            let foundItem = undefined;
            while(currentPos < collection.children.length){
                let currentItem = collection.children[currentPos];
                if (position === currentItem.timelineStartPosition) {
                    foundItem = currentItem;
                    break;
                }
                if (currentItem.timelineStartPosition === undefined || position > currentItem.timelineStartPosition) currentPos++;
                else {
                    // If the position is greater than the current items position we return the previous nav item,
                    // otherwise we return the current position.
                    let itemIndex = currentItem.timelineStartPosition > position ? currentPos - 1 : currentPos;
                    foundItem = collection.children[itemIndex];
                    break;
                }
            }
            return foundItem;
        }
        return undefined;
    }
    _getSectionFromTimelinePosition(position) {
        if (!this._timelineData || !this._timelineData.sections) {
            console.warn("VanillaReaderPublicationPageList._getSectionFromTimelinePosition(), Timeline data does not exist, or has no sections data.");
            return;
        }
        return this._timelineData.sections.find((section)=>position >= section.range.start && position < section.range.end);
    }
}



const $20ba4dc2d35f1a24$export$38db8da868f8aa02 = "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";


class $5340a9bdc44a0542$export$fbea20b286778a79 {
    static{
        this.FontSets = [
            {
                name: "SansSerif",
                defaults: {
                    fallback: "sans-serif"
                },
                fontFaces: []
            },
            {
                name: "Serif",
                defaults: {
                    fallback: "serif",
                    serif: "serif",
                    sansSerif: "serif",
                    cursive: "serif",
                    monospace: "serif",
                    fantasy: "serif"
                },
                fontFaces: []
            },
            {
                name: "EasyReading",
                defaults: {
                    fallback: "EasyReading"
                },
                fontFaces: [
                    {
                        family: "EasyReading",
                        mediaType: (0, $ba5c9d217d86588f$export$483c11740a902fcd).FONT_TTF,
                        src: (0, $20ba4dc2d35f1a24$export$38db8da868f8aa02)
                    }
                ]
            },
            {
                name: "Ysabeau Infant",
                defaults: {
                    fallback: "Ysabeau Infant"
                },
                fontFaces: [
                    {
                        family: "Ysabeau Infant",
                        mediaType: (0, $ba5c9d217d86588f$export$483c11740a902fcd).FONT_TTF,
                        srcUrl: "https://s3.eu-north-1.amazonaws.com/assets.demo.colibrio.com/fonts/YsabeauInfant-VariableFont_wght.ttf",
                        src: ""
                    }
                ]
            }
        ];
    }
    static{
        this.ColorThemes = [
            {
                name: "Default",
                backgroundLight: "#3e3e3e",
                backgroundDark: "#303030",
                foregroundLight: "#ffffff",
                foregroundDark: "#dedede",
                accent: "#36d677",
                uiIsDark: true,
                uiOutlineLight: "rgba(255,255,255,0.5)",
                uiOutlineDark: "rgba(255,255,255,0.2)",
                uiBackgroundLight: "#3e3e3e",
                uiBackgroundDark: "#303030",
                uiForegroundLight: "#ffffff",
                uiForegroundDark: "#dedede"
            },
            {
                name: "Dark",
                backgroundLight: "#3e3e3e",
                backgroundDark: "#303030",
                foregroundLight: "#ffffff",
                foregroundDark: "#dedede",
                accent: "#36d677",
                uiIsDark: true,
                uiOutlineLight: "rgba(255,255,255,0.5)",
                uiOutlineDark: "rgba(255,255,255,0.2)",
                uiBackgroundLight: "#3e3e3e",
                uiBackgroundDark: "#303030",
                uiForegroundLight: "#ffffff",
                uiForegroundDark: "#dedede"
            },
            {
                name: "ContrastDark",
                backgroundLight: "#000000",
                backgroundDark: "#000000",
                foregroundLight: "#ffffff",
                foregroundDark: "#ffffff",
                accent: "#ffde00",
                uiIsDark: true,
                uiOutlineLight: "rgba(255, 255, 255, 1)",
                uiOutlineDark: "rgba(255, 255, 255, 0.6)",
                uiBackgroundLight: "#000000",
                uiBackgroundDark: "#000000",
                uiForegroundLight: "#ffffff",
                uiForegroundDark: "#ffffff"
            },
            {
                name: "Paperlike",
                backgroundLight: "#ece8e2",
                backgroundDark: "#b3a196",
                foregroundLight: "#ece8e2",
                foregroundDark: "#38251d",
                accent: "#D88C00",
                uiIsDark: false,
                uiOutlineLight: "#7f5e4d",
                uiOutlineDark: "#a7958c",
                uiBackgroundLight: "#ece8e2",
                uiBackgroundDark: "#b3a196",
                uiForegroundLight: "#ece8e2",
                uiForegroundDark: "#38251d"
            }
        ];
    }
}


// @ts-ignore
/**
 * Checks if the value is of a specified type.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
// tslint:disable-next-line: typedef
function $39489f5712bfee78$var$isOfType(type) {
    // eslint-disable-next-line valid-typeof
    return (value)=>typeof value === type;
}
const $39489f5712bfee78$export$f6e2535fb5126e54 = $39489f5712bfee78$var$isOfType("function");
const $39489f5712bfee78$export$630801d484da15df = (value)=>{
    return value === null;
};
const $39489f5712bfee78$export$2569c41dd933e9ea = (value)=>{
    return Object.prototype.toString.call(value).slice(8, -1) === "RegExp";
};
const $39489f5712bfee78$export$a6cdc56e425d0d0a = (value)=>{
    return !$39489f5712bfee78$export$fce6876652108ab(value) && !$39489f5712bfee78$export$630801d484da15df(value) && ($39489f5712bfee78$export$f6e2535fb5126e54(value) || typeof value === "object");
};
const $39489f5712bfee78$export$fce6876652108ab = $39489f5712bfee78$var$isOfType("undefined");


/**
 * Check if arrays are equal.
 */ function $bbd508ecb51a96ca$var$equalArray(left, right) {
    const { length: length } = left;
    if (length !== right.length) return false;
    for(let index = length; index-- !== 0;){
        if (!$bbd508ecb51a96ca$export$2e2bcd8739ae039(left[index], right[index])) return false;
    }
    return true;
}
/**
 * Check if array buffers are equal.
 */ function $bbd508ecb51a96ca$var$equalArrayBuffer(left, right) {
    if (left.byteLength !== right.byteLength) return false;
    const view1 = new DataView(left.buffer);
    const view2 = new DataView(right.buffer);
    let index = left.byteLength;
    while(index--){
        if (view1.getUint8(index) !== view2.getUint8(index)) return false;
    }
    return true;
}
/**
 * Check if maps are equal.
 */ function $bbd508ecb51a96ca$var$equalMap(left, right) {
    if (left.size !== right.size) return false;
    for (const index of left.entries()){
        if (!right.has(index[0])) return false;
    }
    for (const index of left.entries()){
        if (!$bbd508ecb51a96ca$export$2e2bcd8739ae039(index[1], right.get(index[0]))) return false;
    }
    return true;
}
/**
 * Check if sets are equal.
 */ function $bbd508ecb51a96ca$var$equalSet(left, right) {
    if (left.size !== right.size) return false;
    for (const index of left.entries()){
        if (!right.has(index[0])) return false;
    }
    return true;
}
function $bbd508ecb51a96ca$export$2e2bcd8739ae039(left, right) {
    if (left === right) return true;
    if (left && (0, $39489f5712bfee78$export$a6cdc56e425d0d0a)(left) && right && (0, $39489f5712bfee78$export$a6cdc56e425d0d0a)(right)) {
        if (left.constructor !== right.constructor) return false;
        if (Array.isArray(left) && Array.isArray(right)) return $bbd508ecb51a96ca$var$equalArray(left, right);
        if (left instanceof Map && right instanceof Map) return $bbd508ecb51a96ca$var$equalMap(left, right);
        if (left instanceof Set && right instanceof Set) return $bbd508ecb51a96ca$var$equalSet(left, right);
        if (ArrayBuffer.isView(left) && ArrayBuffer.isView(right)) return $bbd508ecb51a96ca$var$equalArrayBuffer(left, right);
        if ((0, $39489f5712bfee78$export$2569c41dd933e9ea)(left) && (0, $39489f5712bfee78$export$2569c41dd933e9ea)(right)) return left.source === right.source && left.flags === right.flags;
        if (left.valueOf !== Object.prototype.valueOf) return left.valueOf() === right.valueOf();
        if (left.toString !== Object.prototype.toString) return left.toString() === right.toString();
        const leftKeys = Object.keys(left);
        const rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        for(let index = leftKeys.length; index-- !== 0;){
            if (!Object.prototype.hasOwnProperty.call(right, leftKeys[index])) return false;
        }
        for(let index = leftKeys.length; index-- !== 0;){
            const key = leftKeys[index];
            if (key === "_owner" && left.$$typeof) continue;
            if (!$bbd508ecb51a96ca$export$2e2bcd8739ae039(left[key], right[key])) return false;
        }
        return true;
    }
    if (Number.isNaN(left) && Number.isNaN(right)) return true;
    return left === right;
}


const $ea3a7f5a971b6c2d$var$richTypes = {
    Date: true,
    RegExp: true,
    String: true,
    Number: true
};
function $ea3a7f5a971b6c2d$export$2e2bcd8739ae039(obj, newObj, options = {
    cyclesFix: true
}, _stack = []) {
    let diffs = [];
    const isObjArray = Array.isArray(obj);
    for(const key in obj){
        const objKey = obj[key];
        const path = isObjArray ? +key : key;
        if (!(key in newObj)) {
            diffs.push({
                type: "REMOVE",
                path: [
                    path
                ],
                oldValue: obj[key]
            });
            continue;
        }
        const newObjKey = newObj[key];
        const areObjects = typeof objKey === "object" && typeof newObjKey === "object";
        if (objKey && newObjKey && areObjects && !$ea3a7f5a971b6c2d$var$richTypes[Object.getPrototypeOf(objKey)?.constructor?.name] && (!options.cyclesFix || !_stack.includes(objKey))) {
            const nestedDiffs = $ea3a7f5a971b6c2d$export$2e2bcd8739ae039(objKey, newObjKey, options, options.cyclesFix ? _stack.concat([
                objKey
            ]) : []);
            diffs.push.apply(diffs, nestedDiffs.map((difference)=>{
                difference.path.unshift(path);
                return difference;
            }));
        } else if (objKey !== newObjKey && !(areObjects && (isNaN(objKey) ? objKey + "" === newObjKey + "" : +objKey === +newObjKey))) diffs.push({
            path: [
                path
            ],
            type: "CHANGE",
            value: newObjKey,
            oldValue: objKey
        });
    }
    const isNewObjArray = Array.isArray(newObj);
    for(const key in newObj)if (!(key in obj)) diffs.push({
        type: "CREATE",
        path: [
            isNewObjArray ? +key : key
        ],
        value: newObj[key]
    });
    return diffs;
}


class $33027d939f78e552$export$4855211e6b8ad895 {
    static deepEqual(object1, object2) {
        return (0, $bbd508ecb51a96ca$export$2e2bcd8739ae039)(object1, object2);
    }
    static difference(object1, object2) {
        return (0, $ea3a7f5a971b6c2d$export$2e2bcd8739ae039)(object1, object2);
    }
}


class $476ea80a98863215$export$55c96f9dadd6836 {
    constructor(fileName, fileSourceUri, _colibrioReaderPublication, _shelfItem){
        this._colibrioReaderPublication = _colibrioReaderPublication;
        this._shelfItem = _shelfItem;
        this._id = "";
        this._fileName = "";
        this._title = "";
        this._url = "";
        this._isRtl = false;
        this._isFixedLayout = false;
        this._hasMoSyncMedia = false;
        this._metadata = [];
        this._coverImageUrl = undefined;
        this._coverImageData = undefined;
        this._blobUrlManager = new (0, $ba5c9d217d86588f$export$f31b06a38674c8e1)();
        this._landmarksCollection = undefined;
        // An EPUB can contain both fixed layout documents and reflowable document. In the Vanilla Reader however we treat a publication that has
        // one or more "pre-paginated" content documents as being fixed layout.
        const _publicationIsFixedLayout = this._colibrioReaderPublication.getSpine().some((doc)=>{
            return doc.getSourceContentDocument().getLayout() === "PRE_PAGINATED";
        });
        this._fileName = fileName;
        this._fileSourceUri = fileSourceUri;
        this._id = this._colibrioReaderPublication.getSourcePublication().getMetadata().getIdentifiers()[0]?.content.value || fileSourceUri;
        this._title = this._colibrioReaderPublication.getSourcePublication().getMetadata().getTitles()[0]?.content.value;
        this._url = this._colibrioReaderPublication.getDefaultLocatorUrl();
        this._format = this._colibrioReaderPublication.getSourcePublication().getType();
        this._isFixedLayout = _publicationIsFixedLayout;
        this._isRtl = this._colibrioReaderPublication.getSourcePublication().getPageProgressionDirection() === "RTL";
        this._hasMoSyncMedia = this._colibrioReaderPublication.getAvailableSyncMediaFormats().some((value)=>value === "EPUB_MEDIA_OVERLAY");
        this._metadata = this._colibrioReaderPublication.getSourcePublication().getMetadata().getAll();
        // Cover images are only available for EPUBs and Audiobooks at the moment.
        if ((0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(this._colibrioReaderPublication) || (0, $98c664707733d94d$export$d4671a61002987ce).isWpAudiobookReaderPublication(this._colibrioReaderPublication)) this._coverImageUrl = this._colibrioReaderPublication.getSourcePublication().getCoverImageResourceUrl() || undefined;
        // The navigation tree is instantiated, but it is not yet built. That happens when the timeline has been built.
        // This is because we want to map timeline positions to navigation items.
        // See `VanillaReader._event_timelineReady()` and `VanillaReaderNavigationTree.build()`
        this._navigationTree = new (0, $32ee6384f09b291b$export$43a52b481c2cf436)();
    }
    static async create(fileName, fileSourceUri, colibrioReaderPublication, shelfItem) {
        const publication = new $476ea80a98863215$export$55c96f9dadd6836(fileName, fileSourceUri, colibrioReaderPublication, shelfItem);
        await publication.initializeState().catch(console.warn);
        return publication;
    }
    async initializeState() {
        let publicationHasStoredCachedData = await this._shelfItem.hasCachedData();
        let publicationHasStoredOptionsData = await this._shelfItem.hasOptionsData();
        if (publicationHasStoredCachedData) {
            let initialPublicationCacheDataState = await this._shelfItem.fetchCacheData();
            // Updating the tree data seems to be an issue as it can create duplicated. Not sure why still.
            // if (this._initialPublicationCacheDataState?.navigationTreeData) {
            //     this._navigationTree.setTreeData(this._initialPublicationCacheDataState?.navigationTreeData);
            // }
            initialPublicationCacheDataState?.landmarkData;
        }
        if (publicationHasStoredOptionsData) {
            let initialPublicationOptionsDataState = await this._shelfItem.fetchOptionsData();
            if (initialPublicationOptionsDataState?.ttsOptions) this._ttsOptions = initialPublicationOptionsDataState.ttsOptions;
            if (initialPublicationOptionsDataState?.styleOptions) this.publicationStyleOptions = initialPublicationOptionsDataState.styleOptions;
        }
        // If the shelf item has not been persisted before we update the VanillaReaderShelfItem to include the metadata
        // from the actual publication. Publication data is not going to change over time.
        if (!this._shelfItem.hasBeenPersisted) await this._shelfItem.setPublicationData(await this.serialize());
        if (!publicationHasStoredOptionsData) this._persistCurrentPublicationOptionsState();
        if (!publicationHasStoredCachedData) this._persistCurrentPublicationCacheDataState();
    }
    get id() {
        return this._id;
    }
    get fileName() {
        return this._fileName;
    }
    get fileSourceUri() {
        return this._fileSourceUri;
    }
    get title() {
        return this._title;
    }
    get url() {
        return this._url;
    }
    get format() {
        return this._format;
    }
    get isRtl() {
        return this._isRtl;
    }
    get isFixedLayout() {
        return this._isFixedLayout;
    }
    get isAudiobook() {
        return this._format === (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).WP;
    }
    get hasMoSyncMedia() {
        return this._hasMoSyncMedia;
    }
    get metadata() {
        return this._metadata;
    }
    get language() {
        if (this._colibrioReaderPublication.getSourcePublication().getMetadata().getLanguages().length > 0) return this._colibrioReaderPublication.getSourcePublication().getMetadata().getLanguages()[0].content.value || undefined;
        else return;
    }
    get navigationTree() {
        return this._navigationTree;
    }
    get currentReadingPositionData() {
        return this._currentReadingPositionData;
    }
    setCurrentReadingPositionData(readingPositionData) {
        this._currentReadingPositionData = readingPositionData;
        if (this._shelfItem && readingPositionData && readingPositionData.locator) // Save the new reading position data to the `IVanillaReaderPublicationDataStore` store.
        this._shelfItem.setReadingPositionData(readingPositionData).catch(console.warn);
    }
    get storageState() {
        return this._colibrioReaderPublication.getReaderPublicationStorage().getStorageState();
    }
    set storageState(state) {
        this._colibrioReaderPublication.getReaderPublicationStorage().setStorageState(state);
    }
    get ttsOptions() {
        return this._ttsOptions;
    }
    set ttsOptions(options) {
        this._ttsOptions = options;
        // Save the new TTS options data to the `IVanillaReaderPublicationDataStore` store.
        this._shelfItem?.updateOptionsData({
            publicationId: this.id,
            ttsOptions: options
        }).catch(console.warn);
    }
    get colibrioReaderPublication() {
        return this._colibrioReaderPublication;
    }
    set progressionTimeline(instance) {
        this._progressionTimeline = instance;
        // Save the new timeline data to the `IVanillaReaderPublicationDataStore` store.
        this._shelfItem?.updateCacheData({
            publicationId: this.id,
            timelineData: this._progressionTimeline?.toSerializedData()
        }).catch(console.warn);
    }
    get progressionTimeline() {
        return this._progressionTimeline;
    }
    get pageListData() {
        return this._pageList?.serialize();
    }
    get pageList() {
        return this._pageList;
    }
    get publicationStyleOptions() {
        return this._publicationStyleOptions;
    }
    set publicationStyleOptions(styleOptions) {
        if ((0, $33027d939f78e552$export$4855211e6b8ad895).deepEqual(styleOptions, this._publicationStyleOptions)) {
            console.log("VanillaReaderPublication.publicationStyleOptions, IVanillaReaderPublicationStyleOptions options are identical.");
            return;
        }
        this._publicationStyleOptions = styleOptions;
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_STYLE_OPTIONS_CHANGED", {
            styleOptions: styleOptions ?? {}
        }));
    }
    async fetchLandmarkCollection(timeline, landmarkTypesToInclude) {
        if (this._landmarksCollection) return this._landmarksCollection;
        this._landmarksCollection = new (0, $bca99108001aacff$export$a2ed43cb6446f58f)(this, timeline);
        // We have data that we can restore so that we do not need to repopulate the collection.
        // if (this._landmarksCollectionData) {
        //     this._landmarksCollection.setPublicatonLandmarkData(this._landmarksCollectionData);
        //     return this._landmarksCollection;
        // }
        landmarkTypesToInclude = landmarkTypesToInclude && landmarkTypesToInclude.length > 0 ? landmarkTypesToInclude : [
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FIGURE,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).IMAGE,
            // VanillaReaderPublicationLandmarkType.ORDERED_LIST,
            // VanillaReaderPublicationLandmarkType.UNORDERED_LIST,
            // VanillaReaderPublicationLandmarkType.DESCRIPTION_LIST,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).TABLE,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING1,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING2,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING3,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING4,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING5,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING6,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FOOTNOTE
        ];
        await this._landmarksCollection.populate(undefined, landmarkTypesToInclude);
        // Save the landmark data to the `IVanillaReaderPublicationDataStore` store.
        // this._shelfItem?.updateCacheData({
        //     publicationId: this.id,
        //     landmarkData: this._landmarksCollection.getAll(),
        // }).catch(console.warn);
        return this._landmarksCollection;
    }
    async fetchLandmarkCollectionForDocument(documentIndex, vanillaReadingProgressionTimeline, landmarkTypesToInclude) {
        let landmarksCollection = new (0, $bca99108001aacff$export$a2ed43cb6446f58f)(this, vanillaReadingProgressionTimeline);
        if (!landmarkTypesToInclude) landmarkTypesToInclude = [
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FIGURE,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).IMAGE,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).ORDERED_LIST,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).UNORDERED_LIST,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).DESCRIPTION_LIST,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).TABLE,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING1,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING2,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING3,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING4,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING5,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING6,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FOOTNOTE
        ];
        await landmarksCollection.populate([
            documentIndex
        ], landmarkTypesToInclude);
        return landmarksCollection;
    }
    async fetchCoverImageAsBase64() {
        if (this._coverImageData) return this._coverImageData;
        if ((0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(this._colibrioReaderPublication) && this._coverImageUrl) {
            let imageResource = await this._colibrioReaderPublication.getSourcePublication().getEpubResourceProvider().fetch(this._coverImageUrl);
            if (imageResource) {
                this._coverImageData = (0, $91ca8664a4c236f4$export$f436b0c2107cbd35).encode(await imageResource.asUint8Array());
                return this._coverImageData;
            }
        } else if ((0, $98c664707733d94d$export$d4671a61002987ce).isWpAudiobookReaderPublication(this._colibrioReaderPublication)) {
            const publication = this._colibrioReaderPublication.getSourcePublication();
            const coverImageResourceUrl = publication.getCoverImageResourceUrl();
            if (coverImageResourceUrl) {
                const coverImageResponse = await publication.getBackingResourceProvider().fetch(coverImageResourceUrl);
                this._coverImageData = (0, $91ca8664a4c236f4$export$f436b0c2107cbd35).encode(await coverImageResponse.asUint8Array());
                return this._coverImageData;
            }
        }
        return undefined;
    }
    async fetchResourceBlobUrl(url, forceDataUrl = false) {
        let resource;
        if ((0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(this._colibrioReaderPublication)) resource = await this._colibrioReaderPublication.getSourcePublication().getEpubResourceProvider().fetch(url);
        if (resource) {
            let resourceData = await resource.asUint8Array();
            let mediaType = resource.getMetadata().mediaType;
            if (mediaType) return this._blobUrlManager.createUrl([
                resourceData
            ], mediaType, forceDataUrl).url;
        }
        return undefined;
    }
    revokeResourceBlobUrl(blobUrl) {
        this._blobUrlManager.revokeUrl(blobUrl);
    }
    revokeAllResourceBlobUrls() {
        this._blobUrlManager.revokeAllUrls();
    }
    getColibrioReaderPublication() {
        return this._colibrioReaderPublication;
    }
    /**
     *
     * This method takes in `IPublicationStyleOptions` data and applies the style options using `IReaderView.setOptions()`.
     * `IPublicationStyleOptions` include options for which fonts to use, what colors to display etc.
     *
     * */ setPublicationStyleOptions(styleOptions, vanillaReaderView) {
        let colibrioReaderViewOptions = {};
        colibrioReaderViewOptions.publicationStyleOptions = {
            defaultFontFamily: styleOptions.defaultFontFamily,
            fontSizeScaleFactor: styleOptions.fontSizeScaleFactor,
            lineHeightScaleFactor: styleOptions.lineHeightScaleFactor,
            textAlignment: styleOptions.textAlignment || null,
            pageMargins: styleOptions.pageMargins,
            palette: styleOptions.palette || null
        };
        if (styleOptions.fontSet) {
            let fontFaces = [];
            for (let fontFace of styleOptions.fontSet.fontFaces){
                let fontSetAsset = (0, $5340a9bdc44a0542$export$fbea20b286778a79).FontSets.find((fontSet)=>fontSet.fontFaces[0]?.family === fontFace.family);
                fontFaces.push({
                    family: fontFace.family,
                    fontWeight: fontFace.fontWeight,
                    fontStyle: fontFace.fontStyle,
                    fontStretch: fontFace.fontStretch,
                    mediaType: fontFace.mediaType,
                    src: fontSetAsset?.fontFaces[0]?.src || "",
                    srcUrl: fontSetAsset?.fontFaces[0]?.srcUrl || ""
                });
            }
            colibrioReaderViewOptions.publicationStyleOptions.fontSet = {
                defaults: styleOptions.fontSet.defaults,
                selectors: styleOptions.fontSet.selectors,
                fontFaces: fontFaces
            };
        } else colibrioReaderViewOptions.publicationStyleOptions.fontSet = null;
        // In the Colibrio Reader Framework, the ReaderView handles all rendering aspects (style options etc.), including
        // the current ReaderPublications. So we defer the actual applying of options to the VanillaReaderView component.
        vanillaReaderView.setVanillaReaderViewOptions({
            colibrioReaderViewOptions: colibrioReaderViewOptions
        });
        if (!this.isAudiobook && styleOptions?.palette) vanillaReaderView.setActivePalette(styleOptions.palette);
        // Save the new option's data to the `IVanillaReaderPublicationDataStore` store.
        this._shelfItem?.updateOptionsData({
            publicationId: this.id,
            styleOptions: styleOptions
        }).catch(console.warn);
        this.publicationStyleOptions = styleOptions;
    }
    setPublicationOptions(colibrioEpubPublicationOptionData) {
        if ((0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(this._colibrioReaderPublication)) this._colibrioReaderPublication.setOptions(colibrioEpubPublicationOptionData);
        else if ((0, $98c664707733d94d$export$d4671a61002987ce).isPdfReaderPublication(this.colibrioReaderPublication)) this._colibrioReaderPublication.setOptions(colibrioEpubPublicationOptionData);
        else if ((0, $98c664707733d94d$export$d4671a61002987ce).isWpAudiobookReaderPublication(this.colibrioReaderPublication)) this._colibrioReaderPublication.setOptions(colibrioEpubPublicationOptionData);
        let updatedOptions = this._colibrioReaderPublication.getOptions();
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_OPTIONS_CHANGED", {
            options: updatedOptions
        }));
    }
    async fetchPublicationOptionsData() {
        return this._shelfItem?.fetchOptionsData();
    }
    async fetchHighlights() {
        return this._shelfItem?.fetchHighlights() || [];
    }
    async addHighlight(highlightData) {
        let locator = highlightData.locator;
        let contentLocation = await this._colibrioReaderPublication.fetchContentLocation(highlightData.locator);
        highlightData.publicationId = this.id;
        let navItemRefs = await contentLocation?.fetchNavigationItemReferences({
            collectionTypes: [
                (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC
            ],
            greedy: true
        });
        if (navItemRefs) // Get the last reference toc item text for the `bookSection` field.
        highlightData.bookSection = navItemRefs.getItemsInRange().length > 0 ? navItemRefs.getItemsInRange()[navItemRefs.getItemsInRange().length - 1].getNavigationItem().getTextContent() : undefined;
        if (locator) return this._shelfItem?.addHighlight(highlightData);
        else return;
    }
    async updateHighlight(highlightData) {
        return this._shelfItem?.updateHighlight(highlightData);
    }
    async deleteHighlight(locator) {
        return this._shelfItem?.deleteHighlight(locator);
    }
    async fetchBookmarks() {
        return this._shelfItem?.fetchBookmarks() || [];
    }
    async addBookmark(locator) {
        let location;
        let bookmarkData = undefined;
        if (typeof locator === "string") locator = (await this._colibrioReaderPublication.fetchContentLocation(locator)).getLocator();
        if (this.isAudiobook && this._progressionTimeline) {
            let timelinePosition = await this._progressionTimeline?.fetchTimelinePosition(locator);
            if (timelinePosition === undefined) {
                console.warn(`VanillaPublication.addBookmark(): Unable to get timeline position for locator ${locator.toString()}`);
                return;
            }
            location = await this._progressionTimeline.fetchContentLocation(timelinePosition);
            if (location) {
                let fetchResult = await location.fetchNavigationItemReferences({
                    collectionTypes: [
                        (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC
                    ],
                    greedy: false
                });
                let itemsInRange = fetchResult.getItemsInRange();
                let bookSection;
                if (itemsInRange && itemsInRange.length > 0) bookSection = itemsInRange[0].getNavigationItem().getTextContent();
                bookmarkData = {
                    publicationId: this.id,
                    locator: location.getLocator().toString(),
                    bookSection: bookSection
                };
            }
        } else {
            location = await this._colibrioReaderPublication.fetchContentLocation(locator);
            let locationContent = await location?.fetchContentResolver();
            let textExtract = locationContent?.getTextContentAfter(250) || "";
            if (location) {
                let fetchResult = await location.fetchNavigationItemReferences({
                    collectionTypes: [
                        (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC
                    ],
                    greedy: true
                });
                let itemsInRange = fetchResult.getItemsInRange();
                let bookSection;
                if (itemsInRange && itemsInRange.length > 0) bookSection = itemsInRange[0].getNavigationItem().getTextContent();
                bookmarkData = {
                    publicationId: this.id,
                    locator: location.getLocator().toString(),
                    bookSection: bookSection,
                    text: textExtract
                };
            }
        }
        if (bookmarkData) this._shelfItem?.addBookmark(bookmarkData).catch(console.warn);
        return bookmarkData;
    }
    async deleteBookmark(locator) {
        return this._shelfItem?.deleteBookmark(locator);
    }
    async serialize() {
        return {
            id: this.id,
            fileName: this.fileName,
            fileSourceUri: this.fileSourceUri,
            isFixedLayout: this.isFixedLayout,
            url: this.url,
            title: this.title,
            isRtl: this.isRtl,
            hasMoSyncMedia: this.hasMoSyncMedia,
            isAudiobook: this.isAudiobook,
            format: this.format,
            metadata: this._colibrioReaderPublication.getSourcePublication().getMetadata().toJSON(),
            language: this.language,
            coverImageAsBase64: this._coverImageData || await this.fetchCoverImageAsBase64()
        };
    }
    async buildNavigationTree(timeline) {
        if (!this._navigationTree.hasBeenBuilt) {
            let navigation = await this._colibrioReaderPublication.fetchPublicationNavigation();
            await this._navigationTree.build(navigation, timeline);
            this._shelfItem?.updateCacheData({
                publicationId: this.id,
                navigationTreeData: this._navigationTree.getTreeData()
            }).catch(console.warn);
        }
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("NAVIGATION_TREE_READY", {
            navigationTreeData: this.navigationTree?.getTreeData()
        }));
    }
    async buildPageList(timeline) {
        if (this.isAudiobook) {
            console.log("Not building pagelist since this is an audiobook.");
            return;
        }
        if (!this._navigationTree.hasBeenBuilt) await this.buildNavigationTree();
        this._pageList = new (0, $ad1c600685383a2f$export$8f3e697321b1b1c8)(timeline, this.navigationTree);
        let pageListData = await this._pageList.build();
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_PAGE_LIST_READY", {
            pageListData: pageListData
        }));
    }
    async deleteStoredResources() {
        return this._shelfItem?.deleteStoredResource();
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ _persistCurrentPublicationOptionsState() {
        this._shelfItem?.updateOptionsData({
            publicationId: this.id,
            ttsOptions: this._ttsOptions
        }).catch(console.warn);
    }
    _persistCurrentPublicationCacheDataState() {
        let publicationCacheData = {
            publicationId: this.id,
            storageState: this.storageState,
            navigationTreeData: this.navigationTree?.getTreeData(),
            timelineData: this.progressionTimeline?.toSerializedData()
        };
        // if (this._landmarksCollection || this._landmarksCollectionData) {
        //     publicationCacheData.landmarkData = this._landmarksCollectionData ?
        //         this._landmarksCollectionData :
        //         this._landmarksCollection?.getAll();
        // }
        this._shelfItem?.setCacheData(publicationCacheData).catch(console.warn);
    }
}





var $5c8ac5b7fc4b7c8f$exports = {};
/**
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * without written consent from Colibrio Software AB.
 * 
 * @copyright Colibrio Software AB - All Rights Reserved
 * 
 * This file is part of the Colibrio Reader SDK and is governed by the terms and conditions stated in the
 * LICENSE.md file.
 * 
 * 
 * @version 4.7.0
 */ "use strict";






(function(s, f) {
    if (0, $5c8ac5b7fc4b7c8f$exports) $5c8ac5b7fc4b7c8f$exports = f(s, (parcelRequire("i64v9")), (parcelRequire("loFPd")), (parcelRequire("csyWb")), (parcelRequire("acQau")), (parcelRequire("7kECq")), (parcelRequire("9eVOO")));
    else throw new Error("Unsupported runtime environment!");
})(typeof self !== "undefined" && self ? self : typeof window !== "undefined" && window ? window : typeof $parcel$global !== "undefined" && $parcel$global ? $parcel$global : $5c8ac5b7fc4b7c8f$exports, function(__self, __dep__colibrio_core_base, __dep__colibrio_core_io_base, __dep__colibrio_core_locator, __dep__colibrio_core_publication_base, __dep__colibrio_readingsystem_base, __dep__colibrio_readingsystem_engine) {
    var __lib__bezier_easing = function() {
        var exports = {};
        var module1 = {
            exports: exports
        };
        var define = void 0;
        (function(g) {
            "object" === typeof exports && "undefined" !== typeof module1 ? module1.exports = g() : "function" === typeof define && define.amd ? define([], g) : ("undefined" !== typeof window ? window : "undefined" !== typeof $parcel$global ? $parcel$global : "undefined" !== typeof self ? self : this).lib = g();
        })(function() {
            return (function() {
                function g(l, h, r) {
                    function t(a, d) {
                        if (!h[a]) {
                            if (!l[a]) {
                                var m = undefined;
                                if (!d && m) return m(a, !0);
                                if (c) return c(a, !0);
                                d = Error("Cannot find module '" + a + "'");
                                throw d.code = "MODULE_NOT_FOUND", d;
                            }
                            d = h[a] = {
                                exports: {}
                            };
                            l[a][0].call(d.exports, function(p) {
                                return t(l[a][1][p] || p);
                            }, d, d.exports, g, l, h, r);
                        }
                        return h[a].exports;
                    }
                    for(var c = undefined, e = 0; e < r.length; e++)t(r[e]);
                    return t;
                }
                return g;
            })()({
                1: [
                    function(g, l) {
                        function h(c, e, a) {
                            return (((1 - 3 * a + 3 * e) * c + (3 * a - 6 * e)) * c + 3 * e) * c;
                        }
                        function r(c) {
                            return c;
                        }
                        var t = "function" === typeof Float32Array;
                        l.exports = function(c, e, a, d) {
                            if (!(0 <= c && 1 >= c && 0 <= a && 1 >= a)) throw Error("bezier x values must be in [0, 1] range");
                            if (c === e && a === d) return r;
                            for(var m = t ? new Float32Array(11) : Array(11), p = 0; 11 > p; ++p)m[p] = h(.1 * p, c, a);
                            return function(f) {
                                if (0 === f) return 0;
                                if (1 === f) return 1;
                                for(var k = 0, b = 1; 10 !== b && m[b] <= f; ++b)k += .1;
                                --b;
                                b = k + (f - m[b]) / (m[b + 1] - m[b]) * .1;
                                var n = 3 * (1 - 3 * a + 3 * c) * b * b + 2 * (3 * a - 6 * c) * b + 3 * c;
                                if (.001 <= n) {
                                    for(k = 0; 4 > k; ++k){
                                        n = 3 * (1 - 3 * a + 3 * c) * b * b + 2 * (3 * a - 6 * c) * b + 3 * c;
                                        if (0 === n) break;
                                        var q = h(b, c, a) - f;
                                        b -= q / n;
                                    }
                                    f = b;
                                } else if (0 === n) f = b;
                                else {
                                    b = k;
                                    k += .1;
                                    var u = 0;
                                    do q = b + (k - b) / 2, n = h(q, c, a) - f, 0 < n ? k = q : b = q;
                                    while (1E-7 < Math.abs(n) && 10 > ++u);
                                    f = q;
                                }
                                return h(f, e, d);
                            };
                        };
                    },
                    {}
                ],
                2: [
                    function(g, l) {
                        l.exports = g("bezier-easing");
                    },
                    {
                        "bezier-easing": 1
                    }
                ]
            }, {}, [
                2
            ])(2);
        });
        return module1.exports;
    }();
    var api = {};
    (function() {
        var f;
        function aa(a) {
            var b = 0;
            return function() {
                return b < a.length ? {
                    done: !1,
                    value: a[b++]
                } : {
                    done: !0
                };
            };
        }
        var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
            if (a == Array.prototype || a == Object.prototype) return a;
            a[b] = c.value;
            return a;
        };
        function da(a) {
            a = [
                "object" == typeof globalThis && globalThis,
                a,
                "object" == typeof window && window,
                "object" == typeof self && self,
                "object" == typeof $parcel$global && $parcel$global
            ];
            for(var b = 0; b < a.length; ++b){
                var c = a[b];
                if (c && c.Math == Math) return c;
            }
            throw Error("Cannot find global object");
        }
        var ea = da(this);
        function fa(a, b) {
            if (b) a: {
                var c = ea;
                a = a.split(".");
                for(var d = 0; d < a.length - 1; d++){
                    var e = a[d];
                    if (!(e in c)) break a;
                    c = c[e];
                }
                a = a[a.length - 1];
                d = c[a];
                b = b(d);
                b != d && null != b && ba(c, a, {
                    configurable: !0,
                    writable: !0,
                    value: b
                });
            }
        }
        fa("Symbol", function(a) {
            function b(g) {
                if (this instanceof b) throw new TypeError("Symbol is not a constructor");
                return new c(d + (g || "") + "_" + e++, g);
            }
            function c(g, h) {
                this.g = g;
                ba(this, "description", {
                    configurable: !0,
                    writable: !0,
                    value: h
                });
            }
            if (a) return a;
            c.prototype.toString = function() {
                return this.g;
            };
            var d = "jscomp_symbol_" + (1E9 * Math.random() >>> 0) + "_", e = 0;
            return b;
        });
        fa("Symbol.iterator", function(a) {
            if (a) return a;
            a = Symbol("Symbol.iterator");
            for(var b = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), c = 0; c < b.length; c++){
                var d = ea[b[c]];
                "function" === typeof d && "function" != typeof d.prototype[a] && ba(d.prototype, a, {
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        return ha(aa(this));
                    }
                });
            }
            return a;
        });
        function ha(a) {
            a = {
                next: a
            };
            a[Symbol.iterator] = function() {
                return this;
            };
            return a;
        }
        function k(a) {
            var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
            if (b) return b.call(a);
            if ("number" == typeof a.length) return {
                next: aa(a)
            };
            throw Error(String(a) + " is not an iterable or ArrayLike");
        }
        var ia = "function" == typeof Object.create ? Object.create : function(a) {
            function b() {}
            b.prototype = a;
            return new b;
        }, ja;
        if ("function" == typeof Object.setPrototypeOf) ja = Object.setPrototypeOf;
        else {
            var ka;
            a: {
                var la = {
                    a: !0
                }, ma = {};
                try {
                    ma.__proto__ = la;
                    ka = ma.a;
                    break a;
                } catch (a) {}
                ka = !1;
            }
            ja = ka ? function(a, b) {
                a.__proto__ = b;
                if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
                return a;
            } : null;
        }
        var na = ja;
        function m(a, b) {
            a.prototype = ia(b.prototype);
            a.prototype.constructor = a;
            if (na) na(a, b);
            else for(var c in b)if ("prototype" != c) {
                if (Object.defineProperties) {
                    var d = Object.getOwnPropertyDescriptor(b, c);
                    d && Object.defineProperty(a, c, d);
                } else a[c] = b[c];
            }
            a.pb = b.prototype;
        }
        function oa() {
            this.m = !1;
            this.j = null;
            this.u = void 0;
            this.g = 1;
            this.v = 0;
            this.l = null;
        }
        function pa(a) {
            if (a.m) throw new TypeError("Generator is already running");
            a.m = !0;
        }
        oa.prototype.o = function(a) {
            this.u = a;
        };
        function qa(a, b) {
            a.l = {
                lb: b,
                mb: !0
            };
            a.g = a.v;
        }
        oa.prototype.return = function(a) {
            this.l = {
                return: a
            };
            this.g = this.v;
        };
        function ra(a, b, c) {
            a.g = c;
            return {
                value: b
            };
        }
        function sa(a) {
            this.g = new oa;
            this.j = a;
        }
        function ta(a, b) {
            pa(a.g);
            var c = a.g.j;
            if (c) return ua(a, "return" in c ? c["return"] : function(d) {
                return {
                    value: d,
                    done: !0
                };
            }, b, a.g.return);
            a.g.return(b);
            return n(a);
        }
        function ua(a, b, c, d) {
            try {
                var e = b.call(a.g.j, c);
                if (!(e instanceof Object)) throw new TypeError("Iterator result " + e + " is not an object");
                if (!e.done) return a.g.m = !1, e;
                var g = e.value;
            } catch (h) {
                return a.g.j = null, qa(a.g, h), n(a);
            }
            a.g.j = null;
            d.call(a.g, g);
            return n(a);
        }
        function n(a) {
            for(; a.g.g;)try {
                var b = a.j(a.g);
                if (b) return a.g.m = !1, {
                    value: b.value,
                    done: !1
                };
            } catch (c) {
                a.g.u = void 0, qa(a.g, c);
            }
            a.g.m = !1;
            if (a.g.l) {
                b = a.g.l;
                a.g.l = null;
                if (b.mb) throw b.lb;
                return {
                    value: b.return,
                    done: !0
                };
            }
            return {
                value: void 0,
                done: !0
            };
        }
        function va(a) {
            this.next = function(b) {
                pa(a.g);
                a.g.j ? b = ua(a, a.g.j.next, b, a.g.o) : (a.g.o(b), b = n(a));
                return b;
            };
            this.throw = function(b) {
                pa(a.g);
                a.g.j ? b = ua(a, a.g.j["throw"], b, a.g.o) : (qa(a.g, b), b = n(a));
                return b;
            };
            this.return = function(b) {
                return ta(a, b);
            };
            this[Symbol.iterator] = function() {
                return this;
            };
        }
        function wa(a) {
            function b(d) {
                return a.next(d);
            }
            function c(d) {
                return a.throw(d);
            }
            return new Promise(function(d, e) {
                function g(h) {
                    h.done ? d(h.value) : Promise.resolve(h.value).then(b, c).then(g, e);
                }
                g(a.next());
            });
        }
        function xa(a) {
            return wa(new va(new sa(a)));
        }
        function ya() {
            var a = document.createElement("style");
            a.appendChild(document.createTextNode(".colibrio-renderer-paginated{-webkit-transform-origin:0 0;transform-origin:0 0}.colibrio-renderer-loader,.colibrio-renderer-paginated{-webkit-box-sizing:border-box;box-sizing:border-box;left:0;position:absolute;top:0}.colibrio-renderer-loader{height:100%;opacity:0;pointer-events:none;-webkit-transition:opacity .15s ease-out;transition:opacity .15s ease-out;width:100%;z-index:100}\n.colibrio-renderer-scrolled-document{-webkit-overflow-scrolling:touch;bottom:0;left:0;overflow-x:hidden;overflow-y:auto;position:absolute;right:0;top:0;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-transform-origin:0 0;transform-origin:0 0}.colibrio-renderer-scrolled-document>div{overflow:hidden}.colibrio-renderer-scrolled-document--offscreen-page{height:0;overflow:hidden;position:absolute;top:0;visibility:hidden}\n.colibrio-paged-view-flip-book{opacity:0}.colibrio-paged-view-flip-book__layout{-webkit-backface-visibility:hidden;backface-visibility:hidden;background-color:#fff;overflow:hidden;visibility:hidden}.colibrio-paged-view-flip-book__layout,.colibrio-paged-view-flip-book__page-container{-webkit-box-sizing:border-box;box-sizing:border-box;left:0;position:absolute;top:0}.colibrio-paged-view-flip-book__layout--flip-shadow{background-color:#000;opacity:0;pointer-events:none}.colibrio-paged-view-flip-book__page-fold-shadow{height:100%;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:1000}\n.colibrio-paged-view-single-page-swipe{overflow:hidden;z-index:1}.colibrio-paged-view-single-page-swipe__page-container--background-shadow{-webkit-box-shadow:0 5px 20px rgba(0,0,0,.2);box-shadow:0 5px 20px rgba(0,0,0,.2)}.colibrio-paged-view-single-page-swipe__layout{-webkit-box-align:center;-ms-flex-align:center;-webkit-box-pack:center;-ms-flex-pack:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;justify-content:center;left:0;position:absolute;top:0;z-index:2}.colibrio-paged-view-single-page-swipe__page-container{overflow:hidden;position:relative}\n.colibrio-paged-view-spread-swipe{overflow:hidden;z-index:1}.colibrio-paged-view-spread-swipe__layout{-webkit-box-align:center;-ms-flex-align:center;-webkit-box-pack:start;-ms-flex-pack:start;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;justify-content:flex-start;left:0;position:absolute;top:0;z-index:2}.colibrio-paged-view-spread-swipe__page-container{overflow:hidden;position:absolute}\n.colibrio-paged-view-stack{overflow:visible;z-index:0}.colibrio-paged-view-stack__layout{-webkit-backface-visibility:hidden;backface-visibility:hidden;background-color:#fff;left:0;overflow:hidden;position:absolute;top:0;-webkit-transform-style:flat;transform-style:flat;visibility:hidden}.colibrio-paged-view-stack__page-container{left:0;position:absolute;top:0}.colibrio-paged-view-stack__shadow{background-color:#000;height:auto;pointer-events:none;width:auto}.colibrio-paged-view-stack__shadow--x,.colibrio-paged-view-stack__shadow--y{bottom:3px;left:3px;right:3px;top:3px}"));
            var b = document.head;
            b.insertBefore(a, b.firstChild);
        }
        "object" === typeof document && (document.head ? ya() : document.addEventListener("DOMContentLoaded", ya, !1));
        var q = __dep__colibrio_core_base;
        var r = __dep__colibrio_core_publication_base;
        var w = __dep__colibrio_readingsystem_base;
        function x(a) {
            return 0 < a.length ? a[a.length - 1] : void 0;
        }
        function z(a, b, c) {
            return a < b ? b : a > c ? c : a;
        }
        function za(a, b, c) {
            Array.isArray(a) ? b = [] : b || (b = {});
            if ("object" === typeof a && null !== a) for(var d = Object.keys(a), e = 0; e < d.length; e++){
                var g = d[e], h = a[g];
                null !== h && "object" === typeof h ? b[g] = za(h, b[g], c) : "undefined" === typeof h ? c && delete b[g] : b[g] = h;
            }
            return b;
        }
        function A(a, b, c) {
            return za(a, b, c || !1);
        }
        function Aa(a, b) {
            var c;
            if (a && !Ba(a) && "object" === typeof a) {
                var d = Object.keys(a);
                var e = 0;
                for(c = d.length; e < c; e++){
                    var g = d[e];
                    b(a[g], g);
                }
            }
        }
        var Ba = Array.isArray;
        function B(a) {
            return "number" === typeof a && !isNaN(a);
        }
        function C(a, b, c, d) {
            return (d - c) / b * a + c;
        }
        var Ca = [
            "webkit",
            "moz",
            "ms"
        ];
        function Da(a, b) {
            var c = a.style;
            Aa(b, function(d, e) {
                "string" === typeof c[e] && (c[e] = d);
            });
        }
        function D(a, b) {
            b = F(a, b);
            var c = a.style;
            Aa(b, function(d, e) {
                "string" === typeof c[e] && (c[e] = d);
            });
        }
        function F(a, b) {
            var c = a.style, d = {};
            Aa(b, function(e, g) {
                if (g in c) var h = g;
                else {
                    var l = g.replace(/^./, function(t) {
                        return t.toUpperCase();
                    });
                    h = Ca.find(function(t) {
                        return t + l in c;
                    });
                }
                if (h) {
                    if ("transform" === g && "object" === typeof e) {
                        g = "";
                        if (e.x || e.y || e.z) {
                            var p = e.x || "0", u = e.y || "0";
                            g = e.z ? g + ("translate3d(" + p + "," + u + "," + (e.z || "0") + ") ") : g + ("translate(" + p + "," + u + ") ");
                        }
                        e.rotationX && (g += "rotateX(" + e.rotationX + ") ");
                        e.rotationY && (g += "rotateY(" + e.rotationY + ") ");
                        e.rotationZ && (g += "rotateZ(" + e.rotationZ + ") ");
                        d[h] = g;
                    } else "string" === typeof e && (d[h] = e);
                }
            });
            return d;
        }
        function Ea(a, b) {
            a = a.createElement("div");
            for(var c = 0; c < b.length; c++){
                var d = b[c];
                d.nb ? a.setAttributeNS(d.nb, d.name, d.value) : a.setAttribute(d.name, d.value);
            }
            return a;
        }
        var Fa = new Uint16Array(1);
        Fa[0] = 4660;
        new Uint8Array(Fa.buffer);
        function Ga(a) {
            this.g = a;
        }
        Ga.prototype.hasNext = function(a) {
            return !this.g.isLastPage(a);
        };
        function G(a, b) {
            return q.ColibrioError.call(this, "colibrio.readingsystem.renderer", a, b) || this;
        }
        m(G, q.ColibrioError);
        function Ha(a) {
            this.j = a;
            this.g = [];
        }
        function Ia(a, b) {
            if (b.s) {
                if (b.s.K.isRenderingCompleted()) {
                    a.da(b.s.A, b.s.la);
                    var c = Ja(a, b.s);
                    Ka(a, c);
                } else c = Ja(a), Ka(a, c);
                La(a, b);
            }
        }
        function Ma(a) {
            for(var b = k(a.g), c = b.next(); !c.done; c = b.next())c = c.value, a.j.da(c.A, c.ea);
            a.g = [];
        }
        function Na(a, b) {
            if ("CURRENT" !== b) {
                if ("LEFT" === b) {
                    b = a.g.filter(function(d) {
                        return 1 === d.A;
                    });
                    b = k(b);
                    for(var c = b.next(); !c.done; c = b.next())c = c.value, a.j.da(c.A, c.ea);
                    a.g = a.g.filter(function(d) {
                        return 1 !== d.A;
                    });
                    a = k(a.g);
                    for(b = a.next(); !b.done; b = a.next())b = b.value, -1 === b.A ? b.A = 0 : 0 === b.A && (b.A = 1);
                } else if ("RIGHT" === b) {
                    b = a.g.filter(function(d) {
                        return -1 === d.A;
                    });
                    b = k(b);
                    for(c = b.next(); !c.done; c = b.next())c = c.value, a.j.da(c.A, c.ea);
                    a.g = a.g.filter(function(d) {
                        return -1 !== d.A;
                    });
                    a = k(a.g);
                    for(b = a.next(); !b.done; b = a.next())b = b.value, 1 === b.A ? b.A = 0 : 0 === b.A && (b.A = -1);
                }
            }
        }
        Ha.prototype.ra = function(a, b) {
            var c = this.g.some(function(e) {
                return e.A === a && 0 === e.ea;
            }), d = this.g.some(function(e) {
                return e.A === a && e.ea === b;
            });
            c || d || (0 === b && (this.da(a, -1), this.da(a, 1)), this.g.push({
                A: a,
                ea: b
            }), this.j.ra(a, b));
        };
        function Ka(a, b) {
            b = k(b);
            for(var c = b.next(); !c.done; c = b.next())c = c.value, a.ra(c.A, c.ea);
        }
        function La(a, b) {
            if (b.s) {
                var c = b.qa, d = !1, e = {
                    gb: function(g) {
                        c === b.qa && d !== g.isRenderingCompleted() && b.s && (d = g.isRenderingCompleted()) && (a.da(b.s.A, b.s.la), Oa(b.s));
                    }
                };
                b.s.Pa = e;
                b.s.K.addStateChangeListener(e.gb);
            }
        }
        function Ja(a, b) {
            for(var c = [], d = k([
                -1,
                0,
                1
            ]), e = d.next(); !e.done; e = d.next()){
                e = e.value;
                for(var g = k(Pa(a)), h = g.next(); !h.done; h = g.next())h = h.value, b && e === b.A && b.la === h || c.push({
                    A: e,
                    ea: h
                });
            }
            return c;
        }
        function Pa(a) {
            var b = [];
            a.j.getSpreadMode() === w.RendererSpreadMode.SINGLE_PAGE ? b.push(2) : a.j.getSpreadMode() === w.RendererSpreadMode.TWO_PAGES ? (b.push(-1), b.push(1)) : a.j.getSpreadMode() === w.RendererSpreadMode.MIXED && b.push(0);
            return b;
        }
        function Qa(a, b, c) {
            var d = a.g.findIndex(function(e) {
                return e.A === b && 0 === e.ea;
            });
            -1 !== d && (d = a.g.splice(d, 1)[0], a.j.da(d.A, d.ea), -1 === c ? a.ra(b, 1) : a.ra(b, -1));
        }
        function Ra(a, b, c) {
            return a.j.getSpreadMode() !== w.RendererSpreadMode.MIXED || 0 === c ? !1 : a.g.some(function(d) {
                return d.A === b && 0 === d.ea;
            });
        }
        Ha.prototype.da = function(a, b) {
            if (Ra(this, a, b)) Qa(this, a, b);
            else {
                var c = this.g.findIndex(function(d) {
                    return d.A === a && d.ea === b;
                });
                -1 !== c && (c = this.g.splice(c, 1)[0], this.j.da(c.A, c.ea));
            }
        };
        function Oa(a) {
            a.Pa && a.K.removeStateChangeListener(a.Pa.gb);
            a.Pa = null;
        }
        function Sa(a, b, c) {
            this.j = a;
            this.l = b;
            this.T = c;
            this.P = this.M = null;
            this.o = !1;
            this.v = 1;
            this.ga = this.U = null;
            this.G = this.C = this.B = !1;
            this.W = null;
            this.m = !1;
            this.ba = this.Z = !0;
            this.g = [];
            this.ca = null;
            a.init(b);
            a = this.u = new Ha(a);
            b = Ja(a);
            Ka(a, b);
        }
        function Ta(a) {
            switch(a){
                case r.PageSpreadSlot.LEFT:
                    return -1;
                case r.PageSpreadSlot.RIGHT:
                    return 1;
                case r.PageSpreadSlot.CENTER:
                    return 0;
                case r.PageSpreadSlot.AUTO:
                    return 2;
            }
        }
        f = Sa.prototype;
        f.current = function() {
            return I(this, "CURRENT");
        };
        f.destroy = function() {
            if (!this.m) {
                this.m = !0;
                for(var a = k(this.g.slice()), b = a.next(); !b.done; b = a.next())Ua(this, b.value);
                this.v++;
                this.j.destroy();
                this.ga = this.U = this.P = this.M = null;
            }
        };
        function Va(a, b) {
            for(var c = a.j.getElement(), d = !1, e = b; e && !d;)d = e === c, e = e.parentNode;
            if (!d) return null;
            a = a.g.find(function(g) {
                for(var h = b; h && h !== c;){
                    var l = void 0;
                    if (h === (null == (l = g.s) ? void 0 : l.h)) return !0;
                    h = h.parentNode;
                }
                return !1;
            });
            return (null == a ? 0 : a.s) ? a.s.K : null;
        }
        function Wa(a) {
            var b = a.g.filter(function(c) {
                return null !== c.s;
            }).map(function(c) {
                return c.s;
            });
            a.T === w.ReaderViewPageProgressionDirection.RTL && b.reverse();
            return b;
        }
        f.xa = function() {
            var a = w.NavigationAction.CURRENT;
            if (!this.m && !this.o) {
                var b = this.j.xa();
                this.T === w.ReaderViewPageProgressionDirection.LTR ? "LEFT" === b ? a = w.NavigationAction.PREVIOUS_CONTENT_RANGE : "RIGHT" === b && (a = w.NavigationAction.NEXT_CONTENT_RANGE) : "LEFT" === b ? a = w.NavigationAction.NEXT_CONTENT_RANGE : "RIGHT" === b && (a = w.NavigationAction.PREVIOUS_CONTENT_RANGE);
                if (a === w.NavigationAction.NEXT_CONTENT_RANGE && !Xa(this) || a === w.NavigationAction.PREVIOUS_CONTENT_RANGE && !Ya(this)) a = w.NavigationAction.CURRENT;
            }
            return a;
        };
        f.Ca = function() {
            return this.j.Ca();
        };
        function Za(a) {
            var b = a.g.filter(function(c) {
                var d;
                return 0 === (null == (d = c.s) ? void 0 : d.A);
            }).map(function(c) {
                return c.s;
            });
            a.T === w.ReaderViewPageProgressionDirection.RTL && b.reverse();
            return b;
        }
        function $a(a, b, c) {
            if (a.m) return J();
            for(var d = ab(a), e = k(a.g), g = e.next(); !g.done; g = e.next())g.value.qa++;
            return a.j.Sa().then(function() {
                bb(a, d);
                return b();
            }).then(function(h) {
                return cb(a, h, d, c);
            });
        }
        f.next = function() {
            return Xa(this) ? this.T === w.ReaderViewPageProgressionDirection.LTR ? I(this, "RIGHT") : I(this, "LEFT") : J();
        };
        f.ya = function(a, b) {
            var c = this.g.filter(function(e) {
                return null !== e.s && 0 === e.s.A;
            }).map(function(e) {
                return e.s;
            });
            if (!this.m && !this.o && 0 < c.length) {
                var d = c[0];
                c = x(c);
                this.T === w.ReaderViewPageProgressionDirection.LTR ? (d = !this.l.g.isFirstPage(d.K), c = this.l.hasNext(c.K)) : (d = this.l.hasNext(d.K), c = !this.l.g.isFirstPage(c.K));
                this.j.ya(a, b, d, c);
            }
        };
        f.previous = function() {
            return Ya(this) ? this.T === w.ReaderViewPageProgressionDirection.LTR ? I(this, "LEFT") : I(this, "RIGHT") : J();
        };
        function db(a, b) {
            a.m || (a.M = b);
        }
        function eb(a, b) {
            a.P = b;
        }
        function fb(a, b) {
            a.U = b;
        }
        function gb(a, b) {
            a.ga = b;
        }
        function hb(a, b) {
            a.W = b;
        }
        function I(a, b) {
            if (a.o || a.m) return J();
            var c = ab(a);
            a.ca = b;
            a.ba = !1;
            a.Z = !1;
            return a.j.animate(b).then(function() {
                bb(a, c);
                var d;
                null == (d = a.U) || d.call(a);
                Na(a.u, b);
                d = a.g.slice();
                switch(b){
                    case "LEFT":
                        d = k(d);
                        for(var e = d.next(); !e.done; e = d.next())switch(e = e.value, e.ma){
                            case -1:
                                ib(e, 0);
                                break;
                            case 0:
                                ib(e, 1);
                                break;
                            case 1:
                                Ua(a, e);
                        }
                        break;
                    case "RIGHT":
                        for(d = k(d), e = d.next(); !e.done; e = d.next())switch(e = e.value, e.ma){
                            case -1:
                                Ua(a, e);
                                break;
                            case 0:
                                ib(e, -1);
                                break;
                            case 1:
                                ib(e, 0);
                        }
                }
                a.j.Ma(b);
                a: {
                    d = a.u;
                    switch(b){
                        case "LEFT":
                            var g = -1;
                            break;
                        case "RIGHT":
                            g = 1;
                            break;
                        case "CURRENT":
                            break a;
                    }
                    e = [];
                    for(var h = k(Pa(d)), l = h.next(); !l.done; l = h.next())e.push({
                        A: g,
                        ea: l.value
                    });
                    Ka(d, e);
                }
                g = k(a.g);
                for(d = g.next(); !d.done; d = g.next())d = d.value, d.s && (d.s.h.setAttribute("data-colibrio-internal-position", jb(d.s)), d.s.h.setAttribute("data-distance", kb(d.s)));
                g = lb(a, "previous");
                d = lb(a, "next");
                g && mb(a, g).catch(nb);
                d && ob(a, d).catch(nb);
                pb(a);
                qb(a, c);
                K(a);
            });
        }
        function cb(a, b, c, d) {
            if (a.v !== c || a.m) return a.l.g.unloadPage(b), J();
            for(var e = a.g.slice(), g = 0; g < e.length; g++)Ua(a, e[g]);
            Ma(a.u);
            a.j.Ma("GOTO");
            b = {
                ia: null,
                qa: 0,
                s: rb(a, b, 0, Ta(b.getSpreadSlot())),
                ma: 0
            };
            a.g.push(b);
            Ia(a.u, b);
            b.s && b.s.K.renderTo(b.s.h);
            b = [
                mb(a, b),
                ob(a, b)
            ];
            a.ca = "GOTO";
            a.ba = !1;
            a.Z = !1;
            return Promise.all(b).catch(nb).then(function() {
                bb(a, c);
                return a.j.Ra(d);
            }).then(function() {
                bb(a, c);
                pb(a);
                qb(a, c);
                K(a);
            });
        }
        function sb(a) {
            return 0 !== a.g.length && !a.g.some(function(b) {
                return !b.s;
            });
        }
        function tb(a) {
            return !a.g.some(function(b) {
                return 0 === b.ma && !b.s;
            });
        }
        function bb(a, b) {
            if (a.m || b !== a.v) throw new G(q.ColibrioErrorType.ABORTED);
        }
        function Xa(a) {
            return Za(a).length ? a.T === w.ReaderViewPageProgressionDirection.LTR ? ub(a, "RIGHT") : ub(a, "LEFT") : !1;
        }
        function Ya(a) {
            return Za(a).length ? a.T === w.ReaderViewPageProgressionDirection.LTR ? ub(a, "LEFT") : ub(a, "RIGHT") : !1;
        }
        function kb(a) {
            var b = 0, c = 2 === a.la ? 1 : 2;
            switch(a.A){
                case -1:
                    b = -1 * c;
                    break;
                case 0:
                    b = 0;
                    break;
                case 1:
                    b = c;
            }
            1 === a.la && (b += 1);
            return b.toString();
        }
        function jb(a) {
            var b = "";
            switch(a.A){
                case -1:
                    b += "VISUAL_PREVIOUS.";
                    break;
                case 0:
                    b += "CURRENT.";
                    break;
                case 1:
                    b += "VISUAL_NEXT.";
            }
            switch(a.la){
                case -1:
                    b += "LEFT";
                    break;
                case 0:
                    b += "CENTER";
                    break;
                case 1:
                    b += "RIGHT";
                    break;
                case 2:
                    b += "SINGLE_PAGE";
            }
            return b;
        }
        function rb(a, b, c, d) {
            a = {
                K: b,
                Pa: null,
                h: a.j.Ta(b, c),
                la: d,
                A: c
            };
            a.h.setAttribute("data-colibrio-internal-position", jb(a));
            a.h.setAttribute("data-distance", kb(a));
            return a;
        }
        function qb(a, b) {
            if (a.v === b) {
                a.o = !1;
                var c;
                null == (c = a.U) || c.call(a);
                vb(a);
            }
        }
        function wb(a, b, c) {
            var d = a.g.findIndex(function(e) {
                return e === b;
            });
            return "previous" === c && a.T === w.ReaderViewPageProgressionDirection.LTR || "next" === c && a.T === w.ReaderViewPageProgressionDirection.RTL ? a.g[d - 1] : a.g[d + 1];
        }
        function xb(a, b, c) {
            if (!b) return null;
            if ("previous" === c && a.T === w.ReaderViewPageProgressionDirection.LTR || "next" === c && a.T === w.ReaderViewPageProgressionDirection.RTL) {
                if (1 === b.la) return b.A;
                switch(b.A){
                    case -1:
                        return null;
                    case 0:
                        return -1;
                    case 1:
                        return 0;
                }
            } else {
                if (-1 === b.la) return b.A;
                switch(b.A){
                    case -1:
                        return 0;
                    case 0:
                        return 1;
                    case 1:
                        return null;
                }
            }
        }
        function yb(a, b, c) {
            if (a.j.getSpreadMode() === w.RendererSpreadMode.SINGLE_PAGE) return null;
            if ("previous" === c && a.T === w.ReaderViewPageProgressionDirection.LTR || "next" === c && a.T === w.ReaderViewPageProgressionDirection.RTL) {
                if (1 === b) return -1;
            } else if (-1 === b) return 1;
            return null;
        }
        function lb(a, b) {
            b = "previous" === b && a.T === w.ReaderViewPageProgressionDirection.LTR || "next" === b && a.T === w.ReaderViewPageProgressionDirection.RTL;
            a = a.g.filter(function(c) {
                return null !== c.s;
            });
            return b ? a[0] : x(a);
        }
        function ub(a, b) {
            switch(b){
                case "RIGHT":
                    return a.g.some(function(c) {
                        return 1 === c.ma;
                    });
                case "LEFT":
                    return a.g.some(function(c) {
                        return -1 === c.ma;
                    });
            }
        }
        function ob(a, b) {
            if (a.m || !a.g.includes(b)) return J();
            var c = wb(a, b, "next"), d = xb(a, b.s, "next"), e;
            if (null !== d && (null == (e = b.s) ? 0 : e.K) && !c) {
                if (a.l.hasNext(b.s.K)) {
                    var g = {
                        ia: a.l.g.loadNextPage(b.s.K, 0 === d),
                        qa: 0,
                        s: null,
                        ma: d
                    };
                    a.T === w.ReaderViewPageProgressionDirection.LTR ? a.g.push(g) : a.g.unshift(g);
                    var h = zb(a, g, function() {
                        ob(a, g).catch(nb);
                        K(a);
                    });
                } else if (b = yb(a, b.s.la, "next"), null !== b) {
                    var l, p;
                    null == (p = (l = a.j).$a) || p.call(l, d, b, !1);
                    a.u.da(d, b);
                }
            }
            K(a);
            vb(a);
            return h || Promise.resolve();
        }
        function mb(a, b) {
            if (a.m || !a.g.includes(b)) return J();
            var c = wb(a, b, "previous"), d = xb(a, b.s, "previous"), e;
            if (null !== d && (null == (e = b.s) ? 0 : e.K) && !c) {
                if (a.l.g.isFirstPage(b.s.K)) {
                    if (b = yb(a, b.s.la, "previous"), null !== b) {
                        var g, h;
                        null == (h = (g = a.j).$a) || h.call(g, d, b, !0);
                        a.u.da(d, b);
                    }
                } else {
                    var l = {
                        ia: a.l.g.loadPreviousPage(b.s.K, 0 === d),
                        qa: 0,
                        s: null,
                        ma: d
                    };
                    a.T === w.ReaderViewPageProgressionDirection.LTR ? a.g.unshift(l) : a.g.push(l);
                    var p = zb(a, l, function() {
                        mb(a, l).catch(nb);
                        K(a);
                    });
                }
            }
            K(a);
            vb(a);
            return p || Promise.resolve();
        }
        function vb(a) {
            if (a.W) {
                if (a.o) {
                    if (a.G || a.C || a.B) a.G = !1, a.B = !1, a.C = !1, a.W(a.G, a.B, a.C);
                } else {
                    var b = Ya(a), c = 0 < Za(a).length, d = Xa(a);
                    if (b !== a.G || c !== a.B || d !== a.C) a.G = b, a.B = c, a.C = d, a.W(b, c, d);
                }
            }
        }
        function K(a) {
            a.m || (!a.o && a.P && !a.ba && a.ca && tb(a) && (a.ba = !0, a.P(a.ca)), !a.o && a.M && !a.Z && sb(a) && (a.Z = !0, a.M()));
        }
        function zb(a, b, c) {
            if (b.ia) {
                var d = b.ia, e = ++b.qa;
                return d.then(function(g) {
                    b.ia === d && (b.ia = null);
                    if (a.m || e !== b.qa) throw a.l.g.unloadPage(g), new G(q.ColibrioErrorType.ABORTED);
                    b.s = rb(a, g, b.ma, Ta(g.getSpreadSlot()));
                    b.s && b.s.K.renderTo(b.s.h);
                    La(a.u, b);
                    0 !== b.s.A || a.o || g.setVisible(!0);
                    c();
                });
            }
            return J();
        }
        function ib(a, b) {
            a.ma = b;
            a.s && (a.s.A = b);
        }
        function ab(a) {
            a.o = !0;
            a.v++;
            var b;
            null == (b = a.ga) || b.call(a);
            vb(a);
            return a.v;
        }
        function Ua(a, b) {
            if (b.s) {
                0 === b.s.A && b.s.K.setVisible(!1);
                var c = b.s;
                c && Oa(c);
                a.l.g.unloadPage(b.s.K);
                a.j.Wa(b.s);
                b.s = null;
            }
            b.ia = null;
            b.qa++;
            a.g.splice(a.g.indexOf(b), 1);
        }
        function pb(a) {
            for(var b = 0; b < a.g.length; b++){
                var c = a.g[b];
                if (0 === c.ma) c.s ? c.s.K.setVisible(!0) : c.ia && a.l.g.notifyVisibilityIntentionForLoadingPage(c.ia, !0);
                else {
                    var d = void 0;
                    (null == (d = c.s) ? 0 : d.K) ? c.s.K.setVisible(!1) : c.ia && a.l.g.notifyVisibilityIntentionForLoadingPage(c.ia, !1);
                }
            }
        }
        function J() {
            return Promise.reject(new G(q.ColibrioErrorType.ABORTED));
        }
        function nb(a) {
            q.ColibrioError.isColibrioAbortedError(a) || q.Logger.logWarning(a);
        }
        function L(a, b, c, d, e) {
            var g = this;
            this.j = a;
            this.i = b;
            this.ua = c;
            this.u = d;
            this.G = e;
            this.m = null;
            this.v = !1;
            b = a.getReaderViewElement();
            e = a.getReaderViewDimensions();
            this.l = Ea(b.ownerDocument, [
                {
                    name: "class",
                    value: "colibrio-renderer-paginated"
                }
            ]);
            d = Math.floor((e.width - c.width) / 2);
            e = Math.floor((e.height - c.height) / 2);
            this.M = new DOMRect(d, e, c.width, c.height);
            this.l.style.width = c.width + "px";
            this.l.style.height = c.height + "px";
            this.l.style.left = d + "px";
            this.l.style.top = e + "px";
            b.appendChild(this.l);
            a.setPanZoomAllowed(!0);
            c = new Ga(a);
            this.o = this.B(this.l);
            this.g = new Sa(this.o, c, a.getPageProgressionDirection());
            eb(this.g, function() {
                if (g.m) {
                    var h = Za(g.g).filter(function(p) {
                        return null !== p.K;
                    });
                    if (1 < h.length) {
                        var l = x(h).K;
                        l = h[0].K.getStartContentLocation().createRangeTo(l.getRangeContentLocation());
                        g.m.notifyVisibleRangeChanged(l, h.map(function(p) {
                            return p.K;
                        }));
                    } else 1 === h.length ? (h = h[0].K, g.m.notifyVisibleRangeChanged(h.getRangeContentLocation(), [
                        h
                    ])) : g.m.notifyVisibleRangeChanged(null, []);
                    a.notifyVisiblePagesUpdated();
                }
            });
            db(this.g, function() {
                Ab(g);
                a.notifyPageLoadingComplete();
            });
            gb(this.g, function() {
                a.notifyTransitionStarted();
                a.setSwipeNavigationGestureAllowed(!1);
            });
            fb(this.g, function() {
                a.notifyTransitionFinished();
                a.setSwipeNavigationGestureAllowed(!0);
            });
            hb(this.g, function(h, l, p) {
                a.notifyPossibleNavigationActions({
                    current: l,
                    nextContentRange: p,
                    nextRenderablePage: p,
                    previousContentRange: h,
                    previousRenderablePage: h
                });
            });
        }
        f = L.prototype;
        f.applyTransform = function(a) {
            var b = Math.round((null == a ? void 0 : a.x) || 0), c = Math.round((null == a ? void 0 : a.y) || 0);
            a ? !a.animating && !a.userGestureActive || q.BrowserDetector.isRenderingEngine("Blink") ? (Bb(this, !1), this.l.style.transform = "translate(" + b + "px," + c + "px) scale(" + a.scale + ")") : (Bb(this, !0), this.l.style.transform = "translate3d(" + b + "px," + c + "px, 0px) scale(" + a.scale + ")") : (Bb(this, !1), this.l.style.transform = "");
        };
        f.canHandleMultipleRenderingSections = function() {
            return !0;
        };
        f.destroy = function() {
            this.m = null;
            this.g.destroy();
            if (this.l) {
                var a = this.l, b = a.parentNode;
                b && b.removeChild(a);
            }
        };
        f.getContentDisplayAreaDimensions = function(a, b) {
            b = !b && this.o.Ua();
            var c = "fill" === this.j.getConfiguredPageAspectRatio() || b;
            return a && c ? this.j.getReaderViewDimensions() : b && this.G ? this.G : this.u ? this.u : this.o.getContentDisplayAreaDimensions();
        };
        f.getPublicationViewportBoundingRect = function() {
            return this.M;
        };
        f.getRenderablePageByElement = function(a) {
            return Va(this.g, a);
        };
        f.getRendererElement = function() {
            return this.l;
        };
        f.getSwipeNavigationAxis = function() {
            return q.Axis.X;
        };
        f.handlePointerEngineEvent = function(a, b, c) {
            return Cb(this, a, b, c);
        };
        f.handlePointerEngineEventV2 = function(a, b, c) {
            return (a = Cb(this, a, b, c, !0)) ? {
                pendingNavigationAction: a,
                swipeProgress: this.g.Ca()
            } : null;
        };
        f.isNativePanXAllowed = function() {
            return !1;
        };
        f.isNativePanYAllowed = function() {
            return !1;
        };
        f.navigate = function(a, b) {
            this.m = b;
            switch(a){
                case w.NavigationAction.CURRENT:
                    var c = this.g.current();
                    break;
                case w.NavigationAction.PREVIOUS_RENDERABLE_PAGE:
                case w.NavigationAction.PREVIOUS_CONTENT_RANGE:
                    c = this.g.previous();
                    break;
                case w.NavigationAction.NEXT_RENDERABLE_PAGE:
                case w.NavigationAction.NEXT_CONTENT_RANGE:
                    c = this.g.next();
            }
            return c || Promise.reject(new G(q.ColibrioErrorType.ABORTED));
        };
        f.navigateTo = function(a, b) {
            var c = this;
            this.m = b;
            return $a(this.g, function() {
                return c.j.loadPageByContentLocation(a, !0);
            }, !this.j.isRendererRuntimeVisible());
        };
        f.navigateToStart = function(a) {
            var b = this;
            this.m = a;
            return $a(this.g, function() {
                return b.j.loadFirstPage(!0);
            }, !this.j.isRendererRuntimeVisible());
        };
        f.setOptions = function(a) {
            this.i = a;
        };
        function Cb(a, b, c, d, e) {
            e = void 0 === e ? !1 : e;
            var g = null;
            if (!a.g.o) switch(b.type){
                case "pointermove":
                    a.g.ya(-c, -d);
                    e && (g = a.g.xa());
                    break;
                case "pointerup":
                    a.g.ya(-c, -d);
                    g = a.g.xa();
                    break;
                case "pointercancel":
                    g = w.NavigationAction.CURRENT;
            }
            return g;
        }
        function Bb(a, b) {
            b && !a.v ? (a.v = !0, a.l.style.willChange = "transform") : !b && a.v && (a.v = !1, a.l.style.willChange = "");
        }
        function Ab(a) {
            function b(t) {
                if (1 < t.length) {
                    var E = t[0].getRangeContentLocation();
                    t = x(t).getRangeContentLocation();
                    return E.createRangeTo(t);
                }
                return 1 === t.length ? t[0].getRangeContentLocation() : null;
            }
            for(var c = Wa(a.g).slice(), d = [], e = [], g = [], h = 0; h < c.length; h++){
                var l = c[h];
                if (null !== l.K) {
                    var p = l.A;
                    -1 === p ? d.push(l.K) : 0 === p ? e.push(l.K) : 1 === p && g.push(l.K);
                }
            }
            c = b(d);
            d = b(e);
            g = b(g);
            var u;
            null == (u = a.m) || u.notifyContentRangesChanged({
                next: g,
                previous: c,
                visible: d
            }, e);
        }
        var Db = __lib__bezier_easing;
        function Eb(a) {
            a = a.trim();
            var b = a.slice(13, -1).split(",").map(parseFloat);
            a = Db.apply;
            if (!(b instanceof Array)) {
                b = k(b);
                for(var c, d = []; !(c = b.next()).done;)d.push(c.value);
                b = d;
            }
            return a.call(Db, null, b);
        }
        function Fb() {
            return {
                animationDurationMs: null,
                disableAnimations: !1,
                goToAnimationDurationMs: null,
                ignoreAspectRatio: !1,
                name: "renderer_" + Gb++,
                pageBackgroundColor: "transparent"
            };
        }
        var Gb = 1;
        function M() {
            this.g = [];
            this.j = null;
        }
        M.prototype.N = function(a, b, c) {
            c = B(c) ? {
                duration: c,
                fill: "forwards"
            } : c;
            try {
                var d = a.animate(b, c);
                d.pause();
                this.g.push(d);
                return d;
            } catch (e) {
                q.Logger.logError(e);
            }
            return null;
        };
        M.prototype.destroy = function() {
            for(var a = 0; a < this.g.length; a++){
                var b = this.g[a];
                try {
                    b.cancel();
                } catch (c) {
                    q.Logger.logError(c);
                }
            }
            this.g = [];
        };
        M.prototype.pause = function() {
            for(var a = 0; a < this.g.length; a++){
                var b = this.g[a];
                try {
                    b.pause();
                } catch (c) {
                    q.Logger.logError(c);
                }
            }
        };
        M.prototype.play = function() {
            var a = this;
            return this.j ? this.j : this.j = new Promise(function(b) {
                function c() {
                    if (g === h) {
                        for(var t = 0; t < a.g.length; t++){
                            var E = a.g[t];
                            E.removeEventListener("finish", e);
                            E.removeEventListener("cancel", d);
                        }
                        a.j = null;
                        b(!l);
                    }
                }
                function d() {
                    g++;
                    l = !0;
                    c();
                }
                function e() {
                    g++;
                    c();
                }
                for(var g = 0, h = 0, l = !1, p = 0; p < a.g.length; p++){
                    var u = a.g[p];
                    if ("finished" !== u.playState) {
                        h++;
                        u.addEventListener("finish", e);
                        u.addEventListener("cancel", d);
                        try {
                            u.play();
                        } catch (t) {
                            q.Logger.logError(t), setTimeout(e, 0);
                        }
                    }
                }
                0 === h && b(!0);
            });
        };
        function Hb(a) {
            for(var b = 0; b < a.g.length; b++){
                var c = a.g[b];
                try {
                    c.reverse();
                } catch (d) {
                    q.Logger.logError(d);
                }
            }
        }
        function Ib(a, b) {
            for(var c = 0; c < a.g.length; c++){
                var d = a.g[c];
                try {
                    d.currentTime = b;
                } catch (e) {
                    q.Logger.logError(e);
                }
            }
        }
        function Jb(a, b, c) {
            this.h = a;
            this.i = b;
            this.ha = c;
            this.j = this.g = null;
            this.za = this.I = this.U = 0;
            this.m = this.l = this.ca = this.u = this.o = this.Z = this.W = this.ba = null;
            this.ga = 1;
            B(this.i.animationDurationMs) ? this.H = this.i.animationDurationMs : q.BrowserDetector.isPlatform("mobile") ? this.H = 375 : this.H = 490;
            B(this.i.goToAnimationDurationMs) ? this.S = this.i.goToAnimationDurationMs : q.BrowserDetector.isPlatform("mobile") ? this.S = 225 : q.BrowserDetector.isPlatform("tablet") ? this.S = 290 : this.S = 160;
            q.BrowserDetector.isBrowser("Firefox") && (this.i.showPageTurnShadow = !1);
            this.h.classList.add("colibrio-paged-view-flip-book");
            this.i.showRendererBackgroundShadow && !this.i.hideEmptySpreadSlots && (this.h.style.boxShadow = "0px 5px 20px rgba(0, 0, 0, " + this.i.rendererBackgroundShadowOpacity + ")");
            this.i.disableAnimations || (this.h.style.transitionDuration = "0s", this.h.style.transitionProperty = "opacity", this.h.style.transitionTimingFunction = "cubic-bezier(0.0, 0.0, 0.2, 1)");
            this.Xa = Eb("cubic-bezier(0.25, 0.46, 0.45, 0.94)");
            this.v = this.R(!0);
            this.P = this.R(!0);
            this.B = this.R(!0);
            this.G = this.R(!0);
            this.M = this.R(!0);
            this.C = this.R(!0);
            [
                this.v,
                this.B,
                this.M
            ].forEach(function(d) {
                return d.classList.add("colibrio-paged-view-flip-book__left-spread");
            });
            [
                this.P,
                this.G,
                this.C
            ].forEach(function(d) {
                return d.classList.add("colibrio-paged-view-flip-book__right-spread");
            });
            this.h.appendChild(this.v);
            this.h.appendChild(this.P);
            this.h.appendChild(this.B);
            this.h.appendChild(this.G);
            this.h.appendChild(this.M);
            this.h.appendChild(this.C);
            this.i.showPageFoldShadow && q.RuntimePlatform.isBlobUrlSupported() && (this.ba = URL.createObjectURL(new Blob([
                '<svg xmlns="http://www.w3.org/2000/svg" height="675.37" width="450" preserveAspectRatio="none" viewBox="0 0 450 675.374"><defs><linearGradient id="c" y2="1372.7" gradientUnits="userSpaceOnUse" x2="2719.5" gradientTransform="matrix(2.77008 0 0 1 -7059.72 -1039.3)" y1="1372.7" x1="2679"><stop stop-opacity="0" offset="0"/><stop stop-opacity=".333" offset=".32"/><stop offset="1"/></linearGradient><linearGradient id="d" y2="1372.7" gradientUnits="userSpaceOnUse" x2="2711" gradientTransform="matrix(.83405 0 0 1 -1811.09 -1039.3)" y1="1372.7" x1="2678.4"><stop stop-opacity="0" offset="0"/><stop stop-opacity=".333" offset=".5"/><stop offset="1"/></linearGradient></defs><path opacity=".071" stroke-width="1.001" fill="url(#c)" d="M357 0h93.005v675.37H357z"/><path opacity=".215" stroke-width="1.001" fill="url(#d)" d="M422 0h28.003v675.37H422z"/></svg>'
            ], {
                type: "image/svg+xml"
            })), this.ca = URL.createObjectURL(new Blob([
                '<svg xmlns="http://www.w3.org/2000/svg" height="676.76" width="450.01" viewBox="0 0 450.009 676.764" preserveAspectRatio="none"><defs><linearGradient id="c" x1="2678.4" gradientUnits="userSpaceOnUse" y1="1372.7" gradientTransform="matrix(.65604 0 0 1.00207 -1778.54 -1041.44)" x2="2719.5" y2="1372.7"><stop stop-opacity="0" offset="0"/><stop stop-opacity=".333" offset=".32"/><stop offset=".64"/><stop stop-opacity=".812" offset="1"/></linearGradient><linearGradient id="d" y2="1372.7" gradientUnits="userSpaceOnUse" x2="2719.5" gradientTransform="matrix(.32607 0 0 1.00206 -883.972 -1041.45)" y1="1372.7" x1="2678.4"><stop stop-opacity="0" offset="0"/><stop stop-opacity=".333" offset=".32"/><stop offset=".64"/><stop stop-opacity=".812" offset="1"/></linearGradient><linearGradient id="b" y2="1372.7" gradientUnits="userSpaceOnUse" x2="2719.5" gradientTransform="matrix(2.77014 0 0 1.002 -7509.89 -1041.37)" y1="1372.7" x1="2687.4"><stop stop-opacity="0" offset="0"/><stop stop-opacity=".333" offset=".32"/><stop offset=".592"/><stop stop-opacity=".812" offset="1"/></linearGradient></defs><path opacity=".141" transform="scale(-1 1)" fill="url(#b)" d="M-93.021-.001H-.014v676.72h-93.007z"/><path opacity=".141" transform="scale(-1 1)" fill="url(#c)" d="M-22.025-.001H.001v676.77h-22.026z"/><path opacity=".109" transform="scale(-1 1)" stroke-width="1.001" fill="url(#d)" d="M-10.946-.001H.002v676.76h-10.948z"/></svg>'
            ], {
                type: "image/svg+xml"
            })));
        }
        f = Jb.prototype;
        f.ra = function(a, b) {
            this.ha.renderTo(this.aa(b, a));
        };
        f.animate = function(a) {
            if (this.i.disableAnimations) return Promise.resolve();
            switch(a){
                case "RIGHT":
                    this.g || (this.g = Kb(this, "cubic-bezier(0.455, 0.03, 0.515, 0.955)"));
                    if (this.g) return this.g.play();
                    break;
                case "LEFT":
                    this.j || (this.j = Lb(this, "cubic-bezier(0.455, 0.03, 0.515, 0.955)"));
                    if (this.j) return this.j.play();
                    break;
                case "CURRENT":
                    if (this.j) return Hb(this.j), this.j.play();
                    if (this.g) return Hb(this.g), this.g.play();
            }
            return Promise.resolve();
        };
        f.Ra = function(a) {
            var b = this;
            if (this.i.disableAnimations || a) return this.h.style.transitionDuration = "0s", this.h.style.opacity = "1", Promise.resolve();
            this.h.style.transitionDuration = this.S + "ms";
            this.h.style.opacity = "1";
            return new Promise(function(c) {
                setTimeout(c, b.S + 16);
            });
        };
        f.Sa = function() {
            if (this.i.disableAnimations) return this.h.style.opacity = "0", Promise.resolve();
            Mb(this);
            this.h.style.transitionDuration = "0s";
            this.h.style.opacity = "0";
            return Promise.resolve();
        };
        f.Ta = function(a, b) {
            a = a.getSpreadSlot();
            var c = Nb(a);
            b = this.aa(c, b);
            var d = this.h.ownerDocument.createElement("div"), e = this.getContentDisplayAreaDimensions();
            d.style.height = e.height + "px";
            d.style.width = e.width + "px";
            d.classList.add("colibrio-paged-view-flip-book__page-container");
            -1 === c ? d.classList.add("colibrio-paged-view-flip-book__page-container-left") : 1 === c && d.classList.add("colibrio-paged-view-flip-book__page-container-right");
            c = b.querySelectorAll(".colibrio-paged-view-flip-book__page-container");
            for(e = 0; e < c.length; e++)c[e].remove();
            b.insertBefore(d, b.firstChild);
            a === r.PageSpreadSlot.LEFT && this.ba ? Ob(this, b, this.ba) : a === r.PageSpreadSlot.RIGHT && this.ca && Ob(this, b, this.ca);
            return d;
        };
        f.destroy = function() {
            Mb(this);
            this.ba && (URL.revokeObjectURL(this.ba), this.ba = null);
            this.ca && (URL.revokeObjectURL(this.ca), this.ca = null);
        };
        f.getContentDisplayAreaDimensions = function() {
            var a = this.h.ownerDocument.defaultView.getComputedStyle(this.h);
            return {
                height: Math.ceil(a.height ? parseFloat(a.height) : 0),
                width: Math.ceil((a.width ? parseFloat(a.width) : 0) / 2)
            };
        };
        f.xa = function() {
            var a = "CURRENT";
            .15 < this.U && 0 < this.I ? a = "RIGHT" : -0.15 > this.U && 0 > this.I && (a = "LEFT");
            return a;
        };
        f.getElement = function() {
            return this.h;
        };
        f.getSpreadMode = function() {
            return w.RendererSpreadMode.TWO_PAGES;
        };
        f.Ca = function() {
            return this.Xa(this.U);
        };
        f.init = function() {
            this.pa();
            this.i.showPageTurnShadow && (this.m = this.R(!1), this.m.classList.add("colibrio-paged-view-flip-book__layout--flip-shadow"), this.m.style.zIndex = "11", this.h.appendChild(this.m), this.l = this.R(!1), this.l.classList.add("colibrio-paged-view-flip-book__layout--flip-shadow"), this.l.style.zIndex = "6", this.h.appendChild(this.l));
            if (this.i.hideEmptySpreadSlots && this.i.showRendererBackgroundShadow) {
                this.o = this.R(!1);
                var a = F(this.o, {
                    boxShadow: "0px 5px 20px rgba(0, 0, 0, " + this.i.rendererBackgroundShadowOpacity + ")",
                    opacity: "1",
                    transform: {
                        x: "0",
                        y: "0"
                    },
                    visibility: "visible",
                    zIndex: "1"
                });
                Da(this.o, a);
                this.h.appendChild(this.o);
                this.u = this.R(!1);
                a = F(this.u, {
                    boxShadow: "0px 5px 20px rgba(0, 0, 0, " + this.i.rendererBackgroundShadowOpacity + ")",
                    opacity: "1",
                    transform: {
                        x: "100%",
                        y: "0"
                    },
                    visibility: "visible",
                    zIndex: "1"
                });
                Da(this.u, a);
                this.h.appendChild(this.u);
            }
        };
        f.Ua = function() {
            return !1;
        };
        f.$a = function(a, b, c) {
            c ? (this.W = this.aa(b, a), this.W.style.visibility = "hidden") : (this.Z = this.aa(b, a), this.Z.style.visibility = "hidden");
            Pb(this);
        };
        f.ya = function(a, b, c, d) {
            this.I = .75 * this.I + .25 * (a - this.za);
            this.za = a;
            b = !1;
            -10 > a ? (a = Math.min(0, a + 10), b = !c) : 10 < a ? (a = Math.max(0, a - 10), b = !d) : a = 0;
            b && 0 !== a && (a = Math.pow(Math.abs(a), z(this.i.rubberBandElasticity, 0, 1)) * Math.sign(a));
            this.U = z(a / this.ga, -0.99, .99);
            this.i.disableAnimations || (0 > this.U ? (this.g && (this.g.destroy(), this.g = null), this.j || (this.j = Lb(this, "cubic-bezier(0.25, 0.46, 0.45, 0.94)")), this.j && Ib(this.j, -this.U * this.H)) : 0 < this.U && (this.j && (this.j.destroy(), this.j = null), this.g || (this.g = Kb(this, "cubic-bezier(0.25, 0.46, 0.45, 0.94)")), this.g && Ib(this.g, this.U * this.H)));
        };
        f.pa = function() {
            this.ga = this.h.offsetWidth;
            var a = this.h.style;
            "perspective" in a ? a.perspective = this.ga * this.i.perspectiveFactor + "px" : "webkitPerspective" in a && (a.webkitPerspective = this.ga * this.i.perspectiveFactor + "px");
        };
        f.Wa = function(a) {
            a.h.remove();
        };
        f.da = function(a, b) {
            this.ha.removeFrom(this.aa(b, a));
        };
        function Qb(a, b) {
            b ? a.pa() : (a = a.h.style, "perspective" in a ? a.perspective = "" : "webkitPerspective" in a && (a.webkitPerspective = ""));
        }
        f.Ma = function(a) {
            this.I = this.U = this.za = 0;
            this.m && (this.m.style.opacity = "0", this.m.style.visibility = "visible");
            this.l && (this.l.style.opacity = "0", this.l.style.visibility = "visible");
            Pb(this);
            Mb(this);
            this.W && Rb(this, a, this.W) && (this.W.style.visibility = "visible", this.W = null, Pb(this));
            this.Z && Rb(this, a, this.Z) && (this.Z.style.visibility = "visible", this.Z = null, Pb(this));
            if ("RIGHT" === a) O(this, -1, !1), O(this, 0, !1), O(this, 1, !0), this.h.insertBefore(this.v, null), this.h.insertBefore(this.P, null);
            else if ("LEFT" === a) O(this, -1, !0), O(this, 0, !1), O(this, 1, !1), this.h.insertBefore(this.M, this.v), this.h.insertBefore(this.C, this.v);
            else if ("GOTO" === a || "CURRENT" === a) O(this, -1, !1), O(this, 0, !0), O(this, 1, !1);
            var b = this.v, c = this.P, d = this.B, e = this.G, g = this.M, h = this.C;
            "RIGHT" === a ? (this.v = d, this.P = e, this.B = g, this.G = h, this.M = b, this.C = c) : "LEFT" === a && (this.v = g, this.P = h, this.B = b, this.G = c, this.M = d, this.C = e);
            D(this.v, this.F(-1, -1, void 0, !0));
            D(this.P, this.F(-1, 1, void 0, !0));
            D(this.B, this.F(0, -1, void 0, !0));
            D(this.G, this.F(0, 1, void 0, !0));
            D(this.M, this.F(1, -1, void 0, !0));
            D(this.C, this.F(1, 1, void 0, !0));
        };
        function Ob(a, b, c) {
            var d = document.createElement("img");
            d.classList.add("colibrio-paged-view-flip-book__page-fold-shadow");
            d.style.opacity = a.i.pageFoldShadowOpacity.toString();
            d.setAttribute("role", "presentation");
            d.src = c;
            b.appendChild(d);
        }
        f.R = function(a) {
            var b = this.h.ownerDocument.createElement("div"), c = this.getContentDisplayAreaDimensions();
            b.style.height = c.height + "px";
            b.style.width = c.width + "px";
            b.style.visibility = "hidden";
            b.classList.add("colibrio-paged-view-flip-book__layout");
            a && (b.style.backgroundColor = this.i.pageBackgroundColor);
            return b;
        };
        function Kb(a, b) {
            var c = null;
            b = {
                duration: a.H,
                easing: b,
                fill: "both"
            };
            var d = a.M, e = a.C;
            d.style.visibility = P(a, d) ? "hidden" : "visible";
            e.style.visibility = P(a, e) ? "hidden" : "visible";
            d && (c = new M, c.N(d, [
                F(d, a.F(1, -1, {
                    zIndex: "15"
                })),
                F(d, a.F(0, -1, {
                    zIndex: "15"
                }))
            ], b), d = a.G, P(a, d) || (c.N(d, [
                F(d, a.F(0, 1)),
                F(d, a.F(-1, 1))
            ], b), a.l && c.N(a.l, [
                F(a.l, {
                    opacity: "" + a.i.pageTurnShadowMaxOpacity,
                    transform: {
                        x: "100%"
                    }
                }),
                F(a.l, {
                    offset: "0.5",
                    opacity: "0",
                    transform: {
                        x: "100%"
                    }
                }),
                F(a.l, {
                    opacity: "0",
                    transform: {
                        x: "100%"
                    }
                })
            ], b), a.m && c.N(a.m, [
                F(a.m, {
                    opacity: "0",
                    transform: {
                        x: "0%"
                    }
                }),
                F(a.m, {
                    offset: "0.5",
                    opacity: "0",
                    transform: {
                        x: "0%"
                    }
                }),
                F(a.m, {
                    opacity: "" + a.i.pageTurnShadowMaxOpacity,
                    transform: {
                        x: "0%"
                    }
                })
            ], b), a.o && a.u && (P(a, a.B) && c.N(a.o, [
                F(a.o, {
                    opacity: "0"
                }),
                F(a.o, {
                    offset: "0.8",
                    opacity: "0"
                }),
                F(a.o, {
                    opacity: "0.999"
                })
            ], b), P(a, a.C) && c.N(a.u, [
                F(a.u, {
                    opacity: "0.999"
                }),
                F(a.u, {
                    offset: "0.2",
                    opacity: "0"
                }),
                F(a.u, {
                    opacity: "0"
                })
            ], b))));
            return c;
        }
        function Lb(a, b) {
            var c = null;
            b = {
                duration: a.H,
                easing: b,
                fill: "both"
            };
            var d = a.v, e = a.P;
            d.style.visibility = P(a, d) ? "hidden" : "visible";
            e.style.visibility = P(a, e) ? "hidden" : "visible";
            e && (c = new M, c.N(e, [
                F(e, a.F(-1, 1, {
                    zIndex: "15"
                })),
                F(e, a.F(0, 1, {
                    zIndex: "15"
                }))
            ], b), e = a.B, P(a, a.B) || (c.N(e, [
                F(e, a.F(0, -1)),
                F(e, a.F(1, -1))
            ], b), a.l && c.N(a.l, [
                F(a.l, {
                    opacity: "" + a.i.pageTurnShadowMaxOpacity,
                    transform: {
                        x: "0%"
                    }
                }),
                F(a.l, {
                    offset: "0.5",
                    opacity: "0",
                    transform: {
                        x: "0%"
                    }
                }),
                F(a.l, {
                    opacity: "0",
                    transform: {
                        x: "0%"
                    }
                })
            ], b), a.m && c.N(a.m, [
                F(a.m, {
                    opacity: "0",
                    transform: {
                        x: "100%"
                    }
                }),
                F(a.m, {
                    offset: "0.5",
                    opacity: "0",
                    transform: {
                        x: "100%"
                    }
                }),
                F(a.m, {
                    opacity: "" + a.i.pageTurnShadowMaxOpacity,
                    transform: {
                        x: "100%"
                    }
                })
            ], b), a.o && a.u && (P(a, d) && c.N(a.o, [
                F(a.o, {
                    opacity: "0.999"
                }),
                F(a.o, {
                    offset: "0.2",
                    opacity: "0"
                }),
                F(a.o, {
                    opacity: "0"
                })
            ], b), P(a, a.G) && c.N(a.u, [
                F(a.u, {
                    opacity: "0"
                }),
                F(a.u, {
                    offset: "0.8",
                    opacity: "0"
                }),
                F(a.u, {
                    opacity: "0.999"
                })
            ], b))));
            return c;
        }
        function Mb(a) {
            a.g && (a.g.destroy(), a.g = null);
            a.j && (a.j.destroy(), a.j = null);
        }
        f.F = function(a, b, c, d) {
            -1 === a && -1 === b ? (a = A(c, {
                opacity: "0.999",
                transform: {
                    rotationY: "0",
                    x: "0%"
                },
                transformOrigin: "100% 0%"
            }), d && (a.zIndex = "5", a.transform = {
                x: "0%"
            })) : -1 === a && 1 === b ? (a = A(c, {
                opacity: "0.999",
                transform: {
                    rotationY: "-180deg",
                    x: "100%"
                },
                transformOrigin: "0% 0%"
            }), d && (a.zIndex = "8", a.transform = {
                x: "0%"
            })) : 0 === a && -1 === b ? (a = A(c, {
                opacity: "1",
                transformOrigin: "100% 0%"
            }), d ? (a.zIndex = "10", a.transform = {
                x: "0",
                y: "0"
            }) : a.transform = {
                rotationY: "0",
                x: "0%"
            }) : 0 === a && 1 === b ? (a = A(c, {
                opacity: "1",
                transformOrigin: "0% 0%"
            }), d ? (a.zIndex = "10", a.transform = {
                x: "100%",
                y: "0"
            }) : a.transform = {
                rotationY: "0",
                x: "100%"
            }) : 1 === a && -1 === b ? (a = A(c, {
                opacity: "0.999",
                transform: {
                    rotationY: "180deg",
                    x: "0%"
                },
                transformOrigin: "100% 0%"
            }), d && (a.zIndex = "8", a.transform = {
                x: "100%"
            })) : 1 === a && 1 === b ? (a = A(c, {
                opacity: "0.999",
                transform: {
                    rotationY: "0",
                    x: "100%"
                },
                transformOrigin: "0% 0%"
            }), d && (a.zIndex = "5", a.transform = {
                x: "100%"
            })) : (a = A(c, {
                transform: {
                    x: "-2000%"
                },
                transformOrigin: "0% 0%"
            }), d && (a.zIndex = "1"));
            return a;
        };
        f.aa = function(a, b) {
            switch(b){
                case -1:
                    return 1 === a ? this.P : this.v;
                case 0:
                    return 1 === a ? this.G : this.B;
                case 1:
                    return 1 === a ? this.C : this.M;
            }
        };
        function Nb(a) {
            switch(a){
                case r.PageSpreadSlot.LEFT:
                    return -1;
                case r.PageSpreadSlot.RIGHT:
                    return 1;
                case r.PageSpreadSlot.CENTER:
                    return 0;
                case r.PageSpreadSlot.AUTO:
                    return 2;
            }
        }
        function P(a, b) {
            return b === a.W || b === a.Z;
        }
        function Rb(a, b, c) {
            return "RIGHT" === b && c === a.v || "LEFT" === b && c === a.C || "GOTO" === b;
        }
        function Pb(a) {
            a.o && (a.o.style.opacity = P(a, a.B) ? "0" : "1");
            a.u && (a.u.style.opacity = P(a, a.G) ? "0" : "1");
        }
        function O(a, b, c) {
            c = c ? "visible" : "hidden";
            -1 === b ? (P(a, a.v) || (a.v.style.visibility = c), a.P.style.visibility = c) : 0 === b ? (P(a, a.B) || (a.B.style.visibility = c), P(a, a.G) || (a.G.style.visibility = c)) : 1 === b && (a.M.style.visibility = c, P(a, a.C) || (a.C.style.visibility = c));
        }
        function Q(a, b, c) {
            L.call(this, a, b, c, null, null);
            this.C = !1;
        }
        m(Q, L);
        Q.prototype.applyTransform = function(a) {
            L.prototype.applyTransform.call(this, a);
            Sb(this, null !== a && 1 < a.scale);
        };
        Q.prototype.destroy = function() {
            L.prototype.destroy.call(this);
        };
        Q.prototype.setOptions = function(a) {
            L.prototype.setOptions.call(this, a);
        };
        Q.prototype.B = function(a) {
            var b = this.i;
            return new Jb(a, {
                animationDurationMs: b.animationDurationMs,
                disableAnimations: b.disableAnimations,
                goToAnimationDurationMs: b.goToAnimationDurationMs,
                hideEmptySpreadSlots: b.hideEmptySpreadSlots,
                pageBackgroundColor: b.pageBackgroundColor,
                pageFoldShadowOpacity: b.pageFoldShadowOpacity,
                pageTurnShadowMaxOpacity: b.pageTurnShadowMaxOpacity,
                perspectiveFactor: b.perspectiveFactor,
                rendererBackgroundShadowOpacity: b.rendererBackgroundShadowOpacity,
                rubberBandElasticity: b.rubberBandElasticity,
                showPageFoldShadow: b.showPageFoldShadow,
                showPageTurnShadow: b.showPageTurnShadow,
                showRendererBackgroundShadow: b.showRendererBackgroundShadow
            }, this.j.getContentOnLoading());
        };
        function Sb(a, b) {
            if (a.C !== b) {
                a.C = b;
                var c = a.j.getReaderPublications();
                c = a.i.fixDisappearingCharactersInChromeForAndroid && q.BrowserDetector.isOS("Android") && c.some(function(d) {
                    return d.getSourcePublication().getType() === r.PublicationType.EPUB;
                });
                Qb(a.o, !b || c);
            }
        }
        function Tb(a) {
            this.g = [];
            this.i = A(a, Ub());
        }
        f = Tb.prototype;
        f.createRuntime = function(a) {
            var b = a.getReaderDocuments().every(function(c) {
                return !c.isReflowable();
            });
            a = new Q(a, this.i, Vb(this, a.getReaderViewDimensions(), a.getConfiguredPageAspectRatio(), b, a.getPublicationPreferredAspectRatio()));
            this.g.push(a);
            return a;
        };
        f.destroyRuntime = function(a) {
            if (!(a instanceof Q)) throw new G("RUNTIME_INSTANCE_TYPE_MISMATCH", "Expected a FlipBookRendererRuntime");
            for(var b = 0; b < this.g.length; b++)if (this.g[b] === a) {
                this.g.splice(b, 1);
                break;
            }
            a.destroy();
        };
        f.getName = function() {
            return this.i.name;
        };
        f.getOptions = function() {
            return this.i;
        };
        f.getSpreadMode = function() {
            return w.RendererSpreadMode.TWO_PAGES;
        };
        f.getSupportedFlowModes = function() {
            return [
                r.ContentDocumentFlowMode.PAGINATED
            ];
        };
        f.getVisiblePagesArea = function(a, b, c, d) {
            a = Vb(this, a, b, d, c);
            return a.width * a.height;
        };
        f.isPublicationPreferredAspectRatioRequired = function(a) {
            return a.every(function(b) {
                return !b.isReflowable();
            });
        };
        f.setOptions = function(a) {
            a = A(a, this.i, !0);
            this.i = A(a, Ub());
            var b;
            null == (b = x(this.g)) || b.setOptions(this.i);
        };
        function Ub() {
            return Object.assign(Fb(), {
                fixDisappearingCharactersInChromeForAndroid: !1,
                hideEmptySpreadSlots: !0,
                pageBackgroundColor: "#ffffff",
                pageFoldShadowOpacity: .5,
                pageTurnShadowMaxOpacity: .2,
                perspectiveFactor: 2,
                rendererBackgroundShadowOpacity: .2,
                rubberBandElasticity: .65,
                showPageFoldShadow: !1,
                showPageTurnShadow: !0,
                showRendererBackgroundShadow: !0
            });
        }
        function Wb(a, b) {
            return a.width / a.height > b ? {
                height: a.height,
                width: a.height * b
            } : {
                height: a.width / b,
                width: a.width
            };
        }
        function Vb(a, b, c, d, e) {
            b = {
                height: b.height,
                width: Math.ceil(b.width / 2)
            };
            return d && void 0 !== e ? Xb(Wb(b, e)) : a.i.ignoreAspectRatio || "fill" === c ? Xb(b) : Xb(Wb(b, c));
        }
        function Xb(a) {
            return {
                height: a.height,
                width: 2 * a.width
            };
        }
        function Yb(a, b, c, d) {
            this.h = a;
            this.ha = c;
            this.ua = d;
            this.V = null;
            this.O = this.na = this.$ = this.I = 0;
            this.La = 32;
            this.i = A(b, {
                animationDurationMs: null,
                fa: {
                    height: this.h.clientHeight,
                    width: this.h.clientWidth
                },
                direction: q.Axis.X,
                disableAnimations: !1,
                goToAnimationDurationMs: null,
                minMarginBetweenPages: 24,
                pageBackgroundColor: "transparent",
                rubberBandElasticity: .65,
                showPageBackgroundShadow: !0,
                jb: !0
            });
            this.ja = this.i.direction === q.Axis.X;
            B(this.i.animationDurationMs) ? this.H = Math.round(this.i.animationDurationMs) : q.BrowserDetector.isPlatform("mobile") ? this.H = 300 : this.H = 390;
            B(this.i.goToAnimationDurationMs) ? this.S = Math.round(this.i.goToAnimationDurationMs) : q.BrowserDetector.isPlatform("mobile") ? this.S = 225 : this.S = 290;
            this.h.classList.add("colibrio-paged-view-single-page-swipe");
            this.i.disableAnimations || (this.h.style.transitionProperty = "opacity");
            this.D = this.R();
            this.J = this.R();
            this.L = this.R();
            this.h.appendChild(this.D);
            this.h.appendChild(this.J);
            this.h.appendChild(this.L);
        }
        function R(a, b) {
            b ? "visible" !== a.style.visibility && (a.style.visibility = "visible") : "hidden" !== a.style.visibility && (a.style.visibility = "hidden");
        }
        f = Yb.prototype;
        f.ra = function(a) {
            this.ha.renderTo(this.aa(a));
        };
        f.animate = function(a) {
            this.wa();
            if (this.i.disableAnimations) return Promise.resolve();
            var b = this.O ? "cubic-bezier(0.0, 0.0, 0.2, 1)" : "cubic-bezier(0.4, 0.0, 0.2, 1)";
            switch(a){
                case "RIGHT":
                    this.V = this.Aa(b);
                    break;
                case "LEFT":
                    this.V = this.Ba(b);
                    break;
                case "CURRENT":
                    this.V = this.Za(b);
            }
            return this.V.play().then(function() {}).catch(function(c) {
                return q.Logger.logWarning(new G("ANIMATION_FAILED", String(c)));
            });
        };
        f.Ra = function(a) {
            var b = this;
            if (this.i.disableAnimations || a) return this.h.style.transitionDuration = "0s", this.h.style.opacity = "1", Promise.resolve();
            this.h.style.transitionDuration = this.S + "ms";
            this.h.style.opacity = "1";
            return new Promise(function(c) {
                setTimeout(c, b.S + 16);
            });
        };
        f.Sa = function() {
            if (this.i.disableAnimations) return this.h.style.opacity = "0", Promise.resolve();
            this.V && this.V.pause();
            this.h.style.transitionDuration = "0s";
            this.h.style.opacity = "0";
            return Promise.resolve();
        };
        f.Ta = function(a, b) {
            var c = this.h.ownerDocument.createElement("div");
            c.classList.add("colibrio-paged-view-single-page-swipe__page-container");
            this.i.showPageBackgroundShadow && c.classList.add("colibrio-paged-view-single-page-swipe__page-container--background-shadow");
            a = a.getReaderDocument().isReflowable() ? this.i.fa : this.ua;
            c.style.width = a.width + "px";
            c.style.height = a.height + "px";
            b = this.aa(b);
            a = b.querySelectorAll(".colibrio-paged-view-single-page-swipe__page-container");
            for(var d = 0; d < a.length; d++)a[d].remove();
            b.insertBefore(c, b.firstChild);
            c.style.backgroundColor = this.i.pageBackgroundColor;
            return c;
        };
        f.destroy = function() {
            this.wa();
        };
        f.getContentDisplayAreaDimensions = function() {
            var a = this.h.ownerDocument.defaultView.getComputedStyle(this.h);
            return {
                height: Math.ceil(a.height ? parseFloat(a.height) : 0),
                width: Math.ceil(a.width ? parseFloat(a.width) : 0)
            };
        };
        f.xa = function() {
            var a = "CURRENT";
            this.O > this.La && 0 < this.I ? a = "LEFT" : this.O < -this.La && 0 > this.I && (a = "RIGHT");
            return a;
        };
        f.getElement = function() {
            return this.h;
        };
        f.getPublicationViewportBoundingRect = function(a) {
            var b = this.i.fa;
            if (0 === a.length) return new DOMRect(Math.round((this.h.clientWidth - b.width) / 2), Math.round((this.h.clientHeight - b.height) / 2), b.width, b.height);
            a = a[0].getPageDimensions();
            return new DOMRect(Math.round((this.h.clientWidth - a.width) / 2), Math.round((this.h.clientHeight - a.height) / 2), a.width, a.height);
        };
        f.getSpreadMode = function() {
            return w.RendererSpreadMode.SINGLE_PAGE;
        };
        f.Ca = function() {
            return z(-this.O / this.$, -1, 1);
        };
        f.init = function() {
            this.pa();
        };
        f.Ua = function() {
            return !0;
        };
        f.ya = function(a, b, c, d) {
            this.i.disableAnimations || (R(this.D, !0), R(this.J, !0), R(this.L, !0));
            this.O = this.Ya(this.ja ? -a : -b, c, d);
        };
        f.pa = function() {
            var a = 1;
            a = this.i.jb ? this.ja ? a + Math.ceil(window.innerWidth) : a + Math.ceil(window.innerHeight) : this.ja ? a + Math.ceil(this.h.offsetWidth) : a + Math.ceil(this.h.offsetHeight);
            var b = this.i.fa;
            b = this.ja ? a - b.width : a - b.height;
            b < this.i.minMarginBetweenPages && (a += Math.ceil(this.i.minMarginBetweenPages) - b);
            this.$ = a;
        };
        f.Wa = function(a) {
            a.h.remove();
        };
        f.da = function(a) {
            this.ha.removeFrom(this.aa(a));
        };
        f.Ma = function(a) {
            this.wa();
            this.I = this.na = this.O = 0;
            var b = this.D, c = this.J, d = this.L;
            if ("RIGHT" === a) c.style.visibility = "hidden", d.style.visibility = "visible", b.style.visibility = "hidden", this.h.insertBefore(b, null), this.D = c, this.J = d, this.L = b;
            else if ("LEFT" === a) c.style.visibility = "hidden", b.style.visibility = "visible", d.style.visibility = "hidden", this.h.insertBefore(d, b), this.D = d, this.J = b, this.L = c;
            else if ("GOTO" === a || "CURRENT" === a) b.style.visibility = "hidden", c.style.visibility = "visible", b.style.visibility = "hidden";
            D(this.D, this.F(-1, 0));
            D(this.J, this.F(0, 0));
            D(this.L, this.F(1, 0));
        };
        f.va = function(a, b, c, d, e) {
            a.N(b, [
                F(b, this.F(c, this.O)),
                F(b, this.F(d, 0))
            ], e);
        };
        f.Ya = function(a, b, c) {
            this.na || (this.na = a);
            a -= this.na;
            a = z(a, -this.$, this.$);
            this.I = .8 * this.I + .2 * (a - this.O);
            if (!this.i.disableAnimations) {
                if (0 < a && !b || 0 > a && !c) a = Math.pow(Math.abs(a), z(this.i.rubberBandElasticity, 0, 1)) * Math.sign(a);
                Zb(this, this.D, this.oa(-1, a));
                Zb(this, this.J, this.oa(0, a));
                Zb(this, this.L, this.oa(1, a));
            }
            return a;
        };
        f.N = function(a) {
            var b = {
                duration: Math.round(a.sa),
                easing: a.ta,
                fill: "both"
            }, c = this.D, d = this.J, e = this.L, g = new M;
            R(c, null !== a.Ja);
            R(d, null !== a.Ea);
            R(e, null !== a.Ha);
            null !== a.Ja && this.va(g, c, -1, a.Ja, b);
            null !== a.Ea && this.va(g, d, 0, a.Ea, b);
            null !== a.Ha && this.va(g, e, 1, a.Ha, b);
            return g;
        };
        f.Za = function(a) {
            return this.O ? this.N({
                Ea: 0,
                sa: C(Math.abs(this.O), this.$, this.H / 6, this.H),
                ta: a,
                Ha: 1,
                Ja: -1
            }) : new M;
        };
        f.Aa = function(a) {
            return this.N({
                Ea: -1,
                sa: C(Math.abs(this.O), this.$, this.H, this.H / 6),
                ta: a,
                Ha: 0,
                Ja: null
            });
        };
        f.Ba = function(a) {
            return this.N({
                Ea: 1,
                sa: C(Math.abs(this.O), this.$, this.H, this.H / 6),
                ta: a,
                Ha: null,
                Ja: 0
            });
        };
        f.R = function() {
            var a = this.h.ownerDocument.createElement("div");
            a.classList.add("colibrio-paged-view-single-page-swipe__layout");
            a.style.visibility = "hidden";
            a.style.width = this.h.clientWidth + "px";
            a.style.height = this.h.clientHeight + "px";
            return a;
        };
        f.wa = function() {
            this.V && (this.V.destroy(), this.V = null);
        };
        f.F = function(a, b) {
            a = this.oa(a, b) + "px";
            return this.ja ? {
                transform: {
                    x: a
                }
            } : {
                transform: {
                    y: a
                }
            };
        };
        f.aa = function(a) {
            switch(a){
                case -1:
                    return this.D;
                case 0:
                    return this.J;
                case 1:
                    return this.L;
            }
        };
        f.oa = function(a, b) {
            var c = -20;
            -1 <= a && 1 >= a && (c = a);
            return this.$ * c + b;
        };
        function Zb(a, b, c) {
            b.style.transform = a.ja ? "translate(" + c + "px, 0px)" : "translate(0px, " + c + "px)";
        }
        function S(a, b, c, d) {
            L.call(this, a, b, a.getReaderViewDimensions(), c, d);
        }
        m(S, L);
        S.prototype.getPublicationViewportBoundingRect = function(a) {
            return this.o.getPublicationViewportBoundingRect(a);
        };
        S.prototype.getSwipeNavigationAxis = function() {
            return this.i.direction;
        };
        S.prototype.B = function(a) {
            var b = this.i;
            return new Yb(a, {
                animationDurationMs: b.animationDurationMs,
                fa: this.u || void 0,
                direction: b.direction,
                disableAnimations: b.disableAnimations,
                goToAnimationDurationMs: b.goToAnimationDurationMs,
                minMarginBetweenPages: b.minMarginBetweenPages,
                rubberBandElasticity: b.rubberBandElasticity,
                showPageBackgroundShadow: b.showPageBackgroundShadow,
                jb: b.useWindowDimensionsForPageContainers
            }, this.j.getContentOnLoading(), this.ua);
        };
        function $b(a) {
            this.g = [];
            this.i = A(a, ac());
        }
        f = $b.prototype;
        f.createRuntime = function(a) {
            var b = a.getReaderDocuments().every(function(d) {
                return !d.isReflowable();
            }), c = a.getReaderViewDimensions();
            b = bc(this, c, a.getConfiguredPageAspectRatio(), b);
            a = new S(a, this.i, b, c);
            this.g.push(a);
            return a;
        };
        f.destroyRuntime = function(a) {
            if (!(a instanceof S)) throw new G("RUNTIME_INSTANCE_TYPE_MISMATCH", "Expected a SinglePageSwipeRendererRuntime");
            for(var b = 0; b < this.g.length; b++)if (this.g[b] === a) {
                this.g.splice(b, 1);
                break;
            }
            a.destroy();
        };
        f.getName = function() {
            return this.i.name;
        };
        f.getOptions = function() {
            return this.i;
        };
        f.getSpreadMode = function() {
            return w.RendererSpreadMode.SINGLE_PAGE;
        };
        f.getSupportedFlowModes = function() {
            return [
                r.ContentDocumentFlowMode.PAGINATED
            ];
        };
        f.getVisiblePagesArea = function(a, b, c, d) {
            a = bc(this, a, b, d);
            return a.width * a.height;
        };
        f.isPublicationPreferredAspectRatioRequired = function() {
            return !1;
        };
        f.setOptions = function(a) {
            a = A(a, this.i, !0);
            this.i = A(a, ac());
            var b;
            null == (b = x(this.g)) || b.setOptions(this.i);
        };
        function bc(a, b, c, d) {
            return d || a.i.ignoreAspectRatio || "fill" === c ? b : b.width / b.height > c ? {
                height: b.height,
                width: Math.round(b.height * c)
            } : {
                height: Math.round(b.width / c),
                width: b.width
            };
        }
        function ac() {
            var a = {
                direction: q.Axis.X,
                minMarginBetweenPages: 24,
                pageBackgroundColor: "transparent",
                rubberBandElasticity: .65,
                showPageBackgroundShadow: !1,
                useWindowDimensionsForPageContainers: !0
            };
            return Object.assign(Fb(), a);
        }
        function cc(a, b, c, d, e, g) {
            this.h = a;
            this.ha = c;
            this.T = d;
            this.fb = e;
            this.ua = g;
            this.V = null;
            this.O = this.na = this.$ = this.I = this.Oa = 0;
            this.La = 32;
            this.i = A(b, {
                animationDurationMs: null,
                fa: {
                    height: this.h.clientHeight,
                    width: Math.ceil(this.h.clientWidth / 2)
                },
                direction: q.Axis.X,
                disableAnimations: !1,
                goToAnimationDurationMs: null,
                minMarginBetweenSpreads: 24,
                pageBackgroundColor: "transparent",
                rubberBandElasticity: .65,
                useWindowDimensionsForPageContainers: !0
            });
            this.ja = this.i.direction === q.Axis.X;
            B(this.i.animationDurationMs) ? this.H = Math.round(this.i.animationDurationMs) : q.BrowserDetector.isPlatform("mobile") ? this.H = 300 : this.H = 390;
            B(this.i.goToAnimationDurationMs) ? this.S = Math.round(this.i.goToAnimationDurationMs) : q.BrowserDetector.isPlatform("mobile") ? this.S = 225 : this.S = 290;
            this.h.classList.add("colibrio-paged-view-spread-swipe");
            this.i.disableAnimations || (this.h.style.transitionProperty = "opacity");
            this.D = this.R();
            this.J = this.R();
            this.L = this.R();
            this.h.appendChild(this.D.h);
            this.h.appendChild(this.J.h);
            this.h.appendChild(this.L.h);
        }
        f = cc.prototype;
        f.ra = function(a, b) {
            2 === b ? q.Logger.logWarning("Attempted addLoader in SpreadPageSwipePageViewRenderer with SINGLE_PAGE spread slot") : (a = dc(this, a, b), a.style.visibility = "visible", this.ha.renderTo(a));
        };
        f.animate = function(a) {
            this.wa();
            if (this.i.disableAnimations) return Promise.resolve();
            var b = this.O ? "cubic-bezier(0.0, 0.0, 0.2, 1)" : "cubic-bezier(0.4, 0.0, 0.2, 1)";
            switch(a){
                case "RIGHT":
                    this.V = this.Aa(b);
                    break;
                case "LEFT":
                    this.V = this.Ba(b);
                    break;
                case "CURRENT":
                    this.V = this.Za(b);
            }
            return this.V.play().then(function() {}).catch(function(c) {
                return q.Logger.logWarning(new G("ANIMATION_FAILED", String(c)));
            });
        };
        f.Ra = function(a) {
            var b = this;
            if (this.i.disableAnimations || a) return this.h.style.transitionDuration = "0s", this.h.style.opacity = "1", Promise.resolve();
            this.h.style.transitionDuration = this.S + "ms";
            this.h.style.opacity = "1";
            return new Promise(function(c) {
                setTimeout(c, b.S + 16);
            });
        };
        f.Sa = function() {
            if (this.i.disableAnimations) return this.h.style.opacity = "0", Promise.resolve();
            this.V && this.V.pause();
            this.h.style.transitionDuration = "0s";
            this.h.style.opacity = "0";
            return Promise.resolve();
        };
        f.Ta = function(a, b) {
            b = this.aa(b);
            var c = !a.getReaderDocument().isReflowable();
            a = Ta(a.getSpreadSlot());
            var d = ec(this, a, c), e = 0 === a, g = this.h.ownerDocument.createElement("div");
            g.classList.add("colibrio-paged-view-spread-swipe__page-container");
            var h = {
                height: this.ua.height,
                width: Math.ceil(this.ua.width / 2)
            };
            h = c ? h : this.i.fa;
            g.style.width = h.width * (("fill" === this.fb || c) && e ? 2 : 1) + "px";
            g.style.height = h.height + "px";
            g.style.transform = "translate(" + d + "px, 0px)";
            if (e) for(c = b.h.querySelectorAll(".colibrio-paged-view-spread-swipe__page-container"), d = 0; d < c.length; d++)c[d].remove();
            c = b.ka.Ga;
            this.T === w.ReaderViewPageProgressionDirection.LTR && -1 === a ? c = b.h.firstChild : this.T === w.ReaderViewPageProgressionDirection.RTL && 1 === a && (c = b.h.firstChild);
            b.h.insertBefore(g, c);
            g.style.backgroundColor = this.i.pageBackgroundColor;
            return g;
        };
        f.destroy = function() {
            this.wa();
        };
        f.getContentDisplayAreaDimensions = function() {
            var a = this.h.ownerDocument.defaultView.getComputedStyle(this.h);
            return {
                height: Math.ceil(a.height ? parseFloat(a.height) : 0),
                width: Math.ceil((a.width ? parseFloat(a.width) : 0) / 2)
            };
        };
        f.xa = function() {
            var a = "CURRENT";
            this.O > this.La && 0 < this.I ? a = "LEFT" : this.O < -this.La && 0 > this.I && (a = "RIGHT");
            return a;
        };
        f.getElement = function() {
            return this.h;
        };
        f.getPublicationViewportBoundingRect = function(a) {
            var b = this.i.fa;
            if (0 === a.length) return new DOMRect(Math.round(this.h.clientWidth / 2 - b.width), Math.round((this.h.clientHeight - b.height) / 2), 2 * b.width, b.height);
            if (1 === a.length) {
                b = a[0];
                a = b.getPageDimensions();
                var c = Math.round((this.h.clientHeight - a.height) / 2);
                return b.getSpreadSlot() === r.PageSpreadSlot.CENTER ? new DOMRect(Math.round((this.h.clientWidth - a.width) / 2), c, a.width, a.height) : b.getSpreadSlot() === r.PageSpreadSlot.RIGHT ? new DOMRect(Math.round(this.h.clientWidth / 2), c, a.width, a.height) : new DOMRect(Math.round(this.h.clientWidth / 2 - a.width), c, a.width, a.height);
            }
            b = a[0].getPageDimensions();
            c = a[1].getPageDimensions();
            a = b.width + c.width;
            b = b.height > c.height ? b.height : c.height;
            return new DOMRect(Math.round((this.h.clientWidth - a) / 2), Math.round((this.h.clientHeight - b) / 2), a, b);
        };
        f.getSpreadMode = function() {
            return w.RendererSpreadMode.MIXED;
        };
        f.Ca = function() {
            return z(-this.O / this.$, -1, 1);
        };
        f.init = function() {
            this.pa();
        };
        f.Ua = function() {
            return !0;
        };
        f.ya = function(a, b, c, d) {
            this.i.disableAnimations || (T(this.D.h, !0), T(this.J.h, !0), T(this.L.h, !0));
            this.O = this.Ya(this.ja ? -a : -b, c, d);
        };
        f.pa = function() {
            var a = 1, b = this.ja;
            a = this.i.useWindowDimensionsForPageContainers ? b ? a + Math.ceil(window.innerWidth) : a + Math.ceil(window.innerHeight) : b ? a + Math.ceil(this.h.offsetWidth) : a + Math.ceil(this.h.offsetHeight);
            var c = this.i.fa;
            b = b ? a - 2 * c.width : a - c.height;
            b < this.i.minMarginBetweenSpreads && (a += Math.ceil(this.i.minMarginBetweenSpreads) - b);
            this.Oa = Math.ceil(this.h.offsetWidth / 2);
            b = ec(this, -1, !1);
            c = ec(this, 0, !1);
            for(var d = ec(this, 1, !1), e = k([
                this.D,
                this.J,
                this.L
            ]), g = e.next(); !g.done; g = e.next()){
                g = g.value;
                var h = this.i.fa;
                g.ka.Ga.style.width = h.width + "px";
                g.ka.Ga.style.transform = "translate(" + b + "px, 0px)";
                g.ka.Na.style.width = h.width + "px";
                g.ka.Na.style.transform = "translate(" + c + "px, 0px)";
                g.ka.Qa.style.width = h.width + "px";
                g.ka.Qa.style.transform = "translate(" + d + "px, 0px)";
            }
            this.$ = a;
        };
        f.Wa = function(a) {
            a.h.remove();
        };
        f.da = function(a, b) {
            2 === b ? q.Logger.logWarning("Attempted removeLoader in SpreadPageSwipePageViewRenderer with SINGLE_PAGE spread slot") : (a = dc(this, a, b), this.ha.removeFrom(a), a.style.visibility = "hidden");
        };
        f.Ma = function(a) {
            this.wa();
            this.I = this.na = this.O = 0;
            var b = this.D, c = this.J, d = this.L;
            if ("RIGHT" === a) c.h.style.visibility = "hidden", d.h.style.visibility = "visible", b.h.style.visibility = "hidden", this.h.insertBefore(b.h, null), this.D = c, this.J = d, this.L = b;
            else if ("LEFT" === a) c.h.style.visibility = "hidden", b.h.style.visibility = "visible", d.h.style.visibility = "hidden", this.h.insertBefore(d.h, b.h), this.D = d, this.J = b, this.L = c;
            else if ("GOTO" === a || "CURRENT" === a) b.h.style.visibility = "hidden", c.h.style.visibility = "visible", b.h.style.visibility = "hidden";
            D(this.D.h, this.F(-1, 0));
            D(this.J.h, this.F(0, 0));
            D(this.L.h, this.F(1, 0));
        };
        f.va = function(a, b, c, d, e) {
            a.N(b, [
                F(b, this.F(c, this.O)),
                F(b, this.F(d, 0))
            ], e);
        };
        f.Ya = function(a, b, c) {
            this.na || (this.na = a);
            a -= this.na;
            a = z(a, -this.$, this.$);
            this.I = .8 * this.I + .2 * (a - this.O);
            if (!this.i.disableAnimations) {
                if (0 < a && !b || 0 > a && !c) a = Math.pow(Math.abs(a), z(this.i.rubberBandElasticity, 0, 1)) * Math.sign(a);
                fc(this, this.D.h, this.oa(-1, a));
                fc(this, this.J.h, this.oa(0, a));
                fc(this, this.L.h, this.oa(1, a));
            }
            return a;
        };
        f.N = function(a) {
            var b = {
                duration: Math.round(a.sa),
                easing: a.ta,
                fill: "both"
            };
            T(this.D.h, null !== a.Ka);
            T(this.J.h, null !== a.Fa);
            T(this.L.h, null !== a.Ia);
            var c = new M;
            null !== a.Ka && this.va(c, this.D.h, -1, a.Ka, b);
            null !== a.Fa && this.va(c, this.J.h, 0, a.Fa, b);
            null !== a.Ia && this.va(c, this.L.h, 1, a.Ia, b);
            return c;
        };
        f.Za = function(a) {
            return this.O ? this.N({
                Fa: 0,
                sa: C(Math.abs(this.O), this.$, this.H / 6, this.H),
                ta: a,
                Ia: 1,
                Ka: -1
            }) : new M;
        };
        f.Aa = function(a) {
            return this.N({
                Fa: -1,
                sa: C(Math.abs(this.O), this.$, this.H, this.H / 6),
                ta: a,
                Ia: 0,
                Ka: null
            });
        };
        f.Ba = function(a) {
            return this.N({
                Fa: 1,
                sa: C(Math.abs(this.O), this.$, this.H, this.H / 6),
                ta: a,
                Ia: null,
                Ka: 0
            });
        };
        f.R = function() {
            var a = this.h.ownerDocument.createElement("div");
            a.classList.add("colibrio-paged-view-spread-swipe__layout");
            a.style.visibility = "hidden";
            a.style.width = this.h.clientWidth + "px";
            a.style.height = this.h.clientHeight + "px";
            var b = {
                Na: gc(this, 0),
                Ga: gc(this, -1),
                Qa: gc(this, 1)
            };
            a.appendChild(b.Ga);
            a.appendChild(b.Na);
            a.appendChild(b.Qa);
            return {
                h: a,
                ka: b
            };
        };
        function gc(a, b) {
            var c = document.createElement("div");
            b = ec(a, b, !1);
            c.style.position = "absolute";
            c.style.pointerEvents = "none";
            c.style.overflow = "hidden";
            c.style.height = "100%";
            c.style.transform = "translate(" + b + "px, 0px)";
            c.style.width = a.i.fa.width + "px";
            return c;
        }
        f.wa = function() {
            this.V && (this.V.destroy(), this.V = null);
        };
        f.F = function(a, b) {
            a = this.oa(a, b) + "px";
            return this.ja ? {
                transform: {
                    x: a
                }
            } : {
                transform: {
                    x: "0px",
                    y: a
                }
            };
        };
        f.aa = function(a) {
            switch(a){
                case -1:
                    return this.D;
                case 0:
                    return this.J;
                case 1:
                    return this.L;
            }
        };
        function dc(a, b, c) {
            a = a.aa(b);
            switch(c){
                case -1:
                    return a.ka.Ga;
                case 0:
                    return a.ka.Na;
                case 1:
                    return a.ka.Qa;
            }
        }
        function ec(a, b, c) {
            var d = a.i.fa, e = 0;
            -1 === b ? e = c ? 0 : a.Oa - d.width : 1 === b ? e = a.Oa : 0 === b && (b = a.Oa - d.width / 2, e = "fill" === a.fb || c ? 0 : b);
            return e;
        }
        f.oa = function(a, b) {
            var c = -20;
            -1 <= a && 1 >= a && (c = a);
            return this.$ * c + b;
        };
        function T(a, b) {
            b ? "visible" !== a.style.visibility && (a.style.visibility = "visible") : "hidden" !== a.style.visibility && (a.style.visibility = "hidden");
        }
        function fc(a, b, c) {
            b.style.transform = a.ja ? "translate(" + c + "px, 0px)" : "translate(0px, " + c + "px)";
        }
        function U(a, b, c, d) {
            L.call(this, a, b, a.getReaderViewDimensions(), c, d);
        }
        m(U, L);
        U.prototype.getPublicationViewportBoundingRect = function(a) {
            return this.o.getPublicationViewportBoundingRect(a);
        };
        U.prototype.getSwipeNavigationAxis = function() {
            return this.i.direction;
        };
        U.prototype.B = function(a) {
            var b = this.i;
            return new cc(a, {
                animationDurationMs: b.animationDurationMs,
                fa: this.u || void 0,
                direction: b.direction,
                disableAnimations: b.disableAnimations,
                goToAnimationDurationMs: b.goToAnimationDurationMs,
                minMarginBetweenSpreads: b.minMarginBetweenSpreads,
                rubberBandElasticity: b.rubberBandElasticity,
                useWindowDimensionsForPageContainers: b.useWindowDimensionsForPageContainers
            }, this.j.getContentOnLoading(), this.j.getPageProgressionDirection(), this.j.getConfiguredPageAspectRatio(), this.ua);
        };
        function hc(a) {
            this.g = [];
            this.i = A(a, ic());
        }
        f = hc.prototype;
        f.createRuntime = function(a) {
            var b = a.getReaderDocuments().every(function(d) {
                return !d.isReflowable();
            }), c = a.getReaderViewDimensions();
            c = {
                height: c.height,
                width: Math.ceil(c.width / 2)
            };
            b = jc(this, c, a.getConfiguredPageAspectRatio(), b);
            a = new U(a, this.i, b, c);
            this.g.push(a);
            return a;
        };
        f.destroyRuntime = function(a) {
            if (!(a instanceof U)) throw new G("RUNTIME_INSTANCE_TYPE_MISMATCH", "Expected a SpreadSwipeRendererRuntime");
            for(var b = 0; b < this.g.length; b++)if (this.g[b] === a) {
                this.g.splice(b, 1);
                break;
            }
            a.destroy();
        };
        f.getName = function() {
            return this.i.name;
        };
        f.getOptions = function() {
            return this.i;
        };
        f.getSpreadMode = function() {
            return this.i.enablePageSpreadCenterSupport ? w.RendererSpreadMode.MIXED : w.RendererSpreadMode.TWO_PAGES;
        };
        f.getSupportedFlowModes = function() {
            return [
                r.ContentDocumentFlowMode.PAGINATED
            ];
        };
        f.getVisiblePagesArea = function(a, b, c, d) {
            a = jc(this, {
                height: a.height,
                width: Math.ceil(a.width / 2)
            }, b, d);
            return a.width * a.height;
        };
        f.isPublicationPreferredAspectRatioRequired = function() {
            return !1;
        };
        f.setOptions = function(a) {
            a = A(a, this.i, !0);
            this.i = A(a, ic());
            var b;
            null == (b = x(this.g)) || b.setOptions(this.i);
        };
        function jc(a, b, c, d) {
            return a.i.ignoreAspectRatio || d || "fill" === c ? b : b.width / b.height > c ? {
                height: b.height,
                width: Math.round(b.height * c)
            } : {
                height: Math.round(b.width / c),
                width: b.width
            };
        }
        function ic() {
            var a = {
                direction: q.Axis.X,
                enablePageSpreadCenterSupport: !0,
                minMarginBetweenSpreads: 24,
                pageBackgroundColor: "transparent",
                rubberBandElasticity: .65,
                useWindowDimensionsForPageContainers: !0
            };
            return Object.assign(Fb(), a);
        }
        function kc(a, b, c) {
            this.h = a;
            this.i = b;
            this.ha = c;
            this.j = this.g = null;
            this.C = this.B = this.I = this.o = 0;
            this.u = null;
            this.v = this.G = 1;
            this.m = this.l = null;
            B(this.i.animationDurationMs) ? this.H = this.i.animationDurationMs : q.BrowserDetector.isPlatform("mobile") ? this.H = 375 : this.H = 490;
            B(this.i.goToAnimationDurationMs) ? this.S = this.i.goToAnimationDurationMs : q.BrowserDetector.isPlatform("mobile") ? this.S = 225 : q.BrowserDetector.isPlatform("tablet") ? this.S = 290 : this.S = 160;
            q.BrowserDetector.isBrowser("Firefox") && (this.i.showPageTurnShadow = !1);
            this.h.classList.add("colibrio-paged-view-stack");
            this.i.disableAnimations || (this.h.style.transitionProperty = "opacity");
            this.i.showRendererBackgroundShadow && (this.h.style.boxShadow = "0px 5px 20px rgba(0, 0, 0, " + this.i.rendererBackgroundShadowOpacity + ")");
            this.P = Eb("cubic-bezier(0.25, 0.46, 0.45, 0.94)");
            this.M = Eb("cubic-bezier(0.455, 0.03, 0.515, 0.955)");
            this.D = this.R(!0);
            this.J = this.R(!0);
            this.L = this.R(!0);
            this.h.appendChild(this.D);
            this.h.appendChild(this.J);
            this.h.appendChild(this.L);
        }
        f = kc.prototype;
        f.ra = function(a) {
            this.ha.renderTo(this.aa(a));
        };
        f.animate = function(a) {
            var b;
            if (this.i.disableAnimations) return Promise.resolve();
            switch(a){
                case "RIGHT":
                    this.g || (this.g = this.Aa("cubic-bezier(0.455, 0.03, 0.515, 0.955)"));
                    this.g && (b = this.g.play());
                    break;
                case "LEFT":
                    this.j || (this.j = this.Ba("cubic-bezier(0.455, 0.03, 0.515, 0.955)"));
                    this.j && (b = this.j.play());
                    break;
                case "CURRENT":
                    this.j ? (Hb(this.j), b = this.j.play()) : this.g && (Hb(this.g), b = this.g.play());
            }
            return b ? b.then(function() {}).catch(function(c) {
                return q.Logger.logWarning(new G("ANIMATION_FAILED", String(c)));
            }) : Promise.resolve();
        };
        f.Ra = function(a) {
            var b = this;
            if (this.i.disableAnimations || a) return this.h.style.transitionDuration = "0s", this.h.style.opacity = "1", Promise.resolve();
            this.h.style.transitionDuration = this.S + "ms";
            this.h.style.opacity = "1";
            return new Promise(function(c) {
                setTimeout(c, b.S + 16);
            });
        };
        f.Sa = function() {
            if (this.i.disableAnimations) return this.h.style.opacity = "0", Promise.resolve();
            this.h.style.transitionDuration = "0s";
            this.h.style.opacity = "0";
            return Promise.resolve();
        };
        f.Ta = function(a, b) {
            a = this.h.ownerDocument.createElement("div");
            a.classList.add("colibrio-paged-view-stack__page-container");
            var c = this.getContentDisplayAreaDimensions();
            a.style.width = c.width + "px";
            a.style.height = c.height + "px";
            b = this.aa(b);
            c = b.querySelectorAll(".colibrio-paged-view-stack__page-container");
            for(var d = 0; d < c.length; d++)c[d].remove();
            b.insertBefore(a, b.firstChild);
            return a;
        };
        f.destroy = function() {
            lc(this);
        };
        f.getContentDisplayAreaDimensions = function() {
            var a = this.h.ownerDocument.defaultView.getComputedStyle(this.h);
            return {
                height: Math.ceil(a.height ? parseFloat(a.height) : 0),
                width: Math.ceil(a.width ? parseFloat(a.width) : 0)
            };
        };
        f.xa = function() {
            var a = "CURRENT";
            .15 < this.o && 0 < this.I ? a = "RIGHT" : -0.15 > this.o && 0 > this.I && (a = "LEFT");
            return a;
        };
        f.getElement = function() {
            return this.h;
        };
        f.getSpreadMode = function() {
            return w.RendererSpreadMode.SINGLE_PAGE;
        };
        f.Ca = function() {
            var a = this.o;
            return 0 < a ? this.M(a) : this.P(a);
        };
        f.init = function() {
            this.pa();
            this.i.showPageTurnShadow && !this.i.disable3dPerspective && (this.m = this.R(!1), this.m.style.opacity = "0", this.m.style.zIndex = "11", this.m.style.visibility = "visible", this.m.style.width = "", this.m.style.height = "", this.m.classList.add("colibrio-paged-view-stack__shadow"), this.h.appendChild(this.m), this.l = this.R(!1), this.l.style.opacity = "0", this.l.style.zIndex = "6", this.l.style.width = "", this.l.style.height = "", this.l.style.visibility = "visible", this.l.classList.add("colibrio-paged-view-stack__shadow"), this.h.appendChild(this.l), "x" === this.i.Da ? (this.m.classList.add("colibrio-paged-view-stack__shadow--x"), this.l.classList.add("colibrio-paged-view-stack__shadow--x")) : (this.m.classList.add("colibrio-paged-view-stack__shadow--y"), this.l.classList.add("colibrio-paged-view-stack__shadow--y")));
        };
        f.Ua = function() {
            return !1;
        };
        f.$a = function(a, b, c) {
            c && (this.u = this.aa(a), this.u.style.visibility = "hidden");
        };
        f.ya = function(a, b, c, d) {
            if ("x" === this.i.Da) {
                this.I = .75 * this.I + .25 * (a - this.B);
                this.B = a;
                var e = .8 * this.v;
                a = -10 > a ? Math.min(0, a + 10) : 10 < a ? Math.max(0, a - 10) : 0;
            } else this.I = .75 * this.I + .25 * (b - this.C), this.C = b, e = .8 * this.G, a = -10 > b ? Math.min(0, b + 10) : 10 < b ? Math.max(0, b - 10) : 0;
            b = !1;
            0 > a ? b = !c : 0 < a && (b = !d);
            b && 0 !== a && (a = Math.pow(Math.abs(a), z(this.i.rubberBandElasticity, 0, 1)) * Math.sign(a));
            this.o = z(a / e, -0.99, .99);
            this.i.disableAnimations || (0 > this.o ? (this.g && (this.g.destroy(), this.g = null), this.j || (this.j = this.Ba("cubic-bezier(0.25, 0.46, 0.45, 0.94)")), this.j && Ib(this.j, -this.o * this.H)) : 0 < this.o && (this.j && (this.j.destroy(), this.j = null), this.g || (this.g = this.Aa("cubic-bezier(0.455, 0.03, 0.515, 0.955)")), this.g && Ib(this.g, this.o * this.H)));
        };
        f.pa = function() {
            this.v = this.h.offsetWidth;
            this.G = this.h.offsetHeight;
            if (!this.i.disable3dPerspective) {
                var a = this.h.style;
                "perspective" in a ? a.perspective = this.v * this.i.perspectiveFactor + "px" : "webkitPerspective" in a && (a.webkitPerspective = this.v * this.i.perspectiveFactor + "px");
            }
        };
        f.Wa = function(a) {
            a.h.remove();
        };
        f.da = function(a) {
            this.ha.removeFrom(this.aa(a));
        };
        function mc(a, b) {
            a.i.disable3dPerspective || (b ? a.pa() : (a = a.h.style, "perspective" in a ? a.perspective = "" : "webkitPerspective" in a && (a.webkitPerspective = "")));
        }
        f.Ma = function(a) {
            lc(this);
            this.u && ("RIGHT" === a && this.u === this.D || "GOTO" === a) && (this.u.style.visibility = "visible", this.u = null);
            var b = this.D, c = this.J, d = this.L;
            if ("RIGHT" === a) c.style.visibility = "hidden", d.style.visibility = "visible", b.style.visibility = "hidden", this.h.insertBefore(b, null), this.D = c, this.J = d, this.L = b;
            else if ("LEFT" === a) c.style.visibility = "hidden", b.style.visibility = "visible", d.style.visibility = "hidden", this.h.insertBefore(d, b), this.D = d, this.J = b, this.L = c;
            else if ("GOTO" === a || "CURRENT" === a) b.style.visibility = "hidden", c.style.visibility = "visible", b.style.visibility = "hidden";
            this.i.showPageTurnShadow && !this.i.disable3dPerspective && (a = "x" === this.i.Da ? {
                opacity: "0",
                transform: {
                    x: "-80%"
                }
            } : {
                opacity: "0",
                transform: {
                    y: "-80%"
                }
            }, b = {
                opacity: "" + this.i.pageTurnShadowMaxOpacity
            }, this.m && D(this.m, a), this.l && D(this.l, b));
            D(this.D, this.F(-1, void 0, !0));
            D(this.J, this.F(0, void 0, !0));
            D(this.L, this.F(1, void 0, !0));
        };
        f.Aa = function(a) {
            var b = {
                duration: this.H,
                easing: a,
                fill: "both"
            };
            this.L.style.visibility = "visible";
            a = new M;
            a.N(this.J, [
                F(this.J, this.F(0)),
                {
                    offset: .6,
                    opacity: 1
                },
                F(this.J, this.F(-1))
            ], b);
            if (this.l) {
                if ("x" === this.i.Da) {
                    var c = {
                        opacity: "" + this.i.pageTurnShadowMaxOpacity,
                        transform: {
                            x: "0%",
                            z: "0px"
                        }
                    };
                    var d = {
                        opacity: "0",
                        transform: {
                            x: "-80%",
                            z: "0px"
                        }
                    };
                } else c = {
                    opacity: "" + this.i.pageTurnShadowMaxOpacity,
                    transform: {
                        y: "0%",
                        z: "0px"
                    }
                }, d = {
                    opacity: "0",
                    transform: {
                        y: "-80%",
                        z: "0px"
                    }
                };
                a.N(this.l, [
                    F(this.l, c),
                    {
                        offset: .7,
                        opacity: 0
                    },
                    F(this.l, d)
                ], b);
            }
            return a;
        };
        f.Ba = function(a) {
            var b = null;
            a = {
                duration: this.H,
                easing: a,
                fill: "both"
            };
            if (this.u !== this.D && (this.D.style.visibility = "visible", b = new M, b.N(this.D, [
                F(this.D, this.F(-1)),
                {
                    offset: .4,
                    opacity: 1
                },
                F(this.D, this.F(0))
            ], a), this.m)) {
                if ("x" === this.i.Da) {
                    var c = {
                        opacity: "0",
                        transform: {
                            x: "-80%",
                            z: "0px"
                        }
                    };
                    var d = {
                        opacity: "" + this.i.pageTurnShadowMaxOpacity,
                        transform: {
                            x: "0%",
                            z: "0px"
                        }
                    };
                } else c = {
                    opacity: "0",
                    transform: {
                        y: "-80%",
                        z: "0px"
                    }
                }, d = {
                    opacity: "" + this.i.pageTurnShadowMaxOpacity,
                    transform: {
                        y: "0%",
                        z: "0px"
                    }
                };
                b.N(this.m, [
                    F(this.m, c),
                    {
                        offset: .3,
                        opacity: 0
                    },
                    F(this.m, d)
                ], a);
            }
            return b;
        };
        f.R = function(a) {
            var b = this.h.ownerDocument.createElement("div");
            b.classList.add("colibrio-paged-view-stack__layout");
            var c = this.getContentDisplayAreaDimensions();
            b.style.width = c.width + "px";
            b.style.height = c.height + "px";
            a && (b.style.backgroundColor = this.i.pageBackgroundColor);
            return b;
        };
        function lc(a) {
            a.g && (a.g.destroy(), a.g = null);
            a.j && (a.j.destroy(), a.j = null);
        }
        f.F = function(a, b, c) {
            var d = "x" === this.i.Da, e = this.i.disable3dPerspective;
            switch(a){
                case -1:
                    a = A(b, {
                        opacity: "0"
                    });
                    d ? (a.transformOrigin = "100% 0%", e || c ? a.transform = {
                        x: "-100%"
                    } : a.transform = {
                        rotationY: "10deg",
                        x: "-100%",
                        z: this.v / 6 + "px"
                    }) : (a.transformOrigin = "0% 0%", e || c ? a.transform = {
                        y: "-100%"
                    } : a.transform = {
                        rotationX: "10deg",
                        y: "-100%",
                        z: this.v / 6 + "px"
                    });
                    c && (a.zIndex = "15");
                    break;
                case 0:
                    a = A(b, {
                        opacity: "1"
                    });
                    d ? (e || c ? a.transform = {
                        x: "0%"
                    } : a.transform = {
                        rotationY: "0deg",
                        x: "0%",
                        z: "0px"
                    }, a.transformOrigin = "100% 0%") : (e || c ? a.transform = {
                        y: "0%"
                    } : a.transform = {
                        rotationX: "0deg",
                        y: "0%",
                        z: "0px"
                    }, a.transformOrigin = "0% 0%");
                    c && (a.zIndex = "10", a.transform = {
                        x: "0",
                        y: "0"
                    });
                    break;
                case 1:
                    a = A(b, {
                        opacity: "1"
                    });
                    d ? (e || c ? a.transform = {
                        x: "0%"
                    } : a.transform = {
                        rotationY: "0deg",
                        x: "0%",
                        z: "0px"
                    }, a.transformOrigin = "100% 0%") : (e || c ? a.transform = {
                        y: "0%"
                    } : a.transform = {
                        rotationX: "0deg",
                        y: "0%",
                        z: "0px"
                    }, a.transformOrigin = "0% 0%");
                    c && (a.zIndex = "5");
                    break;
                default:
                    a = A(b, {}), d ? (e || c ? a.transform = {
                        x: "-2000%"
                    } : a.transform = {
                        rotationY: "0deg",
                        x: "-2000%",
                        z: "0px"
                    }, a.transformOrigin = "100% 0%") : (e || c ? a.transform = {
                        y: "-2000%"
                    } : a.transform = {
                        rotationX: "0px",
                        y: "-2000%",
                        z: "0px"
                    }, a.transformOrigin = "0% 0%"), c && (a.zIndex = "1", a.opacity = "1");
            }
            return a;
        };
        f.aa = function(a) {
            switch(a){
                case -1:
                    return this.D;
                case 0:
                    return this.J;
                case 1:
                    return this.L;
            }
        };
        function X(a, b, c) {
            L.call(this, a, b, c, null, null);
            this.C = !1;
        }
        m(X, L);
        X.prototype.applyTransform = function(a) {
            L.prototype.applyTransform.call(this, a);
            nc(this, null !== a && 1 < a.scale);
        };
        X.prototype.destroy = function() {
            L.prototype.destroy.call(this);
        };
        X.prototype.setOptions = function(a) {
            L.prototype.setOptions.call(this, a);
        };
        X.prototype.B = function(a) {
            var b = this.i;
            return new kc(a, {
                animationDurationMs: b.animationDurationMs,
                disable3dPerspective: b.disable3dPerspective,
                disableAnimations: b.disableAnimations,
                goToAnimationDurationMs: b.goToAnimationDurationMs,
                pageBackgroundColor: b.pageBackgroundColor,
                pageTurnShadowMaxOpacity: b.pageTurnShadowMaxOpacity,
                perspectiveFactor: b.perspectiveFactor,
                rendererBackgroundShadowOpacity: b.rendererBackgroundShadowOpacity,
                rubberBandElasticity: b.rubberBandElasticity,
                showPageTurnShadow: b.showPageTurnShadow,
                showRendererBackgroundShadow: b.showRendererBackgroundShadow,
                Da: "x"
            }, this.j.getContentOnLoading());
        };
        function nc(a, b) {
            if (a.C !== b) {
                a.C = b;
                var c = a.j.getReaderPublications();
                c = a.i.fixDisappearingCharactersInChromeForAndroid && q.BrowserDetector.isOS("Android") && c.some(function(d) {
                    return d.getSourcePublication().getType() === r.PublicationType.EPUB;
                });
                mc(a.o, !b || c);
            }
        }
        function oc(a) {
            this.g = [];
            this.i = A(a, pc());
        }
        f = oc.prototype;
        f.createRuntime = function(a) {
            var b = a.getReaderDocuments().every(function(c) {
                return !c.isReflowable();
            });
            a = new X(a, this.i, qc(this, a.getReaderViewDimensions(), a.getConfiguredPageAspectRatio(), b, a.getPublicationPreferredAspectRatio()));
            this.g.push(a);
            return a;
        };
        f.destroyRuntime = function(a) {
            if (!(a instanceof X)) throw new G("RUNTIME_INSTANCE_TYPE_MISMATCH", "Expected a StackRendererRuntime");
            for(var b = 0; b < this.g.length; b++)if (this.g[b] === a) {
                this.g.splice(b, 1);
                break;
            }
            a.destroy();
        };
        f.getName = function() {
            return this.i.name;
        };
        f.getOptions = function() {
            return this.i;
        };
        f.getSpreadMode = function() {
            return w.RendererSpreadMode.SINGLE_PAGE;
        };
        f.getSupportedFlowModes = function() {
            return [
                r.ContentDocumentFlowMode.PAGINATED
            ];
        };
        f.getVisiblePagesArea = function(a, b, c, d) {
            a = qc(this, a, b, d, c);
            return a.width * a.height;
        };
        f.isPublicationPreferredAspectRatioRequired = function(a) {
            return a.every(function(b) {
                return !b.isReflowable();
            });
        };
        f.setOptions = function(a) {
            a = A(a, this.i, !0);
            this.i = A(a, pc());
            var b;
            null == (b = x(this.g)) || b.setOptions(this.i);
        };
        function rc(a, b) {
            return a.width / a.height > b ? {
                height: a.height,
                width: a.height * b
            } : {
                height: a.width / b,
                width: a.width
            };
        }
        function pc() {
            return Object.assign(Fb(), {
                disable3dPerspective: !1,
                fixDisappearingCharactersInChromeForAndroid: !1,
                pageBackgroundColor: "#ffffff",
                pageTurnShadowMaxOpacity: .5,
                perspectiveFactor: 2,
                rendererBackgroundShadowOpacity: .2,
                rubberBandElasticity: .65,
                showPageTurnShadow: !0,
                showRendererBackgroundShadow: !0
            });
        }
        function qc(a, b, c, d, e) {
            return d && e ? rc(b, e) : a.i.ignoreAspectRatio || "fill" === c ? b : rc(b, c);
        }
        function sc(a, b, c, d) {
            d = z(d, 0, a);
            var e = c.cb;
            c = c.bb;
            e > d && (e = d);
            d += b;
            c > a - d && (c = a - d);
            c = Math.min(c, b);
            return {
                hb: c,
                eb: e
            };
        }
        function tc(a, b, c, d, e) {
            this.g = a;
            this.l = b;
            this.v = c;
            this.j = d;
            this.u = e;
            a = sc(this.g.scrollHeight, this.g.clientHeight, this.u, this.g.scrollTop);
            this.o = this.g.scrollTop + a.eb;
            this.m = this.g.clientHeight - a.eb - a.hb;
        }
        function uc(a) {
            return Promise.all([
                vc(a),
                Y(a, a.j, a.g.scrollTop, !1, !1),
                Y(a, a.j, a.g.scrollTop, !0, !0)
            ]).then(function(b) {
                var c = b[0], d = c.previous, e = c.visible;
                c = c.next;
                var g = b[1];
                b = b[2];
                var h = a.getVisiblePages();
                return {
                    next: c,
                    previous: d,
                    ib: e,
                    ob: b,
                    visible: g,
                    visiblePages: h
                };
            });
        }
        function vc(a) {
            var b = a.l[a.j];
            if (!b) return Promise.resolve({
                next: null,
                previous: null,
                visible: null
            });
            var c = a.o - a.m, d = a.o, e = a.o + a.m, g = e + a.m;
            return b.getReaderDocument().getSourceContentDocument().getLayout() === r.ContentDocumentLayout.PRE_PAGINATED ? (c = wc(a), b = Promise.resolve(b.getRangeContentLocation()), d = Y(a, a.j + 1, 0, !0, !1), Promise.all([
                c,
                b,
                d
            ]).then(function(h) {
                return {
                    next: h[2],
                    previous: h[0],
                    visible: h[1]
                };
            })) : b.fetchContentRangesByTopOffsets([
                c,
                d,
                e,
                g
            ]).then(function(h) {
                if (!h.visible) return {
                    next: null,
                    previous: null,
                    visible: null
                };
                var l = h.previous ? Promise.resolve(h.previous) : wc(a);
                var p = h.next ? Promise.resolve(h.next) : Y(a, a.j + 1, 0, !0, !1);
                return Promise.all([
                    l,
                    p
                ]).then(function(u) {
                    return {
                        next: u[1],
                        previous: u[0],
                        visible: h.visible
                    };
                });
            });
        }
        function wc(a) {
            var b = a.v[a.j - 1];
            return b ? Y(a, a.j - 1, b.scrollHeight - a.g.clientHeight, !0, !1) : Promise.resolve(null);
        }
        function Y(a, b, c, d, e) {
            var g = a.v[b];
            b = a.l[b];
            if (!b || !g) return Promise.resolve(null);
            if (b.getReaderDocument().getSourceContentDocument().getLayout() === r.ContentDocumentLayout.PRE_PAGINATED) return Promise.resolve(b.getRangeContentLocation());
            var h = 0, l = 0;
            d && (d = sc(g.scrollHeight, a.g.clientHeight, a.u, c), h = d.eb, l = d.hb);
            d = z(c + h, 0, g.scrollHeight);
            return e ? b.fetchContentLocationByTopOffset(d, !1, !1) : b.fetchContentRangeByTopOffsets(d, z(c + a.g.clientHeight - l, 0, g.scrollHeight));
        }
        tc.prototype.getVisiblePages = function() {
            var a = this.l[this.j];
            return "undefined" === typeof a ? [] : [
                a
            ];
        };
        function xc(a, b) {
            this.l = a;
            this.m = b;
            this.j = this.I = this.g = 0;
        }
        xc.prototype.handlePointerEngineEvent = function(a, b, c, d) {
            return yc(this, a, b, c, d);
        };
        xc.prototype.handlePointerEngineEventV2 = function(a, b, c, d) {
            if (b = yc(this, a, b, c, d, !0)) {
                c = z(this.g, -1, 1);
                if ("pointerup" === a.type || "pointercancel" === a.type) this.g = 0;
                return {
                    pendingNavigationAction: b,
                    swipeProgress: c
                };
            }
            return null;
        };
        function zc(a, b, c, d) {
            var e = null, g = Math.abs(b);
            g > Math.abs(c) && g > .15 * a.l && (0 > b && 0 > a.I ? a.m ? d.nextRenderablePage && (e = w.NavigationAction.NEXT_RENDERABLE_PAGE) : d.previousRenderablePage && (e = w.NavigationAction.PREVIOUS_RENDERABLE_PAGE) : 0 < b && 0 < a.I && (a.m ? d.previousRenderablePage && (e = w.NavigationAction.PREVIOUS_RENDERABLE_PAGE) : d.nextRenderablePage && (e = w.NavigationAction.NEXT_RENDERABLE_PAGE)));
            return e;
        }
        function yc(a, b, c, d, e, g) {
            if (!e) return null;
            var h = c - a.j;
            a.j = c;
            a.I = .75 * a.I + .25 * h;
            var l = null;
            "pointerup" === b.type ? (l = zc(a, c, d, e), a.I = 0, a.j = 0) : "pointercancel" === b.type ? (a.I = 0, a.j = 0) : "pointermove" === b.type && (void 0 === g ? 0 : g) && (l = zc(a, c, d, e), a.g += -h / a.l);
            return l;
        }
        function Ac(a, b, c) {
            var d = this;
            this.g = a;
            this.B = b;
            this.u = c;
            this.m = !1;
            this.l = this.o = 0;
            this.j = null;
            this.v = function() {
                d.m || (d.j ? window.clearTimeout(d.j) : d.B(), d.j = window.setTimeout(function() {
                    if (!d.m) {
                        d.j = null;
                        var e = d.g.scrollTop;
                        var g = 3 > Math.abs(e - d.l) ? !1 : !0;
                        d.l = e;
                        d.u({
                            scrollDistance: d.l - d.o,
                            scrollTop: d.g.scrollTop,
                            userGenerated: g
                        });
                        d.o = d.l;
                    }
                }, 200));
            };
        }
        function Bc(a) {
            a.o = 0;
            a.j && (window.clearTimeout(a.j), a.j = null, a.u(null));
        }
        Ac.prototype.destroy = function() {
            this.j && window.clearTimeout(this.j);
            this.m = !0;
        };
        Ac.prototype.isScrolling = function() {
            return null !== this.j;
        };
        function Z(a, b) {
            a.m || (a.l = z(b, 0, a.g.scrollHeight), b > a.g.scrollHeight - a.g.clientHeight && (a.l = a.g.scrollHeight - a.g.clientHeight), 3 > Math.abs(a.g.scrollTop - a.l) ? Promise.resolve().then(a.v).catch(function(c) {
                q.ColibrioError.isColibrioAbortedError(c) || q.Logger.logError(c);
            }) : (a.isScrolling() || (a.o = a.g.scrollTop), a.g.scrollTop = a.l));
        }
        function Cc(a, b, c) {
            var d = .05 * b;
            return {
                ab: a - b + c.bb + d,
                Va: a - c.cb - d
            };
        }
        function Dc(a, b, c, d) {
            var e = this;
            this.o = a;
            this.i = b;
            this.G = c;
            this.j = null;
            this.W = this.P = !1;
            this.ba = this.M = null;
            this.v = [];
            this.B = new Set;
            this.Z = null;
            this.l = -1;
            this.U = 0;
            this.ga = function() {
                e.u.v();
            };
            this.Xa = function(l) {
                e.o.notifyScrollEnded(l);
                e.U++;
                l && Ec(e);
            };
            this.kb = function() {
                e.o.notifyScrollStarted();
            };
            var g = a.getReaderViewElement();
            this.C = a.getReaderDocuments();
            this.m = Array(this.C.length);
            c = g.ownerDocument;
            var h = a.getReaderViewDimensions();
            this.g = Ea(c, [
                {
                    name: "class",
                    value: "colibrio-renderer-scrolled-document"
                },
                {
                    name: "tabindex",
                    value: "0"
                }
            ]);
            a = "DOCUMENT" === b.scrollbarPosition ? d.width : a.getReaderViewDimensions().width;
            this.g.style.width = a + "px";
            this.g.style.height = d.height + "px";
            g.appendChild(this.g);
            this.g.style.overflowY = "scroll";
            b = this.g.clientWidth;
            this.g.style.overflowY = "";
            this.ca = {
                height: d.height,
                width: Math.min(b, d.width)
            };
            this.za = new xc(d.width, this.o.getPageProgressionDirection() === w.ReaderViewPageProgressionDirection.LTR);
            this.g.style.top = Math.floor((h.height - d.height) / 2) + "px";
            this.g.style.left = Math.floor((h.width - a) / 2) + "px";
            for(d = 0; d < this.C.length; d++)h = Fc(this, c), this.v.push(h);
            this.u = new Ac(this.g, this.kb, this.Xa);
            this.o.setSwipeNavigationGestureAllowed(!0);
            this.o.setPanZoomAllowed(!1);
        }
        f = Dc.prototype;
        f.applyTransform = function() {};
        f.canHandleMultipleRenderingSections = function() {
            return !1;
        };
        f.destroy = function() {
            var a = this;
            this.P || (this.P = !0, this.j = null, this.u.destroy(), this.B.forEach(function(b) {
                b(new G(q.ColibrioErrorType.ABORTED));
            }), this.B.clear(), this.m.forEach(function(b) {
                b && a.unloadPage(b);
            }));
        };
        f.getContentDisplayAreaDimensions = function() {
            return {
                height: Math.floor(this.ca.height - 1),
                width: Math.floor(this.ca.width - 1)
            };
        };
        f.getPublicationViewportBoundingRect = function() {
            var a = this.g;
            return new DOMRect(a.offsetLeft, a.offsetTop, a.offsetWidth, a.offsetHeight);
        };
        f.getRenderablePageByElement = function(a) {
            var b = this.g;
            for(var c = []; a && a !== b;){
                for(var d = 0, e = a; e = e.previousSibling;)d++;
                c.push(d);
                a = a.parentNode;
            }
            b = a === b ? c.reverse() : null;
            a = this.m[this.l];
            return b && B(b[0]) && a || null;
        };
        f.getRendererElement = function() {
            return this.g;
        };
        f.getScrollState = function() {
            var a = this.m[this.l];
            return a && a.isRenderingCompleted() ? {
                rendererClientHeight: this.g.clientHeight,
                scrollHeight: this.g.scrollHeight,
                scrolling: this.u.isScrolling(),
                scrollTop: this.g.scrollTop
            } : null;
        };
        f.getSwipeNavigationAxis = function() {
            return q.Axis.X;
        };
        f.handlePointerEngineEvent = function(a, b, c) {
            return this.za.handlePointerEngineEvent(a, b, c, this.Z);
        };
        f.handlePointerEngineEventV2 = function(a, b, c) {
            return this.za.handlePointerEngineEventV2(a, b, c, this.Z);
        };
        f.isNativePanXAllowed = function() {
            return !1;
        };
        f.isNativePanYAllowed = function() {
            return !0;
        };
        function Gc(a, b, c, d, e) {
            var g, h = (null == (g = a.M) ? void 0 : g.ib) || e;
            if (!h) return Promise.resolve(!1);
            e = a.m[a.l];
            if (!e || b.getReaderDocuments()[0].getIndexInSpine() !== e.getReaderDocument().getIndexInSpine()) return Promise.resolve(!1);
            var l = a.j, p = !1;
            a.ba && d && d.equals(a.ba) && (p = !0);
            a.ba = d || null;
            g = e.getReaderDocument().getIndexInSpine();
            var u = null == d ? void 0 : d.getReaderDocuments(), t, E;
            if (u && (null == (t = 0 < u.length ? u[0] : void 0) ? void 0 : t.getIndexInSpine()) === g && (null == (E = x(u)) ? void 0 : E.getIndexInSpine()) === g && d.contains(b)) {
                var N;
                c ? N = d.intersects(h.collapseToEnd()) || d.isAfter(h) : N = !h.contains(d);
                if (N) return c = [], c.push(e.fetchOverlayRectsForContentLocation(b)), c.push(e.fetchOverlayRectsForContentLocation(d)), Promise.all(c).then(function(v) {
                    if (l !== a.j) return !1;
                    var y = v[0];
                    v = v[1];
                    if (0 < y.rects.length) {
                        y = Cc(y.rects[0].top, a.g.clientHeight, a.G);
                        if (0 < v.rects.length && !p) {
                            for(var H = v.rects[0].top, V = v.rects[0].bottom, ca = 0; ca < v.rects.length; ca++){
                                var W = v.rects[ca];
                                W.top < H && (H = W.top);
                                W.bottom > V && (V = W.bottom);
                            }
                            v = 0;
                            d.isBefore(h) ? v = H - a.G.cb : d.isAfter(h) && (v = V - a.g.clientHeight + a.G.bb);
                            v = z(v, y.ab, y.Va);
                            Z(a.u, v);
                            return !0;
                        }
                        if (b.isBefore(h)) return Z(a.u, y.Va), !0;
                        if (b.isAfter(h)) return Z(a.u, y.ab), !0;
                    }
                    return !1;
                });
            } else if (!h.contains(b)) return e.fetchOverlayRectsForContentLocation(b).then(function(v) {
                if (l !== a.j) return !1;
                if (0 < v.rects.length) {
                    v = Cc(v.rects[0].top, a.g.clientHeight, a.G);
                    if (b.isBefore(h)) return Z(a.u, v.Va), !0;
                    if (b.isAfter(h)) return Z(a.u, v.ab), !0;
                }
                return !1;
            });
            return Promise.resolve(!1);
        }
        f.navigate = function(a, b, c, d) {
            var e, g = null == (e = this.M) ? void 0 : e.previous, h;
            e = null == (h = this.M) ? void 0 : h.next;
            var l;
            h = null == (l = this.M) ? void 0 : l.visible;
            var p;
            l = (null == (p = this.M) ? void 0 : p.ib) || void 0;
            var u, t;
            p = d && c && (null == c ? void 0 : null == (u = c.getReaderDocuments()[0]) ? void 0 : u.getIndexInSpine()) === (null == (t = this.m[this.l]) ? void 0 : t.getReaderDocument().getIndexInSpine());
            this.j = b;
            switch(a){
                case w.NavigationAction.PREVIOUS_CONTENT_RANGE:
                    return c && p ? Hc(this, c, b, d, l) : g ? this.navigateTo(g, b) : Promise.reject(new G("NAVIGATION_FAILED", "navigate to previous failed because there is no previous range."));
                case w.NavigationAction.NEXT_CONTENT_RANGE:
                    return c && p ? Hc(this, c, b, d, l) : e ? h && h.collapseToStart().equals(e.collapseToStart()) || l && l.collapseToStart().equals(e.collapseToStart()) ? (a = h ? h.collapseToEnd() : l.collapseToEnd(), this.navigateTo(a, b)) : this.navigateTo(e, b) : Promise.reject(new G("NAVIGATION_FAILED", "navigate to next failed because there is no next range."));
                case w.NavigationAction.CURRENT:
                    return Ec(this), Ic(this, c);
                case w.NavigationAction.PREVIOUS_RENDERABLE_PAGE:
                    return (a = this.C[this.l - 1]) ? this.navigateTo(a.getContentLocation(), b) : Promise.reject(new G("NAVIGATION_FAILED", "navigate to previous reader document, but there is no previous document."));
                case w.NavigationAction.NEXT_RENDERABLE_PAGE:
                    return (a = this.C[this.l + 1]) ? this.navigateTo(a.getContentLocation(), b) : Promise.reject(new G("NAVIGATION_FAILED", "navigate to next renderable page, but there is no next document."));
            }
        };
        f.navigateTo = function(a, b) {
            return Hc(this, a, b);
        };
        f.navigateToStart = function(a) {
            var b, c = null == (b = this.C[0]) ? void 0 : b.getContentLocation();
            return c ? this.navigateTo(c, a) : Promise.reject(new G("READER_DOCUMENT_NOT_FOUND", "navigateToStart called, but there are no ReaderDocuments."));
        };
        f.onContentHeightChanged = function() {
            this.o.notifyScrollHeightChanged();
        };
        f.onReadingPositionChanged = function(a, b) {
            b && Gc(this, a, !0, b).catch(function(c) {
                q.ColibrioError.isColibrioAbortedError(c) || q.Logger.logError(c);
            });
        };
        f.scrollBy = function(a) {
            a = q.LengthUtils.getLengthAsCssPixels(a, this.g.clientHeight);
            Z(this.u, z(this.g.scrollTop + a, 0, this.g.scrollHeight));
            return !0;
        };
        f.setOptions = function(a, b) {
            this.i = a;
            this.G = b;
        };
        function Jc(a) {
            var b = a.v[a.l];
            b && (b.classList.remove("colibrio-renderer-scrolled-document--offscreen-page"), b.style.left = "0", b.style.right = "0", b.parentElement || a.g.appendChild(b));
            b = k([
                -1,
                1
            ]);
            for(var c = b.next(); !c.done; c = b.next())if (c = a.v[a.l + c.value]) c.classList.add("colibrio-renderer-scrolled-document--offscreen-page"), c.style.left = "-10000px", c.style.right = "auto", c.parentElement || a.g.appendChild(c);
        }
        function Ec(a) {
            var b = a.j, c = a.U, d = new tc(a.g, a.m, a.v, a.l, a.G);
            Kc(a, !1);
            uc(d).then(function(e) {
                b === a.j && c === a.U && (a.M = e, a.j && a.j.notifyContentRangesChanged({
                    next: e.next,
                    previous: e.previous,
                    visible: e.visible
                }, e.visiblePages, e.ob || void 0), Kc(a, !0));
            }).catch(function(e) {
                q.ColibrioError.isColibrioAbortedError(e) || q.Logger.logError(e);
            });
        }
        function Fc(a, b) {
            b = b.createElement("div");
            b.style.width = a.ca.width + "px";
            b.style.marginRight = "auto";
            b.style.marginLeft = "auto";
            b.style.left = "0";
            b.style.right = "0";
            b.style.position = "absolute";
            b.style.minHeight = "100%";
            b.style.backgroundColor = a.i.pageBackgroundColor;
            b.setAttribute("role", "article");
            b.setAttribute("aria-busy", "true");
            b.setAttribute("aria-live", "off");
            return b;
        }
        function Hc(a, b, c, d, e) {
            var g = Promise.resolve();
            try {
                a.j = c;
                a.o.notifyTransitionStarted();
                var h = b.getReaderDocuments()[0], l = Lc(a, h), p = a.l === l;
                p || (Bc(a.u), a.W && (a.W = !1, a.g.removeEventListener("scroll", a.ga, !0)), Mc(a, l), a.g.scrollTop = 0);
                if (-1 === l) return Bc(a.u), Promise.reject(new G("READER_DOCUMENT_NOT_FOUND", "navigateTo called, but the ReaderDocument for the ContentLocation was not found."));
                p ? (a.v[l].style.visibility = "", a.g.style.overflowY = "", a.g.style.overflowX = "") : (a.v[l].style.visibility = "hidden", a.g.style.overflowY = "hidden", a.g.style.overflowX = "hidden");
                a.l = l;
                Kc(a, !1);
                var u = a.l - 1, t = a.l + 1, E = a.m[u];
                E && E.getState() === w.RenderableState.VISIBLE && E.setVisible(!1);
                var N = a.m[t];
                N && N.getState() === w.RenderableState.VISIBLE && N.setVisible(!1);
                Jc(a);
                h = [];
                var v = Nc(a, a.l).then(function(y) {
                    if (c !== a.j) throw new G(q.ColibrioErrorType.ABORTED);
                    a.v[l].style.visibility = "";
                    y.setVisible(!0);
                    a.o.notifyVisiblePagesUpdated();
                    a.o.notifyTransitionFinished();
                    a.o.notifyScrollHeightChanged();
                    return y.fetchOverlayRectsForContentLocation(b).then(function(H) {
                        if (c !== a.j) throw new G(q.ColibrioErrorType.ABORTED);
                        a.W || (a.W = !0, a.g.addEventListener("scroll", a.ga, !0));
                        var V = 0;
                        0 < H.rects.length && (V = H.rects[0].top);
                        var ca = Cc(V, a.g.clientHeight, a.G);
                        return (d && p ? Gc(a, b, !1, d, e) : Promise.resolve(!1)).then(function(W) {
                            if (c !== a.j) throw new G(q.ColibrioErrorType.ABORTED);
                            W || Z(a.u, ca.Va);
                            a.g.style.overflowY = "";
                            a.g.style.overflowX = "";
                            return y;
                        });
                    });
                });
                g = v.then();
                h.push(v);
                0 <= u && h.push(Nc(a, u));
                t < a.C.length && h.push(Nc(a, t));
                Promise.all(h).then(function(y) {
                    if (c !== a.j) return Promise.reject(new G(q.ColibrioErrorType.ABORTED));
                    for(var H = 1; H < y.length; H++)y[H].setVisible(!1);
                    a.o.notifyPageLoadingComplete();
                    Ec(a);
                }).catch(function(y) {
                    q.ColibrioError.isColibrioAbortedError(y) || q.Logger.logError(y);
                });
            } catch (y) {
                return Promise.reject(y);
            } finally{
                a.o.notifyTransitionFinished();
            }
            return g = g.then(function() {
                return Ic(a, b);
            });
        }
        function Ic(a, b) {
            var c = a.j, d = a.U, e = new tc(a.g, a.m, a.v, a.l, a.G), g = a.m[a.l];
            return g ? Y(e, e.j, e.g.scrollTop, !1, !1).then(function(h) {
                c === a.j && d === a.U && a.j && a.j.notifyVisibleRangeChanged(h, [
                    g
                ], b);
            }).catch(function(h) {
                q.ColibrioError.isColibrioAbortedError(h) || q.Logger.logError(h);
            }) : Promise.reject(new G("VISIBLE_PAGES_NOT_LOADED", "Attempted to calculate visible range without a visible document"));
        }
        function Lc(a, b) {
            return a.C.findIndex(function(c) {
                return c === b;
            });
        }
        function Oc(a, b) {
            if (a.P) return Promise.reject(new G(q.ColibrioErrorType.ABORTED));
            var c = a.o, d = a.m[b];
            return d ? Promise.resolve(d) : c.loadFirstPageInReaderDocument(a.C[b], !0).then(function(e) {
                return a.m[b] ? (c.unloadPage(e), a.m[b]) : a.m[b] = e;
            });
        }
        function Pc(a, b, c) {
            var d;
            return xa(function(e) {
                if (1 == e.g) return d = a.j, b.getState() !== w.RenderableState.CREATED ? (e.g = 2, e = void 0) : e = ra(e, Qc(a, b, c), 3), e;
                if (2 != e.g) {
                    if (d !== a.j) throw new G(q.ColibrioErrorType.ABORTED);
                    return e.return();
                }
                if (b.isRenderingCompleted()) return e.return();
                if (a.P) throw new G(q.ColibrioErrorType.ABORTED);
                return e.return(new Promise(function(g, h) {
                    function l(p) {
                        if (d !== a.j) b.removeStateChangeListener(l), a.B.delete(h), h(new G(q.ColibrioErrorType.ABORTED));
                        else if (p.isRenderingCompleted()) b.removeStateChangeListener(l), a.B.delete(h), g();
                        else if (p.getState() === w.RenderableState.CREATED || p.getState() === w.RenderableState.DESTROYED) b.removeStateChangeListener(l), a.B.delete(h), h(new G(q.ColibrioErrorType.ABORTED));
                    }
                    a.B.add(h);
                    b.addStateChangeListener(l);
                }));
            });
        }
        function Nc(a, b) {
            var c, d, e;
            return xa(function(g) {
                if (1 == g.g) return c = a.j, d = Oc(a, b), ra(g, d, 2);
                if (3 != g.g) {
                    e = g.u;
                    if (c !== a.j) throw new G(q.ColibrioErrorType.ABORTED);
                    return ra(g, Pc(a, e, b).catch(function(h) {
                        q.ColibrioError.isColibrioAbortedError(h) || q.Logger.logError(h);
                    }), 3);
                }
                if (a.P) throw new G(q.ColibrioErrorType.ABORTED);
                return g.return(e);
            });
        }
        function Qc(a, b, c) {
            var d;
            return xa(function(e) {
                d = a.v[c];
                if (a.P) throw new G(q.ColibrioErrorType.ABORTED);
                return e.return(new Promise(function(g, h) {
                    function l() {
                        if (b.isRenderingCompleted()) b.removeStateChangeListener(l), d.setAttribute("aria-busy", "false"), a.B.delete(h), g();
                        else if (b.getState() === w.RenderableState.CREATED || b.getState() === w.RenderableState.DESTROYED) b.removeStateChangeListener(l), a.B.delete(h), h(new G(q.ColibrioErrorType.ABORTED));
                    }
                    a.B.add(h);
                    b.addStateChangeListener(l);
                    b.renderTo(d);
                }));
            });
        }
        function Mc(a, b) {
            for(var c = 0 < a.l ? a.l - 1 : 0; c <= a.l + 1 && c < a.v.length; c++)if (1 < Math.abs(b - c)) {
                var d = a.m[c];
                d && a.unloadPage(d);
                d = a.v[c];
                var e = d.parentNode;
                e && e.removeChild(d);
            }
        }
        f.unloadPage = function(a) {
            var b = Lc(this, a.getReaderDocument());
            a.remove();
            this.o.unloadPage(a);
            this.m[b] = void 0;
        };
        function Kc(a, b) {
            var c, d = b && !(null == (c = a.M) || !c.previous), e;
            a.Z = {
                current: !0,
                nextContentRange: b && !(null == (e = a.M) || !e.next),
                nextRenderablePage: a.l < a.C.length - 1,
                previousContentRange: d,
                previousRenderablePage: 0 < a.l
            };
            a.o.notifyPossibleNavigationActions(a.Z);
        }
        function Rc(a) {
            this.g = [];
            this.i = A(a, Sc());
        }
        f = Rc.prototype;
        f.createRuntime = function(a) {
            var b = Tc(this, a.getReaderViewDimensions(), a.getConfiguredPageAspectRatio()), c = Uc(this, b.height);
            a = new Dc(a, this.i, c, b);
            this.g.push(a);
            return a;
        };
        f.destroyRuntime = function(a) {
            if (!(a instanceof Dc)) throw new G("RUNTIME_INSTANCE_TYPE_MISMATCH", "Expected a SingleDocumentScrollRendererRuntime");
            for(var b = 0; b < this.g.length; b++)if (this.g[b] === a) {
                this.g.splice(b, 1);
                break;
            }
            a.destroy();
        };
        f.getName = function() {
            return this.i.name;
        };
        f.getOptions = function() {
            return this.i;
        };
        f.getSpreadMode = function() {
            return w.RendererSpreadMode.SINGLE_PAGE;
        };
        f.getSupportedFlowModes = function() {
            return [
                r.ContentDocumentFlowMode.SCROLLED_DOC
            ];
        };
        f.getVisiblePagesArea = function(a, b) {
            a = Tc(this, a, b);
            return a.width * a.height;
        };
        f.isPublicationPreferredAspectRatioRequired = function() {
            return !0;
        };
        f.setOptions = function(a) {
            a = A(a, this.i, !0);
            this.i = A(a, Sc());
            if (a = x(this.g)) {
                var b = a.getRendererElement().clientHeight;
                b = Uc(this, b);
                a.setOptions(this.i, b);
            }
        };
        function Sc() {
            return {
                ignoreAspectRatio: !1,
                maxWidth: {
                    unit: q.LengthUnit.PERCENT,
                    value: 100
                },
                name: "renderer_" + Gb++,
                pageBackgroundColor: "#ffffff",
                readingAreaOffsetBottom: {
                    unit: q.LengthUnit.PERCENT,
                    value: 20
                },
                readingAreaOffsetTop: {
                    unit: q.LengthUnit.PERCENT,
                    value: 10
                },
                scrollbarPosition: "DOCUMENT"
            };
        }
        function Uc(a, b) {
            var c = q.LengthUtils.getLengthAsCssPixels(a.i.readingAreaOffsetTop, b);
            a = q.LengthUtils.getLengthAsCssPixels(a.i.readingAreaOffsetBottom, b);
            b = 30 * b / 100;
            return {
                bb: z(0, a, b),
                cb: z(0, c, b)
            };
        }
        function Tc(a, b, c) {
            var d = q.LengthUtils.getLengthAsCssPixels(a.i.maxWidth, b.width) | 0;
            d = Math.min(d, b.width);
            b = b.height;
            var e;
            a.i.ignoreAspectRatio || "fill" === c ? e = {
                height: b,
                width: d
            } : e = d / b > c ? {
                height: Math.floor(b),
                width: Math.floor(b * c)
            } : {
                height: Math.floor(d / c),
                width: Math.floor(d)
            };
            return e;
        }
        api = {
            FlipBookRenderer: Tb,
            RendererError: G,
            RendererErrorType: {
                ANIMATION_FAILED: "ANIMATION_FAILED",
                NO_RENDERABLE_PAGES: "NO_RENDERABLE_PAGES",
                NAVIGATION_FAILED: "NAVIGATION_FAILED",
                READER_DOCUMENT_NOT_FOUND: "READER_DOCUMENT_NOT_FOUND",
                RUNTIME_INSTANCE_TYPE_MISMATCH: "RUNTIME_INSTANCE_TYPE_MISMATCH",
                VISIBLE_PAGES_NOT_LOADED: "VISIBLE_PAGES_NOT_LOADED"
            },
            ScrollRendererScrollbarPosition: {
                DOCUMENT: "DOCUMENT",
                READER_VIEW: "READER_VIEW"
            },
            SingleDocumentScrollRenderer: Rc,
            SinglePageSwipeRenderer: $b,
            SpreadSwipeRenderer: hc,
            StackRenderer: oc
        };
        var Vc = new ArrayBuffer(8);
        new DataView(Vc);
        new Uint8Array(Vc);
    }).call(__self);
    return api;
});


const { FlipBookRenderer: $ec828051165c5b2b$export$368c10b5be12ad52, RendererError: $ec828051165c5b2b$export$b5784cc8fa523850, RendererErrorType: $ec828051165c5b2b$export$9bb01afc79bd8ec3, ScrollRendererScrollbarPosition: $ec828051165c5b2b$export$50e9c1e4d05f6510, SingleDocumentScrollRenderer: $ec828051165c5b2b$export$c122e6b15f2d3706, SinglePageSwipeRenderer: $ec828051165c5b2b$export$865a8bfa7a5da5e3, SpreadSwipeRenderer: $ec828051165c5b2b$export$3775ca37f4bb8a58, StackRenderer: $ec828051165c5b2b$export$4ec853217c7f0f57 } = (0, (/*@__PURE__*/$parcel$interopDefault($5c8ac5b7fc4b7c8f$exports)));


class $9921e8fc01f14fe1$export$156ca23c85abf471 {
    constructor(name, _colibrioReaderView){
        this.name = name;
        this._colibrioReaderView = _colibrioReaderView;
        this._locatorToAnnotationMap = new Map();
        this._bookmarksInVisibleRange = new Set();
        this._bookmarksCollectionUpdatedCallback = undefined;
        this._bookmarkAddedCallback = undefined;
        this._bookmarkDeletedCallback = undefined;
        this._bookmarkClickCallback = undefined;
        this._bookmarkPointerEnterCallback = undefined;
        this._bookmarkPointerLeaveCallback = undefined;
        this._bookmarkEnterViewCallback = undefined;
        this._bookmarkExitViewCallback = undefined;
        this._bookmarkContextMenuCallback = undefined;
        this._event_click = (event)=>{
            if (this._bookmarkClickCallback) this._bookmarkClickCallback(event);
        };
        this._event_enterView = (event)=>{
            let annotationData = event.annotation.getCustomData();
            this._bookmarksInVisibleRange.add(annotationData);
            if (this._bookmarkEnterViewCallback) this._bookmarkEnterViewCallback(annotationData);
        };
        this._event_exitView = (event)=>{
            let annotationData = event.annotation.getCustomData();
            this._bookmarksInVisibleRange.delete(annotationData);
            if (this._bookmarkExitViewCallback) this._bookmarkExitViewCallback(annotationData);
        };
        this._event_pointerEnter = (event)=>{
            if (this._bookmarkPointerEnterCallback) this._bookmarkPointerEnterCallback(event);
        };
        this._event_pointerLeave = (event)=>{
            if (this._bookmarkPointerLeaveCallback) this._bookmarkPointerLeaveCallback(event);
        };
        this._event_contextMenu = (event)=>{
            if (this._bookmarkContextMenuCallback) this._bookmarkContextMenuCallback(event);
        };
        this._colibrioAnnotationLayer = this._colibrioReaderView.createAnnotationLayer(this.name);
        this._create();
    }
    onBookmarkAdded(callback) {
        this._bookmarkAddedCallback = callback;
    }
    onBookmarkDeleted(callback) {
        this._bookmarkDeletedCallback = callback;
    }
    onBookmarksCollectionUpdated(callback) {
        this._bookmarksCollectionUpdatedCallback = callback;
    }
    onBookmarkClick(callback) {
        this._bookmarkClickCallback = callback;
    }
    onBookmarkPointerEnter(callback) {
        this._bookmarkPointerEnterCallback = callback;
    }
    onBookmarkPointerLeave(callback) {
        this._bookmarkPointerLeaveCallback = callback;
    }
    onBookmarkEnterView(callback) {
        this._bookmarkEnterViewCallback = callback;
    }
    onBookmarkExitView(callback) {
        this._bookmarkExitViewCallback = callback;
    }
    onBookmarkContextMenu(callback) {
        this._bookmarkContextMenuCallback = callback;
    }
    loadBookmarks(items) {
        if (this._colibrioAnnotationLayer) items.forEach((item)=>{
            this.addBookmark(item).catch(console.warn);
        });
    }
    getBookmarks() {
        let bookmarks = [];
        this._colibrioAnnotationLayer.getAnnotations().forEach((item)=>{
            bookmarks.push(item.getCustomData());
        });
        return bookmarks;
    }
    getReaderViewAnnotations() {
        return this._colibrioAnnotationLayer.getAnnotations();
    }
    async addBookmark(bookmarkData) {
        let locator = bookmarkData.locator;
        let readerViewAnnotation;
        let readerPublication = this._colibrioReaderView.getReaderPublications()[0];
        let contentLocation = await readerPublication?.fetchContentLocation(locator);
        if (contentLocation) {
            readerViewAnnotation = this._colibrioAnnotationLayer.createAnnotation(locator);
            readerViewAnnotation.setCustomData(bookmarkData);
            this._locatorToAnnotationMap.set(locator.toString(), readerViewAnnotation);
            if (this._bookmarkAddedCallback) this._bookmarkAddedCallback(bookmarkData);
            if (this._bookmarksCollectionUpdatedCallback) this._bookmarksCollectionUpdatedCallback();
            return bookmarkData;
        }
        return undefined;
    }
    getBookmark(locator) {
        if (this._locatorToAnnotationMap.has(locator)) return this._locatorToAnnotationMap.get(locator).getCustomData() || undefined;
        else return;
    }
    deleteBookmark(bookmarkLocator) {
        let annotation = this._locatorToAnnotationMap.get(bookmarkLocator);
        if (annotation) {
            let vanillaReaderAnnotationData = annotation.getCustomData();
            let layer = annotation.getAnnotationLayer();
            layer.destroyAnnotation(annotation);
            this._locatorToAnnotationMap.delete(bookmarkLocator);
            if (this._bookmarkDeletedCallback) {
                if (vanillaReaderAnnotationData) this._bookmarkDeletedCallback(bookmarkLocator);
                else console.warn(`VanillaReaderAnnotationLayerHighlights.deleteHighlight(): Unable to get annotation data for annotation with locator "${bookmarkLocator}". "bookmarkDeletedCallback" Callback not fired.`);
            }
            if (this._bookmarksCollectionUpdatedCallback) this._bookmarksCollectionUpdatedCallback();
        }
    }
    clear() {
        this._colibrioAnnotationLayer.destroyAllAnnotations();
    }
    destroy() {
        this._colibrioReaderView.destroyAnnotationLayer(this._colibrioAnnotationLayer);
    }
    locationHasBookmark(locator) {
        return this._locatorToAnnotationMap.has(locator);
    }
    getBookmarksInVisibleRange() {
        return Array.from(this._bookmarksInVisibleRange);
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _create() {
        let layerOptions = {
            layerClassName: "vanilla-reader__bookmarks-layer",
            annotationInputEngineEventsEnabled: true
        };
        this._colibrioAnnotationLayer.setLayerOptions(layerOptions);
        let annotationOptions = {
            positionStyle: {
                "width": "100%",
                "height": "32px"
            },
            containerClassName: "vanilla-reader__bookmark-container",
            containerStyle: {
                "left": "0",
                "width": "32px",
                "height": "32px"
            }
        };
        this._colibrioAnnotationLayer.setDefaultAnnotationOptions(annotationOptions);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationContextMenu", this._event_contextMenu);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationClick", this._event_click);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationIntersectingVisibleRange", this._event_enterView);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationOutsideVisibleRange", this._event_exitView);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationPointerEnter", this._event_pointerEnter);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationPointerLeave", this._event_pointerLeave);
    }
}



class $30063c7d7dbf15f5$export$9add86a2ef1d6204 {
    constructor(name, color = (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow, _colibrioReaderView){
        this.name = name;
        this.color = color;
        this._colibrioReaderView = _colibrioReaderView;
        this._locatorToAnnotationMap = new Map();
        this._highlightAddedCallback = undefined;
        this._highlightDeletedCallback = undefined;
        this._highlightUpdatedCallback = undefined;
        this._highlightsCollectionUpdatedCallback = undefined;
        this._highlightClickCallback = undefined;
        this._highlightPointerEnterCallback = undefined;
        this._highlightPointerLeaveCallback = undefined;
        this._highlightEnterViewCallback = undefined;
        this._highlightExitViewCallback = undefined;
        this._highlightContextMenuCallback = undefined;
        this.updateHighlight = (highlight)=>{
            let existingTarget = this._locatorToAnnotationMap.get(highlight.locator);
            if (existingTarget) {
                existingTarget.setCustomData(highlight);
                existingTarget.setOptions({
                    rangeStyle: {
                        "background-color": highlight.color
                    }
                });
                if (this._highlightUpdatedCallback) this._highlightUpdatedCallback(highlight);
                if (this._highlightsCollectionUpdatedCallback) this._highlightsCollectionUpdatedCallback();
            } else console.log("annotationLayerHighlights_update", "Could not find existing VanillaReaderHighlight with contentBlockLocator ", highlight.locator);
        };
        this._event_click = (event)=>{
            if (this._highlightClickCallback) this._highlightClickCallback(event);
        };
        this._event_enterView = (event)=>{
            this._highlightsInVisibleRange.add(event.annotation.getCustomData());
            if (this._highlightEnterViewCallback) this._highlightEnterViewCallback(event.annotation.getCustomData());
        };
        this._event_exitView = (event)=>{
            this._highlightsInVisibleRange.delete(event.annotation.getCustomData());
            if (this._highlightExitViewCallback) this._highlightExitViewCallback(event.annotation.getCustomData());
        };
        this._event_pointerEnter = (event)=>{
            if (this._highlightPointerEnterCallback) this._highlightPointerEnterCallback(event);
        };
        this._event_pointerLeave = (event)=>{
            if (this._highlightPointerLeaveCallback) this._highlightPointerLeaveCallback(event);
        };
        this._event_contextMenu = (event)=>{
            if (this._highlightContextMenuCallback) this._highlightContextMenuCallback(event);
        };
        this._colibrioAnnotationLayer = this._colibrioReaderView.createAnnotationLayer(this.name);
        this._highlightsInVisibleRange = new Set();
        this._create();
    }
    onHighlightAdded(callback) {
        this._highlightAddedCallback = callback;
    }
    onHighlightUpdated(callback) {
        this._highlightUpdatedCallback = callback;
    }
    onHighlightDeleted(callback) {
        this._highlightDeletedCallback = callback;
    }
    onHighlightsCollectionUpdated(callback) {
        this._highlightsCollectionUpdatedCallback = callback;
    }
    onHighlightClick(callback) {
        this._highlightClickCallback = callback;
    }
    onHighlightPointerEnter(callback) {
        this._highlightPointerEnterCallback = callback;
    }
    onHighlightPointerLeave(callback) {
        this._highlightPointerLeaveCallback = callback;
    }
    onHighlightEnterView(callback) {
        this._highlightEnterViewCallback = callback;
    }
    onHighlightExitView(callback) {
        this._highlightExitViewCallback = callback;
    }
    onHighlightContextMenu(callback) {
        this._highlightContextMenuCallback = callback;
    }
    loadHighlights(items) {
        if (this._colibrioAnnotationLayer) items.forEach((item)=>{
            this.addHighlight(item);
        });
    }
    getHighlights() {
        let highlights = [];
        this._colibrioAnnotationLayer.getAnnotations().forEach((item)=>{
            highlights.push(item.getCustomData());
        });
        return highlights;
    }
    getReaderViewAnnotations() {
        return this._colibrioAnnotationLayer.getAnnotations();
    }
    addHighlight(highlightData) {
        let readerViewAnnotation;
        readerViewAnnotation = this._colibrioAnnotationLayer.createAnnotation(highlightData.locator);
        readerViewAnnotation.setOptions({
            rangeStyle: {
                "background-color": highlightData.color
            }
        });
        readerViewAnnotation.setCustomData(highlightData);
        this._locatorToAnnotationMap.set(highlightData.locator, readerViewAnnotation);
        if (this._highlightAddedCallback) this._highlightAddedCallback(highlightData);
        if (this._highlightsCollectionUpdatedCallback) this._highlightsCollectionUpdatedCallback();
    }
    deleteHighlight(locator) {
        let existingTarget = this._locatorToAnnotationMap.get(locator);
        if (existingTarget) {
            this._locatorToAnnotationMap.delete(locator);
            let vanillaReaderAnnotationData = existingTarget.getCustomData();
            existingTarget.getAnnotationLayer().destroyAnnotation(existingTarget);
            if (this._highlightDeletedCallback) {
                if (vanillaReaderAnnotationData) this._highlightDeletedCallback(vanillaReaderAnnotationData);
                else console.warn(`VanillaReaderAnnotationLayerHighlights.deleteHighlight(): Unable to get annotation data for annotation with locator "${locator}"`);
            }
            if (this._highlightsCollectionUpdatedCallback) this._highlightsCollectionUpdatedCallback();
        } else console.log("annotationLayerHighlights_deleteHighlight", "Could not find existing VanillaReaderHighlight with contentBlockLocator ", locator);
    }
    getHighlight(locator) {
        if (this._locatorToAnnotationMap.has(locator)) return this._locatorToAnnotationMap.get(locator).getCustomData() || undefined;
        else return;
    }
    destroy() {
        this._colibrioReaderView.destroyAnnotationLayer(this._colibrioAnnotationLayer);
    }
    clear() {
        this._colibrioAnnotationLayer.destroyAllAnnotations();
    }
    getHighlightsInVisibleRange() {
        return Array.from(this._highlightsInVisibleRange);
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _create() {
        this._colibrioAnnotationLayer.setDefaultAnnotationOptions({
            rangeClassName: "vanilla-reader__highlights-layer",
            rangeStyle: {
                "background-color": this.color,
                "padding": "2px",
                "margin-top": "-2px",
                "margin-left": "-2px",
                "border-radius": "4px"
            }
        });
        this._colibrioAnnotationLayer.setLayerOptions({
            annotationInputEngineEventsEnabled: true,
            layerStyle: {
                "mix-blend-mode": "multiply"
            }
        });
        this._colibrioAnnotationLayer.addEngineEventListener("annotationContextMenu", this._event_contextMenu);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationClick", this._event_click);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationIntersectingVisibleRange", this._event_enterView);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationOutsideVisibleRange", this._event_exitView);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationPointerEnter", this._event_pointerEnter);
        this._colibrioAnnotationLayer.addEngineEventListener("annotationPointerLeave", this._event_pointerLeave);
    }
}





class $3d08a792c91a6f5b$export$588b7f0add27ff6 {
    constructor(){
        this._wordSequence = null;
        this._totalNumberOfWords = null;
        this._previousRange = null;
        this._wordReadingRateHistory = [];
    }
    setPublicationLength(numberOrWords) {
        this._totalNumberOfWords = numberOrWords;
        this._wordSequence = new (0, $632829fca60d0ba6$export$98bf3bbab5d20daf)(numberOrWords);
    }
    getPublicationLength() {
        return this._totalNumberOfWords;
    }
    addWordRange(range) {
        this._updateAverageWordsPerMinute(this._previousRange || range);
        this._previousRange = range;
        this._wordSequence?.addRange(range.start, range.end);
    }
    invalidateLatestWordRange() {
        this._wordReadingRateHistory.pop();
    }
    getNumberOfWordsRead() {
        let readRanges = this._wordSequence?.getEntries();
        let wordCount = 0;
        readRanges?.forEach((range)=>{
            wordCount += range.end - range.start;
        });
        return wordCount;
    }
    getPercentRead() {
        if (this._totalNumberOfWords) {
            let wordCount = this.getNumberOfWordsRead();
            return wordCount / this._totalNumberOfWords * 100;
        }
        return undefined;
    }
    getRangesNotRead() {
        return this._wordSequence?.getEmptySlots();
    }
    getRangesRead() {
        return this._wordSequence?.getEntries();
    }
    getAverageWordsPerMinute() {
        let averagesSum = 0;
        this._wordReadingRateHistory.forEach((historyItem)=>{
            averagesSum += historyItem[1];
        });
        return averagesSum / this._wordReadingRateHistory.length;
    }
    getLatestAverageWordsPerMinute() {
        return this._wordReadingRateHistory[this._wordReadingRateHistory.length - 1][1];
    }
    _updateAverageWordsPerMinute(wordRange) {
        let nowTimestampInSeconds = Date.now() / 1000;
        let latestRangeChangedTimestamp = this._latestRangeChangedTimestamp ? this._latestRangeChangedTimestamp : nowTimestampInSeconds;
        let secondsElapsedSinceLastChange = nowTimestampInSeconds - latestRangeChangedTimestamp > 0 ? nowTimestampInSeconds - latestRangeChangedTimestamp : 1;
        this._latestRangeChangedTimestamp = nowTimestampInSeconds;
        let averageWordsPerMinute = wordRange.length / (secondsElapsedSinceLastChange / 60);
        this._wordReadingRateHistory.push([
            nowTimestampInSeconds,
            averageWordsPerMinute
        ]);
    }
}


class $91988398b375e795$export$2704a6f5a288a76a {
    constructor(vanillaReaderView, _pageList){
        this.vanillaReaderView = vanillaReaderView;
        this._pageList = _pageList;
        this._pageNumberSvgTemplate = "%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='100%25' preserveAspectRatio='xMinYMin meet' viewBox='0 0 5.7149889 2.5929101' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3E%3Ctext xml:space='preserve' style='font-weight:bold%3Bfont-size:11px%3Bline-height:1%3Bfont-family:sans-serif%3Bfill:{{page_number_color}}' transform='matrix(0.06683661 0 0 0.06683661 0.13437553 1)'%3E%3Ctspan%3E{{page_number}}%3C/tspan%3E%3C/text%3E%3C/svg%3E";
        this._annotationLayer = this.vanillaReaderView.colibrioReaderView.createAnnotationLayer("vanilla-reader__synthetic-page-range-layer");
        this._annotationLayer.setLayerOptions({
            annotationInputEngineEventsEnabled: false,
            layerClassName: "vanilla-reader__synthetic-page-range-layer"
        });
        this._annotationLayer.setVisible(false);
        this._populate();
    }
    get isVisible() {
        return this._annotationLayer.isVisible();
    }
    refresh() {
        this._annotationLayer.destroyAllAnnotations();
        this._populate();
    }
    setVisible(visible) {
        this._annotationLayer.setVisible(visible);
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ _populate() {
        this._pageList.pages.forEach((pageData)=>{
            if (pageData.locatorData) {
                let locatorFactory = this.vanillaReaderView.getVanillaReaderPublication().colibrioReaderPublication.getLocatorFactory();
                let locator = locatorFactory.parse(pageData.locatorData).locator;
                if (locator) {
                    let positionLocator = locatorFactory.collapseRangeLocatorToStart(locator);
                    let pageAnnotation = this._annotationLayer.createAnnotation(positionLocator, pageData);
                    let pageNumberBackgroundString = this._pageNumberSvgTemplate.replace("{{page_number}}", pageData.label);
                    let pageMarkerColorValue = this.vanillaReaderView.activePalette?.isDark ? this.vanillaReaderView.activePalette.foregroundLight : this.vanillaReaderView.activePalette?.foregroundDark;
                    let encodedColorValue = pageMarkerColorValue ? pageMarkerColorValue.replace("#", "%23") : "rgba(0,0,0,0.7)";
                    pageNumberBackgroundString = pageNumberBackgroundString.replace("{{page_number_color}}", encodedColorValue);
                    pageAnnotation.setOptions({
                        containerClassName: "vanilla-reader__synthetic-page-range-layer__annotation",
                        containerStyle: {
                            "background-image": `url("data:image/svg+xml,${pageNumberBackgroundString}")`,
                            "background-size": "contain",
                            "background-repeat": "no-repeat",
                            "left": "0.4em",
                            "height": "36px",
                            "width": "100%",
                            "opacity": "0.6"
                        }
                    });
                } else console.warn(`VanillaReaderAnnotationLayerPageRanges._populate, page data has no valid locator.`, pageData);
            }
        });
    }
}




class $9ff050ad3115202b$export$b034d7788f93e3ea {
    constructor(_vanillaReaderReadingSystem, _vanillaReaderPublication, _readerViewElement, _vanillaReaderOptionsDataStore, _customContentOnLoading, _customContentOnLoadError){
        this._vanillaReaderReadingSystem = _vanillaReaderReadingSystem;
        this._vanillaReaderPublication = _vanillaReaderPublication;
        this._readerViewElement = _readerViewElement;
        this._vanillaReaderOptionsDataStore = _vanillaReaderOptionsDataStore;
        this._customContentOnLoading = _customContentOnLoading;
        this._customContentOnLoadError = _customContentOnLoadError;
        this._useReducedMotion = false;
        this._scrollOverflowingTables = false;
        this._ignoreAspectRatio = false;
        this._showPageMarkerLayer = false;
        this._defaultAnimationDuration = 600;
        this._currentVisibleContentRects = undefined;
        this._initialPublicationViewportRects = [];
        this._event_visibleContentRendered = async ()=>{
            let visibleRangeData = await this.fetchVisibleRangeData(this._vanillaReaderPublication.navigationTree, this._vanillaReaderPublication.progressionTimeline);
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VISIBLE_CONTENT_RENDERED", {
                visibleRangeData: visibleRangeData
            }));
        };
        this._event_visiblePagesChanged = async ()=>{
            let visiblePagesBoundingClientRects = this.getVisiblePagesBoundingClientRects();
            this._initialPublicationViewportRects = visiblePagesBoundingClientRects;
            if (visiblePagesBoundingClientRects) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_VIEWPORT_CHANGED", {
                visiblePageClientRects: visiblePagesBoundingClientRects
            }));
            let visibleRangeData = await this.fetchVisibleRangeData(this._vanillaReaderPublication.navigationTree, this._vanillaReaderPublication.progressionTimeline);
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VISIBLE_PAGES_CHANGED", {
                visibleRangeData: visibleRangeData
            }));
        };
        this._colibrioReaderView = this._vanillaReaderReadingSystem.createReaderView({});
        // Now let's set the reader documents to the Colibrio ReaderView instance. Note that this needs to be done in the
        // sync constructor in order for the calling code to execute correctly.
        this._colibrioReaderView.setReaderDocuments(this._vanillaReaderPublication.getColibrioReaderPublication().getSpine());
        this._activeTransformData = this._setActiveTransformData({
            transformData: undefined,
            zoomTargetClientRect: undefined,
            visiblePageClientRects: [],
            publicationViewportScale: 1
        });
    }
    get activeTransformData() {
        return this._activeTransformData;
    }
    async setup() {
        // Let's get the current option's data from the store. If we find nothing in the store, we set the initial
        // options from the defaults provided by the `getOptions` method.
        let initialOptionsData = await this._vanillaReaderOptionsDataStore.fetchVanillaReaderOptionsData();
        this._initialVanillaReaderViewOptions = initialOptionsData?.viewOptions ? initialOptionsData.viewOptions : this.getCurrentVanillaReaderViewOptionsState();
        this._activePalette = this._initialVanillaReaderViewOptions?.colibrioReaderViewOptions?.publicationStyleOptions?.palette;
        this.showPageMarkerLayer = this._initialVanillaReaderViewOptions.showPageRangesLayer || false;
        this._createRenderers(this._colibrioReaderView);
        // Add custom content to be shown while the reader view is loading new content.
        this._colibrioReaderView.setContentOnLoading({
            layout: (0, $f8f5cf2c043414f4$export$73f4a02232f5da7f).FLEX_CENTER,
            renderTo: (containerElement)=>{
                containerElement.innerHTML = this._customContentOnLoading || "loading...";
            }
        });
        // Add custom content to be shown if a loading error occurs.
        this._colibrioReaderView.setContentOnLoadError({
            layout: (0, $f8f5cf2c043414f4$export$73f4a02232f5da7f).FLEX_CENTER,
            renderTo: (containerElement)=>{
                containerElement.innerHTML = this._customContentOnLoadError || "An error occurred";
            }
        });
        // We check the this._initialVanillaReaderViewOptions object to see if the user has a saved preference for which renderer to use. This
        // will override the renderers added above by explicitly calling `setActiveRenderer()` and their respective
        // `ResponsiveViewRules`.
        if (this._initialVanillaReaderViewOptions && this._initialVanillaReaderViewOptions?.activeRendererTypeName) {
            // We have an option in the `VanillaReaderRendererNames` called `RESPONSIVE`. This option is not really the
            // name of a renderer instance, but is a flag that we should let the `IReaderView` select a renderer for us.
            if (this._initialVanillaReaderViewOptions?.activeRendererTypeName !== (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE) {
                // Since the this._initialVanillaReaderViewOptions has supplied us with a renderer name that does not match `VanillaReaderRendererNames.RESPONSIVE`
                // we can tell the reader view that we will handle selection of renderers manually.
                this._colibrioReaderView.setResponsiveRendererSelectionEnabled(false);
                let newActiveRenderer = this._colibrioReaderView.getRendererByName(this._initialVanillaReaderViewOptions?.activeRendererTypeName);
                if (newActiveRenderer) this._colibrioReaderView.setActiveRenderer(newActiveRenderer);
                else console.warn("VanillaReader.createReaderView()", 'Unable to set new active renderer "' + this._initialVanillaReaderViewOptions?.activeRendererTypeName + '" from this._initialVanillaReaderViewOptions?.');
            } else // The this._initialVanillaReaderViewOptions has supplied us with a renderer name that matches `VanillaReaderRendererNames.RESPONSIVE`.
            // Let's tell the reader view that it should use the `ResponsiveViewRules` to determine the best renderer
            // to use.
            this._colibrioReaderView.setResponsiveRendererSelectionEnabled(true);
        }
        // Now that we have things set up we can finally render the Colibrio ReaderView to the HTML element that was
        // passed in to the constructor
        this._colibrioReaderView.renderTo(this._readerViewElement);
        // Add some event listeners to keep track of transition events, such as page turn animation.
        this._colibrioReaderView.addEngineEventListener("rendererTransitionStarted", (evt)=>{
            if (this._onRendererTransitionStartedCallback) this._onRendererTransitionStartedCallback(evt);
        });
        this._colibrioReaderView.addEngineEventListener("rendererTransitionEnded", (evt)=>{
            if (this._onRendererTransitionEndedCallback) this._onRendererTransitionEndedCallback(evt);
        });
        this._colibrioReaderView.addEngineEventListener("rendererScrollStarted", (evt)=>{
            if (this._onRendererScrollStartedCallback) this._onRendererScrollStartedCallback(evt);
        });
        this._colibrioReaderView.addEngineEventListener("rendererScrollEnded", (evt)=>{
            if (this._onRendererScrollEndedCallback) this._onRendererScrollEndedCallback(evt);
        });
        this._colibrioReaderView.addEngineEventListener("swipeNavigationGestureProgress", (evt)=>{
            if (this._onSwipeNavigationGestureProgressCallback) this._onSwipeNavigationGestureProgressCallback(evt.toJSON());
        });
        this._vanillaReaderReadingSystem.onVisibleContentRendered(()=>{
            this._event_visibleContentRendered().catch(console.warn);
        });
        this._vanillaReaderReadingSystem.onVisiblePagesChanged(()=>{
            this._event_visiblePagesChanged().catch(console.warn);
        });
        this._colibrioReaderView.addEngineEventListener("activeRendererChanged", (evt)=>{
            if (evt.newActiveRenderer) {
                let options;
                if (evt.newActiveRenderer.getName() !== (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL) {
                    const paginatedRendererOptions = {
                        disableAnimations: this.useReducedMotion,
                        ignoreAspectRatio: this.ignoreAspectRatio
                    };
                    options = paginatedRendererOptions;
                } else options = {
                    ignoreAspectRatio: this.ignoreAspectRatio
                };
                evt.newActiveRenderer.setOptions(options);
            }
            if (this._onActiveRendererChangedCallback) this._onActiveRendererChangedCallback(evt);
            this._persistCurrentVanillaReaderOptionsState().catch(console.warn);
        });
        this._colibrioReaderView.addEngineEventListener("pageProgressionTimelineRecalculated", (evt)=>{
            if (this._onPageProgressionTimelineRecalculatedCallback) this._onPageProgressionTimelineRecalculatedCallback(evt);
        });
        this._vanillaReaderReadingSystem.onActiveReaderViewTransformChanged(async (transformData)=>{
            let transformedPublicationClientRects = this.getVisiblePagesBoundingClientRects();
            let publicationViewportScale = this._getPublicationViewportScale(this._initialPublicationViewportRects, transformedPublicationClientRects);
            let vanillaTransformData;
            if (transformData) vanillaTransformData = {
                transformData: transformData,
                visiblePageClientRects: this.getVisiblePagesBoundingClientRects(),
                zoomTargetClientRect: this._activeTransformData?.zoomTargetClientRect,
                publicationViewportScale: publicationViewportScale
            };
            if (vanillaTransformData && transformedPublicationClientRects) vanillaTransformData.visiblePageClientRects = transformedPublicationClientRects;
            if (transformData && !transformData.animating && !transformData.userGestureActive || !transformData) {
                let rects = await this.updateAndFetchVisibleContentRects() || [];
                let rectData = rects.map((rect)=>rect.toJSON());
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VISIBLE_CONTENT_RECTS_CHANGED", {
                    clientRects: rectData || []
                }));
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_VIEWPORT_CHANGED", {
                    visiblePageClientRects: transformedPublicationClientRects
                }));
                if (transformData) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_TRANSFORM_STOPPED", {
                    transformData: vanillaTransformData
                }));
                else {
                    vanillaTransformData = undefined;
                    (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_TRANSFORM_RESET", {}));
                }
            }
            this._setActiveTransformData(vanillaTransformData);
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_TRANSFORM_CHANGED", {
                transformData: this.activeTransformData
            }));
        });
        // Here we create the Annotation Layer that will render all the highlights that the user has added to the book.
        this.highlightsLayer = new (0, $30063c7d7dbf15f5$export$9add86a2ef1d6204)("highlights", "yellow", this._colibrioReaderView);
        this._setupHighlightLayerCallbacks(this.highlightsLayer);
        // And here we create the Annotation Layer that will render all the bookmarks that the user has added to the book.
        this.bookmarksLayer = new (0, $9921e8fc01f14fe1$export$156ca23c85abf471)("bookmarks", this._colibrioReaderView);
        this._setupBookmarkLayerCallbacks(this.bookmarksLayer);
        // And then we create our simple reading stats instance.
        this.readingStats = new (0, $3d08a792c91a6f5b$export$588b7f0add27ff6)();
        if (this._onReaderViewCreatedCallback) {
            let options = this.getCurrentVanillaReaderViewOptionsState();
            this._onReaderViewCreatedCallback(options);
        }
        this.setVanillaReaderViewOptions(this._initialVanillaReaderViewOptions);
    }
    onReducedMotionValueChanged(callback) {
        this._onReducedMotionValueChangedCallback = callback;
    }
    onIgnoreAspectRatioValueChanged(callback) {
        this._onIgnoreAspectRatioValueChangedCallback = callback;
    }
    onReaderViewCreated(callback) {
        this._onReaderViewCreatedCallback = callback;
    }
    onActiveRendererChanged(callback) {
        this._onActiveRendererChangedCallback = callback;
    }
    onSwipeNavigationGestureProgress(callback) {
        this._onSwipeNavigationGestureProgressCallback = callback;
    }
    onRendererTransitionStarted(callback) {
        this._onRendererTransitionStartedCallback = callback;
    }
    onRendererTransitionEnded(callback) {
        this._onRendererTransitionEndedCallback = callback;
    }
    onRendererScrollStarted(callback) {
        this._onRendererScrollStartedCallback = callback;
    }
    onRendererScrollEnded(callback) {
        this._onRendererScrollEndedCallback = callback;
    }
    onPageProgressionTimelineRecalculated(callback) {
        this._onPageProgressionTimelineRecalculatedCallback = callback;
    }
    get activePalette() {
        return this._activePalette;
    }
    get colibrioReaderView() {
        return this._colibrioReaderView;
    }
    setReaderDocuments(documents) {
        this._colibrioReaderView.setReaderDocuments(documents);
    }
    getActiveRenderer() {
        return this._colibrioReaderView.getActiveRenderer();
    }
    canPerformPrevious() {
        return this._colibrioReaderView.canPerformPrevious();
    }
    canPerformNext() {
        return this._colibrioReaderView.canPerformNext();
    }
    canPerformGoTo() {
        return this._colibrioReaderView.canPerformGoTo();
    }
    previous() {
        return this._colibrioReaderView.previous();
    }
    next() {
        return this._colibrioReaderView.next();
    }
    goTo(location, options) {
        return this._colibrioReaderView.goTo(location, options);
    }
    goToStart() {
        return this._colibrioReaderView.goToStart();
    }
    isAtStart() {
        return this._colibrioReaderView.isAtStart();
    }
    isAtEnd() {
        return this._colibrioReaderView.isAtEnd();
    }
    isResponsiveRendererSelectionEnabled() {
        return this._colibrioReaderView.isResponsiveRendererSelectionEnabled();
    }
    getReadingPosition() {
        return this._colibrioReaderView.getReadingPosition();
    }
    focusOnReadingPosition(_options) {
        return this._colibrioReaderView.focusOnReadingPosition(_options).catch(()=>{
            console.log("VanillaReaderView.focusOnReadingPosition() failed");
        });
    }
    clearContentSelection() {
        this.colibrioReaderView.clearContentSelection();
    }
    getCurrentVanillaReaderViewOptionsState() {
        let publicationStyleOptions = this.colibrioReaderView.getOptions().publicationStyleOptions;
        const rendererName = this.getActiveRenderer()?.getName();
        const activeRendererName = rendererName && Object.values((0, $652e6cb51d594b1d$export$7ef357ac666ee52)).some((v)=>v === rendererName) ? rendererName : undefined;
        return {
            colibrioReaderViewOptions: {
                publicationStyleOptions: publicationStyleOptions
            },
            ignoreAspectRatio: this.ignoreAspectRatio,
            useReducedMotion: this.useReducedMotion,
            showPageRangesLayer: this.showPageMarkerLayer,
            scrollOverflowingTables: this.scrollOverflowingTables,
            activeRendererTypeName: this.isResponsiveRendererSelectionEnabled() ? (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE : activeRendererName,
            colibrioRendererOptions: this.colibrioReaderView.getActiveRenderer()?.getOptions()
        };
    }
    setActivePalette(palette) {
        this._activePalette = palette;
        this.getActiveRenderer()?.setOptions({
            pageBackgroundColor: palette?.backgroundLight
        });
        this.pageMarkerLayer?.refresh();
    }
    setVanillaReaderViewOptions(viewOptions) {
        if (viewOptions.colibrioRendererOptions) {
            const activeRendererOptions = this.colibrioReaderView.getActiveRenderer()?.getOptions();
            if (!(0, $33027d939f78e552$export$4855211e6b8ad895).deepEqual(activeRendererOptions, viewOptions.colibrioRendererOptions)) this.colibrioReaderView.getActiveRenderer()?.setOptions(viewOptions.colibrioRendererOptions);
        }
        if (viewOptions.useReducedMotion !== undefined && this.useReducedMotion !== viewOptions.useReducedMotion) this.useReducedMotion = viewOptions.useReducedMotion;
        if (viewOptions.ignoreAspectRatio !== undefined && this.ignoreAspectRatio !== viewOptions.ignoreAspectRatio) this.ignoreAspectRatio = viewOptions.ignoreAspectRatio;
        if (viewOptions.scrollOverflowingTables !== undefined && viewOptions.scrollOverflowingTables !== this.scrollOverflowingTables) this.scrollOverflowingTables = viewOptions.scrollOverflowingTables;
        if (viewOptions.activeRendererTypeName !== undefined && this.activeRendererName !== viewOptions.activeRendererTypeName) this.changeRenderer(viewOptions.activeRendererTypeName, this.ignoreAspectRatio);
        if (viewOptions.colibrioReaderViewOptions) {
            let colibrioReaderViewOptions = this.colibrioReaderView.getOptions();
            const colibrioPublicationStyleOptions = colibrioReaderViewOptions.publicationStyleOptions;
            const publicationStyleOptionsHasChanges = !(0, $33027d939f78e552$export$4855211e6b8ad895).deepEqual(colibrioPublicationStyleOptions, viewOptions.colibrioReaderViewOptions.publicationStyleOptions);
            if (colibrioPublicationStyleOptions && publicationStyleOptionsHasChanges) {
                // Only set the active palette data if it's an  object or if it is explicitly set to null
                const paletteViewOption = viewOptions.colibrioReaderViewOptions.publicationStyleOptions?.palette;
                const activePalette = paletteViewOption !== undefined ? paletteViewOption : null;
                const publicationStyleOptions = viewOptions.colibrioReaderViewOptions.publicationStyleOptions || {};
                publicationStyleOptions.palette = activePalette;
                this.setActivePalette(activePalette);
                this.colibrioReaderView.setOptions({
                    publicationStyleOptions: publicationStyleOptions
                });
            }
            // Let's see if we really need to update the Colibrio ReaderViewOptions. As we have already set the
            // publicationStyleOptions already.
            let colibrioReaderViewOptionsClone = JSON.parse(JSON.stringify(colibrioReaderViewOptions));
            delete colibrioReaderViewOptionsClone.publicationStyleOptions;
            delete viewOptions.colibrioReaderViewOptions.publicationStyleOptions;
            const viewOptionsHasChanges = !(0, $33027d939f78e552$export$4855211e6b8ad895).deepEqual(colibrioReaderViewOptionsClone, viewOptions.colibrioReaderViewOptions);
            if (Object.entries(viewOptions.colibrioReaderViewOptions).length > 0 && viewOptionsHasChanges) this.colibrioReaderView.setOptions(viewOptions.colibrioReaderViewOptions);
        }
        this._persistCurrentVanillaReaderOptionsState().then(()=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_OPTIONS_CHANGED", {
                viewOptions: viewOptions
            }));
        }).catch(console.warn);
    }
    getColibrioReaderPublication() {
        return this._colibrioReaderView.getReaderPublications()[0];
    }
    getVanillaReaderPublication() {
        return this._vanillaReaderPublication;
    }
    getVisibleRange() {
        return this._colibrioReaderView.getVisibleRange();
    }
    getPageProgressionTimeline() {
        return this._colibrioReaderView.getPageProgressionTimeline();
    }
    setAllowedGestureTypes(gestureTypes) {
        this._colibrioReaderView.setAllowedGestureTypes(gestureTypes);
    }
    setContentSelection(enabled) {
        this._colibrioReaderView.setContentSelectionEnabled(enabled);
    }
    async fetchVisibleRangeData(navigationTree, readingProgressionTimeline) {
        return this._fetchVisibleRangeData(navigationTree, readingProgressionTimeline);
    }
    async fetchContentPositionDataFromHref(href, baseUrl) {
        let colibrioReaderPubliction = this.getColibrioReaderPublication();
        if (!(0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(colibrioReaderPubliction)) return undefined;
        let contentLocation = await colibrioReaderPubliction.fetchContentLocationFromHref(href, baseUrl);
        if (!contentLocation) {
            console.warn(`VanillaReaderView.fetchContentPositionDataFromHref(), Unable to retrieve ContentLocation for "${baseUrl.href}/${href}" `);
            return;
        }
        return this.fetchContentPositionData(contentLocation);
    }
    createPageMarkerLayer(pageListData) {
        this.pageMarkerLayer = new (0, $91988398b375e795$export$2704a6f5a288a76a)(this, pageListData);
        this.pageMarkerLayer.setVisible(this._showPageMarkerLayer);
    }
    togglePageMarkerLayer(forceState) {
        if (!this.pageMarkerLayer) return;
        if (forceState !== undefined) {
            this.showPageMarkerLayer = forceState;
            return;
        }
        this.showPageMarkerLayer = !this.pageMarkerLayer.isVisible;
    }
    /*
    *
    * Change the current renderer for a new renderer instance that matches the `rendererName` argument.
    * Have a look at the `VanillaReaderRendererNames` enum to see all the available renderers.
    *
    * */ changeRenderer(rendererName, ignoreAspectRatio) {
        if (this._colibrioReaderView) {
            // If the selected renderer name is not set to our `RESPONSIVE` flag we explicitly set the new renderer.
            // If is set to responsive however, we let the reader view take care of things for us.
            if (rendererName !== (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE) {
                if (Object.values((0, $652e6cb51d594b1d$export$7ef357ac666ee52)).includes(rendererName)) {
                    let renderer = this._colibrioReaderView.getRendererByName(rendererName);
                    if (renderer) {
                        if (rendererName != (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL) {
                            // If the renderer is paginated we should take care to use the set the `disableAnimations`
                            // so that the `_useReducedMotion` value is respected by the new renderer.
                            let paginatedRendererOptions = {
                                disableAnimations: this._initialVanillaReaderViewOptions?.useReducedMotion,
                                ignoreAspectRatio: ignoreAspectRatio
                            };
                            renderer.setOptions(paginatedRendererOptions);
                        }
                        this._colibrioReaderView.setResponsiveRendererSelectionEnabled(false);
                        this._colibrioReaderView.setActiveRenderer(renderer);
                        this.changeRendererAspectRatio(ignoreAspectRatio);
                    } else console.error('VanillaReader.changeRenderer: Renderer name "' + rendererName + '" does not exist');
                } else console.error('VanillaReader.changeRenderer: Renderer name "' + rendererName + '" does not exist');
            } else {
                // The rendererName matches`VanillaReaderRendererNames.RESPONSIVE`, this is our flag to we let Colibrio
                // find the best renderer based on the options we specified in the `_createRenderers` method.
                this._colibrioReaderView.setResponsiveRendererSelectionEnabled(true);
                this.changeRendererAspectRatio(ignoreAspectRatio);
                this.refresh(true);
            }
        } else console.warn("VanillaReader.changeRenderer(): There is no _colibrioReaderView instance, is the current publication an audiobook perhaps? ");
    }
    /*
    *
    * Set the `ignoreAspectRatio` specifically. This makes the `IReaderView` ignore the width and height that the
    * publication has defined and will take up all available space.
    *
    * */ changeRendererAspectRatio(ignore = false) {
        if (this._colibrioReaderView) this.ignoreAspectRatio = ignore;
        else console.warn("VanillaReader.changeRenderer(): There is no _colibrioReaderView instance, is the current publication an audiobook perhaps? ");
    }
    /**
     *
     * Refresh the `_colibrioReaderView`. You need to do this after changing view options in order for them to take effect.
     *
     * */ refresh(force = false) {
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_WILL_REFRESH", {}));
        this._colibrioReaderView?.refresh(force);
    }
    /*
    *
    * This utility method checks if the content that is currently visible on the screen is the first
    * content available in the publication.
    *
    * */ async visibleRangeIsAtStartOfPublication() {
        const visibleRange = this._colibrioReaderView?.getVisibleRange();
        const colibrioReaderPublication = this._vanillaReaderReadingSystem.getColibrioReaderPublication();
        let locator = visibleRange?.getLocator();
        if (visibleRange && locator) {
            const visibleRangeStart = visibleRange.collapseToStart();
            const firstReaderDocumentInPublication = colibrioReaderPublication?.getSpine()[0];
            const firstReaderDocumentContentLocation = await firstReaderDocumentInPublication?.fetchContentLocationForEntireDocument();
            const firstReaderDocumentStart = firstReaderDocumentContentLocation?.collapseToStart();
            return firstReaderDocumentStart?.equals(visibleRangeStart) || false;
        } else {
            console.warn("VanillaReader.readingPositionIsAtStartOfPublication(): Could not resolve a locator or visibleRange.");
            return false;
        }
    }
    /*
    *
    * This utility method checks if the content that is currently visible on the screen is the last
    * content available in the publication.
    *
    * */ async visibleRangeIsAtEndOfPublication() {
        const visibleRange = this._colibrioReaderView?.getVisibleRange();
        const colibrioReaderPublication = this._vanillaReaderReadingSystem.getColibrioReaderPublication();
        let locator = visibleRange?.getLocator();
        if (visibleRange && locator) {
            const visibleRangeEnd = visibleRange.collapseToEnd();
            const readerPublicationLength = colibrioReaderPublication.getSpine().length || 0;
            const lastReaderDocumentInPublication = colibrioReaderPublication.getSpine()[readerPublicationLength - 1];
            const lastReaderDocumentContentLocation = await lastReaderDocumentInPublication?.fetchContentLocationForEntireDocument();
            const lastReaderDocumentEnd = lastReaderDocumentContentLocation?.collapseToEnd();
            return lastReaderDocumentEnd?.equals(visibleRangeEnd) || false;
        } else {
            console.warn("VanillaReader.readingPositionIsAtEndOfPublication(): Could not resolve a locator or visibleRange.");
            return false;
        }
    }
    /*
    *
    * This utility method checks if the content that is currently visible is at the very start of the content document.
    * In other words that the start `IContentLocation` of the visible range is equal to the start IContentLocation` of
    * the entire document.
    *
    * */ async visibleRangeIsAtStartOfDocument() {
        const visibleRange = this._colibrioReaderView?.getVisibleRange();
        let locator = visibleRange?.getLocator();
        if (visibleRange && locator) {
            const visibleRangeStart = visibleRange.collapseToStart();
            const visibleRangeEnd = visibleRange.collapseToEnd();
            const visibleReaderDocument = visibleRangeEnd.getReaderDocuments()[0];
            const visibleReaderDocumentContentLocation = await visibleReaderDocument.fetchContentLocationForEntireDocument();
            const visibleReaderDocumentStart = visibleReaderDocumentContentLocation.collapseToStart();
            return visibleReaderDocumentStart.equals(visibleRangeStart);
        } else {
            console.warn("VanillaReader.readingPositionIsAtStartOfDocument(): Could not resolve a locator or visibleRange.");
            return false;
        }
    }
    /*
    *
    * This utility method checks if the content that is currently visible is at the very end of the content document.
    * In other words that the end `IContentLocation` of the visible range is equal to the end IContentLocation` of
    * the entire document.
    *
    * */ async visibleRangeIsAtEndOfDocument() {
        const visibleRange = this._colibrioReaderView?.getVisibleRange();
        let locator = visibleRange?.getLocator();
        if (visibleRange && locator) {
            const visibleRangeEnd = visibleRange.collapseToEnd();
            const visibleReaderDocument = visibleRangeEnd.getReaderDocuments()[0];
            const visibleReaderDocumentContentLocation = await visibleReaderDocument.fetchContentLocationForEntireDocument();
            const visibleReaderDocumentEnd = visibleReaderDocumentContentLocation.collapseToEnd();
            return visibleReaderDocumentEnd.equals(visibleRangeEnd);
        } else {
            console.warn("VanillaReader.readingPositionIsAtEndOfDocument(): Could not resolve a locator or visibleRange.");
            return false;
        }
    }
    async getReadingPositionData() {
        const readingPosition = this?.getReadingPosition();
        if (!readingPosition) return;
        return this.fetchContentPositionData(readingPosition);
    }
    async fetchVisibleContentRectDataForContentLocation(contentLocation) {
        if (!this._currentVisibleContentRects) {
            await this.updateAndFetchVisibleContentRects();
            if (!this._currentVisibleContentRects) {
                console.log("VanillaReaderView.fetchVisibleContentRectDataForContentLocation(), this._currentVisibleContentRects is undefined.");
                return [];
            }
        }
        let matchingVisibleContentRects = this._currentVisibleContentRects.filter((rect)=>{
            return rect.contentLocation.intersects(contentLocation);
        });
        if (matchingVisibleContentRects.length === 0) {
            let nextContentRect = this._currentVisibleContentRects.find((rect)=>{
                return rect.contentLocation.isAfter(contentLocation);
            });
            matchingVisibleContentRects = nextContentRect ? [
                nextContentRect
            ] : [];
        }
        return matchingVisibleContentRects.map((rect)=>rect.toJSON());
    }
    async updateAndFetchVisibleContentRects() {
        this._currentVisibleContentRects = undefined;
        let contentPositionClientRects = [];
        const pages = this._colibrioReaderView.getVisiblePages();
        for (const page of pages){
            let locationRectsResult = await this._colibrioReaderView.fetchRectsForVisibleContent(page, undefined, {
                includeNodeData: true
            });
            if (locationRectsResult.rects.length > 0) contentPositionClientRects.push(...locationRectsResult.rects);
        }
        this._currentVisibleContentRects = contentPositionClientRects;
        return contentPositionClientRects;
    }
    async fetchContentPositionData(contentLocation) {
        if (!contentLocation) return undefined;
        const navigationItems = await contentLocation.fetchNavigationItemReferences({
            greedy: true,
            collectionTypes: [
                (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC,
                (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).LANDMARKS,
                (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).PAGE_LIST
            ]
        });
        const navigationItemsData = navigationItems.getItemsInRange()?.map((item)=>{
            return {
                title: item.getNavigationItem().getTextContent(),
                collectionType: item.getNavigationCollection().getType(),
                children: [],
                locator: item.getNavigationItem().getLocator()?.toString()
            };
        });
        const contentBlockTargets = await contentLocation.fetchContentBlockTargets((0, $f8f5cf2c043414f4$export$4d9b0aff04ca78b4).INTERSECTING_OR_NEAREST_AFTER);
        let contentPositionClientRects = await this.fetchVisibleContentRectDataForContentLocation(contentLocation) || [];
        let syntheticPageData = await this._vanillaReaderPublication.pageList?.fetchPagesForLocator(contentLocation.getLocator());
        return {
            publicationId: this._vanillaReaderPublication.id,
            documentIndex: contentLocation.getReaderDocuments()[0].getSourceContentDocument().getIndexInSpine(),
            locator: contentLocation.getLocator().toString(),
            contentBlockData: contentBlockTargets.length > 0 ? contentBlockTargets[0].getContentBlock().toSerializableData({
                createLocators: true,
                recursive: false
            }) : undefined,
            navItemData: navigationItemsData,
            timestamp: Date.now(),
            contentRects: contentPositionClientRects,
            syntheticPageData: syntheticPageData
        };
    }
    renderBookmarks(bookmarkData) {
        this.bookmarksLayer?.loadBookmarks(bookmarkData);
    }
    renderHighlights(highlightData) {
        this.highlightsLayer?.loadHighlights(highlightData);
    }
    /*
    *
    * This property controls if the `VanillaReader` should take care to not use too many UI animations.
    * As you can see in the setter we toggle off the renderer transition animations if `useReducedMotion` is set to true.
    * */ get useReducedMotion() {
        return this._useReducedMotion;
    }
    set useReducedMotion(useReducedMotion) {
        if (this.useReducedMotion === useReducedMotion) return;
        this._useReducedMotion = useReducedMotion;
        if (this._colibrioReaderView) {
            // Casting to unknown because otherwise TS would not narrow the type from IRenderer
            const activeRenderer = this.colibrioReaderView.getActiveRenderer();
            if ($9ff050ad3115202b$export$b034d7788f93e3ea.isPaginatedRenderer(activeRenderer)) activeRenderer.setOptions({
                disableAnimations: useReducedMotion
            });
        }
        if (this._onReducedMotionValueChangedCallback) this._onReducedMotionValueChangedCallback(useReducedMotion);
        this.refresh(true);
    }
    get scrollOverflowingTables() {
        return this._scrollOverflowingTables;
    }
    set scrollOverflowingTables(scrollOverflowingTables) {
        if (this._scrollOverflowingTables === scrollOverflowingTables) return;
        this._scrollOverflowingTables = scrollOverflowingTables;
        let readerPublication = this.getColibrioReaderPublication();
        if ((0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(readerPublication)) {
            let activeOptions = readerPublication.getOptions();
            let blacklistedSelectors = activeOptions.reflowOptions.plugins.fragmentableElements.blacklistSelectors;
            if (scrollOverflowingTables === true && !blacklistedSelectors.includes("table")) {
                blacklistedSelectors.push("table");
                activeOptions.reflowOptions.plugins.fragmentableElements.blacklistSelectors = blacklistedSelectors;
            } else {
                let updatedBlacklist = blacklistedSelectors.filter((selector)=>{
                    return selector !== "table";
                });
                activeOptions.reflowOptions.plugins.fragmentableElements.blacklistSelectors = updatedBlacklist;
            }
            this._vanillaReaderPublication.setPublicationOptions(activeOptions);
            this.refresh(true);
        }
    }
    get ignoreAspectRatio() {
        return this._ignoreAspectRatio;
    }
    set ignoreAspectRatio(preference) {
        if (preference === this.ignoreAspectRatio) return;
        this._ignoreAspectRatio = preference;
        if (this._colibrioReaderView) this.colibrioReaderView.getActiveRenderer()?.setOptions({
            ignoreAspectRatio: preference
        });
        if (this._onIgnoreAspectRatioValueChangedCallback) this._onIgnoreAspectRatioValueChangedCallback(preference);
        this.refresh(true);
    }
    get showPageMarkerLayer() {
        return this._showPageMarkerLayer;
    }
    set showPageMarkerLayer(showPageMarkerLayer) {
        if (this._showPageMarkerLayer === showPageMarkerLayer) return;
        this._showPageMarkerLayer = showPageMarkerLayer;
        this.pageMarkerLayer?.setVisible(showPageMarkerLayer);
    }
    get activeRendererName() {
        let activeRendererName = this.isResponsiveRendererSelectionEnabled() ? (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE : this.getActiveRenderer()?.getName();
        return activeRendererName;
    }
    resetViewTransformation() {
        const colibrioTransformManager = this._colibrioReaderView.getTransformManager();
        colibrioTransformManager?.removeActiveTransform().catch(console.warn);
    }
    async zoomToClientRect(zoomRect, animate = true) {
        const colibrioTransformManager = this._colibrioReaderView.getTransformManager();
        if (!colibrioTransformManager.canTransform()) {
            console.warn("VanillaReaderView.zoomToClientRect(), ReaderView is not in Transform state.");
            return null;
        }
        let transformedPublicationClientRects = this.getVisiblePagesBoundingClientRects();
        let publicationViewportScale = this._getPublicationViewportScale(this._initialPublicationViewportRects, transformedPublicationClientRects);
        this._setActiveTransformData({
            transformData: this.activeTransformData?.transformData,
            visiblePageClientRects: this.activeTransformData?.visiblePageClientRects || [],
            zoomTargetClientRect: zoomRect,
            publicationViewportScale: publicationViewportScale
        });
        await colibrioTransformManager.zoomToClientRect(zoomRect, {
            animationOptions: {
                durationMs: animate ? this._defaultAnimationDuration : 0,
                easing: (0, $f8f5cf2c043414f4$export$7d260260b1058ee8).MATERIAL_DECELERATION_CURVE
            }
        });
        let transformData = colibrioTransformManager.getActiveTransform() || undefined;
        transformedPublicationClientRects = this.getVisiblePagesBoundingClientRects();
        publicationViewportScale = this._getPublicationViewportScale(this._initialPublicationViewportRects, transformedPublicationClientRects);
        this._setActiveTransformData({
            transformData: transformData,
            visiblePageClientRects: this.getVisiblePagesBoundingClientRects(),
            zoomTargetClientRect: zoomRect,
            publicationViewportScale: publicationViewportScale
        });
        return this.activeTransformData;
    }
    async zoomToPublicationViewportRect(rect, unit, options) {
        const colibrioTransformManager = this._colibrioReaderView.getTransformManager();
        if (!colibrioTransformManager) {
            console.warn("VanillaReaderView.zoomToPublicationViewportRect(), ReaderView is not in Transform state.");
            return undefined;
        }
        let transformedPublicationClientRects = this.getVisiblePagesBoundingClientRects();
        let publicationViewportScale = this._getPublicationViewportScale(this._initialPublicationViewportRects, transformedPublicationClientRects);
        this._setActiveTransformData({
            transformData: this.activeTransformData?.transformData,
            visiblePageClientRects: this.activeTransformData?.visiblePageClientRects || [],
            zoomTargetClientRect: rect,
            publicationViewportScale: publicationViewportScale
        });
        let domRect = new DOMRect(rect.x, rect.y, rect.width, rect.height);
        await colibrioTransformManager.zoomToPublicationViewportRect(domRect, unit, {
            animationOptions: {
                durationMs: options.animationOptions?.durationMs ?? this._defaultAnimationDuration,
                easing: (0, $f8f5cf2c043414f4$export$7d260260b1058ee8).MATERIAL_DECELERATION_CURVE
            }
        });
        let transformData = colibrioTransformManager.getActiveTransform() || undefined;
        transformedPublicationClientRects = this.getVisiblePagesBoundingClientRects();
        publicationViewportScale = this._getPublicationViewportScale(this._initialPublicationViewportRects, transformedPublicationClientRects);
        this._setActiveTransformData({
            transformData: transformData,
            visiblePageClientRects: this.getVisiblePagesBoundingClientRects(),
            zoomTargetClientRect: rect,
            publicationViewportScale: publicationViewportScale
        });
    }
    async zoomToPublicationViewportPosition(x, y, unit, scale, options) {
        const colibrioTransformManager = this._colibrioReaderView.getTransformManager();
        if (!colibrioTransformManager) {
            console.warn("VanillaReaderView.zoomToPublicationViewportPosition(), ReaderView is not in Transform state.");
            return null;
        }
        await colibrioTransformManager.zoomToPublicationViewportPosition({
            unit: unit,
            value: x
        }, {
            unit: unit,
            value: y
        }, scale, options);
        return colibrioTransformManager.getActiveTransform();
    }
    async zoomToLevel(zoomLevel, animate = true) {
        const colibrioTransformManager = this._colibrioReaderView.getTransformManager();
        if (!colibrioTransformManager) {
            console.warn("VanillaReaderView.zoomToClientRect(), ReaderView is not in Transform state.");
            return null;
        }
        let viewElementBoundingBox = this._readerViewElement.getBoundingClientRect();
        let clientX = viewElementBoundingBox.left + viewElementBoundingBox.width / 2;
        let clientY = viewElementBoundingBox.top + viewElementBoundingBox.height / 2;
        await colibrioTransformManager.zoomToClientPosition(clientX, clientY, zoomLevel, {
            durationMs: animate ? this._defaultAnimationDuration : 0,
            easing: (0, $f8f5cf2c043414f4$export$7d260260b1058ee8).MATERIAL_DECELERATION_CURVE
        });
        return colibrioTransformManager.getActiveTransform();
    }
    getPublicationViewportBoundingClientRect() {
        let visiblePages = this._colibrioReaderView.getVisiblePages();
        if (visiblePages.length < 1) {
            console.warn("VanillaReaderView.getPublicationViewportBoundingClientRect(), IReaderView.getVisiblePages returned an empty array.");
            return;
        }
        let minX = Infinity;
        let minY = Infinity;
        let maxX = 0;
        let maxY = 0;
        for (let page of visiblePages){
            let rect = page.getBoundingClientRect();
            if (!rect) {
                console.warn("VanillaReaderView.getPublicationViewportBoundingClientRect(), page.getBoundingClientRect() returned null.");
                continue;
            }
            minX = Math.min(rect.x, minX);
            minY = Math.min(rect.y, minY);
            maxY = Math.max(Math.abs(rect.x) + rect.width, maxY);
            maxX = Math.max(rect.height, maxX);
        }
        if (minX === Infinity || minY === Infinity) {
            console.warn("VanillaReaderView.getPublicationViewportBoundingClientRect(), Unable to get bounding client rects from visible pages.");
            return;
        }
        return {
            x: minX,
            y: minY,
            width: maxY,
            height: maxX
        };
    }
    getVisiblePagesBoundingClientRects() {
        let visiblePages = this._colibrioReaderView.getVisiblePages();
        let rects = [];
        if (visiblePages.length < 1) {
            console.warn("VanillaReaderView.getVisiblePagesBoundingClientRects(), IReaderView.getVisiblePages returned an empty array.");
            return [];
        }
        for (let page of visiblePages){
            let rect = page.getBoundingClientRect();
            if (!rect) {
                console.warn("VanillaReaderView.getVisiblePagesBoundingClientRects(), page.getBoundingClientRect() returned null.");
                continue;
            }
            rects.push(rect);
        }
        return rects;
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ _getPublicationViewportScale(initialRects, transformedRects) {
        return initialRects.length >= 0 && transformedRects.length > 0 ? transformedRects[0].width / initialRects[0].width : 1;
    }
    _setActiveTransformData(data) {
        this._activeTransformData = {
            transformData: data?.transformData,
            visiblePageClientRects: data?.visiblePageClientRects || [],
            zoomTargetClientRect: data?.zoomTargetClientRect,
            publicationViewportScale: data?.publicationViewportScale || 1
        };
        return this.activeTransformData;
    }
    async _fetchVisibleRangeData(navigationTree, readingProgressionTimeline) {
        const visibleRange = this._colibrioReaderView?.getVisibleRange();
        let locator = visibleRange?.getLocator();
        if (!visibleRange || !locator) return undefined;
        let timelineRange;
        let readingProgression;
        let rangeTimelineStartPosition;
        let rangeTimelineEndPosition;
        if (readingProgressionTimeline) {
            rangeTimelineStartPosition = await readingProgressionTimeline.fetchTimelinePosition(visibleRange.collapseToStart().getLocator());
            rangeTimelineEndPosition = await readingProgressionTimeline.fetchTimelinePosition(visibleRange.collapseToEnd().getLocator());
            readingProgression = rangeTimelineStartPosition ? rangeTimelineStartPosition / readingProgressionTimeline.getLength() : undefined;
            if (rangeTimelineStartPosition && rangeTimelineEndPosition) timelineRange = {
                start: rangeTimelineStartPosition,
                end: rangeTimelineEndPosition
            };
        }
        let navItems = [];
        let navItemRefs = await navigationTree?.fetchItemsInVisibleRange([
            (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC,
            (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).PAGE_LIST,
            (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).LANDMARKS
        ], true, this);
        navItemRefs?.forEach((ref)=>{
            navItems.push({
                locator: ref.getNavigationItem()?.getLocator()?.toString(),
                children: [],
                collectionType: ref.getNavigationCollection().getType(),
                title: ref.getNavigationItem().getTextContent()
            });
        });
        // Check if the start / of the visible range is at the start or end of the reader document, and if so send
        // events.
        // If the visible range has changed while we were fetching the ContentLocation we'll get a new event with more up-to-date data, so we can just return here.
        if (visibleRange !== this._colibrioReaderView?.getVisibleRange()) return undefined;
        let publicationIsAtStart = await this.visibleRangeIsAtStartOfPublication();
        let publicationIsAtEnd = await this.visibleRangeIsAtEndOfPublication();
        let documentIsAtStart = await this.visibleRangeIsAtStartOfDocument();
        let documentIsAtEnd = await this.visibleRangeIsAtEndOfDocument();
        let visibleContentRects = [];
        for (const page of this._colibrioReaderView.getVisiblePages())visibleContentRects = await this.fetchVisibleContentRectDataForContentLocation(page.getRangeContentLocation());
        let contentResolverForVisibleContent = await visibleRange.fetchContentResolver();
        let visibleTextContent = contentResolverForVisibleContent.getTextContent();
        return {
            locator: locator,
            timelinePosition: rangeTimelineStartPosition,
            timelineRange: timelineRange,
            readingProgression: readingProgression,
            bookmarks: this.bookmarksLayer?.getBookmarksInVisibleRange() || [],
            highlights: this.highlightsLayer?.getHighlightsInVisibleRange() || [],
            navItems: navItems || [],
            documentIsAtStart: documentIsAtStart,
            documentIsAtEnd: documentIsAtEnd,
            publicationIsAtStart: publicationIsAtStart,
            publicationIsAtEnd: publicationIsAtEnd,
            visibleTextContent: visibleTextContent,
            visibleContentRects: visibleContentRects
        };
    }
    /**
     *
     * The _persistCurrentVanillaReaderOptionsState method retrieves the current active view options and persists them using the
     * `IVanillaReaderOptionsDataStore` instance.
     *
     * */ _persistCurrentVanillaReaderOptionsState() {
        const viewOptions = this.getCurrentVanillaReaderViewOptionsState();
        return this._vanillaReaderOptionsDataStore.setVanillaReaderOptionsData({
            dateCreated: Date.now(),
            viewOptions: viewOptions
        });
    }
    /*
     *
     * _createRenderers creates the default `IReaderView` instance for the Vanilla Reader. It also sets some default
     * view settings, and adds a number of renderers.
     *
     * For audiobooks that have no traditional view, please have a look at the _createAudiobookView method.
     *
     * */ _createRenderers(colibrioReaderView) {
        // Grab the background color to use for the renderer from the initial options
        let rendererBackgroundColor = this._activePalette?.backgroundLight;
        /*
        *
        * ## A note about Renderers
        *
        * How a book is presented to the user is determined by what kind of `IRenderer` type that is currently set as
        * active in the `IReaderView`.
        *
        * Each type of renderer has different options that affects properties such as if the renderer should keep the
        * aspect ratio defined in the publication, if it should animate to the next / previous page, if it should show
        * a shadow behind the page or spread etc. etc.
        *
        * A handy feature that is also supported by the reader view is that it can choose a fitting renderer based on
        * so called `ResponsiveViewRule` objects. These are defined using the same syntax as CSS Media Queries and
        * saves you the trouble of manually switching renderer from the UI.
        *
        * */ const colibrioFlipBookRenderer = new (0, $ec828051165c5b2b$export$368c10b5be12ad52)({
            name: (0, $652e6cb51d594b1d$export$7ef357ac666ee52).FLIPBOOK,
            ignoreAspectRatio: this._initialVanillaReaderViewOptions?.ignoreAspectRatio,
            disableAnimations: this._initialVanillaReaderViewOptions?.useReducedMotion,
            pageBackgroundColor: rendererBackgroundColor
        });
        const colibrioStackRenderer = new (0, $ec828051165c5b2b$export$4ec853217c7f0f57)({
            name: (0, $652e6cb51d594b1d$export$7ef357ac666ee52).STACK,
            pageBackgroundColor: rendererBackgroundColor
        });
        const colibrioStackRendererMobile = new (0, $ec828051165c5b2b$export$4ec853217c7f0f57)();
        colibrioStackRendererMobile.setOptions({
            name: (0, $652e6cb51d594b1d$export$7ef357ac666ee52).STACK,
            showRendererBackgroundShadow: false,
            ignoreAspectRatio: true,
            disableAnimations: this._initialVanillaReaderViewOptions?.useReducedMotion,
            pageBackgroundColor: rendererBackgroundColor
        });
        const colibrioSwipeRendererSingle = new (0, $ec828051165c5b2b$export$865a8bfa7a5da5e3)({
            name: (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SWIPE_SINGLE,
            ignoreAspectRatio: this._initialVanillaReaderViewOptions?.ignoreAspectRatio,
            disableAnimations: this._initialVanillaReaderViewOptions?.useReducedMotion,
            pageBackgroundColor: rendererBackgroundColor
        });
        const colibrioSwipeRendererSpread = new (0, $ec828051165c5b2b$export$3775ca37f4bb8a58)({
            name: (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SWIPE_SPREAD,
            ignoreAspectRatio: this._initialVanillaReaderViewOptions?.ignoreAspectRatio,
            disableAnimations: this._initialVanillaReaderViewOptions?.useReducedMotion,
            pageBackgroundColor: rendererBackgroundColor
        });
        const colibrioScrollRenderer = new (0, $ec828051165c5b2b$export$c122e6b15f2d3706)({
            name: (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL,
            ignoreAspectRatio: this._initialVanillaReaderViewOptions?.ignoreAspectRatio,
            readingAreaOffsetTop: {
                value: 5,
                unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT
            },
            pageBackgroundColor: rendererBackgroundColor
        });
        // Use the flip book renderer for all screens wider than 600px that are in landscape mode
        colibrioReaderView.addRenderer(colibrioFlipBookRenderer, new (0, $6978732dc0bb5e4e$export$579d6fbe4efb400e)("(orientation: landscape) and (min-width: 600px)"));
        // Use the stack renderer for all screens wider than 450px, but narrower than 600px
        colibrioReaderView.addRenderer(colibrioStackRenderer, new (0, $6978732dc0bb5e4e$export$579d6fbe4efb400e)("(min-width: 450px)"));
        // Use the stack renderer without background shadow, and ignoring the publication aspect ratio for all screens
        // narrower than 450px
        colibrioReaderView.addRenderer(colibrioStackRendererMobile, new (0, $6978732dc0bb5e4e$export$579d6fbe4efb400e)("(max-width: 450px)"));
        colibrioReaderView.addRenderer(colibrioSwipeRendererSingle);
        colibrioReaderView.addRenderer(colibrioSwipeRendererSpread);
        colibrioReaderView.addRenderer(colibrioScrollRenderer);
    }
    _setupBookmarkLayerCallbacks(bookmarksLayer) {
        bookmarksLayer.onBookmarkClick((ev)=>{
            let locator = ev.annotation.getLocator();
            if (locator) {
                let bookmark = bookmarksLayer.getBookmark(locator.toString());
                if (bookmark) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARK_CLICKED", {
                    bookmark: bookmark
                }));
            }
        });
        bookmarksLayer.onBookmarkEnterView((bookmark)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARK_IN_VISIBLE_RANGE", {
                bookmark: bookmark
            }));
        });
        bookmarksLayer.onBookmarkExitView((bookmark)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARK_OUTSIDE_VISIBLE_RANGE", {
                bookmark: bookmark
            }));
        });
    }
    _setupHighlightLayerCallbacks(highlightsLayer) {
        highlightsLayer.onHighlightContextMenu((event)=>{
            let highlight = event.annotation.getCustomData();
            if (highlight && $9ff050ad3115202b$export$b034d7788f93e3ea.isVanillaReaderHighlightData(highlight)) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHT_CLICKED", {
                highlight: highlight
            }));
        });
        highlightsLayer.onHighlightAdded(()=>{
            this._colibrioReaderView?.clearContentSelection();
        });
        highlightsLayer.onHighlightEnterView((highlight)=>{
            if (highlight) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHT_IN_VISIBLE_RANGE", {
                highlight: highlight
            }));
        });
        highlightsLayer.onHighlightExitView((highlight)=>{
            if (highlight) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHT_OUTSIDE_VISIBLE_RANGE", {
                highlight: highlight
            }));
        });
    }
    static isVanillaReaderHighlightData(customData) {
        return "selectionText" in customData;
    }
    static isPaginatedRenderer(activeRenderer) {
        return activeRenderer instanceof (0, $ec828051165c5b2b$export$4ec853217c7f0f57) || activeRenderer instanceof (0, $ec828051165c5b2b$export$368c10b5be12ad52) || activeRenderer instanceof (0, $ec828051165c5b2b$export$865a8bfa7a5da5e3) || activeRenderer instanceof (0, $ec828051165c5b2b$export$3775ca37f4bb8a58);
    }
}






class $ba8410d8a7579ed8$export$427f316d5d7b1929 {
    constructor(_vanillaReaderView, _vanillaPublication, _initialState, _buildProgressCallback){
        this._vanillaReaderView = _vanillaReaderView;
        this._vanillaPublication = _vanillaPublication;
        this._initialState = _initialState;
        this._buildProgressCallback = _buildProgressCallback;
        this._timelineReadyCallback = undefined;
        this._timelinePositionUpdatedCallback = undefined;
        this._timelineData = null;
        this._colibrioReaderPublication = this._vanillaPublication.getColibrioReaderPublication();
    }
    static async create(vanillaReaderView, vanillaPublication, initialState, buildProgressCallback) {
        const instance = new $ba8410d8a7579ed8$export$427f316d5d7b1929(vanillaReaderView, vanillaPublication, initialState, buildProgressCallback);
        return instance._setup().catch(console.warn).then(()=>instance);
    }
    async _setup() {
        this._vanillaReaderView.setVanillaReaderViewOptions({
            colibrioReaderViewOptions: {
                pageProgressionTimelineOptions: {
                    enabled: false
                }
            }
        });
        this._colibrioTimelineInstance = await this._buildTimeline(this._colibrioReaderPublication, this._initialState, this._buildProgressCallback);
        let documentContentLocations = await this._fetchDocumentPositionData(this._colibrioTimelineInstance);
        this._timelineData = {
            length: this._colibrioTimelineInstance.getLength(),
            unit: this._colibrioTimelineInstance.getUnit(),
            sections: documentContentLocations
        };
        if (this._timelineReadyCallback) this._timelineReadyCallback(this._timelineData);
    }
    async serialize() {
        if (!this._colibrioTimelineInstance) {
            console.warn("VanillaReaderProgressionTimeline.serialize(), No content position timeline instance available. Have you ");
            return;
        }
        let documentContentLocations = await this._fetchDocumentPositionData(this._colibrioTimelineInstance);
        return {
            length: this._colibrioTimelineInstance.getLength(),
            unit: this._colibrioTimelineInstance.getUnit(),
            sections: documentContentLocations
        };
    }
    onTimelineReady(callback) {
        this._timelineReadyCallback = callback;
        if (this._colibrioTimelineInstance && this._timelineData) callback(this._timelineData);
    }
    onTimelinePositionUpdated(callback) {
        this._timelinePositionUpdatedCallback = callback;
    }
    isReady() {
        return this._colibrioTimelineInstance !== null && this._colibrioTimelineInstance !== undefined;
    }
    async fetchContentLocation(timelinePosition) {
        if (!this._colibrioTimelineInstance) return undefined;
        return this._colibrioTimelineInstance?.fetchContentLocation(timelinePosition);
    }
    async fetchTimelinePosition(location) {
        if (!this._colibrioTimelineInstance) return undefined;
        return this._colibrioTimelineInstance?.fetchTimelinePosition(location);
    }
    async fetchTimelineRange(location) {
        return this._colibrioTimelineInstance?.fetchTimelineRange(location);
    }
    async fetchContentLocationAsRange(start, end) {
        return this._colibrioTimelineInstance.fetchContentLocationAsRange(start, end);
    }
    getLength() {
        return this._colibrioTimelineInstance.getLength() || 0;
    }
    updateTimelinePosition(locator) {
        const updateFn = async ()=>{
            if (this._colibrioTimelineInstance && locator) {
                let position = await this.fetchTimelinePosition(locator);
                if (this._timelinePositionUpdatedCallback && position !== undefined) this._timelinePositionUpdatedCallback(position);
            }
        };
        if (!this._colibrioTimelineInstance) (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("TIMELINE_READY", updateFn, true);
        else updateFn().catch(console.error);
    }
    getBackingTimelineImplementation() {
        return this._colibrioTimelineInstance;
    }
    toSerializedData() {
        return this._colibrioTimelineInstance.toSerializedData();
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ async _fetchDocumentPositionData(timeline) {
        let documents = this._colibrioReaderPublication.getSpine();
        let documentContentLocations = [];
        for (let doc of documents){
            let contentLocation = await doc.fetchContentLocationForEntireDocument();
            let contentPositionData = await this._vanillaReaderView.fetchContentPositionData(contentLocation);
            if (contentPositionData && contentPositionData.locator) {
                let startPosition = await timeline.fetchTimelinePosition(contentLocation.collapseToStart());
                let endPosition = await timeline.fetchTimelinePosition(contentLocation.collapseToEnd());
                documentContentLocations.push({
                    contentPositionData: contentPositionData,
                    range: {
                        start: startPosition,
                        end: endPosition
                    }
                });
            }
        }
        return documentContentLocations;
    }
    async _buildTimeline(colibrioReaderPublication, state, callback) {
        let timelinePromise;
        if ((0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(colibrioReaderPublication)) {
            let timelineOptions;
            if (colibrioReaderPublication.getAvailableContentPositionTimelineUnits().includes((0, $f8f5cf2c043414f4$export$45587b7b78af24ff).PAGES)) timelineOptions = {
                unit: (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).PAGES
            };
            else timelineOptions = {
                unit: (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).WORDS
            };
            timelineOptions.serializedData = state;
            timelinePromise = colibrioReaderPublication.createContentPositionTimeline(colibrioReaderPublication.getSpine(), timelineOptions, callback);
        } else if ((0, $98c664707733d94d$export$d4671a61002987ce).isPdfReaderPublication(colibrioReaderPublication)) {
            let timelineOptions = {
                unit: (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).PAGES,
                serializedData: state
            };
            timelinePromise = colibrioReaderPublication.createContentPositionTimeline(colibrioReaderPublication.getSpine(), timelineOptions, callback);
        } else timelinePromise = Promise.reject("Not an EPUB or PDF");
        return timelinePromise;
    }
}




class $0771c0f7ebac4abb$export$176db2ff6977fb36 {
    constructor(_colibrioReaderPublication, _colibrioReaderView){
        this._colibrioReaderPublication = _colibrioReaderPublication;
        this._colibrioReaderView = _colibrioReaderView;
        this._colibrioReadingSystemEngine = this._colibrioReaderPublication.getReadingSystemEngine();
        this._colibrioReaderViewAnnotationLayer = this._colibrioReaderView.createAnnotationLayer("vanilla-reader__publication-search-results");
        this._colibrioReaderViewAnnotationLayer.setLayerOptions({
            layerStyle: {
                "mix-blend-mode": "multiply"
            }
        });
        this._colibrioReaderViewAnnotationLayer.setDefaultAnnotationOptions({
            rangeStyle: {
                backgroundColor: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow
            }
        });
        this._colibrioDocumentSearch = this._colibrioReadingSystemEngine.getReaderDocumentSearch();
        this._colibrioReaderViewSearchAgent = this._colibrioDocumentSearch.createReaderViewSearchAgent(this._colibrioReaderViewAnnotationLayer);
    }
    get hasIndexData() {
        return true;
    }
    createIndex(_progressCallback) {
        const readerPublication = this._colibrioReaderView.getReaderPublications()[0];
        const metadata = readerPublication ? readerPublication.getSourcePublication().getMetadata().getAll() : [];
        return Promise.resolve({
            documents: [],
            publicationIndexedTextLength: 0,
            hashSignature: readerPublication.getSourcePublication().getHashSignature().toString(),
            metadata: metadata
        });
    }
    async search(searchText, resultLimit, padding = 50, documentIndexes) {
        return this._search(searchText, resultLimit, padding, documentIndexes, false);
    }
    clearSearch() {
        this._colibrioReaderViewSearchAgent?.setSearchQuery(null);
    }
    async searchAndHighlight(searchText, resultLimit, padding = 50, documentIndexes) {
        return this._search(searchText, resultLimit, padding, documentIndexes, true);
    }
    getIndexData() {
        //NOOP
        return undefined;
    }
    setIndexData(_indexData) {
    //NOOP
    }
    fetchIndexData() {
        //NOOP
        return Promise.resolve(undefined);
    }
    onSearchIndexCreateProgressUpdate(_progressCallback) {
    //NOOP
    }
    onSearchIndexCreated(_createdCallback) {
    //NOOP
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ async _search(searchText, resultLimit, padding = 50, documentIndexes, highlightResults) {
        let documentsToSearch;
        const textQuery = this._colibrioDocumentSearch.createTextQuery(searchText, {
            ignoreCase: true,
            whitespaceMode: (0, $f8f5cf2c043414f4$export$721ba1b8a28abc20).IGNORE,
            searchResultOptions: {
                includeContentBlocks: true,
                numberOfCharactersBefore: padding,
                numberOfCharactersAfter: padding
            }
        });
        if (highlightResults) this._colibrioReaderViewSearchAgent?.setSearchQuery(textQuery);
        // As no specific indexes where provided we use all ReaderDocuments added to the view.
        if (documentIndexes) documentsToSearch = this._getColibrioReaderDocumentsFromSpineIndexes(documentIndexes);
        else documentsToSearch = this._colibrioReaderView.getReaderDocuments();
        let resultIterator = textQuery.execute(documentsToSearch);
        let colibrioResultSet = await resultIterator.take(resultLimit);
        return this._createVanillaResultItemArray(colibrioResultSet);
    }
    _getColibrioReaderDocumentsFromSpineIndexes(_documentIndexes) {
        return this._colibrioReaderPublication.getSpine().filter((_doc, index)=>{
            return _documentIndexes.includes(index);
        });
    }
    async _createVanillaResultItemArray(colibrioSearchResultItems) {
        let vanillaResultSet = [];
        for (let colibrioSearchResultItem of colibrioSearchResultItems){
            let bookSections = await colibrioSearchResultItem.contentLocation.fetchNavigationItemReferences({
                greedy: false,
                collectionTypes: [
                    (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC
                ]
            });
            let bookSection = bookSections.getItemsBefore()[0]?.getNavigationItem().getTextContent() || "unknown";
            let resultItem = {
                bookSection: bookSection,
                locator: colibrioSearchResultItem.contentLocation.getLocator().toString(),
                nodes: [],
                intersectingNodeText: colibrioSearchResultItem.textBefore + colibrioSearchResultItem.matchingText + colibrioSearchResultItem.textAfter,
                readerDocumentIndexInSpine: colibrioSearchResultItem.readerDocumentIndexInSpine,
                searchTermEndOffsetInIndexedContent: colibrioSearchResultItem.textAfter.length,
                searchTermStartOffsetInIndexedContent: colibrioSearchResultItem.textBefore.length
            };
            vanillaResultSet.push(resultItem);
        }
        return vanillaResultSet;
    }
}







class $0bdc67ad7a08435e$export$c3a1133d4c602a0e {
    constructor(_vanillaReaderPublication, _appElement){
        this._vanillaReaderPublication = _vanillaReaderPublication;
        this._appElement = _appElement;
    }
    async render() {
        const colibrioReaderPublication = this._vanillaReaderPublication.getColibrioReaderPublication();
        if ((0, $98c664707733d94d$export$d4671a61002987ce).isWpAudiobookReaderPublication(colibrioReaderPublication)) {
            const sourcePublication = colibrioReaderPublication.getSourcePublication();
            const coverImageResourceUrl = sourcePublication.getCoverImageResourceUrl();
            if (coverImageResourceUrl) {
                const coverImageResponse = await sourcePublication.getBackingResourceProvider().fetch(coverImageResourceUrl);
                const coverImageData = await coverImageResponse.asUint8Array();
                const mediaType = (0, $515eead6db681c17$export$433a31b80ab1705d).detectFromUint8Array(coverImageData);
                const objectURL = URL.createObjectURL(new Blob([
                    coverImageData
                ], {
                    type: mediaType || (0, $ba5c9d217d86588f$export$483c11740a902fcd).IMAGE_JPEG
                }));
                // As the audiobook does not really have a "ReaderView" equivalent, we just insert some markup to show the
                // book cover.
                this._appElement.insertAdjacentHTML("afterbegin", `
                <div id="vanilla-reader__reader-view__audiobook-cover-container">
                    <img src="${objectURL}" aria-label="Book cover" id="vanilla-reader__reader-view__audiobook-cover-container__image" alt="Book cover">
                </div>`);
                this._appElement.addEventListener("pointerdown", (ev)=>{
                    (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("POINTER_DOWN", {
                        srcEventData: ev
                    }));
                });
                this._appElement.addEventListener("pointerup", (ev)=>{
                    (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("POINTER_UP", {
                        srcEventData: ev
                    }));
                });
            }
        } else throw new Error("VanillaReaderAudiobookReaderView.render(), The publication is not a WpAudiobookReaderPublication.");
    }
}




var $9mLnx = parcelRequire("9mLnx");
const { EpubCfiBuilder: $6e4be20e0d38cef0$export$30dc81a044993354, EpubCfiError: $6e4be20e0d38cef0$export$c3341f16446548e6, EpubCfiErrorType: $6e4be20e0d38cef0$export$a6a7e95130f40f59, EpubCfiFragmentSelectorParser: $6e4be20e0d38cef0$export$2f2e0ad9cdf63ca1, EpubCfiIntendedTargetType: $6e4be20e0d38cef0$export$166c884559168df3, EpubCfiNodeType: $6e4be20e0d38cef0$export$ba6fbbcf541b96a9, EpubCfiParser: $6e4be20e0d38cef0$export$21e821b3ad85b00b, EpubCfiParserErrorType: $6e4be20e0d38cef0$export$f5f5ba56f52d8cfe, EpubCfiResolver: $6e4be20e0d38cef0$export$163599238bec848f, EpubCfiResolverErrorType: $6e4be20e0d38cef0$export$759376f13163c591, EpubCfiSelector: $6e4be20e0d38cef0$export$dcbf5e969ce4a74e, EpubCfiSideBias: $6e4be20e0d38cef0$export$e15757c6f58f46eb, EpubCfiStringifier: $6e4be20e0d38cef0$export$50ee5908b8f3d1d6, EpubCfiUtils: $6e4be20e0d38cef0$export$f43a80052d35593a, EpubCfiValidator: $6e4be20e0d38cef0$export$d8b350a4ca611fa9, EpubCfiVirtualTarget: $6e4be20e0d38cef0$export$4a074a74e86ab9ce } = (0, (/*@__PURE__*/$parcel$interopDefault($9mLnx)));



var $2ifeC = parcelRequire("2ifeC");
const { PdfFragmentSelector: $612cabb88341dbdc$export$dd2ab5d4723f27c6, PdfFragmentSelectorParser: $612cabb88341dbdc$export$21727e0a9469013b } = (0, (/*@__PURE__*/$parcel$interopDefault($2ifeC)));



var $bkFGj = parcelRequire("bkFGj");
const { FragmentSelector: $6ecee67d716c9b7a$export$662ecd72df3e465d, FragmentSpecificationIri: $6ecee67d716c9b7a$export$265176d3f240282, RangeSelector: $6ecee67d716c9b7a$export$1081d70813d107d1, RangeSelectorDataParser: $6ecee67d716c9b7a$export$f5e9ffe17fa96017, SelectorFactory: $6ecee67d716c9b7a$export$b03f5681b09e6e49, SelectorType: $6ecee67d716c9b7a$export$4e8b093ec8dcab0d, UnknownFragmentSelector: $6ecee67d716c9b7a$export$eb56969a43229400 } = (0, (/*@__PURE__*/$parcel$interopDefault($bkFGj)));




var $gWxKE = parcelRequire("gWxKE");
const { CoreXmlError: $1461baa2a79367ad$export$e828f26a7ec8b164, CoreXmlErrorType: $1461baa2a79367ad$export$b0128c140db7c8e2, DomParser: $1461baa2a79367ad$export$7d11ccc10e31bfac, XhtmlParser: $1461baa2a79367ad$export$34a4c721232cf97c, XmlSerializer: $1461baa2a79367ad$export$3db6b15714caa522 } = (0, (/*@__PURE__*/$parcel$interopDefault($gWxKE)));



class $b094656fcaba3e63$export$8616061a0b06a42b {
    constructor(vanillaPublication){
        this.playerIsAttachedToView = false;
        this._audioElement = document.createElement("audio");
        this._vanillaPublication = vanillaPublication;
        this._audioElement.onerror = (ev)=>{
            if (this._currentlyPlaying && this._onPlaybackErrorCallback) this._onPlaybackErrorCallback(ev, this._currentlyPlaying);
        };
        this._audioElement.onpause = (ev)=>{
            if (this._currentlyPlaying && this._onPlaybackPausedCallback) this._onPlaybackPausedCallback(ev, this._currentlyPlaying);
        };
        this._audioElement.onabort = (ev)=>{
            if (this._currentlyPlaying && this._onPlaybackAbortedCallback) this._onPlaybackAbortedCallback(ev, this._currentlyPlaying);
        };
        this._audioElement.onended = (ev)=>{
            if (this._currentlyPlaying) {
                if (this._onEndReachedCallback) this._onEndReachedCallback(ev, this._currentlyPlaying);
            }
        };
        this._audioElement.oncanplaythrough = (_ev)=>{};
        this._audioElement.oncanplay = (_ev)=>{};
        this._audioElement.ondurationchange = (_ev)=>{};
        this._audioElement.onplay = (ev)=>{
            if (this._currentlyPlaying && this._onPlaybackStartedCallback) this._onPlaybackStartedCallback(ev, this._currentlyPlaying);
        };
        this._audioElement.onplaying = (_ev)=>{};
        this._audioElement.ontimeupdate = (_ev)=>{
            if (this._timeUpdateTimeoutHandle === undefined) this._timeUpdateTimeoutHandle = setTimeout(()=>{
                this._timeUpdateTimeoutHandle = undefined;
                if (!this._currentlyPlaying) return;
            }, 500);
        };
        this._audioElement.onseeking = (_ev)=>{};
        this._audioElement.onseeked = (_ev)=>{};
        this._audioElement.onratechange = (_ev)=>{};
        this._audioElement.onprogress = (_ev)=>{};
    }
    onPlaybackStarted(callback) {
        this._onPlaybackStartedCallback = callback;
    }
    onPlaybackPaused(callback) {
        this._onPlaybackPausedCallback = callback;
    }
    onPlaybackAborted(callback) {
        this._onPlaybackAbortedCallback = callback;
    }
    onPlaybackEndReached(callback) {
        this._onEndReachedCallback = callback;
    }
    onPlaybackError(callback) {
        this._onPlaybackErrorCallback = callback;
    }
    get audioElement() {
        return this._audioElement;
    }
    set playbackRate(rate) {
        this._audioElement.playbackRate = rate;
    }
    get playbackRate() {
        return this._audioElement.playbackRate;
    }
    get volume() {
        return this._audioElement.volume;
    }
    set volume(volume) {
        this._audioElement.volume = volume;
    }
    get muted() {
        return this._audioElement.muted;
    }
    set muted(muted) {
        this._audioElement.muted = muted;
    }
    getCurrentlyPlaying() {
        return this._currentlyPlaying;
    }
    async setCurrentlyPlaying(audio) {
        if (!audio) {
            this.unset();
            return;
        }
        if (this._audioElement.src && this._currentlyPlaying === audio) {
            console.log("AmbientAudioAudioElementRenderer.setCurrentlyPlaying(): Already playing this audio.");
            return;
        }
        this._currentlyPlaying = audio;
        let srcPublication = this._vanillaPublication?.getColibrioReaderPublication().getSourcePublication();
        let opfBasePath = srcPublication.getOpfDocumentUrl().pathname.slice(0, srcPublication.getOpfDocumentUrl().pathname.lastIndexOf("/"));
        let audioUrl = audio?.startsWith("http") ? audio : await this._vanillaPublication?.fetchResourceBlobUrl(`${opfBasePath}/${audio}`);
        if (!this._audioElement.paused) {
            this._audioElement.src = audioUrl;
            this._audioElement.play();
        } else this._audioElement.src = audioUrl;
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("AMBIENT_AUDIO_READY", {
            isPlaying: !this._audioElement.paused
        }));
    }
    async play() {
        return this._audioElement.play();
    }
    pause() {
        this._audioElement.pause();
    }
    unset() {
        this._audioElement.removeAttribute("src");
    }
}


class $ab06243ba3e98443$export$dea8a9c0c2b1e4c0 {
    constructor(_readerViewElement, // This is the license key that has been provided to you by Colibrio.
    colibrioLicenseApiKey, // User profile data is used to tag reading sessions that are sent to the Colibrio License Server with a unique token.
    // See `fetchOrCreateUserProfile()` in index.ts for our sample implementation.
    _userProfileData, // Initial configuration options retrieved by the calling context (index.ts)
    _initialOptions, optionsDataStore){
        this._readerViewElement = _readerViewElement;
        this._userProfileData = _userProfileData;
        this._initialOptions = _initialOptions;
        this.vanillaReadingProgressionTimeLine = undefined;
        this.vanillaMediaPlayer = undefined;
        this.vanillaAudiobookPlayer = undefined;
        this._colibrioReaderPublication = undefined;
        this._isOffline = false;
        this._isLoaded = false;
        this._shouldFocusOnReadingPosition = true;
        this._event_onSyncMediaPlayerAttached = ()=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_ATTACHED", {}));
        };
        this._event_onSyncMediaPlayerDetached = ()=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_DETACHED", {}));
        };
        this._event_onSyncMediaPlayerCreated = ()=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_CREATED", {}));
        };
        this._event_onSyncMediaPlayerCreateProgress = (progress)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_CREATE_PROGRESS_UPDATED", {
                progress: progress
            }));
        };
        this._event_onSyncMediaPlayerPlaybackStateChanged = (state)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_PLAYBACK_STATE_CHANGED", {
                state: state
            }));
        };
        this._event_onSyncMediaRangePlaybackEndReached = (state)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_PLAYBACK_RANGE_END_REACHED", {
                state: state
            }));
        };
        this._event_onSyncMediaEscapabilityContentChanged = (context)=>{
            let contextData = context.map((contextItem)=>{
                return {
                    blockData: contextItem.block.toSerializableData({
                        createLocators: true
                    }),
                    blockId: contextItem.blockId,
                    blockStartLocator: contextItem.blockRangeLocation.collapseToStart().getLocator().toString(this.vanillaPublication?.url),
                    blockEndLocator: contextItem.blockRangeLocation.collapseToEnd().getLocator().toString(this.vanillaPublication?.url)
                };
            });
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_ESCAPABILITY_CONTEXT_CHANGED", {
                contextData: contextData
            }));
        };
        this._event_onSyncMediaRangePlaybackRemoved = (state, reason)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_PLAYBACK_RANGE_REMOVED", {
                state: state,
                reason: reason
            }));
        };
        this._event_mediaObjectClicked = async (ev)=>{
            if (this.vanillaPublication && !this.vanillaPublication.isFixedLayout) {
                let mediaResourceData = ev.detail.mediaResourceData;
                let mediaElementAttributes;
                if (mediaResourceData && mediaResourceData.resourceUrl && mediaResourceData.mediaTypeCategory === (0, $ba5c9d217d86588f$export$def5bddc25089c06).IMAGE) {
                    let mediaResourceBlobUrl = await this.vanillaPublication.fetchResourceBlobUrl(mediaResourceData.resourceUrl);
                    this.vanillaPublication.fetchLandmarkCollection().then((landmarkCollection)=>{
                        if (landmarkCollection) {
                            let mediaElementUrl = new URL(mediaResourceData.resourceUrl);
                            let mediaElement = landmarkCollection.getFigures()?.find((mediaElement)=>{
                                if (!mediaElement || !mediaElement.resourceHrefs || mediaElement.resourceHrefs.length === 0) return false;
                                return mediaElementUrl.pathname.includes(mediaElement.resourceHrefs[0]);
                            });
                            mediaElementAttributes = mediaElement ? mediaElement.attributes : undefined;
                        }
                        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIA_OBJECT_VIEW_INTENT", {
                            mediaUrl: mediaResourceBlobUrl,
                            mediaElementAttributes: mediaElementAttributes
                        }));
                    }).catch(console.warn);
                }
            }
        };
        this._event_timelineReady = async ()=>{
            if (this.vanillaPublication && this.vanillaPublication.progressionTimeline) {
                this.vanillaReaderView?.readingStats?.setPublicationLength(this.vanillaPublication.progressionTimeline.getLength());
                const readingPosition = this.vanillaReaderView?.getReadingPosition();
                if (readingPosition) this.vanillaReadingProgressionTimeLine?.updateTimelinePosition(readingPosition.getLocator());
                await this.vanillaPublication?.buildNavigationTree(this.vanillaPublication.progressionTimeline).catch(console.error);
                await this.vanillaPublication?.buildPageList(this.vanillaPublication.progressionTimeline).catch(console.error);
                if (this.vanillaReaderView && this.vanillaPublication.pageListData) this.vanillaReaderView.createPageMarkerLayer(this.vanillaPublication.pageListData);
                // As we now have both timeline and navigation tree, we can send more complete visible range data to the UI.
                this._event_visibleRangeDataChanged().catch(console.error);
            }
        };
        this._event_readingPositionChanged = async (ev)=>{
            const readingPosition = ev.readerView.getReadingPosition();
            const readingPositionData = await this.vanillaReaderView?.getReadingPositionData();
            if (readingPosition && readingPositionData && this.vanillaPublication && this.vanillaPublication.id) {
                this.vanillaPublication.setCurrentReadingPositionData(readingPositionData);
                this.vanillaReadingProgressionTimeLine?.updateTimelinePosition(readingPosition.getLocator());
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("READING_POSITION_UPDATED", {
                    readingPositionData: readingPositionData
                }));
                if (this.vanillaPublication.colibrioReaderPublication.getSourcePublication().getType() == (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).EPUB) {
                    var contentUrl = readingPosition.getReaderDocuments()[0].getSourceContentDocument().getContentUrl();
                    let publication = this.vanillaPublication.colibrioReaderPublication.getSourcePublication();
                    let resourceProvider = publication.getEpubResourceProvider();
                    resourceProvider.fetch(contentUrl).then((resp)=>new Response(resp.getReadableStream()).text()).then((result)=>{
                        try {
                            let xml = new (0, $1461baa2a79367ad$export$34a4c721232cf97c)(result, contentUrl.toString(), false).getDocument();
                            const res = xml?.evaluate("//xhtml:*[@epub:type]", xml.getRootNode(), function(prefix) {
                                return xml?.lookupNamespaceURI(prefix === "xhtml" ? null : prefix);
                            });
                            let node = null;
                            let audioFound = false;
                            while(res != null && (node = res?.iterateNext()))if (node.getAttribute("epub:type") == "ibooks:soundtrack") {
                                let audioTrack = node.getAttribute("src");
                                audioFound = true;
                                if (this.vanillaReaderView) {
                                    if (!this.ambientMediaPlayer) this.ambientMediaPlayer = new (0, $b094656fcaba3e63$export$8616061a0b06a42b)(this.vanillaPublication);
                                    this.ambientMediaPlayer.setCurrentlyPlaying(audioTrack);
                                }
                            }
                            if (!audioFound && this.ambientMediaPlayer) {
                                this.ambientMediaPlayer.pause();
                                this.ambientMediaPlayer.setCurrentlyPlaying(undefined);
                                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("AMBIENT_AUDIO_NOT_FOUND", {}));
                            }
                        } catch (e) {
                            console.error("Unable to get publication info", e);
                        }
                    });
                }
            }
        };
        this._event_visibleRangeDataChanged = async ()=>{
            // Invalidate the current rects and update them based on the current visible content.
            await this.vanillaReaderView?.updateAndFetchVisibleContentRects();
            let visibleRangeData = await this.vanillaReaderView?.fetchVisibleRangeData(this.vanillaPublication?.navigationTree, this.vanillaReadingProgressionTimeLine);
            if (visibleRangeData) {
                if (this.vanillaReadingProgressionTimeLine?.isReady() && visibleRangeData.locator) {
                    let wordRange = await this.vanillaReadingProgressionTimeLine?.fetchTimelineRange(visibleRangeData.locator);
                    if (wordRange) this._registerWordRangeReadToStats(new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(wordRange.start, wordRange.end));
                }
                if (visibleRangeData.documentIsAtStart) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("DOCUMENT_IS_AT_START", {}));
                if (visibleRangeData.documentIsAtEnd) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("DOCUMENT_IS_AT_END", {}));
                // Check if the start / of the visible range is at the start or end of the publication, and if so send
                // events.
                if (visibleRangeData.publicationIsAtStart) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_IS_AT_START", {}));
                if (visibleRangeData.publicationIsAtEnd) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_IS_AT_END", {}));
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VISIBLE_RANGE_DATA_CHANGED", {
                    visibleRangeData: visibleRangeData
                }));
            }
        };
        this._event_textSelected = (ev)=>{
            // If we have a range of text selected we turn of view gestures in order to make sure that the view does respond
            // to swipe navigation events etc.
            if (ev.isRange) this.vanillaReaderView?.setAllowedGestureTypes([]);
            else this.vanillaReaderView?.setAllowedGestureTypes([
                (0, $f8f5cf2c043414f4$export$7f084d699ccf1fe7).SWIPE_NAVIGATION,
                (0, $f8f5cf2c043414f4$export$7f084d699ccf1fe7).PAN_ZOOM
            ]);
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("TEXT_SELECTED", {
                srcEventData: ev.toJSON()
            }));
        };
        this._event_appOnlineStateChanged = (_ev)=>{};
        this._event_highlightAdded = (ev)=>{
            if (!this.vanillaPublication) return;
            this.vanillaReaderView?.highlightsLayer?.addHighlight(ev.detail.highlight);
        };
        this._event_highlightUpdated = (ev)=>{
            if (!this.vanillaPublication) return;
            this.vanillaReaderView?.highlightsLayer?.updateHighlight(ev.detail.highlight);
        };
        this._event_highlightDeleted = (ev)=>{
            if (!this.vanillaPublication) return;
            this.vanillaReaderView?.highlightsLayer?.deleteHighlight(ev.detail.locator);
        };
        this._event_bookmarkAdded = (ev)=>{
            if (!this.vanillaPublication) return;
            this.vanillaReaderView?.bookmarksLayer?.addBookmark(ev.detail.bookmark);
        };
        this._event_bookmarkDeleted = (ev)=>{
            if (!this.vanillaPublication) return;
            this.vanillaReaderView?.bookmarksLayer?.deleteBookmark(ev.detail.locator);
        };
        new (0, $d708d48eab9f1a42$export$209340836e0e189)(this);
        this.vanillaOptionsDataStore = optionsDataStore;
        this.vanillaReadingSystem = new (0, $c0755b65389d3173$export$8e0d8beae376a163)(colibrioLicenseApiKey, this._userProfileData);
        this._setUpEventBusEventHandlers();
        this._setUpComponentCallbacks();
        // Let's report to all that are listening that we are all set to open books!
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("APP_LOADED", {
            initialOptions: this._initialOptions
        }));
    /**
         *
         * What happens now?
         *
         * Now the ReaderSystemEngine is up and running, but we still have not loaded any publication. That happens in
         * one of the following methods:
         *
         * - loadPublicationFromUrl()
         * - loadPublicationFromStore()
         * - loadPublicationFromFile()
         *
         * Once the publication has started loading by the `VanillaReaderReadingSystem` (which in turn of course uses the
         * Colibrio Reader Framework `ReadingSystemEngine`) things continue in `_onAfterPublicationLoaded`. Go check it out!
         *
         * */ }
    setReaderViewElement(readerViewElement) {
        this._readerViewElement = readerViewElement;
    }
    get readerViewElement() {
        if (!this._readerViewElement) throw new Error("VanillaReader.readerViewElement has not been set.");
        return this._readerViewElement;
    }
    /*
    *
    * This method serializes all configuration options to be persisted between application sessions.
    *
    * */ serializeToOptionsData() {
        let options = {
            dateCreated: Date.now(),
            viewOptions: undefined,
            syncMediaOptions: undefined
        };
        options.viewOptions = this.vanillaReaderView?.getCurrentVanillaReaderViewOptionsState();
        options.syncMediaOptions = this.vanillaMediaPlayer?.getPlaybackOptions();
        return options;
    }
    /**
     *
     * This property turns on/off the accessibility feature that helps a Screen Reader focus on the current reading
     * position. Focusing is done, as the name suggests, by calling `HTMLElement.focus()` near the reading position.
     * We recommend that you turn this on as a default.
     *
     * NOTE:
     *
     * A consequence of setting this to true is that a focus marker will be rendered in many books, so you might want to
     * have an option to toggle this in the UI.
     *
     * */ get shouldFocusOnReadingPosition() {
        return this._shouldFocusOnReadingPosition;
    }
    set shouldFocusOnReadingPosition(value) {
        this._shouldFocusOnReadingPosition = value;
    }
    async getReadingPositionData() {
        return this.vanillaReaderView?.getReadingPositionData();
    }
    /*
    *
    * It is very important for the whole application to be aware of any changes to internet connectivity. This property
    * is set by the calling context (index.ts in our case) to signal this. The method itself determines if the new state
    * really is different from the current state, and if it is an app wide event is sent.
    *
    */ set isOffline(state) {
        if (this._isOffline !== state) {
            const event = (0, $84c7b345e247d474$export$51b4df07290407).createEvent("APP_ONLINE_STATE_CHANGED", {
                isOnline: !state
            });
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(event);
        }
        this._isOffline = state;
    }
    get isOffline() {
        return this._isOffline;
    }
    set isLoaded(state) {
        this._isLoaded = state;
    }
    get isLoaded() {
        return this._isLoaded;
    }
    /**
     *
     * This method takes in a URL as a string and tries to load a publication from it. "Under the hood" it uses the
     * Colibrio `ReadingSystemEngine`, so have a peek at the `VanillaReaderReadingSystem.loadPublicationFromUrl()`
     *
     * @param publicationUrl - A string URL that points to a publication resource file
     * @param shelfItem - Shelf item is what actual represents the "used" book. It manages all the books state such as notes, bookmarks, reading positions etc.
     * @param size - Optional. The byte size of publication resource. This is only necessary if you can not make HEAD requests to your file server.
     * @param initialLocator - Optional. A publication location to navigate to after the publication has been loaded.
     * @param storeOnDevice - Optional. Should the `IRandomAccessDataSource` instance used when loading the publication use IndexedDB for long term caching?
     * @return void
     * */ async loadPublicationFromUrl(publicationUrl, shelfItem, size, initialLocator, storeOnDevice = false) {
        this._colibrioReaderPublication = await this.vanillaReadingSystem.loadPublicationFromUrl(publicationUrl, shelfItem, size, storeOnDevice).catch((reason)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_LOAD_FAILED", {
                errorMessage: reason
            }));
        });
        if (!this._colibrioReaderPublication) throw new DOMException("VanillaReader.loadPublicationFromUrl(), Failed to load publication");
        let pathName = new URL(publicationUrl).pathname;
        let fileName = pathName.slice(pathName.lastIndexOf("/") + 1);
        await this._onAfterPublicationLoaded(fileName, publicationUrl, this._colibrioReaderPublication, shelfItem, initialLocator);
    }
    async loadPublicationFromAwsLambda(publicationUrl, urlResolver, shelfItem, size, initialLocator, storeOnDevice = false) {
        this._colibrioReaderPublication = await this.vanillaReadingSystem.loadPublicationFromAwsLambda(publicationUrl, urlResolver, shelfItem, size, storeOnDevice).catch((reason)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_LOAD_FAILED", {
                errorMessage: reason
            }));
        });
        if (!this._colibrioReaderPublication) throw new DOMException("VanillaReader.loadPublicationFromAwsLambda(), Failed to load publication");
        let pathName = new URL(publicationUrl).pathname;
        let fileName = pathName.slice(pathName.lastIndexOf("/") + 1);
        await this._onAfterPublicationLoaded(fileName, publicationUrl, this._colibrioReaderPublication, shelfItem, initialLocator);
    }
    /**
     *
     * This method takes in a file name and a source URI to identify the origin of the file and tries to load the publication
     * from using the `IVanillaReaderStreamedResourceStorage` storage client. It uses two different methods to load data,
     * for `https:` URIs it uses `VanillaReaderReadingSystem.loadPublicationFromUrl()` and for `file:` based URIs it uses
     * `VanillaReaderReadingSystem.loadPublicationFromArrayBuffer()`
     *
     * @param fileName - A publication resource file name as a string
     * @param fileSourceUri - The URI used to load the publication as a string
     * @param shelfItem - Shelf item is what actual represents the "used" book. It manages all the books state such as notes, bookmarks, reading positions etc.
     * @param initialLocator - Optional. A publication location to navigate to after the publication has been loaded.
     * @param storeOnDevice - Optional. Should the `IRandomAccessDataSource` instance used when loading the publication use IndexedDB for long term caching?
     * @return void
     * */ async loadPublicationFromStore(fileName, fileSourceUri, shelfItem, initialLocator, storeOnDevice = false) {
        if (shelfItem) {
            let storedResource = await shelfItem.fetchStoredResource();
            if (storedResource) {
                // If the fileSourceUri parameter is provided this is a URL
                if (fileSourceUri?.startsWith("https://")) return this.loadPublicationFromUrl(fileSourceUri, shelfItem, storedResource.size, initialLocator, storeOnDevice);
                else if (fileSourceUri?.startsWith("file://")) {
                    // According to `fileSourceUri` string, this is a file resource. Files opened from the file system
                    // are stored as one single ArrayBuffer.
                    let fileBuffer = await storedResource.fetchChunkAtOffset(0);
                    if (fileBuffer) {
                        this._colibrioReaderPublication = await this.vanillaReadingSystem.loadPublicationFromArrayBuffer(fileBuffer.data, fileName, storeOnDevice, shelfItem).catch((reason)=>{
                            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_LOAD_FAILED", {
                                errorMessage: reason
                            }));
                        });
                        if (!this._colibrioReaderPublication) throw new DOMException("VanillaReader.loadPublicationFromStore(), Failed to load publication");
                        await this._onAfterPublicationLoaded(fileName, fileSourceUri, this._colibrioReaderPublication, shelfItem, initialLocator);
                    } else console.warn("VanillaReader.loadPublicationFromStore(): Unable to get ArrayBuffer data for " + storedResource.name);
                } else console.warn("VanillaReader.loadPublicationFromStore(): The fileSourceUri does not have a valid protocol (https:// or file://). " + fileSourceUri);
            } else console.warn("VanillaReader.loadPublicationFromStore(): Unable to get stored publication with file name " + fileName);
        }
    }
    /**
     *
     * This method takes in a File object and tries to load a publication from it. "Under the hood" it uses the
     * Colibrio `ReadingSystemEngine`, so have a peek at the `VanillaReaderReadingSystem.loadPublicationFromFile()`
     *
     * @param file - A File object to the publication resource.
     * @param shelfItem - Shelf item is what actual represents the "used" book. It manages all the books state such as notes, bookmarks, reading positions etc.
     * @param initialLocator - Optional. A publication location to navigate to after the publication has been loaded.
     * @param storeOnDevice - Optional. Should the loaded publication data be cached on the device for offline access?.
     * @return void
     * */ async loadPublicationFromFile(file, shelfItem, initialLocator, storeOnDevice = false) {
        if (!shelfItem) throw new DOMException(`VanillaReader.loadPublicationFromFile(), No shelf item provider for ${file.name}`);
        this._colibrioReaderPublication = await this.vanillaReadingSystem.loadPublicationFromFile(file, storeOnDevice, shelfItem).catch((reason)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_LOAD_FAILED", {
                errorMessage: reason
            }));
        });
        if (!this._colibrioReaderPublication) throw new DOMException("VanillaReader.loadPublicationFromFile(), Failed to load publication");
        // Since files loaded from disc do not have a file path, with need to create a value for the
        // file `fileSourceUri` argument. This should perhaps be done in the `VanillaReaderReadingSystem`
        // class instead.
        let fileUri = "file://" + file.name;
        await this._onAfterPublicationLoaded(file.name, fileUri, this._colibrioReaderPublication, shelfItem, initialLocator);
    }
    getSelectorFromFragmentSelector(selectors) {
        if (this.vanillaPublication) {
            let selector = {
                sourceUrl: this.vanillaPublication.colibrioReaderPublication.getDefaultLocatorUrl(),
                selectors: selectors
            };
            const selectorFactory = new (0, $6ecee67d716c9b7a$export$b03f5681b09e6e49)([
                new (0, $6e4be20e0d38cef0$export$2f2e0ad9cdf63ca1)(),
                new (0, $612cabb88341dbdc$export$21727e0a9469013b)()
            ]);
            return new (0, $385fc9d0f36a8af6$export$7896dcffc6e8b080)(selectorFactory).parse(selector).locator;
        }
        return null;
    }
    /**
     *
     * Navigates to the position described in the locator.
     *
     * @param locator - The locator to navigate to as an `ILocator` or as a string
     * @param options - The `IReaderViewGotoOptions.setReadingPositionToVisibleRangeStart` option "snaps" the reading
     * position to the start of the visible content if set to `true`. Default is `false` meaning that the reading position
     * will be at the precise position described in the locator.
     *
     * */ async goTo(locator, options) {
        if (this.vanillaPublication) {
            if (this.vanillaReaderView) {
                let useLocator = locator;
                try {
                    await this.vanillaReaderView.goTo(locator, options);
                    useLocator = locator;
                } catch (_err) {
                    console.warn("Unable to get ILocator as specified. Attempting to get ILocator from Fragment Selector");
                    if (typeof locator === "string") {
                        useLocator = this.getSelectorFromFragmentSelector([
                            locator
                        ]);
                        console.log("Locator is string. Using locator: ", useLocator);
                        if (useLocator) await this.vanillaReaderView.goTo(useLocator, options);
                    } else console.log("Locator is type: " + typeof locator);
                }
            } else if (this.vanillaPublication?.isAudiobook) {
                let location = await this.vanillaPublication.getColibrioReaderPublication().fetchContentLocation(locator);
                this.vanillaAudiobookPlayer?.seekToLocator(location.getLocator());
            }
        }
    }
    async goToStart() {
        if (!this.vanillaPublication?.isAudiobook && this.vanillaReaderView) {
            if (!this.vanillaReaderView.isAtStart()) await this.vanillaReaderView.goToStart();
        } else this.vanillaAudiobookPlayer?.seekToApproximateTimeMs(0);
    }
    async next() {
        if (this.vanillaPublication?.isAudiobook) await this.vanillaAudiobookPlayer?.seekToNextSegment();
        else if (this.vanillaReaderView && this.vanillaReaderView.canPerformNext()) this.vanillaReaderView.next().catch(console.error);
    }
    async previous() {
        if (this.vanillaPublication?.isAudiobook) await this.vanillaAudiobookPlayer?.seekToPreviousSegment();
        else if (this.vanillaReaderView && this.vanillaReaderView.canPerformPrevious()) this.vanillaReaderView.previous().catch(console.error);
    }
    /**
     *
     * This method navigates to a location in the book based on a given position off the readingProgressionTimeline.
     * The behavior differs a bit depending on the book format. If it's an EPUB or PDF we first need to resolve the
     * timeline position to a `IContentLocation` that we can then use as a parameter when calling `goTo`.
     * If it is an Audiobook things are much simpler. Since the timeline represents the duration of the audiobook in
     * milliseconds, we can just seek directly to that position in the book.
     *
     * */ async gotoTimelinePosition(position) {
        if (this.vanillaReadingProgressionTimeLine) {
            if (!this.vanillaPublication?.isAudiobook) {
                let contentLocation = await this.vanillaReadingProgressionTimeLine.fetchContentLocation(position);
                if (contentLocation) await this.goTo(contentLocation.getLocator(), {
                    setReadingPositionToVisibleRangeStart: true
                });
            } else this.vanillaAudiobookPlayer?.seekToApproximateTimeMs(position);
        }
    }
    /**
     *
     * This method gets the timeline position as a number. If the loaded `IReaderPublication` is an Audiobook the number
     * represents the progression in ms. If the `IReaderPublication` is a reflowable EPUB the returned number represents
     * the index of the word at the current position. For PDF and Fixed Layout EPUBs the number represents the current
     * page index.
     *
     * */ async getTimelinePosition() {
        if (this.vanillaReadingProgressionTimeLine) {
            if (!this.vanillaPublication?.isAudiobook && this.vanillaReaderView) {
                let readingPosition = this.vanillaReaderView.getReadingPosition()?.collapseToStart().getLocator();
                if (readingPosition) return this.vanillaReadingProgressionTimeLine.fetchTimelinePosition(readingPosition);
            } else return this.vanillaAudiobookPlayer?.getApproximateElapsedTimeMs();
        }
        return undefined;
    }
    /**
     *
     * This method searches the entire publication, or a subset of documents, for the provided search string.
     * In order to be able to perform a search, the search index must first be built. This is done adhoc in the
     * `VanillaReaderPublication.search()` method.
     *
     * */ async searchPublication(searchString, resultSetMaxSize = 50, documentIndexes, highlightResults = true) {
        if (!this.vanillaPublication) return [];
        if (!highlightResults) return this.vanillaPublicationSearch?.search(searchString, resultSetMaxSize, 50, documentIndexes) || [];
        else return this.vanillaPublicationSearch?.searchAndHighlight(searchString, resultSetMaxSize, 50, documentIndexes) || [];
    }
    clearPublicationSearchLayer() {
        this.vanillaPublicationSearch?.clearSearch();
        const event = (0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_SEARCH_CLEARED", {});
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(event);
    }
    /**
     * This method is a quirkfix to let Screen Reader users (primarily NVDA and JAWS) highlight text based on the contents
     * of their clipboard.
     *
     * The reason that we need this is because of the Screen Readers inability to scroll the document as it moves through
     * the document contents. This is a problem for us since we use the visible range as a means to know where the user
     * is reading, so without a change in the visible range we can't can add a correct highlight or bookmark.
     *
     * The way that the Screen Reader user will use this feature is as follows:
     *
     * 1. The user selects and copies the text that represents the location they want highlight or bookmark.
     * 2. The user uses some method to trigger a UI call to this method, sending along the text that is currently
     * in the user's clipboard as well as the document index in the publication spine.
     * 3. This method uses the publication search to grab the first occurrence of the string in the specified document.
     * 4. The result is communicated back to the user using the `HIGHLIGHT_ADDED` / `BOOKMARK_ADDED` or
     * `HIGHLIGHT_TEXTLOCATION_FAILED` / `BOOKMARK_TEXTLOCATION_FAILED` events.
     *
     * */ async bookmarkTextLocation(textToBookmark, documentIndex) {
        this.searchPublication(textToBookmark, 1, [
            documentIndex
        ], false).then(async (resultSet)=>{
            if (resultSet.length > 0) return this.vanillaPublication?.addBookmark(resultSet[0].locator).then((bookmarkData)=>{
                if (!bookmarkData) {
                    const event = (0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARK_TEXTLOCATION_FAILED", {
                        text: textToBookmark,
                        documentIndex: documentIndex
                    });
                    (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(event);
                }
            });
            else {
                const event = (0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARK_TEXTLOCATION_FAILED", {
                    text: textToBookmark,
                    documentIndex: documentIndex
                });
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(event);
            }
        }).catch(console.error);
        return;
    }
    // Bookmarks the `ContentLocation` returned by the `ReaderView`.
    async bookmarkReadingPosition() {
        let readingPositionLocator = undefined;
        if (this.vanillaPublication?.isAudiobook) {
            let timelinePosition = this.vanillaAudiobookPlayer?.getApproximateElapsedTimeMs();
            if (timelinePosition) readingPositionLocator = (await this.vanillaAudiobookPlayer?.getTimeline().fetchContentLocation(timelinePosition))?.getLocator();
        } else readingPositionLocator = this.vanillaReaderView?.getReadingPosition()?.getLocator();
        if (!readingPositionLocator) {
            console.warn(`VanillaReader.bookmarkReadingPosition(): Unable to get reading position from VanillaReaderView.`);
            return;
        }
        return this.addBookmark(readingPositionLocator);
    }
    async addHighlight(highlightData) {
        return this.vanillaPublication?.addHighlight(highlightData);
    }
    /**
     * This method is a quirkfix to let Screen Reader users (primarily NVDA and JAWS) highlight text based on the contents
     * of their clipboard.
     *
     * The reason that we need this is because of the Screen Readers inability to scroll the document as it moves through
     * the document contents. This is a problem for us since we use the visible range as a means to know where the user
     * is reading, so without a change in the visible range we can't can add a correct highlight or bookmark.
     *
     * The way that the Screen Reader user will use this feature is as follows:
     *
     * 1. The user selects and copies the text that represents the location they want highlight or bookmark.
     * 2. The user uses some method to trigger a UI call to this method, sending along the text that is currently
     * in the user's clipboard as well as the document index in the publication spine.
     * 3. This method uses the publication search to grab the first occurrence of the string in the specified document.
     * 4. The result is communicated back to the user using the `HIGHLIGHT_ADDED` / `BOOKMARK_ADDED` or
     * `HIGHLIGHT_TEXTLOCATION_FAILED` / `BOOKMARK_TEXTLOCATION_FAILED` events.
     *
     * */ async highlightTextLocation(textToHighlight, documentIndex, sourceHighlightData) {
        await this.searchPublication(textToHighlight, 1, [
            documentIndex
        ], false).then((resultSet)=>{
            if (!this.vanillaPublication) {
                console.warn("VanillaReader.highlightTextSelection(), no publication loaded.");
                return;
            }
            if (resultSet.length > 0) {
                if (resultSet[0].locator) {
                    sourceHighlightData.locator = resultSet[0].locator;
                    this.addHighlight(sourceHighlightData).catch(console.warn);
                }
            } else {
                const event = (0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHT_TEXTLOCATION_FAILED", {
                    text: textToHighlight,
                    documentIndex: documentIndex,
                    highlightData: sourceHighlightData
                });
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(event);
            }
        }).catch(console.error);
    }
    /**
     *
     * This method helps a Screen Reader focus on the current reading position by calling `HTMLElement.focus()` as close
     * to the current reading position as possible.
     *
     * */ async focusOnReadingPosition() {
        if (this.vanillaReaderView) return this.vanillaReaderView.focusOnReadingPosition({
            focusOnPageContainer: false,
            focusOnPageBodyElement: false,
            focusNearContentLocation: true
        }).then(()=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("FOCUS_ON_READINGPOSITION_DONE", {}));
        }).catch((reason)=>{
            console.error(reason);
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("FOCUS_ON_READINGPOSITION_FAILED", {
                reason: reason
            }));
        });
    }
    ignorePublicationAspectRatio(ignoreAspectRatio = false) {
        this.vanillaReaderView?.changeRendererAspectRatio(ignoreAspectRatio);
    }
    async fetchPublicationLandmarks(landmarkTypesToInclude) {
        let headings, footnotes, figures, tables, lists;
        if (!this.vanillaPublication?.progressionTimeline) {
            console.warn("VanillaReader.fetchPublicationLandmarks, reading progression timeline not initialized.");
            return;
        }
        await this.vanillaPublication?.fetchLandmarkCollection(this.vanillaPublication.progressionTimeline, landmarkTypesToInclude).then((landmarkCollection)=>{
            headings = landmarkCollection?.getHeadings();
            footnotes = landmarkCollection?.getFootnotes();
            figures = landmarkCollection?.getFigures();
            tables = landmarkCollection?.getTables();
            lists = landmarkCollection?.getLists();
        });
        return {
            headings: headings,
            footnotes: footnotes,
            figures: figures,
            tables: tables,
            lists: lists
        };
    }
    async fetchDocumentLandmarks(documentIndex, landmarkTypesToInclude) {
        let landmarkCollection = await this.vanillaPublication?.fetchLandmarkCollectionForDocument(documentIndex, this.vanillaReadingProgressionTimeLine, landmarkTypesToInclude);
        let headings = landmarkCollection?.getHeadings();
        let footnotes = landmarkCollection?.getFootnotes();
        let figures = landmarkCollection?.getFigures();
        let tables = landmarkCollection?.getTables();
        let lists = landmarkCollection?.getLists();
        return {
            documentIndex: documentIndex,
            headings: headings,
            footnotes: footnotes,
            figures: figures,
            tables: tables,
            lists: lists
        };
    }
    navigate(navigationAction) {
        switch(navigationAction.navigationType){
            case (0, $652e6cb51d594b1d$export$25e50d252a728e80).NEXT:
                this.next().catch(console.warn);
                break;
            case (0, $652e6cb51d594b1d$export$25e50d252a728e80).PREVIOUS:
                this.previous().catch(console.warn);
                break;
            case (0, $652e6cb51d594b1d$export$25e50d252a728e80).TIMELINEPOSITION:
                if (navigationAction.position !== undefined) this.gotoTimelinePosition(navigationAction.position).catch(console.error);
                else console.warn("VanillaReader.event_navigationIntent()", "event.detail.position is undefined");
                break;
            case (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO:
                if (navigationAction.locator) this.goTo(navigationAction.locator).catch(console.error);
                else console.warn("VanillaReader.event_navigationIntent()", "event.detail.location is undefined");
                break;
            case (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTOSTART:
                this.goToStart().catch(console.error);
                break;
        }
        if (this.shouldFocusOnReadingPosition && navigationAction.hasOwnProperty("focusNearContentLocation") && navigationAction.focusNearContentLocation) (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("READING_POSITION_UPDATED", ()=>{
            this.focusOnReadingPosition().catch(console.warn);
        }, true);
    }
    addBookmark(bookmarkLocator) {
        return this.vanillaPublication?.addBookmark(bookmarkLocator);
    }
    deleteBookmark(bookmarkLocator) {
        if (bookmarkLocator) this.vanillaPublication?.deleteBookmark(bookmarkLocator).catch(console.warn);
    }
    updateHighlight(highlightData) {
        if (this.vanillaPublication) this.vanillaPublication.updateHighlight(highlightData).catch(console.warn);
    }
    deleteHighlight(highlightLocator) {
        this.vanillaPublication?.deleteHighlight(highlightLocator).catch(console.warn);
    }
    setPublicationOptions(styleOptions) {
        if (this.vanillaPublication) this.vanillaPublication.setPublicationOptions(styleOptions);
    }
    setPublicationStyleOptions(styleOptions) {
        if (this.vanillaReaderView) this.vanillaPublication?.setPublicationStyleOptions(styleOptions, this.vanillaReaderView);
    }
    revokeMediaObjectUrl(mediaUrl) {
        if (mediaUrl) this.vanillaPublication?.revokeResourceBlobUrl(mediaUrl);
        else // The media url was undefined, let's just revoke all urls to be on the safe side. Don't want to leak memory.
        this.vanillaPublication?.revokeAllResourceBlobUrls();
    }
    async fetchContentPositionDataForHref(href, baseDocumentLocator) {
        let baseLocation = await this.vanillaPublication?.colibrioReaderPublication.fetchContentLocation(baseDocumentLocator);
        if (!baseLocation) {
            console.warn(`VanillaReader.fetchContentPositionDataForHref(), Unable to resolve ContentLocation from locator "${baseDocumentLocator}"`);
            return;
        }
        let baseUrl = baseLocation.getReaderDocuments()[0].getSourceContentDocument().getContentUrl();
        return this.vanillaReaderView?.fetchContentPositionDataFromHref(href, baseUrl);
    }
    deletePublicationCacheData(publicationId) {
        this.vanillaPublication?.deleteStoredResources().then(()=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_STORED_RESOURCES_DELETED", {
                publicationId: publicationId
            }));
        });
    }
    toggleReaderViewPageMarkerVisibility(visible = true) {
        if (!this.vanillaReaderView?.pageMarkerLayer) {
            console.warn("VanillaReader._uiEvent_viewPageNumbersVisibilityToggleIntent(), No VanillaReaderAnnotationLayerPageRanges has been created yet.");
            return;
        }
        this.vanillaReaderView.togglePageMarkerLayer(visible);
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_PAGE_MARKERS_VISIBILITY_CHANGED", {
            visible: this.vanillaReaderView.pageMarkerLayer.isVisible
        }));
    }
    useReducedMotion(useReducedMotion) {
        if (this.vanillaReaderView) this.vanillaReaderView.useReducedMotion = useReducedMotion;
    }
    scrollOverflowingTables(scrollOverflowingTables) {
        if (this.vanillaReaderView) this.vanillaReaderView.scrollOverflowingTables = scrollOverflowingTables;
    }
    changeRenderer(rendererName, ignoreAspectRatio) {
        if (rendererName && Object.values((0, $652e6cb51d594b1d$export$7ef357ac666ee52)).includes(rendererName)) this.vanillaReaderView?.changeRenderer(rendererName, ignoreAspectRatio);
    }
    refreshReaderView(force = false) {
        this.vanillaReaderView?.refresh(force);
    }
    clearContentSelection() {
        this.vanillaReaderView?.clearContentSelection();
    }
    async toggleMediaPlayer(activate, options) {
        if (this.vanillaReaderView) {
            let completeOptions = Object.assign(this._initialOptions.syncMediaOptions || {}, options);
            if (activate) {
                let player = this.vanillaMediaPlayer;
                if (!player) player = await this._createSyncMediaPlayer(this.vanillaReaderView, completeOptions);
                player.toggle(activate);
            } else if (this.vanillaMediaPlayer) {
                this.vanillaMediaPlayer.pause();
                this.vanillaMediaPlayer.toggle(false);
            }
        } else console.warn("VanillaReader._uiEvent_mediaPlayerToggleIntent(): No _colibrioReaderView instance found. Is this an audiobook?");
    }
    seekMediaPlaybackNext() {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) this.vanillaMediaPlayer.seekToNext();
        else if (this.vanillaAudiobookPlayer) this.vanillaAudiobookPlayer.seekToNextSegment().catch(console.warn);
    }
    seekMediaPlaybackPrevious() {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) this.vanillaMediaPlayer.seekToPrevious();
        else if (this.vanillaAudiobookPlayer) this.vanillaAudiobookPlayer.seekToPreviousSegment().catch(console.warn);
    }
    seekMediaPlaybackForward() {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) this.vanillaMediaPlayer.seekForward();
        else if (this.vanillaAudiobookPlayer) this.vanillaAudiobookPlayer.seekForward();
    }
    seekMediaPlaybackBackward() {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) this.vanillaMediaPlayer.seekBackward();
        else if (this.vanillaAudiobookPlayer) this.vanillaAudiobookPlayer.seekBackward();
    }
    seekMediaToPlaybackRangeStart() {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) this.vanillaMediaPlayer.seekToPlaybackRangeStart();
    }
    seekMediaToLocator(locator) {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) this.vanillaMediaPlayer.seekToLocator(locator).catch(console.warn);
    }
    seekMediaToLocatorWithinVisibleRange(locator) {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) this.vanillaMediaPlayer.seekToLocatorWithinVisibleRange(locator).catch(console.warn);
    }
    async startMediaPlayback(locator) {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) {
            if (locator) await this.vanillaMediaPlayer.seekToLocator(locator);
            this.vanillaMediaPlayer.play();
        } else if (this.vanillaAudiobookPlayer) this.vanillaAudiobookPlayer.play().catch(console.warn);
    }
    pauseMediaPlayback() {
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) this.vanillaMediaPlayer.pause();
        else if (this.vanillaAudiobookPlayer) this.vanillaAudiobookPlayer.pause().catch(console.warn);
    }
    setMediaPlaybackRate(rate) {
        if (!this.vanillaPublication) return;
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) {
            this.vanillaMediaPlayer.setPlaybackRate(rate);
            this.vanillaPublication.ttsOptions = this.vanillaMediaPlayer.getTtsPlaybackOptions();
        } else if (this.vanillaAudiobookPlayer) this.vanillaAudiobookPlayer.setPlaybackRate(rate);
    }
    setMediaPlaybackVolume(volume) {
        if (!this.vanillaPublication) return;
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) {
            this.vanillaMediaPlayer.setVolume(volume);
            this.vanillaPublication.ttsOptions = this.vanillaMediaPlayer.getTtsPlaybackOptions();
        } else if (this.vanillaAudiobookPlayer) this.vanillaAudiobookPlayer.setVolume(volume);
    }
    async setTtsVoice(voiceName) {
        if (!this.vanillaPublication) return;
        if (this.vanillaMediaPlayer && this.vanillaMediaPlayer.playerIsAttachedToView) {
            await this.vanillaMediaPlayer.setTtsVoiceByName(voiceName).catch(console.warn);
            // Persist the options change in the VanillaPublication instance so that it will be serialized properly.
            this.vanillaPublication.ttsOptions = this.vanillaMediaPlayer.getTtsPlaybackOptions();
            // Back up the media player to the start of the phrase so that it repeats it using the new voice.
            let readingPosition = this.vanillaReaderView?.getReadingPosition();
            if (readingPosition) this.vanillaMediaPlayer.seekToLocator(readingPosition.getLocator()).catch(console.warn);
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_VOICE_CHANGED", {
                voiceName: voiceName
            }));
        }
    }
    async fetchTtsVoiceCollection() {
        let voicesCollection;
        if (this._initialOptions.syncMediaOptions?.webSpeechTtsSynthesizer) voicesCollection = await this._initialOptions.syncMediaOptions?.webSpeechTtsSynthesizer.fetchVoices();
        else voicesCollection = await (0, $410aa1fb5d04a699$export$aa8547013ca2283b).fetchTtsVoices();
        return voicesCollection;
    }
    activatePanZoomMode() {
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_TRANSFORM_PAN_MODE_ACTIVATED", {}));
    }
    deactivatePanZoomMode() {
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_TRANSFORM_PAN_MODE_DEACTIVATED", {}));
    }
    async zoomToClientRect(zoomRect, animate = true) {
        return this.vanillaReaderView?.zoomToClientRect(zoomRect, animate) || null;
    }
    zoomToPublicationViewportClientRect(zoomRect, unit = (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT, transformOptions) {
        this.vanillaReaderView?.zoomToPublicationViewportRect(zoomRect, unit, transformOptions);
    }
    resetZoom() {
        this.vanillaReaderView?.resetViewTransformation();
    }
    async zoomToLevel(zoomLevel, animate = true) {
        return this.vanillaReaderView?.zoomToLevel(zoomLevel, animate) || null;
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ /*
    *
    * You can't have an event driven architecture without events right? Let's add event listeners.
    * Almost all events are intents sent from the `VanillaReaderUI` to the `VanillaReader` as it wants to perform
    * actions, such as navigations etc.
    * */ _setUpEventBusEventHandlers() {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_ONLINE_STATE_CHANGED", this._event_appOnlineStateChanged);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("TIMELINE_READY", this._event_timelineReady);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIA_OBJECT_CLICKED", this._event_mediaObjectClicked);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARK_ADDED", this._event_bookmarkAdded);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARK_DELETED", this._event_bookmarkDeleted);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_ADDED", this._event_highlightAdded);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_DELETED", this._event_highlightDeleted);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_UPDATED", this._event_highlightUpdated);
    //VanillaReaderEventBus.addEventListener('');
    }
    /*
    *
    * Whereas events are used for module to module communication, callbacks are used  within the `VanillaReader` module to
    * act on "child component" events.
    *
    * */ _setUpComponentCallbacks() {
        /**
         * READING SYSTEM CALLBACKS
         * */ this.vanillaReadingSystem.onPublicationRendered(()=>{
            const event = (0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_RENDERED", {});
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(event);
        });
        this.vanillaReadingSystem.onReadingPositionChanged((ev)=>{
            this._event_readingPositionChanged(ev).catch(console.warn);
        });
        this.vanillaReadingSystem.onNavigationStarted((ev)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("NAVIGATION_STARTED", {
                srcEventData: ev.toJSON()
            }));
        });
        this.vanillaReadingSystem.onNavigationEnded((ev)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("NAVIGATION_COMPLETED", {
                srcEventData: ev.toJSON()
            }));
        });
        this.vanillaReadingSystem.onNavigationIntent(async (ev)=>{
            ev.preventDefault();
            // Checkout the `ui_event_navigationIntent` for the other navigation code when navigation intents are sent
            // from the UI.
            if (!ev.internalNavigation) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("NAVIGATION_EXTERNAL_INTENT", {
                targetUrl: ev.locator.toString()
            }));
            else {
                let targetContentPositionData;
                if (this._colibrioReaderPublication && ev.relatedEvent?.target?.contentLocation && (0, $98c664707733d94d$export$d4671a61002987ce).isEpubReaderPublication(this._colibrioReaderPublication)) targetContentPositionData = await this.vanillaReaderView?.fetchContentPositionData(ev.relatedEvent?.target?.contentLocation);
                // Since the UI logic may want to act on this event, if it leads to a footnote for example, we prevent it.
                // The event data contains the information needed for the UI to perform the navigation manually.
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("NAVIGATION_INTERNAL_INTENT", {
                    srcEvent: ev,
                    targetContentPositionData: targetContentPositionData
                }));
            }
        });
        this.vanillaReadingSystem.onClick(async (ev)=>{
            let contentPositionData = ev.target?.contentLocation ? await this.vanillaReaderView?.fetchContentPositionData(ev.target.contentLocation) : undefined;
            if (ev.mediaResource) {
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIA_OBJECT_CLICKED", {
                    mediaResourceData: ev.toJSON().mediaResource
                }));
                ev.preventDefault();
            }
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("CLICK", {
                srcEventData: ev.toJSON(),
                contentPositionData: contentPositionData
            }));
        });
        this.vanillaReadingSystem.onPointerUp(async (ev)=>{
            let contentPositionData = ev.target?.contentLocation ? await this.vanillaReaderView?.fetchContentPositionData(ev.target.contentLocation) : undefined;
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("POINTER_UP", {
                srcEventData: ev.toJSON(),
                contentPositionData: contentPositionData
            }));
        });
        this.vanillaReadingSystem.onPointerDown(async (ev)=>{
            let contentPositionData = ev.target?.contentLocation ? await this.vanillaReaderView?.fetchContentPositionData(ev.target.contentLocation) : undefined;
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("POINTER_DOWN", {
                srcEventData: ev.toJSON(),
                contentPositionData: contentPositionData
            }));
        });
        this.vanillaReadingSystem.onPointerMove((ev)=>{
            //let contentPositionData: IVanillaReaderContentPositionData | undefined  = ev.target?.contentLocation ? await this.vanillaReaderView?.fetchContentPositionData(ev.target.contentLocation) : undefined;
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("POINTER_MOVE", {
                srcEventData: ev.toJSON(),
                contentPositionData: undefined
            }));
        });
        this.vanillaReadingSystem.onVisibleRangeChanged(()=>{
            this._event_visibleRangeDataChanged().catch(console.warn);
        });
        this.vanillaReadingSystem.onSelectionChanged((ev)=>{
            this._event_textSelected(ev);
        });
        this.vanillaReadingSystem.onKeyDown((ev)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("KEY_DOWN", {
                srcEventData: ev.toJSON()
            }));
        });
        this.vanillaReadingSystem.onKeyUp((ev)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("KEY_UP", {
                srcEventData: ev.toJSON()
            }));
        });
        this.vanillaReadingSystem.onPublicationDownloadProgress((progress, url)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_DOWNLOAD_PROGRESS_UPDATED", {
                progress: progress,
                publicationId: url
            }));
        });
    /*
        *
        * STORAGE CALLBACKS
        *
        * */ // These are set up when the SyncMediaPlayer is created. Check out _createSyncMediaPlayer().
    }
    /*
    * _onAfterPublicationLoaded is called after we have a ReaderPublication. This is when we can do all fun stuff such as,
    *
    * - build the search index
    * - build the navigation tree
    * - etc
    *
    * And once all that is done, we can dispatch the `IVanillaReaderAppEvent_PUBLICATION_LOADED` event to everyone that
    * are listening.
    *
    * It has some less optimal aspects still as it has some reliance on the order in which some methods are
    * called. Refactoring is on the todo 🙂
    *
    * */ async _onAfterPublicationLoaded(fileName, fileSourceUri, colibrioReaderPublication, shelfItem, initialLocator) {
        this.vanillaPublication = await (0, $476ea80a98863215$export$55c96f9dadd6836).create(fileName, fileSourceUri, colibrioReaderPublication, shelfItem);
        // TODO: Move to VanillaReaderPublication.ts.
        let initialPublicationCacheDataState = await shelfItem?.fetchCacheData();
        if (this.vanillaPublication.isAudiobook) {
            await this._createAudiobookView(this.vanillaPublication);
            this.vanillaAudiobookPlayer = new (0, $d81cf4a2310ad240$export$4c677816971e17bc)(this.vanillaPublication);
            this.vanillaAudiobookPlayer.onMediaPlayerCreated(async ()=>{
                this.vanillaReadingProgressionTimeLine = await this._createReadingProgressionTimeline(this.vanillaPublication);
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_CREATED", {}));
            });
            this.vanillaAudiobookPlayer.onMediaPlayerCreateProgressUpdated((progress)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_CREATE_PROGRESS_UPDATED", {
                    progress: progress
                }));
            });
            await this.vanillaAudiobookPlayer.createSyncMediaTimeLine();
            this.vanillaAudiobookPlayer.onMediaPlayerPlaybackStateChanged((state)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_PLAYBACK_STATE_CHANGED", {
                    state: state
                }));
            });
            this.vanillaAudiobookPlayer.onMediaPlayerPlaybackPositionChanged(async (state)=>{
                let timelinePosition = state.position;
                let contentLocation = await this.vanillaAudiobookPlayer?.getTimeline().fetchContentLocation(timelinePosition);
                if (contentLocation) {
                    let locator = contentLocation.getLocator().toString();
                    const readingPositionData = {
                        publicationId: this.vanillaPublication?.id,
                        locator: locator,
                        timestamp: Date.now(),
                        navItemData: state.navigationItems
                    };
                    if (readingPositionData && this.vanillaPublication) {
                        this.vanillaPublication.setCurrentReadingPositionData(readingPositionData);
                        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("READING_POSITION_UPDATED", {
                            readingPositionData: readingPositionData
                        }));
                    }
                }
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_PLAYBACK_POSITION_CHANGED", {
                    state: state
                }));
            });
            this.vanillaAudiobookPlayer.onMediaPlayerTrackChanged((state)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("MEDIAPLAYER_SEEK_COMPLETED", {
                    state: state
                }));
            });
        } else {
            /*
            *
            * EPUB and PDF specific setup
            *
            * */ this.vanillaReaderView = new (0, $9ff050ad3115202b$export$b034d7788f93e3ea)(this.vanillaReadingSystem, this.vanillaPublication, this.readerViewElement, this.vanillaOptionsDataStore, this._initialOptions?.customReaderViewContentOnLoading, this._initialOptions?.customReaderViewContentOnLoadError);
            this.vanillaReaderView.onActiveRendererChanged((ev)=>{
                const rendererName = ev.newActiveRenderer?.getName();
                const newRendererName = rendererName && Object.values((0, $652e6cb51d594b1d$export$7ef357ac666ee52)).some((v)=>v === rendererName) ? rendererName : undefined;
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("RENDERER_CHANGED", {
                    newActiveRendererName: newRendererName,
                    newActiveRendererOptions: ev.newActiveRenderer?.getOptions()
                }));
            });
            this.vanillaReaderView.onRendererTransitionStarted((ev)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_TRANSITION_STARTED", {
                    srcEventData: ev.toJSON()
                }));
            });
            this.vanillaReaderView.onRendererTransitionEnded((ev)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_TRANSITION_ENDED", {
                    srcEventData: ev.toJSON()
                }));
            });
            this.vanillaReaderView.onReducedMotionValueChanged((preference)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("REDUCED_MOTION_OPTION_CHANGED", {
                    useReducedMotion: preference
                }));
            });
            this.vanillaReaderView.onIgnoreAspectRatioValueChanged((ignore)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("RENDERER_ASPECT_RATIO_CHANGED", {
                    ignoreAspectRatio: ignore
                }));
            });
            this.vanillaReaderView.onSwipeNavigationGestureProgress((eventData)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("VIEW_SWIPE_NAVIGATION_PROGRESS_UPDATED", {
                    srcEventData: eventData
                }));
            });
            // Now we need to do some asynchronous set up, so we call the async _setup() method.
            await this.vanillaReaderView.setup().catch(console.warn);
            var that = this;
            this._createReadingProgressionTimeline(this.vanillaPublication, initialPublicationCacheDataState?.timelineData).then((timeline)=>{
                that.vanillaReadingProgressionTimeLine = timeline;
            });
            this.vanillaPublicationSearch = new (0, $0771c0f7ebac4abb$export$176db2ff6977fb36)(this.vanillaPublication.colibrioReaderPublication, this.vanillaReaderView.colibrioReaderView);
            this.vanillaPublicationSearch?.onSearchIndexCreateProgressUpdate((progress)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_SEARCH_INDEX_BUILD_PROGRESS", {
                    progress: progress
                }));
            });
            this.vanillaPublicationSearch?.onSearchIndexCreated(()=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_SEARCH_INDEX_READY", {}));
            });
        }
        // We want to preserve all style options *except* for palette which the user will expect to mirror the app theme.
        if (this._initialOptions?.viewOptions?.colibrioReaderViewOptions?.publicationStyleOptions?.palette) this.vanillaReaderView?.setVanillaReaderViewOptions({
            colibrioReaderViewOptions: {
                publicationStyleOptions: {
                    palette: this._initialOptions?.viewOptions?.colibrioReaderViewOptions?.publicationStyleOptions?.palette
                }
            }
        });
        /**
         * If the book has been opened by the user before it will probably have some state that should be restored from
         * the previous session, such as style publicationStyleOptions, bookmarks and highlights.
         **/ await this._restoreBookmarks().catch(console.warn);
        await this._restoreHighlights().catch(console.warn);
        this.goToStart().catch(console.error);
        // The publication is loaded, and we are ready to tell the UI that it can do its thing.
        // We start with serializing the initial publication state so that we can send it back to the UI.
        let vanillaPublicationData = await this.vanillaPublication.serialize();
        let publicationOptionsData = await this.vanillaPublication.fetchPublicationOptionsData();
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_LOADED", {
            initialPosition: initialLocator,
            publicationData: vanillaPublicationData,
            publicationOptionsData: publicationOptionsData
        }));
        this.isLoaded = true;
    }
    /*
    *
    * _createAudiobookView renders a simple view that contains the audiobook cover image. It also adds pointer event
    * listeners to the cover image containers.
    *
    * For EPUB and PDF publications, please check out the _createReaderView method.
    *
    * */ async _createAudiobookView(vanillaReaderPublication) {
        this.vanillaAudiobookView = new (0, $0bdc67ad7a08435e$export$c3a1133d4c602a0e)(vanillaReaderPublication, this.readerViewElement);
        return this.vanillaAudiobookView.render();
    }
    /*
    *
    * The VanillaReader has a general implementation of a reading progress timeline in order to abstract away the differences
    * between Audiobooks and text based books such as EPUB and PDF (`IVanillaReaderReadingProgressionTimeline`).
    *
    * "Under the hood" Audiobooks use the Colibrio `SyncMediaTimeline`, for EPUB and PDF the `ContentPositionTimeline`
    * is used.
    *
    * This method creates and returns a new instance of the `IVanillaReaderReadingProgressionTimeline` which is then used
    * in
    *
    * */ async _createReadingProgressionTimeline(vanillaPublication, timelineSerializedData) {
        let readingProgressionTimeLine;
        if (!vanillaPublication.isAudiobook && this.vanillaReaderView) /*
            * EPUB and PDF specific setup
            * */ readingProgressionTimeLine = await (0, $ba8410d8a7579ed8$export$427f316d5d7b1929).create(this.vanillaReaderView, vanillaPublication, timelineSerializedData, (progress)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("TIMELINE_BUILD_PROCESS_UPDATED", {
                progress: progress
            }));
        });
        else if (this.vanillaAudiobookPlayer) /*
            * Audiobook specific setup
            * */ {
            if (this.vanillaAudiobookPlayer.hasBeenCreated) readingProgressionTimeLine = this.vanillaAudiobookPlayer.getTimeline();
        }
        vanillaPublication.progressionTimeline = readingProgressionTimeLine;
        this.vanillaReadingProgressionTimeLine = readingProgressionTimeLine;
        readingProgressionTimeLine?.onTimelinePositionUpdated((position)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("TIMELINE_POSITION_UPDATED", {
                timelinePosition: position
            }));
        });
        // The timeline can take a moment to build, so we need to send an event when it has finished building. Check out
        // the `_event_timelineReady` handler to follow this thread in the `VanillaReader`.
        readingProgressionTimeLine?.onTimelineReady((timelineData)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("TIMELINE_READY", {
                timelineData: timelineData
            }));
        });
        return readingProgressionTimeLine;
    }
    _registerWordRangeReadToStats(wordRange) {
        this.vanillaReaderView?.readingStats?.addWordRange(wordRange);
    }
    /**
     *
     * This method creates an instance of a `VanillaReaderMediaPlayer`. This object will be used for playback of TTS or
     * EPUB Media Overlays.
     *
     * If you are looking for the method that creates the audiobook player it is done in the `_onAfterPublicationLoaded`.
     *
     * */ async _createSyncMediaPlayer(vanillaReaderView, syncMediaOptions) {
        this.vanillaMediaPlayer = new (0, $69e0beaac038bdf1$export$768bbf8f69747591)(vanillaReaderView, syncMediaOptions, this._event_onSyncMediaPlayerCreateProgress);
        this.vanillaMediaPlayer.onAttached(this._event_onSyncMediaPlayerAttached);
        this.vanillaMediaPlayer.onDetached(this._event_onSyncMediaPlayerDetached);
        this.vanillaMediaPlayer.onCreated(this._event_onSyncMediaPlayerCreated);
        this.vanillaMediaPlayer.onPlaybackStateChanged(this._event_onSyncMediaPlayerPlaybackStateChanged);
        this.vanillaMediaPlayer.onRangePlaybackRemoved(this._event_onSyncMediaRangePlaybackRemoved);
        this.vanillaMediaPlayer.onRangePlaybackEndReached(this._event_onSyncMediaRangePlaybackEndReached);
        this.vanillaMediaPlayer.onEscapabilityContextChanged(this._event_onSyncMediaEscapabilityContentChanged);
        await this.vanillaMediaPlayer.create().catch(console.warn);
        this.vanillaMediaPlayer.setEscapabableContentBlockTypes([
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).ASIDE,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).TABLE,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).TABLE_CELL,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).TABLE_ROW,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).ORDERED_LIST,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).UNORDERED_LIST,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).DESCRIPTION_LIST,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).LIST_ITEM,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).MATHML,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).MATHML_TABLE,
            (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).PREFORMATTED
        ]);
        return this.vanillaMediaPlayer;
    }
    async _restoreBookmarks(_silent = true) {
        if (this.vanillaPublication?.id) {
            let bookmarks = await this.vanillaPublication.fetchBookmarks();
            this.vanillaReaderView?.renderBookmarks(bookmarks);
            // Dispatch events so that the UI can update its state.
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARKS_LOADED", {
                bookmarks: bookmarks
            }));
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARKS_COLLECTION_UPDATED", {
                bookmarks: bookmarks
            }));
        }
    }
    async _restoreHighlights(_silent = true) {
        if (this.vanillaPublication && this.vanillaPublication.id) {
            let highlights = await this.vanillaPublication.fetchHighlights();
            this.vanillaReaderView?.renderHighlights(highlights);
            // Dispatch events so that the UI can update its state.
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHTS_LOADED", {
                highlights: highlights
            }));
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHTS_COLLECTION_UPDATED", {
                highlights: highlights
            }));
        }
    }
}



class $0909cef3c226bd78$export$60ea34962201b1d7 {
    constructor(_streamedResourcesStore, _id, _name, _url, _mimetype, _size){
        this._streamedResourcesStore = _streamedResourcesStore;
        this._id = _id;
        this._name = _name;
        this._url = _url;
        this._mimetype = _mimetype;
    }
    static async instantiate(stateData, streamedResourcesStore) {
        return new $0909cef3c226bd78$export$60ea34962201b1d7(streamedResourcesStore, stateData.id, stateData.name, stateData.url, stateData.mimetype, stateData.size);
    }
    static async create(streamedResourcesStore, id, name, url, mimetype, size = 0) {
        if (!await streamedResourcesStore.hasResource(id)) {
            streamedResourcesStore.addResource({
                id: id,
                mimetype: mimetype,
                url: url,
                name: name,
                size: size
            }).catch(console.error);
            return new $0909cef3c226bd78$export$60ea34962201b1d7(streamedResourcesStore, id, name, url, mimetype, size);
        } else throw new DOMException(`VanillaReaderShelfItemStoredResource.create(), Resource with id "${id}" already exists.`);
    }
    get size() {
        return this._size;
    }
    set size(value) {
        this._size = value;
    }
    get mimetype() {
        return this._mimetype;
    }
    set mimetype(value) {
        this._mimetype = value;
    }
    get url() {
        return this._url;
    }
    set url(value) {
        this._url = value;
    }
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    async hasData() {
        return this._streamedResourcesStore.hasResource(this.id);
    }
    async hasChunkAtOffset(startOffset) {
        return await this._streamedResourcesStore.hasResourceDataByStartOffset(this.id, startOffset) || false;
    }
    async fetchChunkAtOffset(startOffset) {
        return await this._streamedResourcesStore.getResourceDataByStartOffset(this.id, startOffset) || undefined;
    }
    async addChunk(startOffset, endOffset, arrayBuffer) {
        return this._streamedResourcesStore.addResourceData(this.id, startOffset, endOffset, arrayBuffer);
    }
    async deleteData() {
        return this._streamedResourcesStore.deleteResource(this.id);
    }
}


class $e908cf2286e24abc$export$9ad8c9f91059c544 {
    constructor(_vanillaReaderAppStorage, data, hasBeenPersisted, latestReadingPositionData, storedResource){
        this._vanillaReaderAppStorage = _vanillaReaderAppStorage;
        this._hasBeenPersisted = false;
        this._id = data.id;
        this._fileName = data.fileName;
        this._fileSourceUri = data.fileSourceUri;
        this._url = data.url;
        this._format = data.format;
        this._language = data.language;
        this._isFixedLayout = data.isFixedLayout;
        this._title = data.title;
        this._isRtl = data.isRtl;
        this._isScripted = data.isScripted;
        this._isAudiobook = data.isAudiobook;
        this._hasMoSyncMedia = data.hasMoSyncMedia;
        this._metadata = data.metadata;
        this._coverImageAsBase64 = data.coverImageAsBase64;
        this._latestReadingPositionData = latestReadingPositionData;
        this.hasBeenPersisted = hasBeenPersisted;
        if (storedResource) this._storedResource = storedResource;
    }
    static async instantiate(stateData, vanillaReaderAppStorage) {
        let latestReadingPosition;
        let exists = await vanillaReaderAppStorage.publicationDataStore.hasPublicationData(stateData.id);
        if (!exists) throw new DOMException(`VanillaReaderShelfItem.instantiate, item does not exist "${stateData.fileName}".`);
        latestReadingPosition = await vanillaReaderAppStorage.publicationDataStore.fetchPublicationReadingPositionData(stateData.id) || undefined;
        return new $e908cf2286e24abc$export$9ad8c9f91059c544(vanillaReaderAppStorage, stateData, true, latestReadingPosition);
    }
    static async create(fileName, fileSourceUri, format, vanillaReaderAppStorage) {
        let hasBeenPersisted = false;
        let data;
        let id;
        id = fileSourceUri;
        data = {
            id: fileSourceUri,
            fileName: fileName,
            fileSourceUri: fileSourceUri,
            url: fileSourceUri,
            format: format
        };
        await vanillaReaderAppStorage.publicationDataStore.setPublicationData(id, data);
        return new $e908cf2286e24abc$export$9ad8c9f91059c544(vanillaReaderAppStorage, data, hasBeenPersisted);
    }
    get id() {
        return this._id;
    }
    hasOfflineData() {
        return this._vanillaReaderAppStorage.streamedResourcesDataStore.hasResource(this.fileSourceUri);
    }
    get readingPositionData() {
        return this._latestReadingPositionData;
    }
    get language() {
        return this._language;
    }
    get coverImageAsBase64() {
        return this._coverImageAsBase64;
    }
    get metadata() {
        return this._metadata;
    }
    get hasMoSyncMedia() {
        return this._hasMoSyncMedia;
    }
    get isAudiobook() {
        return this._isAudiobook;
    }
    get isScripted() {
        return this._isScripted;
    }
    get isFixedLayout() {
        return this._isFixedLayout;
    }
    get isRtl() {
        return this._isRtl;
    }
    get url() {
        return this._url;
    }
    get format() {
        return this._format;
    }
    get title() {
        return this._title;
    }
    get fileSourceUri() {
        return this._fileSourceUri;
    }
    get fileName() {
        return this._fileName;
    }
    get categories() {
        return this._categories;
    }
    set categories(values) {
        this._categories = values;
    }
    get starred() {
        return this._starred;
    }
    set starred(value) {
        this._starred = value;
    }
    get hasBeenPersisted() {
        return this._hasBeenPersisted;
    }
    set hasBeenPersisted(persisted) {
        this._hasBeenPersisted = persisted;
    }
    get publicationData() {
        return this._publicationData;
    }
    fetchBookmarks() {
        return this._vanillaReaderAppStorage.bookmarkDataStore.fetchBookmarksByPublication(this.id);
    }
    addBookmark(bookmarkData) {
        return this._vanillaReaderAppStorage.bookmarkDataStore.addBookmark(bookmarkData);
    }
    deleteBookmark(bookmarkLocator) {
        return this._vanillaReaderAppStorage.bookmarkDataStore.deleteBookmark(bookmarkLocator);
    }
    fetchHighlights() {
        return this._vanillaReaderAppStorage.highlightDataStore.fetchHighlightsByPublication(this.id);
    }
    addHighlights(highlightData, silent) {
        return this._vanillaReaderAppStorage.highlightDataStore.addHighlights(highlightData, silent);
    }
    addHighlight(highlightData) {
        return this._vanillaReaderAppStorage.highlightDataStore.addHighlight(highlightData);
    }
    updateHighlight(highlightData) {
        return this._vanillaReaderAppStorage.highlightDataStore.updateHighlight(highlightData);
    }
    deleteHighlight(highlightLocator) {
        return this._vanillaReaderAppStorage.highlightDataStore.deleteHighlight(highlightLocator);
    }
    fetchReadingPositionData() {
        //Removed this to prevent previous stored locators in browser from reopening at last-left-off page.
        return Promise.resolve(undefined);
    //return this._vanillaReaderAppStorage.publicationDataStore.fetchPublicationReadingPositionData(this.id);
    }
    setReadingPositionData(readingPositionData) {
        return this._vanillaReaderAppStorage.publicationDataStore.setPublicationReadingPositionData(this._id, readingPositionData);
    }
    deleteStoredResource() {
        this._storedResource = undefined;
        return this._vanillaReaderAppStorage.streamedResourcesDataStore.deleteResource(this.id);
    }
    hasCachedData() {
        return this._vanillaReaderAppStorage.publicationDataStore.hasPublicationCacheData(this.id);
    }
    fetchCacheData() {
        return this._vanillaReaderAppStorage.publicationDataStore.fetchPublicationCacheData(this.id);
    }
    setCacheData(cacheData) {
        return this._vanillaReaderAppStorage.publicationDataStore.setPublicationCacheData(this.id, cacheData);
    }
    updateCacheData(cacheData) {
        return this._vanillaReaderAppStorage.publicationDataStore.updatePublicationCacheData(this.id, cacheData);
    }
    deleteCacheData() {
        return this._vanillaReaderAppStorage.publicationDataStore.deletePublicationCacheData(this.id);
    }
    hasOptionsData() {
        return this._vanillaReaderAppStorage.publicationDataStore.hasPublicationOptionsData(this.id);
    }
    fetchOptionsData() {
        return this._vanillaReaderAppStorage.publicationDataStore.fetchPublicationOptionsData(this.id);
    }
    setOptionsData(optionsData) {
        return this._vanillaReaderAppStorage.publicationDataStore.setPublicationOptionsData(this.id, optionsData);
    }
    updateOptionsData(optionsData) {
        return this._vanillaReaderAppStorage.publicationDataStore.updatePublicationOptionsData(this.id, optionsData);
    }
    fetchPublicationData() {
        return this._vanillaReaderAppStorage.publicationDataStore.fetchPublicationData(this.id);
    }
    async setPublicationData(data) {
        this._id = data.id;
        this._title = data.title;
        this._isRtl = data.isRtl;
        this._isFixedLayout = data.isFixedLayout;
        this._isScripted = data.isScripted;
        this._isAudiobook = data.isAudiobook;
        this._hasMoSyncMedia = data.hasMoSyncMedia;
        this._metadata = data.metadata;
        this._coverImageAsBase64 = data.coverImageAsBase64;
        this._language = data.language;
        return this._vanillaReaderAppStorage.publicationDataStore.updatePublicationDataByFileName(this.fileName, data).then(()=>{
            this.hasBeenPersisted = true;
        });
    }
    async hasStoredResource() {
        return this._vanillaReaderAppStorage.streamedResourcesDataStore.hasResource(this.fileSourceUri);
    }
    async fetchStoredResource() {
        if (!this._storedResource) {
            let storedResourceData = await this._vanillaReaderAppStorage.streamedResourcesDataStore.getResource(this.fileSourceUri);
            if (storedResourceData) this._storedResource = await (0, $0909cef3c226bd78$export$60ea34962201b1d7).instantiate(storedResourceData, this._vanillaReaderAppStorage.streamedResourcesDataStore);
        }
        return this._storedResource;
    }
    async createStoredResource(size = 0, file) {
        if (!this.id) throw new DOMException(`VanillaReaderShelfItem.createStoredResource(), Shelf item id is undefined.`);
        /*
        * NOTE
        *
        * If you want to make it harder for hackers to extract publication data from the store, please use some kind of
        * hashing strategy for the parameter data.
        */ this._storedResource = await (0, $0909cef3c226bd78$export$60ea34962201b1d7).create(this._vanillaReaderAppStorage.streamedResourcesDataStore, this.fileSourceUri, this.fileName, this.url, this.format, size);
        if (file) {
            this._storedResource.size = file.size;
            let fileArrayBuffer = await file.arrayBuffer();
            this._vanillaReaderAppStorage.streamedResourcesDataStore.addResourceData(this.fileSourceUri, 0, file.size, fileArrayBuffer).catch((reason)=>{
                console.error(reason);
            });
        }
        return this._storedResource;
    }
    async serialize() {
        return this._vanillaReaderAppStorage.publicationDataStore.fetchPublicationData(this.id);
    }
}


class $65b364fa4af2a76a$export$fccf27e8fa078aff {
    constructor(_vanillaReaderAppStorage){
        this._vanillaReaderAppStorage = _vanillaReaderAppStorage;
        this._onPublicationDataAdded = async (publicationData)=>{
            if (this._onShelfItemAddedCallback) {
                let shelfItem = await this.fetchShelfItemById(publicationData.id);
                if (!shelfItem) {
                    console.warn(`VanillaReaderBookshelf._onPublicationDataAdded(), Publication "${publicationData.id}" not found in the store.`);
                    return;
                }
                this._onShelfItemAddedCallback(shelfItem);
            }
        };
        this._onPublicationDataUpdated = async (publicationData)=>{
            if (this._onShelfItemUpdatedCallback) {
                let shelfItem = await this.fetchShelfItemById(publicationData.id);
                if (!shelfItem) {
                    console.warn(`VanillaReaderBookshelf._onPublicationDataUpdated(), Publication "${publicationData.id}" not found in the store.`);
                    return;
                }
                this._onShelfItemUpdatedCallback(shelfItem);
            }
        };
        this._onPublicationDataDeleted = ()=>{
            if (this._onShelfItemDeletedCallback) this._onShelfItemDeletedCallback();
        };
        this._onPublicationStreamedDataDownloadProgressUpdated = (ev)=>{
            if (ev.detail.publicationId) {
                if (ev.detail.progress < 1) {
                    if (this._onShelfItemDownloadProgressUpdatedCallback) this._onShelfItemDownloadProgressUpdatedCallback(ev.detail.progress, ev.detail.publicationId);
                } else if (this._onShelfItemDownloadCompletedCallback) this._onShelfItemDownloadCompletedCallback(ev.detail.progress, ev.detail.publicationId);
            }
        };
        this._onHighlightAdded = (highlight, silent)=>{
            // The `silent` parameter tells us that we should not send an event to the UI. This is used when the `addHighlight`
            // method is called repeatedly from the `addHighlights` batch method.
            if (!silent) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHT_ADDED", {
                highlight: highlight
            }));
            if (highlight.publicationId) this._vanillaReaderAppStorage.highlightDataStore.fetchHighlightsByPublication(highlight.publicationId).then((highlights)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHTS_COLLECTION_UPDATED", {
                    highlights: highlights
                }));
            }).catch(console.warn);
        };
        this._onHighlightUpdated = (highlight)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHT_UPDATED", {
                highlight: highlight
            }));
            if (highlight.publicationId) this._vanillaReaderAppStorage.highlightDataStore.fetchHighlightsByPublication(highlight.publicationId).then((highlights)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHTS_COLLECTION_UPDATED", {
                    highlights: highlights
                }));
            }).catch(console.warn);
        };
        this._onHighlightDeleted = (highlight)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHT_DELETED", {
                locator: highlight.locator
            }));
            if (highlight.publicationId) this._vanillaReaderAppStorage.highlightDataStore.fetchHighlightsByPublication(highlight.publicationId).then((highlights)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("HIGHLIGHTS_COLLECTION_UPDATED", {
                    highlights: highlights
                }));
            }).catch(console.warn);
        };
        this._onBookmarkAdded = (bookmarkData, silent)=>{
            // The `silent` parameter tells us that we should not send an event to the UI. This is used when the `addBookmark`
            // method is called repeatedly from the `addBookmarks` batch method.
            if (!silent) (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARK_ADDED", {
                bookmark: bookmarkData
            }));
            if (bookmarkData.publicationId) this._vanillaReaderAppStorage.bookmarkDataStore.fetchBookmarksByPublication(bookmarkData.publicationId).then((bookmarks)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARKS_COLLECTION_UPDATED", {
                    bookmarks: bookmarks
                }));
            }).catch(console.warn);
        };
        this._onBookmarkDeleted = (bookmarkData)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARK_DELETED", {
                locator: bookmarkData.locator
            }));
            if (bookmarkData.publicationId) this._vanillaReaderAppStorage.bookmarkDataStore.fetchBookmarksByPublication(bookmarkData.publicationId).then((bookmarks)=>{
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("BOOKMARKS_COLLECTION_UPDATED", {
                    bookmarks: bookmarks
                }));
            }).catch(console.warn);
        };
        this._onResourceDeleted = (id)=>{
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_STORED_RESOURCES_DELETED", {
                publicationId: id
            }));
        };
        this._vanillaReaderAppStorage.publicationDataStore.onPublicationDataAdded(this._onPublicationDataAdded);
        this._vanillaReaderAppStorage.publicationDataStore.onPublicationDataDeleted(this._onPublicationDataDeleted);
        this._vanillaReaderAppStorage.publicationDataStore.onPublicationDataUpdated(this._onPublicationDataUpdated);
        // Highlights callbacks
        this._vanillaReaderAppStorage.highlightDataStore.onHighlightAdded(this._onHighlightAdded);
        this._vanillaReaderAppStorage.highlightDataStore.onHighlightUpdated(this._onHighlightUpdated);
        this._vanillaReaderAppStorage.highlightDataStore.onHighlightDeleted(this._onHighlightDeleted);
        // Bookmarks callbacks
        this._vanillaReaderAppStorage.bookmarkDataStore.onBookmarkAdded(this._onBookmarkAdded);
        this._vanillaReaderAppStorage.bookmarkDataStore.onBookmarkDeleted(this._onBookmarkDeleted);
        // StoredResource callback
        this._vanillaReaderAppStorage.streamedResourcesDataStore.onResourceDeleted(this._onResourceDeleted);
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_DOWNLOAD_PROGRESS_UPDATED", this._onPublicationStreamedDataDownloadProgressUpdated);
    }
    onShelfItemDeleted(callback) {
        this._onShelfItemDeletedCallback = callback;
    }
    onShelfItemAdded(callback) {
        this._onShelfItemAddedCallback = callback;
    }
    onShelfItemUpdated(callback) {
        this._onShelfItemUpdatedCallback = callback;
    }
    onShelfItemDownloadProgressUpdated(callback) {
        this._onShelfItemDownloadProgressUpdatedCallback = callback;
    }
    onShelfItemDownloadProgressCompleted(callback) {
        this._onShelfItemDownloadCompletedCallback = callback;
    }
    onBookshelfUpdated(callback) {
        this._onBookshelfUpdatedCallback = callback;
    }
    async hasShelfItemById(id) {
        return this._vanillaReaderAppStorage.publicationDataStore.hasPublicationData(id);
    }
    async hasShelfItemByFileName(fileName) {
        return this._vanillaReaderAppStorage.publicationDataStore.hasPublicationDataByFileName(fileName);
    }
    async fetchShelfItems(storedOnly = true) {
        let shelfItems = [];
        // Get all stored publications.
        let vanillaReaderPublicationData = await this._vanillaReaderAppStorage.publicationDataStore.fetchAllPublicationData();
        for (const item of vanillaReaderPublicationData){
            if (item.id && item.fileSourceUri) // All stored publications has uri that reflects the protocol that was used to originally fetch the file.
            // It will be "file://" if it was loaded from disc, and "http://" if it loaded from the web.
            {
                if (item.fileSourceUri.includes("://")) {
                    if (storedOnly && !await this.shelfItemHasStoredResource(item.fileSourceUri)) continue;
                    try {
                        let shelfItem = await (0, $e908cf2286e24abc$export$9ad8c9f91059c544).instantiate(item, this._vanillaReaderAppStorage);
                        shelfItems.push(shelfItem);
                    } catch (e) {
                        console.warn(`VanillaReaderBookshelf.fetchShelfItems(), Failed to load shelf item "${item.id}"`);
                    }
                }
            }
        }
        //console.log('fetchShelfItems end', Date.now() -startTime);
        return shelfItems;
    }
    async fetchShelfItemById(id) {
        let vanillaReaderPublicationData = await this._vanillaReaderAppStorage.publicationDataStore.fetchPublicationData(id);
        if (!vanillaReaderPublicationData) return undefined;
        return (0, $e908cf2286e24abc$export$9ad8c9f91059c544).instantiate(vanillaReaderPublicationData, this._vanillaReaderAppStorage);
    }
    async fetchShelfItemByFileName(fileName) {
        let vanillaReaderPublicationData = await this._vanillaReaderAppStorage.publicationDataStore.fetchPublicationDataByFileName(fileName);
        if (!vanillaReaderPublicationData?.id || !vanillaReaderPublicationData?.fileSourceUri) return undefined;
        if (!vanillaReaderPublicationData.fileSourceUri.includes("://")) return undefined;
        return (0, $e908cf2286e24abc$export$9ad8c9f91059c544).instantiate(vanillaReaderPublicationData, this._vanillaReaderAppStorage);
    }
    async deleteShelfItem(shelfItemData) {
        if (shelfItemData.id) {
            await this._vanillaReaderAppStorage.publicationDataStore.deletePublicationDataByFileName(shelfItemData.fileName);
            await this._vanillaReaderAppStorage.publicationDataStore.deletePublicationOptionsData(shelfItemData.id);
            await this._vanillaReaderAppStorage.publicationDataStore.deletePublicationCacheData(shelfItemData.id);
            await this._vanillaReaderAppStorage.publicationDataStore.clearPublicationReadingPositionData(shelfItemData.id);
            await this._vanillaReaderAppStorage.streamedResourcesDataStore.deleteResourceByName(shelfItemData.fileName);
            let updatedShelfItems = await this.fetchShelfItems();
            if (this._onShelfItemDeletedCallback) this._onShelfItemDeletedCallback();
            if (this._onBookshelfUpdatedCallback) this._onBookshelfUpdatedCallback(updatedShelfItems);
        } else console.warn(`Unable to delete publication ${shelfItemData.fileName} since it did not have an have a valid id.`);
    }
    async addShelfItem(fileName, fileSourceUri, mimetype) {
        let fileExtension = fileName.slice(fileName.lastIndexOf(".") + 1).toLowerCase();
        let fileType = $65b364fa4af2a76a$export$fccf27e8fa078aff._getTypeFromFileExtension(fileExtension);
        if (!fileType) throw new DOMException(`VanillaReaderShelfItem(), file type "${fileExtension}" is not a valid format.`);
        mimetype = mimetype || fileType;
        return (0, $e908cf2286e24abc$export$9ad8c9f91059c544).create(fileName, fileSourceUri, mimetype, this._vanillaReaderAppStorage);
    }
    async shelfItemHasStoredResource(publicationUrl) {
        return this._vanillaReaderAppStorage.streamedResourcesDataStore.hasResource(publicationUrl);
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ static _getTypeFromFileExtension(extension) {
        let fileExtToTypeMap = new Map([
            [
                "epub",
                "application/epub+zip"
            ],
            [
                "lpf",
                "application/lpf+zip"
            ],
            [
                "pdf",
                "application/pdf"
            ]
        ]);
        return fileExtToTypeMap.get(extension);
    }
}








class $10165c303434af76$export$e57b06630a998963 {
    constructor(_hostElement, insertPosition = "beforeend"){
        this._hostElement = _hostElement;
        this._style = `
    <style>
        #vanilla-reader__button-side-menu {
            opacity: 1;
            height: 24px;
            width: auto;            
            bottom: 8px;
            transition: opacity ease-in-out 0.2s;            
            cursor: pointer;
            z-index: 1;
            background-color: transparent;
            font-size:1.5rem;
            color: var(--vanilla-reader__color__ui__foreground-dark);
            border: none;
        }
        #vanilla-reader__button-menu {
            opacity: 1;
            height: 24px;
            width: auto;            
            bottom: 8px;
            transition: opacity ease-in-out 0.2s;            
            cursor: pointer;
            z-index: 1;
            opacity: 0.5;
            background-color: var(--vanilla-reader__color__ui__background-light);
            color: var(--vanilla-reader__color__ui__foreground-dark);
        }
    </style>`;
        this._template = `
        <button id="vanilla-reader__button-side-menu" title="Open main menu" tabindex="0" accesskey="m"><span aria-hidden="true">menu</span></button>
        <button id="vanilla-reader__button-menu" title="Open main menu" tabindex="0" accesskey="m"><span aria-hidden="true">drag_handle</span></button>
    `;
        this._hostElement.insertAdjacentHTML(insertPosition, this._style);
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._sideMenuButton = this._hostElement.querySelector("#vanilla-reader__button-side-menu");
        this._sideMenuButton.addEventListener("click", (_ev)=>{
            if (this._onSideMenuClickCallback) this._onSideMenuClickCallback();
        });
        this._menuButton = this._hostElement.querySelector("#vanilla-reader__button-menu");
        this._menuButton.addEventListener("click", (_ev)=>{
            if (this._onClickCallback) this._onClickCallback();
        });
    }
    show() {
        this._menuButton.removeAttribute("aria-hidden");
        this._menuButton.style.opacity = "1";
        this._menuButton.style.pointerEvents = "all";
        if (this._onMenuVisibleCallback) this._onMenuVisibleCallback();
    }
    hide() {
        this._menuButton.ariaHidden = "true";
        this._menuButton.style.opacity = "0";
        this._menuButton.style.pointerEvents = "none";
        if (this._onMenuHiddenCallback) this._onMenuHiddenCallback();
    }
    onMenuClick(callback) {
        this._onClickCallback = callback;
    }
    onMenuVisible(callback) {
        this._onMenuVisibleCallback = callback;
    }
    onMenuHidden(callback) {
        this._onMenuHiddenCallback = callback;
    }
    showSideMenu() {
        this._sideMenuButton.removeAttribute("aria-hidden");
        this._sideMenuButton.style.opacity = "1";
        this._sideMenuButton.style.pointerEvents = "all";
        if (this._onSideMenuVisibleCallback) this._onSideMenuVisibleCallback();
    }
    hideSideMenu() {
        this._sideMenuButton.ariaHidden = "true";
        this._sideMenuButton.style.opacity = "0";
        this._sideMenuButton.style.pointerEvents = "none";
        if (this._onSideMenuHiddenCallback) this._onSideMenuHiddenCallback();
    }
    onSideMenuClick(callback) {
        this._onSideMenuClickCallback = callback;
    }
    onSideMenuVisible(callback) {
        this._onSideMenuVisibleCallback = callback;
    }
    onSideMenuHidden(callback) {
        this._onSideMenuHiddenCallback = callback;
    }
}



/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ /*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ var $a4b3b7902c9a987d$var$candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(",");
var $a4b3b7902c9a987d$var$NoElement = typeof Element === "undefined";
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scope: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
             // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scope: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var $a4b3b7902c9a987d$var$getTabindex = function getTabindex(node, isScope) {
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        //
        // isScope is positive for custom element with shadow root or slot that by default
        // have tabIndex -1, but need to be sorted by document order in order for their
        // content to be inserted in the correct position
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "hidden";
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "radio";
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
     // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    var nodeRootHost = $a4b3b7902c9a987d$var$getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if (nodeIsAttached) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
         // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
     // visible, as far as we can tell, or per current `displayCheck` mode
    return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i); // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                } // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    } // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$var$getTabindex(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
     // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scope;
        var element = isScope ? item.scope : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getTabindex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(el, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(el, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat("iframe").join(",");
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};


function $282b77e844ac66e5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $282b77e844ac66e5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $282b77e844ac66e5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $282b77e844ac66e5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $282b77e844ac66e5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $282b77e844ac66e5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $282b77e844ac66e5$var$activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                // move this existing trap to the front of the queue
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
var $282b77e844ac66e5$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var $282b77e844ac66e5$var$isEscapeEvent = function isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var $282b77e844ac66e5$var$isTabEvent = function isTabEvent(e) {
    return e.key === "Tab" || e.keyCode === 9;
};
var $282b77e844ac66e5$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var $282b77e844ac66e5$var$findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $282b77e844ac66e5$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var $282b77e844ac66e5$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var $282b77e844ac66e5$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = $282b77e844ac66e5$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   firstTabbableNode: HTMLElement|null,
        //   lastTabbableNode: HTMLElement|null,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element) {
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
             // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus"); // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined) {
            // option not specified: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $a4b3b7902c9a987d$export$17100aea90429aa7)(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes
            var focusableNodes = (0, $a4b3b7902c9a987d$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    // NOTE: If tabindex is positive (in order to manipulate the tab order separate
                    //  from the DOM order), this __will not work__ because the list of focusableNodes,
                    //  while it contains tabbable nodes, does not sort its nodes in any order other
                    //  than DOM order, because it can't: Where would you place focusable (but not
                    //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
                    // Support for positive tabindex is already broken and hard to manage (possibly
                    //  not supportable, TBD), so this isn't going to make things worse than they
                    //  already are, and at least makes things better for the majority of cases where
                    //  tabindex is either 0/unset or negative.
                    // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
                    var nodeIdx = focusableNodes.findIndex(function(n) {
                        return n === node;
                    });
                    if (nodeIdx < 0) return undefined;
                    if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                        return (0, $a4b3b7902c9a987d$export$bebd5a1431fec25d)(n, config.tabbableOptions);
                    });
                    return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                        return (0, $a4b3b7902c9a987d$export$bebd5a1431fec25d)(n, config.tabbableOptions);
                    });
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if ($282b77e844ac66e5$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    }; // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $282b77e844ac66e5$var$getActualTarget(e);
        if (findContainerIndex(target) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($282b77e844ac66e5$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // if, on deactivation, we should return focus to the node originally-focused
                //  when the trap was activated (or the configured `setReturnFocus` node),
                //  then assume it's also OK to return focus to the outside node that was
                //  just clicked, causing deactivation, as long as that node is focusable;
                //  if it isn't focusable, then return focus to the original node focused
                //  on activation (or the configured `setReturnFocus` node)
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked, whether it's focusable or not; by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node)
                returnFocus: config.returnFocusOnDeactivate && !(0, $a4b3b7902c9a987d$export$4c063cf1350e6fed)(target, config.tabbableOptions)
            });
            return;
        } // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($282b77e844ac66e5$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
         // otherwise, prevent the click
        e.preventDefault();
    }; // In case focus escapes the trap for some strange reason, pull it back in.
    var checkFocusIn = function checkFocusIn(e) {
        var target = $282b77e844ac66e5$var$getActualTarget(e);
        var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
    }; // Hijack Tab events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkTab = function checkTab(e) {
        var target = $282b77e844ac66e5$var$getActualTarget(e);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back in to...
                if (e.shiftKey) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (e.shiftKey) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = $282b77e844ac66e5$var$findIndex(state.tabbableGroups, function(_ref2) {
                    var firstTabbableNode = _ref2.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $a4b3b7902c9a987d$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $a4b3b7902c9a987d$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = destinationGroup.lastTabbableNode;
                }
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = $282b77e844ac66e5$var$findIndex(state.tabbableGroups, function(_ref3) {
                    var lastTabbableNode = _ref3.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $a4b3b7902c9a987d$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $a4b3b7902c9a987d$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = _destinationGroup.firstTabbableNode;
                }
            }
        } else // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
        } // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(e) {
        if ($282b77e844ac66e5$var$isEscapeEvent(e) && $282b77e844ac66e5$var$valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
        }
        if ($282b77e844ac66e5$var$isTabEvent(e)) {
            checkTab(e);
            return;
        }
    };
    var checkClick = function checkClick(e) {
        var target = $282b77e844ac66e5$var$getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if ($282b77e844ac66e5$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($282b77e844ac66e5$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }; //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
         // There can be only one listening focus trap at a time
        $282b77e844ac66e5$var$activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $282b77e844ac66e5$var$delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    }; //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                if (onPostActivate) onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $282b77e844ac66e5$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            $282b77e844ac66e5$var$activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            if (onDeactivate) onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $282b77e844ac66e5$var$delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    if (onPostDeactivate) onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause() {
            if (state.paused || !state.active) return this;
            state.paused = true;
            removeListeners();
            return this;
        },
        unpause: function unpause() {
            if (!state.paused || !state.active) return this;
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            return this;
        }
    }; // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};


class $ae520f2259c8ef36$export$b6a78c44cf6c6004 {
    constructor(_hostElement, _id, _title, insertPosition = "afterbegin"){
        this._hostElement = _hostElement;
        this._id = _id;
        this._title = _title;
        this._returnFocusOnClose = true;
        this._closeOnEscKeyUp = true;
        this._dialogTemplate = `
        <div class="vanilla-reader-ui__dialog" id="${this._id}" role="dialog" aria-modal="true" tabindex="0">
            <div class="vanilla-reader-ui__dialog__header">        
                <h2 class="vanilla-reader-ui__dialog__header__title">${this._title}</h2>
                <button class="vanilla-reader-ui__dialog__header__close-button" title="Close dialog"><span aria-hidden="true">close</span></button>
            </div>
            <div class="vanilla-reader-ui__dialog__body">                
            </div>
            <div class="vanilla-reader-ui__dialog__footer">
            </div>           
        </div>
        <div class="vanilla-reader__modal-overlay"></div>`;
        this._dialogStyle = `
        <style>
            #${this._id}[role=dialog] {
                position: fixed;
                display: none;
                flex-direction: column;
                opacity: 0;
                top: 5%;
                left: 15%;
                right: 15%;
                min-height: 50%;
                height: 60%;
                max-width: 900px;
                margin-left: auto;
                margin-right: auto;
                overflow: auto;
                background-color: var(--vanilla-reader__color__ui__background-light);
                color: var(--vanilla-reader__color__ui__foreground-dark);
                border: 1px solid var(--vanilla-reader__color__ui__foreground-dark);
                padding: 2em;
                box-shadow: 5px 5px 20px rgb(0 0 0 / 20%);
                border-radius: 8px;
                z-index: 101;
                transition: all 0.2s ease-out;
            }
            
            /* When on phone screens we place the dialogs at the bottom of the screen. */
            @media only screen and (max-device-width: 480px) {
                #${this._id}[role=dialog] {
                    top: unset;
                    bottom: 0;
                    right: 0;
                    left: 0;
                    border-bottom: 0;
                    border-bottom-left-radius: 0;
                    border-bottom-right-radius: 0;
                    box-shadow: 0 -8px 16px rgba(0,0,0,0.2);
                    transition: all 0.2s ease-in-out;       
                    overflow: scroll;       
                }
            }

            #${this._id} .vanilla-reader-ui__dialog__header {
                display: flex;
                align-content: space-between;
                flex-direction: row;
                flex-wrap: nowrap;
                width: 100%;
            }

            #${this._id} .vanilla-reader-ui__dialog__header__close-button {
                width: 48px;
                height: 48px;
                background-color: transparent;
                -webkit-appearance: none;
                cursor: pointer;
                color: var(--vanilla-reader__color__ui__foreground-dark);
                border: 1px solid var(--vanilla-reader__color__ui__foreground-dark);                
                font-size: 1.2em;
            }

            #${this._id} .vanilla-reader-ui__dialog__header__title {
                flex-grow: 1;
            }
            
            #${this._id} .vanilla-reader-ui__dialog__body {
                flex-grow: 1;
            }
                       
            #${this._id} + .vanilla-reader__modal-overlay {
                display: none;
                position: fixed;
                top: 0;
                left: 0;
                opacity: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0,0,0,0.5);
                z-index: 100;
                transition: all 0.2s ease-in-out;
            }

    </style>`;
        this._onFocusTrapDeactivated = ()=>{
            if ($ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogFocusTrapDeactivatedCallback) $ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogFocusTrapDeactivatedCallback(this._returnFocusOnClose);
            this._focusTrap = undefined;
        };
        this._event_modalOverlay_click = (_ev)=>{
            if (this._clickOutsideCallback) this._clickOutsideCallback();
            this.close();
        };
        this._event_modalOverlay_focus = (_ev)=>{
            if (this._modalOverlayHasFocusCallback) this._modalOverlayHasFocusCallback();
        };
        this._event_modalOverlay_keyup = (_ev)=>{};
        this._event_dialog_focus = (_ev)=>{};
        this._event_dialog_keyup = (ev)=>{
            switch(ev.key){
                case "Escape":
                    if (this._closeOnEscKeyUp) this.close();
                    break;
            }
        };
        this._event_dialog_closeButtonClick = (_e)=>{
            this.close();
        };
        this._hostDocument = this._hostElement.ownerDocument;
        this._hostElement.insertAdjacentHTML(insertPosition, this._dialogTemplate);
        this._dialogElement = this._hostDocument.getElementById(this._id);
        this._dialogElement.insertAdjacentHTML(insertPosition, this._dialogStyle);
        this._dialogHeaderElement = this._dialogElement.querySelector(".vanilla-reader-ui__dialog__header");
        this._dialogHeaderTitleElement = this._dialogElement.querySelector(".vanilla-reader-ui__dialog__header__title");
        this._dialogCloseButtonElement = this._dialogElement.querySelector(".vanilla-reader-ui__dialog__header__close-button");
        this._dialogBodyElement = this._dialogElement.querySelector(".vanilla-reader-ui__dialog__body");
        this._dialogFooterElement = this._dialogElement.querySelector(".vanilla-reader-ui__dialog__footer");
        this._modalOverlayElement = this._hostDocument.querySelector(".vanilla-reader__modal-overlay");
        this._modalOverlayElement.addEventListener("focus", this._event_modalOverlay_focus);
        this._modalOverlayElement.addEventListener("keyup", this._event_modalOverlay_keyup);
        this._dialogElement.addEventListener("focus", this._event_dialog_focus);
        this._dialogElement.addEventListener("keyup", this._event_dialog_keyup);
        this._dialogCloseButtonElement.addEventListener("click", this._event_dialog_closeButtonClick);
        this._dialogElement.addEventListener("scroll", (ev)=>{
            ev.stopPropagation();
            ev.stopImmediatePropagation();
        });
    }
    // This method, as well as the "onAfterDialogClosed" method, are static because they are shared between all dialogs.
    // It lets the VanillaReaderUI listen for these life cycle events in one place.
    static sharedOnDialogOpened(callback) {
        $ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogOpenedCallback = callback;
    }
    static sharedOnDialogClosed(callback) {
        $ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogClosedCallback = callback;
    }
    static sharedOnDialogFocusTrapDeactivated(callback) {
        $ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogFocusTrapDeactivatedCallback = callback;
    }
    onDialogOpened(callback) {
        this._onDialogOpenedCallback = callback;
    }
    onDialogClosed(callback) {
        this._onDialogClosedCallback = callback;
    }
    set closeOnEscKeyUp(value) {
        this._closeOnEscKeyUp = value;
    }
    get closeOnEscKeyUp() {
        return this._closeOnEscKeyUp;
    }
    get id() {
        return this._id;
    }
    set title(value) {
        this._dialogHeaderTitleElement.innerText = value;
    }
    get title() {
        return this._dialogHeaderTitleElement.innerText;
    }
    isOpen() {
        return this._dialogElement.style.display.toLocaleLowerCase() === "flex";
    }
    show(silent = false, returnFocusOnClose = true, onDialogCloseCallbackOverride) {
        this._returnFocusOnClose = returnFocusOnClose;
        this._dialogElement.style.display = "flex";
        this._modalOverlayElement.style.display = "block";
        setTimeout(()=>{
            this._dialogElement.style.opacity = "1";
            this._modalOverlayElement.style.opacity = "1";
        }, 0.3);
        // We can not always guarantee that there are focusable elements within the dialog body element.
        try {
            this._focusTrap = (0, $282b77e844ac66e5$export$360440dfcba94c00)(this._dialogElement, {
                allowOutsideClick: true,
                escapeDeactivates: false,
                delayInitialFocus: true,
                returnFocusOnDeactivate: returnFocusOnClose,
                onPostDeactivate: this._onFocusTrapDeactivated
            });
            this._focusTrap.activate();
        } catch (e) {}
        this._dialogElement.focus();
        this._modalOverlayElement.addEventListener("click", this._event_modalOverlay_click);
        if (this._onDialogOpenedCallback) this._onDialogOpenedCallback(this._title || "");
        if (onDialogCloseCallbackOverride) this._onDialogClosedCallback = onDialogCloseCallbackOverride;
        if ($ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogOpenedCallback) $ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogOpenedCallback(this, this._title || "", silent);
    }
    close(silent = false, returnDialogResult = true) {
        if (this._focusTrap) try {
            this._focusTrap.deactivate();
        } catch (e) {
            console.log(e);
        }
        if (this._dialogElement.style.display === "flex") {
            this._dialogElement.style.opacity = "0";
            setTimeout(()=>{
                this._dialogElement.style.display = "none";
            }, 200);
        }
        this._modalOverlayElement.style.opacity = "0";
        setTimeout(()=>{
            this._modalOverlayElement.style.display = "none";
        }, 200);
        if (this._onDialogClosedCallback) {
            let resultData = returnDialogResult ? {
                title: this._title || "",
                data: this._getDialogResult()
            } : {
                title: this._title || "",
                data: undefined
            };
            this._onDialogClosedCallback(resultData);
        }
        if ($ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogClosedCallback) $ae520f2259c8ef36$export$b6a78c44cf6c6004._sharedOnDialogClosedCallback(this, this._title || "", silent);
        this._modalOverlayElement.removeEventListener("click", this._event_modalOverlay_click);
    }
    /*
    * Class internal
    * */ /**
     * This method can be overridden by an implementation if it needs to return data from the dialog.
     * It is called as part of the close procedure in the `close` method.
     * */ _getDialogResult() {
        return undefined;
    }
}


class $77eacbf1d29a054e$export$a0ef6f1510dd6ee3 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    static{
        this._dialogTitle = "Bookmarks";
    }
    constructor(hostElement, insertPosition = "beforeend"){
        super(hostElement, "vanilla-reader__dialog-bookmarks", $77eacbf1d29a054e$export$a0ef6f1510dd6ee3._dialogTitle);
        this._listIsFiltered = false;
        this._bodyStyle = `
        <style>
            #vanilla-reader__dialog-bookmarks__list {
                padding-inline: 0;
            }

            #vanilla-reader__dialog-bookmarks__list li {
                min-height: 48px;                
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                align-content: space-between;
            }
            
            #vanilla-reader__dialog-bookmarks__list li a {
                vertical-align: super;
                margin-right: 1em;
                margin-top: 1em;
                flex-grow: 1;
            }     

            #vanilla-reader__dialog-bookmarks__list li button {
                align-self: flex-start;
            }
            
            .vanilla-reader__dialog-bookmarks__list__item__section-title {
                /* We set pointer events to none to let the list item receive any key/pointer events */ 
                pointer-events: none;
                display: block;
                font-weight: bold;       
                margin-bottom: 8px;         
            }
            
            .vanilla-reader__dialog-bookmarks__list__item__selection-text {
                pointer-events: none;
            }
            
            
        </style>`;
        this._bodyTemplate = `<ul id="vanilla-reader__dialog-bookmarks__list">
        <span class="vanilla-reader__dialog-bookmarks__list--empty">There are no bookmarks yet</span>
    </ul>`;
        this._dialogTitleWhenFiltered = "Bookmark in view";
        /*
    *
    * EVENT HANDLERS
    *
    * */ this._event_listItemClicked = (ev)=>{
            let locator = ev.target.getAttribute("data-contentblocklocator") || ev.target.parentElement.getAttribute("data-contentblocklocator");
            if (locator && this._onBookmarkItemClickedCallback) this._onBookmarkItemClickedCallback({
                navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
                locator: locator
            });
        };
        this._dialogElement.insertAdjacentHTML(insertPosition, this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._list = this._dialogElement.querySelector("#vanilla-reader__dialog-bookmarks__list");
    }
    get listIsFiltered() {
        return this._listIsFiltered;
    }
    get selectedItems() {
        return this._selectedItems;
    }
    onBookmarkItemClicked(callback) {
        this._onBookmarkItemClickedCallback = callback;
    }
    onBookmarkItemButtonClicked(callback) {
        this._onBookmarkItemButtonClickedCallback = callback;
    }
    populate(annotations) {
        this.empty();
        if (annotations.length >= 1) annotations.forEach((annotation)=>{
            let listItem = this.createItem(annotation);
            this._list.appendChild(listItem);
        });
        else this._list.innerHTML = '<span class="vanilla-reader__dialog-bookmarks__list--empty">There are no bookmarks yet</span>';
        if (this.listIsFiltered) this.filterSelected();
    }
    setSelected(selectedBookmarks = []) {
        this._selectedItems = selectedBookmarks;
        this._list.querySelectorAll("li").forEach((item)=>{
            item.removeAttribute("aria-selected");
            let bookmarkLocator = item.getAttribute("data-contentblocklocator");
            if (bookmarkLocator) {
                let shouldSelect = selectedBookmarks.find((item)=>item.locator === bookmarkLocator);
                if (shouldSelect) item.setAttribute("aria-selected", "true");
            }
        });
    }
    createItem(bookmark) {
        let listItem = this._hostDocument.createElement("li");
        listItem.setAttribute("tabindex", "-1");
        listItem.setAttribute("data-booksection", bookmark.bookSection || "");
        listItem.setAttribute("data-contentblocklocator", bookmark.locator);
        listItem.setAttribute("data-datecreated", `${bookmark.dateCreated || ""}`);
        let listItemActionButton = this._hostDocument.createElement("button");
        listItemActionButton.innerHTML = '<span aria-hidden="true">delete</span>';
        listItemActionButton.title = "Delete bookmark";
        listItemActionButton.setAttribute("tabindex", "0");
        listItemActionButton.addEventListener("click", (_ev)=>{
            if (this._onBookmarkItemButtonClickedCallback) this._onBookmarkItemButtonClickedCallback(bookmark);
        });
        let listItemAnchor = this._hostDocument.createElement("a");
        listItemAnchor.setAttribute("data-contentblocklocator", bookmark.locator);
        listItemAnchor.addEventListener("click", (ev)=>{
            this._event_listItemClicked(ev);
        });
        listItem.addEventListener("keyup", (ev)=>{
            if (ev.key === "Enter" || ev.key === "Space") this._event_listItemClicked(ev);
        });
        listItem.setAttribute("data-contentblocklocator", bookmark.locator);
        listItemAnchor.innerHTML = `
            <span class="vanilla-reader__dialog-bookmarks__list__item__section-title" title="Book section" title="Book section"></span>
            <span class="vanilla-reader__dialog-bookmarks__list__item__selection-text" title="Bookmarked text" title="Bookmarked text"></span>
            `;
        listItemAnchor.setAttribute("tabindex", "0");
        if (bookmark.text) {
            let spanElementText = listItemAnchor.querySelector(".vanilla-reader__dialog-bookmarks__list__item__selection-text");
            spanElementText.innerText = bookmark.text.length > 150 ? bookmark.text.slice(0, 150) + "..." : bookmark.text;
        }
        let spanElementTitle = listItemAnchor.querySelector(".vanilla-reader__dialog-bookmarks__list__item__section-title");
        spanElementTitle.innerText = bookmark.bookSection || "";
        listItem.appendChild(listItemAnchor);
        listItem.appendChild(listItemActionButton);
        return listItem;
    }
    show(silent, returnFocusOnClose = true, onDialogCloseCallbackOverride, filterSelected = false) {
        super.show(silent, returnFocusOnClose, onDialogCloseCallbackOverride);
        if (this._listIsFiltered) this.removeSelectedFilter();
        if (filterSelected) {
            this.title = this._dialogTitleWhenFiltered;
            this.filterSelected();
        } else this.title = $77eacbf1d29a054e$export$a0ef6f1510dd6ee3._dialogTitle;
    }
    filterSelected() {
        this._listIsFiltered = true;
        this._list.querySelectorAll("li").forEach((item)=>{
            let itemLocator = item.getAttribute("data-contentblocklocator");
            let keepItem = this._selectedItems?.find((item)=>{
                return item.locator === itemLocator;
            });
            if (!keepItem) item.style.display = "none";
        });
    }
    removeSelectedFilter() {
        this._listIsFiltered = false;
        this._list.querySelectorAll("li").forEach((item)=>{
            item.style.display = "flex";
        });
    }
    empty() {
        if (this._list.childElementCount > 0) {
            let firstListItem = this._list.firstChild;
            while(firstListItem){
                firstListItem.remove();
                firstListItem = this._list.firstChild;
            }
        }
    }
}



class $12a4e63b52eb779b$export$6940b0d9c820eca7 {
    constructor(container, sourceData){
        this.container = container;
        this.id = Date.now().toString();
        this.activeItem = undefined;
        this.domElement = undefined;
        this.cssClassName = `aria-tree-view-${this.id}`;
        this.items = [];
        this.treeItemExpandButtonPrepend = true;
        this.treeItemExpandButtonLabelExpanded = "collapse item";
        this.treeItemExpandButtonLabelCollapsed = "expand item";
        this.rendered = false;
        this.sourceData = [];
        this.styleElement = undefined;
        this.cssStyle = `
.${this.cssClassName} ul[role=group] {
    max-width: 100%;
    width: 100%;
}

.${this.cssClassName} li[role=treeitem] {
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
}

.${this.cssClassName} li[role=treeitem] a {
    max-width: 90%;    
}

.${this.cssClassName} li[role=treeitem]:before {
    content: ' ';
}

.${this.cssClassName} li[aria-expanded=true] button span:before {
    content: '\u{25BE}';
}

.${this.cssClassName} li[aria-expanded=false] button span:before {
    content: '\u{25B8}';
}

#${this.cssClassName} li[aria-selected] > a {
    text-decoration: underline;
}

`;
        this.keyCode = {
            RETURN: 13,
            SPACE: 32,
            PAGEUP: 33,
            PAGEDOWN: 34,
            END: 35,
            HOME: 36,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        };
        this.domElement = document.createElement("ul");
        this.domElement.setAttribute("class", this.cssClassName);
        this.domElement.setAttribute("role", "tree");
        this.styleElement = document.createElement("style");
        this.domElement.prepend(this.styleElement);
        this.sourceData = sourceData || [];
        this.itemDomElementToTreeViewItemMap = new Map();
        this.treeViewItemDataToTreeViewItemMap = new Map();
        this.selectedItems = new Set();
        this.setTreeViewStyle(this.cssStyle);
        if (this.sourceData.length > 0) this.buildTreeFromSourceData();
    }
    setId(uid) {
        this.id = uid;
        if (this.domElement) this.domElement.setAttribute("id", this.id);
    }
    addClassName(className) {
        if (this.domElement) this.domElement.classList.add(className);
    }
    setPrependExpandTreeItemButton(value) {
        this.treeItemExpandButtonPrepend = value;
    }
    setTreeViewStyle(cssStyle) {
        if (this.styleElement) this.styleElement.innerHTML = cssStyle;
    }
    buildTreeFromSourceData() {
        let groupSize = this.sourceData.length;
        this.sourceData.forEach((item, index)=>{
            let treeViewItem = new $12a4e63b52eb779b$export$6e77ea6719814e9c(item, this, index, groupSize);
            this.items.push(treeViewItem);
            this.itemDomElementToTreeViewItemMap.set(treeViewItem.domElement, treeViewItem);
            this.treeViewItemDataToTreeViewItemMap.set(item, treeViewItem);
            this.domElement.appendChild(treeViewItem.domElement);
        });
        this.addItemKeyEventHandlers();
    }
    mapKeyUpEvents(element, treeItem) {
        element.addEventListener("keyup", (ev)=>{
            let cancelBubble = true;
            let previousItem;
            let nextItem;
            let parentItem;
            // Not really deprecated, please ignore
            switch(ev.keyCode){
                case this.keyCode.SPACE:
                case this.keyCode.RETURN:
                    if (ev.target instanceof HTMLButtonElement) break;
                    treeItem.setIsSelected();
                    element.click();
                    break;
                case this.keyCode.RIGHT:
                    if (treeItem.children.length > 0) {
                        treeItem.setIsExpanded(true);
                        treeItem.children[0].setIsActive(true);
                    }
                    break;
                case this.keyCode.LEFT:
                    if (treeItem.getIsExpanded()) {
                        treeItem.setIsExpanded(false);
                        break;
                    } else {
                        parentItem = treeItem.getParent();
                        if (parentItem) parentItem.setIsActive(true);
                        else this.items[0].setIsActive(true);
                    }
                    break;
                case this.keyCode.DOWN:
                    nextItem = treeItem.getNextAdjacent();
                    if (nextItem) nextItem.setIsActive(true);
                    else {
                        let parentItem = treeItem.getParent();
                        if (parentItem) {
                            let nextParentSibling = parentItem.getNextSibling();
                            if (nextParentSibling) nextParentSibling.setIsActive(true);
                        }
                    }
                    break;
                case this.keyCode.UP:
                    previousItem = treeItem.getPreviousAdjacent();
                    if (previousItem) previousItem.setIsActive(true);
                    else {
                        let parentItem = treeItem.getParent();
                        if (parentItem) parentItem.setIsActive(true);
                    }
                    break;
                case this.keyCode.HOME:
                    let firstItem = this.items[0];
                    if (firstItem) firstItem.setIsActive(true);
                    break;
                case this.keyCode.END:
                    let lastItem = this.items[this.items.length - 1];
                    if (lastItem) lastItem.setIsActive(true);
                    break;
                default:
                    cancelBubble = false;
            }
            if (cancelBubble) ev.cancelBubble = true;
        });
    }
    addItemKeyEventHandlers() {
        let treeItems = this.domElement.querySelectorAll("li");
        let treeItemsArray = Array.from(treeItems);
        treeItemsArray.forEach((item)=>{
            let treeItem = this.itemDomElementToTreeViewItemMap.get(item);
            this.mapKeyUpEvents(item, treeItem);
        });
    }
    addItemClickEventHandler(fn) {
        let treeItems = this.domElement.querySelectorAll("li");
        let treeItemsArray = Array.from(treeItems);
        treeItemsArray.forEach((item)=>{
            let treeItem = this.itemDomElementToTreeViewItemMap.get(item);
            item.addEventListener("click", (ev)=>{
                ev.cancelBubble = true;
                fn(treeItem.getTreeViewItemData());
            });
        });
    }
    render() {
        this.rendered = true;
        this.container.appendChild(this.domElement);
    }
    collapseAll() {
        this.items.forEach((item)=>{
            item.setIsExpanded(false);
        });
    }
    getTreeItemByElement(el) {
        return this.itemDomElementToTreeViewItemMap.get(el);
    }
    getTreeItemByItemSourceData(data) {
        for (let [key, value] of this.treeViewItemDataToTreeViewItemMap.entries()){
            if (key.data == data) return value;
        }
        return undefined;
    }
    expandToTreeItem(item) {
        let parent = item.getParent();
        if (parent) {
            parent.setIsExpanded(true);
            this.expandToTreeItem(parent);
        }
    }
    filterTreeItemsByItemData(filterCallback) {
        let items = Array.from(this.treeViewItemDataToTreeViewItemMap.values());
        return items.filter((item)=>filterCallback(item.data));
    }
    deselectAllItems() {
        this.selectedItems.forEach((item)=>{
            item.setIsSelected(false);
        });
    }
    destroy() {}
}
class $12a4e63b52eb779b$export$6e77ea6719814e9c {
    constructor(treeViewItemSourceData, treeView, indexInGroup, groupSize){
        this.treeViewItemSourceData = treeViewItemSourceData;
        this.treeView = treeView;
        this.childContainerElement = undefined;
        this.isExpanded = false;
        this.isActive = false;
        this.isSelected = false;
        this.domElement = undefined;
        this.children = [];
        this.textContent = treeViewItemSourceData.textContent;
        this.data = treeViewItemSourceData.data;
        this.id = treeViewItemSourceData.id;
        this.indexInGroup = indexInGroup;
        this.domElement = document.createElement("li");
        this.domElement.id = treeViewItemSourceData.id;
        this.domElement.setAttribute("role", "treeitem");
        this.domElement.setAttribute("tabindex", "0");
        this.labelElement = document.createElement("a");
        this.labelElement.setAttribute("role", "presentation");
        this.labelElement.textContent = treeViewItemSourceData.textContent;
        this.domElement.appendChild(this.labelElement);
        this.domElement.setAttribute("aria-posinset", String(this.indexInGroup + 1));
        this.domElement.setAttribute("aria-setsize", String(groupSize));
        treeView.itemDomElementToTreeViewItemMap.set(this.domElement, this);
        treeView.treeViewItemDataToTreeViewItemMap.set(treeViewItemSourceData, this);
        this.buttonElement = document.createElement("button");
        this.buttonElement.setAttribute("aria-expanded", "false");
        this.buttonLabelElement = document.createElement("span");
        this.buttonLabelElement.setAttribute("aria-hidden", "true");
        this.buttonElement.appendChild(this.buttonLabelElement);
        this.buildTreeItemBranchFromSourceData();
    }
    buildTreeItemBranchFromSourceData() {
        if (this.domElement) {
            if (this.treeViewItemSourceData.children && this.treeViewItemSourceData.children.length > 0) {
                this.domElement.setAttribute("data-treeview-role", "group");
                this.childContainerElement = document.createElement("ul");
                this.childContainerElement.setAttribute("role", "group");
                this.treeViewItemSourceData.children.forEach((childItem, index)=>{
                    let newTreeViewItem = new $12a4e63b52eb779b$export$6e77ea6719814e9c(childItem, this.treeView, index, this.treeViewItemSourceData.children.length);
                    this.children.push(newTreeViewItem);
                    this.childContainerElement.appendChild(newTreeViewItem.domElement);
                });
                this.buttonElement.setAttribute("role", "presentation");
                this.setUpExpandButtonEventHandlers();
                if (this.treeView.treeItemExpandButtonPrepend) this.domElement.prepend(this.buttonElement);
                else this.domElement.appendChild(this.buttonElement);
                this.domElement.appendChild(this.childContainerElement);
                this.setIsExpanded(this.isExpanded);
            }
        }
    }
    setUpExpandButtonEventHandlers() {
        this.buttonElement.addEventListener("click", (ev)=>{
            ev.preventDefault();
            this.isExpanded ? this.setIsExpanded(false) : this.setIsExpanded(true);
            ev.stopImmediatePropagation();
        });
        this.buttonElement.addEventListener("keyup", (ev)=>{
            if (ev.code === "Enter" || ev.code === "Space") {
                ev.preventDefault();
                ev.stopImmediatePropagation();
            }
        });
        this.buttonElement.addEventListener("keydown", (ev)=>{
            if (ev.code === "Enter" || ev.code === "Space") {
                ev.stopImmediatePropagation();
                this.buttonElement.click();
            }
        });
        this.buttonElement.addEventListener("focus", (ev)=>{
            if (this.isHtmlElement(ev.target)) {
                if (this.getIsExpanded()) ev.target.setAttribute("title", this.treeView.treeItemExpandButtonLabelExpanded);
                else ev.target.setAttribute("title", this.treeView.treeItemExpandButtonLabelCollapsed);
            }
        });
        this.buttonElement.addEventListener("blur", (ev)=>{
            if (this.isHtmlElement(ev.target)) ev.target.removeAttribute("title");
        });
    }
    setIsSelected(selected = true) {
        this.isSelected = selected;
        if (selected) {
            this.domElement?.setAttribute("aria-selected", "true");
            //this.treeView.selectedItems?.setIsSelected(false);
            this.treeView.selectedItems?.add(this);
        } else {
            this.domElement?.removeAttribute("aria-selected");
            this.treeView.selectedItems.delete(this);
        }
    }
    getIsSelected() {
        return this.isSelected;
    }
    setIsActive(active, scrollIntoView = true) {
        let scrollIntoViewOptions = {
            behavior: "smooth",
            block: "center",
            inline: "center"
        };
        if (active) {
            this.treeView.activeItem?.setIsActive(false);
            this.treeView.activeItem = this;
            this.domElement?.focus();
            if (scrollIntoView) this.domElement?.scrollIntoView(scrollIntoViewOptions);
        } else {
            this.treeView.activeItem = undefined;
            this.domElement?.blur();
        }
    }
    getIsActive() {
        return this.isActive;
    }
    getIsExpanded() {
        return this.isExpanded;
    }
    setIsExpanded(expanded = true) {
        if (this.domElement && this.childContainerElement) {
            this.isExpanded = expanded;
            this.domElement.setAttribute("aria-expanded", `${expanded}`);
            this.buttonElement.setAttribute("aria-expanded", `${expanded}`);
            if (expanded) this.childContainerElement.style.display = "block";
            else this.childContainerElement.style.display = "none";
        }
    }
    getTreeViewItemData() {
        return this.treeViewItemSourceData;
    }
    focus() {
        this.domElement.focus();
    }
    getNextSibling() {
        if (this.domElement) {
            let nextElement = this.domElement.nextSibling;
            if (nextElement) {
                let nextItem = this.treeView.itemDomElementToTreeViewItemMap.get(nextElement);
                return nextItem;
            }
        }
        return undefined;
    }
    getPreviousSibling() {
        if (this.domElement) {
            let previousElement = this.domElement.previousSibling;
            if (previousElement) {
                let previousItem = this.treeView.itemDomElementToTreeViewItemMap.get(previousElement);
                return previousItem;
            }
        }
        return undefined;
    }
    getNextAdjacent() {
        if (this.domElement) {
            if (this.children.length > 0 && this.domElement.getAttribute("aria-expanded") === "true") {
                let childElement = this.domElement.querySelector("ul");
                if (childElement instanceof HTMLUListElement) {
                    let nextElement = childElement.firstElementChild;
                    if (nextElement instanceof HTMLLIElement) return this.treeView.itemDomElementToTreeViewItemMap.get(nextElement);
                }
            } else return this.getNextSibling();
        }
        return undefined;
    }
    getPreviousAdjacent() {
        if (this.domElement) {
            let parentElementSibling = this.domElement.previousElementSibling;
            if (parentElementSibling instanceof HTMLLIElement && parentElementSibling.getAttribute("aria-expanded") === "true") {
                if (parentElementSibling.children.length > 0) {
                    let childElement = parentElementSibling.querySelector("ul");
                    if (childElement instanceof HTMLUListElement) {
                        let previousItem = childElement.lastElementChild;
                        if (previousItem instanceof HTMLLIElement) return this.treeView.itemDomElementToTreeViewItemMap.get(previousItem);
                    }
                } else return undefined;
            } else return this.getPreviousSibling();
        }
        return undefined;
    }
    getParent() {
        if (this.domElement) {
            let parentGroupElement = this.domElement.parentElement;
            let parentItemElement = parentGroupElement.parentElement;
            if (parentItemElement) {
                let parentItem = this.treeView.itemDomElementToTreeViewItemMap.get(parentItemElement);
                return parentItem;
            }
        }
        return undefined;
    }
    isHtmlElement(val) {
        return !!val && val instanceof HTMLElement;
    }
}




class $43e3403fa824d584$export$66a93469b6997762 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(_hostElement, _insertPosition = "afterbegin"){
        super(_hostElement, "vanilla-reader__dialog-contents", "Book contents", _insertPosition);
        this._navItemClickedCallback = undefined;
        this._treeViewToc = undefined;
        this._treeViewPages = undefined;
        this._bodyStyle = `
        <style>
            
            #vanilla-reader__dialog-contents__section-toc ul[role=tree] {
                padding-left: 0;
                list-style: none;
            }
                        
            #vanilla-reader__dialog-contents__section-toc ul[role=tree] button {
                font-size: x-large;
                margin-left: 0;
            }

            #vanilla-reader__dialog-contents__section-toc ul[role=group] {
                padding-left: 1em;
                list-style: none;
            }
            
            #vanilla-reader__dialog-contents__section-toc ul[role=group] li:not([data-treeview-role=group]) {
               margin-left: 1em;
            }
            
            #vanilla-reader__dialog-contents__section-toc li {
                align-items: center;
            }

            #vanilla-reader__dialog-contents__section-toc li a {
                max-width: 70%;
            }

            #vanilla-reader__dialog-contents__section-toc li[aria-selected=true] {
                text-decoration: underline;
            }
            
            #vanilla-reader__dialog-contents__section-toc li[aria-expanded=true] ul {
                border-left: 1px dotted var(--vanilla-reader__color__ui__outline-dark);
            }
            
            #vanilla-reader__dialog-contents__section-pages ul {
                padding-left: 0;
                display: flex;
                flex-wrap: wrap;
            }
                        
            #vanilla-reader__dialog-contents__section-pages li {                                            
                justify-content: space-around;
                align-items: center;
                border: 1px solid var(--vanilla-reader__color__ui__outline-light);
                border-radius: 8px;
                height: 48px;
                width: 48px;
                margin: 0.5em;
            }
            
            #vanilla-reader__dialog-contents__section-pages li[aria-selected=true] {
                border: 2px solid var(--vanilla-reader__color__ui__outline-dark);
                text-decoration: underline;
            }
            
            #vanilla-reader__dialog-contents__section-pages li a {            
                max-width: 100%;
                width: 100%;
                text-align: center;
            }

            #vanilla-reader__dialog-contents__form-search {
                display: flex;
            }
            
            #vanilla-reader__dialog-contents__input-search {                
                flex-grow: 1;
            }
                          
        </style>`;
        this._bodyTemplate = `

        <section id="vanilla-reader__dialog-contents__section-toc">        
            <h2>Table of Contents</h2>           
            <form id="vanilla-reader__dialog-contents__form-search">                        
                <input type="search" placeholder="Search Table of Contents" name="input-search" list="vanilla-reader__dialog-contents__datalist" id="vanilla-reader__dialog-contents__input-search">
                <button id="vanilla-reader__dialog-contents__button-search" aria-label="Do search" title="Do search"><span class="vanilla__button-icon" aria-hidden="true">search</span></button>
                <datalist id="vanilla-reader__dialog-contents__datalist"></datalist>
            </form>            
        </section>
        <section id="vanilla-reader__dialog-contents__section-pages">        
            <h2>Page list</h2>           
        </section>
    `;
        this._onTocSearchSubmitted = (ev)=>{
            ev.preventDefault();
            if (this._navItemClickedCallback && this._inputTocSearch.value) {
                let navItem;
                navItem = this._tocItemsListFlat?.find((itemData)=>{
                    return itemData.textContent === this._inputTocSearch.value;
                });
                if (navItem?.data?.locator && this._navItemClickedCallback) this._navItemClickedCallback({
                    navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
                    locator: navItem.data.locator
                });
            }
            return false;
        };
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._dialogElement.insertAdjacentHTML("afterbegin", this._bodyStyle);
        this._sectionToc = this._dialogElement.querySelector("#vanilla-reader__dialog-contents__section-toc");
        this._sectionPages = this._dialogElement.querySelector("#vanilla-reader__dialog-contents__section-pages");
        this._formSearchActions = this._dialogElement.querySelector("#vanilla-reader__dialog-contents__form-search");
        this._dataListActions = this._dialogElement.querySelector("#vanilla-reader__dialog-contents__datalist");
        this._inputTocSearch = this._dialogElement.querySelector("#vanilla-reader__dialog-contents__input-search");
        this._inputTocSearch.ariaLabel = `
            Search Table of Contents. As you type, results will appear in an options list below the input field. 
            Press Shift + the Down Arrow key to step through the result list."`;
        this._formSearchActions.onsubmit = this._onTocSearchSubmitted;
    }
    show(silent = false, returnFocusOnClose = true, onDialogClosedCallbackOverride) {
        super.show(silent, returnFocusOnClose, onDialogClosedCallbackOverride);
        // Wait to select the item until the dialog has ended its fade in transition.
        setTimeout(()=>{
            this._selectCurrentActiveItem();
        }, 200);
    }
    close(silent = false, returnDialogResult = true) {
        super.close(silent, returnDialogResult);
        this._inputTocSearch.value = "";
    }
    onNavItemClicked(callback) {
        this._navItemClickedCallback = callback;
    }
    populate(treeData) {
        if (treeData) {
            let collections = treeData.collections;
            if (collections) {
                this.empty();
                for (const collection of collections){
                    if (collection.type === (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC) {
                        if (!this._treeViewTocItems) this._treeViewTocItems = this._mapNavigationItemDataToTreeItemData(collection.children);
                        this._tocItemsListFlat = this._treeViewTocItems.flatMap((item)=>{
                            return [
                                item,
                                ...item.children
                            ];
                        });
                        for (let item of this._tocItemsListFlat)if (item.data) {
                            let optionElement = document.createElement("option");
                            optionElement.text = item.textContent;
                            optionElement.setAttribute("data-action-id", item.id);
                            optionElement.setAttribute("data-action-name", item.data?.name || "");
                            this._dataListActions.appendChild(optionElement);
                        }
                        this._treeViewToc = new (0, $12a4e63b52eb779b$export$6940b0d9c820eca7)(this._sectionToc, this._treeViewTocItems);
                        this._treeViewToc.cssClassName = "vanilla-reader__dialog-contents__list-toc";
                        this._treeViewToc.addItemClickEventHandler((navItem)=>{
                            if (navItem.data.locator && this._navItemClickedCallback) this._navItemClickedCallback({
                                navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
                                locator: navItem.data.locator
                            });
                        });
                        this._treeViewToc.render();
                    }
                    if (collection.type === (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).PAGE_LIST) {
                        if (!this._treeViewPageItems) this._treeViewPageItems = this._mapNavigationItemDataToTreeItemData(collection.children);
                        this._treeViewPages = new (0, $12a4e63b52eb779b$export$6940b0d9c820eca7)(this._sectionPages, this._treeViewPageItems);
                        this._treeViewPages.cssClassName = "vanilla-reader__dialog-contents__list-toc";
                        this._treeViewPages.addItemClickEventHandler((navItem)=>{
                            if (navItem.data.locator && this._navItemClickedCallback) this._navItemClickedCallback({
                                navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
                                locator: navItem.data.locator
                            });
                        });
                        this._treeViewPages.render();
                    }
                }
            }
        }
    }
    empty() {
        if (this._treeViewToc) this._treeViewToc.destroy();
    }
    setActiveItems(navigationItemsInVisibleRange) {
        if (navigationItemsInVisibleRange && navigationItemsInVisibleRange.length > 0) {
            this.setActivePageItems(navigationItemsInVisibleRange);
            this.setActiveTocItems(navigationItemsInVisibleRange);
        }
    }
    setActiveTocItems(navigationItemsInVisibleRange) {
        if (navigationItemsInVisibleRange && navigationItemsInVisibleRange.length > 0) {
            this._treeViewToc?.deselectAllItems();
            let selectedItems = [];
            navigationItemsInVisibleRange.forEach((item)=>{
                if (item.collectionType === "TOC") {
                    let locator = item.locator;
                    if (locator) {
                        let treeViewItems = this._treeViewToc?.filterTreeItemsByItemData((navItem)=>{
                            return navItem.locator === item.locator;
                        });
                        if (treeViewItems && treeViewItems.length > 0) selectedItems.push(treeViewItems[0]);
                    }
                }
            });
            let activeTreeItem = selectedItems[selectedItems.length - 1];
            if (activeTreeItem) {
                this._treeViewToc?.expandToTreeItem(activeTreeItem);
                activeTreeItem.setIsActive(true, true);
                activeTreeItem.setIsSelected(true);
            }
        }
    }
    setActivePageItems(navigationItemsInVisibleRange) {
        if (navigationItemsInVisibleRange && navigationItemsInVisibleRange.length > 0) {
            this._treeViewPages?.deselectAllItems();
            let selectedItems = [];
            navigationItemsInVisibleRange.forEach((item)=>{
                if (item.collectionType === "PAGE_LIST") {
                    let locator = item.locator;
                    if (locator) {
                        let treeViewItems = this._treeViewPages?.filterTreeItemsByItemData((navItem)=>{
                            return navItem.locator === item.locator;
                        });
                        if (treeViewItems && treeViewItems.length > 0) selectedItems.push(treeViewItems[0]);
                    }
                }
            });
            selectedItems.forEach((activeTreeItem)=>{
                activeTreeItem.setIsSelected(true);
            });
        }
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _mapNavigationItemDataToTreeItemData(navigationItems) {
        const map = (navigationItem)=>{
            return {
                data: navigationItem,
                id: navigationItem.locator || "",
                textContent: navigationItem.title,
                children: navigationItem.children && navigationItem.children.map(map)
            };
        };
        return navigationItems.map(map);
    }
    _selectCurrentActiveItem() {
        if (this._treeViewToc) this._treeViewToc.activeItem?.setIsActive(true, true);
    }
}



class $f30a84ea8d399c2c$export$bb9fa2da2e9b8963 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(hostElement, insertPosition = "afterbegin"){
        super(hostElement, "vanilla-reader__dialog-footnote", "Footnote", insertPosition);
        this._bodyStyle = `<style>
                
                #vanilla-reader__dialog-footnote + .vanilla-reader__modal-overlay {
                    background-color: transparent !important;
                }

                #vanilla-reader__dialog-footnote {
                    min-height: 20% !important;
                    height: 30% !important;
                    max-width: 600px!important;
                    bottom: 0 !important;
                    top: auto !important;
                    border-bottom-left-radius: 0 !important;
                    border-bottom-right-radius: 0 !important;
                }
                #vanilla-reader__dialog-footnote__button-goto {
                    font-family: Lato;
                    margin-left: 0;
                }
            </style>`;
        this._bodyTemplate = `
            <aside id="vanilla-reader__dialog-footnote__content"></aside>`;
        this._footerTemplate = `
            <button id="vanilla-reader__dialog-footnote__button-goto">Go to footnote</button>`;
        this._dialogElement.insertAdjacentHTML("afterbegin", this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._dialogFooterElement.innerHTML = this._footerTemplate;
        this._footnote = this._dialogBodyElement.querySelector("#vanilla-reader__dialog-footnote__content");
        this._buttonGotoFootnote = this._dialogFooterElement.querySelector("#vanilla-reader__dialog-footnote__button-goto");
        this._buttonGotoFootnote.addEventListener("click", ()=>{
            if (this._gotoFootnoteButtonClickedCallback && this._footnoteElementId) this._gotoFootnoteButtonClickedCallback(this._footnoteElementId);
        });
    }
    onGotoFootnoteButtonClicked(callback) {
        this._gotoFootnoteButtonClickedCallback = callback;
    }
    show(silent, returnFocusOnClose = true, onDialogCloseCallbackOverride, footnoteHTML, footnoteElementId, noteRefLocator) {
        super.show(silent, returnFocusOnClose, onDialogCloseCallbackOverride);
        this._footnote.innerHTML = footnoteHTML || "\uD83E\uDD14";
        this._footnoteElementId = footnoteElementId;
        this._noteRefLocator = noteRefLocator;
    }
    close(silent = false, returnDialogResult = true) {
        this._footnote.innerHTML = "";
        super.close(silent, returnDialogResult);
    }
    /*
    * Class internal
    * */ // Return the element id of the noteRef element so that we can put focus back where it should be.
    _getDialogResult() {
        // @ts-ignore
        return this._noteRefLocator;
    }
}




class $c22cecb4112f958f$export$65e3f2154417f17b extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(hostElement, insertPosition = "afterbegin"){
        super(hostElement, "vanilla-reader__dialog-help", "MasterPlan Reader for PDF, EPUB and Audiobooks is powered by Colibrio Reader", insertPosition);
        this._bodyStyle = `
        <style>    
            #vanilla-reader__dialog-help section {
               margin-bottom: 2em;
               line-height: 1.5em;
            }            
            #vanilla-reader__dialog-help section h2 {
               font-size: 18px;
            }
            #vanilla-reader__dialog-help section h3 {
               font-size: 16px;
            }
            #vanilla-reader__dialog-help kbd {
                border: 1px solid var(--vanilla-reader__color__ui__outline-dark);
                border-radius: 4px;
                padding: 4px;
                background-color: rgba(256,256,256,0.2);;
            }            
            #vanilla-reader__dialog-help a {            
                color: var(--vanilla-reader__color__ui__accent);
            }

        </style>`;
        this._bodyTemplate = `
        <section>
            <a href="#vanilla-reader__dialog-help__keyboard-shortcuts">Jump to keyboard shortcuts</a>
            <h2>
                Note to screen reader users
            </h2>
            
            <p>
                For a good reading experience we recommend that you use the <kbd>Alt</kbd> + <kbd>Z</kbd> / <kbd>Ctrl</kbd> + <kbd>Option</kbd> + <kbd>Z</kbd> shortcut to enter 
                into the screen reader accessibility preset mode. This mode is simply a reading configuration that uses
                the scroll renderer, increases the text font size and turns off unnecessary animations. In this mode, 
                the Read Aloud controls are also active. These controls let you use the built-in Colibrio
                Text to Speech functionality. This will handle all navigation, so you can just listen to your book without
                care.
            </p>
             <p>
                While in Accessibility Mode, tapping / clicking the screen the App Actions dialog is opened. In this dialog you can 
                choose and perform any of actions available in the app UI.  
            </p> 
            <p>
                Also, if you are using NVDA note that in system UI, such as dialogs and menus, you should use focus mode.
            </p>
            
            <h3>Note on reading controls</h3>
            <p>
                In order for Colibrio to properly determine where the screen reader is focused, we recommend that you use
                the "Actions" menu to complete actions such as bookmarking, highlighting etc. You access this menu when 
                in accessibility mode by either double tapping on a touch screen, or by pressing the space bar on a computer.  
                <br>
                You can also choose to read one object (paragraph, heading or section) at a time. Using this reading 
                method bookmarks, highlights and so much more will work well.
            </p>
            <p>
                If you just want to listen continuously, without pressing keyboard buttons to move through the text, we 
                recommend using our build in Text to Speech (<kbd>Alt</kbd> + <kbd>R</kbd>). When you stop the built-in TTS (<kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>R</kbd>), 
                we will try to focus the screen reader as close as possible to the current reading position.
            </p>
            <h4>Tip</h4>
            <p>
                To put focus back to the book contents you can always press,
                <span><kbd>Alt</kbd> + <kbd>X</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>X</kbd></span>
            </p>
            
            <h3>Android specifics</h3>
            <p>
                To navigate to the next or previous you can swipe left or right using two fingers.
            </p>
            
        </section>
        <section>
            <h2 id="vanilla-reader__dialog-help__keyboard-shortcuts">
                Keyboard shortcuts (Windows / Mac)
            </h2>      
            
            <h3>General</h3>
            <ul tabindex="0">
                <li>                    
                    <h4>Open Help dialog (this one).</h4>                    
                    <span><kbd>Alt</kbd> + <kbd>F1</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>F1</kbd></span>
                </li>                          
                <li>                    
                    <h4>Open App actions dialog.</h4>
                    <span><kbd>Alt</kbd> + <kbd>Control</kbd> + <kbd>F2</kbd></span>
                </li>
                <li>                                    
                    <h4>Open Search dialog.</h4>
                    <span><kbd>Alt</kbd> + <kbd>S</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>S</kbd></span>
                </li>
                <li>                                    
                    <h4>Open Settings dialog.</h4>
                    <span><kbd>Alt</kbd> + <kbd>T</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>T</kbd></span>
                </li>
                <li>                
                    <h4>Close all dialogs and focus on reading position.</h4>
                    <span><kbd>Alt</kbd> + <kbd>X</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>X</kbd></span>
                </h4>
                <li>                                    
                    <h4>Open new book.</h4>
                    <span><kbd>Alt</kbd> + <kbd>Q</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Q</kbd></span>                    
                </li>
                <li>                
                    <h4>Open the Main Menu.</h4>
                    <span><kbd>Alt</kbd> + <kbd>M</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>M</kbd></span>
                </li>
            </ul>

            <h3>Navigation</h3>
            <ul tabindex="0">
                <li>                    
                    <h4>Open Table of Contents.</h4>
                    <span><kbd>Alt</kbd> + <kbd>C</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>C</kbd></span>
                </li>
                <li>                    
                    <h4>Go back.</h4>
                    <span><kbd>Arrow Left</kbd></span>
                </li>
                <li>                    
                    <h4>Go forward.</h4>
                    <span><kbd>Arrow Right</kbd></span>
                </li>
                <li>                    
                    <h4>Go back.</h4>
                    <span><kbd>Alt</kbd> + <kbd>Arrow Up</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Arrow Up</kbd></span>
                </li>
                <li>                    
                    <h4>Go forward.</h4>                    
                    <span><kbd>Alt</kbd> + <kbd>Arrow Down</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Arrow Down</kbd></span>
                </li>
                <li>
                    <h4>Go to next heading.</h4>
                    <span><kbd>Alt</kbd> + <kbd>G</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>G</kbd></span>
                </li>                
                <li>                                    
                    <h4>Go to previous heading.</h4>
                    <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>G</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>G</kbd></span>
                </li>
                <li>                    
                    <h4>Go to a specific location in the book.</h4>                
                    <span><kbd>Alt</kbd> + <kbd>P</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>P</kbd></span>                
                </li>
                <li>                    
                    <h4>Open navigation history list.</h4>                
                    <span><kbd>Alt</kbd> + <kbd>Y</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Y</kbd></span>                
                </li>
            </ul>
                
            <h3>Bookmarking</h3>
            <ul tabindex="0">
                <li>
                    <h4>Bookmark reading location.</h4>
                    <span><kbd>Alt</kbd> + <kbd>B</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>B</kbd></span>
                </li>
                <li>
                    <h4>Bookmark text in clipboard. Perfect for screen readers such as NVDA. Please note the extra <kbd>Control</kbd> key modifier for this shortcut.</h4>
                    <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>B</kbd> / <kbd>Control</kbd> + <kbd>Shift</kbd> + <kbd>Option</kbd> + <kbd>B</kbd></span>
                </li>        
                <li>
                    <h4>Open Bookmarks dialog.</h4>
                    <span><kbd>Alt</kbd> + <kbd>O</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>O</kbd></span>
                </li>
                <li>
                    <h4>Show Visible Bookmarks dialog.</h4>            
                    <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>O</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>O</kbd></span>
                </li>
            </ul>    
                        
            <h3>Highlighting</h3>
            <ul tabindex="0">
                <li>
                    <h4>Highlight selected text.</h4>
                    <span><kbd>Alt</kbd> + <kbd>I</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>I</kbd></span>
                    <details>
                        <summary>NVDA and JAWS note</summary>
                        For NVDA and JAWS users, please use the "Highlight text in clipboard." (<kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>Control</kbd> + <kbd>K</kbd>)
                    </details>
                </li>
                <li>
                    <h4>Highlight text in clipboard.</h4>
                    <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>Control</kbd> + <kbd>I</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>I</kbd></span>
                    
                </li>
                <li>
                    <h4>Show Highlights dialog.</h4> 
                    <span><kbd>Alt</kbd> + <kbd>H</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>H</kbd></span>
                </li>
                <li>
                    <h4>Show Visible Highlights dialog.</h4>                    
                    <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>H</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>H</kbd></span>
                </li>
            </ul>   
                        
            <h3>Accessibility</h3>
                <ul tabindex="0">
                    <li>
                        <h4>Use screen reader accessibility mode.</h4>
                        <span><kbd>Alt</kbd> + <kbd>Z</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Z</kbd></span>
                    </li>
                    <li>
                        <h4>Exit screen reader accessibility mode.</h4>
                        <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>Z</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>Z</kbd></span>
                    </li>
                    <li>
                        <h4>Announce current reading position.</h4>
                        <span><kbd>Alt</kbd> + <kbd>W</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>W</kbd></span>
                    </li>            
                    <li>
                        <h4>Show Reading Ruler (Beta).</h4>
                        <span><kbd>Alt</kbd> + <kbd>U</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>U</kbd></span>
                    </li>            
                    <li>
                        <h4>Hide Reading Ruler (Beta).</h4>
                        <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>U</kbd> / <kbd>Control</kbd> + <kbd>Shift</kbd> + <kbd>Option</kbd> + <kbd>u</kbd></span>
                    </li>
                    <li>
                        <h4>Move Reading Ruler next (Beta).</h4>
                        <span><kbd>Arrow Down</kbd></span>
                    </li>
                    <li>
                        <h4>Move Reading Ruler previous (Beta).</h4>
                        <span><kbd>Arrow Up</kbd></span>
                    </li>
                </ul>
                
            <h3>Read Aloud</h3>
                <ul tabindex="0">
                    <li>
                        <h4>Start Read Aloud.</h4>
                        <span><kbd>Alt</kbd> + <kbd>R</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>R</kbd></span>
                    </li>
                    <li>
                        <h4>End Read Aloud.</h4>
                        <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>R</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>R</kbd></span>  
                    </li>
                    <li>
                        <h4>Skip forward.</h4>
                        <span><kbd>Alt</kbd> + <kbd>K</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>K</kbd></span>  
                    </li>
                    <li>
                        <h4>Skip backwards.</h4>
                        <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>K</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>K</kbd></span>  
                    </li>
                    <li>
                        <h4>Escape from current element (for example table cell).</h4>
                        <span><kbd>Alt</kbd> + <kbd>A</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>A</kbd></span>  
                    </li>
                    <li>
                        <h4>Escape from current structure (for example table).</h4>
                        <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>A</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>A</kbd></span>  
                    </li>
                </ul>

            <h3>Zooming and Panning</h3>
                <ul tabindex="0">
                    <li>
                        <h4>Zoom in 20%.</h4>
                        <span><kbd>Alt</kbd> + <kbd>+</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>+</kbd></span>
                    </li>
                    <li>
                        <h4>Zoom out 20%.</h4>
                        <span><kbd>Alt</kbd> + <kbd>-</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>-</kbd></span>  
                    </li>
                    <li>
                        <h4>Zoom to rectangle.</h4>
                        <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>+</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>+</kbd></span>
                    </li>
                    <li>
                        <h4>Exit pan and zoom mode.</h4>
                        <span><kbd>Alt</kbd> + <kbd>Shift</kbd> + <kbd>-</kbd> / <kbd>Control</kbd> + <kbd>Option</kbd> + <kbd>Shift</kbd> + <kbd>-</kbd></span>  
                    </li>
                </ul>
                                                     
        </section>
        
        <section>
            <h2>About</h2>
            <p>
                App version: ${(0, $a0949ff2251db721$export$354c5dd6b66622ea).appVersion}
            </p>
        </section>`;
        this._dialogElement.insertAdjacentHTML(insertPosition, this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
    }
}




class $d6eaf4072ca84a06$export$2a1156151257075e extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(hostElement, insertPosition = "afterbegin"){
        super(hostElement, "vanilla-reader__dialog-highlight", "Highlight");
        this._bodyStyle = `
    <style>
    
    label {
        font-weight: bold;
    }
    
    input[type=radio][name="highlight-color"] {
        -webkit-appearance: none;
        margin: 0;
        width: 40px;
        height: 40px;
        display: inline-block;
        border: 0;
        border-radius: 50%;
      }
    
      input[type=radio][name="highlight-color"]:checked {
        border: 2px solid var(--vanilla-reader__color__ui__outline-dark);    
      }
    
      input[type=radio][title="red"] {
        background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.red};
      }
    
      input[type=radio][title="green"] {
        background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.green};
      }

      input[type=radio][title="blue"] {
        background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.blue};
      }
    
      input[type=radio][title="yellow"] {
        background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow};
      }
      
      #vanilla-reader__dialog-highlight__form__buttonSave {
        font-family: sans-serif;            
        display: inline-block;
      }

      #vanilla-reader__dialog-highlight__form__buttonDelete {
        font-family: sans-serif;
        display: inline-block;
      }
      
      #vanilla-reader__dialog-highlight__selection-text {
        max-height: 112px;
        overflow-y: scroll;
        font-size: 0.9em;
      }
      
      #vanilla-reader__dialog-highlight__goto-location-link {
        display: block;
        text-decoration: underline;
        margin-top: 1em;
        color: var(--vanilla-reader__color__ui__foreground-dark);
      }
    
    </style>`;
        this._bodyTemplate = `
        <form id="vanilla-reader__dialog-highlight__form">
            <label for="vanilla-reader__dialog-highlight__form__comment">Highlighted text</label>
            <div id="vanilla-reader__dialog-highlight__selection-text"></div>      
            <a data-locator="" id="vanilla-reader__dialog-highlight__goto-location-link" href="#">Goto highlighted location</a>      
            <label for="vanilla-reader__dialog-highlight__form__comment">Note</label>
            <textarea id="vanilla-reader__dialog-highlight__form__comment"></textarea>
            <label>Highlight color</label>
            <input type="radio" name="highlight-color" id="vanilla-reader__dialog-highlight__form__color-red" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.red}" title="red"></input>
            <input type="radio" name="highlight-color" id="vanilla-reader__dialog-highlight__form__color-green" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.green}" title="green"></input>
            <input type="radio" name="highlight-color" id="vanilla-reader__dialog-highlight__form__color-blue" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.blue}" title="blue"></input>
            <input type="radio" name="highlight-color" id="vanilla-reader__dialog-highlight__form__color-yellow" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow}" title="yellow" checked></input>
            <input type="hidden" id="vanilla-reader__dialog-highlight__form__selection-text" value="">
            <input type="hidden" id="vanilla-reader__dialog-highlight__form__locator" value="">
            <input type="hidden" id="vanilla-reader__dialog-highlight__form__id" value="">
            <input type="hidden" id="vanilla-reader__dialog-highlight__form__publication-id" value="">
            <hr>            
            <input type="submit" id="vanilla-reader__dialog-highlight__form__buttonSave" title="Save highlight" value="Save">
            <input type="button" id="vanilla-reader__dialog-highlight__form__buttonDelete" title="Delete highlight" value="Delete">
            <input type="hidden" id="vanilla-reader__dialog-highlight__form__new-instance" value="">
        </form>`;
        /*
    *
    * EVENT HANDLERS
    *
    * */ this._event_submit = (event)=>{
            event.preventDefault();
            let formElementIsNewInstance = this._form.querySelector("#vanilla-reader__dialog-highlight__form__new-instance");
            let highlight = this.serialize();
            if (formElementIsNewInstance.value === "false") {
                if (this._updateHighlightCallback) this._updateHighlightCallback(highlight);
            } else if (this._addHighlightCallback) this._addHighlightCallback(highlight);
            this.close();
            return false;
        };
        this._event__delete = (_event)=>{
            let highlight = this.serialize();
            if (this._deleteHighlightCallback) this._deleteHighlightCallback(highlight);
            this.close();
        };
        this._dialogElement.insertAdjacentHTML(insertPosition, this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._form = this._hostDocument.getElementById("vanilla-reader__dialog-highlight__form");
        this._buttonDelete = this._hostDocument.getElementById("vanilla-reader__dialog-highlight__form__buttonDelete");
        this._buttonSubmit = this._hostDocument.getElementById("vanilla-reader__dialog-highlight__form__buttonSave");
        this._linkGoto = this._hostDocument.getElementById("vanilla-reader__dialog-highlight__goto-location-link");
        this._form.addEventListener("submit", this._event_submit);
        this._buttonDelete.addEventListener("click", this._event__delete.bind(this));
        this._buttonSubmit.addEventListener("click", this._event_submit.bind(this));
        this._linkGoto.addEventListener("click", (ev)=>{
            ev.preventDefault();
            if (this._gotoHighlightLocationCallback) {
                let highlightLocator = ev.target.getAttribute("data-locator");
                if (highlightLocator) this._gotoHighlightLocationCallback(highlightLocator);
                else console.warn("Unable to get a valid locator from link element.");
            }
        });
    }
    onGotoHighlightLocation(callback) {
        this._gotoHighlightLocationCallback = callback;
    }
    onHighlightAdd(callback) {
        this._addHighlightCallback = callback;
    }
    onHighlightDelete(callback) {
        this._deleteHighlightCallback = callback;
    }
    onHighlightUpdate(callback) {
        this._updateHighlightCallback = callback;
    }
    setState(highlight, isNewInstance = false) {
        if (isNewInstance) // Don't allow the user to navigate to location before the highlight as saved.
        this._linkGoto.style.display = "none";
        else {
            this._linkGoto.setAttribute("data-locator", highlight.locator);
            this._linkGoto.style.display = "block";
        }
        let highlightColor = highlight.color ? highlight.color : (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow;
        let formElementId = this._form.querySelector("#vanilla-reader__dialog-highlight__form__id");
        let formElementPublicationId = this._form.querySelector("#vanilla-reader__dialog-highlight__form__publication-id");
        let formElementColor = this._form.querySelector('input[name="highlight-color"][value="' + highlightColor + '"]');
        let formElementComment = this._form.querySelector("#vanilla-reader__dialog-highlight__form__comment");
        let formElementLocator = this._form.querySelector("#vanilla-reader__dialog-highlight__form__locator");
        let formElementSelectionText = this._form.querySelector("#vanilla-reader__dialog-highlight__form__selection-text");
        let formElementIsNewInstance = this._form.querySelector("#vanilla-reader__dialog-highlight__form__new-instance");
        let elementSelectionText = this._dialogBodyElement.querySelector("#vanilla-reader__dialog-highlight__selection-text");
        elementSelectionText.textContent = highlight.selectionText || "";
        formElementId.value = highlight._id || "";
        formElementPublicationId.value = highlight.publicationId || "";
        formElementIsNewInstance.value = isNewInstance ? "true" : "false";
        formElementLocator.value = highlight.locator;
        formElementSelectionText.value = highlight.selectionText || "";
        let formElementColorsAll = this._form.querySelectorAll('input[name="highlight-color"]');
        formElementColorsAll.forEach((element)=>{
            element.style.display = "inline-block";
        });
        if (formElementIsNewInstance.value === "false") {
            formElementComment.value = highlight.comment || "";
            formElementColor.checked = true;
        } else {
            let formElementColorChecked = this._form.querySelector('input[name="highlight-color"]:checked');
            if (formElementColorChecked) formElementColorChecked.checked = true;
            formElementComment.value = "";
        }
    }
    serialize() {
        let formElementId = this._form.querySelector("#vanilla-reader__dialog-highlight__form__id");
        let formElementPublicationId = this._form.querySelector("#vanilla-reader__dialog-highlight__form__publication-id");
        let formElementComment = this._form.querySelector("#vanilla-reader__dialog-highlight__form__comment");
        let formElementColor = this._form.querySelector('input[name="highlight-color"]:checked');
        let formElementSelectionText = this._form.querySelector("#vanilla-reader__dialog-highlight__form__selection-text");
        let formElementLocator = this._form.querySelector("#vanilla-reader__dialog-highlight__form__locator");
        let color = formElementColor ? formElementColor.value : "";
        return {
            _id: formElementId.value || Date.now().toString(),
            publicationId: formElementPublicationId.value,
            comment: formElementComment.value,
            color: color,
            selectionText: formElementSelectionText.value,
            locator: formElementLocator.value
        };
    }
}




class $19f0618928aea824$export$388c905326cc79f5 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    static{
        this._dialogTitle = "Highlights";
    }
    constructor(hostElement, insertPosition = "afterbegin"){
        super(hostElement, "vanilla-reader__dialog-highlights", $19f0618928aea824$export$388c905326cc79f5._dialogTitle, insertPosition);
        this._listIsFiltered = false;
        this._bodyStyle = `
        <style>
            #vanilla-reader__dialog-highlights__list {
                padding-inline: 0;
            }
            
            #vanilla-reader__dialog-highlights__list li {
                min-height: 48px;                   
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                align-content: space-between;
            }

            #vanilla-reader__dialog-highlights__list li a {
                display: block;
                margin-right: 1em;
                padding: 1em;
                flex-grow: 2;
                border-radius: 8px;
                color: rgba(0,0,0,0.8);
            }

            #vanilla-reader__dialog-highlights__list li button {
                align-self: flex-start;
            }
    
            .vanilla-reader__dialog-highlights__list__item__section-title {
                /* We set pointer events to none to let the list item receive any key/pointer events */ 
                pointer-events: none;
                display: block;
                font-weight: bold;       
                margin-bottom: 8px;         
            }
            
            .vanilla-reader__dialog-highlights__list__item__selection-text {
                pointer-events: none;
            }
            
            .vanilla-reader__dialog-highlights__list__item__note {
                margin-top: 16px;
            }
            
            .vanilla-reader__dialog-highlights__list__item__note summary {                
                margin-bottom: 8px;                
            }
            
            .vanilla-empty-element {
                display: none;
            }
        </style>`;
        this._bodyTemplate = `<ul id="vanilla-reader__dialog-highlights__list">
        <span class="vanilla-reader__dialog-highlights__list--empty">There are no highlights yet</span>
    </ul>`;
        this._dialogTitleWhenFiltered = "Highlights in view";
        /*
    *
    * EVENT HANDLERS
    *
    * */ this._event_listItemClicked = (ev)=>{
            let locator = ev.target.getAttribute("data-contentblocklocator") || ev.target.parentElement.getAttribute("data-contentblocklocator");
            if (locator && this._onHighlightItemClickedCallback) this._onHighlightItemClickedCallback({
                navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
                locator: locator
            });
        };
        this._dialogElement.insertAdjacentHTML("afterbegin", this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._list = this._dialogElement.querySelector("#vanilla-reader__dialog-highlights__list");
    }
    get listIsFiltered() {
        return this._listIsFiltered;
    }
    get selectedItems() {
        return this._selectedItems;
    }
    onHighlightItemClicked(callback) {
        this._onHighlightItemClickedCallback = callback;
    }
    onHighlightItemEditButtonClicked(callback) {
        this._onHighlightItemEditButtonClickedCallback = callback;
    }
    populate(highlights) {
        this.empty();
        if (highlights.length >= 1) highlights.forEach((highlight)=>{
            let listItem = this.createItem(highlight);
            this._list.appendChild(listItem);
        });
        else this._list.innerHTML = '<span class="vanilla-reader__dialog-highlights__list--empty">There are no highlights yet</span>';
        if (this.listIsFiltered) this.filterSelected();
    }
    setSelected(selectedHighlights = []) {
        this._selectedItems = selectedHighlights;
        this._list.querySelectorAll("li").forEach((item)=>{
            item.removeAttribute("aria-selected");
            let highlightLocator = item.getAttribute("data-contentblocklocator");
            if (highlightLocator) {
                let shouldSelect = selectedHighlights.find((item)=>item.locator === highlightLocator);
                if (shouldSelect) item.setAttribute("aria-selected", "true");
            }
        });
    }
    show(silent, returnFocusOnClose = true, onDialogCloseCallbackOverride, filterSelected) {
        super.show(silent, returnFocusOnClose, onDialogCloseCallbackOverride);
        if (this._listIsFiltered) this.removeSelectedFilter();
        if (filterSelected) {
            this.title = this._dialogTitleWhenFiltered;
            this.filterSelected();
        } else this.title = $19f0618928aea824$export$388c905326cc79f5._dialogTitle;
    }
    filterSelected() {
        this._listIsFiltered = true;
        this._list.querySelectorAll("li").forEach((item)=>{
            let itemLocator = item.getAttribute("data-contentblocklocator");
            let keepItem = this._selectedItems?.find((item)=>{
                return item.locator === itemLocator;
            });
            if (!keepItem) item.style.display = "none";
        });
    }
    removeSelectedFilter() {
        this._listIsFiltered = false;
        this._list.querySelectorAll("li").forEach((item)=>{
            item.style.display = "flex";
        });
    }
    createItem(highlight) {
        let listItem = this._hostDocument.createElement("li");
        listItem.setAttribute("tabindex", "0");
        listItem.setAttribute("title", `Highlight`);
        listItem.setAttribute("data-booksection", highlight.bookSection || "");
        listItem.setAttribute("data-contentblocklocator", highlight.locator);
        listItem.setAttribute("data-datecreated", `${highlight.dateCreated || ""}`);
        listItem.setAttribute("data-dateupdated", `${highlight.dateUpdated || ""}`);
        listItem.className = "vanilla-reader__dialog-highlights__list__item";
        let listItemEditButton = this._hostDocument.createElement("button");
        listItemEditButton.innerHTML = '<span aria-hidden="true">edit</span>';
        listItemEditButton.title = "Edit highlight";
        listItemEditButton.className = "vanilla-reader__dialog-highlights__list__item__button-edit";
        listItemEditButton.setAttribute("tabindex", "0");
        listItemEditButton.addEventListener("click", (_ev)=>{
            if (this._onHighlightItemEditButtonClickedCallback) this._onHighlightItemEditButtonClickedCallback(highlight);
        });
        let listItemAnchor = this._hostDocument.createElement("a");
        listItemAnchor.setAttribute("data-contentblocklocator", highlight.locator);
        listItemAnchor.addEventListener("click", (ev)=>{
            this._event_listItemClicked(ev);
        });
        listItem.addEventListener("keyup", (ev)=>{
            if (ev.key === "Enter" || ev.key === "Space") this._event_listItemClicked(ev);
        });
        listItemAnchor.style.backgroundColor = highlight.color;
        listItemAnchor.innerHTML = `
            <span class="vanilla-reader__dialog-highlights__list__item__section-title" title="Book section"></span>
            <span class="vanilla-reader__dialog-highlights__list__item__selection-text" title="Highlighted text"></span>
            <details class="vanilla-reader__dialog-highlights__list__item__note ${highlight.comment != "" ? "" : "vanilla-empty-element"}">
                <summary>Note</summary>
                <span class="vanilla-reader__dialog-highlights__list__item__note__text"></span>
            </details>
            `;
        listItemAnchor.setAttribute("tabindex", "0");
        let spanElementSelectionText = listItemAnchor.querySelector(".vanilla-reader__dialog-highlights__list__item__selection-text");
        spanElementSelectionText.innerText = highlight.selectionText.length > 150 ? highlight.selectionText.slice(0, 150) + "..." : highlight.selectionText;
        let spanElementTitle = listItemAnchor.querySelector(".vanilla-reader__dialog-highlights__list__item__section-title");
        spanElementTitle.innerText = highlight.bookSection || "";
        let spanElementNoteText = listItemAnchor.querySelector(".vanilla-reader__dialog-highlights__list__item__note__text");
        spanElementNoteText.innerText = highlight.comment;
        listItem.appendChild(listItemAnchor);
        listItem.appendChild(listItemEditButton);
        return listItem;
    }
    empty() {
        if (this._list.childElementCount > 0) {
            let firstListItem = this._list.firstChild;
            while(firstListItem){
                firstListItem.remove();
                firstListItem = this._list.firstChild;
            }
        }
    }
}



class $74af336e1483b477$export$2a16789284a2ec0 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(hostElement, insertPosition = "afterbegin"){
        super(hostElement, "vanilla-reader__dialog-image-viewer", "", insertPosition);
        this._bodyStyle = `
        <style>
            #vanilla-reader__dialog-image-viewer__image-container {
                margin: 0;
            }
            #vanilla-reader__dialog-image-viewer__image-container__image {
                width: 100%;
                height: auto;
            }       
        </style>`;
        this._bodyTemplate = `
            <figure id="vanilla-reader__dialog-image-viewer__image-container">
                <img id="vanilla-reader__dialog-image-viewer__image-container__image" src="">
                <label for="vanilla-reader__dialog-image-viewer__image-container__image-desc">Alternate description</label>
                <figcaption id="vanilla-reader__dialog-image-viewer__image-container__image-desc"></figcaption>
            </figure>`;
        this._dialogElement.insertAdjacentHTML("afterbegin", this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._image = this._hostDocument.getElementById("vanilla-reader__dialog-image-viewer__image-container__image");
        this._imageDescription = this._hostDocument.getElementById("vanilla-reader__dialog-image-viewer__image-container__image-desc");
    }
    loadImage(url, description) {
        if (url) {
            this._image.setAttribute("data-mediaobjecturl", url);
            this._image.src = url;
            this._imageDescription.innerText = description ? description : "No alt text for this image";
        }
    }
    _getDialogResult() {
        let mediaUrl = this._image.getAttribute("data-mediaobjecturl");
        // @ts-ignore
        return mediaUrl;
    }
}


const $105b063428bdec84$export$ad5942a74c9bd4ba = "iVBORw0KGgoAAAANSUhEUgAAAQAAAAFACAYAAABTKqIKAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAIABJREFUeJztnXeAE2X+/98zqbvZlt1sX6pSpElVQKQ3K4IgiCiWs5yennp8LZznnX717tRT7756YgEF1B8IWO5EQBSliigi0qTX3WV7tiS7m00m8/sj7G6yaZNkJslkPq8/lJnMPM8z+zzP+6mfz8Pw1jIeBEEoEjbWCSAIInaQABCEgiEBIAgFQwJAEAqGBIAgFAwJAEEoGBIAglAwJAAEoWBIAAhCwZAAEISCIQEgCAVDAkAQCoYEgCAUDAkAQSgYEgCCUDAkAAShYEgACELBkAAQhIIhASAIBUMCQBAKhgSAIBQMCQBBKBgSAIJQMCQABKFgSAAIQsGQABCEgiEBIAgFQwJAEAqGBIAgFAwJAEEoGBIAglAwJAAEoWBIAAhCwZAAEISCIQEgCAVDAkAQCoYEgCAUDAkAQSgYEgCCUDAkAAShYEgACELBkAAQhIIhASAIBUMCQBAKhgSAIBQMCQBBKBgSAIJQMCQABKFgSAAIQsGQABCEgiEBIAgFQwJAEAqGBIAgFAwJQIJSfa7G43r9qxs8rt+Y96bH9Vt3vONxvePD7zyuWxpbREwdES8wvLWMj3UiiNBxck7UVzbg3L6zKPm1FCWHSlB2tAyVp6tQX1kPiJirPHiwDIvU7FRkdzUhp3sO8nvno7BPIbpc2hnpeelQqVQAI16cRHQgAZAJdpsd5/YX4/DWwzjxw0mc3nMa5hJz2+88eDBCaiADUcUBDJBZmIkug7rg4su64+IRPdB1UBdodBoSBBlAAhCn8DyPylOV2LdhPw5sOohj3x1DU31TrJMliKS0JPQa1RN9xvdB/8n9kNMtBwxLahCPkADEETzPo/hAMX767x789NkelP5aCp6Pr+wR3NNwo6hvIQZeMxDDZgxDUb9CMAyJQbxAAhAH1JyrwXcrdmLXmh9QcrAk1smRlPxe+RgxZziGzx4OU5esWCdH8ZAAxAjOwWH/xv3YvHgLDnx9EE7OGVoADMDz4g+zw2nhw4FVs+gzrg/G3jkaA6YOgFqrljxOwhsSgChjrbFi2/Lt2PTWN6g+W+3zGX+VUIzKGa0KHgqmzlkY+5uxGHPnaBiMhlgnR1GQAESJmuIafP3GJmxdug2NdY1Ri1fqCh9K+MGe1afqMfr2KzH5d5OQWZQpVhKJAJAASIy5tBbrX1mPbcu3w2a1SRZPPLXskaZFl6zDFbeOxNWPXkVCIDEkABJhqbFgw6tf4pu3v0Wzpdn7gQ7r8Txiv2zuLw3REBdfcesMOoy/dxyuengqUrJSJI1fqZAAiIzdZseWd7fii5fWoa68LtbJSQjSc9MxbeF1GHXbKJosFBkSAJHgeR6/bj6MVX9cjbP7zoq+FTdeuvexoPX7O1/aGbP/OguXjL0k1klKGEgARMBSbcHHf/kE25fvAOfgBL8Xy4odD6ISThpUahVGzhuJmc/MQKopVaKUKQcSgAjgeR67P/0Jqxau8rK+i1oa4qAix4KM/AzMeWE2hk0fStuMI4AEIEwsNVasfHwldq78HrzT80/oq1IKrahSrfVHUyii9f2sisVlNw7D3H/cTJOEYUICEAZHth3B0geWofxERayTEhp+LAHDEYd46nnkdM/B/NdvwyVjesc6KbKDBCAEODuHL15ehy9eXAe7zR7r5BBuaPQaXLPgalyz4GqoNKpYJ0c2kAAIpKGqAcseXI6f1+716vIT0cVv74MBBl09ELe/MZ8mCAVCAiCAM3vP4u0738H5I+cjDitw1zk624GCd9+90yFWlz8aQ4f8nnm457270WVgF0njSQRIAIKwd90vWHLPu7CarYKel6IKx9N4OxhSpDWcMA3GZNz55h0YdO0gUdOSaJAA+IHneXz7zmasWrgaLU3kEFOOaPQa3PT8LIy/dxw5IfEDCYAPOAeHT5/9DF/+a2PQjT2RtniRvB8PPYN4/35WxWLqw1Mw4+npYNXkBLsjJAAdsNscWPE/K7Dl3a2iuOOKdiWNN0GJh+9nGAbj7h6LOS/OhlpDtgTukAC4YW+2Y+nvluP7ld/HnS8+MYiHHkOsYFgGV8wdiVv/b57LYzEBgA4GaaOl2Y73frs0YSs/AMVWfgDgnTy2f7gD7923FPZm2sPRCgkAAIfNgeW/W47vV+3yWfl5UR3pC8NXnLFIR6zileT7eWDX6h/w/sMfgLMLN9pKZBQvAE6HEx8uWIGdK7/3+0zAljOERjWUAuwrTn/pkLqChvr9DMug++W90GfiQKjdutuhpDK07xcOz/PY/sEOrHhsZUiWm4mKomdEeJ7HJ89+iq3vuSb8whojh1D6pDLQCSsMH3YBofn3u1D3O4SR1Tkbc179DQZedzkYFYPdq3fgndteAdfi8ApZvO8PER7YvHgL9Kl6zHzmxti7Yoohiu4BfPvOZmz415dt3X6xdroJJaZjch5Q69ToPKg7Lr12GPpfNQSFfbqAVQkrEh1TzjAMBt0wHAu/ewlpXVm8fM8N+Oz1v2LYrCtw8XDfRjqx/H6n04kN//oS37zzbczSEA8otgfwy/p9WLVwNZwOYf74he7wk6JQi7m7kAcPjU6LcfddhQkPXouszjltxjP25haUHyvF+hc/wa4VWzzOKgiUBrVOg2lPz8GUBTNwbM8OvP34PWiyNKBTr36wmi1orBO2i9J/msX9/tY8cjqcWPXH1cgsNGLgNQNFikFeKHIZ8Mzes/jHdS/DWhNZwQRiv7QWLP6OlSfVlIZ7V/wPLplwqd/dcU7OiR3LNuH9+xfBEcTqMTnDgDuW/B6Dpw/Hjxs+xcoXFoIzMJj38N8weNw1aGm0Y9Nra/H1a5+jvrw2jC8MTKjf74uUzBQsWPsoOl/aWdS0yQHFCUBDVQP+PvlFUQx75IYmSYs/bHgWPUf3FfT8+pc+werH3/M7z2EszMJvVz2O7pf3xIalr2Hn5x9h1qPPQNcpDat++Ds6pQ7AmIEz0TW/P8zFVVjzxDLsWrk1Lq0pC3rn44mNjyvOsYii5gA4B4dlv1vuVvnjY3krWlz3x9mCKz8ATHlkGroN7eHzN1PXHDy64Rl0u6wH1rz6DI7s3oGH31iFSy4bi17dhiM9Pw3/+eUN3PH8GPzt/TvBGDn8ZtkjmP7sPKjU8WKv354XpYfPY+kDy+BQ2PKgogTgi5fW4ecv9rrdkXZZzVc4wYYLweION22mrrmY/Mi0kN5h1SpMXTDda6iQ3S0XD3/xF+RfUoTVLz8NW6MF97+yDNXH67FtyVcAAHNTKTI66wG1HZ9tX4En35qOupZyXPPETIycP8FvnFJ9v288v+vnL/Zi/cvrRQw//lGMABzZdgTrXl4vqPvp71y+UBHmAy+0d8KdbxhzzxRok3Uhv9f/6qFIyjC0fX+qKQ0PfLIQBZcUYd3iV8GwKtz8xN9x5JuDeG36c22Wkw6nHayaQU5X11l/B47vw7Kdj4NjHLjhL3ORlpsBIHrfLwTeyWPtS1/g8LYjksURbyhCAKw1Viz93fKIzHqFOrQMPVxp4cFDo9dixLxxYb2vT0lC1yEXgQEDVsXi1kX3o/PA7ti5dhVqK8tw48N/wr51e/DmzS/BUtMAR4tr0jBNbwIDBim5GhiSNXDYOfxSshkHSjfBWJSFoTeOBBCd7w8Fe7Mdyx9cDku1RaIUxRcJLwC8k8eKx1ei/Hi5799F7FJGezVASMoZMOg/dQgyO5nCjqfrhXmAEfPGYvD0ESg5/it+2fIlZv3hGRzedACLb3sFzQ1NYMCgttTlHr175gAYtMlgVAxMRUngGYBzcth2agV43omLRkZ+uIfQ7w8chncoZcfKsfLJVQlrE+JOwgvA7s924/uPdvn9Xc4GMkJSnpKViunPzYsontweBUjJSsOM528D52jBf994EbP+8AzqShuw+PZX0dzQ1Pbs6Z+Ow+ng0D9/ElK1aWAZBqn5Wuj1anBNPE5U74W1xYyci/IjdtIhRs75y/+dK3fix493ixBDfJPQAmCptuCjJ1d12NAS36ruK3XhprmoXxc8sv4ZFPaNbH07LScDEx68FsbCLGxevRTDpt6AzNxCrHx0sdfa/tk9J1B2tBQXmy5DUUZfpOvSwagZ5HZOga3BAWtLHWqbypBqSoMmSesVl9RGUEJD4jkeK5/8CPUV9aLFHY8krADwPI81T38Mc4lnAY1Fix/a9mBf90JLc1pOOqb/7zw8uf1FdBvmexkvFDI7mTDhgWtgMVej+MhBDJ5wLfZ/uQf71nm3kI4WB9a9sAbgWVzbdwEy9CYY9UZc3KMIjkYeTt6JsoYTSM83wmD0XnMPxQgoEP7+4qGEVFtaizVPfxxy3HIiYQXg8JYj2PHBdyGN4yJtafy9H3inmjhehwDXxpxpf5mLv/z8f7juqdlISk+OOGwAKBrQFSlZadj+2YcYe9PtYBgGG176BM4O1nSt6di1Ygt2rdiCooy+uL7/k8hIMiErNRNFnbLhtPOosp6FzqBHQZ9Oon6/O+HIvK9wdq78Hoe3Hg4jNHmQkLYADpsDHy1cFbK5Z6RHV4XTUkXaI2FYBkV9u2L0byZj+NwxSDGlRRSezzgYBvYWG0qOH8ak2+5HU10Tel7ZFwWXdMK5fadxdu9J2CzNbd/C2Tm8f/8i19FdsychPSkX6w7+E6YCCziLDcW1rgrVdWgPHPxqb6CohaVPpF6dr3A4O4eVT6zCU5sXJuTR5In3RQA2L9mMc/vOtV37q7Th7OOPl0lDbbIOfSZcirH3XYVLxg3wOZ4Wk8O7tqL7gKFQqdRINqpxwzO3AAB4pxOVp8qx+c312PzWhrYJweaGJiy54184vfs4rn1qNu694h2U1h/FD2c+Q4XlNBycDZ0HdhccfyQGQZHm/7l957Dl3a2YcN/4MFMQvyScLYCl2oKnhj4t+8kbf4UzoyATw28egyvumIiCSzqJfjIub7fDXloKNikJ6pyctvvv/elBXHvvAmQX+T5sg+d5nPnpOBbP/ydKD531+C2/dxGuWTgLQ6aPhC5FD4ezBWpWg28Xrcf79y/yHV6Mjaza0+ESnrScNDy3+9mEsxVIOAFY/ac1WP/KhqjEFZ1zfFxd8IK+nTHuvqsw7KZRSM1OFz0OvrkZ5iVLYH7nHbScPAlWr0fS5Zcj88EHoR5+OV5/dD4eeXMNVOrAncba8zVYdNMLOLb9kNc35PUqxOU3j0b/qUNQdaYCKx5+p23fgBy4ZsHVuPGZGbFOhqgklADUFNfgqaFPo7mhOdZJARCqhx0fzzKupbyrHpuJITNGhLWVVwhcfT2Kb74ZlnXrvH9UqVAyrD9O9umGu/70CtiMDKjS04EAa/h15834x6SnUHzwTGTfL5Bo9RaS0pLw3O5nYSw0Sh5XtEioVYD1r26QtPKHqpShFMqOz2qTdZj29M1YuONFjJg3VrLKD55H2QMPwH7mDPL//W/oLumwQ4/jcLL4BLiNX+NY37443qcPTk+YgLqVK8E7HD6DTM834o7FD0FvSBKcDKH+/sIxsBKLpvomrH81Or3LaJEwPYCa4hr8cfCfYLPaAj4XcascBQzGFNy17BEMvPYyyccY1s2bcXr8eHRavRppN96Iuo8+QvGcOQDahziNGhY8AIPdzXsSyyLzvvuQ969/gfE1LOCBDx96C5teXyvtB4RIpPmvM+jw15+fS5heQML0AL7699dBKz8QmqVfpKa74TyvSdLijiUPYeB10ld+AKh54w3wPI/apUvR8PnnMC9Z0vZba/TJdqdn5QcApxM1ixbBstZPBWeAcb+9yqPnEg+7MCPNf5vVhq8XbRI9XbEiIQTAWmPFtmXb27PRLd+EFLpwW3kplhDH3jMVg28YHlZ6QoV3OGDduBEMgIa1a3H2+uth/eqrEALgUfP224DTt1/F/N5FyO9d1HYtdW8q3G3UoaZr27JtaKprCv6gDEgIAdi2fDsa6xvbs9Etz8UsdFK3YGm5Gbj68ZkBJ9jExH76NLi6OsHP+/r65l9+gbPJd2VgWBadBnQLM3XC4veIz+c98fPfUmPF9g92iBZuLJG9AHB2Dt++861o3r0CBSNVC9Ya54h5Y5GeH72xJVdR4TctvvD19VxlJWD37zg0OcMQNB0dhdV/l1x6hOb/1298nRAHi8heAPZ9uR+Vp6tECy+S3WaRxKnWqnH5nDFhhxEOvlIc6vez6elAgL0BLU2hz8vEcgOQ0JgrT1dh/5cHJE1LNJC9AGxestnrXiwmmyIttMYiE4oGdBUnMQJx3+kXLvqBA8Em+zc6qiszRxxHIGJ5huKWd7dEJR4pkbUA1BTX4Ndvf/W6Hw9bSEOlsG/nqBubaLp2BZsS2dbW9FmzANZ/Mao+UxlR+MEQy3w4HA5sOoiaYvnsZPSFrAXguxU7w3bjHLnpb3jh+3uv1UlmNGHUahjGjg3rXR6A2mRC6vTpAZ+79/8twORHb2ibC5D67y48nMjTwdm5gN6m5IB8BYAHdkXwxw/1pN2O94O1Mf5Nhn0Tq8MyMubP90yHn+e8vfcCxgcegDo7O2D4+Zd0wpyX78JT37+M/lOHgGUiK3Jite1i5T8JQIw4d+AcSg+Lf7qPmLb+QmgtWFVnvGfko0HqtGnQDx7cdu3vKzveTxo+HFl/+IPgePJ6FeJ3n/4RUxZM9ziAVGiFixah5n/xwWIUHyiWMkmSIlsB2P3pT1H19iMVrQWr9OBZNEV4iGZY8Ws0KFy8GKoM4UOQpGHD0HnNGqhSU0OKS6PXYObf5uOqx25sM2OOluBKmf+7P/tJsrClRpYCwPM89nz+s//fY2gwEioMwyDnonxMWTAdKk1s/LPoBw1C588/h/biiwM+x6akIPP3v0eXjRuhLiwMKy5WxeKGZ+Zi6MwrwnpfCNHO/z2f/yxbF+Ky9AhUeaoSpb+W+v09WpVdqGGJv+d0yTpMevQGXLVghmj++8IledQoXPTjjzC//z4aPv4YzYcOgW9pAavXQ9e7NwyTJyN95kxoe/SIeKeiSqPGza/ejRM7j6DmXGirBEL+5tHO/+KDxag6U43sruGfvRArZGkN+PWiTfh/C1ZcuBLPLYc41n/C0pOWm4G73nsY/aYOjtg/vhQ4LRZw9fVQZ2SACbDOHwmb31yP5fe/EYszWn0SSf7f8vJcWboMk+UQ4OCmg25X4biMDs/6TxjBw0jPM+LBz55C/6uGxGXlB1zdfU1BgWSVHwAunzsGpq65Pn+TcswuRf57lkn5IDsBcLQ4cHTHsYjCiOV8gDZZh7uWPoyLhveKWRrihaS0ZAyZMcLnb1LmkRRhH91xFJwMjxaXnQCc/eUsmuqDm2KK2X6I1hoxwORHpqHflMHBn1UIl149TBIrH3FPEwoeVmNdE866eaKWC7ITgCPbj/q8L3ijThiFTayTgbO75mLqgsRyKhkpub0KkZwufDuy8I064qmK0Pw/sl1+x4rLTgBO/njS533BGc5LM+ckJP7Lbh4tyDxWSaSa0qBP1Qt+PtobtYTCgMGJH3yXzXhGVgLgdDpxcvepiMOJpKiE6waMYRlces1lEcScmKh1GlmduBMo/0/tPhmzLd3hIisBaKhogLlEWvPSYITrBiwlKw25PfKlSJKscdjsspo8C5T/NcVm1FfK60AaWQnA2X1uJ84w4nTlhbidbo0vElKyUmHIDG3rrBKw1ljQ1BCGfz2Revxi57/cJgJlJQDn3I0ueHFOgO0Yhl+Fj1BtDFmpHkYwhIvzR4rRVOtpAyFooi/M/JA6/0sOysswSFYl8vyR0K3/pJwd9hW+P1iVStR4E4Xq0xVQdZgDEHOiz9uMWdr8l8JCVUpkIwA8z6PsWLn/3yXd3ecfoX7mbZbEcCMtNlfcPgEP/ecpZHaKbB99rByJdsz/8uMVsjIMko0AAC4jIH+IUdHFsk33lZbGOmtCeJGVgn5TBmPB188hr1d4FoZA/OR/5anKuLFtEIJsBMDR7EBDZYOkcUi5xtxYY0FDRW3E4SQqeT0L8fDaPyOrS+SOSsNFjPyvLa+Fo8X3mYnxiGwEoKG6QVZdq45YzRYU7zsT62TENTkX5+PuDx6FPsXzUNF4debiEx6wVFtinQrByEYArOZGUcOLdpHqOaovsrvnRTlW+dFzVF9c/eRMj8G7FPM4Uua/pSb6np3CRTYCYKnx3f0Pt3UIpUhFdOgHy2D8A9fg0Y3PILdnQdjhKIlJD12Pov5dBT0bj/lvNZMAiE5tqe/xs9BZ+MhO7gmtBWrf/svi2oU34Zb/uwfaJF2Qt4hWdCl6XPPETEHPxmP+m0vkc1aAbASgPoQJQL+HRfjd4xF64Qj0Tmtc4+6biml/vhlMgIMzCN8MvP7ysHtMsc7/hiqaAxCdhioRVgD87vIMfYwZ7J2+Ewfipn/cBVZNG4DCQWfQY8iMkeIGGqX8F6WsRgnZCIC7E5B4nxVOy8nArYvuhzZJG+ukyBp/LtPiO/chyGFNvCAbAbBZ20+ZjXRWOJiAhDWGdEvS1U/ORM5FZPkXKfm9OyHFlOZ1P3K3rRLkvxvNluaQ0xQrZCMAdpt4myvCcSsdVHQulI+ci/Mx+q7J4SaNcCMlKxWp2Wmi9/gkyf8L8ODhELGsSo1sBEAuNuOj7pgIfWpS8AeJoLAqFul5mTH39hMKDBjZlFVARgLgi3iYC3BPg0qjxqBpw2OYmsSDdzr9/xZn+R/oXrwiGwFQabxn04WuAQslnHfd05DVJRvZ3X37uSdCh7M7YC71v6Yeb/nfSqyOeAsH2QiARifsjxqouxgsgyPtapq65tKGHxGpOVeN2pLqkN6JZf63otFpRAknGshGAHQG4Z5j/SH1WDIj3yhp+Erj1017YbOKN6Mudf63Cow+RT6NgGwEIClNL8nYSkiIQuPVpdDkn1g4nU7sWrnN416853+rwCSlyaccyEYAUk2pfhU8kmIhpE0I2HK4/eSw2SNICeFO8b7TOP7drx734jL/fZBiEn7QSayRjQCkZfv3qBtWx87HS6G0MLzXPwBziONVwj/fLloHe3OLoGdjkf+BSMv23rwUr8hGAIyFIo+vfeR1KErv68mqU+WCCy3hn9M/HcfODzZLG0mE+R8oWNHLqoTIRgAMRnG6VeGqvJD3qs9UoPp0RVjhEy5aGm1Y+chitDS2b/0Oq2fm9/dw818YDABDhnRHqouNfAQg0/eZeqHu6w5X5f2PP9vDt9vs2P/lnrDCJwDeyePTpz/E0W0HPe6HsrTX8Umx3IL7e8tX+UvJpDkA0UnNSvGZC+Hs6xaTjuF/t/wb2GkyMGR4nseXL3+Kr/75n5DeC57/0tIxfoZlkJJFAiA6aq0a6bnpooYpxbLS2Z9P4pe1P4oerlzgnQ7wtgY4LWXgak7CUXEIjrJ94Fv8u8niHBw+feoDfLxwOZyc/62/oqdVgvxPz0mT1WGnskkpwzDI7mpCbVmtaK16oG59uHHwPI///PlD9J00EElp8hkL+oXnwTsawdss4Fss4G0N4FsscDbXgbfVw9lUB7TUuyq9rQFwNIN3OsGAB+9sNYrhYRj/Z6i03sO4ypNl+PDBt7Bv/e4LR7cH/ttHkjcdkSL/s7vn+PRhEK/IRgDAAHk98nD8+xNRiMr3HnOhhaLk4Fl8/ORy3PLavWDY+CwMvNMBvrkevK0OfHM9nLY6wNYAZ5MZziYzeFs9+OZaOG0WMDx3wSjHCQh0ze419lZ5bo81l1Tjm9fX4ps313ucDRjrIZ2/OITmf97FudKPO0REPgIAIL9X6E42fGYcg5B3jwjJfPe4try9Abk9CzDpoetjWiCc1ko460vA1ZfCaSkH31QDvqkGzqZa8Jwd4Dm4ml7/fxChfyqeB/w2fqp270h1ZWY8O/QR1JWbJXfvE+38z+8tL0cwshKAon5FHtdCVNnn7x6HzErTpeQcHFY/vhSsisX4+68JuyfAt1jBN5nBN5vBWavgtFaBt9WBTc6C9pJpYBh/0zg8bAc+hu3Yl4DzQiX39RTPi9Zl9R8M49ED4Oyca5kvwsofj/lf1Lco+INxhKwEoPOATmAYpu2EIDEyLtD20khDd9jsWPnIYpQfLcWM528V6CjEVXEdlYfhbKwGb28EwzsvjKfdSi6rhqbT5WBS/XjO5XnYS/cAzsDeaaIxXmVUarjPN4t1wpO0+S9MGDqWk84DOkWcpmgim1UAwLXFMtJdVsINO8SBc3D4+rXP8fzI/8FPn3wX9IBQnufhqDgEruYE+OZagGuBk7PDq7l0OuCoPBogIM71vlf4YXxEhPCMGnBzjc47Aw03pHWwIXxDj7AS4P5UVqcspJr8b1mPR2QlAGCA7sO6C3rUX0bHwr0UDx4lB85g0U0v4LnL/oCv/vVflB8r9dkSMm3/cbvnp5V2lPwAf1/KNVSAt3t7p43FBDWj0gBuQxWec/pd7ovEH587/vNfOroP6xa3k77+kNUQgGEYXHRZd+z+dLfHfV/dtXCyIdLxoL/3W+85OSfO/HwCZ/aewJonliGzkwkFfTvj6sduxEUjerenXGAz5ag8Akfxj1AXXeaZDqcDLb9+Gnr6A03iCXrf93wCo9EDTLtHJ87BtQmAGGNw8fI/MoEQ2jjFE7ISAADoeUUPr3tSrwu7E6jACk4HD9ibW1B+rBTlx0ox4Koh7QLAMAAr8DAR3ommn96FtqEU6vxBYNR6OC3laDn2JRwVh4SF4Z5+AckPNGno977G4DEJaLM2w9Hi2i0p5Tg+9HCCEyj/e43qKUo6oonsBKDTgE5ITk9GY53w04L9ZVo4rY8UQwhLh5NkGK33ONJf68Q7bLAd+g9sv651jbOdDq+Bvr9KG84KQDiThmxqnscQoLa0JuA8gNhEI/+T05PRqb+8JgABuc0BAFBr1D57AYGIrMWWvqCWHy/1uNYUDPJ6JmhKeQ7g7D5n+UJtsT2CFeHz1Tl9PK5LDp4JHq+If/dI8l9oKnpd2dOn49p4R3YCAAD9JvaLYmzST+oc23EI9uZ2AyJN55HdcForAAAWfUlEQVTQ958NNiU3NrN2bgSKXog4qHP7QV04zO0dHoc37w8eb5xspwucivY/QHTLpHjIbggAAP2n9PfYzSXmZg4xEZquiuNl2L1mO0bMG+e6waqg7TkV2ovGu7bmNpShasc7aKo41f4S096Ca3VapKSlwb248jyPenMNWvxYJjJobWVb/5De6WRVLNKNRqg1ntt4bc1NaKit97mKkV5wEdIH3ghoDWCSsqDK6Owx/i89dA7Ht//q9V5E9hcxy39XnAzDuMqkDJGlAJi6ZKFT3yKcO1AMIH5ai44IPk7K6cTqx5ai06XdUNS/a/sPKi3YlFywKbngMy6G5fg+r3G7PkmHdKMRHSswwzBITklFk7UctjC8FLEqFlk5Jo/K3yoTWp0earUV9T5EIKvrGGi6j/MZJtfiwCd/fB/NFh/Lk0L/Vj5n/GOb/0X9CmHqnBXTNISLLIcADMNg0HXe42QhhDKyjOYJL7Xna/DPq5/Bns++93kaji6rCwDPcbsuSQdTXh5UapeOcw4HWmztnnQ0Wi2ycnOhdfNTL2QXHssyyMzOQpKh3a7dyXFtfX6GYZCelYXUjDSvIYLe1NVnmC1NLfjof97F3s93BY0/EFIfDBvOs0OmDQk3OTFHlgIAAEOnDw1rfOxzJt1PRgcrbKEKRLDna4qrsOimv+OFcQuxdfFGD7VSaT1Ni/VJOmR3qPxV5WWoPH8eLbZ2X/oarRamvDxotC4R8Lca0ArLMsjKyUZySmrbs66wy1F5vgzOC+LEMAwyMjORlpHelg0sy0Kd1m4Mwzt51JbWYNfKrXhx7JP4+rXPozr774tQThMSkv8Mw2DIDfIVAFkOAQCgsE8BivoUovhgsfePIc4PiO0mLJLnOTuHo1sP4vyvxRg2exSSUl0VX5vh2vPPMIBOr0dWXk5b5Xc6naiuqEDzBT96VefLkZWXA50+CTzPQ6PVIjs/D1VlZT7nBForukrFwpidheTU9mVIJ8ehurwcTY0uUakqK4cpLxcsy4JhWaRnubq+9bX1UGm0YPXtHnErTpTib6MeR0Ol7/kCyYhi/hf1K0Jhbz/2GDJAtj0AhmEwYo6fgzjdypqY48NoDgnsNjuazO128pp0V8uqT06CKT8ParWrRXc6naguK0dzY3urb7c7UHW+HLbm5rbK7eoJeA4H3GEvVH5DansF5jgOVWVlbZWf53k0WRtReb7coyeQnpWFdGM6dGkmMOr2U3EaKupFrfyCQ4li/g+ffbms7P87IlsBAFx/fLXIBzEGquRSTTZ1jJEHD3tzC6xmS9s9VqODMSfXNeZXudabed4Jc2UlGq2NXpXM4eBQXeYSgVY0Wh2y8/O9RIBVMcjKMcGQmta2tMdxDlSVnW+r/EB7T6G5sRFV58vb5ioYhkFaZiaMhd08ZvzNpdWCKn/Hv7n/Lrn0BEptx/xXa9UuAZAxshYAY6ERfSf2Cf5gCESyFBV+nN5p4FocaKiqb7vHqnXIKOgG9oJVHc/zqKmogqXeAn/Y7Q5UlZXD1tw+667WaJBdkA+d3tVSq1QsTLk5SE5xdfsZ5kK3v6y8bUjhi6bGRlSWtfcEAECXnuux46/mXFXwj4f33zyWs/qhxNxvYl8YC+RzBoAvZC0AADD2rjFeE1veLYr0SFFozcVuFYhVg7ngU4/nedRWV8NS3+C7hXW757A7UHm+gwioNcjOz4MhNRmmvFzoDe2++jiHw6PbH4gmayOqyyraliaZpEyP36vPSH9GgtTmw/5gGAZj7xojeTxSI3sB6D+pP7K7ZXvcE8MyLB6oLa1pv2BYsPoMAEC92YyGWlfvwOd23g73OAd3YU6gXQRUajWycvOgT052s1b0nPATQqPVCnNlFQAebLLnWnjNWWE9gEgQy3w4VLK7Z6PvxL6SxyM1shcAVs1i3D1jQ34v0lYi3BNoQonXQwAAIMmI+tpa1NXUhjyx5nBwqDxfjuYmlwh03FDEcQ5UCmz5LwTQ9s+GunpY6hu8egA15yq9X4v47y7WhGJk4Yy/ZxxUavnt/e+I7AUAAEbdOgoGo++Tg/wh5KSfQPeDtTERmwzDuwJx6hTU15jDnlXnHBxqKirAORxePQdzVRWaG5v97u/3irPD+5b6BrDJ7QLgaHH4PCw10tY5Gi7Bg903GA0YNe8KUdIRaxJCAAwZyRh9+5WihCVGxQ2FQAWuqsM5g7r0AqRmpHd8UDAsyyDNmNG2f8CdjMxMaHUav3urglkOJqekeAwBGirrYAswidiKGD0lMRGS/6PvuBLJMjr/LxAJIQAAMOn+idCn6P3+HqsCFYxABa6uzOxx2jBjyEJ6ZibSM43uDwqCZRlk5piQktYuIO6tulrj2jHob59AIJIMSUjLKQKjaa8UdWVm2JuCC0C0BFes/Nen6DHp/omihBUPJIwAZBRk4Mr5oy541PLla09+U4E2azPqytode6oM2QDDIj3T6N0TcKNjd51lWWReWOdvheM4VJeXwdbUPjEYbLOQL3R6PUx5eWCTjOBZtz0AxVXg7IEdoEqFlPk/+vYrkZGfIUpY8UDCCAAATH14CpJSk6JW2YW2KuG2Pi1NLagvd/Psq9aD0aaAYRgYTVlITU/z+Z57d51VscjMzoIhpf1Z1zp/GawNjagqL0dzU7t3JY1W52E7EAitTovsgjywLAvWYALj5sqs6lT78EVcr77Bw5Iq/5PSkjD14SmShB0rEkoAjAVGTLhvfNjvh1pQhRqWhL25iHOi+mx7RWJUGrBJru4/wzDIzDYhxY8IAK5uv9GUCUNaWttQgeM4VLkt9TnsHKrLKmBramrrObTaDgQSAVflz2/blcgaPJdiy4+VtKdbxArZMSwxB3YB858BJv52fEK1/kCCCQAATHloCjIKAmdSuNZfQhCrsLemsepUuVvgKjg1qe277y6IgK/hgErFeo35uQs7/Jqsnvb4DgeHqrJyLyvC7HzfwwGtToucgnyo3SYTWUOOxzPlx84L/1gfSHl+Qzj5bywwYvKDk8OILb5JOAEwGJMx/akbAs5ax9N8QLDC2HEloEWVhtqqqvbTkVqHA24ioFKzyMzuMOZ3OFBdVoamRm9nHMAFETjvYzjQwZ9AW8vvVvmtDfVgkk3t38TzqDguTACkFGN/hGzFyTCY/tQNIS81y4GEEwAAGDl3BLoO6Sr4+XA39YhBsMJYdrTE41qdlgdLvQXmygoPizyjKevCEh8LoykLSSntzjw4ziFoh5/DwaG6vBI2dxHQ6ZCVmwudXgtdkt6r5bfU18FcVQMmJbf9XlU9rGZPT8f+iPbyajh0HdIVI+b6sTyVOQkpACqNCjc9PxNqrTBLwXA39bgjlUhUHCv1cKKhNRaB53k01Flgrqz0MMYxmrKQU5APQ2pauzMPztWyC93h57A7UFVe4SEC2gsikJ2f59ny19fBXFkNVpsEVtsuODXFVbBZgy8BhoPwjVr+NjSEFp9aq8bsv85KiF1/vkhIAQCAXqN6YdRtvndrSVFVxWjJfBXuxlor6srMbdcaY+e2XXjWBivMlZXgnU43B6HteyFau/3uJsFCcNi5CyLguUTYOuEHAJa6OlRXVsPp5KFJLwSraY+3/GgpOLvvQ0kjFUoxDmUJhStvG4WeV8jvwA+hJKwAAMCNf54BUxeT1/1IqqrYbsDc8VWIbdZm1Jxt3xLMqnVQ61wbbnieh6XegprKSq+1f57nUV1egaYA23sD4bBzqCwr85gYBFz1x9pQD3NVdVvPRG0wepxmVLz/tNvzAlvmOMTUJQvT/3xDrJMhKQktAIZMA2b/7SawKvE+M9onCTk5J0oOnW27ZrVJ0Bo7t1+rWJdFn49JT7VWG1HcKpW6zfNQKwxcm3/clwj1pm4ez5QePOv2vHwqvDusisWcv89BSmZK8IdlTEILAAAMvn4QRt4yUvDz0dwyLDSuc3vdzwNQQZ3iMrph2dbZ/nYffu6rA5mmLKSmpwd2nuqj5wC4uvw5hQVgVd5jX7XG09uwPucij/BKDp0T9F1SWAZGmnutYY68ZSQGh+l5Wk4kvAAwDIPZf52FvJ55AIIXumi2WEIt0s7tO+VxbSjsC7Vahaxcz8pvt9tRV1PjsU/AmJ2FlDRvgWhPhPd5AhqtFrmF+W6ux3g01Jq95gSy8/ORakxHctGAtvt15bWoO9/BjNkPkVtk+vIFEBgh+Z/fKx9z/naTfB1JhEDCCwDgMt+8/d/zoU3SxtTIRPjmFs80nj9cjBa3WfX0nqOQXVjY5sYLABx2OypKzqPeXIuaigq3swVc/v5atw0Hs+rTtlb+Dkt9tdVmr23Dao0Gph7DoElt3wVYcvAsbFbfk47hfn+w+4HoGGOwMLRJWsx//baEsfYLhiIEAAB6juyB65+8LqzTbQMhpp95f1iqG3Bm78m2a42xMww9J7RNvNmam1FeXAqH3Q6eBxotjaiuKL+wOuCK2ZhtQnpmRsDv1ycnIbeowKvym6tq4HTyrm3DbkuEjEoL3cWTAKZ9mHB06wGPpUkxvl8IYjgSZVgG0xZej54jQzt8Vs7I9lyAcJjy+8k4s/cMfvxkt8/ffZ+QF/rZc+G2VP7ecjo47F69HT2uuORCBCySBt8GbfdxcFoqwJWfQFZnC5ycA7zD7kotA7Dp6dDq9G1h6wAYm5vQaLGA53k47c1gVFowLAtdUjL0BkObQDAAHPYWsOZqZBa6lhlbXX6rklOQ3Kkv2LQCsCl5bel0tNixe813on+/EMQQlyHTBmPyQ5MiDkdOMLy1LD4N5SXCWmPFC1NfRPHBkuAPxxEGYwoWfvcS8nsXxTopftm2eCOW3vt6zE//CYeivkV4bP0CpGQl9qx/RxQzBGjFkGnA3Yt/g1RTavCHQ0DKIs+Dh9VswVtzX/KyDYgLeGD/hp/w0WPvSVL5pV6ZSTWl4u4lv1Fc5QcU2ANoZd/G/Vh0y5uC3FZJRTjHWmcUZGLig9dh8IwRyMjPhDZZJ+o+B6E4WhxosTaj4kQZti3ZiO3LNsHeFNopxLE81r1tWGTQ4bfv34cBMj3eO1IUKwAAsOW9rfjg4Q/BOQJ7rollQfUHq2KRUZgFQ2YKktKSoUvWgdWooVKroNaqXaLAMADPX7CJcKW/9Vvc/w/A456jxd72LhjXISW803VaUUtzC+xNLWiqb0RDRS3qK+uic/CCHyLJG5VGhVtemYuxd8rfv3+4KFoAAODTZz/DF/9YByfne+Y6HHwXSmHTXGKIja8woilicvh+hmVw3WPXYtpT14u+MiQnFDcH0JFpC6/HhPvGg2FDKwShnCHXelcIUjklYcD4TUI4Y+zQz1CMg+9v/TfLYOJvJ+D6heIvC8sNxQsAq2Zx019nudyKh1AWZFls/NTZcCpdvA2JBMMAV86/ErOemxmTuZN4g/4CAFRqFW55eS6umDtSFi2CosdsiOD7GWDkzSMw7+W5gn1FJDokABdQa9W47bVbMeau0T6NZ4J2kwWbo/sPR2jBjlSign2Lr1+jcySXdH4AGZbB2DvGYP7rt0Gto8rfCgmAGxqdBre8PBeT7p/g1T0M2uUVWD8ChePvF7HXwYN9i+8RvLBqF5mxVWjGQUJhVSwm3jcBt7wyF5owDj5JZBS/CuALJ+fEf57/L9a9vD7oEiER36g0Klz9h6tw/ZPXJaxbr0ggAfAH79onsPLxlbA1+t/gEumyVSTvx8P+hHj+fl2yFrNfmI2xd4yR6ayt9JAABGHfl/ux5N530VApzMttR6JdSeNNUGL1/anZqfjN23eh/+R+UYtbjpAACKDkYAnevvMdnDtQHOukREQ89BikhmEYFPQpwD3v3o1O/eLXcCpeIAEQiKXGgg8e+RA/frzb26vOBSI1aSUig2EYDJ0+BLf+c54iDXvCgQQgBJwOJ9b/cwM+//tatIRo+BKMjuIRre28QkQrFj2HUL9fm6TFdU9ci6m/nwKVhib7hEICEAbHdx7Hew8sw/kjoZ1/J1UPIaZdewaCl0ClSCfDMMi9OBe3vzFfUZ58xIIEIEystVas/uMa7Pjgu7CXCuNtTB5KesQQs0i/n1WzGHnzSMz+26yEPLcvGpAARADP89jz3z1Y+cQqVJ+tdt2Ls0odbaL1/aYuJsz5+00YdO2gkA25iHZIAESgvrIBn/3vZ9j+/g44WryPxIq0tRSzUoUbViwnON3TrNaqceX8UZjx9HQYMqnVjxQSABE5sv0IVi1cjVN7TkfNYidYhZa6RY5aj4cBug3phpuen4VeoxL3rL5oQwIgMlwLh63LtmHtS1/AXGom070IYRgGGfkZuOFP0zBiznCy4hMZEgCJsJqt2Pj6V/jmzW9grWtqO4IrnuYIYtGtD+X7k9OTMeG34zH5wUkwZFB3XwpIACSm9nwtNr7+Fba8uxVN9U1Bn491lz5gHCEs+QUMJwhJqXqMmj8KUx6agsxCY8jvE8IhAYgStedrsXnxFmxesgX1lfWxTk7IREN4DEYDRt9+JSY9MBEZ+RmSxkW4IAGIMk31TfhuxU58/cYmVJyo8LutWCxi7ww0MAzDILt7NsbfPQ6jbr1CMWfyxQskADGCs3M49O0hbH53K/Zv3A+HzXv5MBhSedCNBmqtGv0m9cPo269Ev0l9odbQ5F4sIAGIA+rK6rBz5ff4Yc0POPPL2bg4WkuKCUKGYVDUrwgj5gzH5bMug5HG9zGHBCDOKDlUgj2f/4zdn/2EkgMlcDqdIm8Eiu7MP8My6NSvCIOuHYShM4aisHcBmUzGESQAcUxNcQ32bdiPA5sO4vDWw2isbYx1kgSRnJGM3qN7od+Efug7sS9MXbJk4W1ZiZAAyAQn50TxgWIc3noEx3edwKndp1B9Tlz7g3DDyeqUhe7DuuGiy7qjx8ge6HJpF7Bq8jcrB0gAZIyl2oKz+86i5NdSlBwqRdnRMlScrEBdWZ3oqwsMyyA9Nx3Z3bKRe1EOCnoXoKhfEToP6ITU7DRfntQJGUACkKDUltUhIy+97fqrf3+NSQ9MbLt+6453cO97d7ddv3vve7jzrTvarnet/gGXz7qs7drR4qBtuAkICQBBKBgaqBGEgiEBIAgFQwJAEAqGBIAgFAwJAEEoGBIAglAwJAAEoWBIAAhCwZAAEISCIQEgCAVDAkAQCoYEgCAUDAkAQSgYEgCCUDAkAAShYEgACELBkAAQhIIhASAIBUMCQBAKhgSAIBQMCQBBKBgSAIJQMCQABKFgSAAIQsGQABCEgiEBIAgFQwJAEAqGBIAgFAwJAEEoGBIAglAwJAAEoWBIAAhCwZAAEISCIQEgCAVDAkAQCoYEgCAUDAkAQSgYEgCCUDAkAAShYEgACELBkAAQhIIhASAIBUMCQBAKhgSAIBQMCQBBKBgSAIJQMCQABKFgSAAIQsGQABCEgiEBIAgFQwJAEAqGBIAgFAwJAEEoGBIAglAwJAAEoWBIAAhCwZAAEISCIQEgCAVDAkAQCoYEgCAUDAkAQSgYEgCCUDAkAAShYEgACELBkAAQhIIhASAIBUMCQBAKhgSAIBQMCQBBKBgSAIJQMCQABKFgSAAIQsGQABCEgiEBIAgFQwJAEAqGBIAgFAwJAEEoGBIAglAwJAAEoWBIAAhCwZAAEISCIQEgCAVDAkAQCoYEgCAUDAkAQSgYEgCCUDAkAAShYEgACELBkAAQhIIhASAIBUMCQBAKhgSAIBQMCQBBKJj/D1Q4+Fj4x4HOAAAAAElFTkSuQmCC";




class $5a483ffa6a439849$export$30b02a9f27f41c16 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(_hostElement, insertPosition = "afterbegin", showShelf = false, _shelfItems = [], _shelfSortOrderDescending = true){
        super(_hostElement, "vanilla-reader__dialog-file", "", insertPosition);
        this._shelfItems = _shelfItems;
        this._shelfSortOrderDescending = _shelfSortOrderDescending;
        this._isOffline = false;
        this._bodyStyle = `        
        <style>                    
            #vanilla-reader__dialog-file h2 {
                margin-top: 0.5em;
                margin-bottom: 1.5em;
                color: var(--vanilla-reader__color__ui__foreground-dark);      
            }

            #vanilla-reader__dialog-file h3 {
                margin-top: 1.2em;
                margin-bottom: 1.2em;
                color: var(--vanilla-reader__color__ui__foreground-dark);      
            }

            #vanilla-reader__dialog-file h4 {
                color: var(--vanilla-reader__color__ui__foreground-dark);                
            }

            #vanilla-reader__dialog-file__header {
                text-align: center;
                margin-top: 24px;
                margin-bottom: 72px;
                color: var(--vanilla-reader__color__ui__foreground-dark);
            }
            
            #vanilla-reader__dialog-file__header__logo {
                font-size: 36px;
                display: block;               
            }
            
            #icon {
                display: inline;
                width: 64px;
                height: 64px;
                position: relative;
                top: 16px;
            }
            
            #vanilla-reader__dialog-file__header__logo span {
                display: inline-block;                       
                border: 2px solid #ffb55a;
                border-radius: 50%;
                background-color: #fff5db;
                padding: 0.2em;
                width: 48px;
                height: 48px;
             }
             
            #vanilla-reader__dialog-file__header__tagline {                
                margin-top: 16px;
                font-size: 1em;                                
            }            
            
            #vanilla-reader__dialog-file__header__tagline a {
                color: var(--vanilla-reader__color__ui__foreground-dark);
            } 
            
            #vanilla-reader__dialog-file[role=dialog] {  
                padding: 0!important;
                top: 0!important;
                bottom: 0!important;
                right: 0!important;
                left: 0!important;
                height: 100%!important;
                width: 100%!important;
                max-width: initial!important;
                border-radius: 0!important;
                border: 0!important;
            }
            
            #vanilla-reader__dialog-file .vanilla-reader-ui__dialog__header {
                display: none !important;
            }
            
            #vanilla-reader__dialog-file .vanilla-reader-ui__dialog__body {
                flex-grow: 2;
                margin: 16px;
                margin-top: 0;
                margin-bottom: 0;
                overflow: hidden;
                overflow-y: auto;
            }
            
            @media only screen and (max-device-width: 480px) {         
                #vanilla-reader__dialog-file .vanilla-reader-ui__dialog__body {
                    margin: 8px;
                }
                
                .vanilla-reader__card {
                   padding: 8px;
                   box-shadow: none;             
                }
                
                .vanilla-reader__dialog-file__book-data {
                    word-break: break-word;
                }
                
                .vanilla-reader__dialog-file__form__shelf-list__item {                
                    box-shadow: rgb(0 0 0 / 19%) 1px 1px 4px;
                    background-color: rgba(256,256,256,0.2);
                }
            }
        
            #vanilla-reader__dialog-file .vanilla-reader-ui__dialog__header__close-button {
                display: none;
            }

            #vanilla-reader__dialog-file + .vanilla-reader__modal-overlay {
                pointer-events: none;
            }
            
            #vanilla-reader__dialog-file__form {
                max-width: 600px;
                margin-left: auto;
                margin-right: auto;
            }
                              
            #vanilla-reader__dialog-file__form h3 {
                margin-top: 2em;
                margin-bottom: 2em;                
            }
            
            #vanilla-reader__dialog-file__file-input {
                border: 0;
                max-width: 100%;
            }
            
            #vanilla-reader__dialog-file__form__file-list {                                
                max-width: 600px;
                margin-left: auto;
                margin-right: auto;
            }

            .vanilla-reader__dialog-file__form__file-list__item {
                list-style: none;   
            }
                        
                        
            .vanilla-reader__dialog-file__form__file-list__item .vanilla-reader__dialog-file__book-title {
                font-weight: normal;   
            }
            
            #vanilla-reader__dialog-file__form__shelf-list {                                
                max-width: 600px;
                margin-left: auto;
                margin-right: auto;
                list-style: none;
            }
            
                        
            .vanilla-reader__dialog-file__form__shelf-list__item {      
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                align-content: space-between;
                min-height: 48px;
                border-radius: 8px;
                padding: 8px;
                box-shadow: rgb(0 0 0 / 20%) 0 0 4px;
                background-color: rgba(256, 256, 256, 0.1);
            }

            .vanilla-reader__dialog-file__form__shelf-list__item a {    
                display: flex;                
                padding: 8px;
                flex-grow: 2;
                align-items: flex-start;
            }
            
            #vanilla-reader__dialog-file__form__shelf-list .vanilla-reader__dialog-file__form__shelf-list__item .vanilla-reader__dialog-file__book-title {
                display: inline-block;
                margin: 0;                                
                pointer-events: none;
            }
                        
            .vanilla-reader__dialog-file__form__shelf-list__item a img {    
                display: inline-block;                
                width: 96px;
                height: auto;                
                pointer-events: none;
                box-shadow: #0000001f 2px 2px 3px 1px;
                border-radius: 4px;
            }
                        
            .vanilla-reader__dialog-file__form__shelf-list__item__button-remove {
                align-self: flex-start;  
                background-color: rgba(256, 256, 256, 0.1);                
            }
            
            .vanilla-reader__dialog-file__form__shelf-list__notice {
                font-size: small;
                margin-top: -1.5em;
            }
            
            #vanilla-reader__dialog-file .vanilla-reader-ui__dialog__footer {
                text-align: center;
                font-size: small;
                margin-top: 2em;
                margin-bottom: 2em;
            }

            #vanilla-reader__dialog-file .vanilla-reader-ui__dialog__footer a {
                color: var(--vanilla-reader__color__ui__foreground-dark);
            }      
            
            .vanilla-reader__dialog-file__book-title {
                pointer-events: none;
                font-size: 16px;
                font-weight: bold;                
            }
            
            .vanilla-reader__dialog-file__book-data {
                flex-direction: column;
                margin-left: 16px;
                pointer-events: none;
            }
            
            .vanilla-reader__dialog-file__book-a11y-info {
                pointer-events: auto;                        
            }

            .vanilla-reader__dialog-file__book-a11y-info summary {
                text-decoration: underline;
            }

            .vanilla-reader__dialog-file__book-a11y-info summary::marker {
                content: none;
            }

            .vanilla-reader__dialog-file__book-a11y-info h4 {
                opacity: 0.8;
            }
            
            .ltr {
                direction: ltr;
                display: inline-block;                
            }

            .rtl {
                direction: rtl;
                display: inline-block;                
            }
            
            .bidi-override {             
                unicode-bidi: bidi-override;                
            }
                        
        </style>`;
        this._bodyTemplate = `
        <div id="vanilla-reader__dialog-file__header" aria-hidden="true">
            <h1 id="vanilla-reader__dialog-file__header__logo">Vanilla <img id="icon" aria-hidden="true" src="https://demo.colibrio.com/assets/icons/vr-icon.svg"> Reader</h1>
            <p id="vanilla-reader__dialog-file__header__tagline">A vanilla demo implementation of the<br>
                <a href="https://colibrio.com" aria-hidden="true" title="Open the Colibrio Reader Framework homepage in a new window" target="_blank">
                        Colibrio Reader Framework
                </a>
            </p>        
        </div>
        <form id="vanilla-reader__dialog-file__form" class="vanilla-reader__card">
            <h2>Choose a file from your device</h2>
            <input type="file" id="vanilla-reader__dialog-file__file-input" value="Choose a book file" aria-label="Choose a book file">
        </form>

        <ul id="vanilla-reader__dialog-file__form__shelf-list" class="vanilla-reader__card">
            <h2 aria-label="Bookshelf. Use Enter or Shift + Enter to open selected book.">Bookshelf</h2>            
        </ul>

        <ul id="vanilla-reader__dialog-file__form__file-list" class="vanilla-reader__card">
            <h2>Open an online example book</h2>
            <h3>EPUB books</h3>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/catalog.colibrio.com/Accessible_EPUB_3.epub"><h4 class="vanilla-reader__dialog-file__book-title">Accessible EPUB3</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/catalog.colibrio.com/NNELS_Accessible_Publishing_Best_Practices_June_2019.epub"><h4 class="vanilla-reader__dialog-file__book-title">NNELS Accessible Publishing Best Practices</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/open.catalog.colibrio.com/Opening-Eyes-onto-Inclusion-and-Diversity.epub"><h4 class="vanilla-reader__dialog-file__book-title">Opening Eyes onto Inclusion and Diversity</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/open.catalog.colibrio.com/Technical-Writing-Essentials.epub"><h4 class="vanilla-reader__dialog-file__book-title">Technical Writing Essentials</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/open.catalog.colibrio.com/Physical-Geology-2nd-Edition.epub"><h4 class="vanilla-reader__dialog-file__book-title">Physical Geology 2nd Edition</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/catalog.colibrio.com/design-with-fontforge_en-US.epub"><h4 class="vanilla-reader__dialog-file__book-title">Design with FontForge</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/catalog.colibrio.com/Jules-Verne-20000-Leagues-Under-the-Sea.epub"><h4 class="vanilla-reader__dialog-file__book-title">20000 Leagues Under the Sea</h4></a></li>
            <h4>Interactive</h4>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/catalog.colibrio.com/FF001-Overdrive_UK_v1.1_sample.epub"><h5 class="vanilla-reader__dialog-file__book-title">FactFactory - Issue 1</h5></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/catalog.colibrio.com/CircularFLO_v5_1_promo.epub"><h5 class="vanilla-reader__dialog-file__book-title">CircularFLO</h5></a></li>
            <h4>Narrated</h4>                
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/catalog.colibrio.com/The+Jungle+Book-MO.epub"><h5 class="vanilla-reader__dialog-file__book-title">The Jungle Book</h5></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/catalog.colibrio.com/FF001-Overdrive_UK_v1.1_sample.epub"><h5 class="vanilla-reader__dialog-file__book-title">FactFactory - Issue 1</h5></a></li>
            <h3>Audiobooks</h3>       
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/open.catalog.colibrio.com/Princess+of+Mars/princess_mars_tc_librivox.lpf"><h4 class="vanilla-reader__dialog-file__book-title">Princess of Mars</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/open.catalog.colibrio.com/War+of+the+Worlds/war_worlds_solo_librivox_64kb_mp3.lpf"><h4 class="vanilla-reader__dialog-file__book-title">War of the Worlds</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/open.catalog.colibrio.com/Frankenstein/frankenstein_1107_librivox.lpf"><h4 class="vanilla-reader__dialog-file__book-title">Frankenstein</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/open.catalog.colibrio.com/The+Leavenworth+Case/theleavenworthcaseversion2_1604_librivox.lpf"><h4 class="vanilla-reader__dialog-file__book-title">The Leavenworth Case</h4></a></li>
            <li class="vanilla-reader__dialog-file__form__file-list__item"><a tabindex="0" data-href="https://s3.eu-north-1.amazonaws.com/open.catalog.colibrio.com/Dracula/dracula_v4_1903_librivox.lpf"><h4 class="vanilla-reader__dialog-file__book-title">Dracula</h4></a></li>
        </ul>`;
        this._event_listItemClick = (ev)=>{
            if (this._listItemSelectedCallback) {
                let url = ev.target.getAttribute("data-href");
                if (url) this._listItemSelectedCallback(url);
                else console.warn(`List item ${ev.target} has no data-href attribute.`);
            }
        };
        this._event_shelfListItemClick = (ev)=>{
            if (this._shelfListItemClickedCallback) {
                let fileName = ev.target.getAttribute("data-filename");
                if (fileName) {
                    let itemData = this._getShelfItemByFileName(fileName);
                    if (itemData) this._shelfListItemClickedCallback(itemData);
                    else console.warn(`List item ${ev.target} has no related shelfItem data.`);
                } else console.warn(`List item ${ev.target} has no data-filename attribute.`);
            }
        };
        this._event_listItemDeleteCacheClick = (ev)=>{
            if (this._listItemDeleteCacheCallback) {
                let key = ev.target.getAttribute("data-cachekey");
                if (key) {
                    let shelfItemToDelete = this._getShelfItemByFileName(key);
                    if (shelfItemToDelete) this._listItemDeleteCacheCallback(shelfItemToDelete);
                    else console.warn(`List item ${ev.target} has no related shelfItem data.`);
                } else console.warn(`List item ${ev.target} has no data-cachekey attribute.`);
            }
        };
        this._event_change = (ev)=>{
            const filelist = ev.target.files;
            if (filelist && this._fileSelectedCallback) {
                let file = filelist[0];
                if (file) this._fileSelectedCallback(file);
            }
        };
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._dialogElement.insertAdjacentHTML("afterbegin", this._bodyStyle);
        this._inputFile = this._dialogElement.querySelector("#vanilla-reader__dialog-file__file-input");
        this._shelfList = this._dialogElement.querySelector("#vanilla-reader__dialog-file__form__shelf-list");
        this._dialogFooterElement.innerHTML = `
                Powered by the 
                <a href="https://colibrio.com" title="Open the Colibrio Reader Framework homepage in a new window" target="_blank">
                    Colibrio Reader Framework
                </a>`;
        this._inputFile.addEventListener("change", (ev)=>{
            this._event_change(ev);
        });
        let listItems = this._dialogElement.querySelectorAll(".vanilla-reader__dialog-file__form__file-list__item a");
        listItems.forEach((item)=>{
            item.addEventListener("click", this._event_listItemClick);
            item.addEventListener("keyup", (ev)=>{
                if (ev.key === "Enter" || ev.key === "Space") this._event_listItemClick(ev);
            });
        });
        if (showShelf) {
            this.sortShelfItemsOnReadingDate(this._shelfSortOrderDescending);
            this._renderShelfItems().catch(console.warn);
        } else this._shelfList.style.display = "none";
    }
    onFileSelected(callback) {
        this._fileSelectedCallback = callback;
    }
    onFileListItemClicked(callback) {
        this._listItemSelectedCallback = callback;
    }
    onShelfListItemClicked(callback) {
        this._shelfListItemClickedCallback = callback;
    }
    onFileListItemDeletePublicationResourcesButtonClicked(callback) {
        this._listItemDeleteCacheCallback = callback;
    }
    onBookshelfItemsRendered(callback) {
        this._bookshelfItemsRenderedCallback = callback;
    }
    get isOffline() {
        return this._isOffline;
    }
    set isOffline(value) {
        this._isOffline = value;
    }
    close(silent = false, returnDialogResult = true) {
        super.close(silent, returnDialogResult);
        // We'll empty the list to free up resources that will not be used again until the page restarts.
        this._emptyShelf();
    }
    sortShelfItemsOnReadingDate(descending = true) {
        this._shelfItems.sort((a, b)=>{
            let aTimestamp = a.readingPositionData?.timestamp || 0;
            let bTimestamp = b.readingPositionData?.timestamp || 0;
            if (aTimestamp > bTimestamp) return -1;
            else if (aTimestamp < bTimestamp) return 1;
            else return 0;
        });
        if (!descending) this._shelfItems.reverse();
    }
    async updateShelfItems(items) {
        //let startTime = Date.now();
        this._shelfItems = items;
        this.sortShelfItemsOnReadingDate(this._shelfSortOrderDescending);
        this._emptyShelf();
        await this._renderShelfItems();
    //console.log('updateShelfItems', Date.now() - startTime);
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _emptyShelf() {
        if (this._shelfList.childElementCount > 0) {
            let listItems = this._shelfList.querySelectorAll("li");
            listItems.forEach((item)=>{
                this._shelfList.removeChild(item);
            });
        }
    }
    async _renderShelfItems() {
        //let startTime = Date.now();
        for (const item of this._shelfItems){
            let authorMetadata = item.metadata?.all.find((metadataItem)=>{
                return metadataItem.property.name === "creator";
            });
            let authorWritingDirClass = authorMetadata?.content.dir ? (0, $91ca8664a4c236f4$export$63e1cbbb2c6e2c2).RTL ? "rtl" : "ltr" : "ltr";
            let titleString;
            let titleWritingDirClass;
            let titleLang;
            let titleIndex = item.metadata?.titleIndexes[0];
            if (titleIndex !== undefined) {
                let titleMetadata = item.metadata?.all[titleIndex].content;
                titleString = item.metadata?.all[titleIndex].content.value || item.fileName;
                titleWritingDirClass = titleMetadata?.dir ? (0, $91ca8664a4c236f4$export$63e1cbbb2c6e2c2).RTL ? "rtl" : "ltr" : "ltr";
                titleLang = titleMetadata?.lang ? titleMetadata.lang : "en";
            } else {
                titleString = item.fileName;
                titleLang = "en";
                titleWritingDirClass = "en";
            }
            let accessibilitySummaryMetadata = item.metadata?.all.find((metadataItem)=>{
                return metadataItem.property.name === "accessibilitySummary";
            });
            let listItem = document.createElement("li");
            let label = `Remove ${item.title} from device" data-cachekey="${item.fileName}`;
            listItem.className = "vanilla-reader__dialog-file__form__shelf-list__item";
            listItem.innerHTML = `
               <a tabindex="0" data-href="${item.fileSourceUri}" 
                    data-hasofflinedata="${await item.hasOfflineData()}" 
                    data-filename="${item.fileName}">
                    <img src="data:;base64,${item.coverImageAsBase64 || (0, $105b063428bdec84$export$ad5942a74c9bd4ba)}">
                    <div class="vanilla-reader__dialog-file__book-data">                    
                        <h3  class="vanilla-reader__dialog-file__book-title ${titleWritingDirClass}"  
                        ${titleString ? 'lang="' + titleLang + '"' : ""}                       
                        title="Book title">${titleString.slice(0, 150)}</h3>
                        <p class="vanilla-reader__dialog-file__book-author">
                            by <span class="${authorWritingDirClass} ${authorWritingDirClass === "rtl" ? "bidi-override" : ""}" 
                                ${authorMetadata?.content?.lang ? 'lang="' + authorMetadata.content.lang + '"' : ""}
                               >
                                    ${authorMetadata?.content.value || "Unknown"}
                                </span>
                        </p>
                        <details class="vanilla-reader__dialog-file__book-a11y-info">
                            <summary>Accessibility information</summary>
                            <h4>Summary</h4>
                            <p>
                                ${accessibilitySummaryMetadata?.content.value || "No information available"}
                            </p>                            
                        </details>
                    </div>
               </a> 
               <button class="vanilla-reader__dialog-file__form__shelf-list__item__button-remove" aria-label="${label}" title="${label}">delete</button>`;
            let anchorElement = listItem.querySelector("a");
            anchorElement.addEventListener("click", this._event_shelfListItemClick);
            anchorElement.addEventListener("keyup", (ev)=>{
                if (ev.key === "Enter" || ev.key === "Space") this._event_shelfListItemClick(ev);
            });
            let deleteButton = listItem.querySelector("button");
            deleteButton.addEventListener("click", this._event_listItemDeleteCacheClick);
            this._shelfList.appendChild(listItem);
        }
        if (this._bookshelfItemsRenderedCallback) this._bookshelfItemsRenderedCallback();
    //console.log('_renderShelfItems', Date.now() - startTime);
    }
    _getShelfItemByFileName(fileName) {
        return this._shelfItems.find((item)=>{
            return item.fileName === fileName;
        });
    }
}




class $32279154c2e73165$export$a39d6020a9602905 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(hostElement, insertPosition = "afterbegin"){
        super(hostElement, "vanilla-reader__dialog-search-results", "Search publication", insertPosition);
        this._activeResultItem = undefined;
        this._searchResultClickedCallback = undefined;
        this._onExecuteSearchCallback = undefined;
        this._onClearSearchCallback = undefined;
        this._bodyStyle = `
        <style>
            #vanilla-reader__dialog-search-form__input {
                width: 100%;
            }
            
            #vanilla-reader__dialog-search-results__container {
                display: none;
            }
            
            #vanilla-reader__dialog-search-results__list {                
                padding-left: 16px;
            }

            #vanilla-reader__dialog-search-results__container:focus-visible, #vanilla-reader__dialog-search-results__list:focus-visible {                
                outline:none;
            }
                        
            #vanilla-reader__dialog-search-results__list li {                
                border: 1px solid var(--vanilla-reader__color__ui__outline-light);
                border-radius: 6px;
                padding: 1em;
            }
            
            .vanilla-reader__dialog-search-form__list__item__section-title {
                /* We set pointer events to none to let the list item receive any key/pointer events */
                pointer-events: none;
                display: block;
                font-weight: bold;
                margin-bottom: 0.5em;                
            }
              
        </style>`;
        this._bodyTemplate = `
            <form id="vanilla-reader__dialog-search-form">
               <input type="search" placeholder="Enter search term" aria-label="Enter search term" id="vanilla-reader__dialog-search-form__input">               
            </form>
            <section id="vanilla-reader__dialog-search-results__container" aria-label="Search results" tabindex="-1">               
               <ol id="vanilla-reader__dialog-search-results__list" tabindex="-1">
                </ol>
            </section>`;
        /*
    *
    * EVENT HANDLERS
    *
    * */ this._event_click_keyup = (ev)=>{
            let targetElement = ev.target;
            let locator = targetElement.getAttribute("data-contentblocklocator") || ev.target.parentElement.getAttribute("data-contentblocklocator");
            if (locator && this._searchResultClickedCallback) {
                this._activeResultItem?.removeAttribute("aria-selected");
                targetElement.setAttribute("aria-selected", "true");
                this._activeResultItem = targetElement;
                this._searchResultClickedCallback({
                    navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
                    locator: locator
                });
            }
        };
        this._event_formSubmit = (ev)=>{
            ev.preventDefault();
            if (this._onExecuteSearchCallback) this._onExecuteSearchCallback(this._searchInput.value);
        };
        this._event_formMaybeClear = (_ev)=>{
            if (this._searchInput.value === "" && this._onClearSearchCallback) this.clear();
        };
        this._dialogElement.insertAdjacentHTML(insertPosition, this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._form = this._hostDocument.getElementById("vanilla-reader__dialog-search-form");
        this._searchInput = this._hostDocument.getElementById("vanilla-reader__dialog-search-form__input");
        this._resultContainer = this._hostDocument.getElementById("vanilla-reader__dialog-search-results__container");
        this._resultList = this._hostDocument.getElementById("vanilla-reader__dialog-search-results__list");
        this._form.addEventListener("submit", this._event_formSubmit);
        this._searchInput.addEventListener("input", this._event_formMaybeClear);
    }
    onSearchExecute(callback) {
        this._onExecuteSearchCallback = callback;
    }
    onSearchClear(callback) {
        this._onClearSearchCallback = callback;
    }
    onSearchResultItemClicked(callback) {
        this._searchResultClickedCallback = callback;
    }
    populate(resultSet) {
        this._empty();
        this._resultList.setAttribute("aria-setsize", resultSet.length.toString());
        resultSet.forEach((item)=>{
            let listItem = this.createItem(item);
            listItem.setAttribute("aria-posinset", (this._resultList.children.length + 1).toString());
            this._resultList.appendChild(listItem);
        });
        this._resultContainer.style.display = "block";
        window.setTimeout(()=>{
            this._searchInput.blur();
            this._resultContainer.focus();
        }, 500);
    }
    createItem(resultItem) {
        let itemLocator = resultItem.locator;
        let listItem = this._hostDocument.createElement("li");
        let listItemAnchor = this._hostDocument.createElement("a");
        listItem.setAttribute("tabindex", "-1");
        listItemAnchor.setAttribute("tabindex", "0");
        listItemAnchor.setAttribute("data-contentblocklocator", resultItem.locator);
        listItemAnchor.addEventListener("click", (ev)=>{
            this._event_click_keyup(ev);
        });
        listItem.addEventListener("keyup", (ev)=>{
            if (ev.key === "Enter" || ev.key === "Space") this._event_click_keyup(ev);
        });
        if (itemLocator) listItem.setAttribute("data-contentblocklocator", itemLocator.toString());
        listItemAnchor.insertAdjacentHTML("afterbegin", `<span class="vanilla-reader__dialog-search-form__list__item__section-title" aria-label="Book section">${resultItem.bookSection || ""}</span>`);
        listItemAnchor.insertAdjacentText("beforeend", resultItem.intersectingNodeText || "");
        listItem.appendChild(listItemAnchor);
        return listItem;
    }
    clear() {
        this._empty();
        this._resultContainer.style.display = "none";
        this._searchInput.value = "";
        this._searchInput.focus();
        if (this._onClearSearchCallback) this._onClearSearchCallback();
    }
    show(silent, returnFocusOnClose = true, onDialogCloseCallbackOverride, activeItemLocator) {
        super.show(silent, returnFocusOnClose, onDialogCloseCallbackOverride);
        if (activeItemLocator) this.focusOnItemByLocator(activeItemLocator);
        else this._searchInput.focus();
    }
    setSearchTerm(term) {
        this._searchInput.value = term;
    }
    focusOnItemByLocator(locator) {
        let resultItem = this._resultList.querySelector(`[data-contentblocklocator="${locator}"]`);
        if (resultItem) resultItem.focus();
        else console.log("VanillaReaderUiDialogSearch.focusOnItemByLocator(): Unable to find list item with locator " + locator);
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _empty() {
        if (this._resultList.childElementCount > 0) {
            let firstListItem = this._resultList.firstChild;
            while(firstListItem){
                firstListItem.remove();
                firstListItem = this._resultList.firstChild;
            }
        }
    }
}






class $dcfe4d188eb1caa2$export$99aff4b1844eb55a extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(hostElement, initialState, insertPosition = "afterbegin"){
        super(hostElement, "vanilla-reader__dialog-settings", "Settings", insertPosition);
        //private _activeScrollOverflowingTablesOption: boolean;
        this._playbackVoiceLocalOnly = false;
        this._playbackVoiceRemoteOnly = false;
        this._playbackVoiceLanguageOnly = false;
        this._playbackVoiceNoSupport = false;
        this._bodyStyle = `
        <style>
            #vanilla-reader__dialog-settings__form__mediaplayer-tts-voice__note {
                display: none;
            }   
     
            input[type=radio][name="reading-ruler-color"] {
                -webkit-appearance: none;
                margin: 0;
                width: 40px;
                height: 40px;
                display: inline-block;
                border: 0;
                border-radius: 50%;
          }
        
          input[type=radio][name="reading-ruler-color"]:checked {
            border: 2px solid var(--vanilla-reader__color__ui__outline-dark);    
          }
        
          input[type=radio][title="red"] {
            background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.red};
          }
        
          input[type=radio][title="green"] {
            background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.green};
          }
    
          input[type=radio][title="blue"] {
            background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.blue};
          }
        
          input[type=radio][title="yellow"] {
            background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.yellow};
          }
          
          input[type=radio][title="transparent"] {
            background-color: ${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.transparent};
             border: 2px dotted var(--vanilla-reader__color__ui__outline-dark);
          }
          
          fieldset {
            border: 0;
          }

          #vanilla-reader__dialog-settings__form__reset {
            font-family: sans-serif;            
            display: inline-block;
          }
                         
        </style>  
    `;
        this._bodyTemplate = `
            <form id="vanilla-reader__dialog-settings__form">
            
                <label for="vanilla-reader__dialog-settings__form__a11y-mode" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">accessibility</span> Accessibility UI mode</label>
                <span>May improve experience for users of accessibility technologies.</span>                
                <input type="checkbox" data-optionname="useAccessibilityMode" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__a11y-mode">
                
                <hr>
                
                <label for="vanilla-reader__dialog-settings__form__font-size" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">format_size</span> Font size (%)</label>                
                <select data-optionname="fontSizeScaleFactor" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__font-size">
                    <option value="1" selected="selected">100%</option>
                    <option value="1.2">120%</option>
                    <option value="1.3">130%</option>
                    <option value="1.4">140%</option>
                    <option value="1.5">150%</option>
                    <option value="1.6">160%</option>
                    <option value="1.7">170%</option>
                    <option value="1.8">180%</option>
                    <option value="1.9">190%</option>
                    <option value="2">200%</option>
                    <option value="2.2">225%</option>
                    <option value="2.5">250%</option>
                    <option value="2.7">275%</option>
                    <option value="3">300%</option>
                    <option value="3.5">350%</option>
                    <option value="4">400%</option>
                </select>

                <label for="vanilla-reader__dialog-settings__form__line-height" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">format_line_spacing</span> Line height (%)</label>
                <select data-optionname="lineHeightScaleFactor" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__line-height">
                    <option value="1" selected="selected">100%</option>
                    <option value="1.2">120%</option>
                    <option value="1.3">130%</option>
                    <option value="1.4">140%</option>
                    <option value="1.5">150%</option>
                    <option value="1.6">160%</option>
                    <option value="1.7">170%</option>
                    <option value="1.8">180%</option>
                    <option value="1.9">190%</option>
                    <option value="2">200%</option>
                    <option value="2.2">225%</option>
                    <option value="2.5">250%</option>
                </select>

                <label for="vanilla-reader__dialog-settings__form__font-set" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">title</span> Publication font</label>
                <select data-optionname="fontSet" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__font-set">
                    <option value="default" selected="selected">Publication Default</option>
                    <option value="EasyReading">EasyReading</option>
                    <option value="Ysabeau Infant">Ysabeau Infant</option>
                    <option value="sansSerif">All Sans</option>
                </select>

                <label for="vanilla-reader__dialog-settings__form__text-align" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">format_align_left</span> Text align</label>
                <select data-optionname="textAlign" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__text-align">
                    <option value="default" selected="selected">Publication Default</option>
                    <option value="left">Left</option>                    
                    <option value="justify">Justify</option>                    
                    <option value="right">Right</option>                    
                    <option value="center">Center</option>                    
                </select>
                                
                <label for="vanilla-reader__dialog-settings__form__palette" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">format_color_fill</span> Publication color
                    theme</label>
                <select data-optionname="palette" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__palette">
                    <option value="default" selected="selected">Publication Default</option>
                    <option value="Dark" data-usedarkmode>Dark</option>
                    <option value="Paperlike" >Paperlike</option>
                    <option value="ContrastDark" data-usedarkmode>Dark contrast</option>
                </select>
                
                <hr>
                
                <label for="vanilla-reader__dialog-settings__form__margin-vertical" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">margin</span> Vertical page margin
                    (%)</label>
                <select data-optionname="pageMarginHorizontal" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__margin-vertical">
                    <option value="2">2%</option>
                    <option value="6" selected="selected">6%</option>
                    <option value="8">8%</option>
                    <option value="10">10%</option>
                    <option value="12">12%</option>
                    <option value="14">14%</option>
                    <option value="16">16%</option>
                    <option value="18">18%</option>
                    <option value="20">20%</option>
                </select>

                <label for="vanilla-reader__dialog-settings__form__margin-horizontal" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true" style="transform: rotate(-90deg);">margin</span> Horizontal page
                    margin (%)</label>
                <select data-optionname="pageMarginVertical" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__margin-horizontal">
                    <option value="2">2%</option>
                    <option value="6" selected="selected">6%</option>
                    <option value="8">8%</option>
                    <option value="10">10%</option>
                    <option value="12">12%</option>
                    <option value="14">14%</option>
                    <option value="16">16%</option>
                    <option value="18">18%</option>
                    <option value="20">20%</option>
                </select>

                <hr>

                <label for="vanilla-reader__dialog-settings__form__renderer" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">auto_stories</span> Reading mode</label>
                <select data-optionname="renderer" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__renderer">
                    <option value="__responsive__" selected="selected">Adapt to screen</option>
                    <option value="FlipBookRenderer">Flipbook</option>
                    <option value="StackRenderer">Stack</option>
                    <option value="SinglePageSwipeRenderer">Swipe - Single page</option>
                    <option value="SpreadSwipeRenderer">Swipe - Spread</option>                    
                    <option value="SingleDocumentScrollRenderer">Scroll</option>
                </select>
                
                <hr>
                
                <label for="vanilla-reader__dialog-settings__form__show_page_numbers" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">123</span> Show location numbers in book</label>
                <input type="checkbox" data-optionname="showPageNumbers" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__show_page_numbers">
                               
                <hr>

                <label for="vanilla-reader__dialog-settings__form__mediaplayer-playbackrate" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">speed</span> Audio playback rate (%)</label>
                <select data-optionname="mediaPlayerPlaybackRate" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__mediaplayer-playbackrate">                                       
                    <option value="0.4">40%</option>
                    <option value="0.6">60%</option>
                    <option value="0.8">80%</option>
                    <option value="1" selected="selected">100%</option>
                    <option value="1.2">120%</option>
                    <option value="1.3">130%</option>
                    <option value="1.4">140%</option>
                    <option value="1.5">150%</option>
                    <option value="1.6">160%</option>
                    <option value="1.7">170%</option>
                    <option value="1.8">180%</option>
                    <option value="1.9">190%</option>
                    <option value="2">200%</option>
                    <option value="2.2">225%</option>
                    <option value="2.5">250%</option>
                    <option value="3">300%</option>
                    <option value="3.5">350%</option>
                    <option value="4">400%</option>
                    <option value="4.5">450%</option>
                </select>
                
                <label for="vanilla-reader__dialog-settings__form__mediaplayer-tts-voice" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">record_voice_over</span> TTS Voice</label>
                <select data-optionname="mediaPlayerTtsVoice" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__mediaplayer-tts-voice"></select>
                <p id="vanilla-reader__dialog-settings__form__mediaplayer-tts-voice__note">
                    NOTE:<br>
                    Selecting TTS voice may not work properly on the browser that you are using. 
                </p>
                
                <hr>
                
                <label tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">straighten</span> Reading ruler</label>                
                
                <label for="vanilla-reader__dialog-settings__form__ruler-color" tabindex="-1">Ruler color</label>                
                <fieldset id="vanilla-reader__dialog-settings__form__ruler-color">
                    <input type="radio" name="reading-ruler-color" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__ruler-color-red"  selected="selected" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.red}" title="red"></input>
                    <input type="radio" name="reading-ruler-color" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__ruler-color-green" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.green}" title="green"></input>
                    <input type="radio" name="reading-ruler-color" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__ruler-color-blue" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.blue}" title="blue"></input>
                    <input type="radio" name="reading-ruler-color" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__ruler-color-yellow" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.yellow}" title="yellow"></input>
                    <input type="radio" name="reading-ruler-color" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__ruler-color-transparent" value="${(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.transparent}" title="transparent"></input>
                </fieldset>
                              
                <label for="vanilla-reader__dialog-settings__form__ruler-overlay-visible">Hide page content</label>
                <input type="checkbox" data-optionname="ruleroverlay" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__ruler-overlay-visible">

                <label for="vanilla-reader__dialog-settings__form__ruler-line-snapping">Snap to lines</label>
                <input type="checkbox" data-optionname="rulersnapping" class="vanilla-reader__dialog-settings__form__field" checked="checked" id="vanilla-reader__dialog-settings__form__ruler-line-snapping">

                <label for="vanilla-reader__dialog-settings__form__ruler-line-span">Number of text lines</label>
                <select data-optionname="rulerlinespan" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__ruler-line-span">
                    <option value="1">1</option>
                    <option value="3" selected="selected">3</option>
                    <option value="5">5</option>
                </select>
                
                <hr>
                
                <label for="vanilla-reader__dialog-settings__form__aspect-ratio" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">aspect_ratio</span> Ignore default aspect ratio</label>
                <input type="checkbox" data-optionname="aspect" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__aspect-ratio">
                
                <hr>
                
                <label for="vanilla-reader__dialog-settings__form__motion" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">animation</span> Reduce UI motion</label>
                <input type="checkbox" data-optionname="motion" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__motion">
                
<!--                <hr>-->

<!--                <label for="vanilla-reader__dialog-settings__form__table-overflow" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">table_chart</span> Scroll overflowing tables</label>-->
<!--                <input type="checkbox" data-optionname="tableoverflow" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__table-overflow">-->
                
                <hr>
                
                <label for="vanilla-reader__dialog-settings__form__reset" tabindex="-1"><span class="vanilla-reader-icon" aria-hidden="true">restart_alt</span> Reset to defaults</label>
                <input type="button" data-optionname="reset" class="vanilla-reader__dialog-settings__form__field" id="vanilla-reader__dialog-settings__form__reset" value="Reset">
                
            </form>`;
        /*
    *
    * EVENT HANDLERS
    *
    * */ this._event_change = (_ev)=>{
            let formState = this.serializeSettingsState();
            this._sendUpdateOptionsIntent(formState);
        };
        this._dialogElement.insertAdjacentHTML(insertPosition, this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._form = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form");
        this._pageMarginHorizontalSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__margin-horizontal");
        this._pageMarginVerticalSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__margin-vertical");
        this._rendererSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__renderer");
        this._fontSetSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__font-set");
        this._fontScaleSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__font-size");
        this._lineHeightSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__line-height");
        this._textAlignSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__text-align");
        this._paletteSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__palette");
        this._playbackRateSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__mediaplayer-playbackrate");
        this._playbackVoiceSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__mediaplayer-tts-voice");
        this._useAccessibilityModeOption = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__a11y-mode");
        this._reducedMotionOption = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__motion");
        this._aspectRatioOption = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__aspect-ratio");
        this._ttsVoiceNote = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__mediaplayer-tts-voice__note");
        this._rulerColorOptions = Array.from(this._form.querySelectorAll('input[name="reading-ruler-color"]'));
        this._rulerOverlayOption = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__ruler-overlay-visible");
        this._rulerLineSpanSelect = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__ruler-line-span");
        this._rulerLineSnappingOption = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__ruler-line-snapping");
        this._showPageNumbersOption = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__show_page_numbers");
        //this._scrollOverflowingTablesOption = this._hostDocument.getElementById('vanilla-reader__dialog-settings__form__table-overflow')! as HTMLInputElement;
        this._buttonReset = this._hostDocument.getElementById("vanilla-reader__dialog-settings__form__reset");
        this._activeAspectRatioOption = this._aspectRatioOption.checked;
        this._activeAccessibilityModeOption = this._useAccessibilityModeOption.checked;
        this._activeReducedMotionOption = this._reducedMotionOption.checked;
        this._activeRulerOverlayVisibleOption = this._rulerOverlayOption.checked;
        this._activeRulerLineSnappingOption = this._rulerLineSnappingOption.checked;
        this._activePlaybackVoiceOption = undefined;
        this._activeShowPageNumbersOption = this._showPageNumbersOption.checked;
        //this._activeScrollOverflowingTablesOption = this._scrollOverflowingTablesOption.checked;
        if ((0, $91ca8664a4c236f4$export$e8551d08bf651ea9).isOS("macOS") && (0, $91ca8664a4c236f4$export$e8551d08bf651ea9).isBrowser("Safari")) this._playbackVoiceNoSupport = true;
        this._setup();
        if (initialState) this.setViewState(initialState);
    }
    get activeReadingRulerColor() {
        let optionElement = this._form.querySelector('input[name="reading-ruler-color"]:checked');
        return optionElement ? optionElement.value : undefined;
    }
    get activeRendererTypeName() {
        return this._activeRendererTypeName;
    }
    get selectedRendererTypeName() {
        return this._rendererSelect.selectedOptions[0].value.toString();
    }
    get activeAspectRatioOption() {
        return this._activeAspectRatioOption;
    }
    get activePlaybackRateOption() {
        return parseFloat(this._playbackRateSelect.selectedOptions[0].value);
    }
    get activeReducedMotionOption() {
        return this._activeReducedMotionOption;
    }
    get activeAccessibilityModeOption() {
        return this._activeAccessibilityModeOption;
    }
    // public get activeScrollOverflowingTablesOption(): boolean {
    //     return this._activeScrollOverflowingTablesOption;
    // }
    onSettingsUpdated(callback) {
        this._settingsUpdatedCallback = callback;
    }
    onSettingsReset(callback) {
        this._settingsResetCallback = callback;
    }
    setSelectedLineSpanOption(lineSpanOption) {
        this._setSelectedItemInSelectList(this._rulerLineSpanSelect, lineSpanOption);
    }
    setSelectedRendererOption(rendererName) {
        this._setSelectedItemInSelectList(this._rendererSelect, rendererName);
        this._activeRendererTypeName = rendererName;
    }
    setRendererAspectRatioOption(ignoreAspectRatio = false) {
        this._activeAspectRatioOption = ignoreAspectRatio;
        this._aspectRatioOption.checked = ignoreAspectRatio;
    }
    setUseReducedMotionOption(useReducedMotion) {
        this._reducedMotionOption.checked = useReducedMotion;
        this._activeReducedMotionOption = useReducedMotion;
    }
    setUseAccessibilityModeOption(useAccessibilityMode) {
        this._useAccessibilityModeOption.checked = useAccessibilityMode;
        this._activeAccessibilityModeOption = useAccessibilityMode;
    }
    setSelectedTtsVoiceOption(voiceName) {
        this._setSelectedItemInSelectList(this._playbackVoiceSelect, voiceName, "Default", true);
        this._activePlaybackVoiceOption = this._playbackVoiceSelect.selectedOptions[0]?.getAttribute("data-name") || undefined;
    }
    setTtsVoiceCollectionData(voiceCollectionData) {
        this._populateTtsVoicesList(voiceCollectionData);
        this.setSelectedTtsVoiceOption(this._activeSettingsState?.ttsOptions?.voiceName || "Default");
    }
    get activeTtsVoiceOption() {
        return this._activePlaybackVoiceOption;
    }
    get activeShowPageNumberOption() {
        return this._activeShowPageNumbersOption;
    }
    setSelectedShowPageNumberOption(showPageNumbers) {
        this._showPageNumbersOption.checked = showPageNumbers;
        this._activeShowPageNumbersOption = showPageNumbers;
    }
    // setScrollOverflowingTablesOption(scrollOverflowingTables: boolean): void {
    //     this._scrollOverflowingTablesOption.checked = scrollOverflowingTables;
    //     this._activeScrollOverflowingTablesOption = scrollOverflowingTables;
    // }
    setViewState(settings) {
        this._activeSettingsState = settings;
        let publicationStyleOptions = settings.publicationStyleOptions;
        if (publicationStyleOptions) {
            // The two variables below are forced (!) to be not-undefined as they are set in the config file VanillaReaderUiModel.ts
            let pageMarginVertical = publicationStyleOptions.pageMargins?.top ? publicationStyleOptions.pageMargins?.top : (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.publicationStyleOptions?.pageMargins?.top;
            let pageMarginHorizontal = publicationStyleOptions.pageMargins?.left ? publicationStyleOptions.pageMargins?.left : (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.publicationStyleOptions?.pageMargins?.left;
            if (pageMarginHorizontal && this._pageMarginHorizontalSelect.selectedOptions[0].value !== pageMarginVertical?.value.toString()) this._setSelectedItemInSelectList(this._pageMarginHorizontalSelect, pageMarginHorizontal?.value.toString());
            if (pageMarginVertical && this._pageMarginVerticalSelect.selectedOptions[0].value !== pageMarginVertical?.value.toString()) this._setSelectedItemInSelectList(this._pageMarginVerticalSelect, pageMarginVertical?.value.toString());
            if (publicationStyleOptions.fontSizeScaleFactor && this._fontScaleSelect.selectedOptions[0].value !== publicationStyleOptions.fontSizeScaleFactor.toString()) this._setSelectedItemInSelectList(this._fontScaleSelect, publicationStyleOptions.fontSizeScaleFactor.toString());
            if (settings.activePublicationFontSetName && this._fontSetSelect.selectedOptions[0].value !== settings.activePublicationFontSetName) this._setSelectedItemInSelectList(this._fontSetSelect, settings.activePublicationFontSetName);
            if (settings.activePublicationPaletteName && this._paletteSelect.selectedOptions[0].value !== settings.activePublicationPaletteName) this._setSelectedItemInSelectList(this._paletteSelect, settings.activePublicationPaletteName);
            if (publicationStyleOptions.lineHeightScaleFactor && this._lineHeightSelect.selectedOptions[0].value !== publicationStyleOptions.lineHeightScaleFactor.toString()) this._setSelectedItemInSelectList(this._lineHeightSelect, publicationStyleOptions.lineHeightScaleFactor.toString());
            // This option is a bit special since it can be set `null` to explicitly tell the Colibrio framework to
            // unset any customization option. This means that we actually need to check and preserve the `null` value.
            let hasTextAlignProperty = publicationStyleOptions.hasOwnProperty("textAlignment");
            if (hasTextAlignProperty) {
                let textAlignSelectionOptionName = publicationStyleOptions.textAlignment?.defaultAlignment ?? "default";
                if (this._textAlignSelect.selectedOptions[0].value !== textAlignSelectionOptionName) this._setSelectedItemInSelectList(this._textAlignSelect, textAlignSelectionOptionName);
            }
        }
        if (settings.mediaPlayerPlaybackRate && this._playbackRateSelect.selectedOptions[0].value !== settings.mediaPlayerPlaybackRate.toString()) this._setSelectedItemInSelectList(this._playbackRateSelect, settings.mediaPlayerPlaybackRate.toString());
        if (settings.activeRendererTypeName && this._rendererSelect.selectedOptions[0].value !== settings.activeRendererTypeName) this.setSelectedRendererOption(settings.activeRendererTypeName);
        if (settings.ttsOptions && settings.ttsOptions.voiceName) this._setSelectedItemInSelectList(this._playbackVoiceSelect, settings.ttsOptions.voiceName, "Default", true);
        this.setSelectedShowPageNumberOption(settings.showPageNumbers ?? this._showPageNumbersOption.checked);
        this._activeShowPageNumbersOption = settings.showPageNumbers ?? this._showPageNumbersOption.checked;
        this._useAccessibilityModeOption.checked = settings.useAccessibilityMode ?? this._useAccessibilityModeOption.checked;
        this._aspectRatioOption.checked = settings.ignoreAspectRatio ?? this._aspectRatioOption.checked;
        this._activeAspectRatioOption = this._aspectRatioOption.checked;
        this._activePlaybackVoiceOption = this._playbackVoiceSelect.selectedOptions[0]?.getAttribute("data-name") || undefined;
        this._activeRulerOverlayVisibleOption = settings.readingRulerOptions?.overlayIsVisible ?? this._rulerOverlayOption.checked;
        this._activeRulerLineSnappingOption = settings.readingRulerOptions?.snapToLineBoxes ?? this._rulerLineSnappingOption.checked;
        if (settings.useReducedMotion !== undefined) {
            this._reducedMotionOption.checked = settings.useReducedMotion;
            this._activeReducedMotionOption = this._reducedMotionOption.checked;
        } else this._activeReducedMotionOption = this._reducedMotionOption.checked;
        // if (settings.scrollOverflowingTables !== undefined) {
        //     this._scrollOverflowingTablesOption.checked = settings.scrollOverflowingTables;
        //     this._activeScrollOverflowingTablesOption = this._scrollOverflowingTablesOption.checked;
        // } else {
        //     this._activeScrollOverflowingTablesOption = this._scrollOverflowingTablesOption.checked;
        // }
        if (settings.readingRulerOptions && settings.readingRulerOptions.lineBoxBackgroundColor) {
            this._setSelectedItemInOptionsList(this._rulerColorOptions, settings.readingRulerOptions.lineBoxBackgroundColor, (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.red, false);
            this._rulerOverlayOption.checked = this._activeRulerOverlayVisibleOption;
            this._setSelectedItemInSelectList(this._rulerLineSpanSelect, settings.readingRulerOptions.lineBoxLineSpan?.toString() || "3");
            this._rulerLineSnappingOption.checked = this._activeRulerLineSnappingOption;
        }
    }
    resetToDefault() {
        this.setViewState((0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options);
        if (this._settingsResetCallback) this._settingsResetCallback(this.serializeSettingsState());
    }
    serializeSettingsState() {
        let pageMarginHorizontal = parseFloat(this._pageMarginHorizontalSelect.selectedOptions[0].value);
        let pageMarginVertical = parseFloat(this._pageMarginVerticalSelect.selectedOptions[0].value);
        let fontScaleFactor = parseFloat(this._fontScaleSelect.selectedOptions[0].value);
        let activeFontSetName = this._fontSetSelect.selectedOptions[0].value === "default" ? undefined : this._fontSetSelect.selectedOptions[0].value;
        let activePaletteName = this._paletteSelect.selectedOptions[0].value === "default" ? undefined : this._paletteSelect.selectedOptions[0].value;
        let activeUiPaletteName = activePaletteName || "Dark";
        let activeRendererTypeName = this._rendererSelect.selectedOptions[0].value.toString();
        let lineHeightScaleFactor = parseFloat(this._lineHeightSelect.selectedOptions[0].value);
        let textAlignValue = this._textAlignSelect.selectedOptions[0].value.toString();
        let mediaPlayerPlaybackRate = parseFloat(this._playbackRateSelect.selectedOptions[0].value);
        let useReducedMotion = this._reducedMotionOption.checked;
        let ignoreAspectRatio = this._aspectRatioOption.checked;
        let readingRulerColor = this.activeReadingRulerColor || (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.red;
        let readingRulerLineSpan = parseInt(this._rulerLineSpanSelect.selectedOptions[0].value);
        let useDarkMode;
        let activePaletteData;
        let activeFontSetData;
        // let scrollOverflowingTables: boolean = this._scrollOverflowingTablesOption.checked;
        let textAlignOption;
        // If textAlign is set to `"default"` we should set the `textAlignOption` to null in order to tell
        // the ReaderPublication to use the default publication style.
        if (textAlignValue.toString() === "default") textAlignOption = null;
        else textAlignOption = {
            defaultAlignment: textAlignValue,
            preserved: []
        };
        activePaletteData = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name.toLowerCase() === activePaletteName?.toLowerCase()) || null;
        useDarkMode = !activePaletteData ? false : activePaletteData.uiIsDark;
        let publicationStylePalette;
        if (activePaletteData) publicationStylePalette = {
            isDark: useDarkMode,
            foregroundDark: activePaletteData.foregroundDark,
            foregroundLight: activePaletteData.foregroundLight,
            backgroundDark: activePaletteData.backgroundDark,
            backgroundLight: activePaletteData.backgroundLight,
            accent: activePaletteData.accent
        };
        activeFontSetData = (0, $5340a9bdc44a0542$export$fbea20b286778a79).FontSets.find((fontSet)=>fontSet.name.toLowerCase() === activeFontSetName?.toLowerCase()) || null;
        let ttsOptions = {
            voiceName: undefined,
            rate: mediaPlayerPlaybackRate
        };
        if (this._playbackVoiceSelect.selectedOptions.length > 0) ttsOptions.voiceName = this._playbackVoiceSelect.selectedOptions[0].getAttribute("data-name") || undefined;
        return {
            dateCreated: Date.now(),
            useReducedMotion: useReducedMotion,
            activeUiPaletteName: activeUiPaletteName,
            activePublicationFontSetName: activeFontSetName,
            activePublicationPaletteName: activePaletteName,
            activeRendererTypeName: activeRendererTypeName,
            ignoreAspectRatio: ignoreAspectRatio,
            useDarkMode: useDarkMode,
            mediaPlayerPlaybackRate: mediaPlayerPlaybackRate,
            publicationStyleOptions: {
                defaultFontFamily: "serif",
                fontSizeScaleFactor: fontScaleFactor,
                fontSet: activeFontSetData,
                lineHeightScaleFactor: lineHeightScaleFactor,
                textAlignment: textAlignOption,
                pageMargins: {
                    top: {
                        unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                        value: pageMarginVertical
                    },
                    bottom: {
                        unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                        value: pageMarginVertical
                    },
                    left: {
                        unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                        value: pageMarginHorizontal
                    },
                    right: {
                        unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                        value: pageMarginHorizontal
                    }
                },
                palette: publicationStylePalette
            },
            ttsOptions: ttsOptions,
            useAccessibilityMode: this._useAccessibilityModeOption.checked,
            readingRulerOptions: {
                lineBoxBackgroundColor: readingRulerColor,
                overlayIsVisible: this._rulerOverlayOption.checked,
                lineBoxLineSpan: readingRulerLineSpan,
                snapToLineBoxes: this._rulerLineSnappingOption.checked
            },
            showPageNumbers: this._showPageNumbersOption.checked
        };
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _setup() {
        this._form.addEventListener("change", this._event_change);
        this._buttonReset.addEventListener("click", ()=>{
            if (confirm("Reset all settings to their defaults?")) this.resetToDefault();
        });
    }
    _sendUpdateOptionsIntent(settings) {
        if (this._settingsUpdatedCallback) this._settingsUpdatedCallback(settings);
    }
    _setSelectedItemInSelectList(list, optionValueToSelect, fallbackValueToSelect, fuzzyMatch = false) {
        let optionToSelect;
        let fallbackOption;
        for(let i = 0; list.options.length > i; i++){
            let option = list.options[i];
            let optionToSelectFound = false;
            let fallbackOptionFound = false;
            option.selected = false;
            if (!fuzzyMatch) {
                optionToSelectFound = option.value === optionValueToSelect;
                if (fallbackValueToSelect) fallbackOptionFound = option.value === fallbackValueToSelect;
            } else {
                optionToSelectFound = option.value.includes(optionValueToSelect);
                if (fallbackValueToSelect) fallbackOptionFound = option.value.includes(fallbackValueToSelect);
            }
            if (optionToSelectFound) optionToSelect = option;
            if (fallbackOptionFound) fallbackOption = option;
        }
        if (optionToSelect) optionToSelect.selected = true;
        else if (fallbackOption) fallbackOption.selected = true;
    }
    _setSelectedItemInOptionsList(list, optionValueToSelect, fallbackValueToSelect, fuzzyMatch = false) {
        let optionToSelect;
        let fallbackOption;
        for(let i = 0; list.length > i; i++){
            let option = list[i];
            let optionToSelectFound = false;
            let fallbackOptionFound = false;
            option.checked = false;
            if (!fuzzyMatch) {
                optionToSelectFound = option.value === optionValueToSelect;
                if (fallbackValueToSelect) fallbackOptionFound = option.value === fallbackValueToSelect;
            } else {
                optionToSelectFound = option.value.includes(optionValueToSelect);
                if (fallbackValueToSelect) fallbackOptionFound = option.value.includes(fallbackValueToSelect);
            }
            if (optionToSelectFound) optionToSelect = option;
            if (fallbackOptionFound) fallbackOption = option;
        }
        if (optionToSelect) optionToSelect.checked = true;
        else if (fallbackOption) fallbackOption.checked = true;
    }
    _populateTtsVoicesList(voicesCollection) {
        this._playbackVoiceSelect.childNodes.forEach((child)=>child.remove());
        if (this._playbackVoiceNoSupport) this._ttsVoiceNote.style.display = "flex";
        let languages = Array.from(voicesCollection.languages);
        languages.sort((a, b)=>{
            if (a[0] < b[0]) return -1;
            else return 1;
            return 0;
        });
        let option = document.createElement("option");
        option.textContent = `Default`;
        this._playbackVoiceSelect.appendChild(option);
        languages.forEach((lang)=>{
            let langName = lang[0];
            let voices = lang[1];
            let optionLangGroup = document.createElement("optgroup");
            optionLangGroup.label = langName.toUpperCase();
            this._playbackVoiceSelect.appendChild(optionLangGroup);
            if (this._playbackVoiceLanguageOnly) {
                let option = document.createElement("option");
                option.textContent = "Default";
                option.setAttribute("data-lang", voices[0].lang);
                option.setAttribute("data-name", voices[0].name);
                option.setAttribute("data-voiceuri", voices[0].voiceURI);
                option.setAttribute("data-localservice", voices[0].localService.toString());
                option.setAttribute("data-default", voices[0].default.toString());
                optionLangGroup.appendChild(option);
            } else for(let i = 0; i < voices.length; i++){
                if (this._playbackVoiceLocalOnly && !voices[i].localService) continue;
                if (this._playbackVoiceRemoteOnly && voices[i].localService) continue;
                const langString = voices[i].lang ? ` (${voices[i].lang}')` : "";
                let option = document.createElement("option");
                option.textContent = `${voices[i].name}${langString}`;
                option.setAttribute("data-lang", voices[i].lang);
                option.setAttribute("data-name", voices[i].name);
                option.setAttribute("data-voiceuri", voices[i].voiceURI);
                option.setAttribute("data-localservice", voices[i].localService.toString());
                option.setAttribute("data-default", voices[i].default.toString());
                optionLangGroup.appendChild(option);
            }
            this._playbackVoiceSelect.appendChild(optionLangGroup);
        });
    }
}


class $8eeccfaf2615f846$export$2f7be2069423e957 {
    constructor(_hostElement, insertPosition = "afterbegin"){
        this._hostElement = _hostElement;
        this._template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-highlight" type="button" title="Add highlight" aria-hidden="true"><span class="vanilla-reader__fab__icon" aria-hidden="true">edit_note</span></button>`;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._hightlightButton = this._hostElement.querySelector("#vanilla-reader__fab-highlight");
        this._hightlightButton.addEventListener("click", (_ev)=>{
            if (this._onClickCallback) {
                if (this.isVisible) this._onClickCallback();
            }
        });
    }
    get isVisible() {
        return !this._hightlightButton.hasAttribute("aria-hidden");
    }
    show() {
        this._hightlightButton.removeAttribute("aria-hidden");
        this._hightlightButton.setAttribute("accesskey", "i");
        this._hightlightButton.style.display = "flex";
        this._hightlightButton.style.opacity = "1";
        this._hightlightButton.style.pointerEvents = "all";
        if (this._onVisibleCallback) this._onVisibleCallback();
    }
    hide() {
        this._hightlightButton.removeAttribute("accesskey");
        this._hightlightButton.setAttribute("aria-hidden", "true");
        this._hightlightButton.style.opacity = "0";
        this._hightlightButton.style.pointerEvents = "none";
        setTimeout(()=>{
            this._hightlightButton.style.display = "none";
        }, 200);
        if (this._onHiddenCallback) this._onHiddenCallback();
    }
    getComponentElement() {
        return this._hightlightButton;
    }
    onClick(callback) {
        this._onClickCallback = callback;
    }
    onVisible(callback) {
        this._onVisibleCallback = callback;
    }
    onHidden(callback) {
        this._onHiddenCallback = callback;
    }
}


class $309b1409405cd60f$export$f772e11a2a026b3a {
    constructor(_hostElement, insertPosition = "afterbegin"){
        this._hostElement = _hostElement;
        this._template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-mediaplayer" type="button" title="Start / stop read aloud " aria-hidden="true"><span class="vanilla-reader__fab__icon" id="vanilla-reader__fab-mediaplayer__icon" aria-hidden="true">play_arrow</span></button>`;
        this._stateIsPlaying = false;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._playerButton = this._hostElement.querySelector("#vanilla-reader__fab-mediaplayer");
        this._playerButton.addEventListener("click", (ev)=>{
            ev.preventDefault();
            if (this._onClickCallback) {
                if (this.isVisible) this._onClickCallback();
            }
        });
        this._playerButtonIcon = this._hostElement.querySelector("#vanilla-reader__fab-mediaplayer__icon");
    }
    get isVisible() {
        return !this._playerButton.hasAttribute("aria-hidden");
    }
    get stateIsPlaying() {
        return this._stateIsPlaying;
    }
    set stateIsPlaying(isPlaying) {
        this._stateIsPlaying = isPlaying;
        if (isPlaying) this._playerButtonIcon.innerText = "pause";
        else this._playerButtonIcon.innerText = "play_arrow";
    }
    show() {
        this._playerButton.removeAttribute("aria-hidden");
        this._playerButton.style.display = "flex";
        this._playerButton.style.opacity = "1";
        this._playerButton.style.pointerEvents = "all";
        if (this._onVisibleCallback) this._onVisibleCallback();
    }
    hide() {
        this._playerButton.setAttribute("aria-hidden", "true");
        this._playerButton.style.opacity = "0";
        this._playerButton.style.pointerEvents = "none";
        setTimeout(()=>{
            this._playerButton.style.display = "none";
        }, 200);
        if (this._onHiddenCallback) this._onHiddenCallback();
    }
    getComponentElement() {
        return this._playerButton;
    }
    onClick(callback) {
        this._onClickCallback = callback;
    }
    onVisible(callback) {
        this._onVisibleCallback = callback;
    }
    onHidden(callback) {
        this._onHiddenCallback = callback;
    }
}


class $649f2472302fbf6b$export$643ea1dbff021c8b {
    constructor(_hostElement, insertPosition = "afterbegin"){
        this._hostElement = _hostElement;
        this._stateIsPlaying = false;
        this._style = `
        <style>
            #vanilla-reader__menu__mediaplayer {
                display: none;                
                min-height: 48px;
                justify-self: stretch;
                justify-content: center;                
                margin: 0.5em;
            }
            
             #vanilla-reader__menu__mediaplayer > button {
                font-size: x-large;
                margin-top: 0;
                margin-bottom: 0;
                border: 1px solid var(--vanilla-reader__color__ui__outline-dark);
            }
 
            #vanilla-reader__menu__mediaplayer__button-pause {
                display: none;
            }
        </style>`;
        this._template = `
    <div id="vanilla-reader__menu__mediaplayer" title="Read aloud controls" tabindex="0">
        <button id="vanilla-reader__menu__mediaplayer__button-previous" aria-label="Skip back"><span aria-hidden="true">skip_previous</span></button>
        <button id="vanilla-reader__menu__mediaplayer__button-play" aria-label="Play"><span aria-hidden="true">play_arrow</span></button>
        <button id="vanilla-reader__menu__mediaplayer__button-pause" aria-label="Pause"><span aria-hidden="true"><span aria-hidden="true">pause</span></span></button>
        <button id="vanilla-reader__menu__mediaplayer__button-next" aria-label="Skip forward"><span aria-hidden="true">skip_next</span></button>
    </div>`;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this.hostDocument = _hostElement.ownerDocument;
        this.mediaPlayer = this.hostDocument.getElementById("vanilla-reader__menu__mediaplayer");
        this.mediaPlayer.insertAdjacentHTML("afterbegin", this._style);
        this.buttonPrevious = this.hostDocument.getElementById("vanilla-reader__menu__mediaplayer__button-previous");
        this.buttonNext = this.hostDocument.getElementById("vanilla-reader__menu__mediaplayer__button-next");
        this.buttonPlay = this.hostDocument.getElementById("vanilla-reader__menu__mediaplayer__button-play");
        this.buttonPause = this.hostDocument.getElementById("vanilla-reader__menu__mediaplayer__button-pause");
        // Start out disabled. Controls will be enabled in the `VanillaReaderUi._event_mediaPlayerCreated()`.
        this.disable();
        this._setup();
    }
    set stateIsPlaying(playing) {
        this._stateIsPlaying = playing;
        if (playing) {
            this.buttonPlay.style.display = "none";
            this.buttonPause.style.display = "flex";
        } else {
            this.buttonPlay.style.display = "flex";
            this.buttonPause.style.display = "none";
        }
    }
    get stateIsPlaying() {
        return this._stateIsPlaying;
    }
    onOpened(callback) {
        this._openedCallback = callback;
    }
    onClosed(callback) {
        this._closedCallback = callback;
    }
    onPlay(callback) {
        this._playCallback = callback;
    }
    onPause(callback) {
        this._pauseCallback = callback;
    }
    onSeekNext(callback) {
        this._seekNextCallback = callback;
    }
    onSeekPrevious(callback) {
        this._seekPreviousCallback = callback;
    }
    isOpen() {
        return this.mediaPlayer.style.display === "flex";
    }
    disable() {
        this.buttonNext.setAttribute("disabled", "disabled");
        this.buttonNext.setAttribute("aria-disabled", "true");
        this.buttonPrevious.setAttribute("disabled", "disabled");
        this.buttonPrevious.setAttribute("aria-disabled", "true");
        this.buttonPause.setAttribute("disabled", "disabled");
        this.buttonPause.setAttribute("aria-disabled", "disabled");
        this.buttonPlay.setAttribute("disabled", "disabled");
        this.buttonPlay.setAttribute("aria-disabled", "disabled");
    }
    enable() {
        this.buttonNext.removeAttribute("disabled");
        this.buttonNext.removeAttribute("aria-disabled");
        this.buttonPrevious.removeAttribute("disabled");
        this.buttonPrevious.removeAttribute("aria-disabled");
        this.buttonPlay.removeAttribute("disabled");
        this.buttonPlay.removeAttribute("aria-disabled");
        this.buttonPause.removeAttribute("disabled");
        this.buttonPause.removeAttribute("aria- disabled");
    }
    open() {
        this.mediaPlayer.style.display = "flex";
        if (this._openedCallback) this._openedCallback();
    }
    close() {
        this.mediaPlayer.style.display = "none";
        this.buttonPlay.style.display = "flex";
        this.buttonPause.style.display = "none";
        if (this._closedCallback) this._closedCallback();
    }
    getComponentElement() {
        return this.mediaPlayer;
    }
    /*
    * PRIVATE METHODS
    * */ _setup() {
        this.buttonPrevious.addEventListener("click", ()=>{
            if (this._seekPreviousCallback) this._seekPreviousCallback();
        });
        this.buttonNext.addEventListener("click", ()=>{
            if (this._seekNextCallback) this._seekNextCallback();
        });
        this.buttonPlay.addEventListener("click", ()=>{
            if (this._playCallback) this._playCallback();
            this.stateIsPlaying = true;
        });
        this.buttonPause.addEventListener("click", ()=>{
            if (this._pauseCallback) this._pauseCallback();
            this.stateIsPlaying = false;
        });
    }
}




class $24a4e81f2b6663c1$export$3d4f64ec72732a0e {
    constructor(_hostElement, insertPosition = "beforeend", _hostContext){
        this._hostElement = _hostElement;
        this._hostContext = _hostContext;
        this._enablePanZoomButton = !(0, $91ca8664a4c236f4$export$e8551d08bf651ea9).isPlatform("mobile");
        this._contentsDialogOpenCallback = undefined;
        this._showNavigationHistoryCallback = undefined;
        this._style = `
        <style>
            #vanilla-reader__menu {                
                position: fixed;
                bottom: 0;
                opacity: 0;
                display: flex;  
                width: 100%;                
                margin-left: auto;
                margin-right: auto;
                padding: 1em;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-around;
                box-sizing: border-box;
                z-index: 2;
                background-color: var(--vanilla-reader__color__ui__background-light);                
                box-shadow: 0 -3px 16px 0 rgb(0 0 0 / 30%);
                border-radius: 16px 16px 0 0;
                border: none;
                border-top: 1px solid var(--vanilla-reader__color__ui__outline-dark);
                pointer-events: none;                
                transition: bottom 0.2s ease-out;
                will-change: bottom;
            }
                    
            @media (prefers-reduced-motion: reduce) {
                #vanilla-reader__menu {
                    transition: opacity 0.2s ease-out;
                }
            }
            
            #vanilla-reader__menu button {
                flex-direction: column;                
                min-height: 48px;
                min-width: 48px;
                font-size: x-large;
                color: var(--vanilla-reader__color__ui__foreground-dark);
                border-color: transparent;
                background-color: transparent;                
            }           
            
            #vanilla-reader__menu button .vanilla__button-icon { 
                display: block;
                width: 32px;   
                height: 32px;   
                margin-bottom: 5px;
            }
            
            #vanilla-reader__menu button .vanilla__button-label { 
                font-family: 'Lato';
                font-size: 10px;
                font-weight: 600;
                min-height: 20px;                
                display: block;            
            }
                        
            #vanilla-reader__menu__button-handle {
                height: 24px;                
                min-height: 24px!important;
                width: 100%;
                margin: 8px;
                align-self: center;                
                background-color: transparent;               
                border: 0;
            }

            #vanilla-reader__menu__button-handle span {
                width: 100%;
                display: block;
                font-size: x-large;
                color: var(--vanilla-reader__color__ui__foreground-dark);
            }
                        
            #vanilla-reader__menu__mediaplayer-container {
                width: 100%;
                justify-content: center;
                font-size: x-large;
            }
                        
            #vanilla-reader__menu__slider-container {
                display: flex;
                flex-grow: 1;
                flex-direction: row;
                flex-wrap: wrap;            
                width: 100%; 
                max-width: 900px;            
            }

            #vanilla-reader__menu__action-button-container {
                display: flex;
                flex-grow: 1;
                width: 100%;       
                max-width: max-content;          
                align-items: center;
                flex-direction: row;                
                justify-content: space-between;
                overflow-x: auto;
            }                    
            
            #vanilla-reader__menu__action-button-container > button {
                min-width: 64px;
            }
            
            #vanilla-reader__dialog-highlight__form__comment {
                width: 100%;
                height: 10em;
                margin-bottom: 1em;
            }
            
            #vanilla-reader__menu__button-bookmark-add {}
            
            #vanilla-reader__menu__button-bookmark-remove {
                display: none;
            }
            
            #vanilla-reader__menu__button-readaloud-hide {
                display: none;
            }
            
            @media only screen and (max-device-width: 1000px) {
                #vanilla-reader__menu__action-button-container {
                    justify-content: space-between;
                }
            }
            
        </style>`;
        this._template = `
        <nav id="vanilla-reader__menu" title="Menu section" aria-hidden="true" inert>      
            <button id="vanilla-reader__menu__button-handle" title="Close menu" accesskey="x"><span aria-hidden="true">drag_handle</span></button>
            <div id="vanilla-reader__menu__mediaplayer-container" inert></div>
            <div id="vanilla-reader__menu__slider-container" inert></div>
            <hr>
            <div id="vanilla-reader__menu__action-button-container">
                <button id="vanilla-reader__menu__button-help" title="Open help dialog"><span class="vanilla__button-icon" aria-hidden="true">help</span><span aria-hidden="true" class="vanilla__button-label">Help</span></button>
                <!--<button id="vanilla-reader__menu__button-file" title="Open new book" accesskey="q"><span class="vanilla__button-icon" aria-hidden="true">folder_open</span><span aria-hidden="true" class="vanilla__button-label">Open file</span></button>-->
                <button id="vanilla-reader__menu__button-toc" title="Open table of contents dialog" accesskey="c"><span class="vanilla__button-icon" aria-hidden="true">toc</span><span aria-hidden="true" class="vanilla__button-label">Contents</span></button>
                <button id="vanilla-reader__menu__button-navigation-history" title="Open navigation history" accesskey="y"><span class="vanilla__button-icon" aria-hidden="true">history</span><span aria-hidden="true" class="vanilla__button-label">History</span></button>
                <button id="vanilla-reader__menu__button-bookmarks" title="Open bookmarks dialog" accesskey="o"><span class="vanilla__button-icon" aria-hidden="true">bookmarks</span><span aria-hidden="true" class="vanilla__button-label">Bookmarks</span></button>
                <button id="vanilla-reader__menu__button-highlights" title="Open highlights dialog" accesskey="h"><span class="vanilla__button-icon" aria-hidden="true">edit_note</span><span aria-hidden="true" class="vanilla__button-label">Highlights</span></button>
                <button id="vanilla-reader__menu__button-bookmark-readingposition" title="Bookmark current position" accesskey="b"><span class="vanilla__button-icon" aria-hidden="true">bookmark_add</span><span aria-hidden="true" class="vanilla__button-label">Add Bookmark</span></button>
                <button id="vanilla-reader__menu__button-readaloud-show" title="Show read aloud controls" accesskey="r"><span class="vanilla__button-icon" aria-hidden="true">hearing</span><span aria-hidden="true" class="vanilla__button-label">Read Aloud</span></button>
                <button id="vanilla-reader__menu__button-readaloud-hide" title="Show read aloud controls"><span class="vanilla__button-icon" aria-hidden="true">hearing_disabled</span><span aria-hidden="true" class="vanilla__button-label">Read Aloud</span></button>
                <button id="vanilla-reader__menu__button-panzoom-activate" title="Activate Pan and Zoom mode"><span class="vanilla__button-icon" aria-hidden="true">zoom_in</span><span aria-hidden="true" class="vanilla__button-label">Zoom</span></button>
                <button id="vanilla-reader__menu__button-panzoom-deactivate" title="Exit Pan and Zoom mode"><span class="vanilla__button-icon" aria-hidden="true">zoom_out_map</span><span aria-hidden="true" class="vanilla__button-label">Exit Zoom</span></button>
                <!--<button id="vanilla-reader__menu__button-ruler-activate" title="Activate Reading Ruler"><span class="vanilla__button-icon" aria-hidden="true">straighten</span><span aria-hidden="true" class="vanilla__button-label">Ruler (Beta)</span></button>
                <button id="vanilla-reader__menu__button-ruler-deactivate" title="Deactivate Reading Ruler"><span class="vanilla__button-icon" aria-hidden="true">straighten</span><span aria-hidden="true" class="vanilla__button-label">Hide ruler</span></button>-->                
                <button id="vanilla-reader__menu__button-search" title="Search book" accesskey="s"><span class="vanilla__button-icon" aria-hidden="true">search</span><span aria-hidden="true" class="vanilla__button-label">Search</span></button>
                <button id="vanilla-reader__menu__button-settings" title="Open settings dialog" accesskey="t"><span class="vanilla__button-icon" aria-hidden="true">settings</span><span aria-hidden="true" class="vanilla__button-label">Settings</span></button>
            </div>
        </nav>`;
        this._event_menu_keyup = (ev)=>{
            switch(ev.key){
                case "Escape":
                    this.hide();
                    break;
            }
        };
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._hostDocument = _hostElement.ownerDocument;
        this._menu = this._hostDocument.getElementById("vanilla-reader__menu");
        this._menu.insertAdjacentHTML("afterbegin", this._style);
        this._buttonMenuHandle = this._hostDocument.getElementById("vanilla-reader__menu__button-handle");
        this._buttonHelp = this._hostDocument.getElementById("vanilla-reader__menu__button-help");
        //this._buttonFile = this._hostDocument.getElementById('vanilla-reader__menu__button-file')!;
        this._buttonToc = this._hostDocument.getElementById("vanilla-reader__menu__button-toc");
        this._buttonBookmarks = this._hostDocument.getElementById("vanilla-reader__menu__button-bookmarks");
        this._buttonHighlights = this._hostDocument.getElementById("vanilla-reader__menu__button-highlights");
        this._buttonSettings = this._hostDocument.getElementById("vanilla-reader__menu__button-settings");
        this._buttonBookmarkReadingPosition = this._hostDocument.getElementById("vanilla-reader__menu__button-bookmark-readingposition");
        this._buttonReadAloudOpen = this._hostDocument.getElementById("vanilla-reader__menu__button-readaloud-show");
        this._buttonReadAloudClose = this._hostDocument.getElementById("vanilla-reader__menu__button-readaloud-hide");
        this._buttonSearch = this._hostDocument.getElementById("vanilla-reader__menu__button-search");
        this._buttonPanZoomActivate = this._hostDocument.getElementById("vanilla-reader__menu__button-panzoom-activate");
        this._buttonPanZoomDeactivate = this._hostDocument.getElementById("vanilla-reader__menu__button-panzoom-deactivate");
        //this._buttonRulerActivate = this._hostDocument.getElementById('vanilla-reader__menu__button-ruler-activate')!;
        //this._buttonRulerDeactivate = this._hostDocument.getElementById('vanilla-reader__menu__button-ruler-deactivate')!;
        this._buttonNavigationHistory = this._hostDocument.getElementById("vanilla-reader__menu__button-navigation-history");
        this._menu.addEventListener("keyup", this._event_menu_keyup);
        this._menu.inert = true;
        // Ok, we have references to all the menu component's HTML elements. Now let's setup various behaviours such as
        // event listeners.
        this._setup();
    }
    onMenuHandleSwipeDown(callback) {
        this._swipeDownCallback = callback;
    }
    onHelpOpen(callback) {
        this._openHelpDialogCallback = callback;
    }
    onMenuHandleClicked(callback) {
        this._menuHandleClickedCallback = callback;
    }
    /*onFileOpen(callback: VanillaVoidCallback): void {
        this._fileOpenCallback = callback;
    }*/ onContentsOpen(callback) {
        this._contentsDialogOpenCallback = callback;
    }
    onMenuVisible(callback) {
        this._visibleCallback = callback;
    }
    onMenuHidden(callback) {
        this._hiddenCallback = callback;
    }
    onBookmarkReadingPosition(callback) {
        this._bookmarkReadingPositionIntentCallback = callback;
    }
    onReadAloudControlsOpen(callback) {
        this._showReadAloudControlsCallback = callback;
    }
    onReadAloudControlsClose(callback) {
        this._hideReadAloudControlsCallback = callback;
    }
    onPanZoomActivate(callback) {
        this._panZoomActivateCallback = callback;
    }
    onPanZoomDeactivate(callback) {
        this._panZoomDeactivateCallback = callback;
    }
    onPublicationSearch(callback) {
        this._searchPublicationCallback = callback;
    }
    /*onReadingRulerShow(callback: VanillaVoidCallback): void {
        this._readingRulerActivateCallback = callback;
    }

    onReadingRulerHide(callback: VanillaVoidCallback): void {
        this._readingRulerDeactivateCallback = callback;
    }*/ onNavigationHistoryShow(callback) {
        this._showNavigationHistoryCallback = callback;
    }
    getComponentElement() {
        return this._hostDocument.getElementById("vanilla-reader__menu");
    }
    getMediaPlayerContainerElement() {
        return this._hostDocument.getElementById("vanilla-reader__menu__mediaplayer-container");
    }
    getProgressionSliderContainerElement() {
        return this._hostDocument.getElementById("vanilla-reader__menu__slider-container");
    }
    setAsImportantForAccessibility() {
        this._menu.removeAttribute("aria-hidden");
    }
    setAsNotImportantForAccessibility() {
        this._menu.setAttribute("aria-hidden", "true");
    }
    get isVisible() {
        return this._menu.style.opacity === "1";
    }
    show(animate = true) {
        if (!animate) this._menu.style.transition = "opacity 0.2s ease-out";
        else this._menu.style.transition = "bottom 0.2s ease-out";
        this._toggleMenuButtonsKeyboardFocusable(true);
        this.getProgressionSliderContainerElement().tabIndex = 0;
        this.getProgressionSliderContainerElement().inert = false;
        this.getMediaPlayerContainerElement().inert = false;
        this._menu.tabIndex = 0;
        this._menu.inert = false;
        this._menu.style.opacity = "1";
        this._menu.style.bottom = "0";
        this._focusTrap = (0, $282b77e844ac66e5$export$360440dfcba94c00)(this._menu, {
            allowOutsideClick: true,
            escapeDeactivates: false,
            returnFocusOnDeactivate: true
        });
        this._focusTrap.activate();
        // Wait until just a bit before turning on events and calling the callback function.
        window.setTimeout(()=>{
            this._menu.style.pointerEvents = "auto";
            if (this._visibleCallback) this._visibleCallback();
        }, 500);
    }
    hide(animate = true, silent = false) {
        if (!animate) this._menu.style.transition = "opacity 0.2s ease-out";
        else this._menu.style.transition = "bottom 0.2s ease-out";
        this._menu.tabIndex = -1;
        this.getProgressionSliderContainerElement().tabIndex = -1;
        this.getProgressionSliderContainerElement().inert = true;
        this.getMediaPlayerContainerElement().inert = true;
        this._toggleMenuButtonsKeyboardFocusable(false);
        this._menu.inert = true;
        this._menu.style.pointerEvents = "none";
        this._menu.style.bottom = `${-(this._menu.clientHeight + 16)}px`;
        // Wait for the animation to finish before calling callback method etc.
        window.setTimeout(()=>{
            this._menu.style.opacity = "0";
            if (this._focusTrap) {
                let options = {
                    returnFocus: false
                };
                try {
                    this._focusTrap.deactivate(options);
                } catch (e) {}
            }
            if (this._hiddenCallback) this._hiddenCallback("menu", silent);
        }, 400);
    }
    toggleReadAloudButtonState(on) {
        if (on) {
            this._buttonReadAloudClose.style.display = "flex";
            this._buttonReadAloudOpen.style.display = "none";
        } else {
            this._buttonReadAloudOpen.style.display = "flex";
            this._buttonReadAloudClose.style.display = "none";
        }
    }
    togglePanZoomButtonState(on) {
        if (on) {
            this._buttonPanZoomDeactivate.style.display = "flex";
            this._buttonPanZoomActivate.style.display = "none";
        } else {
            this._buttonPanZoomActivate.style.display = "flex";
            this._buttonPanZoomDeactivate.style.display = "none";
        }
    }
    /*toggleRulerButtonState(on: boolean): void {
        if (on) {
            this._buttonRulerDeactivate.style.display = 'flex';
            this._buttonRulerActivate.style.display = 'none';
        } else {
            this._buttonRulerActivate.style.display = 'flex';
            this._buttonRulerDeactivate.style.display = 'none';
        }
    }*/ /*
    *
    * PRIVATE METHODS
    *
    * */ _setup() {
        this.hide();
        this._buttonMenuHandle.addEventListener("click", (_ev)=>{
            if (this._menuHandleClickedCallback) this._menuHandleClickedCallback();
        });
        this._buttonMenuHandle.addEventListener("touchstart", (ev)=>{
            this._touchEventCoords = [
                ev.changedTouches[0].clientX,
                ev.changedTouches[0].clientY
            ];
        });
        this._buttonMenuHandle.addEventListener("touchend", (ev)=>{
            if (this._touchEventCoords && this._touchEventCoords[1] - ev.changedTouches[0].clientY <= -96) {
                if (this._swipeDownCallback) this._swipeDownCallback();
            }
        });
        /*this._buttonFile.addEventListener('click', (_ev) => {
            if (this._fileOpenCallback) {
                this._fileOpenCallback();
            }
        });*/ this._buttonBookmarks.addEventListener("click", (_ev)=>{
            if (!this._hostContext.dialogBookmarks?.isOpen()) this._hostContext.dialogBookmarks?.show();
            else this._hostContext.dialogBookmarks?.close();
        });
        this._buttonHighlights.addEventListener("click", (_ev)=>{
            if (!this._hostContext.dialogHighlights?.isOpen()) this._hostContext.dialogHighlights?.show();
            else this._hostContext.dialogHighlights?.close();
        });
        this._buttonSettings.addEventListener("click", (_ev)=>{
            if (this._hostContext.dialogSettings?.isOpen()) this._hostContext.dialogSettings.close();
            else this._hostContext.dialogSettings?.show();
        });
        this._buttonBookmarkReadingPosition.addEventListener("click", (_ev)=>{
            if (this._bookmarkReadingPositionIntentCallback) this._bookmarkReadingPositionIntentCallback();
        });
        this._buttonReadAloudOpen.addEventListener("click", (_ev)=>{
            // Toggle the show/hide button-pair state
            this._buttonReadAloudOpen.style.display = "none";
            this._buttonReadAloudClose.style.display = "flex";
            if (this._showReadAloudControlsCallback) this._showReadAloudControlsCallback();
        });
        this._buttonReadAloudClose.addEventListener("click", (_ev)=>{
            // Toggle the show/hide button-pair state
            this._buttonReadAloudClose.style.display = "none";
            this._buttonReadAloudOpen.style.display = "flex";
            if (this._hideReadAloudControlsCallback) this._hideReadAloudControlsCallback();
        });
        this._buttonSearch.addEventListener("click", (_ev)=>{
            if (this._searchPublicationCallback) this._searchPublicationCallback();
        });
        this._buttonHelp.addEventListener("click", (_ev)=>{
            if (this._openHelpDialogCallback) this._openHelpDialogCallback();
        });
        this._buttonToc.addEventListener("click", (ev)=>{
            // This event must be prevented from propagation to not fire a click
            // on the selected navigation item in the contents dialog, if that
            // item has received focus before the callback has run.
            ev.stopImmediatePropagation();
            ev.preventDefault();
            ev.cancelBubble = true;
            if (this._contentsDialogOpenCallback) this._contentsDialogOpenCallback();
        });
        if (this._sliderProgression) this._sliderProgression.disabled = true;
        if (this._enablePanZoomButton) {
            this._buttonPanZoomActivate.addEventListener("click", (_ev)=>{
                this._buttonPanZoomActivate.style.display = "none";
                this._buttonPanZoomDeactivate.style.display = "flex";
                if (this._panZoomActivateCallback) this._panZoomActivateCallback();
            });
            this._buttonPanZoomDeactivate.addEventListener("click", (_ev)=>{
                this._buttonPanZoomDeactivate.style.display = "none";
                this._buttonPanZoomActivate.style.display = "flex";
                if (this._panZoomDeactivateCallback) this._panZoomDeactivateCallback();
            });
        } else this._buttonPanZoomActivate.style.display = "none";
        this._buttonPanZoomDeactivate.style.display = "none";
        /*this._buttonRulerActivate.addEventListener('click', (_ev) => {
            this._buttonRulerActivate.style.display = 'none';
            this._buttonRulerDeactivate.style.display = 'flex';

            if (this._readingRulerActivateCallback) {
                this._readingRulerActivateCallback();
            }
        });

        this._buttonRulerDeactivate.addEventListener('click', (_ev) => {
            this._buttonRulerDeactivate.style.display = 'none';
            this._buttonRulerActivate.style.display = 'flex';

            if (this._readingRulerDeactivateCallback) {
                this._readingRulerDeactivateCallback();
            }
        });

        this._buttonRulerDeactivate.style.display = 'none';*/ this._buttonNavigationHistory.addEventListener("click", (_ev)=>{
            if (this._showNavigationHistoryCallback) this._showNavigationHistoryCallback();
        });
    }
    _toggleMenuButtonsKeyboardFocusable(focusable) {
        let tabIndex = 0;
        if (!focusable) tabIndex = -1;
        this._menu.querySelectorAll("button").forEach((button)=>button.tabIndex = tabIndex);
    }
}


class $bca7dcbc805ee09c$export$9149414ff58ba915 {
    constructor(_hostElement, insertPosition = "beforeend"){
        this._hostElement = _hostElement;
        this._currentToasts = new Set();
        this._template = `<section id="vanilla-reader-ui__toast-container"></section>`;
        this._style = `
    <style>
         #vanilla-reader-ui__toast-container {
              position: fixed;
              z-index: 500;       
              inset-block-end: 0;
              inset-inline: 0;
              padding-block-end: 5vh;
            
              display: grid;
              justify-items: center;
              justify-content: center;
              gap: 1vh;
            
              pointer-events: none;
        }
        
        .vanilla-reader-ui__toast {
          --_duration: 3s;
          --_bg-lightness: 90%;
          --_travel-distance: 0;
        
          font-family: system-ui, sans-serif;
          color: var(--vanilla-reader__color__ui__foreground-light);
          background: var(--vanilla-reader__color__ui__background-dark);
          opacity: 0.9;
          
          max-inline-size: min(25ch, 90vw);
          padding: 2em;
          padding-block: 1.5ch 1.5ch;
          padding-inline: 1.5ch;
          border-radius: 6px;
          font-size: 1rem;          
          word-break: break-word; 
           
          will-change: transform;
        
          @media (prefers-color-scheme: dark) {
            color: white;
            --_bg-lightness: 20%;
          }
        
          @media (prefers-reduced-motion: no-preference) {
            --_travel-distance: 5vh;
          }
        }
        
        @keyframes fade-in {
          from { opacity: 0 }
        }
        
        @keyframes fade-out {
          to { opacity: 0 }
        }
        
        @keyframes slide-in {
          from { transform: translateY(var(--_travel-distance, 10px)) }
        }
    </style>`;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._toastContainer = this._hostElement.querySelector("#vanilla-reader-ui__toast-container");
        this._toastContainer.insertAdjacentHTML("afterbegin", this._style);
    }
    _createToast(text, assertive = false, timeout) {
        const node = document.createElement("output");
        node.innerText = text;
        node.classList.add("vanilla-reader-ui__toast");
        node.setAttribute("role", "status");
        node.setAttribute("aria-live", "polite");
        node.style.animation = `fade-in .3s ease, slide-in .3s ease, fade-out .3s ease ${timeout}ms`;
        if (assertive) {
            node.setAttribute("role", "alert");
            node.setAttribute("aria-live", "assertive");
        }
        return node;
    }
    _addToast(toast) {
        const { matches: motionOK } = window.matchMedia("(prefers-reduced-motion: no-preference)");
        this._toastContainer.children.length && motionOK ? this._flipToast(toast) : this._toastContainer.appendChild(toast);
    }
    toast(text, assertive = false, timeoutMs = 3000) {
        let toastData = {
            text: text,
            assertive: assertive,
            timeout: timeoutMs
        };
        let isDuplicate = false;
        this._currentToasts.forEach((toast)=>{
            if (toast.text === text) isDuplicate = true;
        });
        if (isDuplicate) return Promise.resolve();
        let toast = this._createToast(text, assertive, timeoutMs);
        this._addToast(toast);
        this._currentToasts.add(toastData);
        return new Promise(async (resolve)=>{
            // @ts-ignore
            await Promise.allSettled(toast.getAnimations().map((animation)=>animation.finished));
            this._toastContainer.removeChild(toast);
            this._currentToasts.delete(toastData);
            resolve();
        });
    }
    // https://aerotwist.com/blog/flip-your-animations/
    _flipToast(toast) {
        // FIRST
        const first = this._toastContainer.offsetHeight;
        // add new child to change container size
        this._toastContainer.appendChild(toast);
        // LAST
        const last = this._toastContainer.offsetHeight;
        // INVERT
        const invert = last - first;
        // PLAY
        const animation = this._toastContainer.animate([
            {
                transform: `translateY(${invert}px)`
            },
            {
                transform: "translateY(0)"
            }
        ], {
            duration: 150,
            easing: "ease-out"
        });
        animation.startTime = document.timeline.currentTime;
    }
}





const $7e547761815b3149$export$5145047f44d7dabf = [
    {
        id: Date.now().toString(),
        textContent: "Where am I?",
        data: {
            name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).WHERE_AM_I
        },
        children: []
    },
    {
        id: Date.now().toString(),
        textContent: "Open Table of Contents",
        data: {
            name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).TOC_OPEN_DIALOG
        },
        children: []
    },
    // Navigation actions
    {
        id: Date.now().toString(),
        data: undefined,
        textContent: "Navigation actions",
        children: [
            {
                id: Date.now().toString(),
                textContent: "Next book section",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Previous book section",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Next heading",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT_HEADING
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Previous heading",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS_HEADING
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Go to location number",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).GOTO_PAGE_DIALOG_OPEN
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Open navigation history",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATION_HISTORY_DIALOG_OPEN
                },
                children: []
            }
        ]
    },
    // Highlighting actions
    {
        id: Date.now().toString(),
        data: undefined,
        textContent: "Highlight actions",
        children: [
            {
                id: Date.now().toString(),
                textContent: "Highlight active paragraph",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_READING_POSITION
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Highlight clipboard contents",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_CLIPBOARD
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Show all highlights",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ALL
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Show active highlights",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ACTIVE
                },
                children: []
            }
        ]
    },
    // Bookmarking actions
    {
        id: Date.now().toString(),
        data: undefined,
        textContent: "Bookmark actions",
        children: [
            {
                id: Date.now().toString(),
                textContent: "Bookmark active paragraph",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_READING_POSITION
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Bookmark clipboard contents",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_CLIPBOARD
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Show all bookmarks",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ALL
                },
                children: []
            },
            {
                id: Date.now().toString(),
                textContent: "Show active bookmarks",
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ACTIVE
                },
                children: []
            }
        ]
    },
    // Search actions
    {
        textContent: "Book search",
        children: [
            {
                textContent: "Open search dialog",
                children: [],
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_DIALOG_OPEN
                },
                id: Date.now().toString()
            },
            {
                textContent: "Clear search",
                children: [],
                data: {
                    name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_CLEAR
                },
                id: Date.now().toString()
            }
        ],
        data: undefined,
        id: Date.now().toString()
    },
    {
        id: Date.now().toString(),
        textContent: "Exit to bookshelf",
        data: {
            name: (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKSHELF_DIALOG_OPEN
        },
        children: []
    }
];


class $8dee3d7d4253f169$export$b8371b45619761cf extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(_hostElement, _insertPosition = "afterbegin"){
        super(_hostElement, "vanilla-reader__dialog-ui-actions", "App actions", _insertPosition);
        this._actionItemClickedCallback = undefined;
        this._treeViewActions = undefined;
        this._bodyStyle = `
        <style>
            
            #vanilla-reader__dialog-ui-actions__list ul[role=tree] {
                padding-left: 0;
                list-style: none;
            }
                        
            #vanilla-reader__dialog-ui-actions__list ul[role=tree] button {
                font-size: x-large;
                margin-left: 0;
            }

            #vanilla-reader__dialog-ui-actions__list ul[role=group] {
                padding-left: 1em;
                list-style: none;
            }
            
            #vanilla-reader__dialog-ui-actions__list ul[role=group] li:not([data-treeview-role=group]) {
               margin-left: 1em;
            }
            
            #vanilla-reader__dialog-ui-actions__list li {
                align-items: center;
            }

            #vanilla-reader__dialog-ui-actions__list li a {
                max-width: 70%;
            }

            #vanilla-reader__dialog-ui-actions__list li[aria-selected=true] {
                text-decoration: underline;
            }
            
            #vanilla-reader__dialog-ui-actions__list li[aria-expanded=true] ul {
                border-left: 1px dotted var(--vanilla-reader__color__ui__outline-dark);
            }
            
            #vanilla-reader__dialog-ui-actions__form-search {
                display: flex;
            }
            
            #vanilla-reader__dialog-ui-actions__input-search {
                flex-grow: 1;
            }

        </style>`;
        this._bodyTemplate = `
        <form id="vanilla-reader__dialog-ui-actions__form-search">                   
            <input type="search" name="input-search" placeholder="Search for action" list="vanilla-reader__dialog-ui-actions__datalist" id="vanilla-reader__dialog-ui-actions__input-search">
            <button id="vanilla-reader__dialog-ui-actions__button-search" aria-label="Do search" title="Do search"><span class="vanilla__button-icon" aria-hidden="true">search</span></button>
            <datalist id="vanilla-reader__dialog-ui-actions__datalist"></datalist>
        </form>        
        <section id="vanilla-reader__dialog-ui-actions__list"></section>`;
        this._onActionSearchSubmitted = (ev)=>{
            ev.preventDefault();
            if (this._actionItemClickedCallback && this._inputSearchActions.value) {
                let actionCommand;
                actionCommand = this._actionListFlat?.find((itemData)=>{
                    return itemData.textContent === this._inputSearchActions.value;
                });
                if (actionCommand && actionCommand.data) this._actionItemClickedCallback(actionCommand.data.name);
            }
            return false;
        };
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._dialogElement.insertAdjacentHTML("afterbegin", this._bodyStyle);
        this._formSearchActions = this._dialogElement.querySelector("#vanilla-reader__dialog-ui-actions__form-search");
        this._actionsListElement = this._dialogElement.querySelector("#vanilla-reader__dialog-ui-actions__list");
        this._dataListActions = this._dialogElement.querySelector("#vanilla-reader__dialog-ui-actions__datalist");
        this._inputSearchActions = this._dialogElement.querySelector("#vanilla-reader__dialog-ui-actions__input-search");
        this._inputSearchActions.ariaLabel = `
            Search app actions. As you type, results will appear in an options list below the input field. 
            Press Shift + the Down Arrow key to step through the result list."`;
        this._formSearchActions.onsubmit = this._onActionSearchSubmitted;
        this._actionListFlat = [];
        this.populate();
    }
    show(silent = false, returnFocusOnClose = true, onDialogCloseCallbackOverride, collapseAll = true) {
        super.show(silent, returnFocusOnClose, onDialogCloseCallbackOverride);
        if (collapseAll) this._treeViewActions?.collapseAll();
    }
    close(silent = false, returnDialogResult = true) {
        silent = true;
        super.close(silent, returnDialogResult);
        this._inputSearchActions.value = "";
    }
    onActionItemClicked(callback) {
        this._actionItemClickedCallback = callback;
    }
    populate() {
        this._actionListFlat = (0, $7e547761815b3149$export$5145047f44d7dabf).flatMap((item)=>{
            return [
                item,
                ...item.children
            ];
        });
        for (let item of this._actionListFlat)if (item.data) {
            let optionElement = document.createElement("option");
            optionElement.text = item.textContent;
            optionElement.setAttribute("data-action-id", item.id);
            optionElement.setAttribute("data-action-name", item.data?.name || "");
            this._dataListActions.appendChild(optionElement);
        }
        this._treeViewActions = new (0, $12a4e63b52eb779b$export$6940b0d9c820eca7)(this._actionsListElement, (0, $7e547761815b3149$export$5145047f44d7dabf));
        this._treeViewActions.cssClassName = "vanilla-reader__dialog-ui-actions-list";
        this._treeViewActions.addItemClickEventHandler((actionItem)=>{
            if (this._actionItemClickedCallback && actionItem.data) this._actionItemClickedCallback(actionItem.data.name);
            else {
                let treeViewItem = this._treeViewActions?.treeViewItemDataToTreeViewItemMap.get(actionItem);
                if (treeViewItem) treeViewItem.setIsExpanded(!treeViewItem.getIsExpanded());
            }
        });
        this._treeViewActions.render();
    }
    empty() {
        if (this._treeViewActions) this._treeViewActions.destroy();
    }
}





class $9da9a5d1a2c3c19f$export$499c73363e921e89 {
    _handleKeyboardShortcut(key, altKeyPressed, shiftKeyPressed, _ctrlKeyPressed) {
        // Get the user defined key mapping for this key
        let keyCommand = this._resolveUiActionKeyCommand(key, shiftKeyPressed);
        if (!keyCommand) return;
        // We do allow ArrowLeft and ArrowRight navigation without the Alt modifier key pressed.
        switch(key){
            case "ArrowLeft":
                if (this.activeDialogTitle === undefined) this.navigatePrevious();
                return;
            case "ArrowRight":
                if (this.activeDialogTitle === undefined) this.navigateNext();
                return;
        }
        switch(key){
            case "ArrowUp":
                if (this.readingRuler.snapToContentLineBoxes && this.activeDialogTitle === undefined) {
                    if (this.readingRuler?.isVisible) {
                        if (!this.readingRuler.isAtStartOfContent) this.readingRuler.moveToPreviousContentLineBox(!this.useReducedMotion);
                        else this.navigatePrevious();
                    }
                } else console.warn("VanillaReaderUiKeyboardShortcutController", "Unable to move reading ruler as a dialog is open");
                break;
            case "ArrowDown":
                if (this.readingRuler.snapToContentLineBoxes && this.activeDialogTitle === undefined) {
                    if (this.readingRuler?.isVisible) {
                        if (!this.readingRuler.isAtEndOfContent) this.readingRuler.moveToNextContentLineBox(!this.useReducedMotion);
                        else this.navigateNext();
                    }
                } else console.warn("VanillaReaderUiKeyboardShortcutController", "Unable to move reading ruler as a dialog is open");
                break;
        }
        // The Alt key needs to be pressed for this event to be considered a valid keyboard action.
        if (!altKeyPressed) return;
        switch(keyCommand.actionName){
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS:
                if (this.activeDialogTitle === undefined) this.navigatePrevious();
                else console.warn("VanillaReaderUiKeyboardShortcutController", "Unable to navigate as a dialog is open");
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT:
                if (this.activeDialogTitle === undefined) this.navigateNext();
                else console.warn("VanillaReaderUiKeyboardShortcutController", "Unable to navigate as a dialog is open");
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT_HEADING:
                this.navigateToNextHeading();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS_HEADING:
                this.navigateToPreviousHeading();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MAIN_MENU_OPEN:
                this.menuBottom.show(!this.useReducedMotion);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_DIALOG_OPEN:
                // If we have an active selection we use this text to populate the search input.
                if (this.activeSelection?.selectionText) this.dialogSearch.setSearchTerm(this.activeSelection.selectionText);
                this.dialogSearch.show(false, false, undefined, this.latestSelectedSearchResultLocator);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_CLEAR:
                this.dialogSearch.clear();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_READING_POSITION:
                this.bookmarkReadingPosition();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_CLIPBOARD:
                this.bookmarkClipboardContents().catch(console.warn);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).TOC_OPEN_DIALOG:
                this.dialogContents.show(false, true);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_DIALOG_OPEN:
                this.dialogSettings.show(false, true);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_RESET:
                this.dialogSettings.resetToDefault();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKSHELF_DIALOG_OPEN:
                this.closePublicationAndShowFileOpenDialog();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION:
                this.closeAllDialogsAndFocusOnReadingPosition();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ALL:
                this.dialogBookmarks.show(false, true);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ACTIVE:
                this.dialogBookmarks.show(false, true, undefined, true);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ALL:
                this.dialogHighlights.show(false, true);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ACTIVE:
                this.dialogHighlights.show(false, true, undefined, true);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HELP_DIALOG_OPEN:
                this.dialogHelp.show(false, false);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_SELECTION:
                this.showHighlightDialogWithActiveSelectionState();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_CLIPBOARD:
                this.highlightClipboardContents().catch(console.warn);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).WHERE_AM_I:
                this.toastReadingPosition().catch(console.warn);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_START:
                this.openMediaPlayer(true);
                this.startMediaPlayer();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_STOP:
                this.closeMediaPlayer();
                this.focusOnReadingPosition();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_ESCAPE_ACTIVE_SEGMENT:
                this.escapeActiveSegment();
                this.focusOnReadingPosition();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_ESCAPE_ALL:
                this.escapeAll();
                this.focusOnReadingPosition();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_SKIP_FORWARD:
                this.seekNext();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_SKIP_BACKWARD:
                this.seekPrevious();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_ENTER:
                this.enterAccessibilityMode();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_EXIT:
                this.exitAccessibilityMode();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).GOTO_PAGE_DIALOG_OPEN:
                this.showGoToPagePrompt();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACTIONS_MENU_OPEN:
                this.dialogUiActions.show(true, true, undefined, true);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_TOOL_ACTIVATE:
                this.activatePanZoomTool();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_TOOL_DEACTIVATE:
                this.deactivatePanZoomTool();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_OUT:
                if (this.isReaderViewIsInPanZoomMode) this.zoomToLevel(0.8);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_IN:
                this.zoomToLevel(1.2);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_ACTIVATE:
                this.showReadingRuler();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_DEACTIVATE:
                this.hideReadingRuler();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_MOVE_NEXT:
                this.moveReadingRulerToNextContentLineBox();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_MOVE_PREVIOUS:
                this.moveReadingRulerToPreviousContentLineBox();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATION_HISTORY_DIALOG_OPEN:
                this.dialogNavigationHistory.show();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).LANDMARKS_DIALOG_OPEN:
                if (this.publicationHeadingLandmarks) this.showLandmarksDialog();
                break;
        }
    }
    /*
    * This method looks up the action that should be triggered for the specified key. Key mappings can be changed and
    * persisted by updating `IVanillaReaderUiActionKeyCommand` items the `VanillaReaderAppUiDefaults.options.uIActionKeyCommands`
    * array.
    * */ _resolveUiActionKeyCommand(key, shiftKeyPressed) {
        return (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.uIActionKeyCommands?.find((keyCommand)=>{
            let keyCommandFound = keyCommand.key === key;
            if (keyCommandFound && shiftKeyPressed) keyCommandFound = keyCommand.modifiers.includes((0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Shift);
            return keyCommandFound;
        });
    }
}


class $2543dc836a5b86e1$export$fd8a872ef991911c {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.menuMediaPlayer.onOpened(vanillaReaderUiContext._onMenuMediaPlayerOpened.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuMediaPlayer.onClosed(vanillaReaderUiContext._onMenuMediaPlayerClosed.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuMediaPlayer.onPlay(vanillaReaderUiContext._onMenuMediaPlayerPlayIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuMediaPlayer.onPause(vanillaReaderUiContext._onMenuMediaPlayerPauseIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuMediaPlayer.onSeekNext(vanillaReaderUiContext._onMenuMediaPlayerSeekNextIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuMediaPlayer.onSeekPrevious(vanillaReaderUiContext._onMenuMediaPlayerPreviousIntent.bind(vanillaReaderUiContext));
    }
    startPlayback(locator) {
        this.vanillaReaderAPI?.startMediaPlayback(locator);
    }
    pausePlayback() {
        this.vanillaReaderAPI?.pauseMediaPlayback();
    }
    escapeActiveSegment() {
        let contextPathArrayLength = this.mediaPlayerEscapabilityContext.length;
        if (contextPathArrayLength > 0) {
            let previousPathIndex = contextPathArrayLength > 1 ? contextPathArrayLength - 1 : 0;
            this.seekToLocator(this.mediaPlayerEscapabilityContext[previousPathIndex].blockEndLocator);
        }
    }
    escapeAll() {
        let contextPathArrayLength = this.mediaPlayerEscapabilityContext.length;
        if (contextPathArrayLength > 0) this.seekToLocator(this.mediaPlayerEscapabilityContext[0].blockEndLocator);
    }
    seekNext() {
        this.vanillaReaderAPI?.seekMediaPlaybackNext();
    }
    seekPrevious() {
        this.vanillaReaderAPI?.seekMediaPlaybackPrevious();
    }
    seekForward() {
        this.vanillaReaderAPI?.seekMediaPlaybackForward();
    }
    seekBackward() {
        this.vanillaReaderAPI?.seekMediaPlaybackBackward();
    }
    seekToLocator(locator) {
        this.vanillaReaderAPI?.seekMediaToLocator(locator);
    }
    seekToLocatorWithinVisibleRange(locator) {
        this.vanillaReaderAPI?.seekMediaToLocatorWithinVisibleRange(locator);
    }
    setPlaybackRate(rate) {
        this.vanillaReaderAPI?.setMediaPlaybackRate(rate);
    }
    setPlaybackVolume(volume) {
        this.vanillaReaderAPI?.setMediaPlaybackVolume(volume);
    }
    setTtsVoice(voiceName) {
        this.vanillaReaderAPI?.setTtsVoice(voiceName);
    }
    togglePlayback(activate) {
        this.vanillaReaderAPI?.toggleMediaPlayer(activate, {
            rate: this.dialogSettings.activePlaybackRateOption
        });
    }
    _onMenuMediaPlayerOpened() {
        this.fabMediaPlayer.stateIsPlaying = false;
        this.fabMediaPlayer.show();
        this.togglePlayback(true);
        // Save the updated option value
        let updatedUiOptions = this.serializeToUiOptionsData();
        this.vanillaReaderOptionsDataStore.setVanillaReaderUiOptionsData(updatedUiOptions).catch(console.warn);
    }
    _onMenuMediaPlayerClosed() {
        this.fabMediaPlayer.stateIsPlaying = false;
        this.fabMediaPlayer.hide();
        this.togglePlayback(false);
        // Save the updated option value
        let updatedUiOptions = this.serializeToUiOptionsData();
        this.vanillaReaderOptionsDataStore.setVanillaReaderUiOptionsData(updatedUiOptions).catch(console.warn);
    }
    _onMenuMediaPlayerPlayIntent(locator) {
        this.startPlayback(locator);
    }
    _onMenuMediaPlayerPauseIntent() {
        this.pausePlayback();
    }
    _onMenuMediaPlayerSeekNextIntent() {
        this.seekNext();
    }
    _onMenuMediaPlayerPreviousIntent() {
        this.seekPrevious();
    }
    _onMediaPlayerIsReadyToPlay() {
        this.menuMediaPlayer.enable();
        if (this.menuMediaPlayer.isOpen() && this.mediaPlayerShouldStartPlaybackWhenReady) this._onMenuMediaPlayerPlayIntent();
    }
}


class $db7d3271244acdbe$export$58bc822c137e4e45 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.menuBottom.onMenuHandleClicked(vanillaReaderUiContext._onMenuBottomHandleClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onMenuHandleSwipeDown(vanillaReaderUiContext._onMenuBottomHandleClicked.bind(vanillaReaderUiContext));
        //vanillaReaderUiContext.menuBottom.onFileOpen(vanillaReaderUiContext._onMenuBottomFileOpenAction.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onPublicationSearch(vanillaReaderUiContext._onMenuBottomPublicationSearch.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onBookmarkReadingPosition(vanillaReaderUiContext._onMenuBottomBookmarkReadingPosition.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onMenuVisible(vanillaReaderUiContext._onMenuBottomVisible.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onMenuHidden(vanillaReaderUiContext._onMenuBottomHidden.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onHelpOpen(vanillaReaderUiContext._onMenuBottomHelpDialogOpen.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onContentsOpen(vanillaReaderUiContext._onMenuBottomContentsDialogOpen.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onReadAloudControlsOpen(vanillaReaderUiContext._onMenuBottomReadAloudControlsOpen.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onReadAloudControlsClose(vanillaReaderUiContext._onMenuBottomReadAloudControlsClose.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onPanZoomActivate(vanillaReaderUiContext._onPanZoomActivate.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onPanZoomDeactivate(vanillaReaderUiContext._onPanZoomDeactivate.bind(vanillaReaderUiContext));
        //vanillaReaderUiContext.menuBottom.onReadingRulerShow(vanillaReaderUiContext._onReadingRulerShow.bind(vanillaReaderUiContext));
        //vanillaReaderUiContext.menuBottom.onReadingRulerHide(vanillaReaderUiContext._onReadingRulerHide.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuBottom.onNavigationHistoryShow(vanillaReaderUiContext._onNavigationHistoryShow.bind(vanillaReaderUiContext));
    }
    _onMenuBottomPublicationSearch() {
        this.dialogSearch.show(false, true, undefined, this.latestSelectedSearchResultLocator);
    }
    _onMenuBottomHandleClicked() {
        this.menuBottom.hide(!this.useReducedMotion);
        this.toaster.toast("Menu closed").catch(console.warn);
    }
    _onMenuBottomFileOpenAction() {
        this.closePublicationAndShowFileOpenDialog();
    }
    _onMenuBottomBookmarkReadingPosition() {
        this.bookmarkReadingPosition();
    }
    _onMenuBottomVisible() {
        this.menuBottom.setAsImportantForAccessibility();
        // Let's make sure that the highlight button is not hidden below the menu
        let fabBottomOffset = 16;
        let fabButtonOffset = this.menuBottom.getComponentElement().getBoundingClientRect().height + fabBottomOffset + "px";
        this.vanillaReaderFabContainerElement.style.marginBottom = fabButtonOffset;
        this.setReaderViewAsNotImportantForAccessibility();
    }
    _onMenuBottomHidden() {
        this.menuBottom.setAsNotImportantForAccessibility();
        // Move the highlight button back to its original position
        this.vanillaReaderFabContainerElement.style.marginBottom = "0";
        this.setReaderViewAsImportantForAccessibility();
        this.focusOnReadingPosition();
    }
    _onMenuBottomHelpDialogOpen() {
        this.dialogHelp.show(!this.useReducedMotion);
    }
    _onMenuBottomContentsDialogOpen() {
        this.dialogContents.show();
    }
    _onMenuBottomReadAloudControlsOpen(startPlaybackWhenReady = false) {
        this.openMediaPlayer(startPlaybackWhenReady);
    }
    _onMenuBottomReadAloudControlsClose() {
        this.closeMediaPlayer();
    }
    _onPanZoomActivate() {
        this.activatePanZoomTool();
    }
    _onPanZoomDeactivate() {
        this.deactivatePanZoomTool();
    }
    _onReadingRulerShow() {
        this.showReadingRuler();
    }
    _onReadingRulerHide() {
        this.hideReadingRuler();
    }
    _onNavigationHistoryShow() {
        this.dialogNavigationHistory.show();
    }
}


class $a66d862f8e976b86$export$5f3d5fd85af6a906 {
    /*
    *
    * Media Session event setup to support background media playback actions from the lockscreen etc.
    * Works for Audiobooks and EPUBs that have Media Overlays.
    *
    * Check out the `_vanillaReaderEvent_mediaPlayerPlaybackStateChanged`, `_vanillaReaderEvent_mediaPlayerPlaybackPositionChanged` and
    * `_vanillaReaderEvent_mediaPlayerSeekCompleted` for more mediaSession related stuff.
    *
    * */ _setUpMediaSessionActionHandlers() {
        if (window.navigator.mediaSession) {
            window.navigator.mediaSession.setActionHandler("nexttrack", (_actionDetails)=>{
                this.seekNext();
            });
            window.navigator.mediaSession.setActionHandler("previoustrack", (_actionDetails)=>{
                this.seekPrevious();
            });
            window.navigator.mediaSession.setActionHandler("pause", (_actionDetails)=>{
                this.pausePlayback();
            });
            window.navigator.mediaSession.setActionHandler("play", (_actionDetails)=>{
                this.startPlayback();
            });
            window.navigator.mediaSession.setActionHandler("seekto", (actionDetails)=>{
                if (actionDetails.seekTime) {
                    let segmentStartOffset = this.latestSyncMediaPlaybackStateData?.segmentData?.segmentTimelineStartOffsetMs;
                    if (segmentStartOffset !== undefined) {
                        let seekTimeInSeconds = segmentStartOffset + actionDetails.seekTime * 1000;
                        this.navigateToTimelinePosition(seekTimeInSeconds);
                    }
                }
            });
            window.navigator.mediaSession.setActionHandler("seekforward", (_actionDetails)=>{
                this.seekForward();
            });
            window.navigator.mediaSession.setActionHandler("seekbackward", (_actionDetails)=>{
                this.seekBackward();
            });
        }
    }
    onMediaPlayerPlaybackPositionChanged(state) {
        if (state.segmentData?.approximateDurationMs !== undefined && state.positionWithinSegment !== undefined) {
            let positionInSeconds = state.positionWithinSegment / 1000;
            let durationInSeconds = state.segmentData?.approximateDurationMs / 1000;
            window.navigator.mediaSession.setPositionState({
                position: positionInSeconds,
                duration: durationInSeconds,
                playbackRate: state.rate
            });
        }
    }
    onMediaPlayerPlaybackStateChanged(state) {
        if (window.navigator.mediaSession) {
            let isPaused = state.isPaused || false;
            if (isPaused) window.navigator.mediaSession.playbackState = "paused";
            else window.navigator.mediaSession.playbackState = "playing";
        }
    }
    onMediaPlayerSeekCompleted(state) {
        let segmentTitle = state.navigationItems ? state.navigationItems[0].title : "Untitled";
        let artistMetadata = this.initialPublicationData?.metadata?.all.find((item)=>{
            return item.property.name === "author";
        });
        window.navigator.mediaSession.metadata = new MediaMetadata({
            title: segmentTitle,
            album: this.initialPublicationData?.title,
            artwork: [
                {
                    src: `data:;base64,${this.initialPublicationData?.coverImageAsBase64}`
                }
            ],
            artist: artistMetadata?.content.value || "Unknown"
        });
    }
}


class $9a25081f4659eac5$export$9d151eb701879eb8 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogHighlight.onHighlightAdd(vanillaReaderUiContext._onDialogHighlightAdd.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogHighlight.onHighlightDelete(vanillaReaderUiContext._onDialogHighlightDelete.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogHighlight.onHighlightUpdate(vanillaReaderUiContext._onDialogHighlightUpdate.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogHighlight.onGotoHighlightLocation(vanillaReaderUiContext._onDialogHighlightGoToLocation.bind(vanillaReaderUiContext));
    }
    _onDialogHighlightAdd(highlight) {
        this.vanillaReaderAPI?.addHighlight(highlight);
    }
    _onDialogHighlightDelete(highlight) {
        this.vanillaReaderAPI?.deleteHighlight(highlight.locator);
    }
    _onDialogHighlightUpdate(highlight) {
        this.vanillaReaderAPI?.updateHighlight(highlight);
    }
    _onDialogHighlightGoToLocation(locator) {
        this.dialogHighlight.close(true, false);
        this.navigateTo(locator);
    }
}


class $8f8efaba4b87e0ee$export$8316e76e4c7c0fc9 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogHighlights.onHighlightItemClicked(vanillaReaderUiContext._onDialogHighlightsItemClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogHighlights.onHighlightItemEditButtonClicked(vanillaReaderUiContext._onDialogHighlightsItemEditButtonClicked.bind(vanillaReaderUiContext));
    }
    _onDialogHighlightsItemClicked(navigationData) {
        if (navigationData.locator) this.navigateTo(navigationData.locator.toString());
        this.dialogHighlights?.close(true, false);
    }
    _onDialogHighlightsItemEditButtonClicked(highlight) {
        // If the highlight dialog was opened from the highlights list, let's close it.
        if (this.activeDialogTitle === "Highlights") this.dialogHighlights.close(true);
        this.dialogHighlight?.setState(highlight, false);
        this.dialogHighlight?.show();
    }
}



class $81ca9fd26f6dbbf0$export$1003937c5f028af1 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogSettings.onSettingsUpdated(vanillaReaderUiContext._onDialogSettingsUpdated.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogSettings.onSettingsReset(vanillaReaderUiContext._onDialogSettingsReset.bind(vanillaReaderUiContext));
    }
    _onDialogSettingsReset() {
        this._resetAllOptions();
        this.toaster.toast("View settings have been reset to defaults.", true).catch(console.warn);
    }
    _onDialogSettingsUpdated(settings) {
        if (settings.useAccessibilityMode !== this.isInAccessibilityMode) {
            if (settings.useAccessibilityMode) {
                this.enterAccessibilityMode();
                this.dialogSettings.close();
            } else {
                this.exitAccessibilityMode();
                this.dialogSettings.close();
            }
            return;
        }
        // The Reading Ruler options are a bit special as they do not affect the VanillaReader module at all.
        // Thus, we can apply the changes here in this module.
        if (settings.readingRulerOptions) {
            let paletteAsset = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === settings.activeUiPaletteName);
            let defaultPaletteAsset = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === "Dark");
            this.readingRuler.setOptions({
                lineBoxBackgroundColor: settings.readingRulerOptions.lineBoxBackgroundColor,
                overlayIsVisible: settings.readingRulerOptions.overlayIsVisible,
                lineBoxLineSpan: settings.readingRulerOptions.lineBoxLineSpan,
                snapToLineBoxes: settings.readingRulerOptions.snapToLineBoxes,
                overlayBackgroundColor: paletteAsset?.backgroundDark || defaultPaletteAsset.backgroundDark
            });
            // Make sure that the overlay color matches the palette
            settings.readingRulerOptions.overlayBackgroundColor = paletteAsset?.backgroundDark || defaultPaletteAsset.backgroundDark;
        }
        // Check if the media player is open and if so save it along with the other settings data
        settings.showNarrationControls = this.menuMediaPlayer.isOpen();
        this.vanillaReaderAPI.setAppUiOptions(settings);
    }
    _resetAllOptions() {
        this.vanillaReaderAPI.resetAppUiOptions();
    }
}




class $d7adc8dbfa2bd8eb$export$766b3f4b027c3330 {
    rendererToElement(blocks, rootElement) {
        blocks.forEach((block)=>{
            this._templateBlockData(block, rootElement);
        });
    }
    rendererToString(blocks, wrapperElementTagName = "div") {
        let rootElement = document.createElement(wrapperElementTagName);
        blocks.forEach((block)=>{
            this._templateBlockData(block, rootElement);
        });
        return rootElement.innerHTML;
    }
    _templateBlockData(blockData, parentElement) {
        let blockElement = $d7adc8dbfa2bd8eb$export$766b3f4b027c3330._applyElementTemplate(blockData);
        if (blockElement) {
            blockData.attributes.forEach((attrData)=>{
                if (attrData.prefix) blockElement.setAttributeNS(attrData.prefix, attrData.localName, attrData.value);
                else blockElement.setAttribute(attrData.localName, attrData.value);
            });
            this._templateMarkData(blockData, blockElement);
            blockData.children.forEach((childBlock)=>{
                this._templateBlockData(childBlock, blockElement);
            });
            parentElement.appendChild(blockElement);
        }
        return parentElement;
    }
    _templateMarkData(_blockData, _parentElement) {}
    // private static _applyMarkTemplate(markData: IContentBlockMarkData, blockData: IContentBlockData): HTMLElement {
    //     let element: HTMLElement;
    //     switch (markData.type) {
    //         case 'ANCHOR':
    //             element = document.createElement('a');
    //             break;
    //         case 'STRONG':
    //             element = document.createElement('strong');
    //             break;
    //         case 'EMPHASIS':
    //             element = document.createElement('em');
    //             break;
    //         default:
    //             element = document.createElement('span');
    //     }
    //     const textNode = document.createTextNode(blockData.textContent.slice(markData.startOffset, markData.endOffset));
    //     element.appendChild(textNode);
    //
    //     return element;
    // }
    static _applyElementTemplate(block) {
        let element;
        switch(block.blockType){
            case "ARTICLE":
                element = document.createElement("article");
                break;
            case "ASIDE":
                element = document.createElement("aside");
                break;
            case "BLOCK_QUOTE":
                element = document.createElement("blockquote");
                break;
            case "DESCRIPTION_LIST":
                element = document.createElement("dl");
                break;
            case "DESCRIPTION_TERM":
                element = document.createElement("dt");
                break;
            case "DESCRIPTION_DEFINITION":
                element = document.createElement("dd");
                break;
            case "FIGURE":
                element = document.createElement("figure");
                break;
            case "GENERIC":
                element = document.createElement("div");
                break;
            case "ORDERED_LIST":
                element = document.createElement("ol");
                break;
            case "LIST_ITEM":
                element = document.createElement("li");
                break;
            case "SECTION":
                element = document.createElement("section");
                break;
            case "TABLE":
                element = document.createElement("table");
                break;
            case "TABLE_BODY":
                element = document.createElement("tbody");
                break;
            case "TABLE_CELL":
                element = document.createElement("td");
                break;
            case "TABLE_FOOTER":
                element = document.createElement("tfooter");
                break;
            case "TABLE_HEADER":
                element = document.createElement("th");
                break;
            case "TABLE_ROW":
                element = document.createElement("tr");
                break;
            case "UNORDERED_LIST":
                element = document.createElement("ul");
                break;
            case "AUDIO":
                element = document.createElement("audio");
                break;
            case "IMAGE":
                element = document.createElement("img");
                break;
            case "VIDEO":
                element = document.createElement("video");
                break;
            case "HEADING1":
                element = document.createElement("h1");
                break;
            case "HEADING2":
                element = document.createElement("h2");
                break;
            case "HEADING3":
                element = document.createElement("h3");
                break;
            case "HEADING4":
                element = document.createElement("h4");
                break;
            case "HEADING5":
                element = document.createElement("h5");
                break;
            case "HEADING6":
                element = document.createElement("h6");
                break;
            case "PARAGRAPH":
                element = document.createElement("p");
                break;
            case "TEXT":
                element = document.createElement("p");
                break;
            default:
                element = document.createElement("div");
        }
        const textNode = document.createTextNode(block.textContent);
        element.appendChild(textNode);
        return element;
    }
}


class $ffc706f83aa31473$export$afef38667e53c4f5 {
    _addVanillaReaderAPIEventListeners() {
        /*
        *
        * Here are all the event listeners. Almost all events are fired by the `VanillaReaderAPI` instance in response
        * to a change in the application state.
        *
        * The naming is quite intuitive I hope :)
        *
        * */ this.vanillaReaderAPI.onAmbientAudioReady(this._vanillaReaderEvent_ambientAudioReady.bind(this));
        this.vanillaReaderAPI.onAmbientAudioNotFound(this._vanillaReaderEvent_ambientAudioNotFound.bind(this));
        this.vanillaReaderAPI.onAppLoaded(this._vanillaReaderEvent_appLoaded.bind(this));
        this.vanillaReaderAPI.onAppOnlineStateChanged(this._vanillaReaderEvent_appOnlineStateChanged.bind(this));
        this.vanillaReaderAPI.onAppUiOptionsChanged(this._vanillaReaderEvent_appUiOptionsChanged.bind(this));
        this.vanillaReaderAPI.onBookmarksLoaded(this._vanillaReaderEvent_bookmarksLoaded.bind(this));
        this.vanillaReaderAPI.onBookmarkAdded(this._vanillaReaderEvent_bookmarkAdded.bind(this));
        this.vanillaReaderAPI.onBookmarkClicked(this._vanillaReaderEvent_bookmarkClicked.bind(this));
        this.vanillaReaderAPI.onBookmarkDeleted(this._vanillaReaderEvent_bookmarkDeleted.bind(this));
        this.vanillaReaderAPI.onBookmarkTextLocationFailed(this._vanillaReaderEvent_bookmarkTextLocationFailed.bind(this));
        this.vanillaReaderAPI.onBookmarksCollectionUpdated(this._vanillaReaderEvent_bookmarksCollectionUpdated.bind(this));
        this.vanillaReaderAPI.onBookmarkInVisibleRange(this._vanillaReaderEvent_bookmarkInVisibleRange.bind(this));
        this.vanillaReaderAPI.onBookmarkOutsideVisibleRange(this._vanillaReaderEvent_bookmarkOutsideVisibleRange.bind(this));
        this.vanillaReaderAPI.onDocumentIsAtStart(this._vanillaReaderEvent_documentIsAtStart.bind(this));
        this.vanillaReaderAPI.onDocumentIsAtEnd(this._vanillaReaderEvent_documentIsAtEnd.bind(this));
        this.vanillaReaderAPI.onHighlightsLoaded(this._vanillaReaderEvent_highlightsLoaded.bind(this));
        this.vanillaReaderAPI.onHighlightAdded(this._vanillaReaderEvent_highlightAdded.bind(this));
        this.vanillaReaderAPI.onHighlightDeleted(this._vanillaReaderEvent_highlightDeleted.bind(this));
        this.vanillaReaderAPI.onHighlightUpdated(this._vanillaReaderEvent_highlightUpdated.bind(this));
        this.vanillaReaderAPI.onHighlightsCollectionUpdated(this._vanillaReaderEvent_highlightsCollectionUpdated.bind(this));
        this.vanillaReaderAPI.onHighlightClicked(this._vanillaReaderEvent_highlightClicked.bind(this));
        this.vanillaReaderAPI.onHighlightTextLocationFailed(this._vanillaReaderEvent_highlightTextLocationFailed.bind(this));
        this.vanillaReaderAPI.onHighlightInVisibleRange(this._vanillaReaderEvent_highlightInVisibleRange.bind(this));
        this.vanillaReaderAPI.onHighlightOutsideVisibleRange(this._vanillaReaderEvent_highlightOutsideVisibleRange.bind(this));
        this.vanillaReaderAPI.onReaderKeyUp(this._vanillaReaderEvent_readerKeyUp.bind(this));
        // This is one of the few intents that are sent from the `VanillaReader`. This is because the event (probably a
        // pointer up on an image element) is emitted by the Colibrio `ReaderView`. So an intent is sent to the UI so that
        // it can show the media resource in a popup dialog.
        this.vanillaReaderAPI.onMediaObjectViewIntent(this._vanillaReaderEvent_mediaObjectViewIntent.bind(this));
        this.vanillaReaderAPI.onMediaPlayerCreated(this._vanillaReaderEvent_mediaPlayerCreated.bind(this));
        this.vanillaReaderAPI.onMediaPlayerPlaybackStateChanged(this._vanillaReaderEvent_mediaPlayerPlaybackStateChanged.bind(this));
        this.vanillaReaderAPI.onMediaPlayerPlaybackPositionChanged(this._vanillaReaderEvent_mediaPlayerPlaybackPositionChanged.bind(this));
        this.vanillaReaderAPI.onMediaPlayerSeekCompleted(this._vanillaReaderEvent_mediaPlayerSeekCompleted.bind(this));
        this.vanillaReaderAPI.onMediaPlayerAttached(this._vanillaReaderEvent_mediaPlayerAttached.bind(this));
        this.vanillaReaderAPI.onMediaPlayerDetached(this._vanillaReaderEvent_mediaPlayerDetached.bind(this));
        this.vanillaReaderAPI.onMediaPlayerEscapabilityContextChanged(this._vanillaReaderEvent_mediaPlayerEscapabilityContextChanged.bind(this));
        this.vanillaReaderAPI.onMediaPlayerVoiceListChanged(this._vanillaReaderEvent_mediaPlayerVoiceListChanged.bind(this));
        // This is one of the few intents that are sent from the `VanillaReader`. A link with a target outside the publication
        // has been triggered in the Colibrio `IReaderView`. An intent is sent to the UI in order for it to decide how
        // to give the appropriate options to the user.
        this.vanillaReaderAPI.onNavigationOpenRemoteAddressIntent(this._vanillaReaderEvent_navigationOpenRemoteAddressIntent.bind(this));
        this.vanillaReaderAPI.onNavigationGotoInternalLocationIntent(this._vanillaReaderEvent_navigationGotoInternalLocationIntent.bind(this));
        this.vanillaReaderAPI.onNavigationStarted(this._vanillaReaderEvent_navigationStarted.bind(this));
        this.vanillaReaderAPI.onNavigationCompleted(this._vanillaReaderEvent_navigationCompleted.bind(this));
        this.vanillaReaderAPI.onNavigationTreeReady(this._vanillaReaderEvent_navigationTreeReady.bind(this));
        this.vanillaReaderAPI.onReaderViewPointerDown(this._vanillaReaderEvent_readerViewPointerDown.bind(this));
        this.vanillaReaderAPI.onReaderViewPointerUp(this._vanillaReaderEvent_readerViewPointerUp.bind(this));
        this.vanillaReaderAPI.onReaderViewPointerMove(this._vanillaReaderEvent_readerViewPointerMove.bind(this));
        this.vanillaReaderAPI.onClick(this._vanillaReaderEvent_click.bind(this));
        this.vanillaReaderAPI.onPublicationLoaded(this._vanillaReaderEvent_publicationLoaded.bind(this));
        this.vanillaReaderAPI.onPublicationLoadFailed(this._vanillaReaderEvent_publicationLoadFailed.bind(this));
        this.vanillaReaderAPI.onPublicationRendered(this._vanillaReaderEvent_publicationRendered.bind(this));
        this.vanillaReaderAPI.onPublicationPageListReady(this._vanillaReaderEvent_publicationPageListReady.bind(this));
        this.vanillaReaderAPI.onPublicationPageNumberVisibilityChanged(this._vanillaReaderEvent_publicationPageNumberVisibilityChanged.bind(this));
        this.vanillaReaderAPI.onPublicationDownloadProgressUpdated(this._vanillaReaderEvent_publicationDownloadProgressUpdated.bind(this));
        this.vanillaReaderAPI.onPublicationSearchCompleted(this._vanillaReaderEvent_publicationSearchCompleted.bind(this));
        this.vanillaReaderAPI.onPublicationShelfUpdated(this._appEvent_publicationShelfUpdated.bind(this));
        this.vanillaReaderAPI.onPublicationStyleOptionsChanged(this._vanillaReaderEvent_publicationStyleOptionsChanged.bind(this));
        this.vanillaReaderAPI.onPublicationViewportChanged(this._vanillaReaderEvent_publicationViewportChanged.bind(this));
        this.vanillaReaderAPI.onRendererChanged(this._vanillaReaderEvent_rendererChanged.bind(this));
        this.vanillaReaderAPI.onRendererAspectRatioChanged(this._vanillaReaderEvent_rendererAspectRatioChanged.bind(this));
        this.vanillaReaderAPI.onReducedMotionOptionChanged(this._vanillaReaderEvent_reducedMotionOptionChanged.bind(this));
        this.vanillaReaderAPI.onReadingPositionUpdated(this._vanillaReaderEvent_readingPositionUpdated.bind(this));
        this.vanillaReaderAPI.onTextSelected(this._vanillaReaderEvent_textSelected.bind(this));
        this.vanillaReaderAPI.onTimelinePositionUpdated(this._vanillaReaderEvent_timelinePositionUpdated.bind(this));
        this.vanillaReaderAPI.onVisibleContentRendered(this._vanillaReaderEvent_visibleContentRendered.bind(this));
        this.vanillaReaderAPI.onVisiblePagesChanged(this._vanillaReaderEvent_visiblePagesChanged.bind(this));
        this.vanillaReaderAPI.onTimelineReady(this._vanillaReaderEvent_timelineReady.bind(this));
        this.vanillaReaderAPI.onViewTransitionStarted(this._vanillaReaderEvent_viewTransitionStarted.bind(this));
        this.vanillaReaderAPI.onViewTransitionEnded(this._vanillaReaderEvent_viewTransitionEnded.bind(this));
        this.vanillaReaderAPI.onViewTransformChanged(this._vanillaReaderEvent_viewTransformChanged.bind(this));
        this.vanillaReaderAPI.onVisibleContentRectsChanged(this._vanillaReaderEvent_visibleContentRectsChanged.bind(this));
        this.vanillaReaderAPI.onPublicationLandmarksReady(this._vanillaReaderEvent_publicationLandmarksReady.bind(this));
        this.vanillaReaderAPI.onViewSwipeNavigationProgressUpdated(this._vanillaReaderEvent_swipeNavigationProgressUpdated.bind(this));
        this.vanillaReaderAPI.onVisibleRangeDataChanged(this._vanillaReaderEvent_visibleRangeDataChanged.bind(this));
    }
    _vanillaReaderEvent_ambientAudioReady(ev) {
        this.functionButtons.enableSoundtrack(ev.detail.isPlaying);
    }
    _vanillaReaderEvent_ambientAudioNotFound(_ev) {
        this.functionButtons.disableSoundtrack();
    }
    _vanillaReaderEvent_appLoaded(_ev) {
        console.log("The application is all set to load publications.");
    }
    _vanillaReaderEvent_appOnlineStateChanged(ev) {
        let toastMsg = ev.detail.isOnline ? "App running online" : "App running offline";
        this.toaster.toast(toastMsg).catch(console.error);
        this.dialogOpenFile.isOffline = ev.detail.isOnline;
    }
    _vanillaReaderEvent_appUiOptionsChanged(ev) {
        this.activeUiOptionsData = ev.detail.uiOptionsData;
        this.dialogSettings.setViewState(ev.detail.uiOptionsData);
    }
    _vanillaReaderEvent_readerViewPointerDown(ev) {
        this.latestReaderViewPointerDownEventTimestamp = Date.now();
        this.latestReaderViewPointerDownEventCoords = {
            x: ev.detail.srcEventData.clientX,
            y: ev.detail.srcEventData.clientY
        };
        this.latestReaderViewPointerDownEventButton = ev.detail.srcEventData.buttons;
        // Pointer down should cancel the hover timeout
        if (this.readerViewPointerHoverTimeoutHandle) clearTimeout(this.readerViewPointerHoverTimeoutHandle);
    }
    /*
    *
    * This event handler takes care of deciding what to do when a pointer up has been released. In an EPUB especially
    * there are a lot of things that need to be handled correctly for the user experience to be good. Especially in
    * EPUBs that are scripted.
    *
    * In the Vanilla Reader this is extra important since it uses the familiar "click the publication to open the
    * main menu"-feature. There are quite a number of instances where you *don't* want to open the menu, such as if the
    * user,
    *
    * - clicks an HTML Form control
    * - clicks an image
    * - a details element
    * - etc
    *
    * */ _vanillaReaderEvent_readerViewPointerUp(ev) {
        // This is run after a timeout in order to catch double clicks etc. This is so that users can double
        // tap / click text without us showing the menu.
        const _internalReaderViewPointerUp = ()=>{
            let srcEventData = ev.detail.srcEventData;
            let ignoreEvent = false;
            this.latestReaderViewPointerUpEventCoords = {
                x: ev.detail.srcEventData.clientX,
                y: ev.detail.srcEventData.clientY
            };
            this.readerViewPointerUpTimeoutHandle = undefined;
            // Check if the pointer event is an engine event. If not we can not reference any Colibrio specific data.
            if (this._eventDataIsPointerEngineEventData(srcEventData)) {
                let hasMediaPlayerReadAloudAttribute = srcEventData.target?.nodeData?.attributes.some((attribute)=>{
                    return attribute.localName === "ibooks-readaloud" || attribute.localName === "readaloud";
                });
                if (hasMediaPlayerReadAloudAttribute) this.startMediaPlayer(srcEventData.target?.locator?.selectors[0] || undefined);
                if (srcEventData.mediaResource) // Clicks on images are handled in the `event_mediaObjectViewIntent` method, so we can return.
                return;
                let eventTarget = srcEventData.target;
                const bubbleSearchForIgnoreElement = (nodeData)=>{
                    let nodeName = nodeData.nodeName?.toLocaleLowerCase();
                    if (!nodeName || nodeName === "body") return false;
                    // Filter out other elements where we should not interfere in the original event behaviour
                    switch(nodeName){
                        case "a":
                        case "figure":
                        case "img":
                        case "details":
                        case "summary":
                        case "button":
                        case "select":
                        case "input":
                        case "textarea":
                            return true;
                        default:
                            if (nodeData.parent) return bubbleSearchForIgnoreElement(nodeData.parent);
                            else return false;
                    }
                };
                if (srcEventData.target?.nodeData && bubbleSearchForIgnoreElement(srcEventData.target.nodeData)) ignoreEvent = true;
                let targetIsBookmarkOrHighlight = eventTarget?.frameworkComponent === (0, $f8f5cf2c043414f4$export$1d65de24d737ed61).READER_VIEW_ANNOTATION;
                if (targetIsBookmarkOrHighlight || this.activeSelection) ignoreEvent = true;
                if (srcEventData.readerDocumentEventState === (0, $f8f5cf2c043414f4$export$ce06c08e13a84fea).DEFAULT_PREVENTED) ignoreEvent = true;
                // If the reader is in accessibility mode we show a dialog with actions instead of the bottom menu.
                // This is done in the click event handler
                if (this.isInAccessibilityMode && !this.activeSelection) ignoreEvent = true;
            }
            // If the media player is playing we should not open the menu as clicking the book page also moves the reading
            // position.
            if (this.menuMediaPlayer.stateIsPlaying && !this.initialPublicationData?.isAudiobook) ignoreEvent = true;
            // if the pressed button is not the left button (the button id is 1) we skip opening the menu
            if (this.latestReaderViewPointerDownEventButton !== 1) ignoreEvent = true;
            if (!this.latestReaderViewPointerDownEventCoords) // If, for some strange reason, we do not have data about the pointer down event.
            this.latestReaderViewPointerDownEventCoords = this.latestReaderViewPointerUpEventCoords;
            let pointerEventDeltas = {
                x: Math.abs(this.latestReaderViewPointerDownEventCoords.x - this.latestReaderViewPointerUpEventCoords.x),
                y: Math.abs(this.latestReaderViewPointerDownEventCoords.y - this.latestReaderViewPointerUpEventCoords.y)
            };
            if (!this.showMenuOnReaderViewClick || ignoreEvent || pointerEventDeltas.x > 20 || pointerEventDeltas.y > 20) return;
            else {
                ev.preventDefault();
                if (this.menuBottom.isVisible) this.menuBottom.hide(!this.useReducedMotion);
                if (this.menuSide.isVisible) this.menuSide.hide(!this.useReducedMotion);
            //if (this.menuBottom.isVisible) {
            //    this.menuBottom.hide(!this.useReducedMotion);
            //} else {
            //    this.menuBottom.show(!this.useReducedMotion);
            //}
            }
        };
        if (this.readerViewPointerUpTimeoutHandle) clearTimeout(this.readerViewPointerUpTimeoutHandle);
        // Use setTimeout to catch double clicks.
        this.readerViewPointerUpTimeoutHandle = setTimeout(_internalReaderViewPointerUp, 200);
    }
    _vanillaReaderEvent_readerViewPointerMove(ev) {
        // This is run after a timeout in order to "throttle" the number of times we run the function.
        const _internalReaderViewPointerMove = ()=>{
            let srcEventData = ev.detail.srcEventData;
            if (this._eventDataIsPointerEngineEventData(srcEventData)) {
                let nodeData = srcEventData.target?.nodeData;
                if (nodeData) {
                    // Lookup the nearest node that has a href attribute. This can be the node itself.
                    let hrefNode = this._findNearestHrefValueInNodeData(nodeData);
                    if (!hrefNode || hrefNode.length < 1) return;
                    // We toast information about where the href is pointing to. If it's not a location within
                    // the publication we show just the url.
                    this.toastHrefTargetPositionInfo(hrefNode).catch();
                }
                this.readerViewPointerHoverTimeoutHandle = undefined;
            }
        };
        if (this.readerViewPointerHoverTimeoutHandle) clearTimeout(this.readerViewPointerHoverTimeoutHandle);
        // Use setTimeout to only run if the mouse has been still for the specified amount of time.
        this.readerViewPointerHoverTimeoutHandle = setTimeout(_internalReaderViewPointerMove, 700);
    }
    _vanillaReaderEvent_click(ev) {
        let srcEventData = ev.detail.srcEventData;
        // Check if the pointer event is an engine event. If not, we can not reference any Colibrio specific data.
        if (this._eventDataIsMouseEngineEventData(srcEventData)) {
            if (srcEventData.defaultPrevented || srcEventData.readerDocumentEventState === (0, $f8f5cf2c043414f4$export$ce06c08e13a84fea).DEFAULT_PREVENTED) return;
            // If the reader is in accessibility mode we show a dialog with actions instead of the bottom menu.
            if (this.isInAccessibilityMode && !this.activeSelection) {
                // Grab the locator of the latest caret position if possible as this has char offset info.
                // Otherwise, get the more low-res locator of the click event that will point to the start of the element.
                //let targetSelector = this.latestCaretLocator ? this.latestCaretLocator : srcEventData.target?.locator?.selectors[0];
                let targetSelector = srcEventData.target?.locator?.selectors[0];
                if (targetSelector) {
                    this.navigateTo(`#${targetSelector}`, false);
                    ev.preventDefault();
                    ev.stopImmediatePropagation();
                    this.dialogUiActions.show(true, true, undefined, true);
                } else console.warn("VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_click(), No locator was available in the event data so we dont show the actions dialog.");
            }
        }
        // Click should cancel the hover timeout
        if (this.readerViewPointerHoverTimeoutHandle) clearTimeout(this.readerViewPointerHoverTimeoutHandle);
    }
    /*
    *
    * This event handler is called when the `VanillaReader` has sent the `PUBLICATION_LOADED`. This means that the
    * rendering has started. There is also a `PUBLICATION_RENDERED` that you can listen to if you want to know when the
    * first page has been rendered.
    *
    * */ _vanillaReaderEvent_publicationLoaded(ev) {
        // If we had no publication data stored in the data store, we populate the `_initialPublicationData`
        // variable with the data sent in the event data.
        if (!this.initialPublicationData) this.initialPublicationData = ev.detail.publicationData;
        if (!this.initialPublicationOptionsData) {
            this.initialPublicationOptionsData = ev.detail.publicationOptionsData;
            if (this.initialPublicationOptionsData?.ttsOptions?.voiceName) this.dialogSettings.setSelectedTtsVoiceOption(this.initialPublicationOptionsData.ttsOptions.voiceName);
        }
        if (this._publicationOpenedCallback) this._publicationOpenedCallback(this.initialPublicationData);
        this._onAfterPublicationLoadedSetup(ev.detail.publicationData);
        if (this.dialogOpenFile.isOpen()) this.dialogOpenFile.close(true);
    }
    _vanillaReaderEvent_publicationLoadFailed(_ev) {
        this.toaster.toast("Failed to load book. App will restart in 5 seconds.", true, 5000).catch();
        setTimeout(()=>{
            document.location.reload();
        }, 5200);
    }
    _vanillaReaderEvent_publicationRendered(_ev) {
        this._onPublicationRendered();
    }
    _vanillaReaderEvent_publicationPageListReady(ev) {
        if (ev.detail.pageListData) {
            this.publicationPageListData = ev.detail.pageListData;
            this.menuProgressionSlider.setSyntheticPages(this.publicationPageListData);
        } else console.warn("VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_publicationPageListReady(), No page list data in the event data.");
    }
    /*
    *
    * This method is called multiple times as a publication is being downloaded for offline reading.
    * The `progress` value is a number between 0 and 1.
    *
    * */ _vanillaReaderEvent_publicationDownloadProgressUpdated(ev) {
        if (ev.detail.progress === 1) this._onPublicationDownloaded(ev.detail.publicationId);
        else this._onPublicationDownloadProgressUpdated(ev.detail.publicationId, ev.detail.progress);
    }
    _vanillaReaderEvent_publicationPageNumberVisibilityChanged(ev) {
        this.activeUiOptionsData.showPageNumbers = ev.detail.visible;
    }
    _vanillaReaderEvent_highlightsLoaded(ev) {
        this.dialogHighlights?.populate(ev.detail.highlights || []);
    }
    _vanillaReaderEvent_highlightTextLocationFailed(ev) {
        this.toaster.toast(`Failed to add highlight for text "${ev.detail.text}"`, true).catch(console.warn);
    }
    _vanillaReaderEvent_highlightClicked(ev) {
        let highlight = ev.detail.highlight;
        this.dialogHighlight?.setState(highlight, false);
        this.dialogHighlight?.show();
    }
    async _vanillaReaderEvent_highlightInVisibleRange(_ev) {
        await this.toaster.toast("Visible content has highlights. Press Alt + Shift + H to list them.", true);
    }
    _vanillaReaderEvent_highlightOutsideVisibleRange(_ev) {}
    _vanillaReaderEvent_highlightAdded(ev) {
        // Add the new bookmark to the list of selected items so that it can be filtered out as being visible.
        let selectedHighlights = this.dialogHighlights.selectedItems || [];
        selectedHighlights.push(ev.detail.highlight);
        this.dialogHighlights.setSelected(selectedHighlights);
        this.navigateTo(ev.detail.highlight.locator, true);
        this.toaster.toast("Highlight added", true).catch(console.error);
    }
    _vanillaReaderEvent_highlightDeleted(_ev) {
        this.toaster.toast("Highlight deleted", true).catch(console.error);
    }
    _vanillaReaderEvent_highlightUpdated(_ev) {}
    _vanillaReaderEvent_highlightsCollectionUpdated(ev) {
        this.dialogHighlights?.populate(ev.detail.highlights);
    }
    _vanillaReaderEvent_bookmarksLoaded(ev) {
        this.dialogBookmarks?.populate(ev.detail.bookmarks || []);
    }
    _vanillaReaderEvent_bookmarkAdded(ev) {
        // Add the new bookmark to the list of selected items so that it can be filtered out as being visible.
        let selectedBookmarks = this.dialogBookmarks.selectedItems || [];
        selectedBookmarks.push(ev.detail.bookmark);
        this.dialogBookmarks.setSelected(selectedBookmarks);
        this.navigateTo(ev.detail.bookmark.locator, true);
        this.toaster.toast("Bookmark added", true).catch(console.error);
    }
    _vanillaReaderEvent_bookmarkClicked(ev) {
        this.vanillaReaderAPI?.deleteBookmark(ev.detail.bookmark.locator);
    }
    _vanillaReaderEvent_bookmarkDeleted(_ev) {
        this.toaster.toast("Bookmark deleted", true).catch(console.error);
    }
    _vanillaReaderEvent_bookmarkTextLocationFailed(ev) {
        this.toaster.toast(`Failed to add bookmark for text "${ev.detail.text}"`, true).catch(console.error);
    }
    _vanillaReaderEvent_bookmarksCollectionUpdated(ev) {
        this.dialogBookmarks?.populate(ev.detail.bookmarks);
    }
    async _vanillaReaderEvent_bookmarkInVisibleRange(_ev) {
        await this.toaster.toast("Visible content has bookmarks. Press Alt + Shift + O to list them.", true);
    }
    _vanillaReaderEvent_bookmarkOutsideVisibleRange(_ev) {}
    _vanillaReaderEvent_documentIsAtStart(_ev) {
        if (this.dialogSettings.activeRendererTypeName === (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL) console.log("_vanillaReaderEvent_documentIsAtStart");
    }
    async _vanillaReaderEvent_documentIsAtEnd(_ev) {
        if (this.dialogSettings.activeRendererTypeName === (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL) await this.toaster.toast("Book section is at end.", true);
    }
    _vanillaReaderEvent_mediaPlayerAttached(_ev) {
        if (!this.menuMediaPlayer?.isOpen()) {
            this.menuBottom.toggleReadAloudButtonState(true);
            this.menuMediaPlayer.open();
        }
    }
    _vanillaReaderEvent_mediaPlayerDetached(_ev) {
        if (this.menuMediaPlayer.isOpen()) {
            this.menuBottom.toggleReadAloudButtonState(false);
            this.menuMediaPlayer?.close();
        }
    }
    _vanillaReaderEvent_mediaPlayerEscapabilityContextChanged(ev) {
        this.mediaPlayerEscapabilityContext = ev.detail.contextData;
    }
    _vanillaReaderEvent_mediaPlayerVoiceListChanged(ev) {
        if (!ev.detail.voiceCollection) {
            console.warn("VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_mediaPlayerVoiceListChanged: voiceCollection was undefined.");
            return;
        }
        this.dialogSettings.setTtsVoiceCollectionData(ev.detail.voiceCollection);
    }
    _vanillaReaderEvent_mediaObjectViewIntent(ev) {
        // No image dialog if the view is in accessibility mode
        if (this.isInAccessibilityMode === true) return;
        // No image dialog if the view is in pan zoom mode
        if (this.isReaderViewIsInPanZoomMode === true) return;
        if (ev.detail.mediaUrl) {
            let description;
            if (ev.detail.mediaElementAttributes && ev.detail.mediaElementAttributes.length > 0) description = ev.detail.mediaElementAttributes.find((attribute)=>attribute.localName === "alt")?.value;
            this.dialogImageViewer?.loadImage(ev.detail.mediaUrl, description);
            this.dialogImageViewer.show(false, true);
        } else console.warn("_vanillaReaderEvent_mediaObjectViewIntent(): mediaUrl event data was undefined.");
    }
    _vanillaReaderEvent_navigationOpenRemoteAddressIntent(ev) {
        let url = ev.detail.targetUrl;
        // Do not open urls that are local to the "com.colibrio" scope.
        if (url && !url.includes("com.colibrio")) {
            if (window.confirm('Do you wish to open "' + url + '"?')) window.open(url);
        }
    }
    /*
    *
    * This method is called when a navigation within the publication content has been triggered.
    * There are some specific cases where you will not simply navigate to the location, such if you click on a footnote.
    * In the code below a popup is shown when the user clicks an HTML link to a footnote.
    *
    * */ async _vanillaReaderEvent_navigationGotoInternalLocationIntent(ev) {
        if (ev.detail.srcEvent?.relatedEvent?.target) {
            let nodeData = ev.detail.srcEvent.relatedEvent.target.nodeData;
            let srcEvent = ev.detail.srcEvent;
            if (nodeData) {
                // Let's check if this is a noteref element
                let isNoteRef = nodeData.attributes.find((attribute)=>{
                    return attribute.value === "noteref";
                });
                if (isNoteRef) {
                    ev.preventDefault();
                    let noteRefLocator = ev.detail.srcEvent.relatedEvent.target.contentLocation?.getLocator().toString();
                    let internalHref = nodeData.attributes.find((attribute)=>{
                        return attribute.localName === "href";
                    });
                    if (!internalHref) {
                        console.warn('_vanillaReaderEvent_navigationGotoInternalLocationIntent, link has no "href" attribute. ');
                        return;
                    }
                    let id = internalHref.value.slice(internalHref.value.indexOf("#") + 1);
                    let footnoteContentBlock = this.getFootnoteLandmarkByElementId(id);
                    if (footnoteContentBlock && srcEvent.locator) {
                        footnoteContentBlock;
                        let footerHtmlContent = new (0, $d7adc8dbfa2bd8eb$export$766b3f4b027c3330)().rendererToString([
                            await footnoteContentBlock.serialize(true, true)
                        ]);
                        this.dialogFootnote.show(false, true, this._onDialogFootnoteClosed.bind(this), footerHtmlContent, srcEvent.locator.toString(), noteRefLocator);
                    } else console.warn(`_vanillaReaderEvent_navigationGotoInternalLocationIntent, could not find a footnote with id "${id}".`);
                } else if (ev.detail.srcEvent && ev.detail.srcEvent.locator) {
                    // Not a noteref so we can do an internal navigation as usual.
                    ev.preventDefault();
                    let locator = ev.detail.srcEvent.locator.toString();
                    this.navigateTo(locator);
                }
            } else if (ev.detail.srcEvent && ev.detail.srcEvent.locator) {
                // Probably a PDF since there is no nodeData.
                ev.preventDefault();
                let locator = ev.detail.srcEvent.locator.toString();
                this.navigateTo(locator);
            }
        } else console.warn("_vanillaReaderEvent_navigationGotoInternalLocationIntent, got invalid locator. ");
    }
    _vanillaReaderEvent_navigationStarted(_ev) {
        this.isReaderViewNavigating = true;
        this._cancelAllActiveTimeouts();
    }
    _vanillaReaderEvent_navigationCompleted(_ev) {
        this.isReaderViewNavigating = false;
        if (this.menuBottom.isVisible) this.menuBottom.hide(!this.useReducedMotion);
    // Deselect bottom nav buttons. One off the buttons may have been toggled when the user swiped
    // in order to indicate pending navigation action (in _vanillaReaderEvent_swipeNavigationProgressUpdated()).
    //this.buttonNext.selected = false;
    //this.buttonPrevious.selected = false;
    }
    _vanillaReaderEvent_publicationSearchCompleted(ev) {
        if (ev.detail.resultSet) {
            this.dialogSearch?.populate(ev.detail.resultSet);
            this.dialogSearch?.show();
            this.toaster.toast(`Search returned ${ev.detail.resultSet.length} results.`, true).catch(console.warn);
        } else this.toaster.toast(`Search returned no results.`, true).catch(console.warn);
    }
    _appEvent_publicationShelfUpdated(ev) {
        this.dialogOpenFile.updateShelfItems(ev.detail.shelfItems).catch(console.warn);
    }
    _vanillaReaderEvent_publicationStyleOptionsChanged(_ev) {}
    _vanillaReaderEvent_publicationViewportChanged(ev) {
        this.visiblePageClientRects = ev.detail.visiblePageClientRects;
    }
    _vanillaReaderEvent_timelinePositionUpdated(ev) {
        let position = ev.detail.timelinePosition;
        if (position !== undefined && position >= 0) {
            this.menuProgressionSlider?.updateSliderProgressionValue(position);
            this.latestTimelinePosition = position;
        } else console.warn(`VanillaReaderUI._vanillaReaderEvent_timelineUpdateIntent(): timelinePosition value ${position} is not a valid postion.`);
    }
    _vanillaReaderEvent_rendererChanged(_ev) {}
    _vanillaReaderEvent_rendererAspectRatioChanged(ev) {
        this.activeUiOptionsData.ignoreAspectRatio = ev.detail.ignoreAspectRatio;
        this.dialogSettings?.setRendererAspectRatioOption(ev.detail.ignoreAspectRatio);
    }
    _vanillaReaderEvent_reducedMotionOptionChanged(ev) {
        this.activeUiOptionsData.useReducedMotion = ev.detail.useReducedMotion;
        this.dialogSettings?.setUseReducedMotionOption(ev.detail.useReducedMotion);
        this.readingRuler.useReducedMotion = this.useReducedMotion;
    }
    _vanillaReaderEvent_readingPositionUpdated(ev) {
        this.setReadingPositionData(ev.detail.readingPositionData);
        // Only focus on reading position if there is no dialog open, and that the scroll renderer is not used.
        if (!this.activeDialogTitle && this.dialogSettings.activeRendererTypeName !== (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL && !this.menuMediaPlayer.stateIsPlaying) this.focusOnReadingPosition();
        // Move ruler along with TTS and MO, unless the scroll renderer is active.
        if (this.readingRuler.isVisible && this.dialogSettings.activeRendererTypeName !== (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL && (this.readingRuler.snapToContentLineBoxes || this.menuMediaPlayer.stateIsPlaying)) setTimeout(()=>{
            this.moveReadingRulerToReadingPosition();
        }, 0);
    }
    _vanillaReaderEvent_navigationTreeReady(ev) {
        if (ev.detail.navigationTreeData) this.initializeNavigationTree(ev.detail.navigationTreeData);
        else console.warn("VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_navigationTreeReady(), event data did not contain any navigation tree data.");
    }
    _vanillaReaderEvent_readerKeyUp(ev) {
        this._handleKeyboardShortcut(ev.detail.srcEventData.key, ev.detail.srcEventData.modifiers.alt, ev.detail.srcEventData.modifiers.shift, ev.detail.srcEventData.modifiers.control);
    }
    _vanillaReaderEvent_textSelected(ev) {
        this.latestCaretLocatorData = ev.detail.srcEventData.locator || undefined;
        if (ev.detail.srcEventData.isRange) {
            clearTimeout(this.selectionTimeoutHandle);
            this.activeSelection = {
                locatorData: ev.detail.srcEventData.locator,
                selector: "#" + ev.detail.srcEventData.locator?.selectors[0],
                isRange: ev.detail.srcEventData.isRange,
                selectionText: ev.detail.srcEventData.selectionText || ""
            };
            this.fabHighlight.show();
            this.fabSpeakText.show();
        } else // Wait a bit before clearing the activeSelection variable in order to not create a racing condition
        // when the highlight button is pressed and the selection gets cleared.
        this.selectionTimeoutHandle = setTimeout(()=>{
            this.activeSelection = undefined;
            this.fabHighlight.hide();
            this.fabSpeakText.hide();
        }, 500);
        // If the media player is active, we should move (seek to) the playback position to the locator that points to.
        // This way the user can easily tap or click on the content they want to listen to when using TTS, or in a book with MO.
        if (this.menuMediaPlayer.isOpen() && ev.detail.srcEventData.locator && !ev.detail.srcEventData.isRange) this.seekToLocatorWithinVisibleRange(ev.detail.srcEventData.locator);
    }
    _vanillaReaderEvent_visibleRangeDataChanged(ev) {
        let visibleRangeData = ev.detail.visibleRangeData;
        if (visibleRangeData) {
            this.latestContentRangeData = visibleRangeData;
            this.visibleContentRectData = visibleRangeData.visibleContentRects;
            this.dialogHighlights.setSelected(visibleRangeData.highlights);
            this.dialogBookmarks.setSelected(visibleRangeData.bookmarks);
            this.dialogContents.setActiveTocItems(visibleRangeData.navItems);
            this.dialogContents.setActivePageItems(visibleRangeData.navItems);
            if (visibleRangeData.timelineRange) {
                this.menuProgressionSlider.setVisibleRangeData(visibleRangeData);
                if (this.latestTimelinePosition) this.menuProgressionSlider?.updateSliderProgressionValue(this.latestTimelinePosition);
                if (this.vanillaReaderButtonContainerElement.querySelector("#vanilla-reader__slider-progression")) this.vanillaReaderButtonContainerElement.querySelector("#vanilla-reader__slider-progression").classList.remove("loading");
            } else console.warn("VanillaReaderUiVanillaReaderEventController._vanillaReaderEvent_visibleRangeDataChanged(), Unable to get get timelineRange from visibleRangeData.");
            if (this.visibleContentRectData && this.visibleContentRectData.length > 0) this.readingRuler.setContentLineBoxes(this.visibleContentRectData);
            // No moving the ruler if we have the scroll renderer.
            if (this.readingRuler.isVisible && this.dialogSettings.activeRendererTypeName !== (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL) this.moveReadingRulerToReadingPosition();
        } else console.warn("_vanillaReaderEvent_visibleRangeDataChanged: The event did not contain any range data.");
    }
    _vanillaReaderEvent_visibleContentRendered(ev) {
        let visibleRangeData = ev.detail.visibleRangeData;
        if (visibleRangeData) {
            this.visibleContentRectData = visibleRangeData.visibleContentRects;
            if (this.visibleContentRectData && this.visibleContentRectData.length > 0) this.readingRuler.setContentLineBoxes(this.visibleContentRectData);
        //console.log('_vanillaReaderEvent_visibleContentRendered', this.visibleElementClientRects);
        } else console.warn("_vanillaReaderEvent_visibleContentRendered: The event did not contain any range data.");
    }
    _vanillaReaderEvent_visiblePagesChanged(ev) {
        let visibleRangeData = ev.detail.visibleRangeData;
        if (visibleRangeData) {
            this.visibleContentRectData = visibleRangeData.visibleContentRects;
            if (this.visibleContentRectData && this.visibleContentRectData.length > 0) this.readingRuler.setContentLineBoxes(this.visibleContentRectData);
        } else console.warn("_vanillaReaderEvent_visiblePagesChanged: The event did not contain any range data.");
    }
    _vanillaReaderEvent_timelineReady(ev) {
        this.initializeProgressionTimeline(ev.detail.timelineData);
        // If this is a PDF we don't need to fetch landmarks as PDFs do not contain any meaningful landmark semantics
        // other than those presented in the navigation metadata.
        if (this.initialPublicationData?.format !== "application/pdf") this._populatePublicationLandmarks();
    }
    _vanillaReaderEvent_publicationLandmarksReady(ev) {
        this.publicationHeadingLandmarks = ev.detail.headings || [];
        this.publicationFootnoteLandmarks = ev.detail.footnotes || [];
        this.publicationFigureLandmarks = ev.detail.figures || [];
        this.publicationTableLandmarks = ev.detail.tables || [];
        this.publicationListLandmarks = ev.detail.lists || [];
    }
    _vanillaReaderEvent_swipeNavigationProgressUpdated(ev) {
        let navigationAction = ev.detail.srcEventData.pendingNavigationAction;
        this.buttonNext.selected = false;
        this.buttonPrevious.selected = false;
        switch(navigationAction){
            case (0, $f8f5cf2c043414f4$export$3fe606efa32546a8).NEXT_RENDERABLE_PAGE:
            case (0, $f8f5cf2c043414f4$export$3fe606efa32546a8).NEXT_CONTENT_RANGE:
                this.buttonNext.selected = true;
                break;
            case (0, $f8f5cf2c043414f4$export$3fe606efa32546a8).PREVIOUS_CONTENT_RANGE:
            case (0, $f8f5cf2c043414f4$export$3fe606efa32546a8).PREVIOUS_RENDERABLE_PAGE:
                this.buttonPrevious.selected = true;
                break;
            default:
        }
    }
    _vanillaReaderEvent_viewTransitionStarted(_ev) {
        this.isReaderViewTransitioning = true;
    }
    _vanillaReaderEvent_viewTransitionEnded(_ev) {
        this.isReaderViewTransitioning = false;
        this.activeTransformData = undefined;
    }
    /**
     *
     * When the user is panning and zooming, this method is called with the updated transform data. The transform data
     * can also be `undefined` in which case the zoom has been reset.
     *
     * */ _vanillaReaderEvent_viewTransformChanged(ev) {
        if (ev.detail.transformData && !this.isReaderViewIsInPanZoomMode) {
            this.isReaderViewIsInPanZoomMode = true;
            if (!this.panZoomTool.isActive) {
                this.panZoomTool.activate();
                this.panZoomTool.enablePanning();
            }
        } else if (!ev.detail.transformData?.transformData && this.isReaderViewIsInPanZoomMode) {
            this.isReaderViewIsInPanZoomMode = false;
            this.panZoomTool.deactivate();
        }
        this.activeTransformData = ev.detail.transformData;
        this.panZoomTool.activeTransformData = this.activeTransformData?.transformData;
        if (this.activeTransformData && this.isInReadingRulerMode) {
            if (this.activeTransformData.transformData?.animating || this.activeTransformData.transformData?.userGestureActive) this.hideReadingRuler(false);
            else setTimeout(()=>{
                this.showReadingRuler(false);
            }, 500);
        } else if (!this.activeTransformData && this.isInReadingRulerMode) // As there is no transform data, we are no longer zoomed in.
        // However, we are still supposed to show the reading ruler.
        setTimeout(()=>{
            this.showReadingRuler(false);
        }, 500);
    }
    _vanillaReaderEvent_visibleContentRectsChanged(ev) {
        this.visibleContentRectData = ev.detail.clientRects;
        this.readingRuler.setContentLineBoxes(this.visibleContentRectData);
    }
    _vanillaReaderEvent_mediaPlayerCreated(_ev) {
        this._onMediaPlayerIsReadyToPlay();
    }
    // The `SyncMediaPlayer` instance (TTS, MO and Audiobooks) in the `VanillaReader` has started playing, or has paused.
    _vanillaReaderEvent_mediaPlayerPlaybackStateChanged(ev) {
        this.latestSyncMediaPlaybackStateData = ev.detail.state;
        if (ev.detail.state.isPaused) {
            this.menuMediaPlayer.stateIsPlaying = false;
            this.fabSpeakText.stateIsSpeaking = false;
        } else this.menuMediaPlayer.stateIsPlaying = true;
        this.fabMediaPlayer.stateIsPlaying = this.menuMediaPlayer.stateIsPlaying;
        if (window.navigator.mediaSession) this.onMediaPlayerPlaybackStateChanged(ev.detail.state);
    }
    // The `VanillaReaderAudiobookMediaPlayer` instance in the `VanillaReader` has progressed to a new timeline position.
    // Note: This event fires every 1000ms.
    _vanillaReaderEvent_mediaPlayerPlaybackPositionChanged(ev) {
        this.latestSyncMediaPlaybackStateData = ev.detail.state;
        if (window.navigator.mediaSession && ev.detail.state) this.onMediaPlayerPlaybackPositionChanged(ev.detail.state);
    }
    // The `VanillaReaderAudiobookMediaPlayer` instance in the `VanillaReader` has progressed to a new segment.
    _vanillaReaderEvent_mediaPlayerSeekCompleted(ev) {
        let playbackState = ev.detail.state;
        this.latestSyncMediaPlaybackStateData = playbackState;
        if (window.navigator.mediaSession) this.onMediaPlayerSeekCompleted(playbackState);
        if (ev.detail.state.navigationItems && ev.detail.state.navigationItems.length >= 0) {
            // Only grab the first item in the navigaionItems array to circumvent a bug in Beta1
            this.dialogContents?.setActiveTocItems([
                ev.detail.state.navigationItems[0]
            ]);
            this.dialogContents?.setActivePageItems([
                ev.detail.state.navigationItems[0]
            ]);
        }
    }
    _cancelAllActiveTimeouts() {
        if (this.readerViewPointerHoverTimeoutHandle) clearTimeout(this.readerViewPointerHoverTimeoutHandle);
        if (this.selectionTimeoutHandle) clearTimeout(this.selectionTimeoutHandle);
        if (this.readerViewPointerUpTimeoutHandle) clearTimeout(this.readerViewPointerUpTimeoutHandle);
    }
}


class $07cb77a13df2a195$export$f317f8d05aaf6c48 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogBookmarks.onBookmarkItemClicked(vanillaReaderUiContext._onDialogBookmarksItemClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogBookmarks.onBookmarkItemButtonClicked(vanillaReaderUiContext._onDialogBookmarkItemButtonClicked.bind(vanillaReaderUiContext));
    }
    _onDialogBookmarksItemClicked(navigationData) {
        if (navigationData.locator) this.navigateTo(navigationData.locator.toString());
        this.dialogBookmarks?.close();
    }
    _onDialogBookmarkItemButtonClicked(bookmark) {
        this.vanillaReaderAPI?.deleteBookmark(bookmark.locator);
        this.dialogBookmarks?.close();
    }
}







class $90fcc7ba9e85f12d$export$464365d0f40f6901 {
    constructor(_vanillaReaderAppMain){
        this._vanillaReaderAppMain = _vanillaReaderAppMain;
        this._vanillaReaderAppMain.onVanillaReaderInstanceCreated(()=>{
            const vanillaReader = this._vanillaReaderAppMain.getVanillaReaderInstance();
            if (!vanillaReader) throw new Error("VanillaReaderAPI.constructor(): vanillaReaderAppMain.getVanillaReaderInstance() returned undefined.");
            this._vanillaReader = vanillaReader;
            (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_OPTIONS_CHANGED", (_ev)=>{
                const uiOptionsData = this.serializeToVanillaReaderAppUiOptionsData();
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("APP_UI_OPTIONS_CHANGED", {
                    uiOptionsData: uiOptionsData
                }));
            });
        });
    }
    get vanillaReader() {
        if (!this._vanillaReader) throw new Error("VanillaReaderAPI.vanillaReader(): VanillaReader has not been instantiated.");
        return this._vanillaReader;
    }
    static get instance() {
        return $90fcc7ba9e85f12d$export$464365d0f40f6901._vanillaReaderApiInstance;
    }
    static create(appMain) {
        $90fcc7ba9e85f12d$export$464365d0f40f6901._vanillaReaderApiInstance = new $90fcc7ba9e85f12d$export$464365d0f40f6901(appMain);
        return $90fcc7ba9e85f12d$export$464365d0f40f6901._vanillaReaderApiInstance;
    }
    get shouldFocusOnReadingPosition() {
        return this.vanillaReader.shouldFocusOnReadingPosition;
    }
    get isOffline() {
        return this.vanillaReader.isOffline;
    }
    get isMobileScreenSize() {
        return window.matchMedia("only screen and (max-width: 480px)").matches;
    }
    get isInDarkMode() {
        return this._vanillaReaderAppMain.activeAppUiTheme?.uiIsDark || true;
    }
    get useDeviceStorage() {
        return this._vanillaReaderAppMain.useDeviceStorage;
    }
    setAppMainColorTheme(colorTheme) {
        this._vanillaReaderAppMain.changeAppUiColorTheme(colorTheme);
    }
    static addEventListener(event, listener, once = false) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener(event, listener, once);
    }
    static removeEventListener(eventType, listener) {
        (0, $84c7b345e247d474$export$51b4df07290407).removeEventListener(eventType, listener);
    }
    static dispatchEvent(event) {
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(event);
    }
    serializeToVanillaReaderOptionsData() {
        return this.vanillaReader.serializeToOptionsData();
    }
    serializeToVanillaReaderAppUiOptionsData() {
        return this._collateVanillaReaderUiOptionsData();
    }
    /**
     *
     * This method takes in an AWS UID and tries to load a publication from it. "Under the hood" it uses the
     * Colibrio `ReadingSystemEngine`, so have a peek at the `VanillaReaderReadingSystem.loadPublicationFromAws()`
     *
     * @param uid - Base64 Encoded UID
     * @param initialLocator - Optional. A publication location to navigate to after the publication has been loaded.
     * @return void
     *
     * @fires IVanillaReaderAppEvent_PUBLICATION_LOADED
     * @fires IVanillaReaderAppEvent_PUBLICATION_LOAD_FAILED
     * */ loadPublicationFromUid(uid, initialLocator) {
        this._vanillaReaderAppMain.loadPublicationFromAws(uid, initialLocator).catch(console.warn);
    }
    /**
     *
     * This method takes in a File object and tries to load a publication from it. "Under the hood" it uses the
     * Colibrio `ReadingSystemEngine`, so have a peek at the `VanillaReaderReadingSystem.loadPublicationFromFile()`
     *
     * @param fileObject - A File object to the publication resource.
     * @param initialLocator - Optional. A publication location to navigate to after the publication has been loaded.
     * @param storeOnDevice - Optional. Should the loaded publication data be cached on the device for offline access?.
     * @return void
     *
     * @fires IVanillaReaderAppEvent_PUBLICATION_LOADED
     * @fires IVanillaReaderAppEvent_PUBLICATION_LOAD_FAILED
     * */ loadPublicationFromFile(fileObject, initialLocator, storeOnDevice) {
        this._vanillaReaderAppMain.loadPublicationFromFile(fileObject, initialLocator, storeOnDevice).catch(console.warn);
    }
    /**
     *
     * This method takes in a URL as a string and tries to load a publication from it. "Under the hood" it uses the
     * Colibrio `ReadingSystemEngine`, so have a peek at the `VanillaReaderReadingSystem.loadPublicationFromUrl()`
     *
     * @param url - A string URL that points to a publication resource file
     * @param initialLocator - Optional. A publication location to navigate to after the publication has been loaded.
     * @param storeOnDevice - Optional. Should the `IRandomAccessDataSource` instance used when loading the publication use IndexedDB for long term caching?
     * @return void
     *
     * @fires IVanillaReaderAppEvent_PUBLICATION_LOADED
     * @fires IVanillaReaderAppEvent_PUBLICATION_LOAD_FAILED
     * */ loadPublicationFromUrl(url, initialLocator, storeOnDevice) {
        this._vanillaReaderAppMain.loadPublicationFromUrl(url, initialLocator, storeOnDevice).catch(console.warn);
    }
    /**
     *
     * This method takes in a IVanillaReaderShelfItemData object. It identifies the origin of the file and tries to load
     * the publication data from using the `IVanillaReaderStreamedResourceStorage` storage client.
     *
     * @param shelfItemData - "Shelf item data" contains metadata about the "used book", along with reading position, bookmarks and hightlights.
     * @return void
     *
     * @fires IVanillaReaderAppEvent_PUBLICATION_LOADED
     * @fires IVanillaReaderAppEvent_PUBLICATION_LOAD_FAILED
     * */ loadPublicationFromShelfItemData(shelfItemData) {
        this._vanillaReaderAppMain.loadPublicationFromShelfItemData(shelfItemData).catch(console.warn);
    }
    closePublication() {
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(new CustomEvent("PUBLICATION_CLOSE_INTENT"));
        this._vanillaReaderAppMain.closePublication();
    }
    /**
     *
     * Navigates to the position described in the locator.
     *
     * @param locator - The locator to navigate to as an `ILocator` or as a string
     * @param options - The `IReaderViewGotoOptions.setReadingPositionToVisibleRangeStart` option "snaps" the reading
     * position to the start of the visible content if set to `true`. Default is `false` meaning that the reading position
     * will be at the precise position described in the locator.
     *
     * @fires IVanillaReaderAppEvent_NAVIGATION_STARTED
     * @fires IVanillaReaderAppEvent_NAVIGATION_COMPLETED
     * @fires IVanillaReaderAppEvent_READING_POSITION_UPDATED
     * @fires IVanillaReaderAppEvent_TIMELINE_POSITION_UPDATED
     *
     * */ goTo(locator, options) {
        console.log(`GoTo: ${locator.toString()}`);
        this.vanillaReader.goTo(locator, options).catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_NAVIGATION_STARTED
     * @fires IVanillaReaderAppEvent_NAVIGATION_COMPLETED
     * @fires IVanillaReaderAppEvent_READING_POSITION_UPDATED
     * @fires IVanillaReaderAppEvent_TIMELINE_POSITION_UPDATED
     * */ goToStart() {
        this.vanillaReader.goToStart().catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_NAVIGATION_STARTED
     * @fires IVanillaReaderAppEvent_NAVIGATION_COMPLETED
     * @fires IVanillaReaderAppEvent_READING_POSITION_UPDATED
     * @fires IVanillaReaderAppEvent_TIMELINE_POSITION_UPDATED
     * */ next() {
        this.vanillaReader.next().catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_NAVIGATION_STARTED
     * @fires IVanillaReaderAppEvent_NAVIGATION_COMPLETED
     * @fires IVanillaReaderAppEvent_READING_POSITION_UPDATED
     * @fires IVanillaReaderAppEvent_TIMELINE_POSITION_UPDATED
     * */ previous() {
        this.vanillaReader.previous().catch(console.warn);
    }
    /**
     *
     * This method navigates to a location in the book based on a given position off the readingProgressionTimeline.
     * The behavior differs a bit depending on the book format. If it's an EPUB or PDF we first need to resolve the
     * timeline position to a `IContentLocation` that we can then use as a parameter when calling `goTo`.
     * If it is an Audiobook things are much simpler. Since the timeline represents the duration of the audiobook in
     * milliseconds, we can just seek directly to that position in the book.
     *
     * @fires IVanillaReaderAppEvent_NAVIGATION_STARTED
     * @fires IVanillaReaderAppEvent_NAVIGATION_COMPLETED
     * @fires IVanillaReaderAppEvent_READING_POSITION_UPDATED
     * @fires IVanillaReaderAppEvent_TIMELINE_POSITION_UPDATED
     *
     * * */ gotoTimelinePosition(position) {
        this.vanillaReader.gotoTimelinePosition(position).catch(console.warn);
    }
    /**
     *
     * This method gets the timeline position as a number. If the loaded `IReaderPublication` is an Audiobook the number
     * represents the progression in ms. If the `IReaderPublication` is a reflowable EPUB the returned number represents
     * the index of the word at the current position. For PDF and Fixed Layout EPUBs the number represents the current
     * page index.
     *
     * */ getTimelinePosition() {
        return this.vanillaReader.getTimelinePosition();
    }
    createAnnotationLayer(locator) {
        if (typeof locator !== "undefined" && this._vanillaReader?.vanillaPublication && this.vanillaReader.vanillaReaderView) {
            locator = this._vanillaReader?.vanillaPublication.colibrioReaderPublication.getDefaultLocatorUrl() + "#" + locator;
            let locatorParsed = this._vanillaReader?.vanillaPublication.colibrioReaderPublication.getLocatorFactory().parse(locator);
            if (locatorParsed.locator && locatorParsed.locator.getSelectors().length > 0 && locatorParsed.locator.getSelectors()[0].isRangeSelector()) {
                let annotationLayer = this.vanillaReader.vanillaReaderView.colibrioReaderView.createAnnotationLayer("share-selection-highlight");
                annotationLayer.setLayerOptions({
                    layerStyle: {
                        "mix-blend-mode": "multiply",
                        "opacity": "0.4"
                    }
                });
                annotationLayer.destroyAllAnnotations();
                let annotation = annotationLayer.createAnnotation(locatorParsed.locator);
                annotation.setOptions({
                    rangeStyle: {
                        "background-color": "#36d677"
                    }
                });
            }
        }
    }
    setRenderableDocuments(spreadAccess) {
        let readerPublication = this._vanillaReader?.vanillaPublication?.colibrioReaderPublication;
        if (typeof readerPublication === "undefined") return;
        let readerDocuments = readerPublication.getSpine().filter((readerDocument)=>{
            return readerDocument.getSourceContentDocument().isInLinearContent();
        });
        if (spreadAccess) {
            if (spreadAccess !== '"all"' && JSON.parse(spreadAccess)) {
                console.log("Colibrio access is restricted (A)");
                let accessArray = JSON.parse(spreadAccess);
                readerDocuments = readerPublication.getSpine().filter((readerDocument)=>{
                    var isAllowed = false;
                    let selector = readerDocument.getLocator().getSelectors()[0];
                    if (selector.getType() == (0, $6ecee67d716c9b7a$export$4e8b093ec8dcab0d).FRAGMENT_SELECTOR) {
                        let cfi = selector;
                        if (typeof accessArray[cfi.getValue()] !== "undefined") isAllowed = accessArray[cfi.getValue()];
                        else if (typeof accessArray["#" + cfi.getValue()] !== "undefined") isAllowed = accessArray["#" + cfi.getValue()];
                        else if (typeof accessArray[readerPublication?.getDefaultLocatorUrl() + "#" + cfi.getValue()] !== "undefined") isAllowed = accessArray[readerPublication?.getDefaultLocatorUrl() + "#" + cfi.getValue()];
                    }
                    return readerDocument.getSourceContentDocument().isInLinearContent() && isAllowed;
                });
            } else if (spreadAccess !== '"all"' && spreadAccess !== "") {
                console.log("Colibrio access is restricted (S)");
                let accessArray = spreadAccess.split(",").map((val)=>{
                    if (isNaN(parseInt(val))) return val;
                    return parseInt(val) - 1;
                });
                if (accessArray.length > 0) readerDocuments = readerPublication.getSpine().filter((readerDocument)=>{
                    let isAllowed = false;
                    let selector = readerDocument.getLocator().getSelectors()[0];
                    if (selector.getType() == (0, $6ecee67d716c9b7a$export$4e8b093ec8dcab0d).FRAGMENT_SELECTOR) {
                        let cfi = selector;
                        if (accessArray.indexOf(cfi.getValue()) > -1) isAllowed = true;
                    }
                    return readerDocument.getSourceContentDocument().isInLinearContent() && isAllowed;
                });
            }
        }
        this._vanillaReader?.vanillaReaderView?.setReaderDocuments(readerDocuments);
    }
    /**
     *
     * This method searches the entire publication, or a subset of documents, for the provided search string.
     * In order to be able to perform a search, the search index must first be built. This is done adhoc in the
     * `VanillaReaderPublication.search()` method.
     *
     * @fires IVanillaReaderAppEvent_PUBLICATION_SEARCH_INDEX_BUILD_PROGRESS
     * @fires IVanillaReaderAppEvent_PUBLICATION_SEARCH_INDEX_READY
     * @fires IVanillaReaderAppEvent_PUBLICATION_SEARCH_COMPLETED
     *
     * */ searchPublication(searchString, resultSetMaxSize, documentIndexes, highlightResults = true) {
        this.vanillaReader.searchPublication(searchString, resultSetMaxSize, documentIndexes, highlightResults).then((resultSet)=>{
            const event = (0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_SEARCH_COMPLETED", {
                resultSet: resultSet
            });
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent(event);
        }).catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_PUBLICATION_SEARCH_CLEARED
     * */ clearPublicationSearchLayer() {
        return this.vanillaReader.clearPublicationSearchLayer();
    }
    /**
     * This method is a "quirkfix" to let Screen Reader users (primarily NVDA and JAWS) highlight text based on the contents
     * of their clipboard.
     *
     * The reason that we need this is because of the Screen Readers inability to scroll the document as it moves through
     * the document contents. This is a problem for us since we use the visible range as a means to know where the user
     * is reading, so without a change in the visible range we can't can add a correct highlight or bookmark.
     *
     * The way that the Screen Reader user will use this feature is as follows:
     *
     * 1. The user selects and copies the text that represents the location they want highlight or bookmark.
     * 2. The user uses some method to trigger a UI call to this method, sending along the text that is currently
     * in the user's clipboard as well as the document index in the publication spine.
     * 3. This method uses the publication search to grab the first occurrence of the string in the specified document.
     * 4. The result is communicated back to the user using the `HIGHLIGHT_ADDED` / `BOOKMARK_ADDED` or
     * `HIGHLIGHT_TEXTLOCATION_FAILED` / `BOOKMARK_TEXTLOCATION_FAILED` events.
     *
     * @fires IVanillaReaderAppEvent_BOOKMARK_ADDED
     * @fires IVanillaReaderAppEvent_BOOKMARK_TEXTLOCATION_FAILED
     *
     * */ bookmarkTextLocation(textToBookmark, documentIndex) {
        this.vanillaReader.bookmarkTextLocation(textToBookmark, documentIndex).catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_BOOKMARK_ADDED
     * */ bookmarkReadingPosition() {
        this.vanillaReader.bookmarkReadingPosition().catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_HIGHLIGHT_ADDED
     * */ addHighlight(highlightData) {
        this.vanillaReader.addHighlight(highlightData).catch(console.warn);
    }
    /**
     * This method is a quirkfix to let Screen Reader users (primarily NVDA and JAWS) highlight text based on the contents
     * of their clipboard.
     *
     * The reason that we need this is because of the Screen Readers inability to scroll the document as it moves through
     * the document contents. This is a problem for us since we use the visible range as a means to know where the user
     * is reading, so without a change in the visible range we can't can add a correct highlight or bookmark.
     *
     * The way that the Screen Reader user will use this feature is as follows:
     *
     * 1. The user selects and copies the text that represents the location they want highlight or bookmark.
     * 2. The user uses some method to trigger a UI call to this method, sending along the text that is currently
     * in the user's clipboard as well as the document index in the publication spine.
     * 3. This method uses the publication search to grab the first occurrence of the string in the specified document.
     * 4. The result is communicated back to the user using the `HIGHLIGHT_ADDED` / `BOOKMARK_ADDED` or
     * `HIGHLIGHT_TEXTLOCATION_FAILED` / `BOOKMARK_TEXTLOCATION_FAILED` events.
     *
     * @fires IVanillaReaderAppEvent_HIGHLIGHT_ADDED
     * @fires IVanillaReaderAppEvent_HIGHLIGHT_TEXTLOCATION_FAILED
     *
     * */ highlightTextLocation(textToHighlight, documentIndex, sourceHighlightData) {
        this.vanillaReader.highlightTextLocation(textToHighlight, documentIndex, sourceHighlightData).catch(console.warn);
    }
    /**
     *
     * This method helps a Screen Reader focus on the current reading position by calling `HTMLElement.focus()` as close
     * to the current reading position as possible.
     *
     * @fires IVanillaReaderAppEvent_FOCUS_ON_READINGPOSITION_DONE
     * @fires IVanillaReaderAppEvent_FOCUS_ON_READINGPOSITION_FAILED
     *
     * */ focusOnReadingPosition() {
        this.vanillaReader.focusOnReadingPosition().catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_RENDERER_ASPECT_RATIO_CHANGED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ ignorePublicationAspectRatio(ignoreAspectRatio) {
        this.vanillaReader.ignorePublicationAspectRatio(ignoreAspectRatio);
    }
    /**
     * @fires IVanillaReaderAppEvent_PUBLICATION_LANDMARKS_READY
     * */ fetchPublicationLandmarks(landmarkTypesToInclude) {
        return this.vanillaReader.fetchPublicationLandmarks(landmarkTypesToInclude).then((landmarkCollection)=>{
            let headings = landmarkCollection?.headings || [];
            let footnotes = landmarkCollection?.footnotes || [];
            let figures = landmarkCollection?.figures || [];
            let tables = landmarkCollection?.tables || [];
            let lists = landmarkCollection?.lists || [];
            (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_LANDMARKS_READY", {
                headings: headings,
                footnotes: footnotes,
                figures: figures,
                tables: tables,
                lists: lists
            }));
        });
    }
    /**
     * @fires IVanillaReaderAppEvent_DOCUMENT_LANDMARKS_READY
     * */ fetchDocumentLandmarks(documentIndex, landmarkTypesToInclude) {
        return this.vanillaReader.fetchDocumentLandmarks(documentIndex, landmarkTypesToInclude);
    }
    /**
     * @fires IVanillaReaderAppEvent_NAVIGATION_STARTED
     * @fires IVanillaReaderAppEvent_NAVIGATION_COMPLETED
     * @fires IVanillaReaderAppEvent_READING_POSITION_UPDATED
     * @fires IVanillaReaderAppEvent_TIMELINE_POSITION_UPDATED
     * */ navigate(navigationAction) {
        this.vanillaReader.navigate(navigationAction);
    }
    /**
     * @fires IVanillaReaderAppEvent_BOOKMARK_ADDED
     * */ addBookmark(bookmarkLocator) {
        this.vanillaReader.addBookmark(bookmarkLocator);
    }
    /**
     * @fires IVanillaReaderAppEvent_BOOKMARK_DELETED
     * @fires IVanillaReaderAppEvent_BOOKMARKS_COLLECTION_UPDATED
     * */ deleteBookmark(bookmarkLocator) {
        this.vanillaReader.deleteBookmark(bookmarkLocator);
    }
    /**
     * @fires IVanillaReaderAppEvent_HIGHLIGHT_UPDATED
     * @fires IVanillaReaderAppEvent_HIGHLIGHTS_COLLECTION_UPDATED
     * */ updateHighlight(highlightData) {
        this.vanillaReader.updateHighlight(highlightData);
    }
    /**
     * @fires IVanillaReaderAppEvent_HIGHLIGHT_DELETED
     * @fires IVanillaReaderAppEvent_HIGHLIGHTS_COLLECTION_UPDATED
     * */ deleteHighlight(highlightLocator) {
        this.vanillaReader.deleteHighlight(highlightLocator);
    }
    /**
     * @fires IVanillaReaderAppEvent_PUBLICATION_OPTIONS_CHANGED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ setPublicationOptions(publicationOptions) {
        this.vanillaReader.setPublicationOptions(publicationOptions);
    }
    /**
     * @fires IVanillaReaderAppEvent_PUBLICATION_STYLE_OPTIONS_CHANGED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ setPublicationStyleOptions(styleOptions) {
        this.vanillaReader.setPublicationStyleOptions(styleOptions);
    }
    revokeMediaObjectUrl(mediaUrl) {
        this.vanillaReader.revokeMediaObjectUrl(mediaUrl);
    }
    fetchContentPositionDataForHref(href, baseDocumentLocator) {
        return this.vanillaReader.fetchContentPositionDataForHref(href, baseDocumentLocator);
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_PAGE_MARKERS_VISIBILITY_CHANGED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ toggleReaderViewPageMarkerVisibility(visible) {
        this.vanillaReader.toggleReaderViewPageMarkerVisibility(visible);
    }
    /**
     * @fires IVanillaReaderAppEvent_REDUCED_MOTION_OPTION_CHANGED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ useReducedMotion(useReducedMotion) {
        this.vanillaReader.useReducedMotion(useReducedMotion);
    }
    /**
     * @fires IVanillaReaderAppEvent_RENDERER_CHANGED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ changeRenderer(rendererName, ignoreAspectRatio) {
        this.vanillaReader.changeRenderer(rendererName, ignoreAspectRatio);
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_WILL_REFRESH
     * */ refreshReaderView(force) {
        this.vanillaReader.refreshReaderView(force);
    }
    clearContentSelection() {
        this.vanillaReader.clearContentSelection();
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_CREATED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_CREATE_PROGRESS_UPDATED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_ATTACHED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_DETACHED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ toggleMediaPlayer(activate, options) {
        this.vanillaReader.toggleMediaPlayer(activate, options).catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED
     *
     * */ seekMediaPlaybackNext() {
        this.vanillaReader.seekMediaPlaybackNext();
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED
     *
     * */ seekMediaPlaybackPrevious() {
        this.vanillaReader.seekMediaPlaybackPrevious();
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED
     *
     * */ seekMediaPlaybackForward() {
        this.vanillaReader.seekMediaPlaybackForward();
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED
     *
     * */ seekMediaPlaybackBackward() {
        this.vanillaReader.seekMediaPlaybackBackward();
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED
     *
     * */ seekMediaToPlaybackRangeStart() {
        this.vanillaReader.seekMediaToPlaybackRangeStart();
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED
     *
     * */ seekMediaToLocator(locator) {
        this.vanillaReader.seekMediaToLocator(locator);
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_SEEK_COMPLETED
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_POSITION_CHANGED
     *
     * */ seekMediaToLocatorWithinVisibleRange(locator) {
        this.vanillaReader.seekMediaToLocatorWithinVisibleRange(locator);
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_STATE_CHANGED
     * */ startMediaPlayback(locator) {
        this.vanillaReader.startMediaPlayback(locator).catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_PLAYBACK_STATE_CHANGED
     * */ pauseMediaPlayback() {
        this.vanillaReader.pauseMediaPlayback();
    }
    playTimelineRange(range, options) {
        this.vanillaReader.vanillaMediaPlayer?.playTimelineRange(range, options);
    }
    /**
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ setMediaPlaybackRate(rate) {
        this.vanillaReader.setMediaPlaybackRate(rate);
    }
    /**
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ setMediaPlaybackVolume(volume) {
        this.vanillaReader.setMediaPlaybackVolume(volume);
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_VOICE_CHANGED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ setTtsVoice(voiceName) {
        this.vanillaReader.setTtsVoice(voiceName).catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_MEDIAPLAYER_VOICE_LIST_FETCH_RESULT
     * */ fetchTtsVoiceCollection() {
        return this.vanillaReader.fetchTtsVoiceCollection();
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_TRANSFORM_PAN_MODE_ACTIVATED
     * @fires IVanillaReaderAppEvent_VIEW_TRANSFORM_CHANGED
     * */ activatePanZoomMode() {
        this.vanillaReader.activatePanZoomMode();
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_TRANSFORM_RESET
     * @fires IVanillaReaderAppEvent_VIEW_TRANSFORM_PAN_MODE_DEACTIVATED
     * */ deactivatePanZoomMode() {
        this.vanillaReader.deactivatePanZoomMode();
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_TRANSFORM_CHANGED
     * */ zoomToClientRect(zoomRect, animate) {
        return this.vanillaReader.zoomToClientRect(zoomRect, animate);
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_TRANSFORM_CHANGED
     * */ zoomToPublicationViewportClientRect(zoomRect, unit, transformOptions) {
        this.vanillaReader.zoomToPublicationViewportClientRect(zoomRect, unit, transformOptions);
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_TRANSFORM_RESET
     * */ resetZoom() {
        this.vanillaReader.resetZoom();
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_TRANSFORM_CHANGED
     * */ zoomToLevel(zoomLevel, animate) {
        this.vanillaReader.zoomToLevel(zoomLevel, animate).catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_PUBLICATION_OPTIONS_CHANGED
     * */ scrollOverflowingTables(scrollOverflowingTables) {
        this.vanillaReader.scrollOverflowingTables(scrollOverflowingTables);
    }
    /**
     * @fires IVanillaReaderAppEvent_PUBLICATION_RESOURCES_DELETED
     * */ deletePublicationResources(shelfItemData) {
        this._vanillaReaderAppMain.deletePublicationResources(shelfItemData).catch(console.warn);
    }
    /**
     * @fires IVanillaReaderAppEvent_VIEW_OPTIONS_CHANGED
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ setViewOptions(viewOptions) {
        this.vanillaReader.vanillaReaderView?.setVanillaReaderViewOptions(viewOptions);
    }
    playAmbientMedia() {
        if (this.vanillaReader.ambientMediaPlayer) this.vanillaReader.ambientMediaPlayer.play().catch(console.warn);
    }
    stopAmbientMedia() {
        if (this.vanillaReader.ambientMediaPlayer) this.vanillaReader.ambientMediaPlayer.pause();
    }
    /**
     * This method sets all UI related options across all modules and components in the Vanilla Reader app.
     * In the Colibrio Reader Framework there are many options that affect rendering. For example: font and text related
     * options, such as color values, line height and font style are options on the `IPublicationStyleOptions`; options
     * such as page aspect ratio, page turn animations belong to `IRendererOptions` etc.
     *
     * When calling this method, it will apply all these options. Very convenient.
     *
     * @param uiOptions - A *complete* set of options of type `IVanillaReaderUiOptionsData`. Missing options will be reset
     * to the defaults specified in the `VanillaReaderAppUiDefaults.options` object.
     *
     * @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     * */ setAppUiOptions(uiOptions) {
        if (!this._vanillaReader) {
            console.warn("VanillaReaderAPI.setAppUiOptions(), no VanillaReader instance has been referenced.");
            return;
        }
        let activePalette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === uiOptions.activeUiPaletteName);
        const defaultPalette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === "Dark");
        const defaultOptions = (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options;
        if (!activePalette) activePalette = defaultPalette;
        uiOptions.useAccessibilityMode = uiOptions.useAccessibilityMode !== undefined ? uiOptions.useAccessibilityMode : defaultOptions.useAccessibilityMode;
        uiOptions.useDarkMode = uiOptions.useDarkMode !== undefined ? uiOptions.useDarkMode : defaultOptions.useDarkMode;
        uiOptions.activeRendererTypeName = uiOptions.activeRendererTypeName || (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE;
        uiOptions.ignoreAspectRatio = uiOptions.ignoreAspectRatio !== undefined ? uiOptions.ignoreAspectRatio : defaultOptions.ignoreAspectRatio;
        uiOptions.useReducedMotion = uiOptions.useReducedMotion !== undefined ? uiOptions.useReducedMotion : defaultOptions.useReducedMotion;
        uiOptions.scrollOverflowingTables = uiOptions.scrollOverflowingTables !== undefined ? uiOptions.scrollOverflowingTables : defaultOptions.scrollOverflowingTables;
        uiOptions.mediaPlayerPlaybackRate = uiOptions.mediaPlayerPlaybackRate !== undefined ? uiOptions.mediaPlayerPlaybackRate : defaultOptions.mediaPlayerPlaybackRate;
        uiOptions.readingRulerOptions = uiOptions.readingRulerOptions !== undefined ? uiOptions.readingRulerOptions : (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions;
        uiOptions.showPageNumbers = uiOptions.showPageNumbers !== undefined ? uiOptions.showPageNumbers : defaultOptions.showPageNumbers;
        uiOptions.showNarrationControls = uiOptions.showNarrationControls !== undefined ? uiOptions.showNarrationControls : defaultOptions.showNarrationControls;
        uiOptions.publicationStyleOptions = uiOptions.publicationStyleOptions !== undefined ? uiOptions.publicationStyleOptions : defaultOptions.publicationStyleOptions;
        uiOptions.ttsOptions = uiOptions.ttsOptions !== undefined ? uiOptions.ttsOptions : defaultOptions.ttsOptions;
        if (uiOptions.publicationStyleOptions) this.setPublicationStyleOptions(uiOptions.publicationStyleOptions);
        this.setViewOptions({
            activeRendererTypeName: uiOptions.activeRendererTypeName,
            ignoreAspectRatio: uiOptions.ignoreAspectRatio,
            useReducedMotion: uiOptions.useReducedMotion
        });
        this.toggleReaderViewPageMarkerVisibility(uiOptions.showPageNumbers);
        this.scrollOverflowingTables(uiOptions.scrollOverflowingTables);
        this.setMediaPlaybackRate(uiOptions.mediaPlayerPlaybackRate);
        this.setTtsVoice(uiOptions.ttsOptions?.voiceName);
        this.setAppMainColorTheme(activePalette);
    }
    /**
     * Reset to the defaults specified in the `VanillaReaderAppUiDefaults.options` object.
     *
     *  @fires IVanillaReaderAppEvent_APP_UI_OPTIONS_CHANGED
     **/ resetAppUiOptions() {
        let defaultPalette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === "Default");
        // Create a deep copy of the default options.
        const defaultOptionsString = JSON.stringify((0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options);
        const defaultOptions = JSON.parse(defaultOptionsString);
        defaultOptions.useAccessibilityMode = defaultOptions.useAccessibilityMode !== undefined ? defaultOptions.useAccessibilityMode : false;
        defaultOptions.useDarkMode = defaultOptions.useDarkMode !== undefined ? defaultOptions.useDarkMode : false;
        defaultOptions.activeRendererTypeName = defaultOptions.activeRendererTypeName || (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE;
        defaultOptions.ignoreAspectRatio = this.isMobileScreenSize ? true : defaultOptions.ignoreAspectRatio !== undefined ? defaultOptions.ignoreAspectRatio : false;
        defaultOptions.useReducedMotion = defaultOptions.useReducedMotion !== undefined ? defaultOptions.useReducedMotion : false;
        defaultOptions.scrollOverflowingTables = defaultOptions.scrollOverflowingTables !== undefined ? defaultOptions.scrollOverflowingTables : false;
        defaultOptions.mediaPlayerPlaybackRate = defaultOptions.mediaPlayerPlaybackRate !== undefined ? defaultOptions.mediaPlayerPlaybackRate : 1;
        defaultOptions.readingRulerOptions = {
            rulerBackgroundColor: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.rulerBackgroundColor,
            overlayIsVisible: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.overlayIsVisible,
            lineBoxLineSpan: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.lineBoxLineSpan,
            snapToLineBoxes: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.snapToLineBoxes
        };
        defaultOptions.showPageNumbers = defaultOptions.showPageNumbers !== undefined ? defaultOptions.showPageNumbers : true;
        defaultOptions.showNarrationControls = defaultOptions.showNarrationControls !== undefined ? defaultOptions.showNarrationControls : false;
        // Finally we set the PublicationStyleOptions
        if (defaultOptions.publicationStyleOptions) {
            defaultOptions.publicationStyleOptions.palette = null;
            this.setPublicationStyleOptions(defaultOptions.publicationStyleOptions);
        }
        this.setViewOptions({
            activeRendererTypeName: defaultOptions.activeRendererTypeName,
            ignoreAspectRatio: defaultOptions.ignoreAspectRatio,
            useReducedMotion: defaultOptions.useReducedMotion
        });
        this.toggleReaderViewPageMarkerVisibility(defaultOptions.showPageNumbers);
        this.scrollOverflowingTables(defaultOptions.scrollOverflowingTables);
        this.setMediaPlaybackRate(defaultOptions.mediaPlayerPlaybackRate);
        this.setTtsVoice(defaultOptions.ttsOptions?.voiceName);
        this.setAppMainColorTheme(defaultPalette);
    }
    /**
     *
     * Gets all the current options for the resulting `IVanillaReaderUiOptionsData` from the various modules and components
     * in the Vanilla Reader app.
     *
     * */ _collateVanillaReaderUiOptionsData() {
        const vanillaReaderViewOptions = this.vanillaReader.vanillaReaderView?.getCurrentVanillaReaderViewOptionsState();
        const vanillaReaderPublicationStyleOptions = this._vanillaReader?.vanillaPublication?.publicationStyleOptions;
        const vanillaReaderSyncMediaOptions = this._vanillaReader?.vanillaMediaPlayer?.getPlaybackOptions();
        const vanillaReaderTtsOptions = this._vanillaReader?.vanillaMediaPlayer?.getTtsPlaybackOptions();
        let activeUiColorTheme;
        if (vanillaReaderPublicationStyleOptions?.palette) activeUiColorTheme = this._getMatchingUiColorThemeByPublicationStylePalette(vanillaReaderPublicationStyleOptions.palette);
        let options = {};
        const uiOptions = this._vanillaReaderAppMain.getVanillaReaderUiInstance()?.serializeToUiOptionsData() || {};
        options.readingRulerOptions = uiOptions.readingRulerOptions;
        options.useAccessibilityMode = uiOptions.useAccessibilityMode;
        options.showNarrationControls = uiOptions.showNarrationControls;
        options.showReadingRuler = uiOptions.showReadingRuler;
        options.ttsOptions = vanillaReaderTtsOptions || uiOptions.ttsOptions;
        options.scrollOverflowingTables = vanillaReaderViewOptions?.scrollOverflowingTables;
        options.ignoreAspectRatio = vanillaReaderViewOptions?.ignoreAspectRatio;
        options.showPageNumbers = vanillaReaderViewOptions?.showPageRangesLayer;
        options.activeRendererTypeName = vanillaReaderViewOptions?.activeRendererTypeName;
        options.useReducedMotion = vanillaReaderViewOptions?.useReducedMotion;
        options.publicationStyleOptions = vanillaReaderPublicationStyleOptions;
        options.mediaPlayerPlaybackRate = vanillaReaderSyncMediaOptions?.rate;
        options.activeUiPaletteName = activeUiColorTheme?.name;
        options.activePublicationFontSetName = vanillaReaderPublicationStyleOptions?.fontSet?.name;
        options.activePublicationPaletteName = activeUiColorTheme?.name;
        options.useDarkMode = activeUiColorTheme?.uiIsDark;
        return options;
    }
    _getMatchingUiColorThemeByPublicationStylePalette(stylePalette) {
        return (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>{
            return palette.accent === stylePalette.accent && palette.backgroundDark === stylePalette.backgroundDark && palette.backgroundLight === stylePalette.backgroundLight && palette.foregroundDark === stylePalette.foregroundDark && palette.foregroundLight === stylePalette.foregroundLight;
        });
    }
    /**
     *
     * EVENT CALLBACKS
     *
     * */ onAmbientAudioReady(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("AMBIENT_AUDIO_READY", callback, once);
    }
    onAmbientAudioNotFound(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("AMBIENT_AUDIO_NOT_FOUND", callback, once);
    }
    onAppLoaded(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_LOADED", callback, once);
    }
    onAppOnlineStateChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_ONLINE_STATE_CHANGED", callback, once);
    }
    onBookmarkAdded(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARK_ADDED", callback, once);
    }
    onBookmarkClicked(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARK_CLICKED", callback, once);
    }
    onBookmarkDeleted(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARK_DELETED", callback, once);
    }
    onBookmarkInVisibleRange(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARK_IN_VISIBLE_RANGE", callback, once);
    }
    onBookmarkOutsideVisibleRange(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARK_OUTSIDE_VISIBLE_RANGE", callback, once);
    }
    onBookmarkTextLocationFailed(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARK_TEXTLOCATION_FAILED", callback, once);
    }
    onBookmarksCollectionUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARKS_COLLECTION_UPDATED", callback, once);
    }
    onBookmarksLoaded(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("BOOKMARKS_LOADED", callback, once);
    }
    onClick(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("CLICK", callback, once);
    }
    onDocumentIsAtEnd(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("DOCUMENT_IS_AT_END", callback, once);
    }
    onDocumentIsAtStart(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("DOCUMENT_IS_AT_START", callback, once);
    }
    onDocumentLandmarksReady(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("DOCUMENT_LANDMARKS_READY", callback, once);
    }
    onHighlightAdded(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_ADDED", callback, once);
    }
    onHighlightClicked(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_CLICKED", callback, once);
    }
    onHighlightDeleted(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_DELETED", callback, once);
    }
    onHighlightInVisibleRange(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_IN_VISIBLE_RANGE", callback, once);
    }
    onHighlightOutsideVisibleRange(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_OUTSIDE_VISIBLE_RANGE", callback, once);
    }
    onHighlightTextLocationFailed(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_TEXTLOCATION_FAILED", callback, once);
    }
    onHighlightUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHT_UPDATED", callback, once);
    }
    onHighlightsCollectionUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHTS_COLLECTION_UPDATED", callback, once);
    }
    onHighlightsLoaded(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("HIGHLIGHTS_LOADED", callback, once);
    }
    onMediaObjectViewIntent(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIA_OBJECT_VIEW_INTENT", callback, once);
    }
    onMediaPlayerAttached(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_ATTACHED", callback, once);
    }
    onMediaPlayerCreated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_CREATED", callback, once);
    }
    onMediaPlayerDetached(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_DETACHED", callback, once);
    }
    onMediaPlayerPlaybackPositionChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_PLAYBACK_POSITION_CHANGED", callback, once);
    }
    onMediaPlayerPlaybackStateChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_PLAYBACK_STATE_CHANGED", callback, once);
    }
    onMediaPlayerSeekCompleted(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_SEEK_COMPLETED", callback, once);
    }
    onMediaPlayerPlaybackRangeEndReached(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_PLAYBACK_RANGE_END_REACHED", callback, once);
    }
    onMediaPlayerPlaybackRangeRemoved(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_PLAYBACK_RANGE_REMOVED", callback, once);
    }
    onMediaPlayerVoiceChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_VOICE_CHANGED", callback, once);
    }
    onMediaPlayerEscapabilityContextChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_ESCAPABILITY_CONTEXT_CHANGED", callback, once);
    }
    onMediaObjectClicked(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIA_OBJECT_CLICKED", callback, once);
    }
    onMediaPlayerVoiceListChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("MEDIAPLAYER_VOICE_LIST_CHANGED", callback, once);
    }
    onNavigationCompleted(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("NAVIGATION_COMPLETED", callback, once);
    }
    onNavigationGotoInternalLocationIntent(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("NAVIGATION_INTERNAL_INTENT", callback, once);
    }
    onNavigationOpenRemoteAddressIntent(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("NAVIGATION_EXTERNAL_INTENT", callback, once);
    }
    onNavigationStarted(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("NAVIGATION_STARTED", callback, once);
    }
    onNavigationTreeReady(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("NAVIGATION_TREE_READY", callback, once);
    }
    onPublicationDownloadProgressUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_DOWNLOAD_PROGRESS_UPDATED", callback, once);
    }
    onPublicationIsAtStart(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_IS_AT_START", callback, once);
    }
    onPublicationIsAtEnd(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_IS_AT_END", callback, once);
    }
    onPublicationLandmarksReady(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_LANDMARKS_READY", callback, once);
    }
    onPublicationLoadFailed(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_LOAD_FAILED", callback, once);
    }
    onPublicationLoaded(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_LOADED", callback, once);
    }
    onPublicationPageListReady(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_PAGE_LIST_READY", callback, once);
    }
    onPublicationPageNumberVisibilityChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_PAGE_MARKERS_VISIBILITY_CHANGED", callback, once);
    }
    onPublicationRendered(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_RENDERED", callback, once);
    }
    onPublicationSearchCompleted(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_SEARCH_COMPLETED", callback, once);
    }
    onPublicationStyleOptionsChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_STYLE_OPTIONS_CHANGED", callback, once);
    }
    onPublicationViewportChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_VIEWPORT_CHANGED", callback, once);
    }
    onPublicationShelfUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_SHELF_UPDATED", callback, once);
    }
    onReaderKeyUp(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("KEY_UP", callback, once);
    }
    onReaderKeyDown(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("KEY_DOWN", callback, once);
    }
    onReaderViewPointerDown(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("POINTER_DOWN", callback, once);
    }
    onReaderViewPointerMove(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("POINTER_MOVE", callback, once);
    }
    onReaderViewPointerUp(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("POINTER_UP", callback, once);
    }
    onReadingPositionUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("READING_POSITION_UPDATED", callback, once);
    }
    onReducedMotionOptionChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("REDUCED_MOTION_OPTION_CHANGED", callback, once);
    }
    onRendererAspectRatioChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("RENDERER_ASPECT_RATIO_CHANGED", callback, once);
    }
    onRendererChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("RENDERER_CHANGED", callback, once);
    }
    onTextSelected(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("TEXT_SELECTED", callback, once);
    }
    onTimelinePositionUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("TIMELINE_POSITION_UPDATED", callback, once);
    }
    onTimelineBuildProcessUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("TIMELINE_BUILD_PROCESS_UPDATED", callback, once);
    }
    onTimelineReady(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("TIMELINE_READY", callback, once);
    }
    onViewTransformChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_TRANSFORM_CHANGED", callback, once);
    }
    onViewTransformStopped(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_TRANSFORM_STOPPED", callback, once);
    }
    onViewTransitionEnded(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_TRANSITION_ENDED", callback, once);
    }
    onViewTransitionStarted(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_TRANSITION_STARTED", callback, once);
    }
    onVisibleContentRectsChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VISIBLE_CONTENT_RECTS_CHANGED", callback, once);
    }
    onVisibleContentRendered(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VISIBLE_CONTENT_RENDERED", callback, once);
    }
    onVisiblePagesChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VISIBLE_PAGES_CHANGED", callback, once);
    }
    onVisibleRangeDataChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VISIBLE_RANGE_DATA_CHANGED", callback, once);
    }
    onPublicationSearchCleared(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_SEARCH_CLEARED", callback, once);
    }
    onPublicationStoredResourcesDeleted(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_STORED_RESOURCES_DELETED", callback, once);
    }
    onViewPanZoomModeActivated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_TRANSFORM_PAN_MODE_ACTIVATED", callback, once);
    }
    onViewPanZoomModeDeactivated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_TRANSFORM_PAN_MODE_DEACTIVATED", callback, once);
    }
    onViewSwipeNavigationProgressUpdated(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_SWIPE_NAVIGATION_PROGRESS_UPDATED", callback, once);
    }
    onAppWindowResized(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_WINDOW_RESIZED", callback, once);
    }
    onAppUiOptionsReset(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_UI_OPTIONS_RESET", callback, once);
    }
    onAppUiOptionsChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_UI_OPTIONS_CHANGED", callback, once);
    }
    onAppUiOptionsPresetApplied(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_UI_OPTIONS_PRESET_APPLIED", callback, once);
    }
    onAppUiThemeChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("APP_UI_THEME_CHANGED", callback, once);
    }
    onPublicationClose(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_CLOSE_INTENT", callback, once);
    }
    onViewOptionsChanged(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_OPTIONS_CHANGED", callback, once);
    }
    onViewWillRefresh(callback, once) {
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_WILL_REFRESH", callback, once);
    }
}


class $04f27b2dd57ea0c6$export$9f8c079b7aa8a777 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogOpenFile.onBookshelfItemsRendered(vanillaReaderUiContext._onBookshelfItemsRendered.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogOpenFile.onFileSelected(vanillaReaderUiContext._onDialogOpenFileSelected.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogOpenFile.onFileListItemClicked(vanillaReaderUiContext._onDialogOpenFileOpenUrl.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogOpenFile.onShelfListItemClicked(vanillaReaderUiContext._onDialogOpenFileOpenShelfItem.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogOpenFile.onFileListItemDeletePublicationResourcesButtonClicked(vanillaReaderUiContext._onDialogOpenFilePublicationResourcesDeleteButtonClicked.bind(vanillaReaderUiContext));
    }
    _onDialogOpenFileSelected(fileObject) {
        let storeOnDevice = this.useDeviceStorage; // If we run as a Progressive Web App we can store the downloaded data for offline reading.
        (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance?.loadPublicationFromFile(fileObject, undefined, storeOnDevice);
        this.toaster.toast(`Opening ${fileObject.name}`).catch(console.warn);
    }
    _onDialogOpenFileOpenShelfItem(shelfItemData) {
        (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance?.loadPublicationFromShelfItemData(shelfItemData);
        this.toaster.toast(`Opening ${shelfItemData.fileName}`).catch(console.warn);
    }
    _onDialogOpenFileOpenUrl(fileUrl) {
        // We should really use the url here as the file name is not guaranteed to be unique.
        let fileName = fileUrl.slice(fileUrl.lastIndexOf("/") + 1);
        // If we run as a Progressive Web App we can store the downloaded data for offline reading.
        let storeOnDevice = this.useDeviceStorage;
        (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance?.loadPublicationFromUrl(fileUrl, undefined, storeOnDevice);
        this.toaster.toast(`Opening ${fileName}`).catch(console.warn);
    }
    _onDialogOpenFilePublicationResourcesDeleteButtonClicked(shelfItemData) {
        if (window.confirm(`Are you sure you want to remove "${shelfItemData.title}", including all bookmarks and annotations?`)) (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance?.deletePublicationResources(shelfItemData);
    }
    _onBookshelfItemsRendered() {
    //console.log('_onBookshelfItemsRendered');
    }
}


class $16eafaf23f2ea416$export$2a16cdd44c6e04c1 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogFootnote.onGotoFootnoteButtonClicked(vanillaReaderUiContext._onDialogFootnoteButtonGotoFootnoteClicked.bind(vanillaReaderUiContext));
    }
    _onDialogFootnoteButtonGotoFootnoteClicked(locator) {
        if (locator) this.navigateTo(locator, true);
        this.dialogFootnote.close(true, false);
    }
    _onDialogFootnoteClosed(result) {
        if (result.data) this.navigateTo(result.data, true);
    }
}



class $6810f3e03d125232$export$be7e850a7e40f346 {
    static __initialize__(vanillaReaderUiContext) {
        // Static event callbacks that are triggered regardless of what dialog instance are opened and closed.
        (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004).sharedOnDialogOpened(vanillaReaderUiContext._uiEvent_dialogOpened.bind(vanillaReaderUiContext));
        (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004).sharedOnDialogClosed(vanillaReaderUiContext._uiEvent_dialogClosed.bind(vanillaReaderUiContext));
        // This callback is a bit of a workaround to manage the FocusTrap focus management. Ironic right? ;)
        // When the FocusTrap is deactivated we can safely move focus back to the current reading position.
        (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004).sharedOnDialogFocusTrapDeactivated(vanillaReaderUiContext._uiEvent_dialogFocusTrapDeactivated.bind(vanillaReaderUiContext));
    }
    _uiEvent_dialogOpened(dialogInstance, dialogTitle, _silent = false) {
        this.setReaderViewAsNotImportantForAccessibility();
        this.activeDialogTitle = dialogTitle;
        this.activeDialog = dialogInstance;
        this.setReaderViewAsNotImportantForAccessibility();
        this.menuBottom.getComponentElement().inert = true;
    }
    _uiEvent_dialogClosed(_dialogInstance, dialogTitle, silent = false) {
        this.setReaderViewAsImportantForAccessibility();
        this.activeDialogTitle = undefined;
        this.activeDialog = undefined;
        if (!silent) this.toaster.toast(`Dialog ${dialogTitle} closed`).catch(console.error);
        if (this.sendRefreshIntentAfterDialogClosed) this.refreshReaderView(true);
        this.setReaderViewAsImportantForAccessibility();
        this.menuBottom.getComponentElement().inert = false;
    }
    _uiEvent_dialogFocusTrapDeactivated(returnFocusOnClose) {
        if (returnFocusOnClose) this.focusOnReadingPosition();
    }
}


class $cb95b37fbaffd425$export$b3b810734fdcfd10 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogImageViewer.onDialogClosed(vanillaReaderUiContext._onDialogImageViewerDialogClosed.bind(vanillaReaderUiContext));
    }
    _onDialogImageViewerDialogClosed(dialogResult) {
        this.vanillaReaderAPI.revokeMediaObjectUrl(dialogResult.data);
    }
}


class $8df163c44ff9e3dc$export$29d2ca8ac9db0202 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogSearch.onSearchResultItemClicked(vanillaReaderUiContext._onDialogSearchResultItemClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogSearch.onSearchExecute(vanillaReaderUiContext._onDialogSearchExecute.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.dialogSearch.onSearchClear(vanillaReaderUiContext._onDialogSearchClear.bind(vanillaReaderUiContext));
    }
    _onDialogSearchExecute(searchTerm) {
        this.searchPublication(searchTerm);
    }
    _onDialogSearchClear() {
        this.vanillaReaderAPI?.clearPublicationSearchLayer();
        this.toaster.toast("Search results cleared", true).catch(console.warn);
        this.latestSelectedSearchResultLocator = undefined;
    }
    _onDialogSearchResultItemClicked(navigationData) {
        if (navigationData.locator) {
            // Let's save this locator so that we can use it to highlight the correct result item the next time we show
            // the same search result.
            this.latestSelectedSearchResultLocator = navigationData.locator;
            this.navigateTo(navigationData.locator.toString());
        }
        this.dialogSearch.close(true);
        this.menuSide.hide(true, true);
    }
}



class $ed8eb279e0f9a27e$export$54cf3042660a7067 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext: vanillaReaderUiContext.fabHighlight.onClick(vanillaReaderUiContext._onFabHighlightClicked.bind(vanillaReaderUiContext));
    }
    _onFabHighlightClicked() {
        if (this.activeSelection && this.activeSelection.selector) {
            let highlight = {
                locator: this.activeSelection.selector,
                color: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow,
                selectionText: this.activeSelection.selectionText,
                comment: ""
            };
            this.dialogHighlight?.setState(highlight, true);
            this.dialogHighlight?.show();
        }
    }
}


class $f126b516cbe55a33$export$88d1321d45ccc568 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.fabMediaPlayer.onClick(vanillaReaderUiContext._onFabMediaPlayerClicked.bind(vanillaReaderUiContext));
    }
    _onFabMediaPlayerClicked() {
        if (!this.menuMediaPlayer.stateIsPlaying) this.startPlayback();
        else this.pausePlayback();
    }
}


class $8f75d7714857d362$export$6698851ae1c2b42b {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogContents.onNavItemClicked(vanillaReaderUiContext._onDialogContentsNavigationItemClicked.bind(vanillaReaderUiContext));
    }
    _onDialogContentsNavigationItemClicked(navigationData) {
        if (navigationData.locator) this.navigateTo(navigationData.locator.toString());
        this.menuBottom.hide();
        this.dialogContents?.close(false, false);
    }
}



class $26f03edaca4cc466$export$2ed97b2d9ba7d085 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogUiActions.onActionItemClicked(vanillaReaderUiContext._onDialogActionsItemSelected.bind(vanillaReaderUiContext));
    }
    _onDialogActionsItemSelected(actionName) {
        let closeActionsDialogAfterActionHasBeenCalled = true;
        const onAfterChildDialogClosed = ()=>{
            this.dialogUiActions.close(true, false);
            this.focusOnReadingPosition();
        };
        switch(actionName){
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MAIN_MENU_OPEN:
                this.menuBottom.show(!this.useReducedMotion);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT:
                this.navigateNext();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS:
                this.navigatePrevious();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_DIALOG_OPEN:
                // If we have an active selection we use this text to populate the search input.
                if (this.activeSelection?.selectionText) this.dialogSearch.setSearchTerm(this.activeSelection.selectionText);
                this.dialogSearch.show(false, false, onAfterChildDialogClosed, this.latestSelectedSearchResultLocator);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_CLEAR:
                this.dialogSearch.clear();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_READING_POSITION:
                this.bookmarkReadingPosition();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_CLIPBOARD:
                this.bookmarkClipboardContents().catch(console.warn);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).TOC_OPEN_DIALOG:
                this.dialogContents.show(false, true, onAfterChildDialogClosed);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_DIALOG_OPEN:
                this.dialogSettings.show(false, false, onAfterChildDialogClosed);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKSHELF_DIALOG_OPEN:
                this.closePublicationAndShowFileOpenDialog();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION:
                this.closeAllDialogsAndFocusOnReadingPosition();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ALL:
                this.dialogBookmarks.show(false, false, onAfterChildDialogClosed);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ACTIVE:
                this.dialogBookmarks.show(false, false, onAfterChildDialogClosed, true);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ALL:
                this.dialogHighlights.show(false, false, onAfterChildDialogClosed);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ACTIVE:
                this.dialogHighlights.show(false, false, onAfterChildDialogClosed, true);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HELP_DIALOG_OPEN:
                this.dialogHelp.show(false, false, onAfterChildDialogClosed);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_SELECTION:
                if (this.activeSelection) this.showHighlightDialogWithActiveSelectionState();
                else closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_CLIPBOARD:
                this.highlightClipboardContents().catch(()=>{
                    this.toaster.toast("Unable to use system clipboard", true).catch(console.warn);
                    closeActionsDialogAfterActionHasBeenCalled = false;
                });
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_ACTIVE_CONTENT:
                this.highlightVisibleRange(false);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_READING_POSITION:
                this.highlightReadingPosition(false);
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).WHERE_AM_I:
                this.toastReadingPosition().catch(console.warn);
                closeActionsDialogAfterActionHasBeenCalled = false;
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT_HEADING:
                this.navigateToNextHeading();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS_HEADING:
                this.navigateToPreviousHeading();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_START:
                this.openMediaPlayer(true);
                this.startMediaPlayer();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_STOP:
                this.closeMediaPlayer();
                this.focusOnReadingPosition();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_ENTER:
                this.enterAccessibilityMode();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_EXIT:
                this.exitAccessibilityMode();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).GOTO_PAGE_DIALOG_OPEN:
                this.showGoToPagePrompt();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATION_HISTORY_DIALOG_OPEN:
                this.dialogNavigationHistory.show();
                break;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).LANDMARKS_DIALOG_OPEN:
                this.dialogLandmarks.show();
                break;
        }
        if (closeActionsDialogAfterActionHasBeenCalled) this.dialogUiActions.close(true);
    }
}



class $949d3c060ef3afe0$export$a9dafad5522a1a3b {
    constructor(_hostElement, insertPosition = "afterbegin", options){
        this._hostElement = _hostElement;
        this._style = `
        <style>            
        :root {
              --vanilla-reader__ruler__overlay__ruler-clip-box-top: 0;
              --vanilla-reader__ruler__overlay__ruler-clip-box-left: 0;
              --vanilla-reader__ruler__overlay__ruler-clip-box-bottom: 0;
              --vanilla-reader__ruler__overlay__ruler-clip-box-right: 0;            

        }
            #vanilla-reader__ruler__overlay {            
                display: none;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                pointer-events: none;
                touch-action: none;
                background-color: transparent;
                mix-blend-mode: multiply;                
                z-index: 1;
                clip-path: polygon( evenodd,
                    /* overlay rect */
                    0 0,
                    100% 0,
                    100% 100%,
                    0% 100%,
                    0 0,
                    /* ruler clip rect */
                    var(--vanilla-reader__ruler__overlay__ruler-clip-box-left) var(--vanilla-reader__ruler__overlay__ruler-clip-box-top),
                    var(--vanilla-reader__ruler__overlay__ruler-clip-box-right) var(--vanilla-reader__ruler__overlay__ruler-clip-box-top),
                    var(--vanilla-reader__ruler__overlay__ruler-clip-box-right) var(--vanilla-reader__ruler__overlay__ruler-clip-box-bottom),
                    var(--vanilla-reader__ruler__overlay__ruler-clip-box-left) var(--vanilla-reader__ruler__overlay__ruler-clip-box-bottom),
                    var(--vanilla-reader__ruler__overlay__ruler-clip-box-left) var(--vanilla-reader__ruler__overlay__ruler-clip-box-top)             
                );
                opacity: 0;                
            }
        
            #vanilla-reader__ruler {
                top: 0;
                left: 0;
                width: 100%;                
                z-index: 1;                
                position: fixed;
                display: none;
                flex-direction: row;
                align-items: center;
                justify-content:center;                      
                mix-blend-mode: multiply;
                touch-action: none;
                opacity: 0;     
                box-shadow: 0 0 16px rgb(0 0 0 / 8%);                  
            }
            
            #vanilla-reader__ruler__linebox {
                flex-grow: 8;                
                mix-blend-mode: initial;
                border: 0;
                border-inline: none;
                pointer-events: none;
            }
            
            #vanilla-reader__ruler__drag-handle-start {
                flex-grow: 1;
            }
    
            #vanilla-reader__ruler__drag-handle-end {
                flex-grow: 1;                                
            }
            
            .vanilla-reader__ruler__drag-handle {
                display: none;
                outline: 2px solid rgb(0 0 0 / 25%);
                height: 64px;
                width: 64px;
                min-width: 64px;
                border-radius: 4px;
            }
            
            .isBeingDragged {
                box-shadow: 0 4px 16px rgb(0 0 0 / 16%) !important;             
            }
        </style>
    `;
        this._template = `
        <div id="vanilla-reader__ruler__overlay" aria-hidden="true"></div>
        <div id="vanilla-reader__ruler" aria-hidden="true">
            <div class="vanilla-reader__ruler__drag-handle" id="vanilla-reader__ruler__drag-handle-start"></div>
            <div id="vanilla-reader__ruler__linebox"></div>
            <div class="vanilla-reader__ruler__drag-handle" id="vanilla-reader__ruler__drag-handle-end"></div>
        </div>
    `;
        this._uiFadeDuration = 200;
        this._isBeingDragged = false;
        this._rulerLineBoxElementOffsetTop = ((0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions?.rulerBorderTopWidth || 0) + ((0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions?.lineBoxBorderTopWidth || 0);
        this._rulerLineBoxElementOffsetBottom = ((0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions?.rulerBorderBottomWidth || 0) + ((0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions?.lineBoxBorderBottomWidth || 0);
        this._rulerLineBoxMinHeight = (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.lineBoxMinHeight;
        this._rulerLineBoxSpan = (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.lineBoxLineSpan;
        this._rulerDragThreshold = (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.rulerDragThreshold;
        this._rulerOpacity = (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.rulerOpacity;
        this._snapToContentLineBoxes = (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions.snapToLineBoxes;
        this._contentLineBoxRects = [];
        this._contentLineBoxRectData = [];
        this._currentIntersectingContentLineBoxRect = undefined;
        this._currentIntersectingContentLineBoxIndex = undefined;
        this._currentRulerLineBoxRect = undefined;
        this._contentLineBoxIntersectionMargin = 4;
        this._contentLineBoxMinWidthThreshold = 8;
        this._contentLineBoxAverageHeight = this._rulerLineBoxMinHeight;
        this._rulerLineBoxVerticalSpacingFactor = 1.8;
        this._animationDuration = 200;
        this._pageOverlayOpacity = 0.8;
        this._useReducedMotion = false;
        this._debugMode = false;
        this._onRulerClick = (ev)=>{
            if (this._onRulerClickCallback && this._initialPointerDownPosition && Math.abs(this._initialPointerDownPosition.y - ev.clientY) < 2) this._onRulerClickCallback(ev);
            this._initialPointerDownPosition = undefined;
        };
        this._onPointerDown = (ev)=>{
            this._initialPointerDownPosition = {
                x: ev.clientX,
                y: ev.clientY
            };
            try {
                this._rulerElement.setPointerCapture(ev.pointerId);
            } catch (e) {}
        };
        this._onPointerUp = (ev)=>{
            // Update the intersection data based on the new ruler position
            this._updateIntersectingContentLineBoxData();
            if (this.isBeingDragged) this._onDragEnd(ev);
            try {
                this._rulerElement.releasePointerCapture(ev.pointerId);
            } catch (e) {}
            if (this._initialPointerDownPosition && Math.abs(this._initialPointerDownPosition.y - ev.clientY) > 2) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        };
        this._onPointerMove = (ev)=>{
            if (!(ev.buttons & 1) || !this._initialPointerDownPosition || Math.abs(ev.clientY - this._initialPointerDownPosition.y) < this._rulerDragThreshold) return;
            else if (this.isBeingDragged) this._onDrag(ev);
            else this._onDragStart(ev);
        };
        this._onDragStart = (ev)=>{
            this._isBeingDragged = true;
            this._currentIntersectingContentLineBoxRect = undefined;
            this._currentIntersectingContentLineBoxIndex = undefined;
            let rulerElementClientRect = this.rulerBoundingBox;
            let newLineHeight = Math.min(this._contentLineBoxAverageHeight * this._rulerLineBoxVerticalSpacingFactor * this._rulerLineBoxSpan, this._rulerLineBoxMinHeight * this._rulerLineBoxSpan * this._rulerLineBoxVerticalSpacingFactor);
            this._currentRulerLineBoxRect = this.setRulerLineBoxHeight(newLineHeight, false);
            this._dragStartPositionOffset = {
                x: ev.clientX - rulerElementClientRect.left,
                y: ev.clientY - rulerElementClientRect.top
            };
            this.moveTo(ev.clientY, false);
            this._rulerElement.classList.add("isBeingDragged");
            if (this._onRulerDragStartCallback) this._onRulerDragStartCallback(ev);
        };
        this._onDrag = (ev)=>{
            if (!this.isBeingDragged || !this._dragStartPositionOffset) return;
            ev.preventDefault();
            ev.stopPropagation();
            if (this._onRulerDragCallback) this._onRulerDragCallback(ev);
            this.moveTo(ev.clientY, false);
            let rulerElementClientRect = this.rulerBoundingBox;
            if (rulerElementClientRect.bottom >= window.innerHeight) {
                if (this._onRulerAtScreenBottomCallback) this._onRulerAtScreenBottomCallback(ev);
            }
            if (rulerElementClientRect.top <= 0) {
                if (this._onRulerAtScreenTopCallback) this._onRulerAtScreenTopCallback(ev);
            }
        };
        this._onDragEnd = (ev)=>{
            if (this._snapToContentLineBoxes) {
                if (this._currentIntersectingContentLineBoxRect) this.moveToAndAlign(this._currentIntersectingContentLineBoxRect.y, this._currentIntersectingContentLineBoxRect.height, !this.useReducedMotion);
            }
            if (this._onRulerDragEndCallback && this._currentIntersectingContentLineBoxIndex) this._onRulerDragEndCallback(ev, this._contentLineBoxRectData[this._currentIntersectingContentLineBoxIndex]);
            this._rulerElement.classList.remove("isBeingDragged");
            this._isBeingDragged = false;
            this._dragStartPositionOffset = undefined;
        };
        this._onTransitionEndOrCancel = (_ev)=>{
            this._updateIntersectingContentLineBoxData();
        };
        this._hostElement.insertAdjacentHTML(insertPosition, this._style);
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._rulerElement = this._hostElement.querySelector("#vanilla-reader__ruler");
        this._rulerLineBoxElement = this._hostElement.querySelector("#vanilla-reader__ruler__linebox");
        this._rulerOverlayElement = this._hostElement.querySelector("#vanilla-reader__ruler__overlay");
        // this._rulerDragHandleStart = this._hostElement.querySelector('#vanilla-reader__ruler__drag-handle-start')!;
        // this._rulerDragHandleEnd = this._hostElement.querySelector('#vanilla-reader__ruler__drag-handle-end')!;
        this._rulerElement.addEventListener("click", this._onRulerClick);
        this._rulerElement.addEventListener("pointerdown", this._onPointerDown);
        this._rulerElement.addEventListener("pointerup", this._onPointerUp);
        this._rulerElement.addEventListener("pointermove", this._onPointerMove);
        this._rulerElement.addEventListener("pointercancel", this._onPointerUp);
        this._rulerElement.addEventListener("transitionend", this._onTransitionEndOrCancel);
        this._rulerElement.addEventListener("transitioncancel", this._onTransitionEndOrCancel);
        this._activeOptions = this._applyOptions(options || {});
        this._toggleUiAnimations(this.useReducedMotion);
    }
    get position() {
        return {
            x: this._rulerElement.offsetLeft,
            y: this._rulerElement.offsetTop
        };
    }
    get isOverlayVisible() {
        return this._rulerOverlayElement.style.visibility != "hidden";
    }
    get isVisible() {
        return this._rulerElement.style.display === "flex";
    }
    get isBeingDragged() {
        return this._isBeingDragged;
    }
    get isAtStartOfContent() {
        return this._currentIntersectingContentLineBoxIndex !== undefined ? this._currentIntersectingContentLineBoxIndex === 0 : false;
    }
    get isAtEndOfContent() {
        return this._currentIntersectingContentLineBoxIndex !== undefined ? this._currentIntersectingContentLineBoxIndex >= this._contentLineBoxRects.length - this._rulerLineBoxSpan : false;
    }
    get rulerLineBoxBoundingBox() {
        let rect = this._rulerLineBoxElement.getBoundingClientRect();
        return new DOMRect(Math.floor(rect.x), Math.floor(rect.y), Math.floor(rect.width), Math.floor(rect.height));
    }
    get rulerBoundingBox() {
        let rect = this._rulerElement.getBoundingClientRect();
        return new DOMRect(Math.floor(rect.x), Math.floor(rect.y), Math.floor(rect.width), Math.floor(rect.height));
    }
    set useReducedMotion(state) {
        this._useReducedMotion = state;
        this._toggleUiAnimations(!state);
    }
    get useReducedMotion() {
        return this._useReducedMotion;
    }
    get snapToContentLineBoxes() {
        return this._snapToContentLineBoxes;
    }
    set snapToContentLineBoxes(shouldSnap) {
        if (shouldSnap != this._snapToContentLineBoxes) this.setOptions({
            snapToLineBoxes: shouldSnap
        });
    }
    onClick(callback) {
        this._onRulerClickCallback = callback;
    }
    onDragEnd(callback) {
        this._onRulerDragEndCallback = callback;
    }
    onDragStart(callback) {
        this._onRulerDragStartCallback = callback;
    }
    onDrag(callback) {
        this._onRulerDragCallback = callback;
    }
    onMoveEnd(callback) {
        this._onRulerMoveEndCallback = callback;
    }
    onAtScreenTop(callback) {
        this._onRulerAtScreenTopCallback = callback;
    }
    onAtScreenBottom(callback) {
        this._onRulerAtScreenBottomCallback = callback;
    }
    onVisible(callback) {
        this._onVisibleCallback = callback;
    }
    onHidden(callback) {
        this._onHiddenCallback = callback;
    }
    showPageOverlay() {
        this._rulerOverlayElement.style.visibility = "visible";
    }
    hidePageOverlay() {
        this._rulerOverlayElement.style.visibility = "hidden";
    }
    setOptions(options) {
        return this._applyOptions(options);
    }
    setContentLineBoxes(rectData, _filterOutOverlappingLines = true) {
        let processedRectData = [];
        this._currentIntersectingContentLineBoxRect = undefined;
        this._currentIntersectingContentLineBoxIndex = undefined;
        processedRectData = this._filterOutBelowMinWidthLineBoxes(rectData);
        if (this._debugMode) this._drawDebugContentLineBoxes(processedRectData);
        let totalContentLineBoxHeight = this._rulerLineBoxMinHeight;
        processedRectData.forEach((rect)=>{
            totalContentLineBoxHeight += rect.clientRect.height;
        });
        this._contentLineBoxAverageHeight = totalContentLineBoxHeight / processedRectData.length;
        this._contentLineBoxRectData = processedRectData;
        this._contentLineBoxRects = processedRectData.map((rectData)=>rectData.clientRect);
    }
    setRulerLineBoxHeight(heightRequestInPx, animate = true) {
        // The useReducedMotion option always overrides any param value
        if (this.useReducedMotion) animate = false;
        this._toggleUiAnimations(animate);
        let newLineBoxHeight = Math.max(heightRequestInPx, this._rulerLineBoxMinHeight);
        let rulerLineBoxRect = new DOMRect(0, this._rulerLineBoxElementOffsetTop + this._rulerElement.offsetTop, this._rulerElement.clientWidth, newLineBoxHeight);
        this._rulerLineBoxElement.style.height = `${newLineBoxHeight}px`;
        this._moveAndScaleOverlayMaskRect(rulerLineBoxRect);
        return rulerLineBoxRect;
    }
    moveTo(y, animate = true, relativeToLineBox = false, affectReadingPosition = true) {
        // There are many factors that can trigger the ruler to move, such as user interaction, but also
        // changes in reading position. In order to not react to redundant calls we check if we actually
        // need to move.
        if (!this._rulerNeedsToMove(y)) return;
        let rulerLineBoxElementOffsetTop = relativeToLineBox ? this._rulerLineBoxElementOffsetTop : 0;
        // The useReducedMotion option always overrides any param value
        if (this.useReducedMotion) animate = false;
        this._toggleUiAnimations(animate);
        let rulerLineBoxRect = this._currentRulerLineBoxRect || this.rulerLineBoxBoundingBox;
        let newRulerTop;
        if (this._dragStartPositionOffset) {
            // Take into account the drag offset set by the `rulerDragThreshold` option.
            newRulerTop = y - Math.floor(this._dragStartPositionOffset.y + rulerLineBoxElementOffsetTop);
            this._rulerElement.style.top = newRulerTop + "px";
        } else {
            newRulerTop = Math.max(y - rulerLineBoxElementOffsetTop, 0);
            this._rulerElement.style.top = newRulerTop + "px";
        }
        this._moveAndScaleOverlayMaskRect(new DOMRect(rulerLineBoxRect.x, newRulerTop + this._rulerLineBoxElementOffsetTop, rulerLineBoxRect.width, rulerLineBoxRect.height));
        if (!this.isBeingDragged) // After both the line box animation and move animation have finished update the intersection data.
        // Also call the onMoveEnd callback.
        setTimeout(()=>{
            this._updateIntersectingContentLineBoxData();
            if (this._currentRulerLineBoxRect) this.setRulerLineBoxHeight(this._currentRulerLineBoxRect.height);
            this._onMoveEnd(affectReadingPosition);
        }, this._animationDuration * 2);
    }
    moveToAndAlign(y, contentLineBoxHeight, animate = true, affectReadingPosition = true) {
        let newLineBoxRect;
        // There are many factors that can trigger the ruler to move, such as user interaction, but also
        // changes in reading position. In order to not react to redundant calls we check if we actually
        // need to move.
        if (!this._rulerNeedsToMove(y)) return;
        // The useReducedMotion option always overrides any param value
        if (this.useReducedMotion) animate = false;
        this._toggleUiAnimations(animate);
        const getLineBoxHeightFunction = ()=>{
            let rulerLineBoxHeight;
            if (this._currentRulerLineBoxRect) {
                let currentIndex = this._currentIntersectingContentLineBoxIndex != undefined && this._currentIntersectingContentLineBoxIndex >= 0 ? this._currentIntersectingContentLineBoxIndex : 0;
                let endIndex = currentIndex + this._rulerLineBoxSpan;
                let contentLineBoxSpanBoundingBox = this._getBoundingBoxForContentLineBoxSpan(this._contentLineBoxRects, currentIndex, endIndex);
                rulerLineBoxHeight = contentLineBoxSpanBoundingBox.height; //Math.min(contentLineBoxSpanHeight, this._rulerMaxHeight);
            } else rulerLineBoxHeight = (contentLineBoxHeight ? contentLineBoxHeight : this._contentLineBoxAverageHeight) * this._rulerLineBoxSpan;
            this._currentRulerLineBoxRect = this._getRulerLineBoxFromHeightRequest(rulerLineBoxHeight);
            return this._currentRulerLineBoxRect;
        };
        const moveToAndScaleFunction = (rulerLineBoxRect)=>{
            // let rulerRect = new DOMRect(
            //     rulerLineBoxRect.x,
            //     rulerLineBoxRect.y - this._rulerLineBoxElementOffsetTop,
            //     rulerLineBoxRect.width,
            //     this._rulerLineBoxElementOffsetTop + rulerLineBoxRect.height + this._rulerLineBoxElementOffsetBottom
            // );
            let newTopPosition = Math.floor(y - this._rulerLineBoxElementOffsetTop);
            this._rulerElement.style.top = `${newTopPosition}px`;
            this._rulerLineBoxElement.style.height = `${rulerLineBoxRect.height}px`;
            let overlayMaskRect = new DOMRect(rulerLineBoxRect.x, y, rulerLineBoxRect.width, rulerLineBoxRect.height);
            this._moveAndScaleOverlayMaskRect(overlayMaskRect);
            return overlayMaskRect;
        };
        if (animate) {
            // After the move has completed, we scale the box to fit the configured no of line boxes
            newLineBoxRect = getLineBoxHeightFunction();
            // Move the ruler to its new top position.
            setTimeout(()=>{
                moveToAndScaleFunction(newLineBoxRect);
            }, this._animationDuration);
        } else {
            newLineBoxRect = getLineBoxHeightFunction();
            moveToAndScaleFunction(newLineBoxRect);
        }
        // After both the line box animation and move animation have finished update the intersection data.
        // Also call the onMoveEnd callback.
        setTimeout(()=>{
            this._updateIntersectingContentLineBoxData();
            this._onMoveEnd(affectReadingPosition);
        }, this._animationDuration * 2);
    }
    moveToNextContentLineBox(animate = true, affectReadingPosition = true) {
        // The useReducedMotion option always overrides any param value
        if (this.useReducedMotion) animate = false;
        if (this._currentIntersectingContentLineBoxRect && this._contentLineBoxRects && this._currentIntersectingContentLineBoxIndex !== undefined && this._currentIntersectingContentLineBoxIndex < this._contentLineBoxRects.length - 1) {
            let nextLineBox;
            let nextLineBoxIndex = Math.min(this._currentIntersectingContentLineBoxIndex + this._rulerLineBoxSpan, this._contentLineBoxRects.length);
            let intersectingLineBox = this._currentIntersectingContentLineBoxRect;
            for(let i = nextLineBoxIndex; this._contentLineBoxRects.length > i; i++){
                let currentLineBox = this._contentLineBoxRects[i];
                if (currentLineBox.y >= intersectingLineBox.y + intersectingLineBox.height - this._contentLineBoxIntersectionMargin && !this._domRectsAreEquiv(intersectingLineBox, currentLineBox)) {
                    nextLineBox = currentLineBox;
                    nextLineBoxIndex = i;
                    break;
                }
            }
            if (nextLineBox) {
                this._updateIntersectingContentLineBoxData(nextLineBox, nextLineBoxIndex);
                if (this.snapToContentLineBoxes) this.moveToAndAlign(nextLineBox.y, nextLineBox.height, animate, affectReadingPosition);
                else this.moveTo(nextLineBox.y, animate, true, affectReadingPosition);
            } else console.warn("VanillaReaderUiReadingRuler.moveToNextContentLineBox", "Unable to find next linebox");
        } else console.warn("moveToNextContentLineBox", "No _currentIntersectingContentLineBoxRect or _contentLineBoxRects", this._currentIntersectingContentLineBoxRect, this._contentLineBoxRects);
    }
    moveToPreviousContentLineBox(animate = true, affectReadingPosition = true) {
        // The useReducedMotion option always overrides any param value
        if (this.useReducedMotion) animate = false;
        if (this._currentIntersectingContentLineBoxRect && this._contentLineBoxRects && this._currentIntersectingContentLineBoxIndex !== undefined && this._currentIntersectingContentLineBoxIndex > 0) {
            let previousLineBox;
            let previousLineBoxIndex = Math.max(this._currentIntersectingContentLineBoxIndex - this._rulerLineBoxSpan, 0);
            let intersectingLineBox = this._currentIntersectingContentLineBoxRect;
            for(let i = previousLineBoxIndex; i >= 0; i--){
                let currentLineBox = this._contentLineBoxRects[i];
                if (currentLineBox.y + currentLineBox.height <= intersectingLineBox.y + this._contentLineBoxIntersectionMargin && !this._domRectsAreEquiv(intersectingLineBox, currentLineBox)) {
                    previousLineBox = currentLineBox;
                    break;
                }
            }
            if (previousLineBox) {
                this._updateIntersectingContentLineBoxData(previousLineBox, previousLineBoxIndex);
                if (this.snapToContentLineBoxes) this.moveToAndAlign(previousLineBox.y, previousLineBox.height, animate, affectReadingPosition);
                else this.moveTo(previousLineBox.y, animate, true, affectReadingPosition);
            } else console.warn("VanillaReaderUiReadingRuler.moveToPreviousContentLineBox", "Unable to find previous linebox");
        } else console.log("moveToPreviousContentLineBox", "No _currentIntersectingContentLineBoxRect or _contentLineBoxRects", this._currentIntersectingContentLineBoxRect, this._contentLineBoxRects);
    }
    moveToContentLineBoxIndex(index, animate = true, affectReadingPosition = true) {
        // The useReducedMotion option always overrides any param value
        if (this.useReducedMotion) animate = false;
        if (this._contentLineBoxRects) {
            let lineBox = this._contentLineBoxRects[index];
            if (lineBox) {
                this._updateIntersectingContentLineBoxData(lineBox, index);
                this.moveToAndAlign(lineBox.y, lineBox.height, animate, affectReadingPosition);
            } else console.warn("VanillaReaderUiReadingRuler.moveToContentLineBoxIndex", "Unable to find lineBox with index", index);
        } else console.log("VanillaReaderUiReadingRuler.moveToContentLineBoxIndex", "No _contentLineBoxRects");
    }
    hide() {
        this._rulerOverlayElement.style.opacity = "0";
        this._rulerElement.style.opacity = "0";
        // Run after fade out
        setTimeout(()=>{
            this._rulerOverlayElement.style.display = "none";
            this._rulerElement.style.display = "none";
            if (this._onHiddenCallback) this._onHiddenCallback();
        }, this._uiFadeDuration);
    }
    show(initialPosition, affectReadingPosition = true) {
        this._rulerElement.style.display = "flex";
        this._rulerOverlayElement.style.display = "flex";
        if (initialPosition) this.moveToAndAlign(initialPosition, undefined, false, affectReadingPosition);
        else {
            this._updateIntersectingContentLineBoxData();
            let lineBoxHeight = this._rulerLineBoxMinHeight * this._rulerLineBoxVerticalSpacingFactor * this._rulerLineBoxSpan;
            this._currentRulerLineBoxRect = this.setRulerLineBoxHeight(lineBoxHeight, false);
        }
        // Run after animations have finished
        setTimeout(()=>{
            this._rulerOverlayElement.style.opacity = this._pageOverlayOpacity.toString();
            this._rulerElement.style.opacity = this._rulerOpacity.toString();
            if (this._onVisibleCallback) this._onVisibleCallback();
        }, this._animationDuration);
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ _rulerNeedsToMove(y) {
        let targetLineBoxYPos = Math.round(y);
        let currentLineBoxYPos = this._rulerElement.offsetTop + this._rulerLineBoxElementOffsetTop;
        return targetLineBoxYPos !== currentLineBoxYPos;
    }
    _getRulerLineBoxFromHeightRequest(heightRequestInPx) {
        let newLineBoxHeight = Math.max(heightRequestInPx, this._rulerLineBoxMinHeight);
        let rulerLineBoxRect = new DOMRect(0, this._rulerLineBoxElementOffsetTop + this._rulerElement.offsetTop, this._rulerElement.clientWidth, newLineBoxHeight);
        return rulerLineBoxRect;
    }
    _redraw() {
        if (this._currentIntersectingContentLineBoxRect) {
            let rulerLineBoxHeight;
            let currentIndex = this._currentIntersectingContentLineBoxIndex != undefined && this._currentIntersectingContentLineBoxIndex >= 0 ? this._currentIntersectingContentLineBoxIndex : 0;
            let endIndex = currentIndex + this._rulerLineBoxSpan;
            let contentLineBoxSpanBoundingBox = this._getBoundingBoxForContentLineBoxSpan(this._contentLineBoxRects, currentIndex, endIndex);
            let averageLineBoxSpanHeight = this._contentLineBoxAverageHeight * this._rulerLineBoxSpan;
            let contentLineBoxSpanHeight = contentLineBoxSpanBoundingBox?.height || averageLineBoxSpanHeight;
            rulerLineBoxHeight = contentLineBoxSpanHeight; // Math.min(contentLineBoxSpanHeight, this._rulerMaxHeight);
            this._currentRulerLineBoxRect = this.setRulerLineBoxHeight(rulerLineBoxHeight);
        }
    }
    _applyOptions(newOptions) {
        let defaultReadingRulerOptions = {
            ...(0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.readingRulerOptions
        };
        for(let key in newOptions)if (newOptions[key] === undefined) delete newOptions[key];
        let newOptionsAppliedToDefaults = Object.assign(defaultReadingRulerOptions, newOptions);
        let normalizedOptions = Object.assign(this._activeOptions || {}, newOptionsAppliedToDefaults);
        this._rulerElement.style.backgroundColor = normalizedOptions.rulerBackgroundColor;
        this._rulerElement.style.mixBlendMode = normalizedOptions.rulerMixBlendMode;
        this._rulerElement.style.opacity = normalizedOptions.rulerOpacity.toString(2);
        //this._rulerElement.style.minHeight = `${normalizedOptions.rulerMinHeight}px`;
        this._rulerOverlayElement.style.backgroundColor = normalizedOptions.overlayBackgroundColor;
        this._rulerOverlayElement.style.mixBlendMode = normalizedOptions.overlayMixBlendMode;
        this._rulerOverlayElement.style.opacity = `${normalizedOptions.overlayOpacity}`;
        this._rulerLineBoxElement.style.backgroundColor = normalizedOptions.lineBoxBackgroundColor;
        this._rulerLineBoxElement.style.mixBlendMode = normalizedOptions.lineBoxMixBlendMode;
        this._rulerLineBoxElement.style.opacity = normalizedOptions.lineBoxOpacity.toString(2);
        this._rulerLineBoxElement.style.borderStyle = "solid";
        this._rulerLineBoxElement.style.borderTopWidth = `${normalizedOptions.lineBoxBorderTopWidth}px`;
        this._rulerLineBoxElement.style.borderBottomWidth = `${normalizedOptions.lineBoxBorderBottomWidth}px`;
        this._rulerLineBoxElement.style.borderLeftWidth = `${normalizedOptions.lineBoxBorderLeftWidth}px`;
        this._rulerLineBoxElement.style.borderRightWidth = `${normalizedOptions.lineBoxBorderRightWidth}px`;
        this._rulerLineBoxElement.style.borderTopColor = `${normalizedOptions.lineBoxBorderTopColor}`;
        this._rulerLineBoxElement.style.borderBottomColor = `${normalizedOptions.lineBoxBorderBottomColor}`;
        this._rulerLineBoxElement.style.borderLeftColor = `${normalizedOptions.lineBoxBorderLeftColor}`;
        this._rulerLineBoxElement.style.borderRightColor = `${normalizedOptions.lineBoxBorderRightColor}`;
        this._rulerElement.style.borderStyle = "solid";
        this._rulerElement.style.borderTopWidth = `${normalizedOptions.rulerBorderTopWidth}px`;
        this._rulerElement.style.borderTopColor = `${normalizedOptions.rulerBorderTopColor}`;
        this._rulerElement.style.borderBottomWidth = `${normalizedOptions.rulerBorderBottomWidth}px`;
        this._rulerElement.style.borderBottomColor = `${normalizedOptions.rulerBorderBottomColor}`;
        this._rulerElement.style.borderLeftWidth = `${normalizedOptions.rulerBorderLeftWidth}px`;
        this._rulerElement.style.borderLeftColor = `${normalizedOptions.rulerBorderLeftColor}`;
        this._rulerElement.style.borderRightWidth = `${normalizedOptions.rulerBorderRightWidth}px`;
        this._rulerElement.style.borderRightColor = `${normalizedOptions.rulerBorderRightColor}`;
        this._rulerLineBoxElement.style.minHeight = `${normalizedOptions.lineBoxMinHeight}px`;
        this._rulerDragThreshold = normalizedOptions.rulerDragThreshold;
        this._rulerLineBoxMinHeight = normalizedOptions.lineBoxMinHeight;
        this._rulerOpacity = normalizedOptions.rulerOpacity;
        this._snapToContentLineBoxes = normalizedOptions.snapToLineBoxes;
        this._rulerLineBoxSpan = normalizedOptions.lineBoxLineSpan;
        this._rulerLineBoxVerticalSpacingFactor = normalizedOptions.lineBoxLineVerticalSpacing;
        this._pageOverlayOpacity = normalizedOptions.overlayOpacity;
        if (normalizedOptions.overlayIsVisible) this.showPageOverlay();
        else this.hidePageOverlay();
        this._redraw();
        this._rulerLineBoxElementOffsetTop = (normalizedOptions.rulerBorderTopWidth || 0) + (normalizedOptions.lineBoxBorderTopWidth || 0);
        this._rulerLineBoxElementOffsetBottom = (normalizedOptions.rulerBorderBottomWidth || 0) + (normalizedOptions.lineBoxBorderBottomWidth || 0);
        this._activeOptions = normalizedOptions;
        return normalizedOptions;
    }
    _getBoundingBoxForContentLineBoxSpan(contentLineBoxRects, startIndex, endIndex) {
        let minX = Infinity;
        let maxX = 0;
        let minY = Infinity;
        let maxY = 0;
        let startEndDelta = Math.abs(endIndex - startIndex);
        startIndex = Math.max(startIndex, 0);
        endIndex = startIndex + startEndDelta < contentLineBoxRects.length ? startIndex + startEndDelta : contentLineBoxRects.length;
        for(let i = startIndex; i < endIndex; i++){
            const rect = contentLineBoxRects[i];
            let rectBottom = rect.y + rect.height;
            minX = rect.x < minX ? rect.x : minX;
            maxX = rect.x + rect.width > maxX ? rect.x + rect.width : maxX;
            minY = rect.y < minY ? rect.y : minY;
            maxY = rectBottom > maxY ? rectBottom : maxY;
        }
        return new DOMRect(minX, minY, maxX - minX, maxY - minY);
    }
    _filterOutBelowMinWidthLineBoxes(rectData) {
        return rectData.filter((rect)=>{
            return rect.clientRect.width >= this._contentLineBoxMinWidthThreshold;
        });
    }
    _filterOutOverlappingLines(rects) {
        let processedRects = [];
        let previousRect;
        for(let i = 0; rects.length > i; i++){
            if (previousRect) {
                let overlapPreviousBottom = Math.max(previousRect.bottom - rects[i].top, 0);
                if (rects[i].top > previousRect.top && rects[i].top < previousRect.bottom && rects[i].height > previousRect.height && overlapPreviousBottom > this._contentLineBoxIntersectionMargin) console.log("VanillaReaderUiReadingRuler.setContentLineBoxes: rect ", rects[i], " overlaps ", previousRect);
                else processedRects.push(rects[i]);
            } else processedRects.push(rects[i]);
            previousRect = rects[i];
        }
        return processedRects;
    }
    _moveAndScaleOverlayMaskRect(rect) {
        this._rulerOverlayElement.style.setProperty("--vanilla-reader__ruler__overlay__ruler-clip-box-left", `${rect.left}px`);
        this._rulerOverlayElement.style.setProperty("--vanilla-reader__ruler__overlay__ruler-clip-box-top", `${rect.top + 1}px`);
        this._rulerOverlayElement.style.setProperty("--vanilla-reader__ruler__overlay__ruler-clip-box-right", `${rect.right}px`);
        this._rulerOverlayElement.style.setProperty("--vanilla-reader__ruler__overlay__ruler-clip-box-bottom", `${rect.bottom - 1}px`);
    }
    _updateIntersectingContentLineBoxData(forceUpdateRect, forceUpdateIndex) {
        if (forceUpdateRect || forceUpdateIndex) {
            this._currentIntersectingContentLineBoxRect = forceUpdateRect;
            this._currentIntersectingContentLineBoxIndex = forceUpdateIndex;
            return;
        }
        if (this._contentLineBoxRects) {
            let intersectingRect = this._contentLineBoxRects?.find((rect, index)=>{
                let rectTop = rect.y;
                let rectBottom = rect.y + rect.height;
                let topIntersects = rectTop <= this.rulerLineBoxBoundingBox.bottom && rect.y >= this.rulerLineBoxBoundingBox.top - this._contentLineBoxIntersectionMargin;
                let bottomIntersects = rectBottom >= this.rulerLineBoxBoundingBox.top && rectBottom <= this.rulerLineBoxBoundingBox.bottom + this._contentLineBoxIntersectionMargin;
                let contains = rectTop < this.rulerLineBoxBoundingBox.top && rectBottom > this.rulerLineBoxBoundingBox.bottom;
                let doesIntersect = topIntersects || bottomIntersects || contains;
                if (doesIntersect) {
                    this._currentIntersectingContentLineBoxRect = rect;
                    this._currentIntersectingContentLineBoxIndex = index;
                }
                return doesIntersect;
            });
            return intersectingRect || undefined;
        } else return;
    }
    _onMoveEnd(affectReadingPosition = true) {
        if (this._onRulerMoveEndCallback) {
            if (this._currentIntersectingContentLineBoxIndex !== undefined) this._onRulerMoveEndCallback(this._contentLineBoxRectData[this._currentIntersectingContentLineBoxIndex], affectReadingPosition);
        }
    }
    _toggleUiAnimations(animate) {
        if (animate) {
            this._rulerElement.style.transition = `top ${this._animationDuration}ms ease 0s, height ${this._animationDuration}ms ease 0s, opacity ${this._uiFadeDuration}ms ease 0s`;
            this._rulerLineBoxElement.style.transition = `top ${this._animationDuration}ms ease 0s, height ${this._animationDuration}ms ease 0s, opacity ${this._uiFadeDuration}ms ease 0s`;
            this._rulerOverlayElement.style.transition = `clip-path ${this._animationDuration}ms ease 0s, opacity ${this._uiFadeDuration}ms ease 0s`;
        } else {
            this._rulerElement.style.transition = `opacity ${this._uiFadeDuration}ms ease 0s`;
            this._rulerLineBoxElement.style.transition = `opacity ${this._uiFadeDuration}ms ease 0s`;
            this._rulerOverlayElement.style.transition = `opacity ${this._uiFadeDuration}ms ease 0s`;
        }
    }
    _isValidOverlap(rect, overlappingRect) {
        let overlap = Math.abs(rect.bottom - overlappingRect.top);
        let maxValidOverlap = rect.height * this._contentLineBoxIntersectionMargin;
        return overlap > maxValidOverlap;
    }
    _domRectsAreEquiv(rect1, rect2) {
        return rect1.y === rect2.y && rect1.x === rect2.x && rect1.height === rect2.height && rect1.width === rect2.width;
    }
    _drawDebugContentLineBoxes(rectData) {
        document.querySelectorAll(".debug-rect").forEach((el)=>{
            el.remove();
        });
        rectData.forEach((data)=>{
            let rect = data.clientRect;
            let rectSelector = data.locator.selectors[0];
            let rectDiv = document.createElement("div");
            rectDiv.className = "debug-rect";
            rectDiv.style.position = "absolute";
            rectDiv.style.border = "1px solid green";
            rectDiv.style.mixBlendMode = "multiply";
            rectDiv.style.width = `${rect.width}px`;
            rectDiv.style.height = `${rect.height}px`;
            rectDiv.style.top = `${rect.y}px`;
            rectDiv.style.left = `${rect.x}px`;
            rectDiv.style.zIndex = "10";
            rectDiv.style.pointerEvents = "none";
            rectDiv.title = `x: ${rect.x}, y: ${rect.y}, width: ${rect.width}, height: ${rect.height}, top: ${rect.y}, bottom: ${rect.y + rect.height}, selector: ${rectSelector}`;
            document.body.appendChild(rectDiv);
        });
    }
}


class $17e4e03783fd07b3$export$7ea148da10587d3b {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.readingRuler.onDragEnd(vanillaReaderUiContext._onReadingRulerDragEnd.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.readingRuler.onVisible(vanillaReaderUiContext._onReadingRulerVisible.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.readingRuler.onHidden(vanillaReaderUiContext._onReadingRulerHidden.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.readingRuler.onClick(vanillaReaderUiContext._onReadingRulerClick.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.readingRuler.onMoveEnd(vanillaReaderUiContext._onReadingRulerMoveEnd.bind(vanillaReaderUiContext));
    }
    _onReadingRulerDragEnd(_ev, _rectData) {}
    _onReadingRulerVisible() {
        if (this.latestReadingPositionData) this.moveReadingRulerToReadingPosition();
    }
    _onReadingRulerHidden() {}
    _onReadingRulerMoveEnd(rectData, affectReadingPosition = true) {
        if (rectData.locator && affectReadingPosition) {
            let locator = `${rectData.locator.sourceUrl}#${rectData.locator.selectors[0]}`;
            if (affectReadingPosition && this.latestReadingPositionData?.locator !== locator) this.navigateTo(locator);
        }
    }
    _onReadingRulerClick(ev) {
        if (!this.readingRuler.snapToContentLineBoxes) return;
        if (ev.clientX > window.innerWidth / 2) {
            if (this.readingRuler.isAtEndOfContent) this.navigateNext(true);
            else this.readingRuler.moveToNextContentLineBox(!this.useReducedMotion, false);
        } else if (this.readingRuler.isAtStartOfContent) this.navigatePrevious(true);
        else this.readingRuler.moveToPreviousContentLineBox();
    }
}


class $0b34040224e6095d$export$455b3e501151f400 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.buttonMenu.onMenuClick(vanillaReaderUiContext._onButtonMenuClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.buttonMenu.onSideMenuClick(vanillaReaderUiContext._onButtonSideMenuClicked.bind(vanillaReaderUiContext));
    }
    _onInitialise() {}
    _onButtonMenuClicked() {
        this.menuBottom.show();
    }
    _onButtonSideMenuClicked() {
        this.menuSide.show();
    }
}


class $e781ecc3dca79823$export$4e2928d0e6403e09 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.panZoomTool.onActivate(vanillaReaderUiContext._onPanZoomStateActivateIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onDeactivate(vanillaReaderUiContext._onPanZoomStateDeactivateIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onZoomReset(vanillaReaderUiContext._onZoomLevelResetIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onDragStart(vanillaReaderUiContext._onZoomToolDragStart.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onDrag(vanillaReaderUiContext._onZoomToolDrag.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onDragEnd(vanillaReaderUiContext._onZoomToolDragEnd.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onPanningEnable(vanillaReaderUiContext._onPanningEnableIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onPanningDisable(vanillaReaderUiContext._onPanningDisableIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onZoomToLevel(vanillaReaderUiContext._onZoomToLevel.bind(vanillaReaderUiContext));
    }
    _onPanZoomStateActivateIntent() {
        if (!this.isMobileScreenSize) this.menuBottom.togglePanZoomButtonState(true);
    }
    _onPanZoomStateDeactivateIntent() {
        this.panZoomTool.resetZoomToolRect();
        if (!this.isMobileScreenSize) this.menuBottom.togglePanZoomButtonState(false);
        this.vanillaReaderAPI?.resetZoom();
    }
    _onZoomLevelResetIntent() {
        this.vanillaReaderAPI?.zoomToLevel(1, !this.useReducedMotion);
    }
    _onPanningEnableIntent() {
        this.vanillaReaderAPI?.activatePanZoomMode();
    }
    _onPanningDisableIntent() {
        this.vanillaReaderAPI?.deactivatePanZoomMode();
    }
    _onZoomToLevel(zoomLevel) {
        this.vanillaReaderAPI?.zoomToLevel(zoomLevel, !this.useReducedMotion);
    }
    _onZoomToolDragStart() {}
    _onZoomToolDrag() {}
    _onZoomToolDragEnd(_ev, zoomRect) {
        this.panZoomTool.disablePointerZoom();
        this.panZoomTool.resetZoomToolRect();
        if (zoomRect) this.vanillaReaderAPI?.zoomToClientRect(zoomRect, !this.useReducedMotion).catch(console.warn);
    }
}


class $78c751306bd7c4c5$export$bc028063957ce849 {
    constructor(_hostElement, insertPosition = "afterbegin"){
        this._hostElement = _hostElement;
        this._template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-panzoom-exit" type="button" title="Exit Pan Zoom mode" aria-hidden="true"><span class="vanilla-reader__fab__icon" id="vanilla-reader__fab-panzoom__icon" aria-hidden="true">zoom_out_map</span></button>`;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._exitButton = this._hostElement.querySelector("#vanilla-reader__fab-panzoom-exit");
        this._exitButton.addEventListener("click", (ev)=>{
            ev.preventDefault();
            if (this._onClickCallback) {
                if (this.isVisible) this._onClickCallback();
            }
        });
    }
    get isVisible() {
        return !this._exitButton.hasAttribute("aria-hidden");
    }
    show() {
        this._exitButton.removeAttribute("aria-hidden");
        this._exitButton.style.display = "flex";
        this._exitButton.style.opacity = "1";
        this._exitButton.style.pointerEvents = "all";
        if (this._onVisibleCallback) this._onVisibleCallback();
    }
    hide() {
        this._exitButton.setAttribute("aria-hidden", "true");
        this._exitButton.style.opacity = "0";
        this._exitButton.style.pointerEvents = "none";
        setTimeout(()=>{
            this._exitButton.style.display = "none";
        }, 200);
        if (this._onHiddenCallback) this._onHiddenCallback();
    }
    getComponentElement() {
        return this._exitButton;
    }
    onClick(callback) {
        this._onClickCallback = callback;
    }
    onVisible(callback) {
        this._onVisibleCallback = callback;
    }
    onHidden(callback) {
        this._onHiddenCallback = callback;
    }
}


class $be3221946ebf0b51$export$c19704de2ec1eaeb {
    constructor(_fabHostElement){
        this._fabHostElement = _fabHostElement;
        this._bodyStyle = `
        <style>
        
            #vanilla-reader__pan-zoom-viewport {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;                
                z-index: 1000;                
                pointer-events: all;
                touch-action: none;
            }
                                   
            #vanilla-reader__pan-zoom-tool {
                position: absolute;
                width: 0;
                height: 0;
                border: 1px dotted var(--vanilla-reader__color__ui__outline-dark);
                background-color: var(--vanilla-reader__color__ui__accent);
                mix-blend-mode: multiply;       
                opacity: 0.2;
                touch-action: none;    
            }
            
            #vanilla-reader__pan-zoom-viewport.dragging {
                
            }          

            #vanilla-reader__pan-zoom-viewport.panning {
                cursor: grab;
                pointer-events: none;
            }
                          
            #vanilla-reader__pan-zoom-viewport.zooming-in {
                cursor: zoom-in;
            }          

            #vanilla-reader__pan-zoom-viewport.zooming-out {
                cursor: zoom-out;
            }          
              
        </style>`;
        this._bodyTemplate = `<div id="vanilla-reader__pan-zoom-viewport"><div id="vanilla-reader__pan-zoom-tool"></div></div>`;
        this._isBeingDragged = false;
        this._isZoomDisabled = false;
        this._isActive = false;
        this._shouldShowExitButton = true;
        this._pointerDown = (ev)=>{
            if (!this._panZoomViewportElement || !this._zoomToolElement) return;
            ev.preventDefault();
            ev.stopImmediatePropagation();
            this.resetZoomToolRect();
            this._pointerDownStartCoords = {
                x: ev.clientX,
                y: ev.clientY
            };
            this._zoomToolElement.style.top = `${ev.clientY}px`;
            this._zoomToolElement.style.left = `${ev.clientX}px`;
            if (this._onZoomToolDragStartCallback) this._onZoomToolDragStartCallback(ev, this.currentZoomRect);
        };
        this._pointerMove = (ev)=>{
            if (!this._panZoomViewportElement || !this._zoomToolElement) return;
            if (!this._pointerDownStartCoords) return;
            ev.preventDefault();
            ev.stopImmediatePropagation();
            let xPositionDelta = ev.clientX - this._pointerDownStartCoords.x;
            let yPositionDelta = ev.clientY - this._pointerDownStartCoords.y;
            this._isBeingDragged = true;
            this._zoomToolElement.style.width = `${xPositionDelta}px`;
            this._zoomToolElement.style.height = `${yPositionDelta}px`;
            this._zoomToolElement.classList.add("dragging");
            if (this._onZoomToolDragCallback) this._onZoomToolDragCallback(ev, this.currentZoomRect);
        };
        this._pointerUp = (ev)=>{
            if (!this._panZoomViewportElement || !this._zoomToolElement) return;
            ev.preventDefault();
            ev.stopImmediatePropagation();
            this._isBeingDragged = false;
            this._zoomToolElement.classList.remove("dragging");
            this._pointerDownStartCoords = undefined;
            if (this._onZoomToolDragEndCallback) this._onZoomToolDragEndCallback(ev, this.currentZoomRect);
        };
        this._keyUp = (ev)=>{
            switch(ev.key){
                case "Escape":
                    this.deactivate();
                    break;
            }
        };
        this._hostElement = document.body;
        this._hostElement.insertAdjacentHTML("beforeend", this._bodyStyle);
        this.buttonFabPanZoomExit = new (0, $78c751306bd7c4c5$export$bc028063957ce849)(this._fabHostElement);
        this.buttonFabPanZoomExit.onClick(()=>{
            this.deactivate();
        });
    }
    set shouldShowExitButton(value) {
        this._shouldShowExitButton = value;
        if (!this._shouldShowExitButton && this.isActive) this.buttonFabPanZoomExit.hide();
    }
    get shouldShowExitButton() {
        return this._shouldShowExitButton;
    }
    get currentZoomRect() {
        return this._zoomToolElement?.getBoundingClientRect();
    }
    get isBeingDragged() {
        return this._isBeingDragged;
    }
    get isZoomEnabled() {
        return !this._isZoomDisabled;
    }
    get isActive() {
        return this._isActive;
    }
    get activeTransformData() {
        return this._activeTransformData;
    }
    set activeTransformData(data) {
        this._activeTransformData = data;
        this._maybeToggleExitFab(data);
    }
    onDragStart(callback) {
        this._onZoomToolDragStartCallback = callback;
    }
    onDrag(callback) {
        this._onZoomToolDragCallback = callback;
    }
    onDragEnd(callback) {
        this._onZoomToolDragEndCallback = callback;
    }
    onActivate(callback) {
        this._onZoomStateActivatedCallback = callback;
    }
    onDeactivate(callback) {
        this._onZoomStateDeactivatedCallback = callback;
    }
    onZoomDisabled(callback) {
        this._onZoomDisabledCallback = callback;
    }
    onZoomEnabled(callback) {
        this._onZoomEnabledCallback = callback;
    }
    onZoomReset(callback) {
        this._onZoomResetCallback = callback;
    }
    onZoomToLevel(callback) {
        this._onZoomToLevelCallback = callback;
    }
    onPanningDisable(callback) {
        this._onPanningDisabledCallback = callback;
    }
    onPanningEnable(callback) {
        this._onPanningEnabledCallback = callback;
    }
    disablePointerZoom() {
        if (this._panZoomViewportElement && this._zoomToolElement) {
            this._panZoomViewportElement.removeEventListener("pointerdown", this._pointerDown);
            this._panZoomViewportElement.removeEventListener("pointermove", this._pointerMove);
            this._panZoomViewportElement.removeEventListener("pointerup", this._pointerUp);
            this._isZoomDisabled = true;
            this._panZoomViewportElement.classList.remove("zooming-in", "zooming-out");
            this._panZoomViewportElement.classList.add("panning");
        }
        if (this._onZoomDisabledCallback) this._onZoomDisabledCallback();
    }
    enablePointerZoom() {
        if (this._panZoomViewportElement && this._zoomToolElement) {
            this._panZoomViewportElement.addEventListener("pointerdown", this._pointerDown);
            this._panZoomViewportElement.addEventListener("pointermove", this._pointerMove);
            this._panZoomViewportElement.addEventListener("pointerup", this._pointerUp);
            this._isZoomDisabled = false;
            this._panZoomViewportElement.classList.remove("panning");
            this._panZoomViewportElement.classList.add("zooming-in");
        }
        if (this._onZoomEnabledCallback) this._onZoomEnabledCallback();
    }
    enablePanning() {
        this.disablePointerZoom();
        if (this._panZoomViewportElement) {
            this._panZoomViewportElement.classList.add("panning");
            this._panZoomViewportElement.classList.remove("zooming-in");
        }
        if (this._onPanningEnabledCallback) this._onPanningEnabledCallback();
    }
    disablePanning() {
        this.enablePointerZoom();
        if (this._panZoomViewportElement) {
            this._panZoomViewportElement.classList.remove("panning");
            this._panZoomViewportElement.classList.add("zooming-in");
        }
        if (this._onPanningDisabledCallback) this._onPanningDisabledCallback();
    }
    resetZoomLevel() {
        if (this._onZoomResetCallback) this._onZoomResetCallback();
    }
    activate() {
        if (this.isActive) return;
        if (!this._panZoomViewportElement) {
            this._hostElement.insertAdjacentHTML("beforeend", this._bodyTemplate);
            this._panZoomViewportElement = this._hostElement.querySelector("#vanilla-reader__pan-zoom-viewport");
            this._zoomToolElement = this._hostElement.querySelector("#vanilla-reader__pan-zoom-tool");
            this._panZoomViewportElement.addEventListener("pointerdown", this._pointerDown);
            this._panZoomViewportElement.addEventListener("pointermove", this._pointerMove);
            this._panZoomViewportElement.addEventListener("pointerup", this._pointerUp);
            this._panZoomViewportElement.addEventListener("keyup", this._keyUp);
            this._isActive = true;
        }
        if (this._onZoomStateActivatedCallback) this._onZoomStateActivatedCallback();
    }
    deactivate() {
        if (!this.isActive) return;
        if (this._panZoomViewportElement && this._zoomToolElement) {
            this._panZoomViewportElement.removeEventListener("pointerdown", this._pointerDown);
            this._panZoomViewportElement.removeEventListener("pointermove", this._pointerMove);
            this._panZoomViewportElement.removeEventListener("pointerup", this._pointerUp);
            this._panZoomViewportElement.removeEventListener("keyup", this._keyUp);
            this._panZoomViewportElement.removeChild(this._zoomToolElement);
            this._hostElement.removeChild(this._panZoomViewportElement);
            this._panZoomViewportElement = undefined;
            this._zoomToolElement = undefined;
            this.buttonFabPanZoomExit.hide();
            this._isActive = false;
        }
        if (this._onZoomStateDeactivatedCallback) this._onZoomStateDeactivatedCallback();
    }
    zoomToRect(_domRect, _animate) {}
    zoomToPoint(_x, _y, _animate) {}
    zoomToolToLevel(zoomLevel, animate) {
        if (this._onZoomToLevelCallback) this._onZoomToLevelCallback(zoomLevel, animate);
    }
    resetZoomToolRect() {
        if (this._zoomToolElement) {
            this._zoomToolElement.style.top = "0";
            this._zoomToolElement.style.left = "0";
            this._zoomToolElement.style.width = "0";
            this._zoomToolElement.style.height = "0";
        }
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ _maybeToggleExitFab(data) {
        if (data) {
            if (this._shouldShowExitButton && !this.buttonFabPanZoomExit.isVisible) this.buttonFabPanZoomExit.show();
        } else if (this.buttonFabPanZoomExit.isVisible) this.buttonFabPanZoomExit.hide();
    }
}





class $af44375496964535$export$3f1e0fed16df5bed {
    constructor(_hostElement, insertPosition = "beforeend", _timelineData, _navigationTreeData){
        this._hostElement = _hostElement;
        this._timelineData = _timelineData;
        this._navigationTreeData = _navigationTreeData;
        this._timelineLength = 0;
        this._showSyntheticPageNumbers = true;
        this._syntheticPages = [];
        this._sliderStepSize = 1;
        this._progressSliderUpdatedCallback = undefined;
        this._style = `
        <style>                        
            #vanilla-reader__slider-progression {
                display: flex;
                flex-grow: 1;
                flex-direction: row;
                flex-wrap: wrap;            
                width: 100%; 
            }
                        
            #vanilla-reader__slider-progression button {
                font-size: x-large;
                align-content: center;
                min-width: 48px;    
                margin: 8px 0px;
                opacity: 1;
                height: 24px;
                width: auto;            
                bottom: 8px;                    
                transition: opacity, border ease-in-out 0.2s;            
                cursor: pointer;
                z-index: 1;
                background-color: transparent;
                border: 1px solid transparent;
                font-size: 2.5rem;
            }

            #vanilla-reader__slider-progression__input {
                flex-grow: 8;
                padding: 0;
            }
            
            #vanilla-reader__slider-progression__label {
                height: 0px;
                margin: 0;
                width: 100%;
                justify-self: stretch;
                text-align: center;
                font-size: 0.8em;
                line-height: 1.5;
                color: var(--vanilla-reader__color__ui__foreground-dark);
            }


            input[type="range"] {
                -webkit-appearance: none;
                outline:none;
                appearance: none;
                background: transparent;
                cursor: pointer;
                border: none;
                border-radius: 16px;
                height: 2px;
                background: hsla(0,0%,100%,.2);
            }

            #vanilla-reader__slider-progression.loading input[type="range"]{
                background: linear-gradient(90deg, hsla(0,0%,100%,0.2), var(--vanilla-reader__color__ui__accent) 10%, hsla(0,0%,100%,0.2));
                background-size: 200% auto;
                background-position: 0 100%;
                animation: loadingRangeSliderAnimation 1s infinite;
                animation-fill-mode: forwards;
                animation-timing-function: linear;
            }

            @keyframes loadingRangeSliderAnimation {
                0%   { background-position: 0 0; }
                100% { background-position: -200% 0; }
            }

             /* Thumb: webkit */
            input[type="range"]::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                height: 15px;
                width: 15px;
                background-color: var(--vanilla-reader__color__ui__accent);
                border-radius: 50%;
                border: none;
                transition: .2s ease-in-out;
            }
            #vanilla-reader__slider-progression.loading input[type="range"]::-webkit-slider-thumb {
                visibility: hidden;
            }

            /* Thumb: Firefox */
            input[type="range"]::-moz-range-thumb {
                height: 15px;
                width: 15px;
                background-color: var(--vanilla-reader__color__ui__accent);
                border-radius: 50%;
                border: none;
                transition: .2s ease-in-out;/\
            }
            #vanilla-reader__slider-progression.loading input[type="range"]::-moz-range-thumb {
                visibility: hidden;
            }
             
            /* Removes default focus */
            input[type="range"]:focus {
               outline: none;
            }
             
            input[type="range"]::-webkit-slider-thumb:hover {
                box-shadow: 0 0 0 10px rgba(54, 214, 119, .1)
            }
            input[type="range"]:active::-webkit-slider-thumb {
                box-shadow: 0 0 0 13px rgba(54, 214, 119, .2)
            }
            input[type="range"]:focus::-webkit-slider-thumb {
                box-shadow: 0 0 0 13px rgba(54, 214, 119, .2)
            }
            
            /* Hover, active & focus Thumb: Firfox */
            
            input[type="range"]::-moz-range-thumb:hover {
                box-shadow: 0 0 0 10px rgba(54, 214, 119, .1)
            }
            input[type="range"]:active::-moz-range-thumb {
                box-shadow: 0 0 0 13px rgba(54, 214, 119, .2)
            }
            input[type="range"]:focus::-moz-range-thumb {
                box-shadow: 0 0 0 13px rgba(54, 214, 119, .2)   
            }
            

        </style>`;
        this._template = `
            <div id="vanilla-reader__slider-progression" class="loading">
                <label id="vanilla-reader__slider-progression__label" aria-hidden="true" for="vanilla-reader__slider-progression__input"></label>
                <div style="display: flex; width: 100%; justify-content: space-between; align-items: center;">
                    <button id="vanilla-reader__progression-slider__button-previous" title="Go to previous"><span aria-hidden="true">navigate_before</span></button> 
                    <input type="range" id="vanilla-reader__slider-progression__input" title="Reading progression slider" value="0">
                    <button id="vanilla-reader__progression-slider__button-next" title="Go to next"><span aria-hidden="true">navigate_next</span></button>
                </div>
             </div>`;
        this._event_sliderProgressionInput = (_event)=>{
            let sliderValue = parseInt(this._sliderProgressionInputElement.value);
            if (!isNaN(sliderValue)) this.updateSliderProgressionValue(sliderValue);
        };
        this._event_menu_sliderProgressionChange = (_event)=>{
            let sliderPosition = parseInt(this._sliderProgressionInputElement.value);
            if (this._sliderProgressionChangeTimeout) {
                window.clearTimeout(this._sliderProgressionChangeTimeout);
                this._sliderProgressionChangeTimeout = undefined;
            }
            this._sliderProgressionChangeTimeout = window.setTimeout(()=>{
                if (this._navigateToTimelinePositionCallback) this._navigateToTimelinePositionCallback({
                    navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).TIMELINEPOSITION,
                    position: sliderPosition
                });
            }, 250);
            this.updateSliderProgressionValue(sliderPosition);
        };
        this._hostDocument = _hostElement.ownerDocument;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._hostElement.insertAdjacentHTML("afterbegin", this._style);
        this._sliderProgressionElement = this._hostDocument.getElementById("vanilla-reader__slider-progression");
        this._sliderProgressionInputElement = this._sliderProgressionElement.querySelector("#vanilla-reader__slider-progression__input");
        this._sliderProgressionLabelElement = this._sliderProgressionElement.querySelector("#vanilla-reader__slider-progression__label");
        this._buttonPrevious = this._hostDocument.getElementById("vanilla-reader__progression-slider__button-previous");
        this._buttonNext = this._hostDocument.getElementById("vanilla-reader__progression-slider__button-next");
        this._buttonPrevious.addEventListener("click", (_ev)=>{
            if (this._navigatePreviousCallback) this._navigatePreviousCallback({
                navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).PREVIOUS
            });
        });
        this._buttonNext.addEventListener("click", (_ev)=>{
            if (this._navigateNextCallback) this._navigateNextCallback({
                navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).NEXT
            });
        });
        if (this._timelineData) this.initializeTimeline(this._timelineData, this._navigationTreeData);
    }
    get value() {
        return parseInt(this._sliderProgressionInputElement.value);
    }
    get disabled() {
        return this._sliderProgressionInputElement.disabled;
    }
    set disabled(value) {
        this._sliderProgressionInputElement.disabled = value;
    }
    get showSyntheticPageNumbers() {
        return this._showSyntheticPageNumbers;
    }
    set showSyntheticPageNumbers(value) {
        this._showSyntheticPageNumbers = value;
    }
    get syntheticPageCount() {
        let returnValue;
        switch(this._timelineData?.unit){
            case (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).PAGES:
                returnValue = this._timelineData.sections?.length || 0;
                break;
            case (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).DOCUMENTS:
                returnValue = this._timelineData.sections?.length || 0;
                break;
            default:
                returnValue = this._syntheticPages.length;
        }
        return returnValue;
    }
    get visibleRange() {
        return this._visibleRange;
    }
    get syntheticPages() {
        return this._syntheticPages;
    }
    setSyntheticPages(pageList) {
        this._syntheticPages = pageList.pages;
        if (this._timelineData) {
            this.initializeTimeline(this._timelineData, this._navigationTreeData);
            this._sliderStepSize = Math.floor(this._timelineLength / this.syntheticPageCount);
            this._setSliderElementAttributes(0, this._timelineLength - 1, this.value, this._sliderStepSize);
            this.updateSliderProgressionValue(this.value);
        }
    }
    get visibleSyntheticPages() {
        const visibleRange = this._visibleRange;
        if (!visibleRange) {
            console.warn("VanillaReaderUiSliderProgression.visibleSyntheticPages, No visible range has been set.");
            return;
        }
        return this._syntheticPages.filter((page)=>{
            return page.range.intersects(visibleRange);
        });
    }
    get activeSyntheticPage() {
        return this._activeSyntheticPage;
    }
    get paginationType() {
        let returnValue;
        let pageList = this._navigationTreeData?.collections.find((collection)=>collection.type === (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).PAGE_LIST);
        switch(this._timelineData?.unit){
            case (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).PAGES:
                returnValue = (0, $652e6cb51d594b1d$export$5eef632beec47929).SECTIONS;
                break;
            case (0, $f8f5cf2c043414f4$export$45587b7b78af24ff).DOCUMENTS:
                returnValue = (0, $652e6cb51d594b1d$export$5eef632beec47929).SECTIONS;
                break;
            default:
                returnValue = pageList ? (0, $652e6cb51d594b1d$export$5eef632beec47929).PAGE_LIST : (0, $652e6cb51d594b1d$export$5eef632beec47929).SYNTHETIC;
        }
        return returnValue;
    }
    onNavigatePrevious(callback) {
        this._navigatePreviousCallback = callback;
    }
    onNavigateNext(callback) {
        this._navigateNextCallback = callback;
    }
    onNavigateToTimelinePosition(callback) {
        this._navigateToTimelinePositionCallback = callback;
    }
    onProgressionSliderUpdated(callback) {
        this._progressSliderUpdatedCallback = callback;
    }
    initializeTimeline(timelineData, navigationTreeData) {
        if (navigationTreeData) this._navigationTreeData = navigationTreeData;
        this._timelineLength = timelineData.length;
        this._timelineData = timelineData;
        let syntheticPageStepSize = this.syntheticPageCount;
        this._sliderStepSize = Math.floor(syntheticPageStepSize <= this._timelineLength ? syntheticPageStepSize : 1);
        this._sliderProgressionInputElement.disabled = false;
        this._setSliderElementAttributes(0, this._timelineLength - 1, 0, this._sliderStepSize);
        this._sliderProgressionInputElement.addEventListener("change", this._event_menu_sliderProgressionChange);
        this._sliderProgressionInputElement.addEventListener("input", this._event_sliderProgressionInput);
    }
    updateSliderProgressionValue(value) {
        let timelineProgress = parseFloat((value / this._timelineLength).toFixed(2));
        this._activeSyntheticPage = this.getSyntheticPageDataFromPosition(value);
        let syntheticPageRange = this._activeSyntheticPage?.range;
        let pageLength = syntheticPageRange ? syntheticPageRange.end - syntheticPageRange.start : 0;
        let positionOffset = syntheticPageRange ? value - syntheticPageRange.start : 0;
        let syntheticPageProgress = syntheticPageRange ? positionOffset / pageLength % 1.0 * 100 : 0;
        if (syntheticPageRange && this.visibleRange && (this.visibleRange.end >= syntheticPageRange.end || this.visibleRange.start === this.visibleRange.end)) syntheticPageProgress = 100;
        syntheticPageProgress = this.syntheticPageCount <= this._timelineLength ? syntheticPageProgress : 100;
        let progressData = {
            pageData: this._activeSyntheticPage,
            pageProgress: syntheticPageProgress,
            timelineProgress: timelineProgress,
            timelineValue: value
        };
        this.updateSliderBackground(progressData);
        //this.updateProgressionLabelValue(progressData);
        this._sliderProgressionInputElement.value = value.toString();
        if (this._progressSliderUpdatedCallback) this._progressSliderUpdatedCallback(value, progressData);
    }
    updateSliderBackground(progressData) {
        const tempSliderValue = progressData.timelineValue;
        const progress = tempSliderValue / parseInt(this._sliderProgressionInputElement.max) * 100;
        this._sliderProgressionInputElement.style.background = `linear-gradient(to right, var(--vanilla-reader__color__ui__accent) ${progress}%, hsla(0,0%,100%,.2) ${progress}%)`;
    }
    updateProgressionLabelValue(progressData) {
        let navItemtitle = this._getNearestNavItemFromNavCollection(progressData.timelineValue, (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC)?.title;
        navItemtitle = navItemtitle ? navItemtitle : "";
        let progressionLabelText;
        if (this.showSyntheticPageNumbers) {
            let positionText = progressData.pageData?.label ? `location ${progressData.pageData.label} of ${this._syntheticPages[this._syntheticPages.length - 1].label}` : "";
            progressionLabelText = `${navItemtitle} \n ${positionText}`;
        } else progressionLabelText = `${navItemtitle} (${Math.floor(progressData.timelineProgress * 100)}%)`;
        this._sliderProgressionLabelElement.innerText = progressionLabelText;
    }
    setNavigationTreeData(treeData) {
        this._navigationTreeData = treeData;
    }
    setVisibleRangeData(rangeData) {
        if (rangeData.timelineRange) this._visibleRange = new (0, $da1a1533b140aa86$export$495676b7a762bc7f)(rangeData.timelineRange.start, rangeData.timelineRange.end);
    }
    getSyntheticPageDataFromPosition(position) {
        return this._syntheticPages.find((page)=>{
            return position >= page.range.start && position < page.range.end || position === page.range.start && position === page.range.end;
        });
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _setSliderElementAttributes(min = 0, max, value, step = 1) {
        this._sliderProgressionInputElement.setAttribute("min", min.toString());
        this._sliderProgressionInputElement.setAttribute("max", max.toString());
        this._sliderProgressionInputElement.setAttribute("value", value.toString());
        this._sliderProgressionInputElement.setAttribute("step", step.toString());
    }
    _getNearestNavItemFromNavCollection(position, collectionType) {
        if (this._navigationTreeData) {
            let tree = this._navigationTreeData;
            if (!tree) {
                console.warn("VanillaReaderUiSliderProgression._getNearestNavItemFromNavCollection(), No navigation tree data.");
                return undefined;
            }
            let collection = tree.collections.find((collection)=>collection.type === collectionType);
            if (!collection) {
                console.warn("VanillaReaderUiSliderProgression._getNearestNavItemFromNavCollection(), Publication has no TOC.");
                return undefined;
            }
            let currentPos = 0;
            let foundItem = undefined;
            while(currentPos < collection.children.length){
                let currentItem = collection.children[currentPos];
                if (position === currentItem.timelineStartPosition) {
                    foundItem = currentItem;
                    break;
                }
                if (currentItem.timelineStartPosition === undefined || position > currentItem.timelineStartPosition) currentPos++;
                else {
                    // If the position is greater than the current items position we return the previous nav item,
                    // otherwise we return the current position.
                    let itemIndex = currentItem.timelineStartPosition > position ? currentPos - 1 : currentPos;
                    foundItem = collection.children[itemIndex];
                    break;
                }
            }
            return foundItem;
        }
        return undefined;
    }
}


class $5b74c7e0e98a7066$export$9a77c8963be054e1 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.menuProgressionSlider.onNavigateToTimelinePosition(vanillaReaderUiContext._onProgressionSliderNavigateToTimelinePosition.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuProgressionSlider.onProgressionSliderUpdated(vanillaReaderUiContext._onProgressionSliderPositionUpdated.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuProgressionSlider.onNavigateNext(vanillaReaderUiContext._onProgressionSliderNavigateNext.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuProgressionSlider.onNavigatePrevious(vanillaReaderUiContext._onProgressionSliderNavigatePrevious.bind(vanillaReaderUiContext));
    }
    _onProgressionSliderNavigateNext() {
        this.navigateNext();
    }
    _onProgressionSliderNavigatePrevious() {
        this.navigatePrevious();
    }
    _onProgressionSliderNavigateToTimelinePosition(navigationData) {
        if (navigationData.position !== undefined) this.navigateToTimelinePosition(navigationData.position);
    }
    _onProgressionSliderPositionUpdated(_sliderValue, progressData) {
        if (progressData.pageData && progressData.pageProgress !== undefined) {
            this.labelPageNumber.value = progressData.pageData?.label;
            this.labelPageNumber.progress = progressData.pageProgress;
        }
    }
}


class $a87d2123b4d79fd0$export$11b2f654ce5d0663 {
    constructor(_hostElement, insertPosition = "beforeend"){
        this._hostElement = _hostElement;
        this._progress = 0;
        this._style = `
        <style>
            #vanilla-reader__label_page_number {
                min-width: 24px;
                min-height: 24px;
                max-width: 24px;
                max-height: 24px;
                text-align: center;
                color: var(--vanilla-reader__color__ui__foreground-dark);
                border: 2px;
                border-radius: 50%;
                border-color: transparent;
                border-style: solid;
                align-self: center;
                justify-content: center;
                transition: border 1s;
                margin: 0.5em;
            }
            
            #vanilla-reader__label_page_number__value {
                display: contents;
                font-variant: all-petite-caps;
                text-align: center;
                opacity: 0.8;
            }
            
            @media (min-width: 480px) {
                #vanilla-reader__label_page_number {
                    display: none;
                }
            }
            
            @media (orientation: landscape) {
                #vanilla-reader__label_page_number {
                    display: none;
                }
            }
        </style>`;
        this._template = `
        <div aria-hidden="true" id="vanilla-reader__label_page_number">
            <span id="vanilla-reader__label_page_number__value"></span>
        </div>`;
        this./**
     *
     * PRIVATE METHOD
     *
     * */ _onPageNumberElementClick = ()=>{
            if (this._onPageNumberElementClickCallback) this._onPageNumberElementClickCallback(parseInt(this.value));
        };
        this._hostDocument = _hostElement.ownerDocument;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._hostElement.insertAdjacentHTML("afterbegin", this._style);
        this._pageNumberElement = this._hostDocument.getElementById("vanilla-reader__label_page_number");
        this._pageNumberValueElement = this._hostDocument.getElementById("vanilla-reader__label_page_number__value");
        this._pageNumberValueElement.addEventListener("click", this._onPageNumberElementClick);
    }
    get value() {
        return this._pageNumberValueElement.innerHTML;
    }
    set value(value) {
        this._pageNumberValueElement.innerHTML = value;
    }
    get progress() {
        return this._progress;
    }
    set progress(value) {
        this._progress = value;
        this._applyProgress(value);
    }
    onClick(callback) {
        this._onPageNumberElementClickCallback = callback;
    }
    _applyProgress(value) {
        this._pageNumberElement.style.borderColor = "transparent";
        this._pageNumberElement.style.borderWidth = "1px";
        this._pageNumberElement.style.borderRadius = "50%";
        this._pageNumberElement.style.borderStyle = "solid";
        this._pageNumberElement.style.borderTopWidth = "1px";
        this._pageNumberElement.style.borderTopColor = "#b3b3b3";
        if (value >= 25) {
            this._pageNumberElement.style.borderRightWidth = "1px";
            this._pageNumberElement.style.borderRightColor = "#b3b3b3";
        }
        if (value >= 50) {
            this._pageNumberElement.style.borderBottomWidth = "1px";
            this._pageNumberElement.style.borderBottomColor = "#b3b3b3";
        }
        if (value >= 75) {
            this._pageNumberElement.style.borderLeftWidth = "1px";
            this._pageNumberElement.style.borderLeftColor = "#b3b3b3";
        }
    }
}


class $dc493da98accc995$export$c0f7910f7d03579a {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.labelPageNumber.onClick(vanillaReaderUiContext._onLabelPageNumberClick.bind(vanillaReaderUiContext));
    }
    _onLabelPageNumberClick() {
        this.togglePageNumbers();
    }
}





class $e88a1158099e8080$export$23b8de27b1ad9243 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(_hostElement, _insertPosition = "afterbegin"){
        super(_hostElement, "vanilla-reader__dialog-landmarks", "Landmarks", _insertPosition);
        this._headingsItemClickedCallback = undefined;
        this._treeViewLandmarks = undefined;
        this._hasBeenPopulated = false;
        this._bodyStyle = `
        <style>
            
            #vanilla-reader__dialog-landmarks__list ul[role=tree] {
                padding-left: 0;
                list-style: none;
            }
                        
            #vanilla-reader__dialog-landmarks__list ul[role=tree] button {
                font-size: x-large;
                margin-left: 0;
            }

            #vanilla-reader__dialog-landmarks__list ul[role=group] {
                padding-left: 1em;
                list-style: none;
            }
            
            #vanilla-reader__dialog-landmarks__list ul[role=group] li:not([data-treeview-role=group]) {
               margin-left: 1em;
            }
            
            #vanilla-reader__dialog-landmarks__list li {
                align-items: center;
            }

            #vanilla-reader__dialog-landmarks__list li a {
                max-width: 70%;
            }

            #vanilla-reader__dialog-landmarks__list li[aria-selected=true] {
                text-decoration: underline;
            }
            
            #vanilla-reader__dialog-landmarks__list li[aria-expanded=true] ul {
                border-left: 1px dotted var(--vanilla-reader__color__ui__outline-dark);
            }
              
        </style>`;
        this._bodyTemplate = `
            <section aria-label="Landmarks" id="vanilla-reader__dialog-landmarks__list"></section>`;
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._dialogElement.insertAdjacentHTML("afterbegin", this._bodyStyle);
        this._headingsListElement = this._dialogElement.querySelector("#vanilla-reader__dialog-landmarks__list");
        this._treeViewLandmarkRootItems = [];
    }
    get hasBeenPopulated() {
        return this._hasBeenPopulated;
    }
    show(silent = false, returnFocusOnClose = true, onDialogCloseCallbackOverride, collapseAll = true) {
        super.show(silent, returnFocusOnClose, onDialogCloseCallbackOverride);
        if (collapseAll) this._treeViewLandmarks?.collapseAll();
    }
    close(silent = false, returnDialogResult = true) {
        silent = true;
        super.close(silent, returnDialogResult);
    }
    onLandmarkItemClicked(callback) {
        this._headingsItemClickedCallback = callback;
    }
    populate(landmarks = []) {
        this._treeViewLandmarks?.destroy();
        let headingItemData;
        let tableItemData;
        let figureItemData;
        let listItemData;
        let filteredLandmarks = landmarks.filter((landmark)=>landmark.description && landmark.description !== "" || landmark.textContent && landmark.textContent !== "");
        let headingLandmarkData = filteredLandmarks.filter((landmark)=>{
            return landmark.blockType === (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING1 || landmark.blockType === (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING2 || landmark.blockType === (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING3 || landmark.blockType === (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING4 || landmark.blockType === (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING5 || landmark.blockType === (0, $f8f5cf2c043414f4$export$5acfff906ca012a5).HEADING6;
        });
        headingItemData = headingLandmarkData.map((landmark)=>{
            return {
                id: landmark.id.toString(),
                data: landmark,
                children: [],
                textContent: `${landmark.textContent} (${landmark.blockType})`
            };
        });
        let tableLandmarkData = filteredLandmarks.filter((landmark)=>landmark.blockType === (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).TABLE);
        tableItemData = tableLandmarkData.map((landmark)=>{
            return {
                id: landmark.id.toString(),
                data: landmark,
                children: [],
                textContent: landmark.textContent || landmark.description || "Unlabelled table"
            };
        });
        let figureLandmarkData = filteredLandmarks.filter((landmark)=>landmark.blockType === (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).FIGURE || landmark.blockType === (0, $f8f5cf2c043414f4$export$dfc5e1a852a6126b).IMAGE);
        figureItemData = figureLandmarkData.map((landmark)=>{
            return {
                id: landmark.id.toString(),
                data: landmark,
                children: [],
                textContent: landmark.description || landmark.description || "Unlabelled figure"
            };
        });
        let listLandmarkData = filteredLandmarks.filter((landmark)=>landmark.blockType === ((0, $f8f5cf2c043414f4$export$a9ac7502a865bef).ORDERED_LIST || (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).UNORDERED_LIST || (0, $f8f5cf2c043414f4$export$a9ac7502a865bef).DESCRIPTION_LIST));
        listItemData = listLandmarkData.map((landmark)=>{
            return {
                id: landmark.id.toString(),
                data: landmark,
                children: [],
                textContent: landmark.textContent || landmark.description || "Unlabelled list"
            };
        });
        this._treeViewLandmarkRootItems = [
            {
                id: "headings",
                data: {},
                children: headingItemData,
                textContent: headingItemData.length > 0 ? "Headings" : "No labeled headings found"
            },
            {
                id: "tables",
                data: {},
                children: tableItemData,
                textContent: tableItemData.length > 0 ? "Tables" : "No labeled tables found"
            },
            {
                id: "figures",
                data: {},
                children: figureItemData,
                textContent: figureItemData.length > 0 ? "Figures" : "No labeled figures found"
            },
            {
                id: "lists",
                data: {},
                children: listItemData,
                textContent: listItemData.length > 0 ? "Lists" : "No labeled lists found"
            }
        ];
        this._treeViewLandmarks = new (0, $12a4e63b52eb779b$export$6940b0d9c820eca7)(this._headingsListElement, this._treeViewLandmarkRootItems);
        this._treeViewLandmarks.cssClassName = "vanilla-reader__dialog-landmarks-list";
        this._treeViewLandmarks.addItemClickEventHandler((landmarkItem)=>{
            if (this._headingsItemClickedCallback && landmarkItem.data.locatorUrl) this._headingsItemClickedCallback(landmarkItem.data.locatorUrl);
            else {
                let treeViewItem = this._treeViewLandmarks?.treeViewItemDataToTreeViewItemMap.get(landmarkItem);
                if (treeViewItem) treeViewItem.setIsExpanded(!treeViewItem.getIsExpanded());
            }
        });
        this._treeViewLandmarks.render();
        this._hasBeenPopulated = true;
    }
    empty() {
        if (this._treeViewLandmarks) this._treeViewLandmarks.destroy();
    }
}


class $001c5b6e1a16ece4$export$24bbf92aa358b54f {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogLandmarks.onLandmarkItemClicked(vanillaReaderUiContext._onDialogLandmarksItemSelected.bind(vanillaReaderUiContext));
    }
    _onDialogLandmarksItemSelected(locator) {
        if (locator) {
            this.navigateTo(locator);
            this.dialogLandmarks.close();
        }
    }
}


class $4ad4bab2861980cc$export$bc507fcdaf360e3e {
    constructor(_hostElement, insertPosition = "afterbegin"){
        this._hostElement = _hostElement;
        this._template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-speaktext" type="button" title="Speak selected text" aria-hidden="true"><span class="vanilla-reader__fab__icon" aria-hidden="true">hearing</span></button>`;
        this._stateIsPlaying = false;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._speakButton = this._hostElement.querySelector("#vanilla-reader__fab-speaktext");
        this._speakButtonIcon = this._hostElement.querySelector("#vanilla-reader__fab-speaktext > .vanilla-reader__fab__icon");
        this._speakButton.addEventListener("click", (_ev)=>{
            if (this._onClickCallback) {
                if (this.isVisible) this._onClickCallback();
            }
        });
    }
    get isVisible() {
        return !this._speakButton.hasAttribute("aria-hidden");
    }
    show() {
        this._speakButton.removeAttribute("aria-hidden");
        this._speakButton.setAttribute("accesskey", "i");
        this._speakButton.style.display = "flex";
        this._speakButton.style.opacity = "1";
        this._speakButton.style.pointerEvents = "all";
        if (this._onVisibleCallback) this._onVisibleCallback();
    }
    hide() {
        this._speakButton.removeAttribute("accesskey");
        this._speakButton.setAttribute("aria-hidden", "true");
        this._speakButton.style.opacity = "0";
        this._speakButton.style.pointerEvents = "none";
        this.stateIsSpeaking = false;
        setTimeout(()=>{
            this._speakButton.style.display = "none";
        }, 200);
        if (this._onHiddenCallback) this._onHiddenCallback();
    }
    get stateIsSpeaking() {
        return this._stateIsPlaying;
    }
    set stateIsSpeaking(isPlaying) {
        this._stateIsPlaying = isPlaying;
        if (isPlaying) this._speakButtonIcon.innerText = "stop";
        else this._speakButtonIcon.innerText = "hearing";
    }
    getComponentElement() {
        return this._speakButton;
    }
    onClick(callback) {
        this._onClickCallback = callback;
    }
    onVisible(callback) {
        this._onVisibleCallback = callback;
    }
    onHidden(callback) {
        this._onHiddenCallback = callback;
    }
}


class $3908ce7366d3a70c$export$61a498abd5752e90 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext: vanillaReaderUiContext.fabSpeakText.onClick(vanillaReaderUiContext._onFabSpeakTextClicked.bind(vanillaReaderUiContext));
    }
    _onFabSpeakTextClicked() {
        if (this.activeSelection) this.speakActiveSelection();
    }
}





class $95b7d870011bad30$export$d5f03281332b8f17 extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    static{
        this._dialogTitle = "Navigation History";
    }
    constructor(hostElement, insertPosition = "beforeend"){
        super(hostElement, "vanilla-reader__dialog-history-items", $95b7d870011bad30$export$d5f03281332b8f17._dialogTitle);
        this._bodyStyle = `
        <style>
            #vanilla-reader__dialog-history-items__list {
                padding-inline: 0;
            }

            #vanilla-reader__dialog-history-items__list li {
                min-height: 48px;                
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                align-content: space-between;
                margin-bottom: 0.5em;
                margin-top: 0.5em;
            }
            
            #vanilla-reader__dialog-history-items__list li a {
                vertical-align: super;
                margin-right: 1em;
                margin-top: 1em;
                flex-grow: 1;
            }     

            #vanilla-reader__dialog-history-items__list li button {
                align-self: flex-start;
            }
            
            .vanilla-reader__dialog-history-items__list__item__section-title, .vanilla-reader__dialog-history-items__list__item__section-location {
                /* We set pointer events to none to let the list item receive any key/pointer events */ 
                pointer-events: none;
                display: block;
                font-weight: bold;       
                margin-bottom: 8px;         
            }

            .vanilla-reader__dialog-history-items__list__item__section-location {
                font-weight: normal;                        
            }
            
            .vanilla-reader__dialog-history-items__list__item__selection-text {
                pointer-events: none;
            }
            
            
        </style>`;
        this._bodyTemplate = `<ul id="vanilla-reader__dialog-history-items__list">
        <span class="vanilla-reader__dialog-history-items__list--empty">There are no items yet</span>
    </ul>`;
        /*
    *
    * EVENT HANDLERS
    *
    * */ this._event_listItemClicked = (ev)=>{
            let locator = ev.target.getAttribute("data-contentblocklocator") || ev.target.parentElement.getAttribute("data-contentblocklocator");
            if (locator && this._onHistoryItemClickedCallback) this._onHistoryItemClickedCallback({
                navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
                locator: locator
            });
        };
        this._dialogElement.insertAdjacentHTML(insertPosition, this._bodyStyle);
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._list = this._dialogElement.querySelector("#vanilla-reader__dialog-history-items__list");
    }
    onHistoryItemClicked(callback) {
        this._onHistoryItemClickedCallback = callback;
    }
    populate(items) {
        this.empty();
        if (items.length >= 1) items.forEach((item)=>{
            let listItem = this.createItem(item);
            this._list.appendChild(listItem);
        });
        else this._list.innerHTML = '<span class="vanilla-reader__dialog-history-items__list--empty">There are no item yet</span>';
    }
    createItem(historyItem) {
        let listItem = this._hostDocument.createElement("li");
        let bookSection = historyItem.navItemData ? historyItem.navItemData[0]?.title : "";
        listItem.setAttribute("tabindex", "-1");
        listItem.setAttribute("data-booksection", bookSection);
        listItem.setAttribute("data-contentblocklocator", historyItem.locator || "");
        let listItemAnchor = this._hostDocument.createElement("a");
        listItemAnchor.setAttribute("data-contentblocklocator", historyItem.locator || "");
        listItemAnchor.addEventListener("click", (ev)=>{
            this._event_listItemClicked(ev);
        });
        listItem.addEventListener("keyup", (ev)=>{
            if (ev.key === "Enter" || ev.key === "Space") this._event_listItemClicked(ev);
        });
        listItemAnchor.innerHTML = `
            <span class="vanilla-reader__dialog-history-items__list__item__section-title" aria-label="Book section" title="Book section">${bookSection || ""} (at location ${historyItem.syntheticPageData ? historyItem.syntheticPageData[0]?.label : "unknown"})</span>                     
            <span class="vanilla-reader__dialog-history-items__list__item__selection-text" aria-label="Text extract" title="Extract">${historyItem.contentBlockData?.textContent.slice(0, 150) || ""}...</span>           
        `;
        listItemAnchor.setAttribute("tabindex", "0");
        listItem.appendChild(listItemAnchor);
        return listItem;
    }
    show(silent, returnFocusOnClose = true, onDialogCloseCallbackOverride) {
        super.show(silent, returnFocusOnClose, onDialogCloseCallbackOverride);
        this.title = $95b7d870011bad30$export$d5f03281332b8f17._dialogTitle;
    }
    empty() {
        if (this._list.childElementCount > 0) {
            let firstListItem = this._list.firstChild;
            while(firstListItem){
                firstListItem.remove();
                firstListItem = this._list.firstChild;
            }
        }
    }
}


class $b54ab92215f72a81$export$6f1fa999703c70ea {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.dialogNavigationHistory.onHistoryItemClicked(vanillaReaderUiContext._onDialogNavigationHistoryItemClicked.bind(vanillaReaderUiContext));
    }
    _onDialogNavigationHistoryItemClicked(navigationData) {
        if (navigationData.locator) this.navigateTo(navigationData.locator.toString());
        this.dialogNavigationHistory?.close();
    }
}







class $41cd53d5779d12bc$export$7ec151cd4178fb4b extends (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004) {
    constructor(_hostElement, insertPosition = "afterbegin"){
        super(_hostElement, "vanilla-reader__masterplan-start", "", insertPosition);
        this._bodyStyle = `
    <style>      
        #vanilla-reader__masterplan-start[role=dialog] {  
            padding: 0!important;
            top: 0!important;
            bottom: 0!important;
            right: 0!important;
            left: 0!important;
            height: 100%!important;
            width: 100%!important;
            max-width: initial!important;
            border-radius: 0!important;
            border: 0!important;
        }
        #vanilla-reader__masterplan-start .vanilla-reader-ui__dialog__header {
            display: none !important;
        }
        #vanilla-reader__masterplan-start .vanilla-reader-ui__dialog__body {
            flex-grow: 2;
            margin: 16px;
            margin-top: 0;
            margin-bottom: 0;
            overflow: hidden;
            overflow-y: auto;
            display:flex;
            align-items: center;

        }
        #vanilla-reader__masterplan-start .vanilla-reader-ui__dialog__header__close-button {
            display: none;
        }

        #vanilla-reader__masterplan-start .masterplan-logo {
            max-height: 50vh;
            min-height: 300px;
            width: 100%;
            background-image: url("https://masterplan.circularsoftware.com/img/MasterPlan_Light.png");
            background-size:contain;
            background-repeat: no-repeat;
            background-position: center;
            cursor:pointer;
        }

        @media only screen and (max-device-width: 480px) {         
            #vanilla-reader__masterplan-start .vanilla-reader-ui__dialog__body {
                margin: 8px;
            }
            
            .vanilla-reader__card {
               padding: 8px;
               box-shadow: none;             
            }
        }
    </style>`;
        this._bodyTemplate = ``;
        this._event_logoClicked = (_ev)=>{
            window.open("https://www.circularsoftware.com/masterplan/");
        };
        this._dialogBodyElement.innerHTML = this._bodyTemplate;
        this._dialogElement.insertAdjacentHTML("afterbegin", this._bodyStyle);
        this._dialogBodyElement.innerHTML = `
            <div class="masterplan-logo"></div> 
        `;
        document.querySelector(".masterplan-logo").addEventListener("click", this._event_logoClicked);
    }
}



class $5ba5fdbdc211316d$export$c537af2b9901106e {
    static __initialize__(vanillaReaderUiContext) {
        // Static event callbacks that are triggered regardless of what dialog instance are opened and closed.
        (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004).sharedOnDialogOpened(vanillaReaderUiContext._uiEvent_dialogOpened.bind(vanillaReaderUiContext));
        (0, $ae520f2259c8ef36$export$b6a78c44cf6c6004).sharedOnDialogClosed(vanillaReaderUiContext._uiEvent_dialogClosed.bind(vanillaReaderUiContext));
    }
}



class $954b1958e3763ddb$export$e9bbef092049e7c9 {
    constructor(_hostElement, insertPosition = "beforeend", _hostContext){
        this._hostElement = _hostElement;
        this._hostContext = _hostContext;
        this._enablePanZoomButton = !(0, $91ca8664a4c236f4$export$e8551d08bf651ea9).isPlatform("mobile");
        this._style = `
        <style>    
        #vanilla-reader__main-menu {
            display: flex;
        }
        #vanilla-reader__main-menu > button {        
            font-size: 1.5rem;   
            align-content: center;
            min-width: 48px;
            margin: 8px;
            height: 24px;
            width: auto;
            bottom: 8px;
            transition: opacity, border ease-in-out 0.2s;
            cursor: pointer;
            z-index: 1;
            background-color: transparent;
            color: var(--vanilla-reader__color__ui__foreground-light);
            border: 1px solid transparent;
        }
        #vanilla-reader__menu__button-panzoom-activate > i {
            font-style:normal;
        }
        </style>`;
        this._template = `
        <div id="vanilla-reader__main-menu">
            <button id="vanilla-reader__menu__button-soundtrack-activate" title="Play Soundtrack"><span class="vanilla__button-icon" aria-hidden="true">music_note</span></button>
            <button id="vanilla-reader__menu__button-soundtrack-deactivate" title="Stop Soundtrack"><span class="vanilla__button-icon" aria-hidden="true">music_off</span></button>
            <button id="vanilla-reader__menu__button-panzoom-activate" title="Activate Pan and Zoom mode"><span class="vanilla__button-icon" aria-hidden="true">zoom_in</span></button>
            <button id="vanilla-reader__menu__button-panzoom-deactivate" title="Exit Pan and Zoom mode"><span class="vanilla__button-icon" aria-hidden="true">zoom_out_map</span></button>
            <button id="vanilla-reader__menu__button-settings" title="Open settings dialog" accesskey="t"><span class="vanilla__button-icon" aria-hidden="true">settings</span></button>
        </div>
            `;
        this._hostDocument = _hostElement.ownerDocument;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._hostElement.insertAdjacentHTML("afterbegin", this._style);
        this._buttonPanZoomActivate = this._hostDocument.getElementById("vanilla-reader__menu__button-panzoom-activate");
        this._buttonPanZoomDeactivate = this._hostDocument.getElementById("vanilla-reader__menu__button-panzoom-deactivate");
        this._buttonSoundtrackActivate = this._hostDocument.getElementById("vanilla-reader__menu__button-soundtrack-activate");
        this._buttonSoundtrackDeactivate = this._hostDocument.getElementById("vanilla-reader__menu__button-soundtrack-deactivate");
        this._buttonSettings = this._hostDocument.getElementById("vanilla-reader__menu__button-settings");
        if (this._enablePanZoomButton) {
            this._buttonPanZoomActivate.addEventListener("click", (_ev)=>{
                this._buttonPanZoomActivate.style.display = "none";
                this._buttonPanZoomDeactivate.style.display = "flex";
                if (this._panZoomActivateCallback) this._panZoomActivateCallback();
            });
            this._buttonPanZoomDeactivate.addEventListener("click", (_ev)=>{
                this._buttonPanZoomDeactivate.style.display = "none";
                this._buttonPanZoomActivate.style.display = "flex";
                if (this._panZoomDeactivateCallback) this._panZoomDeactivateCallback();
            });
        } else this._buttonPanZoomActivate.style.display = "none";
        this._buttonPanZoomDeactivate.style.display = "none";
        this._buttonSoundtrackActivate.style.display = "none";
        this._buttonSoundtrackDeactivate.style.display = "none";
        this._buttonSoundtrackActivate.addEventListener("click", (_ev)=>{
            this._buttonSoundtrackActivate.style.display = "none";
            this._buttonSoundtrackDeactivate.style.display = "flex";
            if (this._startAmbientMediaCallback) this._startAmbientMediaCallback();
        });
        this._buttonSoundtrackDeactivate.addEventListener("click", (_ev)=>{
            this._buttonSoundtrackDeactivate.style.display = "none";
            this._buttonSoundtrackActivate.style.display = "flex";
            if (this._stopAmbientMediaCallback) this._stopAmbientMediaCallback();
        });
        this._buttonSettings.addEventListener("click", (_ev)=>{
            if (this._hostContext.dialogSettings?.isOpen()) this._hostContext.dialogSettings.close();
            else this._hostContext.dialogSettings?.show();
        });
    }
    onPanZoomActivate(callback) {
        this._panZoomActivateCallback = callback;
    }
    onPanZoomDeactivate(callback) {
        this._panZoomDeactivateCallback = callback;
    }
    togglePanZoomButtonState(on) {
        if (on) {
            this._buttonPanZoomDeactivate.style.display = "flex";
            this._buttonPanZoomActivate.style.display = "none";
        } else {
            this._buttonPanZoomActivate.style.display = "flex";
            this._buttonPanZoomDeactivate.style.display = "none";
        }
    }
    enableSoundtrack(isPlaying) {
        if (isPlaying) {
            this._buttonSoundtrackActivate.style.display = "none";
            this._buttonSoundtrackDeactivate.style.display = "flex";
        } else {
            this._buttonSoundtrackActivate.style.display = "flex";
            this._buttonSoundtrackDeactivate.style.display = "none";
        }
    }
    disableSoundtrack() {
        this._buttonSoundtrackActivate.style.display = "none";
        this._buttonSoundtrackDeactivate.style.display = "none";
    }
    onPlayAmbientMedia(callback) {
        this._startAmbientMediaCallback = callback;
    }
    onStopAmbientMedia(callback) {
        this._stopAmbientMediaCallback = callback;
    }
}


class $3cd6cdc67ac03ff1$export$6f143415327f1be4 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.functionButtons.onPanZoomActivate(vanillaReaderUiContext._onPanZoomActivate.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.functionButtons.onPanZoomDeactivate(vanillaReaderUiContext._onPanZoomDeactivate.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.functionButtons.onPlayAmbientMedia(vanillaReaderUiContext._onPlayAmbientMedia.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.functionButtons.onStopAmbientMedia(vanillaReaderUiContext._onStopAmbientMedia.bind(vanillaReaderUiContext));
    }
    _onPanZoomActivate() {
        this.activatePanZoomTool();
    }
    _onPanZoomDeactivate() {
        this.deactivatePanZoomTool();
    }
    _onPlayAmbientMedia() {
        this.playAmbientMedia();
    }
    _onStopAmbientMedia() {
        this.stopAmbientMedia();
    }
}






class $5372a4fd472c9cf4$export$2f49cb7a8e1a38fe {
    constructor(_hostElement, insertPosition = "beforeend"){
        this._hostElement = _hostElement;
        this._treeViewToc = undefined;
        this._navItemClickedCallback = undefined;
        this._onExecuteSearchCallback = undefined;
        this._onClearSearchCallback = undefined;
        this._style = `
        <style>
            #vanilla-reader__side-menu {                
                position: fixed;
                left: 0;
                opacity: 0;
                display: flex;  
                width: 35vw !important;  
                height:100%;              
                margin-left: auto;
                margin-right: auto;
                flex-direction: row;
                flex-wrap: wrap;
                box-sizing: border-box;
                z-index: 2;
                background-color: var(--vanilla-reader__color__ui__background-light);                
                box-shadow: 0 -3px 16px 0 rgb(0 0 0 / 30%);
                border-radius: 16px 16px 0 0;
                border: none;
                border-top: 1px solid var(--vanilla-reader__color__ui__outline-dark);
                pointer-events: none;                
                transition: left 0.2s ease-out;
                will-change: left;
                overflow: auto;
            }
                    
            @media (prefers-reduced-motion: reduce) {
                #vanilla-reader__side-menu {
                    transition: opacity 0.2s ease-out;
                }
            }
            
            #vanilla-reader__side-menu button {
                flex-direction: column;                
                min-height: 48px;
                min-width: 48px;
                font-size: x-large;
                color: var(--vanilla-reader__color__ui__foreground-dark);
                border-color: transparent;
                background-color: transparent;                
            }           
            

      
            #vanilla-reader__side-menu__button-handle {
                height: 24px;                
                min-height: 24px!important;
                width: 100%;
                margin: 8px;
                align-self: center;                
                background-color: transparent;               
                border: 0;
            }

            #vanilla-reader__side-menu__button-handle span {
                width: 100%;
                display: block;
                font-size: x-large;
                color: var(--vanilla-reader__color__ui__foreground-dark);
            }

            #vanilla-reader__side-menu__top-card {
                position:relative;
                background-color: #4d9056!important;
                border-color: #4d9056!important;
                overflow:hidden;
                min-height:150px;
                display: flex;
                align-items:center;
                width: 100%;
            }

            #vanilla-reader__side-menu__top-card:after {
                background: url(data:image/svg+xml;base64,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);
                background-position: 50%;
                background-size: cover;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                opacity: .3;
                content: "";
                background-repeat: no-repeat;
            }

            #vanilla-reader__side-menu__publication-title {
                font-size:1.5rem;
                font-weight:bold;
            }

            #vanilla-reader___side-menu__search-form__input {
                width: 100%;
            }

        </style>`;
        this._template = `
        <aside id="vanilla-reader__side-menu" title="Menu section" aria-hidden="true" inert>     
            <div id="vanilla-reader__side-menu__top-card">
                <div style="z-index:1000; position:absolute; display:flex; width:100%; ">
                    <button id="vanilla-reader__side-menu__button-handle" title="Close menu" accesskey="x" style="flex:0"><span aria-hidden="true">chevron_left</span></button>
                    <div style="flex:1; display:flex; align-items:center;"><span id="vanilla-reader__side-menu__publication-title"></span></div>
                </div>
            </div>
            <div style="width:100%; padding: 0 20px">
                <form id="vanilla-reader___side-menu__search-form">
                    <input type="search" placeholder="Enter search term" aria-label="Enter search term" id="vanilla-reader___side-menu__search-form__input">
                </form>
            </div>
            <hr />
            <section id="vanilla-reader__side-men__section-toc">
                <datalist id="vanilla-reader__side-menu__datalist"></datalist>
            </section>
        </aside>`;
        this._event_menu_keyup = (ev)=>{
            switch(ev.key){
                case "Escape":
                    this.hide();
                    break;
            }
        };
        this._event_formSubmit = (ev)=>{
            ev.preventDefault();
            if (this._onExecuteSearchCallback) this._onExecuteSearchCallback(this._searchInput.value);
        };
        this._event_formMaybeClear = (_ev)=>{
            if (this._searchInput.value === "" && this._onClearSearchCallback) this.clear();
        };
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._hostDocument = _hostElement.ownerDocument;
        this._menu = this._hostDocument.getElementById("vanilla-reader__side-menu");
        this._menu.insertAdjacentHTML("afterbegin", this._style);
        this._buttonMenuHandle = this._hostDocument.getElementById("vanilla-reader__side-menu__button-handle");
        this._menu.addEventListener("keyup", this._event_menu_keyup);
        this._menu.inert = true;
        this._sectionToc = this._menu.querySelector("#vanilla-reader__side-men__section-toc");
        this._publicationTitle = this._hostDocument.getElementById("vanilla-reader__side-menu__publication-title");
        this._searchForm = this._hostDocument.getElementById("vanilla-reader___side-menu__search-form");
        this._searchInput = this._hostDocument.getElementById("vanilla-reader___side-menu__search-form__input");
        this._searchForm.addEventListener("submit", this._event_formSubmit);
        this._searchInput.addEventListener("input", this._event_formMaybeClear);
        this._dataListActions = this._menu.querySelector("#vanilla-reader__side-menu__datalist");
        // Ok, we have references to all the menu component's HTML elements. Now let's setup various behaviours such as
        // event listeners.
        this._setup();
    }
    getComponentElement() {
        return this._hostDocument.getElementById("vanilla-reader__side-menu");
    }
    onMenuHandleSwipeDown(callback) {
        this._swipeDownCallback = callback;
    }
    onMenuHandleClicked(callback) {
        this._menuHandleClickedCallback = callback;
    }
    onMenuVisible(callback) {
        this._visibleCallback = callback;
    }
    onMenuHidden(callback) {
        this._hiddenCallback = callback;
    }
    onNavItemClicked(callback) {
        this._navItemClickedCallback = callback;
    }
    onSearchExecute(callback) {
        this._onExecuteSearchCallback = callback;
    }
    onSearchClear(callback) {
        this._onClearSearchCallback = callback;
    }
    setAsImportantForAccessibility() {
        this._menu.removeAttribute("aria-hidden");
    }
    setAsNotImportantForAccessibility() {
        this._menu.setAttribute("aria-hidden", "true");
    }
    setPublicationTitle(title) {
        this._publicationTitle.innerHTML = title;
    }
    get isVisible() {
        return this._menu.style.opacity === "1";
    }
    show(animate = true) {
        if (!animate) this._menu.style.transition = "opacity 0.2s ease-out";
        else this._menu.style.transition = "left 0.2s ease-out";
        this._toggleMenuButtonsKeyboardFocusable(true);
        this._menu.tabIndex = 0;
        this._menu.inert = false;
        this._menu.style.opacity = "1";
        this._menu.style.left = "0";
        this._focusTrap = (0, $282b77e844ac66e5$export$360440dfcba94c00)(this._menu, {
            allowOutsideClick: true,
            escapeDeactivates: false,
            returnFocusOnDeactivate: true
        });
        this._focusTrap.activate();
        // Wait until just a bit before turning on events and calling the callback function.
        window.setTimeout(()=>{
            this._menu.style.pointerEvents = "auto";
            if (this._visibleCallback) this._visibleCallback();
        }, 500);
    }
    hide(animate = true, silent = false) {
        if (!animate) this._menu.style.transition = "opacity 0.2s ease-out";
        else this._menu.style.transition = "left 0.2s ease-out";
        this._menu.tabIndex = -1;
        this._toggleMenuButtonsKeyboardFocusable(false);
        this._menu.inert = true;
        this._menu.style.pointerEvents = "none";
        this._menu.style.left = `${-(this._menu.clientWidth + 16)}px`;
        // Wait for the animation to finish before calling callback method etc.
        window.setTimeout(()=>{
            this._menu.style.opacity = "0";
            if (this._focusTrap) {
                let options = {
                    returnFocus: false
                };
                try {
                    this._focusTrap.deactivate(options);
                } catch (e) {}
            }
            if (this._hiddenCallback) this._hiddenCallback("menu", silent);
        }, 400);
    }
    populateContents(treeData) {
        if (treeData) {
            let collections = treeData.collections;
            if (collections) {
                this.empty();
                for (const collection of collections)if (collection.type === (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC) {
                    if (!this._treeViewTocItems) this._treeViewTocItems = this._mapNavigationItemDataToTreeItemData(collection.children);
                    this._tocItemsListFlat = this._treeViewTocItems.flatMap((item)=>{
                        return [
                            item,
                            ...item.children
                        ];
                    });
                    for (let item of this._tocItemsListFlat)if (item.data) {
                        let optionElement = document.createElement("option");
                        optionElement.text = item.textContent;
                        optionElement.setAttribute("data-action-id", item.id);
                        optionElement.setAttribute("data-action-name", item.data?.name || "");
                        this._dataListActions.appendChild(optionElement);
                    }
                    this._treeViewToc = new (0, $12a4e63b52eb779b$export$6940b0d9c820eca7)(this._sectionToc, this._treeViewTocItems);
                    this._treeViewToc.cssClassName = "vanilla-reader__dialog-contents__list-toc";
                    this._treeViewToc.addItemClickEventHandler((navItem)=>{
                        if (navItem.data.locator && this._navItemClickedCallback) this._navItemClickedCallback({
                            navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
                            locator: navItem.data.locator
                        });
                    });
                    this._treeViewToc.render();
                }
            }
        }
    }
    empty() {
        if (this._treeViewToc) this._treeViewToc.destroy();
    }
    clear() {
        this._searchInput.value = "";
        this._searchInput.focus();
        if (this._onClearSearchCallback) this._onClearSearchCallback();
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ _setup() {
        this.hide();
        this._buttonMenuHandle.addEventListener("click", (_ev)=>{
            if (this._menuHandleClickedCallback) this._menuHandleClickedCallback();
        });
        this._buttonMenuHandle.addEventListener("touchstart", (ev)=>{
            this._touchEventCoords = [
                ev.changedTouches[0].clientX,
                ev.changedTouches[0].clientY
            ];
        });
        this._buttonMenuHandle.addEventListener("touchend", (ev)=>{
            if (this._touchEventCoords && this._touchEventCoords[1] - ev.changedTouches[0].clientY <= -96) {
                if (this._swipeDownCallback) this._swipeDownCallback();
            }
        });
    }
    _toggleMenuButtonsKeyboardFocusable(focusable) {
        let tabIndex = 0;
        if (!focusable) tabIndex = -1;
        this._menu.querySelectorAll("button").forEach((button)=>button.tabIndex = tabIndex);
    }
    _mapNavigationItemDataToTreeItemData(navigationItems) {
        const map = (navigationItem)=>{
            return {
                data: navigationItem,
                id: navigationItem.locator || "",
                textContent: navigationItem.title,
                children: navigationItem.children && navigationItem.children.map(map)
            };
        };
        return navigationItems.map(map);
    }
}


class $ed17a493d80cdc0c$export$d3ec9010a76b5c89 {
    static __initialize__(vanillaReaderUiContext) {
        vanillaReaderUiContext.menuSide.onMenuHandleClicked(vanillaReaderUiContext._onMenuBottomHandleClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onMenuHandleSwipeDown(vanillaReaderUiContext._onMenuBottomHandleClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onMenuVisible(vanillaReaderUiContext._onMenuBottomVisible.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onMenuHidden(vanillaReaderUiContext._onMenuBottomHidden.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onNavItemClicked(vanillaReaderUiContext._onDialogContentsNavigationItemClicked.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onSearchExecute(vanillaReaderUiContext._onDialogSearchExecute.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.menuSide.onSearchClear(vanillaReaderUiContext._onDialogSearchClear.bind(vanillaReaderUiContext));
    }
    _onMenuBottomHandleClicked() {
        this.menuSide.hide(!this.useReducedMotion);
    }
    _onMenuBottomVisible() {
        this.menuSide.setAsImportantForAccessibility();
        this.setReaderViewAsNotImportantForAccessibility();
    }
    _onMenuBottomHidden() {
        this.menuSide.setAsNotImportantForAccessibility();
        this.setReaderViewAsImportantForAccessibility();
        this.focusOnReadingPosition();
    }
    _onDialogContentsNavigationItemClicked(navigationData) {
        if (navigationData.locator) this.navigateTo(navigationData.locator.toString());
        this.menuSide.hide();
        this.dialogContents?.close(true, false);
    }
    _onDialogSearchExecute(searchTerm) {
        this.dialogSearch.show();
        this.dialogSearch.setSearchTerm(searchTerm);
        this.searchPublication(searchTerm);
    }
    _onDialogSearchClear() {
        this.vanillaReaderAPI?.clearPublicationSearchLayer();
        this.toaster.toast("Search results cleared", true).catch(console.warn);
        this.latestSelectedSearchResultLocator = undefined;
    }
}


class $539461ce1f8559bb$export$aac599461d91d7c2 {
    constructor(_rootElement, vanillaBookshelf, vanillaReaderOptionsDataStore, useDeviceStorage = false, _initialPalette){
        this._rootElement = _rootElement;
        this._initialPalette = _initialPalette;
        this.useDeviceStorage = false;
        this.publicationNavigationTreeData = undefined;
        this.isReaderViewNavigating = false;
        this.isReaderViewTransitioning = false;
        this.mediaPlayerIsInRangePlaybackMode = false;
        this.mediaPlayerIsPausedInRange = false;
        this.mediaPlayerEscapabilityContext = [];
        this.navigationHistoryData = [];
        this.latestTimelinePosition = undefined;
        this.latestReadingPositionData = undefined;
        this.latestCaretLocatorData = undefined;
        this./**
     *
     * UI state fields. These affect UI element behaviour etc. and do not directly reflect the `VanillaReader` state.
     *
     * These fields are accessible to all `VanillaReaderUi*Controller` classes.
     *
     * */ mediaPlayerShouldStartPlaybackWhenReady = false;
        this.isInReadingRulerMode = false;
        this.sendRefreshIntentAfterDialogClosed = false;
        this.showMenuOnReaderViewClick = true;
        this.latestSelectedSearchResultLocator = undefined;
        this._style = `
        <style>
            :root {
                font-size: 16px;
                
                /*
                * The color variables below define the Vanilla Readers "theming system". These vars are used by all
                * UI components, such as the menu and the dialogs, as color values.
                * Check out the setUiTheme method to see how they are used in JavaScript to change app theme.
                */
                
                --vanilla-reader__color__reader__background-light: ${this._initialPalette.backgroundLight};
                --vanilla-reader__color__reader__background-dark: ${this._initialPalette.backgroundDark};
                --vanilla-reader__color__reader__foreground-light: ${this._initialPalette.foregroundLight};
                --vanilla-reader__color__reader__foreground-dark: ${this._initialPalette.foregroundDark};

                --vanilla-reader__color__ui__background-light: ${this._initialPalette.uiBackgroundLight};
                --vanilla-reader__color__ui__background-dark: ${this._initialPalette.uiBackgroundDark};
                --vanilla-reader__color__ui__foreground-light: ${this._initialPalette.uiForegroundLight};
                --vanilla-reader__color__ui__foreground-dark: ${this._initialPalette.uiForegroundDark};
                --vanilla-reader__color__ui__outline-light: ${this._initialPalette.uiOutlineLight};
                --vanilla-reader__color__ui__outline-dark: ${this._initialPalette.uiOutlineDark};
                --vanilla-reader__color__ui__accent: ${this._initialPalette.accent};                     
            }
                    
            hr {            
                min-width: 100%;
                height: 1px;
                border: 0;
                border-top: 1px solid var(--vanilla-reader__color__ui__outline-dark);                
            }
            
            li {
                cursor: pointer;
                margin-top: 1em;
                margin-bottom: 1em;
                min-height: 40px;
            }
            
            li a {
                display: block;
            }
            
            label, input, select {
                display: block;
                margin: 1em;
                margin-left: 0;
                margin-right: 0;
            }
            
            input, select {
                font-size: 16px;
                border-radius: 12px;
                padding: 1em;
                border: 1px solid var(--vanilla-reader__color__ui__outline-dark);                               
            }
            
            select {
                min-width: 12em;
                max-width: min(100%,24em);
            }
            
            input[type=checkbox] {                
                height: 40px;  
                width: 40px;    
                border-radius: 12px;
                /* remove saturation in order to better match with color themes */
                mix-blend-mode: luminosity;   
            }

            input[type=range] {                
                /* remove saturation in order to better match with color themes */
                /* mix-blend-mode: luminosity;   */
            }
            
            textarea {
                font-size: 16px;
            }
            
            button, input[type=button], input[type=submit] {
                font-family: Material Icons Round;
                display: flex;
                flex-direction: row;
                align-items: center;
                align-self: center;
                justify-content: space-around;   
                margin: 0.5em;                               
                cursor: pointer;
                user-select: none;
                border: 0;
                border-radius: 12px;                
                min-width: 48px;
                height: 48px;
                border: 1px solid var(--vanilla-reader__color__ui__outline-dark);
                background-color: var(--vanilla-reader__color__ui__background-light);
                color: var(--vanilla-reader__color__ui__foreground-dark);
            }
            
            button[disabled] {
                opacity: 0.5;
            }
                                    
            #vanilla-reader {                             
                background-color: var(--vanilla-reader__color__reader__background-dark);
                color: var(--vanilla-reader__color__reader__foreground-dark);
                width: 100%;
                height: 100%;
                max-height: 100%;
                display: flex;
                flex-direction: column;        
            }      
            
            #vanilla-reader__reader-view {
                width: 100vw;
                height: 100vh;
                max-height: 100vh;
                position: relative;
                display: flex;
                flex-direction: column;                
            }
            
            #vanilla-reader__reader-view__loader {
                width: auto;
                height: auto;
                text-align: center;
                vertical-align: center;
                animation-name: spin;
                animation-duration: 5000ms;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
            }

            .vanilla-reader__loader {
                position: relative;
                height: 42px;
                width: 42px;
            }

            .vanilla-reader__loader__spinner {
                position: absolute;
                display: inline-block;
                background-color: transparent;
                border-right: 1px solid #69a742;
                border-radius: 50% 50%;
                animation: spin 3s infinite;
                transform: rotate(30deg);
                opacity: .7;
                width: 100%;
                height: 100%;
            }
            .vanilla-reader__loader__logo {
                position: absolute;
                background-image: url(data:image/svg+xml;base64,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);
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                width: 70%;
                height: 70%;
                top: 15%;
                left: 15%;
            }
            
            #vanilla-reader__fab-container {                
                position: fixed;
                z-index: 2;
                display: flex;
                flex-direction: column;
                right: 24px;
                bottom: 24px;
                width: 48px;                                
                cursor: pointer;
                transition: margin-bottom ease-in-out 0.1s;
            }
            
            #vanilla-reader__button-container {
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                z-index: 2;
                align-items: center;
                width: 100%;
                align-self: center;
                background: var(--vanilla-reader__color__ui__background-dark);
            }
            
            #vanilla-reader__slider-progression-container {
                display: flex;
                justify-content: center;
            }
            
            .vanilla-reader__fab {
                display: none;
                pointer-events: none;
                opacity: 0;                
                transition: opacity ease-in-out 0.2s;            
                cursor: pointer;
                z-index: 1;
                box-shadow: 0 4px 8px rgba(0,0,0,0.2);
                background-color: var(--vanilla-reader__color__ui__background-dark);
                color: var(--vanilla-reader__color__ui__foreground-light);
                border-radius: 12px;
                width: 48px;
                height: 48px;
                font-size: x-large;
            }
            
            .vanilla-reader__fab__icon {
                pointer-events: none;
            }
            
            .vanilla-reader__bookmark-container {
                width: 48px;
                height: 48px;
                cursor: pointer;
            }
            
            .vanilla-reader__bookmark-container::before {
                content: "bookmark";
                font-family: "Material Icons Round"            
            }
            
            .colibrio-reader-view-annotation-layer--right-spread .vanilla-reader__bookmark-container {
                right: 0;
                left: unset!important;
            }
            
            .colibrio-custom-page-content {
                pointer-events: none;
            }
            
            .vanilla-reader-icon {
                display: inline-block;
                font-family: Material Icons Round;
                font-weight: normal;
                color: var(--vanilla-reader__color__ui__foreground-dark);
                font-size: 24px;
                margin-right: 0.5em;
                vertical-align: middle;
            }
            
            .vanilla-reader__card {
                padding: 1em;
                border-radius: 12px;                
                box-shadow: 0px 2px 8px rgb(0 0 0 / 17%);
            }

        </style>`;
        this._template = `
        <div id="vanilla-reader">
            <div id="vanilla-reader__reader-view" tabindex="0"></div>     
            <div role="presentation" id="vanilla-reader__slider-progression-container" tabindex="0"></div>       
            <div role="presentation" id="vanilla-reader__button-container" tabindex="0"></div>                           
            <div role="presentation" id="vanilla-reader__fab-container" tabindex="0"></div>                           
        </div>`;
        this.togglePageNumbers = ()=>{
            let newOptionState = !this.dialogSettings.activeShowPageNumberOption;
            this.dialogSettings.setSelectedShowPageNumberOption(newOptionState);
            this.vanillaReaderAPI?.toggleReaderViewPageMarkerVisibility(newOptionState);
        };
        this./*
    *
    * EVENT HANDLERS
    *
    * */ _uiEvent_uiKeyUp = (ev)=>{
            this._handleKeyboardShortcut(ev.key, ev.altKey, ev.shiftKey, ev.ctrlKey);
        };
        this._uiEvent_windowResize = (ev)=>{
            ev.stopPropagation();
            // A resize can happen when an on-screen keyboard pops up for example. If there is a dialog open, such as the
            // search dialog, we do not refresh the reader view as this can disrupt the user experience. We need to add
            // a reminder however to do a refresh later when the dialog has closed.
            if (!this.activeDialogTitle) {
                // TODO: This should really be a top level event listener, perhaps in the VanillaReaderAppMain class.
                (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("APP_WINDOW_RESIZED", {
                    srcEvent: ev
                }));
                this.sendRefreshIntentAfterDialogClosed = false;
            } else this.sendRefreshIntentAfterDialogClosed = true;
            // Re-check if the screen size matches our definition of a mobile screen.
            this.isMobileScreenSize = window.matchMedia("only screen and (max-width: 480px)").matches;
        };
        this._uiEvent_uiOptionsReset = (_options)=>{
            // As we have reset all options we need to invalidate the `previousUiOptionsData` state variable.
            this.previousUiOptionsData = undefined;
        };
        this.vanillaReaderOptionsDataStore = vanillaReaderOptionsDataStore;
        this.vanillaBookshelf = vanillaBookshelf;
        this.useDeviceStorage = useDeviceStorage;
        this.isMobileScreenSize = window.matchMedia("only screen and (max-width: 480px)").matches;
        // Get a deep clone of the default UI options
        const defaultUiOptionsDataString = JSON.stringify((0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options);
        this.activeUiOptionsData = JSON.parse(defaultUiOptionsDataString);
        this._ownerDocument = _rootElement.ownerDocument;
        this._rootElement.innerHTML = this._template;
        this._rootElement.insertAdjacentHTML("afterbegin", this._style);
        this.vanillaReaderUIElement = this._ownerDocument.getElementById("vanilla-reader");
        this.vanillaReaderViewElement = this._ownerDocument.getElementById("vanilla-reader__reader-view");
        this.vanillaReaderButtonContainerElement = this._ownerDocument.getElementById("vanilla-reader__button-container");
        this.vanillaReaderFabContainerElement = this._ownerDocument.getElementById("vanilla-reader__fab-container");
        this.vanillaReaderSliderContainerElement = this._ownerDocument.getElementById("vanilla-reader__slider-progression-container");
        // This component uses output elements to display toast messages.
        this.toaster = new (0, $bca7dcbc805ee09c$export$9149414ff58ba915)(this.vanillaReaderUIElement);
        this.menuBottom = new (0, $24a4e81f2b6663c1$export$3d4f64ec72732a0e)(this.vanillaReaderUIElement, "beforeend", this);
        this.menuSide = new (0, $5372a4fd472c9cf4$export$2f49cb7a8e1a38fe)(this.vanillaReaderUIElement, "beforeend");
        this.menuMediaPlayer = new (0, $649f2472302fbf6b$export$643ea1dbff021c8b)(this.menuBottom.getMediaPlayerContainerElement());
        this.dialogHighlight = new (0, $d6eaf4072ca84a06$export$2a1156151257075e)(this.vanillaReaderUIElement);
        this.dialogHighlights = new (0, $19f0618928aea824$export$388c905326cc79f5)(this.vanillaReaderUIElement);
        this.dialogSettings = new (0, $dcfe4d188eb1caa2$export$99aff4b1844eb55a)(this.vanillaReaderUIElement);
        this.dialogContents = new (0, $43e3403fa824d584$export$66a93469b6997762)(this.vanillaReaderUIElement);
        this.dialogBookmarks = new (0, $77eacbf1d29a054e$export$a0ef6f1510dd6ee3)(this.vanillaReaderUIElement);
        this.dialogSearch = new (0, $32279154c2e73165$export$a39d6020a9602905)(this.vanillaReaderUIElement);
        this.dialogImageViewer = new (0, $74af336e1483b477$export$2a16789284a2ec0)(this.vanillaReaderUIElement);
        this.dialogHelp = new (0, $c22cecb4112f958f$export$65e3f2154417f17b)(this.vanillaReaderUIElement);
        this.dialogOpenFile = new (0, $5a483ffa6a439849$export$30b02a9f27f41c16)(this.vanillaReaderUIElement, "afterbegin", this.useDeviceStorage, []);
        this.masterplanStart = new (0, $41cd53d5779d12bc$export$7ec151cd4178fb4b)(this.vanillaReaderUIElement, "afterbegin");
        this.dialogFootnote = new (0, $f30a84ea8d399c2c$export$bb9fa2da2e9b8963)(this.vanillaReaderUIElement);
        this.dialogUiActions = new (0, $8dee3d7d4253f169$export$b8371b45619761cf)(this.vanillaReaderUIElement);
        this.readingRuler = new (0, $949d3c060ef3afe0$export$a9dafad5522a1a3b)(this.vanillaReaderUIElement, "beforeend");
        this.dialogLandmarks = new (0, $e88a1158099e8080$export$23b8de27b1ad9243)(this.vanillaReaderUIElement);
        this.dialogNavigationHistory = new (0, $95b7d870011bad30$export$d5f03281332b8f17)(this.vanillaReaderUIElement);
        this.fabMediaPlayer = new (0, $309b1409405cd60f$export$f772e11a2a026b3a)(this.vanillaReaderFabContainerElement);
        this.fabHighlight = new (0, $8eeccfaf2615f846$export$2f7be2069423e957)(this.vanillaReaderFabContainerElement);
        this.fabSpeakText = new (0, $4ad4bab2861980cc$export$bc507fcdaf360e3e)(this.vanillaReaderFabContainerElement);
        this.panZoomTool = new (0, $be3221946ebf0b51$export$c19704de2ec1eaeb)(this.vanillaReaderFabContainerElement);
        this.labelPageNumber = new (0, $a87d2123b4d79fd0$export$11b2f654ce5d0663)(this.vanillaReaderSliderContainerElement, "beforeend");
        this.buttonMenu = new (0, $10165c303434af76$export$e57b06630a998963)(this.vanillaReaderButtonContainerElement, "beforeend");
        //this.buttonPrevious = new VanillaReaderUiButtonPrevious(this.vanillaReaderButtonContainerElement, 'beforeend');
        this.menuProgressionSlider = new (0, $af44375496964535$export$3f1e0fed16df5bed)(this.vanillaReaderButtonContainerElement, "beforeend");
        this.functionButtons = new (0, $954b1958e3763ddb$export$e9bbef092049e7c9)(this.vanillaReaderButtonContainerElement, "beforeend", this);
        //this.buttonNext = new VanillaReaderUiButtonNext(this.vanillaReaderButtonContainerElement, 'beforeend');
        if (_initialPalette) this.setUiColorTheme(_initialPalette);
        // In order to get some code separation in VanillaReaderUI class, UI controller code is split up into mixin classes.
        this._applyUiControllerMixins([
            (0, $9da9a5d1a2c3c19f$export$499c73363e921e89),
            (0, $2543dc836a5b86e1$export$fd8a872ef991911c),
            (0, $db7d3271244acdbe$export$58bc822c137e4e45),
            (0, $ed17a493d80cdc0c$export$d3ec9010a76b5c89),
            (0, $5b74c7e0e98a7066$export$9a77c8963be054e1),
            (0, $a66d862f8e976b86$export$5f3d5fd85af6a906),
            (0, $6810f3e03d125232$export$be7e850a7e40f346),
            (0, $26f03edaca4cc466$export$2ed97b2d9ba7d085),
            (0, $9a25081f4659eac5$export$9d151eb701879eb8),
            (0, $8f8efaba4b87e0ee$export$8316e76e4c7c0fc9),
            (0, $07cb77a13df2a195$export$f317f8d05aaf6c48),
            (0, $04f27b2dd57ea0c6$export$9f8c079b7aa8a777),
            (0, $5ba5fdbdc211316d$export$c537af2b9901106e),
            (0, $81ca9fd26f6dbbf0$export$1003937c5f028af1),
            (0, $16eafaf23f2ea416$export$2a16cdd44c6e04c1),
            (0, $cb95b37fbaffd425$export$b3b810734fdcfd10),
            (0, $8df163c44ff9e3dc$export$29d2ca8ac9db0202),
            (0, $8f75d7714857d362$export$6698851ae1c2b42b),
            (0, $b54ab92215f72a81$export$6f1fa999703c70ea),
            (0, $ffc706f83aa31473$export$afef38667e53c4f5),
            (0, $ed8eb279e0f9a27e$export$54cf3042660a7067),
            (0, $f126b516cbe55a33$export$88d1321d45ccc568),
            (0, $0b34040224e6095d$export$455b3e501151f400),
            //VanillaReaderUiButtonNextController,
            //VanillaReaderUiButtonPreviousController,
            (0, $e781ecc3dca79823$export$4e2928d0e6403e09),
            (0, $17e4e03783fd07b3$export$7ea148da10587d3b),
            (0, $dc493da98accc995$export$c0f7910f7d03579a),
            (0, $001c5b6e1a16ece4$export$24bbf92aa358b54f),
            (0, $3908ce7366d3a70c$export$61a498abd5752e90),
            (0, $3cd6cdc67ac03ff1$export$6f143415327f1be4)
        ]);
        window.addEventListener("resize", this._uiEvent_windowResize.bind(this));
        window.addEventListener("keyup", this._uiEvent_uiKeyUp.bind(this));
        this.vanillaReaderAPI.onAppUiOptionsReset(this._uiEvent_uiOptionsReset);
        this._setUpMediaSessionActionHandlers();
        this._addVanillaReaderAPIEventListeners();
        this._setup().catch(console.warn);
    }
    get vanillaReaderAPI() {
        if (!(0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance) throw new Error("VanillaReaderUI.vanillaReaderAPI: The API has not been instantiated.");
        return (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance;
    }
    get isInAccessibilityMode() {
        return this.activeUiOptionsData.useAccessibilityMode || false;
    }
    get isInDarkMode() {
        return this.vanillaReaderAPI.isInDarkMode;
    }
    get useReducedMotion() {
        return this.activeUiOptionsData.useReducedMotion || (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.useReducedMotion;
    }
    clearContentSelection() {
        this.vanillaReaderAPI?.clearContentSelection();
        this.toaster.toast("Text selection cleared.", true).catch(console.warn);
    }
    destroy() {
        window.removeEventListener("resize", this._uiEvent_windowResize.bind(this));
    }
    playAmbientMedia() {
        this.vanillaReaderAPI?.playAmbientMedia();
    }
    stopAmbientMedia() {
        this.vanillaReaderAPI?.stopAmbientMedia();
    }
    setReadingPositionData(readingPositionData) {
        this.latestReadingPositionData = readingPositionData;
    }
    setReaderViewAsNotImportantForAccessibility() {
        this.vanillaReaderViewElement.ariaHidden = "true";
        this.vanillaReaderFabContainerElement.querySelectorAll("button").forEach((buttonElement)=>{
            buttonElement.setAttribute("aria-hidden", "true");
        });
        this.vanillaReaderButtonContainerElement?.querySelectorAll("button").forEach((buttonElement)=>{
            buttonElement.setAttribute("aria-hidden", "true");
        });
    }
    setReaderViewAsImportantForAccessibility() {
        this.vanillaReaderViewElement.removeAttribute("aria-hidden");
        this.vanillaReaderFabContainerElement.querySelectorAll("button").forEach((buttonElement)=>{
            buttonElement.removeAttribute("aria-hidden");
        });
        this.vanillaReaderButtonContainerElement?.querySelectorAll("button").forEach((buttonElement)=>{
            buttonElement.removeAttribute("aria-hidden");
        });
    }
    /*
    *
    * This method serializes the app settings and returns them to the caller.
    * This method is called in index.ts when the app saves the current state.
    *
    * */ serializeToUiOptionsData() {
        let settingsState = this.dialogSettings?.serializeSettingsState();
        settingsState.showNarrationControls = this.menuMediaPlayer.isOpen();
        settingsState.showReadingRuler = this.readingRuler.isVisible;
        return settingsState;
    }
    /*
    *
    * setUiColorTheme takes in a IVanillaReaderColorPalette object and applies it by updating the CSS variables defined in the
    * VanillaReaderUI stylesheet.
    * Note that these colors are specific to the UI, the publication style is updated in the `setPublicationStyleOptions`
    * method.
    *
    * */ setUiColorTheme(palette) {
        if (palette) this.vanillaReaderAPI?.setAppMainColorTheme(palette);
        // Make the overlay match the theme
        this.readingRuler.setOptions({
            overlayBackgroundColor: palette?.backgroundDark || "#000"
        });
    }
    /**
     *
     * This is a utility method for screen reader users. If the user get lost in the interface this method will close
     * all modals and set focus back on the reading position.
     *
     * */ closeAllDialogsAndFocusOnReadingPosition() {
        this.dialogSettings.close(true);
        this.dialogContents.close(true);
        this.dialogSearch.close(true);
        this.dialogHighlights.close(true);
        this.dialogBookmarks.close(true);
        this.dialogHighlight.close(true);
        this.dialogImageViewer.close(true);
        this.dialogHelp.close(true);
        this.dialogFootnote.close(true);
        this.dialogUiActions.close(true, false);
        // `menuBottom.hide` also focuses on reading position
        this.menuBottom.hide(this.useReducedMotion, true);
        this.menuSide.hide(this.useReducedMotion, true);
    }
    /**
     *
     * This is a utility method for screen reader users. It alerts the current reading position using a toast.
     *
     * */ async toastReadingPosition() {
        const announcement = await this._composeReadingPositionAnnouncement();
        this.toaster.toast(announcement || "Unknown reading position", true, 5000).catch(console.warn);
    }
    async toastHrefTargetPositionInfo(href, baseDocumentLocator) {
        let documentLocator = baseDocumentLocator || this.latestReadingPositionData?.locator;
        if (!documentLocator) {
            console.warn("VanillaReaderUI.announceHrefTargetPositionInfo(), Unable to get the locator for the current reading position.");
            return;
        }
        if (href.startsWith("http")) this.toaster.toast(`Link opens URL "${href}"`, true).catch();
        else {
            let contentPositionData = await this.vanillaReaderAPI?.fetchContentPositionDataForHref(href, documentLocator);
            if (contentPositionData) {
                let text = contentPositionData?.navItemData ? `Link opens book section "${contentPositionData.navItemData[0].title}"\nAt location ${contentPositionData.syntheticPageData && contentPositionData.syntheticPageData.length > 0 ? contentPositionData.syntheticPageData[0].label : "?"}` : "";
                if (text) this.toaster.toast(text, true).catch();
            }
        }
    }
    // This method tries to find a `IVanillaReaderLandmarkData` object based on an HTML element's id attribute.
    getFootnoteLandmarkByElementId(id) {
        return this.publicationFootnoteLandmarks?.find((footnote)=>{
            return footnote.attributes.find((attributeData)=>{
                return attributeData.localName === "id" && attributeData.value === id;
            });
        });
    }
    /**
     *
     * This is a utility method for screen reader users. It navigates to the next heading in the publication contents,
     * similar to what the screen reader offers when browsing the web.
     *
     * */ async navigateToNextHeading() {
        let nextHeadingLandmark = undefined;
        let latestTimelinePosition = this.latestTimelinePosition;
        let headings = this.publicationHeadingLandmarks;
        if (headings && latestTimelinePosition) for(let i = 0; i < headings.length; i++){
            let heading = headings[i];
            let timelinePosition = await heading.fetchTimelinePosition();
            if (timelinePosition && timelinePosition > latestTimelinePosition) {
                nextHeadingLandmark = heading;
                break;
            }
        }
        if (nextHeadingLandmark && nextHeadingLandmark.locatorUrl) this.navigateTo(nextHeadingLandmark.locatorUrl, true);
        else this.toaster.toast("No next heading").catch(console.warn);
    }
    /**
     *
     * This is a utility method for screen reader users. It navigates to the previous heading in the publication contents,
     * similar to what the screen reader offers when browsing the web.
     *
     * */ async navigateToPreviousHeading() {
        let previousHeadingLandmark = undefined;
        let latestTimelinePosition = this.latestTimelinePosition;
        let headings = this.publicationHeadingLandmarks;
        if (headings && latestTimelinePosition) for(let i = headings.length - 1; i >= 0; i--){
            let heading = headings[i];
            let timelinePosition = await heading.fetchTimelinePosition();
            if (timelinePosition && timelinePosition < latestTimelinePosition) {
                previousHeadingLandmark = heading;
                break;
            }
        }
        if (previousHeadingLandmark && previousHeadingLandmark.locatorUrl) this.navigateTo(previousHeadingLandmark.locatorUrl, true);
        else this.toaster.toast("No previous heading").catch(console.warn);
    }
    /**
     *
     * `AccessibilityMode` is a "preset" configuration of sorts that is optimised for screen readers.
     * It turns on the `SingleDocumentScrollRenderer`, enlarges the fonts size and turns off animations.
     *
     **/ enterAccessibilityMode() {
        this.previousUiOptionsData = this.dialogSettings.serializeSettingsState();
        // Just in case this was called from an action and not the GUI.
        this.dialogSettings.setUseAccessibilityModeOption(true);
        let pageMargin = this.isMobileScreenSize ? 6 : 18;
        const currentUiOptions = this.activeUiOptionsData;
        currentUiOptions.useAccessibilityMode = true;
        currentUiOptions.publicationStyleOptions = currentUiOptions.publicationStyleOptions ?? {};
        currentUiOptions.publicationStyleOptions.fontSizeScaleFactor = 2.5;
        currentUiOptions.publicationStyleOptions.lineHeightScaleFactor = 1.2;
        currentUiOptions.publicationStyleOptions.pageMargins = {
            left: {
                value: pageMargin,
                unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT
            },
            right: {
                value: pageMargin,
                unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT
            },
            top: {
                unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                value: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.publicationStyleOptions.pageMargins.top.value
            },
            bottom: {
                unit: (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT,
                value: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options.publicationStyleOptions.pageMargins.bottom.value
            }
        };
        this.vanillaReaderAPI.setAppUiOptions(currentUiOptions);
        this.setUseReducedMotion(true);
        this.setPublicationOptions({
            customPublicationCss: {
                injectionPointStart: [
                    ":focus-visible {outline: 2px dotted #ffb55a;}"
                ]
            }
        });
        this.setPublicationRenderer((0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL, true);
        // We need to manually re-focus the AT on the current reading position after the renderer has changed.
        this.vanillaReaderAPI.onRendererChanged(()=>{
            this.focusOnReadingPosition();
        }, true);
        this.menuMediaPlayer.open();
        this.toaster.toast("UI is in accessibility mode.", true).catch(console.warn);
    }
    exitAccessibilityMode() {
        // Just in case this was called from an action and not the GUI.
        this.dialogSettings.setUseAccessibilityModeOption(false);
        this.setPublicationOptions({
            customPublicationCss: {
                injectionPointStart: [
                    ":focus-visible {outline: initial;}"
                ]
            }
        });
        if (this.previousUiOptionsData && !(0, $33027d939f78e552$export$4855211e6b8ad895).deepEqual(this.previousUiOptionsData, this.activeUiOptionsData)) this.vanillaReaderAPI.setAppUiOptions(this.previousUiOptionsData);
        else this.vanillaReaderAPI.resetAppUiOptions();
        // We need to manually re-focus the AT on the current reading position after the renderer has changed.
        this.vanillaReaderAPI.onRendererChanged(()=>{
            this.focusOnReadingPosition();
        }, true);
        this.toaster.toast("UI is not accessibility mode.", true).catch(console.warn);
    }
    setPublicationRenderer(rendererTypeName, ignoreAspectRatio) {
        this.dialogSettings.setSelectedRendererOption(rendererTypeName);
        this.vanillaReaderAPI?.changeRenderer(rendererTypeName, ignoreAspectRatio || this.dialogSettings.activeAspectRatioOption);
    }
    setPublicationStyleOptions(publicationStyleOptions) {
        this.vanillaReaderAPI?.setPublicationStyleOptions(publicationStyleOptions);
    }
    setPublicationOptions(publicationOptions) {
        this.vanillaReaderAPI?.setPublicationOptions(publicationOptions);
    }
    setUseReducedMotion(useReducedMotion) {
        this.dialogSettings.setUseReducedMotionOption(useReducedMotion);
        this.vanillaReaderAPI?.useReducedMotion(useReducedMotion);
    }
    setIgnoreAspectRatio(ignoreAspectRatio) {
        this.dialogSettings.setRendererAspectRatioOption(ignoreAspectRatio);
        this.vanillaReaderAPI?.ignorePublicationAspectRatio(ignoreAspectRatio);
    }
    setScrollOverflowingTables(scrollOverflowingTables) {
        this.vanillaReaderAPI?.scrollOverflowingTables(scrollOverflowingTables);
    }
    highlightVisibleRange(showEditDialog = true) {
        if (this.latestContentRangeData && this.latestContentRangeData.locator) {
            let highlight = {
                locator: this.latestContentRangeData.locator.toUrl().toString(),
                color: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow,
                selectionText: this.latestContentRangeData.visibleTextContent || "",
                comment: ""
            };
            this.dialogHighlight?.setState(highlight, true);
            // Should we show the highlight dialog so that the user can edit it directly, or should we just save it?
            if (showEditDialog) this.dialogHighlight?.show();
            else this._onDialogHighlightAdd(highlight);
        }
    }
    highlightReadingPosition(showEditDialog = true) {
        if (this.latestReadingPositionData && this.latestReadingPositionData.contentBlockData && this.latestReadingPositionData.contentBlockData.locator) {
            let highlight = {
                locator: this.latestReadingPositionData.contentBlockData.locator.toString(),
                color: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow,
                selectionText: this.latestReadingPositionData.contentBlockData.textContent,
                comment: ""
            };
            // Should we show the highlight dialog so that the user can edit it directly, or should we just save it?
            if (showEditDialog) {
                this.dialogHighlight?.setState(highlight, true);
                this.dialogHighlight?.show();
            } else this._onDialogHighlightAdd(highlight);
        }
    }
    /**
     * This method is a quirkfix to let Screen Reader users (primarily NVDA and JAWS) highlight text based on the contents
     * of their clipboard.
     *
     * The reason that we need this is because of the Screen Readers inability to scroll the document as it moves through
     * the document contents. This is a problem for us since we use the visible range as a means to know where the user
     * is reading, so without a change in the visible range we can't can add a correct highlight or bookmark.
     *
     * The way that the Screen Reader user will use this feature is as follows:
     *
     * 1. The user selects and copies the text that represents the location they want highlight or bookmark.
     * 2. The user uses some method to trigger a UI call to the VanillaReader, sending along the text that is currently
     * in the user's clipboard as well as the document index in the publication spine.
     * 3. This method uses the publication search to grab the first occurrence of the string in the specified document.
     * 4. The result is communicated back to the VanillaReaderUI using the `HIGHLIGHT_ADDED` / `BOOKMARK_ADDED` or
     * `HIGHLIGHT_TEXTLOCATION_FAILED` / `BOOKMARK_TEXTLOCATION_FAILED` events.
     *
     * */ async highlightClipboardContents() {
        let clipboardContents = await navigator.clipboard.readText();
        if (!clipboardContents) {
            this.toaster.toast("Unable to create highlight. The clipboard is empty.", true).catch(console.warn);
            return;
        }
        if (this.latestReadingPositionData?.documentIndex) this.vanillaReaderAPI?.highlightTextLocation(clipboardContents, this.latestReadingPositionData.documentIndex, {
            locator: "",
            color: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow,
            selectionText: clipboardContents,
            comment: ""
        });
    }
    /**
     * This method is a "quirkfix" to let Screen Reader users (primarily NVDA and JAWS) highlight text based on the contents
     * of their clipboard.
     *
     * The reason that we need this is because of the Screen Readers inability to scroll the document as it moves through
     * the document contents. This is a problem for us since we use the visible range as a means to know where the user
     * is reading, so without a change in the visible range we can't can add a correct highlight or bookmark.
     *
     * The way that the Screen Reader user will use this feature is as follows:
     *
     * 1. The user selects and copies the text that represents the location they want highlight or bookmark.
     * 2. The user uses some method to trigger a UI call to the VanillaReader, sending along the text that is currently
     * in the user's clipboard as well as the document index in the publication spine.
     * 3. This method uses the publication search to grab the first occurrence of the string in the specified document.
     * 4. The result is communicated back to the VanillaReaderUI using the `HIGHLIGHT_ADDED` / `BOOKMARK_ADDED` or
     * `HIGHLIGHT_TEXTLOCATION_FAILED` / `BOOKMARK_TEXTLOCATION_FAILED` events.
     *
     * */ async bookmarkClipboardContents() {
        let clipboardContents = await navigator.clipboard.readText();
        if (!clipboardContents) {
            this.toaster.toast("Unable to create bookmark. The clipboard is empty.", true).catch(console.warn);
            return;
        }
        if (this.latestReadingPositionData?.documentIndex && clipboardContents) this.vanillaReaderAPI?.bookmarkTextLocation(clipboardContents, this.latestReadingPositionData.documentIndex);
    }
    bookmarkReadingPosition() {
        this.vanillaReaderAPI?.bookmarkReadingPosition();
    }
    focusOnReadingPosition() {
        this.vanillaReaderAPI?.focusOnReadingPosition();
    }
    navigatePrevious(focusNearContentLocation = true) {
        this.vanillaReaderAPI?.navigate({
            navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).PREVIOUS,
            focusNearContentLocation: focusNearContentLocation
        });
    }
    navigateNext(focusNearContentLocation = true) {
        this.vanillaReaderAPI?.navigate({
            navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).NEXT,
            focusNearContentLocation: focusNearContentLocation
        });
    }
    navigateTo(locator, focusNearContentLocation = true) {
        if (this.latestReadingPositionData) this._updateNavigationHistory(this.latestReadingPositionData);
        this.vanillaReaderAPI?.navigate({
            navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).GOTO,
            locator: locator,
            focusNearContentLocation: focusNearContentLocation
        });
    }
    navigateToTimelinePosition(position) {
        if (this.latestReadingPositionData) this._updateNavigationHistory(this.latestReadingPositionData);
        this.vanillaReaderAPI?.navigate({
            navigationType: (0, $652e6cb51d594b1d$export$25e50d252a728e80).TIMELINEPOSITION,
            position: position
        });
    }
    refreshReaderView(force = false) {
        this.vanillaReaderAPI?.refreshReaderView(force);
    }
    searchPublication(searchTerm, resultSetMaxSize, documentsToSearch) {
        this.vanillaReaderAPI?.searchPublication(searchTerm, resultSetMaxSize || 50, documentsToSearch);
    }
    showLandmarksDialog() {
        if (!this.dialogLandmarks.hasBeenPopulated) {
            let landmarks = [
                ...this.publicationHeadingLandmarks || [],
                ...this.publicationTableLandmarks || [],
                ...this.publicationListLandmarks || [],
                ...this.publicationFigureLandmarks || [],
                ...this.publicationFootnoteLandmarks || []
            ];
            this.dialogLandmarks.populate(landmarks);
        }
        this.dialogLandmarks.show();
    }
    /**
     * This method shows a simple browser prompt that lets the user input a location number to navigate to.
     * It's very basic and to the point UI component, so I did not bother making a class etc. for it.
     *
     * Note that there are caveats with using `window.prompt` as it blocks the Main thread until the prompt is closed.
     * This can cause the app to behave incorrectly as event handlers and setTimeout calls will be not be called
     * while the prompt is active.
     *
     * The reason I chose the native prompt for this is that it is, to my knowledge, the only way for
     * us to guarantee that the screen reader will return to its original position within the page contents.
     *
     * The native Dialog element is still not reliable enough to be used from my research.
     */ showGoToPagePrompt() {
        let pageList = this.menuProgressionSlider.syntheticPages;
        if (!pageList) {
            this.toaster.toast("This publication has no defined locations", true).catch(console.warn);
            return;
        }
        // If the SyncMedia is playing we should pause it since the prompt will block the main thread and so the narration
        // gets out of sync with reader view.
        if (this.menuMediaPlayer.stateIsPlaying) this._onMenuMediaPlayerPauseIntent();
        let currentPageItem = this.menuProgressionSlider.activeSyntheticPage;
        let pageInputValue = window.prompt(`Go to page\n\nInput the location number to go to (1-${pageList.length})`, currentPageItem?.label);
        if (!pageInputValue) return;
        let pageItemToGoTo = pageList?.find((item)=>{
            return item.label === pageInputValue;
        });
        if (!pageItemToGoTo || !pageItemToGoTo.range) {
            this.toaster.toast("This location number does not exist in the publication.", true).catch(console.warn);
            return;
        } else this.navigateToTimelinePosition(pageItemToGoTo.range.start);
    }
    closePublicationAndShowFileOpenDialog() {
        this.vanillaReaderAPI?.closePublication();
    }
    openMediaPlayer(startPlaybackWhenReady) {
        this.menuMediaPlayer.open();
        if (startPlaybackWhenReady) this.mediaPlayerShouldStartPlaybackWhenReady = true;
    }
    startMediaPlayer(locator) {
        this.startPlayback(locator);
    }
    closeMediaPlayer() {
        if (this.menuMediaPlayer.isOpen()) {
            this.pausePlayback();
            this.menuMediaPlayer.close();
        }
    }
    speakText(text) {
        this.webSpeechPlayerForTextSelections?.addUtterance({
            text: {
                lang: this.initialPublicationData?.language || "en",
                value: text,
                dir: this.initialPublicationData?.isRtl ? (0, $91ca8664a4c236f4$export$63e1cbbb2c6e2c2).RTL : (0, $91ca8664a4c236f4$export$63e1cbbb2c6e2c2).LTR
            },
            id: Date.now(),
            charOffset: 0,
            nodeData: null
        });
        this.webSpeechPlayerForTextSelections?.play();
    }
    speakActiveSelection() {
        if (this.fabSpeakText.stateIsSpeaking) {
            window.speechSynthesis.cancel();
            this.fabSpeakText.stateIsSpeaking = false;
            return;
        }
        this.speakText(this.activeSelection?.selectionText || "");
        this.fabSpeakText.stateIsSpeaking = true;
    }
    speakTimelineRange(startIndex, endIndex, options) {
        this.vanillaReaderAPI?.playTimelineRange({
            start: {
                segmentIndex: startIndex,
                offsetWithinSegmentMs: 0
            },
            end: {
                segmentIndex: endIndex,
                offsetWithinSegmentMs: 0
            }
        }, options);
    }
    showHighlightDialogWithActiveSelectionState() {
        if (!this.activeSelection || !this.activeSelection.selector) {
            this.toaster.toast("There is no text selection to highlight.", true).catch(console.warn);
            return;
        }
        let highlight = {
            locator: this.activeSelection.selector,
            color: (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).highlightColorValues.yellow,
            selectionText: this.activeSelection.selectionText,
            comment: ""
        };
        this.dialogHighlight?.setState(highlight, true);
        this.dialogHighlight?.show();
    }
    activatePanZoomTool() {
        if (!this.panZoomTool.isActive) this.panZoomTool.activate();
        this.panZoomTool.enablePointerZoom();
        if (this.readingRuler.isVisible) this.readingRuler.hide();
    }
    deactivatePanZoomTool() {
        if (this.isReaderViewIsInPanZoomMode === true) this.panZoomTool.deactivate();
    }
    resetPanZoomTransform() {
        this.panZoomTool.resetZoomLevel();
    }
    zoomToLevel(zoomLevel, animate) {
        this.activatePanZoomTool();
        let relativeZoomLevel = this.activeTransformData?.transformData ? this.activeTransformData.transformData.scale * zoomLevel : zoomLevel;
        this.panZoomTool.zoomToolToLevel(relativeZoomLevel, animate);
        this.panZoomTool.enablePanning();
    }
    zoomToPublicationViewportRect(zoomRect, transformOptions) {
        const zoomDomRect = new DOMRect(zoomRect.x, zoomRect.y, zoomRect.width, zoomRect.height);
        this.vanillaReaderAPI?.zoomToPublicationViewportClientRect(zoomDomRect, (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT, transformOptions);
    }
    showReadingRuler(affectReadingPosition) {
        affectReadingPosition = affectReadingPosition === undefined ? true : affectReadingPosition;
        if (!this.isInReadingRulerMode) {
            let paletteAsset = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === this.activeUiOptionsData?.activeUiPaletteName);
            // We persist the options state in order to be able to switch back to it if the
            // user hides the ruler.
            this.previousUiOptionsData = this.dialogSettings.serializeSettingsState();
            this.setPublicationStyleOptions({
                lineHeightScaleFactor: 1.5,
                palette: paletteAsset
            });
            // Floated elements are really tricky to handle well when the ruler uses snapping. Let's override the
            // publication CSS to not use floats.
            if (this.initialPublicationData?.format.toLowerCase().includes("epub")) this.setPublicationOptions({
                customPublicationCss: {
                    injectionPointEnd: [
                        "* {float: none !important;}"
                    ]
                }
            });
            // Change the renderer only if it is not in scroll mode.
            if (this.dialogSettings.activeRendererTypeName !== (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL) this.setPublicationRenderer((0, $652e6cb51d594b1d$export$7ef357ac666ee52).SWIPE_SINGLE);
            //this.menuBottom.toggleRulerButtonState(true);
            this.isInReadingRulerMode = true;
        }
        this.moveReadingRulerToReadingPosition();
        this.readingRuler.show(undefined, affectReadingPosition);
    }
    hideReadingRuler(exitReadingRulerMode) {
        exitReadingRulerMode = exitReadingRulerMode === undefined ? true : exitReadingRulerMode;
        if (exitReadingRulerMode) {
            // When we opened the ruler we persisted the options state in order to be able to switch back to it if the
            // user hid the ruler. So this is what we'll do.
            if (this.previousUiOptionsData) {
                if (this.previousUiOptionsData.publicationStyleOptions) {
                    if (this.isInDarkMode !== this.previousUiOptionsData.useDarkMode) // If we have changed to dark mode since the ruler was opened, we should respect this.
                    this.previousUiOptionsData.publicationStyleOptions.palette = this.dialogSettings.serializeSettingsState().publicationStyleOptions?.palette;
                    this.setPublicationStyleOptions(this.previousUiOptionsData.publicationStyleOptions);
                }
                // Change the renderer only if it is not in scroll mode.
                if (this.dialogSettings.activeRendererTypeName !== (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL) this.setPublicationRenderer(this.previousUiOptionsData.activeRendererTypeName || (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE);
            }
            // We reset the CSS floats to their initial state.
            if (this.initialPublicationData?.format.toLowerCase().includes("epub")) this.setPublicationOptions({
                customPublicationCss: {
                    injectionPointEnd: [
                        "* {float: initial;}"
                    ]
                }
            });
            //this.menuBottom.toggleRulerButtonState(false);
            this.isInReadingRulerMode = false;
        }
        this.readingRuler.hide();
    }
    moveReadingRulerToNextContentLineBox() {
        if (this.activeDialogTitle === undefined) {
            if (this.readingRuler?.isVisible && this.readingRuler.snapToContentLineBoxes) this.readingRuler.moveToNextContentLineBox(!this.useReducedMotion);
        } else console.warn("VanillaReaderUI.moveReadingRulerToNextContentLineBox", "Unable to move reading ruler as a dialog is open");
    }
    moveReadingRulerToPreviousContentLineBox() {
        if (this.activeDialogTitle === undefined) {
            if (this.readingRuler?.isVisible && this.readingRuler.snapToContentLineBoxes) this.readingRuler.moveToPreviousContentLineBox(!this.useReducedMotion);
        } else console.warn("VanillaReaderUI.moveReadingRulerToPreviousContentLineBox", "Unable to move reading ruler as a dialog is open");
    }
    moveReadingRulerToReadingPosition() {
        let rectData = this.latestReadingPositionData && this.latestReadingPositionData.contentRects ? this.latestReadingPositionData.contentRects[0] : undefined;
        if (this.readingRuler.isVisible && rectData) {
            if (this.readingRuler.snapToContentLineBoxes) this.readingRuler.moveToAndAlign(rectData.clientRect.y, rectData.clientRect.height, !this.useReducedMotion, false);
            else this.readingRuler.moveTo(rectData?.clientRect.y, !this.useReducedMotion, true, false);
        }
    }
    moveReadingRulerToPosition(y, affectReadingPosition = true) {
        if (this.readingRuler.isVisible) this.readingRuler.moveTo(y, !this.useReducedMotion, true, affectReadingPosition);
    }
    moveReadingRulerToPageTop(affectReadingPosition = true) {
        let firstRectOnThePage = this.visibleContentRectData ? this.visibleContentRectData[0].clientRect : undefined;
        if (firstRectOnThePage) {
            if (this.readingRuler.snapToContentLineBoxes) this.readingRuler.moveToAndAlign(firstRectOnThePage.y, firstRectOnThePage.height, !this.useReducedMotion, affectReadingPosition);
            else this.readingRuler.moveTo(firstRectOnThePage.y, !this.useReducedMotion, true, affectReadingPosition);
        }
    }
    showNavigationHistory() {
        if (!this.dialogNavigationHistory.isOpen()) this.dialogNavigationHistory.show();
    }
    initializeProgressionTimeline(timelineData) {
        this.menuProgressionSlider.initializeTimeline(timelineData, this.publicationNavigationTreeData);
    }
    initializeNavigationTree(navigationTreeData) {
        if (this.dialogContents && navigationTreeData) {
            this.publicationNavigationTreeData = navigationTreeData;
            this.dialogContents.populate(navigationTreeData);
            this.menuSide.populateContents(navigationTreeData);
            // Now that we have the navigation tree, we can select the correct tree item based on the initial reading
            // position.
            let latestReadingPosition = this.latestReadingPositionData;
            if (latestReadingPosition && latestReadingPosition.navItemData) {
                this.dialogContents.setActiveTocItems(latestReadingPosition.navItemData);
                this.dialogContents.setActivePageItems(latestReadingPosition.navItemData);
            }
            this.menuProgressionSlider.setNavigationTreeData(navigationTreeData);
            // We can also update the progression label in the menu to show the active toc item.
            // It's just a "refresh" so we just send in the current slider value.
            this.menuProgressionSlider.updateSliderProgressionValue(this.menuProgressionSlider.value);
        }
    }
    /*
    *
    * PRIVATE METHODS
    *
    * */ async _setup() {
        let shelfItems = await this.vanillaBookshelf.fetchShelfItems();
        this.dialogOpenFile.updateShelfItems(shelfItems).catch(console.warn);
        this.dialogOpenFile.closeOnEscKeyUp = false;
        this.initialVanillaReaderUiOptionsData = await this.vanillaReaderOptionsDataStore.fetchVanillaReaderUiOptionsData() || (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options;
        this.dialogSettings.setViewState(this.initialVanillaReaderUiOptionsData);
        // Get default platform voices. These may be overwritten later by a custom TTS implementation.
        // Updates to the voice collection will trigger a `MEDIAPLAYER_VOICE_LIST_CHANGED`.
        const defaultVoicesCollectionData = await (0, $410aa1fb5d04a699$export$aa8547013ca2283b).fetchTtsVoices();
        this.dialogSettings.setTtsVoiceCollectionData(defaultVoicesCollectionData);
        let ttsOptions;
        if (this.initialVanillaReaderUiOptionsData) {
            ttsOptions = this.initialVanillaReaderUiOptionsData.ttsOptions;
            // The user prefers reduced motion, so we will not use movement in our UI transitions.
            if (this.initialVanillaReaderUiOptionsData.useReducedMotion) this.toaster.toast("Using reduced UI animations").catch(console.error);
            if (this.initialVanillaReaderUiOptionsData.readingRulerOptions) {
                this.readingRuler.setOptions(this.initialVanillaReaderUiOptionsData.readingRulerOptions);
                if (this.initialVanillaReaderUiOptionsData.showReadingRuler) this.showReadingRuler();
            }
            // Grab the initial color palette for the app and apply it.
            let palette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === this.initialVanillaReaderUiOptionsData?.activeUiPaletteName);
            if (!palette) palette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === "Dark");
            if (palette) this.setUiColorTheme(palette);
        }
        this.webSpeechPlayerForTextSelections = await this._createWebSpeechSynthesisPlayerForTextSelections(ttsOptions);
    }
    /**
     *
     * */ async _composeReadingPositionAnnouncement() {
        if (this.latestContentRangeData) {
            let previousHeadingLandmark = undefined;
            const latestTimelinePosition = this.latestTimelinePosition;
            let headings = this.publicationHeadingLandmarks;
            let heading = "";
            if (headings && latestTimelinePosition) for(let i = headings.length - 1; i >= 0; i--){
                let heading = headings[i];
                let headingTimelinePosition = await heading.fetchTimelinePosition();
                if (headingTimelinePosition && headingTimelinePosition < latestTimelinePosition) {
                    previousHeadingLandmark = heading;
                    break;
                }
            }
            if (previousHeadingLandmark) heading = `Closest previous heading "${previousHeadingLandmark.textContent}"`;
            let tocItems = this.latestContentRangeData.navItems.filter((item)=>{
                return item.collectionType === (0, $f8f5cf2c043414f4$export$9fe2a4f81c05c3ca).TOC;
            });
            let tocItemTitle = "Unknown";
            if (tocItems && tocItems.length > 0) tocItemTitle = tocItems[0].title;
            let pageItem;
            let pageNumber = "";
            let paginationTypeLabel = "";
            if (this.publicationPageListData && latestTimelinePosition) {
                pageItem = this.publicationPageListData?.pages.find((page)=>{
                    return latestTimelinePosition >= page.range.start && latestTimelinePosition < page.range.end || latestTimelinePosition === page.range.start && latestTimelinePosition === page.range.end;
                });
                paginationTypeLabel = this.publicationPageListData.paginationType === (0, $652e6cb51d594b1d$export$5eef632beec47929).SYNTHETIC ? "in location" : "on page";
                if (pageItem) pageNumber = `${paginationTypeLabel} ${pageItem.label}`;
            }
            let readingProgression = "Unknown";
            if (this.latestContentRangeData.readingProgression) readingProgression = Math.round(this.latestContentRangeData.readingProgression * 100) + "%";
            const announcement = `You are at ${readingProgression} in "${this.initialPublicationData?.title}"\n\nSection "${tocItemTitle}"\n\n${heading}\n\n${pageNumber}`;
            return Promise.resolve(announcement);
        }
    }
    /**
     *
     * This method creates the `WebSpeechTtsSynthesizer` that is used to speak text selections. It has nothing to do
     * with the "real" TTS, which can be found in the `VanillaReaderMediaPlayer` and the `VanillaReaderWebSpeechTtsSynthesizer`
     *
     * */ async _createWebSpeechSynthesisPlayerForTextSelections(ttsOptions) {
        let voicesCollection = await (0, $410aa1fb5d04a699$export$aa8547013ca2283b).fetchTtsVoices();
        let voices = voicesCollection?.allVoices || [];
        let ttsVoiceName = ttsOptions?.voiceName ? ttsOptions.voiceName : (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).options?.ttsOptions?.voiceName;
        ttsVoiceName;
        // Now we filter out the matching `SpeechSynthesisVoice` instance.
        let ttsVoice = voices.find((voice)=>{
            return ttsVoiceName ? voice.name.includes(ttsVoiceName) : false;
        });
        let speechSynt = new (0, $6978732dc0bb5e4e$export$fc39a7efb817638a)((utterance)=>{
            if (ttsVoice) utterance.voice = ttsVoice;
        });
        speechSynt.init({
            onTtsSynthesizerWaiting: ()=>{},
            onUtteranceBoundary: (_utteranceId, _startOffset, _length)=>{},
            onUtteranceEnd: (_utteranceId)=>{
                this.fabSpeakText.stateIsSpeaking = false;
            },
            onUtteranceError: (_utteranceId, _error)=>{
                this.fabSpeakText.stateIsSpeaking = false;
            },
            onUtterancePaused: (_utteranceId)=>{
                this.fabSpeakText.stateIsSpeaking = false;
            },
            onTtsSynthesizerReady: ()=>{}
        });
        return speechSynt;
    }
    _onAfterPublicationLoadedSetup(publicationData) {
        if (this.initialVanillaReaderUiOptionsData?.showNarrationControls || publicationData.hasMoSyncMedia || publicationData.isAudiobook) {
            this.menuMediaPlayer.open();
            this.menuBottom.toggleReadAloudButtonState(true);
            this.fabMediaPlayer.show();
        }
        if ("wakeLock" in navigator) navigator.wakeLock.request("screen").then((sentinel)=>{
            this.screenWakeLockSentinel = sentinel;
        }).catch(console.warn);
        else console.log("wake lock is not supported");
        if (this.initialVanillaReaderUiOptionsData?.scrollOverflowingTables !== undefined) this.setScrollOverflowingTables(this.initialVanillaReaderUiOptionsData?.scrollOverflowingTables);
        if (this.initialVanillaReaderUiOptionsData?.useAccessibilityMode) this.enterAccessibilityMode();
        this.vanillaReaderAPI.fetchTtsVoiceCollection().then((voicesCollection)=>{
            if (voicesCollection) this.dialogSettings.setTtsVoiceCollectionData(voicesCollection);
            else console.warn("VanillaReaderUI._createWebSpeechSynthesisPlayer(): Unable to load TTS voices.");
        }).catch(console.warn);
        this.toaster.toast("Press Alt + F1 / Control + Option + F1 to open help text.", true).catch(console.warn);
    }
    _onPublicationRendered() {}
    _populatePublicationLandmarks() {
        this.vanillaReaderAPI.fetchPublicationLandmarks([
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING1,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING2,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING3,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING4,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING5,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).HEADING6,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).FIGURE,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).IMAGE,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).VIDEO,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).DESCRIPTION_LIST,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).UNORDERED_LIST,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).ORDERED_LIST,
            (0, $652e6cb51d594b1d$export$87e364cacb5e9f8f).TABLE
        ]).catch(console.warn);
    }
    _updateNavigationHistory(readingPositionData) {
        if (this.navigationHistoryData[0]?.locator === readingPositionData.locator) {
            console.log("VanillaReaderUI._updateNavigationHistory(), reading position is identical to the previous entry.");
            return;
        }
        if (this.navigationHistoryData.length >= 10) this.navigationHistoryData = this.navigationHistoryData.slice(this.navigationHistoryData.length - 10, this.navigationHistoryData.length);
        this.navigationHistoryData.unshift(readingPositionData);
        this.dialogNavigationHistory.populate(this.navigationHistoryData);
    }
    // TypeScript type guard
    _eventDataIsPointerEngineEventData(eventData) {
        return eventData.readerViewName !== undefined;
    }
    _eventDataIsMouseEngineEventData(eventData) {
        return eventData.readerViewName !== undefined;
    }
    /*
    *
    * CALLBACKS
    *
    * */ _onPublicationDownloadProgressUpdated(_publicationId, _progress) {}
    _onPublicationDownloaded(publicationId) {
        this.toaster.toast(`Publication ${publicationId} has been added.`).catch(console.error);
    }
    _applyUiControllerMixins(constructors) {
        constructors.forEach((mixinControllerClass)=>{
            Object.getOwnPropertyNames(mixinControllerClass.prototype).forEach((name)=>{
                Object.defineProperty(this.__proto__, name, Object.getOwnPropertyDescriptor(mixinControllerClass.prototype, name) || Object.create(null));
            });
            // If the Class has a static instance method called __initialize__ we call this so that the mixin
            // can do initial setup actions.
            let hasInitializer = Object.getOwnPropertyNames(mixinControllerClass).includes("__initialize__");
            if (hasInitializer) mixinControllerClass.__initialize__(this);
        });
    }
    _findNearestHrefValueInNodeData(nodeData) {
        const _bubblingHrefCheck = (node)=>{
            let href = node.attributes?.find((attr)=>attr?.localName === "href")?.value;
            if (href) return href;
            if (!node.parent) return;
            return _bubblingHrefCheck(node.parent);
        };
        return _bubblingHrefCheck(nodeData);
    }
}


/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 3.2.7, Wed Mar 20 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $2f895839ac78ac6c$var$__assign = function() {
    $2f895839ac78ac6c$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f895839ac78ac6c$var$__assign.apply(this, arguments);
};
function $2f895839ac78ac6c$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $2f895839ac78ac6c$var$_global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
var $2f895839ac78ac6c$var$keys = Object.keys;
var $2f895839ac78ac6c$var$isArray = Array.isArray;
if (typeof Promise !== "undefined" && !$2f895839ac78ac6c$var$_global.Promise) $2f895839ac78ac6c$var$_global.Promise = Promise;
function $2f895839ac78ac6c$var$extend(obj, extension) {
    if (typeof extension !== "object") return obj;
    $2f895839ac78ac6c$var$keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var $2f895839ac78ac6c$var$getProto = Object.getPrototypeOf;
var $2f895839ac78ac6c$var$_hasOwn = {}.hasOwnProperty;
function $2f895839ac78ac6c$var$hasOwn(obj, prop) {
    return $2f895839ac78ac6c$var$_hasOwn.call(obj, prop);
}
function $2f895839ac78ac6c$var$props(proto, extension) {
    if (typeof extension === "function") extension = extension($2f895839ac78ac6c$var$getProto(proto));
    (typeof Reflect === "undefined" ? $2f895839ac78ac6c$var$keys : Reflect.ownKeys)(extension).forEach(function(key) {
        $2f895839ac78ac6c$var$setProp(proto, key, extension[key]);
    });
}
var $2f895839ac78ac6c$var$defineProperty = Object.defineProperty;
function $2f895839ac78ac6c$var$setProp(obj, prop, functionOrGetSet, options) {
    $2f895839ac78ac6c$var$defineProperty(obj, prop, $2f895839ac78ac6c$var$extend(functionOrGetSet && $2f895839ac78ac6c$var$hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function $2f895839ac78ac6c$var$derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            $2f895839ac78ac6c$var$setProp(Child.prototype, "constructor", Child);
            return {
                extend: $2f895839ac78ac6c$var$props.bind(null, Child.prototype)
            };
        }
    };
}
var $2f895839ac78ac6c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function $2f895839ac78ac6c$var$getPropertyDescriptor(obj, prop) {
    var pd = $2f895839ac78ac6c$var$getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = $2f895839ac78ac6c$var$getProto(obj)) && $2f895839ac78ac6c$var$getPropertyDescriptor(proto, prop);
}
var $2f895839ac78ac6c$var$_slice = [].slice;
function $2f895839ac78ac6c$var$slice(args, start, end) {
    return $2f895839ac78ac6c$var$_slice.call(args, start, end);
}
function $2f895839ac78ac6c$var$override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function $2f895839ac78ac6c$var$assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function $2f895839ac78ac6c$var$asap$1(fn) {
    if ($2f895839ac78ac6c$var$_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function $2f895839ac78ac6c$var$arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function $2f895839ac78ac6c$var$tryCatch(fn, onerror, args) {
    try {
        fn.apply(null, args);
    } catch (ex) {
        onerror && onerror(ex);
    }
}
function $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string" && $2f895839ac78ac6c$var$hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== "string") {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf(".");
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : $2f895839ac78ac6c$var$getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ("isFrozen" in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== "string" && "length" in keyPath) {
        $2f895839ac78ac6c$var$assert(typeof value !== "string" && "length" in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$2f895839ac78ac6c$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf(".");
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if ($2f895839ac78ac6c$var$isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !$2f895839ac78ac6c$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $2f895839ac78ac6c$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if ($2f895839ac78ac6c$var$isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function $2f895839ac78ac6c$var$delByKeyPath(obj, keyPath) {
    if (typeof keyPath === "string") $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, undefined);
    else if ("length" in keyPath) [].map.call(keyPath, function(kp) {
        $2f895839ac78ac6c$var$setByKeyPath(obj, kp, undefined);
    });
}
function $2f895839ac78ac6c$var$shallowClone(obj) {
    var rv = {};
    for(var m in obj)if ($2f895839ac78ac6c$var$hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var $2f895839ac78ac6c$var$concat = [].concat;
function $2f895839ac78ac6c$var$flatten(a) {
    return $2f895839ac78ac6c$var$concat.apply([], a);
}
var $2f895839ac78ac6c$var$intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat($2f895839ac78ac6c$var$flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return $2f895839ac78ac6c$var$_global[t];
});
var $2f895839ac78ac6c$var$intrinsicTypes = $2f895839ac78ac6c$var$intrinsicTypeNames.map(function(t) {
    return $2f895839ac78ac6c$var$_global[t];
});
$2f895839ac78ac6c$var$arrayToObject($2f895839ac78ac6c$var$intrinsicTypeNames, function(x) {
    return [
        x,
        true
    ];
});
var $2f895839ac78ac6c$var$circularRefs = null;
function $2f895839ac78ac6c$var$deepClone(any) {
    $2f895839ac78ac6c$var$circularRefs = typeof WeakMap !== "undefined" && new WeakMap();
    var rv = $2f895839ac78ac6c$var$innerDeepClone(any);
    $2f895839ac78ac6c$var$circularRefs = null;
    return rv;
}
function $2f895839ac78ac6c$var$innerDeepClone(any) {
    if (!any || typeof any !== "object") return any;
    var rv = $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.get(any);
    if (rv) return rv;
    if ($2f895839ac78ac6c$var$isArray(any)) {
        rv = [];
        $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.set(any, rv);
        for(var i = 0, l = any.length; i < l; ++i)rv.push($2f895839ac78ac6c$var$innerDeepClone(any[i]));
    } else if ($2f895839ac78ac6c$var$intrinsicTypes.indexOf(any.constructor) >= 0) rv = any;
    else {
        var proto = $2f895839ac78ac6c$var$getProto(any);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        $2f895839ac78ac6c$var$circularRefs && $2f895839ac78ac6c$var$circularRefs.set(any, rv);
        for(var prop in any)if ($2f895839ac78ac6c$var$hasOwn(any, prop)) rv[prop] = $2f895839ac78ac6c$var$innerDeepClone(any[prop]);
    }
    return rv;
}
var $2f895839ac78ac6c$var$toString = {}.toString;
function $2f895839ac78ac6c$var$toStringTag(o) {
    return $2f895839ac78ac6c$var$toString.call(o).slice(8, -1);
}
var $2f895839ac78ac6c$var$iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
var $2f895839ac78ac6c$var$getIteratorOf = typeof $2f895839ac78ac6c$var$iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[$2f895839ac78ac6c$var$iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
var $2f895839ac78ac6c$var$NO_CHAR_ARRAY = {};
function $2f895839ac78ac6c$var$getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if ($2f895839ac78ac6c$var$isArray(arrayLike)) return arrayLike.slice();
        if (this === $2f895839ac78ac6c$var$NO_CHAR_ARRAY && typeof arrayLike === "string") return [
            arrayLike
        ];
        if (it = $2f895839ac78ac6c$var$getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === "number") {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var $2f895839ac78ac6c$var$isAsyncFunction = typeof Symbol !== "undefined" ? function(fn) {
    return fn[Symbol.toStringTag] === "AsyncFunction";
} : function() {
    return false;
};
var $2f895839ac78ac6c$var$debug = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function $2f895839ac78ac6c$var$setDebug(value, filter) {
    $2f895839ac78ac6c$var$debug = value;
    $2f895839ac78ac6c$var$libraryFilter = filter;
}
var $2f895839ac78ac6c$var$libraryFilter = function() {
    return true;
};
var $2f895839ac78ac6c$var$NEEDS_THROW_FOR_STACK = !new Error("").stack;
function $2f895839ac78ac6c$var$getErrorWithStack() {
    if ($2f895839ac78ac6c$var$NEEDS_THROW_FOR_STACK) try {
        $2f895839ac78ac6c$var$getErrorWithStack.arguments;
        throw new Error();
    } catch (e) {
        return e;
    }
    return new Error();
}
function $2f895839ac78ac6c$var$prettyStack(exception, numIgnoredFrames) {
    var stack = exception.stack;
    if (!stack) return "";
    numIgnoredFrames = numIgnoredFrames || 0;
    if (stack.indexOf(exception.name) === 0) numIgnoredFrames += (exception.name + exception.message).split("\n").length;
    return stack.split("\n").slice(numIgnoredFrames).filter($2f895839ac78ac6c$var$libraryFilter).map(function(frame) {
        return "\n" + frame;
    }).join("");
}
var $2f895839ac78ac6c$var$dexieErrorNames = [
    "Modify",
    "Bulk",
    "OpenFailed",
    "VersionChange",
    "Schema",
    "Upgrade",
    "InvalidTable",
    "MissingAPI",
    "NoSuchDatabase",
    "InvalidArgument",
    "SubTransaction",
    "Unsupported",
    "Internal",
    "DatabaseClosed",
    "PrematureCommit",
    "ForeignAwait"
];
var $2f895839ac78ac6c$var$idbDomErrorNames = [
    "Unknown",
    "Constraint",
    "Data",
    "TransactionInactive",
    "ReadOnly",
    "Version",
    "NotFound",
    "InvalidState",
    "InvalidAccess",
    "Abort",
    "Timeout",
    "QuotaExceeded",
    "Syntax",
    "DataClone"
];
var $2f895839ac78ac6c$var$errorList = $2f895839ac78ac6c$var$dexieErrorNames.concat($2f895839ac78ac6c$var$idbDomErrorNames);
var $2f895839ac78ac6c$var$defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function $2f895839ac78ac6c$var$DexieError(name, msg) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.name = name;
    this.message = msg;
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$DexieError).from(Error).extend({
    stack: {
        get: function() {
            return this._stack || (this._stack = this.name + ": " + this.message + $2f895839ac78ac6c$var$prettyStack(this._e, 2));
        }
    },
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join("\n");
}
function $2f895839ac78ac6c$var$ModifyError(msg, failures, successCount, failedKeys) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures);
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$ModifyError).from($2f895839ac78ac6c$var$DexieError);
function $2f895839ac78ac6c$var$BulkError(msg, failures) {
    this._e = $2f895839ac78ac6c$var$getErrorWithStack();
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = $2f895839ac78ac6c$var$getMultiErrorMessage(msg, failures);
}
$2f895839ac78ac6c$var$derive($2f895839ac78ac6c$var$BulkError).from($2f895839ac78ac6c$var$DexieError);
var $2f895839ac78ac6c$var$errnames = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var $2f895839ac78ac6c$var$BaseException = $2f895839ac78ac6c$var$DexieError;
var $2f895839ac78ac6c$var$exceptions = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this._e = $2f895839ac78ac6c$var$getErrorWithStack();
        this.name = fullName;
        if (!msgOrInner) {
            this.message = $2f895839ac78ac6c$var$defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === "string") {
            this.message = "" + msgOrInner + (!inner ? "" : "\n " + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === "object") {
            this.message = msgOrInner.name + " " + msgOrInner.message;
            this.inner = msgOrInner;
        }
    }
    $2f895839ac78ac6c$var$derive(DexieError).from($2f895839ac78ac6c$var$BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
$2f895839ac78ac6c$var$exceptions.Syntax = SyntaxError;
$2f895839ac78ac6c$var$exceptions.Type = TypeError;
$2f895839ac78ac6c$var$exceptions.Range = RangeError;
var $2f895839ac78ac6c$var$exceptionMap = $2f895839ac78ac6c$var$idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = $2f895839ac78ac6c$var$exceptions[name];
    return obj;
}, {});
function $2f895839ac78ac6c$var$mapError(domError, message) {
    if (!domError || domError instanceof $2f895839ac78ac6c$var$DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !$2f895839ac78ac6c$var$exceptionMap[domError.name]) return domError;
    var rv = new $2f895839ac78ac6c$var$exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) $2f895839ac78ac6c$var$setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var $2f895839ac78ac6c$var$fullNameExceptions = $2f895839ac78ac6c$var$errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = $2f895839ac78ac6c$var$exceptions[name];
    return obj;
}, {});
$2f895839ac78ac6c$var$fullNameExceptions.ModifyError = $2f895839ac78ac6c$var$ModifyError;
$2f895839ac78ac6c$var$fullNameExceptions.DexieError = $2f895839ac78ac6c$var$DexieError;
$2f895839ac78ac6c$var$fullNameExceptions.BulkError = $2f895839ac78ac6c$var$BulkError;
function $2f895839ac78ac6c$var$nop() {}
function $2f895839ac78ac6c$var$mirror(val) {
    return val;
}
function $2f895839ac78ac6c$var$pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === $2f895839ac78ac6c$var$mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function $2f895839ac78ac6c$var$callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function $2f895839ac78ac6c$var$hookCreatingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function $2f895839ac78ac6c$var$hookDeletingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
    };
}
function $2f895839ac78ac6c$var$hookUpdatingChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        $2f895839ac78ac6c$var$extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? $2f895839ac78ac6c$var$callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? $2f895839ac78ac6c$var$callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : $2f895839ac78ac6c$var$extend(res, res2);
    };
}
function $2f895839ac78ac6c$var$reverseStoppableEventChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function $2f895839ac78ac6c$var$promisableChain(f1, f2) {
    if (f1 === $2f895839ac78ac6c$var$nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === "function") {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var $2f895839ac78ac6c$var$INTERNAL = {};
var $2f895839ac78ac6c$var$LONG_STACKS_CLIP_LIMIT = 100, $2f895839ac78ac6c$var$MAX_LONG_STACKS = 20, $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT = 100, $2f895839ac78ac6c$var$_a$1 = typeof Promise === "undefined" ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === "undefined" || !crypto.subtle) return [
        globalP,
        $2f895839ac78ac6c$var$getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        $2f895839ac78ac6c$var$getProto(nativeP),
        globalP
    ];
}(), $2f895839ac78ac6c$var$resolvedNativePromise = $2f895839ac78ac6c$var$_a$1[0], $2f895839ac78ac6c$var$nativePromiseProto = $2f895839ac78ac6c$var$_a$1[1], $2f895839ac78ac6c$var$resolvedGlobalPromise = $2f895839ac78ac6c$var$_a$1[2], $2f895839ac78ac6c$var$nativePromiseThen = $2f895839ac78ac6c$var$nativePromiseProto && $2f895839ac78ac6c$var$nativePromiseProto.then;
var $2f895839ac78ac6c$var$NativePromise = $2f895839ac78ac6c$var$resolvedNativePromise && $2f895839ac78ac6c$var$resolvedNativePromise.constructor;
var $2f895839ac78ac6c$var$patchGlobalPromise = !!$2f895839ac78ac6c$var$resolvedGlobalPromise;
var $2f895839ac78ac6c$var$stack_being_generated = false;
var $2f895839ac78ac6c$var$schedulePhysicalTick = $2f895839ac78ac6c$var$resolvedGlobalPromise ? function() {
    $2f895839ac78ac6c$var$resolvedGlobalPromise.then($2f895839ac78ac6c$var$physicalTick);
} : $2f895839ac78ac6c$var$_global.setImmediate ? setImmediate.bind(null, $2f895839ac78ac6c$var$physicalTick) : $2f895839ac78ac6c$var$_global.MutationObserver ? function() {
    var hiddenDiv = document.createElement("div");
    new MutationObserver(function() {
        $2f895839ac78ac6c$var$physicalTick();
        hiddenDiv = null;
    }).observe(hiddenDiv, {
        attributes: true
    });
    hiddenDiv.setAttribute("i", "1");
} : function() {
    setTimeout($2f895839ac78ac6c$var$physicalTick, 0);
};
var $2f895839ac78ac6c$var$asap = function(callback, args) {
    $2f895839ac78ac6c$var$microtickQueue.push([
        callback,
        args
    ]);
    if ($2f895839ac78ac6c$var$needsNewPhysicalTick) {
        $2f895839ac78ac6c$var$schedulePhysicalTick();
        $2f895839ac78ac6c$var$needsNewPhysicalTick = false;
    }
};
var $2f895839ac78ac6c$var$isOutsideMicroTick = true, $2f895839ac78ac6c$var$needsNewPhysicalTick = true, $2f895839ac78ac6c$var$unhandledErrors = [], $2f895839ac78ac6c$var$rejectingErrors = [], $2f895839ac78ac6c$var$currentFulfiller = null, $2f895839ac78ac6c$var$rejectionMapper = $2f895839ac78ac6c$var$mirror;
var $2f895839ac78ac6c$var$globalPSD = {
    id: "global",
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: $2f895839ac78ac6c$var$globalError,
    pgp: false,
    env: {},
    finalize: function() {
        this.unhandleds.forEach(function(uh) {
            try {
                $2f895839ac78ac6c$var$globalError(uh[0], uh[1]);
            } catch (e) {}
        });
    }
};
var $2f895839ac78ac6c$var$PSD = $2f895839ac78ac6c$var$globalPSD;
var $2f895839ac78ac6c$var$microtickQueue = [];
var $2f895839ac78ac6c$var$numScheduledCalls = 0;
var $2f895839ac78ac6c$var$tickFinalizers = [];
function $2f895839ac78ac6c$var$DexiePromise(fn) {
    if (typeof this !== "object") throw new TypeError("Promises must be constructed via new");
    this._listeners = [];
    this.onuncatched = $2f895839ac78ac6c$var$nop;
    this._lib = false;
    var psd = this._PSD = $2f895839ac78ac6c$var$PSD;
    if ($2f895839ac78ac6c$var$debug) {
        this._stackHolder = $2f895839ac78ac6c$var$getErrorWithStack();
        this._prev = null;
        this._numPrev = 0;
    }
    if (typeof fn !== "function") {
        if (fn !== $2f895839ac78ac6c$var$INTERNAL) throw new TypeError("Not a function");
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) $2f895839ac78ac6c$var$handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    $2f895839ac78ac6c$var$executePromiseTask(this, fn);
}
var $2f895839ac78ac6c$var$thenProp = {
    get: function() {
        var psd = $2f895839ac78ac6c$var$PSD, microTaskId = $2f895839ac78ac6c$var$totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== $2f895839ac78ac6c$var$PSD || microTaskId !== $2f895839ac78ac6c$var$totalEchoes);
            var cleanup = possibleAwait && !$2f895839ac78ac6c$var$decrementExpectedAwaits();
            var rv = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                $2f895839ac78ac6c$var$propagateToListener(_this, new $2f895839ac78ac6c$var$Listener($2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            $2f895839ac78ac6c$var$debug && $2f895839ac78ac6c$var$linkToPreviousPromise(rv, this);
            return rv;
        }
        then.prototype = $2f895839ac78ac6c$var$INTERNAL;
        return then;
    },
    set: function(value) {
        $2f895839ac78ac6c$var$setProp(this, "then", value && value.prototype === $2f895839ac78ac6c$var$INTERNAL ? $2f895839ac78ac6c$var$thenProp : {
            get: function() {
                return value;
            },
            set: $2f895839ac78ac6c$var$thenProp.set
        });
    }
};
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$DexiePromise.prototype, {
    then: $2f895839ac78ac6c$var$thenProp,
    _then: function(onFulfilled, onRejected) {
        $2f895839ac78ac6c$var$propagateToListener(this, new $2f895839ac78ac6c$var$Listener(null, null, onFulfilled, onRejected, $2f895839ac78ac6c$var$PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === "function" ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : $2f895839ac78ac6c$var$PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : $2f895839ac78ac6c$var$PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            onFinally();
            return value;
        }, function(err) {
            onFinally();
            return $2f895839ac78ac6c$var$PromiseReject(err);
        });
    },
    stack: {
        get: function() {
            if (this._stack) return this._stack;
            try {
                $2f895839ac78ac6c$var$stack_being_generated = true;
                var stacks = $2f895839ac78ac6c$var$getStack(this, [], $2f895839ac78ac6c$var$MAX_LONG_STACKS);
                var stack = stacks.join("\nFrom previous: ");
                if (this._state !== null) this._stack = stack;
                return stack;
            } finally{
                $2f895839ac78ac6c$var$stack_being_generated = false;
            }
        }
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new $2f895839ac78ac6c$var$exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag) $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
$2f895839ac78ac6c$var$globalPSD.env = $2f895839ac78ac6c$var$snapShot();
function $2f895839ac78ac6c$var$Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$DexiePromise, {
    all: function() {
        var values = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof $2f895839ac78ac6c$var$DexiePromise) return value;
        if (value && typeof value.then === "function") return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new $2f895839ac78ac6c$var$DexiePromise($2f895839ac78ac6c$var$INTERNAL, true, value);
        $2f895839ac78ac6c$var$linkToPreviousPromise(rv, $2f895839ac78ac6c$var$currentFulfiller);
        return rv;
    },
    reject: $2f895839ac78ac6c$var$PromiseReject,
    race: function() {
        var values = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return $2f895839ac78ac6c$var$PSD;
        },
        set: function(value) {
            return $2f895839ac78ac6c$var$PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return $2f895839ac78ac6c$var$totalEchoes;
        }
    },
    newPSD: $2f895839ac78ac6c$var$newScope,
    usePSD: $2f895839ac78ac6c$var$usePSD,
    scheduler: {
        get: function() {
            return $2f895839ac78ac6c$var$asap;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return $2f895839ac78ac6c$var$rejectionMapper;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            return $2f895839ac78ac6c$var$newScope(function(resolve, reject) {
                var psd = $2f895839ac78ac6c$var$PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = $2f895839ac78ac6c$var$callBoth(function() {
                    var _this = this;
                    $2f895839ac78ac6c$var$run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if ($2f895839ac78ac6c$var$NativePromise) {
    if ($2f895839ac78ac6c$var$NativePromise.allSettled) $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise, "allSettled", function() {
        var possiblePromises = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if ($2f895839ac78ac6c$var$NativePromise.any && typeof AggregateError !== "undefined") $2f895839ac78ac6c$var$setProp($2f895839ac78ac6c$var$DexiePromise, "any", function() {
        var possiblePromises = $2f895839ac78ac6c$var$getArrayOf.apply(null, arguments).map($2f895839ac78ac6c$var$onPossibleParallellAsync);
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return $2f895839ac78ac6c$var$DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
}
function $2f895839ac78ac6c$var$executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError("A promise cannot be resolved with itself.");
            var shouldExecuteTick = promise._lib && $2f895839ac78ac6c$var$beginMicroTickScope();
            if (value && typeof value.then === "function") $2f895839ac78ac6c$var$executePromiseTask(promise, function(resolve, reject) {
                value instanceof $2f895839ac78ac6c$var$DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                $2f895839ac78ac6c$var$propagateAllListeners(promise);
            }
            if (shouldExecuteTick) $2f895839ac78ac6c$var$endMicroTickScope();
        }, $2f895839ac78ac6c$var$handleRejection.bind(null, promise));
    } catch (ex) {
        $2f895839ac78ac6c$var$handleRejection(promise, ex);
    }
}
function $2f895839ac78ac6c$var$handleRejection(promise, reason) {
    $2f895839ac78ac6c$var$rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && $2f895839ac78ac6c$var$beginMicroTickScope();
    reason = $2f895839ac78ac6c$var$rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    $2f895839ac78ac6c$var$debug && reason !== null && typeof reason === "object" && !reason._promise && $2f895839ac78ac6c$var$tryCatch(function() {
        var origProp = $2f895839ac78ac6c$var$getPropertyDescriptor(reason, "stack");
        reason._promise = promise;
        $2f895839ac78ac6c$var$setProp(reason, "stack", {
            get: function() {
                return $2f895839ac78ac6c$var$stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
            }
        });
    });
    $2f895839ac78ac6c$var$addPossiblyUnhandledError(promise);
    $2f895839ac78ac6c$var$propagateAllListeners(promise);
    if (shouldExecuteTick) $2f895839ac78ac6c$var$endMicroTickScope();
}
function $2f895839ac78ac6c$var$propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)$2f895839ac78ac6c$var$propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if ($2f895839ac78ac6c$var$numScheduledCalls === 0) {
        ++$2f895839ac78ac6c$var$numScheduledCalls;
        $2f895839ac78ac6c$var$asap(function() {
            if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
        }, []);
    }
}
function $2f895839ac78ac6c$var$propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++$2f895839ac78ac6c$var$numScheduledCalls;
    $2f895839ac78ac6c$var$asap($2f895839ac78ac6c$var$callListener, [
        cb,
        promise,
        listener
    ]);
}
function $2f895839ac78ac6c$var$callListener(cb, promise, listener) {
    try {
        $2f895839ac78ac6c$var$currentFulfiller = promise;
        var ret, value = promise._value;
        if (promise._state) ret = cb(value);
        else {
            if ($2f895839ac78ac6c$var$rejectingErrors.length) $2f895839ac78ac6c$var$rejectingErrors = [];
            ret = cb(value);
            if ($2f895839ac78ac6c$var$rejectingErrors.indexOf(value) === -1) $2f895839ac78ac6c$var$markErrorAsHandled(promise);
        }
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        $2f895839ac78ac6c$var$currentFulfiller = null;
        if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function $2f895839ac78ac6c$var$getStack(promise, stacks, limit) {
    if (stacks.length === limit) return stacks;
    var stack = "";
    if (promise._state === false) {
        var failure = promise._value, errorName, message;
        if (failure != null) {
            errorName = failure.name || "Error";
            message = failure.message || failure;
            stack = $2f895839ac78ac6c$var$prettyStack(failure, 0);
        } else {
            errorName = failure;
            message = "";
        }
        stacks.push(errorName + (message ? ": " + message : "") + stack);
    }
    if ($2f895839ac78ac6c$var$debug) {
        stack = $2f895839ac78ac6c$var$prettyStack(promise._stackHolder, 2);
        if (stack && stacks.indexOf(stack) === -1) stacks.push(stack);
        if (promise._prev) $2f895839ac78ac6c$var$getStack(promise._prev, stacks, limit);
    }
    return stacks;
}
function $2f895839ac78ac6c$var$linkToPreviousPromise(promise, prev) {
    var numPrev = prev ? prev._numPrev + 1 : 0;
    if (numPrev < $2f895839ac78ac6c$var$LONG_STACKS_CLIP_LIMIT) {
        promise._prev = prev;
        promise._numPrev = numPrev;
    }
}
function $2f895839ac78ac6c$var$physicalTick() {
    $2f895839ac78ac6c$var$beginMicroTickScope() && $2f895839ac78ac6c$var$endMicroTickScope();
}
function $2f895839ac78ac6c$var$beginMicroTickScope() {
    var wasRootExec = $2f895839ac78ac6c$var$isOutsideMicroTick;
    $2f895839ac78ac6c$var$isOutsideMicroTick = false;
    $2f895839ac78ac6c$var$needsNewPhysicalTick = false;
    return wasRootExec;
}
function $2f895839ac78ac6c$var$endMicroTickScope() {
    var callbacks, i, l;
    do while($2f895839ac78ac6c$var$microtickQueue.length > 0){
        callbacks = $2f895839ac78ac6c$var$microtickQueue;
        $2f895839ac78ac6c$var$microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while ($2f895839ac78ac6c$var$microtickQueue.length > 0);
    $2f895839ac78ac6c$var$isOutsideMicroTick = true;
    $2f895839ac78ac6c$var$needsNewPhysicalTick = true;
}
function $2f895839ac78ac6c$var$finalizePhysicalTick() {
    var unhandledErrs = $2f895839ac78ac6c$var$unhandledErrors;
    $2f895839ac78ac6c$var$unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = $2f895839ac78ac6c$var$tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function $2f895839ac78ac6c$var$run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        $2f895839ac78ac6c$var$tickFinalizers.splice($2f895839ac78ac6c$var$tickFinalizers.indexOf(finalizer), 1);
    }
    $2f895839ac78ac6c$var$tickFinalizers.push(finalizer);
    ++$2f895839ac78ac6c$var$numScheduledCalls;
    $2f895839ac78ac6c$var$asap(function() {
        if (--$2f895839ac78ac6c$var$numScheduledCalls === 0) $2f895839ac78ac6c$var$finalizePhysicalTick();
    }, []);
}
function $2f895839ac78ac6c$var$addPossiblyUnhandledError(promise) {
    if (!$2f895839ac78ac6c$var$unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) $2f895839ac78ac6c$var$unhandledErrors.push(promise);
}
function $2f895839ac78ac6c$var$markErrorAsHandled(promise) {
    var i = $2f895839ac78ac6c$var$unhandledErrors.length;
    while(i)if ($2f895839ac78ac6c$var$unhandledErrors[--i]._value === promise._value) {
        $2f895839ac78ac6c$var$unhandledErrors.splice(i, 1);
        return;
    }
}
function $2f895839ac78ac6c$var$PromiseReject(reason) {
    return new $2f895839ac78ac6c$var$DexiePromise($2f895839ac78ac6c$var$INTERNAL, false, reason);
}
function $2f895839ac78ac6c$var$wrap(fn, errorCatcher) {
    var psd = $2f895839ac78ac6c$var$PSD;
    return function() {
        var wasRootExec = $2f895839ac78ac6c$var$beginMicroTickScope(), outerScope = $2f895839ac78ac6c$var$PSD;
        try {
            $2f895839ac78ac6c$var$switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            $2f895839ac78ac6c$var$switchToZone(outerScope, false);
            if (wasRootExec) $2f895839ac78ac6c$var$endMicroTickScope();
        }
    };
}
var $2f895839ac78ac6c$var$task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var $2f895839ac78ac6c$var$taskCounter = 0;
var $2f895839ac78ac6c$var$zoneStack = [];
var $2f895839ac78ac6c$var$zoneEchoes = 0;
var $2f895839ac78ac6c$var$totalEchoes = 0;
var $2f895839ac78ac6c$var$zone_id_counter = 0;
function $2f895839ac78ac6c$var$newScope(fn, props, a1, a2) {
    var parent = $2f895839ac78ac6c$var$PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++$2f895839ac78ac6c$var$zone_id_counter;
    var globalEnv = $2f895839ac78ac6c$var$globalPSD.env;
    psd.env = $2f895839ac78ac6c$var$patchGlobalPromise ? {
        Promise: $2f895839ac78ac6c$var$DexiePromise,
        PromiseProp: {
            value: $2f895839ac78ac6c$var$DexiePromise,
            configurable: true,
            writable: true
        },
        all: $2f895839ac78ac6c$var$DexiePromise.all,
        race: $2f895839ac78ac6c$var$DexiePromise.race,
        allSettled: $2f895839ac78ac6c$var$DexiePromise.allSettled,
        any: $2f895839ac78ac6c$var$DexiePromise.any,
        resolve: $2f895839ac78ac6c$var$DexiePromise.resolve,
        reject: $2f895839ac78ac6c$var$DexiePromise.reject,
        nthen: $2f895839ac78ac6c$var$getPatchedPromiseThen(globalEnv.nthen, psd),
        gthen: $2f895839ac78ac6c$var$getPatchedPromiseThen(globalEnv.gthen, psd)
    } : {};
    if (props) $2f895839ac78ac6c$var$extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = $2f895839ac78ac6c$var$usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function $2f895839ac78ac6c$var$incrementExpectedAwaits() {
    if (!$2f895839ac78ac6c$var$task.id) $2f895839ac78ac6c$var$task.id = ++$2f895839ac78ac6c$var$taskCounter;
    ++$2f895839ac78ac6c$var$task.awaits;
    $2f895839ac78ac6c$var$task.echoes += $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT;
    return $2f895839ac78ac6c$var$task.id;
}
function $2f895839ac78ac6c$var$decrementExpectedAwaits() {
    if (!$2f895839ac78ac6c$var$task.awaits) return false;
    if (--$2f895839ac78ac6c$var$task.awaits === 0) $2f895839ac78ac6c$var$task.id = 0;
    $2f895839ac78ac6c$var$task.echoes = $2f895839ac78ac6c$var$task.awaits * $2f895839ac78ac6c$var$ZONE_ECHO_LIMIT;
    return true;
}
if (("" + $2f895839ac78ac6c$var$nativePromiseThen).indexOf("[native code]") === -1) $2f895839ac78ac6c$var$incrementExpectedAwaits = $2f895839ac78ac6c$var$decrementExpectedAwaits = $2f895839ac78ac6c$var$nop;
function $2f895839ac78ac6c$var$onPossibleParallellAsync(possiblePromise) {
    if ($2f895839ac78ac6c$var$task.echoes && possiblePromise && possiblePromise.constructor === $2f895839ac78ac6c$var$NativePromise) {
        $2f895839ac78ac6c$var$incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            $2f895839ac78ac6c$var$decrementExpectedAwaits();
            return x;
        }, function(e) {
            $2f895839ac78ac6c$var$decrementExpectedAwaits();
            return $2f895839ac78ac6c$var$rejection(e);
        });
    }
    return possiblePromise;
}
function $2f895839ac78ac6c$var$zoneEnterEcho(targetZone) {
    ++$2f895839ac78ac6c$var$totalEchoes;
    if (!$2f895839ac78ac6c$var$task.echoes || --$2f895839ac78ac6c$var$task.echoes === 0) $2f895839ac78ac6c$var$task.echoes = $2f895839ac78ac6c$var$task.id = 0;
    $2f895839ac78ac6c$var$zoneStack.push($2f895839ac78ac6c$var$PSD);
    $2f895839ac78ac6c$var$switchToZone(targetZone, true);
}
function $2f895839ac78ac6c$var$zoneLeaveEcho() {
    var zone = $2f895839ac78ac6c$var$zoneStack[$2f895839ac78ac6c$var$zoneStack.length - 1];
    $2f895839ac78ac6c$var$zoneStack.pop();
    $2f895839ac78ac6c$var$switchToZone(zone, false);
}
function $2f895839ac78ac6c$var$switchToZone(targetZone, bEnteringZone) {
    var currentZone = $2f895839ac78ac6c$var$PSD;
    if (bEnteringZone ? $2f895839ac78ac6c$var$task.echoes && (!$2f895839ac78ac6c$var$zoneEchoes++ || targetZone !== $2f895839ac78ac6c$var$PSD) : $2f895839ac78ac6c$var$zoneEchoes && (!--$2f895839ac78ac6c$var$zoneEchoes || targetZone !== $2f895839ac78ac6c$var$PSD)) $2f895839ac78ac6c$var$enqueueNativeMicroTask(bEnteringZone ? $2f895839ac78ac6c$var$zoneEnterEcho.bind(null, targetZone) : $2f895839ac78ac6c$var$zoneLeaveEcho);
    if (targetZone === $2f895839ac78ac6c$var$PSD) return;
    $2f895839ac78ac6c$var$PSD = targetZone;
    if (currentZone === $2f895839ac78ac6c$var$globalPSD) $2f895839ac78ac6c$var$globalPSD.env = $2f895839ac78ac6c$var$snapShot();
    if ($2f895839ac78ac6c$var$patchGlobalPromise) {
        var GlobalPromise_1 = $2f895839ac78ac6c$var$globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        $2f895839ac78ac6c$var$nativePromiseProto.then = targetEnv.nthen;
        GlobalPromise_1.prototype.then = targetEnv.gthen;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty($2f895839ac78ac6c$var$_global, "Promise", targetEnv.PromiseProp);
            GlobalPromise_1.all = targetEnv.all;
            GlobalPromise_1.race = targetEnv.race;
            GlobalPromise_1.resolve = targetEnv.resolve;
            GlobalPromise_1.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise_1.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise_1.any = targetEnv.any;
        }
    }
}
function $2f895839ac78ac6c$var$snapShot() {
    var GlobalPromise = $2f895839ac78ac6c$var$_global.Promise;
    return $2f895839ac78ac6c$var$patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor($2f895839ac78ac6c$var$_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject,
        nthen: $2f895839ac78ac6c$var$nativePromiseProto.then,
        gthen: GlobalPromise.prototype.then
    } : {};
}
function $2f895839ac78ac6c$var$usePSD(psd, fn, a1, a2, a3) {
    var outerScope = $2f895839ac78ac6c$var$PSD;
    try {
        $2f895839ac78ac6c$var$switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        $2f895839ac78ac6c$var$switchToZone(outerScope, false);
    }
}
function $2f895839ac78ac6c$var$enqueueNativeMicroTask(job) {
    $2f895839ac78ac6c$var$nativePromiseThen.call($2f895839ac78ac6c$var$resolvedNativePromise, job);
}
function $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== "function" ? fn : function() {
        var outerZone = $2f895839ac78ac6c$var$PSD;
        if (possibleAwait) $2f895839ac78ac6c$var$incrementExpectedAwaits();
        $2f895839ac78ac6c$var$switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            $2f895839ac78ac6c$var$switchToZone(outerZone, false);
            if (cleanup) $2f895839ac78ac6c$var$enqueueNativeMicroTask($2f895839ac78ac6c$var$decrementExpectedAwaits);
        }
    };
}
function $2f895839ac78ac6c$var$getPatchedPromiseThen(origThen, zone) {
    return function(onResolved, onRejected) {
        return origThen.call(this, $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onResolved, zone), $2f895839ac78ac6c$var$nativeAwaitCompatibleWrap(onRejected, zone));
    };
}
var $2f895839ac78ac6c$var$UNHANDLEDREJECTION = "unhandledrejection";
function $2f895839ac78ac6c$var$globalError(err, promise) {
    var rv;
    try {
        rv = promise.onuncatched(err);
    } catch (e) {}
    if (rv !== false) try {
        var event, eventData = {
            promise: promise,
            reason: err
        };
        if ($2f895839ac78ac6c$var$_global.document && document.createEvent) {
            event = document.createEvent("Event");
            event.initEvent($2f895839ac78ac6c$var$UNHANDLEDREJECTION, true, true);
            $2f895839ac78ac6c$var$extend(event, eventData);
        } else if ($2f895839ac78ac6c$var$_global.CustomEvent) {
            event = new CustomEvent($2f895839ac78ac6c$var$UNHANDLEDREJECTION, {
                detail: eventData
            });
            $2f895839ac78ac6c$var$extend(event, eventData);
        }
        if (event && $2f895839ac78ac6c$var$_global.dispatchEvent) {
            dispatchEvent(event);
            if (!$2f895839ac78ac6c$var$_global.PromiseRejectionEvent && $2f895839ac78ac6c$var$_global.onunhandledrejection) try {
                $2f895839ac78ac6c$var$_global.onunhandledrejection(event);
            } catch (_) {}
        }
        if ($2f895839ac78ac6c$var$debug && event && !event.defaultPrevented) console.warn("Unhandled rejection: " + (err.stack || err));
    } catch (e) {}
}
var $2f895839ac78ac6c$var$rejection = $2f895839ac78ac6c$var$DexiePromise.reject;
function $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !$2f895839ac78ac6c$var$PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._options.autoOpen) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed());
            db.open().catch($2f895839ac78ac6c$var$nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $2f895839ac78ac6c$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $2f895839ac78ac6c$var$tempTransaction(db, mode, storeNames, fn);
                });
            }
            return $2f895839ac78ac6c$var$rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return $2f895839ac78ac6c$var$newScope(function() {
                $2f895839ac78ac6c$var$PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            return trans._completion.then(function() {
                return result;
            });
        });
    }
}
var $2f895839ac78ac6c$var$DEXIE_VERSION = "3.2.7";
var $2f895839ac78ac6c$var$maxString = String.fromCharCode(65535);
var $2f895839ac78ac6c$var$minKey = -Infinity;
var $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var $2f895839ac78ac6c$var$STRING_EXPECTED = "String expected.";
var $2f895839ac78ac6c$var$connections = [];
var $2f895839ac78ac6c$var$isIEOrEdge = typeof navigator !== "undefined" && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var $2f895839ac78ac6c$var$hasIEDeleteObjectStoreBug = $2f895839ac78ac6c$var$isIEOrEdge;
var $2f895839ac78ac6c$var$hangsOnDeleteLargeKeyRange = $2f895839ac78ac6c$var$isIEOrEdge;
var $2f895839ac78ac6c$var$dexieStackFrameFilter = function(frame) {
    return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var $2f895839ac78ac6c$var$DBNAMES_DB = "__dbnames";
var $2f895839ac78ac6c$var$READONLY = "readonly";
var $2f895839ac78ac6c$var$READWRITE = "readwrite";
function $2f895839ac78ac6c$var$combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var $2f895839ac78ac6c$var$AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = $2f895839ac78ac6c$var$deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
var $2f895839ac78ac6c$var$Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || $2f895839ac78ac6c$var$PSD.trans;
        var tableName = this.name;
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new $2f895839ac78ac6c$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = $2f895839ac78ac6c$var$beginMicroTickScope();
        try {
            return trans && trans.db === this.db ? trans === $2f895839ac78ac6c$var$PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : $2f895839ac78ac6c$var$newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD
            }) : $2f895839ac78ac6c$var$tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
        } finally{
            if (wasRootExec) $2f895839ac78ac6c$var$endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        return this._trans("readonly", function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === "string") return new this.db.WhereClause(this, indexOrCrit);
        if ($2f895839ac78ac6c$var$isArray(indexOrCrit)) return new this.db.WhereClause(this, "[" + indexOrCrit.join("+") + "]");
        var keyPaths = $2f895839ac78ac6c$var$keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== $2f895839ac78ac6c$var$maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && $2f895839ac78ac6c$var$debug) console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join("+") + "]"));
        var idxByName = this.schema.idxByName;
        var idb = this.db._deps.indexedDB;
        function equals(a, b) {
            try {
                return idb.cmp(a, b) === 0;
            } catch (e) {
                return false;
            }
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? $2f895839ac78ac6c$var$combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = $2f895839ac78ac6c$var$getByKeyPath(x, keyPath);
                    return $2f895839ac78ac6c$var$isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, $2f895839ac78ac6c$var$getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, $2f895839ac78ac6c$var$isArray(index) ? "[" + index.join("+") + "]" : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        this.schema.mappedClass = constructor;
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if ($2f895839ac78ac6c$var$hasOwn(obj, m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            $2f895839ac78ac6c$var$extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === "object" && !$2f895839ac78ac6c$var$isArray(keyOrObject)) {
            var key = $2f895839ac78ac6c$var$getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Given object does not contain its primary key"));
            try {
                if (typeof modifications !== "function") $2f895839ac78ac6c$var$keys(modifications).forEach(function(keyPath) {
                    $2f895839ac78ac6c$var$setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
                });
                else modifications(keyOrObject, {
                    value: keyOrObject,
                    primKey: key
                });
            } catch (_a) {}
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = $2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "put",
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                $2f895839ac78ac6c$var$setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "deleteRange",
                range: $2f895839ac78ac6c$var$AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? $2f895839ac78ac6c$var$DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans("readonly", function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map($2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "add",
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans("readwrite", function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map($2f895839ac78ac6c$var$workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: "put",
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans("readwrite", function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: "delete",
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new $2f895839ac78ac6c$var$BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
        });
    };
    return Table;
}();
function $2f895839ac78ac6c$var$Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === "string") return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === "object") return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = $2f895839ac78ac6c$var$reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = $2f895839ac78ac6c$var$nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        $2f895839ac78ac6c$var$keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if ($2f895839ac78ac6c$var$isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === "asap") var context = add(eventName, $2f895839ac78ac6c$var$mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    $2f895839ac78ac6c$var$asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function $2f895839ac78ac6c$var$makeClassConstructor(prototype, constructor) {
    $2f895839ac78ac6c$var$derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function $2f895839ac78ac6c$var$createTableConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : $2f895839ac78ac6c$var$Events(null, {
            "creating": [
                $2f895839ac78ac6c$var$hookCreatingChain,
                $2f895839ac78ac6c$var$nop
            ],
            "reading": [
                $2f895839ac78ac6c$var$pureFunctionChain,
                $2f895839ac78ac6c$var$mirror
            ],
            "updating": [
                $2f895839ac78ac6c$var$hookUpdatingChain,
                $2f895839ac78ac6c$var$nop
            ],
            "deleting": [
                $2f895839ac78ac6c$var$hookDeletingChain,
                $2f895839ac78ac6c$var$nop
            ]
        });
    });
}
function $2f895839ac78ac6c$var$isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function $2f895839ac78ac6c$var$addFilter(ctx, fn) {
    ctx.filter = $2f895839ac78ac6c$var$combine(ctx.filter, fn);
}
function $2f895839ac78ac6c$var$addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return $2f895839ac78ac6c$var$combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function $2f895839ac78ac6c$var$addMatchFilter(ctx, fn) {
    ctx.isMatch = $2f895839ac78ac6c$var$combine(ctx.isMatch, fn);
}
function $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new $2f895839ac78ac6c$var$exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function $2f895839ac78ac6c$var$openCursor(ctx, coreTable, trans) {
    var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === "prev",
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function $2f895839ac78ac6c$var$iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? $2f895839ac78ac6c$var$combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return $2f895839ac78ac6c$var$iterate($2f895839ac78ac6c$var$openCursor(ctx, coreTable, coreTrans), $2f895839ac78ac6c$var$combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = "" + primaryKey;
                if (key === "[object ArrayBuffer]") key = "" + new Uint8Array(primaryKey);
                if (!$2f895839ac78ac6c$var$hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            $2f895839ac78ac6c$var$iterate($2f895839ac78ac6c$var$openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function $2f895839ac78ac6c$var$iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = $2f895839ac78ac6c$var$wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = $2f895839ac78ac6c$var$nop;
            }, function(e) {
                cursor.fail(e);
                c = $2f895839ac78ac6c$var$nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
function $2f895839ac78ac6c$var$cmp(a, b) {
    try {
        var ta = $2f895839ac78ac6c$var$type(a);
        var tb = $2f895839ac78ac6c$var$type(b);
        if (ta !== tb) {
            if (ta === "Array") return 1;
            if (tb === "Array") return -1;
            if (ta === "binary") return 1;
            if (tb === "binary") return -1;
            if (ta === "string") return 1;
            if (tb === "string") return -1;
            if (ta === "Date") return 1;
            if (tb !== "Date") return NaN;
            return -1;
        }
        switch(ta){
            case "number":
            case "Date":
            case "string":
                return a > b ? 1 : a < b ? -1 : 0;
            case "binary":
                return $2f895839ac78ac6c$var$compareUint8Arrays($2f895839ac78ac6c$var$getUint8Array(a), $2f895839ac78ac6c$var$getUint8Array(b));
            case "Array":
                return $2f895839ac78ac6c$var$compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function $2f895839ac78ac6c$var$compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = $2f895839ac78ac6c$var$cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $2f895839ac78ac6c$var$compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function $2f895839ac78ac6c$var$type(x) {
    var t = typeof x;
    if (t !== "object") return t;
    if (ArrayBuffer.isView(x)) return "binary";
    var tsTag = $2f895839ac78ac6c$var$toStringTag(x);
    return tsTag === "ArrayBuffer" ? "binary" : tsTag;
}
function $2f895839ac78ac6c$var$getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var $2f895839ac78ac6c$var$Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $2f895839ac78ac6c$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, $2f895839ac78ac6c$var$rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = $2f895839ac78ac6c$var$combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return $2f895839ac78ac6c$var$iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) $2f895839ac78ac6c$var$extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return $2f895839ac78ac6c$var$iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: $2f895839ac78ac6c$var$getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return $2f895839ac78ac6c$var$iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split(".").reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return aVal < bVal ? -order : aVal > bVal ? order : 0;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === "next" && $2f895839ac78ac6c$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return $2f895839ac78ac6c$var$iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx)) $2f895839ac78ac6c$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else $2f895839ac78ac6c$var$addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        $2f895839ac78ac6c$var$addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        $2f895839ac78ac6c$var$addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === "next" && $2f895839ac78ac6c$var$isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = $2f895839ac78ac6c$var$getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        $2f895839ac78ac6c$var$addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = $2f895839ac78ac6c$var$hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === "function") modifyer = changes;
            else {
                var keyPaths = $2f895839ac78ac6c$var$keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i], val = changes[keyPath];
                        if ($2f895839ac78ac6c$var$getByKeyPath(item, keyPath) !== val) {
                            $2f895839ac78ac6c$var$setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = _this.db._options.modifyChunkSize || 200;
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = $2f895839ac78ac6c$var$keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: $2f895839ac78ac6c$var$deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && $2f895839ac78ac6c$var$cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        var criteria = $2f895839ac78ac6c$var$isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || changes === $2f895839ac78ac6c$var$deleteCallback) && {
                            index: ctx.index,
                            range: ctx.range
                        };
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: "add",
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                                trans: trans,
                                type: "put",
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== "function" && changes
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === $2f895839ac78ac6c$var$deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: "delete",
                                keys: deleteKeys,
                                criteria: criteria
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new $2f895839ac78ac6c$var$ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if ($2f895839ac78ac6c$var$isPlainKeyRange(ctx) && (ctx.isPrimKey && !$2f895839ac78ac6c$var$hangsOnDeleteLargeKeyRange || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: "deleteRange",
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new $2f895839ac78ac6c$var$ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify($2f895839ac78ac6c$var$deleteCallback);
    };
    return Collection;
}();
var $2f895839ac78ac6c$var$deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function $2f895839ac78ac6c$var$createCollectionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = $2f895839ac78ac6c$var$AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== $2f895839ac78ac6c$var$mirror ? readingHook : null
        };
    });
}
function $2f895839ac78ac6c$var$simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function $2f895839ac78ac6c$var$simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function $2f895839ac78ac6c$var$fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof $2f895839ac78ac6c$var$WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function $2f895839ac78ac6c$var$emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return $2f895839ac78ac6c$var$rangeEqual("");
    }).limit(0);
}
function $2f895839ac78ac6c$var$upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function $2f895839ac78ac6c$var$lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function $2f895839ac78ac6c$var$nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === "string";
    })) return $2f895839ac78ac6c$var$fail(whereClause, $2f895839ac78ac6c$var$STRING_EXPECTED);
    function initDirection(dir) {
        upper = $2f895839ac78ac6c$var$upperFactory(dir);
        lower = $2f895839ac78ac6c$var$lowerFactory(dir);
        compare = dir === "next" ? $2f895839ac78ac6c$var$simpleCompare : $2f895839ac78ac6c$var$simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return $2f895839ac78ac6c$var$createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== "string") return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = $2f895839ac78ac6c$var$nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function $2f895839ac78ac6c$var$createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function $2f895839ac78ac6c$var$rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var $2f895839ac78ac6c$var$WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return $2f895839ac78ac6c$var$emptyCollection(this);
            return new this.Collection(this, function() {
                return $2f895839ac78ac6c$var$createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== "string") return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$STRING_EXPECTED);
        return this.between(str, str + $2f895839ac78ac6c$var$maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], $2f895839ac78ac6c$var$maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return $2f895839ac78ac6c$var$addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, $2f895839ac78ac6c$var$maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        var c = new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                $2f895839ac78ac6c$var$minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    $2f895839ac78ac6c$var$minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return $2f895839ac78ac6c$var$fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", $2f895839ac78ac6c$var$exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return $2f895839ac78ac6c$var$fail(this, $2f895839ac78ac6c$var$INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return $2f895839ac78ac6c$var$createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = $2f895839ac78ac6c$var$getArrayOf.apply($2f895839ac78ac6c$var$NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === "string";
        })) return $2f895839ac78ac6c$var$fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return $2f895839ac78ac6c$var$emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + $2f895839ac78ac6c$var$maxString
            ];
        }));
    };
    return WhereClause;
}();
function $2f895839ac78ac6c$var$createWhereClauseConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        var indexedDB1 = db._deps.indexedDB;
        if (!indexedDB1) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
        this._cmp = this._ascending = indexedDB1.cmp.bind(indexedDB1);
        this._descending = function(a, b) {
            return indexedDB1.cmp(b, a);
        };
        this._max = function(a, b) {
            return indexedDB1.cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return indexedDB1.cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
    });
}
function $2f895839ac78ac6c$var$eventRejectHandler(reject) {
    return $2f895839ac78ac6c$var$wrap(function(event) {
        $2f895839ac78ac6c$var$preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function $2f895839ac78ac6c$var$preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var $2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
var $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
var $2f895839ac78ac6c$var$globalEvents = $2f895839ac78ac6c$var$Events(null, $2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME);
var $2f895839ac78ac6c$var$Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        $2f895839ac78ac6c$var$assert(!$2f895839ac78ac6c$var$PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !$2f895839ac78ac6c$var$PSD.global) $2f895839ac78ac6c$var$PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        $2f895839ac78ac6c$var$assert(!$2f895839ac78ac6c$var$PSD.global);
        if (--this._reculock === 0) {
            if (!$2f895839ac78ac6c$var$PSD.global) $2f895839ac78ac6c$var$PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    $2f895839ac78ac6c$var$usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && $2f895839ac78ac6c$var$PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        $2f895839ac78ac6c$var$assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new $2f895839ac78ac6c$var$exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new $2f895839ac78ac6c$var$exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new $2f895839ac78ac6c$var$exceptions.TransactionInactive();
        $2f895839ac78ac6c$var$assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = $2f895839ac78ac6c$var$wrap(function(ev) {
            $2f895839ac78ac6c$var$preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = $2f895839ac78ac6c$var$wrap(function(ev) {
            $2f895839ac78ac6c$var$preventDefault(ev);
            _this.active && _this._reject(new $2f895839ac78ac6c$var$exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = $2f895839ac78ac6c$var$wrap(function() {
            _this.active = false;
            _this._resolve();
            if ("mutatedParts" in idbtrans) $2f895839ac78ac6c$var$globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === "readwrite" && this.mode !== "readwrite") return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.TransactionInactive());
        if (this._locked()) return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                $2f895839ac78ac6c$var$PSD
            ]);
        });
        else if (bWriteLock) return $2f895839ac78ac6c$var$newScope(function() {
            var p = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = $2f895839ac78ac6c$var$DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push($2f895839ac78ac6c$var$wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push($2f895839ac78ac6c$var$wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new $2f895839ac78ac6c$var$exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if ($2f895839ac78ac6c$var$hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new $2f895839ac78ac6c$var$exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function $2f895839ac78ac6c$var$createTransactionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = $2f895839ac78ac6c$var$Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return $2f895839ac78ac6c$var$rejection(e);
        });
    });
}
function $2f895839ac78ac6c$var$createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto ? "++" : "") + $2f895839ac78ac6c$var$nameFromKeyPath(keyPath)
    };
}
function $2f895839ac78ac6c$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
}
function $2f895839ac78ac6c$var$createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: $2f895839ac78ac6c$var$arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function $2f895839ac78ac6c$var$safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var $2f895839ac78ac6c$var$getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        $2f895839ac78ac6c$var$getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        $2f895839ac78ac6c$var$getMaxKey = function() {
            return $2f895839ac78ac6c$var$maxString;
        };
        return $2f895839ac78ac6c$var$maxString;
    }
};
function $2f895839ac78ac6c$var$getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === "string") return $2f895839ac78ac6c$var$getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath);
    };
}
function $2f895839ac78ac6c$var$getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split(".");
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return $2f895839ac78ac6c$var$getByKeyPath(obj, keyPath);
    };
}
function $2f895839ac78ac6c$var$arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var $2f895839ac78ac6c$var$_id_counter = 0;
function $2f895839ac78ac6c$var$getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[" + keyPath.join("+") + "]";
}
function $2f895839ac78ac6c$var$createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = $2f895839ac78ac6c$var$arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = $2f895839ac78ac6c$var$isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath)
                        },
                        indexes: $2f895839ac78ac6c$var$arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = $2f895839ac78ac6c$var$isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && "getAll" in trans.objectStore(tables[0]) && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = $2f895839ac78ac6c$var$wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== "delete" && type !== "deleteRange") throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    $2f895839ac78ac6c$var$preventDefault(event);
                };
                if (type === "deleteRange") {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = $2f895839ac78ac6c$var$wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !("openKeyCursor" in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++$2f895839ac78ac6c$var$_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = $2f895839ac78ac6c$var$wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = $2f895839ac78ac6c$var$wrap(resolveIteration);
                            req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !("openKeyCursor" in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = $2f895839ac78ac6c$var$wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = $2f895839ac78ac6c$var$wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '" + name + "' not found");
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: $2f895839ac78ac6c$var$getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function $2f895839ac78ac6c$var$createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, down), create(down));
    }, stackImpl);
}
function $2f895839ac78ac6c$var$createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = $2f895839ac78ac6c$var$createMiddlewareStack($2f895839ac78ac6c$var$createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function $2f895839ac78ac6c$var$generateMiddlewareStacks(_a, tmpTrans) {
    var db = _a._novip;
    var idbdb = tmpTrans.db;
    var stacks = $2f895839ac78ac6c$var$createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function $2f895839ac78ac6c$var$setApiOnPlace(_a, objs, tableNames, dbschema) {
    var db = _a._novip;
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = $2f895839ac78ac6c$var$getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) $2f895839ac78ac6c$var$setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        $2f895839ac78ac6c$var$defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function $2f895839ac78ac6c$var$removeTablesApi(_a, objs) {
    var db = _a._novip;
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function $2f895839ac78ac6c$var$lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function $2f895839ac78ac6c$var$runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD;
    $2f895839ac78ac6c$var$newScope(function() {
        $2f895839ac78ac6c$var$PSD.trans = trans;
        $2f895839ac78ac6c$var$PSD.transless = transless;
        if (oldVersion === 0) {
            $2f895839ac78ac6c$var$keys(globalSchema).forEach(function(tableName) {
                $2f895839ac78ac6c$var$createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            $2f895839ac78ac6c$var$generateMiddlewareStacks(db, idbUpgradeTrans);
            $2f895839ac78ac6c$var$DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else $2f895839ac78ac6c$var$updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
    });
}
function $2f895839ac78ac6c$var$updateTablesAndIndexes(_a, oldVersion, trans, idbUpgradeTrans) {
    var db = _a._novip;
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var anyContentUpgraderHasRun = false;
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = $2f895839ac78ac6c$var$getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                $2f895839ac78ac6c$var$createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new $2f895839ac78ac6c$var$exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return $2f895839ac78ac6c$var$addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        $2f895839ac78ac6c$var$addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                $2f895839ac78ac6c$var$generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                anyContentUpgraderHasRun = true;
                var upgradeSchema_1 = $2f895839ac78ac6c$var$shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                $2f895839ac78ac6c$var$removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                $2f895839ac78ac6c$var$setApiOnPlace(db, [
                    db.Transaction.prototype
                ], $2f895839ac78ac6c$var$keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = $2f895839ac78ac6c$var$isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) $2f895839ac78ac6c$var$incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = $2f895839ac78ac6c$var$DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = $2f895839ac78ac6c$var$decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === "function" ? $2f895839ac78ac6c$var$DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            if (!anyContentUpgraderHasRun || !$2f895839ac78ac6c$var$hasIEDeleteObjectStoreBug) {
                var newSchema = version._cfg.dbschema;
                $2f895839ac78ac6c$var$deleteRemovedTables(newSchema, idbtrans);
            }
            $2f895839ac78ac6c$var$removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            $2f895839ac78ac6c$var$setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
    });
    function runQueue() {
        return queue.length ? $2f895839ac78ac6c$var$DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : $2f895839ac78ac6c$var$DexiePromise.resolve();
    }
    return runQueue().then(function() {
        $2f895839ac78ac6c$var$createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function $2f895839ac78ac6c$var$getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto && !$2f895839ac78ac6c$var$isIEOrEdge) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function $2f895839ac78ac6c$var$createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return $2f895839ac78ac6c$var$addIndex(store, idx);
    });
    return store;
}
function $2f895839ac78ac6c$var$createMissingTables(newSchema, idbtrans) {
    $2f895839ac78ac6c$var$keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) $2f895839ac78ac6c$var$createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    });
}
function $2f895839ac78ac6c$var$deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function $2f895839ac78ac6c$var$addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function $2f895839ac78ac6c$var$buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = $2f895839ac78ac6c$var$createIndexSpec($2f895839ac78ac6c$var$nameFromKeyPath(keyPath), keyPath || "", false, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = $2f895839ac78ac6c$var$createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = $2f895839ac78ac6c$var$createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function $2f895839ac78ac6c$var$readGlobalSchema(_a, idbdb, tmpTrans) {
    var db = _a._novip;
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames, 0);
    $2f895839ac78ac6c$var$setApiOnPlace(db, [
        db._allTables
    ], $2f895839ac78ac6c$var$keys(globalSchema), globalSchema);
}
function $2f895839ac78ac6c$var$verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = $2f895839ac78ac6c$var$buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = $2f895839ac78ac6c$var$getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function $2f895839ac78ac6c$var$adjustToExistingIndexNames(_a, schema, idbtrans) {
    var db = _a._novip;
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = "getAll" in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === "string" ? keyPath : "[" + $2f895839ac78ac6c$var$slice(keyPath).join("+") + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $2f895839ac78ac6c$var$_global.WorkerGlobalScope && $2f895839ac78ac6c$var$_global instanceof $2f895839ac78ac6c$var$_global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function $2f895839ac78ac6c$var$parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(",").map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split("+") : name;
        return $2f895839ac78ac6c$var$createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), $2f895839ac78ac6c$var$isArray(keyPath), indexNum === 0);
    });
}
var $2f895839ac78ac6c$var$Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        $2f895839ac78ac6c$var$keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = $2f895839ac78ac6c$var$parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                if (primKey.multi) throw new $2f895839ac78ac6c$var$exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new $2f895839ac78ac6c$var$exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new $2f895839ac78ac6c$var$exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = $2f895839ac78ac6c$var$createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? $2f895839ac78ac6c$var$extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            $2f895839ac78ac6c$var$extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        $2f895839ac78ac6c$var$removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        $2f895839ac78ac6c$var$setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], $2f895839ac78ac6c$var$keys(dbschema), dbschema);
        db._storeNames = $2f895839ac78ac6c$var$keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = $2f895839ac78ac6c$var$promisableChain(this._cfg.contentUpgrade || $2f895839ac78ac6c$var$nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function $2f895839ac78ac6c$var$createVersionConstructor(db) {
    return $2f895839ac78ac6c$var$makeClassConstructor($2f895839ac78ac6c$var$Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new $2f895839ac78ac6c$export$4ece27d405df7279($2f895839ac78ac6c$var$DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function $2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function $2f895839ac78ac6c$var$getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return $2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== $2f895839ac78ac6c$var$DBNAMES_DB;
        });
    }) : $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function $2f895839ac78ac6c$var$_onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) && name !== $2f895839ac78ac6c$var$DBNAMES_DB && $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch($2f895839ac78ac6c$var$nop);
}
function $2f895839ac78ac6c$var$_onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !$2f895839ac78ac6c$var$hasDatabasesNative(indexedDB1) && name !== $2f895839ac78ac6c$var$DBNAMES_DB && $2f895839ac78ac6c$var$getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch($2f895839ac78ac6c$var$nop);
}
function $2f895839ac78ac6c$var$vip(fn) {
    return $2f895839ac78ac6c$var$newScope(function() {
        $2f895839ac78ac6c$var$PSD.letThrough = true;
        return fn();
    });
}
function $2f895839ac78ac6c$var$idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
function $2f895839ac78ac6c$var$dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? $2f895839ac78ac6c$var$rejection(state.dbOpenError) : db;
    });
    $2f895839ac78ac6c$var$debug && (state.openCanceller._stackHolder = $2f895839ac78ac6c$var$getErrorWithStack());
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new $2f895839ac78ac6c$var$exceptions.DatabaseClosed("db.open() was cancelled");
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema ? indexedDB1.open(dbName) : indexedDB1.open(dbName, Math.round(db.verno * 10));
            if (!req) throw new $2f895839ac78ac6c$var$exceptions.MissingAPI();
            req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
            req.onblocked = $2f895839ac78ac6c$var$wrap(db._fireOnBlocked);
            req.onupgradeneeded = $2f895839ac78ac6c$var$wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = $2f895839ac78ac6c$var$preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = $2f895839ac78ac6c$var$wrap(function() {
                        reject(new $2f895839ac78ac6c$var$exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
                    });
                } else {
                    upgradeTransaction.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db._novip.idbdb = req.result;
                    $2f895839ac78ac6c$var$runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = $2f895839ac78ac6c$var$wrap(function() {
                upgradeTransaction = null;
                var idbdb = db._novip.idbdb = req.result;
                var objectStoreNames = $2f895839ac78ac6c$var$slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction($2f895839ac78ac6c$var$safariMultiStoreFix(objectStoreNames), "readonly");
                    if (state.autoSchema) $2f895839ac78ac6c$var$readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        $2f895839ac78ac6c$var$adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!$2f895839ac78ac6c$var$verifyInstalledSchema(db, tmpTrans)) console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
                    }
                    $2f895839ac78ac6c$var$generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                $2f895839ac78ac6c$var$connections.push(db);
                idbdb.onversionchange = $2f895839ac78ac6c$var$wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = $2f895839ac78ac6c$var$wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) $2f895839ac78ac6c$var$_onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            if (err && err.name === "UnknownError" && state.PR1398_maxLoop > 0) {
                state.PR1398_maxLoop--;
                console.warn("Dexie: Workaround for Chrome UnknownError on open()");
                return tryOpenDB();
            } else return $2f895839ac78ac6c$var$DexiePromise.reject(err);
        });
    };
    return $2f895839ac78ac6c$var$DexiePromise.race([
        openCanceller,
        (typeof navigator === "undefined" ? $2f895839ac78ac6c$var$DexiePromise.resolve() : $2f895839ac78ac6c$var$idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return $2f895839ac78ac6c$var$DexiePromise.resolve($2f895839ac78ac6c$var$vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce($2f895839ac78ac6c$var$promisableChain, $2f895839ac78ac6c$var$nop);
                state.onReadyBeingFired = [];
                return $2f895839ac78ac6c$var$DexiePromise.resolve($2f895839ac78ac6c$var$vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        state.onReadyBeingFired = null;
        state.isBeingOpened = false;
    }).then(function() {
        return db;
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return $2f895839ac78ac6c$var$rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    });
}
function $2f895839ac78ac6c$var$awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== "function" ? $2f895839ac78ac6c$var$isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function $2f895839ac78ac6c$var$extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = $2f895839ac78ac6c$var$flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function $2f895839ac78ac6c$var$enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return $2f895839ac78ac6c$var$DexiePromise.resolve().then(function() {
        var transless = $2f895839ac78ac6c$var$PSD.transless || $2f895839ac78ac6c$var$PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === $2f895839ac78ac6c$var$errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn("Dexie: Need to reopen db");
                db._close();
                return db.open().then(function() {
                    return $2f895839ac78ac6c$var$enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return $2f895839ac78ac6c$var$rejection(ex);
        }
        var scopeFuncIsAsync = $2f895839ac78ac6c$var$isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) $2f895839ac78ac6c$var$incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = $2f895839ac78ac6c$var$DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = $2f895839ac78ac6c$var$decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === "function" && typeof returnValue.throw === "function") returnValue = $2f895839ac78ac6c$var$awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === "function" ? $2f895839ac78ac6c$var$DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return $2f895839ac78ac6c$var$rejection(e);
        });
    });
}
function $2f895839ac78ac6c$var$pad(a, value, count) {
    var result = $2f895839ac78ac6c$var$isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function $2f895839ac78ac6c$var$createVirtualIndexMiddleware(down) {
    return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = $2f895839ac78ac6c$var$getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, lowLevelIndex), {
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: $2f895839ac78ac6c$var$getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[$2f895839ac78ac6c$var$getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: $2f895839ac78ac6c$var$pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: $2f895839ac78ac6c$var$pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                    query: {
                        index: index,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                schema: $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue($2f895839ac78ac6c$var$pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey($2f895839ac78ac6c$var$pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var $2f895839ac78ac6c$var$virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: $2f895839ac78ac6c$var$createVirtualIndexMiddleware
};
function $2f895839ac78ac6c$var$getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || "";
    $2f895839ac78ac6c$var$keys(a).forEach(function(prop) {
        if (!$2f895839ac78ac6c$var$hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
                var apTypeName = $2f895839ac78ac6c$var$toStringTag(ap);
                var bpTypeName = $2f895839ac78ac6c$var$toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === "Object") $2f895839ac78ac6c$var$getObjectDiff(ap, bp, rv, prfx + prop + ".");
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    $2f895839ac78ac6c$var$keys(b).forEach(function(prop) {
        if (!$2f895839ac78ac6c$var$hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function $2f895839ac78ac6c$var$getEffectiveKeys(primaryKey, req) {
    if (req.type === "delete") return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var $2f895839ac78ac6c$var$hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = $2f895839ac78ac6c$var$PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case "add":
                                if (creating.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "put":
                                if (creating.fire === $2f895839ac78ac6c$var$nop && updating.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "delete":
                                if (deleting.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case "deleteRange":
                                if (deleting.fire === $2f895839ac78ac6c$var$nop) break;
                                return dxTrans._promise("readwrite", function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = $2f895839ac78ac6c$var$PSD.trans;
                            var keys = req.keys || $2f895839ac78ac6c$var$getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === "add" || req.type === "put" ? $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                                keys: keys
                            }) : $2f895839ac78ac6c$var$__assign({}, req);
                            if (req.type !== "delete") req.values = $2f895839ac78ac6c$var$__spreadArray([], req.values, true);
                            if (req.keys) req.keys = $2f895839ac78ac6c$var$__spreadArray([], req.keys, true);
                            return $2f895839ac78ac6c$var$getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === "delete") deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === "add" || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) $2f895839ac78ac6c$var$setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = $2f895839ac78ac6c$var$getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if ($2f895839ac78ac6c$var$hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else $2f895839ac78ac6c$var$setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === "put" && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: "delete",
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function $2f895839ac78ac6c$var$getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function $2f895839ac78ac6c$var$getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if ($2f895839ac78ac6c$var$cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? $2f895839ac78ac6c$var$deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var $2f895839ac78ac6c$var$cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = $2f895839ac78ac6c$var$getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return $2f895839ac78ac6c$var$DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? $2f895839ac78ac6c$var$deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
var $2f895839ac78ac6c$var$_a;
function $2f895839ac78ac6c$var$isEmptyRange(node) {
    return !("from" in node);
}
var $2f895839ac78ac6c$export$34cb5241245008dd = function(fromOrTree, to) {
    if (this) $2f895839ac78ac6c$var$extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new $2f895839ac78ac6c$export$34cb5241245008dd();
        if (fromOrTree && "d" in fromOrTree) $2f895839ac78ac6c$var$extend(rv, fromOrTree);
        return rv;
    }
};
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$export$34cb5241245008dd.prototype, ($2f895839ac78ac6c$var$_a = {
    add: function(rangeSet) {
        $2f895839ac78ac6c$export$4876cc3130d3f820(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        $2f895839ac78ac6c$var$addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return $2f895839ac78ac6c$var$addRange(_this, key, key);
        });
        return this;
    }
}, $2f895839ac78ac6c$var$_a[$2f895839ac78ac6c$var$iteratorSymbol] = function() {
    return $2f895839ac78ac6c$var$getRangeSetIterator(this);
}, $2f895839ac78ac6c$var$_a));
function $2f895839ac78ac6c$var$addRange(target, from, to) {
    var diff = $2f895839ac78ac6c$var$cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if ($2f895839ac78ac6c$var$isEmptyRange(target)) return $2f895839ac78ac6c$var$extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if ($2f895839ac78ac6c$var$cmp(to, target.from) < 0) {
        left ? $2f895839ac78ac6c$var$addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $2f895839ac78ac6c$var$rebalance(target);
    }
    if ($2f895839ac78ac6c$var$cmp(from, target.to) > 0) {
        right ? $2f895839ac78ac6c$var$addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return $2f895839ac78ac6c$var$rebalance(target);
    }
    if ($2f895839ac78ac6c$var$cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if ($2f895839ac78ac6c$var$cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) $2f895839ac78ac6c$export$4876cc3130d3f820(target, left);
    if (right && rightWasCutOff) $2f895839ac78ac6c$export$4876cc3130d3f820(target, right);
}
function $2f895839ac78ac6c$export$4876cc3130d3f820(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        $2f895839ac78ac6c$var$addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!$2f895839ac78ac6c$var$isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function $2f895839ac78ac6c$export$8f43b23b5d8de905(rangeSet1, rangeSet2) {
    var i1 = $2f895839ac78ac6c$var$getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = $2f895839ac78ac6c$var$getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if ($2f895839ac78ac6c$var$cmp(b.from, a.to) <= 0 && $2f895839ac78ac6c$var$cmp(b.to, a.from) >= 0) return true;
        $2f895839ac78ac6c$var$cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function $2f895839ac78ac6c$var$getRangeSetIterator(node) {
    var state = $2f895839ac78ac6c$var$isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && $2f895839ac78ac6c$var$cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || $2f895839ac78ac6c$var$cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function $2f895839ac78ac6c$var$rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = $2f895839ac78ac6c$var$__assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = $2f895839ac78ac6c$var$computeDepth(rootClone);
    }
    target.d = $2f895839ac78ac6c$var$computeDepth(target);
}
function $2f895839ac78ac6c$var$computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var $2f895839ac78ac6c$var$observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new $2f895839ac78ac6c$export$34cb5241245008dd(core.MIN_KEY, core.MAX_KEY);
        return $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, core), {
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var tableClone = $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, table), {
                    mutate: function(req) {
                        var trans = req.trans;
                        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                            return mutatedParts[part] || (mutatedParts[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _a = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            [],
                            req.values
                        ] : [], keys = _a[0], newObjs = _a[1];
                        var oldCache = req.trans["_cache"];
                        return table.mutate(req).then(function(res) {
                            if ($2f895839ac78ac6c$var$isArray(keys)) {
                                if (type !== "delete") keys = res.results;
                                pkRangeSet.addKeys(keys);
                                var oldObjs = $2f895839ac78ac6c$var$getFromTransactionCache(keys, oldCache);
                                if (!oldObjs && type !== "add") delsRangeSet.addKeys(keys);
                                if (oldObjs || newObjs) $2f895839ac78ac6c$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                            } else if (keys) {
                                var range = {
                                    from: keys.lower,
                                    to: keys.upper
                                };
                                delsRangeSet.add(range);
                                pkRangeSet.add(range);
                            } else {
                                pkRangeSet.add(FULL_RANGE);
                                delsRangeSet.add(FULL_RANGE);
                                schema.indexes.forEach(function(idx) {
                                    return getRangeSet(idx.name).add(FULL_RANGE);
                                });
                            }
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new $2f895839ac78ac6c$export$34cb5241245008dd((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new $2f895839ac78ac6c$export$34cb5241245008dd(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new $2f895839ac78ac6c$export$34cb5241245008dd().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                $2f895839ac78ac6c$var$keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = $2f895839ac78ac6c$var$PSD.subscr;
                        if (subscr) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
                                return subscr[part] || (subscr[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query($2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function $2f895839ac78ac6c$var$trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && $2f895839ac78ac6c$var$isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if ($2f895839ac78ac6c$var$cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
var $2f895839ac78ac6c$export$4ece27d405df7279 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = $2f895839ac78ac6c$var$__assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: $2f895839ac78ac6c$var$nop,
            dbReadyPromise: null,
            cancelOpen: $2f895839ac78ac6c$var$nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3
        };
        state.dbReadyPromise = new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $2f895839ac78ac6c$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = $2f895839ac78ac6c$var$Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                $2f895839ac78ac6c$var$promisableChain,
                $2f895839ac78ac6c$var$nop
            ]
        });
        this.on.ready.subscribe = $2f895839ac78ac6c$var$override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) $2f895839ac78ac6c$var$DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = $2f895839ac78ac6c$var$createCollectionConstructor(this);
        this.Table = $2f895839ac78ac6c$var$createTableConstructor(this);
        this.Transaction = $2f895839ac78ac6c$var$createTransactionConstructor(this);
        this.Version = $2f895839ac78ac6c$var$createVersionConstructor(this);
        this.WhereClause = $2f895839ac78ac6c$var$createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
            else console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
            _this.close();
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('" + _this.name + "') was blocked");
            else console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
        });
        this._maxKey = $2f895839ac78ac6c$var$getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            $2f895839ac78ac6c$var$connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use($2f895839ac78ac6c$var$virtualIndexMiddleware);
        this.use($2f895839ac78ac6c$var$hooksMiddleware);
        this.use($2f895839ac78ac6c$var$observabilityMiddleware);
        this.use($2f895839ac78ac6c$var$cacheExistingValuesMiddleware);
        this.vip = Object.create(this, {
            _vip: {
                value: true
            }
        });
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new $2f895839ac78ac6c$var$exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new $2f895839ac78ac6c$var$exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort($2f895839ac78ac6c$var$lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || $2f895839ac78ac6c$var$PSD.letThrough || this._vip) ? fn() : new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._options.autoOpen) {
                    reject(new $2f895839ac78ac6c$var$exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch($2f895839ac78ac6c$var$nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        return $2f895839ac78ac6c$var$dexieOpen(this);
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = $2f895839ac78ac6c$var$connections.indexOf(this);
        if (idx >= 0) $2f895839ac78ac6c$var$connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this._novip.idbdb = null;
        }
        state.dbReadyPromise = new $2f895839ac78ac6c$var$DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new $2f895839ac78ac6c$var$DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
    };
    Dexie.prototype.close = function() {
        this._close();
        var state = this._state;
        this._options.autoOpen = false;
        state.dbOpenError = new $2f895839ac78ac6c$var$exceptions.DatabaseClosed();
        if (state.isBeingOpened) state.cancelOpen(state.dbOpenError);
    };
    Dexie.prototype.delete = function() {
        var _this = this;
        var hasArguments = arguments.length > 0;
        var state = this._state;
        return new $2f895839ac78ac6c$var$DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close();
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = $2f895839ac78ac6c$var$wrap(function() {
                    $2f895839ac78ac6c$var$_onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = $2f895839ac78ac6c$var$eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasArguments) throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Arguments not allowed in db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === "DatabaseClosed";
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return $2f895839ac78ac6c$var$keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = $2f895839ac78ac6c$var$extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = $2f895839ac78ac6c$var$PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf("?") !== -1;
        mode = mode.replace("!", "").replace("?", "");
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== "string") throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === $2f895839ac78ac6c$var$READONLY) idbMode = $2f895839ac78ac6c$var$READONLY;
            else if (mode == "rw" || mode == $2f895839ac78ac6c$var$READWRITE) idbMode = $2f895839ac78ac6c$var$READWRITE;
            else throw new $2f895839ac78ac6c$var$exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === $2f895839ac78ac6c$var$READONLY && idbMode === $2f895839ac78ac6c$var$READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new $2f895839ac78ac6c$var$exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new $2f895839ac78ac6c$var$exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : $2f895839ac78ac6c$var$rejection(e);
        }
        var enterTransaction = $2f895839ac78ac6c$var$enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!$2f895839ac78ac6c$var$hasOwn(this._allTables, tableName)) throw new $2f895839ac78ac6c$var$exceptions.InvalidTable("Table " + tableName + " does not exist");
        return this._allTables[tableName];
    };
    return Dexie;
}();
var $2f895839ac78ac6c$var$symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var $2f895839ac78ac6c$var$Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[$2f895839ac78ac6c$var$symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
function $2f895839ac78ac6c$var$extendObservabilitySet(target, newSet) {
    $2f895839ac78ac6c$var$keys(newSet).forEach(function(part) {
        var rangeSet = target[part] || (target[part] = new $2f895839ac78ac6c$export$34cb5241245008dd());
        $2f895839ac78ac6c$export$4876cc3130d3f820(rangeSet, newSet[part]);
    });
    return target;
}
function $2f895839ac78ac6c$export$6a9705d8f6f38796(querier) {
    var hasValue = false;
    var currentValue = undefined;
    var observable = new $2f895839ac78ac6c$var$Observable(function(observer) {
        var scopeFuncIsAsync = $2f895839ac78ac6c$var$isAsyncFunction(querier);
        function execute(subscr) {
            if (scopeFuncIsAsync) $2f895839ac78ac6c$var$incrementExpectedAwaits();
            var exec = function() {
                return $2f895839ac78ac6c$var$newScope(querier, {
                    subscr: subscr,
                    trans: null
                });
            };
            var rv = $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, exec) : exec();
            if (scopeFuncIsAsync) rv.then($2f895839ac78ac6c$var$decrementExpectedAwaits, $2f895839ac78ac6c$var$decrementExpectedAwaits);
            return rv;
        }
        var closed = false;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                closed = true;
                $2f895839ac78ac6c$var$globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var querying = false, startedListening = false;
        function shouldNotify() {
            return $2f895839ac78ac6c$var$keys(currentObs).some(function(key) {
                return accumMuts[key] && $2f895839ac78ac6c$export$8f43b23b5d8de905(accumMuts[key], currentObs[key]);
            });
        }
        var mutationListener = function(parts) {
            $2f895839ac78ac6c$var$extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var doQuery = function() {
            if (querying || closed) return;
            accumMuts = {};
            var subscr = {};
            var ret = execute(subscr);
            if (!startedListening) {
                $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                startedListening = true;
            }
            querying = true;
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                querying = false;
                if (closed) return;
                if (shouldNotify()) doQuery();
                else {
                    accumMuts = {};
                    currentObs = subscr;
                    observer.next && observer.next(result);
                }
            }, function(err) {
                querying = false;
                hasValue = false;
                observer.error && observer.error(err);
                subscription.unsubscribe();
            });
        };
        doQuery();
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var $2f895839ac78ac6c$var$domDeps;
try {
    $2f895839ac78ac6c$var$domDeps = {
        indexedDB: $2f895839ac78ac6c$var$_global.indexedDB || $2f895839ac78ac6c$var$_global.mozIndexedDB || $2f895839ac78ac6c$var$_global.webkitIndexedDB || $2f895839ac78ac6c$var$_global.msIndexedDB,
        IDBKeyRange: $2f895839ac78ac6c$var$_global.IDBKeyRange || $2f895839ac78ac6c$var$_global.webkitIDBKeyRange
    };
} catch (e) {
    $2f895839ac78ac6c$var$domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
var $2f895839ac78ac6c$var$Dexie = $2f895839ac78ac6c$export$4ece27d405df7279;
$2f895839ac78ac6c$var$props($2f895839ac78ac6c$var$Dexie, $2f895839ac78ac6c$var$__assign($2f895839ac78ac6c$var$__assign({}, $2f895839ac78ac6c$var$fullNameExceptions), {
    delete: function(databaseName) {
        var db = new $2f895839ac78ac6c$var$Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new $2f895839ac78ac6c$var$Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch("NoSuchDatabaseError", function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return $2f895839ac78ac6c$var$getDatabaseNames($2f895839ac78ac6c$var$Dexie.dependencies).then(cb);
        } catch (_a) {
            return $2f895839ac78ac6c$var$rejection(new $2f895839ac78ac6c$var$exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            $2f895839ac78ac6c$var$extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$usePSD($2f895839ac78ac6c$var$PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: $2f895839ac78ac6c$var$vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = $2f895839ac78ac6c$var$awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== "function") return $2f895839ac78ac6c$var$DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return $2f895839ac78ac6c$var$rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = $2f895839ac78ac6c$var$awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== "function") return $2f895839ac78ac6c$var$DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return $2f895839ac78ac6c$var$rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return $2f895839ac78ac6c$var$PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = $2f895839ac78ac6c$var$DexiePromise.resolve(typeof promiseOrFunction === "function" ? $2f895839ac78ac6c$var$Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return $2f895839ac78ac6c$var$PSD.trans ? $2f895839ac78ac6c$var$PSD.trans.waitFor(promise) : promise;
    },
    Promise: $2f895839ac78ac6c$var$DexiePromise,
    debug: {
        get: function() {
            return $2f895839ac78ac6c$var$debug;
        },
        set: function(value) {
            $2f895839ac78ac6c$var$setDebug(value, value === "dexie" ? function() {
                return true;
            } : $2f895839ac78ac6c$var$dexieStackFrameFilter);
        }
    },
    derive: $2f895839ac78ac6c$var$derive,
    extend: $2f895839ac78ac6c$var$extend,
    props: $2f895839ac78ac6c$var$props,
    override: $2f895839ac78ac6c$var$override,
    Events: $2f895839ac78ac6c$var$Events,
    on: $2f895839ac78ac6c$var$globalEvents,
    liveQuery: $2f895839ac78ac6c$export$6a9705d8f6f38796,
    extendObservabilitySet: $2f895839ac78ac6c$var$extendObservabilitySet,
    getByKeyPath: $2f895839ac78ac6c$var$getByKeyPath,
    setByKeyPath: $2f895839ac78ac6c$var$setByKeyPath,
    delByKeyPath: $2f895839ac78ac6c$var$delByKeyPath,
    shallowClone: $2f895839ac78ac6c$var$shallowClone,
    deepClone: $2f895839ac78ac6c$var$deepClone,
    getObjectDiff: $2f895839ac78ac6c$var$getObjectDiff,
    cmp: $2f895839ac78ac6c$var$cmp,
    asap: $2f895839ac78ac6c$var$asap$1,
    minKey: $2f895839ac78ac6c$var$minKey,
    addons: [],
    connections: $2f895839ac78ac6c$var$connections,
    errnames: $2f895839ac78ac6c$var$errnames,
    dependencies: $2f895839ac78ac6c$var$domDeps,
    semVer: $2f895839ac78ac6c$var$DEXIE_VERSION,
    version: $2f895839ac78ac6c$var$DEXIE_VERSION.split(".").map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
$2f895839ac78ac6c$var$Dexie.maxKey = $2f895839ac78ac6c$var$getMaxKey($2f895839ac78ac6c$var$Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!$2f895839ac78ac6c$var$propagatingLocally) {
            var event_1;
            if ($2f895839ac78ac6c$var$isIEOrEdge) {
                event_1 = document.createEvent("CustomEvent");
                event_1.initCustomEvent($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
            } else event_1 = new CustomEvent($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            $2f895839ac78ac6c$var$propagatingLocally = true;
            dispatchEvent(event_1);
            $2f895839ac78ac6c$var$propagatingLocally = false;
        }
    });
    addEventListener($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!$2f895839ac78ac6c$var$propagatingLocally) $2f895839ac78ac6c$var$propagateLocally(detail);
    });
}
function $2f895839ac78ac6c$var$propagateLocally(updateParts) {
    var wasMe = $2f895839ac78ac6c$var$propagatingLocally;
    try {
        $2f895839ac78ac6c$var$propagatingLocally = true;
        $2f895839ac78ac6c$var$globalEvents.storagemutated.fire(updateParts);
    } finally{
        $2f895839ac78ac6c$var$propagatingLocally = wasMe;
    }
}
var $2f895839ac78ac6c$var$propagatingLocally = false;
if (typeof BroadcastChannel !== "undefined") {
    var $2f895839ac78ac6c$var$bc_1 = new BroadcastChannel($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME);
    if (typeof $2f895839ac78ac6c$var$bc_1.unref === "function") $2f895839ac78ac6c$var$bc_1.unref();
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!$2f895839ac78ac6c$var$propagatingLocally) $2f895839ac78ac6c$var$bc_1.postMessage(changedParts);
    });
    $2f895839ac78ac6c$var$bc_1.onmessage = function(ev) {
        if (ev.data) $2f895839ac78ac6c$var$propagateLocally(ev.data);
    };
} else if (typeof self !== "undefined" && typeof navigator !== "undefined") {
    $2f895839ac78ac6c$var$globalEvents($2f895839ac78ac6c$var$DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        try {
            if (!$2f895839ac78ac6c$var$propagatingLocally) {
                if (typeof localStorage !== "undefined") localStorage.setItem($2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
                    trig: Math.random(),
                    changedParts: changedParts
                }));
                if (typeof self["clients"] === "object") $2f895839ac78ac6c$var$__spreadArray([], self["clients"].matchAll({
                    includeUncontrolled: true
                }), true).forEach(function(client) {
                    return client.postMessage({
                        type: $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME,
                        changedParts: changedParts
                    });
                });
            }
        } catch (_a) {}
    });
    if (typeof addEventListener !== "undefined") addEventListener("storage", function(ev) {
        if (ev.key === $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME) {
            var data = JSON.parse(ev.newValue);
            if (data) $2f895839ac78ac6c$var$propagateLocally(data.changedParts);
        }
    });
    var $2f895839ac78ac6c$var$swContainer = self.document && navigator.serviceWorker;
    if ($2f895839ac78ac6c$var$swContainer) $2f895839ac78ac6c$var$swContainer.addEventListener("message", $2f895839ac78ac6c$var$propagateMessageLocally);
}
function $2f895839ac78ac6c$var$propagateMessageLocally(_a) {
    var data = _a.data;
    if (data && data.type === $2f895839ac78ac6c$var$STORAGE_MUTATED_DOM_EVENT_NAME) $2f895839ac78ac6c$var$propagateLocally(data.changedParts);
}
$2f895839ac78ac6c$var$DexiePromise.rejectionMapper = $2f895839ac78ac6c$var$mapError;
$2f895839ac78ac6c$var$setDebug($2f895839ac78ac6c$var$debug, $2f895839ac78ac6c$var$dexieStackFrameFilter);


class $46c4fb4ea4a276f7$export$bead30365be78d90 extends (0, $2f895839ac78ac6c$export$4ece27d405df7279) {
    constructor(dbName){
        super(dbName);
        this._initialized = false;
        this.version(1).stores({
            resource: "id, name",
            resourceData: "[resourceId+startOffset], resourceId"
        });
        this.resource = this.table("resource");
        this.resourceData = this.table("resourceData");
    }
    initialize() {
        return this.open().then((_db)=>{
            this._initialized = true;
        }).catch((_)=>{
            this._initialized = false;
        });
    }
    onResourceDeleted(callback) {
        this._resourceDeletedEventCallback = callback;
    }
    onResourceAdded(callback) {
        this._resourceAddedEventCallback = callback;
    }
    getResource(id) {
        if (this._initialized) return this.resource.where("id").equals(id).first((res)=>{
            return res;
        });
        else {
            console.warn("No database connection");
            return Promise.resolve(undefined);
        }
    }
    getResourceByName(name) {
        if (this._initialized) return this.resource.where("name").equals(name).first((res)=>{
            return res;
        });
        else {
            console.warn("No database connection");
            return Promise.resolve(undefined);
        }
    }
    hasResource(id) {
        if (this._initialized) return this.resource.where("id").equals(id).count((num)=>{
            return num >= 1;
        });
        else {
            console.warn("No database connection");
            return Promise.resolve(false);
        }
    }
    hasResourceByName(name) {
        if (this._initialized) return this.resource.where("name").equals(name).count((num)=>{
            return num >= 1;
        });
        else {
            console.warn("No database connection");
            return Promise.resolve(false);
        }
    }
    addResource(resource) {
        if (this._initialized) return this.hasResource(resource.id).then((hasResource)=>{
            if (!hasResource) return this.resource.add(resource, resource.url).then((res)=>{
                console.log("addResource", res);
                if (this._resourceAddedEventCallback) this._resourceAddedEventCallback(resource.id);
                return res;
            });
            else {
                console.log("resource exists", resource);
                return;
            }
        });
        else {
            console.warn("No database connection");
            return Promise.resolve();
        }
    }
    deleteResource(id) {
        if (this._initialized) return this.getResource(id).then((resource)=>{
            if (resource) return this.deleteResourceData("publicationId").then(()=>{
                return this.resource.where("id").equals(resource.url).delete().then((_res)=>{
                    if (this._resourceDeletedEventCallback) this._resourceDeletedEventCallback(id);
                    return Promise.resolve();
                });
            });
            else {
                console.warn(`IVanillaReaderStreamedResourceStorage.deleteResource(): could not find resource with id "${id}".`);
                return;
            }
        });
        else {
            console.warn(`IVanillaReaderStreamedResourceStorage.deleteResource(): No database connection.`);
            return Promise.resolve();
        }
    }
    deleteResourceByName(name) {
        if (this._initialized) return this.getResourceByName(name).then((resource)=>{
            if (resource) return this.deleteResourceData(resource.url).then(()=>{
                return this.resource.where("name").equals(name).delete().then((_res)=>{
                    if (this._resourceDeletedEventCallback) this._resourceDeletedEventCallback(name);
                    return Promise.resolve();
                });
            });
            else return;
        });
        else {
            console.warn(`IVanillaReaderStreamedResourceStorage.deleteResourceByName(): No database connection.`);
            return Promise.resolve();
        }
    }
    addResourceData(id, startOffset, endOffset, data) {
        if (this._initialized) {
            const resourceData = {
                resourceId: id,
                startOffset: startOffset,
                endOffset: endOffset,
                data: data
            };
            return this.resourceData.add(resourceData, id).catch((err)=>{
                console.log("Exception in ResourceStorage.addResourceData: ", err);
                throw err;
            }).then(()=>{});
        } else {
            console.error("Exception in ResourceStorage.addResourceData: No database connection");
            return Promise.reject();
        }
    }
    getResourceDataByStartOffset(id, startOffset) {
        if (this._initialized) return this.resourceData.where("[resourceId+startOffset]").equals([
            id,
            startOffset
        ]).first((dataChunk)=>{
            return dataChunk;
        });
        else return Promise.resolve(undefined);
    }
    hasResourceDataByStartOffset(id, startOffset) {
        if (this._initialized) return this.resourceData.where("[resourceId+startOffset]").equals([
            id,
            startOffset
        ]).count().then((num)=>{
            return num >= 1;
        }).catch((err)=>{
            console.error('Exception in ResourceStorage.hasResourceDataByStartOffset("' + id + '", "' + startOffset + '")', err);
            throw err;
        });
        else {
            console.error('Exception in ResourceStorage.hasResourceDataByStartOffset("' + id + '", "' + startOffset + '"): No database connection');
            return Promise.reject();
        }
    }
    deleteResourceData(id) {
        if (this._initialized) return this.resourceData.where("resourceId").equals(id).delete().catch((err)=>{
            console.error('Exception in ResourceStorage.deleteResourceData("' + id + '")', err);
            throw err;
        });
        else {
            console.error('Exception in ResourceStorage.deleteResourceData("' + id + '"): No database connection');
            return Promise.reject();
        }
    }
}



/*
* # IVanillaReaderHighlight
*
* This interface defines the data that is used to describe a highlight annotation in the VanillaReader. This data is used
* by for example the highlight annotation layer and the UI.
*
**/ var $a9ae8c6e4118a691$export$879ba39c30b12f45;
(function(VanillaReaderStoreRendererNames) {
    VanillaReaderStoreRendererNames["RESPONSIVE"] = "__responsive__";
    VanillaReaderStoreRendererNames["FLIPBOOK"] = "FlipBookRenderer";
    VanillaReaderStoreRendererNames["STACK"] = "StackRenderer";
    VanillaReaderStoreRendererNames["SCROLL"] = "SingleDocumentScrollRenderer";
    VanillaReaderStoreRendererNames["SWIPE_SINGLE"] = "SinglePageSwipeRenderer";
    VanillaReaderStoreRendererNames["SWIPE_SPREAD"] = "SpreadSwipeRenderer";
})($a9ae8c6e4118a691$export$879ba39c30b12f45 || ($a9ae8c6e4118a691$export$879ba39c30b12f45 = {}));
var $a9ae8c6e4118a691$export$13500b787143c912;
(function(VanillaReaderStoreUiActionNames) {
    VanillaReaderStoreUiActionNames["ACTIONS_MENU_OPEN"] = "uiaction_actions_menu_open";
    VanillaReaderStoreUiActionNames["MAIN_MENU_OPEN"] = "uiaction_main_menu_open";
    VanillaReaderStoreUiActionNames["WHERE_AM_I"] = "uiaction_where_am_i";
    VanillaReaderStoreUiActionNames["TOC_OPEN_DIALOG"] = "uiaction_toc_open";
    VanillaReaderStoreUiActionNames["NAVIGATE_NEXT"] = "uiaction_navigate_next";
    VanillaReaderStoreUiActionNames["NAVIGATE_PREVIOUS"] = "uiaction_navigate_previous";
    VanillaReaderStoreUiActionNames["NAVIGATE_NEXT_HEADING"] = "uiaction_navigate_next_heading";
    VanillaReaderStoreUiActionNames["NAVIGATE_PREVIOUS_HEADING"] = "uiaction_navigate_previous_heading";
    VanillaReaderStoreUiActionNames["HIGHLIGHT_OPEN_DIALOG_ALL"] = "uiaction_highlight_open_dialog_all";
    VanillaReaderStoreUiActionNames["HIGHLIGHT_OPEN_DIALOG_ACTIVE"] = "uiaction_highlight_open_dialog_active";
    VanillaReaderStoreUiActionNames["HIGHLIGHT_SELECTION"] = "uiaction_highlight_selection";
    VanillaReaderStoreUiActionNames["HIGHLIGHT_CLIPBOARD"] = "uiaction_highlight_clipboard";
    VanillaReaderStoreUiActionNames["HIGHLIGHT_READING_POSITION"] = "uiaction_highlight_reading_position";
    VanillaReaderStoreUiActionNames["HIGHLIGHT_ACTIVE_CONTENT"] = "uiaction_highlight_active_content";
    VanillaReaderStoreUiActionNames["BOOKMARK_SELECTION"] = "uiaction_bookmark_selection";
    VanillaReaderStoreUiActionNames["BOOKMARK_CLIPBOARD"] = "uiaction_bookmark_clipboard";
    VanillaReaderStoreUiActionNames["BOOKMARK_READING_POSITION"] = "uiaction_bookmark_reading_position";
    VanillaReaderStoreUiActionNames["BOOKMARK_OPEN_DIALOG_ALL"] = "uiaction_bookmark_open_dialog_all";
    VanillaReaderStoreUiActionNames["BOOKMARK_OPEN_DIALOG_ACTIVE"] = "uiaction_bookmark_open_dialog_active";
    VanillaReaderStoreUiActionNames["SEARCH_DIALOG_OPEN"] = "uiaction_search_open_dialog_active";
    VanillaReaderStoreUiActionNames["SEARCH_CLEAR"] = "uiaction_search_clear";
    VanillaReaderStoreUiActionNames["MEDIA_PLAYBACK_START"] = "uiaction_media_playback_start";
    VanillaReaderStoreUiActionNames["MEDIA_PLAYBACK_STOP"] = "uiaction_media_playback_stop";
    VanillaReaderStoreUiActionNames["MEDIA_PLAYBACK_SKIP_FORWARD"] = "uiaction_media_playback_skip_forward";
    VanillaReaderStoreUiActionNames["MEDIA_PLAYBACK_SKIP_BACKWARD"] = "uiaction_media_playback_skip_backward";
    VanillaReaderStoreUiActionNames["MEDIA_PLAYBACK_ESCAPE_SEGMENT"] = "uiaction_media_playback_escape_segment";
    VanillaReaderStoreUiActionNames["MEDIA_PLAYBACK_ESCAPE_ALL"] = "uiaction_media_playback_escape_all";
    VanillaReaderStoreUiActionNames["HELP_DIALOG_OPEN"] = "uiaction_help_dialog_open";
    VanillaReaderStoreUiActionNames["ACCESSIBILITY_MODE_ENTER"] = "uiaction_accessibility_mode_enter";
    VanillaReaderStoreUiActionNames["ACCESSIBILITY_MODE_EXIT"] = "uiaction_accessibility_mode_exit";
    VanillaReaderStoreUiActionNames["SETTINGS_DIALOG_OPEN"] = "uiaction_settings_dialog_open";
    VanillaReaderStoreUiActionNames["SETTINGS_RESET"] = "uiaction_settings_reset";
    VanillaReaderStoreUiActionNames["BOOKSHELF_DIALOG_OPEN"] = "uiaction_bookshelf_dialog_open";
    VanillaReaderStoreUiActionNames["CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION"] = "uiaction_close_dialogs_and_focus_on_reading_position";
    VanillaReaderStoreUiActionNames["GOTO_PAGE_DIALOG_OPEN"] = "uiaction_goto_page_dialog_open";
    VanillaReaderStoreUiActionNames["ZOOM_TOOL_ACTIVATE"] = "uiaction_zoom_mode_enter";
    VanillaReaderStoreUiActionNames["ZOOM_TOOL_DEACTIVATE"] = "uiaction_zoom_mode_exit";
    VanillaReaderStoreUiActionNames["ZOOM_OUT"] = "uiaction_zoom_out";
    VanillaReaderStoreUiActionNames["ZOOM_IN"] = "uiaction_zoom_in";
    VanillaReaderStoreUiActionNames["ZOOM_RESET"] = "uiaction_zoom_reset";
    VanillaReaderStoreUiActionNames["READING_RULER_ACTIVATE"] = "uiaction_ruler_activate";
    VanillaReaderStoreUiActionNames["READING_RULER_DEACTIVATE"] = "uiaction_ruler_deactivate";
    VanillaReaderStoreUiActionNames["READING_RULER_MOVE_NEXT"] = "uiaction_ruler_move_next";
    VanillaReaderStoreUiActionNames["READING_RULER_MOVE_PREVIOUS"] = "uiaction_ruler_move_previous";
    VanillaReaderStoreUiActionNames["LANDMARKS_DIALOG_OPEN"] = "uiaction_landmarks_dialog_open";
    VanillaReaderStoreUiActionNames["NAVIGATION_HISTORY_DIALOG_OPEN"] = "uiaction_navigation_history_dialog_open";
})($a9ae8c6e4118a691$export$13500b787143c912 || ($a9ae8c6e4118a691$export$13500b787143c912 = {}));
var $a9ae8c6e4118a691$export$f5770dcafd219e44;
(function(StoreCssMixBlendModeValues) {
    StoreCssMixBlendModeValues["INHERIT"] = "inherit";
    StoreCssMixBlendModeValues["INITIAL"] = "initial";
    StoreCssMixBlendModeValues["REVERT"] = "revert";
    StoreCssMixBlendModeValues["REVERT_LAYER"] = "revert-layer";
    StoreCssMixBlendModeValues["UNSET"] = "unset";
    StoreCssMixBlendModeValues["NORMAL"] = "normal";
    StoreCssMixBlendModeValues["MULTIPLY"] = "multiply";
    StoreCssMixBlendModeValues["SCREEN"] = "screen";
    StoreCssMixBlendModeValues["OVERLAY"] = "overlay";
    StoreCssMixBlendModeValues["DARKEN"] = "darken";
    StoreCssMixBlendModeValues["LIGHTEN"] = "lighten";
    StoreCssMixBlendModeValues["COLOR_DODGE"] = "color-dodge";
    StoreCssMixBlendModeValues["COLOR_BURN"] = "color-burn";
    StoreCssMixBlendModeValues["HARD_LIGHT"] = "hard-light";
    StoreCssMixBlendModeValues["SOFT_LIGHT"] = "soft-light";
    StoreCssMixBlendModeValues["DIFFERENCE"] = "difference";
    StoreCssMixBlendModeValues["EXCLUSION"] = "exclusion";
    StoreCssMixBlendModeValues["HUE"] = "hue";
    StoreCssMixBlendModeValues["SATURATION"] = "saturation";
    StoreCssMixBlendModeValues["COLOR"] = "color";
    StoreCssMixBlendModeValues["LUMINOSITY"] = "luminosity";
})($a9ae8c6e4118a691$export$f5770dcafd219e44 || ($a9ae8c6e4118a691$export$f5770dcafd219e44 = {}));
var $a9ae8c6e4118a691$export$f3c46465ddda9081;
(function(VanillaReaderLocalStorageKeys) {
    VanillaReaderLocalStorageKeys["VanillaReaderUiActiveOptionsPreset"] = "VanillaReaderUiActiveOptionsPreset";
    VanillaReaderLocalStorageKeys["VanillaReaderUserProfileData"] = "VanillaReaderUserProfileData";
    VanillaReaderLocalStorageKeys["VanillaReaderAppDataMigrationDateStamp"] = "VanillaReaderAppDataMigrationDateStamp";
    VanillaReaderLocalStorageKeys["VanillaReaderActiveColorPalette"] = "VanillaReaderActiveColorPalette";
    VanillaReaderLocalStorageKeys["VanillaReaderViewInitialOptions"] = "VanillaReaderViewInitialOptions";
})($a9ae8c6e4118a691$export$f3c46465ddda9081 || ($a9ae8c6e4118a691$export$f3c46465ddda9081 = {}));





class $f872f385ffa51a29$export$dd19591a313b6cdc {
    static toApplicationPublicationCacheData(storeData) {
        return {
            _id: storeData._id,
            publicationId: storeData.publicationId,
            landmarkData: storeData.landmarkData,
            storageState: storeData.storageState,
            searchIndexData: storeData.searchIndexData,
            navigationTreeData: storeData.navigationTreeData,
            timelineData: storeData.timelineData
        };
    }
    static maybeToApplicationPublicationCacheData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationPublicationCacheData(storeData) : undefined;
    }
    static toStorePublicationCacheData(appData) {
        return {
            _id: appData._id,
            publicationId: appData.publicationId,
            landmarkData: appData.landmarkData,
            storageState: appData.storageState,
            searchIndexData: appData.searchIndexData,
            navigationTreeData: appData.navigationTreeData,
            timelineData: appData.timelineData
        };
    }
    static toApplicationPublicationLandmarkData(storeData) {
        return {
            _id: storeData._id,
            publicationId: storeData.publicationId,
            documents: storeData.documents
        };
    }
    static maybeToApplicationPublicationLandmarkData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationPublicationLandmarkData(storeData) : undefined;
    }
    static toStorePublicationLandmarkData(appData) {
        return {
            _id: appData._id,
            publicationId: appData.publicationId,
            documents: appData.documents
        };
    }
    static toApplicationDocumentLandmarkData(storeData) {
        return {
            documentIndex: storeData.documentIndex,
            headings: storeData.headings,
            tables: storeData.tables,
            figures: storeData.figures,
            audio: storeData.audio,
            video: storeData.video,
            lists: storeData.lists,
            sections: storeData.sections,
            articles: storeData.articles,
            asides: storeData.asides,
            footnotes: storeData.footnotes
        };
    }
    static maybeToApplicationDocumentLandmarkData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationDocumentLandmarkData(storeData) : undefined;
    }
    static toStoreDocumentLandmarkData(appData) {
        return {
            documentIndex: appData.documentIndex,
            headings: appData.headings,
            tables: appData.tables,
            figures: appData.figures,
            audio: appData.audio,
            video: appData.video,
            lists: appData.lists,
            sections: appData.sections,
            articles: appData.articles,
            asides: appData.asides,
            footnotes: appData.footnotes
        };
    }
    static toApplicationLandmarkData(storeData) {
        return {
            parentId: storeData.parentId,
            timelinePosition: storeData.timelinePosition,
            subType: storeData.subType,
            description: storeData.description,
            locatorUrl: storeData.locatorUrl,
            attributes: storeData.attributes,
            blockClass: storeData.blockClass,
            blockType: storeData.blockType,
            children: storeData.children,
            id: storeData.id,
            locator: storeData.locator,
            marks: storeData.marks,
            resourceHrefs: storeData.resourceHrefs,
            textContent: storeData.textContent
        };
    }
    static maybeToApplicationLandmarkData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationLandmarkData(storeData) : undefined;
    }
    static toStoreLandmarkData(appData) {
        return {
            parentId: appData.parentId,
            timelinePosition: appData.timelinePosition,
            subType: appData.subType,
            description: appData.description,
            locatorUrl: appData.locatorUrl,
            attributes: appData.attributes,
            blockClass: appData.blockClass,
            blockType: appData.blockType,
            children: appData.children,
            id: appData.id,
            locator: appData.locator,
            marks: appData.marks,
            resourceHrefs: appData.resourceHrefs,
            textContent: appData.textContent
        };
    }
    static toApplicationIPublicationSearchIndexData(storeData) {
        return {
            hashSignature: storeData.hashSignature,
            metadata: storeData.metadata,
            documents: storeData.documents,
            publicationIndexedTextLength: storeData.publicationIndexedTextLength
        };
    }
    static maybeToApplicationIPublicationSearchIndexData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationIPublicationSearchIndexData(storeData) : undefined;
    }
    static toStoreIPublicationSearchIndexData(appData) {
        return {
            hashSignature: appData.hashSignature,
            metadata: appData.metadata,
            documents: appData.documents,
            publicationIndexedTextLength: appData.publicationIndexedTextLength
        };
    }
    static toApplicationIPublicationSearchIndexDocumentData(storeData) {
        return {
            tocTitle: storeData.tocTitle,
            locator: storeData.locator,
            contentNodes: storeData.contentNodes,
            indexedText: storeData.indexedText,
            charOffsetInPublicationIndexedText: storeData.charOffsetInPublicationIndexedText,
            indexInPublicationSpine: storeData.indexInPublicationSpine
        };
    }
    static maybeToApplicationIPublicationSearchIndexDocumentData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationIPublicationSearchIndexDocumentData(storeData) : undefined;
    }
    static toStoreIPublicationSearchIndexDocumentData(appData) {
        return {
            tocTitle: appData.tocTitle,
            locator: appData.locator,
            contentNodes: appData.contentNodes,
            indexedText: appData.indexedText,
            charOffsetInPublicationIndexedText: appData.charOffsetInPublicationIndexedText,
            indexInPublicationSpine: appData.indexInPublicationSpine
        };
    }
    static toApplicationIPublicationSearchIndexContentNodeData(storeData) {
        return {
            tocTitle: storeData.tocTitle,
            id: storeData.id,
            locator: storeData.locator,
            charRangeInIndexedDocumentText: storeData.charRangeInIndexedDocumentText,
            type: storeData.type,
            attributes: storeData.attributes,
            documentIndex: storeData.documentIndex
        };
    }
    static maybeToApplicationIPublicationSearchIndexContentNodeData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationIPublicationSearchIndexContentNodeData(storeData) : undefined;
    }
    static toStoreIPublicationSearchIndexContentNodeData(appData) {
        return {
            tocTitle: appData.tocTitle,
            id: appData.id,
            locator: appData.locator,
            charRangeInIndexedDocumentText: appData.charRangeInIndexedDocumentText,
            type: appData.type,
            attributes: appData.attributes,
            documentIndex: appData.documentIndex
        };
    }
    static toApplicationNavigationTreeData(storeData) {
        return {
            collections: storeData.collections,
            items: storeData.items
        };
    }
    static maybeToApplicationNavigationTreeData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationNavigationTreeData(storeData) : undefined;
    }
    static toStoreNavigationTreeData(appData) {
        return {
            collections: appData.collections,
            items: appData.items
        };
    }
    static toApplicationNavigationCollection(storeData) {
        return {
            type: storeData.type,
            children: storeData.children
        };
    }
    static maybeToApplicationNavigationCollection(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationNavigationCollection(storeData) : undefined;
    }
    static toStoreNavigationCollection(appData) {
        return {
            type: appData.type,
            children: appData.children
        };
    }
    static toApplicationNavigationItem(storeData) {
        return {
            title: storeData.title,
            collectionType: storeData.collectionType,
            locator: storeData.locator,
            timelineStartPosition: storeData.timelineStartPosition,
            children: storeData.children
        };
    }
    static maybeToApplicationNavigationItem(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationNavigationItem(storeData) : undefined;
    }
    static maybeToStoreNavigationItem(appData) {
        return appData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toStoreNavigationItem(appData) : undefined;
    }
    static toStoreNavigationItem(appData) {
        return {
            title: appData.title,
            collectionType: appData.collectionType,
            locator: appData.locator,
            timelineStartPosition: appData.timelineStartPosition,
            children: appData.children
        };
    }
    static toApplicationPublicationOptionsData(storeData) {
        return {
            _id: storeData._id,
            publicationId: storeData.publicationId,
            styleOptions: storeData.styleOptions ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationPublicationStyleOptions(storeData.styleOptions) : undefined,
            ttsOptions: (0, $26ed862a944e7692$export$484729aaeb61b9fc).maybeToApplicationTtsOptions(storeData.ttsOptions)
        };
    }
    static maybeToApplicationPublicationOptionsData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationPublicationOptionsData(storeData) : undefined;
    }
    static toStorePublicationOptionsData(appData) {
        let optionsData = {
            _id: appData._id,
            publicationId: appData.publicationId
        };
        if (appData.styleOptions) optionsData.styleOptions = $f872f385ffa51a29$export$dd19591a313b6cdc.toStorePublicationStyleOptions(appData.styleOptions);
        if (appData.ttsOptions) optionsData.ttsOptions = (0, $26ed862a944e7692$export$484729aaeb61b9fc).maybeToStoreTtsOptions(appData.ttsOptions);
        return optionsData;
    }
    static toApplicationPublicationData(storeData) {
        return {
            id: storeData.id,
            fileName: storeData.fileName,
            fileSourceUri: storeData.fileSourceUri,
            format: storeData.format,
            url: storeData.url,
            title: storeData.title,
            isRtl: storeData.isRtl,
            isFixedLayout: storeData.isFixedLayout,
            isScripted: storeData.isScripted,
            isAudiobook: storeData.isAudiobook,
            hasMoSyncMedia: storeData.hasMoSyncMedia,
            metadata: storeData.metadata,
            coverImageAsBase64: storeData.coverImageAsBase64,
            language: storeData.language
        };
    }
    static maybeToApplicationPublicationData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationPublicationData(storeData) : undefined;
    }
    static toStorePublicationData(appData) {
        return {
            id: appData.id,
            fileName: appData.fileName,
            fileSourceUri: appData.fileSourceUri,
            format: appData.format,
            url: appData.url,
            title: appData.title,
            isRtl: appData.isRtl,
            isFixedLayout: appData.isFixedLayout,
            isScripted: appData.isScripted,
            isAudiobook: appData.isAudiobook,
            hasMoSyncMedia: appData.hasMoSyncMedia,
            metadata: appData.metadata,
            coverImageAsBase64: appData.coverImageAsBase64,
            language: appData.language
        };
    }
    static toApplicationContentPositionData(storeData) {
        return {
            _id: storeData._id,
            publicationId: storeData.publicationId,
            contentBlockData: storeData.contentBlockData,
            contentRects: storeData.contentRects,
            locator: storeData.locator,
            navItemData: storeData.navItemData?.map($f872f385ffa51a29$export$dd19591a313b6cdc.toStoreNavigationItem),
            documentIndex: storeData.documentIndex,
            timestamp: storeData.timestamp
        };
    }
    static maybeToApplicationContentPositionData(storeData) {
        return storeData ? $f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationContentPositionData(storeData) : undefined;
    }
    static toStoreContentPositionData(appData) {
        return {
            _id: appData._id,
            publicationId: appData.publicationId,
            contentBlockData: appData.contentBlockData,
            contentRects: appData.contentRects,
            locator: appData.locator,
            navItemData: appData.navItemData?.map($f872f385ffa51a29$export$dd19591a313b6cdc.toApplicationNavigationItem),
            documentIndex: appData.documentIndex,
            timestamp: appData.timestamp
        };
    }
    static toStorePublicationStyleOptions(appData) {
        return {
            fontSet: appData.fontSet ? $f872f385ffa51a29$export$dd19591a313b6cdc.toStorePublicationStyleFontSet(appData.fontSet) : undefined,
            defaultFontFamily: appData.defaultFontFamily,
            palette: appData.palette,
            fontSizeScaleFactor: appData.fontSizeScaleFactor,
            pageMargins: appData.pageMargins,
            textAlignment: appData.textAlignment,
            lineHeightScaleFactor: appData.lineHeightScaleFactor
        };
    }
    static toApplicationPublicationStyleOptions(storeData) {
        return {
            defaultFontFamily: storeData.defaultFontFamily,
            palette: storeData.palette,
            fontSizeScaleFactor: storeData.fontSizeScaleFactor,
            pageMargins: storeData.pageMargins,
            textAlignment: storeData.textAlignment,
            lineHeightScaleFactor: storeData.lineHeightScaleFactor
        };
    }
    static toStorePublicationStyleFontSet(appFontSet) {
        let fontFaces = appFontSet.fontFaces.map((fontFace)=>{
            return {
                fontStyle: fontFace.fontStyle,
                fontStretch: fontFace.fontStretch,
                fontWeight: fontFace.fontWeight,
                family: fontFace.family,
                mediaType: fontFace.mediaType,
                src: ""
            };
        });
        return {
            fontFaces: fontFaces,
            defaults: appFontSet.defaults,
            selectors: appFontSet.selectors
        };
    }
}


class $26ed862a944e7692$export$484729aaeb61b9fc {
    static toApplicationData(state) {
        return {
            _id: state._id,
            dateCreated: state.dateCreated,
            viewOptions: state.viewOptions,
            syncMediaOptions: state.syncMediaOptions
        };
    }
    static maybeToApplicationData(state) {
        return state ? $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationData(state) : undefined;
    }
    static toStoreData(state) {
        return {
            _id: state._id,
            dateCreated: state.dateCreated,
            viewOptions: state.viewOptions,
            syncMediaOptions: state.syncMediaOptions
        };
    }
    static maybeToUiApplicationData(state) {
        return state ? $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationUiOptionsData(state) : undefined;
    }
    static toApplicationUiReadingRulerOptions(options) {
        if (options) return {
            overlayIsVisible: options.overlayIsVisible,
            overlayBackgroundColor: options.overlayBackgroundColor,
            overlayOpacity: options.overlayOpacity,
            overlayMixBlendMode: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationCssMixBlendModeValues(options.overlayMixBlendMode),
            rulerBackgroundColor: options.rulerBackgroundColor,
            rulerOpacity: options.rulerOpacity,
            rulerMixBlendMode: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationCssMixBlendModeValues(options.rulerMixBlendMode),
            rulerMinHeight: options.rulerMinHeight,
            rulerDragThreshold: options.rulerDragThreshold,
            rulerBorderTopWidth: options.rulerBorderTopWidth,
            rulerBorderBottomWidth: options.rulerBorderBottomWidth,
            rulerBorderLeftWidth: options.rulerBorderLeftWidth,
            rulerBorderRightWidth: options.rulerBorderRightWidth,
            rulerBorderTopColor: options.rulerBorderTopColor,
            rulerBorderBottomColor: options.rulerBorderBottomColor,
            rulerBorderLeftColor: options.rulerBorderLeftColor,
            rulerBorderRightColor: options.rulerBorderRightColor,
            lineBoxBackgroundColor: options.lineBoxBackgroundColor,
            lineBoxOpacity: options.lineBoxOpacity,
            lineBoxMixBlendMode: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationCssMixBlendModeValues(options.lineBoxMixBlendMode),
            lineBoxLineVerticalSpacing: options.lineBoxLineVerticalSpacing,
            lineBoxBorderTopWidth: options.lineBoxBorderTopWidth,
            lineBoxBorderBottomWidth: options.lineBoxBorderBottomWidth,
            lineBoxBorderLeftWidth: options.lineBoxBorderLeftWidth,
            lineBoxBorderRightWidth: options.lineBoxBorderRightWidth,
            lineBoxBorderTopColor: options.lineBoxBorderTopColor,
            lineBoxBorderBottomColor: options.lineBoxBorderBottomColor,
            lineBoxBorderLeftColor: options.lineBoxBorderLeftColor,
            lineBoxBorderRightColor: options.lineBoxBorderRightColor,
            lineBoxMinHeight: options.lineBoxMinHeight,
            lineBoxMaxHeight: options.lineBoxMaxHeight,
            lineBoxLineSpan: options.lineBoxLineSpan,
            snapToLineBoxes: options.snapToLineBoxes
        };
        else return;
    }
    static toStoreUiReadingRulerOptions(options) {
        if (options) return {
            overlayIsVisible: options.overlayIsVisible,
            overlayBackgroundColor: options.overlayBackgroundColor,
            overlayOpacity: options.overlayOpacity,
            overlayMixBlendMode: $26ed862a944e7692$export$484729aaeb61b9fc.toStoreCssMixBlendModeValues(options.overlayMixBlendMode),
            rulerBackgroundColor: options.rulerBackgroundColor,
            rulerOpacity: options.rulerOpacity,
            rulerMixBlendMode: $26ed862a944e7692$export$484729aaeb61b9fc.toStoreCssMixBlendModeValues(options.rulerMixBlendMode),
            rulerMinHeight: options.rulerMinHeight,
            rulerDragThreshold: options.rulerDragThreshold,
            rulerBorderTopWidth: options.rulerBorderTopWidth,
            rulerBorderBottomWidth: options.rulerBorderBottomWidth,
            rulerBorderLeftWidth: options.rulerBorderLeftWidth,
            rulerBorderRightWidth: options.rulerBorderRightWidth,
            rulerBorderTopColor: options.rulerBorderTopColor,
            rulerBorderBottomColor: options.rulerBorderBottomColor,
            rulerBorderLeftColor: options.rulerBorderLeftColor,
            rulerBorderRightColor: options.rulerBorderRightColor,
            lineBoxBackgroundColor: options.lineBoxBackgroundColor,
            lineBoxOpacity: options.lineBoxOpacity,
            lineBoxMixBlendMode: $26ed862a944e7692$export$484729aaeb61b9fc.toStoreCssMixBlendModeValues(options.lineBoxMixBlendMode),
            lineBoxLineVerticalSpacing: options.lineBoxLineVerticalSpacing,
            lineBoxBorderTopWidth: options.lineBoxBorderTopWidth,
            lineBoxBorderBottomWidth: options.lineBoxBorderBottomWidth,
            lineBoxBorderLeftWidth: options.lineBoxBorderLeftWidth,
            lineBoxBorderRightWidth: options.lineBoxBorderRightWidth,
            lineBoxBorderTopColor: options.lineBoxBorderTopColor,
            lineBoxBorderBottomColor: options.lineBoxBorderBottomColor,
            lineBoxBorderLeftColor: options.lineBoxBorderLeftColor,
            lineBoxBorderRightColor: options.lineBoxBorderRightColor,
            lineBoxMinHeight: options.lineBoxMinHeight,
            lineBoxMaxHeight: options.lineBoxMaxHeight,
            lineBoxLineSpan: options.lineBoxLineSpan,
            snapToLineBoxes: options.snapToLineBoxes
        };
        else return;
    }
    static toApplicationUiOptionsData(state) {
        return {
            _id: state._id,
            dateCreated: state.dateCreated,
            showNarrationControls: state.showNarrationControls,
            ignoreAspectRatio: state.ignoreAspectRatio,
            useReducedMotion: state.useReducedMotion,
            useDarkMode: state.useDarkMode,
            activeRendererTypeName: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationRendererTypeName(state.activeRendererTypeName),
            activeUiPaletteName: state.activeUiPaletteName,
            activePublicationPaletteName: state.activePublicationPaletteName,
            activePublicationFontSetName: state.activePublicationFontSetName,
            publicationStyleOptions: state.publicationStyleOptions ? (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toApplicationPublicationStyleOptions(state.publicationStyleOptions) : undefined,
            mediaPlayerPlaybackRate: state.mediaPlayerPlaybackRate,
            ttsOptions: $26ed862a944e7692$export$484729aaeb61b9fc.maybeToApplicationTtsOptions(state.ttsOptions),
            useAccessibilityMode: state.useAccessibilityMode,
            uIActionKeyCommands: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationUiActionKeyCommands(state.uIActionKeyCommands),
            showReadingRuler: state.showReadingRuler,
            readingRulerOptions: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationUiReadingRulerOptions(state.readingRulerOptions),
            showPageNumbers: state.showPageNumbers,
            scrollOverflowingTables: state.scrollOverflowingTables
        };
    }
    static toStoreUiOptionsData(state) {
        return {
            _id: state._id,
            dateCreated: state.dateCreated,
            showNarrationControls: state.showNarrationControls,
            ignoreAspectRatio: state.ignoreAspectRatio,
            useReducedMotion: state.useReducedMotion,
            useDarkMode: state.useDarkMode,
            activeRendererTypeName: $26ed862a944e7692$export$484729aaeb61b9fc.toStoreRendererTypeName(state.activeRendererTypeName),
            activeUiPaletteName: state.activeUiPaletteName,
            activePublicationPaletteName: state.activePublicationPaletteName,
            activePublicationFontSetName: state.activePublicationFontSetName,
            publicationStyleOptions: state.publicationStyleOptions ? (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationStyleOptions(state.publicationStyleOptions) : undefined,
            mediaPlayerPlaybackRate: state.mediaPlayerPlaybackRate,
            ttsOptions: $26ed862a944e7692$export$484729aaeb61b9fc.maybeToStoreTtsOptions(state.ttsOptions),
            useAccessibilityMode: state.useAccessibilityMode,
            uIActionKeyCommands: $26ed862a944e7692$export$484729aaeb61b9fc.toStoreUiActionKeyCommands(state.uIActionKeyCommands),
            fontSets: undefined,
            palettes: undefined,
            showReadingRuler: state.showReadingRuler,
            readingRulerOptions: $26ed862a944e7692$export$484729aaeb61b9fc.toStoreUiReadingRulerOptions(state.readingRulerOptions),
            showPageNumbers: state.showPageNumbers,
            scrollOverflowingTables: state.scrollOverflowingTables
        };
    }
    static toApplicationCssMixBlendModeValues(value) {
        if (value) switch(value){
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).INHERIT:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).INHERIT;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).INITIAL:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).INITIAL;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).REVERT:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).REVERT;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).REVERT_LAYER:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).REVERT_LAYER;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).UNSET:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).UNSET;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).NORMAL:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).NORMAL;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).MULTIPLY:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).MULTIPLY;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).SCREEN:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).SCREEN;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).OVERLAY:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).OVERLAY;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).DARKEN:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).DARKEN;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).LIGHTEN:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).LIGHTEN;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).COLOR_DODGE:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).COLOR_DODGE;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).COLOR_BURN:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).COLOR_BURN;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).HARD_LIGHT:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).HARD_LIGHT;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).SOFT_LIGHT:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).SOFT_LIGHT;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).DIFFERENCE:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).DIFFERENCE;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).EXCLUSION:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).EXCLUSION;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).HUE:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).HUE;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).SATURATION:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).SATURATION;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).COLOR:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).COLOR;
            case (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).LUMINOSITY:
                return (0, $d2c66ead28054c71$export$d297325fca76c218).LUMINOSITY;
        }
        else return;
    }
    static toStoreCssMixBlendModeValues(value) {
        if (value) switch(value){
            case (0, $d2c66ead28054c71$export$d297325fca76c218).INHERIT:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).INHERIT;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).INITIAL:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).INITIAL;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).REVERT:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).REVERT;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).REVERT_LAYER:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).REVERT_LAYER;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).UNSET:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).UNSET;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).NORMAL:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).NORMAL;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).MULTIPLY:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).MULTIPLY;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).SCREEN:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).SCREEN;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).OVERLAY:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).OVERLAY;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).DARKEN:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).DARKEN;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).LIGHTEN:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).LIGHTEN;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).COLOR_DODGE:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).COLOR_DODGE;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).COLOR_BURN:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).COLOR_BURN;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).HARD_LIGHT:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).HARD_LIGHT;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).SOFT_LIGHT:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).SOFT_LIGHT;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).DIFFERENCE:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).DIFFERENCE;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).EXCLUSION:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).EXCLUSION;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).HUE:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).HUE;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).SATURATION:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).SATURATION;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).COLOR:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).COLOR;
            case (0, $d2c66ead28054c71$export$d297325fca76c218).LUMINOSITY:
                return (0, $a9ae8c6e4118a691$export$f5770dcafd219e44).LUMINOSITY;
        }
        else return;
    }
    static toApplicationUiActionKeyCommands(commands) {
        if (commands) return commands.map((command)=>{
            return {
                actionName: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationUiActionName(command?.actionName),
                key: command.key,
                modifiers: command?.modifiers
            };
        });
        else return;
    }
    static toStoreUiActionKeyCommands(commands) {
        if (commands) return commands.map((command)=>{
            return {
                actionName: $26ed862a944e7692$export$484729aaeb61b9fc.toStoreUiActionName(command?.actionName),
                key: command.key,
                modifiers: command?.modifiers
            };
        });
        else return;
    }
    static toApplicationUiActionName(name) {
        switch(name){
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).ACTIONS_MENU_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACTIONS_MENU_OPEN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).MAIN_MENU_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MAIN_MENU_OPEN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).WHERE_AM_I:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).WHERE_AM_I;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).TOC_OPEN_DIALOG:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).TOC_OPEN_DIALOG;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATE_NEXT:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATE_PREVIOUS:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATE_NEXT_HEADING:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT_HEADING;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATE_PREVIOUS_HEADING:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS_HEADING;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_OPEN_DIALOG_ALL:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ALL;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_OPEN_DIALOG_ACTIVE:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ACTIVE;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_SELECTION:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_SELECTION;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_CLIPBOARD:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_CLIPBOARD;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_READING_POSITION:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_READING_POSITION;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_ACTIVE_CONTENT:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_ACTIVE_CONTENT;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_SELECTION:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_SELECTION;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_CLIPBOARD:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_CLIPBOARD;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_READING_POSITION:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_READING_POSITION;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_OPEN_DIALOG_ALL:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ALL;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_OPEN_DIALOG_ACTIVE:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ACTIVE;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).SEARCH_DIALOG_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_DIALOG_OPEN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).SEARCH_CLEAR:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_CLEAR;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_START:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_START;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_STOP:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_STOP;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_SKIP_FORWARD:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_SKIP_FORWARD;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_SKIP_BACKWARD:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_SKIP_BACKWARD;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_ESCAPE_SEGMENT:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_ESCAPE_ACTIVE_SEGMENT;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_ESCAPE_ALL:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_ESCAPE_ALL;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).HELP_DIALOG_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HELP_DIALOG_OPEN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).ACCESSIBILITY_MODE_ENTER:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_ENTER;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).ACCESSIBILITY_MODE_EXIT:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_EXIT;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).SETTINGS_DIALOG_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_DIALOG_OPEN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).SETTINGS_RESET:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_RESET;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKSHELF_DIALOG_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKSHELF_DIALOG_OPEN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).GOTO_PAGE_DIALOG_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).GOTO_PAGE_DIALOG_OPEN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_TOOL_ACTIVATE:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_TOOL_ACTIVATE;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_TOOL_DEACTIVATE:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_TOOL_DEACTIVATE;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_OUT:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_OUT;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_IN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_IN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_RESET:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_RESET;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).READING_RULER_ACTIVATE:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_ACTIVATE;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).READING_RULER_DEACTIVATE:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_DEACTIVATE;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).READING_RULER_MOVE_NEXT:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_MOVE_NEXT;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).READING_RULER_MOVE_PREVIOUS:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_MOVE_PREVIOUS;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).LANDMARKS_DIALOG_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).LANDMARKS_DIALOG_OPEN;
            case (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATION_HISTORY_DIALOG_OPEN:
                return (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATION_HISTORY_DIALOG_OPEN;
        }
    }
    static toStoreUiActionName(name) {
        switch(name){
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACTIONS_MENU_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).ACTIONS_MENU_OPEN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MAIN_MENU_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).MAIN_MENU_OPEN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).WHERE_AM_I:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).WHERE_AM_I;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).TOC_OPEN_DIALOG:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).TOC_OPEN_DIALOG;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATE_NEXT;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATE_PREVIOUS;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_NEXT_HEADING:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATE_NEXT_HEADING;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATE_PREVIOUS_HEADING:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATE_PREVIOUS_HEADING;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ALL:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_OPEN_DIALOG_ALL;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_OPEN_DIALOG_ACTIVE:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_OPEN_DIALOG_ACTIVE;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_SELECTION:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_SELECTION;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_CLIPBOARD:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_CLIPBOARD;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_READING_POSITION:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_READING_POSITION;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HIGHLIGHT_ACTIVE_CONTENT:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).HIGHLIGHT_ACTIVE_CONTENT;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_SELECTION:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_SELECTION;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_CLIPBOARD:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_CLIPBOARD;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_READING_POSITION:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_READING_POSITION;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ALL:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_OPEN_DIALOG_ALL;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKMARK_OPEN_DIALOG_ACTIVE:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKMARK_OPEN_DIALOG_ACTIVE;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_DIALOG_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).SEARCH_DIALOG_OPEN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SEARCH_CLEAR:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).SEARCH_CLEAR;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_START:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_START;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_STOP:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_STOP;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_SKIP_FORWARD:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_SKIP_FORWARD;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_SKIP_BACKWARD:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_SKIP_BACKWARD;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_ESCAPE_ACTIVE_SEGMENT:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_ESCAPE_SEGMENT;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).MEDIA_PLAYBACK_ESCAPE_ALL:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).MEDIA_PLAYBACK_ESCAPE_ALL;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).HELP_DIALOG_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).HELP_DIALOG_OPEN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_ENTER:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).ACCESSIBILITY_MODE_ENTER;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ACCESSIBILITY_MODE_EXIT:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).ACCESSIBILITY_MODE_EXIT;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_DIALOG_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).SETTINGS_DIALOG_OPEN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).SETTINGS_RESET:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).SETTINGS_RESET;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).BOOKSHELF_DIALOG_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).BOOKSHELF_DIALOG_OPEN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).CLOSE_DIALOGS_AND_FOCUS_ON_READING_POSITION;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).GOTO_PAGE_DIALOG_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).GOTO_PAGE_DIALOG_OPEN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_TOOL_ACTIVATE:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_TOOL_ACTIVATE;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_TOOL_DEACTIVATE:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_TOOL_DEACTIVATE;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_OUT:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_OUT;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_IN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_IN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).ZOOM_RESET:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).ZOOM_RESET;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_ACTIVATE:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).READING_RULER_ACTIVATE;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_DEACTIVATE:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).READING_RULER_DEACTIVATE;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_MOVE_NEXT:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).READING_RULER_MOVE_NEXT;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).READING_RULER_MOVE_PREVIOUS:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).READING_RULER_MOVE_PREVIOUS;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).LANDMARKS_DIALOG_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).LANDMARKS_DIALOG_OPEN;
            case (0, $d2c66ead28054c71$export$98a63c97d3a2bbdf).NAVIGATION_HISTORY_DIALOG_OPEN:
                return (0, $a9ae8c6e4118a691$export$13500b787143c912).NAVIGATION_HISTORY_DIALOG_OPEN;
        }
    }
    static toApplicationRendererTypeName(name) {
        if (name) switch(name){
            case (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).FLIPBOOK:
                return (0, $652e6cb51d594b1d$export$7ef357ac666ee52).FLIPBOOK;
            case (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).STACK:
                return (0, $652e6cb51d594b1d$export$7ef357ac666ee52).STACK;
            case (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).RESPONSIVE:
                return (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE;
            case (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).SCROLL:
                return (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL;
            case (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).SWIPE_SINGLE:
                return (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SWIPE_SINGLE;
            case (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).SWIPE_SPREAD:
                return (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SWIPE_SPREAD;
        }
        else return;
    }
    static toStoreRendererTypeName(name) {
        if (name) switch(name){
            case (0, $652e6cb51d594b1d$export$7ef357ac666ee52).FLIPBOOK:
                return (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).FLIPBOOK;
            case (0, $652e6cb51d594b1d$export$7ef357ac666ee52).STACK:
                return (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).STACK;
            case (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE:
                return (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).RESPONSIVE;
            case (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL:
                return (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).SCROLL;
            case (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SWIPE_SINGLE:
                return (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).SWIPE_SINGLE;
            case (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SWIPE_SPREAD:
                return (0, $a9ae8c6e4118a691$export$879ba39c30b12f45).SWIPE_SPREAD;
        }
        else return;
    }
    static toApplicationTtsOptions(storeData) {
        return {
            voiceName: storeData.voiceName,
            highlightColor: storeData.highlightColor,
            volume: storeData.volume,
            rate: storeData.rate
        };
    }
    static maybeToApplicationTtsOptions(storeData) {
        return storeData ? $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationTtsOptions(storeData) : undefined;
    }
    static maybeToStoreTtsOptions(storeData) {
        return storeData ? $26ed862a944e7692$export$484729aaeb61b9fc.toStoreTtsOptions(storeData) : undefined;
    }
    static toStoreTtsOptions(appData) {
        return {
            voiceName: appData.voiceName,
            highlightColor: appData.highlightColor,
            volume: appData.volume,
            rate: appData.rate
        };
    }
    static maybeToApplicationPalette(palettes) {
        if (palettes) return {
            Default: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(palettes.Default),
            Dark: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(palettes.Dark),
            ContrastDark: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(palettes.ContrastDark),
            Paperlike: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(palettes.Paperlike)
        };
        else return;
    }
    static maybeToStorePalette(palettes) {
        if (palettes) return {
            Default: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(palettes.Default),
            Dark: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(palettes.Dark),
            ContrastDark: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(palettes.ContrastDark),
            Paperlike: $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(palettes.Paperlike)
        };
        else return;
    }
    static toApplicationStoreUiColorPalette(storeData) {
        return {
            foregroundDark: storeData.foregroundDark,
            foregroundLight: storeData.foregroundLight,
            backgroundDark: storeData.backgroundDark,
            backgroundLight: storeData.backgroundLight,
            accent: storeData.accent,
            name: storeData.name,
            uiIsDark: storeData.uiIsDark,
            uiOutlineDark: storeData.uiOutlineDark,
            uiOutlineLight: storeData.uiOutlineLight,
            uiBackgroundDark: storeData.uiBackgroundDark,
            uiBackgroundLight: storeData.uiBackgroundLight,
            uiForegroundDark: storeData.uiForegroundDark,
            uiForegroundLight: storeData.uiForegroundLight
        };
    }
    static maybeToApplicationStoreUiColorPalette(storeData) {
        return storeData ? $26ed862a944e7692$export$484729aaeb61b9fc.toApplicationStoreUiColorPalette(storeData) : undefined;
    }
    static toStoreStoreUiColorPalette(appData) {
        return {
            foregroundDark: appData.foregroundDark,
            foregroundLight: appData.foregroundLight,
            backgroundDark: appData.backgroundDark,
            backgroundLight: appData.backgroundLight,
            accent: appData.accent,
            name: appData.name,
            uiIsDark: appData.uiIsDark,
            uiOutlineDark: appData.uiOutlineDark,
            uiOutlineLight: appData.uiOutlineLight,
            uiBackgroundDark: appData.uiBackgroundDark,
            uiBackgroundLight: appData.uiBackgroundLight,
            uiForegroundDark: appData.uiForegroundDark,
            uiForegroundLight: appData.uiForegroundLight
        };
    }
}


class $40e29b410cef4ce9$export$7a896a6db7ee70f6 extends (0, $2f895839ac78ac6c$export$4ece27d405df7279) {
    constructor(dbName = "options.vanillareader.colibrio.com", persist = true){
        super(dbName);
        this._initialized = false;
        if (persist && navigator.storage && navigator.storage.persist) navigator.storage.persist().then((canPersist)=>{
            if (canPersist) console.log("VanillaReaderSettingsIndexedDbDataStore will persist data.");
            else console.log("VanillaReaderSettingsIndexedDbDataStore will NOT persist data.");
        }).catch(console.warn);
        this.version(1).stores({
            vanillaReaderOptionsData: "_id, dateCreated",
            vanillaReaderUiOptionsData: "_id, dateCreated"
        });
        this._vanillaReaderOptionsData = this.table("vanillaReaderOptionsData");
        this._vanillaReaderUiOptionsData = this.table("vanillaReaderUiOptionsData");
    }
    initialize() {
        return this.open().then((_db)=>{
            this._initialized = true;
        }).catch((_)=>{
            this._initialized = false;
        });
    }
    async fetchVanillaReaderOptionsData() {
        if (this._initialized) return this._vanillaReaderOptionsData.toCollection().last().then((0, $26ed862a944e7692$export$484729aaeb61b9fc).maybeToApplicationData);
        else return;
    }
    async setVanillaReaderOptionsData(state) {
        if (this._initialized) {
            // There should only be one
            let existingOptionCount = await this._vanillaReaderOptionsData.count();
            if (existingOptionCount > 1) await this._vanillaReaderOptionsData.clear();
            state._id = 1;
            const storeState = (0, $26ed862a944e7692$export$484729aaeb61b9fc).toStoreData(state);
            await this._vanillaReaderOptionsData.put(storeState, 1);
        }
    }
    async clearVanillaReaderOptionsData() {
        if (this._initialized) await this._vanillaReaderOptionsData.clear();
    }
    async fetchVanillaReaderUiOptionsData() {
        if (this._initialized) return this._vanillaReaderUiOptionsData.toCollection().last().then((0, $26ed862a944e7692$export$484729aaeb61b9fc).maybeToUiApplicationData);
        else return undefined;
    }
    async setVanillaReaderUiOptionsData(state) {
        if (this._initialized) {
            // There should only be one
            let existingOptionCount = await this._vanillaReaderUiOptionsData.count();
            if (existingOptionCount > 1) await this._vanillaReaderUiOptionsData.clear();
            state._id = 1;
            const storeState = (0, $26ed862a944e7692$export$484729aaeb61b9fc).toStoreUiOptionsData(state);
            await this._vanillaReaderUiOptionsData.put(storeState, 1);
        }
    }
    async clearVanillaReaderUiOptionsData() {
        if (this._initialized) return this._vanillaReaderUiOptionsData.clear();
    }
}




class $95e3201f88ee9822$export$6a7a8975c9f63f42 extends (0, $2f895839ac78ac6c$export$4ece27d405df7279) {
    constructor(dbName = "publication.vanillareader.colibrio.com", persist = true){
        super(dbName);
        this._initialized = false;
        if (persist && navigator.storage && navigator.storage.persist) navigator.storage.persist().then((canPersist)=>{
            if (canPersist) console.log("VanillaReaderPublicationIndexedDbDataStore will persist data.");
            else console.log("VanillaReaderPublicationIndexedDbDataStore will NOT persist data.");
        }).catch(console.warn);
        this.version(1).stores({
            vanillaReaderPublicationData: "id, fileName, url",
            vanillaReaderPublicationOptionsData: "publicationId",
            vanillaReaderPublicationCacheData: "publicationId",
            vanillaReaderPublicationReadingPositionData: "publicationId"
        });
        this._vanillaReaderPublicationData = this.table("vanillaReaderPublicationData");
        this._vanillaReaderPublicationOptionsData = this.table("vanillaReaderPublicationOptionsData");
        this._vanillaReaderPublicationCacheData = this.table("vanillaReaderPublicationCacheData");
        this._vanillaReaderPublicationReadingPositionData = this.table("vanillaReaderPublicationReadingPositionData");
    }
    initialize() {
        return this.open().then((_db)=>{
            this._initialized = true;
        }).catch((_)=>{
            this._initialized = false;
        });
    }
    /**
     *
     * IVanillaReaderPublicationMetadata
     *
     * */ async hasPublicationData(publicationId) {
        if (this._initialized) return await this._vanillaReaderPublicationData.where("id").equals(publicationId).count() > 0;
        else return false;
    }
    async hasPublicationDataByFileName(fileName) {
        if (this._initialized) return await this._vanillaReaderPublicationData.where("fileName").equals(fileName).count() > 0;
        else return false;
    }
    fetchAllPublicationData() {
        if (this._initialized) return this._vanillaReaderPublicationData.toArray().then((arr)=>arr.map((0, $f872f385ffa51a29$export$dd19591a313b6cdc).toApplicationPublicationData));
        else return Promise.resolve([]);
    }
    async fetchPublicationDataByFileName(fileName) {
        if (this._initialized) return this._vanillaReaderPublicationData.where("fileName").equals(fileName).first().then((0, $f872f385ffa51a29$export$dd19591a313b6cdc).maybeToApplicationPublicationData);
        else return;
    }
    async setPublicationDataByFileName(fileName, state) {
        if (this._initialized) {
            // There can be only one!
            await this.deletePublicationDataByFileName(fileName);
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationData(state);
            await this._vanillaReaderPublicationData.add(storeState);
            if (this._onPublicationDataAdded) this._onPublicationDataAdded(state);
        }
        return Promise.resolve();
    }
    async updatePublicationDataByFileName(fileName, state) {
        if (this._initialized) {
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationData(state);
            await this._vanillaReaderPublicationData.where("fileName").equals(fileName).modify(storeState);
            if (this._onPublicationDataUpdated) this._onPublicationDataUpdated(state);
        }
        return Promise.resolve(undefined);
    }
    async deletePublicationDataByFileName(fileName) {
        if (this._initialized) {
            let numberOfDeletions = this._vanillaReaderPublicationData.where("fileName").equals(fileName).delete();
            if (this._onPublicationDataDeleted) this._onPublicationDataDeleted(fileName);
            return Promise.resolve(numberOfDeletions);
        } else return 0;
    }
    async fetchPublicationData(publicationId) {
        if (this._initialized) return this._vanillaReaderPublicationData.where("id").equals(publicationId).first().then((0, $f872f385ffa51a29$export$dd19591a313b6cdc).maybeToApplicationPublicationData);
        else return;
    }
    async setPublicationData(publicationId, state) {
        if (this._initialized) {
            // There can be only one!
            await this._vanillaReaderPublicationData.where("id").equals(publicationId).delete();
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationData(state);
            await this._vanillaReaderPublicationData.add(storeState);
            if (this._onPublicationDataAdded) this._onPublicationDataAdded(state);
        }
        return Promise.resolve();
    }
    async deletePublicationData(publicationId) {
        if (this._initialized) {
            let numberOfDeletions = this._vanillaReaderPublicationData.where("id").equals(publicationId).delete();
            if (this._onPublicationDataDeleted) this._onPublicationDataDeleted(publicationId);
            return Promise.resolve(numberOfDeletions);
        } else return 0;
    }
    async updatePublicationData(publicationId, state) {
        if (this._initialized) {
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationData(state);
            await this._vanillaReaderPublicationData.where("id").equals(publicationId).modify(storeState);
            if (this._onPublicationDataUpdated) this._onPublicationDataUpdated(state);
        }
        return;
    }
    /**
     *
     * IVanillaReaderPublicationCacheData
     *
     * */ async hasPublicationCacheData(publicationId) {
        if (this._initialized) return await this._vanillaReaderPublicationCacheData.where("publicationId").equals(publicationId).count() > 0;
        else return false;
    }
    async fetchPublicationCacheData(publicationId) {
        if (this._initialized) return this._vanillaReaderPublicationCacheData.where("publicationId").equals(publicationId).first().then((0, $f872f385ffa51a29$export$dd19591a313b6cdc).maybeToApplicationPublicationCacheData);
        else return;
    }
    async setPublicationCacheData(publicationId, state) {
        if (this._initialized) {
            // There can be only one!
            await this._vanillaReaderPublicationCacheData.where("publicationId").equals(publicationId).delete();
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationCacheData(state);
            await this._vanillaReaderPublicationCacheData.add(storeState, publicationId);
            if (this._onPublicationCacheDataAdded) this._onPublicationCacheDataAdded(state);
        }
        return Promise.resolve();
    }
    async updatePublicationCacheData(publicationId, state) {
        if (this._initialized) {
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationCacheData(state);
            await this._vanillaReaderPublicationCacheData.update(publicationId, storeState);
            if (this._onPublicationCacheDataUpdated) this._onPublicationCacheDataUpdated(state);
        }
        return Promise.resolve();
    }
    async deletePublicationCacheData(publicationId) {
        if (this._initialized) {
            let numberOfDeletions = await this._vanillaReaderPublicationCacheData.where("publicationId").equals(publicationId).delete();
            if (this._onPublicationCacheDataDeleted) this._onPublicationCacheDataDeleted(publicationId);
            return Promise.resolve(numberOfDeletions);
        } else return 0;
    }
    /**
     *
     * IVanillaReaderPublicationOptionsData
     *
     * */ async hasPublicationOptionsData(publicationId) {
        if (this._initialized) return await this._vanillaReaderPublicationOptionsData.where("publicationId").equals(publicationId).count() > 0;
        else return false;
    }
    async deletePublicationOptionsData(publicationId) {
        if (this._initialized) {
            let numberOfDeletions = await this._vanillaReaderPublicationOptionsData.where("publicationId").equals(publicationId).delete();
            if (this._onPublicationOptionsDataDeleted) this._onPublicationOptionsDataDeleted();
            return Promise.resolve(numberOfDeletions);
        } else return 0;
    }
    fetchAllPublicationOptionsData() {
        if (this._initialized) return this._vanillaReaderPublicationOptionsData.toArray().then((arr)=>arr.map((0, $f872f385ffa51a29$export$dd19591a313b6cdc).toApplicationPublicationOptionsData));
        else return Promise.resolve([]);
    }
    fetchPublicationOptionsData(publicationId) {
        if (this._initialized) return this._vanillaReaderPublicationOptionsData.where("publicationId").equals(publicationId).first().then((0, $f872f385ffa51a29$export$dd19591a313b6cdc).maybeToApplicationPublicationOptionsData);
        else return Promise.resolve(undefined);
    }
    async setPublicationOptionsData(publicationId, state) {
        if (this._initialized) {
            await this._vanillaReaderPublicationOptionsData.where("publicationId").equals(publicationId).delete();
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationOptionsData(state);
            await this._vanillaReaderPublicationOptionsData.add(storeState);
            if (this._onPublicationOptionsDataAdded) this._onPublicationOptionsDataAdded(state);
        }
        return Promise.resolve();
    }
    async updatePublicationOptionsData(publicationId, state) {
        if (this._initialized) {
            if (!await this.hasPublicationOptionsData(publicationId)) await this.setPublicationOptionsData(publicationId, {
                publicationId: publicationId
            });
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStorePublicationOptionsData(state);
            await this._vanillaReaderPublicationOptionsData.update(publicationId, storeState);
            if (this._onPublicationOptionsDataUpdated) this._onPublicationOptionsDataUpdated(state);
        }
        return Promise.resolve();
    }
    /**
     *
     * IVanillaReaderReadingPositionData
     *
     * */ async hasPublicationReadingPositionData(publicationId) {
        if (this._initialized) return await this._vanillaReaderPublicationReadingPositionData.where("publicationId").equals(publicationId).count() > 0;
        else return false;
    }
    async setPublicationReadingPositionData(publicationId, state) {
        if (this._initialized) {
            const storeState = (0, $f872f385ffa51a29$export$dd19591a313b6cdc).toStoreContentPositionData(state);
            await this._vanillaReaderPublicationReadingPositionData.put(storeState, publicationId);
            return Promise.resolve();
        } else return;
    }
    async fetchPublicationReadingPositionData(publicationId) {
        if (this._initialized) return this._vanillaReaderPublicationReadingPositionData.get(publicationId).then((0, $f872f385ffa51a29$export$dd19591a313b6cdc).maybeToApplicationContentPositionData);
        else return;
    }
    async clearPublicationReadingPositionData(publicationId) {
        if (this._initialized) return this._vanillaReaderPublicationReadingPositionData.delete(publicationId);
    }
    /**
     *
     * IVanillaReaderPublicationStateData
     *
     * */ async fetchCompletePublicationStateData(publicationId) {
        let publicationMetadataData = await this.fetchPublicationData(publicationId);
        let publicationOptionsData = await this.fetchPublicationOptionsData(publicationId);
        let publicationCacheData = await this.fetchPublicationCacheData(publicationId);
        let publicationReadingPositionData = await this.fetchPublicationReadingPositionData(publicationId);
        return this._serializeStateData(publicationMetadataData, publicationOptionsData, publicationCacheData, publicationReadingPositionData);
    }
    async fetchCompletePublicationStateDataByFileName(fileName) {
        let publicationOptionsData;
        let publicationCacheData;
        let publicationReadingPositionData;
        let publicationData = await this.fetchPublicationDataByFileName(fileName);
        if (publicationData && publicationData.id) {
            publicationReadingPositionData = await this.fetchPublicationReadingPositionData(publicationData.id);
            publicationOptionsData = await this.fetchPublicationOptionsData(publicationData.id);
            publicationCacheData = await this.fetchPublicationCacheData(publicationData.id);
        }
        return this._serializeStateData(publicationData, publicationOptionsData, publicationCacheData, publicationReadingPositionData);
    }
    async setCompletePublicationStateData(stateData) {
        if (!stateData.id) {
            console.error("VanillaReaderPublicationIndexedDbDataStore.setCompletePublicationStateData(): No valid id parameter found in state data.");
            return;
        }
        const publicationData = {
            id: stateData?.id,
            fileName: stateData?.fileName || "",
            metadata: stateData?.metadata,
            url: stateData?.url || "",
            isRtl: stateData?.isRtl,
            isAudiobook: stateData?.isAudiobook,
            format: stateData?.format || "",
            title: stateData?.title,
            coverImageAsBase64: stateData?.coverImageAsBase64,
            hasMoSyncMedia: stateData?.hasMoSyncMedia,
            isScripted: stateData?.isScripted,
            isFixedLayout: stateData?.isFixedLayout,
            fileSourceUri: stateData?.fileSourceUri || ""
        };
        this.setPublicationData(stateData.id, publicationData).catch(console.warn);
        const publicationCacheData = {
            publicationId: stateData.id,
            searchIndexData: stateData?.searchIndexData,
            navigationTreeData: stateData?.navigationTreeData,
            landmarkData: stateData?.landmarkData,
            timelineData: stateData?.timelineData,
            storageState: stateData?.storageState
        };
        this.setPublicationCacheData(stateData.id, publicationCacheData).catch(console.warn);
        const publicationOptionsData = {
            publicationId: stateData.id,
            styleOptions: stateData.styleOptions,
            ttsOptions: stateData?.ttsOptions
        };
        this.setPublicationOptionsData(stateData.id, publicationOptionsData).catch(console.warn);
        if (stateData.latestReadingPositionData) this.setPublicationReadingPositionData(stateData.id, stateData.latestReadingPositionData).catch(console.warn);
    }
    async _serializeStateData(publicationData, publicationOptionsData, publicationCacheData, publicationReadingPositionData) {
        return {
            id: publicationData?.id || "",
            fileName: publicationData?.fileName || "",
            metadata: publicationData?.metadata,
            url: publicationData?.url || "",
            isRtl: publicationData?.isRtl,
            isAudiobook: publicationData?.isAudiobook,
            format: publicationData?.format || "",
            title: publicationData?.title,
            coverImageAsBase64: publicationData?.coverImageAsBase64,
            hasMoSyncMedia: publicationData?.hasMoSyncMedia,
            isScripted: publicationData?.isScripted,
            isFixedLayout: publicationData?.isFixedLayout,
            fileSourceUri: publicationData?.fileSourceUri || "",
            searchIndexData: publicationCacheData?.searchIndexData,
            navigationTreeData: publicationCacheData?.navigationTreeData,
            landmarkData: publicationCacheData?.landmarkData,
            timelineData: publicationCacheData?.timelineData,
            storageState: publicationCacheData?.storageState,
            latestReadingPositionData: publicationReadingPositionData,
            styleOptions: publicationOptionsData?.styleOptions,
            ttsOptions: publicationOptionsData?.ttsOptions
        };
    }
    /**
     *
     * IVanillaReaderPublicationMetadata
     *
     * */ onPublicationDataAdded(callback) {
        this._onPublicationDataAdded = callback;
    }
    onPublicationDataDeleted(callback) {
        this._onPublicationDataDeleted = callback;
    }
    onPublicationDataUpdated(callback) {
        this._onPublicationDataUpdated = callback;
    }
    /**
     *
     * IVanillaReaderPublicationCacheData
     *
     * */ onPublicationCacheDataUpdated(callback) {
        this._onPublicationCacheDataUpdated = callback;
    }
    onPublicationCacheDataAdded(callback) {
        this._onPublicationCacheDataAdded = callback;
    }
    onPublicationCacheDataDeleted(callback) {
        this._onPublicationOptionsDataDeleted = callback;
    }
    /**
     *
     * IVanillaReaderPublicationOptionsData
     *
     * */ onPublicationOptionsDataUpdated(callback) {
        this._onPublicationOptionsDataUpdated = callback;
    }
    onPublicationOptionsDataAdded(callback) {
        this._onPublicationOptionsDataAdded = callback;
    }
    onPublicationOptionsDataCleared(callback) {
        this._onPublicationOptionsDataDeleted = callback;
    }
}



class $f6634c2bb55dca26$export$1f888110e485dcb8 extends (0, $2f895839ac78ac6c$export$4ece27d405df7279) {
    constructor(dbName = "bookmarks.vanillareader.colibrio.com"){
        super(dbName);
        this._bookmarkAddedCallback = undefined;
        this._bookmarkDeletedCallback = undefined;
        this._bookmarksCollectionUpdatedCallback = undefined;
        this._initialized = false;
        this.version(1).stores({
            bookmarks: "_id, locator, bookSection, publicationId, dateCreated"
        });
        this._bookmarks = this.table("bookmarks");
    }
    initialize() {
        return this.open().then((_db)=>{
            this._initialized = true;
        }).catch((_)=>{
            this._initialized = false;
        });
    }
    onBookmarkAdded(callback) {
        this._bookmarkAddedCallback = callback;
    }
    onBookmarkDeleted(callback) {
        this._bookmarkDeletedCallback = callback;
    }
    onBookmarksCollectionUpdated(callback) {
        this._bookmarksCollectionUpdatedCallback = callback;
    }
    async addBookmark(bookmarkData) {
        let targetLocator = bookmarkData.locator;
        if (this._initialized) {
            let targetHasBookmark = await this._bookmarks.where("locator").equals(targetLocator).count() > 0;
            if (!targetHasBookmark) return this._addBookmark(bookmarkData).catch();
            else {
                console.warn(`VanillaReaderBookmarkStore.addBookmark(): location "${targetLocator}" is already Bookmarked.`);
                return Promise.reject(`VanillaReaderBookmarkStore.addBookmark(): location "${targetLocator}" is already Bookmarked.`);
            }
        } else {
            const message = `VanillaReaderBookmarkStore.addBookmark(): No database connection.`;
            console.warn(message);
            return Promise.reject(message);
        }
    }
    async addBookmarks(bookmarkData, silent = true) {
        if (this._initialized) bookmarkData.forEach((bookmark)=>{
            this._addBookmark(bookmark, silent).catch(console.warn);
        });
        return Promise.resolve();
    }
    async deleteBookmark(locator) {
        if (this._initialized) {
            let bookmark = await this._bookmarks.where("locator").equals(locator).first();
            if (bookmark) {
                if (bookmark._id) {
                    this._bookmarks.delete(bookmark._id);
                    const applicationBookmark = $f6634c2bb55dca26$export$1f888110e485dcb8.toApplicationData(bookmark);
                    if (this._bookmarkDeletedCallback) this._bookmarkDeletedCallback(applicationBookmark);
                    if (this._bookmarksCollectionUpdatedCallback) this._bookmarksCollectionUpdatedCallback();
                }
            } else console.warn(`VanillaReaderBookmarkStore.deleteBookmark(): location "${locator}" is not bookmarked.`);
        } else console.warn(`VanillaReaderBookmarkStore.deleteBookmark(): No database connection`);
    }
    async deleteAllBookmarksByPublication(publicationId) {
        if (this._initialized) await this._bookmarks.where("publicationId").equals(publicationId).delete();
        return Promise.resolve();
    }
    async deleteAllBookmarks() {
        if (this._initialized) await this._bookmarks.each(async (bookmark)=>{
            if (bookmark._id) await this.deleteBookmark(bookmark._id);
        });
        return Promise.resolve();
    }
    async fetchBookmark(locator) {
        if (this._initialized) {
            let bookmark = await this._bookmarks.where("locator").equals(locator).first().then($f6634c2bb55dca26$export$1f888110e485dcb8.maybeToApplicationData);
            if (bookmark) return bookmark;
            else console.warn(`VanillaReaderBookmarkStore.addBookmark(): no bookmark found for location "${locator}".`);
        }
        return;
    }
    async fetchAllBookmarks() {
        if (this._initialized) return this._bookmarks.toArray().then((bookmarks)=>bookmarks.map($f6634c2bb55dca26$export$1f888110e485dcb8.toApplicationData));
        else return [];
    }
    async fetchBookmarksByPublication(publicationId) {
        if (this._initialized) return this._bookmarks.where("publicationId").equals(publicationId).toArray().then((bookmarks)=>bookmarks.map($f6634c2bb55dca26$export$1f888110e485dcb8.toApplicationData));
        else return [];
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ async _addBookmark(bookmarkData, silent = false) {
        let targetLocator = bookmarkData.locator;
        if (!bookmarkData.dateCreated) bookmarkData.dateCreated = Date.now();
        if (!bookmarkData._id) bookmarkData._id = Date.now().toString();
        const storeData = $f6634c2bb55dca26$export$1f888110e485dcb8.toStoreData(bookmarkData);
        await this._bookmarks.put(storeData, targetLocator);
        if (this._bookmarkAddedCallback) this._bookmarkAddedCallback(bookmarkData, silent);
        if (this._bookmarksCollectionUpdatedCallback) this._bookmarksCollectionUpdatedCallback();
        return bookmarkData;
    }
    static toStoreData(bookmarkData) {
        return {
            _id: bookmarkData._id,
            locator: bookmarkData.locator,
            publicationId: bookmarkData.publicationId,
            color: bookmarkData.color,
            text: bookmarkData.text,
            bookSection: bookmarkData.bookSection,
            dateCreated: bookmarkData.dateCreated
        };
    }
    static maybeToApplicationData(storeData) {
        return storeData ? $f6634c2bb55dca26$export$1f888110e485dcb8.toApplicationData(storeData) : undefined;
    }
    static toApplicationData(storeData) {
        return {
            _id: storeData._id,
            locator: storeData.locator,
            publicationId: storeData.publicationId,
            color: storeData.color,
            text: storeData.text,
            bookSection: storeData.bookSection,
            dateCreated: storeData.dateCreated
        };
    }
}



class $7399cd445d59fd6b$export$3a85d47e69232dc9 extends (0, $2f895839ac78ac6c$export$4ece27d405df7279) {
    constructor(dbName = "highlights.vanillareader.colibrio.com"){
        super(dbName);
        this._highlightAddedCallback = undefined;
        this._highlightDeletedCallback = undefined;
        this._highlightUpdatedCallback = undefined;
        this._highlightsCollectionUpdatedCallback = undefined;
        this._initialized = false;
        this.version(1).stores({
            highlights: "_id, locator, color, bookSection, publicationId, dateCreated"
        });
        this._highlights = this.table("highlights");
    }
    initialize() {
        return this.open().then((_db)=>{
            this._initialized = true;
        }).catch((_)=>{
            this._initialized = false;
        });
    }
    onHighlightAdded(callback) {
        this._highlightAddedCallback = callback;
    }
    onHighlightUpdated(callback) {
        this._highlightUpdatedCallback = callback;
    }
    onHighlightDeleted(callback) {
        this._highlightDeletedCallback = callback;
    }
    onHighlightsCollectionUpdated(callback) {
        this._highlightsCollectionUpdatedCallback = callback;
    }
    async addHighlight(highlightData) {
        if (this._initialized) {
            let targetLocator = highlightData.locator;
            let targetHasHighlight = await this._highlights.where("locator").equals(targetLocator).count() > 0;
            if (!targetHasHighlight) return this._addHighlight(highlightData).catch();
            else {
                console.warn(`VanillaReaderHighlightStore.addHighlight(): location "${targetLocator}" is already highlighted.`);
                return Promise.reject(`VanillaReaderHighlightStore.addHighlight(): location "${targetLocator}" is already highlighted.`);
            }
        } else return Promise.reject("No datastore connection");
    }
    async addHighlights(highlightData, silent = true) {
        highlightData.forEach((highlight)=>{
            this._addHighlight(highlight, silent).catch(console.warn);
        });
        return Promise.resolve();
    }
    async updateHighlight(highlightData) {
        if (this._initialized) {
            if (highlightData._id && await this._highlights.get(highlightData._id)) {
                highlightData.dateUpdated = Date.now();
                this._highlights.update(highlightData._id, highlightData);
                const highlight = $7399cd445d59fd6b$export$3a85d47e69232dc9.toApplicationData(highlightData);
                if (this._highlightUpdatedCallback) this._highlightUpdatedCallback(highlight);
                if (this._highlightsCollectionUpdatedCallback) this._highlightsCollectionUpdatedCallback();
            } else {
                console.warn(`VanillaReaderHighlightStore.addHighlight(): no highlight found for location "${highlightData.locator}".`);
                return Promise.reject(`VanillaReaderHighlightStore.addHighlight(): no highlight found for location "${highlightData.locator}".`);
            }
        } else return Promise.reject("No datastore connection");
    }
    async deleteHighlight(locator) {
        if (this._initialized) {
            let highlight = await this._highlights.where("locator").equals(locator).first();
            if (highlight && highlight._id) {
                this._highlights.delete(highlight._id);
                const applicationData = $7399cd445d59fd6b$export$3a85d47e69232dc9.toApplicationData(highlight);
                if (this._highlightDeletedCallback) this._highlightDeletedCallback(applicationData);
                if (this._highlightsCollectionUpdatedCallback) this._highlightsCollectionUpdatedCallback();
            } else {
                console.warn(`VanillaReaderHighlightStore.deleteHighlight(): location "${locator}" is not highlighted.`);
                return Promise.reject(`VanillaReaderHighlightStore.deleteHighlight(): location "${locator}" is not highlighted.`);
            }
        } else return Promise.reject(`VanillaReaderHighlightStore.deleteHighlight(): No database connection`);
    }
    async deleteAllHighlights() {
        if (this._initialized) await this._highlights.each(async (highlight)=>{
            if (highlight._id) return this.deleteHighlight(highlight._id);
            else return Promise.reject();
        });
        return Promise.resolve();
    }
    async deleteAllHighlightsByPublication(publicationId) {
        if (this._initialized) {
            await this._highlights.where("publicationId").equals(publicationId).delete();
            return Promise.resolve();
        } else return Promise.resolve();
    }
    async fetchHighlight(locator) {
        if (this._initialized) {
            let highlight = await this._highlights.where("locator").equals(locator).first().then($7399cd445d59fd6b$export$3a85d47e69232dc9.maybeToApplicationData);
            if (highlight) return highlight;
            else console.warn(`VanillaReaderHighlightStore.addHighlight(): no highlight found for location "${locator}".`);
        }
        return;
    }
    async fetchAllHighlights() {
        if (this._initialized) return this._highlights.toArray().then((storeData)=>storeData.map($7399cd445d59fd6b$export$3a85d47e69232dc9.toApplicationData));
        else return [];
    }
    async fetchHighlightsByPublication(publicationId) {
        if (this._initialized) return this._highlights.where("publicationId").equals(publicationId).toArray().then((storeData)=>storeData.map($7399cd445d59fd6b$export$3a85d47e69232dc9.toApplicationData));
        else return [];
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ async _addHighlight(highlightData, silent = false) {
        if (this._initialized) {
            let targetLocator = highlightData.locator;
            if (!highlightData.dateCreated) highlightData.dateCreated = Date.now();
            if (!highlightData._id) highlightData._id = Date.now().toString();
            const storeData = $7399cd445d59fd6b$export$3a85d47e69232dc9.toStoreData(highlightData);
            await this._highlights.put(storeData, targetLocator);
            if (this._highlightAddedCallback) this._highlightAddedCallback(highlightData, silent);
            if (this._highlightsCollectionUpdatedCallback) this._highlightsCollectionUpdatedCallback();
        }
        return highlightData;
    }
    static toStoreData(highlightData) {
        return {
            _id: highlightData._id,
            color: highlightData.color,
            comment: highlightData.comment,
            locator: highlightData.locator,
            selectionText: highlightData.selectionText,
            publicationId: highlightData.publicationId,
            bookSection: highlightData.bookSection,
            dateCreated: highlightData.dateCreated,
            dateUpdated: highlightData.dateUpdated
        };
    }
    static maybeToApplicationData(storeData) {
        return storeData ? $7399cd445d59fd6b$export$3a85d47e69232dc9.toApplicationData(storeData) : undefined;
    }
    static toApplicationData(storeData) {
        return {
            _id: storeData._id,
            color: storeData.color,
            comment: storeData.comment,
            locator: storeData.locator,
            selectionText: storeData.selectionText,
            publicationId: storeData.publicationId,
            bookSection: storeData.bookSection,
            dateCreated: storeData.dateCreated
        };
    }
}




class $60c892c4ea24e37e$export$e5d4745b968da87f {
    constructor(){
        // Storage client for storage of application options for UI and reading.
        this._vanillaReaderOptionsDataStore = new (0, $40e29b410cef4ce9$export$7a896a6db7ee70f6)("options.vanillareader.colibrio.com");
        // Storage client for storage of publication metadata.
        this._vanillaReaderPublicationDataStore = new (0, $95e3201f88ee9822$export$6a7a8975c9f63f42)("publication.vanillareader.colibrio.com");
        // Storage client for storage of bookmark data.
        this._vanillaReaderBookmarkStorage = new (0, $f6634c2bb55dca26$export$1f888110e485dcb8)("bookmarks.vanillareader.colibrio.com");
        // Storage client for storage of highlight data.
        this._vanillaReaderHighlightStorage = new (0, $7399cd445d59fd6b$export$3a85d47e69232dc9)("highlights.vanillareader.colibrio.com");
        // Storage client for storage of downloaded publication resource data. This is used for offline storage.
        this._vanillaReaderStreamedResourceStorage = new (0, $46c4fb4ea4a276f7$export$bead30365be78d90)("data.vanillareader.colibrio.com");
    }
    async initialize() {
        return Promise.all([
            this._vanillaReaderBookmarkStorage.initialize(),
            this._vanillaReaderHighlightStorage.initialize(),
            this._vanillaReaderStreamedResourceStorage.initialize(),
            this._vanillaReaderPublicationDataStore.initialize(),
            this._vanillaReaderOptionsDataStore.initialize()
        ]);
    }
    get publicationDataStore() {
        return this._vanillaReaderPublicationDataStore;
    }
    get highlightDataStore() {
        return this._vanillaReaderHighlightStorage;
    }
    get bookmarkDataStore() {
        return this._vanillaReaderBookmarkStorage;
    }
    get streamedResourcesDataStore() {
        return this._vanillaReaderStreamedResourceStorage;
    }
    get optionsDataStore() {
        return this._vanillaReaderOptionsDataStore;
    }
    /*
    *
    * This function saves the current application state by calling `serializeAppState` on the `VanillaReader` instance, and
    * then saving it to the device using the active `IVanillaDataStore` instance (currently `VanillaReaderLocalStorageDataStore`).
    *
     */ async saveVanillaReaderAppOptionsState(readerOptionsData, uiOptionsData) {
        if (readerOptionsData) {
            if (readerOptionsData.viewOptions) await this._vanillaReaderOptionsDataStore.setVanillaReaderOptionsData(readerOptionsData);
        }
        if (uiOptionsData) this.saveVanillaReaderUiOptions(uiOptionsData).catch(console.warn);
    }
    // Save the UI settings to the data store.
    async saveVanillaReaderUiOptions(options) {
        await this._vanillaReaderOptionsDataStore.setVanillaReaderUiOptionsData(options);
    }
    getActiveVanillaReaderUiOptionsPresetData() {
        let optionsPresetData = localStorage.getItem((0, $a9ae8c6e4118a691$export$f3c46465ddda9081).VanillaReaderUiActiveOptionsPreset);
        if (!optionsPresetData) return;
        return JSON.parse(optionsPresetData);
    }
    setActiveVanillaReaderUiOptionsPresetData(presetData) {
        localStorage.setItem((0, $a9ae8c6e4118a691$export$f3c46465ddda9081).VanillaReaderUiActiveOptionsPreset, JSON.stringify(presetData));
    }
    clearActiveVanillaReaderUiOptionsPresetData() {
        localStorage.removeItem((0, $a9ae8c6e4118a691$export$f3c46465ddda9081).VanillaReaderUiActiveOptionsPreset);
    }
    async clearAllPublicationCacheData() {
        let publicationData = await this._vanillaReaderPublicationDataStore.fetchAllPublicationData();
        publicationData.forEach((data)=>{
            this._vanillaReaderPublicationDataStore.deletePublicationCacheData(data.id).then((noAffected)=>{
                console.log(`deletePublicationCacheData returned ${noAffected}`);
            }).catch(console.warn);
        });
    }
    // This method is used to migrate data from the older, less persistent storage that used the LocalStorage API.
    async performDataMigrationFromLocalStorage() {
        let numberOfItemsMigrated = 0;
        // As LocalStorage is a simple key value store with no "namespacing", we need to loop through all items in the store
        // and determine if we should migrate the item or not.
        for(const key in localStorage){
            let data;
            let item = localStorage.getItem(key);
            if (item) {
                try {
                    data = JSON.parse(item);
                } catch (e) {
                    continue;
                }
                if (data === undefined) continue;
                if (this._isLegacyVanillaReaderPublicationStateData(data) && data.id) {
                    // Check if the publication has already been migrated.
                    if (await this._vanillaReaderPublicationDataStore.hasPublicationData(data.id)) {
                        console.log(`performDataMigrationFromLocalStorage: "${data.fileName}" has already been migrated.`);
                        continue;
                    }
                    console.log(`performDataMigrationFromLocalStorage: Starting migration for publication "${data.fileName}"`);
                    await this._vanillaReaderPublicationDataStore.setPublicationData(data.id, {
                        id: data.id,
                        fileName: data.fileName,
                        coverImageAsBase64: data.coverImageAsBase64,
                        fileSourceUri: data.fileSourceUri,
                        format: data.fileSourceUri,
                        hasMoSyncMedia: data.hasMoSyncMedia,
                        isScripted: data.isScripted,
                        isFixedLayout: data.isFixedLayout,
                        isRtl: data.isRtl,
                        isAudiobook: data.isAudiobook,
                        metadata: data.metadata,
                        url: data.url,
                        title: data.title
                    }).catch(console.warn);
                    console.log(`performDataMigrationFromLocalStorage: Migrated publication data for "${data.fileName}"`);
                    if (data.highlights && data.highlights.length > 0) {
                        for (const highlight of data.highlights){
                            highlight.publicationId = data.id;
                            await this._vanillaReaderHighlightStorage.addHighlight(highlight).catch(console.warn);
                        }
                        console.log(`performDataMigrationFromLocalStorage: Migrated ${data.highlights.length} highlights`);
                    }
                    if (data.bookmarks && data.bookmarks.length > 0) {
                        for (const bookmark of data.bookmarks){
                            bookmark.publicationId = data.id;
                            await this._vanillaReaderBookmarkStorage.addBookmark(bookmark).catch(console.warn);
                        }
                        console.log(`performDataMigrationFromLocalStorage: Migrated ${data.bookmarks.length} bookmarks`);
                    }
                    if (data.latestReadingPosition) {
                        await this._vanillaReaderPublicationDataStore.setPublicationReadingPositionData(data.id, {
                            publicationId: data.id,
                            timestamp: data.latestReadingDateTime || 0,
                            locator: data.latestReadingPosition.locator,
                            navItemData: data.latestReadingPosition.navItemData,
                            documentIndex: data.latestReadingPosition.documentIndex
                        }).catch(console.warn);
                        console.log(`performDataMigrationFromLocalStorage: Migrated latest reading position data.`);
                    }
                    numberOfItemsMigrated++;
                }
                console.log(`performDataMigrationFromLocalStorage: Done migrating publication "${data.fileName}"`);
            }
        }
        window.localStorage.setItem((0, $a9ae8c6e4118a691$export$f3c46465ddda9081).VanillaReaderAppDataMigrationDateStamp, Date.now().toString());
        return numberOfItemsMigrated;
    }
    _isVanillaReaderUiOptionsPresetName(name) {
        return (0, $d2c66ead28054c71$export$82747f63b1a1778f).hasOwnProperty(name);
    }
    _isLegacyVanillaReaderPublicationStateData(data) {
        return data.hasOwnProperty("id") && data.hasOwnProperty("fileName");
    }
}



var $cLeaP = parcelRequire("cLeaP");
const { Random: $e2beb524c7d9daf5$export$a92776769f460054, Sha1: $e2beb524c7d9daf5$export$c85d589bf4e25fef, Sha256: $e2beb524c7d9daf5$export$3b58ea8124ac5e28 } = (0, (/*@__PURE__*/$parcel$interopDefault($cLeaP)));



const $20ec8651f5382be8$var$getRandomHexString = (0, $e2beb524c7d9daf5$export$a92776769f460054).getRandomHexString;
class $20ec8651f5382be8$export$561293739547e970 {
    // This function returns a IVanillaReaderUserProfileData from LocalStorage. If no user data has been stored previously,
    // the data is created object and stored.
    static async fetchOrCreateUserProfile() {
        let userProfileData;
        let userProfileDataString = window.localStorage.getItem((0, $a9ae8c6e4118a691$export$f3c46465ddda9081).VanillaReaderUserProfileData);
        if (!userProfileDataString) {
            let uuid = $20ec8651f5382be8$var$getRandomHexString(12);
            let token = $20ec8651f5382be8$export$561293739547e970._createDigestFromString(uuid);
            userProfileData = {
                id: uuid,
                token: token
            };
            window.localStorage.setItem((0, $a9ae8c6e4118a691$export$f3c46465ddda9081).VanillaReaderUserProfileData, JSON.stringify(userProfileData));
        } else userProfileData = JSON.parse(userProfileDataString);
        return userProfileData;
    }
    // This function creates a SHA256 hash from a string value. This is to demonstrate and emphasise that the user id
    // should always be obfuscated before used with the framework.
    static _createDigestFromString(stringValue) {
        let sha = new (0, $e2beb524c7d9daf5$export$c85d589bf4e25fef)();
        sha.append(stringValue);
        return sha.digestToHex();
    }
}









class $0a4a19848a70e2ac$export$e5f1b90dcb43f90f {
    constructor(_vanillaReaderAppMain){
        this._vanillaReaderAppMain = _vanillaReaderAppMain;
        this._vanillaReaderAppMain.onVanillaReaderInstanceCreated(()=>{
            const vanillaReader = this._vanillaReaderAppMain.getVanillaReaderInstance();
            if (!vanillaReader) throw new Error("MasterPlanPostMessageHandler.constructor(): vanillaReaderAppMain.getVanillaReaderInstance() returned undefined.");
        });
    }
    static get instance() {
        return $0a4a19848a70e2ac$export$e5f1b90dcb43f90f._masterPlanPostMessageHandlerInstance;
    }
    static create(appMain) {
        $0a4a19848a70e2ac$export$e5f1b90dcb43f90f._masterPlanPostMessageHandlerInstance = new $0a4a19848a70e2ac$export$e5f1b90dcb43f90f(appMain);
        window.addEventListener("message", this._processPostMessage);
        return $0a4a19848a70e2ac$export$e5f1b90dcb43f90f._masterPlanPostMessageHandlerInstance;
    }
    static{
        this._processPostMessage = (message)=>{
            if (!message.origin.includes("masterplan")) return;
            console.log(`>>> Colibrio (${message.data.type})`);
            switch(message.data.type){
                case "LOAD_PUBLICATION_URL":
                    this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.loadPublicationFromUrl(message.data.value, undefined, true);
                    break;
                case "LOAD_PUBLICATION_BLOB":
                    this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.loadPublicationFromFile(message.data.value, undefined, true);
                    break;
                case "INITIAL_LOCATION":
                    this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.goTo(message.data.value);
                    break;
                case "SPREAD_ACCESS":
                    console.log("COLIBRIO Spread Access: ", message.data.value);
                    this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.setRenderableDocuments(message.data.value);
                    break;
                case "GOTO":
                    const waitForLoaded = new Promise((resolve, _)=>{
                        const loop = ()=>this.instance?._vanillaReaderAppMain.getVanillaReaderInstance()?.isLoaded !== undefined && this.instance?._vanillaReaderAppMain.getVanillaReaderInstance()?.isLoaded ? resolve(true) : setTimeout(loop);
                        loop();
                    });
                    waitForLoaded.then(()=>this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.goTo(message.data.value));
                    break;
                case "SET_RENDERER":
                    console.log("COLIBRIO Set Renderer: ", message.data.value);
                    break;
                case "FORCE_RENDERER":
                    let renderer;
                    switch(message.data.value){
                        case "verticalScrollRenderer":
                            renderer = (0, $652e6cb51d594b1d$export$7ef357ac666ee52).SCROLL;
                            break;
                        case "stackRenderer":
                            renderer = (0, $652e6cb51d594b1d$export$7ef357ac666ee52).STACK;
                            break;
                        case "flipbookRenderer":
                            renderer = (0, $652e6cb51d594b1d$export$7ef357ac666ee52).FLIPBOOK;
                            break;
                        case "__responsive":
                            renderer = (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE;
                            break;
                        default:
                            renderer = (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE;
                    }
                    console.log("COLIBRIO Force Renderer: ", message.data.value);
                    this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.changeRenderer(renderer, true);
                    break;
                case "SEARCH_COLIBRIO":
                    console.log("COLIBRIO Search: ", message.data.value);
                    let term = typeof message.data.value !== "undefined" ? message.data.value : "";
                    this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.searchPublication(term, 1000);
                    break;
                case "CLEAR_SEARCH_COLIBRIO":
                    console.log("COLIBRIO Clear Search");
                    this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.clearPublicationSearchLayer();
                    break;
                case "SEARCH_COLIBRIO_AND_NAVIGATE":
                    console.log("COLIBRIO Search and Navigate: ", message.data.value);
                    break;
                case "FORCE_ASPECT_RATIO":
                    console.log("COLIBRIO Force Aspect Ratio: ", message.data.value);
                    break;
                case "READER_PUBLICATION_LOADED":
                    break;
                case "STOP_MEDIA":
                    console.log("COLIBRIO Stop Media: ", message.data.value);
                    break;
                case "ADD_ANNOTATION":
                    console.log("COLIBRIO Add Annotation ", message.data.value);
                    this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.createAnnotationLayer(message.data.value);
                    break;
                default:
            }
        };
    }
}


const $8dc4352c8968dbc4$export$362487a062cb253a = "4.7.0";


class $a0949ff2251db721$export$354c5dd6b66622ea {
    constructor(_applicationViewElement, _licenseKey, _initialOptions){
        this._applicationViewElement = _applicationViewElement;
        this._licenseKey = _licenseKey;
        this._initialOptions = _initialOptions;
        this._isOffline = true;
        this._vanillaReaderAppStorage = new (0, $60c892c4ea24e37e$export$e5d4745b968da87f)();
        this._vanillaReaderBookshelf = new (0, $65b364fa4af2a76a$export$fccf27e8fa078aff)(this._vanillaReaderAppStorage);
        this._vanillaReaderBookshelf.onBookshelfUpdated($a0949ff2251db721$export$354c5dd6b66622ea._onBookshelfUpdated);
        this._vanillaReaderBookshelf.onShelfItemDeleted($a0949ff2251db721$export$354c5dd6b66622ea._onBookshelfItemDeleted);
    }
    static get colibrioFrameworkVersion() {
        return 0, $8dc4352c8968dbc4$export$362487a062cb253a;
    }
    static get appVersion() {
        return 0, $8dc4352c8968dbc4$export$362487a062cb253a;
    }
    get isOffline() {
        return this._isOffline;
    }
    get useDeviceStorage() {
        return this._initialOptions.useDeviceStorage;
    }
    get activeAppUiTheme() {
        return this._activeAppUiTheme;
    }
    async _asyncSetup() {
        await this._vanillaReaderAppStorage.initialize();
        let defaultPalette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === "Default");
        let activePaletteString = localStorage.getItem((0, $a9ae8c6e4118a691$export$f3c46465ddda9081).VanillaReaderActiveColorPalette);
        let activePaletteData = activePaletteString ? JSON.parse(activePaletteString) : defaultPalette;
        this.changeAppUiColorTheme(activePaletteData);
        this._vanillaReader = await this.createVanillaReaderModule(this._licenseKey, this._initialOptions.customWebSpeechTtsSynthesizer);
        this._vanillaReaderAPI = (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).create(this);
        if (this._onVanillaReaderInstanceCreatedCallback) this._onVanillaReaderInstanceCreatedCallback();
        this._vanillaReaderUi = await this.createVanillaReaderUiModule(this._applicationViewElement, activePaletteData, this._vanillaReaderAPI);
        // Now that the UI has rendered, we can get the containing element for the VanillaReaderView.
        this._vanillaReader.setReaderViewElement(this._vanillaReaderUi.vanillaReaderViewElement);
        if (activePaletteData) this._vanillaReaderUi.setUiColorTheme(activePaletteData);
        if (this._onVanillaReaderUiInstanceCreatedCallback) this._onVanillaReaderUiInstanceCreatedCallback();
        this._checkNetworkState();
        this._registerModulesOnWindowObject();
        (0, $0a4a19848a70e2ac$export$e5f1b90dcb43f90f).create(this);
        if (this._onAppLoadedCallback) this._onAppLoadedCallback();
    }
    onVanillaReaderInstanceCreated(callback) {
        this._onVanillaReaderInstanceCreatedCallback = callback;
    }
    onVanillaReaderUiInstanceCreated(callback) {
        this._onVanillaReaderUiInstanceCreatedCallback = callback;
    }
    onAppLoaded(callback) {
        this._onAppLoadedCallback = callback;
    }
    getVanillaReaderInstance() {
        return this._vanillaReader;
    }
    getVanillaReaderUiInstance() {
        return this._vanillaReaderUi;
    }
    getVanillaReaderBookshelfInstance() {
        return this._vanillaReaderBookshelf;
    }
    getVanillaReaderApiInstance() {
        return this._vanillaReaderAPI;
    }
    async createVanillaReaderModule(licenseApiKey, customWebSpeechTtsSynthesizer) {
        // The user profile data holds the unique user identifier that is used as token when loading publications.
        const userProfileData = await (0, $20ec8651f5382be8$export$561293739547e970).fetchOrCreateUserProfile();
        // Get any previously saved framework options from local storage. This will later be used to initialize the
        // VanillaReader to its previous state.
        const storedVanillaReaderOptionsData = await this._vanillaReaderAppStorage?.optionsDataStore.fetchVanillaReaderOptionsData();
        const vanillaReaderViewOptions = storedVanillaReaderOptionsData?.viewOptions;
        let vanillaSyncMediaOptions = storedVanillaReaderOptionsData?.syncMediaOptions;
        if (customWebSpeechTtsSynthesizer) {
            if (!vanillaSyncMediaOptions) vanillaSyncMediaOptions = {
                webSpeechTtsSynthesizer: customWebSpeechTtsSynthesizer
            };
        }
        if (vanillaReaderViewOptions) {
            if (this._initialOptions.useReducedMotion) vanillaReaderViewOptions.useReducedMotion = true;
        }
        // Needed to add a ts-ignore as the TS definitions do not recognize the `downlink` property :/
        // @ts-ignore
        const slowNetwork = navigator.connection?.downlink < 1.5 && !this._initialOptions.forceHighSpeedConnection;
        const vanillaReader = new (0, $ab06243ba3e98443$export$dea8a9c0c2b1e4c0)(undefined, licenseApiKey, userProfileData, {
            slowNetwork: slowNetwork,
            storeOnDevice: this._initialOptions.useDeviceStorage,
            viewOptions: vanillaReaderViewOptions,
            syncMediaOptions: vanillaSyncMediaOptions,
            customReaderViewContentOnLoading: '<div class="vanilla-reader__loader"><div class="vanilla-reader__loader__logo"></div><div class="vanilla-reader__loader__spinner"></div></div>',
            customReaderViewContentOnLoadError: '<div id="vanilla-reader__reader-view__load-error">\uD83D\uDCA5</div>'
        }, this._vanillaReaderAppStorage.optionsDataStore);
        // Add event listeners for connection related events. This check is unfortunately not enough as it only reports if
        // there is an active connection, not that a connection can reach the Internet. In addition to these events we also
        // set up a reoccurring fetch request in the `checkNetworkState()` function.
        window.addEventListener("online", ()=>{
            vanillaReader.isOffline = false;
        });
        window.addEventListener("offline", ()=>{
            vanillaReader.isOffline = true;
        });
        window.addEventListener("resize", ()=>{
            vanillaReader.refreshReaderView();
        });
        return vanillaReader;
    }
    async createVanillaReaderUiModule(readerViewElement, palette, vanillaReaderAPI) {
        let vanillaReaderUi = new (0, $539461ce1f8559bb$export$aac599461d91d7c2)(readerViewElement, this._vanillaReaderBookshelf, this._vanillaReaderAppStorage.optionsDataStore, this._initialOptions.useDeviceStorage, palette);
        // When the user wants to open a new book we reload the index.html page to start from a clean state.
        // We take care to keep the `pwa=true` query parameter on reload.
        vanillaReaderAPI.onPublicationClose((_eventData)=>{
            this.closePublication();
        });
        // Event fired when the VanillaReaderUI has updated settings. These are saved to the store in the `saveVanillaReaderOptionsState`
        // function.
        vanillaReaderAPI.onAppUiOptionsChanged((eventData)=>{
            this._vanillaReaderAppStorage.saveVanillaReaderUiOptions(eventData.detail.uiOptionsData).catch(console.warn);
        });
        vanillaReaderAPI.onAppUiOptionsPresetApplied((eventData)=>{
            this._vanillaReaderAppStorage.saveVanillaReaderUiOptions(eventData.detail.uiOptions).catch(console.warn);
        });
        return vanillaReaderUi;
    }
    async loadPublicationFromFile(fileObject, initialLocator, useDeviceStorage) {
        let shelfItem = await this._vanillaReaderBookshelf.fetchShelfItemByFileName(fileObject.name);
        if (!shelfItem) shelfItem = await this._vanillaReaderBookshelf.addShelfItem(fileObject.name, `file://${fileObject.name}`);
        initialLocator = initialLocator || shelfItem.readingPositionData?.locator;
        this._vanillaReader?.loadPublicationFromFile(fileObject, shelfItem, initialLocator, useDeviceStorage).catch(console.warn);
    }
    async loadPublicationFromUrl(url, initialLocator, useDeviceStorage = this._initialOptions.useDeviceStorage) {
        let fileName = url.slice(url.lastIndexOf("/") + 1);
        let shelfItem = await this._vanillaReaderBookshelf.fetchShelfItemByFileName(fileName);
        if (!shelfItem) shelfItem = await this._vanillaReaderBookshelf.addShelfItem(fileName, url);
        initialLocator = initialLocator || shelfItem.readingPositionData?.locator;
        // let's see if we have any publication data stored for this publication file name.
        await this._vanillaReader?.loadPublicationFromUrl(url, shelfItem, undefined, initialLocator, useDeviceStorage);
        this._vanillaReaderUi?.toaster.toast(`Opening ${fileName}`).catch(console.warn);
        this._vanillaReaderUi?.dialogOpenFile.close(true);
    }
    async loadPublicationFromAws(base64, initialLocator, useDeviceStorage = this._initialOptions.useDeviceStorage) {
        let url = "https://rh771cx8n6.execute-api.eu-west-2.amazonaws.com/masterplan-reader/catalog/publication/" + base64;
        const unencodedUrl = atob(base64);
        const fileName = unencodedUrl.substring(unencodedUrl.lastIndexOf("/") + 1);
        let shelfItem = await this._vanillaReaderBookshelf.fetchShelfItemByFileName(fileName);
        if (!shelfItem) shelfItem = await this._vanillaReaderBookshelf.addShelfItem(fileName, url);
        initialLocator = initialLocator || shelfItem.readingPositionData?.locator;
        await this._vanillaReader?.loadPublicationFromAwsLambda(url, ()=>{
            return this.fetchAwsS3SignedPublicationUrl(base64);
        }, shelfItem, undefined, initialLocator, useDeviceStorage);
        this._vanillaReaderUi?.masterplanStart.close(true);
    }
    async fetchAwsS3SignedPublicationUrl(uid) {
        return fetch("https://rh771cx8n6.execute-api.eu-west-2.amazonaws.com/masterplan-reader/catalog/publication/" + uid + "?invoke=getSignedUrl").then(async (response)=>{
            const data = await response.json();
            return data.url;
        });
    }
    async loadPublicationFromShelfItemData(shelfItemData) {
        let shelfItem = await this._vanillaReaderBookshelf.fetchShelfItemByFileName(shelfItemData.fileName);
        if (!shelfItem) {
            console.warn(`VanillaReaderAppMain.loadPublicationFromShelfItemData(), Unable to load "${shelfItemData.fileName}".`);
            return;
        }
        if (await shelfItem.hasStoredResource()) this._vanillaReader?.loadPublicationFromStore(shelfItem.fileName, shelfItem.fileSourceUri, shelfItem, shelfItem.readingPositionData?.locator);
        else console.warn(`VanillaReaderAppMain.loadPublicationFromShelfItemData(), Item "${shelfItemData.fileName}" has no stored resource.`);
    }
    async deletePublicationResources(shelfItemData) {
        await this._vanillaReaderBookshelf.deleteShelfItem(shelfItemData);
    }
    /*
    *
    * This method changes the color theme for the application UI based on a `IVanillaReaderUiColorTheme`.
    * The palettes are defined in the `VanillaReaderAppUiDefaults` class.
    *
    */ changeAppUiColorTheme(palette) {
        // Normally the `!` operator is a big no-no. In this case though we know that the `VanillaReaderAppUiDefaults`
        // has a set value for all it's members.
        let defaultPalette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === "Dark");
        if (palette) document.documentElement.style.backgroundColor = palette.backgroundDark;
        else document.documentElement.style.backgroundColor = defaultPalette.backgroundLight;
        if (!palette) palette = defaultPalette;
        // Update the VanillaReaderUI theme with the new values
        let uiStyle = this._vanillaReaderUi?.vanillaReaderUIElement.style;
        if (uiStyle) {
            !palette.backgroundDark || uiStyle.setProperty("--vanilla-reader__color__reader__background-dark", palette.backgroundDark);
            !palette.backgroundLight || uiStyle.setProperty("--vanilla-reader__color__reader__background-light", palette.backgroundLight);
            !palette.foregroundDark || uiStyle.setProperty("--vanilla-reader__color__reader__foreground-dark", palette.foregroundDark);
            !palette.foregroundLight || uiStyle.setProperty("--vanilla-reader__color__reader__foreground-light", palette.foregroundLight);
            !palette.uiBackgroundDark || uiStyle.setProperty("--vanilla-reader__color__ui__background-dark", palette.uiBackgroundDark);
            !palette.uiBackgroundLight || uiStyle.setProperty("--vanilla-reader__color__ui__background-light", palette.uiBackgroundLight);
            !palette.uiForegroundDark || uiStyle.setProperty("--vanilla-reader__color__ui__foreground-dark", palette.uiForegroundDark);
            !palette.uiForegroundLight || uiStyle.setProperty("--vanilla-reader__color__ui__foreground-light", palette.uiForegroundLight);
            !palette.uiOutlineDark || uiStyle.setProperty("--vanilla-reader__color__ui__outline-dark", palette.uiOutlineDark);
            !palette.uiOutlineLight || uiStyle.setProperty("--vanilla-reader__color__ui__outline-light", palette.uiOutlineLight);
            !palette.accent || uiStyle.setProperty("--vanilla-reader__color__ui__accent", palette.accent);
        }
        this._activeAppUiTheme = palette;
        // We need to save an extra copy of the active palette in local storage so that we can retrieve it synchronously
        // at app start.
        localStorage.setItem((0, $a9ae8c6e4118a691$export$f3c46465ddda9081).VanillaReaderActiveColorPalette, JSON.stringify(palette));
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("APP_UI_THEME_CHANGED", {
            colorPalette: palette
        }));
    }
    async performDataMigrationFromLocalStorage() {
        return this._vanillaReaderAppStorage.performDataMigrationFromLocalStorage();
    }
    getActiveUiPresetData() {
        if (!this._vanillaReaderAppStorage) return;
        return this._vanillaReaderAppStorage.getActiveVanillaReaderUiOptionsPresetData();
    }
    setActiveUiPresetData(optionsPresetData) {
        if (!this._vanillaReaderAppStorage) return;
        this._vanillaReaderAppStorage.setActiveVanillaReaderUiOptionsPresetData(optionsPresetData);
    }
    clearActiveUiPresetData() {
        if (!this._vanillaReaderAppStorage) return;
        this._vanillaReaderAppStorage.clearActiveVanillaReaderUiOptionsPresetData();
    }
    closePublication() {
        if (this._vanillaReader && this._vanillaReaderUi) {
            let readerOptionsData = this._vanillaReader.serializeToOptionsData();
            let uiOptionsData = this._vanillaReaderUi.serializeToUiOptionsData();
            this._vanillaReaderAppStorage.saveVanillaReaderAppOptionsState(readerOptionsData, uiOptionsData).then(()=>{
                window.location.href = `index.html${this._initialOptions.useDeviceStorage ? "?pwa=true" : ""}`;
            }).catch(console.error);
        }
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ static _onBookshelfUpdated(updatedShelfItems) {
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_SHELF_UPDATED", {
            shelfItems: updatedShelfItems
        }));
    }
    static _onBookshelfItemDeleted() {
        (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("PUBLICATION_RESOURCES_DELETED", {}));
    }
    /*
    *
    * This function simply pings an HTML page on our server to see if we are still connected to the network.
    * This is still the only real way to check connectivity since the existing browser APIs are very hard to work with
    * reliably.
    *
    * When we get a timeout we set the `VanillaReader.isOffline` property to communicate to the application that it should
    * change its internal behaviour to adapt.
    *
     */ _checkNetworkState() {
        try {
            fetch("https://demo.colibrio.com/ping.html", {
                mode: "no-cors",
                method: "HEAD"
            }).then((res)=>{
                // Any status less than 500 means that we got something back from the server.
                if (res.status < 500) this._isOffline = false;
            }).catch((_err)=>{
                this._isOffline = true;
            });
        } catch  {
            this._isOffline = true;
        }
        window.setTimeout(this._checkNetworkState, 2500);
    }
    /**
     *
     * BROWSER CONSOLE HELPERS
     *
     * Let's export the VanillaReader and the VanillaReaderUI so that we can play around with the APIs
     * more easily. The VanillaReader is meant to be a fun playground! 😊
     *
     * */ _registerModulesOnWindowObject() {
        window.vanillaReaderAppMain = this;
        window.vanillaReader = this._vanillaReader;
        window.vanillaReaderAPI = this._vanillaReader ? (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance : undefined;
        window.vanillaReaderUi = this._vanillaReaderUi;
        window.vanillaReaderBookshelf = this._vanillaReaderBookshelf;
        window.VanillaReaderEventBus = (0, $84c7b345e247d474$export$51b4df07290407);
        window.EpubCfiParser = (0, $6e4be20e0d38cef0$export$21e821b3ad85b00b);
        window.TreeNodeWalker = (0, $91ca8664a4c236f4$export$1dc4171992fdbf4b);
        window.ObjectUtils = (0, $33027d939f78e552$export$4855211e6b8ad895);
        // Two very handy utility classes for working with range data. Also classes good to have access to in the console.
        window["IntRange"] = (0, $da1a1533b140aa86$export$495676b7a762bc7f);
        window["IntSequence"] = (0, $632829fca60d0ba6$export$98bf3bbab5d20daf);
    }
}


let $59e9af023252b064$export$e538f94cc8cf4db8 = [];
let $59e9af023252b064$export$83d89fbfd8236492 = "";
function $59e9af023252b064$export$c208e1278d7beb2(m, v) {
    $59e9af023252b064$export$e538f94cc8cf4db8 = m;
    $59e9af023252b064$export$83d89fbfd8236492 = v;
}


/* ☝️NOTE ☝️
*
*  The import above imports an array of items as `manifest` generated by parcel.js.
*  Parcel is also nice enough to generate a `version` string for us to use to determine if cached resources should be
*  removed.
*
* */ /**
 * # Service Worker
 *
 * ## RESPONSIBILITIES
 *
 * This service worker enables the Vanilla Reader to be installed for offline use by caching all the static application
 * resources, such as scripts, images, css etc, on install.
 *
 * The worker uses a cache first strategy, with network fallback. It adds all the resources in the `manifest` to the
 * cache on install, then for each new `fetch` event it will double-check to see if it should complement the cache with
 * additional resources.
 *
 * Service Workers can be trickier than they seem, and do not always behave as described in various docs.
 *
 * A good starting point is this article on this topic on web.dev:
 * https://web.dev/offline-cookbook/
 *
 **/ /**
 * INSTALL EVENT
 **/ async function $6619efc090304cca$var$install() {
    const cache = await caches.open((0, $59e9af023252b064$export$83d89fbfd8236492));
    await cache.addAll((0, $59e9af023252b064$export$e538f94cc8cf4db8));
}
self.addEventListener("install", (e)=>{
    e.waitUntil($6619efc090304cca$var$install());
});
/**
 * ACTIVATE EVENT
 **/ async function $6619efc090304cca$var$activate() {
    const keys = await caches.keys();
    console.log(`Service Worker with version ${(0, $59e9af023252b064$export$83d89fbfd8236492)} is about to activate. Cleaning up previous cache.`);
    await Promise.all(keys.map(async (key)=>{
        // Is the cache from another version than the current? If so delete it to keep things clean and neat.
        if (key !== (0, $59e9af023252b064$export$83d89fbfd8236492)) {
            let result = await caches.delete(key);
            if (result) {
                console.log(`Deleted cache key ${key}`);
                return true;
            }
        }
        return false;
    }));
}
self.addEventListener("activate", (e)=>{
    return e.waitUntil($6619efc090304cca$var$activate());
});
self.addEventListener("fetch", (ev)=>{
    // @ts-ignore
    ev.respondWith(caches.match(ev.request, {
        "ignoreSearch": true
    }).then((cachedResponse)=>{
        if (cachedResponse) // @ts-ignore
        return cachedResponse;
        else // @ts-ignore
        return fetch(ev.request).then((response)=>{
            let pathName = response.url.slice(response.url.lastIndexOf("/"));
            if (!response || response.status !== 200 || response.type !== "basic") return response;
            if ((0, $59e9af023252b064$export$e538f94cc8cf4db8).indexOf(pathName) < 0) {
                console.log("pathName " + pathName + " should not be in the cache.");
                return response;
            }
            // The response is ok
            var responseToCache = response.clone();
            caches.open((0, $59e9af023252b064$export$83d89fbfd8236492)).then((cache)=>{
                console.log("Caching response ", responseToCache);
                // @ts-ignore
                cache.put(ev.request, responseToCache).catch(console.warn);
            }).catch(console.warn);
            return response;
        });
    }));
});
/**
 *
 * MESSAGE EVENT
 *
 **/ self.addEventListener("message", async (ev)=>{
    switch(ev.data.eventName){
        case "APP_PWA_SKIP_WAITING_INTENT":
            // @ts-ignore
            await self.skipWaiting();
            // @ts-ignore
            await self.clients.claim();
            console.log("Service Worker updated to version " + (0, $59e9af023252b064$export$83d89fbfd8236492));
            break;
    }
});
var $6619efc090304cca$export$58c0313f7e281bd1;
(function(VanillaServiceWorkerEventName) {
    VanillaServiceWorkerEventName["APP_PWA_SKIP_WAITING_INTENT"] = "APP_PWA_SKIP_WAITING_INTENT";
})($6619efc090304cca$export$58c0313f7e281bd1 || ($6619efc090304cca$export$58c0313f7e281bd1 = {}));




/**
 * # EPUBStructuralSematicsVocabulary
 *
 * ## RESPONSIBILITIES
 *
 *
 * ## RELATED TYPES
 *
 **/ var $763ee9bb35121c68$export$6ac4214341579ea6;
(function(EPUBStructuralSematicsVocabulary) {
    EPUBStructuralSematicsVocabulary["COMICS_BALLOON"] = "balloon";
    EPUBStructuralSematicsVocabulary["COMICS_PANEL"] = "panel";
    EPUBStructuralSematicsVocabulary["COMICS_PANEL_GROUP"] = "panel-group";
    EPUBStructuralSematicsVocabulary["COMICS_SOUND_AREA"] = "sound-area";
    EPUBStructuralSematicsVocabulary["COMICS_TEXT_AREA"] = "text-area";
})($763ee9bb35121c68$export$6ac4214341579ea6 || ($763ee9bb35121c68$export$6ac4214341579ea6 = {}));


var $7afac31e89fc71f8$export$4db735f0ddc09bb1;
(function(MediaFragmentTypeName) {
    MediaFragmentTypeName["TEMPORAL"] = "t";
    MediaFragmentTypeName["SPATIAL"] = "xywh";
})($7afac31e89fc71f8$export$4db735f0ddc09bb1 || ($7afac31e89fc71f8$export$4db735f0ddc09bb1 = {}));
class $7afac31e89fc71f8$export$6e129b90ac465a0 {
    static parseFragmentSelectorsFromUrl(url) {
        let urlHash = $7afac31e89fc71f8$export$6e129b90ac465a0.getHashFromUrl(url);
        if (!urlHash) {
            console.warn(`MediaFragmentParser.parseFragmentSelectorsFromUrl(), URL "${url}" does not contain any media fragment selectors.`);
            return new Map();
        }
        let fragmentList = urlHash.split("&");
        let selectorPairs = fragmentList.map((item)=>item.split("="));
        let selectorMap = new Map();
        for (const pair of selectorPairs)if (pair.length > 0) selectorMap.set(pair[0], pair[1]);
        return selectorMap;
    }
    static parseSpatialMediaFragmentSelectorFromUrl(url) {
        let urlHash = $7afac31e89fc71f8$export$6e129b90ac465a0.getHashFromUrl(url);
        if (!urlHash || !$7afac31e89fc71f8$export$6e129b90ac465a0.mediaFragmentTypesInUrl(url).includes("xywh")) {
            console.warn(`MediaFragmentParser.parseSpatialMediaFragmentSelectorFromUrl(), URL "${url}" does not contain a spatial media fragment selector.`);
            return;
        }
        let selectorValueOffset = urlHash.indexOf("xywh=") + 5;
        let formatPrefixLength = urlHash.indexOf(":") > 0 ? urlHash.indexOf(":") - selectorValueOffset + 1 : 0;
        let formatPrefixString = formatPrefixLength > 0 ? urlHash.slice(selectorValueOffset, formatPrefixLength) : "percent";
        if (formatPrefixString !== "pixels" && formatPrefixString !== "percent") console.warn(`MediaFragmentParser.parseSpatialMediaFragmentSelectorFromUrl(), format prefix has an invalid value "${formatPrefixString}". Defaulting to "percent".`);
        let format = formatPrefixString === "pixels" || formatPrefixString === "percent" ? formatPrefixString : "percent";
        let coords = urlHash.slice(selectorValueOffset + formatPrefixLength).split(",").map((position)=>{
            return parseFloat(position);
        });
        return {
            format: format,
            x: coords[0],
            y: coords[1],
            width: coords[2],
            height: coords[3]
        };
    }
    static parseTemporalMediaFragmentSelectorFromUrl(url) {
        let urlHash = $7afac31e89fc71f8$export$6e129b90ac465a0.getHashFromUrl(url);
        if (!urlHash || !$7afac31e89fc71f8$export$6e129b90ac465a0.mediaFragmentTypesInUrl(url).includes("t")) {
            console.warn(`MediaFragmentParser.parseTemporalMediaFragmentSelectorFromUrl(), URL "${url}" does not contain a temporal media fragment selector.`);
            return;
        }
        let selectorValueOffset = urlHash.indexOf("t=") + 2;
        let formatPrefixLength = urlHash.indexOf(":") > 0 ? urlHash.indexOf(":") - selectorValueOffset + 1 : 0;
        let timeParams = urlHash.slice(selectorValueOffset + formatPrefixLength).split(",").map((position)=>{
            return parseFloat(position);
        });
        return {
            beginTime: timeParams[0],
            endTime: timeParams[1]
        };
    }
    static mediaFragmentTypesInUrl(url) {
        let urlHash = $7afac31e89fc71f8$export$6e129b90ac465a0.getHashFromUrl(url);
        if (!urlHash) return [];
        let types = [];
        let selectors = urlHash.split("&").map((selector)=>selector.split("="));
        for (let selector of selectors)switch(selector[0]){
            case "t":
            case "xywh":
                types.push(selector[0]);
        }
        return types;
    }
    static getHashFromUrl(url) {
        let hashPosition = url.indexOf("#") + 1;
        return hashPosition > 0 ? url.slice(hashPosition) : undefined;
    }
}


class $8cfd36b7f6dd07b7$export$3b20308943e669dc {
    constructor(_dataNavDocument){
        this._dataNavDocument = _dataNavDocument;
        this.navs = [];
        let navElements = _dataNavDocument.getElementsByTagName("nav");
        for (let navElement of Array.from(navElements)){
            let nav = new $8cfd36b7f6dd07b7$export$3f0152041e82a3a1(navElement);
            if (nav) this.navs.push(nav);
        }
    }
    getXmlDocument() {
        return this._dataNavDocument;
    }
}
class $8cfd36b7f6dd07b7$export$3f0152041e82a3a1 {
    constructor(_navElement){
        this._navElement = _navElement;
        this.regions = [];
        this.title = this._navElement.getAttribute("title") || "";
        let regionGroupElement = this._navElement.querySelector("nav > ol");
        if (regionGroupElement) {
            let regionElements = regionGroupElement.querySelectorAll(":scope > li");
            if (regionElements.length > 0) for (let regionElement of Array.from(regionElements)){
                let region = new $8cfd36b7f6dd07b7$export$b1f97c3099fc6872(regionElement);
                if (region) this.regions.push(region);
            }
        }
    }
    getElement() {
        return this._navElement;
    }
}
class $8cfd36b7f6dd07b7$export$b1f97c3099fc6872 {
    constructor(_regionLiElement){
        this._regionLiElement = _regionLiElement;
        this.metadata = [];
        this.typeName = (0, $763ee9bb35121c68$export$6ac4214341579ea6).COMICS_PANEL;
        this.selectors = new Map();
        this.regions = [];
        const typeNameAttribute = this._regionLiElement.getAttribute("epub:type");
        if (typeNameAttribute && Object.values((0, $763ee9bb35121c68$export$6ac4214341579ea6)).includes(typeNameAttribute)) this.typeName = typeNameAttribute;
        let links = this._regionLiElement.querySelectorAll(":scope > a, :scope > span > a");
        if (links.length > 0) {
            this.uri = links[0].getAttribute("href") || undefined;
            if (this.uri) {
                this.shape = (0, $7afac31e89fc71f8$export$6e129b90ac465a0).parseSpatialMediaFragmentSelectorFromUrl(this.uri);
                this.selectors = (0, $7afac31e89fc71f8$export$6e129b90ac465a0).parseFragmentSelectorsFromUrl(this.uri);
            }
            let metadata = links[0].querySelectorAll(":scope > meta");
            if (metadata.length > 0) for (let data of Array.from(metadata))this.metadata.push({
                property: {
                    name: data.name,
                    namespace: data.namespaceURI || ""
                },
                content: {
                    lang: data.lang,
                    dir: data.dir === "rtl" ? (0, $91ca8664a4c236f4$export$63e1cbbb2c6e2c2).RTL : (0, $91ca8664a4c236f4$export$63e1cbbb2c6e2c2).LTR,
                    value: data.content
                },
                refinedBy: [],
                contentScheme: null
            });
        }
        let subRegionOlElement = this._regionLiElement.querySelector(":scope > ol");
        if (subRegionOlElement) {
            let subRegions = subRegionOlElement.querySelectorAll(":scope > li");
            for (let regionElement of Array.from(subRegions)){
                let region = new $8cfd36b7f6dd07b7$export$b1f97c3099fc6872(regionElement);
                if (region) this.regions.push(region);
            }
        }
    }
    getElement() {
        return this._regionLiElement;
    }
}




class $75832310220f7e41$export$f0651c3f76c1e7a7 {
    constructor(vanillaPublication){
        this._vanillaPublication = vanillaPublication;
    }
    static publicationHasRegionBasedNavigation(vanillaPublication) {
        let srcPublication = vanillaPublication.getColibrioReaderPublication().getSourcePublication();
        return srcPublication.getOpfDocument().querySelector('[properties="data-nav"]') !== null;
    }
    static async create(vanillaPublication) {
        let instance = new $75832310220f7e41$export$f0651c3f76c1e7a7(vanillaPublication);
        let srcPublication = instance._vanillaPublication.getColibrioReaderPublication().getSourcePublication();
        let dataNavManifestElement = srcPublication.getOpfDocument().querySelector('[properties="data-nav"]');
        if (!dataNavManifestElement) throw new Error("VanillaRegionBasedNavigation.create(), No Data Navigation Document found in EPUB OPF manifest.");
        let opfBasePath = srcPublication.getOpfDocumentUrl().pathname.slice(0, srcPublication.getOpfDocumentUrl().pathname.lastIndexOf("/"));
        let dataNavPath = `${opfBasePath}/${dataNavManifestElement.getAttribute("href")}`;
        let dataNavUrl = await instance._vanillaPublication.fetchResourceBlobUrl(dataNavPath);
        if (!dataNavUrl) throw new Error(`VanillaRegionBasedNavigation.create(), Unable to create Blob URL for file "${dataNavPath}".`);
        let dataNavResponse = await fetch(dataNavUrl);
        if (!dataNavResponse) throw new Error(`VanillaRegionBasedNavigation.create(), Unable to fetch XHTML document for file "${dataNavPath}".`);
        let domParser = new DOMParser();
        let dataNavDom = domParser.parseFromString(await dataNavResponse.text(), "text/html");
        if (!dataNavDom) throw new Error(`VanillaRegionBasedNavigation.create(), Unable to parse XHTML source for file "${dataNavPath}".`);
        instance._navigationDocument = new (0, $8cfd36b7f6dd07b7$export$3b20308943e669dc)(dataNavDom);
        return instance;
    }
    toGuidedReadingTimelineData() {
        let stepData = [];
        if (!this._navigationDocument || !this._vanillaPublication) throw new Error(`VanillaRegionBasedNavigation.toGuidedReadingTimelineData(), VanillaRegionBasedNavigation instance has not been created.".`);
        const mapRegionsToSteps = (regions)=>{
            let steps = [];
            let childSteps = [];
            for (const region of regions){
                childSteps = [];
                let mediaObjects = [];
                let alternateAudioMetaDataItem;
                let matchingSpineItem = this._vanillaPublication?.getColibrioReaderPublication().getSpine().find((spineItem)=>{
                    return region.uri !== undefined ? spineItem.getSourceContentDocument().getContentUrl().pathname.includes(region.uri.slice(0, region.uri.indexOf("#"))) : false;
                });
                if (!matchingSpineItem) continue;
                if (region.regions.length > 0) childSteps = mapRegionsToSteps(region.regions);
                mediaObjects = [
                    {
                        mediaType: (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_EPUB_ZIP,
                        url: matchingSpineItem.getContentLocation().getLocator().toString(),
                        selectors: region.selectors || []
                    }
                ];
                alternateAudioMetaDataItem = region.metadata.find((item)=>item.property.name === "alternate");
                if (alternateAudioMetaDataItem) mediaObjects.push({
                    mediaType: (0, $ba5c9d217d86588f$export$483c11740a902fcd).AUDIO_MPEG,
                    url: alternateAudioMetaDataItem.content.value,
                    selectors: (0, $7afac31e89fc71f8$export$6e129b90ac465a0).parseFragmentSelectorsFromUrl(alternateAudioMetaDataItem.content.value)
                });
                steps.push({
                    locator: matchingSpineItem.getContentLocation().getLocator().toString(),
                    stepType: region.typeName || (0, $763ee9bb35121c68$export$6ac4214341579ea6).COMICS_PANEL,
                    mediaObjects: mediaObjects,
                    steps: childSteps || []
                });
            }
            return steps;
        };
        this._navigationDocument.navs.forEach((nav)=>{
            stepData = mapRegionsToSteps(nav.regions);
        });
        return {
            publicationId: this._vanillaPublication.id,
            steps: stepData,
            tracks: []
        };
    }
    getDataNavDocument() {
        return this._navigationDocument;
    }
}








class $4b0f0beaf72b13b4$export$a2e9d5d692146718 {
    constructor(_hostElement, _readerViewElement, insertPosition = "afterbegin", _transitionOptions, _backgroundColor = "#000000"){
        this._hostElement = _hostElement;
        this._readerViewElement = _readerViewElement;
        this._transitionOptions = _transitionOptions;
        this._backgroundColor = _backgroundColor;
        this._style = `
        <style>            
        :root {
              --vanilla-reader__guided-reading-content-mask__clip-box-top: 0;
              --vanilla-reader__guided-reading-content-mask__clip-box-left: 0;
              --vanilla-reader__guided-reading-content-mask__clip-box-bottom: 100%;
              --vanilla-reader__guided-reading-content-mask__clip-box-right: 100%;            

        }
            #vanilla-reader__guided-reading-content-mask {
                display: none;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                pointer-events: none;
                touch-action: none;
                background-color: black;
                mix-blend-mode: multiply;                
                z-index: 1;
                clip-path: polygon( evenodd,
                    /* overlay rect */
                    0 0,
                    100% 0,
                    100% 100%,
                    0% 100%,
                    0 0,
                    /* ruler clip rect */
                    var(--vanilla-reader__guided-reading-content-mask__clip-box-left) var(--vanilla-reader__guided-reading-content-mask__clip-box-top),
                    var(--vanilla-reader__guided-reading-content-mask__clip-box-right) var(--vanilla-reader__guided-reading-content-mask__clip-box-top),
                    var(--vanilla-reader__guided-reading-content-mask__clip-box-right) var(--vanilla-reader__guided-reading-content-mask__clip-box-bottom),
                    var(--vanilla-reader__guided-reading-content-mask__clip-box-left) var(--vanilla-reader__guided-reading-content-mask__clip-box-bottom),
                    var(--vanilla-reader__guided-reading-content-mask__clip-box-left) var(--vanilla-reader__guided-reading-content-mask__clip-box-top)             
                );
                opacity: 0;                
            }

        </style>
    `;
        this._template = `
        <div id="vanilla-reader__guided-reading-content-mask" aria-hidden="true"></div>
    `;
        this._animationDuration = 600;
        this._animate = true;
        this._animationDuration = this._transitionOptions.animationOptions?.durationMs || this._animationDuration;
        this._hostElement.insertAdjacentHTML(insertPosition, this._style);
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._initialHostElementBackgroundColor = this._hostElement.style.backgroundColor;
        this._contentMaskElement = this._hostElement.querySelector("#vanilla-reader__guided-reading-content-mask");
    }
    get backgroundColor() {
        return this._backgroundColor;
    }
    set backgroundColor(color) {
        this._backgroundColor = color;
        this._hostElement.style.backgroundColor = this._backgroundColor;
    }
    get isVisible() {
        return this._contentMaskElement.style.display === "block";
    }
    get currentMaskedRect() {
        return this._currentMaskedRect;
    }
    onTransitionStarted(callback) {
        this._onTransitionStartedCallback = callback;
    }
    onTransitionEnded(callback) {
        this._onTransitionEndedCallback = callback;
    }
    show() {
        this._hostElement.style.backgroundColor = this._backgroundColor;
        this._contentMaskElement.style.display = "block";
        this._contentMaskElement.style.opacity = "1";
    }
    hide() {
        this._hostElement.style.backgroundColor = this._initialHostElementBackgroundColor;
        this._contentMaskElement.style.opacity = "0";
        setTimeout(()=>{
            this._contentMaskElement.style.display = "none";
        }, this._animationDuration);
    }
    resizeRelative(sourceRect, visiblePageRect, clampToCenter = true, transformOptions) {
        if (this._onTransitionStartedCallback) this._onTransitionStartedCallback();
        this._currentMaskedRect = sourceRect;
        let targetHeight = sourceRect.height / 100 * visiblePageRect.height;
        let targetWidth = sourceRect.width / 100 * visiblePageRect.width;
        let targetX = sourceRect.x / 100 * visiblePageRect.width + visiblePageRect.x;
        let targetY = sourceRect.y / 100 * visiblePageRect.height + visiblePageRect.y;
        if (clampToCenter) {
            targetX = (this._readerViewElement.clientWidth - targetWidth) / 2;
            targetY = (this._readerViewElement.clientHeight - targetHeight) / 2;
        }
        let targetRect = new DOMRect(targetX, targetY, targetWidth, targetHeight);
        this._moveAndScaleMaskRect(targetRect, (0, $91ca8664a4c236f4$export$8cba090a009adf02).CSS_PIXELS, transformOptions);
        setTimeout(()=>{
            if (this._onTransitionEndedCallback) this._onTransitionEndedCallback();
        }, transformOptions.animationOptions?.durationMs || 600);
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ _moveAndScaleMaskRect(rect, unit = (0, $91ca8664a4c236f4$export$8cba090a009adf02).CSS_PIXELS, transformOptions) {
        let unitStr = unit === (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT ? "%" : "px";
        let durationMs = transformOptions.animationOptions?.durationMs ?? this._animationDuration;
        if (this._animate) this._contentMaskElement.style.transition = `clip-path ${durationMs}ms ease-in-out 0s, opacity ${durationMs}ms ease 0s`;
        else this._contentMaskElement.style.transition = `opacity ${durationMs}ms ease 0s`;
        this._contentMaskElement.style.setProperty("--vanilla-reader__guided-reading-content-mask__clip-box-left", `${rect.left}${unitStr}`);
        this._contentMaskElement.style.setProperty("--vanilla-reader__guided-reading-content-mask__clip-box-top", `${rect.top + 1}${unitStr}`);
        this._contentMaskElement.style.setProperty("--vanilla-reader__guided-reading-content-mask__clip-box-right", `${rect.right}${unitStr}`);
        this._contentMaskElement.style.setProperty("--vanilla-reader__guided-reading-content-mask__clip-box-bottom", `${rect.bottom - 1}${unitStr}`);
    }
}



class $b4601f8085fda0ed$export$a36e6f22067dfee8 {
    constructor(timelineStepData, _onStepAddedCallback){
        this._onStepAddedCallback = _onStepAddedCallback;
        this.steps = [];
        this.stepType = timelineStepData.stepType;
        this.locator = timelineStepData.locator;
        this.mediaObjects = timelineStepData.mediaObjects;
        this.steps = [];
        timelineStepData.steps?.forEach((stepData)=>{
            let step = this._createStepFromData(stepData);
            this.steps.push(step);
        });
    }
    _createStepFromData(stepData) {
        let stepList = [];
        const onStepAdded = (step)=>{
            stepList.push(step);
        };
        let newStep = new $b4601f8085fda0ed$export$a36e6f22067dfee8(stepData, onStepAdded);
        if (this._onStepAddedCallback) {
            this._onStepAddedCallback(newStep);
            for (let step of stepList)this._onStepAddedCallback(step);
        }
        return newStep;
    }
}
class $b4601f8085fda0ed$export$21afd5bd8fe5314b {
    constructor(timelineData){
        this._steps = [];
        this._stepsListFlat = [];
        this.publicationId = timelineData.publicationId;
        timelineData.steps.forEach((step)=>{
            this._steps.push(this._createStepsFromData(step));
        });
    }
    getStep(index) {
        return this._stepsListFlat[index];
    }
    getSteps() {
        return this._stepsListFlat;
    }
    getStepsByMediaType(stepType) {
        return this._stepsListFlat.filter((step)=>step.stepType === stepType);
    }
    getStepsByMediaObjectType(mediaObjectType) {
        return this._stepsListFlat.filter((step)=>step.mediaObjects.filter((mediaObjectData)=>{
                mediaObjectData.mediaType;
            }));
    }
    _createStepsFromData(stepData) {
        let childSteps = [];
        let newStep = new $b4601f8085fda0ed$export$a36e6f22067dfee8(stepData, (childStep)=>{
            childSteps.push(childStep);
        });
        this._stepsListFlat.push(newStep);
        this._stepsListFlat.push(...childSteps);
        return newStep;
    }
}


class $afbd0b1961a6b545$export$2c59f4c127470deb {
    constructor(_hostElement, insertPosition = "afterbegin"){
        this._hostElement = _hostElement;
        this._template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-mask-toggle" type="button" title="Toggle Guided Reading mask overlay" aria-hidden="true"><span class="vanilla-reader__fab__icon" id="vanilla-reader__fab-mask-toggle__icon" aria-hidden="true">crop</span></button>`;
        this._isActive = false;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._toggleButton = this._hostElement.querySelector("#vanilla-reader__fab-mask-toggle");
        this._toggleButtonIcon = this._hostElement.querySelector("#vanilla-reader__fab-mask-toggle__icon");
        this._toggleButton.addEventListener("click", (ev)=>{
            ev.preventDefault();
            ev.stopImmediatePropagation();
            if (this._onClickCallback) {
                if (this.isVisible) {
                    this._isActive = !this._isActive;
                    let icon = this._isActive ? "fullscreen" : "crop";
                    this._toggleButtonIcon.innerText = icon;
                    this._onClickCallback();
                }
            }
        });
    }
    get isVisible() {
        return !this._toggleButton.hasAttribute("aria-hidden");
    }
    show() {
        this._toggleButton.removeAttribute("aria-hidden");
        this._toggleButton.style.display = "flex";
        this._toggleButton.style.opacity = "1";
        this._toggleButton.style.pointerEvents = "all";
        if (this._onVisibleCallback) this._onVisibleCallback();
    }
    hide() {
        this._toggleButton.setAttribute("aria-hidden", "true");
        this._toggleButton.style.opacity = "0";
        this._toggleButton.style.pointerEvents = "none";
        setTimeout(()=>{
            this._toggleButton.style.display = "none";
        }, 200);
        if (this._onHiddenCallback) this._onHiddenCallback();
    }
    getComponentElement() {
        return this._toggleButton;
    }
    onClick(callback) {
        this._onClickCallback = callback;
    }
    onVisible(callback) {
        this._onVisibleCallback = callback;
    }
    onHidden(callback) {
        this._onHiddenCallback = callback;
    }
}



class $9beae0d98045fa9d$export$7242deb600c36eb4 {
    constructor(_hostElement, insertPosition = "afterbegin"){
        this._hostElement = _hostElement;
        this._template = `<button class="vanilla-reader__fab" id="vanilla-reader__fab-guided-reading-player-toggle" type="button" title="Toggle Guided Reading mode" aria-hidden="true"><span class="vanilla-reader__fab__icon" id="vanilla-reader__fab-guided-reading-player-toggle__icon" aria-hidden="true">near_me</span></button>`;
        this._isActive = false;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._toggleButton = this._hostElement.querySelector("#vanilla-reader__fab-guided-reading-player-toggle");
        this._toggleButtonIcon = this._hostElement.querySelector("#vanilla-reader__fab-guided-reading-player-toggle__icon");
        this._toggleButton.addEventListener("click", (ev)=>{
            ev.preventDefault();
            ev.stopImmediatePropagation();
            if (this._onClickCallback) {
                if (this.isVisible) {
                    this._isActive = !this._isActive;
                    this._toggleButtonIcon.innerText = this._isActive ? "near_me_disabled" : "near_me";
                    this._onClickCallback();
                }
            }
        });
    }
    get isVisible() {
        return !this._toggleButton.hasAttribute("aria-hidden");
    }
    get active() {
        return this._isActive;
    }
    set active(state) {
        this._isActive = state;
        this._setActiveState(state);
    }
    show() {
        this._toggleButton.removeAttribute("aria-hidden");
        this._toggleButton.style.display = "flex";
        this._toggleButton.style.opacity = "1";
        this._toggleButton.style.pointerEvents = "all";
        if (this._onVisibleCallback) this._onVisibleCallback();
    }
    hide() {
        this._toggleButton.setAttribute("aria-hidden", "true");
        this._toggleButton.style.opacity = "0";
        this._toggleButton.style.pointerEvents = "none";
        setTimeout(()=>{
            this._toggleButton.style.display = "none";
        }, 200);
        if (this._onHiddenCallback) this._onHiddenCallback();
    }
    getComponentElement() {
        return this._toggleButton;
    }
    onClick(callback) {
        this._onClickCallback = callback;
    }
    onVisible(callback) {
        this._onVisibleCallback = callback;
    }
    onHidden(callback) {
        this._onHiddenCallback = callback;
    }
    _setActiveState(state) {
        this._toggleButtonIcon.innerText = state ? "near_me_disabled" : "near_me";
    }
}






class $be9eb0f62edacece$export$e63b70b2fbf96f2c {
    constructor(_vanillaReaderAppMain, _timelineData){
        this._vanillaReaderAppMain = _vanillaReaderAppMain;
        this._timelineData = _timelineData;
        this._isActive = false;
        this._activeStepIndex = -1;
        this._playingAudioMap = new Map();
        this._loadedAudioMediaObjectElementsMap = new Map();
        this._timelineAudioMediaObjectMap = new Map();
        this._latestPointerUpEventTimeoutHandle = undefined;
        this._highlightActiveStep = true;
        this._debugMode = false;
        this._initialUseReducedMotionState = true;
        this._initialPanZoomShouldShowExitButtonState = true;
        this._event_viewTransformStopped = (ev)=>{
            this._currentVisiblePageRects = ev.detail.transformData?.visiblePageClientRects;
            // If the user has turned on guided reading, the current masked area should transform along with the publication
            // viewport
            if (ev.detail.transformData?.visiblePageClientRects && this._guidedReadingContentMask?.isVisible && ev.detail.transformData?.zoomTargetClientRect) {
                let animationDurationMs = this._initialVanillaReaderViewOptionsState?.useReducedMotion ? 0 : 600;
                let clampToCenter = false;
                if (ev.detail.transformData && ev.detail.transformData.transformData?.animating) clampToCenter = true;
                if (ev.detail.transformData?.transformData?.userGestureActive) animationDurationMs = 0;
                this.moveAndResizeMaskLayerRect(ev.detail.transformData.zoomTargetClientRect, animationDurationMs, clampToCenter);
            }
        };
        this._event_publicationCloseIntent = ()=>{
            this.stop();
        };
        this._event_visiblePagesChanged = (ev)=>{
            if (!this._isActive) return;
            if (ev.detail.visibleRangeData?.locator) {
                let pageLocator = ev.detail.visibleRangeData.locator.toString();
                let initialPageStep = this._getInitialStepForLocator(pageLocator);
                // If the timeline has steps for this page, and the page locator is not equal to the active step
                // locator, this means that the navigation was not made using the player's navigation methods.
                if (initialPageStep && initialPageStep.locator != this._activeStep?.locator) {
                    this.seekToInitialStepForLocator(ev.detail.visibleRangeData.locator.toString());
                    let visiblePageRect = this._vanillaReader?.vanillaReaderView?.getVisiblePagesBoundingClientRects()[0];
                    if (visiblePageRect) this._goToAndZoom(initialPageStep).catch(console.warn);
                    else console.warn("VanillaReaderGuidedReadingPlayer.constructor: VISIBLE_PAGES_CHANGED, unable to get a rect for the visible page.");
                } else this._vanillaReader?.vanillaReaderView?.resetViewTransformation();
            }
        };
        this._event_pointerDown = (ev)=>{
            ev.preventDefault();
        };
        this._event_pointerUp = (ev)=>{
            ev.preventDefault();
            if (this._latestPointerUpEventTimeoutHandle === undefined) this._latestPointerUpEventTimeoutHandle = setTimeout(()=>{
                this._event_click(ev);
                this._latestPointerUpEventTimeoutHandle = undefined;
            }, 300);
            else {
                clearTimeout(this._latestPointerUpEventTimeoutHandle);
                this._latestPointerUpEventTimeoutHandle = undefined;
                this._event_doubleClick(ev);
            }
        };
        this._event_click = (ev)=>{
            if (ev.readerDocumentEventState === (0, $f8f5cf2c043414f4$export$ce06c08e13a84fea).PROCESSED) return;
            if (ev.clientX < document.documentElement.clientWidth / 2) this.previous().catch(console.warn);
            else this.next().catch(console.warn);
        };
        this._event_doubleClick = (ev)=>{
            if (this._vanillaReader?.vanillaReaderView?.activeTransformData && this._vanillaReader?.vanillaReaderView.activeTransformData.publicationViewportScale > 1.1) return;
            let locator = ev.readerView.getReadingPosition()?.getLocator();
            if (!locator) {
                console.warn("VanillaReaderGuidedReadingPlayer._event_doubleClick(), Unable to get a valid locator from ReaderView");
                return;
            }
            let step = this.getNearestStepByPageLocatorAndPoint(locator.toString(), ev.relativeClientX, ev.relativeClientY);
            if (!step) {
                console.warn("VanillaReaderGuidedReadingPlayer._event_doubleClick(), Unable to get a step for positions ", ev.relativeClientX, ev.relativeClientY);
                return;
            }
            this._performStepAction(step).catch();
        };
        this._event_keyUp = (ev)=>{
            let key = ev.key;
            switch(key){
                case (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).ArrowUp:
                    this.next().catch(console.warn);
                    break;
                case (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).ArrowDown:
                    this.previous().catch(console.warn);
                    break;
                case (0, $83aeb96f47fc070f$export$cd0f44441c3b7719).Escape:
                    this._stopAllAudioMediaObjectPlayback();
                    break;
            }
        };
        this._engineEvent_keyUp = (ev)=>{
            if (ev.readerDocumentEventState === (0, $f8f5cf2c043414f4$export$ce06c08e13a84fea).PROCESSED) return;
            this._event_keyUp(ev);
        };
        this._getSpineIndexFromLocator = (locator)=>{
            let cfiPrefix = "#epubcfi(/6/";
            return parseInt(locator.slice(locator.indexOf(cfiPrefix) + cfiPrefix.length, locator.indexOf("!")));
        };
        this._event_onDocumentVisibilityChanged = ()=>{
            return;
        };
        this._vanillaReader = this._vanillaReaderAppMain.getVanillaReaderInstance();
        this._vanillaReaderUi = this._vanillaReaderAppMain.getVanillaReaderUiInstance();
        if (!this._vanillaReader || !this._vanillaReaderUi) throw new Error("VanillaReaderGuidedReadingPlayer.constructor(), VanillaReaderAppMain is not correctly set up.");
        this._timeline = new (0, $b4601f8085fda0ed$export$21afd5bd8fe5314b)(this._timelineData);
        this.buttonTogglePlayer = new (0, $9beae0d98045fa9d$export$7242deb600c36eb4)(this._vanillaReaderUi?.vanillaReaderFabContainerElement);
        this.buttonTogglePlayer.onClick(()=>{
            if (!this._isActive) this.start();
            else this.stop();
        });
        this.buttonTogglePlayer.show();
        this.buttonTogglePanelMask = new (0, $afbd0b1961a6b545$export$2c59f4c127470deb)(this._vanillaReaderUi?.vanillaReaderFabContainerElement);
        this.buttonTogglePanelMask.onClick(()=>{
            if (this._guidedReadingContentMask) {
                if (this._guidedReadingContentMask.isVisible) this.hideMaskLayer();
                else this.showMaskLayer();
            }
        });
        this._timeline.getStepsByMediaObjectType((0, $ba5c9d217d86588f$export$483c11740a902fcd).AUDIO_MPEG).forEach((step)=>{
            let mediaObjectDataList = step.mediaObjects.filter((mediaObject)=>mediaObject.mediaType === (0, $ba5c9d217d86588f$export$483c11740a902fcd).AUDIO_MPEG);
            if (mediaObjectDataList.length > 0) mediaObjectDataList.forEach((mediaObjectData)=>this._timelineAudioMediaObjectMap.set(step, mediaObjectData));
        });
        this._preloadAudioMediaObject(Array.from(this._timelineAudioMediaObjectMap.values())).catch(console.warn);
    }
    set debugMode(inDebugMode) {
        this._debugMode = inDebugMode;
    }
    get debugMode() {
        return this._debugMode;
    }
    get activeStepIndex() {
        return this._activeStepIndex;
    }
    get activeStep() {
        return this._activeStep;
    }
    static create(vanillaReaderAppMain, timelineData) {
        return new $be9eb0f62edacece$export$e63b70b2fbf96f2c(vanillaReaderAppMain, timelineData);
    }
    start() {
        if (!this._vanillaReader || !this._vanillaReader.vanillaReaderView || !this._vanillaReaderUi) throw new Error("VanillaReaderGuidedReadingPlayer.start(), Unable to get a reference to the VanillaReaderView instance.");
        this._activeStepAnnotationLayer = this._vanillaReader?.vanillaReaderView?.colibrioReaderView.createAnnotationLayer("guidedReadingPlayerActiveStep");
        if (this._activeStepAnnotationLayer && this.debugMode) {
            this._activeStepAnnotationLayer.setDefaultAnnotationOptions({
                containerClassName: "vanilla-reader__guided-reading-player__active-step",
                containerStyle: {
                    "border-color": (0, $6c430f2d57d8d4ff$export$e84536440c3ffd38).readingRulerColorValues.green,
                    "border-style": "solid",
                    "border-radius": "4px",
                    "padding": "2px",
                    "margin-top": "-2px",
                    "margin-left": "-2px",
                    "opacity": "0.5"
                }
            });
            this._activeStepAnnotationLayer.setLayerOptions({
                annotationInputEngineEventsEnabled: false,
                layerStyle: {
                    "mix-blend-mode": "multiply"
                }
            });
            this._activeStepAnnotationLayer.setVisible(true);
        }
        this._initialPanZoomShouldShowExitButtonState = this._vanillaReaderUi?.panZoomTool.shouldShowExitButton;
        this._initialUseReducedMotionState = this._vanillaReader?.vanillaReaderView.useReducedMotion;
        //this._initialNarrationState = this._vanillaReader?.vanillaMediaPlayer?.playerIsAttachedToView || false;
        if (this._vanillaReaderUi) this._vanillaReaderUi.panZoomTool.shouldShowExitButton = false;
        // Grab the current options for the VanillaReaderView so that we can reset them when we exit the guided reading mode.
        this._initialVanillaReaderViewOptionsState = this._vanillaReader?.vanillaReaderView.getCurrentVanillaReaderViewOptionsState();
        window.addEventListener("keyup", this._event_keyUp);
        (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance?.onVisiblePagesChanged(this._event_visiblePagesChanged);
        (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance?.onViewTransformStopped(this._event_viewTransformStopped);
        this.buttonTogglePanelMask.show();
        this._configureVanillaReader();
        this._isActive = true;
        this._vanillaReaderUi?.toaster.toast("Started Guided Reading Mode (Experimental).\n\nUse the UP and DOWN arrows to move through panels.\n\nPress ESC to silence narration.", true, 3000).catch();
        document.addEventListener("visibilitychange", this._event_onDocumentVisibilityChanged);
    }
    stop(paused = false) {
        if (this._activeStepAnnotationLayer) this._vanillaReader?.vanillaReaderView?.colibrioReaderView.destroyAnnotationLayer(this._activeStepAnnotationLayer);
        this._stopAllAudioMediaObjectPlayback();
        this._resetVanillaReaderConfiguration();
        this._removeLocalStorageState();
        window.removeEventListener("keyup", this._event_keyUp);
        document.removeEventListener("visibilitychange", this._event_onDocumentVisibilityChanged);
        (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).removeEventListener("VISIBLE_PAGES_CHANGED", this._event_visiblePagesChanged);
        (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).removeEventListener("VIEW_TRANSFORM_STOPPED", this._event_viewTransformStopped);
        this.buttonTogglePanelMask.hide();
        this.hideMaskLayer();
        if (this._vanillaReaderUi) this._vanillaReaderUi.panZoomTool.shouldShowExitButton = this._initialPanZoomShouldShowExitButtonState;
        if (!paused) this._isActive = false;
        this._vanillaReaderUi?.toaster.toast("Ended Guided Reading Mode", true).catch();
        this.buttonTogglePlayer.active = false;
    }
    createMaskLayer(hostElement) {
        let readerViewElement = this._vanillaReader?.vanillaReaderView?.colibrioReaderView.getElement();
        if (!readerViewElement) throw new Error("VanillaReaderGuidedReadingPlayer.createMaskLayer(), Could not create mask layer. No ReaderView has been created.");
        this._guidedReadingContentMask = new (0, $4b0f0beaf72b13b4$export$a2e9d5d692146718)(hostElement, readerViewElement, "beforeend", {});
        if (!this._guidedReadingContentMask) throw new Error("VanillaReaderGuidedReadingPlayer.createMaskLayer(), Could not create mask layer. VanillaReaderUiGuidedReadingContentMask constructor failed.");
    }
    moveAndResizeMaskLayerRect(rect, animationDuration = 600, clampToCenter = true) {
        if (!this._guidedReadingContentMask) return;
        if (!this._currentVisiblePageRects || this._currentVisiblePageRects.length < 1) {
            console.warn("VanillaReaderGuidedReadingPlayer.moveAndMaskLayerRect(), No visible page rects have been set.");
            return;
        }
        let transformOptions = {
            animationOptions: {
                easing: (0, $f8f5cf2c043414f4$export$7d260260b1058ee8).MATERIAL_DECELERATION_CURVE,
                animationDuration: animationDuration
            }
        };
        this._guidedReadingContentMask.resizeRelative(rect, this._currentVisiblePageRects[0], clampToCenter, transformOptions);
    }
    showMaskLayer() {
        let palette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === "ContrastDark");
        if (this._vanillaReaderUi) this._vanillaReaderUi.vanillaReaderUIElement.style.backgroundColor = palette.backgroundLight || "#000";
        this._guidedReadingContentMask?.show();
        if (this.activeStep) {
            let rect = this._getRectFromStepData(this.activeStep);
            if (rect) this.moveAndResizeMaskLayerRect(rect);
        }
    }
    hideMaskLayer() {
        let defaultPalette = (0, $5340a9bdc44a0542$export$fbea20b286778a79).ColorThemes.find((palette)=>palette.name === "Default");
        if (this._vanillaReaderUi) this._vanillaReaderUi.vanillaReaderUIElement.style.backgroundColor = defaultPalette.backgroundLight || "#fff";
        this._guidedReadingContentMask?.hide();
    }
    pageLocatorHasSteps(locator) {
        return this._timelineHasStepsForPageIndex(this._getSpineIndexFromLocator(locator));
    }
    async goToIndex(index) {
        if (index >= this._timeline.getSteps().length) console.warn("VanillaReaderGuidedReadingTimeline.goToIndex(), index exceeds the number of available steps.");
        let activeStepIndex = index;
        let step = this._timeline.getStep(activeStepIndex);
        await this._performStepAction(step);
        return step;
    }
    seekToInitialStepForLocator(locator) {
        if (!this.pageLocatorHasSteps(locator)) {
            console.warn(`Page with locator ${locator} has no steps in the timeline.`);
            return;
        }
        let step = this._getInitialStepForLocator(locator);
        let stepIndex = this._getInitialStepIndexForLocator(locator);
        if (step && stepIndex >= 0) {
            this._setActiveStep(step);
            this._activeStepIndex = stepIndex;
        }
    }
    async next() {
        let activeStepIndex = this._activeStepIndex < this._timeline.getSteps().length - 1 ? this._activeStepIndex + 1 : this._activeStepIndex;
        let step = this._timeline.getStep(activeStepIndex);
        await this._performStepAction(step);
        return step;
    }
    async previous() {
        let activeStepIndex = this._activeStepIndex <= 0 ? 0 : this._activeStepIndex - 1;
        let step = this._timeline.getStep(activeStepIndex);
        await this._performStepAction(step);
        return step;
    }
    async getNearestVisibleStepByContentLocation(contentLocation) {
        let rectData = await this._vanillaReader?.vanillaReaderView?.fetchVisibleContentRectDataForContentLocation(contentLocation);
        if (!rectData || rectData.length < 1) {
            console.warn("VanillaReaderGuidedReadingPlayer.getNearestVisibleStepByContentLocation(), Did not find any intersecting Steps for content location.");
            return undefined;
        }
        return this.getNearestStepByPageLocatorAndPoint(contentLocation.getLocator().toString(), rectData[0].clientRect.x, rectData[0].clientRect.y);
    }
    //TODO: Also take into account step order?
    getNearestStepByPageLocatorAndPoint(pageLocator, x, y) {
        let steps = this._getStepsForLocator(pageLocator);
        if (!steps) return;
        // Make sure it's percent values and not fractions
        x = x < 1 ? x * 100 : x;
        y = y < 1 ? y * 100 : y;
        let nearestStep = new Map();
        steps.forEach((step)=>{
            let epubMediaObject = step.mediaObjects.find((media)=>media.mediaType === (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_EPUB_ZIP);
            if (!epubMediaObject) return;
            let spatialSelector = epubMediaObject.selectors.get("xywh");
            if (!spatialSelector) return;
            let mediaObjectRect = this._parseSpatialMediaFragmentSelectorValue(spatialSelector);
            if (!mediaObjectRect) return;
            if (nearestStep.size === 0) nearestStep.set(step, mediaObjectRect.width * mediaObjectRect.height);
            let xIntersects = x >= mediaObjectRect.x && x <= mediaObjectRect.x + mediaObjectRect.width;
            let yIntersects = y >= mediaObjectRect.y && y <= mediaObjectRect.y + mediaObjectRect.height;
            if (xIntersects && yIntersects) {
                let currentNearestRectArea = Array.from(nearestStep.values())[0];
                if (currentNearestRectArea) {
                    if (mediaObjectRect.width * mediaObjectRect.height < currentNearestRectArea) {
                        nearestStep.clear();
                        nearestStep.set(step, mediaObjectRect.width * mediaObjectRect.height);
                    }
                }
            }
        });
        return Array.from(nearestStep.keys())[0];
    }
    /**
     *
     * PRIVATE METHODS
     *
     * */ async fetchContentLocationRangeFromVisibleRect(targetRect, targetRectUsesRelativeCoords = true, featherInPx = 10) {
        let containedContentLocations = await this.fetchContentLocationsFromVisibleRect(targetRect, targetRectUsesRelativeCoords, featherInPx);
        if (!containedContentLocations || containedContentLocations.length < 1) return;
        return containedContentLocations[0].createRangeTo(containedContentLocations[containedContentLocations.length - 1]);
    }
    async fetchContentLocationsFromVisibleRect(targetRect, targetRectUsesRelativeCoords = true, featherInPx = 0) {
        let viewTransformData = this._vanillaReader?.vanillaReaderView?.colibrioReaderView.getTransformManager().getActiveTransform();
        let viewScale = viewTransformData?.scale || 1;
        let transformedTargetRect;
        let visiblePage = this._vanillaReader?.vanillaReaderView?.colibrioReaderView.getVisiblePages()[0];
        let pageRect = visiblePage?.getBoundingClientRect();
        if (!visiblePage || !pageRect) {
            console.warn("VanillaReaderGuidedReadingPlayer.fetchContentLocationsFromVisibleRect(), Unable to get the bounding client rects for the visible page.");
            return;
        }
        if (targetRectUsesRelativeCoords) transformedTargetRect = {
            height: pageRect.height * (targetRect.height / 100),
            width: pageRect.width * (targetRect.width / 100),
            x: pageRect.width * (targetRect.x / 100) + pageRect.x - featherInPx,
            y: pageRect.height * (targetRect.y / 100) + pageRect.y - featherInPx
        };
        else transformedTargetRect = {
            x: targetRect.x * viewScale,
            y: targetRect.y * viewScale,
            width: targetRect.width * viewScale,
            height: targetRect.height * viewScale
        };
        let transformedTargetRectBottom = transformedTargetRect.y + transformedTargetRect.height + featherInPx * 2;
        let transformedTargetRectRight = transformedTargetRect.x + transformedTargetRect.width + featherInPx * 2;
        if (this.debugMode) {
            let currentZoomRect = document.documentElement.querySelector("#zoomrect");
            currentZoomRect?.remove();
            let documentElement = document.documentElement.querySelector("#vanilla-reader__reader-view");
            let zoomRectElement = document.createElement("div");
            zoomRectElement.id = "zoomrect";
            zoomRectElement.style.position = `absolute`;
            zoomRectElement.style.top = `${transformedTargetRect.y}px`;
            zoomRectElement.style.left = `${transformedTargetRect.x}px`;
            zoomRectElement.style.height = `${transformedTargetRect.height + featherInPx * 2}px`;
            zoomRectElement.style.width = `${transformedTargetRect.width + featherInPx * 2}px`;
            zoomRectElement.style.backgroundColor = "orange";
            zoomRectElement.style.opacity = "0.5";
            zoomRectElement.style.zIndex = "3";
            documentElement.appendChild(zoomRectElement);
        }
        let containedRects = (await this._vanillaReader?.vanillaReaderView?.colibrioReaderView.fetchRectsForVisibleContent(visiblePage))?.rects.filter((rectData)=>{
            let isContainedWithin = false;
            let visibleContentClientRect = rectData.clientRect;
            let topIntersects = visibleContentClientRect.y <= transformedTargetRectBottom && visibleContentClientRect.y >= transformedTargetRect.y;
            let bottomIntersects = visibleContentClientRect.bottom >= transformedTargetRect.y && visibleContentClientRect.bottom <= transformedTargetRectBottom;
            let leftIntersects = visibleContentClientRect.left >= transformedTargetRect.x && visibleContentClientRect.x <= transformedTargetRectRight;
            let rightIntersects = visibleContentClientRect.right <= transformedTargetRectRight && visibleContentClientRect.right >= transformedTargetRect.x;
            isContainedWithin = topIntersects && bottomIntersects && leftIntersects && rightIntersects;
            if (this._activeStepAnnotationLayer && isContainedWithin && this.debugMode) {
                let annotation = this._activeStepAnnotationLayer?.createAnnotation(rectData.contentLocation.getLocator());
                annotation?.setOptions({
                    containerStyle: {
                        "border-left": leftIntersects ? "1px solid orange" : "1px solid transparent",
                        "border-right": rightIntersects ? "1px solid orange" : "1px solid transparent",
                        "border-top": topIntersects ? "1px solid orange" : "1px solid transparent",
                        "border-bottom": bottomIntersects ? "1px solid orange" : "1px solid transparent"
                    }
                });
            }
            return isContainedWithin;
        });
        return containedRects?.map((rect)=>rect.contentLocation);
    }
    _setActiveStep(step) {
        this._previousStep = this.activeStep;
        this._activeStep = step;
        if (this._highlightActiveStep && this._activeStepAnnotationLayer && !this._guidedReadingContentMask?.isVisible) {
            let stepRect = this._getRectFromStepData(step);
            if (!stepRect) return;
            this._activeStepAnnotationLayer.destroyAllAnnotations();
            let stepAnnotation = this._activeStepAnnotationLayer.createAnnotation(step.locator);
            stepAnnotation.setOptions({
                containerStyle: {
                    top: `${stepRect.y}%`,
                    left: `${stepRect.x}%`,
                    width: `${stepRect.width}%`,
                    height: `${stepRect.height}%`
                }
            });
        }
    }
    _getRectFromStepData(step) {
        let epubMediaObject = step.mediaObjects.find((media)=>media.mediaType === (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_EPUB_ZIP);
        if (!epubMediaObject) return;
        let spatialSelector = epubMediaObject.selectors.get("xywh");
        if (!spatialSelector) return;
        return this._parseSpatialMediaFragmentSelectorValue(spatialSelector);
    }
    /*
    * This method configures the VanillaReader to better support the guided reading experience.
    *
    * */ _configureVanillaReader() {
        this._vanillaReader?.vanillaReaderView?.colibrioReaderView.addEngineEventListener("pointerdown", this._event_pointerDown);
        this._vanillaReader?.vanillaReaderView?.colibrioReaderView.addEngineEventListener("pointerup", this._event_pointerUp);
        this._vanillaReader?.vanillaReaderView?.colibrioReaderView.addEngineEventListener("keyup", this._engineEvent_keyUp);
        this._vanillaReader?.vanillaReaderView?.colibrioReaderView.setOptions({
            gestureOptions: {
                panZoom: {
                    allowSinglePointerPan: false
                }
            }
        });
        this._vanillaReader?.vanillaReaderView?.changeRenderer((0, $652e6cb51d594b1d$export$7ef357ac666ee52).SWIPE_SINGLE, false);
        //this._vanillaReader?.useReducedMotion(true);
        (0, $90fcc7ba9e85f12d$export$464365d0f40f6901).instance?.onPublicationClose(this._event_publicationCloseIntent, true);
    }
    _resetVanillaReaderConfiguration() {
        this._vanillaReader?.vanillaReaderView?.colibrioReaderView.removeEngineEventListener("pointerdown", this._event_pointerDown);
        this._vanillaReader?.vanillaReaderView?.colibrioReaderView.removeEngineEventListener("pointerup", this._event_pointerUp);
        this._vanillaReader?.vanillaReaderView?.colibrioReaderView.removeEngineEventListener("keyup", this._engineEvent_keyUp);
        //this._vanillaReader?.toggleMediaPlayer(this._initialNarrationState, {}).catch(console.warn);
        this._vanillaReader?.useReducedMotion(this._initialUseReducedMotionState);
        if (this._initialVanillaReaderViewOptionsState) {
            this._vanillaReader?.vanillaReaderView?.changeRenderer(this._initialVanillaReaderViewOptionsState.activeRendererTypeName || (0, $652e6cb51d594b1d$export$7ef357ac666ee52).RESPONSIVE, this._initialVanillaReaderViewOptionsState.ignoreAspectRatio);
            this._vanillaReader?.vanillaReaderView?.setVanillaReaderViewOptions(this._initialVanillaReaderViewOptionsState);
        } else console.warn("VanillaReaderGuidedReadingPlayer._resetVanillaReaderConfiguration(), _initialVanillaReaderViewOptionsState is undefined.");
    }
    _getNextStepIndex() {
        let nextStepIndex = this._activeStepIndex >= 0 ? this._activeStepIndex : 0;
        nextStepIndex = nextStepIndex < this._timeline.getSteps().length - 1 ? this._activeStepIndex + 1 : this._activeStepIndex;
        return nextStepIndex;
    }
    async _performStepAction(step) {
        this._activeStepIndex = this._timeline._stepsListFlat.indexOf(step);
        this._setActiveStep(step);
        if (step.stepType !== (0, $763ee9bb35121c68$export$6ac4214341579ea6).COMICS_SOUND_AREA) {
            this._stopAllAudioMediaObjectPlayback();
            let gotoSucceeded = await this._goToAndZoom(step);
            if (this.activeStep) {
                let stepRect = this._getRectFromStepData(this.activeStep);
                if (stepRect) await this.fetchContentLocationRangeFromVisibleRect(stepRect, true, 10);
            }
            if (this._vanillaReader?.vanillaMediaPlayer?.playerIsAttachedToView) // If the stepType is a panel group we do not start the sync media player. Better to wait until the step
            // targets a specific panel.
            {
                if (this.activeStep && this.activeStep.stepType != (0, $763ee9bb35121c68$export$6ac4214341579ea6).COMICS_PANEL_GROUP) {
                    let stepRect = this._getRectFromStepData(this.activeStep);
                    if (stepRect) {
                        let visibleLocationRange = await this.fetchContentLocationRangeFromVisibleRect(stepRect, true, 10);
                        if (visibleLocationRange) this._vanillaReader?.vanillaMediaPlayer.playLocatorRange(visibleLocationRange.getLocator().toJSON(), {
                            seekBehaviour: (0, $f8f5cf2c043414f4$export$47ac58310cdfef71).CLAMP_TO_RANGE
                        }).catch(console.warn);
                    }
                }
            }
            if (!gotoSucceeded) return;
            let audioObject = step.mediaObjects.filter((audio)=>audio.mediaType.toLowerCase().includes("audio"));
            if (audioObject.length > 0) audioObject.forEach((item)=>{
                this._startAudioMediaObjectPlayback(item).catch(console.warn);
            });
        } else {
            let audioObject = step.mediaObjects.filter((audio)=>audio.mediaType.toLowerCase().includes("audio"));
            if (audioObject.length > 0) {
                this._stopAllAudioMediaObjectPlayback();
                audioObject.forEach((item)=>{
                    this._startAudioMediaObjectPlayback(item).catch(console.warn);
                });
            }
        }
    }
    async _goToAndZoom(step) {
        let animationDuration = this._initialVanillaReaderViewOptionsState?.useReducedMotion ? 0 : 600;
        const latestReadingPositionData = await this._vanillaReader?.vanillaReaderView?.getReadingPositionData();
        if (!latestReadingPositionData?.locator) {
            console.warn(`VanillaReaderGuidedReadingPlayer._goToAndZoom(), Unable to read locator from vanillaReaderView.getReadingPositionData().`);
            return false;
        }
        if (!this.pageLocatorHasSteps(latestReadingPositionData.locator)) {
            console.warn(`VanillaReaderGuidedReadingPlayer._goToAndZoom(), Document ${latestReadingPositionData} has no steps defined.`);
            return false;
        }
        const onNavigationCompleted = async ()=>{
            let epubMediaObject = step.mediaObjects.find((item)=>item.mediaType === (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_EPUB_ZIP);
            let spatialSelector = epubMediaObject?.selectors.get("xywh");
            if (spatialSelector) {
                let previousRect = this._previousStep ? this._getRectFromStep(this._previousStep) : undefined;
                let rect = this._parseSpatialMediaFragmentSelectorValue(spatialSelector);
                if (rect) {
                    if (previousRect && this._rectsAreEquivalent(rect, previousRect)) return Promise.resolve(true);
                    let domRect = new DOMRect(rect.x, rect.y, rect.width, rect.height);
                    this._vanillaReader?.zoomToPublicationViewportClientRect(domRect, (0, $91ca8664a4c236f4$export$8cba090a009adf02).PERCENT, {
                        animationOptions: {
                            durationMs: animationDuration
                        }
                    });
                    return new Promise((resolve, _reject)=>{
                        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("VIEW_TRANSFORM_STOPPED", ()=>{
                            resolve(true);
                        }, true);
                    });
                }
            }
            return Promise.reject();
        };
        if (!this._activeStep || this._activeStep && !this._locatorsPointToSamePage(latestReadingPositionData.locator, step.locator)) {
            this._vanillaReader?.goTo(step.locator).catch(console.warn);
            return new Promise((resolve, _reject)=>{
                // We must wait for the navigation to the new page to complete before transforming (zooming etc)
                const navigationCompleted = async (_ev)=>{
                    await onNavigationCompleted();
                    const visiblePageClientRects = this._vanillaReader?.vanillaReaderView?.getVisiblePagesBoundingClientRects();
                    if (visiblePageClientRects && visiblePageClientRects.length > 0) {
                        let epubMediaObject = step.mediaObjects.find((item)=>item.mediaType === (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_EPUB_ZIP);
                        let spatialSelector = epubMediaObject?.selectors.get("xywh");
                        if (spatialSelector) {
                            let rect = this._parseSpatialMediaFragmentSelectorValue(spatialSelector);
                            if (rect && this._guidedReadingContentMask) this._guidedReadingContentMask.resizeRelative(rect, visiblePageClientRects[0], true, {
                                animationOptions: {
                                    durationMs: animationDuration
                                }
                            });
                        }
                        resolve(true);
                    }
                };
                (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("NAVIGATION_COMPLETED", navigationCompleted, true);
            });
        } else return onNavigationCompleted();
    }
    _timelineHasStepsForPageIndex(pageIndex) {
        return this._timeline.getSteps().some((step)=>{
            return this._getSpineIndexFromLocator(step.locator) === pageIndex;
        });
    }
    _locatorsPointToSamePage(locator1, locator2) {
        return this._getSpineIndexFromLocator(locator1) === this._getSpineIndexFromLocator(locator2);
    }
    _rectsAreEquivalent(rect1, rect2) {
        return rect1.width === rect2.width && rect1.height === rect2.height && rect1.x === rect2.x && rect1.y === rect2.y;
    }
    _getRectFromStep(step) {
        let epubMediaObject = step.mediaObjects.find((item)=>item.mediaType === (0, $ba5c9d217d86588f$export$483c11740a902fcd).APPLICATION_EPUB_ZIP);
        let spatialSelector = epubMediaObject?.selectors.get("xywh");
        return spatialSelector ? this._parseSpatialMediaFragmentSelectorValue(spatialSelector) : undefined;
    }
    _getStepsForLocator(locator) {
        let index = this._getSpineIndexFromLocator(locator);
        if (!index) {
            console.warn(`VanillaReaderGuidedReadingPlayer._getStepsForLocator(), unable to get index from locator "${locator}"`);
            return;
        }
        return this._timeline._stepsListFlat.filter((step)=>{
            let stepIndex = this._getSpineIndexFromLocator(step.locator);
            return index === stepIndex;
        });
    }
    _getInitialStepForLocator(locator) {
        let index = this._getSpineIndexFromLocator(locator);
        if (!index) {
            console.warn(`VanillaReaderGuidedReadingPlayer._getInitialStepForLocator(), unable to get index from locator "${locator}"`);
            return;
        }
        return this._timeline._stepsListFlat.find((step)=>{
            let stepIndex = this._getSpineIndexFromLocator(step.locator);
            return index === stepIndex;
        });
    }
    _getInitialStepIndexForLocator(locator) {
        let index = this._getSpineIndexFromLocator(locator);
        return this._timeline._stepsListFlat.findIndex((step)=>{
            let stepIndex = this._getSpineIndexFromLocator(step.locator);
            return index === stepIndex;
        });
    }
    _parseSpatialMediaFragmentSelectorValue(selectorValue) {
        let unitPrefixLength = selectorValue.indexOf(":") > 0 ? selectorValue.indexOf(":") + 1 : 0;
        let coords = selectorValue.slice(unitPrefixLength).split(",").map((position)=>{
            return parseFloat(position);
        });
        return {
            x: coords[0],
            y: coords[1],
            width: coords[2],
            height: coords[3]
        };
    }
    _parseTemporalMediaFragmentSelector(selector) {
        let unitPrefixLength = selector.indexOf(":") > 0 ? selector.indexOf(":") + 1 : 0;
        let positions = selector.slice(unitPrefixLength).split(",").map((position, index)=>{
            if (index === 0 && position === "") return 0;
            return parseInt(position);
        });
        return positions;
    }
    async _preloadAudioMediaObject(audioMediaObjects) {
        for (const mediaObjectData of audioMediaObjects)if (!this._loadedAudioMediaObjectElementsMap.has(mediaObjectData)) await this._createAudioMediaObjectElement(mediaObjectData);
        return;
    }
    async _createAudioMediaObjectElement(mediaObjectData) {
        if (this._loadedAudioMediaObjectElementsMap.size > 5) {
            this._loadedAudioMediaObjectElementsMap.clear();
            this._vanillaReader?.vanillaPublication?.revokeAllResourceBlobUrls();
        }
        if (this._loadedAudioMediaObjectElementsMap.has(mediaObjectData)) {
            console.warn("VanillaReaderGuidedReadingPlayer._preloadAudioMediaObject(), audio element has already been preloaded.", mediaObjectData);
            return;
        }
        let srcPublication = this._vanillaReader?.vanillaPublication?.getColibrioReaderPublication().getSourcePublication();
        let opfBasePath = srcPublication.getOpfDocumentUrl().pathname.slice(0, srcPublication.getOpfDocumentUrl().pathname.lastIndexOf("/"));
        let audioUrl = mediaObjectData.url.startsWith("http") ? mediaObjectData.url : await this._vanillaReader?.vanillaPublication?.fetchResourceBlobUrl(`${opfBasePath}/${mediaObjectData.url}`);
        if (!audioUrl) {
            console.warn("VanillaReaderGuidedReadingPlayer._preloadAudioMediaObject(), unable to get a valid url for media object.", mediaObjectData);
            return;
        }
        let audioElement = new Audio(audioUrl);
        this._loadedAudioMediaObjectElementsMap.set(mediaObjectData, audioElement);
        return audioElement;
    }
    _stopAllAudioMediaObjectPlayback() {
        if (this._vanillaReader?.vanillaMediaPlayer) this._vanillaReader?.vanillaMediaPlayer.pause();
        Array.from(this._playingAudioMap.keys()).forEach((mediaObject)=>{
            this._stopAudioMediaObjectPlayback(mediaObject);
        });
    }
    async _startAudioMediaObjectPlayback(mediaObjectData) {
        const audioElement = this._loadedAudioMediaObjectElementsMap.has(mediaObjectData) ? this._loadedAudioMediaObjectElementsMap.get(mediaObjectData) : await this._createAudioMediaObjectElement(mediaObjectData);
        let temporalSelector = mediaObjectData?.selectors.get("t");
        if (!temporalSelector) {
            console.warn("VanillaReaderGuidedReadingPlayer._startAudioMediaObjectPlayback, No temporal selector found in media object uri.");
            return;
        }
        const selectorComponents = this._parseTemporalMediaFragmentSelector(temporalSelector);
        if (audioElement && selectorComponents) {
            this._playingAudioMap.set(mediaObjectData, audioElement);
            audioElement.ontimeupdate = (_)=>{
                if (audioElement.currentTime > (selectorComponents[1] || audioElement.duration)) audioElement.pause();
            };
            audioElement.currentTime = selectorComponents[0];
            audioElement.play().catch(console.warn);
        } else {
            this._loadedAudioMediaObjectElementsMap.delete(mediaObjectData);
            console.warn("VanillaReaderGuidedReadingPlayer._startAudioMediaObjectPlayback(), unable to create audio element.", mediaObjectData);
        }
    }
    _stopAudioMediaObjectPlayback(mediaObjectData) {
        let audioElement = this._playingAudioMap.get(mediaObjectData);
        if (audioElement) {
            audioElement.pause();
            this._playingAudioMap.delete(mediaObjectData);
        } else console.warn(`Could not find audio element ${mediaObjectData.url} in the playingAudioMap.`);
    }
    async _getPublicationResourceBlob(resourcePath) {
        let vanillaPublication = this._vanillaReader?.vanillaPublication;
        if (vanillaPublication) {
            let srcPublication = vanillaPublication.getColibrioReaderPublication().getSourcePublication();
            let opfBasePath = srcPublication.getOpfDocumentUrl().pathname.slice(0, srcPublication.getOpfDocumentUrl().pathname.lastIndexOf("/"));
            let resourceOcfPath = `${opfBasePath}/${resourcePath}`;
            let blobUrl = await vanillaPublication?.fetchResourceBlobUrl(resourceOcfPath);
            if (!blobUrl) throw new Error(`VanillaRegionBasedNavigation.getPublicationResourceBlobUrl(), Unable to create Blob URL for file "${resourcePath}".`);
            return (await fetch(blobUrl)).blob();
        }
        return;
    }
    _revokePublicationResourceBlobUrl(url) {
        this._vanillaReader?.vanillaPublication?.revokeResourceBlobUrl(url);
    }
    _revokeAllPublicationResourceBlobUrls() {
        this._vanillaReader?.vanillaPublication?.revokeAllResourceBlobUrls();
    }
    _setLocalStorageState() {
        this._vanillaReaderAppMain.setActiveUiPresetData({
            presetName: (0, $d2c66ead28054c71$export$82747f63b1a1778f).GUIDED_READING_MODE,
            rollbackVanillaReaderViewOptionsData: this._initialVanillaReaderViewOptionsState
        });
    }
    _removeLocalStorageState() {
        this._vanillaReaderAppMain.clearActiveUiPresetData();
    }
}




/**
 * This file is based on the elevenlabs-node project by FelixWaweru
 * https://github.com/FelixWaweru/elevenlabs-node
 *
 * Types are based on the official ElevenLabs API
 * https://elevenlabs.io/docs/api-reference/text-to-speech
 *
 * The motivation for the rewrite of the original projects was of course the TS types,
 * but also to make it free from dependencies. So instead of using the Axios library
 * for HTTP requests, this uses simple `fetch` calls.
 *
 * At the time of writing the shape of the JS data in the `elevenlabs-node` lib maps 1:1
 * with the TS types in this implementation. This is handy, since you can use the
 * `elevenlabs-node` in your backend code and pretty much let the HTTP Response pass through
 * to the client in most cases.
 *
 *
 * ⚠️ NOTE REGARDING API KEY USAGE
 *
 * This example implementation uses the ElevenLabs API key to access the API backend service.
 *
 *                         ~~~~ YOU SHOULD NOT USE THIS IN PRODUCTION ~~~~
 *
 * */ class $da44cdd194e38fbe$export$6ac7f9e96f234d30 {
    constructor(options, speechDataCacheStorage){
        this._elevenLabsAPIV1 = "https://api.elevenlabs.io/v1";
        this._controllers = [];
        this._apiKey = options.apiKey;
        this._defaultVoiceId = options.voiceId;
        this._speechDataCacheStorage = speechDataCacheStorage;
    }
    abortAllApiRequests() {
        this._controllers.forEach((controller)=>{
            controller.abort();
        });
        this._controllers = [];
    }
    get defaultVoiceId() {
        return this._defaultVoiceId;
    }
    async textToSpeech(ttsRequestData) {
        ttsRequestData.modelId = ttsRequestData.modelId ? ttsRequestData.modelId : "eleven_monolingual_v1";
        const cachedSpeechData = await this._speechDataCacheStorage?.fetch(ttsRequestData);
        if (cachedSpeechData) return cachedSpeechData;
        const voiceIdValue = ttsRequestData.voiceId || this._defaultVoiceId;
        const voiceURL = `${this._elevenLabsAPIV1}/text-to-speech/${voiceIdValue}`;
        const response = await this._makeApiRequest(voiceURL, "POST", {
            "Accept": "audio/mpeg",
            "xi-api-key": this._apiKey,
            "Content-Type": "application/json"
        }, JSON.stringify(ttsRequestData));
        if (response.status !== 200) throw new Error("ElevenLabsApiClient.textToSpeech(): Response status was not 200. Got: " + response.status);
        const buffer = await response.arrayBuffer();
        this._speechDataCacheStorage?.add(ttsRequestData, buffer);
        return buffer;
    }
    async getVoices() {
        const voiceURL = `${this._elevenLabsAPIV1}/voices`;
        const response = await this._makeApiRequest(voiceURL, "GET");
        if (response.status !== 200) throw new Error("ElevenLabsApiClient.textToSpeechStream(): Response status was not 200. Got: " + response.status);
        const voiceList = JSON.parse(await response.text());
        return voiceList.voices;
    }
    async getDefaultVoiceSettings() {
        const settingsURL = `${this._elevenLabsAPIV1}/voices/settings/default`;
        const response = await this._makeApiRequest(settingsURL, "GET");
        if (response.status !== 200) throw new Error("ElevenLabsApiClient.getDefaultVoiceSettings(): Response status was not 200. Got: " + response.status);
        return JSON.parse(await response.text());
    }
    async getVoiceSettings(voiceId) {
        const settingsURL = `${this._elevenLabsAPIV1}/voices/${voiceId}/settings`;
        const response = await this._makeApiRequest(settingsURL, "GET");
        if (response.status !== 200) throw new Error("ElevenLabsApiClient.getVoiceSettings(): Response status was not 200. Got: " + response.status);
        return JSON.parse(await response.text());
    }
    async getVoice(voiceId) {
        const voiceURL = `${this._elevenLabsAPIV1}/voices/${voiceId}`;
        const response = await this._makeApiRequest(voiceURL, "GET");
        if (response.status !== 200) throw new Error("ElevenLabsApiClient.getVoice(): Response status was not 200. Got: " + response.status);
        return JSON.parse(await response.text());
    }
    async editVoiceSettings(voiceId, settings) {
        const settingsURL = `${this._elevenLabsAPIV1}/voices/${voiceId}/settings/edit`;
        const response = await this._makeApiRequest(settingsURL, "POST", {
            "xi-api-key": this._apiKey
        }, JSON.stringify(settings));
        if (response.status !== 200) throw new Error("ElevenLabsApiClient.editVoiceSettings(): Response status was not 200. Got: " + response.status);
        return JSON.parse(await response.text());
    }
    async getModels() {
        const voiceURL = `${this._elevenLabsAPIV1}/models`;
        const response = await this._makeApiRequest(voiceURL, "GET");
        if (response.status !== 200) throw new Error("ElevenLabsApiClient.getModels(): Response status was not 200. Got: " + response.status);
        return JSON.parse(await response.text());
    }
    async getUserInfo() {
        const voiceURL = `${this._elevenLabsAPIV1}/user`;
        const response = await this._makeApiRequest(voiceURL, "GET");
        if (response.status !== 200) throw new Error("ElevenLabsApiClient.getUserInfo(): Response status was not 200. Got: " + response.status);
        return JSON.parse(await response.text());
    }
    async _makeApiRequest(url, method, headers = {}, body) {
        const controller = new AbortController();
        const signal = controller.signal;
        this._controllers.push(controller);
        const allHeaders = Object.assign(headers, {
            "xi-api-key": this._apiKey
        });
        const initData = {
            method: method,
            headers: allHeaders,
            body: body,
            signal: signal
        };
        let response;
        try {
            response = await fetch(url, initData);
        } finally{
            this._controllers = this._controllers.filter((c)=>c !== controller);
        }
        return response;
    }
}



class $4464c858b73c4a4a$export$d1c0d130616ec56a {
    static async generateSHA256Hash(stringToHash) {
        const utf8 = new TextEncoder().encode(stringToHash);
        const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((bytes)=>bytes.toString(16).padStart(2, "0")).join("");
        return hashHex;
    }
}


class $e8410463b3d57889$export$9474decc4b8db424 {
    constructor(_voiceId, _utteranceData, outputFormat, voiceSettings, _apiClient){
        this._voiceId = _voiceId;
        this._utteranceData = _utteranceData;
        this._apiClient = _apiClient;
        this._blobUrlManager = new (0, $ba5c9d217d86588f$export$f31b06a38674c8e1)();
        this._elevenLabsTtsRequestData = {
            voiceId: this._voiceId,
            text: this._utteranceData.text.value,
            outputFormat: outputFormat,
            voiceSettings: voiceSettings
        };
    }
    get id() {
        return this._utteranceData.id;
    }
    get text() {
        return this._utteranceData.text;
    }
    async fetchHashSignature() {
        if (this._hash) return this._hash;
        this._hash = await (0, $4464c858b73c4a4a$export$d1c0d130616ec56a).generateSHA256Hash(`${JSON.stringify(this._elevenLabsTtsRequestData)}`);
        return this._hash;
    }
    get speechData() {
        return this._arrayBuffer;
    }
    get hasSpeechData() {
        return this._arrayBuffer !== undefined;
    }
    async fetchSpeechData() {
        if (this._arrayBuffer) return;
        this._arrayBuffer = await this._apiClient.textToSpeech(this._elevenLabsTtsRequestData);
    }
    /*
    * Transforms the objects ArrayBuffer into a temporary BlobUrl for use by the `ElevenLabsUtteranceRenderer`.
    * */ getBlobUrl() {
        if (!this._arrayBuffer) {
            console.warn("ElevenLabsUtterance.getBlobUrl(): This utterance has no speech data at this point.");
            return;
        }
        return this._blobUrl ? this._blobUrl : this._bufferToBlobUrl(this._arrayBuffer);
    }
    revokeBlobUrl() {
        if (!this._blobUrl) {
            console.warn("ElevenLabsUtterance.revokeBlobUrl(): This utterance has no blob url at this point.");
            return;
        }
        this._blobUrlManager.revokeUrl(this._blobUrl);
    }
    clearSpeechData() {
        this.revokeBlobUrl();
        this._arrayBuffer = undefined;
    }
    _bufferToBlobUrl(buffer) {
        return this._blobUrlManager.createUrl([
            buffer
        ], "audio/mpeg", false).url;
    }
}


class $b7e9b793f8868ff0$export$40bc656ada82a092 {
    constructor(){
        this._audioElement = document.createElement("audio");
        this._audioElement.onerror = (ev)=>{
            if (this._currentlyPlayingUtterance && this._onPlaybackErrorCallback) this._onPlaybackErrorCallback(ev, this._currentlyPlayingUtterance);
        };
        this._audioElement.onpause = (ev)=>{
            if (this._currentlyPlayingUtterance && this._onPlaybackPausedCallback) this._onPlaybackPausedCallback(ev, this._currentlyPlayingUtterance);
        };
        this._audioElement.onabort = (ev)=>{
            if (this._currentlyPlayingUtterance && this._onPlaybackAbortedCallback) this._onPlaybackAbortedCallback(ev, this._currentlyPlayingUtterance);
        };
        this._audioElement.onended = (ev)=>{
            if (this._currentlyPlayingUtterance) {
                if (this._onUtteranceEndReachedCallback) this._onUtteranceEndReachedCallback(ev, this._currentlyPlayingUtterance);
            }
        };
        this._audioElement.oncanplaythrough = (_ev)=>{};
        this._audioElement.oncanplay = (_ev)=>{};
        this._audioElement.ondurationchange = (_ev)=>{};
        this._audioElement.onplay = (ev)=>{
            if (this._currentlyPlayingUtterance && this._onPlaybackStartedCallback) this._onPlaybackStartedCallback(ev, this._currentlyPlayingUtterance);
        };
        this._audioElement.onplaying = (_ev)=>{};
        this._audioElement.ontimeupdate = (_ev)=>{
            if (this._timeUpdateTimeoutHandle === undefined) this._timeUpdateTimeoutHandle = setTimeout(()=>{
                this._timeUpdateTimeoutHandle = undefined;
                if (!this._currentlyPlayingUtterance) return;
                if (this._onUtteranceBoundaryCallback) {
                    const timeProgress = this._audioElement.currentTime / this._audioElement.duration;
                    const textProgress = Math.floor(this._currentlyPlayingUtterance.text.value.length * timeProgress);
                    this._onUtteranceBoundaryCallback(_ev, this._currentlyPlayingUtterance, textProgress, 0);
                }
            }, 500);
        };
        this._audioElement.onseeking = (_ev)=>{};
        this._audioElement.onseeked = (_ev)=>{};
        this._audioElement.onratechange = (_ev)=>{};
        this._audioElement.onprogress = (_ev)=>{};
    }
    onPlaybackStarted(callback) {
        this._onPlaybackStartedCallback = callback;
    }
    onPlaybackPaused(callback) {
        this._onPlaybackPausedCallback = callback;
    }
    onPlaybackAborted(callback) {
        this._onPlaybackAbortedCallback = callback;
    }
    onPlaybackEndReached(callback) {
        this._onUtteranceEndReachedCallback = callback;
    }
    onPlaybackError(callback) {
        this._onPlaybackErrorCallback = callback;
    }
    onUtteranceBoundary(callback) {
        this._onUtteranceBoundaryCallback = callback;
    }
    set playbackRate(rate) {
        this._audioElement.playbackRate = rate;
    }
    get playbackRate() {
        return this._audioElement.playbackRate;
    }
    get volume() {
        return this._audioElement.volume;
    }
    set volume(volume) {
        this._audioElement.volume = volume;
    }
    get muted() {
        return this._audioElement.muted;
    }
    set muted(muted) {
        this._audioElement.muted = muted;
    }
    getUtterance() {
        return this._currentlyPlayingUtterance;
    }
    async setUtterance(utterance) {
        if (!utterance) {
            this.pause();
            this.unset();
            return;
        }
        if (this._audioElement.src && await this._currentlyPlayingUtterance?.fetchHashSignature() === await utterance?.fetchHashSignature()) {
            console.log("ElevenLabsUtteranceRenderer.setUtterance(): Utterance is the same as the currently playing.");
            return;
        }
        this._currentlyPlayingUtterance = utterance;
        await utterance.fetchSpeechData();
        if (!utterance.hasSpeechData) console.warn("ElevenLabsAudioRenderer.utterance: Unable to fetch speech data for utterance.", utterance);
        const blobUrl = utterance.getBlobUrl();
        if (!blobUrl) {
            console.warn("ElevenLabsAudioRenderer.utterance: Unable to get blob url for utterance.", utterance);
            return;
        }
        this._audioElement.src = blobUrl;
    }
    async play() {
        return this._audioElement.play();
    }
    pause() {
        this._audioElement.pause();
    }
    unset() {
        this._audioElement.removeAttribute("src");
    }
}



/*
* Output format of the generated audio.
* */ var $c4f58a12d0fa8abe$export$c2a8773508d105a6;
(function(ElevenLabsOutputFormats) {
    /*
    * mp3 with 44.1kHz sample rate at 64kbps.
    **/ ElevenLabsOutputFormats["mp3_44100_64"] = "mp3_44100_64";
    /*
    * mp3 with 44.1kHz sample rate at 96kbps.
    * */ ElevenLabsOutputFormats["mp3_44100_96"] = "mp3_44100_96";
    /*
    * mp3 with 44.1kHz sample rate at 128kbps.
    * */ ElevenLabsOutputFormats["mp3_44100_128"] = "mp3_44100_128";
    /*
    * mp3 with 44.1kHz sample rate at 192kbps.
    * Requires you to be subscribed to Creator tier or above.
    * */ ElevenLabsOutputFormats["mp3_44100_192"] = "mp3_44100_192";
    /*
    * PCM format (S16LE) with 22.05kHz sample rate.
    * */ ElevenLabsOutputFormats["pcm_22050"] = "pcm_22050";
    /*
    * PCM format (S16LE) with 24kHz sample rate
    * */ ElevenLabsOutputFormats["pcm_24000"] = "pcm_24000";
    /*
    * PCM format (S16LE) with 44.1kHz sample rate.
    * Requires you to be subscribed to Independent Publisher tier or above.
    * */ ElevenLabsOutputFormats["pcm_44100"] = "pcm_44100";
    /*
    * μ-law format (sometimes written mu-law, often approximated as u-law) with 8kHz sample rate. Note that this format
    * is commonly used for Twilio audio inputs.
    * */ ElevenLabsOutputFormats["ulaw_8000"] = "ulaw_8000";
})($c4f58a12d0fa8abe$export$c2a8773508d105a6 || ($c4f58a12d0fa8abe$export$c2a8773508d105a6 = {}));


class $b58132b9acd99faf$export$752dd4072d8ac5ec {
    constructor(_apiClient){
        this._apiClient = _apiClient;
        this._utteranceDataQueue = [];
        this._utteranceIdToUtteranceInstanceMap = new Map();
        this._playbackIsPaused = true;
        this._utteranceRenderer = new (0, $b7e9b793f8868ff0$export$40bc656ada82a092)();
        this._utteranceRenderer.onPlaybackStarted((_ev, _utterance)=>{});
        this._utteranceRenderer.onPlaybackPaused((_ev, _utterance)=>{});
        this._utteranceRenderer.onPlaybackEndReached(async (_ev, utterance)=>{
            this._colibrioContext?.onUtteranceEnd(utterance.id);
            this._activeUtterance = undefined;
            await this.play();
            utterance.revokeBlobUrl();
        });
        this._utteranceRenderer.onUtteranceBoundary((_ev, utterance, startOffset, length)=>{
            this._colibrioContext?.onUtteranceBoundary(utterance.id, startOffset, length);
        });
        this._utteranceRenderer.onPlaybackError((ev, utterance)=>{
            this._colibrioContext?.onUtteranceError(utterance.id, ev);
        });
    }
    get supportsWordBoundaries() {
        return false;
    }
    getActiveVoice() {
        return this._activeVoice;
    }
    addUtterance(utteranceData) {
        const voiceURI = this._activeVoice?.voiceURI || this._apiClient.defaultVoiceId;
        const newUtterance = new (0, $e8410463b3d57889$export$9474decc4b8db424)(voiceURI, utteranceData, (0, $c4f58a12d0fa8abe$export$c2a8773508d105a6).mp3_44100_64, {
            stability: 0.5,
            similarityBoost: 0.5
        }, this._apiClient);
        this._utteranceIdToUtteranceInstanceMap.set(utteranceData.id, newUtterance);
        this._utteranceDataQueue.push(newUtterance);
    }
    clearAndPause() {
        return this._clearPlaybackState();
    }
    destroy() {
        this._clearPlaybackState().catch(console.warn);
    }
    init(context) {
        this._colibrioContext = context;
        this._colibrioContext.onTtsSynthesizerWaiting();
        this._validateUserSession().then(async (_userInfo)=>{
            this._voiceCollection = await this.fetchVoices();
            this._activeVoice = this._getDefaultVoiceDataForService();
            this._colibrioContext?.onTtsSynthesizerReady();
        }).catch((error)=>{
            console.error(error);
            console.error("ElevenLabsWebSpeechSynthesizer.init(): Unable to validate ElevenLabs user.");
        });
    }
    pause() {
        this._playbackIsPaused = true;
        this._utteranceRenderer.pause();
    }
    async play() {
        this._playbackIsPaused = false;
        if (this._activeUtterance) this._playUtterance(this._activeUtterance).catch(console.warn);
        else {
            const nextUtterance = this._utteranceDataQueue.shift();
            if (!nextUtterance) {
                console.warn("ElevenLabsWebSpeechSynthesizer.play(): Unable to get next buffered utterance.");
                return;
            }
            this._prefetchUpcomingUtterance();
            this._playUtterance(nextUtterance).catch(console.warn);
        }
    }
    setMuted(muted) {
        this._utteranceRenderer.muted = muted;
    }
    setPlaybackRate(playbackRate) {
        this._utteranceRenderer.playbackRate = playbackRate;
    }
    setVolume(volume) {
        this._utteranceRenderer.volume = volume;
    }
    setActiveVoice(voice) {
        const voiceName = voice?.name;
        const ttsVoice = this._voiceCollection?.allVoices.find((voice)=>{
            return voice.name === voiceName;
        });
        if (ttsVoice) this._activeVoice = ttsVoice;
        else {
            console.warn(`ElevenLabsWebSpeechSynthesizer.setVoice(): Unable to find voice with name "${voiceName}", using default voice.`);
            this._activeVoice = this._getDefaultVoiceDataForService();
        }
    }
    async fetchVoices() {
        const voiceDataList = await this._apiClient.getVoices();
        const webSpeechVoiceList = voiceDataList.map((voiceData)=>{
            return {
                voiceURI: voiceData.voice_id,
                name: voiceData.name,
                lang: "",
                default: voiceData.voice_id === this._apiClient.defaultVoiceId,
                localService: false
            };
        });
        return (0, $410aa1fb5d04a699$export$aa8547013ca2283b).createCollectionFromVoicesList(webSpeechVoiceList);
    }
    _getDefaultVoiceDataForService() {
        return this._voiceCollection?.allVoices.find((voice)=>{
            return voice.voiceURI === this._apiClient.defaultVoiceId;
        });
    }
    async _validateUserSession() {
        return this._apiClient.getUserInfo();
    }
    _prefetchUpcomingUtterance() {
        if (this._utteranceDataQueue.length < 1) {
            console.log("ElevenLabsWebSpeechSynthesizer._preFetchUpcomingUtterance(), Buffer is empty, nothing to play.");
            return;
        }
        this._utteranceDataQueue[0].fetchSpeechData().catch(console.warn);
    }
    async _playUtterance(utterance) {
        this._activeUtterance = utterance;
        await this._utteranceRenderer.setUtterance(utterance);
        if (!this._playbackIsPaused) this._utteranceRenderer.play().catch(console.warn);
    }
    async _clearPlaybackState() {
        this._utteranceDataQueue.forEach((utterance)=>utterance.revokeBlobUrl());
        this._utteranceDataQueue = [];
        await this._utteranceRenderer.setUtterance(undefined);
        this._activeUtterance?.revokeBlobUrl();
        this._activeUtterance = undefined;
        this._playbackIsPaused = true;
    }
    handleEvent(_evt) {}
}



class $addfaf604fe7428e$export$f095f1167d41ae57 {
    constructor(_storageClient){
        this._storageClient = _storageClient;
    }
    static async open(cacheName = "vr_11labs_cache") {
        let storageClient = await window.caches?.open(cacheName);
        if (!storageClient) throw Error("ElevenLabsSpeechDataCacheStorage.open(): window.caches is not supported in this browser.");
        return new $addfaf604fe7428e$export$f095f1167d41ae57(storageClient);
    }
    async clearAll() {
        let numberOfDeletions = 0;
        const requests = await this._storageClient.keys();
        for (let request of requests){
            numberOfDeletions++;
            await this._storageClient.delete(request);
        }
        return Promise.resolve(numberOfDeletions);
    }
    async delete(speechRequestData) {
        return this._storageClient.delete(new Request(await this.storageKey(speechRequestData)));
    }
    async fetch(speechRequestData) {
        const response = await this._storageClient.match(new Request(await this.storageKey(speechRequestData)));
        return response?.arrayBuffer();
    }
    async add(speechRequestData, speechData) {
        return this._storageClient.put(new Request(await this.storageKey(speechRequestData)), new Response(speechData));
    }
    async storageKey(speechRequestData) {
        const hashString = await (0, $4464c858b73c4a4a$export$d1c0d130616ec56a).generateSHA256Hash(JSON.stringify(speechRequestData));
        return `/${hashString}`;
    }
}


/*
 *
 * # INDEX.TS
 *
 * Hello fellow coder! How nice to see that you found your way here 🙂
 * Please make sure that you read the README file to get an overview of the architecture etc.
 *
 * This file is the entry point for the Vanilla Reader application. This is where it all kicks off.
 *
 * ## SERVICE WORKER
 *
 * I suggest that you learn the Vanilla Reader basics before you dive into the great PWA void. PWAs has many quite complex
 * aspects that are not connected to anything Colibrio related. So one step at a time is my advice. But you do you 😉
 *
 * The Service Worker code is at the bottom of this file.
 *
 */ // The main application logic
let $b4e14b6b8da86996$var$vanillaReaderAppMain;
/**
 *
 * QUERY STRING PARAMETERS
 *
 * */ const $b4e14b6b8da86996$var$locationHash = document.location.hash;
const $b4e14b6b8da86996$var$locationSearch = document.location.search;
// Querystring parameter that acts as a flag to signal when the user has chosen to open a file using "Open with"
// on a PC.
const $b4e14b6b8da86996$var$openFileFromLaunchQueue = $b4e14b6b8da86996$var$locationHash.indexOf("open_file") >= 0;
// If its in PWA mode, we store application data on the device for offline support.
const $b4e14b6b8da86996$var$useDeviceStorage = $b4e14b6b8da86996$var$locationSearch.indexOf("?pwa") >= 0;
// Just a flag that is used later in this file to ignore the `slowNetwork` option.
const $b4e14b6b8da86996$var$forceHighSpeedConnection = $b4e14b6b8da86996$var$locationSearch.indexOf("force_high_speed_connection") >= 0;
// Querystring parameter that is set if the application needs to perform migration of its data to a newer version of
// the database schema. This is parameter is added in the `controllerchange` event listener in the ServiceWorker
// section at the end of this file.
const $b4e14b6b8da86996$var$performMigration = $b4e14b6b8da86996$var$locationHash.indexOf("perform_migration") >= 0;
const $b4e14b6b8da86996$var$hashItemKey = "custom_tts_apikey";
const $b4e14b6b8da86996$var$useCustomTts = $b4e14b6b8da86996$var$locationSearch.indexOf($b4e14b6b8da86996$var$hashItemKey) > 0;
let $b4e14b6b8da86996$var$customTtsApiKey = "";
if ($b4e14b6b8da86996$var$useCustomTts) {
    const hashItemKey = "custom_tts_apikey";
    $b4e14b6b8da86996$var$customTtsApiKey = $b4e14b6b8da86996$var$locationSearch.slice($b4e14b6b8da86996$var$locationSearch.indexOf(hashItemKey) + hashItemKey.length + 1);
}
// This checks if the user has set their system settings to reduce motion such as UI animations.
const $b4e14b6b8da86996$var$useReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
// Grab the `publication_url` URL parameter if it is present. If it is present this publication will be opened
// as soon as the `VanillaReader` has "booted up".
const $b4e14b6b8da86996$var$initialPublicationUrl = $b4e14b6b8da86996$var$getPublicationParameterFromUrl();
window.addEventListener("load", async ()=>{
    return $b4e14b6b8da86996$var$createVanillaReaderApp();
});
/********************************************************************
 *
 *  MAIN APPLICATION SETUP
 *
 *********************************************************************/ async function $b4e14b6b8da86996$var$createVanillaReaderApp() {
    let customWebSpeechTtsSynthesizer;
    if ($b4e14b6b8da86996$var$useCustomTts && $b4e14b6b8da86996$var$customTtsApiKey) {
        const elevenLabsCacheStorageClient = await (0, $addfaf604fe7428e$export$f095f1167d41ae57).open("vr_11labs_cache_");
        const elevenLabsApiClient = new (0, $da44cdd194e38fbe$export$6ac7f9e96f234d30)({
            apiKey: $b4e14b6b8da86996$var$customTtsApiKey,
            voiceId: "21m00Tcm4TlvDq8ikWAM"
        }, elevenLabsCacheStorageClient);
        customWebSpeechTtsSynthesizer = new (0, $b58132b9acd99faf$export$752dd4072d8ac5ec)(elevenLabsApiClient);
    }
    $b4e14b6b8da86996$var$vanillaReaderAppMain = new (0, $a0949ff2251db721$export$354c5dd6b66622ea)(document.getElementById("root"), $b4e14b6b8da86996$var$licenseApiKey, {
        initialPublicationUrl: $b4e14b6b8da86996$var$initialPublicationUrl,
        useDeviceStorage: $b4e14b6b8da86996$var$useDeviceStorage,
        useReducedMotion: $b4e14b6b8da86996$var$useReducedMotion,
        forceHighSpeedConnection: $b4e14b6b8da86996$var$forceHighSpeedConnection,
        openFileFromLaunchQueue: $b4e14b6b8da86996$var$openFileFromLaunchQueue,
        customWebSpeechTtsSynthesizer: customWebSpeechTtsSynthesizer
    });
    $b4e14b6b8da86996$var$vanillaReaderAppMain.onAppLoaded(()=>{
        $b4e14b6b8da86996$var$maybePerformMigrationAndReload().catch(console.warn);
        // Toast app version for easier service worker debugging etc.
        $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderUiInstance()?.toaster.toast(`Reader version ${(0, $a0949ff2251db721$export$354c5dd6b66622ea).appVersion}`).catch(console.warn);
        // If the `publication_url` query parameter was set we should load a publication from a web server right away.
        if ($b4e14b6b8da86996$var$initialPublicationUrl) {
            if ($b4e14b6b8da86996$var$initialPublicationUrl.indexOf("http") == 0) $b4e14b6b8da86996$var$vanillaReaderAppMain.loadPublicationFromUrl($b4e14b6b8da86996$var$initialPublicationUrl).catch(console.warn);
            else {
                $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderUiInstance()?.toaster.toast(`Loading this publication. Please wait.`).catch(console.warn);
                $b4e14b6b8da86996$var$vanillaReaderAppMain.loadPublicationFromAws($b4e14b6b8da86996$var$initialPublicationUrl, $b4e14b6b8da86996$var$getInitialLocator()).catch(console.warn);
            }
        } else if (!$b4e14b6b8da86996$var$openFileFromLaunchQueue) // No initial URL to load and no file in the launch queue, so we show the open file dialog.
        //vanillaReaderAppMain.getVanillaReaderUiInstance()?.dialogOpenFile.show();
        $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderUiInstance()?.masterplanStart.show();
        (0, $84c7b345e247d474$export$51b4df07290407).addEventListener("PUBLICATION_LOADED", async (_ev)=>{
            const vanillaReader = $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderInstance();
            const vanillaReaderPublication = vanillaReader?.vanillaPublication;
            const vanillaReaderUi = $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderUiInstance();
            $b4e14b6b8da86996$var$maybeRestoreUiOptions();
            if (vanillaReaderUi && vanillaReader && vanillaReaderPublication && vanillaReaderPublication.format === (0, $9b29a4abfb1f6cfd$export$cb5cefb0cf6efc43).EPUB && (0, $75832310220f7e41$export$f0651c3f76c1e7a7).publicationHasRegionBasedNavigation(vanillaReaderPublication)) {
                $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderUiInstance()?.toaster.toast("Publication has Region Based " + "Navigation support.");
                let vanillaRegionBasedNavigation = await (0, $75832310220f7e41$export$f0651c3f76c1e7a7).create(vanillaReaderPublication);
                let guidedReadingTimelineData = vanillaRegionBasedNavigation.toGuidedReadingTimelineData();
                vanillaReaderUi.showMenuOnReaderViewClick = false;
                if (guidedReadingTimelineData) {
                    // @ts-ignore
                    window.guidedReadingPlayer = (0, $be9eb0f62edacece$export$e63b70b2fbf96f2c).create($b4e14b6b8da86996$var$vanillaReaderAppMain, guidedReadingTimelineData);
                    // @ts-ignore
                    window.guidedReadingPlayer.createMaskLayer(document.getElementById("root"));
                }
            }
            $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderUiInstance()?.menuSide.setPublicationTitle(vanillaReaderPublication?.title ?? "Unknown");
        });
        return Promise.resolve();
    });
    await $b4e14b6b8da86996$var$vanillaReaderAppMain._asyncSetup().catch(console.warn);
    return;
}
function $b4e14b6b8da86996$var$getInitialLocator() {
    if (window.location.hash) return window.location.hash.slice(1);
    return;
}
/*
*
* FILE HANDLING API
*
* This API lets a PWA register as handler for specific file formats. This means that the PWA  will show up as an option
* in the "Open with" dialog on a PC, and that it can be set as the default application for formats.
* since your PWA can now act more as a "proper PC application"
*
* This is a fairly new API introduced in June 2022. So far, it is supported in Chromium based browsers such as
* Chrome and Edge on all PC operating systems and on ChromeOS.
*
* Read more at :
* https://web.dev/file-handling/
*
* */ if ("launchQueue" in window) window["launchQueue"].setConsumer((launchParams)=>{
    $b4e14b6b8da86996$var$handleIncomingLaunchFiles(launchParams.files).catch(console.warn);
});
// This function is run anytime there is a file that has been opened from the desktop operating system.
async function $b4e14b6b8da86996$var$handleIncomingLaunchFiles(files) {
    if (files.length > 0) {
        const file = await files[0].getFile();
        await $b4e14b6b8da86996$var$createVanillaReaderApp();
        $b4e14b6b8da86996$var$vanillaReaderAppMain.loadPublicationFromFile(file, undefined, $b4e14b6b8da86996$var$useDeviceStorage).catch(console.warn);
    }
}
// This is just a utility function to find and, if found, return the url to a publication that the user wants to load.
function $b4e14b6b8da86996$var$getPublicationParameterFromUrl() {
    let publicationUrlParameterOffset = document.location.search.indexOf("publication_url=");
    let s3UidParameterOffset = document.location.search.indexOf("uid=");
    if (publicationUrlParameterOffset < 0 && s3UidParameterOffset < 0) return;
    if (publicationUrlParameterOffset > -1) {
        const nextParameterOffset = document.location.search.indexOf("&", publicationUrlParameterOffset) > 0 ? document.location.search.indexOf("&", publicationUrlParameterOffset) : undefined;
        const urlParameter = document.location.search.slice(publicationUrlParameterOffset, nextParameterOffset);
        return urlParameter.slice(urlParameter.indexOf("=") + 1);
    }
    if (s3UidParameterOffset > -1) {
        const nextParameterOffset = document.location.search.indexOf("&", s3UidParameterOffset) > 0 ? document.location.search.indexOf("&", s3UidParameterOffset) : undefined;
        const urlParameter = document.location.search.slice(s3UidParameterOffset, nextParameterOffset);
        return urlParameter.slice(urlParameter.indexOf("=") + 1);
    }
    return;
}
function $b4e14b6b8da86996$var$maybeRestoreUiOptions() {
    let optionsPresetData = $b4e14b6b8da86996$var$vanillaReaderAppMain.getActiveUiPresetData();
    if (!optionsPresetData) return;
    if (!optionsPresetData.rollbackUiOptionsData) console.warn(`maybeRestoreUiOptions(), We have stored preset "${optionsPresetData}", but no initial options to rollback to.`);
    // If the reader was closed or refreshed during guided reading, we should restore the options to the ones
    // that was used before the guided reading mode was started.
    if (optionsPresetData.presetName === (0, $d2c66ead28054c71$export$82747f63b1a1778f).GUIDED_READING_MODE) {
        if (optionsPresetData.rollbackVanillaReaderViewOptionsData) {
            let vanillaReader = $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderInstance();
            let vanillaReaderUi = $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderUiInstance();
            let vanillaReaderViewOptions = optionsPresetData.rollbackVanillaReaderViewOptionsData;
            let colibrioReaderViewOptions = vanillaReaderViewOptions.colibrioReaderViewOptions;
            if (vanillaReaderUi && colibrioReaderViewOptions) {
                let colibrioStyleOptions = colibrioReaderViewOptions?.publicationStyleOptions;
                if (colibrioStyleOptions) {
                    vanillaReader?.vanillaReaderView?.colibrioReaderView.setOptions({
                        publicationStyleOptions: colibrioStyleOptions
                    });
                    if (vanillaReaderViewOptions.activeRendererTypeName) vanillaReaderUi.setPublicationRenderer(vanillaReaderViewOptions.activeRendererTypeName);
                    if (vanillaReaderViewOptions.ignoreAspectRatio !== undefined) vanillaReaderUi.setIgnoreAspectRatio(vanillaReaderViewOptions.ignoreAspectRatio);
                    if (vanillaReaderViewOptions.useReducedMotion !== undefined) vanillaReaderUi.setUseReducedMotion(vanillaReaderViewOptions.useReducedMotion);
                }
            }
        }
        $b4e14b6b8da86996$var$vanillaReaderAppMain.clearActiveUiPresetData();
    }
}
/*
*
* Data migration
*
* If the application has been upgraded to a newer version and the database schema has been changed since last version
* we may need to migrate data. If a migration is necessary or not is decided in the `controllerchange` event listener
* in the ServiceWorker section at the end of this file.
*
* Depending on if any data was affected by the migration, the page may need to reload.
*
* */ async function $b4e14b6b8da86996$var$maybePerformMigrationAndReload() {
    if ($b4e14b6b8da86996$var$performMigration) {
        let numberOfItemsMigrated = await $b4e14b6b8da86996$var$vanillaReaderAppMain.performDataMigrationFromLocalStorage();
        if (numberOfItemsMigrated > 0) {
            alert("Migration of data has been performed after version update. The application will reload once more.");
            window.location.href = `index.html${$b4e14b6b8da86996$var$useDeviceStorage ? "?pwa=true" : ""}`;
        } else // Remove the perform_migration hash
        window.location.hash = "";
    }
}
/**********************************************************************
 *
 * PWA SERVICE WORKER SETUP
 *
 *********************************************************************/ /* * This section is all about registering and managing updates of the `service-worker.ts` script.
*
* There are entire books just dedicated to Service Workers. They are an awesome technology, byt there are many caveats
* to be aware of, so if you wish to make your reader app progressive, read up on service workers before you start your
* journey.
*
* Have a look at this article at web.dev https://web.dev/offline-cookbook/ and this one specifically about caching
* https://web.dev/service-worker-caching-and-http-caching/
*
* I have not successfully been able to move this code to a separate file.
*
**/ let $b4e14b6b8da86996$var$serviceWorkerUpdated = false;
var $2857dc952d963d0e$exports = {};
$2857dc952d963d0e$exports = new URL("service-worker.js", import.meta.url).toString();


// Note the `USE_SERVICEWORKER` constant that acts as a switch to turn on the service worker based on an url parameter.
if ("serviceWorker" in navigator) {
    let updatedServiceWorker;
    navigator.serviceWorker.register($2857dc952d963d0e$exports, {
        scope: "/",
        updateViaCache: "none"
    }).then((registration)=>{
        registration.addEventListener("updatefound", ()=>{
            console.log("Update to the installed Service Worker found.");
            // Check if the new service worker is in the process of being installed.
            updatedServiceWorker = registration.installing;
            if (updatedServiceWorker) // Add an event listener so that we get now when the installation is done.
            updatedServiceWorker.addEventListener("statechange", (_ev)=>{
                if (updatedServiceWorker?.state === "installed" && navigator.serviceWorker.controller) {
                    console.log("Updated Service Worker installed.");
                    //serviceWorkerUpdated = true;
                    (0, $84c7b345e247d474$export$51b4df07290407).dispatchEvent((0, $84c7b345e247d474$export$51b4df07290407).createEvent("APP_PWA_INSTALLED", {}));
                    // Send a postMessage to the Service Worker to tell it to skip waiting and set the current page
                    // as controller. This will in turn trigger a `controllerchange` event that is handled elsewhere
                    // in this file.
                    updatedServiceWorker.postMessage({
                        eventName: (0, $6619efc090304cca$export$58c0313f7e281bd1).APP_PWA_SKIP_WAITING_INTENT
                    });
                }
            });
            else console.error("setupServiceWorker()", "Unable to install Service Worker.");
        });
    }).catch(console.error);
    // Add event listener so that we get an alert when the service worker has been set as the controller of the page.
    navigator.serviceWorker.addEventListener("controllerchange", ()=>{
        // If the service worker is new we reload the page in order to make sure that it is activated.
        if ($b4e14b6b8da86996$var$serviceWorkerUpdated) {
            let latestDataMigrationDateStamp = window.localStorage.getItem("VanillaReaderAppDataMigrationDateStamp");
            console.log("Latest data migration date", latestDataMigrationDateStamp);
            $b4e14b6b8da86996$var$vanillaReaderAppMain.getVanillaReaderUiInstance();
            if (latestDataMigrationDateStamp) // Migration done, we'll just reload
            window.location.href = `index.html${$b4e14b6b8da86996$var$useDeviceStorage ? "?pwa" : ""}`;
            else // Reload to perform migration
            window.location.href = `index.html${$b4e14b6b8da86996$var$useDeviceStorage ? "?pwa&#perform_migration" : "?#perform_migration"}`;
        }
    });
}
// `process.env.LICENSE_API_KEY` is replaced by the license key during Parcels build process.
// Don't worry too much about this at the moment, we have more important things to learn :)
const $b4e14b6b8da86996$var$licenseApiKey = "d1f3435c-30ca-4bae-9788-bd003a033834";
if (!$b4e14b6b8da86996$var$licenseApiKey) $b4e14b6b8da86996$var$showAPIKeyMissing();
// Displays a message so that you don't forget to add an API key to the project.
function $b4e14b6b8da86996$var$showAPIKeyMissing() {
    document.body.innerHTML = `
            <h1>
            License API Key missing
            </h1>
            <p style="font-size: 16px">
                Please edit the .env file and add your License API Key:
            </p>
            
            <code style="font-size: 16px">LICENSE_API_KEY=&lt;Your API Key&gt;</code>;
            
            <p>
                Then rebuild your project with <code>yarn start</code>            
            </p>
        `;
}


//# sourceMappingURL=index.226eb646.js.map
